
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1efd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1efd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2nzLi", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1bb9784afa87e369$export$ffb0004e005737fa; }, function (v) { return $1bb9784afa87e369$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1bb9784afa87e369$export$34b9dba7ce09269b; }, function (v) { return $1bb9784afa87e369$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1bb9784afa87e369$export$25062201e9e25d76; }, function (v) { return $1bb9784afa87e369$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bb9784afa87e369$export$ffb0004e005737fa;
var $1bb9784afa87e369$export$34b9dba7ce09269b;
var $1bb9784afa87e369$export$25062201e9e25d76;
'use strict';

var $7fPBF = parcelRequire("7fPBF");
var $1bb9784afa87e369$var$k = Symbol.for("react.element"), $1bb9784afa87e369$var$l = Symbol.for("react.fragment"), $1bb9784afa87e369$var$m = Object.prototype.hasOwnProperty, $1bb9784afa87e369$var$n = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1bb9784afa87e369$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1bb9784afa87e369$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$1bb9784afa87e369$var$m.call(a, b) && !$1bb9784afa87e369$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1bb9784afa87e369$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $1bb9784afa87e369$var$n.current
    };
}
$1bb9784afa87e369$export$ffb0004e005737fa = $1bb9784afa87e369$var$l;
$1bb9784afa87e369$export$34b9dba7ce09269b = $1bb9784afa87e369$var$q;
$1bb9784afa87e369$export$25062201e9e25d76 = $1bb9784afa87e369$var$q;

});
parcelRegister("7fPBF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fSPLm"));

});
parcelRegister("fSPLm", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $b9040d2deeb360f4$export$dca3b0875bd9a954; }, function (v) { return $b9040d2deeb360f4$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $b9040d2deeb360f4$export$16fa2f45be04daa8; }, function (v) { return $b9040d2deeb360f4$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b9040d2deeb360f4$export$ffb0004e005737fa; }, function (v) { return $b9040d2deeb360f4$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $b9040d2deeb360f4$export$e2c29f18771995cb; }, function (v) { return $b9040d2deeb360f4$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $b9040d2deeb360f4$export$221d75b3f55bb0bd; }, function (v) { return $b9040d2deeb360f4$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b9040d2deeb360f4$export$5f8d39834fd61797; }, function (v) { return $b9040d2deeb360f4$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b9040d2deeb360f4$export$74bf444e3cd11ea5; }, function (v) { return $b9040d2deeb360f4$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b9040d2deeb360f4$export$ae55be85d98224ed; }, function (v) { return $b9040d2deeb360f4$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $b9040d2deeb360f4$export$3ba232387fd5d6dd; }, function (v) { return $b9040d2deeb360f4$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $b9040d2deeb360f4$export$e530037191fcd5d7; }, function (v) { return $b9040d2deeb360f4$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $b9040d2deeb360f4$export$fd42f52fd3ae1109; }, function (v) { return $b9040d2deeb360f4$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $b9040d2deeb360f4$export$c8a8987d4410bf2d; }, function (v) { return $b9040d2deeb360f4$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $b9040d2deeb360f4$export$d38cd72104c1f0e9; }, function (v) { return $b9040d2deeb360f4$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43; }, function (v) { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $b9040d2deeb360f4$export$257a8862b851cb5b; }, function (v) { return $b9040d2deeb360f4$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $b9040d2deeb360f4$export$a8257692ac88316c; }, function (v) { return $b9040d2deeb360f4$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $b9040d2deeb360f4$export$488013bae63b21da; }, function (v) { return $b9040d2deeb360f4$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $b9040d2deeb360f4$export$7c73462e0d25e514; }, function (v) { return $b9040d2deeb360f4$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $b9040d2deeb360f4$export$7568632d0d33d16d; }, function (v) { return $b9040d2deeb360f4$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $b9040d2deeb360f4$export$88948ce120ea2619; }, function (v) { return $b9040d2deeb360f4$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $b9040d2deeb360f4$export$35808ee640e87ca7; }, function (v) { return $b9040d2deeb360f4$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $b9040d2deeb360f4$export$fae74005e78b1a27; }, function (v) { return $b9040d2deeb360f4$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e; }, function (v) { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf; }, function (v) { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $b9040d2deeb360f4$export$6d9c69b0de29b591; }, function (v) { return $b9040d2deeb360f4$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $b9040d2deeb360f4$export$f680877a34711e37; }, function (v) { return $b9040d2deeb360f4$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $b9040d2deeb360f4$export$d5a552a76deda3c2; }, function (v) { return $b9040d2deeb360f4$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $b9040d2deeb360f4$export$aaabe4eda9ed9969; }, function (v) { return $b9040d2deeb360f4$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $b9040d2deeb360f4$export$e5c5a5f917a5871c; }, function (v) { return $b9040d2deeb360f4$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $b9040d2deeb360f4$export$1538c33de8887b59; }, function (v) { return $b9040d2deeb360f4$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $b9040d2deeb360f4$export$13e3392192263954; }, function (v) { return $b9040d2deeb360f4$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $b9040d2deeb360f4$export$b8f5890fc79d6aca; }, function (v) { return $b9040d2deeb360f4$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $b9040d2deeb360f4$export$60241385465d0a34; }, function (v) { return $b9040d2deeb360f4$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $b9040d2deeb360f4$export$306c0aa65ff9ec16; }, function (v) { return $b9040d2deeb360f4$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $b9040d2deeb360f4$export$7b286972b8d8ccbf; }, function (v) { return $b9040d2deeb360f4$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $b9040d2deeb360f4$export$83d89fbfd8236492; }, function (v) { return $b9040d2deeb360f4$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b9040d2deeb360f4$export$dca3b0875bd9a954;
var $b9040d2deeb360f4$export$16fa2f45be04daa8;
var $b9040d2deeb360f4$export$ffb0004e005737fa;
var $b9040d2deeb360f4$export$e2c29f18771995cb;
var $b9040d2deeb360f4$export$221d75b3f55bb0bd;
var $b9040d2deeb360f4$export$5f8d39834fd61797;
var $b9040d2deeb360f4$export$74bf444e3cd11ea5;
var $b9040d2deeb360f4$export$ae55be85d98224ed;
var $b9040d2deeb360f4$export$3ba232387fd5d6dd;
var $b9040d2deeb360f4$export$e530037191fcd5d7;
var $b9040d2deeb360f4$export$fd42f52fd3ae1109;
var $b9040d2deeb360f4$export$c8a8987d4410bf2d;
var $b9040d2deeb360f4$export$d38cd72104c1f0e9;
var $b9040d2deeb360f4$export$7d1e3a5e95ceca43;
var $b9040d2deeb360f4$export$257a8862b851cb5b;
var $b9040d2deeb360f4$export$a8257692ac88316c;
var $b9040d2deeb360f4$export$488013bae63b21da;
var $b9040d2deeb360f4$export$7c73462e0d25e514;
var $b9040d2deeb360f4$export$7568632d0d33d16d;
var $b9040d2deeb360f4$export$88948ce120ea2619;
var $b9040d2deeb360f4$export$35808ee640e87ca7;
var $b9040d2deeb360f4$export$fae74005e78b1a27;
var $b9040d2deeb360f4$export$dc8fbce3eb94dc1e;
var $b9040d2deeb360f4$export$6a7bc4e911dc01cf;
var $b9040d2deeb360f4$export$6d9c69b0de29b591;
var $b9040d2deeb360f4$export$f680877a34711e37;
var $b9040d2deeb360f4$export$d5a552a76deda3c2;
var $b9040d2deeb360f4$export$aaabe4eda9ed9969;
var $b9040d2deeb360f4$export$e5c5a5f917a5871c;
var $b9040d2deeb360f4$export$1538c33de8887b59;
var $b9040d2deeb360f4$export$13e3392192263954;
var $b9040d2deeb360f4$export$b8f5890fc79d6aca;
var $b9040d2deeb360f4$export$60241385465d0a34;
var $b9040d2deeb360f4$export$306c0aa65ff9ec16;
var $b9040d2deeb360f4$export$7b286972b8d8ccbf;
var $b9040d2deeb360f4$export$83d89fbfd8236492;
'use strict';
var $b9040d2deeb360f4$var$l = Symbol.for("react.element"), $b9040d2deeb360f4$var$n = Symbol.for("react.portal"), $b9040d2deeb360f4$var$p = Symbol.for("react.fragment"), $b9040d2deeb360f4$var$q = Symbol.for("react.strict_mode"), $b9040d2deeb360f4$var$r = Symbol.for("react.profiler"), $b9040d2deeb360f4$var$t = Symbol.for("react.provider"), $b9040d2deeb360f4$var$u = Symbol.for("react.context"), $b9040d2deeb360f4$var$v = Symbol.for("react.forward_ref"), $b9040d2deeb360f4$var$w = Symbol.for("react.suspense"), $b9040d2deeb360f4$var$x = Symbol.for("react.memo"), $b9040d2deeb360f4$var$y = Symbol.for("react.lazy"), $b9040d2deeb360f4$var$z = Symbol.iterator;
function $b9040d2deeb360f4$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b9040d2deeb360f4$var$z && a[$b9040d2deeb360f4$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b9040d2deeb360f4$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b9040d2deeb360f4$var$C = Object.assign, $b9040d2deeb360f4$var$D = {};
function $b9040d2deeb360f4$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
$b9040d2deeb360f4$var$E.prototype.isReactComponent = {};
$b9040d2deeb360f4$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b9040d2deeb360f4$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b9040d2deeb360f4$var$F() {}
$b9040d2deeb360f4$var$F.prototype = $b9040d2deeb360f4$var$E.prototype;
function $b9040d2deeb360f4$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
var $b9040d2deeb360f4$var$H = $b9040d2deeb360f4$var$G.prototype = new $b9040d2deeb360f4$var$F;
$b9040d2deeb360f4$var$H.constructor = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$var$C($b9040d2deeb360f4$var$H, $b9040d2deeb360f4$var$E.prototype);
$b9040d2deeb360f4$var$H.isPureReactComponent = !0;
var $b9040d2deeb360f4$var$I = Array.isArray, $b9040d2deeb360f4$var$J = Object.prototype.hasOwnProperty, $b9040d2deeb360f4$var$K = {
    current: null
}, $b9040d2deeb360f4$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b9040d2deeb360f4$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$b9040d2deeb360f4$var$J.call(b, d) && !$b9040d2deeb360f4$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $b9040d2deeb360f4$var$K.current
    };
}
function $b9040d2deeb360f4$var$N(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b9040d2deeb360f4$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b9040d2deeb360f4$var$l;
}
function $b9040d2deeb360f4$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b9040d2deeb360f4$var$P = /\/+/g;
function $b9040d2deeb360f4$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b9040d2deeb360f4$var$escape("" + a.key) : b.toString(36);
}
function $b9040d2deeb360f4$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b9040d2deeb360f4$var$l:
                case $b9040d2deeb360f4$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $b9040d2deeb360f4$var$Q(h, 0) : d, $b9040d2deeb360f4$var$I(c) ? (e = "", null != a && (e = a.replace($b9040d2deeb360f4$var$P, "$&/") + "/"), $b9040d2deeb360f4$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($b9040d2deeb360f4$var$O(c) && (c = $b9040d2deeb360f4$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($b9040d2deeb360f4$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($b9040d2deeb360f4$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $b9040d2deeb360f4$var$Q(k, g);
        h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    }
    else if (f = $b9040d2deeb360f4$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $b9040d2deeb360f4$var$Q(k, g++), h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $b9040d2deeb360f4$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $b9040d2deeb360f4$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $b9040d2deeb360f4$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $b9040d2deeb360f4$var$U = {
    current: null
}, $b9040d2deeb360f4$var$V = {
    transition: null
}, $b9040d2deeb360f4$var$W = {
    ReactCurrentDispatcher: $b9040d2deeb360f4$var$U,
    ReactCurrentBatchConfig: $b9040d2deeb360f4$var$V,
    ReactCurrentOwner: $b9040d2deeb360f4$var$K
};
function $b9040d2deeb360f4$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$b9040d2deeb360f4$export$dca3b0875bd9a954 = {
    map: $b9040d2deeb360f4$var$S,
    forEach: function(a, b, e) {
        $b9040d2deeb360f4$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $b9040d2deeb360f4$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $b9040d2deeb360f4$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$b9040d2deeb360f4$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$b9040d2deeb360f4$export$16fa2f45be04daa8 = $b9040d2deeb360f4$var$E;
$b9040d2deeb360f4$export$ffb0004e005737fa = $b9040d2deeb360f4$var$p;
$b9040d2deeb360f4$export$e2c29f18771995cb = $b9040d2deeb360f4$var$r;
$b9040d2deeb360f4$export$221d75b3f55bb0bd = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$export$5f8d39834fd61797 = $b9040d2deeb360f4$var$q;
$b9040d2deeb360f4$export$74bf444e3cd11ea5 = $b9040d2deeb360f4$var$w;
$b9040d2deeb360f4$export$ae55be85d98224ed = $b9040d2deeb360f4$var$W;
$b9040d2deeb360f4$export$3ba232387fd5d6dd = $b9040d2deeb360f4$var$X;
$b9040d2deeb360f4$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $b9040d2deeb360f4$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $b9040d2deeb360f4$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$b9040d2deeb360f4$var$J.call(b, f) && !$b9040d2deeb360f4$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$b9040d2deeb360f4$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $b9040d2deeb360f4$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $b9040d2deeb360f4$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$b9040d2deeb360f4$export$c8a8987d4410bf2d = $b9040d2deeb360f4$var$M;
$b9040d2deeb360f4$export$d38cd72104c1f0e9 = function(a) {
    var b = $b9040d2deeb360f4$var$M.bind(null, a);
    b.type = a;
    return b;
};
$b9040d2deeb360f4$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b9040d2deeb360f4$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$v,
        render: a
    };
};
$b9040d2deeb360f4$export$a8257692ac88316c = $b9040d2deeb360f4$var$O;
$b9040d2deeb360f4$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $b9040d2deeb360f4$var$T
    };
};
$b9040d2deeb360f4$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$b9040d2deeb360f4$export$7568632d0d33d16d = function(a) {
    var b = $b9040d2deeb360f4$var$V.transition;
    $b9040d2deeb360f4$var$V.transition = {};
    try {
        a();
    } finally{
        $b9040d2deeb360f4$var$V.transition = b;
    }
};
$b9040d2deeb360f4$export$88948ce120ea2619 = $b9040d2deeb360f4$var$X;
$b9040d2deeb360f4$export$35808ee640e87ca7 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useCallback(a, b);
};
$b9040d2deeb360f4$export$fae74005e78b1a27 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useContext(a);
};
$b9040d2deeb360f4$export$dc8fbce3eb94dc1e = function() {};
$b9040d2deeb360f4$export$6a7bc4e911dc01cf = function(a) {
    return $b9040d2deeb360f4$var$U.current.useDeferredValue(a);
};
$b9040d2deeb360f4$export$6d9c69b0de29b591 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useEffect(a, b);
};
$b9040d2deeb360f4$export$f680877a34711e37 = function() {
    return $b9040d2deeb360f4$var$U.current.useId();
};
$b9040d2deeb360f4$export$d5a552a76deda3c2 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useImperativeHandle(a, b, e);
};
$b9040d2deeb360f4$export$aaabe4eda9ed9969 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useInsertionEffect(a, b);
};
$b9040d2deeb360f4$export$e5c5a5f917a5871c = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useLayoutEffect(a, b);
};
$b9040d2deeb360f4$export$1538c33de8887b59 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useMemo(a, b);
};
$b9040d2deeb360f4$export$13e3392192263954 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useReducer(a, b, e);
};
$b9040d2deeb360f4$export$b8f5890fc79d6aca = function(a) {
    return $b9040d2deeb360f4$var$U.current.useRef(a);
};
$b9040d2deeb360f4$export$60241385465d0a34 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useState(a);
};
$b9040d2deeb360f4$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useSyncExternalStore(a, b, e);
};
$b9040d2deeb360f4$export$7b286972b8d8ccbf = function() {
    return $b9040d2deeb360f4$var$U.current.useTransition();
};
$b9040d2deeb360f4$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("9kHYF", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $6cb818575e31460e$export$a7c73072b1a182ae; }, function (v) { return $6cb818575e31460e$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $6cb818575e31460e$export$9f27bc3417b4524d; }, function (v) { return $6cb818575e31460e$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $6cb818575e31460e$export$db77ccec0bb4ccac; }, function (v) { return $6cb818575e31460e$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $6cb818575e31460e$export$8392c0c9d3dcbd35; }, function (v) { return $6cb818575e31460e$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $6cb818575e31460e$export$ffb0004e005737fa; }, function (v) { return $6cb818575e31460e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $6cb818575e31460e$export$b624eff549462981; }, function (v) { return $6cb818575e31460e$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $6cb818575e31460e$export$7897aa7841a5380c; }, function (v) { return $6cb818575e31460e$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $6cb818575e31460e$export$602eac185826482c; }, function (v) { return $6cb818575e31460e$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $6cb818575e31460e$export$e2c29f18771995cb; }, function (v) { return $6cb818575e31460e$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $6cb818575e31460e$export$5f8d39834fd61797; }, function (v) { return $6cb818575e31460e$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $6cb818575e31460e$export$74bf444e3cd11ea5; }, function (v) { return $6cb818575e31460e$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $6cb818575e31460e$export$998bcd577473dd93; }, function (v) { return $6cb818575e31460e$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $6cb818575e31460e$export$b706b080d889d2c9; }, function (v) { return $6cb818575e31460e$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $6cb818575e31460e$export$5be5a87408f70ddc; }, function (v) { return $6cb818575e31460e$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $6cb818575e31460e$export$45a5e7f76e0caa8d; }, function (v) { return $6cb818575e31460e$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $6cb818575e31460e$export$455c2e768291efa6; }, function (v) { return $6cb818575e31460e$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $6cb818575e31460e$export$9522e17588c12572; }, function (v) { return $6cb818575e31460e$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $6cb818575e31460e$export$2110ac352bb060b9; }, function (v) { return $6cb818575e31460e$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $6cb818575e31460e$export$56885ab8b9c456ab; }, function (v) { return $6cb818575e31460e$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $6cb818575e31460e$export$d927fcb6adf8f9de; }, function (v) { return $6cb818575e31460e$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $6cb818575e31460e$export$b82d16f27459e05a; }, function (v) { return $6cb818575e31460e$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $6cb818575e31460e$export$522c17b4f5e123e8; }, function (v) { return $6cb818575e31460e$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $6cb818575e31460e$export$1aabd8a0274ecfd6; }, function (v) { return $6cb818575e31460e$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $6cb818575e31460e$export$3d6c20d97e46b957; }, function (v) { return $6cb818575e31460e$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $6cb818575e31460e$export$9b621391a187a31a; }, function (v) { return $6cb818575e31460e$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $6cb818575e31460e$export$f5bbd400c2f4426f; }, function (v) { return $6cb818575e31460e$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6cb818575e31460e$export$a7c73072b1a182ae;
var $6cb818575e31460e$export$9f27bc3417b4524d;
var $6cb818575e31460e$export$db77ccec0bb4ccac;
var $6cb818575e31460e$export$8392c0c9d3dcbd35;
var $6cb818575e31460e$export$ffb0004e005737fa;
var $6cb818575e31460e$export$b624eff549462981;
var $6cb818575e31460e$export$7897aa7841a5380c;
var $6cb818575e31460e$export$602eac185826482c;
var $6cb818575e31460e$export$e2c29f18771995cb;
var $6cb818575e31460e$export$5f8d39834fd61797;
var $6cb818575e31460e$export$74bf444e3cd11ea5;
var $6cb818575e31460e$export$998bcd577473dd93;
var $6cb818575e31460e$export$b706b080d889d2c9;
var $6cb818575e31460e$export$5be5a87408f70ddc;
var $6cb818575e31460e$export$45a5e7f76e0caa8d;
var $6cb818575e31460e$export$455c2e768291efa6;
var $6cb818575e31460e$export$9522e17588c12572;
var $6cb818575e31460e$export$2110ac352bb060b9;
var $6cb818575e31460e$export$56885ab8b9c456ab;
var $6cb818575e31460e$export$d927fcb6adf8f9de;
var $6cb818575e31460e$export$b82d16f27459e05a;
var $6cb818575e31460e$export$522c17b4f5e123e8;
var $6cb818575e31460e$export$1aabd8a0274ecfd6;
var $6cb818575e31460e$export$3d6c20d97e46b957;
var $6cb818575e31460e$export$9b621391a187a31a;
var $6cb818575e31460e$export$f5bbd400c2f4426f;
"use strict";
var $6cb818575e31460e$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $6cb818575e31460e$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $6cb818575e31460e$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $6cb818575e31460e$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $6cb818575e31460e$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $6cb818575e31460e$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $6cb818575e31460e$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $6cb818575e31460e$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $6cb818575e31460e$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $6cb818575e31460e$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $6cb818575e31460e$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $6cb818575e31460e$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $6cb818575e31460e$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $6cb818575e31460e$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $6cb818575e31460e$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $6cb818575e31460e$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $6cb818575e31460e$var$REACT_FRAGMENT_TYPE:
                    case $6cb818575e31460e$var$REACT_PROFILER_TYPE:
                    case $6cb818575e31460e$var$REACT_STRICT_MODE_TYPE:
                    case $6cb818575e31460e$var$REACT_SUSPENSE_TYPE:
                    case $6cb818575e31460e$var$REACT_SUSPENSE_LIST_TYPE:
                    case $6cb818575e31460e$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $6cb818575e31460e$var$REACT_CONTEXT_TYPE:
                            case $6cb818575e31460e$var$REACT_FORWARD_REF_TYPE:
                            case $6cb818575e31460e$var$REACT_LAZY_TYPE:
                            case $6cb818575e31460e$var$REACT_MEMO_TYPE:
                                return object;
                            case $6cb818575e31460e$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $6cb818575e31460e$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$6cb818575e31460e$export$a7c73072b1a182ae = $6cb818575e31460e$var$REACT_CONSUMER_TYPE;
$6cb818575e31460e$export$9f27bc3417b4524d = $6cb818575e31460e$var$REACT_CONTEXT_TYPE;
$6cb818575e31460e$export$db77ccec0bb4ccac = $6cb818575e31460e$var$REACT_ELEMENT_TYPE;
$6cb818575e31460e$export$8392c0c9d3dcbd35 = $6cb818575e31460e$var$REACT_FORWARD_REF_TYPE;
$6cb818575e31460e$export$ffb0004e005737fa = $6cb818575e31460e$var$REACT_FRAGMENT_TYPE;
$6cb818575e31460e$export$b624eff549462981 = $6cb818575e31460e$var$REACT_LAZY_TYPE;
$6cb818575e31460e$export$7897aa7841a5380c = $6cb818575e31460e$var$REACT_MEMO_TYPE;
$6cb818575e31460e$export$602eac185826482c = $6cb818575e31460e$var$REACT_PORTAL_TYPE;
$6cb818575e31460e$export$e2c29f18771995cb = $6cb818575e31460e$var$REACT_PROFILER_TYPE;
$6cb818575e31460e$export$5f8d39834fd61797 = $6cb818575e31460e$var$REACT_STRICT_MODE_TYPE;
$6cb818575e31460e$export$74bf444e3cd11ea5 = $6cb818575e31460e$var$REACT_SUSPENSE_TYPE;
$6cb818575e31460e$export$998bcd577473dd93 = $6cb818575e31460e$var$REACT_SUSPENSE_LIST_TYPE;
$6cb818575e31460e$export$b706b080d889d2c9 = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_CONSUMER_TYPE;
};
$6cb818575e31460e$export$5be5a87408f70ddc = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_CONTEXT_TYPE;
};
$6cb818575e31460e$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $6cb818575e31460e$var$REACT_ELEMENT_TYPE;
};
$6cb818575e31460e$export$455c2e768291efa6 = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_FORWARD_REF_TYPE;
};
$6cb818575e31460e$export$9522e17588c12572 = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_FRAGMENT_TYPE;
};
$6cb818575e31460e$export$2110ac352bb060b9 = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_LAZY_TYPE;
};
$6cb818575e31460e$export$56885ab8b9c456ab = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_MEMO_TYPE;
};
$6cb818575e31460e$export$d927fcb6adf8f9de = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_PORTAL_TYPE;
};
$6cb818575e31460e$export$b82d16f27459e05a = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_PROFILER_TYPE;
};
$6cb818575e31460e$export$522c17b4f5e123e8 = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_STRICT_MODE_TYPE;
};
$6cb818575e31460e$export$1aabd8a0274ecfd6 = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_SUSPENSE_TYPE;
};
$6cb818575e31460e$export$3d6c20d97e46b957 = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_SUSPENSE_LIST_TYPE;
};
$6cb818575e31460e$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $6cb818575e31460e$var$REACT_FRAGMENT_TYPE || type === $6cb818575e31460e$var$REACT_PROFILER_TYPE || type === $6cb818575e31460e$var$REACT_STRICT_MODE_TYPE || type === $6cb818575e31460e$var$REACT_SUSPENSE_TYPE || type === $6cb818575e31460e$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $6cb818575e31460e$var$REACT_LAZY_TYPE || type.$$typeof === $6cb818575e31460e$var$REACT_MEMO_TYPE || type.$$typeof === $6cb818575e31460e$var$REACT_CONTEXT_TYPE || type.$$typeof === $6cb818575e31460e$var$REACT_CONSUMER_TYPE || type.$$typeof === $6cb818575e31460e$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $6cb818575e31460e$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$6cb818575e31460e$export$f5bbd400c2f4426f = $6cb818575e31460e$var$typeOf;

});

parcelRegister("iDep4", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $7KQqJ = parcelRequire("7KQqJ");
function $d9070abd96403449$var$emptyFunction() {}
function $d9070abd96403449$var$emptyFunctionWithReset() {}
$d9070abd96403449$var$emptyFunctionWithReset.resetWarningCache = $d9070abd96403449$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $7KQqJ) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $d9070abd96403449$var$emptyFunctionWithReset,
        resetWarningCache: $d9070abd96403449$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("7KQqJ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $5a557fcd99e4c0a9$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $5a557fcd99e4c0a9$var$ReactPropTypesSecret;

});


parcelRegister("3oWWu", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $27a155bcdd967657$export$2b8d127b894957b9; }, function (v) { return $27a155bcdd967657$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $27a155bcdd967657$export$cea3a54a6425200c; }, function (v) { return $27a155bcdd967657$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $27a155bcdd967657$export$a7c73072b1a182ae; }, function (v) { return $27a155bcdd967657$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $27a155bcdd967657$export$9f27bc3417b4524d; }, function (v) { return $27a155bcdd967657$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $27a155bcdd967657$export$db77ccec0bb4ccac; }, function (v) { return $27a155bcdd967657$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $27a155bcdd967657$export$8392c0c9d3dcbd35; }, function (v) { return $27a155bcdd967657$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $27a155bcdd967657$export$ffb0004e005737fa; }, function (v) { return $27a155bcdd967657$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $27a155bcdd967657$export$b624eff549462981; }, function (v) { return $27a155bcdd967657$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $27a155bcdd967657$export$7897aa7841a5380c; }, function (v) { return $27a155bcdd967657$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $27a155bcdd967657$export$602eac185826482c; }, function (v) { return $27a155bcdd967657$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $27a155bcdd967657$export$e2c29f18771995cb; }, function (v) { return $27a155bcdd967657$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $27a155bcdd967657$export$5f8d39834fd61797; }, function (v) { return $27a155bcdd967657$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $27a155bcdd967657$export$74bf444e3cd11ea5; }, function (v) { return $27a155bcdd967657$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $27a155bcdd967657$export$92387174baf9b227; }, function (v) { return $27a155bcdd967657$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $27a155bcdd967657$export$ec112efeb987d9c6; }, function (v) { return $27a155bcdd967657$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $27a155bcdd967657$export$b706b080d889d2c9; }, function (v) { return $27a155bcdd967657$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $27a155bcdd967657$export$5be5a87408f70ddc; }, function (v) { return $27a155bcdd967657$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $27a155bcdd967657$export$45a5e7f76e0caa8d; }, function (v) { return $27a155bcdd967657$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $27a155bcdd967657$export$455c2e768291efa6; }, function (v) { return $27a155bcdd967657$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $27a155bcdd967657$export$9522e17588c12572; }, function (v) { return $27a155bcdd967657$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $27a155bcdd967657$export$2110ac352bb060b9; }, function (v) { return $27a155bcdd967657$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $27a155bcdd967657$export$56885ab8b9c456ab; }, function (v) { return $27a155bcdd967657$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $27a155bcdd967657$export$d927fcb6adf8f9de; }, function (v) { return $27a155bcdd967657$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $27a155bcdd967657$export$b82d16f27459e05a; }, function (v) { return $27a155bcdd967657$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $27a155bcdd967657$export$522c17b4f5e123e8; }, function (v) { return $27a155bcdd967657$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $27a155bcdd967657$export$1aabd8a0274ecfd6; }, function (v) { return $27a155bcdd967657$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $27a155bcdd967657$export$9b621391a187a31a; }, function (v) { return $27a155bcdd967657$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $27a155bcdd967657$export$f5bbd400c2f4426f; }, function (v) { return $27a155bcdd967657$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $27a155bcdd967657$export$2b8d127b894957b9;
var $27a155bcdd967657$export$cea3a54a6425200c;
var $27a155bcdd967657$export$a7c73072b1a182ae;
var $27a155bcdd967657$export$9f27bc3417b4524d;
var $27a155bcdd967657$export$db77ccec0bb4ccac;
var $27a155bcdd967657$export$8392c0c9d3dcbd35;
var $27a155bcdd967657$export$ffb0004e005737fa;
var $27a155bcdd967657$export$b624eff549462981;
var $27a155bcdd967657$export$7897aa7841a5380c;
var $27a155bcdd967657$export$602eac185826482c;
var $27a155bcdd967657$export$e2c29f18771995cb;
var $27a155bcdd967657$export$5f8d39834fd61797;
var $27a155bcdd967657$export$74bf444e3cd11ea5;
var $27a155bcdd967657$export$92387174baf9b227;
var $27a155bcdd967657$export$ec112efeb987d9c6;
var $27a155bcdd967657$export$b706b080d889d2c9;
var $27a155bcdd967657$export$5be5a87408f70ddc;
var $27a155bcdd967657$export$45a5e7f76e0caa8d;
var $27a155bcdd967657$export$455c2e768291efa6;
var $27a155bcdd967657$export$9522e17588c12572;
var $27a155bcdd967657$export$2110ac352bb060b9;
var $27a155bcdd967657$export$56885ab8b9c456ab;
var $27a155bcdd967657$export$d927fcb6adf8f9de;
var $27a155bcdd967657$export$b82d16f27459e05a;
var $27a155bcdd967657$export$522c17b4f5e123e8;
var $27a155bcdd967657$export$1aabd8a0274ecfd6;
var $27a155bcdd967657$export$9b621391a187a31a;
var $27a155bcdd967657$export$f5bbd400c2f4426f;
'use strict';
var $27a155bcdd967657$var$b = "function" === typeof Symbol && Symbol.for, $27a155bcdd967657$var$c = $27a155bcdd967657$var$b ? Symbol.for("react.element") : 60103, $27a155bcdd967657$var$d = $27a155bcdd967657$var$b ? Symbol.for("react.portal") : 60106, $27a155bcdd967657$var$e = $27a155bcdd967657$var$b ? Symbol.for("react.fragment") : 60107, $27a155bcdd967657$var$f = $27a155bcdd967657$var$b ? Symbol.for("react.strict_mode") : 60108, $27a155bcdd967657$var$g = $27a155bcdd967657$var$b ? Symbol.for("react.profiler") : 60114, $27a155bcdd967657$var$h = $27a155bcdd967657$var$b ? Symbol.for("react.provider") : 60109, $27a155bcdd967657$var$k = $27a155bcdd967657$var$b ? Symbol.for("react.context") : 60110, $27a155bcdd967657$var$l = $27a155bcdd967657$var$b ? Symbol.for("react.async_mode") : 60111, $27a155bcdd967657$var$m = $27a155bcdd967657$var$b ? Symbol.for("react.concurrent_mode") : 60111, $27a155bcdd967657$var$n = $27a155bcdd967657$var$b ? Symbol.for("react.forward_ref") : 60112, $27a155bcdd967657$var$p = $27a155bcdd967657$var$b ? Symbol.for("react.suspense") : 60113, $27a155bcdd967657$var$q = $27a155bcdd967657$var$b ? Symbol.for("react.suspense_list") : 60120, $27a155bcdd967657$var$r = $27a155bcdd967657$var$b ? Symbol.for("react.memo") : 60115, $27a155bcdd967657$var$t = $27a155bcdd967657$var$b ? Symbol.for("react.lazy") : 60116, $27a155bcdd967657$var$v = $27a155bcdd967657$var$b ? Symbol.for("react.block") : 60121, $27a155bcdd967657$var$w = $27a155bcdd967657$var$b ? Symbol.for("react.fundamental") : 60117, $27a155bcdd967657$var$x = $27a155bcdd967657$var$b ? Symbol.for("react.responder") : 60118, $27a155bcdd967657$var$y = $27a155bcdd967657$var$b ? Symbol.for("react.scope") : 60119;
function $27a155bcdd967657$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $27a155bcdd967657$var$c:
                switch(a = a.type, a){
                    case $27a155bcdd967657$var$l:
                    case $27a155bcdd967657$var$m:
                    case $27a155bcdd967657$var$e:
                    case $27a155bcdd967657$var$g:
                    case $27a155bcdd967657$var$f:
                    case $27a155bcdd967657$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $27a155bcdd967657$var$k:
                            case $27a155bcdd967657$var$n:
                            case $27a155bcdd967657$var$t:
                            case $27a155bcdd967657$var$r:
                            case $27a155bcdd967657$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $27a155bcdd967657$var$d:
                return u;
        }
    }
}
function $27a155bcdd967657$var$A(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$m;
}
$27a155bcdd967657$export$2b8d127b894957b9 = $27a155bcdd967657$var$l;
$27a155bcdd967657$export$cea3a54a6425200c = $27a155bcdd967657$var$m;
$27a155bcdd967657$export$a7c73072b1a182ae = $27a155bcdd967657$var$k;
$27a155bcdd967657$export$9f27bc3417b4524d = $27a155bcdd967657$var$h;
$27a155bcdd967657$export$db77ccec0bb4ccac = $27a155bcdd967657$var$c;
$27a155bcdd967657$export$8392c0c9d3dcbd35 = $27a155bcdd967657$var$n;
$27a155bcdd967657$export$ffb0004e005737fa = $27a155bcdd967657$var$e;
$27a155bcdd967657$export$b624eff549462981 = $27a155bcdd967657$var$t;
$27a155bcdd967657$export$7897aa7841a5380c = $27a155bcdd967657$var$r;
$27a155bcdd967657$export$602eac185826482c = $27a155bcdd967657$var$d;
$27a155bcdd967657$export$e2c29f18771995cb = $27a155bcdd967657$var$g;
$27a155bcdd967657$export$5f8d39834fd61797 = $27a155bcdd967657$var$f;
$27a155bcdd967657$export$74bf444e3cd11ea5 = $27a155bcdd967657$var$p;
$27a155bcdd967657$export$92387174baf9b227 = function(a) {
    return $27a155bcdd967657$var$A(a) || $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$l;
};
$27a155bcdd967657$export$ec112efeb987d9c6 = $27a155bcdd967657$var$A;
$27a155bcdd967657$export$b706b080d889d2c9 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$k;
};
$27a155bcdd967657$export$5be5a87408f70ddc = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$h;
};
$27a155bcdd967657$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $27a155bcdd967657$var$c;
};
$27a155bcdd967657$export$455c2e768291efa6 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$n;
};
$27a155bcdd967657$export$9522e17588c12572 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$e;
};
$27a155bcdd967657$export$2110ac352bb060b9 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$t;
};
$27a155bcdd967657$export$56885ab8b9c456ab = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$r;
};
$27a155bcdd967657$export$d927fcb6adf8f9de = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$d;
};
$27a155bcdd967657$export$b82d16f27459e05a = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$g;
};
$27a155bcdd967657$export$522c17b4f5e123e8 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$f;
};
$27a155bcdd967657$export$1aabd8a0274ecfd6 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$p;
};
$27a155bcdd967657$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $27a155bcdd967657$var$e || a === $27a155bcdd967657$var$m || a === $27a155bcdd967657$var$g || a === $27a155bcdd967657$var$f || a === $27a155bcdd967657$var$p || a === $27a155bcdd967657$var$q || "object" === typeof a && null !== a && (a.$$typeof === $27a155bcdd967657$var$t || a.$$typeof === $27a155bcdd967657$var$r || a.$$typeof === $27a155bcdd967657$var$h || a.$$typeof === $27a155bcdd967657$var$k || a.$$typeof === $27a155bcdd967657$var$n || a.$$typeof === $27a155bcdd967657$var$w || a.$$typeof === $27a155bcdd967657$var$x || a.$$typeof === $27a155bcdd967657$var$y || a.$$typeof === $27a155bcdd967657$var$v);
};
$27a155bcdd967657$export$f5bbd400c2f4426f = $27a155bcdd967657$var$z;

});

parcelRegister("2Fp4m", function(module, exports) {
module.exports = $parcel$import("5x3at").then(()=>parcelRequire('fVMg8'));

});

parcelRegister("6EA3T", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $4d82739dd229d539$export$ae55be85d98224ed; }, function (v) { return $4d82739dd229d539$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $4d82739dd229d539$export$d39a5bbd09211389; }, function (v) { return $4d82739dd229d539$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $4d82739dd229d539$export$882461b6382ed46c; }, function (v) { return $4d82739dd229d539$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $4d82739dd229d539$export$466bfc07425424d5; }, function (v) { return $4d82739dd229d539$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $4d82739dd229d539$export$cd75ccfd720a3cd4; }, function (v) { return $4d82739dd229d539$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $4d82739dd229d539$export$fa8d919ba61d84db; }, function (v) { return $4d82739dd229d539$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $4d82739dd229d539$export$757ceba2d55c277e; }, function (v) { return $4d82739dd229d539$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $4d82739dd229d539$export$b3890eb0ae9dca99; }, function (v) { return $4d82739dd229d539$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $4d82739dd229d539$export$502457920280e6be; }, function (v) { return $4d82739dd229d539$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $4d82739dd229d539$export$c78a37762a8d58e1; }, function (v) { return $4d82739dd229d539$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $4d82739dd229d539$export$dc54d992c10e8a18; }, function (v) { return $4d82739dd229d539$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $4d82739dd229d539$export$83d89fbfd8236492; }, function (v) { return $4d82739dd229d539$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $4d82739dd229d539$export$ae55be85d98224ed;
var $4d82739dd229d539$export$d39a5bbd09211389;
var $4d82739dd229d539$export$882461b6382ed46c;
var $4d82739dd229d539$export$466bfc07425424d5;
var $4d82739dd229d539$export$cd75ccfd720a3cd4;
var $4d82739dd229d539$export$fa8d919ba61d84db;
var $4d82739dd229d539$export$757ceba2d55c277e;
var $4d82739dd229d539$export$b3890eb0ae9dca99;
var $4d82739dd229d539$export$502457920280e6be;
var $4d82739dd229d539$export$c78a37762a8d58e1;
var $4d82739dd229d539$export$dc54d992c10e8a18;
var $4d82739dd229d539$export$83d89fbfd8236492;
'use strict';

var $7fPBF = parcelRequire("7fPBF");

var $33s19 = parcelRequire("33s19");
function $4d82739dd229d539$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $4d82739dd229d539$var$da = new Set, $4d82739dd229d539$var$ea = {};
function $4d82739dd229d539$var$fa(a, b) {
    $4d82739dd229d539$var$ha(a, b);
    $4d82739dd229d539$var$ha(a + "Capture", b);
}
function $4d82739dd229d539$var$ha(a, b) {
    $4d82739dd229d539$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$4d82739dd229d539$var$da.add(b[a]);
}
var $4d82739dd229d539$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $4d82739dd229d539$var$ja = Object.prototype.hasOwnProperty, $4d82739dd229d539$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $4d82739dd229d539$var$la = {}, $4d82739dd229d539$var$ma = {};
function $4d82739dd229d539$var$oa(a) {
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$ma, a)) return !0;
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$la, a)) return !1;
    if ($4d82739dd229d539$var$ka.test(a)) return $4d82739dd229d539$var$ma[a] = !0;
    $4d82739dd229d539$var$la[a] = !0;
    return !1;
}
function $4d82739dd229d539$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $4d82739dd229d539$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $4d82739dd229d539$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $4d82739dd229d539$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $4d82739dd229d539$var$ra = /[\-:]([a-z])/g;
function $4d82739dd229d539$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$4d82739dd229d539$var$z.xlinkHref = new $4d82739dd229d539$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $4d82739dd229d539$var$ta(a, b, c, d) {
    var e = $4d82739dd229d539$var$z.hasOwnProperty(b) ? $4d82739dd229d539$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $4d82739dd229d539$var$qa(b, c, e, d) && (c = null), d || null === e ? $4d82739dd229d539$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $4d82739dd229d539$var$ua = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $4d82739dd229d539$var$va = Symbol.for("react.element"), $4d82739dd229d539$var$wa = Symbol.for("react.portal"), $4d82739dd229d539$var$ya = Symbol.for("react.fragment"), $4d82739dd229d539$var$za = Symbol.for("react.strict_mode"), $4d82739dd229d539$var$Aa = Symbol.for("react.profiler"), $4d82739dd229d539$var$Ba = Symbol.for("react.provider"), $4d82739dd229d539$var$Ca = Symbol.for("react.context"), $4d82739dd229d539$var$Da = Symbol.for("react.forward_ref"), $4d82739dd229d539$var$Ea = Symbol.for("react.suspense"), $4d82739dd229d539$var$Fa = Symbol.for("react.suspense_list"), $4d82739dd229d539$var$Ga = Symbol.for("react.memo"), $4d82739dd229d539$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $4d82739dd229d539$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $4d82739dd229d539$var$Ja = Symbol.iterator;
function $4d82739dd229d539$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $4d82739dd229d539$var$Ja && a[$4d82739dd229d539$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $4d82739dd229d539$var$A = Object.assign, $4d82739dd229d539$var$La;
function $4d82739dd229d539$var$Ma(a) {
    if (void 0 === $4d82739dd229d539$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $4d82739dd229d539$var$La = b && b[1] || "";
    }
    return "\n" + $4d82739dd229d539$var$La + a;
}
var $4d82739dd229d539$var$Na = !1;
function $4d82739dd229d539$var$Oa(a, b) {
    if (!a || $4d82739dd229d539$var$Na) return "";
    $4d82739dd229d539$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $4d82739dd229d539$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $4d82739dd229d539$var$Ma(a) : "";
}
function $4d82739dd229d539$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $4d82739dd229d539$var$Ma(a.type);
        case 16:
            return $4d82739dd229d539$var$Ma("Lazy");
        case 13:
            return $4d82739dd229d539$var$Ma("Suspense");
        case 19:
            return $4d82739dd229d539$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $4d82739dd229d539$var$Oa(a.type, !1), a;
        case 11:
            return a = $4d82739dd229d539$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $4d82739dd229d539$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $4d82739dd229d539$var$ya:
            return "Fragment";
        case $4d82739dd229d539$var$wa:
            return "Portal";
        case $4d82739dd229d539$var$Aa:
            return "Profiler";
        case $4d82739dd229d539$var$za:
            return "StrictMode";
        case $4d82739dd229d539$var$Ea:
            return "Suspense";
        case $4d82739dd229d539$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $4d82739dd229d539$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $4d82739dd229d539$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $4d82739dd229d539$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $4d82739dd229d539$var$Ga:
            return b = a.displayName || null, null !== b ? b : $4d82739dd229d539$var$Qa(a.type) || "Memo";
        case $4d82739dd229d539$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $4d82739dd229d539$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $4d82739dd229d539$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $4d82739dd229d539$var$Qa(b);
        case 8:
            return b === $4d82739dd229d539$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $4d82739dd229d539$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $4d82739dd229d539$var$Ua(a) {
    var b = $4d82739dd229d539$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $4d82739dd229d539$var$Va(a) {
    a._valueTracker || (a._valueTracker = $4d82739dd229d539$var$Ua(a));
}
function $4d82739dd229d539$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $4d82739dd229d539$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $4d82739dd229d539$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $4d82739dd229d539$var$Ya(a, b) {
    var c = b.checked;
    return $4d82739dd229d539$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $4d82739dd229d539$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $4d82739dd229d539$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $4d82739dd229d539$var$ab(a, b) {
    b = b.checked;
    null != b && $4d82739dd229d539$var$ta(a, "checked", b, !1);
}
function $4d82739dd229d539$var$bb(a, b) {
    $4d82739dd229d539$var$ab(a, b);
    var c = $4d82739dd229d539$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $4d82739dd229d539$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $4d82739dd229d539$var$cb(a, b.type, $4d82739dd229d539$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $4d82739dd229d539$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $4d82739dd229d539$var$cb(a, b, c) {
    if ("number" !== b || $4d82739dd229d539$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $4d82739dd229d539$var$eb = Array.isArray;
function $4d82739dd229d539$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $4d82739dd229d539$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $4d82739dd229d539$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($4d82739dd229d539$var$p(91));
    return $4d82739dd229d539$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $4d82739dd229d539$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($4d82739dd229d539$var$p(92));
            if ($4d82739dd229d539$var$eb(c)) {
                if (1 < c.length) throw Error($4d82739dd229d539$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $4d82739dd229d539$var$Sa(c)
    };
}
function $4d82739dd229d539$var$ib(a, b) {
    var c = $4d82739dd229d539$var$Sa(b.value), d = $4d82739dd229d539$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $4d82739dd229d539$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $4d82739dd229d539$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $4d82739dd229d539$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $4d82739dd229d539$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $4d82739dd229d539$var$mb, $4d82739dd229d539$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $4d82739dd229d539$var$mb = $4d82739dd229d539$var$mb || document.createElement("div");
        $4d82739dd229d539$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $4d82739dd229d539$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $4d82739dd229d539$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $4d82739dd229d539$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $4d82739dd229d539$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($4d82739dd229d539$var$pb).forEach(function(a) {
    $4d82739dd229d539$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $4d82739dd229d539$var$pb[b] = $4d82739dd229d539$var$pb[a];
    });
});
function $4d82739dd229d539$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $4d82739dd229d539$var$pb.hasOwnProperty(a) && $4d82739dd229d539$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $4d82739dd229d539$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $4d82739dd229d539$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $4d82739dd229d539$var$tb = $4d82739dd229d539$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $4d82739dd229d539$var$ub(a, b) {
    if (b) {
        if ($4d82739dd229d539$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($4d82739dd229d539$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($4d82739dd229d539$var$p(62));
    }
}
function $4d82739dd229d539$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $4d82739dd229d539$var$wb = null;
function $4d82739dd229d539$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $4d82739dd229d539$var$yb = null, $4d82739dd229d539$var$zb = null, $4d82739dd229d539$var$Ab = null;
function $4d82739dd229d539$var$Bb(a) {
    if (a = $4d82739dd229d539$var$Cb(a)) {
        if ("function" !== typeof $4d82739dd229d539$var$yb) throw Error($4d82739dd229d539$var$p(280));
        var b = a.stateNode;
        b && (b = $4d82739dd229d539$var$Db(b), $4d82739dd229d539$var$yb(a.stateNode, a.type, b));
    }
}
function $4d82739dd229d539$var$Eb(a) {
    $4d82739dd229d539$var$zb ? $4d82739dd229d539$var$Ab ? $4d82739dd229d539$var$Ab.push(a) : $4d82739dd229d539$var$Ab = [
        a
    ] : $4d82739dd229d539$var$zb = a;
}
function $4d82739dd229d539$var$Fb() {
    if ($4d82739dd229d539$var$zb) {
        var a = $4d82739dd229d539$var$zb, b = $4d82739dd229d539$var$Ab;
        $4d82739dd229d539$var$Ab = $4d82739dd229d539$var$zb = null;
        $4d82739dd229d539$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$4d82739dd229d539$var$Bb(b[a]);
    }
}
function $4d82739dd229d539$var$Gb(a, b) {
    return a(b);
}
function $4d82739dd229d539$var$Hb() {}
var $4d82739dd229d539$var$Ib = !1;
function $4d82739dd229d539$var$Jb(a, b, c) {
    if ($4d82739dd229d539$var$Ib) return a(b, c);
    $4d82739dd229d539$var$Ib = !0;
    try {
        return $4d82739dd229d539$var$Gb(a, b, c);
    } finally{
        if ($4d82739dd229d539$var$Ib = !1, null !== $4d82739dd229d539$var$zb || null !== $4d82739dd229d539$var$Ab) $4d82739dd229d539$var$Hb(), $4d82739dd229d539$var$Fb();
    }
}
function $4d82739dd229d539$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $4d82739dd229d539$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($4d82739dd229d539$var$p(231, b, typeof c));
    return c;
}
var $4d82739dd229d539$var$Lb = !1;
if ($4d82739dd229d539$var$ia) try {
    var $4d82739dd229d539$var$Mb = {};
    Object.defineProperty($4d82739dd229d539$var$Mb, "passive", {
        get: function() {
            $4d82739dd229d539$var$Lb = !0;
        }
    });
    window.addEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
    window.removeEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
} catch (a) {
    $4d82739dd229d539$var$Lb = !1;
}
function $4d82739dd229d539$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $4d82739dd229d539$var$Ob = !1, $4d82739dd229d539$var$Pb = null, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, $4d82739dd229d539$var$Sb = {
    onError: function(a) {
        $4d82739dd229d539$var$Ob = !0;
        $4d82739dd229d539$var$Pb = a;
    }
};
function $4d82739dd229d539$var$Tb(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Ob = !1;
    $4d82739dd229d539$var$Pb = null;
    $4d82739dd229d539$var$Nb.apply($4d82739dd229d539$var$Sb, arguments);
}
function $4d82739dd229d539$var$Ub(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Tb.apply(this, arguments);
    if ($4d82739dd229d539$var$Ob) {
        if ($4d82739dd229d539$var$Ob) {
            var l = $4d82739dd229d539$var$Pb;
            $4d82739dd229d539$var$Ob = !1;
            $4d82739dd229d539$var$Pb = null;
        } else throw Error($4d82739dd229d539$var$p(198));
        $4d82739dd229d539$var$Qb || ($4d82739dd229d539$var$Qb = !0, $4d82739dd229d539$var$Rb = l);
    }
}
function $4d82739dd229d539$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $4d82739dd229d539$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $4d82739dd229d539$var$Xb(a) {
    if ($4d82739dd229d539$var$Vb(a) !== a) throw Error($4d82739dd229d539$var$p(188));
}
function $4d82739dd229d539$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $4d82739dd229d539$var$Vb(a);
        if (null === b) throw Error($4d82739dd229d539$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $4d82739dd229d539$var$Xb(e), a;
                if (f === d) return $4d82739dd229d539$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($4d82739dd229d539$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($4d82739dd229d539$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($4d82739dd229d539$var$p(190));
    }
    if (3 !== c.tag) throw Error($4d82739dd229d539$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $4d82739dd229d539$var$Zb(a) {
    a = $4d82739dd229d539$var$Yb(a);
    return null !== a ? $4d82739dd229d539$var$$b(a) : null;
}
function $4d82739dd229d539$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $4d82739dd229d539$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$ac = $33s19.unstable_scheduleCallback, $4d82739dd229d539$var$bc = $33s19.unstable_cancelCallback, $4d82739dd229d539$var$cc = $33s19.unstable_shouldYield, $4d82739dd229d539$var$dc = $33s19.unstable_requestPaint, $4d82739dd229d539$var$B = $33s19.unstable_now, $4d82739dd229d539$var$ec = $33s19.unstable_getCurrentPriorityLevel, $4d82739dd229d539$var$fc = $33s19.unstable_ImmediatePriority, $4d82739dd229d539$var$gc = $33s19.unstable_UserBlockingPriority, $4d82739dd229d539$var$hc = $33s19.unstable_NormalPriority, $4d82739dd229d539$var$ic = $33s19.unstable_LowPriority, $4d82739dd229d539$var$jc = $33s19.unstable_IdlePriority, $4d82739dd229d539$var$kc = null, $4d82739dd229d539$var$lc = null;
function $4d82739dd229d539$var$mc(a) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberRoot) try {
        $4d82739dd229d539$var$lc.onCommitFiberRoot($4d82739dd229d539$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $4d82739dd229d539$var$oc = Math.clz32 ? Math.clz32 : $4d82739dd229d539$var$nc, $4d82739dd229d539$var$pc = Math.log, $4d82739dd229d539$var$qc = Math.LN2;
function $4d82739dd229d539$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($4d82739dd229d539$var$pc(a) / $4d82739dd229d539$var$qc | 0) | 0;
}
var $4d82739dd229d539$var$rc = 64, $4d82739dd229d539$var$sc = 4194304;
function $4d82739dd229d539$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $4d82739dd229d539$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $4d82739dd229d539$var$tc(h) : (f &= g, 0 !== f && (d = $4d82739dd229d539$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $4d82739dd229d539$var$tc(g) : 0 !== f && (d = $4d82739dd229d539$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $4d82739dd229d539$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $4d82739dd229d539$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $4d82739dd229d539$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $4d82739dd229d539$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $4d82739dd229d539$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $4d82739dd229d539$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $4d82739dd229d539$var$yc() {
    var a = $4d82739dd229d539$var$rc;
    $4d82739dd229d539$var$rc <<= 1;
    0 === ($4d82739dd229d539$var$rc & 4194240) && ($4d82739dd229d539$var$rc = 64);
    return a;
}
function $4d82739dd229d539$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $4d82739dd229d539$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $4d82739dd229d539$var$oc(b);
    a[b] = c;
}
function $4d82739dd229d539$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $4d82739dd229d539$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $4d82739dd229d539$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $4d82739dd229d539$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $4d82739dd229d539$var$C = 0;
function $4d82739dd229d539$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $4d82739dd229d539$var$Ec, $4d82739dd229d539$var$Fc, $4d82739dd229d539$var$Gc, $4d82739dd229d539$var$Hc, $4d82739dd229d539$var$Ic, $4d82739dd229d539$var$Jc = !1, $4d82739dd229d539$var$Kc = [], $4d82739dd229d539$var$Lc = null, $4d82739dd229d539$var$Mc = null, $4d82739dd229d539$var$Nc = null, $4d82739dd229d539$var$Oc = new Map, $4d82739dd229d539$var$Pc = new Map, $4d82739dd229d539$var$Qc = [], $4d82739dd229d539$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $4d82739dd229d539$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $4d82739dd229d539$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $4d82739dd229d539$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $4d82739dd229d539$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $4d82739dd229d539$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $4d82739dd229d539$var$Pc.delete(b.pointerId);
    }
}
function $4d82739dd229d539$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $4d82739dd229d539$var$Cb(b), null !== b && $4d82739dd229d539$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $4d82739dd229d539$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $4d82739dd229d539$var$Lc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $4d82739dd229d539$var$Mc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $4d82739dd229d539$var$Nc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $4d82739dd229d539$var$Oc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $4d82739dd229d539$var$Pc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $4d82739dd229d539$var$Vc(a) {
    var b = $4d82739dd229d539$var$Wc(a.target);
    if (null !== b) {
        var c = $4d82739dd229d539$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $4d82739dd229d539$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $4d82739dd229d539$var$Ic(a.priority, function() {
                        $4d82739dd229d539$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $4d82739dd229d539$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $4d82739dd229d539$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $4d82739dd229d539$var$wb = d;
            c.target.dispatchEvent(d);
            $4d82739dd229d539$var$wb = null;
        } else return b = $4d82739dd229d539$var$Cb(c), null !== b && $4d82739dd229d539$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $4d82739dd229d539$var$Zc(a, b, c) {
    $4d82739dd229d539$var$Xc(a) && c.delete(b);
}
function $4d82739dd229d539$var$$c() {
    $4d82739dd229d539$var$Jc = !1;
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Lc) && ($4d82739dd229d539$var$Lc = null);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Mc) && ($4d82739dd229d539$var$Mc = null);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Nc) && ($4d82739dd229d539$var$Nc = null);
    $4d82739dd229d539$var$Oc.forEach($4d82739dd229d539$var$Zc);
    $4d82739dd229d539$var$Pc.forEach($4d82739dd229d539$var$Zc);
}
function $4d82739dd229d539$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $4d82739dd229d539$var$Jc || ($4d82739dd229d539$var$Jc = !0, $33s19.unstable_scheduleCallback($33s19.unstable_NormalPriority, $4d82739dd229d539$var$$c)));
}
function $4d82739dd229d539$var$bd(a) {
    function b(b) {
        return $4d82739dd229d539$var$ad(b, a);
    }
    if (0 < $4d82739dd229d539$var$Kc.length) {
        $4d82739dd229d539$var$ad($4d82739dd229d539$var$Kc[0], a);
        for(var c = 1; c < $4d82739dd229d539$var$Kc.length; c++){
            var d = $4d82739dd229d539$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Lc, a);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Mc, a);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Nc, a);
    $4d82739dd229d539$var$Oc.forEach(b);
    $4d82739dd229d539$var$Pc.forEach(b);
    for(c = 0; c < $4d82739dd229d539$var$Qc.length; c++)d = $4d82739dd229d539$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $4d82739dd229d539$var$Qc.length && (c = $4d82739dd229d539$var$Qc[0], null === c.blockedOn);)$4d82739dd229d539$var$Vc(c), null === c.blockedOn && $4d82739dd229d539$var$Qc.shift();
}
var $4d82739dd229d539$var$cd = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$dd = !0;
function $4d82739dd229d539$var$ed(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$gd(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 4, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$fd(a, b, c, d) {
    if ($4d82739dd229d539$var$dd) {
        var e = $4d82739dd229d539$var$Yc(a, b, c, d);
        if (null === e) $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c), $4d82739dd229d539$var$Sc(a, d);
        else if ($4d82739dd229d539$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($4d82739dd229d539$var$Sc(a, d), b & 4 && -1 < $4d82739dd229d539$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $4d82739dd229d539$var$Cb(e);
                null !== f && $4d82739dd229d539$var$Ec(f);
                f = $4d82739dd229d539$var$Yc(a, b, c, d);
                null === f && $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $4d82739dd229d539$var$hd(a, b, d, null, c);
    }
}
var $4d82739dd229d539$var$id = null;
function $4d82739dd229d539$var$Yc(a, b, c, d) {
    $4d82739dd229d539$var$id = null;
    a = $4d82739dd229d539$var$xb(d);
    a = $4d82739dd229d539$var$Wc(a);
    if (null !== a) {
        if (b = $4d82739dd229d539$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $4d82739dd229d539$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $4d82739dd229d539$var$id = a;
    return null;
}
function $4d82739dd229d539$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($4d82739dd229d539$var$ec()){
                case $4d82739dd229d539$var$fc:
                    return 1;
                case $4d82739dd229d539$var$gc:
                    return 4;
                case $4d82739dd229d539$var$hc:
                case $4d82739dd229d539$var$ic:
                    return 16;
                case $4d82739dd229d539$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ld = null, $4d82739dd229d539$var$md = null;
function $4d82739dd229d539$var$nd() {
    if ($4d82739dd229d539$var$md) return $4d82739dd229d539$var$md;
    var a, b = $4d82739dd229d539$var$ld, c = b.length, d, e = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $4d82739dd229d539$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $4d82739dd229d539$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $4d82739dd229d539$var$pd() {
    return !0;
}
function $4d82739dd229d539$var$qd() {
    return !1;
}
function $4d82739dd229d539$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $4d82739dd229d539$var$pd : $4d82739dd229d539$var$qd;
        this.isPropagationStopped = $4d82739dd229d539$var$qd;
        return this;
    }
    $4d82739dd229d539$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $4d82739dd229d539$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $4d82739dd229d539$var$pd);
        },
        persist: function() {},
        isPersistent: $4d82739dd229d539$var$pd
    });
    return b;
}
var $4d82739dd229d539$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $4d82739dd229d539$var$td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$sd), $4d82739dd229d539$var$ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    view: 0,
    detail: 0
}), $4d82739dd229d539$var$vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$ud), $4d82739dd229d539$var$wd, $4d82739dd229d539$var$xd, $4d82739dd229d539$var$yd, $4d82739dd229d539$var$Ad = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $4d82739dd229d539$var$yd && ($4d82739dd229d539$var$yd && "mousemove" === a.type ? ($4d82739dd229d539$var$wd = a.screenX - $4d82739dd229d539$var$yd.screenX, $4d82739dd229d539$var$xd = a.screenY - $4d82739dd229d539$var$yd.screenY) : $4d82739dd229d539$var$xd = $4d82739dd229d539$var$wd = 0, $4d82739dd229d539$var$yd = a);
        return $4d82739dd229d539$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $4d82739dd229d539$var$xd;
    }
}), $4d82739dd229d539$var$Bd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ad), $4d82739dd229d539$var$Cd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    dataTransfer: 0
}), $4d82739dd229d539$var$Dd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Cd), $4d82739dd229d539$var$Ed = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    relatedTarget: 0
}), $4d82739dd229d539$var$Fd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ed), $4d82739dd229d539$var$Gd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Hd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Gd), $4d82739dd229d539$var$Id = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $4d82739dd229d539$var$Jd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Id), $4d82739dd229d539$var$Kd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    data: 0
}), $4d82739dd229d539$var$Ld = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Kd), $4d82739dd229d539$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $4d82739dd229d539$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $4d82739dd229d539$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $4d82739dd229d539$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $4d82739dd229d539$var$Od[a]) ? !!b[a] : !1;
}
function $4d82739dd229d539$var$zd() {
    return $4d82739dd229d539$var$Pd;
}
var $4d82739dd229d539$var$Qd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $4d82739dd229d539$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $4d82739dd229d539$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $4d82739dd229d539$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $4d82739dd229d539$var$Rd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Qd), $4d82739dd229d539$var$Sd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $4d82739dd229d539$var$Td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Sd), $4d82739dd229d539$var$Ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $4d82739dd229d539$var$zd
}), $4d82739dd229d539$var$Vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ud), $4d82739dd229d539$var$Wd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Xd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Wd), $4d82739dd229d539$var$Yd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $4d82739dd229d539$var$Zd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Yd), $4d82739dd229d539$var$$d = [
    9,
    13,
    27,
    32
], $4d82739dd229d539$var$ae = $4d82739dd229d539$var$ia && "CompositionEvent" in window, $4d82739dd229d539$var$be = null;
$4d82739dd229d539$var$ia && "documentMode" in document && ($4d82739dd229d539$var$be = document.documentMode);
var $4d82739dd229d539$var$ce = $4d82739dd229d539$var$ia && "TextEvent" in window && !$4d82739dd229d539$var$be, $4d82739dd229d539$var$de = $4d82739dd229d539$var$ia && (!$4d82739dd229d539$var$ae || $4d82739dd229d539$var$be && 8 < $4d82739dd229d539$var$be && 11 >= $4d82739dd229d539$var$be), $4d82739dd229d539$var$ee = String.fromCharCode(32), $4d82739dd229d539$var$fe = !1;
function $4d82739dd229d539$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $4d82739dd229d539$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $4d82739dd229d539$var$ie = !1;
function $4d82739dd229d539$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $4d82739dd229d539$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $4d82739dd229d539$var$fe = !0;
            return $4d82739dd229d539$var$ee;
        case "textInput":
            return a = b.data, a === $4d82739dd229d539$var$ee && $4d82739dd229d539$var$fe ? null : a;
        default:
            return null;
    }
}
function $4d82739dd229d539$var$ke(a, b) {
    if ($4d82739dd229d539$var$ie) return "compositionend" === a || !$4d82739dd229d539$var$ae && $4d82739dd229d539$var$ge(a, b) ? (a = $4d82739dd229d539$var$nd(), $4d82739dd229d539$var$md = $4d82739dd229d539$var$ld = $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $4d82739dd229d539$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $4d82739dd229d539$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$4d82739dd229d539$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $4d82739dd229d539$var$ne(a, b, c, d) {
    $4d82739dd229d539$var$Eb(d);
    b = $4d82739dd229d539$var$oe(b, "onChange");
    0 < b.length && (c = new $4d82739dd229d539$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $4d82739dd229d539$var$pe = null, $4d82739dd229d539$var$qe = null;
function $4d82739dd229d539$var$re(a) {
    $4d82739dd229d539$var$se(a, 0);
}
function $4d82739dd229d539$var$te(a) {
    var b = $4d82739dd229d539$var$ue(a);
    if ($4d82739dd229d539$var$Wa(b)) return a;
}
function $4d82739dd229d539$var$ve(a, b) {
    if ("change" === a) return b;
}
var $4d82739dd229d539$var$we = !1;
if ($4d82739dd229d539$var$ia) {
    var $4d82739dd229d539$var$xe;
    if ($4d82739dd229d539$var$ia) {
        var $4d82739dd229d539$var$ye = "oninput" in document;
        if (!$4d82739dd229d539$var$ye) {
            var $4d82739dd229d539$var$ze = document.createElement("div");
            $4d82739dd229d539$var$ze.setAttribute("oninput", "return;");
            $4d82739dd229d539$var$ye = "function" === typeof $4d82739dd229d539$var$ze.oninput;
        }
        $4d82739dd229d539$var$xe = $4d82739dd229d539$var$ye;
    } else $4d82739dd229d539$var$xe = !1;
    $4d82739dd229d539$var$we = $4d82739dd229d539$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $4d82739dd229d539$var$Ae() {
    $4d82739dd229d539$var$pe && ($4d82739dd229d539$var$pe.detachEvent("onpropertychange", $4d82739dd229d539$var$Be), $4d82739dd229d539$var$qe = $4d82739dd229d539$var$pe = null);
}
function $4d82739dd229d539$var$Be(a) {
    if ("value" === a.propertyName && $4d82739dd229d539$var$te($4d82739dd229d539$var$qe)) {
        var b = [];
        $4d82739dd229d539$var$ne(b, $4d82739dd229d539$var$qe, a, $4d82739dd229d539$var$xb(a));
        $4d82739dd229d539$var$Jb($4d82739dd229d539$var$re, b);
    }
}
function $4d82739dd229d539$var$Ce(a, b, c) {
    "focusin" === a ? ($4d82739dd229d539$var$Ae(), $4d82739dd229d539$var$pe = b, $4d82739dd229d539$var$qe = c, $4d82739dd229d539$var$pe.attachEvent("onpropertychange", $4d82739dd229d539$var$Be)) : "focusout" === a && $4d82739dd229d539$var$Ae();
}
function $4d82739dd229d539$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $4d82739dd229d539$var$te($4d82739dd229d539$var$qe);
}
function $4d82739dd229d539$var$Ee(a, b) {
    if ("click" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $4d82739dd229d539$var$He = "function" === typeof Object.is ? Object.is : $4d82739dd229d539$var$Ge;
function $4d82739dd229d539$var$Ie(a, b) {
    if ($4d82739dd229d539$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$4d82739dd229d539$var$ja.call(b, e) || !$4d82739dd229d539$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $4d82739dd229d539$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $4d82739dd229d539$var$Ke(a, b) {
    var c = $4d82739dd229d539$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $4d82739dd229d539$var$Je(c);
    }
}
function $4d82739dd229d539$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $4d82739dd229d539$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $4d82739dd229d539$var$Me() {
    for(var a = window, b = $4d82739dd229d539$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $4d82739dd229d539$var$Xa(a.document);
    }
    return b;
}
function $4d82739dd229d539$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $4d82739dd229d539$var$Oe(a) {
    var b = $4d82739dd229d539$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $4d82739dd229d539$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $4d82739dd229d539$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $4d82739dd229d539$var$Ke(c, f);
                var g = $4d82739dd229d539$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $4d82739dd229d539$var$Pe = $4d82739dd229d539$var$ia && "documentMode" in document && 11 >= document.documentMode, $4d82739dd229d539$var$Qe = null, $4d82739dd229d539$var$Re = null, $4d82739dd229d539$var$Se = null, $4d82739dd229d539$var$Te = !1;
function $4d82739dd229d539$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $4d82739dd229d539$var$Te || null == $4d82739dd229d539$var$Qe || $4d82739dd229d539$var$Qe !== $4d82739dd229d539$var$Xa(d) || (d = $4d82739dd229d539$var$Qe, "selectionStart" in d && $4d82739dd229d539$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $4d82739dd229d539$var$Se && $4d82739dd229d539$var$Ie($4d82739dd229d539$var$Se, d) || ($4d82739dd229d539$var$Se = d, d = $4d82739dd229d539$var$oe($4d82739dd229d539$var$Re, "onSelect"), 0 < d.length && (b = new $4d82739dd229d539$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $4d82739dd229d539$var$Qe)));
}
function $4d82739dd229d539$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $4d82739dd229d539$var$We = {
    animationend: $4d82739dd229d539$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $4d82739dd229d539$var$Ve("Animation", "AnimationIteration"),
    animationstart: $4d82739dd229d539$var$Ve("Animation", "AnimationStart"),
    transitionend: $4d82739dd229d539$var$Ve("Transition", "TransitionEnd")
}, $4d82739dd229d539$var$Xe = {}, $4d82739dd229d539$var$Ye = {};
$4d82739dd229d539$var$ia && ($4d82739dd229d539$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $4d82739dd229d539$var$We.animationend.animation, delete $4d82739dd229d539$var$We.animationiteration.animation, delete $4d82739dd229d539$var$We.animationstart.animation), "TransitionEvent" in window || delete $4d82739dd229d539$var$We.transitionend.transition);
function $4d82739dd229d539$var$Ze(a) {
    if ($4d82739dd229d539$var$Xe[a]) return $4d82739dd229d539$var$Xe[a];
    if (!$4d82739dd229d539$var$We[a]) return a;
    var b = $4d82739dd229d539$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $4d82739dd229d539$var$Ye) return $4d82739dd229d539$var$Xe[a] = b[c];
    return a;
}
var $4d82739dd229d539$var$$e = $4d82739dd229d539$var$Ze("animationend"), $4d82739dd229d539$var$af = $4d82739dd229d539$var$Ze("animationiteration"), $4d82739dd229d539$var$bf = $4d82739dd229d539$var$Ze("animationstart"), $4d82739dd229d539$var$cf = $4d82739dd229d539$var$Ze("transitionend"), $4d82739dd229d539$var$df = new Map, $4d82739dd229d539$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $4d82739dd229d539$var$ff(a, b) {
    $4d82739dd229d539$var$df.set(a, b);
    $4d82739dd229d539$var$fa(b, [
        a
    ]);
}
for(var $4d82739dd229d539$var$gf = 0; $4d82739dd229d539$var$gf < $4d82739dd229d539$var$ef.length; $4d82739dd229d539$var$gf++){
    var $4d82739dd229d539$var$hf = $4d82739dd229d539$var$ef[$4d82739dd229d539$var$gf], $4d82739dd229d539$var$jf = $4d82739dd229d539$var$hf.toLowerCase(), $4d82739dd229d539$var$kf = $4d82739dd229d539$var$hf[0].toUpperCase() + $4d82739dd229d539$var$hf.slice(1);
    $4d82739dd229d539$var$ff($4d82739dd229d539$var$jf, "on" + $4d82739dd229d539$var$kf);
}
$4d82739dd229d539$var$ff($4d82739dd229d539$var$$e, "onAnimationEnd");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$af, "onAnimationIteration");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$bf, "onAnimationStart");
$4d82739dd229d539$var$ff("dblclick", "onDoubleClick");
$4d82739dd229d539$var$ff("focusin", "onFocus");
$4d82739dd229d539$var$ff("focusout", "onBlur");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$cf, "onTransitionEnd");
$4d82739dd229d539$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$4d82739dd229d539$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $4d82739dd229d539$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $4d82739dd229d539$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($4d82739dd229d539$var$lf));
function $4d82739dd229d539$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $4d82739dd229d539$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $4d82739dd229d539$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($4d82739dd229d539$var$Qb) throw a = $4d82739dd229d539$var$Rb, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, a;
}
function $4d82739dd229d539$var$D(a, b) {
    var c = b[$4d82739dd229d539$var$of];
    void 0 === c && (c = b[$4d82739dd229d539$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($4d82739dd229d539$var$pf(b, a, 2, !1), c.add(d));
}
function $4d82739dd229d539$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $4d82739dd229d539$var$pf(c, a, d, b);
}
var $4d82739dd229d539$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $4d82739dd229d539$var$sf(a) {
    if (!a[$4d82739dd229d539$var$rf]) {
        a[$4d82739dd229d539$var$rf] = !0;
        $4d82739dd229d539$var$da.forEach(function(b) {
            "selectionchange" !== b && ($4d82739dd229d539$var$mf.has(b) || $4d82739dd229d539$var$qf(b, !1, a), $4d82739dd229d539$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$4d82739dd229d539$var$rf] || (b[$4d82739dd229d539$var$rf] = !0, $4d82739dd229d539$var$qf("selectionchange", !1, b));
    }
}
function $4d82739dd229d539$var$pf(a, b, c, d) {
    switch($4d82739dd229d539$var$jd(b)){
        case 1:
            var e = $4d82739dd229d539$var$ed;
            break;
        case 4:
            e = $4d82739dd229d539$var$gd;
            break;
        default:
            e = $4d82739dd229d539$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$4d82739dd229d539$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $4d82739dd229d539$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $4d82739dd229d539$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $4d82739dd229d539$var$Jb(function() {
        var d = f, e = $4d82739dd229d539$var$xb(c), g = [];
        a: {
            var h = $4d82739dd229d539$var$df.get(a);
            if (void 0 !== h) {
                var k = $4d82739dd229d539$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $4d82739dd229d539$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $4d82739dd229d539$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $4d82739dd229d539$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $4d82739dd229d539$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $4d82739dd229d539$var$Vd;
                        break;
                    case $4d82739dd229d539$var$$e:
                    case $4d82739dd229d539$var$af:
                    case $4d82739dd229d539$var$bf:
                        k = $4d82739dd229d539$var$Hd;
                        break;
                    case $4d82739dd229d539$var$cf:
                        k = $4d82739dd229d539$var$Xd;
                        break;
                    case "scroll":
                        k = $4d82739dd229d539$var$vd;
                        break;
                    case "wheel":
                        k = $4d82739dd229d539$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $4d82739dd229d539$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $4d82739dd229d539$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $4d82739dd229d539$var$Kb(w, x), null != F && t.push($4d82739dd229d539$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $4d82739dd229d539$var$wb && (n = c.relatedTarget || c.fromElement) && ($4d82739dd229d539$var$Wc(n) || n[$4d82739dd229d539$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $4d82739dd229d539$var$Wc(n) : null, null !== n && (J = $4d82739dd229d539$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $4d82739dd229d539$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $4d82739dd229d539$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $4d82739dd229d539$var$ue(k);
                        u = null == n ? h : $4d82739dd229d539$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $4d82739dd229d539$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $4d82739dd229d539$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $4d82739dd229d539$var$vf(F))u++;
                            for(; 0 < w - u;)t = $4d82739dd229d539$var$vf(t), w--;
                            for(; 0 < u - w;)x = $4d82739dd229d539$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $4d82739dd229d539$var$vf(t);
                                x = $4d82739dd229d539$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $4d82739dd229d539$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $4d82739dd229d539$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $4d82739dd229d539$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $4d82739dd229d539$var$ve;
                else if ($4d82739dd229d539$var$me(h)) {
                    if ($4d82739dd229d539$var$we) na = $4d82739dd229d539$var$Fe;
                    else {
                        na = $4d82739dd229d539$var$De;
                        var xa = $4d82739dd229d539$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $4d82739dd229d539$var$Ee);
                if (na && (na = na(a, d))) {
                    $4d82739dd229d539$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $4d82739dd229d539$var$cb(h, "number", h.value);
            }
            xa = d ? $4d82739dd229d539$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($4d82739dd229d539$var$me(xa) || "true" === xa.contentEditable) $4d82739dd229d539$var$Qe = xa, $4d82739dd229d539$var$Re = d, $4d82739dd229d539$var$Se = null;
                    break;
                case "focusout":
                    $4d82739dd229d539$var$Se = $4d82739dd229d539$var$Re = $4d82739dd229d539$var$Qe = null;
                    break;
                case "mousedown":
                    $4d82739dd229d539$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $4d82739dd229d539$var$Te = !1;
                    $4d82739dd229d539$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($4d82739dd229d539$var$Pe) break;
                case "keydown":
                case "keyup":
                    $4d82739dd229d539$var$Ue(g, c, e);
            }
            var $a;
            if ($4d82739dd229d539$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $4d82739dd229d539$var$ie ? $4d82739dd229d539$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($4d82739dd229d539$var$de && "ko" !== c.locale && ($4d82739dd229d539$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $4d82739dd229d539$var$ie && ($a = $4d82739dd229d539$var$nd()) : ($4d82739dd229d539$var$kd = e, $4d82739dd229d539$var$ld = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, $4d82739dd229d539$var$ie = !0)), xa = $4d82739dd229d539$var$oe(d, ba), 0 < xa.length && (ba = new $4d82739dd229d539$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $4d82739dd229d539$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $4d82739dd229d539$var$ce ? $4d82739dd229d539$var$je(a, c) : $4d82739dd229d539$var$ke(a, c)) d = $4d82739dd229d539$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $4d82739dd229d539$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $4d82739dd229d539$var$se(g, b);
    });
}
function $4d82739dd229d539$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $4d82739dd229d539$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $4d82739dd229d539$var$Kb(a, c), null != f && d.unshift($4d82739dd229d539$var$tf(a, f, e)), f = $4d82739dd229d539$var$Kb(a, b), null != f && d.push($4d82739dd229d539$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $4d82739dd229d539$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $4d82739dd229d539$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.unshift($4d82739dd229d539$var$tf(c, k, h))) : e || (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.push($4d82739dd229d539$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $4d82739dd229d539$var$xf = /\r\n?/g, $4d82739dd229d539$var$yf = /\u0000|\uFFFD/g;
function $4d82739dd229d539$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($4d82739dd229d539$var$xf, "\n").replace($4d82739dd229d539$var$yf, "");
}
function $4d82739dd229d539$var$Af(a, b, c) {
    b = $4d82739dd229d539$var$zf(b);
    if ($4d82739dd229d539$var$zf(a) !== b && c) throw Error($4d82739dd229d539$var$p(425));
}
function $4d82739dd229d539$var$Bf() {}
var $4d82739dd229d539$var$Cf = null, $4d82739dd229d539$var$Df = null;
function $4d82739dd229d539$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $4d82739dd229d539$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $4d82739dd229d539$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $4d82739dd229d539$var$Hf = "function" === typeof Promise ? Promise : void 0, $4d82739dd229d539$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $4d82739dd229d539$var$Hf ? function(a) {
    return $4d82739dd229d539$var$Hf.resolve(null).then(a).catch($4d82739dd229d539$var$If);
} : $4d82739dd229d539$var$Ff;
function $4d82739dd229d539$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $4d82739dd229d539$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $4d82739dd229d539$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $4d82739dd229d539$var$bd(b);
}
function $4d82739dd229d539$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $4d82739dd229d539$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $4d82739dd229d539$var$Nf = Math.random().toString(36).slice(2), $4d82739dd229d539$var$Of = "__reactFiber$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Pf = "__reactProps$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$uf = "__reactContainer$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$of = "__reactEvents$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Qf = "__reactListeners$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Rf = "__reactHandles$" + $4d82739dd229d539$var$Nf;
function $4d82739dd229d539$var$Wc(a) {
    var b = a[$4d82739dd229d539$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$4d82739dd229d539$var$uf] || c[$4d82739dd229d539$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $4d82739dd229d539$var$Mf(a); null !== a;){
                if (c = a[$4d82739dd229d539$var$Of]) return c;
                a = $4d82739dd229d539$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $4d82739dd229d539$var$Cb(a) {
    a = a[$4d82739dd229d539$var$Of] || a[$4d82739dd229d539$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $4d82739dd229d539$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($4d82739dd229d539$var$p(33));
}
function $4d82739dd229d539$var$Db(a) {
    return a[$4d82739dd229d539$var$Pf] || null;
}
var $4d82739dd229d539$var$Sf = [], $4d82739dd229d539$var$Tf = -1;
function $4d82739dd229d539$var$Uf(a) {
    return {
        current: a
    };
}
function $4d82739dd229d539$var$E(a) {
    0 > $4d82739dd229d539$var$Tf || (a.current = $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf], $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = null, $4d82739dd229d539$var$Tf--);
}
function $4d82739dd229d539$var$G(a, b) {
    $4d82739dd229d539$var$Tf++;
    $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = a.current;
    a.current = b;
}
var $4d82739dd229d539$var$Vf = {}, $4d82739dd229d539$var$H = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Vf), $4d82739dd229d539$var$Wf = $4d82739dd229d539$var$Uf(!1), $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$Vf;
function $4d82739dd229d539$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $4d82739dd229d539$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $4d82739dd229d539$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $4d82739dd229d539$var$$f() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
}
function $4d82739dd229d539$var$ag(a, b, c) {
    if ($4d82739dd229d539$var$H.current !== $4d82739dd229d539$var$Vf) throw Error($4d82739dd229d539$var$p(168));
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
function $4d82739dd229d539$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($4d82739dd229d539$var$p(108, $4d82739dd229d539$var$Ra(a) || "Unknown", e));
    return $4d82739dd229d539$var$A({}, c, d);
}
function $4d82739dd229d539$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $4d82739dd229d539$var$Vf;
    $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$H.current;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, $4d82739dd229d539$var$Wf.current);
    return !0;
}
function $4d82739dd229d539$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($4d82739dd229d539$var$p(169));
    c ? (a = $4d82739dd229d539$var$bg(a, b, $4d82739dd229d539$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a)) : $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
var $4d82739dd229d539$var$eg = null, $4d82739dd229d539$var$fg = !1, $4d82739dd229d539$var$gg = !1;
function $4d82739dd229d539$var$hg(a) {
    null === $4d82739dd229d539$var$eg ? $4d82739dd229d539$var$eg = [
        a
    ] : $4d82739dd229d539$var$eg.push(a);
}
function $4d82739dd229d539$var$ig(a) {
    $4d82739dd229d539$var$fg = !0;
    $4d82739dd229d539$var$hg(a);
}
function $4d82739dd229d539$var$jg() {
    if (!$4d82739dd229d539$var$gg && null !== $4d82739dd229d539$var$eg) {
        $4d82739dd229d539$var$gg = !0;
        var a = 0, b = $4d82739dd229d539$var$C;
        try {
            var c = $4d82739dd229d539$var$eg;
            for($4d82739dd229d539$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $4d82739dd229d539$var$eg = null;
            $4d82739dd229d539$var$fg = !1;
        } catch (e) {
            throw null !== $4d82739dd229d539$var$eg && ($4d82739dd229d539$var$eg = $4d82739dd229d539$var$eg.slice(a + 1)), $4d82739dd229d539$var$ac($4d82739dd229d539$var$fc, $4d82739dd229d539$var$jg), e;
        } finally{
            $4d82739dd229d539$var$C = b, $4d82739dd229d539$var$gg = !1;
        }
    }
    return null;
}
var $4d82739dd229d539$var$kg = [], $4d82739dd229d539$var$lg = 0, $4d82739dd229d539$var$mg = null, $4d82739dd229d539$var$ng = 0, $4d82739dd229d539$var$og = [], $4d82739dd229d539$var$pg = 0, $4d82739dd229d539$var$qg = null, $4d82739dd229d539$var$rg = 1, $4d82739dd229d539$var$sg = "";
function $4d82739dd229d539$var$tg(a, b) {
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$ng;
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$mg;
    $4d82739dd229d539$var$mg = a;
    $4d82739dd229d539$var$ng = b;
}
function $4d82739dd229d539$var$ug(a, b, c) {
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg;
    $4d82739dd229d539$var$qg = a;
    var d = $4d82739dd229d539$var$rg;
    a = $4d82739dd229d539$var$sg;
    var e = 32 - $4d82739dd229d539$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $4d82739dd229d539$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $4d82739dd229d539$var$rg = 1 << 32 - $4d82739dd229d539$var$oc(b) + e | c << e | d;
        $4d82739dd229d539$var$sg = f + a;
    } else $4d82739dd229d539$var$rg = 1 << f | c << e | d, $4d82739dd229d539$var$sg = a;
}
function $4d82739dd229d539$var$vg(a) {
    null !== a.return && ($4d82739dd229d539$var$tg(a, 1), $4d82739dd229d539$var$ug(a, 1, 0));
}
function $4d82739dd229d539$var$wg(a) {
    for(; a === $4d82739dd229d539$var$mg;)$4d82739dd229d539$var$mg = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null, $4d82739dd229d539$var$ng = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null;
    for(; a === $4d82739dd229d539$var$qg;)$4d82739dd229d539$var$qg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$sg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$rg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null;
}
var $4d82739dd229d539$var$xg = null, $4d82739dd229d539$var$yg = null, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$zg = null;
function $4d82739dd229d539$var$Ag(a, b) {
    var c = $4d82739dd229d539$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $4d82739dd229d539$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $4d82739dd229d539$var$qg ? {
                id: $4d82739dd229d539$var$rg,
                overflow: $4d82739dd229d539$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $4d82739dd229d539$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $4d82739dd229d539$var$Eg(a) {
    if ($4d82739dd229d539$var$I) {
        var b = $4d82739dd229d539$var$yg;
        if (b) {
            var c = b;
            if (!$4d82739dd229d539$var$Cg(a, b)) {
                if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
                b = $4d82739dd229d539$var$Lf(c.nextSibling);
                var d = $4d82739dd229d539$var$xg;
                b && $4d82739dd229d539$var$Cg(a, b) ? $4d82739dd229d539$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$xg = a);
            }
        } else {
            if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $4d82739dd229d539$var$I = !1;
            $4d82739dd229d539$var$xg = a;
        }
    }
}
function $4d82739dd229d539$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $4d82739dd229d539$var$xg = a;
}
function $4d82739dd229d539$var$Gg(a) {
    if (a !== $4d82739dd229d539$var$xg) return !1;
    if (!$4d82739dd229d539$var$I) return $4d82739dd229d539$var$Fg(a), $4d82739dd229d539$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$4d82739dd229d539$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $4d82739dd229d539$var$yg)) {
        if ($4d82739dd229d539$var$Dg(a)) throw $4d82739dd229d539$var$Hg(), Error($4d82739dd229d539$var$p(418));
        for(; b;)$4d82739dd229d539$var$Ag(a, b), b = $4d82739dd229d539$var$Lf(b.nextSibling);
    }
    $4d82739dd229d539$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($4d82739dd229d539$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $4d82739dd229d539$var$yg = null;
        }
    } else $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg ? $4d82739dd229d539$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $4d82739dd229d539$var$Hg() {
    for(var a = $4d82739dd229d539$var$yg; a;)a = $4d82739dd229d539$var$Lf(a.nextSibling);
}
function $4d82739dd229d539$var$Ig() {
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg = null;
    $4d82739dd229d539$var$I = !1;
}
function $4d82739dd229d539$var$Jg(a) {
    null === $4d82739dd229d539$var$zg ? $4d82739dd229d539$var$zg = [
        a
    ] : $4d82739dd229d539$var$zg.push(a);
}
var $4d82739dd229d539$var$Kg = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig;
function $4d82739dd229d539$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($4d82739dd229d539$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($4d82739dd229d539$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($4d82739dd229d539$var$p(284));
        if (!c._owner) throw Error($4d82739dd229d539$var$p(290, a));
    }
    return a;
}
function $4d82739dd229d539$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($4d82739dd229d539$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $4d82739dd229d539$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $4d82739dd229d539$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $4d82739dd229d539$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $4d82739dd229d539$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $4d82739dd229d539$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $4d82739dd229d539$var$Lg(a, b, c), d.return = a, d;
        d = $4d82739dd229d539$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $4d82739dd229d539$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $4d82739dd229d539$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $4d82739dd229d539$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $4d82739dd229d539$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c = $4d82739dd229d539$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $4d82739dd229d539$var$Lg(a, null, b), c.return = a, c;
                case $4d82739dd229d539$var$wa:
                    return b = $4d82739dd229d539$var$Sg(b, a.mode, c), b.return = a, b;
                case $4d82739dd229d539$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($4d82739dd229d539$var$eb(b) || $4d82739dd229d539$var$Ka(b)) return b = $4d82739dd229d539$var$Tg(b, a.mode, c, null), b.return = a, b;
            $4d82739dd229d539$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $4d82739dd229d539$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $4d82739dd229d539$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($4d82739dd229d539$var$eb(c) || $4d82739dd229d539$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $4d82739dd229d539$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $4d82739dd229d539$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $4d82739dd229d539$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $4d82739dd229d539$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($4d82739dd229d539$var$eb(d) || $4d82739dd229d539$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $4d82739dd229d539$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $4d82739dd229d539$var$Ka(h);
        if ("function" !== typeof l) throw Error($4d82739dd229d539$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($4d82739dd229d539$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $4d82739dd229d539$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $4d82739dd229d539$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $4d82739dd229d539$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $4d82739dd229d539$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $4d82739dd229d539$var$ya ? (d = $4d82739dd229d539$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $4d82739dd229d539$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $4d82739dd229d539$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $4d82739dd229d539$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $4d82739dd229d539$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $4d82739dd229d539$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($4d82739dd229d539$var$eb(f)) return n(a, d, f, h);
            if ($4d82739dd229d539$var$Ka(f)) return t(a, d, f, h);
            $4d82739dd229d539$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $4d82739dd229d539$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $4d82739dd229d539$var$Ug = $4d82739dd229d539$var$Og(!0), $4d82739dd229d539$var$Vg = $4d82739dd229d539$var$Og(!1), $4d82739dd229d539$var$Wg = $4d82739dd229d539$var$Uf(null), $4d82739dd229d539$var$Xg = null, $4d82739dd229d539$var$Yg = null, $4d82739dd229d539$var$Zg = null;
function $4d82739dd229d539$var$$g() {
    $4d82739dd229d539$var$Zg = $4d82739dd229d539$var$Yg = $4d82739dd229d539$var$Xg = null;
}
function $4d82739dd229d539$var$ah(a) {
    var b = $4d82739dd229d539$var$Wg.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Wg);
    a._currentValue = b;
}
function $4d82739dd229d539$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $4d82739dd229d539$var$ch(a, b) {
    $4d82739dd229d539$var$Xg = a;
    $4d82739dd229d539$var$Zg = $4d82739dd229d539$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($4d82739dd229d539$var$dh = !0), a.firstContext = null);
}
function $4d82739dd229d539$var$eh(a) {
    var b = a._currentValue;
    if ($4d82739dd229d539$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $4d82739dd229d539$var$Yg) {
            if (null === $4d82739dd229d539$var$Xg) throw Error($4d82739dd229d539$var$p(308));
            $4d82739dd229d539$var$Yg = a;
            $4d82739dd229d539$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $4d82739dd229d539$var$Yg = $4d82739dd229d539$var$Yg.next = a;
    }
    return b;
}
var $4d82739dd229d539$var$fh = null;
function $4d82739dd229d539$var$gh(a) {
    null === $4d82739dd229d539$var$fh ? $4d82739dd229d539$var$fh = [
        a
    ] : $4d82739dd229d539$var$fh.push(a);
}
function $4d82739dd229d539$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $4d82739dd229d539$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $4d82739dd229d539$var$ih(a, d);
}
function $4d82739dd229d539$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $4d82739dd229d539$var$jh = !1;
function $4d82739dd229d539$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $4d82739dd229d539$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $4d82739dd229d539$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $4d82739dd229d539$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($4d82739dd229d539$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $4d82739dd229d539$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $4d82739dd229d539$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $4d82739dd229d539$var$ih(a, c);
}
function $4d82739dd229d539$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
function $4d82739dd229d539$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $4d82739dd229d539$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $4d82739dd229d539$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $4d82739dd229d539$var$A({}, q, r);
                            break a;
                        case 2:
                            $4d82739dd229d539$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $4d82739dd229d539$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $4d82739dd229d539$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($4d82739dd229d539$var$p(191, e));
            e.call(d);
        }
    }
}
var $4d82739dd229d539$var$th = {}, $4d82739dd229d539$var$uh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th), $4d82739dd229d539$var$vh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th), $4d82739dd229d539$var$wh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th);
function $4d82739dd229d539$var$xh(a) {
    if (a === $4d82739dd229d539$var$th) throw Error($4d82739dd229d539$var$p(174));
    return a;
}
function $4d82739dd229d539$var$yh(a, b) {
    $4d82739dd229d539$var$G($4d82739dd229d539$var$wh, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$vh, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, $4d82739dd229d539$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $4d82739dd229d539$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $4d82739dd229d539$var$lb(b, a);
    }
    $4d82739dd229d539$var$E($4d82739dd229d539$var$uh);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, b);
}
function $4d82739dd229d539$var$zh() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$uh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$vh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$wh);
}
function $4d82739dd229d539$var$Ah(a) {
    $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
    var b = $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
    var c = $4d82739dd229d539$var$lb(b, a.type);
    b !== c && ($4d82739dd229d539$var$G($4d82739dd229d539$var$vh, a), $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, c));
}
function $4d82739dd229d539$var$Bh(a) {
    $4d82739dd229d539$var$vh.current === a && ($4d82739dd229d539$var$E($4d82739dd229d539$var$uh), $4d82739dd229d539$var$E($4d82739dd229d539$var$vh));
}
var $4d82739dd229d539$var$L = $4d82739dd229d539$var$Uf(0);
function $4d82739dd229d539$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$Dh = [];
function $4d82739dd229d539$var$Eh() {
    for(var a = 0; a < $4d82739dd229d539$var$Dh.length; a++)$4d82739dd229d539$var$Dh[a]._workInProgressVersionPrimary = null;
    $4d82739dd229d539$var$Dh.length = 0;
}
var $4d82739dd229d539$var$Fh = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$Gh = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$Hh = 0, $4d82739dd229d539$var$M = null, $4d82739dd229d539$var$N = null, $4d82739dd229d539$var$O = null, $4d82739dd229d539$var$Ih = !1, $4d82739dd229d539$var$Jh = !1, $4d82739dd229d539$var$Kh = 0, $4d82739dd229d539$var$Lh = 0;
function $4d82739dd229d539$var$P() {
    throw Error($4d82739dd229d539$var$p(321));
}
function $4d82739dd229d539$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$4d82739dd229d539$var$He(a[c], b[c])) return !1;
    return !0;
}
function $4d82739dd229d539$var$Nh(a, b, c, d, e, f) {
    $4d82739dd229d539$var$Hh = f;
    $4d82739dd229d539$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $4d82739dd229d539$var$Fh.current = null === a || null === a.memoizedState ? $4d82739dd229d539$var$Oh : $4d82739dd229d539$var$Ph;
    a = c(d, e);
    if ($4d82739dd229d539$var$Jh) {
        f = 0;
        do {
            $4d82739dd229d539$var$Jh = !1;
            $4d82739dd229d539$var$Kh = 0;
            if (25 <= f) throw Error($4d82739dd229d539$var$p(301));
            f += 1;
            $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = null;
            b.updateQueue = null;
            $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Qh;
            a = c(d, e);
        }while ($4d82739dd229d539$var$Jh);
    }
    $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Rh;
    b = null !== $4d82739dd229d539$var$N && null !== $4d82739dd229d539$var$N.next;
    $4d82739dd229d539$var$Hh = 0;
    $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = $4d82739dd229d539$var$M = null;
    $4d82739dd229d539$var$Ih = !1;
    if (b) throw Error($4d82739dd229d539$var$p(300));
    return a;
}
function $4d82739dd229d539$var$Sh() {
    var a = 0 !== $4d82739dd229d539$var$Kh;
    $4d82739dd229d539$var$Kh = 0;
    return a;
}
function $4d82739dd229d539$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState = $4d82739dd229d539$var$O = a : $4d82739dd229d539$var$O = $4d82739dd229d539$var$O.next = a;
    return $4d82739dd229d539$var$O;
}
function $4d82739dd229d539$var$Uh() {
    if (null === $4d82739dd229d539$var$N) {
        var a = $4d82739dd229d539$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $4d82739dd229d539$var$N.next;
    var b = null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState : $4d82739dd229d539$var$O.next;
    if (null !== b) $4d82739dd229d539$var$O = b, $4d82739dd229d539$var$N = a;
    else {
        if (null === a) throw Error($4d82739dd229d539$var$p(310));
        $4d82739dd229d539$var$N = a;
        a = {
            memoizedState: $4d82739dd229d539$var$N.memoizedState,
            baseState: $4d82739dd229d539$var$N.baseState,
            baseQueue: $4d82739dd229d539$var$N.baseQueue,
            queue: $4d82739dd229d539$var$N.queue,
            next: null
        };
        null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState = $4d82739dd229d539$var$O = a : $4d82739dd229d539$var$O = $4d82739dd229d539$var$O.next = a;
    }
    return $4d82739dd229d539$var$O;
}
function $4d82739dd229d539$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $4d82739dd229d539$var$Wh(a) {
    var b = $4d82739dd229d539$var$Uh(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = $4d82739dd229d539$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($4d82739dd229d539$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $4d82739dd229d539$var$M.lanes |= m;
                $4d82739dd229d539$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $4d82739dd229d539$var$He(d, b.memoizedState) || ($4d82739dd229d539$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $4d82739dd229d539$var$M.lanes |= f, $4d82739dd229d539$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $4d82739dd229d539$var$Xh(a) {
    var b = $4d82739dd229d539$var$Uh(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $4d82739dd229d539$var$He(f, b.memoizedState) || ($4d82739dd229d539$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $4d82739dd229d539$var$Yh() {}
function $4d82739dd229d539$var$Zh(a, b) {
    var c = $4d82739dd229d539$var$M, d = $4d82739dd229d539$var$Uh(), e = b(), f = !$4d82739dd229d539$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $4d82739dd229d539$var$dh = !0);
    d = d.queue;
    $4d82739dd229d539$var$$h($4d82739dd229d539$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $4d82739dd229d539$var$O && $4d82739dd229d539$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $4d82739dd229d539$var$bi(9, $4d82739dd229d539$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $4d82739dd229d539$var$Q) throw Error($4d82739dd229d539$var$p(349));
        0 !== ($4d82739dd229d539$var$Hh & 30) || $4d82739dd229d539$var$di(c, b, e);
    }
    return e;
}
function $4d82739dd229d539$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $4d82739dd229d539$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $4d82739dd229d539$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $4d82739dd229d539$var$ei(b) && $4d82739dd229d539$var$fi(a);
}
function $4d82739dd229d539$var$ai(a, b, c) {
    return c(function() {
        $4d82739dd229d539$var$ei(b) && $4d82739dd229d539$var$fi(a);
    });
}
function $4d82739dd229d539$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$4d82739dd229d539$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $4d82739dd229d539$var$fi(a) {
    var b = $4d82739dd229d539$var$ih(a, 1);
    null !== b && $4d82739dd229d539$var$gi(b, a, 1, -1);
}
function $4d82739dd229d539$var$hi(a) {
    var b = $4d82739dd229d539$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $4d82739dd229d539$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $4d82739dd229d539$var$ii.bind(null, $4d82739dd229d539$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $4d82739dd229d539$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $4d82739dd229d539$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $4d82739dd229d539$var$ji() {
    return $4d82739dd229d539$var$Uh().memoizedState;
}
function $4d82739dd229d539$var$ki(a, b, c, d) {
    var e = $4d82739dd229d539$var$Th();
    $4d82739dd229d539$var$M.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $4d82739dd229d539$var$li(a, b, c, d) {
    var e = $4d82739dd229d539$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $4d82739dd229d539$var$N) {
        var g = $4d82739dd229d539$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $4d82739dd229d539$var$Mh(d, g.deps)) {
            e.memoizedState = $4d82739dd229d539$var$bi(b, c, f, d);
            return;
        }
    }
    $4d82739dd229d539$var$M.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$bi(1 | b, c, f, d);
}
function $4d82739dd229d539$var$mi(a, b) {
    return $4d82739dd229d539$var$ki(8390656, 8, a, b);
}
function $4d82739dd229d539$var$$h(a, b) {
    return $4d82739dd229d539$var$li(2048, 8, a, b);
}
function $4d82739dd229d539$var$ni(a, b) {
    return $4d82739dd229d539$var$li(4, 2, a, b);
}
function $4d82739dd229d539$var$oi(a, b) {
    return $4d82739dd229d539$var$li(4, 4, a, b);
}
function $4d82739dd229d539$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $4d82739dd229d539$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $4d82739dd229d539$var$li(4, 4, $4d82739dd229d539$var$pi.bind(null, b, a), c);
}
function $4d82739dd229d539$var$ri() {}
function $4d82739dd229d539$var$si(a, b) {
    var c = $4d82739dd229d539$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$ti(a, b) {
    var c = $4d82739dd229d539$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$ui(a, b, c) {
    if (0 === ($4d82739dd229d539$var$Hh & 21)) return a.baseState && (a.baseState = !1, $4d82739dd229d539$var$dh = !0), a.memoizedState = c;
    $4d82739dd229d539$var$He(c, b) || (c = $4d82739dd229d539$var$yc(), $4d82739dd229d539$var$M.lanes |= c, $4d82739dd229d539$var$rh |= c, a.baseState = !0);
    return b;
}
function $4d82739dd229d539$var$vi(a, b) {
    var c = $4d82739dd229d539$var$C;
    $4d82739dd229d539$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $4d82739dd229d539$var$Gh.transition;
    $4d82739dd229d539$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$Gh.transition = d;
    }
}
function $4d82739dd229d539$var$wi() {
    return $4d82739dd229d539$var$Uh().memoizedState;
}
function $4d82739dd229d539$var$xi(a, b, c) {
    var d = $4d82739dd229d539$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$zi(a)) $4d82739dd229d539$var$Ai(b, c);
    else if (c = $4d82739dd229d539$var$hh(a, b, c, d), null !== c) {
        var e = $4d82739dd229d539$var$R();
        $4d82739dd229d539$var$gi(c, a, d, e);
        $4d82739dd229d539$var$Bi(c, b, d);
    }
}
function $4d82739dd229d539$var$ii(a, b, c) {
    var d = $4d82739dd229d539$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$zi(a)) $4d82739dd229d539$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($4d82739dd229d539$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $4d82739dd229d539$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $4d82739dd229d539$var$hh(a, b, e, d);
        null !== c && (e = $4d82739dd229d539$var$R(), $4d82739dd229d539$var$gi(c, a, d, e), $4d82739dd229d539$var$Bi(c, b, d));
    }
}
function $4d82739dd229d539$var$zi(a) {
    var b = a.alternate;
    return a === $4d82739dd229d539$var$M || null !== b && b === $4d82739dd229d539$var$M;
}
function $4d82739dd229d539$var$Ai(a, b) {
    $4d82739dd229d539$var$Jh = $4d82739dd229d539$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $4d82739dd229d539$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
var $4d82739dd229d539$var$Rh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$P,
    useContext: $4d82739dd229d539$var$P,
    useEffect: $4d82739dd229d539$var$P,
    useImperativeHandle: $4d82739dd229d539$var$P,
    useInsertionEffect: $4d82739dd229d539$var$P,
    useLayoutEffect: $4d82739dd229d539$var$P,
    useMemo: $4d82739dd229d539$var$P,
    useReducer: $4d82739dd229d539$var$P,
    useRef: $4d82739dd229d539$var$P,
    useState: $4d82739dd229d539$var$P,
    useDebugValue: $4d82739dd229d539$var$P,
    useDeferredValue: $4d82739dd229d539$var$P,
    useTransition: $4d82739dd229d539$var$P,
    useMutableSource: $4d82739dd229d539$var$P,
    useSyncExternalStore: $4d82739dd229d539$var$P,
    useId: $4d82739dd229d539$var$P,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Oh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: function(a, b) {
        $4d82739dd229d539$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $4d82739dd229d539$var$ki(4194308, 4, $4d82739dd229d539$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $4d82739dd229d539$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $4d82739dd229d539$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $4d82739dd229d539$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $4d82739dd229d539$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $4d82739dd229d539$var$xi.bind(null, $4d82739dd229d539$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $4d82739dd229d539$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $4d82739dd229d539$var$hi,
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        return $4d82739dd229d539$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$hi(!1), b = a[0];
        a = $4d82739dd229d539$var$vi.bind(null, a[1]);
        $4d82739dd229d539$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $4d82739dd229d539$var$M, e = $4d82739dd229d539$var$Th();
        if ($4d82739dd229d539$var$I) {
            if (void 0 === c) throw Error($4d82739dd229d539$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $4d82739dd229d539$var$Q) throw Error($4d82739dd229d539$var$p(349));
            0 !== ($4d82739dd229d539$var$Hh & 30) || $4d82739dd229d539$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $4d82739dd229d539$var$mi($4d82739dd229d539$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $4d82739dd229d539$var$bi(9, $4d82739dd229d539$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $4d82739dd229d539$var$Th(), b = $4d82739dd229d539$var$Q.identifierPrefix;
        if ($4d82739dd229d539$var$I) {
            var c = $4d82739dd229d539$var$sg;
            var d = $4d82739dd229d539$var$rg;
            c = (d & ~(1 << 32 - $4d82739dd229d539$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $4d82739dd229d539$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $4d82739dd229d539$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Ph = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$si,
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$$h,
    useImperativeHandle: $4d82739dd229d539$var$qi,
    useInsertionEffect: $4d82739dd229d539$var$ni,
    useLayoutEffect: $4d82739dd229d539$var$oi,
    useMemo: $4d82739dd229d539$var$ti,
    useReducer: $4d82739dd229d539$var$Wh,
    useRef: $4d82739dd229d539$var$ji,
    useState: function() {
        return $4d82739dd229d539$var$Wh($4d82739dd229d539$var$Vh);
    },
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$Uh();
        return $4d82739dd229d539$var$ui(b, $4d82739dd229d539$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$Wh($4d82739dd229d539$var$Vh)[0], b = $4d82739dd229d539$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$Yh,
    useSyncExternalStore: $4d82739dd229d539$var$Zh,
    useId: $4d82739dd229d539$var$wi,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Qh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$si,
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$$h,
    useImperativeHandle: $4d82739dd229d539$var$qi,
    useInsertionEffect: $4d82739dd229d539$var$ni,
    useLayoutEffect: $4d82739dd229d539$var$oi,
    useMemo: $4d82739dd229d539$var$ti,
    useReducer: $4d82739dd229d539$var$Xh,
    useRef: $4d82739dd229d539$var$ji,
    useState: function() {
        return $4d82739dd229d539$var$Xh($4d82739dd229d539$var$Vh);
    },
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$Uh();
        return null === $4d82739dd229d539$var$N ? b.memoizedState = a : $4d82739dd229d539$var$ui(b, $4d82739dd229d539$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$Xh($4d82739dd229d539$var$Vh)[0], b = $4d82739dd229d539$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$Yh,
    useSyncExternalStore: $4d82739dd229d539$var$Zh,
    useId: $4d82739dd229d539$var$wi,
    unstable_isNewReconciler: !1
};
function $4d82739dd229d539$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $4d82739dd229d539$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $4d82739dd229d539$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $4d82739dd229d539$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $4d82739dd229d539$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $4d82739dd229d539$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$R(), e = $4d82739dd229d539$var$yi(a), f = $4d82739dd229d539$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$nh(a, f, e);
        null !== b && ($4d82739dd229d539$var$gi(b, a, e, d), $4d82739dd229d539$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$R(), e = $4d82739dd229d539$var$yi(a), f = $4d82739dd229d539$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$nh(a, f, e);
        null !== b && ($4d82739dd229d539$var$gi(b, a, e, d), $4d82739dd229d539$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $4d82739dd229d539$var$R(), d = $4d82739dd229d539$var$yi(a), e = $4d82739dd229d539$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $4d82739dd229d539$var$nh(a, e, d);
        null !== b && ($4d82739dd229d539$var$gi(b, a, d, c), $4d82739dd229d539$var$oh(b, a, d));
    }
};
function $4d82739dd229d539$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$4d82739dd229d539$var$Ie(c, d) || !$4d82739dd229d539$var$Ie(e, f) : !0;
}
function $4d82739dd229d539$var$Gi(a, b, c) {
    var d = !1, e = $4d82739dd229d539$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $4d82739dd229d539$var$eh(f) : (e = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $4d82739dd229d539$var$Yf(a, e) : $4d82739dd229d539$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $4d82739dd229d539$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $4d82739dd229d539$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $4d82739dd229d539$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $4d82739dd229d539$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $4d82739dd229d539$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $4d82739dd229d539$var$eh(f) : (f = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, e.context = $4d82739dd229d539$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($4d82739dd229d539$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $4d82739dd229d539$var$Ei.enqueueReplaceState(e, e.state, null), $4d82739dd229d539$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $4d82739dd229d539$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $4d82739dd229d539$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $4d82739dd229d539$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $4d82739dd229d539$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $4d82739dd229d539$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $4d82739dd229d539$var$Ni(a, b, c) {
    c = $4d82739dd229d539$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $4d82739dd229d539$var$Oi || ($4d82739dd229d539$var$Oi = !0, $4d82739dd229d539$var$Pi = d);
        $4d82739dd229d539$var$Li(a, b);
    };
    return c;
}
function $4d82739dd229d539$var$Qi(a, b, c) {
    c = $4d82739dd229d539$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $4d82739dd229d539$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $4d82739dd229d539$var$Li(a, b);
        "function" !== typeof d && (null === $4d82739dd229d539$var$Ri ? $4d82739dd229d539$var$Ri = new Set([
            this
        ]) : $4d82739dd229d539$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $4d82739dd229d539$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $4d82739dd229d539$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $4d82739dd229d539$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $4d82739dd229d539$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $4d82739dd229d539$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $4d82739dd229d539$var$mh(-1, 1), b.tag = 2, $4d82739dd229d539$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $4d82739dd229d539$var$Wi = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$dh = !1;
function $4d82739dd229d539$var$Xi(a, b, c, d) {
    b.child = null === a ? $4d82739dd229d539$var$Vg(b, null, c, d) : $4d82739dd229d539$var$Ug(b, a.child, c, d);
}
function $4d82739dd229d539$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $4d82739dd229d539$var$ch(b, e);
    d = $4d82739dd229d539$var$Nh(a, b, c, d, f, e);
    c = $4d82739dd229d539$var$Sh();
    if (null !== a && !$4d82739dd229d539$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$Zi(a, b, e);
    $4d82739dd229d539$var$I && c && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Xi(a, b, d, e);
    return b.child;
}
function $4d82739dd229d539$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$4d82739dd229d539$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $4d82739dd229d539$var$bj(a, b, f, d, e);
        a = $4d82739dd229d539$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $4d82739dd229d539$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $4d82739dd229d539$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $4d82739dd229d539$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $4d82739dd229d539$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($4d82739dd229d539$var$Ie(f, d) && a.ref === b.ref) {
            if ($4d82739dd229d539$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($4d82739dd229d539$var$dh = !0);
            else return b.lanes = a.lanes, $4d82739dd229d539$var$Zi(a, b, e);
        }
    }
    return $4d82739dd229d539$var$cj(a, b, c, d, e);
}
function $4d82739dd229d539$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj);
            $4d82739dd229d539$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= d;
    $4d82739dd229d539$var$Xi(a, b, e, c);
    return b.child;
}
function $4d82739dd229d539$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $4d82739dd229d539$var$cj(a, b, c, d, e) {
    var f = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current;
    f = $4d82739dd229d539$var$Yf(b, f);
    $4d82739dd229d539$var$ch(b, e);
    c = $4d82739dd229d539$var$Nh(a, b, c, d, f, e);
    d = $4d82739dd229d539$var$Sh();
    if (null !== a && !$4d82739dd229d539$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$Zi(a, b, e);
    $4d82739dd229d539$var$I && d && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Xi(a, b, c, e);
    return b.child;
}
function $4d82739dd229d539$var$hj(a, b, c, d, e) {
    if ($4d82739dd229d539$var$Zf(c)) {
        var f = !0;
        $4d82739dd229d539$var$cg(b);
    } else f = !1;
    $4d82739dd229d539$var$ch(b, e);
    if (null === b.stateNode) $4d82739dd229d539$var$ij(a, b), $4d82739dd229d539$var$Gi(b, c, d), $4d82739dd229d539$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $4d82739dd229d539$var$eh(l) : (l = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, l = $4d82739dd229d539$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $4d82739dd229d539$var$Hi(b, g, d, l);
        $4d82739dd229d539$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$jh ? ("function" === typeof m && ($4d82739dd229d539$var$Di(b, c, m, d), k = b.memoizedState), (h = $4d82739dd229d539$var$jh || $4d82739dd229d539$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $4d82739dd229d539$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $4d82739dd229d539$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $4d82739dd229d539$var$eh(k) : (k = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, k = $4d82739dd229d539$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $4d82739dd229d539$var$Hi(b, g, d, k);
        $4d82739dd229d539$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$jh ? ("function" === typeof y && ($4d82739dd229d539$var$Di(b, c, y, d), n = b.memoizedState), (l = $4d82739dd229d539$var$jh || $4d82739dd229d539$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $4d82739dd229d539$var$jj(a, b, c, d, f, e);
}
function $4d82739dd229d539$var$jj(a, b, c, d, e, f) {
    $4d82739dd229d539$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $4d82739dd229d539$var$dg(b, c, !1), $4d82739dd229d539$var$Zi(a, b, f);
    d = b.stateNode;
    $4d82739dd229d539$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $4d82739dd229d539$var$Ug(b, a.child, null, f), b.child = $4d82739dd229d539$var$Ug(b, null, h, f)) : $4d82739dd229d539$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $4d82739dd229d539$var$dg(b, c, !0);
    return b.child;
}
function $4d82739dd229d539$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $4d82739dd229d539$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $4d82739dd229d539$var$ag(a, b.context, !1);
    $4d82739dd229d539$var$yh(a, b.containerInfo);
}
function $4d82739dd229d539$var$lj(a, b, c, d, e) {
    $4d82739dd229d539$var$Ig();
    $4d82739dd229d539$var$Jg(e);
    b.flags |= 256;
    $4d82739dd229d539$var$Xi(a, b, c, d);
    return b.child;
}
var $4d82739dd229d539$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $4d82739dd229d539$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $4d82739dd229d539$var$oj(a, b, c) {
    var d = b.pendingProps, e = $4d82739dd229d539$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$L, e & 1);
    if (null === a) {
        $4d82739dd229d539$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $4d82739dd229d539$var$pj(g, d, 0, null), a = $4d82739dd229d539$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $4d82739dd229d539$var$nj(c), b.memoizedState = $4d82739dd229d539$var$mj, a) : $4d82739dd229d539$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $4d82739dd229d539$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $4d82739dd229d539$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $4d82739dd229d539$var$Pg(h, f) : (f = $4d82739dd229d539$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $4d82739dd229d539$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $4d82739dd229d539$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $4d82739dd229d539$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $4d82739dd229d539$var$qj(a, b) {
    b = $4d82739dd229d539$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $4d82739dd229d539$var$sj(a, b, c, d) {
    null !== d && $4d82739dd229d539$var$Jg(d);
    $4d82739dd229d539$var$Ug(b, a.child, null, c);
    a = $4d82739dd229d539$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $4d82739dd229d539$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(422))), $4d82739dd229d539$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $4d82739dd229d539$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $4d82739dd229d539$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $4d82739dd229d539$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $4d82739dd229d539$var$nj(g);
        b.memoizedState = $4d82739dd229d539$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $4d82739dd229d539$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($4d82739dd229d539$var$p(419));
        d = $4d82739dd229d539$var$Ki(f, d, void 0);
        return $4d82739dd229d539$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($4d82739dd229d539$var$dh || h) {
        d = $4d82739dd229d539$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $4d82739dd229d539$var$ih(a, e), $4d82739dd229d539$var$gi(d, a, e, -1));
        }
        $4d82739dd229d539$var$tj();
        d = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(421)));
        return $4d82739dd229d539$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $4d82739dd229d539$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(e.nextSibling);
    $4d82739dd229d539$var$xg = b;
    $4d82739dd229d539$var$I = !0;
    $4d82739dd229d539$var$zg = null;
    null !== a && ($4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg, $4d82739dd229d539$var$rg = a.id, $4d82739dd229d539$var$sg = a.overflow, $4d82739dd229d539$var$qg = b);
    b = $4d82739dd229d539$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $4d82739dd229d539$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $4d82739dd229d539$var$bh(a.return, b, c);
}
function $4d82739dd229d539$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $4d82739dd229d539$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $4d82739dd229d539$var$Xi(a, b, d.children, c);
    d = $4d82739dd229d539$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $4d82739dd229d539$var$vj(a, c, b);
            else if (19 === a.tag) $4d82739dd229d539$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $4d82739dd229d539$var$G($4d82739dd229d539$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $4d82739dd229d539$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $4d82739dd229d539$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $4d82739dd229d539$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $4d82739dd229d539$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $4d82739dd229d539$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $4d82739dd229d539$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $4d82739dd229d539$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($4d82739dd229d539$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $4d82739dd229d539$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $4d82739dd229d539$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $4d82739dd229d539$var$kj(b);
            $4d82739dd229d539$var$Ig();
            break;
        case 5:
            $4d82739dd229d539$var$Ah(b);
            break;
        case 1:
            $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$cg(b);
            break;
        case 4:
            $4d82739dd229d539$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $4d82739dd229d539$var$oj(a, b, c);
                $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1);
                a = $4d82739dd229d539$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $4d82739dd229d539$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $4d82739dd229d539$var$dj(a, b, c);
    }
    return $4d82739dd229d539$var$Zi(a, b, c);
}
var $4d82739dd229d539$var$zj, $4d82739dd229d539$var$Aj, $4d82739dd229d539$var$Bj, $4d82739dd229d539$var$Cj;
$4d82739dd229d539$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$4d82739dd229d539$var$Aj = function() {};
$4d82739dd229d539$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $4d82739dd229d539$var$Ya(a, e);
                d = $4d82739dd229d539$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $4d82739dd229d539$var$A({}, e, {
                    value: void 0
                });
                d = $4d82739dd229d539$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $4d82739dd229d539$var$gb(a, e);
                d = $4d82739dd229d539$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
        }
        $4d82739dd229d539$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $4d82739dd229d539$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$4d82739dd229d539$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $4d82739dd229d539$var$Dj(a, b) {
    if (!$4d82739dd229d539$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $4d82739dd229d539$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $4d82739dd229d539$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $4d82739dd229d539$var$S(b), null;
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 3:
            d = b.stateNode;
            $4d82739dd229d539$var$zh();
            $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
            $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
            $4d82739dd229d539$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $4d82739dd229d539$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Fj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null));
            $4d82739dd229d539$var$Aj(a, b);
            $4d82739dd229d539$var$S(b);
            return null;
        case 5:
            $4d82739dd229d539$var$Bh(b);
            var e = $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $4d82739dd229d539$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                    $4d82739dd229d539$var$S(b);
                    return null;
                }
                a = $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    d[$4d82739dd229d539$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $4d82739dd229d539$var$D("cancel", d);
                            $4d82739dd229d539$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], d);
                            break;
                        case "source":
                            $4d82739dd229d539$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $4d82739dd229d539$var$D("error", d);
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "details":
                            $4d82739dd229d539$var$D("toggle", d);
                            break;
                        case "input":
                            $4d82739dd229d539$var$Za(d, f);
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$hb(d, f), $4d82739dd229d539$var$D("invalid", d);
                    }
                    $4d82739dd229d539$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $4d82739dd229d539$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $4d82739dd229d539$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $4d82739dd229d539$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $4d82739dd229d539$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$4d82739dd229d539$var$Of] = b;
                    a[$4d82739dd229d539$var$Pf] = d;
                    $4d82739dd229d539$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $4d82739dd229d539$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $4d82739dd229d539$var$D("cancel", a);
                                $4d82739dd229d539$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $4d82739dd229d539$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $4d82739dd229d539$var$D("error", a);
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $4d82739dd229d539$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $4d82739dd229d539$var$Za(a, d);
                                e = $4d82739dd229d539$var$Ya(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $4d82739dd229d539$var$A({}, d, {
                                    value: void 0
                                });
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$hb(a, d);
                                e = $4d82739dd229d539$var$gb(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $4d82739dd229d539$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $4d82739dd229d539$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $4d82739dd229d539$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $4d82739dd229d539$var$ob(a, k) : "number" === typeof k && $4d82739dd229d539$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($4d82739dd229d539$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $4d82739dd229d539$var$D("scroll", a) : null != k && $4d82739dd229d539$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $4d82739dd229d539$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $4d82739dd229d539$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $4d82739dd229d539$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $4d82739dd229d539$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                c = $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
                $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $4d82739dd229d539$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$4d82739dd229d539$var$Of] = b, b.stateNode = d;
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($4d82739dd229d539$var$I && null !== $4d82739dd229d539$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $4d82739dd229d539$var$Hg(), $4d82739dd229d539$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $4d82739dd229d539$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($4d82739dd229d539$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($4d82739dd229d539$var$p(317));
                        f[$4d82739dd229d539$var$Of] = b;
                    } else $4d82739dd229d539$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $4d82739dd229d539$var$S(b);
                    f = !1;
                } else null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Fj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($4d82739dd229d539$var$L.current & 1) ? 0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 3) : $4d82739dd229d539$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $4d82739dd229d539$var$S(b);
            return null;
        case 4:
            return $4d82739dd229d539$var$zh(), $4d82739dd229d539$var$Aj(a, b), null === a && $4d82739dd229d539$var$sf(b.stateNode.containerInfo), $4d82739dd229d539$var$S(b), null;
        case 10:
            return $4d82739dd229d539$var$ah(b.type._context), $4d82739dd229d539$var$S(b), null;
        case 17:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 19:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            f = b.memoizedState;
            if (null === f) return $4d82739dd229d539$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $4d82739dd229d539$var$Dj(f, !1);
                else {
                    if (0 !== $4d82739dd229d539$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $4d82739dd229d539$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $4d82739dd229d539$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $4d82739dd229d539$var$B() > $4d82739dd229d539$var$Gj && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $4d82739dd229d539$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $4d82739dd229d539$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$4d82739dd229d539$var$I) return $4d82739dd229d539$var$S(b), null;
                    } else 2 * $4d82739dd229d539$var$B() - f.renderingStartTime > $4d82739dd229d539$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $4d82739dd229d539$var$B(), b.sibling = null, c = $4d82739dd229d539$var$L.current, $4d82739dd229d539$var$G($4d82739dd229d539$var$L, d ? c & 1 | 2 : c & 1), b;
            $4d82739dd229d539$var$S(b);
            return null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($4d82739dd229d539$var$fj & 1073741824) && ($4d82739dd229d539$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $4d82739dd229d539$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
}
function $4d82739dd229d539$var$Ij(a, b) {
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $4d82739dd229d539$var$zh(), $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $4d82739dd229d539$var$Bh(b), null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($4d82739dd229d539$var$p(340));
                $4d82739dd229d539$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $4d82739dd229d539$var$E($4d82739dd229d539$var$L), null;
        case 4:
            return $4d82739dd229d539$var$zh(), null;
        case 10:
            return $4d82739dd229d539$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$Jj = !1, $4d82739dd229d539$var$U = !1, $4d82739dd229d539$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $4d82739dd229d539$var$V = null;
function $4d82739dd229d539$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $4d82739dd229d539$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $4d82739dd229d539$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $4d82739dd229d539$var$W(a, b, d);
    }
}
var $4d82739dd229d539$var$Nj = !1;
function $4d82739dd229d539$var$Oj(a, b) {
    $4d82739dd229d539$var$Cf = $4d82739dd229d539$var$dd;
    a = $4d82739dd229d539$var$Me();
    if ($4d82739dd229d539$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $4d82739dd229d539$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $4d82739dd229d539$var$dd = !1;
    for($4d82739dd229d539$var$V = b; null !== $4d82739dd229d539$var$V;)if (b = $4d82739dd229d539$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $4d82739dd229d539$var$V = a;
    else for(; null !== $4d82739dd229d539$var$V;){
        b = $4d82739dd229d539$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $4d82739dd229d539$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(163));
            }
        } catch (F) {
            $4d82739dd229d539$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $4d82739dd229d539$var$V = a;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
    n = $4d82739dd229d539$var$Nj;
    $4d82739dd229d539$var$Nj = !1;
    return n;
}
function $4d82739dd229d539$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $4d82739dd229d539$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $4d82739dd229d539$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $4d82739dd229d539$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $4d82739dd229d539$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $4d82739dd229d539$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$4d82739dd229d539$var$Of], delete b[$4d82739dd229d539$var$Pf], delete b[$4d82739dd229d539$var$of], delete b[$4d82739dd229d539$var$Qf], delete b[$4d82739dd229d539$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $4d82739dd229d539$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $4d82739dd229d539$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $4d82739dd229d539$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $4d82739dd229d539$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $4d82739dd229d539$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Vj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Vj(a, b, c), a = a.sibling;
}
function $4d82739dd229d539$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Wj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Wj(a, b, c), a = a.sibling;
}
var $4d82739dd229d539$var$X = null, $4d82739dd229d539$var$Xj = !1;
function $4d82739dd229d539$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$4d82739dd229d539$var$Zj(a, b, c), c = c.sibling;
}
function $4d82739dd229d539$var$Zj(a, b, c) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberUnmount) try {
        $4d82739dd229d539$var$lc.onCommitFiberUnmount($4d82739dd229d539$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $4d82739dd229d539$var$U || $4d82739dd229d539$var$Lj(c, b);
        case 6:
            var d = $4d82739dd229d539$var$X, e = $4d82739dd229d539$var$Xj;
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Yj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Xj = e;
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Xj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $4d82739dd229d539$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Xj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? $4d82739dd229d539$var$Kf(a.parentNode, c) : 1 === a.nodeType && $4d82739dd229d539$var$Kf(a, c), $4d82739dd229d539$var$bd(a)) : $4d82739dd229d539$var$Kf($4d82739dd229d539$var$X, c.stateNode));
            break;
        case 4:
            d = $4d82739dd229d539$var$X;
            e = $4d82739dd229d539$var$Xj;
            $4d82739dd229d539$var$X = c.stateNode.containerInfo;
            $4d82739dd229d539$var$Xj = !0;
            $4d82739dd229d539$var$Yj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$4d82739dd229d539$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $4d82739dd229d539$var$Mj(c, b, g) : 0 !== (f & 4) && $4d82739dd229d539$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 1:
            if (!$4d82739dd229d539$var$U && ($4d82739dd229d539$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $4d82739dd229d539$var$W(c, b, h);
            }
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 21:
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($4d82739dd229d539$var$U = (d = $4d82739dd229d539$var$U) || null !== c.memoizedState, $4d82739dd229d539$var$Yj(a, b, c), $4d82739dd229d539$var$U = d) : $4d82739dd229d539$var$Yj(a, b, c);
            break;
        default:
            $4d82739dd229d539$var$Yj(a, b, c);
    }
}
function $4d82739dd229d539$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $4d82739dd229d539$var$Kj);
        b.forEach(function(b) {
            var d = $4d82739dd229d539$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $4d82739dd229d539$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $4d82739dd229d539$var$X = h.stateNode;
                        $4d82739dd229d539$var$Xj = !1;
                        break a;
                    case 3:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Xj = !0;
                        break a;
                    case 4:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $4d82739dd229d539$var$X) throw Error($4d82739dd229d539$var$p(160));
            $4d82739dd229d539$var$Zj(f, g, e);
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $4d82739dd229d539$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$4d82739dd229d539$var$dk(b, a), b = b.sibling;
}
function $4d82739dd229d539$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4) {
                try {
                    $4d82739dd229d539$var$Pj(3, a, a.return), $4d82739dd229d539$var$Qj(3, a);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
                try {
                    $4d82739dd229d539$var$Pj(5, a, a.return);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Lj(c, c.return);
            break;
        case 5:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $4d82739dd229d539$var$ob(e, "");
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $4d82739dd229d539$var$ab(e, f);
                    $4d82739dd229d539$var$vb(h, g);
                    var l = $4d82739dd229d539$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $4d82739dd229d539$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $4d82739dd229d539$var$nb(e, q) : "children" === m ? $4d82739dd229d539$var$ob(e, q) : $4d82739dd229d539$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $4d82739dd229d539$var$bb(e, f);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $4d82739dd229d539$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $4d82739dd229d539$var$fb(e, !!f.multiple, f.defaultValue, !0) : $4d82739dd229d539$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$4d82739dd229d539$var$Pf] = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($4d82739dd229d539$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $4d82739dd229d539$var$bd(b.containerInfo);
            } catch (t) {
                $4d82739dd229d539$var$W(a, a.return, t);
            }
            break;
        case 4:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            break;
        case 13:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($4d82739dd229d539$var$fk = $4d82739dd229d539$var$B()));
            d & 4 && $4d82739dd229d539$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($4d82739dd229d539$var$U = (l = $4d82739dd229d539$var$U) || m, $4d82739dd229d539$var$ck(b, a), $4d82739dd229d539$var$U = l) : $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($4d82739dd229d539$var$V = a, m = a.child; null !== m;){
                    for(q = $4d82739dd229d539$var$V = m; null !== $4d82739dd229d539$var$V;){
                        r = $4d82739dd229d539$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $4d82739dd229d539$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $4d82739dd229d539$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $4d82739dd229d539$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $4d82739dd229d539$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $4d82739dd229d539$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $4d82739dd229d539$var$V = y) : $4d82739dd229d539$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $4d82739dd229d539$var$rb("display", g));
                            } catch (t) {
                                $4d82739dd229d539$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $4d82739dd229d539$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 4 && $4d82739dd229d539$var$ak(a);
            break;
        case 21:
            break;
        default:
            $4d82739dd229d539$var$ck(b, a), $4d82739dd229d539$var$ek(a);
    }
}
function $4d82739dd229d539$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($4d82739dd229d539$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($4d82739dd229d539$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($4d82739dd229d539$var$ob(e, ""), d.flags &= -33);
                    var f = $4d82739dd229d539$var$Uj(a);
                    $4d82739dd229d539$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $4d82739dd229d539$var$Uj(a);
                    $4d82739dd229d539$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(161));
            }
        } catch (k) {
            $4d82739dd229d539$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $4d82739dd229d539$var$hk(a, b, c) {
    $4d82739dd229d539$var$V = a;
    $4d82739dd229d539$var$ik(a, b, c);
}
function $4d82739dd229d539$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $4d82739dd229d539$var$V;){
        var e = $4d82739dd229d539$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $4d82739dd229d539$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $4d82739dd229d539$var$U;
                h = $4d82739dd229d539$var$Jj;
                var l = $4d82739dd229d539$var$U;
                $4d82739dd229d539$var$Jj = g;
                if (($4d82739dd229d539$var$U = k) && !l) for($4d82739dd229d539$var$V = e; null !== $4d82739dd229d539$var$V;)g = $4d82739dd229d539$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $4d82739dd229d539$var$jk(e) : null !== k ? (k.return = g, $4d82739dd229d539$var$V = k) : $4d82739dd229d539$var$jk(e);
                for(; null !== f;)$4d82739dd229d539$var$V = f, $4d82739dd229d539$var$ik(f, b, c), f = f.sibling;
                $4d82739dd229d539$var$V = e;
                $4d82739dd229d539$var$Jj = h;
                $4d82739dd229d539$var$U = l;
            }
            $4d82739dd229d539$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $4d82739dd229d539$var$V = f) : $4d82739dd229d539$var$kk(a, b, c);
    }
}
function $4d82739dd229d539$var$kk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $4d82739dd229d539$var$U || $4d82739dd229d539$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$4d82739dd229d539$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $4d82739dd229d539$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $4d82739dd229d539$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $4d82739dd229d539$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $4d82739dd229d539$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($4d82739dd229d539$var$p(163));
                }
                $4d82739dd229d539$var$U || b.flags & 512 && $4d82739dd229d539$var$Rj(b);
            } catch (r) {
                $4d82739dd229d539$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$gk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$jk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $4d82739dd229d539$var$Qj(4, b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $4d82739dd229d539$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $4d82739dd229d539$var$Rj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $4d82739dd229d539$var$Rj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $4d82739dd229d539$var$W(b, b.return, k);
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $4d82739dd229d539$var$V = h;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
var $4d82739dd229d539$var$lk = Math.ceil, $4d82739dd229d539$var$mk = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$nk = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$ok = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$K = 0, $4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Y = null, $4d82739dd229d539$var$Z = 0, $4d82739dd229d539$var$fj = 0, $4d82739dd229d539$var$ej = $4d82739dd229d539$var$Uf(0), $4d82739dd229d539$var$T = 0, $4d82739dd229d539$var$pk = null, $4d82739dd229d539$var$rh = 0, $4d82739dd229d539$var$qk = 0, $4d82739dd229d539$var$rk = 0, $4d82739dd229d539$var$sk = null, $4d82739dd229d539$var$tk = null, $4d82739dd229d539$var$fk = 0, $4d82739dd229d539$var$Gj = Infinity, $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Oi = !1, $4d82739dd229d539$var$Pi = null, $4d82739dd229d539$var$Ri = null, $4d82739dd229d539$var$vk = !1, $4d82739dd229d539$var$wk = null, $4d82739dd229d539$var$xk = 0, $4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = null, $4d82739dd229d539$var$Ak = -1, $4d82739dd229d539$var$Bk = 0;
function $4d82739dd229d539$var$R() {
    return 0 !== ($4d82739dd229d539$var$K & 6) ? $4d82739dd229d539$var$B() : -1 !== $4d82739dd229d539$var$Ak ? $4d82739dd229d539$var$Ak : $4d82739dd229d539$var$Ak = $4d82739dd229d539$var$B();
}
function $4d82739dd229d539$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($4d82739dd229d539$var$K & 2) && 0 !== $4d82739dd229d539$var$Z) return $4d82739dd229d539$var$Z & -$4d82739dd229d539$var$Z;
    if (null !== $4d82739dd229d539$var$Kg.transition) return 0 === $4d82739dd229d539$var$Bk && ($4d82739dd229d539$var$Bk = $4d82739dd229d539$var$yc()), $4d82739dd229d539$var$Bk;
    a = $4d82739dd229d539$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $4d82739dd229d539$var$jd(a.type);
    return a;
}
function $4d82739dd229d539$var$gi(a, b, c, d) {
    if (50 < $4d82739dd229d539$var$yk) throw $4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = null, Error($4d82739dd229d539$var$p(185));
    $4d82739dd229d539$var$Ac(a, c, d);
    if (0 === ($4d82739dd229d539$var$K & 2) || a !== $4d82739dd229d539$var$Q) a === $4d82739dd229d539$var$Q && (0 === ($4d82739dd229d539$var$K & 2) && ($4d82739dd229d539$var$qk |= c), 4 === $4d82739dd229d539$var$T && $4d82739dd229d539$var$Ck(a, $4d82739dd229d539$var$Z)), $4d82739dd229d539$var$Dk(a, d), 1 === c && 0 === $4d82739dd229d539$var$K && 0 === (b.mode & 1) && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
}
function $4d82739dd229d539$var$Dk(a, b) {
    var c = a.callbackNode;
    $4d82739dd229d539$var$wc(a, b);
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$Q ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) null !== c && $4d82739dd229d539$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $4d82739dd229d539$var$bc(c);
        if (1 === b) 0 === a.tag ? $4d82739dd229d539$var$ig($4d82739dd229d539$var$Ek.bind(null, a)) : $4d82739dd229d539$var$hg($4d82739dd229d539$var$Ek.bind(null, a)), $4d82739dd229d539$var$Jf(function() {
            0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
        }), c = null;
        else {
            switch($4d82739dd229d539$var$Dc(d)){
                case 1:
                    c = $4d82739dd229d539$var$fc;
                    break;
                case 4:
                    c = $4d82739dd229d539$var$gc;
                    break;
                case 16:
                    c = $4d82739dd229d539$var$hc;
                    break;
                case 536870912:
                    c = $4d82739dd229d539$var$jc;
                    break;
                default:
                    c = $4d82739dd229d539$var$hc;
            }
            c = $4d82739dd229d539$var$Fk(c, $4d82739dd229d539$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $4d82739dd229d539$var$Gk(a, b) {
    $4d82739dd229d539$var$Ak = -1;
    $4d82739dd229d539$var$Bk = 0;
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    var c = a.callbackNode;
    if ($4d82739dd229d539$var$Hk() && a.callbackNode !== c) return null;
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$Q ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $4d82739dd229d539$var$Ik(a, d);
    else {
        b = d;
        var e = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 2;
        var f = $4d82739dd229d539$var$Jk();
        if ($4d82739dd229d539$var$Q !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$Kk(a, b);
        for(;;)try {
            $4d82739dd229d539$var$Lk();
            break;
        } catch (h) {
            $4d82739dd229d539$var$Mk(a, h);
        }
        $4d82739dd229d539$var$$g();
        $4d82739dd229d539$var$mk.current = f;
        $4d82739dd229d539$var$K = e;
        null !== $4d82739dd229d539$var$Y ? b = 0 : ($4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Z = 0, b = $4d82739dd229d539$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $4d82739dd229d539$var$xc(a), 0 !== e && (d = e, b = $4d82739dd229d539$var$Nk(a, e)));
        if (1 === b) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, d), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
        if (6 === b) $4d82739dd229d539$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$4d82739dd229d539$var$Ok(e) && (b = $4d82739dd229d539$var$Ik(a, d), 2 === b && (f = $4d82739dd229d539$var$xc(a), 0 !== f && (d = f, b = $4d82739dd229d539$var$Nk(a, f))), 1 === b)) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, d), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($4d82739dd229d539$var$p(345));
                case 2:
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 3:
                    $4d82739dd229d539$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $4d82739dd229d539$var$fk + 500 - $4d82739dd229d539$var$B(), 10 < b)) {
                        if (0 !== $4d82739dd229d539$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $4d82739dd229d539$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Pk.bind(null, a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk), b);
                        break;
                    }
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 4:
                    $4d82739dd229d539$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $4d82739dd229d539$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $4d82739dd229d539$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $4d82739dd229d539$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Pk.bind(null, a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk), d);
                        break;
                    }
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 5:
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(329));
            }
        }
    }
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    return a.callbackNode === c ? $4d82739dd229d539$var$Gk.bind(null, a) : null;
}
function $4d82739dd229d539$var$Nk(a, b) {
    var c = $4d82739dd229d539$var$sk;
    a.current.memoizedState.isDehydrated && ($4d82739dd229d539$var$Kk(a, b).flags |= 256);
    a = $4d82739dd229d539$var$Ik(a, b);
    2 !== a && (b = $4d82739dd229d539$var$tk, $4d82739dd229d539$var$tk = c, null !== b && $4d82739dd229d539$var$Fj(b));
    return a;
}
function $4d82739dd229d539$var$Fj(a) {
    null === $4d82739dd229d539$var$tk ? $4d82739dd229d539$var$tk = a : $4d82739dd229d539$var$tk.push.apply($4d82739dd229d539$var$tk, a);
}
function $4d82739dd229d539$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$4d82739dd229d539$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $4d82739dd229d539$var$Ck(a, b) {
    b &= ~$4d82739dd229d539$var$rk;
    b &= ~$4d82739dd229d539$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $4d82739dd229d539$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $4d82739dd229d539$var$Ek(a) {
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    $4d82739dd229d539$var$Hk();
    var b = $4d82739dd229d539$var$uc(a, 0);
    if (0 === (b & 1)) return $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), null;
    var c = $4d82739dd229d539$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $4d82739dd229d539$var$xc(a);
        0 !== d && (b = d, c = $4d82739dd229d539$var$Nk(a, d));
    }
    if (1 === c) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, b), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
    if (6 === c) throw Error($4d82739dd229d539$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    return null;
}
function $4d82739dd229d539$var$Qk(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    try {
        return a(b);
    } finally{
        $4d82739dd229d539$var$K = c, 0 === $4d82739dd229d539$var$K && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
    }
}
function $4d82739dd229d539$var$Rk(a) {
    null !== $4d82739dd229d539$var$wk && 0 === $4d82739dd229d539$var$wk.tag && 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$Hk();
    var b = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    var c = $4d82739dd229d539$var$ok.transition, d = $4d82739dd229d539$var$C;
    try {
        if ($4d82739dd229d539$var$ok.transition = null, $4d82739dd229d539$var$C = 1, a) return a();
    } finally{
        $4d82739dd229d539$var$C = d, $4d82739dd229d539$var$ok.transition = c, $4d82739dd229d539$var$K = b, 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
    }
}
function $4d82739dd229d539$var$Hj() {
    $4d82739dd229d539$var$fj = $4d82739dd229d539$var$ej.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$ej);
}
function $4d82739dd229d539$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $4d82739dd229d539$var$Gf(c));
    if (null !== $4d82739dd229d539$var$Y) for(c = $4d82739dd229d539$var$Y.return; null !== c;){
        var d = c;
        $4d82739dd229d539$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $4d82739dd229d539$var$$f();
                break;
            case 3:
                $4d82739dd229d539$var$zh();
                $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
                $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
                $4d82739dd229d539$var$Eh();
                break;
            case 5:
                $4d82739dd229d539$var$Bh(d);
                break;
            case 4:
                $4d82739dd229d539$var$zh();
                break;
            case 13:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
                break;
            case 19:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
                break;
            case 10:
                $4d82739dd229d539$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $4d82739dd229d539$var$Hj();
        }
        c = c.return;
    }
    $4d82739dd229d539$var$Q = a;
    $4d82739dd229d539$var$Y = a = $4d82739dd229d539$var$Pg(a.current, null);
    $4d82739dd229d539$var$Z = $4d82739dd229d539$var$fj = b;
    $4d82739dd229d539$var$T = 0;
    $4d82739dd229d539$var$pk = null;
    $4d82739dd229d539$var$rk = $4d82739dd229d539$var$qk = $4d82739dd229d539$var$rh = 0;
    $4d82739dd229d539$var$tk = $4d82739dd229d539$var$sk = null;
    if (null !== $4d82739dd229d539$var$fh) {
        for(b = 0; b < $4d82739dd229d539$var$fh.length; b++)if (c = $4d82739dd229d539$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $4d82739dd229d539$var$fh = null;
    }
    return a;
}
function $4d82739dd229d539$var$Mk(a, b) {
    do {
        var c = $4d82739dd229d539$var$Y;
        try {
            $4d82739dd229d539$var$$g();
            $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Rh;
            if ($4d82739dd229d539$var$Ih) {
                for(var d = $4d82739dd229d539$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $4d82739dd229d539$var$Ih = !1;
            }
            $4d82739dd229d539$var$Hh = 0;
            $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = $4d82739dd229d539$var$M = null;
            $4d82739dd229d539$var$Jh = !1;
            $4d82739dd229d539$var$Kh = 0;
            $4d82739dd229d539$var$nk.current = null;
            if (null === c || null === c.return) {
                $4d82739dd229d539$var$T = 1;
                $4d82739dd229d539$var$pk = b;
                $4d82739dd229d539$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $4d82739dd229d539$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $4d82739dd229d539$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $4d82739dd229d539$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $4d82739dd229d539$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $4d82739dd229d539$var$Si(f, l, b);
                            $4d82739dd229d539$var$tj();
                            break a;
                        }
                        k = Error($4d82739dd229d539$var$p(426));
                    }
                } else if ($4d82739dd229d539$var$I && h.mode & 1) {
                    var J = $4d82739dd229d539$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $4d82739dd229d539$var$Vi(J, g, h, f, b);
                        $4d82739dd229d539$var$Jg($4d82739dd229d539$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $4d82739dd229d539$var$Ji(k, h);
                4 !== $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 2);
                null === $4d82739dd229d539$var$sk ? $4d82739dd229d539$var$sk = [
                    f
                ] : $4d82739dd229d539$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $4d82739dd229d539$var$Ni(f, k, b);
                            $4d82739dd229d539$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $4d82739dd229d539$var$Ri || !$4d82739dd229d539$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $4d82739dd229d539$var$Qi(f, h, b);
                                $4d82739dd229d539$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $4d82739dd229d539$var$Sk(c);
        } catch (na) {
            b = na;
            $4d82739dd229d539$var$Y === c && null !== c && ($4d82739dd229d539$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $4d82739dd229d539$var$Jk() {
    var a = $4d82739dd229d539$var$mk.current;
    $4d82739dd229d539$var$mk.current = $4d82739dd229d539$var$Rh;
    return null === a ? $4d82739dd229d539$var$Rh : a;
}
function $4d82739dd229d539$var$tj() {
    if (0 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T || 2 === $4d82739dd229d539$var$T) $4d82739dd229d539$var$T = 4;
    null === $4d82739dd229d539$var$Q || 0 === ($4d82739dd229d539$var$rh & 268435455) && 0 === ($4d82739dd229d539$var$qk & 268435455) || $4d82739dd229d539$var$Ck($4d82739dd229d539$var$Q, $4d82739dd229d539$var$Z);
}
function $4d82739dd229d539$var$Ik(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 2;
    var d = $4d82739dd229d539$var$Jk();
    if ($4d82739dd229d539$var$Q !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Kk(a, b);
    for(;;)try {
        $4d82739dd229d539$var$Tk();
        break;
    } catch (e) {
        $4d82739dd229d539$var$Mk(a, e);
    }
    $4d82739dd229d539$var$$g();
    $4d82739dd229d539$var$K = c;
    $4d82739dd229d539$var$mk.current = d;
    if (null !== $4d82739dd229d539$var$Y) throw Error($4d82739dd229d539$var$p(261));
    $4d82739dd229d539$var$Q = null;
    $4d82739dd229d539$var$Z = 0;
    return $4d82739dd229d539$var$T;
}
function $4d82739dd229d539$var$Tk() {
    for(; null !== $4d82739dd229d539$var$Y;)$4d82739dd229d539$var$Uk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Lk() {
    for(; null !== $4d82739dd229d539$var$Y && !$4d82739dd229d539$var$cc();)$4d82739dd229d539$var$Uk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Uk(a) {
    var b = $4d82739dd229d539$var$Vk(a.alternate, a, $4d82739dd229d539$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $4d82739dd229d539$var$Sk(a) : $4d82739dd229d539$var$Y = b;
    $4d82739dd229d539$var$nk.current = null;
}
function $4d82739dd229d539$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $4d82739dd229d539$var$Ej(c, b, $4d82739dd229d539$var$fj), null !== c) {
                $4d82739dd229d539$var$Y = c;
                return;
            }
        } else {
            c = $4d82739dd229d539$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $4d82739dd229d539$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $4d82739dd229d539$var$T = 6;
                $4d82739dd229d539$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $4d82739dd229d539$var$Y = b;
            return;
        }
        $4d82739dd229d539$var$Y = b = a;
    }while (null !== b);
    0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 5);
}
function $4d82739dd229d539$var$Pk(a, b, c) {
    var d = $4d82739dd229d539$var$C, e = $4d82739dd229d539$var$ok.transition;
    try {
        $4d82739dd229d539$var$ok.transition = null, $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$Wk(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$ok.transition = e, $4d82739dd229d539$var$C = d;
    }
    return null;
}
function $4d82739dd229d539$var$Wk(a, b, c, d) {
    do $4d82739dd229d539$var$Hk();
    while (null !== $4d82739dd229d539$var$wk);
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($4d82739dd229d539$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $4d82739dd229d539$var$Bc(a, f);
    a === $4d82739dd229d539$var$Q && ($4d82739dd229d539$var$Y = $4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $4d82739dd229d539$var$vk || ($4d82739dd229d539$var$vk = !0, $4d82739dd229d539$var$Fk($4d82739dd229d539$var$hc, function() {
        $4d82739dd229d539$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $4d82739dd229d539$var$ok.transition;
        $4d82739dd229d539$var$ok.transition = null;
        var g = $4d82739dd229d539$var$C;
        $4d82739dd229d539$var$C = 1;
        var h = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 4;
        $4d82739dd229d539$var$nk.current = null;
        $4d82739dd229d539$var$Oj(a, c);
        $4d82739dd229d539$var$dk(c, a);
        $4d82739dd229d539$var$Oe($4d82739dd229d539$var$Df);
        $4d82739dd229d539$var$dd = !!$4d82739dd229d539$var$Cf;
        $4d82739dd229d539$var$Df = $4d82739dd229d539$var$Cf = null;
        a.current = c;
        $4d82739dd229d539$var$hk(c, a, e);
        $4d82739dd229d539$var$dc();
        $4d82739dd229d539$var$K = h;
        $4d82739dd229d539$var$C = g;
        $4d82739dd229d539$var$ok.transition = f;
    } else a.current = c;
    $4d82739dd229d539$var$vk && ($4d82739dd229d539$var$vk = !1, $4d82739dd229d539$var$wk = a, $4d82739dd229d539$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($4d82739dd229d539$var$Ri = null);
    $4d82739dd229d539$var$mc(c.stateNode, d);
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($4d82739dd229d539$var$Oi) throw $4d82739dd229d539$var$Oi = !1, a = $4d82739dd229d539$var$Pi, $4d82739dd229d539$var$Pi = null, a;
    0 !== ($4d82739dd229d539$var$xk & 1) && 0 !== a.tag && $4d82739dd229d539$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $4d82739dd229d539$var$zk ? $4d82739dd229d539$var$yk++ : ($4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = a) : $4d82739dd229d539$var$yk = 0;
    $4d82739dd229d539$var$jg();
    return null;
}
function $4d82739dd229d539$var$Hk() {
    if (null !== $4d82739dd229d539$var$wk) {
        var a = $4d82739dd229d539$var$Dc($4d82739dd229d539$var$xk), b = $4d82739dd229d539$var$ok.transition, c = $4d82739dd229d539$var$C;
        try {
            $4d82739dd229d539$var$ok.transition = null;
            $4d82739dd229d539$var$C = 16 > a ? 16 : a;
            if (null === $4d82739dd229d539$var$wk) var d = !1;
            else {
                a = $4d82739dd229d539$var$wk;
                $4d82739dd229d539$var$wk = null;
                $4d82739dd229d539$var$xk = 0;
                if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(331));
                var e = $4d82739dd229d539$var$K;
                $4d82739dd229d539$var$K |= 4;
                for($4d82739dd229d539$var$V = a.current; null !== $4d82739dd229d539$var$V;){
                    var f = $4d82739dd229d539$var$V, g = f.child;
                    if (0 !== ($4d82739dd229d539$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($4d82739dd229d539$var$V = l; null !== $4d82739dd229d539$var$V;){
                                    var m = $4d82739dd229d539$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $4d82739dd229d539$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $4d82739dd229d539$var$V = q;
                                    else for(; null !== $4d82739dd229d539$var$V;){
                                        m = $4d82739dd229d539$var$V;
                                        var r = m.sibling, y = m.return;
                                        $4d82739dd229d539$var$Sj(m);
                                        if (m === l) {
                                            $4d82739dd229d539$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $4d82739dd229d539$var$V = r;
                                            break;
                                        }
                                        $4d82739dd229d539$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $4d82739dd229d539$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $4d82739dd229d539$var$V = g;
                    else b: for(; null !== $4d82739dd229d539$var$V;){
                        f = $4d82739dd229d539$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $4d82739dd229d539$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $4d82739dd229d539$var$V = x;
                            break b;
                        }
                        $4d82739dd229d539$var$V = f.return;
                    }
                }
                var w = a.current;
                for($4d82739dd229d539$var$V = w; null !== $4d82739dd229d539$var$V;){
                    g = $4d82739dd229d539$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $4d82739dd229d539$var$V = u;
                    else b: for(g = w; null !== $4d82739dd229d539$var$V;){
                        h = $4d82739dd229d539$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $4d82739dd229d539$var$Qj(9, h);
                            }
                        } catch (na) {
                            $4d82739dd229d539$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $4d82739dd229d539$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $4d82739dd229d539$var$V = F;
                            break b;
                        }
                        $4d82739dd229d539$var$V = h.return;
                    }
                }
                $4d82739dd229d539$var$K = e;
                $4d82739dd229d539$var$jg();
                if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onPostCommitFiberRoot) try {
                    $4d82739dd229d539$var$lc.onPostCommitFiberRoot($4d82739dd229d539$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$ok.transition = b;
        }
    }
    return !1;
}
function $4d82739dd229d539$var$Xk(a, b, c) {
    b = $4d82739dd229d539$var$Ji(c, b);
    b = $4d82739dd229d539$var$Ni(a, b, 1);
    a = $4d82739dd229d539$var$nh(a, b, 1);
    b = $4d82739dd229d539$var$R();
    null !== a && ($4d82739dd229d539$var$Ac(a, 1, b), $4d82739dd229d539$var$Dk(a, b));
}
function $4d82739dd229d539$var$W(a, b, c) {
    if (3 === a.tag) $4d82739dd229d539$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $4d82739dd229d539$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $4d82739dd229d539$var$Ri || !$4d82739dd229d539$var$Ri.has(d))) {
                a = $4d82739dd229d539$var$Ji(c, a);
                a = $4d82739dd229d539$var$Qi(b, a, 1);
                b = $4d82739dd229d539$var$nh(b, a, 1);
                a = $4d82739dd229d539$var$R();
                null !== b && ($4d82739dd229d539$var$Ac(b, 1, a), $4d82739dd229d539$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $4d82739dd229d539$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $4d82739dd229d539$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $4d82739dd229d539$var$Q === a && ($4d82739dd229d539$var$Z & c) === c && (4 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$Z & 130023424) === $4d82739dd229d539$var$Z && 500 > $4d82739dd229d539$var$B() - $4d82739dd229d539$var$fk ? $4d82739dd229d539$var$Kk(a, 0) : $4d82739dd229d539$var$rk |= c);
    $4d82739dd229d539$var$Dk(a, b);
}
function $4d82739dd229d539$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $4d82739dd229d539$var$sc, $4d82739dd229d539$var$sc <<= 1, 0 === ($4d82739dd229d539$var$sc & 130023424) && ($4d82739dd229d539$var$sc = 4194304)));
    var c = $4d82739dd229d539$var$R();
    a = $4d82739dd229d539$var$ih(a, b);
    null !== a && ($4d82739dd229d539$var$Ac(a, b, c), $4d82739dd229d539$var$Dk(a, c));
}
function $4d82739dd229d539$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $4d82739dd229d539$var$Yk(a, c);
}
function $4d82739dd229d539$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($4d82739dd229d539$var$p(314));
    }
    null !== d && d.delete(b);
    $4d82739dd229d539$var$Yk(a, c);
}
var $4d82739dd229d539$var$Vk;
$4d82739dd229d539$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $4d82739dd229d539$var$Wf.current) $4d82739dd229d539$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $4d82739dd229d539$var$dh = !1, $4d82739dd229d539$var$yj(a, b, c);
            $4d82739dd229d539$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $4d82739dd229d539$var$dh = !1, $4d82739dd229d539$var$I && 0 !== (b.flags & 1048576) && $4d82739dd229d539$var$ug(b, $4d82739dd229d539$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $4d82739dd229d539$var$ij(a, b);
            a = b.pendingProps;
            var e = $4d82739dd229d539$var$Yf(b, $4d82739dd229d539$var$H.current);
            $4d82739dd229d539$var$ch(b, c);
            e = $4d82739dd229d539$var$Nh(null, b, d, a, e, c);
            var f = $4d82739dd229d539$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $4d82739dd229d539$var$Zf(d) ? (f = !0, $4d82739dd229d539$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $4d82739dd229d539$var$kh(b), e.updater = $4d82739dd229d539$var$Ei, b.stateNode = e, e._reactInternals = b, $4d82739dd229d539$var$Ii(b, d, a, c), b = $4d82739dd229d539$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $4d82739dd229d539$var$I && f && $4d82739dd229d539$var$vg(b), $4d82739dd229d539$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $4d82739dd229d539$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $4d82739dd229d539$var$Zk(d);
                a = $4d82739dd229d539$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $4d82739dd229d539$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $4d82739dd229d539$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $4d82739dd229d539$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $4d82739dd229d539$var$$i(null, b, d, $4d82739dd229d539$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($4d82739dd229d539$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $4d82739dd229d539$var$kj(b);
                if (null === a) throw Error($4d82739dd229d539$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $4d82739dd229d539$var$lh(a, b);
                $4d82739dd229d539$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $4d82739dd229d539$var$Ji(Error($4d82739dd229d539$var$p(423)), b);
                        b = $4d82739dd229d539$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $4d82739dd229d539$var$Ji(Error($4d82739dd229d539$var$p(424)), b);
                        b = $4d82739dd229d539$var$lj(a, b, d, c, e);
                        break a;
                    } else for($4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.stateNode.containerInfo.firstChild), $4d82739dd229d539$var$xg = b, $4d82739dd229d539$var$I = !0, $4d82739dd229d539$var$zg = null, c = $4d82739dd229d539$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $4d82739dd229d539$var$Ig();
                    if (d === e) {
                        b = $4d82739dd229d539$var$Zi(a, b, c);
                        break a;
                    }
                    $4d82739dd229d539$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $4d82739dd229d539$var$Ah(b), null === a && $4d82739dd229d539$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $4d82739dd229d539$var$Ef(d, e) ? g = null : null !== f && $4d82739dd229d539$var$Ef(d, f) && (b.flags |= 32), $4d82739dd229d539$var$gj(a, b), $4d82739dd229d539$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $4d82739dd229d539$var$Eg(b), null;
        case 13:
            return $4d82739dd229d539$var$oj(a, b, c);
        case 4:
            return $4d82739dd229d539$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $4d82739dd229d539$var$Ug(b, null, d, c) : $4d82739dd229d539$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$Yi(a, b, d, e, c);
        case 7:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $4d82739dd229d539$var$G($4d82739dd229d539$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($4d82739dd229d539$var$He(f.value, g)) {
                        if (f.children === e.children && !$4d82739dd229d539$var$Wf.current) {
                            b = $4d82739dd229d539$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $4d82739dd229d539$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $4d82739dd229d539$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($4d82739dd229d539$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $4d82739dd229d539$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $4d82739dd229d539$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $4d82739dd229d539$var$ch(b, c), e = $4d82739dd229d539$var$eh(e), d = d(e), b.flags |= 1, $4d82739dd229d539$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $4d82739dd229d539$var$Ci(d, b.pendingProps), e = $4d82739dd229d539$var$Ci(d.type, e), $4d82739dd229d539$var$$i(a, b, d, e, c);
        case 15:
            return $4d82739dd229d539$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$ij(a, b), b.tag = 1, $4d82739dd229d539$var$Zf(d) ? (a = !0, $4d82739dd229d539$var$cg(b)) : a = !1, $4d82739dd229d539$var$ch(b, c), $4d82739dd229d539$var$Gi(b, d, e), $4d82739dd229d539$var$Ii(b, d, e, c), $4d82739dd229d539$var$jj(null, b, d, !0, a, c);
        case 19:
            return $4d82739dd229d539$var$xj(a, b, c);
        case 22:
            return $4d82739dd229d539$var$dj(a, b, c);
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
};
function $4d82739dd229d539$var$Fk(a, b) {
    return $4d82739dd229d539$var$ac(a, b);
}
function $4d82739dd229d539$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $4d82739dd229d539$var$Bg(a, b, c, d) {
    return new $4d82739dd229d539$var$$k(a, b, c, d);
}
function $4d82739dd229d539$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $4d82739dd229d539$var$Zk(a) {
    if ("function" === typeof a) return $4d82739dd229d539$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $4d82739dd229d539$var$Da) return 11;
        if (a === $4d82739dd229d539$var$Ga) return 14;
    }
    return 2;
}
function $4d82739dd229d539$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $4d82739dd229d539$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $4d82739dd229d539$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $4d82739dd229d539$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $4d82739dd229d539$var$ya:
            return $4d82739dd229d539$var$Tg(c.children, e, f, b);
        case $4d82739dd229d539$var$za:
            g = 8;
            e |= 8;
            break;
        case $4d82739dd229d539$var$Aa:
            return a = $4d82739dd229d539$var$Bg(12, c, b, e | 2), a.elementType = $4d82739dd229d539$var$Aa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ea:
            return a = $4d82739dd229d539$var$Bg(13, c, b, e), a.elementType = $4d82739dd229d539$var$Ea, a.lanes = f, a;
        case $4d82739dd229d539$var$Fa:
            return a = $4d82739dd229d539$var$Bg(19, c, b, e), a.elementType = $4d82739dd229d539$var$Fa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ia:
            return $4d82739dd229d539$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $4d82739dd229d539$var$Ba:
                    g = 10;
                    break a;
                case $4d82739dd229d539$var$Ca:
                    g = 9;
                    break a;
                case $4d82739dd229d539$var$Da:
                    g = 11;
                    break a;
                case $4d82739dd229d539$var$Ga:
                    g = 14;
                    break a;
                case $4d82739dd229d539$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($4d82739dd229d539$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $4d82739dd229d539$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $4d82739dd229d539$var$Tg(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$pj(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(22, a, d, b);
    a.elementType = $4d82739dd229d539$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $4d82739dd229d539$var$Qg(a, b, c) {
    a = $4d82739dd229d539$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$Sg(a, b, c) {
    b = $4d82739dd229d539$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $4d82739dd229d539$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $4d82739dd229d539$var$zc(0);
    this.expirationTimes = $4d82739dd229d539$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $4d82739dd229d539$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $4d82739dd229d539$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $4d82739dd229d539$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $4d82739dd229d539$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $4d82739dd229d539$var$kh(f);
    return a;
}
function $4d82739dd229d539$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4d82739dd229d539$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $4d82739dd229d539$var$dl(a) {
    if (!a) return $4d82739dd229d539$var$Vf;
    a = a._reactInternals;
    a: {
        if ($4d82739dd229d539$var$Vb(a) !== a || 1 !== a.tag) throw Error($4d82739dd229d539$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($4d82739dd229d539$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($4d82739dd229d539$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($4d82739dd229d539$var$Zf(c)) return $4d82739dd229d539$var$bg(a, c, b);
    }
    return b;
}
function $4d82739dd229d539$var$el(a, b, c, d, e, f, g, h, k) {
    a = $4d82739dd229d539$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $4d82739dd229d539$var$dl(null);
    c = a.current;
    d = $4d82739dd229d539$var$R();
    e = $4d82739dd229d539$var$yi(c);
    f = $4d82739dd229d539$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $4d82739dd229d539$var$nh(c, f, e);
    a.current.lanes = e;
    $4d82739dd229d539$var$Ac(a, e, d);
    $4d82739dd229d539$var$Dk(a, d);
    return a;
}
function $4d82739dd229d539$var$fl(a, b, c, d) {
    var e = b.current, f = $4d82739dd229d539$var$R(), g = $4d82739dd229d539$var$yi(e);
    c = $4d82739dd229d539$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $4d82739dd229d539$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $4d82739dd229d539$var$nh(e, b, g);
    null !== a && ($4d82739dd229d539$var$gi(a, e, g, f), $4d82739dd229d539$var$oh(a, e, g));
    return g;
}
function $4d82739dd229d539$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $4d82739dd229d539$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $4d82739dd229d539$var$il(a, b) {
    $4d82739dd229d539$var$hl(a, b);
    (a = a.alternate) && $4d82739dd229d539$var$hl(a, b);
}
function $4d82739dd229d539$var$jl() {
    return null;
}
var $4d82739dd229d539$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $4d82739dd229d539$var$ll(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$ml.prototype.render = $4d82739dd229d539$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($4d82739dd229d539$var$p(409));
    $4d82739dd229d539$var$fl(a, b, null, null);
};
$4d82739dd229d539$var$ml.prototype.unmount = $4d82739dd229d539$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $4d82739dd229d539$var$Rk(function() {
            $4d82739dd229d539$var$fl(null, a, null, null);
        });
        b[$4d82739dd229d539$var$uf] = null;
    }
};
function $4d82739dd229d539$var$ml(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $4d82739dd229d539$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $4d82739dd229d539$var$Qc.length && 0 !== b && b < $4d82739dd229d539$var$Qc[c].priority; c++);
        $4d82739dd229d539$var$Qc.splice(c, 0, a);
        0 === c && $4d82739dd229d539$var$Vc(a);
    }
};
function $4d82739dd229d539$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $4d82739dd229d539$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $4d82739dd229d539$var$pl() {}
function $4d82739dd229d539$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $4d82739dd229d539$var$gl(g);
                f.call(a);
            };
        }
        var g = $4d82739dd229d539$var$el(b, d, a, 0, null, !1, !1, "", $4d82739dd229d539$var$pl);
        a._reactRootContainer = g;
        a[$4d82739dd229d539$var$uf] = g.current;
        $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
        $4d82739dd229d539$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $4d82739dd229d539$var$gl(k);
            h.call(a);
        };
    }
    var k = $4d82739dd229d539$var$bl(a, 0, !1, null, null, !1, !1, "", $4d82739dd229d539$var$pl);
    a._reactRootContainer = k;
    a[$4d82739dd229d539$var$uf] = k.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    $4d82739dd229d539$var$Rk(function() {
        $4d82739dd229d539$var$fl(b, k, c, d);
    });
    return k;
}
function $4d82739dd229d539$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $4d82739dd229d539$var$gl(g);
                h.call(a);
            };
        }
        $4d82739dd229d539$var$fl(b, g, a, e);
    } else g = $4d82739dd229d539$var$ql(c, b, a, e, d);
    return $4d82739dd229d539$var$gl(g);
}
$4d82739dd229d539$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $4d82739dd229d539$var$tc(b.pendingLanes);
                0 !== c && ($4d82739dd229d539$var$Cc(b, c | 1), $4d82739dd229d539$var$Dk(b, $4d82739dd229d539$var$B()), 0 === ($4d82739dd229d539$var$K & 6) && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$jg()));
            }
            break;
        case 13:
            $4d82739dd229d539$var$Rk(function() {
                var b = $4d82739dd229d539$var$ih(a, 1);
                if (null !== b) {
                    var c = $4d82739dd229d539$var$R();
                    $4d82739dd229d539$var$gi(b, a, 1, c);
                }
            }), $4d82739dd229d539$var$il(a, 1);
    }
};
$4d82739dd229d539$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$ih(a, 134217728);
        if (null !== b) {
            var c = $4d82739dd229d539$var$R();
            $4d82739dd229d539$var$gi(b, a, 134217728, c);
        }
        $4d82739dd229d539$var$il(a, 134217728);
    }
};
$4d82739dd229d539$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$yi(a), c = $4d82739dd229d539$var$ih(a, b);
        if (null !== c) {
            var d = $4d82739dd229d539$var$R();
            $4d82739dd229d539$var$gi(c, a, b, d);
        }
        $4d82739dd229d539$var$il(a, b);
    }
};
$4d82739dd229d539$var$Hc = function() {
    return $4d82739dd229d539$var$C;
};
$4d82739dd229d539$var$Ic = function(a, b) {
    var c = $4d82739dd229d539$var$C;
    try {
        return $4d82739dd229d539$var$C = a, b();
    } finally{
        $4d82739dd229d539$var$C = c;
    }
};
$4d82739dd229d539$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $4d82739dd229d539$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $4d82739dd229d539$var$Db(d);
                        if (!e) throw Error($4d82739dd229d539$var$p(90));
                        $4d82739dd229d539$var$Wa(d);
                        $4d82739dd229d539$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $4d82739dd229d539$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $4d82739dd229d539$var$fb(a, !!c.multiple, b, !1);
    }
};
$4d82739dd229d539$var$Gb = $4d82739dd229d539$var$Qk;
$4d82739dd229d539$var$Hb = $4d82739dd229d539$var$Rk;
var $4d82739dd229d539$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $4d82739dd229d539$var$Cb,
        $4d82739dd229d539$var$ue,
        $4d82739dd229d539$var$Db,
        $4d82739dd229d539$var$Eb,
        $4d82739dd229d539$var$Fb,
        $4d82739dd229d539$var$Qk
    ]
}, $4d82739dd229d539$var$tl = {
    findFiberByHostInstance: $4d82739dd229d539$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $4d82739dd229d539$var$ul = {
    bundleType: $4d82739dd229d539$var$tl.bundleType,
    version: $4d82739dd229d539$var$tl.version,
    rendererPackageName: $4d82739dd229d539$var$tl.rendererPackageName,
    rendererConfig: $4d82739dd229d539$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $4d82739dd229d539$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $4d82739dd229d539$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $4d82739dd229d539$var$tl.findFiberByHostInstance || $4d82739dd229d539$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $4d82739dd229d539$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$4d82739dd229d539$var$vl.isDisabled && $4d82739dd229d539$var$vl.supportsFiber) try {
        $4d82739dd229d539$var$kc = $4d82739dd229d539$var$vl.inject($4d82739dd229d539$var$ul), $4d82739dd229d539$var$lc = $4d82739dd229d539$var$vl;
    } catch (a) {}
}
$4d82739dd229d539$export$ae55be85d98224ed = $4d82739dd229d539$var$sl;
$4d82739dd229d539$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$4d82739dd229d539$var$nl(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$cl(a, b, null, c);
};
$4d82739dd229d539$export$882461b6382ed46c = function(a, b) {
    if (!$4d82739dd229d539$var$nl(a)) throw Error($4d82739dd229d539$var$p(299));
    var c = !1, d = "", e = $4d82739dd229d539$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $4d82739dd229d539$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $4d82739dd229d539$var$ll(b);
};
$4d82739dd229d539$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($4d82739dd229d539$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($4d82739dd229d539$var$p(268, a));
    }
    a = $4d82739dd229d539$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$4d82739dd229d539$export$cd75ccfd720a3cd4 = function(a) {
    return $4d82739dd229d539$var$Rk(a);
};
$4d82739dd229d539$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$4d82739dd229d539$var$ol(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$rl(null, a, b, !0, c);
};
$4d82739dd229d539$export$757ceba2d55c277e = function(a, b, c) {
    if (!$4d82739dd229d539$var$nl(a)) throw Error($4d82739dd229d539$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $4d82739dd229d539$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $4d82739dd229d539$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $4d82739dd229d539$var$ml(b);
};
$4d82739dd229d539$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$4d82739dd229d539$var$ol(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$rl(null, a, b, !1, c);
};
$4d82739dd229d539$export$502457920280e6be = function(a) {
    if (!$4d82739dd229d539$var$ol(a)) throw Error($4d82739dd229d539$var$p(40));
    return a._reactRootContainer ? ($4d82739dd229d539$var$Rk(function() {
        $4d82739dd229d539$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$4d82739dd229d539$var$uf] = null;
        });
    }), !0) : !1;
};
$4d82739dd229d539$export$c78a37762a8d58e1 = $4d82739dd229d539$var$Qk;
$4d82739dd229d539$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$4d82739dd229d539$var$ol(c)) throw Error($4d82739dd229d539$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($4d82739dd229d539$var$p(38));
    return $4d82739dd229d539$var$rl(a, b, c, !1, d);
};
$4d82739dd229d539$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("33s19", function(module, exports) {
'use strict';

module.exports = (parcelRequire("a0C75"));

});
parcelRegister("a0C75", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $749777fefd570b40$export$c4744153514ff05d; }, function (v) { return $749777fefd570b40$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $749777fefd570b40$export$3e506c1ccc9cc1a7; }, function (v) { return $749777fefd570b40$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $749777fefd570b40$export$e26fe2ed2fa76875; }, function (v) { return $749777fefd570b40$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $749777fefd570b40$export$502329bbf4b505b1; }, function (v) { return $749777fefd570b40$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $749777fefd570b40$export$6e3807111c4874c4; }, function (v) { return $749777fefd570b40$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $749777fefd570b40$export$c27134553091fb3a; }, function (v) { return $749777fefd570b40$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $749777fefd570b40$export$33ee1acdc04fd2a2; }, function (v) { return $749777fefd570b40$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $749777fefd570b40$export$b00a404bbd5edef2; }, function (v) { return $749777fefd570b40$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $749777fefd570b40$export$8352ce38b91d0c62; }, function (v) { return $749777fefd570b40$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $749777fefd570b40$export$d66a1c1c77bd778b; }, function (v) { return $749777fefd570b40$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $749777fefd570b40$export$d3dfb8e4810cb555; }, function (v) { return $749777fefd570b40$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $749777fefd570b40$export$839f9183b0465a69; }, function (v) { return $749777fefd570b40$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $749777fefd570b40$export$72fdf0e06517287b; }, function (v) { return $749777fefd570b40$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $749777fefd570b40$export$4b844e58a3e414b4; }, function (v) { return $749777fefd570b40$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $749777fefd570b40$export$816d2913ae6b83b1; }, function (v) { return $749777fefd570b40$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $749777fefd570b40$export$61bcfe829111a1d0; }, function (v) { return $749777fefd570b40$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $749777fefd570b40$export$7ee8c9beb337bc3f; }, function (v) { return $749777fefd570b40$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $749777fefd570b40$export$b5836b71941fa3ed; }, function (v) { return $749777fefd570b40$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $749777fefd570b40$export$cf845f2c119da08a; }, function (v) { return $749777fefd570b40$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $749777fefd570b40$export$c4744153514ff05d;
var $749777fefd570b40$export$3e506c1ccc9cc1a7;
var $749777fefd570b40$export$e26fe2ed2fa76875;
var $749777fefd570b40$export$502329bbf4b505b1;
var $749777fefd570b40$export$6e3807111c4874c4;
var $749777fefd570b40$export$c27134553091fb3a;
var $749777fefd570b40$export$33ee1acdc04fd2a2;
var $749777fefd570b40$export$b00a404bbd5edef2;
var $749777fefd570b40$export$8352ce38b91d0c62;
var $749777fefd570b40$export$d66a1c1c77bd778b;
var $749777fefd570b40$export$d3dfb8e4810cb555;
var $749777fefd570b40$export$839f9183b0465a69;
var $749777fefd570b40$export$72fdf0e06517287b;
var $749777fefd570b40$export$4b844e58a3e414b4;
var $749777fefd570b40$export$816d2913ae6b83b1;
var $749777fefd570b40$export$61bcfe829111a1d0;
var $749777fefd570b40$export$7ee8c9beb337bc3f;
var $749777fefd570b40$export$b5836b71941fa3ed;
var $749777fefd570b40$export$cf845f2c119da08a;
'use strict';
function $749777fefd570b40$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $749777fefd570b40$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $749777fefd570b40$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $749777fefd570b40$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $749777fefd570b40$var$g(C, c)) n < e && 0 > $749777fefd570b40$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $749777fefd570b40$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $749777fefd570b40$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $749777fefd570b40$var$l = performance;
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$l.now();
    };
} else {
    var $749777fefd570b40$var$p = Date, $749777fefd570b40$var$q = $749777fefd570b40$var$p.now();
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$p.now() - $749777fefd570b40$var$q;
    };
}
var $749777fefd570b40$var$r = [], $749777fefd570b40$var$t = [], $749777fefd570b40$var$u = 1, $749777fefd570b40$var$v = null, $749777fefd570b40$var$y = 3, $749777fefd570b40$var$z = !1, $749777fefd570b40$var$A = !1, $749777fefd570b40$var$B = !1, $749777fefd570b40$var$D = "function" === typeof setTimeout ? setTimeout : null, $749777fefd570b40$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $749777fefd570b40$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $749777fefd570b40$var$G(a) {
    for(var b = $749777fefd570b40$var$h($749777fefd570b40$var$t); null !== b;){
        if (null === b.callback) $749777fefd570b40$var$k($749777fefd570b40$var$t);
        else if (b.startTime <= a) $749777fefd570b40$var$k($749777fefd570b40$var$t), b.sortIndex = b.expirationTime, $749777fefd570b40$var$f($749777fefd570b40$var$r, b);
        else break;
        b = $749777fefd570b40$var$h($749777fefd570b40$var$t);
    }
}
function $749777fefd570b40$var$H(a) {
    $749777fefd570b40$var$B = !1;
    $749777fefd570b40$var$G(a);
    if (!$749777fefd570b40$var$A) {
        if (null !== $749777fefd570b40$var$h($749777fefd570b40$var$r)) $749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J);
        else {
            var b = $749777fefd570b40$var$h($749777fefd570b40$var$t);
            null !== b && $749777fefd570b40$var$K($749777fefd570b40$var$H, b.startTime - a);
        }
    }
}
function $749777fefd570b40$var$J(a, b) {
    $749777fefd570b40$var$A = !1;
    $749777fefd570b40$var$B && ($749777fefd570b40$var$B = !1, $749777fefd570b40$var$E($749777fefd570b40$var$L), $749777fefd570b40$var$L = -1);
    $749777fefd570b40$var$z = !0;
    var c = $749777fefd570b40$var$y;
    try {
        $749777fefd570b40$var$G(b);
        for($749777fefd570b40$var$v = $749777fefd570b40$var$h($749777fefd570b40$var$r); null !== $749777fefd570b40$var$v && (!($749777fefd570b40$var$v.expirationTime > b) || a && !$749777fefd570b40$var$M());){
            var d = $749777fefd570b40$var$v.callback;
            if ("function" === typeof d) {
                $749777fefd570b40$var$v.callback = null;
                $749777fefd570b40$var$y = $749777fefd570b40$var$v.priorityLevel;
                var e = d($749777fefd570b40$var$v.expirationTime <= b);
                b = $749777fefd570b40$export$c4744153514ff05d();
                "function" === typeof e ? $749777fefd570b40$var$v.callback = e : $749777fefd570b40$var$v === $749777fefd570b40$var$h($749777fefd570b40$var$r) && $749777fefd570b40$var$k($749777fefd570b40$var$r);
                $749777fefd570b40$var$G(b);
            } else $749777fefd570b40$var$k($749777fefd570b40$var$r);
            $749777fefd570b40$var$v = $749777fefd570b40$var$h($749777fefd570b40$var$r);
        }
        if (null !== $749777fefd570b40$var$v) var w = !0;
        else {
            var m = $749777fefd570b40$var$h($749777fefd570b40$var$t);
            null !== m && $749777fefd570b40$var$K($749777fefd570b40$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $749777fefd570b40$var$v = null, $749777fefd570b40$var$y = c, $749777fefd570b40$var$z = !1;
    }
}
var $749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = null, $749777fefd570b40$var$L = -1, $749777fefd570b40$var$P = 5, $749777fefd570b40$var$Q = -1;
function $749777fefd570b40$var$M() {
    return $749777fefd570b40$export$c4744153514ff05d() - $749777fefd570b40$var$Q < $749777fefd570b40$var$P ? !1 : !0;
}
function $749777fefd570b40$var$R() {
    if (null !== $749777fefd570b40$var$O) {
        var a = $749777fefd570b40$export$c4744153514ff05d();
        $749777fefd570b40$var$Q = a;
        var b = !0;
        try {
            b = $749777fefd570b40$var$O(!0, a);
        } finally{
            b ? $749777fefd570b40$var$S() : ($749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = null);
        }
    } else $749777fefd570b40$var$N = !1;
}
var $749777fefd570b40$var$S;
if ("function" === typeof $749777fefd570b40$var$F) $749777fefd570b40$var$S = function() {
    $749777fefd570b40$var$F($749777fefd570b40$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $749777fefd570b40$var$T = new MessageChannel, $749777fefd570b40$var$U = $749777fefd570b40$var$T.port2;
    $749777fefd570b40$var$T.port1.onmessage = $749777fefd570b40$var$R;
    $749777fefd570b40$var$S = function() {
        $749777fefd570b40$var$U.postMessage(null);
    };
} else $749777fefd570b40$var$S = function() {
    $749777fefd570b40$var$D($749777fefd570b40$var$R, 0);
};
function $749777fefd570b40$var$I(a) {
    $749777fefd570b40$var$O = a;
    $749777fefd570b40$var$N || ($749777fefd570b40$var$N = !0, $749777fefd570b40$var$S());
}
function $749777fefd570b40$var$K(a, b) {
    $749777fefd570b40$var$L = $749777fefd570b40$var$D(function() {
        a($749777fefd570b40$export$c4744153514ff05d());
    }, b);
}
$749777fefd570b40$export$3e506c1ccc9cc1a7 = 5;
$749777fefd570b40$export$e26fe2ed2fa76875 = 1;
$749777fefd570b40$export$502329bbf4b505b1 = 4;
$749777fefd570b40$export$6e3807111c4874c4 = 3;
$749777fefd570b40$export$c27134553091fb3a = null;
$749777fefd570b40$export$33ee1acdc04fd2a2 = 2;
$749777fefd570b40$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$749777fefd570b40$export$8352ce38b91d0c62 = function() {
    $749777fefd570b40$var$A || $749777fefd570b40$var$z || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J));
};
$749777fefd570b40$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $749777fefd570b40$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$749777fefd570b40$export$d3dfb8e4810cb555 = function() {
    return $749777fefd570b40$var$y;
};
$749777fefd570b40$export$839f9183b0465a69 = function() {
    return $749777fefd570b40$var$h($749777fefd570b40$var$r);
};
$749777fefd570b40$export$72fdf0e06517287b = function(a) {
    switch($749777fefd570b40$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $749777fefd570b40$var$y;
    }
    var c = $749777fefd570b40$var$y;
    $749777fefd570b40$var$y = b;
    try {
        return a();
    } finally{
        $749777fefd570b40$var$y = c;
    }
};
$749777fefd570b40$export$4b844e58a3e414b4 = function() {};
$749777fefd570b40$export$816d2913ae6b83b1 = function() {};
$749777fefd570b40$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $749777fefd570b40$var$y;
    $749777fefd570b40$var$y = a;
    try {
        return b();
    } finally{
        $749777fefd570b40$var$y = c;
    }
};
$749777fefd570b40$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $749777fefd570b40$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $749777fefd570b40$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $749777fefd570b40$var$f($749777fefd570b40$var$t, a), null === $749777fefd570b40$var$h($749777fefd570b40$var$r) && a === $749777fefd570b40$var$h($749777fefd570b40$var$t) && ($749777fefd570b40$var$B ? ($749777fefd570b40$var$E($749777fefd570b40$var$L), $749777fefd570b40$var$L = -1) : $749777fefd570b40$var$B = !0, $749777fefd570b40$var$K($749777fefd570b40$var$H, c - d))) : (a.sortIndex = e, $749777fefd570b40$var$f($749777fefd570b40$var$r, a), $749777fefd570b40$var$A || $749777fefd570b40$var$z || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J)));
    return a;
};
$749777fefd570b40$export$b5836b71941fa3ed = $749777fefd570b40$var$M;
$749777fefd570b40$export$cf845f2c119da08a = function(a) {
    var b = $749777fefd570b40$var$y;
    return function() {
        var c = $749777fefd570b40$var$y;
        $749777fefd570b40$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $749777fefd570b40$var$y = c;
        }
    };
};

});



parcelRegister("bdjQ6", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $82a04c4ec6982288$export$a143d493d941bafc; }, function (v) { return $82a04c4ec6982288$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $82a04c4ec6982288$export$e4cf37d7f6fb9e0a; }, function (v) { return $82a04c4ec6982288$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $82a04c4ec6982288$export$f99ded8fe4b79145; }, function (v) { return $82a04c4ec6982288$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $82a04c4ec6982288$export$599f31c3813fae4d; }, function (v) { return $82a04c4ec6982288$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $82a04c4ec6982288$export$a143d493d941bafc;
var $82a04c4ec6982288$export$e4cf37d7f6fb9e0a;
var $82a04c4ec6982288$export$f99ded8fe4b79145;
var $82a04c4ec6982288$export$599f31c3813fae4d;
'use strict';

var $3nocJ = parcelRequire("3nocJ");

var $gU9iR = parcelRequire("gU9iR");
const $82a04c4ec6982288$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$82a04c4ec6982288$export$a143d493d941bafc = $82a04c4ec6982288$var$Buffer;
$82a04c4ec6982288$export$e4cf37d7f6fb9e0a = $82a04c4ec6982288$var$SlowBuffer;
$82a04c4ec6982288$export$f99ded8fe4b79145 = 50;
const $82a04c4ec6982288$var$K_MAX_LENGTH = 0x7fffffff;
$82a04c4ec6982288$export$599f31c3813fae4d = $82a04c4ec6982288$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $82a04c4ec6982288$var$Buffer.TYPED_ARRAY_SUPPORT = $82a04c4ec6982288$var$typedArraySupport();
if (!$82a04c4ec6982288$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $82a04c4ec6982288$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($82a04c4ec6982288$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$82a04c4ec6982288$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($82a04c4ec6982288$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$82a04c4ec6982288$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $82a04c4ec6982288$var$createBuffer(length) {
    if (length > $82a04c4ec6982288$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $82a04c4ec6982288$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $82a04c4ec6982288$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $82a04c4ec6982288$var$allocUnsafe(arg);
    }
    return $82a04c4ec6982288$var$from(arg, encodingOrOffset, length);
}
$82a04c4ec6982288$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $82a04c4ec6982288$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $82a04c4ec6982288$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $82a04c4ec6982288$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($82a04c4ec6982288$var$isInstance(value, ArrayBuffer) || value && $82a04c4ec6982288$var$isInstance(value.buffer, ArrayBuffer)) return $82a04c4ec6982288$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($82a04c4ec6982288$var$isInstance(value, SharedArrayBuffer) || value && $82a04c4ec6982288$var$isInstance(value.buffer, SharedArrayBuffer))) return $82a04c4ec6982288$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $82a04c4ec6982288$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $82a04c4ec6982288$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $82a04c4ec6982288$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $82a04c4ec6982288$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $82a04c4ec6982288$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($82a04c4ec6982288$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($82a04c4ec6982288$var$Buffer, Uint8Array);
function $82a04c4ec6982288$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $82a04c4ec6982288$var$alloc(size, fill, encoding) {
    $82a04c4ec6982288$var$assertSize(size);
    if (size <= 0) return $82a04c4ec6982288$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $82a04c4ec6982288$var$createBuffer(size).fill(fill, encoding) : $82a04c4ec6982288$var$createBuffer(size).fill(fill);
    return $82a04c4ec6982288$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $82a04c4ec6982288$var$Buffer.alloc = function(size, fill, encoding) {
    return $82a04c4ec6982288$var$alloc(size, fill, encoding);
};
function $82a04c4ec6982288$var$allocUnsafe(size) {
    $82a04c4ec6982288$var$assertSize(size);
    return $82a04c4ec6982288$var$createBuffer(size < 0 ? 0 : $82a04c4ec6982288$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $82a04c4ec6982288$var$Buffer.allocUnsafe = function(size) {
    return $82a04c4ec6982288$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $82a04c4ec6982288$var$Buffer.allocUnsafeSlow = function(size) {
    return $82a04c4ec6982288$var$allocUnsafe(size);
};
function $82a04c4ec6982288$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$82a04c4ec6982288$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $82a04c4ec6982288$var$byteLength(string, encoding) | 0;
    let buf = $82a04c4ec6982288$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $82a04c4ec6982288$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $82a04c4ec6982288$var$checked(array.length) | 0;
    const buf = $82a04c4ec6982288$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $82a04c4ec6982288$var$fromArrayView(arrayView) {
    if ($82a04c4ec6982288$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $82a04c4ec6982288$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $82a04c4ec6982288$var$fromArrayLike(arrayView);
}
function $82a04c4ec6982288$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $82a04c4ec6982288$var$Buffer.prototype);
    return buf;
}
function $82a04c4ec6982288$var$fromObject(obj) {
    if ($82a04c4ec6982288$var$Buffer.isBuffer(obj)) {
        const len = $82a04c4ec6982288$var$checked(obj.length) | 0;
        const buf = $82a04c4ec6982288$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $82a04c4ec6982288$var$numberIsNaN(obj.length)) return $82a04c4ec6982288$var$createBuffer(0);
        return $82a04c4ec6982288$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $82a04c4ec6982288$var$fromArrayLike(obj.data);
}
function $82a04c4ec6982288$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $82a04c4ec6982288$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $82a04c4ec6982288$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $82a04c4ec6982288$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $82a04c4ec6982288$var$Buffer.alloc(+length);
}
$82a04c4ec6982288$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $82a04c4ec6982288$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$82a04c4ec6982288$var$Buffer.compare = function compare(a, b) {
    if ($82a04c4ec6982288$var$isInstance(a, Uint8Array)) a = $82a04c4ec6982288$var$Buffer.from(a, a.offset, a.byteLength);
    if ($82a04c4ec6982288$var$isInstance(b, Uint8Array)) b = $82a04c4ec6982288$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(a) || !$82a04c4ec6982288$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$82a04c4ec6982288$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$82a04c4ec6982288$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $82a04c4ec6982288$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $82a04c4ec6982288$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($82a04c4ec6982288$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) buf = $82a04c4ec6982288$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $82a04c4ec6982288$var$byteLength(string, encoding) {
    if ($82a04c4ec6982288$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $82a04c4ec6982288$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $82a04c4ec6982288$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $82a04c4ec6982288$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$82a04c4ec6982288$var$Buffer.byteLength = $82a04c4ec6982288$var$byteLength;
function $82a04c4ec6982288$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $82a04c4ec6982288$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8Slice(this, start, end);
        case 'ascii':
            return $82a04c4ec6982288$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $82a04c4ec6982288$var$latin1Slice(this, start, end);
        case 'base64':
            return $82a04c4ec6982288$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $82a04c4ec6982288$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$82a04c4ec6982288$var$Buffer.prototype._isBuffer = true;
function $82a04c4ec6982288$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$82a04c4ec6982288$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$82a04c4ec6982288$var$swap(this, i, i + 1);
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $82a04c4ec6982288$var$swap(this, i, i + 3);
        $82a04c4ec6982288$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $82a04c4ec6982288$var$swap(this, i, i + 7);
        $82a04c4ec6982288$var$swap(this, i + 1, i + 6);
        $82a04c4ec6982288$var$swap(this, i + 2, i + 5);
        $82a04c4ec6982288$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $82a04c4ec6982288$var$utf8Slice(this, 0, length);
    return $82a04c4ec6982288$var$slowToString.apply(this, arguments);
};
$82a04c4ec6982288$var$Buffer.prototype.toLocaleString = $82a04c4ec6982288$var$Buffer.prototype.toString;
$82a04c4ec6982288$var$Buffer.prototype.equals = function equals(b) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $82a04c4ec6982288$var$Buffer.compare(this, b) === 0;
};
$82a04c4ec6982288$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $82a04c4ec6982288$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($82a04c4ec6982288$var$customInspectSymbol) $82a04c4ec6982288$var$Buffer.prototype[$82a04c4ec6982288$var$customInspectSymbol] = $82a04c4ec6982288$var$Buffer.prototype.inspect;
$82a04c4ec6982288$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($82a04c4ec6982288$var$isInstance(target, Uint8Array)) target = $82a04c4ec6982288$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $82a04c4ec6982288$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($82a04c4ec6982288$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $82a04c4ec6982288$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($82a04c4ec6982288$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $82a04c4ec6982288$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $82a04c4ec6982288$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $82a04c4ec6982288$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$82a04c4ec6982288$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$82a04c4ec6982288$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $82a04c4ec6982288$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$82a04c4ec6982288$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $82a04c4ec6982288$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $82a04c4ec6982288$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($82a04c4ec6982288$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $82a04c4ec6982288$var$utf8Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $82a04c4ec6982288$var$asciiWrite(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$asciiToBytes(string), buf, offset, length);
}
function $82a04c4ec6982288$var$base64Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$base64ToBytes(string), buf, offset, length);
}
function $82a04c4ec6982288$var$ucs2Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$82a04c4ec6982288$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $82a04c4ec6982288$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $82a04c4ec6982288$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $82a04c4ec6982288$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $82a04c4ec6982288$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$82a04c4ec6982288$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $82a04c4ec6982288$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $3nocJ.fromByteArray(buf);
    else return $3nocJ.fromByteArray(buf.slice(start, end));
}
function $82a04c4ec6982288$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $82a04c4ec6982288$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $82a04c4ec6982288$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $82a04c4ec6982288$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $82a04c4ec6982288$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $82a04c4ec6982288$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $82a04c4ec6982288$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $82a04c4ec6982288$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$82a04c4ec6982288$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $82a04c4ec6982288$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $82a04c4ec6982288$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$82a04c4ec6982288$var$Buffer.prototype.readUintLE = $82a04c4ec6982288$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readUintBE = $82a04c4ec6982288$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint8 = $82a04c4ec6982288$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$82a04c4ec6982288$var$Buffer.prototype.readUint16LE = $82a04c4ec6982288$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint16BE = $82a04c4ec6982288$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$82a04c4ec6982288$var$Buffer.prototype.readUint32LE = $82a04c4ec6982288$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint32BE = $82a04c4ec6982288$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$82a04c4ec6982288$var$Buffer.prototype.readBigUInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$82a04c4ec6982288$var$Buffer.prototype.readBigUInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$82a04c4ec6982288$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$82a04c4ec6982288$var$Buffer.prototype.readBigInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$82a04c4ec6982288$var$Buffer.prototype.readBigInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$82a04c4ec6982288$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return $gU9iR.read(this, offset, true, 23, 4);
};
$82a04c4ec6982288$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return $gU9iR.read(this, offset, false, 23, 4);
};
$82a04c4ec6982288$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 8, this.length);
    return $gU9iR.read(this, offset, true, 52, 8);
};
$82a04c4ec6982288$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 8, this.length);
    return $gU9iR.read(this, offset, false, 52, 8);
};
function $82a04c4ec6982288$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$82a04c4ec6982288$var$Buffer.prototype.writeUintLE = $82a04c4ec6982288$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUintBE = $82a04c4ec6982288$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint8 = $82a04c4ec6982288$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint16LE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint16BE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint32LE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint32BE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $82a04c4ec6982288$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $82a04c4ec6982288$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$82a04c4ec6982288$var$Buffer.prototype.writeBigUInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$82a04c4ec6982288$var$Buffer.prototype.writeBigUInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$82a04c4ec6982288$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeBigInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$82a04c4ec6982288$var$Buffer.prototype.writeBigInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $82a04c4ec6982288$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $gU9iR.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$82a04c4ec6982288$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeFloat(this, value, offset, true, noAssert);
};
$82a04c4ec6982288$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeFloat(this, value, offset, false, noAssert);
};
function $82a04c4ec6982288$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $gU9iR.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$82a04c4ec6982288$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeDouble(this, value, offset, true, noAssert);
};
$82a04c4ec6982288$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$82a04c4ec6982288$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$82a04c4ec6982288$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$82a04c4ec6982288$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $82a04c4ec6982288$var$Buffer.isBuffer(val) ? val : $82a04c4ec6982288$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $82a04c4ec6982288$var$errors = {};
function $82a04c4ec6982288$var$E(sym, getMessage, Base) {
    $82a04c4ec6982288$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$82a04c4ec6982288$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$82a04c4ec6982288$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$82a04c4ec6982288$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $82a04c4ec6982288$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $82a04c4ec6982288$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $82a04c4ec6982288$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $82a04c4ec6982288$var$checkBounds(buf, offset, byteLength) {
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $82a04c4ec6982288$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $82a04c4ec6982288$var$checkBounds(buf, offset, byteLength);
}
function $82a04c4ec6982288$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $82a04c4ec6982288$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $82a04c4ec6982288$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $82a04c4ec6982288$var$validateNumber(value, type);
        throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $82a04c4ec6982288$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $82a04c4ec6982288$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $82a04c4ec6982288$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($82a04c4ec6982288$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $82a04c4ec6982288$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $82a04c4ec6982288$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $82a04c4ec6982288$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $82a04c4ec6982288$var$base64ToBytes(str) {
    return $3nocJ.toByteArray($82a04c4ec6982288$var$base64clean(str));
}
function $82a04c4ec6982288$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $82a04c4ec6982288$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $82a04c4ec6982288$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $82a04c4ec6982288$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $82a04c4ec6982288$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $82a04c4ec6982288$var$BufferBigIntNotDefined : fn;
}
function $82a04c4ec6982288$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("3nocJ", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $27564b8a0078aa3d$export$d622b2ad8d90c771; }, function (v) { return $27564b8a0078aa3d$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $27564b8a0078aa3d$export$6100ba28696e12de; }, function (v) { return $27564b8a0078aa3d$export$6100ba28696e12de = v; });
var $27564b8a0078aa3d$export$a48f0734ac7c2329;
var $27564b8a0078aa3d$export$d622b2ad8d90c771;
var $27564b8a0078aa3d$export$6100ba28696e12de;
'use strict';
$27564b8a0078aa3d$export$a48f0734ac7c2329 = $27564b8a0078aa3d$var$byteLength;
$27564b8a0078aa3d$export$d622b2ad8d90c771 = $27564b8a0078aa3d$var$toByteArray;
$27564b8a0078aa3d$export$6100ba28696e12de = $27564b8a0078aa3d$var$fromByteArray;
var $27564b8a0078aa3d$var$lookup = [];
var $27564b8a0078aa3d$var$revLookup = [];
var $27564b8a0078aa3d$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $27564b8a0078aa3d$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $27564b8a0078aa3d$var$i = 0, $27564b8a0078aa3d$var$len = $27564b8a0078aa3d$var$code.length; $27564b8a0078aa3d$var$i < $27564b8a0078aa3d$var$len; ++$27564b8a0078aa3d$var$i){
    $27564b8a0078aa3d$var$lookup[$27564b8a0078aa3d$var$i] = $27564b8a0078aa3d$var$code[$27564b8a0078aa3d$var$i];
    $27564b8a0078aa3d$var$revLookup[$27564b8a0078aa3d$var$code.charCodeAt($27564b8a0078aa3d$var$i)] = $27564b8a0078aa3d$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$27564b8a0078aa3d$var$revLookup['-'.charCodeAt(0)] = 62;
$27564b8a0078aa3d$var$revLookup['_'.charCodeAt(0)] = 63;
function $27564b8a0078aa3d$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $27564b8a0078aa3d$var$byteLength(b64) {
    var lens = $27564b8a0078aa3d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $27564b8a0078aa3d$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $27564b8a0078aa3d$var$toByteArray(b64) {
    var tmp;
    var lens = $27564b8a0078aa3d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $27564b8a0078aa3d$var$Arr($27564b8a0078aa3d$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 18 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 2 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 10 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $27564b8a0078aa3d$var$tripletToBase64(num) {
    return $27564b8a0078aa3d$var$lookup[num >> 18 & 0x3F] + $27564b8a0078aa3d$var$lookup[num >> 12 & 0x3F] + $27564b8a0078aa3d$var$lookup[num >> 6 & 0x3F] + $27564b8a0078aa3d$var$lookup[num & 0x3F];
}
function $27564b8a0078aa3d$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($27564b8a0078aa3d$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $27564b8a0078aa3d$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($27564b8a0078aa3d$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($27564b8a0078aa3d$var$lookup[tmp >> 2] + $27564b8a0078aa3d$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($27564b8a0078aa3d$var$lookup[tmp >> 10] + $27564b8a0078aa3d$var$lookup[tmp >> 4 & 0x3F] + $27564b8a0078aa3d$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("gU9iR", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $c4e917b4c37bfab7$export$aafa59e2e03f2942; }, function (v) { return $c4e917b4c37bfab7$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $c4e917b4c37bfab7$export$68d8715fc104d294; }, function (v) { return $c4e917b4c37bfab7$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $c4e917b4c37bfab7$export$aafa59e2e03f2942;
var $c4e917b4c37bfab7$export$68d8715fc104d294;
$c4e917b4c37bfab7$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$c4e917b4c37bfab7$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("gSkQi", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.18.1';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`', INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution:
            // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
            var index = -1, length = path.length;
            if (!length) return true;
            while(++index < length){
                var key = toKey(path[index]);
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block constructor/prototype as non-terminal traversal keys to prevent
                // escaping the object graph into built-in constructors and prototypes.
                if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                baseAssignValue(result, pair[0], pair[1]);
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
                if (reForbiddenIdentifierChars.test(key)) throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("f08he", function(module, exports) {

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $aebd46b710a95c96$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $aebd46b710a95c96$var$MAX_UINT32 = 4294967295;
function $aebd46b710a95c96$var$oldBrowser() {
    throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
}

var $838j1 = parcelRequire("838j1");
var $aebd46b710a95c96$require$Buffer = $838j1.Buffer;
var $aebd46b710a95c96$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($aebd46b710a95c96$var$crypto && $aebd46b710a95c96$var$crypto.getRandomValues) module.exports = $aebd46b710a95c96$var$randomBytes;
else module.exports = $aebd46b710a95c96$var$oldBrowser;
function $aebd46b710a95c96$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $aebd46b710a95c96$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $aebd46b710a95c96$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $aebd46b710a95c96$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $aebd46b710a95c96$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $aebd46b710a95c96$var$crypto.getRandomValues(bytes.slice(generated, generated + $aebd46b710a95c96$var$MAX_BYTES));
        else $aebd46b710a95c96$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $4ZL0H.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("4ZL0H", function(module, exports) {
// shim for using process in browser
var $3a3153321729209f$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $3a3153321729209f$var$cachedSetTimeout;
var $3a3153321729209f$var$cachedClearTimeout;
function $3a3153321729209f$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $3a3153321729209f$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $3a3153321729209f$var$cachedSetTimeout = setTimeout;
        else $3a3153321729209f$var$cachedSetTimeout = $3a3153321729209f$var$defaultSetTimout;
    } catch (e) {
        $3a3153321729209f$var$cachedSetTimeout = $3a3153321729209f$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $3a3153321729209f$var$cachedClearTimeout = clearTimeout;
        else $3a3153321729209f$var$cachedClearTimeout = $3a3153321729209f$var$defaultClearTimeout;
    } catch (e) {
        $3a3153321729209f$var$cachedClearTimeout = $3a3153321729209f$var$defaultClearTimeout;
    }
})();
function $3a3153321729209f$var$runTimeout(fun) {
    if ($3a3153321729209f$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($3a3153321729209f$var$cachedSetTimeout === $3a3153321729209f$var$defaultSetTimout || !$3a3153321729209f$var$cachedSetTimeout) && setTimeout) {
        $3a3153321729209f$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3a3153321729209f$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $3a3153321729209f$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $3a3153321729209f$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $3a3153321729209f$var$runClearTimeout(marker) {
    if ($3a3153321729209f$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($3a3153321729209f$var$cachedClearTimeout === $3a3153321729209f$var$defaultClearTimeout || !$3a3153321729209f$var$cachedClearTimeout) && clearTimeout) {
        $3a3153321729209f$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3a3153321729209f$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $3a3153321729209f$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $3a3153321729209f$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $3a3153321729209f$var$queue = [];
var $3a3153321729209f$var$draining = false;
var $3a3153321729209f$var$currentQueue;
var $3a3153321729209f$var$queueIndex = -1;
function $3a3153321729209f$var$cleanUpNextTick() {
    if (!$3a3153321729209f$var$draining || !$3a3153321729209f$var$currentQueue) return;
    $3a3153321729209f$var$draining = false;
    if ($3a3153321729209f$var$currentQueue.length) $3a3153321729209f$var$queue = $3a3153321729209f$var$currentQueue.concat($3a3153321729209f$var$queue);
    else $3a3153321729209f$var$queueIndex = -1;
    if ($3a3153321729209f$var$queue.length) $3a3153321729209f$var$drainQueue();
}
function $3a3153321729209f$var$drainQueue() {
    if ($3a3153321729209f$var$draining) return;
    var timeout = $3a3153321729209f$var$runTimeout($3a3153321729209f$var$cleanUpNextTick);
    $3a3153321729209f$var$draining = true;
    var len = $3a3153321729209f$var$queue.length;
    while(len){
        $3a3153321729209f$var$currentQueue = $3a3153321729209f$var$queue;
        $3a3153321729209f$var$queue = [];
        while(++$3a3153321729209f$var$queueIndex < len)if ($3a3153321729209f$var$currentQueue) $3a3153321729209f$var$currentQueue[$3a3153321729209f$var$queueIndex].run();
        $3a3153321729209f$var$queueIndex = -1;
        len = $3a3153321729209f$var$queue.length;
    }
    $3a3153321729209f$var$currentQueue = null;
    $3a3153321729209f$var$draining = false;
    $3a3153321729209f$var$runClearTimeout(timeout);
}
$3a3153321729209f$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $3a3153321729209f$var$queue.push(new $3a3153321729209f$var$Item(fun, args));
    if ($3a3153321729209f$var$queue.length === 1 && !$3a3153321729209f$var$draining) $3a3153321729209f$var$runTimeout($3a3153321729209f$var$drainQueue);
};
// v8 likes predictible objects
function $3a3153321729209f$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$3a3153321729209f$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$3a3153321729209f$var$process.title = 'browser';
$3a3153321729209f$var$process.browser = true;
$3a3153321729209f$var$process.env = {};
$3a3153321729209f$var$process.argv = [];
$3a3153321729209f$var$process.version = ''; // empty string to avoid regexp issues
$3a3153321729209f$var$process.versions = {};
function $3a3153321729209f$var$noop() {}
$3a3153321729209f$var$process.on = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.addListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.once = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.off = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.removeListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.removeAllListeners = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.emit = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.prependListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.prependOnceListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.listeners = function(name) {
    return [];
};
$3a3153321729209f$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$3a3153321729209f$var$process.cwd = function() {
    return '/';
};
$3a3153321729209f$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$3a3153321729209f$var$process.umask = function() {
    return 0;
};

});

parcelRegister("838j1", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $bdjQ6 = parcelRequire("bdjQ6");
var $5dc50be4850cea7a$var$Buffer = $bdjQ6.Buffer;
// alternative to using Object.keys for old browsers
function $5dc50be4850cea7a$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($5dc50be4850cea7a$var$Buffer.from && $5dc50be4850cea7a$var$Buffer.alloc && $5dc50be4850cea7a$var$Buffer.allocUnsafe && $5dc50be4850cea7a$var$Buffer.allocUnsafeSlow) module.exports = $bdjQ6;
else {
    // Copy properties from require('buffer')
    $5dc50be4850cea7a$var$copyProps($bdjQ6, module.exports);
    module.exports.Buffer = $5dc50be4850cea7a$var$SafeBuffer;
}
function $5dc50be4850cea7a$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $5dc50be4850cea7a$var$Buffer(arg, encodingOrOffset, length);
}
$5dc50be4850cea7a$var$SafeBuffer.prototype = Object.create($5dc50be4850cea7a$var$Buffer.prototype);
// Copy static methods from Buffer
$5dc50be4850cea7a$var$copyProps($5dc50be4850cea7a$var$Buffer, $5dc50be4850cea7a$var$SafeBuffer);
$5dc50be4850cea7a$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $5dc50be4850cea7a$var$Buffer(arg, encodingOrOffset, length);
};
$5dc50be4850cea7a$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $5dc50be4850cea7a$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$5dc50be4850cea7a$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $5dc50be4850cea7a$var$Buffer(size);
};
$5dc50be4850cea7a$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $bdjQ6.SlowBuffer(size);
};

});


parcelRegister("eNPUV", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $2GAk4 = parcelRequire("2GAk4");

var $1Jsb3 = parcelRequire("1Jsb3");

var $15EwC = parcelRequire("15EwC");

var $6GOuC = parcelRequire("6GOuC");
function $ac6de9f97af53a66$var$Hash(hash) {
    $6GOuC.call(this, 'digest');
    this._hash = hash;
}
$dhT4G($ac6de9f97af53a66$var$Hash, $6GOuC);
$ac6de9f97af53a66$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$ac6de9f97af53a66$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $2GAk4();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $1Jsb3();
    return new $ac6de9f97af53a66$var$Hash($15EwC(alg));
};

});
parcelRegister("dhT4G", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("2GAk4", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $fMFLx = parcelRequire("fMFLx");

var $838j1 = parcelRequire("838j1");
var $1f4badf6a671bb38$require$Buffer = $838j1.Buffer;
var $1f4badf6a671bb38$var$ARRAY16 = new Array(16);
function $1f4badf6a671bb38$var$MD5() {
    $fMFLx.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$dhT4G($1f4badf6a671bb38$var$MD5, $fMFLx);
$1f4badf6a671bb38$var$MD5.prototype._update = function() {
    var M = $1f4badf6a671bb38$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $1f4badf6a671bb38$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $1f4badf6a671bb38$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $1f4badf6a671bb38$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $1f4badf6a671bb38$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $1f4badf6a671bb38$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $1f4badf6a671bb38$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $1f4badf6a671bb38$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $1f4badf6a671bb38$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $1f4badf6a671bb38$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $1f4badf6a671bb38$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $1f4badf6a671bb38$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $1f4badf6a671bb38$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $1f4badf6a671bb38$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $1f4badf6a671bb38$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $1f4badf6a671bb38$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $1f4badf6a671bb38$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $1f4badf6a671bb38$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $1f4badf6a671bb38$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $1f4badf6a671bb38$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $1f4badf6a671bb38$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $1f4badf6a671bb38$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $1f4badf6a671bb38$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $1f4badf6a671bb38$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $1f4badf6a671bb38$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $1f4badf6a671bb38$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $1f4badf6a671bb38$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $1f4badf6a671bb38$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $1f4badf6a671bb38$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $1f4badf6a671bb38$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $1f4badf6a671bb38$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $1f4badf6a671bb38$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $1f4badf6a671bb38$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $1f4badf6a671bb38$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $1f4badf6a671bb38$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $1f4badf6a671bb38$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $1f4badf6a671bb38$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $1f4badf6a671bb38$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $1f4badf6a671bb38$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $1f4badf6a671bb38$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $1f4badf6a671bb38$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $1f4badf6a671bb38$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $1f4badf6a671bb38$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $1f4badf6a671bb38$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $1f4badf6a671bb38$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $1f4badf6a671bb38$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $1f4badf6a671bb38$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $1f4badf6a671bb38$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $1f4badf6a671bb38$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $1f4badf6a671bb38$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $1f4badf6a671bb38$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $1f4badf6a671bb38$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $1f4badf6a671bb38$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $1f4badf6a671bb38$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $1f4badf6a671bb38$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $1f4badf6a671bb38$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $1f4badf6a671bb38$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $1f4badf6a671bb38$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $1f4badf6a671bb38$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $1f4badf6a671bb38$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $1f4badf6a671bb38$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $1f4badf6a671bb38$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $1f4badf6a671bb38$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $1f4badf6a671bb38$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $1f4badf6a671bb38$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$1f4badf6a671bb38$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $1f4badf6a671bb38$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $1f4badf6a671bb38$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $1f4badf6a671bb38$var$fnF(a, b, c, d, m, k, s) {
    return $1f4badf6a671bb38$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $1f4badf6a671bb38$var$fnG(a, b, c, d, m, k, s) {
    return $1f4badf6a671bb38$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $1f4badf6a671bb38$var$fnH(a, b, c, d, m, k, s) {
    return $1f4badf6a671bb38$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $1f4badf6a671bb38$var$fnI(a, b, c, d, m, k, s) {
    return $1f4badf6a671bb38$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $1f4badf6a671bb38$var$MD5;

});
parcelRegister("fMFLx", function(module, exports) {
'use strict';

var $838j1 = parcelRequire("838j1");
var $b7dbbc848410cd66$require$Buffer = $838j1.Buffer;

var $3DkjE = parcelRequire("3DkjE");
var $b7dbbc848410cd66$require$Transform = $3DkjE.Transform;

var $dhT4G = parcelRequire("dhT4G");
function $b7dbbc848410cd66$var$HashBase(blockSize) {
    $b7dbbc848410cd66$require$Transform.call(this);
    this._block = $b7dbbc848410cd66$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dhT4G($b7dbbc848410cd66$var$HashBase, $b7dbbc848410cd66$require$Transform);
$b7dbbc848410cd66$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$b7dbbc848410cd66$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
var $b7dbbc848410cd66$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $b7dbbc848410cd66$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && ArrayBuffer.isView && ($b7dbbc848410cd66$require$Buffer.prototype instanceof Uint8Array || $b7dbbc848410cd66$require$Buffer.TYPED_ARRAY_SUPPORT);
function $b7dbbc848410cd66$var$toBuffer(data, encoding) {
    // No need to do anything for exact instance
    // This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
    if (data instanceof $b7dbbc848410cd66$require$Buffer) return data;
    // Convert strings to Buffer
    if (typeof data === 'string') return $b7dbbc848410cd66$require$Buffer.from(data, encoding);
    /*
   * Wrap any TypedArray instances and DataViews
   * Makes sense only on engines with full TypedArray support -- let Buffer detect that
   */ if ($b7dbbc848410cd66$var$useArrayBuffer && ArrayBuffer.isView(data)) {
        if (data.byteLength === 0) return $b7dbbc848410cd66$require$Buffer.alloc(0) // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        ;
        var res = $b7dbbc848410cd66$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
        // Recheck result size, as offset/length doesn't work on Node.js <5.10
        // We just go to Uint8Array case if this fails
        if (res.byteLength === data.byteLength) return res;
    }
    /*
   * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
   * Doesn't make sense with other TypedArray instances
   */ if ($b7dbbc848410cd66$var$useUint8Array && data instanceof Uint8Array) return $b7dbbc848410cd66$require$Buffer.from(data);
    /*
   * Old Buffer polyfill on an engine that doesn't have TypedArray support
   * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
   * Convert to our current Buffer implementation
   */ if ($b7dbbc848410cd66$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $b7dbbc848410cd66$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}
$b7dbbc848410cd66$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    data = $b7dbbc848410cd66$var$toBuffer(data, encoding) // asserts correct input type
    ;
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$b7dbbc848410cd66$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$b7dbbc848410cd66$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$b7dbbc848410cd66$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $b7dbbc848410cd66$var$HashBase;

});
parcelRegister("3DkjE", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $2a54c5edd7835136$var$Stream;

var $fzCxw = parcelRequire("fzCxw");
var $2a54c5edd7835136$require$EE = $fzCxw.EventEmitter;

var $dhT4G = parcelRequire("dhT4G");
$dhT4G($2a54c5edd7835136$var$Stream, $2a54c5edd7835136$require$EE);

$2a54c5edd7835136$var$Stream.Readable = (parcelRequire("52Vgn"));

$2a54c5edd7835136$var$Stream.Writable = (parcelRequire("1uEw0"));

$2a54c5edd7835136$var$Stream.Duplex = (parcelRequire("6APwg"));

$2a54c5edd7835136$var$Stream.Transform = (parcelRequire("6H0L1"));

$2a54c5edd7835136$var$Stream.PassThrough = (parcelRequire("e2OS0"));

$2a54c5edd7835136$var$Stream.finished = (parcelRequire("faWKl"));

$2a54c5edd7835136$var$Stream.pipeline = (parcelRequire("9Mw7i"));
// Backwards-compat with node 0.4.x
$2a54c5edd7835136$var$Stream.Stream = $2a54c5edd7835136$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $2a54c5edd7835136$var$Stream() {
    $2a54c5edd7835136$require$EE.call(this);
}
$2a54c5edd7835136$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($2a54c5edd7835136$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("fzCxw", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $b5680518dd48c196$var$R = typeof Reflect === 'object' ? Reflect : null;
var $b5680518dd48c196$var$ReflectApply = $b5680518dd48c196$var$R && typeof $b5680518dd48c196$var$R.apply === 'function' ? $b5680518dd48c196$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $b5680518dd48c196$var$ReflectOwnKeys;
if ($b5680518dd48c196$var$R && typeof $b5680518dd48c196$var$R.ownKeys === 'function') $b5680518dd48c196$var$ReflectOwnKeys = $b5680518dd48c196$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $b5680518dd48c196$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $b5680518dd48c196$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $b5680518dd48c196$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $b5680518dd48c196$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $b5680518dd48c196$var$EventEmitter() {
    $b5680518dd48c196$var$EventEmitter.init.call(this);
}
module.exports = $b5680518dd48c196$var$EventEmitter;
module.exports.once = $b5680518dd48c196$var$once;
// Backwards-compat with node 0.10.x
$b5680518dd48c196$var$EventEmitter.EventEmitter = $b5680518dd48c196$var$EventEmitter;
$b5680518dd48c196$var$EventEmitter.prototype._events = undefined;
$b5680518dd48c196$var$EventEmitter.prototype._eventsCount = 0;
$b5680518dd48c196$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $b5680518dd48c196$var$defaultMaxListeners = 10;
function $b5680518dd48c196$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($b5680518dd48c196$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $b5680518dd48c196$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $b5680518dd48c196$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $b5680518dd48c196$var$defaultMaxListeners = arg;
    }
});
$b5680518dd48c196$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$b5680518dd48c196$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $b5680518dd48c196$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $b5680518dd48c196$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $b5680518dd48c196$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$b5680518dd48c196$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $b5680518dd48c196$var$_getMaxListeners(this);
};
$b5680518dd48c196$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $b5680518dd48c196$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $b5680518dd48c196$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$b5680518dd48c196$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $b5680518dd48c196$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $b5680518dd48c196$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $b5680518dd48c196$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $b5680518dd48c196$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$b5680518dd48c196$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $b5680518dd48c196$var$_addListener(this, type, listener, false);
};
$b5680518dd48c196$var$EventEmitter.prototype.on = $b5680518dd48c196$var$EventEmitter.prototype.addListener;
$b5680518dd48c196$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $b5680518dd48c196$var$_addListener(this, type, listener, true);
};
function $b5680518dd48c196$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $b5680518dd48c196$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $b5680518dd48c196$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$b5680518dd48c196$var$EventEmitter.prototype.once = function once(type, listener) {
    $b5680518dd48c196$var$checkListener(listener);
    this.on(type, $b5680518dd48c196$var$_onceWrap(this, type, listener));
    return this;
};
$b5680518dd48c196$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $b5680518dd48c196$var$checkListener(listener);
    this.prependListener(type, $b5680518dd48c196$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$b5680518dd48c196$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $b5680518dd48c196$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $b5680518dd48c196$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$b5680518dd48c196$var$EventEmitter.prototype.off = $b5680518dd48c196$var$EventEmitter.prototype.removeListener;
$b5680518dd48c196$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $b5680518dd48c196$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $b5680518dd48c196$var$unwrapListeners(evlistener) : $b5680518dd48c196$var$arrayClone(evlistener, evlistener.length);
}
$b5680518dd48c196$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $b5680518dd48c196$var$_listeners(this, type, true);
};
$b5680518dd48c196$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $b5680518dd48c196$var$_listeners(this, type, false);
};
$b5680518dd48c196$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $b5680518dd48c196$var$listenerCount.call(emitter, type);
};
$b5680518dd48c196$var$EventEmitter.prototype.listenerCount = $b5680518dd48c196$var$listenerCount;
function $b5680518dd48c196$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$b5680518dd48c196$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $b5680518dd48c196$var$ReflectOwnKeys(this._events) : [];
};
function $b5680518dd48c196$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $b5680518dd48c196$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $b5680518dd48c196$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $b5680518dd48c196$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $b5680518dd48c196$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $b5680518dd48c196$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $b5680518dd48c196$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $b5680518dd48c196$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $b5680518dd48c196$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("52Vgn", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
module.exports = $3ac98eed33a0cf82$var$Readable;
/*<replacement>*/ var $3ac98eed33a0cf82$var$Duplex;
/*</replacement>*/ $3ac98eed33a0cf82$var$Readable.ReadableState = $3ac98eed33a0cf82$var$ReadableState;

var $fzCxw = parcelRequire("fzCxw");
var $3ac98eed33a0cf82$require$EE = $fzCxw.EventEmitter;
var $3ac98eed33a0cf82$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $kKRZw = parcelRequire("kKRZw");

var $bdjQ6 = parcelRequire("bdjQ6");
var $3ac98eed33a0cf82$require$Buffer = $bdjQ6.Buffer;
var $3ac98eed33a0cf82$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $3ac98eed33a0cf82$var$_uint8ArrayToBuffer(chunk) {
    return $3ac98eed33a0cf82$require$Buffer.from(chunk);
}
function $3ac98eed33a0cf82$var$_isUint8Array(obj) {
    return $3ac98eed33a0cf82$require$Buffer.isBuffer(obj) || obj instanceof $3ac98eed33a0cf82$var$OurUint8Array;
}

var $ifbub = parcelRequire("ifbub");
var $3ac98eed33a0cf82$var$debug;
if ($ifbub && $ifbub.debuglog) $3ac98eed33a0cf82$var$debug = $ifbub.debuglog('stream');
else $3ac98eed33a0cf82$var$debug = function debug() {};

var $aJGWJ = parcelRequire("aJGWJ");

var $cIBKQ = parcelRequire("cIBKQ");

var $9LKRZ = parcelRequire("9LKRZ");
var $3ac98eed33a0cf82$var$getHighWaterMark = $9LKRZ.getHighWaterMark;

var $akNAa = parcelRequire("akNAa");
var $3ac98eed33a0cf82$require$_require$codes = $akNAa.codes;
var $3ac98eed33a0cf82$var$ERR_INVALID_ARG_TYPE = $3ac98eed33a0cf82$require$_require$codes.ERR_INVALID_ARG_TYPE, $3ac98eed33a0cf82$var$ERR_STREAM_PUSH_AFTER_EOF = $3ac98eed33a0cf82$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $3ac98eed33a0cf82$var$ERR_METHOD_NOT_IMPLEMENTED = $3ac98eed33a0cf82$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $3ac98eed33a0cf82$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $3ac98eed33a0cf82$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $3ac98eed33a0cf82$var$StringDecoder;
var $3ac98eed33a0cf82$var$createReadableStreamAsyncIterator;
var $3ac98eed33a0cf82$var$from;

(parcelRequire("dhT4G"))($3ac98eed33a0cf82$var$Readable, $kKRZw);
var $3ac98eed33a0cf82$var$errorOrDestroy = $cIBKQ.errorOrDestroy;
var $3ac98eed33a0cf82$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $3ac98eed33a0cf82$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $3ac98eed33a0cf82$var$ReadableState(options, stream, isDuplex) {
    $3ac98eed33a0cf82$var$Duplex = $3ac98eed33a0cf82$var$Duplex || (parcelRequire("6APwg"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $3ac98eed33a0cf82$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $3ac98eed33a0cf82$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $aJGWJ();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$3ac98eed33a0cf82$var$StringDecoder) $3ac98eed33a0cf82$var$StringDecoder = (parcelRequire("iGJyf")).StringDecoder;
        this.decoder = new $3ac98eed33a0cf82$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $3ac98eed33a0cf82$var$Readable(options) {
    $3ac98eed33a0cf82$var$Duplex = $3ac98eed33a0cf82$var$Duplex || (parcelRequire("6APwg"));
    if (!(this instanceof $3ac98eed33a0cf82$var$Readable)) return new $3ac98eed33a0cf82$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $3ac98eed33a0cf82$var$Duplex;
    this._readableState = new $3ac98eed33a0cf82$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $kKRZw.call(this);
}
Object.defineProperty($3ac98eed33a0cf82$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$3ac98eed33a0cf82$var$Readable.prototype.destroy = $cIBKQ.destroy;
$3ac98eed33a0cf82$var$Readable.prototype._undestroy = $cIBKQ.undestroy;
$3ac98eed33a0cf82$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$3ac98eed33a0cf82$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $3ac98eed33a0cf82$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $3ac98eed33a0cf82$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$3ac98eed33a0cf82$var$Readable.prototype.unshift = function(chunk) {
    return $3ac98eed33a0cf82$var$readableAddChunk(this, chunk, null, true, false);
};
function $3ac98eed33a0cf82$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $3ac98eed33a0cf82$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $3ac98eed33a0cf82$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $3ac98eed33a0cf82$var$chunkInvalid(state, chunk);
        if (er) $3ac98eed33a0cf82$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $3ac98eed33a0cf82$require$Buffer.prototype) chunk = $3ac98eed33a0cf82$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $3ac98eed33a0cf82$var$errorOrDestroy(stream, new $3ac98eed33a0cf82$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $3ac98eed33a0cf82$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $3ac98eed33a0cf82$var$errorOrDestroy(stream, new $3ac98eed33a0cf82$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $3ac98eed33a0cf82$var$addChunk(stream, state, chunk, false);
                    else $3ac98eed33a0cf82$var$maybeReadMore(stream, state);
                } else $3ac98eed33a0cf82$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $3ac98eed33a0cf82$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $3ac98eed33a0cf82$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $3ac98eed33a0cf82$var$emitReadable(stream);
    }
    $3ac98eed33a0cf82$var$maybeReadMore(stream, state);
}
function $3ac98eed33a0cf82$var$chunkInvalid(state, chunk) {
    var er;
    if (!$3ac98eed33a0cf82$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $3ac98eed33a0cf82$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$3ac98eed33a0cf82$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$3ac98eed33a0cf82$var$Readable.prototype.setEncoding = function(enc) {
    if (!$3ac98eed33a0cf82$var$StringDecoder) $3ac98eed33a0cf82$var$StringDecoder = (parcelRequire("iGJyf")).StringDecoder;
    var decoder = new $3ac98eed33a0cf82$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $3ac98eed33a0cf82$var$MAX_HWM = 0x40000000;
function $3ac98eed33a0cf82$var$computeNewHighWaterMark(n) {
    if (n >= $3ac98eed33a0cf82$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $3ac98eed33a0cf82$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $3ac98eed33a0cf82$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $3ac98eed33a0cf82$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$3ac98eed33a0cf82$var$Readable.prototype.read = function(n) {
    $3ac98eed33a0cf82$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $3ac98eed33a0cf82$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $3ac98eed33a0cf82$var$endReadable(this);
        else $3ac98eed33a0cf82$var$emitReadable(this);
        return null;
    }
    n = $3ac98eed33a0cf82$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $3ac98eed33a0cf82$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $3ac98eed33a0cf82$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $3ac98eed33a0cf82$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $3ac98eed33a0cf82$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $3ac98eed33a0cf82$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $3ac98eed33a0cf82$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $3ac98eed33a0cf82$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $3ac98eed33a0cf82$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $3ac98eed33a0cf82$var$onEofChunk(stream, state) {
    $3ac98eed33a0cf82$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $3ac98eed33a0cf82$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $3ac98eed33a0cf82$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $3ac98eed33a0cf82$var$emitReadable(stream) {
    var state = stream._readableState;
    $3ac98eed33a0cf82$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $3ac98eed33a0cf82$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $4ZL0H.nextTick($3ac98eed33a0cf82$var$emitReadable_, stream);
    }
}
function $3ac98eed33a0cf82$var$emitReadable_(stream) {
    var state = stream._readableState;
    $3ac98eed33a0cf82$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $3ac98eed33a0cf82$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $3ac98eed33a0cf82$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $4ZL0H.nextTick($3ac98eed33a0cf82$var$maybeReadMore_, stream, state);
    }
}
function $3ac98eed33a0cf82$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $3ac98eed33a0cf82$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$3ac98eed33a0cf82$var$Readable.prototype._read = function(n) {
    $3ac98eed33a0cf82$var$errorOrDestroy(this, new $3ac98eed33a0cf82$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$3ac98eed33a0cf82$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $3ac98eed33a0cf82$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $4ZL0H.stdout && dest !== $4ZL0H.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $4ZL0H.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $3ac98eed33a0cf82$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $3ac98eed33a0cf82$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $3ac98eed33a0cf82$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $3ac98eed33a0cf82$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $3ac98eed33a0cf82$var$debug('ondata');
        var ret = dest.write(chunk);
        $3ac98eed33a0cf82$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $3ac98eed33a0cf82$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $3ac98eed33a0cf82$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $3ac98eed33a0cf82$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($3ac98eed33a0cf82$var$EElistenerCount(dest, 'error') === 0) $3ac98eed33a0cf82$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $3ac98eed33a0cf82$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $3ac98eed33a0cf82$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $3ac98eed33a0cf82$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $3ac98eed33a0cf82$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $3ac98eed33a0cf82$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $3ac98eed33a0cf82$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $3ac98eed33a0cf82$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $3ac98eed33a0cf82$var$flow(src);
        }
    };
}
$3ac98eed33a0cf82$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $3ac98eed33a0cf82$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$3ac98eed33a0cf82$var$Readable.prototype.on = function(ev, fn) {
    var res = $kKRZw.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $3ac98eed33a0cf82$var$debug('on readable', state.length, state.reading);
            if (state.length) $3ac98eed33a0cf82$var$emitReadable(this);
            else if (!state.reading) $4ZL0H.nextTick($3ac98eed33a0cf82$var$nReadingNextTick, this);
        }
    }
    return res;
};
$3ac98eed33a0cf82$var$Readable.prototype.addListener = $3ac98eed33a0cf82$var$Readable.prototype.on;
$3ac98eed33a0cf82$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $kKRZw.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $4ZL0H.nextTick($3ac98eed33a0cf82$var$updateReadableListening, this);
    return res;
};
$3ac98eed33a0cf82$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $kKRZw.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $4ZL0H.nextTick($3ac98eed33a0cf82$var$updateReadableListening, this);
    return res;
};
function $3ac98eed33a0cf82$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $3ac98eed33a0cf82$var$nReadingNextTick(self1) {
    $3ac98eed33a0cf82$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$3ac98eed33a0cf82$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $3ac98eed33a0cf82$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $3ac98eed33a0cf82$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $3ac98eed33a0cf82$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $4ZL0H.nextTick($3ac98eed33a0cf82$var$resume_, stream, state);
    }
}
function $3ac98eed33a0cf82$var$resume_(stream, state) {
    $3ac98eed33a0cf82$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $3ac98eed33a0cf82$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$3ac98eed33a0cf82$var$Readable.prototype.pause = function() {
    $3ac98eed33a0cf82$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $3ac98eed33a0cf82$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $3ac98eed33a0cf82$var$flow(stream) {
    var state = stream._readableState;
    $3ac98eed33a0cf82$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$3ac98eed33a0cf82$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $3ac98eed33a0cf82$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $3ac98eed33a0cf82$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $3ac98eed33a0cf82$var$kProxyEvents.length; n++)stream.on($3ac98eed33a0cf82$var$kProxyEvents[n], this.emit.bind(this, $3ac98eed33a0cf82$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $3ac98eed33a0cf82$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $3ac98eed33a0cf82$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($3ac98eed33a0cf82$var$createReadableStreamAsyncIterator === undefined) $3ac98eed33a0cf82$var$createReadableStreamAsyncIterator = (parcelRequire("84GJs"));
    return $3ac98eed33a0cf82$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($3ac98eed33a0cf82$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($3ac98eed33a0cf82$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($3ac98eed33a0cf82$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$3ac98eed33a0cf82$var$Readable._fromList = $3ac98eed33a0cf82$var$fromList;
Object.defineProperty($3ac98eed33a0cf82$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $3ac98eed33a0cf82$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $3ac98eed33a0cf82$var$endReadable(stream) {
    var state = stream._readableState;
    $3ac98eed33a0cf82$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $4ZL0H.nextTick($3ac98eed33a0cf82$var$endReadableNT, state, stream);
    }
}
function $3ac98eed33a0cf82$var$endReadableNT(state, stream) {
    $3ac98eed33a0cf82$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $3ac98eed33a0cf82$var$Readable.from = function(iterable, opts) {
    if ($3ac98eed33a0cf82$var$from === undefined) $3ac98eed33a0cf82$var$from = (parcelRequire("dp7AE"));
    return $3ac98eed33a0cf82$var$from($3ac98eed33a0cf82$var$Readable, iterable, opts);
};
function $3ac98eed33a0cf82$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("kKRZw", function(module, exports) {

module.exports = (parcelRequire("fzCxw")).EventEmitter;

});

parcelRegister("ifbub", function(module, exports) {
"use strict";

});

parcelRegister("aJGWJ", function(module, exports) {
'use strict';
function $7d0f6b91e6ceef9e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7d0f6b91e6ceef9e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7d0f6b91e6ceef9e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $7d0f6b91e6ceef9e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7d0f6b91e6ceef9e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7d0f6b91e6ceef9e$var$_defineProperty(obj, key, value) {
    key = $7d0f6b91e6ceef9e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7d0f6b91e6ceef9e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7d0f6b91e6ceef9e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7d0f6b91e6ceef9e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7d0f6b91e6ceef9e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7d0f6b91e6ceef9e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7d0f6b91e6ceef9e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7d0f6b91e6ceef9e$var$_toPropertyKey(arg) {
    var key = $7d0f6b91e6ceef9e$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $7d0f6b91e6ceef9e$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $bdjQ6 = parcelRequire("bdjQ6");
var $7d0f6b91e6ceef9e$var$Buffer = $bdjQ6.Buffer;

var $ifbub = parcelRequire("ifbub");
var $7d0f6b91e6ceef9e$var$inspect = $ifbub.inspect;
var $7d0f6b91e6ceef9e$var$custom = $7d0f6b91e6ceef9e$var$inspect && $7d0f6b91e6ceef9e$var$inspect.custom || 'inspect';
function $7d0f6b91e6ceef9e$var$copyBuffer(src, target, offset) {
    $7d0f6b91e6ceef9e$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $7d0f6b91e6ceef9e$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $7d0f6b91e6ceef9e$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $7d0f6b91e6ceef9e$var$Buffer.alloc(0);
                var ret = $7d0f6b91e6ceef9e$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $7d0f6b91e6ceef9e$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $7d0f6b91e6ceef9e$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $7d0f6b91e6ceef9e$var$custom,
            value: function value(_, options) {
                return $7d0f6b91e6ceef9e$var$inspect(this, $7d0f6b91e6ceef9e$var$_objectSpread($7d0f6b91e6ceef9e$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("cIBKQ", function(module, exports) {

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $9426e159af77fd1c$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $4ZL0H.nextTick($9426e159af77fd1c$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $4ZL0H.nextTick($9426e159af77fd1c$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $4ZL0H.nextTick($9426e159af77fd1c$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $4ZL0H.nextTick($9426e159af77fd1c$var$emitErrorAndCloseNT, _this, err);
            } else $4ZL0H.nextTick($9426e159af77fd1c$var$emitCloseNT, _this);
        } else if (cb) {
            $4ZL0H.nextTick($9426e159af77fd1c$var$emitCloseNT, _this);
            cb(err);
        } else $4ZL0H.nextTick($9426e159af77fd1c$var$emitCloseNT, _this);
    });
    return this;
}
function $9426e159af77fd1c$var$emitErrorAndCloseNT(self, err) {
    $9426e159af77fd1c$var$emitErrorNT(self, err);
    $9426e159af77fd1c$var$emitCloseNT(self);
}
function $9426e159af77fd1c$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $9426e159af77fd1c$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $9426e159af77fd1c$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $9426e159af77fd1c$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $9426e159af77fd1c$var$destroy,
    undestroy: $9426e159af77fd1c$var$undestroy,
    errorOrDestroy: $9426e159af77fd1c$var$errorOrDestroy
};

});

parcelRegister("9LKRZ", function(module, exports) {
'use strict';

var $71ccdc346f30658a$var$ERR_INVALID_OPT_VALUE = (parcelRequire("akNAa")).codes.ERR_INVALID_OPT_VALUE;
function $71ccdc346f30658a$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $71ccdc346f30658a$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $71ccdc346f30658a$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $71ccdc346f30658a$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $71ccdc346f30658a$var$getHighWaterMark
};

});
parcelRegister("akNAa", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $78623ba8b47f0d8a$export$e45cb6485273080e; }, function (v) { return $78623ba8b47f0d8a$export$e45cb6485273080e = v; });
var $78623ba8b47f0d8a$export$e45cb6485273080e;
'use strict';
function $78623ba8b47f0d8a$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $78623ba8b47f0d8a$var$codes = {};
function $78623ba8b47f0d8a$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $78623ba8b47f0d8a$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $78623ba8b47f0d8a$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $78623ba8b47f0d8a$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $78623ba8b47f0d8a$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $78623ba8b47f0d8a$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $78623ba8b47f0d8a$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$78623ba8b47f0d8a$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$78623ba8b47f0d8a$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $78623ba8b47f0d8a$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($78623ba8b47f0d8a$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($78623ba8b47f0d8a$var$oneOf(expected, 'type'));
    else {
        var type = $78623ba8b47f0d8a$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($78623ba8b47f0d8a$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$78623ba8b47f0d8a$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$78623ba8b47f0d8a$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$78623ba8b47f0d8a$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$78623ba8b47f0d8a$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$78623ba8b47f0d8a$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$78623ba8b47f0d8a$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$78623ba8b47f0d8a$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$78623ba8b47f0d8a$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$78623ba8b47f0d8a$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$78623ba8b47f0d8a$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$78623ba8b47f0d8a$export$e45cb6485273080e = $78623ba8b47f0d8a$var$codes;

});


parcelRegister("6APwg", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
/*<replacement>*/ var $4cce118ae2f1e391$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $4cce118ae2f1e391$var$Duplex;

var $52Vgn = parcelRequire("52Vgn");

var $1uEw0 = parcelRequire("1uEw0");

(parcelRequire("dhT4G"))($4cce118ae2f1e391$var$Duplex, $52Vgn);
// Allow the keys array to be GC'ed.
var $4cce118ae2f1e391$var$keys = $4cce118ae2f1e391$var$objectKeys($1uEw0.prototype);
for(var $4cce118ae2f1e391$var$v = 0; $4cce118ae2f1e391$var$v < $4cce118ae2f1e391$var$keys.length; $4cce118ae2f1e391$var$v++){
    var $4cce118ae2f1e391$var$method = $4cce118ae2f1e391$var$keys[$4cce118ae2f1e391$var$v];
    if (!$4cce118ae2f1e391$var$Duplex.prototype[$4cce118ae2f1e391$var$method]) $4cce118ae2f1e391$var$Duplex.prototype[$4cce118ae2f1e391$var$method] = $1uEw0.prototype[$4cce118ae2f1e391$var$method];
}
function $4cce118ae2f1e391$var$Duplex(options) {
    if (!(this instanceof $4cce118ae2f1e391$var$Duplex)) return new $4cce118ae2f1e391$var$Duplex(options);
    $52Vgn.call(this, options);
    $1uEw0.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $4cce118ae2f1e391$var$onend);
        }
    }
}
Object.defineProperty($4cce118ae2f1e391$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($4cce118ae2f1e391$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($4cce118ae2f1e391$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $4cce118ae2f1e391$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $4ZL0H.nextTick($4cce118ae2f1e391$var$onEndNT, this);
}
function $4cce118ae2f1e391$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($4cce118ae2f1e391$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("1uEw0", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
module.exports = $1168054a9de158f4$var$Writable;
/* <replacement> */ function $1168054a9de158f4$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $1168054a9de158f4$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $1168054a9de158f4$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $1168054a9de158f4$var$Duplex;
/*</replacement>*/ $1168054a9de158f4$var$Writable.WritableState = $1168054a9de158f4$var$WritableState;

/*<replacement>*/ var $1168054a9de158f4$var$internalUtil = {
    deprecate: (parcelRequire("4SymK"))
};

var $kKRZw = parcelRequire("kKRZw");

var $bdjQ6 = parcelRequire("bdjQ6");
var $1168054a9de158f4$require$Buffer = $bdjQ6.Buffer;
var $1168054a9de158f4$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $1168054a9de158f4$var$_uint8ArrayToBuffer(chunk) {
    return $1168054a9de158f4$require$Buffer.from(chunk);
}
function $1168054a9de158f4$var$_isUint8Array(obj) {
    return $1168054a9de158f4$require$Buffer.isBuffer(obj) || obj instanceof $1168054a9de158f4$var$OurUint8Array;
}

var $cIBKQ = parcelRequire("cIBKQ");

var $9LKRZ = parcelRequire("9LKRZ");
var $1168054a9de158f4$var$getHighWaterMark = $9LKRZ.getHighWaterMark;

var $akNAa = parcelRequire("akNAa");
var $1168054a9de158f4$require$_require$codes = $akNAa.codes;
var $1168054a9de158f4$var$ERR_INVALID_ARG_TYPE = $1168054a9de158f4$require$_require$codes.ERR_INVALID_ARG_TYPE, $1168054a9de158f4$var$ERR_METHOD_NOT_IMPLEMENTED = $1168054a9de158f4$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $1168054a9de158f4$var$ERR_MULTIPLE_CALLBACK = $1168054a9de158f4$require$_require$codes.ERR_MULTIPLE_CALLBACK, $1168054a9de158f4$var$ERR_STREAM_CANNOT_PIPE = $1168054a9de158f4$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $1168054a9de158f4$var$ERR_STREAM_DESTROYED = $1168054a9de158f4$require$_require$codes.ERR_STREAM_DESTROYED, $1168054a9de158f4$var$ERR_STREAM_NULL_VALUES = $1168054a9de158f4$require$_require$codes.ERR_STREAM_NULL_VALUES, $1168054a9de158f4$var$ERR_STREAM_WRITE_AFTER_END = $1168054a9de158f4$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $1168054a9de158f4$var$ERR_UNKNOWN_ENCODING = $1168054a9de158f4$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $1168054a9de158f4$var$errorOrDestroy = $cIBKQ.errorOrDestroy;

(parcelRequire("dhT4G"))($1168054a9de158f4$var$Writable, $kKRZw);
function $1168054a9de158f4$var$nop() {}

function $1168054a9de158f4$var$WritableState(options, stream, isDuplex) {
    $1168054a9de158f4$var$Duplex = $1168054a9de158f4$var$Duplex || (parcelRequire("6APwg"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $1168054a9de158f4$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $1168054a9de158f4$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $1168054a9de158f4$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $1168054a9de158f4$var$CorkedRequest(this);
}
$1168054a9de158f4$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($1168054a9de158f4$var$WritableState.prototype, 'buffer', {
            get: $1168054a9de158f4$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $1168054a9de158f4$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $1168054a9de158f4$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($1168054a9de158f4$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($1168054a9de158f4$var$realHasInstance.call(this, object)) return true;
            if (this !== $1168054a9de158f4$var$Writable) return false;
            return object && object._writableState instanceof $1168054a9de158f4$var$WritableState;
        }
    });
} else $1168054a9de158f4$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $1168054a9de158f4$var$Writable(options) {
    $1168054a9de158f4$var$Duplex = $1168054a9de158f4$var$Duplex || (parcelRequire("6APwg"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $1168054a9de158f4$var$Duplex;
    if (!isDuplex && !$1168054a9de158f4$var$realHasInstance.call($1168054a9de158f4$var$Writable, this)) return new $1168054a9de158f4$var$Writable(options);
    this._writableState = new $1168054a9de158f4$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $kKRZw.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$1168054a9de158f4$var$Writable.prototype.pipe = function() {
    $1168054a9de158f4$var$errorOrDestroy(this, new $1168054a9de158f4$var$ERR_STREAM_CANNOT_PIPE());
};
function $1168054a9de158f4$var$writeAfterEnd(stream, cb) {
    var er = new $1168054a9de158f4$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $1168054a9de158f4$var$errorOrDestroy(stream, er);
    $4ZL0H.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $1168054a9de158f4$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $1168054a9de158f4$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $1168054a9de158f4$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $1168054a9de158f4$var$errorOrDestroy(stream, er);
        $4ZL0H.nextTick(cb, er);
        return false;
    }
    return true;
}
$1168054a9de158f4$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $1168054a9de158f4$var$_isUint8Array(chunk);
    if (isBuf && !$1168054a9de158f4$require$Buffer.isBuffer(chunk)) chunk = $1168054a9de158f4$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $1168054a9de158f4$var$nop;
    if (state.ending) $1168054a9de158f4$var$writeAfterEnd(this, cb);
    else if (isBuf || $1168054a9de158f4$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $1168054a9de158f4$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$1168054a9de158f4$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$1168054a9de158f4$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $1168054a9de158f4$var$clearBuffer(this, state);
    }
};
$1168054a9de158f4$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $1168054a9de158f4$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($1168054a9de158f4$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $1168054a9de158f4$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $1168054a9de158f4$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($1168054a9de158f4$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $1168054a9de158f4$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $1168054a9de158f4$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $1168054a9de158f4$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $1168054a9de158f4$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $1168054a9de158f4$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $1168054a9de158f4$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $4ZL0H.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $4ZL0H.nextTick($1168054a9de158f4$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $1168054a9de158f4$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $1168054a9de158f4$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $1168054a9de158f4$var$finishMaybe(stream, state);
    }
}
function $1168054a9de158f4$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $1168054a9de158f4$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $1168054a9de158f4$var$ERR_MULTIPLE_CALLBACK();
    $1168054a9de158f4$var$onwriteStateUpdate(state);
    if (er) $1168054a9de158f4$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $1168054a9de158f4$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $1168054a9de158f4$var$clearBuffer(stream, state);
        if (sync) $4ZL0H.nextTick($1168054a9de158f4$var$afterWrite, stream, state, finished, cb);
        else $1168054a9de158f4$var$afterWrite(stream, state, finished, cb);
    }
}
function $1168054a9de158f4$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $1168054a9de158f4$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $1168054a9de158f4$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $1168054a9de158f4$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $1168054a9de158f4$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $1168054a9de158f4$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $1168054a9de158f4$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $1168054a9de158f4$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$1168054a9de158f4$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $1168054a9de158f4$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$1168054a9de158f4$var$Writable.prototype._writev = null;
$1168054a9de158f4$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $1168054a9de158f4$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($1168054a9de158f4$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $1168054a9de158f4$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $1168054a9de158f4$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $1168054a9de158f4$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $1168054a9de158f4$var$finishMaybe(stream, state);
    });
}
function $1168054a9de158f4$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $4ZL0H.nextTick($1168054a9de158f4$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $1168054a9de158f4$var$finishMaybe(stream, state) {
    var need = $1168054a9de158f4$var$needFinish(state);
    if (need) {
        $1168054a9de158f4$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $1168054a9de158f4$var$endWritable(stream, state, cb) {
    state.ending = true;
    $1168054a9de158f4$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $4ZL0H.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $1168054a9de158f4$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($1168054a9de158f4$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$1168054a9de158f4$var$Writable.prototype.destroy = $cIBKQ.destroy;
$1168054a9de158f4$var$Writable.prototype._undestroy = $cIBKQ.undestroy;
$1168054a9de158f4$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("4SymK", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $38d6dce7fbf76fcf$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $38d6dce7fbf76fcf$var$deprecate(fn, msg) {
    if ($38d6dce7fbf76fcf$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($38d6dce7fbf76fcf$var$config('throwDeprecation')) throw new Error(msg);
            else if ($38d6dce7fbf76fcf$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $38d6dce7fbf76fcf$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("iGJyf", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $d9af7bc5baf161c1$export$63a7aa211a91ed69; }, function (v) { return $d9af7bc5baf161c1$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $d9af7bc5baf161c1$export$63a7aa211a91ed69;
'use strict';

var $838j1 = parcelRequire("838j1");
var $d9af7bc5baf161c1$require$Buffer = $838j1.Buffer;
/*</replacement>*/ var $d9af7bc5baf161c1$var$isEncoding = $d9af7bc5baf161c1$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $d9af7bc5baf161c1$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $d9af7bc5baf161c1$var$normalizeEncoding(enc) {
    var nenc = $d9af7bc5baf161c1$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($d9af7bc5baf161c1$require$Buffer.isEncoding === $d9af7bc5baf161c1$var$isEncoding || !$d9af7bc5baf161c1$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$d9af7bc5baf161c1$export$63a7aa211a91ed69 = $d9af7bc5baf161c1$var$StringDecoder;
function $d9af7bc5baf161c1$var$StringDecoder(encoding) {
    this.encoding = $d9af7bc5baf161c1$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $d9af7bc5baf161c1$var$utf16Text;
            this.end = $d9af7bc5baf161c1$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $d9af7bc5baf161c1$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $d9af7bc5baf161c1$var$base64Text;
            this.end = $d9af7bc5baf161c1$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $d9af7bc5baf161c1$var$simpleWrite;
            this.end = $d9af7bc5baf161c1$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $d9af7bc5baf161c1$require$Buffer.allocUnsafe(nb);
}
$d9af7bc5baf161c1$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$d9af7bc5baf161c1$var$StringDecoder.prototype.end = $d9af7bc5baf161c1$var$utf8End;
// Returns only complete characters in a Buffer
$d9af7bc5baf161c1$var$StringDecoder.prototype.text = $d9af7bc5baf161c1$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$d9af7bc5baf161c1$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $d9af7bc5baf161c1$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $d9af7bc5baf161c1$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $d9af7bc5baf161c1$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $d9af7bc5baf161c1$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $d9af7bc5baf161c1$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $d9af7bc5baf161c1$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $d9af7bc5baf161c1$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $d9af7bc5baf161c1$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $d9af7bc5baf161c1$var$utf8Text(buf, i) {
    var total = $d9af7bc5baf161c1$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $d9af7bc5baf161c1$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $d9af7bc5baf161c1$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $d9af7bc5baf161c1$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $d9af7bc5baf161c1$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $d9af7bc5baf161c1$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $d9af7bc5baf161c1$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $d9af7bc5baf161c1$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("84GJs", function(module, exports) {

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
var $5e0fd82fa820676f$var$_Object$setPrototypeO;
function $5e0fd82fa820676f$var$_defineProperty(obj, key, value) {
    key = $5e0fd82fa820676f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5e0fd82fa820676f$var$_toPropertyKey(arg) {
    var key = $5e0fd82fa820676f$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $5e0fd82fa820676f$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $faWKl = parcelRequire("faWKl");
var $5e0fd82fa820676f$var$kLastResolve = Symbol('lastResolve');
var $5e0fd82fa820676f$var$kLastReject = Symbol('lastReject');
var $5e0fd82fa820676f$var$kError = Symbol('error');
var $5e0fd82fa820676f$var$kEnded = Symbol('ended');
var $5e0fd82fa820676f$var$kLastPromise = Symbol('lastPromise');
var $5e0fd82fa820676f$var$kHandlePromise = Symbol('handlePromise');
var $5e0fd82fa820676f$var$kStream = Symbol('stream');
function $5e0fd82fa820676f$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $5e0fd82fa820676f$var$readAndResolve(iter) {
    var resolve = iter[$5e0fd82fa820676f$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$5e0fd82fa820676f$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$5e0fd82fa820676f$var$kLastPromise] = null;
            iter[$5e0fd82fa820676f$var$kLastResolve] = null;
            iter[$5e0fd82fa820676f$var$kLastReject] = null;
            resolve($5e0fd82fa820676f$var$createIterResult(data, false));
        }
    }
}
function $5e0fd82fa820676f$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $4ZL0H.nextTick($5e0fd82fa820676f$var$readAndResolve, iter);
}
function $5e0fd82fa820676f$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$5e0fd82fa820676f$var$kEnded]) {
                resolve($5e0fd82fa820676f$var$createIterResult(undefined, true));
                return;
            }
            iter[$5e0fd82fa820676f$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $5e0fd82fa820676f$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $5e0fd82fa820676f$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($5e0fd82fa820676f$var$_Object$setPrototypeO = {
    get stream () {
        return this[$5e0fd82fa820676f$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$5e0fd82fa820676f$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$5e0fd82fa820676f$var$kEnded]) return Promise.resolve($5e0fd82fa820676f$var$createIterResult(undefined, true));
        if (this[$5e0fd82fa820676f$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $4ZL0H.nextTick(function() {
                if (_this[$5e0fd82fa820676f$var$kError]) reject(_this[$5e0fd82fa820676f$var$kError]);
                else resolve($5e0fd82fa820676f$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$5e0fd82fa820676f$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($5e0fd82fa820676f$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$5e0fd82fa820676f$var$kStream].read();
            if (data !== null) return Promise.resolve($5e0fd82fa820676f$var$createIterResult(data, false));
            promise = new Promise(this[$5e0fd82fa820676f$var$kHandlePromise]);
        }
        this[$5e0fd82fa820676f$var$kLastPromise] = promise;
        return promise;
    }
}, $5e0fd82fa820676f$var$_defineProperty($5e0fd82fa820676f$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $5e0fd82fa820676f$var$_defineProperty($5e0fd82fa820676f$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$5e0fd82fa820676f$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($5e0fd82fa820676f$var$createIterResult(undefined, true));
        });
    });
}), $5e0fd82fa820676f$var$_Object$setPrototypeO), $5e0fd82fa820676f$var$AsyncIteratorPrototype);
var $5e0fd82fa820676f$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($5e0fd82fa820676f$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $5e0fd82fa820676f$var$_defineProperty(_Object$create, $5e0fd82fa820676f$var$kStream, {
        value: stream,
        writable: true
    }), $5e0fd82fa820676f$var$_defineProperty(_Object$create, $5e0fd82fa820676f$var$kLastResolve, {
        value: null,
        writable: true
    }), $5e0fd82fa820676f$var$_defineProperty(_Object$create, $5e0fd82fa820676f$var$kLastReject, {
        value: null,
        writable: true
    }), $5e0fd82fa820676f$var$_defineProperty(_Object$create, $5e0fd82fa820676f$var$kError, {
        value: null,
        writable: true
    }), $5e0fd82fa820676f$var$_defineProperty(_Object$create, $5e0fd82fa820676f$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $5e0fd82fa820676f$var$_defineProperty(_Object$create, $5e0fd82fa820676f$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$5e0fd82fa820676f$var$kStream].read();
            if (data) {
                iterator[$5e0fd82fa820676f$var$kLastPromise] = null;
                iterator[$5e0fd82fa820676f$var$kLastResolve] = null;
                iterator[$5e0fd82fa820676f$var$kLastReject] = null;
                resolve($5e0fd82fa820676f$var$createIterResult(data, false));
            } else {
                iterator[$5e0fd82fa820676f$var$kLastResolve] = resolve;
                iterator[$5e0fd82fa820676f$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$5e0fd82fa820676f$var$kLastPromise] = null;
    $faWKl(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$5e0fd82fa820676f$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$5e0fd82fa820676f$var$kLastPromise] = null;
                iterator[$5e0fd82fa820676f$var$kLastResolve] = null;
                iterator[$5e0fd82fa820676f$var$kLastReject] = null;
                reject(err);
            }
            iterator[$5e0fd82fa820676f$var$kError] = err;
            return;
        }
        var resolve = iterator[$5e0fd82fa820676f$var$kLastResolve];
        if (resolve !== null) {
            iterator[$5e0fd82fa820676f$var$kLastPromise] = null;
            iterator[$5e0fd82fa820676f$var$kLastResolve] = null;
            iterator[$5e0fd82fa820676f$var$kLastReject] = null;
            resolve($5e0fd82fa820676f$var$createIterResult(undefined, true));
        }
        iterator[$5e0fd82fa820676f$var$kEnded] = true;
    });
    stream.on('readable', $5e0fd82fa820676f$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $5e0fd82fa820676f$var$createReadableStreamAsyncIterator;

});
parcelRegister("faWKl", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $b0c55c009ac329cf$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("akNAa")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $b0c55c009ac329cf$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $b0c55c009ac329cf$var$noop() {}
function $b0c55c009ac329cf$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $b0c55c009ac329cf$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $b0c55c009ac329cf$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $b0c55c009ac329cf$var$once(callback || $b0c55c009ac329cf$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $b0c55c009ac329cf$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $b0c55c009ac329cf$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($b0c55c009ac329cf$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $b0c55c009ac329cf$var$eos;

});


parcelRegister("dp7AE", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("6H0L1", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $4df758a4af864665$var$Transform;

var $akNAa = parcelRequire("akNAa");
var $4df758a4af864665$require$_require$codes = $akNAa.codes;
var $4df758a4af864665$var$ERR_METHOD_NOT_IMPLEMENTED = $4df758a4af864665$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $4df758a4af864665$var$ERR_MULTIPLE_CALLBACK = $4df758a4af864665$require$_require$codes.ERR_MULTIPLE_CALLBACK, $4df758a4af864665$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $4df758a4af864665$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $4df758a4af864665$var$ERR_TRANSFORM_WITH_LENGTH_0 = $4df758a4af864665$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $6APwg = parcelRequire("6APwg");

(parcelRequire("dhT4G"))($4df758a4af864665$var$Transform, $6APwg);
function $4df758a4af864665$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $4df758a4af864665$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $4df758a4af864665$var$Transform(options) {
    if (!(this instanceof $4df758a4af864665$var$Transform)) return new $4df758a4af864665$var$Transform(options);
    $6APwg.call(this, options);
    this._transformState = {
        afterTransform: $4df758a4af864665$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $4df758a4af864665$var$prefinish);
}
function $4df758a4af864665$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $4df758a4af864665$var$done(_this, er, data);
    });
    else $4df758a4af864665$var$done(this, null, null);
}
$4df758a4af864665$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $6APwg.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$4df758a4af864665$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $4df758a4af864665$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$4df758a4af864665$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$4df758a4af864665$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$4df758a4af864665$var$Transform.prototype._destroy = function(err, cb) {
    $6APwg.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $4df758a4af864665$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $4df758a4af864665$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $4df758a4af864665$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("e2OS0", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $a398b6599795cfb9$var$PassThrough;

var $6H0L1 = parcelRequire("6H0L1");

(parcelRequire("dhT4G"))($a398b6599795cfb9$var$PassThrough, $6H0L1);
function $a398b6599795cfb9$var$PassThrough(options) {
    if (!(this instanceof $a398b6599795cfb9$var$PassThrough)) return new $a398b6599795cfb9$var$PassThrough(options);
    $6H0L1.call(this, options);
}
$a398b6599795cfb9$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("9Mw7i", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $71f18271492cbec4$var$eos;
function $71f18271492cbec4$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $akNAa = parcelRequire("akNAa");
var $71f18271492cbec4$require$_require$codes = $akNAa.codes;
var $71f18271492cbec4$var$ERR_MISSING_ARGS = $71f18271492cbec4$require$_require$codes.ERR_MISSING_ARGS, $71f18271492cbec4$var$ERR_STREAM_DESTROYED = $71f18271492cbec4$require$_require$codes.ERR_STREAM_DESTROYED;
function $71f18271492cbec4$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $71f18271492cbec4$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $71f18271492cbec4$var$destroyer(stream, reading, writing, callback) {
    callback = $71f18271492cbec4$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($71f18271492cbec4$var$eos === undefined) $71f18271492cbec4$var$eos = (parcelRequire("faWKl"));
    $71f18271492cbec4$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($71f18271492cbec4$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $71f18271492cbec4$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $71f18271492cbec4$var$call(fn) {
    fn();
}
function $71f18271492cbec4$var$pipe(from, to) {
    return from.pipe(to);
}
function $71f18271492cbec4$var$popCallback(streams) {
    if (!streams.length) return $71f18271492cbec4$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $71f18271492cbec4$var$noop;
    return streams.pop();
}
function $71f18271492cbec4$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $71f18271492cbec4$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $71f18271492cbec4$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $71f18271492cbec4$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($71f18271492cbec4$var$call);
            if (reading) return;
            destroys.forEach($71f18271492cbec4$var$call);
            callback(error);
        });
    });
    return streams.reduce($71f18271492cbec4$var$pipe);
}
module.exports = $71f18271492cbec4$var$pipeline;

});




parcelRegister("1Jsb3", function(module, exports) {
'use strict';

var $bdjQ6 = parcelRequire("bdjQ6");
var $142fd9dc489aa108$require$Buffer = $bdjQ6.Buffer;

var $dhT4G = parcelRequire("dhT4G");

var $lV0fd = parcelRequire("lV0fd");
var $142fd9dc489aa108$var$ARRAY16 = new Array(16);
var $142fd9dc489aa108$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $142fd9dc489aa108$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $142fd9dc489aa108$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $142fd9dc489aa108$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $142fd9dc489aa108$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $142fd9dc489aa108$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $142fd9dc489aa108$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $142fd9dc489aa108$var$fn1(a, b, c, d, e, m, k, s) {
    return $142fd9dc489aa108$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $142fd9dc489aa108$var$fn2(a, b, c, d, e, m, k, s) {
    return $142fd9dc489aa108$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $142fd9dc489aa108$var$fn3(a, b, c, d, e, m, k, s) {
    return $142fd9dc489aa108$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $142fd9dc489aa108$var$fn4(a, b, c, d, e, m, k, s) {
    return $142fd9dc489aa108$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $142fd9dc489aa108$var$fn5(a, b, c, d, e, m, k, s) {
    return $142fd9dc489aa108$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
function $142fd9dc489aa108$var$RIPEMD160() {
    $lV0fd.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$dhT4G($142fd9dc489aa108$var$RIPEMD160, $lV0fd);
$142fd9dc489aa108$var$RIPEMD160.prototype._update = function() {
    var words = $142fd9dc489aa108$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $142fd9dc489aa108$var$fn1(al, bl, cl, dl, el, words[$142fd9dc489aa108$var$zl[i]], $142fd9dc489aa108$var$hl[0], $142fd9dc489aa108$var$sl[i]);
            tr = $142fd9dc489aa108$var$fn5(ar, br, cr, dr, er, words[$142fd9dc489aa108$var$zr[i]], $142fd9dc489aa108$var$hr[0], $142fd9dc489aa108$var$sr[i]);
        } else if (i < 32) {
            tl = $142fd9dc489aa108$var$fn2(al, bl, cl, dl, el, words[$142fd9dc489aa108$var$zl[i]], $142fd9dc489aa108$var$hl[1], $142fd9dc489aa108$var$sl[i]);
            tr = $142fd9dc489aa108$var$fn4(ar, br, cr, dr, er, words[$142fd9dc489aa108$var$zr[i]], $142fd9dc489aa108$var$hr[1], $142fd9dc489aa108$var$sr[i]);
        } else if (i < 48) {
            tl = $142fd9dc489aa108$var$fn3(al, bl, cl, dl, el, words[$142fd9dc489aa108$var$zl[i]], $142fd9dc489aa108$var$hl[2], $142fd9dc489aa108$var$sl[i]);
            tr = $142fd9dc489aa108$var$fn3(ar, br, cr, dr, er, words[$142fd9dc489aa108$var$zr[i]], $142fd9dc489aa108$var$hr[2], $142fd9dc489aa108$var$sr[i]);
        } else if (i < 64) {
            tl = $142fd9dc489aa108$var$fn4(al, bl, cl, dl, el, words[$142fd9dc489aa108$var$zl[i]], $142fd9dc489aa108$var$hl[3], $142fd9dc489aa108$var$sl[i]);
            tr = $142fd9dc489aa108$var$fn2(ar, br, cr, dr, er, words[$142fd9dc489aa108$var$zr[i]], $142fd9dc489aa108$var$hr[3], $142fd9dc489aa108$var$sr[i]);
        } else {
            tl = $142fd9dc489aa108$var$fn5(al, bl, cl, dl, el, words[$142fd9dc489aa108$var$zl[i]], $142fd9dc489aa108$var$hl[4], $142fd9dc489aa108$var$sl[i]);
            tr = $142fd9dc489aa108$var$fn1(ar, br, cr, dr, er, words[$142fd9dc489aa108$var$zr[i]], $142fd9dc489aa108$var$hr[4], $142fd9dc489aa108$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $142fd9dc489aa108$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $142fd9dc489aa108$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$142fd9dc489aa108$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset] = 0x80;
    this._blockOffset += 1;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $142fd9dc489aa108$require$Buffer.alloc ? $142fd9dc489aa108$require$Buffer.alloc(20) : new $142fd9dc489aa108$require$Buffer(20); // eslint-disable-line no-buffer-constructor
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
module.exports = $142fd9dc489aa108$var$RIPEMD160;

});
parcelRegister("lV0fd", function(module, exports) {
'use strict';

var $838j1 = parcelRequire("838j1");
var $ff4f1c6668d95823$require$Buffer = $838j1.Buffer;

var $a9qQG = parcelRequire("a9qQG");

var $dFZZW = parcelRequire("dFZZW");
var $ff4f1c6668d95823$require$Transform = $dFZZW.Transform;

var $dhT4G = parcelRequire("dhT4G");
function $ff4f1c6668d95823$var$HashBase(blockSize) {
    $ff4f1c6668d95823$require$Transform.call(this);
    this._block = $ff4f1c6668d95823$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dhT4G($ff4f1c6668d95823$var$HashBase, $ff4f1c6668d95823$require$Transform);
$ff4f1c6668d95823$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$ff4f1c6668d95823$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$ff4f1c6668d95823$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    var dataBuffer = $a9qQG(data, encoding); // asserts correct input type
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + dataBuffer.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;){
            block[i] = dataBuffer[offset];
            i += 1;
            offset += 1;
        }
        this._update();
        this._blockOffset = 0;
    }
    while(offset < dataBuffer.length){
        block[this._blockOffset] = dataBuffer[offset];
        this._blockOffset += 1;
        offset += 1;
    }
    // update length
    for(var j = 0, carry = dataBuffer.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$ff4f1c6668d95823$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$ff4f1c6668d95823$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$ff4f1c6668d95823$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $ff4f1c6668d95823$var$HashBase;

});
parcelRegister("a9qQG", function(module, exports) {
'use strict';

var $838j1 = parcelRequire("838j1");
var $763f923ff3649c26$require$Buffer = $838j1.Buffer;

var $iDFZs = parcelRequire("iDFZs");
var $763f923ff3649c26$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $763f923ff3649c26$var$useArrayBuffer = $763f923ff3649c26$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $763f923ff3649c26$var$isView = $763f923ff3649c26$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding) {
    if (typeof thing === 'string' || $763f923ff3649c26$require$Buffer.isBuffer(thing) || $763f923ff3649c26$var$useUint8Array && thing instanceof Uint8Array || $763f923ff3649c26$var$isView && $763f923ff3649c26$var$isView(thing)) return $iDFZs(thing, encoding);
    throw new TypeError('The "data" argument must be a string, a Buffer, a Uint8Array, or a DataView');
};

});
parcelRegister("iDFZs", function(module, exports) {
'use strict';

var $838j1 = parcelRequire("838j1");
var $d91c70e90d0fdaa9$require$Buffer = $838j1.Buffer;

var $58ZcN = parcelRequire("58ZcN");

var $awmI8 = parcelRequire("awmI8");
var $d91c70e90d0fdaa9$var$isView = ArrayBuffer.isView || function isView(obj) {
    try {
        $awmI8(obj);
        return true;
    } catch (e) {
        return false;
    }
};
var $d91c70e90d0fdaa9$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $d91c70e90d0fdaa9$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined';
var $d91c70e90d0fdaa9$var$useFromArrayBuffer = $d91c70e90d0fdaa9$var$useArrayBuffer && ($d91c70e90d0fdaa9$require$Buffer.prototype instanceof Uint8Array || $d91c70e90d0fdaa9$require$Buffer.TYPED_ARRAY_SUPPORT);
module.exports = function toBuffer(data, encoding) {
    if ($d91c70e90d0fdaa9$require$Buffer.isBuffer(data)) {
        if (data.constructor && !('isBuffer' in data)) // probably a SlowBuffer
        return $d91c70e90d0fdaa9$require$Buffer.from(data);
        return data;
    }
    if (typeof data === 'string') return $d91c70e90d0fdaa9$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($d91c70e90d0fdaa9$var$useArrayBuffer && $d91c70e90d0fdaa9$var$isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $d91c70e90d0fdaa9$require$Buffer.alloc(0);
        // When Buffer is based on Uint8Array, we can just construct it from ArrayBuffer
        if ($d91c70e90d0fdaa9$var$useFromArrayBuffer) {
            var res = $d91c70e90d0fdaa9$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
            /*
			 * Recheck result size, as offset/length doesn't work on Node.js <5.10
			 * We just go to Uint8Array case if this fails
			 */ if (res.byteLength === data.byteLength) return res;
        }
        // Convert to Uint8Array bytes and then to Buffer
        var uint8 = data instanceof Uint8Array ? data : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
        var result = $d91c70e90d0fdaa9$require$Buffer.from(uint8);
        /*
		 * Let's recheck that conversion succeeded
		 * We have .length but not .byteLength when useFromArrayBuffer is false
		 */ if (result.length === data.byteLength) return result;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($d91c70e90d0fdaa9$var$useUint8Array && data instanceof Uint8Array) return $d91c70e90d0fdaa9$require$Buffer.from(data);
    var isArr = $58ZcN(data);
    if (isArr) for(var i = 0; i < data.length; i += 1){
        var x = data[i];
        if (typeof x !== 'number' || x < 0 || x > 255 || ~~x !== x // NaN and integer check
        ) throw new RangeError('Array items must be numbers in the range 0-255.');
    }
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if (isArr || $d91c70e90d0fdaa9$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $d91c70e90d0fdaa9$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
};

});
parcelRegister("58ZcN", function(module, exports) {
var $3bed2d3a94d62fc0$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $3bed2d3a94d62fc0$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("awmI8", function(module, exports) {
'use strict';

var $5Xz8R = parcelRequire("5Xz8R");

var $eC3A3 = parcelRequire("eC3A3");
/** @type {undefined | ((thisArg: import('.').TypedArray) => Buffer<ArrayBufferLike>)} */ var $7a8e8270e20ed7b6$var$$typedArrayBuffer = $eC3A3('TypedArray.prototype.buffer', true);

var $3v1VX = parcelRequire("3v1VX");
/** @type {import('.')} */ // node <= 0.10, < 0.11.4 has a nonconfigurable own property instead of a prototype getter
module.exports = $7a8e8270e20ed7b6$var$$typedArrayBuffer || function typedArrayBuffer(x) {
    if (!$3v1VX(x)) throw new $5Xz8R('Not a Typed Array');
    return x.buffer;
};

});
parcelRegister("5Xz8R", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("eC3A3", function(module, exports) {
'use strict';

var $hkNzn = parcelRequire("hkNzn");

var $593ev = parcelRequire("593ev");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $aa3764525413497a$var$$indexOf = $593ev([
    $hkNzn('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $hkNzn(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $aa3764525413497a$var$$indexOf(name, '.prototype.') > -1) return $593ev(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("hkNzn", function(module, exports) {
'use strict';
var $c9eac16840c8f75d$var$undefined1;

var $aEzGq = parcelRequire("aEzGq");

var $6xoeI = parcelRequire("6xoeI");

var $SKRnU = parcelRequire("SKRnU");

var $6iFy7 = parcelRequire("6iFy7");

var $j0Ert = parcelRequire("j0Ert");

var $bw8YX = parcelRequire("bw8YX");

var $5Xz8R = parcelRequire("5Xz8R");

var $62IVw = parcelRequire("62IVw");

var $iuXCA = parcelRequire("iuXCA");

var $57uf1 = parcelRequire("57uf1");

var $8KJjU = parcelRequire("8KJjU");

var $cmoNf = parcelRequire("cmoNf");

var $eaKh2 = parcelRequire("eaKh2");

var $13WPP = parcelRequire("13WPP");

var $g26DA = parcelRequire("g26DA");
var $c9eac16840c8f75d$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $c9eac16840c8f75d$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $c9eac16840c8f75d$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $gNKV7 = parcelRequire("gNKV7");

var $bKXTU = parcelRequire("bKXTU");
var $c9eac16840c8f75d$var$throwTypeError = function() {
    throw new $5Xz8R();
};
var $c9eac16840c8f75d$var$ThrowTypeError = $gNKV7 ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $c9eac16840c8f75d$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $gNKV7(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $c9eac16840c8f75d$var$throwTypeError;
        }
    }
}() : $c9eac16840c8f75d$var$throwTypeError;

var $c9eac16840c8f75d$var$hasSymbols = (parcelRequire("4qQ7b"))();

var $b7uaR = parcelRequire("b7uaR");

var $4kTCn = parcelRequire("4kTCn");

var $1Gomj = parcelRequire("1Gomj");

var $aYzei = parcelRequire("aYzei");

var $bSEx1 = parcelRequire("bSEx1");
var $c9eac16840c8f75d$var$needsEval = {};
var $c9eac16840c8f75d$var$TypedArray = typeof Uint8Array === 'undefined' || !$b7uaR ? undefined : $b7uaR(Uint8Array);
var $c9eac16840c8f75d$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $c9eac16840c8f75d$var$hasSymbols && $b7uaR ? $b7uaR([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $c9eac16840c8f75d$var$needsEval,
    '%AsyncGenerator%': $c9eac16840c8f75d$var$needsEval,
    '%AsyncGeneratorFunction%': $c9eac16840c8f75d$var$needsEval,
    '%AsyncIteratorPrototype%': $c9eac16840c8f75d$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $6xoeI,
    '%eval%': eval,
    '%EvalError%': $SKRnU,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $c9eac16840c8f75d$var$$Function,
    '%GeneratorFunction%': $c9eac16840c8f75d$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $c9eac16840c8f75d$var$hasSymbols && $b7uaR ? $b7uaR($b7uaR([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$c9eac16840c8f75d$var$hasSymbols || !$b7uaR ? undefined : $b7uaR(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $aEzGq,
    '%Object.getOwnPropertyDescriptor%': $gNKV7,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $6iFy7,
    '%ReferenceError%': $j0Ert,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$c9eac16840c8f75d$var$hasSymbols || !$b7uaR ? undefined : $b7uaR(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $c9eac16840c8f75d$var$hasSymbols && $b7uaR ? $b7uaR(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $c9eac16840c8f75d$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $bw8YX,
    '%ThrowTypeError%': $c9eac16840c8f75d$var$ThrowTypeError,
    '%TypedArray%': $c9eac16840c8f75d$var$TypedArray,
    '%TypeError%': $5Xz8R,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $62IVw,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $bSEx1,
    '%Function.prototype.apply%': $aYzei,
    '%Object.defineProperty%': $bKXTU,
    '%Object.getPrototypeOf%': $4kTCn,
    '%Math.abs%': $iuXCA,
    '%Math.floor%': $57uf1,
    '%Math.max%': $8KJjU,
    '%Math.min%': $cmoNf,
    '%Math.pow%': $eaKh2,
    '%Math.round%': $13WPP,
    '%Math.sign%': $g26DA,
    '%Reflect.getPrototypeOf%': $1Gomj
};
if ($b7uaR) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $c9eac16840c8f75d$var$errorProto = $b7uaR($b7uaR(e));
    $c9eac16840c8f75d$var$INTRINSICS['%Error.prototype%'] = $c9eac16840c8f75d$var$errorProto;
}
var $c9eac16840c8f75d$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $c9eac16840c8f75d$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $c9eac16840c8f75d$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $c9eac16840c8f75d$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $b7uaR) value = $b7uaR(gen.prototype);
    }
    $c9eac16840c8f75d$var$INTRINSICS[name] = value;
    return value;
};
var $c9eac16840c8f75d$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $eQ7C3 = parcelRequire("eQ7C3");

var $8byr2 = parcelRequire("8byr2");
var $c9eac16840c8f75d$var$$concat = $eQ7C3.call($bSEx1, Array.prototype.concat);
var $c9eac16840c8f75d$var$$spliceApply = $eQ7C3.call($aYzei, Array.prototype.splice);
var $c9eac16840c8f75d$var$$replace = $eQ7C3.call($bSEx1, String.prototype.replace);
var $c9eac16840c8f75d$var$$strSlice = $eQ7C3.call($bSEx1, String.prototype.slice);
var $c9eac16840c8f75d$var$$exec = $eQ7C3.call($bSEx1, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $c9eac16840c8f75d$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $c9eac16840c8f75d$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $c9eac16840c8f75d$var$stringToPath = function stringToPath(string) {
    var first = $c9eac16840c8f75d$var$$strSlice(string, 0, 1);
    var last = $c9eac16840c8f75d$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $bw8YX('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $bw8YX('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $c9eac16840c8f75d$var$$replace(string, $c9eac16840c8f75d$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $c9eac16840c8f75d$var$$replace(subString, $c9eac16840c8f75d$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $c9eac16840c8f75d$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($8byr2($c9eac16840c8f75d$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $c9eac16840c8f75d$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($8byr2($c9eac16840c8f75d$var$INTRINSICS, intrinsicName)) {
        var value = $c9eac16840c8f75d$var$INTRINSICS[intrinsicName];
        if (value === $c9eac16840c8f75d$var$needsEval) value = $c9eac16840c8f75d$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $5Xz8R('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $bw8YX('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $5Xz8R('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $5Xz8R('"allowMissing" argument must be a boolean');
    if ($c9eac16840c8f75d$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $bw8YX('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $c9eac16840c8f75d$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $c9eac16840c8f75d$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $c9eac16840c8f75d$var$$spliceApply(parts, $c9eac16840c8f75d$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $c9eac16840c8f75d$var$$strSlice(part, 0, 1);
        var last = $c9eac16840c8f75d$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $bw8YX('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($8byr2($c9eac16840c8f75d$var$INTRINSICS, intrinsicRealName)) value = $c9eac16840c8f75d$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $5Xz8R('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($gNKV7 && i + 1 >= parts.length) {
                var desc = $gNKV7(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $8byr2(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $c9eac16840c8f75d$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("aEzGq", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("6xoeI", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("SKRnU", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("6iFy7", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("j0Ert", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("bw8YX", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("62IVw", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("iuXCA", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("57uf1", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("8KJjU", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("cmoNf", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("eaKh2", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("13WPP", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("g26DA", function(module, exports) {
'use strict';

var $8hbPu = parcelRequire("8hbPu");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($8hbPu(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("8hbPu", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("gNKV7", function(module, exports) {
'use strict';

var $87tme = parcelRequire("87tme");
var $c3b59e512f612c17$require$$gOPD = $87tme;
if ($c3b59e512f612c17$require$$gOPD) try {
    $c3b59e512f612c17$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $c3b59e512f612c17$require$$gOPD = null;
}
module.exports = $c3b59e512f612c17$require$$gOPD;

});
parcelRegister("87tme", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("bKXTU", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $88f2749ea03868eb$var$$defineProperty = Object.defineProperty || false;
if ($88f2749ea03868eb$var$$defineProperty) try {
    $88f2749ea03868eb$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $88f2749ea03868eb$var$$defineProperty = false;
}
module.exports = $88f2749ea03868eb$var$$defineProperty;

});

parcelRegister("4qQ7b", function(module, exports) {
'use strict';
var $33a204135f6b8445$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $f2BFz = parcelRequire("f2BFz");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $33a204135f6b8445$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $33a204135f6b8445$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $f2BFz();
};

});
parcelRegister("f2BFz", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("b7uaR", function(module, exports) {
'use strict';

var $1Gomj = parcelRequire("1Gomj");

var $4kTCn = parcelRequire("4kTCn");

var $2mxVo = parcelRequire("2mxVo");
/** @type {import('.')} */ module.exports = $1Gomj ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $1Gomj(O);
} : $4kTCn ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $4kTCn(O);
} : $2mxVo ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $2mxVo(O);
} : null;

});
parcelRegister("1Gomj", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("4kTCn", function(module, exports) {
'use strict';

var $aEzGq = parcelRequire("aEzGq");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $aEzGq.getPrototypeOf || null;

});

parcelRegister("2mxVo", function(module, exports) {
'use strict';

var $593ev = parcelRequire("593ev");

var $gNKV7 = parcelRequire("gNKV7");
var $1b87f3939656d8ea$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $1b87f3939656d8ea$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $1b87f3939656d8ea$var$desc = !!$1b87f3939656d8ea$var$hasProtoAccessor && $gNKV7 && $gNKV7(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $1b87f3939656d8ea$var$$Object = Object;
var $1b87f3939656d8ea$var$$getPrototypeOf = $1b87f3939656d8ea$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $1b87f3939656d8ea$var$desc && typeof $1b87f3939656d8ea$var$desc.get === 'function' ? $593ev([
    $1b87f3939656d8ea$var$desc.get
]) : typeof $1b87f3939656d8ea$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $1b87f3939656d8ea$var$$getPrototypeOf(value == null ? value : $1b87f3939656d8ea$var$$Object(value));
} : false;

});
parcelRegister("593ev", function(module, exports) {
'use strict';

var $eQ7C3 = parcelRequire("eQ7C3");

var $5Xz8R = parcelRequire("5Xz8R");

var $bSEx1 = parcelRequire("bSEx1");

var $04tsO = parcelRequire("04tsO");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $5Xz8R('a function is required');
    return $04tsO($eQ7C3, $bSEx1, args);
};

});
parcelRegister("eQ7C3", function(module, exports) {
'use strict';

var $gfKZG = parcelRequire("gfKZG");
module.exports = Function.prototype.bind || $gfKZG;

});
parcelRegister("gfKZG", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $bd52800b6fae4c57$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $bd52800b6fae4c57$var$toStr = Object.prototype.toString;
var $bd52800b6fae4c57$var$max = Math.max;
var $bd52800b6fae4c57$var$funcType = '[object Function]';
var $bd52800b6fae4c57$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $bd52800b6fae4c57$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $bd52800b6fae4c57$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $bd52800b6fae4c57$var$toStr.apply(target) !== $bd52800b6fae4c57$var$funcType) throw new TypeError($bd52800b6fae4c57$var$ERROR_MESSAGE + target);
    var args = $bd52800b6fae4c57$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $bd52800b6fae4c57$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $bd52800b6fae4c57$var$concatty(args, arguments));
    };
    var boundLength = $bd52800b6fae4c57$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $bd52800b6fae4c57$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("bSEx1", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("04tsO", function(module, exports) {
'use strict';

var $eQ7C3 = parcelRequire("eQ7C3");

var $aYzei = parcelRequire("aYzei");

var $bSEx1 = parcelRequire("bSEx1");

var $fYjQh = parcelRequire("fYjQh");
/** @type {import('./actualApply')} */ module.exports = $fYjQh || $eQ7C3.call($bSEx1, $aYzei);

});
parcelRegister("aYzei", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("fYjQh", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("8byr2", function(module, exports) {
'use strict';
var $5f5a0fe320c1ef2a$var$call = Function.prototype.call;
var $5f5a0fe320c1ef2a$var$$hasOwn = Object.prototype.hasOwnProperty;

var $eQ7C3 = parcelRequire("eQ7C3");
/** @type {import('.')} */ module.exports = $eQ7C3.call($5f5a0fe320c1ef2a$var$call, $5f5a0fe320c1ef2a$var$$hasOwn);

});



parcelRegister("3v1VX", function(module, exports) {
'use strict';

var $3y8Uz = parcelRequire("3y8Uz");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$3y8Uz(value);
};

});
parcelRegister("3y8Uz", function(module, exports) {
'use strict';

var $4t3RV = parcelRequire("4t3RV");

var $gxzn4 = parcelRequire("gxzn4");

var $e6nwk = parcelRequire("e6nwk");

var $eC3A3 = parcelRequire("eC3A3");

var $gNKV7 = parcelRequire("gNKV7");

var $b7uaR = parcelRequire("b7uaR");
var $295b75af42290f89$var$$toString = $eC3A3('Object.prototype.toString');

var $295b75af42290f89$var$hasToStringTag = (parcelRequire("1Zhkx"))();
var $295b75af42290f89$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $295b75af42290f89$var$typedArrays = $gxzn4();
var $295b75af42290f89$var$$slice = $eC3A3('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $295b75af42290f89$var$$indexOf = $eC3A3('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $295b75af42290f89$var$cache = {
    __proto__: null
};
if ($295b75af42290f89$var$hasToStringTag && $gNKV7 && $b7uaR) $4t3RV($295b75af42290f89$var$typedArrays, function(typedArray) {
    var arr = new $295b75af42290f89$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $b7uaR) {
        var proto = $b7uaR(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $gNKV7(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $b7uaR(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $gNKV7(superProto, Symbol.toStringTag);
        }
        if (descriptor && descriptor.get) {
            var bound = $e6nwk(descriptor.get);
            $295b75af42290f89$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = bound;
        }
    }
});
else $4t3RV($295b75af42290f89$var$typedArrays, function(typedArray) {
    var arr = new $295b75af42290f89$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) {
        var bound = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
        $e6nwk(fn);
        $295b75af42290f89$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = bound;
    }
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $295b75af42290f89$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $4t3RV(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $295b75af42290f89$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $295b75af42290f89$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $295b75af42290f89$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $4t3RV(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $295b75af42290f89$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $295b75af42290f89$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$295b75af42290f89$var$hasToStringTag) {
        /** @type {string} */ var tag = $295b75af42290f89$var$$slice($295b75af42290f89$var$$toString(value), 8, -1);
        if ($295b75af42290f89$var$$indexOf($295b75af42290f89$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $295b75af42290f89$var$trySlices(value);
    }
    if (!$gNKV7) return null;
     // unknown engine
    return $295b75af42290f89$var$tryTypedArrays(value);
};

});
parcelRegister("4t3RV", function(module, exports) {
'use strict';

var $jUn8P = parcelRequire("jUn8P");
var $340cdf18336e158b$var$toStr = Object.prototype.toString;
var $340cdf18336e158b$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $340cdf18336e158b$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($340cdf18336e158b$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $340cdf18336e158b$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $340cdf18336e158b$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($340cdf18336e158b$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $340cdf18336e158b$var$isArray(x) {
    return $340cdf18336e158b$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$jUn8P(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($340cdf18336e158b$var$isArray(list)) $340cdf18336e158b$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $340cdf18336e158b$var$forEachString(list, iterator, receiver);
    else $340cdf18336e158b$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("jUn8P", function(module, exports) {
'use strict';
var $e7e532a9f9e12dda$var$fnToStr = Function.prototype.toString;
var $e7e532a9f9e12dda$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $e7e532a9f9e12dda$var$badArrayLike;
var $e7e532a9f9e12dda$var$isCallableMarker;
if (typeof $e7e532a9f9e12dda$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $e7e532a9f9e12dda$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $e7e532a9f9e12dda$var$isCallableMarker;
        }
    });
    $e7e532a9f9e12dda$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $e7e532a9f9e12dda$var$reflectApply(function() {
        throw 42;
    }, null, $e7e532a9f9e12dda$var$badArrayLike);
} catch (_) {
    if (_ !== $e7e532a9f9e12dda$var$isCallableMarker) $e7e532a9f9e12dda$var$reflectApply = null;
}
else $e7e532a9f9e12dda$var$reflectApply = null;
var $e7e532a9f9e12dda$var$constructorRegex = /^\s*class\b/;
var $e7e532a9f9e12dda$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $e7e532a9f9e12dda$var$fnToStr.call(value);
        return $e7e532a9f9e12dda$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $e7e532a9f9e12dda$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($e7e532a9f9e12dda$var$isES6ClassFn(value)) return false;
        $e7e532a9f9e12dda$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $e7e532a9f9e12dda$var$toStr = Object.prototype.toString;
var $e7e532a9f9e12dda$var$objectClass = '[object Object]';
var $e7e532a9f9e12dda$var$fnClass = '[object Function]';
var $e7e532a9f9e12dda$var$genClass = '[object GeneratorFunction]';
var $e7e532a9f9e12dda$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $e7e532a9f9e12dda$var$ddaClass2 = '[object HTML document.all class]';
var $e7e532a9f9e12dda$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $e7e532a9f9e12dda$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $e7e532a9f9e12dda$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $e7e532a9f9e12dda$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $e7e532a9f9e12dda$var$all = document.all;
    if ($e7e532a9f9e12dda$var$toStr.call($e7e532a9f9e12dda$var$all) === $e7e532a9f9e12dda$var$toStr.call(document.all)) $e7e532a9f9e12dda$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($e7e532a9f9e12dda$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $e7e532a9f9e12dda$var$toStr.call(value);
            return (str === $e7e532a9f9e12dda$var$ddaClass || str === $e7e532a9f9e12dda$var$ddaClass2 || str === $e7e532a9f9e12dda$var$ddaClass3 // opera 12.16
             || str === $e7e532a9f9e12dda$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $e7e532a9f9e12dda$var$reflectApply ? function isCallable(value) {
    if ($e7e532a9f9e12dda$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $e7e532a9f9e12dda$var$reflectApply(value, null, $e7e532a9f9e12dda$var$badArrayLike);
    } catch (e) {
        if (e !== $e7e532a9f9e12dda$var$isCallableMarker) return false;
    }
    return !$e7e532a9f9e12dda$var$isES6ClassFn(value) && $e7e532a9f9e12dda$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($e7e532a9f9e12dda$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($e7e532a9f9e12dda$var$hasToStringTag) return $e7e532a9f9e12dda$var$tryFunctionObject(value);
    if ($e7e532a9f9e12dda$var$isES6ClassFn(value)) return false;
    var strClass = $e7e532a9f9e12dda$var$toStr.call(value);
    if (strClass !== $e7e532a9f9e12dda$var$fnClass && strClass !== $e7e532a9f9e12dda$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $e7e532a9f9e12dda$var$tryFunctionObject(value);
};

});


parcelRegister("gxzn4", function(module, exports) {
'use strict';

var $9nxil = parcelRequire("9nxil");
var $c0ab2a592dd1c9f4$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $9nxil.length; i++)if (typeof $c0ab2a592dd1c9f4$var$g[$9nxil[i]] === 'function') // @ts-expect-error
    out[out.length] = $9nxil[i];
    return out;
};

});
parcelRegister("9nxil", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("e6nwk", function(module, exports) {
'use strict';

var $5i5al = parcelRequire("5i5al");

var $bKXTU = parcelRequire("bKXTU");

var $593ev = parcelRequire("593ev");

var $02PIM = parcelRequire("02PIM");
module.exports = function callBind(originalFunction) {
    var func = $593ev(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $5i5al(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($bKXTU) $bKXTU(module.exports, 'apply', {
    value: $02PIM
});
else module.exports.apply = $02PIM;

});
parcelRegister("5i5al", function(module, exports) {
'use strict';

var $hkNzn = parcelRequire("hkNzn");

var $g8VEL = parcelRequire("g8VEL");

var $3da2a40616138e3d$var$hasDescriptors = (parcelRequire("iSORN"))();

var $gNKV7 = parcelRequire("gNKV7");

var $5Xz8R = parcelRequire("5Xz8R");
var $3da2a40616138e3d$var$$floor = $hkNzn('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $5Xz8R('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $3da2a40616138e3d$var$$floor(length) !== length) throw new $5Xz8R('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $gNKV7) {
        var desc = $gNKV7(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($3da2a40616138e3d$var$hasDescriptors) $g8VEL(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $g8VEL(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("g8VEL", function(module, exports) {
'use strict';

var $bKXTU = parcelRequire("bKXTU");

var $bw8YX = parcelRequire("bw8YX");

var $5Xz8R = parcelRequire("5Xz8R");

var $gNKV7 = parcelRequire("gNKV7");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $5Xz8R('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $5Xz8R('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $5Xz8R('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $5Xz8R('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $5Xz8R('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $5Xz8R('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$gNKV7 && $gNKV7(obj, property);
    if ($bKXTU) $bKXTU(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $bw8YX('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("iSORN", function(module, exports) {
'use strict';

var $bKXTU = parcelRequire("bKXTU");
var $dbf4ba30baa712f1$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$bKXTU;
};
$dbf4ba30baa712f1$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$bKXTU) return null;
    try {
        return $bKXTU([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $dbf4ba30baa712f1$var$hasPropertyDescriptors;

});


parcelRegister("02PIM", function(module, exports) {
'use strict';

var $eQ7C3 = parcelRequire("eQ7C3");

var $aYzei = parcelRequire("aYzei");

var $04tsO = parcelRequire("04tsO");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $04tsO($eQ7C3, $aYzei, arguments);
};

});


parcelRegister("1Zhkx", function(module, exports) {
'use strict';

var $f2BFz = parcelRequire("f2BFz");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $f2BFz() && !!Symbol.toStringTag;
};

});






parcelRegister("dFZZW", function(module, exports) {

exports = module.exports = (parcelRequire("g4ZW2"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("g6cJS"));

exports.Duplex = (parcelRequire("hxbeF"));

exports.Transform = (parcelRequire("k0KBi"));

exports.PassThrough = (parcelRequire("jYFEV"));

});
parcelRegister("g4ZW2", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';

var $e5LkN = parcelRequire("e5LkN");
/*</replacement>*/ module.exports = $bb4d100ed8009141$var$Readable;

var $gzvFb = parcelRequire("gzvFb");
/*</replacement>*/ /*<replacement>*/ var $bb4d100ed8009141$var$Duplex;
/*</replacement>*/ $bb4d100ed8009141$var$Readable.ReadableState = $bb4d100ed8009141$var$ReadableState;

var $fzCxw = parcelRequire("fzCxw");
var $bb4d100ed8009141$require$EE = $fzCxw.EventEmitter;
var $bb4d100ed8009141$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $bSqQK = parcelRequire("bSqQK");

var $jfWxI = parcelRequire("jfWxI");
var $bb4d100ed8009141$require$Buffer = $jfWxI.Buffer;
var $bb4d100ed8009141$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $bb4d100ed8009141$var$_uint8ArrayToBuffer(chunk) {
    return $bb4d100ed8009141$require$Buffer.from(chunk);
}
function $bb4d100ed8009141$var$_isUint8Array(obj) {
    return $bb4d100ed8009141$require$Buffer.isBuffer(obj) || obj instanceof $bb4d100ed8009141$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $bb4d100ed8009141$var$util = Object.create((parcelRequire("6PLnu")));

$bb4d100ed8009141$var$util.inherits = (parcelRequire("dhT4G"));

var $ifbub = parcelRequire("ifbub");
var $bb4d100ed8009141$var$debug = void 0;
if ($ifbub && $ifbub.debuglog) $bb4d100ed8009141$var$debug = $ifbub.debuglog('stream');
else $bb4d100ed8009141$var$debug = function() {};

var $jAhDc = parcelRequire("jAhDc");

var $ktkM5 = parcelRequire("ktkM5");
var $bb4d100ed8009141$var$StringDecoder;
$bb4d100ed8009141$var$util.inherits($bb4d100ed8009141$var$Readable, $bSqQK);
var $bb4d100ed8009141$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $bb4d100ed8009141$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($gzvFb(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $bb4d100ed8009141$var$ReadableState(options, stream) {
    $bb4d100ed8009141$var$Duplex = $bb4d100ed8009141$var$Duplex || (parcelRequire("hxbeF"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $bb4d100ed8009141$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $jAhDc();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$bb4d100ed8009141$var$StringDecoder) $bb4d100ed8009141$var$StringDecoder = (parcelRequire("bAIDW")).StringDecoder;
        this.decoder = new $bb4d100ed8009141$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $bb4d100ed8009141$var$Readable(options) {
    $bb4d100ed8009141$var$Duplex = $bb4d100ed8009141$var$Duplex || (parcelRequire("hxbeF"));
    if (!(this instanceof $bb4d100ed8009141$var$Readable)) return new $bb4d100ed8009141$var$Readable(options);
    this._readableState = new $bb4d100ed8009141$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $bSqQK.call(this);
}
Object.defineProperty($bb4d100ed8009141$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$bb4d100ed8009141$var$Readable.prototype.destroy = $ktkM5.destroy;
$bb4d100ed8009141$var$Readable.prototype._undestroy = $ktkM5.undestroy;
$bb4d100ed8009141$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$bb4d100ed8009141$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $bb4d100ed8009141$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $bb4d100ed8009141$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$bb4d100ed8009141$var$Readable.prototype.unshift = function(chunk) {
    return $bb4d100ed8009141$var$readableAddChunk(this, chunk, null, true, false);
};
function $bb4d100ed8009141$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $bb4d100ed8009141$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $bb4d100ed8009141$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $bb4d100ed8009141$require$Buffer.prototype) chunk = $bb4d100ed8009141$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $bb4d100ed8009141$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $bb4d100ed8009141$var$addChunk(stream, state, chunk, false);
                    else $bb4d100ed8009141$var$maybeReadMore(stream, state);
                } else $bb4d100ed8009141$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $bb4d100ed8009141$var$needMoreData(state);
}
function $bb4d100ed8009141$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $bb4d100ed8009141$var$emitReadable(stream);
    }
    $bb4d100ed8009141$var$maybeReadMore(stream, state);
}
function $bb4d100ed8009141$var$chunkInvalid(state, chunk) {
    var er;
    if (!$bb4d100ed8009141$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $bb4d100ed8009141$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$bb4d100ed8009141$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$bb4d100ed8009141$var$Readable.prototype.setEncoding = function(enc) {
    if (!$bb4d100ed8009141$var$StringDecoder) $bb4d100ed8009141$var$StringDecoder = (parcelRequire("bAIDW")).StringDecoder;
    this._readableState.decoder = new $bb4d100ed8009141$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $bb4d100ed8009141$var$MAX_HWM = 0x800000;
function $bb4d100ed8009141$var$computeNewHighWaterMark(n) {
    if (n >= $bb4d100ed8009141$var$MAX_HWM) n = $bb4d100ed8009141$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $bb4d100ed8009141$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $bb4d100ed8009141$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$bb4d100ed8009141$var$Readable.prototype.read = function(n) {
    $bb4d100ed8009141$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $bb4d100ed8009141$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $bb4d100ed8009141$var$endReadable(this);
        else $bb4d100ed8009141$var$emitReadable(this);
        return null;
    }
    n = $bb4d100ed8009141$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $bb4d100ed8009141$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $bb4d100ed8009141$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $bb4d100ed8009141$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $bb4d100ed8009141$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $bb4d100ed8009141$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $bb4d100ed8009141$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $bb4d100ed8009141$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $bb4d100ed8009141$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $bb4d100ed8009141$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $bb4d100ed8009141$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $bb4d100ed8009141$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $bb4d100ed8009141$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $e5LkN.nextTick($bb4d100ed8009141$var$emitReadable_, stream);
        else $bb4d100ed8009141$var$emitReadable_(stream);
    }
}
function $bb4d100ed8009141$var$emitReadable_(stream) {
    $bb4d100ed8009141$var$debug('emit readable');
    stream.emit('readable');
    $bb4d100ed8009141$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $bb4d100ed8009141$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $e5LkN.nextTick($bb4d100ed8009141$var$maybeReadMore_, stream, state);
    }
}
function $bb4d100ed8009141$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $bb4d100ed8009141$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$bb4d100ed8009141$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$bb4d100ed8009141$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $bb4d100ed8009141$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $4ZL0H.stdout && dest !== $4ZL0H.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $e5LkN.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $bb4d100ed8009141$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $bb4d100ed8009141$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $bb4d100ed8009141$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $bb4d100ed8009141$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $bb4d100ed8009141$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $bb4d100ed8009141$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $bb4d100ed8009141$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $bb4d100ed8009141$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($bb4d100ed8009141$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $bb4d100ed8009141$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $bb4d100ed8009141$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $bb4d100ed8009141$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $bb4d100ed8009141$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $bb4d100ed8009141$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $bb4d100ed8009141$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $bb4d100ed8009141$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $bb4d100ed8009141$var$flow(src);
        }
    };
}
$bb4d100ed8009141$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $bb4d100ed8009141$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$bb4d100ed8009141$var$Readable.prototype.on = function(ev, fn) {
    var res = $bSqQK.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $e5LkN.nextTick($bb4d100ed8009141$var$nReadingNextTick, this);
            else if (state.length) $bb4d100ed8009141$var$emitReadable(this);
        }
    }
    return res;
};
$bb4d100ed8009141$var$Readable.prototype.addListener = $bb4d100ed8009141$var$Readable.prototype.on;
function $bb4d100ed8009141$var$nReadingNextTick(self1) {
    $bb4d100ed8009141$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$bb4d100ed8009141$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $bb4d100ed8009141$var$debug('resume');
        state.flowing = true;
        $bb4d100ed8009141$var$resume(this, state);
    }
    return this;
};
function $bb4d100ed8009141$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $e5LkN.nextTick($bb4d100ed8009141$var$resume_, stream, state);
    }
}
function $bb4d100ed8009141$var$resume_(stream, state) {
    if (!state.reading) {
        $bb4d100ed8009141$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $bb4d100ed8009141$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$bb4d100ed8009141$var$Readable.prototype.pause = function() {
    $bb4d100ed8009141$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $bb4d100ed8009141$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $bb4d100ed8009141$var$flow(stream) {
    var state = stream._readableState;
    $bb4d100ed8009141$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$bb4d100ed8009141$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $bb4d100ed8009141$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $bb4d100ed8009141$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $bb4d100ed8009141$var$kProxyEvents.length; n++)stream.on($bb4d100ed8009141$var$kProxyEvents[n], this.emit.bind(this, $bb4d100ed8009141$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $bb4d100ed8009141$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($bb4d100ed8009141$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$bb4d100ed8009141$var$Readable._fromList = $bb4d100ed8009141$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $bb4d100ed8009141$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $bb4d100ed8009141$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $bb4d100ed8009141$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $bb4d100ed8009141$var$copyFromBufferString(n, list) : $bb4d100ed8009141$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $bb4d100ed8009141$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $bb4d100ed8009141$var$copyFromBuffer(n, list) {
    var ret = $bb4d100ed8009141$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $bb4d100ed8009141$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $e5LkN.nextTick($bb4d100ed8009141$var$endReadableNT, state, stream);
    }
}
function $bb4d100ed8009141$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $bb4d100ed8009141$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("e5LkN", function(module, exports) {

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
module.exports = {
    nextTick: $a4263fec5066d64f$var$nextTick
};
function $a4263fec5066d64f$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $4ZL0H.nextTick(fn);
        case 2:
            return $4ZL0H.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $4ZL0H.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $4ZL0H.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $4ZL0H.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("gzvFb", function(module, exports) {
var $c10879e6d2766179$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $c10879e6d2766179$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("bSqQK", function(module, exports) {

module.exports = (parcelRequire("fzCxw")).EventEmitter;

});

parcelRegister("jfWxI", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $bdjQ6 = parcelRequire("bdjQ6");
var $e04cd46ce8cf6bde$var$Buffer = $bdjQ6.Buffer;
// alternative to using Object.keys for old browsers
function $e04cd46ce8cf6bde$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($e04cd46ce8cf6bde$var$Buffer.from && $e04cd46ce8cf6bde$var$Buffer.alloc && $e04cd46ce8cf6bde$var$Buffer.allocUnsafe && $e04cd46ce8cf6bde$var$Buffer.allocUnsafeSlow) module.exports = $bdjQ6;
else {
    // Copy properties from require('buffer')
    $e04cd46ce8cf6bde$var$copyProps($bdjQ6, module.exports);
    module.exports.Buffer = $e04cd46ce8cf6bde$var$SafeBuffer;
}
function $e04cd46ce8cf6bde$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $e04cd46ce8cf6bde$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$e04cd46ce8cf6bde$var$copyProps($e04cd46ce8cf6bde$var$Buffer, $e04cd46ce8cf6bde$var$SafeBuffer);
$e04cd46ce8cf6bde$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $e04cd46ce8cf6bde$var$Buffer(arg, encodingOrOffset, length);
};
$e04cd46ce8cf6bde$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $e04cd46ce8cf6bde$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$e04cd46ce8cf6bde$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $e04cd46ce8cf6bde$var$Buffer(size);
};
$e04cd46ce8cf6bde$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $bdjQ6.SlowBuffer(size);
};

});

parcelRegister("6PLnu", function(module, exports) {

$parcel$export(module.exports, "isArray", function () { return $4f9c41bc251cd7a3$export$43bee75e5e14138e; }, function (v) { return $4f9c41bc251cd7a3$export$43bee75e5e14138e = v; });
$parcel$export(module.exports, "isBoolean", function () { return $4f9c41bc251cd7a3$export$f9ce7b637dfbe238; }, function (v) { return $4f9c41bc251cd7a3$export$f9ce7b637dfbe238 = v; });
$parcel$export(module.exports, "isNull", function () { return $4f9c41bc251cd7a3$export$630801d484da15df; }, function (v) { return $4f9c41bc251cd7a3$export$630801d484da15df = v; });
$parcel$export(module.exports, "isNullOrUndefined", function () { return $4f9c41bc251cd7a3$export$bedb7023a7733221; }, function (v) { return $4f9c41bc251cd7a3$export$bedb7023a7733221 = v; });
$parcel$export(module.exports, "isNumber", function () { return $4f9c41bc251cd7a3$export$7e4aa119212bc614; }, function (v) { return $4f9c41bc251cd7a3$export$7e4aa119212bc614 = v; });
$parcel$export(module.exports, "isString", function () { return $4f9c41bc251cd7a3$export$844ec244b1367d54; }, function (v) { return $4f9c41bc251cd7a3$export$844ec244b1367d54 = v; });
$parcel$export(module.exports, "isSymbol", function () { return $4f9c41bc251cd7a3$export$a244864fd9645c7f; }, function (v) { return $4f9c41bc251cd7a3$export$a244864fd9645c7f = v; });
$parcel$export(module.exports, "isUndefined", function () { return $4f9c41bc251cd7a3$export$fce6876652108ab; }, function (v) { return $4f9c41bc251cd7a3$export$fce6876652108ab = v; });
$parcel$export(module.exports, "isRegExp", function () { return $4f9c41bc251cd7a3$export$49841c62b9eff15; }, function (v) { return $4f9c41bc251cd7a3$export$49841c62b9eff15 = v; });
$parcel$export(module.exports, "isObject", function () { return $4f9c41bc251cd7a3$export$a6cdc56e425d0d0a; }, function (v) { return $4f9c41bc251cd7a3$export$a6cdc56e425d0d0a = v; });
$parcel$export(module.exports, "isDate", function () { return $4f9c41bc251cd7a3$export$871608497c498473; }, function (v) { return $4f9c41bc251cd7a3$export$871608497c498473 = v; });
$parcel$export(module.exports, "isError", function () { return $4f9c41bc251cd7a3$export$e6127cc7fe7395c3; }, function (v) { return $4f9c41bc251cd7a3$export$e6127cc7fe7395c3 = v; });
$parcel$export(module.exports, "isFunction", function () { return $4f9c41bc251cd7a3$export$f6e2535fb5126e54; }, function (v) { return $4f9c41bc251cd7a3$export$f6e2535fb5126e54 = v; });
$parcel$export(module.exports, "isPrimitive", function () { return $4f9c41bc251cd7a3$export$c3825b437cbdea5c; }, function (v) { return $4f9c41bc251cd7a3$export$c3825b437cbdea5c = v; });
$parcel$export(module.exports, "isBuffer", function () { return $4f9c41bc251cd7a3$export$a7884ebc965f8f54; }, function (v) { return $4f9c41bc251cd7a3$export$a7884ebc965f8f54 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $4f9c41bc251cd7a3$export$43bee75e5e14138e;
var $4f9c41bc251cd7a3$export$f9ce7b637dfbe238;
var $4f9c41bc251cd7a3$export$630801d484da15df;
var $4f9c41bc251cd7a3$export$bedb7023a7733221;
var $4f9c41bc251cd7a3$export$7e4aa119212bc614;
var $4f9c41bc251cd7a3$export$844ec244b1367d54;
var $4f9c41bc251cd7a3$export$a244864fd9645c7f;
var $4f9c41bc251cd7a3$export$fce6876652108ab;
var $4f9c41bc251cd7a3$export$49841c62b9eff15;
var $4f9c41bc251cd7a3$export$a6cdc56e425d0d0a;
var $4f9c41bc251cd7a3$export$871608497c498473;
var $4f9c41bc251cd7a3$export$e6127cc7fe7395c3;
var $4f9c41bc251cd7a3$export$f6e2535fb5126e54;
var $4f9c41bc251cd7a3$export$c3825b437cbdea5c;
var $4f9c41bc251cd7a3$export$a7884ebc965f8f54;
function $4f9c41bc251cd7a3$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $4f9c41bc251cd7a3$var$objectToString(arg) === '[object Array]';
}
$4f9c41bc251cd7a3$export$43bee75e5e14138e = $4f9c41bc251cd7a3$var$isArray;
function $4f9c41bc251cd7a3$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
$4f9c41bc251cd7a3$export$f9ce7b637dfbe238 = $4f9c41bc251cd7a3$var$isBoolean;
function $4f9c41bc251cd7a3$var$isNull(arg) {
    return arg === null;
}
$4f9c41bc251cd7a3$export$630801d484da15df = $4f9c41bc251cd7a3$var$isNull;
function $4f9c41bc251cd7a3$var$isNullOrUndefined(arg) {
    return arg == null;
}
$4f9c41bc251cd7a3$export$bedb7023a7733221 = $4f9c41bc251cd7a3$var$isNullOrUndefined;
function $4f9c41bc251cd7a3$var$isNumber(arg) {
    return typeof arg === 'number';
}
$4f9c41bc251cd7a3$export$7e4aa119212bc614 = $4f9c41bc251cd7a3$var$isNumber;
function $4f9c41bc251cd7a3$var$isString(arg) {
    return typeof arg === 'string';
}
$4f9c41bc251cd7a3$export$844ec244b1367d54 = $4f9c41bc251cd7a3$var$isString;
function $4f9c41bc251cd7a3$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
$4f9c41bc251cd7a3$export$a244864fd9645c7f = $4f9c41bc251cd7a3$var$isSymbol;
function $4f9c41bc251cd7a3$var$isUndefined(arg) {
    return arg === void 0;
}
$4f9c41bc251cd7a3$export$fce6876652108ab = $4f9c41bc251cd7a3$var$isUndefined;
function $4f9c41bc251cd7a3$var$isRegExp(re) {
    return $4f9c41bc251cd7a3$var$objectToString(re) === '[object RegExp]';
}
$4f9c41bc251cd7a3$export$49841c62b9eff15 = $4f9c41bc251cd7a3$var$isRegExp;
function $4f9c41bc251cd7a3$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
$4f9c41bc251cd7a3$export$a6cdc56e425d0d0a = $4f9c41bc251cd7a3$var$isObject;
function $4f9c41bc251cd7a3$var$isDate(d) {
    return $4f9c41bc251cd7a3$var$objectToString(d) === '[object Date]';
}
$4f9c41bc251cd7a3$export$871608497c498473 = $4f9c41bc251cd7a3$var$isDate;
function $4f9c41bc251cd7a3$var$isError(e) {
    return $4f9c41bc251cd7a3$var$objectToString(e) === '[object Error]' || e instanceof Error;
}
$4f9c41bc251cd7a3$export$e6127cc7fe7395c3 = $4f9c41bc251cd7a3$var$isError;
function $4f9c41bc251cd7a3$var$isFunction(arg) {
    return typeof arg === 'function';
}
$4f9c41bc251cd7a3$export$f6e2535fb5126e54 = $4f9c41bc251cd7a3$var$isFunction;
function $4f9c41bc251cd7a3$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
$4f9c41bc251cd7a3$export$c3825b437cbdea5c = $4f9c41bc251cd7a3$var$isPrimitive;

$4f9c41bc251cd7a3$export$a7884ebc965f8f54 = (parcelRequire("bdjQ6")).Buffer.isBuffer;
function $4f9c41bc251cd7a3$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("jAhDc", function(module, exports) {
'use strict';
function $e41f0e4be4b6884d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $jfWxI = parcelRequire("jfWxI");
var $e41f0e4be4b6884d$require$Buffer = $jfWxI.Buffer;

var $ifbub = parcelRequire("ifbub");
function $e41f0e4be4b6884d$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $e41f0e4be4b6884d$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $e41f0e4be4b6884d$require$Buffer.alloc(0);
        var ret = $e41f0e4be4b6884d$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $e41f0e4be4b6884d$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($ifbub && $ifbub.inspect && $ifbub.inspect.custom) module.exports.prototype[$ifbub.inspect.custom] = function() {
    var obj = $ifbub.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("ktkM5", function(module, exports) {
'use strict';

var $e5LkN = parcelRequire("e5LkN");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $ee76a179a649e840$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $e5LkN.nextTick($ee76a179a649e840$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $e5LkN.nextTick($ee76a179a649e840$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $e5LkN.nextTick($ee76a179a649e840$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $e5LkN.nextTick($ee76a179a649e840$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $ee76a179a649e840$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $ee76a179a649e840$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $ee76a179a649e840$var$destroy,
    undestroy: $ee76a179a649e840$var$undestroy
};

});

parcelRegister("hxbeF", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $e5LkN = parcelRequire("e5LkN");
/*</replacement>*/ /*<replacement>*/ var $cc3e3be8c0373de4$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $cc3e3be8c0373de4$var$Duplex;

/*<replacement>*/ var $cc3e3be8c0373de4$var$util = Object.create((parcelRequire("6PLnu")));

$cc3e3be8c0373de4$var$util.inherits = (parcelRequire("dhT4G"));

var $g4ZW2 = parcelRequire("g4ZW2");

var $g6cJS = parcelRequire("g6cJS");
$cc3e3be8c0373de4$var$util.inherits($cc3e3be8c0373de4$var$Duplex, $g4ZW2);
// avoid scope creep, the keys array can then be collected
var $cc3e3be8c0373de4$var$keys = $cc3e3be8c0373de4$var$objectKeys($g6cJS.prototype);
for(var $cc3e3be8c0373de4$var$v = 0; $cc3e3be8c0373de4$var$v < $cc3e3be8c0373de4$var$keys.length; $cc3e3be8c0373de4$var$v++){
    var $cc3e3be8c0373de4$var$method = $cc3e3be8c0373de4$var$keys[$cc3e3be8c0373de4$var$v];
    if (!$cc3e3be8c0373de4$var$Duplex.prototype[$cc3e3be8c0373de4$var$method]) $cc3e3be8c0373de4$var$Duplex.prototype[$cc3e3be8c0373de4$var$method] = $g6cJS.prototype[$cc3e3be8c0373de4$var$method];
}
function $cc3e3be8c0373de4$var$Duplex(options) {
    if (!(this instanceof $cc3e3be8c0373de4$var$Duplex)) return new $cc3e3be8c0373de4$var$Duplex(options);
    $g4ZW2.call(this, options);
    $g6cJS.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $cc3e3be8c0373de4$var$onend);
}
Object.defineProperty($cc3e3be8c0373de4$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $cc3e3be8c0373de4$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $e5LkN.nextTick($cc3e3be8c0373de4$var$onEndNT, this);
}
function $cc3e3be8c0373de4$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($cc3e3be8c0373de4$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$cc3e3be8c0373de4$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $e5LkN.nextTick(cb, err);
};

});
parcelRegister("g6cJS", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $e5LkN = parcelRequire("e5LkN");
/*</replacement>*/ module.exports = $bb8716969b605b7d$var$Writable;
/* <replacement> */ function $bb8716969b605b7d$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $bb8716969b605b7d$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $bb8716969b605b7d$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $bb8716969b605b7d$var$asyncWrite = (0, $e5LkN.nextTick);
/*</replacement>*/ /*<replacement>*/ var $bb8716969b605b7d$var$Duplex;
/*</replacement>*/ $bb8716969b605b7d$var$Writable.WritableState = $bb8716969b605b7d$var$WritableState;

/*<replacement>*/ var $bb8716969b605b7d$var$util = Object.create((parcelRequire("6PLnu")));

$bb8716969b605b7d$var$util.inherits = (parcelRequire("dhT4G"));

/*</replacement>*/ /*<replacement>*/ var $bb8716969b605b7d$var$internalUtil = {
    deprecate: (parcelRequire("4SymK"))
};

var $bSqQK = parcelRequire("bSqQK");

var $jfWxI = parcelRequire("jfWxI");
var $bb8716969b605b7d$require$Buffer = $jfWxI.Buffer;
var $bb8716969b605b7d$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $bb8716969b605b7d$var$_uint8ArrayToBuffer(chunk) {
    return $bb8716969b605b7d$require$Buffer.from(chunk);
}
function $bb8716969b605b7d$var$_isUint8Array(obj) {
    return $bb8716969b605b7d$require$Buffer.isBuffer(obj) || obj instanceof $bb8716969b605b7d$var$OurUint8Array;
}

var $ktkM5 = parcelRequire("ktkM5");
$bb8716969b605b7d$var$util.inherits($bb8716969b605b7d$var$Writable, $bSqQK);
function $bb8716969b605b7d$var$nop() {}

function $bb8716969b605b7d$var$WritableState(options, stream) {
    $bb8716969b605b7d$var$Duplex = $bb8716969b605b7d$var$Duplex || (parcelRequire("hxbeF"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $bb8716969b605b7d$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $bb8716969b605b7d$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $bb8716969b605b7d$var$CorkedRequest(this);
}
$bb8716969b605b7d$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($bb8716969b605b7d$var$WritableState.prototype, 'buffer', {
            get: $bb8716969b605b7d$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $bb8716969b605b7d$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $bb8716969b605b7d$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($bb8716969b605b7d$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($bb8716969b605b7d$var$realHasInstance.call(this, object)) return true;
            if (this !== $bb8716969b605b7d$var$Writable) return false;
            return object && object._writableState instanceof $bb8716969b605b7d$var$WritableState;
        }
    });
} else $bb8716969b605b7d$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $bb8716969b605b7d$var$Writable(options) {
    $bb8716969b605b7d$var$Duplex = $bb8716969b605b7d$var$Duplex || (parcelRequire("hxbeF"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$bb8716969b605b7d$var$realHasInstance.call($bb8716969b605b7d$var$Writable, this) && !(this instanceof $bb8716969b605b7d$var$Duplex)) return new $bb8716969b605b7d$var$Writable(options);
    this._writableState = new $bb8716969b605b7d$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $bSqQK.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$bb8716969b605b7d$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $bb8716969b605b7d$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $e5LkN.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $bb8716969b605b7d$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $e5LkN.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$bb8716969b605b7d$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $bb8716969b605b7d$var$_isUint8Array(chunk);
    if (isBuf && !$bb8716969b605b7d$require$Buffer.isBuffer(chunk)) chunk = $bb8716969b605b7d$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $bb8716969b605b7d$var$nop;
    if (state.ended) $bb8716969b605b7d$var$writeAfterEnd(this, cb);
    else if (isBuf || $bb8716969b605b7d$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $bb8716969b605b7d$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$bb8716969b605b7d$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$bb8716969b605b7d$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $bb8716969b605b7d$var$clearBuffer(this, state);
    }
};
$bb8716969b605b7d$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $bb8716969b605b7d$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $bb8716969b605b7d$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($bb8716969b605b7d$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $bb8716969b605b7d$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $bb8716969b605b7d$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $bb8716969b605b7d$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $bb8716969b605b7d$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $bb8716969b605b7d$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $e5LkN.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $e5LkN.nextTick($bb8716969b605b7d$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $bb8716969b605b7d$var$finishMaybe(stream, state);
    }
}
function $bb8716969b605b7d$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $bb8716969b605b7d$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $bb8716969b605b7d$var$onwriteStateUpdate(state);
    if (er) $bb8716969b605b7d$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $bb8716969b605b7d$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $bb8716969b605b7d$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $bb8716969b605b7d$var$asyncWrite($bb8716969b605b7d$var$afterWrite, stream, state, finished, cb);
        else $bb8716969b605b7d$var$afterWrite(stream, state, finished, cb);
    }
}
function $bb8716969b605b7d$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $bb8716969b605b7d$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $bb8716969b605b7d$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $bb8716969b605b7d$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $bb8716969b605b7d$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $bb8716969b605b7d$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $bb8716969b605b7d$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $bb8716969b605b7d$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$bb8716969b605b7d$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$bb8716969b605b7d$var$Writable.prototype._writev = null;
$bb8716969b605b7d$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $bb8716969b605b7d$var$endWritable(this, state, cb);
};
function $bb8716969b605b7d$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $bb8716969b605b7d$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $bb8716969b605b7d$var$finishMaybe(stream, state);
    });
}
function $bb8716969b605b7d$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $e5LkN.nextTick($bb8716969b605b7d$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $bb8716969b605b7d$var$finishMaybe(stream, state) {
    var need = $bb8716969b605b7d$var$needFinish(state);
    if (need) {
        $bb8716969b605b7d$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $bb8716969b605b7d$var$endWritable(stream, state, cb) {
    state.ending = true;
    $bb8716969b605b7d$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $e5LkN.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $bb8716969b605b7d$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($bb8716969b605b7d$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$bb8716969b605b7d$var$Writable.prototype.destroy = $ktkM5.destroy;
$bb8716969b605b7d$var$Writable.prototype._undestroy = $ktkM5.undestroy;
$bb8716969b605b7d$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("bAIDW", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $8705afbb181f916e$export$63a7aa211a91ed69; }, function (v) { return $8705afbb181f916e$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $8705afbb181f916e$export$63a7aa211a91ed69;
'use strict';

var $jfWxI = parcelRequire("jfWxI");
var $8705afbb181f916e$require$Buffer = $jfWxI.Buffer;
/*</replacement>*/ var $8705afbb181f916e$var$isEncoding = $8705afbb181f916e$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $8705afbb181f916e$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $8705afbb181f916e$var$normalizeEncoding(enc) {
    var nenc = $8705afbb181f916e$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($8705afbb181f916e$require$Buffer.isEncoding === $8705afbb181f916e$var$isEncoding || !$8705afbb181f916e$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$8705afbb181f916e$export$63a7aa211a91ed69 = $8705afbb181f916e$var$StringDecoder;
function $8705afbb181f916e$var$StringDecoder(encoding) {
    this.encoding = $8705afbb181f916e$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $8705afbb181f916e$var$utf16Text;
            this.end = $8705afbb181f916e$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $8705afbb181f916e$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $8705afbb181f916e$var$base64Text;
            this.end = $8705afbb181f916e$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $8705afbb181f916e$var$simpleWrite;
            this.end = $8705afbb181f916e$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $8705afbb181f916e$require$Buffer.allocUnsafe(nb);
}
$8705afbb181f916e$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$8705afbb181f916e$var$StringDecoder.prototype.end = $8705afbb181f916e$var$utf8End;
// Returns only complete characters in a Buffer
$8705afbb181f916e$var$StringDecoder.prototype.text = $8705afbb181f916e$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$8705afbb181f916e$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $8705afbb181f916e$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $8705afbb181f916e$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $8705afbb181f916e$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $8705afbb181f916e$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $8705afbb181f916e$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $8705afbb181f916e$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $8705afbb181f916e$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $8705afbb181f916e$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $8705afbb181f916e$var$utf8Text(buf, i) {
    var total = $8705afbb181f916e$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $8705afbb181f916e$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $8705afbb181f916e$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $8705afbb181f916e$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $8705afbb181f916e$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $8705afbb181f916e$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $8705afbb181f916e$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $8705afbb181f916e$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});


parcelRegister("k0KBi", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $e917f49caec6d43d$var$Transform;

var $hxbeF = parcelRequire("hxbeF");

/*<replacement>*/ var $e917f49caec6d43d$var$util = Object.create((parcelRequire("6PLnu")));

$e917f49caec6d43d$var$util.inherits = (parcelRequire("dhT4G"));
/*</replacement>*/ $e917f49caec6d43d$var$util.inherits($e917f49caec6d43d$var$Transform, $hxbeF);
function $e917f49caec6d43d$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $e917f49caec6d43d$var$Transform(options) {
    if (!(this instanceof $e917f49caec6d43d$var$Transform)) return new $e917f49caec6d43d$var$Transform(options);
    $hxbeF.call(this, options);
    this._transformState = {
        afterTransform: $e917f49caec6d43d$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $e917f49caec6d43d$var$prefinish);
}
function $e917f49caec6d43d$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $e917f49caec6d43d$var$done(_this, er, data);
    });
    else $e917f49caec6d43d$var$done(this, null, null);
}
$e917f49caec6d43d$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $hxbeF.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$e917f49caec6d43d$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$e917f49caec6d43d$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$e917f49caec6d43d$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$e917f49caec6d43d$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $hxbeF.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $e917f49caec6d43d$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("jYFEV", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $e8b3ef8ac56f630d$var$PassThrough;

var $k0KBi = parcelRequire("k0KBi");

/*<replacement>*/ var $e8b3ef8ac56f630d$var$util = Object.create((parcelRequire("6PLnu")));

$e8b3ef8ac56f630d$var$util.inherits = (parcelRequire("dhT4G"));
/*</replacement>*/ $e8b3ef8ac56f630d$var$util.inherits($e8b3ef8ac56f630d$var$PassThrough, $k0KBi);
function $e8b3ef8ac56f630d$var$PassThrough(options) {
    if (!(this instanceof $e8b3ef8ac56f630d$var$PassThrough)) return new $e8b3ef8ac56f630d$var$PassThrough(options);
    $k0KBi.call(this, options);
}
$e8b3ef8ac56f630d$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});




parcelRegister("15EwC", function(module, exports) {
'use strict';
module.exports = function SHA(algorithm) {
    var alg = algorithm.toLowerCase();
    var Algorithm = module.exports[alg];
    if (!Algorithm) throw new Error(alg + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

module.exports.sha = (parcelRequire("k2Afl"));

module.exports.sha1 = (parcelRequire("hlzHi"));

module.exports.sha224 = (parcelRequire("lzTLZ"));

module.exports.sha256 = (parcelRequire("kC2XM"));

module.exports.sha384 = (parcelRequire("jDuRY"));

module.exports.sha512 = (parcelRequire("c4ppm"));

});
parcelRegister("k2Afl", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $klEcH = parcelRequire("klEcH");

var $838j1 = parcelRequire("838j1");
var $e9701c5afa941cb3$require$Buffer = $838j1.Buffer;
var $e9701c5afa941cb3$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $e9701c5afa941cb3$var$W = new Array(80);
function $e9701c5afa941cb3$var$Sha() {
    this.init();
    this._w = $e9701c5afa941cb3$var$W;
    $klEcH.call(this, 64, 56);
}
$dhT4G($e9701c5afa941cb3$var$Sha, $klEcH);
$e9701c5afa941cb3$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $e9701c5afa941cb3$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $e9701c5afa941cb3$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $e9701c5afa941cb3$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$e9701c5afa941cb3$var$Sha.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $e9701c5afa941cb3$var$rotl5(a) + $e9701c5afa941cb3$var$ft(s, b, c, d) + e + w[j] + $e9701c5afa941cb3$var$K[s] | 0;
        e = d;
        d = c;
        c = $e9701c5afa941cb3$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$e9701c5afa941cb3$var$Sha.prototype._hash = function() {
    var H = $e9701c5afa941cb3$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $e9701c5afa941cb3$var$Sha;

});
parcelRegister("klEcH", function(module, exports) {
'use strict';

var $838j1 = parcelRequire("838j1");
var $ed04f4701195f7c9$require$Buffer = $838j1.Buffer;

var $iDFZs = parcelRequire("iDFZs");
// prototype class for hash functions
function $ed04f4701195f7c9$var$Hash(blockSize, finalSize) {
    this._block = $ed04f4701195f7c9$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$ed04f4701195f7c9$var$Hash.prototype.update = function(data, enc) {
    /* eslint no-param-reassign: 0 */ data = $iDFZs(data, enc || 'utf8');
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$ed04f4701195f7c9$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    /*
	 * zero (rem + 1) trailing bits, where (rem + 1) is the smallest
	 * non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
	 */ this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$ed04f4701195f7c9$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $ed04f4701195f7c9$var$Hash;

});


parcelRegister("hlzHi", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $klEcH = parcelRequire("klEcH");

var $838j1 = parcelRequire("838j1");
var $ca10169aa7393b0d$require$Buffer = $838j1.Buffer;
var $ca10169aa7393b0d$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $ca10169aa7393b0d$var$W = new Array(80);
function $ca10169aa7393b0d$var$Sha1() {
    this.init();
    this._w = $ca10169aa7393b0d$var$W;
    $klEcH.call(this, 64, 56);
}
$dhT4G($ca10169aa7393b0d$var$Sha1, $klEcH);
$ca10169aa7393b0d$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $ca10169aa7393b0d$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $ca10169aa7393b0d$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $ca10169aa7393b0d$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $ca10169aa7393b0d$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$ca10169aa7393b0d$var$Sha1.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = $ca10169aa7393b0d$var$rotl1(w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $ca10169aa7393b0d$var$rotl5(a) + $ca10169aa7393b0d$var$ft(s, b, c, d) + e + w[j] + $ca10169aa7393b0d$var$K[s] | 0;
        e = d;
        d = c;
        c = $ca10169aa7393b0d$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$ca10169aa7393b0d$var$Sha1.prototype._hash = function() {
    var H = $ca10169aa7393b0d$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $ca10169aa7393b0d$var$Sha1;

});

parcelRegister("lzTLZ", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $kC2XM = parcelRequire("kC2XM");

var $klEcH = parcelRequire("klEcH");

var $838j1 = parcelRequire("838j1");
var $fb5821351ada7f8b$require$Buffer = $838j1.Buffer;
var $fb5821351ada7f8b$var$W = new Array(64);
function $fb5821351ada7f8b$var$Sha224() {
    this.init();
    this._w = $fb5821351ada7f8b$var$W; // new Array(64)
    $klEcH.call(this, 64, 56);
}
$dhT4G($fb5821351ada7f8b$var$Sha224, $kC2XM);
$fb5821351ada7f8b$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$fb5821351ada7f8b$var$Sha224.prototype._hash = function() {
    var H = $fb5821351ada7f8b$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $fb5821351ada7f8b$var$Sha224;

});
parcelRegister("kC2XM", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $klEcH = parcelRequire("klEcH");

var $838j1 = parcelRequire("838j1");
var $f019a7adf5bdf392$require$Buffer = $838j1.Buffer;
var $f019a7adf5bdf392$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $f019a7adf5bdf392$var$W = new Array(64);
function $f019a7adf5bdf392$var$Sha256() {
    this.init();
    this._w = $f019a7adf5bdf392$var$W; // new Array(64)
    $klEcH.call(this, 64, 56);
}
$dhT4G($f019a7adf5bdf392$var$Sha256, $klEcH);
$f019a7adf5bdf392$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $f019a7adf5bdf392$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $f019a7adf5bdf392$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $f019a7adf5bdf392$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $f019a7adf5bdf392$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $f019a7adf5bdf392$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $f019a7adf5bdf392$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$f019a7adf5bdf392$var$Sha256.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)w[i] = $f019a7adf5bdf392$var$gamma1(w[i - 2]) + w[i - 7] + $f019a7adf5bdf392$var$gamma0(w[i - 15]) + w[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $f019a7adf5bdf392$var$sigma1(e) + $f019a7adf5bdf392$var$ch(e, f, g) + $f019a7adf5bdf392$var$K[j] + w[j] | 0;
        var T2 = $f019a7adf5bdf392$var$sigma0(a) + $f019a7adf5bdf392$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$f019a7adf5bdf392$var$Sha256.prototype._hash = function() {
    var H = $f019a7adf5bdf392$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $f019a7adf5bdf392$var$Sha256;

});


parcelRegister("jDuRY", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $c4ppm = parcelRequire("c4ppm");

var $klEcH = parcelRequire("klEcH");

var $838j1 = parcelRequire("838j1");
var $e4b99ae2d3c6980e$require$Buffer = $838j1.Buffer;
var $e4b99ae2d3c6980e$var$W = new Array(160);
function $e4b99ae2d3c6980e$var$Sha384() {
    this.init();
    this._w = $e4b99ae2d3c6980e$var$W;
    $klEcH.call(this, 128, 112);
}
$dhT4G($e4b99ae2d3c6980e$var$Sha384, $c4ppm);
$e4b99ae2d3c6980e$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$e4b99ae2d3c6980e$var$Sha384.prototype._hash = function() {
    var H = $e4b99ae2d3c6980e$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $e4b99ae2d3c6980e$var$Sha384;

});
parcelRegister("c4ppm", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $klEcH = parcelRequire("klEcH");

var $838j1 = parcelRequire("838j1");
var $8c99914a22a7c866$require$Buffer = $838j1.Buffer;
var $8c99914a22a7c866$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $8c99914a22a7c866$var$W = new Array(160);
function $8c99914a22a7c866$var$Sha512() {
    this.init();
    this._w = $8c99914a22a7c866$var$W;
    $klEcH.call(this, 128, 112);
}
$dhT4G($8c99914a22a7c866$var$Sha512, $klEcH);
$8c99914a22a7c866$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $8c99914a22a7c866$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $8c99914a22a7c866$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $8c99914a22a7c866$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $8c99914a22a7c866$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $8c99914a22a7c866$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $8c99914a22a7c866$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $8c99914a22a7c866$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $8c99914a22a7c866$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $8c99914a22a7c866$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$8c99914a22a7c866$var$Sha512.prototype._update = function(M) {
    var w = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        w[i] = M.readInt32BE(i * 4);
        w[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = w[i - 30];
        var xl = w[i - 30 + 1];
        var gamma0 = $8c99914a22a7c866$var$Gamma0(xh, xl);
        var gamma0l = $8c99914a22a7c866$var$Gamma0l(xl, xh);
        xh = w[i - 4];
        xl = w[i - 4 + 1];
        var gamma1 = $8c99914a22a7c866$var$Gamma1(xh, xl);
        var gamma1l = $8c99914a22a7c866$var$Gamma1l(xl, xh);
        // w[i] = gamma0 + w[i - 7] + gamma1 + w[i - 16]
        var Wi7h = w[i - 14];
        var Wi7l = w[i - 14 + 1];
        var Wi16h = w[i - 32];
        var Wi16l = w[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $8c99914a22a7c866$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $8c99914a22a7c866$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $8c99914a22a7c866$var$getCarry(Wil, Wi16l) | 0;
        w[i] = Wih;
        w[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = w[j];
        Wil = w[j + 1];
        var majh = $8c99914a22a7c866$var$maj(ah, bh, ch);
        var majl = $8c99914a22a7c866$var$maj(al, bl, cl);
        var sigma0h = $8c99914a22a7c866$var$sigma0(ah, al);
        var sigma0l = $8c99914a22a7c866$var$sigma0(al, ah);
        var sigma1h = $8c99914a22a7c866$var$sigma1(eh, el);
        var sigma1l = $8c99914a22a7c866$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + w[j]
        var Kih = $8c99914a22a7c866$var$K[j];
        var Kil = $8c99914a22a7c866$var$K[j + 1];
        var chh = $8c99914a22a7c866$var$Ch(eh, fh, gh);
        var chl = $8c99914a22a7c866$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $8c99914a22a7c866$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $8c99914a22a7c866$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $8c99914a22a7c866$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $8c99914a22a7c866$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $8c99914a22a7c866$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $8c99914a22a7c866$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $8c99914a22a7c866$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $8c99914a22a7c866$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $8c99914a22a7c866$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $8c99914a22a7c866$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $8c99914a22a7c866$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $8c99914a22a7c866$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $8c99914a22a7c866$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $8c99914a22a7c866$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $8c99914a22a7c866$var$getCarry(this._hl, hl) | 0;
};
$8c99914a22a7c866$var$Sha512.prototype._hash = function() {
    var H = $8c99914a22a7c866$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $8c99914a22a7c866$var$Sha512;

});



parcelRegister("6GOuC", function(module, exports) {
'use strict';

var $838j1 = parcelRequire("838j1");
var $4dedd5233519b29a$require$Buffer = $838j1.Buffer;

var $3DkjE = parcelRequire("3DkjE");
var $4dedd5233519b29a$require$Transform = $3DkjE.Transform;

var $iGJyf = parcelRequire("iGJyf");
var $4dedd5233519b29a$require$StringDecoder = $iGJyf.StringDecoder;

var $dhT4G = parcelRequire("dhT4G");

var $iDFZs = parcelRequire("iDFZs");
function $4dedd5233519b29a$var$CipherBase(hashMode) {
    $4dedd5233519b29a$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this['final'] = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$dhT4G($4dedd5233519b29a$var$CipherBase, $4dedd5233519b29a$require$Transform);
$4dedd5233519b29a$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    var bufferData = $iDFZs(data, inputEnc); // asserts correct input type
    var outData = this._update(bufferData);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$4dedd5233519b29a$var$CipherBase.prototype.setAutoPadding = function() {};
$4dedd5233519b29a$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$4dedd5233519b29a$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$4dedd5233519b29a$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$4dedd5233519b29a$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$4dedd5233519b29a$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$4dedd5233519b29a$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $4dedd5233519b29a$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$4dedd5233519b29a$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $4dedd5233519b29a$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can\u2019t switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $4dedd5233519b29a$var$CipherBase;

});


parcelRegister("cL3Ff", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $9gEy8 = parcelRequire("9gEy8");

var $6GOuC = parcelRequire("6GOuC");

var $838j1 = parcelRequire("838j1");
var $949cb77e369e305c$require$Buffer = $838j1.Buffer;

var $7S8oP = parcelRequire("7S8oP");

var $1Jsb3 = parcelRequire("1Jsb3");

var $15EwC = parcelRequire("15EwC");
var $949cb77e369e305c$var$ZEROS = $949cb77e369e305c$require$Buffer.alloc(128);
function $949cb77e369e305c$var$Hmac(alg, key) {
    $6GOuC.call(this, 'digest');
    if (typeof key === 'string') key = $949cb77e369e305c$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $1Jsb3() : $15EwC(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $949cb77e369e305c$require$Buffer.concat([
        key,
        $949cb77e369e305c$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $949cb77e369e305c$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $949cb77e369e305c$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $1Jsb3() : $15EwC(alg);
    this._hash.update(ipad);
}
$dhT4G($949cb77e369e305c$var$Hmac, $6GOuC);
$949cb77e369e305c$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$949cb77e369e305c$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $1Jsb3() : $15EwC(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $949cb77e369e305c$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $9gEy8($7S8oP, key);
    return new $949cb77e369e305c$var$Hmac(alg, key);
};

});
parcelRegister("9gEy8", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $838j1 = parcelRequire("838j1");
var $6bf50ffe31847a3e$require$Buffer = $838j1.Buffer;

var $6GOuC = parcelRequire("6GOuC");
var $6bf50ffe31847a3e$var$ZEROS = $6bf50ffe31847a3e$require$Buffer.alloc(128);
var $6bf50ffe31847a3e$var$blocksize = 64;
function $6bf50ffe31847a3e$var$Hmac(alg, key) {
    $6GOuC.call(this, 'digest');
    if (typeof key === 'string') key = $6bf50ffe31847a3e$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $6bf50ffe31847a3e$var$blocksize) key = alg(key);
    else if (key.length < $6bf50ffe31847a3e$var$blocksize) key = $6bf50ffe31847a3e$require$Buffer.concat([
        key,
        $6bf50ffe31847a3e$var$ZEROS
    ], $6bf50ffe31847a3e$var$blocksize);
    var ipad = this._ipad = $6bf50ffe31847a3e$require$Buffer.allocUnsafe($6bf50ffe31847a3e$var$blocksize);
    var opad = this._opad = $6bf50ffe31847a3e$require$Buffer.allocUnsafe($6bf50ffe31847a3e$var$blocksize);
    for(var i = 0; i < $6bf50ffe31847a3e$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$dhT4G($6bf50ffe31847a3e$var$Hmac, $6GOuC);
$6bf50ffe31847a3e$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$6bf50ffe31847a3e$var$Hmac.prototype._final = function() {
    var h = this._alg($6bf50ffe31847a3e$require$Buffer.concat(this._hash));
    return this._alg($6bf50ffe31847a3e$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $6bf50ffe31847a3e$var$Hmac;

});

parcelRegister("7S8oP", function(module, exports) {

var $2GAk4 = parcelRequire("2GAk4");
module.exports = function(buffer) {
    return new $2GAk4().update(buffer).digest();
};

});


parcelRegister("gm4QM", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});

parcelRegister("jZEYv", function(module, exports) {
'use strict';

var $838j1 = parcelRequire("838j1");
var $e8e37f9705f45c6f$require$Buffer = $838j1.Buffer;

var $cGyf5 = parcelRequire("cGyf5");

var $i7B8N = parcelRequire("i7B8N");

var $9Tp97 = parcelRequire("9Tp97");

var $8NXst = parcelRequire("8NXst");
var $e8e37f9705f45c6f$var$ZERO_BUF;
var $e8e37f9705f45c6f$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $e8e37f9705f45c6f$var$toBrowser = {
    sha: 'SHA-1',
    'sha-1': 'SHA-1',
    sha1: 'SHA-1',
    sha256: 'SHA-256',
    'sha-256': 'SHA-256',
    sha384: 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    sha512: 'SHA-512'
};
var $e8e37f9705f45c6f$var$checks = [];
var $e8e37f9705f45c6f$var$nextTick;
function $e8e37f9705f45c6f$var$getNextTick() {
    if ($e8e37f9705f45c6f$var$nextTick) return $e8e37f9705f45c6f$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $e8e37f9705f45c6f$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $e8e37f9705f45c6f$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $e8e37f9705f45c6f$var$nextTick = $parcel$global.setImmediate;
    else $e8e37f9705f45c6f$var$nextTick = $parcel$global.setTimeout;
    return $e8e37f9705f45c6f$var$nextTick;
}
function $e8e37f9705f45c6f$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $e8e37f9705f45c6f$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $e8e37f9705f45c6f$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $e8e37f9705f45c6f$require$Buffer.from(res);
    });
}
function $e8e37f9705f45c6f$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$e8e37f9705f45c6f$var$subtle || !$e8e37f9705f45c6f$var$subtle.importKey || !$e8e37f9705f45c6f$var$subtle.deriveBits) return Promise.resolve(false);
    if ($e8e37f9705f45c6f$var$checks[algo] !== undefined) return $e8e37f9705f45c6f$var$checks[algo];
    $e8e37f9705f45c6f$var$ZERO_BUF = $e8e37f9705f45c6f$var$ZERO_BUF || $e8e37f9705f45c6f$require$Buffer.alloc(8);
    var prom = $e8e37f9705f45c6f$var$browserPbkdf2($e8e37f9705f45c6f$var$ZERO_BUF, $e8e37f9705f45c6f$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }, function() {
        return false;
    });
    $e8e37f9705f45c6f$var$checks[algo] = prom;
    return prom;
}
function $e8e37f9705f45c6f$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $e8e37f9705f45c6f$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $e8e37f9705f45c6f$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    $cGyf5(iterations, keylen);
    password = $8NXst(password, $i7B8N, 'Password');
    salt = $8NXst(salt, $i7B8N, 'Salt');
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    digest = digest || 'sha1';
    var algo = $e8e37f9705f45c6f$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') {
        $e8e37f9705f45c6f$var$getNextTick()(function() {
            var out;
            try {
                out = $9Tp97(password, salt, iterations, keylen, digest);
            } catch (e) {
                callback(e);
                return;
            }
            callback(null, out);
        });
        return;
    }
    $e8e37f9705f45c6f$var$resolvePromise($e8e37f9705f45c6f$var$checkNative(algo).then(function(resp) {
        if (resp) return $e8e37f9705f45c6f$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $9Tp97(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("cGyf5", function(module, exports) {
'use strict';
var $93c3f812afbfc00a$var$$isFinite = isFinite;
var $93c3f812afbfc00a$var$MAX_ALLOC = Math.pow(2, 30) - 1; // default in iojs
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0 || !$93c3f812afbfc00a$var$$isFinite(iterations)) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $93c3f812afbfc00a$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
};

});

parcelRegister("i7B8N", function(module, exports) {

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
var $d315b0d2c7e0b4e5$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $d315b0d2c7e0b4e5$var$defaultEncoding = 'utf-8';
else if ($parcel$global.process && $parcel$global.process.version) {
    var $d315b0d2c7e0b4e5$var$pVersionMajor = parseInt($4ZL0H.version.split('.')[0].slice(1), 10);
    $d315b0d2c7e0b4e5$var$defaultEncoding = $d315b0d2c7e0b4e5$var$pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else $d315b0d2c7e0b4e5$var$defaultEncoding = 'utf-8';
module.exports = $d315b0d2c7e0b4e5$var$defaultEncoding;

});

parcelRegister("9Tp97", function(module, exports) {
'use strict';

var $7S8oP = parcelRequire("7S8oP");

var $1Jsb3 = parcelRequire("1Jsb3");

var $15EwC = parcelRequire("15EwC");

var $838j1 = parcelRequire("838j1");
var $01dbd19307582e29$require$Buffer = $838j1.Buffer;

var $cGyf5 = parcelRequire("cGyf5");

var $i7B8N = parcelRequire("i7B8N");

var $8NXst = parcelRequire("8NXst");
var $01dbd19307582e29$var$ZEROS = $01dbd19307582e29$require$Buffer.alloc(128);
var $01dbd19307582e29$var$sizes = {
    __proto__: null,
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    'sha512-256': 32,
    ripemd160: 20,
    rmd160: 20
};
var $01dbd19307582e29$var$mapping = {
    __proto__: null,
    'sha-1': 'sha1',
    'sha-224': 'sha224',
    'sha-256': 'sha256',
    'sha-384': 'sha384',
    'sha-512': 'sha512',
    'ripemd-160': 'ripemd160'
};
function $01dbd19307582e29$var$rmd160Func(data) {
    return new $1Jsb3().update(data).digest();
}
function $01dbd19307582e29$var$getDigest(alg) {
    function shaFunc(data) {
        return $15EwC(alg).update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return $01dbd19307582e29$var$rmd160Func;
    if (alg === 'md5') return $7S8oP;
    return shaFunc;
}
function $01dbd19307582e29$var$Hmac(alg, key, saltLen) {
    var hash = $01dbd19307582e29$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $01dbd19307582e29$require$Buffer.concat([
        key,
        $01dbd19307582e29$var$ZEROS
    ], blocksize);
    var ipad = $01dbd19307582e29$require$Buffer.allocUnsafe(blocksize + $01dbd19307582e29$var$sizes[alg]);
    var opad = $01dbd19307582e29$require$Buffer.allocUnsafe(blocksize + $01dbd19307582e29$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $01dbd19307582e29$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $01dbd19307582e29$var$sizes[alg];
}
$01dbd19307582e29$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $01dbd19307582e29$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $cGyf5(iterations, keylen);
    password = $8NXst(password, $i7B8N, 'Password');
    salt = $8NXst(salt, $i7B8N, 'Salt');
    var lowerDigest = (digest || 'sha1').toLowerCase();
    var mappedDigest = $01dbd19307582e29$var$mapping[lowerDigest] || lowerDigest;
    var size = $01dbd19307582e29$var$sizes[mappedDigest];
    if (typeof size !== 'number' || !size) throw new TypeError('Digest algorithm not supported: ' + digest);
    var hmac = new $01dbd19307582e29$var$Hmac(mappedDigest, password, salt.length);
    var DK = $01dbd19307582e29$require$Buffer.allocUnsafe(keylen);
    var block1 = $01dbd19307582e29$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = size;
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $01dbd19307582e29$var$pbkdf2;

});
parcelRegister("8NXst", function(module, exports) {
'use strict';

var $838j1 = parcelRequire("838j1");
var $66910584d1dc48dd$require$Buffer = $838j1.Buffer;

var $iDFZs = parcelRequire("iDFZs");
var $66910584d1dc48dd$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $66910584d1dc48dd$var$useArrayBuffer = $66910584d1dc48dd$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $66910584d1dc48dd$var$isView = $66910584d1dc48dd$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding, name) {
    if (typeof thing === 'string' || $66910584d1dc48dd$require$Buffer.isBuffer(thing) || $66910584d1dc48dd$var$useUint8Array && thing instanceof Uint8Array || $66910584d1dc48dd$var$isView && $66910584d1dc48dd$var$isView(thing)) return $iDFZs(thing, encoding);
    throw new TypeError(name + ' must be a string, a Buffer, a Uint8Array, or a DataView');
};

});



parcelRegister("aSiVb", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", function () { return $7ead9fe90fb60003$export$cfaef8ed399428b0; }, function (v) { return $7ead9fe90fb60003$export$cfaef8ed399428b0 = v; });
$parcel$export(module.exports, "writeUInt32BE", function () { return $7ead9fe90fb60003$export$a80c7deaea7cbd80; }, function (v) { return $7ead9fe90fb60003$export$a80c7deaea7cbd80 = v; });
$parcel$export(module.exports, "ip", function () { return $7ead9fe90fb60003$export$ed7577ae6e1cd0ef; }, function (v) { return $7ead9fe90fb60003$export$ed7577ae6e1cd0ef = v; });
$parcel$export(module.exports, "rip", function () { return $7ead9fe90fb60003$export$5dcbef3aa594f567; }, function (v) { return $7ead9fe90fb60003$export$5dcbef3aa594f567 = v; });
$parcel$export(module.exports, "pc1", function () { return $7ead9fe90fb60003$export$5bc8001ca71ed9c5; }, function (v) { return $7ead9fe90fb60003$export$5bc8001ca71ed9c5 = v; });
$parcel$export(module.exports, "r28shl", function () { return $7ead9fe90fb60003$export$3e714e2c5d5d8cb2; }, function (v) { return $7ead9fe90fb60003$export$3e714e2c5d5d8cb2 = v; });
$parcel$export(module.exports, "pc2", function () { return $7ead9fe90fb60003$export$94c3e544fd062b7f; }, function (v) { return $7ead9fe90fb60003$export$94c3e544fd062b7f = v; });
$parcel$export(module.exports, "expand", function () { return $7ead9fe90fb60003$export$9f77e0932fb78f72; }, function (v) { return $7ead9fe90fb60003$export$9f77e0932fb78f72 = v; });
$parcel$export(module.exports, "substitute", function () { return $7ead9fe90fb60003$export$d865ce2836f5927f; }, function (v) { return $7ead9fe90fb60003$export$d865ce2836f5927f = v; });
$parcel$export(module.exports, "permute", function () { return $7ead9fe90fb60003$export$95e62ad65da8b7d2; }, function (v) { return $7ead9fe90fb60003$export$95e62ad65da8b7d2 = v; });
$parcel$export(module.exports, "padSplit", function () { return $7ead9fe90fb60003$export$209139ff098c441a; }, function (v) { return $7ead9fe90fb60003$export$209139ff098c441a = v; });
var $7ead9fe90fb60003$export$cfaef8ed399428b0;
var $7ead9fe90fb60003$export$a80c7deaea7cbd80;
var $7ead9fe90fb60003$export$ed7577ae6e1cd0ef;
var $7ead9fe90fb60003$export$5dcbef3aa594f567;
var $7ead9fe90fb60003$export$5bc8001ca71ed9c5;
var $7ead9fe90fb60003$export$3e714e2c5d5d8cb2;
var $7ead9fe90fb60003$export$94c3e544fd062b7f;
var $7ead9fe90fb60003$export$9f77e0932fb78f72;
var $7ead9fe90fb60003$export$d865ce2836f5927f;
var $7ead9fe90fb60003$export$95e62ad65da8b7d2;
var $7ead9fe90fb60003$export$209139ff098c441a;
'use strict';
$7ead9fe90fb60003$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$7ead9fe90fb60003$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$7ead9fe90fb60003$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7ead9fe90fb60003$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7ead9fe90fb60003$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7ead9fe90fb60003$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $7ead9fe90fb60003$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$7ead9fe90fb60003$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $7ead9fe90fb60003$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $7ead9fe90fb60003$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $7ead9fe90fb60003$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $7ead9fe90fb60003$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7ead9fe90fb60003$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $7ead9fe90fb60003$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$7ead9fe90fb60003$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $7ead9fe90fb60003$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $7ead9fe90fb60003$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $7ead9fe90fb60003$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$7ead9fe90fb60003$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $7ead9fe90fb60003$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $7ead9fe90fb60003$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$7ead9fe90fb60003$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("en1ji", function(module, exports) {
'use strict';

var $jLTFB = parcelRequire("jLTFB");
function $a7643ad938c9a927$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $a7643ad938c9a927$var$Cipher;
$a7643ad938c9a927$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$a7643ad938c9a927$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$a7643ad938c9a927$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$a7643ad938c9a927$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$a7643ad938c9a927$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$a7643ad938c9a927$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$a7643ad938c9a927$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$a7643ad938c9a927$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$a7643ad938c9a927$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$a7643ad938c9a927$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$a7643ad938c9a927$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $jLTFB.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("jLTFB", function(module, exports) {
module.exports = $e64d96feb50adf1f$var$assert;
function $e64d96feb50adf1f$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$e64d96feb50adf1f$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});


parcelRegister("gv6xd", function(module, exports) {
'use strict';

var $jLTFB = parcelRequire("jLTFB");

var $dhT4G = parcelRequire("dhT4G");

var $aSiVb = parcelRequire("aSiVb");

var $en1ji = parcelRequire("en1ji");
function $c0349c4390f1b908$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $c0349c4390f1b908$var$DES(options) {
    $en1ji.call(this, options);
    var state = new $c0349c4390f1b908$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$dhT4G($c0349c4390f1b908$var$DES, $en1ji);
module.exports = $c0349c4390f1b908$var$DES;
$c0349c4390f1b908$var$DES.create = function create(options) {
    return new $c0349c4390f1b908$var$DES(options);
};
var $c0349c4390f1b908$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$c0349c4390f1b908$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $jLTFB.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $aSiVb.readUInt32BE(key, 0);
    var kR = $aSiVb.readUInt32BE(key, 4);
    $aSiVb.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $c0349c4390f1b908$var$shiftTable[i >>> 1];
        kL = $aSiVb.r28shl(kL, shift);
        kR = $aSiVb.r28shl(kR, shift);
        $aSiVb.pc2(kL, kR, state.keys, i);
    }
};
$c0349c4390f1b908$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $aSiVb.readUInt32BE(inp, inOff);
    var r = $aSiVb.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $aSiVb.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $aSiVb.writeUInt32BE(out, l, outOff);
    $aSiVb.writeUInt32BE(out, r, outOff + 4);
};
$c0349c4390f1b908$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$c0349c4390f1b908$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$jLTFB.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$c0349c4390f1b908$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $aSiVb.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $aSiVb.substitute(keyL, keyR);
        var f = $aSiVb.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $aSiVb.rip(r, l, out, off);
};
$c0349c4390f1b908$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $aSiVb.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $aSiVb.substitute(keyL, keyR);
        var f = $aSiVb.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $aSiVb.rip(l, r, out, off);
};

});

parcelRegister("f8Mbw", function(module, exports) {

$parcel$export(module.exports, "instantiate", function () { return $b05cfadcd775606f$export$f9bb8d20ccc7477a; }, function (v) { return $b05cfadcd775606f$export$f9bb8d20ccc7477a = v; });
var $b05cfadcd775606f$export$f9bb8d20ccc7477a;
'use strict';

var $jLTFB = parcelRequire("jLTFB");

var $dhT4G = parcelRequire("dhT4G");
var $b05cfadcd775606f$var$proto = {};
function $b05cfadcd775606f$var$CBCState(iv) {
    $jLTFB.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $b05cfadcd775606f$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $dhT4G(CBC, Base);
    var keys = Object.keys($b05cfadcd775606f$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $b05cfadcd775606f$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$b05cfadcd775606f$export$f9bb8d20ccc7477a = $b05cfadcd775606f$var$instantiate;
$b05cfadcd775606f$var$proto._cbcInit = function _cbcInit() {
    var state = new $b05cfadcd775606f$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$b05cfadcd775606f$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("f5Nr9", function(module, exports) {
'use strict';

var $jLTFB = parcelRequire("jLTFB");

var $dhT4G = parcelRequire("dhT4G");

var $en1ji = parcelRequire("en1ji");

var $gv6xd = parcelRequire("gv6xd");
function $afcdabc931806f45$var$EDEState(type, key) {
    $jLTFB.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $gv6xd.create({
            type: 'encrypt',
            key: k1
        }),
        $gv6xd.create({
            type: 'decrypt',
            key: k2
        }),
        $gv6xd.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $gv6xd.create({
            type: 'decrypt',
            key: k3
        }),
        $gv6xd.create({
            type: 'encrypt',
            key: k2
        }),
        $gv6xd.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $afcdabc931806f45$var$EDE(options) {
    $en1ji.call(this, options);
    var state = new $afcdabc931806f45$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$dhT4G($afcdabc931806f45$var$EDE, $en1ji);
module.exports = $afcdabc931806f45$var$EDE;
$afcdabc931806f45$var$EDE.create = function create(options) {
    return new $afcdabc931806f45$var$EDE(options);
};
$afcdabc931806f45$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$afcdabc931806f45$var$EDE.prototype._pad = $gv6xd.prototype._pad;
$afcdabc931806f45$var$EDE.prototype._unpad = $gv6xd.prototype._unpad;

});

parcelRegister("4VNRd", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $397328e55f3c5ce5$export$5b0f6292f11d1d18; }, function (v) { return $397328e55f3c5ce5$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $397328e55f3c5ce5$export$e85a0c9a1067c5d3; }, function (v) { return $397328e55f3c5ce5$export$e85a0c9a1067c5d3 = v; });
var $397328e55f3c5ce5$export$5b0f6292f11d1d18;
var $397328e55f3c5ce5$export$e85a0c9a1067c5d3;
$397328e55f3c5ce5$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$397328e55f3c5ce5$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("dSvNa", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $a1a8faba74f8f15b$export$5b0f6292f11d1d18; }, function (v) { return $a1a8faba74f8f15b$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $a1a8faba74f8f15b$export$e85a0c9a1067c5d3; }, function (v) { return $a1a8faba74f8f15b$export$e85a0c9a1067c5d3 = v; });
var $a1a8faba74f8f15b$export$5b0f6292f11d1d18;
var $a1a8faba74f8f15b$export$e85a0c9a1067c5d3;

var $lG93x = parcelRequire("lG93x");
$a1a8faba74f8f15b$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $lG93x(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$a1a8faba74f8f15b$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $lG93x(out, pad);
};

});
parcelRegister("lG93x", function(module, exports) {

var $bdjQ6 = parcelRequire("bdjQ6");
var $fc848b8cbe231ed8$require$Buffer = $bdjQ6.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $fc848b8cbe231ed8$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("hBCvG", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $cd13c3a99dff038d$export$5b0f6292f11d1d18; }, function (v) { return $cd13c3a99dff038d$export$5b0f6292f11d1d18 = v; });
var $cd13c3a99dff038d$export$5b0f6292f11d1d18;

var $838j1 = parcelRequire("838j1");
var $cd13c3a99dff038d$require$Buffer = $838j1.Buffer;

var $lG93x = parcelRequire("lG93x");
function $cd13c3a99dff038d$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $lG93x(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $cd13c3a99dff038d$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$cd13c3a99dff038d$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $cd13c3a99dff038d$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $cd13c3a99dff038d$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $cd13c3a99dff038d$require$Buffer.concat([
                out,
                $cd13c3a99dff038d$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $cd13c3a99dff038d$require$Buffer.concat([
                out,
                $cd13c3a99dff038d$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("4EjJt", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $362a34512b2cb660$export$5b0f6292f11d1d18; }, function (v) { return $362a34512b2cb660$export$5b0f6292f11d1d18 = v; });
var $362a34512b2cb660$export$5b0f6292f11d1d18;

var $838j1 = parcelRequire("838j1");
var $362a34512b2cb660$require$Buffer = $838j1.Buffer;
function $362a34512b2cb660$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $362a34512b2cb660$require$Buffer.concat([
        self._prev.slice(1),
        $362a34512b2cb660$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$362a34512b2cb660$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $362a34512b2cb660$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $362a34512b2cb660$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("deF8T", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $9a2c7f2fbbd3a86b$export$5b0f6292f11d1d18; }, function (v) { return $9a2c7f2fbbd3a86b$export$5b0f6292f11d1d18 = v; });
var $9a2c7f2fbbd3a86b$export$5b0f6292f11d1d18;

var $838j1 = parcelRequire("838j1");
var $9a2c7f2fbbd3a86b$require$Buffer = $838j1.Buffer;
function $9a2c7f2fbbd3a86b$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $9a2c7f2fbbd3a86b$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $9a2c7f2fbbd3a86b$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $9a2c7f2fbbd3a86b$require$Buffer.allocUnsafe(buffer.length);
    buffer = $9a2c7f2fbbd3a86b$require$Buffer.concat([
        buffer,
        $9a2c7f2fbbd3a86b$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$9a2c7f2fbbd3a86b$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $9a2c7f2fbbd3a86b$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $9a2c7f2fbbd3a86b$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("bxTz8", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $867de0f3149c6687$export$5b0f6292f11d1d18; }, function (v) { return $867de0f3149c6687$export$5b0f6292f11d1d18 = v; });
var $867de0f3149c6687$export$5b0f6292f11d1d18;

var $bdjQ6 = parcelRequire("bdjQ6");
var $867de0f3149c6687$require$Buffer = $bdjQ6.Buffer;

var $lG93x = parcelRequire("lG93x");
function $867de0f3149c6687$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$867de0f3149c6687$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $867de0f3149c6687$require$Buffer.concat([
        self._cache,
        $867de0f3149c6687$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $lG93x(chunk, pad);
};

});

parcelRegister("5DIgH", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $41b2ef081a6e05a6$export$5b0f6292f11d1d18; }, function (v) { return $41b2ef081a6e05a6$export$5b0f6292f11d1d18 = v; });
var $41b2ef081a6e05a6$export$5b0f6292f11d1d18;

var $lG93x = parcelRequire("lG93x");

var $838j1 = parcelRequire("838j1");
var $41b2ef081a6e05a6$require$Buffer = $838j1.Buffer;

var $h75HQ = parcelRequire("h75HQ");
function $41b2ef081a6e05a6$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $h75HQ(self._prev);
    return out;
}
var $41b2ef081a6e05a6$var$blockSize = 16;
$41b2ef081a6e05a6$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $41b2ef081a6e05a6$var$blockSize);
    var start = self._cache.length;
    self._cache = $41b2ef081a6e05a6$require$Buffer.concat([
        self._cache,
        $41b2ef081a6e05a6$require$Buffer.allocUnsafe(chunkNum * $41b2ef081a6e05a6$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $41b2ef081a6e05a6$var$getBlock(self);
        var offset = start + i * $41b2ef081a6e05a6$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $lG93x(chunk, pad);
};

});
parcelRegister("h75HQ", function(module, exports) {
function $c7578441bba1d8c9$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $c7578441bba1d8c9$var$incr32;

});


parcelRegister("8pG42", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("ifbub")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("8OaS6", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("ifbub")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("gWiKw", function(module, exports) {
var $c5509b5bd465f083$var$r;
module.exports = function rand(len) {
    if (!$c5509b5bd465f083$var$r) $c5509b5bd465f083$var$r = new $c5509b5bd465f083$var$Rand(null);
    return $c5509b5bd465f083$var$r.generate(len);
};
function $c5509b5bd465f083$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $c5509b5bd465f083$var$Rand;
$c5509b5bd465f083$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$c5509b5bd465f083$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $c5509b5bd465f083$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $c5509b5bd465f083$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $c5509b5bd465f083$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $c5509b5bd465f083$var$crypto = (parcelRequire("ifbub"));
    if (typeof $c5509b5bd465f083$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $c5509b5bd465f083$var$Rand.prototype._rand = function _rand(n) {
        return $c5509b5bd465f083$var$crypto.randomBytes(n);
    };
} catch (e) {}

});

parcelRegister("aVh2m", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("ifbub")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("5yWHA", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.6.1\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

});

parcelRegister("2KPxf", function(module, exports) {
'use strict';
var $2017da7f3b92fe8f$var$utils = module.exports;

var $7iECc = parcelRequire("7iECc");

var $jLTFB = parcelRequire("jLTFB");

var $bA0W1 = parcelRequire("bA0W1");
$2017da7f3b92fe8f$var$utils.assert = $jLTFB;
$2017da7f3b92fe8f$var$utils.toArray = $bA0W1.toArray;
$2017da7f3b92fe8f$var$utils.zero2 = $bA0W1.zero2;
$2017da7f3b92fe8f$var$utils.toHex = $bA0W1.toHex;
$2017da7f3b92fe8f$var$utils.encode = $bA0W1.encode;
// Represent num in a w-NAF form
function $2017da7f3b92fe8f$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$2017da7f3b92fe8f$var$utils.getNAF = $2017da7f3b92fe8f$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $2017da7f3b92fe8f$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$2017da7f3b92fe8f$var$utils.getJSF = $2017da7f3b92fe8f$var$getJSF;
function $2017da7f3b92fe8f$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$2017da7f3b92fe8f$var$utils.cachedProperty = $2017da7f3b92fe8f$var$cachedProperty;
function $2017da7f3b92fe8f$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $2017da7f3b92fe8f$var$utils.toArray(bytes, 'hex') : bytes;
}
$2017da7f3b92fe8f$var$utils.parseBytes = $2017da7f3b92fe8f$var$parseBytes;
function $2017da7f3b92fe8f$var$intFromLE(bytes) {
    return new $7iECc(bytes, 'hex', 'le');
}
$2017da7f3b92fe8f$var$utils.intFromLE = $2017da7f3b92fe8f$var$intFromLE;

});
parcelRegister("7iECc", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("ifbub")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("bA0W1", function(module, exports) {
'use strict';
var $86e3c8252f82bd4d$var$utils = module.exports;
function $86e3c8252f82bd4d$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$86e3c8252f82bd4d$var$utils.toArray = $86e3c8252f82bd4d$var$toArray;
function $86e3c8252f82bd4d$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$86e3c8252f82bd4d$var$utils.zero2 = $86e3c8252f82bd4d$var$zero2;
function $86e3c8252f82bd4d$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $86e3c8252f82bd4d$var$zero2(msg[i].toString(16));
    return res;
}
$86e3c8252f82bd4d$var$utils.toHex = $86e3c8252f82bd4d$var$toHex;
$86e3c8252f82bd4d$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $86e3c8252f82bd4d$var$toHex(arr);
    else return arr;
};

});


parcelRegister("5Hkfi", function(module, exports) {
'use strict';
var $4260ac48d49db708$var$curve = module.exports;

$4260ac48d49db708$var$curve.base = (parcelRequire("8dytk"));

$4260ac48d49db708$var$curve.short = (parcelRequire("6gfS3"));

$4260ac48d49db708$var$curve.mont = (parcelRequire("cpeEK"));

$4260ac48d49db708$var$curve.edwards = (parcelRequire("1tM9R"));

});
parcelRegister("8dytk", function(module, exports) {
'use strict';

var $7iECc = parcelRequire("7iECc");

var $2KPxf = parcelRequire("2KPxf");
var $5fba47135c9f13e6$var$getNAF = $2KPxf.getNAF;
var $5fba47135c9f13e6$var$getJSF = $2KPxf.getJSF;
var $5fba47135c9f13e6$var$assert = $2KPxf.assert;
function $5fba47135c9f13e6$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $7iECc(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $7iECc.red(conf.prime) : $7iECc.mont(this.p);
    // Useful for many curves
    this.zero = new $7iECc(0).toRed(this.red);
    this.one = new $7iECc(1).toRed(this.red);
    this.two = new $7iECc(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $7iECc(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $5fba47135c9f13e6$var$BaseCurve;
$5fba47135c9f13e6$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$5fba47135c9f13e6$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$5fba47135c9f13e6$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $5fba47135c9f13e6$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $5fba47135c9f13e6$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$5fba47135c9f13e6$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $5fba47135c9f13e6$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $5fba47135c9f13e6$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$5fba47135c9f13e6$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $5fba47135c9f13e6$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $5fba47135c9f13e6$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $5fba47135c9f13e6$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $5fba47135c9f13e6$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$5fba47135c9f13e6$var$BaseCurve.BasePoint = $5fba47135c9f13e6$var$BasePoint;
$5fba47135c9f13e6$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$5fba47135c9f13e6$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$5fba47135c9f13e6$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $2KPxf.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $5fba47135c9f13e6$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $5fba47135c9f13e6$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$5fba47135c9f13e6$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$5fba47135c9f13e6$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$5fba47135c9f13e6$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $2KPxf.encode(this._encode(compact), enc);
};
$5fba47135c9f13e6$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$5fba47135c9f13e6$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$5fba47135c9f13e6$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$5fba47135c9f13e6$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$5fba47135c9f13e6$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$5fba47135c9f13e6$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("6gfS3", function(module, exports) {
'use strict';

var $2KPxf = parcelRequire("2KPxf");

var $7iECc = parcelRequire("7iECc");

var $dhT4G = parcelRequire("dhT4G");

var $8dytk = parcelRequire("8dytk");
var $48f08c4e491a3d05$var$assert = $2KPxf.assert;
function $48f08c4e491a3d05$var$ShortCurve(conf) {
    $8dytk.call(this, 'short', conf);
    this.a = new $7iECc(conf.a, 16).toRed(this.red);
    this.b = new $7iECc(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$dhT4G($48f08c4e491a3d05$var$ShortCurve, $8dytk);
module.exports = $48f08c4e491a3d05$var$ShortCurve;
$48f08c4e491a3d05$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $7iECc(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $7iECc(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $48f08c4e491a3d05$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $7iECc(vec.a, 16),
            b: new $7iECc(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$48f08c4e491a3d05$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $7iECc.mont(num);
    var tinv = new $7iECc(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $7iECc(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$48f08c4e491a3d05$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $7iECc(1);
    var y1 = new $7iECc(0);
    var x2 = new $7iECc(0);
    var y2 = new $7iECc(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$48f08c4e491a3d05$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$48f08c4e491a3d05$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $7iECc(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$48f08c4e491a3d05$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$48f08c4e491a3d05$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $48f08c4e491a3d05$var$Point(curve, x, y, isRed) {
    $8dytk.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $7iECc(x, 16);
        this.y = new $7iECc(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$dhT4G($48f08c4e491a3d05$var$Point, $8dytk.BasePoint);
$48f08c4e491a3d05$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $48f08c4e491a3d05$var$Point(this, x, y, isRed);
};
$48f08c4e491a3d05$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $48f08c4e491a3d05$var$Point.fromJSON(this, obj, red);
};
$48f08c4e491a3d05$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$48f08c4e491a3d05$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$48f08c4e491a3d05$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$48f08c4e491a3d05$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$48f08c4e491a3d05$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$48f08c4e491a3d05$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$48f08c4e491a3d05$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$48f08c4e491a3d05$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$48f08c4e491a3d05$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$48f08c4e491a3d05$var$Point.prototype.mul = function mul(k) {
    k = new $7iECc(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$48f08c4e491a3d05$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$48f08c4e491a3d05$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$48f08c4e491a3d05$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$48f08c4e491a3d05$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$48f08c4e491a3d05$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $48f08c4e491a3d05$var$JPoint(curve, x, y, z) {
    $8dytk.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $7iECc(0);
    } else {
        this.x = new $7iECc(x, 16);
        this.y = new $7iECc(y, 16);
        this.z = new $7iECc(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$dhT4G($48f08c4e491a3d05$var$JPoint, $8dytk.BasePoint);
$48f08c4e491a3d05$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $48f08c4e491a3d05$var$JPoint(this, x, y, z);
};
$48f08c4e491a3d05$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$48f08c4e491a3d05$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$48f08c4e491a3d05$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$48f08c4e491a3d05$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$48f08c4e491a3d05$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$48f08c4e491a3d05$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$48f08c4e491a3d05$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$48f08c4e491a3d05$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$48f08c4e491a3d05$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$48f08c4e491a3d05$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$48f08c4e491a3d05$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $7iECc(k, kbase);
    return this.curve._wnafMul(this, k);
};
$48f08c4e491a3d05$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$48f08c4e491a3d05$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$48f08c4e491a3d05$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$48f08c4e491a3d05$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("cpeEK", function(module, exports) {
'use strict';

var $7iECc = parcelRequire("7iECc");

var $dhT4G = parcelRequire("dhT4G");

var $8dytk = parcelRequire("8dytk");

var $2KPxf = parcelRequire("2KPxf");
function $90833044cafb30f7$var$MontCurve(conf) {
    $8dytk.call(this, 'mont', conf);
    this.a = new $7iECc(conf.a, 16).toRed(this.red);
    this.b = new $7iECc(conf.b, 16).toRed(this.red);
    this.i4 = new $7iECc(4).toRed(this.red).redInvm();
    this.two = new $7iECc(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$dhT4G($90833044cafb30f7$var$MontCurve, $8dytk);
module.exports = $90833044cafb30f7$var$MontCurve;
$90833044cafb30f7$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $90833044cafb30f7$var$Point(curve, x, z) {
    $8dytk.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $7iECc(x, 16);
        this.z = new $7iECc(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$dhT4G($90833044cafb30f7$var$Point, $8dytk.BasePoint);
$90833044cafb30f7$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($2KPxf.toArray(bytes, enc), 1);
};
$90833044cafb30f7$var$MontCurve.prototype.point = function point(x, z) {
    return new $90833044cafb30f7$var$Point(this, x, z);
};
$90833044cafb30f7$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $90833044cafb30f7$var$Point.fromJSON(this, obj);
};
$90833044cafb30f7$var$Point.prototype.precompute = function precompute() {
// No-op
};
$90833044cafb30f7$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$90833044cafb30f7$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $90833044cafb30f7$var$Point(curve, obj[0], obj[1] || curve.one);
};
$90833044cafb30f7$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$90833044cafb30f7$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$90833044cafb30f7$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$90833044cafb30f7$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$90833044cafb30f7$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$90833044cafb30f7$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$90833044cafb30f7$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$90833044cafb30f7$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$90833044cafb30f7$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$90833044cafb30f7$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$90833044cafb30f7$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("1tM9R", function(module, exports) {
'use strict';

var $2KPxf = parcelRequire("2KPxf");

var $7iECc = parcelRequire("7iECc");

var $dhT4G = parcelRequire("dhT4G");

var $8dytk = parcelRequire("8dytk");
var $113ddb0a953c55e8$var$assert = $2KPxf.assert;
function $113ddb0a953c55e8$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $8dytk.call(this, 'edwards', conf);
    this.a = new $7iECc(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $7iECc(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $7iECc(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $113ddb0a953c55e8$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$dhT4G($113ddb0a953c55e8$var$EdwardsCurve, $8dytk);
module.exports = $113ddb0a953c55e8$var$EdwardsCurve;
$113ddb0a953c55e8$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$113ddb0a953c55e8$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$113ddb0a953c55e8$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$113ddb0a953c55e8$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $7iECc(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$113ddb0a953c55e8$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $7iECc(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$113ddb0a953c55e8$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $113ddb0a953c55e8$var$Point(curve, x, y, z, t) {
    $8dytk.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $7iECc(x, 16);
        this.y = new $7iECc(y, 16);
        this.z = z ? new $7iECc(z, 16) : this.curve.one;
        this.t = t && new $7iECc(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$dhT4G($113ddb0a953c55e8$var$Point, $8dytk.BasePoint);
$113ddb0a953c55e8$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $113ddb0a953c55e8$var$Point.fromJSON(this, obj);
};
$113ddb0a953c55e8$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $113ddb0a953c55e8$var$Point(this, x, y, z, t);
};
$113ddb0a953c55e8$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $113ddb0a953c55e8$var$Point(curve, obj[0], obj[1], obj[2]);
};
$113ddb0a953c55e8$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$113ddb0a953c55e8$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$113ddb0a953c55e8$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$113ddb0a953c55e8$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$113ddb0a953c55e8$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$113ddb0a953c55e8$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$113ddb0a953c55e8$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$113ddb0a953c55e8$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$113ddb0a953c55e8$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$113ddb0a953c55e8$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$113ddb0a953c55e8$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$113ddb0a953c55e8$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$113ddb0a953c55e8$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$113ddb0a953c55e8$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$113ddb0a953c55e8$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$113ddb0a953c55e8$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$113ddb0a953c55e8$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$113ddb0a953c55e8$var$Point.prototype.toP = $113ddb0a953c55e8$var$Point.prototype.normalize;
$113ddb0a953c55e8$var$Point.prototype.mixedAdd = $113ddb0a953c55e8$var$Point.prototype.add;

});


parcelRegister("hKjoi", function(module, exports) {
'use strict';
var $ceb5c625f77262d6$var$curves = module.exports;

var $gVjbv = parcelRequire("gVjbv");

var $5Hkfi = parcelRequire("5Hkfi");

var $2KPxf = parcelRequire("2KPxf");
var $ceb5c625f77262d6$var$assert = $2KPxf.assert;
function $ceb5c625f77262d6$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $5Hkfi.short(options);
    else if (options.type === 'edwards') this.curve = new $5Hkfi.edwards(options);
    else this.curve = new $5Hkfi.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $ceb5c625f77262d6$var$assert(this.g.validate(), 'Invalid curve');
    $ceb5c625f77262d6$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$ceb5c625f77262d6$var$curves.PresetCurve = $ceb5c625f77262d6$var$PresetCurve;
function $ceb5c625f77262d6$var$defineCurve(name, options) {
    Object.defineProperty($ceb5c625f77262d6$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $ceb5c625f77262d6$var$PresetCurve(options);
            Object.defineProperty($ceb5c625f77262d6$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$ceb5c625f77262d6$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $gVjbv.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$ceb5c625f77262d6$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $gVjbv.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$ceb5c625f77262d6$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $gVjbv.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$ceb5c625f77262d6$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $gVjbv.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$ceb5c625f77262d6$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $gVjbv.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$ceb5c625f77262d6$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $gVjbv.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$ceb5c625f77262d6$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $gVjbv.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $ceb5c625f77262d6$var$pre;

try {
    $ceb5c625f77262d6$var$pre = (parcelRequire("8M60a"));
} catch (e) {
    $ceb5c625f77262d6$var$pre = undefined;
}
$ceb5c625f77262d6$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $gVjbv.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $ceb5c625f77262d6$var$pre
    ]
});

});
parcelRegister("gVjbv", function(module, exports) {
var $c520d9d9fb7ed821$var$hash = module.exports;

$c520d9d9fb7ed821$var$hash.utils = (parcelRequire("1JocC"));

$c520d9d9fb7ed821$var$hash.common = (parcelRequire("cx4L0"));

$c520d9d9fb7ed821$var$hash.sha = (parcelRequire("czP09"));

$c520d9d9fb7ed821$var$hash.ripemd = (parcelRequire("1KcMM"));

$c520d9d9fb7ed821$var$hash.hmac = (parcelRequire("iBkDX"));
// Proxy hash functions to the main object
$c520d9d9fb7ed821$var$hash.sha1 = $c520d9d9fb7ed821$var$hash.sha.sha1;
$c520d9d9fb7ed821$var$hash.sha256 = $c520d9d9fb7ed821$var$hash.sha.sha256;
$c520d9d9fb7ed821$var$hash.sha224 = $c520d9d9fb7ed821$var$hash.sha.sha224;
$c520d9d9fb7ed821$var$hash.sha384 = $c520d9d9fb7ed821$var$hash.sha.sha384;
$c520d9d9fb7ed821$var$hash.sha512 = $c520d9d9fb7ed821$var$hash.sha.sha512;
$c520d9d9fb7ed821$var$hash.ripemd160 = $c520d9d9fb7ed821$var$hash.ripemd.ripemd160;

});
parcelRegister("1JocC", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $142cc48ad6105c40$export$69f1b2dcda23c5f8; }, function (v) { return $142cc48ad6105c40$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $142cc48ad6105c40$export$45b10814cc054894; }, function (v) { return $142cc48ad6105c40$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $142cc48ad6105c40$export$7ea66e3774a60b67; }, function (v) { return $142cc48ad6105c40$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $142cc48ad6105c40$export$34a52f00f601f6f1; }, function (v) { return $142cc48ad6105c40$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $142cc48ad6105c40$export$812b0cbd5e8a72ab; }, function (v) { return $142cc48ad6105c40$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $142cc48ad6105c40$export$f24f9e11d63bb314; }, function (v) { return $142cc48ad6105c40$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $142cc48ad6105c40$export$b71357c7e07ca1f1; }, function (v) { return $142cc48ad6105c40$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $142cc48ad6105c40$export$2e58a4b541fdcbe8; }, function (v) { return $142cc48ad6105c40$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $142cc48ad6105c40$export$183b950bde9faab8; }, function (v) { return $142cc48ad6105c40$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $142cc48ad6105c40$export$4785c77169fea59e; }, function (v) { return $142cc48ad6105c40$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $142cc48ad6105c40$export$242a185dfcffac5b; }, function (v) { return $142cc48ad6105c40$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $142cc48ad6105c40$export$58c04ae0ae31877d; }, function (v) { return $142cc48ad6105c40$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $142cc48ad6105c40$export$d058ca695f8c6f11; }, function (v) { return $142cc48ad6105c40$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $142cc48ad6105c40$export$a1efd7fc3e986367; }, function (v) { return $142cc48ad6105c40$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $142cc48ad6105c40$export$bbfea4a2b5abaab4; }, function (v) { return $142cc48ad6105c40$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $142cc48ad6105c40$export$97ad4afc7de86152; }, function (v) { return $142cc48ad6105c40$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $142cc48ad6105c40$export$ce4673d9a79f6a4b; }, function (v) { return $142cc48ad6105c40$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $142cc48ad6105c40$export$786cc99fc6eedc0b; }, function (v) { return $142cc48ad6105c40$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $142cc48ad6105c40$export$45c59b9a1848dd0; }, function (v) { return $142cc48ad6105c40$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $142cc48ad6105c40$export$50d8f613e76d3034; }, function (v) { return $142cc48ad6105c40$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $142cc48ad6105c40$export$b8e83683c60ee162; }, function (v) { return $142cc48ad6105c40$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $142cc48ad6105c40$export$aeeb51790d1bcc4a; }, function (v) { return $142cc48ad6105c40$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $142cc48ad6105c40$export$bb7c616f719ad9c; }, function (v) { return $142cc48ad6105c40$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $142cc48ad6105c40$export$4d63290824f9d7df; }, function (v) { return $142cc48ad6105c40$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $142cc48ad6105c40$export$2f64ceb90ef28ea1; }, function (v) { return $142cc48ad6105c40$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $142cc48ad6105c40$export$8d2089d465f6d10d; }, function (v) { return $142cc48ad6105c40$export$8d2089d465f6d10d = v; });
var $142cc48ad6105c40$export$69f1b2dcda23c5f8;
var $142cc48ad6105c40$export$45b10814cc054894;
var $142cc48ad6105c40$export$7ea66e3774a60b67;
var $142cc48ad6105c40$export$34a52f00f601f6f1;
var $142cc48ad6105c40$export$812b0cbd5e8a72ab;
var $142cc48ad6105c40$export$f24f9e11d63bb314;
var $142cc48ad6105c40$export$b71357c7e07ca1f1;
var $142cc48ad6105c40$export$2e58a4b541fdcbe8;
var $142cc48ad6105c40$export$183b950bde9faab8;
var $142cc48ad6105c40$export$4785c77169fea59e;
var $142cc48ad6105c40$export$242a185dfcffac5b;
var $142cc48ad6105c40$export$58c04ae0ae31877d;
var $142cc48ad6105c40$export$d058ca695f8c6f11;
var $142cc48ad6105c40$export$a1efd7fc3e986367;
var $142cc48ad6105c40$export$bbfea4a2b5abaab4;
var $142cc48ad6105c40$export$97ad4afc7de86152;
var $142cc48ad6105c40$export$ce4673d9a79f6a4b;
var $142cc48ad6105c40$export$786cc99fc6eedc0b;
var $142cc48ad6105c40$export$45c59b9a1848dd0;
var $142cc48ad6105c40$export$50d8f613e76d3034;
var $142cc48ad6105c40$export$b8e83683c60ee162;
var $142cc48ad6105c40$export$aeeb51790d1bcc4a;
var $142cc48ad6105c40$export$bb7c616f719ad9c;
var $142cc48ad6105c40$export$4d63290824f9d7df;
var $142cc48ad6105c40$export$2f64ceb90ef28ea1;
var $142cc48ad6105c40$export$8d2089d465f6d10d;
'use strict';

var $jLTFB = parcelRequire("jLTFB");

var $dhT4G = parcelRequire("dhT4G");
$142cc48ad6105c40$export$69f1b2dcda23c5f8 = $dhT4G;
function $142cc48ad6105c40$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $142cc48ad6105c40$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($142cc48ad6105c40$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$142cc48ad6105c40$export$45b10814cc054894 = $142cc48ad6105c40$var$toArray;
function $142cc48ad6105c40$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $142cc48ad6105c40$var$zero2(msg[i].toString(16));
    return res;
}
$142cc48ad6105c40$export$7ea66e3774a60b67 = $142cc48ad6105c40$var$toHex;
function $142cc48ad6105c40$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$142cc48ad6105c40$export$34a52f00f601f6f1 = $142cc48ad6105c40$var$htonl;
function $142cc48ad6105c40$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $142cc48ad6105c40$var$htonl(w);
        res += $142cc48ad6105c40$var$zero8(w.toString(16));
    }
    return res;
}
$142cc48ad6105c40$export$812b0cbd5e8a72ab = $142cc48ad6105c40$var$toHex32;
function $142cc48ad6105c40$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$142cc48ad6105c40$export$f24f9e11d63bb314 = $142cc48ad6105c40$var$zero2;
function $142cc48ad6105c40$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$142cc48ad6105c40$export$b71357c7e07ca1f1 = $142cc48ad6105c40$var$zero8;
function $142cc48ad6105c40$var$join32(msg, start, end, endian) {
    var len = end - start;
    $jLTFB(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$142cc48ad6105c40$export$2e58a4b541fdcbe8 = $142cc48ad6105c40$var$join32;
function $142cc48ad6105c40$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$142cc48ad6105c40$export$183b950bde9faab8 = $142cc48ad6105c40$var$split32;
function $142cc48ad6105c40$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$142cc48ad6105c40$export$4785c77169fea59e = $142cc48ad6105c40$var$rotr32;
function $142cc48ad6105c40$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$142cc48ad6105c40$export$242a185dfcffac5b = $142cc48ad6105c40$var$rotl32;
function $142cc48ad6105c40$var$sum32(a, b) {
    return a + b >>> 0;
}
$142cc48ad6105c40$export$58c04ae0ae31877d = $142cc48ad6105c40$var$sum32;
function $142cc48ad6105c40$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$142cc48ad6105c40$export$d058ca695f8c6f11 = $142cc48ad6105c40$var$sum32_3;
function $142cc48ad6105c40$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$142cc48ad6105c40$export$a1efd7fc3e986367 = $142cc48ad6105c40$var$sum32_4;
function $142cc48ad6105c40$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$142cc48ad6105c40$export$bbfea4a2b5abaab4 = $142cc48ad6105c40$var$sum32_5;
function $142cc48ad6105c40$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$142cc48ad6105c40$export$97ad4afc7de86152 = $142cc48ad6105c40$var$sum64;
function $142cc48ad6105c40$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$142cc48ad6105c40$export$ce4673d9a79f6a4b = $142cc48ad6105c40$var$sum64_hi;
function $142cc48ad6105c40$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$142cc48ad6105c40$export$786cc99fc6eedc0b = $142cc48ad6105c40$var$sum64_lo;
function $142cc48ad6105c40$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$142cc48ad6105c40$export$45c59b9a1848dd0 = $142cc48ad6105c40$var$sum64_4_hi;
function $142cc48ad6105c40$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$142cc48ad6105c40$export$50d8f613e76d3034 = $142cc48ad6105c40$var$sum64_4_lo;
function $142cc48ad6105c40$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$142cc48ad6105c40$export$b8e83683c60ee162 = $142cc48ad6105c40$var$sum64_5_hi;
function $142cc48ad6105c40$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$142cc48ad6105c40$export$aeeb51790d1bcc4a = $142cc48ad6105c40$var$sum64_5_lo;
function $142cc48ad6105c40$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$142cc48ad6105c40$export$bb7c616f719ad9c = $142cc48ad6105c40$var$rotr64_hi;
function $142cc48ad6105c40$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$142cc48ad6105c40$export$4d63290824f9d7df = $142cc48ad6105c40$var$rotr64_lo;
function $142cc48ad6105c40$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$142cc48ad6105c40$export$2f64ceb90ef28ea1 = $142cc48ad6105c40$var$shr64_hi;
function $142cc48ad6105c40$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$142cc48ad6105c40$export$8d2089d465f6d10d = $142cc48ad6105c40$var$shr64_lo;

});

parcelRegister("cx4L0", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $91fc41c6f399bfd6$export$8687658379b577e6; }, function (v) { return $91fc41c6f399bfd6$export$8687658379b577e6 = v; });
var $91fc41c6f399bfd6$export$8687658379b577e6;
'use strict';

var $1JocC = parcelRequire("1JocC");

var $jLTFB = parcelRequire("jLTFB");
function $91fc41c6f399bfd6$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$91fc41c6f399bfd6$export$8687658379b577e6 = $91fc41c6f399bfd6$var$BlockHash;
$91fc41c6f399bfd6$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $1JocC.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $1JocC.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$91fc41c6f399bfd6$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $jLTFB(this.pending === null);
    return this._digest(enc);
};
$91fc41c6f399bfd6$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("czP09", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $928050bd9f998c99$export$5091bdda49ba90f5; }, function (v) { return $928050bd9f998c99$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $928050bd9f998c99$export$97b70509d4e397ea; }, function (v) { return $928050bd9f998c99$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $928050bd9f998c99$export$bced8d2aada2d1c9; }, function (v) { return $928050bd9f998c99$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $928050bd9f998c99$export$612d47d55dedde45; }, function (v) { return $928050bd9f998c99$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $928050bd9f998c99$export$a888d2532e6dc7bb; }, function (v) { return $928050bd9f998c99$export$a888d2532e6dc7bb = v; });
var $928050bd9f998c99$export$5091bdda49ba90f5;
var $928050bd9f998c99$export$97b70509d4e397ea;
var $928050bd9f998c99$export$bced8d2aada2d1c9;
var $928050bd9f998c99$export$612d47d55dedde45;
var $928050bd9f998c99$export$a888d2532e6dc7bb;
'use strict';

$928050bd9f998c99$export$5091bdda49ba90f5 = (parcelRequire("7jFEf"));

$928050bd9f998c99$export$97b70509d4e397ea = (parcelRequire("aE1Pb"));

$928050bd9f998c99$export$bced8d2aada2d1c9 = (parcelRequire("6lk1c"));

$928050bd9f998c99$export$612d47d55dedde45 = (parcelRequire("tUPWi"));

$928050bd9f998c99$export$a888d2532e6dc7bb = (parcelRequire("joihk"));

});
parcelRegister("7jFEf", function(module, exports) {
'use strict';

var $1JocC = parcelRequire("1JocC");

var $cx4L0 = parcelRequire("cx4L0");

var $aoikt = parcelRequire("aoikt");
var $553a9d345907d8a6$var$rotl32 = $1JocC.rotl32;
var $553a9d345907d8a6$var$sum32 = $1JocC.sum32;
var $553a9d345907d8a6$var$sum32_5 = $1JocC.sum32_5;
var $553a9d345907d8a6$var$ft_1 = $aoikt.ft_1;
var $553a9d345907d8a6$var$BlockHash = $cx4L0.BlockHash;
var $553a9d345907d8a6$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $553a9d345907d8a6$var$SHA1() {
    if (!(this instanceof $553a9d345907d8a6$var$SHA1)) return new $553a9d345907d8a6$var$SHA1();
    $553a9d345907d8a6$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$1JocC.inherits($553a9d345907d8a6$var$SHA1, $553a9d345907d8a6$var$BlockHash);
module.exports = $553a9d345907d8a6$var$SHA1;
$553a9d345907d8a6$var$SHA1.blockSize = 512;
$553a9d345907d8a6$var$SHA1.outSize = 160;
$553a9d345907d8a6$var$SHA1.hmacStrength = 80;
$553a9d345907d8a6$var$SHA1.padLength = 64;
$553a9d345907d8a6$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $553a9d345907d8a6$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $553a9d345907d8a6$var$sum32_5($553a9d345907d8a6$var$rotl32(a, 5), $553a9d345907d8a6$var$ft_1(s, b, c, d), e, W[i], $553a9d345907d8a6$var$sha1_K[s]);
        e = d;
        d = c;
        c = $553a9d345907d8a6$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $553a9d345907d8a6$var$sum32(this.h[0], a);
    this.h[1] = $553a9d345907d8a6$var$sum32(this.h[1], b);
    this.h[2] = $553a9d345907d8a6$var$sum32(this.h[2], c);
    this.h[3] = $553a9d345907d8a6$var$sum32(this.h[3], d);
    this.h[4] = $553a9d345907d8a6$var$sum32(this.h[4], e);
};
$553a9d345907d8a6$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $1JocC.toHex32(this.h, 'big');
    else return $1JocC.split32(this.h, 'big');
};

});
parcelRegister("aoikt", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $790a5d18b6572c07$export$5a92649d7ddb9f63; }, function (v) { return $790a5d18b6572c07$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $790a5d18b6572c07$export$c6d0d020c3a6269; }, function (v) { return $790a5d18b6572c07$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $790a5d18b6572c07$export$eb90c27fca05f956; }, function (v) { return $790a5d18b6572c07$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $790a5d18b6572c07$export$14a4a98e063b1999; }, function (v) { return $790a5d18b6572c07$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $790a5d18b6572c07$export$d20cecfa1564c686; }, function (v) { return $790a5d18b6572c07$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $790a5d18b6572c07$export$44fd472a12fc6db; }, function (v) { return $790a5d18b6572c07$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $790a5d18b6572c07$export$1ed238bb6ea1dd47; }, function (v) { return $790a5d18b6572c07$export$1ed238bb6ea1dd47 = v; });
var $790a5d18b6572c07$export$5a92649d7ddb9f63;
var $790a5d18b6572c07$export$c6d0d020c3a6269;
var $790a5d18b6572c07$export$eb90c27fca05f956;
var $790a5d18b6572c07$export$cc992891a14496a1;
var $790a5d18b6572c07$export$14a4a98e063b1999;
var $790a5d18b6572c07$export$d20cecfa1564c686;
var $790a5d18b6572c07$export$44fd472a12fc6db;
var $790a5d18b6572c07$export$1ed238bb6ea1dd47;
'use strict';

var $1JocC = parcelRequire("1JocC");
var $790a5d18b6572c07$var$rotr32 = $1JocC.rotr32;
function $790a5d18b6572c07$var$ft_1(s, x, y, z) {
    if (s === 0) return $790a5d18b6572c07$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $790a5d18b6572c07$var$p32(x, y, z);
    if (s === 2) return $790a5d18b6572c07$var$maj32(x, y, z);
}
$790a5d18b6572c07$export$5a92649d7ddb9f63 = $790a5d18b6572c07$var$ft_1;
function $790a5d18b6572c07$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$790a5d18b6572c07$export$c6d0d020c3a6269 = $790a5d18b6572c07$var$ch32;
function $790a5d18b6572c07$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$790a5d18b6572c07$export$eb90c27fca05f956 = $790a5d18b6572c07$var$maj32;
function $790a5d18b6572c07$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$790a5d18b6572c07$export$cc992891a14496a1 = $790a5d18b6572c07$var$p32;
function $790a5d18b6572c07$var$s0_256(x) {
    return $790a5d18b6572c07$var$rotr32(x, 2) ^ $790a5d18b6572c07$var$rotr32(x, 13) ^ $790a5d18b6572c07$var$rotr32(x, 22);
}
$790a5d18b6572c07$export$14a4a98e063b1999 = $790a5d18b6572c07$var$s0_256;
function $790a5d18b6572c07$var$s1_256(x) {
    return $790a5d18b6572c07$var$rotr32(x, 6) ^ $790a5d18b6572c07$var$rotr32(x, 11) ^ $790a5d18b6572c07$var$rotr32(x, 25);
}
$790a5d18b6572c07$export$d20cecfa1564c686 = $790a5d18b6572c07$var$s1_256;
function $790a5d18b6572c07$var$g0_256(x) {
    return $790a5d18b6572c07$var$rotr32(x, 7) ^ $790a5d18b6572c07$var$rotr32(x, 18) ^ x >>> 3;
}
$790a5d18b6572c07$export$44fd472a12fc6db = $790a5d18b6572c07$var$g0_256;
function $790a5d18b6572c07$var$g1_256(x) {
    return $790a5d18b6572c07$var$rotr32(x, 17) ^ $790a5d18b6572c07$var$rotr32(x, 19) ^ x >>> 10;
}
$790a5d18b6572c07$export$1ed238bb6ea1dd47 = $790a5d18b6572c07$var$g1_256;

});


parcelRegister("aE1Pb", function(module, exports) {
'use strict';

var $1JocC = parcelRequire("1JocC");

var $6lk1c = parcelRequire("6lk1c");
function $7bff0e1ea26927f0$var$SHA224() {
    if (!(this instanceof $7bff0e1ea26927f0$var$SHA224)) return new $7bff0e1ea26927f0$var$SHA224();
    $6lk1c.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$1JocC.inherits($7bff0e1ea26927f0$var$SHA224, $6lk1c);
module.exports = $7bff0e1ea26927f0$var$SHA224;
$7bff0e1ea26927f0$var$SHA224.blockSize = 512;
$7bff0e1ea26927f0$var$SHA224.outSize = 224;
$7bff0e1ea26927f0$var$SHA224.hmacStrength = 192;
$7bff0e1ea26927f0$var$SHA224.padLength = 64;
$7bff0e1ea26927f0$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $1JocC.toHex32(this.h.slice(0, 7), 'big');
    else return $1JocC.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("6lk1c", function(module, exports) {
'use strict';

var $1JocC = parcelRequire("1JocC");

var $cx4L0 = parcelRequire("cx4L0");

var $aoikt = parcelRequire("aoikt");

var $jLTFB = parcelRequire("jLTFB");
var $49e43b734242bc05$var$sum32 = $1JocC.sum32;
var $49e43b734242bc05$var$sum32_4 = $1JocC.sum32_4;
var $49e43b734242bc05$var$sum32_5 = $1JocC.sum32_5;
var $49e43b734242bc05$var$ch32 = $aoikt.ch32;
var $49e43b734242bc05$var$maj32 = $aoikt.maj32;
var $49e43b734242bc05$var$s0_256 = $aoikt.s0_256;
var $49e43b734242bc05$var$s1_256 = $aoikt.s1_256;
var $49e43b734242bc05$var$g0_256 = $aoikt.g0_256;
var $49e43b734242bc05$var$g1_256 = $aoikt.g1_256;
var $49e43b734242bc05$var$BlockHash = $cx4L0.BlockHash;
var $49e43b734242bc05$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $49e43b734242bc05$var$SHA256() {
    if (!(this instanceof $49e43b734242bc05$var$SHA256)) return new $49e43b734242bc05$var$SHA256();
    $49e43b734242bc05$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $49e43b734242bc05$var$sha256_K;
    this.W = new Array(64);
}
$1JocC.inherits($49e43b734242bc05$var$SHA256, $49e43b734242bc05$var$BlockHash);
module.exports = $49e43b734242bc05$var$SHA256;
$49e43b734242bc05$var$SHA256.blockSize = 512;
$49e43b734242bc05$var$SHA256.outSize = 256;
$49e43b734242bc05$var$SHA256.hmacStrength = 192;
$49e43b734242bc05$var$SHA256.padLength = 64;
$49e43b734242bc05$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $49e43b734242bc05$var$sum32_4($49e43b734242bc05$var$g1_256(W[i - 2]), W[i - 7], $49e43b734242bc05$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $jLTFB(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $49e43b734242bc05$var$sum32_5(h, $49e43b734242bc05$var$s1_256(e), $49e43b734242bc05$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $49e43b734242bc05$var$sum32($49e43b734242bc05$var$s0_256(a), $49e43b734242bc05$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $49e43b734242bc05$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $49e43b734242bc05$var$sum32(T1, T2);
    }
    this.h[0] = $49e43b734242bc05$var$sum32(this.h[0], a);
    this.h[1] = $49e43b734242bc05$var$sum32(this.h[1], b);
    this.h[2] = $49e43b734242bc05$var$sum32(this.h[2], c);
    this.h[3] = $49e43b734242bc05$var$sum32(this.h[3], d);
    this.h[4] = $49e43b734242bc05$var$sum32(this.h[4], e);
    this.h[5] = $49e43b734242bc05$var$sum32(this.h[5], f);
    this.h[6] = $49e43b734242bc05$var$sum32(this.h[6], g);
    this.h[7] = $49e43b734242bc05$var$sum32(this.h[7], h);
};
$49e43b734242bc05$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $1JocC.toHex32(this.h, 'big');
    else return $1JocC.split32(this.h, 'big');
};

});


parcelRegister("tUPWi", function(module, exports) {
'use strict';

var $1JocC = parcelRequire("1JocC");

var $joihk = parcelRequire("joihk");
function $059ecc239a13035c$var$SHA384() {
    if (!(this instanceof $059ecc239a13035c$var$SHA384)) return new $059ecc239a13035c$var$SHA384();
    $joihk.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$1JocC.inherits($059ecc239a13035c$var$SHA384, $joihk);
module.exports = $059ecc239a13035c$var$SHA384;
$059ecc239a13035c$var$SHA384.blockSize = 1024;
$059ecc239a13035c$var$SHA384.outSize = 384;
$059ecc239a13035c$var$SHA384.hmacStrength = 192;
$059ecc239a13035c$var$SHA384.padLength = 128;
$059ecc239a13035c$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $1JocC.toHex32(this.h.slice(0, 12), 'big');
    else return $1JocC.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("joihk", function(module, exports) {
'use strict';

var $1JocC = parcelRequire("1JocC");

var $cx4L0 = parcelRequire("cx4L0");

var $jLTFB = parcelRequire("jLTFB");
var $e1de6ff53e4a4c3f$var$rotr64_hi = $1JocC.rotr64_hi;
var $e1de6ff53e4a4c3f$var$rotr64_lo = $1JocC.rotr64_lo;
var $e1de6ff53e4a4c3f$var$shr64_hi = $1JocC.shr64_hi;
var $e1de6ff53e4a4c3f$var$shr64_lo = $1JocC.shr64_lo;
var $e1de6ff53e4a4c3f$var$sum64 = $1JocC.sum64;
var $e1de6ff53e4a4c3f$var$sum64_hi = $1JocC.sum64_hi;
var $e1de6ff53e4a4c3f$var$sum64_lo = $1JocC.sum64_lo;
var $e1de6ff53e4a4c3f$var$sum64_4_hi = $1JocC.sum64_4_hi;
var $e1de6ff53e4a4c3f$var$sum64_4_lo = $1JocC.sum64_4_lo;
var $e1de6ff53e4a4c3f$var$sum64_5_hi = $1JocC.sum64_5_hi;
var $e1de6ff53e4a4c3f$var$sum64_5_lo = $1JocC.sum64_5_lo;
var $e1de6ff53e4a4c3f$var$BlockHash = $cx4L0.BlockHash;
var $e1de6ff53e4a4c3f$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $e1de6ff53e4a4c3f$var$SHA512() {
    if (!(this instanceof $e1de6ff53e4a4c3f$var$SHA512)) return new $e1de6ff53e4a4c3f$var$SHA512();
    $e1de6ff53e4a4c3f$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $e1de6ff53e4a4c3f$var$sha512_K;
    this.W = new Array(160);
}
$1JocC.inherits($e1de6ff53e4a4c3f$var$SHA512, $e1de6ff53e4a4c3f$var$BlockHash);
module.exports = $e1de6ff53e4a4c3f$var$SHA512;
$e1de6ff53e4a4c3f$var$SHA512.blockSize = 1024;
$e1de6ff53e4a4c3f$var$SHA512.outSize = 512;
$e1de6ff53e4a4c3f$var$SHA512.hmacStrength = 192;
$e1de6ff53e4a4c3f$var$SHA512.padLength = 128;
$e1de6ff53e4a4c3f$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $e1de6ff53e4a4c3f$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $e1de6ff53e4a4c3f$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $e1de6ff53e4a4c3f$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $e1de6ff53e4a4c3f$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $e1de6ff53e4a4c3f$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $e1de6ff53e4a4c3f$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$e1de6ff53e4a4c3f$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $jLTFB(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $e1de6ff53e4a4c3f$var$s1_512_hi(eh, el);
        var c1_lo = $e1de6ff53e4a4c3f$var$s1_512_lo(eh, el);
        var c2_hi = $e1de6ff53e4a4c3f$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $e1de6ff53e4a4c3f$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $e1de6ff53e4a4c3f$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $e1de6ff53e4a4c3f$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $e1de6ff53e4a4c3f$var$s0_512_hi(ah, al);
        c0_lo = $e1de6ff53e4a4c3f$var$s0_512_lo(ah, al);
        c1_hi = $e1de6ff53e4a4c3f$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $e1de6ff53e4a4c3f$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $e1de6ff53e4a4c3f$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $e1de6ff53e4a4c3f$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $e1de6ff53e4a4c3f$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $e1de6ff53e4a4c3f$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $e1de6ff53e4a4c3f$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $e1de6ff53e4a4c3f$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $e1de6ff53e4a4c3f$var$sum64(this.h, 0, ah, al);
    $e1de6ff53e4a4c3f$var$sum64(this.h, 2, bh, bl);
    $e1de6ff53e4a4c3f$var$sum64(this.h, 4, ch, cl);
    $e1de6ff53e4a4c3f$var$sum64(this.h, 6, dh, dl);
    $e1de6ff53e4a4c3f$var$sum64(this.h, 8, eh, el);
    $e1de6ff53e4a4c3f$var$sum64(this.h, 10, fh, fl);
    $e1de6ff53e4a4c3f$var$sum64(this.h, 12, gh, gl);
    $e1de6ff53e4a4c3f$var$sum64(this.h, 14, hh, hl);
};
$e1de6ff53e4a4c3f$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $1JocC.toHex32(this.h, 'big');
    else return $1JocC.split32(this.h, 'big');
};
function $e1de6ff53e4a4c3f$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$s0_512_hi(xh, xl) {
    var c0_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$s0_512_lo(xh, xl) {
    var c0_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$s1_512_hi(xh, xl) {
    var c0_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$s1_512_lo(xh, xl) {
    var c0_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$g0_512_hi(xh, xl) {
    var c0_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $e1de6ff53e4a4c3f$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$g0_512_lo(xh, xl) {
    var c0_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $e1de6ff53e4a4c3f$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$g1_512_hi(xh, xl) {
    var c0_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $e1de6ff53e4a4c3f$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$g1_512_lo(xh, xl) {
    var c0_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $e1de6ff53e4a4c3f$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("1KcMM", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $14540152db666e38$export$d1cea0ee4e3f0d3e; }, function (v) { return $14540152db666e38$export$d1cea0ee4e3f0d3e = v; });
var $14540152db666e38$export$d1cea0ee4e3f0d3e;
'use strict';

var $1JocC = parcelRequire("1JocC");

var $cx4L0 = parcelRequire("cx4L0");
var $14540152db666e38$var$rotl32 = $1JocC.rotl32;
var $14540152db666e38$var$sum32 = $1JocC.sum32;
var $14540152db666e38$var$sum32_3 = $1JocC.sum32_3;
var $14540152db666e38$var$sum32_4 = $1JocC.sum32_4;
var $14540152db666e38$var$BlockHash = $cx4L0.BlockHash;
function $14540152db666e38$var$RIPEMD160() {
    if (!(this instanceof $14540152db666e38$var$RIPEMD160)) return new $14540152db666e38$var$RIPEMD160();
    $14540152db666e38$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$1JocC.inherits($14540152db666e38$var$RIPEMD160, $14540152db666e38$var$BlockHash);
$14540152db666e38$export$d1cea0ee4e3f0d3e = $14540152db666e38$var$RIPEMD160;
$14540152db666e38$var$RIPEMD160.blockSize = 512;
$14540152db666e38$var$RIPEMD160.outSize = 160;
$14540152db666e38$var$RIPEMD160.hmacStrength = 192;
$14540152db666e38$var$RIPEMD160.padLength = 64;
$14540152db666e38$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $14540152db666e38$var$sum32($14540152db666e38$var$rotl32($14540152db666e38$var$sum32_4(A, $14540152db666e38$var$f(j, B, C, D), msg[$14540152db666e38$var$r[j] + start], $14540152db666e38$var$K(j)), $14540152db666e38$var$s[j]), E);
        A = E;
        E = D;
        D = $14540152db666e38$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $14540152db666e38$var$sum32($14540152db666e38$var$rotl32($14540152db666e38$var$sum32_4(Ah, $14540152db666e38$var$f(79 - j, Bh, Ch, Dh), msg[$14540152db666e38$var$rh[j] + start], $14540152db666e38$var$Kh(j)), $14540152db666e38$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $14540152db666e38$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $14540152db666e38$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $14540152db666e38$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $14540152db666e38$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $14540152db666e38$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $14540152db666e38$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$14540152db666e38$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $1JocC.toHex32(this.h, 'little');
    else return $1JocC.split32(this.h, 'little');
};
function $14540152db666e38$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $14540152db666e38$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $14540152db666e38$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $14540152db666e38$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $14540152db666e38$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $14540152db666e38$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $14540152db666e38$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("iBkDX", function(module, exports) {
'use strict';

var $1JocC = parcelRequire("1JocC");

var $jLTFB = parcelRequire("jLTFB");
function $d8abb2129232a5b9$var$Hmac(hash, key, enc) {
    if (!(this instanceof $d8abb2129232a5b9$var$Hmac)) return new $d8abb2129232a5b9$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($1JocC.toArray(key, enc));
}
module.exports = $d8abb2129232a5b9$var$Hmac;
$d8abb2129232a5b9$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $jLTFB(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$d8abb2129232a5b9$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$d8abb2129232a5b9$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("8M60a", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("ijEQd", function(module, exports) {
'use strict';

var $7iECc = parcelRequire("7iECc");

var $aZYpB = parcelRequire("aZYpB");

var $2KPxf = parcelRequire("2KPxf");

var $hKjoi = parcelRequire("hKjoi");

var $gWiKw = parcelRequire("gWiKw");
var $d559ae8cfe0978b7$var$assert = $2KPxf.assert;

var $6PbNu = parcelRequire("6PbNu");

var $3Q3Ml = parcelRequire("3Q3Ml");
function $d559ae8cfe0978b7$var$EC(options) {
    if (!(this instanceof $d559ae8cfe0978b7$var$EC)) return new $d559ae8cfe0978b7$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $d559ae8cfe0978b7$var$assert(Object.prototype.hasOwnProperty.call($hKjoi, options), 'Unknown curve ' + options);
        options = $hKjoi[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $hKjoi.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $d559ae8cfe0978b7$var$EC;
$d559ae8cfe0978b7$var$EC.prototype.keyPair = function keyPair(options) {
    return new $6PbNu(this, options);
};
$d559ae8cfe0978b7$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $6PbNu.fromPrivate(this, priv, enc);
};
$d559ae8cfe0978b7$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $6PbNu.fromPublic(this, pub, enc);
};
$d559ae8cfe0978b7$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $aZYpB({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $gWiKw(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $7iECc(2));
    for(;;){
        var priv = new $7iECc(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$d559ae8cfe0978b7$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if ($7iECc.isBN(msg) || typeof msg === 'number') {
        msg = new $7iECc(msg, 16);
        byteLength = msg.byteLength();
    } else if (typeof msg === 'object') {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new $7iECc(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new $7iECc(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== 'number') bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$d559ae8cfe0978b7$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== 'string' && typeof msg !== 'number' && !$7iECc.isBN(msg)) {
        $d559ae8cfe0978b7$var$assert(typeof msg === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
        $d559ae8cfe0978b7$var$assert(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)$d559ae8cfe0978b7$var$assert((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    $d559ae8cfe0978b7$var$assert(!msg.isNeg(), 'Can not sign a negative message');
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Recheck nonce to be bijective to msg
    $d559ae8cfe0978b7$var$assert(new $7iECc(nonce).eq(msg), 'Can not sign message');
    // Instantiate Hmac_DRBG
    var drbg = new $aZYpB({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $7iECc(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $7iECc(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $3Q3Ml({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$d559ae8cfe0978b7$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature = new $3Q3Ml(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$d559ae8cfe0978b7$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $d559ae8cfe0978b7$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $3Q3Ml(signature, enc);
    var n = this.n;
    var e = new $7iECc(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$d559ae8cfe0978b7$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $3Q3Ml(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("aZYpB", function(module, exports) {
'use strict';

var $gVjbv = parcelRequire("gVjbv");

var $bA0W1 = parcelRequire("bA0W1");

var $jLTFB = parcelRequire("jLTFB");
function $801e766dffc0af0b$var$HmacDRBG(options) {
    if (!(this instanceof $801e766dffc0af0b$var$HmacDRBG)) return new $801e766dffc0af0b$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $bA0W1.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $bA0W1.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $bA0W1.toArray(options.pers, options.persEnc || 'hex');
    $jLTFB(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $801e766dffc0af0b$var$HmacDRBG;
$801e766dffc0af0b$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$801e766dffc0af0b$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $gVjbv.hmac(this.hash, this.K);
};
$801e766dffc0af0b$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$801e766dffc0af0b$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $bA0W1.toArray(entropy, entropyEnc);
    add = $bA0W1.toArray(add, addEnc);
    $jLTFB(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$801e766dffc0af0b$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $bA0W1.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $bA0W1.encode(res, enc);
};

});

parcelRegister("6PbNu", function(module, exports) {
'use strict';

var $7iECc = parcelRequire("7iECc");

var $2KPxf = parcelRequire("2KPxf");
var $4f80a828047f5860$var$assert = $2KPxf.assert;
function $4f80a828047f5860$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $4f80a828047f5860$var$KeyPair;
$4f80a828047f5860$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $4f80a828047f5860$var$KeyPair) return pub;
    return new $4f80a828047f5860$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$4f80a828047f5860$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $4f80a828047f5860$var$KeyPair) return priv;
    return new $4f80a828047f5860$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$4f80a828047f5860$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$4f80a828047f5860$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$4f80a828047f5860$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$4f80a828047f5860$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $7iECc(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$4f80a828047f5860$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $4f80a828047f5860$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $4f80a828047f5860$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$4f80a828047f5860$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $4f80a828047f5860$var$assert(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$4f80a828047f5860$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$4f80a828047f5860$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
$4f80a828047f5860$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("3Q3Ml", function(module, exports) {
'use strict';

var $7iECc = parcelRequire("7iECc");

var $2KPxf = parcelRequire("2KPxf");
var $2cb928d2a10fb271$var$assert = $2KPxf.assert;
function $2cb928d2a10fb271$var$Signature(options, enc) {
    if (options instanceof $2cb928d2a10fb271$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $2cb928d2a10fb271$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $7iECc(options.r, 16);
    this.s = new $7iECc(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $2cb928d2a10fb271$var$Signature;
function $2cb928d2a10fb271$var$Position() {
    this.place = 0;
}
function $2cb928d2a10fb271$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $2cb928d2a10fb271$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$2cb928d2a10fb271$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $2KPxf.toArray(data, enc);
    var p = new $2cb928d2a10fb271$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $2cb928d2a10fb271$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $2cb928d2a10fb271$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $2cb928d2a10fb271$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $7iECc(r);
    this.s = new $7iECc(s);
    this.recoveryParam = null;
    return true;
};
function $2cb928d2a10fb271$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$2cb928d2a10fb271$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $2cb928d2a10fb271$var$rmPadding(r);
    s = $2cb928d2a10fb271$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $2cb928d2a10fb271$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $2cb928d2a10fb271$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $2cb928d2a10fb271$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $2KPxf.encode(res, enc);
};

});


parcelRegister("9fmHx", function(module, exports) {
'use strict';

var $gVjbv = parcelRequire("gVjbv");

var $hKjoi = parcelRequire("hKjoi");

var $2KPxf = parcelRequire("2KPxf");
var $6bb71fc30329a406$var$assert = $2KPxf.assert;
var $6bb71fc30329a406$var$parseBytes = $2KPxf.parseBytes;

var $FCwLh = parcelRequire("FCwLh");

var $gKHZ3 = parcelRequire("gKHZ3");
function $6bb71fc30329a406$var$EDDSA(curve) {
    $6bb71fc30329a406$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $6bb71fc30329a406$var$EDDSA)) return new $6bb71fc30329a406$var$EDDSA(curve);
    curve = $hKjoi[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $gVjbv.sha512;
}
module.exports = $6bb71fc30329a406$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $6bb71fc30329a406$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $6bb71fc30329a406$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $6bb71fc30329a406$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $6bb71fc30329a406$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$6bb71fc30329a406$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $2KPxf.intFromLE(hash.digest()).umod(this.curve.n);
};
$6bb71fc30329a406$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $FCwLh.fromPublic(this, pub);
};
$6bb71fc30329a406$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $FCwLh.fromSecret(this, secret);
};
$6bb71fc30329a406$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $gKHZ3) return sig;
    return new $gKHZ3(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $6bb71fc30329a406$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$6bb71fc30329a406$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $2KPxf.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $2KPxf.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$6bb71fc30329a406$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$6bb71fc30329a406$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $2KPxf.intFromLE(bytes);
};
$6bb71fc30329a406$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("FCwLh", function(module, exports) {
'use strict';

var $2KPxf = parcelRequire("2KPxf");
var $07d1b731153c430e$var$assert = $2KPxf.assert;
var $07d1b731153c430e$var$parseBytes = $2KPxf.parseBytes;
var $07d1b731153c430e$var$cachedProperty = $2KPxf.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $07d1b731153c430e$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $07d1b731153c430e$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $07d1b731153c430e$var$parseBytes(params.pub);
}
$07d1b731153c430e$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $07d1b731153c430e$var$KeyPair) return pub;
    return new $07d1b731153c430e$var$KeyPair(eddsa, {
        pub: pub
    });
};
$07d1b731153c430e$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $07d1b731153c430e$var$KeyPair) return secret;
    return new $07d1b731153c430e$var$KeyPair(eddsa, {
        secret: secret
    });
};
$07d1b731153c430e$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$07d1b731153c430e$var$cachedProperty($07d1b731153c430e$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$07d1b731153c430e$var$cachedProperty($07d1b731153c430e$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$07d1b731153c430e$var$cachedProperty($07d1b731153c430e$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$07d1b731153c430e$var$cachedProperty($07d1b731153c430e$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$07d1b731153c430e$var$cachedProperty($07d1b731153c430e$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$07d1b731153c430e$var$cachedProperty($07d1b731153c430e$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$07d1b731153c430e$var$KeyPair.prototype.sign = function sign(message) {
    $07d1b731153c430e$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$07d1b731153c430e$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$07d1b731153c430e$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $07d1b731153c430e$var$assert(this._secret, 'KeyPair is public only');
    return $2KPxf.encode(this.secret(), enc);
};
$07d1b731153c430e$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $2KPxf.encode(this.pubBytes(), enc);
};
module.exports = $07d1b731153c430e$var$KeyPair;

});

parcelRegister("gKHZ3", function(module, exports) {
'use strict';

var $7iECc = parcelRequire("7iECc");

var $2KPxf = parcelRequire("2KPxf");
var $c3230f7d16d20b95$var$assert = $2KPxf.assert;
var $c3230f7d16d20b95$var$cachedProperty = $2KPxf.cachedProperty;
var $c3230f7d16d20b95$var$parseBytes = $2KPxf.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $c3230f7d16d20b95$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $c3230f7d16d20b95$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $c3230f7d16d20b95$var$assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $c3230f7d16d20b95$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $7iECc) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$c3230f7d16d20b95$var$cachedProperty($c3230f7d16d20b95$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$c3230f7d16d20b95$var$cachedProperty($c3230f7d16d20b95$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$c3230f7d16d20b95$var$cachedProperty($c3230f7d16d20b95$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$c3230f7d16d20b95$var$cachedProperty($c3230f7d16d20b95$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$c3230f7d16d20b95$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$c3230f7d16d20b95$var$Signature.prototype.toHex = function toHex() {
    return $2KPxf.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $c3230f7d16d20b95$var$Signature;

});


parcelRegister("hlAHM", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("ifbub")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("7C5CY", function(module, exports) {

var $hl0ih = parcelRequire("hl0ih");

var $dhT4G = parcelRequire("dhT4G");
var $58b0728c3ed07e03$var$api = module.exports;
$58b0728c3ed07e03$var$api.define = function define(name, body) {
    return new $58b0728c3ed07e03$var$Entity(name, body);
};
function $58b0728c3ed07e03$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$58b0728c3ed07e03$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("eqQT5")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $dhT4G(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$58b0728c3ed07e03$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($hl0ih.decoders[enc]);
    return this.decoders[enc];
};
$58b0728c3ed07e03$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$58b0728c3ed07e03$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($hl0ih.encoders[enc]);
    return this.encoders[enc];
};
$58b0728c3ed07e03$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("hl0ih", function(module, exports) {
var $c9f4a02d1f59d6a6$var$asn1 = module.exports;

$c9f4a02d1f59d6a6$var$asn1.bignum = (parcelRequire("hlAHM"));

$c9f4a02d1f59d6a6$var$asn1.define = (parcelRequire("7C5CY")).define;

$c9f4a02d1f59d6a6$var$asn1.base = (parcelRequire("iWwea"));

$c9f4a02d1f59d6a6$var$asn1.constants = (parcelRequire("1fb9t"));

$c9f4a02d1f59d6a6$var$asn1.decoders = (parcelRequire("4hyYb"));

$c9f4a02d1f59d6a6$var$asn1.encoders = (parcelRequire("lDvlV"));

});
parcelRegister("iWwea", function(module, exports) {
var $dca6a4813cf30630$var$base = module.exports;

$dca6a4813cf30630$var$base.Reporter = (parcelRequire("5bsbC")).Reporter;

$dca6a4813cf30630$var$base.DecoderBuffer = (parcelRequire("jH2v3")).DecoderBuffer;

$dca6a4813cf30630$var$base.EncoderBuffer = (parcelRequire("jH2v3")).EncoderBuffer;

$dca6a4813cf30630$var$base.Node = (parcelRequire("3kihE"));

});
parcelRegister("5bsbC", function(module, exports) {

$parcel$export(module.exports, "Reporter", function () { return $3c63d8098c4065a1$export$957313a2f485e5ed; }, function (v) { return $3c63d8098c4065a1$export$957313a2f485e5ed = v; });
var $3c63d8098c4065a1$export$957313a2f485e5ed;

var $dhT4G = parcelRequire("dhT4G");
function $3c63d8098c4065a1$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$3c63d8098c4065a1$export$957313a2f485e5ed = $3c63d8098c4065a1$var$Reporter;
$3c63d8098c4065a1$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $3c63d8098c4065a1$var$ReporterError;
};
$3c63d8098c4065a1$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$3c63d8098c4065a1$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$3c63d8098c4065a1$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$3c63d8098c4065a1$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$3c63d8098c4065a1$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$3c63d8098c4065a1$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$3c63d8098c4065a1$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$3c63d8098c4065a1$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$3c63d8098c4065a1$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $3c63d8098c4065a1$var$ReporterError;
    if (inherited) err = msg;
    else err = new $3c63d8098c4065a1$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$3c63d8098c4065a1$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $3c63d8098c4065a1$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$dhT4G($3c63d8098c4065a1$var$ReporterError, Error);
$3c63d8098c4065a1$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $3c63d8098c4065a1$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("jH2v3", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", function () { return $e563f8e7c404a610$export$bf9f79cdc4a49163; }, function (v) { return $e563f8e7c404a610$export$bf9f79cdc4a49163 = v; });
$parcel$export(module.exports, "EncoderBuffer", function () { return $e563f8e7c404a610$export$8ff24f7760c7a78e; }, function (v) { return $e563f8e7c404a610$export$8ff24f7760c7a78e = v; });
var $e563f8e7c404a610$export$bf9f79cdc4a49163;
var $e563f8e7c404a610$export$8ff24f7760c7a78e;

var $dhT4G = parcelRequire("dhT4G");

var $iWwea = parcelRequire("iWwea");
var $e563f8e7c404a610$require$Reporter = $iWwea.Reporter;

var $bdjQ6 = parcelRequire("bdjQ6");
var $e563f8e7c404a610$require$Buffer = $bdjQ6.Buffer;
function $e563f8e7c404a610$var$DecoderBuffer(base, options) {
    $e563f8e7c404a610$require$Reporter.call(this, options);
    if (!$e563f8e7c404a610$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$dhT4G($e563f8e7c404a610$var$DecoderBuffer, $e563f8e7c404a610$require$Reporter);
$e563f8e7c404a610$export$bf9f79cdc4a49163 = $e563f8e7c404a610$var$DecoderBuffer;
$e563f8e7c404a610$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $e563f8e7c404a610$require$Reporter.prototype.save.call(this)
    };
};
$e563f8e7c404a610$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $e563f8e7c404a610$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $e563f8e7c404a610$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$e563f8e7c404a610$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$e563f8e7c404a610$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$e563f8e7c404a610$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new $e563f8e7c404a610$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$e563f8e7c404a610$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $e563f8e7c404a610$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $e563f8e7c404a610$var$EncoderBuffer)) item = new $e563f8e7c404a610$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $e563f8e7c404a610$require$Buffer.byteLength(value);
    } else if ($e563f8e7c404a610$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
$e563f8e7c404a610$export$8ff24f7760c7a78e = $e563f8e7c404a610$var$EncoderBuffer;
$e563f8e7c404a610$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $e563f8e7c404a610$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($e563f8e7c404a610$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("3kihE", function(module, exports) {

var $iWwea = parcelRequire("iWwea");
var $26c16c1a02aab51e$require$Reporter = $iWwea.Reporter;

var $iWwea = parcelRequire("iWwea");
var $26c16c1a02aab51e$require$EncoderBuffer = $iWwea.EncoderBuffer;

var $iWwea = parcelRequire("iWwea");
var $26c16c1a02aab51e$require$DecoderBuffer = $iWwea.DecoderBuffer;

var $jLTFB = parcelRequire("jLTFB");
// Supported tags
var $26c16c1a02aab51e$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var $26c16c1a02aab51e$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($26c16c1a02aab51e$var$tags);
// Overrided methods list
var $26c16c1a02aab51e$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $26c16c1a02aab51e$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $26c16c1a02aab51e$var$Node;
var $26c16c1a02aab51e$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$26c16c1a02aab51e$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $26c16c1a02aab51e$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$26c16c1a02aab51e$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $26c16c1a02aab51e$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$26c16c1a02aab51e$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $jLTFB(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $jLTFB.equal(state.children.length, 1, 'Root node can have only one child');
};
$26c16c1a02aab51e$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $jLTFB(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $jLTFB(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$26c16c1a02aab51e$var$overrided.forEach(function(method) {
    $26c16c1a02aab51e$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$26c16c1a02aab51e$var$tags.forEach(function(tag) {
    $26c16c1a02aab51e$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $jLTFB(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$26c16c1a02aab51e$var$Node.prototype.use = function use(item) {
    $jLTFB(item);
    var state = this._baseState;
    $jLTFB(state.use === null);
    state.use = item;
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $jLTFB(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $jLTFB(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $jLTFB(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $jLTFB(state.key === null);
    state.key = newKey;
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $jLTFB(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $jLTFB(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$26c16c1a02aab51e$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new $26c16c1a02aab51e$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$26c16c1a02aab51e$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$26c16c1a02aab51e$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $jLTFB(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$26c16c1a02aab51e$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$26c16c1a02aab51e$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $26c16c1a02aab51e$require$EncoderBuffer(data, this.reporter);
};
$26c16c1a02aab51e$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$26c16c1a02aab51e$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $26c16c1a02aab51e$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be omitted only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$26c16c1a02aab51e$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $jLTFB(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$26c16c1a02aab51e$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$26c16c1a02aab51e$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$26c16c1a02aab51e$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("1fb9t", function(module, exports) {
var $0e7fd7b3172df5b4$var$constants = module.exports;
// Helper
$0e7fd7b3172df5b4$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$0e7fd7b3172df5b4$var$constants.der = (parcelRequire("1k4L4"));

});
parcelRegister("1k4L4", function(module, exports) {

$parcel$export(module.exports, "tagClass", function () { return $0f6b5998036e2e79$export$3584c46ed60baee8; }, function (v) { return $0f6b5998036e2e79$export$3584c46ed60baee8 = v; });
$parcel$export(module.exports, "tagClassByName", function () { return $0f6b5998036e2e79$export$f18596ef8d632e49; }, function (v) { return $0f6b5998036e2e79$export$f18596ef8d632e49 = v; });
$parcel$export(module.exports, "tag", function () { return $0f6b5998036e2e79$export$2b067c6666111485; }, function (v) { return $0f6b5998036e2e79$export$2b067c6666111485 = v; });
$parcel$export(module.exports, "tagByName", function () { return $0f6b5998036e2e79$export$f17df38a421ab9e3; }, function (v) { return $0f6b5998036e2e79$export$f17df38a421ab9e3 = v; });
var $0f6b5998036e2e79$export$3584c46ed60baee8;
var $0f6b5998036e2e79$export$f18596ef8d632e49;
var $0f6b5998036e2e79$export$2b067c6666111485;
var $0f6b5998036e2e79$export$f17df38a421ab9e3;

var $1fb9t = parcelRequire("1fb9t");
$0f6b5998036e2e79$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$0f6b5998036e2e79$export$f18596ef8d632e49 = $1fb9t._reverse($0f6b5998036e2e79$export$3584c46ed60baee8);
$0f6b5998036e2e79$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$0f6b5998036e2e79$export$f17df38a421ab9e3 = $1fb9t._reverse($0f6b5998036e2e79$export$2b067c6666111485);

});


parcelRegister("4hyYb", function(module, exports) {
var $31e3e03616588660$var$decoders = module.exports;

$31e3e03616588660$var$decoders.der = (parcelRequire("lOUAW"));

$31e3e03616588660$var$decoders.pem = (parcelRequire("hXQvW"));

});
parcelRegister("lOUAW", function(module, exports) {

var $dhT4G = parcelRequire("dhT4G");

var $hl0ih = parcelRequire("hl0ih");
var $fe2a2b049a9573f9$var$base = $hl0ih.base;
var $fe2a2b049a9573f9$var$bignum = $hl0ih.bignum;
// Import DER constants
var $fe2a2b049a9573f9$var$der = $hl0ih.constants.der;
function $fe2a2b049a9573f9$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $fe2a2b049a9573f9$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $fe2a2b049a9573f9$var$DERDecoder;
$fe2a2b049a9573f9$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $fe2a2b049a9573f9$var$base.DecoderBuffer)) data = new $fe2a2b049a9573f9$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $fe2a2b049a9573f9$var$DERNode(parent) {
    $fe2a2b049a9573f9$var$base.Node.call(this, 'der', parent);
}
$dhT4G($fe2a2b049a9573f9$var$DERNode, $fe2a2b049a9573f9$var$base.Node);
$fe2a2b049a9573f9$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $fe2a2b049a9573f9$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$fe2a2b049a9573f9$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $fe2a2b049a9573f9$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $fe2a2b049a9573f9$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$fe2a2b049a9573f9$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $fe2a2b049a9573f9$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $fe2a2b049a9573f9$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$fe2a2b049a9573f9$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$fe2a2b049a9573f9$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$fe2a2b049a9573f9$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$fe2a2b049a9573f9$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$fe2a2b049a9573f9$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$fe2a2b049a9573f9$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$fe2a2b049a9573f9$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $fe2a2b049a9573f9$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$fe2a2b049a9573f9$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $fe2a2b049a9573f9$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $fe2a2b049a9573f9$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $fe2a2b049a9573f9$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $fe2a2b049a9573f9$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("hXQvW", function(module, exports) {

var $dhT4G = parcelRequire("dhT4G");

var $bdjQ6 = parcelRequire("bdjQ6");
var $d140ae98da07bebb$require$Buffer = $bdjQ6.Buffer;

var $lOUAW = parcelRequire("lOUAW");
function $d140ae98da07bebb$var$PEMDecoder(entity) {
    $lOUAW.call(this, entity);
    this.enc = 'pem';
}
$dhT4G($d140ae98da07bebb$var$PEMDecoder, $lOUAW);
module.exports = $d140ae98da07bebb$var$PEMDecoder;
$d140ae98da07bebb$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new $d140ae98da07bebb$require$Buffer(base64, 'base64');
    return $lOUAW.prototype.decode.call(this, input, options);
};

});


parcelRegister("lDvlV", function(module, exports) {
var $fc058f72de806c01$var$encoders = module.exports;

$fc058f72de806c01$var$encoders.der = (parcelRequire("aowvn"));

$fc058f72de806c01$var$encoders.pem = (parcelRequire("lJ9hm"));

});
parcelRegister("aowvn", function(module, exports) {

var $dhT4G = parcelRequire("dhT4G");

var $bdjQ6 = parcelRequire("bdjQ6");
var $79155c1e61c68e60$require$Buffer = $bdjQ6.Buffer;

var $hl0ih = parcelRequire("hl0ih");
var $79155c1e61c68e60$var$base = $hl0ih.base;
// Import DER constants
var $79155c1e61c68e60$var$der = $hl0ih.constants.der;
function $79155c1e61c68e60$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $79155c1e61c68e60$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $79155c1e61c68e60$var$DEREncoder;
$79155c1e61c68e60$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $79155c1e61c68e60$var$DERNode(parent) {
    $79155c1e61c68e60$var$base.Node.call(this, 'der', parent);
}
$dhT4G($79155c1e61c68e60$var$DERNode, $79155c1e61c68e60$var$base.Node);
$79155c1e61c68e60$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $79155c1e61c68e60$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $79155c1e61c68e60$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $79155c1e61c68e60$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$79155c1e61c68e60$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new $79155c1e61c68e60$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$79155c1e61c68e60$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $79155c1e61c68e60$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $79155c1e61c68e60$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$79155c1e61c68e60$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        $79155c1e61c68e60$var$two(date.getFullYear()),
        $79155c1e61c68e60$var$two(date.getUTCMonth() + 1),
        $79155c1e61c68e60$var$two(date.getUTCDate()),
        $79155c1e61c68e60$var$two(date.getUTCHours()),
        $79155c1e61c68e60$var$two(date.getUTCMinutes()),
        $79155c1e61c68e60$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $79155c1e61c68e60$var$two(date.getFullYear() % 100),
        $79155c1e61c68e60$var$two(date.getUTCMonth() + 1),
        $79155c1e61c68e60$var$two(date.getUTCDate()),
        $79155c1e61c68e60$var$two(date.getUTCHours()),
        $79155c1e61c68e60$var$two(date.getUTCMinutes()),
        $79155c1e61c68e60$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$79155c1e61c68e60$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$79155c1e61c68e60$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$79155c1e61c68e60$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $79155c1e61c68e60$require$Buffer(numArray);
    }
    if ($79155c1e61c68e60$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $79155c1e61c68e60$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $79155c1e61c68e60$require$Buffer(out));
};
$79155c1e61c68e60$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$79155c1e61c68e60$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$79155c1e61c68e60$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $79155c1e61c68e60$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($79155c1e61c68e60$var$der.tagByName.hasOwnProperty(tag)) res = $79155c1e61c68e60$var$der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $79155c1e61c68e60$var$der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});

parcelRegister("lJ9hm", function(module, exports) {

var $dhT4G = parcelRequire("dhT4G");

var $aowvn = parcelRequire("aowvn");
function $fd14ff90396c39a5$var$PEMEncoder(entity) {
    $aowvn.call(this, entity);
    this.enc = 'pem';
}
$dhT4G($fd14ff90396c39a5$var$PEMEncoder, $aowvn);
module.exports = $fd14ff90396c39a5$var$PEMEncoder;
$fd14ff90396c39a5$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $aowvn.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});



parcelRegister("eqQT5", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    'Array',
    'Boolean',
    'Date',
    'Error',
    'EvalError',
    'Function',
    'Infinity',
    'JSON',
    'Math',
    'NaN',
    'Number',
    'Object',
    'RangeError',
    'ReferenceError',
    'RegExp',
    'String',
    'SyntaxError',
    'TypeError',
    'URIError',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'eval',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === 'object') forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("8PYd1", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $hl0ih = parcelRequire("hl0ih");
var $66f1ca64d4f026a4$var$Time = $hl0ih.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $66f1ca64d4f026a4$var$AttributeTypeValue = $hl0ih.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $66f1ca64d4f026a4$var$AlgorithmIdentifier = $hl0ih.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
});
var $66f1ca64d4f026a4$var$SubjectPublicKeyInfo = $hl0ih.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($66f1ca64d4f026a4$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $66f1ca64d4f026a4$var$RelativeDistinguishedName = $hl0ih.define('RelativeDistinguishedName', function() {
    this.setof($66f1ca64d4f026a4$var$AttributeTypeValue);
});
var $66f1ca64d4f026a4$var$RDNSequence = $hl0ih.define('RDNSequence', function() {
    this.seqof($66f1ca64d4f026a4$var$RelativeDistinguishedName);
});
var $66f1ca64d4f026a4$var$Name = $hl0ih.define('Name', function() {
    this.choice({
        rdnSequence: this.use($66f1ca64d4f026a4$var$RDNSequence)
    });
});
var $66f1ca64d4f026a4$var$Validity = $hl0ih.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($66f1ca64d4f026a4$var$Time), this.key('notAfter').use($66f1ca64d4f026a4$var$Time));
});
var $66f1ca64d4f026a4$var$Extension = $hl0ih.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $66f1ca64d4f026a4$var$TBSCertificate = $hl0ih.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0)['int']().optional(), this.key('serialNumber')['int'](), this.key('signature').use($66f1ca64d4f026a4$var$AlgorithmIdentifier), this.key('issuer').use($66f1ca64d4f026a4$var$Name), this.key('validity').use($66f1ca64d4f026a4$var$Validity), this.key('subject').use($66f1ca64d4f026a4$var$Name), this.key('subjectPublicKeyInfo').use($66f1ca64d4f026a4$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($66f1ca64d4f026a4$var$Extension).optional());
});
var $66f1ca64d4f026a4$var$X509Certificate = $hl0ih.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($66f1ca64d4f026a4$var$TBSCertificate), this.key('signatureAlgorithm').use($66f1ca64d4f026a4$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $66f1ca64d4f026a4$var$X509Certificate;

});

parcelRegister("iT16E", function(module, exports) {

var $bdjQ6 = parcelRequire("bdjQ6");
var $dbfe38b5b3f041f5$require$Buffer = $bdjQ6.Buffer;

var $a2sGY = parcelRequire("a2sGY");

var $f8x3B = parcelRequire("f8x3B");
module.exports = function createECDH(curve) {
    return new $dbfe38b5b3f041f5$var$ECDH(curve);
};
var $dbfe38b5b3f041f5$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$dbfe38b5b3f041f5$var$aliases.p224 = $dbfe38b5b3f041f5$var$aliases.secp224r1;
$dbfe38b5b3f041f5$var$aliases.p256 = $dbfe38b5b3f041f5$var$aliases.secp256r1 = $dbfe38b5b3f041f5$var$aliases.prime256v1;
$dbfe38b5b3f041f5$var$aliases.p192 = $dbfe38b5b3f041f5$var$aliases.secp192r1 = $dbfe38b5b3f041f5$var$aliases.prime192v1;
$dbfe38b5b3f041f5$var$aliases.p384 = $dbfe38b5b3f041f5$var$aliases.secp384r1;
$dbfe38b5b3f041f5$var$aliases.p521 = $dbfe38b5b3f041f5$var$aliases.secp521r1;
function $dbfe38b5b3f041f5$var$ECDH(curve) {
    this.curveType = $dbfe38b5b3f041f5$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $a2sGY.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$dbfe38b5b3f041f5$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$dbfe38b5b3f041f5$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$dbfe38b5b3f041f5$require$Buffer.isBuffer(other)) other = new $dbfe38b5b3f041f5$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $dbfe38b5b3f041f5$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$dbfe38b5b3f041f5$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $dbfe38b5b3f041f5$var$formatReturnValue(key, enc);
};
$dbfe38b5b3f041f5$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $dbfe38b5b3f041f5$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$dbfe38b5b3f041f5$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$dbfe38b5b3f041f5$require$Buffer.isBuffer(pub)) pub = new $dbfe38b5b3f041f5$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$dbfe38b5b3f041f5$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$dbfe38b5b3f041f5$require$Buffer.isBuffer(priv)) priv = new $dbfe38b5b3f041f5$require$Buffer(priv, enc);
    var _priv = new $f8x3B(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $dbfe38b5b3f041f5$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $dbfe38b5b3f041f5$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $dbfe38b5b3f041f5$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $dbfe38b5b3f041f5$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRegister("a2sGY", function(module, exports) {
'use strict';
var $74f058f4ed5df70c$var$elliptic = module.exports;

$74f058f4ed5df70c$var$elliptic.version = (parcelRequire("5yWHA")).version;

$74f058f4ed5df70c$var$elliptic.utils = (parcelRequire("2KPxf"));

$74f058f4ed5df70c$var$elliptic.rand = (parcelRequire("gWiKw"));

$74f058f4ed5df70c$var$elliptic.curve = (parcelRequire("5Hkfi"));

$74f058f4ed5df70c$var$elliptic.curves = (parcelRequire("hKjoi"));

// Protocols
$74f058f4ed5df70c$var$elliptic.ec = (parcelRequire("ijEQd"));

$74f058f4ed5df70c$var$elliptic.eddsa = (parcelRequire("9fmHx"));

});

parcelRegister("f8x3B", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("ifbub")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("eWI2k", function(module, exports) {

var $hdVtR = parcelRequire("hdVtR");

var $f08he = parcelRequire("f08he");

var $eNPUV = parcelRequire("eNPUV");

var $k9jil = parcelRequire("k9jil");

var $kkDNX = parcelRequire("kkDNX");

var $jKpja = parcelRequire("jKpja");

var $argyJ = parcelRequire("argyJ");

var $2jcIV = parcelRequire("2jcIV");

var $838j1 = parcelRequire("838j1");
var $ae18a42fc88e982d$require$Buffer = $838j1.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $hdVtR(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $ae18a42fc88e982d$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $ae18a42fc88e982d$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $jKpja(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $2jcIV(paddedMsg, key);
    else return $argyJ(paddedMsg, key);
};
function $ae18a42fc88e982d$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $eNPUV('sha1').update($ae18a42fc88e982d$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = $ae18a42fc88e982d$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $f08he(hLen);
    var maskedDb = $kkDNX($ae18a42fc88e982d$require$Buffer.concat([
        iHash,
        ps,
        $ae18a42fc88e982d$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $k9jil(seed, dblen));
    var maskedSeed = $kkDNX(seed, $k9jil(maskedDb, hLen));
    return new $jKpja($ae18a42fc88e982d$require$Buffer.concat([
        $ae18a42fc88e982d$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $ae18a42fc88e982d$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) ps = $ae18a42fc88e982d$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $ae18a42fc88e982d$var$nonZero(k - mLen - 3);
    return new $jKpja($ae18a42fc88e982d$require$Buffer.concat([
        $ae18a42fc88e982d$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $ae18a42fc88e982d$require$Buffer.alloc(1),
        msg
    ], k));
}
function $ae18a42fc88e982d$var$nonZero(len) {
    var out = $ae18a42fc88e982d$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $f08he(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $f08he(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("hdVtR", function(module, exports) {
'use strict';

var $1mcce = parcelRequire("1mcce");

var $7sB41 = parcelRequire("7sB41");

var $afsnk = parcelRequire("afsnk");

var $jGDtA = parcelRequire("jGDtA");

var $d0xYH = parcelRequire("d0xYH");
var $c8a03d08adb7e240$require$pbkdf2Sync = $d0xYH.pbkdf2Sync;

var $838j1 = parcelRequire("838j1");
var $c8a03d08adb7e240$require$Buffer = $838j1.Buffer;
function $c8a03d08adb7e240$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $7sB41[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $c8a03d08adb7e240$require$pbkdf2Sync(password, salt, iters, keylen, 'sha1');
    var cipher = $jGDtA.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher['final']());
    return $c8a03d08adb7e240$require$Buffer.concat(out);
}
function $c8a03d08adb7e240$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !$c8a03d08adb7e240$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = $c8a03d08adb7e240$require$Buffer.from(buffer);
    var stripped = $afsnk(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $1mcce.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $1mcce.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $1mcce.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $1mcce.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'ENCRYPTED PRIVATE KEY':
            data = $1mcce.EncryptedPrivateKey.decode(data, 'der');
            data = $c8a03d08adb7e240$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $1mcce.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $1mcce.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $1mcce.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $1mcce.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'RSA PUBLIC KEY':
            return $1mcce.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $1mcce.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $1mcce.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $1mcce.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$c8a03d08adb7e240$var$parseKeys.signature = $1mcce.signature;
module.exports = $c8a03d08adb7e240$var$parseKeys;

});
parcelRegister("1mcce", function(module, exports) {

$parcel$export(module.exports, "certificate", function () { return $0fd14e73698eb927$export$c98397a6eb8d0678; }, function (v) { return $0fd14e73698eb927$export$c98397a6eb8d0678 = v; });
$parcel$export(module.exports, "RSAPrivateKey", function () { return $0fd14e73698eb927$export$f4aab6816f64fa6b; }, function (v) { return $0fd14e73698eb927$export$f4aab6816f64fa6b = v; });
$parcel$export(module.exports, "RSAPublicKey", function () { return $0fd14e73698eb927$export$4471f5c65d097c11; }, function (v) { return $0fd14e73698eb927$export$4471f5c65d097c11 = v; });
$parcel$export(module.exports, "PublicKey", function () { return $0fd14e73698eb927$export$ca8b6604d6ce14de; }, function (v) { return $0fd14e73698eb927$export$ca8b6604d6ce14de = v; });
$parcel$export(module.exports, "PrivateKey", function () { return $0fd14e73698eb927$export$8f54525b330fd87b; }, function (v) { return $0fd14e73698eb927$export$8f54525b330fd87b = v; });
$parcel$export(module.exports, "EncryptedPrivateKey", function () { return $0fd14e73698eb927$export$23cd2842b44ca3e7; }, function (v) { return $0fd14e73698eb927$export$23cd2842b44ca3e7 = v; });
$parcel$export(module.exports, "DSAPrivateKey", function () { return $0fd14e73698eb927$export$245c9aaa9f5ce4ce; }, function (v) { return $0fd14e73698eb927$export$245c9aaa9f5ce4ce = v; });
$parcel$export(module.exports, "DSAparam", function () { return $0fd14e73698eb927$export$8ad762e3e6399afe; }, function (v) { return $0fd14e73698eb927$export$8ad762e3e6399afe = v; });
$parcel$export(module.exports, "ECPrivateKey", function () { return $0fd14e73698eb927$export$32ef6f92e22c6ab0; }, function (v) { return $0fd14e73698eb927$export$32ef6f92e22c6ab0 = v; });
$parcel$export(module.exports, "signature", function () { return $0fd14e73698eb927$export$c9cd164b539ebb63; }, function (v) { return $0fd14e73698eb927$export$c9cd164b539ebb63 = v; });
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $0fd14e73698eb927$export$c98397a6eb8d0678;
var $0fd14e73698eb927$export$f4aab6816f64fa6b;
var $0fd14e73698eb927$export$4471f5c65d097c11;
var $0fd14e73698eb927$export$ca8b6604d6ce14de;
var $0fd14e73698eb927$export$8f54525b330fd87b;
var $0fd14e73698eb927$export$23cd2842b44ca3e7;
var $0fd14e73698eb927$export$245c9aaa9f5ce4ce;
var $0fd14e73698eb927$export$8ad762e3e6399afe;
var $0fd14e73698eb927$export$32ef6f92e22c6ab0;
var $0fd14e73698eb927$export$c9cd164b539ebb63;
'use strict';

var $hl0ih = parcelRequire("hl0ih");

$0fd14e73698eb927$export$c98397a6eb8d0678 = (parcelRequire("8PYd1"));
var $0fd14e73698eb927$var$RSAPrivateKey = $hl0ih.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('modulus')['int'](), this.key('publicExponent')['int'](), this.key('privateExponent')['int'](), this.key('prime1')['int'](), this.key('prime2')['int'](), this.key('exponent1')['int'](), this.key('exponent2')['int'](), this.key('coefficient')['int']());
});
$0fd14e73698eb927$export$f4aab6816f64fa6b = $0fd14e73698eb927$var$RSAPrivateKey;
var $0fd14e73698eb927$var$RSAPublicKey = $hl0ih.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus')['int'](), this.key('publicExponent')['int']());
});
$0fd14e73698eb927$export$4471f5c65d097c11 = $0fd14e73698eb927$var$RSAPublicKey;
var $0fd14e73698eb927$var$AlgorithmIdentifier = $hl0ih.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int']()).optional());
});
var $0fd14e73698eb927$var$PublicKey = $hl0ih.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($0fd14e73698eb927$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$0fd14e73698eb927$export$ca8b6604d6ce14de = $0fd14e73698eb927$var$PublicKey;
var $0fd14e73698eb927$var$PrivateKeyInfo = $hl0ih.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version')['int'](), this.key('algorithm').use($0fd14e73698eb927$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$0fd14e73698eb927$export$8f54525b330fd87b = $0fd14e73698eb927$var$PrivateKeyInfo;
var $0fd14e73698eb927$var$EncryptedPrivateKeyInfo = $hl0ih.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters')['int']())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$0fd14e73698eb927$export$23cd2842b44ca3e7 = $0fd14e73698eb927$var$EncryptedPrivateKeyInfo;
var $0fd14e73698eb927$var$DSAPrivateKey = $hl0ih.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int'](), this.key('pub_key')['int'](), this.key('priv_key')['int']());
});
$0fd14e73698eb927$export$245c9aaa9f5ce4ce = $0fd14e73698eb927$var$DSAPrivateKey;
$0fd14e73698eb927$export$8ad762e3e6399afe = $hl0ih.define('DSAparam', function() {
    this['int']();
});
var $0fd14e73698eb927$var$ECParameters = $hl0ih.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $0fd14e73698eb927$var$ECPrivateKey = $hl0ih.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($0fd14e73698eb927$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$0fd14e73698eb927$export$32ef6f92e22c6ab0 = $0fd14e73698eb927$var$ECPrivateKey;
$0fd14e73698eb927$export$c9cd164b539ebb63 = $hl0ih.define('signature', function() {
    this.seq().obj(this.key('r')['int'](), this.key('s')['int']());
});

});

parcelRegister("7sB41", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("afsnk", function(module, exports) {
'use strict';
// adapted from https://github.com/apatil/pemstrip
var $776150cf36ad152d$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $776150cf36ad152d$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $776150cf36ad152d$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $iWvja = parcelRequire("iWvja");

var $jGDtA = parcelRequire("jGDtA");

var $838j1 = parcelRequire("838j1");
var $776150cf36ad152d$require$Buffer = $838j1.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($776150cf36ad152d$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($776150cf36ad152d$var$fullRegex);
        decrypted = $776150cf36ad152d$require$Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = $776150cf36ad152d$require$Buffer.from(match[2], 'hex');
        var cipherText = $776150cf36ad152d$require$Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
        var cipherKey = $iWvja(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $jGDtA.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher['final']());
        decrypted = $776150cf36ad152d$require$Buffer.concat(out);
    }
    var tag = key.match($776150cf36ad152d$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});
parcelRegister("iWvja", function(module, exports) {

var $838j1 = parcelRequire("838j1");
var $dca5eded79f2f8af$require$Buffer = $838j1.Buffer;

var $2GAk4 = parcelRequire("2GAk4");
/* eslint-disable camelcase */ function $dca5eded79f2f8af$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$dca5eded79f2f8af$require$Buffer.isBuffer(password)) password = $dca5eded79f2f8af$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$dca5eded79f2f8af$require$Buffer.isBuffer(salt)) salt = $dca5eded79f2f8af$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $dca5eded79f2f8af$require$Buffer.alloc(keyLen);
    var iv = $dca5eded79f2f8af$require$Buffer.alloc(ivLen || 0);
    var tmp = $dca5eded79f2f8af$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $2GAk4();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $dca5eded79f2f8af$var$EVP_BytesToKey;

});

parcelRegister("jGDtA", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $e5508fb2c65b1709$export$2f64596b8cbf08b4; }, function (v) { return $e5508fb2c65b1709$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $e5508fb2c65b1709$export$36b6d6ef312eab39; }, function (v) { return $e5508fb2c65b1709$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $e5508fb2c65b1709$export$58a258485f1e49f6; }, function (v) { return $e5508fb2c65b1709$export$58a258485f1e49f6 = v; });
var $e5508fb2c65b1709$export$bdd223f16383713e;
var $e5508fb2c65b1709$export$26e5786e8ac8e530;
var $e5508fb2c65b1709$export$2f64596b8cbf08b4;
var $e5508fb2c65b1709$export$20533d26f07f1ee0;
var $e5508fb2c65b1709$export$12ada9414fbc594c;
var $e5508fb2c65b1709$export$2ce6d8d0e8b04e1a;
var $e5508fb2c65b1709$export$36b6d6ef312eab39;
var $e5508fb2c65b1709$export$f5e7e39d57cd9700;
var $e5508fb2c65b1709$export$dedd8dc3dc62b370;
var $e5508fb2c65b1709$export$58a258485f1e49f6;

var $2wD6K = parcelRequire("2wD6K");

var $3eloO = parcelRequire("3eloO");

var $fmEa8 = parcelRequire("fmEa8");
function $e5508fb2c65b1709$var$getCiphers() {
    return Object.keys($fmEa8);
}
$e5508fb2c65b1709$export$bdd223f16383713e = $e5508fb2c65b1709$export$26e5786e8ac8e530 = $2wD6K.createCipher;
$e5508fb2c65b1709$export$2f64596b8cbf08b4 = $e5508fb2c65b1709$export$20533d26f07f1ee0 = $2wD6K.createCipheriv;
$e5508fb2c65b1709$export$12ada9414fbc594c = $e5508fb2c65b1709$export$2ce6d8d0e8b04e1a = $3eloO.createDecipher;
$e5508fb2c65b1709$export$36b6d6ef312eab39 = $e5508fb2c65b1709$export$f5e7e39d57cd9700 = $3eloO.createDecipheriv;
$e5508fb2c65b1709$export$dedd8dc3dc62b370 = $e5508fb2c65b1709$export$58a258485f1e49f6 = $e5508fb2c65b1709$var$getCiphers;

});
parcelRegister("2wD6K", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $1d6ce7ec05afe9d6$export$2f64596b8cbf08b4; }, function (v) { return $1d6ce7ec05afe9d6$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createCipher", function () { return $1d6ce7ec05afe9d6$export$bdd223f16383713e; }, function (v) { return $1d6ce7ec05afe9d6$export$bdd223f16383713e = v; });
var $1d6ce7ec05afe9d6$export$2f64596b8cbf08b4;
var $1d6ce7ec05afe9d6$export$bdd223f16383713e;

var $gaNIZ = parcelRequire("gaNIZ");

var $kvo4q = parcelRequire("kvo4q");

var $838j1 = parcelRequire("838j1");
var $1d6ce7ec05afe9d6$require$Buffer = $838j1.Buffer;

var $2mx7M = parcelRequire("2mx7M");

var $6GOuC = parcelRequire("6GOuC");

var $caH4w = parcelRequire("caH4w");

var $iWvja = parcelRequire("iWvja");

var $dhT4G = parcelRequire("dhT4G");
function $1d6ce7ec05afe9d6$var$Cipher(mode, key, iv) {
    $6GOuC.call(this);
    this._cache = new $1d6ce7ec05afe9d6$var$Splitter();
    this._cipher = new $caH4w.AES(key);
    this._prev = $1d6ce7ec05afe9d6$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dhT4G($1d6ce7ec05afe9d6$var$Cipher, $6GOuC);
$1d6ce7ec05afe9d6$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $1d6ce7ec05afe9d6$require$Buffer.concat(out);
};
var $1d6ce7ec05afe9d6$var$PADDING = $1d6ce7ec05afe9d6$require$Buffer.alloc(16, 0x10);
$1d6ce7ec05afe9d6$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($1d6ce7ec05afe9d6$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$1d6ce7ec05afe9d6$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $1d6ce7ec05afe9d6$var$Splitter() {
    this.cache = $1d6ce7ec05afe9d6$require$Buffer.allocUnsafe(0);
}
$1d6ce7ec05afe9d6$var$Splitter.prototype.add = function(data) {
    this.cache = $1d6ce7ec05afe9d6$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$1d6ce7ec05afe9d6$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$1d6ce7ec05afe9d6$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $1d6ce7ec05afe9d6$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $1d6ce7ec05afe9d6$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $1d6ce7ec05afe9d6$var$createCipheriv(suite, password, iv) {
    var config = $gaNIZ[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $1d6ce7ec05afe9d6$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $1d6ce7ec05afe9d6$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $2mx7M(config.module, password, iv);
    else if (config.type === 'auth') return new $kvo4q(config.module, password, iv);
    return new $1d6ce7ec05afe9d6$var$Cipher(config.module, password, iv);
}
function $1d6ce7ec05afe9d6$var$createCipher(suite, password) {
    var config = $gaNIZ[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $iWvja(password, false, config.key, config.iv);
    return $1d6ce7ec05afe9d6$var$createCipheriv(suite, keys.key, keys.iv);
}
$1d6ce7ec05afe9d6$export$2f64596b8cbf08b4 = $1d6ce7ec05afe9d6$var$createCipheriv;
$1d6ce7ec05afe9d6$export$bdd223f16383713e = $1d6ce7ec05afe9d6$var$createCipher;

});
parcelRegister("gaNIZ", function(module, exports) {








var $bc6426c4a0e99f84$var$modeModules = {
    ECB: (parcelRequire("4VNRd")),
    CBC: (parcelRequire("dSvNa")),
    CFB: (parcelRequire("hBCvG")),
    CFB8: (parcelRequire("4EjJt")),
    CFB1: (parcelRequire("deF8T")),
    OFB: (parcelRequire("bxTz8")),
    CTR: (parcelRequire("5DIgH")),
    GCM: (parcelRequire("5DIgH"))
};

var $fmEa8 = parcelRequire("fmEa8");
for(var $bc6426c4a0e99f84$var$key in $fmEa8)$fmEa8[$bc6426c4a0e99f84$var$key].module = $bc6426c4a0e99f84$var$modeModules[$fmEa8[$bc6426c4a0e99f84$var$key].mode];
module.exports = $fmEa8;

});
parcelRegister("fmEa8", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});


parcelRegister("kvo4q", function(module, exports) {

var $caH4w = parcelRequire("caH4w");

var $838j1 = parcelRequire("838j1");
var $eed95fc46cf3d7a4$require$Buffer = $838j1.Buffer;

var $6GOuC = parcelRequire("6GOuC");

var $dhT4G = parcelRequire("dhT4G");

var $9hgQS = parcelRequire("9hgQS");

var $lG93x = parcelRequire("lG93x");

var $h75HQ = parcelRequire("h75HQ");
function $eed95fc46cf3d7a4$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $eed95fc46cf3d7a4$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $eed95fc46cf3d7a4$require$Buffer.concat([
            iv,
            $eed95fc46cf3d7a4$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $eed95fc46cf3d7a4$require$Buffer.concat([
            iv,
            $eed95fc46cf3d7a4$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $9hgQS(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($eed95fc46cf3d7a4$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($eed95fc46cf3d7a4$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $eed95fc46cf3d7a4$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $eed95fc46cf3d7a4$require$Buffer.from(self._finID);
    $h75HQ(out);
    return out;
}
function $eed95fc46cf3d7a4$var$StreamCipher(mode, key, iv, decrypt) {
    $6GOuC.call(this);
    var h = $eed95fc46cf3d7a4$require$Buffer.alloc(4, 0);
    this._cipher = new $caH4w.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $9hgQS(ck);
    iv = $eed95fc46cf3d7a4$var$calcIv(this, iv, ck);
    this._prev = $eed95fc46cf3d7a4$require$Buffer.from(iv);
    this._cache = $eed95fc46cf3d7a4$require$Buffer.allocUnsafe(0);
    this._secCache = $eed95fc46cf3d7a4$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$dhT4G($eed95fc46cf3d7a4$var$StreamCipher, $6GOuC);
$eed95fc46cf3d7a4$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $eed95fc46cf3d7a4$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$eed95fc46cf3d7a4$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $lG93x(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $eed95fc46cf3d7a4$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$eed95fc46cf3d7a4$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$eed95fc46cf3d7a4$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$eed95fc46cf3d7a4$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$eed95fc46cf3d7a4$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $eed95fc46cf3d7a4$var$StreamCipher;

});
parcelRegister("caH4w", function(module, exports) {

$parcel$export(module.exports, "AES", function () { return $8dc7d467606a8980$export$b80fbe1c3a2b92b5; }, function (v) { return $8dc7d467606a8980$export$b80fbe1c3a2b92b5 = v; });
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $8dc7d467606a8980$export$b80fbe1c3a2b92b5;

var $838j1 = parcelRequire("838j1");
var $8dc7d467606a8980$require$Buffer = $838j1.Buffer;
function $8dc7d467606a8980$var$asUInt32Array(buf) {
    if (!$8dc7d467606a8980$require$Buffer.isBuffer(buf)) buf = $8dc7d467606a8980$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $8dc7d467606a8980$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $8dc7d467606a8980$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $8dc7d467606a8980$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $8dc7d467606a8980$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $8dc7d467606a8980$var$AES(key) {
    this._key = $8dc7d467606a8980$var$asUInt32Array(key);
    this._reset();
}
$8dc7d467606a8980$var$AES.blockSize = 16;
$8dc7d467606a8980$var$AES.keySize = 32;
$8dc7d467606a8980$var$AES.prototype.blockSize = $8dc7d467606a8980$var$AES.blockSize;
$8dc7d467606a8980$var$AES.prototype.keySize = $8dc7d467606a8980$var$AES.keySize;
$8dc7d467606a8980$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $8dc7d467606a8980$var$G.SBOX[t >>> 24] << 24 | $8dc7d467606a8980$var$G.SBOX[t >>> 16 & 0xff] << 16 | $8dc7d467606a8980$var$G.SBOX[t >>> 8 & 0xff] << 8 | $8dc7d467606a8980$var$G.SBOX[t & 0xff];
            t ^= $8dc7d467606a8980$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $8dc7d467606a8980$var$G.SBOX[t >>> 24] << 24 | $8dc7d467606a8980$var$G.SBOX[t >>> 16 & 0xff] << 16 | $8dc7d467606a8980$var$G.SBOX[t >>> 8 & 0xff] << 8 | $8dc7d467606a8980$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $8dc7d467606a8980$var$G.INV_SUB_MIX[0][$8dc7d467606a8980$var$G.SBOX[tt >>> 24]] ^ $8dc7d467606a8980$var$G.INV_SUB_MIX[1][$8dc7d467606a8980$var$G.SBOX[tt >>> 16 & 0xff]] ^ $8dc7d467606a8980$var$G.INV_SUB_MIX[2][$8dc7d467606a8980$var$G.SBOX[tt >>> 8 & 0xff]] ^ $8dc7d467606a8980$var$G.INV_SUB_MIX[3][$8dc7d467606a8980$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$8dc7d467606a8980$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $8dc7d467606a8980$var$asUInt32Array(M);
    return $8dc7d467606a8980$var$cryptBlock(M, this._keySchedule, $8dc7d467606a8980$var$G.SUB_MIX, $8dc7d467606a8980$var$G.SBOX, this._nRounds);
};
$8dc7d467606a8980$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $8dc7d467606a8980$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$8dc7d467606a8980$var$AES.prototype.decryptBlock = function(M) {
    M = $8dc7d467606a8980$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $8dc7d467606a8980$var$cryptBlock(M, this._invKeySchedule, $8dc7d467606a8980$var$G.INV_SUB_MIX, $8dc7d467606a8980$var$G.INV_SBOX, this._nRounds);
    var buf = $8dc7d467606a8980$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$8dc7d467606a8980$var$AES.prototype.scrub = function() {
    $8dc7d467606a8980$var$scrubVec(this._keySchedule);
    $8dc7d467606a8980$var$scrubVec(this._invKeySchedule);
    $8dc7d467606a8980$var$scrubVec(this._key);
};
$8dc7d467606a8980$export$b80fbe1c3a2b92b5 = $8dc7d467606a8980$var$AES;

});

parcelRegister("9hgQS", function(module, exports) {

var $838j1 = parcelRequire("838j1");
var $6c12c604584aeb07$require$Buffer = $838j1.Buffer;
var $6c12c604584aeb07$var$ZEROES = $6c12c604584aeb07$require$Buffer.alloc(16, 0);
function $6c12c604584aeb07$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $6c12c604584aeb07$var$fromArray(out) {
    var buf = $6c12c604584aeb07$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $6c12c604584aeb07$var$GHASH(key) {
    this.h = key;
    this.state = $6c12c604584aeb07$require$Buffer.alloc(16, 0);
    this.cache = $6c12c604584aeb07$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$6c12c604584aeb07$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$6c12c604584aeb07$var$GHASH.prototype._multiply = function() {
    var Vi = $6c12c604584aeb07$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $6c12c604584aeb07$var$fromArray(Zi);
};
$6c12c604584aeb07$var$GHASH.prototype.update = function(buf) {
    this.cache = $6c12c604584aeb07$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$6c12c604584aeb07$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($6c12c604584aeb07$require$Buffer.concat([
        this.cache,
        $6c12c604584aeb07$var$ZEROES
    ], 16));
    this.ghash($6c12c604584aeb07$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $6c12c604584aeb07$var$GHASH;

});


parcelRegister("2mx7M", function(module, exports) {

var $caH4w = parcelRequire("caH4w");

var $838j1 = parcelRequire("838j1");
var $1b8754b29224ac43$require$Buffer = $838j1.Buffer;

var $6GOuC = parcelRequire("6GOuC");

var $dhT4G = parcelRequire("dhT4G");
function $1b8754b29224ac43$var$StreamCipher(mode, key, iv, decrypt) {
    $6GOuC.call(this);
    this._cipher = new $caH4w.AES(key);
    this._prev = $1b8754b29224ac43$require$Buffer.from(iv);
    this._cache = $1b8754b29224ac43$require$Buffer.allocUnsafe(0);
    this._secCache = $1b8754b29224ac43$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$dhT4G($1b8754b29224ac43$var$StreamCipher, $6GOuC);
$1b8754b29224ac43$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$1b8754b29224ac43$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $1b8754b29224ac43$var$StreamCipher;

});


parcelRegister("3eloO", function(module, exports) {

$parcel$export(module.exports, "createDecipher", function () { return $25a34751f31406fd$export$12ada9414fbc594c; }, function (v) { return $25a34751f31406fd$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $25a34751f31406fd$export$36b6d6ef312eab39; }, function (v) { return $25a34751f31406fd$export$36b6d6ef312eab39 = v; });
var $25a34751f31406fd$export$12ada9414fbc594c;
var $25a34751f31406fd$export$36b6d6ef312eab39;

var $kvo4q = parcelRequire("kvo4q");

var $838j1 = parcelRequire("838j1");
var $25a34751f31406fd$require$Buffer = $838j1.Buffer;

var $gaNIZ = parcelRequire("gaNIZ");

var $2mx7M = parcelRequire("2mx7M");

var $6GOuC = parcelRequire("6GOuC");

var $caH4w = parcelRequire("caH4w");

var $iWvja = parcelRequire("iWvja");

var $dhT4G = parcelRequire("dhT4G");
function $25a34751f31406fd$var$Decipher(mode, key, iv) {
    $6GOuC.call(this);
    this._cache = new $25a34751f31406fd$var$Splitter();
    this._last = void 0;
    this._cipher = new $caH4w.AES(key);
    this._prev = $25a34751f31406fd$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dhT4G($25a34751f31406fd$var$Decipher, $6GOuC);
$25a34751f31406fd$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $25a34751f31406fd$require$Buffer.concat(out);
};
$25a34751f31406fd$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $25a34751f31406fd$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$25a34751f31406fd$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $25a34751f31406fd$var$Splitter() {
    this.cache = $25a34751f31406fd$require$Buffer.allocUnsafe(0);
}
$25a34751f31406fd$var$Splitter.prototype.add = function(data) {
    this.cache = $25a34751f31406fd$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$25a34751f31406fd$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$25a34751f31406fd$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $25a34751f31406fd$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $25a34751f31406fd$var$createDecipheriv(suite, password, iv) {
    var config = $gaNIZ[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $25a34751f31406fd$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $25a34751f31406fd$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $2mx7M(config.module, password, iv, true);
    else if (config.type === 'auth') return new $kvo4q(config.module, password, iv, true);
    return new $25a34751f31406fd$var$Decipher(config.module, password, iv);
}
function $25a34751f31406fd$var$createDecipher(suite, password) {
    var config = $gaNIZ[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $iWvja(password, false, config.key, config.iv);
    return $25a34751f31406fd$var$createDecipheriv(suite, keys.key, keys.iv);
}
$25a34751f31406fd$export$12ada9414fbc594c = $25a34751f31406fd$var$createDecipher;
$25a34751f31406fd$export$36b6d6ef312eab39 = $25a34751f31406fd$var$createDecipheriv;

});



parcelRegister("d0xYH", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $9785a1c88b34149b$export$448fa22aedc9dbca; }, function (v) { return $9785a1c88b34149b$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $9785a1c88b34149b$export$b80c7ba289c8fa56; }, function (v) { return $9785a1c88b34149b$export$b80c7ba289c8fa56 = v; });
var $9785a1c88b34149b$export$448fa22aedc9dbca;
var $9785a1c88b34149b$export$b80c7ba289c8fa56;
'use strict';

$9785a1c88b34149b$export$448fa22aedc9dbca = (parcelRequire("jZEYv"));

$9785a1c88b34149b$export$b80c7ba289c8fa56 = (parcelRequire("9Tp97"));

});


parcelRegister("k9jil", function(module, exports) {

var $eNPUV = parcelRequire("eNPUV");

var $838j1 = parcelRequire("838j1");
var $eab39d77b6a56d48$require$Buffer = $838j1.Buffer;
module.exports = function(seed, len) {
    var t = $eab39d77b6a56d48$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $eab39d77b6a56d48$var$i2ops(i++);
        t = $eab39d77b6a56d48$require$Buffer.concat([
            t,
            $eNPUV('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $eab39d77b6a56d48$var$i2ops(c) {
    var out = $eab39d77b6a56d48$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("kkDNX", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("jKpja", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("ifbub")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("argyJ", function(module, exports) {

var $jKpja = parcelRequire("jKpja");

var $838j1 = parcelRequire("838j1");
var $799945527bd57bd7$require$Buffer = $838j1.Buffer;
function $799945527bd57bd7$var$withPublic(paddedMsg, key) {
    return $799945527bd57bd7$require$Buffer.from(paddedMsg.toRed($jKpja.mont(key.modulus)).redPow(new $jKpja(key.publicExponent)).fromRed().toArray());
}
module.exports = $799945527bd57bd7$var$withPublic;

});

parcelRegister("2jcIV", function(module, exports) {
'use strict';

var $aVh2m = parcelRequire("aVh2m");

var $f08he = parcelRequire("f08he");

var $838j1 = parcelRequire("838j1");
var $1ae739bfcb63454f$require$Buffer = $838j1.Buffer;
function $1ae739bfcb63454f$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $aVh2m($f08he(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $1ae739bfcb63454f$var$blind(priv) {
    var r = $1ae739bfcb63454f$var$getr(priv);
    var blinder = r.toRed($aVh2m.mont(priv.modulus)).redPow(new $aVh2m(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $1ae739bfcb63454f$var$crt(msg, priv) {
    var blinds = $1ae739bfcb63454f$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $aVh2m(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($aVh2m.mont(priv.prime1));
    var c2 = blinded.toRed($aVh2m.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($1ae739bfcb63454f$require$Buffer, 'be', len);
}
$1ae739bfcb63454f$var$crt.getr = $1ae739bfcb63454f$var$getr;
module.exports = $1ae739bfcb63454f$var$crt;

});


parcelRegister("fUUOC", function(module, exports) {

var $hdVtR = parcelRequire("hdVtR");

var $k9jil = parcelRequire("k9jil");

var $kkDNX = parcelRequire("kkDNX");

var $jKpja = parcelRequire("jKpja");

var $2jcIV = parcelRequire("2jcIV");

var $eNPUV = parcelRequire("eNPUV");

var $argyJ = parcelRequire("argyJ");

var $838j1 = parcelRequire("838j1");
var $b9682859c179c6a2$require$Buffer = $838j1.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $hdVtR(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $jKpja(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $argyJ(new $jKpja(enc), key);
    else msg = $2jcIV(enc, key);
    var zBuffer = $b9682859c179c6a2$require$Buffer.alloc(k - msg.length);
    msg = $b9682859c179c6a2$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $b9682859c179c6a2$var$oaep(key, msg);
    else if (padding === 1) return $b9682859c179c6a2$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $b9682859c179c6a2$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $eNPUV('sha1').update($b9682859c179c6a2$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $kkDNX(maskedSeed, $k9jil(maskedDb, hLen));
    var db = $kkDNX(maskedDb, $k9jil(seed, k - hLen - 1));
    if ($b9682859c179c6a2$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $b9682859c179c6a2$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $b9682859c179c6a2$var$compare(a, b) {
    a = $b9682859c179c6a2$require$Buffer.from(a);
    b = $b9682859c179c6a2$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});

parcelRegister("iBNfx", function(module, exports) {
"use strict";
var $d8c1e2a1cf8cf9b0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d8c1e2a1cf8cf9b0$var$StyleToObject;

const $d8c1e2a1cf8cf9b0$var$inline_style_parser_1 = $d8c1e2a1cf8cf9b0$var$__importDefault((parcelRequire("7i3uy")));
/**
 * Parses inline style to object.
 *
 * @param style - Inline style.
 * @param iterator - Iterator.
 * @returns - Style object or null.
 *
 * @example Parsing inline style to object:
 *
 * ```js
 * import parse from 'style-to-object';
 * parse('line-height: 42;'); // { 'line-height': '42' }
 * ```
 */ function $d8c1e2a1cf8cf9b0$var$StyleToObject(style, iterator) {
    let styleObject = null;
    if (!style || typeof style !== 'string') return styleObject;
    const declarations = (0, $d8c1e2a1cf8cf9b0$var$inline_style_parser_1.default)(style);
    const hasIterator = typeof iterator === 'function';
    declarations.forEach((declaration)=>{
        if (declaration.type !== 'declaration') return;
        const { property: property, value: value } = declaration;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            styleObject = styleObject || {};
            styleObject[property] = value;
        }
    });
    return styleObject;
}

});
parcelRegister("7i3uy", function(module, exports) {
'use strict';
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $54ecec3fabbab431$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $54ecec3fabbab431$var$NEWLINE_REGEX = /\n/g;
var $54ecec3fabbab431$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $54ecec3fabbab431$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $54ecec3fabbab431$var$COLON_REGEX = /^:\s*/;
var $54ecec3fabbab431$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $54ecec3fabbab431$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $54ecec3fabbab431$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $54ecec3fabbab431$var$NEWLINE = '\n';
var $54ecec3fabbab431$var$FORWARD_SLASH = '/';
var $54ecec3fabbab431$var$ASTERISK = '*';
var $54ecec3fabbab431$var$EMPTY_STRING = '';
// types
var $54ecec3fabbab431$var$TYPE_COMMENT = 'comment';
var $54ecec3fabbab431$var$TYPE_DECLARATION = 'declaration';
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ function $54ecec3fabbab431$var$index(style, options) {
    if (typeof style !== 'string') throw new TypeError('First argument must be a string');
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($54ecec3fabbab431$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($54ecec3fabbab431$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ':' + lineno + ':' + column + ': ' + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) ;
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($54ecec3fabbab431$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($54ecec3fabbab431$var$FORWARD_SLASH != style.charAt(0) || $54ecec3fabbab431$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($54ecec3fabbab431$var$EMPTY_STRING != style.charAt(i) && ($54ecec3fabbab431$var$ASTERISK != style.charAt(i) || $54ecec3fabbab431$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($54ecec3fabbab431$var$EMPTY_STRING === style.charAt(i - 1)) return error('End of comment missing');
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $54ecec3fabbab431$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($54ecec3fabbab431$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($54ecec3fabbab431$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($54ecec3fabbab431$var$VALUE_REGEX);
        var ret = pos({
            type: $54ecec3fabbab431$var$TYPE_DECLARATION,
            property: $54ecec3fabbab431$var$trim(prop[0].replace($54ecec3fabbab431$var$COMMENT_REGEX, $54ecec3fabbab431$var$EMPTY_STRING)),
            value: val ? $54ecec3fabbab431$var$trim(val[0].replace($54ecec3fabbab431$var$COMMENT_REGEX, $54ecec3fabbab431$var$EMPTY_STRING)) : $54ecec3fabbab431$var$EMPTY_STRING
        });
        // ;
        match($54ecec3fabbab431$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
}
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $54ecec3fabbab431$var$trim(str) {
    return str ? str.replace($54ecec3fabbab431$var$TRIM_REGEX, $54ecec3fabbab431$var$EMPTY_STRING) : $54ecec3fabbab431$var$EMPTY_STRING;
}
module.exports = $54ecec3fabbab431$var$index;

});


var $4ab4df502cb196a5$exports = {};
$parcel$extendImportMap({
    "5x3at": "browser-ponyfill.1c02357c.js",
    "dHypX": "model.tar.ad9aa18b.gz"
});

var $824c049f32d4395d$exports = {};
'use strict';

$824c049f32d4395d$exports = (parcelRequire("2nzLi"));


/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $9afc3518733c6a5e$export$2e2bcd8739ae039(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}



var $7fPBF = parcelRequire("7fPBF");
var $dddaf6f84c717660$exports = {};
'use strict';

$dddaf6f84c717660$exports = (parcelRequire("9kHYF"));


function $291e2c063c5d6173$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $291e2c063c5d6173$var$deepClone(source) {
    if (/*#__PURE__*/ $7fPBF.isValidElement(source) || (0, $dddaf6f84c717660$exports.isValidElementType)(source) || !$291e2c063c5d6173$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $291e2c063c5d6173$var$deepClone(source[key]);
    });
    return output;
}
function $291e2c063c5d6173$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($291e2c063c5d6173$export$53b83ca8eaab0383(target) && $291e2c063c5d6173$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $7fPBF.isValidElement(source[key]) || (0, $dddaf6f84c717660$exports.isValidElementType)(source[key])) output[key] = source[key];
        else if ($291e2c063c5d6173$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $291e2c063c5d6173$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $291e2c063c5d6173$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $291e2c063c5d6173$export$53b83ca8eaab0383(source[key]) ? $291e2c063c5d6173$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}



function $3e74852d812b8b64$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $3e74852d812b8b64$export$2e2bcd8739ae039 = $3e74852d812b8b64$var$clamp;


/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $4afad3ab73a4d920$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $3e74852d812b8b64$export$2e2bcd8739ae039)(value, min, max);
}
function $4afad3ab73a4d920$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $4afad3ab73a4d920$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $4afad3ab73a4d920$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $4afad3ab73a4d920$export$677b39864803984e($4afad3ab73a4d920$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $9afc3518733c6a5e$export$2e2bcd8739ae039)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $9afc3518733c6a5e$export$2e2bcd8739ae039)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $4afad3ab73a4d920$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $4afad3ab73a4d920$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
const $4afad3ab73a4d920$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $4afad3ab73a4d920$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $4afad3ab73a4d920$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $4afad3ab73a4d920$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $4afad3ab73a4d920$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$4afad3ab73a4d920$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $4afad3ab73a4d920$export$29fb7152bd3f781a(color) {
    color = $4afad3ab73a4d920$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $4afad3ab73a4d920$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $4afad3ab73a4d920$export$c852d90bf7403b62(color) {
    color = $4afad3ab73a4d920$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $4afad3ab73a4d920$export$677b39864803984e($4afad3ab73a4d920$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $4afad3ab73a4d920$export$d061e26956a60b0a(foreground, background) {
    const lumA = $4afad3ab73a4d920$export$c852d90bf7403b62(foreground);
    const lumB = $4afad3ab73a4d920$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $4afad3ab73a4d920$export$58f0f39f63f3cf42(color, value) {
    color = $4afad3ab73a4d920$export$677b39864803984e(color);
    value = $4afad3ab73a4d920$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $4afad3ab73a4d920$export$211a73f2b8c10ce4(color);
}
function $4afad3ab73a4d920$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $4afad3ab73a4d920$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $4afad3ab73a4d920$export$4b073707ff63303(color, coefficient) {
    color = $4afad3ab73a4d920$export$677b39864803984e(color);
    coefficient = $4afad3ab73a4d920$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $4afad3ab73a4d920$export$211a73f2b8c10ce4(color);
}
function $4afad3ab73a4d920$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $4afad3ab73a4d920$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $4afad3ab73a4d920$export$c0816ed86df316af(color, coefficient) {
    color = $4afad3ab73a4d920$export$677b39864803984e(color);
    coefficient = $4afad3ab73a4d920$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $4afad3ab73a4d920$export$211a73f2b8c10ce4(color);
}
function $4afad3ab73a4d920$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $4afad3ab73a4d920$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $4afad3ab73a4d920$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $4afad3ab73a4d920$export$c852d90bf7403b62(color) > 0.5 ? $4afad3ab73a4d920$export$4b073707ff63303(color, coefficient) : $4afad3ab73a4d920$export$c0816ed86df316af(color, coefficient);
}
function $4afad3ab73a4d920$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $4afad3ab73a4d920$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $4afad3ab73a4d920$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $4afad3ab73a4d920$export$677b39864803984e(background);
    const overlayColor = $4afad3ab73a4d920$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $4afad3ab73a4d920$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}


const $47d3f19e39b3b144$var$common = {
    black: '#000',
    white: '#fff'
};
var $47d3f19e39b3b144$export$2e2bcd8739ae039 = $47d3f19e39b3b144$var$common;


const $1baba9d0f229a247$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $1baba9d0f229a247$export$2e2bcd8739ae039 = $1baba9d0f229a247$var$grey;


const $2a2bdbc6cce4aa96$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $2a2bdbc6cce4aa96$export$2e2bcd8739ae039 = $2a2bdbc6cce4aa96$var$purple;


const $72940215fdf862f4$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $72940215fdf862f4$export$2e2bcd8739ae039 = $72940215fdf862f4$var$red;


const $454ad523c90fa85d$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $454ad523c90fa85d$export$2e2bcd8739ae039 = $454ad523c90fa85d$var$orange;


const $bc4de82bafd68977$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $bc4de82bafd68977$export$2e2bcd8739ae039 = $bc4de82bafd68977$var$blue;


const $12b015f9ee6c8f9f$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $12b015f9ee6c8f9f$export$2e2bcd8739ae039 = $12b015f9ee6c8f9f$var$lightBlue;


const $ca65bc19996a7eac$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $ca65bc19996a7eac$export$2e2bcd8739ae039 = $ca65bc19996a7eac$var$green;


function $07e9efd96a5c6f8a$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: (0, $47d3f19e39b3b144$export$2e2bcd8739ae039).white,
            default: (0, $47d3f19e39b3b144$export$2e2bcd8739ae039).white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $07e9efd96a5c6f8a$export$a43af521ac8c3202 = $07e9efd96a5c6f8a$var$getLight();
function $07e9efd96a5c6f8a$var$getDark() {
    return {
        text: {
            primary: (0, $47d3f19e39b3b144$export$2e2bcd8739ae039).white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: (0, $47d3f19e39b3b144$export$2e2bcd8739ae039).white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $07e9efd96a5c6f8a$export$55ce6f3a06c59543 = $07e9efd96a5c6f8a$var$getDark();
function $07e9efd96a5c6f8a$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $4afad3ab73a4d920$export$c0816ed86df316af)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $4afad3ab73a4d920$export$4b073707ff63303)(intent.main, tonalOffsetDark);
    }
}
function $07e9efd96a5c6f8a$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $bc4de82bafd68977$export$2e2bcd8739ae039)[200],
        light: (0, $bc4de82bafd68977$export$2e2bcd8739ae039)[50],
        dark: (0, $bc4de82bafd68977$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $bc4de82bafd68977$export$2e2bcd8739ae039)[700],
        light: (0, $bc4de82bafd68977$export$2e2bcd8739ae039)[400],
        dark: (0, $bc4de82bafd68977$export$2e2bcd8739ae039)[800]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $2a2bdbc6cce4aa96$export$2e2bcd8739ae039)[200],
        light: (0, $2a2bdbc6cce4aa96$export$2e2bcd8739ae039)[50],
        dark: (0, $2a2bdbc6cce4aa96$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $2a2bdbc6cce4aa96$export$2e2bcd8739ae039)[500],
        light: (0, $2a2bdbc6cce4aa96$export$2e2bcd8739ae039)[300],
        dark: (0, $2a2bdbc6cce4aa96$export$2e2bcd8739ae039)[700]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $72940215fdf862f4$export$2e2bcd8739ae039)[500],
        light: (0, $72940215fdf862f4$export$2e2bcd8739ae039)[300],
        dark: (0, $72940215fdf862f4$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $72940215fdf862f4$export$2e2bcd8739ae039)[700],
        light: (0, $72940215fdf862f4$export$2e2bcd8739ae039)[400],
        dark: (0, $72940215fdf862f4$export$2e2bcd8739ae039)[800]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $12b015f9ee6c8f9f$export$2e2bcd8739ae039)[400],
        light: (0, $12b015f9ee6c8f9f$export$2e2bcd8739ae039)[300],
        dark: (0, $12b015f9ee6c8f9f$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $12b015f9ee6c8f9f$export$2e2bcd8739ae039)[700],
        light: (0, $12b015f9ee6c8f9f$export$2e2bcd8739ae039)[500],
        dark: (0, $12b015f9ee6c8f9f$export$2e2bcd8739ae039)[900]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $ca65bc19996a7eac$export$2e2bcd8739ae039)[400],
        light: (0, $ca65bc19996a7eac$export$2e2bcd8739ae039)[300],
        dark: (0, $ca65bc19996a7eac$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $ca65bc19996a7eac$export$2e2bcd8739ae039)[800],
        light: (0, $ca65bc19996a7eac$export$2e2bcd8739ae039)[500],
        dark: (0, $ca65bc19996a7eac$export$2e2bcd8739ae039)[900]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $454ad523c90fa85d$export$2e2bcd8739ae039)[400],
        light: (0, $454ad523c90fa85d$export$2e2bcd8739ae039)[300],
        dark: (0, $454ad523c90fa85d$export$2e2bcd8739ae039)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $454ad523c90fa85d$export$2e2bcd8739ae039)[500],
        dark: (0, $454ad523c90fa85d$export$2e2bcd8739ae039)[900]
    };
}
function $07e9efd96a5c6f8a$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, ...other } = palette;
    const primary = palette.primary || $07e9efd96a5c6f8a$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $07e9efd96a5c6f8a$var$getDefaultSecondary(mode);
    const error = palette.error || $07e9efd96a5c6f8a$var$getDefaultError(mode);
    const info = palette.info || $07e9efd96a5c6f8a$var$getDefaultInfo(mode);
    const success = palette.success || $07e9efd96a5c6f8a$var$getDefaultSuccess(mode);
    const warning = palette.warning || $07e9efd96a5c6f8a$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $4afad3ab73a4d920$export$d061e26956a60b0a)(background, $07e9efd96a5c6f8a$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $07e9efd96a5c6f8a$export$55ce6f3a06c59543.text.primary : $07e9efd96a5c6f8a$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $9afc3518733c6a5e$export$2e2bcd8739ae039)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $9afc3518733c6a5e$export$2e2bcd8739ae039)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $07e9efd96a5c6f8a$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $07e9efd96a5c6f8a$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $07e9efd96a5c6f8a$var$getLight();
    else if (mode === 'dark') modeHydrated = $07e9efd96a5c6f8a$var$getDark();
    const paletteOutput = (0, $291e2c063c5d6173$export$2e2bcd8739ae039)({
        // A collection of common colors.
        common: {
            ...(0, $47d3f19e39b3b144$export$2e2bcd8739ae039)
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $1baba9d0f229a247$export$2e2bcd8739ae039,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}








function $c15f4f8d85655d33$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $291e2c063c5d6173$export$2e2bcd8739ae039)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $c15f4f8d85655d33$export$2e2bcd8739ae039 = $c15f4f8d85655d33$var$merge;



function $ea0ca560240cc689$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $ea0ca560240cc689$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $ea0ca560240cc689$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $ea0ca560240cc689$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}


const $bad89157221d9afb$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $bad89157221d9afb$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$bad89157221d9afb$export$68c286be0e7e55b7[key]}px)`
};
const $bad89157221d9afb$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $bad89157221d9afb$export$68c286be0e7e55b7[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $bad89157221d9afb$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $bad89157221d9afb$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $bad89157221d9afb$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $ea0ca560240cc689$export$77c7c3e357f440e7)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $ea0ca560240cc689$export$10a9745dfa00d15)(theme.containerQueries ? theme : $bad89157221d9afb$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $bad89157221d9afb$export$68c286be0e7e55b7).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $bad89157221d9afb$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $bad89157221d9afb$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $c15f4f8d85655d33$export$2e2bcd8739ae039)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $bad89157221d9afb$export$1f2600516e91381f(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $bad89157221d9afb$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $bad89157221d9afb$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $bad89157221d9afb$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $291e2c063c5d6173$export$2e2bcd8739ae039)(prev, next), {});
    return $bad89157221d9afb$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $bad89157221d9afb$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $bad89157221d9afb$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $bad89157221d9afb$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $bad89157221d9afb$export$2e2bcd8739ae039 = $bad89157221d9afb$var$breakpoints;



function $d8da749d88f71122$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $9afc3518733c6a5e$export$2e2bcd8739ae039)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}




function $4fed09fbf0aa6bf8$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $4fed09fbf0aa6bf8$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $4fed09fbf0aa6bf8$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $4fed09fbf0aa6bf8$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $4fed09fbf0aa6bf8$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $4fed09fbf0aa6bf8$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $4fed09fbf0aa6bf8$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $d8da749d88f71122$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $bad89157221d9afb$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $4fed09fbf0aa6bf8$export$2e2bcd8739ae039 = $4fed09fbf0aa6bf8$var$style;



function $7299cc11263ea49c$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


const $eaf6549cd0f84e32$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $eaf6549cd0f84e32$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $eaf6549cd0f84e32$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $eaf6549cd0f84e32$var$getCssProperties = (0, $7299cc11263ea49c$export$2e2bcd8739ae039)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($eaf6549cd0f84e32$var$aliases[prop]) prop = $eaf6549cd0f84e32$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $eaf6549cd0f84e32$var$properties[a];
    const direction = $eaf6549cd0f84e32$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $eaf6549cd0f84e32$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $eaf6549cd0f84e32$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $eaf6549cd0f84e32$var$spacingKeys = [
    ...$eaf6549cd0f84e32$export$aab52a0dde05ad8a,
    ...$eaf6549cd0f84e32$export$f8397d44f03ab6ad
];
function $eaf6549cd0f84e32$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $4fed09fbf0aa6bf8$export$2aa3fd96c49a84a8)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') return `calc(${val} * ${themeSpacing})`;
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $eaf6549cd0f84e32$export$1def6f833384e3d1(theme) {
    return $eaf6549cd0f84e32$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $eaf6549cd0f84e32$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $eaf6549cd0f84e32$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $eaf6549cd0f84e32$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $eaf6549cd0f84e32$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $eaf6549cd0f84e32$var$getCssProperties(prop);
    const styleFromPropValue = $eaf6549cd0f84e32$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $bad89157221d9afb$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
}
function $eaf6549cd0f84e32$var$style(props, keys) {
    const transformer = $eaf6549cd0f84e32$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$eaf6549cd0f84e32$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $c15f4f8d85655d33$export$2e2bcd8739ae039), {});
}
function $eaf6549cd0f84e32$export$7ede87f9b603dd3c(props) {
    return $eaf6549cd0f84e32$var$style(props, $eaf6549cd0f84e32$export$aab52a0dde05ad8a);
}
$eaf6549cd0f84e32$export$7ede87f9b603dd3c.propTypes = {};
$eaf6549cd0f84e32$export$7ede87f9b603dd3c.filterProps = $eaf6549cd0f84e32$export$aab52a0dde05ad8a;
function $eaf6549cd0f84e32$export$6f98e8eaf0be1996(props) {
    return $eaf6549cd0f84e32$var$style(props, $eaf6549cd0f84e32$export$f8397d44f03ab6ad);
}
$eaf6549cd0f84e32$export$6f98e8eaf0be1996.propTypes = {};
$eaf6549cd0f84e32$export$6f98e8eaf0be1996.filterProps = $eaf6549cd0f84e32$export$f8397d44f03ab6ad;
function $eaf6549cd0f84e32$var$spacing(props) {
    return $eaf6549cd0f84e32$var$style(props, $eaf6549cd0f84e32$var$spacingKeys);
}
$eaf6549cd0f84e32$var$spacing.propTypes = {};
$eaf6549cd0f84e32$var$spacing.filterProps = $eaf6549cd0f84e32$var$spacingKeys;
var $eaf6549cd0f84e32$export$2e2bcd8739ae039 = $eaf6549cd0f84e32$var$spacing;


function $907b05660525e607$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $eaf6549cd0f84e32$export$1def6f833384e3d1)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $ccdd4faffea356c7$export$2e2bcd8739ae039(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}



/* eslint-disable import/prefer-default-export */ function $b17954a29bc13f9e$export$858538ff6c0d421d(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}


/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $839a14aa2cbe41b8$export$b7855adbea215c1a = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
const $839a14aa2cbe41b8$export$65957d378dc9a0b3 = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
const $839a14aa2cbe41b8$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
function $839a14aa2cbe41b8$export$2e2bcd8739ae039(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $839a14aa2cbe41b8$export$65957d378dc9a0b3(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $839a14aa2cbe41b8$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $839a14aa2cbe41b8$export$b7855adbea215c1a(vars, keys, `var(${cssVar})`, arrayKeys);
                $839a14aa2cbe41b8$export$b7855adbea215c1a(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}


function $baf035aee66e512a$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $839a14aa2cbe41b8$export$2e2bcd8739ae039)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $839a14aa2cbe41b8$export$2e2bcd8739ae039)(scheme, parserConfig);
        themeVars = (0, $291e2c063c5d6173$export$2e2bcd8739ae039)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $839a14aa2cbe41b8$export$2e2bcd8739ae039)(defaultScheme, parserConfig);
        themeVars = (0, $291e2c063c5d6173$export$2e2bcd8739ae039)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $291e2c063c5d6173$export$2e2bcd8739ae039)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $baf035aee66e512a$export$2e2bcd8739ae039 = $baf035aee66e512a$var$prepareCssVars;

function $f2d87fc73ccf6db2$export$2e2bcd8739ae039(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === 'object') vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ''}${value.fontVariant ? `${value.fontVariant} ` : ''}${value.fontWeight ? `${value.fontWeight} ` : ''}${value.fontStretch ? `${value.fontStretch} ` : ''}${value.fontSize || ''}${value.lineHeight ? `/${value.lineHeight} ` : ''}${value.fontFamily || ''}`;
    });
    return vars;
}











function $2b4cda909fc71eed$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $c15f4f8d85655d33$export$2e2bcd8739ae039)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $2b4cda909fc71eed$export$2e2bcd8739ae039 = $2b4cda909fc71eed$var$compose;




function $ea4ec4d97ad0502d$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $ea4ec4d97ad0502d$var$createBorderStyle(prop, transform) {
    return (0, $4fed09fbf0aa6bf8$export$2e2bcd8739ae039)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $ea4ec4d97ad0502d$export$1edee58a52776cd9 = $ea4ec4d97ad0502d$var$createBorderStyle('border', $ea4ec4d97ad0502d$export$34e2febe53ae29cc);
const $ea4ec4d97ad0502d$export$f9a7b6bd24892946 = $ea4ec4d97ad0502d$var$createBorderStyle('borderTop', $ea4ec4d97ad0502d$export$34e2febe53ae29cc);
const $ea4ec4d97ad0502d$export$5abca33e6be905d2 = $ea4ec4d97ad0502d$var$createBorderStyle('borderRight', $ea4ec4d97ad0502d$export$34e2febe53ae29cc);
const $ea4ec4d97ad0502d$export$e2ce9f12a980a822 = $ea4ec4d97ad0502d$var$createBorderStyle('borderBottom', $ea4ec4d97ad0502d$export$34e2febe53ae29cc);
const $ea4ec4d97ad0502d$export$47658cca1a909427 = $ea4ec4d97ad0502d$var$createBorderStyle('borderLeft', $ea4ec4d97ad0502d$export$34e2febe53ae29cc);
const $ea4ec4d97ad0502d$export$e7fb0694ba2404fc = $ea4ec4d97ad0502d$var$createBorderStyle('borderColor');
const $ea4ec4d97ad0502d$export$126a92c968acdb85 = $ea4ec4d97ad0502d$var$createBorderStyle('borderTopColor');
const $ea4ec4d97ad0502d$export$85cc51cb8fbb8c0e = $ea4ec4d97ad0502d$var$createBorderStyle('borderRightColor');
const $ea4ec4d97ad0502d$export$340b0327727f6d1a = $ea4ec4d97ad0502d$var$createBorderStyle('borderBottomColor');
const $ea4ec4d97ad0502d$export$60beef91a985b4bf = $ea4ec4d97ad0502d$var$createBorderStyle('borderLeftColor');
const $ea4ec4d97ad0502d$export$f9258c55612cbed7 = $ea4ec4d97ad0502d$var$createBorderStyle('outline', $ea4ec4d97ad0502d$export$34e2febe53ae29cc);
const $ea4ec4d97ad0502d$export$621fe586efeb64b9 = $ea4ec4d97ad0502d$var$createBorderStyle('outlineColor');
const $ea4ec4d97ad0502d$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $eaf6549cd0f84e32$export$cb5ee237cce814a2)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $eaf6549cd0f84e32$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $bad89157221d9afb$export$88347efdb2e19abd)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$ea4ec4d97ad0502d$export$7a57f79000377ca2.propTypes = {};
$ea4ec4d97ad0502d$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $ea4ec4d97ad0502d$var$borders = (0, $2b4cda909fc71eed$export$2e2bcd8739ae039)($ea4ec4d97ad0502d$export$1edee58a52776cd9, $ea4ec4d97ad0502d$export$f9a7b6bd24892946, $ea4ec4d97ad0502d$export$5abca33e6be905d2, $ea4ec4d97ad0502d$export$e2ce9f12a980a822, $ea4ec4d97ad0502d$export$47658cca1a909427, $ea4ec4d97ad0502d$export$e7fb0694ba2404fc, $ea4ec4d97ad0502d$export$126a92c968acdb85, $ea4ec4d97ad0502d$export$85cc51cb8fbb8c0e, $ea4ec4d97ad0502d$export$340b0327727f6d1a, $ea4ec4d97ad0502d$export$60beef91a985b4bf, $ea4ec4d97ad0502d$export$7a57f79000377ca2, $ea4ec4d97ad0502d$export$f9258c55612cbed7, $ea4ec4d97ad0502d$export$621fe586efeb64b9);
var $ea4ec4d97ad0502d$export$2e2bcd8739ae039 = $ea4ec4d97ad0502d$var$borders;







const $02b672fe58d36ace$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $eaf6549cd0f84e32$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $eaf6549cd0f84e32$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $bad89157221d9afb$export$88347efdb2e19abd)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$02b672fe58d36ace$export$5df9adcb0db95e1e.propTypes = {};
$02b672fe58d36ace$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $02b672fe58d36ace$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $eaf6549cd0f84e32$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $eaf6549cd0f84e32$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $bad89157221d9afb$export$88347efdb2e19abd)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$02b672fe58d36ace$export$ec60d70ff941a580.propTypes = {};
$02b672fe58d36ace$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $02b672fe58d36ace$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $eaf6549cd0f84e32$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $eaf6549cd0f84e32$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $bad89157221d9afb$export$88347efdb2e19abd)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$02b672fe58d36ace$export$8a833ffa5f5dbeda.propTypes = {};
$02b672fe58d36ace$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $02b672fe58d36ace$export$baf44164ca3a34e8 = (0, $4fed09fbf0aa6bf8$export$2e2bcd8739ae039)({
    prop: 'gridColumn'
});
const $02b672fe58d36ace$export$8f7213a1cd01e832 = (0, $4fed09fbf0aa6bf8$export$2e2bcd8739ae039)({
    prop: 'gridRow'
});
const $02b672fe58d36ace$export$b0e0abbc49ba668 = (0, $4fed09fbf0aa6bf8$export$2e2bcd8739ae039)({
    prop: 'gridAutoFlow'
});
const $02b672fe58d36ace$export$bcd8b929d4b4142 = (0, $4fed09fbf0aa6bf8$export$2e2bcd8739ae039)({
    prop: 'gridAutoColumns'
});
const $02b672fe58d36ace$export$e5039a674e14c828 = (0, $4fed09fbf0aa6bf8$export$2e2bcd8739ae039)({
    prop: 'gridAutoRows'
});
const $02b672fe58d36ace$export$42bd9088661ffb03 = (0, $4fed09fbf0aa6bf8$export$2e2bcd8739ae039)({
    prop: 'gridTemplateColumns'
});
const $02b672fe58d36ace$export$920682ae05b999bc = (0, $4fed09fbf0aa6bf8$export$2e2bcd8739ae039)({
    prop: 'gridTemplateRows'
});
const $02b672fe58d36ace$export$1b88fbdd482fd33a = (0, $4fed09fbf0aa6bf8$export$2e2bcd8739ae039)({
    prop: 'gridTemplateAreas'
});
const $02b672fe58d36ace$export$bdb486e40d52d26f = (0, $4fed09fbf0aa6bf8$export$2e2bcd8739ae039)({
    prop: 'gridArea'
});
const $02b672fe58d36ace$var$grid = (0, $2b4cda909fc71eed$export$2e2bcd8739ae039)($02b672fe58d36ace$export$5df9adcb0db95e1e, $02b672fe58d36ace$export$ec60d70ff941a580, $02b672fe58d36ace$export$8a833ffa5f5dbeda, $02b672fe58d36ace$export$baf44164ca3a34e8, $02b672fe58d36ace$export$8f7213a1cd01e832, $02b672fe58d36ace$export$b0e0abbc49ba668, $02b672fe58d36ace$export$bcd8b929d4b4142, $02b672fe58d36ace$export$e5039a674e14c828, $02b672fe58d36ace$export$42bd9088661ffb03, $02b672fe58d36ace$export$920682ae05b999bc, $02b672fe58d36ace$export$1b88fbdd482fd33a, $02b672fe58d36ace$export$bdb486e40d52d26f);
var $02b672fe58d36ace$export$2e2bcd8739ae039 = $02b672fe58d36ace$var$grid;




function $8b98577cfa5ccab4$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $8b98577cfa5ccab4$export$35e9368ef982300f = (0, $4fed09fbf0aa6bf8$export$2e2bcd8739ae039)({
    prop: 'color',
    themeKey: 'palette',
    transform: $8b98577cfa5ccab4$export$dbaffd4420ea0ac6
});
const $8b98577cfa5ccab4$export$2506f56c10355b33 = (0, $4fed09fbf0aa6bf8$export$2e2bcd8739ae039)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $8b98577cfa5ccab4$export$dbaffd4420ea0ac6
});
const $8b98577cfa5ccab4$export$8c5a050822fd698c = (0, $4fed09fbf0aa6bf8$export$2e2bcd8739ae039)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $8b98577cfa5ccab4$export$dbaffd4420ea0ac6
});
const $8b98577cfa5ccab4$var$palette = (0, $2b4cda909fc71eed$export$2e2bcd8739ae039)($8b98577cfa5ccab4$export$35e9368ef982300f, $8b98577cfa5ccab4$export$2506f56c10355b33, $8b98577cfa5ccab4$export$8c5a050822fd698c);
var $8b98577cfa5ccab4$export$2e2bcd8739ae039 = $8b98577cfa5ccab4$var$palette;





function $0174348f2537ddcc$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $0174348f2537ddcc$export$7e3df82ee760448c = (0, $4fed09fbf0aa6bf8$export$2e2bcd8739ae039)({
    prop: 'width',
    transform: $0174348f2537ddcc$export$8afece71750ec241
});
const $0174348f2537ddcc$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || (0, $bad89157221d9afb$export$68c286be0e7e55b7)[propValue];
            if (!breakpoint) return {
                maxWidth: $0174348f2537ddcc$export$8afece71750ec241(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $bad89157221d9afb$export$88347efdb2e19abd)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$0174348f2537ddcc$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $0174348f2537ddcc$export$ee148fbbe8357dd2 = (0, $4fed09fbf0aa6bf8$export$2e2bcd8739ae039)({
    prop: 'minWidth',
    transform: $0174348f2537ddcc$export$8afece71750ec241
});
const $0174348f2537ddcc$export$ac607276a8fe9f0a = (0, $4fed09fbf0aa6bf8$export$2e2bcd8739ae039)({
    prop: 'height',
    transform: $0174348f2537ddcc$export$8afece71750ec241
});
const $0174348f2537ddcc$export$dc0d8bd0b94f8570 = (0, $4fed09fbf0aa6bf8$export$2e2bcd8739ae039)({
    prop: 'maxHeight',
    transform: $0174348f2537ddcc$export$8afece71750ec241
});
const $0174348f2537ddcc$export$a43cf604e12f3b17 = (0, $4fed09fbf0aa6bf8$export$2e2bcd8739ae039)({
    prop: 'minHeight',
    transform: $0174348f2537ddcc$export$8afece71750ec241
});
const $0174348f2537ddcc$export$ffed9f14fb65e276 = (0, $4fed09fbf0aa6bf8$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'width',
    transform: $0174348f2537ddcc$export$8afece71750ec241
});
const $0174348f2537ddcc$export$905076ed6620e671 = (0, $4fed09fbf0aa6bf8$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'height',
    transform: $0174348f2537ddcc$export$8afece71750ec241
});
const $0174348f2537ddcc$export$6ccc93f785106a58 = (0, $4fed09fbf0aa6bf8$export$2e2bcd8739ae039)({
    prop: 'boxSizing'
});
const $0174348f2537ddcc$var$sizing = (0, $2b4cda909fc71eed$export$2e2bcd8739ae039)($0174348f2537ddcc$export$7e3df82ee760448c, $0174348f2537ddcc$export$488fda99655ff65a, $0174348f2537ddcc$export$ee148fbbe8357dd2, $0174348f2537ddcc$export$ac607276a8fe9f0a, $0174348f2537ddcc$export$dc0d8bd0b94f8570, $0174348f2537ddcc$export$a43cf604e12f3b17, $0174348f2537ddcc$export$6ccc93f785106a58);
var $0174348f2537ddcc$export$2e2bcd8739ae039 = $0174348f2537ddcc$var$sizing;


const $8563e7d5caf9f77c$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $ea4ec4d97ad0502d$export$34e2febe53ae29cc)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $ea4ec4d97ad0502d$export$34e2febe53ae29cc)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $ea4ec4d97ad0502d$export$34e2febe53ae29cc)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $ea4ec4d97ad0502d$export$34e2febe53ae29cc)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $ea4ec4d97ad0502d$export$34e2febe53ae29cc)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $ea4ec4d97ad0502d$export$34e2febe53ae29cc)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $ea4ec4d97ad0502d$export$7a57f79000377ca2)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $8b98577cfa5ccab4$export$dbaffd4420ea0ac6)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $8b98577cfa5ccab4$export$dbaffd4420ea0ac6)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $8b98577cfa5ccab4$export$dbaffd4420ea0ac6)
    },
    // spacing
    p: {
        style: (0, $eaf6549cd0f84e32$export$6f98e8eaf0be1996)
    },
    pt: {
        style: (0, $eaf6549cd0f84e32$export$6f98e8eaf0be1996)
    },
    pr: {
        style: (0, $eaf6549cd0f84e32$export$6f98e8eaf0be1996)
    },
    pb: {
        style: (0, $eaf6549cd0f84e32$export$6f98e8eaf0be1996)
    },
    pl: {
        style: (0, $eaf6549cd0f84e32$export$6f98e8eaf0be1996)
    },
    px: {
        style: (0, $eaf6549cd0f84e32$export$6f98e8eaf0be1996)
    },
    py: {
        style: (0, $eaf6549cd0f84e32$export$6f98e8eaf0be1996)
    },
    padding: {
        style: (0, $eaf6549cd0f84e32$export$6f98e8eaf0be1996)
    },
    paddingTop: {
        style: (0, $eaf6549cd0f84e32$export$6f98e8eaf0be1996)
    },
    paddingRight: {
        style: (0, $eaf6549cd0f84e32$export$6f98e8eaf0be1996)
    },
    paddingBottom: {
        style: (0, $eaf6549cd0f84e32$export$6f98e8eaf0be1996)
    },
    paddingLeft: {
        style: (0, $eaf6549cd0f84e32$export$6f98e8eaf0be1996)
    },
    paddingX: {
        style: (0, $eaf6549cd0f84e32$export$6f98e8eaf0be1996)
    },
    paddingY: {
        style: (0, $eaf6549cd0f84e32$export$6f98e8eaf0be1996)
    },
    paddingInline: {
        style: (0, $eaf6549cd0f84e32$export$6f98e8eaf0be1996)
    },
    paddingInlineStart: {
        style: (0, $eaf6549cd0f84e32$export$6f98e8eaf0be1996)
    },
    paddingInlineEnd: {
        style: (0, $eaf6549cd0f84e32$export$6f98e8eaf0be1996)
    },
    paddingBlock: {
        style: (0, $eaf6549cd0f84e32$export$6f98e8eaf0be1996)
    },
    paddingBlockStart: {
        style: (0, $eaf6549cd0f84e32$export$6f98e8eaf0be1996)
    },
    paddingBlockEnd: {
        style: (0, $eaf6549cd0f84e32$export$6f98e8eaf0be1996)
    },
    m: {
        style: (0, $eaf6549cd0f84e32$export$7ede87f9b603dd3c)
    },
    mt: {
        style: (0, $eaf6549cd0f84e32$export$7ede87f9b603dd3c)
    },
    mr: {
        style: (0, $eaf6549cd0f84e32$export$7ede87f9b603dd3c)
    },
    mb: {
        style: (0, $eaf6549cd0f84e32$export$7ede87f9b603dd3c)
    },
    ml: {
        style: (0, $eaf6549cd0f84e32$export$7ede87f9b603dd3c)
    },
    mx: {
        style: (0, $eaf6549cd0f84e32$export$7ede87f9b603dd3c)
    },
    my: {
        style: (0, $eaf6549cd0f84e32$export$7ede87f9b603dd3c)
    },
    margin: {
        style: (0, $eaf6549cd0f84e32$export$7ede87f9b603dd3c)
    },
    marginTop: {
        style: (0, $eaf6549cd0f84e32$export$7ede87f9b603dd3c)
    },
    marginRight: {
        style: (0, $eaf6549cd0f84e32$export$7ede87f9b603dd3c)
    },
    marginBottom: {
        style: (0, $eaf6549cd0f84e32$export$7ede87f9b603dd3c)
    },
    marginLeft: {
        style: (0, $eaf6549cd0f84e32$export$7ede87f9b603dd3c)
    },
    marginX: {
        style: (0, $eaf6549cd0f84e32$export$7ede87f9b603dd3c)
    },
    marginY: {
        style: (0, $eaf6549cd0f84e32$export$7ede87f9b603dd3c)
    },
    marginInline: {
        style: (0, $eaf6549cd0f84e32$export$7ede87f9b603dd3c)
    },
    marginInlineStart: {
        style: (0, $eaf6549cd0f84e32$export$7ede87f9b603dd3c)
    },
    marginInlineEnd: {
        style: (0, $eaf6549cd0f84e32$export$7ede87f9b603dd3c)
    },
    marginBlock: {
        style: (0, $eaf6549cd0f84e32$export$7ede87f9b603dd3c)
    },
    marginBlockStart: {
        style: (0, $eaf6549cd0f84e32$export$7ede87f9b603dd3c)
    },
    marginBlockEnd: {
        style: (0, $eaf6549cd0f84e32$export$7ede87f9b603dd3c)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $02b672fe58d36ace$export$5df9adcb0db95e1e)
    },
    rowGap: {
        style: (0, $02b672fe58d36ace$export$8a833ffa5f5dbeda)
    },
    columnGap: {
        style: (0, $02b672fe58d36ace$export$ec60d70ff941a580)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $0174348f2537ddcc$export$8afece71750ec241)
    },
    maxWidth: {
        style: (0, $0174348f2537ddcc$export$488fda99655ff65a)
    },
    minWidth: {
        transform: (0, $0174348f2537ddcc$export$8afece71750ec241)
    },
    height: {
        transform: (0, $0174348f2537ddcc$export$8afece71750ec241)
    },
    maxHeight: {
        transform: (0, $0174348f2537ddcc$export$8afece71750ec241)
    },
    minHeight: {
        transform: (0, $0174348f2537ddcc$export$8afece71750ec241)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $8563e7d5caf9f77c$export$2e2bcd8739ae039 = $8563e7d5caf9f77c$var$defaultSxConfig;


function $c202727e06c030fc$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $c202727e06c030fc$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $c202727e06c030fc$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $4fed09fbf0aa6bf8$export$2aa3fd96c49a84a8)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $4fed09fbf0aa6bf8$export$741ad47189a64aa0)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $4fed09fbf0aa6bf8$export$741ad47189a64aa0)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $d8da749d88f71122$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $bad89157221d9afb$export$88347efdb2e19abd)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? (0, $8563e7d5caf9f77c$export$2e2bcd8739ae039);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $bad89157221d9afb$export$1f2600516e91381f)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $c202727e06c030fc$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $c15f4f8d85655d33$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $bad89157221d9afb$export$88347efdb2e19abd)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($c202727e06c030fc$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $c15f4f8d85655d33$export$2e2bcd8739ae039)(css, breakpointsValues);
                        }
                    } else css = (0, $c15f4f8d85655d33$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $ea0ca560240cc689$export$456f6c1142f990db)(theme, (0, $bad89157221d9afb$export$8922c90b6e020726)(breakpointsKeys, css))
            };
            return (0, $ea0ca560240cc689$export$456f6c1142f990db)(theme, (0, $bad89157221d9afb$export$8922c90b6e020726)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $c202727e06c030fc$var$styleFunctionSx = $c202727e06c030fc$export$7d53d8bf2911e013();
$c202727e06c030fc$var$styleFunctionSx.filterProps = [
    'sx'
];
var $c202727e06c030fc$export$2e2bcd8739ae039 = $c202727e06c030fc$var$styleFunctionSx;







// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $3c90bf55ed3c1a7d$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $3c90bf55ed3c1a7d$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $3c90bf55ed3c1a7d$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $3c90bf55ed3c1a7d$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}



const $6ca6d3d167e14bf5$var$shape = {
    borderRadius: 4
};
var $6ca6d3d167e14bf5$export$2e2bcd8739ae039 = $6ca6d3d167e14bf5$var$shape;





/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $d51b95faab3deaf9$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}


function $c6ae1e3a98d0d5b8$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $3c90bf55ed3c1a7d$export$2e2bcd8739ae039)(breakpointsInput);
    const spacing = (0, $907b05660525e607$export$2e2bcd8739ae039)(spacingInput);
    let muiTheme = (0, $291e2c063c5d6173$export$2e2bcd8739ae039)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $6ca6d3d167e14bf5$export$2e2bcd8739ae039),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $ea0ca560240cc689$export$2e2bcd8739ae039)(muiTheme);
    muiTheme.applyStyles = (0, $d51b95faab3deaf9$export$2e2bcd8739ae039);
    muiTheme = args.reduce((acc, argument)=>(0, $291e2c063c5d6173$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $8563e7d5caf9f77c$export$2e2bcd8739ae039),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $c202727e06c030fc$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $c6ae1e3a98d0d5b8$export$2e2bcd8739ae039 = $c6ae1e3a98d0d5b8$var$createTheme;



function $04aa49c3b5b31b02$export$2e2bcd8739ae039(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}




function $4027cd084802bc60$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $4027cd084802bc60$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $4027cd084802bc60$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $4027cd084802bc60$export$2e2bcd8739ae039(palette, typography) {
    const { fontFamily: fontFamily = $4027cd084802bc60$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $4027cd084802bc60$var$defaultFontFamily ? {
                letterSpacing: `${$4027cd084802bc60$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $4027cd084802bc60$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $4027cd084802bc60$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $291e2c063c5d6173$export$2e2bcd8739ae039)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}


const $26a3ee12a0d43232$var$shadowKeyUmbraOpacity = 0.2;
const $26a3ee12a0d43232$var$shadowKeyPenumbraOpacity = 0.14;
const $26a3ee12a0d43232$var$shadowAmbientShadowOpacity = 0.12;
function $26a3ee12a0d43232$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $26a3ee12a0d43232$var$shadows = [
    'none',
    $26a3ee12a0d43232$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $26a3ee12a0d43232$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $26a3ee12a0d43232$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $26a3ee12a0d43232$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $26a3ee12a0d43232$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $26a3ee12a0d43232$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $26a3ee12a0d43232$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $26a3ee12a0d43232$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $26a3ee12a0d43232$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $26a3ee12a0d43232$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $26a3ee12a0d43232$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $26a3ee12a0d43232$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $26a3ee12a0d43232$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $26a3ee12a0d43232$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $26a3ee12a0d43232$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $26a3ee12a0d43232$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $26a3ee12a0d43232$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $26a3ee12a0d43232$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $26a3ee12a0d43232$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $26a3ee12a0d43232$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $26a3ee12a0d43232$export$2e2bcd8739ae039 = $26a3ee12a0d43232$var$shadows;


// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const $ec94076b9ecccee1$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $ec94076b9ecccee1$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $ec94076b9ecccee1$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $ec94076b9ecccee1$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $ec94076b9ecccee1$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = {
        ...$ec94076b9ecccee1$export$24c5ac7c37452e7d,
        ...inputTransitions.easing
    };
    const mergedDuration = {
        ...$ec94076b9ecccee1$export$1f34108aa9eb96ab,
        ...inputTransitions.duration
    };
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $ec94076b9ecccee1$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $ec94076b9ecccee1$var$formatMs(delay)}`).join(',');
    };
    return {
        getAutoHeightDuration: $ec94076b9ecccee1$var$getAutoHeightDuration,
        create: create,
        ...inputTransitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}


// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $ab06614e124e32b2$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $ab06614e124e32b2$export$2e2bcd8739ae039 = $ab06614e124e32b2$var$zIndex;


/* eslint-disable import/prefer-default-export */ 
function $8afc533eb383e46c$var$isSerializable(val) {
    return (0, $291e2c063c5d6173$export$53b83ca8eaab0383)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
function $8afc533eb383e46c$export$32c2afa5f91892aa(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$8afc533eb383e46c$var$isSerializable(value) || key.startsWith('unstable_')) delete object[key];
            else if ((0, $291e2c063c5d6173$export$53b83ca8eaab0383)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}


function $210912e9de81c193$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, $9afc3518733c6a5e$export$2e2bcd8739ae039)(20));
    const palette = (0, $07e9efd96a5c6f8a$export$2e2bcd8739ae039)(paletteInput);
    const systemTheme = (0, $c6ae1e3a98d0d5b8$export$2e2bcd8739ae039)(options);
    let muiTheme = (0, $291e2c063c5d6173$export$2e2bcd8739ae039)(systemTheme, {
        mixins: (0, $04aa49c3b5b31b02$export$2e2bcd8739ae039)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $26a3ee12a0d43232$export$2e2bcd8739ae039).slice(),
        typography: (0, $4027cd084802bc60$export$2e2bcd8739ae039)(palette, typographyInput),
        transitions: (0, $ec94076b9ecccee1$export$2e2bcd8739ae039)(transitionsInput),
        zIndex: {
            ...(0, $ab06614e124e32b2$export$2e2bcd8739ae039)
        }
    });
    muiTheme = (0, $291e2c063c5d6173$export$2e2bcd8739ae039)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $291e2c063c5d6173$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = {
        ...(0, $8563e7d5caf9f77c$export$2e2bcd8739ae039),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $c202727e06c030fc$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = (0, $8afc533eb383e46c$export$32c2afa5f91892aa); // for Pigment CSS integration
    return muiTheme;
}
let $210912e9de81c193$var$warnedOnce = false;
function $210912e9de81c193$export$c469355549431d9b(...args) {
    return $210912e9de81c193$var$createThemeNoVars(...args);
}
var $210912e9de81c193$export$2e2bcd8739ae039 = $210912e9de81c193$var$createThemeNoVars;



// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $8fa7ddbbf42193a7$export$2e2bcd8739ae039(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}


const $fa7e90d19bb5b73c$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $8fa7ddbbf42193a7$export$2e2bcd8739ae039)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $fa7e90d19bb5b73c$export$c85e0347fceb69ba(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $fa7e90d19bb5b73c$export$dd191566510330d3(mode) {
    return mode === 'dark' ? $fa7e90d19bb5b73c$var$defaultDarkOverlays : [];
}
function $fa7e90d19bb5b73c$export$2e2bcd8739ae039(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, ...rest } = options;
    const palette = (0, $07e9efd96a5c6f8a$export$2e2bcd8739ae039)(paletteInput);
    return {
        palette: palette,
        opacity: {
            ...$fa7e90d19bb5b73c$export$c85e0347fceb69ba(palette.mode),
            ...opacity
        },
        overlays: overlays || $fa7e90d19bb5b73c$export$dd191566510330d3(palette.mode),
        ...rest
    };
}


function $e9cb96d85031eec5$export$2e2bcd8739ae039(keys) {
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}


/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $4e1fb4440bcd8fb8$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $4e1fb4440bcd8fb8$export$2e2bcd8739ae039 = $4e1fb4440bcd8fb8$var$excludeVariablesFromRoot;


var $57acd5b568390899$export$2e2bcd8739ae039 = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $4e1fb4440bcd8fb8$export$2e2bcd8739ae039)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };



function $ba98ac4ef2005c84$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $ba98ac4ef2005c84$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $ba98ac4ef2005c84$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $4afad3ab73a4d920$export$29fb7152bd3f781a)(color);
}
function $ba98ac4ef2005c84$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $4afad3ab73a4d920$export$427365fc3db6fc5e)($ba98ac4ef2005c84$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $ba98ac4ef2005c84$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $ba98ac4ef2005c84$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $ba98ac4ef2005c84$export$65418b4d9082cc44 = (cssVarPrefix = 'mui')=>(0, $ccdd4faffea356c7$export$2e2bcd8739ae039)(cssVarPrefix);
function $ba98ac4ef2005c84$var$attachColorScheme(colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $fa7e90d19bb5b73c$export$2e2bcd8739ae039)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            }
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $210912e9de81c193$export$2e2bcd8739ae039)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        }
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $fa7e90d19bb5b73c$export$c85e0347fceb69ba)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $fa7e90d19bb5b73c$export$dd191566510330d3)(mode)
    };
    return muiTheme;
}
function $ba98ac4ef2005c84$export$2e2bcd8739ae039(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $e9cb96d85031eec5$export$2e2bcd8739ae039), colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $ba98ac4ef2005c84$export$65418b4d9082cc44(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, $9afc3518733c6a5e$export$2e2bcd8739ae039)(21, defaultColorScheme));
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $ba98ac4ef2005c84$var$attachColorScheme(colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $ba98ac4ef2005c84$var$attachColorScheme(colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $ba98ac4ef2005c84$var$attachColorScheme(colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $f2d87fc73ccf6db2$export$2e2bcd8739ae039)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $ba98ac4ef2005c84$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $ba98ac4ef2005c84$var$setColor(palette.common, 'background', '#fff');
            $ba98ac4ef2005c84$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $ba98ac4ef2005c84$var$setColor(palette.common, 'background', '#000');
            $ba98ac4ef2005c84$var$setColor(palette.common, 'onBackground', '#fff');
        }
        // assign component variables
        $ba98ac4ef2005c84$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'errorColor', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)(palette.error.light, 0.6));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'infoColor', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)(palette.info.light, 0.6));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'successColor', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)(palette.success.light, 0.6));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'warningColor', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)(palette.warning.light, 0.6));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'errorFilledColor', $ba98ac4ef2005c84$var$silent(()=>palette.getContrastText(palette.error.main)));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'infoFilledColor', $ba98ac4ef2005c84$var$silent(()=>palette.getContrastText(palette.info.main)));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'successFilledColor', $ba98ac4ef2005c84$var$silent(()=>palette.getContrastText(palette.success.main)));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'warningFilledColor', $ba98ac4ef2005c84$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'errorStandardBg', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)(palette.error.light, 0.9));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'infoStandardBg', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)(palette.info.light, 0.9));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'successStandardBg', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)(palette.success.light, 0.9));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'warningStandardBg', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)(palette.warning.light, 0.9));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $ba98ac4ef2005c84$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $ba98ac4ef2005c84$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $ba98ac4ef2005c84$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $ba98ac4ef2005c84$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $ba98ac4ef2005c84$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $ba98ac4ef2005c84$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $ba98ac4ef2005c84$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $ba98ac4ef2005c84$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $ba98ac4ef2005c84$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $ba98ac4ef2005c84$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $ba98ac4ef2005c84$var$setColor(palette.LinearProgress, 'primaryBg', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)(palette.primary.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)(palette.secondary.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.LinearProgress, 'errorBg', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)(palette.error.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.LinearProgress, 'infoBg', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)(palette.info.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.LinearProgress, 'successBg', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)(palette.success.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.LinearProgress, 'warningBg', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)(palette.warning.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $ba98ac4ef2005c84$var$setColor(palette.Slider, 'primaryTrack', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)(palette.primary.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.Slider, 'secondaryTrack', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)(palette.secondary.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.Slider, 'errorTrack', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)(palette.error.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.Slider, 'infoTrack', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)(palette.info.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.Slider, 'successTrack', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)(palette.success.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.Slider, 'warningTrack', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)(palette.warning.main, 0.62));
            const snackbarContentBackground = (0, $4afad3ab73a4d920$export$11bb74ba10c85505)(palette.background.default, 0.8);
            $ba98ac4ef2005c84$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $ba98ac4ef2005c84$var$setColor(palette.SnackbarContent, 'color', $ba98ac4ef2005c84$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $ba98ac4ef2005c84$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $4afad3ab73a4d920$export$11bb74ba10c85505)(palette.background.paper, 0.15));
            $ba98ac4ef2005c84$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $ba98ac4ef2005c84$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)(palette.primary.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)(palette.secondary.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'errorDisabledColor', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)(palette.error.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'infoDisabledColor', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)(palette.info.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'successDisabledColor', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)(palette.success.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'warningDisabledColor', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)(palette.warning.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.TableCell, 'border', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)((0, $4afad3ab73a4d920$export$34109543fc7f43f8)(palette.divider, 1), 0.88));
            $ba98ac4ef2005c84$var$setColor(palette.Tooltip, 'bg', (0, $4afad3ab73a4d920$export$34109543fc7f43f8)(palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'errorColor', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)(palette.error.light, 0.6));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'infoColor', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)(palette.info.light, 0.6));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'successColor', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)(palette.success.light, 0.6));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'warningColor', (0, $4afad3ab73a4d920$export$aeeda94ef1d01275)(palette.warning.light, 0.6));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'errorFilledColor', $ba98ac4ef2005c84$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'infoFilledColor', $ba98ac4ef2005c84$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'successFilledColor', $ba98ac4ef2005c84$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'warningFilledColor', $ba98ac4ef2005c84$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'errorStandardBg', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)(palette.error.light, 0.9));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'infoStandardBg', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)(palette.info.light, 0.9));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'successStandardBg', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)(palette.success.light, 0.9));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'warningStandardBg', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)(palette.warning.light, 0.9));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $ba98ac4ef2005c84$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $ba98ac4ef2005c84$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $ba98ac4ef2005c84$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $ba98ac4ef2005c84$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $ba98ac4ef2005c84$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $ba98ac4ef2005c84$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $ba98ac4ef2005c84$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $ba98ac4ef2005c84$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $ba98ac4ef2005c84$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $ba98ac4ef2005c84$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $ba98ac4ef2005c84$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $ba98ac4ef2005c84$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $ba98ac4ef2005c84$var$setColor(palette.LinearProgress, 'primaryBg', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)(palette.primary.main, 0.5));
            $ba98ac4ef2005c84$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)(palette.secondary.main, 0.5));
            $ba98ac4ef2005c84$var$setColor(palette.LinearProgress, 'errorBg', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)(palette.error.main, 0.5));
            $ba98ac4ef2005c84$var$setColor(palette.LinearProgress, 'infoBg', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)(palette.info.main, 0.5));
            $ba98ac4ef2005c84$var$setColor(palette.LinearProgress, 'successBg', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)(palette.success.main, 0.5));
            $ba98ac4ef2005c84$var$setColor(palette.LinearProgress, 'warningBg', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)(palette.warning.main, 0.5));
            $ba98ac4ef2005c84$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $ba98ac4ef2005c84$var$setColor(palette.Slider, 'primaryTrack', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)(palette.primary.main, 0.5));
            $ba98ac4ef2005c84$var$setColor(palette.Slider, 'secondaryTrack', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)(palette.secondary.main, 0.5));
            $ba98ac4ef2005c84$var$setColor(palette.Slider, 'errorTrack', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)(palette.error.main, 0.5));
            $ba98ac4ef2005c84$var$setColor(palette.Slider, 'infoTrack', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)(palette.info.main, 0.5));
            $ba98ac4ef2005c84$var$setColor(palette.Slider, 'successTrack', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)(palette.success.main, 0.5));
            $ba98ac4ef2005c84$var$setColor(palette.Slider, 'warningTrack', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)(palette.warning.main, 0.5));
            const snackbarContentBackground = (0, $4afad3ab73a4d920$export$11bb74ba10c85505)(palette.background.default, 0.98);
            $ba98ac4ef2005c84$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $ba98ac4ef2005c84$var$setColor(palette.SnackbarContent, 'color', $ba98ac4ef2005c84$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $ba98ac4ef2005c84$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $4afad3ab73a4d920$export$11bb74ba10c85505)(palette.background.paper, 0.15));
            $ba98ac4ef2005c84$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $ba98ac4ef2005c84$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)(palette.primary.main, 0.55));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)(palette.secondary.main, 0.55));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'errorDisabledColor', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)(palette.error.main, 0.55));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'infoDisabledColor', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)(palette.info.main, 0.55));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'successDisabledColor', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)(palette.success.main, 0.55));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'warningDisabledColor', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)(palette.warning.main, 0.55));
            $ba98ac4ef2005c84$var$setColor(palette.TableCell, 'border', (0, $4afad3ab73a4d920$export$eaaef2dca3e9e512)((0, $4afad3ab73a4d920$export$34109543fc7f43f8)(palette.divider, 1), 0.68));
            $ba98ac4ef2005c84$var$setColor(palette.Tooltip, 'bg', (0, $4afad3ab73a4d920$export$34109543fc7f43f8)(palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        $ba98ac4ef2005c84$var$setColorChannel(palette.background, 'default');
        // added for consistency with the `background.default` token
        $ba98ac4ef2005c84$var$setColorChannel(palette.background, 'paper');
        $ba98ac4ef2005c84$var$setColorChannel(palette.common, 'background');
        $ba98ac4ef2005c84$var$setColorChannel(palette.common, 'onBackground');
        $ba98ac4ef2005c84$var$setColorChannel(palette, 'divider');
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $ba98ac4ef2005c84$var$setColor(palette[color], 'mainChannel', (0, $4afad3ab73a4d920$export$427365fc3db6fc5e)($ba98ac4ef2005c84$var$toRgb(colors.main)));
                if (colors.light) $ba98ac4ef2005c84$var$setColor(palette[color], 'lightChannel', (0, $4afad3ab73a4d920$export$427365fc3db6fc5e)($ba98ac4ef2005c84$var$toRgb(colors.light)));
                if (colors.dark) $ba98ac4ef2005c84$var$setColor(palette[color], 'darkChannel', (0, $4afad3ab73a4d920$export$427365fc3db6fc5e)($ba98ac4ef2005c84$var$toRgb(colors.dark)));
                if (colors.contrastText) $ba98ac4ef2005c84$var$setColor(palette[color], 'contrastTextChannel', (0, $4afad3ab73a4d920$export$427365fc3db6fc5e)($ba98ac4ef2005c84$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $ba98ac4ef2005c84$var$setColorChannel(palette[color], 'primary');
                    $ba98ac4ef2005c84$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $ba98ac4ef2005c84$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $ba98ac4ef2005c84$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $291e2c063c5d6173$export$2e2bcd8739ae039)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $57acd5b568390899$export$2e2bcd8739ae039)(theme)
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $baf035aee66e512a$export$2e2bcd8739ae039)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $907b05660525e607$export$2e2bcd8739ae039)(input.spacing, (0, $eaf6549cd0f84e32$export$1def6f833384e3d1)(this));
    };
    theme.getColorSchemeSelector = (0, $b17954a29bc13f9e$export$858538ff6c0d421d)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...(0, $8563e7d5caf9f77c$export$2e2bcd8739ae039),
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, $c202727e06c030fc$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = (0, $8afc533eb383e46c$export$32c2afa5f91892aa); // for Pigment CSS integration
    return theme;
}



// eslint-disable-next-line consistent-return
function $ca3239ce6bf6e490$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $07e9efd96a5c6f8a$export$2e2bcd8739ae039)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
function $ca3239ce6bf6e490$export$2e2bcd8739ae039(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...rest } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $210912e9de81c193$export$2e2bcd8739ae039)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $210912e9de81c193$export$2e2bcd8739ae039)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $ca3239ce6bf6e490$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $ca3239ce6bf6e490$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $ba98ac4ef2005c84$export$2e2bcd8739ae039)({
        ...rest,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}



var $7fPBF = parcelRequire("7fPBF");
var $3104ec53a35158ff$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $3104ec53a35158ff$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $3104ec53a35158ff$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $3104ec53a35158ff$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$3104ec53a35158ff$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($3104ec53a35158ff$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $3104ec53a35158ff$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


/**
 * @param {number}
 * @return {number}
 */ var $432f2af859c96d26$export$2335f513bbd82c6d = Math.abs;
var $432f2af859c96d26$export$6788812c4e6611e6 = String.fromCharCode;
var $432f2af859c96d26$export$e6e34fd1f2686227 = Object.assign;
function $432f2af859c96d26$export$d6af199866bfb566(value, length) {
    return $432f2af859c96d26$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $432f2af859c96d26$export$a9db5e087081082d(value, 0)) << 2 ^ $432f2af859c96d26$export$a9db5e087081082d(value, 1)) << 2 ^ $432f2af859c96d26$export$a9db5e087081082d(value, 2)) << 2 ^ $432f2af859c96d26$export$a9db5e087081082d(value, 3) : 0;
}
function $432f2af859c96d26$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $432f2af859c96d26$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $432f2af859c96d26$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $432f2af859c96d26$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $432f2af859c96d26$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $432f2af859c96d26$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $432f2af859c96d26$export$36776f635604f274(value) {
    return value.length;
}
function $432f2af859c96d26$export$f9084667e487ed46(value) {
    return value.length;
}
function $432f2af859c96d26$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $432f2af859c96d26$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}


var $21718d5ff5bac791$export$53f1d5ea8de3d7c = 1;
var $21718d5ff5bac791$export$4e0c71f277ca26b3 = 1;
var $21718d5ff5bac791$export$f24224f1c91d8156 = 0;
var $21718d5ff5bac791$export$5880b8b5730aff45 = 0;
var $21718d5ff5bac791$export$c0306caf338ac095 = 0;
var $21718d5ff5bac791$export$30a86d91af8ff6e6 = '';
function $21718d5ff5bac791$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $21718d5ff5bac791$export$53f1d5ea8de3d7c,
        column: $21718d5ff5bac791$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $21718d5ff5bac791$export$784d13d8ee351f07(root, props) {
    return (0, $432f2af859c96d26$export$e6e34fd1f2686227)($21718d5ff5bac791$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $21718d5ff5bac791$export$eba6f6f03b0a92e7() {
    return $21718d5ff5bac791$export$c0306caf338ac095;
}
function $21718d5ff5bac791$export$232faf9add678146() {
    $21718d5ff5bac791$export$c0306caf338ac095 = $21718d5ff5bac791$export$5880b8b5730aff45 > 0 ? (0, $432f2af859c96d26$export$a9db5e087081082d)($21718d5ff5bac791$export$30a86d91af8ff6e6, --$21718d5ff5bac791$export$5880b8b5730aff45) : 0;
    if ($21718d5ff5bac791$export$4e0c71f277ca26b3--, $21718d5ff5bac791$export$c0306caf338ac095 === 10) $21718d5ff5bac791$export$4e0c71f277ca26b3 = 1, $21718d5ff5bac791$export$53f1d5ea8de3d7c--;
    return $21718d5ff5bac791$export$c0306caf338ac095;
}
function $21718d5ff5bac791$export$48cfd1e771a65c4f() {
    $21718d5ff5bac791$export$c0306caf338ac095 = $21718d5ff5bac791$export$5880b8b5730aff45 < $21718d5ff5bac791$export$f24224f1c91d8156 ? (0, $432f2af859c96d26$export$a9db5e087081082d)($21718d5ff5bac791$export$30a86d91af8ff6e6, $21718d5ff5bac791$export$5880b8b5730aff45++) : 0;
    if ($21718d5ff5bac791$export$4e0c71f277ca26b3++, $21718d5ff5bac791$export$c0306caf338ac095 === 10) $21718d5ff5bac791$export$4e0c71f277ca26b3 = 1, $21718d5ff5bac791$export$53f1d5ea8de3d7c++;
    return $21718d5ff5bac791$export$c0306caf338ac095;
}
function $21718d5ff5bac791$export$4d3fb11e950abb9e() {
    return (0, $432f2af859c96d26$export$a9db5e087081082d)($21718d5ff5bac791$export$30a86d91af8ff6e6, $21718d5ff5bac791$export$5880b8b5730aff45);
}
function $21718d5ff5bac791$export$e88cb2efb12ae807() {
    return $21718d5ff5bac791$export$5880b8b5730aff45;
}
function $21718d5ff5bac791$export$58adb3bec8346d0f(begin, end) {
    return (0, $432f2af859c96d26$export$2f35ab04d2335697)($21718d5ff5bac791$export$30a86d91af8ff6e6, begin, end);
}
function $21718d5ff5bac791$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $21718d5ff5bac791$export$2de70f21292aac9e(value) {
    return $21718d5ff5bac791$export$53f1d5ea8de3d7c = $21718d5ff5bac791$export$4e0c71f277ca26b3 = 1, $21718d5ff5bac791$export$f24224f1c91d8156 = (0, $432f2af859c96d26$export$36776f635604f274)($21718d5ff5bac791$export$30a86d91af8ff6e6 = value), $21718d5ff5bac791$export$5880b8b5730aff45 = 0, [];
}
function $21718d5ff5bac791$export$45918ac1574455b1(value) {
    return $21718d5ff5bac791$export$30a86d91af8ff6e6 = '', value;
}
function $21718d5ff5bac791$export$410ac95b9ec204b8(type) {
    return (0, $432f2af859c96d26$export$87c2784dc9fc4ab)($21718d5ff5bac791$export$58adb3bec8346d0f($21718d5ff5bac791$export$5880b8b5730aff45 - 1, $21718d5ff5bac791$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $21718d5ff5bac791$export$660b2ee2d4fb4eff(value) {
    return $21718d5ff5bac791$export$45918ac1574455b1($21718d5ff5bac791$export$5f8c09e3ae6f64e1($21718d5ff5bac791$export$2de70f21292aac9e(value)));
}
function $21718d5ff5bac791$export$7af1228ff777d175(type) {
    while($21718d5ff5bac791$export$c0306caf338ac095 = $21718d5ff5bac791$export$4d3fb11e950abb9e())if ($21718d5ff5bac791$export$c0306caf338ac095 < 33) $21718d5ff5bac791$export$48cfd1e771a65c4f();
    else break;
    return $21718d5ff5bac791$export$9e1725a4cfeada27(type) > 2 || $21718d5ff5bac791$export$9e1725a4cfeada27($21718d5ff5bac791$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $21718d5ff5bac791$export$5f8c09e3ae6f64e1(children) {
    while($21718d5ff5bac791$export$48cfd1e771a65c4f())switch($21718d5ff5bac791$export$9e1725a4cfeada27($21718d5ff5bac791$export$c0306caf338ac095)){
        case 0:
            (0, $432f2af859c96d26$export$10d8903dec122b9d)($21718d5ff5bac791$export$c2ab62c7bf24634($21718d5ff5bac791$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $432f2af859c96d26$export$10d8903dec122b9d)($21718d5ff5bac791$export$410ac95b9ec204b8($21718d5ff5bac791$export$c0306caf338ac095), children);
            break;
        default:
            (0, $432f2af859c96d26$export$10d8903dec122b9d)((0, $432f2af859c96d26$export$6788812c4e6611e6)($21718d5ff5bac791$export$c0306caf338ac095), children);
    }
    return children;
}
function $21718d5ff5bac791$export$955ba06d119e085e(index, count) {
    while(--count && $21718d5ff5bac791$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($21718d5ff5bac791$export$c0306caf338ac095 < 48 || $21718d5ff5bac791$export$c0306caf338ac095 > 102 || $21718d5ff5bac791$export$c0306caf338ac095 > 57 && $21718d5ff5bac791$export$c0306caf338ac095 < 65 || $21718d5ff5bac791$export$c0306caf338ac095 > 70 && $21718d5ff5bac791$export$c0306caf338ac095 < 97) break;
    return $21718d5ff5bac791$export$58adb3bec8346d0f(index, $21718d5ff5bac791$export$e88cb2efb12ae807() + (count < 6 && $21718d5ff5bac791$export$4d3fb11e950abb9e() == 32 && $21718d5ff5bac791$export$48cfd1e771a65c4f() == 32));
}
function $21718d5ff5bac791$export$c889f2fcc19dbf12(type) {
    while($21718d5ff5bac791$export$48cfd1e771a65c4f())switch($21718d5ff5bac791$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $21718d5ff5bac791$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $21718d5ff5bac791$export$c889f2fcc19dbf12($21718d5ff5bac791$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $21718d5ff5bac791$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $21718d5ff5bac791$export$48cfd1e771a65c4f();
            break;
    }
    return $21718d5ff5bac791$export$5880b8b5730aff45;
}
function $21718d5ff5bac791$export$4254d4e2b3745c4c(type, index) {
    while($21718d5ff5bac791$export$48cfd1e771a65c4f())// //
    if (type + $21718d5ff5bac791$export$c0306caf338ac095 === 57) break;
    else if (type + $21718d5ff5bac791$export$c0306caf338ac095 === 84 && $21718d5ff5bac791$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $21718d5ff5bac791$export$58adb3bec8346d0f(index, $21718d5ff5bac791$export$5880b8b5730aff45 - 1) + '*' + (0, $432f2af859c96d26$export$6788812c4e6611e6)(type === 47 ? type : $21718d5ff5bac791$export$48cfd1e771a65c4f());
}
function $21718d5ff5bac791$export$c2ab62c7bf24634(index) {
    while(!$21718d5ff5bac791$export$9e1725a4cfeada27($21718d5ff5bac791$export$4d3fb11e950abb9e()))$21718d5ff5bac791$export$48cfd1e771a65c4f();
    return $21718d5ff5bac791$export$58adb3bec8346d0f(index, $21718d5ff5bac791$export$5880b8b5730aff45);
}

var $abfe92eb9b93f71b$export$71ad59f2e432cfe8 = '-ms-';
var $abfe92eb9b93f71b$export$2c0f367103c8d01c = '-moz-';
var $abfe92eb9b93f71b$export$39dfd62a25e0fe93 = '-webkit-';
var $abfe92eb9b93f71b$export$a29989082612d0d9 = 'comm';
var $abfe92eb9b93f71b$export$aa3a2e812ca8570d = 'rule';
var $abfe92eb9b93f71b$export$527d108ccf083c2b = 'decl';
var $abfe92eb9b93f71b$export$d3d35020fa5b54f0 = '@page';
var $abfe92eb9b93f71b$export$500415a86c544f73 = '@media';
var $abfe92eb9b93f71b$export$a763edbf796b780a = '@import';
var $abfe92eb9b93f71b$export$2790aeb8b4e5c826 = '@charset';
var $abfe92eb9b93f71b$export$1cc683e23b84b133 = '@viewport';
var $abfe92eb9b93f71b$export$9447a5efea57e862 = '@supports';
var $abfe92eb9b93f71b$export$ef011b4e114b1fba = '@document';
var $abfe92eb9b93f71b$export$6aad947bda0f3f46 = '@namespace';
var $abfe92eb9b93f71b$export$b44a8529a35fcb60 = '@keyframes';
var $abfe92eb9b93f71b$export$2c16de31893252e6 = '@font-face';
var $abfe92eb9b93f71b$export$3d846dd52e150c6f = '@counter-style';
var $abfe92eb9b93f71b$export$22314bfbb57653fe = '@font-feature-values';
var $abfe92eb9b93f71b$export$d773506282b3cfe6 = '@layer';




function $87a6462d2c280dc4$export$ef7acd7185315e22(value) {
    return (0, $21718d5ff5bac791$export$45918ac1574455b1)($87a6462d2c280dc4$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $21718d5ff5bac791$export$2de70f21292aac9e)(value), 0, [
        0
    ], value));
}
function $87a6462d2c280dc4$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $21718d5ff5bac791$export$48cfd1e771a65c4f)()){
        // (
        case 40:
            if (previous != 108 && (0, $432f2af859c96d26$export$a9db5e087081082d)(characters, length - 1) == 58) {
                if ((0, $432f2af859c96d26$export$f8e21b1e77979a08)(characters += (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)((0, $21718d5ff5bac791$export$410ac95b9ec204b8)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $21718d5ff5bac791$export$410ac95b9ec204b8)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $21718d5ff5bac791$export$7af1228ff777d175)(previous);
            break;
        // \
        case 92:
            characters += (0, $21718d5ff5bac791$export$955ba06d119e085e)((0, $21718d5ff5bac791$export$e88cb2efb12ae807)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $21718d5ff5bac791$export$4d3fb11e950abb9e)()){
                case 42:
                case 47:
                    (0, $432f2af859c96d26$export$10d8903dec122b9d)($87a6462d2c280dc4$export$4a34f930e789283c((0, $21718d5ff5bac791$export$4254d4e2b3745c4c)((0, $21718d5ff5bac791$export$48cfd1e771a65c4f)(), (0, $21718d5ff5bac791$export$e88cb2efb12ae807)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $432f2af859c96d26$export$36776f635604f274)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(characters, /\f/g, '');
                    if (property > 0 && (0, $432f2af859c96d26$export$36776f635604f274)(characters) - length) (0, $432f2af859c96d26$export$10d8903dec122b9d)(property > 32 ? $87a6462d2c280dc4$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $87a6462d2c280dc4$export$f8483753829ec8f3((0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $432f2af859c96d26$export$10d8903dec122b9d)(reference = $87a6462d2c280dc4$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $87a6462d2c280dc4$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $432f2af859c96d26$export$a9db5e087081082d)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $87a6462d2c280dc4$export$98e6a39c04603d36(value, reference, reference, rule && (0, $432f2af859c96d26$export$10d8903dec122b9d)($87a6462d2c280dc4$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $87a6462d2c280dc4$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $432f2af859c96d26$export$36776f635604f274)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $21718d5ff5bac791$export$232faf9add678146)() == 125) continue;
            }
            switch(characters += (0, $432f2af859c96d26$export$6788812c4e6611e6)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $432f2af859c96d26$export$36776f635604f274)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $21718d5ff5bac791$export$4d3fb11e950abb9e)() === 45) characters += (0, $21718d5ff5bac791$export$410ac95b9ec204b8)((0, $21718d5ff5bac791$export$48cfd1e771a65c4f)());
                    atrule = (0, $21718d5ff5bac791$export$4d3fb11e950abb9e)(), offset = length = (0, $432f2af859c96d26$export$36776f635604f274)(type = characters += (0, $21718d5ff5bac791$export$c2ab62c7bf24634)((0, $21718d5ff5bac791$export$e88cb2efb12ae807)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $432f2af859c96d26$export$36776f635604f274)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $87a6462d2c280dc4$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $432f2af859c96d26$export$f9084667e487ed46)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $432f2af859c96d26$export$2f35ab04d2335697)(value, post + 1, post = (0, $432f2af859c96d26$export$2335f513bbd82c6d)(j = points[i])), z = value; x < size; ++x)if (z = (0, $432f2af859c96d26$export$87c2784dc9fc4ab)(j > 0 ? rule[x] + ' ' + y : (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $21718d5ff5bac791$export$35059013cd4a06db)(value, root, parent, offset === 0 ? (0, $abfe92eb9b93f71b$export$aa3a2e812ca8570d) : type, props, children, length);
}
function $87a6462d2c280dc4$export$4a34f930e789283c(value, root, parent) {
    return (0, $21718d5ff5bac791$export$35059013cd4a06db)(value, root, parent, (0, $abfe92eb9b93f71b$export$a29989082612d0d9), (0, $432f2af859c96d26$export$6788812c4e6611e6)((0, $21718d5ff5bac791$export$eba6f6f03b0a92e7)()), (0, $432f2af859c96d26$export$2f35ab04d2335697)(value, 2, -2), 0);
}
function $87a6462d2c280dc4$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $21718d5ff5bac791$export$35059013cd4a06db)(value, root, parent, (0, $abfe92eb9b93f71b$export$527d108ccf083c2b), (0, $432f2af859c96d26$export$2f35ab04d2335697)(value, 0, length), (0, $432f2af859c96d26$export$2f35ab04d2335697)(value, length + 1, -1), length);
}






function $e7d905dd9193eed6$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $432f2af859c96d26$export$f9084667e487ed46)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $e7d905dd9193eed6$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $abfe92eb9b93f71b$export$d773506282b3cfe6:
            if (element.children.length) break;
        case 0, $abfe92eb9b93f71b$export$a763edbf796b780a:
        case 0, $abfe92eb9b93f71b$export$527d108ccf083c2b:
            return element.return = element.return || element.value;
        case 0, $abfe92eb9b93f71b$export$a29989082612d0d9:
            return '';
        case 0, $abfe92eb9b93f71b$export$b44a8529a35fcb60:
            return element.return = element.value + '{' + $e7d905dd9193eed6$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $abfe92eb9b93f71b$export$aa3a2e812ca8570d:
            element.value = element.props.join(',');
    }
    return (0, $432f2af859c96d26$export$36776f635604f274)(children = $e7d905dd9193eed6$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}




function $5e2ab9a11893b73e$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $432f2af859c96d26$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + value;
        // tab-size
        case 4789:
            return (0, $abfe92eb9b93f71b$export$2c0f367103c8d01c) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$2c0f367103c8d01c) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + value + value;
        // writing-mode
        case 5936:
            switch((0, $432f2af859c96d26$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') + (!(0, $432f2af859c96d26$export$4659b591c19bdf3d)(value, /flex-|baseline/) ? (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'grid-row-' + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + 'box-' + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)((0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)((0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)((0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + value;
        // justify-self
        case 4200:
            if (!(0, $432f2af859c96d26$export$4659b591c19bdf3d)(value, /flex-|baseline/)) return (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'grid-column-align' + (0, $432f2af859c96d26$export$2f35ab04d2335697)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $432f2af859c96d26$export$4659b591c19bdf3d)(element.props, /grid-\w+-end/);
            })) return ~(0, $432f2af859c96d26$export$f8e21b1e77979a08)(value + (children = children[length].value), 'span') ? value : (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, '-start', '') + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'grid-row-span:' + (~(0, $432f2af859c96d26$export$f8e21b1e77979a08)(children, 'span') ? (0, $432f2af859c96d26$export$4659b591c19bdf3d)(children, /\d+/) : +(0, $432f2af859c96d26$export$4659b591c19bdf3d)(children, /\d+/) - +(0, $432f2af859c96d26$export$4659b591c19bdf3d)(value, /\d+/)) + ';';
            return (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $432f2af859c96d26$export$4659b591c19bdf3d)(element.props, /grid-\w+-start/);
            }) ? value : (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)((0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $432f2af859c96d26$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $432f2af859c96d26$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $432f2af859c96d26$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $abfe92eb9b93f71b$export$2c0f367103c8d01c) + ((0, $432f2af859c96d26$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $432f2af859c96d26$export$f8e21b1e77979a08)(value, 'stretch') ? $5e2ab9a11893b73e$export$82e9f45cca5ba907((0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + a + ':' + b + f + (c ? (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $432f2af859c96d26$export$a9db5e087081082d)(value, length + 6) === 121) return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $432f2af859c96d26$export$a9db5e087081082d)(value, (0, $432f2af859c96d26$export$a9db5e087081082d)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + ((0, $432f2af859c96d26$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}


function $9143b2e387a5a657$export$5a7767152ae0305f(collection) {
    var length = (0, $432f2af859c96d26$export$f9084667e487ed46)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $9143b2e387a5a657$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $9143b2e387a5a657$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $abfe92eb9b93f71b$export$527d108ccf083c2b:
                element.return = (0, $5e2ab9a11893b73e$export$82e9f45cca5ba907)(element.value, element.length, children);
                return;
            case 0, $abfe92eb9b93f71b$export$b44a8529a35fcb60:
                return (0, $e7d905dd9193eed6$export$dfdc1655ccc5b9cb)([
                    (0, $21718d5ff5bac791$export$784d13d8ee351f07)(element, {
                        value: (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $abfe92eb9b93f71b$export$aa3a2e812ca8570d:
                if (element.length) return (0, $432f2af859c96d26$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $432f2af859c96d26$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $e7d905dd9193eed6$export$dfdc1655ccc5b9cb)([
                                (0, $21718d5ff5bac791$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $abfe92eb9b93f71b$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $e7d905dd9193eed6$export$dfdc1655ccc5b9cb)([
                                (0, $21718d5ff5bac791$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $21718d5ff5bac791$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $abfe92eb9b93f71b$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $21718d5ff5bac791$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $9143b2e387a5a657$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $abfe92eb9b93f71b$export$aa3a2e812ca8570d:
            element.props = element.props.map(function(value) {
                return (0, $432f2af859c96d26$export$1be1fc439b849fdf)((0, $21718d5ff5bac791$export$660b2ee2d4fb4eff)(value), function(value, index, children) {
                    switch((0, $432f2af859c96d26$export$a9db5e087081082d)(value, 0)){
                        // \f
                        case 12:
                            return (0, $432f2af859c96d26$export$2f35ab04d2335697)(value, 1, (0, $432f2af859c96d26$export$36776f635604f274)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $432f2af859c96d26$export$2f35ab04d2335697)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $432f2af859c96d26$export$f9084667e487ed46)(children) > 1 ? '' : value;
                                case index = (0, $432f2af859c96d26$export$f9084667e487ed46)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}


var $fef3d59b736200bc$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $3587f7e2ed7416b3$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $0bb108cf9f15301b$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $21718d5ff5bac791$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $21718d5ff5bac791$export$9e1725a4cfeada27)(character)) break;
        (0, $21718d5ff5bac791$export$48cfd1e771a65c4f)();
    }
    return (0, $21718d5ff5bac791$export$58adb3bec8346d0f)(begin, (0, $21718d5ff5bac791$export$5880b8b5730aff45));
};
var $0bb108cf9f15301b$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $21718d5ff5bac791$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $21718d5ff5bac791$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $0bb108cf9f15301b$var$identifierWithPointTracking((0, $21718d5ff5bac791$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $21718d5ff5bac791$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $21718d5ff5bac791$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $432f2af859c96d26$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $21718d5ff5bac791$export$48cfd1e771a65c4f)());
    return parsed;
};
var $0bb108cf9f15301b$var$getRules = function getRules(value, points) {
    return (0, $21718d5ff5bac791$export$45918ac1574455b1)($0bb108cf9f15301b$var$toRules((0, $21718d5ff5bac791$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $0bb108cf9f15301b$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $0bb108cf9f15301b$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$0bb108cf9f15301b$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $0bb108cf9f15301b$var$fixedElements.set(element, true);
    var points = [];
    var rules = $0bb108cf9f15301b$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $0bb108cf9f15301b$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $0bb108cf9f15301b$var$prefix(value, length) {
    switch((0, $432f2af859c96d26$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$2c0f367103c8d01c) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + 'box-' + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)((0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)((0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)((0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $432f2af859c96d26$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $432f2af859c96d26$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $432f2af859c96d26$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $abfe92eb9b93f71b$export$2c0f367103c8d01c) + ((0, $432f2af859c96d26$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $432f2af859c96d26$export$f8e21b1e77979a08)(value, 'stretch') ? $0bb108cf9f15301b$var$prefix((0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $432f2af859c96d26$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $432f2af859c96d26$export$a9db5e087081082d)(value, (0, $432f2af859c96d26$export$36776f635604f274)(value) - 3 - (~(0, $432f2af859c96d26$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + ((0, $432f2af859c96d26$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $432f2af859c96d26$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $0bb108cf9f15301b$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $abfe92eb9b93f71b$export$527d108ccf083c2b:
                element["return"] = $0bb108cf9f15301b$var$prefix(element.value, element.length);
                break;
            case 0, $abfe92eb9b93f71b$export$b44a8529a35fcb60:
                return (0, $e7d905dd9193eed6$export$dfdc1655ccc5b9cb)([
                    (0, $21718d5ff5bac791$export$784d13d8ee351f07)(element, {
                        value: (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $abfe92eb9b93f71b$export$aa3a2e812ca8570d:
                if (element.length) return (0, $432f2af859c96d26$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $432f2af859c96d26$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $e7d905dd9193eed6$export$dfdc1655ccc5b9cb)([
                                (0, $21718d5ff5bac791$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $abfe92eb9b93f71b$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $e7d905dd9193eed6$export$dfdc1655ccc5b9cb)([
                                (0, $21718d5ff5bac791$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $21718d5ff5bac791$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $abfe92eb9b93f71b$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $21718d5ff5bac791$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $0bb108cf9f15301b$var$defaultStylisPlugins = [
    $0bb108cf9f15301b$var$prefixer
];
var $0bb108cf9f15301b$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $0bb108cf9f15301b$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' ');
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $0bb108cf9f15301b$var$compat,
        $0bb108cf9f15301b$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $e7d905dd9193eed6$export$fac44ee5b035f737),
        (0, $9143b2e387a5a657$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $9143b2e387a5a657$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $e7d905dd9193eed6$export$dfdc1655ccc5b9cb)((0, $87a6462d2c280dc4$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $3104ec53a35158ff$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};


function $f43c50d92a19d876$export$2e2bcd8739ae039() {
    return $f43c50d92a19d876$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f43c50d92a19d876$export$2e2bcd8739ae039.apply(null, arguments);
}



var $63fc9407ef8fcdfe$exports = {};
'use strict';
var $a0e803d22f8be2af$exports = {};
'use strict';

$a0e803d22f8be2af$exports = (parcelRequire("3oWWu"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $63fc9407ef8fcdfe$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $63fc9407ef8fcdfe$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$TYPE_STATICS = {};
$63fc9407ef8fcdfe$var$TYPE_STATICS[$a0e803d22f8be2af$exports.ForwardRef] = $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS;
$63fc9407ef8fcdfe$var$TYPE_STATICS[$a0e803d22f8be2af$exports.Memo] = $63fc9407ef8fcdfe$var$MEMO_STATICS;
function $63fc9407ef8fcdfe$var$getStatics(component) {
    // React v16.11 and below
    if ($a0e803d22f8be2af$exports.isMemo(component)) return $63fc9407ef8fcdfe$var$MEMO_STATICS;
     // React v16.12 and above
    return $63fc9407ef8fcdfe$var$TYPE_STATICS[component['$$typeof']] || $63fc9407ef8fcdfe$var$REACT_STATICS;
}
var $63fc9407ef8fcdfe$var$defineProperty = Object.defineProperty;
var $63fc9407ef8fcdfe$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $63fc9407ef8fcdfe$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $63fc9407ef8fcdfe$var$getPrototypeOf = Object.getPrototypeOf;
var $63fc9407ef8fcdfe$var$objectPrototype = Object.prototype;
function $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($63fc9407ef8fcdfe$var$objectPrototype) {
            var inheritedComponent = $63fc9407ef8fcdfe$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $63fc9407ef8fcdfe$var$objectPrototype) $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $63fc9407ef8fcdfe$var$getOwnPropertyNames(sourceComponent);
        if ($63fc9407ef8fcdfe$var$getOwnPropertySymbols) keys = keys.concat($63fc9407ef8fcdfe$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $63fc9407ef8fcdfe$var$getStatics(targetComponent);
        var sourceStatics = $63fc9407ef8fcdfe$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$63fc9407ef8fcdfe$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $63fc9407ef8fcdfe$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$63fc9407ef8fcdfe$exports = $63fc9407ef8fcdfe$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $c80ca66c64e3fad5$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($63fc9407ef8fcdfe$exports)))(targetComponent, sourceComponent);
};


var $48e4b1fcfcd646c1$var$isBrowser = true;
function $48e4b1fcfcd646c1$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $48e4b1fcfcd646c1$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $48e4b1fcfcd646c1$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $48e4b1fcfcd646c1$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $48e4b1fcfcd646c1$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $1529d79d9aa6f066$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $8ec00e8a3ecbe6f7$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $49fc6b0b9a1bf345$var$isDevelopment = false;
var $49fc6b0b9a1bf345$var$hyphenateRegex = /[A-Z]|^ms/g;
var $49fc6b0b9a1bf345$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $49fc6b0b9a1bf345$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $49fc6b0b9a1bf345$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $49fc6b0b9a1bf345$var$processStyleName = /* #__PURE__ */ (0, $3587f7e2ed7416b3$export$2e2bcd8739ae039)(function(styleName) {
    return $49fc6b0b9a1bf345$var$isCustomProperty(styleName) ? styleName : styleName.replace($49fc6b0b9a1bf345$var$hyphenateRegex, '-$&').toLowerCase();
});
var $49fc6b0b9a1bf345$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($49fc6b0b9a1bf345$var$animationRegex, function(match, p1, p2) {
                $49fc6b0b9a1bf345$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $49fc6b0b9a1bf345$var$cursor
                };
                return p1;
            });
    }
    if ((0, $8ec00e8a3ecbe6f7$export$2e2bcd8739ae039)[key] !== 1 && !$49fc6b0b9a1bf345$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $49fc6b0b9a1bf345$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $49fc6b0b9a1bf345$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $49fc6b0b9a1bf345$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $49fc6b0b9a1bf345$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $49fc6b0b9a1bf345$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $49fc6b0b9a1bf345$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $49fc6b0b9a1bf345$var$cursor;
                var result = interpolation(mergedProps);
                $49fc6b0b9a1bf345$var$cursor = previousCursor;
                return $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $49fc6b0b9a1bf345$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($49fc6b0b9a1bf345$var$isProcessableValue(asString)) string += $49fc6b0b9a1bf345$var$processStyleName(key) + ":" + $49fc6b0b9a1bf345$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $49fc6b0b9a1bf345$var$isDevelopment) throw new Error($49fc6b0b9a1bf345$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($49fc6b0b9a1bf345$var$isProcessableValue(value[_i])) string += $49fc6b0b9a1bf345$var$processStyleName(key) + ":" + $49fc6b0b9a1bf345$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $49fc6b0b9a1bf345$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $49fc6b0b9a1bf345$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $49fc6b0b9a1bf345$var$cursor;
function $49fc6b0b9a1bf345$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $49fc6b0b9a1bf345$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $49fc6b0b9a1bf345$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $49fc6b0b9a1bf345$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $1529d79d9aa6f066$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $49fc6b0b9a1bf345$var$cursor
    };
}



var $7fPBF = parcelRequire("7fPBF");
var $b2729db54ba7ee9b$var$syncFallback = function syncFallback(create) {
    return create();
};
var $b2729db54ba7ee9b$var$useInsertionEffect = $7fPBF.useInsertionEffect ? $7fPBF.useInsertionEffect : false;
var $b2729db54ba7ee9b$export$db21c7ffa21794e7 = $b2729db54ba7ee9b$var$useInsertionEffect || $b2729db54ba7ee9b$var$syncFallback;
var $b2729db54ba7ee9b$export$811a713a7276cb9d = $b2729db54ba7ee9b$var$useInsertionEffect || $7fPBF.useLayoutEffect;


var $d62c6f18f523e962$export$23f2a1d2818174ef = false;
var $d62c6f18f523e962$var$EmotionCacheContext = /* #__PURE__ */ $7fPBF.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $0bb108cf9f15301b$export$2e2bcd8739ae039)({
    key: 'css'
}) : null);
var $d62c6f18f523e962$export$e7094788287c5e9b = $d62c6f18f523e962$var$EmotionCacheContext.Provider;
var $d62c6f18f523e962$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $7fPBF.useContext)($d62c6f18f523e962$var$EmotionCacheContext);
};
var $d62c6f18f523e962$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $7fPBF.useContext)($d62c6f18f523e962$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $d62c6f18f523e962$export$971d5caa766a69d7 = /* #__PURE__ */ $7fPBF.createContext({});
var $d62c6f18f523e962$export$3b14a55fb2447963 = function useTheme() {
    return $7fPBF.useContext($d62c6f18f523e962$export$971d5caa766a69d7);
};
var $d62c6f18f523e962$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $d62c6f18f523e962$var$createCacheWithTheme = /* #__PURE__ */ (0, $fef3d59b736200bc$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $fef3d59b736200bc$export$2e2bcd8739ae039)(function(theme) {
        return $d62c6f18f523e962$var$getTheme(outerTheme, theme);
    });
});
var $d62c6f18f523e962$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $7fPBF.useContext($d62c6f18f523e962$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $d62c6f18f523e962$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $7fPBF.createElement($d62c6f18f523e962$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $d62c6f18f523e962$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $7fPBF.forwardRef(function render(props, ref) {
        var theme = $7fPBF.useContext($d62c6f18f523e962$export$971d5caa766a69d7);
        return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $c80ca66c64e3fad5$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $d62c6f18f523e962$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $d62c6f18f523e962$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $d62c6f18f523e962$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($d62c6f18f523e962$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$d62c6f18f523e962$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $d62c6f18f523e962$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $48e4b1fcfcd646c1$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $b2729db54ba7ee9b$export$db21c7ffa21794e7)(function() {
        return (0, $48e4b1fcfcd646c1$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $d62c6f18f523e962$var$Emotion = /* #__PURE__ */ $d62c6f18f523e962$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$d62c6f18f523e962$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $48e4b1fcfcd646c1$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)(registeredStyles, undefined, $7fPBF.useContext($d62c6f18f523e962$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($d62c6f18f523e962$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $d62c6f18f523e962$var$typePropName && !$d62c6f18f523e962$export$23f2a1d2818174ef) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($d62c6f18f523e962$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $7fPBF.createElement(WrappedComponent, newProps));
});
var $d62c6f18f523e962$export$a9c23c6ac3fc3eca = $d62c6f18f523e962$var$Emotion;



var $7fPBF = parcelRequire("7fPBF");








var $84f3fdd51733d70b$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $d62c6f18f523e962$export$dda1d9f60106f0e9).call(props, 'css')) return $7fPBF.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $d62c6f18f523e962$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $d62c6f18f523e962$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $7fPBF.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($84f3fdd51733d70b$export$c8a8987d4410bf2d || ($84f3fdd51733d70b$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $84f3fdd51733d70b$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $d62c6f18f523e962$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)([
        styles
    ], undefined, $7fPBF.useContext((0, $d62c6f18f523e962$export$971d5caa766a69d7)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $7fPBF.useRef();
    (0, $b2729db54ba7ee9b$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $b2729db54ba7ee9b$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $48e4b1fcfcd646c1$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $84f3fdd51733d70b$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)(args);
}
function $84f3fdd51733d70b$export$d25ddfdf17c3ad3e() {
    var insertable = $84f3fdd51733d70b$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $84f3fdd51733d70b$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $84f3fdd51733d70b$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $48e4b1fcfcd646c1$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $84f3fdd51733d70b$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $b2729db54ba7ee9b$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $48e4b1fcfcd646c1$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $84f3fdd51733d70b$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $d62c6f18f523e962$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $d62c6f18f523e962$export$23f2a1d2818174ef)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $48e4b1fcfcd646c1$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $d62c6f18f523e962$export$23f2a1d2818174ef)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $84f3fdd51733d70b$var$merge(cache.registered, css, $84f3fdd51733d70b$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $7fPBF.useContext((0, $d62c6f18f523e962$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($84f3fdd51733d70b$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});



const $8951886a6b49e92a$export$35e9368ef982300f = {
    bg_dark: '#041829',
    bg_light: '#FAFAFA',
    primary_intense: '#02101B',
    primary_dark: '#062844',
    primary_light: '#1d3b58',
    secondary: '#36368B',
    secondary_medium: '#C1C1FF',
    secondary_light: '#dfdff4',
    tertiary: '#EE486F',
    tertiary_updated: '#e51546',
    accent: '#6DB9E7',
    accent_light: '#9dcaff',
    accent_dark: '#4a90e2',
    accent_2: '#F4AE10',
    accent_2_light: '#F9D97D',
    accent_2_serious: '#F2C94C',
    error: '#BA1A1A',
    error_light: '#fef3f6',
    success: '#14761A',
    success_light: '#e9f4eb',
    success_serious: '#094932',
    neutral: '#565C61',
    neutral_light: '#87909B',
    neutral_medium: '#6b7280',
    neutral_dark: '#42474e',
    neutral_accent_1: '#FBFDFE',
    neutral_accent_2: '#F6F6FA',
    neutral_primary: '#E1EBF5',
    border: '#C2C7CF',
    border_dark: '#b9c0c9'
};
const $8951886a6b49e92a$export$c1613448d66f98fa = {
    accent_50: 'rgba(110, 235, 255, 0.5)',
    accent_20: 'rgba(110, 235, 255, 0.2)',
    primary_50: 'rgba(227, 22, 91, 0.5)',
    dark_90: 'rgba(6, 40, 68, 0.9)',
    dark_semi_transparent: 'rgba(6, 40, 68, 0.9)'
};
const $8951886a6b49e92a$export$78ee211991971792 = {
    hero: 'linear-gradient(26deg, #062844 30%, #49558d 70.66%, #6b6cb1 110.51%, #6c82c0 150.36%, #6db9e7 186.13%)',
    primary: 'linear-gradient(30deg, #062844 0%, #693B83 33%, #A4417A 66%, #EE486F 100%);',
    primary_angle: 'linear-gradient(135deg, #062844 0%, #693B83 33%, #A4417A 66%, #EE486F 100%);',
    primary_inverted: 'linear-gradient(30deg, #EE486F 0%, #A4417A 33%, #693B83 66%, #062844 100%);',
    secondary: 'linear-gradient(30deg, #062844 0%, #49558D 25%, #6B6CB1 50%, #6C82C0 75%, #6DB9E7 100%);',
    secondary_inverted: 'linear-gradient(30deg, #6DB9E7 0%, #6C82C0 25%, #6B6CB1 50%, #49558D 75%, #062844 100%);'
};
const $8951886a6b49e92a$export$efc0d715653ad35 = {
    primary: 'linear-gradient(30deg, #062844 0%, #693B83 100%);',
    primary_inverted: 'linear-gradient(30deg, #693B83 0%, #062844 100%);',
    secondary: 'linear-gradient(30deg, #062844 0%, #49558D 100%);',
    secondary_inverted: 'linear-gradient(30deg, #49558D 0%, #062844 100%);'
};
const $8951886a6b49e92a$export$277a472bd1b5ab4b = {
    primary: 'linear-gradient(30deg, #693B83 0%, #A4417A 100%);',
    primary_inverted: 'linear-gradient(30deg, #A4417A 0%, #693B83 100%);',
    secondary: 'linear-gradient(30deg, #49558D 0%, #6B6CB1 100%);',
    secondary_inverted: 'linear-gradient(30deg, #6B6CB1 0%, #49558D 100%);'
};
const $8951886a6b49e92a$export$9d4dc8ed9a67cba0 = {
    primary: 'linear-gradient(30deg, #A4417A 0%, #EE486F 100%);',
    primary_inverted: 'linear-gradient(30deg, #EE486F 0%, #A4417A 100%);',
    secondary: 'linear-gradient(30deg, #6B6CB1 0%, #6C82C0 100%);',
    secondary_inverted: 'linear-gradient(30deg, #6C82C0 0%, #6B6CB1 100%);'
};
const $8951886a6b49e92a$export$7536ca5ba8ef94f0 = {
    font_xs: '0.62rem',
    font_sm: '0.80rem',
    font_md: '1rem',
    font_lg: '1.25rem',
    font_xlg: '1.563rem',
    font_2xlg: '1.953rem',
    font_3xlg: '2.441rem',
    font_4xlg: '3.052rem',
    default: '1rem',
    text_default: '1rem',
    caption: '0.8rem',
    button_default: '1rem',
    button_hover: '1.1rem',
    button_lg: '1.25rem',
    button_lg_hover: '1.35rem',
    button_sm: '0.8rem',
    button_sm_hover: '0.9rem',
    heading_1: '1.563rem',
    heading_2: '1.953rem',
    card_title: '1.953rem',
    card_subtitle: '1.25rem',
    menu_card: '1rem',
    step: '1.25rem',
    step_seperator: '1.563rem'
};
const $8951886a6b49e92a$export$7c48f4a82d421f6e = {
    light: '300',
    regular: '400',
    medium: '500',
    semibold: '600',
    bold: '700',
    default: '400',
    text_default: '400',
    button_default: '400',
    button_bold: '600',
    card_title: '400',
    card_subtitle: '300',
    menu_card: '400'
};
const $8951886a6b49e92a$export$aa43e0cf17fdb070 = {
    // using standard 1.5 multiplier
    font_xs: '0.930rem',
    font_sm: '1.200rem',
    font_md: '1.500rem',
    font_lg: '1.875rem',
    font_xlg: '2.344rem',
    font_2xlg: '2.930rem',
    font_3xlg: '3.661rem',
    font_4xlg: '4.578rem',
    text_default: '1.5rem'
};
const $8951886a6b49e92a$export$66bb15e2994e6a26 = {
    default: 'all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)',
    button: `all 0.1s ease-in-out;`
};
const $8951886a6b49e92a$export$7a57f79000377ca2 = {
    sm: '0.25rem',
    md: '0.5rem',
    default: '0.62rem',
    lg: '2rem',
    round: '50%'
};
const $8951886a6b49e92a$export$16e1fc8de5cd9687 = {
    default: `0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);`,
    hover: `0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);`
};
const $8951886a6b49e92a$export$29bb14a8b9f2803e = `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="1095" height="2164" viewBox="0 0 1095 2164" fill="none"><path opacity="0.1" d="M457.684 1500.32C427.564 1256.88 363.423 1054.11 325.82 871.89C286.698 669.335 239.351 449.24 399.125 295.785C515.961 180.441 714.417 190.481 856.597 257.274C1007.97 338.515 1092.09 469.391 994.562 733.466C1068.45 636.091 1106.37 515.177 1091.93 410.33C1045.97 77.7569 778.061 -1.68068 594.512 0.870846C418.992 3.40439 200.036 114.728 96.5716 329.053C25.8917 475.564 -3.03559 682.462 71.7142 1057.36C163.323 1516.37 125.759 1834.89 8.88889 2087.43C7.06729 2091.18 5.96644 2095.28 3.85654 2098.88C-1.55431 2108.55 -1.09116 2117.86 16.5831 2121.46C19.0256 2121.94 21.5422 2122.63 24.0588 2123.31C160.492 2157.2 297.61 2169.14 431.78 2161.12C435.615 2145.17 501.825 1856.07 457.824 1500.03L457.684 1500.32Z" fill="url(%23paint0_linear_2388_1132)"/><defs><linearGradient id="paint0_linear_2388_1132" x1="459.422" y1="41.4754" x2="192.952" y2="633.478" gradientUnits="userSpaceOnUse"><stop stop-color="%236DB9E7"/><stop offset="0.07" stop-color="%236CA2D7"/><stop offset="0.16" stop-color="%236B8AC6"/><stop offset="0.26" stop-color="%236B79BA"/><stop offset="0.37" stop-color="%236B6FB3"/><stop offset="0.5" stop-color="%236B6CB1"/><stop offset="1" stop-color="%23062844"/></linearGradient></defs></svg>')`;
const $8951886a6b49e92a$export$f6e93140e4a16f4b = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)`
  0% {
    transform: translateY(10%);
    opacity: 0;
    overflow: hidden;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;
const $8951886a6b49e92a$export$a63bc229d382c303 = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)`
    0% {
        background-color: transparent;
    }
    100% {
        background-color: '#062844' ;
    }
`;
const $8951886a6b49e92a$export$42e8f6dfc68e0255 = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;
const $8951886a6b49e92a$export$bca14c5b3b88a9c9 = (0, $ca3239ce6bf6e490$export$2e2bcd8739ae039)({
    palette: {
        text: {
            primary: $8951886a6b49e92a$export$35e9368ef982300f.primary_dark
        },
        primary: {
            main: $8951886a6b49e92a$export$35e9368ef982300f.secondary
        },
        secondary: {
            main: $8951886a6b49e92a$export$35e9368ef982300f.tertiary
        },
        error: {
            main: $8951886a6b49e92a$export$35e9368ef982300f.error
        }
    },
    typography: {
        fontFamily: 'Archivo, sans-serif'
    },
    components: {
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: '1rem',
                    fontWeight: 400,
                    color: $8951886a6b49e92a$export$35e9368ef982300f.neutral
                }
            }
        },
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true
            }
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: '0.5rem'
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: $8951886a6b49e92a$export$7536ca5ba8ef94f0.font_sm,
                    lineHeight: $8951886a6b49e92a$export$aa43e0cf17fdb070.font_xs,
                    backgroundColor: $8951886a6b49e92a$export$c1613448d66f98fa.dark_semi_transparent
                }
            },
            defaultProps: {
                enterDelay: 800,
                leaveDelay: 200,
                enterNextDelay: 400
            }
        },
        MuiRadio: {
            defaultProps: {
                disableRipple: true
            }
        }
    }
});
const $8951886a6b49e92a$export$bf79f457b6853d65 = 32;


const $3ecd3f7dea3d56de$export$c89f3ba9a8ee8018 = 'en';
const $3ecd3f7dea3d56de$export$f44b61b0f29ec = 'en-us';
const $3ecd3f7dea3d56de$export$a1451363a805f944 = {
    'en-us': "\uD83C\uDDFA\uD83C\uDDF8",
    'en-gb': "\uD83C\uDDEC\uD83C\uDDE7",
    'en-in': "\uD83C\uDDEE\uD83C\uDDF3",
    es: "\uD83C\uDDEA\uD83C\uDDF8",
    fr: "\uD83C\uDDEB\uD83C\uDDF7",
    it: "\uD83C\uDDEE\uD83C\uDDF9",
    de: "\uD83C\uDDE9\uD83C\uDDEA",
    ja: "\uD83C\uDDEF\uD83C\uDDF5"
};
const $3ecd3f7dea3d56de$export$df1c34db1371eeed = {
    display: [
        'en',
        'es',
        'fr',
        'it',
        'de',
        'ja'
    ],
    voice: [
        'en-us',
        'en-gb',
        'en-in',
        'es',
        'fr',
        'it',
        'de',
        'ja'
    ]
};
const $3ecd3f7dea3d56de$export$e471f5ee496a5676 = {
    'en-us': [
        'type'
    ],
    'en-gb': [
        'type'
    ],
    'en-in': [
        'type'
    ],
    es: [
        'escribe'
    ],
    fr: [
        'tape'
    ],
    it: [
        'scrivi'
    ],
    de: [
        'schreiben'
    ],
    ja: [
        "\u66F8\u304F"
    ]
};


var $3fc11051985d0b09$exports = {};
$3fc11051985d0b09$exports = JSON.parse('{"logo":"Cephable-Logo","add":"Hinzuf\xfcgen","all":"Alle","edit":"Bearbeiten","create":"Erstellen","delete":"L\xf6schen","previous":"Vorherige","next":"N\xe4chste","search":"Suchen","loading":"Laden...","reload":"Neu laden","cancel":"Stornieren","copy":"Kopie","save":"Speichern","saveAndFinish":"Speichern und beenden","saveAndContinue":"Speichern und fortfahren","saved":"Gespeichert","done":"Erledigt","back":"Zur\xfcck","play":"Spielen","pause":"Pause","success":"Erfolg","continue":"Weitermachen","options":"Optionen","share":"Aktie","finish":"Beenden","finishEdit":"Bearbeitung beenden","advancedOptions":"Erweiterte Optionen anzeigen","authenticating":"Authentifizierung...","skipToMain":"Zum Hauptinhalt springen","skip":"\xdcberspringen","close":"Schlie\xdfen","notFound":"Seite nicht gefunden","notFoundDescription":"Oh nein! Wir haben das ganze Meer abgesucht und k\xf6nnen die Seite nicht finden!","exitSetup":"Setup beenden","experimental":"Experimental","letGetStarted":"Lasst uns anfangen!","exploreInputControls":"Eingabesteuerung erkunden","when":"Wenn ich ...","thenMacro":"Cephable wird ausgef\xfchrt ...","controls":"Bedienelemente","welcome":"Willkommen.","beta":"Beta","macroEmpty":"Es gibt keine Makros, die diesen Kriterien entsprechen.","you":"Du","step":"Schritt","steps":"Vorgehensweise","learnMore":"Mehr erfahren","dangerZone":"Gefahrenzone","connected":"Verbunden","notConnected":"Nicht verbunden","connectAndLearn":"Vernetzen und lernen","tryAgain":"Versuchen Sie es erneut","by":"Von: {{value}}","noName":"- kein Name -","details":"Details","controlFeed":"Kontrollvorschub","upgrade":"Aktualisierung","mobileApp":{"title":"Mobile App"},"dashboard":{"title":"Armaturenbrett"},"invalidNumber":"N / A","wifi":{"disconnected":"Die WLAN-Verbindung ist getrennt.","connected":"WLAN ist verbunden.","description":"Stellen Sie eine WLAN-Verbindung her, damit Cephable mit Ihren Verbindungen und Ihrer Software funktioniert. M\xf6glicherweise sind Ihre aktuellen Steuerelemente nur eingeschr\xe4nkt nutzbar."},"signalR":{"disconnected":"Die Synchronisierung ist getrennt.","action":"Neu verbinden","description":"Es scheint ein Problem mit der Cephable-Synchronisierung zu geben. Dies f\xfchrt zu Problemen beim Speichern Ihrer Einstellungen oder bei der Kommunikation mit anderen Verbindungen.","disconnectedDevice":"Synchronisierung mit {{name}} nicht m\xf6glich.","disconnectedDeviceDescription":"Es scheint ein Problem mit der Synchronisierung zu geben, entweder aufgrund der Authentifizierung oder der Internetverbindung. Sie k\xf6nnen keine Daten senden oder empfangen. Bitte \xfcberpr\xfcfen Sie beide Seiten der Verbindung.","connected":"Die Synchronisierung ist verbunden.","connectedDescription":"Cephable synchronisiert ordnungsgem\xe4\xdf und sollte wie erwartet mit Ihren Verbindungen und Erweiterungen kommunizieren.","swap":"Wechseln Sie zur Verbindung mit einem lokalen Ger\xe4t.","unlinkedDevice":"Verbindung getrennt.","unlinkedDeviceDescription":"Diese Verbindung wurde von Ihrem Konto getrennt."},"billing":{"title":"Abrechnung","expires":"N\xe4chste Abrechnung: {{value}}","isEmployeeAccess":{"title":"Professional","titleLong":"Cephable Profi","short":"Pro","description":"Cephable Professional verleiht Benutzern mehr Produktivit\xe4t und erweitert die lokale, private KI um generative F\xe4higkeiten.","supportedFeatures":{"tag":"Alles in Plus, plus","features":["On-Device-KI-Workflows","Unternehmensorganisationsmanagement","Unternehmensbeschr\xe4nkungen","Unbegrenzte Ger\xe4teinstallationen","Unbegrenzte Anzahl vorkonfigurierter App-Steuerelemente"]}},"isDeveloperAccess":{"title":"SDK","titleLong":"Cephable SDK","short":"SDK","description":"Mit Cephable SDKs k\xf6nnen Sie leistungsstarke adaptive Steuerelemente \u2013 Sprache, Gesicht, Kopf und mehr \u2013 mit minimalem Aufwand und maximalem Nutzen in Ihre Software integrieren.","supportedFeatures":{"tag":"Alles in Plus, plus","features":["Windows- und MacOS-Unterst\xfctzung","Leichtgewichtige, einbettbare SDKs f\xfcr die Offline-Eingabe von Sprache, Gesicht, Kopf und schnellen Aktionen","API-/Webhook-Unterst\xfctzung f\xfcr benutzerdefinierte Ausgabeaktionen","Entwicklerdokumente","Beispielprojekte","Verwandeln Sie Befehle in Dokumentautomatisierung und -navigation","Entwicklerportal zur Verwaltung Ihrer Projekte, Authentifizierungsclients, Ger\xe4tetypen und mehr"]}},"isStudentAccess":{"title":"Student","titleLong":"Cephable-Ausbildung","short":"Bildung","description":"Cephable Education unterst\xfctzt personalisiertes Lernen und inklusiven Unterricht. Cephable funktioniert offline, l\xe4uft auf dem Ger\xe4t und erfordert keine Integration von Drittanbietern.","supportedFeatures":{"tag":"Alles in Plus, plus","features":["Unbegrenzte Ger\xe4teinstallationen","Unbegrenzte vorab trainierte App-Steuerelemente","Unbegrenztes Teilen von benutzerdefinierten App-Steuerelementen"]}},"viewProducts":"Produkte anzeigen","description":"Verwalten Sie die Abrechnung, Sitze, Abonnement-Upgrades, Verl\xe4ngerungen oder K\xfcndigungen Ihres Unternehmens.","view":"Abrechnung verwalten","isResellerAccess":{"title":"Wiederverk\xe4ufer","titleLong":"Cephable-Wiederverk\xe4ufer","description":"Cephable Reseller ist eine kostenpflichtige Lizenz, mit der Sie neue Organisationen erstellen und Lizenzschl\xfcssel zuweisen k\xf6nnen. Dazu geh\xf6rt die Verwendung von Cephable mit Ihrer eigenen Software-Suite und die Verbesserung Ihrer Benutzererfahrung.","short":"Wiederverk\xe4ufer"},"error":"Bitte wenden Sie sich zur Verwaltung Ihrer Abrechnung an Ihren Systemadministrator.","included":"In Ihrer {{licenseType}}-Lizenz enthalten.","upgrade":{"description":"F\xfchren Sie jetzt ein Upgrade durch und bringen Sie Ihre Steuerung auf die n\xe4chste Stufe.","action":"Jetzt upgraden","error":"Fehler bei der Aktualisierung. Bitte versuchen Sie es sp\xe4ter erneut.","requiredDetail":"F\xfcr diese Funktion ist eine {{licenseType}}-Lizenz erforderlich. Sie k\xf6nnen jederzeit in Ihren Kontoeinstellungen ein Upgrade durchf\xfchren oder eine kostenlose Testversion starten.","enableTextGeneration":"Erstellen Sie Inhalte mithilfe von KI und Ihrer Stimme.","longDescription":"Aktualisieren Sie auf eine kostenpflichtige Lizenz, um alle Funktionen von Cephable freizuschalten. Von mehreren Ger\xe4ten \xfcber erweiterte Bedienelemente bis hin zu benutzerdefinierten Integrationen bietet Cephable alles, was Sie f\xfcr ein h\xf6heres Produktivit\xe4tsniveau ben\xf6tigen.","compare":"Pl\xe4ne vergleichen","enableAiDictation":{"title":"Upgrade auf intelligentes Diktieren","description":"Aktualisieren Sie, um die KI-gest\xfctzte Diktierfunktion freizuschalten. Ich kann Satzzeichen hinzuf\xfcgen, Gro\xdf- und Kleinschreibung korrigieren und mich Ihrem Stil anpassen, damit Ihr Text ohne zus\xe4tzlichen Aufwand professionell aussieht."}},"isPlusAccess":{"title":"Plus","titleLong":"Cephable Plus","short":"Plus","description":"Cephable Plus ist f\xfcr Power-User, die mit intelligenter Stimme, intelligentem Diktierger\xe4t, Hunderten von App-Steuerelementen und mehr mehr erreichen m\xf6chten.","supportedFeatures":{"tag":"Alles aus Basic, plus","features":["Intelligente Sprachsteuerung (Nat\xfcrliche Sprache)","Intelligente Diktierfunktion (KI-gest\xfctzt)","Intelligente Aufgaben (Generierung, \xdcbersetzung, Umschreibung)","Hunderte vorkonfigurierte App-Steuerelemente"]}},"personal":{"short":"Basic","title":"Basic","titleLong":"Cephable Basic","description":"Cephable Basic ist dauerhaft kostenlos und hilft Ihnen, schneller voranzukommen, sich auszudr\xfccken und Aufgaben zu erledigen \u2013 ganz nach Ihren W\xfcnschen. Die in Basic enthaltenen Funktionen stehen allen Nutzern zur Verf\xfcgung.","upgrade":{"title":"Bringen Sie Ihre Steuerung auf die n\xe4chste Stufe","description":"Steigen Sie auf Plus oder Pro um und schalten Sie alle Funktionen frei. Mehr Genauigkeit. Mehr Verbindungen. Mehr Steuerungsm\xf6glichkeiten. Mehr Leistung f\xfcr maximale Produktivit\xe4t.","featureHeading":"So kann ich Ihnen helfen:","control":"Ich f\xfchre Sie per Sprachbefehl oder Schnellaktionen schneller durch Apps und Tools \u2013 ohne Unterbrechungen. Mit Intelligent Voice k\xf6nnen wir uns einfach unterhalten.","create":"Ich schreibe, diktiere, generiere und \xfcbersetze direkt in Ihren Apps \u2013 kein Kopieren, Einf\xfcgen oder Umschalten zwischen Bildschirmen erforderlich.","automate":"Ich f\xfchre intelligente Aufgaben und schnelle Aktionen aus, die Ihren Arbeitsablauf beschleunigen. Von einfachen Befehlen bis hin zu komplexen Makros \u2013 ich \xfcbernehme die Routinearbeiten, damit Sie sich auf das Wesentliche konzentrieren k\xf6nnen.","local":"Reine lokale KI. Keine Cloud-Verarbeitung."}},"mostPopular":"Am beliebtesten","subscription":{"options":"Abonnementoptionen","monthly":"Monatlich bezahlen","billedMonthly":"/Monat","yearly":"J\xe4hrliche Zahlung","billedYearly":"/Jahr"}},"organization":{"title":"Organisation","titlePlural":"Organisationen","titleLong":"Cephable Professional f\xfcr Organisationen","description":"Organisationen sind Gruppen von Benutzern, die an Projekten zusammenarbeiten und Ressourcen teilen k\xf6nnen. Hier k\xf6nnen Sie Ihr Team, Teamprofile, Abrechnungen und mehr verwalten.","noAccess":{"title":"Zugriff verweigert.","description":"Ihre Berechtigungen wurden k\xfcrzlich ge\xe4ndert und Sie haben keinen Zugriff mehr auf diese Funktion. Wenn Sie glauben, dass dies ein Fehler ist, wenden Sie sich bitte an den Administrator Ihrer Organisation."},"noOrg":{"title":"Keine zugeh\xf6rige Lizenz.","description":"Sie sind derzeit keiner Lizenz oder Entwicklergruppe zugeordnet. Der Zugriff auf das Portal ist auf Benutzer mit einer kostenpflichtigen Cephable-Lizenz beschr\xe4nkt. Um das volle Potenzial von Cephable auszusch\xf6pfen, starten Sie eine risikofreie Testversion."},"member":{"title":"Mitglied","titlePlural":"Mitglieder","me":"Meine Mitgliedschaft","description":"Mitglieder sind Benutzer, die Teil Ihrer Organisation sind. Ihnen k\xf6nnen verschiedene Rollen zugewiesen werden und sie haben Zugriff auf unterschiedliche Teile der Organisation.","edit":"Mitglieder bearbeiten","removed":"Sie wurden aus einem Team entfernt.","removedDescription":"Sie wurden aus dem Team entfernt. Sie k\xf6nnen nicht mehr auf die Organisation zugreifen. Wenn Sie glauben, dass dies ein Fehler ist, wenden Sie sich bitte an den Administrator Ihrer Organisation.","updated":"Erfolg, die Mitgliedschaft von {{value}} wurde aktualisiert.","error":"Fehler beim Aktualisieren der Mitgliedschaft von {{value}}.","delete":"Erfolg, {{value}} wurde entfernt.","deleteError":"Fehler beim Entfernen von {{value}}.","deleteConfirmation":{"title":"M\xf6chten Sie dieses Mitglied wirklich entfernen?","description":"Sobald Sie dieses Mitglied entfernen, hat es keinen Zugriff mehr auf die Organisation. Sie k\xf6nnen es sp\xe4ter jederzeit erneut einladen.","confirm":"Ja, Mitglied entfernen"},"viewAll":{"title":"Alle Mitglieder anzeigen","description":"Zeigen Sie alle Mitglieder Ihrer Organisation an und verwalten Sie ihre Rollen und Berechtigungen."},"seats":{"title":"Mitgliedersitze","description":"Jedes Mitglied in Ihrer Organisation z\xe4hlt als Sitz. Die Art der Berechtigungen, die sie haben, kann vom Organisationsadministrator ge\xe4ndert werden.","stats":"Sitzpl\xe4tze von {{value}}","max":"Max Sitzpl\xe4tze","current":"Aktuelle Sitze","limit":{"title":"Maximale Anzahl an Sitzpl\xe4tzen erreicht","description":"Ihr aktueller Plan hat sein Limit von {{ maxSeats }} verf\xfcgbaren Pl\xe4tzen erreicht. Sie k\xf6nnen keine weiteren Mitglieder einladen. Wenden Sie sich bitte an Ihren Administrator, um den Plan zu aktualisieren oder Ihre Sitzplatzzuteilung zu verwalten."},"updateLimit":{"title":"Aktualisieren Sie Ihren Plan, um weitere Pl\xe4tze hinzuzuf\xfcgen","description":"Ihr aktueller Plan hat die maximale Anzahl an Sitzpl\xe4tzen erreicht: {{ maxSeats }}. F\xfchren Sie jetzt ein Upgrade durch, um zus\xe4tzliche Sitzpl\xe4tze freizuschalten und sicherzustellen, dass Ihr Team nahtlos weiter wachsen kann.","action":"Upgrade-Plan"},"maxSeatValue":"Max. Sitzpl\xe4tze: {{value}}"},"aboutMe":"\xdcber mich","loadError":"Fehler beim Laden der Organisationsmitglieder.","orgTitle":"Mitglieder von {{value}}","emailExists":"In der Organisation ist bereits eine E-Mail-Adresse vorhanden. Bitte geben Sie eine andere E-Mail-Adresse ein."},"invite":{"title":"Einladen","titlePlural":"Einladungen","description":"Benutzer erhalten Einladungen, Ihrer Organisation beizutreten. Sie k\xf6nnen Benutzer einladen, Ihrer Organisation beizutreten und ihnen verschiedene Rollen zuweisen.","edit":"Mitglied hinzuf\xfcgen","view":"Alle Einladungen anzeigen","viewDescription":"Alle aktuellen Einladungen anzeigen, die nicht angenommen wurden.","new":"Ein Mitglied einladen","emailRequired":"E-Mail ist erforderlich","emailInvalid":"E-Mail ist ung\xfcltig. Bitte geben Sie eine g\xfcltige E-Mail-Adresse ein.","emailExists":"E-Mail wurde bereits zu einer organisation eingeladen. Bitte geben Sie eine andere E-Mail-Adresse ein.","emailPlaceholder":"E-Mail-Adresse eingeben","expiration":"L\xe4uft ab","delete":"Einladung l\xf6schen","confirm":"M\xf6chten Sie diese Einladung wirklich entfernen?","confirmLong":"Sobald Sie diese Einladung l\xf6schen, kann der Benutzer der Organisation nicht mehr beitreten. Sie k\xf6nnen ihn sp\xe4ter jederzeit erneut einladen.","accept":"Einladung annehmen","stat":"aktive Einladungen","noInvites":{"title":"Keine Einladungen.","description":"Es sieht so aus, als ob es f\xfcr Ihre Organisation keine aktiven Einladungen gibt."},"acceptSuccess":{"title":"Willkommen im Team.","description":"Sie sind der Organisation erfolgreich beigetreten.","action":"Zeigen Sie Ihre neue Organisation an"},"acceptError":{"title":"Hoppla. Da liegt offenbar ein Problem vor.","description":"Beim Beitritt zur Organisation ist ein Fehler aufgetreten. Bitte versuchen Sie es sp\xe4ter erneut. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an den Administrator Ihrer Organisation.","action":"Zur\xfcck zur Homepage"},"send":{"success":"Einladung an {{value}} gesendet.","error":"Fehler beim Senden der Einladung an {{value}}.","title":"Einladung senden"},"error":"Fehler beim Laden der Einladungen.","orgTitle":"Einladungen von {{value}}","editDescription":"Erstellen Sie eine neue Einladung f\xfcr einen Benutzer, Ihrer Organisation beizutreten."},"role":{"title":"Rolle","titlePlural":"Rollen","description":"Rollen sind die verschiedenen Zugriffsebenen, die ein Benutzer in Ihrer Organisation haben kann. Sie k\xf6nnen Benutzern verschiedene Rollen zuweisen, um zu steuern, was sie tun k\xf6nnen."},"isAdmin":{"title":"Verwaltung","description":"Administratoren haben vollen Zugriff auf die Organisation und k\xf6nnen alle Aspekte der Organisation verwalten.","conflict":"Dieses Mitglied ist ein Administrator. Sie sind nicht berechtigt, seine Rollen zu bearbeiten."},"canViewMembers":{"title":"Mitglieder anzeigen","description":"Benutzer mit dieser Berechtigung k\xf6nnen alle Mitglieder der Organisation anzeigen."},"canInviteMembers":{"title":"Mitglieder einladen","description":"Benutzer mit dieser Berechtigung k\xf6nnen neue Mitglieder zur Organisation einladen und bestehende Einladungen verwalten."},"canChangeMemberPermissions":{"title":"Mitgliederrollen \xe4ndern","description":"Benutzer mit dieser Berechtigung k\xf6nnen die Rolle anderer Mitglieder in der Organisation \xe4ndern."},"canRemoveMembers":{"title":"Mitglieder entfernen","titleSingle":"Mitglied entfernen","action":"Entfernen","description":"Benutzer mit dieser Berechtigung k\xf6nnen andere Mitglieder aus der Organisation entfernen.","confirm":"M\xf6chten Sie dieses Mitglied wirklich aus der Organisation entfernen?","confirmLong":"Sobald Sie dieses Mitglied entfernen, hat es keinen Zugriff mehr auf die Organisation. Sie k\xf6nnen es sp\xe4ter jederzeit erneut einladen."},"canCreateAuthClients":{"title":"Projekte erstellen","description":"Benutzer mit dieser Berechtigung k\xf6nnen neue Authentifizierungsclients und -projekte f\xfcr die Organisation erstellen."},"canManageBilling":{"title":"Abrechnung verwalten","description":"Benutzer mit dieser Berechtigung k\xf6nnen die Abrechnungseinstellungen f\xfcr die Organisation verwalten.","error":"Sie sind nicht berechtigt, die Abrechnung f\xfcr diese Organisation zu verwalten."},"metrics":{"title":"Metriken","description":"Metriken sind Datenpunkte, die Ihnen helfen zu verstehen, wie Ihre Organisation Cephable verwendet.","view":"Metriken anzeigen","lineChart":{"title":"Durchschnittliche Anzahl gleichzeitiger Verbindungen","description":"Dieses Diagramm zeigt die durchschnittliche Anzahl gleichzeitiger Verbindungen f\xfcr die Organisations- und Projektdaten im Zeitverlauf.","max":"Max. Verbindungen: {{maxConnections}}","project":"Projektgesamt","org":"Organisation Gesamt"},"orgTitle":"Metriken f\xfcr {{value}}","manage":{"title":"Leistungsmetriken","description":"Laden Sie die w\xe4hrend der Modellinferenz erfassten Leistungsmetriken herunter oder l\xf6schen Sie sie."},"download":{"button":"Metriken herunterladen","success":"Die Metrikdatei wurde in Ihrem Download-Ordner gespeichert.","error":"Das Herunterladen der Metrikdatei ist fehlgeschlagen.","noFile":"Keine Metrikdatei gefunden. Versuchen Sie zun\xe4chst, das Modell auszuf\xfchren."},"clear":{"button":"Klare Metriken","success":"Die Metriken wurden gel\xf6scht.","error":"Das L\xf6schen der Metrikdatei ist fehlgeschlagen.","confirm":{"title":"Klare Leistungsmetriken","description":"M\xf6chten Sie wirklich alle aufgezeichneten Leistungsmesswerte l\xf6schen? Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden.","cancel":"Stornieren","confirm":"Klare Metriken"}}},"projects":{"title":"Projekte","description":"Verwenden Sie Projekte, um den sicheren Zugriff zu verwalten, Ger\xe4teinteraktionen zu konfigurieren und die Art und Weise zu optimieren, wie Ihre Apps plattform\xfcbergreifend Befehle senden und empfangen.","name":"App-Name","view":"Projekte anzeigen","error":"Fehler beim Laden der Projekte.","stats":{"title":"Projektstatistiken","connections":"Verbindungen insgesamt","all":{"title":"Alle Projektmetriken","description":"Aggregierte Metriken f\xfcr alle mit {{ orgName }} verkn\xfcpften Projekte"},"card":"Projekte von {{value}}","users":"Gesamtnutzerzahl seit {{date}}","avgUsers":"Durchschnittliche monatliche Benutzerzahl.","concurrent":{"title":"Durchschnittliche Anzahl gleichzeitiger Verbindungen in den letzten {{days}} Tagen","label":"Gleichzeitiger Durchschn","max":"Max. Verbindungen","overage":"\xdcberschuss","description":"Gleichzeitige Verbindungen geben die Anzahl der Benutzer an, die gleichzeitig mit Ihrem Projekt verbunden sind. Diese Kennzahl hilft Ihnen zu verstehen, wie viele Benutzer Ihre App gleichzeitig verwenden."}},"projectType":{"title":"Projekttyp","description":"Projekttypen werden verwendet, um Ihre Projekte zu kategorisieren und uns dabei zu helfen, die richtigen SDKs f\xfcr Sie auszuw\xe4hlen."},"accessDenied":{"generic":"Sie haben keinen Zugriff auf dieses Projekt.","title":"Zugriff verweigert.","description":"Sie haben keinen Zugriff zum Anzeigen, Erstellen, Bearbeiten oder L\xf6schen von Projekten. Wenden Sie sich f\xfcr den Zugriff bitte an Ihren Administrator."},"upgrade":{"title":"Upgrade auf Cephable SDK","description":"Cephable kann mithilfe unserer SDKs direkt in Ihre App, Ihr Spiel oder Ihren Dienst integriert werden. Projekte sind derzeit mit Ihrem Konto nicht verf\xfcgbar. Wenn Sie glauben, dass ein Fehler vorliegt, wenden Sie sich bitte an support@cephable.com.","shortDescription":"Projekte sind f\xfcr Ihr Konto derzeit nicht verf\xfcgbar. Wenden Sie sich an uns, um ein Upgrade durchzuf\xfchren."},"limit":{"title":"Lust auf mehr Projekte?","error":"Projektlimit erreicht.","description":"Sie haben die maximale Anzahl an Projekten f\xfcr Ihre Organisation erreicht. Wenden Sie sich bitte an Ihren Administrator, um Ihr Konto zu aktualisieren."},"create":{"title":"Projekt erstellen","titleLong":"Lasst uns anfangen.","first":{"title":"Beginnen Sie mit Ihrem Projekt.","description":"Es sieht so aus, als h\xe4tten Sie noch kein Projekt erstellt. Client-Schl\xfcssel und -Ger\xe4te sind f\xfcr die sichere Kommunikation zwischen Ihren Anwendungen und unseren Diensten unerl\xe4sslich. Mit einem Client-Schl\xfcssel k\xf6nnen Sie Sprach- und Kopfbewegungssteuerungen schnell und sicher in Ihre Apps integrieren."},"details":{"title":"Projektdetails","description":"Erstellen Sie ein neues Projekt, um die Autorisierung, Ger\xe4tefunktionen und SDK-Integrationen Ihrer Anwendung zu verwalten. Befolgen Sie die folgenden Schritte, um sichere, anpassbare Interaktionen f\xfcr Ihre Benutzer einzurichten."}},"sdk":{"title":"Laden Sie das SDK herunter","description":"Erhalten Sie Zugriff auf unser leistungsstarkes SDK, das entwickelt wurde, um adaptive Steuerungen zu vereinfachen.","select":{"title":"SDK ausw\xe4hlen","description":"W\xe4hlen Sie das SDK aus, das Sie f\xfcr dieses Projekt verwenden m\xf6chten. Unsere SDKs erm\xf6glichen die nahtlose Integration adaptiver Sprach- und Kopfbewegungssteuerungen \xfcber verschiedene Plattformen hinweg."}},"clients":{"title":"Autorisierungsclients","configure":"Autorisierungsclient konfigurieren","description":"Autorisierungsclients verwalten den sicheren Zugriff auf Ihre Anwendungen. Definieren Sie einen Autorisierungsclient, um Benutzer zu authentifizieren und Interaktionen mit Ihrer Anwendung zu steuern.","settings":"Autorisierungseinstellungen","create":"Autorisierungsclient erstellen","max":"Max. Projekte: {{value}}"},"secret":{"title":"Client-Geheimnis","created":"Ihr Client-Geheimnis wurde erstellt.","description":"Ihr Client-Geheimnis wird nur einmal angezeigt. Kopieren Sie es jetzt und bewahren Sie es an einem sicheren Ort auf.<br><br> Verwenden Sie es nur f\xfcr Ihre eigene Entwicklung. Geben Sie es nicht an Dienste oder Anwendungen von Drittanbietern weiter.","copy":"Geheimen Schl\xfcssel kopieren","rotate":{"title":"Rotieren des Client-Geheimnisses","description":"ACHTUNG: Diese Aktion widerruft Ihr bestehendes Client-Geheimnis und erstellt ein neues Client-Geheimnis. Dazu m\xfcssen Sie Ihre gesamte bestehende Nutzung in Ihren Apps aktualisieren. Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden.","error":"Fehler beim Rotieren des Geheimnisses. Bitte versuchen Sie es sp\xe4ter noch einmal."}},"key":{"title":"Client-Schl\xfcssel","view":"Clientschl\xfcssel anzeigen","copy":"Schl\xfcssel kopieren","delete":{"title":"Clientschl\xfcssel l\xf6schen","description":"WARNUNG: Diese Aktion entfernt Ihren vorhandenen Clientschl\xfcssel und alle zugeh\xf6rigen Einstellungen. Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden.","error":"Fehler beim L\xf6schen Ihres Client-Schl\xfcssels.","success":"Ihr Projekt wurde gel\xf6scht."}},"tokenRedirect":{"title":"Token-Umleitungs-URLs","description":"Token-Umleitungs-URLs sind die Endpunkte, an die nach Abschluss der Authentifizierung Zugriffstoken gesendet werden. Mit diesen URLs kann Ihre Anwendung sicher Token empfangen, die f\xfcr den Zugriff auf Benutzerdaten und -dienste erforderlich sind."},"authRedirect":{"title":"Autorisierungscode-Umleitungs-URLs","description":"Die AuthCode-Umleitungs-URL ist der Endpunkt, an den Autorisierungscodes gesendet werden, nachdem ein Benutzer Ihrer Anwendung die Berechtigung erteilt hat. Diese URL ist in OAuth-Flows von entscheidender Bedeutung, da sie die sichere \xdcbertragung des Autorisierungscodes vom Autorisierungsserver an Ihre App gew\xe4hrleistet und es Ihnen erm\xf6glicht, Zugriffstoken im Namen des Benutzers anzufordern."},"scopes":{"title":"Bereiche","configure":"Bereiche definieren","titleLong":"API-Berechtigungsbereiche","description":"Bereiche definieren die Berechtigungen, die dieser Autorisierungsclient haben wird. Legen Sie Bereiche fest, um den Zugriff auf bestimmte Daten und Funktionen zu beschr\xe4nken und sicherzustellen, dass Benutzer nur den Zugriff erhalten, den sie ben\xf6tigen.","manage":"Verwalten von Autorisierungsbereichen"},"type":{"title":"Implementierungstyp"},"deviceScopes":{"title":"Zugeh\xf6rige Ger\xe4tetypen","titleLong":"Erlaubte Ger\xe4tetypen","configure":"Zul\xe4ssige Ger\xe4tetypen konfigurieren","action":"Neuen Ger\xe4tetyp hinzuf\xfcgen","descriptionShort":"Definieren Sie, welche Ger\xe4tetypen auf dieses Projekt zugreifen k\xf6nnen.","titles":"Zugeh\xf6rige Ger\xe4tetypen","description":"Der Ger\xe4tetyp definiert die Berechtigungen und Zugriffsebenen, die ein Ger\xe4t innerhalb Ihrer Anwendung hat. Durch die Zuweisung bestimmter Ger\xe4tetypen k\xf6nnen Sie die Aktionen und Daten steuern, auf die jedes Ger\xe4t zugreifen kann. So stellen Sie sicher, dass Ihre Anwendung sicher bleibt und Ihren Datenschutzrichtlinien entspricht."},"deviceType":{"title":"Ger\xe4tetypen","description":"Ein DeviceType definiert eine Ger\xe4tekategorie und beschreibt detailliert ihre Eingabe-/Ausgabefunktionen und unterst\xfctzten Funktionen (z. B. Sprache, Gesten, Controllertypen). Es stellt sicher, dass nur autorisierte Ger\xe4te mit einer Anwendung interagieren k\xf6nnen.","action":"Ger\xe4tetyp erstellen","name":"Ger\xe4tetypname","descriptionLong":"Ger\xe4tetyp Beschreibung","features":{"title":"Unterst\xfctzt Funktionen","description":"Definieren Sie die Ein- und Ausgaben, die Ihre App unterst\xfctzt. Dies hilft uns, das Benutzererlebnis auf Cephable zu optimieren.","supportsVoiceInput":"Spracheingabe","supportsPhysicalInput":"Physischer Eingang","supportsKeyboardOutput":"Tastaturausgabe","supportsPlayStationControllerOutput":"PlayStation-Controller","supportsFaceInput":"Gesichtseingabe","supportsGestureInput":"Gesteneingabe","supportsXboxControllerOutput":"Xbox-Controller","supportsDigitalExtensions":"Digitale Erweiterungen","supportsPhysicalExtensions":"Physische Erweiterungen","supportsNintendoControllerOutput":"Nintendo-Controller","supportsGenericControllerOutput":"Allgemeiner Controller-Ausgang"},"canAutoStart":{"title":"Unterst\xfctzt automatische Steuerungsstarts","description":"[canAutoStart] Wenn aktiviert, \xfcberpr\xfcfen SDKs die Benutzereinstellungen und versuchen, die Kamera- oder Mikrofonsteuerung sofort nach der Benutzeranmeldung zu starten."},"isSupported":{"title":"Aktiv","description":"[isSupported] Wenn deaktiviert, sendet, empf\xe4ngt oder best\xe4tigt Cephable keine damit verbundenen Benutzerger\xe4te mehr. Entspricht veraltet."},"locale":{"title":"Standardsprache","description":"[defaultLocale] Das Standardgebietsschema f\xfcr diesen Ger\xe4tetyp. Dies wird als Standardsprache f\xfcr das Ger\xe4t verwendet.","support":"Unterst\xfctzt Sprachen","warn":"** Es sieht so aus, als ob Sie benutzerdefinierte Steuerelemente eingerichtet haben. Bitte stellen Sie sicher, dass Sie die benutzerdefinierten Steuerelemente f\xfcr die zugeh\xf6rigen Sprachen aktualisiert haben.**","name":"{{lang}} \u2013 Ger\xe4tetypname","langDescription":"{{lang}} - Beschreibung"},"customControls":{"title":"Benutzerdefinierte Steuerelemente","object":"{{lang}} \u2013 Benutzerdefiniertes Steuerelementobjekt","description":"Benutzerdefinierte Steuerelemente sind eine erweiterte Option, mit der Benutzer die mit diesem Ger\xe4t verkn\xfcpften App-Steuerelemente manuell einrichten und bearbeiten k\xf6nnen. Wenn Sie m\xf6chten, dass Benutzer Ihr Ger\xe4t direkt von Cephable aus steuern, m\xfcssen Sie Ihre Ger\xe4testeuerelemente hier registrieren. Ausf\xfchrliche Informationen zu den Optionen finden Sie in der Cephable-API."},"success":{"title":"Erfolg!","description":"Sie haben einen neuen Ger\xe4tetyp erstellt. {{name}} Sie k\xf6nnen jetzt den Umfang Ihres Autorisierungsclientger\xe4ts nach Bedarf aktualisieren."},"id":"Ger\xe4tetyp-ID","throttleRules":{"title":"Regeln f\xfcr die Gassteuerung","description":"Konfigurieren Sie Drosselungsregeln, um den Befehlsfluss und die Eingabebeschr\xe4nkungen f\xfcr diesen Ger\xe4tetyp zu steuern.","disableVoiceInput":"Spracheingabe deaktivieren","disableHotkeyInput":"Hotkey-Eingabe deaktivieren","disableCameraInput":"Kameraeingang deaktivieren","disableMultiInputs":"Mehrere Eing\xe4nge deaktivieren","maximumCommandsPerSecond":"Maximale Befehle pro Sekunde","maximumCommandsPerMinute":"Maximale Befehle pro Minute","maximumMacroLength":"Maximale Makrol\xe4nge"}},"originHost":{"title":"Ursprungshost","description":"Die URL, die bei API-Interaktionen als prim\xe4re Quelle f\xfcr Anfragen und Daten dient."},"orgTitle":"Projekte von {{value}}"},"viewOrganization":"Organisation Anzeigen","update":"Ihre Organisation wurde aktualisiert! Die App wird aktualisiert.","error":"Fehler beim Laden der Organisation. Bitte versuchen Sie es sp\xe4ter erneut.","new":{"name":{"label":"Name der Organisation","placeholder":"Geben Sie den Namen Ihrer Organisation ein"},"description":{"label":"Beschreibung der Organisation","placeholder":"Was sind Ihre Ziele mit der Verwendung von Cephable Professional?"},"details":"Details zur Organisation"},"expired":{"user":"Ihre Cephable-Lizenz ist anscheinend abgelaufen, daher wurden Sie auf die kostenlose Cephable Basic-Version herabgestuft. Um Ihre Lizenz zu verl\xe4ngern, wenden Sie sich bitte an Ihren Organisationsadministrator.","admin":"Ihre Cephable-Lizenz ist anscheinend abgelaufen, daher wurden Sie auf die kostenlose Cephable Basic-Version zur\xfcckgestuft. Bitte verl\xe4ngern Sie Ihre Lizenz, um weiterhin die erweiterten Funktionen nutzen zu k\xf6nnen.","multiple":"Ihre Cephable-Lizenzen sind anscheinend abgelaufen, daher wurden Sie auf die kostenlose Cephable Basic-Version zur\xfcckgestuft. Bitte verl\xe4ngern Sie mindestens eine Ihrer Lizenzen, um weiterhin die erweiterten Funktionen \xfcber Cephable Basic hinaus nutzen zu k\xf6nnen.","dialog":{"title":"W\xe4hlen Sie eine Organisation aus","description":"Ihrem Konto sind mehrere Organisationen zugeordnet. W\xe4hlen Sie bitte die Organisation aus, deren Abonnement Sie verl\xe4ngern m\xf6chten."},"title":"Ihre Cephable-Lizenz ist abgelaufen","titlePlural":"Ihre Cephable-Lizenzen sind abgelaufen","banner":"Ihre Cephable-Lizenz ist abgelaufen, daher wurden Sie auf die kostenlose Cephable Basic-Version zur\xfcckgestuft. Mit einer Verl\xe4ngerung erhalten Sie Zugriff auf Funktionen wie erweiterte Sprachsteuerung, KI-gest\xfctzte Aufgaben und viele vordefinierte App-Steuerelemente."},"orgName":"Name der Organisation","menu":{"title":"Organisationsmen\xfc","view":"Men\xfc anzeigen","expand":"Men\xfc erweitern"},"settings":{"title":"Organisationseinstellungen","description":"Verwalten Sie die Abrechnung, den Namen, die Beschreibung und die Ressourcen Ihrer Organisation.","view":"Einstellungen anzeigen","general":{"title":"Allgemein"},"resources":{"edit":"Ressourcen bearbeiten","description":"Verwenden Sie den Markdown-Editor auf der linken Seite, um hilfreiche Ressourcen f\xfcr alle Mitglieder der Organisation zu aktualisieren und zu formatieren. W\xe4hrend Sie tippen, zeigt die Vorschau auf der rechten Seite, wie Ihr Inhalt den Benutzern angezeigt wird. Sie k\xf6nnen \xdcberschriften, Listen, Links und andere Formatierungselemente mit Markdown-Syntax hinzuf\xfcgen. \xc4nderungen sind f\xfcr Mitglieder sichtbar, sobald sie gespeichert wurden."},"other":{"title":"Andere Einstellungen","description":"Verwalten Sie die Abrechnung, den Namen, die Beschreibung und die Ressourcen Ihrer Organisation."}},"managed":{"title":"Verwaltete Organisation","titlePlural":"Verwaltete Organisationen","description":"Verwaltete Organisationen sind Organisationen, die von einem Cephable-Wiederverk\xe4ufer verwaltet werden. Wiederverk\xe4ufer k\xf6nnen hier Ihr Team, Teamprofile, Abrechnung und mehr verwalten.","error":"Fehler beim Laden verwalteter Organisationen.","empty":{"title":"Keine verwalteten Organisationen gefunden.","description":"Es sieht nicht so aus, als ob es verwaltete Organisationen gibt, die diesen Kriterien entsprechen. Oder Ihre Lizenzschl\xfcssel wurden noch nicht aktiviert."},"titleShort":"Verwaltet"},"canManageChildOrganizations":{"title":"Untergeordnete Organisationen verwalten","description":"Benutzer mit dieser Berechtigung k\xf6nnen als Administrator untergeordnete Organisationen erstellen und verwalten."},"canViewAnalytics":{"title":"Analytics anzeigen","description":"Benutzer mit dieser Berechtigung k\xf6nnen die Metriken und Analysen f\xfcr die Organisation anzeigen."},"create":"Neue Organisation erstellen","orgCustomBillingUrl":{"title":"Benutzerdefinierte Abrechnungs-URL","description":"Dies ist eine benutzerdefinierte URL, die verwendet wird, um den Benutzer zu Ihrem (dem Abrechnungssystem des Wiederverk\xe4ufers) umzuleiten. Sollte mit \u201Ehttps://\u201C oder \u201EmailTo:\u201C beginnen."},"upgrade":{"existing":{"title":"Sie sind Teil einer bestehenden Lizenz.","description":"Bitte f\xfchren Sie ein Upgrade durch, indem Sie im Seitenmen\xfc auf \u201E{{action}}\u201C klicken."}},"restrictions":{"isGenAIDisabled":{"title":"Generative KI deaktiviert","description":"Ihre Organisation hat den Zugriff auf Generative AI-Funktionen deaktiviert. Weitere Informationen erhalten Sie von Ihrem Organisationsadministrator."},"isRemoteControlDisabled":{"title":"Ger\xe4te\xfcbergreifende Synchronisierung deaktiviert","description":"Ihre Organisation hat den Zugriff auf die Synchronisierung deaktiviert. Sie k\xf6nnen unsere Begleit-App nicht verwenden und keine externen Ger\xe4te steuern. Weitere Informationen erhalten Sie von Ihrem Organisationsadministrator."}},"troubleshooting":{"title":"Fehlerbehebung","editorDescription":"[Optional] Dieser Abschnitt ist f\xfcr alle Benutzer \xfcber die Seite mit den Verbindungsdetails sowohl in der mobilen als auch in der Desktop-App von Cephable sichtbar.","description":"Falls Sie Probleme mit Cephable haben, versuchen Sie die folgenden Schritte, um h\xe4ufig auftretende Probleme zu beheben."},"onboarding":{"title":"Onboarding","editorDescription":"[Optional] Nutzern wird ein Onboarding-Fenster angezeigt, wenn dieser Ger\xe4tetyp ihrem Konto hinzugef\xfcgt wird. Hier k\xf6nnen Sie Anweisungen zur Einrichtung und Verwendung des Ger\xe4tetyps mit Ihrer Anwendung bereitstellen."},"documents":"Unterlagen","completionStatus":{"title":"Abschlussstatus","error":"","complete":"Vollst\xe4ndig.","incomplete":"Unvollst\xe4ndig."},"metadata":{"title":"Metadaten","urlError":"Die URL muss mit http:// oder https:// beginnen.","metatitle":{"label":"Meta-Titel","placeholder":"Geben Sie einen Kurztitel ein"},"shortDescription":{"label":"Kurzbeschreibung","placeholder":"Geben Sie eine kurze Vorschaubeschreibung ein (maximal 150 Zeichen)."},"externalLink":{"label":"Externer Link","placeholder":"https://example.com/device-info","description":"Ein direkter Link zu einer externen Website oder Ressource mit weiteren Informationen zur Ersteinrichtung dieses Ger\xe4ts. Wenn Sie diesen Link verwenden, verzichten wir auf die Verwendung des Markdown-Formats f\xfcr die Kundenliste."},"iconUrl":{"label":"URL des Ger\xe4tesymbols","placeholder":"https://example.com/device-icon.png","description":"Ein direkter Link zu einem Bild, das diesen Ger\xe4tetyp darstellt. Dieses Symbol wird in der Cephable-App und in Ger\xe4telisten angezeigt."},"darkModeIconUrl":{"label":"URL des Symbols f\xfcr Ger\xe4te im Dunkelmodus","placeholder":"https://example.com/device-icon-dark.png","description":"Ein direkter Link zu einem Bild, das diesen Ger\xe4tetyp im Dunkelmodus darstellt. Dieses Symbol wird in der Cephable-App und in Ger\xe4telisten angezeigt, wenn der Nutzer den Dunkelmodus aktiviert hat."},"editorDescription":"Wenn Ihr Ger\xe4t in der Cephable-App als Erweiterung oder Verbindung ausgew\xe4hlt wird, verwenden wir diese Informationen, um sie Benutzern anzuzeigen, die neue Verbindungen einrichten."},"client-listing":{"title":"Kundenliste","editorDescription":"Detaillierte Anweisungen f\xfcr neue Benutzer zum Einrichten von Verbindungen mit diesem Ger\xe4tetyp. Dieser Markdown-Inhalt wird in der Cephable-App angezeigt, wenn Benutzer eine neue Verbindung hinzuf\xfcgen."},"canAccessOrganizationProfiles":{"title":"Steuerelemente der Organisations-App anzeigen","description":"Benutzer mit dieser Berechtigung k\xf6nnen die mit dieser Organisation verkn\xfcpften Organisations-App-Steuerelemente anzeigen."},"canEditOrganizationProfiles":{"title":"Verwaltung der App-Steuerelemente der Organisation","description":"Benutzer mit dieser Berechtigung k\xf6nnen Organisations-App-Steuerelemente erstellen, bearbeiten und l\xf6schen, die dieser Organisation zugeordnet sind."},"profiles":{"title":"Steuerelemente der Organisations-App","description":"Organisations-App-Steuerelemente sind gemeinsam genutzte Profile, mit denen Sie App-Steuerelemente innerhalb Ihrer Organisation verteilen oder mit Ihren Integrationsbenutzern teilen k\xf6nnen.","view":"Steuerelemente der Organisations-App anzeigen","editDescription":"Bearbeiten Sie die Steuerelemente der Organisations-App, um die Einstellungen anzupassen.","empty":"Es wurden keine Steuerelemente f\xfcr Organisations-Apps gefunden. Erstellen Sie eine, um loszulegen.","error":"Fehler beim Laden der Steuerelemente der Organisations-App.","titleShort":"App-Steuerelemente"},"canViewAuthClients":{"title":"Projekte ansehen","description":"Benutzer mit dieser Berechtigung k\xf6nnen Authentifizierungsclients und Projekte f\xfcr die Organisation anzeigen."}},"developer":{"title":"Entwickler","titleLong":"Entwicklerressourcen","description":"Cephable kann mit unseren SDKs direkt in Ihre App, Ihr Spiel oder Ihren Dienst integriert werden.","sdk":{"title":"Entdecken Sie unsere SDKs","description":"Wir bieten erstklassige SDKs, die Spracherkennung und adaptive Steuerungen nahtlos in Ihre Anwendungen integrieren. Unsere Tools sind darauf ausgelegt, die Benutzerinteraktion durch intuitive Steuerungen zu verbessern und die Zug\xe4nglichkeit zu f\xf6rdern, sodass Ihre Software von allen Benutzern effektiver bedient werden kann.","javascript":{"title":"JavaScript","subtitle":"Netz","description":"Integrieren Sie Sprach- und adaptive Steuerelemente direkt in Ihre Webanwendungen.","action":"NPM-Paket abrufen"},"net":{"title":".NET","subtitle":"Windows-Anwendungen","description":"Nutzen Sie die Leistungsf\xe4higkeit von .NET, um mit unseren WPF- und WinUI3-SDKs Anwendungen zu erstellen.","actionCore":"Holen Sie sich das Core-Paket","actionWpf":"WPF-Paket Abrufen"},"android":{"title":"Android","subtitle":"Mobile Ger\xe4te","description":"Android-Anwendungen zur Unterst\xfctzung von Sprach- und Kopfbewegungsfunktionen.","action":"Android SDK holen"},"more":{"title":"Mehr","description":"Sie finden nicht, was Sie brauchen? Kontaktieren Sie uns und wir helfen Ihnen.","action":"Fordern Sie ein SDK an"}},"demo":{"title":"Demos","titleLong":"Erleben Sie unsere SDKs in Aktion","description":"Entdecken Sie die Leistungsf\xe4higkeit unserer Technologien zur Sprach- und Kopfbewegungssteuerung anhand unserer Beispielanwendungen. Von interaktiven Spielen bis hin zu dynamischen Web- und Mobil-Apps demonstriert jedes Beispiel die Vielseitigkeit und Effektivit\xe4t unserer SDKs. Sehen Sie sich diese Beispiele an, um Erkenntnisse und Inspirationen f\xfcr die Integration verbesserter Zug\xe4nglichkeit und immersiver Erlebnisse in Ihre eigenen Projekte zu gewinnen.","game":{"title":"2048 Spiel","subtitle":"Netz","description":"Verbessern Sie das traditionelle Gameplay mit adaptiver Sprach- und Kopfbewegungssteuerung.","action":"Spielen Sie das Spiel"},"unity":{"title":"Einheit","subtitle":"Spieleentwicklung","description":"Erfahren Sie, wie adaptive Steuerelemente beim Spielen genutzt werden k\xf6nnen, um eine ansprechendere UX bereitzustellen.","action":"Beispiel abrufen"},"samples":"Demos und Beispiele","other":{"title":"Andere Demos","description":"Erleben Sie aus erster Hand, wie Cephable Ihre Anwendung, Ihr Spiel oder Ihr Ger\xe4t verbessern kann.","action":"Weitere Demos anzeigen"},"web":{"title":"Web-SDK-Beispiele","subtitle":"Netz","description":"Unkomplizierte Integration aller unserer Kernfunktionen in Webanwendungen.","action":"Erleben Sie das SDK"}},"other":{"title":"Andere Ressourcen","description":"Wenn Sie in unseren SDKs nicht finden, was Sie brauchen, versuchen Sie, direkt mit unseren APIs zu arbeiten, oder wenden Sie sich f\xfcr Hilfe, Inspiration und Unterst\xfctzung an die Community.","api":{"title":"API","description":"Unsere APIs erm\xf6glichen Ihnen die direkte Interaktion mit Cephable. Sie k\xf6nnen unsere APIs verwenden, um benutzerdefinierte Integrationen zu erstellen."},"support":{"title":"Unterst\xfctzung","description":"Sie finden nicht, was Sie brauchen? Kontaktieren Sie unsere Community \xfcber Discord.","action":"Treten Sie Discord bei"}}},"customControls":{"title":"Globale und Ger\xe4testeuerung","prefixDisclaimer":"Dies ist eine Pr\xe4fixsteuerung. Sie \xfcberwacht die W\xf6rter nach dem Befehl und sucht dann in der folgenden Phrase nach \xdcbereinstimmungen.","allowPausedDisclaimer":"Diese Steuerung funktioniert auch, wenn das Mikrofon angehalten ist.","resetControls":{"title":"Steuerelemente zur\xfccksetzen","description":"Ihre Sprachsprache hat sich seit der letzten Aktualisierung Ihrer Steuerung ge\xe4ndert. Hinweis: Dadurch werden Ihre Steuerelemente auf {{language}} zur\xfcckgesetzt und Sie verlieren m\xf6glicherweise alle benutzerdefinierten Befehle. M\xf6chten Sie wirklich zur\xfccksetzen?","confirm":"Ja, Bedienelemente zur\xfccksetzen","error":"Beim Zur\xfccksetzen Ihrer Steuerung ist ein Fehler aufgetreten. Bitte versuchen Sie es sp\xe4ter erneut."},"conflictIndicators":{"warn":"Achtung:","title":"Eingabekonfigurationskonflikte erkannt","globalControls":"Konflikte bei der globalen Steuerungskonfiguration","deviceControls":"Konfigurationskonflikte bei der Ger\xe4testeuerung","usedInput":"dient als Input f\xfcr","description":"Einige der Eingaben f\xfcr Ihre globalen und Ger\xe4testeuerungen werden auch in einer oder mehreren Ihrer App-Steuerungen verwendet. Dies kann bei der Verwendung von Cephable zu Konflikten f\xfchren. In diesem Fall geben wir der App-Steuerung stets den Vorzug vor der globalen oder Ger\xe4testeuerung.","item":"Die Eingabe <strong>{{value}}</strong> wird in Ihren App-Steuerelementen verwendet: ","globalDescription":"Die folgenden globalen Steuerelemente weisen Eingabekonflikte mit den Steuerelementen Ihrer App auf.","deviceDescription":"Bei den folgenden Ger\xe4testeuerungen treten Eingabekonflikte mit Ihren App-Steuerelementen auf."},"globalControls":{"title":"Globale Steuerelemente","empty":"Sie haben noch keine globalen Steuerelemente. Klicken Sie unten, um eines zu erstellen.","edit":"Globale Steuerelemente bearbeiten","description":"Globale Steuerelemente sind immer verf\xfcgbar, unabh\xe4ngig von der verwendeten App oder dem verwendeten Ger\xe4t. Einige funktionieren sogar, wenn die Mikrofon- oder Kamerasteuerung pausiert ist."},"deviceControls":{"title":"Ger\xe4testeuerung","empty":"Sie haben noch keine Ger\xe4testeuerung. Klicken Sie unten, um eine zu erstellen.","edit":"Ger\xe4testeuerung bearbeiten","controls":{"cephable-open-app":{"success":"App \xf6ffnen: {{value}}","error":"App nicht gefunden: {{value}}"},"cephable-close-app":{"commands":["schlie\xdfen"],"name":"App nach Namen schlie\xdfen","description":"Verwenden Sie diesen Befehl mit Sprachsteuerung, um eine App auf Ihrem Computer \xfcber ihren Namen zu schlie\xdfen.","success":"App schlie\xdfen: {{value}}","error":"App nicht gefunden: {{value}}"},"cephable-minimize-focused-app":{"commands":["minimieren"],"name":"Minimieren Sie die aktuell fokussierte App.","description":"Verwenden Sie diesen Befehl mit Sprachsteuerung, um die aktuell fokussierte App zu minimieren.","success":"Minimieren Sie den Erfolg fokussierter Apps!","error":"Fehler beim Minimieren der fokussierten App."},"cephable-maximize-focused-app":{"commands":["maximieren"],"name":"Maximieren Sie die aktuell fokussierte App.","description":"Verwenden Sie diesen Befehl mit Sprachsteuerung, um die aktuell fokussierte App zu maximieren.","success":"Maximieren Sie den gezielten App-Erfolg!","error":"Fehler beim Minimieren der fokussierten App."},"cephable-generate-text":{"commands":["erzeugen"],"name":"Generieren Sie Text, indem Sie die Eingabeaufforderung nach diesem Befehl bereitstellen.","description":"Verwenden Sie diesen Befehl mit Sprachsteuerung, gefolgt von Ihrer Eingabeaufforderung, um entsprechenden Text zu generieren."},"cephable-stop-generate-text":{"commands":["Stoppen Sie die Generierung","Generierung stoppen","Abbrechen Generieren","Generierung abbrechen"],"name":"Stoppen Sie die Textgenerierung.","description":"Verwenden Sie diesen Befehl mit Sprachsteuerung, um die Textgenerierung zu stoppen"},"cephable-open-panel":{"commands":["Panel anzeigen"],"name":"\xd6ffnen Sie das Cephable-Bedienfeld","description":"Verwenden Sie diesen Befehl mit Sprachsteuerung, um das Cephable-Bedienfeld zu \xf6ffnen."},"cephable-close-panel":{"commands":["Bedienfeld ausblenden"],"name":"Verstecken Sie das Cephable-Panel","description":"Verwenden Sie diesen Befehl mit Sprachsteuerung, um das Cephable-Bedienfeld auszublenden oder zu minimieren."},"cephable-close-focused-app":{"commands":["Strom schlie\xdfen"],"name":"Schlie\xdfen Sie die aktuell fokussierte App.","description":"Verwenden Sie diesen Befehl mit Sprachsteuerung, um die aktuell fokussierte App zu schlie\xdfen.","success":"Aktuelle App erfolgreich geschlossen!","error":"Fehler beim Schlie\xdfen der aktuellen App."},"cephable-rewrite-text":{"commands":["umschreiben"],"name":"Schreiben Sie den Text neu, indem Sie die Eingabeaufforderung nach diesem Befehl bereitstellen.","description":"Verwenden Sie diesen Befehl mit Sprachsteuerung, gefolgt von Ihrer Eingabeaufforderung, um Ihren aktuell markierten Text neu zu schreiben."},"cephable-summarize-text":{"commands":["zusammenfassen"],"name":"Fassen Sie den Text zusammen, indem Sie die Eingabeaufforderung nach diesem Befehl bereitstellen.","description":"Verwenden Sie diesen Befehl mit Sprachsteuerung, gefolgt von Ihrer Eingabeaufforderung, um Ihren aktuell hervorgehobenen Text zusammenzufassen."},"cephable-translate-text":{"commands":["\xfcbersetzen"],"name":"\xdcbersetzen Sie Text, indem Sie die Eingabeaufforderung nach diesem Befehl bereitstellen.","description":"Verwenden Sie diesen Befehl mit Sprachsteuerung, gefolgt von Ihrer Eingabeaufforderung, um Ihren aktuell markierten Text zu \xfcbersetzen."},"cephable-click-by-name":{"commands":["klopfen","Schlag","Navigieren Sie zu","gehe zu"],"name":"Tippen Sie auf Element nach Name","description":"Tippen Sie auf der Seite auf den Namen eines Elements, z. B. \u201ETippen Sie auf Speichern\u201C, um auf eine Schaltfl\xe4che mit dem Namen \u201ESpeichern\u201C zu klicken."}},"description":"Ger\xe4testeuerungen sind an das jeweilige Ger\xe4t oder die Verbindung gebunden, die Sie verwenden. Sie sind verf\xfcgbar, ohne dass Sie sie zu Ihren App-Steuerelementen hinzuf\xfcgen m\xfcssen, und sind besonders n\xfctzlich f\xfcr Funktionen oder Ereignisse, die nur auf bestimmten Ger\xe4ten unterst\xfctzt werden."},"warn":"Das Mikrofon wurde nicht gestartet. Sie m\xfcssen Ihr Mikrofon starten, um globale Steuerelemente und Ger\xe4testeuerungen verwenden zu k\xf6nnen.","changeProfile":{"success":"App-Steuerung \xe4ndern: {{value}}","error":"App-Steuerelemente konnten nicht gefunden werden: \u201E{{value}}\u201C"},"descriptionShort":"Globale und Ger\xe4testeuerungen sind stets verf\xfcgbare Aktionen, die f\xfcr die Nutzung mit jeder Software konzipiert sind. Globale Steuerungen \u2013 wie \u201EKamera stoppen\u201C \u2013 sind systemweit und App-unabh\xe4ngig, w\xe4hrend Ger\xe4testeuerungen auf die jeweilige Ger\xe4teverbindung zugeschnitten sind und erweiterte Funktionen als Standard-App-Steuerungen freischalten.","description":"Globale und Ger\xe4testeuerungen sind jederzeit verf\xfcgbare Aktionen, die f\xfcr die Verwendung mit jeder Software konzipiert sind. Globale Steuerungen \u2013 wie \u201EKamera stoppen\u201C \u2013 gelten systemweit und App-unabh\xe4ngig, w\xe4hrend Ger\xe4testeuerungen auf die jeweilige Ger\xe4teverbindung zugeschnitten sind und erweiterte Funktionen als Standard-App-Steuerungen freischalten. Diese Steuerungen werden derzeit per Sprachsteuerung aufgerufen, zuk\xfcnftig werden wir jedoch auch andere Eingaben unterst\xfctzen.","noDevice":"Dieser Schritt verwendet eine benutzerdefinierte Erweiterung, die Sie noch nicht f\xfcr Ihr Konto konfiguriert haben. F\xfcgen Sie die Erweiterung hinzu, um diesen Schritt freizuschalten."},"notifications":{"title":"Benachrichtigungen","center":"Benachrichtigungscenter","empty":"Sie haben derzeit keine Benachrichtigungen. Versuchen Sie es ein anderes Mal noch einmal.","seen":"Gesehen","markAsRead":"Als gelesen markieren","view":"Alle {{value}}-Benachrichtigungen anzeigen"},"unsaved":{"title":"Sie haben nicht gespeicherte \xc4nderungen.","description":"Sie haben nicht gespeicherte \xc4nderungen. M\xf6chten Sie diese Seite wirklich verlassen?","cancel":"Beenden ohne Speichern","confirm":"Speichern und beenden"},"login":{"welcome":"Willkommen bei Cephable!","subtitle":"Kontrollieren Sie Ihre Technologie nach <strong>Ihren</strong> Bedingungen.","create":"Benutzerkonto erstellen","signIn":"Anmelden","loading":"Weiterleitung zur Anmeldung ...","error":"Bei Ihrer Anmeldung ist ein Fehler aufgetreten. Bitte melden Sie sich erneut an.","existingAccount":"Hast du schon ein Konto?","description":"\xdcbernehmen Sie die volle Kontrolle \xfcber Ihren Computer, Ihre Apps und Spiele mit Cephable \u2013 Ihrer pers\xf6nlichen KI f\xfcr schnelle Aktionen, Sprachbefehle, Gesichtsausdr\xfccke, Gesten, Neigung und mehr. Keine Cloud-Verarbeitung. Nur nahtlose Steuerung, die sich mit Ihnen bewegt."},"home":{"title":"Heim","startControls":"Schalten Sie es ein!","manage":"Konfigurieren","profileGenerate":{"title":"Ups. Sieht so aus, als ob Sie noch keine App-Steuerelemente haben.","description":"Damit Cephable Ihren Computer steuern kann, ben\xf6tigen wir Informationen zu Ihren Steuerungsw\xfcnschen. Sie k\xf6nnen App-Steuerelemente von Grund auf neu erstellen oder sich von uns mit unserem Steuerelementgenerator bei der Erstellung unterst\xfctzen lassen."}},"wizard":{"description":"Cephable verwendet diese Informationen dann, um Steuerelemente zu generieren, die Sie \xfcberpr\xfcfen und ausprobieren k\xf6nnen!","includeDefaultKeysQuestion":"Standard-Sprachbefehle f\xfcr Tasten und Mausklicks einschlie\xdfen?","placeholderAppName":"Microsoft Word, Minecraft, YouTube, Code usw.","noOptionsText":"Beginnen Sie mit der Eingabe, um eine App zu finden, die Sie steuern m\xf6chten","generate":"Steuerelemente generieren","complete":{"title":"Okay, wir sind fertig!","description":"Klicken Sie auf die Schaltfl\xe4che unten, um die von uns generierten Steuerelemente anzuzeigen. Sie k\xf6nnen alle Aspekte manuell bearbeiten, hinzuf\xfcgen oder entfernen, um sie f\xfcr sich zu perfektionieren.","viewControls":"Meine Bedienelemente anzeigen"},"error":{"emptyInput":"Bitte w\xe4hlen Sie mindestens eine Eingabemethode aus","emptyApp":"Bitte geben Sie mindestens einen App-Namen ein","generatingProfile":"Fehler beim Generieren der App-Steuerelemente"},"loading":{"title":"Wir f\xfcgen alle Teile zusammen","description":"Dies kann bis zu einer Minute dauern. Verlassen Sie diese Seite nicht und gehen Sie nicht zur\xfcck, sonst wird die Generierung gestoppt."},"selectedTips":{"title":"Tipp Nr. {{count}}","previous":"Vorheriger Tipp","next":"N\xe4chster Tipp","two":"Sie k\xf6nnen die Empfindlichkeit Ihrer Eingaben im Abschnitt \u201EEinstellungen f\xfcr Ausdruckssteuerung\u201C des Hauptfensters steuern. Auf diese Weise k\xf6nnen Sie die Art und Weise, wie Cephable Ihre Eingaben interpretiert, weiter verfeinern. Und Cephable wird mit der Zeit immer besser, da es mit Ihnen zusammenarbeitet!","three":"Nachdem wir dies eingerichtet haben, haben Sie immer noch die vollst\xe4ndige Kontrolle \xfcber die Konfiguration. Wir geben Ihnen eine Basislinie, aber Sie k\xf6nnen jederzeit die Zuordnung zwischen dem, was Sie tun, und dem, was auf dem Computer geschieht, \xe4ndern.","four":"Sie k\xf6nnen Ihre Steuerelemente ausdrucken, um eine physische Kopie zu haben, w\xe4hrend Sie Cephable verwenden. Wir wissen, dass das alles neu ist und etwas Eingew\xf6hnungszeit erfordert. \xdcbung macht den Meister!","one":"Wussten Sie, dass Sie Cephable auf einem Ger\xe4t verwenden k\xf6nnen, um ein anderes zu steuern? Laden Sie Cephable auf Ihr Handy, Tablet oder sogar einen anderen Computer herunter und w\xe4hlen Sie die Verbindung aus, die Sie steuern m\xf6chten (vielleicht diese hier). Ihre pers\xf6nlichen Profile und Eingabeprofile sind auf allen Ger\xe4ten konsistent! Stellen Sie einfach sicher, dass Cephable auf Ihrem Ger\xe4t und Ihren Verbindungen l\xe4uft."},"steps":{"one":"Schritt 1. Geben Sie den Namen der App ein, die Sie steuern m\xf6chten.","two":"Schritt 2. Best\xe4tigen Sie die Eingabesteuerung, die Sie verwenden m\xf6chten:","three":"Schritt 3. (optional)","threeContinued":"Beschreiben Sie alle spezifischen Aktionen, die Sie f\xfcr Befehle einrichten m\xf6chten, die Sie h\xe4ufig verwenden oder f\xfcr die Sie eine starke Vorliebe haben. Bitte verwenden Sie einfaches Englisch wie die folgenden"},"title":"App-Steuerelemente generieren","titleLong":"Generieren einer App-Steuerung","try":"Probieren Sie den Control Generator aus","placeholder":"Achten Sie darauf, dass die Sprachbefehle kurz sind.\\n\\nIch m\xf6chte \u201EVorw\xe4rts\u201C sagen k\xf6nnen, um zur n\xe4chsten Folie in der Pr\xe4sentation zu gelangen.\\n\\nIch m\xf6chte Kopfbewegungen zum Bewegen des Cursors und Sprachsteuerung f\xfcr Bearbeitungstasten verwenden.\\n\\nSchnellaktionsschaltfl\xe4chen f\xfcr alle Bewegungen und F\xe4higkeiten meiner Figur hinzuf\xfcgen."},"macros":{"title":"Kontrolle","titlePlural":"Bedienelemente","description":"Steuerelemente enthalten eine Eingabe (eine Aktion, die Sie ausf\xfchren, z. B. Ihren Kopf neigen) und Schritte, die Cephable ausf\xfchrt, nachdem diese Eingabeaktion aufgezeichnet wurde. Sie k\xf6nnen Steuerelemente verwenden, um eine Kombination von Schritten zu erstellen, die durch eine einzelne Eingabe ausgel\xf6st werden.","new":"Erstellen eines neuen Steuerelements","newDescription":"Erstellen Sie ein neues Steuerelement, um mehrere Schritte und Eingaben zu kombinieren.","add":"Steuerelement hinzuf\xfcgen","create":"Erstellen eines Steuerelements","name":{"title":"Steuerelementname","question":"Wie m\xf6chten Sie diese Steuerung nennen?","description":"Geben Sie Ihrem Steuerelement einen Namen, damit Sie es sp\xe4ter leicht finden k\xf6nnen.","placeholder":"Aktion, die dieses Steuerelement ausf\xfchrt, z. B. \u201ESpringen\u201C oder \u201EVergr\xf6\xdfern\u201C"},"empty":"Sie haben noch keine Steuerelemente. Klicken Sie unten, um eines zu erstellen.","copySuffix":"{{name}}_kopieren"},"event":{"title":"Schritt","titlePlural":"Vorgehensweise","previewSummaryPlural":"{{first}} und {{total}} weitere Ereignisse","add":"Schritt hinzuf\xfcgen","stepType":"Schritttyp","select":"W\xe4hlen Sie den Schritttyp aus, den Sie hinzuf\xfcgen m\xf6chten.","question":"Welche Art von Aktionen soll Cephable ausf\xfchren?","setup":"Konfigurieren Sie Ihren Step","description":"Schritte sind die Aktionen, die Cephable ausf\xfchrt, nachdem die Eingabe ausgel\xf6st wurde. Sie k\xf6nnen einem Steuerelement mehrere Schritte hinzuf\xfcgen, um eine Kombination von Aktionen zu erstellen.","expand":"Erweitern Sie, um die restlichen Schritte anzuzeigen","stepUp":"Schritt nach oben verschieben","stepDown":"Schritt nach unten verschieben","stepCopy":"Schritt kopieren","stepRemove":"Schritt entfernen","insertStep":"Schritt unten einf\xfcgen","showOptions":"Optionen anzeigen","hideOptions":"Optionen ausblenden","hold":"Haltezeit (in Millisekunden)","error":"Sie m\xfcssen Ihren Schritt konfigurieren.","multiple":"Mehrere Schritte","deviceTypeCustomAction":{"title":"Benutzerdefinierte Ger\xe4teaktion"},"keyPress":{"title":"Dr\xfccken Sie die Taste oder den Knopf","short":"Dr\xfccken","fieldSet":"Zu dr\xfcckende Tasten oder Kn\xf6pfe","label":"Taste oder Knopf","holdTime":"Tastendruckdauer (in Millisekunden)","description":"Dr\xfccken Sie eine Taste auf der Tastatur, ohne die Tastatur zu verwenden.","longDescription":"Diese Funktion simuliert das Dr\xfccken einer Taste auf Ihrer Tastatur. Wenn Sie beispielsweise Schwierigkeiten beim Dr\xfccken physischer Tasten haben, k\xf6nnen Sie einen Sprachbefehl oder eine andere Eingabemethode verwenden, um eine Taste virtuell zu \u201Edr\xfccken\u201C.","example":"Sagen Sie \u201EEnter\u201C, um eine E-Mail zu senden, ohne die Eingabetaste physisch zu dr\xfccken.","timing":"Tastendruck-Timing","tap":"Klopfen","tapLong":"Tippen Sie auf die Schaltfl\xe4che","latch":"Verriegeln","latchLong":"Halten bis zur Freigabe","hold":"Halten","holdLong":"Halten Sie f\xfcr eine gewisse Zeit","toggle":"Umschalten","toggleLong":"Aktion umschalten","release":"Freigeben","releaseLong":"Aktion freigeben","latchLabel":"<strong>{{value}}</strong> halten, bis es freigegeben wird","tapLabel":"Tippen Sie auf <strong>{{value}}</strong>","pressLabel":"Dr\xfccken Sie <strong>{{value}}</strong> f\xfcr <strong>{{time}}</strong> Millisekunden","remove":"Tastendruck entfernen","add":"Zum Dr\xfccken eine Taste/einen Knopf hinzuf\xfcgen"},"keyRelease":{"title":"Taste oder Knopf zum Loslassen","short":"Freigeben","selected":"Ausgew\xe4hlte Schl\xfcssel zum Loslassen","description":"Lassen Sie eine Taste auf der Tastatur los, die Sie gedr\xfcckt und gehalten haben.","longDescription":"Diese Funktion simuliert das Loslassen einer Taste auf Ihrer Tastatur. Sie sollte in Verbindung mit einem Tastendruck verwendet werden, der auf unbestimmte Zeit gedr\xfcckt gehalten wird. Wenn Sie beispielsweise Schwierigkeiten beim Dr\xfccken physischer Tasten haben, k\xf6nnen Sie einen Sprachbefehl oder eine andere Eingabemethode verwenden, um eine Taste virtuell \u201Eloszulassen\u201C.","example":"Sagen Sie \u201EStopp\u201C, nachdem Sie \u201EAusf\xfchren umschalten\u201C gesagt haben, um mit dem Laufen aufzuh\xf6ren.","label":"Geben Sie <strong>{{value}}</strong> frei","add":"Schl\xfcssel/Knopf zum Entsperren hinzuf\xfcgen","remove":"Schl\xfcsselfreigabe entfernen"},"keyToggle":{"title":"Umschalttaste oder -knopf","short":"Umschalten","selected":"Ausgew\xe4hlte Tasten zum Umschalten","description":"Schalten Sie eine Taste auf der Tastatur wie einen Lichtschalter mit einem einzigen Steuerelement ein oder aus.","longDescription":"Dadurch wird die Funktion einer Taste wie bei einem Schalter ein- oder ausgeschaltet. Dies ist n\xfctzlich f\xfcr Tasten, die Sie f\xfcr eine unbestimmte Zeit gedr\xfcckt halten m\xf6chten. Sie k\xf6nnen dies verwenden, um die gleiche Aktion sowohl f\xfcr das Dr\xfccken als auch f\xfcr das Loslassen oder Anhalten einer Taste beizubehalten.","example":"Sagen Sie \u201EToggle Run\u201C, um mit dem Laufen zu beginnen. Sagen Sie \u201EToggle Run\u201C, um mit dem Laufen aufzuh\xf6ren.","label":"<strong>{{value}}</strong> umschalten","add":"Taste/Knopf zum Umschalten hinzuf\xfcgen","remove":"Schl\xfcssel entfernen - Umschalter"},"pause":{"title":"Pause","description":"F\xfcgen Sie eine kurze Verz\xf6gerung zwischen den Aktionen hinzu.","longDescription":"Mit dieser Funktion k\xf6nnen Sie eine kurze Verz\xf6gerung zwischen Aktionen einf\xfcgen. Dies ist wichtig, wenn eine Aktion vollst\xe4ndig abgeschlossen sein muss, bevor die n\xe4chste beginnt. Wenn Sie beispielsweise einen Befehl verwenden, um Text in einem Dokument fett zu formatieren, m\xfcssen Sie m\xf6glicherweise zuerst ein Kontextmen\xfc \xf6ffnen. Die Pausenfunktion gibt gen\xfcgend Zeit, damit das Kontextmen\xfc ge\xf6ffnet und aktiviert werden kann, bevor mit dem n\xe4chsten Schritt fortgefahren wird. So wird ein reibungsloser und fehlerfreier Betrieb gew\xe4hrleistet.","example":"Stellen Sie sich vor, Sie bearbeiten ein Dokument mit Sprachbefehlen. Sie sagen \u201EText formatieren\u201C, woraufhin ein Kontextmen\xfc ge\xf6ffnet wird. Dann sagen Sie nach einer kurzen Pause, damit das Men\xfc vollst\xe4ndig angezeigt werden kann, \u201EFett\u201C, um den ausgew\xe4hlten Text fett zu formatieren. Die Pausenfunktion stellt sicher, dass das Kontextmen\xfc bereit ist, Ihren n\xe4chsten Befehl zu empfangen.","label":"Pause f\xfcr <strong>{{value}}</strong> Millisekunden"},"type":{"title":"Typ","field":"Zu tippende Phrase","placeholder":"getippte Phrase","question":"Welchen Text m\xf6chten Sie eingeben?","description":"Schreiben Sie Text wie mit einer Tastatur.","longDescription":"Dies imitiert das Eintippen einer Textzeichenfolge, \xe4hnlich dem Tippen auf einer Tastatur. Es ist ideal, um l\xe4ngere Texte einzugeben, ohne jede Taste dr\xfccken zu m\xfcssen. Wenn Sie Text dynamisch eingeben m\xf6chten, k\xf6nnen Sie stattdessen die Diktierfunktion verwenden.","example":"Sagen Sie \u201EName\u201C, um \u201EHallo, mein Name ist Ellen Ripley.\u201C in ein Chatfenster einzugeben.","label":"Geben Sie <strong>{{value}} ein</strong>"},"mouseMove":{"title":"Bewegen Sie die Maus","description":"Bewegen Sie den Zeiger auf dem Bildschirm.","longDescription":"Bewegen Sie den Cursor oder Zeiger Ihres Bildschirms ohne physische Maus. Dies ist besonders hilfreich f\xfcr Benutzer mit eingeschr\xe4nkter Handbeweglichkeit. Dies ist n\xfctzlich f\xfcr die Feinsteuerung der Mausbewegung, die in einigen Spielen erforderlich ist. Wenn Sie alle Mausbewegungen mithilfe Ihrer Kopfbewegung simulieren m\xf6chten, k\xf6nnen Sie in den Kameraeinstellungen die Option \u201EKopfbewegung zur Maussteuerung\u201C ausprobieren.","example":"Sagen Sie \u201EMaus nach rechts bewegen\u201C, um den Cursor 100 Pixel nach rechts zu bewegen.","moveX":"Maus bewegt sich nach links/rechts um Pixel","numberMoveX":"Anzahl der nach links/rechts zu verschiebenden Pixel","moveY":"Mausbewegung nach oben/unten in Pixeln","numberMoveY":"Anzahl der nach oben/unten zu verschiebenden Pixel","label":"Bewegen Sie die Maus <strong>{{value}}</strong>","command":"Mausbewegung: {{command}}"},"joystickMove":{"title":"Joysticks bewegen","description":"Verwenden Sie einen Joystick, um Dinge auf dem Bildschirm zu bewegen.","longDescription":"Diese Funktion simuliert die Bewegung eines Joysticks. Wenn Sie beispielsweise Schwierigkeiten mit der Verwendung eines physischen Joysticks haben, k\xf6nnen Sie einen Sprachbefehl oder eine andere Eingabemethode verwenden, um einen Joystick virtuell zu bewegen.","example":"Sagen Sie \u201EJoystick nach links bewegen\u201C, um den Joystick 100 Pixel nach links zu bewegen.","prefix":"Bewegen Sie den linken Joystick","left":"Linker Joystick","leftX":"Linke X","leftY":"Linke Y","right":"Rechter Joystick","rightX":"Rechte X","rightY":"Rechte Y","x":"St\xe4rke der X-Achse","y":"St\xe4rke der Y-Achse","moveXLabel":"Zug X: {{value}}","moveYLabel":"Y bewegen: {{value}}","labelLeft":"Bewegen Sie den linken Joystick","labelRight":"Bewegen Sie den rechten Joystick","latch":"Latch h\xe4lt die Position, bis Sie sie mit dem Befehl \u201EAlles stoppen\u201C loslassen."},"playAudio":{"title":"Audio abspielen","placeholder":"Aussagesatz, den Cephable sagen wird","description":"Spielen Sie einen Ton, ein Wort oder eine Phrase ab.","longDescription":"Mit dieser Funktion k\xf6nnen Benutzer eingegebene S\xe4tze in gesprochene W\xf6rter umwandeln. Dies ist besonders n\xfctzlich f\xfcr Personen, die m\xf6glicherweise Schwierigkeiten beim Sprechen haben. Wenn Sie einen Satz eingeben, wird der Text mit der PlayAudio-Funktion mithilfe synthetischer Sprache laut ausgesprochen. Dies kann bei der Kommunikation oder in Situationen hilfreich sein, in denen ein Benutzer Informationen m\xfcndlich weitergeben muss, aber eine Alternative zur Verwendung seiner eigenen Stimme bevorzugt oder ben\xf6tigt.","example":"L\xe4cheln Sie, um das Wort \u201EHallo\u201C abzuspielen.","label":"Sprechen Sie <strong>\\"{{value}}\\"</strong>"},"stopOutputs":{"title":"Alle Ausgaben stoppen","titleLong":"Alle Ausgaben stoppen (alle Tasten und Kn\xf6pfe loslassen, alle Mausbewegungen stoppen, alle Eingaben stoppen)","description":"Stoppen Sie alle laufenden Aktionen wie etwa Tastendr\xfccke.","longDescription":"Stoppen Sie sofort alle laufenden Ausgaben oder Aktionen. Dies ist eine Sicherheits- oder Komfortfunktion, um jeden Prozess anzuhalten. Wir erledigen dies automatisch f\xfcr Sie, wenn Sie die Kamera- oder Mikrofonsteuerung schlie\xdfen oder anhalten.","example":"Sagen Sie \u201EStopp\u201C, um alle Ausgaben zu stoppen.","label":"Alle Ausg\xe4nge stoppen und Tasten loslassen"},"custom":{"title":"Brauch"},"options":{"moveUp":"Nach oben","moveDown":"Nach unten","moveLeft":"Nach links bewegen","moveRight":"Nach rechts bewegen","copyStep":"Schritt kopieren","removeStep":"Schritt entfernen"},"directions":{"up":"Hoch","down":"Runter","left":"Links","right":"Rechts"}},"expression":{"title":"Gesichtsausdruck","titlePlural":"Gesichtsausdr\xfccke","label":"Ausdruck / Gestik","start":"Starten Sie die Ausdruckssteuerung","startSmiling":{"title":"Fangen Sie an zu l\xe4cheln","description":"Wenn Sie zun\xe4chst nicht l\xe4cheln und dann anfangen zu l\xe4cheln, wird diese Steuerung ausgel\xf6st. Hinweis: Die Verwendung dieser Steuerung in denselben App-Steuerelementen wie die Steuerung zum \xd6ffnen/Schlie\xdfen des Mundes kann zu Konflikten f\xfchren."},"stopSmiling":{"title":"H\xf6r auf zu l\xe4cheln","description":"Wenn Sie l\xe4cheln und dann aufh\xf6ren zu l\xe4cheln, wird diese Steuerung ausgel\xf6st. Hinweis: Die Verwendung dieser Steuerung in denselben App-Steuerelementen wie die Steuerung zum \xd6ffnen/Schlie\xdfen des Mundes kann zu Konflikten f\xfchren."},"eyebrows":{"title":"Augenbrauen hochziehen","description":"Wenn Sie beide Augenbrauen aus Ihrer Ruheposition heben, wird diese Steuerung ausgel\xf6st."},"openMouth":{"title":"Offener Mund","description":"Wenn Ihr Mund geschlossen ist (oder Ihre Grundlinie leicht ge\xf6ffnet ist) und Sie ihn weiter \xf6ffnen, wird diese Steuerung ausgel\xf6st. Hinweis: Die Verwendung dieser Steuerung in denselben App-Steuerelementen wie die L\xe4chelsteuerung kann zu Konflikten f\xfchren."},"closeMouth":{"title":"Mund schlie\xdfen","description":"Wenn Sie Ihren Mund ge\xf6ffnet haben und ihn vollst\xe4ndig schlie\xdfen, wird diese Steuerung ausgel\xf6st. Hinweis: Die Verwendung dieser Steuerung in denselben App-Steuerungen wie die L\xe4chelsteuerung kann zu Konflikten f\xfchren."},"description":"Verbessern Sie Ihr digitales Erlebnis mit Gesichtsausdr\xfccken. Verwenden Sie Gesten wie Augenbrauenheben, L\xe4cheln und andere Bewegungen, um Ihren Mauszeiger nahtlos zu steuern, Aktionen auszuf\xfchren oder Ihre Interaktionen anzupassen."},"head":{"title":"Kopfbewegung","titlePlural":"Kopfbewegungen","label":"Kopf-/K\xf6rperbewegung","question":"Welche Art von Bewegung m\xf6chten Sie verwenden?","tilt":{"title":"Kopfneigung","left":{"title":"Kopf nach links neigen","description":"Wenn Sie in die Kamera schauen und Ihren Kopf nach links neigen, wird diese Steuerung ausgel\xf6st."},"right":{"title":"Kopf nach rechts neigen","description":"Wenn Sie in die Kamera schauen und Ihren Kopf nach rechts neigen, wird diese Steuerung ausgel\xf6st."},"back":{"title":"Kopf nach hinten neigen","description":"Wenn Sie in die Kamera schauen, den Kopf in den Nacken legen und nach oben schauen, wird diese Steuerung ausgel\xf6st."},"forward":{"title":"Kopf nach vorne neigen","description":"Wenn Sie in die Kamera schauen, den Kopf nach vorne neigen und nach unten schauen, wird diese Steuerung ausgel\xf6st."},"description":"Neigen Sie Ihren Kopf nach links oder rechts, um die Steuerung oder Mausnavigation zu verbessern."},"turn":{"title":"Kopf drehen","left":{"title":"Kopf nach links drehen","description":"Wenn Sie in die Kamera schauen und Ihren Kopf drehen und nach links schauen, wird diese Steuerung ausgel\xf6st."},"right":{"title":"Kopf rechts abbiegen","description":"Wenn Sie in die Kamera schauen und Ihren Kopf drehen und nach rechts schauen, wird diese Steuerung ausgel\xf6st."},"description":"Drehen Sie Ihren Kopf nach links oder rechts, um die Steuerung oder Mausnavigation zu verbessern."},"lean":{"title":"Kopf schlank","left":{"title":"Kopf nach links neigen","description":"Wenn Sie in die Kamera schauen und sich nach links neigen, sodass Ihr Gesicht weiter links im Kamerarahmen ist, wird diese Steuerung ausgel\xf6st."},"right":{"title":"Kopf nach rechts neigen","description":"Wenn Sie in die Kamera schauen und sich nach rechts neigen, sodass Ihr Gesicht weiter rechts im Kamerarahmen ist, wird diese Steuerung ausgel\xf6st."},"back":{"title":"Kopf nach hinten neigen","description":"Wenn Sie in die Kamera schauen und sich nach hinten lehnen, sodass Ihr Gesicht weiter von der Kamera entfernt ist, wird diese Steuerung ausgel\xf6st."},"forward":{"title":"Kopf nach vorne lehnen","description":"Wenn Sie in die Kamera schauen und sich nach vorne beugen, sodass Ihr Gesicht n\xe4her an der Kamera ist, wird diese Steuerung ausgel\xf6st."},"up":{"title":"K\xf6rper nach oben bewegen","description":"Wenn Sie in die Kamera schauen und Ihren Kopf nach oben bewegen, indem Sie Ihren Hals strecken oder Ihren ganzen K\xf6rper nach oben bewegen, wird diese Steuerung ausgel\xf6st."},"down":{"title":"K\xf6rper nach unten bewegen","description":"Diese Steuerung wird ausgel\xf6st, wenn Sie in die Kamera schauen und Ihren Kopf nach unten bewegen, indem Sie den Hals kr\xfcmmen, sich ducken oder Ihren ganzen K\xf6rper senken."},"center":{"title":"Zentrieren Sie Ihren Kopf","description":"Wenn Sie in die Kamera schauen und Ihren Kopf zur\xfcck in die der Grundlinie entsprechende Mittelposition bewegen, wird diese Steuerung ausgel\xf6st."},"description":"Neigen Sie Ihren Kopf nach links oder rechts, um die Steuerung oder Mausnavigation zu verbessern."},"description":"Steuern Sie Ihr Ger\xe4t oder Ihre Verbindung mit Kopfbewegungen wie Neigen, Nicken oder Drehen. Mithilfe der Kamera Ihres Ger\xe4ts sorgt Cephable f\xfcr ein privates und intuitives Erlebnis mit verbesserter Steuerung oder Mausnavigation."},"voice":{"title":"Sprachsteuerung","titlePlural":"Sprachsteuerung","placeholder":"Stimme oder Satz, auf den Cephable achtet","question":"Welche Aussage oder Phrase m\xf6chten Sie zu diesem Steuerelement sagen?","when":"Wenn ich sage ...","say":"Sagen Sie \'{{value}}\'","load":{"fail":{"title":"{{language}} Sprachsteuerung nicht verf\xfcgbar","description":"Oh nein! {{language}} konnte f\xfcr die Sprachsteuerung nicht geladen werden. Bitte \xfcberpr\xfcfen Sie Ihre Internetverbindung und versuchen Sie es erneut. Wir verwenden Englisch (USA), bis die Verbindung wiederhergestellt ist."}},"description":"Durch das Einschalten des Mikrofons werden intelligente und nat\xfcrliche Sprachbefehle freigeschaltet, die eine nahtlose Interaktion mit dem Computer \xfcber Anwendungen und Software hinweg erm\xf6glichen. Sprechen Sie nat\xfcrlich, um Befehle auszuf\xfchren oder Text zu diktieren \u2013 f\xfcr ein m\xfcheloses und intuitives Erlebnis."},"motion":{"title":"Bewegungssteuerung","titlePlural":"Bewegungssteuerung","question":"Welche Art der Bewegung mit einem Telefon oder Tablet m\xf6chten Sie verwenden?","start":"Bewegungssteuerung starten","settings":"Bewegungseinstellungen","descriptionShort":"Neigen, drehen oder sch\xfctteln Sie Ihr Ger\xe4t, um Cephable zu steuern.","description":"Mit Bewegungssteuerungen k\xf6nnen Sie die Bewegungen Ihres Telefons oder Tablets in der Companion App in Steuerelemente f\xfcr Ihr Ger\xe4t umwandeln. Neigen oder sch\xfctteln Sie Ihr Telefon in verschiedene Richtungen, um neue Ergebnisse zu erzielen.","up":{"title":"Neigen Sie Ihr Ger\xe4t nach oben","description":"Wenn Ihr Ger\xe4t flach auf einer Oberfl\xe4che liegt und Sie es nach oben neigen, sodass Sie es sehen, wird diese Steuerung ausgel\xf6st."},"down":{"title":"Neigen Sie Ihr Ger\xe4t nach unten","description":"Wenn Ihr Ger\xe4t flach auf einer Oberfl\xe4che liegt und Sie es nach unten neigen, sodass es von Ihnen weg zeigt, wird diese Steuerung ausgel\xf6st."},"left":{"title":"Neigen Sie Ihr Ger\xe4t nach links","description":"Wenn Ihr Ger\xe4t flach auf einer Oberfl\xe4che liegt und Sie es nach links neigen, sodass es nach links zeigt, wird diese Steuerung ausgel\xf6st."},"right":{"title":"Neigen Sie Ihr Ger\xe4t nach rechts","description":"Wenn Ihr Ger\xe4t flach auf einer Oberfl\xe4che liegt und Sie es nach rechts neigen, wird diese Steuerung ausgel\xf6st."},"shake":{"title":"Sch\xfctteln Sie Ihr Ger\xe4t","description":"Wenn Sie Ihr Ger\xe4t sch\xfctteln, wird diese Steuerung ausgel\xf6st."},"edit":{"title":"Bewegungseinstellungen bearbeiten","description":"\xc4ndern Sie Ihre Bewegungssteuerungseinstellungen, um anzupassen, wie weit Sie Ihr Telefon beim Laufen zur Companion App bewegen m\xfcssen","sensitivity":{"title":"Empfindlichkeitseinstellungen f\xfcr die Bewegungssteuerung","description":"Die Empfindlichkeit gibt Cephable an, wie weit Sie Ihr Ger\xe4t neigen m\xfcssen, um eine Steuerung auszul\xf6sen. Je gr\xf6\xdfer der Wert (ganz rechts auf dem Schieberegler), desto h\xf6her ist die Empfindlichkeit und desto weniger m\xfcssen Sie neigen, um die Steuerung auszul\xf6sen."},"tilt":{"title":"Neigungsempfindlichkeit","description":"Diese Werte bestimmen, wie weit Sie Ihr Ger\xe4t nach oben, unten, links und rechts neigen m\xfcssen, damit eine Eingabe erkannt wird."},"mouse":{"title":"Bewegungssteuerung f\xfcr Mausbewegungen","description":"Legen Sie fest, ob und wie Sie Bewegungssteuerungen zum Bewegen der Maus anstelle von Ausl\xf6sesteuerungen verwenden m\xf6chten","enable":{"title":"Bewegungssteuerung f\xfcr Mausbewegungen aktivieren","description":"Wenn dies aktiviert ist, werden zum Bewegen der Maus einige Ihrer Bewegungssteuerelemente anstelle der Trigger-Steuerelemente verwendet.","option":"Bewegungssteuerung f\xfcr Mausbewegungen verwenden?"},"invert":{"title":"Mausbewegung umkehren","description":"F\xfcr die X-Achse: Wenn diese Option aktiviert ist, bewegt eine Bewegung nach links die Maus nach rechts und eine Bewegung nach rechts nach links. F\xfcr die Y-Achse: Wenn diese Option aktiviert ist, bewegt eine Bewegung nach unten die Maus nach oben und eine Bewegung nach oben nach unten.","x":"Mausbewegung auf der X-Achse umkehren?","y":"Mausbewegung auf der Y-Achse umkehren?"}}}},"keys":{"title":"Taste oder Knopf","titlePlural":"Tasten oder Kn\xf6pfe","label":"Externe Taste / Knopf","question":"Welche Taste oder Schaltfl\xe4che m\xf6chten Sie dr\xfccken?","edit":"Tasten und Schaltfl\xe4chen bearbeiten","defaultOption":"Standard-Sprachbefehle f\xfcr Tasten und Mausklicks einschlie\xdfen?","description":"Mithilfe von Tasten und Schaltfl\xe4chen k\xf6nnen Sie Ihre verschiedenen Eingabesteuerungen den Tastendr\xfccken auf der Tastatur und dem Controller zuordnen.","then":"Cephable wird dr\xfccken...","empty":"Es sind keine Tastensteuerungen vorhanden, die diesen Kriterien entsprechen.","backspace":"R\xfccktaste","delete":"L\xf6schen","enter":"Eingeben","space":"Leertaste","tab":"Tab","shift":"Schicht","ctrl":"Strg","leftCtrl":"Linke Strg-Taste","rightCtrl":"Rechte Strg-Taste","leftShift":"Linksverschiebung","rightShift":"Rechtsverschiebung","alt":"Alle","leftAlt":"Linke Alt-Taste","escape":"Flucht","up":"Pfeil nach oben","down":"Pfeil nach unten","left":"Pfeil nach links","right":"Pfeil nach rechts","command":"Befehl","caps":"Feststelltaste","reset":{"title":"Tastenbelegung zur\xfccksetzen","confirm":"Alle Tastenbelegungen zur\xfccksetzen?","confirmDescription":"W\xe4hlen Sie aus, wie Sie die Tastenbelegung zur\xfccksetzen m\xf6chten. Diese Aktion kann erst nach dem Speichern r\xfcckg\xe4ngig gemacht werden.","confirmButton":"Tastenbelegung zur\xfccksetzen","defaultOption":"Auf Standardwerte f\xfcr die aktuelle Sprache zur\xfccksetzen","emptyOption":"Auf leeren Zustand zur\xfccksetzen (alle Befehle l\xf6schen)"}},"talkback":{"title":"Talkback","question":"Was m\xf6chten Sie, dass Cephable sagt?","description":"Richten Sie Steuerelemente ein, mit denen Cephable f\xfcr Sie spricht. Sie k\xf6nnen Steuerelemente verschiedenen S\xe4tzen zuweisen, die vorgelesen werden sollen.","thenMacro":"dann wird Cephable sagen ...","empty":"Es gibt keine Talkback-Bedienelemente, die diesem Kriterium entsprechen.","add":"Hinzuf\xfcgen einer neuen Talkback-Steuerung","remove":"Talkback-Steuerung entfernen","edit":"Talkback-Steuerelemente bearbeiten","deprecatedNotice":"Talkback ist jetzt direkt in die prim\xe4ren App-Steuerelemente integriert. Ihre App-Steuerelemente enthalten einige \xe4ltere Talkback-Ereignisse, die aktualisiert werden m\xfcssen."},"dictation":{"title":"Diktat","question":"Welcher Satz soll den Diktiermodus ausl\xf6sen?","thenMacro":"Cephable wird \u2026","empty":"Es gibt keine Diktiersteuerungen, die diesen Kriterien entsprechen.","type":"Typ","edit":"Diktatphrasen bearbeiten","remove":"Diktatphrase entfernen","add":"Neue Diktierphrase hinzuf\xfcgen","on":"Diktat","off":"Befehle","onboarding":{"tourLabel":"Diktat","learn":"Erfahren Sie, wie Sie mit dem Diktiermodus Ihre Sprache freih\xe4ndig in Text umwandeln.","welcome":{"title":"Diktat","description":"Mit der Diktierfunktion k\xf6nnen Sie nat\xfcrlich sprechen und Ihre Worte direkt w\xe4hrend des Sprechens abtippen lassen. Es ist, als h\xe4tten Sie einen pers\xf6nlichen Assistenten, der alles tippt, was Sie sagen."},"microphone":{"title":"Schalten Sie Ihr Mikrofon ein","description":"Schalten Sie zun\xe4chst Ihr Mikrofon ein. Klicken Sie dazu auf den Mikrofonschalter im Cephable-Panel."},"activate":{"title":"Diktiermodus starten","description":"Die Sprachsteuerung startet im Befehlsmodus. Um das Diktieren zu starten, sagen Sie \u201EDiktat starten\u201C oder klicken Sie auf die Schaltfl\xe4che \u201EDiktieren\u201C. Schalten wir jetzt den Diktiermodus ein."},"speaking":{"title":"Klicken Sie auf ein Dokument oder Feld und beginnen Sie zu sprechen","description":"Die Diktierfunktion gibt Ihre Eindr\xfccke in Echtzeit wieder. Klicken Sie auf ein Textfeld oder Dokument und beginnen Sie zu sprechen. Sagen Sie beispielsweise: \u201ESo verwenden Sie den Diktiermodus.\u201C"},"pauseResume":{"title":"Diktat pausieren","description":"Brauchen Sie eine Pause, ohne die Diktierfunktion auszuschalten? Sagen Sie einfach \u201EDiktat pausieren\u201C. Sie k\xf6nnen jederzeit mit \u201EDiktat starten\u201C fortfahren. Sie k\xf6nnen die Funktion mit Ihren globalen Always-On- und Ger\xe4testeuerungen weiter anpassen."},"stop":{"title":"Diktat stoppen","description":"M\xf6chten Sie zur\xfcck zur App-Steuerung wechseln? Sagen Sie einfach \u201EDiktat beenden\u201C. Dadurch wird der Diktiermodus beendet und Sie kehren in den Befehlsmodus zur\xfcck. Sie k\xf6nnen jederzeit mit \u201EDiktat starten\u201C fortfahren."},"complete":{"title":"Gl\xfcckwunsch!","description":"Das war\'s! Sie k\xf6nnen jetzt diktieren, pausieren, fortsetzen und zwischen Diktier- und Befehlsmodus wechseln. Diktieren ist ein leistungsstarkes Tool f\xfcr freih\xe4ndiges Tippen. Verwenden Sie es zum Schreiben von E-Mails, Dokumenten oder anderen Texten, die Sie laut tippen m\xfcssen."}},"description":"Mit der Diktierfunktion k\xf6nnen Sie nat\xfcrlich sprechen und Ihre Worte w\xe4hrend des Sprechens eintippen lassen. Es ist, als h\xe4tten Sie einen pers\xf6nlichen Assistenten, der alles tippt, was Sie sagen."},"face":{"title":"Gesichtsausdruck","titlePlural":"Gesichtsausdr\xfccke","try":"Probieren Sie die Gesichtsausdrucksteuerung aus","question":"Welche Art von Gesichtsausdruck m\xf6chten Sie verwenden?","descriptionShort":"Verwenden Sie verschiedene Gesichtsbewegungen f\xfcr eine verbesserte Steuerung.","description":"Gesichtsausdr\xfccke sind Teil der Ausdruckssteuerung. Sie erm\xf6glicht Ihnen die Verwendung verschiedener Gesichtsbewegungen f\xfcr erweiterte Steuerungen. Sie k\xf6nnen Augenbrauenbewegungen, Mundbewegungen und mehr verwenden, um unterschiedliche Ergebnisse zu erzielen."},"other":{"title":"Andere","titlePlural":"Andere Bedienelemente","label":"Andere Steuerung","placeholder":"anderer experimenteller Befehl","question":"Welchen zus\xe4tzlichen Befehl m\xf6chten Sie verwenden? Diese sind typischerweise f\xfcr nicht-Cephable-Verbindungen gedacht, die nicht in andere Kategorien passen. Sie k\xf6nnen auch als Sprachbefehle fungieren, wenn Sie das angegebene Wort oder die angegebene Phrase aussprechen. Hinweis: Diese Steuerelemente sind experimentell und werden m\xf6glicherweise nicht vollst\xe4ndig unterst\xfctzt.","description":"Andere Steuerelemente sind experimentell und werden m\xf6glicherweise nicht vollst\xe4ndig unterst\xfctzt. Sie k\xf6nnen f\xfcr nicht-Cephable-Verbindungen oder als Sprachbefehle verwendet werden, wenn Sie das angegebene Wort oder den angegebenen Satz aussprechen."},"support":{"title":"Unterst\xfctzung","profiles":"Einf\xfchrung in App-Steuerelemente","question":"Finden Sie immer noch nicht, was Sie brauchen?","more":"Erfahren Sie mehr auf Cephable.com mit Schritt-f\xfcr-Schritt-Anleitungen, Tutorials, Videos und mehr."},"community":{"title":"Treten Sie der Community bei","description":"Holen Sie sich Unterst\xfctzung, tauschen Sie Ideen aus oder werden Sie Mitglied der Cephable-Communitys.","discord":"Discord-Community","facebook":"Facebook-Gruppe"},"resources":{"title":"Hilfreiche Ressourcen","description":"Finden Sie Antworten auf Ihre Fragen zu den Merkmalen und Funktionen von Cephable.","guides":"Schritt-f\xfcr-Schritt-Anleitungen"},"feedback":{"title":"R\xfcckmeldung","description":"Erz\xe4hlen Sie uns von Ihren Erfahrungen mit Cephable.","contact":"Kontaktieren Sie uns","feature":"Funktion vorschlagen","bug":"Ein Problem melden"},"settings":{"title":"Einstellungen","general":"Allgemeine App-Einstellungen","description":"Dies ist Ihre Leinwand, auf der Sie durch die Feinabstimmung Ihrer Steuerungen Ihr Erlebnis individuell gestalten k\xf6nnen.","orgTitle":"{{ value }}-Einstellungen"},"account":{"title":"Konto","menu":"Nutzermen\xfc","settings":"Kontoeinstellungen","description":"Aktualisieren Sie wichtige Informationen, um mit Cephable in Verbindung zu bleiben.","usernameLabel":"Benutzername:","emailLabel":"E-Mail:","password":{"change":"Kennwort \xe4ndern","description":"Aktualisieren Sie Ihr Passwort, um Ihr Konto zu sch\xfctzen.","old":"Altes Passwort","current":"Ihr aktuelles Passwort","new":"Neues Passwort","desired":"Ihr gew\xfcnschtes neues Passwort","confirm":"Neues Passwort best\xe4tigen","update":"Kennwort aktualisieren"},"isEmailVerified":{"title":"E-Mail ist nicht verifiziert.","description":"Ihre E-Mail wurde nicht best\xe4tigt. Bitte suchen Sie in Ihrem Posteingang nach einem Best\xe4tigungslink.","resend":"E-Mail erneut senden","success":"Wir haben Ihnen eine neue Best\xe4tigungs-E-Mail gesendet.","error":"Beim Senden der Best\xe4tigungs-E-Mail ist ein Fehler aufgetreten. Bitte versuchen Sie es sp\xe4ter noch einmal.","org":"Ihre E-Mail-Adresse wurde nicht best\xe4tigt. Sie ist f\xfcr den Zugriff auf die Lizenzdaten erforderlich. Bitte \xfcberpr\xfcfen Sie Ihre E-Mail-Adresse auf einen Best\xe4tigungslink.","titleAlt":"Best\xe4tigen Sie Ihre E-Mail-Adresse","descriptionLong":"Willkommen bei Cephable! Eine Best\xe4tigungs-E-Mail wurde an {{email}} gesendet. Bitte \xfcberpr\xfcfen Sie Ihren Posteingang oder Spam-Ordner und klicken Sie auf den Link. Falls Sie ihn nicht sehen, k\xf6nnen Sie die Best\xe4tigungs-E-Mail erneut senden.","appBlock":"Du hast es fast geschafft! Eine Best\xe4tigungs-E-Mail wurde an {{email}} gesendet. Bitte \xfcberpr\xfcfe deinen Posteingang und klicke auf den Link, um deine E-Mail-Adresse zu best\xe4tigen. Solltest du den Link nicht finden, \xfcberpr\xfcfe bitte deinen Spam-Ordner."},"signout":{"title":"Abmelden","question":"M\xf6chten Sie sich wirklich abmelden?","confirm":"Ja, abmelden","warn":{"title":"Sie werden gleich abgemeldet.","description":"Es sieht so aus, als w\xe4ren Sie eine Weile inaktiv gewesen. Aus Sicherheitsgr\xfcnden melden wir Sie in XX Sekunden ab. Wenn Sie angemeldet bleiben m\xf6chten, klicken Sie unten auf \u201EAngemeldet bleiben\u201C.","confirm":"Angemeldet bleiben","cancel":"Jetzt abmelden"},"description":"Sobald Sie sich abmelden, wird diese Verbindung aus Ihrem Konto entfernt und ist in der Companion App oder anderen Verbindungen nicht mehr sichtbar.","confirmDescription":"Sie werden abgemeldet und diese Verbindung wird entfernt"},"marketing":{"title":"E-Mail-Einstellungen","description":"Aktualisieren Sie Ihre E-Mail-Einstellungen, um Updates und Neuigkeiten von Cephable zu erhalten.","marketing":"Marketing-E-Mails","optIn":"Ich m\xf6chte Tutorials, Tipps, Updates und Newsletter erhalten, um mein Cephable-Erlebnis zu verbessern"},"error":{"save":"Fehler beim Speichern der Kontoeinstellungen.","password":"Fehler beim Aktualisieren des Passworts.","signout":"Fehler beim Abmelden.","old":"Altes Passwort ist erforderlich.","new":"Ein neues Passwort ist erforderlich.","match":"Die Passw\xf6rter stimmen nicht \xfcberein.","marketing":"Fehler beim Aktualisieren der E-Mail-Einstellungen.","userPreferences":"Fehler beim Speichern der Benutzereinstellungen."},"success":{"save":"Kontoeinstellungen gespeichert.","password":"Passwort aktualisiert.","marketing":"E-Mail-Einstellungen aktualisiert.","userPreferences":"Benutzereinstellungen aktualisiert."},"userPreferences":{"title":"Benutzereinstellungen","description":"Aktualisieren Sie Ihre Einstellungen, um das f\xfcr Sie passende Cephable-Erlebnis zu schaffen.","warningOptOut":"Warnungen ausblenden, wenn ich App-Steuerelemente speichere oder aktualisiere","enableTranscribeTask":"Aktivieren Sie die experimentelle Dateitranskriptionsaufgabe im Cephable-Panel","enableClickByName":"NUR f\xfcr Windows. Aktivieren Sie die experimentelle Funktion \u201ETippen Sie auf ein Element auf dem Bildschirm anhand seines Namens\u201C, z. B. \u201ETippen Sie auf Speichern\u201C, um auf eine Schaltfl\xe4che mit der Bezeichnung \u201ESpeichern\u201C zu klicken.","enableGamepadSupport":"Aktivieren Sie die Gamepad-Unterst\xfctzung f\xfcr lokale Treiber und Xbox-Controller-Emulation","enableMetrics":"Aktivieren Sie die Ausgabe von Nutzungsmetriken f\xfcr Leistungstests. Sie k\xf6nnen die Protokolle vom Cephable Panel herunterladen."},"delete":{"title":"Konto l\xf6schen","description":"Sie k\xf6nnen Ihr Konto endg\xfcltig l\xf6schen und alle Bez\xfcge zu Ihren pers\xf6nlichen Daten entfernen. Mit der L\xf6schung Ihres Kontos werden Ihre Verbindungen getrennt und funktionieren nicht mehr, sind nicht mehr mit Ihrem Konto verkn\xfcpft und Ihre App-Einstellungen sowie alle weiteren Einstellungen gehen verloren. Dieser Vorgang kann nicht r\xfcckg\xe4ngig gemacht werden.","button":"Konto endg\xfcltig l\xf6schen","confirmation":"Sind Sie sicher, dass Sie Ihr Konto l\xf6schen m\xf6chten?","note":"Diese Handlung ist unumkehrbar.","confirm":"Ja, mein Konto l\xf6schen"}},"appSettings":{"description":"Diese Einstellungen gelten nur f\xfcr diese App. Wenn Sie die Einstellungen der Cephable-App auf einem anderen Computer oder Mobilger\xe4t \xe4ndern m\xf6chten, bearbeiten Sie die Einstellungen in dieser App.","autostart":{"title":"Cephable automatisch starten","description":"Wenn diese Einstellung aktiviert ist, wird die Cephable-App automatisch gestartet, wenn Sie sich bei Ihrem Ger\xe4t anmelden. Wenn Sie auch \xfcber automatische Sprach- und Ausdruckssteuerungen verf\xfcgen, werden diese ebenfalls sofort gestartet.","question":"Cephable-App automatisch starten?"},"position":{"topLeft":"Oben links","top":"Oben Mitte","topRight":"Oben rechts","bottom":"Unten Mitte","bottomLeft":"Unten links","bottomRight":"Unten rechts","label":"Befehlsvorschubposition ausw\xe4hlen","description":"W\xe4hlen Sie aus, wo der Befehls-Feed auf Ihrem Bildschirm angezeigt werden soll."},"micPosition":{"title":"Position des Mikrofon-Eingangsfensters","description":"W\xe4hlen Sie aus, wo auf Ihrem Bildschirm die Mikrofonsteuerung f\xfcr Sprache und Diktieren platziert werden soll.","label":"Fensterposition f\xfcr Mikrofoneingang ausw\xe4hlen"},"cameraPosition":{"title":"Position des Kamera-Eingabefensters","description":"W\xe4hlen Sie aus, wo auf Ihrem Bildschirm die Kamerasteuerung f\xfcr Gesichts- und Kopfbewegungen positioniert werden soll.","label":"W\xe4hlen Sie die Position des Kamera-Eingabefensters"},"theme":{"title":"Thema","description":"W\xe4hlen Sie ein Thema, das zu Ihrem Stil passt.","label":"W\xe4hlen Sie ein Thema","light":"Licht","dark":"Dunkel","system":"Verwenden Sie die Betriebssystem-Systemeinstellungen"},"overlay":{"title":"Befehlsfeed","description":"Der Befehlsfeed zeigt die verschiedenen von Ihnen verwendeten Steuerelemente und die an Ihren Computer gesendeten Steuerelemente an. Er ist per Klick erreichbar, wird aber immer \xfcber anderen Fenstern angezeigt. Wenn diese Einstellung aktiviert ist, wird die Cephable-App angezeigt und befindet sich immer \xfcber anderen Fenstern und Anwendungen.","question":"Befehls-Feed anzeigen?"},"transparent":{"title":"Transparenz des Befehlsfeeds","description":"Der Wert bestimmt die Opazit\xe4t des Textes. Je niedriger der Wert, desto durchsichtiger ist der Feed."},"panelAutoHide":{"title":"Cephable-Panel automatisch ausblenden","delay":"Verz\xf6gerung vor dem Verstecken","denominator":"Sekunden","time":"{{value}} Sekunden"},"title":"Allgemeine App-Einstellungen"},"input":{"title":"Eingang","titlePlural":"Eingabesteuerung","explore":"Eingabesteuerung erkunden","descriptionShort":"Entdecken Sie die verschiedenen Eingabesteuerelemente, die Cephable nutzt, um Ihnen ein besseres digitales Erlebnis zu bieten.","typeLabel":"Eingabesteuerungstyp","toolTip":"Dies verwendet {{alt}}","remove":"Eingabesteuerung entfernen","filter":"Filtern nach Eingabetyp","select":"W\xe4hlen Sie einen Eingang","question":"Welchen Eingabetyp m\xf6chten Sie verwenden?","add":"Eingabe hinzuf\xfcgen","addMore":"Einen weiteren Eingang hinzuf\xfcgen","removeItem":"Element entfernen {{index}}","item":"Artikel {{index}}: {{label}}","duplicate":"Doppelte Elemente sind nicht zul\xe4ssig.","maximum":"Maximal {{maxItems}} Elemente zul\xe4ssig.","description":"Eingabesteuerungen sind die verschiedenen Methoden zur Steuerung Ihres Ger\xe4ts. Dazu geh\xf6ren beispielsweise Ihre Stimme, Kopfbewegungen, Gesichtsausdr\xfccke und zus\xe4tzliche Verbindungen. Entdecken Sie unten die verschiedenen Eingabesteuerungen, um mehr zu erfahren."},"time":{"soon":"Demn\xe4chst verf\xfcgbar","now":"Jetzt","today":"Heute","yesterday":"Gestern","minutesAgo":"vor {{count}} Minute","minutesAgo_plural":"vor {{count}} Minuten","daysAgo":"vor {{count}} Tagen","daysAgo_plural":"vor {{count}} Tagen","monthsAgo":"vor {{count}} Monaten","monthsAgo_plural":"vor {{count}} Monaten","yearsAgo":"vor {{count}} Jahr","yearsAgo_plural":"vor {{count}} Jahren","minutesAhead":"in {{count}} Minuten","todayAhead":"sp\xe4ter heute","tomorrow":"morgen","daysAhead":"in {{count}} Tagen","monthsAhead":"in {{count}} Monaten","yearsAhead":"in {{count}} Jahren"},"peripherals":{"empty":"Keine Peripherieger\xe4te erkannt","switch":"Schalten","keyboard":"Tastatur","gamepad":"Gamepad","companionApp":"Begleit-App","available":"Verf\xfcgbar zur Nutzung","error":"\xdcberpr\xfcfen Sie Ihre Einstellungen."},"camera":{"windowTitle":"Cephable-Kamerasteuerung","title":"Kamera","titlePlural":"Kameras","settings":"Kameraeinstellungen","start":"Kamera starten","restart":"Kamera neu starten","descriptionShort":"Erm\xf6glicht Gesichtsausdruck und Kopfbewegungen.","description":"Verwenden Sie Ihre Kamera, um Gesichtsausdr\xfccke und K\xf6rpergesten als verschiedene Steuerelemente zu erkennen.","empty":"Keine Kameras gefunden.","search":"Suche nach Kameranamen","loading":"Kamerasteuerung wird geladen \u2026","error":"Unerwarteter Fehler beim Laden der Kamerasteuerung. Bitte \xfcberpr\xfcfen Sie Ihre Kamera und versuchen Sie es erneut.","manage":{"title":"Klicken Sie hier, um Details zu Ihren Kameras anzuzeigen und zu verwalten.","description":""},"detected":{"face":"Gesicht erkannt.","noFace":"Kein Gesicht erkannt. Bitte passen Sie Ihre Kamera oder Position an und versuchen Sie es erneut.","command":"Erkannt: {{command}}"},"permission":{"title":"Kameraberechtigungen erforderlich","description":"Sie m\xfcssen Cephable die Berechtigung erteilen, Ihre Kamera zu verwenden, um Gesichts- und K\xf6rpersteuerungen zu nutzen.","button":"Berechtigungseinstellungen \xf6ffnen","no":"Kein Kamerazugriff","help":"Cephable ben\xf6tigt Zugriff auf Ihre Kamera, um Ausdrucks- und Kopfsteuerungen verwenden zu k\xf6nnen. Navigieren Sie zu <strong>Systemeinstellungen</strong> > <strong>Datenschutz</strong> > <strong>Kamera</strong> und erm\xf6glichen Sie Cephable den Zugriff auf Ihre Kamera."},"controls":{"startData":"Aufzeichnung der Gesichtsdaten gestartet. Dr\xfccken Sie im Kamerafenster die Tastenkombination erneut, um die Aufzeichnung und den Download zu stoppen.","downloadData":"Aufzeichnung gestoppt, Daten werden heruntergeladen","paused":"Kamerasteuerung angehalten.","pause":"Kamerasteuerung anhalten","resume":"Kamerasteuerung fortsetzen","resumed":"Kamerasteuerung wieder aufgenommen.","linesOn":"Gesichtslinien einschalten","linesOff":"Gesichtslinien ausschalten","linesToggle":"Zeichnen von Gesichtslinien ein-/ausschalten","noDeviceTitle":"Es wurde keine Kamera erkannt, die mit Cephable verwendet werden kann.","noDeviceDescription":"Sie m\xfcssen eine Kamera anschlie\xdfen, die mit mobilen Apps kompatibel ist.","noDeviceConnectedDescription":"Die Kamerasteuerung dient als Vorschau der Oberfl\xe4che. Es werden keine Schritte erfolgreich ausgef\xfchrt. Verbinden Sie dieses Begleitger\xe4t mit einem anderen, um Befehle auszul\xf6sen.","lines":"Gesichtsfalten"},"switch":{"title":"Kamera wechseln","description":"W\xe4hlen Sie eine andere Kamera zur Gesichts- und K\xf6rperkontrolle aus.","select":"Kamera ausw\xe4hlen","next":"N\xe4chste Kamera","nextLong":"Zur n\xe4chsten Kamera wechseln","empty":"Keine weiteren Kameras gefunden.","search":"Suche nach Kameranamen"},"baseline":{"title":"Ausgangslage","description":"Die Basislinie ist die Standardposition Ihres Gesichts und K\xf6rpers, die Cephable zur Bestimmung Ihrer Bewegungen verwendet. Sie k\xf6nnen die Basislinie hier aktualisieren und zur\xfccksetzen.","update":"Baseline aktualisieren","reset":"Basislinie zur\xfccksetzen","updated":"Baseline aktualisiert","tooltip":"Klicken Sie, um Ihre Basislinie auf Ihre aktuelle Ruheposition zu aktualisieren."},"edit":{"title":"Kameraeinstellungen bearbeiten","description":"Sie k\xf6nnen die Einstellungen f\xfcr Ihre Eing\xe4nge, die eine Kamera erfordern, verfeinern, um sie besser an Ihre Anforderungen anzupassen.","autoStart":{"title":"Kamera automatisch starten","option":"Kamera- und Kopf-/Ausdruckssteuerung automatisch starten?","description":"Ist diese Einstellung aktiviert, startet Ihr Controller die Kamera, sodass Sie Gesichtsausdr\xfccke und Kopfbewegungen direkt beim Start der App steuern k\xf6nnen. Ist diese Einstellung deaktiviert, tippen Sie auf der Verbindungsseite auf die Schaltfl\xe4che \u201EKamera starten\u201C."},"head":{"title":"Kopfbewegungsempfindlichkeit","description":"Die Empfindlichkeit gibt Cephable an, wie weit Sie sich bewegen m\xfcssen, um eine Steuerung auszul\xf6sen. Je gr\xf6\xdfer der Wert (ganz rechts auf dem Schieberegler), desto h\xf6her ist die Empfindlichkeit und desto weniger m\xfcssen Sie sich bewegen, um die Steuerung auszul\xf6sen.","tilt":{"title":"Kopfneigungsempfindlichkeit","description":"Diese Werte bestimmen, wie weit Sie Ihren Kopf nach oben, unten, links und rechts neigen m\xfcssen, um Bedienelemente auszul\xf6sen","up":"Neigungsempfindlichkeit","down":"Neigungsempfindlichkeit","left":"Neigungsempfindlichkeit nach links","right":"Neigungsempfindlichkeit nach rechts","scaleHigh":"Leichte Neigung","scaleLow":"Gro\xdfe Neigung"},"turn":{"title":"Kopfdrehempfindlichkeit","description":"Diese Werte bestimmen, wie weit Sie Ihren Kopf nach links und rechts drehen m\xfcssen, um Bedienelemente auszul\xf6sen","left":"Empfindlichkeit f\xfcr Linksabbiegen","right":"Empfindlichkeit f\xfcr Rechtsabbiegen","scaleHigh":"Leichte Wendung","scaleLow":"Gro\xdfe Wende"},"lean":{"title":"Kopfneigungsempfindlichkeit","description":"Diese Werte bestimmen, wie weit Sie Ihren Kopf nach vorne und hinten neigen m\xfcssen, um Bedienelemente auszul\xf6sen","forward":"Empfindlichkeit beim Vorw\xe4rtslehnen","back":"Zur\xfccklehnen-Empfindlichkeit","right":"Empfindlichkeit der Neigung nach rechts","left":"Empfindlichkeit f\xfcr Neigung nach links","scaleHigh":"Leichte Neigung","scaleLow":"Gro\xdfes Lean"},"duck":{"title":"Kopfentspannung/Kopfanstiegsempfindlichkeit","description":"Diese Werte bestimmen, wie weit Sie Ihren Kopf beugen oder heben m\xfcssen, um die Steuerung auszul\xf6sen","down":"Empfindlichkeit von Entendaunen","up":"Sensibilit\xe4t steigern","scaleHigh":"Leichte Verschiebung","scaleLow":"Gro\xdfe Verschiebung"}},"face":{"title":"Gesichtsausdrucksempfindlichkeit","description":"Die Empfindlichkeit gibt Cephable an, wie \xfcbertrieben ein Ausdruck sein muss, damit ein Steuerelement ausgel\xf6st wird. Je gr\xf6\xdfer der Wert (ganz rechts auf dem Schieberegler), desto h\xf6her ist die Empfindlichkeit und desto weniger m\xfcssen Sie sich bewegen, um das Steuerelement auszul\xf6sen.","eyebrow":{"title":"Empfindlichkeit der Augenbrauen","description":"Diese Werte bestimmen, wie weit Sie Ihre Augenbrauen heben oder senken m\xfcssen, um die Steuerung auszul\xf6sen","up":"Erh\xf6hen Sie die Empfindlichkeit der Augenbrauen","scaleHigh":"Leichte Erh\xf6hung","scaleLow":"Gro\xdfe Erh\xf6hung"},"mouth":{"title":"Mundempfindlichkeit","description":"Diese Werte bestimmen, wie weit Sie Ihren Mund \xf6ffnen oder schlie\xdfen m\xfcssen, um Bedienelemente auszul\xf6sen","open":"Empfindlichkeit beim \xd6ffnen des Mundes","close":"Empfindlichkeit bei geschlossenem Mund","smile":"L\xe4chelempfindlichkeit","scaleHigh":"Leicht ge\xf6ffnet","scaleLow":"Gro\xdfes offenes","closeScaleHigh":"Leicht geschlossen","closeScaleLow":"Dicht verschlossen","smileScaleHigh":"Leichtes L\xe4cheln","smileScaleLow":"Gro\xdfes L\xe4cheln"}},"mouse":{"title":"Kopfbewegung zur Maussteuerung","description":"Legen Sie fest, ob und wie Sie zum Bewegen der Maus Kopfbewegungssteuerungen verwenden m\xf6chten, anstatt andere Ausgaben auszul\xf6sen.","enable":{"title":"Kopfbewegung f\xfcr Maussteuerung aktivieren","description":"Wenn dies eingeschaltet ist, werden einige Ihrer Kopfbewegungssteuerelemente anstelle der Triggersteuerelemente zum Bewegen Ihrer Maus verwendet.","option":"Kopfsteuerung f\xfcr Mausbewegungen verwenden?"},"input":{"title":"Mauseingabetyp","description":"W\xe4hlen Sie aus, welche Art von Kopfgesten Sie der Maussteuerung zuweisen m\xf6chten. Beispielsweise bedeutet Kopfneigen, dass Sie Ihren Kopf nach links und rechts neigen k\xf6nnen, um die Maus nach links und rechts zu bewegen, Kopfdrehen bedeutet, dass Sie Ihren Kopf nach links und rechts drehen k\xf6nnen, um die Maus zu bewegen, und Kopfneigen bedeutet, dass Sie sich nach links und rechts neigen k\xf6nnen, um die Maus zu bewegen.","option":"Eingabetyp ausw\xe4hlen","optionLong":"W\xe4hlen Sie die Art der Kopfbewegung aus, die Sie zur Steuerung Ihrer Maus verwenden m\xf6chten."},"invert":{"title":"Mausbewegung umkehren","description":"Wenn diese Option aktiviert ist, wird die Richtung, in die Sie Ihren Kopf bewegen, umgekehrt zur Richtung, in die Sie Ihre Maus bewegen. F\xfcr die X-Achse: Wenn diese Option aktiviert ist, bewegt eine Bewegung nach links Ihre Maus nach rechts und eine Bewegung nach rechts nach links. F\xfcr die Y-Achse: Wenn diese Option aktiviert ist, bewegt eine Bewegung nach unten Ihre Maus nach oben und eine Bewegung nach oben nach unten.","x":"Mausbewegung auf der X-Achse umkehren?","y":"Mausbewegung auf der Y-Achse umkehren?"},"mode":{"title":"Mausbewegungsmodus","description":"W\xe4hlen Sie aus, wie der Cursor auf Ihre Kopfbewegungen reagieren soll."},"speed":{"title":"Mausgeschwindigkeit","description":"Bestimmen Sie die konstante Geschwindigkeit, mit der sich der Cursor bewegen soll.","fast":"Schnell","slow":"Langsam"},"linear":{"title":"Lineare Mausbewegung","description":"Wenn diese Option aktiviert ist, bewegt sich der Cursor nur in geraden horizontalen oder vertikalen Linien. Dies erleichtert die Navigation in diese spezifischen Richtungen ohne diagonale Abweichungen.","option":"Lineare Mausbewegung verwenden?"},"accelerationRate":{"title":"Reaktionsverz\xf6gerung bei Mausbeschleunigung","description":"Die Anzahl der Millisekunden, die zum Erh\xf6hen der Mausgeschwindigkeit ben\xf6tigt wird."},"accelerationCurve":{"title":"Mausbeschleunigungskurve","description":"Passen Sie die Rate an, mit der die Cursorgeschwindigkeit im Verh\xe4ltnis zur Kopfbewegung zunimmt.","linear":"Linear","exponential":"Exponentiell","sublinear":"Unterlinear"},"maximumSpeed":{"title":"Maximale Mausgeschwindigkeit","description":"Bestimmen Sie die maximale Anzahl an Pixeln, die sich der Cursor pro Sekunde bewegen kann."},"off":{"title":"Aus","description":"Die Mausbewegung ist deaktiviert."},"steadyGlide":{"title":"Gleichm\xe4\xdfiges Gleiten","description":"Wenn Sie Ihren Kopf \xfcber einen bestimmten Punkt hinaus bewegen, gleitet der Cursor kontinuierlich mit gleichm\xe4\xdfiger Geschwindigkeit in diese Richtung."},"speedBoost":{"title":"Geschwindigkeitsschub","description":"Der Cursor bewegt sich schneller, je l\xe4nger Sie Ihren Kopf in einer Position halten. Je l\xe4nger Sie Ihren Kopf still halten, desto schneller beschleunigt der Cursor."},"dynamicGlide":{"title":"Dynamisches Gleiten","description":"Die Geschwindigkeit des Cursors erh\xf6ht sich, je weiter Sie Ihren Kopf bewegen. Je weiter Sie Ihren Kopf bewegen, desto schneller gleitet der Cursor."},"proportionalSpeed":{"title":"Proportionale Geschwindigkeit","description":"Der Cursor folgt Ihrer Nasenspitze proportional zu Ihren Bildschirmabmessungen."},"disabled":"Diese Funktion ist f\xfcr Remote-Verbindungen und Nebenstellen deaktiviert."}},"stop":"Kamera stoppen","show":"Kamera anzeigen","hide":"Kamera ausblenden","warn":"Die Kamerasteuerung wurde nicht gestartet. Starten Sie Ihre Kamera, um die Gesichts- und K\xf6rpersteuerung zu erm\xf6glichen.","draw":{"error":"Fehler beim Laden des Kamera-Feeds. Bitte \xfcberpr\xfcfen Sie Ihre Kamera und versuchen Sie es erneut."},"select":"W\xe4hlen Sie eine Kamera aus, mit der Sie eine Verbindung herstellen m\xf6chten, um erweiterte Steuerfunktionen \xfcber Ihr Gesicht, Ihren K\xf6rper und die Schnellaktionstasten zu erhalten."},"microphone":{"windowTitle":"Cephable-Sprachsteuerung","title":"Mikrofon","titlePlural":"Mikrofone","settings":"Mikrofoneinstellungen","start":"Mikrofon starten","stop":"Mikrofon stoppen","descriptionShort":"Erm\xf6glicht Sprachbefehle und Diktate.","description":"Verwenden Sie Ihr eingebautes Mikrofon, um Sprachsteuerung und Diktieren zu aktivieren.","select":"W\xe4hlen Sie ein Mikrofon aus, das Sie f\xfcr eine erweiterte Steuerung per Sprache koppeln m\xf6chten.","empty":"Keine Mikrofone gefunden.","search":"Suche nach Mikrofonnamen","manage":{"title":"Klicken Sie hier, um Details zu Ihren Mikrofonen anzuzeigen und zu verwalten.","description":""},"permission":{"title":"Mikrofonberechtigungen erforderlich","description":"Um die Sprachsteuerung nutzen zu k\xf6nnen, m\xfcssen Sie Cephable die Berechtigung erteilen, Ihr Mikrofon zu verwenden.","button":"Berechtigungseinstellungen \xf6ffnen","no":"Kein Mikrofonzugriff","help":"Cephable ben\xf6tigt Zugriff auf Ihr Mikrofon, um Sprachsteuerungen verwenden zu k\xf6nnen. Navigieren Sie zu <strong>Systemeinstellungen</strong> > <strong>Datenschutz</strong> > <strong>Mikrofon</strong> und erm\xf6glichen Sie Cephable den Zugriff auf Ihr Mikrofon."},"controls":{"loadingDetail":"Dies kann einige Minuten dauern.","pause":"Sprachsteuerung pausieren","paused":"Steuerung angehalten.","resume":"Sprachsteuerung fortsetzen","dictationPlay":"Diktiermodus starten","dictationPause":"Diktiermodus beenden","prompt":"Beginnen Sie zu sprechen, um hier Ihre Sprachsteuerung anzuzeigen \u2026","dictationPrompt":"Beginnen Sie zu sprechen, um einzutippen, was Sie sagen m\xf6chten \u2026","latency":"Hohe Latenz erkannt. Schlie\xdfen Sie ggf. einige Anwendungen, die m\xf6glicherweise zu viele Ressourcen verbrauchen.","noDeviceConnectedDescription":"Die Mikrofonsteuerung dient als Vorschau der Oberfl\xe4che. Es werden keine Schritte erfolgreich ausgef\xfchrt. Verbinden Sie dieses Begleitger\xe4t mit einem anderen, um Befehle auszul\xf6sen.","status":{"loadingModel":"Sprachmodell wird geladen \u2026","paused":"Angehalten.","dictating":"Diktieren.","optimistic":"Optimistisch:","listening":"H\xf6ren:","thinking":"Denken...","loadingPhiModel":"Textgenerierungsmodell wird geladen \u2026","generatingText":"Generieren...","preparingPhiModel":"Textgenerierungsmodell wird vorbereitet ...","permission":"Mikrofonberechtigungen werden \xfcberpr\xfcft \u2026","typing":"Tippen..."},"generatingTextDetail":"Stoppen Sie die Generierung, indem Sie Apps \xe4ndern oder \u201EStoppen Sie die Generierung\u201C sagen."},"edit":{"title":"Mikrofoneinstellungen bearbeiten","autoStart":{"title":"Mikrofon automatisch starten","option":"Mikrofon und Sprachsteuerung automatisch starten?","description":"Wenn diese Einstellung aktiviert ist, schaltet Ihr Eingabeger\xe4t die Mikrofone ein und beginnt mit der Sprachsteuerung, sobald es nach dem Anschlie\xdfen oder Einschalten hochf\xe4hrt. Wenn diese Einstellung deaktiviert ist, tippen Sie auf der Verbindungsseite auf die Schaltfl\xe4che \u201EMith\xf6ren starten\u201C."},"optimistic":{"title":"Optimistische Sprachsteuerung","option":"Optimistische Sprachsteuerung verwenden?","description":"Cephable bietet zwei verschiedene Empfindlichkeitsmodi f\xfcr die Sprachsteuerung: Standard und Optimistisch. Im Standardmodus erkennt Cephable alle W\xf6rter und kann im Diktiermodus verwendet werden. Im optimistischen Modus konzentriert sich Cephable st\xe4rker auf die Sprachsteuerung in Ihren App-Steuerelementen. Im optimistischen Modus werden Ihre Sprachsteuerungen schneller ausgel\xf6st, Sie k\xf6nnen aber auch versehentlich Ihre Steuerung ausl\xf6sen, wenn Sie nicht das genaue Wort sagen. Diktieren ist im optimistischen Modus nicht m\xf6glich."},"confirm":{"title":"Sie haben nicht gespeicherte \xc4nderungen.","description":"Es wurden nicht gespeicherte \xc4nderungen erkannt. M\xf6chten Sie vor dem Beenden speichern?"},"aiCommands":{"title":"Intelligente Sprachbefehle","description":"Dank intelligenter Sprachbefehle kann Cephable AI Ihre Sprachbefehle vorhersagen, ohne sie exakt einhalten zu m\xfcssen. So k\xf6nnen Sie Ihrem Computer nat\xfcrlichere Anweisungen geben, und Cephable hilft Ihnen, diese zu verstehen.","option":"Intelligente Sprachbefehle verwenden?"},"aiDictation":{"title":"Intelligentes Diktieren und Schnelltippen","description":"Intelligentes Diktieren und Quick Type bieten die pr\xe4ziseste Eingabe auf dem Ger\xe4t. Die Diktierfunktion verarbeitet Zeichensetzung, Eigennamen und Satzstruktur automatisch, w\xe4hrend Quick Type intelligente Vorhersagen und Korrekturen bietet, die Ihnen helfen, einfach und pr\xe4zise zu schreiben.","option":"Intelligentes Diktieren und Schnelltyp verwenden?"},"description":"Verwalten Sie Ihre Sprachbefehle und Diktiereinstellungen f\xfcr diese Verbindung."},"warn":"Ihr Mikrofon wurde nicht gestartet. Starten Sie das Mikrofon, um Sprachbefehle und Diktate zu erm\xf6glichen.","devices":{"error":"Mikrofon-Eingabeger\xe4t nicht gefunden."},"startDescription":"Schalten Sie das Mikrofon ein, um mit dem Anh\xf6ren von Befehlen zu beginnen."},"localization":{"title":"Spracheinstellungen","titleShort":"Sprache","description":"W\xe4hlen Sie Ihre bevorzugte Sprache aus einer Liste unterst\xfctzter Sprachen aus.","newUserDescription":"Bitte w\xe4hlen Sie eine bevorzugte Sprache aus, bevor Sie fortfahren.","edit":"Sprache aktualisieren","display":{"title":"Anzeigesprache","description":"Sprache, die bei der Verwendung von Cephable angezeigt wird. Dazu geh\xf6ren Dinge wie Men\xfcs, Benachrichtigungen und App-Steuerelemente, die in der Sprache Ihrer Wahl angezeigt werden."},"voice":{"title":"Sprache f\xfcr die Sprachsteuerung","description":"Dies ist die Sprache, die bei der Erkennung von Diktaten und Sprachbefehlen verwendet wird. Durch die Angabe der Sprache wird die Genauigkeit Ihrer Spracheingaben verbessert.","settings":{"title":"Spracherkennung und Anzeigesprache","description":"Passen Sie Ihre Spracheinstellungen f\xfcr Anzeige und Sprachsteuerung an. Mit dieser Option k\xf6nnen Sie Ihre bevorzugten Sprachen f\xfcr Bildschirmtext und Mikrofoninteraktionen wie Sprachsteuerung und Diktierfunktion ausw\xe4hlen."}},"locales":{"en":"English - Englisch","en-us":"English (US) - Englisch (US)","es":"Espa\xf1ol \u2014 Spanisch","fr":"Fran\xe7ais \u2013 Franz\xf6sisch","it":"Italiano \u2013 Italienisch","de":"Deutsch","ja":"\u65E5\u672C\u8A9E - Japanisch","en-gb":"English (UK) - Englisch (UK)","en-in":"English (India) - Englisch (Indien)"},"save":{"success":"Benutzer-Gebietsschemaeinstellungen gespeichert!","error":"Fehler beim Speichern der Gebietsschemaeinstellungen des Benutzers"},"profile":{"view":"Varianten","title":"App-Steuerungssprache","question":"Welche App-Steuerungssprache m\xf6chten Sie bearbeiten?","description":"Einige App-Steuerelemente bieten Varianten f\xfcr verschiedene Sprachen. Wechseln Sie zu einer anderen Sprache, um die Einstellungen zu bearbeiten und anzupassen.","change":"Sprache \xe4ndern"},"unsupported":{"title":"Nicht unterst\xfctzte Sprache {{locale}}","description":"Die ausgew\xe4hlte Sprache wird nicht unterst\xfctzt. Bitte w\xe4hlen Sie eine andere Sprache."},"select":"Sprache ausw\xe4hlen","localesShort":{"en":"Englisch","en-us":"Englisch (USA)","es":"Spanisch","fr":"Franz\xf6sisch","it":"Italienisch","de":"Deutsch","ja":"japanisch"}},"license":{"trial":{"subtitle":"Sie k\xf6nnen {{count}} Kollegen einladen, Cephable mit Ihnen auszuprobieren.","noUsersSubtitle":"Sie haben keine Testbenutzer mehr. Aktualisieren Sie auf eine kostenpflichtige Lizenz, um weitere Benutzer hinzuzuf\xfcgen.","expired":{"user":"Ihr kostenloses Upgrade auf {{productName}} l\xe4uft am {{date}} ab. Um ein Upgrade durchzuf\xfchren, wenden Sie sich bitte an Ihren Organisationsadministrator \u2013 {{admin}}.","admin":"Ihr kostenloses Upgrade auf {{productName}} l\xe4uft am {{date}} ab.","userLong":"Ihr kostenloses Upgrade auf {{productName}} ist abgelaufen. Um ein Upgrade durchzuf\xfchren, wenden Sie sich bitte an Ihren Organisationsadministrator \u2013 {{admin}}.","adminLong":"Ihr kostenloses Upgrade auf {{productName}} ist abgelaufen. Sie k\xf6nnen Ihre Lizenz upgraden, um weiterhin auf erweiterte Funktionen zuzugreifen, die in Cephable Basic nicht verf\xfcgbar sind."},"start":"Kostenlose Testversion starten","title":{"single":"Sie wurden kostenlos auf {{productName}} mit {{days}} verbleibenden Tagen aktualisiert.","multiple":"{{organization}} ist in einer kostenlosen Testversion mit {{days}} verbleibenden Tagen"},"upgrade":"Behalten Sie durch das Upgrade Ihren Zugriff auf Funktionen wie erweiterte Sprachsteuerung, intelligente KI-Aufgaben und viele vorgefertigte App-Steuerungen."},"required":{"title":"Eine Cephable Professional-Lizenz ist erforderlich","description":"Sie verwenden offenbar Cephable Basic. Die kommerzielle Nutzung von Cephable wird jedoch nicht unterst\xfctzt. Bitte aktualisieren Sie auf eine professionelle Lizenz, um die App weiterhin nutzen zu k\xf6nnen."},"upgrade":{"professional":"Upgrade auf die Cephable Professional-Lizenz","generic":{"title":"Verbessern Sie Ihr Cephable-Erlebnis","description":"Die Cephable-Plattform bietet verschiedene Produkte f\xfcr den kommerziellen Einsatz am Arbeitsplatz, in der Schule oder integriert in native L\xf6sungen."},"fallback":{"title":"Fehler beim Laden des Abrechnungsportals","description":"Das Abrechnungsportal konnte nicht geladen werden. Klicken Sie bitte auf die Schaltfl\xe4che unten, um sales@cephable.com zu kontaktieren und mit dem Upgrade fortzufahren."}},"activate":{"question":"Sie haben bereits einen Lizenzschl\xfcssel?","button":"Aktivieren","title":"Lizenzschl\xfcssel Aktivieren","description":"Geben Sie Ihren Lizenzschl\xfcssel ein, um Cephable zu aktualisieren. Wenn Sie keinen haben, starten Sie eine kostenlose Testversion oder erwerben Sie eine Lizenz.","fieldLabel":"Lizenzschl\xfcssel","placeholder":"NkmurBfZzFrmm9Kx","success":"Gl\xfcckwunsch. Ihr Konto wurde auf {{license}} aktualisiert!","invalid":{"key":"Ung\xfcltiger Schl\xfcssel. Bitte stellen Sie sicher, dass Sie den richtigen Schl\xfcssel eingegeben haben.","empty":{"key":"Ung\xfcltiger Schl\xfcssel. Bitte stellen Sie sicher, dass Sie einen Wert eingegeben haben.","name":"Ung\xfcltiger Organisationsname. Bitte stellen Sie sicher, dass Sie einen Wert eingegeben haben."}},"descriptionLong":"Geben Sie Ihren Lizenzschl\xfcssel ein, um Cephable zu aktualisieren. Wenn Sie keinen haben, starten Sie eine kostenlose Testversion oder erwerben Sie eine Lizenz."},"welcome":{"title":"Willkommen bei {{license}}.","description":"Sie sind {{organization}} erfolgreich beigetreten. {{description}}"},"redirect":{"title":"Umleitung","description":"Sie wurden zu einem externen Abrechnungsportal weitergeleitet. In Ihrem Browser wird ein neuer Tab ge\xf6ffnet. Wenn Sie nicht innerhalb weniger Sekunden weitergeleitet werden, klicken Sie bitte auf die Schaltfl\xe4che unten.","error":"Fehler bei der Rechnungsumleitung","external":"Sie wurden weitergeleitet. Bitte \xfcberpr\xfcfen Sie Ihren Browser."},"key":{"title":"Lizenzschl\xfcssel","titlePlural":"Lizenzschl\xfcssel","description":"Ein Lizenzschl\xfcssel ist eine eindeutige Kennung, die zum Gew\xe4hren des Zugriffs auf die Funktionen \u201ECephable Professional\u201C, \u201EEducation\u201C oder \u201EDeveloper\u201C verwendet wird.","details":"Details zum Lizenzschl\xfcssel","assigned":"Verwendet am: {{date}}","expires":"L\xe4uft ab am: {{date}}","assign":"Schl\xfcssel einer neuen Organisation zuweisen","error":"Fehler beim Laden des Lizenzschl\xfcssels.","empty":{"title":"Keine Lizenzschl\xfcssel gefunden.","description":"Es scheint, als g\xe4be es keine Lizenzschl\xfcssel, die diesen Kriterien entsprechen. Oder Sie haben noch keinen Lizenzschl\xfcssel erworben."},"product":{"title":"Kaufen","titleLong":"Lizenzschl\xfcssel kaufen","description":"Erwerben Sie einen Lizenzschl\xfcssel, um das volle Potenzial von Cephable auszusch\xf6pfen. Sehen Sie sich die verschiedenen verf\xfcgbaren Pl\xe4ne und Preisoptionen an.","action":"Jetzt kaufen","empty":{"title":"Keine Produkte gefunden.","description":"Es sieht so aus, als h\xe4tten Sie keine Produkte. Bitte wenden Sie sich an unser Vertriebsteam oder Ihren Vertreter, um das Problem zu l\xf6sen."},"yearly":"J\xe4hrliche Abrechnung","years":"Abrechnung alle {{value}} Jahre","days":"Abrechnung alle {{value}} Tage","Subscription":{"title":"Abonnement"},"MeteredConsumption":{"title":"Gemessener Verbrauch"},"PayDown":{"title":"R\xfcckzahlung"},"OneTime":{"title":"Einmalig"}}},"pro":{"tag":"Pro","detail":"Dies ist eine Funktion, die nur Cephable Professional bietet.","requiredDetail":"F\xfcr diese Funktion ist eine Cephable Professional-Lizenz erforderlich. Sie k\xf6nnen in Ihren Kontoeinstellungen ein Upgrade durchf\xfchren oder eine kostenlose Testversion starten."},"titlePlural":"Lizenzen"},"purchase":"Kaufen","saveError":"Fehler beim Speichern der \xc4nderungen.","description":"Beschreibung","expand":"Expandieren","expandMenu":"Men\xfc erweitern","editor":{"title":"Markdown-Editor","bold":"Deutlich","italic":"Kursiv","underline":"Unterstreichen","hr":"Horizontale Regel","link":"Link","quote":"Zitat","code":"Code","codeBlock":"Codeblock","comment":"Kommentar","image":"Bild","table":"Tisch","unordered-list":"Ungeordnete Liste","ordered-list":"Sortierte Liste","checked-list":"Pr\xfcfliste","help":"Helfen","edit":"Bearbeiten","live":"Live","preview":"Vorschau","fullscreen":"Vollbild","placeholder":"Bitte geben Sie hier Markdown-Text ein ...","strikethrough":"Durchgestrichen"},"created":"Erstellt: {{value}}","updated":"Aktualisiert: {{value}}","deleted":"Gel\xf6scht: {{value}}","expires":"L\xe4uft ab: {{value}}","expired":"Abgelaufen: {{value}}","used":"Verwendet: {{value}}","results":"Ergebnisse","panel":{"title":"Cephable-Panel","question":"Autostart-Panel?","position":{"top":"Spitze","right":"Rechts","left":"Links","bottom":"Unten ","description":"W\xe4hlen Sie aus, wo das Cephable Panel auf Ihrem Bildschirm angezeigt werden soll.","label":"Position"},"sections":{"description":"W\xe4hlen Sie aus, welche Abschnitte im Bedienfeld sichtbar sein sollen. Sie k\xf6nnen Abschnitte nach Ihren W\xfcnschen ausblenden, um den Platz im Bedienfeld optimal zu nutzen.","microphone":"Mikrofon- und Sprachsteuerung","camera":"Kamera- und Gesichts-/Kopfsteuerung","profile":"App-Steuerung und Vorschau","globalControls":"Globale und Ger\xe4testeuerungen","tasks":"Intelligente Aufgaben","buttons":"Schnellaktionsschaltfl\xe4chen"},"titleShort":"Panel","description":"Dies ist das Bedienfeld, das als Hauptsteuerungszentrale dient. Es ist immer sichtbar und erm\xf6glicht Ihnen unter anderem die Steuerung Ihrer Apps per Sprachbefehl."},"resume":"Wieder aufnehmen","textGeneration":{"settings":"Einstellungen zur Textgenerierung","edit":{"title":"Einstellungen f\xfcr die Textgenerierung bearbeiten","description":"Sie k\xf6nnen die Einstellungen f\xfcr Ihre intelligente Textgenerierung verfeinern, um die f\xfcr Sie besten Ergebnisse zu erzielen.","autoStart":{"title":"Automatisches Aufw\xe4rmen der Textgenerierung","description":"Ist diese Einstellung aktiviert, w\xe4rmt Cephable AI die f\xfcr die Textgenerierung verwendeten KI-Modelle automatisch auf. Dadurch werden die Modelle bei der Verwendung von Generierungsbefehlen schneller ausgef\xfchrt, verbrauchen aber mehr Ressourcen auf Ihrem Computer. Das Deaktivieren dieser Einstellung spart Ressourcen, kann aber die Textgenerierung verlangsamen.","option":"Automatisches Aufw\xe4rmen von KI-Modellen zur Textgenerierung?"},"prompt":{"title":"Zus\xe4tzliche Informationen zur Textgenerierung","description":"Geben Sie zus\xe4tzliche Details ein, die mit der KI von Cephable zur Textgenerierung verwendet werden sollen. Nutzen Sie dieses Feld, um Ihre Pr\xe4ferenzen f\xfcr Ton, Schreibstil oder andere Details einzugeben.","field":"Zus\xe4tzliche Eingabeaufforderung","placeholder":"Verwenden Sie beispielsweise einen freundlichen Ton, schreiben Sie professionell, seien Sie pr\xe4gnant und auf den Punkt. Hinterlassen Sie beim Schreiben von Code durchdachte, aber nicht zu viele Kommentare usw."},"enableTextGen":{"title":"Intelligente Textgenerierung aktivieren","description":"Wenn diese Einstellung aktiviert ist, kann Cephable AI die Ger\xe4testeuerung zur Textgenerierung nutzen, um in jeder App Text f\xfcr Sie zu generieren. Wenn Sie diese Einstellung deaktivieren, wird dieser Befehl deaktiviert.","option":"Intelligente Textgenerierung verwenden?"},"terminate":{"title":"Ressourcen zur Klartextgenerierung","description":"Klicken Sie hier, um die f\xfcr die Textgenerierung verwendeten Ressourcen zu l\xf6schen. Dadurch werden Ressourcen auf Ihrem Computer freigegeben, die Textgenerierung kann jedoch bei der n\xe4chsten Verwendung langsamer werden.","button":"Ressourcen l\xf6schen","success":"Ressourcen zur Textgenerierung l\xf6schen.","confirm":{"title":"Ressourcen zur Klartextgenerierung","description":"M\xf6chten Sie die f\xfcr die Textgenerierung verwendeten Ressourcen wirklich l\xf6schen? Dadurch werden zwar Ressourcen auf Ihrem Computer freigegeben, die Textgenerierung kann jedoch bei der n\xe4chsten Verwendung langsamer werden.","confirm":"Ja, klare Ressourcen","cancel":"Stornieren"}},"clearModelCache":{"title":"KI-Modell-Cache l\xf6schen","description":"W\xe4hlen Sie aus, welche KI-Modelle im Cache gel\xf6scht und neu heruntergeladen werden sollen. Dadurch wird Speicherplatz auf Ihrem Computer freigegeben und die ausgew\xe4hlten Modelldateien werden erneut heruntergeladen.","button":"L\xf6schen und erneut herunterladen","success":"Lokale Modelldateien gel\xf6scht.","confirm":{"title":"KI-Modellcache l\xf6schen und neu herunterladen","description":"M\xf6chten Sie den Cache des ausgew\xe4hlten KI-Modells wirklich leeren und die Dateien von Ihrem System l\xf6schen? Die ausgew\xe4hlten Modelle werden automatisch erneut heruntergeladen.","confirm":"Ja, l\xf6schen und erneut herunterladen.","cancel":"Stornieren","textGenLabel":"Text Generation (Inference) model","workflowsLabel":"AI Workflows models"},"error":"Fehler beim L\xf6schen lokaler Modelldateien."},"enableHistory":{"title":"Textgenerierungsverlauf aktivieren","description":"Wenn diese Einstellung aktiviert ist, verwendet Cephable AI Ihren Textgenerierungsverlauf, um Text im Kontext Ihrer vorherigen Aktion zu generieren.","option":"Textgenerierungsverlauf verwenden?"}},"prompt":{"systemPrompt":"Generieren Sie AUSSCHLIESSLICH den angeforderten Text \u2013 keine Erkl\xe4rungen, Kommentare oder sonstige Zus\xe4tze. Kein unaufgefordertes Markdown oder Erl\xe4uterungen. Geben Sie bei Code ausschlie\xdflich den Rohcode aus: keine Codebl\xf6cke, keine Sprachkennzeichnungen, keine Erl\xe4uterungen.","appName":"Sie generieren derzeit Text f\xfcr {{appName}}.","userPreferences":"Beachten Sie diese Benutzereinstellungen hinsichtlich der Textgenerierung: {{userPreferences}}."},"rewritePrompt":{"systemPrompt":"Schreiben oder formatieren Sie den bereitgestellten Text gem\xe4\xdf den Anweisungen um. Bei der Umformatierung (z. B. Listen, Tabellen, Struktur\xe4nderungen) behalten Sie den Originaltext exakt bei. Bei der \xdcberarbeitung (z. B. Tonfall, Stil, L\xe4nge) bewahren Sie die Bedeutung, aber nicht unbedingt den Wortlaut. Geben Sie NUR das Ergebnis aus \u2013 ohne Erkl\xe4rungen oder Kommentare. Dies kann Teil eines gr\xf6\xdferen Dokuments sein. Geben Sie nur das Ergebnis ohne \xdcberschriften, Beschriftungen oder Einleitung aus.","userPreferences":"Beachten Sie diese Benutzereinstellungen hinsichtlich der Textgenerierung: {{userPreferences}}.","rewriteInstructions":"Anweisungen: {{rewriteInstructions}}."},"translatePrompt":{"systemPrompt":"\xdcbersetzen Sie den folgenden Text in {{language}}. Geben Sie NUR den \xfcbersetzten Text aus. Keine Erkl\xe4rungen, keine Pr\xe4ambel, keine Markdown-Formatierung, keine Codebl\xf6cke. Formatierung beibehalten. F\xfcr Code: Nur Kommentare und Zeichenketten \xfcbersetzen, Syntax exakt beibehalten.","userPreferences":"Beachten Sie diese Benutzereinstellungen hinsichtlich der Textgenerierung: {{userPreferences}}.","genericUserPrompt":"\xdcbersetzen: {{userRequestText}}"},"disabled":{"title":"Intelligente Aufgaben sind deaktiviert","description":"Sie haben anscheinend intelligente Aufgaben deaktiviert. Aktualisieren Sie Ihre Einstellungen, um Textgenerierung, Textumschreibung und weitere Funktionen freizuschalten."},"summarizePrompt":{"systemPrompt":"Fassen Sie den bereitgestellten Text kurz und pr\xe4gnant zusammen. Er kann Teil eines l\xe4ngeren Dokuments sein. Geben Sie NUR die Zusammenfassung aus \u2013 keine Einleitung, Beschriftungen oder Erl\xe4uterungen.","userPreferences":"Beachten Sie diese Benutzereinstellungen f\xfcr die Textgenerierung: {{userPreferences}}.","userPrompt":"Zusammenfassend: {{userRequestText}}"}},"profile":{"title":"App-Steuerung","titlePlural":"App-Steuerung","titlePreview":"Vorschau der Steuerelemente","previous":"Vorherige App-Steuerelemente","manage":"App-Steuerelemente verwalten","view":"Steuerelemente anzeigen","edit":"App-Steuerelemente bearbeiten","add":"App-Steuerelemente hinzuf\xfcgen","create":"App-Steuerelemente erstellen","warn":"Um Ihre App-Steuerung verwenden zu k\xf6nnen, m\xfcssen Kamera oder Mikrofon gestartet sein.","descriptionShort":"Entdecken Sie die verschiedenen M\xf6glichkeiten, wie Cephable Ihnen bei der Steuerung Ihrer Ger\xe4te und Software hilft.","name":"App-Name","nameQuestion":"Wie m\xf6chten Sie diese App-Steuerelemente nennen?","newName":"Neue App-Steuerelemente","search":"App-Steuerelemente nach Namen durchsuchen","searchLong":"Suchen Sie nach App-Steuerelementen nach Name oder Beschreibung","keyboardAndMouse":"Tastatur und Maus","genericController":"Gamepad-Controller","keyboardMouseAndController":"Tastatur, Maus und Controller","permissionError":"Sie haben keine Berechtigung, diese App-Steuerelemente zu verwenden.","set":{"title":"Es sieht nicht so aus, als h\xe4tten Sie die App-Steuerung bereits eingerichtet.","cta":"App-Steuerelemente festlegen","empty":{"auto":"Wechseln Sie zu einer anderen App, um die Steuerelemente anzuzeigen","select":"W\xe4hlen Sie ein Steuerelement aus, um zu beginnen","none":"Keine App-Steuerelemente gefunden"},"description":"Mithilfe der App-Steuerung wei\xdf Cephable, worauf es achten muss und welche Aktionen ausgef\xfchrt werden sollen. Sie k\xf6nnen die App-Steuerung jederzeit von der Startseite oder \xfcber Ihre Verbindungseinstellungen \xe4ndern."},"summary":{"title":"Zusammenfassung der App-Steuerelemente","descriptionLong":"Hier sind die Details dieser App-Steuerelemente. Sie k\xf6nnen nach Steuerelementen, Aktionen und mehr suchen, um zu sehen, was Sie mit diesen App-Steuerelementen tun k\xf6nnen.","description":"Erhalten Sie eine Zusammenfassung dieser App-Steuerelemente, einschlie\xdflich der verf\xfcgbaren Steuerelemente, Anpassungsm\xf6glichkeiten, Details und mehr.","view":"Zusammenfassung der App-Steuerelemente anzeigen","filter":"Filtern nach Eingabetyp","placeholder":"Steuerelementnamen suchen ..."},"copy":{"title":"App-Steuerelemente kopieren","duplicate":"Doppelte App-Steuerelemente","question":"Eine Kopie erstellen?","description":"M\xf6chten Sie eine neue Kopie dieser App-Steuerelemente erstellen? Dadurch wird ein neues Fenster mit den kopierten App-Steuerelementen ge\xf6ffnet. Die Kopie wird Ihrem Konto jedoch erst nach dem Speichern hinzugef\xfcgt.","confirm":"Ja, Kopie erstellen","profileSuffix":"{{name}} (Kopie)"},"new":{"title":"Neue App-Steuerelemente erstellen","description":"Entwickeln Sie Steuerelemente von Grund auf neu oder lassen Sie modernste KI personalisierte Steuerelemente erstellen, sodass Sie mithilfe Ihrer Stimme, Ihres Kopfes und Ihrer Gesichtsbewegungen m\xfchelos durch Apps und Software navigieren k\xf6nnen.","note":"Empfohlen f\xfcr fortgeschrittene Benutzer.","scratch":"Von Grund auf neu erstellen"},"advancedOptions":"Erweiterte Steuerungsoptionen","delete":{"title":"App-Steuerelemente l\xf6schen","titleLong":"L\xf6schen Sie diese App-Steuerelemente","description":"Sie k\xf6nnen diese App-Steuerelemente l\xf6schen, indem Sie auf \u201EApp-Steuerelemente l\xf6schen\u201C klicken.","confirm":"M\xf6chten Sie diese App-Steuerelemente wirklich l\xf6schen?","confirmLong":"Sobald Sie diese App-Steuerelemente gel\xf6scht haben, k\xf6nnen Sie nicht mehr darauf zugreifen. M\xf6chten Sie diese App-Steuerelemente wirklich l\xf6schen?","confirmButton":"Ja, diese App-Steuerelemente l\xf6schen"},"current":"Aktuelle Kontrollen","loading":"Steuerelemente werden geladen \u2026","null":"Sie haben noch keine App-Steuerelemente. Klicken Sie unten, um eines zu erstellen.","nullButton":"Erstellen Sie Ihre ersten App-Steuerelemente","preview":"Vorschau","features":"Merkmale","byline_public":"Von: Cephable Team","byline_shared":"Geteilt von: Cephable Community","share":{"title":"App-Steuerelemente teilen","previewTitle":"Vorschau der freigegebenen App-Steuerelemente","description":"Geben Sie diese App-Steuerelemente an andere weiter, damit diese eine Kopie erhalten und diese dann personalisieren k\xf6nnen!","descriptionLong":"Teilen Sie diese App-Steuerelemente mit anderen, damit diese eine Kopie erhalten und sie anschlie\xdfend personalisieren k\xf6nnen! W\xe4hlen Sie aus, wie Sie die App teilen m\xf6chten, und erstellen Sie anschlie\xdfend einen Link zum Senden an andere.","add":"Einen Freigabelink erstellen","confirm":"Teilen Sie diese URL","link":"Link teilen","copy":"Link kopieren","copied":"Kopiert!","usage":"Nutzungsmenge","created":"Erstellt {{value}}","expiration":{"title":"Ablauf","once":"Nur eine Verwendung zulassen","unlimited":"Unbegrenzte Nutzung zulassen","no":"Kein Ablaufdatum","date":"Verfallsdatum","dateDescription":"L\xe4uft an einem bestimmten Datum ab"},"manage":"Vorherige Freigabelinks verwalten","empty":"F\xfcr diese App-Steuerelemente wurden keine Freigaben erstellt."},"swap":{"title":"Steuerelemente austauschen","titleLong":"Tauschen Sie Ihre App-Steuerelemente aus","descriptionShort":"Verwenden Sie unterschiedliche App-Steuerelemente, die zu dem von Ihnen verwendeten Programm oder der Software passen.","description":"Sie k\xf6nnen zwischen verschiedenen App-Steuerelementen wechseln, um sie an das von Ihnen verwendete Programm oder die von Ihnen verwendete Software anzupassen."},"autoProfileSwitching":{"title":"Automatische Steuerungsumschaltung","alerts":{"disabled":"Die automatische Steuerungsumschaltung ist deaktiviert.","temporarilyDisabled":"Die automatische Steuerungsumschaltung ist vor\xfcbergehend deaktiviert.","enabled":"Die automatische Steuerungsumschaltung ist eingeschaltet.","error":"Fehler beim Speichern der Einstellungen f\xfcr die automatische Steuerungsumschaltung"},"associatedPrograms":{"add":"Ein neues zugeh\xf6riges Programm hinzuf\xfcgen","description":{"personal":"W\xe4hlen Sie die Software oder Programme aus, die Sie mit diesen Steuerelementen verbinden m\xf6chten. Dies unterst\xfctzt die automatische Steuerungsumschaltung, bei der Cephable diese App-Steuerelemente automatisch an das aktuell verwendete Programm anpasst.","short":"W\xe4hlen Sie die Software oder Programme aus, die Sie mit diesen Steuerelementen verbinden m\xf6chten."},"edit":"Zugeh\xf6rige Programme bearbeiten","noOptionsText":"Beginnen Sie mit der Eingabe, um zugeh\xf6rige Programme zu finden","profileLabel":"App-Steuerung:","remove":"Zugeh\xf6riges Programm entfernen","title":"Zugeh\xf6rige Programme","when":"Cephable schaltet meine App-Steuerung automatisch auf {{profileName}} um, wenn ich \u2026 verwende.","emptySearch":"Mit diesen Steuerelementen sind keine Programme verkn\xfcpft.","error":"Fehler beim Speichern der zugeh\xf6rigen Programme. Bitte versuchen Sie es sp\xe4ter erneut.","emptyError":"Leeres zugeh\xf6riges Programm erkannt. Bitte entfernen Sie es, bevor Sie fortfahren."},"commandOverlay":{"command":"App-Steuerung wechseln: {{value}}"},"description":"Durch die automatische Steuerungsumschaltung passt sich Cephable nahtlos an Ihren Arbeitsablauf an. Ist die Funktion aktiviert, passt Cephable Ihre App-Steuerung kontextbezogen an das verwendete Programm oder die verwendete Software an. Ist sie deaktiviert, k\xf6nnen Sie die App-Steuerung manuell \xfcber die Schaltfl\xe4che \u201ESteuerung tauschen\u201C oder \xfcber globale Befehle umschalten."},"error":{"noMatch":"Keine App-Steuerung entspricht Ihrer Suche.","load":"Fehler beim Laden der App-Steuerelemente.","add":"Fehler beim Hinzuf\xfcgen der App-Steuerelemente.","delete":"Fehler beim L\xf6schen der App-Steuerelemente.","audioEventsWithEmptyCommands":"In Ihrem Talkback fehlen Steuerelemente. \xdcberpr\xfcfen Sie Ihre Talkback-Steuerelemente, um sicherzustellen, dass sie vollst\xe4ndig sind.","conflicts":"Fehler beim Speichern der App-Steuerelemente aufgrund von Konflikten.","save":"Fehler beim Speichern der App-Steuerung. Bitte versuchen Sie es erneut.","device":"Ung\xfcltige App-Steuerung f\xfcr diese Verbindung. Bitte versuchen Sie es mit einer anderen."},"conflictIndicators":{"errorTitle":"Fehler beim Speichern der App-Steuerelemente aufgrund von Konflikten","warningTitle":"App-Steuerung mit Warnungen gespeichert","subtitle":"Die von Ihnen erstellten App-Steuerelemente weisen einige Konfigurationen auf, die zu Konflikten f\xfchren k\xf6nnen.","profileNameErrors":"Namenskonflikt bei App-Steuerelementen","emptyControlsMapped":"Leere Eingabenamen","emptyControlsMappedDescription":"Bitte f\xfcgen Sie Ihrer Eingabe einen Sprachbefehl, einen Gesichtsausdruck, eine Kopfneigung oder einen anderen Befehl hinzu.","emptyKeybindingControlsMapped":"Leere Eingabenamen f\xfcr Tastenkombinationen","emptyKeybindingControlsMappedDescription":"Bitte f\xfcgen Sie Ihrer Eingabe f\xfcr Tastenkombinationen einen Sprachbefehl, einen Gesichtsausdruck, eine Kopfneigung oder einen anderen Befehl hinzu.","duplicateNameTitle":"Doppelter Name der App-Steuerung","duplicateNameDescription":"Sie verf\xfcgen \xfcber bereits vorhandene App-Steuerelemente mit demselben Namen. Bitte \xe4ndern Sie den Namen, bevor Sie fortfahren.","emptyNameTitle":"Leerer Name der App-Steuerelemente","emptyNameDescription":"Die App-Steuerelemente m\xfcssen einen Namen haben, z. B. Spiel 1, Spotify, Word usw.","macrosReleaseKeysMissingTitle":"Ausgaben mit unver\xf6ffentlichten Schl\xfcsseln","macrosReleaseKeysMissingDescription":"Bitte f\xfcgen Sie einen Freigabeschl\xfcssel hinzu oder stoppen Sie alle Schritte, um zu verhindern, dass Schl\xfcssel h\xe4ngen bleiben.","duplicateInputCommandMacroTitle":"Identische Steuereing\xe4nge","duplicateCommandsDescription":"Bitte entfernen oder \xe4ndern Sie die doppelten Eingabebefehle.","duplicateInputCommandBindingsTitle":"Identische Steuereingaben f\xfcr Tastenkombinationen","conflictIndicatorDisplayString":"{{container}} : {{commandOrKeyName}} mit {{commandOrEventType}}","duplicateMacroNames":"Doppelte Steuerelementnamen","duplicateMacroNamesDescription":"Bitte entfernen oder \xe4ndern Sie einen Ihrer identischen Steuerelementnamen.","warningIgnore":"Ignorieren","warningDoNotShowAgain":"Warnungen nicht mehr anzeigen","macrosVoiceCommandConflictWithDictationTitle":"Sprachbefehle genauso steuern wie Diktierschl\xfcsselw\xf6rter","keybindingsVoiceCommandConflictWithDictationTitle":"Tastenkombinationen Sprachbefehle gleich wie Diktierschl\xfcsselw\xf6rter","macrosVoiceCommandConflictWithDictationDescription":"Ihre Spracheingaben l\xf6sen Diktate und Sprachbefehle aus.","keybindingsVoiceCommandConflictWithDictationDescription":"Ihre Spracheingaben l\xf6sen Diktate und Tastendr\xfccke aus.","macrosVoiceCommandConflictWithGenerationTitle":"Sprachbefehle steuern wie Schl\xfcsselw\xf6rter generieren","keybindingsVoiceCommandConflictWithGenerationTitle":"Tastenkombinationen f\xfcr Sprachbefehle sind dieselben wie bei der Generierung von Schl\xfcsselw\xf6rtern","macrosVoiceCommandConflictWithGenerationDescription":"Ihre Spracheingaben l\xf6sen die Generierung und Sprachbefehle aus.","keybindingsVoiceCommandConflictWithGenerationDescription":"Ihre Spracheingaben l\xf6sen die Generierung und Tastendr\xfccke aus.","duplicateAssociatedProgramNames":"Doppelte zugeh\xf6rige Programmnamen","duplicateAssociatedProgramNamesDescription":"Bitte entfernen oder \xe4ndern Sie eines Ihrer identischen verkn\xfcpften Programme.","emptyEvent":{"title":"Fehlende Schritte","description":"In Ihrer Steuerung fehlen Schritte. Dies kann dazu f\xfchren, dass Cephable beim Eingeben eines Befehls keine Aktion ausf\xfchrt."},"warningDetails":"Alle Konflikte anzeigen"},"success":{"save":"App-Steuerung gespeichert.","add":"App-Steuerung hinzugef\xfcgt.","delete":"App-Steuerung gel\xf6scht.","share":"Freigabelink erstellt und in die Zwischenablage kopiert","shareDelete":"Freigabelink gel\xf6scht.","generate":"App-Steuerelemente generiert."},"warning":"App-Steuerung mit Warnungen gespeichert","customize":"App-Steuerelemente anpassen","custom":"{{name}} (Benutzerdefiniert)","description":"App-Steuerelemente sind eine Reihe von Steuerelementen, mit denen Sie Ihr Ger\xe4t oder Ihre Verbindung steuern k\xf6nnen. Sie k\xf6nnen mehrere App-Steuerelemente erstellen und jederzeit zwischen ihnen wechseln."},"publicProfiles":{"toolbar":"App-Steuerelemente erkunden","title":"App-Steuerelemente erkunden","offline":{"title":"\xd6ffentliche App-Steuerelemente k\xf6nnen nicht geladen werden","description":"Offenbar sind Sie offline. Sie k\xf6nnen Ihre App-Steuerelemente weiterhin verwenden, aber keine neuen \xf6ffentlichen App-Steuerelemente laden.","confirm":"Okay"},"announcement":"{{count}} Neue App-Steuerelemente wurden geladen","description":{"personal":"\xd6ffentliche App-Steuerelemente erleichtern Ihnen den schnellen Einstieg in Cephable mit Ihren Lieblings-Apps. Sie k\xf6nnen die Standard-Steuerelemente verwenden, diese an Ihre Bed\xfcrfnisse anpassen oder v\xf6llig neue, benutzerdefinierte App-Steuerelemente erstellen.","pro":"\xd6ffentliche App-Steuerelemente erleichtern Ihnen den schnellen Einstieg in Cephable mit Ihren Lieblings-Apps. Sie k\xf6nnen die Standard-Steuerelemente verwenden, diese an Ihre Bed\xfcrfnisse anpassen oder mit dem Steuerelementgenerator v\xf6llig neue, benutzerdefinierte App-Steuerelemente erstellen."},"team":"Cephable Team"},"publicTag":"\xd6ffentlich","tray":{"panel":"Bedienfeld umschalten","dashboard":"Dashboard anzeigen","quit":"Cephable beenden"},"generate":"Erzeugen","stop":"Stoppen","clear":"Klar","rewrite":"Umschreiben","translate":"\xdcbersetzen","smartTasks":{"title":"Intelligente Aufgaben","show":"Intelligente Aufgaben anzeigen","description":"Intelligente Aufgaben sind die verschiedenen Aufgaben, die die KI von Cephable f\xfcr Sie erledigen kann. Diese Aufgaben werden durch die KI auf dem Ger\xe4t unterst\xfctzt und k\xf6nnen zum Erstellen von Texten, Zusammenfassen, Umschreiben, \xdcbersetzen, Notieren und Chatten mit Dokumenten verwendet werden.","generateText":{"title":"Text generieren","description":"Erstellen Sie Textinhalte basierend auf Ihren Eingaben oder Aufforderungen.","label":"Beschreiben Sie, was Sie generieren m\xf6chten"},"summarizeText":{"title":"Text zusammenfassen","description":"Verdichten Sie langen Text zu einer pr\xe4gnanten Zusammenfassung.","directions":"Geben Sie den zusammenzufassenden Text ein, andernfalls verwendet Cephable automatisch den von Ihnen markierten Text.","titleShort":"Zusammenfassen","write":"Zusammenfassung schreiben","label":"Geben Sie einen zusammenfassenden Text ein","outputLabel":"Ihre Zusammenfassung wird hier stehen."},"rewriteText":{"title":"Text neu schreiben","description":"Markieren Sie den Text, in dem Sie schreiben, in einer anderen App, und kehren Sie dann hierher zur\xfcck und beschreiben Sie, wie er neu geschrieben werden soll.","label":"Beschreiben Sie, wie Sie den Text umschreiben m\xf6chten","inputLabel":"Geben Sie den umzuschreibenden Text ein"},"translateText":{"title":"Text \xfcbersetzen","description":"Geben Sie den zu \xfcbersetzenden Text ein, oder Cephable verwendet automatisch den von Ihnen markierten Text.","label":"Geben Sie den zu \xfcbersetzenden Text ein","languageLabel":"Zu \xfcbersetzende Sprache"},"noteTaker":{"title":"Notizenmacher","description":"Lassen Sie Cephable Ihre Meetings oder Gespr\xe4che lokal aufzeichnen und transkribieren"},"documentChat":{"title":"Dokumenten-Chat","description":"Interagieren Sie mit Dokumenten und fragen Sie sie ab, um schnelle Erkenntnisse zu gewinnen."},"highlightText":{"title":"Hervorgehobenen Text verwenden","description":"Cephable kann den in einer App markierten Text automatisch verwenden, um Aufgaben wie Zusammenfassen, Umschreiben oder \xdcbersetzen auszuf\xfchren. Sie k\xf6nnen Text auch manuell eingeben, wenn Sie m\xf6chten.","label":"Geben Sie den zu verwendenden Text ein","placeholder":"Sie k\xf6nnen Text auch in einer anderen App markieren und hierher zur\xfcckkehren, um ihn zu verwenden."},"pasteText":{"title":"Text einf\xfcgen","description":"Cephable kann den in die Zwischenablage kopierten Text automatisch f\xfcr Aufgaben wie Zusammenfassen, Umschreiben oder \xdcbersetzen verwenden. Sie k\xf6nnen den Text auch manuell eingeben.","label":"Geben Sie den zu verwendenden Text ein","placeholder":"Sie k\xf6nnen Text auch in einer anderen App markieren und hierher zur\xfcckkehren, um ihn zu verwenden."},"clearCache":"Wenn beim Generieren Probleme auftreten, l\xf6schen Sie bitte Ihren Cache und Ihre Ressourcen aus den Textgenerierungseinstellungen und versuchen Sie es erneut.","transcribeAudio":{"title":"Audio transkribieren","description":"Konvertieren Sie Audio- oder Videodateien mithilfe der KI-Transkription in Text.","inputMethod":"Eingabemethode ausw\xe4hlen","localFile":"Lokale Datei","url":"URL","selectFile":"Audio-/Videodatei ausw\xe4hlen","urlLabel":"Audio-/Video-URL","transcribe":"Transkribieren","result":"Transkriptionsergebnis","invalidFileType":"Bitte w\xe4hlen Sie eine g\xfcltige Audio- oder Videodatei (mp3, wav, ogg, mp4, webm, mov, avi)","error":"Transkriptionsfehler","history":{"title":"Transkriptionsverlauf","description":"Zeigen Sie Ihre gespeicherten Transkriptionen an und verwalten Sie sie.","viewHistory":"Verlauf anzeigen","empty":"Noch keine Transkriptionen. Beginnen Sie mit der Transkription, um Ihren Verlauf aufzubauen!","titleLabel":"Titel (optional)","titlePlaceholder":"Geben Sie einen Titel f\xfcr diese Transkription ein","textLabel":"Transkriptionstext","confirmDelete":"M\xf6chten Sie diese Transkription wirklich l\xf6schen?"}},"aiWorkflows":{"description":"Automatisieren Sie Ihre Desktop- und Browseraufgaben mit KI. Beschreiben Sie einfach, was Sie erreichen m\xf6chten, und Cephable f\xfchrt die Aktionen f\xfcr Sie aus.","label":"Beschreiben Sie, was Sie erreichen m\xf6chten.","status":{"idle":"Wir warten auf Ihre Anweisungen...","initializing":"Die Vorbereitungen laufen...","planning":["Einen Plan machen...","Aufschl\xfcsselung Ihrer Anfrage...","Die einzelnen Schritte planen...","Organisation des Arbeitsablaufs...","Die Strategie wird vorbereitet...","Einen Aktionsplan erstellen...","Wir \xfcberlegen, wie wir Ihnen am besten helfen k\xf6nnen...","Die richtige Vorgehensweise festlegen...","Ihre Anfrage wird analysiert...","Planung der Durchf\xfchrung..."],"thinking":["Denken...","Ihre Anfrage wird analysiert...","Wir \xfcberlegen, wie wir Ihnen am besten helfen k\xf6nnen...","Die n\xe4chsten Schritte festlegen...","Die vorherigen Schritte werden verarbeitet...","Wir bearbeiten Ihre Anfrage...","Details werden abgerufen...","\xdcberpr\xfcfung des Plans...","Die verschiedenen Optionen in Betracht ziehen...","Erstellen, Bewerten, Entscheiden..."],"waitingForUser":"Ihre Eingabe ist erforderlich, um fortzufahren.","completed":"Erfolg!","failed":"Ihre Anfrage ist fehlgeschlagen. Bitte versuchen Sie es erneut.","canceled":"Ihre Anfrage wurde storniert.","terminated":"Angehalten. Warte auf Ihre Anweisungen...","thinkingInteractive":["\xdcberlegen Sie sich den n\xe4chsten Schritt...","Ein R\xfcckblick auf das bisher Erreichte...","Die Entscheidung, was als N\xe4chstes zu tun ist...","Analyse der Ergebnisse...","Planung der Fortsetzung...","Die Optionen auswerten...","Den besten n\xe4chsten Schritt herausfinden...","Ich arbeite am n\xe4chsten Teil Ihrer Anfrage...","Ich arbeite an den n\xe4chsten Schritten...","Die Ergebnisse des vorherigen Schritts werden verarbeitet..."],"tools":{"click_element_by_index":{"executing-start":"Durch Klicken der entsprechenden Schaltfl\xe4che...","executing-complete":"Ich habe auf {{params.index}} geklickt."},"click_element":{"executing-start":"Durch Anklicken der markierten Zahl...","executing-complete":"Ich habe auf {{params.elementName}} geklickt."},"copy_selection":{"executing-start":"Kontextinformationen sammeln...","executing-complete":"Ich habe den Kontext und bin bereit f\xfcr den n\xe4chsten Teil Ihrer Anfrage."},"create_file":{"executing-start":"Datei wird erstellt...","executing-complete":"Ich habe eine Datei mit dem Namen {{params.fileName}} erstellt."},"draft_email":{"executing-start":"Eine E-Mail verfassen...","executing-complete":"Ich habe eine E-Mail zum Thema {{params.subject}} entworfen."},"execute_app_action":{"executing-start":"{{params.actionName}} wird ausgef\xfchrt...","executing-complete":"{{params.actionName}} abgeschlossen."},"find_all_text":{"executing-start":"Suche nach allen relevanten Kontextinformationen zu {{params.searchText}}...","executing-complete":"Ich habe alle relevanten Kontextinformationen zu {{params.searchText}} gefunden."},"find_and_select_text":{"executing-start":"Suche und Auswahl relevanter Kontextinformationen zu {{params.searchText}}...","executing-complete":"Ich habe relevanten Kontext zu {{params.searchText}} gefunden und ausgew\xe4hlt."},"generate_text":{"executing-start":"Inhalte erstellen...","executing-progress":"Inhalte werden erstellt...{{progress}}%","executing-complete":"Ich habe die angeforderten Inhalte erstellt."},"get_all_interactive_elements":{"executing-start":"Scannen, um mehr Kontext zu erhalten...","executing-complete":"Ich verstehe, womit ich interagieren kann."},"get_all_text_elements_content":{"executing-start":"Lesen, um mehr Kontext zu erhalten...","executing-complete":"Ich verstehe, welche Textinhalte verf\xfcgbar sind."},"get_all_text_elements_names":{"executing-start":"Lesen, um mehr Kontext zu erhalten...","executing-complete":"Ich verstehe, welche Textinhalte verf\xfcgbar sind."},"get_available_profile_actions":{"executing-start":"Ich pr\xfcfe, welche Steuerelemente in dieser App verf\xfcgbar sind...","executing-complete":"Ich verstehe, was ich mit dieser App machen kann."},"get_document_content":{"executing-start":"Lesen, um mehr Kontext zu erhalten...","executing-complete":"Ich habe den Kontext und bin bereit f\xfcr den n\xe4chsten Teil Ihrer Anfrage."},"get_installed_apps":{"executing-start":"Die Entscheidung, welche App f\xfcr Ihre Anfrage relevant ist...","executing-complete":"Ich wei\xdf, welche Apps ich verwenden kann."},"get_running_app_names":{"executing-start":"Die Entscheidung, welche App f\xfcr Ihre Anfrage relevant ist...","executing-complete":"Ich wei\xdf, welche Apps ich verwenden kann."},"get_selected_text":{"executing-start":"Der ausgew\xe4hlte Inhalt wird gelesen...","executing-complete":"Ich habe Kontextinformationen zum ausgew\xe4hlten Inhalt."},"get_stored_content":{"executing-start":"Kontext sammeln...","executing-complete":"Ich habe den Kontext und bin bereit f\xfcr den n\xe4chsten Teil Ihrer Anfrage."},"keyboard_shortcut":{"executing-start":"Kontext sammeln...","executing-complete":"Ich habe den Kontext und bin bereit f\xfcr den n\xe4chsten Teil Ihrer Anfrage."},"open_app":{"executing-start":"\xd6ffne {{params.appName}}...","executing-complete":"Ich habe {{params.appName}} ge\xf6ffnet."},"open_webpage":{"executing-start":"\xd6ffne {{params.url}}...","executing-complete":"Ich habe {{params.url}} ge\xf6ffnet."},"paste_content":{"executing-start":"Schreiben...","executing-complete":"Ich habe mit dem Schreiben fertig."},"respond_to_user":{"executing-start":"Ihre Anfrage wird abgeschlossen...","executing-complete:":"Ich habe Ihre Anfrage bearbeitet."},"search_and_open_file":{"executing-start":"Suche nach der Datei {{params.query}} und \xf6ffne sie...","executing-complete":"Ich habe nach der Datei {{params.query}} gesucht und sie ge\xf6ffnet."},"search_browser":{"executing-start":"Suche im Web nach {{params.query}}...","executing-complete":"Ich habe im Internet nach {{params.query}} gesucht."},"select_all_text":{"executing-start":"Der gesamte Text wird ausgew\xe4hlt...","executing-complete":"Ich habe den gesamten Text ausgew\xe4hlt."},"summarize_text":{"executing-start":"Zusammenfassend l\xe4sst sich sagen:","executing-progress":"Zusammenfassend...{{progress}}%","executing-complete":"Ich habe den Text zusammengefasst."},"translate_text":{"executing-start":"Der Text wird in {{params.targetLanguage}} \xfcbersetzt...","executing-progress":"\xdcbersetzung l\xe4uft...{{progress}}%","executing-complete":"Ich habe den Text in {{params.targetLanguage}} \xfcbersetzt."},"type_stored_content":{"executing-start":"Schreiben...","executing-complete":"Ich habe mit dem Schreiben fertig."},"type_text":{"executing-start":"Schreiben...","executing-complete":"Ich habe mit dem Schreiben fertig."},"write_file_content":{"executing-start":"In die Datei schreiben...","executing-complete":"Ich habe das Schreiben in die Datei {{params.fileName}} abgeschlossen."},"unknown":{"executing-start":"Ich bin auf ein Problem gesto\xdfen, als ich eine andere Strategie ausprobiert habe...","executing-complete":"Ich habe eine andere Strategie ausprobiert."}},"networkError":"Die Verbindung wurde beim Herunterladen des Modells unterbrochen. Bitte \xfcberpr\xfcfen Sie Ihre Internetverbindung und versuchen Sie es erneut, indem Sie eine Anfrage senden oder die App neu starten.","executing-org-block":"{{params.toolName}} kann nicht aufgerufen werden, da die Interaktion mit {{params.appOrDomain}} von der Organisation blockiert wird.","executing-destructive-block":"Die Interaktion mit {{params.elementName}} ist blockiert. Bitte \xfcberpr\xfcfen Sie dies und f\xfchren Sie diese Aktion manuell aus.","executing-type-focus-block":"Ich hatte ein Problem beim Schreiben des Inhalts. Er wurde in Ihre Zwischenablage kopiert, bitte f\xfcgen Sie ihn manuell ein."},"ready":{"waiting":"AI Workflows ist einsatzbereit. Wir warten auf Ihre Anweisungen.","execute":"AI Workflows ist bereit. Wir starten auf Ihre Anfrage hin..."},"start":"Start","progress":"Arbeiten...","introModal":{"description":"Ich kann jetzt Ihre Desktop- und Browseraufgaben automatisieren \u2013 sagen Sie mir einfach, was Sie m\xf6chten, und ich k\xfcmmere mich um den Rest. Ich laufe im Hintergrund auf Ihrem Ger\xe4t, Ihre Daten bleiben also Ihr Eigentum. Zum Starten muss ich ein lokales KI-Modell herunterladen. Laden Sie es jetzt herunter, damit ich bereit bin, oder ich lade es herunter, sobald Sie Ihren ersten Workflow starten.","confirm":"Jetzt herunterladen","cancel":"Jetzt \xfcberspringen","title":"KI-Workflows sind verf\xfcgbar"},"title":"Ihre KI-Workflows sind bereit"},"generatedByAI":"Die Daten werden durch ger\xe4teinterne KI bereitgestellt. Bitte \xfcberpr\xfcfen Sie die Angaben auf Richtigkeit.","networkError":"Die Verbindung wurde beim Herunterladen des Modells unterbrochen. Bitte \xfcberpr\xfcfen Sie Ihre Internetverbindung und versuchen Sie es erneut, indem Sie eine Anfrage senden oder die App neu starten.","genericError":"Es ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut.","download":{"title":"Laden Sie KI-Modelle herunter, um weitere Funktionen freizuschalten","description":"Um intelligente Aufgaben nutzen zu k\xf6nnen, muss ein lokales Modell auf Ihr Ger\xe4t heruntergeladen werden. Dadurch wird sichergestellt, dass Ihre Daten privat bleiben und niemals in die Cloud \xfcbertragen werden.","confirm":"Herunterladen","cancel":"Nicht jetzt.","includeWorkflows":"Laden Sie au\xdferdem KI-Workflow-Modelle f\xfcr die erweiterte Automatisierung herunter."}},"inputMethod":"Eingabemethode:","hotkey":{"title":"Schnellaktionsschaltfl\xe4che","titlePlural":"Schnellaktionsschaltfl\xe4chen","titlePanel":"Schnellaktionen","label":"Anzeigename der Schnellaktionsschaltfl\xe4che","placeholder":"Anzuzeigender Name","question":"Wie m\xf6chten Sie diese Schaltfl\xe4che benennen?","when":"Wenn ich tippe ...","description":"Schnellaktionsschaltfl\xe4chen sind anpassbare Schaltfl\xe4chen, mit denen Sie durch Antippen relevante Aktionen in Ihrer App ausf\xfchren k\xf6nnen. Ein einziges Antippen kann mehrere Schritte oder eine einzelne Aktion ausl\xf6sen.","usagePrompt":"Schnellaktionsschaltfl\xe4chen sind anpassbare Schaltfl\xe4chen, mit denen Sie durch Antippen entsprechende Aktionen in Ihrer App ausf\xfchren k\xf6nnen. Sie k\xf6nnen die Namen auf der Hauptseite der App-Steuerungseinstellungen hinzuf\xfcgen, entfernen oder bearbeiten.","reorder":"Sie k\xf6nnen die Reihenfolge mit den Schaltfl\xe4chen \u201ENach oben\u201C und \u201ENach unten\u201C neu anordnen.","emptyTitle":"Keine Schnellaktionstasten","edit":"Schnellaktionsschaltfl\xe4chen bearbeiten","tap":"Tippen Sie auf {{value}}","copySuffix":"{{name}}_Kopie","hotkeysOnly":"Benutzerdefinierte Schaltfl\xe4chen","allControls":"Alle App-Steuerelemente","show":"Schnellaktionsschaltfl\xe4chen anzeigen","deprecatedDialog":{"title":"Ihre App-Steuerung erfordert ein Update.","description2":"Ein schnelles Update gen\xfcgt \u2013 buchst\xe4blich eine Sekunde \u2013 und Sie k\xf6nnen die nahtlose Anpassung der Schaltfl\xe4chen genie\xdfen. Verabschieden Sie sich von zus\xe4tzlichen Schritten und freuen Sie sich auf eine benutzerfreundlichere Oberfl\xe4che. Sind Sie bereit f\xfcr den Wechsel?","confirm":"Lass es uns tun!","description1":"Sie verwenden anscheinend \xe4ltere App-Steuerelemente mit Schnellaktionsschaltfl\xe4chen. Wir haben spannende Updates f\xfcr Sie! Wir haben das System \xfcberarbeitet, damit das Erstellen und Bearbeiten von Schnellaktionsschaltfl\xe4chen kinderleicht ist \u2013 Sie m\xfcssen sich nicht mehr in die erweiterten Einstellungen vertiefen."},"demo":{"title":"Demo der Schnellaktionsschaltfl\xe4chen","step1":"Aktivieren Sie die Schnellaktionsschaltfl\xe4chen","step2":"Verwenden Sie die folgenden Beispielaufforderungen, um den Textblock zu steuern.","command1":"Dr\xfccken Sie die Taste 1, um den Text zu vergr\xf6\xdfern.","command2":"Dr\xfccken Sie die Taste 2, um den Text fett darzustellen.","command3":"","continue":"Weiter mit Quick Action Buttons","description":"Im Demobereich unten k\xf6nnen Sie Schnellaktionsschaltfl\xe4chen ausprobieren. Die Demo beschr\xe4nkt sich auf die Steuerung dieses Textbereichs unten."},"example":{"title":"Beispiele f\xfcr Schnellaktionsschaltfl\xe4chen","command1":"Tippen Sie auf \u201EPause\u201C","example1":"Beispiel \u201EVideo anhalten\u201C","command2":"Tippen Sie auf Weiter","example2":"Beispiel \u201EHerauszoomen\u201C","command3":"Tippen Sie auf \u201EStopp\u201C","example3":"Beispiel \u201EFenster schlie\xdfen\u201C","description":"Diese Beispiele zeigen die Vielseitigkeit von Quick Action Buttons bei der Steuerung Ihres Ger\xe4ts oder Ihrer Verbindung. Mit ihnen k\xf6nnen Sie Befehle ausf\xfchren, durch Benutzeroberfl\xe4chen navigieren oder Aktionen mit einem einfachen Fingertipp ausf\xfchren."},"emptySearch":"Es gibt keine Schnellaktionen, die diesen Kriterien entsprechen.","empty":"Es sieht so aus, als ob Sie derzeit keine Schnellaktionen haben.","emptyLong":"In diesen App-Steuerelementen sind keine Schnellaktionsschaltfl\xe4chen konfiguriert. Sobald Sie Schnellaktionsschaltfl\xe4chen hinzuf\xfcgen oder App-Steuerelemente mit einer solchen Schaltfl\xe4che ausw\xe4hlen, werden diese hier angezeigt."},"reset":"Zur\xfccksetzen","info":"Weitere Informationen","device":{"title":"Verbindung","titlePlural":"Anschl\xfcsse","status":{"title":"Verbindungsstatus:","connected":{"application":"Verbundene Anwendung","connection":"Verbunden","device":"Verbundenes Ger\xe4t","game":"Verbundenes Spiel"},"disconnected":{"application":"Getrennte Anwendung","connection":"Getrennt","device":"Getrenntes Ger\xe4t","game":"Getrenntes Spiel"}},"running":"L\xe4uft","offline":"Offline","otherDevices":"Andere Ausgangsanschl\xfcsse","currentStatus":"Aktueller Status:","connectionStatus":"Verbindungsstatus:","profileStatus":"Aktuelle App-Steuerelemente:","name":{"title":"Verbindungsname","question":"Wie m\xf6chten Sie diese Verbindung nennen?","description":"Geben Sie Ihrer Verbindung einen Namen, damit Sie sie sp\xe4ter leicht wiederfinden k\xf6nnen.","placeholder":"Verbindungsname","edit":"Verbindungsnamen bearbeiten"},"updates":{"title":"Verbindungsupdates","settings":"Verbindungsaktualisierungseinstellungen","description":"Suchen Sie nach Firmware-Updates f\xfcr die Verbindung und \xe4ndern Sie die Einstellungen f\xfcr die automatische Aktualisierung","edit":"Update-Einstellungen bearbeiten","check":{"title":"Nach Updates suchen","processing":"Suche nach Updates! Dies kann einige Minuten dauern und Ihre Verbindung wird w\xe4hrend der Updates m\xf6glicherweise neu gestartet.","description":"Tippen Sie hier, um nach Updates f\xfcr Ihre Verbindung zu suchen. Wenn ein Update verf\xfcgbar ist und Ihre Verbindung aktiv ist, wird die Aktualisierung gestartet. Die Aktualisierung kann einige Minuten dauern."},"auto":{"title":"Automatisch aktualisieren","description":"Wenn diese Einstellung aktiviert ist, wird Ihre Verbindung automatisch aktualisiert, sobald sie angeschlossen ist, mit dem WLAN verbunden ist und ein Update verf\xfcgbar ist. Wenn diese Einstellung deaktiviert ist, m\xfcssen Sie auf die Schaltfl\xe4che \u201EAktualisieren\u201C tippen, um die neueste Version zu erhalten.","option":"Automatische Aktualisierung verwenden?"}},"delete":{"title":"Link {{name}} entfernen","titleLong":"Verkn\xfcpfung von Konto aufheben","description":"Durch das Trennen der Verbindung wird Cephable von diesem Computer oder Spiel getrennt und aus Ihrem Konto entfernt. Sie k\xf6nnen sich dann nicht mehr verbinden, Befehle senden oder Updates durchf\xfchren. Dieser Vorgang kann nicht r\xfcckg\xe4ngig gemacht werden. Sie k\xf6nnen jedoch eine neue Verbindung zum selben Computer oder Spiel herstellen, falls Sie Cephable sp\xe4ter wieder verwenden m\xf6chten.","confirm":"M\xf6chten Sie diese Verbindung wirklich trennen?","confirmLong":"M\xf6chten Sie diese Verbindung wirklich abmelden und zur\xfccksetzen? Sie k\xf6nnen sich danach nicht mehr damit verbinden, Befehle senden oder sie aktualisieren. Nach dieser Abmeldung und Zur\xfccksetzung kann jeder diese Verbindung von Grund auf neu einrichten.","confirmButton":"Ja, diese Verbindung entfernen."},"manage":{"title":"Klicken Sie hier, um Details zu Ihren Verbindungen anzuzeigen und zu verwalten.","description":"","name":"Passen Sie Ihren Verbindungsnamen zur einfacheren Verwaltung an."},"error":{"save":"Fehler beim Speichern der Verbindung.","load":"Fehler beim Laden der Verbindung.","add":"Fehler beim Hinzuf\xfcgen der Verbindung.","delete":"Fehler beim L\xf6schen der Verbindung.","updates":"Fehler beim Suchen nach Updates.","connection":"Die Verbindung konnte nicht hergestellt werden. Stellen Sie sicher, dass die Verbindung besteht, bevor Sie es erneut versuchen.","deleteLong":"Wir konnten diese Verbindung nicht aus Ihrem Konto l\xf6schen. Wenn Sie sich erneut bei diesem Konto anmelden, m\xfcssen Sie diese Verbindung m\xf6glicherweise manuell in den Verbindungseinstellungen l\xf6schen."},"success":{"save":"Verbindung gespeichert.","add":"Verbindung hinzugef\xfcgt.","delete":"Verbindung gel\xf6scht."},"description":"Cephable unterst\xfctzt mehrere Ger\xe4te und Verbindungen. Sie k\xf6nnen hier Einstellungen verwalten oder alle ausw\xe4hlen. Dieser Computer ist immer Ihre Hauptverbindung. Sie k\xf6nnen sp\xe4ter weitere Verbindungen hinzuf\xfcgen.","swap":{"titlePlural":"Verbindungen austauschen"},"control":{"button":"Kontrolle {{name}}","description":{"application":"Steuern Sie diese verbundene Anwendung per Sprache, Schnellaktionen, Kopfbewegungen und mehr. Wenn Sie beispielsweise \u201ESpeichern\u201C sagen, wird die laufende Anwendung gespeichert.","connection":"Steuern Sie diese Verbindung per Sprache, Schnellaktionen, Kopfbewegungen und mehr. Wenn Sie beispielsweise \u201ESpeichern\u201C sagen, wird Ihre laufende Verbindung gespeichert.","device":"Steuern Sie dieses verbundene Ger\xe4t per Sprache, Schnellaktionen, Kopfbewegungen und mehr. Wenn Sie beispielsweise \u201ESpotify \xf6ffnen\u201C sagen, wird Spotify auf dem laufenden Ger\xe4t ge\xf6ffnet.","game":"Steuern Sie dieses vernetzte Spiel mit Ihrer Stimme, schnellen Aktionen, Kopfbewegungen und mehr. Wenn Sie beispielsweise \u201ELos\u201C sagen, bewegt sich der Spieler im Laufspiel."},"generic":"Steueranschluss"},"titleShort":"Verbinden","titleLong":"Verbindungen & Erweiterungen","viewAll":"Alle Verbindungen anzeigen","add":{"short":"Verl\xe4ngern","title":"Neue Verbindung oder Erweiterung hinzuf\xfcgen","description":"Verbindungen und Erweiterungen bieten Ihnen zus\xe4tzliche M\xf6glichkeiten, Ihr Cephable-Erlebnis zu optimieren. Sie k\xf6nnen neue Verbindungen hinzuf\xfcgen, um weitere Ger\xe4te, Anwendungen oder Spiele zu verbinden. Bringen Sie Ihr Cephable-Erlebnis auf die n\xe4chste Stufe, indem Sie Verbindungen und Erweiterungen hinzuf\xfcgen.","action":"Neue Verbindung hinzuf\xfcgen","notAvailable":"Diese Verbindung bzw. Erweiterung ist derzeit nicht \xf6ffentlich verf\xfcgbar. Dies tritt h\xe4ufig bei der Verwendung von benutzergenerierten Erweiterungen auf. Bitte versuchen Sie es sp\xe4ter erneut.","isNotPublic":"VORSCHAU: Diese Erweiterung befindet sich in der Entwicklervorschau und ist m\xf6glicherweise unvollst\xe4ndig. Entwickler sollten alle Schritte vor der Ver\xf6ffentlichung abschlie\xdfen. Benutzer k\xf6nnen sp\xe4ter wieder vorbeischauen, um die Vollversion zu erhalten."},"new":"Sie haben eine neue Verbindung!","newLong":"Sie haben eine neue Verbindung! Um sie zu nutzen, w\xe4hlen Sie sie im Men\xfc unten aus."},"explore":"Erkunden","shortcuts":{"title":"Globale Verkn\xfcpfungen","description":"Passen Sie Tastaturk\xfcrzel an, um von \xfcberall auf Ihrem System aus schnell auf die Cephable-Steuerelemente zugreifen zu k\xf6nnen.","info":"Diese Verkn\xfcpfungen funktionieren global und k\xf6nnen auch verwendet werden, wenn Cephable nicht das aktive Fenster ist.","shortcut":"Abk\xfcrzung","toggleMicrophone":"Mikrofon umschalten","toggleDictation":"Diktiermodus umschalten","toggleVoiceControl":"Sprachsteuerungsmodus umschalten","togglePanel":"Bedienfeld umschalten","registrationFailed":"Einige globale Tastenkombinationen konnten nicht registriert werden. Sie werden m\xf6glicherweise von einer anderen Anwendung verwendet:","record":{"title":"Verkn\xfcpfung aufzeichnen","start":"Klicken zum Aufzeichnen","listening":"Dr\xfccken Sie die gew\xfcnschte Tastenkombination...","pressKeys":"Jetzt Tasten dr\xfccken"},"formatHint":"W\xe4hlen Sie mindestens eine Sondertaste ({{modifierKey}}, {{modifierKey2}}, Umschalttaste) und eine weitere Taste aus."},"gamepad":{"title":"Gamepad-Unterst\xfctzung","description":"Konfigurieren Sie die Gamepad- und Joystick-Ausgabe f\xfcr PC-Spiele","driver":{"description":"Zur Unterst\xfctzung von Gamecontroller-Ausgaben muss Cephable einen externen Treiber namens ViGEm herunterladen und installieren. Dieser Treiber erm\xf6glicht die Funktionalit\xe4t eines virtuellen Xbox 360-Controllers, den Spiele nativ erkennen.","installed":"Gamecontroller-Treiber installiert \u2013 Sie k\xf6nnen die Gamepad-Ausg\xe4nge verwenden! Sollten weiterhin Probleme auftreten, k\xf6nnen Sie versuchen, den Treiber neu zu installieren.","notInstalled":"Gamecontroller-Treiber nicht installiert","install":"Installieren Sie den Gamecontroller-Treiber","reinstall":"Installieren Sie den Gamecontroller-Treiber neu","installing":"ViGEm-Gamecontroller-Treiber wird installiert \u2026","installSuccess":"Der ViGEm-Gamecontroller-Treiber wurde erfolgreich installiert! Sie k\xf6nnen jetzt Gamepad-Ausg\xe4nge in Ihren Steuerelementen verwenden.","installFailed":"Der ViGEm-Treiber konnte nicht installiert werden. Bitte versuchen Sie es erneut oder installieren Sie den Treiber manuell von der ViGEm-Website."},"platform":{"unsupported":"Plattform wird f\xfcr Gamepad-Funktionen nicht unterst\xfctzt","unsupportedDescription":"Die Gamepad-Ausgabefunktion wird derzeit nur auf Windows x64-Systemen unterst\xfctzt. Aufgrund von SDK-Einschr\xe4nkungen ist die Unterst\xfctzung f\xfcr Windows ARM64 noch nicht verf\xfcgbar."},"usage":"Sobald der Gamecontroller-Treiber installiert ist, k\xf6nnen Sie Joystick-Bewegungen und Gamepad-Tastendr\xfccke in Ihren Makros und Sprachbefehlen zur Steuerung von Spielen verwenden."},"youtube":{"unavailable":{"title":"Video nicht verf\xfcgbar","description":"Dieses Video ist derzeit nicht verf\xfcgbar. Bitte versuchen Sie es sp\xe4ter erneut.","retry":"Wiederholen"},"watch":{"title":"Hoppla.","description":"Beim Laden des Videos ist anscheinend ein Problem aufgetreten. Sie k\xf6nnen es direkt auf YouTube ansehen.","button":"Auf YouTube ansehen"},"offline":{"title":"Video nicht verf\xfcgbar","description":"Zum Laden dieses YouTube-Videos ist eine Internetverbindung erforderlich. Bitte \xfcberpr\xfcfen Sie Ihre Verbindung und versuchen Sie es erneut."}},"metrics":{"download":{"success":"Auf die Metrikdatei wurde erfolgreich zugegriffen.","manualPath":"Metrikdatei verf\xfcgbar unter: {{path}}","error":"Fehler beim Herunterladen der Metrikdatei.","noFile":"Keine Metrikdatei gefunden."},"clear":{"success":"Die Metrikdatei wurde erfolgreich gel\xf6scht.","error":"Fehler beim L\xf6schen der Metrikdatei.","noFile":"Keine zu l\xf6schende Metrikdatei gefunden.","confirm":"M\xf6chten Sie wirklich alle Messdaten l\xf6schen? Dies kann nicht r\xfcckg\xe4ngig gemacht werden."}},"suggestedPrompts":{"title":"Vorgeschlagene Eingabeaufforderungen","description":"Passen Sie die in KI-Aufgaben angezeigten Eingabeaufforderungen an, damit Sie schnell loslegen k\xf6nnen.","edit":"Vorgeschlagene Eingabeaufforderungen bearbeiten","generate":"Text generieren","rewrite":"Text neu schreiben","addGenerate":"Hinzuf\xfcgen einer Eingabeaufforderung zum Generieren","addRewrite":"F\xfcgen Sie eine Umschreibeaufforderung hinzu","remove":"Eingabeaufforderung entfernen","generatePlaceholder":"Geben Sie eine Eingabeaufforderung zur Textgenerierung ein ...","rewritePlaceholder":"Geben Sie eine Eingabeaufforderung zum Umschreiben des Textes ein ...","suggested":"Vorgeschlagene Eingabeaufforderungen","suggestedFor":"Vorgeschlagen f\xfcr {{profileName}}","seeAll":"Alle Eingabeaufforderungen anzeigen","showLess":"Weniger anzeigen","allPrompts":"Alle Eingabeaufforderungen","customFor":"Benutzerdefinierte Eingabeaufforderungen f\xfcr {{profileName}}","defaultPrompts":"Standardaufforderungen","defaultGenerate":["Eine professionelle E-Mail zur Vorstellung unseres neuen Produkts","Eine Tagesordnung f\xfcr die Teamdiskussion der n\xe4chsten Woche","Ein Projektvorschlagsentwurf f\xfcr eine neue Initiative","Eine formelle Gesch\xe4ftsbriefvorlage","Ein Abschnitt zur technischen Dokumentation","Eine Einf\xfchrung in das Benutzerhandbuch","Eine \xdcbersicht \xfcber Schulungsunterlagen","Entwurf eines Strategiedokuments","Eine Folge-E-Mail nach einem Meeting","Eine Dankesnachricht an einen Kunden","Eine E-Mail mit einem Update zum Projektstatus","Eine Einladung zu einer Firmenveranstaltung","Eine Erinnerungs-E-Mail f\xfcr bevorstehende Fristen","Eine Willkommens-E-Mail f\xfcr neue Teammitglieder","Eine Entschuldigungs-E-Mail f\xfcr die Dienstunterbrechung","Eine Newsletter-Einf\xfchrung","Eine Brainstorming-Liste f\xfcr Marketingkampagnen","Kreative L\xf6sungen zur Verbesserung der Teamproduktivit\xe4t","Ideen f\xfcr Aktivit\xe4ten bei einer Firmenklausur","Konzepte f\xfcr eine neue Funktion der mobilen App","Vorschl\xe4ge zur Verbesserung des Kundenerlebnisses","Innovationsideen f\xfcr unsere Produktentwicklung","Inhaltsideen f\xfcr Social-Media-Beitr\xe4ge","Workshop-Themen zur beruflichen Weiterentwicklung","Eine Funktion, die Benutzereingaben validiert","Eine Datenbankabfrage zur Benutzerverwaltung","Fehlerbehandlungscode f\xfcr API-Anfragen","Eine Konfigurationsdateivorlage","Kommentare zur Erl\xe4uterung eines komplexen Algorithmus","Unit-Testf\xe4lle f\xfcr eine neue Funktion","Dokumentation f\xfcr API-Endpunkte","Ein Skript f\xfcr die automatisierte Bereitstellung"],"defaultRewrite":["Machen Sie diesen Text pr\xe4gnanter und auf den Punkt","Erweitern Sie diese Zusammenfassung um weitere Details","Formatieren Sie dies als nummerierte Liste neu","Wandeln Sie dies in Aufz\xe4hlungspunkte um","Strukturieren Sie dies in klare Abs\xe4tze um","Machen Sie diesen Text leichter \xfcberfliegbar","Organisieren Sie diese Informationen hierarchisch","Formatieren Sie dies als Schritt-f\xfcr-Schritt-Anleitung","Gestalten Sie diese Nachricht professioneller und formeller","Schreiben Sie dies um, damit es lockerer und freundlicher klingt","Passen Sie den Ton an, um ermutigender zu sein","Machen Sie dies selbstbewusster und durchsetzungsf\xe4higer","Den Ton mildern, um diplomatischer zu sein","Geben Sie diesem Text Begeisterung und Energie","Machen Sie dies einf\xfchlsamer und verst\xe4ndnisvoller","Schreiben Sie in einem kooperativeren Ton neu","Vereinfachen Sie dies f\xfcr ein allgemeines Publikum","Machen Sie diese Erkl\xe4rung technischer und detaillierter","Zerlegen Sie dieses komplexe Konzept in einfachere Begriffe","F\xfcgen Sie mehr Kontext und Hintergrundinformationen hinzu","Fassen Sie dies in den wichtigsten Erkenntnissen zusammen","Erl\xe4utern Sie die wichtigsten Punkte anhand von Beispielen","Machen Sie dies f\xfcr Anf\xe4nger zug\xe4nglicher","Verdichten Sie dies, w\xe4hrend Sie die wesentlichen Informationen behalten","Verbessern Sie die \xdcbersichtlichkeit und Lesbarkeit","Machen Sie es ansprechender und interessanter","Passen Sie es an, um die Grammatik und den Lesefluss zu verbessern","Schreiben Sie es neu, um die Vorteile hervorzuheben"]},"accessibilityService":{"error":{"generic":"Interner Fehler. Bitte versuchen Sie es sp\xe4ter erneut.","elementNotFound":"Es wurden keine Ergebnisse gefunden. Bitte \xfcberpr\xfcfen Sie, ob die Suchanfrage existiert, und versuchen Sie es erneut.","highlightOnConflict":"Es wurden mehrere Elemente gefunden. Bitte pr\xe4zisieren Sie Ihren Befehl, um anzugeben, welches Element Sie ausw\xe4hlen m\xf6chten.","clickNotInitialized":"Die Namensauswahl ist momentan nicht verf\xfcgbar. Bitte kontaktieren Sie den Support, falls das Problem weiterhin besteht.","platformUnsupported":"Die Voice Mouse-Funktionen werden auf dieser Plattform nicht unterst\xfctzt."},"clickWait":"Initialisierung l\xe4uft. Bitte warten Sie einen Moment und versuchen Sie es erneut."},"deprecated":"Veraltet","view":"Sicht","aiWorkflows":{"settings":{"title":"KI-Workflow-Einstellungen","description":"Konfigurieren Sie die f\xfcr KI-Workflows verwendeten KI-Modelle und -Ger\xe4te. KI-Workflows erm\xf6glichen die Automatisierung von Desktop- und Browseraufgaben mithilfe von ger\xe4teinterner KI.","configType":{"title":"Modellkonfigurationstyp","description":"W\xe4hlen Sie den gew\xfcnschten Modellkonfigurationstyp f\xfcr KI-Workflows aus. Verschiedene Konfigurationen sind f\xfcr unterschiedliche Modelle optimiert.","label":"Konfigurationstyp"},"reasoningModel":{"title":"Argumentationsmodell","description":"W\xe4hlen Sie das KI-Modell f\xfcr die Aufgaben im Bereich logisches Denken und Planen aus. Das Modell analysiert Ihre Anfragen und erstellt Aktionspl\xe4ne.","label":"Argumentationsmodell"},"reasoningDevice":{"label":"Logikger\xe4t"},"generationModel":{"title":"Generationsmodell","description":"W\xe4hlen Sie das KI-Modell f\xfcr die Textgenerierung aus. Das Generierungsmodell erstellt bei Bedarf im Rahmen der Arbeitsabl\xe4ufe Textinhalte.","label":"Generationsmodell"},"generationDevice":{"label":"Erzeugungsger\xe4t"},"noModelsFound":"Keine Modelle gefunden","terminate":{"title":"Ressourcen f\xfcr einen klaren Workflow","description":"Klicken Sie hier, um den Workflow-Worker zu beenden und Ressourcen freizugeben. Dadurch werden alle laufenden Workflows gestoppt und der von den KI-Modellen belegte Speicher freigegeben.","button":"Workflow-Mitarbeiter beenden","success":"Workflow-Mitarbeiter beendet.","confirm":{"title":"Workflow-Mitarbeiter beenden","description":"M\xf6chten Sie den Workflow-Worker wirklich beenden? Dadurch werden alle laufenden Workflows gestoppt und Ressourcen freigegeben.","confirm":"Ja, beenden"}},"autoWarm":{"title":"Automatischer Start von KI-Workflows","description":"KI-Workflow-Modelle werden beim Start der App automatisch initialisiert. Die Modelle werden vorab geladen, sodass Workflows sofort starten k\xf6nnen.","option":"Automatischer Start von KI-Workflow-Modellen beim App-Start"},"prompt":{"title":"Zus\xe4tzliche Informationen zu KI-Workflows","description":"Geben Sie hier zus\xe4tzliche Details ein, die von der KI von Cephable bei der Ausf\xfchrung von Workflows verwendet werden sollen. In diesem Feld k\xf6nnen Sie Ihre Pr\xe4ferenzen f\xfcr Tonfall, Verhalten oder andere Details festlegen.","field":"Zus\xe4tzliche Aufforderung","placeholder":"Beispielsweise sollten Sie vor dem Absenden von E-Mails immer eine Best\xe4tigung abgeben. Bevorzugen Sie kurze Antworten. Verwenden Sie in Dokumenten eine formelle Sprache."},"disableButtonNames":{"edit":"Block-Button-Interaktionen","input":{"label":"Schaltfl\xe4chenname","question":"Welche Schaltfl\xe4chen m\xf6chten Sie blockieren? Sie k\xf6nnen vollst\xe4ndige oder teilweise Schaltfl\xe4chennamen eingeben.","remove":"Name der Schaltfl\xe4che \u201EEntfernen\u201C"},"button":"Block-Schaltfl\xe4chen","description":"Legen Sie fest, mit welchen Schaltfl\xe4chen KI-Workflows interagieren d\xfcrfen. Standardm\xe4\xdfig kann Cephable jede Schaltfl\xe4che auf Ihrem Bildschirm anklicken. Verwenden Sie diese Einstellung, um versehentliche Aktionen (z. B. \u201EKaufen\u201C, \u201EL\xf6schen\u201C) zu verhindern."}}},"control":"Kontrolle","automate":"Automatisieren","deviceCommandThrottled":{"macroLength":"Diese Verbindung unterst\xfctzt keine langen Makros. Ihr Makro wurde automatisch gek\xfcrzt.","commandCount":"Diese Verbindung begrenzt die Geschwindigkeit, mit der Sie Befehle senden k\xf6nnen. Bitte warten Sie und versuchen Sie es sp\xe4ter erneut."},"tos":{"title":"Aktualisierung der Nutzungsbedingungen","description":"Unsere Nutzungsbedingungen wurden aktualisiert. Bitte lesen und akzeptieren Sie die aktualisierten Bedingungen, um Cephable weiterhin zu nutzen.","effectiveDate":"G\xfcltigkeitsdatum: {{date}}","accept":"Nutzungsbedingungen akzeptieren","loadError":"Nutzungsbedingungen k\xf6nnen nicht geladen werden. Bitte versuchen Sie es erneut.","viewInBrowser":"Nutzungsbedingungen im Browser anzeigen","acceptCheckbox":"Ich habe die Nutzungsbedingungen gelesen und akzeptiere sie"}}');


var $00d894b7ec9a312b$exports = {};
$00d894b7ec9a312b$exports = JSON.parse('{"404":"Oh nein! Wir haben das ganze Meer abgesucht und k\xf6nnen die Seite nicht finden!"}');


var $a20b4edf601225c9$exports = {};
$a20b4edf601225c9$exports = JSON.parse('{"smartTasks":{"tourLabel":"Intelligente Aufgaben","learn":"Erfahren Sie, wie Sie mit Cephable Text generieren, umschreiben und \xfcbersetzen.","generate":{"openTool":{"title":"Tool \u201EText generieren\u201C \xf6ffnen","description":"Klicken Sie im Cephable-Bedienfeld auf das Symbol neben \u201EIntelligente Aufgaben\u201C und w\xe4hlen Sie \u201EText generieren\u201C aus."},"enterPrompt":{"title":"Eingabeaufforderung eingeben","description":"Geben Sie in das Eingabefeld ein: \u201EErstellen Sie ein einpr\xe4gsames Wortspiel in einem Satz.\u201C"},"clickGenerate":{"title":"Klicken Sie auf Generieren","description":"Klicken Sie auf die Schaltfl\xe4che \u201EGenerieren\u201C. Der Text wird in Echtzeit angezeigt."},"focusApp":{"title":"Konzentrieren Sie sich auf die App","description":"Konzentrieren Sie sich auf die App, in der der generierte Text erscheinen soll. Klicken Sie auf \u201EGenerieren\u201C, um Text nahtlos an dieser Stelle zu generieren."}},"rewrite":{"welcome":{"title":"Willkommen bei Rewrite","description":"Formulieren Sie Inhalte schnell mit hervorgehobenem oder eingef\xfcgtem Text um."},"highlightToggle":{"title":"Hervorgehobenen Text verwenden","description":"Stellen Sie sicher, dass \u201EHervorgehobenen Text verwenden\u201C ausgew\xe4hlt ist (Standard)."},"highlightText":{"title":"Markieren Sie den Text zum Umschreiben","description":"Highlight: Ein Oktopus kann jeden Arm unabh\xe4ngig steuern."},"enterInstructions":{"title":"Geben Sie die Umschreibanweisungen ein","description":"Typ: Im alten englischen Stil."},"clickGenerate":{"title":"Klicken Sie auf Generieren","description":"Ihr markierter Text wird basierend auf Ihrer Eingabe neu geschrieben."},"pasteMode":{"title":"Verwenden Sie \u201EText einf\xfcgen\u201C","description":"Original einf\xfcgen und Anweisung neu schreiben. Klicken Sie auf \u201EGenerieren\u201C. Klicken Sie zum Zur\xfccksetzen auf \u201EL\xf6schen\u201C."},"openTool":{"title":"\xd6ffnen Sie das Tool \u201EText umschreiben\u201C","description":"Klicken Sie im Cephable-Bedienfeld auf das Symbol neben \u201EIntelligente Aufgaben\u201C und w\xe4hlen Sie \u201EText umschreiben\u201C aus."},"focusApp":{"title":"Konzentrieren Sie sich auf die App","description":"Konzentrieren Sie sich auf die App, in der der umgeschriebene Text erscheinen soll. Klicken Sie auf \u201EGenerieren\u201C, um Text nahtlos an dieser Stelle zu generieren."}},"translate":{"welcome":{"title":"Willkommen bei Translate","description":"\xdcbersetzen Sie markierten oder eingef\xfcgten Text in eine andere Sprache."},"highlightToggle":{"title":"Hervorgehobenen Text verwenden","description":"Stellen Sie sicher, dass \u201EHervorgehobenen Text verwenden\u201C ausgew\xe4hlt ist."},"highlightText":{"title":"Markieren Sie den zu \xfcbersetzenden Text","description":"Highlight: Ein Oktopus kann jeden Arm unabh\xe4ngig steuern."},"enterLanguage":{"title":"Zielsprache eingeben","description":"Typ: Portugiesisch."},"clickGenerate":{"title":"Klicken Sie auf Generieren","description":"Die \xdcbersetzung wird an der Stelle in Ihre App eingegeben, an der Sie den Cursor bewegen."},"pasteMode":{"title":"Verwenden Sie \u201EText einf\xfcgen\u201C","description":"F\xfcgen Sie Text und Sprache ein. Klicken Sie auf \u201EGenerieren\u201C. Klicken Sie zum Zur\xfccksetzen auf \u201EL\xf6schen\u201C."},"openTool":{"title":"\xd6ffnen Sie das Tool zum \xdcbersetzen von Text","description":"Klicken Sie im Cephable-Bedienfeld auf das Symbol neben \u201EIntelligente Aufgaben\u201C und w\xe4hlen Sie \u201EText \xfcbersetzen\u201C aus."}},"rowDescription":"Intelligente Aufgaben sind die verschiedenen Aufgaben, die die KI von Cephable f\xfcr Sie erledigen kann. Diese Aufgaben werden durch die KI auf dem Ger\xe4t unterst\xfctzt und k\xf6nnen zum Erstellen von Texten, Zusammenfassen, Umschreiben, \xdcbersetzen und vielem mehr verwendet werden."},"overview":{"title":"\xdcberblick","description":"Cephable ist Ihre pers\xf6nliche KI \u2013 entwickelt f\xfcr schnelle Aktionen, Sprachbefehle, Inhaltsgenerierung und intelligente Automatisierung Ihrer Tools. Sofort einsatzbereite Steuerung. Keine Cloud-Verarbeitung. Nur Produktivit\xe4t, die mit Ihnen mitgeht."},"customControls":{"tourLabel":"Immer verf\xfcgbare globale und Ger\xe4testeuerungen","rowDescription":"Globale und Ger\xe4testeuerungen sind immer verf\xfcgbar, wenn Ihr Mikrofon eingeschaltet ist, unabh\xe4ngig von der verwendeten App. Sie k\xf6nnen diese Steuerungen verwenden, um mit Ihrem Ger\xe4t zu interagieren, ohne neue App-Steuerungen erstellen zu m\xfcssen. Sie enthalten hilfreiche Befehle wie das Wechseln von Steuerungen oder Apps, das Generieren von Text, das Pausieren Ihres Mikrofons und mehr."},"profile":{"tourLabel":"App-Steuerung","learn":"Erfahren Sie, wie Sie Ihre App-Steuerelemente und Einstellungen in Cephable einrichten.","rowDescription":"App-Steuerelemente sind konfigurierte Steuerelemente, mit denen Sie bestimmte Aktionen ausf\xfchren k\xf6nnen. M\xf6chten Sie \u201EN\xe4chste Folie\u201C sagen, um zur n\xe4chsten Folie Ihrer Pr\xe4sentation zu gelangen? Oder den Cursor per Kopfbewegung und Sprachsteuerung f\xfcr Bearbeitungsverkn\xfcpfungen nutzen? Mit App-Steuerelementen ist das m\xf6glich. In der Steuerelementzeile werden alle f\xfcr Ihre aktuelle App verf\xfcgbaren Steuerelemente angezeigt.","check":{"title":"\xdcberpr\xfcfen Sie Ihre verf\xfcgbaren Steuerelemente.","description":"App-Steuerungen sind f\xfcr jede von Ihnen verwendete App verf\xfcgbar. Hier sehen Sie die verf\xfcgbaren Steuerungen f\xfcr die aktuell verwendete App. Probieren Sie einen anderen Befehl aus, um zu sehen, wie er funktioniert. Achten Sie jedoch darauf, dass Sie sich auf die App konzentrieren, die Sie steuern m\xf6chten."}},"dictation":{"tourLabel":"Diktat","learn":"Erfahren Sie, wie Sie mit dem Diktiermodus Ihre Sprache freih\xe4ndig in Text umwandeln.","welcome":{"title":"Diktat","description":"Mit der Diktierfunktion k\xf6nnen Sie nat\xfcrlich sprechen und Ihre Worte direkt w\xe4hrend des Sprechens abtippen lassen. Es ist, als h\xe4tten Sie einen pers\xf6nlichen Assistenten, der alles tippt, was Sie sagen."},"microphone":{"title":"Schalten Sie Ihr Mikrofon ein","description":"Schalten Sie zun\xe4chst Ihr Mikrofon ein. Klicken Sie dazu auf den Mikrofonschalter im Cephable-Panel."},"activate":{"title":"Diktiermodus starten","description":"Die Sprachsteuerung startet im Befehlsmodus. Um das Diktieren zu starten, sagen Sie \u201EDiktat starten\u201C oder klicken Sie auf die Schaltfl\xe4che \u201EDiktieren\u201C. Schalten wir jetzt den Diktiermodus ein."},"focus":{"title":"Konzentrieren Sie sich auf ein Textfeld oder Dokument","description":"Das Diktieren funktioniert am besten, wenn Sie sich auf ein Textfeld oder Dokument konzentrieren. Klicken Sie auf das Textfeld oder Dokument, in das Sie diktieren m\xf6chten."},"speaking":{"title":"Fangen Sie an zu sprechen","description":"Jetzt k\xf6nnen Sie lossprechen. Alles, was Sie sagen, wird in das Textfeld oder Dokument eingegeben, auf das Sie sich konzentriert haben. Sagen Sie beispielsweise: \u201EHallo, dies ist ein Test des Diktiermodus.\u201C"},"pauseResume":{"title":"Diktat pausieren","description":"Brauchen Sie eine Pause, ohne die Diktierfunktion auszuschalten? Sagen Sie einfach \u201EDiktat pausieren\u201C. Sie k\xf6nnen jederzeit mit \u201EDiktat starten\u201C fortfahren. Sie k\xf6nnen die Funktion mit Ihren globalen Always-On- und Ger\xe4testeuerungen weiter anpassen."},"stop":{"title":"Diktat stoppen","description":"M\xf6chten Sie zur\xfcck zur App-Steuerung wechseln? Sagen Sie einfach \u201EDiktat beenden\u201C. Dadurch wird der Diktiermodus beendet und Sie kehren in den Befehlsmodus zur\xfcck. Sie k\xf6nnen jederzeit mit \u201EDiktat starten\u201C fortfahren."},"complete":{"description":"Das war\'s! Sie k\xf6nnen jetzt diktieren, pausieren, fortsetzen und zwischen Diktier- und Befehlsmodus wechseln. Diktieren ist ein leistungsstarkes Tool f\xfcr freih\xe4ndiges Tippen. Verwenden Sie es zum Schreiben von E-Mails, Dokumenten oder anderen Texten, die Sie laut tippen m\xfcssen."}},"camera":{"tourLabel":"Kamerasteuerung","rowDescription":"Mit der Kamerasteuerung k\xf6nnen Sie Ihr Ger\xe4t mit Gesicht und K\xf6rper steuern. Sie k\xf6nnen verschiedene Gesichtsausdr\xfccke und Kopfbewegungen verwenden, um Ihr Ger\xe4t zu steuern. Bei eingeschaltetem Mikrofon k\xf6nnen Sie die Kamera per Sprachbefehl starten, stoppen und zwischen Kameras wechseln.","learn":"Erfahren Sie, wie Sie mithilfe der Kamerasteuerung freih\xe4ndig auf Ihrem Ger\xe4t navigieren und interagieren.","welcome":{"title":"Kamerasteuerung","description":"Mit der Kamerasteuerung k\xf6nnen Sie Ihr Ger\xe4t mit Gesicht und K\xf6rper steuern. Nutzen Sie verschiedene Gesichtsausdr\xfccke, Kopfbewegungen und Sprachbefehle, um freih\xe4ndig auf Ihrem Ger\xe4t zu navigieren und zu interagieren."},"start":{"title":"Kamerasteuerung starten","description":"Um die Kamerasteuerung per Sprache zu starten, sagen Sie \u201EKamerasteuerung starten\u201C oder klicken Sie auf die Schaltfl\xe4che \u201EKamerasteuerung\u201C."}},"microphone":{"tourLabel":"Sprachsteuerung","learn":"Erfahren Sie, wie Sie jede App mit Ihrer Stimme steuern und Ihre Worte per Diktierfunktion eintippen k\xf6nnen.","description":"Mit der Cephable-Sprachsteuerung k\xf6nnen Sie Ihr Ger\xe4t per Sprache steuern. Sie m\xf6chten ein Dokument speichern? Sagen Sie einfach \u201ESpeichern\u201C. Sie m\xf6chten Ihre Musik pausieren? Sagen Sie einfach \u201EPause\u201C. Sie k\xf6nnen Ihre Worte auch per Diktierfunktion eintippen.","rowDescription":"Wenn das Mikrofon ausgeschaltet ist, h\xf6ren wir Ihre Sprachbefehle \xfcberhaupt nicht. Wenn Sie es jedoch einschalten, k\xf6nnen Sie globale Befehle verwenden, um Pause, Start und mehr umzuschalten. Schalten wir es ein.","start":{"title":"Sprachsteuerung starten","description":"Um die Sprachsteuerung zu nutzen, klicken Sie auf den Mikrofonschalter auf dem Cephable-Panel. Dadurch wird das Mikrofon eingeschaltet und empf\xe4ngt Befehle."},"tryOpen":{"title":"Versuchen Sie, \u201E\xd6ffne Spotify\u201C oder \u201E\xd6ffne Word\u201C zu sagen.","description":"\u201E\xd6ffnen\u201C ist ein globaler Befehl, der die von Ihnen angegebene App \xf6ffnet und den Fokus darauf legt. Wenn Sie die automatische Steuerungsumschaltung aktiviert haben, wird auch zu den App-Steuerelementen gewechselt, die am besten zu Ihrer verwendeten App passen."},"finishedCommands":{"title":"Ausgezeichnet! Sie haben die Grundlagen der Sprachsteuerung gelernt.","description":"Sie k\xf6nnen die Tour jederzeit von der Support-Seite aus erneut aufrufen. Im n\xe4chsten Schritt erfahren Sie mehr \xfcber die Diktierfunktion. Sie k\xf6nnen die Tour von der Support-Seite aus starten."}},"publicProfiles":{"tourLabel":"App-Steuerelemente anpassen"},"tour":{"title":"Willkommen bei Cephable","description":"Cephable ist ein leistungsstarkes Tool, mit dem Sie Ihren Computer per Sprache, Kamera und anderen Eingaben steuern k\xf6nnen. Diese Tour f\xfchrt Sie durch die wichtigsten Funktionen und zeigt Ihnen, wie Sie diese effektiv nutzen k\xf6nnen.","startTour":"Tour starten","finishTour":"Tour beenden","statusDialog":"Weitere Informationen finden Sie im Panel.","step":"Schritt {{step}} von {{total}}","next":"N\xe4chste","previous":"Vorherige","endTour":"Tour beenden","nextTourLabel":"Weiter: {{nextStepTitle}}","skipTour":"Tour \xfcberspringen","steps":{"welcome":{"title":"Willkommen bei Cephable","description":"Diese Tour f\xfchrt Sie durch die Hauptfunktionen von Cephable. Los geht\'s!"},"inputs":{"title":"\xdcbersicht der Eing\xe4nge","description":"Cephable unterst\xfctzt verschiedene Eingabemethoden, darunter Sprachbefehle, Kamerasteuerung und mehr. Sie k\xf6nnen diese Eingaben in den Einstellungen anpassen."},"appControls":{"title":"App-Steuerung","description":"Erstellen Sie App-Steuerelemente, um Ihre Eingaben bestimmten Aktionen in Ihren Anwendungen zuzuordnen. So k\xf6nnen Sie Apps mit Gesten, Sprachbefehlen und mehr steuern."},"settings":{"title":"Einstellungen","description":"Greifen Sie auf die Einstellungen zu, um Ihre Eingaben, App-Steuerung und andere Einstellungen zu konfigurieren. Sie k\xf6nnen hier auch Ihr Konto und Ihre Spracheinstellungen verwalten."},"intelligentTasks":{"title":"Intelligente Aufgaben","description":"Verwenden Sie intelligente Aufgaben, um mithilfe KI-gest\xfctzter Funktionen Text zu generieren, Inhalte zusammenzufassen, Text neu zu schreiben, Sprachen zu \xfcbersetzen und mehr."},"cameraControls":{"title":"Kamerasteuerung","description":"Aktivieren Sie die Kamerasteuerung, um Gesichtsausdr\xfccke und Kopfbewegungen als Eingabemethoden zur Steuerung Ihres Computers zu verwenden."},"voiceControls":{"title":"Sprachsteuerung","description":"Steuern Sie Ihren Computer freih\xe4ndig mit Sprachbefehlen. Diktieren Sie Texte, geben Sie Befehle ein und interagieren Sie mit Anwendungen \u2013 ganz einfach per Sprachbefehl."}}},"onboarding":{"demoPlaceholder":"Dies ist der Platzhalter-Demotext. Mithilfe der obigen Eingabeaufforderungen k\xf6nnen Sie die Formatierung dieses Textes steuern.","exit":"Setup beenden","overview":"\xdcberblick","learn":"Informieren Sie sich \xfcber die Funktionen von Cephable und deren Verwendung.","start":"Sie scheinen gerade erst anzufangen. Hier sind einige Bereiche, die Ihnen dabei helfen werden.","startTour":"Erste Schritte","dashboard":{"title":"Cephable Dashboard","description":"Das Cephable Dashboard ist Ihre zentrale Anlaufstelle f\xfcr die Verwaltung Ihres Ger\xe4ts, Ihrer App-Steuerung und Ihrer Einstellungen. Von hier aus k\xf6nnen Sie Ihr Erlebnis anpassen, aktive Befehle anzeigen und auf alle Funktionen von Cephable zugreifen."},"step1":{"title":"Willkommen bei Cephable","description":"Cephable ist Ihre pers\xf6nliche KI \u2013 entwickelt f\xfcr schnelle Aktionen, Sprachbefehle, Inhaltsgenerierung und intelligente Automatisierung Ihrer Tools. Sofort einsatzbereite Steuerung. Keine Cloud-Verarbeitung. Nur Produktivit\xe4t, die mit Ihnen mitgeht.","inputs":"Was sind Eingaben?","inputDescription":"Eingabesteuerungen sind die Methoden zur Bedienung Ihres Ger\xe4ts, die die M\xf6glichkeiten Ihres Computers \xfcber die herk\xf6mmliche Maus und Tastatur hinaus erweitern. Zu diesen Methoden geh\xf6ren Sprachbefehle, Kopfbewegungen, Mimik und zus\xe4tzliche Peripherieger\xe4te.","profiles":"Was sind App-Steuerelemente?","profileDescription":"App-Steuerungen erm\xf6glichen Ihnen durch die Verkn\xfcpfung von Eingabe- und Ausgabesteuerungen eine einzigartige Verbindung und Kommunikation mit Ihrem Computer. Mit App-Steuerungen k\xf6nnen Sie Cephable anweisen, Aufgaben wie das Speichern einer Datei durch Neigen des Kopfes oder das Klicken auf \u201ESenden\u201C einer E-Mail durch ein L\xe4cheln auszuf\xfchren.","action":"Eingabesteuerelemente erkunden","secondaryAction":"Weiter zu den App-Steuerelementen","secondaryActionDescription":"Kennen Sie bereits Eingabesteuerelemente?"},"finish":{"title":"Einrichtung abgeschlossen","description":"Sie haben Ihre ersten Cephable-App-Steuerelemente erfolgreich verwendet! Sie k\xf6nnen diese und weitere jetzt auf Ihrem Ger\xe4t nutzen. Sie finden sie auf Ihrem Cephable-Dashboard, wo Sie die Einstellungen der App-Steuerelemente nach Bedarf anpassen k\xf6nnen.","continueToApp":"Weiter zum Cephable Dashboard","keepExploring":"Weiter entdecken"},"useCaseSlider":{"context":"Ich m\xf6chte verwenden","control":"kontrollieren"}},"support":{"tourLabel":"Bereit, mehr zu erfahren?","description":"Weitere Informationen zur Verwendung von Cephable, einschlie\xdflich weiterer Touren, Schritt-f\xfcr-Schritt-Anleitungen, Tutorials und Videos, finden Sie in unserem Support-Hub.","cta":"Entdecken Sie andere Touren"},"featureFlag":{"title":"Zeit f\xfcr ein Upgrade","description":"F\xfcr die Funktion, die Sie verwenden m\xf6chten, ist eine andere Lizenz erforderlich. F\xfchren Sie ein Upgrade durch, um diese und weitere Funktionen freizuschalten."},"replyToSocialMedia":{"tourLabel":"Schnellere Social-Media-Antworten mit Diktierfunktion","learn":"Erfahren Sie, wie Sie per Diktierfunktion freih\xe4ndig auf Social-Media-Beitr\xe4ge antworten.","navigateTo":{"title":"Navigieren Sie zu einem Social Media-Beitrag","description":"\xd6ffnen Sie Ihren Webbrowser und navigieren Sie zu einer Social-Media-Plattform wie LinkedIn oder Facebook. Suchen Sie einen Beitrag, auf den Sie antworten m\xf6chten."},"speaking":{"title":"Beginnen Sie zu sprechen","description":"Jetzt k\xf6nnen Sie loslegen. Alles, was Sie sagen, wird in das Textfeld oder Dokument eingegeben, auf das Sie sich konzentriert haben. Sagen Sie beispielsweise \u201EHerzlichen Gl\xfcckwunsch! Ich freue mich f\xfcr Sie.\u201C Stellen Sie sicher, dass der Cursor auf einem Textfeld oder Kommentarfeld steht."},"complete":{"description":"Das war\'s! Sie k\xf6nnen jetzt diktieren, pausieren, fortsetzen und zwischen Diktier- und Befehlsmodus wechseln, um freih\xe4ndig auf Social-Media-Beitr\xe4ge zu antworten. Diktieren ist ein leistungsstarkes Tool f\xfcr freih\xe4ndiges Tippen. Verwenden Sie es zum Schreiben von E-Mails, Dokumenten oder anderen Texten, die Sie laut tippen m\xfcssen."}},"hotkeys":{"tourLabel":"Schnellaktionsschaltfl\xe4chen","learn":"Erfahren Sie, wie Sie Schnellaktionsschaltfl\xe4chen einrichten, um einer einzigen Schaltfl\xe4che mehrere Aktionen zuzuordnen.","rowDescription":"Mit Schnellaktionsschaltfl\xe4chen k\xf6nnen Sie mehrere Aktionen mit einem einzigen Befehl ausf\xfchren. Sie k\xf6nnen beispielsweise eine Schaltfl\xe4che erstellen, die Ihre Lieblingsmusik-App \xf6ffnet und die Wiedergabe einer bestimmten Playlist startet.","check":{"title":"\xdcberpr\xfcfen Sie Ihre verf\xfcgbaren Schnellaktionen.","description":"F\xfcr jede App, die Sie verwenden, stehen Schnellaktionstasten zur Verf\xfcgung. Hier sehen Sie die verf\xfcgbaren Tasten f\xfcr die aktuell verwendete App. Probieren Sie einen anderen Befehl aus, um zu sehen, wie er funktioniert. Achten Sie jedoch darauf, dass Sie sich auf die App konzentrieren, die Sie steuern m\xf6chten."}},"controllingBackgroundMusic":{"tourLabel":"Verwalten Sie Hintergrundmusik, ohne Ihren Arbeitsfluss zu unterbrechen","learn":"Erfahren Sie, wie Sie mithilfe von Sprachsteuerung und Schnellaktionen Ihre Musik freih\xe4ndig steuern und sich gleichzeitig auf Ihre aktuelle Aufgabe konzentrieren k\xf6nnen.","tryOpen":{"title":"Versuchen Sie, \u201E\xd6ffne Spotify\u201C oder \u201E\xd6ffne Apple Music\u201C zu sagen."},"play":{"title":"Sagen Sie \u201EPlay\u201C, um die Musikwiedergabe zu starten.","description":"Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie \u201EPlay\u201C. Dadurch wird die Musikwiedergabe in der ausgew\xe4hlten Musik-App gestartet. Dies funktioniert auch mit jeder anderen Medien-App."},"newPlaylist":{"title":"Erstellen einer neuen Playlist","description":"Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie \u201ENeue Playlist\u201C. Dadurch wird der Vorgang zum Erstellen einer neuen Playlist in der von Ihnen gew\xe4hlten Musik-App gestartet."},"finishedCommands":{"title":"Gut gemacht! Sie haben gelernt, wie Sie Ihre Musik freih\xe4ndig steuern k\xf6nnen.","description":"Sie wissen jetzt, wie Sie in Ihren Lieblingsmusik-Apps mit Sprachbefehlen und Schnellaktionen Titel abspielen, pausieren, \xfcberspringen und die Lautst\xe4rke anpassen. Entdecken Sie weitere Befehle oder passen Sie Ihre eigenen Schnellaktionen an, um Ihre Musik noch einfacher zu steuern."}},"editingVideos":{"tourLabel":"Konzentrieren Sie sich auf die Geschichte, nicht auf die m\xfchsamen Klicks zur Videobearbeitung","learn":"Erfahren Sie, wie Sie mithilfe von Sprachsteuerungen und Schnellaktionen Videos schneller bearbeiten und sich nicht mehr merken m\xfcssen, auf welche Schaltfl\xe4chen Sie w\xe4hrend der Bearbeitung klicken m\xfcssen.","tryOpen":{"title":"Versuchen Sie, \u201E\xd6ffnen Sie iMovie\u201C oder \u201E\xd6ffnen Sie DaVinci Resolve\u201C zu sagen."},"play":{"title":"Sagen Sie \u201EPlay\u201C, um die Wiedergabe Ihres Videos zu starten.","description":"Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie \u201EPlay\u201C. Dadurch wird Ihr Video in der von Ihnen gew\xe4hlten Videobearbeitungs-App abgespielt."},"stop":{"title":"Videowiedergabe stoppen","description":"Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie \u201EStopp\u201C. Dadurch wird die Videowiedergabe in der von Ihnen gew\xe4hlten Videobearbeitungs-App gestoppt."},"finishedCommands":{"title":"Gut gemacht! Sie haben gelernt, wie Sie Ihre Videobearbeitung freih\xe4ndig steuern k\xf6nnen.","description":"Sie wissen jetzt, wie Sie in Ihren bevorzugten Videobearbeitungs-Apps Sprachbefehle und Schnellaktionen zum Abspielen, Anhalten, \xdcberspringen von Titeln und Anpassen der Lautst\xe4rke verwenden. Entdecken Sie weitere Befehle oder passen Sie Ihre eigenen Schnellaktionen an, um die Videosteuerung noch reibungsloser zu gestalten."}},"vibeCoding":{"tourLabel":"Mit Diktierfunktion schneller Ideen entwickeln, Prototypen erstellen und iterieren","learn":"Erfahren Sie, wie Sie Diktat und KI-gest\xfctzte Textgenerierung nutzen, um Code zu simulieren, Prototypen zu erstellen und Ideen zu iterieren.","navigateTo":{"title":"Navigieren Sie zu einem Vibe-Code-Editor","description":"\xd6ffnen Sie Ihren Webbrowser und navigieren Sie zu einem Vibe-Code-Editor. Einige Beispiele sind Vercel V0, GitHub Copilot in VS Code, Base 44 und Lovable."},"focus":{"title":"Klicken Sie auf \u201ENeuer Chat\u201C oder \u201EFokussieren Sie ein Textfeld\u201C","description":"Das Diktieren funktioniert am besten, wenn Sie sich auf ein Textfeld oder Dokument konzentrieren. Klicken Sie auf das Kommentarfeld oder den Antwortthread, in dem Sie diktieren m\xf6chten. Beginnen Sie dann zu sprechen."},"speaking":{"title":"Beginnen Sie zu sprechen","description":"Jetzt k\xf6nnen Sie loslegen. Alles, was Sie sagen, wird in das Textfeld oder Dokument eingegeben, auf das Sie sich konzentriert haben. Geben Sie Ihre technischen Anforderungen und die Funktion des Codes an. Stellen Sie sicher, dass der Cursor auf einem Textfeld oder Kommentarfeld steht."},"rewriteIntro":{"title":"Code mit Anweisungen neu schreiben","description":"Sie k\xf6nnen auch intelligente Aufgaben wie \u201ERewrite\u201C verwenden, um vorhandenen Code direkt zu \xe4ndern. Diese Aufgabe wird durch ger\xe4teinterne KI unterst\xfctzt, d. h. sie funktioniert ohne Internetverbindung und wird von Ihrem Ger\xe4t aus ausgef\xfchrt."},"highlightText":{"title":"Markieren Sie den Text zum Umschreiben","description":"Markieren Sie den Code, den Sie neu schreiben m\xf6chten."},"enterInstructions":{"title":"Geben Sie die Umschreibanweisungen ein","description":"Geben Sie Ihre Anweisungen zum Umschreiben des Codes ein. Geben Sie die Programmiersprache, den Stil oder alle gew\xfcnschten \xc4nderungen an."},"complete":{"description":"Das war\'s! Sie k\xf6nnen jetzt Code diktieren, pausieren, fortsetzen und iterieren. Entdecken Sie weitere Anwendungsf\xe4lle mit Diktierfunktion und intelligenten Aufgaben sowie andere Funktionen zur Optimierung Ihres Workflows."}},"documentCode":{"tourLabel":"Schnelle, sichere Codedokumentation mit KI-Textgenerierung auf dem Ger\xe4t","learn":"Erfahren Sie, wie Sie mithilfe der KI-gest\xfctzten Umschreibung Code dokumentieren, w\xe4hrend Sie in derselben App bleiben und Ihre Daten sicher halten.","rewriteIntro":{"title":"Schreiben Sie Codedokumentation","description":"Sie k\xf6nnen Cephable Intelligent Rewrite verwenden, um Codedokumentation in einem separaten Dokument oder einer App zu schreiben. Rewrite ist Teil der On-Device-KI-Aufgaben, einschlie\xdflich Offline-Generierung und -\xdcbersetzung."},"focusApp":{"title":"Konzentrieren Sie sich auf Ihren Code","description":"\xd6ffnen Sie Ihre IDE und konzentrieren Sie sich auf den Code, den Sie dokumentieren m\xf6chten."},"newFile":{"title":"Erstellen einer Dokumentationsdatei","description":"Erstellen Sie eine neue Datei in Ihrer IDE oder \xf6ffnen Sie eine separate App, in der die Dokumentation angezeigt werden soll."},"highlightText":{"title":"Code hervorheben","description":"Markieren und kopieren Sie den Code, den Sie dokumentieren m\xf6chten."},"pasteMode":{"title":"Klicken Sie auf die Registerkarte \u201EText einf\xfcgen\u201C","description":"Verwenden Sie den Einf\xfcgemodus, um den Originalcode einzuf\xfcgen und die Dokumentation in eine neue Datei zu schreiben."},"pasteInput":{"title":"Code in Dokument einf\xfcgen","description":"F\xfcgen Sie den Code, den Sie dokumentieren m\xf6chten, in das Eingabefeld ein."},"enterInstructions":{"title":"Geben Sie Formatierungs-, Stil- und Inhaltsanweisungen ein","description":"Geben Sie die Anweisungen f\xfcr Ihre Codierungsdokumentation ein. Geben Sie den Dateityp (z. B. Markdown), den Stil oder den gew\xfcnschten Inhalt an."},"complete":{"description":"Sie haben gelernt, wie Sie Intelligent Tasks f\xfcr eine schnelle und sichere Codedokumentation nutzen. Entdecken Sie weitere Anwendungsf\xe4lle mit Rewrite oder anderen Funktionen zur Optimierung Ihres Workflows."}},"generateCode":{"tourLabel":"Schnelle, sichere Codegenerierung mit KI-Textgenerierung auf dem Ger\xe4t","learn":"Erfahren Sie, wie Sie mithilfe der KI-gest\xfctzten Generierung Codeausschnitte erstellen, w\xe4hrend Sie zwischen Apps wechseln und Ihre Daten sicher halten.","rewriteIntro":{"title":"Schreiben Sie Code-Snippets","description":"Mit Cephable Intelligent Rewrite k\xf6nnen Sie Code-Snippets in Ihrer IDE schreiben, w\xe4hrend Sie Anforderungen aus einer anderen Anwendung abrufen. Rewrite ist Teil der On-Device-KI-Aufgaben, einschlie\xdflich Offline-Generierung und -\xdcbersetzung."},"focusApp":{"title":"Konzentrieren Sie sich auf den Inhalt Ihres Tickets","description":"\xd6ffnen Sie Ihr Ticket mit den Anforderungen und konzentrieren Sie sich auf den Inhalt, f\xfcr den Sie Code generieren m\xf6chten."},"newFile":{"title":"Erstellen einer Codeausschnittdatei","description":"Erstellen Sie eine neue Datei in Ihrer IDE."},"highlightText":{"title":"Ticketinhalte hervorheben","description":"Markieren und kopieren Sie den Inhalt, f\xfcr den Sie Code generieren m\xf6chten."},"pasteMode":{"title":"Klicken Sie auf die Registerkarte \u201EText einf\xfcgen\u201C","description":"Verwenden Sie den Einf\xfcgemodus, um die urspr\xfcnglichen Ticketanforderungen einzuf\xfcgen und Codeausschnitte daf\xfcr zu schreiben."},"pasteInput":{"title":"Anforderungen einf\xfcgen, um Code zu generieren","description":"F\xfcgen Sie die Anforderungen, die Sie f\xfcr die Codegenerierung verwenden m\xf6chten, in das Eingabefeld ein."},"enterInstructions":{"title":"Geben Sie Anweisungen zur Programmiersprache und zum Stil ein","description":"Geben Sie Ihre Programmiersprache und Stilanweisungen ein. Geben Sie die Programmiersprache (z. B. C#), den Stil oder alle spezifischen Codierungsanweisungen an, die Sie haben."},"translateIntro":{"title":"Code-Snippets \xfcbersetzen","description":"Sie k\xf6nnen Cephable Intelligent Translate auch verwenden, um Code-Snippets direkt in Ihrer IDE von einer Programmiersprache in eine andere zu konvertieren. Translate ist Teil der On-Device-KI-Aufgaben, einschlie\xdflich Offline-Generierung und -Umschreiben."},"copyGeneratedCode":{"title":"Kopieren Sie den generierten Code","description":"Nachdem Sie mit den vorherigen Schritten Code generiert haben, markieren und kopieren Sie den generierten Codeausschnitt."},"translatePasteMode":{"title":"Klicken Sie auf die Registerkarte \u201EText einf\xfcgen\u201C","description":"Verwenden Sie den Einf\xfcgemodus, um den Originalcode einzuf\xfcgen und in eine andere Programmiersprache zu \xfcbersetzen."},"enterProgrammingLanguage":{"title":"Geben Sie die Zielprogrammiersprache ein","description":"Geben Sie die Programmiersprache ein, in die Sie den Code \xfcbersetzen m\xf6chten (z. B. Python)."},"pasteCode":{"title":"F\xfcgen Sie den generierten Code in Ihre IDE ein","description":"Gehen Sie zu Ihrer IDE und f\xfcgen Sie den kopierten Codeausschnitt in die neue Datei ein, die Sie zuvor erstellt haben."},"complete":{"description":"Sie haben gelernt, wie Sie mit Intelligent Tasks schnell und sicher Code generieren und \xfcbersetzen k\xf6nnen. Entdecken Sie weitere Anwendungsf\xe4lle mit \u201EGenerieren und \xdcbersetzen\u201C oder anderen Funktionen zur Optimierung Ihres Workflows."}},"requirementDocsFromMeeting":{"tourLabel":"Von Notizen zu Produktanforderungsdokumenten in Minuten","learn":"Erfahren Sie, wie Sie mithilfe von AI Intelligent Tasks strukturierte Produktanforderungsdokumente aus Besprechungsnotizen erstellen und gleichzeitig Ihre Daten sch\xfctzen.","rewriteIntro":{"title":"Erstellen von Produktanforderungsdokumenten","description":"Mit Cephable Intelligent Rewrite k\xf6nnen Sie aus Besprechungsnotizen strukturierte Produktanforderungsdokumente erstellen. Rewrite ist Teil der On-Device-KI-Aufgaben, einschlie\xdflich Offline-Generierung und -\xdcbersetzung."},"focusNotes":{"title":"\xd6ffnen Sie Ihre Besprechungsnotizen","description":"\xd6ffnen Sie Ihre Besprechungsnotizen, Transkriptionen oder andere besprechungsbezogene Textinhalte."},"highlight":{"title":"Besprechungsnotizen hervorheben","description":"Markieren Sie die Besprechungsnotizen, die Sie zum Erstellen eines Produktanforderungsdokuments verwenden m\xf6chten."},"enterInstructions":{"title":"Geben Sie die Dokumentstruktur und Inhaltsanweisungen ein","description":"Geben Sie die Anweisungen f\xfcr Ihr Produktanforderungsdokument ein. Geben Sie die Struktur, den Stil oder den gew\xfcnschten Inhalt an."},"complete":{"description":"Sie haben gelernt, wie Sie mit Intelligent Tasks schnell und sicher Produktanforderungsdokumente erstellen. Entdecken Sie weitere Anwendungsf\xe4lle mit Rewrite oder anderen Funktionen zur Optimierung Ihres Workflows."}},"headMouseMovement":{"tourLabel":"Freih\xe4ndiges Gaming-Setup mit Head Mouse","learn":"Erfahren Sie, wie Sie mithilfe von Kopfbewegungen Ihren Mauszeiger steuern und so pr\xe4zise navigieren und klicken k\xf6nnen.","deviceSettings":{"title":"Ger\xe4teeinstellungen \xf6ffnen","description":"Klicken Sie auf die Schaltfl\xe4che \u201EGer\xe4teeinstellungen\u201C, um Kopfbewegungen der Maus zu aktivieren."},"cameraSettings":{"title":"Kameraeinstellungen \xf6ffnen","description":"Klicken Sie in den Ger\xe4teeinstellungen auf Kameraeinstellungen, um auf die Kamerasteuerung zuzugreifen."},"headMouseSection":{"title":"Kopfbewegung zur Maussteuerung","description":"Wenn diese Option aktiviert ist, werden anstelle der Trigger-Steuerung einige Ihrer Kopfbewegungssteuerungen zum Bewegen Ihrer Maus verwendet."},"steadyGlide":{"title":"Steady Glide-Modus","description":"Aktivieren Sie den Steady-Glide-Modus. Wenn Sie Ihren Kopf \xfcber einen bestimmten Punkt hinaus bewegen, gleitet der Cursor kontinuierlich mit konstanter Geschwindigkeit in diese Richtung."},"customization":{"title":"Anpassen der Head Mouse-Einstellungen","description":"Sie k\xf6nnen die Einstellungen der Kopfmaus an Ihre Vorlieben anpassen. Passen Sie Geschwindigkeit, Empfindlichkeit und andere Einstellungen an, um das beste Erlebnis zu erzielen."},"save":{"title":"Head-Maus-Einstellungen speichern","description":"Vergessen Sie nicht, Ihre benutzerdefinierten Kopfmauseinstellungen zu speichern."},"transition":{"title":"Wechseln zum Cephable-Panel","description":"Wechseln wir nun zum Cephable Panel, um Kopfbewegungen der Maus auszuprobieren."},"playGames":{"title":"Spiele mit Head Mouse","description":"Jetzt k\xf6nnen Sie Ihren Mauszeiger beim Spielen mit Kopfbewegungen steuern. Probieren Sie es aus und sehen Sie, wie es funktioniert!"}},"clinicalNoteTaking":{"tourLabel":"HIPAA-konformes Diktieren und Formatieren f\xfcr Kliniker","learn":"Erfahren Sie, wie Sie Sprachbefehle, intelligente Diktierfunktion und KI-Formatierung zum Erstellen klinischer Notizen verwenden.","speaking":{"title":"Beginnen Sie zu sprechen","description":"Jetzt k\xf6nnen Sie sprechen. Alles, was Sie sagen, wird in das Textfeld oder Dokument eingegeben, auf das Sie sich konzentriert haben. Versuchen Sie beispielsweise, etwas zu sagen wie: \u201EDer Patient ist ein 45-j\xe4hriger Mann mit Bluthochdruck in der Vorgeschichte. Das letzte verschriebene Medikament wirkte nicht wie erwartet und l\xf6ste eine allergische Reaktion aus. Wir m\xfcssen nach alternativen Medikamenten suchen, und er m\xf6chte ein Generikum.\u201C"},"rewriteIntro":{"title":"Formatieren Sie Ihre Notizen","description":"Jetzt k\xf6nnen Sie Cephable Intelligent Rewrite verwenden, um Ihre Notizen im SOAP-Stil zu formatieren. Dies geschieht alles auf dem Ger\xe4t, sodass Ihre Daten privat, sicher und HIPAA-konform bleiben."},"copyText":{"title":"Kopieren Sie die Notizen","description":"Nachdem Sie Ihre Notizen markiert haben, kopieren Sie den Text, um ihn f\xfcr die Formatierung vorzubereiten."},"pasteMode":{"title":"Klicken Sie auf die Registerkarte \u201EText einf\xfcgen\u201C","description":"Verwenden Sie den Einf\xfcgemodus, um die Originalnotizen einzuf\xfcgen und sie im SOAP-Stil zu formatieren."},"pasteInput":{"title":"Notizen zum Formatieren einf\xfcgen","description":"F\xfcgen Sie die Notizen, die Sie formatieren m\xf6chten, in das Eingabefeld ein."},"enterInstructions":{"title":"Formatierungsanweisungen eingeben","description":"Sie k\xf6nnen Formatierungsanweisungen schreiben, die f\xfcr Ihre Klinik/Ihr EHR-System befolgt werden m\xfcssen. (Beispiel: Formatieren Sie im SOAP-Stil mit \xdcberschriften, Aufz\xe4hlungspunkten und pr\xe4gnanter Sprache.)"},"navigateToEHR":{"title":"Navigieren Sie zu Ihrem EHR-System","description":"\xd6ffnen Sie Ihr EHR-System und navigieren Sie zu dem Abschnitt, in dem Sie die formatierten Notizen eingeben m\xf6chten."},"focusTextField":{"title":"Konzentrieren Sie sich auf das Textfeld","description":"Klicken Sie auf das Textfeld, in das Sie die formatierten Notizen einf\xfcgen m\xf6chten."},"complete":{"description":"Sie haben gelernt, wie Sie Sprachbefehle und intelligente Diktierfunktion nutzen, um klinische Notizen zu dokumentieren, und wie Sie diese mit Intelligent Rewrite im SOAP-Stil formatieren. Entdecken Sie weitere Anwendungsf\xe4lle mit Diktierfunktion und Rewrite sowie weitere Funktionen zur Optimierung Ihres Workflows."},"focus":{"title":"Konzentrieren Sie sich auf ein Dokument","description":"Das Diktieren funktioniert am besten, wenn Sie sich auf ein Dokument konzentrieren. \xd6ffnen Sie ein Dokument, in dem Sie zwischen den Sitzungen klinische Notizen machen m\xf6chten."}},"webBrowsing":{"tourLabel":"Planen Sie Reisen, kaufen Sie online ein und surfen Sie im Internet per Sprachsteuerung","learn":"Erfahren Sie, wie Sie mithilfe von Sprachbefehlen navigieren, scrollen und Formulare ausf\xfcllen, w\xe4hrend Sie freih\xe4ndig im Internet surfen.","tryOpen":{"title":"Versuchen Sie, \u201EChrome \xf6ffnen\u201C oder \u201EEdge \xf6ffnen\u201C zu sagen.","description":"Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie \u201EChrome \xf6ffnen\u201C oder \u201EEdge \xf6ffnen\u201C. Dadurch wird der gew\xfcnschte Webbrowser ge\xf6ffnet. Wenn Sie die automatische Steuerungsumschaltung aktiviert haben, wird auch zu den App-Steuerelementen gewechselt, die am besten zu Ihrer App passen."},"search":{"title":"Suche","description":"Sagen Sie beispielsweise \u201ESuchen\u201C oder \u201ESuchen nach\u201C. Dadurch wird die Suchleiste in Ihrem Browser fokussiert."},"quickType":{"title":"Schnelles Tippen","description":"Mit der Schnelleingabe k\xf6nnen Sie per Spracheingabe tippen, ohne den Diktiermodus zu aktivieren. Sagen Sie beispielsweise \u201EWie ist das Wetter heute?\u201C. Dadurch wird Ihre Suchanfrage in die Suchleiste eingegeben."},"enter":{"title":"Dr\xfccken Sie die Eingabetaste","description":"Sagen Sie \u201EEnter\u201C. Dadurch wird die eingegebene Suchanfrage ausgef\xfchrt."},"scrollDown":{"title":"Nach unten scrollen","description":"Sagen Sie \u201ENach unten scrollen\u201C. Dadurch wird die Webseite nach unten gescrollt."},"scrollUp":{"title":"Nach oben scrollen","description":"Sagen Sie \u201ENach oben scrollen\u201C. Dadurch wird die Webseite nach oben gescrollt."},"newTab":{"title":"\xd6ffnen Sie einen neuen Tab","description":"Sagen Sie \u201ENeuer Tab\u201C. Dadurch wird ein neuer Tab in Ihrem Browser ge\xf6ffnet."},"formsCustomization":{"title":"Anpassung des Formularausf\xfcllens","description":"Sie k\xf6nnen diese App-Steuerung zum einfachen Ausf\xfcllen von Formularen anpassen. Beispielsweise Vorname, Nachname, E-Mail usw. Anschlie\xdfend k\xf6nnen Sie Schnellaktionen oder Sprachbefehle verwenden, um Formulare noch schneller auszuf\xfcllen."},"complete":{"title":"Gute Arbeit!","description":"Sie wissen jetzt, wie Sie mit Sprachbefehlen und Schnellaktionen navigieren, suchen, scrollen und Formulare ausf\xfcllen, w\xe4hrend Sie im Internet surfen. Entdecken Sie weitere Befehle oder passen Sie Ihre eigenen Schnellaktionen an, um noch fl\xfcssiger im Internet zu surfen."}},"spreadsheetReviews":{"tourLabel":"Schnelleres Arbeiten in Tabellenkalkulationen mit Sprachsteuerung","learn":"Erfahren Sie, wie Sie mithilfe von Sprachbefehlen und Schnellaktionen gro\xdfe Tabellen schnell \xfcberpr\xfcfen und bearbeiten.","tryOpen":{"title":"Sagen Sie \u201EExcel \xf6ffnen\u201C oder \u201EGoogle Tabellen \xf6ffnen\u201C.","description":"Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie \u201EExcel \xf6ffnen\u201C oder \u201EGoogle Tabellen \xf6ffnen\u201C. Dadurch wird die von Ihnen gew\xe4hlte Tabellenkalkulations-App ge\xf6ffnet. Wenn Sie die automatische Steuerungsumschaltung aktiviert haben, wird auch zu den App-Steuerelementen gewechselt, die am besten zu Ihrer verwendeten App passen."},"selectRow":{"title":"W\xe4hlen Sie eine Zeile aus","description":"Klicken Sie auf eine Zelle. Sagen Sie dann \u201EZeile ausw\xe4hlen\u201C. Dadurch wird die gesamte Zeile der fokussierten Zelle ausgew\xe4hlt."},"delete":{"title":"Inhalt einer Zeile l\xf6schen","description":"Sagen Sie \u201EL\xf6schen\u201C. Dadurch wird der Inhalt der ausgew\xe4hlten Zeile gel\xf6scht."},"note":{"title":"Hinzuf\xfcgen einer Notiz zu einer Zelle","description":"Klicken Sie auf eine Zelle. Sagen Sie dann \u201ENotiz hinzuf\xfcgen\u201C. Dadurch k\xf6nnen Sie der fokussierten Zelle eine Notiz hinzuf\xfcgen."},"addNote":{"title":"Geben Sie die Notiz ein","description":"Sagen Sie beispielsweise \u201EGeben Sie diese Zahlen ein, die nicht \xfcbereinstimmen.\u201C. Dadurch wird Ihre Notiz in die Zelle eingegeben."},"currentDate":{"title":"Aktuelles Datum eingeben","description":"Klicken Sie auf eine Zelle. Sagen Sie dann \u201EAktuelles Datum\u201C. Dadurch wird das aktuelle Datum in die fokussierte Zelle eingetragen."},"copy":{"title":"Kopieren einer Zelle","description":"Klicken Sie auf die Zelle, der Sie gerade das aktuelle Datum hinzugef\xfcgt haben. Sagen Sie dann \u201EKopieren\u201C. Dadurch wird das aktuelle Datum kopiert."},"selectColumn":{"title":"W\xe4hlen Sie eine Spalte aus","description":"Sagen Sie beispielsweise \u201ESpalte\u201C. Dadurch wird die gesamte Spalte f\xfcr die fokussierte Zelle ausgew\xe4hlt."},"paste":{"title":"Aktuelles Datum einf\xfcgen","description":"Sagen Sie \u201EEinf\xfcgen\u201C. Dadurch wird das aktuelle Datum in die ausgew\xe4hlte Spalte eingef\xfcgt."},"quickActions":{"title":"Verwenden Sie Schnellaktionen","description":"Viele dieser und weitere Steuerelemente lassen sich auch mit Schnellaktionsschaltfl\xe4chen steuern. Sie k\xf6nnen diese Schaltfl\xe4chen an Ihren Arbeitsablauf anpassen und so die \xdcberpr\xfcfung und Bearbeitung von Tabellenkalkulationen noch schneller gestalten."},"complete":{"description":"Sie wissen nun, wie Sie mithilfe von Sprachbefehlen und Schnellaktionen gro\xdfe Tabellen schnell \xfcberpr\xfcfen und bearbeiten k\xf6nnen. Entdecken Sie weitere Befehle oder passen Sie Ihre eigenen Schnellaktionen an, um die Tabellenverwaltung zu beschleunigen."}},"socialMediaWriting":{"tourLabel":"Erstellen, iterieren und posten Sie Social-Media-Inhalte mit Sprache und On-Device-KI","learn":"Erfahren Sie, wie Sie mit Intelligent Generate and Rewrite \u2013 v\xf6llig privat und auf dem Ger\xe4t \u2013 Inhalte erstellen und iterieren k\xf6nnen.","onDeviceIntro":{"title":"Ihre Forschung bleibt privat und sicher","description":"Die intelligenten Aufgaben von Cephable basieren auf ger\xe4teinterner KI, sodass Ihre Daten vertraulich und sicher bleiben. Sie k\xf6nnen Texte ohne Cloud-Verarbeitung erstellen, umschreiben und \xfcbersetzen. Nutzen Sie au\xdferdem anwendungs\xfcbergreifenden Kontext und entwickeln Sie Ideen direkt in Ihrer bevorzugten App weiter."},"enterPrompt":{"title":"Beginnen Sie mit der Ideenfindung","description":"Geben Sie in das Eingabefeld eine Eingabeaufforderung f\xfcr den Inhalt ein, den Sie erstellen oder generieren m\xf6chten. Sie k\xf6nnen beispielsweise Folgendes eingeben: \u201EListen Sie die Risiken von Agentic AI auf, wo einige L\xfccken liegen und wie Innovationen vorangetrieben werden k\xf6nnen.\u201C"},"customizeSettings":{"title":"Anpassen der Generierungseinstellungen","description":"Sie k\xf6nnen die Generierungseinstellungen an Ihre Pr\xe4ferenzen anpassen. Passen Sie die Einstellungen mit Systemaufforderungen an, die Ton, Markenstimme und mehr widerspiegeln."},"rewriteIntro":{"title":"Inhalt iterieren","description":"Mit Cephable Intelligent Rewrite k\xf6nnen Sie Inhalte direkt in Ihrer bevorzugten App iterieren. Dies geschieht alles auf dem Ger\xe4t, sodass Ihre Daten privat und sicher bleiben."},"highlightText":{"title":"Markieren Sie den Text zum Umschreiben","description":"Markieren Sie eines der aufgelisteten Risiken aus dem generierten Inhalt, das Sie weiter iterieren m\xf6chten."},"enterInstructions":{"title":"Geben Sie die Umschreibanweisungen ein","description":"Geben Sie Ihre Umschreibanweisungen ein. Sie k\xf6nnen beispielsweise Folgendes eingeben: \u201EF\xfcgen Sie weitere Details zu den Risiken hinzu.\u201C"},"writeSocialMediaPost":{"title":"Schreiben Sie einen Social-Media-Beitrag","description":"Verwenden Sie \u201ERewrite\u201C erneut, um diese Sprache in einen \xf6ffentlich zug\xe4nglichen Social-Media-Beitrag umzuformatieren, der die wichtigsten Punkte enth\xe4lt und Bereiche des Engagements hervorhebt."},"highlightPost":{"title":"Markieren Sie den generierten Beitrag","description":"Markieren Sie den generierten Social-Media-Beitrag, den Sie verwenden m\xf6chten."},"enterPostInstructions":{"title":"Postanweisungen eingeben","description":"Geben Sie Ihre Post-Anweisungen ein. Sie k\xf6nnen beispielsweise Folgendes eingeben: \u201EMachen Sie es pr\xe4gnant und ansprechend f\xfcr LinkedIn.\u201C"},"complete":{"description":"Jetzt k\xf6nnen Sie Ihre bevorzugte Social-Media-Plattform \xf6ffnen, auf das Textfeld zur Beitragserstellung klicken und den generierten Beitrag einf\xfcgen. Oder Sie k\xf6nnen weiter iterieren und verfeinern, bis Sie fertig sind!"}},"inboxTriage":{"tourLabel":"Effizientes E-Mail-Management mit Sprache und On-Device-KI","learn":"Erfahren Sie, wie Sie Sprachbefehle und intelligente Aufgaben verwenden, um Ihren Posteingang effizient zu verwalten und gleichzeitig Ihre Daten zu sch\xfctzen.","tryOpen":{"title":"Versuchen Sie, \u201EOutlook \xf6ffnen\u201C oder \u201EGmail \xf6ffnen\u201C zu sagen.","description":"Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie \u201EOutlook \xf6ffnen\u201C oder \u201EGmail \xf6ffnen\u201C. Dadurch wird die gew\xfcnschte E-Mail-App ge\xf6ffnet. Wenn Sie die automatische Steuerungsumschaltung aktiviert haben, wird auch zu den App-Steuerelementen gewechselt, die am besten zu Ihrer verwendeten App passen."},"select":{"title":"W\xe4hlen Sie eine E-Mail","description":"Klicken Sie auf eine E-Mail. Sagen Sie dann \u201EE-Mail ausw\xe4hlen\u201C. Dadurch wird die fokussierte E-Mail ausgew\xe4hlt."},"delete":{"title":"L\xf6schen einer E-Mail","description":"Sagen Sie \u201EL\xf6schen\u201C. Dadurch wird die ausgew\xe4hlte E-Mail gel\xf6scht."},"reply":{"title":"Auf eine E-Mail antworten","description":"Klicken Sie auf eine E-Mail. Sagen Sie anschlie\xdfend \u201EAntworten\u201C. Dadurch wird das Antwortfenster f\xfcr die fokussierte E-Mail ge\xf6ffnet."},"dictateIntro":{"title":"Diktieren Sie Ihre Antwort","description":"Sie k\xf6nnen Ihre Antwort per Diktierfunktion freih\xe4ndig eingeben. Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet und der Diktiermodus aktiviert ist."},"dictateReply":{"title":"Beginnen Sie mit der Antwort","description":"Schreiben Sie beispielsweise: \u201EIch m\xf6chte mehr \xfcber Ihre Dienstleistungen erfahren. Bitte senden Sie mir weitere Informationen.\u201C So schreiben Sie Ihre Antwort in die E-Mail. Konzentrieren Sie sich auf das Antwortfeld."},"newEmail":{"title":"Erstellen einer neuen E-Mail","description":"Sagen Sie \u201ENeue E-Mail\u201C. Dadurch wird ein neues Fenster zum Verfassen einer E-Mail ge\xf6ffnet."},"customEmailTemplates":{"title":"Benutzerdefinierte E-Mail-Vorlagen","description":"Sie k\xf6nnen benutzerdefinierte E-Mail-Vorlagen f\xfcr h\xe4ufige Antworten erstellen. So k\xf6nnen Sie mithilfe von Sprachbefehlen oder Schnellaktionen schnell vorgefertigte Inhalte in Ihre E-Mails einf\xfcgen."},"editAppControls":{"title":"App-Steuerelemente bearbeiten","description":"Um eine benutzerdefinierte E-Mail-Vorlage zu erstellen, klicken Sie auf die Schaltfl\xe4che \u201EApp-Steuerelemente bearbeiten\u201C."},"addNewControl":{"title":"Neues Steuerelement hinzuf\xfcgen","description":"Klicken Sie im App-Steuerelement-Editor auf die Schaltfl\xe4che \u201ENeues Steuerelement hinzuf\xfcgen\u201C."},"quickAction":{"title":"Schnellaktion ausw\xe4hlen","description":"W\xe4hlen Sie als Steuerungstyp \u201ESchnellaktion\u201C."},"templateName":{"title":"Benennen Sie Ihre Vorlage","description":"Geben Sie Ihrer benutzerdefinierten E-Mail-Vorlage einen Namen, beispielsweise \u201EBesprechungsanfrage\u201C."},"eventType":{"title":"Ereignistyp ausw\xe4hlen","description":"W\xe4hlen Sie im Abschnitt \u201EEreignistyp\u201C den Ereignistyp \u201ETyp\u201C aus."},"typeSteps":{"title":"Typvorlageninhalt","description":"Geben Sie den Inhalt Ihrer E-Mail-Vorlage ein. Beispiel: \u201ELead Outreach\\nHallo, ich m\xf6chte ein Treffen vereinbaren, um m\xf6gliche Kooperationsm\xf6glichkeiten zu besprechen. Bitte teilen Sie mir Ihre Verf\xfcgbarkeit mit.\u201C"},"finish":{"title":"Erstellen der Vorlage abschlie\xdfen","description":"Klicken Sie auf die Schaltfl\xe4che \u201EFertig stellen\u201C, um die Erstellung Ihrer benutzerdefinierten E-Mail-Vorlage abzuschlie\xdfen."},"saveTemplate":{"title":"Speichern Sie Ihre Vorlage","description":"Klicken Sie auf die Schaltfl\xe4che \u201ESpeichern\u201C, um Ihre benutzerdefinierte E-Mail-Vorlage zu speichern."},"focusApp":{"title":"Konzentrieren Sie sich wieder auf Ihre E-Mail-App","description":"Gehen Sie zur\xfcck zu Ihrer E-Mail-App und achten Sie darauf, dass Sie sich auf die Betreffzeile der neuen E-Mail konzentrieren."},"useTemplate":{"title":"Verwenden Sie Ihre Vorlage","description":"Jetzt k\xf6nnen Sie Ihre benutzerdefinierte E-Mail-Vorlage verwenden, indem Sie ihren Namen sagen oder auf die Schaltfl\xe4che \u201ESchnellaktion\u201C klicken."},"generateIntro":{"title":"E-Mail-Inhalte generieren","description":"Sie k\xf6nnen Cephable Intelligent Generate auch verwenden, um E-Mail-Inhalte direkt in Ihrer E-Mail-App zu erstellen. Dies geschieht alles auf Ihrem Ger\xe4t, sodass Ihre Daten privat und sicher bleiben."},"enterPrompt":{"title":"E-Mail-Eingabeaufforderung","description":"Geben Sie in das Eingabefeld Folgendes ein: Schreiben Sie eine professionelle E-Mail an einen potenziellen Kunden, in der Sie unsere Dienste vorstellen und um ein Treffen bitten."},"focusNewEmail":{"title":"Konzentrieren Sie sich auf die neue E-Mail","description":"Stellen Sie sicher, dass Sie sich auf das neue E-Mail-Erstellungsfenster konzentrieren, in dem der generierte Text angezeigt werden soll."},"translateEmail":{"title":"E-Mail-Inhalte \xfcbersetzen","description":"Mit Cephable Intelligent Translate k\xf6nnen Sie E-Mail-Inhalte direkt in Ihrer E-Mail-App \xfcbersetzen. Dies geschieht direkt auf Ihrem Ger\xe4t, sodass Ihre Daten vertraulich und sicher bleiben."},"highlightText":{"title":"E-Mail-Inhalte hervorheben","description":"Markieren Sie den Inhalt einer langen E-Mail, die Sie \xfcbersetzen m\xf6chten."},"enterLanguage":{"title":"Geben Sie die \xdcbersetzungssprache ein","description":"Geben Sie Ihre \xdcbersetzungssprache ein. Sie k\xf6nnen beispielsweise \u201ESpanisch\u201C eingeben."},"complete":{"description":"Sie wissen jetzt, wie Sie mit Sprachbefehlen und intelligenten Aufgaben E-Mails navigieren, beantworten, diktieren, erstellen und \xfcbersetzen und gleichzeitig Ihre Daten sch\xfctzen. Entdecken Sie weitere Befehle oder passen Sie Ihre eigenen Schnellaktionen an, um Ihre E-Mails noch einfacher zu verwalten."}},"handsFreeMeeting":{"tourLabel":"Schnelle, freih\xe4ndige Meeting-Steuerung","learn":"Sparen Sie Zeit und reduzieren Sie die Erm\xfcdung bei virtuellen Meetings mit schnellen, freih\xe4ndigen Meeting-Steuerelementen","tryOpen":{"title":"Versuchen Sie, \u201EZoom \xf6ffnen\u201C oder \u201ETeams \xf6ffnen\u201C zu sagen.","description":"Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie \u201EZoom \xf6ffnen\u201C oder \u201ETeams \xf6ffnen\u201C. Dadurch wird die von Ihnen gew\xe4hlte Meeting-App ge\xf6ffnet. Wenn Sie die automatische Steuerungsumschaltung aktiviert haben, wird auch zu den App-Steuerelementen gewechselt, die am besten zu Ihrer verwendeten App passen."},"mute":{"title":"Sagen Sie \u201EStummschalten\u201C, um Ihr Mikrofon stummzuschalten.","description":"Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie \u201EStummschalten\u201C. Dadurch wird Ihr Mikrofon in der ausgew\xe4hlten Meeting-App stummgeschaltet."},"video":{"title":"Sagen Sie \u201EVideo umschalten\u201C, um Ihre Kamera ein- oder auszuschalten","description":"Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie \u201EVideo umschalten\u201C. Dadurch wird Ihre Kamera in der ausgew\xe4hlten Meeting-App ein- oder ausgeschaltet."},"raiseHand":{"title":"Versuchen Sie, \u201EHand heben\u201C zu sagen, um Ihre Hand zu heben","description":"Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie \u201EHand heben\u201C. Dadurch wird Ihre Hand in der von Ihnen gew\xe4hlten Meeting-App gehoben."},"quickType":{"title":"Schnelles Tippen","description":"Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie \u201EDas ist eine coole Funktion\u201C. So k\xf6nnen Sie schnell mit Ihrer Stimme tippen, ohne im Diktiermodus zu sein. Stellen Sie sicher, dass Sie in Ihrer Meeting-App auf ein Textfeld fokussiert sind."},"complete":{"description":"Sie wissen jetzt, wie Sie Sprachbefehle und Schnellaktionen verwenden, um in Ihren bevorzugten Meeting-Apps stummzuschalten/die Stummschaltung aufzuheben, das Video ein-/auszuschalten, die Hand zu heben und schnell zu tippen. Probieren Sie weitere Befehle aus oder passen Sie Ihre eigenen Schnellaktionen an, um die Meeting-Steuerung noch reibungsloser zu gestalten."}},"summarizingReports":{"tourLabel":"Berichte und Dokumente mit On-Device-KI zusammenfassen","learn":"Erfahren Sie, wie Sie mithilfe der KI-gest\xfctzten Zusammenfassung schnell die wichtigsten Punkte aus langen Berichten und Dokumenten herausfiltern und gleichzeitig Ihre vertraulichen und gesch\xfctzten Daten sch\xfctzen.","summarizeIntro":{"title":"Text zusammenfassen","description":"Mit Cephable Intelligent Tasks k\xf6nnen Sie schnell die wichtigsten Punkte aus langen Berichten und Dokumenten erfassen. Summarize ist Teil der On-Device AI Tasks, d. h. es funktioniert ohne Internetverbindung und wird von Ihrem Ger\xe4t aus ausgef\xfchrt."},"navigateToReport":{"title":"Konzentrieren Sie sich auf Ihren Bericht oder Ihr Dokument","description":"\xd6ffnen Sie Ihren Bericht oder Ihr Dokument in Ihrer bevorzugten App und konzentrieren Sie sich auf den Text, den Sie zusammenfassen m\xf6chten."},"highlightText":{"title":"Markieren Sie Text zum Zusammenfassen","description":"Markieren Sie den Text, den Sie zusammenfassen m\xf6chten."},"copyText":{"title":"Kopieren Sie den Text","description":"Nachdem Sie Ihren Text markiert haben, kopieren Sie ihn, um ihn f\xfcr die Zusammenfassung vorzubereiten."},"enterPrompt":{"title":"Zusammenfassungsanweisungen eingeben","description":"Geben Sie Ihre Zusammenfassungsanweisungen ein. Geben Sie die L\xe4nge, den Stil oder den gew\xfcnschten Inhalt an."},"pasteText":{"title":"F\xfcgen Sie Ihren Berichtsinhalt ein","description":"F\xfcgen Sie nach den Anweisungen den kopierten Text in das Eingabefeld ein."},"focusChatApp":{"title":"Konzentrieren Sie sich auf Ihre Chat-App","description":"\xd6ffnen Sie Ihre Chat-App wie Teams oder Slack und konzentrieren Sie sich auf das Textfeld, in dem der zusammengefasste Text angezeigt werden soll."},"rewriteIntro":{"title":"Zusammengefassten Text neu schreiben","description":"Sie k\xf6nnen den zusammengefassten Text auch mit Cephable Intelligent Rewrite weiter verfeinern. Dies geschieht alles auf dem Ger\xe4t, sodass Ihre Daten privat und sicher bleiben."},"highlightSummary":{"title":"Markieren Sie den zusammengefassten Text","description":"Markieren Sie den zusammengefassten Text, den Sie weiter verfeinern m\xf6chten."},"enterRewriteInstructions":{"title":"Geben Sie die Umschreibanweisungen ein","description":"Geben Sie Ihre Anweisungen zum Umschreiben ein. Geben Sie den Ton, den Stil oder alle gew\xfcnschten \xc4nderungen an."},"complete":{"description":"Sie haben gelernt, wie Sie mit Intelligent Tasks schnell und sicher Text zusammenfassen und Ergebnisse mit Ihrem Team teilen. Entdecken Sie weitere Anwendungsf\xe4lle mit \u201EZusammenfassen und Umschreiben\u201C oder anderen Funktionen zur Optimierung Ihres Workflows."}},"congrats":"Gl\xfcckwunsch!","noteTakingAndDocumentation":{"tourLabel":"Notizen machen und Dokumente erstellen mit privater KI auf dem Ger\xe4t","learn":"Erfahren Sie, wie Sie mithilfe von Sprachbefehlen, intelligenter Diktierfunktion und KI-Aufgaben schneller von Notizen zu Entw\xfcrfen und Dokumenten gelangen.","focus":{"title":"Fokussieren Sie auf ein Textfeld oder Dokument","description":"Das Diktieren funktioniert am besten, wenn Sie sich auf ein Textfeld oder Dokument konzentrieren. \xd6ffnen Sie ein Dokument oder klicken Sie auf ein Textfeld, in dem Sie Notizen machen m\xf6chten."},"speaking":{"title":"Beginnen Sie zu sprechen","description":"Jetzt k\xf6nnen Sie loslegen. Sprechen Sie ganz nat\xfcrlich und lassen Sie Ihren Gedanken freien Lauf, w\xe4hrend Sie \xfcber Ihre Idee nachdenken. Alles, was Sie sagen, wird in das Textfeld oder Dokument eingegeben, auf das Sie sich konzentriert haben. Beschreiben Sie Ihr Konzept, skizzieren Sie die Schritte oder f\xfchren Sie ein freies Brainstorming durch. Sagen Sie zum Beispiel: \u201EIch denke \xfcber einen neuen Workflow f\xfcr unser Team nach. Zuerst sollten wir den Berichtsprozess automatisieren und dann die Ergebnisse w\xf6chentlich \xfcberpr\xfcfen.\u201C Achten Sie darauf, dass der Cursor auf dem Dokument steht."},"typeEnter":{"title":"Absatzumbr\xfcche","description":"Um Absatzumbr\xfcche einzuf\xfcgen, dr\xfccken Sie einfach die Eingabetaste. So k\xf6nnen Sie Ihre Notizen in \xfcbersichtliche Abschnitte gliedern. Sprechen Sie Ihre Gedanken weiter oder schreiben Sie die Aussagen anderer ab."},"rewriteIntro":{"title":"Designs erstellen","description":"Jetzt k\xf6nnen Sie Cephable Intelligent Rewrite verwenden, um Ihre Notizen in eine Funktionsidee oder Folgema\xdfnahmen umzusetzen. Dies geschieht alles auf dem Ger\xe4t, sodass Ihre Daten privat und sicher bleiben."},"highlightText":{"title":"Markieren Sie die Notizen","description":"W\xe4hlen Sie alle Notizen aus, die Sie zum Erstellen eines Designs oder Dokuments verwenden m\xf6chten."},"inPlaceReplacement":{"title":"Ideenfindung vor Ort","description":"Jetzt verwenden wir die direkte Ersetzung, um Ihre Notizen in ein Design oder Dokument umzuwandeln. Sie k\xf6nnen stattdessen jederzeit den Einf\xfcgemodus oder die Option zum Erstellen einer neuen Datei verwenden."},"enterInstructions":{"title":"Designanweisungen eingeben","description":"Sie k\xf6nnen Ihre n\xe4chsten Schritte beschreiben und beschreiben, was Sie mit den Notizen tun m\xf6chten. Dies kann Formatierung, Design, Folgeaufgaben oder etwas anderes sein. (Beispiel: Erstellen Sie ein Designdokument, in dem Sie die Funktionsweise der Funktion, den End-to-End-Umgang und m\xf6gliche Erfolgsaussichten hervorheben.)"},"complete":{"description":"Sie haben gelernt, wie Sie Sprachbefehle und intelligente Diktierfunktion nutzen, um klinische Notizen zu dokumentieren, und wie Sie diese mit Intelligent Rewrite im SOAP-Stil formatieren. Entdecken Sie weitere Anwendungsf\xe4lle mit Diktierfunktion und Rewrite sowie weitere Funktionen zur Optimierung Ihres Workflows."}},"fpsGamePlay":{"tourLabel":"Spielen Sie FPS-Spiele mit Sprachsteuerung","learn":"Erfahren Sie, wie Sie Sprachsteuerung und Schnellaktionen zum Spielen von FPS-Spielen verwenden.","changeProfile":{"title":"\xc4nderungskontrollprofil","description":"\xc4ndern Sie Ihre App-Steuerung auf das FPS-Spielprofil. Sie k\xf6nnen dies auch f\xfcr das jeweilige Spiel anpassen, das Sie spielen m\xf6chten. Siehe das Video."},"autoProfileSwitching":{"title":"Automatische Steuerungsumschaltung deaktivieren","description":"Dadurch bleibt Ihre aktuelle App-Steuerung aktiv, bis Sie die App wechseln."},"tryOpen":{"title":"Versuchen Sie, \u201E\xd6ffne Valorant\u201C oder \u201E\xd6ffne Battlefield\u201C zu sagen."},"go":{"title":"Versuchen Sie, \u201ELos\u201C zu sagen.","description":"Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie \u201ELos\u201C. Dadurch bewegt sich Ihre Figur vorw\xe4rts."},"stop":{"title":"Versuchen Sie, \u201EStopp\u201C zu sagen.","description":"Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie \u201EStopp\u201C. Dadurch wird die Bewegung Ihrer Figur gestoppt."},"complete":{"description":"Sie wissen jetzt, wie Sie Sprachbefehle und Schnellaktionen verwenden, um Ihren Charakter in FPS-Spielen zu bewegen, anzuhalten und zu steuern. Entdecken Sie weitere Befehle oder passen Sie Ihre eigenen Schnellaktionen an, um ein noch fl\xfcssigeres und schnelleres Gameplay zu erzielen."}},"presentationControls":{"tourLabel":"Pr\xe4sentationen mit Sprachbefehlen steuern","learn":"Erfahren Sie, wie Sie mithilfe von Sprachbefehlen und Schnellaktionen freih\xe4ndig durch Ihre Pr\xe4sentationen navigieren und sie steuern k\xf6nnen.","tryOpen":{"title":"Versuchen Sie, \u201EPowerPoint \xf6ffnen\u201C oder \u201EGoogle Slides \xf6ffnen\u201C zu sagen."},"startPresentation":{"title":"Sagen Sie \u201EPr\xe4sentation starten\u201C, um Ihre Diashow zu starten.","description":"Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie \u201EPr\xe4sentation starten\u201C. Dadurch wird Ihre Diashow in der von Ihnen gew\xe4hlten Pr\xe4sentations-App gestartet."},"nextSlide":{"title":"Sagen Sie \u201EN\xe4chste Folie\u201C, um zur n\xe4chsten Folie zu wechseln","description":"Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie \u201EN\xe4chste Folie\u201C. Dadurch wird zur n\xe4chsten Folie in Ihrer Diashow gewechselt."},"previousSlide":{"title":"Sagen Sie \u201EVorherige Folie\u201C, um zur vorherigen Folie zur\xfcckzukehren.","description":"Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie \u201EVorherige Folie\u201C. Dadurch gelangen Sie zur\xfcck zur vorherigen Folie in Ihrer Diashow."},"escape":{"title":"Versuchen Sie, \u201EEscape\u201C zu sagen, um den Pr\xe4sentationsmodus zu verlassen","description":"Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie \u201EEscape\u201C. Dadurch wird der Pr\xe4sentationsmodus in der ausgew\xe4hlten Pr\xe4sentations-App beendet."},"complete":{"description":"Sie wissen jetzt, wie Sie mit Sprachbefehlen und Schnellaktionen Pr\xe4sentationen freih\xe4ndig starten, navigieren und beenden. Entdecken Sie weitere Befehle oder passen Sie Ihre eigenen Schnellaktionen an, um die Pr\xe4sentationssteuerung noch reibungsloser zu gestalten."}},"editingImages":{"tourLabel":"Schnellere Bildbearbeitung mit Sprachsteuerung und Diktierfunktion","learn":"Erfahren Sie, wie Sie Sprachbefehle, Schnellaktionen und Diktate verwenden, um Ihren Bildbearbeitungsprozess zu verbessern.","tryOpen":{"title":"Versuchen Sie, \u201EOpen Figma\u201C oder \u201EOpen Photoshop\u201C zu sagen."},"selectAll":{"title":"Sagen Sie \u201EAlles ausw\xe4hlen\u201C, um alle Elemente auf der Leinwand auszuw\xe4hlen","description":"Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie \u201EAlles ausw\xe4hlen\u201C. Dadurch werden alle Elemente auf der Leinwand in der gew\xe4hlten Bildbearbeitungs-App ausgew\xe4hlt. Konzentrieren Sie sich auf die App."},"bold":{"title":"Sagen Sie \u201EFett\u201C, um den ausgew\xe4hlten Text fett darzustellen.","description":"Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie \u201EFett\u201C. Dadurch wird der ausgew\xe4hlte Text in der ausgew\xe4hlten Bildbearbeitungs-App fett dargestellt. Stellen Sie sicher, dass Sie Text ausgew\xe4hlt haben."},"copy":{"title":"Sagen Sie \u201EKopieren\u201C, um das ausgew\xe4hlte Element zu kopieren","description":"Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie \u201EKopieren\u201C. Dadurch wird das ausgew\xe4hlte Element in die ausgew\xe4hlte Bildbearbeitungs-App kopiert. Stellen Sie sicher, dass Sie ein Element ausgew\xe4hlt haben."},"paste":{"title":"Sagen Sie \u201EEinf\xfcgen\u201C, um das kopierte Element einzuf\xfcgen","description":"Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie \u201EEinf\xfcgen\u201C. Dadurch wird das kopierte Element in die von Ihnen gew\xe4hlte Bildbearbeitungs-App eingef\xfcgt."},"delete":{"title":"Sagen Sie \u201EL\xf6schen\u201C, um das ausgew\xe4hlte Element zu l\xf6schen","description":"Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie \u201EL\xf6schen\u201C. Dadurch wird das ausgew\xe4hlte Element in der gew\xe4hlten Bildbearbeitungs-App gel\xf6scht. Stellen Sie sicher, dass Sie ein Element ausgew\xe4hlt haben."},"dictationIntro":{"title":"Diktat","description":"Sie k\xf6nnen die Diktierfunktion verwenden, um Text per Spracheingabe einzugeben. Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet und der Diktiermodus aktiviert ist."},"focus":{"title":"Fokus auf ein Textfeld","description":"Klicken Sie in Ihrer Bildbearbeitungs-App auf ein Textfeld, in dem Sie die Diktierfunktion verwenden m\xf6chten."},"speaking":{"title":"Beginnen Sie zu sprechen","description":"Sagen Sie beispielsweise: \u201EScannen Sie den QR-Code, um fr\xfchzeitig Rabattcodes zu erhalten. Dieser ist bis zum 30. September g\xfcltig. Bewerben Sie sich anschlie\xdfend \xfcber die Website.\u201C Konzentrieren Sie sich dabei auf das Textfeld oder den Bereich, in dem Sie diktieren m\xf6chten."},"complete":{"description":"Sie wissen nun, wie Sie Sprachbefehle, Schnellaktionen und Diktate nutzen k\xf6nnen, um Ihre Bildbearbeitung zu verbessern. Entdecken Sie weitere Befehle oder passen Sie Ihre eigenen Schnellaktionen an, um die Bildbearbeitung noch reibungsloser zu gestalten."}},"redo":"Onboarding wiederholen","title":"Lernen Sie Cephable kennen","description":"Lernen Sie Cephable kennen, Ihren pers\xf6nlichen KI-Assistenten, und teilen Sie Ihr Interesse an personalisierten Anwendungsf\xe4llen.","panel":{"description":"Dies ist das Bedienfeld, die zentrale Steuerungseinheit. Sie ist immer sichtbar und erm\xf6glicht die Steuerung Ihrer Apps per Sprachbefehl und vieles mehr. Beginnen wir mit dem Mikrofon."}}');


var $9334e2246d11ce3e$exports = {};
$9334e2246d11ce3e$exports = JSON.parse('{"introduction":{"title":"Hallo, ich bin Cephable.","back":"Zur\xfcck zur Einleitung","description":"Ich bin Ihre pers\xf6nliche KI, die Ihnen hilft, Ihre gewohnten Tools zu steuern, zu erstellen und zu automatisieren \u2013 \xfcber alle Ihre Verbindungen hinweg. Es gibt ein paar Dinge, die Sie \xfcber mich wissen sollten.","action":"Lass uns anfangen!","recording":{"title":"Ihre Stimme und Ihr Video bleiben lokal.","description":"Ich nehme Ihre Audio- oder Videodaten niemals auf, streame sie nicht und sende sie auch nicht in die Cloud. Alle Eingaben werden auf dem Ger\xe4t verarbeitet \u2013 privat und sicher."},"data":{"title":"Ihre Daten geh\xf6ren Ihnen.","description":"Ich verwende Ihre Befehle oder Aktivit\xe4ten nicht, um Modelle f\xfcr andere zu trainieren. Alles bleibt privat \u2013 und Ihre App-Steuerelemente bleiben \xfcber alle Verbindungen hinweg mit Ihnen verbunden."},"offline":{"title":"Ich arbeite, wenn andere Tools nicht funktionieren.","description":"Intelligente Aufgaben wie das Erstellen von Inhalten, Umschreiben, \xdcbersetzen und Diktieren werden lokal ausgef\xfchrt. Keine Cloud erforderlich. Das bedeutet, ich arbeite auch, wenn Sie offline sind \u2013 und Ihre Daten verlassen Ihr Ger\xe4t nicht."},"empower":{"title":"Entwickelt, um zu st\xe4rken, nicht auszubeuten.","description":"Ich bin darauf ausgelegt, Ihre Kontrolle zu verbessern \u2013 nicht sie zu \xfcberwachen. Kein invasives Tracking. Keine gruselige Datenerfassung. Nur Eingaben, die f\xfcr Sie funktionieren."}},"my-capabilities":{"title":"Perfekt! So kann ich helfen.","back":"Zur\xfcck zu den Funktionen","actionTitle":"Sehen Sie mich in Aktion","description":"Basierend auf Ihren Interessen finden Sie hier die Funktionen und F\xe4higkeiten, die f\xfcr Ihren Arbeitsablauf am relevantesten sind.","action":{"title":"Sehen Sie mich in Aktion","description":"Entdecken Sie einige Beispiele, wie ich Sie bei Ihren t\xe4glichen Aufgaben unterst\xfctzen kann."}},"see-me":{"title":"M\xf6chten Sie sehen, wie ich anderen wie Ihnen geholfen habe?","back":"Zur\xfcck zu den Anwendungsf\xe4llen","description":"Sehen Sie sich einige Beispiele aus der Praxis an, wie ich Arbeitsabl\xe4ufe in verschiedenen Branchen und Rollen ver\xe4ndert habe."},"complete":{"title":"Bereit, mich zu verwenden?","description":"Sie haben gesehen, was ich kann! Jetzt richten wir alles ein und beginnen mit der Umgestaltung Ihres Workflows. Ich stehe Ihnen bei jedem Schritt zur Seite.","action":"Schlie\xdfen Sie die Einrichtung ab und beginnen Sie mit der Verwendung von Cephable"},"apps":{"title":"Ich unterst\xfctze die Tools, die Sie bereits lieben","description":"Mit vorkonfiguriertem Support f\xfcr \xfcber 200 Anwendungen \u2013 ich arbeite mit der Software, die Sie t\xe4glich verwenden. Keine Einrichtung erforderlich.","note":"Sie finden eine App, die Sie verwenden, nicht? Kein Problem \u2013 ich kann Steuerelemente generieren oder Ihnen beim Erstellen benutzerdefinierter Workflows helfen, die f\xfcr Sie funktionieren.","andMore":"Und mehr"},"actions":{"ctaTry":"Jetzt testen","ctaWatch":"Demo ansehen","apps":"Ich bin kompatibel mit:","abilities":"Meine eingesetzten F\xe4higkeiten:"},"interests":{"title":"Wie kann ich Ihnen helfen?","back":"Zur\xfcck zu Interessen","description":"Ich kann Apps auf Ihrem Desktop und verbundenen Ger\xe4ten steuern. Lassen Sie uns Ihr Erlebnis personalisieren \u2013 welche Bereiche interessieren Sie am meisten?","note":"W\xe4hlen Sie alle zutreffenden Optionen aus und ich zeige Ihnen die relevantesten Funktionen und Beispiele f\xfcr Ihren Arbeitsablauf.","action":"Weiter mit {{count}} Interessen","empty":"W\xe4hlen Sie mindestens ein Interesse aus.","create_design":{"label":"Erstellen und Gestalten","shortLabel":"Design","description":"F\xfcr K\xfcnstler, Vermarkter und Content-Ersteller."},"analyze_report":{"label":"Analyse und Berichterstellung","shortLabel":"Analysieren","description":"F\xfcr Analysten, Forscher und Gesch\xe4ftsleute."},"communicate_collaborate":{"label":"Kommunizieren und zusammenarbeiten","shortLabel":"Kommunizieren","description":"F\xfcr Verk\xe4ufer, Meetings und Remote-Teams."},"build_develop":{"label":"Bauen und Entwickeln","shortLabel":"Entwickeln","description":"F\xfcr Entwickler, Ingenieure und technische Fachkr\xe4fte."},"game_play":{"label":"Spiel & Spa\xdf","shortLabel":"Spiele","description":"F\xfcr Gamer, Streamer und Mediensteuerungen."},"learn_teach":{"label":"Lernen & Lehren","shortLabel":"Lernen","description":"F\xfcr P\xe4dagogen, Sch\xfcler und den Unterricht."},"manage_organize":{"label":"Verwalten und Organisieren","shortLabel":"Organisieren","description":"F\xfcr Projektmanager, Koordinatoren und Organisatoren."},"adapt_access":{"label":"Anpassen und zugreifen","shortLabel":"Zug\xe4nglichkeit","description":"F\xfcr adaptive Steuerungen und personalisierte Zug\xe4nglichkeitsanforderungen."},"everything":{"label":"Von allem ein bisschen","shortLabel":"Alles","description":"F\xfcr allgemeine Computerbenutzer und Multitasker."},"filter":"Filtern nach Interessentyp"},"capabilities":{"title":"Meine wichtigsten KI-F\xe4higkeiten","description":"Ich kombiniere fortschrittliche KI mit leistungsstarken Eingabemethoden, um Ihnen nahtlose Kontrolle \xfcber Ihre Apps und Ger\xe4te zu erm\xf6glichen. Hier sind einige meiner M\xf6glichkeiten.","voice_controls":{"title":"Sprachsteuerung","description":"Ich verstehe nat\xfcrliche Sprachbefehle, sodass Sie jede App mit Ihrer Stimme steuern k\xf6nnen.","longDescription":"Ich lasse Sie nat\xfcrlich sprechen und trotzdem Dinge erledigen. Egal, ob Sie Apps \xf6ffnen, durch Men\xfcs navigieren oder Workflows ausl\xf6sen m\xf6chten, ich \xfcbersetze einfaches Englisch in freih\xe4ndige und zuverl\xe4ssige Aktionen."},"smart_dictation":{"title":"Intelligentes Diktieren","description":"Ich wandle Ihre Rede kontextbezogen und formatiert in Text um.","longDescription":"Ich h\xf6re Ihnen aufmerksam zu und erfasse Ihre Worte pr\xe4zise. Ich f\xfcge Satzzeichen hinzu, korrigiere Gro\xdf- und Kleinschreibung und passe mich Ihrem Stil an, damit Ihr Text ohne zus\xe4tzlichen Aufwand professionell aussieht."},"ai_text_generation":{"title":"KI-Textgenerierung","description":"Ich kann im Handumdrehen E-Mails, Dokumente, Code und kreative Inhalte erstellen.","longDescription":"Ich helfe Ihnen beim Entwerfen, Zusammenfassen und Erweitern von Inhalten direkt in Ihren Apps. Von E-Mails und Notizen bis hin zu Codeausschnitten und Dokumenten \u2013 ich stelle sicher, dass Sie nie bei Null anfangen."},"head_face_controls":{"title":"Kopf- und Gesichtskontrolle","description":"Ich lasse Sie Aktionen mit Ihren Kopf- und Gesichtsbewegungen ausl\xf6sen.","longDescription":"Ich setze Ihre nat\xfcrlichen Kopfbewegungen und Mimik in pr\xe4zise Eingaben um. Sie k\xf6nnen mit einem L\xe4cheln eine E-Mail senden, mit einem Nicken eine Seite umbl\xe4ttern oder mit einem Hochziehen der Augenbrauen klicken."},"natural_language_voice_clicking":{"title":"Klicken mit nat\xfcrlicher Sprache","description":"Ich \xfcberlasse es Ihnen, zu sagen, was Sie sehen, um auf Schaltfl\xe4chen, Links und Men\xfcs auf dem Bildschirm zu klicken.","longDescription":"Wenn Sie den Namen eines Objekts auf Ihrem Bildschirm aussprechen, finde ich es und interagiere f\xfcr Sie damit. Keine auswendig gelernten Befehle \u2013 beschreiben Sie einfach, was Sie m\xf6chten, und ich k\xfcmmere mich um den Klick."},"keyboard_mouse_emulation":{"title":"Tastatur- und Mausemulation","description":"Ich emuliere Tasten, Klicks und Scrollen, sodass Sie Apps ohne Hardware steuern k\xf6nnen.","longDescription":"Ich sende Tastenanschl\xe4ge, Mausbewegungen, Klicks und Scroll-Ereignisse an die gew\xfcnschte Stelle. Kombinieren Sie mich mit Sprach- oder Kopfsteuerung, um herk\xf6mmliche Eingabeger\xe4te vollst\xe4ndig zu ersetzen oder zu verbessern."},"profiles_personalization":{"title":"Personalisierung","description":"Ich merke mir Ihre Pr\xe4ferenzen und passe sie an gespeicherte App-Steuerelemente an.","longDescription":"Ich behalte Ihre bevorzugten Apps, Befehle und Einstellungen im Auge. Wechseln Sie automatisch oder manuell zwischen den App-Steuerelementen. Ich zeige Ihnen immer die richtigen Steuerelemente f\xfcr Ihre aktuelle T\xe4tigkeit."},"cross_device_connectivity":{"title":"Ger\xe4te\xfcbergreifende Konnektivit\xe4t","description":"Ich lasse Sie Ihren Computer mit Ihrem Telefon steuern.","longDescription":"Ich verbinde Ihr Mobilger\xe4t mit Ihrem Desktop, damit Sie problemlos Befehle ausf\xfchren, diktieren oder navigieren k\xf6nnen. Perfekt f\xfcr Pr\xe4sentationen, Remote-Sitzungen oder den gelegentlichen Gebrauch."},"quick_action_buttons":{"title":"Schnellaktionsschaltfl\xe4chen","description":"Ich gebe Ihnen App-f\xe4hige Schaltfl\xe4chen f\xfcr schnelle Aktionen.","longDescription":"Ich zeige kontextsensitive Schaltfl\xe4chen an, die sich an Ihre App anpassen. Egal, ob Sie an einem Meeting teilnehmen, eine Nachricht senden oder eine neue E-Mail erstellen m\xf6chten \u2013 komplexe Aufgaben sind mit nur einem Klick erledigt."},"ai_app_awareness":{"title":"KI-App-Bewusstsein","description":"Ich passe meine Steuerung an die von Ihnen verwendete App an.","longDescription":"Ich achte darauf, was auf Ihrem Bildschirm aktiv ist, damit ich Ihnen die richtigen Steuerelemente zum richtigen Zeitpunkt zur Verf\xfcgung stellen kann. Kein Durcheinander, kein R\xe4tselraten \u2013 genau das, was Sie brauchen, wenn Sie es brauchen. Alles auf Ihrem Ger\xe4t und ohne Daten in die Cloud zu senden."},"ai_rewrite":{"title":"KI-Neufassung","description":"Ich kann Ihren Text umschreiben, um den Ton zu verbessern, die Formatierung zu aktualisieren oder Details zu erweitern.","longDescription":"Ich bearbeite Texte direkt bei Ihnen. Ich kann sie freundlicher, formeller, k\xfcrzer, l\xe4nger oder detaillierter gestalten \u2013 ganz wie Sie es brauchen, um Ihre Botschaft besser r\xfcberzubringen."},"ai_translation":{"title":"KI-\xdcbersetzung","description":"Ich kann zwischen Sprachen oder sogar Programmiersprachen \xfcbersetzen.","longDescription":"Ich erm\xf6gliche Ihnen, Text in eine andere gesprochene Sprache umzuwandeln oder Code in eine andere Programmiersprache zu konvertieren. Ich arbeite vor Ort, sodass Sie die App, die Sie gerade verwenden, nicht verlassen m\xfcssen."},"head_mouse":{"title":"Kopfmaus","description":"Ich lasse Sie Ihren Mauszeiger mit Kopfbewegungen bewegen.","longDescription":"Ich setze Ihre Kopfbewegungen sanft in Cursorbewegungen um. Mit Funktionen wie Gleiten und Empfindlichkeitseinstellung erm\xf6gliche ich Ihnen eine pr\xe4zise, komfortable und freih\xe4ndige Steuerung."},"head_joystick":{"title":"Head Joystick","description":"Ich lasse Sie Ihren Kopf als Joystick f\xfcr Spiele oder Apps verwenden.","longDescription":"Ich bilde Ihre Kopfbewegungen auf Joystick-Achsen ab, damit Sie Spiele spielen oder kreative Software ohne Hardware steuern k\xf6nnen. Sie bewegen sich nat\xfcrlich und ich \xfcbersetze sie in analoge Eingaben."},"mcp_agent":{"title":"MCP-Agent","description":"Ich kann \xfcber das Model Context Protocol (MCP) eine Verbindung mit externen KI-Agenten herstellen.","longDescription":"Ich spreche das Model Context Protocol, das mir die Zusammenarbeit mit anderen KI-Agenten und -Tools erm\xf6glicht. Das bedeutet, dass ich Aufgaben koordinieren, Kontext austauschen und meine F\xe4higkeiten mit spezialisierten externen Systemen erweitern kann \u2013 und das alles, w\xe4hrend Sie die Kontrolle behalten."},"byo_ai_integration":{"title":"Bringen Sie Ihre eigene KI mit","description":"Ich lasse Sie meine vorhandene KI mit Ihren eigenen KI-Modellen oder -Diensten erweitern, um sie bei mir zu verwenden.","longDescription":"Wenn Sie bereits einen KI-Dienst, ein KI-Modell oder einen KI-Anbieter Ihres Vertrauens nutzen, integriere ich ihn gerne in meinen Workflow. Ich biete Ihnen die Flexibilit\xe4t, die Engine f\xfcr die Generierung, Umschreibung oder \xdcbersetzung auszuw\xe4hlen \u2013 ob Cloud, lokal oder benutzerdefiniert. Sollten Sie offline sein oder der Dienst nicht verf\xfcgbar sein, greife ich auf meine integrierten Funktionen zur\xfcck."},"workflows":{"title":"Workflows","description":"Ich helfe Ihnen, Aktionen zu wiederholbaren Arbeitsabl\xe4ufen zu verketten.","longDescription":"Ich \xfcbernehme die Gestaltung und Ausf\xfchrung mehrstufiger Prozesse, die verschiedene Eingaben, Befehle und Ausgaben miteinander verbinden. Mit Workflows k\xf6nnen Sie Routineaufgaben automatisieren oder komplexe Interaktionen erstellen \u2013 ausgel\xf6st durch Ihre Stimme oder Gesten. Die Schwerstarbeit \xfcbernehme ich f\xfcr Sie."},"showMore":"Mehr anzeigen","showLess":"Weniger anzeigen"},"listing":{"title":"Anwendungsf\xe4lle","titleLong":"Entdecken Sie, wie ich Ihnen helfen kann","recommended":"F\xfcr Sie empfohlen","exploreMore":"Weitere Anwendungsf\xe4lle entdecken","description":"Entdecken Sie, wie ich Ihren Workflow verbessern kann. Von Produktivit\xe4tssteigerungen bis hin zu kreativer Unterst\xfctzung \u2013 finden Sie die perfekten Anwendungsf\xe4lle, die auf Ihre Bed\xfcrfnisse zugeschnitten sind.","all":"Alle","search":"Suchen Sie nach Anwendungsf\xe4llen, Apps oder Funktionen ...","noResults":"Es wurden keine Ergebnisse gefunden. Versuchen Sie, Ihre Suche oder Filter anzupassen.","emptyAction":"Mehr online ansehen"},"examples":{"universalAppControl":{"title":"Universelle App-Steuerung","description":"Steuern Sie jede Anwendung auf Ihrem Computer mit Sprachbefehlen und intelligenter Automatisierung","descriptionLong":"\xdcbernehmen Sie die Kontrolle \xfcber jede Anwendung mit leistungsstarken Sprachbefehlen und intelligenter Automatisierung. Unser universelles App-Steuerungssystem lernt Ihre Arbeitsweise und passt sich Ihren Bed\xfcrfnissen an. So werden komplexe Aufgaben vereinfacht und Routinevorg\xe4nge sofort erledigt. Von der Verwaltung Ihrer Produktivit\xe4tssuite bis hin zur Steuerung von Medien- und Spieleanwendungen \u2013 diese Funktion funktioniert in Ihrer gesamten digitalen Umgebung."},"handsFreeComputerControl":{"title":"Freih\xe4ndige Computersteuerung","description":"Vollst\xe4ndige Computersteuerung durch Kopfbewegungen, Stimme und Eye-Tracking f\xfcr Barrierefreiheit","descriptionLong":"Erleben Sie mit unserem freih\xe4ndigen Steuerungssystem ein neues Level der Computerbedienung. Durch die Kombination aus fortschrittlicher Augenverfolgung, pr\xe4ziser Kopfbewegungserkennung und Sprachbefehlen erm\xf6glicht diese Funktion jedem die vollst\xe4ndige Steuerung seines Computers ohne H\xe4nde. Perfekt f\xfcr Benutzer mit eingeschr\xe4nkter Mobilit\xe4t, Multitasker oder alle, die ihren Computer auf eine neue Art und Weise nutzen m\xf6chten."},"replyToSocialMediaPosts":{"title":"Schnellere Social-Media-Posts und Antworten mit Diktierfunktion","description":"Antworten Sie auf beliebige Social-Media-Beitr\xe4ge mithilfe der intelligenten Diktierfunktion f\xfcr schnelle Antworten.","descriptionLong":"Die intelligente Diktierfunktion von Cephable beschleunigt das Posten und Kommentieren in sozialen Medien mit Spracherkennung. Die Diktierfunktion funktioniert in jedem Text- oder Postfeld, sodass Sie in sozialen Medien aktiv bleiben k\xf6nnen, ohne dass die Diktierfunktion Ihren Tag in Anspruch nimmt."},"clinicalNoteTaking":{"title":"HIPAA-konformes Diktieren und Formatieren f\xfcr Kliniker","description":"Sparen Sie Zeit, indem Sie zwischen den Sitzungen mithilfe intelligenter Sprachsteuerung und Diktierfunktion klinische Notizen machen. Anschlie\xdfend formatieren Sie Notizen automatisch im SOAP-Stil.","descriptionLong":"Suchen Sie nach HIPAA-konformer Diktiersoftware? Cephable unterst\xfctzt \xc4rzte mit intelligenter Sprachsteuerung und automatischer Formatierung bei der schnellen Dokumentation von Patientennotizen. Erstellen Sie SOAP-Notizen, Verlaufsberichte und Protokolle \u2013 ganz ohne H\xe4nde.","upgrade":{"description":"F\xfchren Sie ein Upgrade durch, um auf HIPAA-konforme, Offline-Intelligent-Tasks f\xfcr die automatische Formatierung und Iteration zuzugreifen."}},"vibeCoding":{"title":"Vom Gedanken zum Code: Diktat f\xfcr Entwickler und Vibe-Coder","description":"Vibe Code mit Diktat und KI-Textgenerierung zum schnelleren Schreiben von Boilerplate-Code und Prototypen.","descriptionLong":"Cephable Dictation hilft Entwicklern, schneller von der Idee zum Code zu gelangen. Diese Demo zeigt, wie Sprachbefehle Komponenten, Dashboards und mehr in Tools wie Vercel V0, GitHub Copilot in VS Code, Base 44 und Lovable generieren. Diktieren Sie Ihre Ideen und verfeinern Sie sie anschlie\xdfend mit Code.","upgrade":{"description":"F\xfchren Sie ein Upgrade durch, um offline auf Intelligent Tasks zuzugreifen und Code in der App umzuschreiben, zu generieren und zu \xfcbersetzen."}},"controllingBackgroundMusic":{"title":"Mediensteuerung: Verwalten Sie Musik, Videos und mehr, ohne Ihren Arbeitsfluss zu unterbrechen","description":"Verwalten Sie Ihre Hintergrundmusik mithilfe von Sprachsteuerungen und Schnellaktionen, w\xe4hrend Sie sich auf die aktuelle Aufgabe konzentrieren.","descriptionLong":"Mit cephable-Sprachbefehlen k\xf6nnen Sie Spotify ganz einfach freih\xe4ndig abspielen, pausieren, \xfcberspringen und die Lautst\xe4rke regeln. Schnellaktionstasten und sofort einsatzbereite Steuerelemente funktionieren auch in anderen Apps wie Apple Music, YouTube, Netflix und \xfcber 200 weiteren!"},"editingVideos":{"title":"Videobearbeitung mit Stimme","description":"Verbessern Sie Ihren Videobearbeitungs-Workflow mithilfe von Sprachsteuerungen, um schneller zu navigieren, zu schneiden und zu bearbeiten.","descriptionLong":"Konzentrieren Sie sich auf die Geschichte, nicht auf die Klicks. Die cephable Sprachsteuerung optimiert die Videobearbeitung mit allen Tools, die Sie bereits verwenden \u2013 Clipchamp, Adobe, iMovie, DaVinci Resolve und mehr. Schnellere Bearbeitungen, weniger Schritte."},"inboxTriage":{"title":"KI-E-Mail-Assistent: Schneller automatisieren, entwerfen und antworten","description":"Verwalten Sie Ihren Posteingang mithilfe von Sprachsteuerung und KI-Textgenerierung auf dem Ger\xe4t, um E-Mails zu sortieren, zu schreiben und zu bearbeiten.","descriptionLong":"Beschleunigen Sie Ihren E-Mail-Prozess mit privater KI auf Ihrem Ger\xe4t. Cephable kombiniert Sprachbefehle, Diktierfunktion, Schnellaktionstasten und Textgenerierung, um die Verwaltung Ihres Posteingangs schneller und einfacher zu gestalten. L\xf6schen Sie E-Mails, verfassen Sie Antworten und erstellen Sie kreative Antworten \u2013 ganz bequem in Outlook, Gmail und anderen Apps.","upgrade":{"description":"F\xfchren Sie ein Upgrade durch, um offline auf intelligente Aufgaben f\xfcr die automatische Formatierung, Inhaltserstellung, \xdcbersetzungen und mehr zuzugreifen."}},"summarizingReports":{"title":"Fassen Sie vertrauliche Berichte mit privater, ger\xe4teinterner KI zusammen","description":"Fassen Sie mithilfe der KI-Textgenerierung lange Berichte f\xfcr Ihr Team zusammen und bleiben Sie dabei privat und auf dem Ger\xe4t.","descriptionLong":"Verwandeln Sie lange Berichte mit ger\xe4teinterner KI in \xfcbersichtliche Team-Updates. Cephable extrahiert wichtige Punkte und Zahlen und erstellt pr\xe4gnante Zusammenfassungen, die Sie direkt mit Ihrem Team teilen k\xf6nnen. Die gesamte Verarbeitung erfolgt auf Ihrem Ger\xe4t, sodass Ihre sensiblen Daten sicher bleiben."},"handsFreeMeeting":{"title":"Reduzieren Sie die Meeting-Erm\xfcdung durch freih\xe4ndige Steuerung","description":"Steuern Sie Ihre Videokonferenzen mit Sprachbefehlen, Schnellaktionstasten und intelligenter Diktierfunktion.","descriptionLong":"Konzentrieren Sie sich in Meetings \u2013 ohne sich durch Men\xfcs klicken zu m\xfcssen. Cephable bringt Sprachbefehle und Schnellaktionsschaltfl\xe4chen in Microsoft Teams, Zoom, Google Meet und mehr. Stummschalten/Stummschaltung aufheben, Video umschalten, Chatnachrichten senden, Hand heben und freih\xe4ndig durch Meetingfenster navigieren \u2013 mit einsatzbereiten Steuerelementen, die Sie an Ihren Arbeitsablauf anpassen k\xf6nnen."},"spreadsheetReviews":{"title":"Arbeiten Sie schneller in Tabellenkalkulationen mit Sprachsteuerung und KI-Automatisierung","description":"\xdcberpr\xfcfen und bearbeiten Sie gro\xdfe Tabellen schnell mithilfe der Sprachsteuerung f\xfcr Navigation, Formatierung, Filterung und Bearbeitung.","descriptionLong":"Cephable bringt Sprachsteuerung und Schnellaktionsschaltfl\xe4chen in Excel, Google Sheets und andere Tabellenkalkulationstools. \xdcberpr\xfcfen, bearbeiten, kommentieren Sie schnell, l\xf6sen Sie Makros und Tastenkombinationen aus und passen Sie Befehle an Ihren Workflow an. Hunderte von Steuerelementen sind sofort einsatzbereit oder auf Ihr Setup zugeschnitten."},"socialMediaWriting":{"title":"Inhaltserstellung und Recherche mit privater, ger\xe4teinterner KI","description":"Entwerfen und schreiben Sie Social-Media-Beitr\xe4ge mithilfe von Sprachsteuerung und KI-Textgenerierung f\xfcr ansprechende Inhalte.","descriptionLong":"Erstellen Sie Inhalte sicher mit der On-Device-KI von Cephable \u2013 ganz ohne Cloud. Erstellen oder \xfcberarbeiten Sie Social-Media-Beitr\xe4ge, E-Mails, Slogans und Dokumentationen direkt in Ihren bevorzugten Tools. Alles l\xe4uft lokal, sodass Ihre vertraulichen Inhalte vertraulich bleiben und Sie \xfcberall arbeiten k\xf6nnen."},"fpsGamePlay":{"title":"Spielen Sie FPS-Spiele mit Sprachsteuerung","description":"Spielen und passen Sie ein Ego-Shooter-Spiel an, indem Sie die Sprachsteuerung f\xfcr Bewegung, Zielen und Schie\xdfen verwenden.","descriptionLong":"Erleben Sie Ego-Shooter-Spiele auf eine neue Art mit Sprachsteuerung. Bewegen, zielen und schie\xdfen Sie mit Ihrer Stimme \u2013 f\xfcr ein intensiveres und freih\xe4ndiges Spielerlebnis."},"customizingGameControls":{"title":"Anpassen der RPG-Spielsteuerung","description":"Passen Sie die Steuerung des Rollenspiels f\xfcr eine bessere Zug\xe4nglichkeit und ein besseres Spielerlebnis an.","descriptionLong":"Gestalten Sie Ihr Spielerlebnis mit anpassbaren Steuerelementen, die die Zug\xe4nglichkeit und das Gameplay verbessern. Passen Sie die Einstellungen an Ihre Vorlieben und Ihren Spielstil an und sorgen Sie so f\xfcr eine komfortable und unterhaltsame Gaming-Session."},"webBrowsing":{"title":"Freih\xe4ndiges Surfen im Internet mit Cephable | Reisen planen, online einkaufen und mehr","description":"Surfen Sie freih\xe4ndig im Internet und nutzen Sie die Sprachsteuerung zum Navigieren, Scrollen und Ausf\xfcllen von Formularen.","descriptionLong":"Suchen, shoppen und planen ohne Tippen. Die intelligente Sprachsteuerung von Cephable funktioniert in jedem Browser \u2013 egal ob Sie Fl\xfcge buchen, online einkaufen oder Ihre n\xe4chste Reise planen."},"documentCode":{"title":"Schnelle, sichere Codedokumentation mit KI-Textgenerierung auf dem Ger\xe4t","description":"Dokumentieren Sie Code, ohne vertrauliche Daten in die Cloud zu senden, und bleiben Sie dabei in derselben App, indem Sie Cephables Intelligent Rewrite verwenden.","descriptionLong":"Cephables Intelligent Rewrite erstellt Entwicklerdokumentation direkt aus dem Code \u2013 ohne sensible Daten in die Cloud zu senden. Generieren Sie README-Dateien, Markdown-Dokumente und API-Referenzen schnell und sicher \u2013 alles innerhalb der App."},"generateCode":{"title":"Schnelle, sichere Codegenerierung mit KI-Textgenerierung auf dem Ger\xe4t","description":"Erstellen Sie mithilfe von AI Intelligent Tasks Prototyp-Codeausschnitte aus Ticketanforderungen.","descriptionLong":"Mit Cephable k\xf6nnen Sie Ticketanforderungen in funktionierenden Code in jeder beliebigen Sprache umwandeln. Verwenden Sie Intelligent Tasks, um Code zu erstellen, Dokumentation zu generieren und Unit-Tests automatisch hinzuzuf\xfcgen. Arbeiten Sie programmiersprachen- und app\xfcbergreifend, ohne den Kontext zu verlieren."},"editingImages":{"title":"Schnellere Bearbeitung in Kreativ-Apps mit Sprachsteuerung und Diktierfunktion","description":"Erstellen und bearbeiten Sie Bilder mithilfe von Sprachsteuerung und KI-Textgenerierung f\xfcr schnelle Anpassungen und Konzepte.","descriptionLong":"Erwecken Sie Ihre visuellen Ideen mit sprachgesteuerter Bilderstellung und -bearbeitung zum Leben. Nutzen Sie die KI-Textgenerierung, um schnelle Anpassungen vorzunehmen, Konzepte zu entwickeln und Ihre Bilder zu verbessern, ohne durch komplexe Men\xfcs navigieren zu m\xfcssen."},"requirementDocsFromMeeting":{"title":"Von Notizen zu Produktanforderungsdokumenten in Minuten mit On-Device-KI","description":"Sparen Sie Stunden, indem Sie Rohprotokolle von Besprechungen in Minutenschnelle in strukturierte Produktanforderungsdokumente umwandeln.","descriptionLong":"Cephable wandelt mithilfe intelligenter Aufgaben Rohprotokolle von Besprechungen in wenigen Minuten in strukturierte Produktanforderungsdokumente um. Erfassen Sie Produkt-, Marketing- und Benutzeranforderungen schnell und sch\xfctzen Sie vertrauliche Diskussionen mit KI auf dem Ger\xe4t. Speichern Sie die Ergebnisse sofort als neue Dokumente."},"gamingVoiceControls":{"title":"Sprachsteuerung in WoW | Schnelle Navigation f\xfcr Men\xfcs, PvP und Dungeonfinder","description":"Steuern Sie Ihr Gameplay mit Sprachbefehlen, um durch Men\xfcs zu navigieren, PvP-K\xe4mpfe zu starten und Dungeons zu finden.","descriptionLong":"Verbessern Sie Ihr Spielerlebnis mit sprachgesteuerter Steuerung. Navigieren Sie mit einfachen Sprachbefehlen durch Men\xfcs, starten Sie PvP-K\xe4mpfe und finden Sie Dungeons. So k\xf6nnen Sie sich auf Ihr Gameplay konzentrieren und behalten gleichzeitig die volle Kontrolle."},"headMouseMovement":{"title":"Freih\xe4ndiges Gaming-Setup mit Head Mouse","description":"Steuern Sie Ihren Mauszeiger mithilfe von Kopfbewegungen f\xfcr pr\xe4zise Navigation und Klicks.","descriptionLong":"Die Kopfmaussteuerung erm\xf6glicht freih\xe4ndiges Spielen. Neigen oder drehen Sie Ihren Kopf, um den Cursor zu bewegen, Geschwindigkeit und Empfindlichkeit anzupassen und die Kontrolle ohne herk\xf6mmliche Maus zu \xfcbernehmen."},"noteTakingAndDocumentation":{"title":"Notizen machen und Dokumente erstellen mit privater KI auf dem Ger\xe4t","description":"Machen Sie sich Notizen und erstellen Sie Dokumente mithilfe der Sprachsteuerung und der KI-Textgenerierung f\xfcr effizientes Schreiben.","descriptionLong":"Optimieren Sie Ihre Notizen mit intelligenter Diktierfunktion und KI-gest\xfctzter Dokumenterstellung. Erstellen Sie schnell Entw\xfcrfe, Gliederungen und fertige Dokumente, damit Sie sich auf Ihre Ideen konzentrieren k\xf6nnen, anstatt sich um die Formatierung zu k\xfcmmern. Die gesamte Verarbeitung erfolgt ger\xe4teintern, um Datenschutz und Sicherheit zu gew\xe4hrleisten.","upgrade":{"description":"F\xfchren Sie ein Upgrade durch, um offline auf intelligente Aufgaben f\xfcr die Formatierung, Inhaltsiteration und mehr zuzugreifen."}},"presentationControls":{"title":"Freih\xe4ndige Pr\xe4sentationssteuerung mit Sprachbefehlen und Schnellaktionen","description":"Steuern Sie Ihre Pr\xe4sentationen mit Sprachbefehlen, um durch Folien zu navigieren, Pr\xe4sentationen zu starten/stoppen und Punkte hervorzuheben.","descriptionLong":"Halten Sie Pr\xe4sentationen souver\xe4n mit Sprachbefehlen. Navigieren Sie durch Folien, starten und stoppen Sie Pr\xe4sentationen und markieren Sie wichtige Punkte \u2013 alles ohne Ihren Computer zu ber\xfchren."},"designingFliers":{"title":"Entwerfen in Kreativ-Apps","description":"Erstellen und bearbeiten Sie Designs mithilfe von Sprachsteuerung und intelligenter Diktierfunktion f\xfcr schnellere Iterationen.","descriptionLong":"Erwecken Sie Ihre kreative Vision mit sprachgesteuerten Design-Tools zum Leben. Navigieren, bearbeiten und iterieren Sie m\xfchelos Ihre Designs, ohne sich in komplexen Men\xfcs zu verlieren \u2013 so k\xf6nnen Sie sich auf Ihre Kreativit\xe4t konzentrieren, statt auf Klicks."},"motionDesign":{"title":"Sprachbefehle f\xfcr Motion Design und Animation","description":"Animieren Sie Szenen und steuern Sie Keyframes mit intuitiven Sprachbefehlen f\xfcr nahtloses Motion Design.","descriptionLong":"Bringen Sie Bewegung in Ihre Ideen mit sprachgesteuerten Animationstools. Steuern Sie Zeitleisten, Keyframes und Effekte m\xfchelos mithilfe nat\xfcrlicher Sprache \u2013 so k\xf6nnen Sie sich auf das Storytelling und den visuellen Rhythmus konzentrieren, anstatt sich mit komplexen Benutzeroberfl\xe4chen herumschlagen zu m\xfcssen."}}}');


var $46e9372b918c82e5$exports = {};
$46e9372b918c82e5$exports = JSON.parse('{"deviceCommandThrottled":{"macroLength":"This connection does not allow long macros. Your macro has been shortened automatically.","commandCount":"This connection limits how fast you can send commands. Please wait and try again soon."},"logo":"Cephable logo","add":"Add","all":"All","edit":"Edit","create":"Create","delete":"Delete","previous":"Previous","next":"Next","search":"Search","loading":"Loading...","reload":"Reload","cancel":"Cancel","copy":"Copy","save":"Save","reset":"Reset","deprecated":"Deprecated","saveAndFinish":"Save and Finish","saveAndContinue":"Save and Continue","saved":"Saved","saveError":"Error saving changes.","done":"Done","back":"Back","play":"Play","pause":"Pause","resume":"Resume","success":"Success","continue":"Continue","options":"Options","share":"Share","finish":"Finish","description":"Description","expand":"Expand","expandMenu":"Expand Menu","finishEdit":"Finish Edit","advancedOptions":"View Advanced Options","authenticating":"Authenticating...","skipToMain":"Skip to Main Content","skip":"Skip","close":"Close","notFound":"Page Not Found","notFoundDescription":"Oh noes! We have searched the sea and we can\'t find thee page!","exitSetup":"Exit Setup","experimental":"Experimental","letGetStarted":"Let\'s get started!","exploreInputControls":"Explore Input Controls","when":"When I ...","thenMacro":"Cephable will run...","controls":"Controls","welcome":"Welcome.","beta":"beta","macroEmpty":"There are no macros matching this criteria.","you":"You","step":"Step","steps":"Steps","learnMore":"Learn More","dangerZone":"Danger Zone","connected":"Connected","notConnected":"Not Connected","connectAndLearn":"Connect & Learn","tryAgain":"Try Again","by":"By: {{value}}","noName":"- no name -","details":"Details","controlFeed":"Control Feed","upgrade":"Upgrade","purchase":"Purchase","results":"Results","explore":"Explore","created":"Created: {{value}}","updated":"Updated: {{value}}","deleted":"Deleted: {{value}}","expires":"Expires: {{value}}","expired":"Expired: {{value}}","used":"Used: {{value}}","generate":"Generate","stop":"Stop","clear":"Clear","rewrite":"Rewrite","translate":"Translate","inputMethod":"Input Method: ","info":"More Information","view":"View","control":"Control","automate":"Automate","mobileApp":{"title":"Mobile App"},"dashboard":{"title":"Dashboard"},"publicTag":"Public","invalidNumber":"N/A","wifi":{"disconnected":"Wi-Fi is disconnected.","connected":"Wi-Fi is connected.","description":"Connect to Wi-Fi to enable Cephable to work with your connections and software. You may have limited ability to use your current controls. "},"signalR":{"disconnected":"Syncing is disconnected.","description":"There appears to be a problem with Cephable syncing. This will cause issues saving your settings or communicating with other connections.","action":"Reconnect","disconnectedDevice":"Unable to sync with {{name}}.","disconnectedDeviceDescription":"There appears to be a problem with syncing either because of authentication or internet connectivity. You can not remotely send or receive data. You need to check both sides of the connection.","connected":"Syncing is connected.","connectedDescription":"Cephable is syncing properly and should be communicating with your connections and extensions as expected.","swap":"Swap to local device connection","unlinkedDevice":"Connection removed.","unlinkedDeviceDescription":"This connection has been unlinked from your account."},"billing":{"title":"Billing","expires":"Next Billing: {{value}}","description":"Manage your organization billing, seats, subscription upgrades, renewal, or cancellation.","error":"Please contact your system administrator to manage your billing.","view":"Manage Billing","included":"Included with your {{licenseType}} license.","mostPopular":"Most Popular","upgrade":{"description":"Upgrade now and take your controls to the next level.","longDescription":"Upgrade to a paid license to unlock all of the features of Cephable. From multiple devices, to advanced controls, to custom integrations, Cephable has everything you need to take you to the next level of productivity.","action":"Upgrade Now","compare":"Compare Plans","error":"Error upgrading. Please try again later.","requiredDetail":"A {{licenseType}} license is required for this feature. You can always upgrade or start a free trial in your Account Settings.","enableTextGeneration":"Upgrade to generate, edit, and translate content using our Intelligent Tasks.","enableAiDictation":{"title":"Upgrade to Intelligent Dictation","description":"Upgrade to unlock AI enhanced dictation. I can add punctuation, fix capitalization, and adapt to your style so your writing looks polished without extra effort."}},"isPlusAccess":{"short":"Plus","title":"Plus","titleLong":"Cephable Plus","description":"Cephable Plus is for power users who want to push more with intelligent voice, intelligent dictation, 100\'s of app controls, and more.","supportedFeatures":{"tag":"Everything in Basic, plus","features":["Intelligent Voice Controls (Natural Language)","Intelligent Dictation (AI Enhanced)","Intelligent Tasks  (Generation, Translation, Rewriting)","100\'s of Pre-trained App Controls"]}},"isEmployeeAccess":{"short":"Pro","title":"Professional","titleLong":"Cephable Professional","description":"Cephable professional empowers users with more productivity power, extending the local, private AI to generative capabilities.","supportedFeatures":{"tag":"Everything in Plus, plus","features":["On-device AI Workflows","Enterprise organization management","Enterprise restrictions","Unlimited Device Installs","Unlimited Pre-trained App Controls"]}},"personal":{"short":"Basic","title":"Basic","titleLong":"Cephable Basic","description":"Cephable Basic is free forever and built to help you move faster, express yourself, and get stuff done\u2014your way. Features included in basic are available to all users.","upgrade":{"title":"Take your controls to the next level","description":"Upgrade to Plus or Pro to unlock all of my features. More accuracy. More connections. More controls. More power to take your productivity to the next level.","featureHeading":"Here\'s how I can help you:","control":"I move you through apps and tools faster using your voice or quick actions \u2014 no broken flow. With Intelligent Voice we can just chat.","create":"I rewrite, dictate, generate, and translate directly inside your apps \u2014 no copying, pasting, or screen switching needed.","automate":"I run intelligent tasks and quick actions that speed up your workflow. From simple commands to complex macros, I can do the heavy lifting so you can focus on the work that matters.","local":"All local AI. No cloud processing."}},"isDeveloperAccess":{"short":"SDK","title":"SDK","titleLong":"Cephable SDK","description":"Cephable SDKs let you integrate powerful adaptive controls\u2014 voice, face, head, and more into your software with minimal lift and maximum payoff.","supportedFeatures":{"tag":"Everything in Plus, plus","features":["Windows and MacOS support","Lightweight, embeddable SDKs for offline voice, face, head, and quick action input","API/webhook support for custom output actions","Developer docs","Sample projects","Turn commands into document automation and navigation","Developer Portal for managing your projects, auth clients, device types, and more"]}},"isStudentAccess":{"short":"Edu","title":"Student","titleLong":"Cephable Education","description":"Cephable Education supports personalized learning and inclusive classrooms. Cephable works offline, runs on-device, and requires no third-party integrations.","supportedFeatures":{"tag":"Everything in Plus, plus","features":["Unlimited device installs","Unlimited pre-trained app controls","Unlimited sharing of custom app controls"]}},"isResellerAccess":{"short":"Reseller","title":"Reseller","titleLong":"Cephable Reseller","description":"Cephable Reseller is a paid license that allows you to create new organizations and assign license keys. This includes using Cephable with your own software suite and improving your user experience."},"viewProducts":"View Products","subscription":{"options":"Subscription Options","monthly":"Pay Monthly","billedMonthly":"/month","yearly":"Pay Yearly","billedYearly":"/year"}},"organization":{"title":"Organization","titlePlural":"Organizations","titleLong":"Cephable Professional for Organizations","description":"Organizations are groups of users who can collaborate on projects and share resources. You can manage your team, team profiles, billing and more here.","viewOrganization":"View Organization","orgName":"Organization Name","orgCustomBillingUrl":{"title":"Custom Billing URL","description":"This is a custom URL that will be used to redirect the user to your (the reseller\'s) billing system. Should begin with \'https://\' or \'mailTo:\'"},"create":"Create New Organization","managed":{"title":"Managed Organization","titleShort":"Managed","titlePlural":"Managed Organizations","description":"Managed organizations are organizations that are managed by a Cephable Reseller. Resellers can manage your team, team profiles, billing and more here.","error":"Error loading managed organizations.","empty":{"title":"No managed organizations found.","description":"It doesn\'t look like there are managed organizations matching this criteria. Or your license keys have not been activated yet."}},"settings":{"title":"Organization Settings","description":"Manage your organization billing, name, description, and resources.","view":"View Settings","general":{"title":"General"},"resources":{"edit":"Edit Resources","description":"Use the Markdown editor on the left to update and format helpful resources for all members of the organization. As you type, the preview on the right will show how your content will appear to users. You can add headings, lists, links, and other formatting elements using Markdown syntax. Changes will be visible to members once saved."},"other":{"title":"Other Settings","description":"Manage your organization billing, name, description, and resources."}},"menu":{"title":"Organization Menu","view":"View Menu","expand":"Expand Menu"},"update":"Your organization has been updated! Refreshing the app.","noAccess":{"title":"Access denied.","description":"Your permissions have recently changed and you no longer have access to this feature. If you believe this is an error, please contact your organization administrator."},"noOrg":{"title":"No associated license.","description":"You are not currently associated with a license or developer group. The portal is limited to users with a paid Cephable License. To unlock the full potential of Cephable start a risk free trial."},"error":"Error loading Organization. Please try again later.","member":{"title":"Member","titlePlural":"Members","orgTitle":"{{value}} Members","me":"My Membership","aboutMe":"About Me","description":"Members are users who are part of your organization. They can be assigned to different roles and have access to different parts of the organization.","edit":"Edit Members","removed":"You have been removed from a team.","removedDescription":"You have been removed from the team. You can no longer access the organization. If you believe this is an error, please contact your organization admin.","updated":"Success, {{value}}\'s membership has been updated.","error":"Error updating {{value}}\'s membership.","delete":"Success, {{value}} has been removed.","deleteError":"Error removing {{value}}.","loadError":"Error loading organization members.","deleteConfirmation":{"title":"Are you sure you want to remove this member?","description":"Once you remove this member, they will no longer have access to the organization. You can always re-invite them later.","confirm":"Yes, remove member"},"viewAll":{"title":"View All Members","description":"View all members of your organization and manage their roles and permissions."},"seats":{"title":"Member Seats","description":"Every member in your organization counts as a seat. The type of permissions they have can be changed by the organization admin.","stats":"seats out of {{value}}","max":"Max seats","maxSeatValue":"Max seats: {{value}}","current":"Current Seats","limit":{"title":"Maximum Seats Reached","description":"Your current plan has reached its limit of {{ maxSeats }} available seats. You are unable to invite additional members. Please contact your administrator to upgrade the plan or manage your seat allocation."},"updateLimit":{"title":"Upgrade Your Plan to Add More Seats","description":"Your current plan has reached the maximum number of seats: {{ maxSeats }}. Upgrade now to unlock additional seats and ensure your team can continue to grow seamlessly.","action":"Upgrade Plan"}},"emailExists":"Email already exists in the organization. Please enter a different email address."},"invite":{"title":"Invite","titlePlural":"Invites","orgTitle":"{{ value }} Invites","description":"Invites are sent to users to join your organization. You can invite users to join your organization and assign them to different roles.","edit":"Add a Member","view":"View All Invites","viewDescription":"See all current invites that have not been accepted.","new":"Invite a Member","editDescription":"Create a new invite for a user to join your organization.","emailRequired":"Email is required","emailInvalid":"Email is invalid. Please enter a valid email address.","emailExists":"Email already has an organization invite. Please enter a different email address.","emailPlaceholder":"Enter email address","expiration":"Expires ","delete":"Delete Invite","confirm":"Are you sure you want to remove this invitation?","confirmLong":"Once you delete this invite, the user will no longer be able to join the organization. You can always re-invite them later.","accept":"Accept Invite","stat":"active invitations","error":"Error loading invites.","noInvites":{"title":"No invites.","description":"It looks like there are no active invites for your organization."},"acceptSuccess":{"title":"Welcome to the team.","description":"You have successfully joined the organization. ","action":"View your new organization"},"acceptError":{"title":"Oops. Looks like there is a problem.","description":"There was an error joining the organization. Please try again later. If the issue persists, please reach out to your organization admin. ","action":"Back to the homepage"},"send":{"title":"Send Invite","success":"Invite to {{value}} sent.","error":"Error sending invite to {{value}}."}},"role":{"title":"Role","titlePlural":"Roles","description":"Roles are the different levels of access that a user can have in your organization. You can assign different roles to users to control what they can do."},"isAdmin":{"title":"Admin","description":"Admins have full access to the organization and can manage all aspects of the organization.","conflict":"This member is an Admin. You do not have permission to edit their roles."},"canViewMembers":{"title":"View Members","description":"Users with this permission can view all members of the organization."},"canInviteMembers":{"title":"Invite Members","description":"Users with this permission can invite new members to the organization and manage existing invites."},"canChangeMemberPermissions":{"title":"Change Member Roles","description":"Users with this permission can change the role of other members in the organization."},"canRemoveMembers":{"title":"Remove Members","titleSingle":"Remove Member","action":"Remove","description":"Users with this permission can remove other members from the organization.","confirm":"Are you sure you want to remove this member from the organization?","confirmLong":"Once you remove this member, they will no longer have access to the organization. You can always re-invite them later."},"canCreateAuthClients":{"title":"Create Projects","description":"Users with this permission can create new auth clients and projects for the organization."},"canViewAuthClients":{"title":"View Projects","description":"Users with this permission can view auth clients and projects for the organization."},"canManageBilling":{"title":"Manage Billing","description":"Users with this permission can manage the billing settings for the organization.","error":"You do not have permission to manage billing for this organization."},"canManageChildOrganizations":{"title":"Manage Child Organizations","description":"Users with this permission can create and manage child organizations as an admin."},"canAccessOrganizationProfiles":{"title":"View Organization App Controls","description":"Users with this permission can view the organization app controls associated with this organization."},"canEditOrganizationProfiles":{"title":"Manage Organization App Controls","description":"Users with this permission can create, edit, and delete organization app controls associated with this organization."},"canViewAnalytics":{"title":"View Analytics","description":"Users with this permission can view the metrics and analytics for the organization."},"metrics":{"title":"Metrics","description":"Metrics are data points that help you understand how your organization is using Cephable.","view":"View Metrics","orgTitle":"{{ value }} Metrics","manage":{"title":"Performance Metrics","description":"Download or clear the performance metrics collected during model inference."},"download":{"button":"Download Metrics","success":"Metrics file has been saved to your Downloads folder.","error":"Failed to download metrics file.","noFile":"No metrics file found. Try running the model first."},"clear":{"button":"Clear Metrics","success":"Metrics have been cleared.","error":"Failed to clear metrics file.","confirm":{"title":"Clear Performance Metrics","description":"Are you sure you want to clear all recorded performance metrics? This action cannot be undone.","cancel":"Cancel","confirm":"Clear Metrics"}},"lineChart":{"title":"Average Concurrent Connections","description":"This chart shows the average concurrent connections for the organization and project data over time.","max":"Max Connections: {{maxConnections}}","project":"Project Total","org":"Organization Total"}},"profiles":{"titleShort":"App Controls","title":"Organization App Controls","description":"Organization App Controls are shared profiles for distributing app controls across your organization or to share with your integration users. ","view":"View Organization App Controls","editDescription":"Edit organization app controls to customize settings.","empty":"No organization app controls found. Create one to get started.","error":"Error loading organization app controls."},"projects":{"title":"Projects","description":"Use Projects to manage secure access, configure device interactions, and streamline how your apps send and receive commands across various platforms.","name":"App Name","view":"View Projects","error":"Error loading projects.","orgTitle":"{{ value }} Projects","stats":{"title":"Project Stats","connections":"Total Connections","all":{"title":"All Project Metrics","description":"Aggregated metrics for all projects associated with {{ orgName }}"},"card":"projects out of {{value}}","users":"total users since {{date}}","avgUsers":"monthly avg users.","concurrent":{"title":"Average Concurrent Connections Last {{days}} days","label":"Avg Concurrent","max":"Max Connections","overage":"Overage","description":"Concurrent connections are the number of users connected to your project at the same time. This metric helps you understand how many users are using your app simultaneously."}},"projectType":{"title":"Project Type","description":"Project Types are used to categorize your projects and help us choose the right SDKs for you."},"accessDenied":{"generic":"You do not have access to this project.","title":"Access Denied.","description":"You do not have access to view, create, edit or delete projects. Please reach out to your administrator for access."},"upgrade":{"title":"Upgrade to Cephable SDK","description":"Cephable can be integrated directly into your app, game, or service using our SDK\u2019s. Projects are not currently available with your account. If you think there is a mistake, please reach out to support@cephable.com.","shortDescription":"Projects are not currently available with your account. Reach out to upgrade."},"limit":{"title":"Want more projects?","error":"Project limit reached.","description":"You have reached the maximum number of projects for your organization. Please reach out to your administrator to upgrade your account."},"create":{"title":"Create Project","titleLong":"Let\u2019s get started.","first":{"title":"Get started with your project.","description":"It looks like you haven\'t created a project yet. Client keys and devices are essential for securing communication between your applications and our services. With a client key, you\u2019ll be able to integrate voice and head motion controls into your apps quickly and securely."},"details":{"title":"Project Details","description":"Create a new project to manage your application\u2019s authorization, device capabilities, and SDK integrations. Follow the steps below to set up secure, customizable interactions for your users."}},"sdk":{"title":"Download the SDK","description":"Get access to our powerful SDK developed to make adaptive controls easy. ","select":{"title":"Select SDK","description":"Select the SDK you\u2019d like to use for this project. Our SDKs enable seamless integration of adaptive voice and head motion controls across different platforms."}},"clients":{"title":"Authorization Clients","configure":"Configure Authorization Client","description":"Authorization Clients manage secure access for your applications. Define an authorization client to authenticate users and control interactions with your application.","settings":"Authorization Settings","create":"Create Authorization Client","max":"Max Projects: {{value}}"},"secret":{"title":"Client Secret","created":"Your client secret has been created.","description":"Your client secret will only be shown once. Copy it now and store it in a safe secure location. <br> <br> Only use this for your own development. Do not share it with third party services or applications.","copy":"Copy Secret","rotate":{"title":"Rotate Client Secret","description":"WARNING: This action will revoke your existing client secret and create a new client secret. This will require you to update all of your existing usage through out your apps. This action can not be reversed.","error":"Error rotating secret. Please try again later."}},"key":{"title":"Client Key","view":"View Client Key","copy":"Copy Key","delete":{"title":"Delete Client Key","description":"WARNING: This action will remove your existing client key and all related settings.This action can not be reversed.","error":"Error deleting your client key.","success":"You\'re project has been deleted. "}},"tokenRedirect":{"title":"Token Redirect URLs","description":"Token Redirect URLs are the endpoints where access tokens are sent after authentication is complete. These URLs allow your application to securely receive tokens needed to access user data and services."},"authRedirect":{"title":"Authorization Code Redirect URLs","description":"The AuthCode Redirect URL is the endpoint where authorization codes are sent after a user grants permission to your application. This URL is essential in OAuth flows, as it ensures the secure transmission of the authorization code from the authorization server to your app, allowing you to request access tokens on behalf of the user."},"originHost":{"title":"Origin Host","description":"The URL that will serve as the primary source for request and data during API interactions."},"scopes":{"title":"Scopes","configure":"Define Scopes","titleLong":"API Permission Scopes","manage":"Manage Authorization Scopes","description":"Scopes define the permissions that this authorization client will have. Set scopes to limit access to specific data and functionality, ensuring users only get the access they need."},"type":{"title":"Implementation Type"},"deviceScopes":{"title":"Associated Device Types","titles":"Associated Device Types","titleLong":"Allowed Device Types","configure":"Configure Allowable Device Types","descriptionShort":"Define which type of devices can access this project.","description":"Device Type defines the permissions and access levels that a device has within your application. By assigning specific devices types, you can control the actions and data that each device can access, ensuring that your application remains secure and compliant with your privacy policies.","action":"Add new device type"},"deviceType":{"title":"Device Types","description":"A DeviceType defines a category of devices, detailing their input/output capabilities and supported features (e.g., voice, gesture, controller types). It ensures that only authorized devices can interact with an application.","action":"Create Device Type","name":"Device Type Name","descriptionLong":"Device Type Description","id":"Device Type Id","features":{"title":"Supports Features","description":"Define the input and outputs that your app supports. This helps us optimize user experience across Cephable.","supportsVoiceInput":"Voice Input","supportsPhysicalInput":"Physical Input","supportsKeyboardOutput":"Keyboard Output","supportsPlayStationControllerOutput":"PlayStation Controller","supportsFaceInput":"Face Input","supportsGestureInput":"Gesture Input","supportsXboxControllerOutput":"Xbox Controller","supportsDigitalExtensions":"Digital Extensions","supportsPhysicalExtensions":"Physical Extensions","supportsNintendoControllerOutput":"Nintendo Controller","supportsGenericControllerOutput":"Generic Controller Output"},"canAutoStart":{"title":"Supports Automatic Control Starts","description":"[canAutoStart] if enabled, SDK\u2019s will check the user settings and attempt to immediately start camera, or microphone controls after user login."},"isSupported":{"title":"Active","description":"[isSupported]  If disabled, Cephable will no longer send, receive or  acknowledge any user devices associated with this. Equivalent to deprecated."},"throttleRules":{"title":"Command Throttle Rules","description":"Configure throttle rules to control command flow and input restrictions for this device type.","disableVoiceInput":"Disable Voice Input","disableHotkeyInput":"Disable Hotkey Input","disableCameraInput":"Disable Camera Input","disableMultiInputs":"Disable Multiple Inputs","maximumCommandsPerSecond":"Maximum Commands Per Second","maximumCommandsPerMinute":"Maximum Commands Per Minute","maximumMacroLength":"Maximum Macro Length"},"locale":{"title":"Default Language","description":"[defaultLocale] The default locale for this device type. This will be used as the default language for the device.","support":"Supports Languages","warn":"** It looks like you have Custom Controls set up. Please make sure that you have updated the custom controls for the associated languages.**","name":"{{lang}} - Device Type Name","langDescription":"{{lang}} - Description"},"customControls":{"title":"Custom Controls","description":"Custom Controls are an advanced option for allowing users to manually set up and edit app controls associated with this device. If you are wanting users to control your device from Cephable directly, then you must register your device controls here. Please see Cephable API for complete details on the options.","object":"{{lang}} - Custom Controls Object"},"success":{"title":"Success!","description":"You have created a new Device Type. {{name}} You can now update your authorization client device scope as needed."}}},"troubleshooting":{"title":"Troubleshooting","editorDescription":"[Optional] This is a section that is visible to all users via the connection details page in both the Cephable mobile and desktop apps.","description":"If you are experiencing issues with Cephable, try the steps below to resolve common problems."},"onboarding":{"title":"Onboarding","editorDescription":"[Optional] Onboarding is displayed to users when this device type is added to their account. This is a great place to provide instructions on how to set up and use the device type with your application."},"documents":"Documents","completionStatus":{"title":"Completion Status","error":"","complete":"Complete.","incomplete":"Incomplete."},"metadata":{"title":"Metadata","urlError":"URL must start with http:// or https://","metatitle":{"label":"Meta Title","placeholder":"Enter a short title"},"shortDescription":{"label":"Short Description","placeholder":"Enter a brief preview description (max 150 characters)"},"externalLink":{"label":"External Link URL","placeholder":"https://example.com/device-info","description":"A direct link to an external website or resource that provides more information about setting up this device for the first time. If you use this we will not use the client listing markdown."},"iconUrl":{"label":"Device Icon URL","placeholder":"https://example.com/device-icon.png","description":"A direct link to an image that represents this device type. This icon will be displayed in the Cephable app and on device listings."},"darkModeIconUrl":{"label":"Dark Mode Device Icon URL","placeholder":"https://example.com/device-icon-dark.png","description":"A direct link to an image that represents this device type in dark mode. This icon will be displayed in the Cephable app and on device listings when the user has dark mode enabled."},"editorDescription":"When your device is chosen to be featured in the Cephable app as an extension or connection, we use this information to display to users setting up new connections."},"client-listing":{"title":"Client Listing","editorDescription":"Detailed instructions for new users to set up new connections with this device type. This markdown content will be displayed in the Cephable app when users are adding a new connection."},"new":{"details":"Organization Details","name":{"label":"Organization Name","placeholder":"Enter the name of your organization"},"description":{"label":"Organization Description","placeholder":"What are your goals with using Cephable Professional?"}},"expired":{"title":"Your Cephable License has Expired","titlePlural":"Your Cephable Licenses have Expired","user":"It looks like your Cephable License has expired, so you\'ve been downgraded to the free Cephable Basic. To renew, please contact your organization administrator.","admin":"It looks like your Cephable License has expired, so you\'ve been downgraded to the free Cephable Basic. Please renew your license to continue using advanced features beyond Cephable Basic.","multiple":"It looks like your Cephable Licenses have expired, so you\'ve been downgraded to the free Cephable Basic. Please renew at least one of your licenses to continue using advanced features beyond Cephable Basic.","banner":"It looks like your Cephable License has expired, so you\'ve been downgraded to the free Cephable Basic. By renewing, gain access to features like enhanced voice controls, AI Intelligent Tasks, and many prebuilt app controls.","dialog":{"title":"Select an Organization","description":"You have multiple organizations associated with your account. Please select the organization you would like to renew."}},"upgrade":{"existing":{"title":"You are part of an existing license.","description":"Please upgrade by clicking `{{action}}` on the side menu."}},"restrictions":{"isGenAIDisabled":{"title":"Generative AI Disabled","description":"Your organization has disabled access to Generative AI features. Please contact your organization administrator for more information."},"isRemoteControlDisabled":{"title":"Cross Device Syncing Disabled","description":"Your organization has disabled access to syncing, you will not be able to use our companion app or control external devices. Please contact your organization administrator for more information."}}},"developer":{"title":"Developer","titleLong":"Developer Resources","description":"Cephable can be integrated directly into your app, game, or service using our SDK\u2019s.","sdk":{"title":"Explore Our SDKs","description":"We provide first-class SDKs designed to seamlessly integrate voice recognition and adaptive controls into your applications. Our tools are crafted to enhance user interaction through intuitive controls and to foster accessibility, ensuring that your software can be operated more effectively by all users.","javascript":{"title":"JavaScript","subtitle":"Web","description":"Integrate voice and adaptive controls directly into your web applications.","action":"Get NPM Package"},"net":{"title":".NET","subtitle":"Windows Applications","description":"Leverage the power of .NET to create applications with our WPF and WinUI3 SDKs.","actionCore":"Get Core Package","actionWpf":"Get WPF Package"},"android":{"title":"Android","subtitle":"Mobile Devices","description":"Android applications designed to facilitate  voice and head motion capabilities.","action":"Get Android SDK"},"more":{"title":"More","description":"Not finding what you need? Reach out and we can help you.","action":"Request a SDK"}},"demo":{"title":"Demos","samples":"Demos and Samples","titleLong":"Experience Our SDKs in Action","description":"Discover the power of our voice and head motion control technologies through our sample applications. From interactive games to dynamic web and mobile apps, each example demonstrates the versatility and effectiveness of our SDKs. Explore these examples to gain insights and inspiration for integrating enhanced accessibility and immersive experiences into your own projects.","game":{"title":"2048 Game","subtitle":"Web","description":"Elevate traditional gameplay with adaptive voice and head motion controls.","action":"Play the Game"},"other":{"title":"Other Demos","description":"Experience firsthand how Cephable can your enhance your application, game or device.","action":"View More Demos"},"web":{"title":"Web SDK Samples","subtitle":"Web","description":"Straightforward integration of all our core functionality into web applications.","action":"Experience the SDK"},"unity":{"title":"Unity","subtitle":"Game Development","description":"See how adaptive controls can be leveraged in gaming to provide a more engaging UX.","action":"Get the Sample"}},"other":{"title":"Other Resources","description":"Not finding what you need in our SDK\u2019s try working directly with out API\u2019s or reach out the community for help, inspiration and support.","api":{"title":"API","description":"Our API\u2019s allow you to interact with Cephable directly. You can use our API\u2019s to create custom integrations."},"support":{"title":"Support","description":"Not finding what you need? Reach out to our community via Discord.","action":"Join Discord"}}},"customControls":{"title":"Global & Device Controls","warn":"Microphone has not been started. You must start your microphone to use global and device controls.","descriptionShort":"Global and device controls are always-available actions designed to work across any software. Global controls\u2014like \'Stop Camera\'\u2014are system-wide and app-independent, while device controls are tailored to each device connection and unlock more advanced features than standard app controls.","description":"Global and device controls are always-available actions designed to work across any software. Global controls\u2014like \'Stop Camera\'\u2014are system-wide and app-independent, while device controls are tailored to each device connection and unlock more advanced features than standard app controls. These controls are currently accessed as voice controls, however in the future we will add support for other inputs.","prefixDisclaimer":" This is a prefix control; it will listen to the words after the command and then search against the following phrase to find matches.","allowPausedDisclaimer":" This control will work even when the microphone is paused.","noDevice":"This step uses a custom extension that you haven\'t configured for your account. Add the extension to unlock this step.","resetControls":{"title":"Reset Controls","description":"Your voice language has changed since the last time you updated your controls. Note: This will reset your controls to match {{language}}, and you may lose any custom commands. Are you sure you want to reset?","confirm":"Yes, reset controls","error":"There was an error resetting your controls. Please try again later."},"conflictIndicators":{"warn":"Warning: ","title":"Input configuration conflicts detected","description":"Some of the inputs for your global & device controls you are using are also used in one or more of your app controls. This may cause conflicts when using Cephable. When this occurs we will always give preference to the app control over the global or device control.","item":"The input <strong> {{value}} </strong> is used in your app controls: ","globalControls":"Global Control Configuration Conflicts","deviceControls":"Device Control Configuration Conflicts","globalDescription":"The following global controls have conflicting inputs with your app controls.","deviceDescription":"The following device controls have conflicting inputs with your app controls.","usedInput":" is used as an input for "},"globalControls":{"title":"Global Controls","description":"Global controls are controls that are always available no matter what app controls or device you are using. Some even work when your microphone or camera controls are paused.","empty":"You have no global controls yet. Click below to create one.","edit":"Edit Global Controls"},"deviceControls":{"title":"Device Controls","description":"Device controls are tied to the specific device or connection you\'re using. They\u2019re available without needing to add them to your app controls and are especially useful for features or events that are only supported on certain devices.","empty":"You have no device controls yet. Click below to create one.","edit":"Edit Device Controls","controls":{"cephable-open-app":{"success":"Open app: {{value}}","error":"Unable to find app: {{value}}"},"cephable-close-app":{"commands":["close"],"name":"Close App By Name","description":"Use this command with voice controls to close an app on your computer by name.","success":"Close app: {{value}}","error":"Unable to find app: {{value}}"},"cephable-minimize-focused-app":{"commands":["minimize"],"name":"Minimize the current app in focus.","description":"Use this command with voice controls to minimize the current app in focus.","success":"Minimize focused app success!","error":"Error minimizing focused app."},"cephable-maximize-focused-app":{"commands":["maximize"],"name":"Maximize the current app in focus.","description":"Use this command with voice controls to maximize the current app in focus.","success":"Maximize focused app success!","error":"Error minimizing focused app."},"cephable-close-focused-app":{"commands":["close current"],"name":"Close the current app in focus.","description":"Use this command with voice controls to close the current app in focus.","success":"Close current app success!","error":"Error closing current app."},"cephable-generate-text":{"commands":["generate"],"name":"Generate text by providing the prompt following this command.","description":"Use this command with voice controls followed by your prompt to generate some related text."},"cephable-rewrite-text":{"commands":["rewrite"],"name":"Rewrite text by providing the prompt following this command.","description":"Use this command with voice controls followed by your prompt to rewrite your current highlighted text."},"cephable-summarize-text":{"commands":["summarize"],"name":"Summarize text by providing the prompt following this command.","description":"Use this command with voice controls followed by your prompt to summarize your current highlighted text."},"cephable-translate-text":{"commands":["translate"],"name":"Translate text by providing the prompt following this command.","description":"Use this command with voice controls followed by your prompt to translate your current highlighted text."},"cephable-stop-generate-text":{"commands":["stop generate","stop generation","cancel generate","cancel generation"],"name":"Stop generating text.","description":"Use this command with voice controls to stop generating text"},"cephable-open-panel":{"commands":["show panel"],"name":"Open the Cephable panel","description":"Use this command with voice controls to open the Cephable panel."},"cephable-close-panel":{"commands":["hide panel"],"name":"Hide the Cephable panel","description":"Use this command with voice controls to hide or minimize the Cephable panel."},"cephable-click-by-name":{"commands":["tap","hit","navigate to","go to"],"name":"Tap Element By Name","description":"Tap something on the page by name, such as \\"tap save\\" to click a button named \\"save\\""}}},"changeProfile":{"success":"Change app controls: {{value}}","error":"Unable to find app controls: \'{{value}}\'"}},"notifications":{"title":"Notifications","center":"Notification Center","empty":"You have no notifications at this time. Check back another time.","seen":"Seen","markAsRead":"Mark as Read","view":"View All {{value}} Notifications"},"unsaved":{"title":"You have unsaved changes.","description":"You have unsaved changes. Are you sure you want to leave this page?","cancel":"Exit without saving","confirm":"Save and Exit"},"login":{"welcome":"Welcome to Cephable!","subtitle":"Control your technology on <strong>your</strong> terms.","description":"Take full control of your computer, apps, and games with Cephable \u2014 your personal AI for fast actions, voice commands, facial expressions, gestures, tilt, and more. No cloud processing. Just seamless control that moves with you.","create":"Create Account","signIn":"Sign In","loading":"Redirecting to sign in...","error":"There was an error signing you in. Please sign in again.","existingAccount":"Already have an account?"},"home":{"title":"Home","startControls":"Turn it on!","manage":"Configure","profileGenerate":{"title":"Oops. Looks like you don\'t have any app controls yet.","description":"In order for Cephable to control your computer, we need to know what you want to control. You can create app controls from scratch or have us help you create one using our control generator."}},"wizard":{"title":"Generate App Controls","titleLong":"Generate New App Controls","description":"Cephable will then use this information to generate controls for you to review and try!","includeDefaultKeysQuestion":"Include default voice commands for keys and mouse clicks?","try":"Try Control Generator","placeholder":"Make sure the voice commands are short.\\n\\nI want to be able to say \\"forward\\" to go to the next slide in the presentation\\n\\nI want to use head movement for moving the cursor and voice controls for editing shortcuts\\n\\nAdd quick action buttons for all my character movement and abilities.","placeholderAppName":"Microsoft Word, Minecraft, YouTube, Code, etc.","noOptionsText":"Begin typing to find an app you want to control","generate":"Generate Controls","complete":{"title":"Alright, we\'re done!","description":"Click the button below to view the controls we generated. You\'ll be able to manually edit, add to, or remove any aspects to perfect it for yourself.","viewControls":"See my controls"},"error":{"emptyInput":"Please select at least one input method","emptyApp":"Please enter at least one app name","generatingProfile":"Error generating app controls"},"loading":{"title":"We\'re putting together all the pieces","description":"This can take up to about a minute. Don\'t leave this page or go back or it will stop generating."},"selectedTips":{"title":"Tip #{{count}}","previous":"Previous Tip","next":"Next Tip","one":"Did you know you can use Cephable on one device to control another? Download Cephable to your mobile, tablet or even another computer and choose the connection you want to control (perhaps this one). Your personal and input profiles are consistent across them all! Just make sure Cephable is running on your device and connections.","two":"You can control the sensitivity of your inputs in the \\"Expression Control Settings\\" section of the main panel. This let\'s you further refine the ways Cephable interprets inputs specific to you. And Cephable get\'s better over time as it works with you!","three":"After we set this up you still have complete control over the configuration. We\'re giving you a baseline but at any point you can change the mapping between what you do and what it does on the computer.","four":"You can print out your controls to have a physical copy as you use Cephable. We know this is all new and takes some getting used to. Practice makes better!"},"steps":{"one":"Step 1. Type the name of an app you want to control.","two":"Step 2. Confirm the input controls you want to use:","three":"Step 3. (optional) ","threeContinued":"Describe any specific actions you\'d like to have setup for commands you commonly use or have a strong preference for. Please use plain english like the ones below"}},"profile":{"title":"App Controls","titlePlural":"App Controls","titlePreview":"Controls Preview","previous":"Previous App Controls","manage":"Manage App Controls","view":"View Controls","edit":"Edit App Controls","add":"Add App Controls","create":"Create App Controls","customize":"Customize App Controls","warn":"Camera or microphone must be started to use your app controls.","descriptionShort":"Discover the different ways Cephable helps you control your devices and software.","description":"App controls are a set of controls that you can use to control your device or connection. You can create multiple app controls and switch between them whenever you\'d like.","name":"App Name","nameQuestion":"What do you want to call these app controls?","newName":"New App Controls","search":"Search App Controls by Name","searchLong":"Search App Controls by Name or Description","keyboardAndMouse":"Keyboard and Mouse","genericController":"Gamepad Controller","keyboardMouseAndController":"Keyboard, Mouse, and Controller","permissionError":"You do not have permission to use these app controls.","custom":"{{name}} (Custom)","set":{"title":"It doesn\'t look like you have app controls set yet.","description":"App Controls are how Cephable knows what to listen for and what actions to take. You can swap control app controls whenever you\'d like from the homepage or by going to your connection settings.","cta":"Set App Controls","empty":{"auto":"Switch to another app to see controls","select":"Select a control to begin","none":"No app controls found"}},"summary":{"title":"App Controls Summary","descriptionLong":"Here are the details of these app controls. You can search controls, actions, and more to see what you can do with these app controls.","description":"Get a summary of these app controls including what controls there are, customizations, details, and more.","view":"View App Controls Summary","filter":"Filter by Input Type","placeholder":"Search control names..."},"copy":{"title":"Copy App Controls","duplicate":"Duplicate App Controls","question":"Create a copy?","description":"Want to create a new copy of these app controls? This will open a new window with these app controls copied but it won\'t be added to your account until you save it.","confirm":"Yes, create a copy","profileSuffix":"{{name}} (copy)"},"new":{"title":"Create New App Controls","description":"Craft controls from the ground up or let cutting-edge AI generate personalized controls, empowering you to navigate apps and software effortlessly using your voice, head, and face gestures.","note":"Recommended for advanced users.","scratch":"Create from Scratch"},"advancedOptions":"Advanced Control Options","delete":{"title":"Delete App Controls","titleLong":"Delete these app controls","description":"You can delete these app controls by clicking \'Delete App Controls\'.","confirm":"Are you sure you want to delete these app controls","confirmLong":"Once you delete these app controls, you won\'t be able to return to it. Are you sure you want to delete these app controls?","confirmButton":"Yes, delete these app controls"},"current":"Current Controls","loading":"Loading controls...","null":"You have no app controls yet. Click below to create one.","nullButton":"Create your first app controls","preview":"Preview","features":"Features","byline_public":"By: Cephable Team","byline_shared":"Shared by: Cephable Community","share":{"title":"Share App Controls","previewTitle":"Shared App Controls Preview","description":"Share these app controls with others so they can get a copy and personalize from there!","descriptionLong":"Share these app controls with others so they can get a copy and personalize from there! Choose how you want to share, then create a link to send to others.","add":"Create a Share Link","confirm":"Share this url","link":"Share Link","copy":"Copy Link","copied":"Copied!","usage":"Usage Amount","created":"Created {{value}}","expiration":{"title":"Expiration","once":"Only allow one use","unlimited":"Allow unlimited usage","no":"No expiration","date":"Expiration Date","dateDescription":"Expire at a specific date"},"manage":"Manage previous share links","empty":"No shares have been created for these app controls."},"swap":{"title":"Swap Controls","titleLong":"Swap your App Controls","descriptionShort":"Use different app controls to match the program or software you are using.","description":"You can swap between different app controls to match the program or software you are using."},"autoProfileSwitching":{"title":"Automatic Control Switching","description":"Automatic control switching allows Cephable to adapt to your workflow seamlessly. When turned on, Cephable will contextually adjust your app controls based on the program or software you\'re using. If turned off, you can manually switch app controls using the \'Swap Controls\' button or using global commands.","alerts":{"disabled":"Automatic Control Switching is turned off.","temporarilyDisabled":"Automatic Control Switching is temporarily turned off.","enabled":"Automatic Control Switching is turned on.","error":"Error saving automatic control switching preferences"},"associatedPrograms":{"add":"Add a New Associated Program","description":{"personal":"Choose the software or programs you want to connect to these controls. This supports Automatic Control Switching, where Cephable will automatically switch these app controls to match the current program you are using.","short":"Choose the software or programs you want to connect to these controls."},"edit":"Edit Associated Programs","noOptionsText":"Begin typing to find associated programs","profileLabel":"App Controls: ","remove":"Remove Associated Program","title":"Associated Programs","when":"Cephable will automatically switch my app controls to {{profileName}} when I use...","emptySearch":"There are no programs associated with these controls.","error":"Error saving associated programs. Please try again later.","emptyError":"Empty Associated Program detected, please remove before continuing."},"commandOverlay":{"command":"Switching App Controls: {{value}}"}},"error":{"noMatch":"No app controls match your search.","save":"Error saving app controls. Please try again.","conflicts":"Error saving app controls due to conflicts.","load":"Error loading app controls.","add":"Error adding app controls.","delete":"Error deleting app controls.","audioEventsWithEmptyCommands":"You have missing controls in your talk back. Check your talk back controls to make sure you fill it out completely.","device":"Invalid app control for this connection. Please try a different one."},"conflictIndicators":{"errorTitle":"Error saving app controls due to conflicts","warningTitle":"App controls saved with warnings","subtitle":"The app controls you created has some configurations that may conflict.","profileNameErrors":"App Controls name conflict","emptyControlsMapped":"Empty input names","emptyControlsMappedDescription":"Please add a voice command, facial expression, head tilt, or other command to your input.","emptyKeybindingControlsMapped":"Empty input names for keybindings","emptyKeybindingControlsMappedDescription":"Please add a voice command, facial expression, head tilt, or other command to your input for keybindings.","duplicateNameTitle":"Duplicate App Controls name","duplicateNameDescription":"You have a existing app controls with the same name. Please change the name before continuing.","emptyNameTitle":"Empty app controls name","emptyNameDescription":"The app controls must have a name for it. ie Game 1, Spotify, Word, etc.","macrosReleaseKeysMissingTitle":"Outputs with unreleased keys","macrosReleaseKeysMissingDescription":"Please add a release key or stop all step to prevent keys from getting stuck.","duplicateInputCommandMacroTitle":"Identical control inputs","duplicateCommandsDescription":"Please remove or change the duplicate input commands.","duplicateInputCommandBindingsTitle":"Identical control inputs for keybindings","conflictIndicatorDisplayString":"{{container}} : {{commandOrKeyName}} with {{commandOrEventType}}","duplicateMacroNames":"Duplicate Control Names","duplicateMacroNamesDescription":"Please remove or change one of your identical control names.","warningIgnore":"Ignore","warningDoNotShowAgain":"Do not show warnings again","macrosVoiceCommandConflictWithDictationTitle":"Control voice commands same as dictation key words","keybindingsVoiceCommandConflictWithDictationTitle":"Keybindings voice commands same as dictation key words","macrosVoiceCommandConflictWithDictationDescription":"Your voice inputs will trigger dictation and voice commands.","keybindingsVoiceCommandConflictWithDictationDescription":"Your voice inputs will trigger dictation and key presses.","macrosVoiceCommandConflictWithGenerationTitle":"Control voice commands same as generation key words","keybindingsVoiceCommandConflictWithGenerationTitle":"Keybindings voice commands same as generation key words","macrosVoiceCommandConflictWithGenerationDescription":"Your voice inputs will trigger generation and voice commands.","keybindingsVoiceCommandConflictWithGenerationDescription":"Your voice inputs will trigger generation and key presses.","duplicateAssociatedProgramNames":"Duplicate associated program names","duplicateAssociatedProgramNamesDescription":"Please remove or change one of your identical associated programs.","emptyEvent":{"title":"Missing Steps","description":"There are missing steps in your controls. This could lead to Cephable not doing an action when you give a command."},"warningDetails":"View all conflicts"},"success":{"save":"App controls saved.","add":"App controls added.","delete":"App controls deleted.","share":"Share link created and copied to clipboard","shareDelete":"Share link deleted.","generate":"App controls generated."},"warning":"App controls saved with warnings"},"macros":{"title":"Control","titlePlural":"Controls","description":"Controls contain an input (action that you do like tilt your head) and steps that Cephable will do after that input action has been recorded. You can use controls to create a combination of steps that are triggered by a single input.","new":"Create a New Control","newDescription":"Create a new control to combine multiple steps and inputs.","add":"Add Control","create":"Create a Control","name":{"title":"Control Name","question":"What do you want to call this control?","description":"Give your control a name so you can easily find it later.","placeholder":"action this control is doing like \\"jump\\" or \\"zoom in\\""},"empty":"You have no controls yet. Click below to create one.","copySuffix":"{{name}}_copy"},"event":{"title":"Step","titlePlural":"Steps","previewSummaryPlural":"{{first}} and {{total}} more events","add":"Add Step","stepType":"Step Type","select":"Select the type of step you want to add.","question":"What type of actions do you want Cephable to perform?","setup":"Configure your Step","description":"Steps are the actions that Cephable will do after the input has been triggered. You can add multiple steps to a control to create a combination of actions.","expand":"Expand to see the rest of the steps","stepUp":"Move Step Up","stepDown":"Move Step Down","stepCopy":"Copy Step","stepRemove":"Remove Step","insertStep":"Insert Step Below","showOptions":"Show Options","hideOptions":"Hide Options","hold":"Hold time (in milliseconds)","error":"You must configure your step.","multiple":"Multiple Steps","deviceTypeCustomAction":{"title":"Custom Device Action"},"keyPress":{"title":"Press Key or Button ","short":"Press","fieldSet":"Keys or Button to Press","label":"Key or Button","holdTime":"Hold key time (in milliseconds)","description":"Press a keyboard key without using the keyboard.","longDescription":"This function simulates the pressing of a key on your keyboard. For instance, if you have difficulty pressing physical keys, you can use a voice command or another input method to \\"press\\" a key virtually.","example":"Say \\"Enter\\" to send an email without physically pressing the Enter key.","timing":"Key Press Timing","tap":"Tap","tapLong":"Tap Button","latch":"Latch","latchLong":"Hold until released","hold":"Hold","holdLong":"Hold for amount of time","toggle":"Toggle","toggleLong":"Toggle action","release":"Release","releaseLong":"Release action","latchLabel":"Hold <strong> {{value}} </strong> until released","tapLabel":"Tap <strong> {{value}} </strong>","pressLabel":"Press <strong> {{value}} </strong> for <strong> {{time}} </strong> milliseconds","remove":"Remove Key Press","add":"Add Key/Button to Press"},"keyRelease":{"title":"Release Key or Button","short":"Release","selected":"Selected Keys to Release","description":"Let go of a keyboard key you\'ve pressed and held.","longDescription":"This function simulates the release of a key on your keyboard. It should be used in conjunction with a key press that is held indefinitely. For instance, if you have difficulty pressing physical keys, you can use a voice command or another input method to \\"release\\" a key virtually.","example":"Say \'Stop\' after saying \'Toggle Run\' to stop running.","label":"Release <strong> {{value}} </strong>","add":"Add Key/Button to Release","remove":"Remove Key Release"},"keyToggle":{"title":"Toggle Key or Button","short":"Toggle","selected":"Selected Keys to Toggle","description":"Turn a keyboard key on or off like a light switch with a single control.","longDescription":"This turns a key\'s function on or off, like a switch. It\'s useful for keys that you want to hold for an indeterminate amount of time. You can use this to keep the same action for both key press and key release or stop.","example":"Say \'Toggle Run\' to start running. Say \'Toggle Run\' to stop running.","label":"Toggle <strong> {{value}} </strong>","add":"Add Key/Button to Toggle","remove":"Remove Key Toggle"},"pause":{"title":"Pause","description":"Add a brief delay between actions.","longDescription":"This function allows you to insert a brief delay between actions, which is essential in situations where one action must fully complete before the next begins. For example, if you\'re using a command to make text bold in a document, you might first need to open a context menu. The Pause function gives enough time for the context menu to open and become active before proceeding to the next step, ensuring smooth and error-free operation.","example":"Imagine you\'re editing a document using voice commands. You say \\"Format text,\\" which opens a context menu. Then, after a brief pause to allow the menu to fully appear, you say \\"Bold\\" to apply bold formatting to the selected text. The Pause function ensures the context menu is ready to receive your next command.","label":"Pause for <strong> {{value}} </strong> milliseconds"},"type":{"title":"Type","field":"Phrase to Type","placeholder":"typed phrase","question":"What text do you want to type?","description":"Write out text like using a keyboard.","longDescription":"This mimics typing a string of text, similar to typing on a keyboard. It\'s ideal for entering longer text without needing to press each key. If you want to dynamically enter text, you can use the Dictation function instead.","example":"Say \\"Name\\" to type \\"Hello, my name is Ellen Ripley.\\" in a chat window.","label":"Type <strong> {{value}} </strong>"},"mouseMove":{"title":"Move the Mouse","description":"Move the pointer on the screen.","longDescription":"Move your screen\'s cursor or pointer without a physical mouse. This is particularly helpful for users with limited hand mobility. This is useful for fine control of mouse movement that is needed in some games. If you want to simulate all mouse movement using your head movement, you can try the \'Head Movement for Mouse Control\' in the camera settings.","example":"Say \\"Move Mouse Right\\" to move the cursor to the right 100px.","moveX":"Mouse Move Left/Right Pixels","numberMoveX":"Number of pixels to Move Left/Right","moveY":"Mouse Move Up/Down Pixels","numberMoveY":"Number of pixels to Move Up/Down","label":"Move the mouse <strong> {{value}} </strong>","command":"Mouse Move: {{command}}"},"joystickMove":{"title":"Move Joysticks","description":"Use a joystick to move things on the screen.","longDescription":"This function simulates the movement of a joystick. For instance, if you have difficulty using a physical joystick, you can use a voice command or another input method to move a joystick virtually.","example":"Say \\"Move Joystick Left\\" to move the joystick to the left 100px.","prefix":"Move the left joystick","left":"Left Joystick","leftX":"Left X","leftY":"Left Y","right":"Right Joystick","rightX":"Right X","rightY":"Right Y","x":"X Axis Strength","y":"Y Axis Strength","moveXLabel":"Move X: {{value}}","moveYLabel":"Move Y: {{value}}","labelLeft":"Move the Left joystick ","labelRight":"Move the Right joystick ","latch":"Latch will hold the position until you release using a \'Stop All\' command."},"playAudio":{"title":"Play Audio","placeholder":"phrase of statement that Cephable will say","description":"Play a sound, word, or phrase.","longDescription":"This function enables users to convert typed phrases into spoken words. It\'s especially useful for individuals who may have difficulty speaking. By typing in a phrase, the PlayAudio feature will articulate the text aloud using synthesized speech. This can assist in communication or in situations where a user needs to relay information verbally but prefers or requires an alternative to using their own voice.","example":"Smile to play the word \\"Hello\\".","label":"Speak <strong>\\"{{value}}\\"</strong>"},"stopOutputs":{"title":"Stop All Outputs","titleLong":"Stop all outputs (release all keys and buttons, stop all mouse movements, stop all typing)","description":"Stop all ongoing actions like key press.","longDescription":"Immediately stop all ongoing outputs or actions. This is a safety or convenience feature to halt any process. We will automatically do this for you when you close, or pause the camera or microphone controls.","example":"Say \\"Stop\\" to stop all outputs.","label":"Stop all outputs and release keys"},"custom":{"title":"Custom"},"options":{"moveUp":"Move Up","moveDown":"Move Down","moveLeft":"Move Left","moveRight":"Move Right","copyStep":"Copy Step","removeStep":"Remove Step"},"directions":{"up":"Up","down":"Down","left":"Left","right":"Right"}},"expression":{"title":"Face Expression","titlePlural":"Face Expressions","label":"Expression / Gesture","description":"Elevate your digital experience with facial expressions. Use gestures like eyebrow raises, smiles, and other movements to seamlessly control your mouse pointer, perform actions, or customize your interactions.","start":"Start Expression Controls","startSmiling":{"title":"Start Smiling","description":"If you start not smiling and then start to smile, this control will trigger. Note: using this control in the same app controls as the Mouth Open / close control may cause conflicts."},"stopSmiling":{"title":"Stop Smilling","description":"If you are smiling and then stop smiling, this control will trigger.  Note: using this control in the same app controls as the Mouth Open / close control may cause conflicts."},"eyebrows":{"title":"Raise Eyebrows","description":"If you raise both your eyebrows from your baseline resting position, this control will trigger."},"openMouth":{"title":"Open Mouth","description":"If your mouth is closed (or if your baseline is slightly open), and you open your mouth more, this control will trigger.  Note: using this control in the same app controls as the smile control may cause conflicts."},"closeMouth":{"title":"Close Mouth","description":"If your mouth is open and you close it entirely, this control will trigger. Note: using this control in the same app controls as the smile control may cause conflicts."}},"head":{"title":"Head Movement","titlePlural":"Head Movements","label":"Head / Body Movement","question":"What type of movement do you want to use?","description":"Control your device or connection with head movements like tilting, nodding, or turning. Using your device\'s camera, Cephable ensures a private and intuitive experience for enhanced control or mouse navigation.","tilt":{"title":"Head Tilt","description":"Tilt your head to the left or right for enhanced control or mouse navigation.","left":{"title":"Tilt Head Left","description":"If you are looking at the camera and tilt your head to your left, this control will trigger."},"right":{"title":"Tilt Head Right","description":"If you are looking at the camera and tilt your head to your right, this control will trigger."},"back":{"title":"Tilt Head Back","description":"If you are looking at the camera and tilt your head back and look up, this control will trigger."},"forward":{"title":"Tilt Head Forward","description":"If you are looking at the camera and tilt your head forward and look down, this control will trigger."}},"turn":{"title":"Head Turn","description":"Turn your head to the left or right for enhanced control or mouse navigation.","left":{"title":"Turn Head Left","description":"If you are looking at the camera and turn your head and look to your left, this control will trigger."},"right":{"title":"Turn Head Right","description":"If you are looking at the camera and turn your head and look to your right, this control will trigger."}},"lean":{"title":"Head Lean","description":"Lean your head to the left or right for enhanced control or mouse navigation.","left":{"title":"Lean Head Left","description":"If you are looking at the camera and lean left so your face is further left in the camera frame, this control will trigger."},"right":{"title":"Lean Head Right","description":"If you are looking at the camera and lean right so your face is further right in the camera frame, this control will trigger."},"back":{"title":"Lean Head Back","description":"If you are looking at the camera and lean back so your face is further from the camera, this control will trigger."},"forward":{"title":"Lean Head Forward","description":"If you are looking at the camera and lean forward so your face is closer to the camera, this control will trigger."},"up":{"title":"Move Body Up","description":"If you are looking at the camera and move your head up by stretching your neck or moving your whole body up, this control will trigger."},"down":{"title":"Move Body Down","description":"If you are looking at the camera and move your head down by scrunching your neck, ducking, or lowering your whole body, this control will trigger."},"center":{"title":"Center your Head","description":"If you are looking at the camera and move your head back to the center position matching baseline, this control will trigger."}}},"voice":{"title":"Voice Control","titlePlural":"Voice Controls","placeholder":"Voice or phrase Cephable will listen for","question":"What statement or phrase do you want to say for this control?","when":"When I say...","say":"Say \'{{value}}\'","description":"Starting the microphone unlocks intelligent and natural voice commands, empowering users to seamlessly interact with their computer across applications and software. Speak naturally to execute commands or dictate text, creating an effortless and intuitive experience.","load":{"fail":{"title":"{{language}} Voice Controls Unavailable","description":"Oh no! We couldn\'t load {{language}} for voice controls. Please check your internet connection and try again. Using English (US) until connection is restored."}}},"hotkey":{"title":"Quick Action Button","titlePlural":"Quick Action Buttons","titlePanel":"Quick Actions","label":"Quick Action Button Display Name","placeholder":"Name to display","question":"What would you like to name this button?","when":"When I tap...","description":"Quick Action Buttons are customizable buttons that you can tap to do relevant actions on your app. A single tap can run multiple steps or a single action.","usagePrompt":"Quick Action Buttons are customizable buttons that you can tap to do relevant actions on your app. You can add, remove, or edit the names from the main app control settings page.","reorder":"You can rearrange the order using the move up and down buttons.","emptySearch":"There are no quick actions matching this criteria.","empty":"It looks like you don\'t currently have any quick actions.","emptyLong":"No quick action buttons are configured in these app controls. Once you add quick action buttons or choose app controls with one, they\'ll appear here.","emptyTitle":"No Quick Action Buttons","edit":"Edit Quick Action Buttons","tap":"Tap {{value}}","copySuffix":"{{name}}_copy","hotkeysOnly":"Custom Buttons","allControls":"All App Controls","show":"Show Quick Action Buttons","deprecatedDialog":{"title":"Your app controls requires an update.","description1":"It looks like you\'re using older app controls with quick action buttons. We\'ve got some exciting updates in\\n            store for you! We\'ve revamped the system to make creating and editing quick action buttons a breeze, no\\n            more diving into advanced settings.","description2":"Just a quick update is all it takes\u2014literally a second\u2014and you\'ll be enjoying the seamless button\\n            customization experience. Say goodbye to the extra steps and hello to a more user-friendly\\n            interface. Ready to make the switch?","confirm":"Let\'s do it!"},"demo":{"title":"Demo Quick Action Buttons","description":"The demo area below will allow you to try quick action buttons. The demo is limited to specifically controlling this text area below.","step1":"Turn On Quick Action Buttons","step2":"Use the example prompts below to control the text block.","command1":"Press button 1 to \u201CMake text larger\u201D","command2":"Press button 2 to \u201Cbold text\u201D","command3":"","continue":"Continue with Quick Action Buttons"},"example":{"title":"Examples of Quick Action Buttons ","description":"These examples showcase the versatility of Quick Action Buttons in controlling your device or connection. They can be used to execute commands, navigate interfaces, or perform actions with a simple tap.","command1":"Tap Pause","example1":"Example \u201Cpause video\u201D","command2":"Tap Forward","example2":"Example \u201Czoom out\u201D","command3":"Tap Stop","example3":"Example \u201Cclose window\u201D"}},"motion":{"title":"Motion Control","titlePlural":"Motion Controls","question":"What type of motion with a phone or tablet do you want to use?","start":"Start Motion Controls","settings":"Motion Settings","descriptionShort":"Tilt, turn, or shake your connection to control Cephable.","description":"Motion controls let you turn your phone or tablet movement in the Companion App into controls for your connection. Tilt or shake your phone in different directions to create new outputs.","up":{"title":"Tilt Your Device Up","description":"If your device is flat on a surface and you tilt it up to face you, this control will trigger."},"down":{"title":"Tilt Your Device Down","description":"If your device is flat on a surface and you tilt it down to face away from you, this control will trigger."},"left":{"title":"Tilt Your Device Left","description":"If your device is flat on a surface and you tilt it left to face toward the left, this control will trigger."},"right":{"title":"Tilt Your Device Right","description":"If your device is flat on a surface and you tilt it right to face toward the right, this control will trigger."},"shake":{"title":"Shake Your Device","description":"If you shake your device, this control will trigger."},"edit":{"title":"Edit Motion Settings","description":"Change your motion control settings to adjust how much you need to move your phone while running to Companion App","sensitivity":{"title":"Motion Control Sensitivity Settings","description":"Sensitivity tells Cephable how far you need to tilt your device in order to trigger a control. The larger the value (furthest right on the slider), the higher the sensitivity is, and therefore the less you need to tilt to trigger the control."},"tilt":{"title":"Tilt Sensitivity","description":"These values determine how far you need to tilt your device up, down, left, and right for an input to be recognized."},"mouse":{"title":"Motion Controls for Mouse Movement","description":"Determine if and how you want to use motion controls for moving your mouse instead of triggering controls","enable":{"title":"Enable Motion Controls for Mouse Movement","description":"If this is turned on, then some of your motion controls will be used to move your mouse instead of trigger controls.","option":"Use Motion Controls for Mouse Movement?"},"invert":{"title":"Invert Mouse Movement","description":"For X-axis: If this is turned on, then moving left will move your mouse right and moving right will move it left. For Y-axis: If this is turned on, then moving down will move your mouse up and moving up will move it down.","x":"Invert X-axis Mouse Movement?","y":"Invert Y-axis Mouse Movement?"}}}},"keys":{"title":"Key or Button","titlePlural":"Keys or Buttons","label":"External Key / Button","question":"What key or button do you want to press?","edit":"Edit Keys and Buttons","defaultOption":"Include default voice commands for keys and mouse clicks?","description":"Keys and buttons allow you to map your different input controls to keyboard and controller button presses.","then":"Cephable will press...","empty":"There are no key controls matching this criteria.","backspace":"Backspace","delete":"Delete","enter":"Enter","space":"Space Bar","tab":"Tab","shift":"Shift","ctrl":"Ctrl","leftCtrl":"Left Ctrl","rightCtrl":"Right Ctrl","leftShift":"Left Shift","rightShift":"Right Shift","alt":"Alt","leftAlt":"Left Alt","escape":"Escape","up":"Up Arrow","down":"Down Arrow","left":"Left Arrow","right":"Right Arrow","command":"Command","caps":"Caps Lock","reset":{"title":"Reset Keybindings","confirm":"Reset all keybindings?","confirmDescription":"Choose how you want to reset the keybindings. This action cannot be undone without saving.","confirmButton":"Reset Keybindings","defaultOption":"Reset to default values for the current language","emptyOption":"Reset to empty (clear all commands)"}},"talkback":{"title":"Talkback","question":"What do you want Cephable to say?","description":"Setup controls that will have Cephable speak for you. You can assign controls to different phrases you want to be spoken.","thenMacro":"then Cephable will say ...","empty":"There are no talkback controls matching this criteria.","deprecatedNotice":"Talkback is now integrated directly into the primary app controls. Your app controls has some older talkback events that need to be updated.","add":"Add a New Talkback Control","remove":"Remove Talkback Control","edit":"Edit Talkback Controls"},"dictation":{"title":"Dictation","question":"What phrase should trigger dictation mode?","description":"Dictation lets you speak naturally and have your words typed while you talk. It\'s like having a personal assistant who types everything you say.","thenMacro":"Cephable will...","empty":"There are no dictation controls matching this criteria.","type":"type","edit":"Edit Dictation Phrases","remove":"Remove Dictation Phrase","add":"Add a New Dictation Phrase","on":"Dictation","off":"Commands","onboarding":{"tourLabel":"Dictation","learn":"Learn how to use dictation mode to convert your speech to text hands-free.","welcome":{"title":"Dictation","description":"Dictation lets you speak naturally and have your words typed while you talk. It\'s like having a personal assistant who types everything you say."},"microphone":{"title":"Turn on Your Microphone","description":"First, turn on your microphone. Click the Microphone Toggle on the Cephable Panel."},"activate":{"title":"Start Dictation Mode","description":"Voice starts in command mode. To start dictation, say \\"Start dictation\\" or click the Dictation button. Lets turn on dictation mode now."},"speaking":{"title":"Click a Document or Field and Start Speaking","description":"Dictation will type out in real-time what you say. Click on a text field or document, then start speaking. For example, say: \\"This is how to use dictation mode.\\""},"pauseResume":{"title":"Pausing Dictation","description":"Need a break without turning off dictation? Just say \\"Pause dictation\\". You can resume anytime with \\"Start dictation.\\" again. You can customize this further with your always on global and device controls."},"stop":{"title":"Stopping Dictation","description":"Need to switch back to your app controls?  Just say \\"Stop dictation\\". This will stop dictation mode and return you to command mode. You can resume anytime with \\"Start dictation.\\" again."},"complete":{"title":"Congrats!","description":"That\'s it! You can now dictate, pause, resume, and swap between dictation and command modes. Dictation is a powerful tool for hands-free typing. Use it to write emails, documents, or anything else you need to type out loud."}}},"suggestedPrompts":{"title":"Suggested Prompts","description":"Customize suggested prompts that appear in AI tasks to help you get started quickly.","edit":"Edit Suggested Prompts","generate":"Generate Text","rewrite":"Rewrite Text","addGenerate":"Add a Generate Prompt","addRewrite":"Add a Rewrite Prompt","remove":"Remove Prompt","generatePlaceholder":"Enter a prompt for text generation...","rewritePlaceholder":"Enter a prompt for text rewriting...","suggested":"Suggested prompts","suggestedFor":"Suggested for {{profileName}}","seeAll":"See all prompts","showLess":"Show less","allPrompts":"All Prompts","customFor":"Custom prompts for {{profileName}}","defaultPrompts":"Default prompts","defaultGenerate":["A professional email introducing our new product","A meeting agenda for next week\'s team discussion","A project proposal outline for a new initiative","A formal business letter template","A technical documentation section","A user manual introduction","A training document overview","A policy document draft","A follow-up email after a meeting","A thank you message to a client","A project status update email","An invitation to a company event","A reminder email for upcoming deadlines","A welcome email for new team members","An apology email for service interruption","A newsletter introduction","A brainstorming list for marketing campaigns","Creative solutions for improving team productivity","Ideas for a company retreat activities","Concepts for a new mobile app feature","Suggestions for improving customer experience","Innovation ideas for our product development","Content ideas for social media posts","Workshop topics for professional development","A function that validates user input","A database query for user management","Error handling code for API requests","A configuration file template","Comments explaining a complex algorithm","Unit test cases for a new feature","Documentation for API endpoints","A script for automated deployment"],"defaultRewrite":["Make this text more concise and to the point","Expand this summary with more detail","Reformat this as a numbered list","Convert this to bullet points","Restructure this into clear paragraphs","Make this text easier to scan quickly","Organize this information hierarchically","Format this as a step-by-step guide","Make this message more professional and formal","Rewrite this to sound more casual and friendly","Adjust the tone to be more encouraging","Make this sound more confident and assertive","Soften the tone to be more diplomatic","Add enthusiasm and energy to this text","Make this more empathetic and understanding","Rewrite with a more collaborative tone","Simplify this for a general audience","Make this explanation more technical and detailed","Break down this complex concept into simpler terms","Add more context and background information","Summarize this into key takeaways","Elaborate on the main points with examples","Make this more accessible to beginners","Condense this while keeping the essential information","Improve the clarity and readability","Make this more engaging and interesting","Adjust for better grammar and flow","Rewrite to emphasize the benefits"]},"face":{"title":"Face Expression","titlePlural":"Face Expressions","try":"Try Face Expression Controls","question":"What type of face expression do you want to use?","descriptionShort":"Use different face movements for enhanced controls.","description":"Face expressions are part of Expression Controls. It lets you use different face movements for enhanced controls. You can use eyebrow movement, mouth movement, and more to create different outputs."},"other":{"title":"Other","titlePlural":"Other Controls","label":"Other Control","placeholder":"other experimental command","question":"What additional command would you like to use? These are typically for non-Cephable connections that don\'t fit into other categories. They may also function as voice commands when you speak the specified word or phrase. Note: These controls are experimental and may not be fully supported.","description":"Other controls are experimental and may not be fully supported. They can be used for non-Cephable connections or as voice commands when you speak the specified word or phrase."},"support":{"title":"Support","question":"Still not finding what you need?","more":"Learn more at Cephable.com with step-by-step guides, tutorials, videos, and more.","profiles":"Introduction to App Controls"},"community":{"title":"Join the Community","description":"Get support, share ideas, or become a member of Cephable\'s communities.","discord":"Discord Community","facebook":"Facebook Group"},"resources":{"title":"Helpful Resources","description":"Find answers to your questions about Cephable features and functions.","guides":"Step by Step Guides"},"feedback":{"title":"Feedback","description":"Tell us about your experience with Cephable.","contact":"Contact Us","feature":"Suggest a Feature","bug":"Report an Issue"},"settings":{"title":"Settings","orgTitle":"{{ value }} Settings","general":"General App Settings","description":"This is your canvas for tailoring-your experience by fine-tuning your controls."},"account":{"title":"Account","menu":"User Menu","settings":"Account Settings","description":"Update key information to stay connected with Cephable.","usernameLabel":"Username: ","emailLabel":"Email: ","delete":{"title":"Delete Account","description":"You can permanently delete your account and remove all reference to your personal information. When you delete your account, your connections will be removed, and will no longer work or be registered to your account, your app controls and all settings will be lost. This process can not be undone.","button":"Permanently Delete Account","confirmation":"Are you sure you want to delete your account?","note":"This action is irreversible.","confirm":"Yes, delete my account"},"password":{"change":"Change Password","description":"Update your password to keep your account secure.","old":"Old Password","current":"Your current password","new":"New Password","desired":"Your desired new password","confirm":"Confirm New Password","update":"Update Password"},"isEmailVerified":{"title":"Email is not verified.","titleAlt":"Verify your email address","description":"Your email is not verified. Please check your email for a verification link.","descriptionLong":"Welcome to Cephable! A verification email has been sent to {{email}}. Please check your inbox or spam folder and click on the link. If you don\'t see it, you can resend the verification email.","org":"Your email is not verified. It is required to access license details. Please check your email for a verification link.","resend":"Resend Email","success":"We have sent you a new verification email.","error":"There was an error sending the verification email. Please try again later.","appBlock":"You\'re almost there! A verification email has been sent to {{email}}. Please check your inbox and click the link to verify your email address. If you don\'t see it, check your spam folder."},"signout":{"title":"Sign Out","description":"Once you sign out, this connection will be removed from your account and no longer be visible from the Companion App or other connections.","question":"Are you sure you want to sign out?","confirm":"Yes, sign out","confirmDescription":"Signing you out and removing this connection","warn":{"title":"You\u2019re about to be signed out.","description":"It looks like you\u2019ve been inactive for a while. For security reasons, we\u2019ll sign you out in XX seconds. If you\u2019d like to stay logged in, click \u201CStay Logged In\u201D below.","confirm":"Stay Logged In","cancel":"Sign Out Now"}},"marketing":{"title":"Email Preferences","description":"Update your email preferences to receive updates and news from Cephable.","marketing":"Marketing Emails","optIn":"I would like to receive tutorials, tips, updates and newsletters to enhance my Cephable experience"},"error":{"save":"Error saving account settings.","password":"Error updating password.","signout":"Error signing out.","old":"Old password is required.","new":"New password is required.","match":"Passwords do not match.","marketing":"Error updating email preferences.","userPreferences":"Error saving user preferences."},"success":{"save":"Account settings saved.","password":"Password updated.","marketing":"Email preferences updated.","userPreferences":"User preferences updated."},"userPreferences":{"title":"User Preferences","description":"Update your preferences to create the Cephable experience that works for you.","warningOptOut":"Hide warnings when I save or update app controls","enableMetrics":"Enable usage metrics output for performance testing. You will be able to download the logs from the Cephable Panel.","enableTranscribeTask":"Enable the experimental file transcriber task in the Cephable Panel","enableGamepadSupport":"Enable gamepad support for local driver and Xbox controller emulation","enableClickByName":"Windows ONLY. Enable experimental \\"Tap\\" something on the screen by name, such as \\"tap save\\" to click a button named \\"save\\""}},"license":{"titlePlural":"Licenses","trial":{"title":{"single":"You\'ve been upgraded to {{productName}} for free with {{days}} Days Remaining","multiple":"{{organization}} is on a Free Trial with {{days}} Days Remaining"},"subtitle":"You can invite {{count}} colleagues to try Cephable with you. ","noUsersSubtitle":"You have no trial users remaining. Upgrade to a paid license to add more users.","upgrade":"By upgrading, maintain your access to features like enhanced voice controls, AI Intelligent Tasks, and many prebuilt app controls.","expired":{"user":"Your free upgrade to {{productName}} expires on {{date}}. To upgrade, please contact your organization administrator - {{admin}}.","userLong":"It looks like your free upgrade to {{productName}} has expired. To upgrade, please contact your organization administrator - {{admin}}.","admin":"Your free upgrade to {{productName}} expires on {{date}}.","adminLong":"It looks like your free upgrade to {{productName}} has expired. You can upgrade your license to continue accessing advanced features not available in Cephable Basic."},"start":"Start a Free Trial"},"key":{"title":"License Key","titlePlural":"License Keys","details":"License Key Details","description":"A License Key is a unique identifier used to grant access to Cephable Professional, Education, or Developer features.","assigned":"Used on: {{date}}","expires":"Expires on: {{date}}","assign":"Assign Key to New Organization","error":"Error loading license key.","empty":{"title":"No License Keys found.","description":"It doesn\'t look like there are license keys matching this criteria. Or you have not purchased a license key yet."},"product":{"title":"Purchase","titleLong":"Purchase License Keys","description":"Purchase a license key to unlock the full potential of Cephable. View the different plans and pricing options available.","action":"Purchase Now","empty":{"title":"No Products Found.","description":"It looks like you don\'t have any products. Please reach out to our sales team or your representative to help resolve this."},"yearly":"Billed yearly","years":"Billed every {{value}} years","days":"Billed every {{value}} days","Subscription":{"title":"Subscription"},"MeteredConsumption":{"title":"Metered Consumption"},"PayDown":{"title":"Pay Down"},"OneTime":{"title":"One Time"}}},"upgrade":{"professional":"Upgrade to Cephable Professional License","generic":{"title":"Upgrade your Cephable Experience","description":"The Cephable Platform offers different products for commercial use at work, school, or integrated into native solutions."},"fallback":{"title":"Error Loading Billing Portal","description":"Unable to load the billing portal. Please click the button below to contact sales@cephable.com to continue with the upgrade."}},"required":{"title":"Cephable Professional License is Required","description":"It looks like you are using Cephable Basic which does not support the commercial use of Cephable. Please upgrade to a professional license to continue using the app."},"activate":{"question":"Already have a license key?","button":"Activate","title":"Activate License Key","description":"Enter your license key to upgrade Cephable.","descriptionLong":"Enter your license key to upgrade Cephable. If you don\'t have one, start a free trial or purchase a license.","fieldLabel":"License Key","placeholder":"NkmurBfZzFrmm9Kx","invalid":{"empty":{"key":"Invalid key. Please make sure you have entered a value.","name":"Invalid Organization Name. Please make sure you have entered a value."},"key":"Invalid key. Please make sure you have entered the correct key."},"success":"Congrats. Your account has been upgraded to {{license}}!"},"welcome":{"title":"Welcome to {{license}}.","description":"You have successfully joined {{organization}}. {{description}}"},"redirect":{"title":"Redirecting","description":"You have been redirected to an external billing portal. This will open a new tab in your browser. If you are not redirected within a few seconds, please click the button below.","error":"Billing Redirect Error","external":"Redirected. Please check your browser."},"pro":{"tag":"Pro","detail":"This is a Cephable Professional only feature","requiredDetail":"A Cephable Professional License is required for this feature. You can upgrade or start a free trial in your Account Settings"}},"publicProfiles":{"toolbar":"Explore App Controls","title":"Explore App Controls","description":{"personal":"Public app controls are available to help you quickly get started with Cephable on your favorite apps. You can use the default controls, customize them to your needs, or create entirely new custom app controls from scratch.","pro":"Public app controls are available to help you quickly get started with Cephable on your favorite apps. You can use the default controls, customize them to your needs, or create entirely new custom app controls through the control generator."},"offline":{"title":"Unable to Load Public App Controls","description":"It looks like you are offline. You can still use your app controls, but you will not be able to load new public app controls.","confirm":"Okay"},"announcement":"{{count}} New App Controls have been loaded","team":"Cephable Team"},"device":{"title":"Connection","titlePlural":"Connections","titleShort":"Connect","titleLong":"Connections & Extensions","description":"Cephable supports multiple devices and connections. You can manage settings or select any of them all from here. You will always have this computer as your main connection. You can add more connections later.","viewAll":"View All Connections","new":"You have a new connection!","newLong":"You have a new connection! To start using it, select it from the menu below.","add":{"short":"Extend","title":"Add a New Connection or Extension","description":"Connections and extensions are additional ways you can enhance your Cephable experience. You can add new connections to connect to more devices, applications, or games. Take your Cephable experience to the next level by adding connections and extensions.","action":"Add a New Connection","notAvailable":"This connection or extension is not currently available to the public. This often occurs when working with user generated extensions. Please check back later.","isNotPublic":"PREVIEW: This extension is in developer preview and may be incomplete. Developers should complete all steps before public release. Users can check back later for the full version."},"swap":{"titlePlural":"Swap Connections"},"status":{"title":"Connection Status: ","connected":{"application":"Connected Application","connection":"Connected","device":"Connected Device","game":"Connected Game"},"disconnected":{"application":"Disconnected Application","connection":"Disconnected","device":"Disconnected Device","game":"Disconnected Game"}},"control":{"button":"Control {{name}}","generic":"Control Connection","description":{"application":"Control this connected application using your voice, quick actions, head movements, and more. For instance, if you say \'Save\' this will save on your running application.","connection":"Control this connected connection using your voice, quick actions, head movements, and more. For instance, if you say \'Save\' this will save on your running connection.","device":"Control this connected device using your voice, quick actions, head movements, and more. For instance, if you say \'Open Spotify\' this will open Spotify on running device.","game":"Control this connected game using your voice, quick actions, head movements, and more. For instance, if you say \'Go\' this will make the player move in running game."}},"running":"Running","offline":"Offline","otherDevices":"Other Output Connections","currentStatus":"Current Status: ","connectionStatus":"Connection Status: ","profileStatus":"Current App Controls: ","name":{"title":"Connection Name","question":"What do you want to call this connection?","description":"Give your connection a name so you can easily find it later.","placeholder":"connection name","edit":"Edit Connection Name"},"updates":{"title":"Connection Updates","settings":"Connection Update Settings","description":"Check for connection firmware updates and change auto-update settings","edit":"Edit Update Settings","check":{"title":"Check for Updates","processing":"Checking for updates! It may take a few minutes and your connection may restart during updates.","description":"Tap to check for updates for your connection. If there is an update available and your connection is active, it will start updating. Updates can take a few minutes."},"auto":{"title":"Automatically Update","description":"With this setting turned on, your connection will automatically update whenever it is plugged in, connected to wi-fi, and an update is available. If this is off, you need to tap the update button to get the latest.","option":"Use Auto-Update?"}},"delete":{"title":"Unlink {{name}}","titleLong":"Unlink From Account","description":"Unlinking disconnects Cephable from this computer or game and removes it from your account. You will no longer be able to connect to it, send commands, or update it. This can not be undone but you can create a new connection to the same computer or game if you want to use it again in the future.","confirm":"Are you sure you want to unlink this connection?","confirmLong":"Are you sure you want to deregister and reset this connection? You will no longer be able to connect to it, send commands, or update it. After this de-register and reset, anyone else can setup this connection from scratch.","confirmButton":"Yes, remove this connection."},"manage":{"title":"Click to view and manage details for your connections.","description":"","name":"Customize your connection name for easier management."},"error":{"save":"Error saving connection.","load":"Error loading connection.","add":"Error adding connection.","delete":"Error deleting connection.","updates":"Error checking for updates.","connection":"Connection is not established. Make sure it is connected before trying again.","deleteLong":"We were unable to delete this connection from your account. If you log in again to this account, you may need to manually delete this connection in the connection settings."},"success":{"save":"Connection saved.","add":"Connection added.","delete":"Connection deleted."}},"appSettings":{"title":"General App Settings","description":"These settings only apply to this app. If you want to change the settings of the Cephable app on another computer or mobile device, edit the settings in that app.","autostart":{"title":"Automatically Start Cephable","description":"With this setting turned on, the Cephable app will automatically start when you log in to your device. If you also have automatic voice and expression controls, those will also start right away.","question":"Autostart Cephable App?"},"overlay":{"title":"Command Feed","description":"The command feed will show the different controls you use and what controls were sent to your computer. It is click-through but will always be on top of other windows. With this setting turned on, the Cephable app will show and will always be on top of other windows and applications.","question":"Show Command Feed?"},"position":{"label":"Select Command Feed Position","description":"Select where you want the command feed to appear on your screen.","topLeft":"Top Left","top":"Top Center","topRight":"Top Right","bottom":"Bottom Center","bottomLeft":"Bottom Left","bottomRight":"Bottom Right"},"panelAutoHide":{"title":"Auto-Hide Cephable Panel","delay":"Delay before hiding","denominator":" seconds","time":"{{value}} seconds"},"transparent":{"title":"Command Feed Transparency","description":"The determines the opacity of the text. The lower the value, the more see-through the feed will be."},"micPosition":{"title":"Microphone Input Window Position","description":"Select where you want the microphone controls for voice and dictation to be positioned on your screen.","label":"Select Microphone Input Window Position"},"cameraPosition":{"title":"Camera Input Window Position","description":"Select where you want the camera controls for face and head movement to be positioned on your screen.","label":"Select Camera Input Window Position"},"theme":{"title":"Theme","description":"Choose a theme that suits your style.","label":"Select a Theme","light":"Light","dark":"Dark","system":"Use OS System settings"}},"shortcuts":{"title":"Global Shortcuts","description":"Customize keyboard shortcuts for quick access to Cephable controls from anywhere on your system.","info":"These shortcuts work globally and can be used even when Cephable is not the active window.","shortcut":"Shortcut","toggleMicrophone":"Toggle Microphone","toggleDictation":"Toggle Dictation Mode","toggleVoiceControl":"Toggle Voice Control Mode","togglePanel":"Toggle Panel","registrationFailed":"Some global shortcuts failed to register. They may be in use by another application:","record":{"title":"Record Shortcut","start":"Click to Record","listening":"Press your desired key combination...","pressKeys":"Press keys now"},"formatHint":"Select at least one modifier key ({{modifierKey}}, {{modifierKey2}}, Shift) and one other key."},"input":{"title":"Input","titlePlural":"Input Controls","explore":"Explore Input Controls","descriptionShort":"Explore the various input controls Cephable utilizes to create a better digital experience for you.","description":"Input controls are the different methods used to control your device. Such as your voice, head movement, face expressions, and additional connections. Explore the different input controls below to learn more.","typeLabel":"Input Control Type","toolTip":"This uses {{alt}}","remove":"Remove Input Control","filter":"Filter by Input Type","select":"Select an Input","question":"What type of input do you want to use?","add":"Add Input","addMore":"Add another input","removeItem":"Remove item {{index}}","item":"Item {{index}}: {{label}}","duplicate":"Duplicate items are not allowed.","maximum":"Maximum of {{maxItems}} items allowed."},"time":{"soon":"Coming Soon","now":"Now","today":"Today","yesterday":"Yesterday","minutesAgo":"{{count}} minute ago","minutesAgo_plural":"{{count}} minutes ago","daysAgo":"{{count}} days ago","daysAgo_plural":"{{count}} days ago","monthsAgo":"{{count}} month ago","monthsAgo_plural":"{{count}} months ago","yearsAgo":"{{count}} year ago","yearsAgo_plural":"{{count}} years ago","minutesAhead":"in {{count}} minutes","todayAhead":"later today","tomorrow":"tomorrow","daysAhead":"in {{count}} days","monthsAhead":"in {{count}} months","yearsAhead":"in {{count}} years"},"peripherals":{"empty":"No Peripherals Detected","switch":"Switch","keyboard":"Keyboard","gamepad":"Gamepad","companionApp":"Companion App","available":"Available to use","error":"Check your settings."},"textGeneration":{"settings":"Text Generation Settings","edit":{"title":"Edit Text Generation Settings","description":"Cephable\'s intelligent text generation feature allows you to use the \\"generate\\" device control to create text in any app. You can generate emails, paragraphs, messages, code, and more. It will generate the text wherever your cursor is as if you were typing it yourself. This feature uses on-device generative AI, which means your content never leaves your machine but that you should check content for accuracy. Use these settings to edit your preferences for how Cephable loads AI models on your device and how it generates text for you.","autoStart":{"title":"Automatically Warm Up Text Generation","description":"With this setting turned on, Cephable AI will automatically warm up the AI models used for text generation. Warming up the models will make them perform faster when you use generate commands, but will consume more resources on your computer. Turning this setting off will save resources, but may make text generation slower.","option":"Auto warm up text-generation AI models?"},"enableTextGen":{"title":"Enable Intelligent Text Generation","description":"With this setting turned on, Cephable AI will can use the text generation device control to generate text in any app for you. Turning this off will disable this command.","option":"Use Intelligent Text Generation?"},"enableHistory":{"title":"Enable Text Generation History","description":"With this setting turned on, Cephable AI will use your text generation history to generate text with context of your previous action.","option":"Use Text Generaton History?"},"prompt":{"title":"Additional Information for Text Generation","description":"Enter additional details to be used with Cephable\'s AI to generate text. Use this field to enter preferences for your tone, style of writing, or any other details.","field":"Additional prompt","placeholder":"e.g. Use a friendly tone, write like a professional, be succint and to the point. When writing code, leave thoughtful comments but not too many, etc."},"terminate":{"title":"Clear Text Generation Resources","description":"Click to clear the resources used for text generation. This will free up resources on your computer, but may make text generation slower the next time you use it.","button":"Clear Resources","success":"Clearing text generation resources.","confirm":{"title":"Clear Text Generation Resources","description":"Are you sure you want to clear the resources used for text generation? This will free up resources on your computer, but may make text generation slower the next time you use it.","confirm":"Yes, clear resources","cancel":"Cancel"}},"clearModelCache":{"title":"Clear AI Model Cache","description":"Select which AI model cache to clear and re-download. This will free up storage on your computer and re-download the selected model files.","button":"Clear and Re-download","success":"Deleted local model files.","error":"Error deleting local model files.","confirm":{"title":"Clear and Re-download AI Model Cache","description":"Are you sure you want to clear the selected AI model cache and delete the files from your system? The selected models will be re-downloaded automatically.","confirm":"Yes, clear and re-download","cancel":"Cancel","textGenLabel":"Intelligent Tasks model","workflowsLabel":"AI Workflows models"}}},"prompt":{"systemPrompt":"Generate ONLY the requested text\u2014no explanations, commentary, or fluff. No unprompted markdown or explanation. For code, output raw code only: no fences, no language tags, no explanation.","appName":"You are currently generating text for {{appName}}.","userPreferences":"Respect these user preferences for how they want text generated: {{userPreferences}}."},"summarizePrompt":{"systemPrompt":"Summarize the provided text concisely. It may be part of a larger document. Output ONLY the summary\u2014no preamble, labels, or explanation.","userPreferences":"Respect these user preferences for how they want text generated: {{userPreferences}}.","userPrompt":"Summarize: {{userRequestText}}"},"rewritePrompt":{"systemPrompt":"Rewrite or reformat the provided text as instructed. If reformatting (e.g. lists, tables, structure changes), preserve the original words exactly. If rewriting (e.g. tone, style, length), preserve the meaning but not necessarily the words. Output ONLY the result\u2014no explanations or commentary. This may be part of a larger document. Output only the result with no headings, labels, or preamble.","userPreferences":"Respect these user preferences for how they want text generated: {{userPreferences}}.","rewriteInstructions":"Instructions: {{rewriteInstructions}}."},"translatePrompt":{"systemPrompt":"Translate the following text into {{language}}. Output ONLY the translated text. No explanations, no preamble, no markdown formatting, no code fences. Retain formatting. For code: translate comments and strings only, preserve syntax exactly.","userPreferences":"Respect these user preferences for how they want text generated: {{userPreferences}}.","genericUserPrompt":"Translate: {{userRequestText}}"},"disabled":{"title":"Intelligent Tasks is Disabled","description":"It looks like you have disabled intelligent tasks. Update to unlock text generation, rewriting, and more in your settings."}},"aiWorkflows":{"settings":{"title":"AI Workflows Settings","description":"Configure the AI models and devices used for AI Workflows. AI Workflows allow you to automate desktop and browser tasks using on-device AI.","configType":{"title":"Model Configuration Type","description":"Select the type of model configuration to use for AI Workflows. Different configurations are optimized for different models.","label":"Configuration Type"},"reasoningModel":{"title":"Reasoning Model","description":"Select the AI model to use for reasoning and planning tasks. The reasoning model analyzes your requests and creates action plans.","label":"Reasoning Model"},"reasoningDevice":{"label":"Reasoning Device"},"generationModel":{"title":"Generation Model","description":"Select the AI model to use for text generation tasks. The generation model creates text content when needed by workflows.","label":"Generation Model"},"generationDevice":{"label":"Generation Device"},"noModelsFound":"No models found","autoWarm":{"title":"Auto-Start AI Workflows","description":"Automatically initialize AI Workflow models when the app starts. Models will be pre-loaded so workflows can start immediately.","option":"Auto-start AI Workflow models on app launch"},"prompt":{"title":"Additional Information for AI Workflows","description":"Enter additional details to be used with Cephable\'s AI when running workflows. Use this field to enter preferences for your tone, behavior, or any other details.","field":"Additional prompt","placeholder":"e.g. Always confirm before sending emails. Prefer concise responses. Use formal language in documents."},"terminate":{"title":"Clear Workflow Resources","description":"Click to terminate the workflow worker and free up resources. This will stop any running workflow and release memory used by the AI models.","button":"Terminate Workflow Worker","success":"Workflow worker terminated.","confirm":{"title":"Terminate Workflow Worker","description":"Are you sure you want to terminate the workflow worker? This will stop any running workflow and free up resources.","confirm":"Yes, terminate"}},"disableButtonNames":{"edit":"Block Button Interactions","description":"Control which buttons AI Workflows are allowed to interact with. By default, Cephable can click any button on your screen. Use this setting to prevent accidental actions (for example, \\"buy\\", \\"delete\\").","input":{"label":"Button Name","question":"Which buttons would you like to block? You can enter full or partial button names.","remove":"Remove Button Name"},"button":"Block Buttons"}}},"camera":{"windowTitle":"Cephable Camera Controls","title":"Camera","titlePlural":"Cameras","settings":"Camera Settings","start":"Start Camera","stop":"Stop Camera","restart":"Restart Camera","show":"Show Camera","hide":"Hide Camera","descriptionShort":"Enables face expression and head movement.","description":"Use your camera to detect face expressions and body gestures as different controls.","select":"Select a camera you want to pair with for enhanced controls using your face and body.","empty":"No cameras found.","search":"Search by camera name","loading":"Loading Camera Controls...","error":"Unexpected error loading camera controls. Please check your camera and try again.","manage":{"title":"Click to view and manage details for your cameras.","description":""},"warn":"Camera controls have not been started, start your camera to allow face and body controls.","detected":{"face":"Face Detected.","noFace":"No Face Detected. Please adjust your camera or position and try again.","command":"Detected: {{command}}"},"permission":{"title":"Camera Permissions Required","description":"You need to give Cephable permission to use your camera to use face and body controls.","button":"Open Permission Settings","no":"No camera access","help":"Cephable needs access to your camera to use expression and head controls. Navigate to <strong>System Settings</strong> > <strong>Privacy</strong> > <strong>Camera</strong> and enable Cephable to access your camera."},"controls":{"startData":"Started recording face data. Press the shortcut again while in camera window to stop recording and download.","downloadData":"Stopped recording, downloading data","paused":"Paused camera controls.","pause":"Pause Camera Controls","resume":"Resume Camera Controls","resumed":"Resumed camera controls.","linesOn":"Turn face lines on","linesOff":"Turn face lines off","lines":"Face Lines","linesToggle":"Toggle draw face lines","noDeviceTitle":"No camera detected that can be used with Cephable.","noDeviceDescription":"You need to connect a camera that is compatible mobile apps.","noDeviceConnectedDescription":"The camera control serves as a preview of the interface. No steps will be successfully executed. Connect this companion device to another, in order to initiate commands."},"draw":{"error":"Error loading camera feed. Please check your camera and try again."},"switch":{"title":"Switch Camera","description":"Select a different camera to use for face and body controls.","select":"Select Camera","next":"Next Camera","nextLong":"Switch to the next camera","empty":"No other cameras found.","search":"Search by camera name"},"baseline":{"title":"Baseline","description":"The baseline is the default position of your face and body that Cephable uses to determine your movements. You can update and reset the baseline here.","update":"Update Baseline","reset":"Reset Baseline","updated":"Baseline Updated","tooltip":"Click to update your baseline to your current resting position."},"edit":{"title":"Edit Camera Settings","description":"You can refine the settings for your inputs that require a camera to better suit your needs.","autoStart":{"title":"Automatically Start Camera","description":"With this setting turned on, your controller will start your camera enabling you to use face expressions and head movement controls right when the app starts. If this is off, you need to tap the \\"Start Camera\\" button in your connection page.","option":"Autostart Camera and Head/Expression Controls?"},"head":{"title":"Head Movement Sensitivity","description":"Sensitivity tells Cephable how far you need to move in order to trigger a control. The larger the value (furthest right on the slider), the higher the sensitivity is, and therefore the less you need to move to trigger the control.","tilt":{"title":"Head Tilt Sensitivity","description":"These values determine how far you need to tilt your head up, down, left, and right to trigger controls","up":"Tilt Up Sensitivity","down":"Tilt Down Sensitivity","left":"Tilt Left Sensitivity","right":"Tilt Right Sensitivity","scaleHigh":"Slight Tilt","scaleLow":"Large Tilt"},"turn":{"title":"Head Turn Sensitivity","description":"These values determine how far you need to turn your head left and right to trigger controls","left":"Turn Left Sensitivity","right":"Turn Right Sensitivity","scaleHigh":"Slight Turn","scaleLow":"Large Turn"},"lean":{"title":"Head Lean Sensitivity","description":"These values determine how far you need to lean your head forward and back to trigger controls","forward":"Lean Forward Sensitivity","back":"Lean Back Sensitivity","right":"Lean Right Sensitivity","left":"Lean Left Sensitivity","scaleHigh":"Slight Lean","scaleLow":"Large Lean"},"duck":{"title":"Head Duck/Rise Sensitivity","description":"These values determine how far you need to duck or rise your head to trigger controls","down":"Duck Down Sensitivity","up":"Rise Up Sensitivity","scaleHigh":"Slight Shift","scaleLow":"Large Shift"}},"face":{"title":"Face Expression Sensitivity","description":"Sensitivity tells Cephable how exaggerated of an expression you need to trigger a control. The larger the value (furthest right on the slider), the higher the sensitivity is, and therefore the less you need to move to trigger the control.","eyebrow":{"title":"Eyebrow Sensitivity","description":"These values determine how far you need to raise or lower your eyebrows to trigger controls","up":"Raise Eyebrow Sensitivity","scaleHigh":"Slight Raise","scaleLow":"Large Raise"},"mouth":{"title":"Mouth Sensitivity","description":"These values determine how far you need to open or close your mouth to trigger controls","open":"Open Mouth Sensitivity","close":"Close Mouth Sensitivity","smile":"Smile Sensitivity","scaleHigh":"Slight Open","scaleLow":"Large Open","closeScaleHigh":"Slight Closed","closeScaleLow":"Tightly Closed","smileScaleHigh":"Slight Smile","smileScaleLow":"Large Smile"}},"mouse":{"title":"Head Movement for Mouse Controls","disabled":"This feature is disabled for remote connections and extensions.","description":"Determine if and how you want to use head movements controls to move your mouse instead of triggering other outputs.","enable":{"title":"Enable Head Movement for Mouse Controls","description":"If this is turned on, then some of your head movement controls will be used to move your mouse instead of trigger controls.","option":"Use Head Controls for Mouse Movement?"},"input":{"title":"Mouse Input Type","description":"Select which type of head gestures you want to assign to mouse controls. For example, Head Tilting means you can tilt your head left and right to move your mouse left and right, Head Turning means you can turn your head left and right to move your mouse, and Head Leaning means you can lean left and right to move your mouse.","option":"Select Input Type","optionLong":"Select the type of head movement you want to use to control your mouse."},"invert":{"title":"Invert Mouse Movement","description":"If this is turned on, then the direction you move your head will be inverted from the direction your mouse moves. For X-axis: If this is turned on, then moving left will move your mouse right and moving right will move it left. For Y-axis: If this is turned on, then moving down will move your mouse up and moving up will move it down.","x":"Invert X-axis Mouse Movement?","y":"Invert Y-axis Mouse Movement?"},"mode":{"title":"Mouse Move Mode","description":"Select how you want the cursor to react to your head movements."},"speed":{"title":"Mouse Speed","description":"Determine the constant speed you want the cursor move.","fast":"Fast","slow":"Slow"},"linear":{"title":"Linear Mouse Movement","description":"If this is turned on, the cursor only moves in straight horizontal or vertical lines, making it easier to navigate in those specific directions without any diagonal drift.","option":"Use Linear Mouse Movement?"},"accelerationRate":{"title":"Mouse Acceleration Response Delay","description":"The number of milliseconds it takes for the mouse speed to increase."},"accelerationCurve":{"title":"Mouse Acceleration Curve","description":"Adjust the rate at which the cursor speed increases relative to head movement. ","linear":"Linear","exponential":"Exponential","sublinear":"Sub-linear"},"maximumSpeed":{"title":"Maximum Mouse Speed","description":"Determine maximum number of pixels the cursor can move per second."},"off":{"title":"Off","description":"Mouse movement is disabled."},"steadyGlide":{"title":"Steady Glide","description":"When you move your head past a certain point, the cursor glides continuously in that direction at a steady speed."},"speedBoost":{"title":"Speed Boost","description":"The cursor starts to move faster the longer you keep your head in one position. The longer you hold your head still, the quicker the cursor accelerates."},"dynamicGlide":{"title":"Dynamic Glide","description":"The cursor\'s speed increases based on how far you move your head. The further you move your head, the faster the cursor glides."},"proportionalSpeed":{"title":"Proportional Speed","description":"The cursor follows your nose tip proportional to your screen dimensions."}}}},"microphone":{"windowTitle":"Cephable Voice Controls","title":"Microphone","titlePlural":"Microphones","settings":"Microphone Settings","start":"Start Microphone","startDescription":"Turn on the microphone to start listening to commands.","stop":"Stop Microphone","descriptionShort":"Enables voice commands and dictation.","description":"Use your built in microphone to enable voice controls and dictation.","select":"Select a microphone you want to pair with for enhanced controls using your voice.","empty":"No microphones found.","search":"Search by microphone name","manage":{"title":"Click to view and manage details for your microphones.","description":""},"warn":"You microphone has not been started. Start the microphone to allow voice commands and dictation.","permission":{"title":"Microphone Permissions Required","description":"You need to give Cephable permission to use your microphone to use voice controls.","button":"Open Permission Settings","no":"No microphone access","help":"Cephable needs access to your microphone to use voice controls. Navigate to <strong>System Settings</strong> > <strong>Privacy</strong> > <strong>Microphone</strong> and enable Cephable to access your microphone."},"controls":{"loadingDetail":"This may take a few minutes.","generatingTextDetail":"Stop generation by changing apps or saying \'stop generating\'","pause":"Pause Voice Controls","paused":"Paused controls.","resume":"Resume Voice Controls","dictationPlay":"Start Dictation Mode","dictationPause":"Stop Dictation Mode","prompt":"Start speaking to see your voice controls here...","dictationPrompt":"Start speaking to type what you say...","latency":"High latency detected. Consider closing some applications that might be consuming too many resources.","noDeviceConnectedDescription":"The microphone control serves as a preview of the interface. No steps will be successfully executed. Connect this companion device to another, in order to initiate commands.","status":{"loadingModel":"Loading Voice Model...","loadingPhiModel":"Loading Text Generation Model...","preparingPhiModel":"Preparing Text Generation Model...","generatingText":"Generating...","thinking":"Thinking...","paused":"Paused.","dictating":"Dictating.","optimistic":"Optimistic:","listening":"Listening:","permission":"Checking microphone permissions...","typing":"Typing..."}},"edit":{"title":"Edit Microphone Settings","description":"Manage your voice commands and dictation settings for this connection.","autoStart":{"title":"Automatically Start Microphone","description":"With this setting turned on, your input device will turn on the microphones and start processing voice controls once it starts up after you plug it in or turn it on. If this is off, you need to tap the Start Listening button in your connection page.","option":"Autostart Microphone and Voice Controls?"},"optimistic":{"title":"Optimistic Voice Controls","description":"Cephable has two different sensitivity modes for voice controls - Standard and Optimistic. Standard mode allows Cephable to recognize all words in its understanding and can be used with dictation mode. Optimistic mode tells Cephable to focus more on the voice controls in your given app controls. With Optimistic mode on, your voice controls will trigger faster but you can also accidentally trigger your control if you don\'t say the exact word. Optimistic mode does not allow for dictation.","option":"Use Optimistic Voice Controls?"},"aiCommands":{"title":"Intelligent Voice Commands","description":"Intelligent voice commands allow Cephable AI to predict voice commands you are trying to use without needing to exactly match. It allows you to more naturally tell your computer what to do and Cephable helps figure it out.","option":"Use Intelligent Voice Commands?"},"aiDictation":{"title":"Intelligent Dictation and Quick Type","description":"Intelligent Dictation and Quick Type deliver the most accurate on-device input experience available. Dictation handles punctuation, proper nouns, and sentence structure automatically, while Quick Type provides smart predictions and corrections that help you write with ease and accuracy.","option":"Use Intelligent Dictation and Quick Type?"},"confirm":{"title":"You have unsaved changes.","description":"Detected unsaved changes. Would you like to save before exiting?"}},"devices":{"error":"Microphone Input Device Not Found."}},"localization":{"title":"Language Settings","titleShort":"Language","select":"Select Language","description":"Choose your preferred language from a list of supported languages.","newUserDescription":"Please select a preferred language before continuing.","edit":"Update Language","profile":{"view":"Variants","title":"App Control Language","question":"What app control language would you like to edit?","description":"Some app controls have variants for different languages. Swap to another language to edit and personalize.","change":"Change Language"},"display":{"title":"Display Language","description":"Language that is displayed when using Cephable. This includes things like menus, notifications, and app controls being displayed in the language of your choice.."},"voice":{"title":"Voice Control Language","description":"This is the language that is used when recognizing dictation and voice commands. Specifying the language enhances the accuracy of your voice inputs.","settings":{"title":"Voice Recognition and Display Language","description":"Adjust your language settings for both display and voice controls. This option allows you to select your preferred languages for on-screen text and microphone interactions like voice controls and dictation."}},"unsupported":{"title":"Unsupported Language {{locale}}","description":"The selected language is not supported. Please choose a different language."},"locales":{"en":"English","en-us":"English (US)","en-gb":"English (UK)","en-in":"English (India)","es":"Espa\xf1ol \u2014 Spanish","fr":"Fran\xe7ais \u2014 French","it":"Italiano \u2014 Italian","de":"Deutsch \u2014 German","ja":"\u65E5\u672C\u8A9E \u2014 Japanese"},"localesShort":{"en":"English","en-us":"English (US)","es":"Spanish","fr":"French","it":"Italian","de":"German","ja":"Japanese"},"save":{"success":"User locale preferences saved!","error":"Error saving user locale preferences"}},"editor":{"title":"Markdown Editor","bold":"Bold","italic":"Italic","underline":"Underline","strikethrough":"Strikethrough","hr":"Horizontal Rule","link":"Link","quote":"Quote","code":"Code","codeBlock":"Code Block","comment":"Comment","image":"Image","table":"Table","unordered-list":"Unordered List","ordered-list":"Ordered List","checked-list":"Checked List","help":"Help","edit":"Edit","live":"Live","preview":"Preview","fullscreen":"Fullscreen","placeholder":"Please enter Markdown text here..."},"panel":{"title":"Cephable Panel","titleShort":"Panel","description":"This is the panel which is the main control center. It is always visible and allows you to control your apps using your voice, and more.","question":"Autostart Panel?","position":{"top":"Top","right":"Right","left":"Left","bottom":"Bottom ","description":"Select where you want the Cephable Panel to appear on your screen.","label":"Position"},"sections":{"description":"Choose what sections in the panel are visible. You can hide sections based on your preferences to make the most of the panel space.","microphone":"Microphone and Voice Controls","camera":"Camera and Face/Head Controls","buttons":"Quick Action Buttons","tasks":"Intelligent Tasks","profile":"App Controls and Previews","globalControls":"Global and Device Controls"}},"smartTasks":{"title":"Intelligent Tasks","show":"Show Intelligent Tasks","description":"Intelligent tasks are the different tasks that Cephable\'s AI can perform for you. These tasks are powered by on-device AI and can be used to create text, summarize, rewrite, translate and more.","clearCache":"If you see issues with generating, please clear your cache and resources from Text Generation Settings and try again.","networkError":"Connection lost while downloading the model. Please check your internet connection and try again by submitting a prompt or restarting the app.","genericError":"An unexpected error occurred. Please try again.","generatedByAI":"Powered by on-device AI, please review for accuracy.","highlightText":{"title":"Use highlighted text","description":"Cephable can automatically use the text you have highlighted in any app to perform tasks like summarizing, rewriting, or translating. You can also enter text manually if you prefer.","label":"Enter text to use","placeholder":"You can also highlight text in another app and come back here to use it."},"pasteText":{"title":"Paste text","description":"Cephable can automatically use the text you have copied to your clipboard to perform tasks like summarizing, rewriting, or translating. You can also enter text manually if you prefer.","label":"Enter text to use","placeholder":"You can also highlight text in another app and come back here to use it."},"generateText":{"title":"Generate Text","description":"Create text content based on your input or prompts.","label":"Describe what you want to generate"},"summarizeText":{"title":"Summarize Text","titleShort":"Summarize","write":"Write Summary","description":"Condense lengthy text into a concise summary.","directions":"Enter the text to summarize, or Cephable will automatically use whatever text you have highlighted.","label":"Enter text to summarize","outputLabel":"Your summary will write here."},"rewriteText":{"title":"Rewrite Text","description":"Highlight text in another app where you are writing and then come back here and describe how you want it to be re-written.","label":"Describe how you want to rewrite the text","inputLabel":"Enter text to rewrite"},"translateText":{"title":"Translate Text","description":"Enter the text to translate, or Cephable will automatically use whatever text you have highlighted.","label":"Enter text to translate","languageLabel":"Language to translate to"},"transcribeAudio":{"title":"Transcribe Audio","description":"Convert audio or video files to text using AI transcription.","inputMethod":"Choose input method","localFile":"Local File","url":"URL","selectFile":"Select Audio/Video File","urlLabel":"Audio/Video URL","transcribe":"Transcribe","result":"Transcription Result","invalidFileType":"Please select a valid audio or video file (mp3, wav, ogg, mp4, webm, mov, avi)","error":"Transcription error","history":{"title":"Transcription History","description":"View and manage your saved transcriptions.","viewHistory":"View History","empty":"No transcriptions yet. Start transcribing to build your history!","titleLabel":"Title (optional)","titlePlaceholder":"Enter a title for this transcription","textLabel":"Transcription Text","confirmDelete":"Are you sure you want to delete this transcription?"}},"noteTaker":{"title":"Note Taker","description":"Let Cephable locally record and transcribe your meetings or conversations"},"documentChat":{"title":"Document Chat","description":"Interact with and query documents for quick insights."},"download":{"title":"Download AI Models to Unlock More Capabilities","description":"To use Intelligent tasks, a local model needs to be downloaded to your device. This ensures your data stays private and is never sent to the cloud.","confirm":"Download","cancel":"Not now","includeWorkflows":"Also download AI Workflow models for advanced automation."},"aiWorkflows":{"title":"AI Workflows","description":"Automate your desktop and browser tasks with AI. Simply describe what you want to accomplish, and watch Cephable execute the actions for you.","introModal":{"title":"Your AI Workflows Are Ready","description":"I can now automate your desktop and browser tasks \u2014 just tell me what you want done, and I\'ll handle the steps. I run privately on your device, so your data stays yours. To get started, I need to download a local AI model. Download it now so I can be ready, or I\'ll grab it when you kick off your first workflow.","confirm":"Download Now","cancel":"Skip for Now"},"label":"What can I help you do?","start":"Start","progress":"Working...","ready":{"waiting":"AI Workflows is ready. Waiting for your instructions.","execute":"AI Workflows is ready. Starting on your request..."},"status":{"idle":"Waiting for your instructions...","initializing":"Getting things ready...","planning":["Making a plan...","Breaking down your request...","Mapping out the steps...","Organizing the workflow...","Preparing the strategy...","Creating a plan of action...","Figuring out the best way to help you...","Determining how to approach this...","Analyzing your request...","Planning the execution..."],"thinking":["Thinking...","Analyzing your request...","Figuring out the best way to help you...","Determining what to do next...","Processing the previous steps...","Working on your request...","Fetching details...","Reviewing the plan...","Considering the options...","Creating, Evaluating, Deciding..."],"thinkingInteractive":["Considering the next step...","Reviewing what we\'ve done so far...","Deciding what to do next...","Analyzing the results...","Planning the continuation...","Evaluating the options...","Figuring out the best next step...","Working on the next part of your request...","Working on the next steps...","Processing the previous step\'s results..."],"waitingForUser":"Your input is needed to continue.","completed":"Success!","failed":"Your request failed: {{message}}","networkError":"Connection lost while downloading the model. Please check your internet connection and try again by submitting a prompt or restarting the app.","canceled":"Your request was canceled.","terminated":"Stopped. Waiting for your instructions...","executing-org-block":"Cannot {{params.toolName}} because interacting with {{params.appOrDomain}} is blocked by the organization.","executing-destructive-block":"Interacting with {{params.elementName}} is blocked. Please review and perform this action manually.","executing-type-focus-block":"I had an issue writing the content. It is copied to your clipboard, please paste it manually.","tools":{"click_element_by_index":{"executing-start":"Clicking the relevant button...","executing-complete":"I clicked {{params.index}}."},"click_element":{"executing-start":"Clicking the highlighted number...","executing-complete":"I clicked {{params.elementName}}."},"copy_selection":{"executing-start":"Gathering context...","executing-complete":"I have context, ready for the next part of your request."},"create_file":{"executing-start":"Creating a file...","executing-complete":"I created a file named {{params.fileName}}."},"draft_email":{"executing-start":"Drafting an email...","executing-complete":"I drafted an email about {{params.subject}}."},"execute_app_action":{"executing-start":"Running {{params.actionName}}...","executing-complete":"{{params.actionName}} completed."},"find_all_text":{"executing-start":"Searching for all relevant context about {{params.searchText}}...","executing-complete":"I found all relevant context about {{params.searchText}}."},"find_and_select_text":{"executing-start":"Searching and selecting relevant context about {{params.searchText}}...","executing-complete":"I found and selected relevant context about {{params.searchText}}."},"generate_text":{"executing-start":"Creating content...","executing-progress":"Creating content...{{progress}}%","executing-complete":"I created the requested content."},"get_all_interactive_elements":{"executing-start":"Scanning to get more context...","executing-complete":"I understand what I can interact with."},"get_all_text_elements_content":{"executing-start":"Reading to get more context...","executing-complete":"I understand what text content is available."},"get_all_text_elements_names":{"executing-start":"Reading to get more context...","executing-complete":"I understand what text content is available."},"get_available_profile_actions":{"executing-start":"Checking what controls are available in this app...","executing-complete":"I understand what I can do in this app."},"get_document_content":{"executing-start":"Reading to get more context...","executing-complete":"I have context, ready for the next part of your request."},"get_installed_apps":{"executing-start":"Deciding which app is relevant to your request...","executing-complete":"I know which apps I can use."},"get_running_app_names":{"executing-start":"Deciding which app is relevant to your request...","executing-complete":"I know which apps I can use."},"get_selected_text":{"executing-start":"Reading the selected content...","executing-complete":"I have context on the selected content."},"get_stored_content":{"executing-start":"Gathering context...","executing-complete":"I have context, ready for the next part of your request."},"keyboard_shortcut":{"executing-start":"Gathering context...","executing-complete":"I have context, ready for the next part of your request."},"open_app":{"executing-start":"Opening {{params.appName}}...","executing-complete":"I opened {{params.appName}}."},"open_webpage":{"executing-start":"Opening {{params.url}}...","executing-complete":"I opened {{params.url}}."},"paste_content":{"executing-start":"Writing...","executing-complete":"I finished writing."},"respond_to_user":{"executing-start":"Completing your request...","executing-complete:":"I completed your request."},"search_and_open_file":{"executing-start":"Searching for the file {{params.query}} and opening it...","executing-complete":"I searched for the file {{params.query}} and opened it."},"search_browser":{"executing-start":"Searching the web for {{params.query}}...","executing-complete":"I searched the web for {{params.query}}."},"select_all_text":{"executing-start":"Selecting all the text...","executing-complete":"I selected all the text."},"summarize_text":{"executing-start":"Summarizing the text...","executing-progress":"Summarizing...{{progress}}%","executing-complete":"I summarized the text."},"translate_text":{"executing-start":"Translating the text to {{params.targetLanguage}}...","executing-progress":"Translating...{{progress}}%","executing-complete":"I translated the text to {{params.targetLanguage}}."},"type_stored_content":{"executing-start":"Writing...","executing-complete":"I finished writing."},"type_text":{"executing-start":"Writing...","executing-complete":"I finished writing."},"write_file_content":{"executing-start":"Writing to the file...","executing-complete":"I finished writing to the file {{params.fileName}}."},"unknown":{"executing-start":"Ran into a problem, trying a different strategy...","executing-complete":"I tried a different strategy."}}}}},"tray":{"panel":"Toggle Panel","dashboard":"Show Dashboard","quit":"Quit Cephable"},"metrics":{"download":{"success":"Metrics file successfully accessed.","manualPath":"Metrics file available at: {{path}}","error":"Error downloading metrics file.","noFile":"No metrics file found."},"clear":{"success":"Metrics file cleared successfully.","error":"Error clearing metrics file.","noFile":"No metrics file found to clear.","confirm":"Are you sure you want to clear all metrics data? This cannot be undone."}},"gamepad":{"title":"Gamepad Support","description":"Configure gamepad and joystick output for PC gaming","driver":{"description":"To support game controller outputs, Cephable needs to download and install an external driver called ViGEm. This driver enables virtual Xbox 360 controller functionality that games recognize natively.","installed":"Game controller driver installed - You\'re ready to use gamepad outputs! If you\'re still facing issues, you can try reinstalling the driver.","notInstalled":"Game controller driver not installed","install":"Install Game Controller Driver","reinstall":"Reinstall Game Controller Driver","installing":"Installing ViGEm game controller driver...","installSuccess":"ViGEm game controller driver installed successfully! You can now use gamepad outputs in your controls.","installFailed":"Failed to install ViGEm driver. Please try again or install manually from the ViGEm website."},"platform":{"unsupported":"Platform not supported for gamepad features","unsupportedDescription":"Gamepad output functionality is currently only supported on Windows x64 systems. Windows ARM64 support is not yet available due to SDK limitations."},"usage":"Once the Game Controller driver is installed, you can use joystick movements and gamepad button presses in your macros and voice commands to control games."},"youtube":{"unavailable":{"title":"Video Unavailable","description":"This video is currently unavailable. Please check again later.","retry":"Retry"},"watch":{"title":"Oops.","description":"Looks like there was an issue loading the video. You can watch it directly on YouTube.","button":"Watch on YouTube"},"offline":{"title":"Video Unavailable","description":"This YouTube video requires an internet connection to load. Please check your connection and try again."}},"accessibilityService":{"error":{"generic":"Internal Error. Please try again later.","elementNotFound":"No result found. Please ensure the search exists and try again.","highlightOnConflict":"Multiple elements found. Please refine your command to specify which one you want to select.","clickNotInitialized":"Tapping by Name is not available at the moment. Please contact support if the issue persists.","platformUnsupported":"Voice Mouse features are not supported on this platform."},"clickWait":"Still initializing. Please wait a moment and try again."},"tos":{"title":"Terms of Service Update","description":"Our Terms of Service have been updated. Please review and accept the updated terms to continue using Cephable.","effectiveDate":"Effective date: {{date}}","accept":"Accept Terms of Service","loadError":"Unable to load Terms of Service. Please try again.","viewInBrowser":"View Terms of Service In Browser","acceptCheckbox":"I have read and accept the Terms of Service"}}');


var $7cbcf568110a7c9e$exports = {};
$7cbcf568110a7c9e$exports = JSON.parse("{\"404\":\"Oh noes! We have searched the sea and we can't find thee page!\"}");


var $2db1ccc6f838feb6$exports = {};
$2db1ccc6f838feb6$exports = JSON.parse('{"redo":"Redo Onboarding","title":"Meet Cephable","description":"Meet Cephable, your personal AI assistant and share your interest for personalized use cases.","congrats":"Congrats!","overview":{"title":"Overview","description":"Cephable is your personal AI \u2014 built for fast actions, voice commands, content generation, and smart automation across your tools. Out-of-the-box controls. No cloud processing. Just productivity that moves with you."},"customControls":{"tourLabel":"Always Available Global & Device Controls","rowDescription":"Global and device controls are always available if your microphone is on, no matter what app you are using. You can use these controls to interact with your device without having to create new app controls. They contain helpful commands like swapping controls or apps, generating text, pausing your microphone and more."},"profile":{"tourLabel":"App Controls","learn":"Learn how to set up your app controls and preferences in Cephable.","rowDescription":"App controls are configured sets of controls that you can use to make things happen. Want to say \'Next Slide\' to go to the next slide in your presentation? Or use head movement to move the cursor and voice controls for editing shortcuts? You can do that with app controls. The controls row shows you all the controls available for your current app.","check":{"title":"Check your available controls.","description":"App controls are available for each app you use. Here you can see the controls that are available for the app you are currently using. Try another command to see how it works. BUT, make sure you are focused on the app you want to control."}},"hotkeys":{"tourLabel":"Quick Action Buttons","learn":"Learn how to set up quick action buttons to map multiple actions to a single button.","rowDescription":"Quick action buttons allow you to perform multiple actions with a single command. For example, you can create a button that opens your favorite music app and starts playing a specific playlist.","check":{"title":"Check your available quick actions.","description":"Quick action buttons are available for each app you use. Here you can see the buttons that are available for the app you are currently using. Try another command to see how it works. BUT, make sure you are focused on the app you want to control."}},"dictation":{"tourLabel":"Dictation","learn":"Learn how to use dictation mode to convert your speech to text hands-free.","welcome":{"title":"Dictation","description":"Dictation lets you speak naturally and have your words typed while you talk. It\'s like having a personal assistant who types everything you say."},"microphone":{"title":"Turn on Your Microphone","description":"First, turn on your microphone. Click the Microphone Toggle on the Cephable Panel."},"activate":{"title":"Start Dictation Mode","description":"Voice starts in command mode. To start dictation, say \\"Start dictation\\" or click the Dictation button. Lets turn on dictation mode now."},"focus":{"title":"Focus on a Text Field or Document","description":"Dictation works best when you focus on a text field or document. Click on a text field or document where you want to dictate."},"speaking":{"title":"Start Speaking","description":"Now you can start speaking. Everything you say will be typed in the text field or document you focused on. Try saying something like \\"Hello, this is a test of dictation mode.\\""},"pauseResume":{"title":"Pausing Dictation","description":"Need a break without turning off dictation? Just say \\"Stop Listening\\". You can resume anytime with \\"Start dictation.\\" again. You can customize this further with your always on global and device controls."},"stop":{"title":"Stopping Dictation","description":"Need to switch back to your app controls?  Just say \\"Stop dictation\\". This will stop dictation mode and return you to command mode. You can resume anytime with \\"Start dictation.\\" again."},"complete":{"description":"That\'s it! You can now dictate, pause, resume, and swap between dictation and command modes. Dictation is a powerful tool for hands-free typing. Use it to write emails, documents, or anything else you need to type out loud."}},"replyToSocialMedia":{"tourLabel":"Faster Social Media Replies with Dictation","learn":"Learn how to use dictation to reply to social media posts hands-free.","navigateTo":{"title":"Navigate to a Social Media Post","description":"Open your web browser and navigate to a social media platform like LinkedIn or Facebook. Find a post you want to reply to."},"speaking":{"title":"Start Speaking","description":"Now you can start speaking. Everything you say will be typed in the text field or document you focused on. Try saying something like \\"Congrats! I am excited for you.\\" Make sure your cursor is focused on a text field or comment box."},"complete":{"description":"That\'s it! You can now use dictate, pause, resume, and swap between dictation and command modes to reply to social media posts hands-free. Dictation is a powerful tool for hands-free typing. Use it to write emails, documents, or anything else you need to type out loud."}},"controllingBackgroundMusic":{"tourLabel":"Manage Background Music without Interrupting Your Flow","learn":"Learn how to use voice controls and quick actions to control your music hands-free, while staying focused on your current task.","tryOpen":{"title":"Try saying `Open Spotify` or `Open Apple Music`"},"play":{"title":"Try saying `Play` to start playing music","description":"Make sure your microphone is on and say `Play`. This will start playing music in your chosen music app. This also works for any other media app."},"newPlaylist":{"title":"Create a New Playlist","description":"Make sure your microphone is on and say `New Playlist`. This will start the process of creating a new playlist in your chosen music app."},"finishedCommands":{"title":"Great job! You\u2019ve learned how to control your music hands-free.","description":"You now know how to use voice commands and quick actions to play, pause, skip tracks, and adjust volume in your favorite music apps. Try exploring more commands or customizing your own quick actions for even smoother music control."}},"editingVideos":{"tourLabel":"Focus on the Story, Not the Tedious Clicks for Video Editing","learn":"Learn how to use voice controls and quick actions to edit videos faster, and remove the cognitive load of remembering which buttons to click while editing.","tryOpen":{"title":"Try saying `Open iMovie` or `Open DaVinci Resolve`"},"play":{"title":"Try saying `Play` to start playing your video","description":"Make sure your microphone is on and say `Play`. This will start playing your video in your chosen video editing app."},"stop":{"title":"Stop Video Playback","description":"Make sure your microphone is on and say `Stop`. This will stop video playback in your chosen video editing app."},"finishedCommands":{"title":"Great job! You\u2019ve learned how to control your video editing hands-free.","description":"You now know how to use voice commands and quick actions to play, pause, skip tracks, and adjust volume in your favorite video editing apps. Try exploring more commands or customizing your own quick actions for even smoother video control."}},"fpsGamePlay":{"tourLabel":"Play FPS Games with Voice Controls","learn":"Learn how to use voice controls and quick actions to play FPS games.","changeProfile":{"title":"Change Control Profile","description":"Change your app control to the FPS game profile. You can customize this for the specific game you want to play with too. Refer to the video."},"autoProfileSwitching":{"title":"Turn Off Auto Control Switching","description":"This will keep your current app control active until you change apps."},"tryOpen":{"title":"Try saying `Open Valorant` or `Open Battlefield`"},"go":{"title":"Try saying `Go`","description":"Make sure your microphone is on and say `Go`. This will start moving your character forward."},"stop":{"title":"Try saying `Stop`","description":"Make sure your microphone is on and say `Stop`. This will stop moving your character."},"complete":{"description":"You now know how to use voice commands and quick actions to move, stop, and control your character in FPS games. Try exploring more commands or customizing your own quick actions for even smoother and faster gameplay."}},"vibeCoding":{"tourLabel":"Ideate, Prototype, and Iterate Faster with Dictation","learn":"Learn how to use dictation and AI-powered text generation to vibe code, prototype, and iterate on ideas.","navigateTo":{"title":"Navigate to a Vibe Code Editor","description":"Open your web browser and navigate to a Vibe Code Editor. Some examples are Vercel V0, GitHub Copilot in VS Code, Base 44, and Lovable."},"focus":{"title":"Click New Chat or Focus a Text Box","description":"Dictation works best when you focus on a text field or document. Click on the comment box or reply thread where you want to dictate. Then start speaking."},"speaking":{"title":"Start Speaking","description":"Now you can start speaking. Everything you say will be typed in the text field or document you focused on. Try saying your technical requirements and what the code should do. Make sure your cursor is focused on a text field or comment box."},"rewriteIntro":{"title":"Rewrite Code with Instructions","description":"You can also use the Intelligent Tasks like Rewrite to modify existing code in place. This task is powered by on-device AI meaning it works without internet connection and runs from your device."},"highlightText":{"title":"Highlight Text to Rewrite","description":"Highlight the code you want to rewrite."},"enterInstructions":{"title":"Enter Rewrite Instructions","description":"Type your coding rewrite instructions. Specify the programming language, style, or any specific changes you want."},"complete":{"description":"That\'s it! You can now dictate, pause, resume, and iterate on Code. Continue exploring more use cases with Dictation and Intelligent Tasks, or other features to optimize your workflow."}},"documentCode":{"tourLabel":"Fast, Secure Code Documentation with On-Device AI Text Generation","learn":"Learn how to use AI-powered rewrite to document code while staying in the same app and keeping your data secure.","rewriteIntro":{"title":"Write Code Documentation","description":"You can use Cephable Intelligent Rewrite to write code documentation in a separate document or app. Rewrite is part of On-device AI Tasks including Offline Generate and Translate."},"focusApp":{"title":"Focus on your Code","description":"Open your IDE, and focus on the code you want to document."},"newFile":{"title":"Create a Documentation File","description":"Create a new file in your IDE or open a separate app where you want the documentation to appear."},"highlightText":{"title":"Highlight Code","description":"Highlight and copy the code you want to document."},"pasteMode":{"title":"Click Paste Text Tab","description":"Use paste mode to paste the original code and write documentation in a new file."},"pasteInput":{"title":"Paste Code to Document","description":"Paste the code you want to document into the input box."},"enterInstructions":{"title":"Enter Formatting, Style, and Content Instructions","description":"Type your coding documentation instructions. Specify the file type (ie markdown), style, or any specific content you want."},"complete":{"description":"You have learned how to use Intelligent Tasks for quick and secure code documentation. Continue exploring more use cases with Rewrite, or other features to optimize your workflow."}},"generateCode":{"tourLabel":"Fast, Secure Code Generation with On-Device AI Text Generation","learn":"Learn how to use AI-powered generation to create code snippets while moving across apps and keeping your data secure.","rewriteIntro":{"title":"Write Code Snippets","description":"You can use Cephable Intelligent Rewrite to write code snippets in your IDE while getting requirements from a different application. Rewrite is part of On-device AI Tasks including Offline Generate and Translate."},"focusApp":{"title":"Focus on your Ticket Contents","description":"Open your ticket that specifies requirements, and focus on the content you want to generate code for."},"newFile":{"title":"Create a Code Snippet File","description":"Create a new file in your IDE."},"highlightText":{"title":"Highlight Ticket Contents","description":"Highlight and copy the content you want to generate code for."},"pasteMode":{"title":"Click Paste Text Tab","description":"Use paste mode to paste the original ticket requirements and write code snippets for."},"pasteInput":{"title":"Paste Requirements to Generate Code","description":"Paste the requirements you want to use for code generation into the input box."},"enterInstructions":{"title":"Enter Programming Language and Style Instructions","description":"Type your programming language and style instructions. Specify the programming language (ie c#), style, or any specific coding instructions you have."},"translateIntro":{"title":"Translate Code Snippets","description":"You can also use Cephable Intelligent Translate to convert code snippets from one programming language to another directly in your IDE. Translate is part of On-device AI Tasks including Offline Generate and Rewrite."},"copyGeneratedCode":{"title":"Copy the Generated Code","description":"After generating code using the previous steps, highlight and copy the generated code snippet."},"translatePasteMode":{"title":"Click Paste Text Tab","description":"Use paste mode to paste the original code and translate it to another programming language."},"enterProgrammingLanguage":{"title":"Enter Target Programming Language","description":"Type the programming language you want to translate the code into (ie Python)."},"pasteCode":{"title":"Paste the Generated Code in your IDE","description":"Go to your IDE and paste the copied code snippet into the new file you created earlier."},"complete":{"description":"You have learned how to use Intelligent Tasks for quick and secure code generation and translation. Continue exploring more use cases with Generate and Translate, or other features to optimize your workflow."}},"requirementDocsFromMeeting":{"tourLabel":"From Notes to Product Requirement Docs in Minutes using On-Device AI","learn":"Learn how to use AI Intelligent Tasks to create structured product requirement documents from meeting notes while keeping your data secure.","rewriteIntro":{"title":"Create Product Requirement Documents","description":"You can use Cephable Intelligent Rewrite to create structured product requirement documents from meeting notes. Rewrite is part of On-device AI Tasks including Offline Generate and Translate."},"focusNotes":{"title":"Open your Meeting Notes","description":"Open your meeting notes, transcriptions, or other meeting related text content."},"highlight":{"title":"Highlight Meeting Notes","description":"Highlight the meeting notes you want to use to create a product requirement document."},"enterInstructions":{"title":"Enter Document Structure and Content Instructions","description":"Type your product requirement document instructions. Specify the structure, style, or any specific content you want."},"complete":{"description":"You have learned how to use Intelligent Tasks for quick and secure product requirement document creation. Continue exploring more use cases with Rewrite, or other features to optimize your workflow."}},"headMouseMovement":{"tourLabel":"Hands-Free Gaming Setup with Head Mouse","learn":"Learn how to use head movements to control your mouse cursor for precise navigation and clicking.","deviceSettings":{"title":"Open Device Settings","description":"To enable head mouse movements, click the Device Settings button."},"cameraSettings":{"title":"Open Camera Settings","description":"In the Device Settings, click on Camera Settings to access the camera controls."},"headMouseSection":{"title":"Head Movement for Mouse Controls","description":"When this is turned on, then some of your head movement controls will be used to move your mouse instead of trigger controls."},"steadyGlide":{"title":"Steady Glide Mode","description":"Turn on Steady Glide mode. When you move your head past a certain point, the cursor glides continuously in that direction at a steady speed."},"customization":{"title":"Customize Head Mouse Settings","description":"You can customize the head mouse settings to fit your preferences. Adjust the speed, sensitivity, and other settings to get the best experience."},"save":{"title":"Save Head Mouse Settings","description":"Don\'t forget to save your customized head mouse settings."},"transition":{"title":"Moving to the Cephable Panel","description":"Now let\'s move to the Cephable Panel to try out head mouse movements."},"playGames":{"title":"Play Games with Head Mouse","description":"Now you can use head movements to control your mouse cursor while playing games. Try it out and see how it works!"}},"clinicalNoteTaking":{"tourLabel":"HIPAA-Compliant Dictation and Formatting for Clinicians","learn":"Learn how to use voice commands, smart dictation, and AI formatting to save time on clinical notes.","focus":{"title":"Focus on a Document","description":"Dictation works best when you focus on a document. Open a Document where you want to take clinical notes between sessions."},"speaking":{"title":"Start Speaking","description":"Now you can start speaking. Everything you say will be typed in the text field or document you focused on. Try saying something like \\"Patient is a 45-year-old male with a history of hypertension. The last medication prescribed did not work as expected and caused an allergic reaction. We will need to check for alternative medicine, and they would like a Generic branded prescription.\\" Make sure your cursor is focused on the document."},"rewriteIntro":{"title":"Format Your Notes","description":"Now, you can use Cephable Intelligent Rewrite to format your notes in SOAP style. This is all done on-device, meaning your data stays private, secure, and HIPAA-compliant."},"copyText":{"title":"Copy the Notes","description":"After highlighting your notes, copy the text to prepare it for formatting."},"pasteMode":{"title":"Click Paste Text Tab","description":"Use paste mode to paste the original notes and format them in SOAP style."},"pasteInput":{"title":"Paste Notes to Format","description":"Paste the notes you want to format into the input box."},"enterInstructions":{"title":"Enter Formatting Instructions","description":"You can write formatting instructions that will need be followed for your Clinic / EHR System. (Ex. Format in SOAP style with headings, bullet points, and concise language.)"},"navigateToEHR":{"title":"Navigate to your EHR System","description":"Open your EHR system and navigate to the section where you want to input the formatted notes."},"focusTextField":{"title":"Focus on the Text Field","description":"Click on the text field where you want to paste the formatted notes."},"complete":{"description":"You have learned how to use voice commands and smart dictation to document clinical notes, and Intelligent Rewrite to format them in SOAP style. Continue exploring more use cases with Dictation and Rewrite, or other features to optimize your workflow."}},"noteTakingAndDocumentation":{"tourLabel":"Note Taking and Document Generation using Private, On-Device AI","learn":"Learn how to use voice commands, smart dictation, and AI Tasks to go from notes to designs and documents faster.","focus":{"title":"Focus on a Text Field or Document","description":"Dictation works best when you focus on a text field or document. Open a Document or Click a Text Field where you want to take notes."},"speaking":{"title":"Start Speaking","description":"Now you can start speaking. As you think through your idea, just talk naturally and let your thoughts flow. Everything you say will be typed in the text field or document you focused on. Try describing your concept, outlining steps, or brainstorming freely. For example, say \\"I\'m considering a new workflow for our team. First, we should automate the reporting process, then review the results weekly.\\" Make sure your cursor is focused on the document."},"typeEnter":{"title":"Paragraph Breaks","description":"To create paragraph breaks, simply press Enter on your keyboard. This will help organize your notes into clear sections. Continue speaking your thoughts, or transcribing from someone else talking."},"rewriteIntro":{"title":"Create Designs","description":"Now, you can use Cephable Intelligent Rewrite to take your notes and design it into a feature idea or follow ups. This is all done on-device, meaning your data stays private and secure."},"highlightText":{"title":"Highlight the Notes","description":"Select all the notes you want to use to create a design or document."},"inPlaceReplacement":{"title":"In Place Ideation","description":"Now, we will use in-place replacement to turn your notes into a design or document. You can always use the paste mode or option to create a new file instead."},"enterInstructions":{"title":"Enter Design Instructions","description":"You can write your next steps instruction of what you would like to do with the notes. This could be formatting, designing, follow up tasks, or anything else. (Ex. Create a design document highlighting how the feature would work, what the end to end looks like, and what success might look like.)"},"complete":{"description":"You have learned how to use voice commands and smart dictation to document clinical notes, and Intelligent Rewrite to format them in SOAP style. Continue exploring more use cases with Dictation and Rewrite, or other features to optimize your workflow."}},"webBrowsing":{"tourLabel":"Plan Trips, Shop Online, and Browse the Web using Voice","learn":"Learn how to use voice commands to navigate, scroll, and fill forms while browsing the web hands-free.","tryOpen":{"title":"Try saying `Open Chrome` or `Open Edge`","description":"Make sure your microphone is on and say `Open Chrome` or `Open Edge`. This will open your chosen web browser. If you have automatic control switching enabled, it will also switch to the app controls that best match the app you are using."},"search":{"title":"Searching","description":"Try saying \\"Search\\" or \\"Search for\\". This will focus the search bar in your browser."},"quickType":{"title":"Quick Typing","description":"Quick Typing allows you to type using your voice without being in dictation mode. Try saying \\"Type what is the weather today\\". This will type out your query in the search bar."},"enter":{"title":"Press Enter","description":"Try saying \\"Enter\\". This will execute the search query you just typed."},"scrollDown":{"title":"Scroll Down","description":"Try saying \\"Scroll down\\". This will scroll down the webpage."},"scrollUp":{"title":"Scroll Up","description":"Try saying \\"Scroll up\\". This will scroll up the webpage."},"newTab":{"title":"Open a New Tab","description":"Try saying \\"New tab\\". This will open a new tab in your browser."},"formsCustomization":{"title":"Form Filling Customization","description":"You can customize this app control for easy form filling. Like first name, last name, email etc. Then you can use Quick Actions or Voice Commands to fill out forms even faster."},"complete":{"title":"Great job!","description":"You now know how to use voice commands and quick actions to navigate, search, scroll, and fill forms while browsing the web. Try exploring more commands or customizing your own quick actions for even smoother web browsing."}},"spreadsheetReviews":{"tourLabel":"Work Faster in Spreadsheets with Voice Controls","learn":"Learn how to use voice commands and quick actions to review and edit large spreadsheets quickly.","tryOpen":{"title":"Try saying `Open Excel` or `Open Google Sheets`","description":"Make sure your microphone is on and say `Open Excel` or `Open Google Sheets`. This will open your chosen spreadsheet app. If you have automatic control switching enabled, it will also switch to the app controls that best match the app you are using."},"selectRow":{"title":"Select a Row","description":"Click a cell. Then, try saying \\"Select row\\". This will select the entire row for the focused cell."},"delete":{"title":"Delete Contents of a Row","description":"Try saying \\"Delete\\". This will delete the contents of the selected row."},"note":{"title":"Add a Note to a Cell","description":"Click a cell. Then, try saying \\"Add note\\". This will allow you to add a note to the focused cell."},"addNote":{"title":"Type the Note","description":"Try saying \\"Type These numbers don\'t match.\\". This will type out your note in the cell."},"currentDate":{"title":"Enter Current Date","description":"Click a cell. Then, try saying \\"Current date\\". This will enter the current date in the focused cell."},"copy":{"title":"Copy a Cell","description":"Click the cell you just added current date to. Then, try saying \\"Copy\\". This will copy the current date."},"selectColumn":{"title":"Select a Column","description":"Try saying \\"Column\\". This will select the entire column for the focused cell."},"paste":{"title":"Paste Current Date","description":"Try saying \\"Paste\\". This will paste the current date into the selected column."},"quickActions":{"title":"Use Quick Actions","description":"You can also do many of these controls and more with Quick Action buttons. You can customize these buttons to fit your workflow and make it even faster to review and edit spreadsheets."},"complete":{"description":"You now know how to use voice commands and quick actions to review and edit large spreadsheets quickly. Try exploring more commands or customizing your own quick actions for faster spreadsheet management."}},"socialMediaWriting":{"tourLabel":"Iterate on Content and Research with Private, On-Device AI","learn":"Learn how to use Intelligent Generate and Rewrite, completely private and on-device, to create and iterate faster on content.","onDeviceIntro":{"title":"Your Research Stays Private and Secure","description":"Cephable\'s Intelligent Tasks are powered by on-device AI, meaning your data stays private and secure. You can create, rewrite, and translate text without any cloud processing. You can also use cross-application context, and iterate on ideas directly in your preferred app."},"enterPrompt":{"title":"Start Ideating","description":"In the input box, write a prompt for content you want to scaffold or generate. For example, you can input: \\"List risks of Agentic AI, where some of the gaps are, and how innovation can get ahead.\\""},"customizeSettings":{"title":"Customize Generation Settings","description":"You can customize the generation settings to fit your preferences. Adjust with system prompts that reflect tone, brand voice, and more."},"rewriteIntro":{"title":"Iterate on Content","description":"You can use Cephable Intelligent Rewrite to iterate on content directly in your preferred app. This is all done on-device, meaning your data stays private and secure."},"highlightText":{"title":"Highlight Text to Rewrite","description":"Highlight one of the listed risks from the generated content you want to further iterate on."},"enterInstructions":{"title":"Enter Rewrite Instructions","description":"Type your rewrite instructions. For example, you can input: \\"Add more details about the risks.\\""},"writeSocialMediaPost":{"title":"Write a Social Media Post","description":"Use rewrite again to reformat this language into a public facing social media post that obtains the key points, and highlights areas of engagement."},"highlightPost":{"title":"Highlight the Generated Post","description":"Highlight the generated social media post you want to use."},"enterPostInstructions":{"title":"Enter Post Instructions","description":"Type your post instructions. For example, you can input: \\"Make it concise and engaging for LinkedIn.\\""},"complete":{"description":"Now you can open your preferred social media platform, focus on the post creation text box, and paste the generated post. Or continue to iterate and refine until you are ready!"}},"inboxTriage":{"tourLabel":"AI Email Assistant: Automate, Draft & Reply Faster with Voice + AI","learn":"Learn how to use voice commands and Intelligent Tasks to manage your inbox efficiently while keeping your data secure.","tryOpen":{"title":"Try saying `Open Outlook` or `Open Gmail`","description":"Make sure your microphone is on and say `Open Outlook` or `Open Gmail`. This will open your chosen email app. If you have automatic control switching enabled, it will also switch to the app controls that best match the app you are using."},"select":{"title":"Select an Email","description":"Click an email. Then, try saying \\"Select email\\". This will select the focused email."},"delete":{"title":"Delete an Email","description":"Try saying \\"Delete\\". This will delete the selected email."},"reply":{"title":"Reply to an Email","description":"Click an email. Then, try saying \\"Reply\\". This will open the reply window for the focused email."},"dictateIntro":{"title":"Dictate Your Reply","description":"You can use dictation to type out your reply hands-free. Make sure your microphone is on and dictation mode is activated."},"dictateReply":{"title":"Start Replying","description":"Try saying \\"I am interested in learning more about your services. Please send me additional information.\\" This will type out your reply in the email. Make sure you are focused on the reply text box."},"newEmail":{"title":"Create a New Email","description":"Try saying \\"New email\\". This will open a new email composition window."},"customEmailTemplates":{"title":"Custom Email Templates","description":"You can create custom email templates for common responses. This will allow you to quickly insert pre-written content into your emails using voice commands or quick actions."},"editAppControls":{"title":"Edit App Controls","description":"To create a custom email template, click the Edit App Controls button."},"addNewControl":{"title":"Add New Control","description":"In the App Controls editor, click the Add New Control button."},"quickAction":{"title":"Select Quick Action","description":"Choose Quick Action as the control type."},"templateName":{"title":"Name Your Template","description":"Give your custom email template a name, such as \\"Meeting Request.\\""},"eventType":{"title":"Select Event Type","description":"In the event type section, choose an event type of \\"type\\"."},"typeSteps":{"title":"Type Template Content","description":"Type out the content of your email template. For example, you can input: \\"Lead Outreach \\n Hello, I would like to schedule a meeting to discuss potential collaboration opportunities. Please let me know your availability.\\""},"finish":{"title":"Finish Creating Template","description":"Click the Finish button to complete the creation of your custom email template."},"saveTemplate":{"title":"Save Your Template","description":"Click the Save button to save your custom email template."},"focusApp":{"title":"Refocus on Your Email App","description":"Go back to your email app and make sure you are focused on the new email subject line."},"useTemplate":{"title":"Use Your Template","description":"Now you can use your custom email template by saying its name or clicking the Quick Action button."},"generateIntro":{"title":"Generate Email Content","description":"You can also use Cephable Intelligent Generate to create email content directly in your email app. This is all done on-device, meaning your data stays private and secure."},"enterPrompt":{"title":"Enter Email Prompt","description":"In the prompt box, type: Write a professional email to a potential client introducing our services and requesting a meeting."},"focusNewEmail":{"title":"Focus on the New Email","description":"Make sure you are focused on the new email composition window where you want the generated text to appear."},"translateEmail":{"title":"Translate Email Content","description":"You can use Cephable Intelligent Translate to translate email content directly in your email app. This is all done on-device, meaning your data stays private and secure."},"highlightText":{"title":"Highlight Email Content","description":"Highlight the content of a long email you want to translate."},"enterLanguage":{"title":"Enter Translation Language","description":"Type your translation language. For example, you can input: \\"Spanish.\\""},"complete":{"description":"You now know how to use voice commands and Intelligent Tasks to navigate, reply, dictate, generate, and translate emails while keeping your data secure. Try exploring more commands or customizing your own quick actions for even smoother email management."}},"handsFreeMeeting":{"tourLabel":"Reduce Meeting Fatigue with Hands-Free Controls","learn":"Save time and Reduce Virtual Meeting Fatigue with Quick Hands-Free Meeting Controls","tryOpen":{"title":"Try saying `Open Zoom` or `Open Teams`","description":"Make sure your microphone is on and say `Open Zoom` or `Open Teams`. This will open your chosen meeting app. If you have automatic control switching enabled, it will also switch to the app controls that best match the app you are using."},"mute":{"title":"Try saying `Toggle Mute` to mute your microphone","description":"Make sure your microphone is on and say `Toggle Mute`. This will mute your microphone in your chosen meeting app."},"video":{"title":"Try saying `Toggle Video` to turn your camera on or off","description":"Make sure your microphone is on and say `Toggle Video`. This will turn your camera on or off in your chosen meeting app."},"raiseHand":{"title":"Try saying `Raise Hand` to raise your hand","description":"Make sure your microphone is on and say `Raise Hand`. This will raise your hand in your chosen meeting app."},"quickType":{"title":"Quick Typing","description":"Make sure your microphone is on and say `Type this is a cool feature`. This will allow you to quickly type using your voice without being in dictation mode. Make sure you are focused on a text field in your meeting app."},"complete":{"description":"You now know how to use voice commands and quick actions to mute/unmute, turn video on/off, raise hand, and type quickly in your favorite meeting apps. Try exploring more commands or customizing your own quick actions for even smoother meeting control."}},"summarizingReports":{"tourLabel":"Summarize Confidential Reports with Private, On-Device AI","learn":"Learn how to use AI-powered summarization to quickly get the key points from long reports and documents while keeping your confidential and proprietary data secure.","summarizeIntro":{"title":"Summarize Text","description":"You can use Cephable Intelligent Tasks to quickly get the key points from long reports and documents. Summarize is part of On-device AI Tasks meaning it works without internet connection and runs from your device."},"navigateToReport":{"title":"Focus on your Report or Document","description":"Open your report or document in your preferred app and focus on the text you want to summarize."},"highlightText":{"title":"Highlight Text to Summarize","description":"Highlight the text you want to summarize."},"copyText":{"title":"Copy the Text","description":"After highlighting your text, copy it to prepare it for summarization."},"enterPrompt":{"title":"Enter Summarization Instructions","description":"Type your summarization instructions. Specify the length, style, or any specific content you want."},"pasteText":{"title":"Paste your Report Content","description":"After the instructions, paste the copied text into the input box."},"focusChatApp":{"title":"Focus on your Chat App","description":"Open your chat app like Teams or Slack and focus on the text box where you want the summarized text to appear."},"rewriteIntro":{"title":"Rewrite Summarized Text","description":"You can also use Cephable Intelligent Rewrite to further refine the summarized text. This is all done on-device, meaning your data stays private and secure."},"highlightSummary":{"title":"Highlight the Summarized Text","description":"Highlight the summarized text you want to further refine."},"enterRewriteInstructions":{"title":"Enter Rewrite Instructions","description":"Type your rewrite instructions. Specify the tone, style, or any specific changes you want."},"complete":{"description":"You have learned how to use Intelligent Tasks for quick and secure text summarization to share findings with your team. Continue exploring more use cases with Summarize and Rewrite, or other features to optimize your workflow."}},"presentationControls":{"tourLabel":"Control Presentations with Voice Commands","learn":"Learn how to use voice commands and quick actions to navigate and control your presentations hands-free.","tryOpen":{"title":"Try saying `Open PowerPoint` or `Open Google Slides`"},"startPresentation":{"title":"Try saying `Start Presentation` to begin your slideshow","description":"Make sure your microphone is on and say `Start Presentation`. This will start your slideshow in your chosen presentation app."},"nextSlide":{"title":"Try saying `Next Slide` to move to the next slide","description":"Make sure your microphone is on and say `Next Slide`. This will move to the next slide in your slideshow."},"previousSlide":{"title":"Try saying `Previous Slide` to go back to the previous slide","description":"Make sure your microphone is on and say `Previous Slide`. This will go back to the previous slide in your slideshow."},"escape":{"title":"Try saying `Escape` to exit the presentation mode","description":"Make sure your microphone is on and say `Escape`. This will exit the presentation mode in your chosen presentation app."},"complete":{"description":"You now know how to use voice commands and quick actions to start, navigate, and exit presentations hands-free. Try exploring more commands or customizing your own quick actions for even smoother presentation control."}},"camera":{"tourLabel":"Camera Controls","rowDescription":"Camera controls allow you to use your face and body to control your device. You can use different face expressions, head movements to control your device. With the microphone on you can use voice commands to start and stop the camera, and switch cameras.","learn":"Learn how to use camera controls to navigate and interact with your device hands-free.","welcome":{"title":"Camera Controls","description":"Camera controls let you use your face and body to control your device. You can use different face expressions, head movements, and voice commands to navigate and interact with your device hands-free."},"start":{"title":"Start Camera Controls","description":"To start using camera controls if you are using voice, say \\"Start camera controls\\" or click the Camera Controls button."}},"microphone":{"tourLabel":"Voice Controls","learn":"Learn how you can use your voice to control any app and use dictation to type what you say.","description":"Cephable Voice Controls allow you to use your voice to control your device. Want to save that document? Just say \'save\'. Want to pause your music? Just say \'pause\'. Voice also allows you to use dictation to type what you say.","rowDescription":"When the microphone is off, we will not listen to your voice commands at all but if you turn it on, you will be able to use global commands to toggle pause, start, and more. Let\'s turn it on.","start":{"title":"Start Voice Controls","description":"To start using voice controls, click the Microphone Toggle on the Cephable Panel. This will turn on the microphone and start listening for commands."},"tryOpen":{"title":"Try saying `Open Spotify` or `Open Word`","description":"`Open` is a global command that will open the app you specify and send focus to it. If you have automatic control switching enabled, it will also switch to the app controls that best match the app you are using."},"finishedCommands":{"title":"Excellent! You\'ve learned the basics of Voice Controls.","description":"You can always revisit the tour from the Support Page. The next step is to learn about Dictation. You can start the tour from the support page."}},"publicProfiles":{"tourLabel":"Customize App Controls"},"editingImages":{"tourLabel":"Faster Image Editing with Voice Controls and Dictation","learn":"Learn how to use voice commands, quick actions, and dictation to improve your image editing process.","tryOpen":{"title":"Try saying `Open Figma` or `Open Photoshop`"},"selectAll":{"title":"Try saying `Select All` to select all elements on the canvas","description":"Make sure your microphone is on and say `Select All`. This will select all elements on the canvas in your chosen image editing app. Make sure you are focused on the app."},"bold":{"title":"Try saying `Bold` to make the selected text bold","description":"Make sure your microphone is on and say `Bold`. This will make the selected text bold in your chosen image editing app. Make sure you have text selected."},"copy":{"title":"Try saying `Copy` to copy the selected element","description":"Make sure your microphone is on and say `Copy`. This will copy the selected element in your chosen image editing app. Make sure you have an element selected."},"paste":{"title":"Try saying `Paste` to paste the copied element","description":"Make sure your microphone is on and say `Paste`. This will paste the copied element in your chosen image editing app."},"delete":{"title":"Try saying `Delete` to delete the selected element","description":"Make sure your microphone is on and say `Delete`. This will delete the selected element in your chosen image editing app. Make sure you have an element selected."},"dictationIntro":{"title":"Dictation","description":"You can use dictation to type text using your voice. Make sure your microphone is on and dictation mode is activated."},"focus":{"title":"Focus on a Text Field","description":"Click on a text field in your image editing app where you want to use dictation."},"speaking":{"title":"Start Speaking","description":"Try saying \\"For early discount codes, scan the QR Code. This is valid until September 30th. Then, apply through the website.\\" Make sure you are focused on the text field or area where you want to dictate."},"complete":{"description":"You now know how to use voice commands, quick actions, and dictation to improve your image editing process. Try exploring more commands or customizing your own quick actions for even smoother image editing."}},"smartTasks":{"tourLabel":"Intelligent Tasks","rowDescription":"Intelligent tasks are the different tasks that Cephable\'s AI can perform for you. These tasks are powered by on-device AI and can be used to create text, summarize, rewrite, translate, and more.","learn":"Learn how to generate, rewrite, and translate text with Cephable.","generate":{"openTool":{"title":"Open Generate Text Tool","description":"In the Cephable panel, click the carrot next to Intelligent Tasks and select Generate Text."},"focusApp":{"title":"Focus on the App","description":"Make sure you are focused on the app where you want the generated text to appear. You will be able to seamlessly generate text into that location when you click Generate."},"enterPrompt":{"title":"Enter Prompt","description":"In the prompt box, type: Create an ink-credible one sentence pun or a short poem about octopuses."},"clickGenerate":{"title":"Click Generate","description":"Click the Generate button. Watch the text appear in real time."}},"rewrite":{"openTool":{"title":"Open Rewrite Text Tool","description":"In the Cephable panel, click the carrot next to Intelligent Tasks and select Rewrite Text."},"focusApp":{"title":"Focus on the App","description":"Make sure you are focused on the app where you want the rewritten text to appear. You will be able to seamlessly generate text into that location when you click Generate."},"welcome":{"title":"Welcome to Rewrite","description":"Rephrase content quickly with highlighted or pasted text."},"highlightToggle":{"title":"Use Highlighted Text","description":"Ensure \'Use Highlighted Text\' is selected (default)."},"highlightText":{"title":"Highlight Text to Rewrite","description":"Highlight: An octopus can control each arm independently."},"enterInstructions":{"title":"Enter Rewrite Instructions","description":"Type: In an old English style."},"clickGenerate":{"title":"Click Generate","description":"Your highlighted text will be rewritten based on your input."},"pasteMode":{"title":"Use Paste Text","description":"Paste original and rewrite instruction. Click Generate. Click Clear to reset."}},"translate":{"welcome":{"title":"Welcome to Translate","description":"Translate highlighted or pasted text into another language."},"openTool":{"title":"Open Translate Text Tool","description":"In the Cephable panel, click the carrot next to Intelligent Tasks and select Translate Text."},"highlightToggle":{"title":"Use Highlighted Text","description":"Make sure \'Use Highlighted Text\' is selected."},"highlightText":{"title":"Highlight Text to Translate","description":"Highlight: An octopus can control each arm independently."},"enterLanguage":{"title":"Enter Target Language","description":"Type: Portuguese."},"clickGenerate":{"title":"Click Generate","description":"Translation will be typed into your app at your cursor."},"pasteMode":{"title":"Use Paste Text","description":"Paste text and language. Click Generate. Click Clear to reset."}}},"featureFlag":{"title":"Time to Upgrade","description":"The feature you are trying to use requires a different license. Upgrade to unlock this feature and more. "},"tour":{"title":"Welcome to Cephable","description":"Cephable is a powerful tool that allows you to control your computer using your voice, camera, and other inputs. This tour will guide you through the key features and how to use them effectively.","startTour":"Start Tour","finishTour":"Finish Tour","statusDialog":"Please check the panel for more information.","step":"Step {{step}} of {{total}}","next":"Next","previous":"Previous","endTour":"End Tour","nextTourLabel":"Next: {{nextStepTitle}}","skipTour":"Skip Tour","steps":{"welcome":{"title":"Welcome to Cephable","description":"This tour will guide you through the main features of Cephable. Let\'s get started!"},"inputs":{"title":"Inputs Overview","description":"Cephable supports various input methods including voice commands, camera controls, and more. You can customize these inputs in the settings."},"appControls":{"title":"App Controls","description":"Create app controls to map your inputs to specific actions in your applications. This allows you to control apps with gestures, voice commands, and more."},"settings":{"title":"Settings","description":"Access the settings to configure your inputs, app controls, and other preferences. You can also manage your account and language settings here."},"intelligentTasks":{"title":"Intelligent Tasks","description":"Use intelligent tasks to generate text, summarize content, rewrite text, translate languages, and more using AI-powered features."},"cameraControls":{"title":"Camera Controls","description":"Enable camera controls to use facial expressions and head movements as input methods for controlling your computer."},"voiceControls":{"title":"Voice Controls","description":"Use voice commands to control your computer hands-free. You can dictate text, issue commands, and interact with applications using your voice."}}},"support":{"tourLabel":"Ready to Learn More?","description":"You can visit our support hub for more information on how to use Cephable, including more tours, step-by-step guides, tutorials, and videos.","cta":"Explore Other Tours"},"onboarding":{"demoPlaceholder":"This is the placeholder demo text. Using the prompts above you can control the styling of this text.","exit":"Exit Setup","overview":"Overview","learn":"Learn about the features of Cephable and how to use them.","start":"Looks like you are just getting started. Here are some areas that will help you along the way.","startTour":" Get Started","dashboard":{"title":"Cephable Dashboard","description":"The Cephable Dashboard is your central hub for managing your device, app controls, and settings. From here, you can customize your experience, view active commands, and access all the features of Cephable."},"step1":{"title":"Welcome to Cephable","description":"Cephable is your personal AI \u2014 built for fast actions, voice commands, content generation, and smart automation across your tools. Out-of-the-box controls. No cloud processing. Just productivity that moves with you.","inputs":"What are Inputs?","inputDescription":"Input controls are the methods for operating your device, extending your computer capabilities beyond the traditional mouse and keyboard. These methods include voice commands, head movements, facial expressions, and additional peripherals.","profiles":"What are App Controls?","profileDescription":"App Controls allow you to connect and communicate with your computer in unique ways by pairing input and output controls. With app controls, you can instruct Cephable to perform tasks like saving a file with a head tilt or clicking \'send\' on an email with a smile.","action":"Explore Input Controls","secondaryAction":"Skip to App Controls","secondaryActionDescription":"Already know about input controls?"},"finish":{"title":"Setup Complete","description":"You have successfully used your first Cephable app controls! You can now utilize these and more on your device. It is available on your Cephable Dashboard where you can continue to customize app controls settings as needed.","continueToApp":"Continue to Cephable Dashboard","keepExploring":"Keep Exploring"},"useCaseSlider":{"context":"I\'d like to use","control":"to control"}},"panel":{"description":"This is the panel which is the main control center. It is always visible and allows you to control your apps using your voice, and more. Let\'s start with the microphone."}}');


var $f2a7e1c8dd4452db$exports = {};
$f2a7e1c8dd4452db$exports = JSON.parse('{"introduction":{"title":"Hi, I\'m Cephable.","back":"Back to introduction","description":"I\'m your personal AI to help you control, create, and automate using the tools you already love \u2014 across all your connections. There are a few things you should know about me.","action":"Let\'s get started!","recording":{"title":"Your voice and video stay local.","description":"I never record, stream, or send your audio or video to the cloud. All inputs are processed on-device \u2014 privately and securely."},"data":{"title":"Your data is yours.","description":"I don\'t use your commands or activity to train models for others. Everything stays private \u2014 and your app controls move with you across connections."},"offline":{"title":"I work when other tools don\'t.","description":"Intelligent Tasks like generating content, rewriting, translating, and dictation all run locally. No cloud required. That means I work even when you\'re offline \u2014 and your data doesn\'t leave your device."},"empower":{"title":"Built to empower, not exploit.","description":"I am designed to enhance your control \u2014 not monitor it. No invasive tracking. No creepy data collection. Just input that works for you."}},"my-capabilities":{"title":"Perfect! Here\'s how I can help.","back":"Back to capabilities","actionTitle":"See Me In Action","description":"Based on your interests, here are the features and capabilities most relevant to your workflow.","action":{"title":"See Me In Action","description":"Explore some examples of how I can assist you in your daily tasks."}},"see-me":{"title":"Want to see how I\'ve helped others like you?","back":"Back to use cases","description":"Check out some real-world examples of how I\'ve transformed workflows across different industries and roles."},"complete":{"title":"Ready to Start Using Me?","description":"You\'ve seen what I can do! Now let\'s get you set up and start transforming your workflow. I\'ll be here to help you every step of the way.","action":"Complete Setup & Start Using Cephable"},"apps":{"title":"I Support the Tools You Already Love","description":"With pre-configured support for 200+ applications \u2014 I work with the software you use every day. No setup required.","note":"Don\'t see an app you use? No problem \u2014 I can generate controls or help you create custom workflows that work for you.","andMore":"And More"},"actions":{"ctaTry":"Try it now","ctaWatch":"Watch demo","apps":"I am Compatible with:","abilities":"My abilities used:"},"interests":{"title":"What can I help you with?","back":"Back to interests","description":"I can control apps on your desktop and connected devices. Let\'s personalize your experience - what areas interest you most? ","note":"Select all that apply and I\'ll show you the most relevant features and examples for your workflow.","action":"Continue with {{count}} interests","empty":"Select at least one interest.","filter":"Filter by Interests Type","create_design":{"label":"Create & Design","shortLabel":"Design","description":"For artists, marketers, and content creators."},"analyze_report":{"label":"Analyze & Report","shortLabel":"Analyze","description":"For analysts, researchers, and business professionals."},"communicate_collaborate":{"label":"Communicate & Collaborate","shortLabel":"Communicate","description":"For sellers, meetings, and remote teams."},"build_develop":{"label":"Build & Develop","shortLabel":"Develop","description":"For developers, engineers, and technical professionals."},"game_play":{"label":"Game & Play","shortLabel":"Gaming","description":"For gamers, streamers, and media controls."},"learn_teach":{"label":"Learn & Teach","shortLabel":"Learning","description":"For educators, students, and instruction."},"manage_organize":{"label":"Manage & Organize","shortLabel":"Organizing","description":"For project managers, coordinators, and organizers."},"adapt_access":{"label":"Adapt & Access","shortLabel":"Accessibility","description":"For adaptive controls and personalized accessibility needs."},"everything":{"label":"A little bit of everything","shortLabel":"Everything","description":"For general computer users and multi-taskers."}},"capabilities":{"title":"My Core AI Capabilities","description":"I combine advanced AI with powerful input methods to give you seamless control over your apps and devices. Here are some of the things I can do.","voice_controls":{"title":"Voice Controls","description":"I understand natural language commands so you can control any app with your voice.","longDescription":"I let you speak naturally and still get things done. Whether you want to open apps, navigate menus, or trigger workflows, I translate plain English into hands-free and reliable actions."},"smart_dictation":{"title":"Intelligent Dictation","description":"I convert your speech to text with context awareness and formatting.","longDescription":"I listen carefully and capture your words accurately. I add punctuation, fix capitalization, and adapt to your style so your writing looks polished without extra effort."},"ai_text_generation":{"title":"AI Text Generation","description":"I can create emails, documents, code, and creative content on the fly.","longDescription":"I help you draft, summarize, or expand on anything directly in your apps. From emails and notes to code snippets and documents, I make sure you never start from a blank page."},"head_face_controls":{"title":"Head & Face Controls","description":"I let you trigger actions with your head and facial movements.","longDescription":"I translate your natural head movements and expressions into precise input. You can send an email with a smile, turn a page with a nod, or click with a raise of the eyebrows."},"natural_language_voice_clicking":{"title":"Natural Language Voice Clicking","description":"I let you say what you see to click buttons, links, and menus on screen.","longDescription":"When you speak the name of something on your screen, I find it and interact with it for you. No memorized commands \u2014 just describe what you want and I\u2019ll handle the click."},"keyboard_mouse_emulation":{"title":"Keyboard & Mouse Emulation","description":"I emulate keys, clicks, and scrolling so you can control apps without hardware.","longDescription":"I send keystrokes, mouse movements, clicks, and scroll events anywhere you need them. Combine me with voice or head controls to fully replace or enhance traditional input devices."},"profiles_personalization":{"title":"Personalization","description":"I remember your preferences and adapt with saved app controls.","longDescription":"I keep track of your favorite apps, commands, and preferences. Switch between app controls automatically or manually, and I\u2019ll always show the right controls for what you\u2019re doing."},"cross_device_connectivity":{"title":"Cross-Device Connectivity","description":"I let you use your phone to control your computer.","longDescription":"I connect your mobile device to your desktop so you can launch commands, dictate, or navigate with ease. Perfect for presentations, remote sessions, or casual use."},"quick_action_buttons":{"title":"Quick Action Buttons","description":"I give you app-aware buttons for fast actions.","longDescription":"I surface context-sensitive buttons that adapt to your app. Whether it\u2019s joining a meeting, sending a message, or creating a new email, I make complex tasks just one click away."},"ai_app_awareness":{"title":"AI App Awareness","description":"I adjust my controls based on the app you\u2019re using.","longDescription":"I pay attention to what\u2019s active on your screen so I can give you the right controls at the right time. No clutter, no guesswork\u2014just what you need, when you need it. All on your device and without sending data to the cloud."},"ai_rewrite":{"title":"AI Rewrite","description":"I can rewrite your text to improve tone, update formatting, or expand on details.","longDescription":"I edit text right where you\u2019re working. I can make it friendlier, more formal, shorter, longer, or more detailed \u2014 whatever you need to get your point across better."},"ai_translation":{"title":"AI Translation","description":"I can translate between languages or even programming languages.","longDescription":"I let you turn text into another spoken language or convert code into another programming language. I work in place, so you don\u2019t have to leave the app you\u2019re using."},"head_mouse":{"title":"Head Mouse","description":"I let you move your mouse cursor with head movements.","longDescription":"I smoothly translate your head motion into cursor motion. With features like glide and sensitivity tuning, I give you precise, comfortable, hands-free control."},"head_joystick":{"title":"Head Joystick","description":"I let you use your head as a joystick for games or apps.","longDescription":"I map your head movements onto joystick axes so you can play games or control creative software without hardware. You move naturally, and I translate it into analog input."},"mcp_agent":{"title":"MCP Agent","description":"I can connect with external AI agents through the Model Context Protocol (MCP).","longDescription":"I speak the Model Context Protocol, which lets me work alongside other AI agents and tools. That means I can coordinate tasks, exchange context, and extend my abilities with specialized external systems \u2014 all while keeping you in control."},"byo_ai_integration":{"title":"Bring Your Own AI","description":"I let you enhance my existing AI with your own AI models or services to use with me.","longDescription":"If you already have an AI service, model, or provider you trust, I can integrate it into my workflow. I give you the flexibility to choose the engine that powers generation, rewriting, or translation\u2014whether it\u2019s cloud, local, or custom. When you are offline or if the service is unavailable, I can fall back to my built-in capabilities."},"workflows":{"title":"Workflows","description":"I help you chain together actions into repeatable workflows.","longDescription":"I let you design and run multi-step processes that connect different inputs, commands, and outputs. With workflows, you can automate routine tasks or create complex interactions\u2014triggered by your voice, or gestures \u2014 so I do the heavy lifting for you."},"showMore":"Show More","showLess":"Show Less"},"listing":{"title":"Use Cases","titleLong":"Explore How I Can Help You","recommended":"Recommended For You","exploreMore":"Explore More Use Cases","description":"Discover everything I can do to enhance your workflow. From productivity boosts to creative assistance, find the perfect use cases tailored to your needs.","all":"All","search":"Search use cases, apps, or capabilities...","noResults":"No results found. Try adjusting your search or filters.","emptyAction":"View More Online"},"examples":{"universalAppControl":{"title":"Universal App Control","description":"Control any application on your computer with voice commands and smart automation","descriptionLong":"Take control of any application with powerful voice commands and intelligent automation. Our Universal App Control system learns how you work and adapts to your needs, making complex tasks simple and routine actions instant. From managing your productivity suite to controlling media and gaming applications, this feature works across your entire digital environment."},"handsFreeComputerControl":{"title":"Hands-Free Computer Control","description":"Complete computer control using head movements, voice, and eye tracking for accessibility","descriptionLong":"Experience a new level of computer accessibility with our hands-free control system. Using a combination of advanced eye tracking, precise head movement detection, and voice commands, this feature allows anyone to fully control their computer without using their hands. Perfect for users with mobility impairments, multitaskers, or anyone who wants to use their computer in a new way."},"replyToSocialMediaPosts":{"title":"Faster Social Media Posts and Replies with Dictation","description":"Reply to any social media post using intelligent dictation for quick responses.","descriptionLong":"Cephable\u2019s intelligent dictation makes it faster to post and comment on social media with voice-to-text. Dictation works in any text box or post field, letting you stay active on social media without it taking over your day."},"clinicalNoteTaking":{"title":"HIPAA-Compliant Dictation and Formatting for Clinicians","description":"Save time by taking clinical notes between sessions using intelligent voice controls and dictation. Then, auto format notes in SOAP style.","descriptionLong":"Looking for HIPAA-compliant dictation software? Cephable helps clinicians document patient notes quickly with intelligent voice controls and automatic formatting. Create SOAP notes, progress reports, and logs\u2014all hands-free.","upgrade":{"description":"Upgrade to access HIPAA-compliant, offline Intelligent Tasks for auto formatting."}},"vibeCoding":{"title":"From Thought to Code: Dictation for Developers & Vibe Coders","description":"Vibe Code with dictation and AI text generation to write boilerplate code and prototype faster.","descriptionLong":"Cephable Dictation helps developers move from thought to code faster. This demo shows how voice commands can generate components, dashboards, and more inside tools like Vercel V0, GitHub Copilot in VS Code, Base 44, and Lovable. Dictate your ideas, then refine with code.","upgrade":{"description":"Upgrade to access offline Intelligent Tasks for in-app code rewrite, generation, and translations."}},"controllingBackgroundMusic":{"title":"Media Controls: Manage Music, Video, and more without Interrupting Your Flow","description":"Manage your background music using voice controls and quick actions while staying focused on the present task.","descriptionLong":"Cephable voice commands make it easy to play, pause, skip, and control volume in Spotify hands-free. Quick action buttons and out-of-the-box controls also work across other apps like Apple Music, YouTube, and Netflix and 200+ other apps!"},"editingVideos":{"title":"Video Editing with Voice","description":"Improve your video editing workflow using voice controls to navigate, cut, and edit faster.","descriptionLong":"Focus on the story, not the clicks. Cephable voice controls streamline video editing across the tools you already use\u2014Clipchamp, Adobe, iMovie, DaVinci Resolve, and more. Faster edits, fewer steps."},"inboxTriage":{"title":"AI Email Assistant: Automate, Draft & Reply Faster","description":"Manage your inbox using voice controls and On-Device AI text generation to triage, write, and edit emails.","descriptionLong":"Speed up your email process with private on-device AI. Cephable combines voice commands, dictation, quick action buttons, and text generation to make managing your inbox faster and easier. Delete emails, draft replies, and generate creative responses hands-free in Outlook, Gmail, and more.","upgrade":{"description":"Upgrade to access offline Intelligent Tasks for auto formatting, content generation, translations, and more."}},"summarizingReports":{"title":"Summarize Confidential Reports with Private, On-Device AI","description":"Summarize lengthy reports to your team while staying private and on-device using AI text generation.","descriptionLong":"Turn long reports into clear team updates with on-device AI. Cephable extracts key points and numbers, then generates concise summaries you can share directly with your team. All processing happens on your device, so your sensitive data stays secure."},"handsFreeMeeting":{"title":"Reduce Meeting Fatigue with Hands-Free Controls","description":"Control your video meetings using voice commands, quick action buttons, and smart dictation.","descriptionLong":"Stay focused in meetings\u2014without clicking through menus. Cephable brings voice commands and quick action buttons to Microsoft Teams, Zoom, Google Meet, and more. Mute/unmute, toggle video, send chat messages, raise your hand, and navigate meeting windows hands-free with ready-to-use controls you can customize for your workflow."},"spreadsheetReviews":{"title":"Work Faster in Spreadsheets with Voice Controls & AI Automation","description":"Review and edit large spreadsheets quickly using voice controls for navigation, formatting, filtering, and editing.","descriptionLong":"Cephable brings voice controls and quick action buttons to Excel, Google Sheets, and other spreadsheet tools. Review, edit, comment quickly, trigger macros and shortcuts, and customize commands for your workflow. Hundreds of controls are ready to use instantly or tailored to your setup."},"socialMediaWriting":{"title":"Content Creation and Research with Private, On-Device AI","description":"Draft and Write Social Media Posts using voice controls and AI text generation for engaging content.","descriptionLong":"Create content securely with Cephable\u2019s on-device AI\u2014no cloud required. Instantly generate or rewrite social posts, emails, taglines, and documentation directly inside your favorite tools. Everything runs locally, so your sensitive content stays private and you can work anywhere."},"fpsGamePlay":{"title":"Play FPS Games with Voice Controls","description":"Play and customize a first-person shooter game using voice controls for movement, aiming, and shooting.","descriptionLong":"Experience a new way to play first-person shooter games with voice controls. Use your voice to move, aim, and shoot, allowing for a more immersive and hands-free gaming experience."},"customizingGameControls":{"title":"Customizing RPG Game Controls","description":"Customize role play game controls for better accessibility and game play.","descriptionLong":"Tailor your gaming experience with customizable controls that enhance accessibility and gameplay. Adjust settings to suit your preferences and play style, ensuring a comfortable and enjoyable gaming session."},"webBrowsing":{"title":"Hands-Free Web Browsing with Cephable | Plan Trips, Shop Online, and More","description":"Browse the web hands-free using voice controls to navigate, scroll, and fill forms.","descriptionLong":"Search, shop, and plan without typing. Cephable\u2019s intelligent voice controls work in any browser\u2014whether booking flights, shopping online, or researching your next trip."},"documentCode":{"title":"Fast, Secure Code Documentation with On-Device AI Text Generation","description":"Document code without sending sensitive data to the cloud, while staying in the same app using Cephable\'s Intelligent Rewrite.","descriptionLong":"Cephable\u2019s Intelligent Rewrite creates developer documentation directly from code\u2014without sending sensitive data to the cloud. Generate README files, Markdown docs, and API references quickly and securely, all within the app."},"generateCode":{"title":"Fast, Secure Code Generation with On-Device AI Text Generation","description":"Prototype code snippets from ticket requirements using AI Intelligent Tasks.","descriptionLong":"Cephable lets you turn ticket requirements into working code in any language. Use Intelligent Tasks to scaffold code, generate documentation, and add unit tests automatically. Work across programming languages and apps without losing context."},"editingImages":{"title":"Faster Editing in Creative Apps with Voice Controls and Dictation","description":"Edit images and designs using voice controls and smart dictation, for faster iterations.","descriptionLong":"Bring your visual ideas to life with voice controlled image editing. Navigate faster, and iterate on designs without having to click through complex menus."},"requirementDocsFromMeeting":{"title":"From Notes to Product Requirement Docs in Minutes using On-Device AI","description":"Save hours by transforming raw meeting transcripts into structured product requirement documents in minutes.","descriptionLong":"Cephable transforms raw meeting transcripts into structured product requirement documents in minutes using Intelligent Tasks. Capture product, marketing, and user needs quickly and keep confidential discussions private with on-device AI. Save results as new documents instantly."},"gamingVoiceControls":{"title":"Voice Control in WoW | Quick Navigation for Menus, PvP and Dungeon Finder","description":"Control your gameplay using voice commands to navigate menus, initiate PvP battles, and find dungeons.","descriptionLong":"Enhance your gaming experience with voice-controlled management. Use simple voice commands to navigate menus, initiate PvP battles, and find dungeons, allowing you to focus on your gameplay while maintaining full control."},"headMouseMovement":{"title":"Hands-Free Gaming Setup with Head Mouse","description":"Control your mouse cursor using head movements for precise navigation and clicking.","descriptionLong":"Head Mouse controls enable hands-free gaming. Tilt or turn your head to move the cursor, customize speed and sensitivity, and take control without a traditional mouse."},"noteTakingAndDocumentation":{"title":"Note Taking and Document Generation using Private, On-Device AI","description":"Take notes and generate documents using voice controls and AI text generation for efficient writing.","descriptionLong":"Streamline your note taking with intelligent dictation and AI-powered document generation. Quickly create drafts, outlines, and polished documents, so you can focus on ideas instead of formatting. All processing happens on-device for privacy and security.","upgrade":{"description":"Upgrade to access offline Intelligent Tasks for formatting, content iteration, and more."}},"presentationControls":{"title":"Hands-Free Presentation Controls with Voice Commands & Quick Actions","description":"Control your presentations using voice commands to navigate slides, start/stop presentations, and highlight points.","descriptionLong":"Deliver presentations with confidence using voice commands. Navigate slides, start and stop presentations, and highlight key points\u2014all without touching your computer."},"designingFliers":{"title":"Designing in Creative Apps","description":"Create and edit designs using voice controls and smart dictation for faster iterations.","descriptionLong":"Bring your creative vision to life with voice-controlled design tools. Effortlessly navigate, edit, and iterate on your designs without getting lost in complex menus\u2014so you can focus on creativity, not clicks."},"motionDesign":{"title":"Voice Commands for Motion Design and Animation","description":"Animate scenes and control keyframes using intuitive voice controls for seamless motion design.","descriptionLong":"Bring movement to your ideas with voice controls and animation tools. Effortlessly control timelines, keyframes, and effects so you can focus on storytelling and visual rhythm instead of complex interfaces."}}}');


var $2e86342825d3cea0$exports = {};
$2e86342825d3cea0$exports = JSON.parse('{"logo":"logo Cephable","add":"Agregar","all":"Todo","edit":"Editar","create":"Crear","delete":"Borrar","next":"Pr\xf3ximo","previous":"Anterior","search":"Buscar","loading":"Cargando...","reload":"Recargar","cancel":"Cancelar","copy":"Copiar","save":"Listo","saveAndFinish":"Guardar y Finalizar","saveAndContinue":"Guardar y Continuar","saved":"Salvado","done":"Hecho","back":"Atr\xe1s","play":"Jugar","pause":"Pausa","success":"\xc9xito","continue":"Continuar","options":"Opciones","share":"Compartir","finish":"Finalizar","finishEdit":"Lo termin\xe9","advancedOptions":"Ver Opciones Avanzadas","authenticating":"Autenticando...","skip":"Omitir","close":"Cerca","notFound":"P\xe1gina no encontrada","notFoundDescription":"\xa1Oh, no! \xa1Hemos buscado por el mar y no encontramos tu p\xe1gina!","exitSetup":"Salir de la configuraci\xf3n","experimental":"Experimental","letGetStarted":"\xa1Empecemos!","exploreInputControls":"Explorar los controles de entrada","when":"Cuando yo ...","thenMacro":"Cephable ejecutar\xe1...","controls":"Los Controles","welcome":"Bienvenido.","beta":"beta","macroEmpty":"No hay macros que igualan con este criterio.","you":"T\xfa","step":"Paso","steps":"Pasos","learnMore":"Aprende M\xe1s","dangerZone":"Zona Peligrosa","connected":"Conectado","notConnected":"No conectado","connectAndLearn":"Con\xe9ctate y Aprende","tryAgain":"Probar otra vez","by":"Por {{value}}","noName":"- sin nombre -","details":"Detalles","controlFeed":"Controlar la alimentaci\xf3n","wifi":{"disconnected":"El wifi est\xe1 desconectado.","connected":"Wi-Fi est\xe1 conectado.","description":"Con\xe9ctese a una red Wi-Fi para que Cephable funcione con sus conexiones y software. Es posible que tenga limitaciones para usar sus controles actuales."},"signalR":{"disconnected":"La sincronizaci\xf3n est\xe1 desconectada.","action":"Reconectar","description":"Parece haber un problema con la sincronizaci\xf3n de Cephable. Esto causar\xe1 problemas al guardar la configuraci\xf3n o comunicarse con otras conexiones.","disconnectedDevice":"No se puede sincronizar con {{name}}.","disconnectedDeviceDescription":"Parece haber un problema con la sincronizaci\xf3n, ya sea por autenticaci\xf3n o por conexi\xf3n a internet. No se pueden enviar ni recibir datos de forma remota. Debe verificar ambos lados de la conexi\xf3n.","connected":"La sincronizaci\xf3n est\xe1 conectada.","connectedDescription":"Cephable se sincroniza correctamente y deber\xeda comunicarse con sus conexiones y extensiones como se espera.","swap":"Cambiar a la conexi\xf3n del dispositivo local","unlinkedDevice":"Conexi\xf3n eliminada.","unlinkedDeviceDescription":"Esta conexi\xf3n ha sido desvinculada de su cuenta."},"billing":{"title":"Facturaci\xf3n","expires":"Pr\xf3xima facturaci\xf3n: {{value}}","isEmployeeAccess":{"title":"Profesional","titleLong":"Cephable Profesional","short":"Pro","description":"Cephable Professional brinda a los usuarios mayor poder de productividad, extendiendo la IA local y privada a capacidades generativas.","supportedFeatures":{"tag":"Todo en Plus, m\xe1s","features":["Flujos de trabajo de IA en el dispositivo","gesti\xf3n de organizaciones empresariales","Restricciones empresariales","Instalaciones ilimitadas en dispositivos","Controles de aplicaci\xf3n preentrenados ilimitados"]}},"isDeveloperAccess":{"title":"Kit de desarrollo de software","titleLong":"Kit de desarrollo de software de Cephable","short":"Kit de desarrollo de software (SDK)","description":"Los SDK de Cephable le permiten integrar poderosos controles adaptativos (voz, rostro, cabeza y m\xe1s) en su software con un esfuerzo m\xednimo y un beneficio m\xe1ximo.","supportedFeatures":{"tag":"Todo en Plus, m\xe1s","features":["Compatibilidad con Windows y macOS","SDK livianos e integrables para entrada de voz, rostro, cabeza y acci\xf3n r\xe1pida sin conexi\xf3n","Compatibilidad de API/webhook para acciones de salida personalizadas","Documentaci\xf3n para desarrolladores","Proyectos de muestra","Convierta los comandos en automatizaci\xf3n y navegaci\xf3n de documentos","Portal para desarrolladores para administrar sus proyectos, clientes de autenticaci\xf3n, tipos de dispositivos y m\xe1s"]}},"isStudentAccess":{"title":"Alumno","titleLong":"Educaci\xf3n Cefaleable","short":"Educaci\xf3n","description":"Cephable Education promueve el aprendizaje personalizado y las aulas inclusivas. Cephable funciona sin conexi\xf3n, se ejecuta en el dispositivo y no requiere integraciones de terceros.","supportedFeatures":{"tag":"Todo en Plus, m\xe1s","features":["Instalaciones ilimitadas de dispositivos","Controles de aplicaci\xf3n ilimitados previamente entrenados","Uso compartido ilimitado de controles de aplicaciones personalizados"]}},"viewProducts":"Ver productos","description":"Administre la facturaci\xf3n de su organizaci\xf3n, asientos, actualizaciones de suscripciones, renovaciones o cancelaciones.","view":"Administrar la facturaci\xf3n","isResellerAccess":{"title":"Revendedor","titleLong":"Revendedor de Cephable","description":"Cephable Reseller es una licencia paga que le permite crear nuevas organizaciones y asignar claves de licencia. Esto incluye el uso de Cephable con su propio paquete de software y la mejora de su experiencia de usuario.","short":"Revendedor"},"error":"Comun\xedquese con el administrador del sistema para administrar su facturaci\xf3n.","included":"Incluido con su licencia {{licenseType}}.","upgrade":{"description":"Actual\xedzate ahora y lleva tus controles al siguiente nivel.","action":"Actualizar ahora","error":"Error al actualizar. Int\xe9ntalo de nuevo m\xe1s tarde.","requiredDetail":"Se requiere una licencia {{licenseType}} para esta funci\xf3n. Siempre puedes actualizarla o iniciar una prueba gratuita en la configuraci\xf3n de tu cuenta.","enableTextGeneration":"Genera contenido usando IA y tu voz.","longDescription":"Actualice a una licencia de pago para acceder a todas las funciones de Cephable. Desde m\xfaltiples dispositivos hasta controles avanzados e integraciones personalizadas, Cephable tiene todo lo que necesita para alcanzar el siguiente nivel de productividad.","compare":"Comparar planes","enableAiDictation":{"title":"Actualice al dictado inteligente","description":"Actual\xedzate para desbloquear el dictado mejorado con IA. Puedo a\xf1adir puntuaci\xf3n, corregir may\xfasculas y adaptarme a tu estilo para que tu escritura se vea impecable sin esfuerzo."}},"isPlusAccess":{"title":"M\xe1s","titleLong":"Cephable Plus","short":"M\xe1s","description":"Cephable Plus es para usuarios avanzados que desean lograr m\xe1s con voz inteligente, dictado inteligente, cientos de controles de aplicaciones y m\xe1s.","supportedFeatures":{"tag":"Todo lo del B\xe1sico, m\xe1s","features":["Controles de voz inteligentes (lenguaje natural)","Dictado inteligente (mejorado con IA)","Tareas inteligentes (generaci\xf3n, traducci\xf3n, reescritura)","Cientos de controles de aplicaciones preentrenados"]}},"personal":{"short":"B\xe1sico","title":"B\xe1sico","titleLong":"Cephable Basic","description":"Cephable Basic es gratuito para siempre y est\xe1 dise\xf1ado para ayudarte a moverte m\xe1s r\xe1pido, expresarte y lograr tus objetivos a tu manera. Las funciones incluidas en la versi\xf3n b\xe1sica est\xe1n disponibles para todos los usuarios.","upgrade":{"title":"Lleva tus controles al siguiente nivel","description":"Actual\xedzate a Plus o Pro para desbloquear todas mis funciones. M\xe1s precisi\xf3n. M\xe1s conexiones. M\xe1s controles. M\xe1s potencia para llevar tu productividad al siguiente nivel.","featureHeading":"As\xed es como puedo ayudarte:","control":"Te muevo por las apps y herramientas m\xe1s r\xe1pido usando tu voz o acciones r\xe1pidas, sin interrupciones. Con Voz Inteligente, podemos simplemente chatear.","create":"Reescribo, dicto, genero y traduzco directamente dentro de tus aplicaciones, sin necesidad de copiar, pegar ni cambiar de pantalla.","automate":"Ejecuto tareas inteligentes y acciones r\xe1pidas que agilizan tu flujo de trabajo. Desde comandos sencillos hasta macros complejas, me encargo del trabajo pesado para que puedas concentrarte en el trabajo que importa.","local":"Toda la IA es local. Sin procesamiento en la nube."}},"mostPopular":"M\xe1s populares","subscription":{"options":"Opciones de suscripci\xf3n","monthly":"Pagar mensualmente","billedMonthly":"/mes","yearly":"Pagar anualmente","billedYearly":"/a\xf1o"}},"organization":{"title":"Organizaci\xf3n","titlePlural":"Organizaciones","titleLong":"Cephable Profesional para Organizaciones","description":"Las organizaciones son grupos de usuarios que pueden colaborar en proyectos y compartir recursos. Puede administrar tu equipo, perfiles de equipo, facturaci\xf3n y m\xe1s aqu\xed.","noAccess":{"title":"Acceso denegado.","description":"Tus permisos cambiaron recientemente y ya no tienes acceso a esta funci\xf3n. Si cree que se trata de un error, comun\xedquese con el administrador de tu organizaci\xf3n."},"member":{"title":"Miembro","titlePlural":"Miembros","me":"Mi membres\xeda","description":"Los miembros son usuarios que forman parte de tu organizaci\xf3n. Se les puede asignar roles diferentes y tener acceso a diferentes partes de la organizaci\xf3n.","edit":"Editar miembros","removed":"Has sido eliminado de un equipo.","removedDescription":"Has sido eliminado del equipo. Ya no puedes acceder a la organizaci\xf3n. Si cree que se trata de un error, comun\xedquese con el administrador de tu organizaci\xf3n.","updated":"\xc9xito, la membres\xeda de {{value}} ha sido actualizada.","error":"Error al actualizar la membres\xeda de {{value}}.","delete":"\xc9xito, {{value}} ha sido eliminado.","deleteError":"Error al eliminar {{value}}.","deleteConfirmation":{"title":"\xbfEst\xe1 seguro de que desea eliminar este miembro?","description":"Una vez que elimines a este miembro, ya no tendr\xe1 acceso a la organizaci\xf3n. Siempre podr\xe1s volver a invitarlo m\xe1s tarde.","confirm":"S\xed, eliminar miembro"},"viewAll":{"title":"Ver todos los miembros","description":"Vea todos los miembros de su organizaci\xf3n y administre sus roles y permisos."},"seats":{"title":"Asientos de miembros","description":"Cada miembro de tu organizaci\xf3n tiene un puesto. El administrador de la organizaci\xf3n puede cambiar el tipo de permisos que tienen.","stats":"asientos fuera de {{value}}","max":"M\xe1ximo de asientos","current":"Asientos actuales","limit":{"title":"Se alcanzaron los asientos m\xe1ximos","description":"Tu plan actual ha alcanzado el l\xedmite de {{ maxSeats }} asientos disponibles. No puedes invitar a m\xe1s miembros. Ponte en contacto con tu administrador para actualizar el plan o administrar la asignaci\xf3n de asientos."},"updateLimit":{"title":"Actualice su plan para agregar m\xe1s asientos","description":"Tu plan actual ha alcanzado la cantidad m\xe1xima de plazas: {{ maxSeats }}. Actualiza ahora para desbloquear plazas adicionales y garantizar que tu equipo pueda seguir creciendo sin problemas.","action":"Plan de actualizaci\xf3n"},"maxSeatValue":"M\xe1ximo de asientos: {{value}}"},"aboutMe":"Acerca de m\xed","loadError":"Error al cargar miembros de la organizaci\xf3n.","orgTitle":"Miembros de {{value}}","emailExists":"El correo electr\xf3nico ya existe en la organizaci\xf3n. Por favor escribe un correo electr\xf3nico diferente."},"invite":{"title":"Invitar","titlePlural":"invita","description":"Se env\xedan invitaciones a los usuarios para que puede particpan a tu organizaci\xf3n. Puede invitar a usuarios a participar a tu organizaci\xf3n y asignarles diferentes roles.","edit":"Crear nueva invitaci\xf3n","view":"Ver todas las invitaciones","emailRequired":"Correo Electronico es requerido","emailInvalid":"El correo electr\xf3nico es invalido. Por favor, escribe un correo electr\xf3nico v\xe1lida.","emailExists":"El correo electr\xf3nico ya tiene una invitaci\xf3n de la organizaci\xf3n. Por favor, escribe una direcci\xf3n de correo electr\xf3nico diferente.","emailPlaceholder":"Escribe tu correo electr\xf3nico","expiration":"Vence ","delete":"Eliminar invitaci\xf3n","confirm":"\xbfEst\xe1s seguro a eliminar esta invitaci\xf3n?","confirmLong":"Una vez que elimine esta invitaci\xf3n, el usuario ya no podr\xe1 participar en la organizaci\xf3n. Siempre puedes volver a invitarlos m\xe1s tarde.","accept":"Aceptar invitaci\xf3n","acceptSuccess":{"title":"Bienvenido al equipo.","description":"Te has unido exitosamente a la organizaci\xf3n. ","action":"Ver tu nueva organizaci\xf3n"},"acceptError":{"title":"Oops. Parece que hay un problema.","description":"Hubo un error al unirse a la organizaci\xf3n. Por favor, volver a probar m\xe1s tarde. Si el problema persiste, comun\xedquese con el administrador de tu organizaci\xf3n. ","action":"Volver a la p\xe1gina principal"},"send":{"success":"Invitaci\xf3n a {{value}} enviada.","error":"Error al enviar la invitaci\xf3n a {{value}}.","title":"Enviar invitaci\xf3n"},"viewDescription":"Ver todas las invitaciones actuales que no han sido aceptadas.","new":"Invitar a un miembro","stat":"invitaciones activas","noInvites":{"title":"Sin invitaciones.","description":"Parece que no hay invitaciones activas para tu organizaci\xf3n."},"error":"Error al cargar invitaciones.","orgTitle":"Invitaciones de {{ value }}","editDescription":"Crea una nueva invitaci\xf3n para que un usuario se una a tu organizaci\xf3n. Las invitaciones caducan autom\xe1ticamente a los 7 d\xedas."},"role":{"title":"Role","titlePlural":"Roles","description":"Los roles son los diferentes niveles de acceso que puede tener un usuario en tu organizaci\xf3n. Puede asignar diferentes roles a los usuarios para controlar lo que pueden hacer."},"isAdmin":{"title":"Administraci\xf3n","description":"Los administradores tienen acceso completo a la organizaci\xf3n y pueden manager todos los aspectos de la organizaci\xf3n.","conflict":"Este miembro es un administrador. No tienes permiso para editar tus roles."},"canViewMembers":{"title":"Ver miembros","description":"Los usuarios con este permiso pueden ver a todos los miembros de la organizaci\xf3n."},"canInviteMembers":{"title":"Invitar a los miembros","description":"Los usuarios con este permiso pueden invitar a nuevos miembros a la organizaci\xf3n y administrar las invitaciones existentes."},"canChangeMemberPermissions":{"title":"Cambiar roles de miembros","description":"Los usuarios con este permiso pueden cambiar el role de otros miembros de la organizaci\xf3n."},"canRemoveMembers":{"title":"Eliminar miembros","titleSingle":"Eliminar miembro","action":"Eliminar","description":"Los usuarios con este permiso pueden eliminar a otros miembros de la organizaci\xf3n.","confirm":"\xbfEst\xe1 seguro a eliminar a este miembro de la organizaci\xf3n?","confirmLong":"Una vez que elimines a este miembro, ya no tendr\xe1 acceso a la organizaci\xf3n. Siempre puedes volver a invitarlos m\xe1s tarde."},"canCreateAuthClients":{"title":"Crear clientes de autenticaci\xf3n","description":"Los usuarios con este permiso pueden crear nuevos clientes de autenticaci\xf3n para la organizaci\xf3n."},"canManageBilling":{"title":"Administrar facturaci\xf3n","description":"Los usuarios con este permiso pueden administrar la configuraci\xf3n de facturaci\xf3n de la organizaci\xf3n.","error":"No tienes permiso para administrar la facturaci\xf3n de esta organizaci\xf3n."},"metrics":{"lineChart":{"title":"Promedio de Conexiones Concurrentes","description":"Este gr\xe1fico muestra las conexiones simult\xe1neas promedio para la organizaci\xf3n y los datos del proyecto a lo largo del tiempo.","max":"M\xe1ximo de Conexiones: {{maxConnections}}","project":"Total del Proyecto","org":"Organizaci\xf3n Total"},"title":"M\xe9trica","description":"Las m\xe9tricas son puntos de datos que le ayudan a comprender c\xf3mo su organizaci\xf3n utiliza Cephable.","view":"Ver m\xe9tricas","orgTitle":"M\xe9tricas de {{ value }}","manage":{"title":"M\xe9tricas de rendimiento","description":"Descargue o borre las m\xe9tricas de rendimiento recopiladas durante la inferencia del modelo."},"download":{"button":"Descargar m\xe9tricas","success":"El archivo de m\xe9tricas se ha guardado en su carpeta de Descargas.","error":"Error al descargar el archivo de m\xe9tricas.","noFile":"No se encontr\xf3 el archivo de m\xe9tricas. Intente ejecutar el modelo primero."},"clear":{"button":"M\xe9tricas claras","success":"Se han borrado las m\xe9tricas.","error":"No se pudo borrar el archivo de m\xe9tricas.","confirm":{"title":"M\xe9tricas de rendimiento claras","description":"\xbfSeguro que desea borrar todas las m\xe9tricas de rendimiento registradas? Esta acci\xf3n no se puede deshacer.","cancel":"Cancelar","confirm":"M\xe9tricas claras"}}},"noOrg":{"title":"Sin licencia asociada.","description":"Actualmente no est\xe1 asociado a ninguna licencia ni grupo de desarrolladores. El portal est\xe1 limitado a usuarios con una licencia de pago de Cephable. Para aprovechar al m\xe1ximo el potencial de Cephable, inicie una prueba gratuita."},"projects":{"title":"Proyectos","description":"Utilice Proyectos para administrar el acceso seguro, configurar las interacciones de los dispositivos y optimizar la forma en que sus aplicaciones env\xedan y reciben comandos en distintas plataformas.","name":"Nombre de la aplicaci\xf3n","stats":{"title":"Estad\xedsticas del proyecto","connections":"Conexiones totales","all":{"title":"Todas las m\xe9tricas del proyecto","description":"M\xe9tricas agregadas para todos los proyectos asociados con {{ orgName }}"},"card":"proyectos de {{value}}","users":"Total de usuarios desde {{date}}","avgUsers":"Promedio mensual de usuarios.","concurrent":{"title":"Promedio de conexiones simult\xe1neas \xdaltimos {{days}} d\xedas","label":"Promedio simult\xe1neo","max":"Conexiones m\xe1ximas","overage":"Exceso","description":"Las conexiones simult\xe1neas son la cantidad de usuarios conectados a tu proyecto al mismo tiempo. Esta m\xe9trica te ayuda a comprender cu\xe1ntos usuarios est\xe1n usando tu aplicaci\xf3n simult\xe1neamente."}},"projectType":{"title":"Tipo de proyecto","description":"Los tipos de proyecto se utilizan para categorizar sus proyectos y ayudarnos a elegir los SDK adecuados para usted."},"accessDenied":{"generic":"No tienes acceso a este proyecto.","title":"Acceso denegado.","description":"No tienes acceso para ver, crear, editar ni eliminar proyectos. Ponte en contacto con tu administrador para obtener acceso."},"upgrade":{"title":"Actualizaci\xf3n al SDK de Cephable","description":"Cephable se puede integrar directamente en su aplicaci\xf3n, juego o servicio mediante nuestros SDK. Los proyectos no est\xe1n disponibles actualmente con su cuenta. Si cree que hay un error, comun\xedquese con support@cephable.com.","shortDescription":"Los proyectos no est\xe1n disponibles actualmente en tu cuenta. Ponte en contacto con nosotros para actualizar."},"limit":{"title":"\xbfQuieres m\xe1s proyectos?","error":"Se alcanz\xf3 el l\xedmite del proyecto.","description":"Has alcanzado la cantidad m\xe1xima de proyectos para tu organizaci\xf3n. Ponte en contacto con tu administrador para actualizar tu cuenta."},"create":{"title":"Crear proyecto","titleLong":"Empecemos.","first":{"title":"Empiece con su proyecto.","description":"Parece que a\xfan no has creado un proyecto. Las claves y dispositivos de cliente son esenciales para proteger la comunicaci\xf3n entre tus aplicaciones y nuestros servicios. Con una clave de cliente, podr\xe1s integrar controles de voz y de movimiento de la cabeza en tus aplicaciones de forma r\xe1pida y segura."},"details":{"title":"Detalles del proyecto","description":"Cree un nuevo proyecto para administrar la autorizaci\xf3n de su aplicaci\xf3n, las capacidades de los dispositivos y las integraciones de SDK. Siga los pasos a continuaci\xf3n para configurar interacciones seguras y personalizables para sus usuarios."}},"sdk":{"title":"Descargar el SDK","description":"Obtenga acceso a nuestro potente SDK desarrollado para facilitar los controles adaptativos.","select":{"title":"Seleccionar SDK","description":"Seleccione el SDK que desea utilizar para este proyecto. Nuestros SDK permiten una integraci\xf3n perfecta de controles de voz y movimiento de la cabeza adaptables en diferentes plataformas."}},"clients":{"title":"Clientes de autorizaci\xf3n","description":"Los clientes de autorizaci\xf3n administran el acceso seguro a sus aplicaciones. Defina un cliente de autorizaci\xf3n para autenticar a los usuarios y controlar las interacciones con su aplicaci\xf3n.","settings":"Configuraci\xf3n de autorizaci\xf3n","configure":"Configurar el cliente de autorizaci\xf3n","create":"Crear cliente de autorizaci\xf3n","max":"M\xe1ximo de proyectos: {{value}}"},"secret":{"title":"Secreto del cliente","created":"Se ha creado su secreto de cliente.","description":"Su secreto de cliente solo se mostrar\xe1 una vez. C\xf3pielo ahora y gu\xe1rdelo en un lugar seguro. \xdaselo solo para su propio desarrollo. <br> <br> No lo comparta con servicios o aplicaciones de terceros.","copy":"Copiar secreto","rotate":{"title":"Rotar secreto de cliente","description":"ADVERTENCIA: Esta acci\xf3n revocar\xe1 su secreto de cliente existente y crear\xe1 uno nuevo. Para ello, deber\xe1 actualizar todos los datos de uso existentes en todas sus aplicaciones. Esta acci\xf3n no se puede revertir.","error":"Error al rotar el secreto. Int\xe9ntalo de nuevo m\xe1s tarde."}},"key":{"title":"Clave de cliente","view":"Ver clave de cliente","delete":{"title":"Eliminar clave de cliente","description":"ADVERTENCIA: Esta acci\xf3n eliminar\xe1 su clave de cliente existente y todas las configuraciones relacionadas. Esta acci\xf3n no se puede revertir.","error":"Error al eliminar su clave de cliente.","success":"Su proyecto ha sido eliminado."},"copy":"Copiar clave"},"tokenRedirect":{"title":"URL de redireccionamiento de tokens","description":"Las URL de redireccionamiento de tokens son los puntos finales a los que se env\xedan los tokens de acceso una vez completada la autenticaci\xf3n. Estas URL permiten que su aplicaci\xf3n reciba de forma segura los tokens necesarios para acceder a los datos y servicios del usuario."},"authRedirect":{"title":"URL de redireccionamiento de c\xf3digo de autorizaci\xf3n","description":"La URL de redireccionamiento de c\xf3digo de autorizaci\xf3n es el punto final donde se env\xedan los c\xf3digos de autorizaci\xf3n despu\xe9s de que un usuario otorga permiso a su aplicaci\xf3n. Esta URL es esencial en los flujos de OAuth, ya que garantiza la transmisi\xf3n segura del c\xf3digo de autorizaci\xf3n desde el servidor de autorizaci\xf3n a su aplicaci\xf3n, lo que le permite solicitar tokens de acceso en nombre del usuario."},"scopes":{"title":"\xc1mbitos","titleLong":"\xc1mbitos de permisos de API","configure":"Definir alcances","description":"Los \xe1mbitos definen los permisos que tendr\xe1 este cliente de autorizaci\xf3n. Establezca \xe1mbitos para limitar el acceso a datos y funciones espec\xedficos, garantizando que los usuarios solo obtengan el acceso que necesitan.","manage":"Administrar los \xe1mbitos de autorizaci\xf3n"},"deviceScopes":{"title":"Tipos de dispositivos asociados","titleLong":"Tipos de dispositivos permitidos","action":"Agregar nuevo tipo de dispositivo","configure":"Configurar los tipos de dispositivos permitidos","descriptionShort":"Define qu\xe9 tipo de dispositivos pueden acceder a este proyecto.","titles":"Tipos de dispositivos asociados","description":"El tipo de dispositivo define los permisos y niveles de acceso que tiene un dispositivo dentro de su aplicaci\xf3n. Al asignar tipos de dispositivos espec\xedficos, puede controlar las acciones y los datos a los que puede acceder cada dispositivo, lo que garantiza que su aplicaci\xf3n se mantenga segura y cumpla con sus pol\xedticas de privacidad."},"deviceType":{"title":"Tipos de dispositivos","description":"Un DeviceType define una categor\xeda de dispositivos, detallando sus capacidades de entrada/salida y las funciones admitidas (por ejemplo, voz, gestos, tipos de controlador). Garantiza que solo los dispositivos autorizados puedan interactuar con una aplicaci\xf3n, lo que permite un acceso limitado a trav\xe9s de configuraciones de dispositivos espec\xedficos, como Xbox o PlayStation.","action":"Crear tipo de dispositivo","name":"Nombre del tipo de dispositivo","descriptionLong":"Descripci\xf3n del tipo de dispositivo","features":{"title":"Funciones compatibles","description":"Define las entradas y salidas que admite tu aplicaci\xf3n. Esto nos ayuda a optimizar la experiencia del usuario en Cephable.","supportsVoiceInput":"Entrada de voz","supportsPhysicalInput":"Entrada f\xedsica","supportsKeyboardOutput":"Salida del teclado","supportsPlayStationControllerOutput":"Mando de PlayStation","supportsFaceInput":"Entrada de cara","supportsGestureInput":"Entrada de gestos","supportsXboxControllerOutput":"Mando Xbox","supportsDigitalExtensions":"Extensiones digitales","supportsPhysicalExtensions":"Extensiones f\xedsicas","supportsNintendoControllerOutput":"Mando de Nintendo","supportsGenericControllerOutput":"Salida del controlador gen\xe9rico"},"canAutoStart":{"title":"Admite arranques de control autom\xe1tico","description":"[canAutoStart] si est\xe1 habilitado, el SDK verificar\xe1 la configuraci\xf3n del usuario e intentar\xe1 iniciar inmediatamente los controles de la c\xe1mara o el micr\xf3fono despu\xe9s de que el usuario inicie sesi\xf3n."},"isSupported":{"title":"Activo","description":"[isSupported] Si est\xe1 deshabilitado, Cephable ya no enviar\xe1, recibir\xe1 ni reconocer\xe1 ning\xfan dispositivo de usuario asociado con esto. Equivale a obsoleto."},"locale":{"title":"Idioma predeterminado","description":"[defaultLocale] La configuraci\xf3n regional predeterminada para este tipo de dispositivo. Se utilizar\xe1 como idioma predeterminado para el dispositivo.","support":"Admite idiomas","warn":"**Parece que tienes configurados controles personalizados. Aseg\xfarate de haber actualizado los controles personalizados para los idiomas asociados.**","name":"{{lang}} - Nombre del tipo de dispositivo","langDescription":"{{lang}} - Descripci\xf3n"},"customControls":{"title":"Controles personalizados","object":"{{lang}} - Objeto de controles personalizados","description":"Los controles personalizados son una opci\xf3n avanzada que permite a los usuarios configurar y editar manualmente los controles de la aplicaci\xf3n asociados a este dispositivo. Si desea que los usuarios controlen su dispositivo directamente desde Cephable, debe registrar los controles de su dispositivo aqu\xed. Consulte la API de Cephable para obtener m\xe1s informaci\xf3n sobre las opciones."},"success":{"title":"\xa1\xc9xito!","description":"Ha creado un nuevo tipo de dispositivo. {{name}} Ahora puede actualizar el alcance del dispositivo de su cliente de autorizaci\xf3n seg\xfan sea necesario."},"id":"Identificaci\xf3n del tipo de dispositivo","throttleRules":{"title":"Reglas del acelerador de comandos","description":"Configure reglas de limitaci\xf3n para controlar el flujo de comandos y las restricciones de entrada para este tipo de dispositivo.","disableVoiceInput":"Desactivar la entrada de voz","disableHotkeyInput":"Deshabilitar la entrada de teclas de acceso r\xe1pido","disableCameraInput":"Desactivar la entrada de la c\xe1mara","disableMultiInputs":"Deshabilitar entradas m\xfaltiples","maximumCommandsPerSecond":"M\xe1ximos comandos por segundo","maximumCommandsPerMinute":"M\xe1ximos comandos por minuto","maximumMacroLength":"Longitud m\xe1xima de macro"}},"view":"Ver proyectos","error":"Error al cargar proyectos.","type":{"title":"Tipo de implementaci\xf3n"},"originHost":{"title":"Origen del anfitri\xf3n","description":"La URL que servir\xe1 como fuente principal de solicitudes y datos durante las interacciones de la API."},"orgTitle":"Proyectos de {{ value }}"},"viewOrganization":"Ver Organizaci\xf3n","update":"\xa1Tu organizaci\xf3n ha sido actualizada! Actualizando la aplicaci\xf3n.","error":"Error al cargar la organizaci\xf3n. Int\xe9ntalo de nuevo m\xe1s tarde.","new":{"name":{"label":"Nombre de la organizaci\xf3n","placeholder":"Introduzca el nombre de su organizaci\xf3n"},"description":{"label":"Descripci\xf3n de la organizaci\xf3n","placeholder":"\xbfCu\xe1les son sus objetivos al utilizar Cephable Professional?"},"details":"Detalles de la organizaci\xf3n"},"expired":{"user":"Parece que su licencia de Cephable ha expirado, por lo que ha cambiado a la versi\xf3n gratuita de Cephable Basic. Para renovarla, p\xf3ngase en contacto con el administrador de su organizaci\xf3n.","admin":"Parece que su licencia de Cephable ha expirado, por lo que ha cambiado a la versi\xf3n gratuita de Cephable Basic. Renueve su licencia para seguir usando funciones avanzadas m\xe1s all\xe1 de Cephable Basic.","multiple":"Parece que sus licencias de Cephable han expirado, por lo que ha cambiado a la versi\xf3n gratuita de Cephable Basic. Renueve al menos una de sus licencias para seguir usando funciones avanzadas m\xe1s all\xe1 de Cephable Basic.","dialog":{"title":"Seleccione una organizaci\xf3n","description":"Tiene varias organizaciones asociadas a su cuenta. Seleccione la organizaci\xf3n que desea renovar."},"title":"Su licencia de Cephable ha expirado","titlePlural":"Sus licencias de Cephable han expirado","banner":"Parece que tu licencia de Cephable ha caducado, por lo que has cambiado a la versi\xf3n gratuita de Cephable Basic. Al renovarla, tendr\xe1s acceso a funciones como controles de voz mejorados, tareas inteligentes con IA y muchos controles de aplicaciones predefinidos."},"orgName":"Nombre de la organizaci\xf3n","menu":{"title":"Men\xfa de la organizaci\xf3n","view":"Ver Men\xfa","expand":"Expandir men\xfa"},"settings":{"title":"Configuraci\xf3n de la organizaci\xf3n","description":"Administre la facturaci\xf3n, el nombre, la descripci\xf3n y los recursos de su organizaci\xf3n.","view":"Ver configuraci\xf3n","general":{"title":"General"},"resources":{"edit":"Editar recursos","description":"Utilice el editor Markdown a la izquierda para actualizar y dar formato a recursos \xfatiles para todos los miembros de la organizaci\xf3n. A medida que escribe, la vista previa a la derecha mostrar\xe1 c\xf3mo se ver\xe1 su contenido para los usuarios. Puede agregar encabezados, listas, enlaces y otros elementos de formato utilizando la sintaxis Markdown. Los cambios ser\xe1n visibles para los miembros una vez guardados."},"other":{"title":"Otros ajustes","description":"Administre la facturaci\xf3n, el nombre, la descripci\xf3n y los recursos de su organizaci\xf3n."}},"managed":{"title":"Organizaci\xf3n administrada","titlePlural":"Organizaciones gestionadas","description":"Las organizaciones administradas son aquellas que est\xe1n a cargo de un revendedor de Cephable. Los revendedores pueden administrar su equipo, los perfiles del equipo, la facturaci\xf3n y m\xe1s aqu\xed.","error":"Error al cargar organizaciones administradas.","empty":{"title":"No se encontraron organizaciones administradas.","description":"Parece que no hay organizaciones administradas que cumplan con estos criterios o que sus claves de licencia a\xfan no se han activado."},"titleShort":"Administrado"},"canManageChildOrganizations":{"title":"Administrar organizaciones infantiles","description":"Los usuarios con este permiso pueden crear y administrar organizaciones secundarias como administrador."},"canViewAnalytics":{"title":"Ver Anal\xedtica","description":"Los usuarios con este permiso pueden ver las m\xe9tricas y los an\xe1lisis de la organizaci\xf3n."},"create":"Crear nueva organizaci\xf3n","orgCustomBillingUrl":{"title":"URL de facturaci\xf3n personalizada","description":"Esta es una URL personalizada que se utilizar\xe1 para redirigir al usuario a su sistema de facturaci\xf3n (el del revendedor). Debe comenzar con \\"https://\\" o \\"mailTo:\\""},"upgrade":{"existing":{"title":"Eres parte de una licencia existente.","description":"Actualice haciendo clic en `{{action}}` en el men\xfa lateral."}},"restrictions":{"isGenAIDisabled":{"title":"IA generativa deshabilitada","description":"Su organizaci\xf3n ha deshabilitado el acceso a las funciones de IA Generativa. Para m\xe1s informaci\xf3n, p\xf3ngase en contacto con el administrador de su organizaci\xf3n."},"isRemoteControlDisabled":{"title":"Sincronizaci\xf3n entre dispositivos deshabilitada","description":"Su organizaci\xf3n ha deshabilitado el acceso a la sincronizaci\xf3n; no podr\xe1 usar nuestra aplicaci\xf3n complementaria ni controlar dispositivos externos. Para obtener m\xe1s informaci\xf3n, p\xf3ngase en contacto con el administrador de su organizaci\xf3n."}},"troubleshooting":{"title":"Soluci\xf3n de problemas","editorDescription":"[Opcional] Esta es una secci\xf3n que es visible para todos los usuarios a trav\xe9s de la p\xe1gina de detalles de conexi\xf3n en las aplicaciones m\xf3viles y de escritorio de Cephable.","description":"Si tiene problemas con Cephable, pruebe los pasos a continuaci\xf3n para resolver problemas comunes."},"onboarding":{"title":"Incorporaci\xf3n","editorDescription":"[Opcional] La incorporaci\xf3n se muestra a los usuarios cuando se a\xf1ade este tipo de dispositivo a su cuenta. Este es un excelente lugar para proporcionar instrucciones sobre c\xf3mo configurar y usar el tipo de dispositivo con su aplicaci\xf3n."},"documents":"Documentos","completionStatus":{"title":"Estado de finalizaci\xf3n","error":"","complete":"Completo.","incomplete":"Incompleto."},"metadata":{"title":"Metadatos","urlError":"La URL debe comenzar con http:// o https://","metatitle":{"label":"Metat\xedtulo","placeholder":"Introduzca un t\xedtulo corto"},"shortDescription":{"label":"Descripci\xf3n breve","placeholder":"Ingrese una breve descripci\xf3n de vista previa (m\xe1ximo 150 caracteres)"},"externalLink":{"label":"URL del enlace externo","placeholder":"https://ejemplo.com/informaci\xf3n-del-dispositivo","description":"Un enlace directo a un sitio web o recurso externo que proporciona m\xe1s informaci\xf3n sobre c\xf3mo configurar este dispositivo por primera vez. Si lo usa, no usaremos el Markdown de la lista de clientes."},"iconUrl":{"label":"URL del icono del dispositivo","placeholder":"https://ejemplo.com/icono-de-dispositivo.png","description":"Un enlace directo a una imagen que representa este tipo de dispositivo. Este icono se mostrar\xe1 en la aplicaci\xf3n Cephable y en las listas de dispositivos."},"darkModeIconUrl":{"label":"URL del icono del dispositivo en modo oscuro","placeholder":"https://ejemplo.com/icono-de-dispositivo-oscuro.png","description":"Un enlace directo a una imagen que representa este tipo de dispositivo en modo oscuro. Este icono se mostrar\xe1 en la app Cephable y en las listas de dispositivos cuando el usuario tenga activado el modo oscuro."},"editorDescription":"Cuando su dispositivo es seleccionado para aparecer en la aplicaci\xf3n Cephable como una extensi\xf3n o conexi\xf3n, utilizamos esta informaci\xf3n para mostr\xe1rsela a los usuarios que configuran nuevas conexiones."},"client-listing":{"title":"Listado de clientes","editorDescription":"Instrucciones detalladas para que los nuevos usuarios configuren conexiones con este tipo de dispositivo. Este contenido de Markdown se mostrar\xe1 en la aplicaci\xf3n Cephable cuando los usuarios agreguen una nueva conexi\xf3n."},"canAccessOrganizationProfiles":{"title":"Ver controles de la aplicaci\xf3n de la organizaci\xf3n","description":"Los usuarios con este permiso pueden ver los controles de la aplicaci\xf3n de la organizaci\xf3n asociados con esta organizaci\xf3n."},"canEditOrganizationProfiles":{"title":"Administrar controles de aplicaciones de la organizaci\xf3n","description":"Los usuarios con este permiso pueden crear, editar y eliminar controles de aplicaciones de organizaci\xf3n asociados con esta organizaci\xf3n."},"profiles":{"title":"Controles de la aplicaci\xf3n de la organizaci\xf3n","description":"Los controles de aplicaciones de la organizaci\xf3n son perfiles compartidos para distribuir controles de aplicaciones en toda su organizaci\xf3n o para compartirlos con sus usuarios de integraci\xf3n.","view":"Ver controles de la aplicaci\xf3n de la organizaci\xf3n","editDescription":"Edite los controles de la aplicaci\xf3n de la organizaci\xf3n para personalizar la configuraci\xf3n.","empty":"No se encontraron controles de la aplicaci\xf3n de la organizaci\xf3n. Crea uno para empezar.","error":"Error al cargar los controles de la aplicaci\xf3n de la organizaci\xf3n.","titleShort":"Controles de la aplicaci\xf3n"},"canViewAuthClients":{"title":"Ver proyectos","description":"Los usuarios con este permiso pueden ver los clientes de autenticaci\xf3n y los proyectos de la organizaci\xf3n."}},"customControls":{"title":"Controles Globales y Dispositivos","prefixDisclaimer":" Este es un control de prefijo; escuchar\xe1 las palabras despu\xe9s del comando y luego buscar\xe1 en la siguiente frase para encontrar coincidencias.","allowPausedDisclaimer":" Este control funcionar\xe1 incluso cuando el micr\xf3fono est\xe9 en pausa.","conflictIndicators":{"warn":"Atenci\xf3n: ","title":"Se detectaron conflictos de configuraci\xf3n de entrada","globalControls":"Conflictos de configuraci\xf3n de control global","deviceControls":"Conflictos de configuraci\xf3n de control de dispositivos","usedInput":" se utiliza como entrada para ","description":"Algunas de las entradas de los controles globales y de dispositivo que utiliza tambi\xe9n se utilizan en uno o m\xe1s controles de su aplicaci\xf3n. Esto puede causar conflictos al usar Cephable. En estos casos, siempre daremos prioridad al control de la aplicaci\xf3n sobre el control global o de dispositivo.","item":"La entrada <strong>{{value}}</strong> se utiliza en los controles de su aplicaci\xf3n: ","globalDescription":"Los siguientes controles globales tienen entradas en conflicto con los controles de su aplicaci\xf3n.","deviceDescription":"Los siguientes controles del dispositivo tienen entradas en conflicto con los controles de su aplicaci\xf3n."},"globalControls":{"title":"Controles Globales","empty":"T\xfa no tienes controles globales. Puede crear uno ahora.","edit":"Editar Controles Globales","description":"Los controles globales son controles que siempre est\xe1n disponibles, independientemente de la aplicaci\xf3n o el dispositivo que uses. Algunos incluso funcionan cuando los controles del micr\xf3fono o la c\xe1mara est\xe1n en pausa."},"deviceControls":{"title":"Controles del Dispositivo","empty":"T\xfa no tienes controles de dispositivo. Puede crear uno ahora.","edit":"Editar Controles del Dispositivo","controls":{"cephable-open-app":{"success":"Abrir aplicaci\xf3n: {{value}}","error":"No se puede encontrar la aplicaci\xf3n: {{value}}"},"cephable-close-app":{"commands":["cerca"],"name":"Cerrar aplicaci\xf3n por nombre","description":"Utilice este comando con controles de voz para cerrar una aplicaci\xf3n en su computadora por nombre.","success":"Cerrar aplicaci\xf3n: {{value}}","error":"No se puede encontrar la aplicaci\xf3n: {{value}}"},"cephable-minimize-focused-app":{"commands":["minimizar"],"name":"Minimizar la aplicaci\xf3n actual en foco.","description":"Utilice este comando con controles de voz para minimizar la aplicaci\xf3n actual en foco.","success":"\xa1Minimiza el \xe9xito de las aplicaciones enfocadas!","error":"Error al minimizar la aplicaci\xf3n enfocada."},"cephable-maximize-focused-app":{"commands":["maximizar"],"name":"Maximizar la aplicaci\xf3n actual en foco.","description":"Utilice este comando con controles de voz para maximizar la aplicaci\xf3n actual en foco.","success":"\xa1Maximice el \xe9xito de su aplicaci\xf3n enfocada!","error":"Error al minimizar la aplicaci\xf3n enfocada."},"cephable-generate-text":{"commands":["generar"],"name":"Genere texto proporcionando el mensaje que sigue a este comando.","description":"Utilice este comando con controles de voz seguido de su mensaje para generar un texto relacionado."},"cephable-stop-generate-text":{"commands":["dejar de generar","detener la generaci\xf3n","cancelar generar","cancelar generaci\xf3n"],"name":"Deja de generar texto.","description":"Utilice este comando con controles de voz para dejar de generar texto"},"cephable-open-panel":{"commands":["panel de exhibici\xf3n"],"name":"Abra el panel de Cephable","description":"Utilice este comando con controles de voz para abrir el panel de Cephable."},"cephable-close-panel":{"commands":["ocultar panel"],"name":"Ocultar el panel Cephable","description":"Utilice este comando con controles de voz para ocultar o minimizar el panel de Cephable."},"cephable-close-focused-app":{"commands":["corriente cerrada"],"name":"Cierra la aplicaci\xf3n actual en foco.","description":"Utilice este comando con controles de voz para cerrar la aplicaci\xf3n actual en foco.","success":"Cerrar aplicaci\xf3n actual \xa1\xe9xito!","error":"Error al cerrar la aplicaci\xf3n actual."},"cephable-rewrite-text":{"commands":["volver a escribir"],"name":"Reescriba el texto proporcionando la indicaci\xf3n despu\xe9s de este comando.","description":"Utilice este comando con controles de voz seguido de su indicaci\xf3n para reescribir el texto resaltado actual."},"cephable-summarize-text":{"commands":["resumir"],"name":"Resuma el texto proporcionando la instrucci\xf3n siguiente a este comando.","description":"Utilice este comando con controles de voz seguido de su mensaje para resumir el texto resaltado actual."},"cephable-translate-text":{"commands":["traducir"],"name":"Traduzca el texto proporcionando la solicitud despu\xe9s de este comando.","description":"Utilice este comando con controles de voz seguido de su indicaci\xf3n para traducir el texto resaltado actual."},"cephable-click-by-name":{"commands":["grifo","golpear","navegar a","ir a"],"name":"Toque el elemento por nombre","description":"Toque algo en la p\xe1gina por su nombre, como \\"tocar guardar\\" para hacer clic en un bot\xf3n llamado \\"guardar\\"."}},"description":"Los controles del dispositivo est\xe1n vinculados al dispositivo o conexi\xf3n espec\xedficos que uses. Est\xe1n disponibles sin necesidad de a\xf1adirlos a los controles de tu app y son especialmente \xfatiles para funciones o eventos que solo son compatibles con ciertos dispositivos."},"resetControls":{"title":"Restablecer Controles","description":"El idioma de tu voz ha cambiado desde la \xfaltima vez que actualizaste tus controles. Nota: Esto restablecer\xe1 tus controles para que coincidan con {{language}} y es posible que pierdas los comandos personalizados. \xbfEst\xe1s seguro de que deseas restablecerlos?","confirm":"S\xed, restablecer controles","error":"Se produjo un error al restablecer los controles. Int\xe9ntalo nuevamente m\xe1s tarde."},"warn":"El micr\xf3fono no se ha iniciado. Debe iniciarlo para usar los controles globales y del dispositivo.","changeProfile":{"success":"Cambiar los controles de la aplicaci\xf3n: {{value}}","error":"No se pueden encontrar los controles de la aplicaci\xf3n: \'{{value}}\'"},"descriptionShort":"Los controles globales y de dispositivo son acciones siempre disponibles, dise\xf1adas para funcionar en cualquier software. Los controles globales, como \\"Detener c\xe1mara\\", se aplican a todo el sistema y son independientes de la aplicaci\xf3n, mientras que los controles de dispositivo se adaptan a la conexi\xf3n de cada dispositivo y ofrecen funciones m\xe1s avanzadas que los controles est\xe1ndar de la aplicaci\xf3n.","description":"Los controles globales y de dispositivo son acciones siempre disponibles, dise\xf1adas para funcionar en cualquier software. Los controles globales, como \\"Detener c\xe1mara\\", son para todo el sistema e independientes de la aplicaci\xf3n, mientras que los controles de dispositivo se adaptan a la conexi\xf3n de cada dispositivo y ofrecen funciones m\xe1s avanzadas que los controles est\xe1ndar de la aplicaci\xf3n. Actualmente, se accede a estos controles mediante comandos de voz; sin embargo, pr\xf3ximamente a\xf1adiremos compatibilidad con otras entradas.","noDevice":"Este paso usa una extensi\xf3n personalizada que no has configurado para tu cuenta. Agrega la extensi\xf3n para desbloquear este paso."},"notifications":{"title":"Notificaciones","center":"Centro de notificaciones","empty":"No tienes notificaciones en este momento. Vuelve a consultar en otro momento.","seen":"Visto","markAsRead":"Marcar como le\xeddo","view":"Ver todas las notificaciones de {{value}}"},"unsaved":{"title":"Tiene cambios sin guardar.","description":"Tiene cambios sin guardar. \xbfEst\xe1s seguro de que quieres salir esta p\xe1gina?","cancel":"Salir sin guardar","confirm":"Guardar y Salir"},"login":{"welcome":"\xa1Bienvenidos a Cephable!","subtitle":"Controle tu tecnolog\xeda seg\xfan <strong>tus propios</strong> t\xe9rminos.","create":"Crear Una Cuenta","signIn":"Iniciar Sesi\xf3n","loading":"Redirigiendo para iniciar sesi\xf3n...","error":"Se produjo un error al iniciar sesi\xf3n. Inicie sesi\xf3n nuevamente.","existingAccount":"\xbfYa tienes una cuenta?","description":"Toma el control total de tu computadora, apps y juegos con Cephable: tu IA personal para acciones r\xe1pidas, comandos de voz, expresiones faciales, gestos, inclinaci\xf3n y m\xe1s. Sin procesamiento en la nube. Solo un control perfecto que se mueve contigo."},"home":{"title":"Principal","startControls":"\xa1Encenderlo!","manage":"Configurar","profileGenerate":{"title":"Ups. Parece que a\xfan no tienes ning\xfan control de aplicaci\xf3n.","description":"Para que Cephable controle tu ordenador, necesitamos saber qu\xe9 quieres controlar. Puedes crear controles de aplicaci\xf3n desde cero o pedirnos ayuda para crear uno con nuestro generador de controles."}},"wizard":{"description":"Luego, Cephable utilizar\xe1 esta informaci\xf3n para generar controles que usted podri\xe1 revisar y probar.","includeDefaultKeysQuestion":"\xbfIncluye comandos de voz predeterminados para teclas y clics del rat\xf3n?","placeholderAppName":"Microsoft Word, Minecraft, YouTube, Code, etc.","generate":"Generar controles","complete":{"title":"\xa1Muy bien, hemos terminado!","description":"Haga clic en el bot\xf3n abjajo para ver los controles que generamos. Podr\xe1s editar, agregar o eliminar manualmente cualquier aspecto para perfeccionarlo.","viewControls":"Ver mis controles"},"error":{"emptyInput":"Seleccione al menos un m\xe9todo de entrada","emptyApp":"Por favor ingresa al menos el nombre de una aplicaci\xf3n","generatingProfile":"Error al generar controles de la aplicaci\xf3n"},"loading":{"title":"Estamos juntando todas las piezas","description":"Esto puede tardar hasta aproximadamente un minuto. No abandones esta p\xe1gina ni regreses o dejar\xe1 de generarse."},"selectedTips":{"title":"Consejo #{{count}}","previous":"Consejo anterior","next":"Siguiente consejo","two":"Puede controlar la sensibilidad de tus entradas en la secci\xf3n \\"Configuraci\xf3n de control de expresi\xf3n\\" del panel principal. Esto le permitir\xe1 refinar a\xfan m\xe1s las formas en que Cephable interpreta las entradas espec\xedficas para usted. \xa1Y Cephable mejora con el tiempo a medida que funciona contigo!","three":"Despu\xe9s de configurar esto, t\xfa tienes control total sobre la configuraci\xf3n. Le estamos brindando una l\xednea de base, pero en cualquier momento puede cambiar el mapeo entre lo que hace y lo que hace en la computadora.","four":"Puede imprimir tus controles para tener una copia f\xedsica mientras usa Cephable. Sabemos que todo esto es nuevo y requiere algo de tiempo para acostumbrarse. \xa1La pr\xe1ctica hace mejor!","one":"\xbfSab\xedas que puedes usar Cephable en un dispositivo para controlar otro? Descarga Cephable en tu m\xf3vil, tableta o incluso en otra computadora y elige la conexi\xf3n que quieres controlar (quiz\xe1s esta). \xa1Tus perfiles personales y de entrada son consistentes en todos! Solo aseg\xfarate de que Cephable se est\xe9 ejecutando en tu dispositivo y conexiones."},"steps":{"one":"Paso 1. Escribe el nombre de la aplicaci\xf3n que quieres controlar.","two":"Paso 2. Confirme los controles de entrada que quieres utilizar:","three":"Paso 3. (opcional) ","threeContinued":"Describe cualquier acci\xf3n espec\xedfica que te gustar\xeda configurar para los comandos que usas com\xfanmente o por los que tienes una fuerte preferencia. Utilice un ingl\xe9s sencillo como los que aparecen a continuaci\xf3n."},"noOptionsText":"Comience a escribir para encontrar una aplicaci\xf3n que quiere controlar.","title":"Generar controles de aplicaci\xf3n","titleLong":"Generar controles de aplicaci\xf3n","try":"Pruebe el generador de control","placeholder":"Aseg\xfarate de que los comandos de voz sean cortos.\\n\\nQuiero poder decir \\"adelante\\" para pasar a la siguiente diapositiva de la presentaci\xf3n.\\n\\nQuiero usar el movimiento de la cabeza para mover el cursor y los controles de voz para editar atajos.\\n\\nA\xf1adir botones de acci\xf3n r\xe1pida para todos los movimientos y habilidades de mi personaje."},"macros":{"title":"Control","titlePlural":"Control S","description":"Los controles contienen una entrada (acci\xf3n que le gusta inclinar la cabeza) y pasos que Cephable realizar\xe1 despu\xe9s de que se haya registrado esa acci\xf3n de entrada. Puede utilizar controles para crear una combinaci\xf3n de pasos que se activan con una \xfanica entrada.","new":"Crear un nuevo control","newDescription":"Cree un nuevo control para combinar m\xfaltiples pasos y entradas.","add":"Agregar control","create":"Crear un control","name":{"title":"Nombre del control","question":"\xbfC\xf3mo quieres llamar a este control?","description":"Asigne un nombre a tu control para que pueda encontrarlo f\xe1cilmente m\xe1s tarde.","placeholder":"acci\xf3n que este control est\xe1 haciendo como \\"saltar\\" o \\"acercar\\""},"empty":"A\xfan no tienes controles. Haga clic a continuaci\xf3n para crear uno.","copySuffix":"{{name}}_copia"},"event":{"title":"Paso","titlePlural":"Pasos","previewSummaryPlural":"{{first}} y {{total}} eventos m\xe1s","add":"Agregar paso","stepType":"Tipo de paso","select":"Seleccione el tipo de paso que desea agregar.","question":"\xbfQu\xe9 tipo de acciones quieres que realice Cephable?","setup":"Configura tu paso","description":"Los pasos son las acciones que Cephable realizar\xe1 despu\xe9s de que se haya activado la entrada. Puede agregar varios pasos a un control para crear una combinaci\xf3n de acciones.","expand":"Ampliar para ver el resto de pasos","stepUp":"Mueve Paso Arriba","stepDown":"Mueve paso Abajo","stepCopy":"Copia paso","stepRemove":"Elimine paso","insertStep":"Inserte paso abajo","showOptions":"Muestre opciones","hideOptions":"Ocuelte opciones","hold":"Tiempo de espera (en milisegundos)","error":"Debes configurar tu paso.","multiple":"M\xfaltiples pasos","deviceTypeCustomAction":{"title":"Acci\xf3n de dispositivo personalizada"},"keyPress":{"title":"Presione la tecla o el bot\xf3n ","short":"Prensa","fieldSet":"Teclas o bot\xf3n para presionar","label":"Tecla o Bot\xf3n","holdTime":"Tiempo de retenci\xf3n de la tecla (en milisegundos)","description":"Presione una tecla del teclado sin usar el teclado.","longDescription":"Esta funci\xf3n simula la pulsaci\xf3n de una tecla en tu teclado. Por ejemplo, si tiene dificultades para presionar teclas f\xedsicas, puede usar un comando de voz u otro m\xe9todo de entrada para \\"presionar\\" una tecla virtualmente.","example":"Diga \\"Intro\\" para enviar un correo electr\xf3nico sin presionar f\xedsicamente la tecla Intro.","timing":"Momento de pulsaci\xf3n de tecla","tap":"Grifo","tapLong":"Toque el bot\xf3n","latch":"Pestillo","latchLong":"Mantener hasta que se suelte","hold":"Sostener","holdLong":"Mantener por una cantidad de tiempo","toggle":"Alternar","toggleLong":"Alternar acci\xf3n","release":"Soltar","releaseLong":"Soltar acci\xf3n","latchLabel":"Mantenga presionado <strong>{{value}}</strong> hasta que se suelte","tapLabel":"Toca <strong>{{value}}</strong>","pressLabel":"Presione <strong>{{value}}</strong> durante <strong>{{time}}</strong> milisegundos","remove":"Eliminar pulsaci\xf3n de tecla","add":"Agregar tecla/bot\xf3n para presionar"},"keyRelease":{"title":"Soltar tecla o bot\xf3n","short":"Liberar","selected":"Claves seleccionadas para liberar","description":"Suelta una tecla del teclado que hayas presionado y mantenido.","longDescription":"Esta funci\xf3n simula la liberaci\xf3n de una tecla de tu teclado. Debe usarse junto con una pulsaci\xf3n de tecla que se mantiene indefinidamente. Por ejemplo, si tiene dificultades para presionar teclas f\xedsicas, puede usar un comando de voz u otro m\xe9todo de entrada para \\"soltar\\" una tecla virtualmente.","example":"Diga \\"Detener\\" despu\xe9s de decir \\"Activar\\" para detener la ejecuci\xf3n.","label":"Liberar <strong>{{value}}</strong>","add":"Agregar tecla/bot\xf3n para liberar","remove":"Quitar liberaci\xf3n de clave"},"keyToggle":{"title":"Alternar tecla o bot\xf3n","short":"Palanca","selected":"Teclas seleccionadas para alternar","description":"Enciende o apaga una tecla del teclado como un interruptor de luz con un solo control.","longDescription":"Esto activa o desactiva la funci\xf3n de una tecla, como un interruptor. Es \xfatil para claves que desea conservar durante un per\xedodo de tiempo indeterminado. Puede usar esto para mantener la misma acci\xf3n tanto al presionar como al soltar o detener la tecla.","example":"Diga \\"Alternar ejecuci\xf3n\\" para comenzar a ejecutar. Diga \\"Alternar ejecuci\xf3n\\" para detener la ejecuci\xf3n.","label":"Alternar <strong>{{value}}</strong>","add":"Agregar tecla/bot\xf3n para alternar","remove":"Quitar palanca de clave"},"pause":{"title":"Pausa","description":"Agregue un breve retraso entre acciones.","longDescription":"Esta funci\xf3n le permite insertar un breve retraso entre acciones, lo cual es esencial en situaciones en las que una acci\xf3n debe completarse por completo antes de que comience la siguiente. Por ejemplo, si est\xe1 utilizando un comando para poner el texto en negrita en un documento, es posible que primero deba abrir un men\xfa contextual. La funci\xf3n Pausa da tiempo suficiente para que el men\xfa contextual se abra y se active antes de continuar con el siguiente paso, lo que garantiza un funcionamiento fluido y sin errores.","example":"Imagina que est\xe1s editando un documento usando comandos de voz. Dices \\"Formate texto\\", lo que abre un men\xfa contextual. Luego, despu\xe9s de una breve pausa para permitir que el men\xfa aparezca por completo, dice \\"Negrita\\" para aplicar formato en negrita al texto seleccionado. La funci\xf3n Pausa garantiza que el men\xfa contextual est\xe9 listo para recibir tu siguiente comando.","label":"Pausa durante <strong>{{value}}</strong> milisegundos"},"type":{"title":"Escribir","field":"Frase a escribir","placeholder":"frase escrita","question":"\xbfQu\xe9 texto quieres escribir?","description":"Escriba texto como si usara un teclado.","longDescription":"Esto imita la escritura de una cadena de texto, similar a escribir en un teclado. Es ideal para ingresar texto m\xe1s largo sin necesidad de presionar cada tecla. Si desea ingresar texto din\xe1micamente, puede usar la funci\xf3n de Dictado.","example":"Diga \\"Nombre\\" para escribir \\"Hola, mi nombre es Ellen Ripley\\". en una ventana de chat.","label":"Escribe <strong>{{value}}</strong>"},"mouseMove":{"title":"Mueve el rat\xf3n","description":"Mueva el puntero en la pantalla.","longDescription":"Mueva el cursor o puntero de tu pantalla sin un rat\xf3n f\xedsico. Esto es especialmente \xfatil para usuarios con movilidad limitada de las manos. Esto es \xfatil para el control preciso del movimiento del rat\xf3n que se necesita en algunos juegos. Si desea simular todo el movimiento del rat\xf3n usando el movimiento de tu cabeza, puede probar el \'Movimiento de la cabeza para el control del rat\xf3n\' en la configuraci\xf3n de la c\xe1mara.","example":"Diga \\"Mueve rat\xf3n Derecha\\" para mover el cursor 100 p\xedxeles hacia la derecha.","moveX":"Mueve p\xedxeles hacia la izquierda/derecha con el rat\xf3n","numberMoveX":"N\xfamero de p\xedxeles para mover hacia la izquierda/derecha","moveY":"Mueve p\xedxeles hacia arriba/abajo con el rat\xf3n","numberMoveY":"N\xfamero de p\xedxeles para mover hacia arriba/abajo","label":"Mueve el rat\xf3n <strong>{{value}}</strong>","command":"Movimiento del rat\xf3n: {{command}}"},"joystickMove":{"title":"Mover palancas de mando","description":"Utilice un joystick para mover cosas en la pantalla.","longDescription":"Esta funci\xf3n simula el movimiento de un joystick. Por ejemplo, si tiene dificultades para usar un joystick f\xedsico, puede usar un comando de voz u otro m\xe9todo de entrada para mover un joystick virtualmente.","example":"Diga \\"Mueve Joystick Izquierda\\" para mover el joystick hacia la izquierda 100 p\xedxeles.","prefix":"Mueva El Joystick Izquierda","left":"Palanca Izquierda","leftX":"X Izquierdo","leftY":"Y Izquierdo","right":"Palanca Derecha","rightX":"X Derecho","rightY":"Y Derecho","x":"Fuerza del eje X","y":"Fuerza del eje Y","moveXLabel":"Mueve X: {{value}}","moveYLabel":"Mueve Y: {{value}}","labelLeft":"Mueva el Joystick Izquierdo ","labelRight":"Mueva el joystick Derecho ","latch":"El pestillo mantendr\xe1 la posici\xf3n hasta que lo sueltes utilizando el comando \\"Detener todo\\"."},"playAudio":{"title":"Reproducir audio","placeholder":"frase de afirmacion que dira Cephable","description":"Reproduce un sonido, palabra o frase.","longDescription":"Esta funci\xf3n permite a los usuarios convertir frases escritas en palabras habladas. Es especialmente \xfatil para personas que pueden tener dificultades para hablar. Al escribir una frase, la funci\xf3n PlayAudio articular\xe1 el texto en voz alta mediante voz sintetizada. Esto puede ayudar en la comunicaci\xf3n o en situaciones en las que un usuario necesita transmitir informaci\xf3n verbalmente pero prefiere o requiere una alternativa al uso de tu propia voz.","example":"Sonr\xede para reproducir la palabra \\"Hola\\".","label":"Habla <strong>\\"{{value}}\\";</strong>"},"stopOutputs":{"title":"Detener todas las salidas","titleLong":"Detenga todas las salidas (suelte todas las teclas y botones, detenga todos los movimientos del rat\xf3n, deje de escribir)","description":"Detenga todas las acciones en curso, como presionar una tecla.","longDescription":"Detenga inmediatamente todos los resultados o acciones en curso. Esta es una caracter\xedstica de seguridad o conveniencia para detener cualquier proceso. Haremos esto autom\xe1ticamente cuando cierre o ponga en pausa los controles de la c\xe1mara o el micr\xf3fono.","example":"Diga \\"Detener\\" para detener todas las salidas.","label":"Detenga todas las salidas y suelte las teclas."},"custom":{"title":"Costumbre"},"options":{"moveUp":"Mueve Arriba","moveDown":"Mueve Abajo","moveLeft":"Mueve Izquierda","moveRight":"Mueve Derecha","copyStep":"Copia paso","removeStep":"Elimine paso"},"directions":{"up":"Arriba","down":"Abajo","left":"Izquierda","right":"Derecha"}},"expression":{"title":"Expresi\xf3n Facial","titlePlural":"Expresiones Faciales","label":"Expresi\xf3n / Gesto","start":"Iniciar controles de expresi\xf3n","startSmiling":{"title":"Empezar a sonre\xedr","description":"Si empiezas a sonre\xedr sin sonre\xedr y luego lo haces, se activar\xe1 este control. Nota: Usar este control en la misma aplicaci\xf3n que el control de apertura/cierre de boca puede causar conflictos."},"stopSmiling":{"title":"Deja de sonre\xedr","description":"Si sonr\xedes y luego dejas de sonre\xedr, se activar\xe1 este control. Nota: Usar este control en la misma aplicaci\xf3n que el control de apertura/cierre de boca puede generar conflictos."},"eyebrows":{"title":"Levantar las cejas","description":"Si levantas ambas cejas desde tu posici\xf3n inicial de reposo, este control se activar\xe1."},"openMouth":{"title":"Boca abierta","description":"Si tienes la boca cerrada (o si tu l\xednea base est\xe1 ligeramente abierta) y la abres m\xe1s, se activar\xe1 este control. Nota: Usar este control en la misma aplicaci\xf3n que el control de sonrisa puede causar conflictos."},"closeMouth":{"title":"Boca cerrada","description":"Si tienes la boca abierta y la cierras por completo, se activar\xe1 este control. Nota: Usar este control en la misma app que el control de sonrisa puede causar conflictos."},"description":"Mejora tu experiencia digital con expresiones faciales. Usa gestos como levantar las cejas, sonre\xedr y otros movimientos para controlar el puntero del rat\xf3n, realizar acciones o personalizar tus interacciones."},"head":{"title":"Movimiento de Cabeza","titlePlural":"Movimientos de Cabeza","label":"Movimiento de cabeza/cuerpo","question":"\xbfQu\xe9 tipo de movimiento quieres usar?","tilt":{"title":"Inclinaci\xf3n de Cabeza","left":{"title":"Incline la Cabeza Izquierda","description":"Si est\xe1s mirando a la c\xe1mara e inclinas la cabeza hacia la izquierda, este control se activar\xe1."},"right":{"title":"Incline la Cabeza Derecha","description":"Si est\xe1s mirando a la c\xe1mara e inclinas la cabeza hacia la derecha, este control se activar\xe1."},"back":{"title":"Incline la Cabeza Atr\xe1s","description":"Si est\xe1 mirando a la c\xe1mara e inclina la cabeza hacia atr\xe1s y mira hacia arriba, este control se activar\xe1."},"forward":{"title":"Incline la Cabeza Adelante","description":"Si est\xe1 mirando a la c\xe1mara e inclina la cabeza hacia adelante y mira hacia abajo, este control se activar\xe1."},"description":"Incline la cabeza hacia la izquierda o la derecha para un mejor control o navegaci\xf3n con el mouse."},"turn":{"title":"Giro de Cabeza","left":{"title":"Gire la Cabeza Izquierda","description":"Si est\xe1 mirando a la c\xe1mara, gira la cabeza y mira hacia la izquierda, este control se activar\xe1."},"right":{"title":"Gire la Cabeza Derecha","description":"Si est\xe1 mirando a la c\xe1mara, gira la cabeza y mira hacia la derecha, este control se activar\xe1."},"description":"Gire la cabeza hacia la izquierda o hacia la derecha para un mejor control o navegaci\xf3n con el mouse."},"lean":{"title":"Cabeza Inclinada","left":{"title":"Cabeza Inclinada Izquierda","description":"Si est\xe1 mirando a la c\xe1mara y se inclina hacia la izquierda para que tu cara quede m\xe1s a la izquierda en el marco de la c\xe1mara, este control se activar\xe1."},"right":{"title":"Cabeza Inclinada Derecha","description":"Si est\xe1s mirando a la c\xe1mara y te inclinas hacia la derecha para que tu cara est\xe9 m\xe1s a la derecha en el marco de la c\xe1mara, este control se activar\xe1."},"back":{"title":"Cabeza Inclinada Atr\xe1s","description":"Si est\xe1 mirando a la c\xe1mara y se inclina hacia atr\xe1s para que tu cara est\xe9 m\xe1s alejada de la c\xe1mara, este control se activar\xe1."},"forward":{"title":"Cabeza Inclinada Adelante","description":"Si est\xe1 mirando a la c\xe1mara y se inclina hacia adelante para que tu cara est\xe9 m\xe1s cerca de la c\xe1mara, este control se activar\xe1."},"up":{"title":"Mueve Cuerpo Arriba","description":"Si est\xe1s mirando a la c\xe1mara y mueves la cabeza hacia arriba estirando el cuello o moviendo todo el cuerpo hacia arriba, este control se activar\xe1."},"down":{"title":"Mueve Cuerpo Abajo","description":"Si est\xe1s mirando a la c\xe1mara y mueves la cabeza hacia abajo arrugando el cuello, agach\xe1ndote o bajando todo el cuerpo, este control se activar\xe1."},"center":{"title":"Centra tu Cabeza","description":"Si est\xe1 mirando a la c\xe1mara y mueve la cabeza hacia la posici\xf3n central que coincide con la l\xednea de base, este control se activar\xe1."},"description":"Incline la cabeza hacia la izquierda o la derecha para obtener un mejor control o navegaci\xf3n con el mouse."},"description":"Controla tu dispositivo o conexi\xf3n con movimientos de cabeza como inclinar, asentir o girar. Con la c\xe1mara de tu dispositivo, Cephable garantiza una experiencia privada e intuitiva para un control mejorado o navegaci\xf3n con el rat\xf3n."},"voice":{"title":"Control de Voz","titlePlural":"Controles de Voz","placeholder":"Voz o frase que Cephable escuchar\xe1","question":"\xbfQu\xe9 afirmaci\xf3n o frase quieres decir para este control?","when":"Cuando yo digo...","say":"Diga \'{{value}}\'","load":{"fail":{"title":"Controles de voz en {{language}} no disponibles","description":"\xa1Oh, no! No pudimos cargar {{language}} para los controles de voz. Por favor verifique tu conexi\xf3n a Internet y int\xe9ntelo nuevamente. Cambiando al Ingl\xe9s (Estados Unidos) hasta que hay conexi\xf3n de internet."}},"description":"Al activar el micr\xf3fono, se activan comandos de voz inteligentes y naturales, lo que permite a los usuarios interactuar fluidamente con su computadora en diferentes aplicaciones y software. Hable con naturalidad para ejecutar comandos o dictar texto, creando una experiencia intuitiva y sin esfuerzo."},"motion":{"title":"Control de Movimiento","titlePlural":"Controles de Movimiento","question":"\xbfQu\xe9 tipo de movimiento con un tel\xe9fono o tableta quieres usar?","start":"Iniciar Controles de Movimiento","settings":"Configuraci\xf3n de movimiento","descriptionShort":"Incline, gire o agite tu dispositivo para controlar Cephable.","description":"Los controles de movimiento le permiten convertir el movimiento de tu tel\xe9fono o tableta en la aplicaci\xf3n complementaria en controles para tu dispositivo. Incline o agite tu tel\xe9fono en diferentes direcciones para crear nuevas salidas.","up":{"title":"Incline Tu Dispositivo Arriba","description":"Si tu dispositivo est\xe1 plano sobre una superficie y lo inclina hacia usted, este control se activar\xe1."},"down":{"title":"Incline tu Dispositivo Abajo","description":"Si tu dispositivo est\xe1 plano sobre una superficie y lo inclina hacia abajo para mirar hacia afuera, este control se activar\xe1."},"left":{"title":"Incline Tu Dispositivo Izquierda","description":"Si tu dispositivo est\xe1 plano sobre una superficie y lo inclina hacia la izquierda, este control se activar\xe1."},"right":{"title":"Incline Tu Dispositivo Derecha","description":"Si tu dispositivo est\xe1 plano sobre una superficie y lo inclina hacia la derecha, este control se activar\xe1."},"shake":{"title":"Agite Tu Dispositivo","description":"Si agita tu dispositivo, este control se activar\xe1."},"edit":{"title":"Editar configuraci\xf3n de movimiento","description":"Cambie la configuraci\xf3n de control de movimiento para ajustar cu\xe1nto necesita mover tu tel\xe9fono mientras ejecuta la aplicaci\xf3n complementaria","sensitivity":{"title":"Configuraci\xf3n de sensibilidad del control de movimiento","description":"La sensibilidad le dice a Cephable hasta qu\xe9 punto debe inclinar tu dispositivo para activar un control. Cuanto mayor sea el valor (m\xe1s a la derecha en el control deslizante), mayor ser\xe1 la sensibilidad y, por lo tanto, menos necesitar\xe1 inclinarse para activar el control."},"tilt":{"title":"Sensibilidad de Inclinaci\xf3n","description":"Estos valores determinan cu\xe1nto debe inclinar tu dispositivo hacia arriba, abajo, izquierda y derecha para que se reconozca una entrada."},"mouse":{"title":"Controles de Movimiento para el Movimiento del Rat\xf3n","description":"Determine si desea utilizar los controles de movimiento para mover el rat\xf3n y c\xf3mo hacerlo en lugar de activar los controles.","enable":{"title":"Habilitar controles de movimiento para el movimiento del rat\xf3n","description":"Si esto est\xe1 activado, algunos de tus controles de movimiento se usar\xe1n para mover el rat\xf3n en lugar de los controles de activaci\xf3n.","option":"\xbfUtiliza controles de movimiento para el movimiento del rat\xf3n?"},"invert":{"title":"Invertir el movimiento del rat\xf3n","description":"Para el eje X: si esto est\xe1 activado, al moverlo hacia la izquierda se mover\xe1 el rat\xf3n hacia la derecha y si se mueve hacia la derecha lo mover\xe1 hacia la izquierda. Para el eje Y: si esto est\xe1 activado, al moverlo hacia abajo, el rat\xf3n se mover\xe1 hacia arriba y al moverlo hacia arriba, lo mover\xe1 hacia abajo.","x":"\xbfInvertir el movimiento del rat\xf3n en el eje X?","y":"\xbfInvertir el movimiento del rat\xf3n en el eje Y?"}}}},"keys":{"title":"Tecla o Bot\xf3n","titlePlural":"Teclas o botones","label":"Tecla/bot\xf3n externo","question":"\xbfQu\xe9 tecla o bot\xf3n quieres presionar?","edit":"Editar Teclas y Botones","defaultOption":"\xbfIncluye comandos de voz predeterminados para teclas y clics del rat\xf3n?","description":"Las teclas y botones le permiten asignar tus diferentes controles de entrada a las pulsaciones de botones del teclado y del controlador.","then":"Cephable presionar\xe1...","empty":"No hay controles clave que coincidan con este criterio.","backspace":"Retroceso","delete":"Borrar","enter":"Ingresar","space":"Barra espaciadora","tab":"Pesta\xf1a","shift":"Cambio","ctrl":"Control","leftCtrl":"Ctrl Izquierdo","rightCtrl":"Ctrl Derecho","leftShift":"Shift Izquierdo","rightShift":"Shift Derecha","alt":"Alt","leftAlt":"Alt Izquierda","escape":"Escapar","up":"Flecha Arriba","down":"Flecha Abajo","left":"Flecha Izquierda","right":"Flecha Derecha","command":"Dominio","caps":"Bloq May\xfas","reset":{"title":"Restablecer combinaciones de teclas","confirm":"\xbfRestablecer todas las combinaciones de teclas?","confirmDescription":"Elige c\xf3mo quieres restablecer las combinaciones de teclas. Esta acci\xf3n no se puede deshacer sin guardar.","confirmButton":"Restablecer la configuraci\xf3n de teclas","defaultOption":"Restablecer a los valores predeterminados para el idioma actual.","emptyOption":"Restablecer a vac\xedo (borrar todos los comandos)"}},"talkback":{"title":"Replicar","question":"\xbfQu\xe9 quieres que diga Cephable?","description":"Controles de configuraci\xf3n que har\xe1n que Cephable hable por usted. Puedes asignar controles a diferentes frases que quieras que se pronuncien.","thenMacro":"entonces Cephable dir\xe1...","empty":"No hay controles de talkback que coincidan con este criterio.","add":"Agregar un nuevo control de conversaci\xf3n","remove":"Quitar el control de conversaci\xf3n","edit":"Editar controles de conversaci\xf3n","deprecatedNotice":"Talkback ahora est\xe1 integrado directamente en los controles principales de la aplicaci\xf3n. Tus controles de la aplicaci\xf3n tienen algunos eventos de Talkback antiguos que deben actualizarse."},"dictation":{"title":"Dictado","question":"\xbfQu\xe9 frase deber\xeda activar el modo de dictado?","thenMacro":"Cephable voluntad...","empty":"No hay controles de dictado que coincidan con este criterio.","type":"escribir a m\xe1quina","edit":"Editar Frases de Dictado","remove":"Eliminar Frase de Dictado","add":"Agregar Nueva Frase de Dictado","on":"Dictado","off":"Comandos","onboarding":{"tourLabel":"Dictado","learn":"Aprenda a utilizar el modo de dictado para convertir su voz en texto sin necesidad de usar manos libres.","welcome":{"title":"Dictado","description":"El dictado te permite hablar con naturalidad y escribir tus palabras mientras hablas. Es como tener un asistente personal que escribe todo lo que dices."},"microphone":{"title":"Enciende tu micr\xf3fono","description":"Primero, activa el micr\xf3fono. Haz clic en el interruptor de micr\xf3fono en el panel de Cephable."},"activate":{"title":"Iniciar el modo de dictado","description":"La voz se inicia en modo comando. Para iniciar el dictado, diga \\"Iniciar dictado\\" o haga clic en el bot\xf3n Dictado. Activemos el modo de dictado."},"speaking":{"title":"Haga clic en un documento o campo y comience a hablar","description":"El dictado escribir\xe1 en tiempo real lo que digas. Haz clic en un campo de texto o documento y empieza a hablar. Por ejemplo, di: \\"As\xed se usa el modo de dictado\\"."},"pauseResume":{"title":"Pausa del dictado","description":"\xbfNecesitas un descanso sin desactivar el dictado? Simplemente di \\"Pausar dictado\\". Puedes reanudarlo en cualquier momento con \\"Iniciar dictado\\". Puedes personalizarlo a\xfan m\xe1s con los controles globales y del dispositivo siempre activos."},"stop":{"title":"Detener el dictado","description":"\xbfNecesitas volver a los controles de tu aplicaci\xf3n? Simplemente di \\"Detener dictado\\". Esto detendr\xe1 el modo de dictado y te permitir\xe1 volver al modo comando. Puedes reanudarlo en cualquier momento con \\"Iniciar dictado\\"."},"complete":{"title":"\xa1Felicitaciones!","description":"\xa1Listo! Ahora puedes dictar, pausar, reanudar y alternar entre los modos de dictado y comando. El dictado es una herramienta potente para escribir sin usar las manos. \xdasalo para escribir correos electr\xf3nicos, documentos o cualquier otra cosa que necesites escribir en voz alta."}},"description":"El dictado te permite hablar con naturalidad y escribir tus palabras mientras hablas. Es como tener un asistente personal que escribe todo lo que dices."},"face":{"title":"Expresi\xf3n Facial","titlePlural":"Expresiones Faciales","try":"Pruebe los controles de expresi\xf3n facial","question":"\xbfQu\xe9 tipo de expresi\xf3n facial quieres usar?","descriptionShort":"Utilice diferentes movimientos faciales para obtener mejores controles.","description":"Las expresiones faciales forman parte de los Controles de Expresi\xf3n. Permiten usar diferentes movimientos faciales para un control mejorado. Puedes usar movimientos de cejas, de boca y m\xe1s para crear diferentes resultados."},"other":{"title":"Otro Control","titlePlural":"Otros Controles","label":"Otros Controles","placeholder":"otro comando experimental","question":"\xbfQu\xe9 comando adicional le gustar\xeda usar? Estos suelen ser para conexiones que no son Cephable y que no encajan en otras categor\xedas. Tambi\xe9n pueden funcionar como comandos de voz al decir la palabra o frase especificada. Nota: Estos controles son experimentales y podr\xedan no ser totalmente compatibles.","description":"Otros controles son experimentales y podr\xedan no ser totalmente compatibles. Pueden usarse para conexiones que no sean Cephable o como comandos de voz al decir la palabra o frase especificada."},"support":{"title":"Apoyo","profiles":"Introducci\xf3n a los controles de la aplicaci\xf3n","question":"\xbfA\xfan no encuentras lo que necesitas?","more":"Obtenga m\xe1s informaci\xf3n en Cephable.com con gu\xedas paso a paso, tutoriales, videos y m\xe1s."},"community":{"title":"Unete a la communidad","description":"Obtenga apoyo, comparta ideas o convi\xe9rtase en miembro de las comunidades de Cephable.","discord":"Discord","facebook":"Facebook"},"resources":{"title":"Recursos \xfatiles","description":"Encuentre respuestas a tus preguntas sobre las caracter\xedsticas y funciones de Cephable.","guides":"Gu\xedas Paso a Paso"},"feedback":{"title":"Comentario","description":"Cu\xe9ntanos tu experiencia con Cephable.","contact":"Cont\xe1ctenos","feature":"Sugerir una Caracter\xedstica","bug":"Reportar un Problema"},"settings":{"title":"Ajustes","general":"Configuraci\xf3n General de Aplicaci\xf3n","description":"Este es tu lienzo para personalizar tu experiencia ajustando tus controles.","orgTitle":"Configuraci\xf3n de {{ value }}"},"account":{"title":"Cuenta","settings":"Configuraciones de la Cuenta","description":"Actualice informaci\xf3n clave para mantenerse conectado con Cephable.","usernameLabel":"Nombre de Usuario: ","emailLabel":"Correo Electr\xf3nico: ","password":{"change":"Cambiar la Contrase\xf1a","description":"Cambia tu contrase\xf1a para mantener tu cuenta segura.","old":"Contrase\xf1a Anterior","current":"Contrase\xf1a Actual","new":"Nueva Contrase\xf1a","desired":"tu nueva contrase\xf1a deseada","confirm":"Confirmar Nueva Contrase\xf1a","update":"Actualiza Contrase\xf1a"},"isEmailVerified":{"title":"Correo no Identificado.","description":"Tu correo electr\xf3nico no est\xe1 verificado. Por favor revise tu correo electr\xf3nico para obtener un enlace de verificaci\xf3n.","resend":"Reenviar Correo","success":"Te hemos enviado un nuevo correo electr\xf3nico de verificaci\xf3n.","error":"Hubo un error al enviar el correo electr\xf3nico de verificaci\xf3n. Por favor, int\xe9ntelo de nuevo m\xe1s tarde.","org":"Su correo electr\xf3nico no est\xe1 verificado. Es necesario para acceder a los detalles de la licencia. Por favor, revise su correo electr\xf3nico para ver si hay un enlace de verificaci\xf3n.","titleAlt":"Verifique su direcci\xf3n de correo electr\xf3nico","descriptionLong":"\xa1Bienvenido a Cephable! Se ha enviado un correo electr\xf3nico de verificaci\xf3n a {{email}}. Revisa tu bandeja de entrada o correo no deseado y haz clic en el enlace. Si no lo ves, puedes reenviar el correo de verificaci\xf3n.","appBlock":"\xa1Ya casi terminas! Se ha enviado un correo electr\xf3nico de verificaci\xf3n a {{email}}. Revisa tu bandeja de entrada y haz clic en el enlace para verificar tu direcci\xf3n de correo electr\xf3nico. Si no lo ves, revisa tu carpeta de correo no deseado."},"signout":{"title":"Desconectar","question":"\xbfEst\xe1s seguro de que deseas cerrar sesi\xf3n?","confirm":"S\xed, cerrar sesi\xf3n","warn":{"title":"Est\xe1s a punto de cerrar tu sesi\xf3n.","description":"Parece que has estado inactivo durante un tiempo. Por razones de seguridad, cerraremos tu sesi\xf3n en XX segundos. Si deseas permanecer conectado, haz clic en \\"Permanecer conectado\\" a continuaci\xf3n.","confirm":"Mantenerse conectado","cancel":"Cerrar sesi\xf3n ahora"},"description":"Una vez que cierre la sesi\xf3n, esta conexi\xf3n se eliminar\xe1 de su cuenta y ya no ser\xe1 visible desde la aplicaci\xf3n complementaria ni desde otras conexiones.","confirmDescription":"Cerrar sesi\xf3n y eliminar esta conexi\xf3n"},"marketing":{"title":"Preferencias de Correo Electr\xf3nico","description":"Suscr\xedbase para recibir tutoriales, sugerencias, actualizaciones y boletines informativos para mejorar t\xfa experiencia con Cephable.","marketing":"Correos electr\xf3nicos de marketing","optIn":"Me gustar\xeda recibir tutoriales, consejos, actualizaciones y boletines para mejorar mi experiencia con Cephable."},"error":{"save":"Error al guardar la configuraci\xf3n de la cuenta.","password":"Error al actualizar la contrase\xf1a.","signout":"Error al cerrar sesi\xf3n.","old":"Se requiere contrase\xf1a anterior.","new":"Se requiere una nueva contrase\xf1a.","match":"Las contrase\xf1as no coinciden.","marketing":"Error al actualizar las preferencias de correo electr\xf3nico.","userPreferences":"Error al guardar las preferencias del usuario."},"success":{"save":"Configuraci\xf3n de la cuenta guardada.","password":"Contrase\xf1a actualiza.","marketing":"Preferencias de correo electr\xf3nico actualizadas.","userPreferences":"Preferencias de usuario actualizadas."},"userPreferences":{"title":"Preferencias del Usuario","description":"Actualice tus preferencias para crear la experiencia Cephable que funcione para usted.","warningOptOut":"Ocultar advertencias al guardar o actualizar los controles de la aplicaci\xf3n","enableTranscribeTask":"Habilite la tarea de transcripci\xf3n de archivos experimentales en el Panel de Cephable","enableClickByName":"SOLO PARA WINDOWS. Habilita la funci\xf3n experimental \\"Tocar\\" un elemento en la pantalla por su nombre, como \\"tocar guardar\\" para hacer clic en un bot\xf3n llamado \\"guardar\\".","enableGamepadSupport":"Habilitar la compatibilidad del gamepad para el controlador local y la emulaci\xf3n del controlador Xbox","enableMetrics":"Habilite la salida de m\xe9tricas de uso para las pruebas de rendimiento. Podr\xe1 descargar los registros desde el panel de Cephable."},"menu":"Men\xfa de usuario","delete":{"title":"Eliminar cuenta","description":"Puedes eliminar tu cuenta permanentemente y eliminar cualquier referencia a tu informaci\xf3n personal. Al eliminar tu cuenta, tus conexiones se eliminar\xe1n y dejar\xe1n de funcionar o estar registradas en tu cuenta. Se perder\xe1n los controles de la aplicaci\xf3n y toda la configuraci\xf3n. Este proceso es irreversible.","button":"Eliminar cuenta permanentemente","confirmation":"\xbfEst\xe1s seguro que deseas eliminar tu cuenta?","note":"Esta acci\xf3n es irreversible.","confirm":"S\xed, eliminar mi cuenta"}},"appSettings":{"description":"Estas configuraciones solo se aplican a esta aplicaci\xf3n. Si desea cambiar la configuraci\xf3n de la aplicaci\xf3n Cephable en otra computadora o dispositivo m\xf3vil, edite la configuraci\xf3n en esa aplicaci\xf3n.","autostart":{"title":"Iniciar Cephable Autom\xe1ticamente","description":"Con esta configuraci\xf3n activada, la aplicaci\xf3n Cephable se iniciar\xe1 autom\xe1ticamente cuando inicie sesi\xf3n en tu dispositivo. Si tambi\xe9n tienes controles autom\xe1ticos de voz y expresi\xf3n, estos tambi\xe9n se iniciar\xe1n de inmediato.","question":"\xbfIniciar autom\xe1ticamente la aplicaci\xf3n Cephable?"},"position":{"topLeft":"Arriba a la Izquierda","top":"Arriba Centro","topRight":"Arriba a la Derecha","bottom":"Abajo Centro","bottomLeft":"Abajo a la Izquierda","bottomRight":"Abajo a la Derecha","label":"Seleccionar la posici\xf3n de alimentaci\xf3n del comando","description":"Selecciona d\xf3nde quieres que aparezca el feed de comandos en tu pantalla."},"micPosition":{"title":"Posici\xf3n de la Ventana de Entrada del <icr\xf3fono","description":"Seleccione d\xf3nde desea que se coloquen los controles del micr\xf3fono para voz y dictado en tu pantalla.","label":"Seleccione la posici\xf3n de la ventana de entrada del micr\xf3fono"},"cameraPosition":{"title":"Posici\xf3n de la Ventana de Entrada de C\xe1mara","description":"Seleccione d\xf3nde desea que se coloquen los controles de la c\xe1mara para el movimiento de la cara y la cabeza en tu pantalla.","label":"Seleccionar posici\xf3n de ventana de entrada de c\xe1mara"},"theme":{"title":"Pantalla y Brillo","description":"Elige un brilla que se ajuste a tu estilo.","light":"Claro","dark":"Oscuro","system":"Usar configuraci\xf3n del sistema operativo","label":"Selecciona un Tema"},"overlay":{"title":"Alimentaci\xf3n de comandos","description":"El feed de comandos mostrar\xe1 los diferentes controles que usas y los que se enviaron a tu computadora. Es f\xe1cil de navegar, pero siempre estar\xe1 sobre las dem\xe1s ventanas. Con esta configuraci\xf3n activada, la aplicaci\xf3n Cephable se mostrar\xe1 y siempre estar\xe1 sobre las dem\xe1s ventanas y aplicaciones.","question":"\xbfMostrar feed de comandos?"},"transparent":{"title":"Transparencia de la fuente de comandos","description":"Determina la opacidad del texto. Cuanto menor sea el valor, m\xe1s transparente ser\xe1 el texto."},"panelAutoHide":{"title":"Ocultar autom\xe1ticamente el panel Cephable","delay":"Retraso antes de esconderse","denominator":"segundos","time":"{{value}} segundos"},"title":"Configuraci\xf3n general de la aplicaci\xf3n"},"input":{"title":"Entradas","titlePlural":"Controles de Entradas","explore":"Explorar los Controles de Entradas","descriptionShort":"Explore los diversos controles de entrada que utiliza Cephable para crear una mejor experiencia digital para usted.","typeLabel":"Tipo de control de entrada","toolTip":"Esto usa {{alt}}","remove":"Eliminar control de entrada","filter":"Filtrar por tipo de entrada","select":"Seleccione una entrada","question":"\xbfQu\xe9 tipo de entrada quieres usar?","add":"Agregar Entrada","addMore":"Agregar Otra Entrada","removeItem":"Eliminar elemento {{index}}","item":"Art\xedculo {{index}}: {{label}}","duplicate":"No se permiten art\xedculos duplicados.","maximum":"Se permite un m\xe1ximo de {{maxItems}} art\xedculos.","description":"Los controles de entrada son los diferentes m\xe9todos que se utilizan para controlar el dispositivo, como la voz, el movimiento de la cabeza, las expresiones faciales y otras conexiones. Explora los diferentes controles de entrada a continuaci\xf3n para obtener m\xe1s informaci\xf3n."},"time":{"soon":"Muy pronto","now":"Ahora","today":"Hoy","yesterday":"Ayer","minutesAgo":"Hace {{count}} minuto","minutesAgo_plural":"Hace {{count}} minutos","daysAgo":"Hace {{count}} d\xeda","daysAgo_plural":"Hace {{count}} d\xedas","monthsAgo":"Hace {{count}} mes","monthsAgo_plural":"Hace {{count}} meses","yearsAgo":"Hace {{count}} a\xf1o","yearsAgo_plural":"Hace {{count}} a\xf1os","minutesAhead":"en {{count}} minutos","todayAhead":"mas tarde, hoy","tomorrow":"ma\xf1ana","daysAhead":"en {{count}} d\xedas","monthsAhead":"en {{count}} meses","yearsAhead":"en {{count}} a\xf1os"},"peripherals":{"empty":"No se detectaron perif\xe9ricos","switch":"Cambiar","keyboard":"Teclado","gamepad":"Mando de juegos","companionApp":"Aplicaci\xf3n complementaria","available":"Disponible","error":"Verifique tu configuraci\xf3n."},"camera":{"windowTitle":"Controles de C\xe1mara Compatibles","title":"C\xe1mara","titlePlural":"C\xe1maras","settings":"Configuraci\xf3n de C\xe1mara","start":"Iniciar C\xe1mara","restart":"Reiniciar C\xe1mara","descriptionShort":"Permite expresi\xf3n facial y movimiento de cabeza.","description":"Utilice tu c\xe1mara para detectar expresiones faciales y gestos corporales como controles diferentes.","empty":"No se encontraron c\xe1maras.","search":"Buscar por nombre de c\xe1mara","loading":"Cargando controles de la c\xe1mara...","error":"No se pudo cargar la c\xe1mara. Aseg\xfarese de que su c\xe1mara est\xe9 conectada y habilitada.","manage":{"title":"Haga clic para ver y administrar los detalles de tus c\xe1maras.","description":""},"detected":{"face":"Cara detectada.","noFace":"No se detect\xf3 ning\xfan expresiones faciales. Ajuste tu c\xe1mara o posici\xf3n e int\xe9ntelo de nuevo.","command":"Detectado: {{command}}"},"permission":{"title":"Permisos de c\xe1mara requeridos","description":"Debes darle permiso a Cephable para usar tu c\xe1mara y usar controles faciales y corporales.","button":"Abrir configuraci\xf3n de permisos","no":"Sin acceso a la c\xe1mara","help":"Cephable necesita acceso a tu c\xe1mara para usar controles de expresi\xf3n y cabeza. Navegue a <strong>Configuraci\xf3n del sistema</strong>  <strong>Privacidad</strong>  <strong>C\xe1mara</strong> y habilite Cephable para acceder a tu c\xe1mara."},"controls":{"startData":"Comenz\xf3 a grabar datos faciales. Presione el acceso directo nuevamente mientras est\xe1 en la ventana de la c\xe1mara para detener la grabaci\xf3n y la descarga.","downloadData":"Se detuvo la grabaci\xf3n y la descarga de datos.","paused":"Controles de c\xe1mara en pausa.","pause":"Pausar controles de c\xe1mara","resume":"Reanudar los controles de la c\xe1mara","resumed":"Controles de c\xe1mara reanudados.","linesOn":"Activar l\xedneas faciales","linesOff":"Desactivar las l\xedneas de la cara","linesToggle":"Alternar dibujar l\xedneas de cara","noDeviceTitle":"No se detect\xf3 ninguna c\xe1mara que pueda usarse con Cephable.","noDeviceDescription":"Necesita conectar una c\xe1mara que sea compatible con aplicaciones m\xf3viles.","noDeviceConnectedDescription":"El control de la c\xe1mara sirve como vista previa de la interfaz. Ning\xfan paso se ejecutar\xe1 exitosamente. Conecte este dispositivo complementario a otro para iniciar comandos.","lines":"L\xedneas de la cara"},"switch":{"title":"Cambiar c\xe1mara","description":"Seleccione una c\xe1mara diferente para usarla en los controles faciales y corporales.","select":"Seleccionar c\xe1mara","next":"Siguiente c\xe1mara","nextLong":"Cambiar a la siguiente c\xe1mara","empty":"No se encontraron otras c\xe1maras.","search":"Buscar por nombre de c\xe1mara"},"baseline":{"title":"Base","description":"La l\xednea de base es la posici\xf3n predeterminada de tu cara y cuerpo que Cephable usa para determinar tus movimientos. Puede actualizar y restablecer la l\xednea base aqu\xed.","update":"Actualizar l\xednea base","reset":"Restablecer l\xednea base","updated":"L\xednea de base actualizada","tooltip":"Haga clic para actualizar tu l\xednea base a tu posici\xf3n de descanso actual."},"edit":{"title":"Editar la Configuraci\xf3n de la C\xe1mara","description":"Puede refinar la configuraci\xf3n de las entradas que requieren una c\xe1mara para que se adapten mejor a tus necesidades.","autoStart":{"title":"Iniciar C\xe1mara Autom\xe1ticamente","option":"\xbfInicio autom\xe1tico de la c\xe1mara y controles de cabeza/expresi\xf3n?","description":"Con esta configuraci\xf3n activada, el controlador iniciar\xe1 la c\xe1mara, lo que te permitir\xe1 usar expresiones faciales y controles de movimiento de cabeza al iniciar la aplicaci\xf3n. Si est\xe1 desactivada, debes pulsar el bot\xf3n \\"Iniciar c\xe1mara\\" en la p\xe1gina de conexi\xf3n."},"head":{"title":"Sensibilidad al Movimiento de Cabeza","description":"La sensibilidad le dice a Cephable qu\xe9 tan lejos debe moverse para activar un control. Cuanto mayor sea el valor (m\xe1s a la derecha en el control deslizante), mayor ser\xe1 la sensibilidad y, por lo tanto, menos necesitar\xe1 moverse para activar el control.","tilt":{"title":"Sensibilidad a la Inclinaci\xf3n de la Cabeza","description":"Estos valores determinan qu\xe9 tan lejos necesita inclinar la cabeza hacia arriba, abajo, izquierda y derecha para activar los controles.","up":"Sensibilidad de Inclinaci\xf3n Arriba","down":"Sensibilidad de Inclinaci\xf3n Abajo","left":"Sensibilidad de Inclinaci\xf3n Izquierda","right":"Sensibilidad de Inclinaci\xf3n Derecha","scaleHigh":"Ligera Inclinaci\xf3n","scaleLow":"Inclinaci\xf3n Grande"},"turn":{"title":"Sensibilidad al Giro de Cabeza","description":"Estos valores determinan cu\xe1nto debe girar la cabeza hacia la izquierda y hacia la derecha para activar los controles.","left":"Sensibilidad de Giro Izquierda","right":"Sensibilidad al Giro Derecha","scaleHigh":"Ligero Giro","scaleLow":"Giro Grande"},"lean":{"title":"Sensibilidad a la Inclinaci\xf3n de Cuerpo","description":"Estos valores determinan cu\xe1nto debe inclinar la cabeza hacia adelante y hacia atr\xe1s para activar los controles.","forward":"Sensibilidad Inclinada hacia Adelante","back":"Sensibilidad hacia Atr\xe1s","right":"Sensibilidad Ajustada a la Derecha","left":"Sensibilidad Magra Izquierda","scaleHigh":"Ligeramente Magro","scaleLow":"Grande Magro"},"duck":{"title":"Sensibilidad de Cabeza Agachada/Levantada","description":"Estos valores determinan qu\xe9 tan lejos debe agacharse o levantar la cabeza para activar los controles.","down":"Sensibilidad de Agacha","up":"Lev\xe1ntate la Sensibilidad","scaleHigh":"Ligero Turno","scaleLow":"Turno Grande"}},"face":{"title":"Sensibilidad a la Expresi\xf3n Facial","description":"La sensibilidad le dice a Cephable qu\xe9 tan exagerada es una expresi\xf3n que necesita para activar un control. Cuanto mayor sea el valor (m\xe1s a la derecha en el control deslizante), mayor ser\xe1 la sensibilidad y, por lo tanto, menos necesitar\xe1 moverse para activar el control.","eyebrow":{"title":"Sensibilidad de las Cejas","description":"Estos valores determinan cu\xe1nto debes levantar o bajar las cejas para activar los controles.","up":"Aumentar la Sensibilidad de las Cejas","scaleHigh":"Ligero Aumento","scaleLow":"Gran Aumento"},"mouth":{"title":"Sensibilidad Bucal","description":"Estos valores determinan cu\xe1nto necesitas abrir o cerrar la boca para activar los controles.","open":"Sensibilidad de la Boca Abierta","close":"Sensibilidad de la Boca Cerrada","smile":"Sensibilidad de la Sonrisa","scaleHigh":"Ligeramente Abierto","scaleLow":"Abierto Grande","smileScaleHigh":"Leve Sonrisa","smileScaleLow":"Gran Sonrisa","closeScaleHigh":"Ligeramente Cerrado","closeScaleLow":"Bien Cerrado"}},"mouse":{"title":"Movimiento de la Cabeza para los Controles del Rat\xf3n","description":"Determine si desea utilizar los controles de movimientos de la cabeza y c\xf3mo quiere mover el rat\xf3n en lugar de activar otras salidas.","enable":{"title":"Habilitar el Movimiento de la Cabeza para los Controles del Rat\xf3n","description":"Si esto est\xe1 activado, algunos de los controles de movimiento de tu cabeza se usar\xe1n para mover el rat\xf3n en lugar de los controles de activaci\xf3n.","option":"\xbfUtiliza controles de cabeza para el movimiento del rat\xf3n?"},"input":{"title":"Tipo de entrada del rat\xf3n","description":"Seleccione qu\xe9 tipo de gestos con la cabeza desea asignar a los controles del rat\xf3n. Por ejemplo, Inclinar la cabeza significa que puede inclinar la cabeza hacia la izquierda y hacia la derecha para mover el rat\xf3n hacia la izquierda y hacia la derecha, Girar la cabeza significa que puede girar la cabeza hacia la izquierda y hacia la derecha para mover el rat\xf3n y Inclinar la cabeza significa que puede inclinarse hacia la izquierda y hacia la derecha para moverse tu rat\xf3n.","option":"Seleccionar tipo de entrada","optionLong":"Seleccione el tipo de movimiento de la cabeza que desea utilizar para controlar el rat\xf3n."},"invert":{"title":"Invertir el Movimiento del Rat\xf3n","description":"Si esto est\xe1 activado, la direcci\xf3n en la que mueve la cabeza se invertir\xe1 respecto de la direcci\xf3n en la que mueve el rat\xf3n. Para el eje X: si esto est\xe1 activado, al moverlo hacia la izquierda se mover\xe1 el rat\xf3n hacia la derecha y si se mueve hacia la derecha lo mover\xe1 hacia la izquierda. Para el eje Y: si esto est\xe1 activado, al moverlo hacia abajo, el rat\xf3n se mover\xe1 hacia arriba y al moverlo hacia arriba, lo mover\xe1 hacia abajo.","x":"\xbfInvertir el movimiento del rat\xf3n en el eje X?","y":"\xbfInvertir el movimiento del rat\xf3n en el eje Y?"},"mode":{"title":"Modo de Movimiento del Rat\xf3n","description":"Selecciona c\xf3mo quieres que el cursor reaccione a los movimientos de tu cabeza."},"speed":{"title":"Velocidad del rat\xf3n","description":"Determina la velocidad constante a la que quieres que se mueva el cursor.","fast":"R\xe1pido","slow":"Lento"},"linear":{"title":"Movimiento Lineal del Rat\xf3n","description":"Si esta opci\xf3n est\xe1 activada, el cursor solo se mueve en l\xedneas rectas horizontales o verticales, lo que hace m\xe1s f\xe1cil navegar en esas direcciones espec\xedficas sin ninguna desviaci\xf3n diagonal.","option":"\xbfUtilizar el movimiento lineal del rat\xf3n?"},"accelerationRate":{"title":"Velocidad de Aceleraci\xf3n del Rat\xf3n","description":"Ajuste la velocidad con la que aumenta la velocidad del cursor cuanto m\xe1s tiempo mantenga la cabeza quieta."},"accelerationCurve":{"title":"Curva de Aceleraci\xf3n del Rat\xf3n","description":"Ajuste la velocidad a la que aumenta la velocidad del cursor en relaci\xf3n con el movimiento de la cabeza.","linear":"Lineal","exponential":"Exponencial","sublinear":"Sub-lineal"},"maximumSpeed":{"title":"Velocidad M\xe1xima del Rat\xf3n","description":"Determinar el n\xfamero m\xe1ximo de p\xedxeles que el cursor puede moverse por segundo."},"steadyGlide":{"title":"Deslizamiento Constante","description":"Cuando mueves la cabeza m\xe1s all\xe1 de un punto determinado, el cursor se desliza continuamente en esa direcci\xf3n a una velocidad constante."},"speedBoost":{"title":"Aumento de Velocidad","description":"El cursor comienza a moverse m\xe1s r\xe1pido cuanto m\xe1s tiempo mantienes la cabeza en una posici\xf3n. Cuanto m\xe1s tiempo mantengas la cabeza quieta, m\xe1s r\xe1pido se acelerar\xe1 el cursor."},"dynamicGlide":{"title":"Deslizamiento Din\xe1mico","description":"La velocidad del cursor aumenta seg\xfan cu\xe1nto mueves la cabeza. Cuanto m\xe1s mueves la cabeza, m\xe1s r\xe1pido se desliza el cursor."},"proportionalSpeed":{"title":"Velocidad Proporcional","description":"El cursor sigue la punta de su nariz en proporci\xf3n a las dimensiones de su pantalla."},"off":{"title":"Apagado","description":"El movimiento del mouse est\xe1 deshabilitado."},"disabled":"Esta funci\xf3n est\xe1 deshabilitada para conexiones y extensiones remotas."}},"stop":"Detener la c\xe1mara","show":"Mostrar c\xe1mara","hide":"Ocultar c\xe1mara","warn":"No se han iniciado los controles de la c\xe1mara. Inicie la c\xe1mara para permitir los controles de rostro y cuerpo.","draw":{"error":"Error al cargar la se\xf1al de la c\xe1mara. Revisa tu c\xe1mara y vuelve a intentarlo."},"select":"Seleccione una c\xe1mara que desee emparejar para obtener controles mejorados usando su rostro, cuerpo y botones de acci\xf3n r\xe1pida."},"microphone":{"windowTitle":"Controles de Voz Compatibles","title":"Micr\xf3fono","titlePlural":"micr\xf3fonos","settings":"Configuraci\xf3n del Micr\xf3fono","start":"Iniciar Micr\xf3fono","stop":"Detener micr\xf3fono","descriptionShort":"Permite comandos de voz y dictado.","description":"Utilice tu micr\xf3fono incorporado para habilitar los controles de voz y el dictado.","select":"Seleccione el micr\xf3fono que desee emparejar para obtener controles mejorados usando tu voz.","empty":"No se encontraron micr\xf3fonos.","search":"Buscar por nombre de micr\xf3fono","manage":{"title":"Haga clic para ver y administrar los detalles de tus micr\xf3fonos.","description":""},"permission":{"title":"Permisos de micr\xf3fono requeridos","description":"Debe darle permiso a Cephable para usar tu micr\xf3fono y usar los controles de voz.","button":"Abrir configuraci\xf3n de permisos","no":"Sin acceso al micr\xf3fono","help":"Cephable necesita acceso a tu micr\xf3fono para usar los controles de voz. Navegue a <strong>Configuraci\xf3n del sistema</strong>  <strong>Privacidad</strong>  <strong>Micr\xf3fono</strong> y habilite Cephable para acceder a tu micr\xf3fono."},"controls":{"pause":"Pausar controles de voz","paused":"Controles en pausa.","resume":"Reanudar controles de voz","dictationPlay":"Iniciar modo de dictado","dictationPause":"Detener el modo de dictado","prompt":"Empieza a hablar para ver tus controles de voz aqu\xed...","dictationPrompt":"Empieza a hablar para escribir lo que dices...","latency":"Alta latencia detectada. Considere cerrar algunas aplicaciones que podr\xedan estar consumiendo demasiados recursos.","noDeviceConnectedDescription":"El control del micr\xf3fono sirve como vista previa de la interfaz. Ning\xfan paso se ejecutar\xe1 exitosamente. Conecte este dispositivo complementario a otro para iniciar comandos.","status":{"paused":"En pausa.","dictating":"Dictando.","optimistic":"Optimista:","listening":"Escuchando:","loadingModel":"Cargando modelo de voz...","thinking":"Pensamiento...","loadingPhiModel":"Cargando modelo de generaci\xf3n de texto...","generatingText":"Generando...","preparingPhiModel":"Preparando modelo de generaci\xf3n de texto...","permission":"Comprobando permisos del micr\xf3fono...","typing":"Mecanograf\xeda..."},"loadingDetail":"Esto puede tardar unos minutos.","generatingTextDetail":"Detenga la generaci\xf3n cambiando las aplicaciones o diciendo \\"deje de generar\\""},"edit":{"title":"Editar la Configuraci\xf3n del Micr\xf3fono","autoStart":{"title":"Iniciar Micr\xf3fono Autom\xe1ticamente","option":"\xbfInicio autom\xe1tico de micr\xf3fono y controles de voz?","description":"Con esta configuraci\xf3n activada, su dispositivo de entrada activar\xe1 los micr\xf3fonos y empezar\xe1 a procesar los controles de voz al iniciarse, despu\xe9s de conectarlo o encenderlo. Si est\xe1 desactivada, debe pulsar el bot\xf3n \\"Comenzar a escuchar\\" en la p\xe1gina de conexi\xf3n."},"optimistic":{"title":"Controles de Voz Optimistas","option":"\xbfUtiliza controles de voz optimistas?","description":"Cephable tiene dos modos de sensibilidad para los controles de voz: Est\xe1ndar y Optimista. El modo Est\xe1ndar permite a Cephable reconocer todas las palabras que comprende y se puede usar con el modo de dictado. El modo Optimista le indica a Cephable que se centre m\xe1s en los controles de voz de la aplicaci\xf3n. Con el modo Optimista activado, los controles de voz se activar\xe1n m\xe1s r\xe1pido, pero tambi\xe9n podr\xedas activarlos accidentalmente si no dices la palabra exacta. El modo Optimista no permite el dictado."},"confirm":{"title":"Tiene cambios sin guardar.","description":"Se detectaron cambios sin guardar. \xbfDesea guardarlos antes de salir?"},"aiCommands":{"title":"Comandos de voz inteligentes","description":"Los comandos de voz inteligentes permiten que la IA de Cephable prediga los comandos de voz que intentas usar sin necesidad de que coincidan exactamente. Esto te permite indicarle a tu computadora qu\xe9 hacer de forma m\xe1s natural y Cephable te ayuda a descifrarlo.","option":"\xbfUtilizar comandos de voz inteligentes?"},"aiDictation":{"title":"Dictado inteligente y escritura r\xe1pida","description":"Dictado Inteligente y Escritura R\xe1pida ofrecen la experiencia de escritura m\xe1s precisa disponible. Dictado gestiona autom\xe1ticamente la puntuaci\xf3n, los nombres propios y la estructura de las oraciones, mientras que Escritura R\xe1pida proporciona predicciones y correcciones inteligentes que te ayudan a escribir con facilidad y precisi\xf3n.","option":"\xbfC\xf3mo utilizar Dictado inteligente y Escritura r\xe1pida?"},"description":"Administre sus comandos de voz y configuraciones de dictado para esta conexi\xf3n."},"warn":"El micr\xf3fono no se ha activado. Activa el micr\xf3fono para permitir comandos de voz y dictado.","devices":{"error":"Dispositivo de entrada de micr\xf3fono no encontrado."},"startDescription":"Encienda el micr\xf3fono para comenzar a escuchar los comandos."},"localization":{"title":"Preferencias de Idioma","titleShort":"El Idioma","description":"Elija tu idioma preferido de una lista de idiomas admitidos.","newUserDescription":"Seleccione un idioma preferido antes de continuar.","edit":"Actualizar Prefencias de Idioma","display":{"title":"Idioma de la pantalla","description":"Idioma que se muestra al usar Cephable. Esto incluye elementos como men\xfas, notificaciones y controles de aplicaciones, que se muestran en el idioma que prefieras."},"voice":{"title":"Idioma de control de voz","description":"Este es el idioma que se utiliza al reconocer dictados y comandos de voz. Especificar el idioma mejora la precisi\xf3n de tus entradas de voz.","settings":{"title":"Reconocimiento de Voz e Idioma de Pantalla","description":"Ajuste la configuraci\xf3n de idioma tanto para la pantalla como para los controles de voz. Esta opci\xf3n le permite seleccionar tus idiomas preferidos para las interacciones de texto y micr\xf3fono en pantalla, como controles de voz y dictado."}},"locales":{"en":"English \u2014 Ingl\xe9s","en-us":"English (US) \u2014 Ingl\xe9s (Estados Unidos)","es":"Espa\xf1ol","fr":"Fran\xe7ais \u2014 Franc\xe9s","it":"Italiano \u2014 Italiano","de":"Deutsch - Alem\xe1n","ja":"\u65E5\u672C\u8A9E - Japon\xe9s","en-gb":"English (UK) - Ingl\xe9s (Reino Unido)","en-in":"English (India) - Ingl\xe9s (India)"},"save":{"success":"\xa1Preferencias de idioma guardadas!","error":"Error al guardar las preferencias de idioma"},"profile":{"view":"Variantes","title":"Idioma de control de la aplicaci\xf3n","question":"\xbfQu\xe9 idioma de control de la aplicaci\xf3n te gustar\xeda editar?","description":"Algunos controles de la aplicaci\xf3n tienen variantes para diferentes idiomas. Cambia a otro idioma para editar y personalizar.","change":"Cambiar idioma"},"unsupported":{"title":"Idioma no compatible {{locale}}","description":"El idioma seleccionado no es compatible. Elija otro idioma."},"select":"Seleccionar idioma","localesShort":{"en":"Ingl\xe9s","en-us":"Ingl\xe9s (EE. UU.)","es":"Espa\xf1ol","fr":"Franc\xe9s","it":"italiano","de":"Alem\xe1n","ja":"japon\xe9s"}},"mobileApp":{"title":"Aplicaci\xf3n m\xf3vil"},"skipToMain":"Saltar al Contenido Principal","dashboard":{"title":"Panel"},"developer":{"title":"Revelador","titleLong":"Recursos para desarrolladores","description":"Cephable se puede integrar directamente en su aplicaci\xf3n, juego o servicio utilizando nuestros SDK.","sdk":{"title":"Explora nuestros SDK","description":"Ofrecemos SDK de primera clase dise\xf1ados para integrar sin problemas el reconocimiento de voz y los controles adaptativos en sus aplicaciones. Nuestras herramientas est\xe1n dise\xf1adas para mejorar la interacci\xf3n del usuario a trav\xe9s de controles intuitivos y fomentar la accesibilidad, lo que garantiza que todos los usuarios puedan utilizar su software de manera m\xe1s eficaz.","javascript":{"title":"JavaScript","subtitle":"Web","description":"Integre controles de voz y adaptativos directamente en sus aplicaciones web.","action":"Obtener el Paquete NPM"},"net":{"title":".NET","subtitle":"Aplicaciones de Windows","description":"Aproveche el poder de .NET para crear aplicaciones con nuestros SDK WPF y WinUI3.","actionCore":"Obtener el Paquete b\xe1sico","actionWpf":"Obtener el Paquete WPF"},"android":{"title":"Androide","subtitle":"Dispositivos m\xf3viles","description":"Aplicaciones de Android dise\xf1adas para facilitar las capacidades de voz y movimiento de la cabeza.","action":"Obtener el SDK de Android"},"more":{"title":"M\xe1s","description":"\xbfNo encuentras lo que necesitas? Cont\xe1ctanos y te ayudaremos.","action":"Solicitar un SDK"}},"demo":{"title":"Poblaci\xf3n","titleLong":"Experimente nuestros SDK en acci\xf3n","description":"Descubra el poder de nuestras tecnolog\xedas de control de voz y movimiento de la cabeza a trav\xe9s de nuestras aplicaciones de muestra. Desde juegos interactivos hasta aplicaciones web y m\xf3viles din\xe1micas, cada ejemplo demuestra la versatilidad y la eficacia de nuestros SDK. Explore estos ejemplos para obtener informaci\xf3n e inspiraci\xf3n para integrar una accesibilidad mejorada y experiencias inmersivas en sus propios proyectos.","game":{"title":"Juego 2048","subtitle":"Web","description":"Mejora el juego tradicional con controles adaptables de voz y movimiento de cabeza.","action":"Juega el juego"},"unity":{"title":"Unidad","subtitle":"Desarrollo de juegos","description":"Vea c\xf3mo se pueden aprovechar los controles adaptativos en los juegos para brindar una experiencia de usuario m\xe1s atractiva.","action":"Obtenga la muestra"},"samples":"Demostraciones y muestras","other":{"title":"Otras demostraciones","description":"Experimente de primera mano c\xf3mo Cephable puede mejorar su aplicaci\xf3n, juego o dispositivo.","action":"Ver m\xe1s demostraciones"},"web":{"title":"Ejemplos de SDK web","subtitle":"Web","description":"Integraci\xf3n sencilla de toda nuestra funcionalidad principal en aplicaciones web.","action":"Experimente el SDK"}},"other":{"title":"Otros recursos","description":"Si no encuentra lo que necesita en nuestros SDK, intente trabajar directamente con nuestras API o comun\xedquese con la comunidad para obtener ayuda, inspiraci\xf3n y soporte.","api":{"title":"API","description":"Nuestras API le permiten interactuar con Cephable directamente. Puede usar nuestras API para crear integraciones personalizadas."},"support":{"title":"Apoyo","description":"\xbfNo encuentras lo que necesitas? Ponte en contacto con nuestra comunidad a trav\xe9s de Discord.","action":"\xdanete a Discord"}}},"invalidNumber":"N/A","upgrade":"Mejora","license":{"trial":{"subtitle":"Puedes invitar a {{count}} colegas a probar Cephable contigo.","noUsersSubtitle":"No tienes usuarios de prueba restantes. Actualiza a una licencia paga para agregar m\xe1s usuarios.","expired":{"user":"Su actualizaci\xf3n gratuita a {{productName}} vence el {{date}}. Para actualizar, contacte con el administrador de su organizaci\xf3n: {{admin}}.","admin":"Su actualizaci\xf3n gratuita a {{productName}} vence el {{date}}.","userLong":"Parece que tu actualizaci\xf3n gratuita a {{productName}} ha expirado. Para actualizar, contacta con el administrador de tu organizaci\xf3n: {{admin}}.","adminLong":"Parece que tu actualizaci\xf3n gratuita a {{productName}} ha expirado. Puedes actualizar tu licencia para seguir accediendo a funciones avanzadas que no est\xe1n disponibles en Cephable Basic."},"start":"Comience una prueba gratuita","title":{"single":"Se le ha actualizado a {{productName}} de forma gratuita con {{days}} d\xedas restantes","multiple":"{{organization}} est\xe1 en una prueba gratuita con {{days}} d\xedas restantes"},"upgrade":"Al actualizar, mantenga su acceso a funciones como controles de voz mejorados, tareas inteligentes de IA y muchos controles de aplicaciones predise\xf1ados."},"required":{"title":"Se requiere licencia profesional de Cephable","description":"Parece que est\xe1s usando Cephable Basic, que no es compatible con el uso comercial de Cephable. Actualiza a una licencia profesional para seguir usando la aplicaci\xf3n."},"upgrade":{"professional":"Actualizaci\xf3n a la Licencia Profesional de Cephable","generic":{"title":"Mejora tu experiencia con Cephable","description":"La plataforma Cephable ofrece diferentes productos para uso comercial en el trabajo, la escuela o integrados en soluciones nativas."},"fallback":{"title":"Error al cargar el portal de facturaci\xf3n","description":"No se puede cargar el portal de facturaci\xf3n. Haga clic en el bot\xf3n a continuaci\xf3n para comunicarse con sales@cephable.com y continuar con la actualizaci\xf3n."}},"activate":{"question":"\xbfYa tienes una clave de licencia?","button":"Activar","title":"Activa Clave de Licencia","description":"Ingresa tu clave de licencia para actualizar Cephable. Si no tienes una, inicia una prueba gratuita o compra una licencia.","fieldLabel":"Clave de Licencia","placeholder":"NkmurBfZzFrmm9Kx","success":"\xa1Felicitaciones! \xa1Su cuenta ha sido actualizada a {{license}}!","invalid":{"key":"Clave no v\xe1lida. Aseg\xfarese de haber ingresado la clave correcta.","empty":{"key":"Clave no v\xe1lida. Aseg\xfarese de haber ingresado un valor.","name":"Nombre de organizaci\xf3n no v\xe1lido. Aseg\xfarese de haber ingresado un valor."}},"descriptionLong":"Ingresa tu clave de licencia para actualizar Cephable. Si no tienes una, inicia una prueba gratuita o compra una licencia."},"welcome":{"title":"Bienvenido a {{license}}.","description":"Te has unido a {{organization}} con \xe9xito. {{description}}"},"redirect":{"title":"Redireccionando","description":"Se le ha redirigido a un portal de facturaci\xf3n externo. Se abrir\xe1 una nueva pesta\xf1a en su navegador. Si no se le redirige en unos segundos, haga clic en el bot\xf3n que aparece a continuaci\xf3n.","error":"Error de redirecci\xf3n de facturaci\xf3n","external":"Redirigido. Por favor, revise su navegador."},"key":{"title":"Clave de licencia","titlePlural":"Claves de licencia","description":"Una clave de licencia es un identificador \xfanico que se utiliza para otorgar acceso a las funciones profesionales, educativas o para desarrolladores de Cephable.","details":"Detalles de la clave de licencia","assigned":"Usado el: {{date}}","expires":"Caduca el: {{date}}","assign":"Asignar clave a nueva organizaci\xf3n","error":"Error al cargar la clave de licencia.","empty":{"title":"No se encontraron claves de licencia.","description":"Parece que no hay claves de licencia que coincidan con estos criterios o que a\xfan no ha adquirido una clave de licencia."},"product":{"title":"Compra","titleLong":"Comprar claves de licencia","description":"Adquiera una clave de licencia para aprovechar todo el potencial de Cephable. Vea los diferentes planes y opciones de precios disponibles.","action":"Comprar ahora","empty":{"title":"No se encontraron productos.","description":"Parece que no tienes ning\xfan producto. Ponte en contacto con nuestro equipo de ventas o con tu representante para que te ayudemos a resolver este problema."},"yearly":"Facturaci\xf3n anual","years":"Facturado cada {{value}} a\xf1os","days":"Facturado cada {{value}} d\xedas","Subscription":{"title":"Suscripci\xf3n"},"MeteredConsumption":{"title":"Consumo medido"},"PayDown":{"title":"Pagar al contado"},"OneTime":{"title":"Una vez"}}},"pro":{"tag":"Pro","detail":"Esta es una funci\xf3n exclusiva de Cephable Professional","requiredDetail":"Se requiere una licencia profesional de Cephable para esta funci\xf3n. Puede actualizarla o iniciar una prueba gratuita en la configuraci\xf3n de su cuenta."},"titlePlural":"Licencias"},"purchase":"Compra","saveError":"Error al guardar los cambios.","description":"Descripci\xf3n","expand":"Expandir","expandMenu":"Expandir men\xfa","editor":{"title":"Editor de Markdown","bold":"Atrevido","italic":"It\xe1lico","underline":"Subrayar","hr":"Regla horizontal","link":"Enlace","quote":"Cita","code":"C\xf3digo","codeBlock":"Bloque de c\xf3digo","comment":"Comentario","image":"Imagen","table":"Mesa","unordered-list":"Lista desordenada","ordered-list":"Lista ordenada","checked-list":"Lista de comprobaci\xf3n","help":"Ayuda","edit":"Editar","live":"Vivir","preview":"Avance","fullscreen":"Pantalla completa","placeholder":"Por favor ingrese el texto de Markdown aqu\xed...","strikethrough":"Tachado"},"created":"Creado: {{value}}","updated":"Actualizado: {{value}}","deleted":"Eliminado: {{value}}","expires":"Caduca: {{value}}","expired":"Vencido: {{value}}","used":"Usado: {{value}}","results":"Resultados","panel":{"title":"Panel Cefaleable","question":"\xbfPanel de inicio autom\xe1tico?","position":{"top":"Arriba","right":"Bien","left":"Izquierda","bottom":"Abajo ","description":"Seleccione d\xf3nde desea que aparezca el Panel Cephable en su pantalla.","label":"Posici\xf3n"},"sections":{"description":"Elige qu\xe9 secciones del panel son visibles. Puedes ocultarlas seg\xfan tus preferencias para aprovechar al m\xe1ximo el espacio del panel.","microphone":"Controles de micr\xf3fono y voz","camera":"Controles de c\xe1mara y rostro/cabeza","profile":"Controles y vistas previas de la aplicaci\xf3n","globalControls":"Controles globales y de dispositivos","tasks":"Tareas inteligentes","buttons":"Botones de acci\xf3n r\xe1pida"},"titleShort":"Panel","description":"Este es el panel que funciona como centro de control principal. Siempre est\xe1 visible y te permite controlar tus aplicaciones con la voz, entre otras funciones."},"resume":"Reanudar","textGeneration":{"settings":"Configuraci\xf3n de generaci\xf3n de texto","edit":{"title":"Editar la configuraci\xf3n de generaci\xf3n de texto","description":"Puede refinar la configuraci\xf3n de Generaci\xf3n de texto inteligente para crear los mejores resultados para usted.","autoStart":{"title":"Generaci\xf3n de texto de calentamiento autom\xe1tico","description":"Con esta configuraci\xf3n activada, Cephable AI preparar\xe1 autom\xe1ticamente los modelos de IA utilizados para la generaci\xf3n de texto. Esto acelerar\xe1 su rendimiento al usar comandos de generaci\xf3n, pero consumir\xe1 m\xe1s recursos del equipo. Desactivar esta configuraci\xf3n ahorrar\xe1 recursos, pero puede ralentizar la generaci\xf3n de texto.","option":"\xbfModelos de IA de generaci\xf3n de texto de calentamiento autom\xe1tico?"},"prompt":{"title":"Informaci\xf3n adicional para la generaci\xf3n de texto","description":"Introduce informaci\xf3n adicional para usarla con la IA de Cephable para generar texto. Usa este campo para especificar tus preferencias de tono, estilo de escritura o cualquier otro detalle.","field":"Aviso adicional","placeholder":"Por ejemplo, usa un tono amable, escribe con profesionalismo, s\xe9 conciso y directo. Al escribir c\xf3digo, deja comentarios reflexivos, pero no demasiados, etc."},"enableTextGen":{"title":"Habilitar la generaci\xf3n de texto inteligente","description":"Con esta configuraci\xf3n activada, Cephable AI podr\xe1 usar el control del dispositivo de generaci\xf3n de texto para generar texto en cualquier aplicaci\xf3n. Desactivarla deshabilitar\xe1 este comando.","option":"\xbfUtilizar generaci\xf3n de texto inteligente?"},"terminate":{"title":"Recursos para la generaci\xf3n de texto claro","description":"Haz clic para borrar los recursos utilizados para la generaci\xf3n de texto. Esto liberar\xe1 recursos en tu computadora, pero podr\xeda ralentizar la generaci\xf3n de texto la pr\xf3xima vez que la uses.","button":"Recursos claros","success":"Limpieza de recursos de generaci\xf3n de texto.","confirm":{"title":"Recursos para la generaci\xf3n de texto claro","description":"\xbfSeguro que desea borrar los recursos utilizados para la generaci\xf3n de texto? Esto liberar\xe1 recursos en su computadora, pero podr\xeda ralentizar la generaci\xf3n de texto la pr\xf3xima vez que la use.","confirm":"S\xed, recursos claros","cancel":"Cancelar"}},"clearModelCache":{"title":"Borrar cach\xe9 del modelo de IA","description":"Seleccione qu\xe9 cach\xe9 del modelo de IA desea borrar y volver a descargar. Esto liberar\xe1 espacio de almacenamiento en su ordenador y volver\xe1 a descargar los archivos del modelo seleccionado.","button":"Borrar y volver a descargar","success":"Se eliminaron archivos de modelo local.","confirm":{"title":"Borrar y volver a descargar la cach\xe9 del modelo de IA","description":"\xbfEst\xe1 seguro de que desea borrar la cach\xe9 del modelo de IA seleccionado y eliminar los archivos de su sistema? Los modelos seleccionados se volver\xe1n a descargar autom\xe1ticamente.","confirm":"S\xed, borrar y volver a descargar.","cancel":"Cancelar","textGenLabel":"Text Generation (Inference) model","workflowsLabel":"AI Workflows models"},"error":"Error al eliminar archivos del modelo local."},"enableHistory":{"title":"Habilitar el historial de generaci\xf3n de texto","description":"Con esta configuraci\xf3n activada, Cephable AI utilizar\xe1 su historial de generaci\xf3n de texto para generar texto con el contexto de su acci\xf3n anterior.","option":"\xbfUtilizar el historial de generaci\xf3n de texto?"}},"prompt":{"systemPrompt":"Genere SOLO el texto solicitado: sin explicaciones, comentarios ni texto superfluo. Sin Markdown ni explicaciones espont\xe1neas. Para el c\xf3digo, genere solo c\xf3digo sin formato: sin restricciones, etiquetas de idioma ni explicaciones.","appName":"Actualmente est\xe1s generando texto para {{appName}}.","userPreferences":"Respete estas preferencias de usuario sobre c\xf3mo quieren que se genere el texto: {{userPreferences}}."},"rewritePrompt":{"systemPrompt":"Reescriba o reformatee el texto proporcionado seg\xfan las instrucciones. Si se reformatea (por ejemplo, listas, tablas, cambios de estructura), conserve exactamente las palabras originales. Si se reescribe (por ejemplo, tono, estilo, extensi\xf3n), conserve el significado, pero no necesariamente las palabras. Imprima SOLO el resultado, sin explicaciones ni comentarios. Esto puede ser parte de un documento m\xe1s extenso. Imprima solo el resultado sin encabezados, etiquetas ni pre\xe1mbulos.","userPreferences":"Respete estas preferencias de usuario sobre c\xf3mo quieren que se genere el texto: {{userPreferences}}.","rewriteInstructions":"Instrucciones: {{rewriteInstructions}}."},"translatePrompt":{"systemPrompt":"Traduce el siguiente texto a {{language}}. Imprime SOLO el texto traducido. Sin explicaciones, pre\xe1mbulos, formato Markdown ni restricciones de c\xf3digo. Conserva el formato. Para el c\xf3digo: traduce solo comentarios y cadenas, conservando la sintaxis con precisi\xf3n.","userPreferences":"Respete estas preferencias de usuario sobre c\xf3mo quieren que se genere el texto: {{userPreferences}}.","genericUserPrompt":"Traducir: {{userRequestText}}"},"disabled":{"title":"Las tareas inteligentes est\xe1n deshabilitadas","description":"Parece que has desactivado las tareas inteligentes. Actualiza para desbloquear la generaci\xf3n de texto, la reescritura y m\xe1s en tu configuraci\xf3n."},"summarizePrompt":{"systemPrompt":"Resuma el texto proporcionado de forma concisa. Puede formar parte de un documento m\xe1s extenso. Imprima SOLO el resumen, sin pre\xe1mbulo, etiquetas ni explicaciones.","userPreferences":"Respete estas preferencias de usuario sobre c\xf3mo desea que se genere el texto: {{userPreferences}}.","userPrompt":"Resumir: {{userRequestText}}"}},"profile":{"title":"Controles de la aplicaci\xf3n","titlePlural":"Controles de la aplicaci\xf3n","titlePreview":"Vista previa de los controles","previous":"Controles de aplicaciones anteriores","manage":"Administrar controles de aplicaciones","view":"Controles de vista","edit":"Editar controles de la aplicaci\xf3n","add":"Agregar controles de aplicaci\xf3n","create":"Crear controles de aplicaci\xf3n","warn":"La c\xe1mara o el micr\xf3fono deben estar iniciados para poder usar los controles de la aplicaci\xf3n.","descriptionShort":"Descubra las diferentes formas en que Cephable le ayuda a controlar sus dispositivos y software.","name":"Nombre de la aplicaci\xf3n","nameQuestion":"\xbfC\xf3mo quieres llamar a estos controles de la aplicaci\xf3n?","newName":"Nuevos controles de la aplicaci\xf3n","search":"Buscar controles de aplicaciones por nombre","searchLong":"Buscar controles de aplicaciones por nombre o descripci\xf3n","keyboardAndMouse":"Teclado y rat\xf3n","genericController":"Mando de gamepad","keyboardMouseAndController":"Teclado, rat\xf3n y controlador","permissionError":"No tienes permiso para usar estos controles de la aplicaci\xf3n.","set":{"title":"Parece que a\xfan no tienes configurados los controles de la aplicaci\xf3n.","cta":"Establecer controles de la aplicaci\xf3n","empty":{"auto":"Cambiar a otra aplicaci\xf3n para ver los controles","select":"Seleccione un control para comenzar","none":"No se encontraron controles de aplicaci\xf3n"},"description":"Los controles de la aplicaci\xf3n permiten a Cephable saber qu\xe9 detectar y qu\xe9 acciones realizar. Puedes cambiar los controles de la aplicaci\xf3n cuando quieras desde la p\xe1gina de inicio o en la configuraci\xf3n de tu conexi\xf3n."},"summary":{"title":"Resumen de los controles de la aplicaci\xf3n","descriptionLong":"Aqu\xed tienes los detalles de estos controles de la aplicaci\xf3n. Puedes buscar controles, acciones y m\xe1s para ver qu\xe9 puedes hacer con ellos.","description":"Obtenga un resumen de estos controles de la aplicaci\xf3n, incluidos qu\xe9 controles hay, personalizaciones, detalles y m\xe1s.","view":"Ver resumen de controles de la aplicaci\xf3n","filter":"Filtrar por tipo de entrada","placeholder":"Buscar nombres de controles..."},"copy":{"title":"Copiar controles de la aplicaci\xf3n","duplicate":"Controles de aplicaciones duplicados","question":"\xbfCrear una copia?","description":"\xbfQuieres crear una copia de estos controles de la aplicaci\xf3n? Se abrir\xe1 una nueva ventana con los controles copiados, pero no se a\xf1adir\xe1 a tu cuenta hasta que la guardes.","confirm":"S\xed, crea una copia","profileSuffix":"{{name}} (copia)"},"new":{"title":"Crear nuevos controles de aplicaci\xf3n","description":"Crea controles desde cero o deja que la IA de vanguardia genere controles personalizados, lo que te permitir\xe1 navegar por aplicaciones y software sin esfuerzo usando tu voz, cabeza y gestos faciales.","note":"Recomendado para usuarios avanzados.","scratch":"Crear desde cero"},"advancedOptions":"Opciones de control avanzadas","delete":{"title":"Eliminar controles de la aplicaci\xf3n","titleLong":"Eliminar estos controles de la aplicaci\xf3n","description":"Puede eliminar estos controles de aplicaci\xf3n haciendo clic en \\"Eliminar controles de aplicaci\xf3n\\".","confirm":"\xbfEst\xe1s seguro de que deseas eliminar estos controles de la aplicaci\xf3n?","confirmLong":"Una vez que elimines estos controles de la aplicaci\xf3n, no podr\xe1s volver a ellos. \xbfEst\xe1s seguro de que quieres eliminarlos?","confirmButton":"S\xed, elimine estos controles de la aplicaci\xf3n"},"current":"Controles actuales","loading":"Controles de carga...","null":"A\xfan no tienes controles de aplicaci\xf3n. Haz clic abajo para crear uno.","nullButton":"Crea tus primeros controles de aplicaci\xf3n","preview":"Avance","features":"Caracter\xedsticas","byline_public":"Por: Equipo Cephable","byline_shared":"Compartido por: Comunidad Cephable","share":{"title":"Controles de la aplicaci\xf3n para compartir","previewTitle":"Vista previa de los controles de aplicaciones compartidas","description":"\xa1Comparte estos controles de aplicaci\xf3n con otros para que puedan obtener una copia y personalizarlos desde all\xed!","descriptionLong":"Comparte estos controles de la aplicaci\xf3n para que puedan obtener una copia y personalizarlos desde ah\xed. Elige c\xf3mo quieres compartirlos y crea un enlace para enviarlos.","add":"Crear un enlace para compartir","confirm":"Comparte esta URL","link":"Compartir enlace","copy":"Copiar enlace","copied":"\xa1Copiado!","usage":"Cantidad de uso","created":"Creado {{value}}","expiration":{"title":"Vencimiento","once":"Solo se permite un uso","unlimited":"Permitir uso ilimitado","no":"Sin vencimiento","date":"Fecha de expiraci\xf3n","dateDescription":"Caduca en una fecha espec\xedfica"},"manage":"Administrar enlaces compartidos anteriores","empty":"No se han creado recursos compartidos para estos controles de aplicaci\xf3n."},"swap":{"title":"Controles de intercambio","titleLong":"Intercambia los controles de tu aplicaci\xf3n","descriptionShort":"Utilice diferentes controles de aplicaci\xf3n para que coincidan con el programa o software que est\xe1 utilizando.","description":"Puede alternar entre diferentes controles de aplicaciones para que coincidan con el programa o software que est\xe9 utilizando."},"autoProfileSwitching":{"title":"Conmutaci\xf3n autom\xe1tica de control","alerts":{"disabled":"El cambio autom\xe1tico de control est\xe1 desactivado.","temporarilyDisabled":"El cambio autom\xe1tico de control est\xe1 desactivado temporalmente.","enabled":"El cambio de control autom\xe1tico est\xe1 activado.","error":"Error al guardar las preferencias de cambio de control autom\xe1tico"},"associatedPrograms":{"add":"Agregar un nuevo programa asociado","description":{"personal":"Seleccione el software o los programas que desea conectar a estos controles. Esto permite el cambio autom\xe1tico de controles, donde Cephable cambiar\xe1 autom\xe1ticamente los controles de la aplicaci\xf3n para que coincidan con el programa que est\xe9 usando.","short":"Elija el software o programas que desea conectar a estos controles."},"edit":"Editar programas asociados","noOptionsText":"Comience a escribir para encontrar programas asociados","profileLabel":"Controles de la aplicaci\xf3n:","remove":"Eliminar programa asociado","title":"Programas asociados","when":"Cephable cambiar\xe1 autom\xe1ticamente los controles de mi aplicaci\xf3n a {{profileName}} cuando use...","emptySearch":"No hay programas asociados a estos controles.","error":"Error al guardar los programas asociados. Int\xe9ntalo de nuevo m\xe1s tarde.","emptyError":"Se detect\xf3 un programa asociado vac\xedo, elim\xednelo antes de continuar."},"commandOverlay":{"command":"Cambiar los controles de la aplicaci\xf3n: {{value}}"},"description":"El cambio autom\xe1tico de controles permite que Cephable se adapte a tu flujo de trabajo sin problemas. Al activarlo, Cephable ajustar\xe1 los controles de tu app seg\xfan el programa o software que uses. Si lo desactivas, puedes cambiar manualmente los controles de la app con el bot\xf3n \\"Intercambiar controles\\" o con comandos globales."},"error":{"noMatch":"No hay controles de aplicaci\xf3n que coincidan con tu b\xfasqueda.","load":"Error al cargar los controles de la aplicaci\xf3n.","add":"Error al agregar controles de la aplicaci\xf3n.","delete":"Error al eliminar los controles de la aplicaci\xf3n.","audioEventsWithEmptyCommands":"Faltan controles en tu respuesta. Revisa los controles para asegurarte de que est\xe9n completos.","conflicts":"Error al guardar los controles de la aplicaci\xf3n debido a conflictos.","save":"Error al guardar los controles de la aplicaci\xf3n. Int\xe9ntalo de nuevo.","device":"Control de aplicaci\xf3n no v\xe1lido para esta conexi\xf3n. Prueba con otro."},"conflictIndicators":{"errorTitle":"Error al guardar los controles de la aplicaci\xf3n debido a conflictos","warningTitle":"Controles de la aplicaci\xf3n guardados con advertencias","subtitle":"Los controles de la aplicaci\xf3n que creaste tienen algunas configuraciones que pueden entrar en conflicto.","profileNameErrors":"Conflicto de nombres en los controles de la aplicaci\xf3n","emptyControlsMapped":"Nombres de entrada vac\xedos","emptyControlsMappedDescription":"Agregue un comando de voz, expresi\xf3n facial, inclinaci\xf3n de cabeza u otro comando a su entrada.","emptyKeybindingControlsMapped":"Nombres de entrada vac\xedos para las combinaciones de teclas","emptyKeybindingControlsMappedDescription":"Agregue un comando de voz, expresi\xf3n facial, inclinaci\xf3n de cabeza u otro comando a su entrada para las combinaciones de teclas.","duplicateNameTitle":"Nombre de controles de aplicaci\xf3n duplicados","duplicateNameDescription":"Tienes controles de aplicaci\xf3n con el mismo nombre. C\xe1mbialo antes de continuar.","emptyNameTitle":"Nombre de controles de aplicaci\xf3n vac\xedos","emptyNameDescription":"Los controles de la aplicaci\xf3n deben tener un nombre, por ejemplo, Juego 1, Spotify, Palabra, etc.","macrosReleaseKeysMissingTitle":"Salidas con claves no liberadas","macrosReleaseKeysMissingDescription":"Agregue una clave de liberaci\xf3n o detenga todos los pasos para evitar que las claves se atasquen.","duplicateInputCommandMacroTitle":"Entradas de control id\xe9nticas","duplicateCommandsDescription":"Elimine o cambie los comandos de entrada duplicados.","duplicateInputCommandBindingsTitle":"Entradas de control id\xe9nticas para combinaciones de teclas","conflictIndicatorDisplayString":"{{container}}: {{commandOrKeyName}} con {{commandOrEventType}}","duplicateMacroNames":"Nombres de control duplicados","duplicateMacroNamesDescription":"Elimine o cambie uno de sus nombres de control id\xe9nticos.","warningIgnore":"Ignorar","warningDoNotShowAgain":"No volver a mostrar advertencias","macrosVoiceCommandConflictWithDictationTitle":"Controlar los comandos de voz igual que las palabras clave de dictado","keybindingsVoiceCommandConflictWithDictationTitle":"Combinaciones de teclas: comandos de voz iguales que las palabras clave de dictado","macrosVoiceCommandConflictWithDictationDescription":"Tus entradas de voz activar\xe1n el dictado y los comandos de voz.","keybindingsVoiceCommandConflictWithDictationDescription":"Tus entradas de voz activar\xe1n el dictado y las pulsaciones de teclas.","macrosVoiceCommandConflictWithGenerationTitle":"Los comandos de voz de control son los mismos que las palabras clave de generaci\xf3n","keybindingsVoiceCommandConflictWithGenerationTitle":"Las combinaciones de teclas de los comandos de voz son las mismas que las palabras clave de generaci\xf3n","macrosVoiceCommandConflictWithGenerationDescription":"Tus entradas de voz activar\xe1n la generaci\xf3n y los comandos de voz.","keybindingsVoiceCommandConflictWithGenerationDescription":"Tus entradas de voz activar\xe1n la generaci\xf3n y las pulsaciones de teclas.","duplicateAssociatedProgramNames":"Nombres de programas asociados duplicados","duplicateAssociatedProgramNamesDescription":"Elimine o cambie uno de sus programas asociados id\xe9nticos.","emptyEvent":{"title":"Pasos faltantes","description":"Faltan pasos en tus controles. Esto podr\xeda provocar que Cephable no realice una acci\xf3n al dar una orden."},"warningDetails":"Ver todos los conflictos"},"success":{"save":"Controles de la aplicaci\xf3n guardados.","add":"Se agregaron controles de aplicaci\xf3n.","delete":"Controles de la aplicaci\xf3n eliminados.","share":"Enlace compartido creado y copiado al portapapeles","shareDelete":"Enlace compartido eliminado.","generate":"Controles de aplicaci\xf3n generados."},"warning":"Controles de la aplicaci\xf3n guardados con advertencias","customize":"Personalizar los controles de la aplicaci\xf3n","custom":"{{name}} (Personalizado)","description":"Los controles de la aplicaci\xf3n son un conjunto de controles que puedes usar para controlar tu dispositivo o conexi\xf3n. Puedes crear varios controles de la aplicaci\xf3n y alternar entre ellos cuando quieras."},"publicProfiles":{"toolbar":"Explorar los controles de la aplicaci\xf3n","title":"Explorar los controles de la aplicaci\xf3n","offline":{"title":"No se pueden cargar los controles de la aplicaci\xf3n p\xfablica","description":"Parece que no tienes conexi\xf3n. Puedes seguir usando los controles de tu aplicaci\xf3n, pero no podr\xe1s cargar nuevos controles p\xfablicos.","confirm":"Bueno"},"announcement":"Se han cargado {{count}} nuevos controles de aplicaci\xf3n","description":{"personal":"Los controles p\xfablicos de aplicaciones est\xe1n disponibles para ayudarte a empezar a usar Cephable r\xe1pidamente en tus aplicaciones favoritas. Puedes usar los controles predeterminados, personalizarlos seg\xfan tus necesidades o crear controles de aplicaci\xf3n completamente nuevos y personalizados desde cero.","pro":"Los controles p\xfablicos de aplicaciones est\xe1n disponibles para ayudarte a empezar a usar Cephable r\xe1pidamente en tus aplicaciones favoritas. Puedes usar los controles predeterminados, personalizarlos seg\xfan tus necesidades o crear controles personalizados completamente nuevos mediante el generador de controles."},"team":"Equipo Cephable"},"publicTag":"P\xfablico","tray":{"panel":"Panel de alternancia","dashboard":"Mostrar panel de control","quit":"Salir de Cephable"},"generate":"Generar","stop":"Detener","clear":"Claro","rewrite":"Volver a escribir","translate":"Traducir","smartTasks":{"title":"Tareas inteligentes","show":"Mostrar tareas inteligentes","description":"Las tareas inteligentes son las diferentes tareas que la IA de Cephable puede realizar por ti. Estas tareas, impulsadas por la IA del dispositivo, permiten crear texto, resumir, reescribir, traducir, tomar notas y chatear con documentos.","generateText":{"title":"Generar texto","description":"Crea contenido de texto basado en tus aportaciones o indicaciones.","label":"Describe lo que quieres generar"},"summarizeText":{"title":"Resumir texto","description":"Condensar un texto extenso en un resumen conciso.","directions":"Ingrese el texto a resumir, o Cephable utilizar\xe1 autom\xe1ticamente el texto que haya resaltado.","titleShort":"Resumir","write":"Escribir resumen","label":"Introduzca texto para resumir","outputLabel":"Tu resumen se escribir\xe1 aqu\xed."},"rewriteText":{"title":"Reescribir texto","description":"Resalte el texto en otra aplicaci\xf3n donde est\xe9 escribiendo y luego regrese aqu\xed y describa c\xf3mo desea que se reescriba.","label":"Describe c\xf3mo quieres reescribir el texto.","inputLabel":"Introduzca el texto para reescribir"},"translateText":{"title":"Traducir texto","description":"Ingrese el texto a traducir o Cephable utilizar\xe1 autom\xe1ticamente el texto que haya resaltado.","label":"Introduzca el texto a traducir","languageLabel":"Idioma al que traducir"},"noteTaker":{"title":"Tomador de notas","description":"Deje que Cephable grabe y transcriba localmente sus reuniones o conversaciones"},"documentChat":{"title":"Chat de documentos","description":"Interact\xfae y consulte documentos para obtener informaci\xf3n r\xe1pidamente."},"highlightText":{"title":"Usar texto resaltado","description":"Cephable puede usar autom\xe1ticamente el texto que hayas resaltado en cualquier aplicaci\xf3n para realizar tareas como resumir, reescribir o traducir. Tambi\xe9n puedes introducir el texto manualmente si lo prefieres.","label":"Introduzca el texto a utilizar","placeholder":"Tambi\xe9n puedes resaltar texto en otra aplicaci\xf3n y volver aqu\xed para usarlo."},"pasteText":{"title":"Pegar texto","description":"Cephable puede usar autom\xe1ticamente el texto que has copiado al portapapeles para realizar tareas como resumir, reescribir o traducir. Tambi\xe9n puedes introducir el texto manualmente si lo prefieres.","label":"Introduzca el texto a utilizar","placeholder":"Tambi\xe9n puedes resaltar texto en otra aplicaci\xf3n y volver aqu\xed para usarlo."},"clearCache":"Si observa problemas con la generaci\xf3n, borre el cach\xe9 y los recursos de la Configuraci\xf3n de generaci\xf3n de texto y vuelva a intentarlo.","transcribeAudio":{"title":"Transcribir audio","description":"Convierta archivos de audio o video en texto usando la transcripci\xf3n de IA.","inputMethod":"Elija el m\xe9todo de entrada","localFile":"Archivo local","url":"URL","selectFile":"Seleccionar archivo de audio/video","urlLabel":"URL de audio/v\xeddeo","transcribe":"Transcribir","result":"Resultado de la transcripci\xf3n","invalidFileType":"Seleccione un archivo de audio o v\xeddeo v\xe1lido (mp3, wav, ogg, mp4, webm, mov, avi)","error":"Error de transcripci\xf3n","history":{"title":"Historial de transcripci\xf3n","description":"Vea y administre sus transcripciones guardadas.","viewHistory":"Ver historial","empty":"A\xfan no hay transcripciones. \xa1Empieza a transcribir para construir tu historia!","titleLabel":"T\xedtulo (opcional)","titlePlaceholder":"Introduzca un t\xedtulo para esta transcripci\xf3n","textLabel":"Texto de transcripci\xf3n","confirmDelete":"\xbfEst\xe1 seguro de que desea eliminar esta transcripci\xf3n?"}},"aiWorkflows":{"description":"Automatiza las tareas de tu escritorio y navegador con IA. Simplemente describe lo que quieres lograr y observa c\xf3mo Cephable ejecuta las acciones.","label":"Describe lo que quieres lograr","status":{"idle":"Esperando tus instrucciones...","initializing":"Preparando las cosas...","planning":["Haciendo un plan...","Desglosando su solicitud...","Trazando los pasos...","Organizando el flujo de trabajo...","Preparando la estrategia...","Creando un plan de acci\xf3n...","Descubriendo la mejor manera de ayudarte...","Determinar c\xf3mo abordar esto...","Analizando su solicitud...","Planificando la ejecuci\xf3n..."],"thinking":["Pensamiento...","Analizando su solicitud...","Descubriendo la mejor manera de ayudarte...","Determinar qu\xe9 hacer a continuaci\xf3n...","Procesando los pasos anteriores...","Trabajando en tu solicitud...","Obteniendo detalles...","Revisando el plan...","Considerando las opciones...","Crear, evaluar, decidir..."],"waitingForUser":"Necesitamos su aportaci\xf3n para continuar.","completed":"\xa1\xc9xito!","failed":"Tu solicitud fall\xf3. Int\xe9ntalo de nuevo.","canceled":"Su solicitud fue cancelada","terminated":"Detenido. Esperando tus instrucciones...","thinkingInteractive":["Considerando el siguiente paso...","Repasando lo que hemos hecho hasta ahora...","Decidir qu\xe9 hacer a continuaci\xf3n...","Analizando los resultados...","Planificando la continuaci\xf3n...","Evaluando las opciones...","Descubriendo cu\xe1l es el mejor siguiente paso...","Trabajando en la siguiente parte de tu solicitud...","Trabajando en los pr\xf3ximos pasos...","Procesando los resultados del paso anterior..."],"tools":{"click_element_by_index":{"executing-start":"Haciendo clic en el bot\xf3n correspondiente...","executing-complete":"Hice clic en {{params.index}}."},"click_element":{"executing-start":"Haciendo clic en el n\xfamero resaltado...","executing-complete":"Hice clic en {{params.elementName}}."},"copy_selection":{"executing-start":"Recopilando contexto...","executing-complete":"Tengo el contexto, listo para la siguiente parte de tu solicitud."},"create_file":{"executing-start":"Creando un archivo...","executing-complete":"Cre\xe9 un archivo llamado {{params.fileName}}."},"draft_email":{"executing-start":"Redactar un correo electr\xf3nico...","executing-complete":"Redact\xe9 un correo electr\xf3nico sobre {{params.subject}}."},"execute_app_action":{"executing-start":"Ejecutando {{params.actionName}}...","executing-complete":"{{params.actionName}} completado."},"find_all_text":{"executing-start":"Buscando todo el contexto relevante sobre {{params.searchText}}...","executing-complete":"Encontr\xe9 todo el contexto relevante sobre {{params.searchText}}."},"find_and_select_text":{"executing-start":"Buscando y seleccionando contexto relevante sobre {{params.searchText}}...","executing-complete":"Encontr\xe9 y seleccion\xe9 contexto relevante sobre {{params.searchText}}."},"generate_text":{"executing-start":"Creando contenido...","executing-progress":"Creando contenido...{{progress}}%","executing-complete":"He creado el contenido solicitado."},"get_all_interactive_elements":{"executing-start":"Escaneando para obtener m\xe1s contexto...","executing-complete":"Entiendo con qu\xe9 puedo interactuar."},"get_all_text_elements_content":{"executing-start":"Leyendo para obtener m\xe1s contexto...","executing-complete":"Entiendo qu\xe9 contenido de texto est\xe1 disponible."},"get_all_text_elements_names":{"executing-start":"Leyendo para obtener m\xe1s contexto...","executing-complete":"Entiendo qu\xe9 contenido de texto est\xe1 disponible."},"get_available_profile_actions":{"executing-start":"Comprobando qu\xe9 controles est\xe1n disponibles en esta aplicaci\xf3n...","executing-complete":"Entiendo lo que puedo hacer en esta aplicaci\xf3n."},"get_document_content":{"executing-start":"Leyendo para obtener m\xe1s contexto...","executing-complete":"Tengo el contexto, listo para la siguiente parte de tu solicitud."},"get_installed_apps":{"executing-start":"Decidir qu\xe9 aplicaci\xf3n es relevante para su solicitud...","executing-complete":"S\xe9 qu\xe9 aplicaciones puedo usar."},"get_running_app_names":{"executing-start":"Decidir qu\xe9 aplicaci\xf3n es relevante para su solicitud...","executing-complete":"S\xe9 qu\xe9 aplicaciones puedo usar."},"get_selected_text":{"executing-start":"Leyendo el contenido seleccionado...","executing-complete":"Tengo contexto sobre el contenido seleccionado."},"get_stored_content":{"executing-start":"Recopilando contexto...","executing-complete":"Tengo el contexto, listo para la siguiente parte de tu solicitud."},"keyboard_shortcut":{"executing-start":"Recopilando contexto...","executing-complete":"Tengo el contexto, listo para la siguiente parte de tu solicitud."},"open_app":{"executing-start":"Abriendo {{params.appName}}...","executing-complete":"Abr\xed {{params.appName}}."},"open_webpage":{"executing-start":"Abriendo {{params.url}}...","executing-complete":"Abr\xed {{params.url}}."},"paste_content":{"executing-start":"Escribiendo...","executing-complete":"Termin\xe9 de escribir."},"respond_to_user":{"executing-start":"Completando su solicitud...","executing-complete:":"He completado tu solicitud."},"search_and_open_file":{"executing-start":"Buscando el archivo {{params.query}} y abri\xe9ndolo...","executing-complete":"Busqu\xe9 el archivo {{params.query}} y lo abr\xed."},"search_browser":{"executing-start":"Buscando en la web {{params.query}}...","executing-complete":"Busqu\xe9 en la web {{params.query}}."},"select_all_text":{"executing-start":"Seleccionando todo el texto...","executing-complete":"Seleccion\xe9 todo el texto."},"summarize_text":{"executing-start":"Resumiendo el texto...","executing-progress":"Resumiendo...{{progress}}%","executing-complete":"Resum\xed el texto."},"translate_text":{"executing-start":"Traduciendo el texto a {{params.targetLanguage}}...","executing-progress":"Traduciendo...{{progress}}%","executing-complete":"Traduje el texto a {{params.targetLanguage}}."},"type_stored_content":{"executing-start":"Escribiendo...","executing-complete":"Termin\xe9 de escribir."},"type_text":{"executing-start":"Escribiendo...","executing-complete":"Termin\xe9 de escribir."},"write_file_content":{"executing-start":"Escribiendo en el archivo...","executing-complete":"Termin\xe9 de escribir en el archivo {{params.fileName}}."},"unknown":{"executing-start":"Me encontr\xe9 con un problema y prob\xe9 una estrategia diferente...","executing-complete":"Prob\xe9 una estrategia diferente."}},"networkError":"Se perdi\xf3 la conexi\xf3n al descargar el modelo. Comprueba tu conexi\xf3n a internet y vuelve a intentarlo enviando un mensaje o reiniciando la aplicaci\xf3n.","executing-org-block":"No se puede {{params.toolName}} porque la interacci\xf3n con {{params.appOrDomain}} est\xe1 bloqueada por la organizaci\xf3n.","executing-destructive-block":"La interacci\xf3n con {{params.elementName}} est\xe1 bloqueada. Por favor, revise y realice esta acci\xf3n manualmente.","executing-type-focus-block":"Tuve un problema al escribir el contenido. Se copi\xf3 al portapapeles; por favor, p\xe9guelo manualmente."},"ready":{"waiting":"AI Workflows est\xe1 listo. Esperando tus instrucciones.","execute":"Los flujos de trabajo de IA est\xe1n listos. A partir de tu solicitud..."},"start":"Comenzar","progress":"Laboral...","introModal":{"description":"Ahora puedo automatizar las tareas de tu ordenador y navegador. Solo dime qu\xe9 quieres que haga y yo me encargar\xe9 de todo. Me ejecuto de forma privada en tu dispositivo, as\xed que tus datos son tuyos. Para empezar, necesito descargar un modelo de IA local. Desc\xe1rgalo ahora para que est\xe9 listo, o lo har\xe9 cuando inicies tu primer flujo de trabajo.","confirm":"Descargar ahora","cancel":"Saltar por ahora","title":"Los flujos de trabajo de IA est\xe1n disponibles."},"title":"Sus flujos de trabajo de IA est\xe1n listos."},"generatedByAI":"Desarrollado con inteligencia artificial en el dispositivo, revise para verificar su precisi\xf3n.","networkError":"Se perdi\xf3 la conexi\xf3n al descargar el modelo. Comprueba tu conexi\xf3n a internet y vuelve a intentarlo enviando un mensaje o reiniciando la aplicaci\xf3n.","genericError":"Se ha producido un error inesperado. Por favor, int\xe9ntelo de nuevo.","download":{"title":"Descarga modelos de IA para desbloquear m\xe1s funcionalidades.","description":"Para usar las tareas inteligentes, es necesario descargar un modelo local en tu dispositivo. Esto garantiza que tus datos permanezcan privados y nunca se env\xeden a la nube.","confirm":"Descargar","cancel":"Ahora no","includeWorkflows":"Descargue tambi\xe9n modelos de flujo de trabajo de IA para una automatizaci\xf3n avanzada."}},"inputMethod":"M\xe9todo de entrada:","hotkey":{"title":"Bot\xf3n de acci\xf3n r\xe1pida","titlePlural":"Botones de acci\xf3n r\xe1pida","titlePanel":"Acciones r\xe1pidas","label":"Nombre para mostrar del bot\xf3n de acci\xf3n r\xe1pida","placeholder":"Nombre para mostrar","question":"\xbfC\xf3mo te gustar\xeda llamar a este bot\xf3n?","when":"Cuando toco...","description":"Los botones de acci\xf3n r\xe1pida son botones personalizables que puedes pulsar para realizar acciones relevantes en tu aplicaci\xf3n. Con una sola pulsaci\xf3n puedes ejecutar varios pasos o una sola acci\xf3n.","usagePrompt":"Los botones de acci\xf3n r\xe1pida son botones personalizables que puedes pulsar para realizar acciones relevantes en tu aplicaci\xf3n. Puedes a\xf1adir, eliminar o editar los nombres desde la p\xe1gina principal de configuraci\xf3n de controles de la aplicaci\xf3n.","reorder":"Puede reorganizar el orden utilizando los botones de subir y bajar.","emptyTitle":"Sin botones de acci\xf3n r\xe1pida","edit":"Editar botones de acci\xf3n r\xe1pida","tap":"Toque {{value}}","copySuffix":"{{name}}_copiar","hotkeysOnly":"Botones personalizados","allControls":"Todos los controles de la aplicaci\xf3n","show":"Mostrar botones de acci\xf3n r\xe1pida","deprecatedDialog":{"title":"Los controles de tu aplicaci\xf3n requieren una actualizaci\xf3n.","description2":"Solo necesitas una actualizaci\xf3n r\xe1pida (literalmente, un segundo) y disfrutar\xe1s de una experiencia de personalizaci\xf3n de botones impecable. Olv\xeddate de los pasos adicionales y dale la bienvenida a una interfaz m\xe1s intuitiva. \xbfListo para el cambio?","confirm":"\xa1Vamos a hacerlo!","description1":"Parece que est\xe1s usando controles de app antiguos con botones de acci\xf3n r\xe1pida. \xa1Tenemos novedades emocionantes para ti! Hemos renovado el sistema para que crear y editar botones de acci\xf3n r\xe1pida sea muy f\xe1cil, sin necesidad de tener que recurrir a ajustes avanzados."},"demo":{"title":"Botones de acci\xf3n r\xe1pida de demostraci\xf3n","step1":"Activar los botones de acci\xf3n r\xe1pida","step2":"Utilice los ejemplos que aparecen a continuaci\xf3n para controlar el bloque de texto.","command1":"Presione el bot\xf3n 1 para \u201CAgrandar el texto\u201D","command2":"Presione el bot\xf3n 2 para poner el texto en negrita","command3":"","continue":"Continuar con los botones de acci\xf3n r\xe1pida","description":"El \xe1rea de demostraci\xf3n a continuaci\xf3n le permitir\xe1 probar los botones de acci\xf3n r\xe1pida. La demostraci\xf3n se limita espec\xedficamente al control de esta \xe1rea de texto."},"example":{"title":"Ejemplos de botones de acci\xf3n r\xe1pida","command1":"Toque Pausa","example1":"Ejemplo de \u201Cpausar video\u201D","command2":"Toque hacia adelante","example2":"Ejemplo de \u201Calejar\u201D","command3":"Toque Detener","example3":"Ejemplo \u201Ccerrar ventana\u201D","description":"Estos ejemplos demuestran la versatilidad de los botones de acci\xf3n r\xe1pida para controlar tu dispositivo o conexi\xf3n. Permiten ejecutar comandos, navegar por interfaces o realizar acciones con un simple toque."},"emptySearch":"No hay acciones r\xe1pidas que coincidan con este criterio.","empty":"Parece que actualmente no tienes ninguna acci\xf3n r\xe1pida.","emptyLong":"No hay botones de acci\xf3n r\xe1pida configurados en estos controles de la aplicaci\xf3n. Una vez que los agregues o elijas controles con uno, aparecer\xe1n aqu\xed."},"reset":"Reiniciar","info":"M\xe1s informaci\xf3n","device":{"title":"Conexi\xf3n","titlePlural":"Conexiones","status":{"title":"Estado de la conexi\xf3n:","connected":{"application":"Aplicaci\xf3n conectada","connection":"Conectado","device":"Dispositivo conectado","game":"Juego conectado"},"disconnected":{"application":"Aplicaci\xf3n desconectada","connection":"Desconectado","device":"Dispositivo desconectado","game":"Juego desconectado"}},"running":"Correr","offline":"Desconectado","otherDevices":"Otras conexiones de salida","currentStatus":"Estado actual:","connectionStatus":"Estado de la conexi\xf3n:","profileStatus":"Controles de la aplicaci\xf3n actual:","name":{"title":"Nombre de la conexi\xf3n","question":"\xbfC\xf3mo quieres llamar a esta conexi\xf3n?","description":"Dale un nombre a tu conexi\xf3n para que puedas encontrarla f\xe1cilmente m\xe1s tarde.","placeholder":"nombre de la conexi\xf3n","edit":"Editar el nombre de la conexi\xf3n"},"updates":{"title":"Actualizaciones de conexi\xf3n","settings":"Configuraci\xf3n de actualizaci\xf3n de conexi\xf3n","description":"Verifique las actualizaciones del firmware de conexi\xf3n y cambie la configuraci\xf3n de actualizaci\xf3n autom\xe1tica","edit":"Editar la configuraci\xf3n de actualizaci\xf3n","check":{"title":"Buscar actualizaciones","processing":"\xa1Buscando actualizaciones! Puede tardar unos minutos y tu conexi\xf3n podr\xeda reiniciarse durante las actualizaciones.","description":"Pulsa para buscar actualizaciones para tu conexi\xf3n. Si hay una actualizaci\xf3n disponible y tu conexi\xf3n est\xe1 activa, empezar\xe1 a actualizarse. Las actualizaciones pueden tardar unos minutos."},"auto":{"title":"Actualizar autom\xe1ticamente","description":"Con esta configuraci\xf3n activada, tu conexi\xf3n se actualizar\xe1 autom\xe1ticamente al conectarte a la red el\xe9ctrica, a una red wifi y al tener una actualizaci\xf3n disponible. Si est\xe1 desactivada, debes pulsar el bot\xf3n de actualizaci\xf3n para obtener la \xfaltima versi\xf3n.","option":"\xbfUtilizar actualizaci\xf3n autom\xe1tica?"}},"delete":{"title":"Desvincular {{name}}","titleLong":"Desvincular de la cuenta","description":"Al desvincular Cephable, se desconecta de este ordenador o juego y se elimina de tu cuenta. Ya no podr\xe1s conectarte, enviar comandos ni actualizarlo. Esta acci\xf3n no se puede deshacer, pero puedes crear una nueva conexi\xf3n al mismo ordenador o juego si quieres volver a usarlo en el futuro.","confirm":"\xbfEst\xe1s seguro de que deseas desvincular esta conexi\xf3n?","confirmLong":"\xbfSeguro que desea cancelar y restablecer esta conexi\xf3n? Ya no podr\xe1 conectarse, enviar comandos ni actualizarla. Despu\xe9s de cancelar y restablecer esta conexi\xf3n, cualquier otra persona podr\xe1 configurarla desde cero.","confirmButton":"S\xed, elimine esta conexi\xf3n."},"manage":{"title":"Haga clic para ver y administrar los detalles de sus conexiones.","description":"","name":"Personalice el nombre de su conexi\xf3n para una gesti\xf3n m\xe1s sencilla."},"error":{"save":"Error al guardar la conexi\xf3n.","load":"Error al cargar la conexi\xf3n.","add":"Error al agregar conexi\xf3n.","delete":"Error al eliminar la conexi\xf3n.","updates":"Error al comprobar actualizaciones.","connection":"No se ha establecido la conexi\xf3n. Aseg\xfarate de que est\xe9 conectada antes de volver a intentarlo.","deleteLong":"No pudimos eliminar esta conexi\xf3n de tu cuenta. Si vuelves a iniciar sesi\xf3n, es posible que tengas que eliminarla manualmente en la configuraci\xf3n de conexi\xf3n."},"success":{"save":"Conexi\xf3n guardada.","add":"Conexi\xf3n agregada.","delete":"Conexi\xf3n eliminada."},"description":"Cephable admite m\xfaltiples dispositivos y conexiones. Puedes administrar la configuraci\xf3n o seleccionar cualquiera de ellas desde aqu\xed. Este ordenador siempre ser\xe1 tu conexi\xf3n principal. Puedes a\xf1adir m\xe1s conexiones posteriormente.","swap":{"titlePlural":"Conexiones de intercambio"},"control":{"button":"Control {{name}}","description":{"application":"Controla esta aplicaci\xf3n conectada con tu voz, acciones r\xe1pidas, movimientos de cabeza y m\xe1s. Por ejemplo, si dices \\"Guardar\\", se guardar\xe1 en la aplicaci\xf3n en ejecuci\xf3n.","connection":"Controla esta conexi\xf3n con tu voz, acciones r\xe1pidas, movimientos de cabeza y m\xe1s. Por ejemplo, si dices \\"Guardar\\", se guardar\xe1 la conexi\xf3n activa.","device":"Controla este dispositivo conectado con tu voz, acciones r\xe1pidas, movimientos de cabeza y m\xe1s. Por ejemplo, si dices \\"Abrir Spotify\\", se abrir\xe1 Spotify en el dispositivo en funcionamiento.","game":"Controla este juego conectado con tu voz, acciones r\xe1pidas, movimientos de cabeza y m\xe1s. Por ejemplo, si dices \\"\xa1Ya!\\", el jugador se mover\xe1 en un juego de carrera."},"generic":"Conexi\xf3n de control"},"titleShort":"Conectar","titleLong":"Conexiones y extensiones","viewAll":"Ver todas las conexiones","add":{"short":"Extender","title":"Agregar una nueva conexi\xf3n o extensi\xf3n","description":"Las conexiones y extensiones son maneras adicionales de mejorar tu experiencia con Cephable. Puedes agregar nuevas conexiones para conectarte a m\xe1s dispositivos, aplicaciones o juegos. Lleva tu experiencia con Cephable al siguiente nivel agregando conexiones y extensiones.","action":"Agregar una nueva conexi\xf3n","notAvailable":"Esta conexi\xf3n o extensi\xf3n no est\xe1 disponible p\xfablicamente actualmente. Esto suele ocurrir al trabajar con extensiones generadas por el usuario. Vuelva a consultarla m\xe1s tarde.","isNotPublic":"VISTA PREVIA: Esta extensi\xf3n se encuentra en versi\xf3n preliminar para desarrolladores y podr\xeda estar incompleta. Los desarrolladores deben completar todos los pasos antes del lanzamiento p\xfablico. Los usuarios pueden consultar la versi\xf3n completa m\xe1s adelante."},"new":"\xa1Tienes una nueva conexi\xf3n!","newLong":"\xa1Tienes una nueva conexi\xf3n! Para empezar a usarla, selecci\xf3nala en el men\xfa de abajo."},"explore":"Explorar","shortcuts":{"title":"Atajos globales","description":"Personalice los atajos de teclado para acceder r\xe1pidamente a los controles de Cephable desde cualquier lugar de su sistema.","info":"Estos atajos funcionan globalmente y se pueden usar incluso cuando Cephable no es la ventana activa.","shortcut":"Atajo","toggleMicrophone":"Activar o desactivar el micr\xf3fono","toggleDictation":"Activar o desactivar el modo de dictado","toggleVoiceControl":"Activar o desactivar el modo de control por voz","togglePanel":"Panel de alternancia","registrationFailed":"Algunos accesos directos globales no se registraron. Es posible que otra aplicaci\xf3n los est\xe9 usando.","record":{"title":"Acceso directo a grabaciones","start":"Haga clic para grabar","listening":"Presione la combinaci\xf3n de teclas deseada...","pressKeys":"Presione las teclas ahora"},"formatHint":"Seleccione al menos una tecla modificadora ({{modifierKey}}, {{modifierKey2}}, Shift) y otra tecla."},"gamepad":{"title":"Compatibilidad con gamepad","description":"Configurar la salida del gamepad y joystick para juegos de PC","driver":{"description":"Para admitir las salidas de los mandos de juego, Cephable necesita descargar e instalar un controlador externo llamado ViGEm. Este controlador habilita la funcionalidad del mando virtual de Xbox 360, que los juegos reconocen de forma nativa.","installed":"Controlador de juego instalado: \xa1Listo para usar las salidas del gamepad! Si el problema persiste, puedes intentar reinstalar el controlador.","notInstalled":"El controlador del controlador de juego no est\xe1 instalado","install":"Instalar el controlador del controlador de juego","reinstall":"Reinstalar el controlador del controlador de juego","installing":"Instalaci\xf3n del controlador de juego ViGEm...","installSuccess":"\xa1El controlador del mando ViGEm se instal\xf3 correctamente! Ya puedes usar las salidas del mando en tus controles.","installFailed":"No se pudo instalar el controlador de ViGEm. Int\xe9ntelo de nuevo o inst\xe1lelo manualmente desde el sitio web de ViGEm."},"platform":{"unsupported":"Plataforma no compatible con las funciones del gamepad","unsupportedDescription":"La funci\xf3n de salida del gamepad actualmente solo es compatible con sistemas Windows x64. La compatibilidad con Windows ARM64 a\xfan no est\xe1 disponible debido a limitaciones del SDK."},"usage":"Una vez instalado el controlador del controlador de juego, puedes usar los movimientos del joystick y las pulsaciones de los botones del gamepad en tus macros y comandos de voz para controlar los juegos."},"youtube":{"unavailable":{"title":"V\xeddeo no disponible","description":"Este v\xeddeo no est\xe1 disponible actualmente. Vuelve a comprobarlo m\xe1s tarde.","retry":"Rever"},"watch":{"title":"Ups.","description":"Parece que hubo un problema al cargar el video. Puedes verlo directamente en YouTube.","button":"Mira en YouTube"},"offline":{"title":"V\xeddeo no disponible","description":"Este video de YouTube requiere conexi\xf3n a internet para cargarse. Comprueba tu conexi\xf3n y vuelve a intentarlo."}},"metrics":{"download":{"success":"Se accedi\xf3 exitosamente al archivo de m\xe9tricas.","manualPath":"Archivo de m\xe9tricas disponible en: {{path}}","error":"Error al descargar el archivo de m\xe9tricas.","noFile":"No se encontr\xf3 ning\xfan archivo de m\xe9tricas."},"clear":{"success":"Archivo de m\xe9tricas borrado exitosamente.","error":"Error al borrar el archivo de m\xe9tricas.","noFile":"No se encontr\xf3 ning\xfan archivo de m\xe9tricas para borrar.","confirm":"\xbfSeguro que desea borrar todos los datos de m\xe9tricas? Esta acci\xf3n no se puede deshacer."}},"suggestedPrompts":{"title":"Indicaciones sugeridas","description":"Personalice las indicaciones sugeridas que aparecen en las tareas de IA para ayudarlo a comenzar r\xe1pidamente.","edit":"Editar indicaciones sugeridas","generate":"Generar texto","rewrite":"Reescribir texto","addGenerate":"Agregar un mensaje de generaci\xf3n","addRewrite":"Agregar una solicitud de reescritura","remove":"Eliminar mensaje","generatePlaceholder":"Introduzca un mensaje para generar texto...","rewritePlaceholder":"Introduzca un mensaje para reescribir el texto...","suggested":"Indicaciones sugeridas","suggestedFor":"Sugerido para {{profileName}}","seeAll":"Ver todas las indicaciones","showLess":"Mostrar menos","allPrompts":"Todas las indicaciones","customFor":"Avisos personalizados para {{profileName}}","defaultPrompts":"Indicaciones predeterminadas","defaultGenerate":["Un correo electr\xf3nico profesional presentando nuestro nuevo producto.","Una agenda de reuni\xf3n para la discusi\xf3n del equipo de la pr\xf3xima semana.","Esquema de propuesta de proyecto para una nueva iniciativa","Una plantilla de carta comercial formal","Una secci\xf3n de documentaci\xf3n t\xe9cnica","Introducci\xf3n al manual del usuario","Descripci\xf3n general del documento de capacitaci\xf3n","Un borrador de documento de pol\xedtica","Un correo electr\xf3nico de seguimiento despu\xe9s de una reuni\xf3n","Un mensaje de agradecimiento a un cliente","Un correo electr\xf3nico de actualizaci\xf3n del estado del proyecto","Una invitaci\xf3n a un evento de la empresa","Un correo electr\xf3nico recordatorio para las pr\xf3ximas fechas l\xedmite","Un correo electr\xf3nico de bienvenida para los nuevos miembros del equipo.","Un correo electr\xf3nico de disculpa por la interrupci\xf3n del servicio.","Introducci\xf3n a un bolet\xedn informativo","Una lista de ideas para campa\xf1as de marketing","Soluciones creativas para mejorar la productividad del equipo","Ideas para actividades de retiro de empresa","Conceptos para una nueva funci\xf3n de la aplicaci\xf3n m\xf3vil","Sugerencias para mejorar la experiencia del cliente","Ideas de innovaci\xf3n para el desarrollo de nuestros productos","Ideas de contenido para publicaciones en redes sociales","Temas de talleres para el desarrollo profesional","Una funci\xf3n que valida la entrada del usuario","Una consulta de base de datos para la gesti\xf3n de usuarios","C\xf3digo de manejo de errores para solicitudes de API","Una plantilla de archivo de configuraci\xf3n","Comentarios que explican un algoritmo complejo","Casos de prueba unitaria para una nueva caracter\xedstica","Documentaci\xf3n para puntos finales de API","Un script para la implementaci\xf3n automatizada"],"defaultRewrite":["Haz que este texto sea m\xe1s conciso y directo.","Ampliar este resumen con m\xe1s detalles","Reformatee esto como una lista numerada","Convertir esto en vi\xf1etas","Reestructura esto en p\xe1rrafos claros.","Haga que este texto sea m\xe1s f\xe1cil de escanear r\xe1pidamente","Organice esta informaci\xf3n jer\xe1rquicamente","Formatee esto como una gu\xeda paso a paso","Haz que este mensaje sea m\xe1s profesional y formal.","Reescribe esto para que suene m\xe1s informal y amigable.","Ajuste el tono para que sea m\xe1s alentador.","Haz que este sonido sea m\xe1s seguro y asertivo.","Suavizar el tono para ser m\xe1s diplom\xe1tico","A\xf1ade entusiasmo y energ\xeda a este texto.","Hazlo m\xe1s emp\xe1tico y comprensivo.","Reescribir con un tono m\xe1s colaborativo","Simplifique esto para una audiencia general.","Haga esta explicaci\xf3n m\xe1s t\xe9cnica y detallada.","Descomponga este concepto complejo en t\xe9rminos m\xe1s simples","A\xf1adir m\xe1s contexto e informaci\xf3n de fondo","Resuma esto en conclusiones clave","Desarrolle los puntos principales con ejemplos.","Hazlo m\xe1s accesible para principiantes.","Condense esto manteniendo la informaci\xf3n esencial.","Mejorar la claridad y la legibilidad","Hazlo m\xe1s atractivo e interesante.","Ajustar para una mejor gram\xe1tica y fluidez","Reescribir para enfatizar los beneficios"]},"accessibilityService":{"error":{"generic":"Error interno. Int\xe9ntelo de nuevo m\xe1s tarde.","elementNotFound":"No se encontr\xf3 ning\xfan resultado. Aseg\xfarese de que la b\xfasqueda exista y vuelva a intentarlo.","highlightOnConflict":"Se encontraron varios elementos. Refine su comando para especificar cu\xe1l desea seleccionar.","clickNotInitialized":"La funci\xf3n de b\xfasqueda por nombre no est\xe1 disponible por el momento. Si el problema persiste, p\xf3ngase en contacto con el servicio de asistencia.","platformUnsupported":"Las funciones de Voice Mouse no son compatibles con esta plataforma."},"clickWait":"Inicializando. Por favor, espere un momento y vuelva a intentarlo."},"deprecated":"Obsoleto","view":"Vista","aiWorkflows":{"settings":{"title":"Configuraci\xf3n de flujos de trabajo de IA","description":"Configure los modelos y dispositivos de IA utilizados para los flujos de trabajo de IA. Los flujos de trabajo de IA le permiten automatizar tareas de escritorio y navegador mediante IA en el dispositivo.","configType":{"title":"Tipo de configuraci\xf3n del modelo","description":"Seleccione el tipo de configuraci\xf3n de modelo que se usar\xe1 para los flujos de trabajo de IA. Cada configuraci\xf3n est\xe1 optimizada para distintos modelos.","label":"Tipo de configuraci\xf3n"},"reasoningModel":{"title":"Modelo de razonamiento","description":"Seleccione el modelo de IA que usar\xe1 para las tareas de razonamiento y planificaci\xf3n. El modelo de razonamiento analiza sus solicitudes y crea planes de acci\xf3n.","label":"Modelo de razonamiento"},"reasoningDevice":{"label":"Dispositivo de razonamiento"},"generationModel":{"title":"Modelo de generaci\xf3n","description":"Seleccione el modelo de IA que se usar\xe1 para las tareas de generaci\xf3n de texto. El modelo de generaci\xf3n crea contenido de texto cuando lo requieren los flujos de trabajo.","label":"Modelo de generaci\xf3n"},"generationDevice":{"label":"Dispositivo de generaci\xf3n"},"noModelsFound":"No se encontraron modelos","terminate":{"title":"Recursos de flujo de trabajo claros","description":"Haga clic para finalizar el flujo de trabajo y liberar recursos. Esto detendr\xe1 cualquier flujo de trabajo en ejecuci\xf3n y liberar\xe1 la memoria utilizada por los modelos de IA.","button":"Terminar trabajador de flujo de trabajo","success":"Trabajador de flujo de trabajo finalizado.","confirm":{"title":"Terminar trabajador de flujo de trabajo","description":"\xbfSeguro que desea finalizar el flujo de trabajo? Esto detendr\xe1 cualquier flujo de trabajo en ejecuci\xf3n y liberar\xe1 recursos.","confirm":"S\xed, terminar"}},"autoWarm":{"title":"Flujos de trabajo de IA de inicio autom\xe1tico","description":"Inicialice autom\xe1ticamente los modelos de flujo de trabajo de IA al iniciar la aplicaci\xf3n. Los modelos se precargar\xe1n para que los flujos de trabajo puedan iniciarse de inmediato.","option":"Iniciar autom\xe1ticamente modelos de flujo de trabajo de IA al iniciar la aplicaci\xf3n"},"prompt":{"title":"Informaci\xf3n adicional para flujos de trabajo de IA","description":"Introduzca detalles adicionales para usar con la IA de Cephable al ejecutar flujos de trabajo. Utilice este campo para especificar sus preferencias de tono, comportamiento o cualquier otro detalle.","field":"Aviso adicional","placeholder":"Por ejemplo, siempre confirme antes de enviar correos electr\xf3nicos. Prefiera respuestas concisas. Use un lenguaje formal en los documentos."},"disableButtonNames":{"edit":"Interacciones de botones de bloqueo","input":{"label":"Nombre del bot\xf3n","question":"\xbfQu\xe9 botones desea bloquear? Puede introducir el nombre completo o parcial de los botones.","remove":"Eliminar nombre del bot\xf3n"},"button":"Botones de bloque","description":"Controla con qu\xe9 botones pueden interactuar los flujos de trabajo de IA. Por defecto, Cephable puede hacer clic en cualquier bot\xf3n de la pantalla. Usa esta configuraci\xf3n para evitar acciones accidentales (por ejemplo, \\"comprar\\", \\"eliminar\\")."}}},"control":"Control","automate":"Automatizar","deviceCommandThrottled":{"macroLength":"Esta conexi\xf3n no permite macros largas. Su macro se ha acortado autom\xe1ticamente.","commandCount":"Esta conexi\xf3n limita la velocidad de env\xedo de comandos. Espere y vuelva a intentarlo pronto."},"tos":{"title":"Actualizaci\xf3n de los T\xe9rminos de Servicio","description":"Nuestros T\xe9rminos de Servicio han sido actualizados. Lea y acepte los t\xe9rminos actualizados para continuar usando Cephable.","effectiveDate":"Fecha de entrada en vigor: {{date}}","accept":"Aceptar los T\xe9rminos de Servicio","loadError":"No se pueden cargar los T\xe9rminos de Servicio. Vuelva a intentarlo.","viewInBrowser":"Ver los T\xe9rminos de Servicio en el navegador","acceptCheckbox":"He le\xeddo y acepto los T\xe9rminos de Servicio"}}');


var $f3b28415484efa10$exports = {};
$f3b28415484efa10$exports = JSON.parse('{"404":"\xa1Oh, no! \xa1Hemos buscado por el mar y no encontramos tu p\xe1gina!"}');


var $b575a9a6bac1cad6$exports = {};
$b575a9a6bac1cad6$exports = JSON.parse('{"smartTasks":{"tourLabel":"Tareas inteligentes","learn":"Aprenda a generar, reescribir y traducir texto con Cephable.","generate":{"openTool":{"title":"Abrir la herramienta Generar texto","description":"En el panel de Cephable, haga clic en la zanahoria junto a Tareas inteligentes y seleccione Generar texto."},"enterPrompt":{"title":"Ingresar mensaje","description":"En el cuadro de solicitud, escribe: Crea un juego de palabras de una sola oraci\xf3n que sea cre\xedble."},"clickGenerate":{"title":"Haga clic en Generar","description":"Haz clic en el bot\xf3n Generar. Observa c\xf3mo aparece el texto en tiempo real."},"focusApp":{"title":"Conc\xe9ntrese en la aplicaci\xf3n","description":"Aseg\xfarate de estar enfocado en la aplicaci\xf3n donde quieres que aparezca el texto generado. Podr\xe1s generar texto sin problemas en esa ubicaci\xf3n al hacer clic en \\"Generar\\"."}},"rewrite":{"welcome":{"title":"Bienvenido a Rewrite","description":"Reformule el contenido r\xe1pidamente con texto resaltado o pegado."},"highlightToggle":{"title":"Usar texto resaltado","description":"Aseg\xfarese de que \u201CUsar texto resaltado\u201D est\xe9 seleccionado (predeterminado)."},"highlightText":{"title":"Resaltar texto para reescribir","description":"Destacado: Un pulpo puede controlar cada brazo independientemente."},"enterInstructions":{"title":"Introduzca instrucciones de reescritura","description":"Tipo: En estilo ingl\xe9s antiguo."},"clickGenerate":{"title":"Haga clic en Generar","description":"El texto resaltado ser\xe1 reescrito en base a tu entrada."},"pasteMode":{"title":"Usar Pegar texto","description":"Pegue el original y reescriba la instrucci\xf3n. Haga clic en \\"Generar\\". Haga clic en \\"Borrar\\" para restablecer."},"openTool":{"title":"Abrir la herramienta Reescribir texto","description":"En el panel de Cephable, haga clic en la zanahoria junto a Tareas inteligentes y seleccione Reescribir texto."},"focusApp":{"title":"Conc\xe9ntrese en la aplicaci\xf3n","description":"Aseg\xfarate de estar enfocado en la aplicaci\xf3n donde quieres que aparezca el texto reescrito. Podr\xe1s generar texto sin problemas en esa ubicaci\xf3n al hacer clic en \\"Generar\\"."}},"translate":{"welcome":{"title":"Bienvenido a Translate","description":"Traducir el texto resaltado o pegado a otro idioma."},"highlightToggle":{"title":"Usar texto resaltado","description":"Aseg\xfarese de que la opci\xf3n \u201CUsar texto resaltado\u201D est\xe9 seleccionada."},"highlightText":{"title":"Resaltar texto para traducir","description":"Destacado: Un pulpo puede controlar cada brazo independientemente."},"enterLanguage":{"title":"Introduzca el idioma de destino","description":"Tipo: Portugu\xe9s."},"clickGenerate":{"title":"Haga clic en Generar","description":"La traducci\xf3n se escribir\xe1 en su aplicaci\xf3n cuando usted coloque el cursor."},"pasteMode":{"title":"Usar Pegar texto","description":"Pegue el texto y el idioma. Haga clic en Generar. Haga clic en Borrar para restablecer."},"openTool":{"title":"Abrir la herramienta Traducir texto","description":"En el panel de Cephable, haga clic en la zanahoria junto a Tareas inteligentes y seleccione Traducir texto."}},"rowDescription":"Las tareas inteligentes son las diferentes tareas que la IA de Cephable puede realizar por ti. Estas tareas, impulsadas por la IA del dispositivo, permiten crear texto, resumir, reescribir, traducir y mucho m\xe1s."},"overview":{"title":"Descripci\xf3n general","description":"Cephable es tu IA personal: dise\xf1ada para acciones r\xe1pidas, comandos de voz, generaci\xf3n de contenido y automatizaci\xf3n inteligente en todas tus herramientas. Controles preconfigurados. Sin procesamiento en la nube. Solo productividad que se mueve contigo."},"customControls":{"tourLabel":"Controles globales y de dispositivos siempre disponibles","rowDescription":"Los controles globales y del dispositivo siempre est\xe1n disponibles si el micr\xf3fono est\xe1 activado, independientemente de la aplicaci\xf3n que uses. Puedes usar estos controles para interactuar con tu dispositivo sin tener que crear nuevos controles para la aplicaci\xf3n. Incluyen comandos \xfatiles como intercambiar controles o aplicaciones, generar texto, pausar el micr\xf3fono y mucho m\xe1s."},"profile":{"tourLabel":"Controles de la aplicaci\xf3n","learn":"Aprenda a configurar los controles y preferencias de su aplicaci\xf3n en Cephable.","rowDescription":"Los controles de la aplicaci\xf3n son conjuntos de controles configurados que puedes usar para hacer cosas. \xbfQuieres decir \\"Siguiente diapositiva\\" para ir a la siguiente diapositiva de tu presentaci\xf3n? \xbfO usar el movimiento de la cabeza para mover el cursor y los controles de voz para editar accesos directos? Puedes hacerlo con los controles de la aplicaci\xf3n. La fila de controles muestra todos los controles disponibles para tu aplicaci\xf3n actual.","check":{"title":"Verifique sus controles disponibles.","description":"Los controles de la aplicaci\xf3n est\xe1n disponibles para cada aplicaci\xf3n que uses. Aqu\xed puedes ver los controles disponibles para la aplicaci\xf3n que est\xe1s usando. Prueba otro comando para ver c\xf3mo funciona. PERO, aseg\xfarate de estar enfocado en la aplicaci\xf3n que quieres controlar."}},"dictation":{"tourLabel":"Dictado","learn":"Aprenda a utilizar el modo de dictado para convertir su voz en texto con manos libres.","welcome":{"title":"Dictado","description":"El dictado te permite hablar con naturalidad y escribir tus palabras mientras hablas. Es como tener un asistente personal que escribe todo lo que dices."},"microphone":{"title":"Enciende tu micr\xf3fono","description":"Primero, activa el micr\xf3fono. Haz clic en el interruptor de micr\xf3fono en el panel de Cephable."},"activate":{"title":"Iniciar el modo de dictado","description":"La voz se inicia en modo comando. Para iniciar el dictado, diga \\"Iniciar dictado\\" o haga clic en el bot\xf3n Dictado. Activemos el modo de dictado."},"focus":{"title":"Centrarse en un campo de texto o documento","description":"El dictado funciona mejor cuando te centras en un campo de texto o documento. Haz clic en el campo de texto o documento donde quieras dictar."},"speaking":{"title":"Empieza a hablar","description":"Ahora puedes empezar a hablar. Todo lo que digas se escribir\xe1 en el campo de texto o documento que hayas seleccionado. Intenta decir algo como \\"Hola, esta es una prueba del modo de dictado\\"."},"pauseResume":{"title":"Pausa del dictado","description":"\xbfNecesitas un descanso sin desactivar el dictado? Simplemente di \\"Pausar dictado\\". Puedes reanudarlo en cualquier momento con \\"Iniciar dictado\\". Puedes personalizarlo a\xfan m\xe1s con los controles globales y del dispositivo siempre activos."},"stop":{"title":"Detener el dictado","description":"\xbfNecesitas volver a los controles de tu aplicaci\xf3n? Simplemente di \\"Detener dictado\\". Esto detendr\xe1 el modo de dictado y te permitir\xe1 volver al modo comando. Puedes reanudarlo en cualquier momento con \\"Iniciar dictado\\"."},"complete":{"description":"\xa1Listo! Ahora puedes dictar, pausar, reanudar y alternar entre los modos de dictado y comando. El dictado es una herramienta potente para escribir sin usar las manos. \xdasalo para escribir correos electr\xf3nicos, documentos o cualquier otra cosa que necesites escribir en voz alta."}},"camera":{"tourLabel":"Controles de la c\xe1mara","rowDescription":"Los controles de la c\xe1mara te permiten usar tu cara y cuerpo para controlar tu dispositivo. Puedes usar diferentes expresiones faciales y movimientos de cabeza para controlarlo. Con el micr\xf3fono activado, puedes usar comandos de voz para iniciar y detener la c\xe1mara, y cambiar de c\xe1mara.","learn":"Aprenda a utilizar los controles de la c\xe1mara para navegar e interactuar con su dispositivo con manos libres.","welcome":{"title":"Controles de la c\xe1mara","description":"Los controles de la c\xe1mara te permiten usar tu cara y cuerpo para controlar tu dispositivo. Puedes usar diferentes expresiones faciales, movimientos de cabeza y comandos de voz para navegar e interactuar con tu dispositivo sin usar las manos."},"start":{"title":"Iniciar controles de la c\xe1mara","description":"Para comenzar a usar los controles de la c\xe1mara si est\xe1 usando la voz, diga \\"Iniciar controles de la c\xe1mara\\" o haga clic en el bot\xf3n Controles de la c\xe1mara."}},"microphone":{"tourLabel":"Controles de voz","learn":"Aprenda c\xf3mo puede usar su voz para controlar cualquier aplicaci\xf3n y usar el dictado para escribir lo que dice.","description":"Los controles de voz de Cephable te permiten usar tu voz para controlar tu dispositivo. \xbfQuieres guardar un documento? Solo di \\"guardar\\". \xbfQuieres pausar la m\xfasica? Solo di \\"pausar\\". La voz tambi\xe9n te permite usar el dictado para escribir lo que dices.","rowDescription":"Cuando el micr\xf3fono est\xe9 apagado, no escucharemos tus comandos de voz, pero si lo enciendes, podr\xe1s usar comandos globales para pausar, iniciar y m\xe1s. Vamos a encenderlo.","start":{"title":"Iniciar controles de voz","description":"Para empezar a usar los controles de voz, haz clic en el interruptor del micr\xf3fono en el panel de Cephable. Esto activar\xe1 el micr\xf3fono y comenzar\xe1 a escuchar comandos."},"tryOpen":{"title":"Prueba a decir \xabAbrir Spotify\xbb o \xabAbrir Word\xbb.","description":"\\"Abrir\\" es un comando global que abrir\xe1 la aplicaci\xf3n que especifiques y le asignar\xe1 el foco. Si tienes habilitado el cambio autom\xe1tico de controles, tambi\xe9n cambiar\xe1 a los controles de la aplicaci\xf3n que mejor se adapten a la que est\xe9s usando."},"finishedCommands":{"title":"\xa1Excelente! Has aprendido lo b\xe1sico de los controles de voz.","description":"Siempre puedes volver a visitar el recorrido desde la p\xe1gina de soporte. El siguiente paso es aprender sobre Dictado. Puedes comenzar el recorrido desde la p\xe1gina de soporte."}},"publicProfiles":{"tourLabel":"Personalizar los controles de la aplicaci\xf3n"},"tour":{"title":"Bienvenido a Cephable","description":"Cephable es una potente herramienta que te permite controlar tu ordenador con la voz, la c\xe1mara y otras entradas. Este tutorial te guiar\xe1 por las funciones clave y c\xf3mo usarlas eficazmente.","startTour":"Iniciar Tour","finishTour":"Finalizar el recorrido","statusDialog":"Por favor consulte el panel para obtener m\xe1s informaci\xf3n.","step":"Paso {{paso}} de {{total}}","next":"Pr\xf3ximo","previous":"Anterior","endTour":"Fin del recorrido","nextTourLabel":"Siguiente: {{nextStepTitle}}","skipTour":"Saltar el recorrido","steps":{"welcome":{"title":"Bienvenido a Cephable","description":"Este recorrido te guiar\xe1 por las principales funciones de Cephable. \xa1Comencemos!"},"inputs":{"title":"Descripci\xf3n general de las entradas","description":"Cephable admite varios m\xe9todos de entrada, como comandos de voz, controles de c\xe1mara y m\xe1s. Puedes personalizarlos en la configuraci\xf3n."},"appControls":{"title":"Controles de la aplicaci\xf3n","description":"Crea controles de app para asignar tus entradas a acciones espec\xedficas en tus aplicaciones. Esto te permite controlar apps con gestos, comandos de voz y m\xe1s."},"settings":{"title":"Ajustes","description":"Accede a la configuraci\xf3n para configurar tus entradas, controles de la app y otras preferencias. Tambi\xe9n puedes administrar tu cuenta y la configuraci\xf3n de idioma aqu\xed."},"intelligentTasks":{"title":"Tareas inteligentes","description":"Utilice tareas inteligentes para generar texto, resumir contenido, reescribir texto, traducir idiomas y m\xe1s utilizando funciones impulsadas por IA."},"cameraControls":{"title":"Controles de la c\xe1mara","description":"Habilite los controles de la c\xe1mara para utilizar expresiones faciales y movimientos de la cabeza como m\xe9todos de entrada para controlar su computadora."},"voiceControls":{"title":"Controles de voz","description":"Usa comandos de voz para controlar tu computadora sin usar las manos. Puedes dictar texto, dar comandos e interactuar con aplicaciones usando la voz."}}},"onboarding":{"demoPlaceholder":"Este es el texto de demostraci\xf3n del marcador de posici\xf3n. Con las indicaciones anteriores, puede controlar el estilo de este texto.","exit":"Configuraci\xf3n de salida","overview":"Descripci\xf3n general","learn":"Conozca las caracter\xedsticas de Cephable y c\xf3mo usarlas.","start":"Parece que apenas est\xe1s empezando. Aqu\xed tienes algunas \xe1reas que te ayudar\xe1n en el proceso.","startTour":"Empezar","dashboard":{"title":"Panel de Cephable","description":"El Panel de Control de Cephable es tu centro de control para administrar tu dispositivo, los controles de las apps y la configuraci\xf3n. Desde aqu\xed, puedes personalizar tu experiencia, ver los comandos activos y acceder a todas las funciones de Cephable."},"step1":{"title":"Bienvenido a Cephable","description":"Cephable es tu IA personal: dise\xf1ada para acciones r\xe1pidas, comandos de voz, generaci\xf3n de contenido y automatizaci\xf3n inteligente en todas tus herramientas. Controles preconfigurados. Sin procesamiento en la nube. Solo productividad que se mueve contigo.","inputs":"\xbfQu\xe9 son las entradas?","inputDescription":"Los controles de entrada son los m\xe9todos para operar su dispositivo, ampliando las capacidades de su computadora m\xe1s all\xe1 del rat\xf3n y el teclado tradicionales. Estos m\xe9todos incluyen comandos de voz, movimientos de cabeza, expresiones faciales y perif\xe9ricos adicionales.","profiles":"\xbfQu\xe9 son los controles de aplicaciones?","profileDescription":"Los controles de la aplicaci\xf3n te permiten conectarte y comunicarte con tu computadora de maneras \xfanicas al combinar controles de entrada y salida. Con los controles de la aplicaci\xf3n, puedes indicarle a Cephable que realice tareas como guardar un archivo inclinando la cabeza o hacer clic en \\"Enviar\\" en un correo electr\xf3nico con una sonrisa.","action":"Explorar los controles de entrada","secondaryAction":"Saltar a los controles de la aplicaci\xf3n","secondaryActionDescription":"\xbfYa conoces los controles de entrada?"},"finish":{"title":"Configuraci\xf3n completada","description":"\xa1Has usado correctamente tus primeros controles de la app de Cephable! Ahora puedes usar estos y m\xe1s en tu dispositivo. Est\xe1n disponibles en tu Panel de Control de Cephable, donde puedes seguir personalizando la configuraci\xf3n de los controles de la app seg\xfan sea necesario.","continueToApp":"Continuar al panel de Cephable","keepExploring":"Sigue explorando"},"useCaseSlider":{"context":"Me gustar\xeda usar","control":"Para controlar"}},"support":{"tourLabel":"\xbfListo para aprender m\xe1s?","description":"Puede visitar nuestro centro de soporte para obtener m\xe1s informaci\xf3n sobre c\xf3mo usar Cephable, incluidos m\xe1s recorridos, gu\xedas paso a paso, tutoriales y videos.","cta":"Explorar otros tours"},"featureFlag":{"title":"Es hora de actualizar","description":"La funci\xf3n que intentas usar requiere una licencia diferente. Actualiza para desbloquear esta funci\xf3n y m\xe1s."},"replyToSocialMedia":{"tourLabel":"Respuestas m\xe1s r\xe1pidas en redes sociales con dictado","learn":"Aprenda a usar el dictado para responder publicaciones en las redes sociales con manos libres.","navigateTo":{"title":"Navegar a una publicaci\xf3n en redes sociales","description":"Abre tu navegador web y accede a una red social como LinkedIn o Facebook. Busca una publicaci\xf3n a la que quieras responder."},"speaking":{"title":"Empieza a hablar","description":"Ahora puedes empezar a hablar. Todo lo que digas se escribir\xe1 en el campo de texto o documento que hayas seleccionado. Intenta decir algo como \\"\xa1Felicidades! \xa1Me alegro mucho por ti!\\". Aseg\xfarate de que el cursor est\xe9 seleccionado en un campo de texto o cuadro de comentarios."},"complete":{"description":"\xa1Listo! Ahora puedes usar dictar, pausar, reanudar y alternar entre dictado y comandos para responder a publicaciones en redes sociales sin usar las manos. Dictado es una herramienta potente para escribir sin usar las manos. \xdasala para escribir correos electr\xf3nicos, documentos o cualquier otra cosa que necesites escribir en voz alta."}},"hotkeys":{"tourLabel":"Botones de acci\xf3n r\xe1pida","learn":"Aprenda a configurar botones de acci\xf3n r\xe1pida para asignar m\xfaltiples acciones a un solo bot\xf3n.","rowDescription":"Los botones de acci\xf3n r\xe1pida te permiten realizar varias acciones con un solo comando. Por ejemplo, puedes crear un bot\xf3n que abra tu app de m\xfasica favorita y comience a reproducir una lista de reproducci\xf3n espec\xedfica.","check":{"title":"Consulta tus acciones r\xe1pidas disponibles.","description":"Hay botones de acci\xf3n r\xe1pida disponibles para cada aplicaci\xf3n que uses. Aqu\xed puedes ver los botones disponibles para la aplicaci\xf3n que est\xe1s usando. Prueba otro comando para ver c\xf3mo funciona. PERO, aseg\xfarate de estar enfocado en la aplicaci\xf3n que quieres controlar."}},"controllingBackgroundMusic":{"tourLabel":"Gestiona la m\xfasica de fondo sin interrumpir tu flujo","learn":"Aprenda a utilizar controles de voz y acciones r\xe1pidas para controlar su m\xfasica con manos libres, mientras se concentra en su tarea actual.","tryOpen":{"title":"Prueba a decir \xabAbrir Spotify\xbb o \xabAbrir Apple Music\xbb"},"play":{"title":"Prueba a decir \\"Reproducir\\" para empezar a reproducir m\xfasica.","description":"Aseg\xfarate de que tu micr\xf3fono est\xe9 activado y di \\"Reproducir\\". Esto iniciar\xe1 la reproducci\xf3n de m\xfasica en la app de m\xfasica que hayas elegido. Esto tambi\xe9n funciona con cualquier otra app multimedia."},"newPlaylist":{"title":"Crear una nueva lista de reproducci\xf3n","description":"Aseg\xfarate de que tu micr\xf3fono est\xe9 activado y di \\"Nueva lista de reproducci\xf3n\\". Esto iniciar\xe1 el proceso de creaci\xf3n de una nueva lista de reproducci\xf3n en la app de m\xfasica que hayas elegido."},"finishedCommands":{"title":"\xa1Excelente trabajo! Has aprendido a controlar tu m\xfasica con las manos libres.","description":"Ya sabes c\xf3mo usar comandos de voz y acciones r\xe1pidas para reproducir, pausar, saltar pistas y ajustar el volumen en tus apps de m\xfasica favoritas. Explora m\xe1s comandos o personaliza tus propias acciones r\xe1pidas para un control de m\xfasica a\xfan m\xe1s fluido."}},"editingVideos":{"tourLabel":"Conc\xe9ntrese en la historia, no en los tediosos clics de la edici\xf3n de video","learn":"Aprenda a usar controles de voz y acciones r\xe1pidas para editar videos m\xe1s r\xe1pido y eliminar la carga cognitiva de recordar qu\xe9 botones hacer clic mientras edita.","tryOpen":{"title":"Prueba a decir \xabAbrir iMovie\xbb o \xabAbrir DaVinci Resolve\xbb"},"play":{"title":"Prueba a decir \\"Reproducir\\" para comenzar a reproducir tu v\xeddeo.","description":"Aseg\xfarate de que tu micr\xf3fono est\xe9 activado y di \\"Reproducir\\". Esto iniciar\xe1 la reproducci\xf3n del video en la aplicaci\xf3n de edici\xf3n de video que hayas elegido."},"stop":{"title":"Detener la reproducci\xf3n del v\xeddeo","description":"Aseg\xfarate de que tu micr\xf3fono est\xe9 activado y di \\"Detener\\". Esto detendr\xe1 la reproducci\xf3n del video en la aplicaci\xf3n de edici\xf3n de video que hayas elegido."},"finishedCommands":{"title":"\xa1Excelente trabajo! Has aprendido a controlar la edici\xf3n de video sin usar las manos.","description":"Ya sabes c\xf3mo usar comandos de voz y acciones r\xe1pidas para reproducir, pausar, saltar pistas y ajustar el volumen en tus apps de edici\xf3n de video favoritas. Explora m\xe1s comandos o personaliza tus propias acciones r\xe1pidas para un control de video a\xfan m\xe1s fluido."}},"vibeCoding":{"tourLabel":"Idear, prototipar e iterar m\xe1s r\xe1pido con Dictado","learn":"Aprenda a utilizar el dictado y la generaci\xf3n de texto impulsada por IA para vibrar el c\xf3digo, crear prototipos e iterar ideas.","navigateTo":{"title":"Navegar a un editor de c\xf3digo Vibe","description":"Abra su navegador web y acceda al editor de c\xf3digo de Vibe. Algunos ejemplos son Vercel V0, GitHub Copilot en VS Code, Base 44 y Lovable."},"focus":{"title":"Haga clic en Nuevo chat o en Enfocar un cuadro de texto","description":"El dictado funciona mejor cuando te concentras en un campo de texto o documento. Haz clic en el cuadro de comentarios o en el hilo de respuestas donde quieras dictar. Luego, empieza a hablar."},"speaking":{"title":"Empieza a hablar","description":"Ahora puedes empezar a hablar. Todo lo que digas se escribir\xe1 en el campo de texto o documento que hayas seleccionado. Intenta indicar tus requisitos t\xe9cnicos y la funci\xf3n del c\xf3digo. Aseg\xfarate de que el cursor est\xe9 seleccionado en un campo de texto o cuadro de comentarios."},"rewriteIntro":{"title":"Reescribir c\xf3digo con instrucciones","description":"Tambi\xe9n puedes usar Tareas Inteligentes como Reescribir para modificar el c\xf3digo existente. Esta tarea se basa en la IA del dispositivo, lo que significa que funciona sin conexi\xf3n a internet y se ejecuta desde tu dispositivo."},"highlightText":{"title":"Resaltar texto para reescribir","description":"Resalte el c\xf3digo que desea reescribir."},"enterInstructions":{"title":"Introduzca instrucciones de reescritura","description":"Escriba las instrucciones de reescritura de c\xf3digo. Especifique el lenguaje de programaci\xf3n, el estilo o cualquier cambio espec\xedfico que desee."},"complete":{"description":"\xa1Listo! Ahora puedes dictar, pausar, reanudar e iterar en el c\xf3digo. Contin\xfaa explorando m\xe1s casos de uso con Dictado y Tareas Inteligentes, u otras funciones para optimizar tu flujo de trabajo."}},"documentCode":{"tourLabel":"Documentaci\xf3n de c\xf3digo r\xe1pida y segura con generaci\xf3n de texto de IA en el dispositivo","learn":"Aprenda a utilizar la reescritura impulsada por IA para documentar el c\xf3digo mientras permanece en la misma aplicaci\xf3n y mantiene sus datos seguros.","rewriteIntro":{"title":"Escribir documentaci\xf3n de c\xf3digo","description":"Puedes usar Cephable Intelligent Rewrite para escribir documentaci\xf3n de c\xf3digo en un documento o aplicaci\xf3n independiente. Rewrite forma parte de las tareas de IA en el dispositivo, incluyendo la generaci\xf3n y traducci\xf3n sin conexi\xf3n."},"focusApp":{"title":"Conc\xe9ntrese en su c\xf3digo","description":"Abra su IDE y conc\xe9ntrese en el c\xf3digo que desea documentar."},"newFile":{"title":"Crear un archivo de documentaci\xf3n","description":"Crea un nuevo archivo en tu IDE o abre una aplicaci\xf3n separada donde quieras que aparezca la documentaci\xf3n."},"highlightText":{"title":"C\xf3digo destacado","description":"Resalte y copie el c\xf3digo que desea documentar."},"pasteMode":{"title":"Haga clic en la pesta\xf1a Pegar texto","description":"Utilice el modo pegar para pegar el c\xf3digo original y escribir la documentaci\xf3n en un nuevo archivo."},"pasteInput":{"title":"Pegar c\xf3digo en el documento","description":"Pegue el c\xf3digo que desea documentar en el cuadro de entrada."},"enterInstructions":{"title":"Introduzca instrucciones de formato, estilo y contenido","description":"Escribe las instrucciones de la documentaci\xf3n de codificaci\xf3n. Especifica el tipo de archivo (por ejemplo, Markdown), el estilo o cualquier contenido espec\xedfico que desees."},"complete":{"description":"Aprendi\xf3 a usar las Tareas Inteligentes para documentar c\xf3digo de forma r\xe1pida y segura. Contin\xfae explorando m\xe1s casos de uso con Rewrite u otras funciones para optimizar su flujo de trabajo."}},"generateCode":{"tourLabel":"Generaci\xf3n de c\xf3digo r\xe1pida y segura con generaci\xf3n de texto con IA en el dispositivo","learn":"Aprenda a utilizar la generaci\xf3n impulsada por IA para crear fragmentos de c\xf3digo mientras se mueve entre aplicaciones y mantiene sus datos seguros.","rewriteIntro":{"title":"Escribir fragmentos de c\xf3digo","description":"Puedes usar Cephable Intelligent Rewrite para escribir fragmentos de c\xf3digo en tu IDE mientras obtienes los requisitos de otra aplicaci\xf3n. Rewrite forma parte de las tareas de IA en el dispositivo, incluyendo la generaci\xf3n y traducci\xf3n sin conexi\xf3n."},"focusApp":{"title":"Conc\xe9ntrese en el contenido de su ticket","description":"Abra su ticket que especifica los requisitos y conc\xe9ntrese en el contenido para el que desea generar c\xf3digo."},"newFile":{"title":"Crear un archivo de fragmento de c\xf3digo","description":"Crea un nuevo archivo en tu IDE."},"highlightText":{"title":"Destacar el contenido del ticket","description":"Resalte y copie el contenido para el cual desea generar c\xf3digo."},"pasteMode":{"title":"Haga clic en la pesta\xf1a Pegar texto","description":"Utilice el modo pegar para pegar los requisitos del ticket original y escribir fragmentos de c\xf3digo para ellos."},"pasteInput":{"title":"Pegar requisitos para generar c\xf3digo","description":"Pegue los requisitos que desea utilizar para la generaci\xf3n de c\xf3digo en el cuadro de entrada."},"enterInstructions":{"title":"Introducir instrucciones de lenguaje y estilo de programaci\xf3n","description":"Escriba su lenguaje de programaci\xf3n y las instrucciones de estilo. Especifique el lenguaje de programaci\xf3n (por ejemplo, C#), el estilo o cualquier instrucci\xf3n de codificaci\xf3n espec\xedfica que tenga."},"translateIntro":{"title":"Traducir fragmentos de c\xf3digo","description":"Tambi\xe9n puedes usar Cephable Intelligent Translate para convertir fragmentos de c\xf3digo de un lenguaje de programaci\xf3n a otro directamente en tu IDE. Translate forma parte de las tareas de IA en el dispositivo, incluyendo la generaci\xf3n y reescritura sin conexi\xf3n."},"copyGeneratedCode":{"title":"Copiar el c\xf3digo generado","description":"Despu\xe9s de generar el c\xf3digo utilizando los pasos anteriores, resalte y copie el fragmento de c\xf3digo generado."},"translatePasteMode":{"title":"Haga clic en la pesta\xf1a Pegar texto","description":"Utilice el modo pegar para pegar el c\xf3digo original y traducirlo a otro lenguaje de programaci\xf3n."},"enterProgrammingLanguage":{"title":"Introduzca el lenguaje de programaci\xf3n de destino","description":"Escriba el lenguaje de programaci\xf3n al que desea traducir el c\xf3digo (por ejemplo, Python)."},"pasteCode":{"title":"Pegue el c\xf3digo generado en su IDE","description":"Vaya a su IDE y pegue el fragmento de c\xf3digo copiado en el nuevo archivo que cre\xf3 anteriormente."},"complete":{"description":"Aprendi\xf3 a usar Tareas Inteligentes para generar y traducir c\xf3digo de forma r\xe1pida y segura. Contin\xfae explorando m\xe1s casos de uso con Generar y Traducir, u otras funciones, para optimizar su flujo de trabajo."}},"requirementDocsFromMeeting":{"tourLabel":"De notas a documentos de requisitos del producto en minutos","learn":"Aprenda a utilizar tareas inteligentes de IA para crear documentos estructurados de requisitos de productos a partir de notas de reuniones mientras mantiene sus datos seguros.","rewriteIntro":{"title":"Crear documentos de requisitos de producto","description":"Puede usar Cephable Intelligent Rewrite para crear documentos estructurados de requisitos de producto a partir de notas de reuniones. Rewrite forma parte de las tareas de IA en el dispositivo, que incluyen la generaci\xf3n y traducci\xf3n sin conexi\xf3n."},"focusNotes":{"title":"Abra sus notas de reuni\xf3n","description":"Abra sus notas de reuni\xf3n, transcripciones u otro contenido de texto relacionado con la reuni\xf3n."},"highlight":{"title":"Resaltar notas de la reuni\xf3n","description":"Resalte las notas de la reuni\xf3n que desea utilizar para crear un documento de requisitos del producto."},"enterInstructions":{"title":"Introducir instrucciones sobre la estructura y el contenido del documento","description":"Escriba las instrucciones del documento de requisitos del producto. Especifique la estructura, el estilo o cualquier contenido espec\xedfico que desee."},"complete":{"description":"Aprendi\xf3 a usar Tareas Inteligentes para crear documentos de requisitos de producto de forma r\xe1pida y segura. Contin\xfae explorando m\xe1s casos de uso con Rewrite u otras funciones para optimizar su flujo de trabajo."}},"headMouseMovement":{"tourLabel":"Configuraci\xf3n de juegos manos libres con rat\xf3n de cabeza","learn":"Aprenda a utilizar los movimientos de la cabeza para controlar el cursor del mouse para navegar y hacer clic con precisi\xf3n.","deviceSettings":{"title":"Abrir la configuraci\xf3n del dispositivo","description":"Para habilitar los movimientos de la cabeza del mouse, haga clic en el bot\xf3n Configuraci\xf3n del dispositivo."},"cameraSettings":{"title":"Abrir la configuraci\xf3n de la c\xe1mara","description":"En la configuraci\xf3n del dispositivo, haga clic en Configuraci\xf3n de la c\xe1mara para acceder a los controles de la c\xe1mara."},"headMouseSection":{"title":"Movimiento de la cabeza para los controles del rat\xf3n","description":"Cuando esta opci\xf3n est\xe1 activada, algunos de los controles de movimiento de la cabeza se utilizar\xe1n para mover el mouse en lugar de los controles de disparo."},"steadyGlide":{"title":"Modo de planeo constante","description":"Activa el modo Deslizamiento constante. Al mover la cabeza m\xe1s all\xe1 de un punto determinado, el cursor se desliza continuamente en esa direcci\xf3n a una velocidad constante."},"customization":{"title":"Personalizar la configuraci\xf3n del rat\xf3n de cabeza","description":"Puedes personalizar la configuraci\xf3n del rat\xf3n de cabeza seg\xfan tus preferencias. Ajusta la velocidad, la sensibilidad y otros par\xe1metros para disfrutar de la mejor experiencia."},"save":{"title":"Guardar la configuraci\xf3n del mouse de cabeza","description":"No olvides guardar la configuraci\xf3n personalizada del mouse de cabeza."},"transition":{"title":"Pasando al panel Cephable","description":"Ahora pasemos al Panel Cephable para probar los movimientos de la cabeza del mouse."},"playGames":{"title":"Juega juegos con Head Mouse","description":"Ahora puedes usar los movimientos de la cabeza para controlar el cursor del rat\xf3n mientras juegas. \xa1Pru\xe9balo y descubre c\xf3mo funciona!"}},"clinicalNoteTaking":{"tourLabel":"Dictado y formato conforme a la HIPAA para m\xe9dicos","learn":"Aprenda a utilizar comandos de voz, dictado inteligente y formato de IA para tomar notas cl\xednicas.","speaking":{"title":"Empieza a hablar","description":"Ahora puede empezar a hablar. Todo lo que diga se escribir\xe1 en el campo de texto o documento que haya seleccionado. Intente decir algo como: \\"El paciente es un hombre de 45 a\xf1os con antecedentes de hipertensi\xf3n. El \xfaltimo medicamento recetado no funcion\xf3 como se esperaba y le caus\xf3 una reacci\xf3n al\xe9rgica. Necesitamos buscar medicamentos alternativos y le gustar\xeda una receta de marca gen\xe9rica\\"."},"rewriteIntro":{"title":"Formatear sus notas","description":"Ahora puedes usar Cephable Intelligent Rewrite para formatear tus notas en estilo SOAP. Todo esto se realiza en el dispositivo, lo que significa que tus datos se mantienen privados, seguros y cumplen con la HIPAA."},"copyText":{"title":"Copiar las notas","description":"Despu\xe9s de resaltar sus notas, copie el texto para prepararlo para el formato."},"pasteMode":{"title":"Haga clic en la pesta\xf1a Pegar texto","description":"Utilice el modo pegar para pegar las notas originales y formatearlas en estilo SOAP."},"pasteInput":{"title":"Pegar notas en formato","description":"Pegue las notas que desea formatear en el cuadro de entrada."},"enterInstructions":{"title":"Introduzca instrucciones de formato","description":"Puede escribir instrucciones de formato que deber\xe1n seguirse en su cl\xednica o sistema de HCE. (Por ejemplo, formato en estilo SOAP con encabezados, vi\xf1etas y lenguaje conciso)."},"navigateToEHR":{"title":"Navegue a su sistema EHR","description":"Abra su sistema EHR y navegue hasta la secci\xf3n donde desea ingresar las notas formateadas."},"focusTextField":{"title":"Centrarse en el campo de texto","description":"Haga clic en el campo de texto donde desea pegar las notas formateadas."},"complete":{"description":"Aprendi\xf3 a usar comandos de voz y dictado inteligente para documentar notas cl\xednicas, y la reescritura inteligente para formatearlas en estilo SOAP. Contin\xfae explorando m\xe1s casos de uso con dictado y reescritura, u otras funciones, para optimizar su flujo de trabajo."},"focus":{"title":"Centrarse en un documento","description":"El dictado funciona mejor cuando te concentras en un documento. Abre el documento donde quieras tomar notas cl\xednicas entre sesiones."}},"webBrowsing":{"tourLabel":"Planifique viajes, compre en l\xednea y navegue por la web usando la voz","learn":"Aprenda a utilizar comandos de voz para navegar, desplazarse y completar formularios mientras navega por la web con manos libres.","tryOpen":{"title":"Prueba a decir \xabAbrir Chrome\xbb o \xabAbrir Edge\xbb","description":"Aseg\xfarate de que tu micr\xf3fono est\xe9 activado y di \\"Abrir Chrome\\" o \\"Abrir Edge\\". Esto abrir\xe1 el navegador web que hayas elegido. Si tienes activado el cambio autom\xe1tico de controles, tambi\xe9n se cambiar\xe1n a los controles de la aplicaci\xf3n que mejor se adapten a la que est\xe9s usando."},"search":{"title":"B\xfasqueda","description":"Prueba a decir \\"Buscar\\" o \\"Buscar\\". Esto enfocar\xe1 la barra de b\xfasqueda en tu navegador."},"quickType":{"title":"Escritura r\xe1pida","description":"Escritura r\xe1pida te permite escribir con la voz sin usar el modo de dictado. Prueba a decir \\"Escribe qu\xe9 tiempo hace hoy\\". Esto escribir\xe1 tu consulta en la barra de b\xfasqueda."},"enter":{"title":"Presione Enter","description":"Prueba a decir \\"Intro\\". Esto ejecutar\xe1 la b\xfasqueda que acabas de escribir."},"scrollDown":{"title":"Desplazarse hacia abajo","description":"Prueba a decir \\"Desplazarse hacia abajo\\". Esto har\xe1 que la p\xe1gina web se desplace hacia abajo."},"scrollUp":{"title":"Desplazarse hacia arriba","description":"Prueba a decir \\"Desplazarse hacia arriba\\". Esto har\xe1 que la p\xe1gina web se desplace hacia arriba."},"newTab":{"title":"Abrir una nueva pesta\xf1a","description":"Prueba a decir \\"Nueva pesta\xf1a\\". Se abrir\xe1 una nueva pesta\xf1a en tu navegador."},"formsCustomization":{"title":"Personalizaci\xf3n del llenado de formularios","description":"Puedes personalizar este control de la aplicaci\xf3n para rellenar formularios f\xe1cilmente, como nombre, apellido, correo electr\xf3nico, etc. Luego, puedes usar Acciones R\xe1pidas o Comandos de Voz para completarlos a\xfan m\xe1s r\xe1pido."},"complete":{"title":"\xa1Buen trabajo!","description":"Ya sabes usar comandos de voz y acciones r\xe1pidas para navegar, buscar, desplazarte y rellenar formularios mientras navegas por la web. Explora m\xe1s comandos o personaliza tus propias acciones r\xe1pidas para una navegaci\xf3n web a\xfan m\xe1s fluida."}},"spreadsheetReviews":{"tourLabel":"Trabaje m\xe1s r\xe1pido en hojas de c\xe1lculo con controles de voz","learn":"Aprenda a utilizar comandos de voz y acciones r\xe1pidas para revisar y editar hojas de c\xe1lculo grandes r\xe1pidamente.","tryOpen":{"title":"Prueba a decir \xabAbrir Excel\xbb o \xabAbrir Hojas de c\xe1lculo de Google\xbb.","description":"Aseg\xfarate de que tu micr\xf3fono est\xe9 activado y di \\"Abrir Excel\\" o \\"Abrir Hojas de C\xe1lculo de Google\\". Esto abrir\xe1 la aplicaci\xf3n de hoja de c\xe1lculo que hayas elegido. Si tienes activado el cambio autom\xe1tico de controles, tambi\xe9n se cambiar\xe1 a los controles que mejor se adapten a la aplicaci\xf3n que est\xe9s usando."},"selectRow":{"title":"Seleccionar una fila","description":"Haz clic en una celda. Luego, prueba a decir \\"Seleccionar fila\\". Esto seleccionar\xe1 toda la fila de la celda seleccionada."},"delete":{"title":"Eliminar el contenido de una fila","description":"Prueba a decir \\"Eliminar\\". Esto eliminar\xe1 el contenido de la fila seleccionada."},"note":{"title":"Agregar una nota a una celda","description":"Haz clic en una celda. Luego, prueba a decir \\"Agregar nota\\". Esto te permitir\xe1 agregar una nota a la celda seleccionada."},"addNote":{"title":"Escribe la nota","description":"Prueba a decir \\"Escribe. Estos n\xfameros no coinciden\\". Esto escribir\xe1 tu nota en la celda."},"currentDate":{"title":"Introduzca la fecha actual","description":"Haz clic en una celda. Luego, prueba a decir \\"Fecha actual\\". Esto introducir\xe1 la fecha actual en la celda seleccionada."},"copy":{"title":"Copiar una celda","description":"Haz clic en la celda donde acabas de a\xf1adir la fecha actual. Luego, prueba a decir \\"Copiar\\". Esto copiar\xe1 la fecha actual."},"selectColumn":{"title":"Seleccionar una columna","description":"Prueba a decir \\"Columna\\". Esto seleccionar\xe1 toda la columna de la celda seleccionada."},"paste":{"title":"Pegar fecha actual","description":"Prueba a decir \\"Pegar\\". Esto pegar\xe1 la fecha actual en la columna seleccionada."},"quickActions":{"title":"Utilice acciones r\xe1pidas","description":"Tambi\xe9n puedes usar muchos de estos controles y m\xe1s con los botones de acci\xf3n r\xe1pida. Puedes personalizarlos para que se adapten a tu flujo de trabajo y agilicen a\xfan m\xe1s la revisi\xf3n y edici\xf3n de hojas de c\xe1lculo."},"complete":{"description":"Ya sabes usar comandos de voz y acciones r\xe1pidas para revisar y editar hojas de c\xe1lculo grandes r\xe1pidamente. Explora m\xe1s comandos o personaliza tus propias acciones r\xe1pidas para gestionar tus hojas de c\xe1lculo m\xe1s r\xe1pidamente."}},"socialMediaWriting":{"tourLabel":"Cree, repita y publique contenido en redes sociales con voz e IA en el dispositivo","learn":"Aprenda a utilizar Generate and Rewrite inteligente, de forma totalmente privada y en el dispositivo, para crear e iterar contenido.","onDeviceIntro":{"title":"Su investigaci\xf3n se mantiene privada y segura","description":"Las Tareas Inteligentes de Cephable se basan en la IA del dispositivo, lo que significa que tus datos se mantienen privados y seguros. Puedes crear, reescribir y traducir texto sin necesidad de procesamiento en la nube. Tambi\xe9n puedes usar contexto entre aplicaciones e iterar ideas directamente en tu aplicaci\xf3n preferida."},"enterPrompt":{"title":"Empieza a idear","description":"En el cuadro de entrada, escriba una propuesta para el contenido que desea estructurar o generar. Por ejemplo, puede escribir: \\"Enumerar los riesgos de la IA Agentic, d\xf3nde se encuentran algunas de las deficiencias y c\xf3mo la innovaci\xf3n puede avanzar\\"."},"customizeSettings":{"title":"Personalizar la configuraci\xf3n de generaci\xf3n","description":"Puedes personalizar la configuraci\xf3n de generaci\xf3n seg\xfan tus preferencias. Aj\xfastala con indicaciones del sistema que reflejan el tono, la imagen de la marca y m\xe1s."},"rewriteIntro":{"title":"Iterar sobre el contenido","description":"Puedes usar Cephable Intelligent Rewrite para iterar el contenido directamente en tu aplicaci\xf3n preferida. Todo esto se realiza en el dispositivo, lo que significa que tus datos se mantienen privados y seguros."},"highlightText":{"title":"Resaltar texto para reescribir","description":"Resalte uno de los riesgos enumerados del contenido generado que desea desarrollar m\xe1s a fondo."},"enterInstructions":{"title":"Introduzca instrucciones de reescritura","description":"Escriba las instrucciones de reescritura. Por ejemplo, puede escribir: \\"Agregue m\xe1s detalles sobre los riesgos\\"."},"writeSocialMediaPost":{"title":"Escribe una publicaci\xf3n en las redes sociales","description":"Utilice la reescritura nuevamente para reformatear este lenguaje y convertirlo en una publicaci\xf3n p\xfablica en las redes sociales que obtenga los puntos clave y destaque las \xe1reas de participaci\xf3n."},"highlightPost":{"title":"Resaltar la publicaci\xf3n generada","description":"Resalte la publicaci\xf3n de redes sociales generada que desea utilizar."},"enterPostInstructions":{"title":"Introducir instrucciones de publicaci\xf3n","description":"Escribe las instrucciones para tu publicaci\xf3n. Por ejemplo, puedes escribir: \\"Que sea concisa y atractiva para LinkedIn\\"."},"complete":{"description":"Ahora puedes abrir tu plataforma de redes sociales preferida, centrarte en el cuadro de texto de creaci\xf3n de la publicaci\xf3n y pegar la publicaci\xf3n generada. \xa1O contin\xfaa iterando y refinando hasta que est\xe9s listo!"}},"inboxTriage":{"tourLabel":"Gesti\xf3n eficiente del correo electr\xf3nico con voz e inteligencia artificial en el dispositivo","learn":"Aprenda a utilizar comandos de voz y tareas inteligentes para administrar su bandeja de entrada de manera eficiente y mantener sus datos seguros.","tryOpen":{"title":"Prueba a decir \xabAbrir Outlook\xbb o \xabAbrir Gmail\xbb.","description":"Aseg\xfarate de que tu micr\xf3fono est\xe9 activado y di \\"Abrir Outlook\\" o \\"Abrir Gmail\\". Esto abrir\xe1 la aplicaci\xf3n de correo electr\xf3nico que hayas elegido. Si tienes activado el cambio autom\xe1tico de controles, tambi\xe9n se cambiar\xe1 a los controles de la aplicaci\xf3n que mejor se adapten a la que est\xe9s usando."},"select":{"title":"Seleccione un correo electr\xf3nico","description":"Haz clic en un correo electr\xf3nico. Luego, prueba a decir \\"Seleccionar correo electr\xf3nico\\". Esto seleccionar\xe1 el correo electr\xf3nico seleccionado."},"delete":{"title":"Eliminar un correo electr\xf3nico","description":"Prueba a decir \\"Eliminar\\". Esto eliminar\xe1 el correo electr\xf3nico seleccionado."},"reply":{"title":"Responder a un correo electr\xf3nico","description":"Haz clic en un correo electr\xf3nico. Luego, prueba a decir \\"Responder\\". Esto abrir\xe1 la ventana de respuesta del correo electr\xf3nico seleccionado."},"dictateIntro":{"title":"Dicte su respuesta","description":"Puedes usar el dictado para escribir tu respuesta sin usar las manos. Aseg\xfarate de que el micr\xf3fono est\xe9 encendido y el modo de dictado activado."},"dictateReply":{"title":"Empezar a responder","description":"Intenta decir: \\"Me interesa saber m\xe1s sobre sus servicios. Por favor, env\xedenme informaci\xf3n adicional\\". Esto escribir\xe1 tu respuesta en el correo electr\xf3nico. Aseg\xfarate de centrarte en el cuadro de respuesta."},"newEmail":{"title":"Crear un nuevo correo electr\xf3nico","description":"Prueba a decir \\"Nuevo correo\\". Se abrir\xe1 una nueva ventana para redactar el correo."},"customEmailTemplates":{"title":"Plantillas de correo electr\xf3nico personalizadas","description":"Puedes crear plantillas de correo electr\xf3nico personalizadas para respuestas comunes. Esto te permitir\xe1 insertar r\xe1pidamente contenido preescrito en tus correos electr\xf3nicos mediante comandos de voz o acciones r\xe1pidas."},"editAppControls":{"title":"Editar controles de la aplicaci\xf3n","description":"Para crear una plantilla de correo electr\xf3nico personalizada, haga clic en el bot\xf3n Editar controles de la aplicaci\xf3n."},"addNewControl":{"title":"Agregar nuevo control","description":"En el editor de controles de la aplicaci\xf3n, haga clic en el bot\xf3n Agregar nuevo control."},"quickAction":{"title":"Seleccionar Acci\xf3n R\xe1pida","description":"Elija Acci\xf3n r\xe1pida como tipo de control."},"templateName":{"title":"Nombra tu plantilla","description":"Dale un nombre a tu plantilla de correo electr\xf3nico personalizada, como por ejemplo \\"Solicitud de reuni\xf3n\\"."},"eventType":{"title":"Seleccionar el tipo de evento","description":"En la secci\xf3n de tipo de evento, elija un tipo de evento de \\"tipo\\"."},"typeSteps":{"title":"Tipo de contenido de plantilla","description":"Escribe el contenido de tu plantilla de correo electr\xf3nico. Por ejemplo, puedes escribir: \\"Lead Outreach\\nHola, me gustar\xeda programar una reuni\xf3n para hablar sobre posibles oportunidades de colaboraci\xf3n. Por favor, ind\xedcame tu disponibilidad\\"."},"finish":{"title":"Terminar de crear la plantilla","description":"Haga clic en el bot\xf3n Finalizar para completar la creaci\xf3n de su plantilla de correo electr\xf3nico personalizada."},"saveTemplate":{"title":"Guarda tu plantilla","description":"Haga clic en el bot\xf3n Guardar para guardar su plantilla de correo electr\xf3nico personalizada."},"focusApp":{"title":"Reenfoca tu aplicaci\xf3n de correo electr\xf3nico","description":"Regrese a su aplicaci\xf3n de correo electr\xf3nico y aseg\xfarese de estar concentrado en la nueva l\xednea de asunto del correo electr\xf3nico."},"useTemplate":{"title":"Utilice su plantilla","description":"Ahora puedes usar tu plantilla de correo electr\xf3nico personalizada diciendo su nombre o haciendo clic en el bot\xf3n Acci\xf3n r\xe1pida."},"generateIntro":{"title":"Generar contenido de correo electr\xf3nico","description":"Tambi\xe9n puedes usar Cephable Intelligent Generate para crear contenido de correo electr\xf3nico directamente en tu aplicaci\xf3n. Todo esto se realiza en el dispositivo, lo que significa que tus datos se mantienen privados y seguros."},"enterPrompt":{"title":"Ingresar solicitud de correo electr\xf3nico","description":"En el cuadro de aviso, escriba: Escriba un correo electr\xf3nico profesional a un cliente potencial presentando nuestros servicios y solicitando una reuni\xf3n."},"focusNewEmail":{"title":"Conc\xe9ntrese en el nuevo correo electr\xf3nico","description":"Aseg\xfarate de estar concentrado en la nueva ventana de redacci\xf3n de correo electr\xf3nico donde quieres que aparezca el texto generado."},"translateEmail":{"title":"Traducir el contenido del correo electr\xf3nico","description":"Puedes usar Cephable Intelligent Translate para traducir el contenido del correo electr\xf3nico directamente en tu aplicaci\xf3n. Todo esto se realiza en el dispositivo, lo que significa que tus datos se mantienen privados y seguros."},"highlightText":{"title":"Resaltar el contenido del correo electr\xf3nico","description":"Resalte el contenido de un correo electr\xf3nico largo que desea traducir."},"enterLanguage":{"title":"Introducir idioma de traducci\xf3n","description":"Escribe el idioma de la traducci\xf3n. Por ejemplo, puedes escribir: \\"espa\xf1ol\\"."},"complete":{"description":"Ya sabes c\xf3mo usar comandos de voz y Tareas Inteligentes para navegar, responder, dictar, generar y traducir correos electr\xf3nicos, manteniendo tus datos seguros. Explora m\xe1s comandos o personaliza tus acciones r\xe1pidas para una gesti\xf3n de correo electr\xf3nico a\xfan m\xe1s fluida."}},"handsFreeMeeting":{"tourLabel":"Controles r\xe1pidos de reuniones con manos libres","learn":"Ahorre tiempo y reduzca la fatiga en las reuniones virtuales con controles r\xe1pidos de reuniones manos libres","tryOpen":{"title":"Prueba a decir \xabAbrir Zoom\xbb o \xabAbrir Teams\xbb.","description":"Aseg\xfarate de que tu micr\xf3fono est\xe9 activado y di \\"Abrir Zoom\\" o \\"Abrir Teams\\". Esto abrir\xe1 la aplicaci\xf3n de reuniones que hayas elegido. Si tienes activado el cambio autom\xe1tico de controles, tambi\xe9n se cambiar\xe1 a los controles que mejor se adapten a la aplicaci\xf3n que est\xe9s usando."},"mute":{"title":"Prueba a decir \xabActivar/Desactivar silencio\xbb para silenciar tu micr\xf3fono.","description":"Aseg\xfarate de que tu micr\xf3fono est\xe9 activado y di \\"Activar/Desactivar silencio\\". Esto silenciar\xe1 tu micr\xf3fono en la aplicaci\xf3n de reuniones seleccionada."},"video":{"title":"Prueba a decir \xabActivar o desactivar video\xbb para encender o apagar tu c\xe1mara.","description":"Aseg\xfarate de que tu micr\xf3fono est\xe9 activado y di \\"Activar/Desactivar video\\". Esto activar\xe1 o desactivar\xe1 tu c\xe1mara en la aplicaci\xf3n de reuniones que hayas elegido."},"raiseHand":{"title":"Intenta decir \xabLevanta la mano\xbb para levantar la mano.","description":"Aseg\xfarate de que tu micr\xf3fono est\xe9 activado y di \\"Levantar la mano\\". Esto har\xe1 que levantes la mano en la aplicaci\xf3n de reuniones que hayas elegido."},"quickType":{"title":"Escritura r\xe1pida","description":"Aseg\xfarate de que tu micr\xf3fono est\xe9 activado y di \\"Escribe, esta es una funci\xf3n genial\\". Esto te permitir\xe1 escribir r\xe1pidamente con la voz sin estar en modo de dictado. Aseg\xfarate de tener el foco en un campo de texto en la aplicaci\xf3n de reuniones."},"complete":{"description":"Ya sabes c\xf3mo usar comandos de voz y acciones r\xe1pidas para silenciar/activar el sonido, activar/desactivar el video, levantar la mano y escribir r\xe1pidamente en tus aplicaciones de reuniones favoritas. Explora m\xe1s comandos o personaliza tus propias acciones r\xe1pidas para un control de reuniones a\xfan m\xe1s fluido."}},"summarizingReports":{"tourLabel":"Resuma informes y documentos con IA en el dispositivo","learn":"Aprenda a utilizar la generaci\xf3n de res\xfamenes impulsada por IA para obtener r\xe1pidamente los puntos clave de informes y documentos extensos y, al mismo tiempo, mantener seguros sus datos confidenciales y exclusivos.","summarizeIntro":{"title":"Resumir texto","description":"Puedes usar las Tareas Inteligentes de Cephable para obtener r\xe1pidamente los puntos clave de informes y documentos extensos. Resumir forma parte de las Tareas de IA en el dispositivo, lo que significa que funciona sin conexi\xf3n a internet y se ejecuta desde tu dispositivo."},"navigateToReport":{"title":"Conc\xe9ntrese en su informe o documento","description":"Abra su informe o documento en su aplicaci\xf3n preferida y conc\xe9ntrese en el texto que desea resumir."},"highlightText":{"title":"Resaltar texto para resumir","description":"Resalte el texto que desea resumir."},"copyText":{"title":"Copiar el texto","description":"Despu\xe9s de resaltar el texto, c\xf3pialo para prepararlo para el resumen."},"enterPrompt":{"title":"Introducir instrucciones de resumen","description":"Escribe las instrucciones para tu resumen. Indica la longitud, el estilo o cualquier contenido espec\xedfico que desees."},"pasteText":{"title":"Pegue el contenido de su informe","description":"Despu\xe9s de las instrucciones, pegue el texto copiado en el cuadro de entrada."},"focusChatApp":{"title":"Conc\xe9ntrese en su aplicaci\xf3n de chat","description":"Abra su aplicaci\xf3n de chat como Teams o Slack y conc\xe9ntrese en el cuadro de texto donde desea que aparezca el texto resumido."},"rewriteIntro":{"title":"Reescribir texto resumido","description":"Tambi\xe9n puede usar Cephable Intelligent Rewrite para refinar a\xfan m\xe1s el texto resumido. Todo esto se realiza en el dispositivo, lo que significa que sus datos se mantienen privados y seguros."},"highlightSummary":{"title":"Resaltar el texto resumido","description":"Resalte el texto resumido que desea refinar m\xe1s."},"enterRewriteInstructions":{"title":"Introduzca instrucciones de reescritura","description":"Escribe las instrucciones de reescritura. Indica el tono, el estilo o cualquier cambio espec\xedfico que desees."},"complete":{"description":"Aprendi\xf3 a usar Tareas Inteligentes para resumir textos de forma r\xe1pida y segura y compartir hallazgos con su equipo. Contin\xfae explorando m\xe1s casos de uso con Resumir y Reescribir, u otras funciones, para optimizar su flujo de trabajo."}},"congrats":"\xa1Felicitaciones!","noteTakingAndDocumentation":{"tourLabel":"Toma de notas y generaci\xf3n de documentos mediante IA privada en el dispositivo","learn":"Aprenda a usar comandos de voz, dictado inteligente y tareas de IA para pasar de notas a dise\xf1os y documentos m\xe1s r\xe1pido.","focus":{"title":"Centrarse en un campo de texto o documento","description":"El dictado funciona mejor cuando te centras en un campo de texto o documento. Abre un documento o haz clic en el campo de texto donde quieras tomar notas."},"speaking":{"title":"Empieza a hablar","description":"Ahora puedes empezar a hablar. Mientras reflexionas sobre tu idea, habla con naturalidad y deja que tus pensamientos fluyan. Todo lo que digas se escribir\xe1 en el campo de texto o documento en el que te centraste. Intenta describir tu concepto, detallar los pasos o generar ideas libremente. Por ejemplo, di: \\"Estoy considerando un nuevo flujo de trabajo para nuestro equipo. Primero, deber\xedamos automatizar el proceso de informes y luego revisar los resultados semanalmente\\". Aseg\xfarate de que el cursor est\xe9 enfocado en el documento."},"typeEnter":{"title":"Saltos de p\xe1rrafo","description":"Para crear saltos de p\xe1rrafo, simplemente pulsa Intro. Esto te ayudar\xe1 a organizar tus notas en secciones claras. Contin\xfaa expresando tus ideas o transcribiendo lo que dice otra persona."},"rewriteIntro":{"title":"Crear dise\xf1os","description":"Ahora puedes usar Cephable Intelligent Rewrite para tomar tus notas y dise\xf1arlas para crear una idea o para realizar seguimientos. Todo esto se realiza en el dispositivo, lo que significa que tus datos se mantienen privados y seguros."},"highlightText":{"title":"Resaltar las notas","description":"Seleccione todas las notas que desee utilizar para crear un dise\xf1o o documento."},"inPlaceReplacement":{"title":"Ideaci\xf3n en el lugar","description":"Ahora, usaremos el reemplazo en contexto para convertir tus notas en un dise\xf1o o documento. Siempre puedes usar el modo pegar o la opci\xf3n para crear un nuevo archivo."},"enterInstructions":{"title":"Introducir instrucciones de dise\xf1o","description":"Puedes escribir las instrucciones de los pr\xf3ximos pasos sobre lo que quieres hacer con las notas. Esto podr\xeda ser formato, dise\xf1o, tareas de seguimiento o cualquier otra cosa. (Por ejemplo, crea un documento de dise\xf1o que destaque c\xf3mo funcionar\xeda la funci\xf3n, c\xf3mo se ve el proceso completo y c\xf3mo se ver\xeda el \xe9xito)."},"complete":{"description":"Aprendi\xf3 a usar comandos de voz y dictado inteligente para documentar notas cl\xednicas, y la reescritura inteligente para formatearlas en estilo SOAP. Contin\xfae explorando m\xe1s casos de uso con dictado y reescritura, u otras funciones, para optimizar su flujo de trabajo."}},"fpsGamePlay":{"tourLabel":"Juega juegos FPS con controles de voz","learn":"Aprende a usar controles de voz y acciones r\xe1pidas para jugar juegos FPS.","changeProfile":{"title":"Perfil de control de cambios","description":"Cambia el control de tu aplicaci\xf3n al perfil de juego FPS. Tambi\xe9n puedes personalizarlo para el juego espec\xedfico que quieras jugar. Consulta el video."},"autoProfileSwitching":{"title":"Desactivar el cambio de control autom\xe1tico","description":"Esto mantendr\xe1 activo el control de su aplicaci\xf3n actual hasta que cambie de aplicaci\xf3n."},"tryOpen":{"title":"Prueba a decir \xabAbrir Valorant\xbb o \xabAbrir Battlefield\xbb."},"go":{"title":"Prueba a decir \\"Ve\\"","description":"Aseg\xfarate de que tu micr\xf3fono est\xe9 encendido y di \\"Adelante\\". Esto har\xe1 que tu personaje avance."},"stop":{"title":"Prueba a decir \\"Alto\\"","description":"Aseg\xfarate de que tu micr\xf3fono est\xe9 encendido y di \\"Detener\\". Esto detendr\xe1 el movimiento de tu personaje."},"complete":{"description":"Ya sabes c\xf3mo usar comandos de voz y acciones r\xe1pidas para moverte, detenerte y controlar a tu personaje en juegos FPS. Explora m\xe1s comandos o personaliza tus propias acciones r\xe1pidas para disfrutar de una experiencia de juego a\xfan m\xe1s fluida y r\xe1pida."}},"presentationControls":{"tourLabel":"Controlar presentaciones con comandos de voz","learn":"Aprenda a utilizar comandos de voz y acciones r\xe1pidas para navegar y controlar sus presentaciones con manos libres.","tryOpen":{"title":"Prueba a decir \xabAbrir PowerPoint\xbb o \xabAbrir Google Slides\xbb."},"startPresentation":{"title":"Intente decir \\"Iniciar presentaci\xf3n\\" para comenzar su presentaci\xf3n de diapositivas","description":"Aseg\xfarate de que tu micr\xf3fono est\xe9 activado y di \\"Iniciar presentaci\xf3n\\". Esto iniciar\xe1 tu presentaci\xf3n en la aplicaci\xf3n de presentaciones que hayas elegido."},"nextSlide":{"title":"Intente decir \\"Siguiente diapositiva\\" para pasar a la siguiente diapositiva","description":"Aseg\xfarate de que tu micr\xf3fono est\xe9 activado y di \\"Siguiente diapositiva\\". Esto te llevar\xe1 a la siguiente diapositiva de tu presentaci\xf3n."},"previousSlide":{"title":"Intente decir \\"Diapositiva anterior\\" para volver a la diapositiva anterior","description":"Aseg\xfarate de que tu micr\xf3fono est\xe9 activado y di \\"Diapositiva anterior\\". Esto te llevar\xe1 a la diapositiva anterior de tu presentaci\xf3n."},"escape":{"title":"Intente decir \xabEscape\xbb para salir del modo de presentaci\xf3n","description":"Aseg\xfarate de que tu micr\xf3fono est\xe9 activado y presiona \\"Escape\\". Esto cerrar\xe1 el modo de presentaci\xf3n en la aplicaci\xf3n elegida."},"complete":{"description":"Ahora ya sabes usar comandos de voz y acciones r\xe1pidas para iniciar, navegar y salir de presentaciones sin usar las manos. Explora m\xe1s comandos o personaliza tus propias acciones r\xe1pidas para un control a\xfan m\xe1s fluido de tus presentaciones."}},"editingImages":{"tourLabel":"Edici\xf3n de im\xe1genes m\xe1s r\xe1pida con controles de voz y dictado","learn":"Aprenda a utilizar comandos de voz, acciones r\xe1pidas y dictado para mejorar su proceso de edici\xf3n de im\xe1genes.","tryOpen":{"title":"Prueba a decir \xabAbrir Figma\xbb o \xabAbrir Photoshop\xbb"},"selectAll":{"title":"Intente decir \\"Seleccionar todo\\" para seleccionar todos los elementos en el lienzo","description":"Aseg\xfarate de que tu micr\xf3fono est\xe9 activado y di \\"Seleccionar todo\\". Esto seleccionar\xe1 todos los elementos del lienzo en la aplicaci\xf3n de edici\xf3n de im\xe1genes que hayas elegido. Aseg\xfarate de tener la aplicaci\xf3n enfocada."},"bold":{"title":"Intente decir \\"Negrita\\" para poner el texto seleccionado en negrita","description":"Aseg\xfarate de que tu micr\xf3fono est\xe9 activado y di \\"Negrita\\". Esto activar\xe1 el texto seleccionado en negrita en la aplicaci\xf3n de edici\xf3n de im\xe1genes que elijas. Aseg\xfarate de tener el texto seleccionado."},"copy":{"title":"Intente decir \\"Copiar\\" para copiar el elemento seleccionado","description":"Aseg\xfarate de que tu micr\xf3fono est\xe9 activado y di \\"Copiar\\". Esto copiar\xe1 el elemento seleccionado en la aplicaci\xf3n de edici\xf3n de im\xe1genes que hayas elegido. Aseg\xfarate de tener un elemento seleccionado."},"paste":{"title":"Intente decir \\"Pegar\\" para pegar el elemento copiado","description":"Aseg\xfarate de que tu micr\xf3fono est\xe9 activado y di \\"Pegar\\". Esto pegar\xe1 el elemento copiado en la aplicaci\xf3n de edici\xf3n de im\xe1genes que hayas elegido."},"delete":{"title":"Intente decir \\"Eliminar\\" para eliminar el elemento seleccionado","description":"Aseg\xfarate de que tu micr\xf3fono est\xe9 activado y di \\"Eliminar\\". Esto eliminar\xe1 el elemento seleccionado en la aplicaci\xf3n de edici\xf3n de im\xe1genes elegida. Aseg\xfarate de tener un elemento seleccionado."},"dictationIntro":{"title":"Dictado","description":"Puedes usar el dictado para escribir texto con la voz. Aseg\xfarate de que el micr\xf3fono est\xe9 encendido y el modo de dictado activado."},"focus":{"title":"Centrarse en un campo de texto","description":"Haga clic en un campo de texto en su aplicaci\xf3n de edici\xf3n de im\xe1genes donde desee utilizar el dictado."},"speaking":{"title":"Empieza a hablar","description":"Intenta decir: \\"Para obtener c\xf3digos de descuento anticipados, escanea el c\xf3digo QR. V\xe1lido hasta el 30 de septiembre. Despu\xe9s, solic\xedtalo a trav\xe9s del sitio web\\". Aseg\xfarate de enfocar el campo de texto o el \xe1rea donde quieres dictar."},"complete":{"description":"Ahora sabes c\xf3mo usar comandos de voz, acciones r\xe1pidas y dictado para optimizar tu edici\xf3n de im\xe1genes. Explora m\xe1s comandos o personaliza tus propias acciones r\xe1pidas para una edici\xf3n a\xfan m\xe1s fluida."}},"redo":"Rehacer la incorporaci\xf3n","title":"Conoce a Cephable","description":"Conozca Cephable, su asistente personal de IA y comparta su inter\xe9s en casos de uso personalizados.","panel":{"description":"Este es el panel, el centro de control principal. Siempre est\xe1 visible y te permite controlar tus aplicaciones con la voz, entre otras funciones. Empecemos por el micr\xf3fono."}}');


var $501d8d6df9954de7$exports = {};
$501d8d6df9954de7$exports = JSON.parse('{"introduction":{"title":"Hola, soy Cephable.","back":"Volver a la introducci\xf3n","description":"Soy tu IA personal para ayudarte a controlar, crear y automatizar las herramientas que ya te encantan, en todas tus conexiones. Hay algunas cosas que debes saber sobre m\xed.","action":"\xa1Comencemos!","recording":{"title":"Su voz y v\xeddeo permanecen locales.","description":"Nunca grabo, transmito ni env\xedo tu audio o video a la nube. Todas las entradas se procesan en el dispositivo de forma privada y segura."},"data":{"title":"Tus datos son tuyos.","description":"No uso tus comandos ni tu actividad para entrenar modelos para otros. Todo se mantiene privado y los controles de tu aplicaci\xf3n se mueven contigo entre conexiones."},"offline":{"title":"Trabajo cuando otras herramientas no lo hacen.","description":"Las tareas inteligentes, como generar contenido, reescribir, traducir y dictar, se ejecutan localmente. No se requiere la nube. Esto significa que trabajo incluso sin conexi\xf3n, y tus datos no salen de tu dispositivo."},"empower":{"title":"Creado para empoderar, no para explotar.","description":"Estoy dise\xf1ado para mejorar tu control, no para monitorearlo. Sin rastreo invasivo. Sin recopilaci\xf3n de datos intrusivos. Solo informaci\xf3n que te funcione."}},"my-capabilities":{"title":"\xa1Perfecto! As\xed es como puedo ayudarte.","back":"Volver a las capacidades","actionTitle":"M\xedrame en acci\xf3n","description":"Seg\xfan sus intereses, aqu\xed se presentan las caracter\xedsticas y capacidades m\xe1s relevantes para su flujo de trabajo.","action":{"title":"M\xedrame en acci\xf3n","description":"Explora algunos ejemplos de c\xf3mo puedo ayudarte en tus tareas diarias."}},"see-me":{"title":"\xbfQuieres ver c\xf3mo he ayudado a otros como t\xfa?","back":"Volver a los casos de uso","description":"Vea algunos ejemplos reales de c\xf3mo he transformado los flujos de trabajo en diferentes industrias y roles."},"complete":{"title":"\xbfEst\xe1s listo para comenzar a usarme?","description":"\xa1Ya viste lo que puedo hacer! Ahora, vamos a configurarlo y a empezar a transformar tu flujo de trabajo. Estar\xe9 aqu\xed para ayudarte en cada paso del proceso.","action":"Complete la configuraci\xf3n y comience a usar Cephable"},"apps":{"title":"Apoyo las herramientas que ya amas","description":"Con soporte preconfigurado para m\xe1s de 200 aplicaciones, trabajo con el software que usas a diario. No requiere configuraci\xf3n.","note":"\xbfNo encuentras una aplicaci\xf3n que uses? No hay problema: puedo generar controles o ayudarte a crear flujos de trabajo personalizados que se adapten a tus necesidades.","andMore":"Y m\xe1s"},"actions":{"ctaTry":"Pru\xe9balo ahora","ctaWatch":"Ver demostraci\xf3n","apps":"Soy compatible con:","abilities":"Mis habilidades utilizadas:"},"interests":{"title":"\xbfEn qu\xe9 puedo ayudarte?","back":"Volver a los intereses","description":"Puedo controlar aplicaciones en tu escritorio y dispositivos conectados. Personalicemos tu experiencia: \xbfqu\xe9 te interesa m\xe1s?","note":"Seleccione todas las que correspondan y le mostrar\xe9 las caracter\xedsticas y ejemplos m\xe1s relevantes para su flujo de trabajo.","action":"Continuar con {{count}} intereses","empty":"Seleccione al menos un inter\xe9s.","create_design":{"label":"Crear y dise\xf1ar","shortLabel":"Dise\xf1o","description":"Para artistas, comercializadores y creadores de contenido."},"analyze_report":{"label":"Analizar e informar","shortLabel":"Analizar","description":"Para analistas, investigadores y profesionales de negocios."},"communicate_collaborate":{"label":"Comunicarse y colaborar","shortLabel":"Comunicar","description":"Para vendedores, reuniones y equipos remotos."},"build_develop":{"label":"Construir y desarrollar","shortLabel":"Desarrollar","description":"Para desarrolladores, ingenieros y profesionales t\xe9cnicos."},"game_play":{"label":"Juego y juego","shortLabel":"Juego de azar","description":"Para jugadores, streamers y controles multimedia."},"learn_teach":{"label":"Aprender y ense\xf1ar","shortLabel":"Aprendiendo","description":"Para educadores, estudiantes e instrucci\xf3n."},"manage_organize":{"label":"Administrar y organizar","shortLabel":"Organizando","description":"Para gerentes de proyectos, coordinadores y organizadores."},"adapt_access":{"label":"Adaptaci\xf3n y acceso","shortLabel":"Accesibilidad","description":"Para controles adaptativos y necesidades de accesibilidad personalizadas."},"everything":{"label":"Un poco de todo","shortLabel":"Todo","description":"Para usuarios de computadoras en general y que realizan m\xfaltiples tareas a la vez."},"filter":"Filtrar por tipo de inter\xe9s"},"capabilities":{"title":"Mis principales capacidades de IA","description":"Combino IA avanzada con potentes m\xe9todos de entrada para ofrecerte un control total sobre tus aplicaciones y dispositivos. Estas son algunas de mis funciones.","voice_controls":{"title":"Controles de voz","description":"Entiendo comandos de lenguaje natural para que puedas controlar cualquier aplicaci\xf3n con tu voz.","longDescription":"Te dejo hablar con naturalidad y aun as\xed lograr tus objetivos. Ya sea que quieras abrir aplicaciones, navegar por los men\xfas o iniciar flujos de trabajo, traduzco el ingl\xe9s sencillo a acciones fiables y sin intervenci\xf3n manual."},"smart_dictation":{"title":"Dictado inteligente","description":"Convierto tu discurso en texto con conocimiento del contexto y formato.","longDescription":"Escucho atentamente y capto tus palabras con precisi\xf3n. Agrego puntuaci\xf3n, corrijo las may\xfasculas y me adapto a tu estilo para que tu escritura se vea impecable sin esfuerzo adicional."},"ai_text_generation":{"title":"Generaci\xf3n de texto con IA","description":"Puedo crear correos electr\xf3nicos, documentos, c\xf3digos y contenido creativo sobre la marcha.","longDescription":"Te ayudo a redactar, resumir o ampliar cualquier contenido directamente en tus aplicaciones. Desde correos electr\xf3nicos y notas hasta fragmentos de c\xf3digo y documentos, me aseguro de que nunca empieces desde cero."},"head_face_controls":{"title":"Controles de cabeza y cara","description":"Te dejo provocar acciones con movimientos de cabeza y cara.","longDescription":"Traduzco tus movimientos y expresiones naturales de cabeza en informaci\xf3n precisa. Puedes enviar un correo electr\xf3nico con una sonrisa, pasar de p\xe1gina con un gesto de la cabeza o hacer clic levantando las cejas."},"natural_language_voice_clicking":{"title":"Clics de voz en lenguaje natural","description":"Te dejo decir lo que ves para hacer clic en botones, enlaces y men\xfas en la pantalla.","longDescription":"Cuando dices el nombre de algo en tu pantalla, lo encuentro e interact\xfao con \xe9l por ti. Sin comandos memorizados: solo describe lo que quieres y yo me encargo de hacer clic."},"keyboard_mouse_emulation":{"title":"Emulaci\xf3n de teclado y rat\xf3n","description":"Emulo teclas, clics y desplazamiento para que puedas controlar aplicaciones sin hardware.","longDescription":"Env\xedo pulsaciones de teclas, movimientos del rat\xf3n, clics y eventos de desplazamiento donde los necesites. Comb\xedname con controles de voz o de cabeza para reemplazar o mejorar por completo los dispositivos de entrada tradicionales."},"profiles_personalization":{"title":"Personalizaci\xf3n","description":"Recuerdo tus preferencias y me adapto con los controles de aplicaciones guardadas.","longDescription":"Monitoreo tus aplicaciones, comandos y preferencias favoritas. Cambia entre los controles de las aplicaciones de forma autom\xe1tica o manual, y siempre te mostrar\xe9 los controles adecuados para lo que est\xe9s haciendo."},"cross_device_connectivity":{"title":"Conectividad entre dispositivos","description":"Te dejo usar tu tel\xe9fono para controlar tu computadora.","longDescription":"Conecto tu dispositivo m\xf3vil a tu escritorio para que puedas ejecutar comandos, dictar o navegar f\xe1cilmente. Perfecto para presentaciones, sesiones remotas o uso ocasional."},"quick_action_buttons":{"title":"Botones de acci\xf3n r\xe1pida","description":"Te doy botones compatibles con aplicaciones para acciones r\xe1pidas.","longDescription":"Muestro botones contextuales que se adaptan a tu app. Ya sea para unirte a una reuni\xf3n, enviar un mensaje o crear un correo electr\xf3nico, puedo realizar tareas complejas con solo un clic."},"ai_app_awareness":{"title":"Conciencia de las aplicaciones de IA","description":"Ajusto mis controles en funci\xf3n de la aplicaci\xf3n que est\xe9s usando.","longDescription":"Presto atenci\xf3n a lo que est\xe1 activo en tu pantalla para ofrecerte los controles adecuados en el momento oportuno. Sin desorden ni conjeturas: solo lo que necesitas, cuando lo necesitas. Todo en tu dispositivo y sin enviar datos a la nube."},"ai_rewrite":{"title":"Reescritura de IA","description":"Puedo reescribir su texto para mejorar el tono, actualizar el formato o ampliar los detalles.","longDescription":"Edito textos justo donde trabajas. Puedo hacerlos m\xe1s accesibles, m\xe1s formales, m\xe1s cortos, m\xe1s largos o m\xe1s detallados: lo que necesites para transmitir mejor tu mensaje."},"ai_translation":{"title":"Traducci\xf3n de IA","description":"Puedo traducir entre idiomas o incluso lenguajes de programaci\xf3n.","longDescription":"Te permito convertir texto a otro idioma hablado o c\xf3digo a otro lenguaje de programaci\xf3n. Trabajo desde el sitio, as\xed que no tienes que salir de la aplicaci\xf3n que est\xe1s usando."},"head_mouse":{"title":"Cabeza de rat\xf3n","description":"Te dejo mover el cursor del mouse con movimientos de la cabeza.","longDescription":"Convierto con fluidez el movimiento de tu cabeza en movimiento del cursor. Con funciones como deslizamiento y ajuste de sensibilidad, te ofrezco un control preciso, c\xf3modo y manos libres."},"head_joystick":{"title":"Joystick de cabeza","description":"Te dejo usar tu cabeza como joystick para juegos o aplicaciones.","longDescription":"Mapeo los movimientos de tu cabeza en los ejes del joystick para que puedas jugar o controlar software creativo sin necesidad de hardware. Te mueves con naturalidad y yo lo traduzco a una se\xf1al anal\xf3gica."},"mcp_agent":{"title":"Agente MCP","description":"Puedo conectarme con agentes de IA externos a trav\xe9s del Protocolo de Contexto de Modelo (MCP).","longDescription":"Domino el Protocolo de Contexto de Modelo, lo que me permite trabajar con otros agentes y herramientas de IA. Esto significa que puedo coordinar tareas, intercambiar contexto y ampliar mis capacidades con sistemas externos especializados, todo ello mientras te mantengo al mando."},"byo_ai_integration":{"title":"Trae tu propia IA","description":"Te permito mejorar mi IA existente con tus propios modelos o servicios de IA para usar conmigo.","longDescription":"Si ya cuenta con un servicio, modelo o proveedor de IA de confianza, puedo integrarlo en mi flujo de trabajo. Le doy la flexibilidad de elegir el motor que impulsa la generaci\xf3n, reescritura o traducci\xf3n, ya sea en la nube, local o personalizado. Si no tiene conexi\xf3n o el servicio no est\xe1 disponible, puedo recurrir a mis funciones integradas."},"workflows":{"title":"Flujos de trabajo","description":"Te ayudo a encadenar acciones en flujos de trabajo repetibles.","longDescription":"Te permito dise\xf1ar y ejecutar procesos de varios pasos que conectan diferentes entradas, comandos y salidas. Con los flujos de trabajo, puedes automatizar tareas rutinarias o crear interacciones complejas, activadas por tu voz o gestos, para que yo me encargue del trabajo pesado."},"showMore":"Mostrar m\xe1s","showLess":"Mostrar menos"},"listing":{"title":"Casos de uso","titleLong":"Explora c\xf3mo puedo ayudarte","recommended":"Recomendado para ti","exploreMore":"Explorar m\xe1s casos de uso","description":"Descubre todo lo que puedo hacer para optimizar tu flujo de trabajo. Desde mejoras de productividad hasta asistencia creativa, encuentra los casos de uso perfectos, adaptados a tus necesidades.","all":"Todo","search":"Buscar casos de uso, aplicaciones o capacidades...","noResults":"No se encontraron resultados. Intenta ajustar tu b\xfasqueda o filtros.","emptyAction":"Ver m\xe1s en l\xednea"},"examples":{"universalAppControl":{"title":"Control universal de aplicaciones","description":"Controle cualquier aplicaci\xf3n en su computadora con comandos de voz y automatizaci\xf3n inteligente","descriptionLong":"Controla cualquier aplicaci\xf3n con potentes comandos de voz y automatizaci\xf3n inteligente. Nuestro sistema Universal App Control aprende c\xf3mo trabajas y se adapta a tus necesidades, simplificando las tareas complejas e instant\xe1neamente las acciones rutinarias. Desde la gesti\xf3n de tu suite de productividad hasta el control de aplicaciones multimedia y de juegos, esta funci\xf3n funciona en todo tu entorno digital."},"handsFreeComputerControl":{"title":"Control de computadora manos libres","description":"Control completo por computadora mediante movimientos de cabeza, voz y seguimiento ocular para accesibilidad.","descriptionLong":"Experimente un nuevo nivel de accesibilidad inform\xe1tica con nuestro sistema de control manos libres. Mediante una combinaci\xf3n de seguimiento ocular avanzado, detecci\xf3n precisa del movimiento de la cabeza y comandos de voz, esta funci\xf3n permite a cualquier persona controlar completamente su ordenador sin usar las manos. Perfecto para usuarios con movilidad reducida, personas que realizan m\xfaltiples tareas o quienes desean usar su ordenador de una forma innovadora."},"replyToSocialMediaPosts":{"title":"Publicaciones y respuestas m\xe1s r\xe1pidas en redes sociales con dictado","description":"Responda a cualquier publicaci\xf3n en las redes sociales utilizando el dictado inteligente para obtener respuestas r\xe1pidas.","descriptionLong":"El dictado inteligente de Cephable agiliza la publicaci\xf3n y los comentarios en redes sociales con la funci\xf3n de voz a texto. El dictado funciona en cualquier cuadro de texto o campo de publicaci\xf3n, lo que te permite mantenerte activo en redes sociales sin que te abrumen el d\xeda."},"clinicalNoteTaking":{"title":"Dictado y formato conforme a la HIPAA para m\xe9dicos","description":"Ahorre tiempo tomando notas cl\xednicas entre sesiones con controles de voz inteligentes y dictado. Luego, formatee autom\xe1ticamente las notas en estilo SOAP.","descriptionLong":"\xbfBusca un software de dictado que cumpla con la HIPAA? Cephable ayuda a los profesionales cl\xednicos a documentar r\xe1pidamente las notas de los pacientes con controles de voz inteligentes y formato autom\xe1tico. Cree notas SOAP, informes de progreso y registros, todo con manos libres.","upgrade":{"description":"Actualice para acceder a tareas inteligentes sin conexi\xf3n que cumplen con la normativa HIPAA para formateo e iteraci\xf3n autom\xe1ticos."}},"vibeCoding":{"title":"Del pensamiento al c\xf3digo: dictado para desarrolladores y programadores de Vibe","description":"Vibe Code con dictado y generaci\xf3n de texto con IA para escribir c\xf3digo repetitivo y prototipos m\xe1s r\xe1pido.","descriptionLong":"Cephable Dictation ayuda a los desarrolladores a pasar de la idea al c\xf3digo m\xe1s r\xe1pido. Esta demostraci\xf3n muestra c\xf3mo los comandos de voz pueden generar componentes, paneles y m\xe1s dentro de herramientas como Vercel V0, GitHub Copilot en VS Code, Base 44 y Lovable. Dicte sus ideas y luego perfeccione con c\xf3digo.","upgrade":{"description":"Actualice para acceder a tareas inteligentes sin conexi\xf3n para la reescritura, generaci\xf3n y traducci\xf3n de c\xf3digo dentro de la aplicaci\xf3n."}},"controllingBackgroundMusic":{"title":"Controles multimedia: administra m\xfasica, videos y m\xe1s sin interrumpir tu flujo","description":"Administra tu m\xfasica de fondo usando controles de voz y acciones r\xe1pidas mientras te mantienes concentrado en la tarea actual.","descriptionLong":"Los comandos de voz de Cephable facilitan reproducir, pausar, saltar y controlar el volumen en Spotify sin usar las manos. Los botones de acci\xf3n r\xe1pida y los controles preconfigurados tambi\xe9n funcionan en otras apps como Apple Music, YouTube, Netflix y m\xe1s de 200 apps m\xe1s."},"editingVideos":{"title":"Edici\xf3n de v\xeddeo con voz","description":"Mejore su flujo de trabajo de edici\xf3n de video utilizando controles de voz para navegar, cortar y editar m\xe1s r\xe1pido.","descriptionLong":"Conc\xe9ntrate en la historia, no en los clics. Los controles de voz de Cephable optimizan la edici\xf3n de video con las herramientas que ya usas: Clipchamp, Adobe, iMovie, DaVinci Resolve y m\xe1s. Ediciones m\xe1s r\xe1pidas, menos pasos."},"inboxTriage":{"title":"Asistente de correo electr\xf3nico con IA: automatiza, redacta y responde m\xe1s r\xe1pido","description":"Administre su bandeja de entrada utilizando controles de voz y generaci\xf3n de texto con inteligencia artificial en el dispositivo para clasificar, escribir y editar correos electr\xf3nicos.","descriptionLong":"Agilice el procesamiento de su correo electr\xf3nico con IA privada en el dispositivo. Cephable combina comandos de voz, dictado, botones de acci\xf3n r\xe1pida y generaci\xf3n de texto para que la gesti\xf3n de su bandeja de entrada sea m\xe1s r\xe1pida y sencilla. Elimine correos electr\xf3nicos, cree borradores de respuestas y genere respuestas creativas sin intervenci\xf3n en Outlook, Gmail y m\xe1s.","upgrade":{"description":"Actualice para acceder a tareas inteligentes sin conexi\xf3n para formato autom\xe1tico, generaci\xf3n de contenido, traducciones y m\xe1s."}},"summarizingReports":{"title":"Resuma informes confidenciales con IA privada en el dispositivo","description":"Resuma informes extensos para su equipo mientras mantiene la privacidad y el dispositivo utilizando la generaci\xf3n de texto con inteligencia artificial.","descriptionLong":"Convierta informes extensos en actualizaciones claras para su equipo con la IA integrada en el dispositivo. Cephable extrae puntos y cifras clave y genera res\xfamenes concisos que puede compartir directamente con su equipo. Todo el procesamiento se realiza en su dispositivo, por lo que sus datos confidenciales se mantienen seguros."},"handsFreeMeeting":{"title":"Reduzca la fatiga en las reuniones con controles manos libres","description":"Controle sus reuniones de video usando comandos de voz, botones de acci\xf3n r\xe1pida y dictado inteligente.","descriptionLong":"Mant\xe9n la concentraci\xf3n en las reuniones sin tener que navegar por los men\xfas. Cephable incorpora comandos de voz y botones de acci\xf3n r\xe1pida a Microsoft Teams, Zoom, Google Meet y m\xe1s. Silencia/activa el sonido, activa o desactiva el video, env\xeda mensajes de chat, levanta la mano y navega por las ventanas de la reuni\xf3n sin usar las manos gracias a controles listos para usar que puedes personalizar seg\xfan tu flujo de trabajo."},"spreadsheetReviews":{"title":"Trabaje m\xe1s r\xe1pido en hojas de c\xe1lculo con controles de voz y automatizaci\xf3n de IA","description":"Revise y edite hojas de c\xe1lculo grandes r\xe1pidamente utilizando controles de voz para navegaci\xf3n, formato, filtrado y edici\xf3n.","descriptionLong":"Cephable incorpora controles de voz y botones de acci\xf3n r\xe1pida a Excel, Hojas de C\xe1lculo de Google y otras herramientas de hojas de c\xe1lculo. Revisa, edita, comenta r\xe1pidamente, activa macros y atajos, y personaliza comandos para tu flujo de trabajo. Cientos de controles listos para usar al instante o adaptados a tu configuraci\xf3n."},"socialMediaWriting":{"title":"Creaci\xf3n e investigaci\xf3n de contenido con IA privada en el dispositivo","description":"Redacte y redacte publicaciones en redes sociales utilizando controles de voz y generaci\xf3n de texto con inteligencia artificial para obtener contenido atractivo.","descriptionLong":"Crea contenido de forma segura con la IA integrada de Cephable, sin necesidad de la nube. Genera o reescribe al instante publicaciones en redes sociales, correos electr\xf3nicos, esl\xf3ganes y documentaci\xf3n directamente desde tus herramientas favoritas. Todo se ejecuta localmente, por lo que tu contenido confidencial se mantiene privado y puedes trabajar desde cualquier lugar."},"fpsGamePlay":{"title":"Juega juegos FPS con controles de voz","description":"Juega y personaliza un juego de disparos en primera persona usando controles de voz para moverte, apuntar y disparar.","descriptionLong":"Experimenta una nueva forma de jugar a juegos de disparos en primera persona con controles de voz. Usa tu voz para moverte, apuntar y disparar, lo que te permite una experiencia de juego m\xe1s inmersiva y manos libres."},"customizingGameControls":{"title":"Personalizaci\xf3n de los controles del juego de rol","description":"Personaliza los controles del juego de rol para una mejor accesibilidad y jugabilidad.","descriptionLong":"Personaliza tu experiencia de juego con controles personalizables que mejoran la accesibilidad y la jugabilidad. Ajusta la configuraci\xf3n a tus preferencias y estilo de juego para garantizar una sesi\xf3n de juego c\xf3moda y divertida."},"webBrowsing":{"title":"Navegaci\xf3n web manos libres con Cephable | Planifica viajes, compra online y m\xe1s","description":"Navegue por la web con manos libres utilizando controles de voz para navegar, desplazarse y completar formularios.","descriptionLong":"Busca, compra y planifica sin necesidad de escribir. Los controles de voz inteligentes de Cephable funcionan en cualquier navegador, ya sea para reservar vuelos, comprar en l\xednea o planificar tu pr\xf3ximo viaje."},"documentCode":{"title":"Documentaci\xf3n de c\xf3digo r\xe1pida y segura con generaci\xf3n de texto de IA en el dispositivo","description":"Documente el c\xf3digo sin enviar datos confidenciales a la nube, mientras permanece en la misma aplicaci\xf3n utilizando la reescritura inteligente de Cephable.","descriptionLong":"La reescritura inteligente de Cephable crea documentaci\xf3n para desarrolladores directamente desde el c\xf3digo, sin enviar datos confidenciales a la nube. Genera archivos README, documentaci\xf3n Markdown y referencias de API de forma r\xe1pida y segura, todo dentro de la aplicaci\xf3n."},"generateCode":{"title":"Generaci\xf3n de c\xf3digo r\xe1pida y segura con generaci\xf3n de texto con IA en el dispositivo","description":"Fragmentos de c\xf3digo de prototipo a partir de requisitos de tickets utilizando tareas inteligentes de IA.","descriptionLong":"Cephable te permite convertir los requisitos de los tickets en c\xf3digo funcional en cualquier lenguaje. Usa Tareas Inteligentes para estructurar el c\xf3digo, generar documentaci\xf3n y a\xf1adir pruebas unitarias autom\xe1ticamente. Trabaja con distintos lenguajes de programaci\xf3n y aplicaciones sin perder contexto."},"editingImages":{"title":"Edici\xf3n m\xe1s r\xe1pida en aplicaciones creativas con controles de voz y dictado","description":"Cree y edite im\xe1genes utilizando controles de voz y generaci\xf3n de texto de IA para realizar ajustes y conceptos r\xe1pidos.","descriptionLong":"Da vida a tus ideas visuales con la creaci\xf3n y edici\xf3n de im\xe1genes controladas por voz. Usa la generaci\xf3n de texto con IA para realizar ajustes r\xe1pidos, generar conceptos y mejorar tus im\xe1genes sin necesidad de navegar por men\xfas complejos."},"requirementDocsFromMeeting":{"title":"De notas a documentos de requisitos del producto en minutos mediante IA en el dispositivo","description":"Ahorre horas transformando transcripciones de reuniones sin procesar en documentos estructurados de requisitos de productos en minutos.","descriptionLong":"Cephable transforma las transcripciones de reuniones en documentos estructurados de requisitos de producto en minutos mediante Tareas Inteligentes. Captura r\xe1pidamente las necesidades de productos, marketing y usuarios, y mant\xe9n la privacidad de las conversaciones confidenciales con la IA integrada en el dispositivo. Guarda los resultados como nuevos documentos al instante."},"gamingVoiceControls":{"title":"Control por voz en WoW | Navegaci\xf3n r\xe1pida por men\xfas, JcJ y buscador de mazmorras","description":"Controla tu juego usando comandos de voz para navegar por los men\xfas, iniciar batallas PvP y encontrar mazmorras.","descriptionLong":"Mejora tu experiencia de juego con la gesti\xf3n por voz. Usa sencillos comandos de voz para navegar por los men\xfas, iniciar batallas JcJ y encontrar mazmorras, lo que te permite concentrarte en el juego con total control."},"headMouseMovement":{"title":"Configuraci\xf3n de juegos manos libres con rat\xf3n de cabeza","description":"Controle el cursor del mouse utilizando los movimientos de la cabeza para lograr una navegaci\xf3n y clics precisos.","descriptionLong":"Los controles de cabeza permiten jugar con manos libres. Inclina o gira la cabeza para mover el cursor, personaliza la velocidad y la sensibilidad, y toma el control sin un rat\xf3n tradicional."},"noteTakingAndDocumentation":{"title":"Toma de notas y generaci\xf3n de documentos mediante IA privada en el dispositivo","description":"Tome notas y genere documentos utilizando controles de voz y generaci\xf3n de texto con IA para una escritura eficiente.","descriptionLong":"Optimiza tus notas con dictado inteligente y generaci\xf3n de documentos con IA. Crea r\xe1pidamente borradores, esquemas y documentos impecables para que puedas concentrarte en tus ideas en lugar de en el formato. Todo el procesamiento se realiza en el dispositivo para mayor privacidad y seguridad.","upgrade":{"description":"Actualice para acceder a tareas inteligentes sin conexi\xf3n para formatear, iterar contenido y m\xe1s."}},"presentationControls":{"title":"Controles de presentaci\xf3n manos libres con comandos de voz y acciones r\xe1pidas","description":"Controle sus presentaciones usando comandos de voz para navegar por las diapositivas, iniciar/detener presentaciones y resaltar puntos.","descriptionLong":"Realiza presentaciones con confianza usando comandos de voz. Navega por las diapositivas, inicia y det\xe9n presentaciones y resalta puntos clave, todo sin tocar la computadora."},"designingFliers":{"title":"Dise\xf1o en aplicaciones creativas","description":"Cree y edite dise\xf1os utilizando controles de voz y dictado inteligente para iteraciones m\xe1s r\xe1pidas.","descriptionLong":"Da vida a tu visi\xf3n creativa con herramientas de dise\xf1o controladas por voz. Navega, edita y renueva tus dise\xf1os sin esfuerzo, sin perderte en men\xfas complejos, para que puedas concentrarte en la creatividad, no en los clics."},"motionDesign":{"title":"Comandos de voz para dise\xf1o de movimiento y animaci\xf3n","description":"Anime escenas y controle fotogramas clave mediante comandos de voz intuitivos para un dise\xf1o de movimiento perfecto.","descriptionLong":"Dale movimiento a tus ideas con herramientas de animaci\xf3n controladas por voz. Controla f\xe1cilmente l\xedneas de tiempo, fotogramas clave y efectos con lenguaje natural, para que puedas centrarte en la narrativa y el ritmo visual en lugar de en interfaces complejas."}}}');


var $8adc0445bd2a69d3$exports = {};
$8adc0445bd2a69d3$exports = JSON.parse('{"logo":"Logo c\xe9phable","add":"Ajouter","all":"Tous","edit":"Modifier","create":"Cr\xe9er","delete":"Supprimer","next":"Suivant","previous":"Pr\xe9c\xe9dent","search":"Recherche","loading":"Chargement...","reload":"Recharger","cancel":"Annuler","copy":"Copie","save":"Sauvegarder","saveAndFinish":"Enregistrer et terminer","saveAndContinue":"Sauvegarder et continuer","saved":"Enregistr\xe9","done":"Fait","back":"Dos","play":"Jouer","pause":"Pause","success":"Succ\xe8s","continue":"Continuer","options":"Possibilit\xe9s","share":"Partager","finish":"Finition","finishEdit":"Terminer Modifier","advancedOptions":"Afficher les options avanc\xe9es","authenticating":"Authentification...","skip":"Sauter","close":"Fermer","notFound":"Page non trouv\xe9e","notFoundDescription":"Ah non ! Nous avons fouill\xe9 la mer et nous ne trouvons pas votre page\xa0!","exitSetup":"Quitter la configuration","experimental":"Exp\xe9rimental","letGetStarted":"Commen\xe7ons!","exploreInputControls":"Explorer les contr\xf4les de saisie","when":"Quand je ...","thenMacro":"Cephable fonctionnera...","controls":"Contr\xf4les","welcome":"Accueillir.","beta":"b\xeata","macroEmpty":"Aucune macro ne correspond \xe0 ces crit\xe8res.","you":"Toi","step":"\xc9tape","steps":"Pas","learnMore":"Apprendre encore plus","dangerZone":"Zone dangereuse","connected":"Connect\xe9","notConnected":"Pas connect\xe9","connectAndLearn":"Connectez-vous et apprenez","tryAgain":"Essayer \xe0 nouveau","by":"Par\xa0: {{value}}","noName":"- sans nom -","details":"D\xe9tails","controlFeed":"Alimentation de contr\xf4le","wifi":{"disconnected":"Le Wi-Fi est d\xe9connect\xe9.","connected":"Le Wi-Fi est connect\xe9.","description":"Connectez-vous au Wi-Fi pour permettre \xe0 Cephable de fonctionner avec vos connexions et logiciels. Vos capacit\xe9s d\'utilisation actuelles peuvent \xeatre limit\xe9es."},"signalR":{"disconnected":"La synchronisation est d\xe9connect\xe9e.","action":"Reconnecter","description":"Il semble y avoir un probl\xe8me de synchronisation avec Cephable. Cela pourrait entra\xeener des probl\xe8mes d\'enregistrement de vos param\xe8tres ou de communication avec d\'autres connexions.","disconnectedDevice":"Impossible de synchroniser avec {{name}}.","disconnectedDeviceDescription":"Il semble y avoir un probl\xe8me de synchronisation, probablement li\xe9 \xe0 l\'authentification ou \xe0 la connexion Internet. L\'envoi et la r\xe9ception de donn\xe9es \xe0 distance sont impossibles. Veuillez v\xe9rifier la connexion des deux c\xf4t\xe9s.","connected":"La synchronisation est \xe9tablie.","connectedDescription":"Cephable se synchronise correctement et devrait communiquer avec vos connexions et extensions comme pr\xe9vu.","swap":"Basculer vers la connexion \xe0 l\'appareil local","unlinkedDevice":"Connexion supprim\xe9e.","unlinkedDeviceDescription":"Cette connexion a \xe9t\xe9 dissoci\xe9e de votre compte."},"billing":{"title":"Facturation","expires":"Prochaine facturation\xa0: {{value}}","isEmployeeAccess":{"title":"Professionnel","titleLong":"C\xe9phable Professionnel","short":"Pro","description":"Cephable Professional offre aux utilisateurs plus de puissance de productivit\xe9, en \xe9tendant l\'IA locale et priv\xe9e aux capacit\xe9s g\xe9n\xe9ratives.","supportedFeatures":{"tag":"Tout en Plus, plus","features":["Flux de travail d\'IA embarqu\xe9s","Gestion de l\'organisation d\'entreprise","Restrictions d\'entreprise","Installations illimit\xe9es sur les appareils","Commandes d\'application pr\xe9-entra\xeen\xe9es illimit\xe9es"]}},"isDeveloperAccess":{"title":"Kit de d\xe9veloppement logiciel (SDK)","titleLong":"Kit de d\xe9veloppement logiciel (SDK) Cephable","short":"SDK","description":"Les SDK Cephable vous permettent d\'int\xe9grer de puissants contr\xf4les adaptatifs (voix, visage, t\xeate, etc.) dans votre logiciel avec un minimum d\'effort et un gain maximal.","supportedFeatures":{"tag":"Tout en Plus, plus","features":["Prise en charge de Windows et MacOS","SDK l\xe9gers et int\xe9grables pour la saisie hors ligne de la voix, du visage, de la t\xeate et des actions rapides","Prise en charge API/webhook pour les actions de sortie personnalis\xe9es","Documentation du d\xe9veloppeur","Exemples de projets","Transformez les commandes en automatisation et navigation de documents","Portail des d\xe9veloppeurs pour g\xe9rer vos projets, vos clients d\'authentification, vos types d\'appareils, etc."]}},"isStudentAccess":{"title":"\xc9tudiant","titleLong":"\xc9ducation C\xe9phable","short":"\xc9ducation","description":"Cephable Education favorise l\'apprentissage personnalis\xe9 et les classes inclusives. Cephable fonctionne hors ligne, sur appareil et ne n\xe9cessite aucune int\xe9gration tierce.","supportedFeatures":{"tag":"Tout en Plus, plus","features":["Installations d\'appareils illimit\xe9es","Contr\xf4les d\'application pr\xe9-entra\xeen\xe9s illimit\xe9s","Partage illimit\xe9 des contr\xf4les d\'application personnalis\xe9s"]}},"viewProducts":"Voir les produits","description":"G\xe9rez la facturation de votre organisation, les si\xe8ges, les mises \xe0 niveau d\'abonnement, le renouvellement ou l\'annulation.","view":"G\xe9rer la facturation","isResellerAccess":{"title":"Revendeur","titleLong":"Revendeur Cephable","description":"Cephable Reseller est une licence payante qui vous permet de cr\xe9er de nouvelles organisations et d\'attribuer des cl\xe9s de licence. Cela inclut l\'utilisation de Cephable avec votre propre suite logicielle et l\'am\xe9lioration de votre exp\xe9rience utilisateur.","short":"Revendeur"},"error":"Veuillez contacter votre administrateur syst\xe8me pour g\xe9rer votre facturation.","included":"Inclus avec votre licence {{licenseType}}.","upgrade":{"description":"Effectuez une mise \xe0 niveau maintenant et faites passer vos commandes au niveau sup\xe9rieur.","action":"Mettre \xe0 niveau maintenant","error":"Erreur lors de la mise \xe0 jour. Veuillez r\xe9essayer ult\xe9rieurement.","requiredDetail":"Une licence {{licenseType}} est requise pour cette fonctionnalit\xe9. Vous pouvez passer \xe0 une version sup\xe9rieure ou d\xe9marrer un essai gratuit dans les param\xe8tres de votre compte.","enableTextGeneration":"G\xe9n\xe9rez du contenu en utilisant l\'IA et votre voix.","longDescription":"Passez \xe0 une licence payante pour acc\xe9der \xe0 toutes les fonctionnalit\xe9s de Cephable. Des appareils multiples aux commandes avanc\xe9es en passant par les int\xe9grations personnalis\xe9es, Cephable vous offre tout ce dont vous avez besoin pour atteindre un niveau de productivit\xe9 sup\xe9rieur.","compare":"Comparer les plans","enableAiDictation":{"title":"Passez \xe0 la dict\xe9e intelligente","description":"Effectuez une mise \xe0 niveau pour d\xe9bloquer la dict\xe9e am\xe9lior\xe9e par l\'IA. Je peux ajouter de la ponctuation, corriger les majuscules et m\'adapter \xe0 votre style pour une \xe9criture soign\xe9e sans effort suppl\xe9mentaire."}},"isPlusAccess":{"title":"Plus","titleLong":"Cephable Plus","short":"Plus","description":"Cephable Plus est destin\xe9 aux utilisateurs exp\xe9riment\xe9s qui souhaitent aller plus loin avec une voix intelligente, une dict\xe9e intelligente, des centaines de commandes d\'applications et bien plus encore.","supportedFeatures":{"tag":"Tout dans Basic, plus","features":["Commandes vocales intelligentes (langage naturel)","Dict\xe9e intelligente (am\xe9lior\xe9e par l\'IA)","T\xe2ches intelligentes (G\xe9n\xe9ration, Traduction, R\xe9\xe9criture)","Des centaines de commandes d\'application pr\xe9-entra\xeen\xe9es"]}},"personal":{"short":"Basique","title":"Basique","titleLong":"C\xe9phable Basic","description":"Cephable Basic est gratuit \xe0 vie et con\xe7u pour vous aider \xe0 progresser plus rapidement, \xe0 vous exprimer et \xe0 accomplir vos t\xe2ches \xe0 votre fa\xe7on. Les fonctionnalit\xe9s incluses dans la version Basic sont accessibles \xe0 tous les utilisateurs.","upgrade":{"title":"Passez au niveau sup\xe9rieur en mati\xe8re de contr\xf4le","description":"Passez \xe0 la version Plus ou Pro pour d\xe9bloquer toutes mes fonctionnalit\xe9s. Plus de pr\xe9cision. Plus de connexions. Plus de contr\xf4le. Plus de puissance pour booster votre productivit\xe9.","featureHeading":"Voici comment je peux vous aider :","control":"Je vous guide plus rapidement entre les applications et les outils gr\xe2ce \xe0 votre voix ou \xe0 des actions rapides, sans interruption. Avec la Voix Intelligente, nous pouvons simplement discuter.","create":"Je r\xe9\xe9cris, dicte, g\xe9n\xe8re et traduis directement dans vos applications \u2014 sans copier, coller ni changer d\'\xe9cran.","automate":"J\'ex\xe9cute des t\xe2ches intelligentes et des actions rapides pour optimiser votre flux de travail. Des commandes simples aux macros complexes, je prends en charge les t\xe2ches fastidieuses pour que vous puissiez vous concentrer sur l\'essentiel.","local":"Intelligence artificielle enti\xe8rement locale. Aucun traitement dans le cloud."}},"mostPopular":"Le plus populaire","subscription":{"options":"Options d\'abonnement","monthly":"Payer mensuellement","billedMonthly":"/mois","yearly":"Paiement annuel","billedYearly":"/ann\xe9e"}},"organization":{"title":"Organisation","titlePlural":"Organisations","titleLong":"Professionnel c\xe9phable pour les organisations","description":"Les organisations sont des groupes d\'utilisateurs qui peuvent collaborer sur des projets et partager des ressources. Vous pouvez g\xe9rer votre \xe9quipe, les profils d\u2019\xe9quipe, la facturation et bien plus encore ici.","noAccess":{"title":"Acc\xe8s refus\xe9.","description":"Vos autorisations ont r\xe9cemment chang\xe9 et vous n\'avez plus acc\xe8s \xe0 cette fonctionnalit\xe9. Si vous pensez qu\'il s\'agit d\'une erreur, veuillez contacter l\'administrateur de votre organisation."},"member":{"title":"Membre","titlePlural":"Membres","me":"Mon adh\xe9sion","description":"Les membres sont des utilisateurs qui font partie de votre organisation. Ils peuvent \xeatre affect\xe9s \xe0 diff\xe9rents r\xf4les et avoir acc\xe8s \xe0 diff\xe9rentes parties de l\u2019organisation.","edit":"Modifier les membres","removed":"Vous avez \xe9t\xe9 supprim\xe9 d\'une \xe9quipe.","removedDescription":"Vous avez \xe9t\xe9 retir\xe9 de l\'\xe9quipe. Vous ne pouvez plus acc\xe9der \xe0 l\'organisation. Si vous pensez qu\'il s\'agit d\'une erreur, veuillez contacter l\'administrateur de votre organisation.","updated":"Bravo, l\'adh\xe9sion de {{value}} a \xe9t\xe9 mise \xe0 jour.","error":"Erreur lors de la mise \xe0 jour de l\'adh\xe9sion de {{value}}.","delete":"Succ\xe8s, {{value}} a \xe9t\xe9 supprim\xe9.","deleteError":"Erreur lors de la suppression de {{value}}.","deleteConfirmation":{"title":"Etes-vous s\xfbr de vouloir supprimer ce membre ?","description":"Une fois ce membre supprim\xe9, il n\'aura plus acc\xe8s \xe0 l\'organisation. Vous pourrez toujours le r\xe9inviter plus tard.","confirm":"Oui, supprimer le membre"},"viewAll":{"title":"Voir tous les membres","description":"Affichez tous les membres de votre organisation et g\xe9rez leurs r\xf4les et autorisations."},"seats":{"title":"Si\xe8ges des membres","description":"Chaque membre de votre organisation dispose d\'un si\xe8ge. Le type d\'autorisations dont ils disposent peut \xeatre modifi\xe9 par l\'administrateur de l\'organisation.","stats":"si\xe8ges sur {{value}}","max":"Nombre de places max.","current":"Si\xe8ges actuels","limit":{"title":"Nombre maximal de si\xe8ges atteint","description":"Votre forfait actuel a atteint sa limite de {{ maxSeats }} si\xe8ges disponibles. Vous ne pouvez pas inviter de membres suppl\xe9mentaires. Veuillez contacter votre administrateur pour mettre \xe0 niveau le forfait ou g\xe9rer votre attribution de si\xe8ges."},"updateLimit":{"title":"Mettez \xe0 niveau votre forfait pour ajouter plus de si\xe8ges","description":"Votre forfait actuel a atteint le nombre maximal de si\xe8ges\xa0: {{ maxSeats }}. Effectuez une mise \xe0 niveau d\xe8s maintenant pour d\xe9bloquer des si\xe8ges suppl\xe9mentaires et garantir que votre \xe9quipe puisse continuer \xe0 se d\xe9velopper en toute transparence.","action":"Plan de mise \xe0 niveau"},"maxSeatValue":"Nombre maximal de si\xe8ges\xa0: {{value}}"},"aboutMe":"Sur moi","loadError":"Erreur lors du chargement des membres de l\'organisation.","orgTitle":"Membres de {{value}} ","emailExists":"L\'e-mail existe d\xe9j\xe0 dans l\'organisation. Veuillez saisir une autre adresse e-mail."},"invite":{"title":"Inviter","titlePlural":"Invitations","description":"Des invitations sont envoy\xe9es aux utilisateurs pour qu\'ils rejoignent votre organisation. Vous pouvez inviter des utilisateurs \xe0 rejoindre votre organisation et leur attribuer diff\xe9rents r\xf4les.","edit":"Cr\xe9er une nouvelle invitation","view":"Afficher toutes les invitations","emailRequired":"L\'e-mail est requis","emailInvalid":"Le courriel est invalide. S\'il vous pla\xeet, mettez une adresse email valide.","emailExists":"L\'e-mail dispose d\xe9j\xe0 d\'une invitation d\'organisation. Veuillez saisir une autre adresse e-mail.","emailPlaceholder":"Entrer l\'adresse e-mail","expiration":"Expire ","delete":"Supprimer l\'invitation","confirm":"\xcates-vous s\xfbr de vouloir supprimer cette invitation\xa0?","confirmLong":"Une fois cette invitation supprim\xe9e, l\'utilisateur ne pourra plus rejoindre l\'organisation. Vous pourrez toujours les r\xe9inviter plus tard.","accept":"Accepter l\'invitation","acceptSuccess":{"title":"Bienvenue dans l\'\xe9quipe.","description":"Vous avez rejoint l\'organisation avec succ\xe8s. ","action":"Afficher votre nouvelle organisation"},"acceptError":{"title":"Oops. On dirait qu\'il y a un probl\xe8me.","description":"Une erreur s\'est produite lors de l\'adh\xe9sion \xe0 l\'organisation. Veuillez r\xe9essayer plus tard. Si le probl\xe8me persiste, veuillez contacter l\'administrateur de votre organisation. ","action":"Retour \xe0 la page d\'accueil"},"send":{"success":"Invitation \xe0 {{value}} envoy\xe9e.","error":"Erreur lors de l\'envoi de l\'invitation \xe0 {{value}}.","title":"Envoyer une invitation"},"viewDescription":"Voir toutes les invitations actuelles qui n\'ont pas \xe9t\xe9 accept\xe9es.","new":"Inviter un membre","stat":"invitations actives","noInvites":{"title":"Aucune invitation.","description":"Il semble qu\'il n\'y ait aucune invitation active pour votre organisation."},"error":"Erreur lors du chargement des invitations.","orgTitle":"Invitations de {{ value }}","editDescription":"Cr\xe9ez une nouvelle invitation pour qu\'un utilisateur rejoigne votre organisation."},"role":{"title":"R\xf4le","titlePlural":"Les r\xf4les","description":"Les r\xf4les correspondent aux diff\xe9rents niveaux d\'acc\xe8s dont un utilisateur peut disposer dans votre organisation. Vous pouvez attribuer diff\xe9rents r\xf4les aux utilisateurs pour contr\xf4ler ce qu\'ils peuvent faire."},"isAdmin":{"title":"Administrateur","description":"Les administrateurs ont un acc\xe8s complet \xe0 l\'organisation et peuvent g\xe9rer tous les aspects de l\'organisation.","conflict":"Ce membre est un administrateur. Vous n\'\xeates pas autoris\xe9 \xe0 modifier leurs r\xf4les."},"canViewMembers":{"title":"Afficher les membres","description":"Les utilisateurs disposant de cette autorisation peuvent voir tous les membres de l\'organisation."},"canInviteMembers":{"title":"Inviter des membres","description":"Les utilisateurs disposant de cette autorisation peuvent inviter de nouveaux membres dans l\'organisation et g\xe9rer les invitations existantes."},"canChangeMemberPermissions":{"title":"Modifier les r\xf4les des membres","description":"Les utilisateurs disposant de cette autorisation peuvent modifier le r\xf4le des autres membres de l\'organisation."},"canRemoveMembers":{"title":"Supprimer des membres","titleSingle":"Supprimer un membre","action":"Retirer","description":"Les utilisateurs disposant de cette autorisation peuvent supprimer d\'autres membres de l\'organisation.","confirm":"\xcates-vous s\xfbr de vouloir supprimer ce membre de l\'organisation?","confirmLong":"Une fois que vous aurez supprim\xe9 ce membre, il n\u2019aura plus acc\xe8s \xe0 l\u2019organisation. Vous pourrez toujours les r\xe9inviter plus tard."},"canCreateAuthClients":{"title":"Cr\xe9er des clients d\'authentification","description":"Les utilisateurs disposant de cette autorisation peuvent cr\xe9er de nouveaux clients d\'authentification pour l\'organisation."},"canManageBilling":{"title":"G\xe9rer la facturation","description":"Les utilisateurs disposant de cette autorisation peuvent g\xe9rer les param\xe8tres de facturation de l\'organisation.","error":"Vous n\'\xeates pas autoris\xe9 \xe0 g\xe9rer la facturation de cette organisation."},"metrics":{"lineChart":{"title":"Connexions Simultan\xe9es Moyennes","description":"Ce graphique montre les connexions simultan\xe9es moyennes pour l\'organisation et les donn\xe9es du projet au fil du temps.","max":"Connexions Max: {{maxConnections}}","project":"Total du Projet","org":"Organisation Total"},"title":"M\xe9trique","description":"Les m\xe9triques sont des points de donn\xe9es qui vous aident \xe0 comprendre comment votre organisation utilise Cephable.","view":"Afficher les m\xe9triques","orgTitle":"M\xe9triques de {{ valeur }}","manage":{"title":"Indicateurs de performance","description":"T\xe9l\xe9chargez ou effacez les mesures de performances collect\xe9es lors de l\u2019inf\xe9rence du mod\xe8le."},"download":{"button":"T\xe9l\xe9charger les m\xe9triques","success":"Le fichier de m\xe9triques a \xe9t\xe9 enregistr\xe9 dans votre dossier T\xe9l\xe9chargements.","error":"\xc9chec du t\xe9l\xe9chargement du fichier de m\xe9triques.","noFile":"Aucun fichier de m\xe9triques trouv\xe9. Essayez d\'abord d\'ex\xe9cuter le mod\xe8le."},"clear":{"button":"Des indicateurs clairs","success":"Les m\xe9triques ont \xe9t\xe9 effac\xe9es.","error":"\xc9chec de l\'effacement du fichier de m\xe9triques.","confirm":{"title":"Indicateurs de performance clairs","description":"Voulez-vous vraiment effacer tous les indicateurs de performance enregistr\xe9s\xa0? Cette action est irr\xe9versible.","cancel":"Annuler","confirm":"Des indicateurs clairs"}}},"noOrg":{"title":"Aucune licence associ\xe9e.","description":"Vous n\'\xeates actuellement associ\xe9 \xe0 aucune licence ni \xe0 aucun groupe de d\xe9veloppeurs. L\'acc\xe8s au portail est r\xe9serv\xe9 aux utilisateurs disposant d\'une licence Cephable payante. Pour exploiter pleinement le potentiel de Cephable, commencez un essai gratuit."},"projects":{"title":"Projets","description":"Utilisez des projets pour g\xe9rer l\'acc\xe8s s\xe9curis\xe9, configurer les interactions des appareils et rationaliser la mani\xe8re dont vos applications envoient et re\xe7oivent des commandes sur diff\xe9rentes plates-formes.","name":"Nom de l\'application","stats":{"title":"Statistiques du projet","connections":"Connexions totales","all":{"title":"Toutes les mesures du projet","description":"M\xe9triques agr\xe9g\xe9es pour tous les projets associ\xe9s \xe0 {{ orgName }}"},"card":"projets sur {{value}}","users":"nombre total d\'utilisateurs depuis {{date}}","avgUsers":"Nombre moyen mensuel d\'utilisateurs.","concurrent":{"title":"Nombre moyen de connexions simultan\xe9es au cours des {{days}} derniers jours","label":"Moy. simultan\xe9e","max":"Connexions maximales","overage":"Exc\xe9dent","description":"Les connexions simultan\xe9es correspondent au nombre d\'utilisateurs connect\xe9s \xe0 votre projet en m\xeame temps. Cette mesure vous aide \xe0 comprendre combien d\'utilisateurs utilisent votre application simultan\xe9ment."}},"projectType":{"title":"Type de projet","description":"Les types de projets sont utilis\xe9s pour cat\xe9goriser vos projets et nous aider \xe0 choisir les SDK qui vous conviennent."},"accessDenied":{"generic":"Vous n\'avez pas acc\xe8s \xe0 ce projet.","title":"Acc\xe8s refus\xe9.","description":"Vous n\'avez pas acc\xe8s aux projets pour les consulter, les cr\xe9er, les modifier ou les supprimer. Veuillez contacter votre administrateur pour y acc\xe9der."},"upgrade":{"title":"Mise \xe0 niveau vers le SDK Cephable","description":"Cephable peut \xeatre int\xe9gr\xe9 directement dans votre application, jeu ou service \xe0 l\'aide de nos SDK. Les projets ne sont actuellement pas disponibles avec votre compte. Si vous pensez qu\'il y a une erreur, veuillez contacter support@cephable.com.","shortDescription":"Les projets ne sont actuellement pas disponibles avec votre compte. Contactez-nous pour effectuer une mise \xe0 niveau."},"limit":{"title":"Vous voulez plus de projets ?","error":"Limite du projet atteinte.","description":"Vous avez atteint le nombre maximum de projets pour votre organisation. Veuillez contacter votre administrateur pour mettre \xe0 niveau votre compte."},"create":{"title":"Cr\xe9er un projet","titleLong":"Commen\xe7ons.","first":{"title":"D\xe9marrez votre projet.","description":"Il semble que vous n\'ayez pas encore cr\xe9\xe9 de projet. Les cl\xe9s et les appareils clients sont essentiels pour s\xe9curiser la communication entre vos applications et nos services. Avec une cl\xe9 client, vous pourrez int\xe9grer les commandes vocales et de mouvement de la t\xeate dans vos applications rapidement et en toute s\xe9curit\xe9."},"details":{"title":"D\xe9tails du projet","description":"Cr\xe9ez un nouveau projet pour g\xe9rer l\'autorisation de votre application, les fonctionnalit\xe9s de votre appareil et les int\xe9grations SDK. Suivez les \xe9tapes ci-dessous pour configurer des interactions s\xe9curis\xe9es et personnalisables pour vos utilisateurs."}},"sdk":{"title":"T\xe9l\xe9charger le SDK","description":"Acc\xe9dez \xe0 notre puissant SDK d\xe9velopp\xe9 pour faciliter les contr\xf4les adaptatifs.","select":{"title":"S\xe9lectionner le SDK","description":"S\xe9lectionnez le SDK que vous souhaitez utiliser pour ce projet. Nos SDK permettent une int\xe9gration transparente des commandes adaptatives de voix et de mouvement de la t\xeate sur diff\xe9rentes plateformes."}},"clients":{"title":"Autorisation des clients","description":"Les clients d\'autorisation g\xe8rent l\'acc\xe8s s\xe9curis\xe9 \xe0 vos applications. D\xe9finissez un client d\'autorisation pour authentifier les utilisateurs et contr\xf4ler les interactions avec votre application.","settings":"Param\xe8tres d\'autorisation","configure":"Configurer le client d\'autorisation","create":"Cr\xe9er un client d\'autorisation","max":"Projets max\xa0: {{value}}"},"secret":{"title":"Secret du client","created":"Votre secret client a \xe9t\xe9 cr\xe9\xe9.","description":"Votre secret client ne sera affich\xe9 qu\'une seule fois. Copiez-le maintenant et stockez-le dans un endroit s\xfbr et s\xe9curis\xe9. <br> <br> Utilisez-le uniquement pour votre propre d\xe9veloppement. Ne le partagez pas avec des services ou des applications tiers.","copy":"Copie secr\xe8te","rotate":{"title":"Faire pivoter le secret client","description":"AVERTISSEMENT\xa0: cette action r\xe9voquera votre secret client existant et cr\xe9era un nouveau secret client. Cela vous obligera \xe0 mettre \xe0 jour toutes vos utilisations existantes dans toutes vos applications. Cette action ne peut pas \xeatre annul\xe9e.","error":"Erreur lors de la rotation du secret. Veuillez r\xe9essayer plus tard."}},"key":{"title":"Cl\xe9 client","view":"Afficher la cl\xe9 client","delete":{"title":"Supprimer la cl\xe9 client","description":"AVERTISSEMENT\xa0: cette action supprimera votre cl\xe9 client existante et tous les param\xe8tres associ\xe9s. Cette action ne peut pas \xeatre annul\xe9e.","error":"Erreur lors de la suppression de votre cl\xe9 client.","success":"Votre projet a \xe9t\xe9 supprim\xe9."},"copy":"Copier la cl\xe9"},"tokenRedirect":{"title":"URL de redirection de jeton","description":"Les URL de redirection de jetons sont les points de terminaison o\xf9 les jetons d\'acc\xe8s sont envoy\xe9s une fois l\'authentification termin\xe9e. Ces URL permettent \xe0 votre application de recevoir en toute s\xe9curit\xe9 les jetons n\xe9cessaires pour acc\xe9der aux donn\xe9es et services utilisateur."},"authRedirect":{"title":"URL de redirection du code d\'autorisation","description":"L\'URL de redirection AuthCode est le point de terminaison o\xf9 les codes d\'autorisation sont envoy\xe9s apr\xe8s qu\'un utilisateur a accord\xe9 l\'autorisation \xe0 votre application. Cette URL est essentielle dans les flux OAuth, car elle garantit la transmission s\xe9curis\xe9e du code d\'autorisation du serveur d\'autorisation \xe0 votre application, vous permettant ainsi de demander des jetons d\'acc\xe8s au nom de l\'utilisateur."},"scopes":{"title":"Port\xe9es","titleLong":"Port\xe9es des autorisations API","configure":"D\xe9finir les p\xe9rim\xe8tres","description":"Les port\xe9es d\xe9finissent les autorisations dont disposera ce client d\'autorisation. D\xe9finissez des port\xe9es pour limiter l\'acc\xe8s \xe0 des donn\xe9es et fonctionnalit\xe9s sp\xe9cifiques, en veillant \xe0 ce que les utilisateurs n\'obtiennent que l\'acc\xe8s dont ils ont besoin.","manage":"G\xe9rer les port\xe9es d\'autorisation"},"deviceScopes":{"title":"Types d\'appareils associ\xe9s","titleLong":"Types d\'appareils autoris\xe9s","action":"Ajouter un nouveau type d\'appareil","configure":"Configurer les types d\'appareils autoris\xe9s","descriptionShort":"D\xe9finissez quel type d\u2019appareils peuvent acc\xe9der \xe0 ce projet.","titles":"Types d\'appareils associ\xe9s","description":"Le type d\'appareil d\xe9finit les autorisations et les niveaux d\'acc\xe8s dont dispose un appareil dans votre application. En attribuant des types d\'appareils sp\xe9cifiques, vous pouvez contr\xf4ler les actions et les donn\xe9es auxquelles chaque appareil peut acc\xe9der, garantissant ainsi que votre application reste s\xe9curis\xe9e et conforme \xe0 vos politiques de confidentialit\xe9."},"deviceType":{"title":"Types d\'appareils","description":"Un DeviceType d\xe9finit une cat\xe9gorie d\'appareils, d\xe9taillant leurs capacit\xe9s d\'entr\xe9e/sortie et les fonctionnalit\xe9s prises en charge (par exemple, la voix, les gestes, les types de contr\xf4leur). Il garantit que seuls les appareils autoris\xe9s peuvent interagir avec une application, permettant un acc\xe8s limit\xe9 via des configurations d\'appareils sp\xe9cifiques, telles que Xbox ou PlayStation.","action":"Cr\xe9er un type d\'appareil","name":"Nom du type d\'appareil","descriptionLong":"Description du type d\'appareil","features":{"title":"Fonctionnalit\xe9s prises en charge","description":"D\xe9finissez les entr\xe9es et les sorties prises en charge par votre application. Cela nous aide \xe0 optimiser l\'exp\xe9rience utilisateur sur Cephable.","supportsVoiceInput":"Saisie vocale","supportsPhysicalInput":"Entr\xe9e physique","supportsKeyboardOutput":"Sortie clavier","supportsPlayStationControllerOutput":"Manette PlayStation","supportsFaceInput":"Saisie faciale","supportsGestureInput":"Saisie gestuelle","supportsXboxControllerOutput":"Manette Xbox","supportsDigitalExtensions":"Extensions num\xe9riques","supportsPhysicalExtensions":"Extensions physiques","supportsNintendoControllerOutput":"Manette Nintendo","supportsGenericControllerOutput":"Sortie du contr\xf4leur g\xe9n\xe9rique"},"canAutoStart":{"title":"Prend en charge les d\xe9marrages \xe0 contr\xf4le automatique","description":"[canAutoStart] si activ\xe9, le SDK v\xe9rifiera les param\xe8tres utilisateur et tentera de d\xe9marrer imm\xe9diatement les commandes de la cam\xe9ra ou du microphone apr\xe8s la connexion de l\'utilisateur."},"isSupported":{"title":"Actif","description":"[isSupported] Si cette option est d\xe9sactiv\xe9e, Cephable n\'enverra, ne recevra et n\'accusera r\xe9ception d\'aucun appareil utilisateur associ\xe9 \xe0 cette option. \xc9quivalent \xe0 obsol\xe8te."},"locale":{"title":"Langue par d\xe9faut","description":"[defaultLocale] Param\xe8tres r\xe9gionaux par d\xe9faut pour ce type d\'appareil. Ils seront utilis\xe9s comme langue par d\xe9faut pour l\'appareil.","support":"Langues prises en charge","warn":"** Il semble que vous ayez configur\xe9 des contr\xf4les personnalis\xe9s. Veuillez vous assurer que vous avez mis \xe0 jour les contr\xf4les personnalis\xe9s pour les langues associ\xe9es.**","name":"{{lang}} - Nom du type d\'appareil","langDescription":"{{lang}} - Description"},"customControls":{"title":"Contr\xf4les personnalis\xe9s","object":"{{lang}} - Objet de contr\xf4les personnalis\xe9s","description":"Les contr\xf4les personnalis\xe9s sont une option avanc\xe9e permettant aux utilisateurs de configurer et de modifier manuellement les contr\xf4les d\'application associ\xe9s \xe0 cet appareil. Si vous souhaitez que les utilisateurs contr\xf4lent votre appareil directement depuis Cephable, vous devez enregistrer les contr\xf4les de votre appareil ici. Consultez l\'API Cephable pour plus de d\xe9tails sur les options."},"success":{"title":"Succ\xe8s!","description":"Vous avez cr\xe9\xe9 un nouveau type d\'appareil. {{name}} Vous pouvez d\xe9sormais mettre \xe0 jour la port\xe9e de votre appareil client d\'autorisation selon vos besoins."},"id":"ID du type d\'appareil","throttleRules":{"title":"R\xe8gles de commande des gaz","description":"Configurez les r\xe8gles de limitation pour contr\xf4ler le flux des commandes et les restrictions d\'entr\xe9e pour ce type de p\xe9riph\xe9rique.","disableVoiceInput":"D\xe9sactiver la saisie vocale","disableHotkeyInput":"D\xe9sactiver la saisie par raccourci clavier","disableCameraInput":"D\xe9sactiver l\'entr\xe9e cam\xe9ra","disableMultiInputs":"D\xe9sactiver les entr\xe9es multiples","maximumCommandsPerSecond":"Nombre maximal de commandes par seconde","maximumCommandsPerMinute":"Nombre maximal de commandes par minute","maximumMacroLength":"Longueur maximale des macros"}},"view":"Voir les projets","error":"Erreur lors du chargement des projets.","type":{"title":"Type d\'impl\xe9mentation"},"originHost":{"title":"H\xf4te d\'origine","description":"L\'URL qui servira de source principale pour la demande et les donn\xe9es lors des interactions API."},"orgTitle":"Projets de {{ valeur }}"},"viewOrganization":"Voir L\'organisation","update":"Votre organisation a \xe9t\xe9 mise \xe0 jour\xa0! Actualisation de l\'application.","error":"Erreur lors du chargement de l\'organisation. Veuillez r\xe9essayer ult\xe9rieurement.","new":{"name":{"label":"Nom de l\'organisation","placeholder":"Entrez le nom de votre organisation"},"description":{"label":"Description de l\'organisation","placeholder":"Quels sont vos objectifs en utilisant Cephable Professional ?"},"details":"D\xe9tails de l\'organisation"},"expired":{"user":"Il semblerait que votre licence Cephable ait expir\xe9. Vous \xeates donc pass\xe9 \xe0 la version gratuite Cephable Basic. Pour la renouveler, veuillez contacter l\'administrateur de votre organisation.","admin":"Il semblerait que votre licence Cephable ait expir\xe9. Vous \xeates donc pass\xe9 \xe0 la version gratuite Cephable Basic. Veuillez renouveler votre licence pour continuer \xe0 utiliser les fonctionnalit\xe9s avanc\xe9es.","multiple":"Il semblerait que vos licences Cephable aient expir\xe9. Vous \xeates donc pass\xe9 \xe0 la version gratuite Cephable Basic. Veuillez renouveler au moins une de vos licences pour continuer \xe0 utiliser les fonctionnalit\xe9s avanc\xe9es.","dialog":{"title":"S\xe9lectionnez une organisation","description":"Plusieurs organisations sont associ\xe9es \xe0 votre compte. Veuillez s\xe9lectionner l\'organisation que vous souhaitez renouveler."},"title":"Votre licence Cephable a expir\xe9","titlePlural":"Vos licences Cephable ont expir\xe9","banner":"Il semblerait que votre licence Cephable ait expir\xe9. Vous \xeates donc pass\xe9 \xe0 la version gratuite Cephable Basic. En renouvelant votre licence, vous b\xe9n\xe9ficierez de fonctionnalit\xe9s suppl\xe9mentaires telles que les commandes vocales am\xe9lior\xe9es, les t\xe2ches intelligentes bas\xe9es sur l\'IA et de nombreuses commandes d\'applications pr\xe9d\xe9finies."},"orgName":"Nom de l\'organisation","menu":{"title":"Menu Organisation","view":"Voir le menu","expand":"D\xe9velopper le menu"},"settings":{"title":"Param\xe8tres de l\'organisation","description":"G\xe9rez la facturation, le nom, la description et les ressources de votre organisation.","view":"Afficher les param\xe8tres","general":{"title":"G\xe9n\xe9ral"},"resources":{"edit":"Modifier les ressources","description":"Utilisez l\'\xe9diteur Markdown sur la gauche pour mettre \xe0 jour et formater des ressources utiles pour tous les membres de l\'organisation. Au fur et \xe0 mesure que vous saisissez du texte, l\'aper\xe7u sur la droite montre comment votre contenu appara\xeetra aux utilisateurs. Vous pouvez ajouter des titres, des listes, des liens et d\'autres \xe9l\xe9ments de mise en forme \xe0 l\'aide de la syntaxe Markdown. Les modifications seront visibles pour les membres une fois enregistr\xe9es."},"other":{"title":"Autres param\xe8tres","description":"G\xe9rez la facturation, le nom, la description et les ressources de votre organisation."}},"managed":{"title":"Organisation g\xe9r\xe9e","titlePlural":"Organisations g\xe9r\xe9es","description":"Les organisations g\xe9r\xe9es sont des organisations g\xe9r\xe9es par un revendeur Cephable. Les revendeurs peuvent g\xe9rer votre \xe9quipe, les profils d\'\xe9quipe, la facturation et bien plus encore ici.","error":"Erreur lors du chargement des organisations g\xe9r\xe9es.","empty":{"title":"Aucune organisation g\xe9r\xe9e trouv\xe9e.","description":"Il ne semble pas qu\'aucune organisation g\xe9r\xe9e ne corresponde \xe0 ces crit\xe8res. Ou vos cl\xe9s de licence n\'ont pas encore \xe9t\xe9 activ\xe9es."},"titleShort":"G\xe9r\xe9"},"canManageChildOrganizations":{"title":"G\xe9rer les organisations pour enfants","description":"Les utilisateurs disposant de cette autorisation peuvent cr\xe9er et g\xe9rer des organisations enfants en tant qu\u2019administrateur."},"canViewAnalytics":{"title":"Voir les analyses","description":"Les utilisateurs disposant de cette autorisation peuvent afficher les mesures et les analyses de l\u2019organisation."},"create":"Cr\xe9er une nouvelle organisation","orgCustomBillingUrl":{"title":"URL de facturation personnalis\xe9e","description":"Il s\'agit d\'une URL personnalis\xe9e qui sera utilis\xe9e pour rediriger l\'utilisateur vers votre syst\xe8me de facturation (celui du revendeur). Doit commencer par \xab https:// \xbb ou \xab mailTo\xa0: \xbb"},"upgrade":{"existing":{"title":"Vous faites partie d\'une licence existante.","description":"Veuillez effectuer une mise \xe0 niveau en cliquant sur \xab\xa0{{action}}\xa0\xbb dans le menu lat\xe9ral."}},"restrictions":{"isGenAIDisabled":{"title":"IA g\xe9n\xe9rative d\xe9sactiv\xe9e","description":"Votre organisation a d\xe9sactiv\xe9 l\'acc\xe8s aux fonctionnalit\xe9s d\'IA g\xe9n\xe9rative. Veuillez contacter l\'administrateur de votre organisation pour plus d\'informations."},"isRemoteControlDisabled":{"title":"Synchronisation entre appareils d\xe9sactiv\xe9e","description":"Votre organisation a d\xe9sactiv\xe9 l\'acc\xe8s \xe0 la synchronisation. Vous ne pourrez donc pas utiliser notre application compagnon ni contr\xf4ler les appareils externes. Veuillez contacter l\'administrateur de votre organisation pour plus d\'informations."}},"troubleshooting":{"title":"D\xe9pannage","editorDescription":"[Facultatif] Cette section est visible par tous les utilisateurs via la page des d\xe9tails de connexion dans les applications mobiles et de bureau Cephable.","description":"Si vous rencontrez des probl\xe8mes avec Cephable, essayez les \xe9tapes ci-dessous pour r\xe9soudre les probl\xe8mes courants."},"onboarding":{"title":"Int\xe9gration","editorDescription":"[Facultatif] Un message d\'accueil s\'affiche lorsque ce type d\'appareil est ajout\xe9 \xe0 votre compte. C\'est l\'endroit id\xe9al pour fournir des instructions sur la configuration et l\'utilisation de cet appareil avec votre application."},"documents":"Documents","completionStatus":{"title":"\xc9tat d\'ach\xe8vement","error":"","complete":"Complet.","incomplete":"Incomplet."},"metadata":{"title":"M\xe9tadonn\xe9es","urlError":"L\'URL doit commencer par http:// ou https://","metatitle":{"label":"Meta Title","placeholder":"Saisissez un titre court"},"shortDescription":{"label":"Description courte","placeholder":"Saisissez une br\xe8ve description (150 caract\xe8res maximum)"},"externalLink":{"label":"URL du lien externe","placeholder":"https://example.com/device-info","description":"Un lien direct vers un site web ou une ressource externe fournissant des informations suppl\xe9mentaires sur la premi\xe8re configuration de cet appareil. Si vous utilisez ce lien, nous n\'utiliserons pas le balisage Markdown de la liste des clients."},"iconUrl":{"label":"URL de l\'ic\xf4ne de l\'appareil","placeholder":"https://example.com/device-icon.png","description":"Lien direct vers une image repr\xe9sentant ce type d\'appareil. Cette ic\xf4ne sera affich\xe9e dans l\'application Cephable et sur les listes d\'appareils."},"darkModeIconUrl":{"label":"URL de l\'ic\xf4ne de l\'appareil en mode sombre","placeholder":"https://example.com/device-icon-dark.png","description":"Lien direct vers une image repr\xe9sentant ce type d\'appareil en mode sombre. Cette ic\xf4ne s\'affichera dans l\'application Cephable et sur les listes d\'appareils lorsque le mode sombre est activ\xe9."},"editorDescription":"Lorsque votre appareil est s\xe9lectionn\xe9 pour figurer dans l\'application Cephable en tant qu\'extension ou connexion, nous utilisons ces informations pour les afficher aux utilisateurs qui configurent de nouvelles connexions."},"client-listing":{"title":"Liste des clients","editorDescription":"Instructions d\xe9taill\xe9es pour les nouveaux utilisateurs afin de configurer des connexions avec ce type d\'appareil. Ce texte s\'affichera dans l\'application Cephable lors de l\'ajout d\'une nouvelle connexion."},"canAccessOrganizationProfiles":{"title":"Afficher les commandes de l\'application Organisation","description":"Les utilisateurs disposant de cette autorisation peuvent consulter les commandes de l\'application d\'organisation associ\xe9es \xe0 cette organisation."},"canEditOrganizationProfiles":{"title":"G\xe9rer les contr\xf4les de l\'application de l\'organisation","description":"Les utilisateurs disposant de cette autorisation peuvent cr\xe9er, modifier et supprimer les contr\xf4les d\'application d\'organisation associ\xe9s \xe0 cette organisation."},"profiles":{"title":"Contr\xf4les de l\'application Organisation","description":"Les contr\xf4les d\'application d\'organisation sont des profils partag\xe9s permettant de distribuer les contr\xf4les d\'application au sein de votre organisation ou de les partager avec vos utilisateurs d\'int\xe9gration.","view":"Afficher les commandes de l\'application Organisation","editDescription":"Modifiez les commandes de l\'application d\'organisation pour personnaliser les param\xe8tres.","empty":"Aucune application de contr\xf4le d\'organisation trouv\xe9e. Cr\xe9ez-en une pour commencer.","error":"Erreur lors du chargement des commandes de l\'application d\'organisation.","titleShort":"Commandes de l\'application"},"canViewAuthClients":{"title":"Voir les projets","description":"Les utilisateurs disposant de cette autorisation peuvent consulter les clients d\'authentification et les projets de l\'organisation."}},"customControls":{"title":"Contr\xf4les globaux et des appareils","prefixDisclaimer":" Il s\'agit d\'un contr\xf4le de pr\xe9fixe\xa0; il \xe9coutera les mots apr\xe8s la commande, puis recherchera la phrase suivante pour trouver des correspondances.","allowPausedDisclaimer":" Cette commande fonctionnera m\xeame lorsque le microphone est en pause.","conflictIndicators":{"warn":"Avertissement: ","title":"Conflits de configuration d\'entr\xe9e d\xe9tect\xe9s","globalControls":"Conflits de configuration de contr\xf4le global","deviceControls":"Conflits de configuration du contr\xf4le des p\xe9riph\xe9riques","usedInput":" est utilis\xe9 comme entr\xe9e pour ","description":"Certaines entr\xe9es de vos contr\xf4les globaux et d\'appareil sont \xe9galement utilis\xe9es dans un ou plusieurs de vos contr\xf4les d\'application. Cela peut entra\xeener des conflits avec Cephable. Dans ce cas, nous privil\xe9gierons toujours le contr\xf4le d\'application par rapport au contr\xf4le global ou d\'appareil.","item":"L&#39;entr\xe9e <strong>{{value}}</strong> est utilis\xe9e dans les contr\xf4les de votre application\xa0: ","globalDescription":"Les contr\xf4les globaux suivants ont des entr\xe9es en conflit avec les contr\xf4les de votre application.","deviceDescription":"Les commandes de l\'appareil suivantes ont des entr\xe9es en conflit avec les commandes de votre application."},"globalControls":{"title":"Contr\xf4les globaux","empty":"Vous n\'avez pas encore de contr\xf4les globaux. Cliquez ci-dessous pour en cr\xe9er un.","edit":"Modifier les contr\xf4les globaux","description":"Les commandes globales sont toujours disponibles, quels que soient les contr\xf4les de l\'application ou l\'appareil utilis\xe9. Certaines fonctionnent m\xeame lorsque les commandes de votre microphone ou de votre appareil photo sont en pause."},"deviceControls":{"title":"Contr\xf4les des appareils","empty":"Vous n\'avez pas encore de commandes d\'appareil. Cliquez ci-dessous pour en cr\xe9er un.","edit":"Modifier les contr\xf4les de l\'appareil","controls":{"cephable-open-app":{"success":"Ouvrir l\'application\xa0: {{value}}","error":"Impossible de trouver l\'application\xa0: {{value}}"},"cephable-close-app":{"commands":["fermer"],"name":"Fermer l\'application par nom","description":"Utilisez cette commande avec les commandes vocales pour fermer une application sur votre ordinateur par son nom.","success":"Fermer l\'application\xa0: {{value}}","error":"Impossible de trouver l\'application\xa0: {{value}}"},"cephable-minimize-focused-app":{"commands":["minimiser"],"name":"R\xe9duire l\'application actuellement s\xe9lectionn\xe9e.","description":"Utilisez cette commande avec les commandes vocales pour minimiser l\u2019application actuellement s\xe9lectionn\xe9e.","success":"Minimisez le succ\xe8s des applications cibl\xe9es\xa0!","error":"Erreur lors de la minimisation de l\'application focalis\xe9e."},"cephable-maximize-focused-app":{"commands":["maximiser"],"name":"Maximisez l\'application actuellement s\xe9lectionn\xe9e.","description":"Utilisez cette commande avec les commandes vocales pour maximiser l\'application actuellement s\xe9lectionn\xe9e.","success":"Maximisez le succ\xe8s de votre application cibl\xe9e\xa0!","error":"Erreur lors de la minimisation de l\'application focalis\xe9e."},"cephable-generate-text":{"commands":["g\xe9n\xe9rer"],"name":"G\xe9n\xe9rez du texte en fournissant l\'invite suivant cette commande.","description":"Utilisez cette commande avec des commandes vocales suivies de votre invite pour g\xe9n\xe9rer du texte associ\xe9."},"cephable-stop-generate-text":{"commands":["arr\xeater de g\xe9n\xe9rer","arr\xeater la g\xe9n\xe9ration","annuler g\xe9n\xe9rer","annuler la g\xe9n\xe9ration"],"name":"Arr\xeatez de g\xe9n\xe9rer du texte.","description":"Utilisez cette commande avec les commandes vocales pour arr\xeater de g\xe9n\xe9rer du texte"},"cephable-open-panel":{"commands":["afficher le panneau"],"name":"Ouvrir le panneau Cephable","description":"Utilisez cette commande avec les commandes vocales pour ouvrir le panneau Cephable."},"cephable-close-panel":{"commands":["masquer le panneau"],"name":"Masquer le panneau Cephable","description":"Utilisez cette commande avec les commandes vocales pour masquer ou r\xe9duire le panneau Cephable."},"cephable-close-focused-app":{"commands":["courant proche"],"name":"Fermez l\'application actuellement s\xe9lectionn\xe9e.","description":"Utilisez cette commande avec les commandes vocales pour fermer l\u2019application actuellement s\xe9lectionn\xe9e.","success":"Fermer l\'application actuelle avec succ\xe8s\xa0!","error":"Erreur lors de la fermeture de l\'application actuelle."},"cephable-rewrite-text":{"commands":["r\xe9crire"],"name":"R\xe9\xe9crivez le texte en fournissant l\'invite suivant cette commande.","description":"Utilisez cette commande avec les commandes vocales suivies de votre invite pour r\xe9\xe9crire votre texte en surbrillance actuel."},"cephable-summarize-text":{"commands":["r\xe9sumer"],"name":"R\xe9sumez le texte en fournissant l\u2019invite suivant cette commande.","description":"Utilisez cette commande avec les commandes vocales suivies de votre invite pour r\xe9sumer votre texte actuellement en surbrillance."},"cephable-translate-text":{"commands":["traduire"],"name":"Traduisez le texte en fournissant l\'invite suivant cette commande.","description":"Utilisez cette commande avec les commandes vocales suivies de votre invite pour traduire votre texte actuellement en surbrillance."},"cephable-click-by-name":{"commands":["robinet","frapper","naviguer vers","aller \xe0"],"name":"Appuyez sur l\'\xe9l\xe9ment par nom","description":"Appuyez sur un \xe9l\xe9ment de la page par son nom, par exemple \xab\xa0appuyer sur Enregistrer\xa0\xbb pour cliquer sur un bouton nomm\xe9 \xab\xa0Enregistrer\xa0\xbb."}},"description":"Les commandes de l\'appareil sont li\xe9es \xe0 l\'appareil ou \xe0 la connexion que vous utilisez. Elles sont disponibles sans avoir \xe0 les ajouter aux commandes de votre application et sont particuli\xe8rement utiles pour les fonctionnalit\xe9s ou \xe9v\xe9nements uniquement pris en charge sur certains appareils."},"resetControls":{"title":"R\xe9initialiser les Commandes","description":"La langue de votre voix a chang\xe9 depuis la derni\xe8re mise \xe0 jour de vos commandes. Remarque\xa0: cette op\xe9ration r\xe9initialisera vos commandes pour qu\'elles correspondent \xe0 {{language}} et vous risquez de perdre toutes les commandes personnalis\xe9es. \xcates-vous s\xfbr de vouloir r\xe9initialiser\xa0?","confirm":"Oui, r\xe9initialiser les commandes","error":"Une erreur s\'est produite lors de la r\xe9initialisation de vos commandes. Veuillez r\xe9essayer ult\xe9rieurement."},"warn":"Le microphone n\'est pas activ\xe9. Vous devez activer votre microphone pour utiliser les commandes globales et celles de l\'appareil.","changeProfile":{"success":"Modifier les contr\xf4les de l\'application\xa0: {{value}}","error":"Impossible de trouver les contr\xf4les de l\'application\xa0: \xab\xa0{{value}}\xa0\xbb"},"descriptionShort":"Les commandes globales et d\'appareil sont des actions toujours disponibles, con\xe7ues pour fonctionner avec tous les logiciels. Les commandes globales, comme \xab\xa0Arr\xeater la cam\xe9ra\xa0\xbb, sont applicables \xe0 l\'ensemble du syst\xe8me et ind\xe9pendantes des applications, tandis que les commandes d\'appareil sont adapt\xe9es \xe0 chaque connexion et d\xe9bloquent des fonctionnalit\xe9s plus avanc\xe9es que les commandes d\'application standard.","description":"Les commandes globales et celles des appareils sont des actions toujours disponibles, con\xe7ues pour fonctionner avec tous les logiciels. Les commandes globales, comme \xab\xa0Arr\xeater la cam\xe9ra\xa0\xbb, sont applicables \xe0 l\'ensemble du syst\xe8me et ind\xe9pendantes des applications, tandis que les commandes des appareils sont adapt\xe9es \xe0 chaque connexion et d\xe9bloquent des fonctionnalit\xe9s plus avanc\xe9es que les commandes d\'application standard. Ces commandes sont actuellement accessibles par commande vocale, mais nous prendrons en charge d\'autres commandes ult\xe9rieurement.","noDevice":"Cette \xe9tape utilise une extension personnalis\xe9e que vous n\'avez pas configur\xe9e pour votre compte. Ajoutez l\'extension pour d\xe9bloquer cette \xe9tape."},"notifications":{"title":"Notifications","center":"Centre de notification","empty":"Vous n\'avez aucune notification pour le moment. Revenez une autre fois.","seen":"Vu","markAsRead":"Marquer comme lu","view":"Afficher toutes les notifications {{value}}"},"unsaved":{"title":"Vous avez des changements non enregistr\xe9s.","description":"Vous avez des changements non enregistr\xe9s. \xcates-vous s\xfbr de vouloir quitter cette page\xa0?","cancel":"Quitter sans sauvegarder","confirm":"Sauvegarder et quitter"},"login":{"welcome":"Bienvenue chez C\xe9phable !","subtitle":"Contr\xf4lez votre technologie selon <strong>vos</strong> conditions.","create":"Cr\xe9er un compte","signIn":"Se connecter","loading":"Redirection vers la connexion...","error":"Une erreur s\'est produite lors de votre connexion. Veuillez vous reconnecter.","existingAccount":"Vous avez d\xe9j\xe0 un compte?","description":"Prenez le contr\xf4le total de votre ordinateur, de vos applications et de vos jeux avec Cephable\xa0: votre IA personnelle pour des actions rapides, des commandes vocales, des expressions faciales, des gestes, l\'inclinaison et bien plus encore. Pas de traitement cloud. Juste un contr\xf4le fluide qui s\'adapte \xe0 vos mouvements."},"home":{"title":"Maison","startControls":"Allume \xe7a!","manage":"Configurer","profileGenerate":{"title":"Oups. On dirait que vous n\'avez pas encore de contr\xf4les d\'application.","description":"Pour que Cephable puisse contr\xf4ler votre ordinateur, nous devons savoir ce que vous souhaitez contr\xf4ler. Vous pouvez cr\xe9er des contr\xf4les d\'application de A \xe0 Z ou nous demander de vous aider \xe0 en cr\xe9er un gr\xe2ce \xe0 notre g\xe9n\xe9rateur de contr\xf4les."}},"wizard":{"description":"Cephable utilisera ensuite ces informations pour g\xe9n\xe9rer des contr\xf4les que vous pourrez examiner et essayer\xa0!","includeDefaultKeysQuestion":"Inclure les commandes vocales par d\xe9faut pour les touches et les clics de souris\xa0?","placeholderAppName":"Microsoft Word, Minecraft, YouTube, Code, etc.","generate":"G\xe9n\xe9rer des contr\xf4les","complete":{"title":"Tr\xe8s bien, nous avons termin\xe9\xa0!","description":"Cliquez sur le bouton ci-dessous pour afficher les contr\xf4les que nous avons g\xe9n\xe9r\xe9s. Vous pourrez modifier, ajouter ou supprimer manuellement n\'importe quel aspect pour le perfectionner vous-m\xeame.","viewControls":"Voir mes contr\xf4les"},"error":{"emptyInput":"Veuillez s\xe9lectionner au moins une m\xe9thode de saisie","emptyApp":"Veuillez saisir au moins un nom d\'application","generatingProfile":"Erreur lors de la g\xe9n\xe9ration des contr\xf4les de l\'application"},"loading":{"title":"Nous rassemblons toutes les pi\xe8ces","description":"Cela peut prendre jusqu\'\xe0 environ une minute. Ne quittez pas cette page et ne revenez pas en arri\xe8re, sinon elle cessera de g\xe9n\xe9rer."},"selectedTips":{"title":"Conseil n\xb0\xa0{{count}}","previous":"Conseil pr\xe9c\xe9dent","next":"Prochain conseil","two":"Vous pouvez contr\xf4ler la sensibilit\xe9 de vos entr\xe9es dans la section \xab\xa0Param\xe8tres de contr\xf4le d\'expression\xa0\xbb du panneau principal. Cela vous permet d\'affiner davantage la mani\xe8re dont Cephable interpr\xe8te les entr\xe9es qui vous sont sp\xe9cifiques. Et Cephable s\'am\xe9liore avec le temps \xe0 mesure qu\'il fonctionne avec vous\xa0!","three":"Apr\xe8s avoir configur\xe9 cela, vous avez toujours un contr\xf4le total sur la configuration. Nous vous donnons une base de r\xe9f\xe9rence, mais \xe0 tout moment, vous pouvez modifier le mappage entre ce que vous faites et ce qu\'il fait sur l\'ordinateur.","four":"Vous pouvez imprimer vos contr\xf4les pour en avoir une copie physique lorsque vous utilisez Cephable. Nous savons que tout cela est nouveau et qu\u2019il faut un certain temps pour s\u2019y habituer. La pratique rend meilleur !","one":"Saviez-vous que vous pouvez utiliser Cephable sur un appareil pour en contr\xf4ler un autre\xa0? T\xe9l\xe9chargez Cephable sur votre mobile, votre tablette ou m\xeame un autre ordinateur et choisissez la connexion que vous souhaitez contr\xf4ler (peut-\xeatre celle-ci). Vos profils personnels et de saisie sont coh\xe9rents sur tous vos appareils\xa0! Assurez-vous simplement que Cephable est actif sur votre appareil et vos connexions."},"steps":{"one":"\xc9tape 1. Tapez le nom d\'une application que vous souhaitez contr\xf4ler.","two":"\xc9tape 2. Confirmez les contr\xf4les de saisie que vous souhaitez utiliser\xa0:","three":"\xc9tape 3. (facultatif) ","threeContinued":"D\xe9crivez toutes les actions sp\xe9cifiques que vous souhaiteriez configurer pour les commandes que vous utilisez couramment ou pour lesquelles vous avez une forte pr\xe9f\xe9rence. Veuillez utiliser un anglais simple comme ceux ci-dessous"},"noOptionsText":"Commencez \xe0 taper pour trouver une application que vous souhaitez contr\xf4ler","title":"G\xe9n\xe9rer des contr\xf4les d\'application","titleLong":"G\xe9n\xe9rer des contr\xf4les d\'application","try":"Essayez le g\xe9n\xe9rateur de contr\xf4le","placeholder":"Assurez-vous que les commandes vocales soient courtes.\\n\\nJe souhaite pouvoir dire \xab\xa0avancer\xa0\xbb pour passer \xe0 la diapositive suivante de la pr\xe9sentation.\\n\\nJe souhaite utiliser les mouvements de la t\xeate pour d\xe9placer le curseur et les commandes vocales pour modifier les raccourcis.\\n\\nAjouter des boutons d\'action rapide pour tous les mouvements et capacit\xe9s de mon personnage."},"macros":{"title":"Contr\xf4le","titlePlural":"Contr\xf4les","description":"Les contr\xf4les contiennent une entr\xe9e (action que vous faites comme incliner la t\xeate) et les \xe9tapes que Cephable effectuera apr\xe8s l\'enregistrement de cette action d\'entr\xe9e. Vous pouvez utiliser des contr\xf4les pour cr\xe9er une combinaison d\'\xe9tapes d\xe9clench\xe9es par une seule entr\xe9e.","new":"Cr\xe9er un nouveau contr\xf4le","newDescription":"Cr\xe9ez un nouveau contr\xf4le pour combiner plusieurs \xe9tapes et entr\xe9es.","add":"Ajouter un contr\xf4le","create":"Cr\xe9er un contr\xf4le","name":{"title":"Nom du contr\xf4le","question":"Comment voulez-vous appeler ce contr\xf4le\xa0?","description":"Donnez un nom \xe0 votre contr\xf4le afin de pouvoir le retrouver facilement plus tard.","placeholder":"action que ce contr\xf4le fait comme \\"sauter\\" ou \\"zoomer\\""},"empty":"Vous n\'avez pas encore de contr\xf4les. Cliquez ci-dessous pour en cr\xe9er un.","copySuffix":"{{name}}_copie"},"event":{"title":"\xc9tape","titlePlural":"Pas","previewSummaryPlural":"{{first}} et {{total}} autres \xe9v\xe9nements","add":"Ajouter une \xe9tape","stepType":"Type d\'\xe9tape","select":"S\xe9lectionnez le type d\'\xe9tape que vous souhaitez ajouter.","question":"Quel type d\u2019actions souhaitez-vous que Cephable effectue\xa0?","setup":"Configurez votre \xe9tape","description":"Les \xe9tapes sont les actions que Cephable effectuera une fois l\'entr\xe9e d\xe9clench\xe9e. Vous pouvez ajouter plusieurs \xe9tapes \xe0 un contr\xf4le pour cr\xe9er une combinaison d\'actions.","expand":"D\xe9veloppez pour voir le reste des \xe9tapes","stepUp":"Progresser","stepDown":"Descendre","stepCopy":"\xc9tape de copie","stepRemove":"Supprimer l\'\xe9tape","insertStep":"Ins\xe9rer l\'\xe9tape ci-dessous","showOptions":"Afficher les options","hideOptions":"Masquer les options","hold":"Temps de maintien (en millisecondes)","error":"Vous devez configurer votre \xe9tape.","multiple":"Plusieurs \xe9tapes","deviceTypeCustomAction":{"title":"Action personnalis\xe9e sur l\'appareil"},"keyPress":{"title":"Appuyez sur la touche ou le bouton ","short":"Presse","fieldSet":"Touches ou boutons sur lesquels appuyer","label":"Cl\xe9 ou bouton","holdTime":"Temps de maintien de la touche (en millisecondes)","description":"Appuyez sur une touche du clavier sans utiliser le clavier.","longDescription":"Cette fonction simule l\'appui sur une touche de votre clavier. Par exemple, si vous rencontrez des difficult\xe9s pour appuyer sur des touches physiques, vous pouvez utiliser une commande vocale ou une autre m\xe9thode de saisie pour \xab\xa0appuyer\xa0\xbb virtuellement sur une touche.","example":"Dites \xab Entr\xe9e \xbb pour envoyer un e-mail sans appuyer physiquement sur la touche Entr\xe9e.","timing":"Synchronisation des touches","tap":"Robinet","tapLong":"Appuyez sur le bouton","latch":"Loquet","latchLong":"Tenir jusqu\'\xe0 ce qu\'il soit rel\xe2ch\xe9","hold":"Prise","holdLong":"Tenir pendant un certain temps","toggle":"Basculer","toggleLong":"Basculer l\'action","release":"Rel\xe2cher","releaseLong":"Rel\xe2cher l\'action","latchLabel":"Conservez <strong>{{value}}</strong> jusqu&#39;\xe0 ce qu&#39;il soit lib\xe9r\xe9","tapLabel":"Appuyez sur <strong>{{value}}</strong>","pressLabel":"Appuyez sur <strong>{{value}}</strong> pendant <strong>{{time}}</strong> millisecondes","remove":"Supprimer la touche enfonc\xe9e","add":"Ajouter une touche/un bouton sur lequel appuyer"},"keyRelease":{"title":"Rel\xe2cher la touche ou le bouton","short":"Lib\xe9rer","selected":"Cl\xe9s s\xe9lectionn\xe9es \xe0 lib\xe9rer","description":"L\xe2chez une touche du clavier que vous avez enfonc\xe9e et maintenue enfonc\xe9e.","longDescription":"Cette fonction simule le rel\xe2chement d\'une touche de votre clavier. Il doit \xeatre utilis\xe9 conjointement avec une pression sur une touche maintenue ind\xe9finiment. Par exemple, si vous rencontrez des difficult\xe9s pour appuyer sur des touches physiques, vous pouvez utiliser une commande vocale ou une autre m\xe9thode de saisie pour \xab rel\xe2cher \xbb virtuellement une touche.","example":"Dites \xab Stop \xbb apr\xe8s avoir dit \xab Toggle Run \xbb pour arr\xeater de fonctionner.","label":"Lib\xe9rer <strong>{{value}}</strong>","add":"Ajouter une cl\xe9/un bouton pour lib\xe9rer","remove":"Supprimer la version de cl\xe9"},"keyToggle":{"title":"Touche ou bouton \xe0 bascule","short":"Basculer","selected":"Touches s\xe9lectionn\xe9es \xe0 basculer","description":"Allumez ou \xe9teignez une touche du clavier comme un interrupteur d\'\xe9clairage avec une seule commande.","longDescription":"Cela active ou d\xe9sactive la fonction d\'une touche, comme un interrupteur. C\'est utile pour les cl\xe9s que vous souhaitez conserver pendant une dur\xe9e ind\xe9termin\xe9e. Vous pouvez l\'utiliser pour conserver la m\xeame action pour l\'appui sur une touche et pour le rel\xe2chement ou l\'arr\xeat d\'une touche.","example":"Dites \xab Toggle Run \xbb pour commencer \xe0 courir. Dites \xab\xa0Toggle Run\xa0\xbb pour arr\xeater de fonctionner.","label":"Basculer <strong>{{value}}</strong>","add":"Ajouter une cl\xe9/un bouton pour basculer","remove":"Supprimer la bascule de cl\xe9"},"pause":{"title":"Pause","description":"Ajoutez un bref d\xe9lai entre les actions.","longDescription":"Cette fonction vous permet d\'ins\xe9rer un bref d\xe9lai entre les actions, ce qui est essentiel dans les situations o\xf9 une action doit \xeatre compl\xe8tement termin\xe9e avant que la suivante ne commence. Par exemple, si vous utilisez une commande pour mettre le texte en gras dans un document, vous devrez peut-\xeatre d\'abord ouvrir un menu contextuel. La fonction Pause donne suffisamment de temps pour que le menu contextuel s\'ouvre et devienne actif avant de passer \xe0 l\'\xe9tape suivante, garantissant ainsi un fonctionnement fluide et sans erreur.","example":"Imaginez que vous modifiez un document \xe0 l\'aide de commandes vocales. Vous dites \xab Formater le texte \xbb, ce qui ouvre un menu contextuel. Ensuite, apr\xe8s une br\xe8ve pause pour permettre au menu d\'appara\xeetre enti\xe8rement, vous dites \xab\xa0Gras\xa0\xbb pour appliquer une mise en forme en gras au texte s\xe9lectionn\xe9. La fonction Pause garantit que le menu contextuel est pr\xeat \xe0 recevoir votre prochaine commande.","label":"Pause pendant <strong>{{value}}</strong>\xa0millisecondes"},"type":{"title":"Taper","field":"Phrase \xe0 saisir","placeholder":"phrase dactylographi\xe9e","question":"Quel texte souhaitez-vous taper ?","description":"\xc9crivez du texte comme si vous utilisiez un clavier.","longDescription":"Cela imite la saisie d\u2019une cha\xeene de texte, comme si vous tapiez sur un clavier. C\'est id\xe9al pour saisir du texte plus long sans avoir besoin d\'appuyer sur chaque touche. Si vous souhaitez saisir du texte de mani\xe8re dynamique, vous pouvez utiliser la fonction Dict\xe9e.","example":"Dites \xab\xa0Nom\xa0\xbb pour saisir \xab\xa0Bonjour, je m\'appelle Ellen Ripley\xa0\xbb. dans une fen\xeatre de discussion.","label":"Tapez <strong>{{value}}</strong>"},"mouseMove":{"title":"D\xe9placez la souris","description":"D\xe9placez le pointeur sur l\'\xe9cran.","longDescription":"D\xe9placez le curseur ou le pointeur de votre \xe9cran sans souris physique. Ceci est particuli\xe8rement utile pour les utilisateurs ayant une mobilit\xe9 limit\xe9e des mains. Ceci est utile pour un contr\xf4le pr\xe9cis des mouvements de la souris, n\xe9cessaire dans certains jeux. Si vous souhaitez simuler tous les mouvements de la souris en utilisant le mouvement de votre t\xeate, vous pouvez essayer le \xab\xa0Mouvement de la t\xeate pour le contr\xf4le de la souris\xa0\xbb dans les param\xe8tres de la cam\xe9ra.","example":"Dites \xab\xa0D\xe9placer la souris vers la droite\xa0\xbb pour d\xe9placer le curseur vers la droite de 100\xa0px.","moveX":"D\xe9placement de la souris vers la gauche/droite","numberMoveX":"Nombre de pixels \xe0 d\xe9placer vers la gauche/droite","moveY":"D\xe9placement de la souris vers le haut/bas des pixels","numberMoveY":"Nombre de pixels \xe0 d\xe9placer vers le haut/bas","label":"D\xe9placez la souris <strong>{{value}}</strong>","command":"D\xe9placement de la souris\xa0: {{commande}}"},"joystickMove":{"title":"D\xe9placer les joysticks","description":"Utilisez un joystick pour d\xe9placer les \xe9l\xe9ments sur l\'\xe9cran.","longDescription":"Cette fonction simule le mouvement d\'un joystick. Par exemple, si vous rencontrez des difficult\xe9s pour utiliser un joystick physique, vous pouvez utiliser une commande vocale ou une autre m\xe9thode de saisie pour d\xe9placer virtuellement un joystick.","example":"Dites \xab\xa0D\xe9placer le joystick vers la gauche\xa0\xbb pour d\xe9placer le joystick vers la gauche de 100\xa0px.","prefix":"D\xe9placez le joystick gauche","left":"Manette gauche","leftX":"X gauche","leftY":"Y gauche","right":"Manette droite","rightX":"X droit","rightY":"Y droit","x":"Force de l\'axe X","y":"Force de l\'axe Y","moveXLabel":"D\xe9placer X\xa0:\xa0{{value}}","moveYLabel":"D\xe9placement Y\xa0:\xa0{{value}}","labelLeft":"D\xe9placez le joystick gauche ","labelRight":"D\xe9placez le joystick droit ","latch":"Le loquet maintiendra la position jusqu\'\xe0 ce que vous le rel\xe2chiez \xe0 l\'aide d\'une commande \xab\xa0Arr\xeater tout\xa0\xbb."},"playAudio":{"title":"Lire l\'audio","placeholder":"phrase de d\xe9claration que Cephable dira","description":"Jouez un son, un mot ou une phrase.","longDescription":"Cette fonction permet aux utilisateurs de convertir des phrases saisies en mots prononc\xe9s. C\'est particuli\xe8rement utile pour les personnes qui peuvent avoir des difficult\xe9s \xe0 parler. En tapant une phrase, la fonction PlayAudio articulera le texte \xe0 haute voix \xe0 l\'aide d\'une parole synth\xe9tis\xe9e. Cela peut faciliter la communication ou dans les situations o\xf9 un utilisateur a besoin de relayer des informations verbalement mais pr\xe9f\xe8re ou n\xe9cessite une alternative \xe0 l\'utilisation de sa propre voix.","example":"Souriez pour jouer le mot \xab\xa0Bonjour\xa0\xbb.","label":"Dites <strong>{{value}}</strong>"},"stopOutputs":{"title":"Arr\xeater toutes les sorties","titleLong":"Arr\xeatez toutes les sorties (rel\xe2chez toutes les touches et boutons, arr\xeatez tous les mouvements de la souris, arr\xeatez toute saisie)","description":"Arr\xeatez toutes les actions en cours comme l\'appui sur une touche.","longDescription":"Arr\xeatez imm\xe9diatement toutes les sorties ou actions en cours. Il s\'agit d\'une fonction de s\xe9curit\xe9 ou de commodit\xe9 permettant d\'arr\xeater tout processus. Nous le ferons automatiquement pour vous lorsque vous fermez ou mettez en pause les commandes de la cam\xe9ra ou du microphone.","example":"Dites \xab\xa0Stop\xa0\xbb pour arr\xeater toutes les sorties.","label":"Arr\xeatez toutes les sorties et rel\xe2chez les touches"},"custom":{"title":"Coutume"},"options":{"moveUp":"D\xe9placer vers le haut","moveDown":"Descendre","moveLeft":"Se d\xe9placer \xe0 gauche","moveRight":"D\xe9placer vers la droite","copyStep":"\xc9tape de copie","removeStep":"Supprimer l\'\xe9tape"},"directions":{"up":"En haut","down":"Vers le bas","left":"Gauche","right":"Droite"}},"expression":{"title":"Expression du visage","titlePlural":"Expressions du visage","label":"Expression / Geste","start":"D\xe9marrer les contr\xf4les d\u2019expression","startSmiling":{"title":"Commencez \xe0 sourire","description":"Si vous commencez \xe0 sourire sans sourire, puis \xe0 sourire, cette commande se d\xe9clenchera. Remarque\xa0: l\'utilisation de cette commande dans les m\xeames commandes d\'application que la commande \xab\xa0Ouvrir/Fermer la bouche\xa0\xbb peut entra\xeener des conflits."},"stopSmiling":{"title":"Arr\xeatez de sourire","description":"Si vous souriez puis cessez, cette commande s\'activera. Remarque\xa0: l\'utilisation de cette commande dans les m\xeames commandes d\'application que la commande \xab\xa0Ouvrir/Fermer la bouche\xa0\xbb peut entra\xeener des conflits."},"eyebrows":{"title":"L\xe8ve sourcils","description":"Si vous soulevez vos deux sourcils par rapport \xe0 votre position de repos de base, cette commande se d\xe9clenchera."},"openMouth":{"title":"Bouche ouverte","description":"Si votre bouche est ferm\xe9e (ou l\xe9g\xe8rement ouverte), et que vous l\'ouvrez davantage, cette commande se d\xe9clenchera. Remarque\xa0: l\'utilisation de cette commande dans les m\xeames commandes d\'application que la commande du sourire peut entra\xeener des conflits."},"closeMouth":{"title":"Fermer la bouche","description":"Si votre bouche est ouverte et que vous la fermez compl\xe8tement, cette commande se d\xe9clenchera. Remarque\xa0: l\'utilisation de cette commande dans les m\xeames commandes d\'application que la commande de sourire peut entra\xeener des conflits."},"description":"Am\xe9liorez votre exp\xe9rience num\xe9rique gr\xe2ce aux expressions faciales. Utilisez des gestes comme lever les sourcils, sourires et autres mouvements pour contr\xf4ler facilement le pointeur de votre souris, effectuer des actions ou personnaliser vos interactions."},"head":{"title":"Mouvement de la t\xeate","titlePlural":"Mouvements de t\xeate","label":"Mouvement de la t\xeate/du corps","question":"Quel type de mouvement souhaitez-vous utiliser ?","tilt":{"title":"Inclinaison de la t\xeate","left":{"title":"Incliner la t\xeate vers la gauche","description":"Si vous regardez la cam\xe9ra et inclinez la t\xeate vers la gauche, cette commande se d\xe9clenchera."},"right":{"title":"Incliner la t\xeate vers la droite","description":"Si vous regardez la cam\xe9ra et inclinez la t\xeate vers la droite, cette commande se d\xe9clenchera."},"back":{"title":"Incliner la t\xeate vers l\'arri\xe8re","description":"Si vous regardez la cam\xe9ra, inclinez la t\xeate en arri\xe8re et regardez vers le haut, cette commande se d\xe9clenchera."},"forward":{"title":"Incliner la t\xeate vers l\'avant","description":"Si vous regardez la cam\xe9ra et inclinez la t\xeate vers l\u2019avant et regardez vers le bas, cette commande se d\xe9clenchera."},"description":"Inclinez votre t\xeate vers la gauche ou la droite pour un contr\xf4le am\xe9lior\xe9 ou une navigation avec la souris."},"turn":{"title":"Tour de t\xeate","left":{"title":"Tourner la t\xeate \xe0 gauche","description":"Si vous regardez la cam\xe9ra et tournez la t\xeate et regardez vers votre gauche, cette commande se d\xe9clenchera."},"right":{"title":"Tourner la t\xeate \xe0 droite","description":"Si vous regardez la cam\xe9ra et tournez la t\xeate et regardez vers votre droite, cette commande se d\xe9clenchera."},"description":"Tournez la t\xeate vers la gauche ou la droite pour un contr\xf4le am\xe9lior\xe9 ou une navigation avec la souris."},"lean":{"title":"T\xeate maigre","left":{"title":"Pencher la t\xeate \xe0 gauche","description":"Si vous regardez la cam\xe9ra et que vous vous penchez vers la gauche pour que votre visage soit plus \xe0 gauche dans le cadre de la cam\xe9ra, cette commande se d\xe9clenchera."},"right":{"title":"Pencher la t\xeate \xe0 droite","description":"Si vous regardez la cam\xe9ra et que vous vous penchez vers la droite pour que votre visage soit plus \xe0 droite dans le cadre de la cam\xe9ra, cette commande se d\xe9clenchera."},"back":{"title":"Pencher la t\xeate en arri\xe8re","description":"Si vous regardez la cam\xe9ra et que vous vous penchez en arri\xe8re pour que votre visage soit plus \xe9loign\xe9 de la cam\xe9ra, cette commande se d\xe9clenchera."},"forward":{"title":"Penchez-vous la t\xeate en avant","description":"Si vous regardez la cam\xe9ra et que vous vous penchez en avant pour que votre visage soit plus proche de la cam\xe9ra, cette commande se d\xe9clenchera."},"up":{"title":"D\xe9placer le corps vers le haut","description":"Si vous regardez la cam\xe9ra et que vous relevez la t\xeate en \xe9tirant votre cou ou en d\xe9pla\xe7ant tout votre corps vers le haut, cette commande se d\xe9clenchera."},"down":{"title":"Descendre le corps","description":"Si vous regardez la cam\xe9ra et baissez la t\xeate en froissant le cou, en vous baissant ou en abaissant tout votre corps, cette commande se d\xe9clenchera."},"center":{"title":"Centrez votre t\xeate","description":"Si vous regardez la cam\xe9ra et d\xe9placez votre t\xeate vers la position centrale correspondant \xe0 la ligne de base, cette commande se d\xe9clenchera."},"description":"Penchez votre t\xeate vers la gauche ou la droite pour un meilleur contr\xf4le ou une meilleure navigation avec la souris."},"description":"Contr\xf4lez votre appareil ou votre connexion par des mouvements de t\xeate comme incliner, hocher la t\xeate ou tourner. Gr\xe2ce \xe0 la cam\xe9ra de votre appareil, Cephable garantit une exp\xe9rience priv\xe9e et intuitive pour un contr\xf4le et une navigation optimis\xe9s."},"voice":{"title":"Commande vocale","titlePlural":"Commandes vocales","placeholder":"Voix ou phrase que Cephable \xe9coutera","question":"Quelle d\xe9claration ou expression voulez-vous dire pour ce contr\xf4le\xa0?","when":"Quand je dis...","say":"Dites \xab\xa0{{value}}\xa0\xbb","load":{"fail":{"title":"{{language}} Commandes vocales indisponibles","description":"Oh non! Nous n\'avons pas pu charger {{language}} pour les commandes vocales. S\'il vous pla\xeet, v\xe9rifiez votre connexion \xe0 internet et r\xe9essayez. Utiliser l\'anglais (\xc9tats-Unis) jusqu\'\xe0 ce que la connexion soit r\xe9tablie."}},"description":"Activer le microphone permet des commandes vocales intelligentes et naturelles, permettant aux utilisateurs d\'interagir facilement avec leur ordinateur, que ce soit pour les applications ou les logiciels. Ex\xe9cutez des commandes ou dictez du texte en parlant naturellement, pour une exp\xe9rience intuitive et intuitive."},"motion":{"title":"Contr\xf4le de mouvement","titlePlural":"Commandes de mouvement","question":"Quel type de mouvement avec un t\xe9l\xe9phone ou une tablette souhaitez-vous utiliser\xa0?","start":"D\xe9marrer les commandes de mouvement","settings":"Param\xe8tres de mouvement","descriptionShort":"Inclinez, tournez ou secouez votre appareil pour contr\xf4ler Cephable.","description":"Les commandes de mouvement vous permettent de transformer les mouvements de votre t\xe9l\xe9phone ou de votre tablette dans l\'application Companion en commandes pour votre appareil. Inclinez ou secouez votre t\xe9l\xe9phone dans diff\xe9rentes directions pour cr\xe9er de nouvelles sorties.","up":{"title":"Inclinez votre appareil vers le haut","description":"Si votre appareil est \xe0 plat sur une surface et que vous l\'inclinez vers vous, cette commande se d\xe9clenchera."},"down":{"title":"Inclinez votre appareil vers le bas","description":"Si votre appareil est \xe0 plat sur une surface et que vous l\'inclinez pour qu\'il soit face \xe0 vous, cette commande se d\xe9clenchera."},"left":{"title":"Inclinez votre appareil vers la gauche","description":"Si votre appareil est plat sur une surface et que vous l\'inclinez vers la gauche pour faire face vers la gauche, cette commande se d\xe9clenchera."},"right":{"title":"Inclinez votre appareil vers la droite","description":"Si votre appareil est plat sur une surface et que vous l\'inclinez vers la droite, cette commande se d\xe9clenchera."},"shake":{"title":"Secouez votre appareil","description":"Si vous secouez votre appareil, cette commande se d\xe9clenchera."},"edit":{"title":"Modifier les param\xe8tres de mouvement","description":"Modifiez vos param\xe8tres de contr\xf4le de mouvement pour ajuster la quantit\xe9 dont vous avez besoin pour d\xe9placer votre t\xe9l\xe9phone pendant l\'ex\xe9cution vers l\'application Companion.","sensitivity":{"title":"Param\xe8tres de sensibilit\xe9 du contr\xf4le de mouvement","description":"La sensibilit\xe9 indique \xe0 Cephable jusqu\'o\xf9 vous devez incliner votre appareil pour d\xe9clencher un contr\xf4le. Plus la valeur est grande (la plus \xe0 droite sur le curseur), plus la sensibilit\xe9 est \xe9lev\xe9e, et donc moins il faut incliner pour d\xe9clencher la commande."},"tilt":{"title":"Sensibilit\xe9 \xe0 l\'inclinaison","description":"Ces valeurs d\xe9terminent jusqu\'o\xf9 vous devez incliner votre appareil vers le haut, le bas, la gauche et la droite pour qu\'une entr\xe9e soit reconnue."},"mouse":{"title":"Commandes de mouvement pour le mouvement de la souris","description":"D\xe9terminez si et comment vous souhaitez utiliser les commandes de mouvement pour d\xe9placer votre souris au lieu de d\xe9clencher les commandes","enable":{"title":"Activer les commandes de mouvement pour le mouvement de la souris","description":"Si cette option est activ\xe9e, certaines de vos commandes de mouvement seront utilis\xe9es pour d\xe9placer votre souris au lieu de d\xe9clencher des commandes.","option":"Utiliser les commandes de mouvement pour les mouvements de la souris\xa0?"},"invert":{"title":"Inverser le mouvement de la souris","description":"Pour l\'axe X\xa0: si cette option est activ\xe9e, un d\xe9placement vers la gauche d\xe9placera votre souris vers la droite et un d\xe9placement vers la droite la d\xe9placera vers la gauche. Pour l\'axe Y\xa0: si cette option est activ\xe9e, le fait de descendre d\xe9placera votre souris vers le haut et le fait de monter la fera descendre.","x":"Inverser le mouvement de la souris sur l\'axe X\xa0?","y":"Inverser le mouvement de la souris sur l\'axe Y\xa0?"}}}},"keys":{"title":"Cl\xe9 ou bouton","titlePlural":"Touches ou boutons","label":"Cl\xe9/bouton externe","question":"Sur quelle touche ou bouton souhaitez-vous appuyer\xa0?","edit":"Modifier les touches et les boutons","defaultOption":"Inclure les commandes vocales par d\xe9faut pour les touches et les clics de souris\xa0?","description":"Les touches et les boutons vous permettent de mapper vos diff\xe9rentes commandes d\'entr\xe9e aux pressions du clavier et des boutons du contr\xf4leur.","then":"Cephable va appuyer...","empty":"Aucun contr\xf4le cl\xe9 ne correspond \xe0 ces crit\xe8res.","backspace":"Retour arri\xe8re","delete":"Supprimer","enter":"Entrer","space":"Barre d\'espace","tab":"Languette","shift":"Changement","ctrl":"Ctrl","leftCtrl":"Ctrl gauche","rightCtrl":"Ctrl droit","leftShift":"D\xe9calage \xe0 gauche","rightShift":"Maj droite","alt":"Tout","leftAlt":"Alt gauche","escape":"S\'\xe9chapper","up":"Fl\xe8che vers le haut","down":"Fl\xe8che vers le bas","left":"Fl\xe8che gauche","right":"Fl\xe8che droite","command":"Commande","caps":"Verrouillage des majuscules","reset":{"title":"R\xe9initialiser les raccourcis clavier","confirm":"R\xe9initialiser tous les raccourcis clavier\xa0?","confirmDescription":"Choisissez comment r\xe9initialiser les raccourcis clavier. Cette action est irr\xe9versible sans enregistrement.","confirmButton":"R\xe9initialiser les raccourcis clavier","defaultOption":"R\xe9tablir les valeurs par d\xe9faut pour la langue actuelle","emptyOption":"R\xe9initialiser \xe0 z\xe9ro (effacer toutes les commandes)"}},"talkback":{"title":"R\xe9pondre","question":"Que veux-tu que C\xe9phable dise ?","description":"Configurez des contr\xf4les qui permettront \xe0 Cephable de parler pour vous. Vous pouvez attribuer des commandes aux diff\xe9rentes phrases que vous souhaitez prononcer.","thenMacro":"alors C\xe9phable dira...","empty":"Il n\'existe aucun contr\xf4le de r\xe9ponse correspondant \xe0 ces crit\xe8res.","add":"Ajouter un nouveau contr\xf4le Talkback","remove":"Supprimer le contr\xf4le Talkback","edit":"Modifier les commandes Talkback","deprecatedNotice":"Talkback est d\xe9sormais int\xe9gr\xe9 directement aux commandes principales de l\'application. Vos commandes d\'application comportent d\'anciens \xe9v\xe9nements Talkback qui doivent \xeatre mis \xe0 jour."},"dictation":{"title":"Dictation","question":"Quelle phrase doit d\xe9clencher le mode dict\xe9e\xa0?","thenMacro":"C\xe9phable va...","empty":"Il n\'existe aucun contr\xf4le de dict\xe9e correspondant \xe0 ces crit\xe8res.","type":"taper","edit":"Modifier les phrases de dict\xe9e","remove":"Supprimer une phrase de dict\xe9e","add":"Ajouter une nouvelle phrase de dict\xe9e","on":"Dict\xe9e","off":"Commandes","onboarding":{"tourLabel":"Dict\xe9e","learn":"Apprenez \xe0 utiliser le mode dict\xe9e pour convertir votre discours en texte en mains libres.","welcome":{"title":"Dict\xe9e","description":"La dict\xe9e vous permet de parler naturellement et de saisir vos mots pendant que vous parlez. C\'est comme avoir un assistant personnel qui saisit tout ce que vous dites."},"microphone":{"title":"Allumez votre microphone","description":"Tout d\'abord, activez votre microphone. Cliquez sur l\'ic\xf4ne \xab\xa0Microphone\xa0\xbb dans le panneau Cephable."},"activate":{"title":"D\xe9marrer le mode dict\xe9e","description":"La voix d\xe9marre en mode commande. Pour lancer la dict\xe9e, dites \xab\xa0D\xe9marrer la dict\xe9e\xa0\xbb ou cliquez sur le bouton \xab\xa0Dict\xe9e\xa0\xbb. Activons maintenant le mode dict\xe9e."},"speaking":{"title":"Cliquez sur un document ou un champ et commencez \xe0 parler","description":"La dict\xe9e enregistre en temps r\xe9el ce que vous dites. Cliquez sur un champ de texte ou un document, puis commencez \xe0 parler. Par exemple, dites\xa0: \xab\xa0Voici comment utiliser le mode dict\xe9e.\xa0\xbb"},"pauseResume":{"title":"Pause de la dict\xe9e","description":"Besoin d\'une pause sans d\xe9sactiver la dict\xe9e\xa0? Dites simplement \xab\xa0Suspendre la dict\xe9e\xa0\xbb. Vous pouvez la reprendre \xe0 tout moment avec \xab\xa0D\xe9marrer la dict\xe9e\xa0\xbb. Vous pouvez personnaliser davantage cette option gr\xe2ce aux commandes globales et aux commandes de l\'appareil toujours actives."},"stop":{"title":"Arr\xeater la dict\xe9e","description":"Besoin de revenir aux commandes de votre application\xa0? Dites simplement \xab\xa0Arr\xeater la dict\xe9e\xa0\xbb. Cela arr\xeatera le mode dict\xe9e et vous ram\xe8nera au mode commande. Vous pouvez reprendre \xe0 tout moment en cliquant \xe0 nouveau sur \xab\xa0D\xe9marrer la dict\xe9e\xa0\xbb."},"complete":{"title":"Bravo!","description":"Et voil\xe0\xa0! Vous pouvez d\xe9sormais dicter, mettre en pause, reprendre et passer du mode dict\xe9e au mode commande. La dict\xe9e est un outil puissant pour la saisie mains libres. Utilisez-la pour r\xe9diger des e-mails, des documents ou tout ce que vous devez saisir \xe0 voix haute."}},"description":"La dict\xe9e vous permet de parler naturellement et de saisir vos mots pendant que vous parlez. C\'est comme avoir un assistant personnel qui saisit tout ce que vous dites."},"face":{"title":"Expression du visage","titlePlural":"Expressions du visage","try":"Essayez les contr\xf4les d\'expression du visage","question":"Quel type d\u2019expression de visage souhaitez-vous utiliser\xa0?","descriptionShort":"Utilisez diff\xe9rents mouvements du visage pour des contr\xf4les am\xe9lior\xe9s.","description":"Les expressions faciales font partie des Contr\xf4les d\'expression. Elles vous permettent d\'utiliser diff\xe9rents mouvements du visage pour des contr\xf4les am\xe9lior\xe9s. Vous pouvez utiliser les mouvements des sourcils, de la bouche, etc. pour cr\xe9er diff\xe9rents rendus."},"other":{"title":"Autre","titlePlural":"Autres contr\xf4les","label":"Autre contr\xf4le","placeholder":"autre commande exp\xe9rimentale","question":"Quelle commande suppl\xe9mentaire souhaitez-vous utiliser\xa0? Ces commandes sont g\xe9n\xe9ralement destin\xe9es aux connexions non Cephable qui ne correspondent pas aux autres cat\xe9gories. Elles peuvent \xe9galement fonctionner comme des commandes vocales lorsque vous prononcez le mot ou la phrase sp\xe9cifi\xe9. Remarque\xa0: ces commandes sont exp\xe9rimentales et peuvent ne pas \xeatre enti\xe8rement prises en charge.","description":"Les autres commandes sont exp\xe9rimentales et peuvent ne pas \xeatre enti\xe8rement prises en charge. Elles peuvent \xeatre utilis\xe9es pour des connexions non Cephable ou comme commandes vocales lorsque vous prononcez le mot ou la phrase sp\xe9cifi\xe9."},"support":{"title":"Soutien","profiles":"Introduction aux contr\xf4les d\'application","question":"Vous ne trouvez toujours pas ce dont vous avez besoin ?","more":"Apprenez-en plus sur Cephable.com avec des guides \xe9tape par \xe9tape, des tutoriels, des vid\xe9os et plus encore."},"community":{"title":"Rejoignez la communaut\xe9","description":"Obtenez du soutien, partagez des id\xe9es ou devenez membre des communaut\xe9s Cephable.","discord":"Communaut\xe9 Discorde","facebook":"Groupe Facebook"},"resources":{"title":"Ressources utiles","description":"Trouvez les r\xe9ponses \xe0 vos questions sur les caract\xe9ristiques et fonctions de Cephable.","guides":"Guides \xe9tape par \xe9tape"},"feedback":{"title":"Retour","description":"Parlez-nous de votre exp\xe9rience avec Cephable.","contact":"Contactez-nous","feature":"Sugg\xe9rer une fonctionnalit\xe9","bug":"Signaler un probl\xe8me"},"settings":{"title":"Param\xe8tres","general":"Param\xe8tres g\xe9n\xe9raux de l\'application","description":"Il s\'agit de votre canevas pour personnaliser votre exp\xe9rience en affinant vos commandes.","orgTitle":"Param\xe8tres de {{ value }}"},"account":{"title":"Compte","settings":"Param\xe8tres du compte","description":"Mettez \xe0 jour les informations cl\xe9s pour rester connect\xe9 avec Cephable.","usernameLabel":"Nom d\'utilisateur: ","emailLabel":"E-mail: ","password":{"change":"Changer le mot de passe","description":"Mettez \xe0 jour votre mot de passe pour s\xe9curiser votre compte.","old":"ancien mot de passe","current":"Votre mot de passe actuel","new":"nouveau mot de passe","desired":"Votre nouveau mot de passe souhait\xe9","confirm":"Confirmer le nouveau mot de passe","update":"Mettre \xe0 jour le mot de passe"},"isEmailVerified":{"title":"L\'email n\'est pas verifi\xe9.","description":"Votre email n\'est pas v\xe9rifi\xe9. Veuillez v\xe9rifier votre courrier \xe9lectronique pour un lien de v\xe9rification.","resend":"R\xe9-envoyer l\'email","success":"Nous vous avons envoy\xe9 un nouvel e-mail de v\xe9rification.","error":"Une erreur s\'est produite lors de l\'envoi de l\'e-mail de v\xe9rification. Veuillez r\xe9essayer plus tard.","org":"Votre adresse e-mail n\'est pas v\xe9rifi\xe9e. Elle est requise pour acc\xe9der aux informations de la licence. Veuillez consulter votre adresse e-mail pour obtenir un lien de v\xe9rification.","titleAlt":"V\xe9rifiez votre adresse e-mail","descriptionLong":"Bienvenue sur Cephable\xa0! Un e-mail de v\xe9rification a \xe9t\xe9 envoy\xe9 \xe0 {{email}}. Veuillez v\xe9rifier votre bo\xeete de r\xe9ception ou votre dossier spam et cliquer sur le lien. Si vous ne le voyez pas, vous pouvez renvoyer l\'e-mail de v\xe9rification.","appBlock":"Vous y \xeates presque\xa0! Un e-mail de v\xe9rification a \xe9t\xe9 envoy\xe9 \xe0 {{email}}. Veuillez consulter votre bo\xeete de r\xe9ception et cliquer sur le lien pour v\xe9rifier votre adresse e-mail. Si vous ne le voyez pas, v\xe9rifiez vos spams."},"signout":{"title":"Se d\xe9connecter","question":"\xcates-vous certain de vouloir vous d\xe9connecter?","confirm":"Oui, d\xe9connectez-vous","warn":{"title":"Vous \xeates sur le point d\u2019\xeatre d\xe9connect\xe9.","description":"Il semblerait que vous ayez \xe9t\xe9 inactif pendant un certain temps. Pour des raisons de s\xe9curit\xe9, nous vous d\xe9connecterons dans XX secondes. Si vous souhaitez rester connect\xe9, cliquez sur \xab\xa0Rester connect\xe9\xa0\xbb ci-dessous.","confirm":"Rester connect\xe9","cancel":"D\xe9connectez-vous maintenant"},"description":"Une fois d\xe9connect\xe9, cette connexion sera supprim\xe9e de votre compte et ne sera plus visible depuis l\'application Companion ou d\'autres connexions.","confirmDescription":"Vous d\xe9connecter et supprimer cette connexion"},"marketing":{"title":"Pr\xe9f\xe9rences de messagerie","description":"Mettez \xe0 jour vos pr\xe9f\xe9rences de messagerie pour recevoir des mises \xe0 jour et des nouvelles de Cephable.","marketing":"E-mails marketing","optIn":"Je souhaite recevoir des tutoriels, des conseils, des mises \xe0 jour et des newsletters pour am\xe9liorer mon exp\xe9rience Cephable"},"error":{"save":"Erreur lors de l\'enregistrement des param\xe8tres du compte.","password":"Erreur lors de la mise \xe0 jour du mot de passe.","signout":"Erreur de d\xe9connexion.","old":"L\'ancien mot de passe est requis.","new":"Un nouveau mot de passe est requis.","match":"Les mots de passe ne correspondent pas.","marketing":"Erreur lors de la mise \xe0 jour des pr\xe9f\xe9rences de messagerie.","userPreferences":"Erreur lors de l\'enregistrement des pr\xe9f\xe9rences utilisateur."},"success":{"save":"Param\xe8tres du compte enregistr\xe9s.","password":"Mot de passe mis \xe0 jour.","marketing":"Pr\xe9f\xe9rences de courrier \xe9lectronique mises \xe0 jour.","userPreferences":"Pr\xe9f\xe9rences utilisateur mises \xe0 jour."},"userPreferences":{"title":"Pr\xe9f\xe9rences de l\'utilisateur","description":"Mettez \xe0 jour vos pr\xe9f\xe9rences pour cr\xe9er l\'exp\xe9rience Cephable qui vous convient.","warningOptOut":"Masquer les avertissements lorsque j\'enregistre ou mets \xe0 jour les contr\xf4les de l\'application","enableTranscribeTask":"Activer la t\xe2che de transcription de fichiers exp\xe9rimentaux dans le panneau Cephable","enableClickByName":"Windows uniquement. Activez la fonctionnalit\xe9 exp\xe9rimentale \xab\xa0Appuyer sur un \xe9l\xe9ment de l\u2019\xe9cran par son nom\xa0\xbb, par exemple \xab\xa0Appuyer sur Enregistrer\xa0\xbb pour cliquer sur un bouton nomm\xe9 \xab\xa0Enregistrer\xa0\xbb.","enableGamepadSupport":"Activer la prise en charge de la manette pour le pilote local et l\'\xe9mulation du contr\xf4leur Xbox","enableMetrics":"Activez la sortie des m\xe9triques d\'utilisation pour les tests de performance. Vous pourrez t\xe9l\xe9charger les journaux depuis le panneau Cephable."},"menu":"Menu utilisateur","delete":{"title":"Supprimer le compte","description":"Vous pouvez supprimer d\xe9finitivement votre compte et effacer toute trace de vos informations personnelles. La suppression de votre compte entra\xeenera la suppression de vos connexions, qui ne seront plus actives ni associ\xe9es \xe0 votre compte. Vos param\xe8tres et commandes d\'application seront \xe9galement perdus. Cette action est irr\xe9versible.","button":"Supprimer d\xe9finitivement le compte","confirmation":"\xcates-vous s\xfbr de vouloir supprimer votre compte\xa0?","note":"Cette action est irr\xe9versible.","confirm":"Oui, supprimez mon compte"}},"appSettings":{"description":"Ces param\xe8tres s\'appliquent uniquement \xe0 cette application. Si vous souhaitez modifier les param\xe8tres de l\'application Cephable sur un autre ordinateur ou appareil mobile, modifiez les param\xe8tres dans cette application.","autostart":{"title":"D\xe9marrer automatiquement Cephable","description":"Avec ce param\xe8tre activ\xe9, l\'application Cephable d\xe9marrera automatiquement lorsque vous vous connecterez \xe0 votre appareil. Si vous disposez \xe9galement de commandes automatiques de voix et d\u2019expression, celles-ci d\xe9marreront \xe9galement imm\xe9diatement.","question":"D\xe9marrage automatique de l\'application Cephable\xa0?"},"position":{"topLeft":"En haut \xe0 gauche","top":"Centre sup\xe9rieur","topRight":"En haut \xe0 droite","bottom":"En bas au centre","bottomLeft":"En bas \xe0 gauche","bottomRight":"En bas \xe0 droite","label":"S\xe9lectionner la position d\'alimentation de commande","description":"S\xe9lectionnez l\u2019endroit o\xf9 vous souhaitez que le flux de commandes apparaisse sur votre \xe9cran."},"micPosition":{"title":"Position de la fen\xeatre d\'entr\xe9e du microphone","description":"S\xe9lectionnez l\'endroit o\xf9 vous souhaitez que les commandes du microphone pour la voix et la dict\xe9e soient positionn\xe9es sur votre \xe9cran.","label":"S\xe9lectionnez la position de la fen\xeatre d\u2019entr\xe9e du microphone"},"cameraPosition":{"title":"Position de la fen\xeatre d\'entr\xe9e de la cam\xe9ra","description":"S\xe9lectionnez l\'endroit o\xf9 vous souhaitez que les commandes de la cam\xe9ra pour les mouvements du visage et de la t\xeate soient positionn\xe9es sur votre \xe9cran.","label":"S\xe9lectionner la position de la fen\xeatre d\'entr\xe9e de la cam\xe9ra"},"theme":{"title":"Th\xe8me","description":"Choisissez un th\xe8me qui correspond \xe0 votre style.","label":"S\xe9lectionnez un th\xe8me","light":"Lumi\xe8re","dark":"Sombre","system":"Utiliser les param\xe8tres du syst\xe8me d\'exploitation"},"overlay":{"title":"Flux de commandes","description":"Le flux de commandes affiche les diff\xe9rentes commandes que vous utilisez et celles envoy\xe9es \xe0 votre ordinateur. Il est accessible par clic, mais il est toujours visible par-dessus les autres fen\xeatres. Lorsque ce param\xe8tre est activ\xe9, l\'application Cephable s\'affiche et est toujours visible par-dessus les autres fen\xeatres et applications.","question":"Afficher le flux de commandes\xa0?"},"transparent":{"title":"Transparence du flux de commandes","description":"D\xe9termine l\'opacit\xe9 du texte. Plus la valeur est faible, plus le flux sera transparent."},"panelAutoHide":{"title":"Masquer automatiquement le panneau Cephable","delay":"Attendre avant de se cacher","denominator":"secondes","time":"{{value}} secondes"},"title":"Param\xe8tres g\xe9n\xe9raux de l\'application"},"input":{"title":"Saisir","titlePlural":"Contr\xf4les d\'entr\xe9e","explore":"Explorer les contr\xf4les de saisie","descriptionShort":"Explorez les diff\xe9rents contr\xf4les d\'entr\xe9e utilis\xe9s par Cephable pour cr\xe9er une meilleure exp\xe9rience num\xe9rique pour vous.","typeLabel":"Type de contr\xf4le d\'entr\xe9e","toolTip":"Cela utilise {{alt}}","remove":"Supprimer le contr\xf4le d\'entr\xe9e","filter":"Filtrer par type d\'entr\xe9e","select":"S\xe9lectionnez une entr\xe9e","question":"Quel type d\'entr\xe9e souhaitez-vous utiliser\xa0?","add":"Ajouter une entr\xe9e","addMore":"Ajouter une autre entr\xe9e","removeItem":"Supprimer l\'\xe9l\xe9ment {{index}}","item":"Article {{index}}\xa0:\xa0{{label}}","duplicate":"Les articles en double ne sont pas autoris\xe9s.","maximum":"Maximum de {{maxItems}} \xe9l\xe9ments autoris\xe9s.","description":"Les commandes d\'entr\xe9e sont les diff\xe9rentes m\xe9thodes utilis\xe9es pour contr\xf4ler votre appareil. Elles incluent votre voix, les mouvements de la t\xeate, les expressions faciales et d\'autres connexions. Explorez les diff\xe9rentes commandes d\'entr\xe9e ci-dessous pour en savoir plus."},"time":{"soon":"\xc0 venir","now":"Maintenant","today":"Aujourd\'hui","yesterday":"Hier","minutesAgo":"il y a {{count}}\xa0minute","minutesAgo_plural":"il y a {{count}}\xa0minutes","daysAgo":"Il y a {{count}}\xa0jours","daysAgo_plural":"il y a {{count}}\xa0jours","monthsAgo":"il y a {{count}}\xa0mois","monthsAgo_plural":"il y a {{count}}\xa0mois","yearsAgo":"Il y a {{count}}\xa0an","yearsAgo_plural":"il y a {{count}} ans","minutesAhead":"dans {{count}}\xa0minutes","todayAhead":"plus tard aujourd\'hui","tomorrow":"demain","daysAhead":"dans {{count}}\xa0jours","monthsAhead":"dans {{count}}\xa0mois","yearsAhead":"dans {{count}} ans"},"peripherals":{"empty":"Aucun p\xe9riph\xe9rique d\xe9tect\xe9","switch":"Changer","keyboard":"Clavier","gamepad":"Manette de jeu","companionApp":"Application compagnon","available":"disponible \xe0 l\'emploi","error":"V\xe9rifiez vos param\xe8tres."},"camera":{"windowTitle":"Commandes de cam\xe9ra c\xe9phable","title":"Cam\xe9ra","titlePlural":"Appareils photo","settings":"Les param\xe8tres de la cam\xe9ra","start":"D\xe9marrer la cam\xe9ra","restart":"Red\xe9marrer la cam\xe9ra","descriptionShort":"Permet l\'expression du visage et le mouvement de la t\xeate.","description":"Utilisez votre appareil photo pour d\xe9tecter les expressions du visage et les gestes du corps comme diff\xe9rentes commandes.","empty":"Aucune cam\xe9ra trouv\xe9e.","search":"Rechercher par nom de cam\xe9ra","loading":"Chargement des commandes de la cam\xe9ra...","error":"Erreur inattendue lors du chargement des commandes de la cam\xe9ra. Veuillez v\xe9rifier votre cam\xe9ra et r\xe9essayer.","manage":{"title":"Cliquez pour afficher et g\xe9rer les d\xe9tails de vos cam\xe9ras.","description":""},"detected":{"face":"Visage d\xe9tect\xe9.","noFace":"Aucun visage d\xe9tect\xe9. Veuillez ajuster votre cam\xe9ra ou votre position et r\xe9essayer.","command":"D\xe9tect\xe9\xa0: {{commande}}"},"permission":{"title":"Autorisations de cam\xe9ra requises","description":"Vous devez autoriser Cephable \xe0 utiliser votre appareil photo pour utiliser les commandes du visage et du corps.","button":"Param\xe8tres d\'autorisation d\'ouverture","no":"Pas d\'acc\xe8s \xe0 la cam\xe9ra","help":"Cephable a besoin d&#39;acc\xe9der \xe0 votre cam\xe9ra pour utiliser les commandes d&#39;expression et de t\xeate. Acc\xe9dez \xe0 <strong>Param\xe8tres syst\xe8me</strong>  <strong>Confidentialit\xe9</strong>  <strong>Cam\xe9ra</strong> et activez Cephable pour acc\xe9der \xe0 votre cam\xe9ra."},"controls":{"startData":"J\'ai commenc\xe9 \xe0 enregistrer les donn\xe9es du visage. Appuyez \xe0 nouveau sur le raccourci dans la fen\xeatre de l\'appareil photo pour arr\xeater l\'enregistrement et le t\xe9l\xe9chargement.","downloadData":"Enregistrement arr\xeat\xe9, t\xe9l\xe9chargement de donn\xe9es","paused":"Commandes de cam\xe9ra suspendues.","pause":"Suspendre les commandes de la cam\xe9ra","resume":"Reprendre les commandes de la cam\xe9ra","resumed":"Reprise des contr\xf4les de la cam\xe9ra.","linesOn":"Activer les lignes du visage","linesOff":"D\xe9sactiver les lignes du visage","linesToggle":"Activer/d\xe9sactiver le dessin des lignes du visage","noDeviceTitle":"Aucune cam\xe9ra d\xe9tect\xe9e pouvant \xeatre utilis\xe9e avec Cephable.","noDeviceDescription":"Vous devez connecter une cam\xe9ra compatible avec les applications mobiles.","noDeviceConnectedDescription":"Le contr\xf4le de la cam\xe9ra sert d\'aper\xe7u de l\'interface. Aucune \xe9tape ne sera ex\xe9cut\xe9e avec succ\xe8s. Connectez cet appareil compagnon \xe0 un autre, afin de lancer des commandes.","lines":"Lignes du visage"},"switch":{"title":"Changer de cam\xe9ra","description":"S\xe9lectionnez une autre cam\xe9ra \xe0 utiliser pour les commandes du visage et du corps.","select":"S\xe9lectionnez la cam\xe9ra","next":"Cam\xe9ra suivante","nextLong":"Passer \xe0 la cam\xe9ra suivante","empty":"Aucune autre cam\xe9ra trouv\xe9e.","search":"Rechercher par nom de cam\xe9ra"},"baseline":{"title":"R\xe9f\xe9rence","description":"La ligne de base est la position par d\xe9faut de votre visage et de votre corps que Cephable utilise pour d\xe9terminer vos mouvements. Vous pouvez mettre \xe0 jour et r\xe9initialiser la ligne de base ici.","update":"Mettre \xe0 jour la r\xe9f\xe9rence","reset":"R\xe9initialiser la ligne de base","updated":"Base de r\xe9f\xe9rence mise \xe0 jour","tooltip":"Cliquez pour mettre \xe0 jour votre ligne de base vers votre position de repos actuelle."},"edit":{"title":"Modifier les param\xe8tres de la cam\xe9ra","description":"Vous pouvez affiner les param\xe8tres de vos entr\xe9es n\xe9cessitant une cam\xe9ra pour mieux r\xe9pondre \xe0 vos besoins.","autoStart":{"title":"D\xe9marrer automatiquement la cam\xe9ra","option":"D\xe9marrage automatique de la cam\xe9ra et des commandes de t\xeate/expression\xa0?","description":"Lorsque ce param\xe8tre est activ\xe9, votre manette activera votre cam\xe9ra, vous permettant d\'utiliser les expressions faciales et les mouvements de la t\xeate d\xe8s le d\xe9marrage de l\'application. Si ce param\xe8tre est d\xe9sactiv\xe9, appuyez sur le bouton \xab\xa0D\xe9marrer la cam\xe9ra\xa0\xbb sur votre page de connexion."},"head":{"title":"Sensibilit\xe9 aux mouvements de la t\xeate","description":"La sensibilit\xe9 indique \xe0 Cephable jusqu\'o\xf9 vous devez vous d\xe9placer pour d\xe9clencher un contr\xf4le. Plus la valeur est grande (la plus \xe0 droite du curseur), plus la sensibilit\xe9 est \xe9lev\xe9e, et donc moins vous aurez besoin de vous d\xe9placer pour d\xe9clencher la commande.","tilt":{"title":"Sensibilit\xe9 \xe0 l\'inclinaison de la t\xeate","description":"Ces valeurs d\xe9terminent jusqu\'o\xf9 vous devez incliner la t\xeate vers le haut, le bas, la gauche et la droite pour d\xe9clencher les commandes.","up":"Sensibilit\xe9 \xe0 l\'inclinaison","down":"Sensibilit\xe9 d\'inclinaison vers le bas","left":"Sensibilit\xe9 d\'inclinaison \xe0 gauche","right":"Sensibilit\xe9 d\'inclinaison \xe0 droite","scaleHigh":"L\xe9g\xe8re inclinaison","scaleLow":"Grande inclinaison"},"turn":{"title":"Sensibilit\xe9 au tour de t\xeate","description":"Ces valeurs d\xe9terminent jusqu\'o\xf9 vous devez tourner la t\xeate vers la gauche et la droite pour d\xe9clencher les commandes.","left":"Tourner \xe0 gauche Sensibilit\xe9","right":"Tourner \xe0 droite Sensibilit\xe9","scaleHigh":"L\xe9ger virage","scaleLow":"Grand virage"},"lean":{"title":"Sensibilit\xe9 de la t\xeate maigre","description":"Ces valeurs d\xe9terminent jusqu\'o\xf9 vous devez pencher la t\xeate en avant et en arri\xe8re pour d\xe9clencher les commandes.","forward":"Sensibilit\xe9 \xe0 se pencher vers l\u2019avant","back":"Sensibilit\xe9 \xe0 se pencher en arri\xe8re","right":"Sensibilit\xe9 maigre \xe0 droite","left":"Sensibilit\xe9 maigre \xe0 gauche","scaleHigh":"L\xe9g\xe8rement pench\xe9","scaleLow":"Grand maigre"},"duck":{"title":"Sensibilit\xe9 t\xeate canard/mont\xe9e","description":"Ces valeurs d\xe9terminent jusqu\'o\xf9 vous devez baisser ou relever la t\xeate pour d\xe9clencher les commandes.","down":"Sensibilit\xe9 au duvet de canard","up":"Augmentez la sensibilit\xe9","scaleHigh":"L\xe9ger d\xe9calage","scaleLow":"Grand changement"}},"face":{"title":"Sensibilit\xe9 \xe0 l\'expression du visage","description":"La sensibilit\xe9 indique \xe0 Cephable \xe0 quel point une expression est exag\xe9r\xe9e dont vous avez besoin pour d\xe9clencher un contr\xf4le. Plus la valeur est grande (la plus \xe0 droite du curseur), plus la sensibilit\xe9 est \xe9lev\xe9e, et donc moins vous aurez besoin de vous d\xe9placer pour d\xe9clencher la commande.","eyebrow":{"title":"Sensibilit\xe9 des sourcils","description":"Ces valeurs d\xe9terminent jusqu\'o\xf9 vous devez lever ou baisser vos sourcils pour d\xe9clencher les commandes.","up":"Augmenter la sensibilit\xe9 des sourcils","scaleHigh":"L\xe9g\xe8re augmentation","scaleLow":"Augmentation importante"},"mouth":{"title":"Sensibilit\xe9 buccale","description":"Ces valeurs d\xe9terminent jusqu\'o\xf9 vous devez ouvrir ou fermer la bouche pour d\xe9clencher les commandes.","open":"Sensibilit\xe9 \xe0 la bouche ouverte","close":"Sensibilit\xe9 de la bouche ferm\xe9e","smile":"Sensibilit\xe9 du sourire","scaleHigh":"L\xe9g\xe8rement ouvert","scaleLow":"Grand Ouvert","closeScaleHigh":"L\xe9g\xe8rement ferm\xe9","closeScaleLow":"Bien ferm\xe9","smileScaleHigh":"L\xe9ger sourire","smileScaleLow":"Grand sourire"}},"mouse":{"title":"Mouvement de la t\xeate pour les commandes de la souris","description":"D\xe9terminez si et comment vous souhaitez utiliser les commandes de mouvements de la t\xeate pour d\xe9placer votre souris au lieu de d\xe9clencher d\'autres sorties.","enable":{"title":"Activer le mouvement de la t\xeate pour les commandes de la souris","description":"Si cette option est activ\xe9e, certaines de vos commandes de mouvement de la t\xeate seront utilis\xe9es pour d\xe9placer votre souris au lieu des commandes de d\xe9clenchement.","option":"Utiliser les commandes de la t\xeate pour le mouvement de la souris\xa0?"},"input":{"title":"Type d\'entr\xe9e de la souris","description":"S\xe9lectionnez le type de gestes de la t\xeate que vous souhaitez attribuer aux commandes de la souris. Par exemple, Head Tilting signifie que vous pouvez incliner votre t\xeate vers la gauche et la droite pour d\xe9placer votre souris vers la gauche et la droite, Head Turning signifie que vous pouvez tourner la t\xeate vers la gauche et la droite pour d\xe9placer votre souris et Head Leaning signifie que vous pouvez vous pencher vers la gauche et la droite pour bouger. votre souris.","option":"S\xe9lectionnez le type d\'entr\xe9e","optionLong":"S\xe9lectionnez le type de mouvement de t\xeate que vous souhaitez utiliser pour contr\xf4ler votre souris."},"invert":{"title":"Inverser le mouvement de la souris","description":"Si cette option est activ\xe9e, la direction dans laquelle vous d\xe9placez votre t\xeate sera invers\xe9e par rapport \xe0 la direction dans laquelle votre souris se d\xe9place. Pour l\'axe X\xa0: si cette option est activ\xe9e, un d\xe9placement vers la gauche d\xe9placera votre souris vers la droite et un d\xe9placement vers la droite la d\xe9placera vers la gauche. Pour l\'axe Y\xa0: si cette option est activ\xe9e, le fait de descendre d\xe9placera votre souris vers le haut et le fait de monter la fera descendre.","x":"Inverser le mouvement de la souris sur l\'axe X\xa0?","y":"Inverser le mouvement de la souris sur l\'axe Y\xa0?"},"mode":{"title":"Mode de d\xe9placement de la souris","description":"S\xe9lectionnez la mani\xe8re dont vous souhaitez que le curseur r\xe9agisse aux mouvements de votre t\xeate."},"speed":{"title":"Vitesse de la souris","description":"D\xe9terminez la vitesse constante \xe0 laquelle vous souhaitez que le curseur se d\xe9place.","fast":"Rapide","slow":"Lent"},"linear":{"title":"Mouvement lin\xe9aire de la souris","description":"Si cette option est activ\xe9e, le curseur se d\xe9place uniquement en lignes droites horizontales ou verticales, ce qui facilite la navigation dans ces directions sp\xe9cifiques sans aucune d\xe9rive diagonale.","option":"Utiliser le mouvement lin\xe9aire de la souris\xa0?"},"accelerationRate":{"title":"Taux d\'acc\xe9l\xe9ration de la souris","description":"Ajustez la vitesse \xe0 laquelle le curseur acc\xe9l\xe8re au fur et \xe0 mesure que vous maintenez votre t\xeate immobile."},"accelerationCurve":{"title":"Courbe d\'acc\xe9l\xe9ration de la souris","description":"Ajustez la vitesse \xe0 laquelle la vitesse du curseur augmente par rapport au mouvement de la t\xeate.","linear":"Lin\xe9aire","exponential":"Exponentiel","sublinear":"Sous-lin\xe9aire"},"maximumSpeed":{"title":"Vitesse maximale de la souris","description":"D\xe9terminez le nombre maximal de pixels que le curseur peut d\xe9placer par seconde."},"steadyGlide":{"title":"Glisse stable","description":"Lorsque vous d\xe9placez votre t\xeate au-del\xe0 d\u2019un certain point, le curseur glisse continuellement dans cette direction \xe0 une vitesse constante."},"speedBoost":{"title":"Augmentation de la vitesse","description":"Le curseur commence \xe0 se d\xe9placer plus rapidement \xe0 mesure que vous gardez la t\xeate dans la m\xeame position. Plus vous gardez la t\xeate immobile longtemps, plus le curseur acc\xe9l\xe8re rapidement."},"dynamicGlide":{"title":"Glisse dynamique","description":"La vitesse du curseur augmente en fonction de la distance \xe0 laquelle vous bougez la t\xeate. Plus vous bougez la t\xeate, plus le curseur glisse vite."},"proportionalSpeed":{"title":"Vitesse proportionnelle","description":"Le curseur suit le bout de votre nez proportionnellement aux dimensions de votre \xe9cran."},"off":{"title":"D\xe9sactiv\xe9","description":"Le mouvement de la souris est d\xe9sactiv\xe9."},"disabled":"Cette fonctionnalit\xe9 est d\xe9sactiv\xe9e pour les connexions et extensions distantes."}},"stop":"Arr\xeater la cam\xe9ra","show":"Afficher la cam\xe9ra","hide":"Masquer la cam\xe9ra","warn":"Les commandes de la cam\xe9ra n\'ont pas \xe9t\xe9 d\xe9marr\xe9es, d\xe9marrez votre cam\xe9ra pour autoriser les commandes du visage et du corps.","draw":{"error":"Erreur lors du chargement du flux de la cam\xe9ra. Veuillez v\xe9rifier votre cam\xe9ra et r\xe9essayer."},"select":"S\xe9lectionnez une cam\xe9ra avec laquelle vous souhaitez vous associer pour des commandes am\xe9lior\xe9es \xe0 l\'aide de votre visage, de votre corps et des boutons d\'action rapide."},"microphone":{"windowTitle":"Commandes vocales c\xe9phables","title":"Microphone","titlePlural":"Micros","settings":"Param\xe8tres du microphone","start":"D\xe9marrer le microphone","stop":"Arr\xeater le microphone","descriptionShort":"Permet les commandes vocales et la dict\xe9e.","description":"Utilisez votre microphone int\xe9gr\xe9 pour activer les commandes vocales et la dict\xe9e.","select":"S\xe9lectionnez un microphone avec lequel vous souhaitez vous associer pour des commandes am\xe9lior\xe9es \xe0 l\'aide de votre voix.","empty":"Aucun microphone trouv\xe9.","search":"Rechercher par nom de microphone","manage":{"title":"Cliquez pour afficher et g\xe9rer les d\xe9tails de vos microphones.","description":""},"permission":{"title":"Autorisations de microphone requises","description":"Vous devez autoriser Cephable \xe0 utiliser votre microphone pour utiliser les commandes vocales.","button":"Param\xe8tres d\'autorisation d\'ouverture","no":"Pas d\'acc\xe8s au microphone","help":"Cephable a besoin d&#39;acc\xe9der \xe0 votre microphone pour utiliser les commandes vocales. Acc\xe9dez \xe0 <strong>Param\xe8tres syst\xe8me</strong>  <strong>Confidentialit\xe9</strong>  <strong>Microphone</strong> et activez Cephable pour acc\xe9der \xe0 votre microphone."},"controls":{"pause":"Suspendre les commandes vocales","paused":"Contr\xf4les suspendus.","resume":"Reprendre les commandes vocales","dictationPlay":"D\xe9marrer le mode dict\xe9e","dictationPause":"Arr\xeater le mode dict\xe9e","prompt":"Commencez \xe0 parler pour voir vos commandes vocales ici...","dictationPrompt":"Commencez \xe0 parler pour taper ce que vous dites...","latency":"Latence \xe9lev\xe9e d\xe9tect\xe9e. Pensez \xe0 fermer certaines applications susceptibles de consommer trop de ressources.","noDeviceConnectedDescription":"Le contr\xf4le du microphone sert d\'aper\xe7u de l\'interface. Aucune \xe9tape ne sera ex\xe9cut\xe9e avec succ\xe8s. Connectez cet appareil compagnon \xe0 un autre, afin de lancer des commandes.","status":{"paused":"En pause.","dictating":"Dicter.","optimistic":"Optimiste:","listening":"\xc9coute:","loadingModel":"Chargement du mod\xe8le vocal...","thinking":"Pens\xe9e...","loadingPhiModel":"Chargement du mod\xe8le de g\xe9n\xe9ration de texte...","generatingText":"G\xe9n\xe9rateur...","preparingPhiModel":"Pr\xe9paration du mod\xe8le de g\xe9n\xe9ration de texte...","permission":"V\xe9rification des autorisations du microphone...","typing":"Dactylographie..."},"loadingDetail":"Cela peut prendre quelques minutes.","generatingTextDetail":"Arr\xeatez la g\xe9n\xe9ration en changeant d\'application ou en disant \xab arr\xeatez de g\xe9n\xe9rer \xbb"},"edit":{"title":"Modifier les param\xe8tres du microphone","autoStart":{"title":"D\xe9marrer automatiquement le microphone","option":"Microphone \xe0 d\xe9marrage automatique et commandes vocales\xa0?","description":"Lorsque ce param\xe8tre est activ\xe9, votre p\xe9riph\xe9rique d\'entr\xe9e activera les microphones et commencera \xe0 traiter les commandes vocales d\xe8s son d\xe9marrage, apr\xe8s l\'avoir branch\xe9 ou allum\xe9. Si ce param\xe8tre est d\xe9sactiv\xe9, vous devez appuyer sur le bouton \xab\xa0Commencer l\'\xe9coute\xa0\xbb dans votre page de connexion."},"optimistic":{"title":"Commandes vocales optimistes","option":"Utiliser les commandes vocales optimistes\xa0?","description":"Cephable propose deux modes de sensibilit\xe9 diff\xe9rents pour les commandes vocales\xa0: Standard et Optimiste. Le mode Standard permet \xe0 Cephable de reconna\xeetre tous les mots qu\'il comprend et peut \xeatre utilis\xe9 avec le mode dict\xe9e. Le mode Optimiste indique \xe0 Cephable de se concentrer davantage sur les commandes vocales dans les commandes de votre application. Avec le mode Optimiste activ\xe9, vos commandes vocales se d\xe9clenchent plus rapidement, mais vous pouvez \xe9galement d\xe9clencher accidentellement votre commande si vous ne prononcez pas le mot exact. Le mode Optimiste ne permet pas la dict\xe9e."},"confirm":{"title":"Vous avez des changements non enregistr\xe9s.","description":"Modifications non enregistr\xe9es d\xe9tect\xe9es. Souhaitez-vous enregistrer avant de quitter\xa0?"},"aiCommands":{"title":"Commandes vocales intelligentes","description":"Gr\xe2ce aux commandes vocales intelligentes, l\'IA de Cephable pr\xe9dit les commandes vocales que vous essayez d\'utiliser sans avoir \xe0 les reproduire exactement. Vous pouvez ainsi indiquer plus naturellement \xe0 votre ordinateur ce qu\'il doit faire, et Cephable vous aide \xe0 le comprendre.","option":"Utiliser des commandes vocales intelligentes\xa0?"},"aiDictation":{"title":"Dict\xe9e intelligente et saisie rapide","description":"La dict\xe9e intelligente et la saisie rapide offrent l\'exp\xe9rience de saisie la plus pr\xe9cise sur appareil. La dict\xe9e g\xe8re automatiquement la ponctuation, les noms propres et la structure des phrases, tandis que la saisie rapide propose des pr\xe9dictions et des corrections intelligentes pour une \xe9criture facile et pr\xe9cise.","option":"Utiliser la dict\xe9e intelligente et la saisie rapide\xa0?"},"description":"G\xe9rez vos commandes vocales et vos param\xe8tres de dict\xe9e pour cette connexion."},"warn":"Votre microphone n\'est pas activ\xe9. Activez-le pour autoriser les commandes vocales et la dict\xe9e.","devices":{"error":"P\xe9riph\xe9rique d\'entr\xe9e du microphone introuvable."},"startDescription":"Allumez le microphone pour commencer \xe0 \xe9couter les commandes."},"localization":{"title":"Param\xe8tres de langue","titleShort":"Langue","description":"Choisissez votre langue pr\xe9f\xe9r\xe9e dans une liste de langues prises en charge.","newUserDescription":"Veuillez s\xe9lectionner une langue pr\xe9f\xe9r\xe9e avant de continuer.","edit":"Modifier les pr\xe9f\xe9rences","display":{"title":"Langue d\'affichage","description":"Langue d\'affichage lors de l\'utilisation de Cephable. Cela inclut les menus, les notifications et les commandes des applications, affich\xe9s dans la langue de votre choix."},"voice":{"title":"Langue de commande vocale","description":"C\'est la langue utilis\xe9e lors de la reconnaissance des dict\xe9es et des commandes vocales. La sp\xe9cification de la langue am\xe9liore la pr\xe9cision de vos saisies vocales.","settings":{"title":"Reconnaissance vocale et langue d\'affichage","description":"Ajustez vos param\xe8tres de langue pour l\'affichage et les commandes vocales. Cette option vous permet de s\xe9lectionner vos langues pr\xe9f\xe9r\xe9es pour le texte \xe0 l\'\xe9cran et les interactions avec le microphone, comme les commandes vocales et la dict\xe9e."}},"locales":{"en":"English - Anglais","en-us":"English (US) - Anglais (\xc9tats-Unis)","es":"Espa\xf1ol - Espagnol","fr":"Fran\xe7ais","it":"Italiano \u2014 Italien","de":"Deutsch - Allemand","ja":"\u65E5\u672C\u8A9E - Japonais","en-gb":"English (UK) - Anglais (Royaume-Uni)","en-in":"English (India) - Anglais (Inde)"},"save":{"success":"Pr\xe9f\xe9rences locales de l\'utilisateur enregistr\xe9es\xa0!","error":"Erreur lors de l\'enregistrement des pr\xe9f\xe9rences de param\xe8tres r\xe9gionaux de l\'utilisateur"},"profile":{"view":"Variantes","title":"Langue de contr\xf4le des applications","question":"Quelle langue de contr\xf4le d\'application souhaitez-vous modifier\xa0?","description":"Certaines commandes d\'application proposent des variantes linguistiques. Changez de langue pour les modifier et les personnaliser.","change":"Changer de langue"},"unsupported":{"title":"Langue non prise en charge {{locale}}","description":"La langue s\xe9lectionn\xe9e n\'est pas prise en charge. Veuillez choisir une autre langue."},"select":"S\xe9lectionner la langue","localesShort":{"en":"Anglais","en-us":"Anglais (\xc9tats-Unis)","es":"Espagnol","fr":"Fran\xe7ais","it":"italien","de":"Allemand","ja":"japonais"}},"mobileApp":{"title":"Application mobile"},"skipToMain":"Acc\xe9der au Contenu Principal","dashboard":{"title":"Tableau de bord"},"developer":{"title":"Promoteur","titleLong":"Ressources pour les d\xe9veloppeurs","description":"Cephable peut \xeatre int\xe9gr\xe9 directement dans votre application, jeu ou service \xe0 l\'aide de nos SDK.","sdk":{"title":"D\xe9couvrez nos SDK","description":"Nous fournissons des SDK de premier ordre con\xe7us pour int\xe9grer de mani\xe8re transparente la reconnaissance vocale et les contr\xf4les adaptatifs dans vos applications. Nos outils sont con\xe7us pour am\xe9liorer l\'interaction des utilisateurs gr\xe2ce \xe0 des commandes intuitives et pour favoriser l\'accessibilit\xe9, garantissant ainsi que votre logiciel peut \xeatre utilis\xe9 plus efficacement par tous les utilisateurs.","javascript":{"title":"JavaScript","subtitle":"Web","description":"Int\xe9grez les commandes vocales et adaptatives directement dans vos applications Web.","action":"Obtenir le Package NPM"},"net":{"title":".NET","subtitle":"Applications Windows","description":"Exploitez la puissance de .NET pour cr\xe9er des applications avec nos SDK WPF et WinUI3.","actionCore":"Obtenez le Package de base","actionWpf":"Obtenir le Package WPF"},"android":{"title":"Andro\xefde","subtitle":"Appareils mobiles","description":"Applications Android con\xe7ues pour faciliter les capacit\xe9s de voix et de mouvement de la t\xeate.","action":"Obtenir le SDK Android"},"more":{"title":"Plus","description":"Vous ne trouvez pas ce que vous cherchez ? Contactez-nous et nous pourrons vous aider.","action":"Demander un SDK"}},"demo":{"title":"D\xe9mos","titleLong":"D\xe9couvrez nos SDK en action","description":"D\xe9couvrez la puissance de nos technologies de contr\xf4le de la voix et des mouvements de la t\xeate gr\xe2ce \xe0 nos exemples d\'applications. Des jeux interactifs aux applications Web et mobiles dynamiques, chaque exemple d\xe9montre la polyvalence et l\'efficacit\xe9 de nos SDK. Explorez ces exemples pour obtenir des informations et des id\xe9es pour int\xe9grer une accessibilit\xe9 am\xe9lior\xe9e et des exp\xe9riences immersives dans vos propres projets.","game":{"title":"Jeu 2048","subtitle":"Web","description":"Am\xe9liorez le gameplay traditionnel avec des commandes adaptatives de voix et de mouvement de la t\xeate.","action":"Jouer le jeu"},"unity":{"title":"Unit\xe9","subtitle":"D\xe9veloppement de jeux","description":"D\xe9couvrez comment les commandes adaptatives peuvent \xeatre exploit\xe9es dans les jeux pour offrir une exp\xe9rience utilisateur plus attrayante.","action":"Obtenir l\'\xe9chantillon"},"samples":"D\xe9mos et \xe9chantillons","other":{"title":"Autres d\xe9mos","description":"D\xe9couvrez de premi\xe8re main comment Cephable peut am\xe9liorer votre application, votre jeu ou votre appareil.","action":"Voir plus de d\xe9mos"},"web":{"title":"Exemples de SDK Web","subtitle":"Web","description":"Int\xe9gration simple de toutes nos fonctionnalit\xe9s principales dans les applications Web.","action":"D\xe9couvrez le SDK"}},"other":{"title":"Autres ressources","description":"Si vous ne trouvez pas ce dont vous avez besoin dans nos SDK, essayez de travailler directement avec nos API ou contactez la communaut\xe9 pour obtenir de l\'aide, de l\'inspiration et du soutien.","api":{"title":"API","description":"Nos API vous permettent d\'interagir directement avec Cephable. Vous pouvez utiliser nos API pour cr\xe9er des int\xe9grations personnalis\xe9es."},"support":{"title":"Soutien","description":"Vous ne trouvez pas ce que vous cherchez ? Contactez notre communaut\xe9 via Discord.","action":"Rejoignez Discord"}}},"invalidNumber":"N/A","upgrade":"Mise \xe0 niveau","license":{"trial":{"subtitle":"Vous pouvez inviter {{count}} coll\xe8gues \xe0 essayer Cephable avec vous.","noUsersSubtitle":"Il ne vous reste plus d\'utilisateurs d\'essai. Passez \xe0 une licence payante pour ajouter plus d\'utilisateurs.","expired":{"user":"Votre mise \xe0 niveau gratuite vers {{productName}} expire le {{date}}. Pour effectuer une mise \xe0 niveau, veuillez contacter l\'administrateur de votre organisation\xa0: {{admin}}.","admin":"Votre mise \xe0 niveau gratuite vers {{productName}} expire le {{date}}.","userLong":"Il semblerait que votre mise \xe0 niveau gratuite vers {{productName}} ait expir\xe9. Pour effectuer une mise \xe0 niveau, veuillez contacter l\'administrateur de votre organisation\xa0: {{admin}}.","adminLong":"Il semblerait que votre mise \xe0 niveau gratuite vers {{productName}} ait expir\xe9. Vous pouvez mettre \xe0 niveau votre licence pour continuer \xe0 acc\xe9der aux fonctionnalit\xe9s avanc\xe9es non disponibles dans Cephable Basic."},"start":"Commencez un essai gratuit","title":{"single":"Vous avez b\xe9n\xe9fici\xe9 d\'une mise \xe0 niveau gratuite vers {{productName}} avec {{days}} jours restants.","multiple":"{{organization}} est en essai gratuit avec {{days}} jours restants"},"upgrade":"En effectuant une mise \xe0 niveau, conservez votre acc\xe8s \xe0 des fonctionnalit\xe9s telles que les commandes vocales am\xe9lior\xe9es, les t\xe2ches intelligentes de l\'IA et de nombreuses commandes d\'applications pr\xe9d\xe9finies."},"required":{"title":"Une licence professionnelle Cephable est requise","description":"Il semble que vous utilisiez Cephable Basic, qui ne prend pas en charge l\'utilisation commerciale de Cephable. Veuillez passer \xe0 une licence professionnelle pour continuer \xe0 utiliser l\'application."},"upgrade":{"professional":"Mise \xe0 niveau vers la Licence Professionnelle Cephable","generic":{"title":"Am\xe9liorez Votre Exp\xe9rience Cephable","description":"La plateforme Cephable propose diff\xe9rents produits destin\xe9s \xe0 une utilisation commerciale au travail, \xe0 l\'\xe9cole ou int\xe9gr\xe9s dans des solutions natives."},"fallback":{"title":"Erreur lors du chargement du portail de facturation","description":"Impossible de charger le portail de facturation. Veuillez cliquer sur le bouton ci-dessous pour contacter sales@cephable.com afin de poursuivre la mise \xe0 niveau."}},"activate":{"question":"Vous avez d\xe9j\xe0 une cl\xe9 de licence ?","button":"Activer","title":"Activer la Cl\xe9 de Licence","description":"Saisissez votre cl\xe9 de licence pour mettre \xe0 niveau Cephable. Si vous n\'en avez pas, d\xe9marrez un essai gratuit ou achetez une licence.","fieldLabel":"Cl\xe9 de Licence","placeholder":"NkmurBfZzFrmm9Kx","success":"F\xe9licitations. Votre compte a \xe9t\xe9 mis \xe0 niveau vers {{license}}\xa0!","invalid":{"key":"Cl\xe9 non valide. Veuillez vous assurer que vous avez saisi la bonne cl\xe9.","empty":{"key":"Cl\xe9 non valide. Veuillez v\xe9rifier la valeur saisie.","name":"Nom d\'organisation non valide. Veuillez v\xe9rifier la valeur saisie."}},"descriptionLong":"Saisissez votre cl\xe9 de licence pour mettre \xe0 niveau Cephable. Si vous n\'en avez pas, d\xe9marrez un essai gratuit ou achetez une licence."},"welcome":{"title":"Bienvenue chez {{license}}.","description":"Vous avez rejoint avec succ\xe8s {{organization}}. {{description}}"},"redirect":{"title":"Redirection","description":"Vous avez \xe9t\xe9 redirig\xe9 vers un portail de facturation externe. Cela ouvrira un nouvel onglet dans votre navigateur. Si vous n\'\xeates pas redirig\xe9 dans quelques secondes, veuillez cliquer sur le bouton ci-dessous.","error":"Erreur de redirection de facturation","external":"Redirection effectu\xe9e. Veuillez v\xe9rifier votre navigateur."},"key":{"title":"Cl\xe9 de licence","titlePlural":"Cl\xe9s de licence","description":"Une cl\xe9 de licence est un identifiant unique utilis\xe9 pour accorder l\'acc\xe8s aux fonctionnalit\xe9s Cephable Professional, Education ou Developer.","details":"D\xe9tails de la cl\xe9 de licence","assigned":"Utilis\xe9 le : {{date}}","expires":"Expire le\xa0: {{date}}","assign":"Attribuer une cl\xe9 \xe0 une nouvelle organisation","error":"Erreur lors du chargement de la cl\xe9 de licence.","empty":{"title":"Aucune cl\xe9 de licence trouv\xe9e.","description":"Il ne semble pas qu\'il existe de cl\xe9s de licence correspondant \xe0 ces crit\xe8res. Ou vous n\'avez pas encore achet\xe9 de cl\xe9 de licence."},"product":{"title":"Achat","titleLong":"Acheter des cl\xe9s de licence","description":"Achetez une cl\xe9 de licence pour exploiter tout le potentiel de Cephable. Consultez les diff\xe9rents plans et options de tarification disponibles.","action":"Achetez maintenant","empty":{"title":"Aucun produit trouv\xe9.","description":"Il semble que vous n\'ayez aucun produit. Veuillez contacter notre \xe9quipe commerciale ou votre repr\xe9sentant pour vous aider \xe0 r\xe9soudre ce probl\xe8me."},"yearly":"Factur\xe9 annuellement","years":"Factur\xe9 tous les {{value}} ans","days":"Factur\xe9 tous les {{value}} jours","Subscription":{"title":"Abonnement"},"MeteredConsumption":{"title":"Consommation mesur\xe9e"},"PayDown":{"title":"Payer"},"OneTime":{"title":"Une fois"}}},"pro":{"tag":"Pro","detail":"Il s\'agit d\'une fonctionnalit\xe9 r\xe9serv\xe9e \xe0 Cephable Professional","requiredDetail":"Une licence Cephable Professionnelle est requise pour cette fonctionnalit\xe9. Vous pouvez mettre \xe0 niveau ou d\xe9marrer un essai gratuit dans les param\xe8tres de votre compte."},"titlePlural":"Licences"},"purchase":"Achat","saveError":"Erreur lors de l\'enregistrement des modifications.","description":"Description","expand":"D\xe9velopper","expandMenu":"D\xe9velopper le menu","editor":{"title":"\xc9diteur Markdown","bold":"Audacieux","italic":"Italique","underline":"Souligner","hr":"R\xe8gle horizontale","link":"Lien","quote":"Citation","code":"Code","codeBlock":"Bloc de code","comment":"Commentaire","image":"Image","table":"Tableau","unordered-list":"Liste non ordonn\xe9e","ordered-list":"Liste ordonn\xe9e","checked-list":"Liste de contr\xf4le","help":"Aide","edit":"Modifier","live":"En direct","preview":"Aper\xe7u","fullscreen":"Plein \xe9cran","placeholder":"Veuillez saisir le texte Markdown ici...","strikethrough":"Barr\xe9"},"created":"Cr\xe9\xe9\xa0: {{value}}","updated":"Mis \xe0 jour\xa0: {{value}}","deleted":"Supprim\xe9\xa0: {{value}}","expires":"Expire\xa0: {{value}}","expired":"Expir\xe9\xa0: {{value}}","used":"Utilis\xe9\xa0: {{value}}","results":"R\xe9sultats","panel":{"title":"Panneau C\xe9phable","question":"Panneau de d\xe9marrage automatique ?","position":{"top":"Haut","right":"Droite","left":"Gauche","bottom":"Bas ","description":"S\xe9lectionnez l\'endroit o\xf9 vous souhaitez que le panneau Cephable apparaisse sur votre \xe9cran.","label":"Position"},"sections":{"description":"Choisissez les sections visibles du panneau. Vous pouvez masquer des sections selon vos pr\xe9f\xe9rences pour optimiser l\'espace du panneau.","microphone":"Microphone et commandes vocales","camera":"Commandes de la cam\xe9ra et du visage/de la t\xeate","profile":"Contr\xf4les et aper\xe7us de l\'application","globalControls":"Contr\xf4les globaux et de p\xe9riph\xe9rique","tasks":"T\xe2ches intelligentes","buttons":"Boutons d\'action rapide"},"titleShort":"Panneau","description":"Voici le panneau de contr\xf4le principal. Toujours visible, il vous permet de contr\xf4ler vos applications \xe0 la voix, et bien plus encore."},"resume":"CV","textGeneration":{"settings":"Param\xe8tres de g\xe9n\xe9ration de texte","edit":{"title":"Modifier les param\xe8tres de g\xe9n\xe9ration de texte","description":"Vous pouvez affiner les param\xe8tres de votre g\xe9n\xe9ration de texte intelligente pour cr\xe9er les meilleures sorties pour vous.","autoStart":{"title":"G\xe9n\xe9ration automatique de texte de pr\xe9chauffage","description":"Lorsque ce param\xe8tre est activ\xe9, Cephable AI r\xe9chauffe automatiquement les mod\xe8les d\'IA utilis\xe9s pour la g\xe9n\xe9ration de texte. Cela acc\xe9l\xe8re les performances des mod\xe8les lors de l\'utilisation des commandes de g\xe9n\xe9ration, mais consomme davantage de ressources sur votre ordinateur. D\xe9sactiver ce param\xe8tre permet d\'\xe9conomiser des ressources, mais peut ralentir la g\xe9n\xe9ration de texte.","option":"Mod\xe8les d\'IA de g\xe9n\xe9ration de texte \xe0 pr\xe9chauffage automatique\xa0?"},"prompt":{"title":"Informations compl\xe9mentaires pour la g\xe9n\xe9ration de texte","description":"Saisissez les informations suppl\xe9mentaires \xe0 utiliser avec l\'IA de Cephable pour g\xe9n\xe9rer du texte. Utilisez ce champ pour indiquer vos pr\xe9f\xe9rences concernant le ton, le style d\'\xe9criture ou tout autre d\xe9tail.","field":"Invite suppl\xe9mentaire","placeholder":"Par exemple, adoptez un ton amical, \xe9crivez comme un professionnel, soyez concis et direct. Lorsque vous \xe9crivez du code, laissez des commentaires pertinents, mais pas trop nombreux, etc."},"enableTextGen":{"title":"Activer la g\xe9n\xe9ration de texte intelligente","description":"Lorsque ce param\xe8tre est activ\xe9, Cephable AI peut utiliser le contr\xf4le de g\xe9n\xe9ration de texte pour g\xe9n\xe9rer du texte dans n\'importe quelle application. D\xe9sactiver cette option d\xe9sactive cette commande.","option":"Utiliser la g\xe9n\xe9ration de texte intelligente ?"},"terminate":{"title":"Ressources de g\xe9n\xe9ration de texte clair","description":"Cliquez pour effacer les ressources utilis\xe9es pour la g\xe9n\xe9ration de texte. Cela lib\xe9rera des ressources sur votre ordinateur, mais pourrait ralentir la g\xe9n\xe9ration de texte lors de votre prochaine utilisation.","button":"Ressources claires","success":"Effacement des ressources de g\xe9n\xe9ration de texte.","confirm":{"title":"Ressources de g\xe9n\xe9ration de texte clair","description":"Voulez-vous vraiment lib\xe9rer les ressources utilis\xe9es pour la g\xe9n\xe9ration de texte\xa0? Cela lib\xe9rera des ressources sur votre ordinateur, mais pourrait ralentir la g\xe9n\xe9ration de texte lors de votre prochaine utilisation.","confirm":"Oui, des ressources claires","cancel":"Annuler"}},"clearModelCache":{"title":"Vider le cache du mod\xe8le d\'IA","description":"S\xe9lectionnez le mod\xe8le d\'IA dont vous souhaitez effacer le cache et le ret\xe9l\xe9charger. Cela lib\xe9rera de l\'espace sur votre ordinateur et t\xe9l\xe9chargera \xe0 nouveau les fichiers du mod\xe8le s\xe9lectionn\xe9.","button":"Effacer et ret\xe9l\xe9charger","success":"Fichiers de mod\xe8le locaux supprim\xe9s.","confirm":{"title":"Vider et ret\xe9l\xe9charger le cache du mod\xe8le d\'IA","description":"\xcates-vous s\xfbr de vouloir vider le cache du mod\xe8le d\'IA s\xe9lectionn\xe9 et supprimer les fichiers de votre syst\xe8me\xa0? Les mod\xe8les s\xe9lectionn\xe9s seront ret\xe9l\xe9charg\xe9s automatiquement.","confirm":"Oui, effacer et ret\xe9l\xe9charger","cancel":"Annuler","textGenLabel":"Text Generation (Inference) model","workflowsLabel":"AI Workflows models"},"error":"Erreur lors de la suppression des fichiers de mod\xe8le locaux."},"enableHistory":{"title":"Activer l\'historique de g\xe9n\xe9ration de texte","description":"Avec ce param\xe8tre activ\xe9, Cephable AI utilisera votre historique de g\xe9n\xe9ration de texte pour g\xe9n\xe9rer du texte avec le contexte de votre action pr\xe9c\xe9dente.","option":"Utiliser l\'historique de g\xe9n\xe9ration de texte\xa0?"}},"prompt":{"systemPrompt":"G\xe9n\xe9rez UNIQUEMENT le texte demand\xe9\xa0: sans explications, commentaires ni informations superflues. Aucun formatage Markdown ni explication non sollicit\xe9s. Pour le code, g\xe9n\xe9rez uniquement le code brut\xa0: sans balises, sans \xe9tiquettes de langage, sans explication.","appName":"Vous g\xe9n\xe9rez actuellement du texte pour {{appName}}.","userPreferences":"Respectez ces pr\xe9f\xe9rences utilisateur quant \xe0 la mani\xe8re dont ils souhaitent que le texte soit g\xe9n\xe9r\xe9\xa0: {{userPreferences}}."},"rewritePrompt":{"systemPrompt":"R\xe9\xe9crivez ou reformatez le texte fourni selon les instructions. En cas de reformatage (listes, tableaux, modifications de structure, etc.), conservez le texte original \xe0 l\'identique. En cas de r\xe9\xe9criture (ton, style, longueur, etc.), conservez le sens, mais pas n\xe9cessairement le vocabulaire. Affichez UNIQUEMENT le r\xe9sultat, sans explications ni commentaires. Ce r\xe9sultat peut faire partie d\'un document plus long. Affichez uniquement le r\xe9sultat, sans titres, \xe9tiquettes ni pr\xe9ambule.","userPreferences":"Respectez ces pr\xe9f\xe9rences utilisateur quant \xe0 la mani\xe8re dont ils souhaitent que le texte soit g\xe9n\xe9r\xe9\xa0: {{userPreferences}}.","rewriteInstructions":"Instructions : {{rewriteInstructions}}."},"translatePrompt":{"systemPrompt":"Traduisez le texte suivant en {{language}}. Affichez UNIQUEMENT le texte traduit. Sans explications, sans pr\xe9ambule, sans mise en forme Markdown, sans balises de code. Conservez la mise en forme. Pour le code\xa0: traduisez uniquement les commentaires et les cha\xeenes de caract\xe8res, en pr\xe9servant la syntaxe \xe0 l\u2019identique.","userPreferences":"Respectez ces pr\xe9f\xe9rences utilisateur quant \xe0 la mani\xe8re dont ils souhaitent que le texte soit g\xe9n\xe9r\xe9\xa0: {{userPreferences}}.","genericUserPrompt":"Traduire\xa0: {{userRequestText}}"},"disabled":{"title":"Les t\xe2ches intelligentes sont d\xe9sactiv\xe9es","description":"Il semble que vous ayez d\xe9sactiv\xe9 les t\xe2ches intelligentes. Mettez \xe0 jour vos param\xe8tres pour d\xe9bloquer la g\xe9n\xe9ration et la r\xe9\xe9criture de texte, et bien plus encore."},"summarizePrompt":{"systemPrompt":"R\xe9sumez le texte fourni de mani\xe8re concise. Il peut s\'agir d\'un extrait d\'un document plus long. Ne fournissez que le r\xe9sum\xe9, sans pr\xe9ambule, \xe9tiquettes ni explications.","userPreferences":"Respectez ces pr\xe9f\xe9rences utilisateur concernant la mani\xe8re dont le texte doit \xeatre g\xe9n\xe9r\xe9\xa0: {{userPreferences}}.","userPrompt":"R\xe9sum\xe9 : {{userRequestText}}"}},"profile":{"title":"Contr\xf4les de l\'application","titlePlural":"Contr\xf4les de l\'application","titlePreview":"Aper\xe7u des commandes","previous":"Contr\xf4les de l\'application pr\xe9c\xe9dente","manage":"G\xe9rer les contr\xf4les des applications","view":"Contr\xf4les d\'affichage","edit":"Modifier les contr\xf4les de l\'application","add":"Ajouter des contr\xf4les d\'application","create":"Cr\xe9er des contr\xf4les d\'application","warn":"La cam\xe9ra ou le microphone doivent \xeatre d\xe9marr\xe9s pour utiliser les commandes de votre application.","descriptionShort":"D\xe9couvrez les diff\xe9rentes mani\xe8res dont Cephable vous aide \xe0 contr\xf4ler vos appareils et logiciels.","name":"Nom de l\'application","nameQuestion":"Comment souhaitez-vous appeler ces contr\xf4les d\u2019application\xa0?","newName":"Nouveaux contr\xf4les d\'application","search":"Rechercher les contr\xf4les d\'application par nom","searchLong":"Rechercher les contr\xf4les d\'application par nom ou description","keyboardAndMouse":"Clavier et souris","genericController":"Manette de jeu","keyboardMouseAndController":"Clavier, souris et contr\xf4leur","permissionError":"Vous n\'\xeates pas autoris\xe9 \xe0 utiliser ces contr\xf4les d\'application.","set":{"title":"Il semble que vous n\'ayez pas encore d\xe9fini de contr\xf4les d\'application.","cta":"D\xe9finir les contr\xf4les de l\'application","empty":{"auto":"Passez \xe0 une autre application pour voir les commandes","select":"S\xe9lectionnez un contr\xf4le pour commencer","none":"Aucun contr\xf4le d\'application trouv\xe9"},"description":"Les contr\xf4les d\'application permettent \xe0 Cephable de savoir ce qu\'il doit \xe9couter et quelles actions il doit entreprendre. Vous pouvez changer de contr\xf4le d\'application \xe0 tout moment depuis la page d\'accueil ou dans vos param\xe8tres de connexion."},"summary":{"title":"R\xe9sum\xe9 des contr\xf4les de l\'application","descriptionLong":"Voici les d\xe9tails de ces commandes d\'application. Vous pouvez rechercher des commandes, des actions et plus encore pour d\xe9couvrir leurs possibilit\xe9s.","description":"Obtenez un r\xe9sum\xe9 de ces contr\xf4les d\'application, y compris les contr\xf4les existants, les personnalisations, les d\xe9tails et plus encore.","view":"Afficher le r\xe9sum\xe9 des contr\xf4les de l\'application","filter":"Filtrer par type d\'entr\xe9e","placeholder":"Rechercher les noms de contr\xf4le..."},"copy":{"title":"Copier les contr\xf4les de l\'application","duplicate":"Contr\xf4les d\'application en double","question":"Cr\xe9er une copie ?","description":"Vous souhaitez cr\xe9er une copie de ces contr\xf4les d\'application\xa0? Une nouvelle fen\xeatre s\'ouvrira avec ces contr\xf4les copi\xe9s, mais ils ne seront ajout\xe9s \xe0 votre compte qu\'apr\xe8s leur enregistrement.","confirm":"Oui, cr\xe9er une copie","profileSuffix":"{{name}} (copie)"},"new":{"title":"Cr\xe9er de nouveaux contr\xf4les d\'application","description":"Cr\xe9ez des commandes personnalis\xe9es \xe0 partir de z\xe9ro ou laissez l\'IA de pointe g\xe9n\xe9rer des commandes personnalis\xe9es, vous permettant de naviguer sans effort dans les applications et les logiciels \xe0 l\'aide de votre voix, de votre t\xeate et de vos gestes du visage.","note":"Recommand\xe9 pour les utilisateurs avanc\xe9s.","scratch":"Cr\xe9er \xe0 partir de z\xe9ro"},"advancedOptions":"Options de contr\xf4le avanc\xe9es","delete":{"title":"Supprimer les contr\xf4les de l\'application","titleLong":"Supprimez ces contr\xf4les d\'application","description":"Vous pouvez supprimer ces contr\xf4les d\'application en cliquant sur \xab\xa0Supprimer les contr\xf4les d\'application\xa0\xbb.","confirm":"\xcates-vous s\xfbr de vouloir supprimer ces contr\xf4les d\'application\xa0?","confirmLong":"Une fois ces contr\xf4les supprim\xe9s, vous ne pourrez plus y revenir. \xcates-vous s\xfbr de vouloir supprimer ces contr\xf4les\xa0?","confirmButton":"Oui, supprimez ces contr\xf4les d\'application"},"current":"Contr\xf4les actuels","loading":"Chargement des commandes...","null":"Vous n\'avez pas encore de contr\xf4les d\'application. Cliquez ci-dessous pour en cr\xe9er un.","nullButton":"Cr\xe9ez vos premiers contr\xf4les d\'application","preview":"Aper\xe7u","features":"Caract\xe9ristiques","byline_public":"Par : l\'\xe9quipe Cephable","byline_shared":"Partag\xe9 par : Communaut\xe9 Cephable","share":{"title":"Partager les contr\xf4les de l\'application","previewTitle":"Aper\xe7u des contr\xf4les d\'applications partag\xe9es","description":"Partagez ces contr\xf4les d\u2019application avec d\u2019autres afin qu\u2019ils puissent en obtenir une copie et les personnaliser \xe0 partir de l\xe0\xa0!","descriptionLong":"Partagez ces commandes d\'application avec d\'autres personnes pour qu\'elles puissent en obtenir une copie et les personnaliser\xa0! Choisissez le mode de partage souhait\xe9, puis cr\xe9ez un lien \xe0 envoyer.","add":"Cr\xe9er un lien de partage","confirm":"Partager cette URL","link":"Partager le lien","copy":"Copier le lien","copied":"Copi\xe9!","usage":"Montant d\'utilisation","created":"Cr\xe9\xe9 {{value}}","expiration":{"title":"Expiration","once":"Autoriser une seule utilisation","unlimited":"Autoriser une utilisation illimit\xe9e","no":"Aucune expiration","date":"Date d\'expiration","dateDescription":"Expire \xe0 une date pr\xe9cise"},"manage":"G\xe9rer les liens de partage pr\xe9c\xe9dents","empty":"Aucun partage n\'a \xe9t\xe9 cr\xe9\xe9 pour ces contr\xf4les d\'application."},"swap":{"title":"Contr\xf4les d\'\xe9change","titleLong":"\xc9changez les commandes de votre application","descriptionShort":"Utilisez diff\xe9rents contr\xf4les d\u2019application pour correspondre au programme ou au logiciel que vous utilisez.","description":"Vous pouvez basculer entre diff\xe9rents contr\xf4les d\'application pour correspondre au programme ou au logiciel que vous utilisez."},"autoProfileSwitching":{"title":"Commutation de commande automatique","alerts":{"disabled":"La commutation de contr\xf4le automatique est d\xe9sactiv\xe9e.","temporarilyDisabled":"La commutation de contr\xf4le automatique est temporairement d\xe9sactiv\xe9e.","enabled":"La commutation de contr\xf4le automatique est activ\xe9e.","error":"Erreur lors de l\'enregistrement des pr\xe9f\xe9rences de commutation de contr\xf4le automatique"},"associatedPrograms":{"add":"Ajouter un nouveau programme associ\xe9","description":{"personal":"Choisissez les logiciels ou programmes que vous souhaitez connecter \xe0 ces commandes. Ce syst\xe8me prend en charge la commutation automatique des commandes\xa0: Cephable adapte automatiquement les commandes de ces applications au programme que vous utilisez.","short":"Choisissez le logiciel ou les programmes que vous souhaitez connecter \xe0 ces commandes."},"edit":"Modifier les programmes associ\xe9s","noOptionsText":"Commencez \xe0 taper pour trouver les programmes associ\xe9s","profileLabel":"Contr\xf4les de l\'application\xa0:","remove":"Supprimer le programme associ\xe9","title":"Programmes associ\xe9s","when":"Cephable basculera automatiquement les contr\xf4les de mon application sur {{profileName}} lorsque j\'utilise...","emptySearch":"Aucun programme n\'est associ\xe9 \xe0 ces contr\xf4les.","error":"Erreur lors de l\'enregistrement des programmes associ\xe9s. Veuillez r\xe9essayer ult\xe9rieurement.","emptyError":"Programme associ\xe9 vide d\xe9tect\xe9, veuillez le supprimer avant de continuer."},"commandOverlay":{"command":"Contr\xf4les de commutation d\'application\xa0: {{value}}"},"description":"Le changement automatique de contr\xf4le permet \xe0 Cephable de s\'adapter parfaitement \xe0 votre flux de travail. Lorsqu\'il est activ\xe9, Cephable ajuste les contr\xf4les de votre application en fonction du programme ou du logiciel utilis\xe9. S\'il est d\xe9sactiv\xe9, vous pouvez changer manuellement de contr\xf4le d\'application \xe0 l\'aide du bouton \xab\xa0Changer de contr\xf4le\xa0\xbb ou des commandes globales."},"error":{"noMatch":"Aucun contr\xf4le d\'application ne correspond \xe0 votre recherche.","load":"Erreur lors du chargement des contr\xf4les de l\'application.","add":"Erreur lors de l\'ajout des contr\xf4les d\'application.","delete":"Erreur lors de la suppression des contr\xf4les de l\'application.","audioEventsWithEmptyCommands":"Il manque des contr\xf4les dans votre r\xe9ponse. V\xe9rifiez-les pour vous assurer de les remplir compl\xe8tement.","conflicts":"Erreur lors de l\'enregistrement des contr\xf4les de l\'application en raison de conflits.","save":"Erreur lors de l\'enregistrement des commandes de l\'application. Veuillez r\xe9essayer.","device":"Contr\xf4le d\'application non valide pour cette connexion. Veuillez en essayer un autre."},"conflictIndicators":{"errorTitle":"Erreur lors de l\'enregistrement des contr\xf4les de l\'application en raison de conflits","warningTitle":"Contr\xf4les d\'application enregistr\xe9s avec des avertissements","subtitle":"Les contr\xf4les d\'application que vous avez cr\xe9\xe9s ont certaines configurations qui peuvent entrer en conflit.","profileNameErrors":"Conflit de nom des contr\xf4les d\'application","emptyControlsMapped":"Noms d\'entr\xe9e vides","emptyControlsMappedDescription":"Veuillez ajouter une commande vocale, une expression faciale, une inclinaison de la t\xeate ou une autre commande \xe0 votre entr\xe9e.","emptyKeybindingControlsMapped":"Noms d\'entr\xe9e vides pour les raccourcis clavier","emptyKeybindingControlsMappedDescription":"Veuillez ajouter une commande vocale, une expression faciale, une inclinaison de la t\xeate ou une autre commande \xe0 votre entr\xe9e pour les raccourcis clavier.","duplicateNameTitle":"Nom des contr\xf4les d\'application en double","duplicateNameDescription":"Vous disposez d\xe9j\xe0 d\'une application portant le m\xeame nom. Veuillez la modifier avant de continuer.","emptyNameTitle":"Nom des contr\xf4les d\'application vides","emptyNameDescription":"Les commandes de l\'application doivent avoir un nom, par exemple Jeu 1, Spotify, Word, etc.","macrosReleaseKeysMissingTitle":"Sorties avec des cl\xe9s non lib\xe9r\xe9es","macrosReleaseKeysMissingDescription":"Veuillez ajouter une cl\xe9 de d\xe9verrouillage ou arr\xeater toutes les \xe9tapes pour \xe9viter que les cl\xe9s ne se bloquent.","duplicateInputCommandMacroTitle":"Entr\xe9es de commande identiques","duplicateCommandsDescription":"Veuillez supprimer ou modifier les commandes d\'entr\xe9e en double.","duplicateInputCommandBindingsTitle":"Entr\xe9es de contr\xf4le identiques pour les raccourcis clavier","conflictIndicatorDisplayString":"{{container}} : {{commandOrKeyName}} avec {{commandOrEventType}}","duplicateMacroNames":"Noms de contr\xf4le en double","duplicateMacroNamesDescription":"Veuillez supprimer ou modifier l\u2019un de vos noms de contr\xf4le identiques.","warningIgnore":"Ignorer","warningDoNotShowAgain":"Ne plus afficher les avertissements","macrosVoiceCommandConflictWithDictationTitle":"Contr\xf4lez les commandes vocales de la m\xeame mani\xe8re que les mots cl\xe9s de la dict\xe9e","keybindingsVoiceCommandConflictWithDictationTitle":"Les raccourcis clavier des commandes vocales sont identiques \xe0 ceux des mots cl\xe9s de la dict\xe9e","macrosVoiceCommandConflictWithDictationDescription":"Vos entr\xe9es vocales d\xe9clencheront la dict\xe9e et les commandes vocales.","keybindingsVoiceCommandConflictWithDictationDescription":"Vos entr\xe9es vocales d\xe9clencheront la dict\xe9e et les pressions sur les touches.","macrosVoiceCommandConflictWithGenerationTitle":"Contr\xf4ler les commandes vocales de la m\xeame mani\xe8re que les mots cl\xe9s de g\xe9n\xe9ration","keybindingsVoiceCommandConflictWithGenerationTitle":"Les commandes vocales des raccourcis clavier sont identiques aux mots cl\xe9s de g\xe9n\xe9ration","macrosVoiceCommandConflictWithGenerationDescription":"Vos entr\xe9es vocales d\xe9clencheront la g\xe9n\xe9ration et les commandes vocales.","keybindingsVoiceCommandConflictWithGenerationDescription":"Vos entr\xe9es vocales d\xe9clencheront la g\xe9n\xe9ration et les pressions sur les touches.","duplicateAssociatedProgramNames":"Noms de programmes associ\xe9s en double","duplicateAssociatedProgramNamesDescription":"Veuillez supprimer ou modifier l\'un de vos programmes associ\xe9s identiques.","emptyEvent":{"title":"\xc9tapes manquantes","description":"Il manque des \xe9tapes dans vos contr\xf4les. Cela pourrait emp\xeacher Cephable d\'ex\xe9cuter une action lorsque vous donnez une commande."},"warningDetails":"Afficher tous les conflits"},"success":{"save":"Contr\xf4les de l\'application enregistr\xe9s.","add":"Contr\xf4les d\'application ajout\xe9s.","delete":"Contr\xf4les de l\'application supprim\xe9s.","share":"Lien de partage cr\xe9\xe9 et copi\xe9 dans le presse-papiers","shareDelete":"Lien de partage supprim\xe9.","generate":"Contr\xf4les d\'application g\xe9n\xe9r\xe9s."},"warning":"Contr\xf4les d\'application enregistr\xe9s avec des avertissements","customize":"Personnaliser les contr\xf4les de l\'application","custom":"{{name}} (Personnalis\xe9)","description":"Les contr\xf4les d\'application sont un ensemble de commandes permettant de contr\xf4ler votre appareil ou votre connexion. Vous pouvez cr\xe9er plusieurs contr\xf4les d\'application et passer de l\'un \xe0 l\'autre \xe0 tout moment."},"publicProfiles":{"toolbar":"Explorer les commandes de l\'application","title":"Explorer les commandes de l\'application","offline":{"title":"Impossible de charger les contr\xf4les d\'application publics","description":"Il semble que vous soyez hors ligne. Vous pouvez toujours utiliser les commandes de votre application, mais vous ne pourrez pas charger de nouvelles commandes publiques.","confirm":"D\'accord"},"announcement":"{{count}} De nouveaux contr\xf4les d\'application ont \xe9t\xe9 charg\xe9s","description":{"personal":"Des contr\xf4les d\'application publics sont disponibles pour vous aider \xe0 d\xe9marrer rapidement avec Cephable sur vos applications pr\xe9f\xe9r\xe9es. Vous pouvez utiliser les contr\xf4les par d\xe9faut, les personnaliser selon vos besoins ou cr\xe9er de toutes nouvelles commandes personnalis\xe9es.","pro":"Des contr\xf4les d\'application publics sont disponibles pour vous aider \xe0 d\xe9marrer rapidement avec Cephable sur vos applications pr\xe9f\xe9r\xe9es. Vous pouvez utiliser les contr\xf4les par d\xe9faut, les personnaliser selon vos besoins ou cr\xe9er de nouveaux contr\xf4les d\'application personnalis\xe9s gr\xe2ce au g\xe9n\xe9rateur de contr\xf4les."},"team":"\xc9quipe Cephable"},"publicTag":"Publique","tray":{"panel":"Basculer le panneau","dashboard":"Afficher le tableau de bord","quit":"Quitter Cephable"},"generate":"G\xe9n\xe9rer","stop":"Arr\xeat","clear":"Clair","rewrite":"R\xe9crire","translate":"Traduire","smartTasks":{"title":"T\xe2ches intelligentes","show":"Afficher les t\xe2ches intelligentes","description":"Les t\xe2ches intelligentes sont les diff\xe9rentes t\xe2ches que l\'IA de Cephable peut effectuer pour vous. Ces t\xe2ches, aliment\xe9es par l\'IA int\xe9gr\xe9e \xe0 l\'appareil, peuvent \xeatre utilis\xe9es pour cr\xe9er du texte, r\xe9sumer, r\xe9\xe9crire, traduire, prendre des notes et discuter avec des documents.","generateText":{"title":"G\xe9n\xe9rer du texte","description":"Cr\xe9ez du contenu textuel en fonction de vos entr\xe9es ou de vos invites.","label":"D\xe9crivez ce que vous souhaitez g\xe9n\xe9rer"},"summarizeText":{"title":"R\xe9sumer le texte","description":"Condensez un texte long en un r\xe9sum\xe9 concis.","directions":"Saisissez le texte \xe0 r\xe9sumer, ou Cephable utilisera automatiquement le texte que vous avez mis en \xe9vidence.","titleShort":"R\xe9sumer","write":"R\xe9diger un r\xe9sum\xe9","label":"Saisissez le texte \xe0 r\xe9sumer","outputLabel":"Votre r\xe9sum\xe9 appara\xeetra ici."},"rewriteText":{"title":"R\xe9\xe9crire le texte","description":"Surlignez le texte dans une autre application dans laquelle vous \xe9crivez, puis revenez ici et d\xe9crivez comment vous souhaitez qu\'il soit r\xe9\xe9crit.","label":"D\xe9crivez comment vous souhaitez r\xe9\xe9crire le texte","inputLabel":"Saisissez le texte \xe0 r\xe9\xe9crire"},"translateText":{"title":"Traduire le texte","description":"Saisissez le texte \xe0 traduire, ou Cephable utilisera automatiquement le texte que vous avez mis en surbrillance.","label":"Entrez le texte \xe0 traduire","languageLabel":"Langue \xe0 traduire"},"noteTaker":{"title":"Preneur de notes","description":"Laissez Cephable enregistrer et transcrire localement vos r\xe9unions ou conversations"},"documentChat":{"title":"Discussion sur les documents","description":"Interagissez avec des documents et interrogez-les pour obtenir des informations rapides."},"highlightText":{"title":"Utiliser le texte en surbrillance","description":"Cephable peut utiliser automatiquement le texte surlign\xe9 dans n\'importe quelle application pour effectuer des t\xe2ches telles que la synth\xe8se, la r\xe9\xe9criture ou la traduction. Vous pouvez \xe9galement saisir du texte manuellement si vous le souhaitez.","label":"Entrez le texte \xe0 utiliser","placeholder":"Vous pouvez \xe9galement surligner du texte dans une autre application et revenir ici pour l\'utiliser."},"pasteText":{"title":"Coller du texte","description":"Cephable peut utiliser automatiquement le texte copi\xe9 dans votre presse-papiers pour effectuer des t\xe2ches telles que la synth\xe8se, la r\xe9\xe9criture ou la traduction. Vous pouvez \xe9galement saisir du texte manuellement si vous le souhaitez.","label":"Entrez le texte \xe0 utiliser","placeholder":"Vous pouvez \xe9galement surligner du texte dans une autre application et revenir ici pour l\'utiliser."},"clearCache":"Si vous rencontrez des probl\xe8mes lors de la g\xe9n\xe9ration, veuillez vider votre cache et vos ressources dans les param\xe8tres de g\xe9n\xe9ration de texte et r\xe9essayer.","transcribeAudio":{"title":"Transcrire l\'audio","description":"Convertissez des fichiers audio ou vid\xe9o en texte \xe0 l\'aide de la transcription IA.","inputMethod":"Choisissez la m\xe9thode de saisie","localFile":"Fichier local","url":"URL","selectFile":"S\xe9lectionner un fichier audio/vid\xe9o","urlLabel":"URL audio/vid\xe9o","transcribe":"Transcrire","result":"R\xe9sultat de la transcription","invalidFileType":"Veuillez s\xe9lectionner un fichier audio ou vid\xe9o valide (mp3, wav, ogg, mp4, webm, mov, avi)","error":"Erreur de transcription","history":{"title":"Historique de la transcription","description":"Affichez et g\xe9rez vos transcriptions enregistr\xe9es.","viewHistory":"Afficher l\'historique","empty":"Aucune transcription pour le moment. Commencez \xe0 transcrire pour enrichir votre histoire\xa0!","titleLabel":"Titre (facultatif)","titlePlaceholder":"Entrez un titre pour cette transcription","textLabel":"Texte de transcription","confirmDelete":"\xcates-vous s\xfbr de vouloir supprimer cette transcription ?"}},"aiWorkflows":{"description":"Automatisez vos t\xe2ches de bureau et de navigation gr\xe2ce \xe0 l\'IA. D\xe9crivez simplement ce que vous souhaitez accomplir, et Cephable se chargera du reste.","label":"D\xe9crivez ce que vous souhaitez accomplir","status":{"idle":"Dans l\'attente de vos instructions...","initializing":"On pr\xe9pare tout...","planning":["\xc9laborer un plan...","Analyse de votre demande...","\xc9laboration des \xe9tapes...","Organisation du flux de travail...","Pr\xe9paration de la strat\xe9gie...","\xc9laboration d\'un plan d\'action...","Trouver la meilleure fa\xe7on de vous aider...","D\xe9terminer comment aborder cette question...","Analyse de votre demande...","Planification de l\'ex\xe9cution..."],"thinking":["Pens\xe9e...","Analyse de votre demande...","Trouver la meilleure fa\xe7on de vous aider...","D\xe9terminer la suite des op\xe9rations...","Traitement des \xe9tapes pr\xe9c\xe9dentes...","Nous travaillons sur votre demande...","R\xe9cup\xe9ration des d\xe9tails...","R\xe9vision du plan...","Envisager les options...","Cr\xe9er, \xe9valuer, d\xe9cider..."],"waitingForUser":"Votre contribution est n\xe9cessaire pour continuer.","completed":"Succ\xe8s!","failed":"Votre requ\xeate a \xe9chou\xe9. Veuillez r\xe9essayer.","canceled":"Votre demande a \xe9t\xe9 annul\xe9e.","terminated":"Arr\xeat\xe9. En attente de vos instructions...","thinkingInteractive":["Envisager la prochaine \xe9tape...","R\xe9capitulons ce que nous avons fait jusqu\'\xe0 pr\xe9sent...","D\xe9cider de la suite...","Analyse des r\xe9sultats...","Planification de la suite...","\xc9valuation des options...","D\xe9terminer la meilleure prochaine \xe9tape...","Je travaille sur la suite de votre demande...","Nous travaillons sur les prochaines \xe9tapes...","Traitement des r\xe9sultats de l\'\xe9tape pr\xe9c\xe9dente..."],"tools":{"click_element_by_index":{"executing-start":"Cliquer sur le bouton correspondant...","executing-complete":"J\'ai cliqu\xe9 sur {{params.index}}."},"click_element":{"executing-start":"Cliquer sur le num\xe9ro en surbrillance...","executing-complete":"J\'ai cliqu\xe9 sur {{params.elementName}}."},"copy_selection":{"executing-start":"Collecte du contexte...","executing-complete":"J\'ai le contexte, pr\xeat pour la suite de votre demande."},"create_file":{"executing-start":"Cr\xe9ation d\'un fichier...","executing-complete":"J\'ai cr\xe9\xe9 un fichier nomm\xe9 {{params.fileName}}."},"draft_email":{"executing-start":"R\xe9diger un courriel...","executing-complete":"J\'ai r\xe9dig\xe9 un courriel concernant {{params.subject}}."},"execute_app_action":{"executing-start":"Ex\xe9cution de {{params.actionName}}...","executing-complete":"{{params.actionName}} termin\xe9."},"find_all_text":{"executing-start":"Recherche de tout le contexte pertinent concernant {{params.searchText}}...","executing-complete":"J\'ai trouv\xe9 tout le contexte pertinent concernant {{params.searchText}}."},"find_and_select_text":{"executing-start":"Recherche et s\xe9lection du contexte pertinent concernant {{params.searchText}}...","executing-complete":"J\'ai trouv\xe9 et s\xe9lectionn\xe9 le contexte pertinent concernant {{params.searchText}}."},"generate_text":{"executing-start":"Cr\xe9ation de contenu...","executing-progress":"Cr\xe9ation de contenu...{{progress}}%","executing-complete":"J\'ai cr\xe9\xe9 le contenu demand\xe9."},"get_all_interactive_elements":{"executing-start":"Recherche en cours pour obtenir plus de contexte...","executing-complete":"Je comprends avec quoi je peux interagir."},"get_all_text_elements_content":{"executing-start":"Je lis pour avoir plus de contexte...","executing-complete":"Je comprends quel contenu textuel est disponible."},"get_all_text_elements_names":{"executing-start":"Je lis pour avoir plus de contexte...","executing-complete":"Je comprends quel contenu textuel est disponible."},"get_available_profile_actions":{"executing-start":"V\xe9rification des commandes disponibles dans cette application...","executing-complete":"Je comprends ce que je peux faire dans cette application."},"get_document_content":{"executing-start":"Je lis pour avoir plus de contexte...","executing-complete":"J\'ai le contexte, pr\xeat pour la suite de votre demande."},"get_installed_apps":{"executing-start":"D\xe9terminer quelle application correspond \xe0 votre demande...","executing-complete":"Je sais quelles applications je peux utiliser."},"get_running_app_names":{"executing-start":"D\xe9terminer quelle application correspond \xe0 votre demande...","executing-complete":"Je sais quelles applications je peux utiliser."},"get_selected_text":{"executing-start":"Lecture du contenu s\xe9lectionn\xe9...","executing-complete":"J\'ai le contexte du contenu s\xe9lectionn\xe9."},"get_stored_content":{"executing-start":"Collecte du contexte...","executing-complete":"J\'ai le contexte, pr\xeat pour la suite de votre demande."},"keyboard_shortcut":{"executing-start":"Collecte du contexte...","executing-complete":"J\'ai le contexte, pr\xeat pour la suite de votre demande."},"open_app":{"executing-start":"Ouverture de {{params.appName}}...","executing-complete":"J\'ai ouvert {{params.appName}}."},"open_webpage":{"executing-start":"Ouverture de {{params.url}}...","executing-complete":"J\'ai ouvert {{params.url}}."},"paste_content":{"executing-start":"En \xe9crivant...","executing-complete":"J\'ai fini d\'\xe9crire."},"respond_to_user":{"executing-start":"Traitement de votre demande...","executing-complete:":"J\'ai trait\xe9 votre demande."},"search_and_open_file":{"executing-start":"Recherche du fichier {{params.query}} et son ouverture...","executing-complete":"J\'ai recherch\xe9 le fichier {{params.query}} et je l\'ai ouvert."},"search_browser":{"executing-start":"Recherche sur le Web de {{params.query}}...","executing-complete":"J\'ai cherch\xe9 sur le web {{params.query}}."},"select_all_text":{"executing-start":"S\xe9lectionner tout le texte...","executing-complete":"J\'ai s\xe9lectionn\xe9 tout le texte."},"summarize_text":{"executing-start":"En r\xe9sum\xe9, le texte\u2026","executing-progress":"En r\xe9sum\xe9...{{progress}}%","executing-complete":"J\'ai r\xe9sum\xe9 le texte."},"translate_text":{"executing-start":"Traduction du texte en {{params.targetLanguage}}...","executing-progress":"Traduction en cours...{{progress}}%","executing-complete":"J\'ai traduit le texte en {{params.targetLanguage}}."},"type_stored_content":{"executing-start":"En \xe9crivant...","executing-complete":"J\'ai fini d\'\xe9crire."},"type_text":{"executing-start":"En \xe9crivant...","executing-complete":"J\'ai fini d\'\xe9crire."},"write_file_content":{"executing-start":"\xc9criture dans le fichier...","executing-complete":"J\'ai termin\xe9 l\'\xe9criture dans le fichier {{params.fileName}}."},"unknown":{"executing-start":"J\'ai rencontr\xe9 un probl\xe8me en essayant une strat\xe9gie diff\xe9rente...","executing-complete":"J\'ai essay\xe9 une strat\xe9gie diff\xe9rente."}},"networkError":"Connexion interrompue lors du t\xe9l\xe9chargement du mod\xe8le. Veuillez v\xe9rifier votre connexion Internet et r\xe9essayer en envoyant une invite ou en red\xe9marrant l\'application.","executing-org-block":"Impossible d\'utiliser {{params.toolName}} car l\'interaction avec {{params.appOrDomain}} est bloqu\xe9e par l\'organisation.","executing-destructive-block":"Toute interaction avec {{params.elementName}} est bloqu\xe9e. Veuillez v\xe9rifier et effectuer cette action manuellement.","executing-type-focus-block":"J\'ai rencontr\xe9 un probl\xe8me lors de la saisie du contenu. Il a \xe9t\xe9 copi\xe9 dans votre presse-papiers\xa0; veuillez le coller manuellement."},"ready":{"waiting":"AI Workflows est pr\xeat. Nous attendons vos instructions.","execute":"Les flux de travail IA sont pr\xeats. \xc0 partir de votre demande\u2026"},"start":"Commencer","progress":"Fonctionnement...","introModal":{"description":"Je peux d\xe9sormais automatiser vos t\xe2ches sur votre ordinateur et votre navigateur\xa0: dites-moi simplement ce que vous souhaitez faire, et je m\u2019occupe du reste. Mon application fonctionne en priv\xe9 sur votre appareil, vos donn\xe9es restent donc confidentielles. Pour commencer, j\u2019ai besoin de t\xe9l\xe9charger un mod\xe8le d\u2019IA local. T\xe9l\xe9chargez-le maintenant pour que je sois pr\xeat(e), ou je le t\xe9l\xe9chargerai lorsque vous lancerez votre premier flux de travail.","confirm":"T\xe9l\xe9charger maintenant","cancel":"Passer pour le moment","title":"Les flux de travail d\'IA sont disponibles"},"title":"Vos flux de travail d\'IA sont pr\xeats"},"generatedByAI":"Fonctionne gr\xe2ce \xe0 l\'IA embarqu\xe9e, veuillez v\xe9rifier l\'exactitude des informations.","networkError":"Connexion interrompue lors du t\xe9l\xe9chargement du mod\xe8le. Veuillez v\xe9rifier votre connexion Internet et r\xe9essayer en envoyant une invite ou en red\xe9marrant l\'application.","genericError":"Une erreur inattendue s\'est produite. Veuillez r\xe9essayer.","download":{"title":"T\xe9l\xe9chargez des mod\xe8les d\'IA pour d\xe9bloquer davantage de fonctionnalit\xe9s","description":"Pour utiliser les t\xe2ches intelligentes, un mod\xe8le local doit \xeatre t\xe9l\xe9charg\xe9 sur votre appareil. Cela garantit la confidentialit\xe9 de vos donn\xe9es, qui ne sont jamais envoy\xe9es sur le cloud.","confirm":"T\xe9l\xe9charger","cancel":"Pas maintenant","includeWorkflows":"T\xe9l\xe9chargez \xe9galement les mod\xe8les de flux de travail IA pour une automatisation avanc\xe9e."}},"inputMethod":"M\xe9thode de saisie :","hotkey":{"title":"Bouton d\'action rapide","titlePlural":"Boutons d\'action rapide","titlePanel":"Actions rapides","label":"Nom d\'affichage du bouton d\'action rapide","placeholder":"Nom \xe0 afficher","question":"Comment souhaitez-vous nommer ce bouton ?","when":"Quand je tape...","description":"Les boutons d\'action rapide sont des boutons personnalisables qui permettent d\'effectuer des actions pertinentes dans votre application. Un simple clic peut ex\xe9cuter plusieurs \xe9tapes ou une seule action.","usagePrompt":"Les boutons d\'action rapide sont des boutons personnalisables qui permettent d\'effectuer des actions pertinentes dans votre application. Vous pouvez ajouter, supprimer ou modifier leur nom depuis la page principale des param\xe8tres de contr\xf4le de l\'application.","reorder":"Vous pouvez r\xe9organiser l\'ordre en utilisant les boutons de d\xe9placement vers le haut et vers le bas.","emptyTitle":"Pas de boutons d\'action rapide","edit":"Modifier les boutons d\'action rapide","tap":"Appuyez sur {{value}}","copySuffix":"{{name}}_copie","hotkeysOnly":"Boutons personnalis\xe9s","allControls":"Toutes les commandes de l\'application","show":"Afficher les boutons d\'action rapide","deprecatedDialog":{"title":"Les contr\xf4les de votre application n\xe9cessitent une mise \xe0 jour.","description2":"Une simple mise \xe0 jour suffit \u2013 une seconde \xe0 peine \u2013 et vous profiterez d\'une personnalisation fluide des boutons. Dites adieu aux \xe9tapes suppl\xe9mentaires et bonjour \xe0 une interface plus conviviale. Pr\xeat \xe0 passer \xe0 l\'action\xa0?","confirm":"Faisons-le!","description1":"Il semble que vous utilisiez d\'anciennes commandes d\'application avec des boutons d\'action rapide. Nous vous r\xe9servons des mises \xe0 jour int\xe9ressantes\xa0! Nous avons repens\xe9 le syst\xe8me pour simplifier la cr\xe9ation et la modification des boutons d\'action rapide, sans avoir \xe0 explorer les param\xe8tres avanc\xe9s."},"demo":{"title":"Boutons d\'action rapide de d\xe9monstration","step1":"Activer les boutons d\'action rapide","step2":"Utilisez les exemples d\u2019invite ci-dessous pour contr\xf4ler le bloc de texte.","command1":"Appuyez sur le bouton 1 pour \xab\xa0Agrandir le texte\xa0\xbb","command2":"Appuyez sur le bouton 2 pour \xab mettre le texte en gras \xbb","command3":"","continue":"Continuer avec les boutons d\'action rapide","description":"La zone de d\xe9monstration ci-dessous vous permettra d\'essayer les boutons d\'action rapide. Elle se limite au contr\xf4le sp\xe9cifique de la zone de texte ci-dessous."},"example":{"title":"Exemples de boutons d\'action rapide","command1":"Appuyez sur Pause","example1":"Exemple \xab\xa0mettre la vid\xe9o en pause\xa0\xbb","command2":"Appuyez sur Suivant","example2":"Exemple \xab\xa0zoom arri\xe8re\xa0\xbb","command3":"Appuyez sur Arr\xeater","example3":"Exemple \xab\xa0fermer la fen\xeatre\xa0\xbb","description":"Ces exemples illustrent la polyvalence des boutons d\'action rapide pour contr\xf4ler votre appareil ou votre connexion. Ils permettent d\'ex\xe9cuter des commandes, de naviguer dans les interfaces ou d\'effectuer des actions d\'un simple toucher."},"emptySearch":"Aucune action rapide ne correspond \xe0 ce crit\xe8re.","empty":"Il semble que vous n\'ayez actuellement aucune action rapide.","emptyLong":"Aucun bouton d\'action rapide n\'est configur\xe9 dans ces commandes d\'application. Une fois que vous aurez ajout\xe9 des boutons d\'action rapide ou choisi des commandes d\'application avec un bouton d\'action rapide, ils appara\xeetront ici."},"reset":"R\xe9initialiser","info":"Plus d\'informations","device":{"title":"Connexion","titlePlural":"Relations","status":{"title":"\xc9tat de la connexion\xa0:","connected":{"application":"Application connect\xe9e","connection":"Connect\xe9","device":"Appareil connect\xe9","game":"Jeu connect\xe9"},"disconnected":{"application":"Application d\xe9connect\xe9e","connection":"D\xe9connect\xe9","device":"Appareil d\xe9connect\xe9","game":"Jeu d\xe9connect\xe9"}},"running":"En cours d\'ex\xe9cution","offline":"Hors ligne","otherDevices":"Autres connexions de sortie","currentStatus":"Statut actuel :","connectionStatus":"\xc9tat de la connexion\xa0:","profileStatus":"Contr\xf4les actuels de l\'application\xa0:","name":{"title":"Nom de la connexion","question":"Comment voulez-vous appeler cette connexion ?","description":"Donnez un nom \xe0 votre connexion afin de pouvoir la retrouver facilement plus tard.","placeholder":"nom de la connexion","edit":"Modifier le nom de la connexion"},"updates":{"title":"Mises \xe0 jour de connexion","settings":"Param\xe8tres de mise \xe0 jour de la connexion","description":"V\xe9rifiez les mises \xe0 jour du micrologiciel de connexion et modifiez les param\xe8tres de mise \xe0 jour automatique","edit":"Modifier les param\xe8tres de mise \xe0 jour","check":{"title":"V\xe9rifier les mises \xe0 jour","processing":"V\xe9rification des mises \xe0 jour\xa0! Cela peut prendre quelques minutes et votre connexion peut red\xe9marrer pendant les mises \xe0 jour.","description":"Appuyez pour v\xe9rifier les mises \xe0 jour de votre connexion. Si une mise \xe0 jour est disponible et que votre connexion est active, la mise \xe0 jour commencera. Les mises \xe0 jour peuvent prendre quelques minutes."},"auto":{"title":"Mise \xe0 jour automatique","description":"Lorsque ce param\xe8tre est activ\xe9, votre connexion se met automatiquement \xe0 jour d\xe8s qu\'une mise \xe0 jour est disponible. Si ce param\xe8tre est d\xe9sactiv\xe9, appuyez sur le bouton de mise \xe0 jour pour obtenir la derni\xe8re version.","option":"Utiliser la mise \xe0 jour automatique\xa0?"}},"delete":{"title":"Dissocier {{name}}","titleLong":"Dissocier du compte","description":"La dissociation d\xe9connecte Cephable de cet ordinateur ou de ce jeu et le supprime de votre compte. Vous ne pourrez plus vous y connecter, lui envoyer de commandes ni le mettre \xe0 jour. Cette action est irr\xe9versible, mais vous pourrez cr\xe9er une nouvelle connexion avec le m\xeame ordinateur ou le m\xeame jeu si vous souhaitez l\'utiliser \xe0 nouveau ult\xe9rieurement.","confirm":"\xcates-vous s\xfbr de vouloir dissocier cette connexion\xa0?","confirmLong":"\xcates-vous s\xfbr de vouloir d\xe9senregistrer et r\xe9initialiser cette connexion\xa0? Vous ne pourrez plus vous y connecter, envoyer de commandes ni la mettre \xe0 jour. Apr\xe8s cette d\xe9sinscription et r\xe9initialisation, n\'importe qui pourra \xe9tablir cette connexion.","confirmButton":"Oui, supprimez cette connexion."},"manage":{"title":"Cliquez pour afficher et g\xe9rer les d\xe9tails de vos connexions.","description":"","name":"Personnalisez le nom de votre connexion pour une gestion plus facile."},"error":{"save":"Erreur lors de l\'enregistrement de la connexion.","load":"Erreur lors du chargement de la connexion.","add":"Erreur lors de l\'ajout de la connexion.","delete":"Erreur lors de la suppression de la connexion.","updates":"Erreur lors de la v\xe9rification des mises \xe0 jour.","connection":"La connexion n\'est pas \xe9tablie. V\xe9rifiez qu\'elle est bien \xe9tablie avant de r\xe9essayer.","deleteLong":"Nous n\'avons pas pu supprimer cette connexion de votre compte. Si vous vous reconnectez \xe0 ce compte, vous devrez peut-\xeatre la supprimer manuellement dans les param\xe8tres de connexion."},"success":{"save":"Connexion enregistr\xe9e.","add":"Connexion ajout\xe9e.","delete":"Connexion supprim\xe9e."},"description":"Cephable prend en charge plusieurs appareils et connexions. Vous pouvez g\xe9rer les param\xe8tres ou s\xe9lectionner l\'un d\'entre eux. Cet ordinateur sera toujours votre connexion principale. Vous pourrez ajouter d\'autres connexions ult\xe9rieurement.","swap":{"titlePlural":"Connexions d\'\xe9change"},"control":{"button":"Contr\xf4le {{name}}","description":{"application":"Contr\xf4lez cette application connect\xe9e avec votre voix, des actions rapides, des mouvements de t\xeate, etc. Par exemple, si vous dites \xab\xa0Enregistrer\xa0\xbb, cela enregistrera l\'application en cours d\'ex\xe9cution.","connection":"Contr\xf4lez cette connexion avec votre voix, des actions rapides, des mouvements de t\xeate, etc. Par exemple, si vous dites \xab\xa0Enregistrer\xa0\xbb, votre connexion en cours sera sauvegard\xe9e.","device":"Contr\xf4lez cet appareil connect\xe9 avec votre voix, des actions rapides, des mouvements de t\xeate, etc. Par exemple, si vous dites \xab\xa0Ouvrir Spotify\xa0\xbb, Spotify s\'ouvrira sur l\'appareil en cours d\'ex\xe9cution.","game":"Contr\xf4lez ce jeu connect\xe9 avec votre voix, des actions rapides, des mouvements de t\xeate et bien plus encore. Par exemple, si vous dites \xab\xa0Go\xa0\xbb, le joueur se d\xe9placera en course."},"generic":"Connexion de contr\xf4le"},"titleShort":"Connecter","titleLong":"Connexions et extensions","viewAll":"Afficher toutes les connexions","add":{"short":"\xc9tendre","title":"Ajouter une nouvelle connexion ou extension","description":"Les connexions et les extensions vous permettent d\'enrichir votre exp\xe9rience Cephable. Vous pouvez ajouter de nouvelles connexions pour vous connecter \xe0 davantage d\'appareils, d\'applications ou de jeux. Passez \xe0 la vitesse sup\xe9rieure avec Cephable\xa0!","action":"Ajouter une nouvelle connexion","notAvailable":"Cette connexion ou extension n\'est pas accessible au public pour le moment. Cela se produit souvent avec les extensions cr\xe9\xe9es par les utilisateurs. Veuillez r\xe9essayer plus tard.","isNotPublic":"APER\xc7U\xa0: Cette extension est en version pr\xe9liminaire pour d\xe9veloppeurs et peut \xeatre incompl\xe8te. Les d\xe9veloppeurs doivent finaliser toutes les \xe9tapes avant sa publication publique. Les utilisateurs pourront consulter cette page ult\xe9rieurement pour obtenir la version compl\xe8te."},"new":"Vous avez une nouvelle connexion !","newLong":"Vous avez une nouvelle connexion ! Pour commencer \xe0 l\'utiliser, s\xe9lectionnez-la dans le menu ci-dessous."},"explore":"Explorer","shortcuts":{"title":"Raccourcis mondiaux","description":"Personnalisez les raccourcis clavier pour un acc\xe8s rapide aux commandes Cephable depuis n\'importe o\xf9 sur votre syst\xe8me.","info":"Ces raccourcis fonctionnent globalement et peuvent \xeatre utilis\xe9s m\xeame lorsque Cephable n\'est pas la fen\xeatre active.","shortcut":"Raccourci","toggleMicrophone":"Basculer le microphone","toggleDictation":"Basculer le mode dict\xe9e","toggleVoiceControl":"Basculer le mode de commande vocale","togglePanel":"Basculer le panneau","registrationFailed":"Certains raccourcis globaux n\'ont pas pu \xeatre enregistr\xe9s. Ils sont peut-\xeatre utilis\xe9s par une autre application\xa0:","record":{"title":"Raccourci d\'enregistrement","start":"Cliquez pour enregistrer","listening":"Appuyez sur la combinaison de touches souhait\xe9e...","pressKeys":"Appuyez sur les touches maintenant"},"formatHint":"S\xe9lectionnez au moins une touche de modification ({{modifierKey}}, {{modifierKey2}}, Shift) et une autre touche."},"gamepad":{"title":"Prise en charge de la manette de jeu","description":"Configurer la sortie du gamepad et du joystick pour les jeux sur PC","driver":{"description":"Pour prendre en charge les sorties de la manette de jeu, Cephable doit t\xe9l\xe9charger et installer un pilote externe appel\xe9 ViGEm. Ce pilote active la fonctionnalit\xe9 de manette virtuelle Xbox 360, reconnue nativement par les jeux.","installed":"Pilote de manette de jeu install\xe9\xa0: vous pouvez utiliser les sorties de la manette\xa0! Si vous rencontrez toujours des probl\xe8mes, vous pouvez essayer de r\xe9installer le pilote.","notInstalled":"Pilote du contr\xf4leur de jeu non install\xe9","install":"Installer le pilote du contr\xf4leur de jeu","reinstall":"R\xe9installer le pilote du contr\xf4leur de jeu","installing":"Installation du pilote du contr\xf4leur de jeu ViGEm...","installSuccess":"Le pilote de la manette de jeu ViGEm a \xe9t\xe9 install\xe9 avec succ\xe8s\xa0! Vous pouvez d\xe9sormais utiliser les sorties de la manette dans vos commandes.","installFailed":"\xc9chec de l\'installation du pilote ViGEm. Veuillez r\xe9essayer ou proc\xe9der \xe0 l\'installation manuelle depuis le site web de ViGEm."},"platform":{"unsupported":"Plateforme non prise en charge pour les fonctionnalit\xe9s de la manette","unsupportedDescription":"La fonctionnalit\xe9 de sortie du contr\xf4leur de jeu n\'est actuellement prise en charge que sur les syst\xe8mes Windows x64. La prise en charge de Windows ARM64 n\'est pas encore disponible en raison des limitations du SDK."},"usage":"Une fois le pilote du contr\xf4leur de jeu install\xe9, vous pouvez utiliser les mouvements du joystick et les pressions sur les boutons de la manette dans vos macros et commandes vocales pour contr\xf4ler les jeux."},"youtube":{"unavailable":{"title":"Vid\xe9o indisponible","description":"Cette vid\xe9o est actuellement indisponible. Veuillez la r\xe9essayer ult\xe9rieurement.","retry":"R\xe9essayer"},"watch":{"title":"Oups.","description":"Il semble qu\'un probl\xe8me soit survenu lors du chargement de la vid\xe9o. Vous pouvez la regarder directement sur YouTube.","button":"Regarder sur YouTube"},"offline":{"title":"Vid\xe9o indisponible","description":"Cette vid\xe9o YouTube n\xe9cessite une connexion internet pour se charger. Veuillez v\xe9rifier votre connexion et r\xe9essayer."}},"metrics":{"download":{"success":"Acc\xe8s r\xe9ussi au fichier de m\xe9triques.","manualPath":"Fichier de m\xe9triques disponible \xe0\xa0: {{path}}","error":"Erreur lors du t\xe9l\xe9chargement du fichier de m\xe9triques.","noFile":"Aucun fichier de m\xe9triques trouv\xe9."},"clear":{"success":"Le fichier de m\xe9triques a \xe9t\xe9 effac\xe9 avec succ\xe8s.","error":"Erreur lors de l\'effacement du fichier de m\xe9triques.","noFile":"Aucun fichier de m\xe9triques n\'a \xe9t\xe9 trouv\xe9 pour \xeatre effac\xe9.","confirm":"Voulez-vous vraiment effacer toutes les donn\xe9es\xa0? Cette action est irr\xe9versible."}},"suggestedPrompts":{"title":"Suggestions d\'invites","description":"Personnalisez les invites sugg\xe9r\xe9es qui s\'affichent dans les t\xe2ches d\'IA pour vous aider \xe0 d\xe9marrer rapidement.","edit":"Modifier les invites sugg\xe9r\xe9es","generate":"G\xe9n\xe9rer du texte","rewrite":"R\xe9\xe9crire le texte","addGenerate":"Ajouter une invite de g\xe9n\xe9ration","addRewrite":"Ajouter une invite de r\xe9\xe9criture","remove":"Supprimer l\'invite","generatePlaceholder":"Entrez une invite pour la g\xe9n\xe9ration de texte...","rewritePlaceholder":"Entrez une invite pour la r\xe9\xe9criture du texte...","suggested":"Suggestions d\'invites","suggestedFor":"Sugg\xe9r\xe9 pour {{profileName}}","seeAll":"Voir toutes les invites","showLess":"Afficher moins","allPrompts":"Toutes les invites","customFor":"Invites personnalis\xe9es pour {{profileName}}","defaultPrompts":"Invites par d\xe9faut","defaultGenerate":["Un e-mail professionnel pr\xe9sentant notre nouveau produit","Un ordre du jour pour la discussion d\'\xe9quipe de la semaine prochaine","Un aper\xe7u de la proposition de projet pour une nouvelle initiative","Un mod\xe8le de lettre commerciale formelle","Une section de documentation technique","Introduction au manuel d\'utilisation","Un aper\xe7u du document de formation","Un projet de document de politique","Un e-mail de suivi apr\xe8s une r\xe9union","Un message de remerciement \xe0 un client","Un e-mail de mise \xe0 jour de l\'\xe9tat du projet","Une invitation \xe0 un \xe9v\xe9nement d\'entreprise","Un e-mail de rappel pour les \xe9ch\xe9ances \xe0 venir","Un e-mail de bienvenue pour les nouveaux membres de l\'\xe9quipe","Un e-mail d\'excuses pour l\'interruption de service","Une introduction \xe0 la newsletter","Une liste de brainstorming pour les campagnes marketing","Solutions cr\xe9atives pour am\xe9liorer la productivit\xe9 des \xe9quipes","Id\xe9es d\'activit\xe9s pour une retraite d\'entreprise","Concepts pour une nouvelle fonctionnalit\xe9 d\'application mobile","Suggestions pour am\xe9liorer l\'exp\xe9rience client","Id\xe9es d\'innovation pour le d\xe9veloppement de nos produits","Id\xe9es de contenu pour les publications sur les r\xe9seaux sociaux","Th\xe8mes d\'atelier pour le d\xe9veloppement professionnel","Une fonction qui valide la saisie de l\'utilisateur","Une requ\xeate de base de donn\xe9es pour la gestion des utilisateurs","Code de gestion des erreurs pour les requ\xeates API","Un mod\xe8le de fichier de configuration","Commentaires expliquant un algorithme complexe","Cas de tests unitaires pour une nouvelle fonctionnalit\xe9","Documentation pour les points de terminaison de l\'API","Un script pour un d\xe9ploiement automatis\xe9"],"defaultRewrite":["Rendre ce texte plus concis et pr\xe9cis","D\xe9veloppez ce r\xe9sum\xe9 avec plus de d\xe9tails","Reformater ceci comme une liste num\xe9rot\xe9e","Convertissez ceci en puces","Restructurez ceci en paragraphes clairs","Rendre ce texte plus facile \xe0 parcourir rapidement","Organiser ces informations de mani\xe8re hi\xe9rarchique","Formatez ceci comme un guide \xe9tape par \xe9tape","Rendez ce message plus professionnel et formel","R\xe9\xe9crivez ceci pour qu\'il paraisse plus d\xe9contract\xe9 et amical","Ajustez le ton pour \xeatre plus encourageant","Rendez ce son plus confiant et affirm\xe9","Adoucir le ton pour \xeatre plus diplomate","Ajoutez de l\'enthousiasme et de l\'\xe9nergie \xe0 ce texte","Rendez cela plus empathique et compr\xe9hensif","R\xe9\xe9crire avec un ton plus collaboratif","Simplifiez ceci pour un public g\xe9n\xe9ral","Rendre cette explication plus technique et d\xe9taill\xe9e","D\xe9composez ce concept complexe en termes plus simples","Ajoutez plus de contexte et d\'informations g\xe9n\xe9rales","R\xe9sumez ceci en points cl\xe9s \xe0 retenir","D\xe9veloppez les points principaux avec des exemples","Rendre cela plus accessible aux d\xe9butants","Condensez ceci tout en gardant les informations essentielles","Am\xe9liorer la clart\xe9 et la lisibilit\xe9","Rendez cela plus engageant et int\xe9ressant","Ajuster pour une meilleure grammaire et un meilleur flux","R\xe9\xe9crire pour mettre l\'accent sur les avantages"]},"accessibilityService":{"error":{"generic":"Erreur interne. Veuillez r\xe9essayer plus tard.","elementNotFound":"Aucun r\xe9sultat trouv\xe9. Veuillez v\xe9rifier que la recherche existe et r\xe9essayer.","highlightOnConflict":"Plusieurs \xe9l\xe9ments ont \xe9t\xe9 trouv\xe9s. Veuillez pr\xe9ciser votre commande pour indiquer celui que vous souhaitez s\xe9lectionner.","clickNotInitialized":"La fonction \xab\xa0Appuyer par nom\xa0\xbb n\'est pas disponible pour le moment. Veuillez contacter l\'assistance si le probl\xe8me persiste.","platformUnsupported":"Les fonctionnalit\xe9s de la souris vocale ne sont pas prises en charge sur cette plateforme."},"clickWait":"Initialisation en cours. Veuillez patienter un instant et r\xe9essayer."},"deprecated":"D\xe9pr\xe9ci\xe9","view":"Voir","aiWorkflows":{"settings":{"title":"Param\xe8tres des flux de travail d\'IA","description":"Configurez les mod\xe8les d\'IA et les appareils utilis\xe9s pour les flux de travail d\'IA. Ces flux de travail vous permettent d\'automatiser les t\xe2ches de bureau et de navigateur gr\xe2ce \xe0 l\'IA embarqu\xe9e.","configType":{"title":"Type de configuration du mod\xe8le","description":"S\xe9lectionnez le type de configuration de mod\xe8le \xe0 utiliser pour les flux de travail d\'IA. Diff\xe9rentes configurations sont optimis\xe9es pour diff\xe9rents mod\xe8les.","label":"Type de configuration"},"reasoningModel":{"title":"Mod\xe8le de raisonnement","description":"S\xe9lectionnez le mod\xe8le d\'IA \xe0 utiliser pour les t\xe2ches de raisonnement et de planification. Ce mod\xe8le analysera vos demandes et cr\xe9era des plans d\'action.","label":"Mod\xe8le de raisonnement"},"reasoningDevice":{"label":"Dispositif de raisonnement"},"generationModel":{"title":"Mod\xe8le de g\xe9n\xe9ration","description":"S\xe9lectionnez le mod\xe8le d\'IA \xe0 utiliser pour les t\xe2ches de g\xe9n\xe9ration de texte. Ce mod\xe8le cr\xe9e du contenu textuel en fonction des besoins des flux de travail.","label":"Mod\xe8le de g\xe9n\xe9ration"},"generationDevice":{"label":"Dispositif de g\xe9n\xe9ration"},"noModelsFound":"Aucun mod\xe8le trouv\xe9","terminate":{"title":"Ressources de flux de travail clair","description":"Cliquez pour interrompre le processus et lib\xe9rer des ressources. Cela arr\xeatera tout flux de travail en cours et lib\xe9rera la m\xe9moire utilis\xe9e par les mod\xe8les d\'IA.","button":"Mettre fin au flux de travail","success":"Le processus de travail a \xe9t\xe9 interrompu.","confirm":{"title":"Mettre fin au flux de travail","description":"\xcates-vous s\xfbr de vouloir interrompre le processus de workflow\xa0? Cela arr\xeatera tout workflow en cours et lib\xe9rera des ressources.","confirm":"Oui, terminez"}},"autoWarm":{"title":"Flux de travail d\'IA \xe0 d\xe9marrage automatique","description":"Initialisation automatique des mod\xe8les de flux de travail d\'IA au d\xe9marrage de l\'application. Les mod\xe8les seront pr\xe9charg\xe9s afin que les flux de travail puissent d\xe9marrer imm\xe9diatement.","option":"D\xe9marrage automatique des mod\xe8les de flux de travail IA au lancement de l\'application"},"prompt":{"title":"Informations compl\xe9mentaires pour les flux de travail d\'IA","description":"Saisissez des informations suppl\xe9mentaires qui seront utilis\xe9es par l\'IA de Cephable lors de l\'ex\xe9cution des workflows. Utilisez ce champ pour indiquer vos pr\xe9f\xe9rences concernant le ton, le comportement ou tout autre d\xe9tail.","field":"Invite suppl\xe9mentaire","placeholder":"Par exemple, confirmez toujours avant d\'envoyer des courriels. Privil\xe9giez les r\xe9ponses concises. Utilisez un langage formel dans vos documents."},"disableButtonNames":{"edit":"Interactions avec le bouton Bloquer","input":{"label":"Nom du bouton","question":"Quels boutons souhaitez-vous bloquer\xa0? Vous pouvez saisir des noms de boutons complets ou partiels.","remove":"Supprimer le nom du bouton"},"button":"Bloquer les boutons","description":"Contr\xf4lez les boutons avec lesquels les flux de travail d\'IA sont autoris\xe9s \xe0 interagir. Par d\xe9faut, Cephable peut cliquer sur n\'importe quel bouton de votre \xe9cran. Utilisez ce param\xe8tre pour \xe9viter les actions accidentelles (par exemple, \xab\xa0acheter\xa0\xbb, \xab\xa0supprimer\xa0\xbb)."}}},"control":"Contr\xf4le","automate":"Automatiser","deviceCommandThrottled":{"macroLength":"Cette connexion ne permet pas les macros longues. Votre macro a \xe9t\xe9 raccourcie automatiquement.","commandCount":"Cette connexion limite la vitesse d\'envoi des commandes. Veuillez patienter et r\xe9essayer ult\xe9rieurement."},"tos":{"title":"Mise \xe0 jour des conditions d\'utilisation","description":"Nos conditions d\'utilisation ont \xe9t\xe9 mises \xe0 jour. Veuillez consulter et accepter les conditions mises \xe0 jour pour continuer \xe0 utiliser Cephable.","effectiveDate":"Date d\'entr\xe9e en vigueur : {{date}}","accept":"Accepter les conditions d\'utilisation","loadError":"Impossible de charger les conditions d\'utilisation. Veuillez r\xe9essayer.","viewInBrowser":"Afficher les conditions d\'utilisation dans le navigateur","acceptCheckbox":"J\'ai lu et j\'accepte les conditions d\'utilisation"}}');


var $e182c8d7a6bdad6a$exports = {};
$e182c8d7a6bdad6a$exports = JSON.parse('{"404":"Ah non ! Nous avons fouill\xe9 la mer et nous ne trouvons pas votre page\xa0!"}');


var $647dd474a4538087$exports = {};
$647dd474a4538087$exports = JSON.parse('{"smartTasks":{"tourLabel":"T\xe2ches intelligentes","learn":"Apprenez \xe0 g\xe9n\xe9rer, r\xe9\xe9crire et traduire du texte avec Cephable.","generate":{"openTool":{"title":"Ouvrir l\'outil de g\xe9n\xe9ration de texte","description":"Dans le panneau Cephable, cliquez sur la carotte \xe0 c\xf4t\xe9 de T\xe2ches intelligentes et s\xe9lectionnez G\xe9n\xe9rer du texte."},"enterPrompt":{"title":"Entrez l\'invite","description":"Dans la bo\xeete de dialogue, saisissez\xa0: Cr\xe9ez un jeu de mots en une seule phrase cr\xe9dible."},"clickGenerate":{"title":"Cliquez sur G\xe9n\xe9rer","description":"Cliquez sur le bouton \xab\xa0G\xe9n\xe9rer\xa0\xbb. Regardez le texte appara\xeetre en temps r\xe9el."},"focusApp":{"title":"Concentrez-vous sur l\'application","description":"Assurez-vous de s\xe9lectionner l\'application o\xf9 vous souhaitez que le texte g\xe9n\xe9r\xe9 apparaisse. Vous pourrez g\xe9n\xe9rer le texte \xe0 cet endroit en toute simplicit\xe9 en cliquant sur \xab\xa0G\xe9n\xe9rer\xa0\xbb."}},"rewrite":{"welcome":{"title":"Bienvenue \xe0 Rewrite","description":"Reformulez rapidement le contenu avec du texte surlign\xe9 ou coll\xe9."},"highlightToggle":{"title":"Utiliser le texte en surbrillance","description":"Assurez-vous que \xab\xa0Utiliser le texte en surbrillance\xa0\xbb est s\xe9lectionn\xe9 (par d\xe9faut)."},"highlightText":{"title":"Surligner le texte \xe0 r\xe9\xe9crire","description":"Point fort : une pieuvre peut contr\xf4ler chaque bras ind\xe9pendamment."},"enterInstructions":{"title":"Entrez les instructions de r\xe9\xe9criture","description":"Type : Dans un style anglais ancien."},"clickGenerate":{"title":"Cliquez sur G\xe9n\xe9rer","description":"Votre texte surlign\xe9 sera r\xe9\xe9crit en fonction de votre saisie."},"pasteMode":{"title":"Utiliser Coller du texte","description":"Collez l\'original et r\xe9\xe9crivez les instructions. Cliquez sur \xab\xa0G\xe9n\xe9rer\xa0\xbb. Cliquez sur \xab\xa0Effacer\xa0\xbb pour r\xe9initialiser."},"openTool":{"title":"Ouvrir l\'outil de r\xe9\xe9criture de texte","description":"Dans le panneau Cephable, cliquez sur la carotte \xe0 c\xf4t\xe9 de T\xe2ches intelligentes et s\xe9lectionnez R\xe9\xe9crire le texte."},"focusApp":{"title":"Concentrez-vous sur l\'application","description":"Assurez-vous de s\xe9lectionner l\'application o\xf9 vous souhaitez que le texte r\xe9\xe9crit apparaisse. Vous pourrez g\xe9n\xe9rer facilement le texte \xe0 cet endroit en cliquant sur \xab\xa0G\xe9n\xe9rer\xa0\xbb."}},"translate":{"welcome":{"title":"Bienvenue sur Translate","description":"Traduisez le texte surlign\xe9 ou coll\xe9 dans une autre langue."},"highlightToggle":{"title":"Utiliser le texte en surbrillance","description":"Assurez-vous que \xab\xa0Utiliser le texte en surbrillance\xa0\xbb est s\xe9lectionn\xe9."},"highlightText":{"title":"Surligner le texte \xe0 traduire","description":"Point fort : une pieuvre peut contr\xf4ler chaque bras ind\xe9pendamment."},"enterLanguage":{"title":"Entrez la langue cible","description":"Type : Portugais."},"clickGenerate":{"title":"Cliquez sur G\xe9n\xe9rer","description":"La traduction sera saisie dans votre application au niveau de votre curseur."},"pasteMode":{"title":"Utiliser Coller du texte","description":"Collez le texte et la langue. Cliquez sur \xab\xa0G\xe9n\xe9rer\xa0\xbb. Cliquez sur \xab\xa0Effacer\xa0\xbb pour r\xe9initialiser."},"openTool":{"title":"Ouvrir l\'outil de traduction de texte","description":"Dans le panneau Cephable, cliquez sur la carotte \xe0 c\xf4t\xe9 de T\xe2ches intelligentes et s\xe9lectionnez Traduire le texte."}},"rowDescription":"Les t\xe2ches intelligentes sont les diff\xe9rentes t\xe2ches que l\'IA de Cephable peut effectuer pour vous. Ces t\xe2ches, aliment\xe9es par l\'IA int\xe9gr\xe9e \xe0 l\'appareil, peuvent \xeatre utilis\xe9es pour cr\xe9er du texte, r\xe9sumer, r\xe9\xe9crire, traduire, et bien plus encore."},"overview":{"title":"Aper\xe7u","description":"Cephable est votre IA personnelle\xa0: con\xe7ue pour des actions rapides, des commandes vocales, la g\xe9n\xe9ration de contenu et une automatisation intelligente de vos outils. Des commandes pr\xeates \xe0 l\'emploi. Aucun traitement cloud. Juste une productivit\xe9 qui vous accompagne."},"customControls":{"tourLabel":"Contr\xf4les globaux et des appareils toujours disponibles","rowDescription":"Les commandes globales et celles de l\'appareil sont toujours disponibles si votre microphone est activ\xe9, quelle que soit l\'application utilis\xe9e. Vous pouvez utiliser ces commandes pour interagir avec votre appareil sans avoir \xe0 cr\xe9er de nouvelles commandes. Elles contiennent des commandes utiles comme changer de commande ou d\'application, g\xe9n\xe9rer du texte, mettre votre microphone en pause, et bien plus encore."},"profile":{"tourLabel":"Contr\xf4les de l\'application","learn":"D\xe9couvrez comment configurer les contr\xf4les et les pr\xe9f\xe9rences de votre application dans Cephable.","rowDescription":"Les commandes d\'application sont des ensembles de commandes configur\xe9es que vous pouvez utiliser pour ex\xe9cuter des actions. Vous souhaitez dire \xab\xa0Diapositive suivante\xa0\xbb pour passer \xe0 la diapositive suivante de votre pr\xe9sentation\xa0? Ou utiliser les mouvements de la t\xeate pour d\xe9placer le curseur et les commandes vocales pour modifier les raccourcis\xa0? C\'est possible avec les commandes d\'application. La ligne \xab\xa0Commandes\xa0\xbb affiche toutes les commandes disponibles pour votre application actuelle.","check":{"title":"V\xe9rifiez vos commandes disponibles.","description":"Les commandes d\'application sont disponibles pour chaque application que vous utilisez. Vous pouvez voir ici les commandes disponibles pour l\'application que vous utilisez actuellement. Essayez une autre commande pour voir son fonctionnement. Assurez-vous toutefois de vous concentrer sur l\'application que vous souhaitez contr\xf4ler."}},"dictation":{"tourLabel":"Dict\xe9e","learn":"Apprenez \xe0 utiliser le mode dict\xe9e pour convertir votre discours en texte en mains libres.","welcome":{"title":"Dict\xe9e","description":"La dict\xe9e vous permet de parler naturellement et de saisir vos mots pendant que vous parlez. C\'est comme avoir un assistant personnel qui saisit tout ce que vous dites."},"microphone":{"title":"Allumez votre microphone","description":"Tout d\'abord, activez votre microphone. Cliquez sur l\'ic\xf4ne \xab\xa0Microphone\xa0\xbb dans le panneau Cephable."},"activate":{"title":"D\xe9marrer le mode dict\xe9e","description":"La voix d\xe9marre en mode commande. Pour lancer la dict\xe9e, dites \xab\xa0D\xe9marrer la dict\xe9e\xa0\xbb ou cliquez sur le bouton \xab\xa0Dict\xe9e\xa0\xbb. Activons maintenant le mode dict\xe9e."},"focus":{"title":"Se concentrer sur un champ de texte ou un document","description":"La dict\xe9e est plus efficace lorsque vous vous concentrez sur un champ de texte ou un document. Cliquez sur le champ de texte ou le document o\xf9 vous souhaitez dicter."},"speaking":{"title":"Commencez \xe0 parler","description":"Vous pouvez maintenant commencer \xe0 parler. Tout ce que vous direz sera saisi dans le champ de texte ou le document sur lequel vous vous \xeates concentr\xe9. Essayez de dire quelque chose comme\xa0: \xab\xa0Bonjour, ceci est un test du mode dict\xe9e.\xa0\xbb"},"pauseResume":{"title":"Pause de la dict\xe9e","description":"Besoin d\'une pause sans d\xe9sactiver la dict\xe9e\xa0? Dites simplement \xab\xa0Suspendre la dict\xe9e\xa0\xbb. Vous pouvez la reprendre \xe0 tout moment avec \xab\xa0D\xe9marrer la dict\xe9e\xa0\xbb. Vous pouvez personnaliser davantage cette option gr\xe2ce aux commandes globales et aux commandes de l\'appareil toujours actives."},"stop":{"title":"Arr\xeater la dict\xe9e","description":"Besoin de revenir aux commandes de votre application\xa0? Dites simplement \xab\xa0Arr\xeater la dict\xe9e\xa0\xbb. Cela arr\xeatera le mode dict\xe9e et vous ram\xe8nera au mode commande. Vous pouvez reprendre \xe0 tout moment en cliquant \xe0 nouveau sur \xab\xa0D\xe9marrer la dict\xe9e\xa0\xbb."},"complete":{"description":"Et voil\xe0\xa0! Vous pouvez d\xe9sormais dicter, mettre en pause, reprendre et passer du mode dict\xe9e au mode commande. La dict\xe9e est un outil puissant pour la saisie mains libres. Utilisez-la pour r\xe9diger des e-mails, des documents ou tout ce que vous devez saisir \xe0 voix haute."}},"camera":{"tourLabel":"Commandes de la cam\xe9ra","rowDescription":"Les commandes de l\'appareil photo vous permettent d\'utiliser votre visage et votre corps pour contr\xf4ler votre appareil. Vous pouvez utiliser diff\xe9rentes expressions faciales et mouvements de t\xeate pour contr\xf4ler votre appareil. Avec le microphone activ\xe9, vous pouvez utiliser des commandes vocales pour d\xe9marrer et arr\xeater l\'appareil photo, et changer de cam\xe9ra.","learn":"Apprenez \xe0 utiliser les commandes de l\u2019appareil photo pour naviguer et interagir avec votre appareil en mains libres.","welcome":{"title":"Commandes de la cam\xe9ra","description":"Les commandes de l\'appareil photo vous permettent d\'utiliser votre visage et votre corps pour contr\xf4ler votre appareil. Vous pouvez utiliser diff\xe9rentes expressions faciales, mouvements de t\xeate et commandes vocales pour naviguer et interagir avec votre appareil en mode mains libres."},"start":{"title":"D\xe9marrer les commandes de la cam\xe9ra","description":"Pour commencer \xe0 utiliser les commandes de la cam\xe9ra si vous utilisez la voix, dites \xab\xa0D\xe9marrer les commandes de la cam\xe9ra\xa0\xbb ou cliquez sur le bouton Commandes de la cam\xe9ra."}},"microphone":{"tourLabel":"Commandes vocales","learn":"D\xe9couvrez comment utiliser votre voix pour contr\xf4ler n\u2019importe quelle application et utiliser la dict\xe9e pour taper ce que vous dites.","description":"Les commandes vocales Cephable vous permettent d\'utiliser votre voix pour contr\xf4ler votre appareil. Vous souhaitez enregistrer un document\xa0? Dites simplement \xab\xa0Enregistrer\xa0\xbb. Vous souhaitez mettre votre musique en pause\xa0? Dites simplement \xab\xa0Pause\xa0\xbb. La voix vous permet \xe9galement d\'utiliser la dict\xe9e vocale pour saisir ce que vous dites.","rowDescription":"Lorsque le microphone est d\xe9sactiv\xe9, nous n\'entendons pas vos commandes vocales. Cependant, si vous l\'activez, vous pourrez utiliser les commandes globales pour mettre en pause, d\xe9marrer, etc. Allumons-le.","start":{"title":"D\xe9marrer les commandes vocales","description":"Pour commencer \xe0 utiliser les commandes vocales, cliquez sur l\'interrupteur \xab\xa0Microphone\xa0\xbb dans le panneau Cephable. Cela activera le microphone et commencera \xe0 \xe9couter les commandes."},"tryOpen":{"title":"Essayez de dire \xab\xa0Ouvrir Spotify\xa0\xbb ou \xab\xa0Ouvrir Word\xa0\xbb","description":"\xab\xa0Ouvrir\xa0\xbb est une commande globale qui ouvre l\'application sp\xe9cifi\xe9e et lui donne le focus. Si le changement automatique de contr\xf4le est activ\xe9, la commande basculera \xe9galement vers les contr\xf4les d\'application les plus adapt\xe9s \xe0 l\'application que vous utilisez."},"finishedCommands":{"title":"Excellent\xa0! Vous avez appris les bases des commandes vocales.","description":"Vous pouvez toujours consulter la visite depuis la page d\'assistance. L\'\xe9tape suivante consiste \xe0 d\xe9couvrir la dict\xe9e. Vous pouvez commencer la visite depuis la page d\'assistance."}},"publicProfiles":{"tourLabel":"Personnaliser les contr\xf4les de l\'application"},"tour":{"title":"Bienvenue chez Cephable","description":"Cephable est un outil puissant qui vous permet de contr\xf4ler votre ordinateur avec votre voix, votre cam\xe9ra et d\'autres commandes. Cette visite vous guidera \xe0 travers ses principales fonctionnalit\xe9s et vous expliquera comment les utiliser efficacement.","startTour":"D\xe9marrer la visite","finishTour":"Terminer la tourn\xe9e","statusDialog":"Veuillez consulter le panneau pour plus d\'informations.","step":"\xc9tape {{step}} sur {{total}}","next":"Suivant","previous":"Pr\xe9c\xe9dent","endTour":"Fin de la tourn\xe9e","nextTourLabel":"Suivant\xa0: {{nextStepTitle}}","skipTour":"Skip Tour","steps":{"welcome":{"title":"Bienvenue chez Cephable","description":"Cette visite vous guidera \xe0 travers les principales fonctionnalit\xe9s de Cephable. C\'est parti\xa0!"},"inputs":{"title":"Aper\xe7u des entr\xe9es","description":"Cephable prend en charge plusieurs m\xe9thodes de saisie, notamment les commandes vocales, les commandes de cam\xe9ra, etc. Vous pouvez personnaliser ces saisies dans les param\xe8tres."},"appControls":{"title":"Contr\xf4les de l\'application","description":"Cr\xe9ez des contr\xf4les d\'application pour associer vos entr\xe9es \xe0 des actions sp\xe9cifiques dans vos applications. Cela vous permet de contr\xf4ler vos applications par gestes, commandes vocales, etc."},"settings":{"title":"Param\xe8tres","description":"Acc\xe9dez aux param\xe8tres pour configurer vos entr\xe9es, les commandes de vos applications et autres pr\xe9f\xe9rences. Vous pouvez \xe9galement g\xe9rer votre compte et vos param\xe8tres de langue ici."},"intelligentTasks":{"title":"T\xe2ches intelligentes","description":"Utilisez des t\xe2ches intelligentes pour g\xe9n\xe9rer du texte, r\xe9sumer du contenu, r\xe9\xe9crire du texte, traduire des langues et bien plus encore \xe0 l\'aide de fonctionnalit\xe9s bas\xe9es sur l\'IA."},"cameraControls":{"title":"Commandes de la cam\xe9ra","description":"Activez les commandes de la cam\xe9ra pour utiliser les expressions faciales et les mouvements de la t\xeate comme m\xe9thodes de saisie pour contr\xf4ler votre ordinateur."},"voiceControls":{"title":"Commandes vocales","description":"Utilisez les commandes vocales pour contr\xf4ler votre ordinateur en mains libres. Vous pouvez dicter du texte, \xe9mettre des commandes et interagir avec des applications gr\xe2ce \xe0 votre voix."}}},"onboarding":{"demoPlaceholder":"Ceci est le texte de d\xe9monstration de l\'espace r\xe9serv\xe9. \xc0 l\'aide des instructions ci-dessus, vous pouvez contr\xf4ler le style de ce texte.","exit":"Configuration de sortie","overview":"Aper\xe7u","learn":"D\xe9couvrez les fonctionnalit\xe9s de Cephable et comment les utiliser.","start":"On dirait que vous ne faites que commencer. Voici quelques pistes pour vous aider.","startTour":"Commencer","dashboard":{"title":"Tableau de bord Cephable","description":"Le tableau de bord Cephable est votre plateforme centrale pour g\xe9rer votre appareil, les commandes de vos applications et vos param\xe8tres. De l\xe0, vous pouvez personnaliser votre exp\xe9rience, consulter les commandes actives et acc\xe9der \xe0 toutes les fonctionnalit\xe9s de Cephable."},"step1":{"title":"Bienvenue chez Cephable","description":"Cephable est votre IA personnelle\xa0: con\xe7ue pour des actions rapides, des commandes vocales, la g\xe9n\xe9ration de contenu et une automatisation intelligente de vos outils. Des commandes pr\xeates \xe0 l\'emploi. Aucun traitement cloud. Juste une productivit\xe9 qui vous accompagne.","inputs":"Que sont les entr\xe9es ?","inputDescription":"Les commandes d\'entr\xe9e sont les m\xe9thodes permettant d\'utiliser votre appareil, \xe9tendant les capacit\xe9s de votre ordinateur au-del\xe0 de la souris et du clavier traditionnels. Ces m\xe9thodes incluent les commandes vocales, les mouvements de la t\xeate, les expressions faciales et les p\xe9riph\xe9riques suppl\xe9mentaires.","profiles":"Que sont les contr\xf4les d\u2019application\xa0?","profileDescription":"Les commandes d\'application vous permettent de vous connecter et de communiquer avec votre ordinateur de mani\xe8re unique en associant les commandes d\'entr\xe9e et de sortie. Gr\xe2ce aux commandes d\'application, vous pouvez demander \xe0 Cephable d\'effectuer des t\xe2ches comme enregistrer un fichier en inclinant la t\xeate ou cliquer sur \xab\xa0Envoyer\xa0\xbb un e-mail avec un sourire.","action":"Explorer les contr\xf4les d\'entr\xe9e","secondaryAction":"Acc\xe9der aux commandes de l\'application","secondaryActionDescription":"Connaissez-vous d\xe9j\xe0 les contr\xf4les d\u2019entr\xe9e\xa0?"},"finish":{"title":"Installation termin\xe9e","description":"Vous avez utilis\xe9 avec succ\xe8s vos premi\xe8res commandes d\'application Cephable\xa0! Vous pouvez d\xe9sormais les utiliser, et bien plus encore, sur votre appareil. Elles sont disponibles sur votre tableau de bord Cephable, o\xf9 vous pouvez continuer \xe0 personnaliser les param\xe8tres des commandes d\'application selon vos besoins.","continueToApp":"Continuer vers le tableau de bord Cephable","keepExploring":"Continuez \xe0 explorer"},"useCaseSlider":{"context":"J\'aimerais utiliser","control":"contr\xf4ler"}},"support":{"tourLabel":"Pr\xeat \xe0 en savoir plus ?","description":"Vous pouvez visiter notre centre d\'assistance pour plus d\'informations sur l\'utilisation de Cephable, notamment des visites guid\xe9es, des guides \xe9tape par \xe9tape, des didacticiels et des vid\xe9os.","cta":"Explorez d\'autres circuits"},"featureFlag":{"title":"Il est temps de mettre \xe0 niveau","description":"La fonctionnalit\xe9 que vous essayez d\'utiliser n\xe9cessite une licence diff\xe9rente. Effectuez une mise \xe0 niveau pour acc\xe9der \xe0 cette fonctionnalit\xe9 et \xe0 bien d\'autres."},"replyToSocialMedia":{"tourLabel":"R\xe9ponses plus rapides sur les r\xe9seaux sociaux gr\xe2ce \xe0 la dict\xe9e","learn":"Apprenez \xe0 utiliser la dict\xe9e pour r\xe9pondre aux publications sur les r\xe9seaux sociaux en mains libres.","navigateTo":{"title":"Acc\xe9der \xe0 une publication sur les r\xe9seaux sociaux","description":"Ouvrez votre navigateur web et acc\xe9dez \xe0 un r\xe9seau social comme LinkedIn ou Facebook. Trouvez la publication \xe0 laquelle vous souhaitez r\xe9pondre."},"speaking":{"title":"Commencez \xe0 parler","description":"Vous pouvez maintenant commencer \xe0 parler. Tout ce que vous direz sera saisi dans le champ de texte ou le document sur lequel vous vous \xeates concentr\xe9. Essayez de dire quelque chose comme \xab\xa0F\xe9licitations\xa0! Je suis ravi pour toi.\xa0\xbb Assurez-vous que votre curseur est positionn\xe9 sur un champ de texte ou une zone de commentaire."},"complete":{"description":"Et voil\xe0 ! Vous pouvez d\xe9sormais utiliser les fonctions de dict\xe9e, de pause, de reprise et de basculement entre les modes dict\xe9e et commande pour r\xe9pondre aux publications sur les r\xe9seaux sociaux en mode mains libres. La dict\xe9e est un outil puissant pour la saisie mains libres. Utilisez-la pour r\xe9diger des e-mails, des documents ou tout ce que vous devez saisir \xe0 voix haute."}},"hotkeys":{"tourLabel":"Boutons d\'action rapide","learn":"D\xe9couvrez comment configurer des boutons d\u2019action rapide pour associer plusieurs actions \xe0 un seul bouton.","rowDescription":"Les boutons d\'action rapide vous permettent d\'effectuer plusieurs actions avec une seule commande. Par exemple, vous pouvez cr\xe9er un bouton qui ouvre votre application musicale pr\xe9f\xe9r\xe9e et lance la lecture d\'une playlist sp\xe9cifique.","check":{"title":"V\xe9rifiez vos actions rapides disponibles.","description":"Des boutons d\'action rapide sont disponibles pour chaque application que vous utilisez. Vous pouvez voir ici les boutons disponibles pour l\'application que vous utilisez actuellement. Essayez une autre commande pour voir son fonctionnement. Assurez-vous toutefois de vous concentrer sur l\'application que vous souhaitez contr\xf4ler."}},"controllingBackgroundMusic":{"tourLabel":"G\xe9rez la musique de fond sans interrompre votre flux","learn":"Apprenez \xe0 utiliser les commandes vocales et les actions rapides pour contr\xf4ler votre musique en mains libres, tout en restant concentr\xe9 sur votre t\xe2che en cours.","tryOpen":{"title":"Essayez de dire \xab\xa0Ouvrir Spotify\xa0\xbb ou \xab\xa0Ouvrir Apple Music\xa0\xbb"},"play":{"title":"Essayez de dire \xab\xa0Play\xa0\xbb pour commencer \xe0 jouer de la musique","description":"Assurez-vous que votre microphone est activ\xe9 et dites \xab\xa0Lecture\xa0\xbb. La musique sera alors diffus\xe9e dans l\'application musicale de votre choix. Cela fonctionne \xe9galement avec toute autre application multim\xe9dia."},"newPlaylist":{"title":"Cr\xe9er une nouvelle playlist","description":"Assurez-vous que votre microphone est activ\xe9 et dites \xab\xa0Nouvelle playlist\xa0\xbb. Cela lancera la cr\xe9ation d\'une nouvelle playlist dans l\'application musicale de votre choix."},"finishedCommands":{"title":"Bravo ! Vous avez appris \xe0 contr\xf4ler votre musique en mains libres.","description":"Vous savez maintenant utiliser les commandes vocales et les actions rapides pour lire, mettre en pause, changer de piste et r\xe9gler le volume dans vos applications musicales pr\xe9f\xe9r\xe9es. Explorez d\'autres commandes ou personnalisez vos propres actions rapides pour un contr\xf4le musical encore plus fluide."}},"editingVideos":{"tourLabel":"Concentrez-vous sur l\'histoire, pas sur les clics fastidieux du montage vid\xe9o","learn":"Apprenez \xe0 utiliser les commandes vocales et les actions rapides pour \xe9diter des vid\xe9os plus rapidement et supprimez la charge cognitive li\xe9e \xe0 la m\xe9morisation des boutons sur lesquels cliquer pendant l\'\xe9dition.","tryOpen":{"title":"Essayez de dire \xab\xa0Ouvrir iMovie\xa0\xbb ou \xab\xa0Ouvrir DaVinci Resolve\xa0\xbb"},"play":{"title":"Essayez de dire \xab\xa0Play\xa0\xbb pour commencer \xe0 lire votre vid\xe9o","description":"Assurez-vous que votre microphone est activ\xe9 et dites \xab\xa0Lecture\xa0\xbb. La lecture de votre vid\xe9o commencera dans l\'application de montage vid\xe9o de votre choix."},"stop":{"title":"Arr\xeater la lecture vid\xe9o","description":"Assurez-vous que votre microphone est activ\xe9 et dites \xab\xa0Stop\xa0\xbb. Cela arr\xeatera la lecture de la vid\xe9o dans l\'application de montage vid\xe9o de votre choix."},"finishedCommands":{"title":"Bravo ! Vous avez appris \xe0 contr\xf4ler votre montage vid\xe9o en mains libres.","description":"Vous savez maintenant utiliser les commandes vocales et les actions rapides pour lire, mettre en pause, changer de piste et r\xe9gler le volume dans vos applications de montage vid\xe9o pr\xe9f\xe9r\xe9es. Explorez d\'autres commandes ou personnalisez vos propres actions rapides pour un contr\xf4le vid\xe9o encore plus fluide."}},"vibeCoding":{"tourLabel":"Cr\xe9ez des id\xe9es, cr\xe9ez des prototypes et it\xe9rez plus rapidement avec la dict\xe9e","learn":"Apprenez \xe0 utiliser la dict\xe9e et la g\xe9n\xe9ration de texte aliment\xe9e par l\'IA pour cr\xe9er du code, cr\xe9er des prototypes et it\xe9rer sur des id\xe9es.","navigateTo":{"title":"Acc\xe9der \xe0 un \xe9diteur de code Vibe","description":"Ouvrez votre navigateur web et acc\xe9dez \xe0 un \xe9diteur de code Vibe. Voici quelques exemples\xa0: Vercel V0, GitHub Copilot dans VS Code, Base 44 et Lovable."},"focus":{"title":"Cliquez sur \xab\xa0Nouvelle discussion\xa0\xbb ou concentrez-vous sur une zone de texte.","description":"La dict\xe9e est plus efficace lorsque vous vous concentrez sur un champ de texte ou un document. Cliquez sur la zone de commentaire ou le fil de discussion o\xf9 vous souhaitez dicter. Ensuite, commencez \xe0 parler."},"speaking":{"title":"Commencez \xe0 parler","description":"Vous pouvez maintenant commencer \xe0 parler. Tout ce que vous direz sera saisi dans le champ de texte ou le document sur lequel vous vous \xeates concentr\xe9. Essayez d\'\xe9noncer vos exigences techniques et ce que le code doit faire. Assurez-vous que votre curseur est positionn\xe9 sur un champ de texte ou une zone de commentaire."},"rewriteIntro":{"title":"R\xe9\xe9crire le code avec des instructions","description":"Vous pouvez \xe9galement utiliser des t\xe2ches intelligentes comme la r\xe9\xe9criture pour modifier le code existant. Cette t\xe2che est optimis\xe9e par l\'IA int\xe9gr\xe9e \xe0 l\'appareil, ce qui signifie qu\'elle fonctionne sans connexion Internet et s\'ex\xe9cute directement depuis votre appareil."},"highlightText":{"title":"Surligner le texte \xe0 r\xe9\xe9crire","description":"Mettez en surbrillance le code que vous souhaitez r\xe9\xe9crire."},"enterInstructions":{"title":"Entrez les instructions de r\xe9\xe9criture","description":"Saisissez vos instructions de r\xe9\xe9criture de code. Pr\xe9cisez le langage de programmation, le style ou toute modification sp\xe9cifique souhait\xe9e."},"complete":{"description":"Et voil\xe0\xa0! Vous pouvez d\xe9sormais dicter, mettre en pause, reprendre et it\xe9rer sur du code. Explorez d\'autres cas d\'utilisation avec la dict\xe9e et les t\xe2ches intelligentes, ou d\'autres fonctionnalit\xe9s pour optimiser votre flux de travail."}},"documentCode":{"tourLabel":"Documentation de code rapide et s\xe9curis\xe9e avec g\xe9n\xe9ration de texte IA sur l\'appareil","learn":"D\xe9couvrez comment utiliser la r\xe9\xe9criture aliment\xe9e par l\'IA pour documenter le code tout en restant dans la m\xeame application et en gardant vos donn\xe9es en s\xe9curit\xe9.","rewriteIntro":{"title":"R\xe9diger la documentation du code","description":"Vous pouvez utiliser Cephable Intelligent Rewrite pour r\xe9diger la documentation de votre code dans un document ou une application distinct. La r\xe9\xe9criture fait partie des t\xe2ches d\'IA sur l\'appareil, notamment la g\xe9n\xe9ration et la traduction hors ligne."},"focusApp":{"title":"Concentrez-vous sur votre code","description":"Ouvrez votre IDE et concentrez-vous sur le code que vous souhaitez documenter."},"newFile":{"title":"Cr\xe9er un fichier de documentation","description":"Cr\xe9ez un nouveau fichier dans votre IDE ou ouvrez une application distincte dans laquelle vous souhaitez que la documentation apparaisse."},"highlightText":{"title":"Code de surbrillance","description":"Mettez en surbrillance et copiez le code que vous souhaitez documenter."},"pasteMode":{"title":"Cliquez sur l\'onglet Coller le texte","description":"Utilisez le mode Coller pour coller le code d\'origine et \xe9crire la documentation dans un nouveau fichier."},"pasteInput":{"title":"Coller le code dans le document","description":"Collez le code que vous souhaitez documenter dans la zone de saisie."},"enterInstructions":{"title":"Saisissez les instructions de formatage, de style et de contenu","description":"Saisissez les instructions de votre documentation de codage. Pr\xe9cisez le type de fichier (par exemple, Markdown), le style ou tout contenu sp\xe9cifique souhait\xe9."},"complete":{"description":"Vous avez appris \xe0 utiliser les t\xe2ches intelligentes pour une documentation de code rapide et s\xe9curis\xe9e. Explorez d\'autres cas d\'utilisation avec la r\xe9\xe9criture ou d\'autres fonctionnalit\xe9s pour optimiser votre flux de travail."}},"generateCode":{"tourLabel":"G\xe9n\xe9ration de code rapide et s\xe9curis\xe9e avec g\xe9n\xe9ration de texte IA sur l\'appareil","learn":"D\xe9couvrez comment utiliser la g\xe9n\xe9ration bas\xe9e sur l\'IA pour cr\xe9er des extraits de code tout en vous d\xe9pla\xe7ant entre les applications et en prot\xe9geant vos donn\xe9es.","rewriteIntro":{"title":"\xc9crire des extraits de code","description":"Vous pouvez utiliser Cephable Intelligent Rewrite pour \xe9crire des extraits de code dans votre IDE tout en r\xe9cup\xe9rant les exigences d\'une autre application. La r\xe9\xe9criture fait partie des t\xe2ches d\'IA sur l\'appareil, notamment la g\xe9n\xe9ration et la traduction hors ligne."},"focusApp":{"title":"Concentrez-vous sur le contenu de votre billet","description":"Ouvrez votre ticket qui sp\xe9cifie les exigences et concentrez-vous sur le contenu pour lequel vous souhaitez g\xe9n\xe9rer du code."},"newFile":{"title":"Cr\xe9er un fichier d\'extrait de code","description":"Cr\xe9ez un nouveau fichier dans votre IDE."},"highlightText":{"title":"Mettre en \xe9vidence le contenu du billet","description":"Mettez en surbrillance et copiez le contenu pour lequel vous souhaitez g\xe9n\xe9rer du code."},"pasteMode":{"title":"Cliquez sur l\'onglet Coller le texte","description":"Utilisez le mode Coller pour coller les exigences du ticket d\'origine et \xe9crire des extraits de code pour."},"pasteInput":{"title":"Coller les exigences pour g\xe9n\xe9rer du code","description":"Collez les exigences que vous souhaitez utiliser pour la g\xe9n\xe9ration de code dans la zone de saisie."},"enterInstructions":{"title":"Entrez les instructions de langage et de style de programmation","description":"Saisissez votre langage de programmation et vos instructions de style. Pr\xe9cisez le langage de programmation (par exemple, C#), le style ou toute instruction de codage sp\xe9cifique."},"translateIntro":{"title":"Traduire des extraits de code","description":"Vous pouvez \xe9galement utiliser Cephable Intelligent Translate pour convertir des extraits de code d\'un langage de programmation \xe0 un autre directement dans votre IDE. Translate fait partie des t\xe2ches d\'IA sur l\'appareil, notamment la g\xe9n\xe9ration et la r\xe9\xe9criture hors ligne."},"copyGeneratedCode":{"title":"Copiez le code g\xe9n\xe9r\xe9","description":"Apr\xe8s avoir g\xe9n\xe9r\xe9 du code en suivant les \xe9tapes pr\xe9c\xe9dentes, mettez en surbrillance et copiez l\u2019extrait de code g\xe9n\xe9r\xe9."},"translatePasteMode":{"title":"Cliquez sur l\'onglet Coller le texte","description":"Utilisez le mode collage pour coller le code d\'origine et le traduire dans un autre langage de programmation."},"enterProgrammingLanguage":{"title":"Entrez le langage de programmation cible","description":"Tapez le langage de programmation dans lequel vous souhaitez traduire le code (par exemple Python)."},"pasteCode":{"title":"Collez le code g\xe9n\xe9r\xe9 dans votre IDE","description":"Acc\xe9dez \xe0 votre IDE et collez l\u2019extrait de code copi\xe9 dans le nouveau fichier que vous avez cr\xe9\xe9 pr\xe9c\xe9demment."},"complete":{"description":"Vous avez appris \xe0 utiliser les t\xe2ches intelligentes pour g\xe9n\xe9rer et traduire du code rapidement et en toute s\xe9curit\xe9. Explorez d\'autres cas d\'utilisation avec G\xe9n\xe9rer et Traduire, ou d\'autres fonctionnalit\xe9s pour optimiser votre flux de travail."}},"requirementDocsFromMeeting":{"tourLabel":"Des notes aux documents d\'exigences produit en quelques minutes","learn":"D\xe9couvrez comment utiliser les t\xe2ches intelligentes de l\'IA pour cr\xe9er des documents d\'exigences de produit structur\xe9s \xe0 partir de notes de r\xe9union tout en gardant vos donn\xe9es en s\xe9curit\xe9.","rewriteIntro":{"title":"Cr\xe9er des documents d\'exigences de produit","description":"Vous pouvez utiliser Cephable Intelligent Rewrite pour cr\xe9er des documents d\'exigences produit structur\xe9s \xe0 partir de notes de r\xe9union. La r\xe9\xe9criture fait partie des t\xe2ches d\'IA sur l\'appareil, notamment la g\xe9n\xe9ration et la traduction hors ligne."},"focusNotes":{"title":"Ouvrez vos notes de r\xe9union","description":"Ouvrez vos notes de r\xe9union, vos transcriptions ou tout autre contenu textuel li\xe9 \xe0 la r\xe9union."},"highlight":{"title":"Mettre en \xe9vidence les notes de r\xe9union","description":"Mettez en surbrillance les notes de r\xe9union que vous souhaitez utiliser pour cr\xe9er un document d\u2019exigences produit."},"enterInstructions":{"title":"Saisissez les instructions relatives \xe0 la structure et au contenu du document","description":"Saisissez les instructions de votre document d\'exigences produit. Pr\xe9cisez la structure, le style ou tout contenu sp\xe9cifique souhait\xe9."},"complete":{"description":"Vous avez appris \xe0 utiliser les t\xe2ches intelligentes pour cr\xe9er rapidement et en toute s\xe9curit\xe9 des documents d\'exigences produit. Explorez d\'autres cas d\'utilisation avec Rewrite ou d\'autres fonctionnalit\xe9s pour optimiser votre flux de travail."}},"headMouseMovement":{"tourLabel":"Configuration de jeu mains libres avec souris \xe0 t\xeate","learn":"Apprenez \xe0 utiliser les mouvements de la t\xeate pour contr\xf4ler le curseur de votre souris pour une navigation et un clic pr\xe9cis.","deviceSettings":{"title":"Ouvrir les param\xe8tres de l\'appareil","description":"Pour activer les mouvements de la t\xeate de la souris, cliquez sur le bouton Param\xe8tres de l\'appareil."},"cameraSettings":{"title":"Ouvrir les param\xe8tres de l\'appareil photo","description":"Dans les param\xe8tres de l\u2019appareil, cliquez sur Param\xe8tres de l\u2019appareil photo pour acc\xe9der aux commandes de l\u2019appareil photo."},"headMouseSection":{"title":"Mouvement de la t\xeate pour les commandes de la souris","description":"Lorsque cette option est activ\xe9e, certaines de vos commandes de mouvement de t\xeate seront utilis\xe9es pour d\xe9placer votre souris au lieu des commandes de d\xe9clenchement."},"steadyGlide":{"title":"Mode de glissement stable","description":"Activez le mode Glissement stable. Lorsque vous d\xe9placez votre t\xeate au-del\xe0 d\'un certain point, le curseur glisse continuellement dans cette direction \xe0 vitesse constante."},"customization":{"title":"Personnaliser les param\xe8tres de la t\xeate de la souris","description":"Vous pouvez personnaliser les param\xe8tres de la t\xeate de la souris selon vos pr\xe9f\xe9rences. Ajustez la vitesse, la sensibilit\xe9 et d\'autres param\xe8tres pour une exp\xe9rience optimale."},"save":{"title":"Enregistrer les param\xe8tres de la t\xeate de la souris","description":"N\'oubliez pas d\'enregistrer vos param\xe8tres de souris de t\xeate personnalis\xe9s."},"transition":{"title":"Passage au panneau Cephable","description":"Passons maintenant au panneau Cephable pour tester les mouvements de la t\xeate de la souris."},"playGames":{"title":"Jouez \xe0 des jeux avec la souris principale","description":"Vous pouvez d\xe9sormais utiliser les mouvements de la t\xeate pour contr\xf4ler le curseur de votre souris pendant vos jeux. Essayez-le et d\xe9couvrez son fonctionnement\xa0!"}},"clinicalNoteTaking":{"tourLabel":"Dict\xe9e et formatage conformes \xe0 la loi HIPAA pour les cliniciens","learn":"Apprenez \xe0 utiliser les commandes vocales, la dict\xe9e intelligente et le formatage IA pour prendre des notes cliniques.","speaking":{"title":"Commencez \xe0 parler","description":"Vous pouvez maintenant commencer \xe0 parler. Tout ce que vous direz sera saisi dans le champ de texte ou le document s\xe9lectionn\xe9. Par exemple, dites\xa0: \xab\xa0Le patient est un homme de 45\xa0ans ayant des ant\xe9c\xe9dents d\u2019hypertension. Le dernier m\xe9dicament prescrit n\u2019a pas eu l\u2019effet escompt\xe9 et a provoqu\xe9 une r\xe9action allergique. Nous allons devoir envisager des m\xe9decines alternatives et souhaiterions une ordonnance g\xe9n\xe9rique.\xa0\xbb"},"rewriteIntro":{"title":"Formatez vos notes","description":"Vous pouvez d\xe9sormais utiliser Cephable Intelligent Rewrite pour formater vos notes selon le format SOAP. L\'op\xe9ration s\'effectue directement sur l\'appareil, ce qui garantit la confidentialit\xe9, la s\xe9curit\xe9 et la conformit\xe9 HIPAA de vos donn\xe9es."},"copyText":{"title":"Copier les notes","description":"Apr\xe8s avoir surlign\xe9 vos notes, copiez le texte pour le pr\xe9parer \xe0 la mise en forme."},"pasteMode":{"title":"Cliquez sur l\'onglet Coller le texte","description":"Utilisez le mode Coller pour coller les notes originales et les formater dans le style SOAP."},"pasteInput":{"title":"Coller des notes au format","description":"Collez les notes que vous souhaitez formater dans la zone de saisie."},"enterInstructions":{"title":"Saisissez les instructions de formatage","description":"Vous pouvez r\xe9diger des instructions de mise en forme qui devront \xeatre respect\xe9es pour votre clinique/syst\xe8me DSE. (Par exemple, formater au format SOAP avec des titres, des puces et un langage concis.)"},"navigateToEHR":{"title":"Acc\xe9dez \xe0 votre syst\xe8me DSE","description":"Ouvrez votre syst\xe8me DSE et acc\xe9dez \xe0 la section dans laquelle vous souhaitez saisir les notes format\xe9es."},"focusTextField":{"title":"Concentrez-vous sur le champ de texte","description":"Cliquez sur le champ de texte dans lequel vous souhaitez coller les notes format\xe9es."},"complete":{"description":"Vous avez appris \xe0 utiliser les commandes vocales et la dict\xe9e intelligente pour documenter vos notes cliniques, ainsi que la r\xe9\xe9criture intelligente pour les formater selon le format SOAP. Explorez d\'autres cas d\'utilisation avec la dict\xe9e et la r\xe9\xe9criture, ou d\'autres fonctionnalit\xe9s pour optimiser votre flux de travail."},"focus":{"title":"Se concentrer sur un document","description":"La dict\xe9e est plus efficace lorsque vous vous concentrez sur un document. Ouvrez un document dans lequel vous souhaitez prendre des notes cliniques entre les s\xe9ances."}},"webBrowsing":{"tourLabel":"Planifiez des voyages, faites des achats en ligne et naviguez sur le Web \xe0 l\'aide de la voix","learn":"Apprenez \xe0 utiliser les commandes vocales pour naviguer, faire d\xe9filer et remplir des formulaires tout en naviguant sur le Web en mains libres.","tryOpen":{"title":"Essayez de dire \xab\xa0Ouvrir Chrome\xa0\xbb ou \xab\xa0Ouvrir Edge\xa0\xbb","description":"Assurez-vous que votre microphone est activ\xe9 et dites \xab\xa0Ouvrir Chrome\xa0\xbb ou \xab\xa0Ouvrir Edge\xa0\xbb. Cela ouvrira le navigateur web de votre choix. Si le changement automatique de contr\xf4le est activ\xe9, les contr\xf4les correspondant le mieux \xe0 l\'application que vous utilisez seront \xe9galement activ\xe9s."},"search":{"title":"Recherche","description":"Essayez de dire \xab\xa0Rechercher\xa0\xbb ou \xab\xa0Rechercher\xa0\xbb. Cela activera la barre de recherche de votre navigateur."},"quickType":{"title":"Saisie rapide","description":"La saisie rapide vous permet de saisir du texte \xe0 la voix sans passer en mode dict\xe9e. Dites \xab\xa0Quel temps fait-il aujourd\'hui\xa0?\xa0\xbb Votre requ\xeate sera alors saisie dans la barre de recherche."},"enter":{"title":"Appuyez sur Entr\xe9e","description":"Essayez de dire \xab\xa0Entr\xe9e\xa0\xbb. Cela ex\xe9cutera la requ\xeate de recherche que vous venez de saisir."},"scrollDown":{"title":"Faites d\xe9filer vers le bas","description":"Essayez de dire \xab\xa0D\xe9filer vers le bas\xa0\xbb. Cela fera d\xe9filer la page web vers le bas."},"scrollUp":{"title":"Faites d\xe9filer vers le haut","description":"Essayez de dire \xab\xa0D\xe9filer vers le haut\xa0\xbb. Cela fera d\xe9filer la page vers le haut."},"newTab":{"title":"Ouvrir un nouvel onglet","description":"Essayez de dire \xab\xa0Nouvel onglet\xa0\xbb. Cela ouvrira un nouvel onglet dans votre navigateur."},"formsCustomization":{"title":"Personnalisation du remplissage de formulaires","description":"Vous pouvez personnaliser cette application pour faciliter le remplissage des formulaires. Par exemple, ajoutez votre pr\xe9nom, votre nom, votre adresse e-mail, etc. Utilisez ensuite les actions rapides ou les commandes vocales pour remplir les formulaires encore plus rapidement."},"complete":{"title":"Bon travail !","description":"Vous savez maintenant utiliser les commandes vocales et les actions rapides pour naviguer, rechercher, faire d\xe9filer et remplir des formulaires sur le Web. Explorez d\'autres commandes ou personnalisez vos propres actions rapides pour une navigation encore plus fluide."}},"spreadsheetReviews":{"tourLabel":"Travaillez plus rapidement dans les feuilles de calcul gr\xe2ce aux commandes vocales","learn":"Apprenez \xe0 utiliser les commandes vocales et les actions rapides pour consulter et modifier rapidement de grandes feuilles de calcul.","tryOpen":{"title":"Essayez de dire \xab\xa0Ouvrir Excel\xa0\xbb ou \xab\xa0Ouvrir Google Sheets\xa0\xbb","description":"Assurez-vous que votre microphone est activ\xe9 et dites \xab\xa0Ouvrir Excel\xa0\xbb ou \xab\xa0Ouvrir Google Sheets\xa0\xbb. Cela ouvrira l\'application de tableur de votre choix. Si le changement automatique des commandes est activ\xe9, les commandes correspondant le mieux \xe0 l\'application que vous utilisez seront \xe9galement activ\xe9es."},"selectRow":{"title":"S\xe9lectionnez une ligne","description":"Cliquez sur une cellule. Ensuite, essayez de dire \xab\xa0S\xe9lectionner une ligne\xa0\xbb. Cela s\xe9lectionnera la ligne enti\xe8re de la cellule cibl\xe9e."},"delete":{"title":"Supprimer le contenu d\'une ligne","description":"Essayez de dire \xab\xa0Supprimer\xa0\xbb. Cela supprimera le contenu de la ligne s\xe9lectionn\xe9e."},"note":{"title":"Ajouter une note \xe0 une cellule","description":"Cliquez sur une cellule. Ensuite, essayez de dire \xab\xa0Ajouter une note\xa0\xbb. Cela vous permettra d\'ajouter une note \xe0 la cellule cibl\xe9e."},"addNote":{"title":"Tapez la note","description":"Essayez de dire \xab\xa0Saisissez ces chiffres qui ne correspondent pas\xa0\xbb. Votre note sera alors saisie dans la cellule."},"currentDate":{"title":"Entrez la date actuelle","description":"Cliquez sur une cellule. Ensuite, essayez de dire \xab\xa0Date du jour\xa0\xbb. La date du jour sera alors inscrite dans la cellule cibl\xe9e."},"copy":{"title":"Copier une cellule","description":"Cliquez sur la cellule \xe0 laquelle vous venez d\'ajouter la date du jour. Ensuite, essayez de dire \xab\xa0Copier\xa0\xbb. Cela copiera la date du jour."},"selectColumn":{"title":"S\xe9lectionnez une colonne","description":"Essayez de dire \xab\xa0Colonne\xa0\xbb. Cela s\xe9lectionnera toute la colonne pour la cellule cibl\xe9e."},"paste":{"title":"Coller la date actuelle","description":"Essayez de dire \xab\xa0Coller\xa0\xbb. Cela collera la date du jour dans la colonne s\xe9lectionn\xe9e."},"quickActions":{"title":"Utiliser les actions rapides","description":"Vous pouvez \xe9galement effectuer bon nombre de ces commandes et bien d\'autres encore gr\xe2ce aux boutons d\'action rapide. Vous pouvez personnaliser ces boutons pour les adapter \xe0 votre flux de travail et acc\xe9l\xe9rer encore la r\xe9vision et la modification des feuilles de calcul."},"complete":{"description":"Vous savez maintenant utiliser les commandes vocales et les actions rapides pour consulter et modifier rapidement de grandes feuilles de calcul. Explorez d\'autres commandes ou personnalisez vos propres actions rapides pour une gestion plus rapide de vos feuilles de calcul."}},"socialMediaWriting":{"tourLabel":"Cr\xe9ez, it\xe9rez et publiez du contenu sur les r\xe9seaux sociaux avec la voix et l\'IA sur l\'appareil","learn":"Apprenez \xe0 utiliser Intelligent Generate and Rewrite, enti\xe8rement priv\xe9 et sur l\'appareil, pour cr\xe9er et it\xe9rer sur du contenu.","onDeviceIntro":{"title":"Vos recherches restent priv\xe9es et s\xe9curis\xe9es","description":"Les t\xe2ches intelligentes de Cephable sont optimis\xe9es par l\'IA int\xe9gr\xe9e \xe0 l\'appareil, garantissant la confidentialit\xe9 et la s\xe9curit\xe9 de vos donn\xe9es. Vous pouvez cr\xe9er, r\xe9\xe9crire et traduire du texte sans aucun traitement cloud. Vous pouvez \xe9galement exploiter le contexte inter-applications et it\xe9rer sur des id\xe9es directement dans votre application pr\xe9f\xe9r\xe9e."},"enterPrompt":{"title":"Commencez \xe0 imaginer","description":"Dans la zone de saisie, saisissez le contenu que vous souhaitez structurer ou g\xe9n\xe9rer. Par exemple, vous pouvez saisir\xa0: \xab\xa0\xc9num\xe9rer les risques li\xe9s \xe0 l\'IA agentique, identifier les lacunes et comment l\'innovation peut progresser.\xa0\xbb"},"customizeSettings":{"title":"Personnaliser les param\xe8tres de g\xe9n\xe9ration","description":"Personnalisez les param\xe8tres de g\xe9n\xe9ration selon vos pr\xe9f\xe9rences. Ajustez-les gr\xe2ce aux invites syst\xe8me qui refl\xe8tent le ton, la voix de la marque, etc."},"rewriteIntro":{"title":"It\xe9rer sur le contenu","description":"Vous pouvez utiliser Cephable Intelligent Rewrite pour it\xe9rer le contenu directement dans votre application pr\xe9f\xe9r\xe9e. Tout se fait sur l\'appareil, ce qui garantit la confidentialit\xe9 et la s\xe9curit\xe9 de vos donn\xe9es."},"highlightText":{"title":"Surligner le texte \xe0 r\xe9\xe9crire","description":"Mettez en surbrillance l\u2019un des risques r\xe9pertori\xe9s \xe0 partir du contenu g\xe9n\xe9r\xe9 sur lequel vous souhaitez poursuivre vos it\xe9rations."},"enterInstructions":{"title":"Entrez les instructions de r\xe9\xe9criture","description":"Saisissez vos instructions de r\xe9\xe9criture. Par exemple, vous pouvez saisir\xa0: \xab\xa0Ajouter plus de d\xe9tails sur les risques\xa0\xbb."},"writeSocialMediaPost":{"title":"R\xe9diger une publication sur les r\xe9seaux sociaux","description":"Utilisez \xe0 nouveau la r\xe9\xe9criture pour reformater ce langage dans une publication sur les r\xe9seaux sociaux destin\xe9e au public qui obtient les points cl\xe9s et met en \xe9vidence les domaines d\'engagement."},"highlightPost":{"title":"Mettre en \xe9vidence la publication g\xe9n\xe9r\xe9e","description":"Mettez en surbrillance la publication sur les r\xe9seaux sociaux g\xe9n\xe9r\xe9e que vous souhaitez utiliser."},"enterPostInstructions":{"title":"Entrez les instructions de publication","description":"Saisissez les instructions de votre publication. Par exemple\xa0: \xab\xa0Soyez concis et engageant pour LinkedIn.\xa0\xbb"},"complete":{"description":"Vous pouvez maintenant ouvrir votre plateforme de m\xe9dias sociaux pr\xe9f\xe9r\xe9e, vous concentrer sur la zone de cr\xe9ation de publication et coller la publication g\xe9n\xe9r\xe9e. Vous pouvez \xe9galement continuer \xe0 peaufiner et \xe0 peaufiner jusqu\'\xe0 ce que vous soyez pr\xeat\xa0!"}},"inboxTriage":{"tourLabel":"Gestion efficace des e-mails avec la voix et l\'IA sur l\'appareil","learn":"Apprenez \xe0 utiliser les commandes vocales et les t\xe2ches intelligentes pour g\xe9rer efficacement votre bo\xeete de r\xe9ception tout en prot\xe9geant vos donn\xe9es.","tryOpen":{"title":"Essayez de dire \xab\xa0Ouvrir Outlook\xa0\xbb ou \xab\xa0Ouvrir Gmail\xa0\xbb","description":"Assurez-vous que votre microphone est activ\xe9 et dites \xab\xa0Ouvrir Outlook\xa0\xbb ou \xab\xa0Ouvrir Gmail\xa0\xbb. Cela ouvrira l\'application de messagerie de votre choix. Si le changement automatique de contr\xf4le est activ\xe9, les contr\xf4les correspondant le mieux \xe0 l\'application que vous utilisez seront \xe9galement activ\xe9s."},"select":{"title":"S\xe9lectionnez une adresse e-mail","description":"Cliquez sur un e-mail. Ensuite, essayez de dire \xab\xa0S\xe9lectionner un e-mail\xa0\xbb. Cela s\xe9lectionnera l\'e-mail cibl\xe9."},"delete":{"title":"Supprimer un e-mail","description":"Essayez de dire \xab\xa0Supprimer\xa0\xbb. Cela supprimera l\'e-mail s\xe9lectionn\xe9."},"reply":{"title":"R\xe9pondre \xe0 un e-mail","description":"Cliquez sur un e-mail. Ensuite, essayez de dire \xab\xa0R\xe9pondre\xa0\xbb. Cela ouvrira la fen\xeatre de r\xe9ponse \xe0 l\'e-mail cibl\xe9."},"dictateIntro":{"title":"Dictez votre r\xe9ponse","description":"Vous pouvez utiliser la dict\xe9e pour saisir votre r\xe9ponse en mode mains libres. Assurez-vous que votre microphone est allum\xe9 et que le mode dict\xe9e est activ\xe9."},"dictateReply":{"title":"Commencer \xe0 r\xe9pondre","description":"Essayez de dire\xa0: \xab\xa0Je souhaite en savoir plus sur vos services. Veuillez m\'envoyer des informations compl\xe9mentaires.\xa0\xbb Cela permettra de r\xe9diger votre r\xe9ponse dans l\'e-mail. Assurez-vous de bien vous concentrer sur la zone de texte de r\xe9ponse."},"newEmail":{"title":"Cr\xe9er un nouvel e-mail","description":"Essayez de dire \xab\xa0Nouvel e-mail\xa0\xbb. Cela ouvrira une nouvelle fen\xeatre de r\xe9daction d\'e-mail."},"customEmailTemplates":{"title":"Mod\xe8les d\'e-mails personnalis\xe9s","description":"Vous pouvez cr\xe9er des mod\xe8les d\'e-mails personnalis\xe9s pour les r\xe9ponses courantes. Cela vous permettra d\'ins\xe9rer rapidement du contenu pr\xe9-r\xe9dig\xe9 dans vos e-mails gr\xe2ce \xe0 des commandes vocales ou des actions rapides."},"editAppControls":{"title":"Modifier les contr\xf4les de l\'application","description":"Pour cr\xe9er un mod\xe8le d\u2019e-mail personnalis\xe9, cliquez sur le bouton Modifier les contr\xf4les de l\u2019application."},"addNewControl":{"title":"Ajouter un nouveau contr\xf4le","description":"Dans l\u2019\xe9diteur de contr\xf4les d\u2019application, cliquez sur le bouton Ajouter un nouveau contr\xf4le."},"quickAction":{"title":"S\xe9lectionnez Action rapide","description":"Choisissez Action rapide comme type de contr\xf4le."},"templateName":{"title":"Nommez votre mod\xe8le","description":"Donnez un nom \xe0 votre mod\xe8le d\u2019e-mail personnalis\xe9, par exemple \xab Demande de r\xe9union \xbb."},"eventType":{"title":"S\xe9lectionnez le type d\'\xe9v\xe9nement","description":"Dans la section type d\'\xe9v\xe9nement, choisissez un type d\'\xe9v\xe9nement \xab type \xbb."},"typeSteps":{"title":"Type de contenu du mod\xe8le","description":"Saisissez le contenu de votre mod\xe8le d\'e-mail. Par exemple\xa0: \xab\xa0Relations avec les prospects\\nBonjour, je souhaiterais organiser une r\xe9union pour discuter d\'\xe9ventuelles collaborations. Veuillez me faire part de vos disponibilit\xe9s.\xa0\xbb"},"finish":{"title":"Terminer la cr\xe9ation du mod\xe8le","description":"Cliquez sur le bouton Terminer pour terminer la cr\xe9ation de votre mod\xe8le d\u2019e-mail personnalis\xe9."},"saveTemplate":{"title":"Enregistrez votre mod\xe8le","description":"Cliquez sur le bouton Enregistrer pour enregistrer votre mod\xe8le d\u2019e-mail personnalis\xe9."},"focusApp":{"title":"Recentrez-vous sur votre application de messagerie","description":"Revenez \xe0 votre application de messagerie et assurez-vous que vous vous concentrez sur la nouvelle ligne d\u2019objet de l\u2019e-mail."},"useTemplate":{"title":"Utilisez votre mod\xe8le","description":"Vous pouvez d\xe9sormais utiliser votre mod\xe8le d\u2019e-mail personnalis\xe9 en pronon\xe7ant son nom ou en cliquant sur le bouton Action rapide."},"generateIntro":{"title":"G\xe9n\xe9rer du contenu d\'e-mail","description":"Vous pouvez \xe9galement utiliser Cephable Intelligent Generate pour cr\xe9er du contenu d\'e-mail directement dans votre application de messagerie. Tout se fait sur l\'appareil, ce qui garantit la confidentialit\xe9 et la s\xe9curit\xe9 de vos donn\xe9es."},"enterPrompt":{"title":"Entrez l\'invite de courrier \xe9lectronique","description":"Dans la bo\xeete de dialogue, saisissez\xa0: R\xe9digez un e-mail professionnel \xe0 un client potentiel pr\xe9sentant nos services et demandant un rendez-vous."},"focusNewEmail":{"title":"Concentrez-vous sur le nouvel e-mail","description":"Assurez-vous que vous \xeates concentr\xe9 sur la nouvelle fen\xeatre de composition de courrier \xe9lectronique dans laquelle vous souhaitez que le texte g\xe9n\xe9r\xe9 apparaisse."},"translateEmail":{"title":"Traduire le contenu des e-mails","description":"Vous pouvez utiliser Cephable Intelligent Translate pour traduire le contenu de vos e-mails directement dans votre application de messagerie. Tout s\'effectue sur l\'appareil, ce qui garantit la confidentialit\xe9 et la s\xe9curit\xe9 de vos donn\xe9es."},"highlightText":{"title":"Mettre en \xe9vidence le contenu de l\'e-mail","description":"Mettez en surbrillance le contenu d\u2019un long e-mail que vous souhaitez traduire."},"enterLanguage":{"title":"Entrez la langue de traduction","description":"Saisissez votre langue de traduction. Par exemple\xa0: \xab\xa0Espagnol\xa0\xbb."},"complete":{"description":"Vous savez d\xe9sormais utiliser les commandes vocales et les t\xe2ches intelligentes pour parcourir, r\xe9pondre, dicter, g\xe9n\xe9rer et traduire des e-mails tout en prot\xe9geant vos donn\xe9es. Explorez d\'autres commandes ou personnalisez vos actions rapides pour une gestion des e-mails encore plus fluide."}},"handsFreeMeeting":{"tourLabel":"Commandes rapides de r\xe9union mains libres","learn":"Gagnez du temps et r\xe9duisez la fatigue des r\xe9unions virtuelles gr\xe2ce aux commandes rapides des r\xe9unions mains libres","tryOpen":{"title":"Essayez de dire \xab\xa0Ouvrir Zoom\xa0\xbb ou \xab\xa0Ouvrir Teams\xa0\xbb","description":"Assurez-vous que votre microphone est activ\xe9 et dites \xab\xa0Ouvrir Zoom\xa0\xbb ou \xab\xa0Ouvrir Teams\xa0\xbb. L\'application de r\xe9union s\xe9lectionn\xe9e s\'ouvrira. Si le changement automatique de contr\xf4le est activ\xe9, les contr\xf4les correspondant \xe0 l\'application que vous utilisez seront \xe9galement activ\xe9s."},"mute":{"title":"Essayez de dire \xab\xa0Basculer en mode muet\xa0\xbb pour couper votre microphone","description":"Assurez-vous que votre microphone est activ\xe9 et dites \xab\xa0D\xe9sactiver le son\xa0\xbb. Cela d\xe9sactivera votre microphone dans l\'application de r\xe9union choisie."},"video":{"title":"Essayez de dire \xab\xa0Basculer la vid\xe9o\xa0\xbb pour allumer ou \xe9teindre votre cam\xe9ra","description":"Assurez-vous que votre microphone est activ\xe9 et dites \xab\xa0Activer/D\xe9sactiver la vid\xe9o\xa0\xbb. Cela activera ou d\xe9sactivera votre cam\xe9ra dans l\'application de r\xe9union choisie."},"raiseHand":{"title":"Essayez de dire \xab\xa0Lever la main\xa0\xbb pour lever la main","description":"Assurez-vous que votre micro est activ\xe9 et dites \xab\xa0Lever la main\xa0\xbb. Votre main sera lev\xe9e dans l\'application de r\xe9union de votre choix."},"quickType":{"title":"Saisie rapide","description":"Assurez-vous que votre microphone est activ\xe9 et dites \xab\xa0Tapez, c\'est une fonctionnalit\xe9 int\xe9ressante\xa0\xbb. Cela vous permettra de saisir rapidement du texte \xe0 la voix sans passer en mode dict\xe9e. Assurez-vous d\'\xeatre concentr\xe9 sur un champ de texte dans votre application de r\xe9union."},"complete":{"description":"Vous savez maintenant utiliser les commandes vocales et les actions rapides pour activer/d\xe9sactiver le son, activer/d\xe9sactiver la vid\xe9o, lever la main et saisir rapidement des messages dans vos applications de r\xe9union pr\xe9f\xe9r\xe9es. Explorez d\'autres commandes ou personnalisez vos propres actions rapides pour un contr\xf4le encore plus fluide de vos r\xe9unions."}},"summarizingReports":{"tourLabel":"R\xe9sumez les rapports et les documents avec l\'IA sur l\'appareil","learn":"Apprenez \xe0 utiliser le r\xe9sum\xe9 bas\xe9 sur l\'IA pour obtenir rapidement les points cl\xe9s de longs rapports et documents tout en pr\xe9servant la s\xe9curit\xe9 de vos donn\xe9es confidentielles et exclusives.","summarizeIntro":{"title":"R\xe9sumer le texte","description":"Vous pouvez utiliser les t\xe2ches intelligentes Cephable pour extraire rapidement les points cl\xe9s de longs rapports et documents. Summarize fait partie des t\xe2ches IA sur appareil, ce qui signifie qu\'il fonctionne sans connexion Internet et directement sur votre appareil."},"navigateToReport":{"title":"Concentrez-vous sur votre rapport ou document","description":"Ouvrez votre rapport ou document dans votre application pr\xe9f\xe9r\xe9e et concentrez-vous sur le texte que vous souhaitez r\xe9sumer."},"highlightText":{"title":"Surligner le texte pour le r\xe9sumer","description":"Surlignez le texte que vous souhaitez r\xe9sumer."},"copyText":{"title":"Copier le texte","description":"Apr\xe8s avoir surlign\xe9 votre texte, copiez-le pour le pr\xe9parer au r\xe9sum\xe9."},"enterPrompt":{"title":"Saisissez les instructions de r\xe9sum\xe9","description":"Saisissez vos instructions de r\xe9sum\xe9. Pr\xe9cisez la longueur, le style ou tout contenu sp\xe9cifique souhait\xe9."},"pasteText":{"title":"Collez le contenu de votre rapport","description":"Apr\xe8s les instructions, collez le texte copi\xe9 dans la zone de saisie."},"focusChatApp":{"title":"Concentrez-vous sur votre application de chat","description":"Ouvrez votre application de chat comme Teams ou Slack et concentrez-vous sur la zone de texte dans laquelle vous souhaitez que le texte r\xe9sum\xe9 apparaisse."},"rewriteIntro":{"title":"R\xe9\xe9crire le texte r\xe9sum\xe9","description":"Vous pouvez \xe9galement utiliser Cephable Intelligent Rewrite pour affiner le texte r\xe9sum\xe9. Tout cela s\'effectue sur l\'appareil, ce qui garantit la confidentialit\xe9 et la s\xe9curit\xe9 de vos donn\xe9es."},"highlightSummary":{"title":"Surlignez le texte r\xe9sum\xe9","description":"Mettez en surbrillance le texte r\xe9sum\xe9 que vous souhaitez affiner davantage."},"enterRewriteInstructions":{"title":"Entrez les instructions de r\xe9\xe9criture","description":"Saisissez vos instructions de r\xe9\xe9criture. Pr\xe9cisez le ton, le style ou toute modification sp\xe9cifique souhait\xe9e."},"complete":{"description":"Vous avez appris \xe0 utiliser les t\xe2ches intelligentes pour synth\xe9tiser rapidement et en toute s\xe9curit\xe9 vos textes et partager vos r\xe9sultats avec votre \xe9quipe. Explorez d\'autres cas d\'utilisation avec \xab\xa0Summarize\xa0\xbb et \xab\xa0Rewrite\xa0\xbb, ou d\'autres fonctionnalit\xe9s pour optimiser votre flux de travail."}},"congrats":"Bravo!","noteTakingAndDocumentation":{"tourLabel":"Prise de notes et g\xe9n\xe9ration de documents \xe0 l\'aide d\'une IA priv\xe9e sur l\'appareil","learn":"Apprenez \xe0 utiliser les commandes vocales, la dict\xe9e intelligente et les t\xe2ches IA pour passer plus rapidement des notes aux conceptions et aux documents.","focus":{"title":"Se concentrer sur un champ de texte ou un document","description":"La dict\xe9e est plus efficace lorsque vous vous concentrez sur un champ de texte ou un document. Ouvrez un document ou cliquez sur le champ de texte o\xf9 vous souhaitez prendre des notes."},"speaking":{"title":"Commencez \xe0 parler","description":"Vous pouvez maintenant commencer \xe0 parler. Pendant que vous r\xe9fl\xe9chissez \xe0 votre id\xe9e, parlez naturellement et laissez libre cours \xe0 vos pens\xe9es. Tout ce que vous direz sera saisi dans le champ de texte ou le document sur lequel vous vous \xeates concentr\xe9. Essayez de d\xe9crire votre concept, de d\xe9crire les \xe9tapes ou de lancer une r\xe9flexion libre. Par exemple, dites\xa0: \xab\xa0J\u2019envisage un nouveau flux de travail pour notre \xe9quipe. Nous devrions d\u2019abord automatiser le processus de reporting, puis examiner les r\xe9sultats chaque semaine.\xa0\xbb Assurez-vous que votre curseur est bien positionn\xe9 sur le document."},"typeEnter":{"title":"Sauts de paragraphe","description":"Pour cr\xe9er des sauts de paragraphe, appuyez simplement sur Entr\xe9e sur votre clavier. Cela vous permettra d\'organiser vos notes en sections claires. Continuez \xe0 exprimer vos pens\xe9es ou \xe0 retranscrire les propos d\'une autre personne."},"rewriteIntro":{"title":"Cr\xe9er des designs","description":"Vous pouvez d\xe9sormais utiliser Cephable Intelligent Rewrite pour prendre vos notes et les transformer en id\xe9es de fonctionnalit\xe9s ou en suivis. Tout se fait sur votre appareil, garantissant ainsi la confidentialit\xe9 et la s\xe9curit\xe9 de vos donn\xe9es."},"highlightText":{"title":"Surligner les notes","description":"S\xe9lectionnez toutes les notes que vous souhaitez utiliser pour cr\xe9er une conception ou un document."},"inPlaceReplacement":{"title":"Id\xe9ation sur place","description":"Nous allons maintenant utiliser le remplacement sur place pour transformer vos notes en mod\xe8le ou en document. Vous pouvez \xe9galement utiliser le mode Coller ou l\'option permettant de cr\xe9er un nouveau fichier."},"enterInstructions":{"title":"Entrez les instructions de conception","description":"Vous pouvez r\xe9diger vos instructions pour les prochaines \xe9tapes, en pr\xe9cisant ce que vous souhaitez faire avec ces notes. Il peut s\'agir de mise en forme, de conception, de suivi, etc. (Par exemple, cr\xe9ez un document de conception d\xe9crivant le fonctionnement de la fonctionnalit\xe9, son aspect final et les conditions de r\xe9ussite potentielles.)"},"complete":{"description":"Vous avez appris \xe0 utiliser les commandes vocales et la dict\xe9e intelligente pour documenter vos notes cliniques, ainsi que la r\xe9\xe9criture intelligente pour les formater selon le format SOAP. Explorez d\'autres cas d\'utilisation avec la dict\xe9e et la r\xe9\xe9criture, ou d\'autres fonctionnalit\xe9s pour optimiser votre flux de travail."}},"fpsGamePlay":{"tourLabel":"Jouez \xe0 des jeux FPS avec des commandes vocales","learn":"Apprenez \xe0 utiliser les commandes vocales et les actions rapides pour jouer \xe0 des jeux FPS.","changeProfile":{"title":"Profil de contr\xf4le des modifications","description":"Modifiez le contr\xf4le de votre application pour le profil de jeu FPS. Vous pouvez \xe9galement le personnaliser pour le jeu auquel vous souhaitez jouer. Consultez la vid\xe9o."},"autoProfileSwitching":{"title":"D\xe9sactiver la commutation de contr\xf4le automatique","description":"Cela gardera votre contr\xf4le d\'application actuel actif jusqu\'\xe0 ce que vous changiez d\'application."},"tryOpen":{"title":"Essayez de dire \xab\xa0Ouvrir Valorant\xa0\xbb ou \xab\xa0Ouvrir Battlefield\xa0\xbb"},"go":{"title":"Essayez de dire \xab\xa0Allez\xa0\xbb","description":"Assurez-vous que votre micro est allum\xe9 et dites \xab\xa0Go\xa0\xbb. Votre personnage avancera."},"stop":{"title":"Essayez de dire \xab Stop \xbb","description":"Assurez-vous que votre micro est allum\xe9 et dites \xab\xa0Stop\xa0\xbb. Cela arr\xeatera de bouger votre personnage."},"complete":{"description":"Vous savez maintenant utiliser les commandes vocales et les actions rapides pour d\xe9placer, arr\xeater et contr\xf4ler votre personnage dans les jeux FPS. Explorez d\'autres commandes ou personnalisez vos actions rapides pour un gameplay encore plus fluide et rapide."}},"presentationControls":{"tourLabel":"Contr\xf4ler les pr\xe9sentations avec des commandes vocales","learn":"D\xe9couvrez comment utiliser les commandes vocales et les actions rapides pour naviguer et contr\xf4ler vos pr\xe9sentations en mains libres.","tryOpen":{"title":"Essayez de dire \xab\xa0Ouvrir PowerPoint\xa0\xbb ou \xab\xa0Ouvrir Google Slides\xa0\xbb"},"startPresentation":{"title":"Essayez de dire \xab\xa0D\xe9marrer la pr\xe9sentation\xa0\xbb pour d\xe9marrer votre diaporama","description":"Assurez-vous que votre microphone est activ\xe9 et dites \xab\xa0D\xe9marrer la pr\xe9sentation\xa0\xbb. Votre diaporama d\xe9marrera dans l\'application de pr\xe9sentation de votre choix."},"nextSlide":{"title":"Essayez de dire \xab Diapositive suivante \xbb pour passer \xe0 la diapositive suivante","description":"Assurez-vous que votre micro est activ\xe9 et dites \xab\xa0Diapositive suivante\xa0\xbb. Cela vous permettra de passer \xe0 la diapositive suivante de votre diaporama."},"previousSlide":{"title":"Essayez de dire \xab Diapositive pr\xe9c\xe9dente \xbb pour revenir \xe0 la diapositive pr\xe9c\xe9dente","description":"Assurez-vous que votre micro est activ\xe9 et dites \xab\xa0Diapositive pr\xe9c\xe9dente\xa0\xbb. Cela vous ram\xe8nera \xe0 la diapositive pr\xe9c\xe9dente de votre diaporama."},"escape":{"title":"Essayez de dire \xab\xa0\xc9chap\xa0\xbb pour quitter le mode de pr\xe9sentation","description":"Assurez-vous que votre microphone est activ\xe9 et dites \xab\xa0\xc9chap\xa0\xbb. Cela quittera le mode pr\xe9sentation dans l\'application de pr\xe9sentation choisie."},"complete":{"description":"Vous savez maintenant utiliser les commandes vocales et les actions rapides pour d\xe9marrer, naviguer et quitter des pr\xe9sentations en mode mains libres. Explorez d\'autres commandes ou personnalisez vos propres actions rapides pour un contr\xf4le encore plus fluide de vos pr\xe9sentations."}},"editingImages":{"tourLabel":"\xc9dition d\'images plus rapide gr\xe2ce aux commandes vocales et \xe0 la dict\xe9e","learn":"Apprenez \xe0 utiliser les commandes vocales, les actions rapides et la dict\xe9e pour am\xe9liorer votre processus d\u2019\xe9dition d\u2019images.","tryOpen":{"title":"Essayez de dire \xab\xa0Ouvrir Figma\xa0\xbb ou \xab\xa0Ouvrir Photoshop\xa0\xbb"},"selectAll":{"title":"Essayez de dire \xab\xa0S\xe9lectionner tout\xa0\xbb pour s\xe9lectionner tous les \xe9l\xe9ments sur le canevas","description":"Assurez-vous que votre microphone est activ\xe9 et dites \xab\xa0S\xe9lectionner tout\xa0\xbb. Cela s\xe9lectionnera tous les \xe9l\xe9ments de la zone de travail dans l\'application de retouche d\'image de votre choix. Assurez-vous d\'\xeatre concentr\xe9 sur l\'application."},"bold":{"title":"Essayez de dire \xab\xa0Gras\xa0\xbb pour mettre le texte s\xe9lectionn\xe9 en gras","description":"Assurez-vous que votre microphone est activ\xe9 et dites \xab\xa0Gras\xa0\xbb. Le texte s\xe9lectionn\xe9 sera mis en gras dans l\'application de retouche d\'image de votre choix. Assurez-vous que le texte est s\xe9lectionn\xe9."},"copy":{"title":"Essayez de dire \xab\xa0Copier\xa0\xbb pour copier l\'\xe9l\xe9ment s\xe9lectionn\xe9","description":"Assurez-vous que votre microphone est activ\xe9 et dites \xab\xa0Copier\xa0\xbb. Cela copiera l\'\xe9l\xe9ment s\xe9lectionn\xe9 dans l\'application de retouche d\'image de votre choix. Assurez-vous d\'avoir s\xe9lectionn\xe9 un \xe9l\xe9ment."},"paste":{"title":"Essayez de dire \xab\xa0Coller\xa0\xbb pour coller l\'\xe9l\xe9ment copi\xe9","description":"Assurez-vous que votre microphone est activ\xe9 et dites \xab\xa0Coller\xa0\xbb. L\'\xe9l\xe9ment copi\xe9 sera alors coll\xe9 dans l\'application de retouche d\'image de votre choix."},"delete":{"title":"Essayez de dire \xab\xa0Supprimer\xa0\xbb pour supprimer l\'\xe9l\xe9ment s\xe9lectionn\xe9","description":"Assurez-vous que votre microphone est activ\xe9 et dites \xab\xa0Supprimer\xa0\xbb. Cela supprimera l\'\xe9l\xe9ment s\xe9lectionn\xe9 dans l\'application de retouche d\'image choisie. Assurez-vous d\'avoir s\xe9lectionn\xe9 un \xe9l\xe9ment."},"dictationIntro":{"title":"Dict\xe9e","description":"Vous pouvez utiliser la dict\xe9e pour saisir du texte avec votre voix. Assurez-vous que votre microphone est allum\xe9 et que le mode dict\xe9e est activ\xe9."},"focus":{"title":"Focus sur un champ de texte","description":"Cliquez sur un champ de texte dans votre application de retouche d\u2019image dans lequel vous souhaitez utiliser la dict\xe9e."},"speaking":{"title":"Commencez \xe0 parler","description":"Essayez de dire\xa0: \xab\xa0Pour obtenir des codes de r\xe9duction anticip\xe9s, scannez le code QR. Valable jusqu\'au 30\xa0septembre. Ensuite, faites votre demande sur le site web.\xa0\xbb Assurez-vous de bien cibler le champ de texte ou la zone o\xf9 vous souhaitez dicter."},"complete":{"description":"Vous savez maintenant utiliser les commandes vocales, les actions rapides et la dict\xe9e pour am\xe9liorer votre processus de retouche d\'images. Explorez d\'autres commandes ou personnalisez vos propres actions rapides pour une retouche encore plus fluide."}},"redo":"Refaire l\'int\xe9gration","title":"D\xe9couvrez Cephable","description":"D\xe9couvrez Cephable, votre assistant IA personnel et partagez votre int\xe9r\xeat pour les cas d\'utilisation personnalis\xe9s.","panel":{"description":"Voici le panneau de contr\xf4le principal. Toujours visible, il vous permet de contr\xf4ler vos applications \xe0 la voix, et bien plus encore. Commen\xe7ons par le microphone."}}');


var $7d9261ac2fd5b6b6$exports = {};
$7d9261ac2fd5b6b6$exports = JSON.parse('{"introduction":{"title":"Salut, je suis Cephable.","back":"Retour \xe0 l\'introduction","description":"Je suis votre IA personnelle pour vous aider \xe0 contr\xf4ler, cr\xe9er et automatiser vos outils pr\xe9f\xe9r\xe9s, quel que soit votre r\xe9seau. Voici quelques informations \xe0 mon sujet.","action":"C\'est parti !","recording":{"title":"Votre voix et votre vid\xe9o restent locales.","description":"Je n\'enregistre, ne diffuse et n\'envoie jamais vos fichiers audio ou vid\xe9o vers le cloud. Toutes les entr\xe9es sont trait\xe9es sur l\'appareil, de mani\xe8re priv\xe9e et s\xe9curis\xe9e."},"data":{"title":"Vos donn\xe9es vous appartiennent.","description":"Je n\'utilise pas vos commandes ni votre activit\xe9 pour entra\xeener des mod\xe8les pour d\'autres. Tout reste priv\xe9 et les commandes de votre application se d\xe9placent avec vous d\'une connexion \xe0 l\'autre."},"offline":{"title":"Je travaille quand les autres outils ne fonctionnent pas.","description":"Les t\xe2ches intelligentes comme la g\xe9n\xe9ration de contenu, la r\xe9\xe9criture, la traduction et la dict\xe9e s\'ex\xe9cutent toutes en local. Aucun cloud requis. Je travaille donc m\xeame lorsque vous \xeates hors ligne, et vos donn\xe9es restent sur votre appareil."},"empower":{"title":"Con\xe7u pour responsabiliser, et non pour exploiter.","description":"Je suis con\xe7u pour am\xe9liorer votre contr\xf4le, et non pour le surveiller. Pas de suivi invasif. Pas de collecte de donn\xe9es suspectes. Juste les informations qui vous conviennent."}},"my-capabilities":{"title":"Parfait\xa0! Voici comment je peux vous aider.","back":"Retour aux capacit\xe9s","actionTitle":"Voyez-moi en action","description":"En fonction de vos int\xe9r\xeats, voici les fonctionnalit\xe9s et capacit\xe9s les plus pertinentes pour votre flux de travail.","action":{"title":"Voyez-moi en action","description":"D\xe9couvrez quelques exemples de la fa\xe7on dont je peux vous aider dans vos t\xe2ches quotidiennes."}},"see-me":{"title":"Vous voulez voir comment j\'ai aid\xe9 d\'autres personnes comme vous ?","back":"Retour aux cas d\'utilisation","description":"D\xe9couvrez quelques exemples concrets de la mani\xe8re dont j\'ai transform\xe9 les flux de travail dans diff\xe9rents secteurs et r\xf4les."},"complete":{"title":"Pr\xeat \xe0 commencer \xe0 m\'utiliser ?","description":"Vous avez vu de quoi je suis capable\xa0! Maintenant, commen\xe7ons \xe0 configurer votre solution et \xe0 transformer votre flux de travail. Je serai l\xe0 pour vous accompagner \xe0 chaque \xe9tape.","action":"Configuration compl\xe8te et utilisation de Cephable"},"apps":{"title":"Je soutiens les outils que vous aimez d\xe9j\xe0","description":"Avec une prise en charge pr\xe9configur\xe9e de plus de 200 applications, je travaille avec les logiciels que vous utilisez au quotidien. Aucune configuration requise.","note":"Vous ne trouvez pas l\'application que vous utilisez\xa0? Aucun probl\xe8me\xa0: je peux g\xe9n\xe9rer des contr\xf4les ou vous aider \xe0 cr\xe9er des workflows personnalis\xe9s qui vous conviennent.","andMore":"Et plus"},"actions":{"ctaTry":"Essayez-le maintenant","ctaWatch":"Regarder la d\xe9mo","apps":"Je suis compatible avec :","abilities":"Mes capacit\xe9s utilis\xe9es :"},"interests":{"title":"En quoi puis-je vous aider ?","back":"Retour aux int\xe9r\xeats","description":"Je peux contr\xf4ler les applications sur votre ordinateur et vos appareils connect\xe9s. Personnalisons votre exp\xe9rience\xa0: quels sont vos centres d\'int\xe9r\xeat\xa0?","note":"S\xe9lectionnez tout ce qui s\u2019applique et je vous montrerai les fonctionnalit\xe9s et les exemples les plus pertinents pour votre flux de travail.","action":"Continuer avec {{count}} int\xe9r\xeats","empty":"S\xe9lectionnez au moins un int\xe9r\xeat.","create_design":{"label":"Cr\xe9er et concevoir","shortLabel":"Conception","description":"Pour les artistes, les sp\xe9cialistes du marketing et les cr\xe9ateurs de contenu."},"analyze_report":{"label":"Analyser et signaler","shortLabel":"Analyser","description":"Pour les analystes, les chercheurs et les professionnels du monde des affaires."},"communicate_collaborate":{"label":"Communiquer et collaborer","shortLabel":"Communiquer","description":"Pour les vendeurs, les r\xe9unions et les \xe9quipes distantes."},"build_develop":{"label":"Construire et d\xe9velopper","shortLabel":"D\xe9velopper","description":"Pour les d\xe9veloppeurs, les ing\xe9nieurs et les professionnels techniques."},"game_play":{"label":"Jeu et jeu","shortLabel":"Jeux vid\xe9o","description":"Pour les joueurs, les streamers et les contr\xf4leurs multim\xe9dias."},"learn_teach":{"label":"Apprendre et enseigner","shortLabel":"Apprentissage","description":"Pour les \xe9ducateurs, les \xe9tudiants et l\u2019enseignement."},"manage_organize":{"label":"G\xe9rer et organiser","shortLabel":"Organisation","description":"Pour les chefs de projet, les coordinateurs et les organisateurs."},"adapt_access":{"label":"Adapter et acc\xe9der","shortLabel":"Accessibilit\xe9","description":"Pour des contr\xf4les adaptatifs et des besoins d\'accessibilit\xe9 personnalis\xe9s."},"everything":{"label":"Un peu de tout","shortLabel":"Tout","description":"Pour les utilisateurs g\xe9n\xe9raux d\'ordinateurs et les multit\xe2ches."},"filter":"Filtrer par type d\'int\xe9r\xeats"},"capabilities":{"title":"Mes principales capacit\xe9s d\'IA","description":"J\'associe une IA avanc\xe9e \xe0 des m\xe9thodes de saisie performantes pour vous offrir un contr\xf4le optimal de vos applications et appareils. Voici quelques exemples de mes comp\xe9tences.","voice_controls":{"title":"Commandes vocales","description":"Je comprends les commandes en langage naturel afin que vous puissiez contr\xf4ler n\'importe quelle application avec votre voix.","longDescription":"Je vous laisse parler naturellement tout en restant efficace. Que vous souhaitiez ouvrir des applications, naviguer dans les menus ou d\xe9clencher des workflows, je traduis un anglais simple en actions mains libres et fiables."},"smart_dictation":{"title":"Dict\xe9e intelligente","description":"Je convertis votre discours en texte en tenant compte du contexte et du formatage.","longDescription":"Je vous \xe9coute attentivement et saisis vos mots avec pr\xe9cision. J\'ajoute la ponctuation, corrige les majuscules et m\'adapte \xe0 votre style pour que votre texte soit soign\xe9 sans effort suppl\xe9mentaire."},"ai_text_generation":{"title":"G\xe9n\xe9ration de texte par IA","description":"Je peux cr\xe9er des e-mails, des documents, du code et du contenu cr\xe9atif \xe0 la vol\xe9e.","longDescription":"Je vous aide \xe0 r\xe9diger, synth\xe9tiser ou d\xe9velopper tout contenu directement dans vos applications. Des e-mails et notes aux extraits de code et documents, je veille \xe0 ce que vous ne partiez jamais de z\xe9ro."},"head_face_controls":{"title":"Commandes de la t\xeate et du visage","description":"Je vous laisse d\xe9clencher des actions avec vos mouvements de t\xeate et de visage.","longDescription":"Je traduis vos mouvements de t\xeate et expressions naturels en informations pr\xe9cises. Vous pouvez envoyer un e-mail avec un sourire, tourner une page d\'un hochement de t\xeate ou cliquer d\'un haussement de sourcils."},"natural_language_voice_clicking":{"title":"Clic vocal en langage naturel","description":"Je vous laisse dire ce que vous voyez en cliquant sur les boutons, les liens et les menus \xe0 l\'\xe9cran.","longDescription":"Lorsque vous prononcez le nom d\'un \xe9l\xe9ment \xe0 l\'\xe9cran, je le trouve et j\'interagis avec lui pour vous. Pas de commandes m\xe9moris\xe9es\xa0: d\xe9crivez simplement ce que vous voulez et je m\'occupe du clic."},"keyboard_mouse_emulation":{"title":"\xc9mulation du clavier et de la souris","description":"J\'\xe9mule les touches, les clics et le d\xe9filement pour que vous puissiez contr\xf4ler les applications sans mat\xe9riel.","longDescription":"J\'envoie les frappes, les mouvements de souris, les clics et les \xe9v\xe9nements de d\xe9filement o\xf9 vous le souhaitez. Combinez-les avec des commandes vocales ou de la t\xeate pour remplacer ou am\xe9liorer compl\xe8tement les p\xe9riph\xe9riques d\'entr\xe9e traditionnels."},"profiles_personalization":{"title":"Personnalisation","description":"Je me souviens de vos pr\xe9f\xe9rences et m\'adapte aux contr\xf4les d\'application enregistr\xe9s.","longDescription":"Je garde une trace de vos applications, commandes et pr\xe9f\xe9rences pr\xe9f\xe9r\xe9es. Passez d\'une application \xe0 l\'autre automatiquement ou manuellement, et j\'afficherai toujours les commandes adapt\xe9es \xe0 vos activit\xe9s."},"cross_device_connectivity":{"title":"Connectivit\xe9 entre appareils","description":"Je vous laisse utiliser votre t\xe9l\xe9phone pour contr\xf4ler votre ordinateur.","longDescription":"Je connecte votre appareil mobile \xe0 votre ordinateur pour que vous puissiez lancer des commandes, dicter ou naviguer facilement. Id\xe9al pour les pr\xe9sentations, les sessions \xe0 distance ou une utilisation occasionnelle."},"quick_action_buttons":{"title":"Boutons d\'action rapide","description":"Je vous donne des boutons adapt\xe9s aux applications pour des actions rapides.","longDescription":"Je propose des boutons contextuels qui s\'adaptent \xe0 votre application. Qu\'il s\'agisse de rejoindre une r\xe9union, d\'envoyer un message ou de cr\xe9er un e-mail, je simplifie les t\xe2ches complexes en un seul clic."},"ai_app_awareness":{"title":"Sensibilisation aux applications d\'IA","description":"J\'ajuste mes commandes en fonction de l\'application que vous utilisez.","longDescription":"Je suis attentif \xe0 ce qui s\'affiche sur votre \xe9cran afin de vous offrir les commandes appropri\xe9es au bon moment. Pas de d\xe9sordre, pas d\'incertitude\xa0: juste ce dont vous avez besoin, quand vous en avez besoin. Tout cela sur votre appareil, sans transfert de donn\xe9es vers le cloud."},"ai_rewrite":{"title":"R\xe9\xe9criture de l\'IA","description":"Je peux r\xe9\xe9crire votre texte pour am\xe9liorer le ton, mettre \xe0 jour la mise en forme ou d\xe9velopper des d\xe9tails.","longDescription":"Je corrige votre texte directement sur place. Je peux le rendre plus convivial, plus formel, plus court, plus long ou plus d\xe9taill\xe9\xa0: tout ce dont vous avez besoin pour mieux faire passer votre message."},"ai_translation":{"title":"Traduction IA","description":"Je peux traduire entre les langues ou m\xeame les langages de programmation.","longDescription":"Je vous permet de convertir du texte en une autre langue parl\xe9e ou du code en un autre langage de programmation. Je travaille sur place, vous n\'avez donc pas besoin de quitter l\'application que vous utilisez."},"head_mouse":{"title":"T\xeate de souris","description":"Je vous laisse d\xe9placer le curseur de votre souris avec les mouvements de la t\xeate.","longDescription":"Je convertis vos mouvements de t\xeate en mouvements de curseur. Gr\xe2ce \xe0 des fonctionnalit\xe9s comme le glissement et le r\xe9glage de la sensibilit\xe9, je vous offre un contr\xf4le pr\xe9cis, confortable et mains libres."},"head_joystick":{"title":"Joystick de t\xeate","description":"Je vous laisse utiliser votre t\xeate comme un joystick pour des jeux ou des applications.","longDescription":"Je cartographie les mouvements de votre t\xeate sur les axes de votre joystick pour vous permettre de jouer \xe0 des jeux ou de contr\xf4ler des logiciels cr\xe9atifs sans mat\xe9riel. Vos mouvements sont naturels, et je les convertis en signaux analogiques."},"mcp_agent":{"title":"Agent MCP","description":"Je peux me connecter \xe0 des agents d\'IA externes via le protocole de contexte de mod\xe8le (MCP).","longDescription":"Je ma\xeetrise le protocole de contexte mod\xe8le, ce qui me permet de collaborer avec d\'autres agents et outils d\'IA. Cela signifie que je peux coordonner des t\xe2ches, \xe9changer du contexte et \xe9tendre mes capacit\xe9s avec des syst\xe8mes externes sp\xe9cialis\xe9s, tout en vous laissant le contr\xf4le."},"byo_ai_integration":{"title":"Apportez votre propre IA","description":"Je vous permets d\'am\xe9liorer mon IA existante avec vos propres mod\xe8les ou services d\'IA \xe0 utiliser avec moi.","longDescription":"Si vous disposez d\xe9j\xe0 d\'un service, d\'un mod\xe8le ou d\'un fournisseur d\'IA de confiance, je peux l\'int\xe9grer \xe0 mon flux de travail. Je vous offre la flexibilit\xe9 de choisir le moteur qui g\xe8re la g\xe9n\xe9ration, la r\xe9\xe9criture ou la traduction, qu\'il soit cloud, local ou personnalis\xe9. En cas d\'indisponibilit\xe9 du service ou de d\xe9connexion, je peux utiliser mes fonctionnalit\xe9s int\xe9gr\xe9es."},"workflows":{"title":"Flux de travail","description":"Je vous aide \xe0 encha\xeener des actions dans des workflows r\xe9p\xe9tables.","longDescription":"Je vous permet de concevoir et d\'ex\xe9cuter des processus en plusieurs \xe9tapes reliant diff\xe9rentes entr\xe9es, commandes et sorties. Gr\xe2ce aux workflows, vous pouvez automatiser des t\xe2ches routini\xe8res ou cr\xe9er des interactions complexes, d\xe9clench\xe9es par votre voix ou vos gestes. Je m\'occupe donc du gros du travail pour vous."},"showMore":"Afficher plus","showLess":"Afficher moins"},"listing":{"title":"Cas d\'utilisation","titleLong":"D\xe9couvrez comment je peux vous aider","recommended":"Recommand\xe9 pour vous","exploreMore":"Explorez davantage de cas d\'utilisation","description":"D\xe9couvrez tout ce que je peux faire pour optimiser votre flux de travail. De l\'am\xe9lioration de la productivit\xe9 \xe0 l\'assistance cr\xe9ative, trouvez les cas d\'utilisation adapt\xe9s \xe0 vos besoins.","all":"Tous","search":"Recherchez des cas d\'utilisation, des applications ou des fonctionnalit\xe9s...","noResults":"Aucun r\xe9sultat trouv\xe9. Essayez d\'ajuster votre recherche ou vos filtres.","emptyAction":"Voir plus en ligne"},"examples":{"universalAppControl":{"title":"Contr\xf4le universel des applications","description":"Contr\xf4lez n\'importe quelle application sur votre ordinateur avec des commandes vocales et une automatisation intelligente","descriptionLong":"Prenez le contr\xf4le de n\'importe quelle application gr\xe2ce \xe0 de puissantes commandes vocales et une automatisation intelligente. Notre syst\xe8me de contr\xf4le universel des applications apprend votre fa\xe7on de travailler et s\'adapte \xe0 vos besoins, simplifiant ainsi les t\xe2ches complexes et instantan\xe9isant les actions courantes. De la gestion de votre suite de productivit\xe9 au contr\xf4le des applications multim\xe9dias et de jeu, cette fonctionnalit\xe9 s\'applique \xe0 l\'ensemble de votre environnement num\xe9rique."},"handsFreeComputerControl":{"title":"Contr\xf4le informatique mains libres","description":"Contr\xf4le informatique complet utilisant les mouvements de la t\xeate, la voix et le suivi oculaire pour l\'accessibilit\xe9","descriptionLong":"D\xe9couvrez un nouveau niveau d\'accessibilit\xe9 informatique gr\xe2ce \xe0 notre syst\xe8me de contr\xf4le mains libres. Gr\xe2ce \xe0 la combinaison d\'un suivi oculaire avanc\xe9, d\'une d\xe9tection pr\xe9cise des mouvements de la t\xeate et de commandes vocales, cette fonctionnalit\xe9 permet \xe0 chacun de contr\xf4ler enti\xe8rement son ordinateur sans utiliser ses mains. Id\xe9al pour les utilisateurs \xe0 mobilit\xe9 r\xe9duite, les personnes multit\xe2ches ou ceux qui souhaitent utiliser leur ordinateur diff\xe9remment."},"replyToSocialMediaPosts":{"title":"Publications et r\xe9ponses plus rapides sur les r\xe9seaux sociaux gr\xe2ce \xe0 la dict\xe9e","description":"R\xe9pondez \xe0 n\u2019importe quelle publication sur les r\xe9seaux sociaux en utilisant la dict\xe9e intelligente pour des r\xe9ponses rapides.","descriptionLong":"La dict\xe9e intelligente de Cephable acc\xe9l\xe8re la publication et les commentaires sur les r\xe9seaux sociaux gr\xe2ce \xe0 la conversion vocale. La dict\xe9e fonctionne dans n\'importe quelle zone de texte ou champ de publication, vous permettant ainsi de rester actif sur les r\xe9seaux sociaux sans que cela ne vous prenne le dessus."},"clinicalNoteTaking":{"title":"Dict\xe9e et formatage conformes \xe0 la loi HIPAA pour les cliniciens","description":"Gagnez du temps en prenant des notes cliniques entre les s\xe9ances gr\xe2ce aux commandes vocales intelligentes et \xe0 la dict\xe9e. Ensuite, formatez automatiquement vos notes au format SOAP.","descriptionLong":"Vous recherchez un logiciel de dict\xe9e conforme \xe0 la loi HIPAA\xa0? Cephable aide les cliniciens \xe0 documenter rapidement les notes des patients gr\xe2ce \xe0 des commandes vocales intelligentes et \xe0 une mise en forme automatique. Cr\xe9ez des notes SOAP, des rapports d\'avancement et des journaux, le tout en mode mains libres.","upgrade":{"description":"Effectuez une mise \xe0 niveau pour acc\xe9der aux t\xe2ches intelligentes hors ligne conformes \xe0 la norme HIPAA pour le formatage et l\'it\xe9ration automatiques."}},"vibeCoding":{"title":"De la pens\xe9e au code\xa0: Dict\xe9e pour les d\xe9veloppeurs et les codeurs Vibe","description":"Vibe Code avec dict\xe9e et g\xe9n\xe9ration de texte IA pour \xe9crire du code standard et cr\xe9er un prototype plus rapidement.","descriptionLong":"Cephable Dictation aide les d\xe9veloppeurs \xe0 passer plus rapidement de la r\xe9flexion au code. Cette d\xe9mo montre comment les commandes vocales peuvent g\xe9n\xe9rer des composants, des tableaux de bord et bien plus encore dans des outils comme Vercel V0, GitHub Copilot dans VS Code, Base 44 et Lovable. Dictez vos id\xe9es, puis peaufinez-les avec du code.","upgrade":{"description":"Effectuez une mise \xe0 niveau pour acc\xe9der aux t\xe2ches intelligentes hors ligne pour la r\xe9\xe9criture, la g\xe9n\xe9ration et les traductions de code dans l\'application."}},"controllingBackgroundMusic":{"title":"Contr\xf4les multim\xe9dias\xa0: g\xe9rez la musique, la vid\xe9o et plus encore sans interrompre votre flux","description":"G\xe9rez votre musique de fond \xe0 l\'aide de commandes vocales et d\'actions rapides tout en restant concentr\xe9 sur la t\xe2che en cours.","descriptionLong":"Les commandes vocales Cephable facilitent la lecture, la pause, le passage d\'une chanson et le r\xe9glage du volume dans Spotify, en mains libres. Les boutons d\'action rapide et les commandes pr\xeates \xe0 l\'emploi fonctionnent \xe9galement avec d\'autres applications comme Apple Music, YouTube, Netflix et plus de 200 autres applications\xa0!"},"editingVideos":{"title":"Montage vid\xe9o avec voix","description":"Am\xe9liorez votre flux de travail de montage vid\xe9o \xe0 l\'aide de commandes vocales pour naviguer, couper et \xe9diter plus rapidement.","descriptionLong":"Concentrez-vous sur l\'histoire, pas sur les clics. Les commandes vocales Cephable simplifient le montage vid\xe9o avec vos outils habituels\xa0: Clipchamp, Adobe, iMovie, DaVinci Resolve, et bien d\'autres. Des montages plus rapides, moins d\'\xe9tapes."},"inboxTriage":{"title":"Assistant de messagerie IA\xa0: automatisez, r\xe9digez et r\xe9pondez plus rapidement","description":"G\xe9rez votre bo\xeete de r\xe9ception \xe0 l\'aide de commandes vocales et de la g\xe9n\xe9ration de texte IA sur l\'appareil pour trier, r\xe9diger et modifier les e-mails.","descriptionLong":"Acc\xe9l\xe9rez votre traitement des e-mails gr\xe2ce \xe0 l\'IA priv\xe9e int\xe9gr\xe9e \xe0 votre appareil. Cephable combine commandes vocales, dict\xe9e, boutons d\'action rapide et g\xe9n\xe9ration de texte pour une gestion plus rapide et plus simple de votre bo\xeete de r\xe9ception. Supprimez des e-mails, r\xe9digez des brouillons de r\xe9ponses et g\xe9n\xe9rez des r\xe9ponses cr\xe9atives en toute libert\xe9 dans Outlook, Gmail et plus encore.","upgrade":{"description":"Effectuez une mise \xe0 niveau pour acc\xe9der aux t\xe2ches intelligentes hors ligne pour le formatage automatique, la g\xe9n\xe9ration de contenu, les traductions, etc."}},"summarizingReports":{"title":"R\xe9sumez les rapports confidentiels avec l\'IA priv\xe9e sur l\'appareil","description":"R\xe9sumez de longs rapports \xe0 votre \xe9quipe tout en restant priv\xe9 et sur l\'appareil gr\xe2ce \xe0 la g\xe9n\xe9ration de texte par IA.","descriptionLong":"Transformez de longs rapports en mises \xe0 jour d\'\xe9quipe claires gr\xe2ce \xe0 l\'IA int\xe9gr\xe9e. Cephable extrait les points cl\xe9s et les chiffres, puis g\xe9n\xe8re des synth\xe8ses concises que vous pouvez partager directement avec votre \xe9quipe. Tout le traitement s\'effectue sur votre appareil, garantissant ainsi la s\xe9curit\xe9 de vos donn\xe9es sensibles."},"handsFreeMeeting":{"title":"R\xe9duisez la fatigue des r\xe9unions gr\xe2ce aux commandes mains libres","description":"Contr\xf4lez vos r\xe9unions vid\xe9o \xe0 l\u2019aide de commandes vocales, de boutons d\u2019action rapide et de dict\xe9e intelligente.","descriptionLong":"Restez concentr\xe9 en r\xe9union, sans avoir \xe0 parcourir les menus. Cephable int\xe8gre des commandes vocales et des boutons d\'action rapide \xe0 Microsoft Teams, Zoom, Google Meet et bien plus encore. Activez/d\xe9sactivez le son, activez/d\xe9sactivez la vid\xe9o, envoyez des messages, levez la main et naviguez dans les fen\xeatres de r\xe9union en mains libres gr\xe2ce \xe0 des commandes pr\xeates \xe0 l\'emploi et personnalisables pour votre flux de travail."},"spreadsheetReviews":{"title":"Travaillez plus rapidement dans les feuilles de calcul gr\xe2ce aux commandes vocales et \xe0 l\'automatisation de l\'IA","description":"Examinez et modifiez rapidement de grandes feuilles de calcul \xe0 l\u2019aide de commandes vocales pour la navigation, le formatage, le filtrage et l\u2019\xe9dition.","descriptionLong":"Cephable int\xe8gre des commandes vocales et des boutons d\'action rapide \xe0 Excel, Google Sheets et autres tableurs. R\xe9visez, modifiez, commentez rapidement, d\xe9clenchez des macros et des raccourcis, et personnalisez les commandes pour votre flux de travail. Des centaines de commandes sont pr\xeates \xe0 l\'emploi instantan\xe9ment ou personnalisables selon votre configuration."},"socialMediaWriting":{"title":"Cr\xe9ation et recherche de contenu avec une IA priv\xe9e sur l\'appareil","description":"R\xe9digez et r\xe9digez des publications sur les r\xe9seaux sociaux \xe0 l\'aide de commandes vocales et de la g\xe9n\xe9ration de texte par IA pour un contenu attrayant.","descriptionLong":"Cr\xe9ez du contenu en toute s\xe9curit\xe9 gr\xe2ce \xe0 l\'IA embarqu\xe9e de Cephable, sans cloud. G\xe9n\xe9rez ou r\xe9\xe9crivez instantan\xe9ment des publications sur les r\xe9seaux sociaux, des e-mails, des slogans et de la documentation directement dans vos outils pr\xe9f\xe9r\xe9s. Tout fonctionne en local\xa0: votre contenu sensible reste confidentiel et vous pouvez travailler o\xf9 que vous soyez."},"fpsGamePlay":{"title":"Jouez \xe0 des jeux FPS avec des commandes vocales","description":"Jouez et personnalisez un jeu de tir \xe0 la premi\xe8re personne en utilisant des commandes vocales pour le mouvement, la vis\xe9e et le tir.","descriptionLong":"D\xe9couvrez une nouvelle fa\xe7on de jouer aux jeux de tir \xe0 la premi\xe8re personne gr\xe2ce aux commandes vocales. D\xe9placez-vous, visez et tirez \xe0 l\'aide de votre voix, pour une exp\xe9rience de jeu plus immersive et mains libres."},"customizingGameControls":{"title":"Personnalisation des commandes de jeu RPG","description":"Personnalisez les commandes du jeu de r\xf4le pour une meilleure accessibilit\xe9 et un meilleur gameplay.","descriptionLong":"Personnalisez votre exp\xe9rience de jeu gr\xe2ce \xe0 des commandes personnalisables qui am\xe9liorent l\'accessibilit\xe9 et la jouabilit\xe9. Ajustez les param\xe8tres selon vos pr\xe9f\xe9rences et votre style de jeu pour une session confortable et agr\xe9able."},"webBrowsing":{"title":"Navigation Web mains libres avec Cephable | Planifiez vos voyages, faites vos achats en ligne et plus encore","description":"Naviguez sur le Web en mains libres \xe0 l\u2019aide de commandes vocales pour naviguer, faire d\xe9filer et remplir des formulaires.","descriptionLong":"Recherchez, achetez et planifiez sans saisir de texte. Les commandes vocales intelligentes de Cephable fonctionnent sur n\'importe quel navigateur, que ce soit pour r\xe9server des vols, faire des achats en ligne ou pr\xe9parer votre prochain voyage."},"documentCode":{"title":"Documentation de code rapide et s\xe9curis\xe9e avec g\xe9n\xe9ration de texte IA sur l\'appareil","description":"Documentez le code sans envoyer de donn\xe9es sensibles au cloud, tout en restant dans la m\xeame application gr\xe2ce \xe0 la r\xe9\xe9criture intelligente de Cephable.","descriptionLong":"La r\xe9\xe9criture intelligente de Cephable cr\xe9e la documentation d\xe9veloppeur directement \xe0 partir du code, sans transf\xe9rer de donn\xe9es sensibles vers le cloud. G\xe9n\xe9rez des fichiers README, des documents Markdown et des r\xe9f\xe9rences API rapidement et en toute s\xe9curit\xe9, directement depuis l\'application."},"generateCode":{"title":"G\xe9n\xe9ration de code rapide et s\xe9curis\xe9e avec g\xe9n\xe9ration de texte IA sur l\'appareil","description":"Prototyper des extraits de code \xe0 partir des exigences des tickets \xe0 l\'aide de t\xe2ches intelligentes d\'IA.","descriptionLong":"Cephable vous permet de transformer les exigences des tickets en code fonctionnel dans n\'importe quel langage. Utilisez les t\xe2ches intelligentes pour structurer le code, g\xe9n\xe9rer de la documentation et ajouter automatiquement des tests unitaires. Travaillez avec diff\xe9rents langages de programmation et applications sans perdre le contexte."},"editingImages":{"title":"\xc9dition plus rapide dans les applications cr\xe9atives avec commandes vocales et dict\xe9e","description":"Cr\xe9ez et modifiez des images \xe0 l\'aide de commandes vocales et de la g\xe9n\xe9ration de texte IA pour des ajustements et des concepts rapides.","descriptionLong":"Donnez vie \xe0 vos id\xe9es visuelles gr\xe2ce \xe0 la cr\xe9ation et \xe0 la retouche d\'images \xe0 commande vocale. Utilisez la g\xe9n\xe9ration de texte par IA pour effectuer des ajustements rapides, g\xe9n\xe9rer des concepts et am\xe9liorer vos images sans avoir \xe0 naviguer dans des menus complexes."},"requirementDocsFromMeeting":{"title":"Des notes aux documents d\'exigences produit en quelques minutes gr\xe2ce \xe0 l\'IA sur l\'appareil","description":"Gagnez des heures en transformant les transcriptions brutes des r\xe9unions en documents structur\xe9s d\'exigences produit en quelques minutes.","descriptionLong":"Cephable transforme les transcriptions brutes des r\xe9unions en documents structur\xe9s d\'exigences produit en quelques minutes gr\xe2ce aux t\xe2ches intelligentes. Identifiez rapidement les besoins produits, marketing et utilisateurs et pr\xe9servez la confidentialit\xe9 des discussions gr\xe2ce \xe0 l\'IA int\xe9gr\xe9e. Enregistrez instantan\xe9ment les r\xe9sultats sous forme de nouveaux documents."},"gamingVoiceControls":{"title":"Contr\xf4le vocal dans WoW | Navigation rapide dans les menus, le JcJ et la recherche de donjons","description":"Contr\xf4lez votre gameplay \xe0 l\'aide de commandes vocales pour naviguer dans les menus, lancer des batailles PvP et trouver des donjons.","descriptionLong":"Am\xe9liorez votre exp\xe9rience de jeu gr\xe2ce \xe0 la gestion vocale. Utilisez des commandes vocales simples pour naviguer dans les menus, lancer des combats JcJ et trouver des donjons, vous permettant ainsi de vous concentrer sur votre jeu tout en gardant le contr\xf4le total."},"headMouseMovement":{"title":"Configuration de jeu mains libres avec souris \xe0 t\xeate","description":"Contr\xf4lez le curseur de votre souris \xe0 l\'aide des mouvements de la t\xeate pour une navigation et un clic pr\xe9cis.","descriptionLong":"Les commandes Head Mouse permettent de jouer en mains libres. Inclinez ou tournez la t\xeate pour d\xe9placer le curseur, ajustez la vitesse et la sensibilit\xe9, et prenez le contr\xf4le sans souris traditionnelle."},"noteTakingAndDocumentation":{"title":"Prise de notes et g\xe9n\xe9ration de documents \xe0 l\'aide d\'une IA priv\xe9e sur l\'appareil","description":"Prenez des notes et g\xe9n\xe9rez des documents \xe0 l\'aide de commandes vocales et de la g\xe9n\xe9ration de texte IA pour une \xe9criture efficace.","descriptionLong":"Simplifiez votre prise de notes gr\xe2ce \xe0 la dict\xe9e intelligente et \xe0 la g\xe9n\xe9ration de documents optimis\xe9e par l\'IA. Cr\xe9ez rapidement des brouillons, des plans et des documents soign\xe9s, pour vous concentrer sur vos id\xe9es plut\xf4t que sur la mise en page. Tout le traitement s\'effectue sur l\'appareil pour plus de confidentialit\xe9 et de s\xe9curit\xe9.","upgrade":{"description":"Effectuez une mise \xe0 niveau pour acc\xe9der aux t\xe2ches intelligentes hors ligne pour le formatage, l\'it\xe9ration du contenu et bien plus encore."}},"presentationControls":{"title":"Commandes de pr\xe9sentation mains libres avec commandes vocales et actions rapides","description":"Contr\xf4lez vos pr\xe9sentations \xe0 l\'aide de commandes vocales pour parcourir les diapositives, d\xe9marrer/arr\xeater les pr\xe9sentations et mettre en \xe9vidence des points.","descriptionLong":"R\xe9alisez des pr\xe9sentations en toute confiance gr\xe2ce aux commandes vocales. Parcourez les diapositives, d\xe9marrez et arr\xeatez les pr\xe9sentations et surlignez les points cl\xe9s, le tout sans toucher votre ordinateur."},"designingFliers":{"title":"Conception d\'applications cr\xe9atives","description":"Cr\xe9ez et modifiez des conceptions \xe0 l\'aide de commandes vocales et de dict\xe9e intelligente pour des it\xe9rations plus rapides.","descriptionLong":"Donnez vie \xe0 votre vision cr\xe9ative gr\xe2ce \xe0 des outils de conception \xe0 commande vocale. Naviguez, modifiez et r\xe9p\xe9tez vos cr\xe9ations sans effort, sans vous perdre dans des menus complexes. Concentrez-vous sur votre cr\xe9ativit\xe9, sans clics."},"motionDesign":{"title":"Commandes vocales pour la conception de mouvements et l\'animation","description":"Animez des sc\xe8nes et contr\xf4lez les images cl\xe9s \xe0 l\'aide de commandes vocales intuitives pour une conception de mouvement fluide.","descriptionLong":"Donnez du mouvement \xe0 vos id\xe9es gr\xe2ce \xe0 des outils d\'animation vocale. Contr\xf4lez facilement les timelines, les images cl\xe9s et les effets gr\xe2ce au langage naturel, pour vous concentrer sur la narration et le rythme visuel plut\xf4t que sur des interfaces complexes."}}}');


var $155a07bb3e087efa$exports = {};
$155a07bb3e087efa$exports = JSON.parse('{"logo":"Logo Cefabile","add":"Aggiungere","all":"Tutto","edit":"Modificare","create":"Creare","delete":"Eliminare","previous":"Precedente","next":"Prossimo","search":"Ricerca","loading":"Caricamento...","reload":"Ricaricare","cancel":"Cancellare","copy":"Copia","save":"Salva","saveAndFinish":"Salva e termina","saveAndContinue":"Salva e continua","saved":"Salvato","done":"Fatto","back":"Indietro","play":"Giocare","pause":"Pausa","success":"Successo","continue":"Continuare","options":"Opzioni","share":"Condividere","finish":"Fine","finishEdit":"Fine Modifica","advancedOptions":"Visualizza opzioni avanzate","authenticating":"Autenticazione in corso...","skipToMain":"Vai al contenuto principale","skip":"Saltare","close":"Vicino","notFound":"Pagina non trovata","notFoundDescription":"Oh no! Abbiamo cercato nel mare e non riusciamo a trovare la pagina!","exitSetup":"Esci dalla configurazione","experimental":"Sperimentale","letGetStarted":"Cominciamo!","exploreInputControls":"Esplora i controlli di input","when":"Quando io...","thenMacro":"Cephable correr\xe0...","controls":"Controlli","welcome":"Benvenuto.","beta":"beta","macroEmpty":"Non ci sono macro che corrispondono a questi criteri.","you":"Voi","step":"Fare un passo","steps":"Passi","learnMore":"Saperne di pi\xf9","dangerZone":"Zona pericolosa","connected":"Collegato","notConnected":"Non connesso","connectAndLearn":"Connettiti e impara","tryAgain":"Riprova","by":"Di: {{value}}","noName":"- nessun nome -","details":"Dettagli","controlFeed":"Controllo Feed","mobileApp":{"title":"Applicazione mobile"},"dashboard":{"title":"Pannello di controllo"},"wifi":{"disconnected":"Il Wi-Fi \xe8 disconnesso.","connected":"La connessione Wi-Fi \xe8 attiva.","description":"Connettiti al Wi-Fi per consentire a Cephable di funzionare con le tue connessioni e il tuo software. Potresti avere una capacit\xe0 limitata di utilizzare i tuoi controlli attuali."},"signalR":{"disconnected":"La sincronizzazione \xe8 interrotta.","action":"Riconnetti","description":"Sembra esserci un problema con la sincronizzazione di Cephable. Ci\xf2 causer\xe0 problemi nel salvataggio delle impostazioni o nella comunicazione con altre connessioni.","disconnectedDevice":"Impossibile sincronizzare con {{name}}.","disconnectedDeviceDescription":"Sembra che ci sia un problema di sincronizzazione dovuto all\'autenticazione o alla connettivit\xe0 Internet. Non \xe8 possibile inviare o ricevere dati in remoto. \xc8 necessario controllare entrambi i lati della connessione.","connected":"La sincronizzazione \xe8 connessa.","connectedDescription":"Cephable si sincronizza correttamente e dovrebbe comunicare con le tue connessioni ed estensioni come previsto.","swap":"Passa alla connessione del dispositivo locale","unlinkedDevice":"Connessione rimossa.","unlinkedDeviceDescription":"Questa connessione \xe8 stata scollegata dal tuo account."},"billing":{"title":"Fatturazione","expires":"Prossima fatturazione: {{value}}","isEmployeeAccess":{"title":"Professionale","titleLong":"Professionista Cephable","short":"Professionista","description":"Cephable Professional offre agli utenti maggiore produttivit\xe0, estendendo l\'intelligenza artificiale locale e privata alle capacit\xe0 generative.","supportedFeatures":{"tag":"Tutto in Plus, plus","features":["Flussi di lavoro di intelligenza artificiale su dispositivo","Gestione dell\'organizzazione aziendale","restrizioni aziendali","Installazioni illimitate su diversi dispositivi.","Controlli dell\'app pre-addestrati illimitati"]}},"isDeveloperAccess":{"title":"Kit di sviluppo software","titleLong":"SDK cefalico","short":"Kit di sviluppo software","description":"Gli SDK di Cephable consentono di integrare potenti controlli adattivi (voce, viso, testa e altro) nel software con un impatto minimo e il massimo vantaggio.","supportedFeatures":{"tag":"Tutto in Plus, plus","features":["Supporto per Windows e MacOS","SDK leggeri e integrabili per input vocali, facciali, oculari e di azioni rapide offline","Supporto API/webhook per azioni di output personalizzate","Documentazione per sviluppatori","Progetti campione","Trasforma i comandi in automazione e navigazione dei documenti","Portale per sviluppatori per la gestione di progetti, client di autorizzazione, tipi di dispositivi e altro ancora"]}},"isStudentAccess":{"title":"Studente","titleLong":"Istruzione Cefabile","short":"Edu","description":"Cephable Education supporta l\'apprendimento personalizzato e le classi inclusive. Cephable funziona offline, funziona su dispositivo e non richiede integrazioni di terze parti.","supportedFeatures":{"tag":"Tutto in Plus, plus","features":["Installazioni di dispositivi illimitate","Controlli app pre-addestrati illimitati","Condivisione illimitata dei controlli delle app personalizzate"]}},"viewProducts":"Visualizza i prodotti","description":"Gestisci la fatturazione, i posti, gli upgrade degli abbonamenti, i rinnovi o le cancellazioni della tua organizzazione.","view":"Gestisci la fatturazione","isResellerAccess":{"title":"Rivenditore","titleLong":"Rivenditore Cephable","description":"Cephable Reseller \xe8 una licenza a pagamento che ti consente di creare nuove organizzazioni e assegnare chiavi di licenza. Ci\xf2 include l\'utilizzo di Cephable con la tua suite software e il miglioramento della tua esperienza utente.","short":"Rivenditore"},"error":"Contatta l\'amministratore di sistema per gestire la fatturazione.","included":"Incluso nella tua licenza {{licenseType}}.","upgrade":{"description":"Esegui subito l\'aggiornamento e porta i tuoi controlli a un livello superiore.","action":"Aggiorna ora","error":"Errore durante l\'aggiornamento. Riprova pi\xf9 tardi.","requiredDetail":"Per questa funzionalit\xe0 \xe8 richiesta una licenza {{licenseType}}. Puoi sempre effettuare l\'upgrade o iniziare una prova gratuita nelle Impostazioni Account.","enableTextGeneration":"Genera contenuti utilizzando l\'intelligenza artificiale e la tua voce.","longDescription":"Passa a una licenza a pagamento per sbloccare tutte le funzionalit\xe0 di Cephable. Dalla gestione di pi\xf9 dispositivi, ai controlli avanzati, alle integrazioni personalizzate, Cephable ha tutto ci\xf2 che ti serve per raggiungere il livello successivo di produttivit\xe0.","compare":"Confronta i piani","enableAiDictation":{"title":"Passa alla dettatura intelligente","description":"Esegui l\'upgrade per sbloccare la dettatura avanzata dell\'IA. Posso aggiungere punteggiatura, correggere le maiuscole e adattarmi al tuo stile, in modo che la tua scrittura risulti impeccabile senza sforzi aggiuntivi."}},"isPlusAccess":{"title":"Pi\xf9","titleLong":"Cephable Plus","short":"Pi\xf9","description":"Cephable Plus \xe8 pensato per gli utenti esperti che desiderano ottenere di pi\xf9 grazie a voce intelligente, dettatura intelligente, centinaia di controlli delle app e molto altro.","supportedFeatures":{"tag":"Tutto ci\xf2 che \xe8 in Basic, pi\xf9","features":["Comandi vocali intelligenti (linguaggio naturale)","Dettatura intelligente (potenziata dall\'IA)","Compiti intelligenti (Generazione, Traduzione, Riscrittura)","Centinaia di controlli per app pre-addestrati"]}},"personal":{"short":"Di base","title":"Di base","titleLong":"Cephable Basic","description":"Cephable Basic \xe8 gratuito per sempre ed \xe8 progettato per aiutarti a muoverti pi\xf9 velocemente, a esprimerti e a portare a termine i tuoi progetti, a modo tuo. Le funzionalit\xe0 incluse nella versione Basic sono disponibili per tutti gli utenti.","upgrade":{"title":"Porta i tuoi controlli a un livello superiore","description":"Passa a Plus o Pro per sbloccare tutte le mie funzionalit\xe0. Pi\xf9 precisione. Pi\xf9 connessioni. Pi\xf9 controlli. Pi\xf9 potenza per portare la tua produttivit\xe0 a un livello superiore.","featureHeading":"Ecco come posso aiutarti:","control":"Ti guido pi\xf9 velocemente tra app e strumenti usando la tua voce o azioni rapide, senza interruzioni. Con Intelligent Voice possiamo semplicemente chattare.","create":"Riscrivo, dettato, genero e traduco direttamente all\'interno delle tue app, senza dover copiare, incollare o cambiare schermata.","automate":"Eseguo attivit\xe0 intelligenti e azioni rapide che velocizzano il tuo flusso di lavoro. Dai comandi pi\xf9 semplici alle macro pi\xf9 complesse, posso occuparmi del lavoro pi\xf9 impegnativo, cos\xec puoi concentrarti sul lavoro che conta davvero.","local":"Tutta IA locale. Nessuna elaborazione cloud."}},"mostPopular":"I pi\xf9 popolari","subscription":{"options":"Opzioni di abbonamento","monthly":"Paga mensilmente","billedMonthly":"/mese","yearly":"Paga annualmente","billedYearly":"/anno"}},"organization":{"title":"Organizzazione","titlePlural":"Organizzazioni","titleLong":"Cephable Professional per le organizzazioni","description":"Le organizzazioni sono gruppi di utenti che possono collaborare a progetti e condividere risorse. Qui puoi gestire il tuo team, i profili del team, la fatturazione e altro ancora.","noAccess":{"title":"Accesso negato.","description":"I tuoi permessi sono cambiati di recente e non hai pi\xf9 accesso a questa funzionalit\xe0. Se ritieni che si tratti di un errore, contatta l\'amministratore della tua organizzazione."},"noOrg":{"title":"Nessuna licenza associata.","description":"Al momento non sei associato a una licenza o a un gruppo di sviluppatori. L\'accesso al portale \xe8 riservato agli utenti con una licenza Cephable a pagamento. Per sfruttare appieno il potenziale di Cephable, inizia una prova gratuita senza rischi."},"member":{"title":"Membro","titlePlural":"Membri","me":"La mia iscrizione","description":"I membri sono utenti che fanno parte della tua organizzazione. Possono essere assegnati a ruoli diversi e avere accesso a parti diverse dell\'organizzazione.","edit":"Modifica membri","removed":"Sei stato rimosso da una squadra.","removedDescription":"Sei stato rimosso dal team. Non puoi pi\xf9 accedere all\'organizzazione. Se ritieni che si tratti di un errore, contatta l\'amministratore della tua organizzazione.","updated":"Riuscito, l\'iscrizione di {{value}} \xe8 stata aggiornata.","error":"Errore durante l\'aggiornamento dell\'iscrizione a {{value}}.","delete":"Riuscito, {{value}} \xe8 stato rimosso.","deleteError":"Errore durante la rimozione di {{value}}.","deleteConfirmation":{"title":"Sei sicuro di voler rimuovere questo membro?","description":"Una volta rimosso questo membro, non avr\xe0 pi\xf9 accesso all\'organizzazione. Puoi sempre invitarlo di nuovo in seguito.","confirm":"S\xec, rimuovi membro"},"viewAll":{"title":"Visualizza tutti i membri","description":"Visualizza tutti i membri della tua organizzazione e gestisci i loro ruoli e autorizzazioni."},"seats":{"title":"Posti dei membri","description":"Ogni membro della tua organizzazione conta come un posto. Il tipo di permessi che hanno pu\xf2 essere modificato dall\'amministratore dell\'organizzazione.","stats":"posti su {{value}}","max":"Posti massimi","current":"Posti attuali","limit":{"title":"Raggiunto il numero massimo di posti","description":"Il tuo piano attuale ha raggiunto il limite di {{ maxSeats }} posti disponibili. Non puoi invitare altri membri. Contatta il tuo amministratore per aggiornare il piano o gestire l\'assegnazione dei posti."},"updateLimit":{"title":"Aggiorna il tuo piano per aggiungere pi\xf9 posti","description":"Il tuo piano attuale ha raggiunto il numero massimo di posti: {{ maxSeats }}. Esegui l\'upgrade ora per sbloccare posti aggiuntivi e garantire che il tuo team possa continuare a crescere senza problemi.","action":"Piano di aggiornamento"},"maxSeatValue":"Numero massimo di posti: {{value}}"},"aboutMe":"Su di me","loadError":"Errore durante il caricamento dei membri dell\'organizzazione.","orgTitle":"Membri di {{value}}","emailExists":"L\'email esiste gi\xe0 nell\'organizzazione. Inserisci un indirizzo email diverso."},"invite":{"title":"Invitare","titlePlural":"Invita","description":"Gli inviti vengono inviati agli utenti per unirsi alla tua organizzazione. Puoi invitare gli utenti a unirsi alla tua organizzazione e assegnare loro ruoli diversi.","edit":"Aggiungi un membro","view":"Visualizza tutti gli inviti","viewDescription":"Visualizza tutti gli inviti attuali che non sono stati accettati.","new":"Invita un membro","emailRequired":"L\'email \xe8 obbligatoria","emailInvalid":"L\'email non \xe8 valida. Inserisci un indirizzo email valido.","emailExists":"L\'email ha gi\xe0 un invito dell\'organizzazione. Inserisci un indirizzo email diverso.","emailPlaceholder":"Inserisci l\'indirizzo email","expiration":"Scade","delete":"Elimina invito","confirm":"Sei sicuro di voler rimuovere questo invito?","confirmLong":"Una volta eliminato questo invito, l\'utente non potr\xe0 pi\xf9 unirsi all\'organizzazione. Puoi sempre invitarlo di nuovo in seguito.","accept":"Accetta invito","stat":"inviti attivi","noInvites":{"title":"Nessun invito.","description":"Sembra che non ci siano inviti attivi per la tua organizzazione."},"acceptSuccess":{"title":"Benvenuti nel team.","description":"Ti sei unito con successo all\'organizzazione.","action":"Visualizza la tua nuova organizzazione"},"acceptError":{"title":"Oops. Sembra che ci sia un problema.","description":"Si \xe8 verificato un errore durante l\'adesione all\'organizzazione. Riprova pi\xf9 tardi. Se il problema persiste, contatta l\'amministratore della tua organizzazione.","action":"Torna alla homepage"},"send":{"success":"Invito a {{value}} inviato.","error":"Errore durante l\'invio dell\'invito a {{value}}.","title":"Invia invito"},"error":"Errore durante il caricamento degli inviti.","orgTitle":"Inviti di {{value}}","editDescription":"Crea un nuovo invito per un utente affinch\xe9 si unisca alla tua organizzazione."},"role":{"title":"Ruolo","titlePlural":"Ruoli","description":"I ruoli sono i diversi livelli di accesso che un utente pu\xf2 avere nella tua organizzazione. Puoi assegnare ruoli diversi agli utenti per controllare cosa possono fare."},"isAdmin":{"title":"Amministratore","description":"Gli amministratori hanno pieno accesso all\'organizzazione e possono gestirne tutti gli aspetti.","conflict":"Questo membro \xe8 un amministratore. Non hai l\'autorizzazione per modificare i suoi ruoli."},"canViewMembers":{"title":"Visualizza i membri","description":"Gli utenti con questa autorizzazione possono visualizzare tutti i membri dell\'organizzazione."},"canInviteMembers":{"title":"Invita i membri","description":"Gli utenti con questa autorizzazione possono invitare nuovi membri all\'organizzazione e gestire gli inviti esistenti."},"canChangeMemberPermissions":{"title":"Cambia i ruoli dei membri","description":"Gli utenti con questa autorizzazione possono modificare il ruolo degli altri membri dell\'organizzazione."},"canRemoveMembers":{"title":"Rimuovi membri","titleSingle":"Rimuovi membro","action":"Rimuovere","description":"Gli utenti con questa autorizzazione possono rimuovere altri membri dall\'organizzazione.","confirm":"Vuoi davvero rimuovere questo membro dall\'organizzazione?","confirmLong":"Una volta rimosso questo membro, non avr\xe0 pi\xf9 accesso all\'organizzazione. Puoi sempre invitarlo di nuovo in seguito."},"canCreateAuthClients":{"title":"Crea progetti","description":"Gli utenti con questa autorizzazione possono creare nuovi client di autenticazione e progetti per l\'organizzazione."},"canManageBilling":{"title":"Gestisci la fatturazione","description":"Gli utenti con questa autorizzazione possono gestire le impostazioni di fatturazione per l\'organizzazione.","error":"Non hai l\'autorizzazione per gestire la fatturazione per questa organizzazione."},"metrics":{"title":"Metrica","description":"Le metriche sono punti dati che ti aiutano a capire come la tua organizzazione utilizza Cephable.","view":"Visualizza le metriche","lineChart":{"title":"Connessioni simultanee medie","description":"Questo grafico mostra la media delle connessioni contemporanee per i dati dell\'organizzazione e del progetto nel tempo.","max":"Numero massimo di connessioni: {{maxConnections}}","project":"Totale del progetto","org":"Organizzazione Totale"},"orgTitle":"Metriche di {{value}}","manage":{"title":"Metriche delle prestazioni","description":"Scarica o cancella le metriche delle prestazioni raccolte durante l\'inferenza del modello."},"download":{"button":"Scarica le metriche","success":"Il file delle metriche \xe8 stato salvato nella cartella Download.","error":"Impossibile scaricare il file delle metriche.","noFile":"Nessun file di metriche trovato. Prova prima a eseguire il modello."},"clear":{"button":"Metriche chiare","success":"Le metriche sono state cancellate.","error":"Impossibile cancellare il file delle metriche.","confirm":{"title":"Metriche di prestazione chiare","description":"Vuoi davvero cancellare tutte le metriche delle prestazioni registrate? Questa azione non pu\xf2 essere annullata.","cancel":"Cancellare","confirm":"Metriche chiare"}}},"projects":{"title":"Progetti","description":"Utilizza Progetti per gestire l\'accesso sicuro, configurare le interazioni con i dispositivi e semplificare il modo in cui le tue app inviano e ricevono comandi su diverse piattaforme.","name":"Nome dell\'app","view":"Visualizza i progetti","error":"Errore durante il caricamento dei progetti.","stats":{"title":"Statistiche del progetto","connections":"Connessioni totali","all":{"title":"Tutte le metriche del progetto","description":"Metriche aggregate per tutti i progetti associati a {{ orgName }}"},"card":"progetti su {{value}}","users":"utenti totali da {{date}}","avgUsers":"utenti medi mensili.","concurrent":{"title":"Media delle connessioni contemporanee negli ultimi {{days}} giorni","label":"Media simultanea","max":"Numero massimo di connessioni","overage":"Eccedenza","description":"Le connessioni simultanee sono il numero di utenti connessi al tuo progetto contemporaneamente. Questa metrica ti aiuta a capire quanti utenti stanno utilizzando la tua app contemporaneamente."}},"projectType":{"title":"Tipo di progetto","description":"I tipi di progetto vengono utilizzati per categorizzare i tuoi progetti e aiutarci a scegliere gli SDK pi\xf9 adatti a te."},"accessDenied":{"generic":"Non hai accesso a questo progetto.","title":"Accesso negato.","description":"Non hai accesso per visualizzare, creare, modificare o eliminare progetti. Contatta il tuo amministratore per ottenere l\'accesso."},"upgrade":{"title":"Aggiorna a Cephable SDK","description":"Cephable pu\xf2 essere integrato direttamente nella tua app, gioco o servizio usando i nostri SDK. I progetti non sono attualmente disponibili con il tuo account. Se pensi che ci sia un errore, contatta support@cephable.com.","shortDescription":"I progetti non sono attualmente disponibili con il tuo account. Contattaci per effettuare l\'upgrade."},"limit":{"title":"Vuoi altri progetti?","error":"Limite del progetto raggiunto.","description":"Hai raggiunto il numero massimo di progetti per la tua organizzazione. Contatta il tuo amministratore per aggiornare il tuo account."},"create":{"title":"Crea progetto","titleLong":"Cominciamo.","first":{"title":"Inizia il tuo progetto.","description":"Sembra che tu non abbia ancora creato un progetto. Le chiavi client e i dispositivi sono essenziali per proteggere la comunicazione tra le tue applicazioni e i nostri servizi. Con una chiave client, sarai in grado di integrare i controlli vocali e di movimento della testa nelle tue app in modo rapido e sicuro."},"details":{"title":"Dettagli del progetto","description":"Crea un nuovo progetto per gestire l\'autorizzazione della tua applicazione, le capacit\xe0 del dispositivo e le integrazioni SDK. Segui i passaggi sottostanti per impostare interazioni sicure e personalizzabili per i tuoi utenti."}},"sdk":{"title":"Scarica l\'SDK","description":"Accedi al nostro potente SDK sviluppato per semplificare i controlli adattivi.","select":{"title":"Seleziona SDK","description":"Seleziona l\'SDK che desideri utilizzare per questo progetto. I nostri SDK consentono un\'integrazione fluida di controlli vocali e di movimento della testa adattivi su diverse piattaforme."}},"clients":{"title":"Autorizzazione Clienti","configure":"Configurare il client di autorizzazione","description":"I client di autorizzazione gestiscono l\'accesso sicuro per le tue applicazioni. Definisci un client di autorizzazione per autenticare gli utenti e controllare le interazioni con la tua applicazione.","settings":"Impostazioni di autorizzazione","create":"Crea client di autorizzazione","max":"Progetti massimi: {{value}}"},"secret":{"title":"Segreto del cliente","created":"Il tuo segreto client \xe8 stato creato.","description":"Il tuo segreto client verr\xe0 mostrato solo una volta. Copialo ora e conservalo in un luogo sicuro.<br> <br> Utilizzalo solo per il tuo sviluppo personale. Non condividerlo con servizi o applicazioni di terze parti.","copy":"Copia segreto","rotate":{"title":"Ruota il segreto del cliente","description":"ATTENZIONE: questa azione revocher\xe0 il tuo segreto client esistente e ne creer\xe0 uno nuovo. Ci\xf2 richieder\xe0 di aggiornare tutto il tuo utilizzo esistente attraverso le tue app. Questa azione non pu\xf2 essere annullata.","error":"Errore durante la rotazione del segreto. Riprova pi\xf9 tardi."}},"key":{"title":"Chiave del cliente","view":"Visualizza la chiave del cliente","copy":"Copia chiave","delete":{"title":"Elimina la chiave client","description":"ATTENZIONE: questa azione rimuover\xe0 la chiave client esistente e tutte le impostazioni correlate. Questa azione non pu\xf2 essere annullata.","error":"Errore durante l\'eliminazione della chiave client.","success":"Il tuo progetto \xe8 stato eliminato."}},"tokenRedirect":{"title":"URL di reindirizzamento del token","description":"Gli URL di reindirizzamento token sono gli endpoint in cui vengono inviati i token di accesso dopo il completamento dell\'autenticazione. Questi URL consentono alla tua applicazione di ricevere in modo sicuro i token necessari per accedere ai dati e ai servizi utente."},"authRedirect":{"title":"URL di reindirizzamento del codice di autorizzazione","description":"L\'URL di reindirizzamento AuthCode \xe8 l\'endpoint in cui vengono inviati i codici di autorizzazione dopo che un utente concede l\'autorizzazione alla tua applicazione. Questo URL \xe8 essenziale nei flussi OAuth, poich\xe9 garantisce la trasmissione sicura del codice di autorizzazione dal server di autorizzazione alla tua app, consentendoti di richiedere token di accesso per conto dell\'utente."},"scopes":{"title":"Ambiti","configure":"Definisci gli ambiti","titleLong":"Ambiti di autorizzazione API","description":"Gli ambiti definiscono i permessi che questo client di autorizzazione avr\xe0. Imposta gli ambiti per limitare l\'accesso a dati e funzionalit\xe0 specifici, assicurando che gli utenti ottengano solo l\'accesso di cui hanno bisogno.","manage":"Gestisci gli ambiti di autorizzazione"},"type":{"title":"Tipo di implementazione"},"deviceScopes":{"title":"Tipi di dispositivi associati","titleLong":"Tipi di dispositivi consentiti","configure":"Configurare i tipi di dispositivi consentiti","action":"Aggiungi nuovo tipo di dispositivo","descriptionShort":"Definisci quali tipi di dispositivi possono accedere a questo progetto.","titles":"Tipi di dispositivi associati","description":"Il tipo di dispositivo definisce i permessi e i livelli di accesso che un dispositivo ha all\'interno della tua applicazione. Assegnando tipi di dispositivi specifici, puoi controllare le azioni e i dati a cui ogni dispositivo pu\xf2 accedere, assicurandoti che la tua applicazione rimanga sicura e conforme alle tue policy sulla privacy."},"deviceType":{"title":"Tipi di dispositivi","description":"Un DeviceType definisce una categoria di dispositivi, specificandone le capacit\xe0 di input/output e le funzionalit\xe0 supportate (ad esempio, voce, gesti, tipi di controller). Garantisce che solo i dispositivi autorizzati possano interagire con un\'applicazione.","action":"Crea tipo di dispositivo","name":"Nome del tipo di dispositivo","descriptionLong":"Descrizione del tipo di dispositivo","features":{"title":"Supporta le funzionalit\xe0","description":"Definisci gli input e gli output supportati dalla tua app. Questo ci aiuta a ottimizzare l\'esperienza utente su Cephable.","supportsVoiceInput":"Input vocale","supportsPhysicalInput":"Ingresso fisico","supportsKeyboardOutput":"Uscita tastiera","supportsPlayStationControllerOutput":"Controllore della PlayStation","supportsFaceInput":"Input facciale","supportsGestureInput":"Input gestuale","supportsXboxControllerOutput":"Controllore Xbox","supportsDigitalExtensions":"Estensioni digitali","supportsPhysicalExtensions":"Estensioni fisiche","supportsNintendoControllerOutput":"Controllore Nintendo","supportsGenericControllerOutput":"Uscita del controller generico"},"canAutoStart":{"title":"Supporta l\'avvio del controllo automatico","description":"[canAutoStart] se abilitato, gli SDK controlleranno le impostazioni utente e tenteranno di avviare immediatamente i controlli della telecamera o del microfono dopo l\'accesso dell\'utente."},"isSupported":{"title":"Attivo","description":"[isSupported] Se disabilitato, Cephable non invier\xe0, ricever\xe0 o riconoscer\xe0 pi\xf9 alcun dispositivo utente associato a questo. Equivale a deprecato."},"locale":{"title":"Lingua predefinita","description":"[defaultLocale] Le impostazioni locali predefinite per questo tipo di dispositivo. Verranno utilizzate come lingua predefinita per il dispositivo.","support":"Supporta le lingue","warn":"** Sembra che tu abbia impostato i Controlli personalizzati. Assicurati di aver aggiornato i controlli personalizzati per le lingue associate.**","name":"{{lang}} - Nome del tipo di dispositivo","langDescription":"{{lang}} - Descrizione"},"customControls":{"title":"Controlli personalizzati","object":"{{lang}} - Oggetto controlli personalizzati","description":"I controlli personalizzati sono un\'opzione avanzata che consente agli utenti di impostare e modificare manualmente i controlli delle app associati a questo dispositivo. Se desideri che gli utenti controllino il tuo dispositivo direttamente da Cephable, devi registrare i controlli del tuo dispositivo qui. Consulta Cephable API per i dettagli completi sulle opzioni."},"success":{"title":"Successo!","description":"Hai creato un nuovo tipo di dispositivo. {{name}} Ora puoi aggiornare l\'ambito del dispositivo client di autorizzazione in base alle tue esigenze."},"id":"ID tipo dispositivo","throttleRules":{"title":"Regole del comando dell\'acceleratore","description":"Configurare le regole di limitazione per controllare il flusso dei comandi e le restrizioni di input per questo tipo di dispositivo.","disableVoiceInput":"Disabilita l\'input vocale","disableHotkeyInput":"Disabilita l\'input tramite tasti di scelta rapida","disableCameraInput":"Disabilita l\'input della telecamera","disableMultiInputs":"Disabilitare pi\xf9 input","maximumCommandsPerSecond":"Comandi massimi al secondo","maximumCommandsPerMinute":"Comandi massimi al minuto","maximumMacroLength":"Lunghezza massima della macro"}},"originHost":{"title":"Origine Host","description":"L\'URL che funger\xe0 da fonte primaria per le richieste e i dati durante le interazioni API."},"orgTitle":"Progetti di {{value}}"},"viewOrganization":"Visualizza Organizzazione","update":"La tua organizzazione \xe8 stata aggiornata! Aggiornamento dell\'app.","error":"Errore durante il caricamento dell\'organizzazione. Riprova pi\xf9 tardi.","new":{"name":{"label":"Nome dell\'organizzazione","placeholder":"Inserisci il nome della tua organizzazione"},"description":{"label":"Descrizione dell\'organizzazione","placeholder":"Quali sono i tuoi obiettivi con Cephable Professional?"},"details":"Dettagli dell\'organizzazione"},"expired":{"user":"Sembra che la tua licenza Cephable sia scaduta, quindi sei stato declassato alla versione gratuita Cephable Basic. Per rinnovarla, contatta l\'amministratore della tua organizzazione.","admin":"Sembra che la tua licenza Cephable sia scaduta, quindi sei stato declassato alla versione gratuita Cephable Basic. Rinnova la licenza per continuare a utilizzare le funzionalit\xe0 avanzate oltre a Cephable Basic.","multiple":"Sembra che le tue licenze Cephable siano scadute, quindi sei stato declassato alla versione gratuita Cephable Basic. Rinnova almeno una delle tue licenze per continuare a utilizzare le funzionalit\xe0 avanzate oltre a Cephable Basic.","dialog":{"title":"Seleziona un\'organizzazione","description":"Hai pi\xf9 organizzazioni associate al tuo account. Seleziona l\'organizzazione che desideri rinnovare."},"title":"La tua licenza Cephable \xe8 scaduta","titlePlural":"Le tue licenze Cephable sono scadute","banner":"Sembra che la tua licenza Cephable sia scaduta, quindi sei passato alla versione gratuita Cephable Basic. Rinnovandola, avrai accesso a funzionalit\xe0 come controlli vocali avanzati, attivit\xe0 intelligenti basate sull\'intelligenza artificiale e molti controlli predefiniti per le app."},"orgName":"Nome dell\'organizzazione","menu":{"title":"Menu Organizzazione","view":"Visualizza il menu","expand":"Espandi Menu"},"settings":{"title":"Impostazioni dell\'organizzazione","description":"Gestisci la fatturazione, il nome, la descrizione e le risorse della tua organizzazione.","view":"Visualizza impostazioni","general":{"title":"Generale"},"resources":{"edit":"Modifica risorse","description":"Utilizza l\'editor Markdown sulla sinistra per aggiornare e formattare risorse utili per tutti i membri dell\'organizzazione. Mentre digiti, l\'anteprima sulla destra mostrer\xe0 come il tuo contenuto apparir\xe0 agli utenti. Puoi aggiungere titoli, elenchi, link e altri elementi di formattazione utilizzando la sintassi Markdown. Le modifiche saranno visibili ai membri una volta salvate."},"other":{"title":"Altre impostazioni","description":"Gestisci la fatturazione, il nome, la descrizione e le risorse della tua organizzazione."}},"managed":{"title":"Organizzazione gestita","titlePlural":"Organizzazioni gestite","description":"Le organizzazioni gestite sono organizzazioni gestite da un rivenditore Cephable. I rivenditori possono gestire il tuo team, i profili del team, la fatturazione e altro qui.","error":"Errore durante il caricamento delle organizzazioni gestite.","empty":{"title":"Nessuna organizzazione gestita trovata.","description":"Sembra che non ci siano organizzazioni gestite che corrispondono a questo criterio. Oppure le tue chiavi di licenza non sono ancora state attivate."},"titleShort":"Gestito"},"canManageChildOrganizations":{"title":"Gestire le organizzazioni secondarie","description":"Gli utenti con questa autorizzazione possono creare e gestire organizzazioni figlio come amministratori."},"canViewAnalytics":{"title":"Visualizza analisi","description":"Gli utenti con questa autorizzazione possono visualizzare le metriche e le analisi per l\'organizzazione."},"create":"Crea nuova organizzazione","orgCustomBillingUrl":{"title":"URL di fatturazione personalizzato","description":"Questo \xe8 un URL personalizzato che verr\xe0 utilizzato per reindirizzare l\'utente al tuo sistema di fatturazione (del rivenditore). Dovrebbe iniziare con \'https://\' o \'mailTo:\'"},"upgrade":{"existing":{"title":"Fai parte di una licenza esistente.","description":"Per effettuare l\'aggiornamento, clicca su `{{action}}` nel menu laterale."}},"restrictions":{"isGenAIDisabled":{"title":"AI generativa disabilitata","description":"La tua organizzazione ha disabilitato l\'accesso alle funzionalit\xe0 di IA generativa. Contatta l\'amministratore della tua organizzazione per ulteriori informazioni."},"isRemoteControlDisabled":{"title":"Sincronizzazione tra dispositivi disabilitata","description":"La tua organizzazione ha disabilitato l\'accesso alla sincronizzazione. Non potrai utilizzare la nostra app complementare n\xe9 controllare dispositivi esterni. Contatta l\'amministratore della tua organizzazione per ulteriori informazioni."}},"troubleshooting":{"title":"Risoluzione dei problemi","editorDescription":"[Facoltativo] Questa \xe8 una sezione visibile a tutti gli utenti tramite la pagina dei dettagli della connessione sia nell\'app mobile che in quella desktop di Cephable.","description":"Se riscontri problemi con Cephable, prova a seguire i passaggi indicati di seguito per risolvere i problemi pi\xf9 comuni."},"onboarding":{"title":"Onboarding","editorDescription":"[Facoltativo] L\'onboarding viene visualizzato agli utenti quando questo tipo di dispositivo viene aggiunto al loro account. Questa \xe8 un\'ottima opportunit\xe0 per fornire istruzioni su come configurare e utilizzare il tipo di dispositivo con la tua applicazione."},"documents":"Documenti","completionStatus":{"title":"Stato di completamento","error":"","complete":"Completare.","incomplete":"Incompleto."},"metadata":{"title":"Metadati","urlError":"L\'URL deve iniziare con http:// o https://","metatitle":{"label":"Meta titolo","placeholder":"Inserisci un titolo breve"},"shortDescription":{"label":"Breve descrizione","placeholder":"Inserisci una breve descrizione di anteprima (max 150 caratteri)"},"externalLink":{"label":"URL del collegamento esterno","placeholder":"https://example.com/device-info","description":"Un collegamento diretto a un sito web o a una risorsa esterna che fornisce maggiori informazioni sulla prima configurazione del dispositivo. Se lo utilizzi, non applicheremo il ribasso dell\'elenco clienti."},"iconUrl":{"label":"URL dell\'icona del dispositivo","placeholder":"https://example.com/device-icon.png","description":"Un collegamento diretto a un\'immagine che rappresenta questo tipo di dispositivo. Questa icona verr\xe0 visualizzata nell\'app Cephable e negli elenchi dei dispositivi."},"darkModeIconUrl":{"label":"URL dell\'icona del dispositivo in modalit\xe0 scura","placeholder":"https://example.com/device-icon-dark.png","description":"Un collegamento diretto a un\'immagine che rappresenta questo tipo di dispositivo in modalit\xe0 scura. Questa icona verr\xe0 visualizzata nell\'app Cephable e negli elenchi dei dispositivi quando l\'utente ha attivato la modalit\xe0 scura."},"editorDescription":"Quando il tuo dispositivo viene selezionato per essere inserito nell\'app Cephable come estensione o connessione, utilizziamo queste informazioni per mostrarle agli utenti che configurano nuove connessioni."},"client-listing":{"title":"Elenco clienti","editorDescription":"Istruzioni dettagliate per i nuovi utenti su come configurare nuove connessioni con questo tipo di dispositivo. Questo contenuto di markdown verr\xe0 visualizzato nell\'app Cephable quando gli utenti aggiungono una nuova connessione."},"canAccessOrganizationProfiles":{"title":"Visualizza i controlli dell\'app Organizzazione","description":"Gli utenti con questa autorizzazione possono visualizzare i controlli delle app dell\'organizzazione associati a questa organizzazione."},"canEditOrganizationProfiles":{"title":"Gestisci i controlli delle app dell\'organizzazione","description":"Gli utenti con questa autorizzazione possono creare, modificare ed eliminare i controlli delle app dell\'organizzazione associati a questa organizzazione."},"profiles":{"title":"Controlli dell\'app dell\'organizzazione","description":"I controlli app dell\'organizzazione sono profili condivisi per distribuire i controlli app all\'interno dell\'organizzazione o per condividerli con gli utenti dell\'integrazione.","view":"Visualizza i controlli dell\'app Organizzazione","editDescription":"Modifica i controlli dell\'app dell\'organizzazione per personalizzare le impostazioni.","empty":"Nessun controllo dell\'app dell\'organizzazione trovato. Creane uno per iniziare.","error":"Errore durante il caricamento dei controlli dell\'app dell\'organizzazione.","titleShort":"Controlli dell\'app"},"canViewAuthClients":{"title":"Visualizza i progetti","description":"Gli utenti con questa autorizzazione possono visualizzare i client e i progetti autenticati per l\'organizzazione."}},"developer":{"title":"Sviluppatore","titleLong":"Risorse per sviluppatori","description":"Cephable pu\xf2 essere integrato direttamente nella tua app, gioco o servizio utilizzando i nostri SDK.","sdk":{"title":"Esplora i nostri SDK","description":"Forniamo SDK di prima classe progettati per integrare senza problemi il riconoscimento vocale e i controlli adattivi nelle tue applicazioni. I nostri strumenti sono realizzati per migliorare l\'interazione dell\'utente tramite controlli intuitivi e per promuovere l\'accessibilit\xe0, assicurando che il tuo software possa essere utilizzato in modo pi\xf9 efficace da tutti gli utenti.","javascript":{"title":"Javascript","subtitle":"Sito web","description":"Integra i controlli vocali e adattivi direttamente nelle tue applicazioni web.","action":"Ottieni il Pacchetto NPM"},"net":{"title":".NET","subtitle":"Applicazioni Windows","description":"Sfrutta la potenza di .NET per creare applicazioni con i nostri SDK WPF e WinUI3.","actionCore":"Ottieni il Pacchetto Core","actionWpf":"Ottieni il Pacchetto WPF"},"android":{"title":"Android","subtitle":"Dispositivi mobili","description":"Applicazioni Android progettate per facilitare le capacit\xe0 vocali e di movimento della testa.","action":"Ottieni Android SDK"},"more":{"title":"Di pi\xf9","description":"Non trovi quello che ti serve? Contattaci e ti aiuteremo.","action":"Richiedi un SDK"}},"demo":{"title":"Dimostrazioni","titleLong":"Prova i nostri SDK in azione","description":"Scopri la potenza delle nostre tecnologie di controllo vocale e dei movimenti della testa attraverso le nostre applicazioni campione. Dai giochi interattivi alle app dinamiche per dispositivi mobili e web, ogni esempio dimostra la versatilit\xe0 e l\'efficacia dei nostri SDK. Esplora questi esempi per ottenere spunti e ispirazione per integrare accessibilit\xe0 avanzata ed esperienze immersive nei tuoi progetti.","game":{"title":"Gioco 2048","subtitle":"Sito web","description":"Migliora il gameplay tradizionale con controlli vocali e movimenti della testa adattivi.","action":"Gioca al gioco"},"unity":{"title":"Unit\xe0","subtitle":"Sviluppo del gioco","description":"Scopri come i controlli adattivi possono essere sfruttati nei giochi per offrire un\'esperienza utente pi\xf9 coinvolgente.","action":"Ottieni il campione"},"samples":"Demo e campioni","other":{"title":"Altre demo","description":"Scopri in prima persona come Cephable pu\xf2 migliorare la tua applicazione, il tuo gioco o il tuo dispositivo.","action":"Visualizza altre demo"},"web":{"title":"Esempi di Web SDK","subtitle":"Sito web","description":"Integrazione semplice di tutte le nostre funzionalit\xe0 principali nelle applicazioni web.","action":"Prova l\'SDK"}},"other":{"title":"Altre risorse","description":"Se non trovi ci\xf2 di cui hai bisogno nei nostri SDK, prova a lavorare direttamente con le nostre API o contatta la community per ricevere aiuto, ispirazione e supporto.","api":{"title":"API","description":"Le nostre API ti consentono di interagire direttamente con Cephable. Puoi usare le nostre API per creare integrazioni personalizzate."},"support":{"title":"Supporto","description":"Non trovi ci\xf2 di cui hai bisogno? Contatta la nostra community tramite Discord.","action":"Unisciti a Discord"}}},"customControls":{"title":"Controlli globali e del dispositivo","prefixDisclaimer":"Questo \xe8 un controllo del prefisso: ascolter\xe0 le parole dopo il comando e poi cercher\xe0 le corrispondenze nella frase seguente.","allowPausedDisclaimer":"Questo controllo funziona anche quando il microfono \xe8 in pausa.","resetControls":{"title":"Ripristina controlli","description":"La lingua della tua voce \xe8 cambiata dall\'ultima volta che hai aggiornato i tuoi controlli. Nota: questo reimposter\xe0 i tuoi controlli in modo che corrispondano a {{language}} e potresti perdere tutti i comandi personalizzati. Vuoi davvero reimpostare?","confirm":"S\xec, ripristina i controlli","error":"Si \xe8 verificato un errore durante la reimpostazione dei controlli. Riprova pi\xf9 tardi."},"conflictIndicators":{"warn":"Avvertimento: ","title":"Rilevati conflitti nella configurazione di input","globalControls":"Conflitti di configurazione del controllo globale","deviceControls":"Conflitti di configurazione del controllo del dispositivo","usedInput":"viene utilizzato come input per","description":"Alcuni degli input per i controlli globali e dispositivo che stai utilizzando sono utilizzati anche in uno o pi\xf9 controlli app. Ci\xf2 potrebbe causare conflitti quando si utilizza Cephable. Quando ci\xf2 accade, daremo sempre la preferenza al controllo app rispetto al controllo globale o dispositivo.","item":"L&#39;input <strong>{{value}}</strong> viene utilizzato nei controlli dell&#39;app: ","globalDescription":"I seguenti controlli globali presentano input in conflitto con i controlli dell\'app.","deviceDescription":"I seguenti controlli del dispositivo presentano input in conflitto con i controlli dell\'app."},"globalControls":{"title":"Controlli globali","empty":"Non hai ancora controlli globali. Clicca qui sotto per crearne uno.","edit":"Modifica controlli globali","description":"I controlli globali sono controlli sempre disponibili, indipendentemente dai controlli dell\'app o dal dispositivo che stai utilizzando. Alcuni funzionano anche quando i controlli del microfono o della fotocamera sono in pausa."},"deviceControls":{"title":"Controlli del dispositivo","empty":"Non hai ancora controlli dispositivo. Fai clic qui sotto per crearne uno.","edit":"Modifica controlli dispositivo","controls":{"cephable-open-app":{"success":"Apri app: {{value}}","error":"Impossibile trovare l\'app: {{value}}"},"cephable-close-app":{"commands":["vicino"],"name":"Chiudi l\'app per nome","description":"Utilizza questo comando con i comandi vocali per chiudere un\'app sul tuo computer in base al nome.","success":"Chiudi app: {{value}}","error":"Impossibile trovare l\'app: {{value}}"},"cephable-minimize-focused-app":{"commands":["minimizzare"],"name":"Riduce a icona l\'app attualmente in evidenza.","description":"Utilizzare questo comando con i comandi vocali per ridurre a icona l\'app attualmente in evidenza.","success":"Riduci al minimo il successo delle app mirate!","error":"Errore durante la riduzione a icona dell\'app selezionata."},"cephable-maximize-focused-app":{"commands":["massimizzare"],"name":"Massimizza l\'app attualmente in evidenza.","description":"Utilizza questo comando con i comandi vocali per mettere a fuoco al massimo l\'app corrente.","success":"Massimizza il successo della tua app mirata!","error":"Errore durante la riduzione a icona dell\'app selezionata."},"cephable-generate-text":{"commands":["generare"],"name":"Generare il testo fornendo il prompt che segue questo comando.","description":"Utilizza questo comando con i comandi vocali seguito dal tuo prompt per generare del testo correlato."},"cephable-stop-generate-text":{"commands":["interrompere la generazione","interrompere la generazione","annulla genera","annullare la generazione"],"name":"Interrompere la generazione del testo.","description":"Utilizzare questo comando con i controlli vocali per interrompere la generazione di testo"},"cephable-open-panel":{"commands":["mostra pannello"],"name":"Aprire il pannello Cephable","description":"Utilizzare questo comando con i comandi vocali per aprire il pannello Cephable."},"cephable-close-panel":{"commands":["nascondi pannello"],"name":"Nascondi il pannello Cephable","description":"Utilizzare questo comando con i comandi vocali per nascondere o ridurre a icona il pannello Cephable."},"cephable-close-focused-app":{"commands":["corrente di chiusura"],"name":"Chiude l\'app attualmente in evidenza.","description":"Utilizzare questo comando con i comandi vocali per chiudere l\'app attualmente in focus.","success":"Chiusura dell\'app corrente riuscita!","error":"Errore durante la chiusura dell\'app corrente."},"cephable-rewrite-text":{"commands":["riscrivere"],"name":"Riscrivi il testo fornendo il prompt che segue questo comando.","description":"Utilizza questo comando con i comandi vocali seguito dal prompt per riscrivere il testo attualmente evidenziato."},"cephable-summarize-text":{"commands":["riassumere"],"name":"Riassumere il testo fornendo il prompt che segue questo comando.","description":"Utilizza questo comando con i comandi vocali seguito dal prompt per riassumere il testo attualmente evidenziato."},"cephable-translate-text":{"commands":["tradurre"],"name":"Traduci il testo fornendo il prompt che segue questo comando.","description":"Utilizza questo comando con i comandi vocali seguito dalla tua richiesta per tradurre il testo attualmente evidenziato."},"cephable-click-by-name":{"commands":["rubinetto","colpo","navigare verso","andare a"],"name":"Tocca l\'elemento per nome","description":"Tocca qualcosa sulla pagina per nome, ad esempio \\"tocca salva\\" per fare clic su un pulsante denominato \\"salva\\""}},"description":"I controlli dispositivo sono legati al dispositivo o alla connessione specifici che stai utilizzando. Sono disponibili senza bisogno di aggiungerli ai controlli dell\'app e sono particolarmente utili per funzionalit\xe0 o eventi supportati solo su determinati dispositivi."},"warn":"Il microfono non \xe8 stato avviato. Devi avviare il microfono per usare i controlli globali e del dispositivo.","changeProfile":{"success":"Cambia i controlli dell\'app: {{value}}","error":"Impossibile trovare i controlli dell\'app: \'{{value}}\'"},"descriptionShort":"I controlli globali e dei dispositivi sono azioni sempre disponibili, progettate per funzionare su qualsiasi software. I controlli globali, come \\"Interrompi fotocamera\\", sono a livello di sistema e indipendenti dall\'app, mentre i controlli dei dispositivi sono personalizzati per ogni connessione e sbloccano funzionalit\xe0 pi\xf9 avanzate rispetto ai controlli delle app standard.","description":"I controlli globali e dei dispositivi sono azioni sempre disponibili, progettate per funzionare su qualsiasi software. I controlli globali, come \\"Interrompi fotocamera\\", sono a livello di sistema e indipendenti dall\'app, mentre i controlli dei dispositivi sono personalizzati in base alla connessione di ciascun dispositivo e sbloccano funzionalit\xe0 pi\xf9 avanzate rispetto ai controlli delle app standard. Attualmente, questi controlli sono accessibili tramite comandi vocali, ma in futuro aggiungeremo il supporto per altri input.","noDevice":"Questo passaggio utilizza un\'estensione personalizzata che non hai configurato per il tuo account. Aggiungi l\'estensione per sbloccare questo passaggio."},"notifications":{"title":"Notifiche","center":"Centro notifiche","empty":"Al momento non hai notifiche. Controlla di nuovo un\'altra volta.","seen":"Visto","markAsRead":"Segna come letto","view":"Visualizza tutte le notifiche {{value}}"},"unsaved":{"title":"Ci sono modifiche non salvate.","description":"Hai modifiche non salvate. Vuoi davvero uscire da questa pagina?","cancel":"Esci senza salvare","confirm":"Salva ed esci"},"login":{"welcome":"Benvenuti a Cephable!","subtitle":"Controlla la tua tecnologia alle <strong>tue</strong> condizioni.","create":"Creare un account","signIn":"Registrazione","loading":"Reindirizzamento per l\'accesso...","error":"Si \xe8 verificato un errore durante l\'accesso. Accedi di nuovo.","existingAccount":"Hai gi\xe0 un account?","description":"Assumi il pieno controllo del tuo computer, delle tue app e dei tuoi giochi con Cephable, la tua intelligenza artificiale personale per azioni rapide, comandi vocali, espressioni facciali, gesti, inclinazione e altro ancora. Nessuna elaborazione cloud. Solo un controllo fluido che si muove con te."},"home":{"title":"Casa","startControls":"Accendilo!","manage":"Configurare","profileGenerate":{"title":"Oops. Sembra che non hai ancora alcun controllo app.","description":"Affinch\xe9 Cephable possa controllare il tuo computer, dobbiamo sapere cosa vuoi controllare. Puoi creare controlli app da zero o farti aiutare a crearne uno usando il nostro generatore di controlli."}},"wizard":{"description":"Cephable utilizzer\xe0 quindi queste informazioni per generare controlli che potrai esaminare e provare!","includeDefaultKeysQuestion":"Includere comandi vocali predefiniti per i tasti e i clic del mouse?","placeholderAppName":"Microsoft Word, Minecraft, YouTube, Codice, ecc.","noOptionsText":"Inizia a digitare per trovare un\'app che desideri controllare","generate":"Genera controlli","complete":{"title":"Bene, abbiamo finito!","description":"Fai clic sul pulsante qui sotto per visualizzare i controlli che abbiamo generato. Sarai in grado di modificare manualmente, aggiungere o rimuovere qualsiasi aspetto per perfezionarlo per te stesso.","viewControls":"Guarda i miei controlli"},"error":{"emptyInput":"Seleziona almeno un metodo di input","emptyApp":"Inserisci almeno un nome di app","generatingProfile":"Errore durante la generazione dei controlli dell\'app"},"loading":{"title":"Stiamo mettendo insieme tutti i pezzi","description":"Questo pu\xf2 richiedere fino a circa un minuto. Non lasciare questa pagina o tornare indietro, altrimenti smetter\xe0 di generare."},"selectedTips":{"title":"Suggerimento n. {{count}}","previous":"Suggerimento precedente","next":"Suggerimento successivo","two":"Puoi controllare la sensibilit\xe0 dei tuoi input nella sezione \\"Expression Control Settings\\" del pannello principale. Questo ti consente di perfezionare ulteriormente i modi in cui Cephable interpreta gli input specifici per te. E Cephable migliora nel tempo man mano che lavora con te!","three":"Dopo averlo impostato, hai ancora il controllo completo sulla configurazione. Ti diamo una baseline, ma in qualsiasi momento puoi cambiare la mappatura tra ci\xf2 che fai e ci\xf2 che fa sul computer.","four":"Puoi stampare i tuoi controlli per averne una copia fisica mentre usi Cephable. Sappiamo che \xe8 tutto nuovo e ci vuole un po\' per abituarsi. La pratica rende migliori!","one":"Sapevi che puoi usare Cephable su un dispositivo per controllarne un altro? Scarica Cephable sul tuo cellulare, tablet o anche su un altro computer e scegli la connessione che desideri controllare (magari questa). I tuoi profili personali e di input saranno identici su tutti! Assicurati solo che Cephable sia in esecuzione sul tuo dispositivo e sulle tue connessioni."},"steps":{"one":"Passaggio 1. Digita il nome dell\'app che desideri controllare.","two":"Passaggio 2. Conferma i controlli di input che desideri utilizzare:","three":"Passaggio 3. (facoltativo)","threeContinued":"Descrivi le azioni specifiche che vorresti impostare per i comandi che usi comunemente o per i quali hai una forte preferenza. Per favore usa un inglese semplice come quelli sottostanti"},"title":"Genera controlli app","titleLong":"Generare un controllo app","try":"Prova il generatore di controllo","placeholder":"Assicurati che i comandi vocali siano brevi.\\n\\nVoglio poter dire \\"avanti\\" per passare alla diapositiva successiva della presentazione.\\n\\nVoglio usare il movimento della testa per spostare il cursore e i comandi vocali per modificare le scorciatoie.\\n\\nAggiungi pulsanti di azione rapida per tutti i movimenti e le abilit\xe0 dei miei personaggi."},"macros":{"title":"Controllare","titlePlural":"Controlli","description":"I controlli contengono un input (un\'azione che fai come inclinare la testa) e i passaggi che Cephable eseguir\xe0 dopo che l\'azione di input \xe8 stata registrata. Puoi usare i controlli per creare una combinazione di passaggi che vengono attivati da un singolo input.","new":"Crea un nuovo controllo","newDescription":"Crea un nuovo controllo per combinare pi\xf9 passaggi e input.","add":"Aggiungi controllo","create":"Crea un controllo","name":{"title":"Nome del controllo","question":"Come vuoi chiamare questo controllo?","description":"Assegna un nome al tuo controllo, cos\xec potrai ritrovarlo facilmente in seguito.","placeholder":"azione che questo controllo sta eseguendo come \\"saltare\\" o \\"ingrandire\\""},"empty":"Non hai ancora alcun controllo. Clicca qui sotto per crearne uno.","copySuffix":"{{name}}_copia"},"event":{"title":"Fare un passo","titlePlural":"Passi","previewSummaryPlural":"{{first}} e {{total}} altri eventi","add":"Aggiungi passaggio","stepType":"Tipo di passo","select":"Seleziona il tipo di passaggio che desideri aggiungere.","question":"Che tipo di azioni vuoi che Cephable esegua?","setup":"Configura il tuo Step","description":"I passaggi sono le azioni che Cephable eseguir\xe0 dopo che l\'input \xe8 stato attivato. \xc8 possibile aggiungere pi\xf9 passaggi a un controllo per creare una combinazione di azioni.","expand":"Espandi per vedere il resto dei passaggi","stepUp":"Sposta il passo avanti","stepDown":"Spostare il passo verso il basso","stepCopy":"Copia passaggio","stepRemove":"Rimuovi passaggio","insertStep":"Inserisci il passaggio qui sotto","showOptions":"Mostra opzioni","hideOptions":"Nascondi opzioni","hold":"Tempo di attesa (in millisecondi)","error":"Devi configurare il tuo passaggio.","multiple":"Passaggi multipli","deviceTypeCustomAction":{"title":"Azione dispositivo personalizzata"},"keyPress":{"title":"Premere il tasto o il pulsante","short":"Premere","fieldSet":"Tasti o pulsanti da premere","label":"Tasto o pulsante","holdTime":"Tempo di mantenimento del tasto (in millisecondi)","description":"Premere un tasto della tastiera senza utilizzare la tastiera.","longDescription":"Questa funzione simula la pressione di un tasto sulla tastiera. Ad esempio, se hai difficolt\xe0 a premere i tasti fisici, puoi usare un comando vocale o un altro metodo di input per \\"premere\\" virtualmente un tasto.","example":"Pronuncia \\"Invio\\" per inviare un\'e-mail senza premere fisicamente il tasto Invio.","timing":"Tempo di pressione dei tasti","tap":"Rubinetto","tapLong":"Pulsante Tocca","latch":"Fermo","latchLong":"Tenere premuto fino al rilascio","hold":"Presa","holdLong":"Tenere premuto per un certo periodo di tempo","toggle":"Attiva/disattiva","toggleLong":"Attiva/disattiva azione","release":"Rilascia","releaseLong":"Rilascia azione","latchLabel":"Tieni premuto <strong>{{value}}</strong> finch\xe9 non viene rilasciato","tapLabel":"Tocca <strong>{{value}}</strong>","pressLabel":"Premi <strong>{{value}}</strong> per <strong>{{time}}</strong> millisecondi","remove":"Rimuovi pressione tasto","add":"Aggiungi tasto/pulsante da premere"},"keyRelease":{"title":"Rilasciare la chiave o il pulsante","short":"Pubblicazione","selected":"Chiavi selezionate per il rilascio","description":"Rilascia un tasto della tastiera che hai tenuto premuto.","longDescription":"Questa funzione simula il rilascio di un tasto sulla tastiera. Dovrebbe essere utilizzata insieme a una pressione di tasto mantenuta indefinitamente. Ad esempio, se hai difficolt\xe0 a premere tasti fisici, puoi usare un comando vocale o un altro metodo di input per \\"rilasciare\\" virtualmente un tasto.","example":"Per interrompere la corsa, pronunciare \\"Stop\\" dopo aver detto \\"Attiva/disattiva esecuzione\\".","label":"Rilascia <strong>{{value}}</strong>","add":"Aggiungi chiave/pulsante per rilasciare","remove":"Rimuovi rilascio chiave"},"keyToggle":{"title":"Tasto o pulsante di attivazione/disattivazione","short":"Attiva/disattiva","selected":"Tasti selezionati per attivare/disattivare","description":"Con un solo comando puoi accendere o spegnere un tasto della tastiera come se fosse un interruttore della luce.","longDescription":"Questo attiva o disattiva la funzione di un tasto, come un interruttore. \xc8 utile per i tasti che vuoi tenere premuti per un periodo di tempo indeterminato. Puoi usarlo per mantenere la stessa azione sia per la pressione del tasto che per il rilascio o l\'arresto del tasto.","example":"Pronuncia \\"Toggle Run\\" per iniziare a correre. Pronuncia \\"Toggle Run\\" per smettere di correre.","label":"Attiva/disattiva <strong>{{value}}</strong>","add":"Aggiungi tasto/pulsante per attivare/disattivare","remove":"Rimuovi tasto di attivazione/disattivazione"},"pause":{"title":"Pausa","description":"Aggiungere un breve ritardo tra le azioni.","longDescription":"Questa funzione consente di inserire un breve ritardo tra le azioni, essenziale in situazioni in cui un\'azione deve essere completata completamente prima che inizi la successiva. Ad esempio, se si utilizza un comando per rendere il testo in grassetto in un documento, potrebbe essere necessario aprire prima un menu contestuale. La funzione Pausa concede abbastanza tempo all\'apertura e all\'attivazione del menu contestuale prima di procedere al passaggio successivo, assicurando un funzionamento fluido e senza errori.","example":"Immagina di modificare un documento usando i comandi vocali. Dici \\"Formatta testo\\", che apre un menu contestuale. Quindi, dopo una breve pausa per consentire al menu di apparire completamente, dici \\"Grassetto\\" per applicare la formattazione in grassetto al testo selezionato. La funzione Pausa assicura che il menu contestuale sia pronto a ricevere il tuo comando successivo.","label":"Pausa per <strong>{{value}}</strong> millisecondi"},"type":{"title":"Tipo","field":"Frase da digitare","placeholder":"frase digitata","question":"Che testo vuoi digitare?","description":"Scrivi il testo come se usassi una tastiera.","longDescription":"Questo imita la digitazione di una stringa di testo, simile alla digitazione su una tastiera. \xc8 ideale per immettere testo pi\xf9 lungo senza dover premere ogni tasto. Se si desidera immettere testo in modo dinamico, \xe8 possibile utilizzare la funzione Dettatura.","example":"Pronuncia \\"Nome\\" per digitare \\"Ciao, mi chiamo Ellen Ripley.\\" in una finestra di chat.","label":"Tipo <strong> {{value}} </strong>"},"mouseMove":{"title":"Muovi il mouse","description":"Spostare il puntatore sullo schermo.","longDescription":"Sposta il cursore o il puntatore dello schermo senza un mouse fisico. Ci\xf2 \xe8 particolarmente utile per gli utenti con mobilit\xe0 limitata delle mani. Ci\xf2 \xe8 utile per il controllo preciso del movimento del mouse, necessario in alcuni giochi. Se vuoi simulare tutti i movimenti del mouse utilizzando il movimento della testa, puoi provare \'Movimento della testa per il controllo del mouse\' nelle impostazioni della telecamera.","example":"Pronuncia \\"Sposta il mouse a destra\\" per spostare il cursore a destra di 100 px.","moveX":"Spostamento del mouse a sinistra/destra dei pixel","numberMoveX":"Numero di pixel da spostare a sinistra/destra","moveY":"Spostamento del mouse su/gi\xf9 Pixel","numberMoveY":"Numero di pixel da spostare su/gi\xf9","label":"Sposta il mouse <strong> {{value}} </strong>","command":"Spostamento del mouse: {{command}}"},"joystickMove":{"title":"Spostare i joystick","description":"Usa un joystick per spostare gli oggetti sullo schermo.","longDescription":"Questa funzione simula il movimento di un joystick. Ad esempio, se hai difficolt\xe0 a usare un joystick fisico, puoi usare un comando vocale o un altro metodo di input per muovere virtualmente un joystick.","example":"Pronuncia \\"Sposta il joystick a sinistra\\" per spostare il joystick a sinistra di 100 px.","prefix":"Muovi il joystick sinistro","left":"Joystick sinistro","leftX":"X sinistro","leftY":"Y sinistro","right":"Joystick destro","rightX":"X destro","rightY":"Y destro","x":"Forza dell\'asse X","y":"Forza dell\'asse Y","moveXLabel":"Sposta X: {{value}}","moveYLabel":"Sposta Y: {{value}}","labelLeft":"Muovi il joystick sinistro","labelRight":"Muovi il joystick a destra","latch":"Latch manterr\xe0 la posizione finch\xe9 non la rilascerai utilizzando il comando \'Stop All\'."},"playAudio":{"title":"Riproduci audio","placeholder":"frase di affermazione che Cephable dir\xe0","description":"Riproduci un suono, una parola o una frase.","longDescription":"Questa funzione consente agli utenti di convertire frasi digitate in parole pronunciate. \xc8 particolarmente utile per le persone che potrebbero avere difficolt\xe0 a parlare. Digitando una frase, la funzione PlayAudio articola il testo ad alta voce utilizzando la sintesi vocale. Questo pu\xf2 aiutare nella comunicazione o in situazioni in cui un utente deve trasmettere informazioni verbalmente ma preferisce o richiede un\'alternativa all\'uso della propria voce.","example":"Sorridi per riprodurre la parola \\"Ciao\\".","label":"Pronuncia <strong>\\"{{value}}\\"</strong>"},"stopOutputs":{"title":"Interrompi tutte le uscite","titleLong":"Interrompere tutti gli output (rilasciare tutti i tasti e i pulsanti, interrompere tutti i movimenti del mouse, interrompere tutta la digitazione)","description":"Interrompere tutte le azioni in corso, come la pressione di tasti.","longDescription":"Interrompere immediatamente tutti gli output o le azioni in corso. Questa \xe8 una funzione di sicurezza o di comodit\xe0 per interrompere qualsiasi processo. Lo faremo automaticamente per te quando chiudi o metti in pausa i controlli della telecamera o del microfono.","example":"Pronunciare \\"Stop\\" per interrompere tutte le uscite.","label":"Arrestare tutte le uscite e rilasciare i tasti"},"custom":{"title":"Costume"},"options":{"moveUp":"Spostarsi verso l\'alto","moveDown":"Sposta gi\xf9","moveLeft":"Spostati a sinistra","moveRight":"Spostati a destra","copyStep":"Copia passaggio","removeStep":"Rimuovi passaggio"},"directions":{"up":"Su","down":"Gi\xf9","left":"Sinistra","right":"Giusto"}},"expression":{"title":"Espressione del viso","titlePlural":"Espressioni del viso","label":"Espressione / Gesto","start":"Avvia i controlli di espressione","startSmiling":{"title":"Inizia a sorridere","description":"Se inizi a non sorridere e poi inizi a sorridere, questo controllo si attiver\xe0. Nota: usare questo controllo negli stessi controlli dell\'app del controllo Apri/chiudi bocca potrebbe causare conflitti."},"stopSmiling":{"title":"Smettila di sorridere","description":"Se stai sorridendo e poi smetti di sorridere, questo controllo si attiver\xe0. Nota: usare questo controllo negli stessi controlli dell\'app del controllo Apri/chiudi bocca potrebbe causare conflitti."},"eyebrows":{"title":"Alza le sopracciglia","description":"Se sollevi entrambe le sopracciglia dalla posizione di riposo di base, questo controllo si attiver\xe0."},"openMouth":{"title":"Bocca aperta","description":"Se la tua bocca \xe8 chiusa (o se la tua linea di base \xe8 leggermente aperta) e apri di pi\xf9 la bocca, questo controllo si attiver\xe0. Nota: usare questo controllo negli stessi controlli dell\'app del controllo del sorriso potrebbe causare conflitti."},"closeMouth":{"title":"Chiudi la bocca","description":"Se la tua bocca \xe8 aperta e la chiudi completamente, questo controllo si attiver\xe0. Nota: usare questo controllo negli stessi controlli dell\'app del controllo del sorriso potrebbe causare conflitti."},"description":"Arricchisci la tua esperienza digitale con le espressioni facciali. Usa gesti come alzare le sopracciglia, sorridere e altri movimenti per controllare senza problemi il puntatore del mouse, eseguire azioni o personalizzare le tue interazioni."},"head":{"title":"Movimento della testa","titlePlural":"Movimenti della testa","label":"Movimento della testa/corpo","question":"Che tipo di movimento vuoi utilizzare?","tilt":{"title":"Inclinazione della testa","left":{"title":"Inclina la testa a sinistra","description":"Se si guarda la telecamera e si inclina la testa verso sinistra, questo controllo si attiver\xe0."},"right":{"title":"Inclina la testa a destra","description":"Se si guarda la telecamera e si inclina la testa verso destra, questo controllo si attiver\xe0."},"back":{"title":"Inclinare la testa all\'indietro","description":"Se si guarda la telecamera e si inclina la testa all\'indietro e si guarda in alto, questo controllo si attiver\xe0."},"forward":{"title":"Inclinare la testa in avanti","description":"Se si guarda la telecamera e si inclina la testa in avanti e si guarda verso il basso, questo controllo si attiver\xe0."},"description":"Inclina la testa verso sinistra o verso destra per un controllo migliore o per navigare con il mouse."},"turn":{"title":"Girare la testa","left":{"title":"Girare la testa a sinistra","description":"Se stai guardando la telecamera e giri la testa guardando verso sinistra, questo controllo si attiver\xe0."},"right":{"title":"Girare la testa a destra","description":"Se stai guardando la telecamera e giri la testa guardando verso destra, questo controllo si attiver\xe0."},"description":"Ruota la testa verso sinistra o verso destra per un controllo migliore o per navigare con il mouse."},"lean":{"title":"Testa inclinata","left":{"title":"Testa inclinata a sinistra","description":"Se stai guardando la telecamera e ti pieghi verso sinistra in modo che il tuo viso sia pi\xf9 a sinistra nell\'inquadratura, questo controllo si attiver\xe0."},"right":{"title":"Testa inclinata a destra","description":"Se stai guardando la telecamera e ti sporgi verso destra in modo che il tuo viso sia pi\xf9 a destra nell\'inquadratura, questo controllo si attiver\xe0."},"back":{"title":"Appoggia la testa all\'indietro","description":"Se stai guardando la telecamera e ti sporgi all\'indietro in modo che il tuo viso sia pi\xf9 lontano dalla telecamera, questo controllo si attiver\xe0."},"forward":{"title":"Piegare la testa in avanti","description":"Se stai guardando la telecamera e ti sporgi in avanti in modo che il tuo viso sia pi\xf9 vicino alla telecamera, questo controllo si attiver\xe0."},"up":{"title":"Muovi il corpo verso l\'alto","description":"Se stai guardando la telecamera e muovi la testa verso l\'alto allungando il collo o muovendo tutto il corpo verso l\'alto, questo controllo si attiver\xe0."},"down":{"title":"Sposta il corpo verso il basso","description":"Se stai guardando la telecamera e muovi la testa verso il basso, contraendo il collo, abbassandoti o abbassando tutto il corpo, questo controllo si attiver\xe0."},"center":{"title":"Centra la tua testa","description":"Se si guarda la telecamera e si riporta la testa nella posizione centrale, in corrispondenza della linea di base, questo controllo verr\xe0 attivato."},"description":"Inclina la testa verso sinistra o verso destra per un controllo migliore o per navigare con il mouse."},"description":"Controlla il tuo dispositivo o la tua connessione con movimenti della testa come inclinare, annuire o ruotare. Utilizzando la fotocamera del tuo dispositivo, Cephable garantisce un\'esperienza privata e intuitiva per un controllo avanzato o la navigazione tramite mouse."},"voice":{"title":"Controllo vocale","titlePlural":"Comandi vocali","placeholder":"La voce o la frase che Cephable ascolter\xe0","question":"Quale affermazione o frase vuoi dire per questo controllo?","when":"Quando dico...","say":"D\xec \'{{value}}\'","load":{"fail":{"title":"{{language}} Controlli vocali non disponibili","description":"Oh no! Non siamo riusciti a caricare {{language}} per i comandi vocali. Controlla la tua connessione Internet e riprova. Utilizzeremo l\'inglese (Stati Uniti) finch\xe9 la connessione non verr\xe0 ripristinata."}},"description":"L\'attivazione del microfono sblocca comandi vocali intelligenti e naturali, consentendo agli utenti di interagire senza problemi con il proprio computer attraverso applicazioni e software. \xc8 possibile parlare in modo naturale per eseguire comandi o dettare testo, creando un\'esperienza intuitiva e senza sforzo."},"motion":{"title":"Controllo del movimento","titlePlural":"Controlli di movimento","question":"Che tipo di movimento vuoi utilizzare con un telefono o un tablet?","start":"Avvia i controlli di movimento","settings":"Impostazioni di movimento","descriptionShort":"Inclina, ruota o agita il dispositivo per controllare Cephable.","description":"I controlli di movimento ti consentono di trasformare il movimento del tuo telefono o tablet nella Companion App in controlli per il tuo dispositivo. Inclina o scuoti il telefono in diverse direzioni per creare nuovi output.","up":{"title":"Inclina il tuo dispositivo verso l\'alto","description":"Se il dispositivo \xe8 appoggiato su una superficie e lo si inclina verso l\'alto, questo controllo si attiver\xe0."},"down":{"title":"Inclina il tuo dispositivo verso il basso","description":"Se il dispositivo \xe8 appoggiato su una superficie e lo si inclina verso il basso in modo che sia rivolto lontano da s\xe9, questo controllo si attiver\xe0."},"left":{"title":"Inclina il tuo dispositivo verso sinistra","description":"Se il dispositivo \xe8 appoggiato su una superficie piana e lo si inclina verso sinistra, questo controllo si attiver\xe0."},"right":{"title":"Inclina il tuo dispositivo verso destra","description":"Se il dispositivo \xe8 appoggiato su una superficie piana e lo si inclina verso destra, questo controllo si attiver\xe0."},"shake":{"title":"Scuoti il tuo dispositivo","description":"Se scuoti il dispositivo, questo controllo si attiver\xe0."},"edit":{"title":"Modifica impostazioni movimento","description":"Modifica le impostazioni del controllo del movimento per stabilire quanto devi muovere il telefono durante la corsa nell\'app complementare","sensitivity":{"title":"Impostazioni di sensibilit\xe0 del controllo del movimento","description":"La sensibilit\xe0 indica a Cephable quanto devi inclinare il tuo dispositivo per attivare un controllo. Maggiore \xe8 il valore (pi\xf9 a destra sul cursore), maggiore \xe8 la sensibilit\xe0 e quindi meno devi inclinare per attivare il controllo."},"tilt":{"title":"Sensibilit\xe0 all\'inclinazione","description":"Questi valori determinano quanto \xe8 necessario inclinare il dispositivo verso l\'alto, verso il basso, verso sinistra e verso destra affinch\xe9 un input venga riconosciuto."},"mouse":{"title":"Controlli di movimento per il movimento del mouse","description":"Determina se e come desideri utilizzare i controlli di movimento per muovere il mouse invece di attivare i controlli","enable":{"title":"Abilita i controlli di movimento per il movimento del mouse","description":"Se questa opzione \xe8 attivata, per muovere il mouse verranno utilizzati alcuni dei controlli di movimento anzich\xe9 i controlli di attivazione.","option":"Utilizzare i controlli di movimento per il movimento del mouse?"},"invert":{"title":"Inverti il movimento del mouse","description":"Per l\'asse X: se \xe8 attivato, spostando il mouse a sinistra si sposter\xe0 a destra e spostando il mouse a destra si sposter\xe0 a sinistra. Per l\'asse Y: se \xe8 attivato, spostando il mouse in basso si sposter\xe0 in alto e spostando il mouse in alto si sposter\xe0 in basso.","x":"Invertire il movimento del mouse sull\'asse X?","y":"Invertire il movimento del mouse sull\'asse Y?"}}}},"keys":{"title":"Tasto o pulsante","titlePlural":"Tasti o pulsanti","label":"Tasto/pulsante esterno","question":"Quale tasto o pulsante vuoi premere?","edit":"Modifica tasti e pulsanti","defaultOption":"Includere comandi vocali predefiniti per i tasti e i clic del mouse?","description":"I tasti e i pulsanti consentono di associare i diversi controlli di input alle pressioni dei pulsanti della tastiera e del controller.","then":"Cephable premer\xe0...","empty":"Non ci sono controlli chiave che corrispondono a questi criteri.","backspace":"Indietro","delete":"Eliminare","enter":"Entrare","space":"Barra spaziatrice","tab":"Scheda","shift":"Spostare","ctrl":"Ctrl","leftCtrl":"Ctrl sinistro","rightCtrl":"Ctrl destro","leftShift":"Spostamento a sinistra","rightShift":"Spostamento a destra","alt":"Tutto","leftAlt":"Alt sinistro","escape":"Fuga","up":"Freccia su","down":"Freccia gi\xf9","left":"Freccia sinistra","right":"Freccia a destra","command":"Comando","caps":"Blocco maiuscole","reset":{"title":"Reimposta le associazioni dei tasti","confirm":"Ripristinare tutte le associazioni dei tasti?","confirmDescription":"Scegli come ripristinare le associazioni dei tasti. Questa azione non pu\xf2 essere annullata senza salvare.","confirmButton":"Reimposta le associazioni dei tasti","defaultOption":"Ripristina i valori predefiniti per la lingua corrente","emptyOption":"Ripristina a vuoto (cancella tutti i comandi)"}},"talkback":{"title":"Risposta","question":"Cosa vuoi che dica Cephable?","description":"Imposta i controlli che faranno parlare Cephable per te. Puoi assegnare i controlli alle diverse frasi che vuoi che vengano pronunciate.","thenMacro":"allora Cefabile dir\xe0...","empty":"Non ci sono controlli Talkback che corrispondono a questi criteri.","add":"Aggiungi un nuovo controllo Talkback","remove":"Rimuovi controllo Talkback","edit":"Modifica controlli Talkback","deprecatedNotice":"Talkback \xe8 ora integrato direttamente nei controlli app primari. I controlli app hanno alcuni eventi talkback pi\xf9 vecchi che devono essere aggiornati."},"dictation":{"title":"Dettatura","question":"Quale frase dovrebbe attivare la modalit\xe0 dettatura?","thenMacro":"Cephable...","empty":"Non ci sono controlli di dettatura che corrispondono a questi criteri.","type":"tipo","edit":"Modifica frasi di dettatura","remove":"Rimuovi frase dettatura","add":"Aggiungi una nuova frase di dettatura","on":"Dettatura","off":"Comandi","onboarding":{"tourLabel":"Dettatura","learn":"Scopri come usare la modalit\xe0 dettatura per convertire i tuoi discorsi in testo senza usare le mani.","welcome":{"title":"Dettatura","description":"La dettatura ti permette di parlare in modo naturale e di sentire le parole digitate mentre parli. \xc8 come avere un assistente personale che digita tutto quello che dici."},"microphone":{"title":"Accendi il microfono","description":"Per prima cosa, accendi il microfono. Fai clic sull\'interruttore del microfono nel pannello Cephable."},"activate":{"title":"Avvia la modalit\xe0 di dettatura","description":"La voce si avvia in modalit\xe0 comando. Per avviare la dettatura, pronuncia \\"Avvia dettatura\\" o fai clic sul pulsante Dettatura. Attiviamo ora la modalit\xe0 dettatura."},"speaking":{"title":"Fai clic su un documento o un campo e inizia a parlare","description":"La dettatura trascriver\xe0 in tempo reale ci\xf2 che dici. Fai clic su un campo di testo o un documento e inizia a parlare. Ad esempio, pronuncia: \\"Ecco come usare la modalit\xe0 dettatura\\"."},"pauseResume":{"title":"Mettere in pausa la dettatura","description":"Hai bisogno di una pausa senza disattivare la dettatura? Basta dire \\"Metti in pausa la dettatura\\". Puoi riprendere la dettatura in qualsiasi momento premendo di nuovo \\"Avvia dettatura\\". Puoi personalizzare ulteriormente questa funzione con i controlli globali e del dispositivo sempre attivi."},"stop":{"title":"Interruzione della dettatura","description":"Devi tornare ai controlli dell\'app? Basta dire \\"Interrompi dettatura\\". Questo interromper\xe0 la modalit\xe0 dettatura e ti riporter\xe0 alla modalit\xe0 comando. Puoi riprendere in qualsiasi momento premendo nuovamente \\"Avvia dettatura\\"."},"complete":{"title":"Congratulazioni!","description":"Ecco fatto! Ora puoi dettare, mettere in pausa, riprendere e passare dalla modalit\xe0 dettatura a quella di comando. La dettatura \xe8 un potente strumento per la digitazione a mani libere. Usala per scrivere email, documenti o qualsiasi altra cosa tu debba digitare ad alta voce."}},"description":"La dettatura ti permette di parlare in modo naturale e di sentire le parole digitate mentre parli. \xc8 come avere un assistente personale che digita tutto quello che dici."},"face":{"title":"Espressione del viso","titlePlural":"Espressioni del viso","try":"Prova i controlli delle espressioni facciali","question":"Che tipo di espressione facciale vuoi usare?","descriptionShort":"Per controlli pi\xf9 efficaci, utilizza diversi movimenti del viso.","description":"Le espressioni facciali fanno parte dei Controlli Espressione. Ti permettono di usare diversi movimenti del viso per controlli avanzati. Puoi usare il movimento delle sopracciglia, della bocca e altro ancora per creare output diversi."},"other":{"title":"Altro","titlePlural":"Altri controlli","label":"Altro controllo","placeholder":"altro comando sperimentale","question":"Quale comando aggiuntivo desideri utilizzare? Questi comandi sono in genere per connessioni non Cephable che non rientrano in altre categorie. Possono anche funzionare come comandi vocali quando pronunci la parola o la frase specificata. Nota: questi controlli sono sperimentali e potrebbero non essere completamente supportati.","description":"Altri controlli sono sperimentali e potrebbero non essere completamente supportati. Possono essere utilizzati per connessioni non Cephable o come comandi vocali quando si pronuncia la parola o la frase specificata."},"support":{"title":"Supporto","profiles":"Introduzione ai controlli delle app","question":"Non hai ancora trovato quello che ti serve?","more":"Scopri di pi\xf9 su Cephable.com con guide dettagliate, tutorial, video e altro ancora."},"community":{"title":"Unisciti alla comunit\xe0","description":"Ottieni supporto, condividi idee o diventa membro delle community di Cephable.","discord":"Comunit\xe0 Discord","facebook":"Gruppo Facebook"},"resources":{"title":"Risorse utili","description":"Trova le risposte alle tue domande sulle caratteristiche e le funzioni di Cephable.","guides":"Guide passo dopo passo"},"feedback":{"title":"Feedback","description":"Raccontaci la tua esperienza con Cephable.","contact":"Contattaci","feature":"Suggerisci una funzionalit\xe0","bug":"Segnala un problema"},"settings":{"title":"Impostazioni","general":"Impostazioni generali dell\'app","description":"Questa \xe8 la tua tela su cui personalizzare la tua esperienza, perfezionando i tuoi controlli.","orgTitle":"Impostazioni di {{value}}"},"account":{"title":"Account","menu":"Menu utente","settings":"Impostazioni dell\'account","description":"Aggiorna le informazioni chiave per rimanere in contatto con Cephable.","usernameLabel":"Nome utente:","emailLabel":"E-mail:","password":{"change":"Cambiare la password","description":"Aggiorna la tua password per proteggere il tuo account.","old":"Vecchia password","current":"La tua password attuale","new":"Nuova password","desired":"La nuova password desiderata","confirm":"Conferma la nuova password","update":"Aggiorna password"},"isEmailVerified":{"title":"L\'email non \xe8 verificata.","description":"La tua email non \xe8 verificata. Controlla la tua email per un link di verifica.","resend":"Invia di nuovo l\'email","success":"Ti abbiamo inviato una nuova email di verifica.","error":"Si \xe8 verificato un errore durante l\'invio dell\'email di verifica. Riprova pi\xf9 tardi.","org":"Il tuo indirizzo email non \xe8 verificato. \xc8 necessario per accedere ai dettagli della licenza. Controlla la tua email per un link di verifica.","titleAlt":"Verifica il tuo indirizzo email","descriptionLong":"Benvenuto su Cephable! Un\'email di verifica \xe8 stata inviata a {{email}}. Controlla la posta in arrivo o la cartella spam e clicca sul link. Se non lo vedi, puoi inviare nuovamente l\'email di verifica.","appBlock":"Ci sei quasi! Un\'email di verifica \xe8 stata inviata a {{email}}. Controlla la tua posta in arrivo e clicca sul link per verificare il tuo indirizzo email. Se non lo vedi, controlla la cartella spam."},"signout":{"title":"Disconnessione","question":"Sei sicuro di voler uscire?","confirm":"S\xec, esci","warn":{"title":"Stai per uscire.","description":"Sembra che tu sia stato inattivo per un po\'. Per motivi di sicurezza, ti disconnetteremo tra XX secondi. Se vuoi rimanere connesso, clicca su \\"Resta connesso\\" qui sotto.","confirm":"Rimani connesso","cancel":"Esci ora"},"description":"Una volta effettuata la disconnessione, questa connessione verr\xe0 rimossa dal tuo account e non sar\xe0 pi\xf9 visibile dall\'app complementare o da altre connessioni.","confirmDescription":"Ti disconnettiamo e rimuoviamo questa connessione"},"marketing":{"title":"Preferenze e-mail","description":"Aggiorna le tue preferenze e-mail per ricevere aggiornamenti e novit\xe0 da Cephable.","marketing":"Email di marketing","optIn":"Vorrei ricevere tutorial, suggerimenti, aggiornamenti e newsletter per migliorare la mia esperienza con Cephable"},"error":{"save":"Errore durante il salvataggio delle impostazioni dell\'account.","password":"Errore durante l\'aggiornamento della password.","signout":"Errore durante la disconnessione.","old":"\xc8 richiesta la vecchia password.","new":"\xc8 richiesta una nuova password.","match":"Le password non corrispondono.","marketing":"Errore durante l\'aggiornamento delle preferenze e-mail.","userPreferences":"Errore durante il salvataggio delle preferenze utente."},"success":{"save":"Impostazioni account salvate.","password":"Password aggiornata.","marketing":"Preferenze e-mail aggiornate.","userPreferences":"Preferenze utente aggiornate."},"userPreferences":{"title":"Preferenze utente","description":"Aggiorna le tue preferenze per creare l\'esperienza Cephable pi\xf9 adatta a te.","warningOptOut":"Nascondi gli avvisi quando salvo o aggiorno i controlli dell\'app","enableTranscribeTask":"Abilita l\'attivit\xe0 di trascrizione del file sperimentale nel pannello Cephable","enableClickByName":"SOLO Windows. Abilita la modalit\xe0 sperimentale \\"Tocca\\" qualcosa sullo schermo in base al nome, ad esempio \\"tocca salva\\" per fare clic su un pulsante denominato \\"salva\\"","enableGamepadSupport":"Abilita il supporto del gamepad per il driver locale e l\'emulazione del controller Xbox","enableMetrics":"Abilita l\'output delle metriche di utilizzo per i test delle prestazioni. Potrai scaricare i log dal pannello Cephable."},"delete":{"title":"Elimina account","description":"Puoi eliminare definitivamente il tuo account e rimuovere ogni riferimento alle tue informazioni personali. Quando elimini il tuo account, le tue connessioni verranno rimosse e non funzioneranno pi\xf9 n\xe9 saranno pi\xf9 registrate sul tuo account; i controlli dell\'app e tutte le impostazioni andranno persi. Questa procedura non pu\xf2 essere annullata.","button":"Elimina definitivamente l\'account","confirmation":"Sei sicuro di voler eliminare il tuo account?","note":"Questa azione \xe8 irreversibile.","confirm":"S\xec, elimina il mio account"}},"appSettings":{"description":"Queste impostazioni si applicano solo a questa app. Se vuoi modificare le impostazioni dell\'app Cephable su un altro computer o dispositivo mobile, modifica le impostazioni in quell\'app.","autostart":{"title":"Avvia automaticamente Cephable","description":"Con questa impostazione attivata, l\'app Cephable si avvier\xe0 automaticamente quando effettui l\'accesso al tuo dispositivo. Se hai anche controlli vocali ed espressivi automatici, anche questi si avvieranno subito.","question":"Avvio automatico dell\'app Cephable?"},"position":{"topLeft":"In alto a sinistra","top":"Centro superiore","topRight":"In alto a destra","bottom":"Centro in basso","bottomLeft":"In basso a sinistra","bottomRight":"In basso a destra","label":"Seleziona la posizione di avanzamento dei comandi","description":"Seleziona dove desideri che il feed dei comandi appaia sullo schermo."},"micPosition":{"title":"Posizione della finestra di input del microfono","description":"Seleziona la posizione sullo schermo in cui desideri posizionare i controlli del microfono per la voce e la dettatura.","label":"Seleziona la posizione della finestra di input del microfono"},"cameraPosition":{"title":"Posizione della finestra di input della telecamera","description":"Seleziona dove desideri posizionare sullo schermo i controlli della telecamera per il movimento del viso e della testa.","label":"Seleziona la posizione della finestra di input della telecamera"},"theme":{"title":"Tema","description":"Scegli un tema adatto al tuo stile.","label":"Seleziona un tema","light":"Leggero","dark":"Buio","system":"Utilizzare le impostazioni di sistema del sistema operativo"},"overlay":{"title":"Feed di comando","description":"Il feed di comando mostrer\xe0 i diversi controlli che usi e quali controlli sono stati inviati al tuo computer. \xc8 click-through ma sar\xe0 sempre in cima alle altre finestre. Con questa impostazione attivata, l\'app Cephable mostrer\xe0 e sar\xe0 sempre in cima alle altre finestre e applicazioni.","question":"Mostrare il feed dei comandi?"},"transparent":{"title":"Trasparenza del feed dei comandi","description":"Determina l\'opacit\xe0 del testo. Pi\xf9 basso \xe8 il valore, pi\xf9 trasparente sar\xe0 il feed."},"panelAutoHide":{"title":"Pannello Cephable con Nascondimento Automatico","delay":"Ritardo prima di nascondersi","denominator":"secondi","time":"{{value}} secondi"},"title":"Impostazioni generali dell\'app"},"input":{"title":"Ingresso","titlePlural":"Controlli di input","explore":"Esplora i controlli di input","descriptionShort":"Esplora i vari controlli di input che Cephable utilizza per creare un\'esperienza digitale migliore per te.","typeLabel":"Tipo di controllo di input","toolTip":"Questo utilizza {{alt}}","remove":"Rimuovi controllo input","filter":"Filtra per tipo di input","select":"Seleziona un input","question":"Che tipo di input vuoi utilizzare?","add":"Aggiungi input","addMore":"Aggiungi un altro input","removeItem":"Rimuovi elemento {{index}}","item":"Elemento {{index}}: {{label}}","duplicate":"Non sono ammessi elementi duplicati.","maximum":"Sono consentiti al massimo {{maxItems}} articoli.","description":"I controlli di input sono i diversi metodi utilizzati per controllare il dispositivo, come la voce, i movimenti della testa, le espressioni facciali e altre connessioni. Esplora i diversi controlli di input qui sotto per saperne di pi\xf9."},"time":{"soon":"Prossimamente","now":"Ora","today":"Oggi","yesterday":"Ieri","minutesAgo":"{{count}} minuto fa","minutesAgo_plural":"{{count}} minuti fa","daysAgo":"{{count}} giorni fa","daysAgo_plural":"{{count}} giorni fa","monthsAgo":"{{count}} mese fa","monthsAgo_plural":"{{count}} mesi fa","yearsAgo":"{{count}} anno fa","yearsAgo_plural":"{{count}} anni fa","minutesAhead":"in {{count}} minuti","todayAhead":"pi\xf9 tardi oggi","tomorrow":"Domani","daysAhead":"tra {{count}} giorni","monthsAhead":"tra {{count}} mesi","yearsAhead":"in {{count}} anni"},"peripherals":{"empty":"Nessuna periferica rilevata","switch":"Interruttore","keyboard":"Tastiera","gamepad":"Controllo dei giochi","companionApp":"App complementare","available":"Disponibile per l\'uso","error":"Controlla le tue impostazioni."},"camera":{"windowTitle":"Controlli della fotocamera Cephable","title":"Telecamera","titlePlural":"Telecamere","settings":"Impostazioni della fotocamera","start":"Avvia la fotocamera","restart":"Riavvia la fotocamera","descriptionShort":"Permette l\'espressione del viso e il movimento della testa.","description":"Utilizza la fotocamera per rilevare le espressioni del viso e i gesti del corpo come controlli diversi.","empty":"Nessuna telecamera trovata.","search":"Cerca per nome della telecamera","loading":"Caricamento dei controlli della telecamera...","error":"Errore imprevisto durante il caricamento dei controlli della fotocamera. Controlla la tua fotocamera e riprova.","manage":{"title":"Fai clic per visualizzare e gestire i dettagli delle tue telecamere.","description":""},"detected":{"face":"Volto rilevato.","noFace":"Nessun volto rilevato. Regola la telecamera o la posizione e riprova.","command":"Rilevato: {{command}}"},"permission":{"title":"Autorizzazioni della fotocamera richieste","description":"Devi autorizzare Cephable a utilizzare la tua fotocamera per usare i controlli del viso e del corpo.","button":"Apri Impostazioni Permessi","no":"Nessun accesso alla telecamera","help":"Cephable ha bisogno di accedere alla tua fotocamera per usare i controlli di espressione e della testa. Vai su <strong>Impostazioni di sistema</strong>  <strong>Privacy</strong>  <strong>Fotocamera</strong> e abilita Cephable per accedere alla tua fotocamera."},"controls":{"startData":"Registrazione dei dati del viso avviata. Premi di nuovo la scorciatoia mentre sei nella finestra della fotocamera per interrompere la registrazione e scaricare.","downloadData":"Registrazione interrotta, download dei dati","paused":"Controlli della telecamera in pausa.","pause":"Pausa controlli telecamera","resume":"Riprendi i controlli della telecamera","resumed":"Ripristino dei controlli della telecamera.","linesOn":"Attiva le linee del viso","linesOff":"Disattiva le linee del viso","linesToggle":"Attiva/disattiva il disegno delle linee del viso","noDeviceTitle":"Nessuna telecamera rilevata che possa essere utilizzata con Cephable.","noDeviceDescription":"\xc8 necessario collegare una fotocamera compatibile con le app mobili.","noDeviceConnectedDescription":"Il controllo della telecamera serve come anteprima dell\'interfaccia. Nessun passaggio verr\xe0 eseguito correttamente. Collega questo dispositivo companion a un altro, per avviare i comandi.","lines":"Linee del viso"},"switch":{"title":"Cambia telecamera","description":"Seleziona una telecamera diversa da utilizzare per i controlli del viso e del corpo.","select":"Seleziona la fotocamera","next":"Prossima telecamera","nextLong":"Passa alla telecamera successiva","empty":"Non sono state trovate altre telecamere.","search":"Cerca per nome della telecamera"},"baseline":{"title":"Linea di base","description":"La linea di base \xe8 la posizione predefinita del tuo viso e del tuo corpo che Cephable usa per determinare i tuoi movimenti. Puoi aggiornare e reimpostare la linea di base qui.","update":"Aggiorna la linea di base","reset":"Ripristina linea di base","updated":"Baseline aggiornata","tooltip":"Fai clic per aggiornare la tua linea di base alla tua posizione di riposo attuale."},"edit":{"title":"Modifica impostazioni fotocamera","description":"Puoi perfezionare le impostazioni per gli input che richiedono una telecamera, in modo che si adattino meglio alle tue esigenze.","autoStart":{"title":"Avvia automaticamente la fotocamera","option":"Avvio automatico della telecamera e dei controlli della testa/espressione?","description":"Con questa impostazione attivata, il controller avvier\xe0 la fotocamera, consentendoti di utilizzare le espressioni facciali e i controlli dei movimenti della testa non appena l\'app si avvia. Se questa impostazione \xe8 disattivata, devi toccare il pulsante \\"Avvia fotocamera\\" nella pagina di connessione."},"head":{"title":"Sensibilit\xe0 al movimento della testa","description":"La sensibilit\xe0 indica a Cephable quanto lontano devi muoverti per attivare un controllo. Maggiore \xe8 il valore (pi\xf9 a destra sullo slider), maggiore \xe8 la sensibilit\xe0 e quindi meno devi muoverti per attivare il controllo.","tilt":{"title":"Sensibilit\xe0 all\'inclinazione della testa","description":"Questi valori determinano quanto \xe8 necessario inclinare la testa verso l\'alto, verso il basso, verso sinistra e verso destra per attivare i controlli","up":"Sensibilit\xe0 inclinazione verso l\'alto","down":"Sensibilit\xe0 inclinazione verso il basso","left":"Sensibilit\xe0 inclinazione a sinistra","right":"Sensibilit\xe0 inclinazione a destra","scaleHigh":"Leggera inclinazione","scaleLow":"Grande inclinazione"},"turn":{"title":"Sensibilit\xe0 alla rotazione della testa","description":"Questi valori determinano quanto \xe8 necessario girare la testa a sinistra e a destra per attivare i controlli","left":"Sensibilit\xe0 svolta a sinistra","right":"Sensibilit\xe0 di svolta a destra","scaleHigh":"Leggera svolta","scaleLow":"Grande svolta"},"lean":{"title":"Sensibilit\xe0 all\'inclinazione della testa","description":"Questi valori determinano quanto \xe8 necessario inclinare la testa in avanti e indietro per attivare i controlli","forward":"Sensibilit\xe0 di inclinazione in avanti","back":"Sensibilit\xe0 di appoggio","right":"Sensibilit\xe0 di inclinazione a destra","left":"Sensibilit\xe0 inclinata a sinistra","scaleHigh":"Leggera inclinazione","scaleLow":"Grande magro"},"duck":{"title":"Sensibilit\xe0 di inclinazione/salita della testa","description":"Questi valori determinano quanto \xe8 necessario abbassare o alzare la testa per attivare i controlli","down":"Sensibilit\xe0 al piumino d\'anatra","up":"Aumenta la sensibilit\xe0","scaleHigh":"Leggero spostamento","scaleLow":"Grande spostamento"}},"face":{"title":"Sensibilit\xe0 all\'espressione del viso","description":"La sensibilit\xe0 indica a Cephable quanto esagerata deve essere l\'espressione per attivare un controllo. Maggiore \xe8 il valore (pi\xf9 a destra sullo slider), maggiore \xe8 la sensibilit\xe0 e quindi meno \xe8 necessario muoversi per attivare il controllo.","eyebrow":{"title":"Sensibilit\xe0 delle sopracciglia","description":"Questi valori determinano quanto \xe8 necessario alzare o abbassare le sopracciglia per attivare i controlli","up":"Aumenta la sensibilit\xe0 delle sopracciglia","scaleHigh":"Lieve aumento","scaleLow":"Grande aumento"},"mouth":{"title":"Sensibilit\xe0 della bocca","description":"Questi valori determinano quanto \xe8 necessario aprire o chiudere la bocca per attivare i controlli","open":"Sensibilit\xe0 della bocca aperta","close":"Sensibilit\xe0 della bocca chiusa","smile":"Sensibilit\xe0 al sorriso","scaleHigh":"Leggermente aperto","scaleLow":"Grande Aperto","closeScaleHigh":"Leggermente Chiuso","closeScaleLow":"Ben chiuso","smileScaleHigh":"Un leggero sorriso","smileScaleLow":"Grande sorriso"}},"mouse":{"title":"Movimento della testa per i controlli del mouse","description":"Determina se e come desideri utilizzare i controlli dei movimenti della testa per muovere il mouse invece di attivare altri output.","enable":{"title":"Abilita il movimento della testa per i controlli del mouse","description":"Se questa opzione \xe8 attivata, per muovere il mouse verranno utilizzati alcuni controlli dei movimenti della testa anzich\xe9 i controlli dei trigger.","option":"Utilizzare i controlli della testa per il movimento del mouse?"},"input":{"title":"Tipo di input del mouse","description":"Seleziona il tipo di gesti della testa che vuoi assegnare ai controlli del mouse. Ad esempio, Inclinazione della testa significa che puoi inclinare la testa a sinistra e a destra per muovere il mouse a sinistra e a destra, Rotazione della testa significa che puoi girare la testa a sinistra e a destra per muovere il mouse e Inclinazione della testa significa che puoi inclinarti a sinistra e a destra per muovere il mouse.","option":"Seleziona il tipo di input","optionLong":"Seleziona il tipo di movimento della testa che desideri utilizzare per controllare il mouse."},"invert":{"title":"Inverti il movimento del mouse","description":"Se \xe8 attivato, la direzione in cui muovi la testa sar\xe0 invertita rispetto alla direzione in cui si muove il mouse. Per l\'asse X: se \xe8 attivato, spostandoti a sinistra sposterai il mouse a destra e spostandoti a destra lo sposterai a sinistra. Per l\'asse Y: se \xe8 attivato, spostandoti verso il basso sposterai il mouse verso l\'alto e spostandoti verso l\'alto lo sposterai verso il basso.","x":"Invertire il movimento del mouse sull\'asse X?","y":"Invertire il movimento del mouse sull\'asse Y?"},"mode":{"title":"Modalit\xe0 di spostamento del mouse","description":"Seleziona il modo in cui desideri che il cursore reagisca ai movimenti della testa."},"speed":{"title":"Velocit\xe0 del mouse","description":"Determina la velocit\xe0 costante a cui vuoi che si muova il cursore.","fast":"Veloce","slow":"Lento"},"linear":{"title":"Movimento lineare del mouse","description":"Se questa opzione \xe8 attivata, il cursore si muove solo lungo linee rette orizzontali o verticali, facilitando la navigazione in quelle specifiche direzioni senza alcuno spostamento diagonale.","option":"Utilizzare il movimento lineare del mouse?"},"accelerationRate":{"title":"Ritardo di risposta all\'accelerazione del mouse","description":"Numero di millisecondi necessari affinch\xe9 la velocit\xe0 del mouse aumenti."},"accelerationCurve":{"title":"Curva di accelerazione del mouse","description":"Regola la velocit\xe0 con cui la velocit\xe0 del cursore aumenta in relazione al movimento della testa.","linear":"Lineare","exponential":"Esponenziale","sublinear":"Sub-lineare"},"maximumSpeed":{"title":"Velocit\xe0 massima del mouse","description":"Determina il numero massimo di pixel che il cursore pu\xf2 spostare al secondo."},"off":{"title":"Spento","description":"Il movimento del mouse \xe8 disabilitato."},"steadyGlide":{"title":"Scivolata costante","description":"Quando si muove la testa oltre un certo punto, il cursore scivola continuamente in quella direzione a velocit\xe0 costante."},"speedBoost":{"title":"Aumento della velocit\xe0","description":"Il cursore inizia a muoversi pi\xf9 velocemente quanto pi\xf9 a lungo tieni la testa in una posizione. Pi\xf9 a lungo tieni ferma la testa, pi\xf9 velocemente il cursore accelera."},"dynamicGlide":{"title":"Scivolamento dinamico","description":"La velocit\xe0 del cursore aumenta in base a quanto muovi la testa. Pi\xf9 muovi la testa, pi\xf9 velocemente scivola il cursore."},"proportionalSpeed":{"title":"Velocit\xe0 proporzionale","description":"Il cursore segue la punta del tuo naso in modo proporzionale alle dimensioni dello schermo."},"disabled":"Questa funzionalit\xe0 \xe8 disabilitata per le connessioni e le estensioni remote."}},"stop":"Ferma la telecamera","show":"Mostra la telecamera","hide":"Nascondi telecamera","warn":"I controlli della fotocamera non sono stati avviati. Avvia la fotocamera per consentire i controlli del viso e del corpo.","draw":{"error":"Errore durante il caricamento del feed della telecamera. Controlla la telecamera e riprova."},"select":"Seleziona la telecamera che desideri associare per ottenere controlli avanzati tramite riconoscimento facciale, corpo e pulsanti di azione rapida."},"microphone":{"windowTitle":"Comandi vocali Cephable","title":"Microfono","titlePlural":"Microfoni","settings":"Impostazioni del microfono","start":"Avvia microfono","stop":"Ferma il microfono","descriptionShort":"Abilita comandi vocali e dettatura.","description":"Utilizza il microfono integrato per abilitare i comandi vocali e la dettatura.","select":"Seleziona il microfono che desideri associare per ottenere controlli avanzati tramite la voce.","empty":"Nessun microfono trovato.","search":"Cerca per nome del microfono","manage":{"title":"Fai clic per visualizzare e gestire i dettagli dei tuoi microfoni.","description":""},"permission":{"title":"Autorizzazioni microfono richieste","description":"Per utilizzare i comandi vocali, devi autorizzare Cephable a utilizzare il tuo microfono.","button":"Apri Impostazioni Permessi","no":"Nessun accesso al microfono","help":"Cephable ha bisogno di accedere al tuo microfono per usare i comandi vocali. Vai su <strong>Impostazioni di sistema</strong>  <strong>Privacy</strong>  <strong>Microfono</strong> e abilita Cephable per accedere al tuo microfono."},"controls":{"loadingDetail":"Potrebbero volerci alcuni minuti.","pause":"Pausa dei controlli vocali","paused":"Controlli in pausa.","resume":"Riprendi i controlli vocali","dictationPlay":"Avvia la modalit\xe0 di dettatura","dictationPause":"Interrompi modalit\xe0 dettatura","prompt":"Inizia a parlare per vedere i tuoi comandi vocali qui...","dictationPrompt":"Inizia a parlare per digitare ci\xf2 che dici...","latency":"Rilevata latenza elevata. Valuta la possibilit\xe0 di chiudere alcune applicazioni che potrebbero consumare troppe risorse.","noDeviceConnectedDescription":"Il controllo del microfono serve come anteprima dell\'interfaccia. Nessun passaggio verr\xe0 eseguito correttamente. Collega questo dispositivo companion a un altro, per avviare i comandi.","status":{"loadingModel":"Caricamento modello vocale...","paused":"In pausa.","dictating":"Dettare.","optimistic":"Ottimista:","listening":"Ascolto:","thinking":"Pensiero...","loadingPhiModel":"Caricamento del modello di generazione del testo...","generatingText":"Generazione in corso...","preparingPhiModel":"Preparazione del modello di generazione del testo...","permission":"Controllo delle autorizzazioni del microfono...","typing":"Sto scrivendo..."},"generatingTextDetail":"Interrompere la generazione cambiando app o dicendo \\"interrompi generazione\\""},"edit":{"title":"Modifica impostazioni microfono","autoStart":{"title":"Avvia automaticamente il microfono","option":"Avvio automatico del microfono e dei comandi vocali?","description":"Con questa impostazione attivata, il dispositivo di input attiver\xe0 i microfoni e inizier\xe0 a elaborare i comandi vocali all\'avvio, dopo averlo collegato o acceso. Se questa impostazione \xe8 disattivata, \xe8 necessario toccare il pulsante \\"Avvia ascolto\\" nella pagina di connessione."},"optimistic":{"title":"Controlli vocali ottimistici","option":"Utilizzi i comandi vocali ottimistici?","description":"Cephable ha due diverse modalit\xe0 di sensibilit\xe0 per i controlli vocali: Standard e Ottimista. La modalit\xe0 Standard consente a Cephable di riconoscere tutte le parole nella sua comprensione e pu\xf2 essere utilizzata con la modalit\xe0 dettatura. La modalit\xe0 Ottimista indica a Cephable di concentrarsi maggiormente sui controlli vocali nei controlli dell\'app forniti. Con la modalit\xe0 Ottimista attiva, i controlli vocali si attiveranno pi\xf9 rapidamente, ma potresti anche attivare accidentalmente il controllo se non pronunci la parola esatta. La modalit\xe0 Ottimista non consente la dettatura."},"confirm":{"title":"Ci sono modifiche non salvate.","description":"Sono state rilevate modifiche non salvate. Vuoi salvare prima di uscire?"},"aiCommands":{"title":"Comandi vocali intelligenti","description":"I comandi vocali intelligenti consentono a Cephable AI di prevedere i comandi vocali che stai cercando di usare senza dover corrispondere esattamente. Ti consente di dire al tuo computer cosa fare in modo pi\xf9 naturale e Cephable ti aiuta a capirlo.","option":"Utilizzare comandi vocali intelligenti?"},"aiDictation":{"title":"Dettatura intelligente e digitazione rapida","description":"Le funzioni di dettatura intelligente e digitazione rapida offrono l\'esperienza di input sul dispositivo pi\xf9 accurata disponibile. La dettatura gestisce automaticamente punteggiatura, nomi propri e struttura delle frasi, mentre la digitazione rapida fornisce previsioni e correzioni intelligenti che ti aiutano a scrivere con facilit\xe0 e precisione.","option":"Utilizzare la dettatura intelligente e la digitazione rapida?"},"description":"Gestisci i comandi vocali e le impostazioni di dettatura per questa connessione."},"warn":"Il microfono non \xe8 stato avviato. Avviare il microfono per consentire i comandi vocali e la dettatura.","devices":{"error":"Dispositivo di input del microfono non trovato."},"startDescription":"Attiva il microfono per iniziare ad ascoltare i comandi."},"localization":{"title":"Impostazioni della lingua","titleShort":"Lingua","description":"Scegli la lingua preferita dall\'elenco delle lingue supportate.","newUserDescription":"Seleziona la lingua preferita prima di continuare.","edit":"Aggiorna lingua","display":{"title":"Lingua di visualizzazione","description":"Lingua visualizzata quando si usa Cephable. Ci\xf2 include elementi come menu, notifiche e controlli delle app visualizzati nella lingua scelta."},"voice":{"title":"Lingua del controllo vocale","description":"Questa \xe8 la lingua utilizzata per riconoscere dettati e comandi vocali. Specificare la lingua aumenta la precisione degli input vocali.","settings":{"title":"Riconoscimento vocale e lingua di visualizzazione","description":"Regola le impostazioni della lingua per i controlli di visualizzazione e vocali. Questa opzione ti consente di selezionare le lingue preferite per il testo sullo schermo e le interazioni con il microfono, come i controlli vocali e la dettatura."}},"locales":{"en":"English - Inglese","en-us":"English (US) - Inglese (Stati Uniti)","es":"Espa\xf1ol \u2014 Spagnolo","fr":"Fran\xe7ais \u2013 Francese","it":"Italiano","de":"Deutsch - Tedesco","ja":"\u65E5\u672C\u8A9E - Giapponese","en-gb":"English (UK) - Inglese (Regno Unito)","en-in":"English (India) - Inglese (India)"},"save":{"success":"Preferenze locali dell\'utente salvate!","error":"Errore durante il salvataggio delle preferenze locali dell\'utente"},"profile":{"view":"Varianti","title":"Linguaggio di controllo dell\'app","question":"Quale linguaggio di controllo dell\'app desideri modificare?","description":"Alcuni controlli delle app hanno varianti per lingue diverse. Passa a un\'altra lingua per modificare e personalizzare.","change":"Cambia lingua"},"unsupported":{"title":"Lingua non supportata {{locale}}","description":"La lingua selezionata non \xe8 supportata. Scegli una lingua diversa."},"select":"Seleziona la lingua","localesShort":{"en":"Inglese","en-us":"Inglese (Stati Uniti)","es":"spagnolo","fr":"francese","it":"Italiano","de":"tedesco","ja":"giapponese"}},"invalidNumber":"N / A","upgrade":"Aggiornamento","license":{"trial":{"subtitle":"Puoi invitare {{count}} colleghi a provare Cephable insieme a te.","noUsersSubtitle":"Non hai pi\xf9 utenti di prova. Esegui l\'upgrade a una licenza a pagamento per aggiungere altri utenti.","expired":{"user":"L\'aggiornamento gratuito a {{productName}} scade il giorno {{date}}. Per effettuare l\'aggiornamento, contatta l\'amministratore della tua organizzazione - {{admin}}.","admin":"L\'aggiornamento gratuito a {{productName}} scade il {{date}}.","userLong":"Sembra che il tuo upgrade gratuito a {{productName}} sia scaduto. Per effettuare l\'upgrade, contatta l\'amministratore della tua organizzazione - {{admin}}.","adminLong":"Sembra che il tuo aggiornamento gratuito a {{productName}} sia scaduto. Puoi aggiornare la tua licenza per continuare ad accedere alle funzionalit\xe0 avanzate non disponibili in Cephable Basic."},"start":"Inizia una prova gratuita","title":{"single":"Hai effettuato l\'upgrade gratuito a {{productName}} con {{days}} giorni rimanenti","multiple":"{{organization}} \xe8 in prova gratuita con {{days}} giorni rimanenti"},"upgrade":"Eseguendo l\'aggiornamento, potrai continuare ad accedere a funzionalit\xe0 quali controlli vocali avanzati, attivit\xe0 intelligenti basate sull\'intelligenza artificiale e numerosi controlli predefiniti delle app."},"required":{"title":"\xc8 richiesta la licenza professionale Cephable","description":"Sembra che tu stia utilizzando Cephable Basic, che non supporta l\'uso commerciale di Cephable. Aggiorna a una licenza professionale per continuare a utilizzare l\'app."},"upgrade":{"professional":"Aggiornamento alla Licenza Cephable Professional","generic":{"title":"Aggiorna la Tua Esperienza Cephable","description":"La piattaforma Cephable offre diversi prodotti per uso commerciale sul lavoro, a scuola o integrati in soluzioni native."},"fallback":{"title":"Errore durante il caricamento del portale di fatturazione","description":"Impossibile caricare il portale di fatturazione. Clicca sul pulsante qui sotto per contattare sales@cephable.com per continuare con l\'aggiornamento."}},"activate":{"question":"Hai gi\xe0 una chiave di licenza?","button":"Attivare","title":"Attiva la Chiave di Licenza","description":"Inserisci la tua chiave di licenza per aggiornare Cephable. Se non ne hai una, inizia una prova gratuita o acquista una licenza.","fieldLabel":"Chiave di Licenza","placeholder":"NkmurBfZzFrmm9Kx","success":"Congratulazioni. Il tuo account \xe8 stato aggiornato a {{license}}!","invalid":{"key":"Chiave non valida. Assicurati di aver inserito la chiave corretta.","empty":{"key":"Chiave non valida. Assicurati di aver inserito un valore.","name":"Nome dell\'organizzazione non valido. Assicurati di aver inserito un valore."}},"descriptionLong":"Inserisci la tua chiave di licenza per aggiornare Cephable. Se non ne hai una, inizia una prova gratuita o acquista una licenza."},"welcome":{"title":"Benvenuti a {{license}}.","description":"Ti sei unito con successo a {{organization}}. {{description}}"},"redirect":{"title":"Reindirizzamento","description":"Sei stato reindirizzato a un portale di fatturazione esterno. Si aprir\xe0 una nuova scheda nel tuo browser. Se non vieni reindirizzato entro pochi secondi, clicca sul pulsante qui sotto.","error":"Errore di reindirizzamento della fatturazione","external":"Reindirizzamento. Controlla il tuo browser."},"key":{"title":"Chiave di licenza","titlePlural":"Chiavi di licenza","description":"Una chiave di licenza \xe8 un identificatore univoco utilizzato per concedere l\'accesso alle funzionalit\xe0 Cephable Professional, Education o Developer.","details":"Dettagli della chiave di licenza","assigned":"Utilizzato il: {{date}}","expires":"Scade il: {{date}}","assign":"Assegna la chiave alla nuova organizzazione","error":"Errore durante il caricamento della chiave di licenza.","empty":{"title":"Nessuna chiave di licenza trovata.","description":"Sembra che non ci siano chiavi di licenza che corrispondono a questo criterio. Oppure non hai ancora acquistato una chiave di licenza."},"product":{"title":"Acquistare","titleLong":"Acquista chiavi di licenza","description":"Acquista una chiave di licenza per sbloccare il pieno potenziale di Cephable. Visualizza i diversi piani e le opzioni di prezzo disponibili.","action":"Acquista ora","empty":{"title":"Nessun prodotto trovato.","description":"Sembra che tu non abbia alcun prodotto. Contatta il nostro team di vendita o il tuo rappresentante per risolvere il problema."},"yearly":"Fatturato annualmente","years":"Fatturato ogni {{value}} anni","days":"Fatturato ogni {{value}} giorni","Subscription":{"title":"Sottoscrizione"},"MeteredConsumption":{"title":"Consumo misurato"},"PayDown":{"title":"Pagare in anticipo"},"OneTime":{"title":"Una volta"}}},"pro":{"tag":"Professionista","detail":"Questa \xe8 una funzionalit\xe0 esclusiva di Cephable Professional","requiredDetail":"Per questa funzionalit\xe0 \xe8 richiesta una licenza Cephable Professional. Puoi effettuare l\'upgrade o iniziare una prova gratuita nelle Impostazioni account"},"titlePlural":"Licenze"},"purchase":"Acquistare","saveError":"Errore durante il salvataggio delle modifiche.","description":"Descrizione","expand":"Espandere","expandMenu":"Espandi Menu","editor":{"title":"Editor di markdown","bold":"Grassetto","italic":"Corsivo","underline":"Sottolineare","hr":"Regola orizzontale","link":"Collegamento","quote":"Citazione","code":"Codice","codeBlock":"Blocco di codice","comment":"Commento","image":"Immagine","table":"Tavolo","unordered-list":"Elenco non ordinato","ordered-list":"Elenco ordinato","checked-list":"Elenco controllato","help":"Aiuto","edit":"Modificare","live":"Vivere","preview":"Anteprima","fullscreen":"A schermo intero","placeholder":"Inserisci qui il testo Markdown...","strikethrough":"Barrato"},"created":"Creato: {{value}}","updated":"Aggiornato: {{value}}","deleted":"Eliminato: {{value}}","expires":"Scade: {{value}}","expired":"Scaduto: {{value}}","used":"Utilizzato: {{value}}","results":"Risultati","panel":{"title":"Pannello Cefabile","question":"Pannello di avvio automatico?","position":{"top":"Superiore","right":"Giusto","left":"Sinistra","bottom":"Metter il fondo a ","description":"Seleziona dove desideri che il pannello Cephable venga visualizzato sullo schermo.","label":"Posizione"},"sections":{"description":"Scegli quali sezioni del pannello rendere visibili. Puoi nascondere le sezioni in base alle tue preferenze per sfruttare al meglio lo spazio del pannello.","microphone":"Microfono e controlli vocali","camera":"Controlli della telecamera e del viso/testa","profile":"Controlli e anteprime delle app","globalControls":"Controlli globali e del dispositivo","tasks":"Compiti intelligenti","buttons":"Pulsanti di azione rapida"},"titleShort":"Pannello","description":"Questo \xe8 il pannello che rappresenta il centro di controllo principale. \xc8 sempre visibile e ti consente di controllare le tue app tramite comandi vocali, e altro ancora."},"resume":"Riprendere","textGeneration":{"settings":"Impostazioni di generazione del testo","edit":{"title":"Modifica impostazioni generazione testo","description":"Puoi perfezionare le impostazioni della Generazione intelligente di testo per ottenere gli output migliori per te.","autoStart":{"title":"Generazione automatica del testo di riscaldamento","description":"Con questa impostazione attivata, Cephable AI riscalder\xe0 automaticamente i modelli AI utilizzati per la generazione di testo. Il riscaldamento dei modelli li render\xe0 pi\xf9 veloci quando si utilizzano i comandi di generazione, ma consumer\xe0 pi\xf9 risorse sul computer. Disattivando questa impostazione si risparmieranno risorse, ma la generazione di testo potrebbe risultare pi\xf9 lenta.","option":"Modelli di intelligenza artificiale che generano testo con riscaldamento automatico?"},"prompt":{"title":"Informazioni aggiuntive per la generazione di testo","description":"Inserisci dettagli aggiuntivi da utilizzare con l\'IA di Cephable per generare testo. Utilizza questo campo per inserire le preferenze per il tono, lo stile di scrittura o altri dettagli.","field":"Richiesta aggiuntiva","placeholder":"ad esempio, usa un tono amichevole, scrivi come un professionista, sii succinto e diretto. Quando scrivi codice, lascia commenti ponderati ma non troppi, ecc."},"enableTextGen":{"title":"Abilita la generazione intelligente del testo","description":"Con questa impostazione attivata, Cephable AI potr\xe0 usare il controllo del dispositivo di generazione del testo per generare testo in qualsiasi app per te. Disattivando questa impostazione disabiliterai questo comando.","option":"Utilizzare la generazione intelligente di testo?"},"terminate":{"title":"Risorse per la generazione di testo chiaro","description":"Fai clic per cancellare le risorse utilizzate per la generazione del testo. Ci\xf2 liberer\xe0 risorse sul tuo computer, ma potrebbe rallentare la generazione del testo la prossima volta che lo utilizzi.","button":"Risorse chiare","success":"Cancellazione delle risorse di generazione del testo.","confirm":{"title":"Risorse per la generazione di testo chiaro","description":"Vuoi davvero cancellare le risorse utilizzate per la generazione del testo? Ci\xf2 liberer\xe0 risorse sul tuo computer, ma potrebbe rallentare la generazione del testo la prossima volta che lo utilizzi.","confirm":"S\xec, risorse chiare","cancel":"Cancellare"}},"clearModelCache":{"title":"Cancella la cache del modello AI","description":"Seleziona quale modello di IA vuoi cancellare dalla cache e scaricare nuovamente. In questo modo libererai spazio di archiviazione sul computer e scaricherai di nuovo i file del modello selezionato.","button":"Cancella e scarica di nuovo","success":"File del modello locale eliminati.","confirm":{"title":"Cancella e scarica nuovamente la cache del modello AI","description":"Sei sicuro di voler cancellare la cache del modello AI selezionato ed eliminare i file dal tuo sistema? I modelli selezionati verranno scaricati nuovamente automaticamente.","confirm":"S\xec, cancella e scarica di nuovo","cancel":"Cancellare","textGenLabel":"Text Generation (Inference) model","workflowsLabel":"AI Workflows models"},"error":"Errore durante l\'eliminazione dei file del modello locale."},"enableHistory":{"title":"Abilita cronologia generazione testo","description":"Se questa impostazione \xe8 attivata, Cephable AI utilizzer\xe0 la cronologia di generazione del testo per generare testo con il contesto dell\'azione precedente.","option":"Utilizzare la cronologia di generazione del testo?"}},"prompt":{"systemPrompt":"Genera SOLO il testo richiesto, senza spiegazioni, commenti o fronzoli. Nessun markdown o spiegazione non richiesta. Per il codice, genera solo codice grezzo: senza recinzioni, senza tag di linguaggio, senza spiegazioni.","appName":"Al momento stai generando testo per {{appName}}.","userPreferences":"Rispettare le seguenti preferenze utente su come desidera che venga generato il testo: {{userPreferences}}."},"rewritePrompt":{"systemPrompt":"Riscrivere o riformattare il testo fornito secondo le istruzioni. In caso di riformattazione (ad esempio, elenchi, tabelle, modifiche alla struttura), mantenere esattamente le parole originali. In caso di riscrittura (ad esempio, tono, stile, lunghezza), mantenere il significato ma non necessariamente le parole. Visualizzare SOLO il risultato, senza spiegazioni o commenti. Questo potrebbe far parte di un documento pi\xf9 ampio. Visualizzare solo il risultato, senza titoli, etichette o preambolo.","userPreferences":"Rispettare le seguenti preferenze utente su come desidera che venga generato il testo: {{userPreferences}}.","rewriteInstructions":"Istruzioni: {{rewriteInstructions}}."},"translatePrompt":{"systemPrompt":"Traduci il testo seguente in {{lingua}}. Visualizza SOLO il testo tradotto. Nessuna spiegazione, nessun preambolo, nessuna formattazione markdown, nessuna delimitazione del codice. Mantieni la formattazione. Per il codice: traduci solo commenti e stringhe, preservando la sintassi esatta.","userPreferences":"Rispettare le seguenti preferenze utente su come desidera che venga generato il testo: {{userPreferences}}.","genericUserPrompt":"Traduci: {{userRequestText}}"},"disabled":{"title":"Le attivit\xe0 intelligenti sono disabilitate","description":"Sembra che tu abbia disabilitato le attivit\xe0 intelligenti. Aggiorna per sbloccare la generazione di testo, la riscrittura e altro ancora nelle impostazioni."},"summarizePrompt":{"systemPrompt":"Riassumere il testo fornito in modo conciso. Potrebbe essere parte di un documento pi\xf9 ampio. Riportare SOLO il riepilogo, senza preamboli, etichette o spiegazioni.","userPreferences":"Rispettare le seguenti preferenze utente su come desidera che venga generato il testo: {{userPreferences}}.","userPrompt":"Riepilogo: {{userRequestText}}"}},"profile":{"title":"Controlli dell\'app","titlePlural":"Controlli dell\'app","titlePreview":"Anteprima dei controlli","previous":"Controlli app precedenti","manage":"Gestisci i controlli delle app","view":"Visualizza controlli","edit":"Modifica controlli app","add":"Aggiungi controlli app","create":"Crea controlli app","warn":"Per poter utilizzare i controlli dell\'app, \xe8 necessario che la fotocamera o il microfono siano attivi.","descriptionShort":"Scopri i diversi modi in cui Cephable ti aiuta a controllare i tuoi dispositivi e software.","name":"Nome dell\'app","nameQuestion":"Come vuoi chiamare questi controlli dell\'app?","newName":"Nuovi controlli dell\'app","search":"Cerca i controlli dell\'app per nome","searchLong":"Cerca i controlli dell\'app per nome o descrizione","keyboardAndMouse":"Tastiera e mouse","genericController":"Controllore del gamepad","keyboardMouseAndController":"Tastiera, mouse e controller","permissionError":"Non hai l\'autorizzazione per utilizzare questi controlli dell\'app.","set":{"title":"Sembra che non hai ancora impostato i controlli dell\'app.","cta":"Imposta i controlli dell\'app","empty":{"auto":"Passa a un\'altra app per vedere i controlli","select":"Seleziona un controllo per iniziare","none":"Nessun controllo dell\'app trovato"},"description":"I controlli delle app consentono a Cephable di sapere cosa ascoltare e quali azioni intraprendere. Puoi cambiare i controlli delle app in qualsiasi momento dalla homepage o dalle impostazioni di connessione."},"summary":{"title":"Riepilogo dei controlli dell\'app","descriptionLong":"Ecco i dettagli di questi controlli app. Puoi cercare controlli, azioni e altro per vedere cosa puoi fare con questi controlli app.","description":"Ottieni un riepilogo di questi controlli dell\'app, inclusi i controlli disponibili, le personalizzazioni, i dettagli e altro ancora.","view":"Visualizza il riepilogo dei controlli dell\'app","filter":"Filtra per tipo di input","placeholder":"Cerca nomi di controllo..."},"copy":{"title":"Copia controlli app","duplicate":"Controlli app duplicati","question":"Creare una copia?","description":"Vuoi creare una nuova copia di questi controlli app? Si aprir\xe0 una nuova finestra con questi controlli app copiati, ma non verranno aggiunti al tuo account finch\xe9 non li salvi.","confirm":"S\xec, crea una copia","profileSuffix":"{{name}} (copia)"},"new":{"title":"Crea nuovi controlli app","description":"Crea controlli da zero o lascia che l\'intelligenza artificiale all\'avanguardia generi controlli personalizzati, consentendoti di usare app e software senza sforzo, usando la voce, i gesti della testa e del viso.","note":"Consigliato per utenti avanzati.","scratch":"Crea da zero"},"advancedOptions":"Opzioni di controllo avanzate","delete":{"title":"Elimina i controlli dell\'app","titleLong":"Elimina questi controlli dell\'app","description":"Puoi eliminare questi controlli app cliccando su \\"Elimina controlli app\\".","confirm":"Sei sicuro di voler eliminare questi controlli dell\'app?","confirmLong":"Una volta eliminati questi controlli app, non potrai pi\xf9 tornarci. Vuoi davvero eliminare questi controlli app?","confirmButton":"S\xec, elimina questi controlli dell\'app"},"current":"Controlli attuali","loading":"Caricamento controlli...","null":"Non hai ancora controlli app. Clicca qui sotto per crearne uno.","nullButton":"Crea i tuoi primi controlli app","preview":"Anteprima","features":"Caratteristiche","byline_public":"Di: Cephable Team","byline_shared":"Condiviso da: Comunit\xe0 Cephable","share":{"title":"Condividi i controlli dell\'app","previewTitle":"Anteprima dei controlli delle app condivise","description":"Condividi questi controlli dell\'app con altri in modo che possano averne una copia e personalizzarli!","descriptionLong":"Condividi questi controlli app con altri in modo che possano ottenere una copia e personalizzarli da l\xec! Scegli come vuoi condividere, quindi crea un collegamento da inviare ad altri.","add":"Crea un collegamento di condivisione","confirm":"Condividi questo URL","link":"Condividi collegamento","copy":"Copia collegamento","copied":"Copiato!","usage":"Quantit\xe0 di utilizzo","created":"Creato {{value}}","expiration":{"title":"Scadenza","once":"Consentire solo un utilizzo","unlimited":"Consentire un utilizzo illimitato","no":"Nessuna scadenza","date":"Data di scadenza","dateDescription":"Scadenza in una data specifica"},"manage":"Gestisci i link di condivisione precedenti","empty":"Non sono state create condivisioni per questi controlli dell\'app."},"swap":{"title":"Controlli di scambio","titleLong":"Scambia i controlli delle tue app","descriptionShort":"Utilizza diversi controlli dell\'app in base al programma o al software che stai utilizzando.","description":"\xc8 possibile alternare i diversi controlli delle app in base al programma o al software in uso."},"autoProfileSwitching":{"title":"Commutazione automatica del controllo","alerts":{"disabled":"La commutazione automatica del controllo \xe8 disattivata.","temporarilyDisabled":"La commutazione automatica del controllo \xe8 temporaneamente disattivata.","enabled":"La commutazione automatica del controllo \xe8 attivata.","error":"Errore durante il salvataggio delle preferenze di commutazione del controllo automatico"},"associatedPrograms":{"add":"Aggiungi un nuovo programma associato","description":{"personal":"Scegli il software o i programmi che vuoi connettere a questi controlli. Questo supporta la commutazione automatica dei controlli, in cui Cephable commuta automaticamente questi controlli delle app per adattarli al programma corrente che stai utilizzando.","short":"Seleziona il software o i programmi che desideri connettere a questi controlli."},"edit":"Modifica programmi associati","noOptionsText":"Inizia a digitare per trovare i programmi associati","profileLabel":"Controlli dell\'app:","remove":"Rimuovi programma associato","title":"Programmi associati","when":"Cephable cambier\xe0 automaticamente i controlli della mia app in {{profileName}} quando utilizzo...","emptySearch":"Non ci sono programmi associati a questi controlli.","error":"Errore durante il salvataggio dei programmi associati. Riprova pi\xf9 tardi.","emptyError":"Rilevato programma associato vuoto. Rimuoverlo prima di continuare."},"commandOverlay":{"command":"Cambiare i controlli dell\'app: {{value}}"},"description":"La commutazione automatica dei controlli consente a Cephable di adattarsi perfettamente al tuo flusso di lavoro. Se attivata, Cephable regoler\xe0 contestualmente i controlli dell\'app in base al programma o al software in uso. Se disattivata, puoi cambiare manualmente i controlli dell\'app utilizzando il pulsante \\"Cambia controlli\\" o i comandi globali."},"error":{"noMatch":"Nessun controllo app corrisponde alla tua ricerca.","load":"Errore durante il caricamento dei controlli dell\'app.","add":"Errore durante l\'aggiunta dei controlli dell\'app.","delete":"Errore durante l\'eliminazione dei controlli dell\'app.","audioEventsWithEmptyCommands":"Mancano dei controlli nel tuo talk back. Controlla i controlli del tuo talk back per assicurarti di compilarlo completamente.","conflicts":"Errore durante il salvataggio dei controlli dell\'app a causa di conflitti.","save":"Errore durante il salvataggio dei controlli dell\'app. Riprova.","device":"Controllo app non valido per questa connessione. Provane un altro."},"conflictIndicators":{"errorTitle":"Errore durante il salvataggio dei controlli dell\'app a causa di conflitti","warningTitle":"Controlli dell\'app salvati con avvisi","subtitle":"I controlli dell\'app creati presentano alcune configurazioni che potrebbero creare conflitti.","profileNameErrors":"Conflitto di nomi dei controlli app","emptyControlsMapped":"Nomi di input vuoti","emptyControlsMappedDescription":"Aggiungi un comando vocale, un\'espressione facciale, un\'inclinazione della testa o un altro comando al tuo input.","emptyKeybindingControlsMapped":"Nomi di input vuoti per le combinazioni di tasti","emptyKeybindingControlsMappedDescription":"Aggiungi un comando vocale, un\'espressione facciale, un\'inclinazione della testa o un altro comando all\'input per le associazioni di tasti.","duplicateNameTitle":"Nome dei controlli app duplicati","duplicateNameDescription":"Hai gi\xe0 un controllo app con lo stesso nome. Cambia il nome prima di continuare.","emptyNameTitle":"Nome dei controlli dell\'app vuoto","emptyNameDescription":"I controlli dell\'app devono avere un nome, ad esempio Gioco 1, Spotify, Word, ecc.","macrosReleaseKeysMissingTitle":"Uscite con tasti non rilasciati","macrosReleaseKeysMissingDescription":"Aggiungere una chiave di sblocco o interrompere tutti i passaggi per evitare che i tasti rimangano incastrati.","duplicateInputCommandMacroTitle":"Input di controllo identici","duplicateCommandsDescription":"Si prega di rimuovere o modificare i comandi di input duplicati.","duplicateInputCommandBindingsTitle":"Input di controllo identici per le associazioni di tasti","conflictIndicatorDisplayString":"{{container}} : {{commandOrKeyName}} con {{commandOrEventType}}","duplicateMacroNames":"Nomi di controllo duplicati","duplicateMacroNamesDescription":"Si prega di rimuovere o modificare uno dei nomi di controllo identici.","warningIgnore":"Ignorare","warningDoNotShowAgain":"Non mostrare pi\xf9 gli avvisi","macrosVoiceCommandConflictWithDictationTitle":"Controlla i comandi vocali come le parole chiave della dettatura","keybindingsVoiceCommandConflictWithDictationTitle":"I comandi vocali delle associazioni di tasti sono gli stessi delle parole chiave della dettatura","macrosVoiceCommandConflictWithDictationDescription":"I tuoi input vocali attiveranno la dettatura e i comandi vocali.","keybindingsVoiceCommandConflictWithDictationDescription":"I tuoi input vocali attiveranno la dettatura e la pressione dei tasti.","macrosVoiceCommandConflictWithGenerationTitle":"I comandi vocali di controllo sono gli stessi delle parole chiave di generazione","keybindingsVoiceCommandConflictWithGenerationTitle":"I comandi vocali delle associazioni di tasti sono gli stessi delle parole chiave di generazione","macrosVoiceCommandConflictWithGenerationDescription":"I tuoi input vocali attiveranno la generazione e i comandi vocali.","keybindingsVoiceCommandConflictWithGenerationDescription":"I tuoi input vocali attiveranno la generazione e la pressione dei tasti.","duplicateAssociatedProgramNames":"Nomi di programmi associati duplicati","duplicateAssociatedProgramNamesDescription":"Si prega di rimuovere o modificare uno dei programmi identici associati.","emptyEvent":{"title":"Passaggi mancanti","description":"Ci sono dei passaggi mancanti nei tuoi controlli. Questo potrebbe portare Cephable a non eseguire un\'azione quando dai un comando."},"warningDetails":"Visualizza tutti i conflitti"},"success":{"save":"Controlli dell\'app salvati.","add":"Aggiunti controlli app.","delete":"Controlli dell\'app eliminati.","share":"Condividi il collegamento creato e copiato negli appunti","shareDelete":"Link di condivisione eliminato.","generate":"Controlli dell\'app generati."},"warning":"Controlli dell\'app salvati con avvisi","customize":"Personalizza i controlli dell\'app","custom":"{{name}} (personalizzato)","description":"I controlli app sono un insieme di controlli che puoi utilizzare per gestire il tuo dispositivo o la tua connessione. Puoi creare pi\xf9 controlli app e passare da uno all\'altro quando vuoi."},"publicProfiles":{"toolbar":"Esplora i controlli delle app","title":"Esplora i controlli delle app","offline":{"title":"Impossibile caricare i controlli dell\'app pubblica","description":"Sembra che tu sia offline. Puoi comunque usare i controlli dell\'app, ma non sarai in grado di caricare nuovi controlli dell\'app pubblici.","confirm":"Va bene"},"announcement":"{{count}} Sono stati caricati nuovi controlli app","description":{"personal":"Sono disponibili controlli app pubblici per aiutarti a iniziare rapidamente a usare Cephable sulle tue app preferite. Puoi usare i controlli predefiniti, personalizzarli in base alle tue esigenze o creare controlli app personalizzati completamente nuovi da zero.","pro":"Sono disponibili controlli app pubblici per aiutarti a iniziare rapidamente a usare Cephable sulle tue app preferite. Puoi usare i controlli predefiniti, personalizzarli in base alle tue esigenze o creare controlli app personalizzati completamente nuovi tramite il generatore di controlli."},"team":"Squadra Cefabile"},"publicTag":"Pubblico","tray":{"panel":"Pannello di attivazione/disattivazione","dashboard":"Mostra dashboard","quit":"Smettila di Cephable"},"generate":"Generare","stop":"Fermare","clear":"Chiaro","rewrite":"Riscrivere","translate":"Tradurre","smartTasks":{"title":"Compiti intelligenti","show":"Mostra attivit\xe0 intelligenti","description":"Le attivit\xe0 intelligenti sono le diverse attivit\xe0 che l\'intelligenza artificiale di Cephable pu\xf2 svolgere per te. Queste attivit\xe0 sono basate sull\'intelligenza artificiale integrata nel dispositivo e possono essere utilizzate per creare testi, riassumere, riscrivere, tradurre, prendere appunti e chattare con i documenti.","generateText":{"title":"Genera testo","description":"Crea contenuti di testo in base ai tuoi input o ai tuoi prompt.","label":"Descrivi cosa vuoi generare"},"summarizeText":{"title":"Riassumere il testo","description":"Condensare un testo lungo in un riassunto conciso.","directions":"Inserisci il testo da riassumere, altrimenti Cephable utilizzer\xe0 automaticamente il testo evidenziato.","titleShort":"Riassumere","write":"Scrivi un riassunto","label":"Inserisci il testo per riassumere","outputLabel":"Il tuo riassunto verr\xe0 scritto qui."},"rewriteText":{"title":"Riscrivi il testo","description":"Evidenzia il testo in un\'altra app in cui stai scrivendo, quindi torna qui e descrivi come vuoi che venga riscritto.","label":"Descrivi come vuoi riscrivere il testo","inputLabel":"Inserisci il testo da riscrivere"},"translateText":{"title":"Traduci testo","description":"Inserisci il testo da tradurre, altrimenti Cephable utilizzer\xe0 automaticamente il testo evidenziato.","label":"Inserisci il testo da tradurre","languageLabel":"Lingua da tradurre"},"noteTaker":{"title":"Prenditore di appunti","description":"Lascia che Cephable registri e trascriva localmente le tue riunioni o conversazioni"},"documentChat":{"title":"Chat sui documenti","description":"Interagisci con i documenti e interrogali per ottenere informazioni rapide."},"highlightText":{"title":"Usa il testo evidenziato","description":"Cephable pu\xf2 utilizzare automaticamente il testo evidenziato in qualsiasi app per eseguire operazioni come riassumere, riscrivere o tradurre. Puoi anche inserire il testo manualmente, se preferisci.","label":"Inserisci il testo da utilizzare","placeholder":"Puoi anche evidenziare il testo in un\'altra app e tornare qui per utilizzarlo."},"pasteText":{"title":"Incolla il testo","description":"Cephable pu\xf2 utilizzare automaticamente il testo copiato negli appunti per eseguire attivit\xe0 come riassumere, riscrivere o tradurre. Puoi anche inserire il testo manualmente, se preferisci.","label":"Inserisci il testo da utilizzare","placeholder":"Puoi anche evidenziare il testo in un\'altra app e tornare qui per utilizzarlo."},"clearCache":"Se riscontri problemi durante la generazione, cancella la cache e le risorse dalle Impostazioni di generazione del testo e riprova.","transcribeAudio":{"title":"Trascrivi audio","description":"Converti file audio o video in testo utilizzando la trascrizione AI.","inputMethod":"Scegli il metodo di input","localFile":"File locale","url":"URL","selectFile":"Seleziona file audio/video","urlLabel":"URL audio/video","transcribe":"Trascrivere","result":"Risultato della trascrizione","invalidFileType":"Seleziona un file audio o video valido (mp3, wav, ogg, mp4, webm, mov, avi)","error":"Errore di trascrizione","history":{"title":"Cronologia della trascrizione","description":"Visualizza e gestisci le trascrizioni salvate.","viewHistory":"Visualizza cronologia","empty":"Nessuna trascrizione ancora. Inizia a trascrivere per costruire la tua storia!","titleLabel":"Titolo (facoltativo)","titlePlaceholder":"Inserisci un titolo per questa trascrizione","textLabel":"Testo di trascrizione","confirmDelete":"Sei sicuro di voler eliminare questa trascrizione?"}},"aiWorkflows":{"description":"Automatizza le attivit\xe0 del tuo desktop e del tuo browser con l\'intelligenza artificiale. Descrivi semplicemente cosa vuoi realizzare e guarda Cephable eseguire le azioni per te.","label":"Descrivi cosa vuoi realizzare","status":{"idle":"In attesa delle tue istruzioni...","initializing":"Preparando tutto...","planning":["Fare un piano...","Analizziamo la tua richiesta...","Mappatura dei passaggi...","Organizzazione del flusso di lavoro...","Preparazione della strategia...","Creare un piano d\'azione...","Scoprire il modo migliore per aiutarti...","Determinare come affrontare questo...","Analisi della tua richiesta in corso...","Pianificazione dell\'esecuzione..."],"thinking":["Pensiero...","Analisi della tua richiesta in corso...","Scoprire il modo migliore per aiutarti...","Decidere cosa fare dopo...","Elaborazione dei passaggi precedenti...","Stiamo lavorando alla tua richiesta...","Recupero dettagli in corso...","Revisione del piano...","Considerando le opzioni...","Creare, valutare, decidere..."],"waitingForUser":"Il tuo contributo \xe8 necessario per continuare.","completed":"Successo!","failed":"La tua richiesta non \xe8 andata a buon fine. Riprova.","canceled":"La tua richiesta \xe8 stata annullata.","terminated":"Fermo. In attesa di tue istruzioni...","thinkingInteractive":["Considerando il passo successivo...","Rivediamo cosa abbiamo fatto finora...","Decidere cosa fare dopo...","Analizzando i risultati...","Pianificando la continuazione...","Valutando le opzioni...","Cercando di capire qual \xe8 il passo successivo migliore...","Stiamo lavorando alla parte successiva della tua richiesta...","Stiamo lavorando ai prossimi passi...","Elaborazione dei risultati del passaggio precedente..."],"tools":{"click_element_by_index":{"executing-start":"Cliccando sul pulsante corrispondente...","executing-complete":"Ho cliccato su {{params.index}}."},"click_element":{"executing-start":"Cliccando sul numero evidenziato...","executing-complete":"Ho cliccato su {{params.elementName}}."},"copy_selection":{"executing-start":"Raccolta del contesto...","executing-complete":"Ho il contesto pronto per la parte successiva della tua richiesta."},"create_file":{"executing-start":"Creazione di un file...","executing-complete":"Ho creato un file denominato {{params.fileName}}."},"draft_email":{"executing-start":"Bozza di un\'e-mail...","executing-complete":"Ho scritto una bozza di email su {{params.subject}}."},"execute_app_action":{"executing-start":"Esecuzione di {{params.actionName}}...","executing-complete":"{{params.actionName}} completato."},"find_all_text":{"executing-start":"Ricerca di tutto il contesto rilevante su {{params.searchText}}...","executing-complete":"Ho trovato tutto il contesto rilevante su {{params.searchText}}."},"find_and_select_text":{"executing-start":"Ricerca e selezione del contesto rilevante su {{params.searchText}}...","executing-complete":"Ho trovato e selezionato il contesto pertinente su {{params.searchText}}."},"generate_text":{"executing-start":"Creazione di contenuti...","executing-progress":"Creazione di contenuti...{{progress}}%","executing-complete":"Ho creato il contenuto richiesto."},"get_all_interactive_elements":{"executing-start":"Scansione per ottenere pi\xf9 contesto...","executing-complete":"Capisco con cosa posso interagire."},"get_all_text_elements_content":{"executing-start":"Leggendo per avere pi\xf9 contesto...","executing-complete":"Ho capito quali contenuti testuali sono disponibili."},"get_all_text_elements_names":{"executing-start":"Leggendo per avere pi\xf9 contesto...","executing-complete":"Ho capito quali contenuti testuali sono disponibili."},"get_available_profile_actions":{"executing-start":"Verifica quali controlli sono disponibili in questa app...","executing-complete":"Ho capito cosa posso fare con questa app."},"get_document_content":{"executing-start":"Leggendo per avere pi\xf9 contesto...","executing-complete":"Ho il contesto pronto per la parte successiva della tua richiesta."},"get_installed_apps":{"executing-start":"Decidere quale app \xe8 rilevante per la tua richiesta...","executing-complete":"So quali app posso usare."},"get_running_app_names":{"executing-start":"Decidere quale app \xe8 rilevante per la tua richiesta...","executing-complete":"So quali app posso usare."},"get_selected_text":{"executing-start":"Lettura del contenuto selezionato...","executing-complete":"Ho un contesto sul contenuto selezionato."},"get_stored_content":{"executing-start":"Raccolta del contesto...","executing-complete":"Ho il contesto pronto per la parte successiva della tua richiesta."},"keyboard_shortcut":{"executing-start":"Raccolta del contesto...","executing-complete":"Ho il contesto pronto per la parte successiva della tua richiesta."},"open_app":{"executing-start":"Apertura di {{params.appName}}...","executing-complete":"Ho aperto {{params.appName}}."},"open_webpage":{"executing-start":"Apertura di {{params.url}}...","executing-complete":"Ho aperto {{params.url}}."},"paste_content":{"executing-start":"Scrivere...","executing-complete":"Ho finito di scrivere."},"respond_to_user":{"executing-start":"Completamento della richiesta in corso...","executing-complete:":"Ho completato la tua richiesta."},"search_and_open_file":{"executing-start":"Ricerca del file {{params.query}} e apertura in corso...","executing-complete":"Ho cercato il file {{params.query}} e l\'ho aperto."},"search_browser":{"executing-start":"Ricerca sul Web di {{params.query}}...","executing-complete":"Ho cercato sul web {{params.query}}."},"select_all_text":{"executing-start":"Selezione di tutto il testo...","executing-complete":"Ho selezionato tutto il testo."},"summarize_text":{"executing-start":"Riassumendo il testo...","executing-progress":"Riassumendo...{{progress}}%","executing-complete":"Ho riassunto il testo."},"translate_text":{"executing-start":"Traduzione del testo in {{params.targetLanguage}}...","executing-progress":"Traduzione in corso...{{progress}}%","executing-complete":"Ho tradotto il testo in {{params.targetLanguage}}."},"type_stored_content":{"executing-start":"Scrivere...","executing-complete":"Ho finito di scrivere."},"type_text":{"executing-start":"Scrivere...","executing-complete":"Ho finito di scrivere."},"write_file_content":{"executing-start":"Scrittura sul file...","executing-complete":"Ho finito di scrivere nel file {{params.fileName}}."},"unknown":{"executing-start":"Ho riscontrato un problema, provando una strategia diversa...","executing-complete":"Ho provato una strategia diversa."}},"networkError":"Connessione persa durante il download del modello. Controlla la tua connessione Internet e riprova inviando un messaggio o riavviando l\'app.","executing-org-block":"Impossibile utilizzare {{params.toolName}} perch\xe9 l\'interazione con {{params.appOrDomain}} \xe8 bloccata dall\'organizzazione.","executing-destructive-block":"L\'interazione con {{params.elementName}} \xe8 bloccata. Si prega di rivedere ed eseguire questa azione manualmente.","executing-type-focus-block":"Ho riscontrato un problema durante la scrittura del contenuto. \xc8 stato copiato negli appunti, si prega di incollarlo manualmente."},"ready":{"waiting":"AI Workflows \xe8 pronto. In attesa delle tue istruzioni.","execute":"AI Workflows \xe8 pronto. A partire dalla tua richiesta..."},"start":"Inizio","progress":"Lavorando...","introModal":{"description":"Ora posso automatizzare le attivit\xe0 del tuo desktop e del tuo browser: dimmi solo cosa vuoi fare e mi occuper\xf2 io di tutto. Il servizio viene eseguito in privato sul tuo dispositivo, quindi i tuoi dati rimangono tuoi. Per iniziare, devo scaricare un modello di intelligenza artificiale locale. Scaricalo ora in modo che io sia pronto, oppure lo scaricher\xf2 quando avvierai il tuo primo flusso di lavoro.","confirm":"Scarica ora","cancel":"Per ora salta","title":"I flussi di lavoro basati sull\'IA sono disponibili"},"title":"I tuoi flussi di lavoro di IA sono pronti"},"generatedByAI":"Basato sull\'intelligenza artificiale integrata nel dispositivo, si prega di verificarne l\'accuratezza.","networkError":"Connessione persa durante il download del modello. Controlla la tua connessione Internet e riprova inviando un messaggio o riavviando l\'app.","genericError":"Si \xe8 verificato un errore imprevisto. Riprova.","download":{"title":"Scarica i modelli di intelligenza artificiale per sbloccare ulteriori funzionalit\xe0.","description":"Per utilizzare le attivit\xe0 intelligenti, \xe8 necessario scaricare un modello locale sul dispositivo. Questo garantisce che i dati rimangano privati e non vengano mai inviati al cloud.","confirm":"Scaricamento","cancel":"Non adesso","includeWorkflows":"\xc8 inoltre possibile scaricare modelli di flusso di lavoro AI per un\'automazione avanzata."}},"inputMethod":"Metodo di input:","hotkey":{"title":"Pulsante di azione rapida","titlePlural":"Pulsanti di azione rapida","titlePanel":"Azioni rapide","label":"Nome visualizzato del pulsante di azione rapida","placeholder":"Nome da visualizzare","question":"Come vorresti chiamare questo pulsante?","when":"Quando tocco...","description":"I pulsanti di azione rapida sono pulsanti personalizzabili che puoi toccare per eseguire azioni pertinenti nella tua app. Un singolo tocco pu\xf2 eseguire pi\xf9 passaggi o una singola azione.","usagePrompt":"I pulsanti di azione rapida sono pulsanti personalizzabili che puoi toccare per eseguire azioni pertinenti nella tua app. Puoi aggiungerli, rimuoverli o modificarne i nomi dalla pagina principale delle impostazioni dei controlli dell\'app.","reorder":"\xc8 possibile modificare l\'ordine utilizzando i pulsanti \\"Sposta su\\" e \\"Sposta gi\xf9\\".","emptyTitle":"Nessun pulsante di azione rapida","edit":"Modifica pulsanti di azione rapida","tap":"Tocca {{value}}","copySuffix":"{{name}}_copia","hotkeysOnly":"Pulsanti personalizzati","allControls":"Tutti i controlli delle app","show":"Mostra pulsanti di azione rapida","deprecatedDialog":{"title":"I controlli dell\'app richiedono un aggiornamento.","description2":"Basta un rapido aggiornamento, letteralmente un secondo, e potrai goderti un\'esperienza di personalizzazione dei pulsanti impeccabile. Di\' addio ai passaggi aggiuntivi e dai il benvenuto a un\'interfaccia pi\xf9 intuitiva. Pronto a cambiare?","confirm":"Facciamolo!","description1":"Sembra che tu stia utilizzando controlli dell\'app meno recenti con pulsanti di azione rapida. Abbiamo in serbo per te degli aggiornamenti entusiasmanti! Abbiamo rinnovato il sistema per semplificare la creazione e la modifica dei pulsanti di azione rapida, senza dover pi\xf9 immergersi nelle impostazioni avanzate."},"demo":{"title":"Pulsanti di azione rapida demo","step1":"Attiva i pulsanti di azione rapida","step2":"Utilizzare i prompt di esempio riportati di seguito per controllare il blocco di testo.","command1":"Premere il pulsante 1 per \u201CIngrandire il testo\u201D","command2":"Premere il pulsante 2 per \u201Cmettere in grassetto il testo\u201D","command3":"","continue":"Continua con i pulsanti di azione rapida","description":"L\'area demo qui sotto ti permetter\xe0 di provare i pulsanti di azione rapida. La demo \xe8 limitata al controllo specifico di quest\'area di testo qui sotto."},"example":{"title":"Esempi di pulsanti di azione rapida","command1":"Tocca Pausa","example1":"Esempio \\"metti in pausa il video\\"","command2":"Tocca Avanti","example2":"Esempio \\"zoom out\\"","command3":"Tocca Stop","example3":"Esempio \u201Cchiudi finestra\u201D","description":"Questi esempi mostrano la versatilit\xe0 dei pulsanti di azione rapida nel controllo del dispositivo o della connessione. Possono essere utilizzati per eseguire comandi, navigare tra le interfacce o eseguire azioni con un semplice tocco."},"emptySearch":"Non ci sono azioni rapide che corrispondono a questi criteri.","empty":"Sembra che al momento non siano disponibili azioni rapide.","emptyLong":"In questi controlli dell\'app non sono configurati pulsanti di azione rapida. Una volta aggiunti pulsanti di azione rapida o scelti controlli dell\'app che ne contengono uno, questi appariranno qui."},"reset":"Reset","info":"Ulteriori informazioni","device":{"title":"Connessione","titlePlural":"Connessioni","status":{"title":"Stato della connessione:","connected":{"application":"Applicazione connessa","connection":"Collegato","device":"Dispositivo connesso","game":"Gioco connesso"},"disconnected":{"application":"Applicazione disconnessa","connection":"Disconnesso","device":"Dispositivo disconnesso","game":"Gioco disconnesso"}},"running":"Corsa","offline":"Fuori linea","otherDevices":"Altre connessioni di uscita","currentStatus":"Stato attuale:","connectionStatus":"Stato della connessione:","profileStatus":"Controlli dell\'app corrente:","name":{"title":"Nome della connessione","question":"Come vuoi chiamare questa connessione?","description":"Assegna un nome alla tua connessione, cos\xec potrai ritrovarla facilmente in seguito.","placeholder":"nome della connessione","edit":"Modifica nome connessione"},"updates":{"title":"Aggiornamenti sulla connessione","settings":"Impostazioni di aggiornamento della connessione","description":"Verificare gli aggiornamenti del firmware di connessione e modificare le impostazioni di aggiornamento automatico","edit":"Modifica impostazioni di aggiornamento","check":{"title":"Controlla gli aggiornamenti","processing":"Controllo aggiornamenti in corso! Potrebbero volerci alcuni minuti e la connessione potrebbe riavviarsi durante gli aggiornamenti.","description":"Tocca per verificare la presenza di aggiornamenti per la tua connessione. Se \xe8 disponibile un aggiornamento e la tua connessione \xe8 attiva, l\'aggiornamento inizier\xe0. Gli aggiornamenti possono richiedere alcuni minuti."},"auto":{"title":"Aggiorna automaticamente","description":"Con questa impostazione attivata, la connessione verr\xe0 aggiornata automaticamente ogni volta che il dispositivo \xe8 collegato alla rete elettrica, connesso al Wi-Fi e disponibile un aggiornamento. Se questa impostazione \xe8 disattivata, \xe8 necessario toccare il pulsante di aggiornamento per ottenere l\'ultima versione.","option":"Utilizzare l\'aggiornamento automatico?"}},"delete":{"title":"Scollega {{name}}","titleLong":"Scollega dall\'account","description":"Scollegando Cephable, lo disconnetti da questo computer o gioco e lo rimuovi dal tuo account. Non potrai pi\xf9 connetterti, inviare comandi o aggiornarlo. Questa operazione non pu\xf2 essere annullata, ma puoi creare una nuova connessione allo stesso computer o gioco se desideri utilizzarlo di nuovo in futuro.","confirm":"Sei sicuro di voler scollegare questa connessione?","confirmLong":"Vuoi davvero annullare la registrazione e reimpostare questa connessione? Non potrai pi\xf9 connetterti, inviare comandi o aggiornarla. Dopo questa operazione di annullamento della registrazione e reimpostazione, chiunque altro potr\xe0 configurare questa connessione da zero.","confirmButton":"S\xec, rimuovi questa connessione."},"manage":{"title":"Fai clic per visualizzare e gestire i dettagli delle tue connessioni.","description":"","name":"Personalizza il nome della tua connessione per una gestione pi\xf9 semplice."},"error":{"save":"Errore durante il salvataggio della connessione.","load":"Errore durante il caricamento della connessione.","add":"Errore durante l\'aggiunta della connessione.","delete":"Errore durante l\'eliminazione della connessione.","updates":"Errore durante il controllo degli aggiornamenti.","connection":"La connessione non \xe8 stata stabilita. Assicurati che sia connessa prima di riprovare.","deleteLong":"Non siamo riusciti a eliminare questa connessione dal tuo account. Se accedi di nuovo a questo account, potresti dover eliminare manualmente questa connessione nelle impostazioni di connessione."},"success":{"save":"Connessione salvata.","add":"Connessione aggiunta.","delete":"Connessione eliminata."},"description":"Cephable supporta pi\xf9 dispositivi e connessioni. Puoi gestire le impostazioni o selezionarne una qualsiasi da qui. Questo computer sar\xe0 sempre la tua connessione principale. Puoi aggiungere altre connessioni in seguito.","swap":{"titlePlural":"Scambia connessioni"},"control":{"button":"Controllo {{name}}","description":{"application":"Controlla questa applicazione connessa usando la voce, azioni rapide, movimenti della testa e altro ancora. Ad esempio, se dici \\"Salva\\", l\'operazione verr\xe0 salvata sull\'applicazione in esecuzione.","connection":"Controlla questa connessione tramite la voce, azioni rapide, movimenti della testa e altro ancora. Ad esempio, se dici \\"Salva\\", questa operazione verr\xe0 salvata sulla connessione in esecuzione.","device":"Controlla questo dispositivo connesso usando la voce, azioni rapide, movimenti della testa e altro ancora. Ad esempio, se dici \\"Apri Spotify\\", Spotify si aprir\xe0 sul dispositivo in esecuzione.","game":"Controlla questo gioco interattivo usando la voce, azioni rapide, movimenti della testa e altro ancora. Ad esempio, se dici \\"Vai\\", il giocatore si muover\xe0 in modalit\xe0 corsa."},"generic":"Collegamento di controllo"},"titleShort":"Collegare","titleLong":"Connessioni ed estensioni","viewAll":"Visualizza tutte le connessioni","add":{"short":"Estendere","title":"Aggiungi una nuova connessione o estensione","description":"Connessioni ed estensioni sono ulteriori modi per migliorare la tua esperienza Cephable. Puoi aggiungere nuove connessioni per connetterti a pi\xf9 dispositivi, applicazioni o giochi. Porta la tua esperienza Cephable a un livello superiore aggiungendo connessioni ed estensioni.","action":"Aggiungi una nuova connessione","notAvailable":"Questa connessione o estensione non \xe8 attualmente disponibile al pubblico. Questo problema si verifica spesso quando si utilizzano estensioni generate dagli utenti. Riprova pi\xf9 tardi.","isNotPublic":"ANTEPRIMA: Questa estensione \xe8 in anteprima per sviluppatori e potrebbe essere incompleta. Gli sviluppatori devono completare tutti i passaggi prima del rilascio pubblico. Gli utenti possono controllare pi\xf9 tardi per la versione completa."},"new":"Hai una nuova connessione!","newLong":"Hai una nuova connessione! Per iniziare a usarla, selezionala dal menu qui sotto."},"explore":"Esplorare","shortcuts":{"title":"Scorciatoie globali","description":"Personalizza le scorciatoie da tastiera per accedere rapidamente ai controlli Cephable da qualsiasi punto del sistema.","info":"Queste scorciatoie funzionano a livello globale e possono essere utilizzate anche quando Cephable non \xe8 la finestra attiva.","shortcut":"Scorciatoia","toggleMicrophone":"Attiva/disattiva microfono","toggleDictation":"Attiva/disattiva la modalit\xe0 di dettatura","toggleVoiceControl":"Attiva/disattiva la modalit\xe0 di controllo vocale","togglePanel":"Pannello di attivazione/disattivazione","registrationFailed":"Alcune scorciatoie globali non sono state registrate. Potrebbero essere utilizzate da un\'altra applicazione:","record":{"title":"Registra scorciatoia","start":"Clicca per registrare","listening":"Premi la combinazione di tasti desiderata...","pressKeys":"Premi i tasti ora"},"formatHint":"Selezionare almeno un tasto modificatore ({{modifierKey}}, {{modifierKey2}}, Maiusc) e un altro tasto."},"gamepad":{"title":"Supporto per gamepad","description":"Configura l\'uscita del gamepad e del joystick per i giochi su PC","driver":{"description":"Per supportare le uscite del controller di gioco, Cephable deve scaricare e installare un driver esterno chiamato ViGEm. Questo driver abilita la funzionalit\xe0 del controller virtuale Xbox 360, riconosciuta in modo nativo dai giochi.","installed":"Driver del controller di gioco installato: ora puoi utilizzare le uscite del gamepad! Se i problemi persistono, puoi provare a reinstallare il driver.","notInstalled":"Driver del controller di gioco non installato","install":"Installa il driver del controller di gioco","reinstall":"Reinstallare il driver del controller di gioco","installing":"Installazione del driver del controller di gioco ViGEm...","installSuccess":"Driver del controller di gioco ViGEm installato correttamente! Ora puoi utilizzare le uscite del gamepad nei tuoi controlli.","installFailed":"Impossibile installare il driver ViGEm. Riprovare o installarlo manualmente dal sito web di ViGEm."},"platform":{"unsupported":"Piattaforma non supportata per le funzionalit\xe0 del gamepad","unsupportedDescription":"La funzionalit\xe0 di output del gamepad \xe8 attualmente supportata solo sui sistemi Windows x64. Il supporto per Windows ARM64 non \xe8 ancora disponibile a causa delle limitazioni dell\'SDK."},"usage":"Una volta installato il driver del Game Controller, puoi usare i movimenti del joystick e le pressioni dei pulsanti del gamepad nelle macro e nei comandi vocali per controllare i giochi."},"youtube":{"unavailable":{"title":"Video non disponibile","description":"Questo video non \xe8 al momento disponibile. Riprova pi\xf9 tardi.","retry":"Riprova"},"watch":{"title":"Ops.","description":"Sembra che si sia verificato un problema durante il caricamento del video. Puoi guardarlo direttamente su YouTube.","button":"Guarda su YouTube"},"offline":{"title":"Video non disponibile","description":"Questo video di YouTube richiede una connessione a Internet per essere caricato. Controlla la tua connessione e riprova."}},"metrics":{"download":{"success":"Accesso al file delle metriche riuscito.","manualPath":"File delle metriche disponibile all\'indirizzo: {{path}}","error":"Errore durante il download del file delle metriche.","noFile":"Nessun file di metriche trovato."},"clear":{"success":"File delle metriche cancellato correttamente.","error":"Errore durante la cancellazione del file delle metriche.","noFile":"Nessun file di metriche trovato da cancellare.","confirm":"Vuoi davvero cancellare tutti i dati delle metriche? Questa operazione non pu\xf2 essere annullata."}},"suggestedPrompts":{"title":"Suggerimenti suggeriti","description":"Personalizza i suggerimenti visualizzati nelle attivit\xe0 di intelligenza artificiale per aiutarti a iniziare rapidamente.","edit":"Modifica i prompt suggeriti","generate":"Genera testo","rewrite":"Riscrivi il testo","addGenerate":"Aggiungi un prompt di generazione","addRewrite":"Aggiungi un prompt di riscrittura","remove":"Rimuovi richiesta","generatePlaceholder":"Inserisci un prompt per la generazione del testo...","rewritePlaceholder":"Inserisci un prompt per la riscrittura del testo...","suggested":"Suggerimenti suggeriti","suggestedFor":"Suggerito per {{profileName}}","seeAll":"Visualizza tutti i prompt","showLess":"Mostra meno","allPrompts":"Tutti i prompt","customFor":"Prompt personalizzati per {{profileName}}","defaultPrompts":"Prompt predefiniti","defaultGenerate":["Un\'e-mail professionale che presenta il nostro nuovo prodotto","Un ordine del giorno per la discussione di gruppo della prossima settimana","Uno schema di proposta di progetto per una nuova iniziativa","Un modello di lettera commerciale formale","Una sezione di documentazione tecnica","Introduzione al manuale utente","Una panoramica del documento di formazione","Una bozza di documento politico","Un\'e-mail di follow-up dopo una riunione","Un messaggio di ringraziamento a un cliente","Un\'e-mail di aggiornamento sullo stato del progetto","Un invito a un evento aziendale","Un\'e-mail di promemoria per le prossime scadenze","Un\'e-mail di benvenuto per i nuovi membri del team","Un\'e-mail di scuse per l\'interruzione del servizio","Introduzione alla newsletter","Un elenco di brainstorming per campagne di marketing","Soluzioni creative per migliorare la produttivit\xe0 del team","Idee per attivit\xe0 di ritiro aziendale","Concetti per una nuova funzionalit\xe0 dell\'app mobile","Suggerimenti per migliorare l\'esperienza del cliente","Idee innovative per lo sviluppo dei nostri prodotti","Idee di contenuti per i post sui social media","Argomenti di workshop per lo sviluppo professionale","Una funzione che convalida l\'input dell\'utente","Una query di database per la gestione degli utenti","Codice di gestione degli errori per le richieste API","Un modello di file di configurazione","Commenti che spiegano un algoritmo complesso","Casi di test unitari per una nuova funzionalit\xe0","Documentazione per gli endpoint API","Uno script per la distribuzione automatizzata"],"defaultRewrite":["Rendi questo testo pi\xf9 conciso e diretto","Espandi questo riepilogo con maggiori dettagli","Riformattalo come un elenco numerato","Converti questo in punti elenco","Ristrutturalo in paragrafi chiari","Rendi questo testo pi\xf9 facile da leggere velocemente","Organizzare queste informazioni in modo gerarchico","Formattalo come una guida passo passo","Rendi questo messaggio pi\xf9 professionale e formale","Riscrivilo per renderlo pi\xf9 informale e amichevole","Adatta il tono per renderlo pi\xf9 incoraggiante","Rendi questo suono pi\xf9 sicuro e assertivo","Addolcisci il tono per essere pi\xf9 diplomatico","Aggiungi entusiasmo ed energia a questo testo","Rendilo pi\xf9 empatico e comprensivo","Riscrivi con un tono pi\xf9 collaborativo","Semplificare questo per un pubblico generale","Rendi questa spiegazione pi\xf9 tecnica e dettagliata","Scomporre questo concetto complesso in termini pi\xf9 semplici","Aggiungere pi\xf9 contesto e informazioni di base","Riassumiamo tutto questo in punti chiave","Elaborare i punti principali con esempi","Rendilo pi\xf9 accessibile ai principianti","Condensa questo mantenendo le informazioni essenziali","Migliorare la chiarezza e la leggibilit\xe0","Rendi questo pi\xf9 coinvolgente e interessante","Adatta per una grammatica e una fluidit\xe0 migliori","Riscrivi per enfatizzare i vantaggi"]},"accessibilityService":{"error":{"generic":"Errore interno. Riprova pi\xf9 tardi.","elementNotFound":"Nessun risultato trovato. Assicurati che la ricerca esista e riprova.","highlightOnConflict":"Sono stati trovati pi\xf9 elementi. Perfeziona il comando per specificare quale vuoi selezionare.","clickNotInitialized":"Al momento, la funzione \\"Tocca per nome\\" non \xe8 disponibile. Se il problema persiste, contatta l\'assistenza.","platformUnsupported":"Le funzionalit\xe0 Voice Mouse non sono supportate su questa piattaforma."},"clickWait":"Inizializzazione in corso. Attendi un attimo e riprova."},"deprecated":"Obsoleto","view":"Visualizzazione","aiWorkflows":{"settings":{"title":"Impostazioni dei flussi di lavoro AI","description":"Configura i modelli di intelligenza artificiale e i dispositivi utilizzati per i flussi di lavoro di intelligenza artificiale. I flussi di lavoro di intelligenza artificiale consentono di automatizzare le attivit\xe0 su desktop e browser utilizzando l\'intelligenza artificiale sul dispositivo.","configType":{"title":"Tipo di configurazione del modello","description":"Seleziona il tipo di configurazione del modello da utilizzare per i flussi di lavoro AI. Diverse configurazioni sono ottimizzate per modelli diversi.","label":"Tipo di configurazione"},"reasoningModel":{"title":"Modello di ragionamento","description":"Seleziona il modello di intelligenza artificiale da utilizzare per le attivit\xe0 di ragionamento e pianificazione. Il modello di ragionamento analizza le tue richieste e crea piani d\'azione.","label":"Modello di ragionamento"},"reasoningDevice":{"label":"Dispositivo di ragionamento"},"generationModel":{"title":"Modello di generazione","description":"Seleziona il modello di intelligenza artificiale da utilizzare per le attivit\xe0 di generazione del testo. Il modello di generazione crea contenuti testuali quando necessario per i flussi di lavoro.","label":"Modello di generazione"},"generationDevice":{"label":"Dispositivo di generazione"},"noModelsFound":"Nessun modello trovato","terminate":{"title":"Risorse chiare del flusso di lavoro","description":"Fare clic per terminare il workflow worker e liberare risorse. Questo interromper\xe0 qualsiasi workflow in esecuzione e liberer\xe0 la memoria utilizzata dai modelli di intelligenza artificiale.","button":"Termina Workflow Worker","success":"Addetto al flusso di lavoro licenziato.","confirm":{"title":"Termina Workflow Worker","description":"Vuoi davvero terminare il workflow worker? Questo interromper\xe0 qualsiasi workflow in esecuzione e liberer\xe0 risorse.","confirm":"S\xec, terminare"}},"autoWarm":{"title":"Flussi di lavoro AI con avvio automatico","description":"Inizializza automaticamente i modelli di flusso di lavoro AI all\'avvio dell\'app. I modelli saranno precaricati in modo che i flussi di lavoro possano iniziare immediatamente.","option":"Avvia automaticamente i modelli di flusso di lavoro AI all\'avvio dell\'app"},"prompt":{"title":"Informazioni aggiuntive per i flussi di lavoro AI","description":"Inserisci dettagli aggiuntivi da utilizzare con l\'intelligenza artificiale di Cephable durante l\'esecuzione dei flussi di lavoro. Utilizza questo campo per inserire le tue preferenze relative a tono, comportamento o altri dettagli.","field":"Richiesta aggiuntiva","placeholder":"Ad esempio, confermare sempre prima di inviare e-mail. Preferire risposte concise. Utilizzare un linguaggio formale nei documenti."},"disableButtonNames":{"edit":"Interazioni con i pulsanti di blocco","input":{"label":"Nome del pulsante","question":"Quali pulsanti desideri bloccare? Puoi inserire il nome completo o parziale del pulsante.","remove":"Rimuovi il nome del pulsante"},"button":"Pulsanti di blocco","description":"Controlla con quali pulsanti i flussi di lavoro basati sull\'IA possono interagire. Per impostazione predefinita, Cephable pu\xf2 fare clic su qualsiasi pulsante sullo schermo. Utilizza questa impostazione per evitare azioni accidentali (ad esempio, \\"acquista\\", \\"elimina\\")."}}},"control":"Controllare","automate":"Automatizzare","deviceCommandThrottled":{"macroLength":"Questa connessione non consente macro lunghe. La tua macro \xe8 stata abbreviata automaticamente.","commandCount":"Questa connessione limita la velocit\xe0 di invio dei comandi. Attendi e riprova pi\xf9 tardi."},"tos":{"title":"Aggiornamento dei Termini di Servizio","description":"I nostri Termini di servizio sono stati aggiornati. Si prega di leggere e accettare i termini aggiornati per continuare a utilizzare Cephable.","effectiveDate":"Data di entrata in vigore: {{date}}","accept":"Accetta i Termini di Servizio","loadError":"Impossibile caricare i Termini di servizio. Riprova.","viewInBrowser":"Visualizza i Termini di servizio nel browser","acceptCheckbox":"Ho letto e accetto i Termini di servizio"}}');


var $b25c88c429ae6c78$exports = {};
$b25c88c429ae6c78$exports = JSON.parse("{\"404\":\"Oh no! Abbiamo cercato nel mare e non riusciamo a trovare la pagina!\"}");


var $bd5ea8d28885a1b5$exports = {};
$bd5ea8d28885a1b5$exports = JSON.parse('{"smartTasks":{"tourLabel":"Compiti intelligenti","learn":"Scopri come generare, riscrivere e tradurre testi con Cephable.","generate":{"openTool":{"title":"Apri lo strumento Genera testo","description":"Nel pannello Cephable, fare clic sull\'icona accanto a Attivit\xe0 intelligenti e selezionare Genera testo."},"enterPrompt":{"title":"Inserisci richiesta","description":"Nella casella di richiesta, digita: Crea un gioco di parole credibile in una sola frase."},"clickGenerate":{"title":"Fai clic su Genera","description":"Fai clic sul pulsante Genera. Guarda il testo apparire in tempo reale."},"focusApp":{"title":"Concentrati sull\'app","description":"Assicurati di concentrarti sull\'app in cui desideri che appaia il testo generato. Potrai generare il testo in modo fluido in quella posizione cliccando su Genera."}},"rewrite":{"welcome":{"title":"Benvenuti a Rewrite","description":"Riformula rapidamente il contenuto evidenziando o incollando il testo."},"highlightToggle":{"title":"Usa testo evidenziato","description":"Assicurati che sia selezionata l\'opzione \\"Usa testo evidenziato\\" (impostazione predefinita)."},"highlightText":{"title":"Evidenzia il testo da riscrivere","description":"In evidenza: un polipo pu\xf2 controllare ogni braccio in modo indipendente."},"enterInstructions":{"title":"Inserisci le istruzioni di riscrittura","description":"Tipo: in stile inglese antico."},"clickGenerate":{"title":"Fai clic su Genera","description":"Il testo evidenziato verr\xe0 riscritto in base ai tuoi input."},"pasteMode":{"title":"Usa Incolla testo","description":"Incolla l\'originale e riscrivi le istruzioni. Fai clic su Genera. Fai clic su Cancella per reimpostare."},"openTool":{"title":"Apri lo strumento Riscrivi testo","description":"Nel pannello Cephable, fare clic sulla carota accanto a Attivit\xe0 intelligenti e selezionare Riscrivi testo."},"focusApp":{"title":"Concentrati sull\'app","description":"Assicurati di concentrarti sull\'app in cui desideri che appaia il testo riscritto. Potrai generare il testo in quella posizione senza problemi cliccando su \\"Genera\\"."}},"translate":{"welcome":{"title":"Benvenuti a Translate","description":"Traduci il testo evidenziato o incollato in un\'altra lingua."},"highlightToggle":{"title":"Usa testo evidenziato","description":"Assicurati che sia selezionata l\'opzione \\"Usa testo evidenziato\\"."},"highlightText":{"title":"Evidenzia il testo da tradurre","description":"In evidenza: un polipo pu\xf2 controllare ogni braccio in modo indipendente."},"enterLanguage":{"title":"Inserisci la lingua di destinazione","description":"Tipo: portoghese."},"clickGenerate":{"title":"Fai clic su Genera","description":"La traduzione verr\xe0 digitata nell\'app in corrispondenza del cursore."},"pasteMode":{"title":"Usa Incolla testo","description":"Incolla testo e lingua. Fai clic su Genera. Fai clic su Cancella per reimpostare."},"openTool":{"title":"Apri lo strumento Traduci testo","description":"Nel pannello Cephable, fare clic sulla carota accanto a Attivit\xe0 intelligenti e selezionare Traduci testo."}},"rowDescription":"Le attivit\xe0 intelligenti sono le diverse attivit\xe0 che l\'intelligenza artificiale di Cephable pu\xf2 svolgere per te. Queste attivit\xe0 sono basate sull\'intelligenza artificiale integrata nel dispositivo e possono essere utilizzate per creare testi, riassumere, riscrivere, tradurre e altro ancora."},"overview":{"title":"Panoramica","description":"Cephable \xe8 la tua intelligenza artificiale personale, progettata per azioni rapide, comandi vocali, generazione di contenuti e automazione intelligente su tutti i tuoi strumenti. Controlli pronti all\'uso. Nessuna elaborazione cloud. Solo produttivit\xe0 che si muove con te."},"customControls":{"tourLabel":"Controlli globali e dei dispositivi sempre disponibili","rowDescription":"I controlli globali e del dispositivo sono sempre disponibili se il microfono \xe8 attivo, indipendentemente dall\'app utilizzata. Puoi utilizzare questi controlli per interagire con il dispositivo senza dover creare nuovi controlli per le app. Contengono comandi utili come lo scambio di controlli o app, la generazione di testo, la messa in pausa del microfono e altro ancora."},"profile":{"tourLabel":"Controlli dell\'app","learn":"Scopri come impostare i controlli e le preferenze delle tue app in Cephable.","rowDescription":"I controlli delle app sono set di controlli configurati che puoi utilizzare per realizzare diverse azioni. Vuoi dire \\"Diapositiva successiva\\" per passare alla diapositiva successiva della presentazione? O usare i movimenti della testa per muovere il cursore e i comandi vocali per modificare le scorciatoie? Puoi farlo con i controlli delle app. La riga dei controlli mostra tutti i controlli disponibili per l\'app corrente.","check":{"title":"Controlla i controlli disponibili.","description":"I controlli app sono disponibili per ogni app che utilizzi. Qui puoi vedere i controlli disponibili per l\'app che stai utilizzando. Prova un altro comando per vedere come funziona. Assicurati per\xf2 di concentrarti sull\'app che desideri controllare."}},"dictation":{"tourLabel":"Dettatura","learn":"Scopri come usare la modalit\xe0 dettatura per convertire i tuoi discorsi in testo senza usare le mani.","welcome":{"title":"Dettatura","description":"La dettatura ti permette di parlare in modo naturale e di sentire le parole digitate mentre parli. \xc8 come avere un assistente personale che digita tutto quello che dici."},"microphone":{"title":"Accendi il microfono","description":"Per prima cosa, accendi il microfono. Fai clic sull\'interruttore del microfono nel pannello Cephable."},"activate":{"title":"Avvia la modalit\xe0 di dettatura","description":"La voce si avvia in modalit\xe0 comando. Per avviare la dettatura, pronuncia \\"Avvia dettatura\\" o fai clic sul pulsante Dettatura. Attiviamo ora la modalit\xe0 dettatura."},"focus":{"title":"Concentrati su un campo di testo o un documento","description":"La dettatura funziona meglio quando ci si concentra su un campo di testo o un documento. Fare clic sul campo di testo o sul documento in cui si desidera dettare."},"speaking":{"title":"Inizia a parlare","description":"Ora puoi iniziare a parlare. Tutto ci\xf2 che dici verr\xe0 digitato nel campo di testo o nel documento su cui ti sei concentrato. Prova a dire qualcosa come \\"Ciao, questo \xe8 un test della modalit\xe0 dettatura\\"."},"pauseResume":{"title":"Mettere in pausa la dettatura","description":"Hai bisogno di una pausa senza disattivare la dettatura? Basta dire \\"Metti in pausa la dettatura\\". Puoi riprendere la dettatura in qualsiasi momento premendo di nuovo \\"Avvia dettatura\\". Puoi personalizzare ulteriormente questa impostazione con i controlli globali e del dispositivo sempre attivi."},"stop":{"title":"Interruzione della dettatura","description":"Devi tornare ai controlli dell\'app? Basta dire \\"Interrompi dettatura\\". Questo interromper\xe0 la modalit\xe0 dettatura e ti riporter\xe0 alla modalit\xe0 comando. Puoi riprendere in qualsiasi momento premendo nuovamente \\"Avvia dettatura\\"."},"complete":{"description":"Ecco fatto! Ora puoi dettare, mettere in pausa, riprendere e passare dalla modalit\xe0 dettatura a quella di comando. La dettatura \xe8 un potente strumento per la digitazione a mani libere. Usala per scrivere email, documenti o qualsiasi altra cosa tu debba digitare ad alta voce."}},"camera":{"tourLabel":"Controlli della fotocamera","rowDescription":"I controlli della fotocamera ti consentono di usare il viso e il corpo per controllare il dispositivo. Puoi usare diverse espressioni facciali e movimenti della testa per controllare il dispositivo. Con il microfono attivo, puoi usare i comandi vocali per avviare e arrestare la fotocamera e cambiare fotocamera.","learn":"Scopri come usare i comandi della fotocamera per navigare e interagire con il tuo dispositivo senza usare le mani.","welcome":{"title":"Controlli della fotocamera","description":"I controlli della fotocamera ti consentono di usare il viso e il corpo per controllare il dispositivo. Puoi usare diverse espressioni facciali, movimenti della testa e comandi vocali per navigare e interagire con il dispositivo a mani libere."},"start":{"title":"Avvia i controlli della fotocamera","description":"Per iniziare a usare i controlli della telecamera se stai usando la voce, pronuncia \\"Avvia controlli della telecamera\\" o fai clic sul pulsante Controlli della telecamera."}},"microphone":{"tourLabel":"Comandi vocali","learn":"Scopri come usare la voce per controllare qualsiasi app e come usare la dettatura per scrivere ci\xf2 che dici.","description":"I controlli vocali Cephable ti permettono di usare la voce per controllare il tuo dispositivo. Vuoi salvare un documento? Di\' semplicemente \\"Salva\\". Vuoi mettere in pausa la musica? Di\' semplicemente \\"Pausa\\". La voce ti permette anche di usare la dettatura per digitare ci\xf2 che dici.","rowDescription":"Quando il microfono \xe8 disattivato, non ascolteremo affatto i tuoi comandi vocali, ma se lo attivi, potrai usare i comandi globali per attivare/disattivare pausa, avvio e altro ancora. Attiviamolo.","start":{"title":"Avvia i controlli vocali","description":"Per iniziare a utilizzare i comandi vocali, fai clic sull\'interruttore del microfono nel pannello Cephable. In questo modo, il microfono verr\xe0 attivato e inizier\xe0 ad ascoltare i comandi."},"tryOpen":{"title":"Prova a dire `Apri Spotify` o `Apri Word`","description":"`Apri` \xe8 un comando globale che aprir\xe0 l\'app specificata e le assegner\xe0 il focus. Se hai abilitato il cambio automatico dei controlli, passer\xe0 anche ai controlli dell\'app che meglio si adattano all\'app che stai utilizzando."},"finishedCommands":{"title":"Ottimo! Hai imparato le basi dei comandi vocali.","description":"Puoi sempre rivedere il tour dalla pagina di supporto. Il passo successivo \xe8 imparare a usare la dettatura. Puoi avviare il tour dalla pagina di supporto."}},"publicProfiles":{"tourLabel":"Personalizza i controlli dell\'app"},"tour":{"title":"Benvenuti a Cephable","description":"Cephable \xe8 un potente strumento che ti permette di controllare il tuo computer tramite voce, fotocamera e altri input. Questo tutorial ti guider\xe0 attraverso le funzionalit\xe0 principali e ti mostrer\xe0 come utilizzarle al meglio.","startTour":"Inizia il tour","finishTour":"Fine del tour","statusDialog":"Per maggiori informazioni consultare il pannello.","step":"Passo {{step}} di {{total}}","next":"Prossimo","previous":"Precedente","endTour":"Fine del tour","nextTourLabel":"Successivo: {{nextStepTitle}}","skipTour":"Salta il tour","steps":{"welcome":{"title":"Benvenuti a Cephable","description":"Questo tour ti guider\xe0 attraverso le funzionalit\xe0 principali di Cephable. Iniziamo!"},"inputs":{"title":"Panoramica degli input","description":"Cephable supporta diversi metodi di input, inclusi comandi vocali, controlli della fotocamera e altro ancora. \xc8 possibile personalizzare questi input nelle impostazioni."},"appControls":{"title":"Controlli dell\'app","description":"Crea controlli app per associare i tuoi input ad azioni specifiche nelle tue applicazioni. In questo modo puoi controllare le app con gesti, comandi vocali e altro ancora."},"settings":{"title":"Impostazioni","description":"Accedi alle impostazioni per configurare gli input, i controlli delle app e altre preferenze. Puoi anche gestire le impostazioni del tuo account e della lingua."},"intelligentTasks":{"title":"Compiti intelligenti","description":"Utilizza attivit\xe0 intelligenti per generare testo, riassumere contenuti, riscrivere testi, tradurre lingue e altro ancora utilizzando funzionalit\xe0 basate sull\'intelligenza artificiale."},"cameraControls":{"title":"Controlli della fotocamera","description":"Abilita i controlli della telecamera per utilizzare le espressioni facciali e i movimenti della testa come metodi di input per controllare il computer."},"voiceControls":{"title":"Comandi vocali","description":"Usa i comandi vocali per controllare il tuo computer senza usare le mani. Puoi dettare testo, impartire comandi e interagire con le applicazioni usando la voce."}}},"onboarding":{"demoPlaceholder":"Questo \xe8 il testo demo segnaposto. Utilizzando i prompt qui sopra puoi controllare lo stile di questo testo.","exit":"Esci dalla configurazione","overview":"Panoramica","learn":"Scopri le funzionalit\xe0 di Cephable e come utilizzarle.","start":"Sembra che tu abbia appena iniziato. Ecco alcuni aspetti che ti aiuteranno lungo il percorso.","startTour":"Per iniziare","dashboard":{"title":"Dashboard Cephable","description":"La dashboard di Cephable \xe8 il tuo hub centrale per la gestione del dispositivo, dei controlli delle app e delle impostazioni. Da qui puoi personalizzare la tua esperienza, visualizzare i comandi attivi e accedere a tutte le funzionalit\xe0 di Cephable."},"step1":{"title":"Benvenuti a Cephable","description":"Cephable \xe8 la tua intelligenza artificiale personale, progettata per azioni rapide, comandi vocali, generazione di contenuti e automazione intelligente su tutti i tuoi strumenti. Controlli pronti all\'uso. Nessuna elaborazione cloud. Solo produttivit\xe0 che si muove con te.","inputs":"Cosa sono gli input?","inputDescription":"I controlli di input sono i metodi per utilizzare il dispositivo, estendendo le capacit\xe0 del computer oltre i tradizionali mouse e tastiera. Questi metodi includono comandi vocali, movimenti della testa, espressioni facciali e periferiche aggiuntive.","profiles":"Cosa sono i controlli delle app?","profileDescription":"I controlli app ti consentono di connetterti e comunicare con il tuo computer in modi unici, abbinando controlli di input e output. Con i controlli app, puoi chiedere a Cephable di eseguire azioni come salvare un file inclinando la testa o cliccare su \\"Invia\\" su un\'e-mail con un sorriso.","action":"Esplora i controlli di input","secondaryAction":"Vai ai controlli dell\'app","secondaryActionDescription":"Conosci gi\xe0 i controlli di input?"},"finish":{"title":"Configurazione completata","description":"Hai utilizzato con successo i tuoi primi controlli app Cephable! Ora puoi utilizzarli e molto altro sul tuo dispositivo. Sono disponibili nella dashboard di Cephable, dove puoi continuare a personalizzare le impostazioni dei controlli app in base alle tue esigenze.","continueToApp":"Continua alla dashboard di Cephable","keepExploring":"Continua a esplorare"},"useCaseSlider":{"context":"Vorrei usare","control":"controllare"}},"support":{"tourLabel":"Pronti a saperne di pi\xf9?","description":"Per maggiori informazioni su come utilizzare Cephable, tra cui ulteriori tour, guide dettagliate, tutorial e video, puoi visitare il nostro hub di supporto.","cta":"Esplora altri tour"},"featureFlag":{"title":"\xc8 ora di aggiornare","description":"La funzionalit\xe0 che stai tentando di utilizzare richiede una licenza diversa. Esegui l\'upgrade per sbloccare questa e altre funzionalit\xe0."},"replyToSocialMedia":{"tourLabel":"Risposte pi\xf9 rapide sui social media con la dettatura","learn":"Scopri come usare la dettatura per rispondere ai post sui social media senza usare le mani.","navigateTo":{"title":"Vai a un post sui social media","description":"Apri il tuo browser web e accedi a una piattaforma social come LinkedIn o Facebook. Trova un post a cui vuoi rispondere."},"speaking":{"title":"Inizia a parlare","description":"Ora puoi iniziare a parlare. Tutto ci\xf2 che dirai verr\xe0 digitato nel campo di testo o nel documento su cui ti sei concentrato. Prova a dire qualcosa come \\"Congratulazioni! Sono emozionato per te\\". Assicurati che il cursore sia posizionato su un campo di testo o una casella di commento."},"complete":{"description":"Ecco fatto! Ora puoi usare le funzioni di dettatura, pausa, ripresa e alternare tra dettatura e comando per rispondere ai post sui social media senza usare le mani. La dettatura \xe8 uno strumento potente per la digitazione a mani libere. Usala per scrivere email, documenti o qualsiasi altra cosa tu debba digitare ad alta voce."}},"hotkeys":{"tourLabel":"Pulsanti di azione rapida","learn":"Scopri come impostare pulsanti di azione rapida per associare pi\xf9 azioni a un singolo pulsante.","rowDescription":"I pulsanti di azione rapida consentono di eseguire pi\xf9 azioni con un singolo comando. Ad esempio, puoi creare un pulsante che apre la tua app musicale preferita e avvia la riproduzione di una playlist specifica.","check":{"title":"Controlla le azioni rapide disponibili.","description":"I pulsanti di azione rapida sono disponibili per ogni app che utilizzi. Qui puoi vedere i pulsanti disponibili per l\'app che stai utilizzando. Prova un altro comando per vedere come funziona. MA assicurati di concentrarti sull\'app che desideri controllare."}},"controllingBackgroundMusic":{"tourLabel":"Gestisci la musica di sottofondo senza interrompere il tuo flusso","learn":"Scopri come utilizzare i comandi vocali e le azioni rapide per gestire la tua musica a mani libere, senza distrarti e concentrandoti sul tuo compito.","tryOpen":{"title":"Prova a dire `Apri Spotify` o `Apri Apple Music`"},"play":{"title":"Prova a dire `Riproduci` per iniziare a riprodurre la musica","description":"Assicurati che il microfono sia acceso e pronuncia il comando `Riproduci`. In questo modo verr\xe0 avviata la riproduzione della musica nell\'app musicale scelta. Questo funziona anche per qualsiasi altra app multimediale."},"newPlaylist":{"title":"Crea una nuova playlist","description":"Assicurati che il microfono sia acceso e pronuncia \\"Nuova playlist\\". Questo avvier\xe0 il processo di creazione di una nuova playlist nell\'app musicale scelta."},"finishedCommands":{"title":"Ottimo lavoro! Hai imparato a controllare la tua musica senza usare le mani.","description":"Ora sai come utilizzare i comandi vocali e le azioni rapide per riprodurre, mettere in pausa, saltare le tracce e regolare il volume nelle tue app musicali preferite. Prova a esplorare altri comandi o a personalizzare le tue azioni rapide per un controllo musicale ancora pi\xf9 fluido."}},"editingVideos":{"tourLabel":"Concentrati sulla storia, non sui noiosi clic per il montaggio video","learn":"Scopri come utilizzare i comandi vocali e le azioni rapide per modificare i video pi\xf9 velocemente ed eliminare il carico cognitivo di dover ricordare quali pulsanti cliccare durante la modifica.","tryOpen":{"title":"Prova a dire `Apri iMovie` o `Apri DaVinci Resolve`"},"play":{"title":"Prova a dire `Riproduci` per iniziare a riprodurre il tuo video","description":"Assicurati che il microfono sia acceso e pronuncia `Riproduci`. In questo modo verr\xe0 avviata la riproduzione del video nell\'app di editing video scelta."},"stop":{"title":"Interrompi la riproduzione video","description":"Assicurati che il microfono sia acceso e pronuncia `Stop`. Questo interromper\xe0 la riproduzione del video nell\'app di editing video che hai scelto."},"finishedCommands":{"title":"Ottimo lavoro! Hai imparato a controllare il tuo video editing senza usare le mani.","description":"Ora sai come utilizzare i comandi vocali e le azioni rapide per riprodurre, mettere in pausa, saltare tracce e regolare il volume nelle tue app di editing video preferite. Prova a esplorare altri comandi o a personalizzare le tue azioni rapide per un controllo video ancora pi\xf9 fluido."}},"vibeCoding":{"tourLabel":"Ideare, prototipare e ripetere pi\xf9 velocemente con la dettatura","learn":"Scopri come utilizzare la dettatura e la generazione di testo basata sull\'intelligenza artificiale per dare ritmo al codice, creare prototipi e ripetere le idee.","navigateTo":{"title":"Passare a un editor di codice Vibe","description":"Apri il tuo browser web e accedi a un editor di codice Vibe. Alcuni esempi sono Vercel V0, GitHub Copilot in VS Code, Base 44 e Lovable."},"focus":{"title":"Fai clic su Nuova chat o seleziona una casella di testo","description":"La dettatura funziona meglio quando ci si concentra su un campo di testo o un documento. Fare clic sulla casella dei commenti o sul thread di risposta in cui si desidera dettare. Quindi iniziare a parlare."},"speaking":{"title":"Inizia a parlare","description":"Ora puoi iniziare a parlare. Tutto ci\xf2 che dirai verr\xe0 digitato nel campo di testo o nel documento su cui ti sei concentrato. Prova a specificare i tuoi requisiti tecnici e cosa dovrebbe fare il codice. Assicurati che il cursore sia posizionato su un campo di testo o una casella di commento."},"rewriteIntro":{"title":"Riscrivi il codice con le istruzioni","description":"Puoi anche utilizzare le attivit\xe0 intelligenti come Rewrite per modificare il codice esistente. Questa attivit\xe0 \xe8 basata sull\'intelligenza artificiale integrata nel dispositivo, il che significa che funziona anche senza connessione a Internet ed \xe8 eseguibile direttamente dal tuo dispositivo."},"highlightText":{"title":"Evidenzia il testo da riscrivere","description":"Evidenzia il codice che vuoi riscrivere."},"enterInstructions":{"title":"Inserisci le istruzioni di riscrittura","description":"Digita le istruzioni di riscrittura del codice. Specifica il linguaggio di programmazione, lo stile o eventuali modifiche specifiche che desideri."},"complete":{"description":"Ecco fatto! Ora puoi dettare, mettere in pausa, riprendere e iterare sul codice. Continua a esplorare altri casi d\'uso con Dettatura e Attivit\xe0 intelligenti, o altre funzionalit\xe0 per ottimizzare il tuo flusso di lavoro."}},"documentCode":{"tourLabel":"Documentazione del codice rapida e sicura con generazione di testo AI sul dispositivo","learn":"Scopri come utilizzare la riscrittura basata sull\'intelligenza artificiale per documentare il codice, rimanendo nella stessa app e mantenendo i tuoi dati al sicuro.","rewriteIntro":{"title":"Scrivi la documentazione del codice","description":"\xc8 possibile utilizzare Cephable Intelligent Rewrite per scrivere la documentazione del codice in un documento o in un\'app separata. La riscrittura fa parte delle attivit\xe0 di intelligenza artificiale sul dispositivo, tra cui Generazione e Traduzione offline."},"focusApp":{"title":"Concentrati sul tuo codice","description":"Apri l\'IDE e concentrati sul codice che vuoi documentare."},"newFile":{"title":"Creare un file di documentazione","description":"Crea un nuovo file nel tuo IDE oppure apri un\'app separata in cui desideri che venga visualizzata la documentazione."},"highlightText":{"title":"Evidenzia il codice","description":"Evidenzia e copia il codice che vuoi documentare."},"pasteMode":{"title":"Fare clic sulla scheda Incolla testo","description":"Utilizzare la modalit\xe0 Incolla per incollare il codice originale e scrivere la documentazione in un nuovo file."},"pasteInput":{"title":"Incolla il codice nel documento","description":"Incolla il codice che vuoi documentare nella casella di input."},"enterInstructions":{"title":"Inserisci le istruzioni di formattazione, stile e contenuto","description":"Digita le istruzioni per la documentazione del codice. Specifica il tipo di file (ad esempio markdown), lo stile o qualsiasi contenuto specifico desideri."},"complete":{"description":"Hai imparato a utilizzare le Attivit\xe0 Intelligenti per una documentazione del codice rapida e sicura. Continua a esplorare altri casi d\'uso con Rewrite o altre funzionalit\xe0 per ottimizzare il tuo flusso di lavoro."}},"generateCode":{"tourLabel":"Generazione di codice rapida e sicura con generazione di testo AI sul dispositivo","learn":"Scopri come utilizzare la generazione basata sull\'intelligenza artificiale per creare frammenti di codice durante lo spostamento tra le app e mantenendo i tuoi dati al sicuro.","rewriteIntro":{"title":"Scrivi frammenti di codice","description":"Puoi utilizzare Cephable Intelligent Rewrite per scrivere frammenti di codice nel tuo IDE mentre ottieni requisiti da un\'altra applicazione. Rewrite fa parte delle attivit\xe0 di intelligenza artificiale sul dispositivo, tra cui Generazione e Traduzione offline."},"focusApp":{"title":"Concentrati sul contenuto del tuo biglietto","description":"Apri il ticket che specifica i requisiti e concentrati sul contenuto per cui vuoi generare il codice."},"newFile":{"title":"Creare un file di frammenti di codice","description":"Crea un nuovo file nel tuo IDE."},"highlightText":{"title":"Evidenzia il contenuto del biglietto","description":"Evidenzia e copia il contenuto per cui vuoi generare il codice."},"pasteMode":{"title":"Fare clic sulla scheda Incolla testo","description":"Utilizzare la modalit\xe0 Incolla per incollare i requisiti del biglietto originale e scrivere frammenti di codice per essi."},"pasteInput":{"title":"Incolla i requisiti per generare il codice","description":"Incolla nella casella di input i requisiti che desideri utilizzare per la generazione del codice."},"enterInstructions":{"title":"Inserisci le istruzioni del linguaggio e dello stile di programmazione","description":"Digita le istruzioni per il linguaggio di programmazione e lo stile. Specifica il linguaggio di programmazione (ad esempio C#), lo stile o eventuali istruzioni di codifica specifiche di cui disponi."},"translateIntro":{"title":"Traduci frammenti di codice","description":"Puoi anche utilizzare Cephable Intelligent Translate per convertire frammenti di codice da un linguaggio di programmazione a un altro direttamente nel tuo IDE. Translate fa parte delle attivit\xe0 di intelligenza artificiale sul dispositivo, tra cui Generazione e riscrittura offline."},"copyGeneratedCode":{"title":"Copia il codice generato","description":"Dopo aver generato il codice seguendo i passaggi precedenti, evidenzia e copia il frammento di codice generato."},"translatePasteMode":{"title":"Fare clic sulla scheda Incolla testo","description":"Utilizzare la modalit\xe0 Incolla per incollare il codice originale e tradurlo in un altro linguaggio di programmazione."},"enterProgrammingLanguage":{"title":"Inserisci il linguaggio di programmazione di destinazione","description":"Digita il linguaggio di programmazione in cui vuoi tradurre il codice (ad esempio Python)."},"pasteCode":{"title":"Incolla il codice generato nel tuo IDE","description":"Vai all\'IDE e incolla il frammento di codice copiato nel nuovo file creato in precedenza."},"complete":{"description":"Hai imparato a utilizzare le Attivit\xe0 Intelligenti per generare e tradurre codice in modo rapido e sicuro. Continua a esplorare altri casi d\'uso con Genera e Traduci, o altre funzionalit\xe0 per ottimizzare il tuo flusso di lavoro."}},"requirementDocsFromMeeting":{"tourLabel":"Dalle note ai documenti sui requisiti del prodotto in pochi minuti","learn":"Scopri come utilizzare le attivit\xe0 intelligenti dell\'intelligenza artificiale per creare documenti strutturati sui requisiti di prodotto a partire dagli appunti delle riunioni, mantenendo al contempo la sicurezza dei tuoi dati.","rewriteIntro":{"title":"Creare documenti sui requisiti del prodotto","description":"\xc8 possibile utilizzare Cephable Intelligent Rewrite per creare documenti strutturati sui requisiti di prodotto a partire dagli appunti delle riunioni. Rewrite fa parte delle attivit\xe0 di intelligenza artificiale sul dispositivo, tra cui Generazione e Traduzione offline."},"focusNotes":{"title":"Apri le note della riunione","description":"Apri gli appunti della riunione, le trascrizioni o altri contenuti di testo correlati alla riunione."},"highlight":{"title":"Evidenziare gli appunti della riunione","description":"Evidenzia gli appunti della riunione che vuoi utilizzare per creare un documento sui requisiti del prodotto."},"enterInstructions":{"title":"Inserisci la struttura del documento e le istruzioni sul contenuto","description":"Digita le istruzioni del documento sui requisiti del prodotto. Specifica la struttura, lo stile o qualsiasi contenuto specifico desideri."},"complete":{"description":"Hai imparato a utilizzare le Attivit\xe0 Intelligenti per creare documenti sui requisiti di prodotto in modo rapido e sicuro. Continua a esplorare altri casi d\'uso con Rewrite o altre funzionalit\xe0 per ottimizzare il tuo flusso di lavoro."}},"headMouseMovement":{"tourLabel":"Configurazione di gioco a mani libere con Head Mouse","learn":"Scopri come usare i movimenti della testa per controllare il cursore del mouse e ottenere una navigazione e un clic precisi.","deviceSettings":{"title":"Apri Impostazioni dispositivo","description":"Per abilitare i movimenti del mouse tramite la testa, fare clic sul pulsante Impostazioni dispositivo."},"cameraSettings":{"title":"Apri le impostazioni della fotocamera","description":"Nelle Impostazioni dispositivo, fare clic su Impostazioni fotocamera per accedere ai controlli della fotocamera."},"headMouseSection":{"title":"Movimento della testa per i controlli del mouse","description":"Quando questa opzione \xe8 attivata, alcuni dei controlli per il movimento della testa verranno utilizzati per muovere il mouse anzich\xe9 i controlli di attivazione."},"steadyGlide":{"title":"Modalit\xe0 di planata costante","description":"Attiva la modalit\xe0 Steady Glide. Quando muovi la testa oltre un certo punto, il cursore scivola continuamente in quella direzione a velocit\xe0 costante."},"customization":{"title":"Personalizza le impostazioni del mouse sulla testa","description":"Puoi personalizzare le impostazioni del mouse in base alle tue preferenze. Regola velocit\xe0, sensibilit\xe0 e altre impostazioni per ottenere la migliore esperienza."},"save":{"title":"Salva le impostazioni del mouse sulla testa","description":"Non dimenticare di salvare le impostazioni personalizzate del mouse."},"transition":{"title":"Passaggio al pannello Cephable","description":"Passiamo ora al pannello Cephable per provare i movimenti della testa del mouse."},"playGames":{"title":"Gioca con il mouse sulla testa","description":"Ora puoi usare i movimenti della testa per controllare il cursore del mouse mentre giochi. Provalo e scopri come funziona!"}},"clinicalNoteTaking":{"tourLabel":"Dettatura e formattazione conformi all\'HIPAA per i medici","learn":"Scopri come utilizzare i comandi vocali, la dettatura intelligente e la formattazione basata sull\'intelligenza artificiale per prendere appunti clinici.","speaking":{"title":"Inizia a parlare","description":"Ora puoi iniziare a parlare. Tutto ci\xf2 che dirai verr\xe0 digitato nel campo di testo o nel documento su cui ti sei concentrato. Prova a dire qualcosa come: \\"Il paziente \xe8 un uomo di 45 anni con una storia di ipertensione. L\'ultimo farmaco prescritto non ha funzionato come previsto e ha causato una reazione allergica. Dovremo verificare la presenza di farmaci alternativi e vorrebbero una prescrizione di un farmaco generico\\"."},"rewriteIntro":{"title":"Formatta le tue note","description":"Ora puoi usare Cephable Intelligent Rewrite per formattare le tue note in stile SOAP. Tutto questo avviene direttamente sul dispositivo, il che significa che i tuoi dati rimangono privati, sicuri e conformi allo standard HIPAA."},"copyText":{"title":"Copia le note","description":"Dopo aver evidenziato le note, copia il testo per prepararlo alla formattazione."},"pasteMode":{"title":"Fare clic sulla scheda Incolla testo","description":"Utilizzare la modalit\xe0 Incolla per incollare le note originali e formattarle in stile SOAP."},"pasteInput":{"title":"Incolla le note nel formato","description":"Incolla le note che vuoi formattare nella casella di input."},"enterInstructions":{"title":"Inserisci le istruzioni di formattazione","description":"Puoi scrivere istruzioni di formattazione che dovranno essere seguite per il tuo sistema clinico/EHR. (Ad esempio, formatta in stile SOAP con titoli, punti elenco e linguaggio conciso.)"},"navigateToEHR":{"title":"Accedi al tuo sistema EHR","description":"Apri il tuo sistema EHR e vai alla sezione in cui desideri inserire le note formattate."},"focusTextField":{"title":"Concentrati sul campo di testo","description":"Fare clic sul campo di testo in cui si desidera incollare le note formattate."},"complete":{"description":"Hai imparato a utilizzare i comandi vocali e la dettatura intelligente per documentare le note cliniche, e la riscrittura intelligente per formattarle in stile SOAP. Continua a esplorare altri casi d\'uso con la dettatura e la riscrittura, o altre funzionalit\xe0 per ottimizzare il tuo flusso di lavoro."},"focus":{"title":"Concentrati su un documento","description":"La dettatura funziona meglio quando ci si concentra su un documento. Apri un documento in cui vuoi prendere appunti clinici tra una sessione e l\'altra."}},"webBrowsing":{"tourLabel":"Pianifica viaggi, fai acquisti online e naviga sul Web utilizzando la voce","learn":"Scopri come usare i comandi vocali per navigare, scorrere e compilare moduli mentre navighi sul Web senza usare le mani.","tryOpen":{"title":"Prova a dire `Apri Chrome` o `Apri Edge`","description":"Assicurati che il microfono sia attivo e pronuncia \\"Apri Chrome\\" o \\"Apri Edge\\". Verr\xe0 aperto il browser web scelto. Se hai attivato il cambio automatico dei controlli, verranno utilizzati anche i controlli dell\'app pi\xf9 adatti all\'app che stai utilizzando."},"search":{"title":"Ricerca","description":"Prova a dire \\"Cerca\\" o \\"Cerca\\". In questo modo verr\xe0 focalizzata la barra di ricerca nel tuo browser."},"quickType":{"title":"Digitazione rapida","description":"La Digitazione Rapida ti consente di digitare usando la voce senza essere in modalit\xe0 dettatura. Prova a dire \\"Scrivi che tempo fa oggi\\". In questo modo, la tua query verr\xe0 digitata nella barra di ricerca."},"enter":{"title":"Premi Invio","description":"Prova a dire \\"Invio\\". Verr\xe0 eseguita la query di ricerca appena digitata."},"scrollDown":{"title":"Scorrere verso il basso","description":"Prova a dire \\"Scorri verso il basso\\". In questo modo la pagina web scorrer\xe0 verso il basso."},"scrollUp":{"title":"Scorri verso l\'alto","description":"Prova a dire \\"Scorri verso l\'alto\\". In questo modo la pagina web scorrer\xe0 verso l\'alto."},"newTab":{"title":"Apri una nuova scheda","description":"Prova a dire \\"Nuova scheda\\". Si aprir\xe0 una nuova scheda nel tuo browser."},"formsCustomization":{"title":"Personalizzazione della compilazione dei moduli","description":"Puoi personalizzare i controlli di questa app per compilare facilmente i moduli, ad esempio inserendo nome, cognome, indirizzo email, ecc. Puoi anche usare le azioni rapide o i comandi vocali per compilare i moduli ancora pi\xf9 velocemente."},"complete":{"title":"Ottimo lavoro!","description":"Ora sai come utilizzare i comandi vocali e le azioni rapide per navigare, cercare, scorrere e compilare moduli mentre navighi sul web. Prova a esplorare altri comandi o a personalizzare le tue azioni rapide per una navigazione web ancora pi\xf9 fluida."}},"spreadsheetReviews":{"tourLabel":"Lavora pi\xf9 velocemente nei fogli di calcolo con i comandi vocali","learn":"Scopri come utilizzare i comandi vocali e le azioni rapide per rivedere e modificare rapidamente fogli di calcolo di grandi dimensioni.","tryOpen":{"title":"Prova a dire `Apri Excel` o `Apri Fogli Google`","description":"Assicurati che il microfono sia acceso e pronuncia \\"Apri Excel\\" o \\"Apri Fogli Google\\". Verr\xe0 aperta l\'app per fogli di calcolo scelta. Se hai attivato il cambio automatico dei controlli, verranno utilizzati anche i controlli pi\xf9 adatti all\'app che stai utilizzando."},"selectRow":{"title":"Seleziona una riga","description":"Fai clic su una cella. Quindi, prova a dire \\"Seleziona riga\\". In questo modo verr\xe0 selezionata l\'intera riga della cella evidenziata."},"delete":{"title":"Elimina il contenuto di una riga","description":"Prova a dire \\"Elimina\\". In questo modo eliminerai il contenuto della riga selezionata."},"note":{"title":"Aggiungi una nota a una cella","description":"Fai clic su una cella. Quindi, prova a dire \\"Aggiungi nota\\". Questo ti permetter\xe0 di aggiungere una nota alla cella evidenziata."},"addNote":{"title":"Digita la nota","description":"Prova a dire \\"Digita Questi numeri non corrispondono\\". In questo modo la nota verr\xe0 digitata nella cella."},"currentDate":{"title":"Inserisci la data corrente","description":"Fai clic su una cella. Quindi, prova a dire \\"Data corrente\\". In questo modo, la data corrente verr\xe0 inserita nella cella evidenziata."},"copy":{"title":"Copia una cella","description":"Fai clic sulla cella a cui hai appena aggiunto la data corrente. Quindi, prova a dire \\"Copia\\". In questo modo, la data corrente verr\xe0 copiata."},"selectColumn":{"title":"Seleziona una colonna","description":"Prova a dire \\"Colonna\\". In questo modo verr\xe0 selezionata l\'intera colonna per la cella evidenziata."},"paste":{"title":"Incolla la data corrente","description":"Prova a dire \\"Incolla\\". In questo modo la data corrente verr\xe0 incollata nella colonna selezionata."},"quickActions":{"title":"Utilizzare le azioni rapide","description":"Puoi anche eseguire molti di questi controlli e altro ancora con i pulsanti Azione rapida. Puoi personalizzare questi pulsanti per adattarli al tuo flusso di lavoro e rendere ancora pi\xf9 veloce la revisione e la modifica dei fogli di calcolo."},"complete":{"description":"Ora sai come utilizzare i comandi vocali e le azioni rapide per rivedere e modificare rapidamente fogli di calcolo di grandi dimensioni. Prova a esplorare altri comandi o a personalizzare le tue azioni rapide per una gestione pi\xf9 rapida dei fogli di calcolo."}},"socialMediaWriting":{"tourLabel":"Crea, ripeti e pubblica contenuti sui social media con la voce e l\'intelligenza artificiale sul dispositivo","learn":"Scopri come utilizzare Intelligent Generate and Rewrite, una funzionalit\xe0 completamente privata e integrata nel dispositivo, per creare e modificare i contenuti.","onDeviceIntro":{"title":"La tua ricerca rimane privata e sicura","description":"Le attivit\xe0 intelligenti di Cephable sono basate sull\'intelligenza artificiale integrata nel dispositivo, il che significa che i tuoi dati rimangono privati e al sicuro. Puoi creare, riscrivere e tradurre testi senza alcuna elaborazione cloud. Puoi anche utilizzare il contesto multi-applicazione e iterare sulle idee direttamente nella tua app preferita."},"enterPrompt":{"title":"Inizia a ideare","description":"Nella casella di input, scrivi un prompt per il contenuto che desideri creare o generare. Ad esempio, puoi inserire: \\"Elenca i rischi dell\'intelligenza artificiale agentiva, dove si trovano alcune lacune e come l\'innovazione pu\xf2 progredire\\"."},"customizeSettings":{"title":"Personalizza le impostazioni di generazione","description":"Puoi personalizzare le impostazioni di generazione in base alle tue preferenze. Regolale con i prompt di sistema che riflettono il tono, la voce del brand e altro ancora."},"rewriteIntro":{"title":"Ripetizione del contenuto","description":"Puoi utilizzare Cephable Intelligent Rewrite per iterare i contenuti direttamente nella tua app preferita. Tutto questo avviene direttamente sul dispositivo, il che significa che i tuoi dati rimangono privati e al sicuro."},"highlightText":{"title":"Evidenzia il testo da riscrivere","description":"Evidenzia uno dei rischi elencati nel contenuto generato su cui vuoi continuare a lavorare."},"enterInstructions":{"title":"Inserisci le istruzioni di riscrittura","description":"Digita le istruzioni per la riscrittura. Ad esempio, puoi inserire: \\"Aggiungi maggiori dettagli sui rischi\\"."},"writeSocialMediaPost":{"title":"Scrivi un post sui social media","description":"Utilizza nuovamente la riscrittura per riformattare questo linguaggio in un post sui social media rivolto al pubblico, che coglie i punti chiave e mette in evidenza le aree di coinvolgimento."},"highlightPost":{"title":"Evidenzia il post generato","description":"Evidenzia il post generato sui social media che desideri utilizzare."},"enterPostInstructions":{"title":"Inserisci le istruzioni per la pubblicazione","description":"Inserisci le istruzioni per il tuo post. Ad esempio, puoi scrivere: \\"Rendilo conciso e accattivante per LinkedIn\\"."},"complete":{"description":"Ora puoi aprire la tua piattaforma social preferita, concentrarti sulla casella di testo per la creazione del post e incollare il post generato. Oppure puoi continuare a iterare e perfezionare finch\xe9 non sei pronto!"}},"inboxTriage":{"tourLabel":"Gestione efficiente della posta elettronica con intelligenza artificiale vocale e sui dispositivi","learn":"Scopri come utilizzare i comandi vocali e le attivit\xe0 intelligenti per gestire la tua casella di posta in modo efficiente, mantenendo al sicuro i tuoi dati.","tryOpen":{"title":"Prova a dire `Apri Outlook` o `Apri Gmail`","description":"Assicurati che il microfono sia acceso e pronuncia \\"Apri Outlook\\" o \\"Apri Gmail\\". Verr\xe0 aperta l\'app di posta elettronica scelta. Se hai attivato il cambio automatico dei controlli, verranno utilizzati anche i controlli pi\xf9 adatti all\'app che stai utilizzando."},"select":{"title":"Seleziona un\'e-mail","description":"Fai clic su un\'e-mail. Quindi, prova a dire \\"Seleziona e-mail\\". In questo modo verr\xe0 selezionata l\'e-mail evidenziata."},"delete":{"title":"Elimina un\'e-mail","description":"Prova a dire \\"Elimina\\". In questo modo eliminerai l\'email selezionata."},"reply":{"title":"Rispondi a un\'e-mail","description":"Fai clic su un\'e-mail. Quindi, prova a dire \\"Rispondi\\". Si aprir\xe0 la finestra di risposta per l\'e-mail evidenziata."},"dictateIntro":{"title":"Detta la tua risposta","description":"Puoi usare la dettatura per scrivere la tua risposta senza usare le mani. Assicurati che il microfono sia acceso e che la modalit\xe0 dettatura sia attivata."},"dictateReply":{"title":"Inizia a rispondere","description":"Prova a scrivere \\"Sono interessato a saperne di pi\xf9 sui vostri servizi. Vi prego di inviarmi ulteriori informazioni\\". In questo modo, la tua risposta verr\xe0 scritta nell\'e-mail. Assicurati di concentrarti sulla casella di testo della risposta."},"newEmail":{"title":"Crea una nuova email","description":"Prova a dire \\"Nuova email\\". Si aprir\xe0 una nuova finestra per la composizione di un\'email."},"customEmailTemplates":{"title":"Modelli di posta elettronica personalizzati","description":"Puoi creare modelli di email personalizzati per le risposte pi\xf9 comuni. Questo ti permetter\xe0 di inserire rapidamente contenuti preimpostati nelle tue email utilizzando comandi vocali o azioni rapide."},"editAppControls":{"title":"Modifica controlli app","description":"Per creare un modello di email personalizzato, fare clic sul pulsante Modifica controlli app."},"addNewControl":{"title":"Aggiungi nuovo controllo","description":"Nell\'editor App Controls, fare clic sul pulsante Aggiungi nuovo controllo."},"quickAction":{"title":"Seleziona Azione rapida","description":"Selezionare Azione rapida come tipo di controllo."},"templateName":{"title":"Assegna un nome al tuo modello","description":"Assegna un nome al tuo modello di posta elettronica personalizzato, ad esempio \\"Richiesta di riunione\\"."},"eventType":{"title":"Seleziona il tipo di evento","description":"Nella sezione Tipo di evento, seleziona \\"tipo\\" come tipo di evento."},"typeSteps":{"title":"Tipo Modello Contenuto","description":"Digita il contenuto del tuo modello di email. Ad esempio, puoi inserire: \\"Lead Outreach\\nBuongiorno, vorrei fissare un incontro per discutere di potenziali opportunit\xe0 di collaborazione. Per favore, fammi sapere se sei disponibile.\\""},"finish":{"title":"Completa la creazione del modello","description":"Fare clic sul pulsante Fine per completare la creazione del modello di posta elettronica personalizzato."},"saveTemplate":{"title":"Salva il tuo modello","description":"Fare clic sul pulsante Salva per salvare il modello di posta elettronica personalizzato."},"focusApp":{"title":"Riconcentrati sulla tua app di posta elettronica","description":"Torna alla tua app di posta elettronica e assicurati di concentrarti sulla nuova riga dell\'oggetto dell\'email."},"useTemplate":{"title":"Usa il tuo modello","description":"Ora puoi utilizzare il tuo modello di email personalizzato pronunciandone il nome o cliccando sul pulsante Azione rapida."},"generateIntro":{"title":"Genera contenuto e-mail","description":"Puoi anche utilizzare Cephable Intelligent Generate per creare contenuti email direttamente nella tua app di posta elettronica. Tutto questo avviene direttamente sul dispositivo, il che significa che i tuoi dati rimangono privati e al sicuro."},"enterPrompt":{"title":"Inserisci richiesta e-mail","description":"Nella casella di richiesta, digita: Scrivi un\'e-mail professionale a un potenziale cliente presentando i nostri servizi e richiedendo un incontro."},"focusNewEmail":{"title":"Concentrati sulla nuova email","description":"Assicurati di concentrarti sulla nuova finestra di composizione dell\'e-mail in cui desideri che venga visualizzato il testo generato."},"translateEmail":{"title":"Traduci il contenuto dell\'email","description":"Puoi utilizzare Cephable Intelligent Translate per tradurre il contenuto delle email direttamente nella tua app di posta elettronica. Tutto questo avviene direttamente sul dispositivo, il che significa che i tuoi dati rimangono privati e al sicuro."},"highlightText":{"title":"Evidenzia il contenuto dell\'email","description":"Evidenzia il contenuto di un\'e-mail lunga che vuoi tradurre."},"enterLanguage":{"title":"Inserisci la lingua della traduzione","description":"Digita la lingua della traduzione. Ad esempio, puoi inserire: \\"Spagnolo\\"."},"complete":{"description":"Ora sai come utilizzare i comandi vocali e le Attivit\xe0 Intelligenti per navigare, rispondere, dettare, generare e tradurre email mantenendo al sicuro i tuoi dati. Prova a esplorare altri comandi o a personalizzare le tue azioni rapide per una gestione delle email ancora pi\xf9 fluida."}},"handsFreeMeeting":{"tourLabel":"Controlli rapidi per riunioni a mani libere","learn":"Risparmia tempo e riduci l\'affaticamento delle riunioni virtuali con i controlli rapidi delle riunioni a mani libere","tryOpen":{"title":"Prova a dire `Apri Zoom` o `Apri Teams`","description":"Assicurati che il microfono sia acceso e pronuncia \\"Apri Zoom\\" o \\"Apri Teams\\". Verr\xe0 aperta l\'app per riunioni scelta. Se hai attivato il cambio automatico dei controlli, verranno utilizzati anche i controlli pi\xf9 adatti all\'app che stai utilizzando."},"mute":{"title":"Prova a dire `Attiva/Disattiva audio` per disattivare il microfono","description":"Assicurati che il microfono sia acceso e pronuncia \\"Attiva/Disattiva audio\\". In questo modo il microfono verr\xe0 disattivato nell\'app per riunioni scelta."},"video":{"title":"Prova a dire \\"Attiva/disattiva video\\" per accendere o spegnere la videocamera","description":"Assicurati che il microfono sia acceso e pronuncia \\"Attiva/disattiva video\\". In questo modo la videocamera verr\xe0 attivata o disattivata nell\'app per riunioni scelta."},"raiseHand":{"title":"Prova a dire `Alza la mano` per alzare la mano","description":"Assicurati che il microfono sia acceso e pronuncia \\"Alza la mano\\". In questo modo alzerai la mano nell\'app per riunioni che hai scelto."},"quickType":{"title":"Digitazione rapida","description":"Assicurati che il microfono sia acceso e pronuncia \\"Digitare \xe8 una funzione fantastica\\". Questo ti permetter\xe0 di digitare rapidamente usando la voce senza essere in modalit\xe0 dettatura. Assicurati di essere concentrato su un campo di testo nell\'app per le riunioni."},"complete":{"description":"Ora sai come utilizzare i comandi vocali e le azioni rapide per disattivare/riattivare l\'audio, attivare/disattivare il video, alzare la mano e digitare rapidamente nelle tue app per riunioni preferite. Prova a esplorare altri comandi o a personalizzare le tue azioni rapide per un controllo ancora pi\xf9 fluido della riunione."}},"summarizingReports":{"tourLabel":"Riepiloga report e documenti con l\'intelligenza artificiale sul dispositivo","learn":"Scopri come utilizzare la sintesi basata sull\'intelligenza artificiale per ottenere rapidamente i punti chiave da lunghi report e documenti, mantenendo al sicuro i tuoi dati riservati e proprietari.","summarizeIntro":{"title":"Riassumi il testo","description":"Puoi utilizzare Cephable Intelligent Tasks per ottenere rapidamente i punti chiave da report e documenti lunghi. Summarize fa parte delle On-device AI Tasks, il che significa che funziona senza connessione a Internet ed \xe8 eseguibile dal tuo dispositivo."},"navigateToReport":{"title":"Concentrati sul tuo report o documento","description":"Apri il tuo report o documento nell\'app che preferisci e concentrati sul testo che vuoi riassumere."},"highlightText":{"title":"Evidenzia il testo per riassumere","description":"Evidenzia il testo che vuoi riassumere."},"copyText":{"title":"Copia il testo","description":"Dopo aver evidenziato il testo, copialo per prepararlo alla sintesi."},"enterPrompt":{"title":"Inserisci le istruzioni di riepilogo","description":"Digita le istruzioni per il riepilogo. Specifica la lunghezza, lo stile o qualsiasi altro contenuto specifico desideri."},"pasteText":{"title":"Incolla il contenuto del tuo report","description":"Dopo le istruzioni, incolla il testo copiato nella casella di input."},"focusChatApp":{"title":"Concentrati sulla tua app di chat","description":"Apri la tua app di chat, come Teams o Slack, e concentrati sulla casella di testo in cui desideri che venga visualizzato il testo riassuntivo."},"rewriteIntro":{"title":"Riscrivi il testo riassuntivo","description":"Puoi anche utilizzare Cephable Intelligent Rewrite per perfezionare ulteriormente il testo riassuntivo. Tutto questo avviene direttamente sul dispositivo, il che significa che i tuoi dati rimangono privati e al sicuro."},"highlightSummary":{"title":"Evidenzia il testo riassunto","description":"Evidenzia il testo riassuntivo che vuoi ulteriormente perfezionare."},"enterRewriteInstructions":{"title":"Inserisci le istruzioni di riscrittura","description":"Digita le istruzioni per la riscrittura. Specifica il tono, lo stile o eventuali modifiche specifiche che desideri."},"complete":{"description":"Hai imparato a utilizzare le Attivit\xe0 Intelligenti per una sintesi testuale rapida e sicura, utile per condividere i risultati con il tuo team. Continua a esplorare altri casi d\'uso con Riepiloga e Riscrivi, o altre funzionalit\xe0 per ottimizzare il tuo flusso di lavoro."}},"congrats":"Congratulazioni!","noteTakingAndDocumentation":{"tourLabel":"Prendere appunti e generare documenti utilizzando l\'intelligenza artificiale privata sul dispositivo","learn":"Scopri come utilizzare i comandi vocali, la dettatura intelligente e le attivit\xe0 basate sull\'intelligenza artificiale per passare pi\xf9 velocemente dagli appunti ai progetti e ai documenti.","focus":{"title":"Concentrarsi su un campo di testo o un documento","description":"La dettatura funziona meglio quando ci si concentra su un campo di testo o un documento. Apri un documento o fai clic su un campo di testo in cui desideri prendere appunti."},"speaking":{"title":"Inizia a parlare","description":"Ora puoi iniziare a parlare. Mentre rifletti sulla tua idea, parla in modo naturale e lascia fluire i tuoi pensieri. Tutto ci\xf2 che dirai verr\xe0 digitato nel campo di testo o nel documento su cui ti sei concentrato. Prova a descrivere il tuo concept, a delineare i passaggi o a fare brainstorming liberamente. Ad esempio, di\': \\"Sto valutando un nuovo flusso di lavoro per il nostro team. Per prima cosa, dovremmo automatizzare il processo di reporting, quindi rivedere i risultati settimanalmente\\". Assicurati che il cursore sia posizionato sul documento."},"typeEnter":{"title":"Interruzioni di paragrafo","description":"Per creare interruzioni di paragrafo, basta premere Invio sulla tastiera. Questo ti aiuter\xe0 a organizzare i tuoi appunti in sezioni chiare. Continua a esprimere i tuoi pensieri o a trascrivere ci\xf2 che sta parlando qualcun altro."},"rewriteIntro":{"title":"Crea progetti","description":"Ora puoi usare Cephable Intelligent Rewrite per prendere appunti e trasformarli in un\'idea per una funzionalit\xe0 o in azioni di follow-up. Tutto questo avviene direttamente sul dispositivo, il che significa che i tuoi dati rimangono privati e al sicuro."},"highlightText":{"title":"Evidenzia le note","description":"Seleziona tutte le note che vuoi utilizzare per creare un progetto o un documento."},"inPlaceReplacement":{"title":"Ideazione sul posto","description":"Ora useremo la sostituzione sul posto per trasformare le tue note in un progetto o in un documento. Puoi sempre usare la modalit\xe0 Incolla o l\'opzione per creare un nuovo file."},"enterInstructions":{"title":"Inserisci le istruzioni di progettazione","description":"Puoi scrivere le istruzioni per i passaggi successivi, specificando cosa vorresti fare con le note. Potrebbe trattarsi di formattazione, progettazione, attivit\xe0 di follow-up o qualsiasi altra cosa. (Ad esempio, crea un documento di progettazione che evidenzi il funzionamento della funzionalit\xe0, l\'aspetto finale e le possibili conseguenze per il successo)."},"complete":{"description":"Hai imparato a utilizzare i comandi vocali e la dettatura intelligente per documentare le note cliniche, e la riscrittura intelligente per formattarle in stile SOAP. Continua a esplorare altri casi d\'uso con la dettatura e la riscrittura, o altre funzionalit\xe0 per ottimizzare il tuo flusso di lavoro."}},"fpsGamePlay":{"tourLabel":"Gioca ai giochi FPS con i comandi vocali","learn":"Scopri come usare i comandi vocali e le azioni rapide per giocare ai giochi FPS.","changeProfile":{"title":"Profilo di controllo delle modifiche","description":"Imposta il controllo dell\'app sul profilo di gioco FPS. Puoi personalizzarlo anche per il gioco specifico a cui vuoi giocare. Guarda il video."},"autoProfileSwitching":{"title":"Disattivare la commutazione del controllo automatico","description":"In questo modo il controllo delle app correnti rimarr\xe0 attivo finch\xe9 non cambierai app."},"tryOpen":{"title":"Prova a dire `Apri Valorant` o `Apri Battlefield`"},"go":{"title":"Prova a dire \\"Vai\\"","description":"Assicurati che il microfono sia acceso e pronuncia il comando \\"Vai\\". Il tuo personaggio inizier\xe0 a muoversi in avanti."},"stop":{"title":"Prova a dire `Stop`","description":"Assicurati che il microfono sia acceso e pronuncia `Stop`. Questo fermer\xe0 il movimento del tuo personaggio."},"complete":{"description":"Ora sai come usare i comandi vocali e le azioni rapide per muoverti, fermarti e controllare il tuo personaggio nei giochi FPS. Prova a esplorare altri comandi o a personalizzare le tue azioni rapide per un gameplay ancora pi\xf9 fluido e veloce."}},"presentationControls":{"tourLabel":"Controlla le presentazioni con i comandi vocali","learn":"Scopri come utilizzare i comandi vocali e le azioni rapide per navigare e controllare le tue presentazioni senza usare le mani.","tryOpen":{"title":"Prova a dire `Apri PowerPoint` o `Apri Google Slides`"},"startPresentation":{"title":"Prova a dire `Avvia presentazione` per iniziare la presentazione","description":"Assicurati che il microfono sia acceso e pronuncia `Avvia presentazione`. In questo modo la presentazione verr\xe0 avviata nell\'app di presentazione scelta."},"nextSlide":{"title":"Prova a dire `Diapositiva successiva` per passare alla diapositiva successiva","description":"Assicurati che il microfono sia acceso e pronuncia \\"Diapositiva successiva\\". In questo modo passerai alla diapositiva successiva della presentazione."},"previousSlide":{"title":"Prova a dire `Diapositiva precedente` per tornare alla diapositiva precedente","description":"Assicurati che il microfono sia acceso e pronuncia \\"Diapositiva precedente\\". In questo modo tornerai alla diapositiva precedente della presentazione."},"escape":{"title":"Prova a dire `Esc` per uscire dalla modalit\xe0 presentazione","description":"Assicurati che il microfono sia acceso e pronuncia `Esc`. Questo uscir\xe0 dalla modalit\xe0 presentazione nell\'app di presentazione scelta."},"complete":{"description":"Ora sai come utilizzare i comandi vocali e le azioni rapide per avviare, navigare e uscire dalle presentazioni senza usare le mani. Prova a esplorare altri comandi o a personalizzare le tue azioni rapide per un controllo ancora pi\xf9 fluido della presentazione."}},"editingImages":{"tourLabel":"Modifica delle immagini pi\xf9 rapida con comandi vocali e dettatura","learn":"Scopri come utilizzare i comandi vocali, le azioni rapide e la dettatura per migliorare il processo di modifica delle immagini.","tryOpen":{"title":"Prova a dire `Apri Figma` o `Apri Photoshop`"},"selectAll":{"title":"Prova a dire `Seleziona tutto` per selezionare tutti gli elementi sulla tela","description":"Assicurati che il microfono sia acceso e pronuncia \\"Seleziona tutto\\". In questo modo verranno selezionati tutti gli elementi sulla tela nell\'app di editing immagini scelta. Assicurati di essere concentrato sull\'app."},"bold":{"title":"Prova a dire `Grassetto` per rendere in grassetto il testo selezionato","description":"Assicurati che il microfono sia acceso e pronuncia \\"Grassetto\\". Questo applicher\xe0 il grassetto al testo selezionato nell\'app di editing immagini scelta. Assicurati di aver selezionato il testo."},"copy":{"title":"Prova a dire `Copia` per copiare l\'elemento selezionato","description":"Assicurati che il microfono sia acceso e pronuncia \\"Copia\\". In questo modo, l\'elemento selezionato verr\xe0 copiato nell\'app di modifica delle immagini scelta. Assicurati di aver selezionato un elemento."},"paste":{"title":"Prova a dire `Incolla` per incollare l\'elemento copiato","description":"Assicurati che il microfono sia acceso e pronuncia `Incolla`. Questo incoller\xe0 l\'elemento copiato nell\'app di modifica delle immagini scelta."},"delete":{"title":"Prova a dire `Elimina` per eliminare l\'elemento selezionato","description":"Assicurati che il microfono sia acceso e pronuncia \\"Elimina\\". Questo eliminer\xe0 l\'elemento selezionato nell\'app di modifica delle immagini scelta. Assicurati di aver selezionato un elemento."},"dictationIntro":{"title":"Dettatura","description":"Puoi usare la dettatura per digitare testo usando la voce. Assicurati che il microfono sia acceso e che la modalit\xe0 dettatura sia attivata."},"focus":{"title":"Concentrati su un campo di testo","description":"Fai clic su un campo di testo nell\'app di modifica delle immagini in cui desideri utilizzare la dettatura."},"speaking":{"title":"Inizia a parlare","description":"Prova a dire \\"Per ottenere codici sconto anticipati, scansiona il codice QR. \xc8 valido fino al 30 settembre. Poi, richiedilo tramite il sito web\\". Assicurati di concentrarti sul campo di testo o sull\'area in cui vuoi dettare."},"complete":{"description":"Ora sai come utilizzare i comandi vocali, le azioni rapide e la dettatura per migliorare il tuo processo di editing delle immagini. Prova a esplorare altri comandi o a personalizzare le tue azioni rapide per un editing delle immagini ancora pi\xf9 fluido."}},"redo":"Ripeti l\'onboarding","title":"Incontra Cephable","description":"Incontra Cephable, il tuo assistente AI personale e condividi il tuo interesse per i casi d\'uso personalizzati.","panel":{"description":"Questo \xe8 il pannello, ovvero il centro di controllo principale. \xc8 sempre visibile e ti permette di controllare le tue app usando la voce, e altro ancora. Iniziamo con il microfono."}}');


var $8e153465ce61e1ac$exports = {};
$8e153465ce61e1ac$exports = JSON.parse('{"introduction":{"title":"Ciao, sono Cephable.","back":"Torna all\'introduzione","description":"Sono la tua intelligenza artificiale personale che ti aiuta a controllare, creare e automatizzare utilizzando gli strumenti che gi\xe0 ami, su tutte le tue connessioni. Ci sono alcune cose che dovresti sapere su di me.","action":"Cominciamo!","recording":{"title":"La tua voce e il tuo video restano locali.","description":"Non registro, trasmetto in streaming o invio mai audio o video al cloud. Tutti gli input vengono elaborati sul dispositivo, in modo privato e sicuro."},"data":{"title":"I tuoi dati sono tuoi.","description":"Non utilizzo i tuoi comandi o le tue attivit\xe0 per addestrare modelli per altri. Tutto rimane privato e i controlli della tua app si spostano con te tra le connessioni."},"offline":{"title":"Io lavoro quando gli altri strumenti non lo fanno.","description":"Attivit\xe0 intelligenti come la generazione di contenuti, la riscrittura, la traduzione e la dettatura vengono eseguite localmente. Non \xe8 necessario il cloud. Ci\xf2 significa che lavoro anche quando sei offline e i tuoi dati non lasciano il tuo dispositivo."},"empower":{"title":"Costruito per dare potere, non per sfruttare.","description":"Sono progettato per migliorare il tuo controllo, non per monitorarlo. Nessun tracciamento invasivo. Nessuna raccolta di dati inquietante. Solo input che funzionano per te."}},"my-capabilities":{"title":"Perfetto! Ecco come posso aiutarti.","back":"Torna alle capacit\xe0","actionTitle":"Guardami in azione","description":"In base ai tuoi interessi, ecco le funzionalit\xe0 e le capacit\xe0 pi\xf9 rilevanti per il tuo flusso di lavoro.","action":{"title":"Guardami in azione","description":"Scopri alcuni esempi di come posso aiutarti nelle tue attivit\xe0 quotidiane."}},"see-me":{"title":"Vuoi vedere come ho aiutato altre persone come te?","back":"Torna ai casi d\'uso","description":"Ecco alcuni esempi concreti di come ho trasformato i flussi di lavoro in diversi settori e ruoli."},"complete":{"title":"Pronto a iniziare a usarmi?","description":"Hai visto cosa so fare! Ora ti aiuter\xf2 a configurare il tutto e a trasformare il tuo flusso di lavoro. Sar\xf2 qui per aiutarti in ogni fase del percorso.","action":"Completa la configurazione e inizia a utilizzare Cephable"},"apps":{"title":"Supporto gli strumenti che gi\xe0 ami","description":"Con supporto preconfigurato per oltre 200 applicazioni, lavoro con il software che usi ogni giorno. Nessuna configurazione richiesta.","note":"Non vedi un\'app che usi? Nessun problema: posso generare controlli o aiutarti a creare flussi di lavoro personalizzati adatti alle tue esigenze.","andMore":"E altro ancora"},"actions":{"ctaTry":"Provalo ora","ctaWatch":"Guarda la demo","apps":"Sono compatibile con:","abilities":"Le mie abilit\xe0 utilizzate:"},"interests":{"title":"Come posso aiutarti?","back":"Torna agli interessi","description":"Posso controllare le app sul tuo desktop e sui dispositivi connessi. Personalizziamo la tua esperienza: quali aree ti interessano di pi\xf9?","note":"Seleziona tutte le opzioni che ritieni appropriate e ti mostrer\xf2 le funzionalit\xe0 e gli esempi pi\xf9 pertinenti per il tuo flusso di lavoro.","action":"Continua con {{count}} interessi","empty":"Seleziona almeno un interesse.","create_design":{"label":"Crea e progetta","shortLabel":"Progetto","description":"Per artisti, addetti al marketing e creatori di contenuti."},"analyze_report":{"label":"Analizza e segnala","shortLabel":"Analizzare","description":"Per analisti, ricercatori e professionisti del settore."},"communicate_collaborate":{"label":"Comunicare e collaborare","shortLabel":"Comunicare","description":"Per venditori, riunioni e team remoti."},"build_develop":{"label":"Costruisci e sviluppa","shortLabel":"Sviluppare","description":"Per sviluppatori, ingegneri e professionisti tecnici."},"game_play":{"label":"Gioco e gioco","shortLabel":"Gioco d\'azzardo","description":"Per giocatori, streamer e controllori multimediali."},"learn_teach":{"label":"Impara e insegna","shortLabel":"Apprendimento","description":"Per educatori, studenti e docenti."},"manage_organize":{"label":"Gestisci e organizza","shortLabel":"Organizzazione","description":"Per project manager, coordinatori e organizzatori."},"adapt_access":{"label":"Adatta e accedi","shortLabel":"Accessibilit\xe0","description":"Per controlli adattivi ed esigenze di accessibilit\xe0 personalizzate."},"everything":{"label":"Un po\' di tutto","shortLabel":"Qualunque cosa","description":"Per utenti generici di computer e per chi svolge pi\xf9 attivit\xe0 contemporaneamente."},"filter":"Filtra per tipo di interessi"},"capabilities":{"title":"Le mie principali capacit\xe0 di intelligenza artificiale","description":"Combino l\'intelligenza artificiale avanzata con potenti metodi di input per offrirti un controllo impeccabile sulle tue app e sui tuoi dispositivi. Ecco alcune delle cose che posso fare.","voice_controls":{"title":"Comandi vocali","description":"Comprendo i comandi in linguaggio naturale, cos\xec puoi controllare qualsiasi app con la tua voce.","longDescription":"Ti lascio parlare in modo naturale e portare a termine le tue attivit\xe0. Che tu voglia aprire app, navigare nei menu o attivare flussi di lavoro, traduco il tuo inglese semplice in azioni affidabili e a mani libere."},"smart_dictation":{"title":"Dettatura intelligente","description":"Convertir\xf2 il tuo discorso in testo tenendo conto del contesto e della formattazione.","longDescription":"Ascolto attentamente e catturo le tue parole con precisione. Aggiungo la punteggiatura, correggo le maiuscole e mi adatto al tuo stile, in modo che la tua scrittura risulti impeccabile senza sforzi aggiuntivi."},"ai_text_generation":{"title":"Generazione di testo tramite intelligenza artificiale","description":"Posso creare e-mail, documenti, codici e contenuti creativi al volo.","longDescription":"Ti aiuto a scrivere bozze, riassumere o ampliare qualsiasi cosa direttamente nelle tue app. Dalle email alle note, dai frammenti di codice ai documenti, mi assicuro che tu non parta mai da una pagina vuota."},"head_face_controls":{"title":"Controlli per la testa e il viso","description":"Ti lascio innescare azioni con i movimenti della testa e del viso.","longDescription":"Traduco i movimenti naturali della testa e le espressioni in input precisi. Puoi inviare un\'e-mail con un sorriso, voltare pagina con un cenno del capo o cliccare alzando le sopracciglia."},"natural_language_voice_clicking":{"title":"Clic vocale in linguaggio naturale","description":"Ti lascio dire ci\xf2 che vedi per cliccare sui pulsanti, sui link e sui menu sullo schermo.","longDescription":"Quando pronunci il nome di qualcosa sullo schermo, lo trovo e interagisco con esso per te. Nessun comando memorizzato: descrivi semplicemente ci\xf2 che desideri e io mi occuper\xf2 del clic."},"keyboard_mouse_emulation":{"title":"Emulazione di tastiera e mouse","description":"Imito tasti, clic e scorrimento per consentirti di controllare le app senza hardware.","longDescription":"Invio sequenze di tasti, movimenti del mouse, clic e azioni di scorrimento ovunque tu ne abbia bisogno. Combinami con controlli vocali o gestuali per sostituire o potenziare completamente i dispositivi di input tradizionali."},"profiles_personalization":{"title":"Personalizzazione","description":"Ricordo le tue preferenze e le adatto ai controlli delle app salvati.","longDescription":"Tengo traccia delle tue app, dei tuoi comandi e delle tue preferenze preferite. Passa da un controllo app all\'altro automaticamente o manualmente e ti mostrer\xf2 sempre i comandi giusti per quello che stai facendo."},"cross_device_connectivity":{"title":"Connettivit\xe0 tra dispositivi","description":"Ti lascio usare il tuo telefono per controllare il tuo computer.","longDescription":"Collego il tuo dispositivo mobile al tuo desktop in modo che tu possa lanciare comandi, dettare o navigare con facilit\xe0. Perfetto per presentazioni, sessioni remote o uso occasionale."},"quick_action_buttons":{"title":"Pulsanti di azione rapida","description":"Ti offro pulsanti sensibili alle app per azioni rapide.","longDescription":"Offro pulsanti contestuali che si adattano alla tua app. Che si tratti di partecipare a una riunione, inviare un messaggio o creare una nuova email, rendo le attivit\xe0 complesse a portata di clic."},"ai_app_awareness":{"title":"Consapevolezza delle app AI","description":"Modifico i miei controlli in base all\'app che stai utilizzando.","longDescription":"Presto attenzione a ci\xf2 che \xe8 attivo sul tuo schermo, cos\xec posso offrirti i comandi giusti al momento giusto. Niente confusione, niente supposizioni: solo ci\xf2 di cui hai bisogno, quando ne hai bisogno. Tutto sul tuo dispositivo e senza inviare dati al cloud."},"ai_rewrite":{"title":"Riscrittura dell\'IA","description":"Posso riscrivere il tuo testo per migliorarne il tono, aggiornarne la formattazione o ampliarne i dettagli.","longDescription":"Modifico il testo proprio dove stai lavorando. Posso renderlo pi\xf9 amichevole, pi\xf9 formale, pi\xf9 breve, pi\xf9 lungo o pi\xf9 dettagliato: qualsiasi cosa ti serva per trasmettere meglio il tuo messaggio."},"ai_translation":{"title":"Traduzione AI","description":"Posso tradurre tra lingue diverse o anche tra linguaggi di programmazione.","longDescription":"Ti permetto di trasformare il testo in un\'altra lingua parlata o di convertire il codice in un altro linguaggio di programmazione. Lavoro sul posto, cos\xec non devi uscire dall\'app che stai utilizzando."},"head_mouse":{"title":"Testa di topo","description":"Ti lascio muovere il cursore del mouse con i movimenti della testa.","longDescription":"Trasduco fluidamente i movimenti della testa in movimenti del cursore. Grazie a funzioni come lo scorrimento e la regolazione della sensibilit\xe0, ti offro un controllo preciso, comodo e a mani libere."},"head_joystick":{"title":"Joystick di testa","description":"Ti lascio usare la testa come un joystick per giochi o app.","longDescription":"Mappo i movimenti della tua testa sugli assi del joystick in modo che tu possa giocare o controllare software creativi senza hardware. Tu ti muovi in modo naturale e io traduco i tuoi movimenti in input analogico."},"mcp_agent":{"title":"Agente MCP","description":"Posso connettermi con agenti di intelligenza artificiale esterni tramite il Model Context Protocol (MCP).","longDescription":"Parlo il protocollo Model Context, che mi permette di lavorare insieme ad altri agenti e strumenti di intelligenza artificiale. Ci\xf2 significa che posso coordinare attivit\xe0, scambiare contesto ed estendere le mie capacit\xe0 con sistemi esterni specializzati, il tutto mantenendo il controllo a te."},"byo_ai_integration":{"title":"Porta la tua intelligenza artificiale","description":"Ti lascio potenziare la mia IA esistente con i tuoi modelli o servizi di IA da utilizzare insieme a me.","longDescription":"Se disponi gi\xe0 di un servizio, un modello o un fornitore di intelligenza artificiale di cui ti fidi, posso integrarlo nel mio flusso di lavoro. Ti offro la flessibilit\xe0 di scegliere il motore che alimenta la generazione, la riscrittura o la traduzione, che sia cloud, locale o personalizzato. Quando sei offline o se il servizio non \xe8 disponibile, posso ricorrere alle mie funzionalit\xe0 integrate."},"workflows":{"title":"Flussi di lavoro","description":"Ti aiuto a concatenare le azioni in flussi di lavoro ripetibili.","longDescription":"Ti lascio progettare ed eseguire processi multi-step che collegano diversi input, comandi e output. Con i flussi di lavoro, puoi automatizzare attivit\xe0 di routine o creare interazioni complesse, attivate dalla tua voce o dai tuoi gesti, lasciando che io faccia il lavoro pi\xf9 pesante per te."},"showMore":"Mostra altro","showLess":"Mostra meno"},"listing":{"title":"Casi d\'uso","titleLong":"Scopri come posso aiutarti","recommended":"Consigliato per te","exploreMore":"Esplora altri casi d\'uso","description":"Scopri tutto quello che posso fare per migliorare il tuo flusso di lavoro. Dall\'aumento della produttivit\xe0 all\'assistenza creativa, trova i casi d\'uso perfetti per le tue esigenze.","all":"Tutto","search":"Cerca casi d\'uso, app o funzionalit\xe0...","noResults":"Nessun risultato trovato. Prova a modificare la ricerca o i filtri.","emptyAction":"Visualizza altro online"},"examples":{"universalAppControl":{"title":"Controllo universale delle app","description":"Controlla qualsiasi applicazione sul tuo computer con comandi vocali e automazione intelligente","descriptionLong":"Assumi il controllo di qualsiasi applicazione con potenti comandi vocali e automazione intelligente. Il nostro sistema Universal App Control impara il tuo modo di lavorare e si adatta alle tue esigenze, semplificando le attivit\xe0 complesse e rendendo istantanee le azioni di routine. Dalla gestione della tua suite di produttivit\xe0 al controllo di applicazioni multimediali e di gioco, questa funzionalit\xe0 \xe8 compatibile con l\'intero ambiente digitale."},"handsFreeComputerControl":{"title":"Controllo del computer a mani libere","description":"Controllo completo del computer tramite movimenti della testa, voce e tracciamento oculare per l\'accessibilit\xe0","descriptionLong":"Scopri un nuovo livello di accessibilit\xe0 al computer con il nostro sistema di controllo a mani libere. Grazie a una combinazione di eye tracking avanzato, rilevamento preciso dei movimenti della testa e comandi vocali, questa funzionalit\xe0 consente a chiunque di controllare completamente il proprio computer senza usare le mani. Perfetto per utenti con difficolt\xe0 motorie, multitasking o chiunque desideri utilizzare il computer in modo nuovo."},"replyToSocialMediaPosts":{"title":"Post e risposte sui social media pi\xf9 rapidi con la dettatura","description":"Rispondi a qualsiasi post sui social media utilizzando la dettatura intelligente per ottenere risposte rapide.","descriptionLong":"La dettatura intelligente di Cephable velocizza la pubblicazione e i commenti sui social media con la conversione da voce a testo. La dettatura funziona in qualsiasi casella di testo o campo di pubblicazione, permettendoti di rimanere attivo sui social media senza che ti occupino troppo della tua giornata."},"clinicalNoteTaking":{"title":"Dettatura e formattazione conformi all\'HIPAA per i medici","description":"Risparmia tempo prendendo appunti clinici tra una sessione e l\'altra utilizzando comandi vocali intelligenti e dettatura. Quindi, formatta automaticamente gli appunti in stile SOAP.","descriptionLong":"Cerchi un software di dettatura conforme all\'HIPAA? Cephable aiuta i medici a documentare rapidamente le cartelle cliniche dei pazienti grazie ai comandi vocali intelligenti e alla formattazione automatica. Crea note SOAP, report di avanzamento e registri, il tutto a mani libere.","upgrade":{"description":"Esegui l\'aggiornamento per accedere alle attivit\xe0 intelligenti offline conformi a HIPAA per la formattazione e l\'iterazione automatiche."}},"vibeCoding":{"title":"Dal pensiero al codice: dettatura per sviluppatori e programmatori Vibe","description":"Vibe Code con dettatura e generazione di testo tramite intelligenza artificiale per scrivere codice boilerplate e prototipi pi\xf9 velocemente.","descriptionLong":"Cephable Dictation aiuta gli sviluppatori a passare pi\xf9 velocemente dal pensiero al codice. Questa demo mostra come i comandi vocali possano generare componenti, dashboard e altro ancora all\'interno di strumenti come Vercel V0, GitHub Copilot in VS Code, Base 44 e Lovable. Detta le tue idee, poi perfezionale con il codice.","upgrade":{"description":"Esegui l\'aggiornamento per accedere alle attivit\xe0 intelligenti offline per la riscrittura, la generazione e la traduzione del codice in-app."}},"controllingBackgroundMusic":{"title":"Controlli multimediali: gestisci musica, video e altro senza interrompere il flusso","description":"Gestisci la musica di sottofondo tramite comandi vocali e azioni rapide, senza perdere di vista l\'attivit\xe0 in corso.","descriptionLong":"I comandi vocali personalizzabili semplificano la riproduzione, la pausa, il salto e il controllo del volume su Spotify, senza l\'uso delle mani. I pulsanti di azione rapida e i controlli predefiniti funzionano anche su altre app come Apple Music, YouTube, Netflix e oltre 200 altre app!"},"editingVideos":{"title":"Montaggio video con voce","description":"Migliora il flusso di lavoro di editing video utilizzando i comandi vocali per navigare, tagliare e modificare pi\xf9 velocemente.","descriptionLong":"Concentrati sulla storia, non sui clic. I controlli vocali Cephable semplificano l\'editing video con gli strumenti che gi\xe0 utilizzi: Clipchamp, Adobe, iMovie, DaVinci Resolve e altri ancora. Modifiche pi\xf9 rapide, meno passaggi."},"inboxTriage":{"title":"Assistente e-mail AI: automatizza, crea bozze e rispondi pi\xf9 velocemente","description":"Gestisci la tua casella di posta utilizzando i comandi vocali e la generazione di testo tramite intelligenza artificiale sul dispositivo per selezionare, scrivere e modificare le email.","descriptionLong":"Accelera il processo di invio delle email con l\'intelligenza artificiale privata integrata nel dispositivo. Cephable combina comandi vocali, dettatura, pulsanti di azione rapida e generazione di testo per semplificare e velocizzare la gestione della posta in arrivo. Elimina email, crea bozze di risposta e genera risposte creative a mani libere in Outlook, Gmail e altro ancora.","upgrade":{"description":"Esegui l\'upgrade per accedere alle attivit\xe0 intelligenti offline per la formattazione automatica, la generazione di contenuti, le traduzioni e altro ancora."}},"summarizingReports":{"title":"Riepiloga i report riservati con l\'intelligenza artificiale privata sul dispositivo","description":"Riassumi lunghi report per il tuo team, mantenendo la riservatezza e il dispositivo, utilizzando la generazione di testo tramite intelligenza artificiale.","descriptionLong":"Trasforma lunghi report in chiari aggiornamenti per il team grazie all\'intelligenza artificiale integrata nel dispositivo. Cephable estrae dati e numeri chiave, quindi genera riepiloghi concisi che puoi condividere direttamente con il tuo team. Tutta l\'elaborazione avviene sul tuo dispositivo, cos\xec i tuoi dati sensibili rimangono al sicuro."},"handsFreeMeeting":{"title":"Riduci l\'affaticamento durante le riunioni con i controlli a mani libere","description":"Controlla le tue videoconferenze tramite comandi vocali, pulsanti di azione rapida e dettatura intelligente.","descriptionLong":"Rimani concentrato durante le riunioni, senza dover cliccare sui menu. Cephable offre comandi vocali e pulsanti di azione rapida per Microsoft Teams, Zoom, Google Meet e altri ancora. Attiva/disattiva l\'audio, attiva/disattiva il video, invia messaggi in chat, alza la mano e naviga tra le finestre delle riunioni senza usare le mani, con controlli pronti all\'uso che puoi personalizzare in base al tuo flusso di lavoro."},"spreadsheetReviews":{"title":"Lavora pi\xf9 velocemente nei fogli di calcolo con i controlli vocali e l\'automazione dell\'intelligenza artificiale","description":"Rivedi e modifica rapidamente fogli di calcolo di grandi dimensioni utilizzando i comandi vocali per la navigazione, la formattazione, il filtraggio e la modifica.","descriptionLong":"Cephable offre controlli vocali e pulsanti di azione rapida per Excel, Fogli Google e altri strumenti per fogli di calcolo. Rivedi, modifica, commenta rapidamente, attiva macro e scorciatoie e personalizza i comandi per il tuo flusso di lavoro. Centinaia di controlli sono pronti all\'uso all\'istante o personalizzati in base alle tue esigenze."},"socialMediaWriting":{"title":"Creazione di contenuti e ricerca con intelligenza artificiale privata sul dispositivo","description":"Crea e scrivi post sui social media utilizzando i comandi vocali e la generazione di testo tramite intelligenza artificiale per contenuti coinvolgenti.","descriptionLong":"Crea contenuti in modo sicuro con l\'intelligenza artificiale integrata di Cephable, senza bisogno di cloud. Genera o riscrivi istantaneamente post social, email, slogan e documentazione direttamente dai tuoi strumenti preferiti. Tutto funziona localmente, cos\xec i tuoi contenuti sensibili rimangono privati e puoi lavorare ovunque."},"fpsGamePlay":{"title":"Gioca ai giochi FPS con i comandi vocali","description":"Gioca e personalizza uno sparatutto in prima persona utilizzando i comandi vocali per muoverti, mirare e sparare.","descriptionLong":"Scopri un nuovo modo di giocare agli sparatutto in prima persona con i comandi vocali. Usa la tua voce per muoverti, mirare e sparare, per un\'esperienza di gioco pi\xf9 immersiva e senza l\'uso delle mani."},"customizingGameControls":{"title":"Personalizzazione dei controlli di gioco di ruolo","description":"Personalizza i controlli del gioco di ruolo per una migliore accessibilit\xe0 e giocabilit\xe0.","descriptionLong":"Personalizza la tua esperienza di gioco con controlli personalizzabili che migliorano l\'accessibilit\xe0 e il gameplay. Regola le impostazioni in base alle tue preferenze e al tuo stile di gioco, assicurandoti una sessione di gioco confortevole e piacevole."},"webBrowsing":{"title":"Navigazione web a mani libere con Cephable | Pianifica viaggi, fai acquisti online e altro ancora","description":"Naviga sul Web senza usare le mani, utilizzando i comandi vocali per navigare, scorrere e compilare i moduli.","descriptionLong":"Cerca, acquista e pianifica senza digitare. I comandi vocali intelligenti di Cephable funzionano su qualsiasi browser, che si tratti di prenotare voli, fare acquisti online o cercare il tuo prossimo viaggio."},"documentCode":{"title":"Documentazione del codice rapida e sicura con generazione di testo AI sul dispositivo","description":"Documenta il codice senza inviare dati sensibili al cloud, rimanendo nella stessa app utilizzando la riscrittura intelligente di Cephable.","descriptionLong":"La funzionalit\xe0 Intelligent Rewrite di Cephable crea la documentazione per gli sviluppatori direttamente dal codice, senza inviare dati sensibili al cloud. Genera file README, documenti Markdown e riferimenti API in modo rapido e sicuro, tutto all\'interno dell\'app."},"generateCode":{"title":"Generazione di codice rapida e sicura con generazione di testo AI sul dispositivo","description":"Prototipa frammenti di codice dai requisiti dei ticket utilizzando le attivit\xe0 intelligenti dell\'IA.","descriptionLong":"Cephable ti consente di trasformare i requisiti dei ticket in codice funzionante in qualsiasi linguaggio. Utilizza le attivit\xe0 intelligenti per creare scaffolding del codice, generare documentazione e aggiungere test unitari automaticamente. Lavora su pi\xf9 linguaggi di programmazione e app senza perdere il contesto."},"editingImages":{"title":"Modifica pi\xf9 rapida nelle app creative con comandi vocali e dettatura","description":"Crea e modifica immagini utilizzando i comandi vocali e la generazione di testo tramite intelligenza artificiale per apportare modifiche e concetti rapidi.","descriptionLong":"Dai vita alle tue idee visive con la creazione e l\'editing di immagini a comando vocale. Utilizza la generazione di testo tramite intelligenza artificiale per apportare modifiche rapide, generare concetti e migliorare le tue immagini senza dover navigare in menu complessi."},"requirementDocsFromMeeting":{"title":"Dalle note ai documenti sui requisiti del prodotto in pochi minuti utilizzando l\'intelligenza artificiale sul dispositivo","description":"Risparmia ore trasformando in pochi minuti le trascrizioni grezze delle riunioni in documenti strutturati sui requisiti del prodotto.","descriptionLong":"Cephable trasforma le trascrizioni grezze delle riunioni in documenti strutturati sui requisiti di prodotto in pochi minuti utilizzando le Attivit\xe0 Intelligenti. Acquisisci rapidamente le esigenze di prodotto, marketing e degli utenti e mantieni private le discussioni riservate grazie all\'intelligenza artificiale integrata nel dispositivo. Salva i risultati come nuovi documenti all\'istante."},"gamingVoiceControls":{"title":"Controllo vocale in WoW | Navigazione rapida per menu, PvP e Dungeon Finder","description":"Controlla il tuo gameplay utilizzando i comandi vocali per navigare nei menu, avviare battaglie PvP e trovare dungeon.","descriptionLong":"Migliora la tua esperienza di gioco con la gestione tramite comandi vocali. Usa semplici comandi vocali per navigare nei menu, avviare battaglie PvP e trovare dungeon, cos\xec potrai concentrarti sul gameplay mantenendo il pieno controllo."},"headMouseMovement":{"title":"Configurazione di gioco a mani libere con Head Mouse","description":"Controlla il cursore del mouse tramite i movimenti della testa per una navigazione e un clic precisi.","descriptionLong":"I controlli Head Mouse consentono di giocare a mani libere. Inclina o ruota la testa per muovere il cursore, personalizzare velocit\xe0 e sensibilit\xe0 e assumere il controllo senza un mouse tradizionale."},"noteTakingAndDocumentation":{"title":"Prendere appunti e generare documenti utilizzando l\'intelligenza artificiale privata sul dispositivo","description":"Prendi appunti e genera documenti utilizzando i comandi vocali e la generazione di testo tramite intelligenza artificiale per una scrittura efficiente.","descriptionLong":"Semplifica la presa di appunti con la dettatura intelligente e la generazione di documenti basata sull\'intelligenza artificiale. Crea rapidamente bozze, schemi e documenti rifiniti, cos\xec puoi concentrarti sulle idee anzich\xe9 sulla formattazione. Tutta l\'elaborazione avviene sul dispositivo per garantire privacy e sicurezza.","upgrade":{"description":"Esegui l\'aggiornamento per accedere alle attivit\xe0 intelligenti offline per la formattazione, l\'iterazione dei contenuti e altro ancora."}},"presentationControls":{"title":"Controlli di presentazione a mani libere con comandi vocali e azioni rapide","description":"Controlla le tue presentazioni utilizzando i comandi vocali per navigare tra le diapositive, avviare/interrompere le presentazioni ed evidenziare i punti.","descriptionLong":"Presentazioni in tutta sicurezza utilizzando i comandi vocali. Naviga tra le diapositive, avvia e interrompi le presentazioni ed evidenzia i punti chiave, il tutto senza toccare il computer."},"designingFliers":{"title":"Progettazione in app creative","description":"Crea e modifica progetti utilizzando i comandi vocali e la dettatura intelligente per iterazioni pi\xf9 rapide.","descriptionLong":"Dai vita alla tua visione creativa con strumenti di progettazione a controllo vocale. Naviga, modifica e ripeti i tuoi progetti senza sforzo, senza perderti in menu complessi, cos\xec puoi concentrarti sulla creativit\xe0, non sui clic."},"motionDesign":{"title":"Comandi vocali per motion design e animazione","description":"Anima le scene e controlla i fotogrammi chiave utilizzando comandi vocali intuitivi per una progettazione del movimento fluida.","descriptionLong":"Dai movimento alle tue idee con strumenti di animazione vocali. Controlla facilmente timeline, fotogrammi chiave ed effetti utilizzando il linguaggio naturale, cos\xec puoi concentrarti sulla narrazione e sul ritmo visivo anzich\xe9 su interfacce complesse."}}}');


var $a02703834f50dafc$exports = {};
$a02703834f50dafc$exports = JSON.parse('{"logo":"\u30BB\u30D5\u30A1\u30D6\u30EB\u30ED\u30B4","add":"\u8FFD\u52A0","all":"\u5168\u3066","edit":"\u7DE8\u96C6","create":"\u4F5C\u6210\u3059\u308B","delete":"\u6D88\u53BB","previous":"\u524D\u306E","next":"\u6B21","search":"\u691C\u7D22","loading":"\u8AAD\u307F\u8FBC\u307F\u4E2D...","reload":"\u30EA\u30ED\u30FC\u30C9","cancel":"\u30AD\u30E3\u30F3\u30BB\u30EB","copy":"\u30B3\u30D4\u30FC","save":"\u4FDD\u5B58","saveAndFinish":"\u4FDD\u5B58\u3057\u3066\u7D42\u4E86","saveAndContinue":"\u4FDD\u5B58\u3057\u3066\u7D9A\u884C","saved":"\u4FDD\u5B58\u3057\u307E\u3057\u305F","saveError":"\u5909\u66F4\u306E\u4FDD\u5B58\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","done":"\u7D42\u308F\u308A","back":"\u623B\u308B","play":"\u904A\u3076","pause":"\u4E00\u6642\u505C\u6B62","success":"\u6210\u529F","continue":"\u7D9A\u304F","options":"\u30AA\u30D7\u30B7\u30E7\u30F3","share":"\u5171\u6709","finish":"\u4ED5\u4E0A\u3052\u308B","description":"\u8AAC\u660E","expand":"\u62E1\u5927\u3059\u308B","expandMenu":"\u30E1\u30CB\u30E5\u30FC\u3092\u5C55\u958B","finishEdit":"\u7DE8\u96C6\u7D42\u4E86","advancedOptions":"\u8A73\u7D30\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u8868\u793A","authenticating":"\u8A8D\u8A3C\u4E2D...","skipToMain":"\u30E1\u30A4\u30F3\u30B3\u30F3\u30C6\u30F3\u30C4\u3078\u30B9\u30AD\u30C3\u30D7","skip":"\u30B9\u30AD\u30C3\u30D7","close":"\u8FD1\u3044","notFound":"\u30DA\u30FC\u30B8\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093","notFoundDescription":"\u3042\u3042\u3001\u5927\u5909\uFF01\u6D77\u4E2D\u3092\u63A2\u3057\u305F\u306E\u3067\u3059\u304C\u3001\u30DA\u30FC\u30B8\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\uFF01","exitSetup":"\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7\u3092\u7D42\u4E86","experimental":"\u5B9F\u9A13\u7684","letGetStarted":"\u3055\u3042\u59CB\u3081\u307E\u3057\u3087\u3046\uFF01","exploreInputControls":"\u5165\u529B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8ABF\u3079\u308B","when":"\u79C1\u304C...","thenMacro":"Cephable \u306F\u5B9F\u884C\u3055\u308C\u307E\u3059...","controls":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","welcome":"\u3044\u3089\u3063\u3057\u3083\u3044\u307E\u305B\u3002","beta":"\u30D9\u30FC\u30BF","macroEmpty":"\u3053\u306E\u6761\u4EF6\u306B\u4E00\u81F4\u3059\u308B\u30DE\u30AF\u30ED\u306F\u3042\u308A\u307E\u305B\u3093\u3002","you":"\u3042\u306A\u305F","step":"\u30B9\u30C6\u30C3\u30D7","steps":"\u624B\u9806","learnMore":"\u3082\u3063\u3068\u8A73\u3057\u304F\u77E5\u308B","dangerZone":"\u5371\u967A\u5730\u5E2F","connected":"\u63A5\u7D9A","notConnected":"\u63A5\u7D9A\u3055\u308C\u3066\u3044\u307E\u305B\u3093","connectAndLearn":"\u3064\u306A\u304C\u308B\uFF06\u5B66\u3076","tryAgain":"\u3082\u3046\u4E00\u5EA6\u3084\u308A\u76F4\u3057\u3066\u304F\u3060\u3055\u3044","by":"\u6295\u7A3F\u8005: {{value}}","noName":"- \u540D\u524D\u306A\u3057 -","details":"\u8A73\u7D30","controlFeed":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u30D5\u30A3\u30FC\u30C9","upgrade":"\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9","purchase":"\u8CFC\u5165","results":"\u7D50\u679C","created":"\u4F5C\u6210\u65E5: {{value}}","updated":"\u66F4\u65B0: {{value}}","deleted":"\u524A\u9664\u6E08\u307F: {{value}}","expires":"\u6709\u52B9\u671F\u9650: {{value}}","expired":"\u671F\u9650\u5207\u308C: {{value}}","used":"\u4F7F\u7528\u6E08\u307F: {{value}}","mobileApp":{"title":"\u30E2\u30D0\u30A4\u30EB\u30A2\u30D7\u30EA"},"dashboard":{"title":"\u30C0\u30C3\u30B7\u30E5\u30DC\u30FC\u30C9"},"invalidNumber":"\u8A72\u5F53\u306A\u3057","wifi":{"disconnected":"Wi-Fi\u304C\u5207\u65AD\u3055\u308C\u307E\u3057\u305F\u3002","connected":"Wi-Fi\u304C\u63A5\u7D9A\u3055\u308C\u3066\u3044\u307E\u3059\u3002","description":"Cephable \u304C\u304A\u4F7F\u3044\u306E\u63A5\u7D9A\u304A\u3088\u3073\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3068\u9023\u643A\u3067\u304D\u308B\u3088\u3046\u306B\u3059\u308B\u306B\u306F\u3001Wi-Fi \u306B\u63A5\u7D9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u73FE\u5728\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u4F7F\u7528\u306B\u5236\u9650\u304C\u751F\u3058\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002"},"signalR":{"disconnected":"\u540C\u671F\u304C\u5207\u65AD\u3055\u308C\u307E\u3057\u305F\u3002","action":"\u518D\u63A5\u7D9A","description":"Cephable \u306E\u540C\u671F\u306B\u554F\u984C\u304C\u767A\u751F\u3057\u3066\u3044\u308B\u3088\u3046\u3067\u3059\u3002\u8A2D\u5B9A\u306E\u4FDD\u5B58\u3084\u4ED6\u306E\u63A5\u7D9A\u3068\u306E\u901A\u4FE1\u306B\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3059\u3002","disconnectedDevice":"{{name}} \u3068\u540C\u671F\u3067\u304D\u307E\u305B\u3093\u3002","disconnectedDeviceDescription":"\u8A8D\u8A3C\u307E\u305F\u306F\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u63A5\u7D9A\u306E\u3044\u305A\u308C\u304B\u304C\u539F\u56E0\u3067\u3001\u540C\u671F\u306B\u554F\u984C\u304C\u767A\u751F\u3057\u3066\u3044\u308B\u3088\u3046\u3067\u3059\u3002\u30EA\u30E2\u30FC\u30C8\u3067\u30C7\u30FC\u30BF\u3092\u9001\u53D7\u4FE1\u3067\u304D\u307E\u305B\u3093\u3002\u63A5\u7D9A\u306E\u4E21\u5074\u3092\u78BA\u8A8D\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","connected":"\u540C\u671F\u304C\u63A5\u7D9A\u3055\u308C\u307E\u3057\u305F\u3002","connectedDescription":"Cephable \u306F\u6B63\u5E38\u306B\u540C\u671F\u3057\u3066\u304A\u308A\u3001\u671F\u5F85\u3069\u304A\u308A\u306B\u63A5\u7D9A\u304A\u3088\u3073\u62E1\u5F35\u6A5F\u80FD\u3068\u901A\u4FE1\u3059\u308B\u306F\u305A\u3067\u3059\u3002","swap":"\u30ED\u30FC\u30AB\u30EB\u30C7\u30D0\u30A4\u30B9\u63A5\u7D9A\u306B\u5207\u308A\u66FF\u3048\u308B","unlinkedDevice":"\u63A5\u7D9A\u304C\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002","unlinkedDeviceDescription":"\u3053\u306E\u63A5\u7D9A\u306F\u30A2\u30AB\u30A6\u30F3\u30C8\u304B\u3089\u30EA\u30F3\u30AF\u89E3\u9664\u3055\u308C\u307E\u3057\u305F\u3002"},"billing":{"title":"\u8ACB\u6C42\u3059\u308B","expires":"\u6B21\u56DE\u306E\u8ACB\u6C42: {{value}}","description":"\u7D44\u7E54\u306E\u8ACB\u6C42\u3001\u30B7\u30FC\u30C8\u3001\u30B5\u30D6\u30B9\u30AF\u30EA\u30D7\u30B7\u30E7\u30F3\u306E\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3001\u66F4\u65B0\u3001\u307E\u305F\u306F\u30AD\u30E3\u30F3\u30BB\u30EB\u3092\u7BA1\u7406\u3057\u307E\u3059\u3002","error":"\u8ACB\u6C42\u3092\u7BA1\u7406\u3059\u308B\u306B\u306F\u3001\u30B7\u30B9\u30C6\u30E0\u7BA1\u7406\u8005\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002","view":"\u8ACB\u6C42\u306E\u7BA1\u7406","isEmployeeAccess":{"title":"\u30D7\u30ED","titleLong":"\u30BB\u30D5\u30A1\u30D6\u30EB\u30D7\u30ED\u30D5\u30A7\u30C3\u30B7\u30E7\u30CA\u30EB","short":"\u30D7\u30ED","description":"Cephable Professional \u306F\u3001\u30ED\u30FC\u30AB\u30EB\u306E\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8 AI \u3092\u751F\u6210\u6A5F\u80FD\u306B\u62E1\u5F35\u3057\u3001\u30E6\u30FC\u30B6\u30FC\u306E\u751F\u7523\u6027\u3092\u3055\u3089\u306B\u9AD8\u3081\u307E\u3059\u3002","supportedFeatures":{"tag":"\u30D7\u30E9\u30B9\u306E\u3059\u3079\u3066\u3001\u30D7\u30E9\u30B9","features":["\u30C7\u30D0\u30A4\u30B9\u4E0A\u306EAI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC","\u4F01\u696D\u7D44\u7E54\u7BA1\u7406","\u4F01\u696D\u5236\u9650","\u30C7\u30D0\u30A4\u30B9\u306E\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u6570\u306F\u7121\u5236\u9650\u3067\u3059\u3002","\u7121\u5236\u9650\u306E\u4E8B\u524D\u5B66\u7FD2\u6E08\u307F\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB"]}},"isDeveloperAccess":{"title":"\u958B\u767A\u30AD\u30C3\u30C8","titleLong":"\u30BB\u30D5\u30A1\u30D6\u30EB SDK","short":"SDK","description":"Cephable SDK \u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u97F3\u58F0\u3001\u9854\u3001\u982D\u306A\u3069\u306E\u5F37\u529B\u306A\u9069\u5FDC\u578B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306B\u7D71\u5408\u3067\u304D\u3001\u6700\u5C0F\u9650\u306E\u624B\u9593\u3067\u6700\u5927\u9650\u306E\u52B9\u679C\u304C\u5F97\u3089\u308C\u307E\u3059\u3002","supportedFeatures":{"tag":"\u30D7\u30E9\u30B9\u306E\u3059\u3079\u3066\u3001\u30D7\u30E9\u30B9","features":["Windows\u3068MacOS\u306E\u30B5\u30DD\u30FC\u30C8","\u30AA\u30D5\u30E9\u30A4\u30F3\u3067\u306E\u97F3\u58F0\u3001\u9854\u3001\u982D\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u5165\u529B\u306E\u305F\u3081\u306E\u8EFD\u91CF\u3067\u57CB\u3081\u8FBC\u307F\u53EF\u80FD\u306A SDK","\u30AB\u30B9\u30BF\u30E0\u51FA\u529B\u30A2\u30AF\u30B7\u30E7\u30F3\u306E API/Webhook \u30B5\u30DD\u30FC\u30C8","\u958B\u767A\u8005\u5411\u3051\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8","\u30B5\u30F3\u30D7\u30EB\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8","\u30B3\u30DE\u30F3\u30C9\u3092\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306E\u81EA\u52D5\u5316\u3068\u30CA\u30D3\u30B2\u30FC\u30B7\u30E7\u30F3\u306B\u5909\u63DB\u3059\u308B","\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3001\u8A8D\u8A3C\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u3001\u30C7\u30D0\u30A4\u30B9\u30BF\u30A4\u30D7\u306A\u3069\u3092\u7BA1\u7406\u3059\u308B\u305F\u3081\u306E\u958B\u767A\u8005\u30DD\u30FC\u30BF\u30EB"]}},"isStudentAccess":{"title":"\u5B66\u751F","titleLong":"\u30BB\u30D5\u30A1\u30D6\u30EB\u6559\u80B2","short":"\u6559\u80B2","description":"Cephable Education\u306F\u3001\u500B\u5225\u5B66\u7FD2\u3068\u30A4\u30F3\u30AF\u30EB\u30FC\u30B7\u30D6\u306A\u6388\u696D\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u307E\u3059\u3002Cephable\u306F\u30AA\u30D5\u30E9\u30A4\u30F3\u3067\u3082\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u52D5\u4F5C\u3057\u3001\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3\u3068\u306E\u9023\u643A\u306F\u4E0D\u8981\u3067\u3059\u3002","supportedFeatures":{"tag":"\u30D7\u30E9\u30B9\u306E\u3059\u3079\u3066\u3001\u30D7\u30E9\u30B9","features":["\u30C7\u30D0\u30A4\u30B9\u306E\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u6570\u306F\u7121\u5236\u9650","\u7121\u5236\u9650\u306E\u4E8B\u524D\u5B66\u7FD2\u6E08\u307F\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","\u30AB\u30B9\u30BF\u30E0\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u7121\u5236\u9650\u306E\u5171\u6709"]}},"isResellerAccess":{"title":"\u30EA\u30BB\u30E9\u30FC","titleLong":"Cephable \u518D\u8CA9\u696D\u8005","description":"Cephable Reseller \u306F\u3001\u65B0\u3057\u3044\u7D44\u7E54\u3092\u4F5C\u6210\u3057\u3001\u30E9\u30A4\u30BB\u30F3\u30B9 \u30AD\u30FC\u3092\u5272\u308A\u5F53\u3066\u308B\u3053\u3068\u304C\u3067\u304D\u308B\u6709\u6599\u30E9\u30A4\u30BB\u30F3\u30B9\u3067\u3059\u3002\u3053\u308C\u306B\u306F\u3001\u72EC\u81EA\u306E\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2 \u30B9\u30A4\u30FC\u30C8\u3067 Cephable \u3092\u4F7F\u7528\u3057\u3001\u30E6\u30FC\u30B6\u30FC \u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u5411\u4E0A\u3055\u305B\u308B\u3053\u3068\u304C\u542B\u307E\u308C\u307E\u3059\u3002","short":"\u30EA\u30BB\u30E9\u30FC"},"viewProducts":"\u88FD\u54C1\u3092\u898B\u308B","included":"{{licenseType}} \u30E9\u30A4\u30BB\u30F3\u30B9\u306B\u542B\u307E\u308C\u3066\u3044\u307E\u3059\u3002","upgrade":{"description":"\u4ECA\u3059\u3050\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3057\u3066\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u6B21\u306E\u30EC\u30D9\u30EB\u306B\u5F15\u304D\u4E0A\u3052\u307E\u3057\u3087\u3046\u3002","action":"\u4ECA\u3059\u3050\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9","error":"\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","requiredDetail":"\u3053\u306E\u6A5F\u80FD\u306B\u306F{{licenseType}}\u30E9\u30A4\u30BB\u30F3\u30B9\u304C\u5FC5\u8981\u3067\u3059\u3002\u30A2\u30AB\u30A6\u30F3\u30C8\u8A2D\u5B9A\u304B\u3089\u3044\u3064\u3067\u3082\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u307E\u305F\u306F\u7121\u6599\u30C8\u30E9\u30A4\u30A2\u30EB\u3092\u958B\u59CB\u3067\u304D\u307E\u3059\u3002","enableTextGeneration":"AI\u3068\u97F3\u58F0\u3092\u4F7F\u7528\u3057\u3066\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u751F\u6210\u3057\u307E\u3059\u3002","longDescription":"\u6709\u6599\u30E9\u30A4\u30BB\u30F3\u30B9\u306B\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u3068\u3001Cephable \u306E\u3059\u3079\u3066\u306E\u6A5F\u80FD\u304C\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002\u8907\u6570\u306E\u30C7\u30D0\u30A4\u30B9\u3001\u9AD8\u5EA6\u306A\u5236\u5FA1\u3001\u30AB\u30B9\u30BF\u30E0\u7D71\u5408\u306A\u3069\u3001Cephable \u306B\u306F\u751F\u7523\u6027\u3092\u6B21\u306E\u30EC\u30D9\u30EB\u306B\u5F15\u304D\u4E0A\u3052\u308B\u305F\u3081\u306B\u5FC5\u8981\u306A\u3082\u306E\u304C\u3059\u3079\u3066\u63C3\u3063\u3066\u3044\u307E\u3059\u3002","compare":"\u30D7\u30E9\u30F3\u3092\u6BD4\u8F03\u3059\u308B","enableAiDictation":{"title":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u306B\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9","description":"\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u3068\u3001AI\u306B\u3088\u308B\u9AD8\u5EA6\u306A\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u6A5F\u80FD\u304C\u5229\u7528\u53EF\u80FD\u306B\u306A\u308A\u307E\u3059\u3002\u53E5\u8AAD\u70B9\u306E\u8FFD\u52A0\u3001\u5927\u6587\u5B57\u306E\u4FEE\u6B63\u3001\u305D\u3057\u3066\u3042\u306A\u305F\u306E\u30B9\u30BF\u30A4\u30EB\u306B\u5408\u308F\u305B\u305F\u8ABF\u6574\u304C\u3067\u304D\u308B\u306E\u3067\u3001\u4F59\u5206\u306A\u624B\u9593\u3092\u304B\u3051\u305A\u306B\u6D17\u7DF4\u3055\u308C\u305F\u6587\u7AE0\u3092\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002"}},"isPlusAccess":{"title":"\u30D7\u30E9\u30B9","titleLong":"\u30BB\u30D5\u30A1\u30D6\u30EB\u30D7\u30E9\u30B9","short":"\u30D7\u30E9\u30B9","description":"Cephable Plus \u306F\u3001\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u97F3\u58F0\u3001\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3001\u6570\u767E\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306A\u3069\u3092\u6D3B\u7528\u3057\u3066\u3001\u3088\u308A\u591A\u304F\u306E\u3053\u3068\u3092\u884C\u3044\u305F\u3044\u30D1\u30EF\u30FC\u30E6\u30FC\u30B6\u30FC\u5411\u3051\u3067\u3059\u3002","supportedFeatures":{"tag":"\u30D9\u30FC\u30B7\u30C3\u30AF\u306E\u3059\u3079\u3066\u306B\u52A0\u3048\u3066","features":["\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\uFF08\u81EA\u7136\u8A00\u8A9E\uFF09","\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u97F3\u58F0\u8A8D\u8B58\uFF08AI\u5F37\u5316\u7248\uFF09","\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\uFF08\u751F\u6210\u3001\u7FFB\u8A33\u3001\u66F8\u304D\u63DB\u3048\uFF09","\u6570\u767E\u7A2E\u985E\u306E\u4E8B\u524D\u5B66\u7FD2\u6E08\u307F\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB"]}},"personal":{"short":"\u57FA\u672C","title":"\u57FA\u672C","titleLong":"\u30BB\u30D5\u30A1\u30D6\u30EB \u30D9\u30FC\u30B7\u30C3\u30AF","description":"Cephable Basic\u306F\u6C38\u4E45\u7121\u6599\u3067\u3001\u3088\u308A\u901F\u304F\u52D5\u304D\u3001\u81EA\u5206\u3089\u3057\u3055\u3092\u8868\u73FE\u3057\u3001\u81EA\u5206\u3089\u3057\u3044\u65B9\u6CD5\u3067\u7269\u4E8B\u3092\u6210\u3057\u9042\u3052\u3089\u308C\u308B\u3088\u3046\u8A2D\u8A08\u3055\u308C\u3066\u3044\u307E\u3059\u3002Basic\u306B\u542B\u307E\u308C\u308B\u6A5F\u80FD\u306F\u3059\u3079\u3066\u306E\u30E6\u30FC\u30B6\u30FC\u304C\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u3059\u3002","upgrade":{"title":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u6B21\u306E\u30EC\u30D9\u30EB\u3078","description":"Plus\u307E\u305F\u306FPro\u306B\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3057\u3066\u3001\u3059\u3079\u3066\u306E\u6A5F\u80FD\u3092\u3054\u5229\u7528\u304F\u3060\u3055\u3044\u3002\u3088\u308A\u9AD8\u7CBE\u5EA6\u306B\u3002\u3088\u308A\u591A\u304F\u306E\u63A5\u7D9A\u3002\u3088\u308A\u591A\u304F\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3002\u751F\u7523\u6027\u3092\u6B21\u306E\u30EC\u30D9\u30EB\u306B\u5F15\u304D\u4E0A\u3052\u308B\u30D1\u30EF\u30FC\u3002","featureHeading":"\u79C1\u304C\u304A\u624B\u4F1D\u3044\u3067\u304D\u308B\u3053\u3068\u306F\u4EE5\u4E0B\u306E\u901A\u308A\u3067\u3059:","control":"\u97F3\u58F0\u3084\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u4F7F\u3063\u3066\u3001\u30A2\u30D7\u30EA\u3084\u30C4\u30FC\u30EB\u3092\u7D20\u65E9\u304F\u5207\u308A\u66FF\u3048\u307E\u3059\u3002\u9014\u5207\u308C\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30DC\u30A4\u30B9\u306A\u3089\u3001\u30C1\u30E3\u30C3\u30C8\u3067\u7C21\u5358\u306B\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002","create":"\u30A2\u30D7\u30EA\u5185\u3067\u76F4\u63A5\u3001\u66F8\u304D\u76F4\u3057\u3001\u53E3\u8FF0\u3001\u751F\u6210\u3001\u7FFB\u8A33\u3092\u884C\u3044\u307E\u3059\u3002\u30B3\u30D4\u30FC\u3001\u8CBC\u308A\u4ED8\u3051\u3001\u753B\u9762\u306E\u5207\u308A\u66FF\u3048\u306F\u5FC5\u8981\u3042\u308A\u307E\u305B\u3093\u3002","automate":"\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u30B9\u30D4\u30FC\u30C9\u30A2\u30C3\u30D7\u3059\u308B\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u30BF\u30B9\u30AF\u3068\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u5B9F\u884C\u3057\u307E\u3059\u3002\u30B7\u30F3\u30D7\u30EB\u306A\u30B3\u30DE\u30F3\u30C9\u304B\u3089\u8907\u96D1\u306A\u30DE\u30AF\u30ED\u307E\u3067\u3001\u9762\u5012\u306A\u4F5C\u696D\u306F\u79C1\u304C\u5F15\u304D\u53D7\u3051\u307E\u3059\u306E\u3067\u3001\u304A\u5BA2\u69D8\u306F\u91CD\u8981\u306A\u4F5C\u696D\u306B\u96C6\u4E2D\u3067\u304D\u307E\u3059\u3002","local":"\u3059\u3079\u3066\u30ED\u30FC\u30AB\u30EBAI\u3002\u30AF\u30E9\u30A6\u30C9\u51E6\u7406\u306F\u4E0D\u8981\u3002"}},"mostPopular":"\u6700\u3082\u4EBA\u6C17\u306E\u3042\u308B","subscription":{"options":"\u30B5\u30D6\u30B9\u30AF\u30EA\u30D7\u30B7\u30E7\u30F3\u30AA\u30D7\u30B7\u30E7\u30F3","monthly":"\u6708\u6255\u3044","billedMonthly":"/\u6708","yearly":"\u5E74\u6255\u3044","billedYearly":"/\u5E74"}},"organization":{"title":"\u7D44\u7E54","titlePlural":"\u7D44\u7E54","titleLong":"\u7D44\u7E54\u5411\u3051Cephable\u30D7\u30ED\u30D5\u30A7\u30C3\u30B7\u30E7\u30CA\u30EB","description":"\u7D44\u7E54\u3068\u306F\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3067\u5171\u540C\u4F5C\u696D\u3057\u305F\u308A\u3001\u30EA\u30BD\u30FC\u30B9\u3092\u5171\u6709\u3057\u305F\u308A\u3067\u304D\u308B\u30E6\u30FC\u30B6\u30FC\u306E\u30B0\u30EB\u30FC\u30D7\u3067\u3059\u3002\u3053\u3053\u3067\u306F\u3001\u30C1\u30FC\u30E0\u3001\u30C1\u30FC\u30E0 \u30D7\u30ED\u30D5\u30A1\u30A4\u30EB\u3001\u8ACB\u6C42\u306A\u3069\u3092\u7BA1\u7406\u3067\u304D\u307E\u3059\u3002","viewOrganization":"\u7D44\u7E54\u3092\u8868\u793A","orgName":"\u7D44\u7E54\u540D","orgCustomBillingUrl":{"title":"\u30AB\u30B9\u30BF\u30E0\u8ACB\u6C42 URL","description":"\u3053\u308C\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u3092\uFF08\u518D\u8CA9\u696D\u8005\u306E\uFF09\u8AB2\u91D1\u30B7\u30B9\u30C6\u30E0\u306B\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8\u3059\u308B\u305F\u3081\u306B\u4F7F\u7528\u3055\u308C\u308B\u30AB\u30B9\u30BF\u30E0 URL \u3067\u3059\u3002\u300Chttps://\u300D\u307E\u305F\u306F\u300CmailTo:\u300D\u3067\u59CB\u307E\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002"},"create":"\u65B0\u3057\u3044\u7D44\u7E54\u3092\u4F5C\u6210\u3059\u308B","managed":{"title":"\u7BA1\u7406\u5BFE\u8C61\u7D44\u7E54","titleShort":"\u7BA1\u7406","titlePlural":"\u7BA1\u7406\u5BFE\u8C61\u7D44\u7E54","description":"\u7BA1\u7406\u5BFE\u8C61\u7D44\u7E54\u306F\u3001Cephable \u30EA\u30BB\u30E9\u30FC\u306B\u3088\u3063\u3066\u7BA1\u7406\u3055\u308C\u308B\u7D44\u7E54\u3067\u3059\u3002\u30EA\u30BB\u30E9\u30FC\u306F\u3053\u3053\u3067\u30C1\u30FC\u30E0\u3001\u30C1\u30FC\u30E0 \u30D7\u30ED\u30D5\u30A1\u30A4\u30EB\u3001\u8ACB\u6C42\u306A\u3069\u3092\u7BA1\u7406\u3067\u304D\u307E\u3059\u3002","error":"\u7BA1\u7406\u5BFE\u8C61\u7D44\u7E54\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","empty":{"title":"\u7BA1\u7406\u5BFE\u8C61\u306E\u7D44\u7E54\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002","description":"\u3053\u306E\u6761\u4EF6\u306B\u4E00\u81F4\u3059\u308B\u7BA1\u7406\u5BFE\u8C61\u7D44\u7E54\u304C\u5B58\u5728\u3057\u306A\u3044\u3088\u3046\u3067\u3059\u3002\u307E\u305F\u306F\u3001\u30E9\u30A4\u30BB\u30F3\u30B9 \u30AD\u30FC\u304C\u307E\u3060\u30A2\u30AF\u30C6\u30A3\u30D6\u5316\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002"}},"settings":{"title":"\u7D44\u7E54\u8A2D\u5B9A","description":"\u7D44\u7E54\u306E\u8ACB\u6C42\u3001\u540D\u524D\u3001\u8AAC\u660E\u3001\u30EA\u30BD\u30FC\u30B9\u3092\u7BA1\u7406\u3057\u307E\u3059\u3002","view":"\u8868\u793A\u8A2D\u5B9A","general":{"title":"\u4E00\u822C\u7684\u306A"},"resources":{"edit":"\u30EA\u30BD\u30FC\u30B9\u3092\u7DE8\u96C6","description":"\u5DE6\u5074\u306E Markdown \u30A8\u30C7\u30A3\u30BF\u30FC\u3092\u4F7F\u7528\u3057\u3066\u3001\u7D44\u7E54\u306E\u3059\u3079\u3066\u306E\u30E1\u30F3\u30D0\u30FC\u306B\u5F79\u7ACB\u3064\u30EA\u30BD\u30FC\u30B9\u3092\u66F4\u65B0\u304A\u3088\u3073\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3057\u307E\u3059\u3002\u5165\u529B\u3059\u308B\u3068\u3001\u53F3\u5074\u306E\u30D7\u30EC\u30D3\u30E5\u30FC\u306B\u30B3\u30F3\u30C6\u30F3\u30C4\u304C\u30E6\u30FC\u30B6\u30FC\u306B\u3069\u306E\u3088\u3046\u306B\u8868\u793A\u3055\u308C\u308B\u304B\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002Markdown \u69CB\u6587\u3092\u4F7F\u7528\u3057\u3066\u3001\u898B\u51FA\u3057\u3001\u30EA\u30B9\u30C8\u3001\u30EA\u30F3\u30AF\u3001\u305D\u306E\u4ED6\u306E\u66F8\u5F0F\u8A2D\u5B9A\u8981\u7D20\u3092\u8FFD\u52A0\u3067\u304D\u307E\u3059\u3002\u5909\u66F4\u306F\u4FDD\u5B58\u3059\u308B\u3068\u30E1\u30F3\u30D0\u30FC\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002"},"other":{"title":"\u305D\u306E\u4ED6\u306E\u8A2D\u5B9A","description":"\u7D44\u7E54\u306E\u8ACB\u6C42\u3001\u540D\u524D\u3001\u8AAC\u660E\u3001\u30EA\u30BD\u30FC\u30B9\u3092\u7BA1\u7406\u3057\u307E\u3059\u3002"}},"menu":{"title":"\u7D44\u7E54\u30E1\u30CB\u30E5\u30FC","view":"\u8868\u793A\u30E1\u30CB\u30E5\u30FC","expand":"\u30E1\u30CB\u30E5\u30FC\u3092\u5C55\u958B"},"update":"\u7D44\u7E54\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002\u30A2\u30D7\u30EA\u3092\u66F4\u65B0\u3057\u3066\u3044\u307E\u3059\u3002","noAccess":{"title":"\u30A2\u30AF\u30BB\u30B9\u304C\u62D2\u5426\u3055\u308C\u307E\u3057\u305F\u3002","description":"\u6700\u8FD1\u6A29\u9650\u304C\u5909\u66F4\u3055\u308C\u305F\u305F\u3081\u3001\u3053\u306E\u6A5F\u80FD\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3057\u305F\u3002\u30A8\u30E9\u30FC\u3060\u3068\u601D\u308F\u308C\u308B\u5834\u5408\u306F\u3001\u7D44\u7E54\u306E\u7BA1\u7406\u8005\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002"},"noOrg":{"title":"\u95A2\u9023\u3059\u308B\u30E9\u30A4\u30BB\u30F3\u30B9\u306F\u3042\u308A\u307E\u305B\u3093\u3002","description":"\u73FE\u5728\u3001\u30E9\u30A4\u30BB\u30F3\u30B9\u307E\u305F\u306F\u958B\u767A\u8005\u30B0\u30EB\u30FC\u30D7\u306B\u95A2\u9023\u4ED8\u3051\u3089\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u3053\u306E\u30DD\u30FC\u30BF\u30EB\u306F\u3001\u6709\u6599\u306ECephable\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u304A\u6301\u3061\u306E\u30E6\u30FC\u30B6\u30FC\u306E\u307F\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u3059\u3002Cephable\u306E\u6F5C\u5728\u80FD\u529B\u3092\u6700\u5927\u9650\u306B\u5F15\u304D\u51FA\u3059\u306B\u306F\u3001\u30EA\u30B9\u30AF\u30D5\u30EA\u30FC\u306E\u30C8\u30E9\u30A4\u30A2\u30EB\u3092\u3054\u5229\u7528\u304F\u3060\u3055\u3044\u3002"},"error":"\u7D44\u7E54\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","member":{"title":"\u30E1\u30F3\u30D0\u30FC","titlePlural":"\u30E1\u30F3\u30D0\u30FC","orgTitle":"{{value}} \u30E1\u30F3\u30D0\u30FC","me":"\u79C1\u306E\u4F1A\u54E1\u8CC7\u683C","aboutMe":"\u79C1\u306B\u3064\u3044\u3066","description":"\u30E1\u30F3\u30D0\u30FC\u3068\u306F\u3001\u7D44\u7E54\u306B\u6240\u5C5E\u3059\u308B\u30E6\u30FC\u30B6\u30FC\u3067\u3059\u3002\u30E1\u30F3\u30D0\u30FC\u306B\u306F\u3055\u307E\u3056\u307E\u306A\u5F79\u5272\u3092\u5272\u308A\u5F53\u3066\u308B\u3053\u3068\u304C\u3067\u304D\u3001\u7D44\u7E54\u306E\u3055\u307E\u3056\u307E\u306A\u90E8\u5206\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u3059\u3002","edit":"\u30E1\u30F3\u30D0\u30FC\u3092\u7DE8\u96C6","removed":"\u30C1\u30FC\u30E0\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002","removedDescription":"\u30C1\u30FC\u30E0\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002\u7D44\u7E54\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3057\u305F\u3002\u30A8\u30E9\u30FC\u3060\u3068\u601D\u308F\u308C\u308B\u5834\u5408\u306F\u3001\u7D44\u7E54\u306E\u7BA1\u7406\u8005\u306B\u554F\u3044\u5408\u308F\u305B\u3066\u304F\u3060\u3055\u3044\u3002","updated":"\u6210\u529F\u3057\u307E\u3057\u305F\u3002{{value}} \u306E\u30E1\u30F3\u30D0\u30FC\u30B7\u30C3\u30D7\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002","error":"{{value}} \u306E\u30E1\u30F3\u30D0\u30FC\u30B7\u30C3\u30D7\u306E\u66F4\u65B0\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","delete":"\u6210\u529F\u3057\u307E\u3057\u305F\u3002{{value}} \u304C\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002","deleteError":"{{value}} \u306E\u524A\u9664\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","loadError":"\u7D44\u7E54\u30E1\u30F3\u30D0\u30FC\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","deleteConfirmation":{"title":"\u3053\u306E\u30E1\u30F3\u30D0\u30FC\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B?","description":"\u3053\u306E\u30E1\u30F3\u30D0\u30FC\u3092\u524A\u9664\u3059\u308B\u3068\u3001\u305D\u306E\u30E1\u30F3\u30D0\u30FC\u306F\u7D44\u7E54\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002\u5F8C\u304B\u3089\u3044\u3064\u3067\u3082\u518D\u5EA6\u62DB\u5F85\u3067\u304D\u307E\u3059\u3002","confirm":"\u306F\u3044\u3001\u30E1\u30F3\u30D0\u30FC\u3092\u524A\u9664\u3057\u307E\u3059"},"viewAll":{"title":"\u3059\u3079\u3066\u306E\u30E1\u30F3\u30D0\u30FC\u3092\u8868\u793A","description":"\u7D44\u7E54\u306E\u3059\u3079\u3066\u306E\u30E1\u30F3\u30D0\u30FC\u3092\u8868\u793A\u3057\u3001\u305D\u306E\u5F79\u5272\u3068\u6A29\u9650\u3092\u7BA1\u7406\u3057\u307E\u3059\u3002"},"seats":{"title":"\u4F1A\u54E1\u5E2D","description":"\u7D44\u7E54\u5185\u306E\u3059\u3079\u3066\u306E\u30E1\u30F3\u30D0\u30FC\u304C\u30B7\u30FC\u30C8\u3068\u3057\u3066\u30AB\u30A6\u30F3\u30C8\u3055\u308C\u307E\u3059\u3002\u30E1\u30F3\u30D0\u30FC\u304C\u6301\u3064\u6A29\u9650\u306E\u7A2E\u985E\u306F\u3001\u7D44\u7E54\u7BA1\u7406\u8005\u304C\u5909\u66F4\u3067\u304D\u307E\u3059\u3002","stats":"{{value}} \u5E2D\u4E2D","max":"\u6700\u5927\u5EA7\u5E2D\u6570","maxSeatValue":"\u6700\u5927\u5EA7\u5E2D\u6570: {{value}}","current":"\u73FE\u5728\u306E\u5EA7\u5E2D","limit":{"title":"\u5EA7\u5E2D\u6570\u304C\u4E0A\u9650\u306B\u9054\u3057\u307E\u3057\u305F","description":"\u73FE\u5728\u306E\u30D7\u30E9\u30F3\u306E\u5229\u7528\u53EF\u80FD\u306A\u5EA7\u5E2D\u6570\u306E\u4E0A\u9650\u3067\u3042\u308B {{ maxSeats }} \u306B\u9054\u3057\u307E\u3057\u305F\u3002\u8FFD\u52A0\u30E1\u30F3\u30D0\u30FC\u3092\u62DB\u5F85\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002\u30D7\u30E9\u30F3\u3092\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u304B\u3001\u5EA7\u5E2D\u306E\u5272\u308A\u5F53\u3066\u3092\u7BA1\u7406\u3059\u308B\u306B\u306F\u3001\u7BA1\u7406\u8005\u306B\u554F\u3044\u5408\u308F\u305B\u3066\u304F\u3060\u3055\u3044\u3002"},"updateLimit":{"title":"\u30D7\u30E9\u30F3\u3092\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3057\u3066\u5EA7\u5E2D\u6570\u3092\u5897\u3084\u3059","description":"\u73FE\u5728\u306E\u30D7\u30E9\u30F3\u306F\u6700\u5927\u30B7\u30FC\u30C8\u6570\u306B\u9054\u3057\u307E\u3057\u305F: {{ maxSeats }}\u3002\u4ECA\u3059\u3050\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3057\u3066\u8FFD\u52A0\u30B7\u30FC\u30C8\u306E\u30ED\u30C3\u30AF\u3092\u89E3\u9664\u3057\u3001\u30C1\u30FC\u30E0\u304C\u30B7\u30FC\u30E0\u30EC\u30B9\u306B\u6210\u9577\u3057\u7D9A\u3051\u308B\u3053\u3068\u304C\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","action":"\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u30D7\u30E9\u30F3"}},"emailExists":"\u7D44\u7E54\u5185\u306B\u65E2\u306B\u96FB\u5B50\u30E1\u30FC\u30EB\u304C\u5B58\u5728\u3057\u307E\u3059\u3002\u5225\u306E\u96FB\u5B50\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"invite":{"title":"\u62DB\u5F85\u3059\u308B","titlePlural":"\u62DB\u5F85","orgTitle":"{{ value }} \u62DB\u5F85","description":"\u7D44\u7E54\u306B\u53C2\u52A0\u3059\u308B\u305F\u3081\u306E\u62DB\u5F85\u72B6\u304C\u30E6\u30FC\u30B6\u30FC\u306B\u9001\u4FE1\u3055\u308C\u307E\u3059\u3002\u7D44\u7E54\u306B\u53C2\u52A0\u3059\u308B\u3088\u3046\u30E6\u30FC\u30B6\u30FC\u3092\u62DB\u5F85\u3057\u3001\u3055\u307E\u3056\u307E\u306A\u5F79\u5272\u3092\u5272\u308A\u5F53\u3066\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","edit":"\u30E1\u30F3\u30D0\u30FC\u3092\u8FFD\u52A0\u3059\u308B","view":"\u3059\u3079\u3066\u306E\u62DB\u5F85\u3092\u8868\u793A","viewDescription":"\u73FE\u5728\u627F\u8A8D\u3055\u308C\u3066\u3044\u306A\u3044\u3059\u3079\u3066\u306E\u62DB\u5F85\u3092\u8868\u793A\u3057\u307E\u3059\u3002","new":"\u30E1\u30F3\u30D0\u30FC\u3092\u62DB\u5F85\u3059\u308B","emailRequired":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306F\u5FC5\u9808\u3067\u3059","emailInvalid":"\u96FB\u5B50\u30E1\u30FC\u30EB\u304C\u7121\u52B9\u3067\u3059\u3002\u6709\u52B9\u306A\u96FB\u5B50\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","emailExists":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306B\u306F\u65E2\u306B\u7D44\u7E54\u3078\u306E\u62DB\u5F85\u72B6\u304C\u3042\u308A\u307E\u3059\u3002\u5225\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","emailPlaceholder":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","expiration":"\u671F\u9650\u5207\u308C","delete":"\u62DB\u5F85\u3092\u524A\u9664","confirm":"\u3053\u306E\u62DB\u5F85\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B?","confirmLong":"\u3053\u306E\u62DB\u5F85\u3092\u524A\u9664\u3059\u308B\u3068\u3001\u30E6\u30FC\u30B6\u30FC\u306F\u7D44\u7E54\u306B\u53C2\u52A0\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002\u5F8C\u304B\u3089\u3044\u3064\u3067\u3082\u518D\u5EA6\u62DB\u5F85\u3067\u304D\u307E\u3059\u3002","accept":"\u62DB\u5F85\u3092\u627F\u8AFE","stat":"\u30A2\u30AF\u30C6\u30A3\u30D6\u306A\u62DB\u5F85","error":"\u62DB\u5F85\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","noInvites":{"title":"\u62DB\u5F85\u306F\u3042\u308A\u307E\u305B\u3093\u3002","description":"\u3042\u306A\u305F\u306E\u7D44\u7E54\u306B\u306F\u30A2\u30AF\u30C6\u30A3\u30D6\u306A\u62DB\u5F85\u304C\u306A\u3044\u3088\u3046\u3067\u3059\u3002"},"acceptSuccess":{"title":"\u30C1\u30FC\u30E0\u3078\u3088\u3046\u3053\u305D\u3002","description":"\u7D44\u7E54\u3078\u306E\u53C2\u52A0\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002","action":"\u65B0\u3057\u3044\u7D44\u7E54\u3092\u8868\u793A\u3059\u308B"},"acceptError":{"title":"\u304A\u3063\u3068\u3002\u554F\u984C\u304C\u767A\u751F\u3057\u305F\u3088\u3046\u3067\u3059\u3002","description":"\u7D44\u7E54\u3078\u306E\u53C2\u52A0\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002\u554F\u984C\u304C\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001\u7D44\u7E54\u306E\u7BA1\u7406\u8005\u306B\u554F\u3044\u5408\u308F\u305B\u3066\u304F\u3060\u3055\u3044\u3002","action":"\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8\u306B\u623B\u308B"},"send":{"title":"\u62DB\u5F85\u3092\u9001\u4FE1","success":"{{value}} \u3078\u306E\u62DB\u5F85\u304C\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F\u3002","error":"{{value}} \u3078\u306E\u62DB\u5F85\u306E\u9001\u4FE1\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002"},"editDescription":"\u30E6\u30FC\u30B6\u30FC\u304C\u7D44\u7E54\u306B\u53C2\u52A0\u3059\u308B\u305F\u3081\u306E\u65B0\u3057\u3044\u62DB\u5F85\u72B6\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002"},"role":{"title":"\u5F79\u5272","titlePlural":"\u5F79\u5272","description":"\u5F79\u5272\u3068\u306F\u3001\u7D44\u7E54\u5185\u3067\u30E6\u30FC\u30B6\u30FC\u304C\u6301\u3064\u3053\u3068\u304C\u3067\u304D\u308B\u3055\u307E\u3056\u307E\u306A\u30A2\u30AF\u30BB\u30B9 \u30EC\u30D9\u30EB\u3067\u3059\u3002\u30E6\u30FC\u30B6\u30FC\u306B\u3055\u307E\u3056\u307E\u306A\u5F79\u5272\u3092\u5272\u308A\u5F53\u3066\u3066\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u5B9F\u884C\u3067\u304D\u308B\u64CD\u4F5C\u3092\u5236\u5FA1\u3067\u304D\u307E\u3059\u3002"},"isAdmin":{"title":"\u7BA1\u7406\u8005","description":"\u7BA1\u7406\u8005\u306F\u7D44\u7E54\u3078\u306E\u5B8C\u5168\u306A\u30A2\u30AF\u30BB\u30B9\u6A29\u3092\u6301\u3061\u3001\u7D44\u7E54\u306E\u3042\u3089\u3086\u308B\u5074\u9762\u3092\u7BA1\u7406\u3067\u304D\u307E\u3059\u3002","conflict":"\u3053\u306E\u30E1\u30F3\u30D0\u30FC\u306F\u7BA1\u7406\u8005\u3067\u3059\u3002\u5F79\u5272\u3092\u7DE8\u96C6\u3059\u308B\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002"},"canViewMembers":{"title":"\u30E1\u30F3\u30D0\u30FC\u3092\u8868\u793A","description":"\u3053\u306E\u6A29\u9650\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u7D44\u7E54\u306E\u3059\u3079\u3066\u306E\u30E1\u30F3\u30D0\u30FC\u3092\u8868\u793A\u3067\u304D\u307E\u3059\u3002"},"canInviteMembers":{"title":"\u30E1\u30F3\u30D0\u30FC\u3092\u62DB\u5F85","description":"\u3053\u306E\u6A29\u9650\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u7D44\u7E54\u306B\u65B0\u3057\u3044\u30E1\u30F3\u30D0\u30FC\u3092\u62DB\u5F85\u3057\u305F\u308A\u3001\u65E2\u5B58\u306E\u62DB\u5F85\u3092\u7BA1\u7406\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002"},"canChangeMemberPermissions":{"title":"\u30E1\u30F3\u30D0\u30FC\u306E\u5F79\u5272\u3092\u5909\u66F4\u3059\u308B","description":"\u3053\u306E\u6A29\u9650\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u7D44\u7E54\u5185\u306E\u4ED6\u306E\u30E1\u30F3\u30D0\u30FC\u306E\u5F79\u5272\u3092\u5909\u66F4\u3067\u304D\u307E\u3059\u3002"},"canRemoveMembers":{"title":"\u30E1\u30F3\u30D0\u30FC\u3092\u524A\u9664","titleSingle":"\u30E1\u30F3\u30D0\u30FC\u3092\u524A\u9664","action":"\u53D6\u308A\u9664\u304F","description":"\u3053\u306E\u6A29\u9650\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u7D44\u7E54\u304B\u3089\u4ED6\u306E\u30E1\u30F3\u30D0\u30FC\u3092\u524A\u9664\u3067\u304D\u307E\u3059\u3002","confirm":"\u3053\u306E\u30E1\u30F3\u30D0\u30FC\u3092\u7D44\u7E54\u304B\u3089\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B?","confirmLong":"\u3053\u306E\u30E1\u30F3\u30D0\u30FC\u3092\u524A\u9664\u3059\u308B\u3068\u3001\u305D\u306E\u30E1\u30F3\u30D0\u30FC\u306F\u7D44\u7E54\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002\u5F8C\u304B\u3089\u3044\u3064\u3067\u3082\u518D\u5EA6\u62DB\u5F85\u3067\u304D\u307E\u3059\u3002"},"canCreateAuthClients":{"title":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u4F5C\u6210\u3059\u308B","description":"\u3053\u306E\u6A29\u9650\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u7D44\u7E54\u306B\u5BFE\u3057\u3066\u65B0\u3057\u3044\u8A8D\u8A3C\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u3068\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002"},"canManageBilling":{"title":"\u8ACB\u6C42\u306E\u7BA1\u7406","description":"\u3053\u306E\u6A29\u9650\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u7D44\u7E54\u306E\u8AB2\u91D1\u8A2D\u5B9A\u3092\u7BA1\u7406\u3067\u304D\u307E\u3059\u3002","error":"\u3053\u306E\u7D44\u7E54\u306E\u8ACB\u6C42\u3092\u7BA1\u7406\u3059\u308B\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002"},"canManageChildOrganizations":{"title":"\u5B50\u7D44\u7E54\u306E\u7BA1\u7406","description":"\u3053\u306E\u6A29\u9650\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u7BA1\u7406\u8005\u3068\u3057\u3066\u5B50\u7D44\u7E54\u3092\u4F5C\u6210\u304A\u3088\u3073\u7BA1\u7406\u3067\u304D\u307E\u3059\u3002"},"canViewAnalytics":{"title":"\u5206\u6790\u3092\u8868\u793A","description":"\u3053\u306E\u6A29\u9650\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u7D44\u7E54\u306E\u6307\u6A19\u3068\u5206\u6790\u3092\u8868\u793A\u3067\u304D\u307E\u3059\u3002"},"metrics":{"title":"\u30E1\u30C8\u30EA\u30AF\u30B9","description":"\u30E1\u30C8\u30EA\u30C3\u30AF\u306F\u3001\u7D44\u7E54\u304C Cephable \u3092\u3069\u306E\u3088\u3046\u306B\u4F7F\u7528\u3057\u3066\u3044\u308B\u304B\u3092\u7406\u89E3\u3059\u308B\u306E\u306B\u5F79\u7ACB\u3064\u30C7\u30FC\u30BF \u30DD\u30A4\u30F3\u30C8\u3067\u3059\u3002","view":"\u6307\u6A19\u3092\u8868\u793A","orgTitle":"{{ value }} \u30E1\u30C8\u30EA\u30C3\u30AF","lineChart":{"title":"\u5E73\u5747\u540C\u6642\u63A5\u7D9A\u6570","description":"\u3053\u306E\u30B0\u30E9\u30D5\u306B\u306F\u3001\u7D44\u7E54\u3068\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30C7\u30FC\u30BF\u306E\u5E73\u5747\u540C\u6642\u63A5\u7D9A\u6570\u304C\u6642\u9593\u306E\u7D4C\u904E\u3068\u3068\u3082\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002","max":"\u6700\u5927\u63A5\u7D9A\u6570: {{maxConnections}}","project":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u5408\u8A08","org":"\u7D44\u7E54\u5408\u8A08"},"manage":{"title":"\u30D1\u30D5\u30A9\u30FC\u30DE\u30F3\u30B9\u30E1\u30C8\u30EA\u30C3\u30AF","description":"\u30E2\u30C7\u30EB\u63A8\u8AD6\u4E2D\u306B\u53CE\u96C6\u3055\u308C\u305F\u30D1\u30D5\u30A9\u30FC\u30DE\u30F3\u30B9 \u30E1\u30C8\u30EA\u30C3\u30AF\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u307E\u305F\u306F\u30AF\u30EA\u30A2\u3057\u307E\u3059\u3002"},"download":{"button":"\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u30E1\u30C8\u30EA\u30AF\u30B9","success":"\u30E1\u30C8\u30EA\u30C3\u30AF \u30D5\u30A1\u30A4\u30EB\u306F\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9 \u30D5\u30A9\u30EB\u30C0\u30FC\u306B\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F\u3002","error":"\u30E1\u30C8\u30EA\u30C3\u30AF \u30D5\u30A1\u30A4\u30EB\u306E\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002","noFile":"\u30E1\u30C8\u30EA\u30AF\u30B9\u30D5\u30A1\u30A4\u30EB\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002\u307E\u305A\u306F\u30E2\u30C7\u30EB\u3092\u5B9F\u884C\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002"},"clear":{"button":"\u660E\u78BA\u306A\u6307\u6A19","success":"\u30E1\u30C8\u30EA\u30C3\u30AF\u304C\u30AF\u30EA\u30A2\u3055\u308C\u307E\u3057\u305F\u3002","error":"\u30E1\u30C8\u30EA\u30C3\u30AF \u30D5\u30A1\u30A4\u30EB\u306E\u30AF\u30EA\u30A2\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002","confirm":{"title":"\u660E\u78BA\u306A\u30D1\u30D5\u30A9\u30FC\u30DE\u30F3\u30B9\u6307\u6A19","description":"\u8A18\u9332\u3055\u308C\u305F\u3059\u3079\u3066\u306E\u30D1\u30D5\u30A9\u30FC\u30DE\u30F3\u30B9 \u30E1\u30C8\u30EA\u30C3\u30AF\u3092\u30AF\u30EA\u30A2\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B? \u3053\u306E\u64CD\u4F5C\u306F\u5143\u306B\u623B\u305B\u307E\u305B\u3093\u3002","cancel":"\u30AD\u30E3\u30F3\u30BB\u30EB","confirm":"\u660E\u78BA\u306A\u6307\u6A19"}}},"projects":{"title":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8","description":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u4F7F\u7528\u3057\u3066\u3001\u5B89\u5168\u306A\u30A2\u30AF\u30BB\u30B9\u3092\u7BA1\u7406\u3057\u3001\u30C7\u30D0\u30A4\u30B9\u306E\u30A4\u30F3\u30BF\u30E9\u30AF\u30B7\u30E7\u30F3\u3092\u69CB\u6210\u3057\u3001\u3055\u307E\u3056\u307E\u306A\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u9593\u3067\u30A2\u30D7\u30EA\u304C\u30B3\u30DE\u30F3\u30C9\u3092\u9001\u53D7\u4FE1\u3059\u308B\u65B9\u6CD5\u3092\u52B9\u7387\u5316\u3057\u307E\u3059\u3002","name":"\u30A2\u30D7\u30EA\u540D","view":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u898B\u308B","error":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","orgTitle":"{{ value }} \u30D7\u30ED\u30B8\u30A7\u30AF\u30C8","stats":{"title":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u7D71\u8A08","connections":"\u5408\u8A08\u63A5\u7D9A\u6570","all":{"title":"\u3059\u3079\u3066\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u6307\u6A19","description":"{{ orgName }} \u306B\u95A2\u9023\u4ED8\u3051\u3089\u308C\u3066\u3044\u308B\u3059\u3079\u3066\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u96C6\u8A08\u30E1\u30C8\u30EA\u30C3\u30AF"},"card":"{{value}} \u500B\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u3046\u3061","users":"{{date}} \u4EE5\u964D\u306E\u5408\u8A08\u30E6\u30FC\u30B6\u30FC\u6570","avgUsers":"\u6708\u9593\u5E73\u5747\u30E6\u30FC\u30B6\u30FC\u6570\u3002","concurrent":{"title":"\u904E\u53BB {{days}} \u65E5\u9593\u306E\u5E73\u5747\u540C\u6642\u63A5\u7D9A\u6570","label":"\u5E73\u5747\u540C\u6642\u63A5\u7D9A\u6570","max":"\u6700\u5927\u63A5\u7D9A\u6570","overage":"\u8D85\u904E\u6599\u91D1","description":"\u540C\u6642\u63A5\u7D9A\u3068\u306F\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u540C\u6642\u306B\u63A5\u7D9A\u3057\u3066\u3044\u308B\u30E6\u30FC\u30B6\u30FC\u306E\u6570\u3067\u3059\u3002\u3053\u306E\u6307\u6A19\u306F\u3001\u540C\u6642\u306B\u30A2\u30D7\u30EA\u3092\u4F7F\u7528\u3057\u3066\u3044\u308B\u30E6\u30FC\u30B6\u30FC\u306E\u6570\u3092\u628A\u63E1\u3059\u308B\u306E\u306B\u5F79\u7ACB\u3061\u307E\u3059\u3002"}},"projectType":{"title":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u30BF\u30A4\u30D7","description":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30BF\u30A4\u30D7\u306F\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u5206\u985E\u3057\u3001\u9069\u5207\u306A SDK \u3092\u9078\u629E\u3059\u308B\u305F\u3081\u306B\u4F7F\u7528\u3055\u308C\u307E\u3059\u3002"},"accessDenied":{"generic":"\u3053\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u6A29\u304C\u3042\u308A\u307E\u305B\u3093\u3002","title":"\u30A2\u30AF\u30BB\u30B9\u304C\u62D2\u5426\u3055\u308C\u307E\u3057\u305F\u3002","description":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u8868\u793A\u3001\u4F5C\u6210\u3001\u7DE8\u96C6\u3001\u524A\u9664\u3059\u308B\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002\u30A2\u30AF\u30BB\u30B9\u6A29\u306B\u3064\u3044\u3066\u306F\u7BA1\u7406\u8005\u306B\u554F\u3044\u5408\u308F\u305B\u3066\u304F\u3060\u3055\u3044\u3002"},"upgrade":{"title":"Cephable SDK \u3078\u306E\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9","description":"Cephable \u306F\u3001SDK \u3092\u4F7F\u7528\u3057\u3066\u30A2\u30D7\u30EA\u3001\u30B2\u30FC\u30E0\u3001\u307E\u305F\u306F\u30B5\u30FC\u30D3\u30B9\u306B\u76F4\u63A5\u7D71\u5408\u3067\u304D\u307E\u3059\u3002\u73FE\u5728\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306F\u304A\u5BA2\u69D8\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u3067\u306F\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u305B\u3093\u3002\u9593\u9055\u3044\u304C\u3042\u308B\u3068\u601D\u308F\u308C\u308B\u5834\u5408\u306F\u3001support@cephable.com \u307E\u3067\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002","shortDescription":"\u73FE\u5728\u3001\u3042\u306A\u305F\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u3067\u306F\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u5229\u7528\u3067\u304D\u307E\u305B\u3093\u3002\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u306B\u306F\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002"},"limit":{"title":"\u3082\u3063\u3068\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u304C\u6B32\u3057\u3044\u3067\u3059\u304B?","error":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u5236\u9650\u306B\u9054\u3057\u307E\u3057\u305F\u3002","description":"\u7D44\u7E54\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u6570\u306E\u4E0A\u9650\u306B\u9054\u3057\u307E\u3057\u305F\u3002\u7BA1\u7406\u8005\u306B\u9023\u7D61\u3057\u3066\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"create":{"title":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u4F5C\u6210","titleLong":"\u59CB\u3081\u307E\u3057\u3087\u3046\u3002","first":{"title":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u59CB\u3081\u307E\u3057\u3087\u3046\u3002","description":"\u307E\u3060\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u4F5C\u6210\u3057\u3066\u3044\u306A\u3044\u3088\u3046\u3067\u3059\u3002\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8 \u30AD\u30FC\u3068\u30C7\u30D0\u30A4\u30B9\u306F\u3001\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3068\u5F53\u793E\u306E\u30B5\u30FC\u30D3\u30B9\u9593\u306E\u901A\u4FE1\u3092\u5B89\u5168\u306B\u3059\u308B\u305F\u3081\u306B\u4E0D\u53EF\u6B20\u3067\u3059\u3002\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8 \u30AD\u30FC\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u97F3\u58F0\u3068\u30D8\u30C3\u30C9 \u30E2\u30FC\u30B7\u30E7\u30F3 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30A2\u30D7\u30EA\u306B\u8FC5\u901F\u304B\u3064\u5B89\u5168\u306B\u7D71\u5408\u3067\u304D\u307E\u3059\u3002"},"details":{"title":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u8A73\u7D30","description":"\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306E\u8A8D\u8A3C\u3001\u30C7\u30D0\u30A4\u30B9\u6A5F\u80FD\u3001SDK \u7D71\u5408\u3092\u7BA1\u7406\u3059\u308B\u306B\u306F\u3001\u65B0\u3057\u3044\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002\u4EE5\u4E0B\u306E\u624B\u9806\u306B\u5F93\u3063\u3066\u3001\u30E6\u30FC\u30B6\u30FC\u5411\u3051\u306B\u5B89\u5168\u3067\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u53EF\u80FD\u306A\u30A4\u30F3\u30BF\u30E9\u30AF\u30B7\u30E7\u30F3\u3092\u8A2D\u5B9A\u3057\u307E\u3059\u3002"}},"sdk":{"title":"SDK\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9","description":"\u9069\u5FDC\u578B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u7C21\u5358\u306B\u3059\u308B\u305F\u3081\u306B\u958B\u767A\u3055\u308C\u305F\u5F37\u529B\u306A SDK \u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u3059\u3002","select":{"title":"SDK\u3092\u9078\u629E","description":"\u3053\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3067\u4F7F\u7528\u3059\u308B SDK \u3092\u9078\u629E\u3057\u307E\u3059\u3002\u5F53\u793E\u306E SDK \u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u3055\u307E\u3056\u307E\u306A\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u9593\u3067\u9069\u5FDC\u578B\u97F3\u58F0\u304A\u3088\u3073\u30D8\u30C3\u30C9 \u30E2\u30FC\u30B7\u30E7\u30F3 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30B7\u30FC\u30E0\u30EC\u30B9\u306B\u7D71\u5408\u3067\u304D\u307E\u3059\u3002"}},"clients":{"title":"\u8A8D\u53EF\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8","configure":"\u8A8D\u8A3C\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u306E\u8A2D\u5B9A","description":"\u627F\u8A8D\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u306F\u3001\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3078\u306E\u5B89\u5168\u306A\u30A2\u30AF\u30BB\u30B9\u3092\u7BA1\u7406\u3057\u307E\u3059\u3002\u627F\u8A8D\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u3092\u5B9A\u7FA9\u3057\u3066\u3001\u30E6\u30FC\u30B6\u30FC\u3092\u8A8D\u8A3C\u3057\u3001\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3068\u306E\u3084\u308A\u53D6\u308A\u3092\u5236\u5FA1\u3057\u307E\u3059\u3002","settings":"\u8A8D\u8A3C\u8A2D\u5B9A","create":"\u627F\u8A8D\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u306E\u4F5C\u6210","max":"\u6700\u5927\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u6570: {{value}}"},"secret":{"title":"\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u30B7\u30FC\u30AF\u30EC\u30C3\u30C8","created":"\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u30B7\u30FC\u30AF\u30EC\u30C3\u30C8\u304C\u4F5C\u6210\u3055\u308C\u307E\u3057\u305F\u3002","description":"\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8 \u30B7\u30FC\u30AF\u30EC\u30C3\u30C8\u306F 1 \u56DE\u3060\u3051\u8868\u793A\u3055\u308C\u307E\u3059\u3002\u4ECA\u3059\u3050\u30B3\u30D4\u30FC\u3057\u3066\u3001\u5B89\u5168\u306A\u5834\u6240\u306B\u4FDD\u7BA1\u3057\u3066\u304F\u3060\u3055\u3044\u3002<br><br>\u3054\u81EA\u8EAB\u306E\u958B\u767A\u306B\u306E\u307F\u4F7F\u7528\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3\u306E\u30B5\u30FC\u30D3\u30B9\u3084\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3068\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002","copy":"\u30B7\u30FC\u30AF\u30EC\u30C3\u30C8\u3092\u30B3\u30D4\u30FC","rotate":{"title":"\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u30B7\u30FC\u30AF\u30EC\u30C3\u30C8\u306E\u30ED\u30FC\u30C6\u30FC\u30B7\u30E7\u30F3","description":"\u8B66\u544A: \u3053\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u306B\u3088\u308A\u3001\u65E2\u5B58\u306E\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8 \u30B7\u30FC\u30AF\u30EC\u30C3\u30C8\u304C\u53D6\u308A\u6D88\u3055\u308C\u3001\u65B0\u3057\u3044\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8 \u30B7\u30FC\u30AF\u30EC\u30C3\u30C8\u304C\u4F5C\u6210\u3055\u308C\u307E\u3059\u3002\u3053\u306E\u305F\u3081\u3001\u30A2\u30D7\u30EA\u5168\u4F53\u3067\u65E2\u5B58\u306E\u4F7F\u7528\u72B6\u6CC1\u3092\u3059\u3079\u3066\u66F4\u65B0\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u5143\u306B\u623B\u3059\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002","error":"\u30B7\u30FC\u30AF\u30EC\u30C3\u30C8\u306E\u30ED\u30FC\u30C6\u30FC\u30B7\u30E7\u30F3\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002"}},"key":{"title":"\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u30AD\u30FC","view":"\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u30AD\u30FC\u3092\u8868\u793A","copy":"\u30AD\u30FC\u3092\u30B3\u30D4\u30FC","delete":{"title":"\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u30AD\u30FC\u306E\u524A\u9664","description":"\u8B66\u544A: \u3053\u306E\u64CD\u4F5C\u306B\u3088\u308A\u3001\u65E2\u5B58\u306E\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8 \u30AD\u30FC\u3068\u95A2\u9023\u3059\u308B\u3059\u3079\u3066\u306E\u8A2D\u5B9A\u304C\u524A\u9664\u3055\u308C\u307E\u3059\u3002\u3053\u306E\u64CD\u4F5C\u3092\u5143\u306B\u623B\u3059\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002","error":"\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8 \u30AD\u30FC\u306E\u524A\u9664\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","success":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306F\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002"}},"tokenRedirect":{"title":"\u30C8\u30FC\u30AF\u30F3\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8 URL","description":"\u30C8\u30FC\u30AF\u30F3 \u30EA\u30C0\u30A4\u30EC\u30AF\u30C8 URL \u306F\u3001\u8A8D\u8A3C\u304C\u5B8C\u4E86\u3057\u305F\u5F8C\u306B\u30A2\u30AF\u30BB\u30B9 \u30C8\u30FC\u30AF\u30F3\u304C\u9001\u4FE1\u3055\u308C\u308B\u30A8\u30F3\u30C9\u30DD\u30A4\u30F3\u30C8\u3067\u3059\u3002\u3053\u308C\u3089\u306E URL \u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306F\u30E6\u30FC\u30B6\u30FC \u30C7\u30FC\u30BF\u3084\u30B5\u30FC\u30D3\u30B9\u306B\u30A2\u30AF\u30BB\u30B9\u3059\u308B\u305F\u3081\u306B\u5FC5\u8981\u306A\u30C8\u30FC\u30AF\u30F3\u3092\u5B89\u5168\u306B\u53D7\u4FE1\u3067\u304D\u307E\u3059\u3002"},"authRedirect":{"title":"\u8A8D\u8A3C\u30B3\u30FC\u30C9\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8 URL","description":"AuthCode \u30EA\u30C0\u30A4\u30EC\u30AF\u30C8 URL \u306F\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306B\u6A29\u9650\u3092\u4ED8\u4E0E\u3057\u305F\u5F8C\u306B\u8A8D\u8A3C\u30B3\u30FC\u30C9\u304C\u9001\u4FE1\u3055\u308C\u308B\u30A8\u30F3\u30C9\u30DD\u30A4\u30F3\u30C8\u3067\u3059\u3002\u3053\u306E URL \u306F\u3001OAuth \u30D5\u30ED\u30FC\u306B\u4E0D\u53EF\u6B20\u3067\u3059\u3002\u8A8D\u8A3C\u30B5\u30FC\u30D0\u30FC\u304B\u3089\u30A2\u30D7\u30EA\u3078\u306E\u8A8D\u8A3C\u30B3\u30FC\u30C9\u306E\u5B89\u5168\u306A\u9001\u4FE1\u3092\u4FDD\u8A3C\u3057\u3001\u30E6\u30FC\u30B6\u30FC\u306B\u4EE3\u308F\u3063\u3066\u30A2\u30AF\u30BB\u30B9 \u30C8\u30FC\u30AF\u30F3\u3092\u8981\u6C42\u3067\u304D\u308B\u3088\u3046\u306B\u3059\u308B\u305F\u3081\u3067\u3059\u3002"},"originHost":{"title":"\u5143\u306E\u30DB\u30B9\u30C8","description":"API \u306E\u3084\u308A\u53D6\u308A\u4E2D\u306B\u30EA\u30AF\u30A8\u30B9\u30C8\u3068\u30C7\u30FC\u30BF\u306E\u4E3B\u306A\u30BD\u30FC\u30B9\u3068\u3057\u3066\u6A5F\u80FD\u3059\u308B URL\u3002"},"scopes":{"title":"\u30B9\u30B3\u30FC\u30D7","configure":"\u30B9\u30B3\u30FC\u30D7\u3092\u5B9A\u7FA9\u3059\u308B","titleLong":"API \u6A29\u9650\u30B9\u30B3\u30FC\u30D7","manage":"\u627F\u8A8D\u30B9\u30B3\u30FC\u30D7\u306E\u7BA1\u7406","description":"\u30B9\u30B3\u30FC\u30D7\u306F\u3001\u3053\u306E\u627F\u8A8D\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u304C\u6301\u3064\u6A29\u9650\u3092\u5B9A\u7FA9\u3057\u307E\u3059\u3002\u30B9\u30B3\u30FC\u30D7\u3092\u8A2D\u5B9A\u3057\u3066\u7279\u5B9A\u306E\u30C7\u30FC\u30BF\u3068\u6A5F\u80FD\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u5236\u9650\u3057\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u5FC5\u8981\u306A\u30A2\u30AF\u30BB\u30B9\u306E\u307F\u3092\u53D6\u5F97\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002"},"type":{"title":"\u5B9F\u88C5\u30BF\u30A4\u30D7"},"deviceScopes":{"title":"\u95A2\u9023\u30C7\u30D0\u30A4\u30B9\u306E\u7A2E\u985E","titles":"\u95A2\u9023\u30C7\u30D0\u30A4\u30B9\u306E\u7A2E\u985E","titleLong":"\u8A31\u53EF\u3055\u308C\u308B\u30C7\u30D0\u30A4\u30B9\u306E\u7A2E\u985E","configure":"\u8A31\u53EF\u3055\u308C\u308B\u30C7\u30D0\u30A4\u30B9\u306E\u7A2E\u985E\u3092\u8A2D\u5B9A\u3059\u308B","descriptionShort":"\u3053\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u308B\u30C7\u30D0\u30A4\u30B9\u306E\u30BF\u30A4\u30D7\u3092\u5B9A\u7FA9\u3057\u307E\u3059\u3002","description":"\u30C7\u30D0\u30A4\u30B9 \u30BF\u30A4\u30D7\u306F\u3001\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u5185\u3067\u30C7\u30D0\u30A4\u30B9\u304C\u6301\u3064\u6A29\u9650\u3068\u30A2\u30AF\u30BB\u30B9 \u30EC\u30D9\u30EB\u3092\u5B9A\u7FA9\u3057\u307E\u3059\u3002\u7279\u5B9A\u306E\u30C7\u30D0\u30A4\u30B9 \u30BF\u30A4\u30D7\u3092\u5272\u308A\u5F53\u3066\u308B\u3053\u3068\u3067\u3001\u5404\u30C7\u30D0\u30A4\u30B9\u304C\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u308B\u30A2\u30AF\u30B7\u30E7\u30F3\u3068\u30C7\u30FC\u30BF\u3092\u5236\u5FA1\u3067\u304D\u3001\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306E\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u3092\u7DAD\u6301\u3057\u3001\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC \u30DD\u30EA\u30B7\u30FC\u306B\u6E96\u62E0\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","action":"\u65B0\u3057\u3044\u30C7\u30D0\u30A4\u30B9\u30BF\u30A4\u30D7\u3092\u8FFD\u52A0"},"deviceType":{"title":"\u30C7\u30D0\u30A4\u30B9\u306E\u7A2E\u985E","description":"DeviceType \u306F\u3001\u30C7\u30D0\u30A4\u30B9\u306E\u30AB\u30C6\u30B4\u30EA\u3092\u5B9A\u7FA9\u3057\u3001\u305D\u306E\u5165\u51FA\u529B\u6A5F\u80FD\u3068\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u308B\u6A5F\u80FD (\u97F3\u58F0\u3001\u30B8\u30A7\u30B9\u30C1\u30E3\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u306E\u7A2E\u985E\u306A\u3069) \u3092\u8A73\u7D30\u306B\u8AAC\u660E\u3057\u307E\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u627F\u8A8D\u3055\u308C\u305F\u30C7\u30D0\u30A4\u30B9\u306E\u307F\u304C\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3068\u5BFE\u8A71\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002","action":"\u30C7\u30D0\u30A4\u30B9\u30BF\u30A4\u30D7\u306E\u4F5C\u6210","name":"\u30C7\u30D0\u30A4\u30B9\u30BF\u30A4\u30D7\u540D","descriptionLong":"\u30C7\u30D0\u30A4\u30B9\u30BF\u30A4\u30D7\u306E\u8AAC\u660E","id":"\u30C7\u30D0\u30A4\u30B9\u30BF\u30A4\u30D7ID","features":{"title":"\u30B5\u30DD\u30FC\u30C8\u6A5F\u80FD","description":"\u30A2\u30D7\u30EA\u304C\u30B5\u30DD\u30FC\u30C8\u3059\u308B\u5165\u529B\u3068\u51FA\u529B\u3092\u5B9A\u7FA9\u3057\u307E\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001Cephable \u5168\u4F53\u306E\u30E6\u30FC\u30B6\u30FC \u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u6700\u9069\u5316\u3067\u304D\u307E\u3059\u3002","supportsVoiceInput":"\u97F3\u58F0\u5165\u529B","supportsPhysicalInput":"\u7269\u7406\u7684\u5165\u529B","supportsKeyboardOutput":"\u30AD\u30FC\u30DC\u30FC\u30C9\u51FA\u529B","supportsPlayStationControllerOutput":"\u30D7\u30EC\u30A4\u30B9\u30C6\u30FC\u30B7\u30E7\u30F3 \u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC","supportsFaceInput":"\u9854\u5165\u529B","supportsGestureInput":"\u30B8\u30A7\u30B9\u30C1\u30E3\u30FC\u5165\u529B","supportsXboxControllerOutput":"Xbox \u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC","supportsDigitalExtensions":"\u30C7\u30B8\u30BF\u30EB\u62E1\u5F35\u6A5F\u80FD","supportsPhysicalExtensions":"\u7269\u7406\u7684\u306A\u62E1\u5F35","supportsNintendoControllerOutput":"\u4EFB\u5929\u5802\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC","supportsGenericControllerOutput":"\u6C4E\u7528\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u51FA\u529B"},"canAutoStart":{"title":"\u81EA\u52D5\u5236\u5FA1\u30B9\u30BF\u30FC\u30C8\u3092\u30B5\u30DD\u30FC\u30C8","description":"[canAutoStart] \u3092\u6709\u52B9\u306B\u3059\u308B\u3068\u3001SDK \u306F\u30E6\u30FC\u30B6\u30FC\u8A2D\u5B9A\u3092\u78BA\u8A8D\u3057\u3001\u30E6\u30FC\u30B6\u30FC\u306E\u30ED\u30B0\u30A4\u30F3\u5F8C\u306B\u30AB\u30E1\u30E9\u307E\u305F\u306F\u30DE\u30A4\u30AF\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u3059\u3050\u306B\u958B\u59CB\u3057\u3088\u3046\u3068\u3057\u307E\u3059\u3002"},"isSupported":{"title":"\u30A2\u30AF\u30C6\u30A3\u30D6","description":"[isSupported] \u7121\u52B9\u306B\u3059\u308B\u3068\u3001Cephable \u306F\u3053\u308C\u306B\u95A2\u9023\u4ED8\u3051\u3089\u308C\u305F\u30E6\u30FC\u30B6\u30FC\u30C7\u30D0\u30A4\u30B9\u3092\u9001\u4FE1\u3001\u53D7\u4FE1\u3001\u307E\u305F\u306F\u78BA\u8A8D\u3057\u306A\u304F\u306A\u308A\u307E\u3059\u3002\u975E\u63A8\u5968\u306B\u76F8\u5F53\u3057\u307E\u3059\u3002"},"locale":{"title":"\u30C7\u30D5\u30A9\u30EB\u30C8\u8A00\u8A9E","description":"[defaultLocale] \u3053\u306E\u30C7\u30D0\u30A4\u30B9 \u30BF\u30A4\u30D7\u306E\u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u30ED\u30B1\u30FC\u30EB\u3002\u3053\u308C\u306F\u30C7\u30D0\u30A4\u30B9\u306E\u30C7\u30D5\u30A9\u30EB\u30C8\u8A00\u8A9E\u3068\u3057\u3066\u4F7F\u7528\u3055\u308C\u307E\u3059\u3002","support":"\u30B5\u30DD\u30FC\u30C8\u8A00\u8A9E","warn":"** \u30AB\u30B9\u30BF\u30E0 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u308B\u3088\u3046\u3067\u3059\u3002\u95A2\u9023\u3059\u308B\u8A00\u8A9E\u306E\u30AB\u30B9\u30BF\u30E0 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u66F4\u65B0\u3055\u308C\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002**","name":"{{lang}} - \u30C7\u30D0\u30A4\u30B9\u30BF\u30A4\u30D7\u540D","langDescription":"{{lang}} - \u8AAC\u660E"},"customControls":{"title":"\u30AB\u30B9\u30BF\u30E0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","object":"{{lang}} - \u30AB\u30B9\u30BF\u30E0 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB \u30AA\u30D6\u30B8\u30A7\u30AF\u30C8","description":"\u30AB\u30B9\u30BF\u30E0 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u306B\u95A2\u9023\u4ED8\u3051\u3089\u308C\u305F\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u624B\u52D5\u3067\u8A2D\u5B9A\u304A\u3088\u3073\u7DE8\u96C6\u3067\u304D\u308B\u3088\u3046\u306B\u3059\u308B\u9AD8\u5EA6\u306A\u30AA\u30D7\u30B7\u30E7\u30F3\u3067\u3059\u3002\u30E6\u30FC\u30B6\u30FC\u304C Cephable \u304B\u3089\u76F4\u63A5\u30C7\u30D0\u30A4\u30B9\u3092\u5236\u5FA1\u3067\u304D\u308B\u3088\u3046\u306B\u3059\u308B\u306B\u306F\u3001\u3053\u3053\u3067\u30C7\u30D0\u30A4\u30B9 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u767B\u9332\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u30AA\u30D7\u30B7\u30E7\u30F3\u306E\u8A73\u7D30\u306B\u3064\u3044\u3066\u306F\u3001Cephable API \u3092\u53C2\u7167\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"success":{"title":"\u6210\u529F\uFF01","description":"\u65B0\u3057\u3044\u30C7\u30D0\u30A4\u30B9 \u30BF\u30A4\u30D7\u3092\u4F5C\u6210\u3057\u307E\u3057\u305F\u3002{{name}} \u5FC5\u8981\u306B\u5FDC\u3058\u3066\u3001\u8A8D\u8A3C\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u306E\u30C7\u30D0\u30A4\u30B9 \u30B9\u30B3\u30FC\u30D7\u3092\u66F4\u65B0\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002"},"throttleRules":{"title":"\u30B3\u30DE\u30F3\u30C9\u30B9\u30ED\u30C3\u30C8\u30EB\u30EB\u30FC\u30EB","description":"\u3053\u306E\u30C7\u30D0\u30A4\u30B9 \u30BF\u30A4\u30D7\u306E\u30B3\u30DE\u30F3\u30C9 \u30D5\u30ED\u30FC\u3068\u5165\u529B\u5236\u9650\u3092\u5236\u5FA1\u3059\u308B\u305F\u3081\u306E\u30B9\u30ED\u30C3\u30C8\u30EB \u30EB\u30FC\u30EB\u3092\u69CB\u6210\u3057\u307E\u3059\u3002","disableVoiceInput":"\u97F3\u58F0\u5165\u529B\u3092\u7121\u52B9\u306B\u3059\u308B","disableHotkeyInput":"\u30DB\u30C3\u30C8\u30AD\u30FC\u5165\u529B\u3092\u7121\u52B9\u306B\u3059\u308B","disableCameraInput":"\u30AB\u30E1\u30E9\u5165\u529B\u3092\u7121\u52B9\u306B\u3059\u308B","disableMultiInputs":"\u8907\u6570\u5165\u529B\u3092\u7121\u52B9\u306B\u3059\u308B","maximumCommandsPerSecond":"1\u79D2\u3042\u305F\u308A\u306E\u6700\u5927\u30B3\u30DE\u30F3\u30C9\u6570","maximumCommandsPerMinute":"1\u5206\u3042\u305F\u308A\u306E\u6700\u5927\u30B3\u30DE\u30F3\u30C9\u6570","maximumMacroLength":"\u6700\u5927\u30DE\u30AF\u30ED\u9577"}}},"new":{"details":"\u7D44\u7E54\u306E\u8A73\u7D30","name":{"label":"\u7D44\u7E54\u540D","placeholder":"\u7D44\u7E54\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"},"description":{"label":"\u7D44\u7E54\u306E\u8AAC\u660E","placeholder":"Cephable Professional \u3092\u4F7F\u7528\u3059\u308B\u76EE\u7684\u306F\u4F55\u3067\u3059\u304B?"}},"expired":{"user":"Cephable\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u305F\u305F\u3081\u3001\u7121\u6599\u306ECephable Basic\u306B\u30C0\u30A6\u30F3\u30B0\u30EC\u30FC\u30C9\u3055\u308C\u307E\u3057\u305F\u3002\u66F4\u65B0\u3059\u308B\u306B\u306F\u3001\u7D44\u7E54\u306E\u7BA1\u7406\u8005\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002","admin":"Cephable\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u305F\u305F\u3081\u3001\u7121\u6599\u306ECephable Basic\u306B\u30C0\u30A6\u30F3\u30B0\u30EC\u30FC\u30C9\u3055\u308C\u307E\u3057\u305F\u3002Cephable Basic\u3092\u8D85\u3048\u308B\u9AD8\u5EA6\u306A\u6A5F\u80FD\u3092\u5F15\u304D\u7D9A\u304D\u3054\u5229\u7528\u3044\u305F\u3060\u304F\u306B\u306F\u3001\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u66F4\u65B0\u3057\u3066\u304F\u3060\u3055\u3044\u3002","multiple":"Cephable\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u305F\u305F\u3081\u3001\u7121\u6599\u306ECephable Basic\u306B\u30C0\u30A6\u30F3\u30B0\u30EC\u30FC\u30C9\u3055\u308C\u307E\u3057\u305F\u3002Cephable Basic\u3092\u8D85\u3048\u308B\u9AD8\u5EA6\u306A\u6A5F\u80FD\u3092\u5F15\u304D\u7D9A\u304D\u3054\u5229\u7528\u3044\u305F\u3060\u304F\u306B\u306F\u3001\u5C11\u306A\u304F\u3068\u30821\u3064\u306E\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u66F4\u65B0\u3057\u3066\u304F\u3060\u3055\u3044\u3002","dialog":{"title":"\u7D44\u7E54\u3092\u9078\u629E","description":"\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u306F\u8907\u6570\u306E\u7D44\u7E54\u304C\u95A2\u9023\u4ED8\u3051\u3089\u308C\u3066\u3044\u307E\u3059\u3002\u66F4\u65B0\u3059\u308B\u7D44\u7E54\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"title":"Cephable\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u307E\u3057\u305F","titlePlural":"Cephable\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u307E\u3057\u305F","banner":"Cephable\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u305F\u305F\u3081\u3001\u7121\u6599\u306ECephable Basic\u306B\u30C0\u30A6\u30F3\u30B0\u30EC\u30FC\u30C9\u3055\u308C\u307E\u3057\u305F\u3002\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u66F4\u65B0\u3059\u308B\u3068\u3001\u5F37\u5316\u3055\u308C\u305F\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3001AI\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\u3001\u591A\u6570\u306E\u30D7\u30EA\u30D3\u30EB\u30C9\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306A\u3069\u306E\u6A5F\u80FD\u3092\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u3059\u3002"},"upgrade":{"existing":{"title":"\u3042\u306A\u305F\u306F\u65E2\u5B58\u306E\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u4E00\u90E8\u3067\u3059\u3002","description":"\u30B5\u30A4\u30C9\u30E1\u30CB\u30E5\u30FC\u306E `{{action}}` \u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002"}},"restrictions":{"isGenAIDisabled":{"title":"\u751F\u6210AI\u304C\u7121\u52B9","description":"\u7D44\u7E54\u3067\u306FGenerative AI\u6A5F\u80FD\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u304C\u7121\u52B9\u306B\u306A\u3063\u3066\u3044\u307E\u3059\u3002\u8A73\u7D30\u306B\u3064\u3044\u3066\u306F\u3001\u7D44\u7E54\u306E\u7BA1\u7406\u8005\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002"},"isRemoteControlDisabled":{"title":"\u30AF\u30ED\u30B9\u30C7\u30D0\u30A4\u30B9\u540C\u671F\u304C\u7121\u52B9","description":"\u7D44\u7E54\u306B\u3088\u3063\u3066\u540C\u671F\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u304C\u7121\u52B9\u306B\u306A\u3063\u3066\u3044\u308B\u305F\u3081\u3001\u30B3\u30F3\u30D1\u30CB\u30AA\u30F3\u30A2\u30D7\u30EA\u306E\u4F7F\u7528\u3084\u5916\u90E8\u30C7\u30D0\u30A4\u30B9\u306E\u64CD\u4F5C\u306F\u3067\u304D\u307E\u305B\u3093\u3002\u8A73\u3057\u304F\u306F\u3001\u7D44\u7E54\u306E\u7BA1\u7406\u8005\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002"}},"troubleshooting":{"title":"\u30C8\u30E9\u30D6\u30EB\u30B7\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0","editorDescription":"[\u30AA\u30D7\u30B7\u30E7\u30F3] \u3053\u308C\u306F\u3001Cephable \u30E2\u30D0\u30A4\u30EB \u30A2\u30D7\u30EA\u3068\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7 \u30A2\u30D7\u30EA\u306E\u4E21\u65B9\u306E\u63A5\u7D9A\u8A73\u7D30\u30DA\u30FC\u30B8\u3092\u901A\u3058\u3066\u3059\u3079\u3066\u306E\u30E6\u30FC\u30B6\u30FC\u306B\u8868\u793A\u3055\u308C\u308B\u30BB\u30AF\u30B7\u30E7\u30F3\u3067\u3059\u3002","description":"Cephable \u3067\u554F\u984C\u304C\u767A\u751F\u3057\u3066\u3044\u308B\u5834\u5408\u306F\u3001\u4EE5\u4E0B\u306E\u624B\u9806\u3092\u8A66\u3057\u3066\u4E00\u822C\u7684\u306A\u554F\u984C\u3092\u89E3\u6C7A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"onboarding":{"title":"\u30AA\u30F3\u30DC\u30FC\u30C7\u30A3\u30F3\u30B0","editorDescription":"[\u30AA\u30D7\u30B7\u30E7\u30F3] \u3053\u306E\u30C7\u30D0\u30A4\u30B9\u30BF\u30A4\u30D7\u304C\u30E6\u30FC\u30B6\u30FC\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u8FFD\u52A0\u3055\u308C\u308B\u3068\u3001\u30AA\u30F3\u30DC\u30FC\u30C7\u30A3\u30F3\u30B0\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002\u3053\u306E\u6B04\u306F\u3001\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3067\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u30BF\u30A4\u30D7\u3092\u8A2D\u5B9A\u3057\u3066\u4F7F\u7528\u3059\u308B\u65B9\u6CD5\u306B\u3064\u3044\u3066\u306E\u8AAC\u660E\u3092\u63D0\u4F9B\u3059\u308B\u306E\u306B\u6700\u9069\u3067\u3059\u3002"},"documents":"\u6587\u66F8","completionStatus":{"title":"\u5B8C\u4E86\u30B9\u30C6\u30FC\u30BF\u30B9","error":"","complete":"\u5B8C\u4E86\u3002","incomplete":"\u4E0D\u5B8C\u5168\u3002"},"metadata":{"title":"\u30E1\u30BF\u30C7\u30FC\u30BF","urlError":"URL \u306F http:// \u307E\u305F\u306F https:// \u3067\u59CB\u307E\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059","metatitle":{"label":"\u30E1\u30BF\u30BF\u30A4\u30C8\u30EB","placeholder":"\u77ED\u3044\u30BF\u30A4\u30C8\u30EB\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"},"shortDescription":{"label":"\u7C21\u5358\u306A\u8AAC\u660E","placeholder":"\u7C21\u5358\u306A\u30D7\u30EC\u30D3\u30E5\u30FC\u306E\u8AAC\u660E\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\uFF08\u6700\u5927 150 \u6587\u5B57\uFF09"},"externalLink":{"label":"\u5916\u90E8\u30EA\u30F3\u30AFURL","placeholder":"https://example.com/\u30C7\u30D0\u30A4\u30B9\u60C5\u5831","description":"\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u306E\u521D\u56DE\u8A2D\u5B9A\u306B\u95A2\u3059\u308B\u8A73\u7D30\u60C5\u5831\u3092\u63D0\u4F9B\u3059\u308B\u5916\u90E8\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u307E\u305F\u306F\u30EA\u30BD\u30FC\u30B9\u3078\u306E\u76F4\u63A5\u30EA\u30F3\u30AF\u3067\u3059\u3002\u3053\u308C\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u30EA\u30B9\u30C8\u306E\u30DE\u30FC\u30AF\u30C0\u30A6\u30F3\u306F\u4F7F\u7528\u3055\u308C\u307E\u305B\u3093\u3002"},"iconUrl":{"label":"\u30C7\u30D0\u30A4\u30B9\u30A2\u30A4\u30B3\u30F3URL","placeholder":"https://example.com/\u30C7\u30D0\u30A4\u30B9\u30A2\u30A4\u30B3\u30F3.png","description":"\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u30BF\u30A4\u30D7\u3092\u8868\u3059\u753B\u50CF\u3078\u306E\u76F4\u63A5\u30EA\u30F3\u30AF\u3002\u3053\u306E\u30A2\u30A4\u30B3\u30F3\u306FCephable\u30A2\u30D7\u30EA\u3068\u30C7\u30D0\u30A4\u30B9\u30EA\u30B9\u30C8\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002"},"darkModeIconUrl":{"label":"\u30C0\u30FC\u30AF\u30E2\u30FC\u30C9\u30C7\u30D0\u30A4\u30B9\u30A2\u30A4\u30B3\u30F3URL","placeholder":"https://example.com/device-icon-dark.png","description":"\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u30BF\u30A4\u30D7\u3092\u30C0\u30FC\u30AF\u30E2\u30FC\u30C9\u3067\u8868\u793A\u3059\u308B\u753B\u50CF\u3078\u306E\u76F4\u63A5\u30EA\u30F3\u30AF\u3067\u3059\u3002\u3053\u306E\u30A2\u30A4\u30B3\u30F3\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u30C0\u30FC\u30AF\u30E2\u30FC\u30C9\u3092\u6709\u52B9\u306B\u3057\u3066\u3044\u308B\u5834\u5408\u3001Cephable\u30A2\u30D7\u30EA\u3068\u30C7\u30D0\u30A4\u30B9\u30EA\u30B9\u30C8\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002"},"editorDescription":"\u304A\u4F7F\u3044\u306E\u30C7\u30D0\u30A4\u30B9\u304C Cephable \u30A2\u30D7\u30EA\u3067\u62E1\u5F35\u6A5F\u80FD\u307E\u305F\u306F\u63A5\u7D9A\u3068\u3057\u3066\u8868\u793A\u3055\u308C\u308B\u3088\u3046\u306B\u9078\u629E\u3055\u308C\u305F\u5834\u5408\u3001\u3053\u306E\u60C5\u5831\u306F\u65B0\u3057\u3044\u63A5\u7D9A\u3092\u8A2D\u5B9A\u3059\u308B\u30E6\u30FC\u30B6\u30FC\u306B\u8868\u793A\u3059\u308B\u305F\u3081\u306B\u4F7F\u7528\u3055\u308C\u307E\u3059\u3002"},"client-listing":{"title":"\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u30EA\u30B9\u30C8","editorDescription":"\u65B0\u898F\u30E6\u30FC\u30B6\u30FC\u304C\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u30BF\u30A4\u30D7\u3067\u65B0\u3057\u3044\u63A5\u7D9A\u3092\u8A2D\u5B9A\u3059\u308B\u305F\u3081\u306E\u8A73\u7D30\u306A\u624B\u9806\u3002\u3053\u306E\u30DE\u30FC\u30AF\u30C0\u30A6\u30F3\u30B3\u30F3\u30C6\u30F3\u30C4\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u65B0\u3057\u3044\u63A5\u7D9A\u3092\u8FFD\u52A0\u3059\u308B\u3068\u304D\u306BCephable\u30A2\u30D7\u30EA\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002"},"canAccessOrganizationProfiles":{"title":"\u7D44\u7E54\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8868\u793A","description":"\u3053\u306E\u6A29\u9650\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u3053\u306E\u7D44\u7E54\u306B\u95A2\u9023\u4ED8\u3051\u3089\u308C\u3066\u3044\u308B\u7D44\u7E54\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8868\u793A\u3067\u304D\u307E\u3059\u3002"},"canEditOrganizationProfiles":{"title":"\u7D44\u7E54\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u7BA1\u7406\u3059\u308B","description":"\u3053\u306E\u6A29\u9650\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u3053\u306E\u7D44\u7E54\u306B\u95A2\u9023\u4ED8\u3051\u3089\u308C\u305F\u7D44\u7E54\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F5C\u6210\u3001\u7DE8\u96C6\u3001\u524A\u9664\u3067\u304D\u307E\u3059\u3002"},"profiles":{"title":"\u7D44\u7E54\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","description":"\u7D44\u7E54\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3001\u7D44\u7E54\u5168\u4F53\u306B\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u914D\u5E03\u3057\u305F\u308A\u3001\u7D71\u5408\u30E6\u30FC\u30B6\u30FC\u3068\u5171\u6709\u3057\u305F\u308A\u3059\u308B\u305F\u3081\u306E\u5171\u6709\u30D7\u30ED\u30D5\u30A1\u30A4\u30EB\u3067\u3059\u3002","view":"\u7D44\u7E54\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8868\u793A","editDescription":"\u7D44\u7E54\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u7DE8\u96C6\u3057\u3066\u8A2D\u5B9A\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u307E\u3059\u3002","empty":"\u7D44\u7E54\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002\u958B\u59CB\u3059\u308B\u306B\u306F\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002","error":"\u7D44\u7E54\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","titleShort":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB"},"canViewAuthClients":{"title":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u898B\u308B","description":"\u3053\u306E\u6A29\u9650\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u7D44\u7E54\u306E\u8A8D\u8A3C\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u3068\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u95B2\u89A7\u3067\u304D\u307E\u3059\u3002"}},"developer":{"title":"\u958B\u767A\u8005","titleLong":"\u958B\u767A\u8005\u30EA\u30BD\u30FC\u30B9","description":"Cephable \u306F\u3001\u5F53\u793E\u306E SDK \u3092\u4F7F\u7528\u3057\u3066\u30A2\u30D7\u30EA\u3001\u30B2\u30FC\u30E0\u3001\u307E\u305F\u306F\u30B5\u30FC\u30D3\u30B9\u306B\u76F4\u63A5\u7D71\u5408\u3067\u304D\u307E\u3059\u3002","sdk":{"title":"SDK \u3092\u8A73\u3057\u304F\u898B\u308B","description":"\u5F53\u793E\u306F\u3001\u97F3\u58F0\u8A8D\u8B58\u3068\u9069\u5FDC\u578B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306B\u30B7\u30FC\u30E0\u30EC\u30B9\u306B\u7D71\u5408\u3059\u308B\u3088\u3046\u306B\u8A2D\u8A08\u3055\u308C\u305F\u4E00\u6D41\u306E SDK \u3092\u63D0\u4F9B\u3057\u3066\u3044\u307E\u3059\u3002\u5F53\u793E\u306E\u30C4\u30FC\u30EB\u306F\u3001\u76F4\u611F\u7684\u306A\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u901A\u3058\u3066\u30E6\u30FC\u30B6\u30FC \u30A4\u30F3\u30BF\u30E9\u30AF\u30B7\u30E7\u30F3\u3092\u5F37\u5316\u3057\u3001\u30A2\u30AF\u30BB\u30B7\u30D3\u30EA\u30C6\u30A3\u3092\u4FC3\u9032\u3059\u308B\u3088\u3046\u306B\u4F5C\u6210\u3055\u308C\u3066\u304A\u308A\u3001\u3059\u3079\u3066\u306E\u30E6\u30FC\u30B6\u30FC\u304C\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3092\u3088\u308A\u52B9\u7387\u7684\u306B\u64CD\u4F5C\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002","javascript":{"title":"JavaScript","subtitle":"\u30A6\u30A7\u30D6","description":"\u97F3\u58F0\u304A\u3088\u3073\u9069\u5FDC\u578B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092 Web \u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306B\u76F4\u63A5\u7D71\u5408\u3057\u307E\u3059\u3002","action":"NPM \u30D1\u30C3\u30B1\u30FC\u30B8\u3092\u5165\u624B"},"net":{"title":"\u3002\u30CD\u30C3\u30C8","subtitle":"Windows \u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3","description":".NET \u306E\u30D1\u30EF\u30FC\u3092\u6D3B\u7528\u3057\u3066\u3001WPF \u304A\u3088\u3073 WinUI3 SDK \u3092\u4F7F\u7528\u3057\u3066\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002","actionCore":"\u30B3\u30A2\u30D1\u30C3\u30B1\u30FC\u30B8\u3092\u5165\u624B","actionWpf":"WPF \u30D1\u30C3\u30B1\u30FC\u30B8\u3092\u5165\u624B"},"android":{"title":"\u30A2\u30F3\u30C9\u30ED\u30A4\u30C9","subtitle":"\u30E2\u30D0\u30A4\u30EB\u30C7\u30D0\u30A4\u30B9","description":"\u97F3\u58F0\u3068\u982D\u306E\u52D5\u304D\u306E\u6A5F\u80FD\u3092\u5BB9\u6613\u306B\u3059\u308B\u305F\u3081\u306B\u8A2D\u8A08\u3055\u308C\u305F Android \u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3002","action":"Android SDK\u3092\u5165\u624B"},"more":{"title":"\u3082\u3063\u3068","description":"\u5FC5\u8981\u306A\u3082\u306E\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u304B? \u3054\u9023\u7D61\u3044\u305F\u3060\u3051\u308C\u3070\u304A\u624B\u4F1D\u3044\u3044\u305F\u3057\u307E\u3059\u3002","action":"SDK\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3059\u308B"}},"demo":{"title":"\u30C7\u30E2","samples":"\u30C7\u30E2\u3068\u30B5\u30F3\u30D7\u30EB","titleLong":"\u5F53\u793E\u306ESDK\u3092\u5B9F\u969B\u306B\u4F53\u9A13\u3057\u3066\u304F\u3060\u3055\u3044","description":"\u30B5\u30F3\u30D7\u30EB \u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u901A\u3058\u3066\u3001\u97F3\u58F0\u304A\u3088\u3073\u30D8\u30C3\u30C9 \u30E2\u30FC\u30B7\u30E7\u30F3 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB \u30C6\u30AF\u30CE\u30ED\u30B8\u30FC\u306E\u5A01\u529B\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002\u30A4\u30F3\u30BF\u30E9\u30AF\u30C6\u30A3\u30D6 \u30B2\u30FC\u30E0\u304B\u3089\u52D5\u7684\u306A Web \u30A2\u30D7\u30EA\u3084\u30E2\u30D0\u30A4\u30EB \u30A2\u30D7\u30EA\u307E\u3067\u3001\u305D\u308C\u305E\u308C\u306E\u4F8B\u3067 SDK \u306E\u6C4E\u7528\u6027\u3068\u6709\u52B9\u6027\u304C\u5B9F\u8A3C\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u3053\u308C\u3089\u306E\u4F8B\u3092\u8ABF\u3079\u3066\u3001\u5F37\u5316\u3055\u308C\u305F\u30A2\u30AF\u30BB\u30B7\u30D3\u30EA\u30C6\u30A3\u3068\u6CA1\u5165\u578B\u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u72EC\u81EA\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u7D71\u5408\u3059\u308B\u305F\u3081\u306E\u6D1E\u5BDF\u3068\u30A4\u30F3\u30B9\u30D4\u30EC\u30FC\u30B7\u30E7\u30F3\u3092\u5F97\u3066\u304F\u3060\u3055\u3044\u3002","game":{"title":"2048 \u30B2\u30FC\u30E0","subtitle":"\u30A6\u30A7\u30D6","description":"\u30A2\u30C0\u30D7\u30C6\u30A3\u30D6\u97F3\u58F0\u3068\u30D8\u30C3\u30C9\u30E2\u30FC\u30B7\u30E7\u30F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u5F93\u6765\u306E\u30B2\u30FC\u30E0\u30D7\u30EC\u30A4\u3092\u5411\u4E0A\u3055\u305B\u307E\u3059\u3002","action":"\u30B2\u30FC\u30E0\u3092\u30D7\u30EC\u30A4\u3059\u308B"},"other":{"title":"\u305D\u306E\u4ED6\u306E\u30C7\u30E2","description":"Cephable \u304C\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3001\u30B2\u30FC\u30E0\u3001\u30C7\u30D0\u30A4\u30B9\u3092\u3069\u306E\u3088\u3046\u306B\u5F37\u5316\u3067\u304D\u308B\u304B\u3092\u76F4\u63A5\u4F53\u9A13\u3057\u3066\u304F\u3060\u3055\u3044\u3002","action":"\u305D\u306E\u4ED6\u306E\u30C7\u30E2\u3092\u898B\u308B"},"web":{"title":"Web SDK \u30B5\u30F3\u30D7\u30EB","subtitle":"\u30A6\u30A7\u30D6","description":"\u3059\u3079\u3066\u306E\u30B3\u30A2\u6A5F\u80FD\u3092 Web \u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306B\u7C21\u5358\u306B\u7D71\u5408\u3057\u307E\u3059\u3002","action":"SDK\u3092\u4F53\u9A13\u3059\u308B"},"unity":{"title":"\u56E3\u7D50","subtitle":"\u30B2\u30FC\u30E0\u958B\u767A","description":"\u30A2\u30C0\u30D7\u30C6\u30A3\u30D6 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30B2\u30FC\u30E0\u3067\u6D3B\u7528\u3057\u3066\u3001\u3088\u308A\u9B45\u529B\u7684\u306A UX \u3092\u63D0\u4F9B\u3059\u308B\u65B9\u6CD5\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002","action":"\u30B5\u30F3\u30D7\u30EB\u3092\u5165\u624B"}},"other":{"title":"\u305D\u306E\u4ED6\u306E\u30EA\u30BD\u30FC\u30B9","description":"\u5F0A\u793E\u306E SDK \u3067\u5FC5\u8981\u306A\u3082\u306E\u304C\u898B\u3064\u304B\u3089\u306A\u3044\u5834\u5408\u306F\u3001API \u3092\u76F4\u63A5\u64CD\u4F5C\u3059\u308B\u304B\u3001\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u306B\u9023\u7D61\u3057\u3066\u30D8\u30EB\u30D7\u3001\u30A4\u30F3\u30B9\u30D4\u30EC\u30FC\u30B7\u30E7\u30F3\u3001\u30B5\u30DD\u30FC\u30C8\u3092\u6C42\u3081\u3066\u304F\u3060\u3055\u3044\u3002","api":{"title":"API","description":"\u5F53\u793E\u306E API \u3092\u4F7F\u7528\u3059\u308B\u3068\u3001Cephable \u3068\u76F4\u63A5\u3084\u308A\u53D6\u308A\u3067\u304D\u307E\u3059\u3002\u5F53\u793E\u306E API \u3092\u4F7F\u7528\u3057\u3066\u30AB\u30B9\u30BF\u30E0\u7D71\u5408\u3092\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002"},"support":{"title":"\u30B5\u30DD\u30FC\u30C8","description":"\u5FC5\u8981\u306A\u3082\u306E\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u304B? Discord \u7D4C\u7531\u3067\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u306B\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002","action":"Discord\u306B\u53C2\u52A0\u3059\u308B"}}},"customControls":{"title":"\u30B0\u30ED\u30FC\u30D0\u30EB\u304A\u3088\u3073\u30C7\u30D0\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","prefixDisclaimer":"\u3053\u308C\u306F\u30D7\u30EC\u30D5\u30A3\u30C3\u30AF\u30B9\u5236\u5FA1\u3067\u3059\u3002\u30B3\u30DE\u30F3\u30C9\u306E\u5F8C\u306E\u5358\u8A9E\u3092\u30EA\u30C3\u30B9\u30F3\u3057\u3001\u6B21\u306E\u30D5\u30EC\u30FC\u30BA\u3092\u691C\u7D22\u3057\u3066\u4E00\u81F4\u3059\u308B\u3082\u306E\u3092\u898B\u3064\u3051\u307E\u3059\u3002","allowPausedDisclaimer":"\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3001\u30DE\u30A4\u30AF\u304C\u4E00\u6642\u505C\u6B62\u3055\u308C\u3066\u3044\u308B\u5834\u5408\u3067\u3082\u6A5F\u80FD\u3057\u307E\u3059\u3002","resetControls":{"title":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30EA\u30BB\u30C3\u30C8","description":"\u6700\u5F8C\u306B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u66F4\u65B0\u3057\u3066\u304B\u3089\u97F3\u58F0\u8A00\u8A9E\u304C\u5909\u66F4\u3055\u308C\u307E\u3057\u305F\u3002\u6CE8: \u3053\u308C\u306B\u3088\u308A\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C {{language}} \u306B\u4E00\u81F4\u3059\u308B\u3088\u3046\u306B\u30EA\u30BB\u30C3\u30C8\u3055\u308C\u3001\u30AB\u30B9\u30BF\u30E0 \u30B3\u30DE\u30F3\u30C9\u304C\u5931\u308F\u308C\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u30EA\u30BB\u30C3\u30C8\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B?","confirm":"\u306F\u3044\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30EA\u30BB\u30C3\u30C8\u3057\u307E\u3059","error":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u30EA\u30BB\u30C3\u30C8\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002"},"conflictIndicators":{"warn":"\u8B66\u544A\uFF1A ","title":"\u5165\u529B\u69CB\u6210\u306E\u7AF6\u5408\u304C\u691C\u51FA\u3055\u308C\u307E\u3057\u305F","globalControls":"\u30B0\u30ED\u30FC\u30D0\u30EB\u5236\u5FA1\u69CB\u6210\u306E\u7AF6\u5408","deviceControls":"\u30C7\u30D0\u30A4\u30B9\u5236\u5FA1\u69CB\u6210\u306E\u7AF6\u5408","usedInput":"\u5165\u529B\u3068\u3057\u3066\u4F7F\u7528\u3055\u308C\u308B","description":"\u4F7F\u7528\u3057\u3066\u3044\u308B\u30B0\u30ED\u30FC\u30D0\u30EB \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30C7\u30D0\u30A4\u30B9 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u5165\u529B\u306E\u4E00\u90E8\u306F\u30011 \u3064\u4EE5\u4E0A\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u3082\u4F7F\u7528\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001Cephable \u306E\u4F7F\u7528\u6642\u306B\u7AF6\u5408\u304C\u767A\u751F\u3059\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u306E\u3088\u3046\u306A\u72B6\u6CC1\u304C\u767A\u751F\u3057\u305F\u5834\u5408\u3001\u30B0\u30ED\u30FC\u30D0\u30EB \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3084\u30C7\u30D0\u30A4\u30B9 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3088\u308A\u3082\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u5E38\u306B\u512A\u5148\u3055\u308C\u307E\u3059\u3002","item":"\u5165\u529B<strong>{{value}}</strong>\u306F\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u4F7F\u7528\u3055\u308C\u307E\u3059: ","globalDescription":"\u6B21\u306E\u30B0\u30ED\u30FC\u30D0\u30EB \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u306F\u3001\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u7AF6\u5408\u3059\u308B\u5165\u529B\u304C\u3042\u308A\u307E\u3059\u3002","deviceDescription":"\u6B21\u306E\u30C7\u30D0\u30A4\u30B9 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u306F\u3001\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u7AF6\u5408\u3059\u308B\u5165\u529B\u304C\u3042\u308A\u307E\u3059\u3002"},"globalControls":{"title":"\u30B0\u30ED\u30FC\u30D0\u30EB\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","empty":"\u30B0\u30ED\u30FC\u30D0\u30EB \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u307E\u3060\u3042\u308A\u307E\u305B\u3093\u3002\u4EE5\u4E0B\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002","edit":"\u30B0\u30ED\u30FC\u30D0\u30EB\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u7DE8\u96C6","description":"\u30B0\u30ED\u30FC\u30D0\u30EB \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3001\u4F7F\u7528\u3057\u3066\u3044\u308B\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3084\u30C7\u30D0\u30A4\u30B9\u306B\u95A2\u4FC2\u306A\u304F\u3001\u5E38\u306B\u5229\u7528\u3067\u304D\u308B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u3059\u3002\u30DE\u30A4\u30AF\u3084\u30AB\u30E1\u30E9\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u4E00\u6642\u505C\u6B62\u3055\u308C\u3066\u3044\u308B\u3068\u304D\u3067\u3082\u6A5F\u80FD\u3059\u308B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3082\u3042\u308A\u307E\u3059\u3002"},"deviceControls":{"title":"\u30C7\u30D0\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","empty":"\u30C7\u30D0\u30A4\u30B9 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u307E\u3060\u3042\u308A\u307E\u305B\u3093\u3002\u4EE5\u4E0B\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002","edit":"\u30C7\u30D0\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u7DE8\u96C6\u3059\u308B","controls":{"cephable-open-app":{"success":"\u30A2\u30D7\u30EA\u3092\u958B\u304F: {{value}}","error":"\u30A2\u30D7\u30EA\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093: {{value}}"},"cephable-close-app":{"commands":["\u8FD1\u3044"],"name":"\u540D\u524D\u3067\u30A2\u30D7\u30EA\u3092\u9589\u3058\u308B","description":"\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u3068\u3082\u306B\u4F7F\u7528\u3057\u3066\u3001\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u4E0A\u306E\u30A2\u30D7\u30EA\u3092\u540D\u524D\u3067\u9589\u3058\u307E\u3059\u3002","success":"\u30A2\u30D7\u30EA\u3092\u9589\u3058\u308B: {{value}}","error":"\u30A2\u30D7\u30EA\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093: {{value}}"},"cephable-minimize-focused-app":{"commands":["\u6700\u5C0F\u5316"],"name":"\u73FE\u5728\u30D5\u30A9\u30FC\u30AB\u30B9\u3055\u308C\u3066\u3044\u308B\u30A2\u30D7\u30EA\u3092\u6700\u5C0F\u5316\u3057\u307E\u3059\u3002","description":"\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u3068\u3082\u306B\u4F7F\u7528\u3059\u308B\u3068\u3001\u73FE\u5728\u30D5\u30A9\u30FC\u30AB\u30B9\u3055\u308C\u3066\u3044\u308B\u30A2\u30D7\u30EA\u304C\u6700\u5C0F\u5316\u3055\u308C\u307E\u3059\u3002","success":"\u96C6\u4E2D\u3057\u305F\u30A2\u30D7\u30EA\u306E\u6210\u529F\u3092\u6700\u5C0F\u9650\u306B\u6291\u3048\u307E\u3059\u3002","error":"\u30D5\u30A9\u30FC\u30AB\u30B9\u3055\u308C\u305F\u30A2\u30D7\u30EA\u3092\u6700\u5C0F\u5316\u3059\u308B\u3068\u304D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002"},"cephable-maximize-focused-app":{"commands":["\u6700\u5927\u5316\u3059\u308B"],"name":"\u73FE\u5728\u30D5\u30A9\u30FC\u30AB\u30B9\u3055\u308C\u3066\u3044\u308B\u30A2\u30D7\u30EA\u3092\u6700\u5927\u5316\u3057\u307E\u3059\u3002","description":"\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u3068\u3082\u306B\u4F7F\u7528\u3059\u308B\u3068\u3001\u73FE\u5728\u30D5\u30A9\u30FC\u30AB\u30B9\u3055\u308C\u3066\u3044\u308B\u30A2\u30D7\u30EA\u304C\u6700\u5927\u5316\u3055\u308C\u307E\u3059\u3002","success":"\u96C6\u4E2D\u7684\u306A\u30A2\u30D7\u30EA\u306E\u6210\u529F\u3092\u6700\u5927\u5316\u3057\u307E\u3057\u3087\u3046!","error":"\u30D5\u30A9\u30FC\u30AB\u30B9\u3055\u308C\u305F\u30A2\u30D7\u30EA\u3092\u6700\u5C0F\u5316\u3059\u308B\u3068\u304D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002"},"cephable-generate-text":{"commands":["\u751F\u6210\u3059\u308B"],"name":"\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u306E\u5F8C\u306B\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u6307\u5B9A\u3057\u3066\u30C6\u30AD\u30B9\u30C8\u3092\u751F\u6210\u3057\u307E\u3059\u3002","description":"\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u3068\u3082\u306B\u4F7F\u7528\u3057\u3001\u305D\u306E\u5F8C\u306B\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u5165\u529B\u3057\u3066\u3001\u95A2\u9023\u3059\u308B\u30C6\u30AD\u30B9\u30C8\u3092\u751F\u6210\u3057\u307E\u3059\u3002"},"cephable-stop-generate-text":{"commands":["\u751F\u6210\u3092\u505C\u6B62","\u751F\u6210\u3092\u505C\u6B62\u3059\u308B","\u30AD\u30E3\u30F3\u30BB\u30EB\u751F\u6210","\u751F\u6210\u3092\u30AD\u30E3\u30F3\u30BB\u30EB"],"name":"\u30C6\u30AD\u30B9\u30C8\u306E\u751F\u6210\u3092\u505C\u6B62\u3057\u307E\u3059\u3002","description":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u30C6\u30AD\u30B9\u30C8\u306E\u751F\u6210\u304C\u505C\u6B62\u3057\u307E\u3059"},"cephable-open-panel":{"commands":["\u30D1\u30CD\u30EB\u3092\u8868\u793A"],"name":"Cephable\u30D1\u30CD\u30EB\u3092\u958B\u304F","description":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3057\u3066\u3001Cephable \u30D1\u30CD\u30EB\u3092\u958B\u304D\u307E\u3059\u3002"},"cephable-close-panel":{"commands":["\u30D1\u30CD\u30EB\u3092\u975E\u8868\u793A"],"name":"Cephable\u30D1\u30CD\u30EB\u3092\u975E\u8868\u793A\u306B\u3059\u308B","description":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001Cephable \u30D1\u30CD\u30EB\u3092\u975E\u8868\u793A\u306B\u3057\u305F\u308A\u6700\u5C0F\u5316\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002"},"cephable-close-focused-app":{"commands":["\u8FD1\u3044\u6D41\u308C"],"name":"\u73FE\u5728\u30D5\u30A9\u30FC\u30AB\u30B9\u3055\u308C\u3066\u3044\u308B\u30A2\u30D7\u30EA\u3092\u9589\u3058\u307E\u3059\u3002","description":"\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u4F7F\u7528\u3057\u3066\u3001\u73FE\u5728\u30D5\u30A9\u30FC\u30AB\u30B9\u3055\u308C\u3066\u3044\u308B\u30A2\u30D7\u30EA\u3092\u9589\u3058\u307E\u3059\u3002","success":"\u73FE\u5728\u306E\u30A2\u30D7\u30EA\u3092\u6B63\u5E38\u306B\u9589\u3058\u307E\u3057\u305F!","error":"\u73FE\u5728\u306E\u30A2\u30D7\u30EA\u3092\u9589\u3058\u308B\u3068\u304D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002"},"cephable-rewrite-text":{"commands":["\u30EA\u30E9\u30A4\u30C8"],"name":"\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u306E\u5F8C\u306B\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u6307\u5B9A\u3057\u3066\u30C6\u30AD\u30B9\u30C8\u3092\u66F8\u304D\u63DB\u3048\u307E\u3059\u3002","description":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u7D9A\u3044\u3066\u30D7\u30ED\u30F3\u30D7\u30C8\u3067\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u73FE\u5728\u5F37\u8ABF\u8868\u793A\u3055\u308C\u3066\u3044\u308B\u30C6\u30AD\u30B9\u30C8\u304C\u66F8\u304D\u63DB\u3048\u3089\u308C\u307E\u3059\u3002"},"cephable-summarize-text":{"commands":["\u8981\u7D04\u3059\u308B"],"name":"\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u306E\u5F8C\u306B\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u6307\u5B9A\u3057\u3066\u30C6\u30AD\u30B9\u30C8\u3092\u8981\u7D04\u3057\u307E\u3059\u3002","description":"\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u3068\u3082\u306B\u4F7F\u7528\u3057\u3001\u305D\u306E\u5F8C\u306B\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u5165\u529B\u3057\u3066\u3001\u73FE\u5728\u5F37\u8ABF\u8868\u793A\u3055\u308C\u3066\u3044\u308B\u30C6\u30AD\u30B9\u30C8\u3092\u8981\u7D04\u3057\u307E\u3059\u3002"},"cephable-translate-text":{"commands":["\u7FFB\u8A33\u3059\u308B"],"name":"\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u306E\u5F8C\u306B\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u5165\u529B\u3057\u3066\u30C6\u30AD\u30B9\u30C8\u3092\u7FFB\u8A33\u3057\u307E\u3059\u3002","description":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u7D9A\u3044\u3066\u30D7\u30ED\u30F3\u30D7\u30C8\u3067\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u73FE\u5728\u5F37\u8ABF\u8868\u793A\u3055\u308C\u3066\u3044\u308B\u30C6\u30AD\u30B9\u30C8\u304C\u7FFB\u8A33\u3055\u308C\u307E\u3059\u3002"},"cephable-click-by-name":{"commands":["\u30BF\u30C3\u30D7","\u6253\u3064","\u79FB\u52D5","\u884C\u304F"],"name":"\u540D\u524D\u3067\u8981\u7D20\u3092\u30BF\u30C3\u30D7","description":"\u30DA\u30FC\u30B8\u4E0A\u306E\u4F55\u304B\u306E\u540D\u524D\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059\u3002\u305F\u3068\u3048\u3070\u3001\u300C\u4FDD\u5B58\u3092\u30BF\u30C3\u30D7\u300D\u3059\u308B\u3068\u3001\u300C\u4FDD\u5B58\u300D\u3068\u3044\u3046\u30DC\u30BF\u30F3\u304C\u30AF\u30EA\u30C3\u30AF\u3055\u308C\u307E\u3059\u3002"}},"description":"\u30C7\u30D0\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3001\u4F7F\u7528\u3057\u3066\u3044\u308B\u7279\u5B9A\u306E\u30C7\u30D0\u30A4\u30B9\u307E\u305F\u306F\u63A5\u7D9A\u306B\u95A2\u9023\u4ED8\u3051\u3089\u308C\u3066\u3044\u307E\u3059\u3002\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u8FFD\u52A0\u3057\u306A\u304F\u3066\u3082\u5229\u7528\u3067\u304D\u3001\u7279\u5B9A\u306E\u30C7\u30D0\u30A4\u30B9\u3067\u306E\u307F\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u308B\u6A5F\u80FD\u3084\u30A4\u30D9\u30F3\u30C8\u306B\u7279\u306B\u5F79\u7ACB\u3061\u307E\u3059\u3002"},"warn":"\u30DE\u30A4\u30AF\u304C\u8D77\u52D5\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u30B0\u30ED\u30FC\u30D0\u30EB \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30C7\u30D0\u30A4\u30B9 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u306B\u306F\u3001\u30DE\u30A4\u30AF\u3092\u8D77\u52D5\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","changeProfile":{"success":"\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u5909\u66F4: {{value}}","error":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093: \'{{value}}\'"},"descriptionShort":"\u30B0\u30ED\u30FC\u30D0\u30EB\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30C7\u30D0\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3001\u3042\u3089\u3086\u308B\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3067\u52D5\u4F5C\u3059\u308B\u3088\u3046\u306B\u8A2D\u8A08\u3055\u308C\u305F\u3001\u3044\u3064\u3067\u3082\u5229\u7528\u53EF\u80FD\u306A\u30A2\u30AF\u30B7\u30E7\u30F3\u3067\u3059\u3002\u300C\u30AB\u30E1\u30E9\u3092\u505C\u6B62\u300D\u306A\u3069\u306E\u30B0\u30ED\u30FC\u30D0\u30EB\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u30B7\u30B9\u30C6\u30E0\u5168\u4F53\u306B\u9069\u7528\u3055\u308C\u3001\u30A2\u30D7\u30EA\u306B\u4F9D\u5B58\u3057\u307E\u305B\u3093\u3002\u4E00\u65B9\u3001\u30C7\u30D0\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u5404\u30C7\u30D0\u30A4\u30B9\u63A5\u7D9A\u306B\u5408\u308F\u305B\u3066\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3055\u308C\u3001\u6A19\u6E96\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3088\u308A\u3082\u9AD8\u5EA6\u306A\u6A5F\u80FD\u3092\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002","description":"\u30B0\u30ED\u30FC\u30D0\u30EB\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30C7\u30D0\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3001\u3042\u3089\u3086\u308B\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3067\u52D5\u4F5C\u3059\u308B\u3088\u3046\u306B\u8A2D\u8A08\u3055\u308C\u305F\u3001\u3044\u3064\u3067\u3082\u5229\u7528\u53EF\u80FD\u306A\u30A2\u30AF\u30B7\u30E7\u30F3\u3067\u3059\u3002\u300C\u30AB\u30E1\u30E9\u3092\u505C\u6B62\u300D\u306A\u3069\u306E\u30B0\u30ED\u30FC\u30D0\u30EB\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u30B7\u30B9\u30C6\u30E0\u5168\u4F53\u306B\u9069\u7528\u3055\u308C\u3001\u30A2\u30D7\u30EA\u306B\u4F9D\u5B58\u3057\u307E\u305B\u3093\u3002\u4E00\u65B9\u3001\u30C7\u30D0\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u5404\u30C7\u30D0\u30A4\u30B9\u306E\u63A5\u7D9A\u306B\u5408\u308F\u305B\u3066\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3055\u308C\u3001\u6A19\u6E96\u7684\u306A\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3088\u308A\u3082\u9AD8\u5EA6\u306A\u6A5F\u80FD\u3092\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002\u3053\u308C\u3089\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u73FE\u5728\u3001\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u3057\u3066\u30A2\u30AF\u30BB\u30B9\u3055\u308C\u3066\u3044\u307E\u3059\u304C\u3001\u5C06\u6765\u7684\u306B\u306F\u4ED6\u306E\u5165\u529B\u306B\u3082\u5BFE\u5FDC\u3059\u308B\u4E88\u5B9A\u3067\u3059\u3002","noDevice":"\u3053\u306E\u30B9\u30C6\u30C3\u30D7\u3067\u306F\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u306A\u3044\u30AB\u30B9\u30BF\u30E0\u62E1\u5F35\u6A5F\u80FD\u3092\u4F7F\u7528\u3057\u307E\u3059\u3002\u3053\u306E\u30B9\u30C6\u30C3\u30D7\u306E\u30ED\u30C3\u30AF\u3092\u89E3\u9664\u3059\u308B\u306B\u306F\u3001\u62E1\u5F35\u6A5F\u80FD\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"notifications":{"title":"\u901A\u77E5","center":"\u901A\u77E5\u30BB\u30F3\u30BF\u30FC","empty":"\u73FE\u6642\u70B9\u3067\u306F\u901A\u77E5\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002","seen":"\u898B\u305F","markAsRead":"\u65E2\u8AAD\u306B\u3059\u308B","view":"\u3059\u3079\u3066\u306E {{value}} \u4EF6\u306E\u901A\u77E5\u3092\u8868\u793A"},"unsaved":{"title":"\u4FDD\u5B58\u3055\u308C\u3066\u3044\u306A\u3044\u5909\u66F4\u304C\u3042\u308A\u307E\u3059\u3002","description":"\u5909\u66F4\u304C\u4FDD\u5B58\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u3053\u306E\u30DA\u30FC\u30B8\u3092\u96E2\u308C\u307E\u3059\u304B?","cancel":"\u4FDD\u5B58\u305B\u305A\u306B\u7D42\u4E86","confirm":"\u4FDD\u5B58\u3057\u3066\u7D42\u4E86"},"login":{"welcome":"Cephable \u3078\u3088\u3046\u3053\u305D!","subtitle":"<strong>\u3042\u306A\u305F\u306E</strong>\u6761\u4EF6\u306B\u5408\u308F\u305B\u3066\u30C6\u30AF\u30CE\u30ED\u30B8\u30FC\u3092\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3057\u307E\u3059\u3002","create":"\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u6210\u3059\u308B","signIn":"\u30B5\u30A4\u30F3\u30A4\u30F3","loading":"\u30B5\u30A4\u30F3\u30A4\u30F3\u306B\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8\u3057\u3066\u3044\u307E\u3059...","error":"\u30B5\u30A4\u30F3\u30A4\u30F3\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3082\u3046\u4E00\u5EA6\u30B5\u30A4\u30F3\u30A4\u30F3\u3057\u3066\u304F\u3060\u3055\u3044\u3002","existingAccount":"\u3059\u3067\u306B\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u304A\u6301\u3061\u3067\u3059\u304B?","description":"Cephable\u3067\u3001\u30D1\u30BD\u30B3\u30F3\u3001\u30A2\u30D7\u30EA\u3001\u30B2\u30FC\u30E0\u3092\u81EA\u5728\u306B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3002\u7D20\u65E9\u3044\u64CD\u4F5C\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3001\u8868\u60C5\u3001\u30B8\u30A7\u30B9\u30C1\u30E3\u30FC\u3001\u50BE\u304D\u306A\u3069\u3092\u81EA\u5728\u306B\u64CD\u308B\u30D1\u30FC\u30BD\u30CA\u30EBAI\u3002\u30AF\u30E9\u30A6\u30C9\u51E6\u7406\u306F\u4E00\u5207\u4E0D\u8981\u3002\u3042\u306A\u305F\u3068\u4E00\u7DD2\u306B\u52D5\u304D\u3001\u30B7\u30FC\u30E0\u30EC\u30B9\u306B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3057\u307E\u3059\u3002"},"home":{"title":"\u5BB6","startControls":"\u96FB\u6E90\u3092\u5165\u308C\u3066\u304F\u3060\u3055\u3044\uFF01","manage":"\u8A2D\u5B9A","profileGenerate":{"title":"\u304A\u3063\u3068\u3002\u307E\u3060\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u306A\u3044\u3088\u3046\u3067\u3059\u3002","description":"Cephable \u304C\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u3092\u5236\u5FA1\u3059\u308B\u306B\u306F\u3001\u4F55\u3092\u5236\u5FA1\u3057\u305F\u3044\u306E\u304B\u3092\u77E5\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u6700\u521D\u304B\u3089\u4F5C\u6210\u3059\u308B\u3053\u3068\u3082\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB \u30B8\u30A7\u30CD\u30EC\u30FC\u30BF\u30FC\u3092\u4F7F\u7528\u3057\u3066\u4F5C\u6210\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002"}},"wizard":{"description":"Cephable \u306F\u3053\u306E\u60C5\u5831\u3092\u4F7F\u7528\u3057\u3066\u3001\u78BA\u8A8D\u3057\u3066\u8A66\u3059\u305F\u3081\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u751F\u6210\u3057\u307E\u3059\u3002","includeDefaultKeysQuestion":"\u30AD\u30FC\u3068\u30DE\u30A6\u30B9\u306E\u30AF\u30EA\u30C3\u30AF\u306B\u5BFE\u3059\u308B\u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3092\u542B\u3081\u307E\u3059\u304B?","placeholderAppName":"Microsoft Word\u3001Minecraft\u3001YouTube\u3001\u30B3\u30FC\u30C9\u306A\u3069\u3002","noOptionsText":"\u5236\u5FA1\u3057\u305F\u3044\u30A2\u30D7\u30EA\u3092\u898B\u3064\u3051\u308B\u305F\u3081\u306B\u5165\u529B\u3092\u59CB\u3081\u307E\u3059","generate":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u751F\u6210\u3059\u308B","complete":{"title":"\u306F\u3044\u3001\u7D42\u308F\u308A\u307E\u3057\u305F\uFF01","description":"\u751F\u6210\u3055\u308C\u305F\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8868\u793A\u3059\u308B\u306B\u306F\u3001\u4E0B\u306E\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044\u3002 \u624B\u52D5\u3067\u7DE8\u96C6\u3001\u8FFD\u52A0\u3001\u307E\u305F\u306F\u524A\u9664\u3057\u3066\u3001\u81EA\u5206\u306B\u3068\u3063\u3066\u5B8C\u74A7\u306A\u3082\u306E\u306B\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","viewControls":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u898B\u308B"},"error":{"emptyInput":"\u5C11\u306A\u304F\u3068\u30821\u3064\u306E\u5165\u529B\u65B9\u6CD5\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044","emptyApp":"\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u306E\u30A2\u30D7\u30EA\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","generatingProfile":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u751F\u6210\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F"},"loading":{"title":"\u79C1\u305F\u3061\u306F\u3059\u3079\u3066\u306E\u30D4\u30FC\u30B9\u3092\u307E\u3068\u3081\u3066\u3044\u307E\u3059","description":"\u3053\u308C\u306B\u306F\u7D04 1 \u5206\u307B\u3069\u304B\u304B\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u306E\u30DA\u30FC\u30B8\u3092\u96E2\u308C\u305F\u308A\u623B\u3063\u305F\u308A\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002\u305D\u3046\u3057\u306A\u3044\u3068\u751F\u6210\u304C\u505C\u6B62\u3057\u307E\u3059\u3002"},"selectedTips":{"title":"\u30D2\u30F3\u30C8 #{{count}}","previous":"\u524D\u306E\u30D2\u30F3\u30C8","next":"\u6B21\u306E\u30D2\u30F3\u30C8","two":"\u30E1\u30A4\u30F3 \u30D1\u30CD\u30EB\u306E\u300C\u8868\u73FE\u5236\u5FA1\u8A2D\u5B9A\u300D\u30BB\u30AF\u30B7\u30E7\u30F3\u3067\u3001\u5165\u529B\u306E\u611F\u5EA6\u3092\u5236\u5FA1\u3067\u304D\u307E\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001Cephable \u304C\u7279\u5B9A\u306E\u5165\u529B\u3092\u89E3\u91C8\u3059\u308B\u65B9\u6CD5\u3092\u3055\u3089\u306B\u7D30\u304B\u304F\u8ABF\u6574\u3067\u304D\u307E\u3059\u3002\u307E\u305F\u3001Cephable \u306F\u30E6\u30FC\u30B6\u30FC\u3068\u9023\u643A\u3057\u3066\u6642\u9593\u306E\u7D4C\u904E\u3068\u3068\u3082\u306B\u6539\u5584\u3055\u308C\u307E\u3059\u3002","three":"\u3053\u308C\u3092\u8A2D\u5B9A\u3057\u305F\u5F8C\u3082\u3001\u69CB\u6210\u3092\u5B8C\u5168\u306B\u5236\u5FA1\u3067\u304D\u307E\u3059\u3002\u30D9\u30FC\u30B9\u30E9\u30A4\u30F3\u3092\u63D0\u4F9B\u3057\u307E\u3059\u304C\u3001\u3044\u3064\u3067\u3082\u3001\u81EA\u5206\u306E\u64CD\u4F5C\u3068\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u4E0A\u3067\u306E\u52D5\u4F5C\u306E\u30DE\u30C3\u30D4\u30F3\u30B0\u3092\u5909\u66F4\u3067\u304D\u307E\u3059\u3002","four":"Cephable \u3092\u4F7F\u7528\u3059\u308B\u3068\u304D\u306F\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u5370\u5237\u3057\u3066\u7269\u7406\u7684\u306A\u30B3\u30D4\u30FC\u3092\u7528\u610F\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u3053\u308C\u306F\u307E\u3063\u305F\u304F\u65B0\u3057\u3044\u3053\u3068\u306A\u306E\u3067\u3001\u6163\u308C\u308B\u307E\u3067\u306B\u5C11\u3057\u6642\u9593\u304C\u304B\u304B\u308B\u3053\u3068\u306F\u627F\u77E5\u3057\u3066\u3044\u307E\u3059\u3002\u7DF4\u7FD2\u3059\u308C\u3070\u4E0A\u9054\u3057\u307E\u3059!","one":"Cephable\u3092\u4F7F\u3063\u3066\u3001\u3042\u308B\u30C7\u30D0\u30A4\u30B9\u304B\u3089\u5225\u306E\u30C7\u30D0\u30A4\u30B9\u3092\u64CD\u4F5C\u3067\u304D\u308B\u3053\u3068\u3092\u3054\u5B58\u77E5\u3067\u3059\u304B\uFF1F\u30E2\u30D0\u30A4\u30EB\u3001\u30BF\u30D6\u30EC\u30C3\u30C8\u3001\u3042\u308B\u3044\u306F\u5225\u306E\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u306BCephable\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3001\u64CD\u4F5C\u3057\u305F\u3044\u63A5\u7D9A\uFF08\u3053\u306E\u63A5\u7D9A\u3082\u53EF\uFF09\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u500B\u4EBA\u8A2D\u5B9A\u3068\u5165\u529B\u30D7\u30ED\u30D5\u30A1\u30A4\u30EB\u306F\u3001\u3059\u3079\u3066\u306E\u30C7\u30D0\u30A4\u30B9\u3067\u5171\u901A\u3067\u3059\uFF01\u30C7\u30D0\u30A4\u30B9\u3068\u63A5\u7D9A\u3067Cephable\u304C\u52D5\u4F5C\u3057\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"steps":{"one":"\u30B9\u30C6\u30C3\u30D7 1. \u5236\u5FA1\u3059\u308B\u30A2\u30D7\u30EA\u306E\u540D\u524D\u3092\u5165\u529B\u3057\u307E\u3059\u3002","two":"\u30B9\u30C6\u30C3\u30D7 2. \u4F7F\u7528\u3059\u308B\u5165\u529B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u78BA\u8A8D\u3057\u307E\u3059\u3002","three":"\u30B9\u30C6\u30C3\u30D73.\uFF08\u30AA\u30D7\u30B7\u30E7\u30F3\uFF09","threeContinued":"\u3088\u304F\u4F7F\u7528\u3059\u308B\u30B3\u30DE\u30F3\u30C9\u3084\u7279\u306B\u597D\u3093\u3067\u4F7F\u7528\u3059\u308B\u30B3\u30DE\u30F3\u30C9\u306B\u8A2D\u5B9A\u3057\u305F\u3044\u7279\u5B9A\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u306B\u3064\u3044\u3066\u8AAC\u660E\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u4EE5\u4E0B\u306E\u3088\u3046\u306A\u308F\u304B\u308A\u3084\u3059\u3044\u82F1\u8A9E\u3092\u4F7F\u7528\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"title":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u751F\u6210\u3059\u308B","titleLong":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u751F\u6210\u3059\u308B","try":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u30B8\u30A7\u30CD\u30EC\u30FC\u30BF\u3092\u8A66\u3059","placeholder":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u306F\u77ED\u304F\u3057\u3066\u304F\u3060\u3055\u3044\u3002\\n\\n\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u306E\u6B21\u306E\u30B9\u30E9\u30A4\u30C9\u306B\u9032\u3080\u306B\u306F\u3001\u300C\u9032\u3080\u300D\u3068\u8A00\u3048\u3070\u3044\u3044\u3068\u601D\u3044\u307E\u3059\u3002\\n\\n\u30AB\u30FC\u30BD\u30EB\u306E\u79FB\u52D5\u306B\u306F\u982D\u306E\u52D5\u304D\u3092\u3001\u7DE8\u96C6\u306E\u30B7\u30E7\u30FC\u30C8\u30AB\u30C3\u30C8\u306B\u306F\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u3044\u305F\u3044\u3067\u3059\u3002\\n\\n\u30AD\u30E3\u30E9\u30AF\u30BF\u30FC\u306E\u52D5\u304D\u3084\u80FD\u529B\u3059\u3079\u3066\u306B\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"macros":{"title":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","titlePlural":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","description":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u306F\u3001\u5165\u529B (\u982D\u3092\u50BE\u3051\u308B\u306A\u3069\u306E\u30A2\u30AF\u30B7\u30E7\u30F3) \u3068\u3001\u305D\u306E\u5165\u529B\u30A2\u30AF\u30B7\u30E7\u30F3\u304C\u8A18\u9332\u3055\u308C\u305F\u5F8C\u306B Cephable \u304C\u5B9F\u884C\u3059\u308B\u624B\u9806\u304C\u542B\u307E\u308C\u307E\u3059\u3002\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u5358\u4E00\u306E\u5165\u529B\u306B\u3088\u3063\u3066\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u308B\u624B\u9806\u306E\u7D44\u307F\u5408\u308F\u305B\u3092\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002","new":"\u65B0\u3057\u3044\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F5C\u6210\u3059\u308B","newDescription":"\u8907\u6570\u306E\u30B9\u30C6\u30C3\u30D7\u3068\u5165\u529B\u3092\u7D44\u307F\u5408\u308F\u305B\u308B\u305F\u3081\u306E\u65B0\u3057\u3044\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002","add":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8FFD\u52A0","create":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F5C\u6210\u3059\u308B","name":{"title":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u540D","question":"\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u4F55\u3068\u3044\u3046\u540D\u524D\u3092\u4ED8\u3051\u307E\u3059\u304B?","description":"\u5F8C\u3067\u7C21\u5358\u306B\u898B\u3064\u3051\u3089\u308C\u308B\u3088\u3046\u306B\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u540D\u524D\u3092\u4ED8\u3051\u307E\u3059\u3002","placeholder":"\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u300C\u30B8\u30E3\u30F3\u30D7\u300D\u3084\u300C\u30BA\u30FC\u30E0\u30A4\u30F3\u300D\u306A\u3069\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u5B9F\u884C\u3057\u3066\u3044\u308B"},"empty":"\u307E\u3060\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u3042\u308A\u307E\u305B\u3093\u3002\u4EE5\u4E0B\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002","copySuffix":"{{name}}_\u30B3\u30D4\u30FC"},"event":{"title":"\u30B9\u30C6\u30C3\u30D7","titlePlural":"\u624B\u9806","previewSummaryPlural":"{{first}} \u304A\u3088\u3073 {{total}} \u4EF6\u306E\u4ED6\u306E\u30A4\u30D9\u30F3\u30C8","add":"\u30B9\u30C6\u30C3\u30D7\u3092\u8FFD\u52A0","stepType":"\u30B9\u30C6\u30C3\u30D7\u30BF\u30A4\u30D7","select":"\u8FFD\u52A0\u3059\u308B\u30B9\u30C6\u30C3\u30D7\u306E\u30BF\u30A4\u30D7\u3092\u9078\u629E\u3057\u307E\u3059\u3002","question":"Cephable \u306B\u3069\u306E\u3088\u3046\u306A\u7A2E\u985E\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u5B9F\u884C\u3055\u305B\u305F\u3044\u3067\u3059\u304B?","setup":"\u30B9\u30C6\u30C3\u30D7\u3092\u8A2D\u5B9A\u3059\u308B","description":"\u30B9\u30C6\u30C3\u30D7\u306F\u3001\u5165\u529B\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u305F\u5F8C\u306B Cephable \u304C\u5B9F\u884C\u3059\u308B\u30A2\u30AF\u30B7\u30E7\u30F3\u3067\u3059\u3002\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u8907\u6570\u306E\u30B9\u30C6\u30C3\u30D7\u3092\u8FFD\u52A0\u3057\u3066\u3001\u30A2\u30AF\u30B7\u30E7\u30F3\u306E\u7D44\u307F\u5408\u308F\u305B\u3092\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002","expand":"\u5C55\u958B\u3057\u3066\u6B8B\u308A\u306E\u624B\u9806\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044","stepUp":"\u30B9\u30C6\u30C3\u30D7\u30A2\u30C3\u30D7","stepDown":"\u30B9\u30C6\u30C3\u30D7\u30C0\u30A6\u30F3","stepCopy":"\u30B3\u30D4\u30FC\u30B9\u30C6\u30C3\u30D7","stepRemove":"\u30B9\u30C6\u30C3\u30D7\u3092\u524A\u9664","insertStep":"\u4EE5\u4E0B\u306B\u624B\u9806\u3092\u633F\u5165","showOptions":"\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u8868\u793A","hideOptions":"\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u975E\u8868\u793A","hold":"\u30DB\u30FC\u30EB\u30C9\u6642\u9593\uFF08\u30DF\u30EA\u79D2\uFF09","error":"\u30B9\u30C6\u30C3\u30D7\u3092\u69CB\u6210\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","multiple":"\u8907\u6570\u306E\u30B9\u30C6\u30C3\u30D7","deviceTypeCustomAction":{"title":"\u30AB\u30B9\u30BF\u30E0\u30C7\u30D0\u30A4\u30B9\u30A2\u30AF\u30B7\u30E7\u30F3"},"keyPress":{"title":"\u30AD\u30FC\u307E\u305F\u306F\u30DC\u30BF\u30F3\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044","short":"\u30D7\u30EC\u30B9","fieldSet":"\u62BC\u3059\u30AD\u30FC\u307E\u305F\u306F\u30DC\u30BF\u30F3","label":"\u30AD\u30FC\u307E\u305F\u306F\u30DC\u30BF\u30F3","holdTime":"\u30AD\u30FC\u3092\u62BC\u3057\u7D9A\u3051\u308B\u6642\u9593\uFF08\u30DF\u30EA\u79D2\uFF09","description":"\u30AD\u30FC\u30DC\u30FC\u30C9\u3092\u4F7F\u308F\u305A\u306B\u30AD\u30FC\u30DC\u30FC\u30C9\u306E\u30AD\u30FC\u3092\u62BC\u3057\u307E\u3059\u3002","longDescription":"\u3053\u306E\u6A5F\u80FD\u306F\u3001\u30AD\u30FC\u30DC\u30FC\u30C9\u306E\u30AD\u30FC\u3092\u62BC\u3059\u52D5\u4F5C\u3092\u30B7\u30DF\u30E5\u30EC\u30FC\u30C8\u3057\u307E\u3059\u3002\u305F\u3068\u3048\u3070\u3001\u7269\u7406\u7684\u306A\u30AD\u30FC\u3092\u62BC\u3059\u306E\u304C\u96E3\u3057\u3044\u5834\u5408\u306F\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u307E\u305F\u306F\u5225\u306E\u5165\u529B\u65B9\u6CD5\u3092\u4F7F\u7528\u3057\u3066\u3001\u4EEE\u60F3\u7684\u306B\u30AD\u30FC\u3092\u300C\u62BC\u3059\u300D\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","example":"\u300CEnter\u300D\u3068\u8A00\u3048\u3070\u3001Enter \u30AD\u30FC\u3092\u7269\u7406\u7684\u306B\u62BC\u3055\u305A\u306B\u96FB\u5B50\u30E1\u30FC\u30EB\u3092\u9001\u4FE1\u3067\u304D\u307E\u3059\u3002","timing":"\u30AD\u30FC\u3092\u62BC\u3059\u30BF\u30A4\u30DF\u30F3\u30B0","tap":"\u30BF\u30C3\u30D7","tapLong":"\u30BF\u30C3\u30D7\u30DC\u30BF\u30F3","latch":"\u30E9\u30C3\u30C1","latchLong":"\u89E3\u653E\u3055\u308C\u308B\u307E\u3067\u4FDD\u6301\u3059\u308B","hold":"\u6240\u6709","holdLong":"\u4E00\u5B9A\u6642\u9593\u4FDD\u6301\u3059\u308B","toggle":"\u5207\u308A\u66FF\u3048","toggleLong":"\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u5207\u308A\u66FF\u3048","release":"\u30EA\u30EA\u30FC\u30B9","releaseLong":"\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u30EA\u30EA\u30FC\u30B9","latchLabel":"\u89E3\u653E\u3055\u308C\u308B\u307E\u3067<strong>{{value}}</strong>\u3092\u4FDD\u6301\u3057\u307E\u3059","tapLabel":"<strong>{{value}}</strong>\u3092\u30BF\u30C3\u30D7","pressLabel":"<strong>{{value}}</strong>\u3092<strong>{{time}}</strong>\u30DF\u30EA\u79D2\u9593\u62BC\u3057\u307E\u3059","remove":"\u30AD\u30FC\u306E\u62BC\u4E0B\u3092\u89E3\u9664","add":"\u62BC\u3059\u30AD\u30FC/\u30DC\u30BF\u30F3\u3092\u8FFD\u52A0"},"keyRelease":{"title":"\u30AD\u30FC\u307E\u305F\u306F\u30DC\u30BF\u30F3\u3092\u96E2\u3059","short":"\u30EA\u30EA\u30FC\u30B9","selected":"\u30EA\u30EA\u30FC\u30B9\u3059\u308B\u30AD\u30FC\u3092\u9078\u629E","description":"\u62BC\u3057\u305F\u307E\u307E\u306B\u3057\u3066\u3044\u305F\u30AD\u30FC\u30DC\u30FC\u30C9\u306E\u30AD\u30FC\u3092\u653E\u3057\u307E\u3059\u3002","longDescription":"\u3053\u306E\u6A5F\u80FD\u306F\u3001\u30AD\u30FC\u30DC\u30FC\u30C9\u306E\u30AD\u30FC\u3092\u653E\u3059\u52D5\u4F5C\u3092\u30B7\u30DF\u30E5\u30EC\u30FC\u30C8\u3057\u307E\u3059\u3002\u30AD\u30FC\u3092\u7121\u671F\u9650\u306B\u62BC\u3057\u7D9A\u3051\u308B\u64CD\u4F5C\u3068\u7D44\u307F\u5408\u308F\u305B\u3066\u4F7F\u7528\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u305F\u3068\u3048\u3070\u3001\u7269\u7406\u7684\u306A\u30AD\u30FC\u3092\u62BC\u3059\u306E\u304C\u96E3\u3057\u3044\u5834\u5408\u306F\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u307E\u305F\u306F\u5225\u306E\u5165\u529B\u65B9\u6CD5\u3092\u4F7F\u7528\u3057\u3066\u3001\u4EEE\u60F3\u7684\u306B\u30AD\u30FC\u3092\u300C\u653E\u3059\u300D\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","example":"\u5B9F\u884C\u3092\u505C\u6B62\u3059\u308B\u306B\u306F\u3001\u300CToggle Run\u300D\u3068\u8A00\u3063\u305F\u5F8C\u306B\u300CStop\u300D\u3068\u8A00\u3044\u307E\u3059\u3002","label":"<strong>{{value}}</strong>\u3092\u30EA\u30EA\u30FC\u30B9","add":"\u30EA\u30EA\u30FC\u30B9\u306B\u30AD\u30FC/\u30DC\u30BF\u30F3\u3092\u8FFD\u52A0","remove":"\u30AD\u30FC\u30EA\u30EA\u30FC\u30B9\u3092\u524A\u9664\u3059\u308B"},"keyToggle":{"title":"\u30C8\u30B0\u30EB\u30AD\u30FC\u307E\u305F\u306F\u30DC\u30BF\u30F3","short":"\u30C8\u30B0\u30EB","selected":"\u5207\u308A\u66FF\u3048\u308B\u30AD\u30FC\u3092\u9078\u629E","description":"\u5358\u4E00\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u3001\u7167\u660E\u30B9\u30A4\u30C3\u30C1\u306E\u3088\u3046\u306B\u30AD\u30FC\u30DC\u30FC\u30C9\u306E\u30AD\u30FC\u3092\u30AA\u30F3\u307E\u305F\u306F\u30AA\u30D5\u306B\u3057\u307E\u3059\u3002","longDescription":"\u3053\u308C\u306F\u3001\u30B9\u30A4\u30C3\u30C1\u306E\u3088\u3046\u306B\u3001\u30AD\u30FC\u306E\u6A5F\u80FD\u3092\u30AA\u30F3\u307E\u305F\u306F\u30AA\u30D5\u306B\u3057\u307E\u3059\u3002\u3053\u308C\u306F\u3001\u30AD\u30FC\u3092\u4E0D\u5B9A\u306E\u6642\u9593\u62BC\u3057\u305F\u307E\u307E\u306B\u3057\u3066\u304A\u304F\u5834\u5408\u306B\u4FBF\u5229\u3067\u3059\u3002\u3053\u308C\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u30AD\u30FC\u306E\u62BC\u4E0B\u3068\u30AD\u30FC\u306E\u30EA\u30EA\u30FC\u30B9\u307E\u305F\u306F\u505C\u6B62\u306E\u4E21\u65B9\u306B\u5BFE\u3057\u3066\u540C\u3058\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u7DAD\u6301\u3067\u304D\u307E\u3059\u3002","example":"\u8D70\u308A\u59CB\u3081\u308B\u306B\u306F\u300CToggle Run\u300D\u3068\u8A00\u3044\u307E\u3059\u3002\u8D70\u308A\u3092\u6B62\u3081\u308B\u306B\u306F\u300CToggle Run\u300D\u3068\u8A00\u3044\u307E\u3059\u3002","label":"<strong>{{value}}</strong>\u3092\u5207\u308A\u66FF\u3048\u308B","add":"\u30C8\u30B0\u30EB\u306B\u30AD\u30FC/\u30DC\u30BF\u30F3\u3092\u8FFD\u52A0","remove":"\u30AD\u30FC\u30C8\u30B0\u30EB\u306E\u524A\u9664"},"pause":{"title":"\u4E00\u6642\u505C\u6B62","description":"\u30A2\u30AF\u30B7\u30E7\u30F3\u9593\u306B\u77ED\u3044\u9045\u5EF6\u3092\u8FFD\u52A0\u3057\u307E\u3059\u3002","longDescription":"\u3053\u306E\u6A5F\u80FD\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u30A2\u30AF\u30B7\u30E7\u30F3\u9593\u306B\u77ED\u3044\u9045\u5EF6\u3092\u633F\u5165\u3067\u304D\u307E\u3059\u3002\u3053\u308C\u306F\u3001\u6B21\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u958B\u59CB\u3059\u308B\u524D\u306B 1 \u3064\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u5B8C\u5168\u306B\u5B8C\u4E86\u3059\u308B\u5FC5\u8981\u304C\u3042\u308B\u72B6\u6CC1\u3067\u306F\u4E0D\u53EF\u6B20\u3067\u3059\u3002\u305F\u3068\u3048\u3070\u3001\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u5185\u306E\u30C6\u30AD\u30B9\u30C8\u3092\u592A\u5B57\u306B\u3059\u308B\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3057\u3066\u3044\u308B\u5834\u5408\u306F\u3001\u6700\u521D\u306B\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8 \u30E1\u30CB\u30E5\u30FC\u3092\u958B\u304F\u5FC5\u8981\u304C\u3042\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002\u4E00\u6642\u505C\u6B62\u6A5F\u80FD\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u6B21\u306E\u624B\u9806\u306B\u9032\u3080\u524D\u306B\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8 \u30E1\u30CB\u30E5\u30FC\u304C\u958B\u3044\u3066\u30A2\u30AF\u30C6\u30A3\u30D6\u306B\u306A\u308B\u307E\u3067\u306E\u5341\u5206\u306A\u6642\u9593\u3092\u78BA\u4FDD\u3067\u304D\u308B\u305F\u3081\u3001\u30B9\u30E0\u30FC\u30BA\u3067\u30A8\u30E9\u30FC\u306E\u306A\u3044\u64CD\u4F5C\u304C\u4FDD\u8A3C\u3055\u308C\u307E\u3059\u3002","example":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3057\u3066\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u7DE8\u96C6\u3057\u3066\u3044\u308B\u3068\u3057\u307E\u3059\u3002\u300C\u30C6\u30AD\u30B9\u30C8\u306E\u66F8\u5F0F\u8A2D\u5B9A\u300D\u3068\u8A00\u3046\u3068\u3001\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8 \u30E1\u30CB\u30E5\u30FC\u304C\u958B\u304D\u307E\u3059\u3002\u6B21\u306B\u3001\u30E1\u30CB\u30E5\u30FC\u304C\u5B8C\u5168\u306B\u8868\u793A\u3055\u308C\u308B\u307E\u3067\u5C11\u3057\u5F85\u3063\u3066\u304B\u3089\u3001\u300C\u592A\u5B57\u300D\u3068\u8A00\u3046\u3068\u3001\u9078\u629E\u3057\u305F\u30C6\u30AD\u30B9\u30C8\u306B\u592A\u5B57\u306E\u66F8\u5F0F\u304C\u9069\u7528\u3055\u308C\u307E\u3059\u3002\u4E00\u6642\u505C\u6B62\u6A5F\u80FD\u306B\u3088\u308A\u3001\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8 \u30E1\u30CB\u30E5\u30FC\u304C\u6B21\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u53D7\u3051\u4ED8\u3051\u308B\u6E96\u5099\u304C\u6574\u3044\u307E\u3059\u3002","label":"<strong>{{value}}</strong>\u30DF\u30EA\u79D2\u9593\u4E00\u6642\u505C\u6B62\u3057\u307E\u3059"},"type":{"title":"\u30BF\u30A4\u30D7","field":"\u5165\u529B\u3059\u308B\u30D5\u30EC\u30FC\u30BA","placeholder":"\u5165\u529B\u3057\u305F\u30D5\u30EC\u30FC\u30BA","question":"\u3069\u306E\u3088\u3046\u306A\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3057\u307E\u3059\u304B?","description":"\u30AD\u30FC\u30DC\u30FC\u30C9\u3092\u4F7F\u7528\u3059\u308B\u306E\u3068\u540C\u3058\u3088\u3046\u306B\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3057\u307E\u3059\u3002","longDescription":"\u3053\u308C\u306F\u3001\u30AD\u30FC\u30DC\u30FC\u30C9\u3067\u306E\u5165\u529B\u3068\u540C\u69D8\u306B\u3001\u30C6\u30AD\u30B9\u30C8\u6587\u5B57\u5217\u306E\u5165\u529B\u3092\u6A21\u5023\u3057\u307E\u3059\u3002\u5404\u30AD\u30FC\u3092\u62BC\u3055\u305A\u306B\u9577\u3044\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3059\u308B\u306E\u306B\u6700\u9069\u3067\u3059\u3002\u30C6\u30AD\u30B9\u30C8\u3092\u52D5\u7684\u306B\u5165\u529B\u3059\u308B\u5834\u5408\u306F\u3001\u4EE3\u308F\u308A\u306B\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u6A5F\u80FD\u3092\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002","example":"\u300C\u540D\u524D\u300D\u3068\u8A00\u3046\u3068\u3001\u30C1\u30E3\u30C3\u30C8 \u30A6\u30A3\u30F3\u30C9\u30A6\u306B\u300C\u3053\u3093\u306B\u3061\u306F\u3001\u79C1\u306E\u540D\u524D\u306F Ellen Ripley \u3067\u3059\u3002\u300D\u3068\u5165\u529B\u3067\u304D\u307E\u3059\u3002","label":"<strong>{{value}}</strong>\u3068\u5165\u529B"},"mouseMove":{"title":"\u30DE\u30A6\u30B9\u3092\u52D5\u304B\u3059","description":"\u753B\u9762\u4E0A\u3067\u30DD\u30A4\u30F3\u30BF\u30FC\u3092\u79FB\u52D5\u3057\u307E\u3059\u3002","longDescription":"\u7269\u7406\u7684\u306A\u30DE\u30A6\u30B9\u3092\u4F7F\u308F\u305A\u306B\u3001\u753B\u9762\u306E\u30AB\u30FC\u30BD\u30EB\u3084\u30DD\u30A4\u30F3\u30BF\u30FC\u3092\u79FB\u52D5\u3057\u307E\u3059\u3002\u3053\u308C\u306F\u3001\u624B\u306E\u53EF\u52D5\u6027\u304C\u9650\u3089\u308C\u3066\u3044\u308B\u30E6\u30FC\u30B6\u30FC\u306B\u3068\u3063\u3066\u7279\u306B\u4FBF\u5229\u3067\u3059\u3002\u3053\u308C\u306F\u3001\u4E00\u90E8\u306E\u30B2\u30FC\u30E0\u3067\u5FC5\u8981\u306A\u30DE\u30A6\u30B9\u306E\u52D5\u304D\u306E\u7D30\u304B\u3044\u5236\u5FA1\u306B\u5F79\u7ACB\u3061\u307E\u3059\u3002\u982D\u306E\u52D5\u304D\u3092\u4F7F\u7528\u3057\u3066\u3059\u3079\u3066\u306E\u30DE\u30A6\u30B9\u306E\u52D5\u304D\u3092\u30B7\u30DF\u30E5\u30EC\u30FC\u30C8\u3059\u308B\u5834\u5408\u306F\u3001\u30AB\u30E1\u30E9\u8A2D\u5B9A\u3067\u300C\u30DE\u30A6\u30B9\u5236\u5FA1\u306E\u305F\u3081\u306E\u982D\u306E\u52D5\u304D\u300D\u3092\u8A66\u3059\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","example":"\u300C\u30DE\u30A6\u30B9\u3092\u53F3\u306B\u79FB\u52D5\u300D\u3068\u8A00\u3046\u3068\u3001\u30AB\u30FC\u30BD\u30EB\u304C 100 \u30D4\u30AF\u30BB\u30EB\u53F3\u306B\u79FB\u52D5\u3057\u307E\u3059\u3002","moveX":"\u30DE\u30A6\u30B9\u3092\u5DE6/\u53F3\u306B\u30D4\u30AF\u30BB\u30EB\u79FB\u52D5","numberMoveX":"\u5DE6/\u53F3\u306B\u79FB\u52D5\u3059\u308B\u30D4\u30AF\u30BB\u30EB\u6570","moveY":"\u30DE\u30A6\u30B9\u3092\u4E0A\u4E0B\u306B\u30D4\u30AF\u30BB\u30EB\u79FB\u52D5","numberMoveY":"\u4E0A/\u4E0B\u306B\u79FB\u52D5\u3059\u308B\u30D4\u30AF\u30BB\u30EB\u6570","label":"\u30DE\u30A6\u30B9\u3092<strong>{{value}}</strong>\u56DE\u52D5\u304B\u3059","command":"\u30DE\u30A6\u30B9\u306E\u79FB\u52D5: {{command}}"},"joystickMove":{"title":"\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u3092\u52D5\u304B\u3059","description":"\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u3092\u4F7F\u7528\u3057\u3066\u753B\u9762\u4E0A\u306E\u3082\u306E\u3092\u79FB\u52D5\u3057\u307E\u3059\u3002","longDescription":"\u3053\u306E\u6A5F\u80FD\u306F\u3001\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u306E\u52D5\u304D\u3092\u30B7\u30DF\u30E5\u30EC\u30FC\u30C8\u3057\u307E\u3059\u3002\u305F\u3068\u3048\u3070\u3001\u7269\u7406\u7684\u306A\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u306E\u4F7F\u7528\u304C\u96E3\u3057\u3044\u5834\u5408\u306F\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u307E\u305F\u306F\u5225\u306E\u5165\u529B\u65B9\u6CD5\u3092\u4F7F\u7528\u3057\u3066\u3001\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u3092\u4EEE\u60F3\u7684\u306B\u52D5\u304B\u3059\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","example":"\u300C\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u3092\u5DE6\u306B\u52D5\u304B\u3057\u3066\u300D\u3068\u8A00\u3046\u3068\u3001\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u304C 100 \u30D4\u30AF\u30BB\u30EB\u5DE6\u306B\u79FB\u52D5\u3057\u307E\u3059\u3002","prefix":"\u5DE6\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u3092\u52D5\u304B\u3059","left":"\u5DE6\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF","leftX":"\u5DE6X","leftY":"\u5DE6Y","right":"\u53F3\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF","rightX":"\u53F3X","rightY":"\u53F3Y","x":"X\u8EF8\u306E\u5F37\u5EA6","y":"Y\u8EF8\u306E\u5F37\u5EA6","moveXLabel":"X \u306B\u79FB\u52D5: {{value}}","moveYLabel":"Y \u65B9\u5411\u306B\u79FB\u52D5: {{value}}","labelLeft":"\u5DE6\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u3092\u52D5\u304B\u3059","labelRight":"\u53F3\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u3092\u52D5\u304B\u3059","latch":"\u30E9\u30C3\u30C1\u306F\u3001\u300C\u3059\u3079\u3066\u505C\u6B62\u300D\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3057\u3066\u89E3\u653E\u3055\u308C\u308B\u307E\u3067\u4F4D\u7F6E\u3092\u4FDD\u6301\u3057\u307E\u3059\u3002"},"playAudio":{"title":"\u30AA\u30FC\u30C7\u30A3\u30AA\u3092\u518D\u751F","placeholder":"Cephable\u304C\u8A00\u3046\u3067\u3042\u308D\u3046\u767A\u8A00\u306E\u30D5\u30EC\u30FC\u30BA","description":"\u97F3\u3001\u5358\u8A9E\u3001\u307E\u305F\u306F\u30D5\u30EC\u30FC\u30BA\u3092\u518D\u751F\u3057\u307E\u3059\u3002","longDescription":"\u3053\u306E\u6A5F\u80FD\u306B\u3088\u308A\u3001\u30E6\u30FC\u30B6\u30FC\u306F\u5165\u529B\u3057\u305F\u30D5\u30EC\u30FC\u30BA\u3092\u97F3\u58F0\u306B\u5909\u63DB\u3067\u304D\u307E\u3059\u3002\u3053\u308C\u306F\u3001\u8A71\u3059\u3053\u3068\u304C\u56F0\u96E3\u306A\u4EBA\u306B\u3068\u3063\u3066\u7279\u306B\u4FBF\u5229\u3067\u3059\u3002\u30D5\u30EC\u30FC\u30BA\u3092\u5165\u529B\u3059\u308B\u3068\u3001PlayAudio \u6A5F\u80FD\u306B\u3088\u308A\u5408\u6210\u97F3\u58F0\u3092\u4F7F\u7528\u3057\u3066\u30C6\u30AD\u30B9\u30C8\u304C\u8AAD\u307F\u4E0A\u3052\u3089\u308C\u307E\u3059\u3002\u3053\u308C\u306F\u3001\u30B3\u30DF\u30E5\u30CB\u30B1\u30FC\u30B7\u30E7\u30F3\u3084\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u53E3\u982D\u3067\u60C5\u5831\u3092\u4F1D\u3048\u308B\u5FC5\u8981\u304C\u3042\u308B\u304C\u81EA\u5206\u306E\u58F0\u3092\u4F7F\u7528\u3059\u308B\u4EE3\u308F\u308A\u306B\u5225\u306E\u65B9\u6CD5\u3092\u597D\u3080\u3001\u307E\u305F\u306F\u5FC5\u8981\u3068\u3059\u308B\u72B6\u6CC1\u306B\u5F79\u7ACB\u3061\u307E\u3059\u3002","example":"\u7B11\u9854\u3067\u300CHello\u300D\u3068\u3044\u3046\u8A00\u8449\u3092\u6F14\u594F\u3057\u307E\u3059\u3002","label":"<strong>\\"{{value}}\\"</strong>\u3068\u767A\u97F3\u3059\u308B"},"stopOutputs":{"title":"\u3059\u3079\u3066\u306E\u51FA\u529B\u3092\u505C\u6B62","titleLong":"\u3059\u3079\u3066\u306E\u51FA\u529B\u3092\u505C\u6B62\u3057\u307E\u3059\uFF08\u3059\u3079\u3066\u306E\u30AD\u30FC\u3068\u30DC\u30BF\u30F3\u3092\u653E\u3057\u3001\u3059\u3079\u3066\u306E\u30DE\u30A6\u30B9\u306E\u52D5\u304D\u3092\u505C\u6B62\u3057\u3001\u3059\u3079\u3066\u306E\u5165\u529B\u3092\u505C\u6B62\u3057\u307E\u3059\uFF09","description":"\u30AD\u30FC\u306E\u62BC\u4E0B\u306A\u3069\u3001\u9032\u884C\u4E2D\u306E\u3059\u3079\u3066\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u505C\u6B62\u3057\u307E\u3059\u3002","longDescription":"\u9032\u884C\u4E2D\u306E\u51FA\u529B\u307E\u305F\u306F\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u3059\u3079\u3066\u76F4\u3061\u306B\u505C\u6B62\u3057\u307E\u3059\u3002\u3053\u308C\u306F\u3001\u30D7\u30ED\u30BB\u30B9\u3092\u505C\u6B62\u3059\u308B\u305F\u3081\u306E\u5B89\u5168\u6A5F\u80FD\u307E\u305F\u306F\u5229\u4FBF\u6027\u6A5F\u80FD\u3067\u3059\u3002\u30AB\u30E1\u30E9\u307E\u305F\u306F\u30DE\u30A4\u30AF\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u9589\u3058\u308B\u304B\u4E00\u6642\u505C\u6B62\u3059\u308B\u3068\u3001\u81EA\u52D5\u7684\u306B\u5B9F\u884C\u3055\u308C\u307E\u3059\u3002","example":"\u3059\u3079\u3066\u306E\u51FA\u529B\u3092\u505C\u6B62\u3059\u308B\u306B\u306F\u3001\u300C\u505C\u6B62\u300D\u3068\u8A00\u3044\u307E\u3059\u3002","label":"\u3059\u3079\u3066\u306E\u51FA\u529B\u3092\u505C\u6B62\u3057\u3001\u30AD\u30FC\u3092\u653E\u3057\u307E\u3059"},"custom":{"title":"\u30AB\u30B9\u30BF\u30E0"},"options":{"moveUp":"\u4E0A\u3078\u79FB\u52D5","moveDown":"\u4E0B\u306B\u79FB\u52D5","moveLeft":"\u5DE6\u306B\u79FB\u52D5","moveRight":"\u53F3\u306B\u79FB\u52D5","copyStep":"\u30B3\u30D4\u30FC\u30B9\u30C6\u30C3\u30D7","removeStep":"\u30B9\u30C6\u30C3\u30D7\u3092\u524A\u9664"},"directions":{"up":"\u4E0A","down":"\u4E0B","left":"\u5DE6","right":"\u53F3"}},"expression":{"title":"\u8868\u60C5","titlePlural":"\u8868\u60C5","label":"\u8868\u60C5\u30FB\u8EAB\u632F\u308A","start":"\u5F0F\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u958B\u59CB","startSmiling":{"title":"\u7B11\u9854\u3092\u59CB\u3081\u307E\u3057\u3087\u3046","description":"\u6700\u521D\u306F\u7B11\u3063\u3066\u3044\u306A\u304B\u3063\u305F\u306E\u306B\u3001\u305D\u306E\u5F8C\u7B11\u9854\u306B\u306A\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002\u6CE8\u610F: \u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u3001\u53E3\u306E\u958B\u9589\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u540C\u3058\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u4F7F\u7528\u3059\u308B\u3068\u3001\u7AF6\u5408\u304C\u767A\u751F\u3059\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002"},"stopSmiling":{"title":"\u7B11\u3046\u306E\u3092\u3084\u3081\u3066","description":"\u7B11\u3063\u3066\u3044\u3066\u3001\u305D\u306E\u5F8C\u7B11\u9854\u3092\u3084\u3081\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002\u6CE8\u610F: \u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u3001\u53E3\u306E\u958B\u9589\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u540C\u3058\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u4F7F\u7528\u3059\u308B\u3068\u3001\u7AF6\u5408\u304C\u767A\u751F\u3059\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002"},"eyebrows":{"title":"\u7709\u3092\u4E0A\u3052\u308B","description":"\u4E21\u65B9\u306E\u7709\u6BDB\u3092\u57FA\u672C\u306E\u4F11\u606F\u4F4D\u7F6E\u304B\u3089\u4E0A\u3052\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"openMouth":{"title":"\u53E3\u3092\u958B\u3051\u308B","description":"\u53E3\u304C\u9589\u3058\u3066\u3044\u308B\u5834\u5408\uFF08\u307E\u305F\u306F\u30D9\u30FC\u30B9\u30E9\u30A4\u30F3\u304C\u308F\u305A\u304B\u306B\u958B\u3044\u3066\u3044\u308B\u5834\u5408\uFF09\u3001\u3055\u3089\u306B\u53E3\u3092\u958B\u3051\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002\u6CE8\u610F: \u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30B9\u30DE\u30A4\u30EB \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u540C\u3058\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u4F7F\u7528\u3059\u308B\u3068\u3001\u7AF6\u5408\u304C\u767A\u751F\u3059\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002"},"closeMouth":{"title":"\u53E3\u3092\u9589\u3058\u308B","description":"\u53E3\u304C\u958B\u3044\u3066\u3044\u308B\u72B6\u614B\u3067\u5B8C\u5168\u306B\u9589\u3058\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002\u6CE8\u610F: \u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30B9\u30DE\u30A4\u30EB \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u540C\u3058\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u4F7F\u7528\u3059\u308B\u3068\u3001\u7AF6\u5408\u304C\u767A\u751F\u3059\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002"},"description":"\u8868\u60C5\u3067\u30C7\u30B8\u30BF\u30EB\u4F53\u9A13\u3092\u30EF\u30F3\u30E9\u30F3\u30AF\u30A2\u30C3\u30D7\u3002\u7709\u3092\u4E0A\u3052\u308B\u3001\u7B11\u9854\u3092\u4F5C\u308B\u3001\u305D\u306E\u4ED6\u306E\u30B8\u30A7\u30B9\u30C1\u30E3\u30FC\u3092\u4F7F\u3063\u3066\u3001\u30DE\u30A6\u30B9\u30DD\u30A4\u30F3\u30BF\u30FC\u3092\u30B7\u30FC\u30E0\u30EC\u30B9\u306B\u64CD\u4F5C\u3057\u305F\u308A\u3001\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u5B9F\u884C\u3057\u305F\u308A\u3001\u30A4\u30F3\u30BF\u30E9\u30AF\u30B7\u30E7\u30F3\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002"},"head":{"title":"\u982D\u306E\u52D5\u304D","titlePlural":"\u982D\u306E\u52D5\u304D","label":"\u982D/\u4F53\u306E\u52D5\u304D","question":"\u3069\u306E\u3088\u3046\u306A\u7A2E\u985E\u306E\u52D5\u304D\u3092\u4F7F\u3044\u305F\u3044\u3067\u3059\u304B?","tilt":{"title":"\u982D\u3092\u50BE\u3051\u308B","left":{"title":"\u982D\u3092\u5DE6\u306B\u50BE\u3051\u308B","description":"\u30AB\u30E1\u30E9\u3092\u898B\u3066\u982D\u3092\u5DE6\u306B\u50BE\u3051\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"right":{"title":"\u982D\u3092\u53F3\u306B\u50BE\u3051\u308B","description":"\u30AB\u30E1\u30E9\u3092\u898B\u3066\u982D\u3092\u53F3\u306B\u50BE\u3051\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"back":{"title":"\u982D\u3092\u5F8C\u308D\u306B\u50BE\u3051\u308B","description":"\u30AB\u30E1\u30E9\u3092\u898B\u3066\u3001\u982D\u3092\u5F8C\u308D\u306B\u50BE\u3051\u3066\u4E0A\u3092\u898B\u4E0A\u3052\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"forward":{"title":"\u982D\u3092\u524D\u306B\u50BE\u3051\u308B","description":"\u30AB\u30E1\u30E9\u3092\u898B\u3066\u3001\u982D\u3092\u524D\u306B\u50BE\u3051\u3066\u4E0B\u3092\u5411\u304F\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"description":"\u982D\u3092\u5DE6\u307E\u305F\u306F\u53F3\u306B\u50BE\u3051\u308B\u3068\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3084\u30DE\u30A6\u30B9\u306E\u30CA\u30D3\u30B2\u30FC\u30B7\u30E7\u30F3\u304C\u5F37\u5316\u3055\u308C\u307E\u3059\u3002"},"turn":{"title":"\u30D8\u30C3\u30C9\u30BF\u30FC\u30F3","left":{"title":"\u982D\u3092\u5DE6\u306B\u5411\u3051\u308B","description":"\u30AB\u30E1\u30E9\u3092\u898B\u3066\u982D\u3092\u56DE\u3057\u3066\u5DE6\u3092\u5411\u304F\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"right":{"title":"\u982D\u3092\u53F3\u306B\u5411\u3051\u308B","description":"\u30AB\u30E1\u30E9\u3092\u898B\u3066\u982D\u3092\u56DE\u3057\u3066\u53F3\u3092\u5411\u304F\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"description":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3084\u30DE\u30A6\u30B9\u306E\u30CA\u30D3\u30B2\u30FC\u30B7\u30E7\u30F3\u3092\u5F37\u5316\u3059\u308B\u306B\u306F\u3001\u982D\u3092\u5DE6\u307E\u305F\u306F\u53F3\u306B\u56DE\u3057\u307E\u3059\u3002"},"lean":{"title":"\u30D8\u30C3\u30C9\u30EA\u30FC\u30F3","left":{"title":"\u982D\u3092\u5DE6\u306B\u50BE\u3051\u308B","description":"\u30AB\u30E1\u30E9\u3092\u898B\u3066\u5DE6\u306B\u50BE\u304D\u3001\u9854\u304C\u30AB\u30E1\u30E9 \u30D5\u30EC\u30FC\u30E0\u5185\u3067\u3055\u3089\u306B\u5DE6\u306B\u6765\u308B\u3088\u3046\u306B\u3059\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"right":{"title":"\u982D\u3092\u53F3\u306B\u50BE\u3051\u308B","description":"\u30AB\u30E1\u30E9\u3092\u898B\u3066\u53F3\u306B\u50BE\u304D\u3001\u9854\u304C\u30AB\u30E1\u30E9 \u30D5\u30EC\u30FC\u30E0\u5185\u3067\u3055\u3089\u306B\u53F3\u5074\u306B\u6765\u308B\u3088\u3046\u306B\u3059\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"back":{"title":"\u982D\u3092\u5F8C\u308D\u306B\u50BE\u3051\u308B","description":"\u30AB\u30E1\u30E9\u3092\u898B\u3064\u3081\u3066\u3044\u308B\u3068\u304D\u306B\u3001\u5F8C\u308D\u306B\u50BE\u3044\u3066\u9854\u304C\u30AB\u30E1\u30E9\u304B\u3089\u9060\u3056\u304B\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"forward":{"title":"\u982D\u3092\u524D\u306B\u50BE\u3051\u308B","description":"\u30AB\u30E1\u30E9\u3092\u898B\u3066\u3001\u9854\u3092\u30AB\u30E1\u30E9\u306B\u8FD1\u3065\u3051\u308B\u305F\u3081\u306B\u524D\u306B\u50BE\u304F\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"up":{"title":"\u30DC\u30C7\u30A3\u3092\u4E0A\u306B\u79FB\u52D5","description":"\u30AB\u30E1\u30E9\u3092\u898B\u306A\u304C\u3089\u3001\u9996\u3092\u4F38\u3070\u3057\u305F\u308A\u3001\u4F53\u5168\u4F53\u3092\u4E0A\u306B\u52D5\u304B\u3057\u305F\u308A\u3057\u3066\u982D\u3092\u4E0A\u3052\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"down":{"title":"\u672C\u6587\u3092\u4E0B\u306B\u79FB\u52D5","description":"\u30AB\u30E1\u30E9\u3092\u898B\u306A\u304C\u3089\u3001\u9996\u3092\u3059\u304F\u3081\u305F\u308A\u3001\u3057\u3083\u304C\u3093\u3060\u308A\u3001\u4F53\u5168\u4F53\u3092\u4E0B\u3052\u305F\u308A\u3057\u3066\u982D\u3092\u4E0B\u3052\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"center":{"title":"\u982D\u3092\u96C6\u4E2D\u3055\u305B\u308B","description":"\u30AB\u30E1\u30E9\u3092\u898B\u3066\u3001\u982D\u3092\u30D9\u30FC\u30B9\u30E9\u30A4\u30F3\u306B\u4E00\u81F4\u3059\u308B\u4E2D\u5FC3\u4F4D\u7F6E\u306B\u623B\u3059\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"description":"\u982D\u3092\u5DE6\u307E\u305F\u306F\u53F3\u306B\u50BE\u3051\u308B\u3068\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3084\u30DE\u30A6\u30B9\u64CD\u4F5C\u304C\u5F37\u5316\u3055\u308C\u307E\u3059\u3002"},"description":"\u982D\u3092\u50BE\u3051\u308B\u3001\u3046\u306A\u305A\u304F\u3001\u56DE\u3059\u3068\u3044\u3063\u305F\u52D5\u304D\u3067\u3001\u30C7\u30D0\u30A4\u30B9\u3084\u63A5\u7D9A\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002Cephable\u306F\u30C7\u30D0\u30A4\u30B9\u306E\u30AB\u30E1\u30E9\u3092\u4F7F\u7528\u3059\u308B\u3053\u3068\u3067\u3001\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3092\u5B88\u308A\u306A\u304C\u3089\u76F4\u611F\u7684\u306A\u64CD\u4F5C\u6027\u3092\u5B9F\u73FE\u3057\u3001\u9AD8\u5EA6\u306A\u64CD\u4F5C\u3084\u30DE\u30A6\u30B9\u64CD\u4F5C\u3092\u5B9F\u73FE\u3057\u307E\u3059\u3002"},"voice":{"title":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","titlePlural":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","placeholder":"Cephable\u304C\u805E\u304D\u53D6\u308B\u97F3\u58F0\u307E\u305F\u306F\u30D5\u30EC\u30FC\u30BA","question":"\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u5BFE\u3057\u3066\u3069\u306E\u3088\u3046\u306A\u30B9\u30C6\u30FC\u30C8\u30E1\u30F3\u30C8\u307E\u305F\u306F\u30D5\u30EC\u30FC\u30BA\u3092\u4F1D\u3048\u305F\u3044\u3067\u3059\u304B?","when":"\u79C1\u304C\u8A00\u3046\u3068...","say":"\u300C{{value}}\u300D\u3068\u767A\u97F3\u3059\u308B","load":{"fail":{"title":"{{language}} \u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u5229\u7528\u3067\u304D\u307E\u305B\u3093","description":"\u3042\u3042\u3001\u5927\u5909\uFF01\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u7528\u306E {{language}} \u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u63A5\u7D9A\u3092\u78BA\u8A8D\u3057\u3066\u3001\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002\u63A5\u7D9A\u304C\u56DE\u5FA9\u3059\u308B\u307E\u3067\u82F1\u8A9E (\u7C73\u56FD) \u3092\u4F7F\u7528\u3057\u307E\u3059\u3002"}},"description":"\u30DE\u30A4\u30AF\u3092\u8D77\u52D5\u3059\u308B\u3068\u3001\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u3067\u81EA\u7136\u306A\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u304C\u4F7F\u7528\u53EF\u80FD\u306B\u306A\u308A\u3001\u30E6\u30FC\u30B6\u30FC\u306F\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3084\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3092\u554F\u308F\u305A\u3001\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u3092\u30B7\u30FC\u30E0\u30EC\u30B9\u306B\u64CD\u4F5C\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002\u81EA\u7136\u306A\u767A\u58F0\u3067\u30B3\u30DE\u30F3\u30C9\u3092\u5B9F\u884C\u3057\u305F\u308A\u3001\u30C6\u30AD\u30B9\u30C8\u3092\u97F3\u58F0\u5165\u529B\u3057\u305F\u308A\u3059\u308B\u3053\u3068\u3067\u3001\u7C21\u5358\u304B\u3064\u76F4\u611F\u7684\u306A\u64CD\u4F5C\u3092\u5B9F\u73FE\u3057\u307E\u3059\u3002"},"motion":{"title":"\u30E2\u30FC\u30B7\u30E7\u30F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","titlePlural":"\u30E2\u30FC\u30B7\u30E7\u30F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","question":"\u643A\u5E2F\u96FB\u8A71\u3084\u30BF\u30D6\u30EC\u30C3\u30C8\u3067\u3069\u306E\u3088\u3046\u306A\u7A2E\u985E\u306E\u30E2\u30FC\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3057\u305F\u3044\u3067\u3059\u304B?","start":"\u30E2\u30FC\u30B7\u30E7\u30F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u958B\u59CB","settings":"\u30E2\u30FC\u30B7\u30E7\u30F3\u8A2D\u5B9A","descriptionShort":"\u30C7\u30D0\u30A4\u30B9\u3092\u50BE\u3051\u305F\u308A\u3001\u56DE\u3057\u305F\u308A\u3001\u632F\u3063\u305F\u308A\u3057\u3066 Cephable \u3092\u5236\u5FA1\u3057\u307E\u3059\u3002","description":"\u30E2\u30FC\u30B7\u30E7\u30F3 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u30B3\u30F3\u30D1\u30CB\u30AA\u30F3 \u30A2\u30D7\u30EA\u3067\u306E\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u3084\u30BF\u30D6\u30EC\u30C3\u30C8\u306E\u52D5\u304D\u3092\u30C7\u30D0\u30A4\u30B9\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u5909\u63DB\u3067\u304D\u307E\u3059\u3002\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u3092\u3055\u307E\u3056\u307E\u306A\u65B9\u5411\u306B\u50BE\u3051\u305F\u308A\u632F\u3063\u305F\u308A\u3057\u3066\u3001\u65B0\u3057\u3044\u51FA\u529B\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002","up":{"title":"\u30C7\u30D0\u30A4\u30B9\u3092\u4E0A\u306B\u50BE\u3051\u308B","description":"\u30C7\u30D0\u30A4\u30B9\u304C\u5E73\u3089\u306A\u9762\u306B\u7F6E\u304B\u308C\u3001\u81EA\u5206\u306E\u65B9\u3092\u5411\u304F\u3088\u3046\u306B\u50BE\u3051\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u8D77\u52D5\u3057\u307E\u3059\u3002"},"down":{"title":"\u30C7\u30D0\u30A4\u30B9\u3092\u4E0B\u306B\u50BE\u3051\u308B","description":"\u30C7\u30D0\u30A4\u30B9\u304C\u5E73\u3089\u306A\u9762\u306B\u7F6E\u304B\u308C\u3001\u81EA\u5206\u304B\u3089\u9060\u3056\u304B\u308B\u3088\u3046\u306B\u4E0B\u306B\u50BE\u3051\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u8D77\u52D5\u3057\u307E\u3059\u3002"},"left":{"title":"\u30C7\u30D0\u30A4\u30B9\u3092\u5DE6\u306B\u50BE\u3051\u308B","description":"\u30C7\u30D0\u30A4\u30B9\u304C\u5E73\u3089\u306A\u9762\u306B\u7F6E\u304B\u308C\u3001\u5DE6\u306B\u50BE\u3051\u3066\u5DE6\u3092\u5411\u304F\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"right":{"title":"\u30C7\u30D0\u30A4\u30B9\u3092\u53F3\u306B\u50BE\u3051\u308B","description":"\u30C7\u30D0\u30A4\u30B9\u304C\u5E73\u3089\u306A\u9762\u306B\u7F6E\u304B\u308C\u3001\u53F3\u306B\u50BE\u3051\u3066\u53F3\u3092\u5411\u304F\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"shake":{"title":"\u30C7\u30D0\u30A4\u30B9\u3092\u632F\u308B","description":"\u30C7\u30D0\u30A4\u30B9\u3092\u632F\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u8D77\u52D5\u3057\u307E\u3059\u3002"},"edit":{"title":"\u30E2\u30FC\u30B7\u30E7\u30F3\u8A2D\u5B9A\u3092\u7DE8\u96C6","description":"\u30E2\u30FC\u30B7\u30E7\u30F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u8A2D\u5B9A\u3092\u5909\u66F4\u3057\u3066\u3001\u30B3\u30F3\u30D1\u30CB\u30AA\u30F3\u30A2\u30D7\u30EA\u3067\u30E9\u30F3\u30CB\u30F3\u30B0\u4E2D\u306B\u643A\u5E2F\u96FB\u8A71\u3092\u3069\u308C\u3060\u3051\u52D5\u304B\u3059\u5FC5\u8981\u304C\u3042\u308B\u304B\u3092\u8ABF\u6574\u3057\u307E\u3059\u3002","sensitivity":{"title":"\u30E2\u30FC\u30B7\u30E7\u30F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u611F\u5EA6\u8A2D\u5B9A","description":"\u611F\u5EA6\u306F\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u305F\u3081\u306B\u30C7\u30D0\u30A4\u30B9\u3092\u3069\u306E\u7A0B\u5EA6\u50BE\u3051\u308B\u5FC5\u8981\u304C\u3042\u308B\u304B\u3092 Cephable \u306B\u4F1D\u3048\u307E\u3059\u3002\u5024\u304C\u5927\u304D\u3044\u307B\u3069 (\u30B9\u30E9\u30A4\u30C0\u30FC\u306E\u53F3\u7AEF)\u3001\u611F\u5EA6\u304C\u9AD8\u304F\u306A\u308A\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u305F\u3081\u306B\u50BE\u3051\u308B\u5FC5\u8981\u304C\u5C11\u306A\u304F\u306A\u308A\u307E\u3059\u3002"},"tilt":{"title":"\u50BE\u304D\u611F\u5EA6","description":"\u3053\u308C\u3089\u306E\u5024\u306F\u3001\u5165\u529B\u304C\u8A8D\u8B58\u3055\u308C\u308B\u305F\u3081\u306B\u30C7\u30D0\u30A4\u30B9\u3092\u4E0A\u4E0B\u5DE6\u53F3\u306B\u3069\u306E\u7A0B\u5EA6\u50BE\u3051\u308B\u5FC5\u8981\u304C\u3042\u308B\u304B\u3092\u6C7A\u5B9A\u3057\u307E\u3059\u3002"},"mouse":{"title":"\u30DE\u30A6\u30B9\u79FB\u52D5\u306E\u30E2\u30FC\u30B7\u30E7\u30F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","description":"\u30DE\u30A6\u30B9\u3092\u52D5\u304B\u3059\u305F\u3081\u306B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u306E\u3067\u306F\u306A\u304F\u3001\u30E2\u30FC\u30B7\u30E7\u30F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u304B\u3069\u3046\u304B\u3001\u307E\u305F\u3069\u306E\u3088\u3046\u306B\u4F7F\u7528\u3059\u308B\u304B\u3092\u6C7A\u5B9A\u3057\u307E\u3059\u3002","enable":{"title":"\u30DE\u30A6\u30B9\u79FB\u52D5\u306E\u30E2\u30FC\u30B7\u30E7\u30F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u6709\u52B9\u306B\u3059\u308B","description":"\u3053\u308C\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u30C8\u30EA\u30AC\u30FC \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u4EE3\u308F\u308A\u306B\u3001\u4E00\u90E8\u306E\u30E2\u30FC\u30B7\u30E7\u30F3 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30DE\u30A6\u30B9\u306E\u79FB\u52D5\u306B\u4F7F\u7528\u3055\u308C\u307E\u3059\u3002","option":"\u30DE\u30A6\u30B9\u306E\u79FB\u52D5\u306B\u30E2\u30FC\u30B7\u30E7\u30F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3057\u307E\u3059\u304B?"},"invert":{"title":"\u30DE\u30A6\u30B9\u306E\u52D5\u304D\u3092\u53CD\u8EE2","description":"X \u8EF8\u306E\u5834\u5408: \u3053\u308C\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u5834\u5408\u3001\u30DE\u30A6\u30B9\u3092\u5DE6\u306B\u52D5\u304B\u3059\u3068\u53F3\u306B\u79FB\u52D5\u3057\u3001\u53F3\u306B\u52D5\u304B\u3059\u3068\u5DE6\u306B\u79FB\u52D5\u3057\u307E\u3059\u3002Y \u8EF8\u306E\u5834\u5408: \u3053\u308C\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u5834\u5408\u3001\u30DE\u30A6\u30B9\u3092\u4E0B\u306B\u52D5\u304B\u3059\u3068\u4E0A\u306B\u79FB\u52D5\u3057\u3001\u4E0A\u306B\u52D5\u304B\u3059\u3068\u4E0B\u306B\u79FB\u52D5\u3057\u307E\u3059\u3002","x":"X\u8EF8\u306E\u30DE\u30A6\u30B9\u306E\u52D5\u304D\u3092\u53CD\u8EE2\u3057\u307E\u3059\u304B?","y":"Y\u8EF8\u306E\u30DE\u30A6\u30B9\u306E\u52D5\u304D\u3092\u53CD\u8EE2\u3057\u307E\u3059\u304B?"}}}},"keys":{"title":"\u30AD\u30FC\u307E\u305F\u306F\u30DC\u30BF\u30F3","titlePlural":"\u30AD\u30FC\u307E\u305F\u306F\u30DC\u30BF\u30F3","label":"\u5916\u90E8\u30AD\u30FC/\u30DC\u30BF\u30F3","question":"\u3069\u306E\u30AD\u30FC\u307E\u305F\u306F\u30DC\u30BF\u30F3\u3092\u62BC\u3057\u307E\u3059\u304B?","edit":"\u30AD\u30FC\u3068\u30DC\u30BF\u30F3\u3092\u7DE8\u96C6\u3059\u308B","defaultOption":"\u30AD\u30FC\u3068\u30DE\u30A6\u30B9\u306E\u30AF\u30EA\u30C3\u30AF\u306B\u5BFE\u3059\u308B\u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3092\u542B\u3081\u307E\u3059\u304B?","description":"\u30AD\u30FC\u3068\u30DC\u30BF\u30F3\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u3055\u307E\u3056\u307E\u306A\u5165\u529B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30AD\u30FC\u30DC\u30FC\u30C9\u3068\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u306E\u30DC\u30BF\u30F3\u306E\u62BC\u4E0B\u306B\u30DE\u30C3\u30D4\u30F3\u30B0\u3067\u304D\u307E\u3059\u3002","then":"Cephable \u306F... \u3092\u62BC\u3057\u307E\u3059\u3002","empty":"\u3053\u306E\u6761\u4EF6\u306B\u4E00\u81F4\u3059\u308B\u30AD\u30FC\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3042\u308A\u307E\u305B\u3093\u3002","backspace":"\u30D0\u30C3\u30AF\u30B9\u30DA\u30FC\u30B9","delete":"\u6D88\u53BB","enter":"\u5165\u529B","space":"\u30B9\u30DA\u30FC\u30B9\u30D0\u30FC","tab":"\u30BF\u30D6","shift":"\u30B7\u30D5\u30C8","ctrl":"Ctrl","leftCtrl":"\u5DE6Ctrl","rightCtrl":"\u53F3Ctrl","leftShift":"\u5DE6\u30B7\u30D5\u30C8","rightShift":"\u53F3\u30B7\u30D5\u30C8","alt":"\u5168\u3066","leftAlt":"\u5DE6Alt","escape":"\u9003\u3052\u308B","up":"\u4E0A\u77E2\u5370","down":"\u4E0B\u77E2\u5370","left":"\u5DE6\u77E2\u5370","right":"\u53F3\u77E2\u5370","command":"\u6307\u793A","caps":"\u30AD\u30E3\u30C3\u30D7\u30B9\u30ED\u30C3\u30AF","reset":{"title":"\u30AD\u30FC\u30D0\u30A4\u30F3\u30C9\u3092\u30EA\u30BB\u30C3\u30C8\u3059\u308B","confirm":"\u30AD\u30FC\u30D0\u30A4\u30F3\u30C9\u3092\u3059\u3079\u3066\u30EA\u30BB\u30C3\u30C8\u3057\u307E\u3059\u304B\uFF1F","confirmDescription":"\u30AD\u30FC\u30D0\u30A4\u30F3\u30C9\u306E\u30EA\u30BB\u30C3\u30C8\u65B9\u6CD5\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u3053\u306E\u64CD\u4F5C\u306F\u4FDD\u5B58\u3057\u306A\u3044\u3068\u5143\u306B\u623B\u305B\u307E\u305B\u3093\u3002","confirmButton":"\u30AD\u30FC\u30D0\u30A4\u30F3\u30C9\u3092\u30EA\u30BB\u30C3\u30C8\u3059\u308B","defaultOption":"\u73FE\u5728\u306E\u8A00\u8A9E\u306E\u30C7\u30D5\u30A9\u30EB\u30C8\u5024\u306B\u30EA\u30BB\u30C3\u30C8\u3057\u307E\u3059","emptyOption":"\u30EA\u30BB\u30C3\u30C8\u3057\u3066\u7A7A\u306B\u3059\u308B\uFF08\u3059\u3079\u3066\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u30AF\u30EA\u30A2\u3059\u308B\uFF09"}},"talkback":{"title":"\u30C8\u30FC\u30AF\u30D0\u30C3\u30AF","question":"Cephable \u306B\u4F55\u3092\u8A00\u3063\u3066\u3082\u3089\u3044\u305F\u3044\u3067\u3059\u304B?","description":"Cephable \u306B\u8A71\u3057\u304B\u3051\u308B\u305F\u3081\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8A2D\u5B9A\u3057\u307E\u3059\u3002\u8A71\u3057\u304B\u3051\u305F\u3044\u3055\u307E\u3056\u307E\u306A\u30D5\u30EC\u30FC\u30BA\u306B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u5272\u308A\u5F53\u3066\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","thenMacro":"\u3059\u308B\u3068\u3001Cephable \u306F\u3053\u3046\u8A00\u3044\u307E\u3059...","empty":"\u3053\u306E\u6761\u4EF6\u306B\u4E00\u81F4\u3059\u308B\u30C8\u30FC\u30AF\u30D0\u30C3\u30AF \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3042\u308A\u307E\u305B\u3093\u3002","add":"\u65B0\u3057\u3044\u30C8\u30FC\u30AF\u30D0\u30C3\u30AF\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8FFD\u52A0\u3059\u308B","remove":"\u30C8\u30FC\u30AF\u30D0\u30C3\u30AF\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u524A\u9664","edit":"\u30C8\u30FC\u30AF\u30D0\u30C3\u30AF\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u7DE8\u96C6\u3059\u308B","deprecatedNotice":"Talkback \u306F\u3001\u4E3B\u8981\u306A\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u76F4\u63A5\u7D71\u5408\u3055\u308C\u307E\u3057\u305F\u3002\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u306F\u3001\u66F4\u65B0\u304C\u5FC5\u8981\u306A\u53E4\u3044 Talkback \u30A4\u30D9\u30F3\u30C8\u304C\u3044\u304F\u3064\u304B\u3042\u308A\u307E\u3059\u3002"},"dictation":{"title":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3","question":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3 \u30E2\u30FC\u30C9\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u30D5\u30EC\u30FC\u30BA\u306F\u4F55\u3067\u3059\u304B?","thenMacro":"Cephable \u306F...","empty":"\u3053\u306E\u6761\u4EF6\u306B\u4E00\u81F4\u3059\u308B\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3042\u308A\u307E\u305B\u3093\u3002","type":"\u30BF\u30A4\u30D7","edit":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30D5\u30EC\u30FC\u30BA\u3092\u7DE8\u96C6\u3059\u308B","remove":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30D5\u30EC\u30FC\u30BA\u3092\u524A\u9664","add":"\u65B0\u3057\u3044\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30D5\u30EC\u30FC\u30BA\u3092\u8FFD\u52A0\u3059\u308B","on":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3","off":"\u30B3\u30DE\u30F3\u30C9","onboarding":{"tourLabel":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3","learn":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3 \u30E2\u30FC\u30C9\u3092\u4F7F\u7528\u3057\u3066\u3001\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u97F3\u58F0\u3092\u30C6\u30AD\u30B9\u30C8\u306B\u5909\u63DB\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","welcome":{"title":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3","description":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u4F7F\u3048\u3070\u3001\u81EA\u7136\u306A\u8A71\u3057\u65B9\u3067\u3001\u8A71\u3057\u306A\u304C\u3089\u5165\u529B\u3067\u304D\u307E\u3059\u3002\u307E\u308B\u3067\u3001\u3042\u306A\u305F\u306E\u8A71\u3059\u8A00\u8449\u3092\u3059\u3079\u3066\u5165\u529B\u3057\u3066\u304F\u308C\u308B\u30D1\u30FC\u30BD\u30CA\u30EB\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u304C\u3044\u308B\u304B\u306E\u3088\u3046\u3067\u3059\u3002"},"microphone":{"title":"\u30DE\u30A4\u30AF\u3092\u30AA\u30F3\u306B\u3059\u308B","description":"\u307E\u305A\u3001\u30DE\u30A4\u30AF\u3092\u30AA\u30F3\u306B\u3057\u307E\u3059\u3002Cephable\u30D1\u30CD\u30EB\u306E\u30DE\u30A4\u30AF\u5207\u308A\u66FF\u3048\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002"},"activate":{"title":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u3092\u958B\u59CB","description":"\u97F3\u58F0\u306F\u30B3\u30DE\u30F3\u30C9\u30E2\u30FC\u30C9\u3067\u8D77\u52D5\u3057\u307E\u3059\u3002\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u958B\u59CB\u3059\u308B\u306B\u306F\u3001\u300C\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u958B\u59CB\u300D\u3068\u8A00\u3046\u304B\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u305D\u308C\u3067\u306F\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u3092\u30AA\u30F3\u306B\u3057\u307E\u3057\u3087\u3046\u3002"},"speaking":{"title":"\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u307E\u305F\u306F\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u8AAD\u307F\u4E0A\u3052\u3092\u958B\u59CB\u3057\u307E\u3059","description":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u306F\u3001\u8A71\u3057\u305F\u5185\u5BB9\u3092\u30EA\u30A2\u30EB\u30BF\u30A4\u30E0\u3067\u5165\u529B\u3057\u307E\u3059\u3002\u30C6\u30AD\u30B9\u30C8\u30D5\u30A3\u30FC\u30EB\u30C9\u307E\u305F\u306F\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001\u8AAD\u307F\u4E0A\u3052\u3092\u958B\u59CB\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u4F8B\u3048\u3070\u3001\u300C\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u306E\u4F7F\u3044\u65B9\u306F\u6B21\u306E\u3068\u304A\u308A\u3067\u3059\u300D\u3068\u767A\u58F0\u3057\u307E\u3059\u3002"},"pauseResume":{"title":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u306E\u4E00\u6642\u505C\u6B62","description":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u505C\u6B62\u305B\u305A\u306B\u4F11\u61A9\u3057\u305F\u3044\u5834\u5408\u306F\u3001\u300C\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u4E00\u6642\u505C\u6B62\u300D\u3068\u767A\u58F0\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u300C\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u958B\u59CB\u300D\u3068\u767A\u58F0\u3059\u308C\u3070\u3044\u3064\u3067\u3082\u518D\u958B\u3067\u304D\u307E\u3059\u3002\u3053\u306E\u6A5F\u80FD\u306F\u3001\u5E38\u6642\u30AA\u30F3\u306E\u30B0\u30ED\u30FC\u30D0\u30EB\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30C7\u30D0\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u3055\u3089\u306B\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3067\u304D\u307E\u3059\u3002"},"stop":{"title":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u3084\u3081\u308B","description":"\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u623B\u308A\u305F\u3044\u3067\u3059\u304B\uFF1F\u300C\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u505C\u6B62\u300D\u3068\u8A00\u3046\u3060\u3051\u3067\u3059\u3002\u3053\u308C\u3067\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u304C\u505C\u6B62\u3057\u3001\u30B3\u30DE\u30F3\u30C9\u30E2\u30FC\u30C9\u306B\u623B\u308A\u307E\u3059\u3002\u300C\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u958B\u59CB\u300D\u3068\u8A00\u3048\u3070\u3044\u3064\u3067\u3082\u518D\u958B\u3067\u304D\u307E\u3059\u3002"},"complete":{"title":"\u304A\u3081\u3067\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01","description":"\u3053\u308C\u3067\u5B8C\u4E86\u3067\u3059\uFF01\u97F3\u58F0\u5165\u529B\u3001\u4E00\u6642\u505C\u6B62\u3001\u518D\u958B\u3001\u305D\u3057\u3066\u97F3\u58F0\u5165\u529B\u30E2\u30FC\u30C9\u3068\u30B3\u30DE\u30F3\u30C9\u30E2\u30FC\u30C9\u306E\u5207\u308A\u66FF\u3048\u304C\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002\u97F3\u58F0\u5165\u529B\u306F\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u5165\u529B\u3092\u53EF\u80FD\u306B\u3059\u308B\u5F37\u529B\u306A\u30C4\u30FC\u30EB\u3067\u3059\u3002\u30E1\u30FC\u30EB\u3084\u6587\u66F8\u306E\u4F5C\u6210\u306A\u3069\u3001\u97F3\u58F0\u5165\u529B\u304C\u5FC5\u8981\u306A\u3042\u3089\u3086\u308B\u4F5C\u696D\u306B\u304A\u4F7F\u3044\u3044\u305F\u3060\u3051\u307E\u3059\u3002"}},"description":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u4F7F\u3048\u3070\u3001\u81EA\u7136\u306B\u8A71\u3057\u306A\u304C\u3089\u3001\u8A71\u3057\u306A\u304C\u3089\u5165\u529B\u3067\u304D\u307E\u3059\u3002\u307E\u308B\u3067\u3001\u3042\u306A\u305F\u306E\u8A71\u3059\u8A00\u8449\u3092\u3059\u3079\u3066\u5165\u529B\u3057\u3066\u304F\u308C\u308B\u30D1\u30FC\u30BD\u30CA\u30EB\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u304C\u3044\u308B\u304B\u306E\u3088\u3046\u3067\u3059\u3002"},"face":{"title":"\u8868\u60C5","titlePlural":"\u8868\u60C5","try":"\u8868\u60C5\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8A66\u3059","question":"\u3069\u306E\u3088\u3046\u306A\u8868\u60C5\u3092\u4F7F\u3044\u305F\u3044\u3067\u3059\u304B?","descriptionShort":"\u3055\u307E\u3056\u307E\u306A\u9854\u306E\u52D5\u304D\u3092\u4F7F\u7528\u3057\u3066\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u5F37\u5316\u3057\u307E\u3059\u3002","description":"\u8868\u60C5\u306F\u8868\u60C5\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u4E00\u90E8\u3067\u3059\u3002\u8868\u60C5\u3092\u69D8\u3005\u306A\u52D5\u304D\u3067\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u304D\u307E\u3059\u3002\u7709\u6BDB\u3084\u53E3\u306E\u52D5\u304D\u306A\u3069\u3001\u69D8\u3005\u306A\u8868\u60C5\u3092\u4F5C\u308A\u51FA\u3059\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"},"other":{"title":"\u4ED6\u306E","titlePlural":"\u305D\u306E\u4ED6\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","label":"\u305D\u306E\u4ED6\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","placeholder":"\u305D\u306E\u4ED6\u306E\u5B9F\u9A13\u30B3\u30DE\u30F3\u30C9","question":"\u3069\u306E\u3088\u3046\u306A\u8FFD\u52A0\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3057\u307E\u3059\u304B\uFF1F\u3053\u308C\u3089\u306F\u901A\u5E38\u3001\u4ED6\u306E\u30AB\u30C6\u30B4\u30EA\u306B\u5F53\u3066\u306F\u307E\u3089\u306A\u3044Cephable\u4EE5\u5916\u306E\u63A5\u7D9A\u3067\u4F7F\u7528\u3055\u308C\u307E\u3059\u3002\u307E\u305F\u3001\u6307\u5B9A\u3055\u308C\u305F\u5358\u8A9E\u307E\u305F\u306F\u30D5\u30EC\u30FC\u30BA\u3092\u8A71\u3059\u3068\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u3057\u3066\u6A5F\u80FD\u3059\u308B\u5834\u5408\u3082\u3042\u308A\u307E\u3059\u3002\u6CE8\uFF1A\u3053\u308C\u3089\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u8A66\u9A13\u6BB5\u968E\u3067\u3042\u308A\u3001\u5B8C\u5168\u306B\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u306A\u3044\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002","description":"\u305D\u306E\u4ED6\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u8A66\u9A13\u6BB5\u968E\u3067\u3042\u308A\u3001\u5B8C\u5168\u306B\u306F\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u306A\u3044\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002Cephable\u4EE5\u5916\u306E\u63A5\u7D9A\u3001\u307E\u305F\u306F\u6307\u5B9A\u3055\u308C\u305F\u5358\u8A9E\u3084\u30D5\u30EC\u30FC\u30BA\u3092\u8A71\u3059\u969B\u306E\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u3057\u3066\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002"},"support":{"title":"\u30B5\u30DD\u30FC\u30C8","profiles":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u6982\u8981","question":"\u307E\u3060\u5FC5\u8981\u306A\u3082\u306E\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u304B?","more":"Cephable.com \u3067\u30B9\u30C6\u30C3\u30D7\u30D0\u30A4\u30B9\u30C6\u30C3\u30D7\u306E\u30AC\u30A4\u30C9\u3001\u30C1\u30E5\u30FC\u30C8\u30EA\u30A2\u30EB\u3001\u30D3\u30C7\u30AA\u306A\u3069\u306E\u8A73\u7D30\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002"},"community":{"title":"\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u306B\u53C2\u52A0\u3059\u308B","description":"\u30B5\u30DD\u30FC\u30C8\u3092\u53D7\u3051\u305F\u308A\u3001\u30A2\u30A4\u30C7\u30A2\u3092\u5171\u6709\u3057\u305F\u308A\u3001Cephable \u306E\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u306E\u30E1\u30F3\u30D0\u30FC\u306B\u306A\u3063\u305F\u308A\u3067\u304D\u307E\u3059\u3002","discord":"Discord\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3","facebook":"Facebook\u30B0\u30EB\u30FC\u30D7"},"resources":{"title":"\u5F79\u7ACB\u3064\u30EA\u30BD\u30FC\u30B9","description":"Cephable \u306E\u7279\u5FB4\u3068\u6A5F\u80FD\u306B\u95A2\u3059\u308B\u8CEA\u554F\u3078\u306E\u56DE\u7B54\u3092\u898B\u3064\u3051\u307E\u3059\u3002","guides":"\u30B9\u30C6\u30C3\u30D7\u30D0\u30A4\u30B9\u30C6\u30C3\u30D7\u30AC\u30A4\u30C9"},"feedback":{"title":"\u30D5\u30A3\u30FC\u30C9\u30D0\u30C3\u30AF","description":"Cephable \u306E\u4F7F\u7528\u7D4C\u9A13\u306B\u3064\u3044\u3066\u6559\u3048\u3066\u304F\u3060\u3055\u3044\u3002","contact":"\u304A\u554F\u3044\u5408\u308F\u305B","feature":"\u6A5F\u80FD\u3092\u63D0\u6848\u3059\u308B","bug":"\u554F\u984C\u3092\u5831\u544A\u3059\u308B"},"settings":{"title":"\u8A2D\u5B9A","orgTitle":"{{ value }} \u8A2D\u5B9A","general":"\u4E00\u822C\u7684\u306A\u30A2\u30D7\u30EA\u8A2D\u5B9A","description":"\u3053\u308C\u306F\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u5FAE\u8ABF\u6574\u3057\u3066\u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3059\u308B\u305F\u3081\u306E\u30AD\u30E3\u30F3\u30D0\u30B9\u3067\u3059\u3002"},"account":{"title":"\u30A2\u30AB\u30A6\u30F3\u30C8","menu":"\u30E6\u30FC\u30B6\u30FC\u30E1\u30CB\u30E5\u30FC","settings":"\u30A2\u30AB\u30A6\u30F3\u30C8\u8A2D\u5B9A","description":"Cephable \u3068\u306E\u63A5\u7D9A\u3092\u7DAD\u6301\u3059\u308B\u306B\u306F\u3001\u91CD\u8981\u306A\u60C5\u5831\u3092\u66F4\u65B0\u3057\u3066\u304F\u3060\u3055\u3044\u3002","usernameLabel":"\u30E6\u30FC\u30B6\u30FC\u540D:","emailLabel":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9:","password":{"change":"\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5909\u66F4\u3059\u308B","description":"\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u5B89\u5168\u306B\u4FDD\u3064\u305F\u3081\u306B\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u66F4\u65B0\u3057\u3066\u304F\u3060\u3055\u3044\u3002","old":"\u4EE5\u524D\u306E\u30D1\u30B9\u30EF\u30FC\u30C9","current":"\u73FE\u5728\u306E\u30D1\u30B9\u30EF\u30FC\u30C9","new":"\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9","desired":"\u5E0C\u671B\u3059\u308B\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9","confirm":"\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u78BA\u8A8D","update":"\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u66F4\u65B0"},"isEmailVerified":{"title":"\u96FB\u5B50\u30E1\u30FC\u30EB\u306F\u78BA\u8A8D\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002","description":"\u3042\u306A\u305F\u306E\u30E1\u30FC\u30EB\u306F\u78BA\u8A8D\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u78BA\u8A8D\u30EA\u30F3\u30AF\u304C\u8A18\u8F09\u3055\u308C\u305F\u30E1\u30FC\u30EB\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","resend":"\u30E1\u30FC\u30EB\u3092\u518D\u9001\u4FE1","success":"\u65B0\u3057\u3044\u78BA\u8A8D\u30E1\u30FC\u30EB\u3092\u9001\u4FE1\u3057\u307E\u3057\u305F\u3002","error":"\u78BA\u8A8D\u30E1\u30FC\u30EB\u306E\u9001\u4FE1\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","org":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u78BA\u8A8D\u304C\u307E\u3060\u5B8C\u4E86\u3057\u3066\u3044\u307E\u305B\u3093\u3002\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u8A73\u7D30\u306B\u30A2\u30AF\u30BB\u30B9\u3059\u308B\u306B\u306F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u304C\u5FC5\u8981\u3067\u3059\u3002\u78BA\u8A8D\u30EA\u30F3\u30AF\u304C\u8A18\u8F09\u3055\u308C\u305F\u30E1\u30FC\u30EB\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002","titleAlt":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044","descriptionLong":"Cephable\u3078\u3088\u3046\u3053\u305D\uFF01{{email}}\u306B\u78BA\u8A8D\u30E1\u30FC\u30EB\u3092\u9001\u4FE1\u3057\u307E\u3057\u305F\u3002\u53D7\u4FE1\u30C8\u30EC\u30A4\u307E\u305F\u306F\u8FF7\u60D1\u30E1\u30FC\u30EB\u30D5\u30A9\u30EB\u30C0\u3092\u3054\u78BA\u8A8D\u306E\u4E0A\u3001\u30EA\u30F3\u30AF\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30E1\u30FC\u30EB\u304C\u898B\u3064\u304B\u3089\u306A\u3044\u5834\u5408\u306F\u3001\u78BA\u8A8D\u30E1\u30FC\u30EB\u3092\u518D\u9001\u4FE1\u3067\u304D\u307E\u3059\u3002","appBlock":"\u3082\u3046\u3059\u3050\u5B8C\u4E86\u3067\u3059\uFF01\u78BA\u8A8D\u30E1\u30FC\u30EB\u3092{{email}}\u306B\u9001\u4FE1\u3057\u307E\u3057\u305F\u3002\u53D7\u4FE1\u30C8\u30EC\u30A4\u3092\u3054\u78BA\u8A8D\u306E\u4E0A\u3001\u30EA\u30F3\u30AF\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002\u30E1\u30FC\u30EB\u304C\u898B\u3064\u304B\u3089\u306A\u3044\u5834\u5408\u306F\u3001\u8FF7\u60D1\u30E1\u30FC\u30EB\u30D5\u30A9\u30EB\u30C0\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"},"signout":{"title":"\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8","question":"\u672C\u5F53\u306B\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8\u3057\u307E\u3059\u304B?","confirm":"\u306F\u3044\u3001\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8\u3057\u307E\u3059","warn":{"title":"\u30ED\u30B0\u30A2\u30A6\u30C8\u3055\u308C\u307E\u3059\u3002","description":"\u3057\u3070\u3089\u304F\u64CD\u4F5C\u304C\u884C\u308F\u308C\u3066\u3044\u306A\u3044\u3088\u3046\u3067\u3059\u3002\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u4E0A\u306E\u7406\u7531\u304B\u3089\u3001XX \u79D2\u5F8C\u306B\u30ED\u30B0\u30A2\u30A6\u30C8\u3057\u307E\u3059\u3002\u30ED\u30B0\u30A4\u30F3\u3057\u305F\u307E\u307E\u306B\u3057\u305F\u3044\u5834\u5408\u306F\u3001\u4E0B\u306E\u300C\u30ED\u30B0\u30A4\u30F3\u3057\u305F\u307E\u307E\u306B\u3059\u308B\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044\u3002","confirm":"\u30ED\u30B0\u30A4\u30F3\u3057\u305F\u307E\u307E\u306B\u3059\u308B","cancel":"\u4ECA\u3059\u3050\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8"},"description":"\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8\u3059\u308B\u3068\u3001\u3053\u306E\u63A5\u7D9A\u306F\u30A2\u30AB\u30A6\u30F3\u30C8\u304B\u3089\u524A\u9664\u3055\u308C\u3001Companion \u30A2\u30D7\u30EA\u3084\u4ED6\u306E\u63A5\u7D9A\u304B\u3089\u306F\u8868\u793A\u3055\u308C\u306A\u304F\u306A\u308A\u307E\u3059\u3002","confirmDescription":"\u30ED\u30B0\u30A2\u30A6\u30C8\u3057\u3066\u3053\u306E\u63A5\u7D9A\u3092\u524A\u9664\u3057\u307E\u3059"},"marketing":{"title":"\u30E1\u30FC\u30EB\u8A2D\u5B9A","description":"Cephable \u304B\u3089\u306E\u66F4\u65B0\u60C5\u5831\u3084\u30CB\u30E5\u30FC\u30B9\u3092\u53D7\u3051\u53D6\u308B\u306B\u306F\u3001\u96FB\u5B50\u30E1\u30FC\u30EB\u306E\u8A2D\u5B9A\u3092\u66F4\u65B0\u3057\u3066\u304F\u3060\u3055\u3044\u3002","marketing":"\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0\u30E1\u30FC\u30EB","optIn":"Cephable \u4F53\u9A13\u3092\u5411\u4E0A\u3055\u305B\u308B\u305F\u3081\u306E\u30C1\u30E5\u30FC\u30C8\u30EA\u30A2\u30EB\u3001\u30D2\u30F3\u30C8\u3001\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u3001\u30CB\u30E5\u30FC\u30B9\u30EC\u30BF\u30FC\u3092\u53D7\u3051\u53D6\u308A\u305F\u3044"},"error":{"save":"\u30A2\u30AB\u30A6\u30F3\u30C8\u8A2D\u5B9A\u306E\u4FDD\u5B58\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","password":"\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u66F4\u65B0\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","signout":"\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","old":"\u53E4\u3044\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u5FC5\u8981\u3067\u3059\u3002","new":"\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u5FC5\u8981\u3067\u3059\u3002","match":"\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u4E00\u81F4\u3057\u307E\u305B\u3093\u3002","marketing":"\u96FB\u5B50\u30E1\u30FC\u30EB\u8A2D\u5B9A\u306E\u66F4\u65B0\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","userPreferences":"\u30E6\u30FC\u30B6\u30FC\u8A2D\u5B9A\u306E\u4FDD\u5B58\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002"},"success":{"save":"\u30A2\u30AB\u30A6\u30F3\u30C8\u8A2D\u5B9A\u304C\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F\u3002","password":"\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002","marketing":"\u96FB\u5B50\u30E1\u30FC\u30EB\u306E\u8A2D\u5B9A\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002","userPreferences":"\u30E6\u30FC\u30B6\u30FC\u8A2D\u5B9A\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002"},"userPreferences":{"title":"\u30E6\u30FC\u30B6\u30FC\u8A2D\u5B9A","description":"\u8A2D\u5B9A\u3092\u66F4\u65B0\u3057\u3066\u3001\u81EA\u5206\u306B\u5408\u3063\u305F Cephable \u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u5B9F\u73FE\u3057\u3066\u304F\u3060\u3055\u3044\u3002","warningOptOut":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4FDD\u5B58\u307E\u305F\u306F\u66F4\u65B0\u3059\u308B\u3068\u304D\u306B\u8B66\u544A\u3092\u975E\u8868\u793A\u306B\u3059\u308B","enableTranscribeTask":"Cephable\u30D1\u30CD\u30EB\u3067\u5B9F\u9A13\u7684\u306A\u30D5\u30A1\u30A4\u30EB\u30C8\u30E9\u30F3\u30B9\u30AF\u30EA\u30D7\u30BF\u30FC\u30BF\u30B9\u30AF\u3092\u6709\u52B9\u306B\u3059\u308B","enableClickByName":"Windows\u306E\u307F\u3002\u753B\u9762\u4E0A\u306E\u4F55\u304B\u306E\u540D\u524D\u3092\u300C\u30BF\u30C3\u30D7\u300D\u3059\u308B\u6A5F\u80FD\u3092\u8A66\u9A13\u7684\u306B\u6709\u52B9\u306B\u3057\u307E\u3059\u3002\u4F8B\u3048\u3070\u3001\u300C\u4FDD\u5B58\u3092\u30BF\u30C3\u30D7\u300D\u3059\u308B\u3068\u300C\u4FDD\u5B58\u300D\u3068\u3044\u3046\u30DC\u30BF\u30F3\u304C\u30AF\u30EA\u30C3\u30AF\u3055\u308C\u307E\u3059\u3002","enableGamepadSupport":"\u30ED\u30FC\u30AB\u30EB\u30C9\u30E9\u30A4\u30D0\u30FC\u3068Xbox\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30A8\u30DF\u30E5\u30EC\u30FC\u30B7\u30E7\u30F3\u306E\u30B2\u30FC\u30E0\u30D1\u30C3\u30C9\u30B5\u30DD\u30FC\u30C8\u3092\u6709\u52B9\u306B\u3059\u308B","enableMetrics":"\u30D1\u30D5\u30A9\u30FC\u30DE\u30F3\u30B9\u30C6\u30B9\u30C8\u306E\u305F\u3081\u306B\u4F7F\u7528\u72B6\u6CC1\u30E1\u30C8\u30EA\u30AF\u30B9\u306E\u51FA\u529B\u3092\u6709\u52B9\u306B\u3057\u307E\u3059\u3002Cephable\u30D1\u30CD\u30EB\u304B\u3089\u30ED\u30B0\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002"},"delete":{"title":"\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664","description":"\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u5B8C\u5168\u306B\u524A\u9664\u3057\u3001\u500B\u4EBA\u60C5\u5831\u3078\u306E\u53C2\u7167\u3092\u3059\u3079\u3066\u524A\u9664\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664\u3059\u308B\u3068\u3001\u63A5\u7D9A\u304C\u524A\u9664\u3055\u308C\u3001\u6A5F\u80FD\u3057\u306A\u304F\u306A\u308A\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u767B\u9332\u3055\u308C\u306A\u304F\u306A\u308A\u307E\u3059\u3002\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u3059\u3079\u3066\u306E\u8A2D\u5B9A\u3082\u5931\u308F\u308C\u307E\u3059\u3002\u3053\u306E\u30D7\u30ED\u30BB\u30B9\u306F\u5143\u306B\u623B\u305B\u307E\u305B\u3093\u3002","button":"\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u5B8C\u5168\u306B\u524A\u9664\u3059\u308B","confirmation":"\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B?","note":"\u3053\u306E\u64CD\u4F5C\u306F\u5143\u306B\u623B\u305B\u307E\u305B\u3093\u3002","confirm":"\u306F\u3044\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664\u3057\u307E\u3059"}},"license":{"trial":{"subtitle":"{{count}} \u4EBA\u306E\u540C\u50DA\u3092\u62DB\u5F85\u3057\u3066\u4E00\u7DD2\u306B Cephable \u3092\u8A66\u3059\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","noUsersSubtitle":"\u8A66\u7528\u7248\u306E\u30E6\u30FC\u30B6\u30FC\u306F\u6B8B\u3063\u3066\u3044\u307E\u305B\u3093\u3002\u30E6\u30FC\u30B6\u30FC\u3092\u8FFD\u52A0\u3059\u308B\u306B\u306F\u3001\u6709\u6599\u30E9\u30A4\u30BB\u30F3\u30B9\u306B\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002","expired":{"user":"{{productName}} \u3078\u306E\u7121\u6599\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u306F {{date}} \u306B\u671F\u9650\u5207\u308C\u3068\u306A\u308A\u307E\u3059\u3002\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u306B\u306F\u3001\u7D44\u7E54\u306E\u7BA1\u7406\u8005\uFF08{{admin}}\uFF09\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002","userLong":"{{productName}}\u3078\u306E\u7121\u6599\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u3066\u3044\u308B\u3088\u3046\u3067\u3059\u3002\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u306B\u306F\u3001\u7D44\u7E54\u306E\u7BA1\u7406\u8005\uFF08{{admin}}\uFF09\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002","admin":"{{productName}} \u3078\u306E\u7121\u6599\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u306F {{date}} \u306B\u671F\u9650\u5207\u308C\u3068\u306A\u308A\u307E\u3059\u3002","adminLong":"{{productName}}\u3078\u306E\u7121\u6599\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u305F\u3088\u3046\u3067\u3059\u3002\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u3068\u3001Cephable Basic\u3067\u306F\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u306A\u3044\u9AD8\u5EA6\u306A\u6A5F\u80FD\u3092\u5F15\u304D\u7D9A\u304D\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u3059\u3002"},"start":"\u7121\u6599\u30C8\u30E9\u30A4\u30A2\u30EB\u3092\u59CB\u3081\u308B","title":{"single":"{{productName}} \u306B\u7121\u6599\u3067\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3055\u308C\u307E\u3057\u305F\u3002\u6B8B\u308A {{days}} \u65E5\u3067\u3059","multiple":"{{organization}} \u306F\u6B8B\u308A {{days}} \u65E5\u9593\u306E\u7121\u6599\u30C8\u30E9\u30A4\u30A2\u30EB\u4E2D\u3067\u3059"},"upgrade":"\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u3068\u3001\u5F37\u5316\u3055\u308C\u305F\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3001AI \u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8 \u30BF\u30B9\u30AF\u3001\u591A\u6570\u306E\u4E8B\u524D\u69CB\u7BC9\u6E08\u307F\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306A\u3069\u306E\u6A5F\u80FD\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u304C\u7DAD\u6301\u3055\u308C\u307E\u3059\u3002"},"key":{"title":"\u30E9\u30A4\u30BB\u30F3\u30B9\u30AD\u30FC","titlePlural":"\u30E9\u30A4\u30BB\u30F3\u30B9\u30AD\u30FC","details":"\u30E9\u30A4\u30BB\u30F3\u30B9\u30AD\u30FC\u306E\u8A73\u7D30","description":"\u30E9\u30A4\u30BB\u30F3\u30B9 \u30AD\u30FC\u306F\u3001Cephable Professional\u3001Education\u3001\u307E\u305F\u306F Developer \u6A5F\u80FD\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u8A31\u53EF\u3059\u308B\u305F\u3081\u306B\u4F7F\u7528\u3055\u308C\u308B\u4E00\u610F\u306E\u8B58\u5225\u5B50\u3067\u3059\u3002","assigned":"\u4F7F\u7528\u65E5: {{date}}","expires":"\u6709\u52B9\u671F\u9650: {{date}}","assign":"\u65B0\u3057\u3044\u7D44\u7E54\u306B\u30AD\u30FC\u3092\u5272\u308A\u5F53\u3066\u308B","error":"\u30E9\u30A4\u30BB\u30F3\u30B9 \u30AD\u30FC\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","empty":{"title":"\u30E9\u30A4\u30BB\u30F3\u30B9 \u30AD\u30FC\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002","description":"\u3053\u306E\u6761\u4EF6\u306B\u4E00\u81F4\u3059\u308B\u30E9\u30A4\u30BB\u30F3\u30B9 \u30AD\u30FC\u304C\u306A\u3044\u3088\u3046\u3067\u3059\u3002\u307E\u305F\u306F\u3001\u30E9\u30A4\u30BB\u30F3\u30B9 \u30AD\u30FC\u3092\u307E\u3060\u8CFC\u5165\u3057\u3066\u3044\u307E\u305B\u3093\u3002"},"product":{"title":"\u8CFC\u5165","titleLong":"\u30E9\u30A4\u30BB\u30F3\u30B9\u30AD\u30FC\u3092\u8CFC\u5165\u3059\u308B","description":"\u30E9\u30A4\u30BB\u30F3\u30B9 \u30AD\u30FC\u3092\u8CFC\u5165\u3057\u3066\u3001Cephable \u306E\u6F5C\u5728\u80FD\u529B\u3092\u6700\u5927\u9650\u306B\u5F15\u304D\u51FA\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u5229\u7528\u53EF\u80FD\u306A\u3055\u307E\u3056\u307E\u306A\u30D7\u30E9\u30F3\u3068\u4FA1\u683C\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002","action":"\u4ECA\u3059\u3050\u8CFC\u5165","empty":{"title":"\u5546\u54C1\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002","description":"\u88FD\u54C1\u304C\u306A\u3044\u3088\u3046\u3067\u3059\u3002\u3053\u306E\u554F\u984C\u3092\u89E3\u6C7A\u3059\u308B\u306B\u306F\u3001\u5F0A\u793E\u306E\u55B6\u696D\u30C1\u30FC\u30E0\u307E\u305F\u306F\u62C5\u5F53\u8005\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002"},"yearly":"\u5E74\u6255\u3044","years":"{{value}} \u5E74\u3054\u3068\u306B\u8ACB\u6C42\u3055\u308C\u307E\u3059","days":"{{value}} \u65E5\u3054\u3068\u306B\u8ACB\u6C42\u3055\u308C\u307E\u3059","Subscription":{"title":"\u30B5\u30D6\u30B9\u30AF\u30EA\u30D7\u30B7\u30E7\u30F3"},"MeteredConsumption":{"title":"\u5F93\u91CF\u5236\u6D88\u8CBB"},"PayDown":{"title":"\u8FD4\u6E08\u3059\u308B"},"OneTime":{"title":"\u4E00\u5EA6"}}},"upgrade":{"professional":"Cephable\u30D7\u30ED\u30D5\u30A7\u30C3\u30B7\u30E7\u30CA\u30EB\u30E9\u30A4\u30BB\u30F3\u30B9\u3078\u306E\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9","generic":{"title":"Cephable\u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9","description":"Cephable \u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u306F\u3001\u8077\u5834\u3084\u5B66\u6821\u3067\u306E\u5546\u7528\u5229\u7528\u3084\u30CD\u30A4\u30C6\u30A3\u30D6 \u30BD\u30EA\u30E5\u30FC\u30B7\u30E7\u30F3\u3078\u306E\u7D71\u5408\u306B\u9069\u3057\u305F\u3055\u307E\u3056\u307E\u306A\u88FD\u54C1\u3092\u63D0\u4F9B\u3057\u307E\u3059\u3002"},"fallback":{"title":"\u8ACB\u6C42\u30DD\u30FC\u30BF\u30EB\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F","description":"\u8ACB\u6C42\u30DD\u30FC\u30BF\u30EB\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3002\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3092\u7D9A\u884C\u3059\u308B\u306B\u306F\u3001\u4E0B\u306E\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066 sales@cephable.com \u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002"}},"required":{"title":"Cephable\u30D7\u30ED\u30D5\u30A7\u30C3\u30B7\u30E7\u30CA\u30EB\u30E9\u30A4\u30BB\u30F3\u30B9\u304C\u5FC5\u8981\u3067\u3059","description":"Cephable Basic \u3092\u3054\u5229\u7528\u306E\u3088\u3046\u3067\u3059\u304C\u3001\u3053\u308C\u306F Cephable \u306E\u5546\u7528\u5229\u7528\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u3066\u3044\u307E\u305B\u3093\u3002\u30A2\u30D7\u30EA\u3092\u5F15\u304D\u7D9A\u304D\u3054\u5229\u7528\u3044\u305F\u3060\u304F\u306B\u306F\u3001\u30D7\u30ED\u30D5\u30A7\u30C3\u30B7\u30E7\u30CA\u30EB\u30E9\u30A4\u30BB\u30F3\u30B9\u306B\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"activate":{"question":"\u3059\u3067\u306B\u30E9\u30A4\u30BB\u30F3\u30B9\u30AD\u30FC\u3092\u304A\u6301\u3061\u3067\u3059\u304B?","button":"\u6D3B\u6027\u5316","title":"\u30E9\u30A4\u30BB\u30F3\u30B9\u30AD\u30FC\u3092\u6709\u52B9\u5316","description":"Cephable \u3092\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u306B\u306F\u3001\u30E9\u30A4\u30BB\u30F3\u30B9 \u30AD\u30FC\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","descriptionLong":"Cephable \u3092\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u306B\u306F\u3001\u30E9\u30A4\u30BB\u30F3\u30B9 \u30AD\u30FC\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30E9\u30A4\u30BB\u30F3\u30B9 \u30AD\u30FC\u3092\u304A\u6301\u3061\u3067\u306A\u3044\u5834\u5408\u306F\u3001\u7121\u6599\u30C8\u30E9\u30A4\u30A2\u30EB\u3092\u958B\u59CB\u3059\u308B\u304B\u3001\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u8CFC\u5165\u3057\u3066\u304F\u3060\u3055\u3044\u3002","fieldLabel":"\u30E9\u30A4\u30BB\u30F3\u30B9\u30AD\u30FC","placeholder":"\u7FFB\u8A33\u8005","invalid":{"key":"\u7121\u52B9\u306A\u30AD\u30FC\u3067\u3059\u3002\u6B63\u3057\u3044\u30AD\u30FC\u3092\u5165\u529B\u3057\u305F\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","empty":{"key":"\u7121\u52B9\u306A\u30AD\u30FC\u3067\u3059\u3002\u5024\u3092\u5165\u529B\u3057\u305F\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","name":"\u7D44\u7E54\u540D\u304C\u7121\u52B9\u3067\u3059\u3002\u5024\u3092\u5165\u529B\u3057\u305F\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002"}},"success":"\u304A\u3081\u3067\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002\u30A2\u30AB\u30A6\u30F3\u30C8\u306F {{license}} \u306B\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3055\u308C\u307E\u3057\u305F\u3002"},"welcome":{"title":"{{license}} \u3078\u3088\u3046\u3053\u305D\u3002","description":"{{organization}} \u306B\u6B63\u5E38\u306B\u53C2\u52A0\u3057\u307E\u3057\u305F\u3002{{description}}"},"redirect":{"title":"\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8","description":"\u5916\u90E8\u306E\u8ACB\u6C42\u30DD\u30FC\u30BF\u30EB\u306B\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8\u3055\u308C\u307E\u3057\u305F\u3002\u30D6\u30E9\u30A6\u30B6\u306B\u65B0\u3057\u3044\u30BF\u30D6\u304C\u958B\u304D\u307E\u3059\u3002\u6570\u79D2\u4EE5\u5185\u306B\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8\u3055\u308C\u306A\u3044\u5834\u5408\u306F\u3001\u4E0B\u306E\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044\u3002","error":"\u8ACB\u6C42\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8\u30A8\u30E9\u30FC","external":"\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8\u3055\u308C\u307E\u3057\u305F\u3002\u30D6\u30E9\u30A6\u30B6\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"},"pro":{"tag":"\u30D7\u30ED","detail":"\u3053\u308C\u306FCephable Professional\u306E\u307F\u306E\u6A5F\u80FD\u3067\u3059","requiredDetail":"\u3053\u306E\u6A5F\u80FD\u306B\u306FCephable Professional\u30E9\u30A4\u30BB\u30F3\u30B9\u304C\u5FC5\u8981\u3067\u3059\u3002\u30A2\u30AB\u30A6\u30F3\u30C8\u8A2D\u5B9A\u3067\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u304B\u7121\u6599\u30C8\u30E9\u30A4\u30A2\u30EB\u3092\u958B\u59CB\u3067\u304D\u307E\u3059\u3002"},"titlePlural":"\u30E9\u30A4\u30BB\u30F3\u30B9"},"appSettings":{"description":"\u3053\u308C\u3089\u306E\u8A2D\u5B9A\u306F\u3053\u306E\u30A2\u30D7\u30EA\u306B\u306E\u307F\u9069\u7528\u3055\u308C\u307E\u3059\u3002\u5225\u306E\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u307E\u305F\u306F\u30E2\u30D0\u30A4\u30EB \u30C7\u30D0\u30A4\u30B9\u4E0A\u306E Cephable \u30A2\u30D7\u30EA\u306E\u8A2D\u5B9A\u3092\u5909\u66F4\u3059\u308B\u5834\u5408\u306F\u3001\u305D\u306E\u30A2\u30D7\u30EA\u3067\u8A2D\u5B9A\u3092\u7DE8\u96C6\u3057\u3066\u304F\u3060\u3055\u3044\u3002","autostart":{"title":"Cephable \u3092\u81EA\u52D5\u7684\u306B\u8D77\u52D5\u3059\u308B","description":"\u3053\u306E\u8A2D\u5B9A\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u30C7\u30D0\u30A4\u30B9\u306B\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u3068 Cephable \u30A2\u30D7\u30EA\u304C\u81EA\u52D5\u7684\u306B\u8D77\u52D5\u3057\u307E\u3059\u3002\u81EA\u52D5\u97F3\u58F0\u304A\u3088\u3073\u8868\u60C5\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3082\u8A2D\u5B9A\u3057\u3066\u3044\u308B\u5834\u5408\u306F\u3001\u305D\u308C\u3089\u3082\u3059\u3050\u306B\u8D77\u52D5\u3057\u307E\u3059\u3002","question":"Cephable \u30A2\u30D7\u30EA\u3092\u81EA\u52D5\u8D77\u52D5\u3057\u307E\u3059\u304B?"},"position":{"topLeft":"\u5DE6\u4E0A","top":"\u4E0A\u4E2D\u592E","topRight":"\u53F3\u4E0A","bottom":"\u4E0B\u4E2D\u592E","bottomLeft":"\u5DE6\u4E0B","bottomRight":"\u53F3\u4E0B","label":"\u30B3\u30DE\u30F3\u30C9\u30D5\u30A3\u30FC\u30C9\u4F4D\u7F6E\u3092\u9078\u629E","description":"\u30B3\u30DE\u30F3\u30C9 \u30D5\u30A3\u30FC\u30C9\u3092\u753B\u9762\u4E0A\u306E\u3069\u3053\u306B\u8868\u793A\u3059\u308B\u304B\u3092\u9078\u629E\u3057\u307E\u3059\u3002"},"micPosition":{"title":"\u30DE\u30A4\u30AF\u5165\u529B\u30A6\u30A3\u30F3\u30C9\u30A6\u306E\u4F4D\u7F6E","description":"\u97F3\u58F0\u3068\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u7528\u306E\u30DE\u30A4\u30AF \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u753B\u9762\u4E0A\u306E\u3069\u3053\u306B\u914D\u7F6E\u3059\u308B\u304B\u3092\u9078\u629E\u3057\u307E\u3059\u3002","label":"\u30DE\u30A4\u30AF\u5165\u529B\u30A6\u30A3\u30F3\u30C9\u30A6\u306E\u4F4D\u7F6E\u3092\u9078\u629E"},"cameraPosition":{"title":"\u30AB\u30E1\u30E9\u5165\u529B\u30A6\u30A3\u30F3\u30C9\u30A6\u306E\u4F4D\u7F6E","description":"\u9854\u3068\u982D\u306E\u52D5\u304D\u306E\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u753B\u9762\u4E0A\u306E\u3069\u3053\u306B\u914D\u7F6E\u3059\u308B\u304B\u3092\u9078\u629E\u3057\u307E\u3059\u3002","label":"\u30AB\u30E1\u30E9\u5165\u529B\u30A6\u30A3\u30F3\u30C9\u30A6\u306E\u4F4D\u7F6E\u3092\u9078\u629E"},"theme":{"title":"\u30C6\u30FC\u30DE","description":"\u3042\u306A\u305F\u306E\u30B9\u30BF\u30A4\u30EB\u306B\u5408\u3063\u305F\u30C6\u30FC\u30DE\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002","label":"\u30C6\u30FC\u30DE\u3092\u9078\u629E","light":"\u30E9\u30A4\u30C8","dark":"\u6697\u3044","system":"OS\u306E\u30B7\u30B9\u30C6\u30E0\u8A2D\u5B9A\u3092\u4F7F\u7528\u3059\u308B"},"overlay":{"title":"\u30B3\u30DE\u30F3\u30C9\u30D5\u30A3\u30FC\u30C9","description":"\u30B3\u30DE\u30F3\u30C9 \u30D5\u30A3\u30FC\u30C9\u306B\u306F\u3001\u4F7F\u7528\u3057\u3066\u3044\u308B\u3055\u307E\u3056\u307E\u306A\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u3001\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u306B\u9001\u4FE1\u3055\u308C\u305F\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002\u3053\u308C\u306F\u30AF\u30EA\u30C3\u30AF\u30B9\u30EB\u30FC\u3067\u3059\u304C\u3001\u5E38\u306B\u4ED6\u306E\u30A6\u30A3\u30F3\u30C9\u30A6\u3088\u308A\u3082\u624B\u524D\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002\u3053\u306E\u8A2D\u5B9A\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001Cephable \u30A2\u30D7\u30EA\u304C\u8868\u793A\u3055\u308C\u3001\u5E38\u306B\u4ED6\u306E\u30A6\u30A3\u30F3\u30C9\u30A6\u3084\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3088\u308A\u3082\u624B\u524D\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002","question":"\u30B3\u30DE\u30F3\u30C9\u30D5\u30A3\u30FC\u30C9\u3092\u8868\u793A\u3057\u307E\u3059\u304B?"},"transparent":{"title":"\u30B3\u30DE\u30F3\u30C9\u30D5\u30A3\u30FC\u30C9\u306E\u900F\u660E\u6027","description":"\u30C6\u30AD\u30B9\u30C8\u306E\u4E0D\u900F\u660E\u5EA6\u3092\u6C7A\u5B9A\u3057\u307E\u3059\u3002\u5024\u304C\u4F4E\u3044\u307B\u3069\u3001\u30D5\u30A3\u30FC\u30C9\u304C\u900F\u3051\u3066\u898B\u3048\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002"},"panelAutoHide":{"title":"\u30BB\u30D5\u30A1\u30D6\u30EB\u30D1\u30CD\u30EB\u306E\u81EA\u52D5\u975E\u8868\u793A","delay":"\u96A0\u308C\u308B\u524D\u306B\u9045\u308C\u308B","denominator":"\u79D2","time":"{{value}} \u79D2"},"title":"\u4E00\u822C\u7684\u306A\u30A2\u30D7\u30EA\u8A2D\u5B9A"},"input":{"title":"\u5165\u529B","titlePlural":"\u5165\u529B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","explore":"\u5165\u529B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8ABF\u3079\u308B","descriptionShort":"Cephable \u304C\u3088\u308A\u826F\u3044\u30C7\u30B8\u30BF\u30EB \u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u5B9F\u73FE\u3059\u308B\u305F\u3081\u306B\u4F7F\u7528\u3059\u308B\u3055\u307E\u3056\u307E\u306A\u5165\u529B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8ABF\u3079\u3066\u307F\u307E\u3057\u3087\u3046\u3002","typeLabel":"\u5165\u529B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u30BF\u30A4\u30D7","toolTip":"\u3053\u308C\u306F{{alt}}\u3092\u4F7F\u7528\u3057\u307E\u3059","remove":"\u5165\u529B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u524A\u9664","filter":"\u5165\u529B\u30BF\u30A4\u30D7\u3067\u30D5\u30A3\u30EB\u30BF\u30EA\u30F3\u30B0","select":"\u5165\u529B\u3092\u9078\u629E","question":"\u3069\u306E\u3088\u3046\u306A\u30BF\u30A4\u30D7\u306E\u5165\u529B\u3092\u4F7F\u7528\u3057\u307E\u3059\u304B?","add":"\u5165\u529B\u3092\u8FFD\u52A0","addMore":"\u5225\u306E\u5165\u529B\u3092\u8FFD\u52A0\u3059\u308B","removeItem":"\u30A2\u30A4\u30C6\u30E0 {{index}} \u3092\u524A\u9664","item":"\u30A2\u30A4\u30C6\u30E0 {{index}}: {{label}}","duplicate":"\u91CD\u8907\u3057\u305F\u30A2\u30A4\u30C6\u30E0\u306F\u8A31\u53EF\u3055\u308C\u307E\u305B\u3093\u3002","maximum":"\u8A31\u53EF\u3055\u308C\u308B\u30A2\u30A4\u30C6\u30E0\u306E\u6700\u5927\u6570\u306F {{maxItems}} \u500B\u3067\u3059\u3002","description":"\u5165\u529B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u306F\u3001\u30C7\u30D0\u30A4\u30B9\u3092\u64CD\u4F5C\u3059\u308B\u305F\u3081\u306E\u69D8\u3005\u306A\u65B9\u6CD5\u3092\u6307\u3057\u307E\u3059\u3002\u4F8B\u3048\u3070\u3001\u97F3\u58F0\u3001\u982D\u306E\u52D5\u304D\u3001\u8868\u60C5\u3001\u305D\u306E\u4ED6\u306E\u63A5\u7D9A\u306A\u3069\u3067\u3059\u3002\u8A73\u3057\u304F\u306F\u3001\u4EE5\u4E0B\u306E\u69D8\u3005\u306A\u5165\u529B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002"},"time":{"soon":"\u8FD1\u65E5\u516C\u958B","now":"\u4ECA","today":"\u4ECA\u65E5","yesterday":"\u6628\u65E5","minutesAgo":"{{count}} \u5206\u524D","minutesAgo_plural":"{{count}} \u5206\u524D","daysAgo":"{{count}}\u65E5\u524D","daysAgo_plural":"{{count}}\u65E5\u524D","monthsAgo":"{{count}} \u304B\u6708\u524D","monthsAgo_plural":"{{count}}\u304B\u6708\u524D","yearsAgo":"{{count}}\u5E74\u524D","yearsAgo_plural":"{{count}}\u5E74\u524D","minutesAhead":"{{count}}\u5206\u5F8C","todayAhead":"\u4ECA\u65E5\u9045\u304F","tomorrow":"\u660E\u65E5","daysAhead":"{{count}}\u65E5\u5F8C","monthsAhead":"{{count}}\u304B\u6708\u4EE5\u5185","yearsAhead":"{{count}}\u5E74"},"peripherals":{"empty":"\u5468\u8FBA\u6A5F\u5668\u304C\u691C\u51FA\u3055\u308C\u307E\u305B\u3093\u3067\u3057\u305F","switch":"\u30B9\u30A4\u30C3\u30C1","keyboard":"\u30AD\u30FC\u30DC\u30FC\u30C9","gamepad":"\u30B2\u30FC\u30E0\u30D1\u30C3\u30C9","companionApp":"\u30B3\u30F3\u30D1\u30CB\u30AA\u30F3\u30A2\u30D7\u30EA","available":"\u4F7F\u7528\u53EF\u80FD","error":"\u8A2D\u5B9A\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"camera":{"windowTitle":"\u30BB\u30D5\u30A1\u30D6\u30EB\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","title":"\u30AB\u30E1\u30E9","titlePlural":"\u30AB\u30E1\u30E9","settings":"\u30AB\u30E1\u30E9\u8A2D\u5B9A","start":"\u30AB\u30E1\u30E9\u3092\u8D77\u52D5","restart":"\u30AB\u30E1\u30E9\u3092\u518D\u8D77\u52D5","descriptionShort":"\u9854\u306E\u8868\u60C5\u3084\u982D\u306E\u52D5\u304D\u3092\u53EF\u80FD\u306B\u3057\u307E\u3059\u3002","description":"\u30AB\u30E1\u30E9\u3092\u4F7F\u7528\u3057\u3066\u3001\u9854\u306E\u8868\u60C5\u3084\u4F53\u306E\u30B8\u30A7\u30B9\u30C1\u30E3\u30FC\u3092\u3055\u307E\u3056\u307E\u306A\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u3057\u3066\u691C\u51FA\u3057\u307E\u3059\u3002","empty":"\u30AB\u30E1\u30E9\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002","search":"\u30AB\u30E1\u30E9\u540D\u3067\u691C\u7D22","loading":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8AAD\u307F\u8FBC\u3093\u3067\u3044\u307E\u3059...","error":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u4E88\u671F\u3057\u306A\u3044\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u30AB\u30E1\u30E9\u3092\u78BA\u8A8D\u3057\u3066\u3001\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","manage":{"title":"\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001\u30AB\u30E1\u30E9\u306E\u8A73\u7D30\u3092\u8868\u793A\u304A\u3088\u3073\u7BA1\u7406\u3067\u304D\u307E\u3059\u3002","description":""},"detected":{"face":"\u9854\u304C\u691C\u51FA\u3055\u308C\u307E\u3057\u305F\u3002","noFace":"\u9854\u304C\u691C\u51FA\u3055\u308C\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u30AB\u30E1\u30E9\u307E\u305F\u306F\u4F4D\u7F6E\u3092\u8ABF\u6574\u3057\u3066\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","command":"\u691C\u51FA: {{command}}"},"permission":{"title":"\u30AB\u30E1\u30E9\u306E\u8A31\u53EF\u304C\u5FC5\u8981\u3067\u3059","description":"\u9854\u3068\u4F53\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u306B\u306F\u3001Cephable \u306B\u30AB\u30E1\u30E9\u306E\u4F7F\u7528\u8A31\u53EF\u3092\u4E0E\u3048\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","button":"\u6A29\u9650\u8A2D\u5B9A\u3092\u958B\u304F","no":"\u30AB\u30E1\u30E9\u30A2\u30AF\u30BB\u30B9\u4E0D\u53EF","help":"Cephable \u306F\u3001\u8868\u60C5\u3084\u982D\u90E8\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u305F\u3081\u306B\u30AB\u30E1\u30E9\u306B\u30A2\u30AF\u30BB\u30B9\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002 <strong>[\u30B7\u30B9\u30C6\u30E0\u8A2D\u5B9A]</strong> > <strong>[\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC]</strong> > <strong>[\u30AB\u30E1\u30E9]</strong>\u306B\u79FB\u52D5\u3057\u3066\u3001Cephable \u304C\u30AB\u30E1\u30E9\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002"},"controls":{"startData":"\u9854\u30C7\u30FC\u30BF\u306E\u8A18\u9332\u3092\u958B\u59CB\u3057\u307E\u3057\u305F\u3002\u30AB\u30E1\u30E9 \u30A6\u30A3\u30F3\u30C9\u30A6\u3067\u30B7\u30E7\u30FC\u30C8\u30AB\u30C3\u30C8\u3092\u3082\u3046\u4E00\u5EA6\u62BC\u3059\u3068\u3001\u8A18\u9332\u304C\u505C\u6B62\u3057\u3001\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3055\u308C\u307E\u3059\u3002","downloadData":"\u9332\u753B\u3092\u505C\u6B62\u3057\u307E\u3057\u305F\u3002\u30C7\u30FC\u30BF\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u3044\u307E\u3059","paused":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4E00\u6642\u505C\u6B62\u3057\u307E\u3057\u305F\u3002","pause":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4E00\u6642\u505C\u6B62","resume":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u518D\u958B","resumed":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u518D\u958B\u3057\u307E\u3057\u305F\u3002","linesOn":"\u30D5\u30A7\u30A4\u30B9\u30E9\u30A4\u30F3\u3092\u30AA\u30F3\u306B\u3059\u308B","linesOff":"\u30D5\u30A7\u30A4\u30B9\u30E9\u30A4\u30F3\u3092\u6D88\u3059","linesToggle":"\u30D5\u30A7\u30A4\u30B9\u30E9\u30A4\u30F3\u306E\u63CF\u753B\u3092\u5207\u308A\u66FF\u3048\u308B","noDeviceTitle":"Cephable \u3067\u4F7F\u7528\u3067\u304D\u308B\u30AB\u30E1\u30E9\u304C\u691C\u51FA\u3055\u308C\u307E\u305B\u3093\u3067\u3057\u305F\u3002","noDeviceDescription":"\u30E2\u30D0\u30A4\u30EB\u30A2\u30D7\u30EA\u3068\u4E92\u63DB\u6027\u306E\u3042\u308B\u30AB\u30E1\u30E9\u3092\u63A5\u7D9A\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","noDeviceConnectedDescription":"\u30AB\u30E1\u30E9 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u30A4\u30F3\u30BF\u30FC\u30D5\u30A7\u30A4\u30B9\u306E\u30D7\u30EC\u30D3\u30E5\u30FC\u3068\u3057\u3066\u6A5F\u80FD\u3057\u307E\u3059\u3002\u30B9\u30C6\u30C3\u30D7\u306F\u6B63\u5E38\u306B\u5B9F\u884C\u3055\u308C\u307E\u305B\u3093\u3002\u30B3\u30DE\u30F3\u30C9\u3092\u958B\u59CB\u3059\u308B\u306B\u306F\u3001\u3053\u306E\u30B3\u30F3\u30D1\u30CB\u30AA\u30F3 \u30C7\u30D0\u30A4\u30B9\u3092\u5225\u306E\u30C7\u30D0\u30A4\u30B9\u306B\u63A5\u7D9A\u3057\u307E\u3059\u3002","lines":"\u30D5\u30A7\u30A4\u30B9\u30E9\u30A4\u30F3"},"switch":{"title":"\u30AB\u30E1\u30E9\u3092\u5207\u308A\u66FF\u3048\u308B","description":"\u9854\u3068\u4F53\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u4F7F\u7528\u3059\u308B\u5225\u306E\u30AB\u30E1\u30E9\u3092\u9078\u629E\u3057\u307E\u3059\u3002","select":"\u30AB\u30E1\u30E9\u3092\u9078\u629E","next":"\u6B21\u306E\u30AB\u30E1\u30E9","nextLong":"\u6B21\u306E\u30AB\u30E1\u30E9\u306B\u5207\u308A\u66FF\u3048\u308B","empty":"\u4ED6\u306E\u30AB\u30E1\u30E9\u306F\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002","search":"\u30AB\u30E1\u30E9\u540D\u3067\u691C\u7D22"},"baseline":{"title":"\u30D9\u30FC\u30B9\u30E9\u30A4\u30F3","description":"\u30D9\u30FC\u30B9\u30E9\u30A4\u30F3\u306F\u3001Cephable \u304C\u52D5\u304D\u3092\u5224\u65AD\u3059\u308B\u305F\u3081\u306B\u4F7F\u7528\u3059\u308B\u9854\u3068\u4F53\u306E\u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u4F4D\u7F6E\u3067\u3059\u3002\u3053\u3053\u3067\u30D9\u30FC\u30B9\u30E9\u30A4\u30F3\u3092\u66F4\u65B0\u304A\u3088\u3073\u30EA\u30BB\u30C3\u30C8\u3067\u304D\u307E\u3059\u3002","update":"\u30D9\u30FC\u30B9\u30E9\u30A4\u30F3\u306E\u66F4\u65B0","reset":"\u30D9\u30FC\u30B9\u30E9\u30A4\u30F3\u3092\u30EA\u30BB\u30C3\u30C8","updated":"\u30D9\u30FC\u30B9\u30E9\u30A4\u30F3\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F","tooltip":"\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001\u30D9\u30FC\u30B9\u30E9\u30A4\u30F3\u304C\u73FE\u5728\u306E\u4F11\u606F\u4F4D\u7F6E\u306B\u66F4\u65B0\u3055\u308C\u307E\u3059\u3002"},"edit":{"title":"\u30AB\u30E1\u30E9\u8A2D\u5B9A\u3092\u7DE8\u96C6\u3059\u308B","description":"\u30AB\u30E1\u30E9\u3092\u5FC5\u8981\u3068\u3059\u308B\u5165\u529B\u306E\u8A2D\u5B9A\u3092\u3001\u30CB\u30FC\u30BA\u306B\u5408\u308F\u305B\u3066\u8ABF\u6574\u3067\u304D\u307E\u3059\u3002","autoStart":{"title":"\u30AB\u30E1\u30E9\u3092\u81EA\u52D5\u7684\u306B\u8D77\u52D5","option":"\u30AB\u30E1\u30E9\u3068\u30D8\u30C3\u30C9/\u8868\u60C5\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u81EA\u52D5\u8D77\u52D5\u3057\u307E\u3059\u304B?","description":"\u3053\u306E\u8A2D\u5B9A\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u30A2\u30D7\u30EA\u8D77\u52D5\u6642\u306B\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u304C\u30AB\u30E1\u30E9\u3092\u8D77\u52D5\u3057\u3001\u8868\u60C5\u3084\u982D\u306E\u52D5\u304D\u3092\u64CD\u4F5C\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002\u30AA\u30D5\u306E\u5834\u5408\u306F\u3001\u63A5\u7D9A\u30DA\u30FC\u30B8\u3067\u300C\u30AB\u30E1\u30E9\u3092\u8D77\u52D5\u300D\u30DC\u30BF\u30F3\u3092\u30BF\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"head":{"title":"\u982D\u306E\u52D5\u304D\u306E\u611F\u5EA6","description":"\u611F\u5EA6\u306F\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u305F\u3081\u306B\u3069\u308C\u3060\u3051\u79FB\u52D5\u3059\u308B\u5FC5\u8981\u304C\u3042\u308B\u304B\u3092 Cephable \u306B\u4F1D\u3048\u307E\u3059\u3002\u5024\u304C\u5927\u304D\u3044\u307B\u3069 (\u30B9\u30E9\u30A4\u30C0\u30FC\u306E\u53F3\u7AEF)\u3001\u611F\u5EA6\u304C\u9AD8\u304F\u306A\u308A\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u305F\u3081\u306B\u5FC5\u8981\u306A\u79FB\u52D5\u304C\u5C11\u306A\u304F\u306A\u308A\u307E\u3059\u3002","tilt":{"title":"\u30D8\u30C3\u30C9\u30C6\u30A3\u30EB\u30C8\u611F\u5EA6","description":"\u3053\u308C\u3089\u306E\u5024\u306F\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u305F\u3081\u306B\u982D\u3092\u4E0A\u4E0B\u5DE6\u53F3\u306B\u3069\u308C\u3060\u3051\u50BE\u3051\u308B\u5FC5\u8981\u304C\u3042\u308B\u304B\u3092\u6C7A\u5B9A\u3057\u307E\u3059\u3002","up":"\u4E0A\u65B9\u5411\u50BE\u659C\u611F\u5EA6","down":"\u30C1\u30EB\u30C8\u30C0\u30A6\u30F3\u611F\u5EA6","left":"\u5DE6\u50BE\u659C\u611F\u5EA6","right":"\u53F3\u50BE\u304D\u611F\u5EA6","scaleHigh":"\u308F\u305A\u304B\u306B\u50BE\u304F","scaleLow":"\u5927\u304D\u306A\u50BE\u659C"},"turn":{"title":"\u30D8\u30C3\u30C9\u30BF\u30FC\u30F3\u611F\u5EA6","description":"\u3053\u308C\u3089\u306E\u5024\u306F\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u305F\u3081\u306B\u982D\u3092\u5DE6\u53F3\u306B\u3069\u308C\u3060\u3051\u56DE\u3059\u5FC5\u8981\u304C\u3042\u308B\u304B\u3092\u6C7A\u5B9A\u3057\u307E\u3059\u3002","left":"\u5DE6\u6298\u611F\u5EA6","right":"\u53F3\u6298\u611F\u5EA6","scaleHigh":"\u308F\u305A\u304B\u306B\u66F2\u304C\u308B","scaleLow":"\u5927\u30BF\u30FC\u30F3"},"lean":{"title":"\u30D8\u30C3\u30C9\u30EA\u30FC\u30F3\u611F\u5EA6","description":"\u3053\u308C\u3089\u306E\u5024\u306F\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u305F\u3081\u306B\u982D\u3092\u524D\u5F8C\u306B\u3069\u308C\u3060\u3051\u50BE\u3051\u308B\u5FC5\u8981\u304C\u3042\u308B\u304B\u3092\u6C7A\u5B9A\u3057\u307E\u3059\u3002","forward":"\u524D\u50BE\u611F\u5EA6","back":"\u30EA\u30FC\u30F3\u30D0\u30C3\u30AF\u611F\u5EA6","right":"\u53F3\u50BE\u304D\u611F\u5EA6","left":"\u5DE6\u50BE\u304D\u611F\u5EA6","scaleHigh":"\u308F\u305A\u304B\u306B\u50BE\u304F","scaleLow":"\u30E9\u30FC\u30B8\u30EA\u30FC\u30F3"},"duck":{"title":"\u30D8\u30C3\u30C9\u30C0\u30C3\u30AF/\u30E9\u30A4\u30BA\u611F\u5EA6","description":"\u3053\u308C\u3089\u306E\u5024\u306F\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u305F\u3081\u306B\u982D\u3092\u3069\u308C\u3060\u3051\u4E0B\u3052\u305F\u308A\u4E0A\u3052\u305F\u308A\u3059\u308B\u5FC5\u8981\u304C\u3042\u308B\u304B\u3092\u6C7A\u5B9A\u3057\u307E\u3059\u3002","down":"\u30C0\u30C3\u30AF\u30C0\u30A6\u30F3\u611F\u5EA6","up":"\u30E9\u30A4\u30BA\u30A2\u30C3\u30D7\u611F\u5EA6","scaleHigh":"\u308F\u305A\u304B\u306A\u5909\u5316","scaleLow":"\u5927\u304D\u306A\u5909\u5316"}},"face":{"title":"\u8868\u60C5\u306E\u654F\u611F\u3055","description":"\u611F\u5EA6\u306F\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u305F\u3081\u306B\u5FC5\u8981\u306A\u8868\u73FE\u3092\u3069\u306E\u7A0B\u5EA6\u8A87\u5F35\u3059\u308B\u304B\u3092 Cephable \u306B\u4F1D\u3048\u307E\u3059\u3002\u5024\u304C\u5927\u304D\u3044\u307B\u3069 (\u30B9\u30E9\u30A4\u30C0\u30FC\u306E\u53F3\u7AEF)\u3001\u611F\u5EA6\u304C\u9AD8\u304F\u306A\u308A\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u305F\u3081\u306B\u5FC5\u8981\u306A\u52D5\u304D\u304C\u5C11\u306A\u304F\u306A\u308A\u307E\u3059\u3002","eyebrow":{"title":"\u7709\u6BDB\u306E\u654F\u611F\u3055","description":"\u3053\u308C\u3089\u306E\u5024\u306F\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u305F\u3081\u306B\u7709\u6BDB\u3092\u3069\u306E\u304F\u3089\u3044\u4E0A\u3052\u305F\u308A\u4E0B\u3052\u305F\u308A\u3059\u308B\u5FC5\u8981\u304C\u3042\u308B\u304B\u3092\u6C7A\u5B9A\u3057\u307E\u3059\u3002","up":"\u7709\u6BDB\u306E\u611F\u5EA6\u3092\u9AD8\u3081\u308B","scaleHigh":"\u308F\u305A\u304B\u306B\u4E0A\u3052\u308B","scaleLow":"\u5927\u5E45\u306A\u5024\u4E0A\u3052"},"mouth":{"title":"\u53E3\u306E\u654F\u611F\u3055","description":"\u3053\u308C\u3089\u306E\u5024\u306F\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u305F\u3081\u306B\u53E3\u3092\u3069\u308C\u3060\u3051\u958B\u3044\u305F\u308A\u9589\u3058\u305F\u308A\u3059\u308B\u5FC5\u8981\u304C\u3042\u308B\u304B\u3092\u6C7A\u5B9A\u3057\u307E\u3059\u3002","open":"\u53E3\u3092\u958B\u3051\u305F\u3068\u304D\u306E\u654F\u611F\u3055","close":"\u53E3\u3092\u9589\u3058\u308B\u611F\u899A","smile":"\u7B11\u9854\u306E\u654F\u611F\u3055","scaleHigh":"\u308F\u305A\u304B\u306B\u958B\u3044\u3066\u3044\u308B","scaleLow":"\u5927\u304D\u304F\u958B\u304F","closeScaleHigh":"\u308F\u305A\u304B\u306B\u9589\u3058\u305F","closeScaleLow":"\u3057\u3063\u304B\u308A\u3068\u9589\u3058\u305F","smileScaleHigh":"\u5FAE\u7B11\u307F","smileScaleLow":"\u5927\u304D\u306A\u7B11\u9854"}},"mouse":{"title":"\u30DE\u30A6\u30B9\u64CD\u4F5C\u306E\u305F\u3081\u306E\u982D\u306E\u52D5\u304D","description":"\u4ED6\u306E\u51FA\u529B\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u4EE3\u308F\u308A\u306B\u3001\u30D8\u30C3\u30C9\u79FB\u52D5\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3057\u3066\u30DE\u30A6\u30B9\u3092\u79FB\u52D5\u3059\u308B\u304B\u3069\u3046\u304B\u3001\u307E\u305F\u305D\u306E\u5834\u5408\u3069\u306E\u3088\u3046\u306B\u4F7F\u7528\u3059\u308B\u304B\u3092\u6C7A\u5B9A\u3057\u307E\u3059\u3002","enable":{"title":"\u30DE\u30A6\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u30D8\u30C3\u30C9\u79FB\u52D5\u3092\u6709\u52B9\u306B\u3059\u308B","description":"\u3053\u308C\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u30C8\u30EA\u30AC\u30FC \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u4EE3\u308F\u308A\u306B\u3001\u30D8\u30C3\u30C9 \u30E0\u30FC\u30D6\u30E1\u30F3\u30C8 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u4E00\u90E8\u304C\u30DE\u30A6\u30B9\u306E\u79FB\u52D5\u306B\u4F7F\u7528\u3055\u308C\u307E\u3059\u3002","option":"\u30DE\u30A6\u30B9\u306E\u79FB\u52D5\u306B\u30D8\u30C3\u30C9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3057\u307E\u3059\u304B?"},"input":{"title":"\u30DE\u30A6\u30B9\u5165\u529B\u30BF\u30A4\u30D7","description":"\u30DE\u30A6\u30B9 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u5272\u308A\u5F53\u3066\u308B\u30D8\u30C3\u30C9 \u30B8\u30A7\u30B9\u30C1\u30E3\u306E\u7A2E\u985E\u3092\u9078\u629E\u3057\u307E\u3059\u3002\u305F\u3068\u3048\u3070\u3001\u300C\u982D\u3092\u50BE\u3051\u308B\u300D\u306F\u3001\u982D\u3092\u5DE6\u53F3\u306B\u50BE\u3051\u3066\u30DE\u30A6\u30B9\u3092\u5DE6\u53F3\u306B\u52D5\u304B\u3059\u3053\u3068\u304C\u3067\u304D\u3001\u300C\u982D\u3092\u56DE\u3059\u300D\u306F\u3001\u982D\u3092\u5DE6\u53F3\u306B\u56DE\u3057\u3066\u30DE\u30A6\u30B9\u3092\u52D5\u304B\u3059\u3053\u3068\u304C\u3067\u304D\u3001\u300C\u982D\u3092\u50BE\u3051\u308B\u300D\u306F\u3001\u982D\u3092\u5DE6\u53F3\u306B\u50BE\u3051\u3066\u30DE\u30A6\u30B9\u3092\u52D5\u304B\u3059\u3053\u3068\u304C\u3067\u304D\u308B\u3053\u3068\u3092\u610F\u5473\u3057\u307E\u3059\u3002","option":"\u5165\u529B\u30BF\u30A4\u30D7\u3092\u9078\u629E","optionLong":"\u30DE\u30A6\u30B9\u3092\u5236\u5FA1\u3059\u308B\u305F\u3081\u306B\u4F7F\u7528\u3059\u308B\u30D8\u30C3\u30C9\u306E\u52D5\u304D\u306E\u30BF\u30A4\u30D7\u3092\u9078\u629E\u3057\u307E\u3059\u3002"},"invert":{"title":"\u30DE\u30A6\u30B9\u306E\u52D5\u304D\u3092\u53CD\u8EE2","description":"\u3053\u308C\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u982D\u3092\u52D5\u304B\u3059\u65B9\u5411\u304C\u30DE\u30A6\u30B9\u3092\u52D5\u304B\u3059\u65B9\u5411\u3068\u53CD\u8EE2\u3057\u307E\u3059\u3002X \u8EF8\u306E\u5834\u5408: \u3053\u308C\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u5DE6\u306B\u52D5\u304B\u3059\u3068\u30DE\u30A6\u30B9\u306F\u53F3\u306B\u79FB\u52D5\u3057\u3001\u53F3\u306B\u52D5\u304B\u3059\u3068\u5DE6\u306B\u79FB\u52D5\u3057\u307E\u3059\u3002Y \u8EF8\u306E\u5834\u5408: \u3053\u308C\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u4E0B\u306B\u52D5\u304B\u3059\u3068\u30DE\u30A6\u30B9\u306F\u4E0A\u306B\u79FB\u52D5\u3057\u3001\u4E0A\u306B\u52D5\u304B\u3059\u3068\u4E0B\u306B\u79FB\u52D5\u3057\u307E\u3059\u3002","x":"X\u8EF8\u306E\u30DE\u30A6\u30B9\u306E\u52D5\u304D\u3092\u53CD\u8EE2\u3057\u307E\u3059\u304B?","y":"Y\u8EF8\u306E\u30DE\u30A6\u30B9\u306E\u52D5\u304D\u3092\u53CD\u8EE2\u3057\u307E\u3059\u304B?"},"mode":{"title":"\u30DE\u30A6\u30B9\u79FB\u52D5\u30E2\u30FC\u30C9","description":"\u982D\u306E\u52D5\u304D\u306B\u5BFE\u3057\u3066\u30AB\u30FC\u30BD\u30EB\u304C\u3069\u306E\u3088\u3046\u306B\u53CD\u5FDC\u3059\u308B\u304B\u3092\u9078\u629E\u3057\u307E\u3059\u3002"},"speed":{"title":"\u30DE\u30A6\u30B9\u306E\u901F\u5EA6","description":"\u30AB\u30FC\u30BD\u30EB\u3092\u79FB\u52D5\u3055\u305B\u305F\u3044\u4E00\u5B9A\u306E\u901F\u5EA6\u3092\u6C7A\u5B9A\u3057\u307E\u3059\u3002","fast":"\u901F\u3044","slow":"\u9045\u3044"},"linear":{"title":"\u30DE\u30A6\u30B9\u306E\u76F4\u7DDA\u79FB\u52D5","description":"\u3053\u308C\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u30AB\u30FC\u30BD\u30EB\u306F\u6C34\u5E73\u307E\u305F\u306F\u5782\u76F4\u306E\u76F4\u7DDA\u306E\u307F\u306B\u79FB\u52D5\u3059\u308B\u305F\u3081\u3001\u659C\u3081\u306B\u30C9\u30EA\u30D5\u30C8\u3059\u308B\u3053\u3068\u306A\u304F\u7279\u5B9A\u306E\u65B9\u5411\u306B\u7C21\u5358\u306B\u79FB\u52D5\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002","option":"\u30DE\u30A6\u30B9\u306E\u76F4\u7DDA\u79FB\u52D5\u3092\u4F7F\u7528\u3057\u307E\u3059\u304B?"},"accelerationRate":{"title":"\u30DE\u30A6\u30B9\u52A0\u901F\u5FDC\u7B54\u9045\u5EF6","description":"\u30DE\u30A6\u30B9\u306E\u901F\u5EA6\u304C\u4E0A\u304C\u308B\u307E\u3067\u306B\u304B\u304B\u308B\u30DF\u30EA\u79D2\u6570\u3002"},"accelerationCurve":{"title":"\u30DE\u30A6\u30B9\u52A0\u901F\u66F2\u7DDA","description":"\u982D\u306E\u52D5\u304D\u306B\u5FDC\u3058\u3066\u30AB\u30FC\u30BD\u30EB\u306E\u901F\u5EA6\u304C\u5897\u52A0\u3059\u308B\u901F\u5EA6\u3092\u8ABF\u6574\u3057\u307E\u3059\u3002","linear":"\u30EA\u30CB\u30A2","exponential":"\u6307\u6570\u95A2\u6570","sublinear":"\u30B5\u30D6\u30EA\u30CB\u30A2"},"maximumSpeed":{"title":"\u6700\u5927\u30DE\u30A6\u30B9\u901F\u5EA6","description":"\u30AB\u30FC\u30BD\u30EB\u304C 1 \u79D2\u9593\u306B\u79FB\u52D5\u3067\u304D\u308B\u6700\u5927\u30D4\u30AF\u30BB\u30EB\u6570\u3092\u6C7A\u5B9A\u3057\u307E\u3059\u3002"},"off":{"title":"\u30AA\u30D5","description":"\u30DE\u30A6\u30B9\u306E\u79FB\u52D5\u306F\u7121\u52B9\u3067\u3059\u3002"},"steadyGlide":{"title":"\u5B89\u5B9A\u3057\u305F\u6ED1\u7A7A","description":"\u982D\u3092\u7279\u5B9A\u306E\u30DD\u30A4\u30F3\u30C8\u3092\u8D85\u3048\u3066\u52D5\u304B\u3059\u3068\u3001\u30AB\u30FC\u30BD\u30EB\u306F\u4E00\u5B9A\u306E\u901F\u5EA6\u3067\u305D\u306E\u65B9\u5411\u306B\u9023\u7D9A\u7684\u306B\u52D5\u304D\u307E\u3059\u3002"},"speedBoost":{"title":"\u30B9\u30D4\u30FC\u30C9\u30D6\u30FC\u30B9\u30C8","description":"\u982D\u3092\u540C\u3058\u4F4D\u7F6E\u306B\u9577\u304F\u4FDD\u3064\u3068\u3001\u30AB\u30FC\u30BD\u30EB\u306E\u52D5\u304D\u304C\u901F\u304F\u306A\u308A\u307E\u3059\u3002\u982D\u3092\u52D5\u304B\u3055\u305A\u306B\u9577\u304F\u4FDD\u3064\u3068\u3001\u30AB\u30FC\u30BD\u30EB\u306E\u52A0\u901F\u3082\u901F\u304F\u306A\u308A\u307E\u3059\u3002"},"dynamicGlide":{"title":"\u30C0\u30A4\u30CA\u30DF\u30C3\u30AF\u30B0\u30E9\u30A4\u30C9","description":"\u30AB\u30FC\u30BD\u30EB\u306E\u901F\u5EA6\u306F\u3001\u982D\u3092\u52D5\u304B\u3059\u8DDD\u96E2\u306B\u5FDC\u3058\u3066\u5897\u52A0\u3057\u307E\u3059\u3002\u982D\u3092\u52D5\u304B\u3059\u8DDD\u96E2\u304C\u9577\u3044\u307B\u3069\u3001\u30AB\u30FC\u30BD\u30EB\u306E\u79FB\u52D5\u901F\u5EA6\u304C\u901F\u304F\u306A\u308A\u307E\u3059\u3002"},"proportionalSpeed":{"title":"\u6BD4\u4F8B\u901F\u5EA6","description":"\u30AB\u30FC\u30BD\u30EB\u306F\u753B\u9762\u306E\u30B5\u30A4\u30BA\u306B\u6BD4\u4F8B\u3057\u3066\u9F3B\u5148\u306B\u6CBF\u3063\u3066\u52D5\u304D\u307E\u3059\u3002"},"disabled":"\u3053\u306E\u6A5F\u80FD\u306F\u3001\u30EA\u30E2\u30FC\u30C8\u63A5\u7D9A\u304A\u3088\u3073\u62E1\u5F35\u6A5F\u80FD\u3067\u306F\u7121\u52B9\u306B\u306A\u3063\u3066\u3044\u307E\u3059\u3002"}},"stop":"\u30AB\u30E1\u30E9\u3092\u505C\u6B62","show":"\u30AB\u30E1\u30E9\u3092\u8868\u793A","hide":"\u30AB\u30E1\u30E9\u3092\u96A0\u3059","warn":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u958B\u59CB\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u9854\u3068\u4F53\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8A31\u53EF\u3059\u308B\u306B\u306F\u3001\u30AB\u30E1\u30E9\u3092\u8D77\u52D5\u3057\u3066\u304F\u3060\u3055\u3044\u3002","draw":{"error":"\u30AB\u30E1\u30E9\u30D5\u30A3\u30FC\u30C9\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u30AB\u30E1\u30E9\u3092\u78BA\u8A8D\u3057\u3066\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002"},"select":"\u9854\u3001\u4F53\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3 \u30DC\u30BF\u30F3\u3092\u4F7F\u7528\u3057\u3066\u5F37\u5316\u3055\u308C\u305F\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u884C\u3046\u306B\u306F\u3001\u30DA\u30A2\u30EA\u30F3\u30B0\u3059\u308B\u30AB\u30E1\u30E9\u3092\u9078\u629E\u3057\u307E\u3059\u3002"},"microphone":{"windowTitle":"\u982D\u3067\u8A8D\u8B58\u3067\u304D\u308B\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","title":"\u30DE\u30A4\u30AF\u30ED\u30D5\u30A9\u30F3","titlePlural":"\u30DE\u30A4\u30AF","settings":"\u30DE\u30A4\u30AF\u8A2D\u5B9A","start":"\u30DE\u30A4\u30AF\u3092\u958B\u59CB","stop":"\u30DE\u30A4\u30AF\u3092\u505C\u6B62","descriptionShort":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u6709\u52B9\u306B\u3057\u307E\u3059\u3002","description":"\u5185\u8535\u30DE\u30A4\u30AF\u3092\u4F7F\u7528\u3057\u3066\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u6709\u52B9\u306B\u3057\u307E\u3059\u3002","select":"\u97F3\u58F0\u3092\u4F7F\u7528\u3057\u305F\u5236\u5FA1\u3092\u5F37\u5316\u3059\u308B\u305F\u3081\u306B\u3001\u30DA\u30A2\u30EA\u30F3\u30B0\u3059\u308B\u30DE\u30A4\u30AF\u3092\u9078\u629E\u3057\u307E\u3059\u3002","empty":"\u30DE\u30A4\u30AF\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002","search":"\u30DE\u30A4\u30AF\u540D\u3067\u691C\u7D22","manage":{"title":"\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001\u30DE\u30A4\u30AF\u306E\u8A73\u7D30\u3092\u8868\u793A\u304A\u3088\u3073\u7BA1\u7406\u3067\u304D\u307E\u3059\u3002","description":""},"permission":{"title":"\u30DE\u30A4\u30AF\u306E\u8A31\u53EF\u304C\u5FC5\u8981\u3067\u3059","description":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u306B\u306F\u3001Cephable \u306B\u30DE\u30A4\u30AF\u306E\u4F7F\u7528\u8A31\u53EF\u3092\u4E0E\u3048\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","button":"\u6A29\u9650\u8A2D\u5B9A\u3092\u958B\u304F","no":"\u30DE\u30A4\u30AF\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u305B\u3093","help":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u306B\u306F\u3001Cephable \u304C\u30DE\u30A4\u30AF\u306B\u30A2\u30AF\u30BB\u30B9\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002 <strong>[\u30B7\u30B9\u30C6\u30E0\u8A2D\u5B9A]</strong> > <strong>[\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC]</strong> > <strong>[\u30DE\u30A4\u30AF]</strong>\u306B\u79FB\u52D5\u3057\u3066\u3001Cephable \u304C\u30DE\u30A4\u30AF\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002"},"controls":{"loadingDetail":"\u3053\u308C\u306B\u306F\u6570\u5206\u304B\u304B\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002","pause":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4E00\u6642\u505C\u6B62","paused":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4E00\u6642\u505C\u6B62\u3057\u307E\u3057\u305F\u3002","resume":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u518D\u958B\u3059\u308B","dictationPlay":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u3092\u958B\u59CB","dictationPause":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u3092\u505C\u6B62","prompt":"\u8A71\u3057\u59CB\u3081\u308B\u3068\u3001\u3053\u3053\u3067\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u8868\u793A\u3055\u308C\u307E\u3059...","dictationPrompt":"\u8A71\u3057\u59CB\u3081\u308B\u3068\u3001\u8A71\u3057\u305F\u5185\u5BB9\u304C\u5165\u529B\u3055\u308C\u307E\u3059...","latency":"\u9AD8\u3044\u9045\u5EF6\u304C\u691C\u51FA\u3055\u308C\u307E\u3057\u305F\u3002\u30EA\u30BD\u30FC\u30B9\u3092\u904E\u5270\u306B\u6D88\u8CBB\u3057\u3066\u3044\u308B\u53EF\u80FD\u6027\u306E\u3042\u308B\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u9589\u3058\u308B\u3053\u3068\u3092\u691C\u8A0E\u3057\u3066\u304F\u3060\u3055\u3044\u3002","noDeviceConnectedDescription":"\u30DE\u30A4\u30AF \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u30A4\u30F3\u30BF\u30FC\u30D5\u30A7\u30A4\u30B9\u306E\u30D7\u30EC\u30D3\u30E5\u30FC\u3068\u3057\u3066\u6A5F\u80FD\u3057\u307E\u3059\u3002\u30B9\u30C6\u30C3\u30D7\u306F\u6B63\u5E38\u306B\u5B9F\u884C\u3055\u308C\u307E\u305B\u3093\u3002\u30B3\u30DE\u30F3\u30C9\u3092\u958B\u59CB\u3059\u308B\u306B\u306F\u3001\u3053\u306E\u30B3\u30F3\u30D1\u30CB\u30AA\u30F3 \u30C7\u30D0\u30A4\u30B9\u3092\u5225\u306E\u30C7\u30D0\u30A4\u30B9\u306B\u63A5\u7D9A\u3057\u307E\u3059\u3002","status":{"loadingModel":"\u97F3\u58F0\u30E2\u30C7\u30EB\u3092\u8AAD\u307F\u8FBC\u3093\u3067\u3044\u307E\u3059...","thinking":"\u8003\u3048...","paused":"\u4E00\u6642\u505C\u6B62\u3057\u307E\u3057\u305F\u3002","dictating":"\u53E3\u8FF0\u3059\u308B\u3002","optimistic":"\u697D\u89B3\u7684\uFF1A","listening":"\u30EA\u30B9\u30CB\u30F3\u30B0\uFF1A","loadingPhiModel":"\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u30E2\u30C7\u30EB\u3092\u8AAD\u307F\u8FBC\u3093\u3067\u3044\u307E\u3059...","generatingText":"\u751F\u6210\u4E2D...","preparingPhiModel":"\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u30E2\u30C7\u30EB\u3092\u6E96\u5099\u3057\u3066\u3044\u307E\u3059...","permission":"\u30DE\u30A4\u30AF\u306E\u6A29\u9650\u3092\u78BA\u8A8D\u3057\u3066\u3044\u307E\u3059...","typing":"\u30BF\u30A4\u30D4\u30F3\u30B0..."},"generatingTextDetail":"\u30A2\u30D7\u30EA\u3092\u5909\u66F4\u3059\u308B\u304B\u3001\u300C\u751F\u6210\u3092\u505C\u6B62\u300D\u3068\u8A00\u3063\u3066\u751F\u6210\u3092\u505C\u6B62\u3057\u307E\u3059"},"edit":{"title":"\u30DE\u30A4\u30AF\u306E\u8A2D\u5B9A\u3092\u7DE8\u96C6\u3059\u308B","autoStart":{"title":"\u30DE\u30A4\u30AF\u3092\u81EA\u52D5\u7684\u306B\u8D77\u52D5\u3059\u308B","option":"\u30DE\u30A4\u30AF\u3068\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u81EA\u52D5\u8D77\u52D5\u3057\u307E\u3059\u304B?","description":"\u3053\u306E\u8A2D\u5B9A\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u5165\u529B\u30C7\u30D0\u30A4\u30B9\u3092\u63A5\u7D9A\u3059\u308B\u304B\u96FB\u6E90\u3092\u5165\u308C\u308B\u3068\u3001\u8D77\u52D5\u6642\u306B\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u308A\u3001\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u51E6\u7406\u304C\u958B\u59CB\u3055\u308C\u307E\u3059\u3002\u30AA\u30D5\u306B\u306A\u3063\u3066\u3044\u308B\u5834\u5408\u306F\u3001\u63A5\u7D9A\u30DA\u30FC\u30B8\u3067\u300C\u805E\u304D\u53D6\u308A\u958B\u59CB\u300D\u30DC\u30BF\u30F3\u3092\u30BF\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"optimistic":{"title":"\u697D\u89B3\u7684\u306A\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","option":"\u697D\u89B3\u7684\u306A\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3057\u307E\u3059\u304B?","description":"Cephable \u306B\u306F\u3001\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u7528\u306E 2 \u3064\u306E\u7570\u306A\u308B\u611F\u5EA6\u30E2\u30FC\u30C9 (\u6A19\u6E96\u3068\u697D\u89B3) \u304C\u3042\u308A\u307E\u3059\u3002\u6A19\u6E96\u30E2\u30FC\u30C9\u3067\u306F\u3001Cephable \u306F\u7406\u89E3\u3067\u304D\u308B\u3059\u3079\u3066\u306E\u5358\u8A9E\u3092\u8A8D\u8B58\u3067\u304D\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3 \u30E2\u30FC\u30C9\u3067\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002\u697D\u89B3\u30E2\u30FC\u30C9\u3067\u306F\u3001Cephable \u306F\u6307\u5B9A\u3055\u308C\u305F\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u91CD\u70B9\u3092\u7F6E\u304F\u3088\u3046\u306B\u6307\u793A\u3055\u308C\u307E\u3059\u3002\u697D\u89B3\u30E2\u30FC\u30C9\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3088\u308A\u901F\u304F\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u304C\u3001\u6B63\u78BA\u306A\u5358\u8A9E\u3092\u8A00\u308F\u306A\u3044\u3068\u3001\u8AA4\u3063\u3066\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u308B\u53EF\u80FD\u6027\u3082\u3042\u308A\u307E\u3059\u3002\u697D\u89B3\u30E2\u30FC\u30C9\u3067\u306F\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u306F\u4F7F\u7528\u3067\u304D\u307E\u305B\u3093\u3002"},"confirm":{"title":"\u4FDD\u5B58\u3055\u308C\u3066\u3044\u306A\u3044\u5909\u66F4\u304C\u3042\u308A\u307E\u3059\u3002","description":"\u4FDD\u5B58\u3055\u308C\u3066\u3044\u306A\u3044\u5909\u66F4\u304C\u691C\u51FA\u3055\u308C\u307E\u3057\u305F\u3002\u7D42\u4E86\u3059\u308B\u524D\u306B\u4FDD\u5B58\u3057\u307E\u3059\u304B?"},"aiCommands":{"title":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9","description":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u306B\u3088\u308A\u3001Cephable AI \u306F\u3001\u6B63\u78BA\u306B\u4E00\u81F4\u3055\u305B\u308B\u5FC5\u8981\u306A\u3057\u306B\u3001\u4F7F\u7528\u3057\u3088\u3046\u3068\u3057\u3066\u3044\u308B\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3092\u4E88\u6E2C\u3067\u304D\u307E\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u306B\u4F55\u3092\u3059\u3079\u304D\u304B\u3092\u3088\u308A\u81EA\u7136\u306B\u6307\u793A\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u3001Cephable \u304C\u305D\u308C\u3092\u7406\u89E3\u3059\u308B\u306E\u306B\u5F79\u7ACB\u3061\u307E\u3059\u3002","option":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3057\u307E\u3059\u304B?"},"aiDictation":{"title":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3068\u30AF\u30A4\u30C3\u30AF\u30BF\u30A4\u30D7","description":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3068\u30AF\u30A4\u30C3\u30AF\u30BF\u30A4\u30D7\u306F\u3001\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u6700\u3082\u6B63\u78BA\u306A\u5165\u529B\u4F53\u9A13\u3092\u63D0\u4F9B\u3057\u307E\u3059\u3002\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u306F\u53E5\u8AAD\u70B9\u3001\u56FA\u6709\u540D\u8A5E\u3001\u6587\u69CB\u9020\u3092\u81EA\u52D5\u7684\u306B\u51E6\u7406\u3057\u3001\u30AF\u30A4\u30C3\u30AF\u30BF\u30A4\u30D7\u306F\u30B9\u30DE\u30FC\u30C8\u306A\u4E88\u6E2C\u3068\u4FEE\u6B63\u6A5F\u80FD\u3092\u63D0\u4F9B\u3057\u3001\u7C21\u5358\u304B\u3064\u6B63\u78BA\u306A\u5165\u529B\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u307E\u3059\u3002","option":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3068\u30AF\u30A4\u30C3\u30AF\u30BF\u30A4\u30D7\u3092\u4F7F\u7528\u3057\u307E\u3059\u304B?"},"description":"\u3053\u306E\u63A5\u7D9A\u306E\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u8A2D\u5B9A\u3092\u7BA1\u7406\u3057\u307E\u3059\u3002"},"warn":"\u30DE\u30A4\u30AF\u304C\u8D77\u52D5\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u8A31\u53EF\u3059\u308B\u306B\u306F\u3001\u30DE\u30A4\u30AF\u3092\u8D77\u52D5\u3057\u3066\u304F\u3060\u3055\u3044\u3002","devices":{"error":"\u30DE\u30A4\u30AF\u5165\u529B\u30C7\u30D0\u30A4\u30B9\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002"},"startDescription":"\u30B3\u30DE\u30F3\u30C9\u306E\u805E\u304D\u53D6\u308A\u3092\u958B\u59CB\u3059\u308B\u306B\u306F\u3001\u30DE\u30A4\u30AF\u3092\u30AA\u30F3\u306B\u3057\u307E\u3059\u3002"},"localization":{"title":"\u8A00\u8A9E\u8A2D\u5B9A","titleShort":"\u8A00\u8A9E","description":"\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u308B\u8A00\u8A9E\u306E\u30EA\u30B9\u30C8\u304B\u3089\u5E0C\u671B\u306E\u8A00\u8A9E\u3092\u9078\u629E\u3057\u307E\u3059\u3002","newUserDescription":"\u7D9A\u884C\u3059\u308B\u524D\u306B\u3001\u5E0C\u671B\u3059\u308B\u8A00\u8A9E\u3092\u9078\u629E\u3057\u307E\u3059\u3002","edit":"\u8A00\u8A9E\u306E\u66F4\u65B0","display":{"title":"\u8868\u793A\u8A00\u8A9E","description":"Cephable \u306E\u4F7F\u7528\u6642\u306B\u8868\u793A\u3055\u308C\u308B\u8A00\u8A9E\u3002\u3053\u308C\u306B\u306F\u3001\u9078\u629E\u3057\u305F\u8A00\u8A9E\u3067\u8868\u793A\u3055\u308C\u308B\u30E1\u30CB\u30E5\u30FC\u3001\u901A\u77E5\u3001\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306A\u3069\u304C\u542B\u307E\u308C\u307E\u3059\u3002"},"voice":{"title":"\u97F3\u58F0\u5236\u5FA1\u8A00\u8A9E","description":"\u3053\u308C\u306F\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3068\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3092\u8A8D\u8B58\u3059\u308B\u3068\u304D\u306B\u4F7F\u7528\u3055\u308C\u308B\u8A00\u8A9E\u3067\u3059\u3002\u8A00\u8A9E\u3092\u6307\u5B9A\u3059\u308B\u3068\u3001\u97F3\u58F0\u5165\u529B\u306E\u7CBE\u5EA6\u304C\u5411\u4E0A\u3057\u307E\u3059\u3002","settings":{"title":"\u97F3\u58F0\u8A8D\u8B58\u3068\u8868\u793A\u8A00\u8A9E","description":"\u30C7\u30A3\u30B9\u30D7\u30EC\u30A4\u3068\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u4E21\u65B9\u306E\u8A00\u8A9E\u8A2D\u5B9A\u3092\u8ABF\u6574\u3057\u307E\u3059\u3002\u3053\u306E\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u753B\u9762\u4E0A\u306E\u30C6\u30AD\u30B9\u30C8\u3084\u3001\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3084\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u306A\u3069\u306E\u30DE\u30A4\u30AF\u306E\u64CD\u4F5C\u306B\u4F7F\u7528\u3059\u308B\u8A00\u8A9E\u3092\u9078\u629E\u3067\u304D\u307E\u3059\u3002"}},"locales":{"en":"English - \u82F1\u8A9E","en-us":"English (US) - \u82F1\u8A9E\uFF08\u7C73\u56FD\uFF09","es":"Espa\xf1ol \u2014 \u30B9\u30DA\u30A4\u30F3\u8A9E","fr":"Fran\xe7ais \u2014 \u30D5\u30E9\u30F3\u30B9\u8A9E","it":"Italiano \u2014 \u30A4\u30BF\u30EA\u30A2\u8A9E","de":"Deutsch \u2014 \u30C9\u30A4\u30C4\u8A9E","ja":"\u65E5\u672C\u8A9E","en-gb":"English (UK) - \u82F1\u8A9E\uFF08\u82F1\u56FD\uFF09","en-in":"English (India) - \u82F1\u8A9E\uFF08\u30A4\u30F3\u30C9\uFF09"},"save":{"success":"\u30E6\u30FC\u30B6\u30FC\u306E\u30ED\u30B1\u30FC\u30EB\u8A2D\u5B9A\u304C\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F\u3002","error":"\u30E6\u30FC\u30B6\u30FC\u306E\u30ED\u30B1\u30FC\u30EB\u8A2D\u5B9A\u306E\u4FDD\u5B58\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F"},"profile":{"view":"\u5909\u7A2E","title":"\u30A2\u30D7\u30EA\u5236\u5FA1\u8A00\u8A9E","question":"\u3069\u306E\u30A2\u30D7\u30EA\u5236\u5FA1\u8A00\u8A9E\u3092\u7DE8\u96C6\u3057\u307E\u3059\u304B?","description":"\u4E00\u90E8\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u306F\u3001\u7570\u306A\u308B\u8A00\u8A9E\u306E\u30D0\u30EA\u30A8\u30FC\u30B7\u30E7\u30F3\u304C\u7528\u610F\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u5225\u306E\u8A00\u8A9E\u306B\u5207\u308A\u66FF\u3048\u3066\u7DE8\u96C6\u3057\u3001\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u3066\u304F\u3060\u3055\u3044\u3002","change":"\u8A00\u8A9E\u3092\u5909\u66F4"},"unsupported":{"title":"\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u306A\u3044\u8A00\u8A9E {{locale}}","description":"\u9078\u629E\u3057\u305F\u8A00\u8A9E\u306F\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u5225\u306E\u8A00\u8A9E\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"select":"\u8A00\u8A9E\u3092\u9078\u629E","localesShort":{"en":"\u82F1\u8A9E","en-us":"\u82F1\u8A9E\uFF08\u7C73\u56FD\uFF09","es":"\u30B9\u30DA\u30A4\u30F3\u8A9E","fr":"\u30D5\u30E9\u30F3\u30B9\u8A9E","it":"\u30A4\u30BF\u30EA\u30A2\u8A9E","de":"\u30C9\u30A4\u30C4\u8A9E","ja":"\u65E5\u672C\u8A9E"}},"editor":{"title":"\u30DE\u30FC\u30AF\u30C0\u30A6\u30F3\u30A8\u30C7\u30A3\u30BF\u30FC","bold":"\u5927\u80C6\u306A","italic":"\u30A4\u30BF\u30EA\u30C3\u30AF","underline":"\u4E0B\u7DDA","strikethrough":"\u53D6\u308A\u6D88\u3057\u7DDA","hr":"\u6C34\u5E73\u7DDA","link":"\u30EA\u30F3\u30AF","quote":"\u5F15\u7528","code":"\u30B3\u30FC\u30C9","codeBlock":"\u30B3\u30FC\u30C9\u30D6\u30ED\u30C3\u30AF","comment":"\u30B3\u30E1\u30F3\u30C8","image":"\u753B\u50CF","table":"\u30C6\u30FC\u30D6\u30EB","unordered-list":"\u9806\u5E8F\u306A\u3057\u30EA\u30B9\u30C8","ordered-list":"\u9806\u5E8F\u4ED8\u304D\u30EA\u30B9\u30C8","checked-list":"\u30C1\u30A7\u30C3\u30AF\u30EA\u30B9\u30C8","help":"\u30D8\u30EB\u30D7","edit":"\u7DE8\u96C6","live":"\u30E9\u30A4\u30D6","preview":"\u30D7\u30EC\u30D3\u30E5\u30FC","fullscreen":"\u5168\u753B\u9762\u8868\u793A","placeholder":"\u3053\u3053\u306B Markdown \u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044..."},"resume":"\u518D\u958B\u3059\u308B","panel":{"title":"\u982D\u84CB\u9AA8\u30D1\u30CD\u30EB","question":"\u81EA\u52D5\u8D77\u52D5\u30D1\u30CD\u30EB?","position":{"top":"\u30C8\u30C3\u30D7","right":"\u53F3","left":"\u5DE6","bottom":"\u5E95 ","description":"Cephable \u30D1\u30CD\u30EB\u3092\u753B\u9762\u4E0A\u306E\u3069\u3053\u306B\u8868\u793A\u3059\u308B\u304B\u3092\u9078\u629E\u3057\u307E\u3059\u3002","label":"\u4F4D\u7F6E"},"sections":{"description":"\u30D1\u30CD\u30EB\u5185\u306E\u8868\u793A\u3059\u308B\u30BB\u30AF\u30B7\u30E7\u30F3\u3092\u9078\u629E\u3057\u307E\u3059\u3002\u597D\u307F\u306B\u5FDC\u3058\u3066\u30BB\u30AF\u30B7\u30E7\u30F3\u3092\u975E\u8868\u793A\u306B\u3059\u308B\u3053\u3068\u3067\u3001\u30D1\u30CD\u30EB\u306E\u30B9\u30DA\u30FC\u30B9\u3092\u6700\u5927\u9650\u306B\u6D3B\u7528\u3067\u304D\u307E\u3059\u3002","microphone":"\u30DE\u30A4\u30AF\u3068\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","camera":"\u30AB\u30E1\u30E9\u3068\u9854/\u982D\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","profile":"\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30D7\u30EC\u30D3\u30E5\u30FC","globalControls":"\u30B0\u30ED\u30FC\u30D0\u30EB\u304A\u3088\u3073\u30C7\u30D0\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","tasks":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF","buttons":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3"},"titleShort":"\u30D1\u30CD\u30EB","description":"\u3053\u308C\u306F\u30E1\u30A4\u30F3\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u30BB\u30F3\u30BF\u30FC\u3068\u306A\u308B\u30D1\u30CD\u30EB\u3067\u3059\u3002\u5E38\u306B\u8868\u793A\u3055\u308C\u3066\u304A\u308A\u3001\u97F3\u58F0\u3092\u4F7F\u3063\u3066\u30A2\u30D7\u30EA\u306A\u3069\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002"},"textGeneration":{"settings":"\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u8A2D\u5B9A","edit":{"title":"\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u8A2D\u5B9A\u306E\u7DE8\u96C6","description":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8 \u30C6\u30AD\u30B9\u30C8\u751F\u6210\u306E\u8A2D\u5B9A\u3092\u8ABF\u6574\u3057\u3066\u3001\u6700\u9069\u306A\u51FA\u529B\u3092\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002","autoStart":{"title":"\u81EA\u52D5\u7684\u306B\u30A6\u30A9\u30FC\u30E0\u30A2\u30C3\u30D7\u30C6\u30AD\u30B9\u30C8\u3092\u751F\u6210\u3059\u308B","description":"\u3053\u306E\u8A2D\u5B9A\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001Cephable AI \u306F\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u306B\u4F7F\u7528\u3055\u308C\u308B AI \u30E2\u30C7\u30EB\u3092\u81EA\u52D5\u7684\u306B\u30A6\u30A9\u30FC\u30E0\u30A2\u30C3\u30D7\u3057\u307E\u3059\u3002\u30E2\u30C7\u30EB\u3092\u30A6\u30A9\u30FC\u30E0\u30A2\u30C3\u30D7\u3059\u308B\u3068\u3001\u751F\u6210\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3059\u308B\u3068\u304D\u306B\u30D1\u30D5\u30A9\u30FC\u30DE\u30F3\u30B9\u304C\u901F\u304F\u306A\u308A\u307E\u3059\u304C\u3001\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u306E\u30EA\u30BD\u30FC\u30B9\u306E\u6D88\u8CBB\u91CF\u304C\u5897\u3048\u307E\u3059\u3002\u3053\u306E\u8A2D\u5B9A\u3092\u30AA\u30D5\u306B\u3059\u308B\u3068\u30EA\u30BD\u30FC\u30B9\u306F\u7BC0\u7D04\u3055\u308C\u307E\u3059\u304C\u3001\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u304C\u9045\u304F\u306A\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002","option":"\u30C6\u30AD\u30B9\u30C8\u751F\u6210 AI \u30E2\u30C7\u30EB\u3092\u81EA\u52D5\u30A6\u30A9\u30FC\u30E0\u30A2\u30C3\u30D7\u3057\u307E\u3059\u304B?"},"prompt":{"title":"\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u306B\u95A2\u3059\u308B\u8FFD\u52A0\u60C5\u5831","description":"Cephable \u306E AI \u3067\u30C6\u30AD\u30B9\u30C8\u3092\u751F\u6210\u3059\u308B\u305F\u3081\u306B\u4F7F\u7528\u3059\u308B\u8FFD\u52A0\u306E\u8A73\u7D30\u3092\u5165\u529B\u3057\u307E\u3059\u3002\u3053\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u4F7F\u7528\u3057\u3066\u3001\u30C8\u30FC\u30F3\u3001\u66F8\u304D\u65B9\u3001\u305D\u306E\u4ED6\u306E\u8A73\u7D30\u306B\u95A2\u3059\u308B\u8A2D\u5B9A\u3092\u5165\u529B\u3057\u307E\u3059\u3002","field":"\u8FFD\u52A0\u306E\u30D7\u30ED\u30F3\u30D7\u30C8","placeholder":"\u305F\u3068\u3048\u3070\u3001\u30D5\u30EC\u30F3\u30C9\u30EA\u30FC\u306A\u53E3\u8ABF\u3067\u3001\u30D7\u30ED\u30D5\u30A7\u30C3\u30B7\u30E7\u30CA\u30EB\u306E\u3088\u3046\u306B\u3001\u7C21\u6F54\u304B\u3064\u8981\u70B9\u3092\u62BC\u3055\u3048\u3066\u66F8\u304D\u307E\u3059\u3002\u30B3\u30FC\u30C9\u3092\u66F8\u304F\u3068\u304D\u306F\u3001\u601D\u616E\u6DF1\u3044\u30B3\u30E1\u30F3\u30C8\u3092\u6B8B\u3057\u307E\u3059\u304C\u3001\u591A\u3059\u304E\u306A\u3044\u3088\u3046\u306B\u3057\u307E\u3059\u3002"},"enableTextGen":{"title":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u3092\u6709\u52B9\u306B\u3059\u308B","description":"\u3053\u306E\u8A2D\u5B9A\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001Cephable AI \u306F\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u30C7\u30D0\u30A4\u30B9 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3057\u3066\u3001\u4EFB\u610F\u306E\u30A2\u30D7\u30EA\u3067\u30C6\u30AD\u30B9\u30C8\u3092\u751F\u6210\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002\u3053\u308C\u3092\u30AA\u30D5\u306B\u3059\u308B\u3068\u3001\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u306F\u7121\u52B9\u306B\u306A\u308A\u307E\u3059\u3002","option":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u3092\u4F7F\u7528\u3057\u307E\u3059\u304B?"},"terminate":{"title":"\u30AF\u30EA\u30A2\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u30EA\u30BD\u30FC\u30B9","description":"\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u306B\u4F7F\u7528\u3055\u308C\u305F\u30EA\u30BD\u30FC\u30B9\u304C\u30AF\u30EA\u30A2\u3055\u308C\u307E\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u306E\u30EA\u30BD\u30FC\u30B9\u304C\u89E3\u653E\u3055\u308C\u307E\u3059\u304C\u3001\u6B21\u56DE\u4F7F\u7528\u3059\u308B\u3068\u304D\u306B\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u304C\u9045\u304F\u306A\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002","button":"\u30EA\u30BD\u30FC\u30B9\u3092\u30AF\u30EA\u30A2","success":"\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u30EA\u30BD\u30FC\u30B9\u3092\u30AF\u30EA\u30A2\u3057\u3066\u3044\u307E\u3059\u3002","confirm":{"title":"\u30AF\u30EA\u30A2\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u30EA\u30BD\u30FC\u30B9","description":"\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u306B\u4F7F\u7528\u3055\u308C\u305F\u30EA\u30BD\u30FC\u30B9\u3092\u30AF\u30EA\u30A2\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B? \u3053\u308C\u306B\u3088\u308A\u3001\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u306E\u30EA\u30BD\u30FC\u30B9\u304C\u89E3\u653E\u3055\u308C\u307E\u3059\u304C\u3001\u6B21\u56DE\u4F7F\u7528\u3059\u308B\u3068\u304D\u306B\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u304C\u9045\u304F\u306A\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002","confirm":"\u306F\u3044\u3001\u660E\u78BA\u306A\u30EA\u30BD\u30FC\u30B9","cancel":"\u30AD\u30E3\u30F3\u30BB\u30EB"}},"clearModelCache":{"title":"AI\u30E2\u30C7\u30EB\u30AD\u30E3\u30C3\u30B7\u30E5\u3092\u30AF\u30EA\u30A2\u3059\u308B","description":"\u30AD\u30E3\u30C3\u30B7\u30E5\u3092\u30AF\u30EA\u30A2\u3057\u3066\u518D\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3059\u308BAI\u30E2\u30C7\u30EB\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u306E\u30B9\u30C8\u30EC\u30FC\u30B8\u5BB9\u91CF\u304C\u89E3\u653E\u3055\u308C\u3001\u9078\u629E\u3057\u305F\u30E2\u30C7\u30EB\u30D5\u30A1\u30A4\u30EB\u304C\u518D\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3055\u308C\u307E\u3059\u3002","button":"\u30AF\u30EA\u30A2\u3057\u3066\u518D\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9","success":"\u30ED\u30FC\u30AB\u30EB \u30E2\u30C7\u30EB \u30D5\u30A1\u30A4\u30EB\u3092\u524A\u9664\u3057\u307E\u3057\u305F\u3002","confirm":{"title":"AI\u30E2\u30C7\u30EB\u30AD\u30E3\u30C3\u30B7\u30E5\u3092\u30AF\u30EA\u30A2\u3057\u3066\u518D\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3059\u308B","description":"\u9078\u629E\u3057\u305FAI\u30E2\u30C7\u30EB\u306E\u30AD\u30E3\u30C3\u30B7\u30E5\u3092\u30AF\u30EA\u30A2\u3057\u3066\u3001\u30B7\u30B9\u30C6\u30E0\u304B\u3089\u30D5\u30A1\u30A4\u30EB\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F\u9078\u629E\u3057\u305F\u30E2\u30C7\u30EB\u306F\u81EA\u52D5\u7684\u306B\u518D\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3055\u308C\u307E\u3059\u3002","confirm":"\u306F\u3044\u3001\u30AF\u30EA\u30A2\u3057\u3066\u518D\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044","cancel":"\u30AD\u30E3\u30F3\u30BB\u30EB","textGenLabel":"Text Generation (Inference) model","workflowsLabel":"AI Workflows models"},"error":"\u30ED\u30FC\u30AB\u30EB \u30E2\u30C7\u30EB \u30D5\u30A1\u30A4\u30EB\u306E\u524A\u9664\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002"},"enableHistory":{"title":"\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u5C65\u6B74\u3092\u6709\u52B9\u306B\u3059\u308B","description":"\u3053\u306E\u8A2D\u5B9A\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001Cephable AI \u306F\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u5C65\u6B74\u3092\u4F7F\u7528\u3057\u3066\u3001\u4EE5\u524D\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u306E\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3067\u30C6\u30AD\u30B9\u30C8\u3092\u751F\u6210\u3057\u307E\u3059\u3002","option":"\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u5C65\u6B74\u3092\u4F7F\u7528\u3057\u307E\u3059\u304B?"}},"prompt":{"systemPrompt":"\u8981\u6C42\u3055\u308C\u305F\u30C6\u30AD\u30B9\u30C8\u306E\u307F\u3092\u751F\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u8AAC\u660E\u3001\u30B3\u30E1\u30F3\u30C8\u3001\u305D\u306E\u4ED6\u306E\u4F59\u8A08\u306A\u60C5\u5831\u306F\u51FA\u529B\u3057\u307E\u305B\u3093\u3002\u4E00\u65B9\u7684\u306A\u30DE\u30FC\u30AF\u30C0\u30A6\u30F3\u3084\u8AAC\u660E\u306F\u51FA\u529B\u3057\u307E\u305B\u3093\u3002\u30B3\u30FC\u30C9\u306E\u5834\u5408\u306F\u3001\u751F\u306E\u30B3\u30FC\u30C9\u306E\u307F\u3092\u51FA\u529B\u3057\u307E\u3059\u3002\u30D5\u30A7\u30F3\u30B9\u3001\u8A00\u8A9E\u30BF\u30B0\u3001\u8AAC\u660E\u306F\u51FA\u529B\u3057\u307E\u305B\u3093\u3002","appName":"\u73FE\u5728\u3001{{appName}} \u306E\u30C6\u30AD\u30B9\u30C8\u3092\u751F\u6210\u3057\u3066\u3044\u307E\u3059\u3002","userPreferences":"\u30C6\u30AD\u30B9\u30C8\u306E\u751F\u6210\u65B9\u6CD5\u306B\u95A2\u3059\u308B\u30E6\u30FC\u30B6\u30FC\u8A2D\u5B9A\u3092\u5C0A\u91CD\u3057\u307E\u3059: {{userPreferences}}\u3002"},"rewritePrompt":{"systemPrompt":"\u6307\u793A\u306B\u5F93\u3063\u3066\u3001\u63D0\u4F9B\u3055\u308C\u305F\u30C6\u30AD\u30B9\u30C8\u3092\u66F8\u304D\u76F4\u3057\u3001\u307E\u305F\u306F\u66F8\u5F0F\u3092\u5909\u66F4\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u66F8\u5F0F\u3092\u5909\u66F4\u3059\u308B\u5834\u5408\uFF08\u4F8B\uFF1A\u30EA\u30B9\u30C8\u3001\u8868\u3001\u69CB\u9020\u306E\u5909\u66F4\uFF09\u306F\u3001\u5143\u306E\u6587\u8A00\u3092\u305D\u306E\u307E\u307E\u4FDD\u6301\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u66F8\u304D\u76F4\u3059\u5834\u5408\uFF08\u4F8B\uFF1A\u30C8\u30FC\u30F3\u3001\u30B9\u30BF\u30A4\u30EB\u3001\u9577\u3055\uFF09\u306F\u3001\u610F\u5473\u306F\u4FDD\u6301\u3057\u307E\u3059\u304C\u3001\u5FC5\u305A\u3057\u3082\u6587\u8A00\u306F\u4FDD\u6301\u3059\u308B\u5FC5\u8981\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u7D50\u679C\u306E\u307F\u3092\u51FA\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u8AAC\u660E\u3084\u8AD6\u8A55\u306F\u4E0D\u8981\u3067\u3059\u3002\u3053\u308C\u306F\u3001\u3088\u308A\u5927\u304D\u306A\u6587\u66F8\u306E\u4E00\u90E8\u3067\u3042\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u898B\u51FA\u3057\u3001\u30E9\u30D9\u30EB\u3001\u524D\u6587\u306F\u542B\u3081\u305A\u3001\u7D50\u679C\u306E\u307F\u3092\u51FA\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","userPreferences":"\u30C6\u30AD\u30B9\u30C8\u306E\u751F\u6210\u65B9\u6CD5\u306B\u95A2\u3059\u308B\u30E6\u30FC\u30B6\u30FC\u8A2D\u5B9A\u3092\u5C0A\u91CD\u3057\u307E\u3059: {{userPreferences}}\u3002","rewriteInstructions":"\u624B\u9806: {{rewriteInstructions}}\u3002"},"translatePrompt":{"systemPrompt":"\u4EE5\u4E0B\u306E\u30C6\u30AD\u30B9\u30C8\u3092{{language}}\u306B\u7FFB\u8A33\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u7FFB\u8A33\u3055\u308C\u305F\u30C6\u30AD\u30B9\u30C8\u306E\u307F\u3092\u51FA\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u8AAC\u660E\u3001\u524D\u7F6E\u304D\u3001\u30DE\u30FC\u30AF\u30C0\u30A6\u30F3\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3001\u30B3\u30FC\u30C9\u30D5\u30A7\u30F3\u30B9\u306F\u4E0D\u8981\u3067\u3059\u3002\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u306F\u4FDD\u6301\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30B3\u30FC\u30C9\u306B\u3064\u3044\u3066\u306F\u3001\u30B3\u30E1\u30F3\u30C8\u3068\u6587\u5B57\u5217\u306E\u307F\u3092\u7FFB\u8A33\u3057\u3001\u69CB\u6587\u306F\u305D\u306E\u307E\u307E\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","userPreferences":"\u30C6\u30AD\u30B9\u30C8\u306E\u751F\u6210\u65B9\u6CD5\u306B\u95A2\u3059\u308B\u30E6\u30FC\u30B6\u30FC\u8A2D\u5B9A\u3092\u5C0A\u91CD\u3057\u307E\u3059: {{userPreferences}}\u3002","genericUserPrompt":"\u7FFB\u8A33: {{userRequestText}}"},"disabled":{"title":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\u304C\u7121\u52B9\u306B\u306A\u3063\u3066\u3044\u307E\u3059","description":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\u304C\u7121\u52B9\u306B\u306A\u3063\u3066\u3044\u308B\u3088\u3046\u3067\u3059\u3002\u8A2D\u5B9A\u3092\u66F4\u65B0\u3057\u3066\u3001\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u3001\u66F8\u304D\u63DB\u3048\u306A\u3069\u306E\u6A5F\u80FD\u3092\u6709\u52B9\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"summarizePrompt":{"systemPrompt":"\u63D0\u4F9B\u3055\u308C\u305F\u30C6\u30AD\u30B9\u30C8\u3092\u7C21\u6F54\u306B\u8981\u7D04\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u3053\u308C\u306F\u3001\u3088\u308A\u5927\u304D\u306A\u6587\u66F8\u306E\u4E00\u90E8\u3067\u3042\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u8981\u7D04\u306E\u307F\u3092\u51FA\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u524D\u6587\u3001\u30E9\u30D9\u30EB\u3001\u8AAC\u660E\u306F\u542B\u3081\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002","userPreferences":"\u30C6\u30AD\u30B9\u30C8\u306E\u751F\u6210\u65B9\u6CD5\u306B\u95A2\u3059\u308B\u30E6\u30FC\u30B6\u30FC\u8A2D\u5B9A\u3092\u5C0A\u91CD\u3057\u307E\u3059: {{userPreferences}}\u3002","userPrompt":"\u8981\u7D04: {{userRequestText}}"}},"profile":{"title":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","titlePlural":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","titlePreview":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u30D7\u30EC\u30D3\u30E5\u30FC","previous":"\u4EE5\u524D\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","manage":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u7BA1\u7406","view":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u8868\u793A","edit":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u7DE8\u96C6","add":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8FFD\u52A0\u3059\u308B","create":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F5C\u6210\u3059\u308B","warn":"\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u306B\u306F\u3001\u30AB\u30E1\u30E9\u307E\u305F\u306F\u30DE\u30A4\u30AF\u3092\u8D77\u52D5\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","descriptionShort":"Cephable \u304C\u30C7\u30D0\u30A4\u30B9\u3084\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306E\u5236\u5FA1\u306B\u5F79\u7ACB\u3064\u3055\u307E\u3056\u307E\u306A\u65B9\u6CD5\u3092\u3054\u7D39\u4ECB\u3057\u307E\u3059\u3002","name":"\u30A2\u30D7\u30EA\u540D","nameQuestion":"\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F55\u3068\u547C\u3073\u307E\u3059\u304B?","newName":"\u65B0\u3057\u3044\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","search":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u540D\u524D\u3067\u691C\u7D22","searchLong":"\u540D\u524D\u307E\u305F\u306F\u8AAC\u660E\u3067\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u691C\u7D22\u3059\u308B","keyboardAndMouse":"\u30AD\u30FC\u30DC\u30FC\u30C9\u3068\u30DE\u30A6\u30B9","genericController":"\u30B2\u30FC\u30E0\u30D1\u30C3\u30C9\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC","keyboardMouseAndController":"\u30AD\u30FC\u30DC\u30FC\u30C9\u3001\u30DE\u30A6\u30B9\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC","permissionError":"\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002","set":{"title":"\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u307E\u3060\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u306A\u3044\u3088\u3046\u3067\u3059\u3002","cta":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8A2D\u5B9A\u3059\u308B","empty":{"auto":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8868\u793A\u3059\u308B\u306B\u306F\u5225\u306E\u30A2\u30D7\u30EA\u306B\u5207\u308A\u66FF\u3048\u3066\u304F\u3060\u3055\u3044","select":"\u958B\u59CB\u3059\u308B\u306B\u306F\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044","none":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093"},"description":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3001Cephable\u304C\u4F55\u3092\u691C\u77E5\u3057\u3001\u3069\u306E\u3088\u3046\u306A\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u5B9F\u884C\u3059\u308B\u304B\u3092\u5224\u65AD\u3059\u308B\u305F\u3081\u306E\u3082\u306E\u3067\u3059\u3002\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3001\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8\u307E\u305F\u306F\u63A5\u7D9A\u8A2D\u5B9A\u304B\u3089\u3044\u3064\u3067\u3082\u5207\u308A\u66FF\u3048\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"},"summary":{"title":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u6982\u8981","descriptionLong":"\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u8A73\u7D30\u306F\u6B21\u306E\u3068\u304A\u308A\u3067\u3059\u3002\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3001\u30A2\u30AF\u30B7\u30E7\u30F3\u306A\u3069\u3092\u691C\u7D22\u3057\u3066\u3001\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u4F55\u304C\u3067\u304D\u308B\u304B\u3092\u78BA\u8A8D\u3067\u304D\u307E\u3059\u3002","description":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u5185\u5BB9\u3001\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3001\u8A73\u7D30\u306A\u3069\u3001\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u6982\u8981\u3092\u53D6\u5F97\u3057\u307E\u3059\u3002","view":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u6982\u8981\u3092\u8868\u793A","filter":"\u5165\u529B\u30BF\u30A4\u30D7\u3067\u30D5\u30A3\u30EB\u30BF\u30EA\u30F3\u30B0","placeholder":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u540D\u3092\u691C\u7D22..."},"copy":{"title":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30B3\u30D4\u30FC","duplicate":"\u91CD\u8907\u3057\u305F\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","question":"\u30B3\u30D4\u30FC\u3092\u4F5C\u6210\u3057\u307E\u3059\u304B?","description":"\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u65B0\u3057\u3044\u30B3\u30D4\u30FC\u3092\u4F5C\u6210\u3057\u307E\u3059\u304B? \u3053\u3046\u3059\u308B\u3068\u3001\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30B3\u30D4\u30FC\u3055\u308C\u305F\u65B0\u3057\u3044\u30A6\u30A3\u30F3\u30C9\u30A6\u304C\u958B\u304D\u307E\u3059\u304C\u3001\u4FDD\u5B58\u3059\u308B\u307E\u3067\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u8FFD\u52A0\u3055\u308C\u307E\u305B\u3093\u3002","confirm":"\u306F\u3044\u3001\u30B3\u30D4\u30FC\u3092\u4F5C\u6210\u3057\u307E\u3059","profileSuffix":"{{name}} (\u30B3\u30D4\u30FC)"},"new":{"title":"\u65B0\u3057\u3044\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F5C\u6210\u3059\u308B","description":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4E00\u304B\u3089\u4F5C\u6210\u3059\u308B\u304B\u3001\u6700\u5148\u7AEF\u306E AI \u3067\u30D1\u30FC\u30BD\u30CA\u30E9\u30A4\u30BA\u3055\u308C\u305F\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u751F\u6210\u3057\u3066\u3001\u97F3\u58F0\u3001\u982D\u3001\u9854\u306E\u30B8\u30A7\u30B9\u30C1\u30E3\u30FC\u3092\u4F7F\u7528\u3057\u3066\u30A2\u30D7\u30EA\u3084\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3092\u7C21\u5358\u306B\u64CD\u4F5C\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002","note":"\u4E0A\u7D1A\u30E6\u30FC\u30B6\u30FC\u306B\u304A\u3059\u3059\u3081\u3067\u3059\u3002","scratch":"\u30BC\u30ED\u304B\u3089\u4F5C\u6210"},"advancedOptions":"\u9AD8\u5EA6\u306A\u5236\u5FA1\u30AA\u30D7\u30B7\u30E7\u30F3","delete":{"title":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u524A\u9664","titleLong":"\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u524A\u9664\u3059\u308B","description":"\u300C\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u524A\u9664\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u524A\u9664\u3067\u304D\u307E\u3059\u3002","confirm":"\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B?","confirmLong":"\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u524A\u9664\u3059\u308B\u3068\u3001\u5143\u306B\u623B\u3059\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B?","confirmButton":"\u306F\u3044\u3001\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u524A\u9664\u3057\u307E\u3059"},"current":"\u73FE\u5728\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","loading":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8AAD\u307F\u8FBC\u3093\u3067\u3044\u307E\u3059...","null":"\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u307E\u3060\u3042\u308A\u307E\u305B\u3093\u3002\u4EE5\u4E0B\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002","nullButton":"\u6700\u521D\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F5C\u6210\u3059\u308B","preview":"\u30D7\u30EC\u30D3\u30E5\u30FC","features":"\u7279\u5FB4","byline_public":"\u8457\u8005: Cephable \u30C1\u30FC\u30E0","byline_shared":"\u5171\u6709\u8005: Cephable \u30B3\u30DF\u30E5\u30CB\u30C6\u30A3","share":{"title":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u5171\u6709\u3059\u308B","previewTitle":"\u5171\u6709\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u30D7\u30EC\u30D3\u30E5\u30FC","description":"\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u3068\u5171\u6709\u3059\u308B\u3068\u3001\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u304C\u30B3\u30D4\u30FC\u3092\u53D6\u5F97\u3057\u3066\u305D\u3053\u304B\u3089\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002","descriptionLong":"\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u3068\u5171\u6709\u3059\u308B\u3068\u3001\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u304C\u30B3\u30D4\u30FC\u3092\u53D6\u5F97\u3057\u3066\u305D\u3053\u304B\u3089\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002\u5171\u6709\u65B9\u6CD5\u3092\u9078\u629E\u3057\u3001\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u306B\u9001\u4FE1\u3059\u308B\u30EA\u30F3\u30AF\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002","add":"\u5171\u6709\u30EA\u30F3\u30AF\u3092\u4F5C\u6210\u3059\u308B","confirm":"\u3053\u306EURL\u3092\u5171\u6709\u3059\u308B","link":"\u30EA\u30F3\u30AF\u3092\u5171\u6709","copy":"\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC","copied":"\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F\uFF01","usage":"\u4F7F\u7528\u91CF","created":"{{value}} \u3092\u4F5C\u6210\u3057\u307E\u3057\u305F","expiration":{"title":"\u6709\u52B9\u671F\u9650","once":"1\u56DE\u306E\u307F\u4F7F\u7528\u53EF\u80FD","unlimited":"\u7121\u5236\u9650\u306E\u4F7F\u7528\u3092\u8A31\u53EF\u3059\u308B","no":"\u6709\u52B9\u671F\u9650\u306A\u3057","date":"\u6709\u52B9\u671F\u9650","dateDescription":"\u7279\u5B9A\u306E\u65E5\u4ED8\u306B\u671F\u9650\u5207\u308C\u306B\u306A\u308B"},"manage":"\u4EE5\u524D\u306E\u5171\u6709\u30EA\u30F3\u30AF\u3092\u7BA1\u7406\u3059\u308B","empty":"\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u5171\u6709\u306F\u4F5C\u6210\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002"},"swap":{"title":"\u30B9\u30EF\u30C3\u30D7\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","titleLong":"\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u5165\u308C\u66FF\u3048\u308B","descriptionShort":"\u4F7F\u7528\u3057\u3066\u3044\u308B\u30D7\u30ED\u30B0\u30E9\u30E0\u3084\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306B\u5408\u308F\u305B\u3066\u3001\u3055\u307E\u3056\u307E\u306A\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3057\u307E\u3059\u3002","description":"\u4F7F\u7528\u3057\u3066\u3044\u308B\u30D7\u30ED\u30B0\u30E9\u30E0\u3084\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306B\u5408\u308F\u305B\u3066\u3001\u3055\u307E\u3056\u307E\u306A\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u5207\u308A\u66FF\u3048\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"},"autoProfileSwitching":{"title":"\u81EA\u52D5\u5236\u5FA1\u5207\u308A\u66FF\u3048","alerts":{"disabled":"\u81EA\u52D5\u5236\u5FA1\u5207\u308A\u66FF\u3048\u304C\u30AA\u30D5\u306B\u306A\u3063\u3066\u3044\u307E\u3059\u3002","temporarilyDisabled":"\u81EA\u52D5\u5236\u5FA1\u5207\u308A\u66FF\u3048\u304C\u4E00\u6642\u7684\u306B\u30AA\u30D5\u306B\u306A\u3063\u3066\u3044\u307E\u3059\u3002","enabled":"\u81EA\u52D5\u5236\u5FA1\u5207\u308A\u66FF\u3048\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u307E\u3059\u3002","error":"\u81EA\u52D5\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u5207\u308A\u66FF\u3048\u8A2D\u5B9A\u306E\u4FDD\u5B58\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F"},"associatedPrograms":{"add":"\u65B0\u3057\u3044\u95A2\u9023\u30D7\u30ED\u30B0\u30E9\u30E0\u3092\u8FFD\u52A0\u3059\u308B","description":{"personal":"\u3053\u308C\u3089\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u63A5\u7D9A\u3059\u308B\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u307E\u305F\u306F\u30D7\u30ED\u30B0\u30E9\u30E0\u3092\u9078\u629E\u3057\u307E\u3059\u3002\u3053\u308C\u306F\u81EA\u52D5\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u5207\u308A\u66FF\u3048\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u3066\u304A\u308A\u3001Cephable \u306F\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u73FE\u5728\u4F7F\u7528\u3057\u3066\u3044\u308B\u30D7\u30ED\u30B0\u30E9\u30E0\u306B\u5408\u308F\u305B\u3066\u81EA\u52D5\u7684\u306B\u5207\u308A\u66FF\u3048\u307E\u3059\u3002","short":"\u3053\u308C\u3089\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u63A5\u7D9A\u3059\u308B\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u307E\u305F\u306F\u30D7\u30ED\u30B0\u30E9\u30E0\u3092\u9078\u629E\u3057\u307E\u3059\u3002"},"edit":"\u95A2\u9023\u30D7\u30ED\u30B0\u30E9\u30E0\u3092\u7DE8\u96C6\u3059\u308B","noOptionsText":"\u95A2\u9023\u3059\u308B\u30D7\u30ED\u30B0\u30E9\u30E0\u3092\u691C\u7D22\u3059\u308B\u306B\u306F\u5165\u529B\u3092\u958B\u59CB\u3057\u3066\u304F\u3060\u3055\u3044","profileLabel":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB:","remove":"\u95A2\u9023\u30D7\u30ED\u30B0\u30E9\u30E0\u3092\u524A\u9664\u3059\u308B","title":"\u95A2\u9023\u30D7\u30ED\u30B0\u30E9\u30E0","when":"Cephable \u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C {{profileName}} \u306B\u81EA\u52D5\u7684\u306B\u5207\u308A\u66FF\u308F\u308A\u307E\u3059...","emptySearch":"\u3053\u308C\u3089\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u95A2\u9023\u4ED8\u3051\u3089\u308C\u305F\u30D7\u30ED\u30B0\u30E9\u30E0\u306F\u3042\u308A\u307E\u305B\u3093\u3002","error":"\u95A2\u9023\u30D7\u30ED\u30B0\u30E9\u30E0\u306E\u4FDD\u5B58\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","emptyError":"\u7A7A\u306E\u95A2\u9023\u30D7\u30ED\u30B0\u30E9\u30E0\u304C\u691C\u51FA\u3055\u308C\u307E\u3057\u305F\u3002\u7D9A\u884C\u3059\u308B\u524D\u306B\u524A\u9664\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"commandOverlay":{"command":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u5207\u308A\u66FF\u3048: {{value}}"},"description":"\u81EA\u52D5\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u5207\u308A\u66FF\u3048\u306B\u3088\u308A\u3001Cephable\u306F\u30E6\u30FC\u30B6\u30FC\u306E\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306B\u30B7\u30FC\u30E0\u30EC\u30B9\u306B\u9069\u5FDC\u3057\u307E\u3059\u3002\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001Cephable\u306F\u4F7F\u7528\u3057\u3066\u3044\u308B\u30D7\u30ED\u30B0\u30E9\u30E0\u3084\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306B\u5FDC\u3058\u3066\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8ABF\u6574\u3057\u307E\u3059\u3002\u30AA\u30D5\u306B\u3057\u305F\u5834\u5408\u306F\u3001\u300C\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u5207\u308A\u66FF\u3048\u300D\u30DC\u30BF\u30F3\u307E\u305F\u306F\u30B0\u30ED\u30FC\u30D0\u30EB\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3057\u3066\u3001\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u624B\u52D5\u3067\u5207\u308A\u66FF\u3048\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"},"error":{"noMatch":"\u691C\u7D22\u306B\u4E00\u81F4\u3059\u308B\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3042\u308A\u307E\u305B\u3093\u3002","load":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","add":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u8FFD\u52A0\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","delete":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u524A\u9664\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","audioEventsWithEmptyCommands":"\u30C8\u30FC\u30AF\u30D0\u30C3\u30AF\u306B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u3042\u308A\u307E\u305B\u3093\u3002\u30C8\u30FC\u30AF\u30D0\u30C3\u30AF \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C1\u30A7\u30C3\u30AF\u3057\u3066\u3001\u5B8C\u5168\u306B\u5165\u529B\u3055\u308C\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","conflicts":"\u7AF6\u5408\u306E\u305F\u3081\u3001\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u4FDD\u5B58\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","save":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u4FDD\u5B58\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","device":"\u3053\u306E\u63A5\u7D9A\u3067\u306F\u7121\u52B9\u306A\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u3059\u3002\u5225\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002"},"conflictIndicators":{"errorTitle":"\u7AF6\u5408\u306B\u3088\u308A\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u4FDD\u5B58\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F","warningTitle":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u8B66\u544A\u4ED8\u304D\u3067\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F","subtitle":"\u4F5C\u6210\u3057\u305F\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u306F\u3001\u7AF6\u5408\u3059\u308B\u53EF\u80FD\u6027\u306E\u3042\u308B\u69CB\u6210\u304C\u3044\u304F\u3064\u304B\u3042\u308A\u307E\u3059\u3002","profileNameErrors":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u540D\u524D\u306E\u7AF6\u5408","emptyControlsMapped":"\u5165\u529B\u540D\u304C\u7A7A\u3067\u3059","emptyControlsMappedDescription":"\u5165\u529B\u306B\u306F\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3001\u8868\u60C5\u3001\u982D\u306E\u50BE\u304D\u3001\u305D\u306E\u4ED6\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044\u3002","emptyKeybindingControlsMapped":"\u30AD\u30FC\u30D0\u30A4\u30F3\u30C9\u306E\u7A7A\u306E\u5165\u529B\u540D","emptyKeybindingControlsMappedDescription":"\u30AD\u30FC\u30D0\u30A4\u30F3\u30C9\u306E\u5165\u529B\u306B\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3001\u8868\u60C5\u3001\u982D\u306E\u50BE\u304D\u3001\u307E\u305F\u306F\u305D\u306E\u4ED6\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044\u3002","duplicateNameTitle":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u540D\u304C\u91CD\u8907\u3057\u3066\u3044\u307E\u3059","duplicateNameDescription":"\u540C\u3058\u540D\u524D\u306E\u65E2\u5B58\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u3042\u308A\u307E\u3059\u3002\u7D9A\u884C\u3059\u308B\u524D\u306B\u540D\u524D\u3092\u5909\u66F4\u3057\u3066\u304F\u3060\u3055\u3044\u3002","emptyNameTitle":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u540D\u304C\u7A7A\u3067\u3059","emptyNameDescription":"\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u306F\u540D\u524D\u3092\u4ED8\u3051\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u4F8B: Game 1\u3001Spotify\u3001Word \u306A\u3069\u3002","macrosReleaseKeysMissingTitle":"\u672A\u30EA\u30EA\u30FC\u30B9\u306E\u30AD\u30FC\u306E\u51FA\u529B","macrosReleaseKeysMissingDescription":"\u30AD\u30FC\u304C\u52D5\u304B\u306A\u304F\u306A\u308B\u306E\u3092\u9632\u3050\u306B\u306F\u3001\u30EA\u30EA\u30FC\u30B9 \u30AD\u30FC\u3092\u8FFD\u52A0\u3059\u308B\u304B\u3001\u3059\u3079\u3066\u306E\u30B9\u30C6\u30C3\u30D7\u3092\u505C\u6B62\u3057\u3066\u304F\u3060\u3055\u3044\u3002","duplicateInputCommandMacroTitle":"\u540C\u4E00\u306E\u5236\u5FA1\u5165\u529B","duplicateCommandsDescription":"\u91CD\u8907\u3059\u308B\u5165\u529B\u30B3\u30DE\u30F3\u30C9\u3092\u524A\u9664\u3059\u308B\u304B\u5909\u66F4\u3057\u3066\u304F\u3060\u3055\u3044\u3002","duplicateInputCommandBindingsTitle":"\u30AD\u30FC\u30D0\u30A4\u30F3\u30C7\u30A3\u30F3\u30B0\u306E\u540C\u4E00\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u5165\u529B","conflictIndicatorDisplayString":"{{container}} : {{commandOrKeyName}} \u3068 {{commandOrEventType}}","duplicateMacroNames":"\u91CD\u8907\u3057\u305F\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u540D","duplicateMacroNamesDescription":"\u540C\u4E00\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u540D\u306E\u3044\u305A\u308C\u304B\u3092\u524A\u9664\u3059\u308B\u304B\u5909\u66F4\u3057\u3066\u304F\u3060\u3055\u3044\u3002","warningIgnore":"\u7121\u8996\u3059\u308B","warningDoNotShowAgain":"\u518D\u5EA6\u8B66\u544A\u3092\u8868\u793A\u3057\u306A\u3044","macrosVoiceCommandConflictWithDictationTitle":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30AD\u30FC\u30EF\u30FC\u30C9\u3068\u540C\u3058\u3088\u3046\u306B\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3092\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3057\u307E\u3059","keybindingsVoiceCommandConflictWithDictationTitle":"\u30AD\u30FC\u30D0\u30A4\u30F3\u30C9\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u306F\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30AD\u30FC\u30EF\u30FC\u30C9\u3068\u540C\u3058\u3067\u3059","macrosVoiceCommandConflictWithDictationDescription":"\u97F3\u58F0\u5165\u529B\u306B\u3088\u308A\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3068\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002","keybindingsVoiceCommandConflictWithDictationDescription":"\u97F3\u58F0\u5165\u529B\u306B\u3088\u308A\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3068\u30AD\u30FC\u306E\u62BC\u4E0B\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002","macrosVoiceCommandConflictWithGenerationTitle":"\u751F\u6210\u30AD\u30FC\u30EF\u30FC\u30C9\u3068\u540C\u3058\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3092\u5236\u5FA1\u3059\u308B","keybindingsVoiceCommandConflictWithGenerationTitle":"\u30AD\u30FC\u30D0\u30A4\u30F3\u30C9\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u306F\u751F\u6210\u30AD\u30FC\u30EF\u30FC\u30C9\u3068\u540C\u3058","macrosVoiceCommandConflictWithGenerationDescription":"\u97F3\u58F0\u5165\u529B\u306B\u3088\u308A\u3001\u751F\u6210\u3068\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002","keybindingsVoiceCommandConflictWithGenerationDescription":"\u97F3\u58F0\u5165\u529B\u306B\u3088\u308A\u3001\u751F\u6210\u3068\u30AD\u30FC\u306E\u62BC\u4E0B\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002","duplicateAssociatedProgramNames":"\u95A2\u9023\u30D7\u30ED\u30B0\u30E9\u30E0\u540D\u304C\u91CD\u8907\u3057\u3066\u3044\u307E\u3059","duplicateAssociatedProgramNamesDescription":"\u540C\u4E00\u306E\u95A2\u9023\u30D7\u30ED\u30B0\u30E9\u30E0\u306E 1 \u3064\u3092\u524A\u9664\u3059\u308B\u304B\u5909\u66F4\u3057\u3066\u304F\u3060\u3055\u3044\u3002","emptyEvent":{"title":"\u4E0D\u8DB3\u3057\u3066\u3044\u308B\u624B\u9806","description":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u4E0D\u8DB3\u3057\u3066\u3044\u308B\u624B\u9806\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u30B3\u30DE\u30F3\u30C9\u3092\u767A\u884C\u3057\u3066\u3082 Cephable \u304C\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u5B9F\u884C\u3057\u306A\u3044\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002"},"warningDetails":"\u3059\u3079\u3066\u306E\u7AF6\u5408\u3092\u8868\u793A"},"success":{"save":"\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F\u3002","add":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F\u3002","delete":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002","share":"\u5171\u6709\u30EA\u30F3\u30AF\u304C\u4F5C\u6210\u3055\u308C\u3001\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3055\u308C\u307E\u3057\u305F","shareDelete":"\u5171\u6709\u30EA\u30F3\u30AF\u304C\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002","generate":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u751F\u6210\u3055\u308C\u307E\u3057\u305F\u3002"},"warning":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u8B66\u544A\u4ED8\u304D\u3067\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F","customize":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3059\u308B","custom":"{{name}} (\u30AB\u30B9\u30BF\u30E0)","description":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3001\u30C7\u30D0\u30A4\u30B9\u3084\u63A5\u7D9A\u3092\u5236\u5FA1\u3059\u308B\u305F\u3081\u306B\u4F7F\u7528\u3067\u304D\u308B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u30BB\u30C3\u30C8\u3067\u3059\u3002\u8907\u6570\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F5C\u6210\u3057\u3001\u3044\u3064\u3067\u3082\u5207\u308A\u66FF\u3048\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"},"publicProfiles":{"toolbar":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u63A2\u7D22","title":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u63A2\u7D22","offline":{"title":"\u30D1\u30D6\u30EA\u30C3\u30AF \u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093","description":"\u30AA\u30D5\u30E9\u30A4\u30F3\u306E\u3088\u3046\u3067\u3059\u3002\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u5F15\u304D\u7D9A\u304D\u4F7F\u7528\u3067\u304D\u307E\u3059\u304C\u3001\u65B0\u3057\u3044\u30D1\u30D6\u30EA\u30C3\u30AF \u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8AAD\u307F\u8FBC\u3080\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002","confirm":"\u308F\u304B\u3063\u305F"},"announcement":"{{count}} \u500B\u306E\u65B0\u3057\u3044\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u8AAD\u307F\u8FBC\u307E\u308C\u307E\u3057\u305F","description":{"personal":"\u30D1\u30D6\u30EA\u30C3\u30AF \u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u304A\u6C17\u306B\u5165\u308A\u306E\u30A2\u30D7\u30EA\u3067 Cephable \u3092\u3059\u3050\u306B\u4F7F\u3044\u59CB\u3081\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u3053\u3068\u3082\u3001\u30CB\u30FC\u30BA\u306B\u5408\u308F\u305B\u3066\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3059\u308B\u3053\u3068\u3082\u3001\u307E\u3063\u305F\u304F\u65B0\u3057\u3044\u30AB\u30B9\u30BF\u30E0 \u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u6700\u521D\u304B\u3089\u4F5C\u6210\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002","pro":"\u30D1\u30D6\u30EA\u30C3\u30AF \u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u304A\u6C17\u306B\u5165\u308A\u306E\u30A2\u30D7\u30EA\u3067 Cephable \u3092\u3059\u3050\u306B\u4F7F\u3044\u59CB\u3081\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3057\u305F\u308A\u3001\u30CB\u30FC\u30BA\u306B\u5408\u308F\u305B\u3066\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u305F\u308A\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB \u30B8\u30A7\u30CD\u30EC\u30FC\u30BF\u30FC\u3092\u4F7F\u7528\u3057\u3066\u307E\u3063\u305F\u304F\u65B0\u3057\u3044\u30AB\u30B9\u30BF\u30E0 \u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F5C\u6210\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002"},"team":"\u30BB\u30D5\u30A1\u30D6\u30EB\u30C1\u30FC\u30E0"},"publicTag":"\u516C\u5171","tray":{"panel":"\u30C8\u30B0\u30EB\u30D1\u30CD\u30EB","dashboard":"\u30C0\u30C3\u30B7\u30E5\u30DC\u30FC\u30C9\u3092\u8868\u793A","quit":"Cephable \u3092\u7D42\u4E86\u3059\u308B"},"generate":"\u751F\u6210\u3059\u308B","stop":"\u505C\u6B62","clear":"\u30AF\u30EA\u30A2","rewrite":"\u30EA\u30E9\u30A4\u30C8","translate":"\u7FFB\u8A33\u3059\u308B","smartTasks":{"title":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF","show":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\u3092\u8868\u793A","description":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\u3068\u306F\u3001Cephable\u306EAI\u304C\u3042\u306A\u305F\u306B\u4EE3\u308F\u3063\u3066\u5B9F\u884C\u3067\u304D\u308B\u69D8\u3005\u306A\u30BF\u30B9\u30AF\u3067\u3059\u3002\u3053\u308C\u3089\u306E\u30BF\u30B9\u30AF\u306F\u30C7\u30D0\u30A4\u30B9\u4E0A\u306EAI\u306B\u3088\u3063\u3066\u5B9F\u884C\u3055\u308C\u3001\u30C6\u30AD\u30B9\u30C8\u306E\u4F5C\u6210\u3001\u8981\u7D04\u3001\u66F8\u304D\u76F4\u3057\u3001\u7FFB\u8A33\u3001\u30E1\u30E2\u306E\u4F5C\u6210\u3001\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u4F7F\u3063\u305F\u30C1\u30E3\u30C3\u30C8\u306A\u3069\u306B\u5229\u7528\u3067\u304D\u307E\u3059\u3002","generateText":{"title":"\u30C6\u30AD\u30B9\u30C8\u751F\u6210","description":"\u5165\u529B\u307E\u305F\u306F\u30D7\u30ED\u30F3\u30D7\u30C8\u306B\u57FA\u3065\u3044\u3066\u30C6\u30AD\u30B9\u30C8 \u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002","label":"\u4F55\u3092\u751F\u6210\u3057\u305F\u3044\u306E\u304B\u8AAC\u660E\u3057\u3066\u304F\u3060\u3055\u3044"},"summarizeText":{"title":"\u30C6\u30AD\u30B9\u30C8\u3092\u8981\u7D04\u3059\u308B","description":"\u9577\u3044\u30C6\u30AD\u30B9\u30C8\u3092\u7C21\u6F54\u306A\u8981\u7D04\u306B\u307E\u3068\u3081\u307E\u3059\u3002","directions":"\u8981\u7D04\u3059\u308B\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3059\u308B\u304B\u3001\u5F37\u8ABF\u8868\u793A\u3057\u305F\u30C6\u30AD\u30B9\u30C8\u3092 Cephable \u304C\u81EA\u52D5\u7684\u306B\u4F7F\u7528\u3057\u307E\u3059\u3002","titleShort":"\u8981\u7D04","write":"\u8981\u7D04\u3092\u66F8\u304F","label":"\u8981\u7D04\u3059\u308B\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","outputLabel":"\u3042\u306A\u305F\u306E\u8981\u7D04\u3092\u3053\u3053\u306B\u66F8\u304D\u307E\u3059\u3002"},"rewriteText":{"title":"\u30C6\u30AD\u30B9\u30C8\u306E\u66F8\u304D\u63DB\u3048","description":"\u5225\u306E\u30A2\u30D7\u30EA\u3067\u66F8\u304D\u8FBC\u3093\u3067\u3044\u308B\u30C6\u30AD\u30B9\u30C8\u3092\u30CF\u30A4\u30E9\u30A4\u30C8\u8868\u793A\u3057\u3066\u304B\u3089\u3001\u3053\u3053\u306B\u623B\u3063\u3066\u3001\u3069\u306E\u3088\u3046\u306B\u66F8\u304D\u76F4\u3057\u305F\u3044\u304B\u3092\u8AAC\u660E\u3057\u307E\u3059\u3002","label":"\u30C6\u30AD\u30B9\u30C8\u3092\u3069\u306E\u3088\u3046\u306B\u66F8\u304D\u76F4\u3057\u305F\u3044\u304B\u8AAC\u660E\u3057\u3066\u304F\u3060\u3055\u3044","inputLabel":"\u66F8\u304D\u63DB\u3048\u308B\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"},"translateText":{"title":"\u30C6\u30AD\u30B9\u30C8\u3092\u7FFB\u8A33\u3059\u308B","description":"\u7FFB\u8A33\u3059\u308B\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3059\u308B\u304B\u3001\u5F37\u8ABF\u8868\u793A\u3057\u305F\u30C6\u30AD\u30B9\u30C8\u3092 Cephable \u304C\u81EA\u52D5\u7684\u306B\u4F7F\u7528\u3057\u307E\u3059\u3002","label":"\u7FFB\u8A33\u3059\u308B\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","languageLabel":"\u7FFB\u8A33\u5148\u306E\u8A00\u8A9E"},"noteTaker":{"title":"\u30E1\u30E2\u30C6\u30A4\u30AB\u30FC","description":"Cephable\u3067\u4F1A\u8B70\u3084\u4F1A\u8A71\u3092\u30ED\u30FC\u30AB\u30EB\u3067\u9332\u97F3\u30FB\u66F8\u304D\u8D77\u3053\u3057\u307E\u3057\u3087\u3046"},"documentChat":{"title":"\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u30C1\u30E3\u30C3\u30C8","description":"\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u64CD\u4F5C\u3057\u3066\u30AF\u30A8\u30EA\u3092\u5B9F\u884C\u3057\u3001\u3059\u3050\u306B\u6D1E\u5BDF\u3092\u5F97\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"},"highlightText":{"title":"\u5F37\u8ABF\u8868\u793A\u3055\u308C\u305F\u30C6\u30AD\u30B9\u30C8\u3092\u4F7F\u7528\u3059\u308B","description":"Cephable\u306F\u3001\u30A2\u30D7\u30EA\u3067\u30CF\u30A4\u30E9\u30A4\u30C8\u3057\u305F\u30C6\u30AD\u30B9\u30C8\u3092\u81EA\u52D5\u7684\u306B\u4F7F\u7528\u3057\u3066\u3001\u8981\u7D04\u3001\u66F8\u304D\u76F4\u3057\u3001\u7FFB\u8A33\u306A\u3069\u306E\u30BF\u30B9\u30AF\u3092\u5B9F\u884C\u3057\u307E\u3059\u3002\u5FC5\u8981\u306B\u5FDC\u3058\u3066\u3001\u624B\u52D5\u3067\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002","label":"\u4F7F\u7528\u3059\u308B\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","placeholder":"\u5225\u306E\u30A2\u30D7\u30EA\u3067\u30C6\u30AD\u30B9\u30C8\u3092\u30CF\u30A4\u30E9\u30A4\u30C8\u3057\u3001\u3053\u3053\u306B\u623B\u3063\u3066\u4F7F\u7528\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002"},"pasteText":{"title":"\u30C6\u30AD\u30B9\u30C8\u3092\u8CBC\u308A\u4ED8\u3051\u308B","description":"Cephable\u306F\u3001\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3057\u305F\u30C6\u30AD\u30B9\u30C8\u3092\u81EA\u52D5\u7684\u306B\u4F7F\u7528\u3057\u3066\u3001\u8981\u7D04\u3001\u66F8\u304D\u76F4\u3057\u3001\u7FFB\u8A33\u306A\u3069\u306E\u30BF\u30B9\u30AF\u3092\u5B9F\u884C\u3057\u307E\u3059\u3002\u5FC5\u8981\u306B\u5FDC\u3058\u3066\u3001\u624B\u52D5\u3067\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002","label":"\u4F7F\u7528\u3059\u308B\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","placeholder":"\u5225\u306E\u30A2\u30D7\u30EA\u3067\u30C6\u30AD\u30B9\u30C8\u3092\u30CF\u30A4\u30E9\u30A4\u30C8\u3057\u3001\u3053\u3053\u306B\u623B\u3063\u3066\u4F7F\u7528\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002"},"clearCache":"\u751F\u6210\u6642\u306B\u554F\u984C\u304C\u767A\u751F\u3057\u305F\u5834\u5408\u306F\u3001\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u8A2D\u5B9A\u304B\u3089\u30AD\u30E3\u30C3\u30B7\u30E5\u3068\u30EA\u30BD\u30FC\u30B9\u3092\u30AF\u30EA\u30A2\u3057\u3066\u3001\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","transcribeAudio":{"title":"\u97F3\u58F0\u3092\u66F8\u304D\u8D77\u3053\u3059","description":"AI \u30C8\u30E9\u30F3\u30B9\u30AF\u30EA\u30D7\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3057\u3066\u3001\u30AA\u30FC\u30C7\u30A3\u30AA \u30D5\u30A1\u30A4\u30EB\u307E\u305F\u306F\u30D3\u30C7\u30AA \u30D5\u30A1\u30A4\u30EB\u3092\u30C6\u30AD\u30B9\u30C8\u306B\u5909\u63DB\u3057\u307E\u3059\u3002","inputMethod":"\u5165\u529B\u65B9\u6CD5\u3092\u9078\u629E","localFile":"\u30ED\u30FC\u30AB\u30EB\u30D5\u30A1\u30A4\u30EB","url":"URL","selectFile":"\u30AA\u30FC\u30C7\u30A3\u30AA/\u30D3\u30C7\u30AA\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E","urlLabel":"\u30AA\u30FC\u30C7\u30A3\u30AA/\u30D3\u30C7\u30AAURL","transcribe":"\u8EE2\u5199","result":"\u8EE2\u5199\u7D50\u679C","invalidFileType":"\u6709\u52B9\u306A\u30AA\u30FC\u30C7\u30A3\u30AA\u307E\u305F\u306F\u30D3\u30C7\u30AA\u30D5\u30A1\u30A4\u30EB\uFF08mp3\u3001wav\u3001ogg\u3001mp4\u3001webm\u3001mov\u3001avi\uFF09\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044","error":"\u8EE2\u8A18\u30A8\u30E9\u30FC","history":{"title":"\u8EE2\u5199\u5C65\u6B74","description":"\u4FDD\u5B58\u3057\u305F\u6587\u5B57\u8D77\u3053\u3057\u3092\u8868\u793A\u304A\u3088\u3073\u7BA1\u7406\u3057\u307E\u3059\u3002","viewHistory":"\u5C65\u6B74\u3092\u8868\u793A","empty":"\u307E\u3060\u66F8\u304D\u8D77\u3053\u3057\u304C\u3042\u308A\u307E\u305B\u3093\u3002\u66F8\u304D\u8D77\u3053\u3057\u3092\u59CB\u3081\u3066\u3001\u6B74\u53F2\u3092\u7BC9\u304D\u307E\u3057\u3087\u3046\u3002","titleLabel":"\u30BF\u30A4\u30C8\u30EB\uFF08\u30AA\u30D7\u30B7\u30E7\u30F3\uFF09","titlePlaceholder":"\u3053\u306E\u8EE2\u5199\u306E\u30BF\u30A4\u30C8\u30EB\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","textLabel":"\u8EE2\u5199\u30C6\u30AD\u30B9\u30C8","confirmDelete":"\u3053\u306E\u8EE2\u5199\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B?"}},"aiWorkflows":{"description":"AI\u3092\u6D3B\u7528\u3057\u3066\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u3068\u30D6\u30E9\u30A6\u30B6\u306E\u30BF\u30B9\u30AF\u3092\u81EA\u52D5\u5316\u3002\u3084\u308A\u305F\u3044\u3053\u3068\u3092\u8AAC\u660E\u3059\u308B\u3060\u3051\u3067\u3001Cephable\u304C\u81EA\u52D5\u7684\u306B\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u5B9F\u884C\u3057\u307E\u3059\u3002","label":"\u9054\u6210\u3057\u305F\u3044\u3053\u3068\u3092\u8AAC\u660E\u3057\u3066\u304F\u3060\u3055\u3044","status":{"idle":"\u3054\u6307\u793A\u3092\u304A\u5F85\u3061\u3057\u3066\u3044\u307E\u3059...","initializing":"\u6E96\u5099\u4E2D\u3067\u3059...","planning":["\u8A08\u753B\u3092\u7ACB\u3066\u3066\u3044\u307E\u3059...","\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u8A73\u3057\u304F\u8AAC\u660E\u3057\u307E\u3059...","\u624B\u9806\u3092\u56F3\u89E3\u3057\u307E\u3059...","\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u6574\u7406\u3057\u3066\u3044\u307E\u3059...","\u6226\u7565\u3092\u6E96\u5099\u4E2D...","\u884C\u52D5\u8A08\u753B\u3092\u4F5C\u6210\u3057\u3066\u3044\u307E\u3059...","\u3042\u306A\u305F\u3092\u52A9\u3051\u308B\u305F\u3081\u306E\u6700\u5584\u306E\u65B9\u6CD5\u3092\u8003\u3048\u307E\u3059...","\u3053\u308C\u306B\u3069\u306E\u3088\u3046\u306B\u30A2\u30D7\u30ED\u30FC\u30C1\u3059\u308B\u304B\u3092\u6C7A\u5B9A\u3057\u307E\u3059...","\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u5206\u6790\u3057\u3066\u3044\u307E\u3059...","\u5B9F\u884C\u3092\u8A08\u753B\u4E2D..."],"thinking":["\u8003\u3048...","\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u5206\u6790\u3057\u3066\u3044\u307E\u3059...","\u3042\u306A\u305F\u3092\u52A9\u3051\u308B\u6700\u5584\u306E\u65B9\u6CD5\u3092\u8003\u3048\u307E\u3059...","\u6B21\u306B\u4F55\u3092\u3059\u308B\u304B\u3092\u6C7A\u5B9A\u3057\u307E\u3059...","\u524D\u306E\u624B\u9806\u3092\u51E6\u7406\u3057\u3066\u3044\u307E\u3059...","\u30EA\u30AF\u30A8\u30B9\u30C8\u306B\u5BFE\u5FDC\u4E2D\u3067\u3059...","\u8A73\u7D30\u3092\u53D6\u5F97\u3057\u3066\u3044\u307E\u3059...","\u8A08\u753B\u3092\u898B\u76F4\u3057\u3066\u3044\u307E\u3059...","\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u691C\u8A0E\u4E2D...","\u4F5C\u6210\u3001\u8A55\u4FA1\u3001\u6C7A\u5B9A..."],"waitingForUser":"\u7D9A\u884C\u3059\u308B\u306B\u306F\u3042\u306A\u305F\u306E\u5165\u529B\u304C\u5FC5\u8981\u3067\u3059\u3002","completed":"\u6210\u529F\uFF01","failed":"\u30EA\u30AF\u30A8\u30B9\u30C8\u306F\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","canceled":"\u30EA\u30AF\u30A8\u30B9\u30C8\u306F\u30AD\u30E3\u30F3\u30BB\u30EB\u3055\u308C\u307E\u3057\u305F\u3002","terminated":"\u505C\u6B62\u3057\u307E\u3057\u305F\u3002\u6307\u793A\u3092\u5F85\u3063\u3066\u3044\u307E\u3059...","thinkingInteractive":["\u6B21\u306E\u30B9\u30C6\u30C3\u30D7\u3092\u691C\u8A0E\u3057\u3066\u3044\u307E\u3059...","\u3053\u308C\u307E\u3067\u3084\u3063\u3066\u304D\u305F\u3053\u3068\u3092\u632F\u308A\u8FD4\u3063\u3066\u307F\u308B\u3068\u2026","\u6B21\u306B\u4F55\u3092\u3059\u308B\u304B\u6C7A\u3081\u3066\u3044\u307E\u3059...","\u7D50\u679C\u3092\u5206\u6790\u3057\u3066\u3044\u307E\u3059...","\u7D9A\u304D\u3092\u4F01\u753B\u4E2D\u2026","\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u8A55\u4FA1\u3057\u3066\u3044\u307E\u3059...","\u6700\u5584\u306E\u6B21\u306E\u30B9\u30C6\u30C3\u30D7\u3092\u8003\u3048\u307E\u3059...","\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u6B21\u306E\u90E8\u5206\u306B\u53D6\u308A\u7D44\u3093\u3067\u3044\u307E\u3059...","\u6B21\u306E\u30B9\u30C6\u30C3\u30D7\u306B\u53D6\u308A\u7D44\u3093\u3067\u3044\u307E\u3059...","\u524D\u306E\u30B9\u30C6\u30C3\u30D7\u306E\u7D50\u679C\u3092\u51E6\u7406\u3057\u3066\u3044\u307E\u3059..."],"tools":{"click_element_by_index":{"executing-start":"\u8A72\u5F53\u3059\u308B\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068...","executing-complete":"{{params.index}}\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3057\u305F\u3002"},"click_element":{"executing-start":"\u30CF\u30A4\u30E9\u30A4\u30C8\u8868\u793A\u3055\u308C\u305F\u756A\u53F7\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068...","executing-complete":"{{params.elementName}}\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3057\u305F\u3002"},"copy_selection":{"executing-start":"\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3092\u53CE\u96C6\u3057\u3066\u3044\u307E\u3059...","executing-complete":"\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u306F\u3042\u308A\u307E\u3059\u306E\u3067\u3001\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u6B21\u306E\u90E8\u5206\u306B\u5BFE\u5FDC\u3059\u308B\u6E96\u5099\u304C\u3067\u304D\u3066\u3044\u307E\u3059\u3002"},"create_file":{"executing-start":"\u30D5\u30A1\u30A4\u30EB\u3092\u4F5C\u6210\u3057\u3066\u3044\u307E\u3059...","executing-complete":"{{params.fileName}} \u3068\u3044\u3046\u540D\u524D\u306E\u30D5\u30A1\u30A4\u30EB\u3092\u4F5C\u6210\u3057\u307E\u3057\u305F\u3002"},"draft_email":{"executing-start":"\u30E1\u30FC\u30EB\u3092\u4F5C\u6210\u4E2D\u3067\u3059...","executing-complete":"{{params.subject}} \u306B\u95A2\u3059\u308B\u30E1\u30FC\u30EB\u3092\u4F5C\u6210\u3057\u307E\u3057\u305F\u3002"},"execute_app_action":{"executing-start":"{{params.actionName}} \u3092\u5B9F\u884C\u3057\u3066\u3044\u307E\u3059...","executing-complete":"{{params.actionName}}\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002"},"find_all_text":{"executing-start":"{{params.searchText}} \u306B\u95A2\u3059\u308B\u3059\u3079\u3066\u306E\u95A2\u9023\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3092\u691C\u7D22\u3057\u3066\u3044\u307E\u3059...","executing-complete":"{{params.searchText}} \u306B\u95A2\u3059\u308B\u3059\u3079\u3066\u306E\u95A2\u9023\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u304C\u898B\u3064\u304B\u308A\u307E\u3057\u305F\u3002"},"find_and_select_text":{"executing-start":"{{params.searchText}} \u306B\u95A2\u3059\u308B\u95A2\u9023\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3092\u691C\u7D22\u3057\u3066\u9078\u629E\u3057\u3066\u3044\u307E\u3059...","executing-complete":"{{params.searchText}} \u306B\u95A2\u3059\u308B\u95A2\u9023\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3092\u898B\u3064\u3051\u3066\u9078\u629E\u3057\u307E\u3057\u305F\u3002"},"generate_text":{"executing-start":"\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F5C\u6210\u3057\u3066\u3044\u307E\u3059...","executing-progress":"\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F5C\u6210\u4E2D...{{progress}}%","executing-complete":"\u8981\u6C42\u3055\u308C\u305F\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F5C\u6210\u3057\u307E\u3057\u305F\u3002"},"get_all_interactive_elements":{"executing-start":"\u3088\u308A\u591A\u304F\u306E\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3092\u53D6\u5F97\u3059\u308B\u305F\u3081\u306B\u30B9\u30AD\u30E3\u30F3\u3057\u3066\u3044\u307E\u3059...","executing-complete":"\u4F55\u3068\u3084\u308A\u3068\u308A\u3067\u304D\u308B\u304B\u7406\u89E3\u3057\u307E\u3057\u305F\u3002"},"get_all_text_elements_content":{"executing-start":"\u3088\u308A\u591A\u304F\u306E\u6587\u8108\u3092\u7406\u89E3\u3059\u308B\u305F\u3081\u306B\u8AAD\u3093\u3067\u304F\u3060\u3055\u3044...","executing-complete":"\u5229\u7528\u53EF\u80FD\u306A\u30C6\u30AD\u30B9\u30C8\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u7406\u89E3\u3057\u3066\u3044\u307E\u3059\u3002"},"get_all_text_elements_names":{"executing-start":"\u3088\u308A\u591A\u304F\u306E\u6587\u8108\u3092\u7406\u89E3\u3059\u308B\u305F\u3081\u306B\u8AAD\u3093\u3067\u304F\u3060\u3055\u3044...","executing-complete":"\u5229\u7528\u53EF\u80FD\u306A\u30C6\u30AD\u30B9\u30C8\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u7406\u89E3\u3057\u3066\u3044\u307E\u3059\u3002"},"get_available_profile_actions":{"executing-start":"\u3053\u306E\u30A2\u30D7\u30EA\u3067\u4F7F\u7528\u3067\u304D\u308B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u78BA\u8A8D\u3057\u3066\u3044\u307E\u3059...","executing-complete":"\u3053\u306E\u30A2\u30D7\u30EA\u3067\u4F55\u304C\u3067\u304D\u308B\u306E\u304B\u7406\u89E3\u3057\u307E\u3057\u305F\u3002"},"get_document_content":{"executing-start":"\u3088\u308A\u591A\u304F\u306E\u6587\u8108\u3092\u7406\u89E3\u3059\u308B\u305F\u3081\u306B\u8AAD\u3093\u3067\u304F\u3060\u3055\u3044...","executing-complete":"\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u306F\u3042\u308A\u307E\u3059\u306E\u3067\u3001\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u6B21\u306E\u90E8\u5206\u306B\u5BFE\u5FDC\u3059\u308B\u6E96\u5099\u304C\u3067\u304D\u3066\u3044\u307E\u3059\u3002"},"get_installed_apps":{"executing-start":"\u30EA\u30AF\u30A8\u30B9\u30C8\u306B\u95A2\u9023\u3059\u308B\u30A2\u30D7\u30EA\u3092\u6C7A\u5B9A\u3057\u3066\u3044\u307E\u3059...","executing-complete":"\u3069\u306E\u30A2\u30D7\u30EA\u304C\u4F7F\u3048\u308B\u304B\u308F\u304B\u3063\u3066\u3044\u307E\u3059\u3002"},"get_running_app_names":{"executing-start":"\u30EA\u30AF\u30A8\u30B9\u30C8\u306B\u95A2\u9023\u3059\u308B\u30A2\u30D7\u30EA\u3092\u6C7A\u5B9A\u3057\u3066\u3044\u307E\u3059...","executing-complete":"\u3069\u306E\u30A2\u30D7\u30EA\u304C\u4F7F\u3048\u308B\u304B\u308F\u304B\u3063\u3066\u3044\u307E\u3059\u3002"},"get_selected_text":{"executing-start":"\u9078\u629E\u3057\u305F\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u8AAD\u307F\u8FBC\u3093\u3067\u3044\u307E\u3059...","executing-complete":"\u9078\u629E\u3057\u305F\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u304C\u3042\u308A\u307E\u3059\u3002"},"get_stored_content":{"executing-start":"\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3092\u53CE\u96C6\u3057\u3066\u3044\u307E\u3059...","executing-complete":"\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u306F\u3042\u308A\u307E\u3059\u306E\u3067\u3001\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u6B21\u306E\u90E8\u5206\u306B\u5BFE\u5FDC\u3059\u308B\u6E96\u5099\u304C\u3067\u304D\u3066\u3044\u307E\u3059\u3002"},"keyboard_shortcut":{"executing-start":"\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3092\u53CE\u96C6\u3057\u3066\u3044\u307E\u3059...","executing-complete":"\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u306F\u3042\u308A\u307E\u3059\u306E\u3067\u3001\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u6B21\u306E\u90E8\u5206\u306B\u5BFE\u5FDC\u3059\u308B\u6E96\u5099\u304C\u3067\u304D\u3066\u3044\u307E\u3059\u3002"},"open_app":{"executing-start":"{{params.appName}} \u3092\u958B\u3044\u3066\u3044\u307E\u3059...","executing-complete":"{{params.appName}}\u3092\u958B\u304D\u307E\u3057\u305F\u3002"},"open_webpage":{"executing-start":"{{params.url}} \u3092\u958B\u3044\u3066\u3044\u307E\u3059...","executing-complete":"{{params.url}}\u3092\u958B\u304D\u307E\u3057\u305F\u3002"},"paste_content":{"executing-start":"\u66F8\u304D\u8FBC\u307F...","executing-complete":"\u66F8\u304D\u7D42\u308F\u308A\u307E\u3057\u305F\u3002"},"respond_to_user":{"executing-start":"\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u5B8C\u4E86\u3057\u3066\u3044\u307E\u3059...","executing-complete:":"\u3054\u8981\u671B\u306B\u304A\u5FDC\u3048\u3057\u307E\u3057\u305F\u3002"},"search_and_open_file":{"executing-start":"\u30D5\u30A1\u30A4\u30EB {{params.query}} \u3092\u691C\u7D22\u3057\u3066\u958B\u3044\u3066\u3044\u307E\u3059...","executing-complete":"\u30D5\u30A1\u30A4\u30EB {{params.query}} \u3092\u691C\u7D22\u3057\u3066\u958B\u304D\u307E\u3057\u305F\u3002"},"search_browser":{"executing-start":"{{params.query}} \u3092 Web \u3067\u691C\u7D22\u3057\u3066\u3044\u307E\u3059...","executing-complete":"{{params.query}}\u3092Web\u3067\u691C\u7D22\u3057\u307E\u3057\u305F\u3002"},"select_all_text":{"executing-start":"\u3059\u3079\u3066\u306E\u30C6\u30AD\u30B9\u30C8\u3092\u9078\u629E\u3057\u3066\u3044\u307E\u3059...","executing-complete":"\u3059\u3079\u3066\u306E\u30C6\u30AD\u30B9\u30C8\u3092\u9078\u629E\u3057\u307E\u3057\u305F\u3002"},"summarize_text":{"executing-start":"\u672C\u6587\u3092\u8981\u7D04\u3059\u308B\u3068\u2026","executing-progress":"\u8981\u7D04\u4E2D...{{\u9032\u6357}}%","executing-complete":"\u672C\u6587\u3092\u8981\u7D04\u3057\u307E\u3057\u305F\u3002"},"translate_text":{"executing-start":"\u30C6\u30AD\u30B9\u30C8\u3092 {{params.targetLanguage}} \u306B\u7FFB\u8A33\u3057\u3066\u3044\u307E\u3059...","executing-progress":"\u7FFB\u8A33\u4E2D...{{progress}}%","executing-complete":"\u30C6\u30AD\u30B9\u30C8\u3092 {{params.targetLanguage}} \u306B\u7FFB\u8A33\u3057\u307E\u3057\u305F\u3002"},"type_stored_content":{"executing-start":"\u66F8\u304D\u8FBC\u307F...","executing-complete":"\u66F8\u304D\u7D42\u308F\u308A\u307E\u3057\u305F\u3002"},"type_text":{"executing-start":"\u66F8\u304D\u8FBC\u307F...","executing-complete":"\u66F8\u304D\u7D42\u308F\u308A\u307E\u3057\u305F\u3002"},"write_file_content":{"executing-start":"\u30D5\u30A1\u30A4\u30EB\u306B\u66F8\u304D\u8FBC\u307F\u4E2D...","executing-complete":"\u30D5\u30A1\u30A4\u30EB {{params.fileName}} \u3078\u306E\u66F8\u304D\u8FBC\u307F\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002"},"unknown":{"executing-start":"\u554F\u984C\u304C\u767A\u751F\u3057\u305F\u306E\u3067\u3001\u5225\u306E\u6226\u7565\u3092\u8A66\u3057\u307E\u3057\u305F...","executing-complete":"\u5225\u306E\u6226\u7565\u3092\u8A66\u3057\u3066\u307F\u307E\u3057\u305F\u3002"}},"networkError":"\u30E2\u30C7\u30EB\u306E\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u4E2D\u306B\u63A5\u7D9A\u304C\u5207\u65AD\u3055\u308C\u307E\u3057\u305F\u3002\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u63A5\u7D9A\u3092\u78BA\u8A8D\u3057\u3001\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u9001\u4FE1\u3059\u308B\u304B\u30A2\u30D7\u30EA\u3092\u518D\u8D77\u52D5\u3057\u3066\u518D\u8A66\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002","executing-org-block":"{{params.toolName}} \u306F\u3001{{params.appOrDomain}} \u3068\u306E\u3084\u308A\u53D6\u308A\u304C\u7D44\u7E54\u306B\u3088\u3063\u3066\u30D6\u30ED\u30C3\u30AF\u3055\u308C\u3066\u3044\u308B\u305F\u3081\u3001\u4F7F\u7528\u3067\u304D\u307E\u305B\u3093\u3002","executing-destructive-block":"{{params.elementName}}\u3068\u306E\u3084\u308A\u53D6\u308A\u306F\u30D6\u30ED\u30C3\u30AF\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u5185\u5BB9\u3092\u3054\u78BA\u8A8D\u306E\u4E0A\u3001\u624B\u52D5\u3067\u64CD\u4F5C\u3057\u3066\u304F\u3060\u3055\u3044\u3002","executing-type-focus-block":"\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u5165\u529B\u306B\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u5185\u5BB9\u306F\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3055\u308C\u3066\u3044\u307E\u3059\u306E\u3067\u3001\u624B\u52D5\u3067\u8CBC\u308A\u4ED8\u3051\u3066\u304F\u3060\u3055\u3044\u3002"},"ready":{"waiting":"AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306E\u6E96\u5099\u304C\u6574\u3044\u307E\u3057\u305F\u3002\u3054\u6307\u793A\u3092\u304A\u5F85\u3061\u3057\u3066\u3044\u307E\u3059\u3002","execute":"AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u304C\u6E96\u5099\u5B8C\u4E86\u3067\u3059\u3002\u3054\u8981\u671B\u306B\u5FDC\u3058\u3066\u958B\u59CB\u3057\u307E\u3059\u3002"},"start":"\u59CB\u3081\u308B","progress":"\u50CD\u304F...","introModal":{"description":"\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u3084\u30D6\u30E9\u30A6\u30B6\u306E\u30BF\u30B9\u30AF\u3092\u81EA\u52D5\u5316\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002\u3084\u308A\u305F\u3044\u3053\u3068\u3092\u6559\u3048\u3066\u3044\u305F\u3060\u3051\u308C\u3070\u3001\u3042\u3068\u306F\u79C1\u304C\u3059\u3079\u3066\u51E6\u7406\u3057\u307E\u3059\u3002\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u306B\u5B9F\u884C\u3055\u308C\u308B\u305F\u3081\u3001\u30C7\u30FC\u30BF\u306F\u304A\u5BA2\u69D8\u306E\u3082\u306E\u3067\u3059\u3002\u307E\u305A\u3001\u30ED\u30FC\u30AB\u30EBAI\u30E2\u30C7\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u4ECA\u3059\u3050\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u6E96\u5099\u3057\u3066\u3044\u305F\u3060\u304F\u304B\u3001\u6700\u521D\u306E\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u958B\u59CB\u3057\u305F\u969B\u306B\u81EA\u52D5\u7684\u306B\u53D6\u5F97\u3057\u307E\u3059\u3002","confirm":"\u4ECA\u3059\u3050\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9","cancel":"\u4ECA\u306F\u30B9\u30AD\u30C3\u30D7","title":"AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u304C\u5229\u7528\u53EF\u80FD\u3067\u3059"},"title":"AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306E\u6E96\u5099\u304C\u6574\u3044\u307E\u3057\u305F"},"generatedByAI":"\u30C7\u30D0\u30A4\u30B9\u4E0A\u306E AI \u3092\u642D\u8F09\u3057\u3066\u3044\u307E\u3059\u3002\u6B63\u78BA\u6027\u306B\u3064\u3044\u3066\u306F\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002","networkError":"\u30E2\u30C7\u30EB\u306E\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u4E2D\u306B\u63A5\u7D9A\u304C\u5207\u65AD\u3055\u308C\u307E\u3057\u305F\u3002\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u63A5\u7D9A\u3092\u78BA\u8A8D\u3057\u3001\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u9001\u4FE1\u3059\u308B\u304B\u30A2\u30D7\u30EA\u3092\u518D\u8D77\u52D5\u3057\u3066\u518D\u8A66\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002","genericError":"\u4E88\u671F\u305B\u306C\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","download":{"title":"AI\u30E2\u30C7\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u3001\u3088\u308A\u591A\u304F\u306E\u6A5F\u80FD\u3092\u89E3\u304D\u653E\u3061\u307E\u3057\u3087\u3046","description":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\u3092\u4F7F\u7528\u3059\u308B\u306B\u306F\u3001\u30ED\u30FC\u30AB\u30EB\u30E2\u30C7\u30EB\u3092\u30C7\u30D0\u30A4\u30B9\u306B\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u30C7\u30FC\u30BF\u306E\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u304C\u4FDD\u8B77\u3055\u308C\u3001\u30AF\u30E9\u30A6\u30C9\u306B\u9001\u4FE1\u3055\u308C\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002","confirm":"\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9","cancel":"\u4ECA\u3058\u3083\u306A\u3044","includeWorkflows":"\u9AD8\u5EA6\u306A\u81EA\u52D5\u5316\u3092\u5B9F\u73FE\u3059\u308B\u306B\u306F\u3001AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u30E2\u30C7\u30EB\u3082\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002"}},"inputMethod":"\u5165\u529B\u65B9\u6CD5:","hotkey":{"title":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3","titlePlural":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3","titlePanel":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3","label":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u306E\u8868\u793A\u540D","placeholder":"\u8868\u793A\u3059\u308B\u540D\u524D","question":"\u3053\u306E\u30DC\u30BF\u30F3\u306B\u3069\u3093\u306A\u540D\u524D\u3092\u4ED8\u3051\u307E\u3059\u304B?","when":"\u30BF\u30C3\u30D7\u3059\u308B\u3068\u2026","description":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u306F\u3001\u30A2\u30D7\u30EA\u4E0A\u3067\u95A2\u9023\u3059\u308B\u64CD\u4F5C\u3092\u5B9F\u884C\u3059\u308B\u305F\u3081\u306B\u30BF\u30C3\u30D7\u3067\u304D\u308B\u3001\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u53EF\u80FD\u306A\u30DC\u30BF\u30F3\u3067\u3059\u30021\u56DE\u306E\u30BF\u30C3\u30D7\u3067\u8907\u6570\u306E\u624B\u9806\u3092\u5B9F\u884C\u3057\u305F\u308A\u3001\u5358\u4E00\u306E\u64CD\u4F5C\u3092\u5B9F\u884C\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002","usagePrompt":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u306F\u3001\u30A2\u30D7\u30EA\u4E0A\u3067\u95A2\u9023\u3059\u308B\u64CD\u4F5C\u3092\u5B9F\u884C\u3059\u308B\u305F\u3081\u306B\u30BF\u30C3\u30D7\u3067\u304D\u308B\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u53EF\u80FD\u306A\u30DC\u30BF\u30F3\u3067\u3059\u3002\u30E1\u30A4\u30F3\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u8A2D\u5B9A\u30DA\u30FC\u30B8\u304B\u3089\u3001\u30DC\u30BF\u30F3\u306E\u8FFD\u52A0\u3001\u524A\u9664\u3001\u540D\u524D\u306E\u7DE8\u96C6\u3092\u884C\u3046\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","reorder":"\u4E0A\u3078\u79FB\u52D5\u30DC\u30BF\u30F3\u3068\u4E0B\u3078\u79FB\u52D5\u30DC\u30BF\u30F3\u3092\u4F7F\u7528\u3057\u3066\u9806\u5E8F\u3092\u4E26\u3079\u66FF\u3048\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","emptyTitle":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u306A\u3057","edit":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u306E\u7DE8\u96C6","tap":"{{value}}\u3092\u30BF\u30C3\u30D7","copySuffix":"{{name}}_\u30B3\u30D4\u30FC","hotkeysOnly":"\u30AB\u30B9\u30BF\u30E0\u30DC\u30BF\u30F3","allControls":"\u3059\u3079\u3066\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","show":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u3092\u8868\u793A","deprecatedDialog":{"title":"\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u66F4\u65B0\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","description2":"\u305F\u3063\u305F1\u79D2\u306E\u7C21\u5358\u306A\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u3067\u3001\u30B7\u30FC\u30E0\u30EC\u30B9\u306A\u30DC\u30BF\u30F3\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u4F53\u9A13\u3092\u304A\u697D\u3057\u307F\u3044\u305F\u3060\u3051\u307E\u3059\u3002\u9762\u5012\u306A\u624B\u9806\u306F\u3082\u3046\u4E0D\u8981\u3002\u3088\u308A\u30E6\u30FC\u30B6\u30FC\u30D5\u30EC\u30F3\u30C9\u30EA\u30FC\u306A\u30A4\u30F3\u30BF\u30FC\u30D5\u30A7\u30FC\u30B9\u304C\u3042\u306A\u305F\u3092\u5F85\u3063\u3066\u3044\u307E\u3059\u3002\u3055\u3042\u3001\u4E57\u308A\u63DB\u3048\u306E\u6E96\u5099\u306F\u3067\u304D\u3066\u3044\u307E\u3059\u304B\uFF1F","confirm":"\u3084\u308A\u307E\u3057\u3087\u3046\uFF01","description1":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u4ED8\u304D\u306E\u53E4\u3044\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u3054\u5229\u7528\u306E\u3088\u3046\u3067\u3059\u306D\u3002\u30A8\u30AD\u30B5\u30A4\u30C6\u30A3\u30F3\u30B0\u306A\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u3092\u3054\u7528\u610F\u3057\u307E\u3057\u305F\uFF01\u30B7\u30B9\u30C6\u30E0\u3092\u5237\u65B0\u3057\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u306E\u4F5C\u6210\u3068\u7DE8\u96C6\u304C\u7C21\u5358\u306B\u306A\u308A\u307E\u3057\u305F\u3002\u3082\u3046\u8A73\u7D30\u306A\u8A2D\u5B9A\u306B\u7169\u308F\u3055\u308C\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002"},"demo":{"title":"\u30C7\u30E2\u306E\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3","step1":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u3092\u30AA\u30F3\u306B\u3059\u308B","step2":"\u30C6\u30AD\u30B9\u30C8 \u30D6\u30ED\u30C3\u30AF\u3092\u5236\u5FA1\u3059\u308B\u306B\u306F\u3001\u4EE5\u4E0B\u306E\u30B5\u30F3\u30D7\u30EB \u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u4F7F\u7528\u3057\u307E\u3059\u3002","command1":"\u30DC\u30BF\u30F31\u3092\u62BC\u3059\u3068\u300C\u6587\u5B57\u3092\u5927\u304D\u304F\u3059\u308B\u300D","command2":"\u30DC\u30BF\u30F32\u3092\u62BC\u3059\u3068\u300C\u592A\u5B57\u300D\u306B\u306A\u308A\u307E\u3059","command3":"","continue":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u3067\u7D9A\u884C","description":"\u4EE5\u4E0B\u306E\u30C7\u30E2\u30A8\u30EA\u30A2\u3067\u306F\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u3092\u8A66\u3059\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u30C7\u30E2\u3067\u306F\u3001\u4EE5\u4E0B\u306E\u30C6\u30AD\u30B9\u30C8\u30A8\u30EA\u30A2\u306E\u64CD\u4F5C\u306E\u307F\u306B\u9650\u5B9A\u3055\u308C\u3066\u3044\u307E\u3059\u3002"},"example":{"title":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u306E\u4F8B","command1":"\u4E00\u6642\u505C\u6B62\u3092\u30BF\u30C3\u30D7","example1":"\u4F8B\uFF1A\u300C\u30D3\u30C7\u30AA\u3092\u4E00\u6642\u505C\u6B62\u300D","command2":"\u300C\u9032\u3080\u300D\u3092\u30BF\u30C3\u30D7","example2":"\u300C\u30BA\u30FC\u30E0\u30A2\u30A6\u30C8\u300D\u306E\u4F8B","command3":"\u30BF\u30C3\u30D7\u30B9\u30C8\u30C3\u30D7","example3":"\u4F8B\uFF1A\u300C\u30A6\u30A3\u30F3\u30C9\u30A6\u3092\u9589\u3058\u308B\u300D","description":"\u3053\u308C\u3089\u306E\u4F8B\u306F\u3001\u30C7\u30D0\u30A4\u30B9\u3084\u63A5\u7D9A\u3092\u5236\u5FA1\u3059\u308B\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u306E\u6C4E\u7528\u6027\u3092\u793A\u3057\u3066\u3044\u307E\u3059\u3002\u30B3\u30DE\u30F3\u30C9\u306E\u5B9F\u884C\u3001\u30A4\u30F3\u30BF\u30FC\u30D5\u30A7\u30FC\u30B9\u306E\u64CD\u4F5C\u3001\u3042\u308B\u3044\u306F\u30BF\u30C3\u30D7\u3059\u308B\u3060\u3051\u3067\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u5B9F\u884C\u3067\u304D\u307E\u3059\u3002"},"emptySearch":"\u3053\u306E\u6761\u4EF6\u306B\u4E00\u81F4\u3059\u308B\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u306F\u3042\u308A\u307E\u305B\u3093\u3002","empty":"\u73FE\u5728\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u304C\u306A\u3044\u3088\u3046\u3067\u3059\u3002","emptyLong":"\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u306F\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u304C\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u3092\u8FFD\u52A0\u3059\u308B\u304B\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u3092\u542B\u3080\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u9078\u629E\u3059\u308B\u3068\u3001\u3053\u3053\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002"},"reset":"\u30EA\u30BB\u30C3\u30C8","info":"\u8A73\u7D30\u60C5\u5831","device":{"title":"\u7E4B\u304C\u308A","titlePlural":"\u63A5\u7D9A","status":{"title":"\u63A5\u7D9A\u30B9\u30C6\u30FC\u30BF\u30B9:","connected":{"application":"\u63A5\u7D9A\u3055\u308C\u305F\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3","connection":"\u63A5\u7D9A","device":"\u63A5\u7D9A\u3055\u308C\u305F\u30C7\u30D0\u30A4\u30B9","game":"\u30B3\u30CD\u30AF\u30C6\u30C3\u30C9\u30B2\u30FC\u30E0"},"disconnected":{"application":"\u5207\u65AD\u3055\u308C\u305F\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3","connection":"\u5207\u65AD","device":"\u5207\u65AD\u3055\u308C\u305F\u30C7\u30D0\u30A4\u30B9","game":"\u5207\u65AD\u3055\u308C\u305F\u30B2\u30FC\u30E0"}},"running":"\u30E9\u30F3\u30CB\u30F3\u30B0","offline":"\u30AA\u30D5\u30E9\u30A4\u30F3","otherDevices":"\u305D\u306E\u4ED6\u306E\u51FA\u529B\u63A5\u7D9A","currentStatus":"\u73FE\u5728\u306E\u30B9\u30C6\u30FC\u30BF\u30B9:","connectionStatus":"\u63A5\u7D9A\u30B9\u30C6\u30FC\u30BF\u30B9:","profileStatus":"\u73FE\u5728\u306E\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB:","name":{"title":"\u63A5\u7D9A\u540D","question":"\u3053\u306E\u63A5\u7D9A\u3092\u4F55\u3068\u547C\u3073\u307E\u3059\u304B?","description":"\u5F8C\u3067\u7C21\u5358\u306B\u898B\u3064\u3051\u3089\u308C\u308B\u3088\u3046\u306B\u3001\u63A5\u7D9A\u306B\u540D\u524D\u3092\u4ED8\u3051\u307E\u3059\u3002","placeholder":"\u63A5\u7D9A\u540D","edit":"\u63A5\u7D9A\u540D\u3092\u7DE8\u96C6"},"updates":{"title":"\u63A5\u7D9A\u306E\u66F4\u65B0","settings":"\u63A5\u7D9A\u66F4\u65B0\u8A2D\u5B9A","description":"\u63A5\u7D9A\u30D5\u30A1\u30FC\u30E0\u30A6\u30A7\u30A2\u306E\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u3092\u78BA\u8A8D\u3057\u3001\u81EA\u52D5\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u8A2D\u5B9A\u3092\u5909\u66F4\u3057\u307E\u3059","edit":"\u66F4\u65B0\u8A2D\u5B9A\u3092\u7DE8\u96C6\u3059\u308B","check":{"title":"\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u3092\u78BA\u8A8D\u3059\u308B","processing":"\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u3092\u78BA\u8A8D\u3057\u3066\u3044\u307E\u3059\u3002\u6570\u5206\u304B\u304B\u308B\u5834\u5408\u304C\u3042\u308A\u3001\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u4E2D\u306B\u63A5\u7D9A\u304C\u518D\u958B\u3055\u308C\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002","description":"\u30BF\u30C3\u30D7\u3057\u3066\u63A5\u7D9A\u306E\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u304C\u5229\u7528\u53EF\u80FD\u3067\u3001\u63A5\u7D9A\u304C\u30A2\u30AF\u30C6\u30A3\u30D6\u306A\u5834\u5408\u306F\u3001\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u304C\u958B\u59CB\u3055\u308C\u307E\u3059\u3002\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u306B\u306F\u6570\u5206\u304B\u304B\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002"},"auto":{"title":"\u81EA\u52D5\u66F4\u65B0","description":"\u3053\u306E\u8A2D\u5B9A\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u96FB\u6E90\u306B\u63A5\u7D9A\u3057\u3001Wi-Fi\u306B\u63A5\u7D9A\u3057\u3001\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u304C\u5229\u7528\u53EF\u80FD\u306A\u5834\u5408\u3001\u81EA\u52D5\u7684\u306B\u63A5\u7D9A\u304C\u66F4\u65B0\u3055\u308C\u307E\u3059\u3002\u30AA\u30D5\u306E\u5834\u5408\u306F\u3001\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u30DC\u30BF\u30F3\u3092\u30BF\u30C3\u30D7\u3057\u3066\u6700\u65B0\u306E\u72B6\u614B\u306B\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","option":"\u81EA\u52D5\u66F4\u65B0\u3092\u4F7F\u7528\u3057\u307E\u3059\u304B?"}},"delete":{"title":"{{name}} \u306E\u30EA\u30F3\u30AF\u3092\u89E3\u9664","titleLong":"\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u30EA\u30F3\u30AF\u3092\u89E3\u9664","description":"\u30EA\u30F3\u30AF\u3092\u89E3\u9664\u3059\u308B\u3068\u3001Cephable\u3068\u3053\u306E\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u307E\u305F\u306F\u30B2\u30FC\u30E0\u306E\u63A5\u7D9A\u304C\u5207\u65AD\u3055\u308C\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u304B\u3089\u3082\u524A\u9664\u3055\u308C\u307E\u3059\u3002\u63A5\u7D9A\u3001\u30B3\u30DE\u30F3\u30C9\u306E\u9001\u4FE1\u3001\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u306F\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002\u3053\u306E\u64CD\u4F5C\u306F\u5143\u306B\u623B\u305B\u307E\u305B\u3093\u304C\u3001\u5C06\u6765\u518D\u3073\u4F7F\u7528\u3057\u305F\u3044\u5834\u5408\u306F\u3001\u540C\u3058\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u307E\u305F\u306F\u30B2\u30FC\u30E0\u3078\u306E\u65B0\u3057\u3044\u63A5\u7D9A\u3092\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002","confirm":"\u3053\u306E\u63A5\u7D9A\u3092\u89E3\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B?","confirmLong":"\u3053\u306E\u63A5\u7D9A\u3092\u767B\u9332\u89E3\u9664\u3057\u3066\u30EA\u30BB\u30C3\u30C8\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F \u4ECA\u5F8C\u3001\u3053\u306E\u63A5\u7D9A\u306B\u63A5\u7D9A\u3057\u305F\u308A\u3001\u30B3\u30DE\u30F3\u30C9\u3092\u9001\u4FE1\u3057\u305F\u308A\u3001\u66F4\u65B0\u3057\u305F\u308A\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002\u767B\u9332\u89E3\u9664\u3068\u30EA\u30BB\u30C3\u30C8\u3092\u884C\u3046\u3068\u3001\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u304C\u3053\u306E\u63A5\u7D9A\u3092\u6700\u521D\u304B\u3089\u8A2D\u5B9A\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002","confirmButton":"\u306F\u3044\u3001\u3053\u306E\u63A5\u7D9A\u3092\u524A\u9664\u3057\u307E\u3059\u3002"},"manage":{"title":"\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001\u63A5\u7D9A\u306E\u8A73\u7D30\u3092\u8868\u793A\u304A\u3088\u3073\u7BA1\u7406\u3067\u304D\u307E\u3059\u3002","description":"","name":"\u7BA1\u7406\u3092\u5BB9\u6613\u306B\u3059\u308B\u305F\u3081\u306B\u63A5\u7D9A\u540D\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u307E\u3059\u3002"},"error":{"save":"\u63A5\u7D9A\u306E\u4FDD\u5B58\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","load":"\u63A5\u7D9A\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","add":"\u63A5\u7D9A\u306E\u8FFD\u52A0\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","delete":"\u63A5\u7D9A\u306E\u524A\u9664\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","updates":"\u66F4\u65B0\u306E\u78BA\u8A8D\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","connection":"\u63A5\u7D9A\u304C\u78BA\u7ACB\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u518D\u8A66\u884C\u3059\u308B\u524D\u306B\u63A5\u7D9A\u3055\u308C\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","deleteLong":"\u3053\u306E\u63A5\u7D9A\u3092\u30A2\u30AB\u30A6\u30F3\u30C8\u304B\u3089\u524A\u9664\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u3053\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u518D\u5EA6\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u5834\u5408\u306F\u3001\u63A5\u7D9A\u8A2D\u5B9A\u3067\u3053\u306E\u63A5\u7D9A\u3092\u624B\u52D5\u3067\u524A\u9664\u3059\u308B\u5FC5\u8981\u304C\u3042\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002"},"success":{"save":"\u63A5\u7D9A\u304C\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F\u3002","add":"\u63A5\u7D9A\u304C\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F\u3002","delete":"\u63A5\u7D9A\u304C\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002"},"description":"Cephable\u306F\u8907\u6570\u306E\u30C7\u30D0\u30A4\u30B9\u3068\u63A5\u7D9A\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u3066\u3044\u307E\u3059\u3002\u8A2D\u5B9A\u3092\u7BA1\u7406\u3057\u305F\u308A\u3001\u3053\u3053\u304B\u3089\u3059\u3079\u3066\u3092\u9078\u629E\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002\u3053\u306E\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u306F\u5E38\u306B\u30E1\u30A4\u30F3\u306E\u63A5\u7D9A\u3068\u3057\u3066\u4F7F\u7528\u3055\u308C\u307E\u3059\u3002\u63A5\u7D9A\u306F\u5F8C\u3067\u8FFD\u52A0\u3067\u304D\u307E\u3059\u3002","swap":{"titlePlural":"\u30B9\u30EF\u30C3\u30D7\u63A5\u7D9A"},"control":{"button":"{{name}} \u3092\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","description":{"application":"\u97F3\u58F0\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3001\u30D8\u30C3\u30C9\u30E2\u30FC\u30B7\u30E7\u30F3\u306A\u3069\u3092\u4F7F\u3063\u3066\u3001\u63A5\u7D9A\u3055\u308C\u305F\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002\u4F8B\u3048\u3070\u3001\u300C\u4FDD\u5B58\u300D\u3068\u8A00\u3046\u3068\u3001\u5B9F\u884C\u4E2D\u306E\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u304C\u4FDD\u5B58\u3055\u308C\u307E\u3059\u3002","connection":"\u97F3\u58F0\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3001\u30D8\u30C3\u30C9\u30E2\u30FC\u30B7\u30E7\u30F3\u306A\u3069\u3092\u4F7F\u3063\u3066\u3001\u63A5\u7D9A\u4E2D\u306E\u30C7\u30D0\u30A4\u30B9\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002\u4F8B\u3048\u3070\u3001\u300C\u4FDD\u5B58\u300D\u3068\u8A00\u3046\u3068\u3001\u63A5\u7D9A\u4E2D\u306E\u30C7\u30D0\u30A4\u30B9\u304C\u4FDD\u5B58\u3055\u308C\u307E\u3059\u3002","device":"\u97F3\u58F0\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3001\u30D8\u30C3\u30C9\u30E2\u30FC\u30B7\u30E7\u30F3\u306A\u3069\u3092\u4F7F\u3063\u3066\u3001\u63A5\u7D9A\u3055\u308C\u305F\u30C7\u30D0\u30A4\u30B9\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002\u4F8B\u3048\u3070\u3001\u300CSpotify\u3092\u958B\u3044\u3066\u300D\u3068\u8A00\u3046\u3068\u3001\u8D77\u52D5\u4E2D\u306E\u30C7\u30D0\u30A4\u30B9\u3067Spotify\u304C\u958B\u304D\u307E\u3059\u3002","game":"\u3053\u306E\u63A5\u7D9A\u578B\u30B2\u30FC\u30E0\u306F\u3001\u97F3\u58F0\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3001\u982D\u306E\u52D5\u304D\u306A\u3069\u3092\u4F7F\u3063\u3066\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002\u4F8B\u3048\u3070\u3001\u300CGo\u300D\u3068\u8A00\u3046\u3068\u3001\u30E9\u30F3\u30CB\u30F3\u30B0\u30B2\u30FC\u30E0\u3067\u30D7\u30EC\u30A4\u30E4\u30FC\u304C\u52D5\u304D\u307E\u3059\u3002"},"generic":"\u5236\u5FA1\u63A5\u7D9A"},"titleShort":"\u63A5\u7D9A\u3059\u308B","titleLong":"\u63A5\u7D9A\u3068\u62E1\u5F35\u6A5F\u80FD","viewAll":"\u3059\u3079\u3066\u306E\u63A5\u7D9A\u3092\u8868\u793A","add":{"short":"\u4F38\u3070\u3059","title":"\u65B0\u3057\u3044\u63A5\u7D9A\u307E\u305F\u306F\u62E1\u5F35\u6A5F\u80FD\u3092\u8FFD\u52A0\u3059\u308B","description":"\u63A5\u7D9A\u3068\u62E1\u5F35\u6A5F\u80FD\u306F\u3001Cephable\u306E\u4F53\u9A13\u3092\u3055\u3089\u306B\u5145\u5B9F\u3055\u305B\u308B\u65B9\u6CD5\u3067\u3059\u3002\u65B0\u3057\u3044\u63A5\u7D9A\u3092\u8FFD\u52A0\u3059\u308B\u3053\u3068\u3067\u3001\u3088\u308A\u591A\u304F\u306E\u30C7\u30D0\u30A4\u30B9\u3001\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3001\u30B2\u30FC\u30E0\u306B\u63A5\u7D9A\u3067\u304D\u307E\u3059\u3002\u63A5\u7D9A\u3068\u62E1\u5F35\u6A5F\u80FD\u3092\u8FFD\u52A0\u3059\u308B\u3053\u3068\u3067\u3001Cephable\u306E\u4F53\u9A13\u3092\u6B21\u306E\u30EC\u30D9\u30EB\u306B\u5F15\u304D\u4E0A\u3052\u307E\u3057\u3087\u3046\u3002","action":"\u65B0\u3057\u3044\u63A5\u7D9A\u3092\u8FFD\u52A0\u3059\u308B","notAvailable":"\u3053\u306E\u63A5\u7D9A\u307E\u305F\u306F\u62E1\u5F35\u6A5F\u80FD\u306F\u73FE\u5728\u516C\u958B\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u3053\u308C\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u4F5C\u6210\u3057\u305F\u62E1\u5F35\u6A5F\u80FD\u3092\u4F7F\u7528\u3059\u308B\u5834\u5408\u306B\u3088\u304F\u767A\u751F\u3057\u307E\u3059\u3002\u5F8C\u307B\u3069\u518D\u5EA6\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002","isNotPublic":"\u30D7\u30EC\u30D3\u30E5\u30FC\uFF1A\u3053\u306E\u62E1\u5F35\u6A5F\u80FD\u306F\u958B\u767A\u8005\u5411\u3051\u30D7\u30EC\u30D3\u30E5\u30FC\u6BB5\u968E\u3067\u3042\u308A\u3001\u672A\u5B8C\u6210\u306E\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u958B\u767A\u8005\u306E\u7686\u69D8\u306F\u3001\u4E00\u822C\u516C\u958B\u524D\u306B\u3059\u3079\u3066\u306E\u624B\u9806\u3092\u5B8C\u4E86\u3057\u3066\u3044\u305F\u3060\u304F\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u30E6\u30FC\u30B6\u30FC\u306F\u5F8C\u307B\u3069\u3001\u5B8C\u5168\u7248\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"},"new":"\u65B0\u3057\u3044\u63A5\u7D9A\u304C\u3067\u304D\u307E\u3057\u305F!","newLong":"\u65B0\u3057\u3044\u63A5\u7D9A\u304C\u3067\u304D\u307E\u3057\u305F\u3002\u4F7F\u7528\u3092\u958B\u59CB\u3059\u308B\u306B\u306F\u3001\u4E0B\u306E\u30E1\u30CB\u30E5\u30FC\u304B\u3089\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"explore":"\u63A2\u691C\u3059\u308B","shortcuts":{"title":"\u30B0\u30ED\u30FC\u30D0\u30EB\u30B7\u30E7\u30FC\u30C8\u30AB\u30C3\u30C8","description":"\u30AD\u30FC\u30DC\u30FC\u30C9 \u30B7\u30E7\u30FC\u30C8\u30AB\u30C3\u30C8\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u3066\u3001\u30B7\u30B9\u30C6\u30E0\u4E0A\u306E\u3069\u3053\u304B\u3089\u3067\u3082 Cephable \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u3059\u3070\u3084\u304F\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u3059\u3002","info":"\u3053\u308C\u3089\u306E\u30B7\u30E7\u30FC\u30C8\u30AB\u30C3\u30C8\u306F\u30B0\u30ED\u30FC\u30D0\u30EB\u306B\u6A5F\u80FD\u3057\u3001Cephable \u304C\u30A2\u30AF\u30C6\u30A3\u30D6\u30A6\u30A3\u30F3\u30C9\u30A6\u3067\u306A\u3044\u5834\u5408\u3067\u3082\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002","shortcut":"\u30B7\u30E7\u30FC\u30C8\u30AB\u30C3\u30C8","toggleMicrophone":"\u30DE\u30A4\u30AF\u3092\u5207\u308A\u66FF\u3048\u308B","toggleDictation":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u3092\u5207\u308A\u66FF\u3048\u308B","toggleVoiceControl":"\u97F3\u58F0\u5236\u5FA1\u30E2\u30FC\u30C9\u3092\u5207\u308A\u66FF\u3048\u308B","togglePanel":"\u30C8\u30B0\u30EB\u30D1\u30CD\u30EB","registrationFailed":"\u4E00\u90E8\u306E\u30B0\u30ED\u30FC\u30D0\u30EB\u30B7\u30E7\u30FC\u30C8\u30AB\u30C3\u30C8\u3092\u767B\u9332\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u4ED6\u306E\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3067\u4F7F\u7528\u3055\u308C\u3066\u3044\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002","record":{"title":"\u30B7\u30E7\u30FC\u30C8\u30AB\u30C3\u30C8\u3092\u8A18\u9332","start":"\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u8A18\u9332","listening":"\u5E0C\u671B\u3059\u308B\u30AD\u30FC\u306E\u7D44\u307F\u5408\u308F\u305B\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044...","pressKeys":"\u4ECA\u3059\u3050\u30AD\u30FC\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044"},"formatHint":"\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u306E\u4FEE\u98FE\u30AD\u30FC ({{modifierKey}}, {{modifierKey2}}, Shift) \u3068\u4ED6\u306E 1 \u3064\u306E\u30AD\u30FC\u3092\u9078\u629E\u3057\u307E\u3059\u3002"},"gamepad":{"title":"\u30B2\u30FC\u30E0\u30D1\u30C3\u30C9\u306E\u30B5\u30DD\u30FC\u30C8","description":"PC\u30B2\u30FC\u30E0\u7528\u306E\u30B2\u30FC\u30E0\u30D1\u30C3\u30C9\u3068\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u306E\u51FA\u529B\u3092\u69CB\u6210\u3059\u308B","driver":{"description":"\u30B2\u30FC\u30E0\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u51FA\u529B\u3092\u30B5\u30DD\u30FC\u30C8\u3059\u308B\u306B\u306F\u3001Cephable \u3067 ViGEm \u3068\u547C\u3070\u308C\u308B\u5916\u90E8\u30C9\u30E9\u30A4\u30D0\u30FC\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u306E\u30C9\u30E9\u30A4\u30D0\u30FC\u306F\u3001\u30B2\u30FC\u30E0\u304C\u30CD\u30A4\u30C6\u30A3\u30D6\u306B\u8A8D\u8B58\u3059\u308B\u4EEE\u60F3 Xbox 360 \u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u6A5F\u80FD\u3092\u6709\u52B9\u306B\u3057\u307E\u3059\u3002","installed":"\u30B2\u30FC\u30E0\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30C9\u30E9\u30A4\u30D0\u30FC\u304C\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3055\u308C\u307E\u3057\u305F\u3002\u30B2\u30FC\u30E0\u30D1\u30C3\u30C9\u306E\u51FA\u529B\u304C\u4F7F\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002\u305D\u308C\u3067\u3082\u554F\u984C\u304C\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001\u30C9\u30E9\u30A4\u30D0\u30FC\u3092\u518D\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002","notInstalled":"\u30B2\u30FC\u30E0\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u306E\u30C9\u30E9\u30A4\u30D0\u30FC\u304C\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3055\u308C\u3066\u3044\u307E\u305B\u3093","install":"\u30B2\u30FC\u30E0\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30C9\u30E9\u30A4\u30D0\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3059\u308B","reinstall":"\u30B2\u30FC\u30E0\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30C9\u30E9\u30A4\u30D0\u3092\u518D\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3059\u308B","installing":"ViGEm \u30B2\u30FC\u30E0 \u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC \u30C9\u30E9\u30A4\u30D0\u30FC\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3057\u3066\u3044\u307E\u3059...","installSuccess":"ViGEm \u30B2\u30FC\u30E0 \u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC \u30C9\u30E9\u30A4\u30D0\u30FC\u304C\u6B63\u5E38\u306B\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3055\u308C\u307E\u3057\u305F\u3002\u3053\u308C\u3067\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u30B2\u30FC\u30E0\u30D1\u30C3\u30C9\u306E\u51FA\u529B\u3092\u4F7F\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002","installFailed":"ViGEm\u30C9\u30E9\u30A4\u30D0\u306E\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u3044\u305F\u3060\u304F\u304B\u3001ViGEm\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u304B\u3089\u624B\u52D5\u3067\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"platform":{"unsupported":"\u30B2\u30FC\u30E0\u30D1\u30C3\u30C9\u306E\u6A5F\u80FD\u306F\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u306B\u3088\u3063\u3066\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u307E\u305B\u3093","unsupportedDescription":"\u30B2\u30FC\u30E0\u30D1\u30C3\u30C9\u51FA\u529B\u6A5F\u80FD\u306F\u73FE\u5728\u3001Windows x64 \u30B7\u30B9\u30C6\u30E0\u3067\u306E\u307F\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u307E\u3059\u3002Windows ARM64 \u306E\u30B5\u30DD\u30FC\u30C8\u306F\u3001SDK \u306E\u5236\u9650\u306B\u3088\u308A\u307E\u3060\u5229\u7528\u3067\u304D\u307E\u305B\u3093\u3002"},"usage":"\u30B2\u30FC\u30E0 \u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC \u30C9\u30E9\u30A4\u30D0\u30FC\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3059\u308B\u3068\u3001\u30DE\u30AF\u30ED\u3084\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3067\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u306E\u52D5\u304D\u3084\u30B2\u30FC\u30E0\u30D1\u30C3\u30C9\u306E\u30DC\u30BF\u30F3\u306E\u62BC\u4E0B\u3092\u4F7F\u7528\u3057\u3066\u30B2\u30FC\u30E0\u3092\u5236\u5FA1\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002"},"youtube":{"unavailable":{"title":"\u30D3\u30C7\u30AA\u306F\u5229\u7528\u3067\u304D\u307E\u305B\u3093","description":"\u3053\u306E\u52D5\u753B\u306F\u73FE\u5728\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u305B\u3093\u3002\u5F8C\u307B\u3069\u3082\u3046\u4E00\u5EA6\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002","retry":"\u30EA\u30C8\u30E9\u30A4"},"watch":{"title":"\u304A\u3063\u3068\u3002","description":"\u52D5\u753B\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u554F\u984C\u304C\u767A\u751F\u3057\u305F\u3088\u3046\u3067\u3059\u3002YouTube\u3067\u76F4\u63A5\u8996\u8074\u3067\u304D\u307E\u3059\u3002","button":"YouTube\u3067\u898B\u308B"},"offline":{"title":"\u30D3\u30C7\u30AA\u306F\u5229\u7528\u3067\u304D\u307E\u305B\u3093","description":"\u3053\u306EYouTube\u52D5\u753B\u3092\u8AAD\u307F\u8FBC\u3080\u306B\u306F\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u63A5\u7D9A\u304C\u5FC5\u8981\u3067\u3059\u3002\u63A5\u7D9A\u3092\u78BA\u8A8D\u3057\u3066\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002"}},"metrics":{"download":{"success":"\u30E1\u30C8\u30EA\u30C3\u30AF \u30D5\u30A1\u30A4\u30EB\u306B\u6B63\u5E38\u306B\u30A2\u30AF\u30BB\u30B9\u3057\u307E\u3057\u305F\u3002","manualPath":"\u30E1\u30C8\u30EA\u30AF\u30B9\u30D5\u30A1\u30A4\u30EB\u306F {{path}} \u3067\u5165\u624B\u3067\u304D\u307E\u3059","error":"\u30E1\u30C8\u30EA\u30C3\u30AF \u30D5\u30A1\u30A4\u30EB\u306E\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","noFile":"\u30E1\u30C8\u30EA\u30C3\u30AF \u30D5\u30A1\u30A4\u30EB\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002"},"clear":{"success":"\u30E1\u30C8\u30EA\u30C3\u30AF \u30D5\u30A1\u30A4\u30EB\u304C\u6B63\u5E38\u306B\u30AF\u30EA\u30A2\u3055\u308C\u307E\u3057\u305F\u3002","error":"\u30E1\u30C8\u30EA\u30C3\u30AF \u30D5\u30A1\u30A4\u30EB\u306E\u6D88\u53BB\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","noFile":"\u30AF\u30EA\u30A2\u3059\u308B\u30E1\u30C8\u30EA\u30C3\u30AF \u30D5\u30A1\u30A4\u30EB\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002","confirm":"\u3059\u3079\u3066\u306E\u30E1\u30C8\u30EA\u30C3\u30AF\u30C7\u30FC\u30BF\u3092\u30AF\u30EA\u30A2\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B? \u5143\u306B\u623B\u3059\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002"}},"suggestedPrompts":{"title":"\u63D0\u6848\u3055\u308C\u305F\u30D7\u30ED\u30F3\u30D7\u30C8","description":"AI \u30BF\u30B9\u30AF\u306B\u8868\u793A\u3055\u308C\u308B\u63D0\u6848\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u3066\u3001\u3059\u3050\u306B\u958B\u59CB\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002","edit":"\u63D0\u6848\u3055\u308C\u305F\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u7DE8\u96C6\u3059\u308B","generate":"\u30C6\u30AD\u30B9\u30C8\u3092\u751F\u6210\u3059\u308B","rewrite":"\u30C6\u30AD\u30B9\u30C8\u306E\u66F8\u304D\u63DB\u3048","addGenerate":"\u751F\u6210\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u8FFD\u52A0\u3059\u308B","addRewrite":"\u66F8\u304D\u63DB\u3048\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u8FFD\u52A0\u3059\u308B","remove":"\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u524A\u9664","generatePlaceholder":"\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u306E\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044...","rewritePlaceholder":"\u30C6\u30AD\u30B9\u30C8\u66F8\u304D\u63DB\u3048\u306E\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044...","suggested":"\u63D0\u6848\u3055\u308C\u305F\u30D7\u30ED\u30F3\u30D7\u30C8","suggestedFor":"{{profileName}} \u306B\u304A\u3059\u3059\u3081","seeAll":"\u3059\u3079\u3066\u306E\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u8868\u793A","showLess":"\u8868\u793A\u3092\u6E1B\u3089\u3059","allPrompts":"\u3059\u3079\u3066\u306E\u30D7\u30ED\u30F3\u30D7\u30C8","customFor":"{{profileName}} \u306E\u30AB\u30B9\u30BF\u30E0\u30D7\u30ED\u30F3\u30D7\u30C8","defaultPrompts":"\u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u30D7\u30ED\u30F3\u30D7\u30C8","defaultGenerate":["\u65B0\u88FD\u54C1\u3092\u7D39\u4ECB\u3059\u308B\u30D7\u30ED\u30D5\u30A7\u30C3\u30B7\u30E7\u30CA\u30EB\u306A\u30E1\u30FC\u30EB","\u6765\u9031\u306E\u30C1\u30FC\u30E0\u30C7\u30A3\u30B9\u30AB\u30C3\u30B7\u30E7\u30F3\u306E\u8B70\u984C","\u65B0\u3057\u3044\u53D6\u308A\u7D44\u307F\u306E\u305F\u3081\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u63D0\u6848\u306E\u6982\u8981","\u6B63\u5F0F\u306A\u30D3\u30B8\u30CD\u30B9\u30EC\u30BF\u30FC\u306E\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8","\u6280\u8853\u6587\u66F8\u30BB\u30AF\u30B7\u30E7\u30F3","\u30E6\u30FC\u30B6\u30FC\u30DE\u30CB\u30E5\u30A2\u30EB\u306E\u7D39\u4ECB","\u30C8\u30EC\u30FC\u30CB\u30F3\u30B0\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306E\u6982\u8981","\u653F\u7B56\u6587\u66F8\u306E\u8349\u6848","\u4F1A\u8B70\u5F8C\u306E\u30D5\u30A9\u30ED\u30FC\u30A2\u30C3\u30D7\u30E1\u30FC\u30EB","\u9867\u5BA2\u3078\u306E\u611F\u8B1D\u306E\u30E1\u30C3\u30BB\u30FC\u30B8","\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u30B9\u30C6\u30FC\u30BF\u30B9\u66F4\u65B0\u30E1\u30FC\u30EB","\u4F1A\u793E\u306E\u30A4\u30D9\u30F3\u30C8\u3078\u306E\u62DB\u5F85\u72B6","\u671F\u9650\u304C\u8FEB\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u77E5\u3089\u305B\u308B\u30EA\u30DE\u30A4\u30F3\u30C0\u30FC\u30E1\u30FC\u30EB","\u65B0\u3057\u3044\u30C1\u30FC\u30E0\u30E1\u30F3\u30D0\u30FC\u3078\u306E\u6B53\u8FCE\u30E1\u30FC\u30EB","\u30B5\u30FC\u30D3\u30B9\u4E2D\u65AD\u306B\u95A2\u3059\u308B\u304A\u8A6B\u3073\u30E1\u30FC\u30EB","\u30CB\u30E5\u30FC\u30B9\u30EC\u30BF\u30FC\u306E\u7D39\u4ECB","\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u306E\u305F\u3081\u306E\u30D6\u30EC\u30A4\u30F3\u30B9\u30C8\u30FC\u30DF\u30F3\u30B0\u30EA\u30B9\u30C8","\u30C1\u30FC\u30E0\u306E\u751F\u7523\u6027\u3092\u5411\u4E0A\u3055\u305B\u308B\u5275\u9020\u7684\u306A\u30BD\u30EA\u30E5\u30FC\u30B7\u30E7\u30F3","\u4F1A\u793E\u306E\u6170\u5B89\u65C5\u884C\u306E\u30A2\u30A4\u30C7\u30A2","\u65B0\u3057\u3044\u30E2\u30D0\u30A4\u30EB\u30A2\u30D7\u30EA\u6A5F\u80FD\u306E\u30B3\u30F3\u30BB\u30D7\u30C8","\u9867\u5BA2\u4F53\u9A13\u5411\u4E0A\u306E\u305F\u3081\u306E\u63D0\u6848","\u88FD\u54C1\u958B\u767A\u306E\u305F\u3081\u306E\u9769\u65B0\u7684\u306A\u30A2\u30A4\u30C7\u30A2","\u30BD\u30FC\u30B7\u30E3\u30EB\u30E1\u30C7\u30A3\u30A2\u6295\u7A3F\u306E\u30B3\u30F3\u30C6\u30F3\u30C4\u30A2\u30A4\u30C7\u30A2","\u5C02\u9580\u80FD\u529B\u958B\u767A\u306E\u305F\u3081\u306E\u30EF\u30FC\u30AF\u30B7\u30E7\u30C3\u30D7\u306E\u30C8\u30D4\u30C3\u30AF","\u30E6\u30FC\u30B6\u30FC\u5165\u529B\u3092\u691C\u8A3C\u3059\u308B\u95A2\u6570","\u30E6\u30FC\u30B6\u30FC\u7BA1\u7406\u306E\u305F\u3081\u306E\u30C7\u30FC\u30BF\u30D9\u30FC\u30B9\u30AF\u30A8\u30EA","API\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u30A8\u30E9\u30FC\u51E6\u7406\u30B3\u30FC\u30C9","\u8A2D\u5B9A\u30D5\u30A1\u30A4\u30EB\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8","\u8907\u96D1\u306A\u30A2\u30EB\u30B4\u30EA\u30BA\u30E0\u3092\u8AAC\u660E\u3059\u308B\u30B3\u30E1\u30F3\u30C8","\u65B0\u3057\u3044\u6A5F\u80FD\u306E\u30E6\u30CB\u30C3\u30C8\u30C6\u30B9\u30C8\u30B1\u30FC\u30B9","API\u30A8\u30F3\u30C9\u30DD\u30A4\u30F3\u30C8\u306E\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8","\u81EA\u52D5\u5C55\u958B\u7528\u306E\u30B9\u30AF\u30EA\u30D7\u30C8"],"defaultRewrite":["\u3053\u306E\u30C6\u30AD\u30B9\u30C8\u3092\u3082\u3063\u3068\u7C21\u6F54\u306B\u3001\u8981\u70B9\u3092\u62BC\u3055\u3048\u305F\u3082\u306E\u306B\u3057\u307E\u3057\u3087\u3046","\u3053\u306E\u8981\u7D04\u3092\u3055\u3089\u306B\u8A73\u3057\u304F\u8A18\u8FF0\u3059\u308B","\u3053\u308C\u3092\u756A\u53F7\u4ED8\u304D\u30EA\u30B9\u30C8\u3068\u3057\u3066\u518D\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3057\u307E\u3059","\u3053\u308C\u3092\u7B87\u6761\u66F8\u304D\u306B\u5909\u63DB\u3059\u308B","\u3053\u308C\u3092\u660E\u78BA\u306A\u6BB5\u843D\u306B\u518D\u69CB\u6210\u3059\u308B","\u3053\u306E\u30C6\u30AD\u30B9\u30C8\u3092\u7D20\u65E9\u304F\u30B9\u30AD\u30E3\u30F3\u3057\u3084\u3059\u304F\u3057\u307E\u3059","\u3053\u306E\u60C5\u5831\u3092\u968E\u5C64\u7684\u306B\u6574\u7406\u3059\u308B","\u3053\u308C\u3092\u30B9\u30C6\u30C3\u30D7\u30D0\u30A4\u30B9\u30C6\u30C3\u30D7\u306E\u30AC\u30A4\u30C9\u3068\u3057\u3066\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3057\u307E\u3059","\u3053\u306E\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u3088\u308A\u30D7\u30ED\u30D5\u30A7\u30C3\u30B7\u30E7\u30CA\u30EB\u3067\u30D5\u30A9\u30FC\u30DE\u30EB\u306A\u3082\u306E\u306B\u3057\u307E\u3057\u3087\u3046","\u3053\u308C\u3092\u3082\u3063\u3068\u30AB\u30B8\u30E5\u30A2\u30EB\u3067\u30D5\u30EC\u30F3\u30C9\u30EA\u30FC\u306A\u611F\u3058\u306B\u66F8\u304D\u76F4\u3057\u3066\u304F\u3060\u3055\u3044","\u3088\u308A\u52B1\u307E\u3057\u306B\u306A\u308B\u3088\u3046\u53E3\u8ABF\u3092\u8ABF\u6574\u3059\u308B","\u3082\u3063\u3068\u81EA\u4FE1\u3068\u65AD\u5B9A\u7684\u306A\u8A00\u3044\u65B9\u3092\u3057\u307E\u3057\u3087\u3046","\u5916\u4EA4\u7684\u306B\u53E3\u8ABF\u3092\u548C\u3089\u3052\u308B","\u3053\u306E\u30C6\u30AD\u30B9\u30C8\u306B\u71B1\u610F\u3068\u30A8\u30CD\u30EB\u30AE\u30FC\u3092\u52A0\u3048\u308B","\u3082\u3063\u3068\u5171\u611F\u7684\u3067\u7406\u89E3\u306E\u3042\u308B\u3082\u306E\u306B\u3057\u307E\u3057\u3087\u3046","\u3088\u308A\u5354\u529B\u7684\u306A\u53E3\u8ABF\u3067\u66F8\u304D\u76F4\u3059","\u4E00\u822C\u5411\u3051\u306B\u7C21\u7565\u5316\u3059\u308B","\u3053\u306E\u8AAC\u660E\u3092\u3088\u308A\u6280\u8853\u7684\u304B\u3064\u8A73\u7D30\u306B\u3057\u3066\u304F\u3060\u3055\u3044","\u3053\u306E\u8907\u96D1\u306A\u6982\u5FF5\u3092\u3088\u308A\u5358\u7D14\u306A\u8A00\u8449\u3067\u5206\u89E3\u3059\u308B","\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3068\u80CC\u666F\u60C5\u5831\u3092\u3082\u3063\u3068\u8FFD\u52A0\u3059\u308B","\u3053\u308C\u3092\u91CD\u8981\u306A\u30DD\u30A4\u30F3\u30C8\u306B\u307E\u3068\u3081\u308B","\u4F8B\u3092\u6319\u3052\u3066\u8981\u70B9\u3092\u8A73\u3057\u304F\u8AAC\u660E\u3059\u308B","\u521D\u5FC3\u8005\u306B\u3068\u3063\u3066\u3088\u308A\u30A2\u30AF\u30BB\u30B9\u3057\u3084\u3059\u3044\u3082\u306E\u306B\u3059\u308B","\u91CD\u8981\u306A\u60C5\u5831\u3092\u7DAD\u6301\u3057\u306A\u304C\u3089\u3053\u308C\u3092\u8981\u7D04\u3059\u308B","\u660E\u77AD\u6027\u3068\u8AAD\u307F\u3084\u3059\u3055\u3092\u5411\u4E0A\u3055\u305B\u308B","\u3082\u3063\u3068\u9B45\u529B\u7684\u3067\u8208\u5473\u6DF1\u3044\u3082\u306E\u306B\u3057\u307E\u3057\u3087\u3046","\u6587\u6CD5\u3068\u6D41\u308C\u3092\u6539\u5584\u3059\u308B","\u30E1\u30EA\u30C3\u30C8\u3092\u5F37\u8ABF\u3059\u308B\u3088\u3046\u306B\u66F8\u304D\u76F4\u3059"]},"accessibilityService":{"error":{"generic":"\u5185\u90E8\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","elementNotFound":"\u7D50\u679C\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u691C\u7D22\u304C\u5B58\u5728\u3059\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u3001\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","highlightOnConflict":"\u8907\u6570\u306E\u8981\u7D20\u304C\u898B\u3064\u304B\u308A\u307E\u3057\u305F\u3002\u9078\u629E\u3059\u308B\u8981\u7D20\u3092\u6307\u5B9A\u3059\u308B\u3088\u3046\u306B\u30B3\u30DE\u30F3\u30C9\u3092\u8ABF\u6574\u3057\u3066\u304F\u3060\u3055\u3044\u3002","clickNotInitialized":"\u540D\u524D\u306B\u3088\u308B\u30BF\u30C3\u30D7\u306F\u73FE\u5728\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u305B\u3093\u3002\u554F\u984C\u304C\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001\u30B5\u30DD\u30FC\u30C8\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002","platformUnsupported":"\u3053\u306E\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u3067\u306F\u97F3\u58F0\u30DE\u30A6\u30B9\u6A5F\u80FD\u306F\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002"},"clickWait":"\u521D\u671F\u5316\u4E2D\u3067\u3059\u3002\u3057\u3070\u3089\u304F\u304A\u5F85\u3061\u3044\u305F\u3060\u304D\u3001\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002"},"deprecated":"\u975E\u63A8\u5968","view":"\u30D3\u30E5\u30FC","aiWorkflows":{"settings":{"title":"AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u8A2D\u5B9A","description":"AI \u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3067\u4F7F\u7528\u3059\u308B AI \u30E2\u30C7\u30EB\u3068\u30C7\u30D0\u30A4\u30B9\u3092\u8A2D\u5B9A\u3057\u307E\u3059\u3002AI \u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u30C7\u30D0\u30A4\u30B9\u4E0A\u306E AI \u3092\u4F7F\u7528\u3057\u3066\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u304A\u3088\u3073\u30D6\u30E9\u30A6\u30B6\u306E\u30BF\u30B9\u30AF\u3092\u81EA\u52D5\u5316\u3067\u304D\u307E\u3059\u3002","configType":{"title":"\u30E2\u30C7\u30EB\u69CB\u6210\u30BF\u30A4\u30D7","description":"AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306B\u4F7F\u7528\u3059\u308B\u30E2\u30C7\u30EB\u69CB\u6210\u306E\u30BF\u30A4\u30D7\u3092\u9078\u629E\u3057\u307E\u3059\u3002\u30E2\u30C7\u30EB\u3054\u3068\u306B\u6700\u9069\u5316\u3055\u308C\u305F\u69CB\u6210\u304C\u7570\u306A\u308A\u307E\u3059\u3002","label":"\u69CB\u6210\u30BF\u30A4\u30D7"},"reasoningModel":{"title":"\u63A8\u8AD6\u30E2\u30C7\u30EB","description":"\u63A8\u8AD6\u304A\u3088\u3073\u8A08\u753B\u30BF\u30B9\u30AF\u306B\u4F7F\u7528\u3059\u308BAI\u30E2\u30C7\u30EB\u3092\u9078\u629E\u3057\u307E\u3059\u3002\u63A8\u8AD6\u30E2\u30C7\u30EB\u306F\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u5206\u6790\u3057\u3001\u30A2\u30AF\u30B7\u30E7\u30F3\u30D7\u30E9\u30F3\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002","label":"\u63A8\u8AD6\u30E2\u30C7\u30EB"},"reasoningDevice":{"label":"\u63A8\u8AD6\u88C5\u7F6E"},"generationModel":{"title":"\u4E16\u4EE3\u30E2\u30C7\u30EB","description":"\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u30BF\u30B9\u30AF\u306B\u4F7F\u7528\u3059\u308BAI\u30E2\u30C7\u30EB\u3092\u9078\u629E\u3057\u307E\u3059\u3002\u751F\u6210\u30E2\u30C7\u30EB\u306F\u3001\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3067\u5FC5\u8981\u306A\u3068\u304D\u306B\u30C6\u30AD\u30B9\u30C8\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002","label":"\u4E16\u4EE3\u30E2\u30C7\u30EB"},"generationDevice":{"label":"\u751F\u6210\u88C5\u7F6E"},"noModelsFound":"\u30E2\u30C7\u30EB\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093","terminate":{"title":"\u660E\u78BA\u306A\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u30EA\u30BD\u30FC\u30B9","description":"\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u30EF\u30FC\u30AB\u30FC\u304C\u7D42\u4E86\u3057\u3001\u30EA\u30BD\u30FC\u30B9\u304C\u89E3\u653E\u3055\u308C\u307E\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u5B9F\u884C\u4E2D\u306E\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u304C\u505C\u6B62\u3057\u3001AI\u30E2\u30C7\u30EB\u304C\u4F7F\u7528\u3057\u3066\u3044\u308B\u30E1\u30E2\u30EA\u304C\u89E3\u653E\u3055\u308C\u307E\u3059\u3002","button":"\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u30EF\u30FC\u30AB\u30FC\u3092\u7D42\u4E86\u3059\u308B","success":"\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC \u30EF\u30FC\u30AB\u30FC\u304C\u7D42\u4E86\u3057\u307E\u3057\u305F\u3002","confirm":{"title":"\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u30EF\u30FC\u30AB\u30FC\u3092\u7D42\u4E86\u3059\u308B","description":"\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u30EF\u30FC\u30AB\u30FC\u3092\u7D42\u4E86\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B? \u3053\u308C\u306B\u3088\u308A\u3001\u5B9F\u884C\u4E2D\u306E\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u304C\u505C\u6B62\u3057\u3001\u30EA\u30BD\u30FC\u30B9\u304C\u89E3\u653E\u3055\u308C\u307E\u3059\u3002","confirm":"\u306F\u3044\u3001\u7D42\u4E86\u3057\u307E\u3059"}},"autoWarm":{"title":"AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306E\u81EA\u52D5\u958B\u59CB","description":"\u30A2\u30D7\u30EA\u8D77\u52D5\u6642\u306BAI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u30E2\u30C7\u30EB\u3092\u81EA\u52D5\u7684\u306B\u521D\u671F\u5316\u3057\u307E\u3059\u3002\u30E2\u30C7\u30EB\u306F\u4E8B\u524D\u306B\u8AAD\u307F\u8FBC\u307E\u308C\u308B\u305F\u3081\u3001\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u3059\u3050\u306B\u958B\u59CB\u3067\u304D\u307E\u3059\u3002","option":"\u30A2\u30D7\u30EA\u8D77\u52D5\u6642\u306B AI \u30EF\u30FC\u30AF\u30D5\u30ED\u30FC \u30E2\u30C7\u30EB\u3092\u81EA\u52D5\u958B\u59CB"},"prompt":{"title":"AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306B\u95A2\u3059\u308B\u8FFD\u52A0\u60C5\u5831","description":"\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u5B9F\u884C\u6642\u306BCephable\u306EAI\u3067\u4F7F\u7528\u3059\u308B\u8FFD\u52A0\u60C5\u5831\u3092\u5165\u529B\u3057\u307E\u3059\u3002\u3053\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u4F7F\u7528\u3057\u3066\u3001\u30C8\u30FC\u30F3\u3001\u52D5\u4F5C\u3001\u305D\u306E\u4ED6\u306E\u8A73\u7D30\u306B\u95A2\u3059\u308B\u8A2D\u5B9A\u3092\u5165\u529B\u3057\u307E\u3059\u3002","field":"\u8FFD\u52A0\u306E\u30D7\u30ED\u30F3\u30D7\u30C8","placeholder":"\u4F8B\uFF1A\u30E1\u30FC\u30EB\u3092\u9001\u4FE1\u3059\u308B\u524D\u306B\u5FC5\u305A\u78BA\u8A8D\u3059\u308B\u3002\u8FD4\u4FE1\u306F\u7C21\u6F54\u306B\u3059\u308B\u3002\u6587\u66F8\u3067\u306F\u4E01\u5BE7\u306A\u8A00\u8449\u9063\u3044\u3092\u3059\u308B\u3002"},"disableButtonNames":{"edit":"\u30D6\u30ED\u30C3\u30AF\u30DC\u30BF\u30F3\u306E\u64CD\u4F5C","input":{"label":"\u30DC\u30BF\u30F3\u540D","question":"\u3069\u306E\u30DC\u30BF\u30F3\u3092\u975E\u8868\u793A\u306B\u3057\u305F\u3044\u3067\u3059\u304B\uFF1F\u30DC\u30BF\u30F3\u540D\u306F\u5168\u90E8\u307E\u305F\u306F\u4E00\u90E8\u3092\u5165\u529B\u3067\u304D\u307E\u3059\u3002","remove":"\u30DC\u30BF\u30F3\u540D\u3092\u524A\u9664"},"button":"\u30D6\u30ED\u30C3\u30AF\u30DC\u30BF\u30F3","description":"AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u304C\u64CD\u4F5C\u3067\u304D\u308B\u30DC\u30BF\u30F3\u3092\u5236\u5FA1\u3057\u307E\u3059\u3002\u30C7\u30D5\u30A9\u30EB\u30C8\u3067\u306F\u3001Cephable\u306F\u753B\u9762\u4E0A\u306E\u3069\u306E\u30DC\u30BF\u30F3\u3067\u3082\u30AF\u30EA\u30C3\u30AF\u3067\u304D\u307E\u3059\u3002\u3053\u306E\u8A2D\u5B9A\u3092\u4F7F\u7528\u3057\u3066\u3001\u610F\u56F3\u3057\u306A\u3044\u64CD\u4F5C\uFF08\u4F8B\u3048\u3070\u3001\u300C\u8CFC\u5165\u300D\u3001\u300C\u524A\u9664\u300D\u306A\u3069\uFF09\u3092\u9632\u6B62\u3067\u304D\u307E\u3059\u3002"}}},"control":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","automate":"\u81EA\u52D5\u5316","deviceCommandThrottled":{"macroLength":"\u3053\u306E\u63A5\u7D9A\u3067\u306F\u9577\u3044\u30DE\u30AF\u30ED\u306F\u4F7F\u7528\u3067\u304D\u307E\u305B\u3093\u3002\u30DE\u30AF\u30ED\u306F\u81EA\u52D5\u7684\u306B\u77ED\u7E2E\u3055\u308C\u307E\u3057\u305F\u3002","commandCount":"\u3053\u306E\u63A5\u7D9A\u3067\u306F\u30B3\u30DE\u30F3\u30C9\u306E\u9001\u4FE1\u901F\u5EA6\u304C\u5236\u9650\u3055\u308C\u307E\u3059\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002"},"tos":{"title":"\u5229\u7528\u898F\u7D04\u306E\u66F4\u65B0","description":"\u5229\u7528\u898F\u7D04\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002Cephable\u3092\u5F15\u304D\u7D9A\u304D\u3054\u5229\u7528\u3044\u305F\u3060\u304F\u306B\u306F\u3001\u66F4\u65B0\u3055\u308C\u305F\u898F\u7D04\u3092\u3054\u78BA\u8A8D\u306E\u4E0A\u3001\u540C\u610F\u3057\u3066\u3044\u305F\u3060\u304F\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","effectiveDate":"\u6709\u52B9\u65E5: {{date}}","accept":"\u5229\u7528\u898F\u7D04\u306B\u540C\u610F\u3059\u308B","loadError":"\u5229\u7528\u898F\u7D04\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","viewInBrowser":"\u5229\u7528\u898F\u7D04\u3092\u30D6\u30E9\u30A6\u30B6\u3067\u8868\u793A\u3059\u308B","acceptCheckbox":"\u5229\u7528\u898F\u7D04\u3092\u8AAD\u307F\u3001\u540C\u610F\u3057\u307E\u3059\u3002"}}');


var $8e6856e76156b5da$exports = {};
$8e6856e76156b5da$exports = JSON.parse('{"404":"\u3042\u3042\u3001\u5927\u5909\uFF01\u6D77\u4E2D\u3092\u63A2\u3057\u305F\u306E\u3067\u3059\u304C\u3001\u30DA\u30FC\u30B8\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\uFF01"}');


var $0fb65a16e8d9a99f$exports = {};
$0fb65a16e8d9a99f$exports = JSON.parse('{"smartTasks":{"tourLabel":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF","learn":"Cephable \u3092\u4F7F\u7528\u3057\u3066\u30C6\u30AD\u30B9\u30C8\u3092\u751F\u6210\u3001\u66F8\u304D\u63DB\u3048\u3001\u7FFB\u8A33\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","generate":{"openTool":{"title":"\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u30C4\u30FC\u30EB\u3092\u958B\u304F","description":"Cephable \u30D1\u30CD\u30EB\u3067\u3001\u300C\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8 \u30BF\u30B9\u30AF\u300D\u306E\u6A2A\u306B\u3042\u308B\u30CB\u30F3\u30B8\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3001\u300C\u30C6\u30AD\u30B9\u30C8\u306E\u751F\u6210\u300D\u3092\u9078\u629E\u3057\u307E\u3059\u3002"},"enterPrompt":{"title":"\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u5165\u529B","description":"\u30D7\u30ED\u30F3\u30D7\u30C8 \u30DC\u30C3\u30AF\u30B9\u306B\u6B21\u306E\u3088\u3046\u306B\u5165\u529B\u3057\u307E\u3059: \u30A4\u30F3\u30AF\u3067\u4FE1\u983C\u3067\u304D\u308B 1 \u6587\u306E\u99C4\u6D12\u843D\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002"},"clickGenerate":{"title":"\u751F\u6210\u3092\u30AF\u30EA\u30C3\u30AF","description":"\u300C\u751F\u6210\u300D\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002\u30C6\u30AD\u30B9\u30C8\u304C\u30EA\u30A2\u30EB\u30BF\u30A4\u30E0\u3067\u8868\u793A\u3055\u308C\u307E\u3059\u3002"},"focusApp":{"title":"\u30A2\u30D7\u30EA\u306B\u7126\u70B9\u3092\u5F53\u3066\u308B","description":"\u751F\u6210\u3055\u308C\u305F\u30C6\u30AD\u30B9\u30C8\u3092\u8868\u793A\u3057\u305F\u3044\u30A2\u30D7\u30EA\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u3092\u5408\u308F\u305B\u3066\u304F\u3060\u3055\u3044\u3002\u300C\u751F\u6210\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001\u305D\u306E\u5834\u6240\u306B\u30B7\u30FC\u30E0\u30EC\u30B9\u306B\u30C6\u30AD\u30B9\u30C8\u304C\u751F\u6210\u3055\u308C\u307E\u3059\u3002"}},"rewrite":{"welcome":{"title":"\u30EA\u30E9\u30A4\u30C8\u3078\u3088\u3046\u3053\u305D","description":"\u5F37\u8ABF\u8868\u793A\u307E\u305F\u306F\u8CBC\u308A\u4ED8\u3051\u305F\u30C6\u30AD\u30B9\u30C8\u3092\u4F7F\u7528\u3057\u3066\u3001\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u3059\u3070\u3084\u304F\u8A00\u3044\u63DB\u3048\u307E\u3059\u3002"},"highlightToggle":{"title":"\u5F37\u8ABF\u8868\u793A\u3055\u308C\u305F\u30C6\u30AD\u30B9\u30C8\u3092\u4F7F\u7528\u3059\u308B","description":"\u300C\u5F37\u8ABF\u8868\u793A\u3055\u308C\u305F\u30C6\u30AD\u30B9\u30C8\u3092\u4F7F\u7528\u3059\u308B\u300D\u304C\u9078\u629E\u3055\u308C\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u307E\u3059 (\u30C7\u30D5\u30A9\u30EB\u30C8)\u3002"},"highlightText":{"title":"\u66F8\u304D\u63DB\u3048\u308B\u30C6\u30AD\u30B9\u30C8\u3092\u5F37\u8ABF\u8868\u793A\u3059\u308B","description":"\u30CF\u30A4\u30E9\u30A4\u30C8: \u30BF\u30B3\u306F\u305D\u308C\u305E\u308C\u306E\u8155\u3092\u72EC\u7ACB\u3057\u3066\u5236\u5FA1\u3067\u304D\u307E\u3059\u3002"},"enterInstructions":{"title":"\u66F8\u304D\u63DB\u3048\u6307\u793A\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","description":"\u30BF\u30A4\u30D7: \u53E4\u3044\u82F1\u8A9E\u30B9\u30BF\u30A4\u30EB\u3002"},"clickGenerate":{"title":"\u751F\u6210\u3092\u30AF\u30EA\u30C3\u30AF","description":"\u5F37\u8ABF\u8868\u793A\u3055\u308C\u305F\u30C6\u30AD\u30B9\u30C8\u306F\u5165\u529B\u5185\u5BB9\u306B\u57FA\u3065\u3044\u3066\u66F8\u304D\u63DB\u3048\u3089\u308C\u307E\u3059\u3002"},"pasteMode":{"title":"\u30C6\u30AD\u30B9\u30C8\u8CBC\u308A\u4ED8\u3051\u3092\u4F7F\u7528\u3059\u308B","description":"\u5143\u306E\u30B3\u30FC\u30C9\u3092\u8CBC\u308A\u4ED8\u3051\u3066\u3001\u6307\u793A\u3092\u66F8\u304D\u63DB\u3048\u307E\u3059\u3002\u300C\u751F\u6210\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002\u300C\u30AF\u30EA\u30A2\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u30EA\u30BB\u30C3\u30C8\u3055\u308C\u307E\u3059\u3002"},"openTool":{"title":"\u30C6\u30AD\u30B9\u30C8\u66F8\u304D\u63DB\u3048\u30C4\u30FC\u30EB\u3092\u958B\u304F","description":"Cephable \u30D1\u30CD\u30EB\u3067\u3001\u300C\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8 \u30BF\u30B9\u30AF\u300D\u306E\u6A2A\u306B\u3042\u308B\u30CB\u30F3\u30B8\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3001\u300C\u30C6\u30AD\u30B9\u30C8\u306E\u66F8\u304D\u63DB\u3048\u300D\u3092\u9078\u629E\u3057\u307E\u3059\u3002"},"focusApp":{"title":"\u30A2\u30D7\u30EA\u306B\u7126\u70B9\u3092\u5F53\u3066\u308B","description":"\u66F8\u304D\u63DB\u3048\u305F\u30C6\u30AD\u30B9\u30C8\u3092\u8868\u793A\u3057\u305F\u3044\u30A2\u30D7\u30EA\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u3092\u5408\u308F\u305B\u3066\u304F\u3060\u3055\u3044\u3002\u300C\u751F\u6210\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001\u305D\u306E\u5834\u6240\u306B\u30B7\u30FC\u30E0\u30EC\u30B9\u306B\u30C6\u30AD\u30B9\u30C8\u304C\u751F\u6210\u3055\u308C\u307E\u3059\u3002"}},"translate":{"welcome":{"title":"\u7FFB\u8A33\u3078\u3088\u3046\u3053\u305D","description":"\u5F37\u8ABF\u8868\u793A\u307E\u305F\u306F\u8CBC\u308A\u4ED8\u3051\u3089\u308C\u305F\u30C6\u30AD\u30B9\u30C8\u3092\u5225\u306E\u8A00\u8A9E\u306B\u7FFB\u8A33\u3057\u307E\u3059\u3002"},"highlightToggle":{"title":"\u5F37\u8ABF\u8868\u793A\u3055\u308C\u305F\u30C6\u30AD\u30B9\u30C8\u3092\u4F7F\u7528\u3059\u308B","description":"\u300C\u5F37\u8ABF\u8868\u793A\u3055\u308C\u305F\u30C6\u30AD\u30B9\u30C8\u3092\u4F7F\u7528\u3059\u308B\u300D\u304C\u9078\u629E\u3055\u308C\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u307E\u3059\u3002"},"highlightText":{"title":"\u7FFB\u8A33\u3059\u308B\u30C6\u30AD\u30B9\u30C8\u3092\u5F37\u8ABF\u8868\u793A\u3059\u308B","description":"\u30CF\u30A4\u30E9\u30A4\u30C8: \u30BF\u30B3\u306F\u305D\u308C\u305E\u308C\u306E\u8155\u3092\u72EC\u7ACB\u3057\u3066\u5236\u5FA1\u3067\u304D\u307E\u3059\u3002"},"enterLanguage":{"title":"\u5BFE\u8C61\u8A00\u8A9E\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","description":"\u30BF\u30A4\u30D7: \u30DD\u30EB\u30C8\u30AC\u30EB\u8A9E\u3002"},"clickGenerate":{"title":"\u751F\u6210\u3092\u30AF\u30EA\u30C3\u30AF","description":"\u7FFB\u8A33\u306F\u30A2\u30D7\u30EA\u306E\u30AB\u30FC\u30BD\u30EB\u4F4D\u7F6E\u306B\u5165\u529B\u3055\u308C\u307E\u3059\u3002"},"pasteMode":{"title":"\u30C6\u30AD\u30B9\u30C8\u8CBC\u308A\u4ED8\u3051\u3092\u4F7F\u7528\u3059\u308B","description":"\u30C6\u30AD\u30B9\u30C8\u3068\u8A00\u8A9E\u3092\u8CBC\u308A\u4ED8\u3051\u307E\u3059\u3002\u300C\u751F\u6210\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002\u300C\u30AF\u30EA\u30A2\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u30EA\u30BB\u30C3\u30C8\u3055\u308C\u307E\u3059\u3002"},"openTool":{"title":"\u30C6\u30AD\u30B9\u30C8\u7FFB\u8A33\u30C4\u30FC\u30EB\u3092\u958B\u304F","description":"Cephable \u30D1\u30CD\u30EB\u3067\u3001\u300C\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8 \u30BF\u30B9\u30AF\u300D\u306E\u6A2A\u306B\u3042\u308B\u30CB\u30F3\u30B8\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3001\u300C\u30C6\u30AD\u30B9\u30C8\u306E\u7FFB\u8A33\u300D\u3092\u9078\u629E\u3057\u307E\u3059\u3002"}},"rowDescription":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\u3068\u306F\u3001Cephable\u306EAI\u304C\u3042\u306A\u305F\u306B\u4EE3\u308F\u3063\u3066\u5B9F\u884C\u3067\u304D\u308B\u69D8\u3005\u306A\u30BF\u30B9\u30AF\u3067\u3059\u3002\u3053\u308C\u3089\u306E\u30BF\u30B9\u30AF\u306F\u30C7\u30D0\u30A4\u30B9\u4E0A\u306EAI\u306B\u3088\u3063\u3066\u5B9F\u884C\u3055\u308C\u3001\u30C6\u30AD\u30B9\u30C8\u306E\u4F5C\u6210\u3001\u8981\u7D04\u3001\u66F8\u304D\u63DB\u3048\u3001\u7FFB\u8A33\u306A\u3069\u3001\u3055\u307E\u3056\u307E\u306A\u7528\u9014\u306B\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002"},"overview":{"title":"\u6982\u8981","description":"Cephable\u306F\u3001\u3042\u306A\u305F\u306E\u30D1\u30FC\u30BD\u30CA\u30EBAI\u3067\u3059\u3002\u7D20\u65E9\u3044\u30A2\u30AF\u30B7\u30E7\u30F3\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3001\u30B3\u30F3\u30C6\u30F3\u30C4\u751F\u6210\u3001\u305D\u3057\u3066\u30C4\u30FC\u30EB\u5168\u4F53\u306E\u30B9\u30DE\u30FC\u30C8\u306A\u81EA\u52D5\u5316\u3092\u5B9F\u73FE\u3057\u307E\u3059\u3002\u3059\u3050\u306B\u4F7F\u3048\u308B\u64CD\u4F5C\u6027\u3002\u30AF\u30E9\u30A6\u30C9\u51E6\u7406\u306F\u4E0D\u8981\u3002\u3042\u306A\u305F\u306E\u79FB\u52D5\u306B\u5408\u308F\u305B\u3066\u751F\u7523\u6027\u3092\u5411\u4E0A\u3057\u307E\u3059\u3002"},"customControls":{"tourLabel":"\u5E38\u306B\u5229\u7528\u53EF\u80FD\u306A\u30B0\u30ED\u30FC\u30D0\u30EB\u304A\u3088\u3073\u30C7\u30D0\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","rowDescription":"\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u5834\u5408\u3001\u3069\u306E\u30A2\u30D7\u30EA\u3092\u4F7F\u7528\u3057\u3066\u3044\u3066\u3082\u3001\u30B0\u30ED\u30FC\u30D0\u30EB\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30C7\u30D0\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u5E38\u306B\u5229\u7528\u3067\u304D\u307E\u3059\u3002\u3053\u308C\u3089\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u3048\u3070\u3001\u65B0\u3057\u3044\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F5C\u6210\u3059\u308B\u3053\u3068\u306A\u304F\u30C7\u30D0\u30A4\u30B9\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3084\u30A2\u30D7\u30EA\u306E\u5207\u308A\u66FF\u3048\u3001\u30C6\u30AD\u30B9\u30C8\u306E\u751F\u6210\u3001\u30DE\u30A4\u30AF\u306E\u4E00\u6642\u505C\u6B62\u306A\u3069\u3001\u4FBF\u5229\u306A\u30B3\u30DE\u30F3\u30C9\u304C\u542B\u307E\u308C\u3066\u3044\u307E\u3059\u3002"},"profile":{"tourLabel":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","learn":"Cephable \u3067\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u8A2D\u5B9A\u3092\u8A2D\u5B9A\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","rowDescription":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3001\u69D8\u3005\u306A\u64CD\u4F5C\u3092\u884C\u3046\u305F\u3081\u306B\u4F7F\u7528\u3067\u304D\u308B\u4E00\u9023\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u69CB\u6210\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u306E\u6B21\u306E\u30B9\u30E9\u30A4\u30C9\u306B\u79FB\u52D5\u3059\u308B\u306B\u306F\u300C\u6B21\u306E\u30B9\u30E9\u30A4\u30C9\u300D\u3068\u767A\u58F0\u3057\u305F\u3044\u3067\u3059\u304B\uFF1F\u982D\u306E\u52D5\u304D\u3067\u30AB\u30FC\u30BD\u30EB\u3092\u52D5\u304B\u3057\u3001\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u7DE8\u96C6\u30B7\u30E7\u30FC\u30C8\u30AB\u30C3\u30C8\u3092\u64CD\u4F5C\u3057\u305F\u3044\u3067\u3059\u304B\uFF1F\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u3048\u3070\u3001\u3053\u308C\u3089\u304C\u53EF\u80FD\u3067\u3059\u3002\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u884C\u306B\u306F\u3001\u73FE\u5728\u306E\u30A2\u30D7\u30EA\u3067\u4F7F\u7528\u3067\u304D\u308B\u3059\u3079\u3066\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002","check":{"title":"\u5229\u7528\u53EF\u80FD\u306A\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u78BA\u8A8D\u3057\u307E\u3059\u3002","description":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3001\u4F7F\u7528\u3057\u3066\u3044\u308B\u30A2\u30D7\u30EA\u3054\u3068\u306B\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u3059\u3002\u3053\u3053\u3067\u306F\u3001\u73FE\u5728\u4F7F\u7528\u3057\u3066\u3044\u308B\u30A2\u30D7\u30EA\u3067\u5229\u7528\u53EF\u80FD\u306A\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u78BA\u8A8D\u3067\u304D\u307E\u3059\u3002\u5225\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u8A66\u3057\u3066\u3001\u3069\u306E\u3088\u3046\u306B\u52D5\u4F5C\u3059\u308B\u304B\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u305F\u3060\u3057\u3001\u64CD\u4F5C\u3057\u305F\u3044\u30A2\u30D7\u30EA\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u3092\u5F53\u3066\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002"}},"dictation":{"tourLabel":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3","learn":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3 \u30E2\u30FC\u30C9\u3092\u4F7F\u7528\u3057\u3066\u3001\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u97F3\u58F0\u3092\u30C6\u30AD\u30B9\u30C8\u306B\u5909\u63DB\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","welcome":{"title":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3","description":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u4F7F\u3048\u3070\u3001\u81EA\u7136\u306A\u8A71\u3057\u65B9\u3067\u3001\u8A71\u3057\u306A\u304C\u3089\u5165\u529B\u3067\u304D\u307E\u3059\u3002\u307E\u308B\u3067\u3001\u3042\u306A\u305F\u306E\u8A71\u3059\u8A00\u8449\u3092\u3059\u3079\u3066\u5165\u529B\u3057\u3066\u304F\u308C\u308B\u30D1\u30FC\u30BD\u30CA\u30EB\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u304C\u3044\u308B\u304B\u306E\u3088\u3046\u3067\u3059\u3002"},"microphone":{"title":"\u30DE\u30A4\u30AF\u3092\u30AA\u30F3\u306B\u3059\u308B","description":"\u307E\u305A\u3001\u30DE\u30A4\u30AF\u3092\u30AA\u30F3\u306B\u3057\u307E\u3059\u3002Cephable\u30D1\u30CD\u30EB\u306E\u30DE\u30A4\u30AF\u5207\u308A\u66FF\u3048\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002"},"activate":{"title":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u3092\u958B\u59CB","description":"\u97F3\u58F0\u306F\u30B3\u30DE\u30F3\u30C9\u30E2\u30FC\u30C9\u3067\u8D77\u52D5\u3057\u307E\u3059\u3002\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u958B\u59CB\u3059\u308B\u306B\u306F\u3001\u300C\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u958B\u59CB\u300D\u3068\u8A00\u3046\u304B\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u305D\u308C\u3067\u306F\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u3092\u30AA\u30F3\u306B\u3057\u307E\u3057\u3087\u3046\u3002"},"focus":{"title":"\u30C6\u30AD\u30B9\u30C8\u30D5\u30A3\u30FC\u30EB\u30C9\u307E\u305F\u306F\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u3059\u308B","description":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u306F\u3001\u30C6\u30AD\u30B9\u30C8\u30D5\u30A3\u30FC\u30EB\u30C9\u307E\u305F\u306F\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u3092\u5F53\u3066\u308B\u3068\u6700\u3082\u52B9\u679C\u7684\u306B\u6A5F\u80FD\u3057\u307E\u3059\u3002\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3057\u305F\u3044\u30C6\u30AD\u30B9\u30C8\u30D5\u30A3\u30FC\u30EB\u30C9\u307E\u305F\u306F\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002"},"speaking":{"title":"\u8A71\u3057\u59CB\u3081\u308B","description":"\u3055\u3042\u3001\u8A71\u3057\u59CB\u3081\u307E\u3057\u3087\u3046\u3002\u8A71\u3057\u305F\u5185\u5BB9\u306F\u3059\u3079\u3066\u3001\u30D5\u30A9\u30FC\u30AB\u30B9\u3057\u305F\u30C6\u30AD\u30B9\u30C8\u30D5\u30A3\u30FC\u30EB\u30C9\u307E\u305F\u306F\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306B\u5165\u529B\u3055\u308C\u307E\u3059\u3002\u300C\u3053\u3093\u306B\u3061\u306F\u3002\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u306E\u30C6\u30B9\u30C8\u3067\u3059\u300D\u306E\u3088\u3046\u306B\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002"},"pauseResume":{"title":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u306E\u4E00\u6642\u505C\u6B62","description":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u505C\u6B62\u305B\u305A\u306B\u4F11\u61A9\u3057\u305F\u3044\u5834\u5408\u306F\u3001\u300C\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u4E00\u6642\u505C\u6B62\u300D\u3068\u767A\u58F0\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u300C\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u958B\u59CB\u300D\u3068\u767A\u58F0\u3059\u308C\u3070\u3044\u3064\u3067\u3082\u518D\u958B\u3067\u304D\u307E\u3059\u3002\u3053\u306E\u6A5F\u80FD\u306F\u3001\u5E38\u6642\u30AA\u30F3\u306E\u30B0\u30ED\u30FC\u30D0\u30EB\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30C7\u30D0\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u3055\u3089\u306B\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3067\u304D\u307E\u3059\u3002"},"stop":{"title":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u3084\u3081\u308B","description":"\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u623B\u308A\u305F\u3044\u3067\u3059\u304B\uFF1F\u300C\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u505C\u6B62\u300D\u3068\u8A00\u3046\u3060\u3051\u3067\u3059\u3002\u3053\u308C\u3067\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u304C\u505C\u6B62\u3057\u3001\u30B3\u30DE\u30F3\u30C9\u30E2\u30FC\u30C9\u306B\u623B\u308A\u307E\u3059\u3002\u300C\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u958B\u59CB\u300D\u3068\u8A00\u3048\u3070\u3044\u3064\u3067\u3082\u518D\u958B\u3067\u304D\u307E\u3059\u3002"},"complete":{"description":"\u3053\u308C\u3067\u5B8C\u4E86\u3067\u3059\uFF01\u97F3\u58F0\u5165\u529B\u3001\u4E00\u6642\u505C\u6B62\u3001\u518D\u958B\u3001\u305D\u3057\u3066\u97F3\u58F0\u5165\u529B\u30E2\u30FC\u30C9\u3068\u30B3\u30DE\u30F3\u30C9\u30E2\u30FC\u30C9\u306E\u5207\u308A\u66FF\u3048\u304C\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002\u97F3\u58F0\u5165\u529B\u306F\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u5165\u529B\u3092\u53EF\u80FD\u306B\u3059\u308B\u5F37\u529B\u306A\u30C4\u30FC\u30EB\u3067\u3059\u3002\u30E1\u30FC\u30EB\u3084\u6587\u66F8\u306E\u4F5C\u6210\u306A\u3069\u3001\u97F3\u58F0\u5165\u529B\u304C\u5FC5\u8981\u306A\u3042\u3089\u3086\u308B\u4F5C\u696D\u306B\u304A\u4F7F\u3044\u3044\u305F\u3060\u3051\u307E\u3059\u3002"}},"camera":{"tourLabel":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","rowDescription":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u9854\u3084\u4F53\u3092\u4F7F\u3063\u3066\u30C7\u30D0\u30A4\u30B9\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002\u3055\u307E\u3056\u307E\u306A\u8868\u60C5\u3084\u982D\u306E\u52D5\u304D\u3092\u4F7F\u3063\u3066\u30C7\u30D0\u30A4\u30B9\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002\u30DE\u30A4\u30AF\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3067\u30AB\u30E1\u30E9\u306E\u8D77\u52D5\u3068\u505C\u6B62\u3001\u30AB\u30E1\u30E9\u306E\u5207\u308A\u66FF\u3048\u304C\u3067\u304D\u307E\u3059\u3002","learn":"\u30AB\u30E1\u30E9 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3057\u3066\u3001\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u30C7\u30D0\u30A4\u30B9\u3092\u64CD\u4F5C\u304A\u3088\u3073\u64CD\u4F5C\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","welcome":{"title":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","description":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u3048\u3070\u3001\u9854\u3084\u4F53\u3092\u4F7F\u3063\u3066\u30C7\u30D0\u30A4\u30B9\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002\u8868\u60C5\u3084\u982D\u306E\u52D5\u304D\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u3063\u3066\u3001\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u30C7\u30D0\u30A4\u30B9\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002"},"start":{"title":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u958B\u59CB","description":"\u97F3\u58F0\u3092\u4F7F\u7528\u3057\u3066\u3044\u308B\u5834\u5408\u306B\u30AB\u30E1\u30E9 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u958B\u59CB\u3059\u308B\u306B\u306F\u3001\u300C\u30AB\u30E1\u30E9 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u958B\u59CB\u300D\u3068\u8A00\u3046\u304B\u3001[\u30AB\u30E1\u30E9 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB] \u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002"}},"microphone":{"tourLabel":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","learn":"\u97F3\u58F0\u3092\u4F7F\u7528\u3057\u3066\u4EFB\u610F\u306E\u30A2\u30D7\u30EA\u3092\u5236\u5FA1\u3057\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3057\u3066\u8A71\u3057\u305F\u3053\u3068\u3092\u5165\u529B\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","description":"Cephable Voice Controls\u3092\u4F7F\u3048\u3070\u3001\u97F3\u58F0\u3067\u30C7\u30D0\u30A4\u30B9\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u4FDD\u5B58\u3057\u305F\u3044\u3067\u3059\u304B\uFF1F\u300C\u4FDD\u5B58\u300D\u3068\u8A00\u3046\u3060\u3051\u3067\u3059\u3002\u97F3\u697D\u3092\u4E00\u6642\u505C\u6B62\u3057\u305F\u3044\u3067\u3059\u304B\uFF1F\u300C\u4E00\u6642\u505C\u6B62\u300D\u3068\u8A00\u3046\u3060\u3051\u3067\u3059\u3002\u97F3\u58F0\u5165\u529B\u6A5F\u80FD\u3092\u4F7F\u3048\u3070\u3001\u8A71\u3057\u305F\u5185\u5BB9\u3092\u97F3\u58F0\u5165\u529B\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002","rowDescription":"\u30DE\u30A4\u30AF\u304C\u30AA\u30D5\u306B\u306A\u3063\u3066\u3044\u308B\u3068\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u306F\u5168\u304F\u8A8D\u8B58\u3055\u308C\u307E\u305B\u3093\u3002\u3057\u304B\u3057\u3001\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u4E00\u6642\u505C\u6B62\u3084\u958B\u59CB\u306A\u3069\u306E\u64CD\u4F5C\u3092\u30B0\u30ED\u30FC\u30D0\u30EB\u30B3\u30DE\u30F3\u30C9\u3067\u64CD\u4F5C\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002\u3055\u3042\u3001\u30AA\u30F3\u306B\u3057\u3066\u307F\u307E\u3057\u3087\u3046\u3002","start":{"title":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u958B\u59CB","description":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u3044\u59CB\u3081\u308B\u306B\u306F\u3001\u30BB\u30D5\u30A1\u30D6\u30EB\u30D1\u30CD\u30EB\u306E\u30DE\u30A4\u30AF\u5207\u308A\u66FF\u3048\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u308A\u3001\u30B3\u30DE\u30F3\u30C9\u306E\u805E\u304D\u53D6\u308A\u304C\u958B\u59CB\u3055\u308C\u307E\u3059\u3002"},"tryOpen":{"title":"\u300CSpotify \u3092\u958B\u304F\u300D\u307E\u305F\u306F\u300CWord \u3092\u958B\u304F\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044","description":"`Open` \u306F\u3001\u6307\u5B9A\u3057\u305F\u30A2\u30D7\u30EA\u3092\u958B\u304D\u3001\u30D5\u30A9\u30FC\u30AB\u30B9\u3092\u305D\u306E\u30A2\u30D7\u30EA\u306B\u9001\u308B\u30B0\u30ED\u30FC\u30D0\u30EB\u30B3\u30DE\u30F3\u30C9\u3067\u3059\u3002\u81EA\u52D5\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u5207\u308A\u66FF\u3048\u304C\u6709\u52B9\u306B\u306A\u3063\u3066\u3044\u308B\u5834\u5408\u306F\u3001\u4F7F\u7528\u4E2D\u306E\u30A2\u30D7\u30EA\u306B\u6700\u9069\u306A\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u5207\u308A\u66FF\u3048\u307E\u3059\u3002"},"finishedCommands":{"title":"\u7D20\u6674\u3089\u3057\u3044\uFF01\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u57FA\u672C\u3092\u5B66\u7FD2\u3057\u307E\u3057\u305F\u3002","description":"\u30B5\u30DD\u30FC\u30C8\u30DA\u30FC\u30B8\u304B\u3089\u3044\u3064\u3067\u3082\u30C4\u30A2\u30FC\u3092\u518D\u958B\u3067\u304D\u307E\u3059\u3002\u6B21\u306E\u30B9\u30C6\u30C3\u30D7\u306F\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u306B\u3064\u3044\u3066\u5B66\u3076\u3053\u3068\u3067\u3059\u3002\u30B5\u30DD\u30FC\u30C8\u30DA\u30FC\u30B8\u304B\u3089\u30C4\u30A2\u30FC\u3092\u958B\u59CB\u3067\u304D\u307E\u3059\u3002"}},"publicProfiles":{"tourLabel":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3059\u308B"},"tour":{"title":"Cephable\u3078\u3088\u3046\u3053\u305D","description":"Cephable\u306F\u3001\u97F3\u58F0\u3001\u30AB\u30E1\u30E9\u3001\u305D\u306E\u4ED6\u306E\u5165\u529B\u3092\u4F7F\u3063\u3066\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u3092\u64CD\u4F5C\u3067\u304D\u308B\u5F37\u529B\u306A\u30C4\u30FC\u30EB\u3067\u3059\u3002\u3053\u306E\u30C4\u30A2\u30FC\u3067\u306F\u3001\u4E3B\u8981\u306A\u6A5F\u80FD\u3068\u52B9\u679C\u7684\u306A\u4F7F\u3044\u65B9\u3092\u3054\u7D39\u4ECB\u3057\u307E\u3059\u3002","startTour":"\u30C4\u30A2\u30FC\u3092\u958B\u59CB","finishTour":"\u30C4\u30A2\u30FC\u7D42\u4E86","statusDialog":"\u8A73\u7D30\u306B\u3064\u3044\u3066\u306F\u30D1\u30CD\u30EB\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002","step":"{{step}} / {{total}} \u30B9\u30C6\u30C3\u30D7","next":"\u6B21","previous":"\u524D\u306E","endTour":"\u30C4\u30A2\u30FC\u7D42\u4E86","nextTourLabel":"\u6B21\u3078: {{nextStepTitle}}","skipTour":"\u30C4\u30A2\u30FC\u3092\u30B9\u30AD\u30C3\u30D7","steps":{"welcome":{"title":"Cephable\u3078\u3088\u3046\u3053\u305D","description":"\u3053\u306E\u30C4\u30A2\u30FC\u3067\u306F\u3001Cephable\u306E\u4E3B\u306A\u6A5F\u80FD\u3092\u3054\u7D39\u4ECB\u3057\u307E\u3059\u3002\u3055\u3042\u3001\u59CB\u3081\u307E\u3057\u3087\u3046\uFF01"},"inputs":{"title":"\u5165\u529B\u306E\u6982\u8981","description":"Cephable\u306F\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3001\u30AB\u30E1\u30E9\u64CD\u4F5C\u306A\u3069\u3001\u3055\u307E\u3056\u307E\u306A\u5165\u529B\u65B9\u6CD5\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u3066\u3044\u307E\u3059\u3002\u3053\u308C\u3089\u306E\u5165\u529B\u306F\u8A2D\u5B9A\u3067\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3067\u304D\u307E\u3059\u3002"},"appControls":{"title":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","description":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F5C\u6210\u3057\u3066\u3001\u5165\u529B\u3092\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u5185\u306E\u7279\u5B9A\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u306B\u30DE\u30C3\u30D4\u30F3\u30B0\u3057\u307E\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u30B8\u30A7\u30B9\u30C1\u30E3\u30FC\u3084\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u306A\u3069\u3067\u30A2\u30D7\u30EA\u3092\u64CD\u4F5C\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002"},"settings":{"title":"\u8A2D\u5B9A","description":"\u8A2D\u5B9A\u306B\u30A2\u30AF\u30BB\u30B9\u3057\u3066\u3001\u5165\u529B\u65B9\u6CD5\u3001\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3001\u305D\u306E\u4ED6\u306E\u8A2D\u5B9A\u3092\u5909\u66F4\u3067\u304D\u307E\u3059\u3002\u30A2\u30AB\u30A6\u30F3\u30C8\u3068\u8A00\u8A9E\u8A2D\u5B9A\u3082\u3053\u3053\u3067\u7BA1\u7406\u3067\u304D\u307E\u3059\u3002"},"intelligentTasks":{"title":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF","description":"AI \u3092\u6D3B\u7528\u3057\u305F\u6A5F\u80FD\u3092\u4F7F\u7528\u3057\u3066\u3001\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8 \u30BF\u30B9\u30AF\u3067\u30C6\u30AD\u30B9\u30C8\u306E\u751F\u6210\u3001\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u8981\u7D04\u3001\u30C6\u30AD\u30B9\u30C8\u306E\u66F8\u304D\u63DB\u3048\u3001\u8A00\u8A9E\u306E\u7FFB\u8A33\u306A\u3069\u3092\u884C\u3046\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"},"cameraControls":{"title":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","description":"\u30AB\u30E1\u30E9 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u6709\u52B9\u306B\u3059\u308B\u3068\u3001\u9854\u306E\u8868\u60C5\u3084\u982D\u306E\u52D5\u304D\u3092\u5165\u529B\u65B9\u6CD5\u3068\u3057\u3066\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u3092\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u304D\u307E\u3059\u3002"},"voiceControls":{"title":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","description":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u3063\u3066\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002\u97F3\u58F0\u3067\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3057\u305F\u308A\u3001\u30B3\u30DE\u30F3\u30C9\u3092\u767A\u884C\u3057\u305F\u308A\u3001\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u64CD\u4F5C\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002"}}},"onboarding":{"demoPlaceholder":"\u3053\u308C\u306F\u30C7\u30E2\u7528\u306E\u30D7\u30EC\u30FC\u30B9\u30DB\u30EB\u30C0\u30C6\u30AD\u30B9\u30C8\u3067\u3059\u3002\u4E0A\u8A18\u306E\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u4F7F\u7528\u3057\u3066\u3001\u3053\u306E\u30C6\u30AD\u30B9\u30C8\u306E\u30B9\u30BF\u30A4\u30EB\u3092\u5236\u5FA1\u3067\u304D\u307E\u3059\u3002","exit":"\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7\u3092\u7D42\u4E86","overview":"\u6982\u8981","learn":"Cephable \u306E\u6A5F\u80FD\u3068\u305D\u306E\u4F7F\u7528\u65B9\u6CD5\u306B\u3064\u3044\u3066\u5B66\u3073\u307E\u3059\u3002","start":"\u307E\u3060\u59CB\u307E\u3063\u305F\u3070\u304B\u308A\u306E\u3088\u3046\u3067\u3059\u306D\u3002\u3053\u308C\u304B\u3089\u5F79\u7ACB\u3064\u30D2\u30F3\u30C8\u3092\u3044\u304F\u3064\u304B\u3054\u7D39\u4ECB\u3057\u307E\u3059\u3002","startTour":"\u59CB\u3081\u308B","dashboard":{"title":"Cephable\u30C0\u30C3\u30B7\u30E5\u30DC\u30FC\u30C9","description":"Cephable\u30C0\u30C3\u30B7\u30E5\u30DC\u30FC\u30C9\u306F\u3001\u30C7\u30D0\u30A4\u30B9\u3001\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3001\u8A2D\u5B9A\u3092\u7BA1\u7406\u3059\u308B\u305F\u3081\u306E\u4E2D\u5FC3\u7684\u306A\u30CF\u30D6\u3067\u3059\u3002\u3053\u3053\u304B\u3089\u3001\u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u305F\u308A\u3001\u30A2\u30AF\u30C6\u30A3\u30D6\u306A\u30B3\u30DE\u30F3\u30C9\u3092\u78BA\u8A8D\u3057\u305F\u308A\u3001Cephable\u306E\u3059\u3079\u3066\u306E\u6A5F\u80FD\u306B\u30A2\u30AF\u30BB\u30B9\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002"},"step1":{"title":"Cephable\u3078\u3088\u3046\u3053\u305D","description":"Cephable\u306F\u3001\u3042\u306A\u305F\u306E\u30D1\u30FC\u30BD\u30CA\u30EBAI\u3067\u3059\u3002\u7D20\u65E9\u3044\u30A2\u30AF\u30B7\u30E7\u30F3\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3001\u30B3\u30F3\u30C6\u30F3\u30C4\u751F\u6210\u3001\u305D\u3057\u3066\u30C4\u30FC\u30EB\u5168\u4F53\u306E\u30B9\u30DE\u30FC\u30C8\u306A\u81EA\u52D5\u5316\u3092\u5B9F\u73FE\u3057\u307E\u3059\u3002\u3059\u3050\u306B\u4F7F\u3048\u308B\u64CD\u4F5C\u6027\u3002\u30AF\u30E9\u30A6\u30C9\u51E6\u7406\u306F\u4E0D\u8981\u3002\u3042\u306A\u305F\u306E\u79FB\u52D5\u306B\u5408\u308F\u305B\u3066\u751F\u7523\u6027\u3092\u5411\u4E0A\u3057\u307E\u3059\u3002","inputs":"\u5165\u529B\u3068\u306F\u4F55\u3067\u3059\u304B?","inputDescription":"\u5165\u529B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u306F\u3001\u30C7\u30D0\u30A4\u30B9\u3092\u64CD\u4F5C\u3059\u308B\u305F\u3081\u306E\u65B9\u6CD5\u3067\u3042\u308A\u3001\u5F93\u6765\u306E\u30DE\u30A6\u30B9\u3068\u30AD\u30FC\u30DC\u30FC\u30C9\u3092\u8D85\u3048\u3066\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u306E\u6A5F\u80FD\u3092\u62E1\u5F35\u3057\u307E\u3059\u3002\u3053\u308C\u306B\u306F\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3001\u982D\u306E\u52D5\u304D\u3001\u8868\u60C5\u3001\u305D\u306E\u4ED6\u306E\u5468\u8FBA\u6A5F\u5668\u306A\u3069\u304C\u542B\u307E\u308C\u307E\u3059\u3002","profiles":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u306F\u4F55\u3067\u3059\u304B?","profileDescription":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u5165\u529B\u3068\u51FA\u529B\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u7D44\u307F\u5408\u308F\u305B\u308B\u3053\u3068\u3067\u3001\u72EC\u81EA\u306E\u65B9\u6CD5\u3067\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u306B\u63A5\u7D9A\u3057\u3001\u901A\u4FE1\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u982D\u3092\u50BE\u3051\u308B\u3060\u3051\u3067\u30D5\u30A1\u30A4\u30EB\u3092\u4FDD\u5B58\u3057\u305F\u308A\u3001\u7B11\u9854\u3067\u30E1\u30FC\u30EB\u306E\u300C\u9001\u4FE1\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u305F\u308A\u3059\u308B\u306A\u3069\u3001Cephable\u306B\u30BF\u30B9\u30AF\u3092\u5B9F\u884C\u3055\u305B\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","action":"\u5165\u529B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8ABF\u3079\u308B","secondaryAction":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3078\u30B9\u30AD\u30C3\u30D7","secondaryActionDescription":"\u5165\u529B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u3064\u3044\u3066\u3059\u3067\u306B\u3054\u5B58\u77E5\u3067\u3059\u304B?"},"finish":{"title":"\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7\u5B8C\u4E86","description":"Cephable\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u6700\u521D\u306E\u4F7F\u7528\u306B\u6210\u529F\u3057\u307E\u3057\u305F\uFF01\u3053\u308C\u3067\u3001\u30C7\u30D0\u30A4\u30B9\u3067\u3053\u308C\u3089\u306E\u6A5F\u80FD\u3084\u305D\u306E\u4ED6\u306E\u6A5F\u80FD\u3092\u5229\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002Cephable\u30C0\u30C3\u30B7\u30E5\u30DC\u30FC\u30C9\u3067\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u8A2D\u5B9A\u3092\u5FC5\u8981\u306B\u5FDC\u3058\u3066\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3067\u304D\u307E\u3059\u3002","continueToApp":"Cephable\u30C0\u30C3\u30B7\u30E5\u30DC\u30FC\u30C9\u306B\u9032\u3080","keepExploring":"\u63A2\u691C\u3092\u7D9A\u3051\u308B"},"useCaseSlider":{"context":"\u4F7F\u7528\u3057\u305F\u3044","control":"\u5236\u5FA1\u3059\u308B"}},"support":{"tourLabel":"\u3055\u3089\u306B\u8A73\u3057\u304F\u77E5\u308A\u305F\u3044\u3067\u3059\u304B?","description":"Cephable \u306E\u4F7F\u7528\u65B9\u6CD5\u306B\u95A2\u3059\u308B\u8A73\u7D30\u60C5\u5831\uFF08\u305D\u306E\u4ED6\u306E\u30C4\u30A2\u30FC\u3001\u30B9\u30C6\u30C3\u30D7\u30D0\u30A4\u30B9\u30C6\u30C3\u30D7 \u30AC\u30A4\u30C9\u3001\u30C1\u30E5\u30FC\u30C8\u30EA\u30A2\u30EB\u3001\u30D3\u30C7\u30AA\u306A\u3069\uFF09\u306B\u3064\u3044\u3066\u306F\u3001\u30B5\u30DD\u30FC\u30C8 \u30CF\u30D6\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002","cta":"\u4ED6\u306E\u30C4\u30A2\u30FC\u3092\u898B\u308B"},"featureFlag":{"title":"\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u306E\u6642\u671F","description":"\u3054\u5229\u7528\u306B\u306A\u308A\u305F\u3044\u6A5F\u80FD\u306B\u306F\u5225\u306E\u30E9\u30A4\u30BB\u30F3\u30B9\u304C\u5FC5\u8981\u3067\u3059\u3002\u3053\u306E\u6A5F\u80FD\u3084\u305D\u306E\u4ED6\u306E\u6A5F\u80FD\u3092\u3054\u5229\u7528\u3044\u305F\u3060\u304F\u306B\u306F\u3001\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"replyToSocialMedia":{"tourLabel":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3067\u30BD\u30FC\u30B7\u30E3\u30EB\u30E1\u30C7\u30A3\u30A2\u3078\u306E\u8FD4\u4FE1\u3092\u9AD8\u901F\u5316","learn":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3057\u3066\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u30BD\u30FC\u30B7\u30E3\u30EB \u30E1\u30C7\u30A3\u30A2\u306E\u6295\u7A3F\u306B\u8FD4\u4FE1\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","navigateTo":{"title":"\u30BD\u30FC\u30B7\u30E3\u30EB\u30E1\u30C7\u30A3\u30A2\u306E\u6295\u7A3F\u306B\u79FB\u52D5\u3059\u308B","description":"\u30A6\u30A7\u30D6\u30D6\u30E9\u30A6\u30B6\u3092\u958B\u304D\u3001LinkedIn\u3084Facebook\u306A\u3069\u306E\u30BD\u30FC\u30B7\u30E3\u30EB\u30E1\u30C7\u30A3\u30A2\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u306B\u30A2\u30AF\u30BB\u30B9\u3057\u307E\u3059\u3002\u8FD4\u4FE1\u3057\u305F\u3044\u6295\u7A3F\u3092\u898B\u3064\u3051\u307E\u3059\u3002"},"speaking":{"title":"\u8A71\u3057\u59CB\u3081\u308B","description":"\u3055\u3042\u3001\u8A71\u3057\u59CB\u3081\u307E\u3057\u3087\u3046\u3002\u8A71\u3057\u305F\u5185\u5BB9\u306F\u3059\u3079\u3066\u3001\u30D5\u30A9\u30FC\u30AB\u30B9\u3057\u305F\u30C6\u30AD\u30B9\u30C8\u30D5\u30A3\u30FC\u30EB\u30C9\u307E\u305F\u306F\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306B\u5165\u529B\u3055\u308C\u307E\u3059\u3002\u300C\u304A\u3081\u3067\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01\u697D\u3057\u307F\u306B\u3057\u3066\u3044\u307E\u3059\u300D\u306E\u3088\u3046\u306B\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002\u30AB\u30FC\u30BD\u30EB\u304C\u30C6\u30AD\u30B9\u30C8\u30D5\u30A3\u30FC\u30EB\u30C9\u307E\u305F\u306F\u30B3\u30E1\u30F3\u30C8\u30DC\u30C3\u30AF\u30B9\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u3055\u308C\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"complete":{"description":"\u3053\u308C\u3067\u5B8C\u4E86\u3067\u3059\uFF01\u97F3\u58F0\u5165\u529B\u3001\u4E00\u6642\u505C\u6B62\u3001\u518D\u958B\u3001\u97F3\u58F0\u5165\u529B\u30E2\u30FC\u30C9\u3068\u30B3\u30DE\u30F3\u30C9\u30E2\u30FC\u30C9\u306E\u5207\u308A\u66FF\u3048\u306A\u3069\u3092\u4F7F\u3063\u3066\u3001\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u30BD\u30FC\u30B7\u30E3\u30EB\u30E1\u30C7\u30A3\u30A2\u306E\u6295\u7A3F\u306B\u8FD4\u4FE1\u3067\u304D\u307E\u3059\u3002\u97F3\u58F0\u5165\u529B\u306F\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u5165\u529B\u306E\u305F\u3081\u306E\u5F37\u529B\u306A\u30C4\u30FC\u30EB\u3067\u3059\u3002\u30E1\u30FC\u30EB\u3084\u6587\u66F8\u306E\u4F5C\u6210\u306A\u3069\u3001\u97F3\u58F0\u5165\u529B\u304C\u5FC5\u8981\u306A\u3042\u3089\u3086\u308B\u4F5C\u696D\u306B\u304A\u4F7F\u3044\u3044\u305F\u3060\u3051\u307E\u3059\u3002"}},"hotkeys":{"tourLabel":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3","learn":"\u30AF\u30A4\u30C3\u30AF \u30A2\u30AF\u30B7\u30E7\u30F3 \u30DC\u30BF\u30F3\u3092\u8A2D\u5B9A\u3057\u3066\u3001\u8907\u6570\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u3092 1 \u3064\u306E\u30DC\u30BF\u30F3\u306B\u30DE\u30C3\u30D4\u30F3\u30B0\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","rowDescription":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u3092\u4F7F\u7528\u3059\u308B\u3068\u30011\u3064\u306E\u30B3\u30DE\u30F3\u30C9\u3067\u8907\u6570\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u5B9F\u884C\u3067\u304D\u307E\u3059\u3002\u4F8B\u3048\u3070\u3001\u304A\u6C17\u306B\u5165\u308A\u306E\u97F3\u697D\u30A2\u30D7\u30EA\u3092\u8D77\u52D5\u3057\u3066\u7279\u5B9A\u306E\u30D7\u30EC\u30A4\u30EA\u30B9\u30C8\u306E\u518D\u751F\u3092\u958B\u59CB\u3059\u308B\u30DC\u30BF\u30F3\u3092\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002","check":{"title":"\u5229\u7528\u53EF\u80FD\u306A\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u78BA\u8A8D\u3057\u307E\u3059\u3002","description":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u306F\u3001\u4F7F\u7528\u3059\u308B\u30A2\u30D7\u30EA\u3054\u3068\u306B\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u3059\u3002\u3053\u3053\u3067\u306F\u3001\u73FE\u5728\u4F7F\u7528\u4E2D\u306E\u30A2\u30D7\u30EA\u3067\u5229\u7528\u3067\u304D\u308B\u30DC\u30BF\u30F3\u3092\u78BA\u8A8D\u3067\u304D\u307E\u3059\u3002\u5225\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u8A66\u3057\u3066\u3001\u3069\u306E\u3088\u3046\u306B\u52D5\u4F5C\u3059\u308B\u304B\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u305F\u3060\u3057\u3001\u64CD\u4F5C\u3057\u305F\u3044\u30A2\u30D7\u30EA\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u3092\u5F53\u3066\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002"}},"controllingBackgroundMusic":{"tourLabel":"\u4F5C\u696D\u306E\u6D41\u308C\u3092\u4E2D\u65AD\u305B\u305A\u306BBGM\u3092\u7BA1\u7406\u3059\u308B","learn":"\u73FE\u5728\u306E\u30BF\u30B9\u30AF\u306B\u96C6\u4E2D\u3057\u306A\u304C\u3089\u3001\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3057\u3066\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u97F3\u697D\u3092\u5236\u5FA1\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","tryOpen":{"title":"\u300CSpotify\u3092\u958B\u304F\u300D\u307E\u305F\u306F\u300CApple Music\u3092\u958B\u304F\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044"},"play":{"title":"\u97F3\u697D\u306E\u518D\u751F\u3092\u958B\u59CB\u3059\u308B\u306B\u306F\u3001\u300C\u518D\u751F\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044","description":"\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u3001\u300C\u518D\u751F\u300D\u3068\u767A\u58F0\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u9078\u629E\u3057\u305F\u97F3\u697D\u30A2\u30D7\u30EA\u3067\u97F3\u697D\u306E\u518D\u751F\u304C\u59CB\u307E\u308A\u307E\u3059\u3002\u4ED6\u306E\u30E1\u30C7\u30A3\u30A2\u30A2\u30D7\u30EA\u3067\u3082\u540C\u69D8\u306B\u6A5F\u80FD\u3057\u307E\u3059\u3002"},"newPlaylist":{"title":"\u65B0\u3057\u3044\u30D7\u30EC\u30A4\u30EA\u30B9\u30C8\u3092\u4F5C\u6210\u3059\u308B","description":"\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3001\u300C\u65B0\u3057\u3044\u30D7\u30EC\u30A4\u30EA\u30B9\u30C8\u300D\u3068\u767A\u58F0\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u9078\u629E\u3057\u305F\u97F3\u697D\u30A2\u30D7\u30EA\u3067\u65B0\u3057\u3044\u30D7\u30EC\u30A4\u30EA\u30B9\u30C8\u306E\u4F5C\u6210\u30D7\u30ED\u30BB\u30B9\u304C\u958B\u59CB\u3055\u308C\u307E\u3059\u3002"},"finishedCommands":{"title":"\u3088\u304F\u3067\u304D\u307E\u3057\u305F\uFF01\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u97F3\u697D\u3092\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3057\u305F\u3002","description":"\u304A\u6C17\u306B\u5165\u308A\u306E\u97F3\u697D\u30A2\u30D7\u30EA\u3067\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u4F7F\u3063\u3066\u518D\u751F\u3001\u4E00\u6642\u505C\u6B62\u3001\u66F2\u306E\u30B9\u30AD\u30C3\u30D7\u3001\u97F3\u91CF\u8ABF\u6574\u3092\u884C\u3046\u65B9\u6CD5\u3092\u7FD2\u5F97\u3057\u307E\u3057\u305F\u3002\u4ED6\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u8A66\u3057\u305F\u308A\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u3066\u3001\u3055\u3089\u306B\u30B9\u30E0\u30FC\u30BA\u306A\u97F3\u697D\u64CD\u4F5C\u3092\u5B9F\u73FE\u3057\u307E\u3057\u3087\u3046\u3002"}},"editingVideos":{"tourLabel":"\u52D5\u753B\u7DE8\u96C6\u306E\u9762\u5012\u306A\u30AF\u30EA\u30C3\u30AF\u3067\u306F\u306A\u304F\u3001\u30B9\u30C8\u30FC\u30EA\u30FC\u306B\u96C6\u4E2D\u3057\u307E\u3057\u3087\u3046","learn":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3057\u3066\u30D3\u30C7\u30AA\u3092\u3088\u308A\u901F\u304F\u7DE8\u96C6\u3057\u3001\u7DE8\u96C6\u4E2D\u306B\u3069\u306E\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u304B\u3092\u899A\u3048\u3066\u304A\u304F\u3068\u3044\u3046\u8A8D\u77E5\u8CA0\u8377\u3092\u53D6\u308A\u9664\u304F\u65B9\u6CD5\u3092\u5B66\u7FD2\u3057\u307E\u3059\u3002","tryOpen":{"title":"\u300CiMovie\u3092\u958B\u304F\u300D\u307E\u305F\u306F\u300CDaVinci Resolve\u3092\u958B\u304F\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002"},"play":{"title":"\u300C\u518D\u751F\u300D\u3068\u8A00\u3063\u3066\u30D3\u30C7\u30AA\u3092\u518D\u751F\u3057\u3066\u307F\u307E\u3057\u3087\u3046","description":"\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u3001\u300C\u518D\u751F\u300D\u3068\u767A\u58F0\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u9078\u629E\u3057\u305F\u52D5\u753B\u7DE8\u96C6\u30A2\u30D7\u30EA\u3067\u52D5\u753B\u306E\u518D\u751F\u304C\u59CB\u307E\u308A\u307E\u3059\u3002"},"stop":{"title":"\u30D3\u30C7\u30AA\u306E\u518D\u751F\u3092\u505C\u6B62","description":"\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3001\u300C\u505C\u6B62\u300D\u3068\u8A00\u3063\u3066\u304F\u3060\u3055\u3044\u3002\u9078\u629E\u3057\u305F\u52D5\u753B\u7DE8\u96C6\u30A2\u30D7\u30EA\u3067\u52D5\u753B\u306E\u518D\u751F\u304C\u505C\u6B62\u3057\u307E\u3059\u3002"},"finishedCommands":{"title":"\u3088\u304F\u3067\u304D\u307E\u3057\u305F\uFF01\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u30D3\u30C7\u30AA\u7DE8\u96C6\u3092\u64CD\u4F5C\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3057\u305F\u3002","description":"\u304A\u6C17\u306B\u5165\u308A\u306E\u52D5\u753B\u7DE8\u96C6\u30A2\u30D7\u30EA\u3067\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u4F7F\u3063\u3066\u518D\u751F\u3001\u4E00\u6642\u505C\u6B62\u3001\u30C8\u30E9\u30C3\u30AF\u30B9\u30AD\u30C3\u30D7\u3001\u97F3\u91CF\u8ABF\u6574\u3092\u884C\u3046\u65B9\u6CD5\u3092\u7FD2\u5F97\u3057\u307E\u3057\u305F\u3002\u4ED6\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u8A66\u3057\u305F\u308A\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u3066\u3001\u3055\u3089\u306B\u30B9\u30E0\u30FC\u30BA\u306A\u52D5\u753B\u64CD\u4F5C\u3092\u5B9F\u73FE\u3057\u307E\u3057\u3087\u3046\u3002"}},"vibeCoding":{"tourLabel":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3067\u30A2\u30A4\u30C7\u30A2\u5275\u51FA\u3001\u30D7\u30ED\u30C8\u30BF\u30A4\u30D7\u4F5C\u6210\u3001\u53CD\u5FA9\u4F5C\u696D\u3092\u30B9\u30D4\u30FC\u30C9\u30A2\u30C3\u30D7","learn":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3068 AI \u3092\u6D3B\u7528\u3057\u305F\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u3092\u4F7F\u7528\u3057\u3066\u3001\u30B3\u30FC\u30C9\u306E\u5B9F\u884C\u3001\u30D7\u30ED\u30C8\u30BF\u30A4\u30D7\u306E\u4F5C\u6210\u3001\u30A2\u30A4\u30C7\u30A2\u306E\u53CD\u5FA9\u51E6\u7406\u3092\u5B9F\u884C\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","navigateTo":{"title":"Vibe\u30B3\u30FC\u30C9\u30A8\u30C7\u30A3\u30BF\u30FC\u306B\u79FB\u52D5\u3059\u308B","description":"\u30A6\u30A7\u30D6\u30D6\u30E9\u30A6\u30B6\u3092\u958B\u304D\u3001Vibe\u30B3\u30FC\u30C9\u30A8\u30C7\u30A3\u30BF\u306B\u30A2\u30AF\u30BB\u30B9\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u4F8B\u3068\u3057\u3066\u306F\u3001Vercel V0\u3001VS Code\u306EGitHub Copilot\u3001Base 44\u3001Lovable\u306A\u3069\u304C\u3042\u308A\u307E\u3059\u3002"},"focus":{"title":"\u65B0\u3057\u3044\u30C1\u30E3\u30C3\u30C8\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u304B\u3001\u30C6\u30AD\u30B9\u30C8\u30DC\u30C3\u30AF\u30B9\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u3092\u5F53\u3066\u307E\u3059","description":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u306F\u3001\u30C6\u30AD\u30B9\u30C8\u30D5\u30A3\u30FC\u30EB\u30C9\u307E\u305F\u306F\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u3092\u5F53\u3066\u308B\u3068\u6700\u3082\u52B9\u679C\u7684\u306B\u6A5F\u80FD\u3057\u307E\u3059\u3002\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3057\u305F\u3044\u30B3\u30E1\u30F3\u30C8\u30DC\u30C3\u30AF\u30B9\u307E\u305F\u306F\u8FD4\u4FE1\u30B9\u30EC\u30C3\u30C9\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001\u8AAD\u307F\u4E0A\u3052\u3092\u958B\u59CB\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"speaking":{"title":"\u8A71\u3057\u59CB\u3081\u308B","description":"\u3055\u3042\u3001\u8A71\u3057\u59CB\u3081\u307E\u3057\u3087\u3046\u3002\u8A71\u3057\u305F\u5185\u5BB9\u306F\u3059\u3079\u3066\u3001\u30D5\u30A9\u30FC\u30AB\u30B9\u3057\u305F\u30C6\u30AD\u30B9\u30C8\u30D5\u30A3\u30FC\u30EB\u30C9\u307E\u305F\u306F\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306B\u5165\u529B\u3055\u308C\u307E\u3059\u3002\u6280\u8853\u7684\u306A\u8981\u4EF6\u3084\u30B3\u30FC\u30C9\u306E\u52D5\u4F5C\u3092\u8A71\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002\u30AB\u30FC\u30BD\u30EB\u304C\u30C6\u30AD\u30B9\u30C8\u30D5\u30A3\u30FC\u30EB\u30C9\u307E\u305F\u306F\u30B3\u30E1\u30F3\u30C8\u30DC\u30C3\u30AF\u30B9\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u3055\u308C\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"rewriteIntro":{"title":"\u547D\u4EE4\u3092\u4F7F\u3063\u3066\u30B3\u30FC\u30C9\u3092\u66F8\u304D\u63DB\u3048\u308B","description":"\u307E\u305F\u3001Rewrite\u306A\u3069\u306E\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\u3092\u4F7F\u7528\u3057\u3066\u3001\u65E2\u5B58\u306E\u30B3\u30FC\u30C9\u3092\u305D\u306E\u5834\u3067\u5909\u66F4\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002\u3053\u306E\u30BF\u30B9\u30AF\u306F\u30C7\u30D0\u30A4\u30B9\u4E0A\u306EAI\u306B\u3088\u3063\u3066\u5B9F\u884C\u3055\u308C\u308B\u305F\u3081\u3001\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u63A5\u7D9A\u306A\u3057\u3067\u3082\u30C7\u30D0\u30A4\u30B9\u304B\u3089\u5B9F\u884C\u3067\u304D\u307E\u3059\u3002"},"highlightText":{"title":"\u66F8\u304D\u63DB\u3048\u308B\u30C6\u30AD\u30B9\u30C8\u3092\u5F37\u8ABF\u8868\u793A\u3059\u308B","description":"\u66F8\u304D\u63DB\u3048\u305F\u3044\u30B3\u30FC\u30C9\u3092\u5F37\u8ABF\u8868\u793A\u3057\u307E\u3059\u3002"},"enterInstructions":{"title":"\u66F8\u304D\u63DB\u3048\u6307\u793A\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","description":"\u30B3\u30FC\u30C7\u30A3\u30F3\u30B0\u306E\u66F8\u304D\u63DB\u3048\u6307\u793A\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30D7\u30ED\u30B0\u30E9\u30DF\u30F3\u30B0\u8A00\u8A9E\u3001\u30B9\u30BF\u30A4\u30EB\u3001\u307E\u305F\u306F\u5FC5\u8981\u306A\u5909\u66F4\u70B9\u306A\u3069\u3092\u6307\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"complete":{"description":"\u3053\u308C\u3067\u5B8C\u4E86\u3067\u3059\uFF01\u3053\u308C\u3067\u3001\u30B3\u30FC\u30C9\u4E0A\u3067\u97F3\u58F0\u5165\u529B\u3001\u4E00\u6642\u505C\u6B62\u3001\u518D\u958B\u3001\u53CD\u5FA9\u51E6\u7406\u304C\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002\u97F3\u58F0\u5165\u529B\u3084\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\u3001\u305D\u306E\u4ED6\u306E\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u6700\u9069\u5316\u6A5F\u80FD\u3092\u4F7F\u3063\u3066\u3001\u3055\u3089\u306B\u591A\u304F\u306E\u30E6\u30FC\u30B9\u30B1\u30FC\u30B9\u3092\u63A2\u7D22\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002"}},"documentCode":{"tourLabel":"\u30C7\u30D0\u30A4\u30B9\u4E0A\u306E AI \u30C6\u30AD\u30B9\u30C8\u751F\u6210\u306B\u3088\u308B\u9AD8\u901F\u3067\u5B89\u5168\u306A\u30B3\u30FC\u30C9\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8","learn":"\u540C\u3058\u30A2\u30D7\u30EA\u5185\u3067\u30C7\u30FC\u30BF\u306E\u5B89\u5168\u6027\u3092\u4FDD\u3061\u306A\u304C\u3089\u3001AI \u3092\u6D3B\u7528\u3057\u305F\u66F8\u304D\u63DB\u3048\u3092\u4F7F\u7528\u3057\u3066\u30B3\u30FC\u30C9\u3092\u6587\u66F8\u5316\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","rewriteIntro":{"title":"\u30B3\u30FC\u30C9\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306E\u4F5C\u6210","description":"Cephable Intelligent Rewrite \u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u5225\u306E\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u307E\u305F\u306F\u30A2\u30D7\u30EA\u306B\u30B3\u30FC\u30C9\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002Rewrite \u306F\u3001\u30AA\u30D5\u30E9\u30A4\u30F3\u751F\u6210\u3068\u7FFB\u8A33\u3092\u542B\u3080\u30C7\u30D0\u30A4\u30B9\u5185 AI \u30BF\u30B9\u30AF\u306E\u4E00\u90E8\u3067\u3059\u3002"},"focusApp":{"title":"\u30B3\u30FC\u30C9\u306B\u96C6\u4E2D\u3059\u308B","description":"IDE \u3092\u958B\u304D\u3001\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u5316\u3059\u308B\u30B3\u30FC\u30C9\u306B\u7126\u70B9\u3092\u5F53\u3066\u307E\u3059\u3002"},"newFile":{"title":"\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u30D5\u30A1\u30A4\u30EB\u3092\u4F5C\u6210\u3059\u308B","description":"IDE \u3067\u65B0\u3057\u3044\u30D5\u30A1\u30A4\u30EB\u3092\u4F5C\u6210\u3059\u308B\u304B\u3001\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u8868\u793A\u3059\u308B\u5225\u306E\u30A2\u30D7\u30EA\u3092\u958B\u304D\u307E\u3059\u3002"},"highlightText":{"title":"\u30CF\u30A4\u30E9\u30A4\u30C8\u30B3\u30FC\u30C9","description":"\u6587\u66F8\u5316\u3059\u308B\u30B3\u30FC\u30C9\u3092\u5F37\u8ABF\u8868\u793A\u3057\u3066\u30B3\u30D4\u30FC\u3057\u307E\u3059\u3002"},"pasteMode":{"title":"\u30C6\u30AD\u30B9\u30C8\u8CBC\u308A\u4ED8\u3051\u30BF\u30D6\u3092\u30AF\u30EA\u30C3\u30AF","description":"\u8CBC\u308A\u4ED8\u3051\u30E2\u30FC\u30C9\u3092\u4F7F\u7528\u3057\u3066\u5143\u306E\u30B3\u30FC\u30C9\u3092\u8CBC\u308A\u4ED8\u3051\u3001\u65B0\u3057\u3044\u30D5\u30A1\u30A4\u30EB\u306B\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u66F8\u304D\u8FBC\u307F\u307E\u3059\u3002"},"pasteInput":{"title":"\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306B\u30B3\u30FC\u30C9\u3092\u8CBC\u308A\u4ED8\u3051\u308B","description":"\u6587\u66F8\u5316\u3059\u308B\u30B3\u30FC\u30C9\u3092\u5165\u529B\u30DC\u30C3\u30AF\u30B9\u306B\u8CBC\u308A\u4ED8\u3051\u307E\u3059\u3002"},"enterInstructions":{"title":"\u66F8\u5F0F\u3001\u30B9\u30BF\u30A4\u30EB\u3001\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u6307\u793A\u3092\u5165\u529B\u3057\u307E\u3059","description":"\u30B3\u30FC\u30C7\u30A3\u30F3\u30B0\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306E\u6307\u793A\u3092\u5165\u529B\u3057\u307E\u3059\u3002\u30D5\u30A1\u30A4\u30EB\u306E\u7A2E\u985E\uFF08\u30DE\u30FC\u30AF\u30C0\u30A6\u30F3\u306A\u3069\uFF09\u3001\u30B9\u30BF\u30A4\u30EB\u3001\u307E\u305F\u306F\u5FC5\u8981\u306A\u7279\u5B9A\u306E\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u6307\u5B9A\u3057\u307E\u3059\u3002"},"complete":{"description":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\u3092\u4F7F\u3063\u3066\u8FC5\u901F\u304B\u3064\u5B89\u5168\u306B\u30B3\u30FC\u30C9\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u7FD2\u3057\u307E\u3057\u305F\u3002Rewrite\u3084\u305D\u306E\u4ED6\u306E\u6A5F\u80FD\u3092\u4F7F\u3063\u3066\u3001\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u6700\u9069\u5316\u3059\u308B\u30E6\u30FC\u30B9\u30B1\u30FC\u30B9\u3092\u3055\u3089\u306B\u63A2\u3063\u3066\u307F\u307E\u3057\u3087\u3046\u3002"}},"generateCode":{"tourLabel":"\u30C7\u30D0\u30A4\u30B9\u4E0A\u306E AI \u30C6\u30AD\u30B9\u30C8\u751F\u6210\u306B\u3088\u308B\u9AD8\u901F\u3067\u5B89\u5168\u306A\u30B3\u30FC\u30C9\u751F\u6210","learn":"AI \u3092\u6D3B\u7528\u3057\u305F\u751F\u6210\u3092\u4F7F\u7528\u3057\u3066\u3001\u30A2\u30D7\u30EA\u9593\u3092\u79FB\u52D5\u3057\u306A\u304C\u3089\u30C7\u30FC\u30BF\u3092\u5B89\u5168\u306B\u4FDD\u3061\u306A\u304C\u3089\u30B3\u30FC\u30C9 \u30B9\u30CB\u30DA\u30C3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","rewriteIntro":{"title":"\u30B3\u30FC\u30C9\u30B9\u30CB\u30DA\u30C3\u30C8\u3092\u66F8\u304F","description":"Cephable Intelligent Rewrite \u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u5225\u306E\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u304B\u3089\u8981\u4EF6\u3092\u53D6\u5F97\u3057\u306A\u304C\u3089\u3001IDE \u3067\u30B3\u30FC\u30C9\u30B9\u30CB\u30DA\u30C3\u30C8\u3092\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002Rewrite \u306F\u3001\u30AA\u30D5\u30E9\u30A4\u30F3\u751F\u6210\u3084\u7FFB\u8A33\u3092\u542B\u3080\u30AA\u30F3\u30C7\u30D0\u30A4\u30B9 AI \u30BF\u30B9\u30AF\u306E\u4E00\u90E8\u3067\u3059\u3002"},"focusApp":{"title":"\u30C1\u30B1\u30C3\u30C8\u306E\u5185\u5BB9\u306B\u6CE8\u76EE","description":"\u8981\u4EF6\u3092\u6307\u5B9A\u3059\u308B\u30C1\u30B1\u30C3\u30C8\u3092\u958B\u304D\u3001\u30B3\u30FC\u30C9\u3092\u751F\u6210\u3059\u308B\u30B3\u30F3\u30C6\u30F3\u30C4\u306B\u7126\u70B9\u3092\u5F53\u3066\u307E\u3059\u3002"},"newFile":{"title":"\u30B3\u30FC\u30C9\u30B9\u30CB\u30DA\u30C3\u30C8\u30D5\u30A1\u30A4\u30EB\u3092\u4F5C\u6210\u3059\u308B","description":"IDE \u3067\u65B0\u3057\u3044\u30D5\u30A1\u30A4\u30EB\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002"},"highlightText":{"title":"\u30CF\u30A4\u30E9\u30A4\u30C8\u30C1\u30B1\u30C3\u30C8\u306E\u5185\u5BB9","description":"\u30B3\u30FC\u30C9\u3092\u751F\u6210\u3059\u308B\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u5F37\u8ABF\u8868\u793A\u3057\u3066\u30B3\u30D4\u30FC\u3057\u307E\u3059\u3002"},"pasteMode":{"title":"\u30C6\u30AD\u30B9\u30C8\u8CBC\u308A\u4ED8\u3051\u30BF\u30D6\u3092\u30AF\u30EA\u30C3\u30AF","description":"\u8CBC\u308A\u4ED8\u3051\u30E2\u30FC\u30C9\u3092\u4F7F\u7528\u3057\u3066\u3001\u5143\u306E\u30C1\u30B1\u30C3\u30C8\u8981\u4EF6\u3092\u8CBC\u308A\u4ED8\u3051\u3001\u30B3\u30FC\u30C9 \u30B9\u30CB\u30DA\u30C3\u30C8\u3092\u8A18\u8FF0\u3057\u307E\u3059\u3002"},"pasteInput":{"title":"\u8981\u4EF6\u3092\u8CBC\u308A\u4ED8\u3051\u3066\u30B3\u30FC\u30C9\u3092\u751F\u6210\u3059\u308B","description":"\u30B3\u30FC\u30C9\u751F\u6210\u306B\u4F7F\u7528\u3059\u308B\u8981\u4EF6\u3092\u5165\u529B\u30DC\u30C3\u30AF\u30B9\u306B\u8CBC\u308A\u4ED8\u3051\u307E\u3059\u3002"},"enterInstructions":{"title":"\u30D7\u30ED\u30B0\u30E9\u30DF\u30F3\u30B0\u8A00\u8A9E\u3068\u30B9\u30BF\u30A4\u30EB\u306E\u6307\u793A\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","description":"\u30D7\u30ED\u30B0\u30E9\u30DF\u30F3\u30B0\u8A00\u8A9E\u3068\u30B9\u30BF\u30A4\u30EB\u306E\u6307\u793A\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30D7\u30ED\u30B0\u30E9\u30DF\u30F3\u30B0\u8A00\u8A9E\uFF08\u4F8B\uFF1AC#\uFF09\u3001\u30B9\u30BF\u30A4\u30EB\u3001\u307E\u305F\u306F\u5177\u4F53\u7684\u306A\u30B3\u30FC\u30C7\u30A3\u30F3\u30B0\u6307\u793A\u3092\u6307\u5B9A\u3057\u307E\u3059\u3002"},"translateIntro":{"title":"\u30B3\u30FC\u30C9\u30B9\u30CB\u30DA\u30C3\u30C8\u3092\u7FFB\u8A33\u3059\u308B","description":"Cephable Intelligent Translate \u3092\u4F7F\u7528\u3059\u308B\u3068\u3001IDE \u5185\u3067\u30B3\u30FC\u30C9\u30B9\u30CB\u30DA\u30C3\u30C8\u3092\u3042\u308B\u30D7\u30ED\u30B0\u30E9\u30DF\u30F3\u30B0\u8A00\u8A9E\u304B\u3089\u5225\u306E\u30D7\u30ED\u30B0\u30E9\u30DF\u30F3\u30B0\u8A00\u8A9E\u3078\u76F4\u63A5\u5909\u63DB\u3067\u304D\u307E\u3059\u3002Translate \u306F\u3001\u30AA\u30D5\u30E9\u30A4\u30F3\u751F\u6210\u3068\u66F8\u304D\u63DB\u3048\u3092\u542B\u3080\u30AA\u30F3\u30C7\u30D0\u30A4\u30B9 AI \u30BF\u30B9\u30AF\u306E\u4E00\u90E8\u3067\u3059\u3002"},"copyGeneratedCode":{"title":"\u751F\u6210\u3055\u308C\u305F\u30B3\u30FC\u30C9\u3092\u30B3\u30D4\u30FC\u3059\u308B","description":"\u524D\u306E\u624B\u9806\u3092\u4F7F\u7528\u3057\u3066\u30B3\u30FC\u30C9\u3092\u751F\u6210\u3057\u305F\u5F8C\u3001\u751F\u6210\u3055\u308C\u305F\u30B3\u30FC\u30C9 \u30B9\u30CB\u30DA\u30C3\u30C8\u3092\u5F37\u8ABF\u8868\u793A\u3057\u3066\u30B3\u30D4\u30FC\u3057\u307E\u3059\u3002"},"translatePasteMode":{"title":"\u30C6\u30AD\u30B9\u30C8\u8CBC\u308A\u4ED8\u3051\u30BF\u30D6\u3092\u30AF\u30EA\u30C3\u30AF","description":"\u8CBC\u308A\u4ED8\u3051\u30E2\u30FC\u30C9\u3092\u4F7F\u7528\u3057\u3066\u5143\u306E\u30B3\u30FC\u30C9\u3092\u8CBC\u308A\u4ED8\u3051\u3001\u5225\u306E\u30D7\u30ED\u30B0\u30E9\u30DF\u30F3\u30B0\u8A00\u8A9E\u306B\u5909\u63DB\u3057\u307E\u3059\u3002"},"enterProgrammingLanguage":{"title":"\u30BF\u30FC\u30B2\u30C3\u30C8\u30D7\u30ED\u30B0\u30E9\u30DF\u30F3\u30B0\u8A00\u8A9E\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","description":"\u30B3\u30FC\u30C9\u3092\u5909\u63DB\u3059\u308B\u30D7\u30ED\u30B0\u30E9\u30DF\u30F3\u30B0\u8A00\u8A9E (\u4F8B: Python) \u3092\u5165\u529B\u3057\u307E\u3059\u3002"},"pasteCode":{"title":"\u751F\u6210\u3055\u308C\u305F\u30B3\u30FC\u30C9\u3092IDE\u306B\u8CBC\u308A\u4ED8\u3051\u307E\u3059","description":"IDE \u306B\u79FB\u52D5\u3057\u3001\u30B3\u30D4\u30FC\u3057\u305F\u30B3\u30FC\u30C9 \u30B9\u30CB\u30DA\u30C3\u30C8\u3092\u5148\u307B\u3069\u4F5C\u6210\u3057\u305F\u65B0\u3057\u3044\u30D5\u30A1\u30A4\u30EB\u306B\u8CBC\u308A\u4ED8\u3051\u307E\u3059\u3002"},"complete":{"description":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\u3092\u4F7F\u3063\u3066\u3001\u8FC5\u901F\u304B\u3064\u5B89\u5168\u306B\u30B3\u30FC\u30C9\u751F\u6210\u3068\u7FFB\u8A33\u3092\u884C\u3046\u65B9\u6CD5\u3092\u5B66\u7FD2\u3057\u307E\u3057\u305F\u3002\u751F\u6210\u3068\u7FFB\u8A33\u3084\u305D\u306E\u4ED6\u306E\u6A5F\u80FD\u3092\u4F7F\u3063\u3066\u3001\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u6700\u9069\u5316\u3059\u308B\u30E6\u30FC\u30B9\u30B1\u30FC\u30B9\u3092\u3055\u3089\u306B\u63A2\u3063\u3066\u307F\u307E\u3057\u3087\u3046\u3002"}},"requirementDocsFromMeeting":{"tourLabel":"\u6570\u5206\u3067\u30E1\u30E2\u304B\u3089\u88FD\u54C1\u8981\u4EF6\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u4F5C\u6210","learn":"AI \u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8 \u30BF\u30B9\u30AF\u3092\u4F7F\u7528\u3057\u3066\u3001\u30C7\u30FC\u30BF\u3092\u5B89\u5168\u306B\u4FDD\u3061\u306A\u304C\u3089\u4F1A\u8B70\u30E1\u30E2\u304B\u3089\u69CB\u9020\u5316\u3055\u308C\u305F\u88FD\u54C1\u8981\u4EF6\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","rewriteIntro":{"title":"\u88FD\u54C1\u8981\u4EF6\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306E\u4F5C\u6210","description":"Cephable Intelligent Rewrite \u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u4F1A\u8B70\u30E1\u30E2\u304B\u3089\u69CB\u9020\u5316\u3055\u308C\u305F\u88FD\u54C1\u8981\u4EF6\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002Rewrite \u306F\u3001\u30AA\u30D5\u30E9\u30A4\u30F3\u751F\u6210\u3068\u7FFB\u8A33\u3092\u542B\u3080\u30AA\u30F3\u30C7\u30D0\u30A4\u30B9 AI \u30BF\u30B9\u30AF\u306E\u4E00\u90E8\u3067\u3059\u3002"},"focusNotes":{"title":"\u4F1A\u8B70\u30E1\u30E2\u3092\u958B\u304F","description":"\u4F1A\u8B70\u306E\u30E1\u30E2\u3001\u8B70\u4E8B\u9332\u3001\u307E\u305F\u306F\u305D\u306E\u4ED6\u306E\u4F1A\u8B70\u95A2\u9023\u306E\u30C6\u30AD\u30B9\u30C8 \u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u958B\u304D\u307E\u3059\u3002"},"highlight":{"title":"\u4F1A\u8B70\u30E1\u30E2\u306E\u30CF\u30A4\u30E9\u30A4\u30C8","description":"\u88FD\u54C1\u8981\u4EF6\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306E\u4F5C\u6210\u306B\u4F7F\u7528\u3059\u308B\u4F1A\u8B70\u30E1\u30E2\u3092\u5F37\u8ABF\u8868\u793A\u3057\u307E\u3059\u3002"},"enterInstructions":{"title":"\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u69CB\u9020\u3068\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u6307\u793A\u3092\u5165\u529B\u3059\u308B","description":"\u88FD\u54C1\u8981\u4EF6\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306E\u6307\u793A\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u69CB\u9020\u3001\u30B9\u30BF\u30A4\u30EB\u3001\u307E\u305F\u306F\u5FC5\u8981\u306A\u7279\u5B9A\u306E\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u6307\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"complete":{"description":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\u3092\u4F7F\u7528\u3057\u3066\u3001\u8FC5\u901F\u304B\u3064\u5B89\u5168\u306B\u88FD\u54C1\u8981\u4EF6\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u7FD2\u3057\u307E\u3057\u305F\u3002Rewrite\u3084\u305D\u306E\u4ED6\u306E\u6A5F\u80FD\u3092\u4F7F\u3063\u3066\u3001\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u6700\u9069\u5316\u3059\u308B\u30E6\u30FC\u30B9\u30B1\u30FC\u30B9\u3092\u3055\u3089\u306B\u63A2\u3063\u3066\u307F\u307E\u3057\u3087\u3046\u3002"}},"headMouseMovement":{"tourLabel":"\u30D8\u30C3\u30C9\u30DE\u30A6\u30B9\u3092\u4F7F\u3063\u305F\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u30B2\u30FC\u30DF\u30F3\u30B0\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7","learn":"\u982D\u306E\u52D5\u304D\u3092\u4F7F\u3063\u3066\u30DE\u30A6\u30B9 \u30AB\u30FC\u30BD\u30EB\u3092\u5236\u5FA1\u3057\u3001\u6B63\u78BA\u306A\u30CA\u30D3\u30B2\u30FC\u30B7\u30E7\u30F3\u3068\u30AF\u30EA\u30C3\u30AF\u3092\u884C\u3046\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","deviceSettings":{"title":"\u30C7\u30D0\u30A4\u30B9\u8A2D\u5B9A\u3092\u958B\u304F","description":"\u30D8\u30C3\u30C9\u30DE\u30A6\u30B9\u306E\u52D5\u304D\u3092\u6709\u52B9\u306B\u3059\u308B\u306B\u306F\u3001[\u30C7\u30D0\u30A4\u30B9\u8A2D\u5B9A] \u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002"},"cameraSettings":{"title":"\u30AB\u30E1\u30E9\u8A2D\u5B9A\u3092\u958B\u304F","description":"\u30C7\u30D0\u30A4\u30B9\u8A2D\u5B9A\u3067\u3001\u30AB\u30E1\u30E9\u8A2D\u5B9A\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u30A2\u30AF\u30BB\u30B9\u3057\u307E\u3059\u3002"},"headMouseSection":{"title":"\u30DE\u30A6\u30B9\u64CD\u4F5C\u306E\u305F\u3081\u306E\u982D\u306E\u52D5\u304D","description":"\u3053\u308C\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u30C8\u30EA\u30AC\u30FC \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u4EE3\u308F\u308A\u306B\u3001\u30D8\u30C3\u30C9 \u30E0\u30FC\u30D6\u30E1\u30F3\u30C8 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u4E00\u90E8\u304C\u30DE\u30A6\u30B9\u306E\u79FB\u52D5\u306B\u4F7F\u7528\u3055\u308C\u307E\u3059\u3002"},"steadyGlide":{"title":"\u5B89\u5B9A\u3057\u305F\u6ED1\u7A7A\u30E2\u30FC\u30C9","description":"\u30B9\u30C6\u30C7\u30A3\u30B0\u30E9\u30A4\u30C9\u30E2\u30FC\u30C9\u3092\u30AA\u30F3\u306B\u3057\u307E\u3059\u3002\u982D\u3092\u7279\u5B9A\u306E\u30DD\u30A4\u30F3\u30C8\u3092\u8D85\u3048\u3066\u52D5\u304B\u3059\u3068\u3001\u30AB\u30FC\u30BD\u30EB\u304C\u305D\u306E\u65B9\u5411\u306B\u4E00\u5B9A\u306E\u901F\u5EA6\u3067\u9023\u7D9A\u7684\u306B\u79FB\u52D5\u3057\u307E\u3059\u3002"},"customization":{"title":"\u30D8\u30C3\u30C9\u30DE\u30A6\u30B9\u8A2D\u5B9A\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3059\u308B","description":"\u30D8\u30C3\u30C9\u30DE\u30A6\u30B9\u306E\u8A2D\u5B9A\u3092\u597D\u307F\u306B\u5408\u308F\u305B\u3066\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3067\u304D\u307E\u3059\u3002\u901F\u5EA6\u3001\u611F\u5EA6\u3001\u305D\u306E\u4ED6\u306E\u8A2D\u5B9A\u3092\u8ABF\u6574\u3057\u3066\u3001\u6700\u9069\u306A\u64CD\u4F5C\u6027\u3092\u5B9F\u73FE\u3057\u307E\u3057\u3087\u3046\u3002"},"save":{"title":"\u30D8\u30C3\u30C9\u30DE\u30A6\u30B9\u8A2D\u5B9A\u3092\u4FDD\u5B58","description":"\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u305F\u30D8\u30C3\u30C9\u30DE\u30A6\u30B9\u306E\u8A2D\u5B9A\u3092\u5FD8\u308C\u305A\u306B\u4FDD\u5B58\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"transition":{"title":"\u30BB\u30D5\u30A1\u30D6\u30EB\u30D1\u30CD\u30EB\u3078\u306E\u79FB\u884C","description":"\u305D\u308C\u3067\u306F\u3001Cephable \u30D1\u30CD\u30EB\u306B\u79FB\u52D5\u3057\u3066\u3001\u30DE\u30A6\u30B9\u306E\u982D\u306E\u52D5\u304D\u3092\u8A66\u3057\u3066\u307F\u307E\u3057\u3087\u3046\u3002"},"playGames":{"title":"\u30D8\u30C3\u30C9\u30DE\u30A6\u30B9\u3067\u30B2\u30FC\u30E0\u3092\u30D7\u30EC\u30A4","description":"\u30B2\u30FC\u30E0\u4E2D\u306B\u982D\u306E\u52D5\u304D\u3067\u30DE\u30A6\u30B9\u30AB\u30FC\u30BD\u30EB\u3092\u64CD\u4F5C\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002\u305C\u3072\u8A66\u3057\u3066\u307F\u3066\u3001\u305D\u306E\u52B9\u679C\u3092\u5B9F\u611F\u3057\u3066\u304F\u3060\u3055\u3044\uFF01"}},"clinicalNoteTaking":{"tourLabel":"\u81E8\u5E8A\u533B\u306E\u305F\u3081\u306EHIPAA\u6E96\u62E0\u306E\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3068\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8","learn":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3001\u30B9\u30DE\u30FC\u30C8\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3001AI \u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3092\u4F7F\u7528\u3057\u3066\u81E8\u5E8A\u30E1\u30E2\u3092\u53D6\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","speaking":{"title":"\u8A71\u3057\u59CB\u3081\u308B","description":"\u3055\u3042\u3001\u8A71\u3057\u59CB\u3081\u307E\u3057\u3087\u3046\u3002\u8A71\u3057\u305F\u5185\u5BB9\u306F\u3059\u3079\u3066\u3001\u30D5\u30A9\u30FC\u30AB\u30B9\u3057\u305F\u30C6\u30AD\u30B9\u30C8\u30D5\u30A3\u30FC\u30EB\u30C9\u307E\u305F\u306F\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306B\u5165\u529B\u3055\u308C\u307E\u3059\u3002\u300C\u60A3\u8005\u69D8\u306F45\u6B73\u306E\u7537\u6027\u3067\u3001\u9AD8\u8840\u5727\u306E\u65E2\u5F80\u6B74\u304C\u3042\u308A\u307E\u3059\u3002\u524D\u56DE\u51E6\u65B9\u3055\u308C\u305F\u85AC\u304C\u671F\u5F85\u901A\u308A\u306E\u52B9\u679C\u3092\u793A\u3055\u305A\u3001\u30A2\u30EC\u30EB\u30AE\u30FC\u53CD\u5FDC\u3092\u8D77\u3053\u3057\u307E\u3057\u305F\u3002\u4EE3\u66FF\u85AC\u3092\u691C\u8A0E\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u304C\u3001\u30B8\u30A7\u30CD\u30EA\u30C3\u30AF\u533B\u85AC\u54C1\u306E\u51E6\u65B9\u7B8B\u3092\u5E0C\u671B\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u300D\u306E\u3088\u3046\u306B\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002"},"rewriteIntro":{"title":"\u30E1\u30E2\u306E\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8","description":"Cephable Intelligent Rewrite \u3092\u4F7F\u3048\u3070\u3001\u30E1\u30E2\u3092SOAP\u5F62\u5F0F\u3067\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3067\u304D\u307E\u3059\u3002\u3059\u3079\u3066\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u5B9F\u884C\u3055\u308C\u308B\u305F\u3081\u3001\u30C7\u30FC\u30BF\u306E\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3068\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u306F\u7DAD\u6301\u3055\u308C\u3001HIPAA\u306B\u6E96\u62E0\u3057\u307E\u3059\u3002"},"copyText":{"title":"\u30E1\u30E2\u3092\u30B3\u30D4\u30FC\u3059\u308B","description":"\u30E1\u30E2\u3092\u30CF\u30A4\u30E9\u30A4\u30C8\u3057\u305F\u5F8C\u3001\u30C6\u30AD\u30B9\u30C8\u3092\u30B3\u30D4\u30FC\u3057\u3066\u66F8\u5F0F\u8A2D\u5B9A\u306E\u6E96\u5099\u3092\u3057\u307E\u3059\u3002"},"pasteMode":{"title":"\u30C6\u30AD\u30B9\u30C8\u8CBC\u308A\u4ED8\u3051\u30BF\u30D6\u3092\u30AF\u30EA\u30C3\u30AF","description":"\u8CBC\u308A\u4ED8\u3051\u30E2\u30FC\u30C9\u3092\u4F7F\u7528\u3057\u3066\u5143\u306E\u30E1\u30E2\u3092\u8CBC\u308A\u4ED8\u3051\u3001SOAP \u30B9\u30BF\u30A4\u30EB\u3067\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3057\u307E\u3059\u3002"},"pasteInput":{"title":"\u30E1\u30E2\u3092\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u306B\u8CBC\u308A\u4ED8\u3051\u308B","description":"\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3057\u305F\u3044\u30E1\u30E2\u3092\u5165\u529B\u30DC\u30C3\u30AF\u30B9\u306B\u8CBC\u308A\u4ED8\u3051\u307E\u3059\u3002"},"enterInstructions":{"title":"\u66F8\u5F0F\u8A2D\u5B9A\u306E\u6307\u793A\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","description":"\u30AF\u30EA\u30CB\u30C3\u30AF/EHR\u30B7\u30B9\u30C6\u30E0\u3067\u9075\u5B88\u3059\u308B\u5FC5\u8981\u304C\u3042\u308B\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u6307\u793A\u3092\u8A18\u8FF0\u3067\u304D\u307E\u3059\u3002\uFF08\u4F8B\uFF1A\u898B\u51FA\u3057\u3001\u7B87\u6761\u66F8\u304D\u3001\u7C21\u6F54\u306A\u8A00\u8449\u9063\u3044\u3092\u542B\u3080SOAP\u30B9\u30BF\u30A4\u30EB\u3067\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3059\u308B\uFF09"},"navigateToEHR":{"title":"EHR\u30B7\u30B9\u30C6\u30E0\u3078\u79FB\u52D5","description":"EHR \u30B7\u30B9\u30C6\u30E0\u3092\u958B\u304D\u3001\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3055\u308C\u305F\u30E1\u30E2\u3092\u5165\u529B\u3059\u308B\u30BB\u30AF\u30B7\u30E7\u30F3\u306B\u79FB\u52D5\u3057\u307E\u3059\u3002"},"focusTextField":{"title":"\u30C6\u30AD\u30B9\u30C8\u30D5\u30A3\u30FC\u30EB\u30C9\u306B\u30D5\u30A9\u30FC\u30AB\u30B9","description":"\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3055\u308C\u305F\u30E1\u30E2\u3092\u8CBC\u308A\u4ED8\u3051\u308B\u30C6\u30AD\u30B9\u30C8 \u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002"},"complete":{"description":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30B9\u30DE\u30FC\u30C8\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u4F7F\u3063\u3066\u81E8\u5E8A\u30CE\u30FC\u30C8\u3092\u4F5C\u6210\u3057\u3001\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30EA\u30E9\u30A4\u30C8\u3092\u4F7F\u3063\u3066SOAP\u30B9\u30BF\u30A4\u30EB\u3067\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3057\u305F\u3002\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3068\u30EA\u30E9\u30A4\u30C8\u3001\u3042\u308B\u3044\u306F\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u6700\u9069\u5316\u3059\u308B\u305D\u306E\u4ED6\u306E\u6A5F\u80FD\u3092\u4F7F\u3063\u305F\u30E6\u30FC\u30B9\u30B1\u30FC\u30B9\u3092\u3055\u3089\u306B\u63A2\u3063\u3066\u307F\u307E\u3057\u3087\u3046\u3002"},"focus":{"title":"\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306B\u7126\u70B9\u3092\u5F53\u3066\u308B","description":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u306F\u3001\u6587\u66F8\u306B\u96C6\u4E2D\u3057\u3066\u3044\u308B\u3068\u304D\u306B\u6700\u3082\u52B9\u679C\u7684\u306B\u6A5F\u80FD\u3057\u307E\u3059\u3002\u30BB\u30C3\u30B7\u30E7\u30F3\u306E\u5408\u9593\u306B\u81E8\u5E8A\u30E1\u30E2\u3092\u53D6\u308A\u305F\u3044\u6587\u66F8\u3092\u958B\u3044\u3066\u304F\u3060\u3055\u3044\u3002"}},"webBrowsing":{"tourLabel":"\u97F3\u58F0\u3092\u4F7F\u3063\u3066\u65C5\u884C\u3092\u8A08\u753B\u3057\u305F\u308A\u3001\u30AA\u30F3\u30E9\u30A4\u30F3\u30B7\u30E7\u30C3\u30D4\u30F3\u30B0\u3092\u3057\u305F\u308A\u3001Web\u3092\u95B2\u89A7\u3057\u305F\u308A\u3067\u304D\u307E\u3059","learn":"\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067 Web \u3092\u95B2\u89A7\u3057\u306A\u304C\u3089\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3057\u3066\u30CA\u30D3\u30B2\u30FC\u30C8\u3001\u30B9\u30AF\u30ED\u30FC\u30EB\u3001\u30D5\u30A9\u30FC\u30E0\u3078\u306E\u5165\u529B\u3092\u884C\u3046\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","tryOpen":{"title":"\u300CChrome \u3092\u958B\u304F\u300D\u307E\u305F\u306F\u300CEdge \u3092\u958B\u304F\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044","description":"\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3001\u300CChrome\u3092\u958B\u304F\u300D\u307E\u305F\u306F\u300CEdge\u3092\u958B\u304F\u300D\u3068\u767A\u58F0\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u9078\u629E\u3057\u305F\u30A6\u30A7\u30D6\u30D6\u30E9\u30A6\u30B6\u304C\u958B\u304D\u307E\u3059\u3002\u81EA\u52D5\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u5207\u308A\u66FF\u3048\u304C\u6709\u52B9\u306B\u306A\u3063\u3066\u3044\u308B\u5834\u5408\u306F\u3001\u4F7F\u7528\u4E2D\u306E\u30A2\u30D7\u30EA\u306B\u6700\u9069\u306A\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u5207\u308A\u66FF\u308F\u308A\u307E\u3059\u3002"},"search":{"title":"\u691C\u7D22\u4E2D","description":"\u300C\u691C\u7D22\u300D\u307E\u305F\u306F\u300C\u691C\u7D22\u300D\u3068\u767A\u58F0\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002\u30D6\u30E9\u30A6\u30B6\u306E\u691C\u7D22\u30D0\u30FC\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u304C\u5F53\u305F\u308A\u307E\u3059\u3002"},"quickType":{"title":"\u30AF\u30A4\u30C3\u30AF\u30BF\u30A4\u30D4\u30F3\u30B0","description":"\u30AF\u30A4\u30C3\u30AF\u5165\u529B\u3092\u4F7F\u3048\u3070\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u3092\u4F7F\u308F\u305A\u306B\u97F3\u58F0\u5165\u529B\u3067\u304D\u307E\u3059\u3002\u300C\u4ECA\u65E5\u306E\u5929\u6C17\u3092\u5165\u529B\u300D\u3068\u767A\u58F0\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002\u691C\u7D22\u30D0\u30FC\u306B\u691C\u7D22\u30AF\u30A8\u30EA\u304C\u5165\u529B\u3055\u308C\u307E\u3059\u3002"},"enter":{"title":"Enter\u30AD\u30FC\u3092\u62BC\u3057\u307E\u3059","description":"\u300CEnter\u300D\u3068\u767A\u58F0\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002\u5165\u529B\u3057\u305F\u691C\u7D22\u30AF\u30A8\u30EA\u304C\u5B9F\u884C\u3055\u308C\u307E\u3059\u3002"},"scrollDown":{"title":"\u4E0B\u306B\u30B9\u30AF\u30ED\u30FC\u30EB","description":"\u300C\u4E0B\u306B\u30B9\u30AF\u30ED\u30FC\u30EB\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002\u30A6\u30A7\u30D6\u30DA\u30FC\u30B8\u304C\u4E0B\u306B\u30B9\u30AF\u30ED\u30FC\u30EB\u3057\u307E\u3059\u3002"},"scrollUp":{"title":"\u4E0A\u3078\u30B9\u30AF\u30ED\u30FC\u30EB","description":"\u300C\u4E0A\u306B\u30B9\u30AF\u30ED\u30FC\u30EB\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002\u30A6\u30A7\u30D6\u30DA\u30FC\u30B8\u304C\u4E0A\u306B\u30B9\u30AF\u30ED\u30FC\u30EB\u3057\u307E\u3059\u3002"},"newTab":{"title":"\u65B0\u3057\u3044\u30BF\u30D6\u3092\u958B\u304F","description":"\u300C\u65B0\u3057\u3044\u30BF\u30D6\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002\u30D6\u30E9\u30A6\u30B6\u3067\u65B0\u3057\u3044\u30BF\u30D6\u304C\u958B\u304D\u307E\u3059\u3002"},"formsCustomization":{"title":"\u30D5\u30A9\u30FC\u30E0\u5165\u529B\u306E\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA","description":"\u3053\u306E\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u3066\u3001\u30D5\u30A9\u30FC\u30E0\u5165\u529B\u3092\u7C21\u5358\u306B\u884C\u3046\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u4F8B\u3048\u3070\u3001\u540D\u3001\u59D3\u3001\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306A\u3069\u3067\u3059\u3002\u305D\u306E\u5F8C\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3084\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u3063\u3066\u3001\u30D5\u30A9\u30FC\u30E0\u3078\u306E\u5165\u529B\u3092\u3055\u3089\u306B\u7D20\u65E9\u304F\u884C\u3046\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"},"complete":{"title":"\u7D20\u6674\u3089\u3057\u3044\u4ED5\u4E8B\u3067\u3059\uFF01","description":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u4F7F\u3063\u3066\u3001\u30A6\u30A7\u30D6\u95B2\u89A7\u4E2D\u306B\u30CA\u30D3\u30B2\u30FC\u30C8\u3001\u691C\u7D22\u3001\u30B9\u30AF\u30ED\u30FC\u30EB\u3001\u30D5\u30A9\u30FC\u30E0\u3078\u306E\u5165\u529B\u3092\u884C\u3046\u65B9\u6CD5\u3092\u7FD2\u5F97\u3057\u307E\u3057\u305F\u3002\u4ED6\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u8A66\u3057\u305F\u308A\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u3066\u3001\u3055\u3089\u306B\u30B9\u30E0\u30FC\u30BA\u306A\u30A6\u30A7\u30D6\u95B2\u89A7\u3092\u5B9F\u73FE\u3057\u307E\u3057\u3087\u3046\u3002"}},"spreadsheetReviews":{"tourLabel":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u30B9\u30D7\u30EC\u30C3\u30C9\u30B7\u30FC\u30C8\u306E\u4F5C\u696D\u3092\u9AD8\u901F\u5316","learn":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30AF\u30A4\u30C3\u30AF \u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3057\u3066\u3001\u5927\u304D\u306A\u30B9\u30D7\u30EC\u30C3\u30C9\u30B7\u30FC\u30C8\u3092\u3059\u3070\u3084\u304F\u78BA\u8A8D\u304A\u3088\u3073\u7DE8\u96C6\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","tryOpen":{"title":"\u300CExcel \u3092\u958B\u304F\u300D\u307E\u305F\u306F\u300CGoogle \u30B9\u30D7\u30EC\u30C3\u30C9\u30B7\u30FC\u30C8\u3092\u958B\u304F\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002","description":"\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3001\u300CExcel\u3092\u958B\u304F\u300D\u307E\u305F\u306F\u300CGoogle\u30B9\u30D7\u30EC\u30C3\u30C9\u30B7\u30FC\u30C8\u3092\u958B\u304F\u300D\u3068\u767A\u58F0\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u9078\u629E\u3057\u305F\u30B9\u30D7\u30EC\u30C3\u30C9\u30B7\u30FC\u30C8\u30A2\u30D7\u30EA\u304C\u958B\u304D\u307E\u3059\u3002\u81EA\u52D5\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u5207\u308A\u66FF\u3048\u304C\u6709\u52B9\u306B\u306A\u3063\u3066\u3044\u308B\u5834\u5408\u306F\u3001\u4F7F\u7528\u4E2D\u306E\u30A2\u30D7\u30EA\u306B\u6700\u9069\u306A\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u5207\u308A\u66FF\u308F\u308A\u307E\u3059\u3002"},"selectRow":{"title":"\u884C\u3092\u9078\u629E","description":"\u30BB\u30EB\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002\u6B21\u306B\u3001\u300C\u884C\u3092\u9078\u629E\u300D\u3068\u767A\u58F0\u3057\u3066\u307F\u307E\u3057\u3087\u3046\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u30D5\u30A9\u30FC\u30AB\u30B9\u3055\u308C\u305F\u30BB\u30EB\u306E\u884C\u5168\u4F53\u304C\u9078\u629E\u3055\u308C\u307E\u3059\u3002"},"delete":{"title":"\u884C\u306E\u5185\u5BB9\u3092\u524A\u9664\u3059\u308B","description":"\u300C\u524A\u9664\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002\u9078\u629E\u3057\u305F\u884C\u306E\u5185\u5BB9\u304C\u524A\u9664\u3055\u308C\u307E\u3059\u3002"},"note":{"title":"\u30BB\u30EB\u306B\u30E1\u30E2\u3092\u8FFD\u52A0\u3059\u308B","description":"\u30BB\u30EB\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002\u6B21\u306B\u3001\u300C\u30E1\u30E2\u3092\u8FFD\u52A0\u300D\u3068\u767A\u58F0\u3057\u3066\u307F\u307E\u3057\u3087\u3046\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u30D5\u30A9\u30FC\u30AB\u30B9\u3055\u308C\u305F\u30BB\u30EB\u306B\u30E1\u30E2\u3092\u8FFD\u52A0\u3067\u304D\u307E\u3059\u3002"},"addNote":{"title":"\u30E1\u30E2\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","description":"\u300C\u3053\u308C\u3089\u306E\u6570\u5B57\u306F\u4E00\u81F4\u3057\u307E\u305B\u3093\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002\u3059\u308B\u3068\u3001\u30BB\u30EB\u306B\u30E1\u30E2\u304C\u5165\u529B\u3055\u308C\u307E\u3059\u3002"},"currentDate":{"title":"\u73FE\u5728\u306E\u65E5\u4ED8\u3092\u5165\u529B","description":"\u30BB\u30EB\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002\u6B21\u306B\u300C\u73FE\u5728\u306E\u65E5\u4ED8\u300D\u3068\u767A\u58F0\u3057\u3066\u307F\u307E\u3057\u3087\u3046\u3002\u3059\u308B\u3068\u3001\u30D5\u30A9\u30FC\u30AB\u30B9\u3055\u308C\u305F\u30BB\u30EB\u306B\u73FE\u5728\u306E\u65E5\u4ED8\u304C\u5165\u529B\u3055\u308C\u307E\u3059\u3002"},"copy":{"title":"\u30BB\u30EB\u3092\u30B3\u30D4\u30FC\u3059\u308B","description":"\u5148\u307B\u3069\u73FE\u5728\u306E\u65E5\u4ED8\u3092\u8FFD\u52A0\u3057\u305F\u30BB\u30EB\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002\u6B21\u306B\u300C\u30B3\u30D4\u30FC\u300D\u3068\u767A\u58F0\u3057\u3066\u307F\u307E\u3057\u3087\u3046\u3002\u3053\u308C\u3067\u73FE\u5728\u306E\u65E5\u4ED8\u304C\u30B3\u30D4\u30FC\u3055\u308C\u307E\u3059\u3002"},"selectColumn":{"title":"\u5217\u3092\u9078\u629E","description":"\u300C\u5217\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002\u30D5\u30A9\u30FC\u30AB\u30B9\u3055\u308C\u305F\u30BB\u30EB\u306E\u5217\u5168\u4F53\u304C\u9078\u629E\u3055\u308C\u307E\u3059\u3002"},"paste":{"title":"\u73FE\u5728\u306E\u65E5\u4ED8\u3092\u8CBC\u308A\u4ED8\u3051","description":"\u300C\u8CBC\u308A\u4ED8\u3051\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002\u9078\u629E\u3057\u305F\u5217\u306B\u73FE\u5728\u306E\u65E5\u4ED8\u304C\u8CBC\u308A\u4ED8\u3051\u3089\u308C\u307E\u3059\u3002"},"quickActions":{"title":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3059\u308B","description":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u3092\u4F7F\u3048\u3070\u3001\u3053\u308C\u3089\u306E\u64CD\u4F5C\u306E\u591A\u304F\u306B\u52A0\u3048\u3001\u3055\u3089\u306B\u591A\u304F\u306E\u64CD\u4F5C\u3092\u5B9F\u884C\u3067\u304D\u307E\u3059\u3002\u3053\u308C\u3089\u306E\u30DC\u30BF\u30F3\u3092\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306B\u5408\u308F\u305B\u3066\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3059\u308B\u3053\u3068\u3067\u3001\u30B9\u30D7\u30EC\u30C3\u30C9\u30B7\u30FC\u30C8\u306E\u78BA\u8A8D\u3068\u7DE8\u96C6\u3092\u3055\u3089\u306B\u8FC5\u901F\u306B\u884C\u3046\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"},"complete":{"description":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u4F7F\u3063\u3066\u3001\u5927\u304D\u306A\u30B9\u30D7\u30EC\u30C3\u30C9\u30B7\u30FC\u30C8\u3092\u7D20\u65E9\u304F\u78BA\u8A8D\u30FB\u7DE8\u96C6\u3059\u308B\u65B9\u6CD5\u3092\u7FD2\u5F97\u3057\u307E\u3057\u305F\u3002\u4ED6\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u8A66\u3057\u305F\u308A\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u3066\u3001\u30B9\u30D7\u30EC\u30C3\u30C9\u30B7\u30FC\u30C8\u3092\u3088\u308A\u901F\u304F\u7BA1\u7406\u3057\u3066\u307F\u307E\u3057\u3087\u3046\u3002"}},"socialMediaWriting":{"tourLabel":"\u97F3\u58F0\u3068\u30C7\u30D0\u30A4\u30B9\u4E0A\u306E AI \u3092\u6D3B\u7528\u3057\u3066\u3001\u30BD\u30FC\u30B7\u30E3\u30EB \u30E1\u30C7\u30A3\u30A2 \u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F5C\u6210\u3001\u53CD\u5FA9\u3001\u6295\u7A3F\u3059\u308B","learn":"\u5B8C\u5168\u306B\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u3067\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u5B9F\u884C\u3055\u308C\u308B\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u751F\u6210\u3068\u66F8\u304D\u63DB\u3048\u6A5F\u80FD\u3092\u4F7F\u7528\u3057\u3066\u3001\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F5C\u6210\u3057\u3001\u53CD\u5FA9\u51E6\u7406\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","onDeviceIntro":{"title":"\u3042\u306A\u305F\u306E\u7814\u7A76\u306F\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3068\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u3092\u4FDD\u3061\u307E\u3059","description":"Cephable\u306E\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\u306F\u30C7\u30D0\u30A4\u30B9\u4E0A\u306EAI\u3092\u642D\u8F09\u3057\u3066\u3044\u308B\u305F\u3081\u3001\u30C7\u30FC\u30BF\u306E\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3068\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u306F\u78BA\u4FDD\u3055\u308C\u307E\u3059\u3002\u30AF\u30E9\u30A6\u30C9\u51E6\u7406\u3092\u5FC5\u8981\u3068\u305B\u305A\u3001\u30C6\u30AD\u30B9\u30C8\u306E\u4F5C\u6210\u3001\u66F8\u304D\u63DB\u3048\u3001\u7FFB\u8A33\u304C\u53EF\u80FD\u3067\u3059\u3002\u307E\u305F\u3001\u30AF\u30ED\u30B9\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3092\u6D3B\u7528\u3057\u3001\u304A\u6C17\u306B\u5165\u308A\u306E\u30A2\u30D7\u30EA\u5185\u3067\u76F4\u63A5\u30A2\u30A4\u30C7\u30A2\u3092\u53CD\u5FA9\u51E6\u7406\u3059\u308B\u3053\u3068\u3082\u53EF\u80FD\u3067\u3059\u3002"},"enterPrompt":{"title":"\u30A2\u30A4\u30C7\u30A2\u51FA\u3057\u3092\u59CB\u3081\u308B","description":"\u5165\u529B\u30DC\u30C3\u30AF\u30B9\u306B\u3001\u30B9\u30AD\u30E3\u30D5\u30A9\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u307E\u305F\u306F\u751F\u6210\u3057\u305F\u3044\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u5165\u529B\u3057\u307E\u3059\u3002\u4F8B\u3048\u3070\u3001\u300C\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u578BAI\u306E\u30EA\u30B9\u30AF\u3001\u30AE\u30E3\u30C3\u30D7\u3068\u306A\u308B\u70B9\u3001\u305D\u3057\u3066\u30A4\u30CE\u30D9\u30FC\u30B7\u30E7\u30F3\u3092\u524D\u9032\u3055\u305B\u308B\u65B9\u6CD5\u3092\u6319\u3052\u3066\u304F\u3060\u3055\u3044\u300D\u3068\u5165\u529B\u3067\u304D\u307E\u3059\u3002"},"customizeSettings":{"title":"\u751F\u6210\u8A2D\u5B9A\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3059\u308B","description":"\u597D\u307F\u306B\u5408\u308F\u305B\u3066\u751F\u6210\u8A2D\u5B9A\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3067\u304D\u307E\u3059\u3002\u30C8\u30FC\u30F3\u3084\u30D6\u30E9\u30F3\u30C9\u30DC\u30A4\u30B9\u306A\u3069\u3092\u53CD\u6620\u3057\u305F\u30B7\u30B9\u30C6\u30E0\u30D7\u30ED\u30F3\u30D7\u30C8\u3067\u8ABF\u6574\u3067\u304D\u307E\u3059\u3002"},"rewriteIntro":{"title":"\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u53CD\u5FA9","description":"Cephable Intelligent Rewrite \u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u304A\u6C17\u306B\u5165\u308A\u306E\u30A2\u30D7\u30EA\u5185\u3067\u76F4\u63A5\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u53CD\u5FA9\u51E6\u7406\u3067\u304D\u307E\u3059\u3002\u3059\u3079\u3066\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u5B9F\u884C\u3055\u308C\u308B\u305F\u3081\u3001\u30C7\u30FC\u30BF\u306E\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3068\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u306F\u78BA\u4FDD\u3055\u308C\u307E\u3059\u3002"},"highlightText":{"title":"\u66F8\u304D\u63DB\u3048\u308B\u30C6\u30AD\u30B9\u30C8\u3092\u5F37\u8ABF\u8868\u793A\u3059\u308B","description":"\u751F\u6210\u3055\u308C\u305F\u30B3\u30F3\u30C6\u30F3\u30C4\u304B\u3089\u3001\u3055\u3089\u306B\u53CD\u5FA9\u3059\u308B\u30EA\u30B9\u30C8\u3055\u308C\u305F\u30EA\u30B9\u30AF\u306E 1 \u3064\u3092\u5F37\u8ABF\u8868\u793A\u3057\u307E\u3059\u3002"},"enterInstructions":{"title":"\u66F8\u304D\u63DB\u3048\u6307\u793A\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","description":"\u66F8\u304D\u63DB\u3048\u306E\u6307\u793A\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u4F8B\u3048\u3070\u3001\u300C\u30EA\u30B9\u30AF\u306B\u95A2\u3059\u308B\u8A73\u7D30\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044\u300D\u3068\u5165\u529B\u3067\u304D\u307E\u3059\u3002"},"writeSocialMediaPost":{"title":"\u30BD\u30FC\u30B7\u30E3\u30EB\u30E1\u30C7\u30A3\u30A2\u306B\u6295\u7A3F\u3059\u308B","description":"\u518D\u5EA6\u66F8\u304D\u76F4\u3057\u3092\u4F7F\u7528\u3057\u3066\u3001\u3053\u306E\u8A00\u8A9E\u3092\u3001\u91CD\u8981\u306A\u30DD\u30A4\u30F3\u30C8\u3092\u53D6\u308A\u4E0A\u3052\u3001\u95A2\u4E0E\u306E\u9818\u57DF\u3092\u5F37\u8ABF\u3059\u308B\u3001\u4E00\u822C\u5411\u3051\u306E\u30BD\u30FC\u30B7\u30E3\u30EB \u30E1\u30C7\u30A3\u30A2\u6295\u7A3F\u306B\u518D\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3057\u307E\u3059\u3002"},"highlightPost":{"title":"\u751F\u6210\u3055\u308C\u305F\u6295\u7A3F\u3092\u30CF\u30A4\u30E9\u30A4\u30C8\u3059\u308B","description":"\u4F7F\u7528\u3057\u305F\u3044\u751F\u6210\u3055\u308C\u305F\u30BD\u30FC\u30B7\u30E3\u30EB \u30E1\u30C7\u30A3\u30A2\u306E\u6295\u7A3F\u3092\u5F37\u8ABF\u8868\u793A\u3057\u307E\u3059\u3002"},"enterPostInstructions":{"title":"\u6295\u7A3F\u624B\u9806\u3092\u5165\u529B","description":"\u6295\u7A3F\u306E\u6307\u793A\u3092\u5165\u529B\u3057\u307E\u3059\u3002\u4F8B\u3048\u3070\u3001\u300CLinkedIn\u5411\u3051\u306B\u7C21\u6F54\u3067\u9B45\u529B\u7684\u306A\u5185\u5BB9\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u300D\u306A\u3069\u3068\u5165\u529B\u3067\u304D\u307E\u3059\u3002"},"complete":{"description":"\u304A\u597D\u307F\u306E\u30BD\u30FC\u30B7\u30E3\u30EB\u30E1\u30C7\u30A3\u30A2\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u3092\u958B\u304D\u3001\u6295\u7A3F\u4F5C\u6210\u30C6\u30AD\u30B9\u30C8\u30DC\u30C3\u30AF\u30B9\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u3092\u5F53\u3066\u3066\u3001\u751F\u6210\u3055\u308C\u305F\u6295\u7A3F\u3092\u8CBC\u308A\u4ED8\u3051\u3066\u304F\u3060\u3055\u3044\u3002\u3042\u308B\u3044\u306F\u3001\u6E96\u5099\u304C\u6574\u3046\u307E\u3067\u7E70\u308A\u8FD4\u3057\u4FEE\u6B63\u3092\u7D9A\u3051\u3066\u304F\u3060\u3055\u3044\u3002"}},"inboxTriage":{"tourLabel":"\u97F3\u58F0\u3068\u30C7\u30D0\u30A4\u30B9\u4E0A\u306EAI\u306B\u3088\u308B\u52B9\u7387\u7684\u306A\u30E1\u30FC\u30EB\u7BA1\u7406","learn":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8 \u30BF\u30B9\u30AF\u3092\u4F7F\u7528\u3057\u3066\u3001\u30C7\u30FC\u30BF\u3092\u5B89\u5168\u306B\u4FDD\u3061\u306A\u304C\u3089\u53D7\u4FE1\u30C8\u30EC\u30A4\u3092\u52B9\u7387\u7684\u306B\u7BA1\u7406\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","tryOpen":{"title":"\u300COutlook \u3092\u958B\u304F\u300D\u307E\u305F\u306F\u300CGmail \u3092\u958B\u304F\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002","description":"\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3001\u300COutlook \u3092\u958B\u304F\u300D\u307E\u305F\u306F\u300CGmail \u3092\u958B\u304F\u300D\u3068\u767A\u58F0\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u9078\u629E\u3057\u305F\u30E1\u30FC\u30EB\u30A2\u30D7\u30EA\u304C\u958B\u304D\u307E\u3059\u3002\u81EA\u52D5\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u5207\u308A\u66FF\u3048\u304C\u6709\u52B9\u306B\u306A\u3063\u3066\u3044\u308B\u5834\u5408\u306F\u3001\u4F7F\u7528\u4E2D\u306E\u30A2\u30D7\u30EA\u306B\u6700\u9069\u306A\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u5207\u308A\u66FF\u308F\u308A\u307E\u3059\u3002"},"select":{"title":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u9078\u629E","description":"\u30E1\u30FC\u30EB\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002\u6B21\u306B\u3001\u300C\u30E1\u30FC\u30EB\u3092\u9078\u629E\u300D\u3068\u767A\u58F0\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002\u3053\u308C\u3067\u30D5\u30A9\u30FC\u30AB\u30B9\u3055\u308C\u305F\u30E1\u30FC\u30EB\u304C\u9078\u629E\u3055\u308C\u307E\u3059\u3002"},"delete":{"title":"\u30E1\u30FC\u30EB\u3092\u524A\u9664\u3059\u308B","description":"\u300C\u524A\u9664\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002\u9078\u629E\u3057\u305F\u30E1\u30FC\u30EB\u304C\u524A\u9664\u3055\u308C\u307E\u3059\u3002"},"reply":{"title":"\u30E1\u30FC\u30EB\u306B\u8FD4\u4FE1\u3059\u308B","description":"\u30E1\u30FC\u30EB\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002\u6B21\u306B\u3001\u300C\u8FD4\u4FE1\u300D\u3068\u767A\u58F0\u3057\u3066\u307F\u307E\u3057\u3087\u3046\u3002\u3059\u308B\u3068\u3001\u30D5\u30A9\u30FC\u30AB\u30B9\u3055\u308C\u3066\u3044\u308B\u30E1\u30FC\u30EB\u306E\u8FD4\u4FE1\u30A6\u30A3\u30F3\u30C9\u30A6\u304C\u958B\u304D\u307E\u3059\u3002"},"dictateIntro":{"title":"\u8FD4\u4FE1\u3092\u97F3\u58F0\u5165\u529B\u3059\u308B","description":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u4F7F\u3048\u3070\u3001\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u8FD4\u4FE1\u3092\u5165\u529B\u3067\u304D\u307E\u3059\u3002\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u3066\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u304C\u6709\u52B9\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"dictateReply":{"title":"\u8FD4\u4FE1\u3092\u958B\u59CB\u3059\u308B","description":"\u300C\u5FA1\u793E\u306E\u30B5\u30FC\u30D3\u30B9\u306B\u3064\u3044\u3066\u3082\u3063\u3068\u8A73\u3057\u304F\u77E5\u308A\u305F\u3044\u3068\u601D\u3063\u3066\u3044\u307E\u3059\u3002\u8FFD\u52A0\u60C5\u5831\u3092\u304A\u9001\u308A\u304F\u3060\u3055\u3044\u3002\u300D\u3068\u66F8\u3044\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002\u3053\u3046\u3059\u308B\u3068\u3001\u30E1\u30FC\u30EB\u306B\u8FD4\u4FE1\u5185\u5BB9\u304C\u5165\u529B\u3055\u308C\u307E\u3059\u3002\u8FD4\u4FE1\u30C6\u30AD\u30B9\u30C8\u30DC\u30C3\u30AF\u30B9\u306B\u96C6\u4E2D\u3059\u308B\u3088\u3046\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"newEmail":{"title":"\u65B0\u3057\u3044\u30E1\u30FC\u30EB\u3092\u4F5C\u6210\u3059\u308B","description":"\u300C\u65B0\u3057\u3044\u30E1\u30FC\u30EB\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002\u65B0\u3057\u3044\u30E1\u30FC\u30EB\u4F5C\u6210\u30A6\u30A3\u30F3\u30C9\u30A6\u304C\u958B\u304D\u307E\u3059\u3002"},"customEmailTemplates":{"title":"\u30AB\u30B9\u30BF\u30E0\u30E1\u30FC\u30EB\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8","description":"\u3088\u304F\u3042\u308B\u8FD4\u4FE1\u7528\u306E\u30AB\u30B9\u30BF\u30E0\u30E1\u30FC\u30EB\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3092\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3084\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u4F7F\u3063\u3066\u3001\u4E8B\u524D\u306B\u7528\u610F\u3057\u305F\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u30E1\u30FC\u30EB\u306B\u7C21\u5358\u306B\u633F\u5165\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002"},"editAppControls":{"title":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u7DE8\u96C6\u3059\u308B","description":"\u30AB\u30B9\u30BF\u30E0\u96FB\u5B50\u30E1\u30FC\u30EB \u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3092\u4F5C\u6210\u3059\u308B\u306B\u306F\u3001[\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u7DE8\u96C6] \u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002"},"addNewControl":{"title":"\u65B0\u3057\u3044\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8FFD\u52A0","description":"\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB \u30A8\u30C7\u30A3\u30BF\u30FC\u3067\u3001[\u65B0\u3057\u3044\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u8FFD\u52A0] \u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002"},"quickAction":{"title":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u9078\u629E","description":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB \u30BF\u30A4\u30D7\u3068\u3057\u3066\u30AF\u30A4\u30C3\u30AF \u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u9078\u629E\u3057\u307E\u3059\u3002"},"templateName":{"title":"\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u306B\u540D\u524D\u3092\u4ED8\u3051\u308B","description":"\u30AB\u30B9\u30BF\u30E0\u96FB\u5B50\u30E1\u30FC\u30EB \u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u306B\u300C\u4F1A\u8B70\u51FA\u5E2D\u4F9D\u983C\u300D\u306A\u3069\u306E\u540D\u524D\u3092\u4ED8\u3051\u307E\u3059\u3002"},"eventType":{"title":"\u30A4\u30D9\u30F3\u30C8\u306E\u7A2E\u985E\u3092\u9078\u629E","description":"\u30A4\u30D9\u30F3\u30C8 \u30BF\u30A4\u30D7 \u30BB\u30AF\u30B7\u30E7\u30F3\u3067\u3001\u300Ctype\u300D\u306E\u30A4\u30D9\u30F3\u30C8 \u30BF\u30A4\u30D7\u3092\u9078\u629E\u3057\u307E\u3059\u3002"},"typeSteps":{"title":"\u30BF\u30A4\u30D7\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u30B3\u30F3\u30C6\u30F3\u30C4","description":"\u30E1\u30FC\u30EB\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u306E\u5185\u5BB9\u3092\u5165\u529B\u3057\u307E\u3059\u3002\u4F8B\u3048\u3070\u3001\u300C\u30EA\u30FC\u30C9\u30A2\u30A6\u30C8\u30EA\u30FC\u30C1\\n\u3053\u3093\u306B\u3061\u306F\u3002\u4ECA\u5F8C\u306E\u30B3\u30E9\u30DC\u30EC\u30FC\u30B7\u30E7\u30F3\u306E\u53EF\u80FD\u6027\u306B\u3064\u3044\u3066\u8A71\u3057\u5408\u3046\u305F\u3081\u306B\u3001\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u3092\u4E88\u5B9A\u3057\u305F\u3044\u3068\u601D\u3063\u3066\u3044\u307E\u3059\u3002\u3054\u90FD\u5408\u306E\u826F\u3044\u65E5\u6642\u3092\u304A\u77E5\u3089\u305B\u304F\u3060\u3055\u3044\u3002\u300D\u306E\u3088\u3046\u306B\u5165\u529B\u3067\u304D\u307E\u3059\u3002"},"finish":{"title":"\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u306E\u4F5C\u6210\u3092\u5B8C\u4E86","description":"[\u5B8C\u4E86] \u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001\u30AB\u30B9\u30BF\u30E0\u96FB\u5B50\u30E1\u30FC\u30EB \u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u306E\u4F5C\u6210\u3092\u5B8C\u4E86\u3057\u307E\u3059\u3002"},"saveTemplate":{"title":"\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3092\u4FDD\u5B58\u3059\u308B","description":"\u300C\u4FDD\u5B58\u300D\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001\u30AB\u30B9\u30BF\u30E0\u96FB\u5B50\u30E1\u30FC\u30EB \u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3092\u4FDD\u5B58\u3057\u307E\u3059\u3002"},"focusApp":{"title":"\u30E1\u30FC\u30EB\u30A2\u30D7\u30EA\u306B\u518D\u3073\u7126\u70B9\u3092\u5F53\u3066\u308B","description":"\u30E1\u30FC\u30EB \u30A2\u30D7\u30EA\u306B\u623B\u308A\u3001\u65B0\u3057\u3044\u30E1\u30FC\u30EB\u306E\u4EF6\u540D\u306B\u6CE8\u76EE\u3057\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u307E\u3059\u3002"},"useTemplate":{"title":"\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3092\u4F7F\u7528\u3059\u308B","description":"\u3053\u308C\u3067\u3001\u30AB\u30B9\u30BF\u30E0 \u30E1\u30FC\u30EB \u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u306E\u540D\u524D\u3092\u8A00\u3046\u304B\u3001\u30AF\u30A4\u30C3\u30AF \u30A2\u30AF\u30B7\u30E7\u30F3 \u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3053\u3068\u3067\u3001\u30AB\u30B9\u30BF\u30E0 \u30E1\u30FC\u30EB \u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3092\u4F7F\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002"},"generateIntro":{"title":"\u30E1\u30FC\u30EB\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u751F\u6210\u3059\u308B","description":"Cephable Intelligent Generate\u3092\u4F7F\u3048\u3070\u3001\u30E1\u30FC\u30EB\u30A2\u30D7\u30EA\u5185\u3067\u76F4\u63A5\u30E1\u30FC\u30EB\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F5C\u6210\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002\u3059\u3079\u3066\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u884C\u308F\u308C\u308B\u305F\u3081\u3001\u30C7\u30FC\u30BF\u306E\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3068\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u306F\u78BA\u4FDD\u3055\u308C\u307E\u3059\u3002"},"enterPrompt":{"title":"\u30E1\u30FC\u30EB\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u5165\u529B","description":"\u30D7\u30ED\u30F3\u30D7\u30C8 \u30DC\u30C3\u30AF\u30B9\u306B\u6B21\u306E\u3088\u3046\u306B\u5165\u529B\u3057\u307E\u3059: \u6F5C\u5728\u7684\u306A\u9867\u5BA2\u306B\u5F53\u793E\u306E\u30B5\u30FC\u30D3\u30B9\u3092\u7D39\u4ECB\u3057\u3001\u4F1A\u8B70\u3092\u4F9D\u983C\u3059\u308B\u30D7\u30ED\u30D5\u30A7\u30C3\u30B7\u30E7\u30CA\u30EB\u306A\u30E1\u30FC\u30EB\u3092\u66F8\u304D\u307E\u3059\u3002"},"focusNewEmail":{"title":"\u65B0\u3057\u3044\u30E1\u30FC\u30EB\u306B\u6CE8\u76EE","description":"\u751F\u6210\u3055\u308C\u305F\u30C6\u30AD\u30B9\u30C8\u3092\u8868\u793A\u3059\u308B\u65B0\u3057\u3044\u96FB\u5B50\u30E1\u30FC\u30EB\u4F5C\u6210\u30A6\u30A3\u30F3\u30C9\u30A6\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u304C\u5F53\u3066\u3089\u308C\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u307E\u3059\u3002"},"translateEmail":{"title":"\u30E1\u30FC\u30EB\u306E\u5185\u5BB9\u3092\u7FFB\u8A33\u3059\u308B","description":"Cephable Intelligent Translate\u3092\u4F7F\u3048\u3070\u3001\u30E1\u30FC\u30EB\u30A2\u30D7\u30EA\u5185\u3067\u30E1\u30FC\u30EB\u306E\u5185\u5BB9\u3092\u76F4\u63A5\u7FFB\u8A33\u3067\u304D\u307E\u3059\u3002\u3059\u3079\u3066\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u884C\u308F\u308C\u308B\u305F\u3081\u3001\u30C7\u30FC\u30BF\u306E\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3068\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u306F\u78BA\u4FDD\u3055\u308C\u307E\u3059\u3002"},"highlightText":{"title":"\u30E1\u30FC\u30EB\u306E\u5185\u5BB9\u3092\u30CF\u30A4\u30E9\u30A4\u30C8\u3059\u308B","description":"\u7FFB\u8A33\u3057\u305F\u3044\u9577\u3044\u30E1\u30FC\u30EB\u306E\u5185\u5BB9\u3092\u5F37\u8ABF\u8868\u793A\u3057\u307E\u3059\u3002"},"enterLanguage":{"title":"\u7FFB\u8A33\u8A00\u8A9E\u3092\u5165\u529B","description":"\u7FFB\u8A33\u8A00\u8A9E\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u4F8B\u3048\u3070\u3001\u300C\u30B9\u30DA\u30A4\u30F3\u8A9E\u300D\u3068\u5165\u529B\u3067\u304D\u307E\u3059\u3002"},"complete":{"description":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\u3092\u4F7F\u3063\u3066\u3001\u30C7\u30FC\u30BF\u306E\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u3092\u78BA\u4FDD\u3057\u306A\u304C\u3089\u30E1\u30FC\u30EB\u306E\u64CD\u4F5C\u3001\u8FD4\u4FE1\u3001\u97F3\u58F0\u5165\u529B\u3001\u30E1\u30FC\u30EB\u4F5C\u6210\u3001\u7FFB\u8A33\u3092\u884C\u3046\u65B9\u6CD5\u3092\u7FD2\u5F97\u3057\u307E\u3057\u305F\u3002\u4ED6\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u8A66\u3057\u305F\u308A\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u3066\u3001\u30E1\u30FC\u30EB\u7BA1\u7406\u3092\u3055\u3089\u306B\u30B9\u30E0\u30FC\u30BA\u306B\u3057\u307E\u3057\u3087\u3046\u3002"}},"handsFreeMeeting":{"tourLabel":"\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u306E\u30AF\u30A4\u30C3\u30AF\u4F1A\u8B70\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","learn":"\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u306E\u8FC5\u901F\u306A\u4F1A\u8B70\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u6642\u9593\u3092\u7BC0\u7D04\u3057\u3001\u4EEE\u60F3\u4F1A\u8B70\u306E\u75B2\u52B4\u3092\u8EFD\u6E1B\u3057\u307E\u3059","tryOpen":{"title":"\u300CZoom \u3092\u958B\u304F\u300D\u307E\u305F\u306F\u300CTeams \u3092\u958B\u304F\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044","description":"\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3001\u300CZoom \u3092\u958B\u304F\u300D\u307E\u305F\u306F\u300CTeams \u3092\u958B\u304F\u300D\u3068\u767A\u58F0\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u9078\u629E\u3057\u305F\u4F1A\u8B70\u30A2\u30D7\u30EA\u304C\u958B\u304D\u307E\u3059\u3002\u81EA\u52D5\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u5207\u308A\u66FF\u3048\u304C\u6709\u52B9\u306B\u306A\u3063\u3066\u3044\u308B\u5834\u5408\u306F\u3001\u4F7F\u7528\u3057\u3066\u3044\u308B\u30A2\u30D7\u30EA\u306B\u6700\u9069\u306A\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u5207\u308A\u66FF\u308F\u308A\u307E\u3059\u3002"},"mute":{"title":"\u30DE\u30A4\u30AF\u3092\u30DF\u30E5\u30FC\u30C8\u3059\u308B\u306B\u306F\u3001\u300C\u30DF\u30E5\u30FC\u30C8\u3092\u5207\u308A\u66FF\u3048\u308B\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044","description":"\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3001\u300C\u30DF\u30E5\u30FC\u30C8\u3092\u5207\u308A\u66FF\u3048\u300D\u3068\u767A\u58F0\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u9078\u629E\u3057\u305F\u4F1A\u8B70\u30A2\u30D7\u30EA\u306E\u30DE\u30A4\u30AF\u304C\u30DF\u30E5\u30FC\u30C8\u3055\u308C\u307E\u3059\u3002"},"video":{"title":"\u30AB\u30E1\u30E9\u306E\u30AA\u30F3/\u30AA\u30D5\u3092\u5207\u308A\u66FF\u3048\u308B\u306B\u306F\u3001\u300C\u30D3\u30C7\u30AA\u3092\u30AA\u30F3/\u30AA\u30D5\u306B\u3059\u308B\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044","description":"\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3001\u300C\u30D3\u30C7\u30AA\u3092\u30AA\u30F3\u300D\u3068\u8A00\u3063\u3066\u304F\u3060\u3055\u3044\u3002\u9078\u629E\u3057\u305F\u4F1A\u8B70\u30A2\u30D7\u30EA\u3067\u30AB\u30E1\u30E9\u306E\u30AA\u30F3/\u30AA\u30D5\u3092\u5207\u308A\u66FF\u3048\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"},"raiseHand":{"title":"\u300C\u624B\u3092\u6319\u3052\u3066\u300D\u3068\u8A00\u3063\u3066\u624B\u3092\u6319\u3052\u3066\u307F\u307E\u3057\u3087\u3046","description":"\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3001\u300C\u624B\u3092\u6319\u3052\u3066\u300D\u3068\u8A00\u3063\u3066\u304F\u3060\u3055\u3044\u3002\u9078\u629E\u3057\u305F\u4F1A\u8B70\u30A2\u30D7\u30EA\u3067\u624B\u304C\u6319\u304C\u308A\u307E\u3059\u3002"},"quickType":{"title":"\u30AF\u30A4\u30C3\u30AF\u30BF\u30A4\u30D4\u30F3\u30B0","description":"\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3001\u300C\u3053\u308C\u306F\u4FBF\u5229\u306A\u6A5F\u80FD\u3067\u3059\u300D\u3068\u767A\u58F0\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u3053\u3046\u3059\u308B\u3053\u3068\u3067\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u3092\u4F7F\u308F\u305A\u306B\u97F3\u58F0\u5165\u529B\u3092\u7D20\u65E9\u304F\u884C\u3046\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u4F1A\u8B70\u30A2\u30D7\u30EA\u306E\u30C6\u30AD\u30B9\u30C8\u30D5\u30A3\u30FC\u30EB\u30C9\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u3092\u5F53\u3066\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"complete":{"description":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u4F7F\u3063\u3066\u3001\u30DF\u30E5\u30FC\u30C8/\u30DF\u30E5\u30FC\u30C8\u89E3\u9664\u3001\u30D3\u30C7\u30AA\u306E\u30AA\u30F3/\u30AA\u30D5\u3001\u6319\u624B\u3001\u305D\u3057\u3066\u304A\u6C17\u306B\u5165\u308A\u306E\u4F1A\u8B70\u30A2\u30D7\u30EA\u3067\u306E\u30AF\u30A4\u30C3\u30AF\u5165\u529B\u3092\u884C\u3046\u65B9\u6CD5\u3092\u7FD2\u5F97\u3057\u307E\u3057\u305F\u3002\u4ED6\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u8A66\u3057\u305F\u308A\u3001\u72EC\u81EA\u306E\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u3066\u3001\u4F1A\u8B70\u3092\u3055\u3089\u306B\u30B9\u30E0\u30FC\u30BA\u306B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3057\u3066\u307F\u307E\u3057\u3087\u3046\u3002"}},"summarizingReports":{"tourLabel":"\u30AA\u30F3\u30C7\u30D0\u30A4\u30B9 AI \u3067\u30EC\u30DD\u30FC\u30C8\u3084\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u8981\u7D04","learn":"AI \u3092\u6D3B\u7528\u3057\u305F\u8981\u7D04\u6A5F\u80FD\u3092\u4F7F\u7528\u3057\u3066\u3001\u6A5F\u5BC6\u30C7\u30FC\u30BF\u3084\u72EC\u81EA\u30C7\u30FC\u30BF\u3092\u5B89\u5168\u306B\u4FDD\u3061\u306A\u304C\u3089\u3001\u9577\u3044\u30EC\u30DD\u30FC\u30C8\u3084\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u304B\u3089\u91CD\u8981\u306A\u30DD\u30A4\u30F3\u30C8\u3092\u3059\u3070\u3084\u304F\u53D6\u5F97\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","summarizeIntro":{"title":"\u30C6\u30AD\u30B9\u30C8\u3092\u8981\u7D04\u3059\u308B","description":"Cephable\u306E\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\u3092\u4F7F\u3048\u3070\u3001\u9577\u6587\u306E\u30EC\u30DD\u30FC\u30C8\u3084\u6587\u66F8\u304B\u3089\u8981\u70B9\u3092\u7D20\u65E9\u304F\u62BD\u51FA\u3067\u304D\u307E\u3059\u3002Summarize\u306F\u30AA\u30F3\u30C7\u30D0\u30A4\u30B9AI\u30BF\u30B9\u30AF\u306E\u4E00\u90E8\u3067\u3001\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u63A5\u7D9A\u306A\u3057\u3067\u30C7\u30D0\u30A4\u30B9\u304B\u3089\u5B9F\u884C\u3067\u304D\u307E\u3059\u3002"},"navigateToReport":{"title":"\u30EC\u30DD\u30FC\u30C8\u3084\u6587\u66F8\u306B\u7126\u70B9\u3092\u5F53\u3066\u308B","description":"\u597D\u307F\u306E\u30A2\u30D7\u30EA\u3067\u30EC\u30DD\u30FC\u30C8\u307E\u305F\u306F\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u958B\u304D\u3001\u8981\u7D04\u3057\u305F\u3044\u30C6\u30AD\u30B9\u30C8\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u3092\u5F53\u3066\u307E\u3059\u3002"},"highlightText":{"title":"\u8981\u7D04\u3059\u308B\u30C6\u30AD\u30B9\u30C8\u3092\u5F37\u8ABF\u8868\u793A\u3059\u308B","description":"\u8981\u7D04\u3057\u305F\u3044\u30C6\u30AD\u30B9\u30C8\u3092\u5F37\u8ABF\u8868\u793A\u3057\u307E\u3059\u3002"},"copyText":{"title":"\u30C6\u30AD\u30B9\u30C8\u3092\u30B3\u30D4\u30FC\u3059\u308B","description":"\u30C6\u30AD\u30B9\u30C8\u3092\u30CF\u30A4\u30E9\u30A4\u30C8\u3057\u305F\u5F8C\u3001\u305D\u308C\u3092\u30B3\u30D4\u30FC\u3057\u3066\u8981\u7D04\u306E\u6E96\u5099\u3092\u3057\u307E\u3059\u3002"},"enterPrompt":{"title":"\u8981\u7D04\u306E\u6307\u793A\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","description":"\u8981\u7D04\u306E\u6307\u793A\u3092\u5165\u529B\u3057\u307E\u3059\u3002\u9577\u3055\u3001\u30B9\u30BF\u30A4\u30EB\u3001\u307E\u305F\u306F\u5FC5\u8981\u306A\u5177\u4F53\u7684\u306A\u5185\u5BB9\u3092\u6307\u5B9A\u3057\u307E\u3059\u3002"},"pasteText":{"title":"\u30EC\u30DD\u30FC\u30C8\u306E\u5185\u5BB9\u3092\u8CBC\u308A\u4ED8\u3051\u308B","description":"\u6307\u793A\u306B\u5F93\u3063\u3066\u3001\u30B3\u30D4\u30FC\u3057\u305F\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u30DC\u30C3\u30AF\u30B9\u306B\u8CBC\u308A\u4ED8\u3051\u307E\u3059\u3002"},"focusChatApp":{"title":"\u30C1\u30E3\u30C3\u30C8\u30A2\u30D7\u30EA\u306B\u6CE8\u529B","description":"Teams \u3084 Slack \u306A\u3069\u306E\u30C1\u30E3\u30C3\u30C8 \u30A2\u30D7\u30EA\u3092\u958B\u304D\u3001\u8981\u7D04\u30C6\u30AD\u30B9\u30C8\u3092\u8868\u793A\u3059\u308B\u30C6\u30AD\u30B9\u30C8 \u30DC\u30C3\u30AF\u30B9\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u3092\u5F53\u3066\u307E\u3059\u3002"},"rewriteIntro":{"title":"\u8981\u7D04\u30C6\u30AD\u30B9\u30C8\u306E\u66F8\u304D\u63DB\u3048","description":"Cephable Intelligent Rewrite \u3092\u4F7F\u3048\u3070\u3001\u8981\u7D04\u30C6\u30AD\u30B9\u30C8\u3092\u3055\u3089\u306B\u6D17\u7DF4\u3055\u305B\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002\u3053\u308C\u3089\u306F\u3059\u3079\u3066\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u884C\u308F\u308C\u308B\u305F\u3081\u3001\u30C7\u30FC\u30BF\u306E\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3068\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u306F\u78BA\u4FDD\u3055\u308C\u307E\u3059\u3002"},"highlightSummary":{"title":"\u8981\u7D04\u30C6\u30AD\u30B9\u30C8\u3092\u5F37\u8ABF\u8868\u793A\u3059\u308B","description":"\u3055\u3089\u306B\u7D5E\u308A\u8FBC\u307F\u305F\u3044\u8981\u7D04\u30C6\u30AD\u30B9\u30C8\u3092\u5F37\u8ABF\u8868\u793A\u3057\u307E\u3059\u3002"},"enterRewriteInstructions":{"title":"\u66F8\u304D\u63DB\u3048\u6307\u793A\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","description":"\u66F8\u304D\u76F4\u3057\u306E\u6307\u793A\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30C8\u30FC\u30F3\u3001\u30B9\u30BF\u30A4\u30EB\u3001\u307E\u305F\u306F\u5177\u4F53\u7684\u306A\u5909\u66F4\u70B9\u306A\u3069\u3092\u6307\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"complete":{"description":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\u3092\u4F7F\u3063\u3066\u3001\u8FC5\u901F\u304B\u3064\u5B89\u5168\u306B\u30C6\u30AD\u30B9\u30C8\u3092\u8981\u7D04\u3057\u3001\u30C1\u30FC\u30E0\u3068\u8ABF\u67FB\u7D50\u679C\u3092\u5171\u6709\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3057\u305F\u3002\u8981\u7D04\u3068\u66F8\u304D\u63DB\u3048\u3001\u305D\u306E\u4ED6\u306E\u6A5F\u80FD\u3092\u4F7F\u3063\u3066\u3001\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u6700\u9069\u5316\u3059\u308B\u30E6\u30FC\u30B9\u30B1\u30FC\u30B9\u3092\u3055\u3089\u306B\u63A2\u3063\u3066\u307F\u307E\u3057\u3087\u3046\u3002"}},"congrats":"\u304A\u3081\u3067\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01","noteTakingAndDocumentation":{"tourLabel":"\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u306A\u30C7\u30D0\u30A4\u30B9\u5185 AI \u3092\u4F7F\u7528\u3057\u305F\u30E1\u30E2\u4F5C\u6210\u3068\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u751F\u6210","learn":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3001\u30B9\u30DE\u30FC\u30C8 \u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3001AI \u30BF\u30B9\u30AF\u3092\u4F7F\u7528\u3057\u3066\u3001\u30E1\u30E2\u304B\u3089\u30C7\u30B6\u30A4\u30F3\u3084\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u7D20\u65E9\u304F\u4F5C\u6210\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","focus":{"title":"\u30C6\u30AD\u30B9\u30C8\u30D5\u30A3\u30FC\u30EB\u30C9\u307E\u305F\u306F\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u3059\u308B","description":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u306F\u3001\u30C6\u30AD\u30B9\u30C8\u30D5\u30A3\u30FC\u30EB\u30C9\u307E\u305F\u306F\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u3092\u5F53\u3066\u308B\u3068\u6700\u3082\u52B9\u679C\u7684\u306B\u6A5F\u80FD\u3057\u307E\u3059\u3002\u30E1\u30E2\u3092\u53D6\u308A\u305F\u3044\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u958B\u304F\u304B\u3001\u30C6\u30AD\u30B9\u30C8\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"speaking":{"title":"\u8A71\u3057\u59CB\u3081\u308B","description":"\u3055\u3042\u3001\u8A71\u3057\u59CB\u3081\u307E\u3057\u3087\u3046\u3002\u30A2\u30A4\u30C7\u30A2\u3092\u7DF4\u308A\u306A\u304C\u3089\u3001\u81EA\u7136\u306B\u3001\u8003\u3048\u3092\u81EA\u7531\u306B\u8868\u73FE\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u8A71\u3057\u305F\u5185\u5BB9\u306F\u3059\u3079\u3066\u3001\u30D5\u30A9\u30FC\u30AB\u30B9\u3057\u305F\u30C6\u30AD\u30B9\u30C8\u30D5\u30A3\u30FC\u30EB\u30C9\u307E\u305F\u306F\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306B\u5165\u529B\u3055\u308C\u307E\u3059\u3002\u30B3\u30F3\u30BB\u30D7\u30C8\u3092\u8AAC\u660E\u3057\u305F\u308A\u3001\u624B\u9806\u3092\u5927\u307E\u304B\u306B\u8AAC\u660E\u3057\u305F\u308A\u3001\u81EA\u7531\u306B\u30D6\u30EC\u30A4\u30F3\u30B9\u30C8\u30FC\u30DF\u30F3\u30B0\u3057\u305F\u308A\u3057\u3066\u307F\u307E\u3057\u3087\u3046\u3002\u4F8B\u3048\u3070\u3001\u300C\u30C1\u30FC\u30E0\u306E\u65B0\u3057\u3044\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u691C\u8A0E\u3057\u3066\u3044\u307E\u3059\u3002\u307E\u305A\u3001\u30EC\u30DD\u30FC\u30C8\u4F5C\u6210\u30D7\u30ED\u30BB\u30B9\u3092\u81EA\u52D5\u5316\u3057\u3001\u305D\u306E\u7D50\u679C\u3092\u6BCE\u9031\u30EC\u30D3\u30E5\u30FC\u3059\u308B\u3079\u304D\u3067\u3059\u300D\u306A\u3069\u3068\u767A\u8A00\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30AB\u30FC\u30BD\u30EB\u304C\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u3055\u308C\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"typeEnter":{"title":"\u6BB5\u843D\u533A\u5207\u308A","description":"\u6BB5\u843D\u533A\u5207\u308A\u3092\u4F5C\u6210\u3059\u308B\u306B\u306F\u3001\u30AD\u30FC\u30DC\u30FC\u30C9\u306EEnter\u30AD\u30FC\u3092\u62BC\u3059\u3060\u3051\u3067\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u30E1\u30E2\u3092\u660E\u78BA\u306A\u30BB\u30AF\u30B7\u30E7\u30F3\u306B\u6574\u7406\u3057\u3084\u3059\u304F\u306A\u308A\u307E\u3059\u3002\u8003\u3048\u3092\u8A71\u3057\u7D9A\u3051\u305F\u308A\u3001\u4ED6\u306E\u4EBA\u306E\u8A71\u3092\u66F8\u304D\u5199\u3057\u305F\u308A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"rewriteIntro":{"title":"\u30C7\u30B6\u30A4\u30F3\u3092\u4F5C\u6210\u3059\u308B","description":"Cephable Intelligent Rewrite\u3092\u4F7F\u3048\u3070\u3001\u30E1\u30E2\u3092\u53D6\u308A\u3001\u6A5F\u80FD\u306E\u30A2\u30A4\u30C7\u30A2\u3084\u30D5\u30A9\u30ED\u30FC\u30A2\u30C3\u30D7\u306B\u53CD\u6620\u3055\u305B\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u3059\u3079\u3066\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u884C\u308F\u308C\u308B\u305F\u3081\u3001\u30C7\u30FC\u30BF\u306E\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3068\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u306F\u78BA\u4FDD\u3055\u308C\u307E\u3059\u3002"},"highlightText":{"title":"\u30CE\u30FC\u30C8\u3092\u5F37\u8ABF\u8868\u793A\u3059\u308B","description":"\u30C7\u30B6\u30A4\u30F3\u3084\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306E\u4F5C\u6210\u306B\u4F7F\u7528\u3059\u308B\u3059\u3079\u3066\u306E\u30E1\u30E2\u3092\u9078\u629E\u3057\u307E\u3059\u3002"},"inPlaceReplacement":{"title":"\u73FE\u5834\u3067\u306E\u30A2\u30A4\u30C7\u30A2\u5275\u51FA","description":"\u305D\u308C\u3067\u306F\u3001\u30A4\u30F3\u30D7\u30EC\u30FC\u30B9\u7F6E\u63DB\u3092\u4F7F\u3063\u3066\u30E1\u30E2\u3092\u30C7\u30B6\u30A4\u30F3\u3084\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306B\u5909\u63DB\u3057\u3066\u307F\u307E\u3057\u3087\u3046\u3002\u8CBC\u308A\u4ED8\u3051\u30E2\u30FC\u30C9\u3084\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u4F7F\u3063\u3066\u65B0\u3057\u3044\u30D5\u30A1\u30A4\u30EB\u3092\u4F5C\u6210\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002"},"enterInstructions":{"title":"\u8A2D\u8A08\u6307\u793A\u3092\u5165\u529B","description":"\u30E1\u30E2\u306B\u306F\u3001\u6B21\u306B\u4F55\u3092\u3057\u305F\u3044\u304B\u3068\u3044\u3046\u6307\u793A\u3092\u66F8\u304D\u8FBC\u3080\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3001\u30C7\u30B6\u30A4\u30F3\u3001\u30D5\u30A9\u30ED\u30FC\u30A2\u30C3\u30D7\u30BF\u30B9\u30AF\u306A\u3069\u3001\u4F55\u3067\u3082\u69CB\u3044\u307E\u305B\u3093\u3002\uFF08\u4F8B\uFF1A\u6A5F\u80FD\u306E\u52D5\u4F5C\u65B9\u6CD5\u3001\u30A8\u30F3\u30C9\u30C4\u30FC\u30A8\u30F3\u30C9\u306E\u6982\u8981\u3001\u6210\u529F\u306E\u898B\u901A\u3057\u3092\u307E\u3068\u3081\u305F\u8A2D\u8A08\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u306A\u3069\u3002\uFF09"},"complete":{"description":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30B9\u30DE\u30FC\u30C8\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u4F7F\u3063\u3066\u81E8\u5E8A\u30CE\u30FC\u30C8\u3092\u4F5C\u6210\u3057\u3001\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30EA\u30E9\u30A4\u30C8\u3092\u4F7F\u3063\u3066SOAP\u30B9\u30BF\u30A4\u30EB\u3067\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3057\u305F\u3002\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3068\u30EA\u30E9\u30A4\u30C8\u3001\u3042\u308B\u3044\u306F\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u6700\u9069\u5316\u3059\u308B\u305D\u306E\u4ED6\u306E\u6A5F\u80FD\u3092\u4F7F\u3063\u305F\u30E6\u30FC\u30B9\u30B1\u30FC\u30B9\u3092\u3055\u3089\u306B\u63A2\u3063\u3066\u307F\u307E\u3057\u3087\u3046\u3002"}},"fpsGamePlay":{"tourLabel":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067FPS\u30B2\u30FC\u30E0\u3092\u30D7\u30EC\u30A4","learn":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3057\u3066 FPS \u30B2\u30FC\u30E0\u3092\u30D7\u30EC\u30A4\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","changeProfile":{"title":"\u5909\u66F4\u7BA1\u7406\u30D7\u30ED\u30D5\u30A1\u30A4\u30EB","description":"\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092FPS\u30B2\u30FC\u30E0\u30D7\u30ED\u30D5\u30A1\u30A4\u30EB\u306B\u5909\u66F4\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30D7\u30EC\u30A4\u3057\u305F\u3044\u30B2\u30FC\u30E0\u306B\u5408\u308F\u305B\u3066\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002\u52D5\u753B\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002"},"autoProfileSwitching":{"title":"\u81EA\u52D5\u5236\u5FA1\u5207\u308A\u66FF\u3048\u3092\u30AA\u30D5\u306B\u3059\u308B","description":"\u3053\u308C\u306B\u3088\u308A\u3001\u30A2\u30D7\u30EA\u3092\u5909\u66F4\u3059\u308B\u307E\u3067\u73FE\u5728\u306E\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30A2\u30AF\u30C6\u30A3\u30D6\u306A\u307E\u307E\u306B\u306A\u308A\u307E\u3059\u3002"},"tryOpen":{"title":"\u300CValorant\u3092\u958B\u304F\u300D\u307E\u305F\u306F\u300CBattlefield\u3092\u958B\u304F\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044"},"go":{"title":"\u300CGo\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044","description":"\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u3001\u300CGo\u300D\u3068\u8A00\u3063\u3066\u304F\u3060\u3055\u3044\u3002\u30AD\u30E3\u30E9\u30AF\u30BF\u30FC\u304C\u524D\u9032\u3057\u59CB\u3081\u307E\u3059\u3002"},"stop":{"title":"\u300C\u30B9\u30C8\u30C3\u30D7\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044","description":"\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u3001\u300C\u505C\u6B62\u300D\u3068\u8A00\u3063\u3066\u304F\u3060\u3055\u3044\u3002\u3053\u308C\u3067\u30AD\u30E3\u30E9\u30AF\u30BF\u30FC\u306E\u52D5\u304D\u304C\u6B62\u307E\u308A\u307E\u3059\u3002"},"complete":{"description":"FPS\u30B2\u30FC\u30E0\u3067\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u4F7F\u3063\u3066\u30AD\u30E3\u30E9\u30AF\u30BF\u30FC\u3092\u52D5\u304B\u3057\u305F\u308A\u3001\u505C\u6B62\u3057\u305F\u308A\u3001\u64CD\u4F5C\u3059\u308B\u65B9\u6CD5\u3092\u7FD2\u5F97\u3057\u307E\u3057\u305F\u3002\u3082\u3063\u3068\u591A\u304F\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u8A66\u3057\u305F\u308A\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u3066\u3001\u3088\u308A\u30B9\u30E0\u30FC\u30BA\u3067\u30B9\u30D4\u30FC\u30C7\u30A3\u30FC\u306A\u30B2\u30FC\u30E0\u30D7\u30EC\u30A4\u3092\u5B9F\u73FE\u3057\u307E\u3057\u3087\u3046\u3002"}},"presentationControls":{"tourLabel":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3067\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u5236\u5FA1\u3059\u308B","learn":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3057\u3066\u3001\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u64CD\u4F5C\u304A\u3088\u3073\u5236\u5FA1\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","tryOpen":{"title":"\u300CPowerPoint \u3092\u958B\u304F\u300D\u307E\u305F\u306F\u300CGoogle \u30B9\u30E9\u30A4\u30C9\u3092\u958B\u304F\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002"},"startPresentation":{"title":"\u30B9\u30E9\u30A4\u30C9\u30B7\u30E7\u30FC\u3092\u958B\u59CB\u3059\u308B\u306B\u306F\u3001\u300C\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u958B\u59CB\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002","description":"\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3001\u300C\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u958B\u59CB\u300D\u3068\u8A00\u3063\u3066\u304F\u3060\u3055\u3044\u3002\u9078\u629E\u3057\u305F\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u30A2\u30D7\u30EA\u3067\u30B9\u30E9\u30A4\u30C9\u30B7\u30E7\u30FC\u304C\u958B\u59CB\u3055\u308C\u307E\u3059\u3002"},"nextSlide":{"title":"\u6B21\u306E\u30B9\u30E9\u30A4\u30C9\u306B\u79FB\u52D5\u3059\u308B\u306B\u306F\u3001\u300C\u6B21\u306E\u30B9\u30E9\u30A4\u30C9\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044","description":"\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3001\u300C\u6B21\u306E\u30B9\u30E9\u30A4\u30C9\u300D\u3068\u8A00\u3063\u3066\u304F\u3060\u3055\u3044\u3002\u30B9\u30E9\u30A4\u30C9\u30B7\u30E7\u30FC\u306E\u6B21\u306E\u30B9\u30E9\u30A4\u30C9\u306B\u9032\u307F\u307E\u3059\u3002"},"previousSlide":{"title":"\u524D\u306E\u30B9\u30E9\u30A4\u30C9\u306B\u623B\u308B\u306B\u306F\u3001\u300C\u524D\u306E\u30B9\u30E9\u30A4\u30C9\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002","description":"\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3001\u300C\u524D\u306E\u30B9\u30E9\u30A4\u30C9\u300D\u3068\u8A00\u3063\u3066\u304F\u3060\u3055\u3044\u3002\u30B9\u30E9\u30A4\u30C9\u30B7\u30E7\u30FC\u306E\u524D\u306E\u30B9\u30E9\u30A4\u30C9\u306B\u623B\u308A\u307E\u3059\u3002"},"escape":{"title":"\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u3092\u7D42\u4E86\u3059\u308B\u306B\u306F\u3001\u300CEscape\u300D\u3068\u767A\u58F0\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044","description":"\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3001\u300CEscape\u300D\u3068\u767A\u58F0\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u9078\u629E\u3057\u305F\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u30A2\u30D7\u30EA\u306E\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u304C\u7D42\u4E86\u3057\u307E\u3059\u3002"},"complete":{"description":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u4F7F\u3063\u3066\u3001\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u958B\u59CB\u3001\u64CD\u4F5C\u3001\u7D42\u4E86\u3059\u308B\u65B9\u6CD5\u3092\u7FD2\u5F97\u3057\u307E\u3057\u305F\u3002\u4ED6\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u8A66\u3057\u305F\u308A\u3001\u72EC\u81EA\u306E\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u3066\u3001\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u3055\u3089\u306B\u30B9\u30E0\u30FC\u30BA\u306B\u64CD\u4F5C\u3057\u3066\u307F\u307E\u3057\u3087\u3046\u3002"}},"editingImages":{"tourLabel":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u306B\u3088\u308B\u3088\u308A\u9AD8\u901F\u306A\u753B\u50CF\u7DE8\u96C6","learn":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3057\u3066\u753B\u50CF\u7DE8\u96C6\u30D7\u30ED\u30BB\u30B9\u3092\u6539\u5584\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","tryOpen":{"title":"\u300CFigma\u3092\u958B\u304F\u300D\u307E\u305F\u306F\u300CPhotoshop\u3092\u958B\u304F\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002"},"selectAll":{"title":"\u30AD\u30E3\u30F3\u30D0\u30B9\u4E0A\u306E\u3059\u3079\u3066\u306E\u8981\u7D20\u3092\u9078\u629E\u3059\u308B\u306B\u306F\u3001\u300C\u3059\u3079\u3066\u9078\u629E\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002","description":"\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3001\u300C\u3059\u3079\u3066\u9078\u629E\u300D\u3068\u8A00\u3063\u3066\u304F\u3060\u3055\u3044\u3002\u9078\u629E\u3057\u305F\u753B\u50CF\u7DE8\u96C6\u30A2\u30D7\u30EA\u306E\u30AD\u30E3\u30F3\u30D0\u30B9\u4E0A\u306E\u3059\u3079\u3066\u306E\u8981\u7D20\u304C\u9078\u629E\u3055\u308C\u307E\u3059\u3002\u30A2\u30D7\u30EA\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u3057\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"bold":{"title":"\u9078\u629E\u3057\u305F\u30C6\u30AD\u30B9\u30C8\u3092\u592A\u5B57\u306B\u3059\u308B\u306B\u306F\u3001\u300C\u592A\u5B57\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044","description":"\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3001\u300C\u592A\u5B57\u300D\u3068\u767A\u58F0\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u9078\u629E\u3057\u305F\u753B\u50CF\u7DE8\u96C6\u30A2\u30D7\u30EA\u3067\u9078\u629E\u3057\u305F\u30C6\u30AD\u30B9\u30C8\u304C\u592A\u5B57\u306B\u306A\u308A\u307E\u3059\u3002\u30C6\u30AD\u30B9\u30C8\u304C\u9078\u629E\u3055\u308C\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"copy":{"title":"\u9078\u629E\u3057\u305F\u8981\u7D20\u3092\u30B3\u30D4\u30FC\u3059\u308B\u306B\u306F\u3001\u300C\u30B3\u30D4\u30FC\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044","description":"\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3001\u300C\u30B3\u30D4\u30FC\u300D\u3068\u8A00\u3063\u3066\u304F\u3060\u3055\u3044\u3002\u9078\u629E\u3057\u305F\u753B\u50CF\u7DE8\u96C6\u30A2\u30D7\u30EA\u3067\u9078\u629E\u3057\u305F\u8981\u7D20\u304C\u30B3\u30D4\u30FC\u3055\u308C\u307E\u3059\u3002\u8981\u7D20\u304C\u9078\u629E\u3055\u308C\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"paste":{"title":"\u30B3\u30D4\u30FC\u3057\u305F\u8981\u7D20\u3092\u8CBC\u308A\u4ED8\u3051\u308B\u306B\u306F\u3001\u300C\u8CBC\u308A\u4ED8\u3051\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002","description":"\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3001\u300C\u8CBC\u308A\u4ED8\u3051\u300D\u3068\u8A00\u3063\u3066\u304F\u3060\u3055\u3044\u3002\u30B3\u30D4\u30FC\u3057\u305F\u8981\u7D20\u304C\u9078\u629E\u3057\u305F\u753B\u50CF\u7DE8\u96C6\u30A2\u30D7\u30EA\u306B\u8CBC\u308A\u4ED8\u3051\u3089\u308C\u307E\u3059\u3002"},"delete":{"title":"\u9078\u629E\u3057\u305F\u8981\u7D20\u3092\u524A\u9664\u3059\u308B\u306B\u306F\u3001\u300CDelete\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044","description":"\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3001\u300C\u524A\u9664\u300D\u3068\u767A\u58F0\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u9078\u629E\u3057\u305F\u753B\u50CF\u7DE8\u96C6\u30A2\u30D7\u30EA\u3067\u9078\u629E\u3057\u305F\u8981\u7D20\u304C\u524A\u9664\u3055\u308C\u307E\u3059\u3002\u8981\u7D20\u304C\u9078\u629E\u3055\u308C\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"dictationIntro":{"title":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3","description":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u97F3\u58F0\u3067\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3067\u304D\u307E\u3059\u3002\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u3066\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u304C\u6709\u52B9\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"focus":{"title":"\u30C6\u30AD\u30B9\u30C8\u30D5\u30A3\u30FC\u30EB\u30C9\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u3059\u308B","description":"\u753B\u50CF\u7DE8\u96C6\u30A2\u30D7\u30EA\u3067\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3059\u308B\u30C6\u30AD\u30B9\u30C8 \u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002"},"speaking":{"title":"\u8A71\u3057\u59CB\u3081\u308B","description":"\u300C\u65E9\u671F\u5272\u5F15\u30B3\u30FC\u30C9\u306FQR\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3057\u3066\u304F\u3060\u3055\u3044\u30029\u670830\u65E5\u307E\u3067\u6709\u52B9\u3067\u3059\u3002\u305D\u306E\u5F8C\u3001\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u304B\u3089\u304A\u7533\u3057\u8FBC\u307F\u304F\u3060\u3055\u3044\u3002\u300D\u3068\u767A\u58F0\u3057\u3066\u307F\u307E\u3057\u3087\u3046\u3002\u97F3\u58F0\u5165\u529B\u3057\u305F\u3044\u30C6\u30AD\u30B9\u30C8\u30D5\u30A3\u30FC\u30EB\u30C9\u307E\u305F\u306F\u9818\u57DF\u306B\u7126\u70B9\u3092\u5408\u308F\u305B\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"complete":{"description":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u4F7F\u3063\u3066\u753B\u50CF\u7DE8\u96C6\u30D7\u30ED\u30BB\u30B9\u3092\u6539\u5584\u3059\u308B\u65B9\u6CD5\u3092\u7FD2\u5F97\u3057\u307E\u3057\u305F\u3002\u4ED6\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u8A66\u3057\u305F\u308A\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u3066\u3001\u753B\u50CF\u7DE8\u96C6\u3092\u3055\u3089\u306B\u30B9\u30E0\u30FC\u30BA\u306B\u3057\u307E\u3057\u3087\u3046\u3002"}},"redo":"\u30AA\u30F3\u30DC\u30FC\u30C7\u30A3\u30F3\u30B0\u3092\u3084\u308A\u76F4\u3059","title":"Cephable\u306B\u3064\u3044\u3066","description":"\u3042\u306A\u305F\u306E\u30D1\u30FC\u30BD\u30CA\u30EB AI \u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u3067\u3042\u308B Cephable \u3092\u4F53\u9A13\u3057\u3001\u30D1\u30FC\u30BD\u30CA\u30E9\u30A4\u30BA\u3055\u308C\u305F\u30E6\u30FC\u30B9\u30B1\u30FC\u30B9\u3078\u306E\u95A2\u5FC3\u3092\u5171\u6709\u3057\u307E\u3057\u3087\u3046\u3002","panel":{"description":"\u3053\u308C\u306F\u30E1\u30A4\u30F3\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u30BB\u30F3\u30BF\u30FC\u3068\u306A\u308B\u30D1\u30CD\u30EB\u3067\u3059\u3002\u5E38\u306B\u8868\u793A\u3055\u308C\u3066\u304A\u308A\u3001\u97F3\u58F0\u3092\u4F7F\u3063\u3066\u30A2\u30D7\u30EA\u306A\u3069\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002\u307E\u305A\u306F\u30DE\u30A4\u30AF\u304B\u3089\u59CB\u3081\u307E\u3057\u3087\u3046\u3002"}}');


var $3a6703d76fc08995$exports = {};
$3a6703d76fc08995$exports = JSON.parse('{"introduction":{"title":"\u3053\u3093\u306B\u3061\u306F\u3001Cephable\u3067\u3059\u3002","back":"\u306F\u3058\u3081\u306B\u623B\u308B","description":"\u79C1\u306F\u3042\u306A\u305F\u306E\u30D1\u30FC\u30BD\u30CA\u30EBAI\u3067\u3059\u3002\u4F7F\u3044\u6163\u308C\u305F\u30C4\u30FC\u30EB\u3092\u4F7F\u3063\u3066\u3001\u3042\u3089\u3086\u308B\u63A5\u7D9A\u74B0\u5883\u306B\u304A\u3051\u308B\u5236\u5FA1\u3001\u4F5C\u6210\u3001\u81EA\u52D5\u5316\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u307E\u3059\u3002\u79C1\u306B\u3064\u3044\u3066\u3044\u304F\u3064\u304B\u77E5\u3063\u3066\u304A\u304F\u3079\u304D\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002","action":"\u3055\u3042\u3001\u59CB\u3081\u307E\u3057\u3087\u3046\uFF01","recording":{"title":"\u97F3\u58F0\u3068\u30D3\u30C7\u30AA\u306F\u30ED\u30FC\u30AB\u30EB\u306E\u307E\u307E\u3067\u3059\u3002","description":"\u3042\u306A\u305F\u306E\u97F3\u58F0\u3084\u52D5\u753B\u3092\u9332\u97F3\u3001\u30B9\u30C8\u30EA\u30FC\u30DF\u30F3\u30B0\u3001\u30AF\u30E9\u30A6\u30C9\u306B\u9001\u4FE1\u3059\u308B\u3053\u3068\u306F\u4E00\u5207\u3042\u308A\u307E\u305B\u3093\u3002\u3059\u3079\u3066\u306E\u5165\u529B\u306F\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u51E6\u7406\u3055\u308C\u3001\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3068\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u304C\u78BA\u4FDD\u3055\u308C\u307E\u3059\u3002"},"data":{"title":"\u3042\u306A\u305F\u306E\u30C7\u30FC\u30BF\u306F\u3042\u306A\u305F\u306E\u3082\u306E\u3067\u3059\u3002","description":"\u3042\u306A\u305F\u306E\u30B3\u30DE\u30F3\u30C9\u3084\u30A2\u30AF\u30C6\u30A3\u30D3\u30C6\u30A3\u3092\u3001\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u306E\u30E2\u30C7\u30EB\u5B66\u7FD2\u306B\u5229\u7528\u3059\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u3059\u3079\u3066\u306F\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u306B\u4FDD\u305F\u308C\u3001\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u63A5\u7D9A\u9593\u3067\u3082\u5171\u6709\u3055\u308C\u307E\u3059\u3002"},"offline":{"title":"\u4ED6\u306E\u30C4\u30FC\u30EB\u304C\u6A5F\u80FD\u3057\u306A\u3044\u3068\u304D\u306B\u3082\u6A5F\u80FD\u3057\u307E\u3059\u3002","description":"\u30B3\u30F3\u30C6\u30F3\u30C4\u751F\u6210\u3001\u30EA\u30E9\u30A4\u30C8\u3001\u7FFB\u8A33\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3068\u3044\u3063\u305F\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u30BF\u30B9\u30AF\u306F\u3059\u3079\u3066\u30ED\u30FC\u30AB\u30EB\u3067\u5B9F\u884C\u3055\u308C\u307E\u3059\u3002\u30AF\u30E9\u30A6\u30C9\u306F\u4E0D\u8981\u3067\u3059\u3002\u3064\u307E\u308A\u3001\u30AA\u30D5\u30E9\u30A4\u30F3\u3067\u3082\u4F5C\u696D\u304C\u53EF\u80FD\u3067\u3001\u30C7\u30FC\u30BF\u304C\u30C7\u30D0\u30A4\u30B9\u304B\u3089\u5916\u90E8\u306B\u6F0F\u308C\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002"},"empower":{"title":"\u643E\u53D6\u3059\u308B\u305F\u3081\u3067\u306F\u306A\u304F\u3001\u529B\u3092\u4E0E\u3048\u308B\u305F\u3081\u306B\u69CB\u7BC9\u3055\u308C\u307E\u3057\u305F\u3002","description":"\u79C1\u306F\u3042\u306A\u305F\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u5F37\u5316\u3059\u308B\u305F\u3081\u306B\u8A2D\u8A08\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u76E3\u8996\u3059\u308B\u305F\u3081\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u4FB5\u5165\u7684\u306A\u8FFD\u8DE1\u3084\u4E0D\u6C17\u5473\u306A\u30C7\u30FC\u30BF\u53CE\u96C6\u306F\u4E00\u5207\u3042\u308A\u307E\u305B\u3093\u3002\u3042\u306A\u305F\u306B\u3068\u3063\u3066\u4F7F\u3044\u3084\u3059\u3044\u5165\u529B\u3060\u3051\u3092\u3002"}},"my-capabilities":{"title":"\u5B8C\u74A7\u3067\u3059\uFF01\u79C1\u304C\u304A\u624B\u4F1D\u3044\u3067\u304D\u308B\u3053\u3068\u306F\u6B21\u306E\u3068\u304A\u308A\u3067\u3059\u3002","back":"\u6A5F\u80FD\u306B\u623B\u308B","actionTitle":"\u79C1\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u3054\u89A7\u304F\u3060\u3055\u3044","description":"\u3042\u306A\u305F\u306E\u8208\u5473\u306B\u57FA\u3065\u3044\u3066\u3001\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306B\u6700\u3082\u95A2\u9023\u306E\u3042\u308B\u6A5F\u80FD\u3068\u6A5F\u80FD\u3092\u7D39\u4ECB\u3057\u307E\u3059\u3002","action":{"title":"\u79C1\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u3054\u89A7\u304F\u3060\u3055\u3044","description":"\u65E5\u3005\u306E\u696D\u52D9\u3067\u79C1\u304C\u3069\u306E\u3088\u3046\u306B\u30B5\u30DD\u30FC\u30C8\u3067\u304D\u308B\u304B\u3001\u3044\u304F\u3064\u304B\u306E\u4F8B\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002"}},"see-me":{"title":"\u79C1\u304C\u3042\u306A\u305F\u306E\u3088\u3046\u306A\u4ED6\u306E\u4EBA\u9054\u3092\u3069\u306E\u3088\u3046\u306B\u52A9\u3051\u3066\u304D\u305F\u304B\u77E5\u308A\u305F\u3044\u3067\u3059\u304B?","back":"\u30E6\u30FC\u30B9\u30B1\u30FC\u30B9\u306B\u623B\u308B","description":"\u3055\u307E\u3056\u307E\u306A\u696D\u754C\u3084\u5F79\u5272\u306B\u308F\u305F\u3063\u3066\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u3069\u306E\u3088\u3046\u306B\u5909\u9769\u3057\u305F\u304B\u3001\u5B9F\u969B\u306E\u4F8B\u3092\u3044\u304F\u3064\u304B\u3054\u89A7\u304F\u3060\u3055\u3044\u3002"},"complete":{"title":"\u79C1\u3092\u4F7F\u3044\u59CB\u3081\u308B\u6E96\u5099\u306F\u3067\u304D\u307E\u3057\u305F\u304B?","description":"\u79C1\u306E\u5B9F\u529B\u3001\u3054\u89A7\u3044\u305F\u3060\u3051\u307E\u3057\u305F\u3067\u3057\u3087\u3046\u304B\uFF1F\u3055\u3042\u3001\u8A2D\u5B9A\u3092\u3057\u3066\u3001\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306E\u5909\u9769\u3092\u59CB\u3081\u307E\u3057\u3087\u3046\u3002\u6700\u5F8C\u307E\u3067\u5168\u529B\u3067\u30B5\u30DD\u30FC\u30C8\u3044\u305F\u3057\u307E\u3059\u3002","action":"\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7\u3092\u5B8C\u4E86\u3057\u3066Cephable\u306E\u4F7F\u7528\u3092\u958B\u59CB\u3059\u308B"},"apps":{"title":"\u3059\u3067\u306B\u611B\u7528\u3055\u308C\u3066\u3044\u308B\u30C4\u30FC\u30EB\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u307E\u3059","description":"200\u4EE5\u4E0A\u306E\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u4E8B\u524D\u8A2D\u5B9A\u6E08\u307F\u3067\u30B5\u30DD\u30FC\u30C8\u3002\u6BCE\u65E5\u4F7F\u7528\u3059\u308B\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3092\u305D\u306E\u307E\u307E\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002\u8A2D\u5B9A\u306F\u4E0D\u8981\u3067\u3059\u3002","note":"\u304A\u4F7F\u3044\u306E\u30A2\u30D7\u30EA\u304C\u898B\u3064\u304B\u3089\u306A\u3044\u5834\u5408\u3067\u3082\u3001\u554F\u984C\u3042\u308A\u307E\u305B\u3093\u3002\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u751F\u6210\u3057\u305F\u308A\u3001\u304A\u5BA2\u69D8\u306B\u6700\u9069\u306A\u30AB\u30B9\u30BF\u30E0\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306E\u4F5C\u6210\u3092\u304A\u624B\u4F1D\u3044\u3057\u307E\u3059\u3002","andMore":"\u305D\u306E\u4ED6"},"actions":{"ctaTry":"\u4ECA\u3059\u3050\u8A66\u3059","ctaWatch":"\u30C7\u30E2\u3092\u898B\u308B","apps":"\u9069\u5408\u3059\u308B\u3082\u306E:","abilities":"\u4F7F\u7528\u3057\u305F\u80FD\u529B:"},"interests":{"title":"\u4F55\u3092\u304A\u624B\u4F1D\u3044\u3057\u307E\u3057\u3087\u3046\u304B\uFF1F","back":"\u8208\u5473\u306B\u623B\u308B","description":"\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u3084\u63A5\u7D9A\u3055\u308C\u305F\u30C7\u30D0\u30A4\u30B9\u4E0A\u306E\u30A2\u30D7\u30EA\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002\u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u307E\u3057\u3087\u3046\u3002\u7279\u306B\u3054\u8208\u5473\u306E\u3042\u308B\u5206\u91CE\u306F\u4F55\u3067\u3059\u304B\uFF1F","note":"\u8A72\u5F53\u3059\u308B\u3082\u306E\u3092\u3059\u3079\u3066\u9078\u629E\u3059\u308B\u3068\u3001\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306B\u6700\u3082\u95A2\u9023\u6027\u306E\u9AD8\u3044\u6A5F\u80FD\u3068\u4F8B\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002","action":"{{count}}\u4EF6\u306E\u8208\u5473\u3092\u7D99\u7D9A","empty":"\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u306E\u8208\u5473\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002","create_design":{"label":"\u4F5C\u6210\u3068\u30C7\u30B6\u30A4\u30F3","shortLabel":"\u30C7\u30B6\u30A4\u30F3","description":"\u30A2\u30FC\u30C6\u30A3\u30B9\u30C8\u3001\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0\u62C5\u5F53\u8005\u3001\u30B3\u30F3\u30C6\u30F3\u30C4\u30AF\u30EA\u30A8\u30A4\u30BF\u30FC\u5411\u3051\u3002"},"analyze_report":{"label":"\u5206\u6790\u3068\u30EC\u30DD\u30FC\u30C8","shortLabel":"\u5206\u6790\u3059\u308B","description":"\u30A2\u30CA\u30EA\u30B9\u30C8\u3001\u7814\u7A76\u8005\u3001\u30D3\u30B8\u30CD\u30B9\u30D7\u30ED\u30D5\u30A7\u30C3\u30B7\u30E7\u30CA\u30EB\u5411\u3051\u3002"},"communicate_collaborate":{"label":"\u30B3\u30DF\u30E5\u30CB\u30B1\u30FC\u30B7\u30E7\u30F3\u3068\u30B3\u30E9\u30DC\u30EC\u30FC\u30B7\u30E7\u30F3","shortLabel":"\u901A\u4FE1\u3059\u308B","description":"\u8CA9\u58F2\u8005\u3001\u4F1A\u8B70\u3001\u30EA\u30E2\u30FC\u30C8 \u30C1\u30FC\u30E0\u5411\u3051\u3002"},"build_develop":{"label":"\u69CB\u7BC9\u3068\u958B\u767A","shortLabel":"\u958B\u767A\u3059\u308B","description":"\u958B\u767A\u8005\u3001\u30A8\u30F3\u30B8\u30CB\u30A2\u3001\u6280\u8853\u5C02\u9580\u5BB6\u5411\u3051\u3002"},"game_play":{"label":"\u30B2\u30FC\u30E0\u3068\u30D7\u30EC\u30A4","shortLabel":"\u30B2\u30FC\u30E0","description":"\u30B2\u30FC\u30DE\u30FC\u3001\u30B9\u30C8\u30EA\u30FC\u30DE\u30FC\u3001\u30E1\u30C7\u30A3\u30A2 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u5411\u3051\u3002"},"learn_teach":{"label":"\u5B66\u3076\uFF06\u6559\u3048\u308B","shortLabel":"\u5B66\u3076","description":"\u6559\u80B2\u8005\u3001\u5B66\u751F\u3001\u6307\u5C0E\u54E1\u5411\u3051\u3002"},"manage_organize":{"label":"\u7BA1\u7406\u3068\u6574\u7406","shortLabel":"\u7D44\u7E54\u5316","description":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DE\u30CD\u30FC\u30B8\u30E3\u30FC\u3001\u30B3\u30FC\u30C7\u30A3\u30CD\u30FC\u30BF\u30FC\u3001\u30AA\u30FC\u30AC\u30CA\u30A4\u30B6\u30FC\u5411\u3051\u3002"},"adapt_access":{"label":"\u9069\u5FDC\u3068\u30A2\u30AF\u30BB\u30B9","shortLabel":"\u30A2\u30AF\u30BB\u30B7\u30D3\u30EA\u30C6\u30A3","description":"\u9069\u5FDC\u578B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30D1\u30FC\u30BD\u30CA\u30E9\u30A4\u30BA\u3055\u308C\u305F\u30A2\u30AF\u30BB\u30B7\u30D3\u30EA\u30C6\u30A3\u306E\u30CB\u30FC\u30BA\u306B\u5BFE\u5FDC\u3057\u307E\u3059\u3002"},"everything":{"label":"\u3042\u3089\u3086\u308B\u3082\u306E\u3092\u5C11\u3057\u305A\u3064","shortLabel":"\u3059\u3079\u3066","description":"\u4E00\u822C\u7684\u306A\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u30E6\u30FC\u30B6\u30FC\u304A\u3088\u3073\u30DE\u30EB\u30C1\u30BF\u30B9\u30AF\u30E6\u30FC\u30B6\u30FC\u5411\u3051\u3002"},"filter":"\u8208\u5473\u306E\u7A2E\u985E\u3067\u30D5\u30A3\u30EB\u30BF\u30EA\u30F3\u30B0"},"capabilities":{"title":"\u79C1\u306E\u30B3\u30A2AI\u6A5F\u80FD","description":"\u9AD8\u5EA6\u306AAI\u3068\u5F37\u529B\u306A\u5165\u529B\u65B9\u6CD5\u3092\u7D44\u307F\u5408\u308F\u305B\u308B\u3053\u3068\u3067\u3001\u30A2\u30D7\u30EA\u3084\u30C7\u30D0\u30A4\u30B9\u3092\u30B7\u30FC\u30E0\u30EC\u30B9\u306B\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002\u79C1\u304C\u3067\u304D\u308B\u3053\u3068\u306E\u4E00\u90E8\u3092\u3054\u7D39\u4ECB\u3057\u307E\u3059\u3002","voice_controls":{"title":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","description":"\u81EA\u7136\u8A00\u8A9E\u30B3\u30DE\u30F3\u30C9\u3092\u7406\u89E3\u3057\u3066\u3044\u308B\u306E\u3067\u3001\u3042\u3089\u3086\u308B\u30A2\u30D7\u30EA\u3092\u97F3\u58F0\u3067\u5236\u5FA1\u3067\u304D\u307E\u3059\u3002","longDescription":"\u81EA\u7136\u306A\u8A71\u3057\u65B9\u3067\u3001\u7269\u4E8B\u3092\u30B9\u30E0\u30FC\u30BA\u306B\u9032\u3081\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u30A2\u30D7\u30EA\u3092\u958B\u3044\u305F\u308A\u3001\u30E1\u30CB\u30E5\u30FC\u3092\u64CD\u4F5C\u3057\u305F\u308A\u3001\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u958B\u59CB\u3057\u305F\u308A\u3057\u305F\u3044\u6642\u3001\u5206\u304B\u308A\u3084\u3059\u3044\u82F1\u8A9E\u3092\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u78BA\u5B9F\u306A\u64CD\u4F5C\u306B\u5909\u63DB\u3057\u307E\u3059\u3002"},"smart_dictation":{"title":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3","description":"\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u8A8D\u8B58\u3068\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3092\u4F7F\u7528\u3057\u3066\u3001\u3042\u306A\u305F\u306E\u30B9\u30D4\u30FC\u30C1\u3092\u30C6\u30AD\u30B9\u30C8\u306B\u5909\u63DB\u3057\u307E\u3059\u3002","longDescription":"\u3042\u306A\u305F\u306E\u8A00\u8449\u3092\u6CE8\u610F\u6DF1\u304F\u805E\u304D\u3001\u6B63\u78BA\u306B\u6349\u3048\u307E\u3059\u3002\u53E5\u8AAD\u70B9\u306E\u8FFD\u52A0\u3001\u5927\u6587\u5B57\u306E\u4FEE\u6B63\u3001\u305D\u3057\u3066\u3042\u306A\u305F\u306E\u30B9\u30BF\u30A4\u30EB\u306B\u5408\u308F\u305B\u305F\u30A2\u30EC\u30F3\u30B8\u3092\u3059\u308B\u3053\u3068\u3067\u3001\u4F59\u5206\u306A\u624B\u9593\u3092\u304B\u3051\u305A\u306B\u6D17\u7DF4\u3055\u308C\u305F\u6587\u7AE0\u306B\u4ED5\u4E0A\u3052\u307E\u3059\u3002"},"ai_text_generation":{"title":"AI\u30C6\u30AD\u30B9\u30C8\u751F\u6210","description":"\u30E1\u30FC\u30EB\u3001\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3001\u30B3\u30FC\u30C9\u3001\u30AF\u30EA\u30A8\u30A4\u30C6\u30A3\u30D6\u306A\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u5373\u5EA7\u306B\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002","longDescription":"\u30A2\u30D7\u30EA\u5185\u3067\u76F4\u63A5\u3001\u4E0B\u66F8\u304D\u3001\u8981\u7D04\u3001\u62E1\u5F35\u306A\u3069\u3001\u3042\u3089\u3086\u308B\u4F5C\u696D\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u307E\u3059\u3002\u30E1\u30FC\u30EB\u3084\u30E1\u30E2\u304B\u3089\u30B3\u30FC\u30C9\u30B9\u30CB\u30DA\u30C3\u30C8\u3084\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u307E\u3067\u3001\u767D\u7D19\u306E\u72B6\u614B\u304B\u3089\u59CB\u3081\u308B\u3053\u3068\u306A\u304F\u3001\u30B9\u30E0\u30FC\u30BA\u306B\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002"},"head_face_controls":{"title":"\u30D8\u30C3\u30C9\uFF06\u30D5\u30A7\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","description":"\u982D\u3084\u9854\u306E\u52D5\u304D\u3067\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u8D77\u3053\u305B\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002","longDescription":"\u3042\u306A\u305F\u306E\u81EA\u7136\u306A\u982D\u306E\u52D5\u304D\u3084\u8868\u60C5\u3092\u3001\u6B63\u78BA\u306A\u5165\u529B\u306B\u5909\u63DB\u3057\u307E\u3059\u3002\u7B11\u9854\u3067\u30E1\u30FC\u30EB\u3092\u9001\u4FE1\u3057\u305F\u308A\u3001\u3046\u306A\u305A\u304D\u306A\u304C\u3089\u30DA\u30FC\u30B8\u3092\u3081\u304F\u3063\u305F\u308A\u3001\u7709\u3092\u4E0A\u3052\u3066\u30AF\u30EA\u30C3\u30AF\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002"},"natural_language_voice_clicking":{"title":"\u81EA\u7136\u8A00\u8A9E\u97F3\u58F0\u30AF\u30EA\u30C3\u30AF","description":"\u753B\u9762\u4E0A\u306E\u30DC\u30BF\u30F3\u3001\u30EA\u30F3\u30AF\u3001\u30E1\u30CB\u30E5\u30FC\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u304D\u306B\u3001\u898B\u305F\u3082\u306E\u3092\u305D\u306E\u307E\u307E\u767A\u97F3\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002","longDescription":"\u753B\u9762\u4E0A\u306E\u4F55\u304B\u306E\u540D\u524D\u3092\u8A71\u3059\u3068\u3001\u79C1\u304C\u305D\u308C\u3092\u898B\u3064\u3051\u3066\u64CD\u4F5C\u3057\u307E\u3059\u3002\u30B3\u30DE\u30F3\u30C9\u3092\u899A\u3048\u308B\u5FC5\u8981\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u6B32\u3057\u3044\u3082\u306E\u3092\u8AAC\u660E\u3059\u308B\u3060\u3051\u3067\u3001\u30AF\u30EA\u30C3\u30AF\u306F\u79C1\u304C\u884C\u3044\u307E\u3059\u3002"},"keyboard_mouse_emulation":{"title":"\u30AD\u30FC\u30DC\u30FC\u30C9\u3068\u30DE\u30A6\u30B9\u306E\u30A8\u30DF\u30E5\u30EC\u30FC\u30B7\u30E7\u30F3","description":"\u30AD\u30FC\u3001\u30AF\u30EA\u30C3\u30AF\u3001\u30B9\u30AF\u30ED\u30FC\u30EB\u3092\u30A8\u30DF\u30E5\u30EC\u30FC\u30C8\u3059\u308B\u306E\u3067\u3001\u30CF\u30FC\u30C9\u30A6\u30A7\u30A2\u306A\u3057\u3067\u30A2\u30D7\u30EA\u3092\u5236\u5FA1\u3067\u304D\u307E\u3059\u3002","longDescription":"\u30AD\u30FC\u30B9\u30C8\u30ED\u30FC\u30AF\u3001\u30DE\u30A6\u30B9\u306E\u52D5\u304D\u3001\u30AF\u30EA\u30C3\u30AF\u3001\u30B9\u30AF\u30ED\u30FC\u30EB\u30A4\u30D9\u30F3\u30C8\u3092\u5FC5\u8981\u306A\u5834\u6240\u306B\u9001\u4FE1\u3057\u307E\u3059\u3002\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3084\u30D8\u30C3\u30C9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u7D44\u307F\u5408\u308F\u305B\u308B\u3053\u3068\u3067\u3001\u5F93\u6765\u306E\u5165\u529B\u30C7\u30D0\u30A4\u30B9\u3092\u5B8C\u5168\u306B\u7F6E\u304D\u63DB\u3048\u305F\u308A\u3001\u5F37\u5316\u3057\u305F\u308A\u3059\u308B\u3053\u3068\u3082\u53EF\u80FD\u3067\u3059\u3002"},"profiles_personalization":{"title":"\u30D1\u30FC\u30BD\u30CA\u30E9\u30A4\u30BC\u30FC\u30B7\u30E7\u30F3","description":"\u3042\u306A\u305F\u306E\u597D\u307F\u3092\u8A18\u61B6\u3057\u3001\u4FDD\u5B58\u3055\u308C\u305F\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u9069\u5FDC\u3057\u307E\u3059\u3002","longDescription":"\u304A\u6C17\u306B\u5165\u308A\u306E\u30A2\u30D7\u30EA\u3001\u30B3\u30DE\u30F3\u30C9\u3001\u8A2D\u5B9A\u3092\u5E38\u306B\u8A18\u9332\u3057\u307E\u3059\u3002\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u81EA\u52D5\u307E\u305F\u306F\u624B\u52D5\u3067\u5207\u308A\u66FF\u3048\u308B\u3068\u3001\u5E38\u306B\u3042\u306A\u305F\u306E\u4F5C\u696D\u306B\u6700\u9069\u306A\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002"},"cross_device_connectivity":{"title":"\u30AF\u30ED\u30B9\u30C7\u30D0\u30A4\u30B9\u63A5\u7D9A","description":"\u643A\u5E2F\u96FB\u8A71\u3092\u4F7F\u3063\u3066\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u3092\u5236\u5FA1\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002","longDescription":"\u30E2\u30D0\u30A4\u30EB\u30C7\u30D0\u30A4\u30B9\u3092\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u306B\u63A5\u7D9A\u3059\u308C\u3070\u3001\u30B3\u30DE\u30F3\u30C9\u306E\u8D77\u52D5\u3001\u97F3\u58F0\u5165\u529B\u3001\u30CA\u30D3\u30B2\u30FC\u30B7\u30E7\u30F3\u304C\u7C21\u5358\u306B\u884C\u3048\u307E\u3059\u3002\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u3001\u30EA\u30E2\u30FC\u30C8\u30BB\u30C3\u30B7\u30E7\u30F3\u3001\u307E\u305F\u306F\u666E\u6BB5\u4F7F\u3044\u306B\u6700\u9069\u3067\u3059\u3002"},"quick_action_buttons":{"title":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3","description":"\u7D20\u65E9\u3044\u30A2\u30AF\u30B7\u30E7\u30F3\u306E\u305F\u3081\u306B\u30A2\u30D7\u30EA\u5BFE\u5FDC\u30DC\u30BF\u30F3\u3092\u7528\u610F\u3057\u307E\u3057\u305F\u3002","longDescription":"\u30A2\u30D7\u30EA\u306B\u5408\u308F\u305B\u3066\u72B6\u6CC1\u306B\u5FDC\u3058\u305F\u30DC\u30BF\u30F3\u3092\u914D\u7F6E\u3057\u307E\u3059\u3002\u4F1A\u8B70\u3078\u306E\u53C2\u52A0\u3001\u30E1\u30C3\u30BB\u30FC\u30B8\u306E\u9001\u4FE1\u3001\u30E1\u30FC\u30EB\u306E\u65B0\u898F\u4F5C\u6210\u306A\u3069\u3001\u8907\u96D1\u306A\u30BF\u30B9\u30AF\u3082\u30EF\u30F3\u30AF\u30EA\u30C3\u30AF\u3067\u5B9F\u884C\u3067\u304D\u307E\u3059\u3002"},"ai_app_awareness":{"title":"AI\u30A2\u30D7\u30EA\u8A8D\u8B58","description":"\u4F7F\u7528\u3057\u3066\u3044\u308B\u30A2\u30D7\u30EA\u306B\u5FDC\u3058\u3066\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8ABF\u6574\u3057\u307E\u3059\u3002","longDescription":"\u753B\u9762\u4E0A\u3067\u4F55\u304C\u30A2\u30AF\u30C6\u30A3\u30D6\u306B\u306A\u3063\u3066\u3044\u308B\u304B\u306B\u6CE8\u610F\u3092\u6255\u3044\u3001\u9069\u5207\u306A\u30BF\u30A4\u30DF\u30F3\u30B0\u3067\u9069\u5207\u306A\u64CD\u4F5C\u3092\u63D0\u4F9B\u3057\u307E\u3059\u3002\u7169\u96D1\u3055\u3084\u63A8\u6E2C\u306F\u4E00\u5207\u306A\u304F\u3001\u5FC5\u8981\u306A\u6642\u306B\u5FC5\u8981\u306A\u3082\u306E\u3060\u3051\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002\u3059\u3079\u3066\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u5B9F\u884C\u3055\u308C\u3001\u30AF\u30E9\u30A6\u30C9\u306B\u30C7\u30FC\u30BF\u3092\u9001\u4FE1\u3059\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002"},"ai_rewrite":{"title":"AI\u306B\u3088\u308B\u66F8\u304D\u63DB\u3048","description":"\u30C6\u30AD\u30B9\u30C8\u3092\u66F8\u304D\u76F4\u3057\u3066\u3001\u30C8\u30FC\u30F3\u3092\u6539\u5584\u3057\u305F\u308A\u3001\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3092\u66F4\u65B0\u3057\u305F\u308A\u3001\u8A73\u7D30\u3092\u62E1\u5F35\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002","longDescription":"\u4F5C\u696D\u4E2D\u306E\u30C6\u30AD\u30B9\u30C8\u3092\u305D\u306E\u5834\u3067\u7DE8\u96C6\u3057\u307E\u3059\u3002\u3088\u308A\u89AA\u3057\u307F\u3084\u3059\u304F\u3001\u3088\u308A\u30D5\u30A9\u30FC\u30DE\u30EB\u306B\u3001\u3088\u308A\u77ED\u304F\u3001\u3088\u308A\u9577\u304F\u3001\u3088\u308A\u8A73\u7D30\u306B\u306A\u3069\u3001\u304A\u5BA2\u69D8\u306E\u3054\u8981\u671B\u306B\u5408\u308F\u305B\u3066\u3001\u3088\u308A\u52B9\u679C\u7684\u306B\u4F1D\u3048\u307E\u3059\u3002"},"ai_translation":{"title":"AI\u7FFB\u8A33","description":"\u8A00\u8A9E\u9593\u3001\u3055\u3089\u306B\u306F\u30D7\u30ED\u30B0\u30E9\u30DF\u30F3\u30B0\u8A00\u8A9E\u9593\u306E\u7FFB\u8A33\u3082\u53EF\u80FD\u3067\u3059\u3002","longDescription":"\u30C6\u30AD\u30B9\u30C8\u3092\u5225\u306E\u97F3\u58F0\u8A00\u8A9E\u306B\u5909\u63DB\u3057\u305F\u308A\u3001\u30B3\u30FC\u30C9\u3092\u5225\u306E\u30D7\u30ED\u30B0\u30E9\u30DF\u30F3\u30B0\u8A00\u8A9E\u306B\u5909\u63DB\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002\u4F5C\u696D\u306F\u73FE\u5834\u3067\u884C\u3044\u307E\u3059\u306E\u3067\u3001\u73FE\u5728\u4F7F\u7528\u3057\u3066\u3044\u308B\u30A2\u30D7\u30EA\u3092\u96E2\u308C\u308B\u5FC5\u8981\u306F\u3042\u308A\u307E\u305B\u3093\u3002"},"head_mouse":{"title":"\u30D8\u30C3\u30C9\u30DE\u30A6\u30B9","description":"\u982D\u306E\u52D5\u304D\u306B\u5408\u308F\u305B\u3066\u30DE\u30A6\u30B9\u30AB\u30FC\u30BD\u30EB\u3092\u79FB\u52D5\u3055\u305B\u307E\u3059\u3002","longDescription":"\u982D\u306E\u52D5\u304D\u3092\u30B9\u30E0\u30FC\u30BA\u306B\u30AB\u30FC\u30BD\u30EB\u3078\u5909\u63DB\u3057\u307E\u3059\u3002\u30B0\u30E9\u30A4\u30C9\u6A5F\u80FD\u3084\u611F\u5EA6\u8ABF\u6574\u6A5F\u80FD\u306A\u3069\u306B\u3088\u308A\u3001\u6B63\u78BA\u3067\u5FEB\u9069\u306A\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u64CD\u4F5C\u3092\u5B9F\u73FE\u3057\u307E\u3059\u3002"},"head_joystick":{"title":"\u30D8\u30C3\u30C9\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF","description":"\u30B2\u30FC\u30E0\u3084\u30A2\u30D7\u30EA\u306E\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u3068\u3057\u3066\u982D\u3092\u4F7F\u3048\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002","longDescription":"\u3042\u306A\u305F\u306E\u982D\u306E\u52D5\u304D\u3092\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u306E\u8EF8\u306B\u30DE\u30C3\u30D4\u30F3\u30B0\u3059\u308B\u3053\u3068\u3067\u3001\u30CF\u30FC\u30C9\u30A6\u30A7\u30A2\u3092\u4F7F\u308F\u305A\u306B\u30B2\u30FC\u30E0\u3092\u30D7\u30EC\u30A4\u3057\u305F\u308A\u3001\u30AF\u30EA\u30A8\u30A4\u30C6\u30A3\u30D6\u306A\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3092\u64CD\u4F5C\u3057\u305F\u308A\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002\u3042\u306A\u305F\u306E\u81EA\u7136\u306A\u52D5\u304D\u3092\u3001\u79C1\u304C\u30A2\u30CA\u30ED\u30B0\u5165\u529B\u306B\u5909\u63DB\u3057\u307E\u3059\u3002"},"mcp_agent":{"title":"MCP\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8","description":"\u30E2\u30C7\u30EB\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u30D7\u30ED\u30C8\u30B3\u30EB (MCP) \u3092\u4ECB\u3057\u3066\u5916\u90E8 AI \u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u306B\u63A5\u7D9A\u3067\u304D\u307E\u3059\u3002","longDescription":"\u79C1\u306F\u30E2\u30C7\u30EB\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u30D7\u30ED\u30C8\u30B3\u30EB\u3092\u8A71\u3057\u3001\u4ED6\u306EAI\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u3084\u30C4\u30FC\u30EB\u3068\u9023\u643A\u3057\u3066\u4F5C\u696D\u3067\u304D\u307E\u3059\u3002\u3064\u307E\u308A\u3001\u30BF\u30B9\u30AF\u3092\u8ABF\u6574\u3057\u3001\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3092\u4EA4\u63DB\u3057\u3001\u5C02\u7528\u306E\u5916\u90E8\u30B7\u30B9\u30C6\u30E0\u3068\u9023\u643A\u3057\u3066\u80FD\u529B\u3092\u62E1\u5F35\u3067\u304D\u308B\u306E\u3067\u3059\u3002\u3057\u304B\u3082\u3001\u3059\u3079\u3066\u30E6\u30FC\u30B6\u30FC\u304C\u5236\u5FA1\u3067\u304D\u307E\u3059\u3002"},"byo_ai_integration":{"title":"\u72EC\u81EA\u306EAI\u3092\u5C0E\u5165\u3059\u308B","description":"\u65E2\u5B58\u306E AI \u3092\u3001\u72EC\u81EA\u306E AI \u30E2\u30C7\u30EB\u3084\u30B5\u30FC\u30D3\u30B9\u3067\u5F37\u5316\u3057\u3066\u3001\u4E00\u7DD2\u306B\u4F7F\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002","longDescription":"\u3059\u3067\u306B\u4FE1\u983C\u3067\u304D\u308BAI\u30B5\u30FC\u30D3\u30B9\u3001\u30E2\u30C7\u30EB\u3001\u307E\u305F\u306F\u30D7\u30ED\u30D0\u30A4\u30C0\u30FC\u3092\u304A\u6301\u3061\u306E\u5834\u5408\u306F\u3001\u305D\u308C\u3089\u3092\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306B\u7D71\u5408\u3067\u304D\u307E\u3059\u3002\u751F\u6210\u3001\u66F8\u304D\u63DB\u3048\u3001\u7FFB\u8A33\u306B\u4F7F\u7528\u3059\u308B\u30A8\u30F3\u30B8\u30F3\u306F\u3001\u30AF\u30E9\u30A6\u30C9\u3001\u30ED\u30FC\u30AB\u30EB\u3001\u30AB\u30B9\u30BF\u30E0\u306A\u3069\u3001\u67D4\u8EDF\u306B\u304A\u9078\u3073\u3044\u305F\u3060\u3051\u307E\u3059\u3002\u30AA\u30D5\u30E9\u30A4\u30F3\u306E\u5834\u5408\u3084\u30B5\u30FC\u30D3\u30B9\u304C\u5229\u7528\u3067\u304D\u306A\u3044\u5834\u5408\u306F\u3001\u7D44\u307F\u8FBC\u307F\u306E\u6A5F\u80FD\u306B\u30D5\u30A9\u30FC\u30EB\u30D0\u30C3\u30AF\u3067\u304D\u307E\u3059\u3002"},"workflows":{"title":"\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC","description":"\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u7E70\u308A\u8FD4\u3057\u53EF\u80FD\u306A\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306B\u9023\u7D50\u3059\u308B\u304A\u624B\u4F1D\u3044\u3092\u3057\u307E\u3059\u3002","longDescription":"\u3055\u307E\u3056\u307E\u306A\u5165\u529B\u3001\u30B3\u30DE\u30F3\u30C9\u3001\u51FA\u529B\u3092\u9023\u643A\u3055\u305B\u308B\u8907\u6570\u30B9\u30C6\u30C3\u30D7\u306E\u30D7\u30ED\u30BB\u30B9\u3092\u8A2D\u8A08\u30FB\u5B9F\u884C\u3067\u304D\u307E\u3059\u3002\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u4F7F\u3048\u3070\u3001\u5B9A\u578B\u7684\u306A\u30BF\u30B9\u30AF\u3092\u81EA\u52D5\u5316\u3057\u305F\u308A\u3001\u97F3\u58F0\u3084\u30B8\u30A7\u30B9\u30C1\u30E3\u30FC\u3067\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u308B\u8907\u96D1\u306A\u30A4\u30F3\u30BF\u30E9\u30AF\u30B7\u30E7\u30F3\u3092\u4F5C\u6210\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002\u9762\u5012\u306A\u4F5C\u696D\u306F\u79C1\u304C\u4EE3\u308F\u308A\u306B\u884C\u3044\u307E\u3059\u3002"},"showMore":"\u3082\u3063\u3068\u898B\u308B","showLess":"\u8868\u793A\u3092\u6E1B\u3089\u3059"},"listing":{"title":"\u30E6\u30FC\u30B9\u30B1\u30FC\u30B9","titleLong":"\u79C1\u304C\u3069\u306E\u3088\u3046\u306B\u304A\u624B\u4F1D\u3044\u3067\u304D\u308B\u304B\u3092\u3054\u89A7\u304F\u3060\u3055\u3044","recommended":"\u3042\u306A\u305F\u306B\u304A\u3059\u3059\u3081","exploreMore":"\u305D\u306E\u4ED6\u306E\u30E6\u30FC\u30B9\u30B1\u30FC\u30B9\u3092\u898B\u308B","description":"\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u5F37\u5316\u3059\u308B\u305F\u3081\u306B\u79C1\u304C\u3067\u304D\u308B\u3053\u3068\u3092\u3059\u3079\u3066\u3054\u7D39\u4ECB\u3057\u307E\u3059\u3002\u751F\u7523\u6027\u306E\u5411\u4E0A\u304B\u3089\u30AF\u30EA\u30A8\u30A4\u30C6\u30A3\u30D6\u306A\u30B5\u30DD\u30FC\u30C8\u307E\u3067\u3001\u304A\u5BA2\u69D8\u306E\u30CB\u30FC\u30BA\u306B\u5408\u308F\u305B\u305F\u6700\u9069\u306A\u30E6\u30FC\u30B9\u30B1\u30FC\u30B9\u3092\u898B\u3064\u3051\u3066\u304F\u3060\u3055\u3044\u3002","all":"\u5168\u3066","search":"\u30E6\u30FC\u30B9\u30B1\u30FC\u30B9\u3001\u30A2\u30D7\u30EA\u3001\u307E\u305F\u306F\u6A5F\u80FD\u3092\u691C\u7D22...","noResults":"\u7D50\u679C\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u691C\u7D22\u6761\u4EF6\u307E\u305F\u306F\u30D5\u30A3\u30EB\u30BF\u30FC\u3092\u8ABF\u6574\u3057\u3066\u304F\u3060\u3055\u3044\u3002","emptyAction":"\u30AA\u30F3\u30E9\u30A4\u30F3\u3067\u3055\u3089\u306B\u898B\u308B"},"examples":{"universalAppControl":{"title":"\u30E6\u30CB\u30D0\u30FC\u30B5\u30EB\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","description":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30B9\u30DE\u30FC\u30C8\u30AA\u30FC\u30C8\u30E1\u30FC\u30B7\u30E7\u30F3\u3067\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u4E0A\u306E\u3042\u3089\u3086\u308B\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u5236\u5FA1\u3067\u304D\u307E\u3059","descriptionLong":"\u5F37\u529B\u306A\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u81EA\u52D5\u5316\u6A5F\u80FD\u3067\u3001\u3042\u3089\u3086\u308B\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u81EA\u5728\u306B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u304D\u307E\u3059\u3002\u30E6\u30CB\u30D0\u30FC\u30B5\u30EB\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u30B7\u30B9\u30C6\u30E0\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u306E\u4F5C\u696D\u65B9\u6CD5\u3092\u5B66\u7FD2\u3057\u3001\u30CB\u30FC\u30BA\u306B\u5408\u308F\u305B\u3066\u9069\u5FDC\u3059\u308B\u3053\u3068\u3067\u3001\u8907\u96D1\u306A\u30BF\u30B9\u30AF\u3092\u30B7\u30F3\u30D7\u30EB\u306B\u3001\u5B9A\u578B\u7684\u306A\u64CD\u4F5C\u3092\u77AC\u6642\u306B\u5B9F\u884C\u3057\u307E\u3059\u3002\u751F\u7523\u6027\u5411\u4E0A\u30B9\u30A4\u30FC\u30C8\u306E\u7BA1\u7406\u304B\u3089\u30E1\u30C7\u30A3\u30A2\u3084\u30B2\u30FC\u30E0\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306E\u64CD\u4F5C\u307E\u3067\u3001\u3053\u306E\u6A5F\u80FD\u306F\u30C7\u30B8\u30BF\u30EB\u74B0\u5883\u5168\u4F53\u3067\u5229\u7528\u3067\u304D\u307E\u3059\u3002"},"handsFreeComputerControl":{"title":"\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u5236\u5FA1","description":"\u30A2\u30AF\u30BB\u30B7\u30D3\u30EA\u30C6\u30A3\u306E\u305F\u3081\u306B\u3001\u982D\u306E\u52D5\u304D\u3001\u97F3\u58F0\u3001\u8996\u7DDA\u8FFD\u8DE1\u3092\u4F7F\u7528\u3057\u305F\u5B8C\u5168\u306A\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u5236\u5FA1","descriptionLong":"\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u30B7\u30B9\u30C6\u30E0\u3067\u3001\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u306E\u30A2\u30AF\u30BB\u30B7\u30D3\u30EA\u30C6\u30A3\u3092\u65B0\u305F\u306A\u6B21\u5143\u3078\u3068\u5F15\u304D\u4E0A\u3052\u307E\u3059\u3002\u9AD8\u5EA6\u306A\u8996\u7DDA\u8FFD\u8DE1\u3001\u9AD8\u7CBE\u5EA6\u306A\u982D\u90E8\u52D5\u4F5C\u691C\u51FA\u3001\u305D\u3057\u3066\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3092\u7D44\u307F\u5408\u308F\u305B\u308B\u3053\u3068\u3067\u3001\u8AB0\u3067\u3082\u624B\u3092\u4F7F\u308F\u305A\u306B\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u3092\u5B8C\u5168\u306B\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002\u904B\u52D5\u969C\u5BB3\u306E\u3042\u308B\u65B9\u3001\u30DE\u30EB\u30C1\u30BF\u30B9\u30AF\u3092\u884C\u3046\u65B9\u3001\u305D\u3057\u3066\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u3092\u65B0\u3057\u3044\u65B9\u6CD5\u3067\u4F7F\u3044\u305F\u3044\u65B9\u306B\u6700\u9069\u3067\u3059\u3002"},"replyToSocialMediaPosts":{"title":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3067\u30BD\u30FC\u30B7\u30E3\u30EB\u30E1\u30C7\u30A3\u30A2\u3078\u306E\u6295\u7A3F\u3068\u8FD4\u4FE1\u3092\u9AD8\u901F\u5316","description":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3057\u3066\u3001\u3042\u3089\u3086\u308B\u30BD\u30FC\u30B7\u30E3\u30EB \u30E1\u30C7\u30A3\u30A2\u306E\u6295\u7A3F\u306B\u8FD4\u4FE1\u3057\u3001\u3059\u3070\u3084\u304F\u5FDC\u7B54\u3067\u304D\u307E\u3059\u3002","descriptionLong":"Cephable\u306E\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u6A5F\u80FD\u3092\u4F7F\u3048\u3070\u3001\u97F3\u58F0\u5165\u529B\u3067\u30BD\u30FC\u30B7\u30E3\u30EB\u30E1\u30C7\u30A3\u30A2\u3078\u306E\u6295\u7A3F\u3084\u30B3\u30E1\u30F3\u30C8\u304C\u3055\u3089\u306B\u30B9\u30D4\u30FC\u30C7\u30A3\u30FC\u306B\u306A\u308A\u307E\u3059\u3002\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u306F\u3042\u3089\u3086\u308B\u30C6\u30AD\u30B9\u30C8\u30DC\u30C3\u30AF\u30B9\u3084\u6295\u7A3F\u6B04\u3067\u4F7F\u7528\u3067\u304D\u308B\u305F\u3081\u3001\u30BD\u30FC\u30B7\u30E3\u30EB\u30E1\u30C7\u30A3\u30A2\u306B\u6642\u9593\u3092\u53D6\u3089\u308C\u308B\u3053\u3068\u306A\u304F\u3001\u30A2\u30AF\u30C6\u30A3\u30D6\u306B\u904E\u3054\u3059\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"},"clinicalNoteTaking":{"title":"\u81E8\u5E8A\u533B\u306E\u305F\u3081\u306EHIPAA\u6E96\u62E0\u306E\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3068\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8","description":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u6A5F\u80FD\u3092\u4F7F\u3063\u3066\u3001\u30BB\u30C3\u30B7\u30E7\u30F3\u306E\u5408\u9593\u306B\u81E8\u5E8A\u30E1\u30E2\u3092\u53D6\u308A\u3001\u6642\u9593\u3092\u7BC0\u7D04\u3057\u307E\u3057\u3087\u3046\u3002\u30E1\u30E2\u306FSOAP\u5F62\u5F0F\u3067\u81EA\u52D5\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3055\u308C\u307E\u3059\u3002","descriptionLong":"HIPAA\u6E96\u62E0\u306E\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3092\u304A\u63A2\u3057\u3067\u3059\u304B\uFF1FCephable\u306F\u3001\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u81EA\u52D5\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u6A5F\u80FD\u306B\u3088\u308A\u3001\u81E8\u5E8A\u533B\u304C\u60A3\u8005\u306E\u8A18\u9332\u3092\u8FC5\u901F\u306B\u8A18\u9332\u3067\u304D\u308B\u3088\u3046\u652F\u63F4\u3057\u307E\u3059\u3002SOAP\u30E1\u30E2\u3001\u9032\u6357\u30EC\u30DD\u30FC\u30C8\u3001\u30ED\u30B0\u306A\u3069\u3001\u3059\u3079\u3066\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002","upgrade":{"description":"\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u3068\u3001\u81EA\u52D5\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3068\u53CD\u5FA9\u51E6\u7406\u3092\u5B9F\u884C\u3059\u308B HIPAA \u6E96\u62E0\u306E\u30AA\u30D5\u30E9\u30A4\u30F3 \u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8 \u30BF\u30B9\u30AF\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u3059\u3002"}},"vibeCoding":{"title":"\u601D\u8003\u304B\u3089\u30B3\u30FC\u30C9\u3078: \u958B\u767A\u8005\u3068Vibe Coder\u306E\u305F\u3081\u306E\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3","description":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3068 AI \u30C6\u30AD\u30B9\u30C8\u751F\u6210\u6A5F\u80FD\u3092\u5099\u3048\u305F Vibe Code \u3067\u3001\u5B9A\u578B\u30B3\u30FC\u30C9\u3068\u30D7\u30ED\u30C8\u30BF\u30A4\u30D7\u3092\u3088\u308A\u901F\u304F\u8A18\u8FF0\u3067\u304D\u307E\u3059\u3002","descriptionLong":"Cephable Dictation\u306F\u3001\u958B\u767A\u8005\u304C\u601D\u8003\u304B\u3089\u30B3\u30FC\u30C9\u3078\u3068\u3088\u308A\u901F\u304F\u79FB\u884C\u3059\u308B\u306E\u306B\u5F79\u7ACB\u3061\u307E\u3059\u3002\u3053\u306E\u30C7\u30E2\u3067\u306F\u3001Vercel V0\u3001VS Code\u306EGitHub Copilot\u3001Base 44\u3001Lovable\u306A\u3069\u306E\u30C4\u30FC\u30EB\u5185\u3067\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u3063\u3066\u30B3\u30F3\u30DD\u30FC\u30CD\u30F3\u30C8\u3084\u30C0\u30C3\u30B7\u30E5\u30DC\u30FC\u30C9\u306A\u3069\u3092\u751F\u6210\u3059\u308B\u65B9\u6CD5\u3092\u7D39\u4ECB\u3057\u307E\u3059\u3002\u30A2\u30A4\u30C7\u30A2\u3092\u97F3\u58F0\u3067\u4F1D\u3048\u3001\u30B3\u30FC\u30C9\u3067\u6D17\u7DF4\u3055\u305B\u307E\u3057\u3087\u3046\u3002","upgrade":{"description":"\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u3068\u3001\u30A2\u30D7\u30EA\u5185\u30B3\u30FC\u30C9\u306E\u66F8\u304D\u63DB\u3048\u3001\u751F\u6210\u3001\u7FFB\u8A33\u306E\u305F\u3081\u306E\u30AA\u30D5\u30E9\u30A4\u30F3 \u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8 \u30BF\u30B9\u30AF\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u3059\u3002"}},"controllingBackgroundMusic":{"title":"\u30E1\u30C7\u30A3\u30A2\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB: \u4F5C\u696D\u306E\u6D41\u308C\u3092\u4E2D\u65AD\u3059\u308B\u3053\u3068\u306A\u304F\u3001\u97F3\u697D\u3001\u30D3\u30C7\u30AA\u306A\u3069\u3092\u7BA1\u7406\u3067\u304D\u307E\u3059","description":"\u73FE\u5728\u306E\u30BF\u30B9\u30AF\u306B\u96C6\u4E2D\u3057\u306A\u304C\u3089\u3001\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3057\u3066\u30D0\u30C3\u30AF\u30B0\u30E9\u30A6\u30F3\u30C9 \u30DF\u30E5\u30FC\u30B8\u30C3\u30AF\u3092\u7BA1\u7406\u3057\u307E\u3059\u3002","descriptionLong":"\u30BB\u30D5\u30A1\u30D6\u30EB\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u3048\u3070\u3001Spotify\u306E\u518D\u751F\u3001\u4E00\u6642\u505C\u6B62\u3001\u30B9\u30AD\u30C3\u30D7\u3001\u97F3\u91CF\u8ABF\u7BC0\u304C\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u7C21\u5358\u306B\u884C\u3048\u307E\u3059\u3002\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u3068\u3059\u3050\u306B\u4F7F\u3048\u308B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3001Apple Music\u3001YouTube\u3001Netflix\u306A\u3069\u3001200\u4EE5\u4E0A\u306E\u30A2\u30D7\u30EA\u3067\u3082\u4F7F\u3048\u307E\u3059\u3002"},"editingVideos":{"title":"\u97F3\u58F0\u3092\u4F7F\u3063\u305F\u30D3\u30C7\u30AA\u7DE8\u96C6","description":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3057\u3066\u3001\u30CA\u30D3\u30B2\u30FC\u30C8\u3001\u30AB\u30C3\u30C8\u3001\u7DE8\u96C6\u3092\u9AD8\u901F\u5316\u3057\u3001\u30D3\u30C7\u30AA\u7DE8\u96C6\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u6539\u5584\u3057\u307E\u3059\u3002","descriptionLong":"\u30AF\u30EA\u30C3\u30AF\u3067\u306F\u306A\u304F\u3001\u30B9\u30C8\u30FC\u30EA\u30FC\u306B\u96C6\u4E2D\u3057\u307E\u3057\u3087\u3046\u3002\u30BB\u30D5\u30A1\u30E9\u30D6\u30EB\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u3001Clipchamp\u3001Adobe\u3001iMovie\u3001DaVinci Resolve\u306A\u3069\u3001\u4F7F\u3044\u6163\u308C\u305F\u30C4\u30FC\u30EB\u3067\u306E\u30D3\u30C7\u30AA\u7DE8\u96C6\u3092\u52B9\u7387\u5316\u3002\u3088\u308A\u30B9\u30D4\u30FC\u30C7\u30A3\u30FC\u306B\u3001\u3088\u308A\u5C11\u306A\u3044\u624B\u9806\u3067\u7DE8\u96C6\u3067\u304D\u307E\u3059\u3002"},"inboxTriage":{"title":"AI\u30E1\u30FC\u30EB\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\uFF1A\u81EA\u52D5\u5316\u3001\u4E0B\u66F8\u304D\u3001\u8FD4\u4FE1\u3092\u9AD8\u901F\u5316","description":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30C7\u30D0\u30A4\u30B9\u4E0A\u306E AI \u30C6\u30AD\u30B9\u30C8\u751F\u6210\u3092\u4F7F\u7528\u3057\u3066\u53D7\u4FE1\u30C8\u30EC\u30A4\u3092\u7BA1\u7406\u3057\u3001\u30E1\u30FC\u30EB\u306E\u9078\u5225\u3001\u4F5C\u6210\u3001\u7DE8\u96C6\u3092\u884C\u3044\u307E\u3059\u3002","descriptionLong":"\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u306A\u30AA\u30F3\u30C7\u30D0\u30A4\u30B9AI\u3067\u30E1\u30FC\u30EB\u51E6\u7406\u3092\u30B9\u30D4\u30FC\u30C9\u30A2\u30C3\u30D7\u3002Cephable\u306F\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u3001\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u3092\u7D44\u307F\u5408\u308F\u305B\u3001\u53D7\u4FE1\u30C8\u30EC\u30A4\u306E\u7BA1\u7406\u3092\u3088\u308A\u8FC5\u901F\u304B\u3064\u7C21\u5358\u306B\u3057\u307E\u3059\u3002Outlook\u3001Gmail\u306A\u3069\u3067\u3001\u30E1\u30FC\u30EB\u306E\u524A\u9664\u3001\u8FD4\u4FE1\u306E\u4E0B\u66F8\u304D\u3001\u30AF\u30EA\u30A8\u30A4\u30C6\u30A3\u30D6\u306A\u8FD4\u4FE1\u306E\u4F5C\u6210\u3092\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u884C\u3048\u307E\u3059\u3002","upgrade":{"description":"\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u3068\u3001\u81EA\u52D5\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3001\u30B3\u30F3\u30C6\u30F3\u30C4\u751F\u6210\u3001\u7FFB\u8A33\u306A\u3069\u3092\u884C\u3046\u30AA\u30D5\u30E9\u30A4\u30F3 \u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8 \u30BF\u30B9\u30AF\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u3059\u3002"}},"summarizingReports":{"title":"\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u306A\u30C7\u30D0\u30A4\u30B9\u5185 AI \u3067\u6A5F\u5BC6\u30EC\u30DD\u30FC\u30C8\u3092\u8981\u7D04","description":"AI \u30C6\u30AD\u30B9\u30C8\u751F\u6210\u3092\u4F7F\u7528\u3057\u3066\u3001\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u3092\u4FDD\u3061\u306A\u304C\u3089\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u9577\u3044\u30EC\u30DD\u30FC\u30C8\u3092\u30C1\u30FC\u30E0\u306B\u8981\u7D04\u3057\u307E\u3059\u3002","descriptionLong":"\u30C7\u30D0\u30A4\u30B9\u4E0A\u306EAI\u3092\u6D3B\u7528\u3057\u3066\u3001\u9577\u6587\u306E\u30EC\u30DD\u30FC\u30C8\u3092\u5206\u304B\u308A\u3084\u3059\u3044\u30C1\u30FC\u30E0\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u306B\u5909\u63DB\u3057\u307E\u3059\u3002Cephable\u306F\u91CD\u8981\u306A\u30DD\u30A4\u30F3\u30C8\u3068\u6570\u5024\u3092\u62BD\u51FA\u3057\u3001\u7C21\u6F54\u306A\u8981\u7D04\u3092\u751F\u6210\u3057\u3066\u30C1\u30FC\u30E0\u3068\u76F4\u63A5\u5171\u6709\u3067\u304D\u307E\u3059\u3002\u3059\u3079\u3066\u306E\u51E6\u7406\u306F\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u884C\u308F\u308C\u308B\u305F\u3081\u3001\u6A5F\u5BC6\u30C7\u30FC\u30BF\u306F\u5B89\u5168\u306B\u4FDD\u305F\u308C\u307E\u3059\u3002"},"handsFreeMeeting":{"title":"\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u4F1A\u8B70\u306E\u75B2\u52B4\u3092\u8EFD\u6E1B","description":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3001\u30AF\u30A4\u30C3\u30AF \u30A2\u30AF\u30B7\u30E7\u30F3 \u30DC\u30BF\u30F3\u3001\u30B9\u30DE\u30FC\u30C8 \u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3057\u3066\u30D3\u30C7\u30AA\u4F1A\u8B70\u3092\u5236\u5FA1\u3057\u307E\u3059\u3002","descriptionLong":"\u30E1\u30CB\u30E5\u30FC\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3053\u3068\u306A\u304F\u3001\u4F1A\u8B70\u306B\u96C6\u4E2D\u3067\u304D\u307E\u3059\u3002Cephable \u306F\u3001Microsoft Teams\u3001Zoom\u3001Google Meet \u306A\u3069\u306E\u30C7\u30D0\u30A4\u30B9\u306B\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u3092\u63D0\u4F9B\u3057\u307E\u3059\u3002\u30DF\u30E5\u30FC\u30C8/\u30DF\u30E5\u30FC\u30C8\u89E3\u9664\u3001\u30D3\u30C7\u30AA\u306E\u30AA\u30F3/\u30AA\u30D5\u3001\u30C1\u30E3\u30C3\u30C8\u30E1\u30C3\u30BB\u30FC\u30B8\u306E\u9001\u4FE1\u3001\u6319\u624B\u3001\u4F1A\u8B70\u30A6\u30A3\u30F3\u30C9\u30A6\u306E\u64CD\u4F5C\u306A\u3069\u3001\u3059\u3050\u306B\u4F7F\u3048\u308B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306B\u5408\u308F\u305B\u3066\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u3001\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002"},"spreadsheetReviews":{"title":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068 AI \u81EA\u52D5\u5316\u3067\u30B9\u30D7\u30EC\u30C3\u30C9\u30B7\u30FC\u30C8\u3067\u306E\u4F5C\u696D\u3092\u30B9\u30D4\u30FC\u30C9\u30A2\u30C3\u30D7","description":"\u30CA\u30D3\u30B2\u30FC\u30B7\u30E7\u30F3\u3001\u66F8\u5F0F\u8A2D\u5B9A\u3001\u30D5\u30A3\u30EB\u30BF\u30EA\u30F3\u30B0\u3001\u7DE8\u96C6\u7528\u306E\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3057\u3066\u3001\u5927\u898F\u6A21\u306A\u30B9\u30D7\u30EC\u30C3\u30C9\u30B7\u30FC\u30C8\u3092\u3059\u3070\u3084\u304F\u78BA\u8A8D\u304A\u3088\u3073\u7DE8\u96C6\u3057\u307E\u3059\u3002","descriptionLong":"Cephable\u306F\u3001Excel\u3001Google\u30B9\u30D7\u30EC\u30C3\u30C9\u30B7\u30FC\u30C8\u3001\u305D\u306E\u4ED6\u306E\u30B9\u30D7\u30EC\u30C3\u30C9\u30B7\u30FC\u30C8\u30C4\u30FC\u30EB\u306B\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u3092\u63D0\u4F9B\u3057\u307E\u3059\u3002\u30EC\u30D3\u30E5\u30FC\u3001\u7DE8\u96C6\u3001\u30B3\u30E1\u30F3\u30C8\u306E\u8FFD\u52A0\u3001\u30DE\u30AF\u30ED\u3084\u30B7\u30E7\u30FC\u30C8\u30AB\u30C3\u30C8\u306E\u8D77\u52D5\u3001\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306B\u5408\u308F\u305B\u305F\u30B3\u30DE\u30F3\u30C9\u306E\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u306A\u3069\u3001\u69D8\u3005\u306A\u6A5F\u80FD\u304C\u5229\u7528\u53EF\u80FD\u3067\u3059\u3002\u6570\u767E\u7A2E\u985E\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3001\u3059\u3050\u306B\u4F7F\u3048\u308B\u3082\u306E\u3082\u3042\u308C\u3070\u3001\u8A2D\u5B9A\u306B\u5408\u308F\u305B\u3066\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3067\u304D\u308B\u3082\u306E\u3082\u3042\u308A\u307E\u3059\u3002"},"socialMediaWriting":{"title":"\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u306A\u30C7\u30D0\u30A4\u30B9\u5185AI\u306B\u3088\u308B\u30B3\u30F3\u30C6\u30F3\u30C4\u4F5C\u6210\u3068\u30EA\u30B5\u30FC\u30C1","description":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068 AI \u30C6\u30AD\u30B9\u30C8\u751F\u6210\u3092\u4F7F\u7528\u3057\u3066\u3001\u9B45\u529B\u7684\u306A\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F5C\u6210\u3059\u308B\u305F\u3081\u306E\u30BD\u30FC\u30B7\u30E3\u30EB \u30E1\u30C7\u30A3\u30A2\u6295\u7A3F\u306E\u4E0B\u66F8\u304D\u3068\u66F8\u304D\u8FBC\u307F\u3092\u884C\u3044\u307E\u3059\u3002","descriptionLong":"Cephable\u306E\u30C7\u30D0\u30A4\u30B9\u5185AI\u3067\u5B89\u5168\u306B\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F5C\u6210\u3002\u30AF\u30E9\u30A6\u30C9\u306F\u4E0D\u8981\u3067\u3059\u3002\u304A\u6C17\u306B\u5165\u308A\u306E\u30C4\u30FC\u30EB\u5185\u3067\u3001\u30BD\u30FC\u30B7\u30E3\u30EB\u30E1\u30C7\u30A3\u30A2\u306E\u6295\u7A3F\u3001\u30E1\u30FC\u30EB\u3001\u30AD\u30E3\u30C3\u30C1\u30D5\u30EC\u30FC\u30BA\u3001\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u77AC\u6642\u306B\u751F\u6210\u30FB\u66F8\u304D\u63DB\u3048\u3067\u304D\u307E\u3059\u3002\u3059\u3079\u3066\u30ED\u30FC\u30AB\u30EB\u3067\u5B9F\u884C\u3055\u308C\u308B\u305F\u3081\u3001\u6A5F\u5BC6\u6027\u306E\u9AD8\u3044\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u306F\u78BA\u4FDD\u3055\u308C\u3001\u3069\u3053\u304B\u3089\u3067\u3082\u4F5C\u696D\u3067\u304D\u307E\u3059\u3002"},"fpsGamePlay":{"title":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067FPS\u30B2\u30FC\u30E0\u3092\u30D7\u30EC\u30A4","description":"\u79FB\u52D5\u3001\u7167\u6E96\u3001\u5C04\u6483\u3092\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u64CD\u4F5C\u3057\u3001\u4E00\u4EBA\u79F0\u30B7\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0 \u30B2\u30FC\u30E0\u3092\u30D7\u30EC\u30A4\u3057\u3066\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u307E\u3059\u3002","descriptionLong":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u3001\u4E00\u4EBA\u79F0\u8996\u70B9\u30B7\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0\u30B2\u30FC\u30E0\u3092\u65B0\u305F\u306A\u65B9\u6CD5\u3067\u30D7\u30EC\u30A4\u3057\u307E\u3057\u3087\u3046\u3002\u97F3\u58F0\u64CD\u4F5C\u3067\u79FB\u52D5\u3001\u7167\u6E96\u3001\u5C04\u6483\u3092\u64CD\u4F5C\u3057\u3001\u3088\u308A\u6CA1\u5165\u611F\u306E\u3042\u308B\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u306E\u30B2\u30FC\u30E0\u4F53\u9A13\u3092\u5B9F\u73FE\u3057\u307E\u3059\u3002"},"customizingGameControls":{"title":"RPG\u30B2\u30FC\u30E0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA","description":"\u30ED\u30FC\u30EB \u30D7\u30EC\u30A4 \u30B2\u30FC\u30E0\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u3066\u3001\u30A2\u30AF\u30BB\u30B7\u30D3\u30EA\u30C6\u30A3\u3068\u30B2\u30FC\u30E0 \u30D7\u30EC\u30A4\u3092\u5411\u4E0A\u3055\u305B\u307E\u3059\u3002","descriptionLong":"\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u53EF\u80FD\u306A\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u3001\u30A2\u30AF\u30BB\u30B7\u30D3\u30EA\u30C6\u30A3\u3068\u30B2\u30FC\u30E0\u30D7\u30EC\u30A4\u3092\u5411\u4E0A\u3055\u305B\u3001\u81EA\u5206\u3060\u3051\u306E\u30B2\u30FC\u30E0\u4F53\u9A13\u3092\u3002\u597D\u307F\u3084\u30D7\u30EC\u30A4\u30B9\u30BF\u30A4\u30EB\u306B\u5408\u308F\u305B\u3066\u8A2D\u5B9A\u3092\u8ABF\u6574\u3057\u3001\u5FEB\u9069\u3067\u697D\u3057\u3044\u30B2\u30FC\u30E0\u30BB\u30C3\u30B7\u30E7\u30F3\u3092\u5B9F\u73FE\u3057\u307E\u3057\u3087\u3046\u3002"},"webBrowsing":{"title":"Cephable\u3067\u30CF\u30F3\u30BA\u30D5\u30EA\u30FCWeb\u30D6\u30E9\u30A6\u30B8\u30F3\u30B0 | \u65C5\u884C\u306E\u8A08\u753B\u3001\u30AA\u30F3\u30E9\u30A4\u30F3\u30B7\u30E7\u30C3\u30D4\u30F3\u30B0\u306A\u3069","description":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3057\u3066\u3001\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067 Web \u3092\u95B2\u89A7\u3057\u3001\u30CA\u30D3\u30B2\u30FC\u30C8\u3001\u30B9\u30AF\u30ED\u30FC\u30EB\u3001\u30D5\u30A9\u30FC\u30E0\u3078\u306E\u5165\u529B\u3092\u884C\u3046\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","descriptionLong":"\u5165\u529B\u306A\u3057\u3067\u691C\u7D22\u3001\u30B7\u30E7\u30C3\u30D4\u30F3\u30B0\u3001\u30D7\u30E9\u30F3\u30CB\u30F3\u30B0\u3002Cephable\u306E\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3001\u3069\u306E\u30D6\u30E9\u30A6\u30B6\u3067\u3082\u4F7F\u3048\u307E\u3059\u3002\u822A\u7A7A\u5238\u306E\u4E88\u7D04\u3001\u30AA\u30F3\u30E9\u30A4\u30F3\u30B7\u30E7\u30C3\u30D4\u30F3\u30B0\u3001\u6B21\u306E\u65C5\u884C\u306E\u30EA\u30B5\u30FC\u30C1\u306A\u3069\u3001\u3042\u3089\u3086\u308B\u5834\u9762\u3067\u6D3B\u8E8D\u3057\u307E\u3059\u3002"},"documentCode":{"title":"\u30C7\u30D0\u30A4\u30B9\u4E0A\u306E AI \u30C6\u30AD\u30B9\u30C8\u751F\u6210\u306B\u3088\u308B\u9AD8\u901F\u3067\u5B89\u5168\u306A\u30B3\u30FC\u30C9\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8","description":"Cephable \u306E\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8 \u30EA\u30E9\u30A4\u30C8\u3092\u4F7F\u7528\u3057\u3066\u3001\u540C\u3058\u30A2\u30D7\u30EA\u5185\u3067\u6A5F\u5BC6\u30C7\u30FC\u30BF\u3092\u30AF\u30E9\u30A6\u30C9\u306B\u9001\u4FE1\u305B\u305A\u306B\u30B3\u30FC\u30C9\u3092\u6587\u66F8\u5316\u3057\u307E\u3059\u3002","descriptionLong":"Cephable\u306E\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30EA\u30E9\u30A4\u30C8\u6A5F\u80FD\u306F\u3001\u6A5F\u5BC6\u30C7\u30FC\u30BF\u3092\u30AF\u30E9\u30A6\u30C9\u306B\u9001\u4FE1\u3059\u308B\u3053\u3068\u306A\u304F\u3001\u30B3\u30FC\u30C9\u304B\u3089\u76F4\u63A5\u958B\u767A\u8005\u5411\u3051\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002README\u30D5\u30A1\u30A4\u30EB\u3001Markdown\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3001API\u30EA\u30D5\u30A1\u30EC\u30F3\u30B9\u3092\u3059\u3079\u3066\u30A2\u30D7\u30EA\u5185\u3067\u8FC5\u901F\u304B\u3064\u5B89\u5168\u306B\u751F\u6210\u3057\u307E\u3059\u3002"},"generateCode":{"title":"\u30C7\u30D0\u30A4\u30B9\u4E0A\u306E AI \u30C6\u30AD\u30B9\u30C8\u751F\u6210\u306B\u3088\u308B\u9AD8\u901F\u3067\u5B89\u5168\u306A\u30B3\u30FC\u30C9\u751F\u6210","description":"AI \u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8 \u30BF\u30B9\u30AF\u3092\u4F7F\u7528\u3057\u3066\u3001\u30C1\u30B1\u30C3\u30C8\u8981\u4EF6\u304B\u3089\u30B3\u30FC\u30C9 \u30B9\u30CB\u30DA\u30C3\u30C8\u306E\u30D7\u30ED\u30C8\u30BF\u30A4\u30D7\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002","descriptionLong":"Cephable\u3092\u4F7F\u3048\u3070\u3001\u30C1\u30B1\u30C3\u30C8\u306E\u8981\u4EF6\u3092\u3042\u3089\u3086\u308B\u8A00\u8A9E\u3067\u52D5\u4F5C\u3059\u308B\u30B3\u30FC\u30C9\u306B\u5909\u63DB\u3067\u304D\u307E\u3059\u3002\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\u3092\u4F7F\u3048\u3070\u3001\u30B3\u30FC\u30C9\u306E\u30B9\u30AD\u30E3\u30D5\u30A9\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u3001\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u751F\u6210\u3001\u30E6\u30CB\u30C3\u30C8\u30C6\u30B9\u30C8\u306E\u8FFD\u52A0\u3092\u81EA\u52D5\u5316\u3067\u304D\u307E\u3059\u3002\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3092\u5931\u3046\u3053\u3068\u306A\u304F\u3001\u8907\u6570\u306E\u30D7\u30ED\u30B0\u30E9\u30DF\u30F3\u30B0\u8A00\u8A9E\u3084\u30A2\u30D7\u30EA\u3067\u4F5C\u696D\u3067\u304D\u307E\u3059\u3002"},"editingImages":{"title":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3067\u30AF\u30EA\u30A8\u30A4\u30C6\u30A3\u30D6\u30A2\u30D7\u30EA\u306E\u7DE8\u96C6\u3092\u9AD8\u901F\u5316","description":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068 AI \u30C6\u30AD\u30B9\u30C8\u751F\u6210\u3092\u4F7F\u7528\u3057\u3066\u753B\u50CF\u3092\u4F5C\u6210\u304A\u3088\u3073\u7DE8\u96C6\u3057\u3001\u3059\u3070\u3084\u304F\u8ABF\u6574\u3057\u3066\u30B3\u30F3\u30BB\u30D7\u30C8\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002","descriptionLong":"\u97F3\u58F0\u5236\u5FA1\u306B\u3088\u308B\u753B\u50CF\u4F5C\u6210\u30FB\u7DE8\u96C6\u3067\u3001\u3042\u306A\u305F\u306E\u30D3\u30B8\u30E5\u30A2\u30EB\u30A2\u30A4\u30C7\u30A2\u3092\u73FE\u5B9F\u306B\u3002AI\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u6A5F\u80FD\u3092\u4F7F\u3048\u3070\u3001\u8907\u96D1\u306A\u30E1\u30CB\u30E5\u30FC\u3092\u64CD\u4F5C\u3059\u308B\u3053\u3068\u306A\u304F\u3001\u7D20\u65E9\u304F\u8ABF\u6574\u3057\u305F\u308A\u3001\u30B3\u30F3\u30BB\u30D7\u30C8\u3092\u751F\u6210\u3057\u305F\u308A\u3001\u753B\u50CF\u306E\u9B45\u529B\u3092\u9AD8\u3081\u305F\u308A\u3067\u304D\u307E\u3059\u3002"},"requirementDocsFromMeeting":{"title":"\u30AA\u30F3\u30C7\u30D0\u30A4\u30B9 AI \u3092\u6D3B\u7528\u3057\u3001\u30E1\u30E2\u304B\u3089\u88FD\u54C1\u8981\u4EF6\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u307E\u3067\u3092\u6570\u5206\u3067\u4F5C\u6210","description":"\u751F\u306E\u4F1A\u8B70\u8A18\u9332\u3092\u6570\u5206\u3067\u69CB\u9020\u5316\u3055\u308C\u305F\u88FD\u54C1\u8981\u4EF6\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306B\u5909\u63DB\u3059\u308B\u3053\u3068\u3067\u3001\u6642\u9593\u3092\u7BC0\u7D04\u3067\u304D\u307E\u3059\u3002","descriptionLong":"Cephable\u306F\u3001\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\u3092\u6D3B\u7528\u3057\u3066\u3001\u751F\u306E\u4F1A\u8B70\u8A18\u9332\u3092\u308F\u305A\u304B\u6570\u5206\u3067\u69CB\u9020\u5316\u3055\u308C\u305F\u88FD\u54C1\u8981\u4EF6\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306B\u5909\u63DB\u3057\u307E\u3059\u3002\u88FD\u54C1\u3001\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0\u3001\u30E6\u30FC\u30B6\u30FC\u30CB\u30FC\u30BA\u3092\u8FC5\u901F\u306B\u628A\u63E1\u3057\u3001\u30C7\u30D0\u30A4\u30B9\u4E0A\u306EAI\u306B\u3088\u3063\u3066\u6A5F\u5BC6\u6027\u306E\u9AD8\u3044\u8B70\u8AD6\u3092\u975E\u516C\u958B\u306B\u4FDD\u3061\u307E\u3059\u3002\u7D50\u679C\u3092\u65B0\u3057\u3044\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3068\u3057\u3066\u5373\u5EA7\u306B\u4FDD\u5B58\u3067\u304D\u307E\u3059\u3002"},"gamingVoiceControls":{"title":"WoW \u306E\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB | \u30E1\u30CB\u30E5\u30FC\u3001PvP\u3001\u30C0\u30F3\u30B8\u30E7\u30F3\u30D5\u30A1\u30A4\u30F3\u30C0\u30FC\u306E\u30AF\u30A4\u30C3\u30AF\u30CA\u30D3\u30B2\u30FC\u30B7\u30E7\u30F3","description":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3057\u3066\u30B2\u30FC\u30E0\u30D7\u30EC\u30A4\u3092\u5236\u5FA1\u3057\u3001\u30E1\u30CB\u30E5\u30FC\u3092\u79FB\u52D5\u3057\u305F\u308A\u3001PvP \u30D0\u30C8\u30EB\u3092\u958B\u59CB\u3057\u305F\u308A\u3001\u30C0\u30F3\u30B8\u30E7\u30F3\u3092\u898B\u3064\u3051\u305F\u308A\u3057\u307E\u3059\u3002","descriptionLong":"\u97F3\u58F0\u64CD\u4F5C\u306B\u3088\u308B\u64CD\u4F5C\u3067\u3001\u30B2\u30FC\u30E0\u4F53\u9A13\u3092\u3055\u3089\u306B\u5145\u5B9F\u3055\u305B\u307E\u3057\u3087\u3046\u3002\u30B7\u30F3\u30D7\u30EB\u306A\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3067\u30E1\u30CB\u30E5\u30FC\u306E\u64CD\u4F5C\u3001PvP\u30D0\u30C8\u30EB\u306E\u958B\u59CB\u3001\u30C0\u30F3\u30B8\u30E7\u30F3\u306E\u63A2\u7D22\u306A\u3069\u304C\u53EF\u80FD\u306B\u306A\u308A\u3001\u30B2\u30FC\u30E0\u30D7\u30EC\u30A4\u306B\u96C6\u4E2D\u3057\u306A\u304C\u3089\u3082\u3001\u64CD\u4F5C\u6027\u3092\u7DAD\u6301\u3067\u304D\u307E\u3059\u3002"},"headMouseMovement":{"title":"\u30D8\u30C3\u30C9\u30DE\u30A6\u30B9\u3092\u4F7F\u3063\u305F\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u30B2\u30FC\u30DF\u30F3\u30B0\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7","description":"\u982D\u306E\u52D5\u304D\u3067\u30DE\u30A6\u30B9 \u30AB\u30FC\u30BD\u30EB\u3092\u5236\u5FA1\u3057\u3001\u6B63\u78BA\u306A\u30CA\u30D3\u30B2\u30FC\u30B7\u30E7\u30F3\u3068\u30AF\u30EA\u30C3\u30AF\u3092\u5B9F\u73FE\u3057\u307E\u3059\u3002","descriptionLong":"\u30D8\u30C3\u30C9\u30DE\u30A6\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u30B2\u30FC\u30E0\u3092\u5B9F\u73FE\u3002\u982D\u3092\u50BE\u3051\u305F\u308A\u56DE\u3057\u305F\u308A\u3057\u3066\u30AB\u30FC\u30BD\u30EB\u3092\u52D5\u304B\u3057\u3001\u901F\u5EA6\u3068\u611F\u5EA6\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u3066\u3001\u5F93\u6765\u306E\u30DE\u30A6\u30B9\u3092\u4F7F\u308F\u305A\u306B\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002"},"noteTakingAndDocumentation":{"title":"\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u306A\u30C7\u30D0\u30A4\u30B9\u5185 AI \u3092\u4F7F\u7528\u3057\u305F\u30E1\u30E2\u4F5C\u6210\u3068\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u751F\u6210","description":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068 AI \u30C6\u30AD\u30B9\u30C8\u751F\u6210\u3092\u4F7F\u7528\u3057\u3066\u30E1\u30E2\u3092\u53D6\u308A\u3001\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u751F\u6210\u3057\u3001\u52B9\u7387\u7684\u306B\u66F8\u304D\u8FBC\u307F\u307E\u3059\u3002","descriptionLong":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3068AI\u3092\u6D3B\u7528\u3057\u305F\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u751F\u6210\u3067\u3001\u30E1\u30E2\u4F5C\u6210\u3092\u52B9\u7387\u5316\u3002\u4E0B\u66F8\u304D\u3001\u30A2\u30A6\u30C8\u30E9\u30A4\u30F3\u3001\u305D\u3057\u3066\u6D17\u7DF4\u3055\u308C\u305F\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u7D20\u65E9\u304F\u4F5C\u6210\u3067\u304D\u308B\u306E\u3067\u3001\u66F8\u5F0F\u8A2D\u5B9A\u306B\u7169\u308F\u3055\u308C\u308B\u3053\u3068\u306A\u304F\u30A2\u30A4\u30C7\u30A2\u306B\u96C6\u4E2D\u3067\u304D\u307E\u3059\u3002\u3059\u3079\u3066\u306E\u51E6\u7406\u306F\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u884C\u308F\u308C\u308B\u305F\u3081\u3001\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3068\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u304C\u78BA\u4FDD\u3055\u308C\u307E\u3059\u3002","upgrade":{"description":"\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u3068\u3001\u66F8\u5F0F\u8A2D\u5B9A\u3001\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u53CD\u5FA9\u51E6\u7406\u306A\u3069\u3092\u884C\u3046\u30AA\u30D5\u30E9\u30A4\u30F3 \u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8 \u30BF\u30B9\u30AF\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u3059\u3002"}},"presentationControls":{"title":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u306B\u3088\u308B\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","description":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3057\u3066\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u5236\u5FA1\u3057\u3001\u30B9\u30E9\u30A4\u30C9\u9593\u3092\u79FB\u52D5\u3057\u305F\u308A\u3001\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u958B\u59CB/\u505C\u6B62\u3057\u305F\u308A\u3001\u30DD\u30A4\u30F3\u30C8\u3092\u5F37\u8ABF\u8868\u793A\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002","descriptionLong":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u3063\u3066\u3001\u81EA\u4FE1\u3092\u6301\u3063\u3066\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u884C\u3046\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u30B9\u30E9\u30A4\u30C9\u306E\u79FB\u52D5\u3001\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u306E\u958B\u59CB\u3068\u505C\u6B62\u3001\u91CD\u8981\u306A\u30DD\u30A4\u30F3\u30C8\u306E\u5F37\u8ABF\u8868\u793A\u306A\u3069\u3001\u3059\u3079\u3066\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u306B\u89E6\u308C\u308B\u3053\u3068\u306A\u304F\u884C\u3048\u307E\u3059\u3002"},"designingFliers":{"title":"\u30AF\u30EA\u30A8\u30A4\u30C6\u30A3\u30D6\u30A2\u30D7\u30EA\u3067\u30C7\u30B6\u30A4\u30F3\u3059\u308B","description":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30B9\u30DE\u30FC\u30C8\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3057\u3066\u30C7\u30B6\u30A4\u30F3\u3092\u4F5C\u6210\u304A\u3088\u3073\u7DE8\u96C6\u3057\u3001\u53CD\u5FA9\u4F5C\u696D\u3092\u9AD8\u901F\u5316\u3057\u307E\u3059\u3002","descriptionLong":"\u97F3\u58F0\u64CD\u4F5C\u306E\u30C7\u30B6\u30A4\u30F3\u30C4\u30FC\u30EB\u3067\u3001\u30AF\u30EA\u30A8\u30A4\u30C6\u30A3\u30D6\u306A\u30D3\u30B8\u30E7\u30F3\u3092\u73FE\u5B9F\u306B\u3002\u8907\u96D1\u306A\u30E1\u30CB\u30E5\u30FC\u306B\u8FF7\u3046\u3053\u3068\u306A\u304F\u3001\u30C7\u30B6\u30A4\u30F3\u3092\u30B9\u30E0\u30FC\u30BA\u306B\u64CD\u4F5C\u3001\u7DE8\u96C6\u3001\u4FEE\u6B63\u3067\u304D\u308B\u306E\u3067\u3001\u30AF\u30EA\u30C3\u30AF\u64CD\u4F5C\u3067\u306F\u306A\u304F\u3001\u5275\u9020\u6027\u305D\u306E\u3082\u306E\u306B\u96C6\u4E2D\u3067\u304D\u307E\u3059\u3002"},"motionDesign":{"title":"\u30E2\u30FC\u30B7\u30E7\u30F3\u30C7\u30B6\u30A4\u30F3\u3068\u30A2\u30CB\u30E1\u30FC\u30B7\u30E7\u30F3\u306E\u305F\u3081\u306E\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9","description":"\u76F4\u611F\u7684\u306A\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3057\u3066\u30B7\u30FC\u30F3\u3092\u30A2\u30CB\u30E1\u30FC\u30C8\u3057\u3001\u30AD\u30FC\u30D5\u30EC\u30FC\u30E0\u3092\u5236\u5FA1\u3057\u3001\u30B7\u30FC\u30E0\u30EC\u30B9\u306A\u30E2\u30FC\u30B7\u30E7\u30F3 \u30C7\u30B6\u30A4\u30F3\u3092\u5B9F\u73FE\u3057\u307E\u3059\u3002","descriptionLong":"\u97F3\u58F0\u99C6\u52D5\u578B\u30A2\u30CB\u30E1\u30FC\u30B7\u30E7\u30F3\u30C4\u30FC\u30EB\u3067\u3001\u30A2\u30A4\u30C7\u30A2\u306B\u52D5\u304D\u3092\u52A0\u3048\u307E\u3057\u3087\u3046\u3002\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u3001\u30AD\u30FC\u30D5\u30EC\u30FC\u30E0\u3001\u30A8\u30D5\u30A7\u30AF\u30C8\u3092\u81EA\u7136\u8A00\u8A9E\u3067\u7C21\u5358\u306B\u64CD\u4F5C\u3067\u304D\u308B\u306E\u3067\u3001\u8907\u96D1\u306A\u30A4\u30F3\u30BF\u30FC\u30D5\u30A7\u30FC\u30B9\u306B\u7169\u308F\u3055\u308C\u308B\u3053\u3068\u306A\u304F\u3001\u30B9\u30C8\u30FC\u30EA\u30FC\u30C6\u30EA\u30F3\u30B0\u3068\u8996\u899A\u7684\u306A\u30EA\u30BA\u30E0\u306B\u96C6\u4E2D\u3067\u304D\u307E\u3059\u3002"}}}');


const $1e580fbd50c9e2d3$var$isString = (obj)=>typeof obj === 'string';
const $1e580fbd50c9e2d3$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $1e580fbd50c9e2d3$var$makeString = (object)=>{
    if (object == null) return '';
    return '' + object;
};
const $1e580fbd50c9e2d3$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $1e580fbd50c9e2d3$var$lastOfPathSeparatorRegExp = /###/g;
const $1e580fbd50c9e2d3$var$cleanKey = (key)=>key && key.indexOf('###') > -1 ? key.replace($1e580fbd50c9e2d3$var$lastOfPathSeparatorRegExp, '.') : key;
const $1e580fbd50c9e2d3$var$canNotTraverseDeeper = (object)=>!object || $1e580fbd50c9e2d3$var$isString(object);
const $1e580fbd50c9e2d3$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$1e580fbd50c9e2d3$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($1e580fbd50c9e2d3$var$canNotTraverseDeeper(object)) return {};
        const key = $1e580fbd50c9e2d3$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($1e580fbd50c9e2d3$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $1e580fbd50c9e2d3$var$cleanKey(stack[stackIndex])
    };
};
const $1e580fbd50c9e2d3$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $1e580fbd50c9e2d3$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $1e580fbd50c9e2d3$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $1e580fbd50c9e2d3$var$getLastOfPath(object, p, Object);
        if (last?.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $1e580fbd50c9e2d3$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $1e580fbd50c9e2d3$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $1e580fbd50c9e2d3$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $1e580fbd50c9e2d3$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
    return obj[k];
};
const $1e580fbd50c9e2d3$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $1e580fbd50c9e2d3$var$getPath(data, key);
    if (value !== undefined) return value;
    return $1e580fbd50c9e2d3$var$getPath(defaultData, key);
};
const $1e580fbd50c9e2d3$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if ($1e580fbd50c9e2d3$var$isString(target[prop]) || target[prop] instanceof String || $1e580fbd50c9e2d3$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $1e580fbd50c9e2d3$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $1e580fbd50c9e2d3$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var $1e580fbd50c9e2d3$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $1e580fbd50c9e2d3$var$escape = (data)=>{
    if ($1e580fbd50c9e2d3$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$1e580fbd50c9e2d3$var$_entityMap[s]);
    return data;
};
class $1e580fbd50c9e2d3$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $1e580fbd50c9e2d3$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $1e580fbd50c9e2d3$var$looksLikeObjectPathRegExpCache = new $1e580fbd50c9e2d3$var$RegExpCache(20);
const $1e580fbd50c9e2d3$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $1e580fbd50c9e2d3$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $1e580fbd50c9e2d3$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $1e580fbd50c9e2d3$var$deepFind = (obj, path, keySeparator = '.')=>{
    if (!obj) return undefined;
    if (obj[path]) {
        if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
        return obj[path];
    }
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $1e580fbd50c9e2d3$var$getCleanedCode = (code)=>code?.replace(/_/g, '-');
const $1e580fbd50c9e2d3$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        console?.[type]?.apply?.(console, args);
    }
};
class $1e580fbd50c9e2d3$var$Logger {
    constructor(concreteLogger, options = {}){
        this.init(concreteLogger, options);
    }
    init(concreteLogger, options = {}) {
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $1e580fbd50c9e2d3$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log(...args) {
        return this.forward(args, 'log', '', true);
    }
    warn(...args) {
        return this.forward(args, 'warn', '', true);
    }
    error(...args) {
        return this.forward(args, 'error', '');
    }
    deprecate(...args) {
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if ($1e580fbd50c9e2d3$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $1e580fbd50c9e2d3$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $1e580fbd50c9e2d3$var$Logger(this.logger, options);
    }
}
var $1e580fbd50c9e2d3$var$baseLogger = new $1e580fbd50c9e2d3$var$Logger();
class $1e580fbd50c9e2d3$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event, ...args) {
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
class $1e580fbd50c9e2d3$var$ResourceStore extends $1e580fbd50c9e2d3$var$EventEmitter {
    constructor(data, options = {
        ns: [
            'translation'
        ],
        defaultNS: 'translation'
    }){
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key, options = {}) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($1e580fbd50c9e2d3$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $1e580fbd50c9e2d3$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$1e580fbd50c9e2d3$var$isString(key)) return result;
        return $1e580fbd50c9e2d3$var$deepFind(this.data?.[lng]?.[ns], key, keySeparator);
    }
    addResource(lng, ns, key, value, options = {
        silent: false
    }) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $1e580fbd50c9e2d3$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources, options = {
        silent: false
    }) {
        for(const m in resources)if ($1e580fbd50c9e2d3$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite, options = {
        silent: false,
        skipCopy: false
    }) {
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $1e580fbd50c9e2d3$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $1e580fbd50c9e2d3$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $1e580fbd50c9e2d3$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $1e580fbd50c9e2d3$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            value = this.processors[processor]?.process(value, key, options, translator) ?? value;
        });
        return value;
    }
};
const $1e580fbd50c9e2d3$var$PATH_KEY = Symbol('i18next/PATH_KEY');
function $1e580fbd50c9e2d3$var$createProxy() {
    const state = [];
    const handler = Object.create(null);
    let proxy;
    handler.get = (target, key)=>{
        proxy?.revoke?.();
        if (key === $1e580fbd50c9e2d3$var$PATH_KEY) return state;
        state.push(key);
        proxy = Proxy.revocable(target, handler);
        return proxy.proxy;
    };
    return Proxy.revocable(Object.create(null), handler).proxy;
}
function $1e580fbd50c9e2d3$export$ec2cccc18ab4c2ae(selector, opts) {
    const { [$1e580fbd50c9e2d3$var$PATH_KEY]: path } = selector($1e580fbd50c9e2d3$var$createProxy());
    const keySeparator = opts?.keySeparator ?? '.';
    const nsSeparator = opts?.nsSeparator ?? ':';
    if (path.length > 1 && nsSeparator) {
        const ns = opts?.ns;
        const namespaces = ns ? Array.isArray(ns) ? ns : [
            ns
        ] : [];
        if (namespaces.includes(path[0])) return `${path[0]}${nsSeparator}${path.slice(1).join(keySeparator)}`;
    }
    return path.join(keySeparator);
}
const $1e580fbd50c9e2d3$var$checkedLoadedFor = {};
const $1e580fbd50c9e2d3$var$shouldHandleAsObject = (res)=>!$1e580fbd50c9e2d3$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class $1e580fbd50c9e2d3$var$Translator extends $1e580fbd50c9e2d3$var$EventEmitter {
    constructor(services, options = {}){
        super();
        $1e580fbd50c9e2d3$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create('translator');
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key, o = {
        interpolation: {}
    }) {
        const opt = {
            ...o
        };
        if (key == null) return false;
        const resolved = this.resolve(key, opt);
        if (resolved?.res === undefined) return false;
        const isObject = $1e580fbd50c9e2d3$var$shouldHandleAsObject(resolved.res);
        if (opt.returnObjects === false && isObject) return false;
        return true;
    }
    extractFromKey(key, opt) {
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        let namespaces = opt.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !opt.keySeparator && !this.options.userDefinedNsSeparator && !opt.nsSeparator && !$1e580fbd50c9e2d3$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $1e580fbd50c9e2d3$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $1e580fbd50c9e2d3$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, o, lastKey) {
        let opt = typeof o === 'object' ? {
            ...o
        } : o;
        if (typeof opt !== 'object' && this.options.overloadTranslationOptionHandler) opt = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof opt === 'object') opt = {
            ...opt
        };
        if (!opt) opt = {};
        if (keys == null) return '';
        if (typeof keys === 'function') keys = $1e580fbd50c9e2d3$export$ec2cccc18ab4c2ae(keys, {
            ...this.options,
            ...opt
        });
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        keys = keys.map((k)=>typeof k === 'function' ? $1e580fbd50c9e2d3$export$ec2cccc18ab4c2ae(k, {
                ...this.options,
                ...opt
            }) : String(k));
        const returnDetails = opt.returnDetails !== undefined ? opt.returnDetails : this.options.returnDetails;
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], opt);
        const namespace = namespaces[namespaces.length - 1];
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const lng = opt.lng || this.language;
        const appendNamespaceToCIMode = opt.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng?.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(opt)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(opt)
            };
            return key;
        }
        const resolved = this.resolve(keys, opt);
        let res = resolved?.res;
        const resUsedKey = resolved?.usedKey || key;
        const resExactUsedKey = resolved?.exactUsedKey || key;
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = opt.joinArrays !== undefined ? opt.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const needsPluralHandling = opt.count !== undefined && !$1e580fbd50c9e2d3$var$isString(opt.count);
        const hasDefaultValue = $1e580fbd50c9e2d3$var$Translator.hasDefaultValue(opt);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, opt) : '';
        const defaultValueSuffixOrdinalFallback = opt.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, {
            ordinal: false
        }) : '';
        const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
        const defaultValue = needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] || opt[`defaultValue${defaultValueSuffix}`] || opt[`defaultValue${defaultValueSuffixOrdinalFallback}`] || opt.defaultValue;
        let resForObjHndl = res;
        if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
        const handleAsObject = $1e580fbd50c9e2d3$var$shouldHandleAsObject(resForObjHndl);
        const resType = Object.prototype.toString.apply(resForObjHndl);
        if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && noObject.indexOf(resType) < 0 && !($1e580fbd50c9e2d3$var$isString(joinArrays) && Array.isArray(resForObjHndl))) {
            if (!opt.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, {
                    ...opt,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(opt);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(resForObjHndl);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in resForObjHndl)if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, {
                        ...opt,
                        defaultValue: $1e580fbd50c9e2d3$var$shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                        joinArrays: false,
                        ns: namespaces
                    });
                    else copy[m] = this.translate(deepKey, {
                        ...opt,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $1e580fbd50c9e2d3$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, opt, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = opt.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...opt,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, opt.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(opt.lng || this.language);
                else lngs.push(opt.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, opt);
                    else if (this.backendConnector?.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, opt);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, opt);
                        if (needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, opt[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, opt, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}${nsSeparator}${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}${nsSeparator}${key}` : key, usedDefault ? res : undefined, opt);
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(opt);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, opt, resolved, lastKey) {
        if (this.i18nFormat?.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...opt
        }, opt.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!opt.skipInterpolation) {
            if (opt.interpolation) this.interpolator.init({
                ...opt,
                interpolation: {
                    ...this.options.interpolation,
                    ...opt.interpolation
                }
            });
            const skipOnVariables = $1e580fbd50c9e2d3$var$isString(res) && (opt?.interpolation?.skipOnVariables !== undefined ? opt.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = opt.replace && !$1e580fbd50c9e2d3$var$isString(opt.replace) ? opt.replace : opt;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, opt.lng || this.language || resolved.usedLng, opt);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) opt.nest = false;
            }
            if (!opt.lng && resolved && resolved.res) opt.lng = this.language || resolved.usedLng;
            if (opt.nest !== false) res = this.interpolator.nest(res, (...args)=>{
                if (lastKey?.[0] === args[0] && !opt.context) {
                    this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return this.translate(...args, key);
            }, opt);
            if (opt.interpolation) this.interpolator.reset();
        }
        const postProcess = opt.postProcess || this.options.postProcess;
        const postProcessorNames = $1e580fbd50c9e2d3$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res != null && postProcessorNames?.length && opt.applyPostProcessor !== false) res = $1e580fbd50c9e2d3$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(opt)
            },
            ...opt
        } : opt, this);
        return res;
    }
    resolve(keys, opt = {}) {
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($1e580fbd50c9e2d3$var$isString(keys)) keys = [
            keys
        ];
        if (Array.isArray(keys)) keys = keys.map((k)=>typeof k === 'function' ? $1e580fbd50c9e2d3$export$ec2cccc18ab4c2ae(k, {
                ...this.options,
                ...opt
            }) : k);
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, opt);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = opt.count !== undefined && !$1e580fbd50c9e2d3$var$isString(opt.count);
            const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
            const needsContextHandling = opt.context !== undefined && ($1e580fbd50c9e2d3$var$isString(opt.context) || typeof opt.context === 'number') && opt.context !== '';
            const codes = opt.lngs ? opt.lngs : this.languageUtils.toResolveHierarchy(opt.lng || this.language, opt.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$1e580fbd50c9e2d3$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(usedNS)) {
                    $1e580fbd50c9e2d3$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat?.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, opt);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, opt.count, opt);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            finalKeys.push(key + pluralSuffix);
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator || '_'}${opt.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                finalKeys.push(contextKey + pluralSuffix);
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, opt);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key, options = {}) {
        if (this.i18nFormat?.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails(options = {}) {
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$1e580fbd50c9e2d3$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
class $1e580fbd50c9e2d3$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = $1e580fbd50c9e2d3$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $1e580fbd50c9e2d3$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($1e580fbd50c9e2d3$var$isString(code) && code.indexOf('-') > -1) {
            let formattedCode;
            try {
                formattedCode = Intl.getCanonicalLocales(code)[0];
            } catch (e) {}
            if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
            if (formattedCode) return formattedCode;
            if (this.options.lowerCaseLng) return code.toLowerCase();
            return code;
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngScOnly = this.getScriptPartFromCode(code);
            if (this.isSupportedCode(lngScOnly)) return found = lngScOnly;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($1e580fbd50c9e2d3$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes((fallbackCode === false ? [] : fallbackCode) || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($1e580fbd50c9e2d3$var$isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($1e580fbd50c9e2d3$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
const $1e580fbd50c9e2d3$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $1e580fbd50c9e2d3$var$dummyRule = {
    select: (count)=>count === 1 ? 'one' : 'other',
    resolvedOptions: ()=>({
            pluralCategories: [
                'one',
                'other'
            ]
        })
};
class $1e580fbd50c9e2d3$var$PluralResolver {
    constructor(languageUtils, options = {}){
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code, options = {}) {
        const cleanedCode = $1e580fbd50c9e2d3$var$getCleanedCode(code === 'dev' ? 'en' : code);
        const type = options.ordinal ? 'ordinal' : 'cardinal';
        const cacheKey = JSON.stringify({
            cleanedCode: cleanedCode,
            type: type
        });
        if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
        let rule;
        try {
            rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
        } catch (err) {
            if (typeof Intl === 'undefined') {
                this.logger.error('No Intl support, please use an Intl polyfill!');
                return $1e580fbd50c9e2d3$var$dummyRule;
            }
            if (!code.match(/-|_/)) return $1e580fbd50c9e2d3$var$dummyRule;
            const lngPart = this.languageUtils.getLanguagePartFromCode(code);
            rule = this.getRule(lngPart, options);
        }
        this.pluralRulesCache[cacheKey] = rule;
        return rule;
    }
    needsPlural(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        return rule?.resolvedOptions().pluralCategories.length > 1;
    }
    getPluralFormsOfKey(code, key, options = {}) {
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        if (!rule) return [];
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$1e580fbd50c9e2d3$var$suffixesOrder[pluralCategory1] - $1e580fbd50c9e2d3$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    getSuffix(code, count, options = {}) {
        const rule = this.getRule(code, options);
        if (rule) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        this.logger.warn(`no plural rule found for: ${code}`);
        return this.getSuffix('dev', count, options);
    }
}
const $1e580fbd50c9e2d3$var$deepFindWithDefaults = (data, defaultData, key, keySeparator = '.', ignoreJSONStructure = true)=>{
    let path = $1e580fbd50c9e2d3$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $1e580fbd50c9e2d3$var$isString(key)) {
        path = $1e580fbd50c9e2d3$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $1e580fbd50c9e2d3$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $1e580fbd50c9e2d3$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $1e580fbd50c9e2d3$var$Interpolator {
    constructor(options = {}){
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options?.interpolation?.format || ((value)=>value);
        this.init(options);
    }
    init(options = {}) {
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $1e580fbd50c9e2d3$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $1e580fbd50c9e2d3$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $1e580fbd50c9e2d3$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
        this.nestingPrefix = nestingPrefix ? $1e580fbd50c9e2d3$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $1e580fbd50c9e2d3$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $1e580fbd50c9e2d3$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $1e580fbd50c9e2d3$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp?.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $1e580fbd50c9e2d3$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($1e580fbd50c9e2d3$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options?.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$1e580fbd50c9e2d3$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $1e580fbd50c9e2d3$var$regexSafe(this.escape(val)) : $1e580fbd50c9e2d3$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $1e580fbd50c9e2d3$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$1e580fbd50c9e2d3$var$isString(value) && !this.useRawValueToEscape) value = $1e580fbd50c9e2d3$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc, options = {}) {
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${$1e580fbd50c9e2d3$var$regexEscape(sep)}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if ((matchedSingleQuotes?.length ?? 0) % 2 === 0 && !matchedDoubleQuotes || (matchedDoubleQuotes?.length ?? 0) % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !$1e580fbd50c9e2d3$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            const keyEndIndex = /{.*}/.test(match[1]) ? match[1].lastIndexOf('}') + 1 : match[1].indexOf(this.formatSeparator);
            if (keyEndIndex !== -1) {
                formatters = match[1].slice(keyEndIndex).split(this.formatSeparator).map((elem)=>elem.trim()).filter(Boolean);
                match[1] = match[1].slice(0, keyEndIndex);
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$1e580fbd50c9e2d3$var$isString(value)) return value;
            if (!$1e580fbd50c9e2d3$var$isString(value)) value = $1e580fbd50c9e2d3$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (formatters.length) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $1e580fbd50c9e2d3$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $1e580fbd50c9e2d3$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (v, l, o)=>{
        let optForCache = o;
        if (o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey]) optForCache = {
            ...optForCache,
            [o.interpolationkey]: undefined
        };
        const key = l + JSON.stringify(optForCache);
        let frm = cache[key];
        if (!frm) {
            frm = fn($1e580fbd50c9e2d3$var$getCleanedCode(l), o);
            cache[key] = frm;
        }
        return frm(v);
    };
};
const $1e580fbd50c9e2d3$var$createNonCachedFormatter = (fn)=>(v, l, o)=>fn($1e580fbd50c9e2d3$var$getCleanedCode(l), o)(v);
class $1e580fbd50c9e2d3$var$Formatter {
    constructor(options = {}){
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create('formatter');
        this.options = options;
        this.init(options);
    }
    init(services, options = {
        interpolation: {}
    }) {
        this.formatSeparator = options.interpolation.formatSeparator || ',';
        const cf = options.cacheInBuiltFormats ? $1e580fbd50c9e2d3$var$createCachedFormatter : $1e580fbd50c9e2d3$var$createNonCachedFormatter;
        this.formats = {
            number: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: cf((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: cf((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: cf((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $1e580fbd50c9e2d3$var$createCachedFormatter(fc);
    }
    format(value, format, lng, options = {}) {
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find((f)=>f.indexOf(')') > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(')') > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $1e580fbd50c9e2d3$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options?.formatParams?.[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $1e580fbd50c9e2d3$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $1e580fbd50c9e2d3$var$Connector extends $1e580fbd50c9e2d3$var$EventEmitter {
    constructor(backend, store, services, options = {}){
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        this.backend?.init?.(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $1e580fbd50c9e2d3$var$pushPath(q.loaded, [
                lng
            ], ns);
            $1e580fbd50c9e2d3$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName, tried = 0, wait = this.retryTimeout, callback) {
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces, options = {}, callback) {
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($1e580fbd50c9e2d3$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($1e580fbd50c9e2d3$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name, prefix = '') {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate, options = {}, clb = ()=>{}) {
        if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend?.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $1e580fbd50c9e2d3$var$get = ()=>({
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($1e580fbd50c9e2d3$var$isString(args[1])) ret.defaultValue = args[1];
            if ($1e580fbd50c9e2d3$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        },
        cacheInBuiltFormats: true
    });
const $1e580fbd50c9e2d3$var$transformOptions = (options)=>{
    if ($1e580fbd50c9e2d3$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($1e580fbd50c9e2d3$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($1e580fbd50c9e2d3$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs?.indexOf?.('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    if (typeof options.initImmediate === 'boolean') options.initAsync = options.initImmediate;
    return options;
};
const $1e580fbd50c9e2d3$var$noop = ()=>{};
const $1e580fbd50c9e2d3$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
const $1e580fbd50c9e2d3$var$SUPPORT_NOTICE_KEY = '__i18next_supportNoticeShown';
const $1e580fbd50c9e2d3$var$getSupportNoticeShown = ()=>typeof globalThis !== 'undefined' && !!globalThis[$1e580fbd50c9e2d3$var$SUPPORT_NOTICE_KEY];
const $1e580fbd50c9e2d3$var$setSupportNoticeShown = ()=>{
    if (typeof globalThis !== 'undefined') globalThis[$1e580fbd50c9e2d3$var$SUPPORT_NOTICE_KEY] = true;
};
const $1e580fbd50c9e2d3$var$usesLocize = (inst)=>{
    if (inst?.modules?.backend?.name?.indexOf('Locize') > 0) return true;
    if (inst?.modules?.backend?.constructor?.name?.indexOf('Locize') > 0) return true;
    if (inst?.options?.backend?.backends) {
        if (inst.options.backend.backends.some((b)=>b?.name?.indexOf('Locize') > 0 || b?.constructor?.name?.indexOf('Locize') > 0)) return true;
    }
    if (inst?.options?.backend?.projectId) return true;
    if (inst?.options?.backend?.backendOptions) {
        if (inst.options.backend.backendOptions.some((b)=>b?.projectId)) return true;
    }
    return false;
};
class $1e580fbd50c9e2d3$var$I18n extends $1e580fbd50c9e2d3$var$EventEmitter {
    constructor(options = {}, callback){
        super();
        this.options = $1e580fbd50c9e2d3$var$transformOptions(options);
        this.services = {};
        this.logger = $1e580fbd50c9e2d3$var$baseLogger;
        this.modules = {
            external: []
        };
        $1e580fbd50c9e2d3$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initAsync) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init(options = {}, callback) {
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (options.defaultNS == null && options.ns) {
            if ($1e580fbd50c9e2d3$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $1e580fbd50c9e2d3$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$1e580fbd50c9e2d3$var$transformOptions(options)
        };
        this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        if (typeof this.options.overloadTranslationOptionHandler !== 'function') this.options.overloadTranslationOptionHandler = defOpts.overloadTranslationOptionHandler;
        if (this.options.showSupportNotice !== false && !$1e580fbd50c9e2d3$var$usesLocize(this) && !$1e580fbd50c9e2d3$var$getSupportNoticeShown()) {
            if (typeof console !== 'undefined' && typeof console.info !== 'undefined') console.info("\uD83C\uDF10 i18next is made possible by our own product, Locize \u2014 consider powering your project with managed localization (AI, CDN, integrations): https://locize.com \uD83D\uDC99");
            $1e580fbd50c9e2d3$var$setSupportNoticeShown();
        }
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $1e580fbd50c9e2d3$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $1e580fbd50c9e2d3$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else formatter = $1e580fbd50c9e2d3$var$Formatter;
            const lu = new $1e580fbd50c9e2d3$var$LanguageUtil(this.options);
            this.store = new $1e580fbd50c9e2d3$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $1e580fbd50c9e2d3$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $1e580fbd50c9e2d3$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            const usingLegacyFormatFunction = this.options.interpolation.format && this.options.interpolation.format !== defOpts.interpolation.format;
            if (usingLegacyFormatFunction) this.logger.deprecate(`init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting`);
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                if (s.formatter.init) s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $1e580fbd50c9e2d3$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $1e580fbd50c9e2d3$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $1e580fbd50c9e2d3$var$Translator(this.services, this.options);
            this.translator.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $1e580fbd50c9e2d3$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = (...args)=>this.store[fcName](...args);
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = (...args)=>{
                this.store[fcName](...args);
                return this;
            };
        });
        const deferred = $1e580fbd50c9e2d3$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initAsync) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language, callback = $1e580fbd50c9e2d3$var$noop) {
        let usedCallback = callback;
        const usedLng = $1e580fbd50c9e2d3$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng?.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            this.options.preload?.forEach?.((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $1e580fbd50c9e2d3$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $1e580fbd50c9e2d3$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $1e580fbd50c9e2d3$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
        if (!this.resolvedLanguage && this.languages.indexOf(l) < 0 && this.store.hasLanguageSomeTranslations(l)) {
            this.resolvedLanguage = l;
            this.languages.unshift(l);
        }
    }
    changeLanguage(lng, callback) {
        this.isLanguageChangingTo = lng;
        const deferred = $1e580fbd50c9e2d3$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                if (this.isLanguageChangingTo === lng) {
                    setLngProps(l);
                    this.translator.changeLanguage(l);
                    this.isLanguageChangingTo = undefined;
                    this.emit('languageChanged', l);
                    this.logger.log('languageChanged', l);
                }
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve((...args)=>this.t(...args));
            if (callback) callback(err, (...args)=>this.t(...args));
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const fl = $1e580fbd50c9e2d3$var$isString(lngs) ? lngs : lngs && lngs[0];
            const l = this.store.hasLanguageSomeTranslations(fl) ? fl : this.services.languageUtils.getBestMatchFromCodes($1e580fbd50c9e2d3$var$isString(lngs) ? [
                lngs
            ] : lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                this.services.languageDetector?.cacheUserLanguage?.(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        const fixedT = (key, opts, ...rest)=>{
            let o;
            if (typeof opts !== 'object') o = this.options.overloadTranslationOptionHandler([
                key,
                opts
            ].concat(rest));
            else o = {
                ...opts
            };
            o.lng = o.lng || fixedT.lng;
            o.lngs = o.lngs || fixedT.lngs;
            o.ns = o.ns || fixedT.ns;
            if (o.keyPrefix !== '') o.keyPrefix = o.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = this.options.keySeparator || '.';
            let resultKey;
            if (o.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>{
                if (typeof k === 'function') k = $1e580fbd50c9e2d3$export$ec2cccc18ab4c2ae(k, {
                    ...this.options,
                    ...opts
                });
                return `${o.keyPrefix}${keySeparator}${k}`;
            });
            else {
                if (typeof key === 'function') key = $1e580fbd50c9e2d3$export$ec2cccc18ab4c2ae(key, {
                    ...this.options,
                    ...opts
                });
                resultKey = o.keyPrefix ? `${o.keyPrefix}${keySeparator}${key}` : key;
            }
            return this.t(resultKey, o);
        };
        if ($1e580fbd50c9e2d3$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t(...args) {
        return this.translator?.translate(...args);
    }
    exists(...args) {
        return this.translator?.exists(...args);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns, options = {}) {
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $1e580fbd50c9e2d3$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($1e580fbd50c9e2d3$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $1e580fbd50c9e2d3$var$defer();
        if ($1e580fbd50c9e2d3$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        try {
            const l = new Intl.Locale(lng);
            if (l && l.getTextInfo) {
                const ti = l.getTextInfo();
                if (ti && ti.direction) return ti.direction;
            }
        } catch (e) {}
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services?.languageUtils || new $1e580fbd50c9e2d3$var$LanguageUtil($1e580fbd50c9e2d3$var$get());
        if (lng.toLowerCase().indexOf('-latn') > 1) return 'ltr';
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance(options = {}, callback) {
        const instance = new $1e580fbd50c9e2d3$var$I18n(options, callback);
        instance.createInstance = $1e580fbd50c9e2d3$var$I18n.createInstance;
        return instance;
    }
    cloneInstance(options = {}, callback = $1e580fbd50c9e2d3$var$noop) {
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $1e580fbd50c9e2d3$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            const clonedData = Object.keys(this.store.data).reduce((prev, l)=>{
                prev[l] = {
                    ...this.store.data[l]
                };
                prev[l] = Object.keys(prev[l]).reduce((acc, n)=>{
                    acc[n] = {
                        ...prev[l][n]
                    };
                    return acc;
                }, prev[l]);
                return prev;
            }, {});
            clone.store = new $1e580fbd50c9e2d3$var$ResourceStore(clonedData, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        if (options.interpolation) {
            const defOpts = $1e580fbd50c9e2d3$var$get();
            const mergedInterpolation = {
                ...defOpts.interpolation,
                ...this.options.interpolation,
                ...options.interpolation
            };
            const mergedForInterpolator = {
                ...mergedOptions,
                interpolation: mergedInterpolation
            };
            clone.services.interpolator = new $1e580fbd50c9e2d3$var$Interpolator(mergedForInterpolator);
        }
        clone.translator = new $1e580fbd50c9e2d3$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', (event, ...args)=>{
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $1e580fbd50c9e2d3$export$2e2bcd8739ae039 = $1e580fbd50c9e2d3$var$I18n.createInstance();
const $1e580fbd50c9e2d3$export$99152e8d49ca4e7d = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.createInstance;
const $1e580fbd50c9e2d3$export$147ec2801e896265 = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.dir;
const $1e580fbd50c9e2d3$export$2cd8252107eb640b = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.init;
const $1e580fbd50c9e2d3$export$d3d08d944062d7e = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.loadResources;
const $1e580fbd50c9e2d3$export$a5d9bf5d83fcab09 = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.reloadResources;
const $1e580fbd50c9e2d3$export$1f96ae73734a86cc = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.use;
const $1e580fbd50c9e2d3$export$61465194746e7fd2 = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.changeLanguage;
const $1e580fbd50c9e2d3$export$f90d180fc7da3b3b = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.getFixedT;
const $1e580fbd50c9e2d3$export$625550452a3fa3ec = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.t;
const $1e580fbd50c9e2d3$export$f7e9f41ea797a17 = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.exists;
const $1e580fbd50c9e2d3$export$2b4b218e406d2d00 = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.setDefaultNamespace;
const $1e580fbd50c9e2d3$export$93d9ee97c1ad3f31 = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.hasLoadedNamespace;
const $1e580fbd50c9e2d3$export$83be934b53fff43b = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.loadNamespaces;
const $1e580fbd50c9e2d3$export$8cd7e7a54fa865bc = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.loadLanguages;


const { slice: $f73f86de2138df56$var$slice, forEach: $f73f86de2138df56$var$forEach } = [];
function $f73f86de2138df56$var$defaults(obj) {
    $f73f86de2138df56$var$forEach.call($f73f86de2138df56$var$slice.call(arguments, 1), (source)=>{
        if (source) {
            for(const prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $f73f86de2138df56$var$hasXSS(input) {
    if (typeof input !== 'string') return false;
    // Common XSS attack patterns
    const xssPatterns = [
        /<\s*script.*?>/i,
        /<\s*\/\s*script\s*>/i,
        /<\s*img.*?on\w+\s*=/i,
        /<\s*\w+\s*on\w+\s*=.*?>/i,
        /javascript\s*:/i,
        /vbscript\s*:/i,
        /expression\s*\(/i,
        /eval\s*\(/i,
        /alert\s*\(/i,
        /document\.cookie/i,
        /document\.write\s*\(/i,
        /window\.location/i,
        /innerHTML/i
    ];
    return xssPatterns.some((pattern)=>pattern.test(input));
}
// eslint-disable-next-line no-control-regex
const $f73f86de2138df56$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
const $f73f86de2138df56$var$serializeCookie = function(name, val) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        path: '/'
    };
    const opt = options;
    const value = encodeURIComponent(val);
    let str = `${name}=${value}`;
    if (opt.maxAge > 0) {
        const maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += `; Max-Age=${Math.floor(maxAge)}`;
    }
    if (opt.domain) {
        if (!$f73f86de2138df56$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += `; Domain=${opt.domain}`;
    }
    if (opt.path) {
        if (!$f73f86de2138df56$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += `; Path=${opt.path}`;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += `; Expires=${opt.expires.toUTCString()}`;
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        const sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    if (opt.partitioned) str += '; Partitioned';
    return str;
};
const $f73f86de2138df56$var$cookie = {
    create (name, value, minutes, domain) {
        let cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $f73f86de2138df56$var$serializeCookie(name, value, cookieOptions);
    },
    read (name) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++){
            let c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove (name, domain) {
        this.create(name, '', -1, domain);
    }
};
var $f73f86de2138df56$var$cookie$1 = {
    name: 'cookie',
    // Deconstruct the options object and extract the lookupCookie property
    lookup (_ref) {
        let { lookupCookie: lookupCookie } = _ref;
        if (lookupCookie && typeof document !== 'undefined') return $f73f86de2138df56$var$cookie.read(lookupCookie) || undefined;
        return undefined;
    },
    // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
    cacheUserLanguage (lng, _ref2) {
        let { lookupCookie: lookupCookie, cookieMinutes: cookieMinutes, cookieDomain: cookieDomain, cookieOptions: cookieOptions } = _ref2;
        if (lookupCookie && typeof document !== 'undefined') $f73f86de2138df56$var$cookie.create(lookupCookie, lng, cookieMinutes, cookieDomain, cookieOptions);
    }
};
var $f73f86de2138df56$var$querystring = {
    name: 'querystring',
    // Deconstruct the options object and extract the lookupQuerystring property
    lookup (_ref) {
        let { lookupQuerystring: lookupQuerystring } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            let { search: search } = window.location;
            if (!window.location.search && window.location.hash?.indexOf('?') > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            const query = search.substring(1);
            const params = query.split('&');
            for(let i = 0; i < params.length; i++){
                const pos = params[i].indexOf('=');
                if (pos > 0) {
                    const key = params[i].substring(0, pos);
                    if (key === lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $f73f86de2138df56$var$hash = {
    name: 'hash',
    // Deconstruct the options object and extract the lookupHash property and the lookupFromHashIndex property
    lookup (_ref) {
        let { lookupHash: lookupHash, lookupFromHashIndex: lookupFromHashIndex } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            const { hash: hash } = window.location;
            if (hash && hash.length > 2) {
                const query = hash.substring(1);
                if (lookupHash) {
                    const params = query.split('&');
                    for(let i = 0; i < params.length; i++){
                        const pos = params[i].indexOf('=');
                        if (pos > 0) {
                            const key = params[i].substring(0, pos);
                            if (key === lookupHash) found = params[i].substring(pos + 1);
                        }
                    }
                }
                if (found) return found;
                if (!found && lookupFromHashIndex > -1) {
                    const language = hash.match(/\/([a-zA-Z-]*)/g);
                    if (!Array.isArray(language)) return undefined;
                    const index = typeof lookupFromHashIndex === 'number' ? lookupFromHashIndex : 0;
                    return language[index]?.replace('/', '');
                }
            }
        }
        return found;
    }
};
let $f73f86de2138df56$var$hasLocalStorageSupport = null;
const $f73f86de2138df56$var$localStorageAvailable = ()=>{
    if ($f73f86de2138df56$var$hasLocalStorageSupport !== null) return $f73f86de2138df56$var$hasLocalStorageSupport;
    try {
        $f73f86de2138df56$var$hasLocalStorageSupport = typeof window !== 'undefined' && window.localStorage !== null;
        if (!$f73f86de2138df56$var$hasLocalStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $f73f86de2138df56$var$hasLocalStorageSupport = false;
    }
    return $f73f86de2138df56$var$hasLocalStorageSupport;
};
var $f73f86de2138df56$var$localStorage = {
    name: 'localStorage',
    // Deconstruct the options object and extract the lookupLocalStorage property
    lookup (_ref) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref;
        if (lookupLocalStorage && $f73f86de2138df56$var$localStorageAvailable()) return window.localStorage.getItem(lookupLocalStorage) || undefined; // Undefined ensures type consistency with the previous version of this function
        return undefined;
    },
    // Deconstruct the options object and extract the lookupLocalStorage property
    cacheUserLanguage (lng, _ref2) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref2;
        if (lookupLocalStorage && $f73f86de2138df56$var$localStorageAvailable()) window.localStorage.setItem(lookupLocalStorage, lng);
    }
};
let $f73f86de2138df56$var$hasSessionStorageSupport = null;
const $f73f86de2138df56$var$sessionStorageAvailable = ()=>{
    if ($f73f86de2138df56$var$hasSessionStorageSupport !== null) return $f73f86de2138df56$var$hasSessionStorageSupport;
    try {
        $f73f86de2138df56$var$hasSessionStorageSupport = typeof window !== 'undefined' && window.sessionStorage !== null;
        if (!$f73f86de2138df56$var$hasSessionStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $f73f86de2138df56$var$hasSessionStorageSupport = false;
    }
    return $f73f86de2138df56$var$hasSessionStorageSupport;
};
var $f73f86de2138df56$var$sessionStorage = {
    name: 'sessionStorage',
    lookup (_ref) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref;
        if (lookupSessionStorage && $f73f86de2138df56$var$sessionStorageAvailable()) return window.sessionStorage.getItem(lookupSessionStorage) || undefined;
        return undefined;
    },
    cacheUserLanguage (lng, _ref2) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref2;
        if (lookupSessionStorage && $f73f86de2138df56$var$sessionStorageAvailable()) window.sessionStorage.setItem(lookupSessionStorage, lng);
    }
};
var $f73f86de2138df56$var$navigator$1 = {
    name: 'navigator',
    lookup (options) {
        const found = [];
        if (typeof navigator !== 'undefined') {
            const { languages: languages, userLanguage: userLanguage, language: language } = navigator;
            if (languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(let i = 0; i < languages.length; i++)found.push(languages[i]);
            if (userLanguage) found.push(userLanguage);
            if (language) found.push(language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $f73f86de2138df56$var$htmlTag = {
    name: 'htmlTag',
    // Deconstruct the options object and extract the htmlTag property
    lookup (_ref) {
        let { htmlTag: htmlTag } = _ref;
        let found;
        const internalHtmlTag = htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (internalHtmlTag && typeof internalHtmlTag.getAttribute === 'function') found = internalHtmlTag.getAttribute('lang');
        return found;
    }
};
var $f73f86de2138df56$var$path = {
    name: 'path',
    // Deconstruct the options object and extract the lookupFromPathIndex property
    lookup (_ref) {
        let { lookupFromPathIndex: lookupFromPathIndex } = _ref;
        if (typeof window === 'undefined') return undefined;
        const language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
        if (!Array.isArray(language)) return undefined;
        const index = typeof lookupFromPathIndex === 'number' ? lookupFromPathIndex : 0;
        return language[index]?.replace('/', '');
    }
};
var $f73f86de2138df56$var$subdomain = {
    name: 'subdomain',
    lookup (_ref) {
        let { lookupFromSubdomainIndex: lookupFromSubdomainIndex } = _ref;
        // If given get the subdomain index else 1
        const internalLookupFromSubdomainIndex = typeof lookupFromSubdomainIndex === 'number' ? lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group match which should be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        const language = typeof window !== 'undefined' && window.location?.hostname?.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[internalLookupFromSubdomainIndex];
    }
};
// some environments, throws when accessing document.cookie
let $f73f86de2138df56$var$canCookies = false;
try {
    // eslint-disable-next-line no-unused-expressions
    document.cookie;
    $f73f86de2138df56$var$canCookies = true;
// eslint-disable-next-line no-empty
} catch (e) {}
const $f73f86de2138df56$var$order = [
    'querystring',
    'cookie',
    'localStorage',
    'sessionStorage',
    'navigator',
    'htmlTag'
];
if (!$f73f86de2138df56$var$canCookies) $f73f86de2138df56$var$order.splice(1, 1);
const $f73f86de2138df56$var$getDefaults = ()=>({
        order: $f73f86de2138df56$var$order,
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: (l)=>l
    });
class $f73f86de2138df56$export$2e2bcd8739ae039 {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
    init() {
        let services = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            languageUtils: {}
        };
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.services = services;
        this.options = $f73f86de2138df56$var$defaults(options, this.options || {}, $f73f86de2138df56$var$getDefaults());
        if (typeof this.options.convertDetectedLanguage === 'string' && this.options.convertDetectedLanguage.indexOf('15897') > -1) this.options.convertDetectedLanguage = (l)=>l.replace('-', '_');
        // backwards compatibility
        if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
        this.i18nOptions = i18nOptions;
        this.addDetector($f73f86de2138df56$var$cookie$1);
        this.addDetector($f73f86de2138df56$var$querystring);
        this.addDetector($f73f86de2138df56$var$localStorage);
        this.addDetector($f73f86de2138df56$var$sessionStorage);
        this.addDetector($f73f86de2138df56$var$navigator$1);
        this.addDetector($f73f86de2138df56$var$htmlTag);
        this.addDetector($f73f86de2138df56$var$path);
        this.addDetector($f73f86de2138df56$var$subdomain);
        this.addDetector($f73f86de2138df56$var$hash);
    }
    addDetector(detector) {
        this.detectors[detector.name] = detector;
        return this;
    }
    detect() {
        let detectionOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.order;
        let detected = [];
        detectionOrder.forEach((detectorName)=>{
            if (this.detectors[detectorName]) {
                let lookup = this.detectors[detectorName].lookup(this.options);
                if (lookup && typeof lookup === 'string') lookup = [
                    lookup
                ];
                if (lookup) detected = detected.concat(lookup);
            }
        });
        detected = detected.filter((d)=>d !== undefined && d !== null && !$f73f86de2138df56$var$hasXSS(d)).map((d)=>this.options.convertDetectedLanguage(d));
        if (this.services && this.services.languageUtils && this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
        return detected.length > 0 ? detected[0] : null; // a little backward compatibility
    }
    cacheUserLanguage(lng) {
        let caches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.caches;
        if (!caches) return;
        if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
        caches.forEach((cacheName)=>{
            if (this.detectors[cacheName]) this.detectors[cacheName].cacheUserLanguage(lng, this.options);
        });
    }
}
$f73f86de2138df56$export$2e2bcd8739ae039.type = 'languageDetector';


function $5e94ee2b5c33482b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5e94ee2b5c33482b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5e94ee2b5c33482b$var$_typeof(o);
}
var $5e94ee2b5c33482b$var$arr = [];
var $5e94ee2b5c33482b$var$each = $5e94ee2b5c33482b$var$arr.forEach;
var $5e94ee2b5c33482b$var$slice = $5e94ee2b5c33482b$var$arr.slice;
function $5e94ee2b5c33482b$export$ebe90cb607ad99e(obj) {
    $5e94ee2b5c33482b$var$each.call($5e94ee2b5c33482b$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $5e94ee2b5c33482b$export$87022daa49baf612() {
    return typeof XMLHttpRequest === 'function' || (typeof XMLHttpRequest === "undefined" ? "undefined" : $5e94ee2b5c33482b$var$_typeof(XMLHttpRequest)) === 'object';
}
function $5e94ee2b5c33482b$var$isPromise(maybePromise) {
    return !!maybePromise && typeof maybePromise.then === 'function';
}
function $5e94ee2b5c33482b$export$1625492ec82002b9(maybePromise) {
    if ($5e94ee2b5c33482b$var$isPromise(maybePromise)) return maybePromise;
    return Promise.resolve(maybePromise);
}



function $115a9e8b8151a003$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $115a9e8b8151a003$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $115a9e8b8151a003$var$ownKeys(Object(t), !0).forEach(function(r) {
            $115a9e8b8151a003$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $115a9e8b8151a003$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $115a9e8b8151a003$var$_defineProperty(e, r, t) {
    return (r = $115a9e8b8151a003$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $115a9e8b8151a003$var$_toPropertyKey(t) {
    var i = $115a9e8b8151a003$var$_toPrimitive(t, "string");
    return "symbol" == $115a9e8b8151a003$var$_typeof(i) ? i : i + "";
}
function $115a9e8b8151a003$var$_toPrimitive(t, r) {
    if ("object" != $115a9e8b8151a003$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $115a9e8b8151a003$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $115a9e8b8151a003$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $115a9e8b8151a003$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $115a9e8b8151a003$var$_typeof(o);
}
var $115a9e8b8151a003$var$fetchApi = typeof fetch === 'function' ? fetch : undefined;
if (typeof $parcel$global !== 'undefined' && $parcel$global.fetch) $115a9e8b8151a003$var$fetchApi = $parcel$global.fetch;
else if (typeof window !== 'undefined' && window.fetch) $115a9e8b8151a003$var$fetchApi = window.fetch;
var $115a9e8b8151a003$var$XmlHttpRequestApi;
if ((0, $5e94ee2b5c33482b$export$87022daa49baf612)()) {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.XMLHttpRequest) $115a9e8b8151a003$var$XmlHttpRequestApi = $parcel$global.XMLHttpRequest;
    else if (typeof window !== 'undefined' && window.XMLHttpRequest) $115a9e8b8151a003$var$XmlHttpRequestApi = window.XMLHttpRequest;
}
var $115a9e8b8151a003$var$ActiveXObjectApi;
if (typeof ActiveXObject === 'function') {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.ActiveXObject) $115a9e8b8151a003$var$ActiveXObjectApi = $parcel$global.ActiveXObject;
    else if (typeof window !== 'undefined' && window.ActiveXObject) $115a9e8b8151a003$var$ActiveXObjectApi = window.ActiveXObject;
}
if (typeof $115a9e8b8151a003$var$fetchApi !== 'function') $115a9e8b8151a003$var$fetchApi = undefined;

if (!$115a9e8b8151a003$var$fetchApi && !$115a9e8b8151a003$var$XmlHttpRequestApi && !$115a9e8b8151a003$var$ActiveXObjectApi) try {
    (parcelRequire("2Fp4m")).then(function(mod) {
        $115a9e8b8151a003$var$fetchApi = mod.default;
    }).catch(function() {});
} catch (e) {}
var $115a9e8b8151a003$var$addQueryString = function addQueryString(url, params) {
    if (params && $115a9e8b8151a003$var$_typeof(params) === 'object') {
        var queryString = '';
        for(var paramName in params)queryString += '&' + encodeURIComponent(paramName) + '=' + encodeURIComponent(params[paramName]);
        if (!queryString) return url;
        url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
    }
    return url;
};
var $115a9e8b8151a003$var$fetchIt = function fetchIt(url, fetchOptions, callback, altFetch) {
    var resolver = function resolver(response) {
        if (!response.ok) return callback(response.statusText || 'Error', {
            status: response.status
        });
        response.text().then(function(data) {
            callback(null, {
                status: response.status,
                data: data
            });
        }).catch(callback);
    };
    if (altFetch) {
        var altResponse = altFetch(url, fetchOptions);
        if (altResponse instanceof Promise) {
            altResponse.then(resolver).catch(callback);
            return;
        }
    }
    if (typeof fetch === 'function') fetch(url, fetchOptions).then(resolver).catch(callback);
    else $115a9e8b8151a003$var$fetchApi(url, fetchOptions).then(resolver).catch(callback);
};
var $115a9e8b8151a003$var$omitFetchOptions = false;
var $115a9e8b8151a003$var$requestWithFetch = function requestWithFetch(options, url, payload, callback) {
    if (options.queryStringParams) url = $115a9e8b8151a003$var$addQueryString(url, options.queryStringParams);
    var headers = $115a9e8b8151a003$var$_objectSpread({}, typeof options.customHeaders === 'function' ? options.customHeaders() : options.customHeaders);
    if (typeof window === 'undefined' && typeof $parcel$global !== 'undefined' && typeof $parcel$global.process !== 'undefined' && $parcel$global.process.versions && $parcel$global.process.versions.node) headers['User-Agent'] = "i18next-http-backend (node/".concat($parcel$global.process.version, "; ").concat($parcel$global.process.platform, " ").concat($parcel$global.process.arch, ")");
    if (payload) headers['Content-Type'] = 'application/json';
    var reqOptions = typeof options.requestOptions === 'function' ? options.requestOptions(payload) : options.requestOptions;
    var fetchOptions = $115a9e8b8151a003$var$_objectSpread({
        method: payload ? 'POST' : 'GET',
        body: payload ? options.stringify(payload) : undefined,
        headers: headers
    }, $115a9e8b8151a003$var$omitFetchOptions ? {} : reqOptions);
    var altFetch = typeof options.alternateFetch === 'function' && options.alternateFetch.length >= 1 ? options.alternateFetch : undefined;
    try {
        $115a9e8b8151a003$var$fetchIt(url, fetchOptions, callback, altFetch);
    } catch (e) {
        if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf('not implemented') < 0) return callback(e);
        try {
            Object.keys(reqOptions).forEach(function(opt) {
                delete fetchOptions[opt];
            });
            $115a9e8b8151a003$var$fetchIt(url, fetchOptions, callback, altFetch);
            $115a9e8b8151a003$var$omitFetchOptions = true;
        } catch (err) {
            callback(err);
        }
    }
};
var $115a9e8b8151a003$var$requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
    if (payload && $115a9e8b8151a003$var$_typeof(payload) === 'object') payload = $115a9e8b8151a003$var$addQueryString('', payload).slice(1);
    if (options.queryStringParams) url = $115a9e8b8151a003$var$addQueryString(url, options.queryStringParams);
    try {
        var x = $115a9e8b8151a003$var$XmlHttpRequestApi ? new $115a9e8b8151a003$var$XmlHttpRequestApi() : new $115a9e8b8151a003$var$ActiveXObjectApi('MSXML2.XMLHTTP.3.0');
        x.open(payload ? 'POST' : 'GET', url, 1);
        if (!options.crossDomain) x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        x.withCredentials = !!options.withCredentials;
        if (payload) x.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        if (x.overrideMimeType) x.overrideMimeType('application/json');
        var h = options.customHeaders;
        h = typeof h === 'function' ? h() : h;
        if (h) for(var i in h)x.setRequestHeader(i, h[i]);
        x.onreadystatechange = function() {
            x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
                status: x.status,
                data: x.responseText
            });
        };
        x.send(payload);
    } catch (e) {
        console && console.log(e);
    }
};
var $115a9e8b8151a003$var$request = function request(options, url, payload, callback) {
    if (typeof payload === 'function') {
        callback = payload;
        payload = undefined;
    }
    callback = callback || function() {};
    if ($115a9e8b8151a003$var$fetchApi && url.indexOf('file:') !== 0) return $115a9e8b8151a003$var$requestWithFetch(options, url, payload, callback);
    if ((0, $5e94ee2b5c33482b$export$87022daa49baf612)() || typeof ActiveXObject === 'function') return $115a9e8b8151a003$var$requestWithXmlHttpRequest(options, url, payload, callback);
    callback(new Error('No fetch and no xhr implementation found!'));
};
var $115a9e8b8151a003$export$2e2bcd8739ae039 = $115a9e8b8151a003$var$request;


function $fcb831e2a23edeea$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fcb831e2a23edeea$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fcb831e2a23edeea$var$_typeof(o);
}
function $fcb831e2a23edeea$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fcb831e2a23edeea$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fcb831e2a23edeea$var$ownKeys(Object(t), !0).forEach(function(r) {
            $fcb831e2a23edeea$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fcb831e2a23edeea$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fcb831e2a23edeea$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $fcb831e2a23edeea$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $fcb831e2a23edeea$var$_toPropertyKey(o.key), o);
    }
}
function $fcb831e2a23edeea$var$_createClass(e, r, t) {
    return r && $fcb831e2a23edeea$var$_defineProperties(e.prototype, r), t && $fcb831e2a23edeea$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $fcb831e2a23edeea$var$_defineProperty(e, r, t) {
    return (r = $fcb831e2a23edeea$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fcb831e2a23edeea$var$_toPropertyKey(t) {
    var i = $fcb831e2a23edeea$var$_toPrimitive(t, "string");
    return "symbol" == $fcb831e2a23edeea$var$_typeof(i) ? i : i + "";
}
function $fcb831e2a23edeea$var$_toPrimitive(t, r) {
    if ("object" != $fcb831e2a23edeea$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $fcb831e2a23edeea$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $fcb831e2a23edeea$var$getDefaults = function getDefaults() {
    return {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
        addPath: '/locales/add/{{lng}}/{{ns}}',
        parse: function parse(data) {
            return JSON.parse(data);
        },
        stringify: JSON.stringify,
        parsePayload: function parsePayload(namespace, key, fallbackValue) {
            return $fcb831e2a23edeea$var$_defineProperty({}, key, fallbackValue || '');
        },
        parseLoadPayload: function parseLoadPayload(languages, namespaces) {
            return undefined;
        },
        request: (0, $115a9e8b8151a003$export$2e2bcd8739ae039),
        reloadInterval: typeof window !== 'undefined' ? false : 3600000,
        customHeaders: {},
        queryStringParams: {},
        crossDomain: false,
        withCredentials: false,
        overrideMimeType: false,
        requestOptions: {
            mode: 'cors',
            credentials: 'same-origin',
            cache: 'default'
        }
    };
};
var $fcb831e2a23edeea$var$Backend = function() {
    function Backend(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $fcb831e2a23edeea$var$_classCallCheck(this, Backend);
        this.services = services;
        this.options = options;
        this.allOptions = allOptions;
        this.type = 'backend';
        this.init(services, options, allOptions);
    }
    return $fcb831e2a23edeea$var$_createClass(Backend, [
        {
            key: "init",
            value: function init(services) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $fcb831e2a23edeea$var$_objectSpread($fcb831e2a23edeea$var$_objectSpread($fcb831e2a23edeea$var$_objectSpread({}, $fcb831e2a23edeea$var$getDefaults()), this.options || {}), options);
                this.allOptions = allOptions;
                if (this.services && this.options.reloadInterval) {
                    var timer = setInterval(function() {
                        return _this.reload();
                    }, this.options.reloadInterval);
                    if ($fcb831e2a23edeea$var$_typeof(timer) === 'object' && typeof timer.unref === 'function') timer.unref();
                }
            }
        },
        {
            key: "readMulti",
            value: function readMulti(languages, namespaces, callback) {
                this._readAny(languages, languages, namespaces, namespaces, callback);
            }
        },
        {
            key: "read",
            value: function read(language, namespace, callback) {
                this._readAny([
                    language
                ], language, [
                    namespace
                ], namespace, callback);
            }
        },
        {
            key: "_readAny",
            value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
                var _this2 = this;
                var loadPath = this.options.loadPath;
                if (typeof this.options.loadPath === 'function') loadPath = this.options.loadPath(languages, namespaces);
                loadPath = (0, $5e94ee2b5c33482b$export$1625492ec82002b9)(loadPath);
                loadPath.then(function(resolvedLoadPath) {
                    if (!resolvedLoadPath) return callback(null, {});
                    var url = _this2.services.interpolator.interpolate(resolvedLoadPath, {
                        lng: languages.join('+'),
                        ns: namespaces.join('+')
                    });
                    _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
                });
            }
        },
        {
            key: "loadUrl",
            value: function loadUrl(url, callback, languages, namespaces) {
                var _this3 = this;
                var lng = typeof languages === 'string' ? [
                    languages
                ] : languages;
                var ns = typeof namespaces === 'string' ? [
                    namespaces
                ] : namespaces;
                var payload = this.options.parseLoadPayload(lng, ns);
                this.options.request(this.options, url, payload, function(err, res) {
                    if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback('failed loading ' + url + '; status code: ' + res.status, true);
                    if (res && res.status >= 400 && res.status < 500) return callback('failed loading ' + url + '; status code: ' + res.status, false);
                    if (!res && err && err.message) {
                        var errorMessage = err.message.toLowerCase();
                        var isNetworkError = [
                            'failed',
                            'fetch',
                            'network',
                            'load'
                        ].find(function(term) {
                            return errorMessage.indexOf(term) > -1;
                        });
                        if (isNetworkError) return callback('failed loading ' + url + ': ' + err.message, true);
                    }
                    if (err) return callback(err, false);
                    var ret, parseErr;
                    try {
                        if (typeof res.data === 'string') ret = _this3.options.parse(res.data, languages, namespaces);
                        else ret = res.data;
                    } catch (e) {
                        parseErr = 'failed parsing ' + url + ' to json';
                    }
                    if (parseErr) return callback(parseErr, false);
                    callback(null, ret);
                });
            }
        },
        {
            key: "create",
            value: function create(languages, namespace, key, fallbackValue, callback) {
                var _this4 = this;
                if (!this.options.addPath) return;
                if (typeof languages === 'string') languages = [
                    languages
                ];
                var payload = this.options.parsePayload(namespace, key, fallbackValue);
                var finished = 0;
                var dataArray = [];
                var resArray = [];
                languages.forEach(function(lng) {
                    var addPath = _this4.options.addPath;
                    if (typeof _this4.options.addPath === 'function') addPath = _this4.options.addPath(lng, namespace);
                    var url = _this4.services.interpolator.interpolate(addPath, {
                        lng: lng,
                        ns: namespace
                    });
                    _this4.options.request(_this4.options, url, payload, function(data, res) {
                        finished += 1;
                        dataArray.push(data);
                        resArray.push(res);
                        if (finished === languages.length) {
                            if (typeof callback === 'function') callback(dataArray, resArray);
                        }
                    });
                });
            }
        },
        {
            key: "reload",
            value: function reload() {
                var _this5 = this;
                var _this$services = this.services, backendConnector = _this$services.backendConnector, languageUtils = _this$services.languageUtils, logger = _this$services.logger;
                var currentLanguage = backendConnector.language;
                if (currentLanguage && currentLanguage.toLowerCase() === 'cimode') return;
                var toLoad = [];
                var append = function append(lng) {
                    var lngs = languageUtils.toResolveHierarchy(lng);
                    lngs.forEach(function(l) {
                        if (toLoad.indexOf(l) < 0) toLoad.push(l);
                    });
                };
                append(currentLanguage);
                if (this.allOptions.preload) this.allOptions.preload.forEach(function(l) {
                    return append(l);
                });
                toLoad.forEach(function(lng) {
                    _this5.allOptions.ns.forEach(function(ns) {
                        backendConnector.read(lng, ns, 'read', null, null, function(err, data) {
                            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
                            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
                            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
                        });
                    });
                });
            }
        }
    ]);
}();
$fcb831e2a23edeea$var$Backend.type = 'backend';
var $fcb831e2a23edeea$export$2e2bcd8739ae039 = $fcb831e2a23edeea$var$Backend;



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $f1ee620f0561c02a$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $f1ee620f0561c02a$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $3be60b4f29d3a6e3$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $3be60b4f29d3a6e3$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($f1ee620f0561c02a$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($3be60b4f29d3a6e3$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $3be60b4f29d3a6e3$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $3be60b4f29d3a6e3$var$i = /^\s*$/, $3be60b4f29d3a6e3$var$s = Object.create(null);
function $3be60b4f29d3a6e3$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($3be60b4f29d3a6e3$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "\x3c!--" + t.comment + "--\x3e";
    }
}
var $3be60b4f29d3a6e3$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $3be60b4f29d3a6e3$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($3be60b4f29d3a6e3$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("\x3c!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $3be60b4f29d3a6e3$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $3be60b4f29d3a6e3$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $3be60b4f29d3a6e3$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $3be60b4f29d3a6e3$var$a("", t);
        }, "");
    }
};
var $3be60b4f29d3a6e3$export$2e2bcd8739ae039 = $3be60b4f29d3a6e3$var$c;


const $445d14444882807b$export$c106dd0671a0fc2d = (i18n, code, msg, rest)=>{
    const args = [
        msg,
        {
            code: code,
            ...rest || {}
        }
    ];
    if (i18n?.services?.logger?.forward) return i18n.services.logger.forward(args, 'warn', 'react-i18next::', true);
    if ($445d14444882807b$export$844ec244b1367d54(args[0])) args[0] = `react-i18next:: ${args[0]}`;
    if (i18n?.services?.logger?.warn) i18n.services.logger.warn(...args);
    else if (console?.warn) console.warn(...args);
};
const $445d14444882807b$var$alreadyWarned = {};
const $445d14444882807b$export$5b28268982f175ba = (i18n, code, msg, rest)=>{
    if ($445d14444882807b$export$844ec244b1367d54(msg) && $445d14444882807b$var$alreadyWarned[msg]) return;
    if ($445d14444882807b$export$844ec244b1367d54(msg)) $445d14444882807b$var$alreadyWarned[msg] = new Date();
    $445d14444882807b$export$c106dd0671a0fc2d(i18n, code, msg, rest);
};
const $445d14444882807b$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
const $445d14444882807b$export$83be934b53fff43b = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, $445d14444882807b$var$loadedClb(i18n, cb));
};
const $445d14444882807b$export$8cd7e7a54fa865bc = (i18n, lng, ns, cb)=>{
    if ($445d14444882807b$export$844ec244b1367d54(ns)) ns = [
        ns
    ];
    if (i18n.options.preload && i18n.options.preload.indexOf(lng) > -1) return $445d14444882807b$export$83be934b53fff43b(i18n, ns, cb);
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $445d14444882807b$var$loadedClb(i18n, cb));
};
const $445d14444882807b$export$93d9ee97c1ad3f31 = (ns, i18n, options = {})=>{
    if (!i18n.languages || !i18n.languages.length) {
        $445d14444882807b$export$5b28268982f175ba(i18n, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
            languages: i18n.languages
        });
        return true;
    }
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const $445d14444882807b$export$be63e0664592e141 = (Component)=>Component.displayName || Component.name || ($445d14444882807b$export$844ec244b1367d54(Component) && Component.length > 0 ? Component : 'Unknown');
const $445d14444882807b$export$844ec244b1367d54 = (obj)=>typeof obj === 'string';
const $445d14444882807b$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'object' && obj !== null;


const $dbc236e0ae4b1bc0$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $dbc236e0ae4b1bc0$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $dbc236e0ae4b1bc0$var$unescapeHtmlEntity = (m)=>$dbc236e0ae4b1bc0$var$htmlEntities[m];
const $dbc236e0ae4b1bc0$export$e8bacd2802a88316 = (text)=>text.replace($dbc236e0ae4b1bc0$var$matchHtmlEntity, $dbc236e0ae4b1bc0$var$unescapeHtmlEntity);


let $ba1062cc0d1f4b93$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $dbc236e0ae4b1bc0$export$e8bacd2802a88316
};
const $ba1062cc0d1f4b93$export$2e2366488d12e20d = (options = {})=>{
    $ba1062cc0d1f4b93$var$defaultOptions = {
        ...$ba1062cc0d1f4b93$var$defaultOptions,
        ...options
    };
};
const $ba1062cc0d1f4b93$export$212bb2fc580a90a8 = ()=>$ba1062cc0d1f4b93$var$defaultOptions;


let $91a4dd25d142fe34$var$i18nInstance;
const $91a4dd25d142fe34$export$a039134f2fc7e0 = (instance)=>{
    $91a4dd25d142fe34$var$i18nInstance = instance;
};
const $91a4dd25d142fe34$export$64af334f494c2f47 = ()=>$91a4dd25d142fe34$var$i18nInstance;


const $1bd7e790a57f14c4$var$hasChildren = (node, checkLength)=>{
    if (!node) return false;
    const base = node.props?.children ?? node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
const $1bd7e790a57f14c4$var$getChildren = (node)=>{
    if (!node) return [];
    const children = node.props?.children ?? node.children;
    return node.props?.i18nIsDynamicList ? $1bd7e790a57f14c4$var$getAsArray(children) : children;
};
const $1bd7e790a57f14c4$var$hasValidReactChildren = (children)=>Array.isArray(children) && children.every((0, $7fPBF.isValidElement));
const $1bd7e790a57f14c4$var$getAsArray = (data)=>Array.isArray(data) ? data : [
        data
    ];
const $1bd7e790a57f14c4$var$mergeProps = (source, target)=>{
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
};
const $1bd7e790a57f14c4$export$4f7a36dd898f1267 = (children, i18nOptions, i18n, i18nKey)=>{
    if (!children) return '';
    let stringNode = '';
    const childrenArray = $1bd7e790a57f14c4$var$getAsArray(children);
    const keepArray = i18nOptions?.transSupportBasicHtmlNodes ? i18nOptions.transKeepBasicHtmlNodesFor ?? [] : [];
    childrenArray.forEach((child, childIndex)=>{
        if ((0, $445d14444882807b$export$844ec244b1367d54)(child)) {
            stringNode += `${child}`;
            return;
        }
        if ((0, $7fPBF.isValidElement)(child)) {
            const { props: props, type: type } = child;
            const childPropsCount = Object.keys(props).length;
            const shouldKeepChild = keepArray.indexOf(type) > -1;
            const childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) {
                stringNode += `<${type}/>`;
                return;
            }
            if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) {
                stringNode += `<${childIndex}></${childIndex}>`;
                return;
            }
            if (shouldKeepChild && childPropsCount === 1 && (0, $445d14444882807b$export$844ec244b1367d54)(childChildren)) {
                stringNode += `<${type}>${childChildren}</${type}>`;
                return;
            }
            const content = $1bd7e790a57f14c4$export$4f7a36dd898f1267(childChildren, i18nOptions, i18n, i18nKey);
            stringNode += `<${childIndex}>${content}</${childIndex}>`;
            return;
        }
        if (child === null) {
            (0, $445d14444882807b$export$c106dd0671a0fc2d)(i18n, 'TRANS_NULL_VALUE', `Passed in a null value as child`, {
                i18nKey: i18nKey
            });
            return;
        }
        if ((0, $445d14444882807b$export$a6cdc56e425d0d0a)(child)) {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
                return;
            }
            (0, $445d14444882807b$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_OBJ', `Invalid child - Object should only have keys {{ value, format }} (format is optional).`, {
                i18nKey: i18nKey,
                child: child
            });
            return;
        }
        (0, $445d14444882807b$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_VAR', `Passed in a variable like {number} - pass variables for interpolation as full objects like {{number}}.`, {
            i18nKey: i18nKey,
            child: child
        });
    });
    return stringNode;
};
const $1bd7e790a57f14c4$var$renderNodes = (children, knownComponentsMap, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape)=>{
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !knownComponentsMap && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = knownComponentsMap ?? {};
    const getData = (childs)=>{
        const childrenArray = $1bd7e790a57f14c4$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $445d14444882807b$export$844ec244b1367d54)(child)) return;
            if ($1bd7e790a57f14c4$var$hasChildren(child)) getData($1bd7e790a57f14c4$var$getChildren(child));
            else if ((0, $445d14444882807b$export$a6cdc56e425d0d0a)(child) && !(0, $7fPBF.isValidElement)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    const ast = (0, $3be60b4f29d3a6e3$export$2e2bcd8739ae039).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    const renderInner = (child, node, rootReactNode)=>{
        const childs = $1bd7e790a57f14c4$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $1bd7e790a57f14c4$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props?.i18nIsDynamicList ? childs : mappedChildren;
    };
    const pushTranslatedJSX = (child, inner, mem, i, isVoid)=>{
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $7fPBF.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $7fPBF.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, $7fPBF.createElement)(c.type, {
                ...props,
                key: i,
                ref: c.props.ref ?? c.ref
            }, isVoid ? null : inner);
        }));
    };
    const mapAST = (reactNode, astNode, rootReactNode)=>{
        const reactNodes = $1bd7e790a57f14c4$var$getAsArray(reactNode);
        const astNodes = $1bd7e790a57f14c4$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children?.[0]?.content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && knownComponentsMap) tmp = knownComponentsMap[node.name];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $1bd7e790a57f14c4$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $7fPBF.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $1bd7e790a57f14c4$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $445d14444882807b$export$a6cdc56e425d0d0a)(child) && child.dummy && !isElement;
                const isKnownComponent = (0, $445d14444882807b$export$a6cdc56e425d0d0a)(knownComponentsMap) && Object.hasOwnProperty.call(knownComponentsMap, node.name);
                if ((0, $445d14444882807b$export$844ec244b1367d54)(child)) {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($1bd7e790a57f14c4$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $7fPBF.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $7fPBF.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if ((0, $445d14444882807b$export$a6cdc56e425d0d0a)(child) && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $7fPBF.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    };
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $1bd7e790a57f14c4$var$getAsArray(children || []));
    return $1bd7e790a57f14c4$var$getChildren(result[0]);
};
const $1bd7e790a57f14c4$var$fixComponentProps = (component, index, translation)=>{
    const componentKey = component.key || index;
    const comp = (0, $7fPBF.cloneElement)(component, {
        key: componentKey
    });
    if (!comp.props || !comp.props.children || translation.indexOf(`${index}/>`) < 0 && translation.indexOf(`${index} />`) < 0) return comp;
    function Componentized() {
        return (0, $7fPBF.createElement)((0, $7fPBF.Fragment), null, comp);
    }
    return (0, $7fPBF.createElement)(Componentized, {
        key: componentKey
    });
};
const $1bd7e790a57f14c4$var$generateArrayComponents = (components, translation)=>components.map((c, index)=>$1bd7e790a57f14c4$var$fixComponentProps(c, index, translation));
const $1bd7e790a57f14c4$var$generateObjectComponents = (components, translation)=>{
    const componentMap = {};
    Object.keys(components).forEach((c)=>{
        Object.assign(componentMap, {
            [c]: $1bd7e790a57f14c4$var$fixComponentProps(components[c], c, translation)
        });
    });
    return componentMap;
};
const $1bd7e790a57f14c4$var$generateComponents = (components, translation, i18n, i18nKey)=>{
    if (!components) return null;
    if (Array.isArray(components)) return $1bd7e790a57f14c4$var$generateArrayComponents(components, translation);
    if ((0, $445d14444882807b$export$a6cdc56e425d0d0a)(components)) return $1bd7e790a57f14c4$var$generateObjectComponents(components, translation);
    (0, $445d14444882807b$export$5b28268982f175ba)(i18n, 'TRANS_INVALID_COMPONENTS', `<Trans /> "components" prop expects an object or array`, {
        i18nKey: i18nKey
    });
    return null;
};
const $1bd7e790a57f14c4$var$isComponentsMap = (object)=>{
    if (!(0, $445d14444882807b$export$a6cdc56e425d0d0a)(object)) return false;
    if (Array.isArray(object)) return false;
    return Object.keys(object).reduce((acc, key)=>acc && Number.isNaN(Number.parseFloat(key)), true);
};
function $1bd7e790a57f14c4$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const i18n = i18nFromProps || (0, $91a4dd25d142fe34$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $445d14444882807b$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', `Trans: You need to pass in an i18next instance using i18nextReactModule`, {
            i18nKey: i18nKey
        });
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = {
        ...(0, $ba1062cc0d1f4b93$export$212bb2fc580a90a8)(),
        ...i18n.options?.react
    };
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $445d14444882807b$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const nodeAsString = $1bd7e790a57f14c4$export$4f7a36dd898f1267(children, reactI18nextOptions, i18n, i18nKey);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options?.interpolation?.defaultVariables) values = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const interpolationOverride = values || count !== undefined && !i18n.options?.interpolation?.alwaysFormat || !children ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: '#$?',
            suffix: '?$#'
        }
    };
    const combinedTOpts = {
        ...tOptions,
        context: context || tOptions.context,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    const generatedComponents = $1bd7e790a57f14c4$var$generateComponents(components, translation, i18n, i18nKey);
    let indexedChildren = generatedComponents || children;
    let componentsMap = null;
    if ($1bd7e790a57f14c4$var$isComponentsMap(generatedComponents)) {
        componentsMap = generatedComponents;
        indexedChildren = children;
    }
    const content = $1bd7e790a57f14c4$var$renderNodes(indexedChildren, componentsMap, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent ?? reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $7fPBF.createElement)(useAsParent, additionalProps, content) : content;
}



var $7fPBF = parcelRequire("7fPBF");




const $09536692873e4879$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init (instance) {
        (0, $ba1062cc0d1f4b93$export$2e2366488d12e20d)(instance.options.react);
        (0, $91a4dd25d142fe34$export$a039134f2fc7e0)(instance);
    }
};


const $021c8539c0651064$export$5603ab5ced17ce64 = (0, $7fPBF.createContext)();
class $021c8539c0651064$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
const $021c8539c0651064$export$30ff0342ccf735a = (ForComponent)=>async (ctx)=>{
        const componentsInitialProps = await ForComponent.getInitialProps?.(ctx) ?? {};
        const i18nInitialProps = $021c8539c0651064$export$704200e5d0b9e8f();
        return {
            ...componentsInitialProps,
            ...i18nInitialProps
        };
    };
const $021c8539c0651064$export$704200e5d0b9e8f = ()=>{
    const i18n = (0, $91a4dd25d142fe34$export$64af334f494c2f47)();
    const namespaces = i18n.reportNamespaces?.getUsedNamespaces() ?? [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};


function $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $7fPBF.useContext)((0, $021c8539c0651064$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $91a4dd25d142fe34$export$64af334f494c2f47)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $1bd7e790a57f14c4$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $7fPBF = parcelRequire("7fPBF");


const $9c081519ec78392c$var$usePrevious = (value, ignore)=>{
    const ref = (0, $7fPBF.useRef)();
    (0, $7fPBF.useEffect)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
const $9c081519ec78392c$var$alwaysNewT = (i18n, language, namespace, keyPrefix)=>i18n.getFixedT(language, namespace, keyPrefix);
const $9c081519ec78392c$var$useMemoizedT = (i18n, language, namespace, keyPrefix)=>(0, $7fPBF.useCallback)($9c081519ec78392c$var$alwaysNewT(i18n, language, namespace, keyPrefix), [
        i18n,
        language,
        namespace,
        keyPrefix
    ]);
const $9c081519ec78392c$export$9fc83ad70ead8663 = (ns, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $7fPBF.useContext)((0, $021c8539c0651064$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $91a4dd25d142fe34$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $021c8539c0651064$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $445d14444882807b$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', 'useTranslation: You will need to pass in an i18next instance by using initReactI18next');
        const notReadyT = (k, optsOrDefaultValue)=>{
            if ((0, $445d14444882807b$export$844ec244b1367d54)(optsOrDefaultValue)) return optsOrDefaultValue;
            if ((0, $445d14444882807b$export$a6cdc56e425d0d0a)(optsOrDefaultValue) && (0, $445d14444882807b$export$844ec244b1367d54)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react?.wait) (0, $445d14444882807b$export$5b28268982f175ba)(i18n, 'DEPRECATED_OPTION', 'useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
    const i18nOptions = {
        ...(0, $ba1062cc0d1f4b93$export$212bb2fc580a90a8)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options?.defaultNS;
    namespaces = (0, $445d14444882807b$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    i18n.reportNamespaces.addUsedNamespaces?.(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $445d14444882807b$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
    const memoGetT = $9c081519ec78392c$var$useMemoizedT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const getT = ()=>memoGetT;
    const getNewT = ()=>$9c081519ec78392c$var$alwaysNewT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const [t, setT] = (0, $7fPBF.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = $9c081519ec78392c$var$usePrevious(joinedNS);
    const isMounted = (0, $7fPBF.useRef)(true);
    (0, $7fPBF.useEffect)(()=>{
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $445d14444882807b$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
            else (0, $445d14444882807b$export$83be934b53fff43b)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getNewT);
        const boundReset = ()=>{
            if (isMounted.current) setT(getNewT);
        };
        if (bindI18n) i18n?.on(bindI18n, boundReset);
        if (bindI18nStore) i18n?.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (i18n && bindI18n) bindI18n?.split(' ').forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (isMounted.current && ready) setT(getT);
    }, [
        i18n,
        keyPrefix,
        ready
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, $445d14444882807b$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, $445d14444882807b$export$83be934b53fff43b)(i18n, namespaces, ()=>resolve());
    });
};



var $7fPBF = parcelRequire("7fPBF");


const $1b9d18dce12af9e0$export$2dcb0053efd21124 = (ns, options = {})=>function Extend(WrappedComponent) {
        function I18nextWithTranslation({ forwardedRef: forwardedRef, ...rest }) {
            const [t, i18n, ready] = (0, $9c081519ec78392c$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $7fPBF.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $445d14444882807b$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $7fPBF.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $7fPBF.forwardRef)(forwardRef) : I18nextWithTranslation;
    };



const $1123dfab2acde046$export$b63289fbda65eed1 = ({ ns: ns, children: children, ...options })=>{
    const [t, i18n, ready] = (0, $9c081519ec78392c$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
};



var $7fPBF = parcelRequire("7fPBF");

function $f40df753886fac13$export$1325e8699caa160f({ i18n: i18n, defaultNS: defaultNS, children: children }) {
    const value = (0, $7fPBF.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $7fPBF.createElement)((0, $021c8539c0651064$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

const $6dc6e4594d06aae3$export$3526fb65ade8d8b7 = (initialI18nStore, initialLanguage, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $7fPBF.useContext)((0, $021c8539c0651064$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $91a4dd25d142fe34$export$64af334f494c2f47)();
    if (i18n.options?.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
};




const $25e3a7ece768866e$export$80dfa519af1c8605 = ()=>function Extend(WrappedComponent) {
        function I18nextWithSSR({ initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest }) {
            (0, $6dc6e4594d06aae3$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $7fPBF.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $021c8539c0651064$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $445d14444882807b$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };







const $2af286126fb112dc$export$324d90190a8b822a = ()=>'';
const $2af286126fb112dc$export$2da9be4cfdb689b1 = ()=>'';
const $2af286126fb112dc$export$98e628dec113755e = ()=>'';
const $2af286126fb112dc$export$2e6c959c16ff56b8 = ()=>'';
const $2af286126fb112dc$export$4e35d5c922a95490 = ()=>'';
const $2af286126fb112dc$export$720a3b9db04b7a0f = ()=>'';


const $4817740e8b777c73$export$d29cf4180255d829 = 'common';
const $4817740e8b777c73$export$41fc20bb625e8618 = [
    'common',
    'error',
    'tour',
    'usecases'
];
const $4817740e8b777c73$export$bc99aaabaf7b70a7 = {
    en: {
        common: (0, (/*@__PURE__*/$parcel$interopDefault($46e9372b918c82e5$exports))),
        error: (0, (/*@__PURE__*/$parcel$interopDefault($7cbcf568110a7c9e$exports))),
        tour: (0, (/*@__PURE__*/$parcel$interopDefault($2db1ccc6f838feb6$exports))),
        usecases: (0, (/*@__PURE__*/$parcel$interopDefault($f2a7e1c8dd4452db$exports)))
    },
    es: {
        common: (0, (/*@__PURE__*/$parcel$interopDefault($2e86342825d3cea0$exports))),
        error: (0, (/*@__PURE__*/$parcel$interopDefault($f3b28415484efa10$exports))),
        tour: (0, (/*@__PURE__*/$parcel$interopDefault($b575a9a6bac1cad6$exports))),
        usecases: (0, (/*@__PURE__*/$parcel$interopDefault($501d8d6df9954de7$exports)))
    },
    fr: {
        common: (0, (/*@__PURE__*/$parcel$interopDefault($8adc0445bd2a69d3$exports))),
        error: (0, (/*@__PURE__*/$parcel$interopDefault($e182c8d7a6bdad6a$exports))),
        tour: (0, (/*@__PURE__*/$parcel$interopDefault($647dd474a4538087$exports))),
        usecases: (0, (/*@__PURE__*/$parcel$interopDefault($7d9261ac2fd5b6b6$exports)))
    },
    it: {
        common: (0, (/*@__PURE__*/$parcel$interopDefault($155a07bb3e087efa$exports))),
        error: (0, (/*@__PURE__*/$parcel$interopDefault($b25c88c429ae6c78$exports))),
        tour: (0, (/*@__PURE__*/$parcel$interopDefault($bd5ea8d28885a1b5$exports))),
        usecases: (0, (/*@__PURE__*/$parcel$interopDefault($8e153465ce61e1ac$exports)))
    },
    de: {
        common: (0, (/*@__PURE__*/$parcel$interopDefault($3fc11051985d0b09$exports))),
        error: (0, (/*@__PURE__*/$parcel$interopDefault($00d894b7ec9a312b$exports))),
        tour: (0, (/*@__PURE__*/$parcel$interopDefault($a20b4edf601225c9$exports))),
        usecases: (0, (/*@__PURE__*/$parcel$interopDefault($9334e2246d11ce3e$exports)))
    },
    ja: {
        common: (0, (/*@__PURE__*/$parcel$interopDefault($a02703834f50dafc$exports))),
        error: (0, (/*@__PURE__*/$parcel$interopDefault($8e6856e76156b5da$exports))),
        tour: (0, (/*@__PURE__*/$parcel$interopDefault($0fb65a16e8d9a99f$exports))),
        usecases: (0, (/*@__PURE__*/$parcel$interopDefault($3a6703d76fc08995$exports)))
    }
};
// set to true to enable pseudo localization
const $4817740e8b777c73$var$pseudoEnabled = false; // process.env.ENABLED_ENVIRONMENT == "dev";
(0, $1e580fbd50c9e2d3$export$2e2bcd8739ae039)// .use(
//     new Pseudo({
//         enabled: pseudoEnabled,
//         letterMultiplier: 1,
//     })
// )
.use((0, $09536692873e4879$export$ae7e14d40d89f296)).use((0, $fcb831e2a23edeea$export$2e2bcd8739ae039)).use((0, $f73f86de2138df56$export$2e2bcd8739ae039)).init({
    returnNull: false,
    defaultNS: $4817740e8b777c73$export$d29cf4180255d829,
    ns: $4817740e8b777c73$export$41fc20bb625e8618,
    resources: $4817740e8b777c73$export$bc99aaabaf7b70a7,
    interpolation: {
        escapeValue: false
    },
    debug: false,
    fallbackLng: (0, $3ecd3f7dea3d56de$export$c89f3ba9a8ee8018),
    fallbackNS: $4817740e8b777c73$export$d29cf4180255d829,
    postProcess: [
        'pseudo'
    ],
    partialBundledLanguages: true,
    backend: {
        // HttpBackend options
        loadPath: '/locales/{{lng}}/{{ns}}.json'
    },
    detection: {
        order: [
            'localStorage',
            'navigator'
        ],
        lookupLocalStorage: 'displayLocale'
    },
    lowerCaseLng: true,
    load: 'languageOnly'
});
var $4817740e8b777c73$export$2e2bcd8739ae039 = (0, $1e580fbd50c9e2d3$export$2e2bcd8739ae039);


var $f11ec298ebcca059$export$882461b6382ed46c;
var $f11ec298ebcca059$export$757ceba2d55c277e;
'use strict';
var $b4ba1c853f6e1116$exports = {};
'use strict';
function $b4ba1c853f6e1116$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b4ba1c853f6e1116$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b4ba1c853f6e1116$var$checkDCE();

$b4ba1c853f6e1116$exports = (parcelRequire("6EA3T"));


var $f11ec298ebcca059$var$i;
$f11ec298ebcca059$export$882461b6382ed46c = $b4ba1c853f6e1116$exports.createRoot;
$f11ec298ebcca059$export$757ceba2d55c277e = $b4ba1c853f6e1116$exports.hydrateRoot;




function $939dffaddf93a85b$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $7fPBF = parcelRequire("7fPBF");

/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param defaultProps
 * @param props
 * @returns resolved props
 */ function $bdfe01df7c24351f$export$2e2bcd8739ae039(defaultProps, props) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = $bdfe01df7c24351f$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                }
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}


function $fdf252551f75687d$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $bdfe01df7c24351f$export$2e2bcd8739ae039)(theme.components[name].defaultProps, props);
}




var $7fPBF = parcelRequire("7fPBF");

'use client';
function $f85b78a6cc253b21$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $f85b78a6cc253b21$var$useTheme(defaultTheme = null) {
    const contextTheme = $7fPBF.useContext((0, $d62c6f18f523e962$export$971d5caa766a69d7));
    return !contextTheme || $f85b78a6cc253b21$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $f85b78a6cc253b21$export$2e2bcd8739ae039 = $f85b78a6cc253b21$var$useTheme;


'use client';
const $c44ae2e7a62d29e0$export$35e57303dbd8a66 = (0, $c6ae1e3a98d0d5b8$export$2e2bcd8739ae039)();
function $c44ae2e7a62d29e0$var$useTheme(defaultTheme = $c44ae2e7a62d29e0$export$35e57303dbd8a66) {
    return (0, $f85b78a6cc253b21$export$2e2bcd8739ae039)(defaultTheme);
}
var $c44ae2e7a62d29e0$export$2e2bcd8739ae039 = $c44ae2e7a62d29e0$var$useTheme;


'use client';
function $28e571e09dc390d3$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $c44ae2e7a62d29e0$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, $fdf252551f75687d$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
}



'use client';
const $726fe1d2377a5002$var$defaultTheme = (0, $ca3239ce6bf6e490$export$2e2bcd8739ae039)();
var $726fe1d2377a5002$export$2e2bcd8739ae039 = $726fe1d2377a5002$var$defaultTheme;


var $e35ef6915a224202$export$2e2bcd8739ae039 = '$$material';


'use client';
function $3dd0e9417d40119e$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $28e571e09dc390d3$export$2e2bcd8739ae039)({
        props: props,
        name: name,
        defaultTheme: $726fe1d2377a5002$export$2e2bcd8739ae039,
        themeId: (0, $e35ef6915a224202$export$2e2bcd8739ae039)
    });
}



'use client';
const $cbc6c65ed9f8bf86$var$_excluded = [
    "localeText"
];
const $cbc6c65ed9f8bf86$export$544976378534cf9 = /*#__PURE__*/ $7fPBF.createContext(null);
const $cbc6c65ed9f8bf86$export$dc45bdc734ce6f1e = function LocalizationProvider(inProps) {
    const { localeText: inLocaleText } = inProps, otherInProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(inProps, $cbc6c65ed9f8bf86$var$_excluded);
    const { utils: parentUtils, localeText: parentLocaleText } = $7fPBF.useContext($cbc6c65ed9f8bf86$export$544976378534cf9) ?? {
        utils: undefined,
        localeText: undefined
    };
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
        // We will then merge this theme value with our value manually
        props: otherInProps,
        name: 'MuiLocalizationProvider'
    });
    const { children: children, dateAdapter: DateAdapter, dateFormats: dateFormats, dateLibInstance: dateLibInstance, adapterLocale: adapterLocale, localeText: themeLocaleText } = props;
    const localeText = $7fPBF.useMemo(()=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, themeLocaleText, parentLocaleText, inLocaleText), [
        themeLocaleText,
        parentLocaleText,
        inLocaleText
    ]);
    const utils = $7fPBF.useMemo(()=>{
        if (!DateAdapter) {
            if (parentUtils) return parentUtils;
            return null;
        }
        const adapter = new DateAdapter({
            locale: adapterLocale,
            formats: dateFormats,
            instance: dateLibInstance
        });
        if (!adapter.isMUIAdapter) throw new Error([
            'MUI X: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`',
            "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`",
            'More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation'
        ].join(`\n`));
        return adapter;
    }, [
        DateAdapter,
        adapterLocale,
        dateFormats,
        dateLibInstance,
        parentUtils
    ]);
    const defaultDates = $7fPBF.useMemo(()=>{
        if (!utils) return null;
        return {
            minDate: utils.date('1900-01-01T00:00:00.000'),
            maxDate: utils.date('2099-12-31T00:00:00.000')
        };
    }, [
        utils
    ]);
    const contextValue = $7fPBF.useMemo(()=>{
        return {
            utils: utils,
            defaultDates: defaultDates,
            localeText: localeText
        };
    }, [
        defaultDates,
        utils,
        localeText
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($cbc6c65ed9f8bf86$export$544976378534cf9.Provider, {
        value: contextValue,
        children: children
    });
};



var $615652efb7481f32$exports = {};
!function(t, e) {
    $615652efb7481f32$exports = e();
}($615652efb7481f32$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});


var $623ecd0fd8e4aed5$exports = {};
!function(e, t) {
    $623ecd0fd8e4aed5$exports = t();
}($623ecd0fd8e4aed5$exports, function() {
    "use strict";
    var e = "week", t = "year";
    return function(i, n, r) {
        var f = n.prototype;
        f.week = function(i) {
            if (void 0 === i && (i = null), null !== i) return this.add(7 * (i - this.week()), "day");
            var n = this.$locale().yearStart || 1;
            if (11 === this.month() && this.date() > 25) {
                var f = r(this).startOf(t).add(1, t).date(n), s = r(this).endOf(e);
                if (f.isBefore(s)) return 1;
            }
            var a = r(this).startOf(t).date(n).startOf(e).subtract(1, "millisecond"), o = this.diff(a, e, !0);
            return o < 0 ? r(this).startOf("week").week() : Math.ceil(o);
        }, f.weeks = function(e) {
            return void 0 === e && (e = null), this.week(e);
        };
    };
});


var $f31b2d9172e2fa32$exports = {};
!function(e, t) {
    $f31b2d9172e2fa32$exports = t();
}($f31b2d9172e2fa32$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, a = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var f = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, h = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], u = function(e) {
        var t = s[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, d = function(e, t) {
        var n, r = s.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, c = {
        A: [
            o,
            function(e) {
                this.afternoon = d(e, !1);
            }
        ],
        a: [
            o,
            function(e) {
                this.afternoon = d(e, !0);
            }
        ],
        Q: [
            n,
            function(e) {
                this.month = 3 * (e - 1) + 1;
            }
        ],
        S: [
            n,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            r,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            i,
            f("seconds")
        ],
        ss: [
            i,
            f("seconds")
        ],
        m: [
            i,
            f("minutes")
        ],
        mm: [
            i,
            f("minutes")
        ],
        H: [
            i,
            f("hours")
        ],
        h: [
            i,
            f("hours")
        ],
        HH: [
            i,
            f("hours")
        ],
        hh: [
            i,
            f("hours")
        ],
        D: [
            i,
            f("day")
        ],
        DD: [
            r,
            f("day")
        ],
        Do: [
            o,
            function(e) {
                var t = s.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        w: [
            i,
            f("week")
        ],
        ww: [
            r,
            f("week")
        ],
        M: [
            i,
            f("month")
        ],
        MM: [
            r,
            f("month")
        ],
        MMM: [
            o,
            function(e) {
                var t = u("months"), n = (u("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            o,
            function(e) {
                var t = u("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            f("year")
        ],
        YY: [
            r,
            function(e) {
                this.year = a(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            f("year")
        ],
        Z: h,
        ZZ: h
    };
    function l(n) {
        var r, i;
        r = n, i = s && s.formats;
        for(var o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = o.length, f = 0; f < a; f += 1){
            var h = o[f], u = c[h], d = u && u[0], l = u && u[1];
            o[f] = l ? {
                regex: d,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = o[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var s = i.regex, f = i.parser, h = e.slice(r), u = s.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (a = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, o = e.args;
            this.$u = r;
            var a = o[1];
            if ("string" == typeof a) {
                var f = !0 === o[2], h = !0 === o[3], u = f || h, d = o[2];
                h && (d = o[2]), s = this.$locale(), !f && d && (s = n.Ls[d]), this.$d = function(e, t, n, r) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var i = l(t)(e), o = i.year, s = i.month, a = i.day, f = i.hours, h = i.minutes, u = i.seconds, d = i.milliseconds, c = i.zone, m = i.week, M = new Date, Y = a || (o || s ? 1 : M.getDate()), p = o || M.getFullYear(), v = 0;
                        o && !s || (v = s > 0 ? s - 1 : M.getMonth());
                        var D, w = f || 0, g = h || 0, y = u || 0, L = d || 0;
                        return c ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c.offset * 1e3)) : n ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m && (D = r(D).week(m).toDate()), D);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
            } else if (a instanceof Array) for(var c = a.length, m = 1; m <= c; m += 1){
                o[1] = a[m - 1];
                var M = n.apply(this, o);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === c && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});


var $7c31004894e2ce7c$exports = {};
!function(e, t) {
    $7c31004894e2ce7c$exports = t();
}($7c31004894e2ce7c$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    return function(t, o, n) {
        var r = o.prototype, i = r.format;
        n.en.formats = e, r.format = function(t) {
            void 0 === t && (t = "YYYY-MM-DDTHH:mm:ssZ");
            var o = this.$locale().formats, n = function(t, o) {
                return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
                    var i = r && r.toUpperCase();
                    return n || o[r] || e[r] || o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, o) {
                        return t || o.slice(1);
                    });
                });
            }(t, void 0 === o ? {} : o);
            return i.call(this, n);
        };
    };
});


var $6a47e7d083ad10fd$exports = {};
!function(e, i) {
    $6a47e7d083ad10fd$exports = i();
}($6a47e7d083ad10fd$exports, function() {
    "use strict";
    return function(e, i, t) {
        i.prototype.isBetween = function(e, i, s, f) {
            var n = t(e), o = t(i), r = "(" === (f = f || "()")[0], u = ")" === f[1];
            return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u ? this.isAfter(o, s) : !this.isBefore(o, s));
        };
    };
});


var $af0b8cdb79055738$exports = {};
!function(e, t) {
    $af0b8cdb79055738$exports = t();
}($af0b8cdb79055738$exports, function() {
    "use strict";
    return function(e, t) {
        var r = t.prototype, n = r.format;
        r.format = function(e) {
            var t = this, r = this.$locale();
            if (!this.isValid()) return n.bind(this)(e);
            var s = this.$utils(), a = (e || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(e) {
                switch(e){
                    case "Q":
                        return Math.ceil((t.$M + 1) / 3);
                    case "Do":
                        return r.ordinal(t.$D);
                    case "gggg":
                        return t.weekYear();
                    case "GGGG":
                        return t.isoWeekYear();
                    case "wo":
                        return r.ordinal(t.week(), "W");
                    case "w":
                    case "ww":
                        return s.s(t.week(), "w" === e ? 1 : 2, "0");
                    case "W":
                    case "WW":
                        return s.s(t.isoWeek(), "W" === e ? 1 : 2, "0");
                    case "k":
                    case "kk":
                        return s.s(String(0 === t.$H ? 24 : t.$H), "k" === e ? 1 : 2, "0");
                    case "X":
                        return Math.floor(t.$d.getTime() / 1e3);
                    case "x":
                        return t.$d.getTime();
                    case "z":
                        return "[" + t.offsetName() + "]";
                    case "zzz":
                        return "[" + t.offsetName("long") + "]";
                    default:
                        return e;
                }
            });
            return n.bind(this)(a);
        };
    };
});



(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($7c31004894e2ce7c$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($623ecd0fd8e4aed5$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($6a47e7d083ad10fd$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($af0b8cdb79055738$exports))));
const $3281ad3dbde45caa$var$formatTokenMap = {
    // Year
    YY: 'year',
    YYYY: {
        sectionType: 'year',
        contentType: 'digit',
        maxLength: 4
    },
    // Month
    M: {
        sectionType: 'month',
        contentType: 'digit',
        maxLength: 2
    },
    MM: 'month',
    MMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    MMMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    // Day of the month
    D: {
        sectionType: 'day',
        contentType: 'digit',
        maxLength: 2
    },
    DD: 'day',
    Do: {
        sectionType: 'day',
        contentType: 'digit-with-letter'
    },
    // Day of the week
    d: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 2
    },
    dd: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    ddd: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    dddd: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    // Meridiem
    A: 'meridiem',
    a: 'meridiem',
    // Hours
    H: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    HH: 'hours',
    h: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    hh: 'hours',
    // Minutes
    m: {
        sectionType: 'minutes',
        contentType: 'digit',
        maxLength: 2
    },
    mm: 'minutes',
    // Seconds
    s: {
        sectionType: 'seconds',
        contentType: 'digit',
        maxLength: 2
    },
    ss: 'seconds'
};
const $3281ad3dbde45caa$var$defaultFormats = {
    year: 'YYYY',
    month: 'MMMM',
    monthShort: 'MMM',
    dayOfMonth: 'D',
    dayOfMonthFull: 'Do',
    weekday: 'dddd',
    weekdayShort: 'dd',
    hours24h: 'HH',
    hours12h: 'hh',
    meridiem: 'A',
    minutes: 'mm',
    seconds: 'ss',
    fullDate: 'll',
    keyboardDate: 'L',
    shortDate: 'MMM D',
    normalDate: 'D MMMM',
    normalDateWithWeekday: 'ddd, MMM D',
    fullTime: 'LT',
    fullTime12h: 'hh:mm A',
    fullTime24h: 'HH:mm',
    keyboardDateTime: 'L LT',
    keyboardDateTime12h: 'L hh:mm A',
    keyboardDateTime24h: 'L HH:mm'
};
const $3281ad3dbde45caa$var$MISSING_UTC_PLUGIN = [
    'Missing UTC plugin',
    'To be able to use UTC or timezones, you have to enable the `utc` plugin',
    'Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-utc'
].join('\n');
const $3281ad3dbde45caa$var$MISSING_TIMEZONE_PLUGIN = [
    'Missing timezone plugin',
    'To be able to use timezones, you have to enable both the `utc` and the `timezone` plugin',
    'Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-timezone'
].join('\n');
const $3281ad3dbde45caa$var$withLocale = (dayjs, locale)=>!locale ? dayjs : (...args)=>dayjs(...args).locale(locale);
class $3281ad3dbde45caa$export$33545c6a80bae043 {
    constructor({ locale: _locale, formats: formats } = {}){
        this.isMUIAdapter = true;
        this.isTimezoneCompatible = true;
        this.lib = 'dayjs';
        this.dayjs = void 0;
        this.locale = void 0;
        this.formats = void 0;
        this.escapedCharacters = {
            start: '[',
            end: ']'
        };
        this.formatTokenMap = $3281ad3dbde45caa$var$formatTokenMap;
        this.setLocaleToValue = (value)=>{
            const expectedLocale = this.getCurrentLocaleCode();
            if (expectedLocale === value.locale()) return value;
            return value.locale(expectedLocale);
        };
        this.hasUTCPlugin = ()=>typeof (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc !== 'undefined';
        this.hasTimezonePlugin = ()=>typeof (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).tz !== 'undefined';
        this.isSame = (value, comparing, comparisonTemplate)=>{
            const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
            return value.format(comparisonTemplate) === comparingInValueTimezone.format(comparisonTemplate);
        };
        /**
     * Replaces "default" by undefined and "system" by the system timezone before passing it to `dayjs`.
     */ this.cleanTimezone = (timezone)=>{
            switch(timezone){
                case 'default':
                    return undefined;
                case 'system':
                    return (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).tz.guess();
                default:
                    return timezone;
            }
        };
        this.createSystemDate = (value)=>{
            if (this.hasUTCPlugin() && this.hasTimezonePlugin()) {
                const timezone = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).tz.guess();
                // We can't change the system timezone in the tests
                /* istanbul ignore next */ if (timezone !== 'UTC') return (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).tz(value, timezone);
                return (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(value);
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(value);
        };
        this.createUTCDate = (value)=>{
            /* istanbul ignore next */ if (!this.hasUTCPlugin()) throw new Error($3281ad3dbde45caa$var$MISSING_UTC_PLUGIN);
            return (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(value);
        };
        this.createTZDate = (value, timezone)=>{
            /* istanbul ignore next */ if (!this.hasUTCPlugin()) throw new Error($3281ad3dbde45caa$var$MISSING_UTC_PLUGIN);
            /* istanbul ignore next */ if (!this.hasTimezonePlugin()) throw new Error($3281ad3dbde45caa$var$MISSING_TIMEZONE_PLUGIN);
            const keepLocalTime = value !== undefined && !value.endsWith('Z');
            return (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(value).tz(this.cleanTimezone(timezone), keepLocalTime);
        };
        this.getLocaleFormats = ()=>{
            const locales = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).Ls;
            const locale = this.locale || 'en';
            let localeObject = locales[locale];
            if (localeObject === undefined) localeObject = locales.en;
            return localeObject.formats;
        };
        /**
     * If the new day does not have the same offset as the old one (when switching to summer day time for example),
     * Then dayjs will not automatically adjust the offset (moment does).
     * We have to parse again the value to make sure the `fixOffset` method is applied.
     * See https://github.com/iamkun/dayjs/blob/b3624de619d6e734cd0ffdbbd3502185041c1b60/src/plugin/timezone/index.js#L72
     */ this.adjustOffset = (value)=>{
            if (!this.hasTimezonePlugin()) return value;
            const timezone = this.getTimezone(value);
            if (timezone !== 'UTC') {
                const fixedValue = value.tz(this.cleanTimezone(timezone), true);
                // TODO: Simplify the case when we raise the `dayjs` peer dep to 1.11.12 (https://github.com/iamkun/dayjs/releases/tag/v1.11.12)
                /* istanbul ignore next */ // @ts-ignore
                if (fixedValue.$offset === (value.$offset ?? 0)) return value;
                // Change only what is needed to avoid creating a new object with unwanted data
                // Especially important when used in an environment where utc or timezone dates are used only in some places
                // Reference: https://github.com/mui/mui-x/issues/13290
                // @ts-ignore
                value.$offset = fixedValue.$offset;
            }
            return value;
        };
        this.date = (value, timezone = 'default')=>{
            if (value === null) return null;
            let parsedValue;
            if (timezone === 'UTC') parsedValue = this.createUTCDate(value);
            else if (timezone === 'system' || timezone === 'default' && !this.hasTimezonePlugin()) parsedValue = this.createSystemDate(value);
            else parsedValue = this.createTZDate(value, timezone);
            if (this.locale === undefined) return parsedValue;
            return parsedValue.locale(this.locale);
        };
        this.getInvalidDate = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(new Date('Invalid date'));
        this.getTimezone = (value)=>{
            if (this.hasTimezonePlugin()) {
                // @ts-ignore
                const zone = value.$x?.$timezone;
                if (zone) return zone;
            }
            if (this.hasUTCPlugin() && value.isUTC()) return 'UTC';
            return 'system';
        };
        this.setTimezone = (value, timezone)=>{
            if (this.getTimezone(value) === timezone) return value;
            if (timezone === 'UTC') {
                /* istanbul ignore next */ if (!this.hasUTCPlugin()) throw new Error($3281ad3dbde45caa$var$MISSING_UTC_PLUGIN);
                return value.utc();
            }
            // We know that we have the UTC plugin.
            // Otherwise, the value timezone would always equal "system".
            // And it would be caught by the first "if" of this method.
            if (timezone === 'system') return value.local();
            if (!this.hasTimezonePlugin()) {
                if (timezone === 'default') return value;
                /* istanbul ignore next */ throw new Error($3281ad3dbde45caa$var$MISSING_TIMEZONE_PLUGIN);
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).tz(value, this.cleanTimezone(timezone));
        };
        this.toJsDate = (value)=>{
            return value.toDate();
        };
        this.parse = (value, format)=>{
            if (value === '') return null;
            return this.dayjs(value, format, this.locale, true);
        };
        this.getCurrentLocaleCode = ()=>{
            return this.locale || 'en';
        };
        this.is12HourCycleInCurrentLocale = ()=>{
            /* istanbul ignore next */ return /A|a/.test(this.getLocaleFormats().LT || '');
        };
        this.expandFormat = (format)=>{
            const localeFormats = this.getLocaleFormats();
            // @see https://github.com/iamkun/dayjs/blob/dev/src/plugin/localizedFormat/index.js
            const t = (formatBis)=>formatBis.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (_, a, b)=>a || b.slice(1));
            return format.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (_, a, b)=>{
                const B = b && b.toUpperCase();
                return a || localeFormats[b] || t(localeFormats[B]);
            });
        };
        this.isValid = (value)=>{
            if (value == null) return false;
            return value.isValid();
        };
        this.format = (value, formatKey)=>{
            return this.formatByString(value, this.formats[formatKey]);
        };
        this.formatByString = (value, formatString)=>{
            return this.dayjs(value).format(formatString);
        };
        this.formatNumber = (numberToFormat)=>{
            return numberToFormat;
        };
        this.isEqual = (value, comparing)=>{
            if (value === null && comparing === null) return true;
            if (value === null || comparing === null) return false;
            return value.toDate().getTime() === comparing.toDate().getTime();
        };
        this.isSameYear = (value, comparing)=>{
            return this.isSame(value, comparing, 'YYYY');
        };
        this.isSameMonth = (value, comparing)=>{
            return this.isSame(value, comparing, 'YYYY-MM');
        };
        this.isSameDay = (value, comparing)=>{
            return this.isSame(value, comparing, 'YYYY-MM-DD');
        };
        this.isSameHour = (value, comparing)=>{
            return value.isSame(comparing, 'hour');
        };
        this.isAfter = (value, comparing)=>{
            return value > comparing;
        };
        this.isAfterYear = (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isAfter(comparing, 'year');
            return !this.isSameYear(value, comparing) && value.utc() > comparing.utc();
        };
        this.isAfterDay = (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isAfter(comparing, 'day');
            return !this.isSameDay(value, comparing) && value.utc() > comparing.utc();
        };
        this.isBefore = (value, comparing)=>{
            return value < comparing;
        };
        this.isBeforeYear = (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isBefore(comparing, 'year');
            return !this.isSameYear(value, comparing) && value.utc() < comparing.utc();
        };
        this.isBeforeDay = (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isBefore(comparing, 'day');
            return !this.isSameDay(value, comparing) && value.utc() < comparing.utc();
        };
        this.isWithinRange = (value, [start, end])=>{
            return value >= start && value <= end;
        };
        this.startOfYear = (value)=>{
            return this.adjustOffset(value.startOf('year'));
        };
        this.startOfMonth = (value)=>{
            return this.adjustOffset(value.startOf('month'));
        };
        this.startOfWeek = (value)=>{
            return this.adjustOffset(this.setLocaleToValue(value).startOf('week'));
        };
        this.startOfDay = (value)=>{
            return this.adjustOffset(value.startOf('day'));
        };
        this.endOfYear = (value)=>{
            return this.adjustOffset(value.endOf('year'));
        };
        this.endOfMonth = (value)=>{
            return this.adjustOffset(value.endOf('month'));
        };
        this.endOfWeek = (value)=>{
            return this.adjustOffset(this.setLocaleToValue(value).endOf('week'));
        };
        this.endOfDay = (value)=>{
            return this.adjustOffset(value.endOf('day'));
        };
        this.addYears = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'year') : value.add(amount, 'year'));
        };
        this.addMonths = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'month') : value.add(amount, 'month'));
        };
        this.addWeeks = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'week') : value.add(amount, 'week'));
        };
        this.addDays = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'day') : value.add(amount, 'day'));
        };
        this.addHours = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'hour') : value.add(amount, 'hour'));
        };
        this.addMinutes = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'minute') : value.add(amount, 'minute'));
        };
        this.addSeconds = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'second') : value.add(amount, 'second'));
        };
        this.getYear = (value)=>{
            return value.year();
        };
        this.getMonth = (value)=>{
            return value.month();
        };
        this.getDate = (value)=>{
            return value.date();
        };
        this.getHours = (value)=>{
            return value.hour();
        };
        this.getMinutes = (value)=>{
            return value.minute();
        };
        this.getSeconds = (value)=>{
            return value.second();
        };
        this.getMilliseconds = (value)=>{
            return value.millisecond();
        };
        this.setYear = (value, year)=>{
            return this.adjustOffset(value.set('year', year));
        };
        this.setMonth = (value, month)=>{
            return this.adjustOffset(value.set('month', month));
        };
        this.setDate = (value, date)=>{
            return this.adjustOffset(value.set('date', date));
        };
        this.setHours = (value, hours)=>{
            return this.adjustOffset(value.set('hour', hours));
        };
        this.setMinutes = (value, minutes)=>{
            return this.adjustOffset(value.set('minute', minutes));
        };
        this.setSeconds = (value, seconds)=>{
            return this.adjustOffset(value.set('second', seconds));
        };
        this.setMilliseconds = (value, milliseconds)=>{
            return this.adjustOffset(value.set('millisecond', milliseconds));
        };
        this.getDaysInMonth = (value)=>{
            return value.daysInMonth();
        };
        this.getWeekArray = (value)=>{
            const start = this.startOfWeek(this.startOfMonth(value));
            const end = this.endOfWeek(this.endOfMonth(value));
            let count = 0;
            let current = start;
            const nestedWeeks = [];
            while(current < end){
                const weekNumber = Math.floor(count / 7);
                nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
                nestedWeeks[weekNumber].push(current);
                current = this.addDays(current, 1);
                count += 1;
            }
            return nestedWeeks;
        };
        this.getWeekNumber = (value)=>{
            return value.week();
        };
        this.getYearRange = ([start, end])=>{
            const startDate = this.startOfYear(start);
            const endDate = this.endOfYear(end);
            const years = [];
            let current = startDate;
            while(this.isBefore(current, endDate)){
                years.push(current);
                current = this.addYears(current, 1);
            }
            return years;
        };
        this.dayjs = $3281ad3dbde45caa$var$withLocale((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))), _locale);
        this.locale = _locale;
        this.formats = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $3281ad3dbde45caa$var$defaultFormats, formats);
        // Moved plugins to the constructor to allow for users to use options on the library
        // for reference: https://github.com/mui/mui-x/pull/11151
        (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($f31b2d9172e2fa32$exports))));
    }
    getDayOfWeek(value) {
        return value.day() + 1;
    }
}









var $7fPBF = parcelRequire("7fPBF");

// eslint-disable-next-line no-undef
var $742aea85e4e67b26$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $742aea85e4e67b26$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $3587f7e2ed7416b3$export$2e2bcd8739ae039)(function(prop) {
    return $742aea85e4e67b26$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});


var $2078ce513e00dfd7$var$isDevelopment = false;
var $2078ce513e00dfd7$var$testOmitPropsOnStringTag = (0, $742aea85e4e67b26$export$2e2bcd8739ae039);
var $2078ce513e00dfd7$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $2078ce513e00dfd7$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $2078ce513e00dfd7$var$testOmitPropsOnStringTag : $2078ce513e00dfd7$var$testOmitPropsOnComponent;
};
var $2078ce513e00dfd7$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $2078ce513e00dfd7$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $48e4b1fcfcd646c1$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $b2729db54ba7ee9b$export$db21c7ffa21794e7)(function() {
        return (0, $48e4b1fcfcd646c1$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $2078ce513e00dfd7$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $2078ce513e00dfd7$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $2078ce513e00dfd7$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $d62c6f18f523e962$export$efccba1c4a2ef57b)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $7fPBF.useContext((0, $d62c6f18f523e962$export$971d5caa766a69d7));
            }
            if (typeof props.className === 'string') className = (0, $48e4b1fcfcd646c1$export$95d99596f328fd52)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $2078ce513e00dfd7$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($2078ce513e00dfd7$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $7fPBF.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $2078ce513e00dfd7$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, options, nextOptions, {
                shouldForwardProp: $2078ce513e00dfd7$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};







parcelRequire("7fPBF");

var $8de346382d86c747$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $8de346382d86c747$export$2e2bcd8739ae039 = (0, $2078ce513e00dfd7$export$2e2bcd8739ae039).bind(null);
$8de346382d86c747$var$tags.forEach(function(tagName) {
    $8de346382d86c747$export$2e2bcd8739ae039[tagName] = $8de346382d86c747$export$2e2bcd8739ae039(tagName);
});



const $19e0bc52fddd02b4$var$DefaultStyles = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    button,
    a {
        &:focus {
            outline: ${(0, $8951886a6b49e92a$export$35e9368ef982300f).accent} auto 2px;
        }
    }
    a {
        text-decoration: none;
    }
    * {
        font-family:
            'Archivo',
            system-ui,
            -apple-system,
            BlinkMacSystemFont,
            'Segoe UI',
            Ubuntu,
            'Helvetica Neue',
            Oxygen,
            Cantarell,
            sans-serif;
    }
`;
const $19e0bc52fddd02b4$export$87f1b08a59e6d1dd = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
    &:focus-visible {
        outline: 2px dashed ${(0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary_updated} !important;
        outline-offset: 2px;
        z-index: 100;
    }
`;
const $19e0bc52fddd02b4$export$15b02e474f045d64 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
    padding: 0;
    margin: 0;
`;
const $19e0bc52fddd02b4$var$fadeIn = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)`
    from {
        opacity: 0;

    }
    to {
        opacity: 1;

    }
`;
const $19e0bc52fddd02b4$export$db407487374f02c9 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
    animation: ${$19e0bc52fddd02b4$var$fadeIn} 0.5s ease-in-out;
`;
const $19e0bc52fddd02b4$export$29c8ed22df400735 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
    animation: ${$19e0bc52fddd02b4$var$fadeIn} 0.1s ease-in-out;
`;
const $19e0bc52fddd02b4$export$ed89a9014ca4c6b4 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    ${$19e0bc52fddd02b4$export$db407487374f02c9};
`;
var $19e0bc52fddd02b4$export$2e2bcd8739ae039 = $19e0bc52fddd02b4$var$DefaultStyles;





var $7fPBF = parcelRequire("7fPBF");
parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");
'use client';
const $dd87211657db4860$var$ThemeContext = /*#__PURE__*/ $7fPBF.createContext(null);
var $dd87211657db4860$export$2e2bcd8739ae039 = $dd87211657db4860$var$ThemeContext;



var $7fPBF = parcelRequire("7fPBF");

function $e46b55d129f481d9$export$2e2bcd8739ae039() {
    const theme = $7fPBF.useContext((0, $dd87211657db4860$export$2e2bcd8739ae039));
    return theme;
}


const $4c857f7020f41c54$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $4c857f7020f41c54$export$2e2bcd8739ae039 = $4c857f7020f41c54$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';



function $6ad547863bdcfe26$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return {
        ...outerTheme,
        ...localTheme
    };
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $6ad547863bdcfe26$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $e46b55d129f481d9$export$2e2bcd8739ae039)();
    const theme = $7fPBF.useMemo(()=>{
        const output = outerTheme === null ? {
            ...localTheme
        } : $6ad547863bdcfe26$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $4c857f7020f41c54$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd87211657db4860$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $6ad547863bdcfe26$export$2e2bcd8739ae039 = $6ad547863bdcfe26$var$ThemeProvider;






var $7fPBF = parcelRequire("7fPBF");


'use client';
const $0459201d2cf8a80b$var$RtlContext = /*#__PURE__*/ $7fPBF.createContext();
function $0459201d2cf8a80b$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0459201d2cf8a80b$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $0459201d2cf8a80b$export$b2dd014b6c321cb = ()=>{
    const value = $7fPBF.useContext($0459201d2cf8a80b$var$RtlContext);
    return value ?? false;
};
var $0459201d2cf8a80b$export$2e2bcd8739ae039 = $0459201d2cf8a80b$var$RtlProvider;



var $7fPBF = parcelRequire("7fPBF");



'use client';
const $e4c2bf5434c896cc$var$PropsContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
function $e4c2bf5434c896cc$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e4c2bf5434c896cc$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $e4c2bf5434c896cc$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $bdfe01df7c24351f$export$2e2bcd8739ae039)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $bdfe01df7c24351f$export$2e2bcd8739ae039)(config, props);
    return props;
}
function $e4c2bf5434c896cc$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $7fPBF.useContext($e4c2bf5434c896cc$var$PropsContext);
    return $e4c2bf5434c896cc$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $e4c2bf5434c896cc$export$2e2bcd8739ae039 = $e4c2bf5434c896cc$var$DefaultPropsProvider;


parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $fd3794ae41ea97a8$var$useEnhancedEffect = typeof window !== 'undefined' ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
var $fd3794ae41ea97a8$export$2e2bcd8739ae039 = $fd3794ae41ea97a8$var$useEnhancedEffect;



var $7fPBF = parcelRequire("7fPBF");
'use client';
let $46f5b561912058f9$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $46f5b561912058f9$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $7fPBF.useState(idOverride);
    const id = idOverride || defaultId;
    $7fPBF.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $46f5b561912058f9$var$globalId += 1;
            setDefaultId(`mui-${$46f5b561912058f9$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $46f5b561912058f9$var$safeReact = {
    ...$7fPBF
};
const $46f5b561912058f9$var$maybeReactUseId = $46f5b561912058f9$var$safeReact.useId;
function $46f5b561912058f9$export$2e2bcd8739ae039(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($46f5b561912058f9$var$maybeReactUseId !== undefined) {
        const reactId = $46f5b561912058f9$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $46f5b561912058f9$var$useGlobalId(idOverride);
}


parcelRequire("7fPBF");

parcelRequire("7fPBF");



'use client';
function $4f9510cab8f1f9e8$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $4f9510cab8f1f9e8$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($4f9510cab8f1f9e8$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $84f3fdd51733d70b$export$98f03c5d19621d70), {
        styles: globalStyles
    });
}

/**
 * @mui/styled-engine v6.5.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable no-underscore-dangle */ 




function $d1cc2e8a071de52d$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $8de346382d86c747$export$2e2bcd8739ae039)(tag, options);
    var styles, style;
    return stylesFactory;
}
function $d1cc2e8a071de52d$export$592c7226e4cb0171(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $d1cc2e8a071de52d$var$wrapper = [];
function $d1cc2e8a071de52d$export$13a2d3ef13012b32(styles) {
    $d1cc2e8a071de52d$var$wrapper[0] = styles;
    return (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)($d1cc2e8a071de52d$var$wrapper);
}




'use client';
function $a68fc7f0d1abfe1c$var$wrapGlobalLayer(styles) {
    const serialized = (0, $d1cc2e8a071de52d$export$13a2d3ef13012b32)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $a68fc7f0d1abfe1c$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $c44ae2e7a62d29e0$export$2e2bcd8739ae039)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $a68fc7f0d1abfe1c$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $a68fc7f0d1abfe1c$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $a68fc7f0d1abfe1c$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f9510cab8f1f9e8$export$2e2bcd8739ae039), {
        styles: globalStyles
    });
}
var $a68fc7f0d1abfe1c$export$2e2bcd8739ae039 = $a68fc7f0d1abfe1c$var$GlobalStyles;




function $cdab96ef3107baab$export$2e2bcd8739ae039(theme) {
    const upperTheme = (0, $f85b78a6cc253b21$export$2e2bcd8739ae039)();
    const id = (0, $46f5b561912058f9$export$2e2bcd8739ae039)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && firstChild.hasAttribute?.('data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else head.querySelector(`style[data-mui-layer-order="${id}"]`)?.remove();
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a68fc7f0d1abfe1c$export$2e2bcd8739ae039), {
        styles: layerOrder
    });
}



'use client';
const $81b8d739f707ea56$var$EMPTY_THEME = {};
function $81b8d739f707ea56$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $7fPBF.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $81b8d739f707ea56$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $f85b78a6cc253b21$export$2e2bcd8739ae039)($81b8d739f707ea56$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $e46b55d129f481d9$export$2e2bcd8739ae039)() || $81b8d739f707ea56$var$EMPTY_THEME;
    const engineTheme = $81b8d739f707ea56$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $81b8d739f707ea56$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    const layerOrder = (0, $cdab96ef3107baab$export$2e2bcd8739ae039)(engineTheme);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6ad547863bdcfe26$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d62c6f18f523e962$export$971d5caa766a69d7).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0459201d2cf8a80b$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e4c2bf5434c896cc$export$2e2bcd8739ae039), {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var $81b8d739f707ea56$export$2e2bcd8739ae039 = $81b8d739f707ea56$var$ThemeProvider;




'use client';
function $1ad83304ee89086b$export$2e2bcd8739ae039({ theme: themeInput, ...props }) {
    const scopedTheme = (0, $e35ef6915a224202$export$2e2bcd8739ae039) in themeInput ? themeInput[0, $e35ef6915a224202$export$2e2bcd8739ae039] : undefined;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $81b8d739f707ea56$export$2e2bcd8739ae039), {
        ...props,
        themeId: scopedTheme ? (0, $e35ef6915a224202$export$2e2bcd8739ae039) : undefined,
        theme: scopedTheme || themeInput
    });
}


parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");





/**
 * Split this component for RSC import
 */ parcelRequire("7fPBF");

const $f71c49a9b5c696ee$export$ff0fa3047d11164c = 'mode';
const $f71c49a9b5c696ee$export$665054ea9d94dab9 = 'color-scheme';
const $f71c49a9b5c696ee$export$14ebe5b26ee7fb38 = 'data-color-scheme';
function $f71c49a9b5c696ee$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $f71c49a9b5c696ee$export$ff0fa3047d11164c, colorSchemeStorageKey: colorSchemeStorageKey = $f71c49a9b5c696ee$export$665054ea9d94dab9, attribute: initialAttribute = $f71c49a9b5c696ee$export$14ebe5b26ee7fb38, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^\]]+)\]/); // case [data-color-scheme=%s] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split('=');
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}



var $7fPBF = parcelRequire("7fPBF");

function $b48c84105a3cc5d9$var$noop() {}
const $b48c84105a3cc5d9$var$localStorageManager = ({ key: key, storageWindow: storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch  {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch  {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return $b48c84105a3cc5d9$var$noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var $b48c84105a3cc5d9$export$2e2bcd8739ae039 = $b48c84105a3cc5d9$var$localStorageManager;


'use client';
function $5f67b1819d30286d$var$noop() {}
function $5f67b1819d30286d$export$ab3d447356dfa3e5(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $5f67b1819d30286d$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $5f67b1819d30286d$export$3caa7590cc1987bd(state) {
    return $5f67b1819d30286d$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $5f67b1819d30286d$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = (0, $f71c49a9b5c696ee$export$ff0fa3047d11164c), colorSchemeStorageKey: colorSchemeStorageKey = (0, $f71c49a9b5c696ee$export$665054ea9d94dab9), storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, storageManager: storageManager = (0, $b48c84105a3cc5d9$export$2e2bcd8739ae039), noSsr: noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = $7fPBF.useMemo(()=>storageManager?.({
            key: modeStorageKey,
            storageWindow: storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = $7fPBF.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = $7fPBF.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = $7fPBF.useState(()=>{
        const initialMode = modeStorage?.get(defaultMode) || defaultMode;
        const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
        const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: $5f67b1819d30286d$export$ab3d447356dfa3e5(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const [isClient, setIsClient] = $7fPBF.useState(noSsr || !isMultiSchemes);
    $7fPBF.useEffect(()=>{
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = $5f67b1819d30286d$export$3caa7590cc1987bd(state);
    const setMode = $7fPBF.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            modeStorage?.set(newMode);
            return {
                ...currentState,
                mode: newMode,
                systemMode: $5f67b1819d30286d$export$ab3d447356dfa3e5(newMode)
            };
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = $7fPBF.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage?.set(defaultLightColorScheme);
            darkStorage?.set(defaultDarkColorScheme);
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                $5f67b1819d30286d$var$processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage?.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage?.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage?.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage?.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $7fPBF.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event?.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode: systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $7fPBF.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $7fPBF.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $7fPBF.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = modeStorage?.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            }) || $5f67b1819d30286d$var$noop;
            const unsubscribeLight = lightStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            }) || $5f67b1819d30286d$var$noop;
            const unsubscribeDark = darkStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            }) || $5f67b1819d30286d$var$noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    };
}



'use client';
const $3b2614c10151bbd1$export$c09f426c4535c3ec = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $3b2614c10151bbd1$export$2e2bcd8739ae039(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = (0, $f71c49a9b5c696ee$export$ff0fa3047d11164c), colorSchemeStorageKey: defaultColorSchemeStorageKey = (0, $f71c49a9b5c696ee$export$665054ea9d94dab9), disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
    const useColorScheme = ()=>$7fPBF.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageManager: storageManager, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', noSsr: noSsr } = props;
        const hasMounted = $7fPBF.useRef(false);
        const upperTheme = (0, $e46b55d129f481d9$export$2e2bcd8739ae039)();
        const ctx = $7fPBF.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $7fPBF.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes: colorSchemes = defaultColorSchemes, components: components = defaultComponents, cssVarPrefix: cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = $7fPBF.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $5f67b1819d30286d$export$2e2bcd8739ae039)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageManager: storageManager,
            storageWindow: storageWindow,
            noSsr: noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        const memoTheme = $7fPBF.useMemo(()=>{
            // `colorScheme` is undefined on the server and hydration phase
            const calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components: components,
                colorSchemes: colorSchemes,
                cssVarPrefix: cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            colorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $7fPBF.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($3b2614c10151bbd1$export$c09f426c4535c3ec));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $7fPBF.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $7fPBF.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $81b8d739f707ea56$export$2e2bcd8739ae039), {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f9510cab8f1f9e8$export$2e2bcd8739ae039), {
                    styles: memoTheme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $f71c49a9b5c696ee$export$2e2bcd8739ae039)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}





parcelRequire("7fPBF");


const $77af86c63cb046a6$export$f84bd70098573c5c = {
    attribute: 'data-mui-color-scheme',
    colorSchemeStorageKey: 'mui-color-scheme',
    defaultLightColorScheme: 'light',
    defaultDarkColorScheme: 'dark',
    modeStorageKey: 'mui-mode'
};
var $77af86c63cb046a6$export$2e2bcd8739ae039 = function InitColorSchemeScript(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f71c49a9b5c696ee$export$2e2bcd8739ae039), {
        ...$77af86c63cb046a6$export$f84bd70098573c5c,
        ...props
    });
};



'use client';
const { CssVarsProvider: $cd1be95953c44948$var$InternalCssVarsProvider, useColorScheme: $cd1be95953c44948$export$6343629ee1b29116, getInitColorSchemeScript: $cd1be95953c44948$var$deprecatedGetInitColorSchemeScript } = (0, $3b2614c10151bbd1$export$2e2bcd8739ae039)({
    themeId: (0, $e35ef6915a224202$export$2e2bcd8739ae039),
    // @ts-ignore ignore module augmentation tests
    theme: ()=>(0, $ca3239ce6bf6e490$export$2e2bcd8739ae039)({
            cssVariables: true
        }),
    colorSchemeStorageKey: (0, $77af86c63cb046a6$export$f84bd70098573c5c).colorSchemeStorageKey,
    modeStorageKey: (0, $77af86c63cb046a6$export$f84bd70098573c5c).modeStorageKey,
    defaultColorScheme: {
        light: (0, $77af86c63cb046a6$export$f84bd70098573c5c).defaultLightColorScheme,
        dark: (0, $77af86c63cb046a6$export$f84bd70098573c5c).defaultDarkColorScheme
    },
    resolveTheme: (theme)=>{
        const newTheme = {
            ...theme,
            typography: (0, $4027cd084802bc60$export$2e2bcd8739ae039)(theme.palette, theme.typography)
        };
        newTheme.unstable_sx = function sx(props) {
            return (0, $c202727e06c030fc$export$2e2bcd8739ae039)({
                sx: props,
                theme: this
            });
        };
        return newTheme;
    }
});
let $cd1be95953c44948$var$warnedOnce = false;
// TODO: remove in v7
// eslint-disable-next-line @typescript-eslint/naming-convention
function $cd1be95953c44948$export$99adf6d9ed169a14(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($cd1be95953c44948$var$InternalCssVarsProvider, {
        ...props
    });
}
let $cd1be95953c44948$var$warnedInitScriptOnce = false;
// TODO: remove in v7
const $cd1be95953c44948$export$f9a57b4a2abf8ed = (params)=>{
    if (!$cd1be95953c44948$var$warnedInitScriptOnce) {
        console.warn([
            'MUI: The getInitColorSchemeScript function has been deprecated.',
            '',
            "You should use `import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'`",
            'and replace the function call with `<InitColorSchemeScript />` instead.'
        ].join('\n'));
        $cd1be95953c44948$var$warnedInitScriptOnce = true;
    }
    return $cd1be95953c44948$var$deprecatedGetInitColorSchemeScript(params);
};
const $cd1be95953c44948$export$50ec01b133c61652 = $cd1be95953c44948$var$InternalCssVarsProvider;




'use client';
function $b8226d5132dedede$export$2e2bcd8739ae039({ theme: theme, ...props }) {
    const noVarsTheme = $7fPBF.useMemo(()=>{
        if (typeof theme === 'function') return theme;
        const muiTheme = (0, $e35ef6915a224202$export$2e2bcd8739ae039) in theme ? theme[0, $e35ef6915a224202$export$2e2bcd8739ae039] : theme;
        if (!('colorSchemes' in muiTheme)) {
            if (!('vars' in muiTheme)) // For non-CSS variables themes, set `vars` to null to prevent theme inheritance from the upper theme.
            // The example use case is the docs demo that uses ThemeProvider to customize the theme while the upper theme is using CSS variables.
            return {
                ...theme,
                vars: null
            };
            return theme;
        }
        return null;
    }, [
        theme
    ]);
    if (noVarsTheme) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1ad83304ee89086b$export$2e2bcd8739ae039), {
        theme: noVarsTheme,
        ...props
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cd1be95953c44948$export$50ec01b133c61652), {
        theme: theme,
        ...props
    });
}


var $7fPBF = parcelRequire("7fPBF");



'use client';
// TODO React 17: Remove `useMediaQueryOld` once React 17 support is removed
function $9972c250eb40bcc5$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $7fPBF.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addEventListener('change', updateMatch);
        return ()=>{
            queryList.removeEventListener('change', updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $9972c250eb40bcc5$var$safeReact = {
    ...$7fPBF
};
const $9972c250eb40bcc5$var$maybeReactUseSyncExternalStore = $9972c250eb40bcc5$var$safeReact.useSyncExternalStore;
function $9972c250eb40bcc5$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $7fPBF.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $7fPBF.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $7fPBF.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                mediaQueryList.addEventListener('change', notify);
                return ()=>{
                    mediaQueryList.removeEventListener('change', notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $9972c250eb40bcc5$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $9972c250eb40bcc5$export$96d7927a982220b5(params = {}) {
    const { themeId: themeId } = params;
    return function useMediaQuery(queryInput, options = {}) {
        let theme = (0, $f85b78a6cc253b21$export$2e2bcd8739ae039)();
        if (theme && themeId) theme = theme[themeId] || theme;
        // Wait for jsdom to support the match media feature.
        // All the browsers MUI support have this built-in.
        // This defensive check is here for simplicity.
        // Most of the time, the match media logic isn't central to people tests.
        const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
        const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $fdf252551f75687d$export$2e2bcd8739ae039)({
            name: 'MuiUseMediaQuery',
            props: options,
            theme: theme
        });
        let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
        query = query.replace(/^@media( ?)/m, '');
        if (query.includes('print')) console.warn([
            `MUI: You have provided a \`print\` query to the \`useMediaQuery\` hook.`,
            'Using the print media query to modify print styles can lead to unexpected results.',
            'Consider using the `displayPrint` field in the `sx` prop instead.',
            'More information about `displayPrint` on our docs: https://mui.com/system/display/#display-in-print.'
        ].join('\n'));
        const useMediaQueryImplementation = $9972c250eb40bcc5$var$maybeReactUseSyncExternalStore !== undefined ? $9972c250eb40bcc5$var$useMediaQueryNew : $9972c250eb40bcc5$var$useMediaQueryOld;
        const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
        return match;
    };
}
const $9972c250eb40bcc5$var$useMediaQuery = $9972c250eb40bcc5$export$96d7927a982220b5();
var $9972c250eb40bcc5$export$2e2bcd8739ae039 = $9972c250eb40bcc5$var$useMediaQuery;



const $d692658be43721e5$var$useMediaQuery = (0, $9972c250eb40bcc5$export$96d7927a982220b5)({
    themeId: (0, $e35ef6915a224202$export$2e2bcd8739ae039)
});
var $d692658be43721e5$export$2e2bcd8739ae039 = $d692658be43721e5$var$useMediaQuery;



var $7fPBF = parcelRequire("7fPBF");
const $1c78e537a9e9e9b0$export$a49f528ae1a4d0ed = (0, $7fPBF.createContext)({
    color: "currentColor",
    size: "1em",
    weight: "regular",
    mirrored: !1
});



const $640cd3167d5819eb$export$ce2efe5baec76fba = {
    mode: 'light',
    panelPosition: 'right',
    panelOrientation: 'vertical',
    color: {
        background: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
        card: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_accent_2,
        cardHover: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_light,
        accentCard: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_accent_2,
        border: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_light,
        text: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
        textBody: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral,
        error: (0, $8951886a6b49e92a$export$35e9368ef982300f).error,
        neutral: (0, $8951886a6b49e92a$export$35e9368ef982300f).border,
        link: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
        accent: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
        tint: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent,
        danger: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary_updated,
        success: (0, $8951886a6b49e92a$export$35e9368ef982300f).success,
        secondary: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
        sidebarDivider: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_light,
        indicator: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
        waveVoice: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_dark,
        waveDictation: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary
    },
    input: {
        text: '#1A1C1E',
        placeholder: '#54606F',
        border: (0, $8951886a6b49e92a$export$35e9368ef982300f).border,
        background: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_primary
    },
    dialog: {
        background: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
        text: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_intense,
        warn: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
        success: (0, $8951886a6b49e92a$export$35e9368ef982300f).success_light,
        remote: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent,
        border: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_intense
    },
    tag: {
        background: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
        text: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark
    },
    banner: {
        default: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            linkText: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            linkBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            linkHoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            linkHoverBackground: `#fdf3db`
        },
        accent: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            background: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).secondary}15`,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            linkText: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            linkBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).secondary}15`,
            linkHoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            linkHoverBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).secondary}15`
        },
        error: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).error,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).error,
            linkText: (0, $8951886a6b49e92a$export$35e9368ef982300f).error,
            linkBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).error}15`,
            linkHoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).error,
            linkHoverBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).error}15`
        },
        warning: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            background: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2}15`,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            linkText: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            linkBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            linkHoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            linkHoverBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2}15`
        },
        success: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            background: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).success}15`,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).success,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).success,
            linkText: (0, $8951886a6b49e92a$export$35e9368ef982300f).success,
            linkBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).success}15`,
            linkHoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).success,
            linkHoverBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).success}15`
        },
        info: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            background: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).accent}15`,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent,
            linkText: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            linkBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_accent_1}15`,
            linkHoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_accent_1,
            linkHoverBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_accent_1}15`
        }
    },
    button: {
        primary: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            backgroundImage: true,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_light,
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            hoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark
        },
        secondary: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            hoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark
        },
        accent: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            hoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_accent_2
        },
        simple: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            border: 'none',
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            hoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light
        },
        quick: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral,
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            hoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark
        }
    }
};
const $640cd3167d5819eb$export$86c8e15b70e05cb1 = {
    mode: 'dark',
    panelPosition: 'right',
    panelOrientation: 'vertical',
    color: {
        background: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_dark,
        card: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_intense,
        cardHover: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_light,
        accentCard: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
        border: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_light,
        text: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
        textBody: (0, $8951886a6b49e92a$export$35e9368ef982300f).border,
        error: (0, $8951886a6b49e92a$export$35e9368ef982300f).error_light,
        neutral: (0, $8951886a6b49e92a$export$35e9368ef982300f).border,
        link: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
        accent: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent,
        tint: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent,
        danger: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary_updated,
        success: (0, $8951886a6b49e92a$export$35e9368ef982300f).success_light,
        secondary: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_light,
        sidebarDivider: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_light + '20',
        indicator: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent,
        waveVoice: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent,
        waveDictation: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2
    },
    input: {
        text: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
        placeholder: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_light,
        border: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_dark,
        background: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_dark
    },
    dialog: {
        background: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
        text: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_intense,
        warn: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
        success: (0, $8951886a6b49e92a$export$35e9368ef982300f).success_light,
        remote: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent,
        border: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_intense
    },
    tag: {
        background: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_light,
        text: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark
    },
    banner: {
        default: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            linkText: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            linkBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            linkHoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            linkHoverBackground: `#fdf3db`
        },
        accent: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            background: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).secondary}15`,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            linkText: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            linkBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).secondary}15`,
            linkHoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            linkHoverBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).secondary}15`
        },
        error: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_dark,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary,
            linkText: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary,
            linkBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_dark,
            linkHoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary,
            linkHoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_dark,
            buttonText: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_dark
        },
        warning: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            background: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2}25`,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            linkText: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            linkBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            linkHoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            linkHoverBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2}15`,
            buttonText: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark
        },
        success: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            background: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).success}15`,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).success,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).success,
            linkText: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            linkBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).success}15`,
            linkHoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).success,
            linkHoverBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).success}15`
        },
        info: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            background: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).accent}15`,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent,
            linkText: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            linkBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_accent_1}15`,
            linkHoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_accent_1,
            linkHoverBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_accent_1}15`
        }
    },
    button: {
        primary: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            hoverBackground: 'transparent'
        },
        secondary: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent,
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            hoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent
        },
        accent: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).border,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_dark,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            hoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_intense
        },
        simple: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            background: 'transparent',
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            border: 'none',
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            hoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_dark
        },
        quick: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_dark,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_light,
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            hoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark
        }
    }
};




const $6efd2a8884b3d0c5$var$commonSettings = {
    typography: {
        fontFamily: 'Archivo, sans-serif'
    },
    components: {
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: '1rem',
                    fontWeight: 700
                }
            }
        },
        // MuiOutlinedInput: {
        //     styleOverrides: {
        //         root: {
        //             paddingRight: '0',
        //         },
        //         notchedOutline: {
        //             borderColor: color.border,
        //         },
        //     },
        // },
        MuiCheckbox: {
            styleOverrides: {
                indeterminate: {
                    color: 'red'
                }
            }
        },
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true
            }
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: '0.5rem'
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: (0, $8951886a6b49e92a$export$7536ca5ba8ef94f0).font_sm,
                    lineHeight: (0, $8951886a6b49e92a$export$aa43e0cf17fdb070).font_xs
                }
            },
            defaultProps: {
                enterDelay: 800,
                leaveDelay: 200,
                enterNextDelay: 400
            }
        },
        MuiRadio: {
            defaultProps: {
                disableRipple: true
            }
        }
    }
};
const $6efd2a8884b3d0c5$export$c2e730548983f1c2 = (0, $ca3239ce6bf6e490$export$2e2bcd8739ae039)({
    ...$6efd2a8884b3d0c5$var$commonSettings,
    palette: {
        mode: 'light',
        text: {
            primary: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark
        },
        primary: {
            main: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            contrastText: (0, $8951886a6b49e92a$export$35e9368ef982300f).border
        },
        secondary: {
            main: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary
        },
        error: {
            main: (0, $8951886a6b49e92a$export$35e9368ef982300f).error
        },
        background: {
            paper: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light
        },
        info: {
            light: '#7676ca',
            main: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            dark: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            contrastText: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light
        }
    },
    components: {
        ...$6efd2a8884b3d0c5$var$commonSettings.components,
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    ...$6efd2a8884b3d0c5$var$commonSettings.components.MuiInputLabel.styleOverrides.root,
                    color: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    ...$6efd2a8884b3d0c5$var$commonSettings.components.MuiTooltip.styleOverrides.tooltip,
                    backgroundColor: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_light,
                    color: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark
                },
                arrow: {
                    color: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light
                }
            }
        }
    }
});
const $6efd2a8884b3d0c5$export$faedaf67268e9c67 = (0, $ca3239ce6bf6e490$export$2e2bcd8739ae039)({
    ...$6efd2a8884b3d0c5$var$commonSettings,
    palette: {
        mode: 'dark',
        text: {
            primary: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light
        },
        primary: {
            main: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_light,
            contrastText: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_light
        },
        secondary: {
            main: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary
        },
        error: {
            main: (0, $8951886a6b49e92a$export$35e9368ef982300f).error_light
        },
        background: {
            paper: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark
        },
        info: {
            light: '#2086c4',
            main: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent,
            dark: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            contrastText: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light
        }
    },
    components: {
        ...$6efd2a8884b3d0c5$var$commonSettings.components,
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    ...$6efd2a8884b3d0c5$var$commonSettings.components.MuiInputLabel.styleOverrides.root,
                    color: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    ...$6efd2a8884b3d0c5$var$commonSettings.components.MuiTooltip.styleOverrides.tooltip,
                    backgroundColor: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark
                },
                arrow: {
                    color: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark
                }
            }
        }
    }
});




var $7fPBF = parcelRequire("7fPBF");
const $c6dc2c2d62651942$var$defaultThemeContext = {
    theme: 'light',
    setThemeDirectly: ()=>{},
    panelPosition: 'right',
    setPanelPosition: ()=>{}
};
const $c6dc2c2d62651942$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $7fPBF.createContext)($c6dc2c2d62651942$var$defaultThemeContext);
const $c6dc2c2d62651942$export$c507fb1c2e1ac13a = ()=>{
    const theme = (0, $d62c6f18f523e962$export$3b14a55fb2447963)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $84f3fdd51733d70b$export$98f03c5d19621d70), {
        styles: {
            body: {
                color: theme.color.text,
                ':not(:has(#command-overlay, #panel-overlay))': {
                    backgroundColor: theme.color.background
                }
            },
            // for storybook
            '.light-theme': {
                color: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
                backgroundColor: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light
            },
            '.dark-theme': {
                color: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
                backgroundColor: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_dark
            }
        }
    });
};
const $c6dc2c2d62651942$export$e6cf561029f29d90 = ({ children: children })=>{
    const prefersDarkMode = (0, $d692658be43721e5$export$2e2bcd8739ae039)('(prefers-color-scheme: dark)');
    const [theme, setTheme] = (0, $7fPBF.useState)(prefersDarkMode ? 'dark' : 'light');
    const [panelPosition, setPanelPosition] = (0, $7fPBF.useState)('left'); // Default
    (0, $7fPBF.useEffect)(()=>{
        setTheme(prefersDarkMode ? 'dark' : 'light');
    }, [
        prefersDarkMode
    ]);
    const muiThemeObject = (0, $7fPBF.useMemo)(()=>theme === 'light' ? (0, $6efd2a8884b3d0c5$export$c2e730548983f1c2) : (0, $6efd2a8884b3d0c5$export$faedaf67268e9c67), [
        theme
    ]);
    const emotionThemeObject = (0, $7fPBF.useMemo)(()=>({
            ...theme === 'light' ? (0, $640cd3167d5819eb$export$ce2efe5baec76fba) : (0, $640cd3167d5819eb$export$86c8e15b70e05cb1),
            mode: theme,
            panelPosition: panelPosition,
            panelOrientation: panelPosition === 'left' || panelPosition === 'right' ? 'vertical' : 'horizontal'
        }), [
        theme,
        panelPosition
    ]);
    const setThemeDirectly = (0, $7fPBF.useCallback)((theme)=>{
        setTheme(theme);
    }, []);
    const contextValue = (0, $7fPBF.useMemo)(()=>({
            theme: theme,
            setThemeDirectly: setThemeDirectly,
            panelPosition: panelPosition,
            setPanelPosition: setPanelPosition
        }), [
        theme,
        setThemeDirectly,
        panelPosition,
        setPanelPosition
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1c78e537a9e9e9b0$export$a49f528ae1a4d0ed).Provider, {
        value: {
            weight: 'light'
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c6dc2c2d62651942$export$2c657da244d00bd6.Provider, {
            value: contextValue,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d62c6f18f523e962$export$407448d2b89b1813), {
                theme: emotionThemeObject,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $b8226d5132dedede$export$2e2bcd8739ae039), {
                    theme: muiThemeObject,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c6dc2c2d62651942$export$c507fb1c2e1ac13a, {}),
                        children
                    ]
                })
            })
        })
    });
};



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
function $78783f85c4167892$export$26ae5ca175b4ec5a(useHook) {
    var Context = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);
    function Provider(props) {
        var value = useHook(props.initialState);
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Context.Provider, {
            value: value
        }, props.children);
    }
    function useContainer() {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext(Context);
        if (value === null) throw new Error("Component must be wrapped with <Container.Provider>");
        return value;
    }
    return {
        Provider: Provider,
        useContainer: useContainer
    };
}
function $78783f85c4167892$export$b537cf6ebaf7ff54(container) {
    return container.useContainer();
}


// Pre-initialize the listeners object for every event in EventMap,
// with explicit type assertions for each empty array.
const $e7df95de73caec26$var$listeners = {
    analyticsTrackEvent: [],
    alertSuccess: [],
    alertError: [],
    alertWarning: [],
    audioStream: [],
    hotkeyCommand: [],
    stopListening: [],
    userProfileAdded: [],
    userProfileUpdated: [],
    userProfileDeleted: [],
    profileDeleted: [],
    voiceCommandFinal: [],
    voiceCommandPartial: [],
    voiceCommandPaused: [],
    voiceCommandDictation: [],
    voiceCommandHandled: [],
    cameraCommandHandled: [],
    voiceStopped: [],
    nowPlaying: [],
    updateUserLicenseAccess: [],
    userLicenseChangeLocal: [],
    userLocalePreferencesUpdated: [],
    userFeatureFlagsUpdated: [],
    userUpdated: [],
    whisperInitialize: [],
    whisperStart: [],
    whisperStop: [],
    whisperTerminate: [],
    currentDeviceUpdated: [],
    remoteDeviceCommand: [],
    navigateTo: [],
    tourStarted: [],
    tourEnded: [],
    tourStepChanged: [],
    tourPaused: [],
    tourFocusSource: [],
    // from IPC events
    'force-reconnect': [],
    'license-trial-started': [],
    'default-profiles-updated': [],
    'update-voice-dictation-controls': [],
    'remove-device': [],
    'device-added': []
};
// A helper function to narrow the type of the listeners array for a given event key
function $e7df95de73caec26$var$getListeners(event) {
    return $e7df95de73caec26$var$listeners[event];
}
function $e7df95de73caec26$export$ec068583843480e7(event, callback) {
    // Add the callback to the event's listener array
    $e7df95de73caec26$var$getListeners(event).push(callback);
    // Instead of reassigning listeners[event] with a filtered array,
    // we remove the callback from the existing array in place.
    return ()=>{
        const arr = $e7df95de73caec26$var$getListeners(event);
        const index = arr.indexOf(callback);
        if (index !== -1) arr.splice(index, 1);
    };
}
function $e7df95de73caec26$export$89b472e03be495df(event, ...payload) {
    const data = payload[0];
    $e7df95de73caec26$var$listeners[event]?.forEach((cb)=>cb(data));
}
function $e7df95de73caec26$var$hasInitiator(obj) {
    return !!obj && typeof obj === 'object' && 'initiator' in obj;
}
function $e7df95de73caec26$export$8f65b2710ad2adaf(eventNames, initiatorRef, sendFn) {
    const unsubscribers = eventNames.map((eventName)=>$e7df95de73caec26$export$ec068583843480e7(eventName, (event)=>{
            if ($e7df95de73caec26$var$hasInitiator(event) && event.initiator === initiatorRef.current) sendFn(eventName, event);
        }));
    return ()=>unsubscribers.forEach((unsub)=>unsub());
}


function $d8990c2b9fb87b75$var$useAlertsContainer() {
    const [error, setError] = (0, $7fPBF.useState)(null);
    const [success, setSuccess] = (0, $7fPBF.useState)(null);
    const [warning, setWarning] = (0, $7fPBF.useState)(null);
    const [bannerMap, setBannerMap] = (0, $7fPBF.useState)(new Map());
    const bannersArray = Array.from(bannerMap.values());
    const showError = (error, timeout = 5000)=>{
        setError(error);
        setTimeout(()=>{
            setError(null);
        }, timeout);
    };
    const showSuccess = (success, timeout = 5000)=>{
        setSuccess(success);
        setTimeout(()=>{
            setSuccess(null);
        }, timeout);
    };
    const showWarning = (warning, timeout = 5000)=>{
        setWarning(warning);
        setTimeout(()=>{
            setWarning(null);
        }, timeout);
    };
    const addBanner = (newBanner, duration)=>{
        setBannerMap((prevBannerMap)=>{
            const updatedMap = new Map(prevBannerMap);
            // Clear the existing timeout if the banner already exists
            if (updatedMap.has(newBanner.id)) {
                const existingBanner = updatedMap.get(newBanner.id);
                if (existingBanner && existingBanner.timeout) clearTimeout(existingBanner.timeout);
            }
            let timeout;
            // Set a new timeout to remove the banner if duration is provided
            if (duration !== undefined) timeout = setTimeout(()=>{
                setBannerMap((currentMap)=>{
                    const newMap = new Map(currentMap);
                    newMap.delete(newBanner.id);
                    return newMap;
                });
            }, duration);
            // Add the banner with the timeout if it exists
            updatedMap.set(newBanner.id, {
                ...newBanner,
                timeout: timeout
            });
            return updatedMap;
        });
    };
    const removeBanner = (id)=>{
        setBannerMap((prevBannerMap)=>{
            const updatedMap = new Map(prevBannerMap);
            const banner = updatedMap.get(id);
            if (banner && banner.timeout) clearTimeout(banner.timeout);
            updatedMap.delete(id);
            return updatedMap;
        });
    };
    (0, $7fPBF.useEffect)(()=>{
        const unsubscribeSuccess = (0, $e7df95de73caec26$export$ec068583843480e7)('alertSuccess', (alert)=>{
            showSuccess(alert.message);
        });
        const unsubscribeError = (0, $e7df95de73caec26$export$ec068583843480e7)('alertError', (alert)=>{
            showError(alert.message);
        });
        const unsubscribeWarning = (0, $e7df95de73caec26$export$ec068583843480e7)('alertWarning', (alert)=>{
            showWarning(alert.message);
        });
        return ()=>{
            unsubscribeSuccess();
            unsubscribeError();
            unsubscribeWarning();
        };
    }, []);
    return {
        showSuccess: showSuccess,
        showError: showError,
        showWarning: showWarning,
        bannersArray: bannersArray,
        addBanner: addBanner,
        removeBanner: removeBanner,
        success: success,
        error: error,
        warning: warning
    };
}
const $d8990c2b9fb87b75$var$AlertsContainer = (0, $78783f85c4167892$export$26ae5ca175b4ec5a)($d8990c2b9fb87b75$var$useAlertsContainer);
var $d8990c2b9fb87b75$export$2e2bcd8739ae039 = $d8990c2b9fb87b75$var$AlertsContainer;



var $7fPBF = parcelRequire("7fPBF");

function $5eb45bbdec4cc6a0$var$useAnalyticsTrackingContainer() {
    const [eventHandlers, setEventHandlers] = (0, $7fPBF.useState)([]);
    const addEventHandler = (handler)=>{
        setEventHandlers([
            ...eventHandlers,
            handler
        ]);
    };
    const removeEventHandler = (handler)=>{
        setEventHandlers(eventHandlers.filter((x)=>x !== handler));
    };
    const trackEvent = async (eventName, data)=>{
        for (const handler of eventHandlers)await handler(eventName, data);
    };
    return {
        trackEvent: trackEvent,
        addEventHandler: addEventHandler,
        removeEventHandler: removeEventHandler
    };
}
const $5eb45bbdec4cc6a0$var$AnalyticsTrackingContainer = (0, $78783f85c4167892$export$26ae5ca175b4ec5a)($5eb45bbdec4cc6a0$var$useAnalyticsTrackingContainer);
var $5eb45bbdec4cc6a0$export$2e2bcd8739ae039 = $5eb45bbdec4cc6a0$var$AnalyticsTrackingContainer;


class $5f3c730b3d8aae7c$export$2e2bcd8739ae039 {
    constructor(){
        this.resultType = 'Unexpected';
        this.errors = [
            'An unexpected error has occurred. Please try again later.'
        ];
    }
}



var $7fPBF = parcelRequire("7fPBF");

function $13d0c8a27a7be22f$export$6b17a39e52c8ee53(request, baseUrl = '', locale) {
    const params = new URLSearchParams();
    if (locale) request = {
        ...request,
        locale: locale
    };
    if (!request) return baseUrl;
    Object.entries(request).forEach(([key, value])=>{
        if (value == null) return;
        if (Array.isArray(value) && value.length > 0) value.forEach((item)=>params.append(key, item));
        else if (value.toString().trim() !== '') params.append(key, value.toString());
    });
    const queryString = params.toString();
    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
}
function $13d0c8a27a7be22f$export$990cf17cc7759dd4(path, newParams, additionalParams, locale) {
    const merged = {};
    // Safely spread existing params (if any)
    Object.entries(additionalParams || {}).forEach(([key, value])=>{
        merged[key] = value;
    });
    // Override or add new ones
    Object.assign(merged, newParams);
    return $13d0c8a27a7be22f$export$6b17a39e52c8ee53(merged, path, locale);
}


// constants for keys
const $db3063bd3b6d501e$export$d975f71e6c6b349c = 'ENABLED_ACCESS_TOKEN';
const $db3063bd3b6d501e$export$f849a8e4906d2051 = 'ENABLED_REFRESH_TOKEN';
const $db3063bd3b6d501e$export$302657547b2577c2 = 'ENABLED_USER';
const $db3063bd3b6d501e$export$ccdad49998c6d6ff = 'ENABLED_ACCESS_EXPIRATION';
const $db3063bd3b6d501e$export$7b02f2982f8105ff = 'CUSTOM_CONTROLS';
function $db3063bd3b6d501e$export$5dbf9a24b655dde4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        let r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
const $db3063bd3b6d501e$export$666167f3cc1c081a = ()=>{
    if (window.ADMIN_ENVIRONMENT) return $db3063bd3b6d501e$var$getAdminClientId();
    if (!window.WEB_ENVIRONMENT || window.DESKTOP_ENVIRONMENT) return '8b70d50a-3428-48dc-bc21-dc6807258aa4';
    if (window.ENABLED_ENVIRONMENT == 'dev') return 'bc55094d-6cea-446e-a44a-e61c9d2c07e2';
    if (window.ENABLED_ENVIRONMENT == 'beta') return 'cc55094d-6cea-446e-a44a-e61c9d2c07e2';
    return '8b70d50a-3428-48dc-bc21-dc6807258aa4'; // production
};
const $db3063bd3b6d501e$export$abb5e0783f1a4f17 = ()=>{
    if (window.ADMIN_ENVIRONMENT) return $db3063bd3b6d501e$var$getAdminClientSecret();
    if (!window.WEB_ENVIRONMENT || window.DESKTOP_ENVIRONMENT) return 'AmZiNDUxOGM1ZGFiNDhlNmE5MjY2ZjBiYzliNDUxMmQ1OGExZDAxZjU0ZWI0ODU5YmRhN2VkYTc0OTA1M2M4Nw==';
    if (window.ENABLED_ENVIRONMENT == 'dev') return 'Fg709dBr0DMOxlWDIfX27gJKDCQz5TnfyVkUh8WzM7YCpmmPM37j3UQtkal1';
    if (window.ENABLED_ENVIRONMENT == 'beta') return 'Fg709dBr0DMOxlWDIfX27gJKDCQz5TnfyVkUh8WzM7YCpmmPM37j3UQtkal1';
    return 'AmZiNDUxOGM1ZGFiNDhlNmE5MjY2ZjBiYzliNDUxMmQ1OGExZDAxZjU0ZWI0ODU5YmRhN2VkYTc0OTA1M2M4Nw=='; // production
};
const $db3063bd3b6d501e$var$getAdminClientId = ()=>{
    const environment = "production";
    if (environment == 'dev') return 'a2409dc9-b495-4b14-ac38-6c288b7871bd';
    if (environment == 'staging') return 'a2409dc9-b495-4b14-ac38-6c288b7871bd';
    if (environment == 'beta') return 'a2409dc9-b495-4b14-ac38-6c288b7871bd';
    if (environment == 'staging-local') return 'a2409dc9-b495-4b14-ac38-6c288b7871bd';
    return '3c8de27c-e1d7-4565-a4f2-e5de5f5a0e63'; // production
};
const $db3063bd3b6d501e$var$getAdminClientSecret = ()=>{
    const environment = "production";
    if (environment == 'production') return 'V7xGFh85f0FlwKN5WWmPfgWHrrrGy96WV6QM4jisQA46SQkUmRF5xIdaJEg0ftlv';
    if (environment == 'dev') return 'MftKwkGoysYJjTMnZo2Greym7jf0gQpu 2Ry4tpZBLuGkQU83WXl0Qb4cYkqS273O';
    if (environment == 'staging') return 'MftKwkGoysYJjTMnZo2Greym7jf0gQpu 2Ry4tpZBLuGkQU83WXl0Qb4cYkqS273O';
    if (environment == 'beta') return 'MftKwkGoysYJjTMnZo2Greym7jf0gQpu 2Ry4tpZBLuGkQU83WXl0Qb4cYkqS273O';
    if (environment == 'staging-local') return 'MftKwkGoysYJjTMnZo2Greym7jf0gQpu 2Ry4tpZBLuGkQU83WXl0Qb4cYkqS273O';
    return 'V7xGFh85f0FlwKN5WWmPfgWHrrrGy96WV6QM4jisQA46SQkUmRF5xIdaJEg0ftlv'; // production
};


// the base url is handled in the api calls from the env variable API_URL
const $07546889aef07ebc$export$df8e085683bf7fe4 = ()=>{
    const environment = "production";
    if (environment == 'dev') return 'http://localhost:3002';
    else if (environment == 'staging') return 'https://enabled-dev.azurewebsites.net';
    else if (environment == 'production') return 'https://services.cephable.com';
    else if (environment == 'staging-local') return 'https://enabled-dev.azurewebsites.net';
    return 'https://services.cephable.com';
};
const $07546889aef07ebc$export$b0c2c82d7aa8a735 = ()=>{
    if (window.ADMIN_ENVIRONMENT) return $07546889aef07ebc$var$getAdminAuthRedirectUri();
    if (!window.WEB_ENVIRONMENT || window.DESKTOP_ENVIRONMENT) return 'enabledplay://authcallback';
    if (window.ENABLED_ENVIRONMENT == 'dev') return 'http://localhost:3000/authcallback';
    else if (window.ENABLED_ENVIRONMENT == 'staging') return 'https://enableddevportal.z13.web.core.windows.net/authcallback';
    else if (window.ENABLED_ENVIRONMENT == 'production') return 'https://portal.cephable.com/authcallback';
    else if (window.ENABLED_ENVIRONMENT == 'staging-local') // for parity to desktop app development
    return 'https://dev-app.cephable.com/authcallback';
    return 'https://portal.cephable.com/authcallback';
};
const $07546889aef07ebc$var$getAdminAuthRedirectUri = ()=>{
    const environment = "production";
    if (environment == 'dev') return 'http://localhost:3004/';
    else if (environment == 'staging') return 'https://enableddevportal.z13.web.core.windows.net/';
    else if (environment == 'production') return 'https://portal.cephable.com/';
    else if (environment == 'staging-local') // for parity to desktop app development
    return 'http://localhost:3004/';
    return 'https://portal.cephable.com/';
};
const $07546889aef07ebc$export$db48712d9b7c9727 = ()=>{
    const environment = "production";
    if (environment == 'dev') return 'http://localhost:3003';
    else if (environment == 'staging' || environment == 'staging-local') return 'https://enabled-dev-analytics.azurewebsites.net';
    else if (environment == 'production') return 'https://analytics.cephable.com';
    return 'https://analytics.cephable.com';
};


class $6340c001daecf2cb$export$2e2bcd8739ae039 {
    constructor(error){
        this.resultType = 'Invalid';
        this.errors = [
            error
        ];
    }
}


class $be7228f0da37b2ae$export$2e2bcd8739ae039 {
    constructor(){
        this.resultType = 'NoResponse';
        this.errors = [
            'The server did not respond.'
        ];
    }
}


class $206736819695f5cd$export$2e2bcd8739ae039 {
    constructor(error = 'Unable to find the given resource.'){
        this.resultType = 'NotFound';
        this.errors = [
            error
        ];
    }
}


class $6d6350e3c807681d$export$2e2bcd8739ae039 {
    constructor(){
        this.resultType = 'Offline';
        this.errors = [
            'Network is offline. Please check your connection.'
        ];
    }
}


class $84d8c1f6f6e5603d$export$2e2bcd8739ae039 {
    constructor(data){
        this.resultType = 'Ok';
        this.errors = [];
        this.data = data;
    }
}


class $eb323d7d149f5b89$export$2e2bcd8739ae039 {
    constructor(error = 'Your session has expired. Please sign in and try again.'){
        this.resultType = 'Unauthorized';
        this.errors = [
            error
        ];
    }
}



'use strict';
function $4c852d2f6a5a0387$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $77146a31cb578292$var$toString } = Object.prototype;
const { getPrototypeOf: $77146a31cb578292$var$getPrototypeOf } = Object;
const { iterator: $77146a31cb578292$var$iterator, toStringTag: $77146a31cb578292$var$toStringTag } = Symbol;
const $77146a31cb578292$var$kindOf = ((cache)=>(thing)=>{
        const str = $77146a31cb578292$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $77146a31cb578292$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$77146a31cb578292$var$kindOf(thing) === type;
};
const $77146a31cb578292$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $77146a31cb578292$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $77146a31cb578292$var$isUndefined = $77146a31cb578292$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $77146a31cb578292$var$isBuffer(val) {
    return val !== null && !$77146a31cb578292$var$isUndefined(val) && val.constructor !== null && !$77146a31cb578292$var$isUndefined(val.constructor) && $77146a31cb578292$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $77146a31cb578292$var$isArrayBuffer = $77146a31cb578292$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $77146a31cb578292$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $77146a31cb578292$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $77146a31cb578292$var$isString = $77146a31cb578292$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $77146a31cb578292$var$isFunction = $77146a31cb578292$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $77146a31cb578292$var$isNumber = $77146a31cb578292$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $77146a31cb578292$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $77146a31cb578292$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $77146a31cb578292$var$isPlainObject = (val)=>{
    if ($77146a31cb578292$var$kindOf(val) !== 'object') return false;
    const prototype = $77146a31cb578292$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($77146a31cb578292$var$toStringTag in val) && !($77146a31cb578292$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $77146a31cb578292$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$77146a31cb578292$var$isObject(val) || $77146a31cb578292$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $77146a31cb578292$var$isDate = $77146a31cb578292$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $77146a31cb578292$var$isFile = $77146a31cb578292$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 * 
 * @param {*} value The value to test
 * 
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $77146a31cb578292$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 * 
 * @param {*} formData The formData to test
 * 
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $77146a31cb578292$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $77146a31cb578292$var$isBlob = $77146a31cb578292$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $77146a31cb578292$var$isFileList = $77146a31cb578292$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $77146a31cb578292$var$isStream = (val)=>$77146a31cb578292$var$isObject(val) && $77146a31cb578292$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $77146a31cb578292$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $77146a31cb578292$var$G = $77146a31cb578292$var$getGlobal();
const $77146a31cb578292$var$FormDataCtor = typeof $77146a31cb578292$var$G.FormData !== 'undefined' ? $77146a31cb578292$var$G.FormData : undefined;
const $77146a31cb578292$var$isFormData = (thing)=>{
    let kind;
    return thing && ($77146a31cb578292$var$FormDataCtor && thing instanceof $77146a31cb578292$var$FormDataCtor || $77146a31cb578292$var$isFunction(thing.append) && ((kind = $77146a31cb578292$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $77146a31cb578292$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $77146a31cb578292$var$isURLSearchParams = $77146a31cb578292$var$kindOfTest('URLSearchParams');
const [$77146a31cb578292$var$isReadableStream, $77146a31cb578292$var$isRequest, $77146a31cb578292$var$isResponse, $77146a31cb578292$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($77146a31cb578292$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $77146a31cb578292$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $77146a31cb578292$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($77146a31cb578292$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($77146a31cb578292$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $77146a31cb578292$var$findKey(obj, key) {
    if ($77146a31cb578292$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $77146a31cb578292$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $77146a31cb578292$var$isContextDefined = (context)=>!$77146a31cb578292$var$isUndefined(context) && context !== $77146a31cb578292$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $77146a31cb578292$var$merge() {
    const { caseless: caseless, skipUndefined: skipUndefined } = $77146a31cb578292$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        const targetKey = caseless && $77146a31cb578292$var$findKey(result, key) || key;
        if ($77146a31cb578292$var$isPlainObject(result[targetKey]) && $77146a31cb578292$var$isPlainObject(val)) result[targetKey] = $77146a31cb578292$var$merge(result[targetKey], val);
        else if ($77146a31cb578292$var$isPlainObject(val)) result[targetKey] = $77146a31cb578292$var$merge({}, val);
        else if ($77146a31cb578292$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$77146a31cb578292$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $77146a31cb578292$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $77146a31cb578292$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $77146a31cb578292$var$forEach(b, (val, key)=>{
        if (thisArg && $77146a31cb578292$var$isFunction(val)) Object.defineProperty(a, key, {
            value: (0, $4c852d2f6a5a0387$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $77146a31cb578292$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $77146a31cb578292$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $77146a31cb578292$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $77146a31cb578292$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $77146a31cb578292$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $77146a31cb578292$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($77146a31cb578292$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$77146a31cb578292$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $77146a31cb578292$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $77146a31cb578292$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $77146a31cb578292$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$77146a31cb578292$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $77146a31cb578292$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $77146a31cb578292$var$isHTMLForm = $77146a31cb578292$var$kindOfTest('HTMLFormElement');
const $77146a31cb578292$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $77146a31cb578292$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $77146a31cb578292$var$isRegExp = $77146a31cb578292$var$kindOfTest('RegExp');
const $77146a31cb578292$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $77146a31cb578292$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $77146a31cb578292$var$freezeMethods = (obj)=>{
    $77146a31cb578292$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($77146a31cb578292$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$77146a31cb578292$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $77146a31cb578292$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $77146a31cb578292$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $77146a31cb578292$var$noop = ()=>{};
const $77146a31cb578292$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $77146a31cb578292$var$isSpecCompliantForm(thing) {
    return !!(thing && $77146a31cb578292$var$isFunction(thing.append) && thing[$77146a31cb578292$var$toStringTag] === 'FormData' && thing[$77146a31cb578292$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $77146a31cb578292$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($77146a31cb578292$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($77146a31cb578292$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $77146a31cb578292$var$isArray(source) ? [] : {};
                $77146a31cb578292$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$77146a31cb578292$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $77146a31cb578292$var$isAsyncFn = $77146a31cb578292$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $77146a31cb578292$var$isThenable = (thing)=>thing && ($77146a31cb578292$var$isObject(thing) || $77146a31cb578292$var$isFunction(thing)) && $77146a31cb578292$var$isFunction(thing.then) && $77146a31cb578292$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $77146a31cb578292$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $77146a31cb578292$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $77146a31cb578292$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $77146a31cb578292$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $77146a31cb578292$var$isFunction($77146a31cb578292$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $77146a31cb578292$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($77146a31cb578292$var$_global) : $77146a31cb578292$var$_setImmediate;
// *********************
const $77146a31cb578292$var$isIterable = (thing)=>thing != null && $77146a31cb578292$var$isFunction(thing[$77146a31cb578292$var$iterator]);
var $77146a31cb578292$export$2e2bcd8739ae039 = {
    isArray: $77146a31cb578292$var$isArray,
    isArrayBuffer: $77146a31cb578292$var$isArrayBuffer,
    isBuffer: $77146a31cb578292$var$isBuffer,
    isFormData: $77146a31cb578292$var$isFormData,
    isArrayBufferView: $77146a31cb578292$var$isArrayBufferView,
    isString: $77146a31cb578292$var$isString,
    isNumber: $77146a31cb578292$var$isNumber,
    isBoolean: $77146a31cb578292$var$isBoolean,
    isObject: $77146a31cb578292$var$isObject,
    isPlainObject: $77146a31cb578292$var$isPlainObject,
    isEmptyObject: $77146a31cb578292$var$isEmptyObject,
    isReadableStream: $77146a31cb578292$var$isReadableStream,
    isRequest: $77146a31cb578292$var$isRequest,
    isResponse: $77146a31cb578292$var$isResponse,
    isHeaders: $77146a31cb578292$var$isHeaders,
    isUndefined: $77146a31cb578292$var$isUndefined,
    isDate: $77146a31cb578292$var$isDate,
    isFile: $77146a31cb578292$var$isFile,
    isReactNativeBlob: $77146a31cb578292$var$isReactNativeBlob,
    isReactNative: $77146a31cb578292$var$isReactNative,
    isBlob: $77146a31cb578292$var$isBlob,
    isRegExp: $77146a31cb578292$var$isRegExp,
    isFunction: $77146a31cb578292$var$isFunction,
    isStream: $77146a31cb578292$var$isStream,
    isURLSearchParams: $77146a31cb578292$var$isURLSearchParams,
    isTypedArray: $77146a31cb578292$var$isTypedArray,
    isFileList: $77146a31cb578292$var$isFileList,
    forEach: $77146a31cb578292$var$forEach,
    merge: $77146a31cb578292$var$merge,
    extend: $77146a31cb578292$var$extend,
    trim: $77146a31cb578292$var$trim,
    stripBOM: $77146a31cb578292$var$stripBOM,
    inherits: $77146a31cb578292$var$inherits,
    toFlatObject: $77146a31cb578292$var$toFlatObject,
    kindOf: $77146a31cb578292$var$kindOf,
    kindOfTest: $77146a31cb578292$var$kindOfTest,
    endsWith: $77146a31cb578292$var$endsWith,
    toArray: $77146a31cb578292$var$toArray,
    forEachEntry: $77146a31cb578292$var$forEachEntry,
    matchAll: $77146a31cb578292$var$matchAll,
    isHTMLForm: $77146a31cb578292$var$isHTMLForm,
    hasOwnProperty: $77146a31cb578292$var$hasOwnProperty,
    hasOwnProp: $77146a31cb578292$var$hasOwnProperty,
    reduceDescriptors: $77146a31cb578292$var$reduceDescriptors,
    freezeMethods: $77146a31cb578292$var$freezeMethods,
    toObjectSet: $77146a31cb578292$var$toObjectSet,
    toCamelCase: $77146a31cb578292$var$toCamelCase,
    noop: $77146a31cb578292$var$noop,
    toFiniteNumber: $77146a31cb578292$var$toFiniteNumber,
    findKey: $77146a31cb578292$var$findKey,
    global: $77146a31cb578292$var$_global,
    isContextDefined: $77146a31cb578292$var$isContextDefined,
    isSpecCompliantForm: $77146a31cb578292$var$isSpecCompliantForm,
    toJSONObject: $77146a31cb578292$var$toJSONObject,
    isAsyncFn: $77146a31cb578292$var$isAsyncFn,
    isThenable: $77146a31cb578292$var$isThenable,
    setImmediate: $77146a31cb578292$var$_setImmediate,
    asap: $77146a31cb578292$var$asap,
    isIterable: $77146a31cb578292$var$isIterable
};







'use strict';
class $b9cc6960093b095e$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $b9cc6960093b095e$var$AxiosError(error.message, code || error.code, config, request, response);
        axiosError.cause = error;
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
     * Create an Error with the specified message, config, error code, request and response.
     *
     * @param {string} message The error message.
     * @param {string} [code] The error code (for example, 'ECONNABORTED').
     * @param {Object} [config] The config.
     * @param {Object} [request] The request.
     * @param {Object} [response] The response.
     *
     * @returns {Error} The created error.
     */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $77146a31cb578292$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$b9cc6960093b095e$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$b9cc6960093b095e$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$b9cc6960093b095e$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$b9cc6960093b095e$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$b9cc6960093b095e$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$b9cc6960093b095e$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$b9cc6960093b095e$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$b9cc6960093b095e$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$b9cc6960093b095e$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$b9cc6960093b095e$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$b9cc6960093b095e$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$b9cc6960093b095e$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
var $b9cc6960093b095e$export$2e2bcd8739ae039 = $b9cc6960093b095e$var$AxiosError;


// eslint-disable-next-line strict
var $31df7fcb8acaa73a$export$2e2bcd8739ae039 = null;



var $bdjQ6 = parcelRequire("bdjQ6");
var $19044a9fa7281693$require$Buffer = $bdjQ6.Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $19044a9fa7281693$var$isVisitable(thing) {
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $19044a9fa7281693$var$removeBrackets(key) {
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $19044a9fa7281693$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $19044a9fa7281693$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $19044a9fa7281693$var$isFlatArray(arr) {
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(arr) && !arr.some($19044a9fa7281693$var$isVisitable);
}
const $19044a9fa7281693$var$predicates = (0, $77146a31cb578292$export$2e2bcd8739ae039).toFlatObject((0, $77146a31cb578292$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $19044a9fa7281693$var$toFormData(obj, formData, options) {
    if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $31df7fcb8acaa73a$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $77146a31cb578292$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $77146a31cb578292$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $77146a31cb578292$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $19044a9fa7281693$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isReactNative(formData) && (0, $77146a31cb578292$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($19044a9fa7281693$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(value) && $19044a9fa7281693$var$isFlatArray(value) || ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFileList(value) || (0, $77146a31cb578292$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $77146a31cb578292$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $19044a9fa7281693$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $19044a9fa7281693$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($19044a9fa7281693$var$isVisitable(value)) return true;
        formData.append($19044a9fa7281693$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($19044a9fa7281693$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $19044a9fa7281693$var$isVisitable
    });
    function build(value, path) {
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $77146a31cb578292$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $19044a9fa7281693$export$2e2bcd8739ae039 = $19044a9fa7281693$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $a2774d1dd3bec636$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $a2774d1dd3bec636$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $19044a9fa7281693$export$2e2bcd8739ae039)(params, this, options);
}
const $a2774d1dd3bec636$var$prototype = $a2774d1dd3bec636$var$AxiosURLSearchParams.prototype;
$a2774d1dd3bec636$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$a2774d1dd3bec636$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $a2774d1dd3bec636$var$encode);
    } : $a2774d1dd3bec636$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $a2774d1dd3bec636$export$2e2bcd8739ae039 = $a2774d1dd3bec636$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $4a4d655613ae826e$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $4a4d655613ae826e$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    const _encode = options && options.encode || $4a4d655613ae826e$var$encode;
    const _options = (0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    const serializeFn = _options && _options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $77146a31cb578292$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $a2774d1dd3bec636$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $ec4d8e24b0699790$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $ec4d8e24b0699790$export$2e2bcd8739ae039 = $ec4d8e24b0699790$var$InterceptorManager;





'use strict';
var $7e146da7bba06216$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true
};






'use strict';
var $9a13f762833a66d0$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $a2774d1dd3bec636$export$2e2bcd8739ae039);


'use strict';
var $16325b87e107b4bc$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $650c3d387ae3fbd4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $e4489594588108ef$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $9a13f762833a66d0$export$2e2bcd8739ae039,
        FormData: $16325b87e107b4bc$export$2e2bcd8739ae039,
        Blob: $650c3d387ae3fbd4$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $1bbd8fa0325c4f9a$exports = {};

$parcel$export($1bbd8fa0325c4f9a$exports, "hasBrowserEnv", function () { return $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf; });
$parcel$export($1bbd8fa0325c4f9a$exports, "navigator", function () { return $1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae; });
$parcel$export($1bbd8fa0325c4f9a$exports, "hasStandardBrowserEnv", function () { return $1bbd8fa0325c4f9a$export$c0bcc9250309d66; });
$parcel$export($1bbd8fa0325c4f9a$exports, "hasStandardBrowserWebWorkerEnv", function () { return $1bbd8fa0325c4f9a$export$c81692cf5af97dac; });
$parcel$export($1bbd8fa0325c4f9a$exports, "origin", function () { return $1bbd8fa0325c4f9a$export$f710a83a91838a36; });
const $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $1bbd8fa0325c4f9a$export$c0bcc9250309d66 = $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf && (!$1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $1bbd8fa0325c4f9a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $1bbd8fa0325c4f9a$export$f710a83a91838a36 = $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $f9f874191f496b63$export$2e2bcd8739ae039 = {
    ...$1bbd8fa0325c4f9a$exports,
    ...(0, $e4489594588108ef$export$2e2bcd8739ae039)
};


'use strict';
function $f1a69cd24a140b61$export$2e2bcd8739ae039(data, options) {
    return (0, $19044a9fa7281693$export$2e2bcd8739ae039)(data, new (0, $f9f874191f496b63$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $f9f874191f496b63$export$2e2bcd8739ae039).isNode && (0, $77146a31cb578292$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $24febbb5d340c733$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $24febbb5d340c733$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $24febbb5d340c733$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $24febbb5d340c733$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFormData(formData) && (0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($24febbb5d340c733$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $24febbb5d340c733$export$2e2bcd8739ae039 = $24febbb5d340c733$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $a5e696f232d0dc12$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $77146a31cb578292$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $a5e696f232d0dc12$var$defaults = {
    transitional: (0, $7e146da7bba06216$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $77146a31cb578292$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $77146a31cb578292$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $24febbb5d340c733$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isBuffer(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isStream(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isFile(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isBlob(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $f1a69cd24a140b61$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $77146a31cb578292$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $19044a9fa7281693$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $a5e696f232d0dc12$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $a5e696f232d0dc12$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isResponse(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $77146a31cb578292$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, this.parseReviver);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $b9cc6960093b095e$export$2e2bcd8739ae039).from(e, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $f9f874191f496b63$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $f9f874191f496b63$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $a5e696f232d0dc12$var$defaults.headers[method] = {};
});
var $a5e696f232d0dc12$export$2e2bcd8739ae039 = $a5e696f232d0dc12$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $cf2275aca40d6d88$var$ignoreDuplicateOf = (0, $77146a31cb578292$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $cf2275aca40d6d88$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $cf2275aca40d6d88$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $c7e8ef3e2bb241a6$var$$internals = Symbol('internals');
function $c7e8ef3e2bb241a6$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $c7e8ef3e2bb241a6$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(value) ? value.map($c7e8ef3e2bb241a6$var$normalizeValue) : String(value);
}
function $c7e8ef3e2bb241a6$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $c7e8ef3e2bb241a6$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $c7e8ef3e2bb241a6$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $c7e8ef3e2bb241a6$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $c7e8ef3e2bb241a6$var$buildAccessors(obj, header) {
    const accessorName = (0, $77146a31cb578292$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $c7e8ef3e2bb241a6$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $c7e8ef3e2bb241a6$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$c7e8ef3e2bb241a6$var$isValidHeaderName(header)) setHeaders((0, $cf2275aca40d6d88$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(header) && (0, $77146a31cb578292$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $c7e8ef3e2bb241a6$var$normalizeHeader(header);
        if (header) {
            const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $c7e8ef3e2bb241a6$var$parseTokens(value);
                if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $c7e8ef3e2bb241a6$var$normalizeHeader(header);
        if (header) {
            const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $c7e8ef3e2bb241a6$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $c7e8ef3e2bb241a6$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $c7e8ef3e2bb241a6$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$c7e8ef3e2bb241a6$var$$internals] = this[$c7e8ef3e2bb241a6$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $c7e8ef3e2bb241a6$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$c7e8ef3e2bb241a6$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $77146a31cb578292$export$2e2bcd8739ae039).reduceDescriptors($c7e8ef3e2bb241a6$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $77146a31cb578292$export$2e2bcd8739ae039).freezeMethods($c7e8ef3e2bb241a6$var$AxiosHeaders);
var $c7e8ef3e2bb241a6$export$2e2bcd8739ae039 = $c7e8ef3e2bb241a6$var$AxiosHeaders;


'use strict';
function $0cb2ce7608ace114$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $a5e696f232d0dc12$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $36f1aa490c1da053$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $f6ac833a4b31e3dc$var$CanceledError extends (0, $b9cc6960093b095e$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $f6ac833a4b31e3dc$export$2e2bcd8739ae039 = $f6ac833a4b31e3dc$var$CanceledError;







'use strict';
function $2c92173995cdc070$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $2ecf5cf4c0202afd$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $d592abf0a04957f1$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $d592abf0a04957f1$export$2e2bcd8739ae039 = $d592abf0a04957f1$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $5603d643a9d93c92$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $5603d643a9d93c92$export$2e2bcd8739ae039 = $5603d643a9d93c92$var$throttle;



const $de65761df8a598af$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $d592abf0a04957f1$export$2e2bcd8739ae039)(50, 250);
    return (0, $5603d643a9d93c92$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $de65761df8a598af$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $de65761df8a598af$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $77146a31cb578292$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $82d74b1a5a0a01da$export$2e2bcd8739ae039 = (0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $f9f874191f496b63$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $f9f874191f496b63$export$2e2bcd8739ae039).origin), (0, $f9f874191f496b63$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $f9f874191f496b63$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $534b3794da5c002d$export$2e2bcd8739ae039 = (0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $12188e34b7070552$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $f55e71b6c54c4376$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $2ec1d7b86495f966$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $12188e34b7070552$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $f55e71b6c54c4376$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $3d132bbf7812485b$var$headersToObject = (thing)=>thing instanceof (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $3d132bbf7812485b$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(target) && (0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $77146a31cb578292$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $77146a31cb578292$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($3d132bbf7812485b$var$headersToObject(a), $3d132bbf7812485b$var$headersToObject(b), prop, true)
    };
    (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $b00a7ead3edff84a$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $3d132bbf7812485b$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $4a4d655613ae826e$export$2e2bcd8739ae039)((0, $2ec1d7b86495f966$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            const formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            const allowedHeaders = [
                'content-type',
                'content-length'
            ];
            Object.entries(formHeaders).forEach(([key, val])=>{
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $82d74b1a5a0a01da$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $534b3794da5c002d$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $2cabe869ce51dbf6$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $2cabe869ce51dbf6$export$2e2bcd8739ae039 = $2cabe869ce51dbf6$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $b00a7ead3edff84a$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $2c92173995cdc070$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Request aborted', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(msg, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $7e146da7bba06216$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ETIMEDOUT : (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $de65761df8a598af$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $de65761df8a598af$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $2ecf5cf4c0202afd$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $f9f874191f496b63$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $62bdf0498e608a4a$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $b9cc6960093b095e$export$2e2bcd8739ae039) ? err : new (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $77146a31cb578292$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $62bdf0498e608a4a$export$2e2bcd8739ae039 = $62bdf0498e608a4a$var$composeSignals;


const $c626b6acbc30fe14$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c626b6acbc30fe14$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c626b6acbc30fe14$var$readStream(iterable))yield* $c626b6acbc30fe14$export$71b051935044bd5d(chunk, chunkSize);
};
const $c626b6acbc30fe14$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c626b6acbc30fe14$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c626b6acbc30fe14$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $c2191f87f9ef3849$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $c2191f87f9ef3849$var$isFunction } = (0, $77146a31cb578292$export$2e2bcd8739ae039);
const $c2191f87f9ef3849$var$globalFetchAPI = (({ Request: Request, Response: Response })=>({
        Request: Request,
        Response: Response
    }))((0, $77146a31cb578292$export$2e2bcd8739ae039).global);
const { ReadableStream: $c2191f87f9ef3849$var$ReadableStream, TextEncoder: $c2191f87f9ef3849$var$TextEncoder } = (0, $77146a31cb578292$export$2e2bcd8739ae039).global;
const $c2191f87f9ef3849$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $c2191f87f9ef3849$var$factory = (env)=>{
    env = (0, $77146a31cb578292$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, $c2191f87f9ef3849$var$globalFetchAPI, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $c2191f87f9ef3849$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $c2191f87f9ef3849$var$isFunction(Request);
    const isResponseSupported = $c2191f87f9ef3849$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $c2191f87f9ef3849$var$isFunction($c2191f87f9ef3849$var$ReadableStream);
    const encodeText = isFetchSupported && (typeof $c2191f87f9ef3849$var$TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new $c2191f87f9ef3849$var$TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $c2191f87f9ef3849$var$test(()=>{
        let duplexAccessed = false;
        const hasContentType = new Request((0, $f9f874191f496b63$export$2e2bcd8739ae039).origin, {
            body: new $c2191f87f9ef3849$var$ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $c2191f87f9ef3849$var$test(()=>(0, $77146a31cb578292$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $f9f874191f496b63$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $77146a31cb578292$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $b00a7ead3edff84a$export$2e2bcd8739ae039)(config);
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $62bdf0498e608a4a$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: 'half'
                });
                let contentTypeHeader;
                if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $de65761df8a598af$export$d9fadd12586c18d6)(requestContentLength, (0, $de65761df8a598af$export$c1b28109d46c3592)((0, $de65761df8a598af$export$5d35863c355a22a9)(onUploadProgress)));
                    data = (0, $c626b6acbc30fe14$export$b0119225647bd83)(_request.body, $c2191f87f9ef3849$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $77146a31cb578292$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $de65761df8a598af$export$d9fadd12586c18d6)(responseContentLength, (0, $de65761df8a598af$export$c1b28109d46c3592)((0, $de65761df8a598af$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                response = new Response((0, $c626b6acbc30fe14$export$b0119225647bd83)(response.body, $c2191f87f9ef3849$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $2c92173995cdc070$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Network Error', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response), {
                cause: err.cause || err
            });
            throw (0, $b9cc6960093b095e$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $c2191f87f9ef3849$var$seedCache = new Map();
const $c2191f87f9ef3849$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $c2191f87f9ef3849$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $c2191f87f9ef3849$var$factory(env));
        map = target;
    }
    return target;
};
const $c2191f87f9ef3849$var$adapter = $c2191f87f9ef3849$export$3105c6651375d4fa();
var $c2191f87f9ef3849$export$2e2bcd8739ae039 = $c2191f87f9ef3849$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $c036c406f3928265$var$knownAdapters = {
    http: (0, $31df7fcb8acaa73a$export$2e2bcd8739ae039),
    xhr: (0, $2cabe869ce51dbf6$export$2e2bcd8739ae039),
    fetch: {
        get: $c2191f87f9ef3849$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach($c036c406f3928265$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $c036c406f3928265$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $c036c406f3928265$var$isResolvedHandle = (adapter)=>(0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $c036c406f3928265$var$getAdapter(adapters, config) {
    adapters = (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$c036c406f3928265$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $c036c406f3928265$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($c036c406f3928265$var$renderReason).join('\n') : ' ' + $c036c406f3928265$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $c036c406f3928265$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $c036c406f3928265$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $c036c406f3928265$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $a98a53c8a75f9db0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039)(null, config);
}
function $a98a53c8a75f9db0$export$2e2bcd8739ae039(config) {
    $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
    config.headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $0cb2ce7608ace114$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $c036c406f3928265$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $a5e696f232d0dc12$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $0cb2ce7608ace114$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $36f1aa490c1da053$export$2e2bcd8739ae039)(reason)) {
            $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $0cb2ce7608ace114$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $95be4ecd446de127$export$a4ad2735b021c132 = "1.13.6";



'use strict';
const $1ad671c27810423e$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $1ad671c27810423e$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $1ad671c27810423e$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $1ad671c27810423e$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $95be4ecd446de127$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$1ad671c27810423e$var$deprecatedWarnings[opt]) {
            $1ad671c27810423e$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$1ad671c27810423e$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $1ad671c27810423e$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('options must be an object', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $1ad671c27810423e$export$2e2bcd8739ae039 = {
    assertOptions: $1ad671c27810423e$var$assertOptions,
    validators: $1ad671c27810423e$var$validators
};




'use strict';
const $66f2b8a41463d1e8$var$validators = (0, $1ad671c27810423e$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $66f2b8a41463d1e8$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $ec4d8e24b0699790$export$2e2bcd8739ae039)(),
            response: new (0, $ec4d8e24b0699790$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $3d132bbf7812485b$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $1ad671c27810423e$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            forcedJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            clarifyTimeoutError: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            legacyInterceptorReqResOrdering: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $1ad671c27810423e$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $66f2b8a41463d1e8$var$validators.function,
                serialize: $66f2b8a41463d1e8$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $1ad671c27810423e$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $66f2b8a41463d1e8$var$validators.spelling('baseURL'),
            withXsrfToken: $66f2b8a41463d1e8$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $77146a31cb578292$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $7e146da7bba06216$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $a98a53c8a75f9db0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $a98a53c8a75f9db0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $3d132bbf7812485b$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $2ec1d7b86495f966$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $4a4d655613ae826e$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $66f2b8a41463d1e8$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $3d132bbf7812485b$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $3d132bbf7812485b$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $66f2b8a41463d1e8$var$Axios.prototype[method] = generateHTTPMethod();
    $66f2b8a41463d1e8$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $66f2b8a41463d1e8$export$2e2bcd8739ae039 = $66f2b8a41463d1e8$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $f4994f37c883aea2$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $f4994f37c883aea2$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $f4994f37c883aea2$export$2e2bcd8739ae039 = $f4994f37c883aea2$var$CancelToken;






'use strict';
function $8145c4b68bfee186$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $ec03acb464b74212$export$2e2bcd8739ae039(payload) {
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $a9353565c2e0947e$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($a9353565c2e0947e$var$HttpStatusCode).forEach(([key, value])=>{
    $a9353565c2e0947e$var$HttpStatusCode[value] = key;
});
var $a9353565c2e0947e$export$2e2bcd8739ae039 = $a9353565c2e0947e$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $747d656b899e6115$var$createInstance(defaultConfig) {
    const context = new (0, $66f2b8a41463d1e8$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $4c852d2f6a5a0387$export$2e2bcd8739ae039)((0, $66f2b8a41463d1e8$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $77146a31cb578292$export$2e2bcd8739ae039).extend(instance, (0, $66f2b8a41463d1e8$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $77146a31cb578292$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $747d656b899e6115$var$createInstance((0, $3d132bbf7812485b$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $747d656b899e6115$var$axios = $747d656b899e6115$var$createInstance((0, $a5e696f232d0dc12$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$747d656b899e6115$var$axios.Axios = (0, $66f2b8a41463d1e8$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$747d656b899e6115$var$axios.CanceledError = (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.CancelToken = (0, $f4994f37c883aea2$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.isCancel = (0, $36f1aa490c1da053$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.VERSION = (0, $95be4ecd446de127$export$a4ad2735b021c132);
$747d656b899e6115$var$axios.toFormData = (0, $19044a9fa7281693$export$2e2bcd8739ae039);
// Expose AxiosError class
$747d656b899e6115$var$axios.AxiosError = (0, $b9cc6960093b095e$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$747d656b899e6115$var$axios.Cancel = $747d656b899e6115$var$axios.CanceledError;
// Expose all/spread
$747d656b899e6115$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$747d656b899e6115$var$axios.spread = (0, $8145c4b68bfee186$export$2e2bcd8739ae039);
// Expose isAxiosError
$747d656b899e6115$var$axios.isAxiosError = (0, $ec03acb464b74212$export$2e2bcd8739ae039);
// Expose mergeConfig
$747d656b899e6115$var$axios.mergeConfig = (0, $3d132bbf7812485b$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.AxiosHeaders = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.formToJSON = (thing)=>(0, $24febbb5d340c733$export$2e2bcd8739ae039)((0, $77146a31cb578292$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$747d656b899e6115$var$axios.getAdapter = (0, $c036c406f3928265$export$2e2bcd8739ae039).getAdapter;
$747d656b899e6115$var$axios.HttpStatusCode = (0, $a9353565c2e0947e$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.default = $747d656b899e6115$var$axios;
var // this module should only have a default export
$747d656b899e6115$export$2e2bcd8739ae039 = $747d656b899e6115$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $c6ba0193c6fadd6f$export$1c00760e9e5a4e95, AxiosError: $c6ba0193c6fadd6f$export$c1fbed17c2f6a328, CanceledError: $c6ba0193c6fadd6f$export$1ab0c6b20d94fa14, isCancel: $c6ba0193c6fadd6f$export$3b22524397b493c6, CancelToken: $c6ba0193c6fadd6f$export$fd08e3cb425f0d61, VERSION: $c6ba0193c6fadd6f$export$a4ad2735b021c132, all: $c6ba0193c6fadd6f$export$84bf76cd7afc7469, Cancel: $c6ba0193c6fadd6f$export$848c9b7ead0df967, isAxiosError: $c6ba0193c6fadd6f$export$fbafdbe06a5b5a9a, spread: $c6ba0193c6fadd6f$export$3ae0fd4797ed47c8, toFormData: $c6ba0193c6fadd6f$export$10ae0d317ea97f8b, AxiosHeaders: $c6ba0193c6fadd6f$export$4e7d6ff0f3e6520, HttpStatusCode: $c6ba0193c6fadd6f$export$a972f69c851492b3, formToJSON: $c6ba0193c6fadd6f$export$86d7c59254d6a2c9, getAdapter: $c6ba0193c6fadd6f$export$17ddc20a97d669e2, mergeConfig: $c6ba0193c6fadd6f$export$7ec1ebcfa9d8bd6a } = (0, $747d656b899e6115$export$2e2bcd8739ae039);


const $7353c99a37ec31b7$export$4a68059d3a005c64 = async (url, body, baseUrl)=>{
    let fullUrl = (baseUrl === undefined ? (0, $07546889aef07ebc$export$df8e085683bf7fe4)() : baseUrl) + url;
    try {
        $7353c99a37ec31b7$var$setToken();
        const response = await (0, $747d656b899e6115$export$2e2bcd8739ae039).post(fullUrl, body);
        return $7353c99a37ec31b7$var$handleResponse(response);
    } catch (error) {
        return $7353c99a37ec31b7$var$handleResponse(error.response);
    }
};
const $7353c99a37ec31b7$export$e9845906888b3aa9 = async (url, body, baseUrl)=>{
    let fullUrl = (baseUrl === undefined ? (0, $07546889aef07ebc$export$df8e085683bf7fe4)() : baseUrl) + url;
    try {
        $7353c99a37ec31b7$var$setToken();
        const response = await (0, $747d656b899e6115$export$2e2bcd8739ae039).post(fullUrl, body, {
            responseType: 'blob'
        });
        return $7353c99a37ec31b7$var$handleResponse(response);
    } catch (error) {
        return $7353c99a37ec31b7$var$handleResponse(error.response);
    }
};
const $7353c99a37ec31b7$export$a5575dbeeffdad98 = async (url, file, baseUrl)=>{
    let fullUrl = (baseUrl === undefined ? (0, $07546889aef07ebc$export$df8e085683bf7fe4)() : baseUrl) + url;
    try {
        $7353c99a37ec31b7$var$setToken();
        let formData = new FormData();
        formData.append('file', file);
        const response = await (0, $747d656b899e6115$export$2e2bcd8739ae039).post(fullUrl, formData);
        return $7353c99a37ec31b7$var$handleResponse(response);
    } catch (error) {
        return $7353c99a37ec31b7$var$handleResponse(error.response);
    }
};
const $7353c99a37ec31b7$export$bcf74ec8477a7e2 = async (url, file, progressCallback)=>{
    try {
        let instance = (0, $747d656b899e6115$export$2e2bcd8739ae039).create();
        instance.defaults.headers.common = {};
        const response = await instance.put(url, file, {
            headers: {
                'Content-Type': $7353c99a37ec31b7$var$getFileType(file.type)
            },
            onUploadProgress: (progressEvent)=>{
                if (progressCallback && progressEvent.total) progressCallback(Math.floor(progressEvent.loaded * 100 / progressEvent.total));
            }
        });
        return $7353c99a37ec31b7$var$handleResponse(response);
    } catch (error) {
        return $7353c99a37ec31b7$var$handleResponse(error.response);
    }
};
const $7353c99a37ec31b7$var$getFileType = (fileType)=>{
    // override file type for content type since certain browsers just make up their own rules
    if (fileType == 'audio/mpeg') return 'audio/mp3';
    return fileType;
};
const $7353c99a37ec31b7$export$f8781c51b9396ab9 = async (url, baseUrl)=>{
    let fullUrl = (baseUrl === undefined ? (0, $07546889aef07ebc$export$df8e085683bf7fe4)() : baseUrl) + url;
    try {
        $7353c99a37ec31b7$var$setToken();
        const response = await (0, $747d656b899e6115$export$2e2bcd8739ae039).get(fullUrl);
        return $7353c99a37ec31b7$var$handleResponse(response);
    } catch (error) {
        return $7353c99a37ec31b7$var$handleResponse(error.response);
    }
};
const $7353c99a37ec31b7$export$409e9b97a28ed92d = async (url, baseUrl)=>{
    let fullUrl = (baseUrl === undefined ? (0, $07546889aef07ebc$export$df8e085683bf7fe4)() : baseUrl) + url;
    try {
        $7353c99a37ec31b7$var$setToken();
        const response = await (0, $747d656b899e6115$export$2e2bcd8739ae039).get(fullUrl, {
            responseType: 'blob'
        });
        return $7353c99a37ec31b7$var$handleResponse(response);
    } catch (error) {
        return $7353c99a37ec31b7$var$handleResponse(error.response);
    }
};
const $7353c99a37ec31b7$export$991733b4d823dec6 = async (url, body, baseUrl)=>{
    let fullUrl = (baseUrl === undefined ? (0, $07546889aef07ebc$export$df8e085683bf7fe4)() : baseUrl) + url;
    try {
        $7353c99a37ec31b7$var$setToken();
        const response = await (0, $747d656b899e6115$export$2e2bcd8739ae039).put(fullUrl, body);
        return $7353c99a37ec31b7$var$handleResponse(response);
    } catch (error) {
        return $7353c99a37ec31b7$var$handleResponse(error.response);
    }
};
const $7353c99a37ec31b7$export$21a4386506d04384 = async (url, baseUrl)=>{
    let fullUrl = (baseUrl === undefined ? (0, $07546889aef07ebc$export$df8e085683bf7fe4)() : baseUrl) + url;
    try {
        $7353c99a37ec31b7$var$setToken();
        const response = await (0, $747d656b899e6115$export$2e2bcd8739ae039).delete(fullUrl);
        return $7353c99a37ec31b7$var$handleResponse(response);
    } catch (error) {
        return $7353c99a37ec31b7$var$handleResponse(error.response);
    }
};
const $7353c99a37ec31b7$export$b0d93e0dab97a966 = (model)=>{
    let stringArray = [];
    for(let property in model)if (Object.prototype.hasOwnProperty.call(model, property) && model[property] != null) stringArray.push(encodeURIComponent(property) + '=' + encodeURIComponent(model[property]));
    return stringArray.join('&');
};
const $7353c99a37ec31b7$var$setToken = ()=>{
    // pull token from local store
    const accessToken = sessionStorage.getItem((0, $db3063bd3b6d501e$export$d975f71e6c6b349c));
    (0, $747d656b899e6115$export$2e2bcd8739ae039).defaults.headers.common['Access-Control-Allow-Origin'] = '*';
    // set to default header
    if (accessToken !== undefined) (0, $747d656b899e6115$export$2e2bcd8739ae039).defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
};
const $7353c99a37ec31b7$export$4ee989d074b27610 = (token)=>{
    (0, $747d656b899e6115$export$2e2bcd8739ae039).defaults.headers.common['Access-Control-Allow-Origin'] = '*';
    (0, $747d656b899e6115$export$2e2bcd8739ae039).defaults.headers.common['Authorization'] = `Bearer ${token}`;
};
const $7353c99a37ec31b7$export$ea8b7c0df46197b5 = (token)=>{
    (0, $747d656b899e6115$export$2e2bcd8739ae039).defaults.headers.common['X-COMMAND-TOKEN'] = token;
};
// maps an axios response to a result
const $7353c99a37ec31b7$var$handleResponse = (response)=>{
    if (!navigator.onLine) return new (0, $6d6350e3c807681d$export$2e2bcd8739ae039)();
    if (!response) return new (0, $be7228f0da37b2ae$export$2e2bcd8739ae039)();
    if (response.status === 200 || response.status === 204) {
        if (response.data === undefined) return new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)({});
        return new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)(response.data);
    } else if (response.status === 400) {
        let errors = response.data;
        let error = errors[0];
        if (error == undefined) {
            let attributeErrorNames = Object.getOwnPropertyNames(errors);
            if (attributeErrorNames[0] != undefined && errors[attributeErrorNames[0]] != null) error = errors[attributeErrorNames[0]];
            else error = response.data['Responses[0].Content'][0];
        }
        return new (0, $6340c001daecf2cb$export$2e2bcd8739ae039)(error);
    } else if (response.status === 404) return new (0, $206736819695f5cd$export$2e2bcd8739ae039)();
    else if (response.status === 403) return new (0, $eb323d7d149f5b89$export$2e2bcd8739ae039)();
    return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
};


const $1a4c36336f303477$export$c542b5e295206b2a = (clientId, clientSecret, refreshToken)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/signin/token?client_id=${clientId}&client_secret=${clientSecret}&refresh_token=${refreshToken}&grant_type=refresh_token`, null);
};
const $1a4c36336f303477$export$257b2d10b709d8ef = (clientId, code, redirectUri)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/signin/token?client_id=${clientId}&code=${code}&redirect_uri=${encodeURI(redirectUri)}&grant_type=code`, null);
};
const $1a4c36336f303477$export$5a6314a822d8df05 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)('/api/Authentication/AuthClient/FeatureAccess');
};
const $1a4c36336f303477$export$376a941b4307217d = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/ClientOnboarding/status/current`);
};
const $1a4c36336f303477$export$63e184abc187829a = (request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/ClientOnboarding/status/current`, request);
};
const $1a4c36336f303477$export$b77d91733b0be1c3 = (deviceTypeId, name, hardwareId, platform)=>{
    let paramsObj = {};
    if (name) paramsObj.name = name;
    if (hardwareId) paramsObj.hardwareId = hardwareId;
    if (platform) paramsObj.platform = platform;
    const params = new URLSearchParams(paramsObj);
    const queryString = params.toString();
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/device/userDevices/new/${deviceTypeId}?${queryString ?? ''}`, null);
};
const $1a4c36336f303477$export$7d50e0ca36e10692 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/device/userDevices`);
};
const $1a4c36336f303477$export$bcdfb52e5b6fae71 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/device/deviceTypes`);
};
const $1a4c36336f303477$export$1550d2bbaae6a36d = (locale)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/Device/deviceTypes/public/clientListings/locale?locale=${locale}`);
};
const $1a4c36336f303477$export$9c71b804c7d56d57 = (deviceTypeId, locale)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/device/deviceTypes/${deviceTypeId}/clientListing?locale=${locale}`);
};
const $1a4c36336f303477$export$fb1c38ee1d8d29f5 = (deviceTypeId, locale)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/device/deviceTypes/${deviceTypeId}/customControls?locale=${locale}`);
};
const $1a4c36336f303477$export$7c456bfd2296405b = (userDeviceId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/device/userDevices/${userDeviceId}`);
};
const $1a4c36336f303477$export$d11b3391d3492ee8 = (userDeviceId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/device/userDevices/${userDeviceId}/tokens`);
};
const $1a4c36336f303477$export$d90355b21d70c45b = (userDeviceId, options)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/device/userDevices/${userDeviceId}/tokens`, options);
};
const $1a4c36336f303477$export$600b579bd3ac45b1 = (userDeviceId, locale)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/device/userDevices/${userDeviceId}/customControls?locale=${locale}`);
};
const $1a4c36336f303477$export$b9a2c62bbb3b9917 = (userDeviceTypeId, configuration, locale)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/device/userDevices/${userDeviceTypeId}/customControls?locale=${locale}`, configuration);
};
const $1a4c36336f303477$export$acdb1997acaa39c3 = (userDeviceId, controls, locale)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/device/userDevices/${userDeviceId}/customControls/default?locale=${locale}`, controls);
};
const $1a4c36336f303477$export$4ff3dab44ee74505 = (userDeviceId)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/device/userDevices/${userDeviceId}/tokens/command`, null);
};
const $1a4c36336f303477$export$4ec306b864d03d47 = (userDeviceId, profileId)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/device/userDevices/${userDeviceId}/setprofile/${profileId}`, null);
};
const $1a4c36336f303477$export$c35b3a8741882c0 = (userDeviceId, request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/device/userDevices/${userDeviceId}/setProfile/v2`, request);
};
const $1a4c36336f303477$export$3620b5cb1c7d18ec = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/deviceProfile/private`);
};
const $1a4c36336f303477$export$5bd7a6effa9290bc = (profileId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/deviceProfile/${profileId}`);
};
const $1a4c36336f303477$export$dda1c3bd332d195f = (request)=>{
    const params = new URLSearchParams();
    // build the query string
    Object.entries(request).forEach(([key, value])=>{
        if (value == null) return;
        if (Array.isArray(value)) value.forEach((item)=>params.append(key, item));
        else params.append(key, value.toString());
    });
    let queryString = params.toString();
    queryString = queryString ? `?${queryString}` : '';
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/deviceProfile/public${queryString}`);
};
const $1a4c36336f303477$export$fb988fbe57f9c402 = (profileId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/deviceProfile/public/${profileId}`);
};
const $1a4c36336f303477$export$6660b028f5be10a7 = (configuration)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/deviceProfile/v2`, configuration);
};
const $1a4c36336f303477$export$5880729c5d131040 = (profileId, configuration)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/deviceProfile/v2/${profileId}`, configuration);
};
const $1a4c36336f303477$export$29d101fdcde3d3d3 = (profileId)=>{
    return (0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/deviceProfile/${profileId}`);
};
const $1a4c36336f303477$export$2fbfcdb28574a0 = (userDeviceId, token)=>{
    (0, $7353c99a37ec31b7$export$ea8b7c0df46197b5)(token);
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/deviceCommand/${userDeviceId}/listen/start`, null);
};
const $1a4c36336f303477$export$8f1ea12fa311585e = (userDeviceId, token)=>{
    (0, $7353c99a37ec31b7$export$ea8b7c0df46197b5)(token);
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/deviceCommand/${userDeviceId}/listen/stop`, null);
};
const $1a4c36336f303477$export$18c61c16dde23826 = (userDeviceId, model)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/device/userDevices/${userDeviceId}`, model);
};
const $1a4c36336f303477$export$7cbb8f3d5a86c9b4 = (userDeviceId)=>{
    return (0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/device/userDevices/${userDeviceId}`);
};
const $1a4c36336f303477$export$c25252bb8cefd145 = (userDeviceId)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/device/userDevices/${userDeviceId}/disable`, null);
};
const $1a4c36336f303477$export$52e3a002786737fb = (userDeviceId, command, token, macro)=>{
    (0, $7353c99a37ec31b7$export$ea8b7c0df46197b5)(token);
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/deviceCommand/${userDeviceId}/command?command=${command}`, macro);
};
const $1a4c36336f303477$export$24fb0aee8e6ea00f = (userDeviceId, phrase, token)=>{
    (0, $7353c99a37ec31b7$export$ea8b7c0df46197b5)(token);
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/deviceCommand/${userDeviceId}/type?phrase=${phrase}`, null);
};
const $1a4c36336f303477$export$e5712e6cd1606beb = (userDeviceId, token)=>{
    (0, $7353c99a37ec31b7$export$ea8b7c0df46197b5)(token);
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/deviceCommand/${userDeviceId}/firmware/update`, null);
};
const $1a4c36336f303477$export$e5432d4c8eb97ea7 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/user`);
};
const $1a4c36336f303477$export$160fb9e4529c1fb8 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/config/tos`);
};
const $1a4c36336f303477$export$c2c1fd00af0fe210 = (request)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/User/tos-acceptance`, request);
};
const $1a4c36336f303477$export$423f8e8c6cce5fd3 = ()=>{
    return (0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/user/deleteCurrentUser`);
};
const $1a4c36336f303477$export$99d837dc30eb1ef7 = (request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/user/changePassword`, request);
};
const $1a4c36336f303477$export$ca144d7073999c98 = (request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/user/locales`, request);
};
const $1a4c36336f303477$export$a5fa6ef87cbd9c24 = ()=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/user/locales/reset`, null);
};
const $1a4c36336f303477$export$4cedc5ba9e15b997 = ()=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/user/requestEmailVerification`, null);
};
const $1a4c36336f303477$export$2892959f926e8bd6 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/user/licenseAccess`);
};
const $1a4c36336f303477$export$6dcf149406a53b24 = (profileId, request)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/deviceProfile/${profileId}/share`, request);
};
const $1a4c36336f303477$export$c7b3bc714f32d7a9 = (profileId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/deviceProfile/${profileId}/shares`);
};
const $1a4c36336f303477$export$80c41221f92ef9be = (shareId)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/deviceProfile/shares/${shareId}/disable`, null);
};
const $1a4c36336f303477$export$e5888858f383ec64 = (shareAccessCode)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/deviceProfile/shares/preview/${shareAccessCode}`);
};
const $1a4c36336f303477$export$827ad3bf4ce3bb83 = (shareAccessCode)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/deviceProfile/shares/accept/${shareAccessCode}`, null);
};
const $1a4c36336f303477$export$8cf7ec95b3fb64ef = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/capabilityFacets`);
};
const $1a4c36336f303477$export$d12f355dc16ebf93 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/user/CapabilitySettings`);
};
const $1a4c36336f303477$export$78668e730a02e76 = (request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/user/CapabilitySettings`, request);
};
const $1a4c36336f303477$export$8fe3f057eebad1bc = (request)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/deviceProfile/generate`, request);
};
const $1a4c36336f303477$export$e212b208cbec5050 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/SystemNotifications/scoped/all`);
};
const $1a4c36336f303477$export$1cfb7ff6a4b15ea = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/SystemNotifications/scoped/unread`);
};
const $1a4c36336f303477$export$49199adf1afcc108 = (notificationId)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/SystemNotifications/${notificationId}/read`, null);
};
const $1a4c36336f303477$export$f4d031e4baefbd82 = (notification)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/SystemNotifications/scoped`, notification);
};
const $1a4c36336f303477$export$7320d6eeb2c8ac54 = (request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/user/emailPreferences`, request);
};
const $1a4c36336f303477$export$2a6c232d8be225a8 = (request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/user/UserPreferences`, request);
};
const $1a4c36336f303477$export$ae3f5fa351e2f57a = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)('/api/user/UserPreferences');
};
const $1a4c36336f303477$export$3c6d5a5870f12c81 = (locale)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/user/AppInterfaceControls?locale=${locale}`);
};
const $1a4c36336f303477$export$1ac6c99dd884ccad = (interfaceControl, locale)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/user/AppInterfaceControls?locale=${locale}`, interfaceControl);
};
const $1a4c36336f303477$export$a751a00626fa5d99 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/Scope`);
};
const $1a4c36336f303477$export$760587335e9aead6 = (inviteCode)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/organization/invitation/accept?inviteCode=${inviteCode}`, null);
};
const $1a4c36336f303477$export$bc4193cb9cb5ffbf = (inviteCode)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/organization/invitation/reject?inviteCode=${inviteCode}`, null);
};
const $1a4c36336f303477$export$723853a93f25bfc8 = (invitationId)=>{
    return (0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/organization/invitation/${invitationId}`);
};
const $1a4c36336f303477$export$ca73d6dfa029e755 = (organizationId, request)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/organization/${organizationId}/invite`, request);
};
const $1a4c36336f303477$export$7e61d855c21d0cf9 = (organizationId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}`);
};
const $1a4c36336f303477$export$9fa0549694b5b397 = (organizationId, search)=>{
    const url = (0, $13d0c8a27a7be22f$export$6b17a39e52c8ee53)(search ?? {}, `/api/organization/${organizationId}/members`);
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(url);
};
const $1a4c36336f303477$export$e826230d7947b0b6 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/joined`);
};
const $1a4c36336f303477$export$99736a1ab639617d = (organizationMemberId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/members/${organizationMemberId}`);
};
const $1a4c36336f303477$export$f49c5f59ccb70c7 = (organizationMemberId)=>{
    return (0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/organization/members/${organizationMemberId}`);
};
const $1a4c36336f303477$export$9e3347137373e17d = (organizationMemberId, request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/organization/members/${organizationMemberId}`, request);
};
const $1a4c36336f303477$export$fc5cc62c84093276 = (organizationId, search)=>{
    const url = (0, $13d0c8a27a7be22f$export$6b17a39e52c8ee53)(search ?? {}, `/api/organization/${organizationId}/invite`);
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(url);
};
const $1a4c36336f303477$export$244d7766d2df1442 = (organizationId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/deviceProfiles`);
};
const $1a4c36336f303477$export$3f4430ea1068bd7f = (organizationId, request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/organization/${organizationId}`, request);
};
const $1a4c36336f303477$export$671500b18c6f825a = (organizationId)=>{
    return (0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/organization/${organizationId}`);
};
const $1a4c36336f303477$export$3c51bcb045a4dcf7 = (organizationId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/authClients`);
};
const $1a4c36336f303477$export$1dd21c4331ea2afe = (organizationId, authClientId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/authClients/${authClientId}`);
};
const $1a4c36336f303477$export$882babc7ce0168b1 = (organizationId, authClientId, request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/organization/${organizationId}/authClients/${authClientId}`, request);
};
const $1a4c36336f303477$export$6273d0fdd20ec2b = (organizationId, request)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/organization/${organizationId}/authClients`, request);
};
const $1a4c36336f303477$export$fb8fa300ccf972f1 = (organizationId, authClientId)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/organization/${organizationId}/authClients/${authClientId}/rotateSecret`, null);
};
const $1a4c36336f303477$export$9d046100115f8eb6 = (organizationId, authClientId)=>{
    return (0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/organization/${organizationId}/authClients/${authClientId}`);
};
const $1a4c36336f303477$export$1349a2482875cb46 = (organizationId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/deviceTypes`);
};
const $1a4c36336f303477$export$283d103ee023ff02 = (organizationId, deviceTypeId, request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/organization/${organizationId}/deviceTypes/${deviceTypeId}`, request);
};
const $1a4c36336f303477$export$56b000d2f0c12703 = (organizationId, request)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/organization/${organizationId}/deviceTypes`, request);
};
const $1a4c36336f303477$export$564a73641b2b83a = (organizationId, deviceTypeId)=>{
    return (0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/organization/${organizationId}/deviceTypes/${deviceTypeId}`);
};
const $1a4c36336f303477$export$b7d20456d96f632 = (organizationId, deviceTypeId, request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/organization/${organizationId}/deviceTypes/${deviceTypeId}/throttleRules`, request);
};
const $1a4c36336f303477$export$fa9b0f7297241009 = (organizationId, deviceTypeId, request)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/organization/${organizationId}/deviceTypes/${deviceTypeId}/customControls`, request);
};
const $1a4c36336f303477$export$ae6dfd1cb318a3be = (organizationId, deviceTypeId, locale, request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/organization/${organizationId}/deviceTypes/${deviceTypeId}/customControls?locale=${locale}`, request);
};
const $1a4c36336f303477$export$f942174137d3f696 = (organizationId, deviceTypeId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/deviceTypes/${deviceTypeId}/clientListings`);
};
const $1a4c36336f303477$export$a1d716d9f71fe1c5 = (organizationId, deviceTypeId, request)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/organization/${organizationId}/deviceTypes/${deviceTypeId}/clientListings`, request);
};
const $1a4c36336f303477$export$2fbd549f3e7afb42 = (organizationId, deviceTypeId, request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/organization/${organizationId}/deviceTypes/${deviceTypeId}/clientListings`, request);
};
const $1a4c36336f303477$export$3459b02a7394388f = (organizationId, search)=>{
    const url = (0, $13d0c8a27a7be22f$export$6b17a39e52c8ee53)(search ?? {}, `/api/organization/${organizationId}/managedLicenseKeys`);
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(url);
};
const $1a4c36336f303477$export$c9479eea2fe9bdb4 = (organizationId, search)=>{
    const url = (0, $13d0c8a27a7be22f$export$6b17a39e52c8ee53)(search ?? {}, `/api/organization/${organizationId}/managedLicenseKeys/available`);
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(url);
};
const $1a4c36336f303477$export$9b109560db3e5fa8 = (organizationId, search)=>{
    const url = (0, $13d0c8a27a7be22f$export$6b17a39e52c8ee53)(search ?? {}, `/api/organization/${organizationId}/managedLicenseKeys/used`);
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(url);
};
const $1a4c36336f303477$export$c2666d621521d258 = (organizationId, search)=>{
    const url = (0, $13d0c8a27a7be22f$export$6b17a39e52c8ee53)(search ?? {}, `/api/organization/${organizationId}/managedOrganizations`);
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(url);
};
const $1a4c36336f303477$export$cbe92e1dd502f37 = (organizationId, request)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/organization/${organizationId}/managedOrganizations`, request);
};
const $1a4c36336f303477$export$e8e91c27f56f2528 = (organizationId, managedOrgId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/managedOrganizations/${managedOrgId}/billing/link`);
};
const $1a4c36336f303477$export$e57608268c048777 = (organizationId, locale, search)=>{
    const url = (0, $13d0c8a27a7be22f$export$6b17a39e52c8ee53)(search ?? {}, `/api/organization/${organizationId}/products`, locale);
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(url);
};
const $1a4c36336f303477$export$8c8a9832b60f1887 = (organizationId, productId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/products/${productId}/link`);
};
const $1a4c36336f303477$export$520abd51d5e65c96 = (organizationId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/members/me`);
};
const $1a4c36336f303477$export$f7fea89e235b5345 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/memberships`);
};
const $1a4c36336f303477$export$8c7a465b3f0d49dd = (organizationId, trialId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/trial/${trialId}/upgradeLink`);
};
const $1a4c36336f303477$export$912fe73bbf623b0f = (organizationId, trialId, productId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/trial/${trialId}/upgradeLink/product/${productId}`);
};
const $1a4c36336f303477$export$dabcd4edef40b727 = (organizationId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/billing/link`);
};
const $1a4c36336f303477$export$7c5bc9294ee86597 = (organizationId, productId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/billing/link/product/${productId}`);
};
const $1a4c36336f303477$export$a465a1c9c4acd44f = (organizationId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/automationRules`);
};
const $1a4c36336f303477$export$f242f627e9439409 = (organizationId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/automationRules/member`);
};
const $1a4c36336f303477$export$26cbfe4feb76f571 = (organizationId, ruleId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/automationRules/${ruleId}`);
};
const $1a4c36336f303477$export$fb336c06cd332913 = (organizationId, request)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/organization/${organizationId}/automationRules`, request);
};
const $1a4c36336f303477$export$79317fff3103dbad = (organizationId, ruleId, request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/organization/${organizationId}/automationRules/${ruleId}`, request);
};
const $1a4c36336f303477$export$2a08cd7e8e594692 = (organizationId, ruleId)=>{
    return (0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/organization/${organizationId}/automationRules/${ruleId}`);
};
const $1a4c36336f303477$export$b9df2887c5fea5c = (organizationId, organizationMemberId, ruleId)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/organization/${organizationId}/members/${organizationMemberId}/automationRules/${ruleId}`, null);
};
const $1a4c36336f303477$export$ba7b32392a99780c = (organizationId, organizationMemberId, ruleId)=>{
    return (0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/organization/${organizationId}/members/${organizationMemberId}/automationRules/${ruleId}`);
};
const $1a4c36336f303477$export$a6f9b5388d528cec = (organizationId, organizationMemberId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/members/${organizationMemberId}/automationRules`);
};
const $1a4c36336f303477$export$2e4ad76cf0d49052 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/License/products/public`);
};
const $1a4c36336f303477$export$dd3c078d2eaaeb12 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/ModelReference/genai`);
};
const $1a4c36336f303477$export$4f1930389137b6da = (request)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/License/activate`, request);
};
const $1a4c36336f303477$export$68ccee5da54c27c3 = (organizationId, request)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/License/activate/${organizationId}`, request);
};
const $1a4c36336f303477$export$18169adbba1e88bc = (licenseKey)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/License/validate/${licenseKey}`);
};
const $1a4c36336f303477$export$4e97a7883c500e67 = (organizationId, licenseKey)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/License/validate/${organizationId}/${licenseKey}`);
};
const $1a4c36336f303477$export$5a3de2615974c687 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/ModelReference/voice`);
};
const $1a4c36336f303477$export$f97d6f9131c89174 = (modelId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/ModelReference/voice/${modelId}`);
};
const $1a4c36336f303477$export$78ac26d691c779f4 = (locale, fileFormat)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/ModelReference/voice/locale/${locale}?fileFormat=${fileFormat}`);
};
const $1a4c36336f303477$export$1ac08db9e5a63db = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/ModelReference/vision`);
};
const $1a4c36336f303477$export$9f3370c4c207cc54 = (modelId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/ModelReference/vision/${modelId}`);
};





var $7fPBF = parcelRequire("7fPBF");
/**
 * Note: This is a custom hook that is used to store a reference to the state.
 * When updating the state from the ref, you will need to use cloneDeep to create a new reference.
 * Without doing so, the state will not update and any useEffects that depend on the state will not run.
 * For examples of this, please see the ProfilesContainer.ts file.
 */ const $03ffc57089f4cd6c$var$isFunction = (setStateAction)=>typeof setStateAction === 'function';
const $03ffc57089f4cd6c$var$useStateRef = (initialState)=>{
    const [state, setState] = (0, $7fPBF.useState)(initialState);
    const ref = (0, $7fPBF.useRef)(state);
    const dispatch = (0, $7fPBF.useCallback)((setStateAction)=>{
        ref.current = $03ffc57089f4cd6c$var$isFunction(setStateAction) ? setStateAction(ref.current) : setStateAction;
        setState(ref.current);
    }, []);
    return [
        state,
        dispatch,
        ref
    ];
};
var $03ffc57089f4cd6c$export$2e2bcd8739ae039 = $03ffc57089f4cd6c$var$useStateRef;


function $455682785eac4c5b$var$useAuthContainer() {
    const [isAuthenticated, setIsAuthenticated, isAuthenticatedRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(false);
    const [accessToken, setAccessToken, accessTokenRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(null);
    const [refreshToken, setRefreshToken, refreshTokenRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(null);
    const [expirationDate, setExpirationDate, expirationDateRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(new Date());
    const [isLoading, setIsLoading, isLoadingRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(true);
    const [isLoadingDataComplete, setIsLoadingDataComplete, isLoadingDataCompleteRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(false);
    const [isInitialized, setIsInitialized, isInitializedRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(false);
    const signoutListenersRef = (0, $7fPBF.useRef)([]);
    const [errors, setErrors] = (0, $7fPBF.useState)([]);
    const notifyListeners = (listeners)=>{
        listeners.forEach((listener)=>{
            try {
                listener();
            } catch (error) {
                console.error('Error in signout listener:', error);
            }
        });
    };
    const addSignoutListener = (listener)=>{
        signoutListenersRef.current.push(listener);
    };
    const removeSignoutListener = (listener)=>{
        signoutListenersRef.current = signoutListenersRef.current.filter((l)=>l !== listener);
    };
    const initializeFromStorage = ()=>{
        setIsLoading(true);
        try {
            const accessToken = sessionStorage.getItem((0, $db3063bd3b6d501e$export$d975f71e6c6b349c));
            const refreshToken = localStorage.getItem((0, $db3063bd3b6d501e$export$f849a8e4906d2051));
            const expirationDate = localStorage.getItem((0, $db3063bd3b6d501e$export$ccdad49998c6d6ff));
            if (refreshToken) {
                setAccessToken(accessToken);
                setRefreshToken(refreshToken);
                if (expirationDate) setExpirationDate(new Date(expirationDate));
                setIsAuthenticated(true);
                if (!isInitializedRef.current) setIsInitialized(true);
                console.log('Auth.initialzeFromStorage: Authenticated');
            } else console.log('Auth.initialzeFromStorage: No refresh token found');
            return true;
        } catch (e) {
            console.log('Auth.initialzeFromStorage:', e);
            return false;
        } finally{
            setIsLoading(false);
        }
    };
    const loginFromCode = async (code)=>{
        try {
            setIsLoading(true);
            const result = await $1a4c36336f303477$export$257b2d10b709d8ef((0, $db3063bd3b6d501e$export$666167f3cc1c081a)(), code, (0, $07546889aef07ebc$export$b0c2c82d7aa8a735)());
            if (result?.resultType == 'Ok' && result.data) {
                sessionStorage.setItem((0, $db3063bd3b6d501e$export$d975f71e6c6b349c), result.data.access_token);
                localStorage.setItem((0, $db3063bd3b6d501e$export$f849a8e4906d2051), result.data.refresh_token);
                localStorage.setItem((0, $db3063bd3b6d501e$export$ccdad49998c6d6ff), result.data.access_token_expiration);
                setAccessToken(result.data.access_token);
                setRefreshToken(result.data.refresh_token);
                setExpirationDate(new Date(result.data.access_token_expiration));
                setIsAuthenticated(true);
                if (!isInitializedRef.current) setIsInitialized(true);
            } else if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            return result;
        } catch (error) {
            setErrors([
                error
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setIsLoading(false);
        }
    };
    const getNewToken = async ()=>{
        setIsLoading(true);
        try {
            const latestRefresh = localStorage.getItem((0, $db3063bd3b6d501e$export$f849a8e4906d2051));
            if (!latestRefresh) {
                setIsLoading(false);
                return {
                    resultType: 'Invalid',
                    errors: [
                        'No refresh token found'
                    ]
                };
            }
            const result = await $1a4c36336f303477$export$c542b5e295206b2a((0, $db3063bd3b6d501e$export$666167f3cc1c081a)(), (0, $db3063bd3b6d501e$export$abb5e0783f1a4f17)(), latestRefresh);
            if (result.resultType == 'Offline' || result.resultType == 'NoResponse') {
                // just use the token from storage and early return
                const storage = initializeFromStorage();
                if (storage) return {
                    resultType: 'Ok'
                };
            }
            if (result?.resultType == 'Ok' && result.data) {
                // set the new tokens in session and local storage
                sessionStorage.setItem((0, $db3063bd3b6d501e$export$d975f71e6c6b349c), result.data.access_token);
                localStorage.setItem((0, $db3063bd3b6d501e$export$f849a8e4906d2051), result.data.refresh_token);
                localStorage.setItem((0, $db3063bd3b6d501e$export$ccdad49998c6d6ff), result.data.access_token_expiration);
                setAccessToken(result.data.access_token);
                setRefreshToken(result.data.refresh_token);
                setExpirationDate(new Date(result.data.access_token_expiration));
                setIsAuthenticated(true);
                if (!isInitializedRef.current) setIsInitialized(true);
            }
            if (result.errors != null && result.errors.length > 0 && result.resultType != 'Ok') {
                setErrors([
                    ...result.errors
                ]);
                logout();
            }
            return result;
        } catch (error) {
            setErrors([
                error
            ]);
            return {
                resultType: 'Invalid',
                errors: [
                    error
                ]
            };
        } finally{
            setIsLoading(false);
        }
    };
    const handleIsLoading = (loading)=>{
        setIsLoading(loading);
    };
    const logout = ()=>{
        setIsLoading(true);
        notifyListeners(signoutListenersRef.current);
        sessionStorage.clear();
        localStorage.clear();
        setIsAuthenticated(false);
        setAccessToken(null);
        setRefreshToken(null);
        setExpirationDate(new Date());
        signoutListenersRef.current = [];
        setIsLoading(false);
    };
    return {
        isInitialized: isInitialized,
        setIsInitialized: setIsInitialized,
        isInitializedRef: isInitializedRef,
        isAuthenticated: isAuthenticated,
        isAuthenticatedRef: isAuthenticatedRef,
        accessToken: accessToken,
        accessTokenRef: accessTokenRef,
        refreshToken: refreshToken,
        refreshTokenRef: refreshTokenRef,
        expirationDate: expirationDate,
        expirationDateRef: expirationDateRef,
        isLoading: isLoading,
        isLoadingRef: isLoadingRef,
        isLoadingDataComplete: isLoadingDataComplete,
        isLoadingDataCompleteRef: isLoadingDataCompleteRef,
        setIsLoadingDataComplete: setIsLoadingDataComplete,
        handleIsLoading: handleIsLoading,
        errors: errors,
        logout: logout,
        loginFromCode: loginFromCode,
        getNewToken: getNewToken,
        initializeFromStorage: initializeFromStorage,
        addSignoutListener: addSignoutListener,
        removeSignoutListener: removeSignoutListener
    };
}
const $455682785eac4c5b$var$AuthContainer = (0, $78783f85c4167892$export$26ae5ca175b4ec5a)($455682785eac4c5b$var$useAuthContainer);
var $455682785eac4c5b$export$2e2bcd8739ae039 = $455682785eac4c5b$var$AuthContainer;



const $4c9078e3f4d4e7ac$export$fec487fd88f90673 = 'left_eyebrow_raise';
const $4c9078e3f4d4e7ac$export$e29bd3f870e59532 = 'right_eyebrow_raise';
const $4c9078e3f4d4e7ac$export$1bcbc534e3cad6ca = 'eyebrows_raised';
const $4c9078e3f4d4e7ac$export$8c373650910b3bac = 'left_eyebrow_lower';
const $4c9078e3f4d4e7ac$export$5e8f0e6a41a5a9f0 = 'right_eyebrow_lower';
const $4c9078e3f4d4e7ac$export$ae6877785f945029 = 'eyebrows_lower';
const $4c9078e3f4d4e7ac$export$8bc8e7800890a14c = 'smile';
const $4c9078e3f4d4e7ac$export$81ed1df06f5efbb1 = 'stop_smile';
const $4c9078e3f4d4e7ac$export$964c1b24697b74c8 = 'mouth_open';
const $4c9078e3f4d4e7ac$export$5aa1ceccf76c493d = 'mouth_close';
const $4c9078e3f4d4e7ac$export$e9fd9bbd349f12e = 'mouth_pucker';
const $4c9078e3f4d4e7ac$export$c9933241f376f0db = 'left_eye_close';
const $4c9078e3f4d4e7ac$export$743a943ffb348687 = 'right_eye_close';
const $4c9078e3f4d4e7ac$export$eca640d50ff796d5 = 'left_eye_open';
const $4c9078e3f4d4e7ac$export$a938ee9b6fd7a635 = 'right_eye_open';
const $4c9078e3f4d4e7ac$export$7f9a6c987783536c = 'both_eyes_close';
const $4c9078e3f4d4e7ac$export$a903f8481631e4eb = 'both_eyes_open';
const $4c9078e3f4d4e7ac$export$821d2a2d20ce1ccf = [
    $4c9078e3f4d4e7ac$export$fec487fd88f90673,
    $4c9078e3f4d4e7ac$export$e29bd3f870e59532,
    $4c9078e3f4d4e7ac$export$1bcbc534e3cad6ca,
    $4c9078e3f4d4e7ac$export$8c373650910b3bac,
    $4c9078e3f4d4e7ac$export$5e8f0e6a41a5a9f0,
    $4c9078e3f4d4e7ac$export$ae6877785f945029,
    $4c9078e3f4d4e7ac$export$8bc8e7800890a14c,
    $4c9078e3f4d4e7ac$export$81ed1df06f5efbb1,
    $4c9078e3f4d4e7ac$export$964c1b24697b74c8,
    $4c9078e3f4d4e7ac$export$5aa1ceccf76c493d,
    $4c9078e3f4d4e7ac$export$c9933241f376f0db,
    $4c9078e3f4d4e7ac$export$743a943ffb348687,
    $4c9078e3f4d4e7ac$export$eca640d50ff796d5,
    $4c9078e3f4d4e7ac$export$a938ee9b6fd7a635,
    $4c9078e3f4d4e7ac$export$7f9a6c987783536c,
    $4c9078e3f4d4e7ac$export$a903f8481631e4eb
];
const $4c9078e3f4d4e7ac$var$createFaceCommand = (value, title, description)=>{
    return {
        value: value,
        title: title,
        description: description
    };
};
const $4c9078e3f4d4e7ac$export$66556ffb0952dbd1 = [
    $4c9078e3f4d4e7ac$var$createFaceCommand($4c9078e3f4d4e7ac$export$8bc8e7800890a14c, 'common:expression.startSmiling.title', 'common:expression.startSmiling.description'),
    $4c9078e3f4d4e7ac$var$createFaceCommand($4c9078e3f4d4e7ac$export$81ed1df06f5efbb1, 'common:expression.stopSmiling.title', 'common:expression.stopSmiling.description'),
    $4c9078e3f4d4e7ac$var$createFaceCommand($4c9078e3f4d4e7ac$export$1bcbc534e3cad6ca, 'common:expression.eyebrows.title', 'common:expression.eyebrows.description'),
    $4c9078e3f4d4e7ac$var$createFaceCommand($4c9078e3f4d4e7ac$export$964c1b24697b74c8, 'common:expression.openMouth.title', 'common:expression.openMouth.description'),
    $4c9078e3f4d4e7ac$var$createFaceCommand($4c9078e3f4d4e7ac$export$5aa1ceccf76c493d, 'common:expression.closeMouth.title', 'common:expression.closeMouth.description')
];


const $36ef3dc0587051fc$export$d94f9a81f26f28d7 = 'head_tilt_left';
const $36ef3dc0587051fc$export$4c0c3d8967111e99 = 'head_tilt_right';
const $36ef3dc0587051fc$export$cb516a1825b74c73 = 'head_tilt_back';
const $36ef3dc0587051fc$export$51b0ed0abf71f56b = 'head_tilt_forward';
const $36ef3dc0587051fc$export$ce9364ff9e3ce20f = 'head_turn_left';
const $36ef3dc0587051fc$export$97a51662dd806ec0 = 'head_turn_right';
const $36ef3dc0587051fc$export$e20c154cab65adce = 'head_lean_left';
const $36ef3dc0587051fc$export$520abd32623264d3 = 'head_lean_right';
const $36ef3dc0587051fc$export$78319fa5fd133058 = 'head_lean_back';
const $36ef3dc0587051fc$export$18c969b8ac64ef37 = 'head_lean_forward';
const $36ef3dc0587051fc$export$9a70b70b3792325c = 'head_move_up';
const $36ef3dc0587051fc$export$c9a7f673431c7a0f = 'head_move_down';
const $36ef3dc0587051fc$export$6a9d09a2b2e2f93f = 'head_center';
const $36ef3dc0587051fc$export$b83c6ea936a344b9 = [
    $36ef3dc0587051fc$export$d94f9a81f26f28d7,
    $36ef3dc0587051fc$export$4c0c3d8967111e99,
    $36ef3dc0587051fc$export$cb516a1825b74c73,
    $36ef3dc0587051fc$export$51b0ed0abf71f56b,
    $36ef3dc0587051fc$export$ce9364ff9e3ce20f,
    $36ef3dc0587051fc$export$97a51662dd806ec0,
    $36ef3dc0587051fc$export$e20c154cab65adce,
    $36ef3dc0587051fc$export$520abd32623264d3,
    $36ef3dc0587051fc$export$78319fa5fd133058,
    $36ef3dc0587051fc$export$18c969b8ac64ef37,
    $36ef3dc0587051fc$export$c9a7f673431c7a0f,
    $36ef3dc0587051fc$export$9a70b70b3792325c,
    $36ef3dc0587051fc$export$6a9d09a2b2e2f93f
];
const $36ef3dc0587051fc$var$createHeadCommand = (value, title, description)=>{
    return {
        value: value,
        title: title,
        description: description
    };
};
const $36ef3dc0587051fc$export$d58460d69cd22e7b = [
    $36ef3dc0587051fc$var$createHeadCommand($36ef3dc0587051fc$export$d94f9a81f26f28d7, 'common:head.tilt.left.title', 'common:head.tilt.left.description'),
    $36ef3dc0587051fc$var$createHeadCommand($36ef3dc0587051fc$export$4c0c3d8967111e99, 'common:head.tilt.right.title', 'common:head.tilt.right.description'),
    $36ef3dc0587051fc$var$createHeadCommand($36ef3dc0587051fc$export$cb516a1825b74c73, 'common:head.tilt.back.title', 'common:head.tilt.back.description'),
    $36ef3dc0587051fc$var$createHeadCommand($36ef3dc0587051fc$export$51b0ed0abf71f56b, 'common:head.tilt.forward.title', 'common:head.tilt.forward.description'),
    $36ef3dc0587051fc$var$createHeadCommand($36ef3dc0587051fc$export$ce9364ff9e3ce20f, 'common:head.turn.left.title', 'common:head.turn.left.description'),
    $36ef3dc0587051fc$var$createHeadCommand($36ef3dc0587051fc$export$97a51662dd806ec0, 'common:head.turn.right.title', 'common:head.turn.right.description'),
    $36ef3dc0587051fc$var$createHeadCommand($36ef3dc0587051fc$export$78319fa5fd133058, 'common:head.lean.back.title', 'common:head.lean.back.description'),
    $36ef3dc0587051fc$var$createHeadCommand($36ef3dc0587051fc$export$18c969b8ac64ef37, 'common:head.lean.forward.title', 'common:head.lean.forward.description'),
    $36ef3dc0587051fc$var$createHeadCommand($36ef3dc0587051fc$export$e20c154cab65adce, 'common:head.lean.left.title', 'common:head.lean.left.description'),
    $36ef3dc0587051fc$var$createHeadCommand($36ef3dc0587051fc$export$520abd32623264d3, 'common:head.lean.right.title', 'common:head.lean.right.description'),
    $36ef3dc0587051fc$var$createHeadCommand($36ef3dc0587051fc$export$9a70b70b3792325c, 'common:head.lean.up.title', 'common:head.lean.up.description'),
    $36ef3dc0587051fc$var$createHeadCommand($36ef3dc0587051fc$export$c9a7f673431c7a0f, 'common:head.lean.down.title', 'common:head.lean.down.description'),
    $36ef3dc0587051fc$var$createHeadCommand($36ef3dc0587051fc$export$6a9d09a2b2e2f93f, 'common:head.lean.center.title', 'common:head.lean.center.description')
];


const $8b57d7f20ec64936$var$createExternalKeyboardCommand = (value, title, translationKey)=>{
    return {
        value: value,
        title: title,
        ...translationKey ? {
            translationKey: translationKey
        } : {},
        isExternalKeyboard: true
    };
};
const $8b57d7f20ec64936$export$2f33dbd1b958ee82 = [
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_backtick', '`'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_1', '1'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_2', '2'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_3', '3'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_4', '4'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_5', '5'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_6', '6'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_7', '7'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_8', '8'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_9', '9'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_0', '0'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_minus', '-'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_equal', '='),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_backspace', 'Backspace', 'common:keys.backspace'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_delete', 'Delete'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_tab', 'Tab'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_q', 'q'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_w', 'w'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_e', 'e'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_r', 'r'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_t', 't'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_y', 'y'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_u', 'u'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_i', 'i'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_o', 'o'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_p', 'p'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_leftbrace', '['),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_rightbrace', ']'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_capslock', 'Caps', 'common:keys.caps'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_a', 'a'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_s', 's'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_d', 'd'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_f', 'f'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_g', 'g'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_h', 'h'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_j', 'j'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_k', 'k'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_l', 'l'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_semicolon', ';'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_singlequote', "'"),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_enter', 'Enter', 'common:keys.enter'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_shift', 'Left Shift', 'common:keys.leftShift'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_z', 'z'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_x', 'x'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_c', 'c'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_v', 'v'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_b', 'b'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_n', 'n'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_m', 'm'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_comma', ','),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_period', '.'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_slash', '/'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_controls', 'Left Ctrl', 'common:keys.leftCtrl'),
    //createExternalKeyboardCommand("fn"),
    //createExternalKeyboardCommand("keyboard_windows", "win"),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_command', 'Command', 'common:keys.command'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_alt', 'Left Alt', 'common:keys.leftAlt'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_space', 'Space Bar', 'common:keys.space'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_left', 'Left Arrow', 'common:keys.left'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_up', 'Up Arrow'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_down', 'Down Arrow'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_right', 'Right Arrow'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_tilde', '~'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_at', '@'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_pound', '#'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_dollar', '$'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_percent', '%'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_caret', '^'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_ampersand', '&'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_asterisk', '*'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_leftparenthesis', '('),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_rightparenthesis', ')'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_underscore', '_'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_plus', '+'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_leftbracket', '{'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_rightbracket', '}'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_backslash', '\\'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_pipe', '|'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_colon', ':'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_quote', '"'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_lessthan', '<'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_greaterthan', '>'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_question', '?'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_escape', 'Escape'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_f1', 'F1'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_f2', 'F2'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_f3', 'F3'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_f4', 'F4'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_f5', 'F5'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_f6', 'F6'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_f7', 'F7'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_f8', 'F8'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_f9', 'F9'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_f10', 'F10'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_f11', 'F11'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_f12', 'F12')
];


const $404e806b46f153e3$export$46f94b06a762d5ba = 'tiltleft';
const $404e806b46f153e3$export$6f9656353bf603ba = 'tiltright';
const $404e806b46f153e3$export$7d85f18c9dd87007 = 'tiltdown';
const $404e806b46f153e3$export$41960994f2211016 = 'tiltup';
const $404e806b46f153e3$export$8f4f878545c604f9 = 'shake';
const $404e806b46f153e3$export$27ae0cf28d39b9f3 = [
    $404e806b46f153e3$export$8f4f878545c604f9,
    $404e806b46f153e3$export$41960994f2211016,
    $404e806b46f153e3$export$7d85f18c9dd87007,
    $404e806b46f153e3$export$6f9656353bf603ba,
    $404e806b46f153e3$export$46f94b06a762d5ba
];
const $404e806b46f153e3$export$26e9961207366bf5 = (command)=>$404e806b46f153e3$export$27ae0cf28d39b9f3.indexOf(command) > -1;
const $404e806b46f153e3$var$createTiltCommand = (value, title, description)=>{
    return {
        value: value,
        title: title,
        description: description
    };
};
const $404e806b46f153e3$export$11fae295fa56fc7a = [
    $404e806b46f153e3$var$createTiltCommand($404e806b46f153e3$export$41960994f2211016, 'common:motion.up.title', 'common:motion.up.description'),
    $404e806b46f153e3$var$createTiltCommand($404e806b46f153e3$export$7d85f18c9dd87007, 'common:motion.down.title', 'common:motion.down.description'),
    $404e806b46f153e3$var$createTiltCommand($404e806b46f153e3$export$46f94b06a762d5ba, 'common:motion.left.title', 'common:motion.left.description'),
    $404e806b46f153e3$var$createTiltCommand($404e806b46f153e3$export$6f9656353bf603ba, 'common:motion.right.title', 'common:motion.right.description'),
    $404e806b46f153e3$var$createTiltCommand($404e806b46f153e3$export$8f4f878545c604f9, 'common:motion.shake.title', 'common:motion.shake.description')
];


const $f44f3a5bc46b1c4c$export$57362fc655624cdd = [
    ...(0, $4c9078e3f4d4e7ac$export$821d2a2d20ce1ccf),
    ...(0, $36ef3dc0587051fc$export$b83c6ea936a344b9)
];
const $f44f3a5bc46b1c4c$export$5c8cf246d7d853ae = (command)=>$f44f3a5bc46b1c4c$export$57362fc655624cdd.indexOf(command) > -1;
const $f44f3a5bc46b1c4c$export$8f4c3955f61548f = (command)=>(0, $404e806b46f153e3$export$27ae0cf28d39b9f3).indexOf(command) > -1;
const $f44f3a5bc46b1c4c$export$3ef50a29b2ee6c06 = (command)=>(0, $4c9078e3f4d4e7ac$export$821d2a2d20ce1ccf).indexOf(command) > -1;
const $f44f3a5bc46b1c4c$export$f5a21b27ff68bc03 = (command)=>(0, $36ef3dc0587051fc$export$b83c6ea936a344b9).indexOf(command) > -1;
const $f44f3a5bc46b1c4c$export$dca0f63ee9e3d900 = (command)=>command?.startsWith('hotkey') == true;
const $f44f3a5bc46b1c4c$export$5417e47c2f21e675 = (command)=>command?.startsWith('mouse_move') == true;
const $f44f3a5bc46b1c4c$export$946f15e1943cbe85 = (command)=>command?.startsWith('joystick_move') == true;
const $f44f3a5bc46b1c4c$export$152edcbfa0aee749 = (command)=>command?.startsWith('keyboard_') == true;
const $f44f3a5bc46b1c4c$export$8c2b4826af6cc511 = 'stop_all_outputs';
const $f44f3a5bc46b1c4c$export$b617c310e3426257 = 'hotkey_';
const $f44f3a5bc46b1c4c$export$2edc7d5e93b11fea = 'mouse_move';
const $f44f3a5bc46b1c4c$export$5c5d516f10138ecd = 'Mouse move';
const $f44f3a5bc46b1c4c$export$e9c0f8ebac1b37df = (command)=>{
    if ($f44f3a5bc46b1c4c$export$3ef50a29b2ee6c06(command)) return 'expression';
    if ($f44f3a5bc46b1c4c$export$f5a21b27ff68bc03(command)) return 'head';
    if ($f44f3a5bc46b1c4c$export$8f4c3955f61548f(command)) return 'tilt';
    if ($f44f3a5bc46b1c4c$export$dca0f63ee9e3d900(command)) return 'hotkey';
    if ($f44f3a5bc46b1c4c$export$152edcbfa0aee749(command)) return 'external_keyboard';
    if (command.includes('_')) return 'other';
    return 'voice';
};
const $f44f3a5bc46b1c4c$export$6c5a93cb3986a928 = [
    'voice',
    'head',
    'expression',
    'hotkey',
    'other'
];
const $f44f3a5bc46b1c4c$export$31469898f99e9a2 = {
    hotkey: {
        title: 'common:hotkey.titlePanel',
        description: 'common:hotkey.description',
        question: 'common:hotkey.question',
        icon: 'virtualButton',
        alt: 'Virtual Buttons'
    },
    //TODO: we need to double check this spoken was used for voice controls in some places but not others
    spoken: {
        title: 'common:talkback.title',
        description: 'common:talkback.description',
        question: 'common:talkback.question',
        icon: 'speaker',
        alt: 'Talkback'
    },
    voice: {
        title: 'common:voice.titlePlural',
        description: 'common:voice.description',
        question: 'common:voice.question',
        icon: 'voiceControl',
        alt: 'Voice Control'
    },
    expression: {
        title: 'common:expression.titlePlural',
        description: 'common:expression.description',
        question: 'common:face.question',
        icon: 'faceExpression',
        alt: 'Facial Expression Control'
    },
    head: {
        title: 'common:head.titlePlural',
        description: 'common:head.description',
        question: 'common:head.question',
        icon: 'headMovement',
        alt: 'Head Movement Control'
    },
    tilt: {
        title: 'common:motion.titlePlural',
        description: 'common:motion.description',
        question: 'common:motion.question',
        icon: 'motionControl',
        alt: 'Motion Control'
    },
    //TODO: We need to double check this - I believe this is Remap Keyboard and not Virtual Buttons (hotkeys)
    external_keyboard: {
        title: 'common:keys.titlePlural',
        description: 'common:keys.description',
        question: 'common:keys.question',
        icon: 'virtualButton',
        alt: 'Keys & Buttons'
    },
    //TODO: We need to double check this - I believe this is a dupe of Tilt
    motion: {
        title: 'common:motion.titlePlural',
        description: 'common:motion.description',
        question: 'common:motion.question',
        icon: 'motionControl',
        alt: 'Motion Control'
    },
    dictation: {
        title: 'common:dictation.title',
        description: 'common:dictation.description',
        question: 'common:dictation.question',
        icon: 'dictationPlay',
        alt: 'Dictation Control'
    },
    //TODO: Practically speaking, this is the same as voice but it is treated distinctly elsewhere. We might need to change how we assign voice and other -- e.g. check for underscore and not associated with other commandtypes
    other: {
        title: 'common:other.title',
        description: 'common:other.description',
        question: 'common:other.question',
        icon: 'voiceControl',
        alt: 'Other Control'
    },
    smartTasks: {
        title: 'common:smartTasks.title',
        description: 'common:smartTasks.description',
        question: 'common:smartTasks.title',
        icon: 'ai',
        alt: 'Smart Tasks Control'
    }
};
const $f44f3a5bc46b1c4c$export$6ed006bdf26d1b97 = (0, $404e806b46f153e3$export$11fae295fa56fc7a);
const $f44f3a5bc46b1c4c$export$f1577663de47cd5e = [
    ...(0, $36ef3dc0587051fc$export$d58460d69cd22e7b),
    ...(0, $4c9078e3f4d4e7ac$export$66556ffb0952dbd1)
];
const $f44f3a5bc46b1c4c$export$71d467a5c4a5cf9f = (0, $8b57d7f20ec64936$export$2f33dbd1b958ee82);
const $f44f3a5bc46b1c4c$export$b47f0ea920cae9ed = (0, $36ef3dc0587051fc$export$d58460d69cd22e7b);
const $f44f3a5bc46b1c4c$export$c64c937c3a3522ea = (0, $4c9078e3f4d4e7ac$export$66556ffb0952dbd1);
const $f44f3a5bc46b1c4c$export$48c02457e332140e = [
    ...$f44f3a5bc46b1c4c$export$6ed006bdf26d1b97,
    ...$f44f3a5bc46b1c4c$export$f1577663de47cd5e,
    ...$f44f3a5bc46b1c4c$export$71d467a5c4a5cf9f
];
const $f44f3a5bc46b1c4c$export$72d891864ef26d3d = (command)=>{
    if (!command) return null;
    if (command.startsWith('mouse_move')) return 'mouse';
    if ($f44f3a5bc46b1c4c$export$c64c937c3a3522ea.find((c)=>c.value == command)) return 'faceExpression';
    if ($f44f3a5bc46b1c4c$export$b47f0ea920cae9ed.find((c)=>c.value == command)) return 'headMovement';
    if ($f44f3a5bc46b1c4c$export$6ed006bdf26d1b97.find((c)=>c.value == command)) return 'motionControl';
    if ($f44f3a5bc46b1c4c$export$71d467a5c4a5cf9f.find((c)=>c.value == command)) return 'keyboard';
    if (command.startsWith($f44f3a5bc46b1c4c$export$b617c310e3426257)) return 'virtualButton';
    return 'voiceControl';
};


const $28343ab509e453ee$export$513d3938ac2af8f0 = (profile)=>{
    if (!profile) return false;
    return profile.requiresGenericLicense || profile.requiresEmployeeAccess || profile.requiresStudentAccess || profile.requiresPlusAccess;
};
const $28343ab509e453ee$export$6ff753f9d38ae18d = (profile, licenseAccess)=>{
    if (!$28343ab509e453ee$export$513d3938ac2af8f0(profile)) return true;
    if (!licenseAccess || licenseAccess.type === 'personal') return false;
    if (!licenseAccess.access.isEmployeeAccess && profile.requiresEmployeeAccess) return false;
    if (!licenseAccess.access.isStudentAccess && profile.requiresStudentAccess) return false;
    if (!licenseAccess.access.isPlusAccess && profile.requiresPlusAccess) return false;
    // profile has generic license or specific profile license
    return true;
};


const $4a3c7ab711a29dd4$export$959de94a57794f15 = 'USER';
const $4a3c7ab711a29dd4$export$d7b509e53699b6f9 = 'USER_ACCESS';
const $4a3c7ab711a29dd4$export$a1ad07ee66337027 = 'DEVICE_CURRENT_PROFILE';
const $4a3c7ab711a29dd4$export$e51ceeb4d2d72ad4 = 'appSettings';
const $4a3c7ab711a29dd4$export$7e1b78538df536d8 = 'DEVICES';
const $4a3c7ab711a29dd4$export$e0520dc8c020e730 = 'VIRTUAL_DEVICE';
const $4a3c7ab711a29dd4$export$c66d0139ef02a287 = 'VIRTUAL_DEVICE_ID';
const $4a3c7ab711a29dd4$export$e79477942e3c1f1 = 'VIRTUAL_DEVICE_TOKEN';
const $4a3c7ab711a29dd4$export$ee420f2304181127 = 'cephable_upgrade_modal_dismissed';
const $4a3c7ab711a29dd4$export$59915694013eef2b = 14;
const $4a3c7ab711a29dd4$export$59dcb33d1d7504ec = 'AUTOMATION_RULES';
const $4a3c7ab711a29dd4$export$6c5171fd90ae3d4f = 'ai_workflows_intro_choice';
const $4a3c7ab711a29dd4$export$6f3b2eeee43c7273 = 'inference_model_download_prompted';





var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");



/**
 * Container managing the device based on routing of /deviceId
 * In the panel window, CurrentDeviceContainer.id is the same as deviceContainer.outputDeviceId because panel is always showing the current device
 */ function $43d630686eddb628$var$useCurrentDeviceContainer() {
    const userLicenseAccessRef = (0, $7fPBF.useRef)(undefined);
    const [device, setDevice, deviceRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(undefined);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [previousProfileId, setPreviousProfileId] = (0, $7fPBF.useState)(null);
    const [errors, setErrors] = (0, $7fPBF.useState)([]);
    const [id, setId, idRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(undefined);
    const [currentProfile, setCurrentProfile, currentProfileRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(null);
    const loadInstalledAppNamesRef = (0, $7fPBF.useRef)(()=>{});
    const [installedAppNames, setInstalledAppNames] = (0, $7fPBF.useState)([]);
    const [tryCommandHandlers, setTryCommandHandlers] = (0, $7fPBF.useState)([]);
    const appTrackPrevious = (0, $7fPBF.useRef)('Cephable');
    const appTrackingCurrentReal = (0, $7fPBF.useRef)('Cephable');
    const [appTrackingCurrent, setAppTrackingCurrent, appTrackingCurrentRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)('Cephable');
    const [phiNativeResult, setPhiNativeResult, phiNativeResultRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)('');
    const [phiNativeStatus, setPhiNativeStatus, phiNativeStatusRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)('');
    const deviceTypeIdRef = (0, $7fPBF.useRef)(undefined);
    const updatePhiResult = (token)=>{
        setPhiNativeResult(phiNativeResultRef.current + token);
    };
    const resetPhiResult = ()=>{
        setPhiNativeResult('');
    };
    const addTryCommandHandler = (handler)=>{
        setTryCommandHandlers([
            ...tryCommandHandlers,
            handler
        ]);
    };
    const updateLocalState = (device, newProfile)=>{
        setDevice(device);
        if (idRef.current !== device?.id) {
            setId(device?.id);
            deviceTypeIdRef.current = device?.device?.deviceType.id;
        }
        const existingProfileStr = JSON.stringify(currentProfileRef.current);
        const newProfileStr = JSON.stringify(newProfile);
        let updatedProfile = currentProfileRef.current;
        if (existingProfileStr !== newProfileStr) {
            // license check
            if (newProfile && (0, $28343ab509e453ee$export$6ff753f9d38ae18d)(newProfile, userLicenseAccessRef.current)) updatedProfile = newProfile;
            else updatedProfile = null;
            // update current profile
            setCurrentProfile(updatedProfile);
            snapshotState(updatedProfile);
        }
        (0, $e7df95de73caec26$export$89b472e03be495df)('currentDeviceUpdated', {
            device: device,
            profile: updatedProfile
        });
        return true;
    };
    const snapshotState = (profile)=>{
        localStorage.setItem((0, $4a3c7ab711a29dd4$export$a1ad07ee66337027), JSON.stringify(profile));
    };
    const updateDeviceState = (device, newProfile)=>{
        // updating because device has updated
        let isDeviceEqual = false;
        if (device && deviceRef.current) {
            // sparse property check for current device
            const isIdEqual = device.id === deviceRef.current.id;
            const isModifiedDateEqual = device.modifiedDate === deviceRef.current.modifiedDate;
            isDeviceEqual = isIdEqual && isModifiedDateEqual;
        }
        const isProfileEqual = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).isEqual(newProfile, currentProfileRef.current);
        if (isDeviceEqual && isProfileEqual) // no changes
        return false;
        return updateLocalState(device, newProfile);
    };
    const loadInstalledAppNames = ()=>{
        loadInstalledAppNamesRef.current();
    };
    const setLoadInstalledAppNamesRef = (handler)=>{
        loadInstalledAppNamesRef.current = handler;
    };
    const tryDeviceCommand = async (command, additionalInputContent)=>{
        if (currentProfileRef.current && idRef.current && deviceRef.current) for (let handler of tryCommandHandlers){
            if (handler(command, currentProfileRef.current)) return true;
        }
        return false;
    };
    const stopAllOutputs = async ()=>{
        return await tryDeviceCommand((0, $f44f3a5bc46b1c4c$export$8c2b4826af6cc511));
    };
    const resetCurrentProfile = async ()=>{
        if (!idRef.current || !deviceRef.current) return new (0, $6340c001daecf2cb$export$2e2bcd8739ae039)('Device ID is not set');
        const currentDeviceProfile = currentProfileRef.current;
        let result;
        // reset current profile to null
        if (currentDeviceProfile?.isPublic) result = await $1a4c36336f303477$export$c35b3a8741882c0(idRef.current, {
            defaultProfileId: null
        });
        else result = await $1a4c36336f303477$export$c35b3a8741882c0(idRef.current, {
            customProfileId: null
        });
        if (result.resultType === 'Ok' && result.data) updateLocalState(result.data, null);
        else if (result.resultType !== 'Ok') {
            // offline reset
            const updatedDeviceState = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).cloneDeep(deviceRef.current);
            if (currentDeviceProfile?.isPublic) updatedDeviceState.defaultProfileId = null;
            else updatedDeviceState.currentProfile = null;
            updateLocalState(updatedDeviceState, null);
            result = new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)(updatedDeviceState);
        }
        return result;
    };
    (0, $7fPBF.useEffect)(()=>{
        const unsubscribeUserLicenseChange = (0, $e7df95de73caec26$export$ec068583843480e7)('userLicenseChangeLocal', async (data)=>{
            if (data) {
                userLicenseAccessRef.current = data;
                if (data.type === 'personal' && (0, $28343ab509e453ee$export$513d3938ac2af8f0)(currentProfileRef.current)) // profile requires license and user has expired license
                await resetCurrentProfile();
            }
        });
        const unsubscribeProfileDeleted = (0, $e7df95de73caec26$export$ec068583843480e7)('profileDeleted', async (data)=>{
            if (data && data.profile?.id === currentProfileRef.current?.id) // profile deleted
            await resetCurrentProfile();
        });
        return ()=>{
            unsubscribeUserLicenseChange();
            unsubscribeProfileDeleted();
            clearAll();
        };
    }, []);
    const clearListeners = ()=>{
        setTryCommandHandlers([]);
    };
    const clearAll = ()=>{
        setDevice(undefined);
        setCurrentProfile(null);
        setPreviousProfileId(null);
        setErrors([]);
        setId(undefined);
        setIsLoading(false);
        setInstalledAppNames([]);
        clearListeners();
        localStorage.removeItem((0, $4a3c7ab711a29dd4$export$a1ad07ee66337027));
    };
    return {
        phiNativeResult: phiNativeResult,
        setPhiNativeResult: setPhiNativeResult,
        phiNativeResultRef: phiNativeResultRef,
        phiNativeStatus: phiNativeStatus,
        setPhiNativeStatus: setPhiNativeStatus,
        phiNativeStatusRef: phiNativeStatusRef,
        updatePhiResult: updatePhiResult,
        resetPhiResult: resetPhiResult,
        idRef: idRef,
        id: id,
        isLoading: isLoading,
        previousProfileId: previousProfileId,
        setPreviousProfileId: setPreviousProfileId,
        errors: errors,
        userLicenseAccessRef: userLicenseAccessRef,
        updateDeviceState: updateDeviceState,
        currentProfile: currentProfile,
        currentProfileRef: currentProfileRef,
        appTrackPrevious: appTrackPrevious,
        appTrackingCurrentReal: appTrackingCurrentReal,
        appTrackingCurrent: appTrackingCurrent,
        setAppTrackingCurrent: setAppTrackingCurrent,
        appTrackingCurrentRef: appTrackingCurrentRef,
        device: device,
        deviceRef: deviceRef,
        deviceTypeIdRef: deviceTypeIdRef,
        setLoadInstalledAppNamesRef: setLoadInstalledAppNamesRef,
        loadInstalledAppNames: loadInstalledAppNames,
        installedAppNames: installedAppNames,
        setInstalledAppNames: setInstalledAppNames,
        addTryCommandHandler: addTryCommandHandler,
        tryDeviceCommand: tryDeviceCommand,
        stopAllOutputs: stopAllOutputs,
        clearListeners: clearListeners,
        clearAll: clearAll,
        setIsLoading: setIsLoading
    };
}
const $43d630686eddb628$var$CurrentDeviceContainer = (0, $78783f85c4167892$export$26ae5ca175b4ec5a)($43d630686eddb628$var$useCurrentDeviceContainer);
var $43d630686eddb628$export$2e2bcd8739ae039 = $43d630686eddb628$var$CurrentDeviceContainer;



const $eec5c3b697f8e81e$export$19e7a64c17ac6a78 = 'enableHeadMouseMode';
const $eec5c3b697f8e81e$export$cc151e4b60d415ed = 'enableCephablePanel';
const $eec5c3b697f8e81e$export$47004e5aac15b5cd = 'enableAutomaticProfileSwitching';
const $eec5c3b697f8e81e$export$ff16be44cd4b36c3 = 'enableTextGeneration';
const $eec5c3b697f8e81e$export$e76346433d751760 = 'enableWizard';
const $eec5c3b697f8e81e$export$489136a71f0926f1 = 'EnableAiCommands';
const $eec5c3b697f8e81e$export$c51d6dbcab7ae7e0 = 'enableAiDictation';
const $eec5c3b697f8e81e$export$57439186bae3e5ef = 'enableTranscribeTask';
const $eec5c3b697f8e81e$export$a82e5a6dbb0cf7ef = 'enableClickByName';
const $eec5c3b697f8e81e$export$16bd572ace4b0246 = 'enableGamepadSupport';
const $eec5c3b697f8e81e$export$cbbbf2d12e5a7bce = 'enableMetrics';
const $eec5c3b697f8e81e$export$68822a6b235e54e4 = 'enableAiWorkflows';
const $eec5c3b697f8e81e$export$9338f61da19c4759 = {
    personal: [
        $eec5c3b697f8e81e$export$16bd572ace4b0246
    ],
    isPlusAccess: [
        $eec5c3b697f8e81e$export$a82e5a6dbb0cf7ef,
        $eec5c3b697f8e81e$export$57439186bae3e5ef,
        $eec5c3b697f8e81e$export$16bd572ace4b0246
    ],
    isEmployeeAccess: [
        $eec5c3b697f8e81e$export$57439186bae3e5ef,
        $eec5c3b697f8e81e$export$cbbbf2d12e5a7bce,
        $eec5c3b697f8e81e$export$a82e5a6dbb0cf7ef
    ],
    isStudentAccess: [
        $eec5c3b697f8e81e$export$cbbbf2d12e5a7bce,
        $eec5c3b697f8e81e$export$a82e5a6dbb0cf7ef
    ],
    isDeveloperAccess: [
        $eec5c3b697f8e81e$export$cbbbf2d12e5a7bce,
        $eec5c3b697f8e81e$export$a82e5a6dbb0cf7ef
    ]
};
const $eec5c3b697f8e81e$export$97f1def75ed4b43c = [
    ...new Set(Object.values($eec5c3b697f8e81e$export$9338f61da19c4759).flat())
]; // All unique beta feature flags for all license types
const $eec5c3b697f8e81e$export$89398edf022c69af = [
    $eec5c3b697f8e81e$export$47004e5aac15b5cd,
    $eec5c3b697f8e81e$export$cc151e4b60d415ed,
    $eec5c3b697f8e81e$export$19e7a64c17ac6a78
];
const $eec5c3b697f8e81e$export$9e1a6fca7c3450cd = [
    'isPlusAccess',
    'isEmployeeAccess',
    'isDeveloperAccess',
    'isStudentAccess'
];
const $eec5c3b697f8e81e$var$licenseTypesInHighestPriorityOrder = [
    'isEmployeeAccess',
    'isDeveloperAccess',
    'isStudentAccess',
    'isPlusAccess',
    'personal'
];
const $eec5c3b697f8e81e$export$edc04589e178d7ee = {
    isEmployeeAccess: [
        $eec5c3b697f8e81e$export$ff16be44cd4b36c3,
        $eec5c3b697f8e81e$export$e76346433d751760,
        $eec5c3b697f8e81e$export$489136a71f0926f1,
        $eec5c3b697f8e81e$export$c51d6dbcab7ae7e0,
        $eec5c3b697f8e81e$export$68822a6b235e54e4
    ],
    isDeveloperAccess: [
        $eec5c3b697f8e81e$export$e76346433d751760,
        $eec5c3b697f8e81e$export$489136a71f0926f1,
        $eec5c3b697f8e81e$export$c51d6dbcab7ae7e0
    ],
    isStudentAccess: [
        $eec5c3b697f8e81e$export$e76346433d751760,
        $eec5c3b697f8e81e$export$489136a71f0926f1,
        $eec5c3b697f8e81e$export$c51d6dbcab7ae7e0
    ],
    isPlusAccess: [
        $eec5c3b697f8e81e$export$ff16be44cd4b36c3,
        $eec5c3b697f8e81e$export$e76346433d751760,
        $eec5c3b697f8e81e$export$489136a71f0926f1,
        $eec5c3b697f8e81e$export$c51d6dbcab7ae7e0
    ]
};
const $eec5c3b697f8e81e$export$a231937237d0f395 = (flag)=>{
    if ($eec5c3b697f8e81e$export$89398edf022c69af.includes(flag)) return 'personal';
    for (const licenseType of $eec5c3b697f8e81e$export$9e1a6fca7c3450cd){
        const flags = $eec5c3b697f8e81e$export$edc04589e178d7ee[licenseType];
        if (flags && flags.includes(flag)) return licenseType;
    }
    for (const licenseType of Object.keys($eec5c3b697f8e81e$export$9338f61da19c4759)){
        const flags = $eec5c3b697f8e81e$export$9338f61da19c4759[licenseType];
        if (flags && flags.includes(flag)) return licenseType;
    }
    return;
};
const $eec5c3b697f8e81e$export$aca9a606a8b2695d = (flags)=>{
    if (!flags || flags.length === 0) return;
    const licenseTypesFound = new Set();
    for (const flag of flags){
        const licenseType = $eec5c3b697f8e81e$export$a231937237d0f395(flag);
        if (licenseType) licenseTypesFound.add(licenseType);
    }
    if (licenseTypesFound.size === 0) return; // No valid license types found
    for (const licenseType of $eec5c3b697f8e81e$var$licenseTypesInHighestPriorityOrder){
        if (licenseTypesFound.has(licenseType)) return licenseType;
    }
    return;
};





function $eeb1a4bb5a11a603$export$894a92ec5bebf83(locale) {
    return (0, $3ecd3f7dea3d56de$export$df1c34db1371eeed).voice.includes(locale);
}
function $eeb1a4bb5a11a603$export$5aa7fdaae13057ac(locale) {
    if ($eeb1a4bb5a11a603$export$894a92ec5bebf83(locale)) return `common:localization.locales.${locale}`;
    return 'common:localization.unsupported.title';
}
const $eeb1a4bb5a11a603$export$d44f5da3b0eb939f = (locale)=>{
    return locale.toLowerCase().split('-')[0];
};
const $eeb1a4bb5a11a603$export$e88b669f03544b69 = (locale, variant)=>{
    let result = null;
    if (locale) {
        const localeOptions = (0, $3ecd3f7dea3d56de$export$df1c34db1371eeed)[variant];
        const localeLower = locale.toLowerCase();
        const languageOnly = $eeb1a4bb5a11a603$export$d44f5da3b0eb939f(locale);
        if (localeOptions.includes(localeLower)) result = localeLower;
        else if (localeOptions.includes(languageOnly)) result = languageOnly;
        else if (localeLower.startsWith('en') && variant == 'voice') result = 'en-us'; // exception for English Voice because the base is en-us
    }
    return result;
};
const $eeb1a4bb5a11a603$export$635ddbacad8e65bf = (locale)=>{
    const language = $eeb1a4bb5a11a603$export$e88b669f03544b69(locale, 'voice');
    let result = (0, $3ecd3f7dea3d56de$export$e471f5ee496a5676)['en-us'];
    if (language) result = (0, $3ecd3f7dea3d56de$export$e471f5ee496a5676)[language];
    return result;
};




var $7fPBF = parcelRequire("7fPBF");




var $cfd4b075d263c876$exports = {};
$cfd4b075d263c876$exports = $parcel$resolve("dHypX");


// todo : vosk language preferences, defaults, and selection
function $8a1185b15e8317ab$var$useCurrentUserContainer() {
    const { i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [isLoadingFacets, setIsLoadingFacets] = (0, $7fPBF.useState)(false);
    const [errors, setErrors] = (0, $7fPBF.useState)([]);
    const [currentUser, setCurrentUser, currentUserRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(null);
    const [capabilityFacetGroups, setCapabilityFacetGroups] = (0, $7fPBF.useState)([]);
    const [userLicenseAccess, setUserLicenseAccess, userLicenseAccessRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(null);
    const [signalRConnected, setSignalRConnected] = (0, $7fPBF.useState)(true);
    const [userLocalePreferences, setUserLocalePreferences, userLocalePreferencesRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)({
        defaultLocale: (0, $3ecd3f7dea3d56de$export$c89f3ba9a8ee8018),
        defaultVoiceLocale: (0, $3ecd3f7dea3d56de$export$f44b61b0f29ec)
    });
    const [showUserFallbackDialog, setShowUserFallbackDialog] = (0, $7fPBF.useState)(false);
    const [voiceModelUrl, setVoiceModelUrl, voiceModelUrlRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)($cfd4b075d263c876$exports);
    const [isApprovedDomain, setIsApprovedDomain, isApprovedDomainRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(false);
    const [upgradeBannerMap, setUpgradeBannerMap] = (0, $7fPBF.useState)(new Map());
    const upgradeBannersArray = Array.from(upgradeBannerMap.values());
    const [isEmailVerified, setIsEmailVerified, isEmailVerifiedRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(false);
    const [pendingTosConfig, setPendingTosConfig] = (0, $7fPBF.useState)(null);
    const initializeFromStorage = async (isMainWindow = true)=>{
        try {
            console.log('INITIALIZING USER FROM STORAGE');
            const currentUser = localStorage.getItem((0, $4a3c7ab711a29dd4$export$959de94a57794f15));
            if (currentUser) {
                const currentUserModel = JSON.parse(currentUser);
                setCurrentUser(currentUserModel);
                await updateUserLocales({
                    defaultLocale: currentUserModel.defaultLocale,
                    defaultVoiceLocale: currentUserModel.defaultVoiceLocale
                }, isMainWindow);
                const userPermission = currentUserModel.isApprovedDomain ?? false;
                setIsApprovedDomain(userPermission);
                setIsEmailVerified(currentUserModel.isEmailVerified ?? false);
                (0, $e7df95de73caec26$export$89b472e03be495df)('userUpdated', {
                    user: currentUserModel
                });
            }
            loadUserLicenseAccessFromStorage();
        } catch (e) {
            console.log(e);
        }
    };
    const deleteCurrentUser = async ()=>{
        try {
            setIsLoading(true);
            const result = await $1a4c36336f303477$export$423f8e8c6cce5fd3();
            if (result?.resultType === 'Ok') {
                localStorage.removeItem((0, $4a3c7ab711a29dd4$export$959de94a57794f15));
                setCurrentUser(null);
            }
            setIsLoading(false);
            return result;
        } catch (e) {
            console.log(e);
            setIsLoading(false);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const loadCurrentUser = async ()=>{
        try {
            setIsLoading(true);
            // verify user permissions
            const userAuthPermissions = await $1a4c36336f303477$export$5a6314a822d8df05();
            let userPermission = false;
            if (userAuthPermissions.resultType !== 'Ok' && userAuthPermissions?.errors != null && userAuthPermissions.errors.length > 0) setErrors([
                ...userAuthPermissions.errors
            ]);
            else if (userAuthPermissions?.resultType == 'Ok') userPermission = true;
            setIsApprovedDomain(userPermission);
            const result = await $1a4c36336f303477$export$d12f355dc16ebf93();
            if (result?.resultType == 'Ok' && result.data) {
                handleUpdateUser(result.data);
                await updateUserLocales({
                    defaultLocale: result.data.defaultLocale,
                    defaultVoiceLocale: result.data.defaultVoiceLocale
                });
            } else if (result?.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            setIsLoading(false);
            return result;
        } catch (e) {
            setIsLoading(false);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const updatePassword = async (oldPassword, newPassword, confirmNewPassword)=>{
        try {
            setIsLoading(true);
            const result = await $1a4c36336f303477$export$99d837dc30eb1ef7({
                oldPassword: oldPassword,
                newPassword: newPassword,
                newPasswordConfirmation: confirmNewPassword
            });
            setIsLoading(false);
            return result;
        } catch (e) {
            setIsLoading(false);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const loadCapabilityFacetGroups = async ()=>{
        try {
            setIsLoadingFacets(true);
            const result = await $1a4c36336f303477$export$8cf7ec95b3fb64ef();
            if (result?.resultType == 'Ok' && result.data) setCapabilityFacetGroups(result.data);
            setIsLoadingFacets(false);
            return result;
        } catch (e) {
            setIsLoadingFacets(false);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const updateUserCapabilities = async (request)=>{
        try {
            setIsLoading(true);
            const result = await $1a4c36336f303477$export$78668e730a02e76(request);
            if (result?.resultType == 'Ok' && result.data) handleUpdateUser(result.data);
            setIsLoading(false);
            return result;
        } catch (e) {
            setIsLoading(false);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const updateEmailPreferences = async (request)=>{
        try {
            setIsLoading(true);
            const result = await $1a4c36336f303477$export$7320d6eeb2c8ac54(request);
            if (result?.resultType == 'Ok') {
                const updatedUser = {
                    ...currentUser,
                    ...result.data
                };
                handleUpdateUser(updatedUser);
            }
            setIsLoading(false);
            return result;
        } catch (e) {
            setIsLoading(false);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const updateUserPreferences = async (request)=>{
        try {
            setIsLoading(true);
            const result = await $1a4c36336f303477$export$2a6c232d8be225a8(request);
            if (result?.resultType == 'Ok') {
                const updatedUser = {
                    ...currentUser,
                    ...result.data
                }; // spread both so we don't lose capability settings and other data
                handleUpdateUser(updatedUser);
            } else if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([
                ...error
            ]);
            setIsLoading(false);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const getUserPreferences = async ()=>{
        try {
            setIsLoading(true);
            const result = await $1a4c36336f303477$export$ae3f5fa351e2f57a();
            if (result?.resultType == 'Ok') {
                setIsLoading(false);
                return result;
            } else if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
        } catch (error) {
            setErrors([
                ...error
            ]);
            setIsLoading(false);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const requestEmailVerificationResend = async ()=>{
        try {
            const result = await $1a4c36336f303477$export$4cedc5ba9e15b997();
            if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            return result;
        } catch (error) {
            setErrors([
                ...error
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const clearCurrentUser = ()=>{
        setCurrentUser(null);
    };
    const updateUserLocales = async (request, isMainWindow = true)=>{
        const localePreferences = getValidatedUserLocales(request);
        changeAppLanguage(localePreferences.defaultLocale);
        const modelUrl = await loadVoiceModelUrl(localePreferences.defaultVoiceLocale, isMainWindow, localePreferences.voiceModelUrl);
        const hasChanges = localePreferences.defaultLocale !== userLocalePreferences.defaultLocale || localePreferences.defaultVoiceLocale !== userLocalePreferences.defaultVoiceLocale;
        if (hasChanges) {
            setUserLocalePreferences({
                ...localePreferences,
                voiceModelUrl: modelUrl
            });
            (0, $e7df95de73caec26$export$89b472e03be495df)('userLocalePreferencesUpdated', {
                localePreferences: localePreferences
            });
        }
    };
    // gets client supported locale preferences
    const getValidatedUserLocales = (localePreferences)=>{
        const defaultLocale = (0, $eeb1a4bb5a11a603$export$e88b669f03544b69)(localePreferences.defaultLocale, 'display') ?? (0, $3ecd3f7dea3d56de$export$c89f3ba9a8ee8018);
        const defaultVoiceLocale = (0, $eeb1a4bb5a11a603$export$e88b669f03544b69)(localePreferences.defaultVoiceLocale, 'voice') ?? (0, $3ecd3f7dea3d56de$export$f44b61b0f29ec);
        return {
            defaultLocale: defaultLocale,
            defaultVoiceLocale: defaultVoiceLocale
        };
    };
    const changeAppLanguage = (displayLocale)=>{
        if (i18n.language !== displayLocale) i18n.changeLanguage(displayLocale, (error)=>{
            if (error) console.error(`Unsupported language ${displayLocale}. Defaulting to ${(0, $3ecd3f7dea3d56de$export$c89f3ba9a8ee8018)}`);
            else localStorage.setItem('displayLocale', displayLocale);
        });
    };
    // update database values
    const saveUserLocales = async (request)=>{
        try {
            setIsLoading(true);
            const result = await $1a4c36336f303477$export$ca144d7073999c98(request);
            if (result?.resultType == 'Ok' && result.data) {
                await updateUserLocales(request);
                const updatedUser = {
                    ...currentUser,
                    ...result.data
                };
                handleUpdateUser(updatedUser);
            } else if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([
                ...error
            ]);
            setIsLoading(false);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const handleUpdateUser = (user)=>{
        user.isApprovedDomain = isApprovedDomainRef.current;
        setCurrentUser(user);
        localStorage.setItem((0, $4a3c7ab711a29dd4$export$959de94a57794f15), JSON.stringify(user));
        if (user.isEmailVerified !== isEmailVerifiedRef.current) setIsEmailVerified(user.isEmailVerified);
        (0, $e7df95de73caec26$export$89b472e03be495df)('userUpdated', {
            user: user
        });
    };
    const loadVoiceModelUrl = async (voiceLocale, isMainWindow, requestUrl)=>{
        let modelUrl = requestUrl ?? localStorage.getItem('VOICE_MODEL_URL') ?? $cfd4b075d263c876$exports;
        try {
            setIsLoading(true);
            if (isMainWindow) {
                const result = await $1a4c36336f303477$export$78ac26d691c779f4(voiceLocale, 'tar.gz');
                if (result.resultType === 'Ok' && result.data) modelUrl = result.data.fileUrl;
            }
        } catch (error) {
            setErrors([
                `Error loading voice model. ${error}`
            ]);
        } finally{
            updateVoiceModelUrl(modelUrl);
            informUserOfFallbackModel(modelUrl, voiceLocale);
            setIsLoading(false);
        }
        return modelUrl;
    };
    const updateVoiceModelUrl = (modelUrl)=>{
        if (modelUrl !== voiceModelUrlRef.current) {
            localStorage.setItem('VOICE_MODEL_URL', modelUrl);
            setVoiceModelUrl(modelUrl);
        }
    };
    const informUserOfFallbackModel = (modelUrl, voiceLocale)=>{
        if (voiceLocale !== (0, $3ecd3f7dea3d56de$export$f44b61b0f29ec) && modelUrl === $cfd4b075d263c876$exports) setShowUserFallbackDialog(true);
    };
    const updateUserLicenseAccess = async (access, updateLocal)=>{
        const currentAccess = userLicenseAccessRef.current;
        const hasChanged = !currentAccess || JSON.stringify(currentAccess) !== JSON.stringify(access);
        if (!hasChanged) return;
        setUserLicenseAccess(access);
        const type = getUserLicenseAccess(access);
        if (updateLocal) localStorage.setItem((0, $4a3c7ab711a29dd4$export$d7b509e53699b6f9), JSON.stringify({
            access: access,
            type: type
        }));
        (0, $e7df95de73caec26$export$89b472e03be495df)('userLicenseChangeLocal', {
            access: access,
            type: type
        });
    };
    const loadUserLicenseAccess = async ()=>{
        try {
            const result = await $1a4c36336f303477$export$2892959f926e8bd6();
            if (result?.resultType == 'Ok' && result.data) updateUserLicenseAccess(result.data, true);
            else if (result.errors != null && result.errors.length > 0) {
                setErrors([
                    ...result.errors
                ]);
                loadUserLicenseAccessFromStorage();
            }
        } catch (error) {
            setErrors([
                error
            ]);
            loadUserLicenseAccessFromStorage();
        }
    };
    const loadUserLicenseAccessFromStorage = ()=>{
        const userAccess = localStorage.getItem((0, $4a3c7ab711a29dd4$export$d7b509e53699b6f9));
        if (userAccess) {
            const { access: access, type: type } = JSON.parse(userAccess);
            updateUserLicenseAccess(access, false);
            return {
                access: access,
                type: type
            };
        }
    };
    const isFreeUser = ()=>{
        return !(userLicenseAccessRef.current?.isDeveloperAccess || userLicenseAccessRef.current?.isEmployeeAccess || userLicenseAccessRef.current?.isStudentAccess || userLicenseAccessRef.current?.isPlusAccess);
    };
    const isProUser = ()=>{
        return userLicenseAccessRef.current?.isEmployeeAccess;
    };
    const isEduUser = ()=>{
        return userLicenseAccessRef.current?.isStudentAccess;
    };
    const isSdkUser = ()=>{
        return userLicenseAccessRef.current?.isDeveloperAccess;
    };
    const isPlusUser = ()=>{
        return userLicenseAccessRef.current?.isPlusAccess;
    };
    const isTrialUser = ()=>{
        return userLicenseAccessRef.current?.licenseExpirationDate !== undefined && userLicenseAccessRef.current.hasLicense === false && userLicenseAccessRef.current?.licenseExpirationDate && new Date(userLicenseAccessRef.current.licenseExpirationDate) > new Date();
    };
    const getUserLicenseAccess = (access)=>{
        if (access.isEmployeeAccess) return 'isEmployeeAccess';
        if (access.isStudentAccess) return 'isStudentAccess';
        if (access.isDeveloperAccess) return 'isDeveloperAccess';
        if (access.isPlusAccess) return 'isPlusAccess';
        return 'personal';
    };
    const userLicenseType = (0, $7fPBF.useMemo)(()=>{
        if (isProUser()) return 'isEmployeeAccess';
        if (isEduUser()) return 'isStudentAccess';
        if (isSdkUser()) return 'isDeveloperAccess';
        if (isPlusUser()) return 'isPlusAccess';
        return 'personal';
    }, [
        isApprovedDomain,
        userLicenseAccess
    ]);
    const getUserFeatureFlags = ()=>{
        // todo: enforce type safety
        const userFlags = [];
        userFlags.push(...(0, $eec5c3b697f8e81e$export$89398edf022c69af));
        // Collect license enabled feature flags for every license the user has access to
        if (userLicenseAccessRef.current) {
            for (const licenseKey of Object.keys((0, $eec5c3b697f8e81e$export$edc04589e178d7ee)))if (userLicenseAccessRef.current[licenseKey]) userFlags.push(...(0, $eec5c3b697f8e81e$export$edc04589e178d7ee)[licenseKey]);
        }
        // Add beta feature flags that the user has access to
        if (currentUserRef.current?.userPreferences?.featureFlags) {
            for (const flag of currentUserRef.current.userPreferences.featureFlags)if ((0, $eec5c3b697f8e81e$export$97f1def75ed4b43c).includes(flag)) userFlags.push(flag);
        }
        return [
            ...new Set(userFlags)
        ]; // return unique flags
    };
    const isUserLicensedForAllFeatureFlags = (flagNames)=>{
        if (!userLicenseAccessRef.current) return false;
        return flagNames.every((flag)=>isFeatureFlagEnabled(flag));
    };
    const isFeatureFlagEnabled = (flagName)=>{
        // all personal flags are enabled
        const freeFlags = (0, $eec5c3b697f8e81e$export$89398edf022c69af).includes(flagName);
        if (freeFlags) return true;
        // check if user has access to the flag
        if (userLicenseAccessRef.current) for (const licenseKey of Object.keys((0, $eec5c3b697f8e81e$export$edc04589e178d7ee))){
            if (userLicenseAccessRef.current[licenseKey] && (0, $eec5c3b697f8e81e$export$edc04589e178d7ee)[licenseKey].includes(flagName)) return true;
        }
        // check if user has beta access
        const betaFlags = (0, $eec5c3b697f8e81e$export$97f1def75ed4b43c).includes(flagName);
        if (!betaFlags) return false;
        return currentUserRef.current?.userPreferences?.featureFlags?.includes(flagName) ?? false;
    };
    const userBetaFeatureFlags = (0, $7fPBF.useMemo)(()=>{
        const result = [
            ...(0, $eec5c3b697f8e81e$export$9338f61da19c4759)['personal']
        ];
        if (isProUser()) result.push(...(0, $eec5c3b697f8e81e$export$9338f61da19c4759)['isEmployeeAccess']);
        if (isEduUser()) result.push(...(0, $eec5c3b697f8e81e$export$9338f61da19c4759)['isStudentAccess']);
        if (isSdkUser()) result.push(...(0, $eec5c3b697f8e81e$export$9338f61da19c4759)['isDeveloperAccess']);
        if (isPlusUser()) result.push(...(0, $eec5c3b697f8e81e$export$9338f61da19c4759)['isPlusAccess']);
        const uniqueFlags = [
            ...new Set(result)
        ];
        return uniqueFlags;
    }, [
        userLicenseAccess
    ]);
    const updateUserPermissions = (value)=>{
        setIsApprovedDomain(value);
        const currUser = currentUserRef.current;
        if (currUser) handleUpdateUser(currUser);
    };
    const checkAndUpdatePendingTos = async ()=>{
        try {
            const tosResult = await $1a4c36336f303477$export$160fb9e4529c1fb8();
            if (tosResult?.resultType === 'Ok' && tosResult.data) {
                const acceptedVersion = currentUserRef.current?.acceptedTosVersion;
                const requiredVersion = tosResult.data.requiredVersion;
                if (!acceptedVersion || acceptedVersion < requiredVersion) setPendingTosConfig(tosResult.data);
            }
        } catch (error) {
            console.error('Error checking TOS config:', error);
        }
    };
    const hasNoOrgMemberships = (0, $7fPBF.useMemo)(()=>{
        return (userLicenseAccessRef.current?.organizationLicenses?.length ?? 0) === 0;
    }, [
        userLicenseAccess
    ]);
    const isLicenseExpired = (0, $7fPBF.useMemo)(()=>{
        return userLicenseAccessRef.current?.licenseExpirationDate ? new Date(userLicenseAccessRef.current.licenseExpirationDate) < new Date() : false;
    }, [
        userLicenseAccess
    ]);
    const addUpgradeBanner = (newBanner, duration)=>{
        setUpgradeBannerMap((prevBannerMap)=>{
            const updatedMap = new Map(prevBannerMap);
            // Clear the existing timeout if the banner already exists
            if (updatedMap.has(newBanner.id)) {
                const existingBanner = updatedMap.get(newBanner.id);
                if (existingBanner && existingBanner.timeout) clearTimeout(existingBanner.timeout);
            }
            let timeout;
            // Set a new timeout to remove the banner if duration is provided
            if (duration !== undefined) timeout = setTimeout(()=>{
                setUpgradeBannerMap((currentMap)=>{
                    const newMap = new Map(currentMap);
                    newMap.delete(newBanner.id);
                    return newMap;
                });
            }, duration);
            // Add the banner with the timeout if it exists
            updatedMap.set(newBanner.id, {
                ...newBanner,
                timeout: timeout
            });
            return updatedMap;
        });
    };
    const removeUpgradeBanner = (id)=>{
        setUpgradeBannerMap((prevBannerMap)=>{
            const updatedMap = new Map(prevBannerMap);
            const banner = updatedMap.get(id);
            if (banner && banner.timeout) clearTimeout(banner.timeout);
            updatedMap.delete(id);
            return updatedMap;
        });
    };
    (0, $7fPBF.useEffect)(()=>{
        const featureFlags = getUserFeatureFlags();
        (0, $e7df95de73caec26$export$89b472e03be495df)('userFeatureFlagsUpdated', {
            featureFlags: featureFlags
        });
    }, [
        currentUser,
        userLicenseAccess
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const unsubsribeUpdateUserLicenseAccess = (0, $e7df95de73caec26$export$ec068583843480e7)('updateUserLicenseAccess', async ()=>{
            await loadUserLicenseAccess();
        });
        return ()=>{
            unsubsribeUpdateUserLicenseAccess();
        };
    });
    return {
        currentUser: currentUser,
        currentUserRef: currentUserRef,
        clearCurrentUser: clearCurrentUser,
        capabilityFacetGroups: capabilityFacetGroups,
        deleteCurrentUser: deleteCurrentUser,
        loadCurrentUser: loadCurrentUser,
        initializeFromStorage: initializeFromStorage,
        updatePassword: updatePassword,
        updateUserCapabilities: updateUserCapabilities,
        loadCapabilityFacetGroups: loadCapabilityFacetGroups,
        getUserPreferences: getUserPreferences,
        updateEmailPreferences: updateEmailPreferences,
        updateUserPreferences: updateUserPreferences,
        addUpgradeBanner: addUpgradeBanner,
        removeUpgradeBanner: removeUpgradeBanner,
        upgradeBannersArray: upgradeBannersArray,
        requestEmailVerificationResend: requestEmailVerificationResend,
        userLicenseAccess: userLicenseAccess,
        userLicenseAccessRef: userLicenseAccessRef,
        updateUserLicenseAccess: updateUserLicenseAccess,
        loadUserLicenseAccess: loadUserLicenseAccess,
        loadUserLicenseAccessFromStorage: loadUserLicenseAccessFromStorage,
        isLoadingFacets: isLoadingFacets,
        isLoading: isLoading,
        errors: errors,
        userLocalePreferences: userLocalePreferences,
        userLocalePreferencesRef: userLocalePreferencesRef,
        updateUserLocales: updateUserLocales,
        saveUserLocales: saveUserLocales,
        handleUpdateUser: handleUpdateUser,
        voiceModelUrl: voiceModelUrl,
        voiceModelUrlRef: voiceModelUrlRef,
        showUserFallbackDialog: showUserFallbackDialog,
        setShowUserFallbackDialog: setShowUserFallbackDialog,
        isEmailVerified: isEmailVerified,
        isEmailVerifiedRef: isEmailVerifiedRef,
        isUserLicensedForAllFeatureFlags: isUserLicensedForAllFeatureFlags,
        isFeatureFlagEnabled: isFeatureFlagEnabled,
        isFreeUser: isFreeUser,
        isProUser: isProUser,
        isEduUser: isEduUser,
        isSdkUser: isSdkUser,
        isTrialUser: isTrialUser,
        userLicenseType: userLicenseType,
        isApprovedDomain: isApprovedDomain,
        isApprovedDomainRef: isApprovedDomainRef,
        updateUserPermissions: updateUserPermissions,
        hasNoOrgMemberships: hasNoOrgMemberships,
        isLicenseExpired: isLicenseExpired,
        userBetaFeatureFlags: userBetaFeatureFlags,
        signalRConnected: signalRConnected,
        setSignalRConnected: setSignalRConnected,
        pendingTosConfig: pendingTosConfig,
        setPendingTosConfig: setPendingTosConfig,
        checkAndUpdatePendingTos: checkAndUpdatePendingTos
    };
}
const $8a1185b15e8317ab$var$CurrentUserContainer = (0, $78783f85c4167892$export$26ae5ca175b4ec5a)($8a1185b15e8317ab$var$useCurrentUserContainer);
var $8a1185b15e8317ab$export$2e2bcd8739ae039 = $8a1185b15e8317ab$var$CurrentUserContainer;




const $2e1b9b7946b06a36$export$e57a519b54d74351 = '3ae3d1ed-97b7-4572-a57a-00d4724270a0';






const $488d70defc02145b$export$3674500df62ac424 = (device)=>{
    const deviceType = device.device?.deviceType;
    if (!deviceType) return 'application';
    if (deviceType.id === (0, $2e1b9b7946b06a36$export$e57a519b54d74351)) return 'device';
    if (deviceType.supportsGenericControllerOutput || deviceType.supportsXboxControllerOutput || deviceType.supportsNintendoControllerOutput || deviceType.supportsPlayStationControllerOutput) return 'game';
    return 'application';
};
const $488d70defc02145b$export$e9455858f5005fb = (command, profile)=>{
    if (!profile) return false;
    // check profile configuration
    if (command.toLowerCase().startsWith((0, $f44f3a5bc46b1c4c$export$2edc7d5e93b11fea)) || command.toLowerCase().startsWith((0, $f44f3a5bc46b1c4c$export$b617c310e3426257))) return true;
    if (profile?.configuration?.audioEvents?.some((a)=>a.commands?.some((c)=>c.toLowerCase() == command.toLowerCase()))) return true;
    if (profile?.configuration?.macros?.some((m)=>m.commands.some((c)=>c.toLowerCase() == command.toLowerCase()))) return true;
    if (profile?.configuration?.commandKeyMappings?.some((c)=>c.commands?.some((cc)=>cc.toLowerCase() == command.toLowerCase()))) return true;
    return false;
};






var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");



/**
 * Manages all devices and api calls.
 * VirtualDevice = Cephable Desktop App, Virtual Controller. Works as both an input and output device.
 * OutputDevice = The device controlled by the panel. Ex: Panel microphone processes voice controls and dictation, then if it matches to an event / output, it sends the command to output device to be controlled.
 * @returns
 */ function $57ef534a0961ba07$var$useDeviceContainer() {
    const currentAppNameRef = (0, $7fPBF.useRef)(null);
    const userLicenseAccessRef = (0, $7fPBF.useRef)(undefined);
    const [isSwitchingTempDisabled, setIsSwitchingTempDisabled, isSwitchingTempDisabledRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(false);
    const [devices, setDevices, devicesRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)([]);
    const [deviceTypeClientList, setDeviceTypeClientList] = (0, $7fPBF.useState)([]);
    const [deviceTypesInitializing, setDeviceTypesInitializing] = (0, $7fPBF.useState)(true);
    const [virtualDeviceToken, setVirtualDeviceToken, virtualDeviceTokenRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(null);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(true);
    const [errors, setErrors] = (0, $7fPBF.useState)([]);
    const [isInitialized, setIsInitialized] = (0, $7fPBF.useState)(false);
    const [deviceCommandTokens, setDeviceCommandTokens] = (0, $7fPBF.useState)([]);
    const [tryCommandHandlers, setTryCommandHandlers] = (0, $7fPBF.useState)([]);
    const [outputDeviceId, setOutputDeviceId, outputDeviceIdRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(null);
    const [virtualDeviceId, setVirtualDeviceId, virtualDeviceIdRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(null);
    const addTryCommandHandler = (handler)=>{
        setTryCommandHandlers([
            ...tryCommandHandlers,
            handler
        ]);
    };
    const [tryGlobalControlHandlers, setTryGlobalControlHandlers] = (0, $7fPBF.useState)([]);
    const addTryGlobalControlHandler = (handler)=>{
        setTryGlobalControlHandlers([
            ...tryGlobalControlHandlers,
            handler
        ]);
    };
    const [throttleWarningHandlers, setThrottleWarningHandlers, throttleWarningHandlersRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)([]);
    const addThrottleWarningHandler = (handler)=>{
        setThrottleWarningHandlers([
            ...throttleWarningHandlers,
            handler
        ]);
    };
    const initializeFromStorage = ()=>{
        try {
            setIsInitialized(false);
            const localDevices = localStorage.getItem((0, $4a3c7ab711a29dd4$export$7e1b78538df536d8));
            let storedDevices = [];
            if (localDevices) {
                storedDevices = JSON.parse(localDevices);
                setDevices(storedDevices);
            }
            const virtualDevice = getLocalVirtualDevice();
            setVirtualDeviceId(virtualDevice?.id ?? null);
            const virtualDeviceToken = getLocalVirtualDeviceToken();
            setVirtualDeviceToken(virtualDeviceToken);
        } catch (e) {
            console.log('Error loading devices from storage', e);
        } finally{
            setIsInitialized(true);
        }
    };
    const getLocalVirtualDevice = ()=>{
        // Try ref first
        if (virtualDeviceIdRef.current) {
            const device = getLocalDevice(virtualDeviceIdRef.current);
            if (device) return device;
        }
        // get from storage
        const virtualDevice = localStorage.getItem((0, $4a3c7ab711a29dd4$export$e0520dc8c020e730));
        const virtualDeviceId = localStorage.getItem((0, $4a3c7ab711a29dd4$export$c66d0139ef02a287));
        let device = virtualDevice ? JSON.parse(virtualDevice) : null;
        if (device) return device;
        return getLocalDevice(virtualDeviceId);
    };
    const getLocalVirtualDeviceToken = ()=>{
        // Try ref first
        if (virtualDeviceTokenRef.current) return virtualDeviceTokenRef.current;
        // get from storage
        const virtualDeviceTokenLocal = localStorage.getItem((0, $4a3c7ab711a29dd4$export$e79477942e3c1f1));
        if (virtualDeviceTokenLocal) {
            const deviceToken = JSON.parse(virtualDeviceTokenLocal);
            return deviceToken;
        }
        return null;
    };
    const initializeFromRemote = async (computerName, hardwareId, platform = 'generic')=>{
        try {
            setIsInitialized(false);
            await initializeVirtualController(computerName, hardwareId, platform); // updates existing device, or registers a new one
            const deviceLoadResult = await getDevices(); // gets all devices including virtual controller
            return deviceLoadResult;
        } catch (error) {
            console.error('[ERROR initializeFromRemote]', error);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setIsInitialized(true);
            setIsLoading(false);
        }
    };
    const getDeviceName = (deviceId)=>{
        const device = getLocalDevice(deviceId);
        if (device) return device.nameOverride ?? device.device?.name ?? device.device.deviceType?.name ?? '-';
        return '-';
    };
    const updateDevicePlatform = async (device, platform = 'generic')=>{
        if (device?.platform === platform) return;
        await updateDevice(device.id, {
            ...device,
            platform: platform
        });
    };
    const registerNewVirtualDevice = async (computerName, hardwareId, platform = 'generic')=>{
        try {
            setIsLoading(true);
            const result = await $1a4c36336f303477$export$b77d91733b0be1c3((0, $2e1b9b7946b06a36$export$e57a519b54d74351), computerName, hardwareId, platform);
            if (result?.resultType == 'Ok' && result.data) {
                setVirtualDeviceId(result.data.id);
                const tokenResult = await $1a4c36336f303477$export$d90355b21d70c45b(result.data.id, {
                    includeUserEvents: true
                });
                if (tokenResult.resultType == 'Ok' && tokenResult.data) setVirtualDeviceToken(tokenResult.data);
                snapshotState(devices, result.data.id, tokenResult.data ?? null);
                return new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)([
                    result.data,
                    tokenResult.data ?? null
                ]);
            } else if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            return {
                ...result,
                data: [
                    null,
                    null
                ]
            };
        } catch (error) {
            setErrors([
                error
            ]);
            console.debug('[ERROR registerNewVirtualDevice]', error);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setIsLoading(false);
        }
    };
    const initializeVirtualController = async (computerName, hardwareId, platform = 'generic')=>{
        try {
            const existingVirtualDevice = getLocalVirtualDevice();
            const existingToken = getLocalVirtualDeviceToken();
            if (existingVirtualDevice && existingToken) {
                //  update existing device's platform if not already set
                setVirtualDeviceId(existingVirtualDevice.id);
                setVirtualDeviceToken(existingToken);
                await updateDevicePlatform(existingVirtualDevice, platform);
                return new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)([
                    existingVirtualDevice,
                    existingToken
                ]);
            }
            const result = await registerNewVirtualDevice(computerName, hardwareId, platform);
            return result;
        } catch (error) {
            setErrors([
                error
            ]);
            console.debug('[ERROR initializeVirtualController]', error);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const getDevices = async ()=>{
        try {
            setIsLoading(true);
            const result = await $1a4c36336f303477$export$7d50e0ca36e10692();
            if (result?.resultType == 'Ok' && result.data) {
                const loadedDevices = result.data.filter((d)=>d.isVerified);
                setDevices(loadedDevices);
                snapshotState(loadedDevices, virtualDeviceIdRef.current, virtualDeviceToken);
                return new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)(loadedDevices);
            }
            return result;
        } catch (e) {
            setErrors([
                'Error getting devices'
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setIsLoading(false);
        }
    };
    const getLocalDevice = (userDeviceId)=>{
        if (!userDeviceId) return null;
        const device = devicesRef.current?.find((d)=>d.id == userDeviceId);
        return device ?? null;
    };
    const updateVirtualDevice = (device)=>{
        // legacy for web sub project
        updateLocalDevice(device);
    };
    const updateLocalDevice = (device)=>{
        const updatedDevices = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).cloneDeep(devicesRef.current);
        const index = devicesRef.current.findIndex((x)=>x.id == device.id);
        if (index > -1) updatedDevices[index] = device;
        else updatedDevices.push(device);
        setDevices([
            ...updatedDevices
        ]);
        snapshotState(updatedDevices, virtualDeviceIdRef.current, virtualDeviceToken);
    };
    const snapshotState = (devices, virtualDeviceId, virtualDeviceToken)=>{
        if (devices?.length > 0) localStorage.setItem((0, $4a3c7ab711a29dd4$export$7e1b78538df536d8), JSON.stringify(devices));
        if (virtualDeviceId) localStorage.setItem((0, $4a3c7ab711a29dd4$export$c66d0139ef02a287), virtualDeviceId);
        if (virtualDeviceToken) localStorage.setItem((0, $4a3c7ab711a29dd4$export$e79477942e3c1f1), JSON.stringify(virtualDeviceToken));
    };
    const updateDevice = async (userDeviceId, update)=>{
        const result = await $1a4c36336f303477$export$18c61c16dde23826(userDeviceId, update);
        const updatedDevices = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).cloneDeep(devicesRef.current);
        if (result?.resultType == 'Ok' && result.data) {
            const deviceIndex = devicesRef.current?.findIndex((x)=>x.id == userDeviceId);
            if (deviceIndex != null) {
                updatedDevices[deviceIndex] = result.data;
                setDevices([
                    ...updatedDevices
                ]);
                snapshotState(updatedDevices, virtualDeviceIdRef.current, virtualDeviceToken);
            }
        }
        return result;
    };
    const checkForUpdates = async (userDeviceId)=>{
        const token = await getDeviceToken(userDeviceId);
        if (!token) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        const result = await $1a4c36336f303477$export$e5712e6cd1606beb(userDeviceId, token.token);
        return result;
    };
    const getDeviceToken = async (userDeviceId)=>{
        if (userDeviceId == virtualDeviceIdRef.current) return virtualDeviceTokenRef.current;
        const existingToken = deviceCommandTokens.find((x)=>x.userDeviceId == userDeviceId && !x.token.isDisabled);
        if (existingToken) return existingToken.token;
        const result = await $1a4c36336f303477$export$4ff3dab44ee74505(userDeviceId);
        if (result?.resultType == 'Ok' && result.data) {
            setDeviceCommandTokens([
                ...deviceCommandTokens,
                {
                    userDeviceId: userDeviceId,
                    token: result.data
                }
            ]);
            return result.data;
        }
    };
    const tryDeviceCommand = async (userDeviceId, command, profile, additionalInputContent)=>{
        // if we are in the virtual controller then fire it locally
        // if we are not in the VC, then fire via API call
        if (userDeviceId == virtualDeviceIdRef.current) {
            if (profile) for (let handler of tryCommandHandlers){
                if (handler(command, profile)) return true;
            }
        } else {
            const device = devicesRef.current?.find((d)=>d.id == userDeviceId);
            if (device && profile && !(0, $488d70defc02145b$export$e9455858f5005fb)(command, profile)) {
                for (let handler of tryGlobalControlHandlers){
                    if (handler(command, userDeviceId)) return true;
                }
                return false;
            }
            let macro = devicesRef.current?.find((d)=>d.id == userDeviceId)?.currentProfile?.configuration?.macros?.find((m)=>m.commands.some((c)=>c.toLowerCase() == command.toLowerCase()));
            const keybinding = device?.currentProfile?.configuration?.commandKeyMappings.find((k)=>k.commands.some((c)=>c.toLowerCase() == command.toLowerCase()));
            if (!macro && keybinding && keybinding.key) // create a temp macro for this command so that it can be sent to the device and executed by the agent
            macro = {
                id: 'keybind' + keybinding.key,
                name: 'keybind',
                commands: [
                    command
                ],
                events: [
                    {
                        keys: [
                            keybinding.key
                        ],
                        eventType: 'KeyPress',
                        isKeyLatch: false,
                        holdTimeMilliseconds: 0
                    }
                ]
            };
            const sendResult = await sendDeviceCommand(userDeviceId, command, macro);
            return sendResult;
        }
        return false;
    };
    const tryDeviceTypeCommand = async (userDeviceId, phrase)=>{
        const device = devicesRef.current?.find((d)=>d.id == userDeviceId);
        if (device) {
            const token = await getDeviceToken(userDeviceId);
            if (token) {
                await $1a4c36336f303477$export$24fb0aee8e6ea00f(userDeviceId, phrase, token.token);
                return true;
            }
        }
        return false;
    };
    // Throttle state tracking
    const deviceThrottleStateRef = (0, $7fPBF.useRef)({});
    const sendDeviceCommand = async (userDeviceId, command, macro)=>{
        const device = devicesRef.current?.find((d)=>d.id == userDeviceId);
        if (!device) return false;
        // Get throttle rules if available
        const throttleRules = device.device?.deviceType?.commandThrottleRules;
        // Macro length restriction
        let macroToSend = macro ? {
            ...macro
        } : undefined;
        if (macroToSend && throttleRules?.maximumMacroLength != null && throttleRules.maximumMacroLength > 0) {
            if (macroToSend.events && macroToSend.events.length > throttleRules.maximumMacroLength) {
                macroToSend.events = macroToSend.events.slice(0, throttleRules.maximumMacroLength);
                throttleWarningHandlersRef?.current?.forEach((handler)=>handler('macroLength'));
            }
        }
        if (macroToSend) macroToSend.issuedAt = new Date().toISOString();
        // Per-second and per-minute throttling
        const now = Date.now();
        if (!deviceThrottleStateRef.current[userDeviceId]) deviceThrottleStateRef.current[userDeviceId] = {
            perSecond: [],
            perMinute: []
        };
        const state = deviceThrottleStateRef.current[userDeviceId];
        // Clean up old timestamps
        state.perSecond = state.perSecond.filter((ts)=>now - ts < 1000);
        state.perMinute = state.perMinute.filter((ts)=>now - ts < 60000);
        // Check per-second throttle
        const maxPerSecond = throttleRules?.maximumCommandsPerSecond && throttleRules.maximumCommandsPerSecond > 0 ? throttleRules.maximumCommandsPerSecond : null;
        if (maxPerSecond && state.perSecond.length >= maxPerSecond) {
            throttleWarningHandlersRef?.current?.forEach((handler)=>handler('commandCount'));
            return false; // Throttled per second
        }
        // Check per-minute throttle
        const maxPerMinute = throttleRules?.maximumCommandsPerMinute && throttleRules.maximumCommandsPerMinute > 0 ? throttleRules.maximumCommandsPerMinute : null;
        if (maxPerMinute && state.perMinute.length >= maxPerMinute) {
            throttleWarningHandlersRef?.current?.forEach((handler)=>handler('commandCount'));
            return false; // Throttled per minute
        }
        // Passed throttles, record send
        state.perSecond.push(now);
        state.perMinute.push(now);
        const token = await getDeviceToken(userDeviceId);
        if (token) {
            // TODO: we should probably send over signalr if we have the connection instead of over HTTP
            await $1a4c36336f303477$export$52e3a002786737fb(userDeviceId, command, token.token, macroToSend);
            return true;
        }
        return false;
    };
    const deleteDevice = async (userDeviceId)=>{
        try {
            const result = await $1a4c36336f303477$export$7cbb8f3d5a86c9b4(userDeviceId);
            if (result?.resultType == 'Ok') {
                const clone = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).cloneDeep(devicesRef.current);
                const updatedDevices = clone.filter((d)=>d.id != userDeviceId);
                const isVirtualDevice = virtualDeviceIdRef.current == userDeviceId;
                if (isVirtualDevice) {
                    setVirtualDeviceId(null);
                    setVirtualDeviceToken(null);
                    localStorage.removeItem((0, $4a3c7ab711a29dd4$export$c66d0139ef02a287));
                    localStorage.removeItem((0, $4a3c7ab711a29dd4$export$e79477942e3c1f1));
                    // backwards compatibility for anyone who has not signed out
                    localStorage.removeItem((0, $4a3c7ab711a29dd4$export$e0520dc8c020e730));
                }
                if (outputDeviceIdRef.current === userDeviceId) setOutputDeviceId(null);
                setDevices(updatedDevices);
                snapshotState(updatedDevices, isVirtualDevice ? null : virtualDeviceIdRef.current, virtualDeviceToken);
            }
            return result;
        } catch (e) {
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const disableDevice = async (userDeviceId)=>{
        try {
            const result = await $1a4c36336f303477$export$c25252bb8cefd145(userDeviceId);
            if (result?.resultType == 'Ok') {
                const updatedDevices = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).cloneDeep(devicesRef.current);
                const deviceIndex = devicesRef.current?.findIndex((x)=>x.id == userDeviceId);
                if (deviceIndex !== -1) {
                    updatedDevices.splice(deviceIndex, 1);
                    const isVirtualDevice = virtualDeviceIdRef.current == userDeviceId;
                    if (isVirtualDevice) {
                        setVirtualDeviceId(null);
                        setVirtualDeviceToken(null);
                        localStorage.removeItem((0, $4a3c7ab711a29dd4$export$c66d0139ef02a287));
                        localStorage.removeItem((0, $4a3c7ab711a29dd4$export$e79477942e3c1f1));
                        // backwards compatibility for anyone who has not signed out
                        localStorage.removeItem((0, $4a3c7ab711a29dd4$export$e0520dc8c020e730));
                    }
                    if (outputDeviceIdRef.current === userDeviceId) setOutputDeviceId(null);
                    setDevices(updatedDevices);
                    snapshotState(updatedDevices, isVirtualDevice ? null : virtualDeviceIdRef.current, virtualDeviceToken);
                }
            }
            return result;
        } catch (e) {
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const removeLocalDevice = (userDeviceId)=>{
        const clone = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).cloneDeep(devicesRef.current);
        const updatedDevices = clone.filter((d)=>d.id != userDeviceId);
        const isVirtualDevice = virtualDeviceIdRef.current == userDeviceId;
        setDevices(updatedDevices);
        snapshotState(updatedDevices, isVirtualDevice ? null : virtualDeviceIdRef.current, virtualDeviceToken);
    };
    const startListening = async (userDeviceId)=>{
        const token = await getDeviceToken(userDeviceId);
        if (!token) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        const result = await $1a4c36336f303477$export$2fbfcdb28574a0(userDeviceId, token.token);
        return result;
    };
    const stopListening = async (userDeviceId)=>{
        const token = await getDeviceToken(userDeviceId);
        if (!token) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        const device = devicesRef.current?.find((d)=>d.id == userDeviceId);
        if (!device || !device.isListening) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        const result = await $1a4c36336f303477$export$8f1ea12fa311585e(userDeviceId, token.token);
        return result;
    };
    const stopAllOutputs = async (userDeviceId, profile)=>{
        tryDeviceCommand(userDeviceId, (0, $f44f3a5bc46b1c4c$export$8c2b4826af6cc511), profile);
    };
    const isDeviceVirtualController = (deviceId)=>{
        // current output device is same as input device
        return deviceId === virtualDeviceIdRef.current;
    };
    const isAutoProfileSwitchingDisabled = ()=>{
        if (!outputDeviceIdRef.current) return true;
        const device = devicesRef.current?.find((d)=>d.id == outputDeviceIdRef.current);
        return !isDeviceVirtualController(outputDeviceIdRef.current) || !device?.isAutoProfileSwitchingEnabled || isSwitchingTempDisabledRef.current;
    };
    const initializeDeviceTypesClientList = async (locale)=>{
        setDeviceTypesInitializing(true);
        try {
            const result = await $1a4c36336f303477$export$1550d2bbaae6a36d(locale);
            if (result && result.data) setDeviceTypeClientList(result.data);
        } catch (e) {
            setDeviceTypeClientList([]);
        } finally{
            setDeviceTypesInitializing(false);
        }
    };
    const clearDevices = ()=>{
        setDevices([]);
        setVirtualDeviceId(null);
        setVirtualDeviceToken(null);
        setOutputDeviceId(null);
        setDeviceTypeClientList([]);
        snapshotState([], null, null);
    };
    const isDesktopApp = (deviceTypeId)=>{
        return deviceTypeId === (0, $2e1b9b7946b06a36$export$e57a519b54d74351);
    };
    const setDeviceProfile = async (deviceId, profile)=>{
        try {
            if (!deviceId) return new (0, $6340c001daecf2cb$export$2e2bcd8739ae039)('Device ID is required to set profile');
            const device = devicesRef.current?.find((d)=>d.id == deviceId);
            if (!device) return new (0, $6340c001daecf2cb$export$2e2bcd8739ae039)('Device not found');
            if (!(0, $28343ab509e453ee$export$6ff753f9d38ae18d)(profile, userLicenseAccessRef.current)) return new (0, $6340c001daecf2cb$export$2e2bcd8739ae039)('Invalid permissions. Cannot set device profile');
            let result = new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
            let updatedDevice = device;
            // server call
            const profileUpdate = profile.isPublic ? {
                customProfileId: null,
                defaultProfileId: profile.id
            } : {
                customProfileId: profile.id
            };
            result = await $1a4c36336f303477$export$c35b3a8741882c0(deviceId, profileUpdate);
            if (result.resultType === 'Ok' && result.data) updatedDevice = result.data;
            if (result?.resultType === 'NoResponse' || result?.resultType === 'Offline') {
                // offline mode
                updatedDevice = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).cloneDeep(device);
                if (profile.isPublic) {
                    updatedDevice.currentProfile = null;
                    updatedDevice.defaultProfileId = profile.id;
                } else updatedDevice.currentProfile = profile;
                result = new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)(updatedDevice);
            }
            updateLocalDevice(updatedDevice);
            return result;
        } catch (e) {
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const resetDeviceProfile = async (deviceId, profile)=>{
        if (!deviceId) return new (0, $6340c001daecf2cb$export$2e2bcd8739ae039)('Device ID is not set');
        const device = devicesRef.current?.find((d)=>d.id == deviceId);
        if (!device) return new (0, $6340c001daecf2cb$export$2e2bcd8739ae039)('Device not found');
        let result;
        // reset current profile to null
        if (profile?.isPublic) result = await $1a4c36336f303477$export$c35b3a8741882c0(deviceId, {
            defaultProfileId: null
        });
        else result = await $1a4c36336f303477$export$c35b3a8741882c0(deviceId, {
            customProfileId: null
        });
        let updatedDevice = device;
        if (result.resultType === 'Ok' && result.data) updatedDevice = result.data;
        else if (result.resultType !== 'Ok') {
            // offline reset
            updatedDevice = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).cloneDeep(device);
            if (profile?.isPublic) updatedDevice.defaultProfileId = null;
            else updatedDevice.currentProfile = null;
            result = new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)(updatedDevice);
        }
        updateLocalDevice(updatedDevice);
        return result;
    };
    const updateCurrentAppName = (appName)=>{
        if (appName !== currentAppNameRef.current) {
            currentAppNameRef.current = appName;
            fallbackToDeviceSwitching();
            return true;
        }
        return false;
    };
    const fallbackToDeviceSwitching = ()=>{
        setIsSwitchingTempDisabled(false);
    };
    const overrideAppSwitching = ()=>{
        if (!isSwitchingTempDisabledRef.current) setIsSwitchingTempDisabled(true);
    };
    /**
     * Sets the output device Id. This is the same as the device being controlled by the panel.
     * @param deviceId
     */ const updateOutputDeviceId = (deviceId)=>{
        if (deviceId !== outputDeviceIdRef.current) {
            setOutputDeviceId(deviceId);
            const device = getLocalDevice(deviceId);
            if (connectedDevices.length > 1 && device) // only track if more than 1 device is connected to avoid
            (0, $e7df95de73caec26$export$89b472e03be495df)('analyticsTrackEvent', {
                eventName: 'output_device_switched',
                data: {
                    deviceTypeId: device?.device?.deviceType?.id
                }
            });
        }
        if (deviceId === virtualDeviceIdRef.current) fallbackToDeviceSwitching();
    };
    (0, $7fPBF.useEffect)(()=>{
        const unsubscribeUserLicenseChange = (0, $e7df95de73caec26$export$ec068583843480e7)('userLicenseChangeLocal', async (data)=>{
            if (data) userLicenseAccessRef.current = data;
        });
        return ()=>{
            unsubscribeUserLicenseChange();
        };
    }, []);
    const connectedDevices = (0, $7fPBF.useMemo)(()=>{
        const updatedConnectedDevices = devices.filter((d)=>d.id === virtualDeviceId || d.isConnected);
        return updatedConnectedDevices;
    }, [
        devices
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const unsubDeviceAdded = (0, $e7df95de73caec26$export$ec068583843480e7)('device-added', (data)=>{
            updateLocalDevice(data.device);
        });
        const unsubDeviceRemoved = (0, $e7df95de73caec26$export$ec068583843480e7)('remove-device', (data)=>{
            removeLocalDevice(data.device.id);
        });
        return ()=>{
            unsubDeviceAdded();
            unsubDeviceRemoved();
        };
    }, []);
    return {
        connectedDevices: connectedDevices,
        devices: devices,
        devicesRef: devicesRef,
        setDevices: setDevices,
        fallbackToDeviceSwitching: fallbackToDeviceSwitching,
        getLocalDevice: getLocalDevice,
        isAutoProfileSwitchingDisabled: isAutoProfileSwitchingDisabled,
        isInitialized: isInitialized,
        isSwitchingTempDisabled: isSwitchingTempDisabled,
        outputDeviceId: outputDeviceId,
        outputDeviceIdRef: outputDeviceIdRef,
        overrideAppSwitching: overrideAppSwitching,
        setDeviceProfile: setDeviceProfile,
        updateCurrentAppName: updateCurrentAppName,
        updateOutputDeviceId: updateOutputDeviceId,
        virtualDeviceId: virtualDeviceId,
        virtualDeviceIdRef: virtualDeviceIdRef,
        virtualDeviceToken: virtualDeviceToken,
        virtualDeviceTokenRef: virtualDeviceTokenRef,
        isLoading: isLoading,
        errors: errors,
        clearDevices: clearDevices,
        updateLocalDevice: updateLocalDevice,
        updateVirtualDevice: updateVirtualDevice,
        initializeFromStorage: initializeFromStorage,
        initializeVirtualController: initializeVirtualController,
        updateDevice: updateDevice,
        checkForUpdates: checkForUpdates,
        initializeFromRemote: initializeFromRemote,
        isDesktopApp: isDesktopApp,
        getDevices: getDevices,
        getDeviceName: getDeviceName,
        deleteDevice: deleteDevice,
        disableDevice: disableDevice,
        resetDeviceProfile: resetDeviceProfile,
        startListening: startListening,
        stopListening: stopListening,
        stopAllOutputs: stopAllOutputs,
        addTryCommandHandler: addTryCommandHandler,
        addTryGlobalControlHandler: addTryGlobalControlHandler,
        tryDeviceTypeCommand: tryDeviceTypeCommand,
        tryDeviceCommand: tryDeviceCommand,
        sendDeviceCommand: sendDeviceCommand,
        removeLocalDevice: removeLocalDevice,
        deviceTypeClientList: deviceTypeClientList,
        deviceTypesInitializing: deviceTypesInitializing,
        initializeDeviceTypesClientList: initializeDeviceTypesClientList,
        addThrottleWarningHandler: addThrottleWarningHandler
    };
}
const $57ef534a0961ba07$var$DeviceContainer = (0, $78783f85c4167892$export$26ae5ca175b4ec5a)($57ef534a0961ba07$var$useDeviceContainer);
var $57ef534a0961ba07$export$2e2bcd8739ae039 = $57ef534a0961ba07$var$DeviceContainer;




const $37766e6a1a6352f1$export$a58d95327faf613d = {
    createdDate: '',
    modifiedDate: '',
    name: '',
    description: '',
    isPrivate: false,
    isSupported: false,
    isVirtual: false,
    defaultLocale: '',
    supportsVoiceInput: false,
    supportsFaceInput: false,
    supportsGestureInput: false,
    supportsPhysicalInput: false,
    supportsWifi: false,
    supportsDigitalExtensions: false,
    supportsPhysicalExtensions: false,
    supportsKeyboardOutput: false,
    supportsGenericControllerOutput: false,
    supportsXboxControllerOutput: false,
    supportsPlayStationControllerOutput: false,
    supportsNintendoControllerOutput: false,
    supportsTextGeneration: false,
    supportsTextSummarization: false,
    supportsNLUCommands: false,
    supportsEnhancedDictation: false,
    supportsAIWorkflows: false,
    supportsAutoProfileSwitching: false,
    isApplication: true
};
const $37766e6a1a6352f1$export$3d14a40e22c549b = {
    organizationId: '',
    name: '',
    originHost: '',
    createdDate: new Date().toISOString(),
    modifiedDate: new Date().toISOString(),
    tokenAdditionalRedirectUris: [],
    additionalRedirectUris: [],
    authClientScopes: [],
    authClientDeviceTypes: []
};
const $37766e6a1a6352f1$export$7e4b5db9af1d87c4 = (0, $3ecd3f7dea3d56de$export$df1c34db1371eeed).display.map((locale)=>({
        deviceTypeId: '',
        locale: locale,
        title: '',
        shortDescription: '',
        markdownDescription: '',
        markdownOnboardingInstructions: '',
        markdownTroubleshootingInstructions: '',
        iconUrl: '',
        darkModeIconUrl: '',
        createdDate: '',
        updatedDate: '',
        priority: 0,
        isPublic: false
    }));




var $7fPBF = parcelRequire("7fPBF");



const $710192f33815db16$export$c9f16ca2d09e032e = (organizationId)=>{
    return {
        ...(0, $37766e6a1a6352f1$export$a58d95327faf613d),
        organizationId: organizationId
    };
};
const $710192f33815db16$export$78965615411ef913 = (organizationId)=>{
    return {
        ...(0, $37766e6a1a6352f1$export$3d14a40e22c549b),
        organizationId: organizationId
    };
};
const $710192f33815db16$export$e0ee21b9e212f3d0 = (listing)=>{
    if (!listing) return [];
    return listing.map(({ createdDate: createdDate, updatedDate: updatedDate, deviceTypeId: deviceTypeId, priority: priority, isPublic: isPublic, ...rest })=>rest);
};
const $710192f33815db16$export$304e7ba006a6c8a3 = (listing)=>{
    const updatedListing = [
        ...listing
    ];
    const iconLight = listing.find((l)=>l.locale === 'en')?.iconUrl || '';
    const darkModeIconUrl = listing.find((l)=>l.locale === 'en')?.darkModeIconUrl || '';
    (0, $3ecd3f7dea3d56de$export$df1c34db1371eeed).display.forEach((locale)=>{
        if (!updatedListing.find((l)=>l.locale === locale)) updatedListing.push({
            locale: locale,
            markdownDescription: '',
            markdownOnboardingInstructions: '',
            markdownTroubleshootingInstructions: '',
            title: '',
            shortDescription: '',
            iconUrl: iconLight,
            darkModeIconUrl: darkModeIconUrl
        });
    });
    return updatedListing;
};



function $c6a32ec408b1369c$var$useDeviceTypeEditorContainer() {
    const [editDeviceType, setEditDeviceType, editDeviceTypeRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(null);
    const [hasChanges, setHasChanges, hasChangesRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(false);
    const [listingHasChanges, setListingHasChanges, listingHasChangesRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(false);
    const [editListing, setEditListing, editListingRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(null);
    const [loadingListing, setLoadingListing] = (0, $7fPBF.useState)(false);
    const initializeEditListing = async (organizationId, deviceId)=>{
        setLoadingListing(true);
        let model = (0, $37766e6a1a6352f1$export$7e4b5db9af1d87c4);
        if (organizationId && deviceId) try {
            const result = await $1a4c36336f303477$export$f942174137d3f696(organizationId, deviceId);
            if (result.resultType === 'Ok' && result.data && result.data.length > 0) model = (0, $710192f33815db16$export$304e7ba006a6c8a3)(result.data);
            setListingHasChanges(false);
        } catch (error) {
            // Ignore errors
            console.error('Error fetching device type client listings:', error);
        } finally{
            setEditListing(model);
            setListingHasChanges(false);
            setLoadingListing(false);
        }
        setEditListing(model);
    };
    const initializeEditor = (model, organizationId)=>{
        if (model) setEditDeviceType(model);
        else if (organizationId) setEditDeviceType((0, $710192f33815db16$export$c9f16ca2d09e032e)(organizationId));
        setHasChanges(false);
    };
    const handleFieldChange = (fieldName, value)=>{
        setEditDeviceType((prevModel)=>prevModel ? {
                ...prevModel,
                [fieldName]: value
            } : null);
        setHasChanges(true);
    };
    const handleInputChange = (fieldName, value)=>{
        handleFieldChange(fieldName, value);
    };
    const createUpdateRequest = ()=>{
        if (editDeviceTypeRef.current) return editDeviceTypeRef.current;
    };
    const handleUpdate = async (actions, organizationId, deviceId)=>{
        try {
            const request = createUpdateRequest();
            if (!request) throw new Error('Missing request data');
            const result = await actions.updateOrgDeviceType(organizationId, deviceId, request);
            if (result.resultType === 'Ok' && result.data) {
                setEditDeviceType(result.data);
                setHasChanges(false);
            }
            return result;
        } catch (error) {
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const handleCreate = async (actions, organizationId)=>{
        try {
            const request = createUpdateRequest();
            if (!request) throw new Error('Missing request data');
            const result = await actions.createOrgDeviceType(organizationId, request);
            if (result.resultType === 'Ok' && result.data) {
                setEditDeviceType(result.data);
                setHasChanges(false);
            }
            return result;
        } catch (error) {
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const handleSave = async (actions, organizationId, deviceId)=>{
        if (editDeviceTypeRef.current?.id && deviceId) return await handleUpdate(actions, organizationId, deviceId);
        else return await handleCreate(actions, organizationId);
    };
    const handleCreateAndClearEditor = async (actions, organizationId)=>{
        const result = await handleCreate(actions, organizationId);
        if (result.resultType === 'Ok') {
            setEditDeviceType((0, $710192f33815db16$export$c9f16ca2d09e032e)(organizationId));
            setHasChanges(false);
        }
        return result;
    };
    const clearEditor = (organizationId)=>{
        if (organizationId) setEditDeviceType((0, $710192f33815db16$export$c9f16ca2d09e032e)(organizationId));
        else setEditDeviceType(null);
        setHasChanges(false);
    };
    return {
        editDeviceType: editDeviceType,
        editDeviceTypeRef: editDeviceTypeRef,
        setEditDeviceType: setEditDeviceType,
        hasChanges: hasChanges,
        hasChangesRef: hasChangesRef,
        initializeEditor: initializeEditor,
        handleFieldChange: handleFieldChange,
        handleInputChange: handleInputChange,
        handleSave: handleSave,
        handleCreateAndClearEditor: handleCreateAndClearEditor,
        loadingListing: loadingListing,
        listingHasChanges: listingHasChanges,
        listingHasChangesRef: listingHasChangesRef,
        setListingHasChanges: setListingHasChanges,
        editListing: editListing,
        editListingRef: editListingRef,
        initializeEditListing: initializeEditListing,
        setEditListing: setEditListing,
        clearEditor: clearEditor,
        createUpdateRequest: createUpdateRequest
    };
}
const $c6a32ec408b1369c$var$EditDeviceTypeContainer = (0, $78783f85c4167892$export$26ae5ca175b4ec5a)($c6a32ec408b1369c$var$useDeviceTypeEditorContainer);
var $c6a32ec408b1369c$export$2e2bcd8739ae039 = $c6a32ec408b1369c$var$EditDeviceTypeContainer;




const $14e4f1609944ac39$export$18d6475ce2e9bfe8 = 'main-content';
const $14e4f1609944ac39$export$269aad7f0fa0a52c = 'video';
const $14e4f1609944ac39$export$6c8c79e8a32401f3 = 'canvas';
const $14e4f1609944ac39$export$53ee1da10d1b10bc = 'swap-profile';
const $14e4f1609944ac39$export$a9a172bf96c7a4ed = 'profile-name-input';
const $14e4f1609944ac39$export$78fc16d191511ade = 'profile-conflict-indicators';




const $9a9874d925dad9cc$export$1042f3e960dd652b = (key, displayName, icon = 'keySpace', defaultCommand, alternateKeys = [], platform = 'generic')=>({
        commands: [
            {
                command: defaultCommand ?? key,
                commandType: (0, $f44f3a5bc46b1c4c$export$e9c0f8ebac1b37df)(defaultCommand ?? key)
            }
        ],
        key: key,
        displayName: displayName ?? key,
        alternateKeys: alternateKeys,
        icon: icon,
        platform: platform
    });
const $9a9874d925dad9cc$export$e4e98b6e2a74daae = (model, locale, alternateKeys = [], platform)=>{
    const defaultKeyMapping = $9a9874d925dad9cc$export$2f002ae08ac7e997(locale, platform);
    const keyMapping = defaultKeyMapping.find((v)=>v.key == model.key);
    return {
        commands: model.commands.map((c)=>({
                command: c,
                commandType: (0, $f44f3a5bc46b1c4c$export$e9c0f8ebac1b37df)(c)
            })),
        key: model.key,
        displayName: keyMapping?.displayName ?? model.key,
        alternateKeys: alternateKeys,
        icon: $9a9874d925dad9cc$export$fbe8b56204f00600(model.key, locale),
        platform: keyMapping?.platform ?? 'generic'
    };
};
const $9a9874d925dad9cc$export$d8fdbd751da3b492 = {
    en: [
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_1', 'Mouse Button 1 (Left Click)', 'mouseLeftClick', 'click', [
            'click',
            'left click'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_2', 'Mouse Button 2 (Right Click)', 'mouseRightClick', 'right click'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_3', 'Mouse Button 3 (Middle Click)', 'mouseMiddleClick', 'middle click'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('1', '1', 'key1', 'one', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('2', '2', 'key2', 'two', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('3', '3', 'key3', 'three', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('4', '4', 'key4', 'four', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('5', '5', 'key5', 'five', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('6', '6', 'key6', 'six', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('7', '7', 'key7', 'seven', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('8', '8', 'key8', 'eight', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('9', '9', 'key9', 'nine', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('0', '0', 'key0', 'zero', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('a', 'a', 'keyA'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('b', 'b', 'keyB'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('c', 'c', 'keyC'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('d', 'd', 'keyD'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('e', 'e', 'keyE'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f', 'f', 'keyF'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('g', 'g', 'keyG'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('h', 'h', 'keyH'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('i', 'i', 'keyI'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('j', 'j', 'keyJ'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('k', 'k', 'keyK'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('l', 'l', 'keyL'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('m', 'm', 'keyM'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('n', 'n', 'keyN'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('o', 'o', 'keyO'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('p', 'p', 'keyP'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('q', 'q', 'keyQ', 'q'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('r', 'r', 'keyR'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('s', 's', 'keyS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('t', 't', 'keyT'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('u', 'u', 'keyU'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('v', 'v', 'keyV'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('w', 'w', 'keyW'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('x', 'x', 'keyX'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('y', 'y', 'keyY'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('z', 'z', 'keyZ'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('_', '_', undefined, 'underscore'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('-', '-', undefined, 'dash', [
            'subtract'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b(',', ',', undefined, 'comma', [
            'comma',
            'Comma (,)',
            ','
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b(';', ';', undefined, 'semi colon'),
        $9a9874d925dad9cc$export$1042f3e960dd652b(':', ':', undefined, 'colin'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('?', '?', undefined, 'question mark'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('.', '.', 'keyDot', 'period'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('"', '"', undefined, 'quote'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('(', '(', undefined, 'open parenthesis'),
        $9a9874d925dad9cc$export$1042f3e960dd652b(')', ')', undefined, 'close parenthesis'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('[', '[', undefined, 'open brace'),
        $9a9874d925dad9cc$export$1042f3e960dd652b(']', ']', undefined, 'close brace'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('{', '{', undefined, 'open bracket'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('}', '}', undefined, 'close bracket'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('!', '!', undefined, 'exclamation'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('@', '@', undefined, 'at sign'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('*', '*', 'keyAsterisk', 'asterisk', [
            'multiply'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('/', '/', 'keySolidus', 'forward slash', [
            'divide'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('\\', '\\', undefined, 'backslash'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('&', '&', undefined, 'ampersand'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('#', '#', 'keyHashtag', 'lb'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('%', '%', undefined, 'percent'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('`', '`', undefined, 'back tick'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('^', '^', undefined, 'carrot'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('+', '+', undefined, 'plus', [
            'add'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('<', '<', 'keyLeftAngleParentheses', 'less than'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('=', '=', 'keyEqual', 'equals'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('>', '>', 'keyRightAngleParentheses', 'greater than'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('|', '|', undefined, 'pipe'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('~', '~', undefined, 'til de'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('$', '$', undefined, 'dollar sign'),
        $9a9874d925dad9cc$export$1042f3e960dd652b("'", "'", undefined, 'single quote'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('backspace', 'Backspace', 'keyDelete', 'back space', [
            'back space',
            'backspace'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('capslock', 'Caps', 'keyCapsLock', 'caps lock', [
            'caps lock',
            'caps'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numlock', 'Num Lock', undefined, 'num lock', [
            'num lock'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('scrolllock', 'Scroll Lock', undefined, 'scroll lock', [
            'scroll lock'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('cmd', 'Command', 'keyCommand', 'command', [
            'leftcmd',
            'command'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightcmd', 'Right Command', 'keyCommand', 'right command', [], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('delete', 'Delete', 'keyDelete'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('down', 'Down Arrow', 'keyPageDownButton', 'move down', [
            'down arrow',
            'downarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('left', 'Left Arrow', 'keyHomeButton', 'move left', [
            'left arrow',
            'leftarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('right', 'Right Arrow', 'keyEndButton', 'move right', [
            'right arrow',
            'rightarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('up', 'Up Arrow', 'keyPageUpButton', 'move up', [
            'up arrow',
            'uparrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('enter', 'Enter', 'keyEnterMac', 'enter', [
            'return'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('escape', 'Escape', 'keyEsc', 'escape', [
            'esc'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftalt', 'Left Alt', 'keyAlt', 'alt', [
            'alt'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftcontrol', 'Left Ctrl', 'keyCtrl', 'control', [
            'ctrl',
            'control'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftshift', 'Left Shift', 'shift', 'shift', [
            'shift'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('option', 'Option', 'keyOption', 'option', [
            'opt'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightcontrol', 'Right Ctrl', 'keyCtrl', 'right control'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightshift', 'Right Shift', 'shift', 'right shift'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('space', 'Space Bar', 'keySpace', 'space', [
            'space bar',
            'spacebar'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('tab', 'Tab', 'keyTab'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('win', 'Windows', 'keyWindows', 'windows', [
            'windows'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('fn', 'Function', 'keyFn', 'function', [
            'function',
            'fn'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('menu', 'Menu', undefined, 'menu'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('printscreen', 'Print Screen', undefined, 'print screen', [
            'print screen'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('insert', 'Insert', undefined, 'insert'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('home', 'Home', undefined, 'home', [], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('end', 'End', undefined, 'end', [], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('pageup', 'Page Up', undefined, 'page up', [
            'page up'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('pagedown', 'Page Down', undefined, 'page down', [
            'page down'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_0', 'Numpad 0', 'key0', 'num pad zero'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_1', 'Numpad 1', 'key1', 'num pad one'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_2', 'Numpad 2', 'key2', 'num pad two'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_3', 'Numpad 3', 'key3', 'num pad three'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_4', 'Numpad 4', 'key4', 'num pad four'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_5', 'Numpad 5', 'key5', 'num pad five'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_6', 'Numpad 6', 'key6', 'num pad six'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_7', 'Numpad 7', 'key7', 'num pad seven'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_8', 'Numpad 8', 'key8', 'num pad eight'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_9', 'Numpad 9', 'key9', 'num pad nine'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_decimal', 'Numpad Decimal', 'keyDot', 'num pad decimal'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f1', 'F1', 'keyF1', 'function one'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f2', 'F2', 'keyF2', 'function two'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f3', 'F3', 'keyF3', 'function three'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f4', 'F4', 'keyF4', 'function four'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f5', 'F5', 'keyF5', 'function five'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f6', 'F6', 'keyF6', 'function six'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f7', 'F7', 'keyF7', 'function seven'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f8', 'F8', 'keyF8', 'function eight'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f9', 'F9', 'keyF9', 'function nine'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f10', 'F10', 'keyF10', 'function ten'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f11', 'F11', 'keyF11', 'function eleven'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f12', 'F12', 'keyF12', 'function twelve'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_mute', 'Mute Audio', undefined, 'mute audio', [
            'mute',
            'mute audio',
            'audio mute'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_vol_down', 'Volume Down', undefined, 'volume down', [
            'volume down'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_vol_up', 'Volume Up', undefined, 'volume up', [
            'volume up'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_play', 'Play Audio', undefined, 'play audio', [
            'play'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_stop', 'Stop Audio', undefined, 'stop audio', [
            'stop'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_pause', 'Pause Audio', undefined, 'pause audio', [
            'pause'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_prev', 'Previous Track', undefined, 'previous track', [
            'previous',
            'audio_prev'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_next', 'Next Track', undefined, 'next track', [
            'next'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_rewind', 'Rewind Track', undefined, 'rewind track', [
            'rewind'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_forward', 'Forward Track', undefined, 'forward track', [
            'forward'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_repeat', 'Repeat Track', undefined, 'repeat track', [
            'repeat'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_random', 'Shuffle Tracks', undefined, 'shuffle tracks', [
            'shuffle',
            'random'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_1', 'Controller Button 1 (A)', 'joystick', 'button one'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_2', 'Controller Button 2 (B)', 'joystick', 'button two'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_3', 'Controller Button 3 (X)', 'joystick', 'button three'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_4', 'Controller Button 4 (Y)', 'joystick', 'button four'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_5', 'Controller Button 5 (LB)', 'joystick', 'button five'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_6', 'Controller Button 6 (RB)', 'joystick', 'button six'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_7', 'Controller Button 7 (LT)', 'joystick', 'button seven'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_8', 'Controller Button 8 (RT)', 'joystick', 'button eight'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_9', 'Controller Button 9 (Options)', 'joystick', 'button nine'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_10', 'Controller Button 10 (Pause)', 'joystick', 'button ten'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_11', 'Controller Button 11 (L3)', 'joystick', 'button eleven'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_12', 'Controller Button 12 (R3)', 'joystick', 'button twelve'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_13', 'Controller D-Pad Up', 'joystick', 'direction up'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_14', 'Controller D-Pad Down', 'joystick', 'direction down'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_15', 'Controller D-Pad Left', 'joystick', 'direction left'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_16', 'Controller D-Pad Right', 'joystick', 'direction right')
    ],
    es: [
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_1', "Bot\xf3n 1 del Rat\xf3n (Clic Izquierdo)", 'mouseLeftClick', 'cliq', [
            'click',
            'left click'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_2', "Bot\xf3n 2 del Rat\xf3n (Clic Derecha)", 'mouseRightClick', 'cliq derecha'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_3', "Bot\xf3n 3 del Rat\xf3n (Clic Centro)", 'mouseMiddleClick', 'cliq centro'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('1', '1', 'key1', 'uno', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('2', '2', 'key2', 'dos', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('3', '3', 'key3', 'tres', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('4', '4', 'key4', 'cuatro', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('5', '5', 'key5', 'cinco', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('6', '6', 'key6', 'seis', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('7', '7', 'key7', 'siete', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('8', '8', 'key8', 'ocho', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('9', '9', 'key9', 'nueve', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('0', '0', 'key0', 'cero', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('a', 'a', 'keyA'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('b', 'b', 'keyB', 'be'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('c', 'c', 'keyC', 'se'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('d', 'd', 'keyD', 'de'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('e', 'e', 'keyE', 'eh'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f', 'f', 'keyF', 'efe'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('g', 'g', 'keyG', 'je'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('h', 'h', 'keyH', 'hace'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('i', 'i', 'keyI'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('j', 'j', 'keyJ', 'jota'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('k', 'k', 'keyK', 'ca'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('l', 'l', 'keyL', 'ele'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('m', 'm', 'keyM', 'eh me'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('n', 'n', 'keyN', 'en e'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('o', 'o', 'keyO'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('p', 'p', 'keyP', 'pe'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('q', 'q', 'keyQ'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('r', 'r', 'keyR', 'eh rey'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('s', 's', 'keyS', 'ese'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('t', 't', 'keyT', 'te'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('u', 'u', 'keyU'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('v', 'v', 'keyV', 've'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('w', 'w', 'keyW', 'doble ve'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('x', 'x', 'keyX', 'equis'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('y', 'y', 'keyY'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('z', 'z', 'keyZ', 'zeta'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('_', '_', undefined, 'guion bajo'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('-', '-', undefined, "gui\xf3n", [
            'subtract'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b(',', ',', undefined, 'coma', [
            'comma',
            'Comma (,)',
            ','
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b(';', ';', undefined, 'punto y coma'),
        $9a9874d925dad9cc$export$1042f3e960dd652b(':', ':', undefined, 'colon'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('?', '?', undefined, 'interrogante'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('.', '.', 'keyDot', 'punto'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('"', '"', undefined, 'comilla doble'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('(', '(', undefined, "par\xe9ntesis abierto"),
        $9a9874d925dad9cc$export$1042f3e960dd652b(')', ')', undefined, "par\xe9ntesis cerrado"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('[', '[', undefined, 'corchete abierto'),
        $9a9874d925dad9cc$export$1042f3e960dd652b(']', ']', undefined, 'corchete cerrado'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('{', '{', undefined, 'llave abierto'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('}', '}', undefined, 'llave cerrado'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('!', '!', undefined, "exclamaci\xf3n"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('@', '@', undefined, 'signo de a'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('*', '*', 'keyAsterisk', 'asterisco', [
            'multiply'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('/', '/', 'keySolidus', 'barra inclinada', [
            'divide'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('\\', '\\', undefined, 'barra invertida'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('&', '&', undefined, 'signo commercial'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('#', '#', 'keyHashtag', "signo de n\xfamero"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('%', '%', undefined, 'por ciento'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('`', '`', undefined, 'grave'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('^', '^', undefined, "signo de intercalaci\xf3n"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('+', '+', 'keyPlus', "m\xe1s", [
            'add'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('<', '<', 'keyLeftAngleParentheses', 'menos que'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('=', '=', 'keyEqual', 'igual'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('>', '>', 'keyRightAngleParentheses', 'mas grande que'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('|', '|', undefined, 'linea vertical'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('~', '~', undefined, 'til de'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('$', '$', undefined, "d\xf3lar"),
        $9a9874d925dad9cc$export$1042f3e960dd652b("'", "'", undefined, 'comilla simple'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('backspace', 'Backspace', 'keyDelete', 'retroceso', [
            'back space',
            'backspace'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('capslock', 'Caps', 'keyCapsLock', "bloq may\xfas", [
            'caps lock',
            'caps'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numlock', 'Num Lock', undefined, 'bloqueo numerico', [
            'num lock'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('scrolllock', 'Scroll Lock', undefined, 'bloqueo desplazamiento', [
            'scroll lock'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('cmd', 'Command', 'keyCommand', 'command', [
            'leftcmd',
            'command'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightcmd', 'Right Command', 'keyCommand', 'command derecha', [], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('delete', 'Delete', 'keyDelete', 'borrar'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('down', 'Flecha Abajo', 'keyPageDownButton', 'abajo', [
            'down arrow',
            'downarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('left', 'Flecha Izquierdo', 'keyHomeButton', 'izquierda', [
            'left arrow',
            'leftarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('right', 'Flecha Derecha', 'keyEndButton', 'derecha', [
            'right arrow',
            'rightarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('up', 'Flecha Arriba', 'keyPageUpButton', 'arriba', [
            'up arrow',
            'uparrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('enter', 'Enter', 'keyEnterMac', 'entrar', [
            'return'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('escape', 'Esc', 'keyEsc', 'escapar', [
            'esc'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftalt', 'Alt Izquierda', 'keyAlt', 'alt', [
            'alt'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftcontrol', 'Ctrl Izquierda', 'keyCtrl', 'control', [
            'ctrl',
            'control'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftshift', 'Shift Izquierda', 'shift', 'cambio', [
            'shift'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('option', 'Option', 'keyOption', "opci\xf3n", [
            'opt'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightcontrol', 'Ctrl Derecha', 'keyCtrl', 'control derecha'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightshift', 'Shift Derecha', 'shift', 'cambio derecha'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('space', 'Espacio', 'keySpace', 'espacio', [
            'space bar',
            'spacebar'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('tab', 'Tab', 'keyTab', "pesta\xf1a"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('win', 'Win', 'keyWindows', 'windows', [
            'windows'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('fn', 'Function', 'keyFn', "funci\xf3n", [
            'function',
            'fn'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('menu', 'Menu', undefined, 'menu'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('printscreen', 'Print Screen', undefined, 'imprimir pantalla', [
            'print screen'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('insert', 'Insert', undefined, 'insertar'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('home', 'Home', undefined, 'inicio', [], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('end', 'End', undefined, 'finalizar', [], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('pageup', 'Page Up', undefined, "p\xe1gina arriba", [
            'page up'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('pagedown', 'Page Down', undefined, "p\xe1gina abajo", [
            'page down'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_0', 'Numpad 0', 'key0', "n\xfamero cero"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_1', 'Numpad 1', 'key1', "n\xfamero uno"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_2', 'Numpad 2', 'key2', "n\xfamero dos"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_3', 'Numpad 3', 'key3', "n\xfamero tres"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_4', 'Numpad 4', 'key4', "n\xfamero cuatro"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_5', 'Numpad 5', 'key5', "n\xfamero cinco"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_6', 'Numpad 6', 'key6', "n\xfamero seis"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_7', 'Numpad 7', 'key7', "n\xfamero siete"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_8', 'Numpad 8', 'key8', "n\xfamero ocho"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_9', 'Numpad 9', 'key9', "n\xfamero nueve"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_decimal', 'Numpad Decimal', 'keyDot', "n\xfamero decimal"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f1', 'F1', 'keyF1', "funci\xf3n uno"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f2', 'F2', 'keyF2', "funci\xf3n dos"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f3', 'F3', 'keyF3', "funci\xf3n tres"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f4', 'F4', 'keyF4', "funci\xf3n cuatro"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f5', 'F5', 'keyF5', "funci\xf3n cinco"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f6', 'F6', 'keyF6', "funci\xf3n seis"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f7', 'F7', 'keyF7', "funci\xf3n siete"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f8', 'F8', 'keyF8', "funci\xf3n ocho"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f9', 'F9', 'keyF9', "funci\xf3n nueve"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f10', 'F10', 'keyF10', "funci\xf3n diez"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f11', 'F11', 'keyF11', "funci\xf3n once"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f12', 'F12', 'keyF12', "funci\xf3n doce"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_mute', 'Mute Audio', undefined, 'silenciar', [
            'mute',
            'mute audio',
            'audio mute'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_vol_down', 'Volume Down', undefined, 'baja volumen', [
            'volume down'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_vol_up', 'Volume Up', undefined, 'sube volumen', [
            'volume up'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_play', 'Play Audio', undefined, 'reproduce audio', [
            'play'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_stop', 'Stop Audio', undefined, 'detener audio', [
            'stop'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_pause', 'Pause Audio', undefined, 'pausa audio', [
            'pause'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_prev', 'Previous Track', undefined, 'pista anterior', [
            'previous',
            'audio_prev'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_next', 'Next Track', undefined, 'siguiente pista', [
            'next'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_rewind', 'Rewind Track', undefined, 'rebobinar pista', [
            'rewind'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_forward', 'Forward Track', undefined, 'avance pista', [
            'forward'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_repeat', 'Repeat Track', undefined, 'repita', [
            'repeat'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_random', 'Shuffle Tracks', undefined, 'aleatoriamente pistas', [
            'shuffle',
            'random'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_1', "Bot\xf3n 1 del Controlador (A)", 'joystick', "bot\xf3n uno"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_2', "Bot\xf3n 2 del Controlador (B)", 'joystick', "bot\xf3n dos"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_3', "Bot\xf3n 3 del Controlador (X)", 'joystick', "bot\xf3n tres"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_4', "Bot\xf3n 4 del Controlador (Y)", 'joystick', "bot\xf3n cuatro"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_5', "Bot\xf3n 5 del Controlador (LB)", 'joystick', "bot\xf3n cinco"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_6', "Bot\xf3n 6 del Controlador (RB)", 'joystick', "bot\xf3n seis"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_7', "Bot\xf3n 7 del Controlador (LT)", 'joystick', "bot\xf3n siete"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_8', "Bot\xf3n 8 del Controlador (RT)", 'joystick', "bot\xf3n ocho"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_9', "Bot\xf3n 8 del Controlador (Options)", 'joystick', "bot\xf3n nueve"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_10', "Bot\xf3n 10 del Controlador (Pause)", 'joystick', "bot\xf3n diez"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_11', "Bot\xf3n 11 del Controlador (L3)", 'joystick', "bot\xf3n once"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_12', "Bot\xf3n 12 del Controlador(R3)", 'joystick', "bot\xf3n doce"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_13', 'Controller D-Pad Arriba', 'joystick', "direcci\xf3n arriba"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_14', 'Controller D-Pad Abajo', 'joystick', "direcci\xf3n abajo"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_15', 'Controller D-Pad Izquierda', 'joystick', "direcci\xf3n izquierda"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_16', 'Controller D-Pad Derecha', 'joystick', "direcci\xf3n derecha")
    ],
    fr: [
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_1', 'Bouton 1 de la Souris (Clic Gauche)', 'mouseLeftClick', 'cliquez', [
            'click',
            'left click'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_2', 'Bouton 2 de la Souris (Clic Droit)', 'mouseRightClick', 'cli droit'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_3', 'Bouton 3 de la Souris (Clic Central)', 'mouseMiddleClick', 'clic central'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('1', '1', 'key1', 'un', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('2', '2', 'key2', 'deux', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('3', '3', 'key3', 'trois', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('4', '4', 'key4', 'quatre', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('5', '5', 'key5', 'cinq', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('6', '6', 'key6', 'six', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('7', '7', 'key7', 'sept', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('8', '8', 'key8', 'huit', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('9', '9', 'key9', 'neuf', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('0', '0', 'key0', "z\xe9ro", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('a', 'a', 'keyA', 'a'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('b', 'b', 'keyB'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('c', 'c', 'keyC'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('d', 'd', 'keyD'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('e', 'e', 'keyE'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f', 'f', 'keyF', 'effe'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('g', 'g', 'keyG'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('h', 'h', 'keyH', 'hache'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('i', 'i', 'keyI'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('j', 'j', 'keyJ'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('k', 'k', 'keyK', 'ca'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('l', 'l', 'keyL'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('m', 'm', 'keyM', 'eh me'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('n', 'n', 'keyN', 'en e'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('o', 'o', 'keyO'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('p', 'p', 'keyP', 'pe'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('q', 'q', 'keyQ', 'qu'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('r', 'r', 'keyR', 'eh re'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('s', 's', 'keyS', 'ese'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('t', 't', 'keyT', 'te'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('u', 'u', 'keyU', 'u'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('v', 'v', 'keyV', 've'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('w', 'w', 'keyW', 'doble ve'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('x', 'x', 'keyX', 'ics'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('y', 'y', 'keyY', 'i grec'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('z', 'z', 'keyZ'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('_', '_', undefined, 'souligner'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('-', '-', undefined, 'tiret', [
            'subtract'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b(',', ',', undefined, 'virgule', [
            'comma',
            'Comma (,)',
            ','
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b(';', ';', undefined, 'point virgule'),
        $9a9874d925dad9cc$export$1042f3e960dd652b(':', ':', undefined, "c\xf4lon"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('?', '?', undefined, "point d'interrogation"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('.', '.', 'keyDot', "p\xe9riode"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('"', '"', undefined, 'citation'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('(', '(', undefined, "parenth\xe8se ouverte"),
        $9a9874d925dad9cc$export$1042f3e960dd652b(')', ')', undefined, "fermer la parenth\xe8se"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('[', '[', undefined, 'accolade ouverte'),
        $9a9874d925dad9cc$export$1042f3e960dd652b(']', ']', undefined, "fermer \u013Eaccolade"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('{', '{', undefined, 'crochet ouvert'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('}', '}', undefined, 'fermer le crochet'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('!', '!', undefined, 'exclamation'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('@', '@', undefined, 'arobase'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('*', '*', 'keyAsterisk', "ast\xe9risque", [
            'multiply'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('/', '/', 'keySolidus', 'barre oblique', [
            'divide'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('\\', '\\', undefined, 'barre oblique inverse'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('&', '&', undefined, 'esperluette'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('#', '#', 'keyHashtag', 'hash tag'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('%', '%', undefined, 'pour cent'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('`', '`', undefined, "tique arri\xe8r"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('^', '^', undefined, 'carotte'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('+', '+', 'keyPlus', 'plus'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('<', '<', 'keyLeftAngleParentheses', 'moins que'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('=', '=', 'keyEqual', "est \xe9gal \xe0"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('>', '>', 'keyRightAngleParentheses', 'plus grand que'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('|', '|', undefined, 'tuyau'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('~', '~', undefined, 'til de'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('$', '$', undefined, 'signe dollar'),
        $9a9874d925dad9cc$export$1042f3e960dd652b("'", "'", undefined, 'guillemet simple'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('backspace', 'Backspace', 'keyDelete', "retour arri\xe8re", [
            'back space',
            'backspace'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('capslock', 'Caps', 'keyCapsLock', 'verrouillage des majuscules', [
            'caps lock',
            'caps'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numlock', 'Num Lock', undefined, "verrouillage num\xe9rique", [
            'num lock'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('scrolllock', 'Scroll Lock', undefined, "verrouillage du d\xe9filement", [
            'scroll lock'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('cmd', 'Command', 'keyCommand', 'commande', [
            'leftcmd',
            'command'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightcmd', 'Right Command', 'keyCommand', 'commande droite', [], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('delete', 'Delete', 'keyDelete', 'supprimer'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('down', 'Down Arrow', 'keyPageDownButton', 'descendre', [
            'down arrow',
            'downarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('left', 'Left Arrow', 'keyHomeButton', 'gauche', [
            'left arrow',
            'leftarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('right', 'Right Arrow', 'keyEndButton', 'droite', [
            'right arrow',
            'rightarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('up', 'Up Arrow', 'keyPageUpButton', 'monter', [
            'up arrow',
            'uparrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('enter', 'Enter', 'keyEnterMac', 'entrer', [
            'return'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('escape', 'Escape', 'keyEsc', "s\xe9chapper", [
            'esc'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftalt', 'Left Alt', 'keyAlt', 'alt', [
            'alt'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftcontrol', 'Left Ctrl', 'keyCtrl', "contr\xf4le", [
            'ctrl',
            'control'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftshift', 'Left Shift', 'shift', 'changement', [
            'shift'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('option', 'Option', 'keyOption', 'option', [
            'opt'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightcontrol', 'Right Ctrl', 'keyCtrl', "contr\xf4le droit"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightshift', 'Right Shift', 'shift', 'changement droit'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('space', 'Space Bar', 'keySpace', 'espace', [
            'space bar',
            'spacebar'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('tab', 'Tab', 'keyTab', 'languette'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('win', 'Windows', 'keyWindows', "fen\xeatres", [
            'windows'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('fn', 'Function', 'keyFn', 'fonction', [
            'function',
            'fn'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('menu', 'Menu', undefined, 'menu'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('printscreen', 'Print Screen', undefined, "\xe9cran d'impression", [
            'print screen'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('insert', 'Insert', undefined, "ins\xe9rer"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('home', 'Home', undefined, "d'accueil", [], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('end', 'End', undefined, 'fin', [], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('pageup', 'Page Up', undefined, "page pr\xe9c\xe9dente", [
            'page up'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('pagedown', 'Page Down', undefined, 'page suivante', [
            'page down'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_0', 'Numpad 0', 'key0', "pav\xe9 num\xe9rique z\xe9ro"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_1', 'Numpad 1', 'key1', "pav\xe9 num\xe9rique un"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_2', 'Numpad 2', 'key2', "pav\xe9 num\xe9rique deux"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_3', 'Numpad 3', 'key3', "pav\xe9 num\xe9rique trois"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_4', 'Numpad 4', 'key4', "pav\xe9 num\xe9rique quatre"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_5', 'Numpad 5', 'key5', "pav\xe9 num\xe9rique cinq"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_6', 'Numpad 6', 'key6', "pav\xe9 num\xe9rique six"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_7', 'Numpad 7', 'key7', "pav\xe9 num\xe9rique sept"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_8', 'Numpad 8', 'key8', "pav\xe9 num\xe9rique huit"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_9', 'Numpad 9', 'key9', "pav\xe9 num\xe9rique neuf"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_decimal', 'Numpad Decimal', 'keyDot', "pav\xe9 num\xe9rique d\xe9cimal"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f1', 'F1', 'keyF1', 'fonction un'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f2', 'F2', 'keyF2', 'fonction deux'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f3', 'F3', 'keyF3', 'fonction trois'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f4', 'F4', 'keyF4', 'fonction quatre'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f5', 'F5', 'keyF5', 'fonction cinq'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f6', 'F6', 'keyF6', 'fonction six'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f7', 'F7', 'keyF7', 'fonction sept'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f8', 'F8', 'keyF8', 'fonction huit'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f9', 'F9', 'keyF9', 'fonction neuf'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f10', 'F10', 'keyF10', 'fonction dix'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f11', 'F11', 'keyF11', 'fonction onze'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f12', 'F12', 'keyF12', 'fonction douze'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_mute', 'Mute Audio', undefined, 'couper son', [
            'mute',
            'mute audio',
            'audio mute'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_vol_down', 'Volume Down', undefined, 'baisser volume', [
            'volume down'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_vol_up', 'Volume Up', undefined, 'augmenter volume', [
            'volume up'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_play', 'Play Audio', undefined, 'lire son', [
            'play'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_stop', 'Stop Audio', undefined, "arr\xeater son", [
            'stop'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_pause', 'Pause Audio', undefined, 'mettre son pause', [
            'pause'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_prev', 'Previous Track', undefined, "piste pr\xe9c\xe9dente", [
            'previous',
            'audio_prev'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_next', 'Next Track', undefined, 'piste suivante', [
            'next'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_rewind', 'Rewind Track', undefined, 'rembobiner piste', [
            'rewind'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_forward', 'Forward Track', undefined, 'piste avant', [
            'forward'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_repeat', 'Repeat Track', undefined, "r\xe9p\xe9ter piste", [
            'repeat'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_random', 'Shuffle Tracks', undefined, "m\xe9langer pistes", [
            'shuffle',
            'random'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_1', "Bouton du Contr\xf4leur 1 (A)", 'joystick', 'bouton un'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_2', "Bouton du Contr\xf4leur 2 (B)", 'joystick', 'bouton deux'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_3', "Bouton du Contr\xf4leur 3 (X)", 'joystick', 'bouton trois'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_4', "Bouton du Contr\xf4leur 4 (Y)", 'joystick', 'bouton quatre'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_5', "Bouton du Contr\xf4leur 5 (LB)", 'joystick', 'bouton cinq'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_6', "Bouton du Contr\xf4leur 6 (RB)", 'joystick', 'bouton six'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_7', "Bouton du Contr\xf4leur 7 (LT)", 'joystick', 'bouton sept'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_8', "Bouton du Contr\xf4leur 8 (RT)", 'joystick', 'bouton huit'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_9', "Bouton du Contr\xf4leur 9 (Options)", 'joystick', 'bouton neuf'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_10', "Bouton du Contr\xf4leur 10 (Pause)", 'joystick', 'bouton dix'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_11', "Bouton du Contr\xf4leur 11 (L3)", 'joystick', 'bouton onze'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_12', "Bouton du Contr\xf4leur 12 (R3)", 'joystick', 'bouton douze'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_13', "Contr\xf4leur D-Pad En Haut", 'joystick', 'direction vers haut'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_14', "Contr\xf4leur D-Pad Vers le Bas", 'joystick', 'direction vers bas'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_15', "Contr\xf4leur D-Pad Gauche", 'joystick', 'direction gauche'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_16', "Contr\xf4leur D-Pad Droit", 'joystick', "direction \xe0 droite")
    ],
    it: [
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_1', 'Pulsante 1 Del Mouse (Clic Sinistro)', 'mouseLeftClick', 'clic', [
            'click',
            'left click'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_2', 'Pulsante 2 Del Mouse (Clic Destro)', 'mouseRightClick', 'clic destro'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_3', 'Pulsante 3 Del Mouse (Clic Centrale)', 'mouseMiddleClick', 'clic centrale'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('1', '1', 'key1', 'uno', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('2', '2', 'key2', 'due', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('3', '3', 'key3', 'tre', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('4', '4', 'key4', 'quattro', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('5', '5', 'key5', 'cinque', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('6', '6', 'key6', 'sei', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('7', '7', 'key7', 'sette', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('8', '8', 'key8', 'otto', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('9', '9', 'key9', 'nove', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('0', '0', 'key0', 'zero', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('a', 'A', 'keyA'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('b', 'B', 'keyB', 'bi'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('c', 'C', 'keyC', 'si'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('d', 'D', 'keyD', 'di'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('e', 'E', 'keyE'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f', 'F', 'keyF', 'efe'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('g', 'G', 'keyG', 'ji'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('h', 'H', 'keyH', 'acca'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('i', 'I', 'keyI'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('j', 'J', 'keyJ'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('k', 'K', 'keyK'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('l', 'L', 'keyL', 'ele'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('m', 'M', 'keyM', 'eh me'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('n', 'N', 'keyN', 'en e'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('o', 'O', 'keyO'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('p', 'P', 'keyP', 'pi'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('q', 'Q', 'keyQ', 'cu'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('r', 'R', 'keyR', 'eh re'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('s', 'S', 'keyS', 'ese'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('t', 'T', 'keyT', 'ti'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('u', 'U', 'keyU'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('v', 'V', 'keyV', 've'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('w', 'W', 'keyW', 'doppia ve'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('x', 'X', 'keyX', 'ics'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('y', 'Y', 'keyY', 'ipsilon'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('z', 'Z', 'keyZ', 'zeta'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('_', '_', undefined, 'trattino basso'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('-', '-', undefined, 'trattino', [
            'subtract'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b(',', ',', undefined, 'virgola', [
            'comma',
            'Comma (,)',
            ','
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b(';', ';', undefined, 'punto e virgola'),
        $9a9874d925dad9cc$export$1042f3e960dd652b(':', ':', undefined, 'due punti'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('?', '?', undefined, 'punto interrogativo'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('.', '.', 'keyDot', 'punto'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('"', '"', undefined, 'virgolette'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('(', '(', undefined, 'parentesi aperta'),
        $9a9874d925dad9cc$export$1042f3e960dd652b(')', ')', undefined, 'parentesi chiusa'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('[', '[', undefined, 'parentesi quadra aperta'),
        $9a9874d925dad9cc$export$1042f3e960dd652b(']', ']', undefined, 'parentesi quadra chiusa'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('{', '{', undefined, 'parentesi graffa aperta'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('}', '}', undefined, 'parentesi graffa chiusa'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('!', '!', undefined, 'punto esclamativo'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('@', '@', undefined, 'chiocciola'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('*', '*', 'keyAsterisk', 'asterisco', [
            'multiply'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('/', '/', 'keySolidus', 'barra', [
            'divide'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('\\', '\\', undefined, 'barra inversa'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('&', '&', undefined, 'e'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('#', '#', 'keyHashtag', 'cancelletto'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('%', '%', undefined, 'percentuale'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('`', '`', undefined, 'accento grave'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('^', '^', undefined, 'accento circonflesso'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('+', '+', undefined, "pi\xf9", [
            'add'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('<', '<', 'keyLeftAngleParentheses', 'minore di'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('=', '=', 'keyEqual', 'uguale'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('>', '>', 'keyRightAngleParentheses', 'maggiore di'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('|', '|', undefined, 'barra verticale'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('~', '~', undefined, 'til de'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('$', '$', undefined, 'dollaro'),
        $9a9874d925dad9cc$export$1042f3e960dd652b("'", "'", undefined, 'apostrofo'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('backspace', 'Indietro', 'keyDelete', 'indietro', [
            'back space',
            'backspace'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('capslock', 'Blocco Maiuscole', 'keyCapsLock', 'blocco maiuscole', [
            'caps lock',
            'caps'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numlock', 'Blocco Numerico', undefined, 'blocco numerico', [
            'num lock'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('scrolllock', 'Blocco Scorrimento', undefined, 'blocco scorrimento', [
            'scroll lock'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('cmd', 'Comando', 'keyCommand', 'comando', [
            'leftcmd',
            'command'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightcmd', 'Comando Destro', 'keyCommand', 'comando destro', [], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('delete', 'Cancella', 'keyDelete', 'eliminare'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('down', "Freccia Gi\xf9", 'keyPageDownButton', 'giu', [
            'down arrow',
            'downarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('left', 'Freccia Sinistra', 'keyHomeButton', 'sinistra', [
            'left arrow',
            'leftarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('right', 'Freccia Destra', 'keyEndButton', 'destra', [
            'right arrow',
            'rightarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('up', 'Freccia Su', 'keyPageUpButton', 'su', [
            'up arrow',
            'uparrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('enter', 'Entrare', 'keyEnterMac', 'entrare', [
            'return'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('escape', 'Fuga', 'keyEsc', 'fuga', [
            'esc'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftalt', 'Alt Sinistra', 'keyAlt', 'altra', [
            'alt'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftcontrol', 'Ctrl Sinistra', 'keyCtrl', 'controllo', [
            'ctrl',
            'control'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftshift', 'Shift Sinistra', 'shift', 'spostare', [
            'shift'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('option', 'Opzione', 'keyOption', 'opzione', [
            'opt'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightcontrol', 'Ctrl Destra', 'keyCtrl', 'control destra'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightshift', 'Shift Destra', 'shift', 'spostamento destra'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('space', 'Barra Spaziatrice', 'keySpace', 'spazio', [
            'space bar',
            'spacebar'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('tab', 'Tab', 'keyTab', 'scheda'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('win', 'Windows', 'keyWindows', 'finestre', [
            'windows'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('fn', 'Funzione', 'keyFn', 'funzione', [
            'function',
            'fn'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('menu', 'Menu', undefined, 'menu'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('printscreen', 'Print Screen', undefined, 'stampa schermo', [
            'print screen'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('insert', 'Insert', undefined, 'inserisci'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('home', 'Home', undefined, 'iniziale', [], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('end', 'End', undefined, 'fine', [], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('pageup', 'Pagina Su', undefined, 'pagina su', [
            'page up'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('pagedown', "Pagina Gi\xf9", undefined, "pagina gi\xf9", [
            'page down'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_0', 'Numpad 0', 'key0', 'tastierino numerico zero'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_1', 'Numpad 1', 'key1', 'tastierino numerico uno'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_2', 'Numpad 2', 'key2', 'tastierino numerico due'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_3', 'Numpad 3', 'key3', 'tastierino numerico tre'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_4', 'Numpad 4', 'key4', 'tastierino numerico quattro'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_5', 'Numpad 5', 'key5', 'tastierino numerico cinque'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_6', 'Numpad 6', 'key6', 'tastierino numerico sei'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_7', 'Numpad 7', 'key7', 'tastierino numerico sette'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_8', 'Numpad 8', 'key8', 'tastierino numerico otto'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_9', 'Numpad 9', 'key9', 'tastierino numerico nove'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_decimal', 'Numpad Decimale', 'keyDot', 'tastierino numerico decimale'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f1', 'F1', 'keyF1', 'funzione uno'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f2', 'F2', 'keyF2', 'funzione due'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f3', 'F3', 'keyF3', 'funzione tre'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f4', 'F4', 'keyF4', 'funzione quattro'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f5', 'F5', 'keyF5', 'funzione cinque'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f6', 'F6', 'keyF6', 'funzione sei'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f7', 'F7', 'keyF7', 'funzione sette'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f8', 'F8', 'keyF8', 'funzione otto'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f9', 'F9', 'keyF9', 'funzione nove'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f10', 'F10', 'keyF10', 'funzione dieci'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f11', 'F11', 'keyF11', 'funzione undici'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f12', 'F12', 'keyF12', 'funzione dodici'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_mute', 'Disattiva Audio', undefined, 'disattiva audio', [
            'mute',
            'mute audio',
            'audio mute'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_vol_down', "Volume Gi\xf9", undefined, "volume gi\xf9", [
            'volume down'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_vol_up', 'Volume Su', undefined, 'volume su', [
            'volume up'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_play', 'Riproduci Audio', undefined, 'riproduci audio', [
            'play'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_stop', 'Ferma Audio', undefined, 'ferma audio', [
            'stop'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_pause', 'Pausa Audio', undefined, 'pausa audio', [
            'pause'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_prev', 'Traccia Precedente', undefined, 'traccia precedente', [
            'previous',
            'audio_prev'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_next', 'Traccia Successiva', undefined, 'traccia successiva', [
            'next'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_rewind', 'Riavvolgi Traccia', undefined, 'riavvolgi traccia', [
            'rewind'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_forward', 'Avanza Traccia', undefined, 'avanza traccia', [
            'forward'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_repeat', 'Ripeti Traccia', undefined, 'ripeti traccia', [
            'repeat'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_random', 'Riproduzione Casuale', undefined, 'riproduzione casuale', [
            'shuffle',
            'random'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_1', 'Pulsante 1 Del Controller (A)', 'joystick', 'pulsante uno'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_2', 'Pulsante 2 Del Controller (B)', 'joystick', 'pulsante due'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_3', 'Pulsante 3 Del Controller (X)', 'joystick', 'pulsante tre'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_4', 'Pulsante 4 Del Controller (Y)', 'joystick', 'pulsante quattro'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_5', 'Pulsante 5 Del Controller (LB)', 'joystick', 'pulsante cinque'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_6', 'Pulsante 6 Del Controller (RB)', 'joystick', 'pulsante sei'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_7', 'Pulsante 7 Del Controller (LT)', 'joystick', 'pulsante sette'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_8', 'Pulsante 8 Del Controller (RT)', 'joystick', 'pulsante otto'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_9', 'Pulsante 9 Del Controller (Opzioni)', 'joystick', 'pulsante nove'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_10', 'Pulsante 10 Del Controller (Pausa)', 'joystick', 'pulsante dieci'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_11', 'Pulsante 11 Del Controller (L3)', 'joystick', 'pulsante undici'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_12', 'Pulsante 12 Del Controller (R3)', 'joystick', 'pulsante dodici'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_13', 'Controller D-Pad Su', 'joystick', 'direzione su'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_14', "Controller D-Pad Gi\xf9", 'joystick', "direzione gi\xf9"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_15', 'Controller D-Pad Sinistra', 'joystick', 'direzione sinistra'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_16', 'Controller D-Pad Destra', 'joystick', 'direzione destra')
    ],
    de: [
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_1', 'Maustaste 1 (linksklick)', 'mouseLeftClick', 'klicken', [
            'click',
            'left click'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_2', 'Maustaste 2 (rechtsklick)', 'mouseRightClick', 'rechtsklick', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_3', 'Maustaste 3 (mittlerer Klick)', 'mouseMiddleClick', 'mittlerer klick', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('1', '1', 'key1', 'eins', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('2', '2', 'key2', 'zwei', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('3', '3', 'key3', 'drei', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('4', '4', 'key4', 'vier', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('5', '5', 'key5', "f\xfcnf", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('6', '6', 'key6', 'sechs', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('7', '7', 'key7', 'sieben', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('8', '8', 'key8', 'acht', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('9', '9', 'key9', 'neun', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('0', '0', 'key0', 'null', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('a', 'A', 'keyA', 'a', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('b', 'B', 'keyB', 'b', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('c', 'C', 'keyC', 'c', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('d', 'D', 'keyD', 'd', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('e', 'Und', 'keyE', 'e', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f', 'F', 'keyF', 'ef', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('g', 'G', 'keyG', 'ge', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('h', 'H', 'keyH', 'ha', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('i', 'Ich', 'keyI', 'ee', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('j', 'J', 'keyJ', 'yot', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('k', 'K', 'keyK', 'ca', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('l', 'M', 'keyL', 'l', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('m', 'M', 'keyM', 'em', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('n', 'N', 'keyN', 'n', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('o', 'Die', 'keyO', 'oh', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('p', 'P', 'keyP', 'p', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('q', 'Q', 'keyQ', 'koo', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('r', 'R', 'keyR', 'r', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('s', 'S', 'keyS', 's', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('t', 'T', 'keyT', 't', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('u', 'In', 'keyU', 'u', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('v', 'V', 'keyV', 'vow', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('w', 'In', 'keyW', 'vee', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('x', 'X', 'keyX', 'iks', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('y', 'Und', 'keyY', 'oopsilohn', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('z', 'Mit', 'keyZ', 'zet', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('_', '_', 'keySpace', 'unterstreichen', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('-', '-', 'keySpace', 'bindestrich', [
            'subtract'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b(',', ',', 'keySpace', 'komma', [
            'comma',
            'Comma (,)',
            ','
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b(';', ';', 'keySpace', 'semi kolon', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b(':', ':', 'keySpace', 'doppelpunkt', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('?', '?', 'keySpace', 'fragezeichen', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('.', '.', 'keyDot', 'zeitraum', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('"', '"', 'keySpace', 'zitat', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('(', '(', 'keySpace', "\xf6ffnende klammer", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b(')', ')', 'keySpace', "schlie\xdfende klammer", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('[', '[', 'keySpace', "\xf6ffnende eckige klammer", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b(']', ']', 'keySpace', "schlie\xdfende eckige klammer", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('{', '{', 'keySpace', "offene st\xfctzstrebe", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('}', '}', 'keySpace', "schlie\xdfen st\xfctzbandage", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('!', '!', 'keySpace', 'ausruf', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('@', '@', 'keySpace', 'at zeichen', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('*', '*', 'keyAsterisk', 'sternchen', [
            'multiply'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('/', '/', 'keySolidus', "schr\xe4gstrich", [
            'divide'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('\\', '\\', 'keySpace', "umgekehrter schr\xe4gstrich", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('&', 'Und', 'keySpace', "kaufm\xe4nnisches und zeichen", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('#', '#', 'keyHashtag', 'pfund', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('%', '%', 'keySpace', 'prozent', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('`', '`', 'keySpace', "zur\xfcck h\xe4kchen", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('^', '^', 'keySpace', 'karotte', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('+', '+', 'keySpace', 'plus', [
            'add'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('<', '<', 'keyLeftAngleParentheses', 'weniger als', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('=', '=', 'keyEqual', 'ist gleich', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('>', '>', 'keyRightAngleParentheses', "gr\xf6\xdfer als", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('|', '|', 'keySpace', 'rohr', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('~', '~', 'keySpace', 'zu ihnen', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('$', '$', 'keySpace', 'dollarzeichen', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b("'", "'", 'keySpace', "einfaches anf\xfchrungszeichen", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('backspace', "R\xfccktaste", 'keyDelete', "r\xfccktaste", [
            'back space',
            'backspace'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('capslock', 'Kappen', 'keyCapsLock', 'feststelltaste', [
            'caps lock',
            'caps'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numlock', 'Num Lock', 'keySpace', 'zahlenschloss', [
            'num lock'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('scrolllock', 'Rollen-taste', 'keySpace', 'rollen taste', [
            'scroll lock'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('cmd', 'Befehl', 'keyCommand', 'befehl', [
            'leftcmd',
            'command'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightcmd', 'Richtiger Befehl', 'keyCommand', 'richtiger befehl', [], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('delete', "L\xf6schen", 'keyDelete', "l\xf6schen", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('down', 'Pfeil Nach Unten', 'keyPageDownButton', 'nach unten', [
            'down arrow',
            'downarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('left', 'Pfeil Nach Links', 'keyHomeButton', 'nach links gehen', [
            'left arrow',
            'leftarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('right', 'Pfeil Nach Rechts', 'keyEndButton', 'nach rechts gehen', [
            'right arrow',
            'rightarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('up', 'Pfeil Nach Oben', 'keyPageUpButton', 'nach oben', [
            'up arrow',
            'uparrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('enter', 'Eingeben', 'keyEnterMac', 'eingeben', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('escape', 'Flucht', 'keyEsc', 'flucht', [
            'esc'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftalt', 'Linke Alt-taste', 'keyAlt', 'alle', [
            'alt'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftcontrol', 'Linke Strg-taste', 'keyCtrl', 'kontrolle', [
            'ctrl',
            'control'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftshift', 'Linksverschiebung', 'shift', 'schicht', [
            'shift'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('option', 'Option', 'keyOption', 'option', [
            'opt'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightcontrol', 'Rechte Strg-taste', 'keyCtrl', 'rechte kontrolle', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightshift', 'Rechtsverschiebung', 'shift', 'rechtsverschiebung', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('space', 'Leertaste', 'keySpace', 'raum', [
            'space bar',
            'spacebar'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('tab', 'Tab', 'keyTab', 'tab', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('win', 'Windows', 'keyWindows', 'fenster', [
            'windows'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('fn', 'Funktion', 'keyFn', 'funktion', [
            'function',
            'fn'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('menu', 'Speisekarte', 'keySpace', 'speisekarte', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('printscreen', 'Bildschirm Drucken', 'keySpace', 'bildschirm drucken', [
            'print screen'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('insert', "Einf\xfcgen", 'keySpace', "einf\xfcgen", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('home', 'Heim', 'keySpace', 'heim', [], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('end', 'Ende', 'keySpace', 'ende', [], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('pageup', 'Bild Nach Oben', 'keySpace', 'bild nach oben', [
            'page up'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('pagedown', 'Bild Ab', 'keySpace', 'bild ab', [
            'page down'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_0', 'Numpad 0', 'key0', 'nummernblock null', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_1', 'Numpad 1', 'key1', 'nummernblock eins', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_2', 'Numpad 2', 'key2', 'nummernblock zwei', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_3', 'Numpad 3', 'key3', 'nummernblock drei', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_4', 'Numpad 4', 'key4', 'nummernblock vier', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_5', 'Numpad 5', 'key5', "nummernblock f\xfcnf", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_6', 'Numpad 6', 'key6', 'nummernblock sechs', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_7', 'Numpad 7', 'key7', 'nummernblock sieben', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_8', 'Numpad 8', 'key8', 'nummernblock acht', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_9', 'Numpad 9', 'key9', 'nummernblock neun', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_decimal', 'Numpad Dezimal', 'keyDot', 'nummernblock dezimal', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f1', 'F1', 'keyF1', 'funktion eins', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f2', 'F2', 'keyF2', 'funktion zwei', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f3', 'F3', 'keyF3', 'funktion drei', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f4', 'F4', 'keyF4', 'funktion vier', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f5', 'F5', 'keyF5', "funktion f\xfcnf", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f6', 'F6', 'keyF6', 'funktion sechs', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f7', 'F7', 'keyF7', 'funktion sieben', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f8', 'F8', 'keyF8', 'funktion acht', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f9', 'F9', 'keyF9', 'funktion neun', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f10', 'F10', 'keyF10', 'funktion zehn', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f11', 'F11', 'keyF11', 'funktion elf', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f12', 'F12', 'keyF12', "funktion zw\xf6lf", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_mute', 'Audio Stumm Schalten', 'keySpace', 'audio stumm schalten', [
            'mute',
            'mute audio',
            'audio mute'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_vol_down', "Lautst\xe4rke Verringern", 'keySpace', "lautst\xe4rke verringern", [
            'volume down'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_vol_up', "Lautst\xe4rke Erh\xf6hen", 'keySpace', "lautst\xe4rke erh\xf6hen", [
            'volume up'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_play', 'Audio Abspielen', 'keySpace', 'audio abspielen', [
            'play'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_stop', 'Audio Stoppen', 'keySpace', 'audio stoppen', [
            'stop'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_pause', 'Pause Audio', 'keySpace', 'audio anhalten', [
            'pause'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_prev', 'Vorheriger Titel', 'keySpace', 'vorheriger titel', [
            'previous',
            'audio_prev'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_next', "N\xe4chster Titel", 'keySpace', "n\xe4chstes st\xfcck", [
            'next'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_rewind', "Titel Zur\xfcckspulen", 'keySpace', "titel zur\xfcckspulen", [
            'rewind'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_forward', "Vorw\xe4rts-track", 'keySpace', "vorw\xe4rts verfolgen", [
            'forward'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_repeat', 'Titel Wiederholen', 'keySpace', 'titel wiederholen', [
            'repeat'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_random', 'Zufallswiedergabe Von Titeln', 'keySpace', 'zufallswiedergabe von titeln', [
            'shuffle',
            'random'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_1', 'Controller-taste 1 (a)', 'joystick', 'taste eins', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_2', 'Controller-taste 2 (b)', 'joystick', 'taste zwei', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_3', 'Controller-taste 3 (x)', 'joystick', 'taste drei', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_4', 'Controller-taste 4 (y)', 'joystick', 'taste vier', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_5', 'Controller-taste 5 (lb)', 'joystick', "taste f\xfcnf", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_6', 'Controller-taste 6 (rb)', 'joystick', 'taste sechs', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_7', 'Controller-taste 7 (lt)', 'joystick', 'taste sieben', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_8', 'Controller-taste 8 (rt)', 'joystick', 'taste acht', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_9', 'Controller-taste 9 (optionen)', 'joystick', 'taste neun', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_10', 'Controller-taste 10 (pause)', 'joystick', 'taste zehn', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_11', 'Controller-taste 11 (l3)', 'joystick', 'taste elf', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_12', 'Controller-taste 12 (r3)', 'joystick', "taste zw\xf6lf", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_13', 'Controller D-pad Nach Oben', 'joystick', 'richtung nach oben', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_14', 'Controller D-pad Nach Unten', 'joystick', 'richtung nach unten', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_15', 'Controller D-pad Links', 'joystick', 'richtung links', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_16', 'Controller D-pad Rechts', 'joystick', 'richtung rechts', [])
    ],
    ja: [
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_1', "\u30DE\u30A6\u30B9\u30DC\u30BF\u30F31\uFF08\u5DE6\u30AF\u30EA\u30C3\u30AF\uFF09", 'mouseLeftClick', "\u30AF\u30EA\u30C3\u30AF", [
            'click',
            'left click'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_2', "\u30DE\u30A6\u30B9\u30DC\u30BF\u30F32\uFF08\u53F3\u30AF\u30EA\u30C3\u30AF\uFF09", 'mouseRightClick', "\u53F3\u30AF\u30EA\u30C3\u30AF", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_3', "\u30DE\u30A6\u30B9\u30DC\u30BF\u30F33\uFF08\u4E2D\u592E\u30AF\u30EA\u30C3\u30AF\uFF09", 'mouseMiddleClick', "\u4E2D\u30AF\u30EA\u30C3\u30AF", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('1', '1', 'key1', "\u3044\u3061", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('2', '2', 'key2', "\u306B", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('3', '3', 'key3', "\u3055\u3093", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('4', '4', 'key4', "\u3088\u3093", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('5', '5', 'key5', "\u3054", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('6', '6', 'key6', "\u308D\u304F", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('7', '7', 'key7', "\u306A\u306A", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('8', '8', 'key8', "\u306F\u3061", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('9', '9', 'key9', "\u304D\u3085\u3046", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('0', '0', 'key0', "\u305C\u308D", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('a', 'A', 'keyA', "\u3048\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('b', 'B', 'keyB', "\u3073\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('c', 'C', 'keyC', "\u3057\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('d', 'D', 'keyD', "\u3067\u3043\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('e', 'E', 'keyE', "\u3044\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f', 'F', 'keyF', "\u3048\u3075", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('g', 'G', 'keyG', "\u3058\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('h', 'H', 'keyH', "\u3048\u3044\u3061", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('i', 'I', 'keyI', "\u3042\u3044", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('j', 'J', 'keyJ', "\u3058\u3047\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('k', 'K', 'keyK', "\u3051\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('l', 'L', 'keyL', "\u3048\u308B", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('m', 'M', 'keyM', "\u3048\u3080", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('n', 'N', 'keyN', "\u3048\u306C", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('o', 'O', 'keyO', "\u304A\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('p', 'P', 'keyP', "\u3074\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('q', 'Q', 'keyQ', "\u304D\u3085\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('r', 'R', 'keyR', "\u3042\u30FC\u308B", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('s', 'S', 'keyS', "\u3048\u3059", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('t', 'T', 'keyT', "\u3066\u3043\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('u', 'U', 'keyU', "\u3086\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('v', 'V', 'keyV', "\u3076\u3044", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('w', 'W', 'keyW', "\u3060\u3076\u308A\u3085\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('x', 'X', 'keyX', "\u3048\u3063\u304F\u3059", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('y', 'Y', 'keyY', "\u308F\u3044", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('z', 'Z', 'keyZ', "\u305C\u3063\u3068", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('_', '_', 'keySpace', "\u30A2\u30F3\u30C0\u30FC\u30B9\u30B3\u30A2", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('-', '-', 'keySpace', "\u30C0\u30C3\u30B7\u30E5", [
            'subtract'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b(',', "\u3001", 'keySpace', "\u30B3\u30F3\u30DE", [
            'comma',
            'Comma (,)',
            ','
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b(';', ';', 'keySpace', "\u30BB\u30DF\u30B3\u30ED\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b(':', ':', 'keySpace', "\u30B3\u30EA\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('?', '?', 'keySpace', "\u306F\u3066\u306A", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('.', '.', 'keyDot', "\u30D4\u30EA\u30AA\u30C9", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('"', '"', 'keySpace', "\u30AF\u30A9\u30FC\u30C6\u30FC\u30B7\u30E7\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('(', "\uFF08", 'keySpace', "\u304B\u3063\u3053", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b(')', "\uFF09", 'keySpace', "\u9589\u3058\u308B\u304B\u3063\u3053", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('[', '[', 'keySpace', "\u958B\u304F\u30D6\u30E9\u30B1\u30C3\u30C8", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b(']', ']', 'keySpace', "\u9589\u3058\u308B\u30D6\u30E9\u30B1\u30C3\u30C8", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('{', '{', 'keySpace', "\u958B\u304F\u30AB\u30FC\u30EA\u30FC\u30D6\u30E9\u30B1\u30C3\u30C8", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('}', '}', 'keySpace', "\u9589\u3058\u308B\u30AB\u30FC\u30EA\u30FC\u30D6\u30E9\u30B1\u30C3\u30C8", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('!', "\uFF01", 'keySpace', "\u3073\u3063\u304F\u308A", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('@', '@', 'keySpace', "\u30A2\u30C3\u30C8\u30DE\u30FC\u30AF", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('*', '*', 'keyAsterisk', "\u30A2\u30B9\u30BF\u30EA\u30B9\u30AF", [
            'multiply'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('/', '/', 'keySolidus', "\u30B9\u30E9\u30C3\u30B7\u30E5", [
            'divide'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('\\', '\\', 'keySpace', "\u30D0\u30C3\u30AF\u30B9\u30E9\u30C3\u30B7\u30E5", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('&', "\uFF06", 'keySpace', "\u30A2\u30F3\u30D1\u30B5\u30F3\u30C9", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('#', '#', 'keyHashtag', "\u30B7\u30E3\u30FC\u30D7", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('%', '%', 'keySpace', "\u30D1\u30FC\u30BB\u30F3\u30C8", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('`', '`', 'keySpace', "\u30D0\u30C3\u30AF\u30AF\u30A9\u30FC\u30C8", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('^', '^', 'keySpace', "\u30AD\u30E3\u30EC\u30C3\u30C8", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('+', '+', 'keySpace', "\u30D7\u30E9\u30B9", [
            'add'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('<', '<', 'keyLeftAngleParentheses', "\u3088\u308A\u5C0F\u3055\u3044", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('=', '=', 'keyEqual', "\u30A4\u30B3\u30FC\u30EB", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('>', '>', 'keyRightAngleParentheses', "\u3088\u308A\u5927\u304D\u3044", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('|', '|', 'keySpace', "\u30D1\u30A4\u30D7", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('~', "\u301C", 'keySpace', "\u30C1\u30EB\u30C0", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('$', '$', 'keySpace', "\u30C9\u30EB\u8A18\u53F7", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b("'", "'", 'keySpace', "\u30C9\u30EB", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('backspace', "\u30D0\u30C3\u30AF\u30B9\u30DA\u30FC\u30B9", 'keyDelete', "\u30D0\u30C3\u30AF\u30B9\u30DA\u30FC\u30B9", [
            'back space',
            'backspace'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('capslock', "\u30AD\u30E3\u30D7\u30B9\u30ED\u30C3\u30AF", 'keyCapsLock', "\u30AD\u30E3\u30C3\u30D7\u30B9\u30ED\u30C3\u30AF", [
            'caps lock',
            'caps'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numlock', "\u30CA\u30E0\u30ED\u30C3\u30AF", 'keySpace', "num\u30ED\u30C3\u30AF", [
            'num lock'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('scrolllock', "\u30B9\u30AF\u30ED\u30FC\u30EB\u30ED\u30C3\u30AF", 'keySpace', "\u30B9\u30AF\u30ED\u30FC\u30EB\u30ED\u30C3\u30AF", [
            'scroll lock'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('cmd', "\u30B3\u30DE\u30F3\u30C9", 'keyCommand', "\u30B3\u30DE\u30F3\u30C9", [
            'leftcmd',
            'command'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightcmd', "\u53F3\u30B3\u30DE\u30F3\u30C9", 'keyCommand', "\u53F3\u30B3\u30DE\u30F3\u30C9", [], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('delete', "\u30C7\u30EA\u30FC\u30C8", 'keyDelete', "\u30C7\u30EA\u30FC\u30C8", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('down', "\u3057\u305F", 'keyPageDownButton', "\u3057\u305F", [
            'down arrow',
            'downarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('left', "\u3072\u3060\u308A", 'keyHomeButton', "\u3072\u3060\u308A", [
            'left arrow',
            'leftarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('right', "\u307F\u304E", 'keyEndButton', "\u307F\u304E", [
            'right arrow',
            'rightarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('up', "\u3046\u3048", 'keyPageUpButton', "\u3046\u3048", [
            'up arrow',
            'uparrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('enter', "\u5165\u529B", 'keyEnterMac', "\u5165\u529B", [
            'return'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('escape', "\u30A8\u30B9\u30B1\u30FC\u30D7", 'keyEsc', "\u30A8\u30B9\u30B1\u30FC\u30D7", [
            'esc'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftalt', "\u5DE6\u30AA\u30EB\u30C8", 'keyAlt', "\u5DE6\u30AA\u30EB\u30C8", [
            'alt'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftcontrol', "\u5DE6\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB", 'keyCtrl', "\u5DE6\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB", [
            'ctrl',
            'control'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftshift', "\u5DE6\u30B7\u30D5\u30C8", 'shift', "\u5DE6\u30B7\u30D5\u30C8", [
            'shift'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('option', "\u30AA\u30D7\u30B7\u30E7\u30F3", 'keyOption', "\u30AA\u30D7\u30B7\u30E7\u30F3", [
            'opt'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightcontrol', "\u53F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB", 'keyCtrl', "\u53F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightshift', "\u53F3\u30B7\u30D5\u30C8", 'shift', "\u53F3\u30B7\u30D5\u30C8", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('space', "\u30B9\u30DA\u30FC\u30B9", 'keySpace', "\u30B9\u30DA\u30FC\u30B9", [
            'space bar',
            'spacebar'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('tab', "\u30BF\u30D6", 'keyTab', "\u30BF\u30D6", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('win', "\u30A6\u30A3\u30F3\u30C9\u30A6\u30BA", 'keyWindows', "\u30A6\u30A3\u30F3\u30C9\u30A6\u30BA", [
            'windows'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('fn', "\u30D5\u30A1\u30F3\u30AF\u30B7\u30E7\u30F3", 'keyFn', "\u30D5\u30A1\u30F3\u30AF\u30B7\u30E7\u30F3", [
            'function',
            'fn'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('menu', "\u30E1\u30CB\u30E5\u30FC", 'keySpace', "\u30E1\u30CB\u30E5\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('printscreen', "\u30D7\u30EA\u30F3\u30C8\u30B9\u30AF\u30EA\u30FC\u30F3", 'keySpace', "\u30D7\u30EA\u30F3\u30C8\u30B9\u30AF\u30EA\u30FC\u30F3", [
            'print screen'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('insert', "\u30A4\u30F3\u30B5\u30FC\u30C8", 'keySpace', "\u30A4\u30F3\u30B5\u30FC\u30C8", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('home', "\u30DB\u30FC\u30E0", 'keySpace', "\u30DB\u30FC\u30E0", [], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('end', "\u30A8\u30F3\u30C9", 'keySpace', "\u30A8\u30F3\u30C9", [], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('pageup', "\u30DA\u30FC\u30B8\u30A2\u30C3\u30D7", 'keySpace', "\u30DA\u30FC\u30B8\u30A2\u30C3\u30D7", [
            'page up'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('pagedown', "\u30DA\u30FC\u30B8\u30C0\u30A6\u30F3", 'keySpace', "\u30DA\u30FC\u30B8\u30C0\u30A6\u30F3", [
            'page down'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_0', "\u30C6\u30F3\u30AD\u30FC0", 'key0', "\u30C6\u30F3\u30AD\u30FC\u30BC\u30ED", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_1', "\u30C6\u30F3\u30AD\u30FC1", 'key1', "\u30C6\u30F3\u30AD\u30FC\u3044\u3061", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_2', "\u30C6\u30F3\u30AD\u30FC2", 'key2', "\u30C6\u30F3\u30AD\u30FC\u306B", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_3', "\u30C6\u30F3\u30AD\u30FC3", 'key3', "\u30C6\u30F3\u30AD\u30FC\u3055\u3093", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_4', "\u30C6\u30F3\u30AD\u30FC4", 'key4', "\u30C6\u30F3\u30AD\u30FC\u3088\u3093", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_5', "\u30C6\u30F3\u30AD\u30FC5", 'key5', "\u30C6\u30F3\u30AD\u30FC\u3054", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_6', "\u30C6\u30F3\u30AD\u30FC6", 'key6', "\u30C6\u30F3\u30AD\u30FC\u308D\u304F", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_7', "\u30C6\u30F3\u30AD\u30FC7", 'key7', "\u30C6\u30F3\u30AD\u30FC\u306A\u306A", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_8', "\u30C6\u30F3\u30AD\u30FC8", 'key8', "\u30C6\u30F3\u30AD\u30FC\u306F\u3061", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_9', "\u30C6\u30F3\u30AD\u30FC9", 'key9', "\u30C6\u30F3\u30AD\u30FC\u304D\u3085\u3046", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_decimal', "\u30C6\u30F3\u30AD\u30FC\u5C0F\u6570\u70B9", 'keyDot', "\u30C6\u30F3\u30AD\u30FC\u3057\u3087\u3046\u3059\u3046\u3066\u3093", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f1', 'F1', 'keyF1', "\u30A8\u30D5\u30EF\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f2', 'F2', 'keyF2', "\u30A8\u30D5\u30C4\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f3', 'F3', 'keyF3', "\u30A8\u30D5\u30B9\u30EA\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f4', 'F4', 'keyF4', "\u30A8\u30D5\u30D5\u30A9\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f5', 'F5', 'keyF5', "\u30A8\u30D5\u30D5\u30A1\u30A4\u30D6", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f6', 'F6', 'keyF6', "\u30A8\u30D5\u30B7\u30C3\u30AF\u30B9", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f7', 'F7', 'keyF7', "\u30A8\u30D5\u30BB\u30D6\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f8', 'F8', 'keyF8', "\u30A8\u30D5\u30A8\u30A4\u30C8", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f9', 'F9', 'keyF9', "\u30A8\u30D5\u30CA\u30A4\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f10', 'F10', 'keyF10', "\u30A8\u30D5\u30C6\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f11', 'F11', 'keyF11', "\u30A8\u30D5\u30A4\u30EC\u30D6\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f12', 'F12', 'keyF12', "\u30A8\u30D5\u30C8\u30A5\u30A8\u30EB\u30D6", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_mute', "\u97F3\u58F0\u3092\u30DF\u30E5\u30FC\u30C8\u3059\u308B", 'keySpace', "\u30DF\u30E5\u30FC\u30C8", [
            'mute',
            'mute audio',
            'audio mute'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_vol_down', "\u97F3\u91CF\u3092\u4E0B\u3052\u308B", 'keySpace', "\u30DC\u30EA\u30E5\u30FC\u30E0\u30C0\u30A6\u30F3", [
            'volume down'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_vol_up', "\u97F3\u91CF\u3092\u4E0A\u3052\u308B", 'keySpace', "\u30DC\u30EA\u30E5\u30FC\u30E0\u30A2\u30C3\u30D7", [
            'volume up'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_play', "\u30AA\u30FC\u30C7\u30A3\u30AA\u3092\u518D\u751F", 'keySpace', "\u518D\u751F", [
            'play'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_stop', "\u97F3\u58F0\u3092\u505C\u6B62", 'keySpace', "\u505C\u6B62", [
            'stop'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_pause', "\u97F3\u58F0\u3092\u4E00\u6642\u505C\u6B62", 'keySpace', "\u97F3\u58F0\u3092\u4E00\u6642\u505C\u6B62", [
            'pause'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_prev', "\u524D\u306E\u30C8\u30E9\u30C3\u30AF", 'keySpace', "\u524D\u306E\u30C8\u30E9\u30C3\u30AF", [
            'previous',
            'audio_prev'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_next', "\u6B21\u306E\u30C8\u30E9\u30C3\u30AF", 'keySpace', "\u6B21\u306E\u30C8\u30E9\u30C3\u30AF", [
            'next'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_rewind', "\u30C8\u30E9\u30C3\u30AF\u3092\u5DFB\u304D\u623B\u3059", 'keySpace', "\u5DFB\u304D\u623B\u3057", [
            'rewind'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_forward', "\u524D\u9032\u8ECC\u9053", 'keySpace', "\u65E9\u9001\u308A", [
            'forward'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_repeat', "\u30C8\u30E9\u30C3\u30AF\u3092\u7E70\u308A\u8FD4\u3059", 'keySpace', "\u30EA\u30D4\u30FC\u30C8", [
            'repeat'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_random', "\u30C8\u30E9\u30C3\u30AF\u3092\u30B7\u30E3\u30C3\u30D5\u30EB", 'keySpace', "\u30B7\u30E3\u30C3\u30D5\u30EB", [
            'shuffle',
            'random'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_1', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30DC\u30BF\u30F31 (a)", 'joystick', "\u30DC\u30BF\u30F3\u30EF\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_2', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30DC\u30BF\u30F32 (b)", 'joystick', "\u30DC\u30BF\u30F3\u30C4\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_3', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30DC\u30BF\u30F33 (x)", 'joystick', "\u30DC\u30BF\u30F3\u30B9\u30EA\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_4', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30DC\u30BF\u30F34 (y)", 'joystick', "\u30DC\u30BF\u30F3\u30D5\u30A9\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_5', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30DC\u30BF\u30F35\uFF08lb\uFF09", 'joystick', "\u30DC\u30BF\u30F3\u30D5\u30A1\u30A4\u30D6", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_6', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30DC\u30BF\u30F36 (rb)", 'joystick', "\u30DC\u30BF\u30F3\u30B7\u30C3\u30AF\u30B9", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_7', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30DC\u30BF\u30F37 (lt)", 'joystick', "\u30DC\u30BF\u30F3\u30BB\u30D6\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_8', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30DC\u30BF\u30F38 (rt)", 'joystick', "\u30DC\u30BF\u30F3\u30A8\u30A4\u30C8", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_9', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30DC\u30BF\u30F39\uFF08\u30AA\u30D7\u30B7\u30E7\u30F3\uFF09", 'joystick', "\u30DC\u30BF\u30F3\u30CA\u30A4\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_10', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30DC\u30BF\u30F310\uFF08\u4E00\u6642\u505C\u6B62\uFF09", 'joystick', "\u30DC\u30BF\u30F3\u30C6\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_11', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30DC\u30BF\u30F311\uFF08l3\uFF09", 'joystick', "\u30DC\u30BF\u30F3\u30A4\u30EC\u30D6\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_12', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30DC\u30BF\u30F312\uFF08r3\uFF09", 'joystick', "\u30DC\u30BF\u30F3\u30C8\u30A5\u30A8\u30EB\u30D6", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_13', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u306E\u5341\u5B57\u30DC\u30BF\u30F3\u4E0A", 'joystick', "\u4E0A\u30DC\u30BF\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_14', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u306Ed\u30D1\u30C3\u30C9\u3092\u4E0B", 'joystick', "\u4E0B\u30DC\u30BF\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_15', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC D\u30D1\u30C3\u30C9 \u5DE6", 'joystick', "\u5DE6\u30DC\u30BF\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_16', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC D\u30D1\u30C3\u30C9\u53F3", 'joystick', "\u53F3\u30DC\u30BF\u30F3", [])
    ]
};
const $9a9874d925dad9cc$export$2f002ae08ac7e997 = (locale, platform)=>{
    const language = (0, $eeb1a4bb5a11a603$export$e88b669f03544b69)(locale, 'display');
    let result = [];
    if (language) result = $9a9874d925dad9cc$export$d8fdbd751da3b492[language] ?? [];
    if (platform && platform !== 'generic') // filter by platform. generic profiles get all of the keybindings
    result = result.filter((kcd)=>!kcd.platform || kcd.platform === 'generic' || kcd.platform === platform);
    return result;
};
const $9a9874d925dad9cc$export$a23a68036192c276 = (key, locale)=>{
    const keyName = $9a9874d925dad9cc$export$2f002ae08ac7e997(locale).find((v)=>v.key == key)?.displayName ?? key;
    if (keyName?.length == 1) return keyName.toUpperCase();
    return keyName;
};
const $9a9874d925dad9cc$export$fbe8b56204f00600 = (key, locale)=>{
    const newKey = $9a9874d925dad9cc$export$38eb86f225c9e34c(key, locale);
    const keyIcon = $9a9874d925dad9cc$export$2f002ae08ac7e997(locale).find((v)=>v.key == newKey)?.icon ?? newKey;
    return keyIcon;
};
const $9a9874d925dad9cc$export$38eb86f225c9e34c = (value, locale)=>{
    const defaultKeyMapping = $9a9874d925dad9cc$export$2f002ae08ac7e997(locale);
    const key = defaultKeyMapping.find((v)=>v.key == value)?.key;
    if (key) return key;
    const keyFromDisplayName = defaultKeyMapping.find((v)=>v.displayName == value)?.key;
    if (keyFromDisplayName) return keyFromDisplayName;
    const keyFromAlias = defaultKeyMapping.find((v)=>v.alternateKeys?.includes(value))?.key;
    if (keyFromAlias) return keyFromAlias;
    return value;
};
const $9a9874d925dad9cc$export$c59c56a4092c247a = (key, locale)=>{
    const newKey = $9a9874d925dad9cc$export$38eb86f225c9e34c(key, locale);
    const keyPlatform = $9a9874d925dad9cc$export$2f002ae08ac7e997(locale).find((v)=>v.key == newKey)?.platform ?? 'generic';
    return keyPlatform;
};






var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");


const $fadcf04f5e0ec6ac$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $fadcf04f5e0ec6ac$export$2e2bcd8739ae039 = {
    randomUUID: $fadcf04f5e0ec6ac$var$randomUUID
};


let $2bcaa466815aa8a5$var$getRandomValues;
const $2bcaa466815aa8a5$var$rnds8 = new Uint8Array(16);
function $2bcaa466815aa8a5$export$2e2bcd8739ae039() {
    if (!$2bcaa466815aa8a5$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $2bcaa466815aa8a5$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $2bcaa466815aa8a5$var$getRandomValues($2bcaa466815aa8a5$var$rnds8);
}


var $7709510a2fca9f72$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $8df89a4d60889f85$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $7709510a2fca9f72$export$2e2bcd8739ae039).test(uuid);
}
var $8df89a4d60889f85$export$2e2bcd8739ae039 = $8df89a4d60889f85$var$validate;


const $ee13ceee8d9f46c4$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$ee13ceee8d9f46c4$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $ee13ceee8d9f46c4$export$8fb373d660548968(arr, offset = 0) {
    return ($ee13ceee8d9f46c4$var$byteToHex[arr[offset + 0]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 1]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 2]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 3]] + '-' + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 4]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 5]] + '-' + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 6]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 7]] + '-' + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 8]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 9]] + '-' + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 10]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 11]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 12]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 13]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 14]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $ee13ceee8d9f46c4$var$stringify(arr, offset = 0) {
    const uuid = $ee13ceee8d9f46c4$export$8fb373d660548968(arr, offset);
    if (!(0, $8df89a4d60889f85$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $ee13ceee8d9f46c4$export$2e2bcd8739ae039 = $ee13ceee8d9f46c4$var$stringify;


function $6810e10b84975c3e$var$v4(options, buf, offset) {
    if ((0, $fadcf04f5e0ec6ac$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $fadcf04f5e0ec6ac$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $2bcaa466815aa8a5$export$2e2bcd8739ae039)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $ee13ceee8d9f46c4$export$8fb373d660548968)(rnds);
}
var $6810e10b84975c3e$export$2e2bcd8739ae039 = $6810e10b84975c3e$var$v4;



const $15df2073755d9d49$export$eb5036441d82cea3 = (c, hotkeys)=>{
    if (c.hotkeyLocalId !== undefined) return c.hotkeyLocalId;
    const matchingHotkey = hotkeys.find((hotkey)=>hotkey.command === c.command);
    if (matchingHotkey) return matchingHotkey?.localId;
};
const $15df2073755d9d49$export$8887ad9c8dfc8e0a = (hotkey, macros)=>{
    const matchingMacro = macros.find((macro)=>macro.commands.some((macroCommand)=>macroCommand.command === hotkey.command));
    if (!matchingMacro) return;
    const i = macros.indexOf(matchingMacro);
    return {
        m: matchingMacro,
        index: i
    };
};
const $15df2073755d9d49$export$bb07e30d9b3432d = (c, hotkeys)=>{
    const matchingHotkey = hotkeys.find((hotkey)=>hotkey.command === c.command);
    if (!matchingHotkey) return;
    const i = hotkeys.indexOf(matchingHotkey);
    return {
        match: matchingHotkey,
        index: i
    };
};




const $03a56fb167cf9474$export$caaa93ee9052213c = [
    {
        eventType: 'KeyPress',
        displayName: 'common:event.keyPress.title'
    },
    {
        eventType: 'KeyRelease',
        displayName: 'common:event.keyRelease.title'
    },
    {
        eventType: 'KeyToggle',
        displayName: 'common:event.keyToggle.title'
    },
    {
        eventType: 'Pause',
        displayName: 'common:event.pause.title'
    },
    {
        eventType: 'Type',
        displayName: 'common:event.type.title'
    },
    {
        eventType: 'MouseMove',
        displayName: 'common:event.mouseMove.title'
    },
    {
        eventType: 'JoysticksMove',
        displayName: 'common:event.joystickMove.title'
    },
    {
        eventType: 'PlayAudio',
        displayName: 'common:event.playAudio.title'
    },
    {
        eventType: 'StopOutputs',
        displayName: 'common:event.stopOutputs.title'
    },
    {
        eventType: 'DeviceTypeCustomAction',
        displayName: 'common:event.custom.title'
    }
];
const $03a56fb167cf9474$export$7e8bcaa1250bba4e = (macroEvent)=>{
    return macroEvent.eventType == 'KeyPress' && macroEvent.holdTimeMilliseconds != null || macroEvent.eventType == 'Pause';
};


const $9d76aba0a210d2c6$export$ec2c4b4373af4b61 = (params)=>{
    const { macros: macros, dictationCommands: dictationCommands, profileId: profileId, t: t } = params;
    const macrosWithVoiceCommands = macros.filter((m)=>m.commands.some((c)=>c.commandType === 'voice' && c.command !== ''));
    const nonEmptyDictationCommands = dictationCommands.filter((c)=>c !== '').map((c)=>c.toLowerCase());
    const conflictingVoiceCommands = [];
    macrosWithVoiceCommands.forEach((macro)=>{
        macro.commands.forEach((c)=>{
            if (nonEmptyDictationCommands.includes(c.command.toLowerCase())) {
                const macroName = macro.name ?? $9d76aba0a210d2c6$export$61a248617ae833c4(c.command, t);
                conflictingVoiceCommands.push({
                    key: 'MacroVoiceCommandWithDictation',
                    scrollID: macro.id,
                    displayString: $9d76aba0a210d2c6$export$a507c6cda418ed27(macroName, c.command, c.commandType, t),
                    pageLink: `/profiles/edit/${profileId}`
                });
            }
        });
    });
    return conflictingVoiceCommands;
};
const $9d76aba0a210d2c6$export$845f2f159de600e0 = (params)=>{
    const { commandKeyMappings: commandKeyMappings, dictationCommands: dictationCommands, profileId: profileId, t: t } = params;
    const keybindingsWithVoiceCommands = commandKeyMappings.filter((c)=>c.commands.some((c)=>c.commandType === 'voice' && c.command !== ''));
    const nonEmptyDictationCommands = dictationCommands.filter((c)=>c !== '').map((c)=>c.toLowerCase());
    const conflictingVoiceCommands = [];
    keybindingsWithVoiceCommands.forEach((keybinding)=>{
        keybinding.commands.forEach((c)=>{
            if (nonEmptyDictationCommands.includes(c.command.toLowerCase())) conflictingVoiceCommands.push({
                key: 'KeybindingVoiceCommandWithDictation',
                scrollID: keybinding.key,
                displayString: $9d76aba0a210d2c6$export$a507c6cda418ed27(keybinding.displayName, c.command, c.commandType, t),
                pageLink: `/profiles/edit/${profileId}/advanced/keybindings`
            });
        });
    });
    return conflictingVoiceCommands;
};
const $9d76aba0a210d2c6$export$eb3146089825fa9d = (params)=>{
    const { commandKeyMappings: commandKeyMappings, profileId: profileId, t: t } = params;
    const commands = [];
    commandKeyMappings.forEach((keyCommand)=>{
        const nonEmptyCommands = keyCommand.commands.filter((c)=>c.command !== '');
        const transformedCommands = nonEmptyCommands.map((commandModel)=>{
            let commandName = $9d76aba0a210d2c6$export$a9e54ec0b37334dc(commandModel.command, t);
            if (commandModel.commandType === 'voice') commandName = commandName.toLowerCase();
            return {
                commandDisplayName: commandName,
                commandType: commandModel.commandType,
                macroOrKeyName: keyCommand.displayName,
                macroOrKeyId: keyCommand.key,
                pageLink: `/profiles/edit/${profileId}/advanced/keybindings`
            };
        });
        commands.push(...transformedCommands);
    });
    return $9d76aba0a210d2c6$export$69d072b3a37082dd(commands, 'DuplicateKeybindingInputCommands', t);
};
const $9d76aba0a210d2c6$export$69d072b3a37082dd = (allCommands, key, t)=>{
    const alreadySeen = {};
    const duplicated = [];
    // Create a map of command input names and control type to a list of macros or keybindings
    allCommands.forEach((commandModel)=>{
        const keyStr = `${commandModel.commandDisplayName}_${commandModel.commandType}`;
        if (!alreadySeen[keyStr]) alreadySeen[keyStr] = [];
        alreadySeen[keyStr].push({
            id: commandModel.macroOrKeyId,
            name: commandModel.macroOrKeyName,
            pageLink: commandModel.pageLink
        });
    });
    // Create the duplicate conflicting commands list
    for(const commandModelKey in alreadySeen)if (alreadySeen[commandModelKey].length > 1) {
        const [inputName, controlType] = commandModelKey.split('_');
        alreadySeen[commandModelKey].forEach((conflictDetail)=>{
            duplicated.push({
                key: key,
                scrollID: conflictDetail.id,
                displayString: $9d76aba0a210d2c6$export$a507c6cda418ed27(conflictDetail.name, inputName, controlType, t),
                pageLink: conflictDetail.pageLink
            });
        });
    }
    return duplicated;
};
const $9d76aba0a210d2c6$export$4a2e027df0dfc855 = (params)=>{
    const { associatedPrograms: associatedPrograms, profileId: profileId } = params;
    const uniqueNames = new Set();
    const duplicatedNames = [];
    associatedPrograms.forEach((name, idx)=>{
        const lowerCaseName = name.toLowerCase();
        if (lowerCaseName === '') return;
        if (uniqueNames.has(lowerCaseName)) duplicatedNames.push({
            displayString: name,
            key: 'DuplicateAssociatedProgramsName',
            pageLink: `/profiles/edit/${profileId}`,
            scrollID: `${idx}_associated_program_field`
        });
        else uniqueNames.add(lowerCaseName);
    });
    return duplicatedNames;
};
const $9d76aba0a210d2c6$export$1d55b5fa728affd1 = (params)=>{
    const { macros: macros, profileId: profileId, t: t } = params;
    const emptyCommands = [];
    const emptyCommandName = t('common:noName');
    macros.forEach((macro)=>{
        macro.commands.forEach((c)=>{
            if (!c.command) {
                const macroName = macro.name ?? t('common:noName');
                emptyCommands.push({
                    key: 'EmptyMacroInputs',
                    scrollID: macro.id,
                    displayString: $9d76aba0a210d2c6$export$a507c6cda418ed27(macroName, emptyCommandName, c.commandType, t),
                    pageLink: `/profiles/edit/${profileId}`
                });
            }
        });
    });
    return emptyCommands;
};
const $9d76aba0a210d2c6$export$639d475f7be72f7d = (params)=>{
    const { macros: macros, profileId: profileId, t: t } = params;
    const commands = [];
    macros.forEach((macro)=>{
        const nonEmptyCommands = macro.commands.filter((c)=>c.command !== '');
        const transformedCommands = nonEmptyCommands.map((commandModel)=>{
            let commandName = $9d76aba0a210d2c6$export$a9e54ec0b37334dc(commandModel.command, t);
            if (commandModel.commandType === 'voice') commandName = commandName.toLowerCase();
            return {
                commandDisplayName: commandName,
                commandType: commandModel.commandType,
                macroOrKeyName: macro.name ?? $9d76aba0a210d2c6$export$61a248617ae833c4(commandModel.command, t),
                macroOrKeyId: macro.id,
                pageLink: `/profiles/edit/${profileId}`
            };
        });
        commands.push(...transformedCommands);
    });
    return $9d76aba0a210d2c6$export$69d072b3a37082dd(commands, 'DuplicateMacroInputCommands', t);
};
const $9d76aba0a210d2c6$export$b59cab01f4e26d1b = (params)=>{
    const { macros: macros, profileId: profileId, defaultLocale: defaultLocale, t: t } = params;
    const unreleasedLatchedKeys = [];
    // Filter on macros with latched keys and those with release or toggle event key types
    const macrosWithLatchedKeys = macros.filter((macro)=>macro.events.some((event)=>event.isKeyLatch));
    const macrosWithReleaseKeys = macros.filter((macro)=>macro.events.some((event)=>event.eventType === 'KeyRelease' || event.eventType === 'KeyToggle'));
    const stopAllMacros = macros.filter((macro)=>macro.events.some((event)=>event.eventType === 'StopOutputs'));
    // StopOutputs trumps all other key release types
    if (stopAllMacros.length === 0) {
        // Flatten release keys to an array of strings
        const releaseKeysPerMacro = macrosWithReleaseKeys.flatMap((macro)=>macro.events.map((event)=>event.keys));
        const releaseKeys = releaseKeysPerMacro.flat();
        // Iterate through each latched macro and find a release key
        macrosWithLatchedKeys.forEach((macro)=>{
            macro.events.forEach((event)=>{
                if (event.isKeyLatch && event.keys) for (const latchKey of event.keys){
                    const hasReleasedKey = releaseKeys.length > 0 && releaseKeys.includes(latchKey);
                    if (!hasReleasedKey) {
                        const eventTypeDisplayName = t($9d76aba0a210d2c6$export$be0c0c806bbe3773(event.eventType));
                        unreleasedLatchedKeys.push({
                            key: 'UnreleasedLatchedKey',
                            scrollID: macro.id,
                            displayString: $9d76aba0a210d2c6$export$a507c6cda418ed27(macro.name ?? $9d76aba0a210d2c6$export$61a248617ae833c4(macro.commands?.[0]?.command, t), (0, $9a9874d925dad9cc$export$a23a68036192c276)(latchKey, defaultLocale), eventTypeDisplayName, t),
                            pageLink: `/profiles/edit/${profileId}`
                        });
                    }
                }
            });
        });
    }
    return unreleasedLatchedKeys;
};
const $9d76aba0a210d2c6$export$134d4256d4cafcf4 = (params)=>{
    const { commandKeyMappings: commandKeyMappings, profileId: profileId, t: t } = params;
    const emptyCommands = [];
    const emptyCommandName = t('common:noName');
    commandKeyMappings.forEach((mapping)=>{
        mapping.commands.forEach((c)=>{
            if (!c.command) emptyCommands.push({
                key: 'EmptyKeybindingInputs',
                scrollID: mapping.key,
                displayString: $9d76aba0a210d2c6$export$a507c6cda418ed27(mapping.displayName, emptyCommandName, c.commandType, t),
                pageLink: `/profiles/edit/${profileId}/advanced/keybindings`
            });
        });
    });
    return emptyCommands;
};
const $9d76aba0a210d2c6$export$7b817b6bf4f2cb70 = (params)=>{
    const { macros: macros, profileId: profileId, t: t } = params;
    const uniqueNames = new Set();
    const duplicatedNames = [];
    const noNameText = t('common:noName');
    macros.forEach((macro)=>{
        const macroName = macro.name ?? $9d76aba0a210d2c6$export$61a248617ae833c4(macro.commands?.[0]?.command, t);
        if (macroName === noNameText) return;
        if (uniqueNames.has(macroName)) duplicatedNames.push({
            displayString: macroName,
            key: 'DuplicateMacroName',
            pageLink: `/profiles/edit/${profileId}`,
            scrollID: macro.id
        });
        else uniqueNames.add(macroName);
    });
    return duplicatedNames;
};
const $9d76aba0a210d2c6$export$a634520ef9a79c74 = (params)=>{
    const { macros: macros, profileId: profileId, t: t } = params;
    const emptyKeyConflicts = [];
    const eventTypeKey = [
        'KeyPress',
        'KeyRelease',
        'KeyToggle'
    ];
    const eventTypeTextInput = [
        'Type',
        'PlayAudio'
    ];
    const isEmptyEvent = (event)=>{
        const isKeyEventEmpty = eventTypeKey.includes(event.eventType) && (!event.keys || event.keys.length === 0 || event.keys.some((key)=>!key));
        const isFreeFormEventEmpty = eventTypeTextInput.includes(event.eventType) && !(event.typedPhrase || event.outputSpeech || event.additionalInputContent);
        return isKeyEventEmpty || isFreeFormEventEmpty;
    };
    macros.forEach((macro)=>{
        const macroName = macro.name ?? $9d76aba0a210d2c6$export$61a248617ae833c4(macro.commands[0]?.command, t);
        macro.events.forEach((event)=>{
            const eventTypeDisplayName = t($9d76aba0a210d2c6$export$be0c0c806bbe3773(event.eventType));
            if (isEmptyEvent(event)) emptyKeyConflicts.push({
                displayString: `${macroName}: ${eventTypeDisplayName}`,
                key: 'EmptyEvent',
                pageLink: `/profiles/edit/${profileId}`,
                scrollID: macro.id
            });
        });
    });
    return emptyKeyConflicts;
};
const $9d76aba0a210d2c6$export$be0c0c806bbe3773 = (eventType)=>{
    return (0, $03a56fb167cf9474$export$caaa93ee9052213c).find((macroDisplayType)=>macroDisplayType.eventType === eventType)?.displayName;
};
const $9d76aba0a210d2c6$export$d1b24cb1984823a4 = (keybinds)=>{
    return keybinds.map((k)=>({
            commands: k.commands.map((c)=>c.command),
            key: k.key
        }));
};
const $9d76aba0a210d2c6$export$f31ec4fcec40d1f9 = (defaultKeybindings, profileKeybindings = [])=>{
    const profileBindingsMap = Object.fromEntries(profileKeybindings.map((k)=>[
            k.key,
            k
        ]));
    // Union of default and profile keybindings. Priority to profile keybindings, but following the order of default keybindings for consistency
    const unionKeybindings = defaultKeybindings.map((defaultKey)=>profileBindingsMap[defaultKey.key] || defaultKey);
    if (!profileKeybindings?.length || profileKeybindings.every((k)=>k.commands.length === 0)) // no command keys or empty commands in profile keybindings
    unionKeybindings.forEach((k)=>{
        k.commands = [];
    });
    return unionKeybindings;
};
const $9d76aba0a210d2c6$export$9f33ffede7fa8708 = (title, items, conflictList, subtitle)=>{
    if (items.length > 0) conflictList.push({
        title: title,
        items: items,
        subtitle: subtitle
    });
};
function $9d76aba0a210d2c6$export$a9e54ec0b37334dc(command, t) {
    if (!command) return t('common:noName');
    if (command.startsWith('mouse_move')) return t('common:event.mouseMove.command', 'Move mouse', {
        command: command.replace('mouse_move', '')
    });
    const commandControl = (0, $f44f3a5bc46b1c4c$export$48c02457e332140e).find((c)=>c.value === command);
    if (commandControl) {
        if (commandControl.isExternalKeyboard) return commandControl.translationKey ?? commandControl.title;
        else return t(commandControl.title);
    }
    if (command.startsWith((0, $f44f3a5bc46b1c4c$export$b617c310e3426257))) return t('common:hotkey.tap', 'Tap', {
        value: command.replace((0, $f44f3a5bc46b1c4c$export$b617c310e3426257), '')
    });
    return t('common:voice.say', 'Say', {
        value: command
    });
}
const $9d76aba0a210d2c6$export$61a248617ae833c4 = (command, t)=>{
    if (!command) return t('common:noName');
    const commandControl = (0, $f44f3a5bc46b1c4c$export$48c02457e332140e).find((c)=>c.value === command);
    if (commandControl) {
        if (commandControl.isExternalKeyboard) return commandControl.translationKey ?? commandControl.title;
        else return t(commandControl.title ? commandControl.title : 'common:noName');
    }
    return command;
};
const $9d76aba0a210d2c6$export$a507c6cda418ed27 = (macroOrBindingName, commandOrKeyName, commandOrEventType, t)=>{
    return t('common:profile.conflictIndicators.conflictIndicatorDisplayString', `${macroOrBindingName} : ${commandOrKeyName} with ${commandOrEventType}`, {
        container: macroOrBindingName,
        commandOrKeyName: commandOrKeyName,
        commandOrEventType: commandOrEventType
    });
};






const $2616fe0411c33582$export$5a74056075e3647e = (customControl)=>{
    return customControl.requiresEmployeeAccess || customControl.requiresGenericLicense || customControl.requiresPlusAccess || customControl.requiresStudentAccess;
};
const $2616fe0411c33582$export$82e40272e8bb746b = (deviceControls, controlOverrides)=>{
    const result = [];
    const controlIds = new Set();
    for (const control of deviceControls){
        result.push({
            ...control,
            commands: control.defaultCommands ?? []
        });
        controlIds.add(control.id);
    }
    // take override over the defaults if available
    for (const override of controlOverrides)if (controlIds.has(override.deviceTypeCustomControlId)) {
        const control = result.find((c)=>c.id === override.deviceTypeCustomControlId);
        if (control && (override.commands?.length ?? 0) > 0) control.commands = override.commands;
    // todo: hotkey
    }
    return result;
};






var $4caff0eaeff97cc6$exports = {};
// eslint-disable-next-line no-multi-assign
var $4caff0eaeff97cc6$export$5f828d93ff035aa8;
var $4caff0eaeff97cc6$export$cd94982b18c6332c;
var $4caff0eaeff97cc6$export$1d518568e4f529b0;
var $4caff0eaeff97cc6$export$5285b6d41c912b41;
// eslint-disable-next-line no-multi-assign
var $4caff0eaeff97cc6$export$2fb37efbf6ae0c0e;
var $4caff0eaeff97cc6$export$ab85ecd77ce6a5cd;
// eslint-disable-next-line no-multi-assign
var $4caff0eaeff97cc6$export$da39cf97e1eb7c91;
var $4caff0eaeff97cc6$export$52a9039d7177394f;
var $4caff0eaeff97cc6$export$f7201db400317331;
var $4caff0eaeff97cc6$export$448fa22aedc9dbca;
var $4caff0eaeff97cc6$export$b80c7ba289c8fa56;
var $4caff0eaeff97cc6$export$26e5786e8ac8e530;
var $4caff0eaeff97cc6$export$bdd223f16383713e;
var $4caff0eaeff97cc6$export$20533d26f07f1ee0;
var $4caff0eaeff97cc6$export$2f64596b8cbf08b4;
var $4caff0eaeff97cc6$export$2ce6d8d0e8b04e1a;
var $4caff0eaeff97cc6$export$12ada9414fbc594c;
var $4caff0eaeff97cc6$export$f5e7e39d57cd9700;
var $4caff0eaeff97cc6$export$36b6d6ef312eab39;
var $4caff0eaeff97cc6$export$58a258485f1e49f6;
var $4caff0eaeff97cc6$export$dedd8dc3dc62b370;
var $4caff0eaeff97cc6$export$971862a2fcb1bb40;
var $4caff0eaeff97cc6$export$c6ff6a88acbeaf40;
var $4caff0eaeff97cc6$export$fdc27893e98845cc;
var $4caff0eaeff97cc6$export$6671fb9a1323bed;
var $4caff0eaeff97cc6$export$d74daf141a551db;
var $4caff0eaeff97cc6$export$45df7cae684751af;
var $4caff0eaeff97cc6$export$1db683ad541682f6;
var $4caff0eaeff97cc6$export$6f65485f87568e37;
var $4caff0eaeff97cc6$export$91a8e56769aeb334;
var $4caff0eaeff97cc6$export$2d4117e99c2179e4;
var $4caff0eaeff97cc6$export$512823e338ddb1b7;
var $4caff0eaeff97cc6$export$9d0e0c0c4a8d30f3;
var $4caff0eaeff97cc6$export$b9d55ff329113abd;
var $4caff0eaeff97cc6$export$7efb24e2fddf99b9;
var $4caff0eaeff97cc6$export$bb1abf2ce84fc7e8;
var $4caff0eaeff97cc6$export$2f7171e78e524d5e;
var $4caff0eaeff97cc6$export$e1d879b482f37d98;
var $4caff0eaeff97cc6$export$1a988e7317c65621;
'use strict';

$4caff0eaeff97cc6$export$5f828d93ff035aa8 = $4caff0eaeff97cc6$export$cd94982b18c6332c = $4caff0eaeff97cc6$export$1d518568e4f529b0 = $4caff0eaeff97cc6$export$5285b6d41c912b41 = (parcelRequire("f08he"));

$4caff0eaeff97cc6$export$2fb37efbf6ae0c0e = $4caff0eaeff97cc6$export$ab85ecd77ce6a5cd = (parcelRequire("eNPUV"));

$4caff0eaeff97cc6$export$da39cf97e1eb7c91 = $4caff0eaeff97cc6$export$52a9039d7177394f = (parcelRequire("cL3Ff"));
var $826ee5b5b5439bab$exports = {};
'use strict';

$826ee5b5b5439bab$exports = (parcelRequire("gm4QM"));


var $4caff0eaeff97cc6$var$algoKeys = Object.keys($826ee5b5b5439bab$exports);
var $4caff0eaeff97cc6$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($4caff0eaeff97cc6$var$algoKeys);
$4caff0eaeff97cc6$export$f7201db400317331 = function() {
    return $4caff0eaeff97cc6$var$hashes;
};

var $d0xYH = parcelRequire("d0xYH");
$4caff0eaeff97cc6$export$448fa22aedc9dbca = $d0xYH.pbkdf2;
$4caff0eaeff97cc6$export$b80c7ba289c8fa56 = $d0xYH.pbkdf2Sync;
var $e55c9b7f3ad34522$export$bdd223f16383713e;
var $e55c9b7f3ad34522$export$26e5786e8ac8e530;
var $e55c9b7f3ad34522$export$2f64596b8cbf08b4;
var $e55c9b7f3ad34522$export$20533d26f07f1ee0;
var $e55c9b7f3ad34522$export$12ada9414fbc594c;
var $e55c9b7f3ad34522$export$2ce6d8d0e8b04e1a;
var $e55c9b7f3ad34522$export$36b6d6ef312eab39;
var $e55c9b7f3ad34522$export$f5e7e39d57cd9700;
var $e55c9b7f3ad34522$export$dedd8dc3dc62b370;
var $e55c9b7f3ad34522$export$58a258485f1e49f6;
var $95cd04dabc1eb7c8$exports = {};

var $6GOuC = parcelRequire("6GOuC");
var $c57f0e5ad20890a2$export$eab97d15b1788b8d;
var $c57f0e5ad20890a2$export$26e5786e8ac8e530;
var $c57f0e5ad20890a2$export$cc8859615686b300;
var $c57f0e5ad20890a2$export$8ad3f227af08fcc5;
var $c57f0e5ad20890a2$export$947646e34766044f;
'use strict';

$c57f0e5ad20890a2$export$eab97d15b1788b8d = (parcelRequire("aSiVb"));

$c57f0e5ad20890a2$export$26e5786e8ac8e530 = (parcelRequire("en1ji"));

$c57f0e5ad20890a2$export$cc8859615686b300 = (parcelRequire("gv6xd"));

$c57f0e5ad20890a2$export$8ad3f227af08fcc5 = (parcelRequire("f8Mbw"));

$c57f0e5ad20890a2$export$947646e34766044f = (parcelRequire("f5Nr9"));



var $dhT4G = parcelRequire("dhT4G");

var $838j1 = parcelRequire("838j1");
var $95cd04dabc1eb7c8$require$Buffer = $838j1.Buffer;
var $95cd04dabc1eb7c8$var$modes = {
    'des-ede3-cbc': $c57f0e5ad20890a2$export$8ad3f227af08fcc5.instantiate($c57f0e5ad20890a2$export$947646e34766044f),
    'des-ede3': $c57f0e5ad20890a2$export$947646e34766044f,
    'des-ede-cbc': $c57f0e5ad20890a2$export$8ad3f227af08fcc5.instantiate($c57f0e5ad20890a2$export$947646e34766044f),
    'des-ede': $c57f0e5ad20890a2$export$947646e34766044f,
    'des-cbc': $c57f0e5ad20890a2$export$8ad3f227af08fcc5.instantiate($c57f0e5ad20890a2$export$cc8859615686b300),
    'des-ecb': $c57f0e5ad20890a2$export$cc8859615686b300
};
$95cd04dabc1eb7c8$var$modes.des = $95cd04dabc1eb7c8$var$modes['des-cbc'];
$95cd04dabc1eb7c8$var$modes.des3 = $95cd04dabc1eb7c8$var$modes['des-ede3-cbc'];
$95cd04dabc1eb7c8$exports = $95cd04dabc1eb7c8$var$DES;
$dhT4G($95cd04dabc1eb7c8$var$DES, $6GOuC);
function $95cd04dabc1eb7c8$var$DES(opts) {
    $6GOuC.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $95cd04dabc1eb7c8$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (!$95cd04dabc1eb7c8$require$Buffer.isBuffer(key)) key = $95cd04dabc1eb7c8$require$Buffer.from(key);
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $95cd04dabc1eb7c8$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$95cd04dabc1eb7c8$require$Buffer.isBuffer(iv)) iv = $95cd04dabc1eb7c8$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$95cd04dabc1eb7c8$var$DES.prototype._update = function(data) {
    return $95cd04dabc1eb7c8$require$Buffer.from(this._des.update(data));
};
$95cd04dabc1eb7c8$var$DES.prototype._final = function() {
    return $95cd04dabc1eb7c8$require$Buffer.from(this._des.final());
};



var $jGDtA = parcelRequire("jGDtA");

var $gaNIZ = parcelRequire("gaNIZ");
var $8228ba5d20e426a7$exports = {};

$parcel$export($8228ba5d20e426a7$exports, "des-ecb", function () { return $8228ba5d20e426a7$export$116f8a5cee447347; }, function (v) { return $8228ba5d20e426a7$export$116f8a5cee447347 = v; });
$parcel$export($8228ba5d20e426a7$exports, "des-cbc", function () { return $8228ba5d20e426a7$export$7483c4066bfb7ae9; }, function (v) { return $8228ba5d20e426a7$export$7483c4066bfb7ae9 = v; });
$parcel$export($8228ba5d20e426a7$exports, "des", function () { return $8228ba5d20e426a7$export$e7a565d2e588bb06; }, function (v) { return $8228ba5d20e426a7$export$e7a565d2e588bb06 = v; });
$parcel$export($8228ba5d20e426a7$exports, "des-ede3-cbc", function () { return $8228ba5d20e426a7$export$aaa2f54a426f3eb8; }, function (v) { return $8228ba5d20e426a7$export$aaa2f54a426f3eb8 = v; });
$parcel$export($8228ba5d20e426a7$exports, "des3", function () { return $8228ba5d20e426a7$export$eba20568dde4ada; }, function (v) { return $8228ba5d20e426a7$export$eba20568dde4ada = v; });
$parcel$export($8228ba5d20e426a7$exports, "des-ede3", function () { return $8228ba5d20e426a7$export$d3b5e5996938f5ae; }, function (v) { return $8228ba5d20e426a7$export$d3b5e5996938f5ae = v; });
$parcel$export($8228ba5d20e426a7$exports, "des-ede-cbc", function () { return $8228ba5d20e426a7$export$57c08356130bc99b; }, function (v) { return $8228ba5d20e426a7$export$57c08356130bc99b = v; });
$parcel$export($8228ba5d20e426a7$exports, "des-ede", function () { return $8228ba5d20e426a7$export$c7169791d5c1e65d; }, function (v) { return $8228ba5d20e426a7$export$c7169791d5c1e65d = v; });
var $8228ba5d20e426a7$export$116f8a5cee447347;
var $8228ba5d20e426a7$export$7483c4066bfb7ae9;
var $8228ba5d20e426a7$export$e7a565d2e588bb06;
var $8228ba5d20e426a7$export$aaa2f54a426f3eb8;
var $8228ba5d20e426a7$export$eba20568dde4ada;
var $8228ba5d20e426a7$export$d3b5e5996938f5ae;
var $8228ba5d20e426a7$export$57c08356130bc99b;
var $8228ba5d20e426a7$export$c7169791d5c1e65d;
$8228ba5d20e426a7$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$8228ba5d20e426a7$export$7483c4066bfb7ae9 = $8228ba5d20e426a7$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$8228ba5d20e426a7$export$aaa2f54a426f3eb8 = $8228ba5d20e426a7$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$8228ba5d20e426a7$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$8228ba5d20e426a7$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$8228ba5d20e426a7$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};



var $iWvja = parcelRequire("iWvja");
function $e55c9b7f3ad34522$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($gaNIZ[suite]) {
        keyLen = $gaNIZ[suite].key;
        ivLen = $gaNIZ[suite].iv;
    } else if ($8228ba5d20e426a7$exports[suite]) {
        keyLen = $8228ba5d20e426a7$exports[suite].key * 8;
        ivLen = $8228ba5d20e426a7$exports[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $iWvja(password, false, keyLen, ivLen);
    return $e55c9b7f3ad34522$var$createCipheriv(suite, keys.key, keys.iv);
}
function $e55c9b7f3ad34522$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($gaNIZ[suite]) {
        keyLen = $gaNIZ[suite].key;
        ivLen = $gaNIZ[suite].iv;
    } else if ($8228ba5d20e426a7$exports[suite]) {
        keyLen = $8228ba5d20e426a7$exports[suite].key * 8;
        ivLen = $8228ba5d20e426a7$exports[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $iWvja(password, false, keyLen, ivLen);
    return $e55c9b7f3ad34522$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $e55c9b7f3ad34522$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($gaNIZ[suite]) return $jGDtA.createCipheriv(suite, key, iv);
    if ($8228ba5d20e426a7$exports[suite]) return new $95cd04dabc1eb7c8$exports({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError('invalid suite type');
}
function $e55c9b7f3ad34522$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($gaNIZ[suite]) return $jGDtA.createDecipheriv(suite, key, iv);
    if ($8228ba5d20e426a7$exports[suite]) return new $95cd04dabc1eb7c8$exports({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError('invalid suite type');
}
function $e55c9b7f3ad34522$var$getCiphers() {
    return Object.keys($8228ba5d20e426a7$exports).concat($jGDtA.getCiphers());
}
$e55c9b7f3ad34522$export$bdd223f16383713e = $e55c9b7f3ad34522$export$26e5786e8ac8e530 = $e55c9b7f3ad34522$var$createCipher;
$e55c9b7f3ad34522$export$2f64596b8cbf08b4 = $e55c9b7f3ad34522$export$20533d26f07f1ee0 = $e55c9b7f3ad34522$var$createCipheriv;
$e55c9b7f3ad34522$export$12ada9414fbc594c = $e55c9b7f3ad34522$export$2ce6d8d0e8b04e1a = $e55c9b7f3ad34522$var$createDecipher;
$e55c9b7f3ad34522$export$36b6d6ef312eab39 = $e55c9b7f3ad34522$export$f5e7e39d57cd9700 = $e55c9b7f3ad34522$var$createDecipheriv;
$e55c9b7f3ad34522$export$dedd8dc3dc62b370 = $e55c9b7f3ad34522$export$58a258485f1e49f6 = $e55c9b7f3ad34522$var$getCiphers;


$4caff0eaeff97cc6$export$26e5786e8ac8e530 = $e55c9b7f3ad34522$export$26e5786e8ac8e530;
$4caff0eaeff97cc6$export$bdd223f16383713e = $e55c9b7f3ad34522$export$bdd223f16383713e;
$4caff0eaeff97cc6$export$20533d26f07f1ee0 = $e55c9b7f3ad34522$export$20533d26f07f1ee0;
$4caff0eaeff97cc6$export$2f64596b8cbf08b4 = $e55c9b7f3ad34522$export$2f64596b8cbf08b4;
$4caff0eaeff97cc6$export$2ce6d8d0e8b04e1a = $e55c9b7f3ad34522$export$2ce6d8d0e8b04e1a;
$4caff0eaeff97cc6$export$12ada9414fbc594c = $e55c9b7f3ad34522$export$12ada9414fbc594c;
$4caff0eaeff97cc6$export$f5e7e39d57cd9700 = $e55c9b7f3ad34522$export$f5e7e39d57cd9700;
$4caff0eaeff97cc6$export$36b6d6ef312eab39 = $e55c9b7f3ad34522$export$36b6d6ef312eab39;
$4caff0eaeff97cc6$export$58a258485f1e49f6 = $e55c9b7f3ad34522$export$58a258485f1e49f6;
$4caff0eaeff97cc6$export$dedd8dc3dc62b370 = $e55c9b7f3ad34522$export$dedd8dc3dc62b370;
var $635a00d17aeeed5c$export$971862a2fcb1bb40;
var $635a00d17aeeed5c$export$c6ff6a88acbeaf40;
var $635a00d17aeeed5c$export$fdc27893e98845cc;
var $635a00d17aeeed5c$export$6671fb9a1323bed;
var $635a00d17aeeed5c$export$d74daf141a551db;

var $bdjQ6 = parcelRequire("bdjQ6");
var $635a00d17aeeed5c$require$Buffer = $bdjQ6.Buffer;
var $6dce41594cded7d5$exports = {};

var $f08he = parcelRequire("f08he");
$6dce41594cded7d5$exports = $6dce41594cded7d5$var$findPrime;
$6dce41594cded7d5$var$findPrime.simpleSieve = $6dce41594cded7d5$var$simpleSieve;
$6dce41594cded7d5$var$findPrime.fermatTest = $6dce41594cded7d5$var$fermatTest;

var $8pG42 = parcelRequire("8pG42");
var $6dce41594cded7d5$var$TWENTYFOUR = new $8pG42(24);
var $c52b7ae23bf69e77$exports = {};

var $8OaS6 = parcelRequire("8OaS6");

var $gWiKw = parcelRequire("gWiKw");
function $c52b7ae23bf69e77$var$MillerRabin(rand) {
    this.rand = rand || new $gWiKw.Rand();
}
$c52b7ae23bf69e77$exports = $c52b7ae23bf69e77$var$MillerRabin;
$c52b7ae23bf69e77$var$MillerRabin.create = function create(rand) {
    return new $c52b7ae23bf69e77$var$MillerRabin(rand);
};
$c52b7ae23bf69e77$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $8OaS6(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$c52b7ae23bf69e77$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$c52b7ae23bf69e77$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $8OaS6.mont(n);
    var rone = new $8OaS6(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $8OaS6(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$c52b7ae23bf69e77$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $8OaS6.mont(n);
    var rone = new $8OaS6(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $8OaS6(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};


var $6dce41594cded7d5$var$millerRabin = new $c52b7ae23bf69e77$exports();
var $6dce41594cded7d5$var$ONE = new $8pG42(1);
var $6dce41594cded7d5$var$TWO = new $8pG42(2);
var $6dce41594cded7d5$var$FIVE = new $8pG42(5);
var $6dce41594cded7d5$var$SIXTEEN = new $8pG42(16);
var $6dce41594cded7d5$var$EIGHT = new $8pG42(8);
var $6dce41594cded7d5$var$TEN = new $8pG42(10);
var $6dce41594cded7d5$var$THREE = new $8pG42(3);
var $6dce41594cded7d5$var$SEVEN = new $8pG42(7);
var $6dce41594cded7d5$var$ELEVEN = new $8pG42(11);
var $6dce41594cded7d5$var$FOUR = new $8pG42(4);
var $6dce41594cded7d5$var$TWELVE = new $8pG42(12);
var $6dce41594cded7d5$var$primes = null;
function $6dce41594cded7d5$var$_getPrimes() {
    if ($6dce41594cded7d5$var$primes !== null) return $6dce41594cded7d5$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $6dce41594cded7d5$var$primes = res;
    return res;
}
function $6dce41594cded7d5$var$simpleSieve(p) {
    var primes = $6dce41594cded7d5$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $6dce41594cded7d5$var$fermatTest(p) {
    var red = $8pG42.mont(p);
    return $6dce41594cded7d5$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $6dce41594cded7d5$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $8pG42([
            0x8c,
            0x7b
        ]);
        else return new $8pG42([
            0x8c,
            0x27
        ]);
    }
    gen = new $8pG42(gen);
    var num, n2;
    while(true){
        num = new $8pG42($f08he(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($6dce41594cded7d5$var$ONE);
        if (!num.testn(1)) num.iadd($6dce41594cded7d5$var$TWO);
        if (!gen.cmp($6dce41594cded7d5$var$TWO)) while(num.mod($6dce41594cded7d5$var$TWENTYFOUR).cmp($6dce41594cded7d5$var$ELEVEN))num.iadd($6dce41594cded7d5$var$FOUR);
        else if (!gen.cmp($6dce41594cded7d5$var$FIVE)) while(num.mod($6dce41594cded7d5$var$TEN).cmp($6dce41594cded7d5$var$THREE))num.iadd($6dce41594cded7d5$var$FOUR);
        n2 = num.shrn(1);
        if ($6dce41594cded7d5$var$simpleSieve(n2) && $6dce41594cded7d5$var$simpleSieve(num) && $6dce41594cded7d5$var$fermatTest(n2) && $6dce41594cded7d5$var$fermatTest(num) && $6dce41594cded7d5$var$millerRabin.test(n2) && $6dce41594cded7d5$var$millerRabin.test(num)) return num;
    }
}


var $fdd8cc6048f91da2$exports = {};
$fdd8cc6048f91da2$exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");


var $685b72df33913130$exports = {};

var $bdjQ6 = parcelRequire("bdjQ6");
var $685b72df33913130$require$Buffer = $bdjQ6.Buffer;

var $8pG42 = parcelRequire("8pG42");

var $685b72df33913130$var$millerRabin = new $c52b7ae23bf69e77$exports();
var $685b72df33913130$var$TWENTYFOUR = new $8pG42(24);
var $685b72df33913130$var$ELEVEN = new $8pG42(11);
var $685b72df33913130$var$TEN = new $8pG42(10);
var $685b72df33913130$var$THREE = new $8pG42(3);
var $685b72df33913130$var$SEVEN = new $8pG42(7);


var $f08he = parcelRequire("f08he");
$685b72df33913130$exports = $685b72df33913130$var$DH;
function $685b72df33913130$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$685b72df33913130$require$Buffer.isBuffer(pub)) pub = new $685b72df33913130$require$Buffer(pub, enc);
    this._pub = new $8pG42(pub);
    return this;
}
function $685b72df33913130$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$685b72df33913130$require$Buffer.isBuffer(priv)) priv = new $685b72df33913130$require$Buffer(priv, enc);
    this._priv = new $8pG42(priv);
    return this;
}
var $685b72df33913130$var$primeCache = {};
function $685b72df33913130$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $685b72df33913130$var$primeCache) return $685b72df33913130$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$6dce41594cded7d5$exports.simpleSieve || !$6dce41594cded7d5$exports.fermatTest(prime) || !$685b72df33913130$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $685b72df33913130$var$primeCache[hex] = error;
        return error;
    }
    if (!$685b72df33913130$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($685b72df33913130$var$TWENTYFOUR).cmp($685b72df33913130$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($685b72df33913130$var$TEN);
            if (rem.cmp($685b72df33913130$var$THREE) && rem.cmp($685b72df33913130$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $685b72df33913130$var$primeCache[hex] = error;
    return error;
}
function $685b72df33913130$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $8pG42(prime);
    this._prime = $8pG42.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $685b72df33913130$var$setPublicKey;
        this.setPrivateKey = $685b72df33913130$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($685b72df33913130$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = $685b72df33913130$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$685b72df33913130$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $8pG42($f08he(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$685b72df33913130$var$DH.prototype.computeSecret = function(other) {
    other = new $8pG42(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $685b72df33913130$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $685b72df33913130$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $685b72df33913130$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$685b72df33913130$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $685b72df33913130$var$formatReturnValue(this._pub, enc);
};
$685b72df33913130$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $685b72df33913130$var$formatReturnValue(this._priv, enc);
};
$685b72df33913130$var$DH.prototype.getPrime = function(enc) {
    return $685b72df33913130$var$formatReturnValue(this.__prime, enc);
};
$685b72df33913130$var$DH.prototype.getGenerator = function(enc) {
    return $685b72df33913130$var$formatReturnValue(this._gen, enc);
};
$685b72df33913130$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$685b72df33913130$require$Buffer.isBuffer(gen)) gen = new $685b72df33913130$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $8pG42(gen);
    return this;
};
function $685b72df33913130$var$formatReturnValue(bn, enc) {
    var buf = new $685b72df33913130$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}


function $635a00d17aeeed5c$var$getDiffieHellman(mod) {
    var prime = new $635a00d17aeeed5c$require$Buffer($fdd8cc6048f91da2$exports[mod].prime, 'hex');
    var gen = new $635a00d17aeeed5c$require$Buffer($fdd8cc6048f91da2$exports[mod].gen, 'hex');
    return new $685b72df33913130$exports(prime, gen);
}
var $635a00d17aeeed5c$var$ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function $635a00d17aeeed5c$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($635a00d17aeeed5c$require$Buffer.isBuffer(enc) || $635a00d17aeeed5c$var$ENCODINGS[enc] === undefined) return $635a00d17aeeed5c$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $635a00d17aeeed5c$require$Buffer([
        2
    ]);
    if (!$635a00d17aeeed5c$require$Buffer.isBuffer(generator)) generator = new $635a00d17aeeed5c$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $685b72df33913130$exports($6dce41594cded7d5$exports(prime, generator), generator, true);
    if (!$635a00d17aeeed5c$require$Buffer.isBuffer(prime)) prime = new $635a00d17aeeed5c$require$Buffer(prime, enc);
    return new $685b72df33913130$exports(prime, generator, true);
}
$635a00d17aeeed5c$export$971862a2fcb1bb40 = $635a00d17aeeed5c$export$c6ff6a88acbeaf40 = $635a00d17aeeed5c$export$fdc27893e98845cc = $635a00d17aeeed5c$var$getDiffieHellman;
$635a00d17aeeed5c$export$6671fb9a1323bed = $635a00d17aeeed5c$export$d74daf141a551db = $635a00d17aeeed5c$var$createDiffieHellman;


$4caff0eaeff97cc6$export$971862a2fcb1bb40 = $635a00d17aeeed5c$export$971862a2fcb1bb40;
$4caff0eaeff97cc6$export$c6ff6a88acbeaf40 = $635a00d17aeeed5c$export$c6ff6a88acbeaf40;
$4caff0eaeff97cc6$export$fdc27893e98845cc = $635a00d17aeeed5c$export$fdc27893e98845cc;
$4caff0eaeff97cc6$export$6671fb9a1323bed = $635a00d17aeeed5c$export$6671fb9a1323bed;
$4caff0eaeff97cc6$export$d74daf141a551db = $635a00d17aeeed5c$export$d74daf141a551db;
var $870db353fba87e6d$exports = {};
'use strict';

var $838j1 = parcelRequire("838j1");
var $870db353fba87e6d$require$Buffer = $838j1.Buffer;

var $eNPUV = parcelRequire("eNPUV");

var $dFZZW = parcelRequire("dFZZW");

var $dhT4G = parcelRequire("dhT4G");
var $463833414b7fa82a$exports = {};
'use strict';

var $838j1 = parcelRequire("838j1");
var $463833414b7fa82a$require$Buffer = $838j1.Buffer;

var $cL3Ff = parcelRequire("cL3Ff");

var $2jcIV = parcelRequire("2jcIV");

var $a2sGY = parcelRequire("a2sGY");
var $463833414b7fa82a$require$EC = $a2sGY.ec;

var $aVh2m = parcelRequire("aVh2m");

var $hdVtR = parcelRequire("hdVtR");
var $484f9bbb9588ddbc$exports = {};
$484f9bbb9588ddbc$exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");


var $463833414b7fa82a$var$RSA_PKCS1_PADDING = 1;
function $463833414b7fa82a$var$sign(hash, key, hashType, signType, tag) {
    var priv = $hdVtR(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $463833414b7fa82a$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $463833414b7fa82a$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    if (key.padding !== undefined && key.padding !== $463833414b7fa82a$var$RSA_PKCS1_PADDING) throw new Error('illegal or unsupported padding mode');
    hash = $463833414b7fa82a$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $2jcIV(pad, priv);
    return out;
}
function $463833414b7fa82a$var$ecSign(hash, priv) {
    var curveId = $484f9bbb9588ddbc$exports[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $463833414b7fa82a$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $463833414b7fa82a$require$Buffer.from(out.toDER());
}
function $463833414b7fa82a$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $aVh2m(0);
    var k;
    var H = $463833414b7fa82a$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $463833414b7fa82a$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $463833414b7fa82a$var$makeKey(q, kv, algo);
        r = $463833414b7fa82a$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $aVh2m(0);
        }
    }
    return $463833414b7fa82a$var$toDER(r, s);
}
function $463833414b7fa82a$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $463833414b7fa82a$require$Buffer.from(res);
}
function $463833414b7fa82a$var$getKey(x, q, hash, algo) {
    x = $463833414b7fa82a$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $463833414b7fa82a$require$Buffer.alloc(q.byteLength() - x.length);
        x = $463833414b7fa82a$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $463833414b7fa82a$var$bits2octets(hash, q);
    var v = $463833414b7fa82a$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $463833414b7fa82a$require$Buffer.alloc(hlen);
    k = $cL3Ff(algo, k).update(v).update($463833414b7fa82a$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $cL3Ff(algo, k).update(v).digest();
    k = $cL3Ff(algo, k).update(v).update($463833414b7fa82a$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $cL3Ff(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $463833414b7fa82a$var$bits2int(obits, q) {
    var bits = new $aVh2m(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $463833414b7fa82a$var$bits2octets(bits, q) {
    bits = $463833414b7fa82a$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $463833414b7fa82a$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $463833414b7fa82a$require$Buffer.alloc(q.byteLength() - out.length);
        out = $463833414b7fa82a$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $463833414b7fa82a$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $463833414b7fa82a$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $cL3Ff(algo, kv.k).update(kv.v).digest();
            t = $463833414b7fa82a$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $463833414b7fa82a$var$bits2int(t, q);
        kv.k = $cL3Ff(algo, kv.k).update(kv.v).update($463833414b7fa82a$require$Buffer.from([
            0
        ])).digest();
        kv.v = $cL3Ff(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $463833414b7fa82a$var$makeR(g, k, p, q) {
    return g.toRed($aVh2m.mont(p)).redPow(k).fromRed().mod(q);
}
$463833414b7fa82a$exports = $463833414b7fa82a$var$sign;
$463833414b7fa82a$exports.getKey = $463833414b7fa82a$var$getKey;
$463833414b7fa82a$exports.makeKey = $463833414b7fa82a$var$makeKey;


var $5a766155c8ab551b$exports = {};
'use strict';

var $838j1 = parcelRequire("838j1");
var $5a766155c8ab551b$require$Buffer = $838j1.Buffer;

var $aVh2m = parcelRequire("aVh2m");

var $a2sGY = parcelRequire("a2sGY");
var $5a766155c8ab551b$require$EC = $a2sGY.ec;

var $hdVtR = parcelRequire("hdVtR");

function $5a766155c8ab551b$var$verify(sig, hash, key, signType, tag) {
    var pub = $hdVtR(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $5a766155c8ab551b$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $5a766155c8ab551b$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    hash = $5a766155c8ab551b$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $5a766155c8ab551b$require$Buffer.from(pad);
    var red = $aVh2m.mont(pub.modulus);
    sig = new $aVh2m(sig).toRed(red);
    sig = sig.redPow(new $aVh2m(pub.publicExponent));
    sig = $5a766155c8ab551b$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $5a766155c8ab551b$var$ecVerify(sig, hash, pub) {
    var curveId = $484f9bbb9588ddbc$exports[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $5a766155c8ab551b$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $5a766155c8ab551b$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $hdVtR.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $5a766155c8ab551b$var$checkValue(s, q);
    $5a766155c8ab551b$var$checkValue(r, q);
    var montp = $aVh2m.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $aVh2m(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $5a766155c8ab551b$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= 0) throw new Error('invalid sig');
}
$5a766155c8ab551b$exports = $5a766155c8ab551b$var$verify;



var $gm4QM = parcelRequire("gm4QM");
Object.keys($gm4QM).forEach(function(key) {
    $gm4QM[key].id = $870db353fba87e6d$require$Buffer.from($gm4QM[key].id, 'hex');
    $gm4QM[key.toLowerCase()] = $gm4QM[key];
});
function $870db353fba87e6d$var$Sign(algorithm) {
    $dFZZW.Writable.call(this);
    var data = $gm4QM[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $eNPUV(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dhT4G($870db353fba87e6d$var$Sign, $dFZZW.Writable);
$870db353fba87e6d$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$870db353fba87e6d$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $870db353fba87e6d$require$Buffer.from(data, enc) : data);
    return this;
};
$870db353fba87e6d$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $463833414b7fa82a$exports(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $870db353fba87e6d$var$Verify(algorithm) {
    $dFZZW.Writable.call(this);
    var data = $gm4QM[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $eNPUV(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dhT4G($870db353fba87e6d$var$Verify, $dFZZW.Writable);
$870db353fba87e6d$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$870db353fba87e6d$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $870db353fba87e6d$require$Buffer.from(data, enc) : data);
    return this;
};
$870db353fba87e6d$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === 'string' ? $870db353fba87e6d$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $5a766155c8ab551b$exports(sigBuffer, hash, key, this._signType, this._tag);
};
function $870db353fba87e6d$var$createSign(algorithm) {
    return new $870db353fba87e6d$var$Sign(algorithm);
}
function $870db353fba87e6d$var$createVerify(algorithm) {
    return new $870db353fba87e6d$var$Verify(algorithm);
}
$870db353fba87e6d$exports = {
    Sign: $870db353fba87e6d$var$createSign,
    Verify: $870db353fba87e6d$var$createVerify,
    createSign: $870db353fba87e6d$var$createSign,
    createVerify: $870db353fba87e6d$var$createVerify
};


$4caff0eaeff97cc6$export$45df7cae684751af = $870db353fba87e6d$exports.createSign;
$4caff0eaeff97cc6$export$1db683ad541682f6 = $870db353fba87e6d$exports.Sign;
$4caff0eaeff97cc6$export$6f65485f87568e37 = $870db353fba87e6d$exports.createVerify;
$4caff0eaeff97cc6$export$91a8e56769aeb334 = $870db353fba87e6d$exports.Verify;

$4caff0eaeff97cc6$export$2d4117e99c2179e4 = (parcelRequire("iT16E"));
var $a86ab166e2d75ba5$export$512823e338ddb1b7;
var $a86ab166e2d75ba5$export$7efb24e2fddf99b9;
var $a86ab166e2d75ba5$export$9d0e0c0c4a8d30f3;
var $a86ab166e2d75ba5$export$b9d55ff329113abd;

$a86ab166e2d75ba5$export$512823e338ddb1b7 = (parcelRequire("eWI2k"));

$a86ab166e2d75ba5$export$7efb24e2fddf99b9 = (parcelRequire("fUUOC"));
$a86ab166e2d75ba5$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $a86ab166e2d75ba5$export$512823e338ddb1b7(key, buf, true);
};
$a86ab166e2d75ba5$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $a86ab166e2d75ba5$export$7efb24e2fddf99b9(key, buf, true);
};


$4caff0eaeff97cc6$export$512823e338ddb1b7 = $a86ab166e2d75ba5$export$512823e338ddb1b7;
$4caff0eaeff97cc6$export$9d0e0c0c4a8d30f3 = $a86ab166e2d75ba5$export$9d0e0c0c4a8d30f3;
$4caff0eaeff97cc6$export$b9d55ff329113abd = $a86ab166e2d75ba5$export$b9d55ff329113abd;
$4caff0eaeff97cc6$export$7efb24e2fddf99b9 = $a86ab166e2d75ba5$export$7efb24e2fddf99b9;
var $29796313a5dc60f7$export$bb1abf2ce84fc7e8;
var $29796313a5dc60f7$export$2f7171e78e524d5e;

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
function $29796313a5dc60f7$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}

var $838j1 = parcelRequire("838j1");

var $f08he = parcelRequire("f08he");
var $29796313a5dc60f7$var$Buffer = $838j1.Buffer;
var $29796313a5dc60f7$var$kBufferMaxLength = $838j1.kMaxLength;
var $29796313a5dc60f7$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $29796313a5dc60f7$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $29796313a5dc60f7$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $29796313a5dc60f7$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $29796313a5dc60f7$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $29796313a5dc60f7$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $29796313a5dc60f7$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $29796313a5dc60f7$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($29796313a5dc60f7$var$crypto && $29796313a5dc60f7$var$crypto.getRandomValues || false) {
    $29796313a5dc60f7$export$bb1abf2ce84fc7e8 = $29796313a5dc60f7$var$randomFill;
    $29796313a5dc60f7$export$2f7171e78e524d5e = $29796313a5dc60f7$var$randomFillSync;
} else {
    $29796313a5dc60f7$export$bb1abf2ce84fc7e8 = $29796313a5dc60f7$var$oldBrowser;
    $29796313a5dc60f7$export$2f7171e78e524d5e = $29796313a5dc60f7$var$oldBrowser;
}
function $29796313a5dc60f7$var$randomFill(buf, offset, size, cb) {
    if (!$29796313a5dc60f7$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $29796313a5dc60f7$var$assertOffset(offset, buf.length);
    $29796313a5dc60f7$var$assertSize(size, offset, buf.length);
    return $29796313a5dc60f7$var$actualFill(buf, offset, size, cb);
}
function $29796313a5dc60f7$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $29796313a5dc60f7$var$crypto.getRandomValues(uint);
    if (cb) {
        $4ZL0H.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $f08he(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $f08he(size);
    bytes.copy(buf, offset);
    return buf;
}
function $29796313a5dc60f7$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$29796313a5dc60f7$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $29796313a5dc60f7$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $29796313a5dc60f7$var$assertSize(size, offset, buf.length);
    return $29796313a5dc60f7$var$actualFill(buf, offset, size);
}


$4caff0eaeff97cc6$export$bb1abf2ce84fc7e8 = $29796313a5dc60f7$export$bb1abf2ce84fc7e8;
$4caff0eaeff97cc6$export$2f7171e78e524d5e = $29796313a5dc60f7$export$2f7171e78e524d5e;
$4caff0eaeff97cc6$export$e1d879b482f37d98 = function() {
    throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};
$4caff0eaeff97cc6$export$1a988e7317c65621 = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
};



var $7fPBF = parcelRequire("7fPBF");





function $b8d2d4cc121e033d$var$useGlobalCustomControlsContainer() {
    const deviceContainer = (0, $57ef534a0961ba07$export$2e2bcd8739ae039).useContainer();
    const currentDeviceContainer = (0, $43d630686eddb628$export$2e2bcd8739ae039).useContainer();
    const [availableCustomControls, setAvailableCustomControls, availableCustomControlsRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(null);
    const userLocale = (0, $7fPBF.useRef)((0, $3ecd3f7dea3d56de$export$f44b61b0f29ec));
    const [profileCustomControls, setProfileCustomControls, profileCustomControlsRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(null);
    const customControlsLocaleRef = (0, $7fPBF.useRef)((0, $3ecd3f7dea3d56de$export$f44b61b0f29ec));
    const voicePausedCustomControlsRef = (0, $7fPBF.useRef)(new Set());
    const voiceDictationCustomControlsRef = (0, $7fPBF.useRef)(new Set());
    const voicePrefixCustomControlsRef = (0, $7fPBF.useRef)(new Set());
    const devicesCountRef = (0, $7fPBF.useRef)(0);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [errors, setErrors] = (0, $7fPBF.useState)([]);
    const [resetDeviceControls, setResetDeviceControls] = (0, $7fPBF.useState)(false);
    const handleVoiceDictationControlsUpdate = (dictationControls)=>{
        voiceDictationCustomControlsRef.current = dictationControls;
        (0, $e7df95de73caec26$export$89b472e03be495df)('update-voice-dictation-controls', dictationControls);
    };
    const initializeFromStorage = (localePreferences)=>{
        try {
            setIsLoading(true);
            const storedControls = localStorage.getItem((0, $db3063bd3b6d501e$export$7b02f2982f8105ff));
            let available = [];
            if (storedControls) {
                const parsedControls = JSON.parse(storedControls);
                const devices = deviceContainer.devicesRef.current;
                if (devices) for (let device of devices){
                    const storedDeviceControls = parsedControls.available.find((d)=>d.deviceId === device.id);
                    if (storedDeviceControls) {
                        let controls = storedDeviceControls.controls;
                        controls = storedDeviceControls.controls;
                        available.push({
                            deviceId: device.id,
                            deviceTypeId: device.device?.deviceType?.id || device.id,
                            name: deviceContainer.getDeviceName(device.id),
                            controls: controls
                        });
                    }
                }
                const globalControls = parsedControls.available.find((d)=>d.deviceId === 'global');
                if (globalControls) available.push({
                    deviceId: 'global',
                    deviceTypeId: 'global',
                    name: 'Cephable',
                    controls: globalControls.controls
                });
                setAvailableCustomControls(available);
                setProfileCustomControls(parsedControls.profile);
                customControlsLocaleRef.current = localePreferences.defaultVoiceLocale;
                voicePausedCustomControlsRef.current = new Set(parsedControls.paused);
                handleVoiceDictationControlsUpdate(new Set(parsedControls.dictation));
                voicePrefixCustomControlsRef.current = new Set(parsedControls.prefix);
            }
        } catch (e) {
            console.log(e);
            setErrors([
                'Failed to parse custom controls from local storage.'
            ]);
        } finally{
            setIsLoading(false);
        }
    };
    const initializeFromRemote = async (localePreferences, virtualDeviceId)=>{
        userLocale.current = localePreferences.defaultVoiceLocale;
        try {
            setIsLoading(true);
            const locale = localePreferences.defaultVoiceLocale;
            customControlsLocaleRef.current = locale;
            const interfaceResult = await $1a4c36336f303477$export$3c6d5a5870f12c81(locale);
            // get virtual device controls from API because of seeded device type controls (ie Open App)
            const virtualDeviceResult = virtualDeviceId ? await $1a4c36336f303477$export$600b579bd3ac45b1(virtualDeviceId, locale) : new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
            let available = [];
            let profile = [];
            const devices = deviceContainer.devicesRef.current;
            if (devices) for (let device of devices){
                if (device.isVerified === false) continue;
                const deviceType = device.device?.deviceType;
                // If there are no custom controls for the device, check if there are device type controls to seed it with
                if (deviceType && device.customControls.length === 0 && device.customDeviceTypeControlOverrides.length === 0) {
                    const deviceTypeControlsResult = await $1a4c36336f303477$export$fb1c38ee1d8d29f5(deviceType.id, locale);
                    if (deviceTypeControlsResult?.resultType === 'Ok' && deviceTypeControlsResult.data) device.customControls = deviceTypeControlsResult.data.controls.map((c)=>({
                            ...c,
                            isDeviceTypeControl: true
                        }));
                }
                if (device.customControls.length === 0 && device.customDeviceTypeControlOverrides.length === 0) continue;
                const deviceId = device.id;
                const deviceName = deviceContainer.getDeviceName(deviceId);
                const isPrivate = deviceType?.isPrivate;
                let controls;
                if (deviceId === virtualDeviceId && virtualDeviceResult?.resultType === 'Ok' && virtualDeviceResult.data) controls = virtualDeviceResult.data.controls;
                else controls = (0, $2616fe0411c33582$export$82e40272e8bb746b)(device.customControls, device.customDeviceTypeControlOverrides);
                available.push({
                    deviceId: device.id,
                    deviceTypeId: deviceType.id,
                    name: deviceName,
                    isPrivate: isPrivate,
                    controls: controls
                });
                const profileControls = controls.filter((c)=>c.isProfileControl);
                if (profileControls.length > 0) profile.push({
                    deviceId: device.id,
                    deviceTypeId: deviceType.id,
                    name: deviceName,
                    isPrivate: isPrivate,
                    controls: profileControls
                });
            }
            if (interfaceResult?.resultType == 'Ok' && interfaceResult.data) {
                // Add global interface controls
                const interfaceControlRemote = interfaceResult.data;
                const globalDevice = {
                    deviceId: 'global',
                    deviceTypeId: 'global',
                    name: 'Cephable',
                    isPrivate: false,
                    controls: interfaceControlRemote.controls
                };
                available.push(globalDevice);
                const profileInterface = interfaceResult.data.controls.filter((c)=>c.isProfileControl);
                if (profileInterface.length > 0) profile.push(globalDevice);
            }
            setProfileCustomControls(profile);
            setAvailableCustomControls(available);
            resetVoiceCustomControls();
            snapshotState();
            return new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)(true);
        } catch (error) {
            console.log(error);
            setErrors(errors);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setIsLoading(false);
        }
    };
    async function getDeviceCustomControls(userDeviceId) {
        try {
            const result = await $1a4c36336f303477$export$600b579bd3ac45b1(userDeviceId, customControlsLocaleRef.current);
            return result;
        } catch (e) {
            console.log(e);
            setErrors([
                'Error getting device custom controls'
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    }
    const currentDeviceControls = (0, $7fPBF.useMemo)(()=>{
        const deviceControls = [];
        const global = availableCustomControlsRef.current?.find((d)=>d.deviceId === 'global')?.controls;
        const device = availableCustomControlsRef.current?.find((d)=>d.deviceId === currentDeviceContainer.id)?.controls;
        if (device) deviceControls.push(...device);
        if (global) deviceControls.push(...global);
        return {
            global: global,
            device: device
        };
    }, [
        availableCustomControls,
        currentDeviceContainer.id
    ]);
    function snapshotState() {
        localStorage.setItem((0, $db3063bd3b6d501e$export$7b02f2982f8105ff), JSON.stringify({
            available: availableCustomControlsRef.current,
            profile: profileCustomControlsRef.current,
            paused: [
                ...voicePausedCustomControlsRef.current
            ],
            dictation: [
                ...voiceDictationCustomControlsRef.current
            ],
            prefix: [
                ...voicePrefixCustomControlsRef.current
            ]
        }));
    }
    function resetVoiceCustomControls() {
        voicePausedCustomControlsRef.current.clear();
        handleVoiceDictationControlsUpdate(new Set());
        voicePrefixCustomControlsRef.current.clear();
        let paused = [];
        let dictation = [];
        let prefix = [];
        availableCustomControlsRef.current?.forEach((deviceControls)=>{
            // ignore general DeviceType controls but allow global controls
            if (deviceControls.deviceId !== deviceControls.deviceTypeId || deviceControls.deviceId === 'global') {
                const voicePausedControls = deviceControls.controls.filter((c)=>c.allowWhenVoicePaused);
                const voiceDictationControls = deviceControls.controls.filter((c)=>c.allowWhenDictating);
                const voicePrefixControls = deviceControls.controls.filter((c)=>c.isPrefixVoiceCommand);
                voicePausedControls.forEach((c)=>{
                    if (c.commands) paused.push(...c.commands);
                });
                voiceDictationControls.forEach((c)=>{
                    if (c.commands) dictation.push(...c.commands);
                });
                voicePrefixControls.forEach((c)=>{
                    if (c.commands) prefix.push(...c.commands);
                });
            }
        });
        voicePausedCustomControlsRef.current = new Set(paused);
        handleVoiceDictationControlsUpdate(new Set(dictation));
        voicePrefixCustomControlsRef.current = new Set(prefix);
    }
    function getDeviceControlName(controlId) {
        if (!availableCustomControlsRef.current) return controlId;
        for(let device in availableCustomControlsRef.current)for (let control of availableCustomControlsRef.current[device].controls){
            if (control.id == controlId) return control.name;
        }
        return controlId;
    }
    function updateAvailableCustomControls(index, controls, deviceId, deviceTypeId, name) {
        if (availableCustomControlsRef.current) {
            if (index < 0) setAvailableCustomControls([
                ...availableCustomControlsRef.current,
                {
                    deviceId: deviceId,
                    deviceTypeId: deviceTypeId,
                    name: name,
                    controls: controls
                }
            ]);
            else availableCustomControlsRef.current[index].controls = controls;
            setAvailableCustomControls([
                ...availableCustomControlsRef.current
            ]);
        }
        resetVoiceCustomControls();
        snapshotState();
    }
    async function updateAppInterfaceControls(overrides) {
        const allAppInterfaceControls = availableCustomControlsRef.current?.find((d)=>d.deviceId === 'global')?.controls || [];
        const sendAppInterfaceControls = allAppInterfaceControls.map((c)=>{
            const override = overrides.find((o)=>o.appInterfaceControlId === c.id);
            return {
                appInterfaceControlId: c.id,
                commands: override?.commands || c?.commands || []
            };
        });
        try {
            const result = await $1a4c36336f303477$export$1ac6c99dd884ccad(sendAppInterfaceControls, customControlsLocaleRef.current);
            if (result?.resultType === 'Ok' && result.data) {
                updateLocalAppInterfaceControls(result.data);
                return result;
            }
        } catch (e) {
            console.log(e);
            setErrors([
                'Error updating app interface controls'
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    }
    async function updateDeviceCustomControls(deviceId, overrides) {
        if (!availableCustomControlsRef.current) return;
        const allDeviceControls = availableCustomControlsRef.current.find((d)=>d.deviceId === deviceId)?.controls;
        if (!allDeviceControls) return;
        const sendDeviceControls = allDeviceControls.map((c)=>{
            const override = overrides.find((o)=>o.deviceTypeCustomControlId === c.id);
            return {
                deviceTypeCustomControlId: c.id,
                commands: override?.commands || c?.commands || []
            };
        });
        try {
            const result = await $1a4c36336f303477$export$b9a2c62bbb3b9917(deviceId, sendDeviceControls, customControlsLocaleRef.current);
            if (result.resultType === 'Ok' && result.data) {
                updateLocalDeviceCustomControls(result.data);
                return result;
            }
        } catch (e) {
            console.log(e);
            setErrors([
                'Error updating device custom controls'
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    }
    async function updateCustomUserDeviceControls(deviceId, controlsToUpdate, locale) {
        if (!deviceId || !controlsToUpdate) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        if (controlsToUpdate.length === 0) return;
        try {
            const result = await $1a4c36336f303477$export$acdb1997acaa39c3(deviceId, controlsToUpdate, locale);
        } catch (e) {
            console.log(e);
            setErrors([
                `Error updating device custom controls`
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    }
    function updateLocalAppInterfaceControls(appInterfaceControls) {
        if (!appInterfaceControls) return;
        const deviceIndex = availableCustomControlsRef.current?.findIndex((d)=>d.deviceId === 'global');
        if (deviceIndex == undefined) return;
        updateAvailableCustomControls(deviceIndex, appInterfaceControls.controls, 'global', 'global', 'Cephable');
    }
    function updateLocalDeviceCustomControls(deviceCustomControls) {
        const deviceId = deviceCustomControls?.userDeviceId;
        if (!deviceId) return;
        const deviceIndex = availableCustomControlsRef.current?.findIndex((d)=>d.deviceId === deviceId);
        const deviceName = deviceContainer.getDeviceName(deviceId);
        if (deviceIndex == undefined) return;
        updateAvailableCustomControls(deviceIndex, deviceCustomControls.controls, deviceId, deviceId, deviceName);
    }
    function convertCustomControlToMacro(customControls, control, additionalInputContent) {
        const macro = {
            id: control.id,
            name: control.name,
            commands: control.commands || [],
            events: [
                {
                    eventType: 'DeviceTypeCustomAction',
                    additionalInputContent: additionalInputContent,
                    deviceTypeCustomActionId: control.id,
                    deviceTypeId: customControls.deviceId
                }
            ]
        };
        return macro;
    }
    function separatePrefixCommand(command) {
        if (!voicePrefixCustomControlsRef.current || !command) return undefined;
        for (let prefix of voicePrefixCustomControlsRef.current)if (command.toLowerCase().startsWith(prefix)) {
            let additionalInputStartIndex = prefix.length;
            while(command[additionalInputStartIndex] === ' ')additionalInputStartIndex++;
            const phrase = command?.substring(additionalInputStartIndex);
            return {
                prefix: prefix,
                phrase: phrase
            };
        }
        return undefined;
    }
    function cleanCommand(command) {
        return command.toLowerCase().trim();
    }
    function findCustomControl(command, currentDeviceId, isEligibleControl, additionalInputContent) {
        if (!availableCustomControlsRef.current) return null;
        for (const deviceControls of availableCustomControlsRef.current)if (deviceControls.deviceId === currentDeviceId || deviceControls.deviceId === 'global') {
            for (const control of deviceControls.controls)if (isEligibleControl(control) && control.commands?.includes(command)) {
                const macro = convertCustomControlToMacro(deviceControls, control, additionalInputContent);
                return macro;
            }
        }
        return null;
    }
    function getFinalControlMacro(command, currentDeviceId, additionalInputContent, isEligibleControl) {
        // find any macro control and account for prefix controls
        const cleanedCommand = cleanCommand(command);
        if (cleanedCommand.length === 0) return null;
        const cleanedPrefixCommand = separatePrefixCommand(command);
        let effectiveCommand = cleanedCommand;
        if (cleanedPrefixCommand) {
            effectiveCommand = cleanedPrefixCommand.prefix;
            additionalInputContent = cleanedPrefixCommand.phrase;
        }
        const isEligible = isEligibleControl ?? ((control)=>true);
        return findCustomControl(effectiveCommand, currentDeviceId, isEligible, additionalInputContent);
    }
    function getFinalDictationControlMacro(command, currentDeviceId, isPaused, additionalInputContent) {
        // find controls that are not prefix controls
        const cleanedCommand = cleanCommand(command);
        if (cleanedCommand.length === 0) return null;
        const cleanedPrefixCommand = separatePrefixCommand(command);
        let effectiveCommand = cleanedCommand;
        if (cleanedPrefixCommand) {
            effectiveCommand = cleanedPrefixCommand.prefix;
            additionalInputContent = cleanedPrefixCommand.phrase;
        }
        if (isPaused) {
            const isPausedCommand = voicePausedCustomControlsRef.current.has(effectiveCommand);
            if (!isPausedCommand) return null;
        } else {
            const isDictationCommand = voiceDictationCustomControlsRef.current.has(effectiveCommand);
            if (!isDictationCommand) return null;
        }
        return findCustomControl(effectiveCommand, currentDeviceId, (command)=>true, additionalInputContent);
    }
    function getPartialControlMacro(command, currentDeviceId, additionalInputContent, isEligibleControl) {
        // find controls that are not prefix or dictation controls
        const cleanedCommand = cleanCommand(command);
        if (cleanedCommand.length === 0) return null;
        const isEligible = isEligibleControl ?? ((control)=>true);
        return findCustomControl(cleanedCommand, currentDeviceId, (control)=>!control.isPrefixVoiceCommand && !control.allowWhenDictating && isEligible(control), additionalInputContent);
    }
    function getAllCustomCommandsMap() {
        const map = new Map();
        if (!availableCustomControlsRef.current) return map;
        for (const deviceControls of availableCustomControlsRef.current){
            if (deviceControls.controls) for (const control of deviceControls.controls){
                if (control.commands) for (const command of control.commands){
                    const key = deviceControls.deviceId + (0, $4caff0eaeff97cc6$exports.randomUUID)();
                    map.set(key, {
                        id: control.id,
                        source: deviceControls.deviceId,
                        value: command.toLowerCase(),
                        name: control.name,
                        deviceName: deviceControls.name
                    });
                }
            }
        }
        return map;
    }
    function clear() {
        setAvailableCustomControls([]);
        setProfileCustomControls([]);
        voicePausedCustomControlsRef.current.clear();
        handleVoiceDictationControlsUpdate(new Set());
        voicePrefixCustomControlsRef.current.clear();
        localStorage.removeItem('CUSTOM_CONTROLS');
    }
    async function resetCustomControls(localePreferences) {
        const locale = localePreferences.defaultVoiceLocale;
        customControlsLocaleRef.current = locale;
        const interfaceResult = await $1a4c36336f303477$export$1ac6c99dd884ccad([], locale);
        if (interfaceResult?.resultType === 'Ok' && interfaceResult.data) updateLocalAppInterfaceControls(interfaceResult.data);
        const devices = deviceContainer.devicesRef.current;
        if (devices) for (let device of devices){
            if (device.isVerified === false) continue;
            const result = await $1a4c36336f303477$export$b9a2c62bbb3b9917(device.id, [], locale);
            if (result?.resultType === 'Ok' && result.data) {
                setResetDeviceControls(true);
                updateLocalDeviceCustomControls(result.data);
            }
        }
    }
    function removeDeviceControls(deviceId) {
        const updatedAvailableControls = availableCustomControlsRef.current?.filter((d)=>d.deviceId !== deviceId) || null;
        setAvailableCustomControls(updatedAvailableControls);
        const updatedProfileControls = profileCustomControlsRef.current?.filter((d)=>d.deviceId !== deviceId) || null;
        setProfileCustomControls(updatedProfileControls);
        resetVoiceCustomControls();
        snapshotState();
    }
    async function addDeviceControls(device) {
        const locale = customControlsLocaleRef.current;
        try {
            setIsLoading(true);
            const deviceType = device.device?.deviceType;
            // Seed with device type controls if none exist
            if (deviceType && device.customControls.length === 0 && device.customDeviceTypeControlOverrides.length === 0) {
                const deviceTypeControlsResult = await $1a4c36336f303477$export$fb1c38ee1d8d29f5(deviceType.id, locale);
                if (deviceTypeControlsResult?.resultType === 'Ok' && deviceTypeControlsResult.data) device.customControls = deviceTypeControlsResult.data.controls.map((c)=>({
                        ...c,
                        isDeviceTypeControl: true
                    }));
            }
            // If still no controls, nothing to add
            if (device.customControls.length === 0 && device.customDeviceTypeControlOverrides.length === 0) return new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)(true);
            const deviceId = device.id;
            const deviceName = deviceContainer.getDeviceName(deviceId);
            const isPrivate = deviceType?.isPrivate;
            const controls = (0, $2616fe0411c33582$export$82e40272e8bb746b)(device.customControls, device.customDeviceTypeControlOverrides);
            const newEntry = {
                deviceId: deviceId,
                deviceTypeId: deviceType.id,
                name: deviceName,
                isPrivate: isPrivate,
                controls: controls
            };
            setAvailableCustomControls((prev)=>[
                    ...prev ?? [],
                    newEntry
                ]);
            const profileControls = controls.filter((c)=>c.isProfileControl);
            if (profileControls.length > 0) setProfileCustomControls((prev)=>[
                    ...prev ?? [],
                    {
                        ...newEntry,
                        controls: profileControls
                    }
                ]);
            snapshotState();
            return new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)(true);
        } catch (error) {
            console.log(error);
            setErrors(errors);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setIsLoading(false);
        }
    }
    (0, $7fPBF.useEffect)(()=>{
        const unsubDeviceAdded = (0, $e7df95de73caec26$export$ec068583843480e7)('device-added', (data)=>{
            addDeviceControls(data.device);
        });
        const unsubDeviceRemoved = (0, $e7df95de73caec26$export$ec068583843480e7)('remove-device', (data)=>{
            removeDeviceControls(data.device.id);
        });
        return ()=>{
            unsubDeviceAdded();
            unsubDeviceRemoved();
        };
    }, []);
    return {
        initializeFromStorage: initializeFromStorage,
        initializeFromRemote: initializeFromRemote,
        availableCustomControls: availableCustomControls,
        availableCustomControlsRef: availableCustomControlsRef,
        devicesCountRef: devicesCountRef,
        errors: errors,
        profileCustomControls: profileCustomControls,
        profileCustomControlsRef: profileCustomControlsRef,
        voicePausedCustomControlsRef: voicePausedCustomControlsRef,
        voiceDictationCustomControlsRef: voiceDictationCustomControlsRef,
        voicePrefixCustomControlsRef: voicePrefixCustomControlsRef,
        updateAppInterfaceControls: updateAppInterfaceControls,
        updateLocalAppInterfaceControls: updateLocalAppInterfaceControls,
        updateDeviceCustomControls: updateDeviceCustomControls,
        updateLocalDeviceCustomControls: updateLocalDeviceCustomControls,
        getDeviceControlName: getDeviceControlName,
        getFinalControlMacro: getFinalControlMacro,
        getFinalDictationControlMacro: getFinalDictationControlMacro,
        getPartialControlMacro: getPartialControlMacro,
        resetVoiceCustomControls: resetVoiceCustomControls,
        getAllCustomCommandsMap: getAllCustomCommandsMap,
        currentDeviceControls: currentDeviceControls,
        clear: clear,
        isLoading: isLoading,
        resetCustomControls: resetCustomControls,
        customControlsLocaleRef: customControlsLocaleRef,
        resetDeviceControls: resetDeviceControls,
        setResetDeviceControls: setResetDeviceControls,
        getDeviceCustomControls: getDeviceCustomControls,
        updateCustomUserDeviceControls: updateCustomUserDeviceControls,
        setAvailableCustomControls: setAvailableCustomControls,
        snapshotState: snapshotState
    };
}
const $b8d2d4cc121e033d$var$GlobalCustomControlsContainer = (0, $78783f85c4167892$export$26ae5ca175b4ec5a)($b8d2d4cc121e033d$var$useGlobalCustomControlsContainer);
var $b8d2d4cc121e033d$export$2e2bcd8739ae039 = $b8d2d4cc121e033d$var$GlobalCustomControlsContainer;


function $31424fe514516834$export$2e2bcd8739ae039() {
    const { currentUserRef: currentUserRef } = (0, $8a1185b15e8317ab$export$2e2bcd8739ae039).useContainer();
    const { getAllCustomCommandsMap: getAllCustomCommandsMap } = (0, $b8d2d4cc121e033d$export$2e2bcd8739ae039).useContainer();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    function getGlobalEditProfileConflicts(macros, dictationCommands, keyCommands, profileId) {
        const deviceIntersectionMap = new Map([]);
        const globalIntersections = [];
        let deviceCommandConflictDisplay = [];
        let globalCommandConflictDisplay = [];
        const editProfileCommandsMap = new Map();
        if (currentUserRef.current?.userPreferences?.isWarningConflictIndicatorsOptOut) return {
            globalCommandConflictDisplay: globalCommandConflictDisplay,
            deviceCommandConflictDisplay: deviceCommandConflictDisplay
        };
        const addCommandsToMap = (commandsMap, commands, macroOrKeyId, macroOrKeyName, pageLink)=>{
            for (const command of commands){
                const normalizedCommand = command.command.trim().toLowerCase();
                if (!normalizedCommand) continue;
                if (!commandsMap.has(normalizedCommand)) commandsMap.set(normalizedCommand, []);
                commandsMap.get(normalizedCommand).push({
                    macroOrKeyName: macroOrKeyName ? macroOrKeyName : t('common:noName'),
                    commandDisplayName: command?.command,
                    macroOrKeyId: macroOrKeyId,
                    pageLink: pageLink
                });
            }
        };
        if (macros) for (const macro of macros)addCommandsToMap(editProfileCommandsMap, macro.commands, macro.id, macro.name ? macro.name : t('common:noName'), `/profiles/edit/${profileId}`);
        if (keyCommands) for (const keyCommand of keyCommands)addCommandsToMap(editProfileCommandsMap, keyCommand.commands, keyCommand.key, `${t('common:keys.title')}: ${keyCommand.displayName}`, `/profiles/edit/${profileId}/advanced/keybindings`);
        if (dictationCommands) addCommandsToMap(editProfileCommandsMap, dictationCommands.map((command)=>({
                command: command,
                commandType: 'dictationCommand'
            })), 'dictation', t('common:dictation.title'), `/profiles/edit/${profileId}/advanced/dictation`);
        const customCommandsMap = getAllCustomCommandsMap();
        // Iterate through custom commands and check for intersections
        for (const [customValue, customDetails] of customCommandsMap){
            const normalizedCustomValue = customDetails.value.trim().toLowerCase();
            if (editProfileCommandsMap.has(normalizedCustomValue)) {
                const profileDetailsArray = editProfileCommandsMap.get(normalizedCustomValue);
                if (!profileDetailsArray) continue;
                for (const profileDetails of profileDetailsArray)if (customDetails.source === 'global') globalIntersections.push({
                    key: (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)(),
                    scrollID: profileDetails.macroOrKeyId,
                    displayString: `"${normalizedCustomValue}" ${t('common:customControls.conflictIndicators.usedInput')} ${customDetails.deviceName}: ${customDetails.name} & ${profileDetails.macroOrKeyName}`,
                    pageLink: profileDetails.pageLink
                });
                else {
                    if (!deviceIntersectionMap.has(customDetails.source)) deviceIntersectionMap.set(customDetails.source, []);
                    deviceIntersectionMap.get(customDetails.source).push({
                        key: (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)(),
                        scrollID: profileDetails.macroOrKeyId,
                        displayString: `"${normalizedCustomValue}" ${t('common:customControls.conflictIndicators.usedInput')} ${customDetails.deviceName}: ${customDetails.name} & ${profileDetails.macroOrKeyName} `,
                        pageLink: profileDetails.pageLink
                    });
                }
            }
        }
        deviceCommandConflictDisplay = [
            ...deviceIntersectionMap.values()
        ].flat();
        globalCommandConflictDisplay = globalIntersections;
        return {
            deviceCommandConflictDisplay: deviceCommandConflictDisplay,
            globalCommandConflictDisplay: globalCommandConflictDisplay
        };
    }
    return getGlobalEditProfileConflicts;
}






class $e46dfbc23b659948$export$2e2bcd8739ae039 {
    static getDescendantProperty(object, path, list = []) {
        let firstSegment;
        let remaining;
        let dotIndex;
        let value;
        let index;
        let length;
        if (path) {
            dotIndex = path.indexOf('.');
            if (dotIndex === -1) firstSegment = path;
            else {
                firstSegment = path.slice(0, dotIndex);
                remaining = path.slice(dotIndex + 1);
            }
            value = object[firstSegment];
            if (value !== null && typeof value !== 'undefined') {
                if (!remaining && (typeof value === 'string' || typeof value === 'number')) list.push(value);
                else if (Object.prototype.toString.call(value) === '[object Array]') for(index = 0, length = value.length; index < length; index++)$e46dfbc23b659948$export$2e2bcd8739ae039.getDescendantProperty(value[index], remaining, list);
                else if (remaining) $e46dfbc23b659948$export$2e2bcd8739ae039.getDescendantProperty(value, remaining, list);
            }
        } else list.push(object);
        return list;
    }
}


class $666c2eeb26cf6d23$export$2e2bcd8739ae039 {
    constructor(haystack = [], keys = [], options = {}){
        if (!Array.isArray(keys)) {
            options = keys;
            keys = [];
        }
        this.haystack = haystack;
        this.keys = keys;
        this.options = Object.assign({
            caseSensitive: false,
            sort: false
        }, options);
    }
    search(query = '') {
        if (query === '') return this.haystack;
        const results = [];
        for(let i = 0; i < this.haystack.length; i++){
            const item = this.haystack[i];
            if (this.keys.length === 0) {
                const score = $666c2eeb26cf6d23$export$2e2bcd8739ae039.isMatch(item, query, this.options.caseSensitive);
                if (score) results.push({
                    item: item,
                    score: score
                });
            } else for(let y = 0; y < this.keys.length; y++){
                const propertyValues = (0, $e46dfbc23b659948$export$2e2bcd8739ae039).getDescendantProperty(item, this.keys[y]);
                let found = false;
                for(let z = 0; z < propertyValues.length; z++){
                    const score = $666c2eeb26cf6d23$export$2e2bcd8739ae039.isMatch(propertyValues[z], query, this.options.caseSensitive);
                    if (score) {
                        found = true;
                        results.push({
                            item: item,
                            score: score
                        });
                        break;
                    }
                }
                if (found) break;
            }
        }
        if (this.options.sort) results.sort((a, b)=>a.score - b.score);
        return results.map((result)=>result.item);
    }
    static isMatch(item, query, caseSensitive) {
        item = String(item);
        query = String(query);
        if (!caseSensitive) {
            item = item.toLocaleLowerCase();
            query = query.toLocaleLowerCase();
        }
        const indexes = $666c2eeb26cf6d23$export$2e2bcd8739ae039.nearestIndexesFor(item, query);
        if (!indexes) return false;
        // Exact matches should be first.
        if (item === query) return 1;
        // If we have more than 2 letters, matches close to each other should be first.
        if (indexes.length > 1) return 2 + (indexes[indexes.length - 1] - indexes[0]);
        // Matches closest to the start of the string should be first.
        return 2 + indexes[0];
    }
    static nearestIndexesFor(item, query) {
        const letters = query.split('');
        let indexes = [];
        const indexesOfFirstLetter = $666c2eeb26cf6d23$export$2e2bcd8739ae039.indexesOfFirstLetter(item, query);
        indexesOfFirstLetter.forEach((startingIndex, loopingIndex)=>{
            let index = startingIndex + 1;
            indexes[loopingIndex] = [
                startingIndex
            ];
            for(let i = 1; i < letters.length; i++){
                const letter = letters[i];
                index = item.indexOf(letter, index);
                if (index === -1) {
                    indexes[loopingIndex] = false;
                    break;
                }
                indexes[loopingIndex].push(index);
                index++;
            }
        });
        indexes = indexes.filter((letterIndexes)=>letterIndexes !== false);
        if (!indexes.length) return false;
        return indexes.sort((a, b)=>{
            if (a.length === 1) return a[0] - b[0];
            a = a[a.length - 1] - a[0];
            b = b[b.length - 1] - b[0];
            return a - b;
        })[0];
    }
    static indexesOfFirstLetter(item, query) {
        const match = query[0];
        return item.split('').map((letter, index)=>{
            if (letter !== match) return false;
            return index;
        }).filter((index)=>index !== false);
    }
}



var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");




function $60065a32b4a31650$var$useProfilesContainer() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [profiles, setProfiles, profilesRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)([]);
    const [allProfiles, setAllProfiles, allProfilesRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)([]);
    const [organizationProfiles, setOrganizationProfiles, organizationProfilesRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)([]);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [errors, setErrors] = (0, $7fPBF.useState)([]);
    const lastModifiedDate = (0, $7fPBF.useRef)(null);
    const associatedProgramsListRef = (0, $7fPBF.useRef)({});
    const associatedProgramsAppNames = (0, $7fPBF.useRef)([]);
    const appNameFuzzySearchRef = (0, $7fPBF.useRef)(null);
    const getSortedProfiles = (newProfiles)=>{
        const sortedProfiles = newProfiles.slice().sort((a, b)=>{
            return a.name.localeCompare(b.name);
        });
        return sortedProfiles;
    };
    const setLocalProfiles = (newProfiles, ignoreLocalStorage = false)=>{
        const sortedProfiles = getSortedProfiles(newProfiles);
        setProfiles(sortedProfiles);
        if (!ignoreLocalStorage) localStorage.setItem('DEVICE_PROFILES', JSON.stringify(sortedProfiles));
    };
    const initializeFromStorage = ()=>{
        try {
            const localProfiles = localStorage.getItem('DEVICE_PROFILES');
            if (localProfiles) setLocalProfiles(JSON.parse(localProfiles), true);
        } catch (e) {
            console.log(e);
        }
    };
    const getProfiles = async ()=>{
        try {
            setIsLoading(true);
            const result = await $1a4c36336f303477$export$3620b5cb1c7d18ec();
            setIsLoading(false);
            if (result?.resultType == 'Ok' && result.data) setLocalProfiles(result.data);
            return result;
        } catch (e) {
            setIsLoading(false);
            console.log(e);
            setErrors([
                'Error getting profiles'
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const deleteProfile = async (profileId, isHidden)=>{
        try {
            const result = await $1a4c36336f303477$export$29d101fdcde3d3d3(profileId);
            if (result?.resultType == 'Ok') {
                const clone = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).cloneDeep(profilesRef.current);
                const newProfiles = clone.filter((x)=>x.id != profileId);
                const profile = profilesRef.current.find((x)=>x.id == profileId);
                (0, $e7df95de73caec26$export$89b472e03be495df)('profileDeleted', {
                    profile: profile
                });
                setLocalProfiles(newProfiles);
                if (!isHidden) (0, $e7df95de73caec26$export$89b472e03be495df)('alertSuccess', {
                    message: t('common:profile.success.delete'),
                    timeout: 5000
                });
            }
            return result;
        } catch (e) {
            console.log(e);
            setErrors([
                'Error deleting profile'
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const addProfile = async (profile)=>{
        const newProfiles = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).cloneDeep(profilesRef.current);
        if (newProfiles.find((x)=>x.id == profile.id)) updateProfile(profile);
        else {
            newProfiles.push(profile);
            setLocalProfiles(newProfiles);
        }
    };
    const updateProfile = (profile)=>{
        const clone = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).cloneDeep(profilesRef.current);
        const existingProfile = clone.find((x)=>x.id === profile.id);
        if (existingProfile && (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).isEqual(existingProfile, profile)) return;
        const newProfiles = clone.map((x)=>{
            if (x.id == profile.id) return profile;
            return x;
        });
        setLocalProfiles(newProfiles);
    };
    const removeLocalProfile = (profileId)=>{
        const clone = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).cloneDeep(profilesRef.current);
        const newProfiles = clone.filter((x)=>x.id != profileId);
        setLocalProfiles(newProfiles);
    };
    const createShareLink = async (profileId, isSingleUse, expirationDate)=>{
        if (!profileId) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        try {
            const result = await $1a4c36336f303477$export$6dcf149406a53b24(profileId, {
                expirationDate: expirationDate?.toISOString(),
                isSingleUse: isSingleUse,
                isPublic: true
            });
            if (result?.resultType == 'Ok') (0, $e7df95de73caec26$export$89b472e03be495df)('alertSuccess', {
                message: t('common:profile.success.share'),
                timeout: 5000
            });
            return result;
        } catch (e) {
            console.log(e);
            setErrors([
                'Error creating share link'
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const getShares = async (profileId)=>{
        if (!profileId) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        try {
            const result = await $1a4c36336f303477$export$c7b3bc714f32d7a9(profileId);
            return result;
        } catch (e) {
            setErrors([
                'Error getting shares'
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const deleteShare = async (shareId)=>{
        try {
            const result = await $1a4c36336f303477$export$80c41221f92ef9be(shareId);
            if (result?.resultType == 'Ok') (0, $e7df95de73caec26$export$89b472e03be495df)('alertSuccess', {
                message: t('common:profile.success.shareDelete'),
                timeout: 5000
            });
            return result;
        } catch (e) {
            console.log(e);
            setErrors([
                'Error deleting share link'
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const generateProfile = async (request)=>{
        try {
            const result = await $1a4c36336f303477$export$8fe3f057eebad1bc(request);
            if (result?.resultType == 'Ok') (0, $e7df95de73caec26$export$89b472e03be495df)('alertSuccess', {
                message: t('common:profile.success.generate'),
                timeout: 5000
            });
            return result;
        } catch (e) {
            console.log(e);
            setErrors([
                'Error generating profile'
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const clearProfiles = ()=>{
        setProfiles([]);
        setAllProfiles([]);
        localStorage.removeItem('DEVICE_PROFILES');
    };
    const getAssociationsFromProfiles = (localProfiles)=>{
        // {appName: AssociatedProfileModel[]} -> sparse storage
        const associations = {};
        /** sort local profiles by descending order of modified date */ const sortedProfiles = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).cloneDeep(localProfiles);
        sortedProfiles.sort((a, b)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(a.modifiedDate) > (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(b.modifiedDate) ? -1 : 1;
        });
        sortedProfiles.forEach((profile)=>{
            profile.configuration.associatedPrograms?.forEach((appName)=>{
                const cleansedAppName = appName.trim().toLowerCase();
                if (cleansedAppName === '') return;
                if (!(cleansedAppName in associations)) associations[cleansedAppName] = [];
                if (profile.id) associations[cleansedAppName].push({
                    id: profile.id,
                    name: profile.name,
                    isPublic: profile.isPublic,
                    platform: profile.platform
                });
            });
        });
        return associations;
    };
    const updateCombinedProfiles = (localProfiles)=>{
        const hasNewModifications = ()=>{
            if (allProfilesRef.current.length === 0) return true;
            if (allProfilesRef.current.length !== localProfiles.length) return true;
            // Check if any profile content has actually changed
            // DONT use last modified date for comparison as it can be unreliable
            return localProfiles.some((localProfile)=>{
                const existingProfile = allProfilesRef.current.find((p)=>p.id === localProfile.id);
                if (!existingProfile) return true;
                return !(0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).isEqual(existingProfile.configuration, localProfile.configuration) || existingProfile.name !== localProfile.name || existingProfile.description !== localProfile.description;
            });
        };
        if (hasNewModifications()) {
            lastModifiedDate.current = new Date();
            // set available profiles
            setAllProfiles(localProfiles);
            // calculate associated programs
            const associations = getAssociationsFromProfiles(localProfiles);
            associatedProgramsListRef.current = associations;
            const appNames = Object.keys(associations);
            associatedProgramsAppNames.current = appNames;
            appNameFuzzySearchRef.current = new (0, $666c2eeb26cf6d23$export$2e2bcd8739ae039)(appNames, [], {
                sort: true,
                caseSensitive: false
            });
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        // custom profiles updated
        const publicProfiles = allProfilesRef.current.filter((profile)=>profile.isPublic);
        const combinedProfiles = [
            ...profilesRef.current,
            ...publicProfiles
        ];
        updateCombinedProfiles(combinedProfiles);
    }, [
        profiles
    ]);
    const fuzzySearchProfiles = (search)=>{
        const searcher = new (0, $666c2eeb26cf6d23$export$2e2bcd8739ae039)(allProfilesRef.current, [
            'name',
            'description',
            'configuration.associatedPrograms'
        ], {
            sort: true,
            caseSensitive: false
        });
        return searcher.search(search);
    };
    const getIndicatorName = (name, isPublic)=>{
        return !isPublic ? t('common:profile.custom', {
            name: name
        }) : name;
    };
    const isPlatformCompatible = (devicePlatform, profilePlatform = 'generic')=>{
        const normalizedDevicePlatform = devicePlatform?.toLowerCase();
        if (!devicePlatform || normalizedDevicePlatform == 'generic') return true;
        const normalizedProfilePlatform = profilePlatform.toLowerCase();
        return normalizedDevicePlatform === normalizedProfilePlatform || normalizedProfilePlatform === 'generic';
    };
    const filterProfiles = (search, platform = 'generic', userVoiceLocale, selectedInterest)=>{
        const normalizedFilter = search.toLowerCase().trim();
        const normalizedInterest = selectedInterest?.toLowerCase().trim();
        const filtered = allProfilesRef.current.filter((profile)=>{
            if (!profile || !isPlatformCompatible(platform, profile.platform)) return false;
            // Filter by profile group and locale (from mobile)
            if (profile.deviceProfileGroupId && profile.defaultLocale !== userVoiceLocale && !profile.isDefaultInGroup) return false;
            // Show default profile only if user's locale doesn't have a match
            if (profile.deviceProfileGroupId && profile.isDefaultInGroup && profile.defaultLocale !== userVoiceLocale) {
                const hasCurrentLocale = profile.deviceProfileGroup?.some((groupMember)=>groupMember.locale === userVoiceLocale);
                if (hasCurrentLocale) return false;
            }
            // Gather searchable fields from profile and originated profile
            const fields = [
                getIndicatorName(profile.name, profile.isPublic).toLowerCase(),
                profile.description?.toLowerCase() || '',
                ...profile.configuration.associatedPrograms?.map((p)=>p.toLowerCase()) || []
            ];
            const originated = allProfilesRef.current.find((p)=>p.id === profile.originatedByProfileId);
            if (originated) fields.push(getIndicatorName(originated.name, originated.isPublic).toLowerCase(), originated.description?.toLowerCase() || '', ...originated.configuration.associatedPrograms?.map((p)=>p.toLowerCase()) || []);
            const matchesFilter = fields.some((field)=>field.includes(normalizedFilter));
            const matchesInterest = !normalizedInterest || profile.interests.map((i)=>i.toLowerCase()).includes(normalizedInterest);
            return matchesFilter && matchesInterest;
        });
        return filtered;
    };
    const isPlatformSupportedProfile = (profile, os)=>{
        if (!profile) return false;
        return !profile.platform || profile.platform === os || profile.platform === 'generic';
    };
    const getAssociatedAppName = (appName)=>{
        const cleansedAppName = appName.trim().toLowerCase();
        if (!cleansedAppName) return null;
        // Try fuzzy search first
        const fuzzyResults = appNameFuzzySearchRef.current?.search(cleansedAppName);
        if (fuzzyResults?.length) return fuzzyResults[0];
        // Try exact match
        const storedNames = associatedProgramsAppNames.current;
        const exactMatch = storedNames.find((name)=>name.toLowerCase() === cleansedAppName);
        if (exactMatch) return exactMatch;
        // Calculate scores for partial matches
        const scores = calculateMatchScores(cleansedAppName, storedNames);
        const bestMatch = getBestMatch(scores);
        return bestMatch;
    };
    const calculateMatchScores = (searchTerm, names)=>{
        const searchParts = searchTerm.split(/[\s-]+/);
        const scoreMap = new Map();
        for (const name of names){
            const cleansedName = name.toLowerCase();
            const nameParts = cleansedName.split(/[\s-]+/);
            let score = 0;
            // Check for sequential phrase matches
            const isSequentialMatch = searchParts.join(' ').includes(nameParts.join(' ')) || nameParts.join(' ').includes(searchParts.join(' '));
            if (isSequentialMatch) score += 10;
            // Discrete partial word matches
            const matchCount = Math.max(searchParts.filter((part)=>nameParts.includes(part)).length, nameParts.filter((part)=>searchParts.includes(part)).length);
            score += matchCount;
            // Check for substring matches
            if (cleansedName.includes(searchTerm) || searchTerm.includes(cleansedName)) score += 1;
            if (score > 0) scoreMap.set(name, score);
        }
        return scoreMap;
    };
    const getBestMatch = (scores)=>{
        if (scores.size === 0) return null;
        let bestScore = 0;
        let bestMatch = null;
        for (const [name, score] of scores)if (score > bestScore) {
            bestScore = score;
            bestMatch = name;
        }
        return bestMatch;
    };
    (0, $7fPBF.useEffect)(()=>{
        // public available profiles updated
        const unsubscribeDefaultProfiles = (0, $e7df95de73caec26$export$ec068583843480e7)('default-profiles-updated', (data)=>{
            updateCombinedProfiles([
                ...profilesRef.current,
                ...data
            ]);
        });
        const unsubscribeUserProfileAdded = (0, $e7df95de73caec26$export$ec068583843480e7)('userProfileAdded', (data)=>{
            addProfile(data.profile);
        });
        const unsubscribeUserProfileUpdated = (0, $e7df95de73caec26$export$ec068583843480e7)('userProfileUpdated', (data)=>{
            updateProfile(data.profile);
        });
        const unsubscribeUserProfileDeleted = (0, $e7df95de73caec26$export$ec068583843480e7)('userProfileDeleted', (data)=>{
            deleteProfile(data.profileId, true);
        });
        return ()=>{
            unsubscribeDefaultProfiles();
            unsubscribeUserProfileAdded();
            unsubscribeUserProfileUpdated();
            unsubscribeUserProfileDeleted();
        };
    }, []);
    return {
        profiles: profiles,
        profilesRef: profilesRef,
        clearProfiles: clearProfiles,
        addProfile: addProfile,
        updateProfile: updateProfile,
        getProfiles: getProfiles,
        deleteProfile: deleteProfile,
        createShareLink: createShareLink,
        getShares: getShares,
        deleteShare: deleteShare,
        generateProfile: generateProfile,
        isLoading: isLoading,
        errors: errors,
        initializeFromStorage: initializeFromStorage,
        removeLocalProfile: removeLocalProfile,
        allProfiles: allProfiles,
        allProfilesRef: allProfilesRef,
        associatedProgramsListRef: associatedProgramsListRef,
        fuzzySearchProfiles: fuzzySearchProfiles,
        filterProfiles: filterProfiles,
        getIndicatorName: getIndicatorName,
        isPlatformSupportedProfile: isPlatformSupportedProfile,
        getAssociatedAppName: getAssociatedAppName,
        organizationProfiles: organizationProfiles,
        setOrganizationProfiles: setOrganizationProfiles,
        organizationProfilesRef: organizationProfilesRef
    };
}
const $60065a32b4a31650$var$ProfilesContainer = (0, $78783f85c4167892$export$26ae5ca175b4ec5a)($60065a32b4a31650$var$useProfilesContainer);
var $60065a32b4a31650$export$2e2bcd8739ae039 = $60065a32b4a31650$var$ProfilesContainer;



var $4ZL0H = parcelRequire("4ZL0H");
function $697752726c88b03c$var$useEditProfileContainer() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    // TODO decouple this from the container
    const getGlobalEditProfileConflicts = (0, $31424fe514516834$export$2e2bcd8739ae039)();
    const profilesContainer = (0, $78783f85c4167892$export$b537cf6ebaf7ff54)((0, $60065a32b4a31650$export$2e2bcd8739ae039));
    const [associatedPrograms, setAssociatedPrograms, associatedProgramsRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)([]);
    const [audioEvents, setAudioEvents, audioEventsRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)([]);
    const [commandKeyMappings, setCommandKeyMappings, commandKeyMappingsRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)([]);
    const [description, setDescription, descriptionRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(undefined);
    const [dictationCommands, setDictationCommands, dictationCommandsRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)([]);
    const [suggestedGeneratePrompts, setSuggestedGeneratePrompts, suggestedGeneratePromptsRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)([]);
    const [suggestedRewritePrompts, setSuggestedRewritePrompts, suggestedRewritePromptsRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)([]);
    const [errors, setErrors] = (0, $7fPBF.useState)([]);
    const [hasChanges, setHasChanges, hasChangesRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(false);
    const [hotkeys, setHotkeys, hotkeysRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)([]);
    const [id, setId, idRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(undefined);
    const [imageUri, setImageUri, imageUriRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(undefined);
    const [isDefaultBindingsIncluded, setIsDefaultBindingsIncluded] = (0, $7fPBF.useState)(false);
    const [isDeprecatedHotkey, setIsDeprecatedHotkey, isDeprecatedHotkeyRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(false);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [isPreview, setIsPreview] = (0, $7fPBF.useState)(false);
    const [macros, setMacros, macrosRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)([]);
    const [filter, setFilter] = (0, $7fPBF.useState)('');
    const [name, setName, nameRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)('');
    const originalProfileRef = (0, $7fPBF.useRef)(null);
    const organizationIdRef = (0, $7fPBF.useRef)(null);
    const [profileConflictErrors, updateProfileConflictErrors] = (0, $7fPBF.useState)([]);
    const [profileConflictWarnings, updateProfileConflictWarnings] = (0, $7fPBF.useState)([]);
    const [defaultLocale, setDefaultLocale, defaultLocaleRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)((0, $3ecd3f7dea3d56de$export$f44b61b0f29ec));
    const [originatedByProfileId, setOrignatedByProfileId] = (0, $7fPBF.useState)(undefined);
    const [isProfileConflictsAcknowledged, setIsConflictsAcknowledged] = (0, $7fPBF.useState)(false);
    const [availableCustomControls, setAvailableCustomControls] = (0, $7fPBF.useState)([]);
    const saveChanges = async ()=>{
        /** Validation */ if (!isValidProfile()) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        // Warning - Allow Save
        let conflictWarnings = [];
        detectConflictWarnings(conflictWarnings);
        // Save Profile
        const profileCreateUpdateModel = getProfileCreateUpdateModel();
        const result = idRef.current ? await $1a4c36336f303477$export$5880729c5d131040(idRef.current, profileCreateUpdateModel) : await $1a4c36336f303477$export$6660b028f5be10a7(profileCreateUpdateModel);
        if (result?.resultType == 'Ok' && result.data) {
            setHasChanges(false);
            if (conflictWarnings.length > 0) {
                (0, $e7df95de73caec26$export$89b472e03be495df)('alertWarning', {
                    message: t('common:profile.warning'),
                    timeout: 5000
                });
                result.resultType = 'OkWithWarnings';
            } else (0, $e7df95de73caec26$export$89b472e03be495df)('alertSuccess', {
                message: t('common:profile.success.save'),
                timeout: 5000
            });
            originalProfileRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).cloneDeep(result.data);
            if (!idRef.current) {
                (0, $e7df95de73caec26$export$89b472e03be495df)('userProfileAdded', {
                    profile: result.data
                });
                setId(result.data.id);
            } else (0, $e7df95de73caec26$export$89b472e03be495df)('userProfileUpdated', {
                profile: result.data
            });
        } else (0, $e7df95de73caec26$export$89b472e03be495df)('alertError', {
            message: t('common:profile.error.save'),
            timeout: 5000
        });
        return result;
    };
    const isValidProfile = ()=>{
        let conflictErrors = [];
        validateProfileName(conflictErrors);
        validateProfileItems(conflictErrors);
        updateProfileConflictErrors(conflictErrors);
        /** Deprecated: keeping here for consistent logic on showing an error alert  */ const audioEventsWithEmptyCommands = audioEvents.filter((a)=>a.commands.some((c)=>!c.command));
        if (audioEventsWithEmptyCommands.length > 0) {
            (0, $e7df95de73caec26$export$89b472e03be495df)('alertError', {
                message: t('common:profile.error.audioEventsWithEmptyCommands'),
                timeout: 5000
            });
            return false;
        }
        if (conflictErrors.length > 0) (0, $e7df95de73caec26$export$89b472e03be495df)('alertError', {
            message: t('common:profile.error.conflicts'),
            timeout: 5000
        });
        return conflictErrors.length === 0;
    };
    const validateProfileName = (conflictErrors)=>{
        let validName = true;
        let title = '';
        let description = '';
        if (nameRef.current == '') {
            title = t('common:profile.conflictIndicators.emptyNameTitle');
            description = t('common:profile.conflictIndicators.emptyNameDescription');
            validName = false;
        } else if (isDuplicateName()) {
            title = t('common:profile.conflictIndicators.duplicateNameTitle');
            description = t('common:profile.conflictIndicators.duplicateNameDescription');
            validName = false;
        }
        if (!validName) {
            const newConflictItem = {
                displayString: title,
                key: 'ProfileNameConflict',
                scrollID: (0, $14e4f1609944ac39$export$a9a172bf96c7a4ed),
                pageLink: getEditProfilePath()
            };
            addNewProfileConflictModel(t('common:profile.conflictIndicators.profileNameErrors'), [
                newConflictItem
            ], conflictErrors, description);
        }
    };
    /** validate profile for macros, keybindings, and other item conflicts and warnings. */ const validateProfileItems = (conflictErrors)=>{
        // Macros
        addNewProfileConflictModel(t('common:profile.conflictIndicators.emptyControlsMapped'), (0, $9d76aba0a210d2c6$export$1d55b5fa728affd1)({
            macros: macros,
            profileId: id,
            t: t
        }), conflictErrors, t('common:profile.conflictIndicators.emptyControlsMappedDescription'));
        addNewProfileConflictModel(t('common:profile.conflictIndicators.duplicateInputCommandMacroTitle'), (0, $9d76aba0a210d2c6$export$639d475f7be72f7d)({
            macros: macros,
            profileId: id,
            t: t
        }), conflictErrors, t('common:profile.conflictIndicators.duplicateCommandsDescription'));
        addNewProfileConflictModel(t('common:profile.conflictIndicators.macrosReleaseKeysMissingTitle'), (0, $9d76aba0a210d2c6$export$b59cab01f4e26d1b)({
            macros: macros,
            profileId: id,
            defaultLocale: defaultLocale,
            t: t
        }), conflictErrors, t('common:profile.conflictIndicators.macrosReleaseKeysMissingDescription'));
        addNewProfileConflictModel(t('common:profile.conflictIndicators.macrosVoiceCommandConflictWithDictationTitle'), (0, $9d76aba0a210d2c6$export$ec2c4b4373af4b61)({
            macros: macros,
            dictationCommands: dictationCommands,
            profileId: id,
            t: t
        }), conflictErrors, t('common:profile.conflictIndicators.macrosVoiceCommandConflictWithDictationDescription'));
        // Keybindings
        addNewProfileConflictModel(t('common:profile.conflictIndicators.emptyKeybindingControlsMapped'), (0, $9d76aba0a210d2c6$export$134d4256d4cafcf4)({
            commandKeyMappings: commandKeyMappings,
            profileId: id,
            t: t
        }), conflictErrors, t('common:profile.conflictIndicators.emptyKeybindingControlsMappedDescription'));
        addNewProfileConflictModel(t('common:profile.conflictIndicators.duplicateInputCommandBindingsTitle'), (0, $9d76aba0a210d2c6$export$eb3146089825fa9d)({
            commandKeyMappings: commandKeyMappings,
            profileId: id,
            t: t
        }), conflictErrors, t('common:profile.conflictIndicators.duplicateCommandsDescription'));
        addNewProfileConflictModel(t('common:profile.conflictIndicators.keybindingsVoiceCommandConflictWithDictationTitle'), (0, $9d76aba0a210d2c6$export$845f2f159de600e0)({
            commandKeyMappings: commandKeyMappings,
            dictationCommands: dictationCommands,
            profileId: id,
            t: t
        }), conflictErrors, t('common:profile.conflictIndicators.keybindingsVoiceCommandConflictWithDictationDescription'));
        // associated programs
        addNewProfileConflictModel(t('common:profile.conflictIndicators.duplicateAssociatedProgramNames'), (0, $9d76aba0a210d2c6$export$4a2e027df0dfc855)({
            associatedPrograms: associatedPrograms,
            profileId: id
        }), conflictErrors, t('common:profile.conflictIndicators.duplicateAssociatedProgramsDescription'));
    };
    const detectConflictWarnings = (conflictWarnings)=>{
        if (!idRef.current) return;
        const { deviceCommandConflictDisplay: deviceCommandConflictDisplay, globalCommandConflictDisplay: globalCommandConflictDisplay } = getGlobalEditProfileConflicts(macros, dictationCommands, commandKeyMappings, idRef.current);
        if (globalCommandConflictDisplay?.length > 0) addNewProfileConflictModel(t('common:customControls.conflictIndicators.globalControls'), globalCommandConflictDisplay, conflictWarnings, t('common:customControls.conflictIndicators.description'));
        if (deviceCommandConflictDisplay?.length > 0) addNewProfileConflictModel(t('common:customControls.conflictIndicators.deviceControls'), deviceCommandConflictDisplay, conflictWarnings, t('common:customControls.conflictIndicators.description'));
        addNewProfileConflictModel(t('common:profile.conflictIndicators.duplicateMacroNames'), (0, $9d76aba0a210d2c6$export$7b817b6bf4f2cb70)({
            macros: macros,
            profileId: id,
            t: t
        }), conflictWarnings, t('common:profile.conflictIndicators.duplicateMacroNamesDescription'));
        addNewProfileConflictModel(t('common:profile.conflictIndicators.emptyEvent.title'), (0, $9d76aba0a210d2c6$export$a634520ef9a79c74)({
            macros: macros,
            profileId: id,
            t: t
        }), conflictWarnings, t('common:profile.conflictIndicators.emptyEvent.description'));
        // state update
        updateProfileConflictWarnings(conflictWarnings);
    };
    /** Checks whether a current profile name already exists for the user */ const isDuplicateName = (inputName)=>{
        const benchmarkName = inputName ?? nameRef.current;
        const duplicateNames = getDuplicateProfiles(benchmarkName);
        if (duplicateNames[0]?.id === idRef.current) return false;
        else return duplicateNames.length > 0;
    };
    /** ONLY to be used for public profiles, attaches a number if the profile name already exists for the user. */ const getPublicProfileNameIfDuplicate = (inputName)=>{
        const defaultName = inputName ?? name;
        const exactDuplicates = getDuplicateProfiles(defaultName);
        let updatedName;
        if (exactDuplicates.length > 0) {
            const existingDuplicates = profilesContainer.profilesRef.current.filter((profile)=>profile.name.startsWith(`${defaultName} #`));
            if (existingDuplicates.length > 0) {
                // not doing total + 1 due to in-between profiles being deleted and avoiding more duplicates
                let lastProfileNumber = Math.max(...existingDuplicates.map((profile)=>{
                    const lastChar = profile.name.at(-1);
                    return lastChar ? parseInt(lastChar) : NaN;
                }));
                updatedName = `${defaultName} #${lastProfileNumber + 1}`;
            } else updatedName = `${defaultName} #${1}`;
        }
        return updatedName ?? defaultName;
    };
    /** Private method to get a list of all profiles with the same input name */ const getDuplicateProfiles = (inputName)=>{
        const duplicateNames = profilesContainer.profilesRef.current.filter((profile)=>profile.name === inputName);
        return duplicateNames;
    };
    const getUserDeviceProfileFromState = ()=>{
        let now = new Date();
        const profileConfig = {
            id: idRef.current,
            name: nameRef.current,
            description: descriptionRef.current,
            profileType: 'Default',
            configuration: getProfileConfigFromState(),
            createdDate: now.toISOString(),
            modifiedDate: now.toISOString(),
            defaultLocale: defaultLocaleRef.current,
            requiresEmployeeAccess: originalProfileRef.current?.requiresEmployeeAccess ?? false,
            requiresStudentAccess: originalProfileRef.current?.requiresStudentAccess ?? false,
            requiresGenericLicense: originalProfileRef.current?.requiresGenericLicense ?? false,
            requiresPlusAccess: originalProfileRef.current?.requiresPlusAccess ?? false,
            interests: originalProfileRef.current?.interests ?? []
        };
        if ($4ZL0H.platform == 'darwin') profileConfig.platform = 'MacOS';
        else if ($4ZL0H.platform == 'win32') profileConfig.platform = 'Windows';
        return profileConfig;
    };
    const getProfileCreateUpdateModel = ()=>{
        const profileCreateUpdateModel = {
            name: nameRef.current,
            description: description ?? '',
            profileType: 'Default',
            configuration: getProfileConfigFromState(),
            defaultLocale: defaultLocaleRef.current,
            originatedByProfileId: originatedByProfileId,
            requiresEmployeeAccess: originalProfileRef.current?.requiresEmployeeAccess ?? false,
            requiresStudentAccess: originalProfileRef.current?.requiresStudentAccess ?? false,
            requiresGenericLicense: originalProfileRef.current?.requiresGenericLicense ?? false,
            requiresPlusAccess: originalProfileRef.current?.requiresPlusAccess ?? false,
            platform: originalProfileRef.current?.platform ?? 'generic',
            interests: originalProfileRef.current?.interests ?? [],
            organizationId: organizationIdRef.current ?? undefined
        };
        return profileCreateUpdateModel;
    };
    const getClonedProfile = (profile, originatedByProfileId, nameOverride)=>{
        let clonedProfile = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).cloneDeep(profile);
        const duplicateName = getPublicProfileNameIfDuplicate(profile.name);
        // modifies and copies target properties to the cloned profile
        Object.assign(clonedProfile, {
            profileType: 'Default',
            id: undefined,
            name: nameOverride ?? duplicateName,
            originatedByProfileId: originatedByProfileId
        });
        return clonedProfile;
    };
    const getProfileConfigFromState = ()=>{
        const profileConfig = {
            commandKeyMappings: (0, $9d76aba0a210d2c6$export$d1b24cb1984823a4)(commandKeyMappingsRef.current),
            macros: macrosRef.current.map((m)=>({
                    ...m,
                    id: m.id ?? (0, $6810e10b84975c3e$export$2e2bcd8739ae039)(),
                    commands: m.commands.map((c)=>c.command)
                })),
            hotkeys: hotkeysRef.current,
            audioEvents: audioEventsRef.current.map((a)=>({
                    ...a,
                    commands: a.commands.map((c)=>c.command)
                })),
            dictationCommands: dictationCommandsRef.current,
            suggestedGeneratePrompts: suggestedGeneratePromptsRef.current,
            suggestedRewritePrompts: suggestedRewritePromptsRef.current,
            associatedPrograms: associatedProgramsRef.current,
            profileType: 'Default'
        };
        return profileConfig;
    };
    const setDefaultProfile = (locale)=>{
        const language = (0, $eeb1a4bb5a11a603$export$e88b669f03544b69)(locale, 'voice') ?? (0, $3ecd3f7dea3d56de$export$f44b61b0f29ec);
        setDefaultLocale(language);
        let keyBindings = (0, $9a9874d925dad9cc$export$2f002ae08ac7e997)(language);
        if (!isDefaultBindingsIncluded) keyBindings = keyBindings.map((k)=>({
                ...k,
                commands: []
            }));
        setDescription(undefined);
        setImageUri(undefined);
        setHasChanges(false);
        setName('');
        setIsDeprecatedHotkey(false);
        setId(undefined);
        setMacros([]);
        setHotkeys([]);
        setDictationCommands((0, $eeb1a4bb5a11a603$export$635ddbacad8e65bf)(language));
        setAssociatedPrograms([]);
        setAudioEvents([]);
        setCommandKeyMappings(keyBindings);
        updateProfileConflictErrors([]);
        updateProfileConflictWarnings([]);
        setIsConflictsAcknowledged(false);
        setOrignatedByProfileId(undefined);
        organizationIdRef.current = null;
    };
    const handleLocaleChange = (value)=>{
        setDefaultLocale(value);
        setHasChanges(true);
    };
    const updateProfileState = (profile, isInitial)=>{
        originalProfileRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).cloneDeep(profile);
        if (!profile.configuration) return;
        const language = (0, $eeb1a4bb5a11a603$export$e88b669f03544b69)(profile.defaultLocale ?? (0, $3ecd3f7dea3d56de$export$f44b61b0f29ec), 'voice') ?? (0, $3ecd3f7dea3d56de$export$f44b61b0f29ec);
        setDefaultLocale(language);
        const hotkeys = profile.configuration.hotkeys;
        const macros = profile.configuration.macros;
        const profileKeybindings = profile.configuration.commandKeyMappings;
        const audioEvents = profile.configuration.audioEvents;
        const dictationCommands = profile.configuration.dictationCommands;
        const suggestedGeneratePrompts = profile.configuration.suggestedGeneratePrompts;
        const suggestedRewritePrompts = profile.configuration.suggestedRewritePrompts;
        const associatedPrograms = profile.configuration.associatedPrograms ?? [];
        updateProfileConflictErrors([]);
        updateProfileConflictWarnings([]);
        macros?.forEach((m)=>{
            if (!m.id) m.id = (0, $6810e10b84975c3e$export$2e2bcd8739ae039)();
        });
        const updatedMacros = macros?.map((a)=>({
                ...a,
                id: a.id ?? (0, $6810e10b84975c3e$export$2e2bcd8739ae039)(),
                commands: a.commands.map((c)=>({
                        command: c,
                        commandType: (0, $f44f3a5bc46b1c4c$export$e9c0f8ebac1b37df)(c)
                    }))
            })) ?? [];
        setMacros(updatedMacros);
        setIsDeprecatedHotkey(false);
        hotkeys?.forEach((h)=>{
            if (!h.localId) h.localId = (0, $6810e10b84975c3e$export$2e2bcd8739ae039)();
            if (!h.macroLocalId) {
                const hotkeyMacro = (0, $15df2073755d9d49$export$8887ad9c8dfc8e0a)(h, updatedMacros);
                h.macroLocalId = hotkeyMacro?.m?.id;
            }
            if (!h.command.startsWith((0, $f44f3a5bc46b1c4c$export$b617c310e3426257))) {
                h.macroName = h.macroName ?? 'Deprecated Hotkey';
                setIsDeprecatedHotkey(true);
            }
        });
        setHotkeys(hotkeys ?? []);
        setAudioEvents((audioEvents || []).map((a)=>({
                ...a,
                commands: (a.commands || []).map((c)=>({
                        command: c,
                        commandType: (0, $f44f3a5bc46b1c4c$export$e9c0f8ebac1b37df)(c)
                    }))
            })));
        setDictationCommands(dictationCommands ?? (0, $eeb1a4bb5a11a603$export$635ddbacad8e65bf)(language));
        setSuggestedGeneratePrompts(suggestedGeneratePrompts ?? []);
        setSuggestedRewritePrompts(suggestedRewritePrompts ?? []);
        setAssociatedPrograms(associatedPrograms ?? []);
        setId(profile.id);
        setName(profile.name);
        setDescription(profile.description);
        setImageUri(profile.imageUrl);
        setOrignatedByProfileId(profile.originatedByProfileId);
        let keybindings = (0, $9d76aba0a210d2c6$export$f31ec4fcec40d1f9)((0, $9a9874d925dad9cc$export$2f002ae08ac7e997)(language, profile.platform), profileKeybindings?.map((k)=>(0, $9a9874d925dad9cc$export$e4e98b6e2a74daae)(k, language, [], profile.platform)));
        // Honor the Default Bindings flag for new profiles
        if (!isDefaultBindingsIncluded && !profile.id && !profileKeybindings) keybindings = keybindings.map((k)=>({
                ...k,
                commands: []
            }));
        // Set changes flag if keybindings differ or if not initial load
        // setHasChanges(keybindings.length !== profileKeybindings?.length || !isInitial);
        setCommandKeyMappings(keybindings);
        setIsConflictsAcknowledged(false);
    };
    const loadPreview = async (shareCode)=>{
        setIsLoading(true);
        const result = await $1a4c36336f303477$export$e5888858f383ec64(shareCode);
        if (result?.resultType == 'Ok' && result.data) {
            updateProfileState({
                ...result.data,
                name: result.data.profileName,
                id: result.data.id,
                userId: undefined,
                profileType: result.data.configuration.profileType,
                defaultLocale: result.data.defaultLocale,
                originatedByProfileId: result.data.userDeviceProfileId,
                interests: []
            });
            setIsPreview(true);
        } else (0, $e7df95de73caec26$export$89b472e03be495df)('alertError', {
            message: t('common:profile.error.load'),
            timeout: 5000
        });
        setIsLoading(false);
        return result;
    };
    const loadPublicPreview = async (profileId)=>{
        setIsLoading(true);
        const result = await $1a4c36336f303477$export$5bd7a6effa9290bc(profileId);
        if (result?.resultType == 'Ok' && result.data) {
            updateProfileState({
                ...result.data,
                name: result.data.name,
                id: result.data.id,
                userId: undefined,
                profileType: result.data.configuration.profileType,
                defaultLocale: result.data.defaultLocale,
                originatedByProfileId: result.data.originatedByProfileId,
                platform: result.data.platform
            });
            setIsPreview(true);
        } else (0, $e7df95de73caec26$export$89b472e03be495df)('alertError', {
            message: t('common:profile.error.load'),
            timeout: 5000
        });
        setIsLoading(false);
    };
    const loadOrgPreview = async (profileId)=>{
        setIsLoading(true);
        try {
            const result = await $1a4c36336f303477$export$5bd7a6effa9290bc(profileId ?? '');
            if (result?.resultType == 'Ok' && result.data) {
                updateProfileState({
                    ...result.data,
                    name: result.data.name,
                    id: result.data.id,
                    userId: undefined,
                    profileType: result.data.configuration.profileType,
                    defaultLocale: result.data.defaultLocale,
                    originatedByProfileId: result.data.originatedByProfileId,
                    platform: result.data.platform,
                    organizationId: result.data.organizationId
                });
                setIsPreview(true);
            } else (0, $e7df95de73caec26$export$89b472e03be495df)('alertError', {
                message: t('common:profile.error.load'),
                timeout: 5000
            });
        } catch (error) {
            (0, $e7df95de73caec26$export$89b472e03be495df)('alertError', {
                message: t('common:profile.error.load'),
                timeout: 5000
            });
        } finally{
            setIsLoading(false);
        }
    };
    const addPreview = async (shareCode)=>{
        setIsLoading(true);
        const result = await $1a4c36336f303477$export$827ad3bf4ce3bb83(shareCode);
        if (result?.resultType == 'Ok' && result.data) {
            (0, $e7df95de73caec26$export$89b472e03be495df)('userProfileAdded', {
                profile: result.data
            });
            (0, $e7df95de73caec26$export$89b472e03be495df)('alertSuccess', {
                message: t('common:profile.success.add'),
                timeout: 5000
            });
        } else (0, $e7df95de73caec26$export$89b472e03be495df)('alertError', {
            message: t('common:profile.error.add'),
            timeout: 5000
        });
        setIsLoading(false);
        return result;
    };
    const updateDeprecatedHotkey = (hotkey, macros)=>{
        const linkedMacro = macros.find((macro)=>macro.id === hotkey.macroLocalId);
        const newCommand = {
            command: (0, $f44f3a5bc46b1c4c$export$b617c310e3426257) + hotkey.displayName,
            commandType: 'hotkey',
            hotkeyLocalId: hotkey.localId
        };
        const hotkeys = hotkeysRef.current;
        const macroId = linkedMacro?.id ? linkedMacro.id : (0, $6810e10b84975c3e$export$2e2bcd8739ae039)();
        const updatedHotkey = {
            ...hotkey,
            command: (0, $f44f3a5bc46b1c4c$export$b617c310e3426257) + hotkey.displayName,
            macroLocalId: macroId
        };
        const hotkeyIndex = hotkeys.indexOf(hotkey);
        if (linkedMacro) {
            const indexOfLinkedMacro = macros.indexOf(linkedMacro);
            const existingCommands = linkedMacro.commands;
            macros[indexOfLinkedMacro] = {
                ...linkedMacro,
                commands: [
                    ...existingCommands,
                    newCommand
                ]
            };
            setMacros(macros);
            hotkeys[hotkeyIndex] = updatedHotkey;
        } else hotkeysRef.current.splice(hotkeyIndex, 1);
        updateHotkeys([
            ...hotkeys
        ]);
    };
    const removeHotkeyFromMacro = (command)=>{
        const hotkey = hotkeysRef.current.find((hotkey)=>hotkey.command === command.command);
        (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).remove(hotkeys, (h)=>h == hotkey);
        updateHotkeys([
            ...hotkeys
        ]);
    };
    const updateHotkeyFromMacro = (value, macro, index, originalValue)=>{
        const hotkeyName = value;
        const matchHotkey = hotkeysRef.current.find((hotkey)=>hotkey.command === originalValue);
        if (matchHotkey) {
            const hotkeyIndex = hotkeysRef.current.indexOf(matchHotkey);
            const updatedHotkey = {
                ...matchHotkey,
                displayName: hotkeyName.replace((0, $f44f3a5bc46b1c4c$export$b617c310e3426257), ''),
                command: hotkeyName
            };
            const updatedHotkeys = [
                ...hotkeys
            ];
            updatedHotkeys[hotkeyIndex] = updatedHotkey;
            updateHotkeys(updatedHotkeys);
            return matchHotkey.localId ?? '';
        } else return addHotkeyCommandForMacro(macro, hotkeys, value);
    };
    const addHotkeyCommandForMacro = (macro, hotkeys, command)=>{
        const newHotkey = {
            command: command,
            displayName: command.replace((0, $f44f3a5bc46b1c4c$export$b617c310e3426257), ''),
            localId: (0, $6810e10b84975c3e$export$2e2bcd8739ae039)(),
            macroId: macro.id,
            macroName: macro.name
        };
        updateHotkeys([
            ...hotkeys,
            newHotkey
        ]);
        return newHotkey.localId;
    };
    const updateMacros = (macros)=>{
        setMacros(macros);
    };
    const updateHotkeys = (hotkeys)=>{
        setHotkeys(hotkeys);
    };
    const updateAudioEvents = (audioEvents)=>{
        setAudioEvents(audioEvents);
    };
    const updateDictationCommands = (dictationCommands)=>{
        setDictationCommands(dictationCommands);
    };
    const updateSuggestedGeneratePrompts = (prompts)=>{
        setSuggestedGeneratePrompts(prompts);
    };
    const updateSuggestedRewritePrompts = (prompts)=>{
        setSuggestedRewritePrompts(prompts);
    };
    const updateAssociatedPrograms = (associatedPrograms)=>{
        setAssociatedPrograms(associatedPrograms);
    };
    const updateCommandKeyMappings = (keybindings)=>{
        setCommandKeyMappings(keybindings);
    };
    const resetKeybindingsToDefault = ()=>{
        const platform = originalProfileRef.current?.platform;
        const defaultKeyBindings = (0, $9a9874d925dad9cc$export$2f002ae08ac7e997)(defaultLocaleRef.current, platform);
        setCommandKeyMappings(defaultKeyBindings);
        setHasChanges(true);
    };
    const resetKeybindingsToEmpty = ()=>{
        const platform = originalProfileRef.current?.platform;
        const defaultKeyBindings = (0, $9a9874d925dad9cc$export$2f002ae08ac7e997)(defaultLocaleRef.current, platform);
        const emptyKeyBindings = defaultKeyBindings.map((k)=>({
                ...k,
                commands: []
            }));
        setCommandKeyMappings(emptyKeyBindings);
        setHasChanges(true);
    };
    const updateName = (name)=>{
        setName(name);
    };
    const updateDescription = (description)=>{
        setDescription(description);
    };
    const addNewProfileConflictModel = (title, items, conflictList, subtitle)=>{
        if (items.length > 0) {
            const newConflict = {
                title: title,
                items: items,
                subtitle: subtitle
            };
            conflictList.push(newConflict);
        }
    };
    // PATH HELPERS
    const getEditProfilePath = ()=>{
        if (organizationIdRef.current && idRef.current) {
            console.log('Organization ID present, returning organization edit path');
            return `/org/${organizationIdRef.current}/profiles/edit/${idRef.current}`;
        }
        if (organizationIdRef.current && !idRef.current) {
            console.log('Organization ID present but no profile ID, returning organization create path');
            return ``;
        }
        return `/profiles/edit/${idRef.current}`;
    };
    const resetPreviewStatus = ()=>{
        setIsPreview(false);
    };
    return {
        addPreview: addPreview,
        addHotkeyCommandForMacro: addHotkeyCommandForMacro,
        updateDeprecatedHotkey: updateDeprecatedHotkey,
        associatedPrograms: associatedPrograms,
        audioEvents: audioEvents,
        commandKeyMappings: commandKeyMappings,
        description: description,
        dictationCommands: dictationCommands,
        suggestedGeneratePrompts: suggestedGeneratePrompts,
        suggestedRewritePrompts: suggestedRewritePrompts,
        errors: errors,
        filter: filter,
        setFilter: setFilter,
        getClonedProfile: getClonedProfile,
        getProfileConfigFromState: getProfileConfigFromState,
        getPublicProfileNameIfDuplicate: getPublicProfileNameIfDuplicate,
        getUserDeviceProfileFromState: getUserDeviceProfileFromState,
        hasChanges: hasChanges,
        hasChangesRef: hasChangesRef,
        hotkeys: hotkeys,
        id: id,
        idRef: idRef,
        imageUri: imageUri,
        isDefaultBindingsIncluded: isDefaultBindingsIncluded,
        isDeprecatedHotkey: isDeprecatedHotkey,
        isDuplicateName: isDuplicateName,
        isLoading: isLoading,
        isPreview: isPreview,
        loadPreview: loadPreview,
        loadPublicPreview: loadPublicPreview,
        macros: macros,
        macrosRef: macrosRef,
        name: name,
        nameRef: nameRef,
        profileConflictErrors: profileConflictErrors,
        profileConflictWarnings: profileConflictWarnings,
        removeHotkeyFromMacro: removeHotkeyFromMacro,
        saveChanges: saveChanges,
        setDefaultProfile: setDefaultProfile,
        setHasChanges: setHasChanges,
        setId: setId,
        setIsDeprecatedHotkey: setIsDeprecatedHotkey,
        setIsDefaultBindingsIncluded: setIsDefaultBindingsIncluded,
        setIsPreview: setIsPreview,
        updateAssociatedPrograms: updateAssociatedPrograms,
        updateAudioEvents: updateAudioEvents,
        updateCommandKeyMappings: updateCommandKeyMappings,
        resetKeybindingsToDefault: resetKeybindingsToDefault,
        resetKeybindingsToEmpty: resetKeybindingsToEmpty,
        updateDictationCommands: updateDictationCommands,
        updateSuggestedGeneratePrompts: updateSuggestedGeneratePrompts,
        updateSuggestedRewritePrompts: updateSuggestedRewritePrompts,
        updateHotkeys: updateHotkeys,
        updateHotkeyFromMacro: updateHotkeyFromMacro,
        updateMacros: updateMacros,
        updateName: updateName,
        updateDescription: updateDescription,
        updateProfileState: updateProfileState,
        defaultLocale: defaultLocale,
        defaultLocaleRef: defaultLocaleRef,
        handleLocaleChange: handleLocaleChange,
        isProfileConflictsAcknowledged: isProfileConflictsAcknowledged,
        setIsConflictsAcknowledged: setIsConflictsAcknowledged,
        originatedByProfileId: originatedByProfileId,
        originalProfileRef: originalProfileRef,
        organizationIdRef: organizationIdRef,
        resetPreviewStatus: resetPreviewStatus,
        availableCustomControls: availableCustomControls,
        setAvailableCustomControls: setAvailableCustomControls,
        loadOrgPreview: loadOrgPreview
    };
}
const $697752726c88b03c$var$EditProfileContainer = (0, $78783f85c4167892$export$26ae5ca175b4ec5a)($697752726c88b03c$var$useEditProfileContainer);
var $697752726c88b03c$export$2e2bcd8739ae039 = $697752726c88b03c$var$EditProfileContainer;





var $7fPBF = parcelRequire("7fPBF");

function $3521ff40d609c2ed$var$useNotificationContainer() {
    const [notifications, setNotifications] = (0, $7fPBF.useState)([]);
    const [unreadNotifications, setUnreadNotifications] = (0, $7fPBF.useState)([]);
    const [errors, setErrors] = (0, $7fPBF.useState)([]);
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const initializeFromRemote = async ()=>{
        getUserNotificationsAll();
    };
    const getUserNotificationsUnread = async ()=>{
        setLoading(true);
        try {
            const allNotes = await $1a4c36336f303477$export$1cfb7ff6a4b15ea();
            if (allNotes?.resultType === 'Ok' && allNotes.data) setUnreadNotifications(allNotes.data.filter((n)=>!n.isRead));
            else {
                setErrors([
                    'Failed to load notifications'
                ]);
                console.error('Error initializing notifications:', allNotes);
            }
        } catch (e) {
            setErrors([
                e.message
            ]);
            console.error('Error initializing notifications:', e);
        }
        setLoading(false);
    };
    const getUserNotificationsAll = async ()=>{
        setLoading(true);
        try {
            const allNotes = await $1a4c36336f303477$export$e212b208cbec5050();
            if (allNotes?.resultType === 'Ok' && allNotes.data) {
                setNotifications(allNotes.data);
                const unreadNotes = allNotes.data.filter((n)=>!n.isRead);
                setUnreadNotifications(unreadNotes);
            } else {
                setErrors([
                    'Failed to load notifications'
                ]);
                console.error('Error initializing notifications:', allNotes);
            }
        } catch (e) {
            setErrors([
                e.message
            ]);
            console.error('Error initializing notifications:', e);
        }
        setLoading(false);
    };
    const markNotificationRead = async (notificationId)=>{
        setLoading(true);
        try {
            const markResult = await $1a4c36336f303477$export$49199adf1afcc108(notificationId);
            if (markResult?.resultType == 'Ok' && markResult.data) {
                const newNotes = [
                    ...notifications
                ];
                const noteIndex = newNotes.findIndex((n)=>n.id === notificationId);
                if (noteIndex > -1) {
                    newNotes[noteIndex] = markResult.data;
                    setNotifications(newNotes);
                    setUnreadNotifications(newNotes.filter((n)=>!n.isRead));
                }
            } else {
                setErrors([
                    'Failed to mark notification as read'
                ]);
                console.error('Error marking notification as read:', markResult);
            }
        } catch (e) {
            setErrors([
                e.message
            ]);
            console.error('Error marking notification as read:', e);
        }
    };
    const generateNotification = async (notification)=>{
        setLoading(true);
        try {
            const generateResult = await $1a4c36336f303477$export$f4d031e4baefbd82(notification);
            if (generateResult?.resultType == 'Ok' && generateResult.data) {
                const newNotes = [
                    ...notifications
                ];
                newNotes.push(generateResult.data);
                setNotifications(newNotes);
                setUnreadNotifications(newNotes.filter((n)=>!n.isRead));
            } else {
                setErrors([
                    'Failed to generate notification'
                ]);
                console.error('Error generating notification:', generateResult);
            }
        } catch (e) {
            setErrors([
                e.message
            ]);
            console.error('Error generating notification:', e);
        }
        initializeFromRemote();
        setLoading(false);
    };
    return {
        initializeFromRemote: initializeFromRemote,
        markNotificationRead: markNotificationRead,
        unreadNotifications: unreadNotifications,
        setUnreadNotifications: setUnreadNotifications,
        generateNotification: generateNotification,
        getUserNotificationsAll: getUserNotificationsAll,
        getUserNotificationsUnread: getUserNotificationsUnread,
        notifications: notifications,
        setNotifications: setNotifications,
        errors: errors,
        setErrors: setErrors,
        loading: loading,
        setLoading: setLoading
    };
}
const $3521ff40d609c2ed$var$NotificationContainer = (0, $78783f85c4167892$export$26ae5ca175b4ec5a)($3521ff40d609c2ed$var$useNotificationContainer);
var $3521ff40d609c2ed$export$2e2bcd8739ae039 = $3521ff40d609c2ed$var$NotificationContainer;






var $7fPBF = parcelRequire("7fPBF");



function $55ce97f088539572$var$useOrganizationContainer() {
    const [memberships, setMemberships, membershipsRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)([]);
    const [orgAuthClients, setOrgAuthClients, orgAuthClientsRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)([]);
    const [orgDeviceTypes, setOrgDeviceTypes, orgDeviceTypesRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)([]);
    const [orgAvailableCustomControls, setOrgAvailableCustomControls, orgAvailableCustomControlsRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)([]);
    const [orgManagedLicenseKeys, setOrgManagedLicenseKeys, orgManagedKeysLicenseRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)([]);
    const [orgManagedOrgs, setOrgManagedOrgs, orgManagedOrgsRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)([]);
    const [orgProducts, setOrgProducts, orgProductsRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)([]);
    const [scopes, setScopes, scopesRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)([]);
    const [organizationMembers, setOrganizationMembers, organizationMembersRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)([]);
    const [invites, setInvites, invitesRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)([]);
    const [currentOrg, setCurrentOrg, currentOrgRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(null);
    const currentOrgIdRef = (0, $7fPBF.useRef)();
    const [errors, setErrors] = (0, $7fPBF.useState)([]);
    const [loading, setLoading, loadingRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(true);
    const currentUserEmailRef = (0, $7fPBF.useRef)(null);
    const [loadingData, setLoadingData, loadingDataRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)({
        organizationMembers: false,
        organizations: false,
        projects: false,
        licenseKeys: false,
        invites: false,
        scopes: false,
        memberships: false,
        currentOrg: false,
        managedOrgs: false,
        managedKeys: false,
        products: false
    });
    const handleLoadingDataChange = (key, value)=>{
        setLoadingData((prev)=>({
                ...prev,
                [key]: value
            }));
    };
    const initializeFromRemote = async ()=>{
        return await loadOrganizations(false);
    };
    const updateMemberships = (newMemberships, updateLicenseAccess = true)=>{
        setMemberships(newMemberships);
        if (updateLicenseAccess) // preventing double loading of user license access
        (0, $e7df95de73caec26$export$89b472e03be495df)('updateUserLicenseAccess');
    };
    const initializeFromStorage = ()=>{
        try {
            const localMemberships = localStorage.getItem('ORGANIZATIONS');
            if (localMemberships) updateMemberships(JSON.parse(localMemberships));
        } catch (e) {
            console.log(e);
        }
    };
    // Implement your organization-related functions here
    const loadOrganizations = async (updateLicenseAccess = true)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$f7fea89e235b5345();
            if (response.resultType === 'Ok' && response.data) {
                updateMemberships(response.data, updateLicenseAccess);
                localStorage.setItem('ORGANIZATIONS', JSON.stringify(response.data));
            }
            setLoading(false);
            return response;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            setLoading(false);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const getOrganizationDetails = async (organizationId)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$7e61d855c21d0cf9(organizationId);
            if (response.resultType !== 'Ok') throw new Error('Organization not found');
            return response;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const loadCurrentOrganizationDetails = async (organizationId)=>{
        try {
            handleLoadingDataChange('currentOrg', true);
            const response = await $1a4c36336f303477$export$7e61d855c21d0cf9(organizationId);
            if (response.resultType === 'Ok' && response.data) setCurrentOrg(response.data);
            return response;
        } catch (error) {
            setCurrentOrg(null);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            handleLoadingDataChange('currentOrg', false);
        }
    };
    const loadOrganizationMembers = async (organizationId, searchParams)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$9fa0549694b5b397(organizationId, searchParams);
            const newMembers = [
                ...organizationMembers
            ];
            if (response.data) {
                if (organizationMembers.findIndex((m)=>m.organizationId === organizationId) === -1) newMembers.push({
                    organizationId: organizationId,
                    members: response.data
                });
                else {
                    const index = newMembers.findIndex((m)=>m.organizationId === organizationId);
                    newMembers[index].members = response.data;
                }
            }
            setOrganizationMembers(newMembers);
            setLoading(false);
            return response;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            setLoading(false);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const loadInvites = async (organizationId, searchParams)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$fc5cc62c84093276(organizationId, searchParams);
            const newInvites = [
                ...invites
            ];
            if (response.data) {
                if (invites.findIndex((i)=>i.organizationId === organizationId) === -1) newInvites.push({
                    organizationId: organizationId,
                    invites: response.data
                });
                else {
                    const index = newInvites.findIndex((i)=>i.organizationId === organizationId);
                    newInvites[index].invites = response.data;
                }
            }
            setInvites(newInvites);
            setLoading(false);
            return response;
        } catch (error) {
            setInvites([]);
            setErrors([
                ...errors,
                error.message
            ]);
            setLoading(false);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const createOrganizationInvite = async (organizationId, request)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$ca73d6dfa029e755(organizationId, request);
            if (response.resultType === 'Ok') await loadInvites(organizationId);
            setLoading(false);
            return response;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            setLoading(false);
        }
    };
    const deleteOrganizationInvite = async (organizationId, inviteId)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$723853a93f25bfc8(inviteId);
            if (response.resultType === 'Ok') await loadInvites(organizationId);
            setLoading(false);
            return response;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            setLoading(false);
        }
    };
    const removeMember = async (organizationId, memberId)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$f49c5f59ccb70c7(memberId);
            if (response.resultType === 'Ok') {
                await loadOrganizationMembers(organizationId);
                if (response.data?.user.email === currentUserEmailRef.current) (0, $e7df95de73caec26$export$89b472e03be495df)('updateUserLicenseAccess'); // update user license access after removing member
            }
            setLoading(false);
            return response;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            setLoading(false);
        }
    };
    const updateMemberRole = async (organizationId, memberId, request)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$9e3347137373e17d(memberId, request);
            if (response.resultType === 'Ok') await loadOrganizationMembers(organizationId);
            setLoading(false);
            return response;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            setLoading(false);
        }
    };
    const updateOrganization = async (organizationId, request)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$3f4430ea1068bd7f(organizationId, request);
            if (response.resultType === 'Ok') {
                await loadOrganizations();
                return response;
            } else throw new Error('Error updating organization');
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const acceptOrganizationInvite = async (inviteId)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$760587335e9aead6(inviteId);
            if (response.resultType === 'Ok') await loadOrganizations();
            setLoading(false);
            return response;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            setLoading(false);
            return new (0, $6340c001daecf2cb$export$2e2bcd8739ae039)(error.message);
        }
    };
    const getOrgAuthClients = async (organizationId)=>{
        if (!organizationId) {
            setOrgAuthClients([]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$3c51bcb045a4dcf7(organizationId);
            if (response.resultType === 'Ok' && response.data) setOrgAuthClients(response.data);
            else setOrgAuthClients([]);
            return response;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            setOrgAuthClients([]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const createOrgAuthClient = async (organizationId, request)=>{
        if (!organizationId || !request) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$6273d0fdd20ec2b(organizationId, request);
            if (response.resultType === 'Ok') await getOrgAuthClients(organizationId);
            return response;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const updateOrgAuthClient = async (organizationId, orgAuthClientId, request)=>{
        if (!organizationId || !orgAuthClientId || !request) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$882babc7ce0168b1(organizationId, orgAuthClientId, request);
            if (response.resultType === 'Ok') await getOrgAuthClients(organizationId);
            return response;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const deleteOrgAuthClient = async (organizationId, orgAuthClientId)=>{
        if (!organizationId || !orgAuthClientId) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$9d046100115f8eb6(organizationId, orgAuthClientId);
            if (response.resultType === 'Ok') await getOrgAuthClients(organizationId);
            return response;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const rotateClientSecret = async (organizationId, orgAuthClientId)=>{
        if (!organizationId || !orgAuthClientId) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$fb8fa300ccf972f1(organizationId, orgAuthClientId);
            return response;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const getOrgDeviceTypes = async (organizationId)=>{
        if (!organizationId) {
            setOrgDeviceTypes([]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$1349a2482875cb46(organizationId);
            if (response.resultType === 'Ok' && response.data) setOrgDeviceTypes(response.data);
            else setOrgDeviceTypes([]);
            return response;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            setOrgDeviceTypes([]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const createOrgDeviceType = async (organizationId, request)=>{
        if (!organizationId || !request) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$56b000d2f0c12703(organizationId, request);
            if (response.resultType === 'Ok') await getOrgDeviceTypes(organizationId);
            return response;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const updateOrgDeviceType = async (organizationId, orgDeviceTypeId, request)=>{
        if (!organizationId || !orgDeviceTypeId || !request) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$283d103ee023ff02(organizationId, orgDeviceTypeId, request);
            if (response.resultType === 'Ok') await getOrgDeviceTypes(organizationId);
            return response;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const deleteOrgDeviceType = async (organizationId, orgDeviceTypeId)=>{
        if (!organizationId || !orgDeviceTypeId) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$564a73641b2b83a(organizationId, orgDeviceTypeId);
            if (response.resultType === 'Ok') await getOrgDeviceTypes(organizationId);
            return response;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const getScopes = async ()=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$a751a00626fa5d99();
            if (response.resultType === 'Ok' && response.data) return response.data;
            return [];
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            return [];
        } finally{
            setLoading(false);
        }
    };
    const updateMembershipsByOrganization = async (organization)=>{
        const localMemberships = membershipsRef.current;
        const index = localMemberships.findIndex((m)=>m.organizationId === organization.id);
        if (index > 0) {
            localMemberships[index].organization = organization;
            updateMemberships(localMemberships);
        } else // new organization
        await loadOrganizations(); // this gets all the membership details too
    };
    const activateNewOrgLicenseKey = async (request)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$4f1930389137b6da(request);
            if (response.resultType === 'Ok' && response.data) // update memberships
            await updateMembershipsByOrganization(response.data);
            return response;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const activateExistingOrgLicenseKey = async (organizationId, request)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$68ccee5da54c27c3(organizationId, request);
            if (response.resultType === 'Ok' && response.data) // update memberships
            await updateMembershipsByOrganization(response.data);
            return response;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const validateLicenseKey = async (licenseKey)=>{
        try {
            const response = await $1a4c36336f303477$export$18169adbba1e88bc(licenseKey);
            return response;
        } catch (error) {
            setErrors((prev)=>[
                    ...prev,
                    error.message
                ]);
            return null;
        }
    };
    const validateLicenseKeyForOrganization = async (organizationId, licenseKey)=>{
        try {
            const response = await $1a4c36336f303477$export$4e97a7883c500e67(organizationId, licenseKey);
            return response;
        } catch (error) {
            setErrors((prev)=>[
                    ...prev,
                    error.message
                ]);
            return null;
        }
    };
    const getTrialUpgradeLink = async (organizationId, trialId)=>{
        let url = null;
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$8c7a465b3f0d49dd(organizationId, trialId);
            if (response.resultType == 'Ok' && response.data) url = response.data.url;
            return url;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            return url;
        } finally{
            setLoading(false);
        }
    };
    const getTrialUpgradeLinkForProduct = async (organizationId, trialId, productId)=>{
        let url = null;
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$912fe73bbf623b0f(organizationId, trialId, productId);
            if (response.resultType == 'Ok' && response.data) url = response.data.url;
            return url;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            return url;
        } finally{
            setLoading(false);
        }
    };
    const getBillingLink = async (organizationId)=>{
        let url = null;
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$dabcd4edef40b727(organizationId);
            if (response.resultType == 'Ok' && response.data) url = response.data.url;
            return url;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            return url;
        } finally{
            setLoading(false);
        }
    };
    const getBillingLinkForOrgByProduct = async (organizationId, productId)=>{
        let url = null;
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$7c5bc9294ee86597(organizationId, productId);
            if (response.resultType == 'Ok' && response.data) url = response.data.url;
            return url;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            return url;
        } finally{
            setLoading(false);
        }
    };
    const getBillingLinkForManagedOrg = async (organizationId, managedOrgId)=>{
        let url = null;
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$e8e91c27f56f2528(organizationId, managedOrgId);
            if (response.resultType == 'Ok' && response.data) url = response.data.url;
            return url;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            return url;
        } finally{
            setLoading(false);
        }
    };
    const loadAvailableProducts = async ()=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$2e4ad76cf0d49052();
            if (response.resultType === 'Ok' && response.data) return response.data;
            else return [];
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            return [];
        } finally{
            setLoading(false);
        }
    };
    const getOrganizationMembership = (organizationId)=>{
        if (!organizationId) return undefined;
        return membershipsRef.current.find((member)=>member.organizationId === organizationId);
    };
    const searchOrgManageLicenseKeys = async (organizationId, searchParams, filter)=>{
        try {
            let response = null;
            if (filter === 'available') response = await getOrgManagedLicenseKeysAvailable(organizationId, searchParams);
            else if (filter === 'used') response = await getOrgManagedLicenseKeysUsed(organizationId, searchParams);
            else response = await getOrgManagedLicenseKeys(organizationId, searchParams);
            return response;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const getOrgManagedLicenseKeys = async (organizationId, searchParams)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$3459b02a7394388f(organizationId, searchParams);
            if (response.resultType === 'Ok' && response.data) setOrgManagedLicenseKeys(response.data);
            return response;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const getOrgManagedLicenseKeysAvailable = async (organizationId, searchParams)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$c9479eea2fe9bdb4(organizationId, searchParams);
            if (response.resultType === 'Ok' && response.data) setOrgManagedLicenseKeys(response.data);
            else setOrgManagedLicenseKeys([]);
            return response;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const getOrgManagedLicenseKeysUsed = async (organizationId, searchParams)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$9b109560db3e5fa8(organizationId, searchParams);
            if (response.resultType === 'Ok' && response.data) setOrgManagedLicenseKeys(response.data);
            else setOrgManagedLicenseKeys([]);
            return response;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const getOrgManagedOrgsAll = async (organizationId, searchParams)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$c2666d621521d258(organizationId, searchParams);
            if (response.resultType === 'Ok' && response.data) setOrgManagedOrgs(response.data);
            else setOrgManagedOrgs([]);
            return response;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const createManagedOrg = async (organizationId, newOrganization)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$cbe92e1dd502f37(organizationId, newOrganization);
            if (response.resultType === 'Ok' && response.data) await getOrgManagedOrgsAll(organizationId);
            return response;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const getOrganizationProducts = async (organizationId, locale, searchParams)=>{
        if (!organizationId) {
            setOrgProducts([]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$e57608268c048777(organizationId, locale, searchParams);
            if (response.resultType === 'Ok' && response.data) setOrgProducts(response.data);
            else setOrgProducts([]);
            return response;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            setOrgProducts([]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const getOrgAvailableCustomControls = async (organizationId, locale)=>{
        if (!organizationId) {
            setOrgAvailableCustomControls([]);
            return false;
        }
        let newAvailableCustomControls = [];
        try {
            setLoading(true);
            const response = await getOrgDeviceTypes(organizationId);
            if (response.resultType === 'Ok' && response.data) {
                for (const deviceType of response.data){
                    const controlsResponse = await $1a4c36336f303477$export$fb1c38ee1d8d29f5(deviceType.id, locale);
                    if (controlsResponse.resultType === 'Ok' && controlsResponse.data) {
                        if (controlsResponse.data.controls && controlsResponse.data.controls.length > 0) newAvailableCustomControls.push({
                            deviceId: deviceType.id,
                            deviceTypeId: deviceType.id,
                            name: deviceType.name,
                            controls: controlsResponse.data.controls.filter((control)=>control.isProfileControl)
                        });
                    }
                }
                setOrgAvailableCustomControls(newAvailableCustomControls);
            } else setOrgAvailableCustomControls([]);
            return true;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            setOrgAvailableCustomControls([]);
            return false;
        } finally{
            setLoading(false);
        }
    };
    const getOrganizationProductLink = async (organizationId, productId)=>{
        let url = null;
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$8c8a9832b60f1887(organizationId, productId);
            if (response.resultType == 'Ok' && response.data) url = response.data.url;
            return url;
        } catch (error) {
            setErrors([
                ...errors,
                error.message
            ]);
            return url;
        } finally{
            setLoading(false);
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        const unsubscribeCurrentUserUpdated = (0, $e7df95de73caec26$export$ec068583843480e7)('userUpdated', (data)=>currentUserEmailRef.current = data.user.email);
        return ()=>{
            unsubscribeCurrentUserUpdated();
        };
    }, []);
    return {
        initializeFromRemote: initializeFromRemote,
        initializeFromStorage: initializeFromStorage,
        memberships: memberships,
        membershipsRef: membershipsRef,
        organizationMembers: organizationMembers,
        organizationMembersRef: organizationMembersRef,
        invites: invites,
        invitesRef: invitesRef,
        errors: errors,
        setErrors: setErrors,
        loading: loading,
        loadingRef: loadingRef,
        setLoading: setLoading,
        loadingData: loadingData,
        loadingDataRef: loadingDataRef,
        handleLoadingDataChange: handleLoadingDataChange,
        loadOrganizations: loadOrganizations,
        loadOrganizationMembers: loadOrganizationMembers,
        loadInvites: loadInvites,
        createOrganizationInvite: createOrganizationInvite,
        deleteOrganizationInvite: deleteOrganizationInvite,
        acceptOrganizationInvite: acceptOrganizationInvite,
        removeMember: removeMember,
        updateMemberRole: updateMemberRole,
        updateOrganization: updateOrganization,
        getOrgAuthClients: getOrgAuthClients,
        createOrgAuthClient: createOrgAuthClient,
        updateOrgAuthClient: updateOrgAuthClient,
        rotateClientSecret: rotateClientSecret,
        deleteOrgAuthClient: deleteOrgAuthClient,
        orgAuthClients: orgAuthClients,
        orgAuthClientsRef: orgAuthClientsRef,
        setOrgAuthClients: setOrgAuthClients,
        getOrgDeviceTypes: getOrgDeviceTypes,
        setOrgDeviceTypes: setOrgDeviceTypes,
        createOrgDeviceType: createOrgDeviceType,
        updateOrgDeviceType: updateOrgDeviceType,
        deleteOrgDeviceType: deleteOrgDeviceType,
        orgDeviceTypes: orgDeviceTypes,
        orgDeviceTypesRef: orgDeviceTypesRef,
        currentOrg: currentOrg,
        currentOrgRef: currentOrgRef,
        getOrganizationDetails: getOrganizationDetails,
        loadCurrentOrganizationDetails: loadCurrentOrganizationDetails,
        getScopes: getScopes,
        currentOrgIdRef: currentOrgIdRef,
        scopes: scopes,
        setScopes: setScopes,
        scopesRef: scopesRef,
        updateMembershipsByOrganization: updateMembershipsByOrganization,
        activateNewOrgLicenseKey: activateNewOrgLicenseKey,
        activateExistingOrgLicenseKey: activateExistingOrgLicenseKey,
        getTrialUpgradeLink: getTrialUpgradeLink,
        getTrialUpgradeLinkForProduct: getTrialUpgradeLinkForProduct,
        getBillingLink: getBillingLink,
        getBillingLinkForOrgByProduct: getBillingLinkForOrgByProduct,
        getBillingLinkForManagedOrg: getBillingLinkForManagedOrg,
        loadAvailableProducts: loadAvailableProducts,
        orgProducts: orgProducts,
        orgProductsRef: orgProductsRef,
        getOrganizationProducts: getOrganizationProducts,
        getOrganizationProductLink: getOrganizationProductLink,
        getOrganizationMembership: getOrganizationMembership,
        orgManagedKeysLicenseRef: orgManagedKeysLicenseRef,
        orgManagedLicenseKeys: orgManagedLicenseKeys,
        searchOrgManageLicenseKeys: searchOrgManageLicenseKeys,
        getOrgManagedLicenseKeys: getOrgManagedLicenseKeys,
        getOrgManagedLicenseKeysAvailable: getOrgManagedLicenseKeysAvailable,
        getOrgManagedLicenseKeysUsed: getOrgManagedLicenseKeysUsed,
        orgManagedOrgs: orgManagedOrgs,
        orgManagedOrgsRef: orgManagedOrgsRef,
        getOrgManagedOrgsAll: getOrgManagedOrgsAll,
        createManagedOrg: createManagedOrg,
        validateLicenseKey: validateLicenseKey,
        validateLicenseKeyForOrganization: validateLicenseKeyForOrganization,
        orgAvailableCustomControls: orgAvailableCustomControls,
        orgAvailableCustomControlsRef: orgAvailableCustomControlsRef,
        getOrgAvailableCustomControls: getOrgAvailableCustomControls
    };
}
const $55ce97f088539572$var$OrganizationContainer = (0, $78783f85c4167892$export$26ae5ca175b4ec5a)($55ce97f088539572$var$useOrganizationContainer);
var $55ce97f088539572$export$2e2bcd8739ae039 = $55ce97f088539572$var$OrganizationContainer;











var $7fPBF = parcelRequire("7fPBF");




const $54aa53414bc5a0d5$var$hasTiltControls = (macros)=>{
    return macros.some((macro)=>{
        const hasMotion = (0, $404e806b46f153e3$export$27ae0cf28d39b9f3).some((expression)=>macro.commands.some((command)=>command.includes(expression)));
        return hasMotion;
    });
};
const $54aa53414bc5a0d5$var$hasHeadControls = (macros)=>{
    return macros.some((macro)=>{
        const hasHead = (0, $36ef3dc0587051fc$export$b83c6ea936a344b9).some((expression)=>macro.commands.some((command)=>command.includes(expression)));
        return hasHead;
    });
};
const $54aa53414bc5a0d5$var$hasExpressionControls = (macros)=>{
    return macros.some((macro)=>{
        const hasExpression = (0, $4c9078e3f4d4e7ac$export$821d2a2d20ce1ccf).some((expression)=>macro.commands.some((command)=>command.includes(expression)));
        return hasExpression;
    });
};
const $54aa53414bc5a0d5$var$getProfileFeatures = (profileConfig)=>{
    const features = [];
    if (profileConfig.hotkeys?.length > 0) features.push('hotkey');
    if ($54aa53414bc5a0d5$var$hasTiltControls(profileConfig.macros)) features.push('tilt');
    if ($54aa53414bc5a0d5$var$hasHeadControls(profileConfig.macros)) features.push('head');
    if ($54aa53414bc5a0d5$var$hasExpressionControls(profileConfig.macros)) features.push('expression');
    if (profileConfig.macros?.length > 0) features.push('voice');
    if (profileConfig.audioEvents?.length > 0) features.push('spoken');
    return features;
};
var $54aa53414bc5a0d5$export$2e2bcd8739ae039 = $54aa53414bc5a0d5$var$getProfileFeatures;





var $7fPBF = parcelRequire("7fPBF");

const $c921e0617b97e4e7$export$7f5c23377d97a19f = ()=>typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean' ? navigator.onLine : true;
function $c921e0617b97e4e7$export$2e2bcd8739ae039() {
    const { addBanner: addBanner, removeBanner: removeBanner } = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [status, setStatus] = (0, $7fPBF.useState)($c921e0617b97e4e7$export$7f5c23377d97a19f());
    const setOnline = ()=>setStatus(true);
    const setOffline = ()=>setStatus(false);
    const handleOffline = (0, $7fPBF.useCallback)(()=>{
        const offlineBanner = {
            id: 'offline',
            icon: 'connectionOffline',
            title: t('common:wifi.disconnected'),
            subtitle: t('common:wifi.description'),
            color: 'error'
        };
        addBanner(offlineBanner);
    }, [
        addBanner,
        t
    ]);
    const handleOnline = (0, $7fPBF.useCallback)(()=>{
        removeBanner('offline');
    }, [
        removeBanner
    ]);
    (0, $7fPBF.useEffect)(()=>{
        window.addEventListener('online', setOnline);
        window.addEventListener('offline', setOffline);
        return ()=>{
            window.removeEventListener('online', setOnline);
            window.removeEventListener('offline', setOffline);
        };
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        if (status) handleOnline();
        else handleOffline();
    }, [
        status
    ]);
}



const $ba024c453c69bc05$var$PROFILES_LAST_UPDATED_DATE = 'PROFILES_LAST_UPDATED_DATE';
const $ba024c453c69bc05$var$DEFAULT_PROFILES = 'DEFAULT_PROFILES';
// todo: offline storage of default profiles with in app sqlite database
// todo: might need to be place an upper limit or time out if we get to too many profiles
function $ba024c453c69bc05$var$usePublicProfilesContainer() {
    const [defaultProfiles, setDefaultProfiles, defaultProfilesRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)([]);
    const [publicProfiles, setPublicProfiles, publicProfilesRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)([]);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [errors, setErrors] = (0, $7fPBF.useState)([]);
    const loadPublicProfiles = async (locale, os, licenseAccess, loadFromStorage = false)=>{
        const isOnline = (0, $c921e0617b97e4e7$export$7f5c23377d97a19f)();
        if (!isOnline || loadFromStorage) {
            initializeFromStorage(locale, licenseAccess);
            return;
        }
        const defaultProfilesResult = await loadDefaultProfiles(locale, os, licenseAccess);
        if (defaultProfilesResult?.resultType !== 'Ok') initializeFromStorage(locale, licenseAccess);
    };
    const initializeFromStorage = (locale, licenseAccess)=>{
        try {
            let localDefaultProfiles = loadDefaultProfilesFromStorage(locale, licenseAccess);
            updateLocalDefaultProfiles(localDefaultProfiles);
        } catch (e) {
            console.log(e);
        }
    };
    const loadDefaultProfilesFromStorage = (locale, licenseAccess)=>{
        let localDefaultProfiles = [];
        try {
            const localProfiles = localStorage.getItem($ba024c453c69bc05$var$DEFAULT_PROFILES);
            if (localProfiles) {
                const parsedProfiles = JSON.parse(localProfiles);
                localDefaultProfiles = getFilteredProfiles(parsedProfiles, locale, licenseAccess);
            }
        } catch (e) {
            console.log(e);
        }
        return localDefaultProfiles;
    };
    const getFilteredProfiles = (profiles, locale, licenseAccess)=>{
        let localProfiles = profiles.filter((profile)=>isProfileLocaleMatch(profile, locale) && (0, $28343ab509e453ee$export$6ff753f9d38ae18d)(profile, licenseAccess));
        return localProfiles;
    };
    const isProfileLocaleMatch = (profile, locale)=>{
        if (!profile.defaultLocale) return true;
        const normalizedLocale = locale.toLowerCase();
        const profileLocale = profile.defaultLocale.toLowerCase();
        return (0, $eeb1a4bb5a11a603$export$e88b669f03544b69)(profileLocale, 'voice') === normalizedLocale || (0, $eeb1a4bb5a11a603$export$d44f5da3b0eb939f)(profileLocale) === (0, $eeb1a4bb5a11a603$export$d44f5da3b0eb939f)(normalizedLocale);
    };
    /**
     * gets a paginated amount of public profiles at a time.
     * @param filters
     * @param os pass in getProcessOS if calling from desktop/render side
     * @returns
     */ const getPaginatedPublicProfiles = async (filters, os)=>{
        try {
            setIsLoading(true);
            const request = {
                ...filters,
                platform: os
            };
            const result = await $1a4c36336f303477$export$dda1c3bd332d195f(request);
            if (result?.resultType == 'Ok') {
                const sortedProfiles = result.data?.sort((a, b)=>(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(b.modifiedDate).diff((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(a.modifiedDate))) || [];
                sortedProfiles.map((p, i)=>{
                    sortedProfiles[i].features = (0, $54aa53414bc5a0d5$export$2e2bcd8739ae039)(p.configuration);
                });
                setPublicProfiles(sortedProfiles);
            }
            setIsLoading(false);
            return result;
        } catch (error) {
            console.error(error);
            setIsLoading(false);
            setErrors([
                'Error getting profiles'
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    /**
     * get a public profile by Id if it is not already loaded.
     * @param profileId
     * @returns
     */ const getProfileById = async (profileId, loadFromStorageOnly = false)=>{
        try {
            // public profile or hidden onboarding profile
            const existingProfile = defaultProfilesRef.current.find((p)=>p.id == profileId);
            if (existingProfile) return new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)(existingProfile);
            else if (loadFromStorageOnly) return new (0, $206736819695f5cd$export$2e2bcd8739ae039)();
            else {
                const result = await $1a4c36336f303477$export$fb988fbe57f9c402(profileId);
                return result;
            }
        } catch (error) {
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const loadDefaultProfilesFromRemote = async (locale, os, lastUpdatedDate)=>{
        const localDefaultProfiles = [];
        try {
            let skip = 0;
            const take = 25;
            let result = new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
            let request = {
                locale: locale,
                skip: skip,
                take: take,
                isHidden: false,
                modifiedDate: lastUpdatedDate ? lastUpdatedDate : undefined,
                platform: os
            };
            // load profiles via pagination
            let hasMore = true;
            while(hasMore){
                result = await $1a4c36336f303477$export$dda1c3bd332d195f(request);
                if (result?.resultType === 'Ok' && result.data) {
                    if (result.data.length === 0 || result.data.length < take) hasMore = false;
                    localDefaultProfiles.push(...result.data);
                    skip += result.data.length;
                    request = {
                        ...request,
                        skip: skip
                    };
                } else {
                    setErrors(result.errors ?? [
                        'Error loading default profiles'
                    ]);
                    break;
                }
            }
            return localDefaultProfiles;
        } catch (error) {
            console.error(error);
            setErrors([
                'Error loading default profiles'
            ]);
            return localDefaultProfiles;
        } finally{
            setIsLoading(false);
        }
    };
    const saveDefaultProfilesToStorage = (profiles)=>{
        try {
            localStorage.setItem($ba024c453c69bc05$var$PROFILES_LAST_UPDATED_DATE, new Date().toISOString());
            localStorage.setItem($ba024c453c69bc05$var$DEFAULT_PROFILES, JSON.stringify(profiles));
            updateLocalDefaultProfiles(profiles);
        } catch (error) {
            console.error(error);
        }
    };
    const isProfilesOutdated = (profiles, locale, licenseAccess)=>{
        // no profiles
        if (profiles.length === 0) return true;
        // locale mismatch
        const newLocaleProfiles = profiles.filter((p)=>isProfileLocaleMatch(p, locale));
        if (newLocaleProfiles.length === 0) return true;
        // license upgraded
        const freeProfiles = profiles.filter((p)=>(0, $28343ab509e453ee$export$513d3938ac2af8f0)(p));
        if (freeProfiles.length === profiles.length && licenseAccess.type !== 'personal') return true;
        return false;
    };
    /**
     * Loads all available default and public profiles after a modified date. Does not get hidden profiles.
     * @param locale
     * @param os pass in getProcessOS if calling from desktop/render side
     * @returns that last result of the paginated profiles
     */ const loadDefaultProfiles = async (locale, os, licenseAccess)=>{
        try {
            setIsLoading(true);
            let existingProfiles = loadDefaultProfilesFromStorage(locale, licenseAccess);
            const lastUpdatedDate = existingProfiles.length > 0 && !isProfilesOutdated(existingProfiles, locale, licenseAccess) ? localStorage.getItem($ba024c453c69bc05$var$PROFILES_LAST_UPDATED_DATE) : undefined;
            const localDefaultProfiles = await loadDefaultProfilesFromRemote(locale, os, lastUpdatedDate);
            const combinedProfiles = [
                ...localDefaultProfiles
            ];
            if (localDefaultProfiles.length > 0 && existingProfiles) {
                // only add existing profiles if their locale matches
                for (const profile of existingProfiles)if (isProfileLocaleMatch(profile, locale)) {
                    const existingProfile = combinedProfiles.find((p)=>p.id === profile.id);
                    if (!existingProfile) combinedProfiles.push(profile);
                }
            }
            if (combinedProfiles.length > 0) saveDefaultProfilesToStorage(combinedProfiles);
            else updateLocalDefaultProfiles(existingProfiles);
            return combinedProfiles.length > 0 ? new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)(combinedProfiles) : new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)(existingProfiles);
        } catch (error) {
            console.error(error);
            setErrors([
                'Error loading default profiles'
            ]);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setIsLoading(false);
        }
    };
    const getPublicProfileFeatures = (profileId)=>{
        const profile = publicProfiles.find((p)=>p.id === profileId);
        if (!profile) return [];
        const features = (0, $54aa53414bc5a0d5$export$2e2bcd8739ae039)(profile?.configuration);
        return features;
    };
    const clearProfiles = ()=>{
        updateLocalDefaultProfiles([]);
        setPublicProfiles([]);
        localStorage.removeItem($ba024c453c69bc05$var$DEFAULT_PROFILES);
        localStorage.removeItem($ba024c453c69bc05$var$PROFILES_LAST_UPDATED_DATE);
    };
    const updateLocalDefaultProfiles = (profiles)=>{
        const sorted = profiles.sort((a, b)=>a.name.localeCompare(b.name));
        setDefaultProfiles(sorted);
        (0, $e7df95de73caec26$export$89b472e03be495df)('default-profiles-updated', sorted);
    };
    const getProfile = async (profileId, loadFromStorageOnly = false)=>{
        const profileResult = await getProfileById(profileId, loadFromStorageOnly);
        if (profileResult?.resultType === 'Ok' && profileResult.data) return profileResult.data;
        return null;
    };
    return {
        publicProfiles: publicProfiles,
        publicProfilesRef: publicProfilesRef,
        getPublicProfileFeatures: getPublicProfileFeatures,
        isLoading: isLoading,
        errors: errors,
        initializeFromStorage: initializeFromStorage,
        loadPublicProfiles: loadPublicProfiles,
        defaultProfiles: defaultProfiles,
        defaultProfilesRef: defaultProfilesRef,
        loadDefaultProfilesFromRemote: loadDefaultProfilesFromRemote,
        saveDefaultProfilesToStorage: saveDefaultProfilesToStorage,
        isProfileLocaleMatch: isProfileLocaleMatch,
        clearProfiles: clearProfiles,
        getProfile: getProfile,
        getPaginatedPublicProfiles: getPaginatedPublicProfiles
    };
}
const $ba024c453c69bc05$var$PublicProfilesContainer = (0, $78783f85c4167892$export$26ae5ca175b4ec5a)($ba024c453c69bc05$var$usePublicProfilesContainer);
var $ba024c453c69bc05$export$2e2bcd8739ae039 = $ba024c453c69bc05$var$PublicProfilesContainer;







var $7fPBF = parcelRequire("7fPBF");

function $07a883fe7c352c85$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $07a883fe7c352c85$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $07a883fe7c352c85$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $07a883fe7c352c85$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $07a883fe7c352c85$export$2e2bcd8739ae039 = $07a883fe7c352c85$export$4f5d2d50c9deca37;



/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $93971f0806345477$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}






function $8b571bd6b8501d36$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $8b571bd6b8501d36$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $8b571bd6b8501d36$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $8b571bd6b8501d36$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $8b571bd6b8501d36$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $dddaf6f84c717660$exports.ForwardRef:
            return $8b571bd6b8501d36$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $dddaf6f84c717660$exports.Memo:
            return $8b571bd6b8501d36$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}





function $fc14e19011b26945$export$2e2bcd8739ae039(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $d1cc2e8a071de52d$export$13a2d3ef13012b32)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $d1cc2e8a071de52d$export$13a2d3ef13012b32)(variant.style);
    });
    return result;
}


const $8936448efcebb2cc$export$35e57303dbd8a66 = (0, $c6ae1e3a98d0d5b8$export$2e2bcd8739ae039)();
function $8936448efcebb2cc$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $8936448efcebb2cc$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
function $8936448efcebb2cc$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $8936448efcebb2cc$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $8936448efcebb2cc$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $8936448efcebb2cc$var$processStyle(props, style, layerName) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$8936448efcebb2cc$var$processStyle(props, subStyle, layerName));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = layerName ? $8936448efcebb2cc$var$shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = layerName ? $8936448efcebb2cc$var$shallowLayer((0, $d1cc2e8a071de52d$export$13a2d3ef13012b32)(otherStyles), layerName) : otherStyles;
        }
        return $8936448efcebb2cc$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ], layerName);
    }
    if (resolvedStyle?.isProcessed) return layerName ? $8936448efcebb2cc$var$shallowLayer((0, $d1cc2e8a071de52d$export$13a2d3ef13012b32)(resolvedStyle.style), layerName) : resolvedStyle.style;
    return layerName ? $8936448efcebb2cc$var$shallowLayer((0, $d1cc2e8a071de52d$export$13a2d3ef13012b32)(resolvedStyle), layerName) : resolvedStyle;
}
function $8936448efcebb2cc$var$processStyleVariants(props, variants, results = [], layerName) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            results.push(layerName ? $8936448efcebb2cc$var$shallowLayer((0, $d1cc2e8a071de52d$export$13a2d3ef13012b32)(variant.style(mergedState)), layerName) : variant.style(mergedState));
        } else results.push(layerName ? $8936448efcebb2cc$var$shallowLayer((0, $d1cc2e8a071de52d$export$13a2d3ef13012b32)(variant.style), layerName) : variant.style);
    }
    return results;
}
function $8936448efcebb2cc$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $8936448efcebb2cc$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $8936448efcebb2cc$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $8936448efcebb2cc$export$3ba67b570e26eea0 } = input;
    function styleAttachTheme(props) {
        $8936448efcebb2cc$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $d1cc2e8a071de52d$export$592c7226e4cb0171)(tag, (styles)=>styles.filter((style)=>style !== (0, $c202727e06c030fc$export$2e2bcd8739ae039)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $8936448efcebb2cc$var$defaultOverridesResolver($8936448efcebb2cc$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $8936448efcebb2cc$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($8936448efcebb2cc$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $d1cc2e8a071de52d$export$2e2bcd8739ae039)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $8936448efcebb2cc$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return $8936448efcebb2cc$var$processStyle(props, style, props.theme.modularCssLayers ? layerName : undefined);
            };
            if ((0, $291e2c063c5d6173$export$53b83ca8eaab0383)(style)) {
                const serialized = (0, $fc14e19011b26945$export$2e2bcd8739ae039)(style);
                return function styleObjectProcessor(props) {
                    if (!serialized.variants) return props.theme.modularCssLayers ? $8936448efcebb2cc$var$shallowLayer(serialized.style, layerName) : serialized.style;
                    return $8936448efcebb2cc$var$processStyle(props, serialized, props.theme.modularCssLayers ? layerName : undefined);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $8936448efcebb2cc$var$processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? 'theme' : undefined);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $8936448efcebb2cc$var$processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsTail.push((0, $c202727e06c030fc$export$2e2bcd8739ae039));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $8936448efcebb2cc$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $d8da749d88f71122$export$2e2bcd8739ae039)(componentSlot || '')}`;
    return `Styled(${(0, $8b571bd6b8501d36$export$2e2bcd8739ae039)(tag)})`;
}
function $8936448efcebb2cc$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $8936448efcebb2cc$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $8936448efcebb2cc$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $8936448efcebb2cc$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}




// copied from @mui/system/createStyled
function $066f83798075d563$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $066f83798075d563$export$2e2bcd8739ae039 = $066f83798075d563$var$slotShouldForwardProp;


const $0820e164eb5fbaff$var$rootShouldForwardProp = (prop)=>(0, $066f83798075d563$export$2e2bcd8739ae039)(prop) && prop !== 'classes';
var $0820e164eb5fbaff$export$2e2bcd8739ae039 = $0820e164eb5fbaff$var$rootShouldForwardProp;



'use client';
const $f0645ef192f222f7$var$styled = (0, $8936448efcebb2cc$export$2e2bcd8739ae039)({
    themeId: (0, $e35ef6915a224202$export$2e2bcd8739ae039),
    defaultTheme: $726fe1d2377a5002$export$2e2bcd8739ae039,
    rootShouldForwardProp: $0820e164eb5fbaff$export$2e2bcd8739ae039
});
var $f0645ef192f222f7$export$2e2bcd8739ae039 = $f0645ef192f222f7$var$styled;



/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $c76324e7d0f0ede1$var$arg = {
    theme: undefined
};
function $c76324e7d0f0ede1$export$2e2bcd8739ae039(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $c76324e7d0f0ede1$var$arg.theme = props.theme;
            value = (0, $fc14e19011b26945$export$2e2bcd8739ae039)(styleFn($c76324e7d0f0ede1$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}


const $574bade4fe8533ba$var$memoTheme = (0, $c76324e7d0f0ede1$export$2e2bcd8739ae039);
var $574bade4fe8533ba$export$2e2bcd8739ae039 = $574bade4fe8533ba$var$memoTheme;


parcelRequire("7fPBF");



'use client';
function $dc79fb0f6686e80b$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4c2bf5434c896cc$export$2e2bcd8739ae039), {
        ...props
    });
}
var $dc79fb0f6686e80b$export$2e2bcd8739ae039 = $dc79fb0f6686e80b$var$DefaultPropsProvider;
function $dc79fb0f6686e80b$export$2440da353cedad43(params) {
    return (0, $e4c2bf5434c896cc$export$2440da353cedad43)(params);
}



var $816c65c0e1f7082c$export$2e2bcd8739ae039 = (0, $d8da749d88f71122$export$2e2bcd8739ae039);


/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function $061b5988a3817e26$var$hasCorrectMainProperty(obj) {
    return typeof obj.main === 'string';
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function $061b5988a3817e26$var$checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!$061b5988a3817e26$var$hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== 'string') return false;
    }
    return true;
}
function $061b5988a3817e26$export$2e2bcd8739ae039(additionalPropertiesToCheck = []) {
    return ([, value])=>value && $061b5988a3817e26$var$checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}


const $f37dfc12e5d89c96$var$defaultGenerator = (componentName)=>componentName;
const $f37dfc12e5d89c96$var$createClassNameGenerator = ()=>{
    let generate = $f37dfc12e5d89c96$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $f37dfc12e5d89c96$var$defaultGenerator;
        }
    };
};
const $f37dfc12e5d89c96$var$ClassNameGenerator = $f37dfc12e5d89c96$var$createClassNameGenerator();
var $f37dfc12e5d89c96$export$2e2bcd8739ae039 = $f37dfc12e5d89c96$var$ClassNameGenerator;


const $ea3dfa6b173640a4$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $ea3dfa6b173640a4$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $ea3dfa6b173640a4$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $f37dfc12e5d89c96$export$2e2bcd8739ae039).generate(componentName)}-${slot}`;
}
function $ea3dfa6b173640a4$export$34c0130b1f3e8ae3(slot) {
    return $ea3dfa6b173640a4$export$9d6b9120de57c54[slot] !== undefined;
}


function $32447174989d1976$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)(componentName, slot, globalStatePrefix);
    });
    return result;
}



function $978389e4a0c045ec$export$29cad1383b3f235d(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiCircularProgress', slot);
}
const $978389e4a0c045ec$var$circularProgressClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $978389e4a0c045ec$export$2e2bcd8739ae039 = $978389e4a0c045ec$var$circularProgressClasses;



'use client';
const $d513166e63c42433$var$SIZE = 44;
const $d513166e63c42433$var$circularRotateKeyframe = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const $d513166e63c42433$var$circularDashKeyframe = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $d513166e63c42433$var$rotateAnimation = typeof $d513166e63c42433$var$circularRotateKeyframe !== 'string' ? (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
        animation: ${$d513166e63c42433$var$circularRotateKeyframe} 1.4s linear infinite;
      ` : null;
const $d513166e63c42433$var$dashAnimation = typeof $d513166e63c42433$var$circularDashKeyframe !== 'string' ? (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
        animation: ${$d513166e63c42433$var$circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null;
const $d513166e63c42433$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $978389e4a0c045ec$export$29cad1383b3f235d), classes);
};
const $d513166e63c42433$var$CircularProgressRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-block',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('transform')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: $d513166e63c42433$var$rotateAnimation || {
                    animation: `${$d513166e63c42433$var$circularRotateKeyframe} 1.4s linear infinite`
                }
            },
            ...Object.entries(theme.palette).filter((0, $061b5988a3817e26$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const $d513166e63c42433$var$CircularProgressSVG = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $d513166e63c42433$var$CircularProgressCircle = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        stroke: 'currentColor',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('stroke-dashoffset')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: {
                    // Some default value that looks fine waiting for the animation to kicks in.
                    strokeDasharray: '80px, 200px',
                    strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                style: $d513166e63c42433$var$dashAnimation || {
                    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
                    animation: `${$d513166e63c42433$var$circularDashKeyframe} 1.4s ease-in-out infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $d513166e63c42433$var$CircularProgress = /*#__PURE__*/ $7fPBF.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    };
    const classes = $d513166e63c42433$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($d513166e63c42433$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d513166e63c42433$var$CircularProgressRoot, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        style: {
            width: size,
            height: size,
            ...rootStyle,
            ...style
        },
        ownerState: ownerState,
        ref: ref,
        role: "progressbar",
        ...rootProps,
        ...other,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d513166e63c42433$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$d513166e63c42433$var$SIZE / 2} ${$d513166e63c42433$var$SIZE / 2} ${$d513166e63c42433$var$SIZE} ${$d513166e63c42433$var$SIZE}`,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d513166e63c42433$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $d513166e63c42433$var$SIZE,
                cy: $d513166e63c42433$var$SIZE,
                r: ($d513166e63c42433$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    });
});
var $d513166e63c42433$export$2e2bcd8739ae039 = $d513166e63c42433$var$CircularProgress;



parcelRequire("7fPBF");
const $0e54c6b17377038f$var$SvgIcon = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 500 500",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "icon_svg__linear-gradient",
                        x1: 87.69,
                        x2: 445.37,
                        y1: 515.02,
                        y2: 376.71,
                        gradientTransform: "rotate(-8.86 -1005.607 449.555)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#36368b"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.07,
                                stopColor: "#563986"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.17,
                                stopColor: "#7e3d7f"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.27,
                                stopColor: "#a1407a"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.38,
                                stopColor: "#bd4376"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#d24573"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.63,
                                stopColor: "#e24670"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.78,
                                stopColor: "#eb476f"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ee486f"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "icon_svg__linear-gradient-2",
                        x1: -1214.8,
                        x2: -1320.26,
                        y1: -1720.35,
                        y2: -1993.07,
                        gradientTransform: "rotate(81.14 -1702.827 77.309)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#6db9e7"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.07,
                                stopColor: "#6ca2d7"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.16,
                                stopColor: "#6b8ac6"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.26,
                                stopColor: "#6b79ba"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.37,
                                stopColor: "#6b6fb3"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#6b6cb1"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#062844"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "icon_svg__luminosity-invert",
                        width: 386,
                        height: 388,
                        x: 57.27,
                        y: 56.08,
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            result: "cm",
                            values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("style", {
                        children: '.icon_svg__cls-8{stroke-width:0}.icon_svg__cls-10{mix-blend-mode:multiply;opacity:.2}.icon_svg__cls-8{fill:#ee486f}'
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "icon_svg__mask",
                        width: 386,
                        height: 388,
                        x: 57.27,
                        y: 56.08,
                        maskUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                            xlinkHref: "data:image/png;base64,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",
                            width: 386,
                            height: 388,
                            style: {
                                filter: 'url(#icon_svg__luminosity-invert)'
                            },
                            transform: "translate(57.27 56.08)"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    isolation: 'isolate'
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    id: "icon_svg__Layer_1",
                    "data-name": "Layer 1",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            cx: 250,
                            cy: 250,
                            r: 218.04,
                            style: {
                                fill: '#fff',
                                strokeWidth: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M423.3 278.06c-6.24-20.76-23.53-25.23-34.56-23.23-3.73.68-7.06 2.19-9.6 3.65-1.18.68-.54 2.48.8 2.29 7.95-1.09 22-.85 28.92 12.28 2.42 4.6 12.06 24.68-18.71 41.5-16.41 8.97-35.03 6.43-43.28-4.98-4.76 2.88-9.59 5.81-14.61 8.81-12.93-18.26-30.68-11.37-39.03-5.58-1.14.79-.3 2.57 1.04 2.21 8.24-2.21 22.21-3.67 29.17 8.79 6.02 10.79-1.44 25.88-15.8 33.23-14.36 7.35-31.45 8.24-36.53-7.56-5.86 2.13-11.77 4.06-17.76 5.63-4.84-18.54-20.06-20.22-28.74-17.95-1.34.35-1.18 2.31.2 2.43 6.28.56 15.15 2.91 18.77 11.41 2.9 6.83 2.42 22.51-22.21 25.61-13.96 1.76-28.18-4.3-27.8-17.71-6.35-.98-12.67-2.4-18.91-4.42 6.76-16.28-4.56-26.7-12.61-30.2-1.29-.56-2.4 1.09-1.35 2.03 4.06 3.65 8.69 9.47 8.47 16.88-1.17 15.18-16.96 19.66-30.98 12.01-11.58-6.32-19.7-18.59-11.68-30.53-12.52-12.32-23-30.24-29.21-48.7-12.14-36.08 0-72.66 26.42-94.1 33.14-26.87 65.23-18.02 80.26-12.18 2.7 1.05 2.23 3.64-.83 3.01-2.06-.43-4.6-.58-6.87-.72-5.33-.34-10.96 0-15.57 1.17-15.55 3.96-28.26 22.1-29.23 46.19.29 22.04 11.21 47.71 32.94 55.39 29.17 10.77 54.06-8.72 77.23-26.1 20.69-15.92 42.37-36.48 71.26-55.21 42.25-27.4 85.07-37.27 85.07-37.27-27.13-48.06-74.23-82.66-128.27-93.87-21.93-4.55-45.02-5.34-68.45-1.69a192.795 192.795 0 0 0-36.2 9.32s-24.5 8.63-44.5 23.19c-2.25 1.63-4.94 3.83-7.73 6.2-4.46 3.8-1.26 11.06 4.55 10.31 11.82-1.52 27.68-1.4 46.13 4.13 34.82 10.44 52.88 35.39 61.54 52 4.7 9.03-4.08 12.95-9.12 7.9-15.94-15.99-64.45-45.57-121.42-15.56-37.65 19.83-51.86 54.75-54.29 83.82-3.7 44.1 12.63 83.05 23.73 102.62 27.1 47.83 73.78 81.92 127.59 93.18 22.02 4.61 45.23 5.43 68.77 1.76 43.21-6.73 80.75-27.43 108.83-56.75a193.006 193.006 0 0 0 30.14-41.27c10.4-19.14 17.61-40.12 21.01-62.13a2.18 2.18 0 0 0-1.97-2.49c-8.48-.7-15.01 1.26-15.01 1.26Z",
                            style: {
                                strokeWidth: 0,
                                fill: 'url(#icon_svg__linear-gradient)'
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            style: {
                                mask: 'url(#icon_svg__mask)'
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M423.3 278.06c-6.24-20.76-23.53-25.23-34.56-23.23-3.73.68-7.06 2.19-9.6 3.65-1.18.68-.54 2.48.8 2.29 7.95-1.09 22-.85 28.92 12.28 2.42 4.6 12.06 24.68-18.71 41.5-16.41 8.97-35.03 6.43-43.28-4.98-4.76 2.88-9.59 5.81-14.61 8.81-12.93-18.26-30.68-11.37-39.03-5.58-1.14.79-.3 2.57 1.04 2.21 8.24-2.21 22.21-3.67 29.17 8.79 6.02 10.79-1.44 25.88-15.8 33.23-14.36 7.35-31.45 8.24-36.53-7.56-5.86 2.13-11.77 4.06-17.76 5.63-4.84-18.54-20.06-20.22-28.74-17.95-1.34.35-1.18 2.31.2 2.43 6.28.56 15.15 2.91 18.77 11.41 2.9 6.83 2.42 22.51-22.21 25.61-13.96 1.76-28.18-4.3-27.8-17.71-6.35-.98-12.67-2.4-18.91-4.42 6.76-16.28-4.56-26.7-12.61-30.2-1.29-.56-2.4 1.09-1.35 2.03 4.06 3.65 8.69 9.47 8.47 16.88-1.17 15.18-16.96 19.66-30.98 12.01-11.58-6.32-19.7-18.59-11.68-30.53-12.52-12.32-23-30.24-29.21-48.7-12.14-36.08 0-72.66 26.42-94.1 33.14-26.87 65.23-18.02 80.26-12.18 2.7 1.05 2.23 3.64-.83 3.01-2.06-.43-4.6-.58-6.87-.72-5.33-.34-10.96 0-15.57 1.17-15.55 3.96-28.26 22.1-29.23 46.19.29 22.04 11.21 47.71 32.94 55.39 29.17 10.77 54.06-8.72 77.23-26.1 20.69-15.92 42.37-36.48 71.26-55.21 42.25-27.4 85.07-37.27 85.07-37.27-27.13-48.06-74.23-82.66-128.27-93.87-21.93-4.55-45.02-5.34-68.45-1.69a192.795 192.795 0 0 0-36.2 9.32s-24.5 8.63-44.5 23.19c-2.25 1.63-4.94 3.83-7.73 6.2-4.46 3.8-1.26 11.06 4.55 10.31 11.82-1.52 27.68-1.4 46.13 4.13 34.82 10.44 52.88 35.39 61.54 52 4.7 9.03-4.08 12.95-9.12 7.9-15.94-15.99-64.45-45.57-121.42-15.56-37.65 19.83-51.86 54.75-54.29 83.82-3.7 44.1 12.63 83.05 23.73 102.62 27.1 47.83 73.78 81.92 127.59 93.18 22.02 4.61 45.23 5.43 68.77 1.76 43.21-6.73 80.75-27.43 108.83-56.75a193.006 193.006 0 0 0 30.14-41.27c10.4-19.14 17.61-40.12 21.01-62.13a2.18 2.18 0 0 0-1.97-2.49c-8.48-.7-15.01 1.26-15.01 1.26Z",
                                className: "icon_svg__cls-10",
                                style: {
                                    fill: '#141728',
                                    strokeWidth: 0
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M282.16 344.9c1.32 2.58 4.5 3.52 6.28 3.84 4.19.77 9.19-.13 13.73-2.45 7.84-4.01 11.81-10.96 11.12-15.38-.09-.6-.27-1.15-.55-1.68-1.32-2.58-4.5-3.52-6.28-3.84-4.19-.77-9.19.13-13.73 2.45-7.84 4.01-11.8 10.97-11.11 15.38.09.6.27 1.15.54 1.67ZM204.94 359.8v.09c.54 3.38 6.68 7.58 15.12 6.49 4.29-.56 8.17-2.41 10.67-5.07.77-.82 2.52-2.97 2.21-5.23-.53-3.37-6.67-7.58-15.11-6.49-4.29.56-8.17 2.41-10.66 5.07-.77.82-2.52 2.97-2.23 5.14ZM135.15 331.26c-.13.2-.5.79-.43 2.08.16 3.06 2.65 7.61 7.83 10.9 3.47 2.2 7.38 3.3 10.71 3 .96-.08 3.29-.44 4.18-1.84.12-.2.5-.78.43-2.07-.16-3.05-2.65-7.61-7.83-10.9-3.47-2.2-7.38-3.3-10.71-3-.96.09-3.29.44-4.17 1.83ZM354.77 298.44c.17 1.11.52 2.16 1.03 3.12 3.96 7.35 17.35 8.47 28.67 2.39 11.08-5.96 15.86-15.63 14.85-22.1a9.572 9.572 0 0 0-1.04-3.12c-3.95-7.35-17.34-8.47-28.66-2.39-11.08 5.96-15.86 15.63-14.85 22.1Z",
                            className: "icon_svg__cls-8"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M332.91 193.39c-28.88 18.73-50.56 39.3-71.26 55.21-23.17 17.37-48.06 36.86-77.23 26.1-21.74-7.68-32.65-33.34-32.94-55.39.97-24.09 12.32-42.76 51.67-46.63-16.82-3.36-34.43-.73-46.78 7.54-39.16 26.22-32.77 64.92-21.16 87.92 11.09 22 38.58 42.82 72.01 42.74 22.84-.06 50.73-9.11 93.49-41.57 52.34-39.73 94.85-54.55 133.93-55.27.59-.01 1.18-.11 1.75-.07 1.55.08 2.7-.54 2.07-2.99-.09-.35-.15-.7-.22-1.05-4.11-19.3-11.01-37.36-20.24-53.81-2.25.51-42.83 9.87-85.07 37.27Z",
                            style: {
                                fill: 'url(#icon_svg__linear-gradient-2)',
                                strokeWidth: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M258.57 228.81c-23.17 17.37-46.14 40.29-75.31 29.52-15.38-5.43-27.15-23.33-31.77-39.13 0 .04 0 .07-.01.11.02 1.38.08 2.77.18 4.17.1 1.4.24 2.81.43 4.22 2.58 19.78 13.32 40.27 32.34 46.99 5.47 2.02 10.79 2.97 15.97 3.08 22.47.45 42.43-15.06 61.26-29.17 6.11-4.7 12.33-9.82 18.76-15.16 15.38-12.76 32.13-26.84 52.49-40.05 41.43-26.87 81.37-36.42 85.02-37.26v-.11a191.01 191.01 0 0 0-11.29-17.62c-16.21 5.31-50.57 18.18-76.81 35.19-28.88 18.73-50.56 39.29-71.25 55.21Z",
                            style: {
                                fill: '#141526',
                                mixBlendMode: 'multiply',
                                opacity: 0.2,
                                strokeWidth: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M99.69 189.16c-13.2 15.05-31.43 60.23-13.11 104.52 4.7 11.37 11.11 24.1 21.23 34.37-.64 3.74-.68 7.44-.12 11.05 3.05 19.55 22.46 29.74 23.45 30.25 19.15 9.13 33.08 3.38 38.85-.06l10.79 3.27c7.88 22.93 39.73 20.67 41.12 20.56 23.42-1.76 33-14.04 36.22-19.78l7.55-2.49c20.74 19.19 51.76 1.14 53.12.33 21.54-12.7 24.48-31.1 24.62-39.32l1.83-1.06c26.46 16.4 56.87-2.77 57.87-3.43 17.86-9.84 24.13-25.13 26.15-32.16 2.45-.6 5.42-.59 7.91-.37 1.24-5.12 2.29-10.3 3.11-15.55.19-1.24-.73-2.39-1.98-2.49-1.35-.11-2.65-.15-3.89-.14-.17 0-.36-.01-.53 0-.48 0-.92.04-1.38.07-.52.02-1.08.03-1.56.07-.19.01-.34.04-.53.06-.71.06-1.41.13-2.04.22-1.2.16-2.16.34-2.96.51-.28.06-.58.12-.81.17-.82.19-1.29.33-1.29.33-.71-2.34-1.59-4.42-2.55-6.36-.29-.58-.6-1.11-.91-1.66-.76-1.35-1.57-2.6-2.43-3.75-.34-.45-.68-.93-1.03-1.35-2.57-3.05-5.48-5.38-8.55-7.02a29.867 29.867 0 0 0-9.9-3.21c-1.63-.23-3.24-.32-4.78-.29-1.54.03-3.02.18-4.39.43-1.53.28-2.93.76-4.29 1.25-.82.31-1.64.63-2.4.98-1.01.46-2.05.92-2.9 1.41-.01 0-.01.02-.02.03-.36.23-.5.57-.53.91v.24c.05.35.19.7.5.91.14.09.34.09.53.11.12.02.2.09.33.07.96-.13 2.04-.23 3.16-.3h.2c.6-.04 1.25-.02 1.88-.03h.09c.57 0 1.11-.04 1.7-.02s.02 0 .02 0c.05 0 .1.01.15.01 1.01.04 2.05.13 3.1.26.53.07 1.05.18 1.58.27.64.12 1.28.25 1.92.41.73.18 1.45.39 2.19.65.53.18 1.05.42 1.58.63s1.04.4 1.55.66c1.19.6 2.36 1.28 3.47 2.13 2.42 1.85 4.59 4.33 6.32 7.61.04.07.09.2.14.28.51.99 1.25 2.55 1.9 4.56.1.32.21.63.3.97.2.7.37 1.43.53 2.21.02.08.04.16.06.25.14.78.26 1.6.33 2.46v.02c.04.51.04 1.06.05 1.59v.04c.03 1.68-.14 3.46-.54 5.32-.05.24-.09.48-.15.72-.1.41-.21.82-.34 1.23-.42 1.36-1.01 2.75-1.73 4.15l-.03.06c-.49.94-1.05 1.88-1.7 2.84-.17.26-.34.51-.52.76-.64.89-1.37 1.78-2.16 2.68-.06.07-.12.13-.17.2a41.236 41.236 0 0 1-4.27 4.13c-.05.04-.09.09-.14.13a58.12 58.12 0 0 1-5.6 4.09h-.01c-1.13.73-2.35 1.45-3.63 2.18-.01 0-.03.01-.04.02-.33.19-.61.38-.95.57-.08.04-.17.08-.25.11-.71.38-1.43.64-2.15.98-1.05.5-2.09 1.02-3.15 1.43-1.2.46-2.4.79-3.61 1.14h-.02c-.65.19-1.3.4-1.95.55h-.02c-.92.22-1.83.4-2.75.56-.85.14-1.69.23-2.53.31-1.08.11-2.15.23-3.2.25h-.01c-.1 0-.2-.01-.3-.01-2.3.02-4.51-.19-6.66-.58-.09-.02-.17-.04-.25-.05-1.81-.34-3.53-.83-5.18-1.46h-.02a26.38 26.38 0 0 1-4.64-2.3c-.13-.08-.26-.18-.39-.27-1.12-.73-2.19-1.49-3.16-2.38-.25-.22-.45-.48-.67-.73-.57-.57-1.13-1.14-1.63-1.77-.24-.25-.5-.48-.7-.76-4.76 2.88-9.59 5.81-14.61 8.81-.07-.1-.14-.17-.21-.27-.07-.08-.13-.16-.2-.25-.78-1.06-1.57-2.04-2.38-2.93-.38-.42-.77-.78-1.15-1.16a30.6 30.6 0 0 0-1.81-1.66c-.43-.35-.85-.69-1.28-1.01-.6-.44-1.21-.83-1.81-1.2-.2-.12-.41-.24-.61-.36-.01 0-.03-.01-.04-.02-.2-.12-.4-.25-.61-.36-.76-.4-1.52-.73-2.29-1.02-2.14-.83-4.29-1.31-6.41-1.48h-.03c-1.61-.12-3.2-.08-4.75.1s-.01 0-.02 0c-.62.07-1.22.18-1.83.29-.06 0-.13.02-.19.03-.3.05-.6.1-.89.16l-.22.06c-.13.03-.25.07-.38.1-1.02.25-2.02.55-2.98.88-.03 0-.05.02-.08.03-.13.04-.26.09-.39.13-1.29.47-2.52 1-3.68 1.57-.07.03-.14.07-.22.11-.05.02-.09.04-.14.07-1.57.8-3 1.64-4.23 2.48-.03.02-.05.03-.08.05-.04.03-.08.05-.12.08-.27.19-.42.44-.49.7-.04.15 0 .29.02.44v.08c0 .05 0 .09.02.14.07.19.19.37.35.52.12.12.27.21.43.28h.09c.12.03.25.05.39.04.07 0 .13.02.2 0 .87-.23 1.83-.45 2.81-.65.18-.04.34-.09.52-.12 1.07-.21 2.22-.36 3.38-.48l.59-.06c.16-.01.32 0 .48-.02 1.28-.1 2.58-.13 3.91-.07h.04c1.31.06 2.63.21 3.94.46.28.06.56.14.84.22 1.02.24 2.03.52 3.01.91.3.12.59.3.88.44h.02c.92.43 1.83.87 2.7 1.46.42.28.79.67 1.19 1.01.74.6 1.48 1.19 2.15 1.94.97 1.08 1.89 2.28 2.69 3.72.62 1.11 1.01 2.29 1.34 3.48.18.61.3 1.23.41 1.86.16.95.29 1.9.29 2.88 0 .6-.07 1.19-.14 1.79-.06.49-.15 1.3-.24 1.79-.16.86-.34 1.71-.6 2.57-.26.84-.56 1.67-.92 2.5-.37.87-.82 1.72-1.29 2.57-.16.28-.33.56-.5.84-1.62 2.68-3.72 5.2-6.27 7.48-.63.55-1.24 1.11-1.92 1.63-1.83 1.42-3.77 2.75-5.94 3.85s-.01.01-.02.01c-1.27.65-2.56 1.22-3.85 1.76-.05.02-.11.04-.16.07h-.01c-2.69 1.11-5.42 1.96-8.12 2.51h-.01c-.09.02-.19.04-.28.05-5.24 1.03-10.29.87-14.5-.94-.15-.06-.28-.14-.43-.21-.83-.38-1.62-.83-2.37-1.35-.16-.11-.34-.22-.5-.34a16.09 16.09 0 0 1-2.37-2.17c-.1-.12-.19-.25-.29-.37-.61-.73-1.17-1.55-1.68-2.43-.14-.24-.28-.47-.41-.72-.55-1.05-1.06-2.17-1.46-3.43-5.86 2.13-11.77 4.07-17.76 5.63s0-.03-.01-.04c0-.02-.01-.04-.02-.06-1.08-4.1-2.72-7.27-4.63-9.85-.2-.27-.37-.61-.57-.89-.18-.24-.37-.43-.56-.63s-.04-.05-.07-.07c-.45-.51-.9-1-1.37-1.44-.31-.29-.63-.54-.94-.8-.39-.32-.78-.64-1.18-.92-.34-.24-.68-.47-1.02-.68-.41-.26-.83-.5-1.24-.72-.16-.09-.32-.17-.48-.25-.18-.09-.35-.19-.53-.27-.5-.23-1.01-.43-1.52-.63-.02 0-.04-.02-.07-.02-.01 0-.02 0-.03-.01-.22-.08-.43-.18-.65-.25-.79-.26-1.58-.48-2.37-.65l-.17-.03h-.06c-.75-.15-1.51-.27-2.25-.35h-.12c-.07 0-.15-.01-.22-.02-.73-.07-1.45-.11-2.16-.11h-.19c-.79 0-1.56.03-2.31.1h-.13c-.25.02-.5.05-.75.08-.98.12-1.91.29-2.78.51-.12.03-.25.05-.37.08-.32.08-.54.27-.69.49-.14.21-.2.46-.19.72v.01c0 .07.02.15.04.22.03.16.1.3.19.44.05.08.1.15.17.22.03.02.07.03.11.05.07.05.16.08.25.12.07.04.13.08.21.1.05.01.09.05.14.05.08 0 .17.04.25.05 1.72.17 3.62.49 5.55 1.01s.08 0 .12.02c.07.02.15.06.22.08.87.25 1.73.55 2.59.89.04.01.07.03.11.05.85.35 1.68.75 2.49 1.21h.02c1.67.95 3.21 2.16 4.55 3.68.25.29.5.57.73.88.77 1.01 1.46 2.1 2.02 3.37s0 0 0 .02c.02.05.06.09.08.14.02.05.04.12.06.17.27.67.51 1.43.7 2.24.16.67.29 1.37.36 2.11v.08c.07.69.08 1.41.06 2.15 0 .18-.02.36-.03.54-.03.58-.1 1.17-.2 1.77-.03.19-.06.37-.1.56-.14.7-.33 1.39-.57 2.09l-.06.21c-.59 1.63-1.49 3.24-2.74 4.77-.06.07-.12.14-.18.2-.6.71-1.29 1.4-2.06 2.07-.06.05-.11.09-.16.14-1.71 1.44-3.85 2.74-6.5 3.82-.18.07-.39.14-.58.21h-.02c-1.14.44-2.38.83-3.71 1.19-.4.11-.79.21-1.2.31-1.64.38-3.36.73-5.28.97-2.13.27-4.25.29-6.35.2-.21-.01-.4-.04-.61-.05-2.03-.13-3.98-.43-5.86-.9h-.01c-.21-.05-.43-.1-.64-.16-1.27-.35-2.47-.79-3.63-1.29-.16-.07-.31-.13-.46-.2a22.76 22.76 0 0 1-2.99-1.67c-.2-.13-.38-.28-.57-.41-.88-.64-1.7-1.33-2.43-2.1-.14-.15-.26-.32-.4-.48-.73-.83-1.4-1.69-1.93-2.66-.16-.29-.27-.62-.4-.93-.49-1.07-.89-2.18-1.13-3.4-.26-1.14-.44-2.33-.4-3.64-3.4-.53-6.8-1.21-10.17-2.01-2.93-.68-5.84-1.48-8.74-2.41s0 0 0-.01c.8-1.94 1.34-3.78 1.67-5.55v-.03c.32-1.77.42-3.46.34-5.07-.05-.96-.15-1.89-.32-2.79-.02-.13-.06-.25-.09-.38-.2-.92-.46-1.79-.77-2.64-.02-.04-.03-.09-.05-.13-.06-.17-.13-.33-.19-.5-.3-.73-.63-1.44-1-2.12-.06-.12-.12-.25-.19-.37l-.03-.06c-.45-.79-.95-1.54-1.48-2.25-.11-.14-.22-.28-.33-.41-.03-.04-.06-.07-.09-.11-.41-.51-.83-1.01-1.27-1.48-.02-.03-.05-.05-.08-.08-.18-.19-.36-.39-.55-.57-.43-.43-.87-.83-1.31-1.22-.08-.07-.17-.15-.25-.23l-.3-.27c-.58-.48-1.16-.91-1.75-1.33-.12-.09-.24-.16-.37-.24l-.54-.36c-.32-.21-.64-.41-.96-.59-.03-.01-.05-.03-.08-.04-.24-.14-.47-.27-.71-.4l-.21-.12c-.29-.16-.58-.29-.87-.43-.28-.13-.56-.28-.83-.4-.3-.13-.59-.12-.85-.05-.05.01-.09.04-.13.06-.11.05-.19.14-.28.22-.07.06-.16.09-.21.17-.03.04-.07.08-.09.12-.13.22-.21.47-.19.72.02.14.14.27.21.4.07.13.08.28.2.39.3.27.61.59.92.89.01.01.03.03.05.04.46.45.91.92 1.37 1.42l.02.02c.04.05.09.1.13.15 1.07 1.18 2.09 2.51 2.98 3.96.06.1.13.19.19.3.4.67.75 1.36 1.08 2.08.06.12.14.24.19.37.02.04.02.09.04.13.41.96.72 1.99.97 3.04.03.12.05.24.08.37.28 1.3.46 2.65.42 4.07v.02c-.01.13-.06.23-.08.36-.16 1.66-.47 3.2-.97 4.59-.39 1.12-.98 2.06-1.56 3.01 0 0 0 .02-.01.03-.18.28-.29.62-.48.89-.45.63-.99 1.15-1.52 1.69-.4.41-.8.83-1.24 1.19-.57.47-1.17.88-1.8 1.26-.54.33-1.11.6-1.69.87-.63.28-1.23.58-1.9.8-.53.17-1.11.23-1.66.36-1.15.25-2.31.45-3.53.5h-.02c-1.05.05-2.11.05-3.21-.05-.56-.05-1.11-.14-1.67-.23-.37-.06-.74-.17-1.11-.25-2.33-.47-4.68-1.25-7.02-2.38-.49-.23-.99-.37-1.47-.64-1.3-.71-2.54-1.52-3.74-2.37-.35-.25-.68-.51-1.01-.77-.86-.66-1.68-1.36-2.46-2.08-2.71-2.53-4.86-5.44-6.18-8.58v-.02c-.41-.99-.88-2.67-1.14-3.71l-.04-.16c-.23-1.28-.36-2.58-.28-3.91s0-.02 0-.03c0-.02.01-.04.01-.07 0-.03.02-.07.02-.1.11-1.41.38-2.84.89-4.27.52-1.48 1.26-2.97 2.25-4.46-3.83-3.77-7.44-8.11-10.82-12.78-.67-.91-1.35-1.83-1.99-2.76-.32-.48-.63-.97-.95-1.45-.92-1.4-1.82-2.8-2.67-4.23-1.98-3.27-3.81-6.67-5.53-10.15-.16-.32-.31-.63-.47-.95-1.7-3.51-3.27-7.07-4.67-10.7-.1-.25-.21-.47-.31-.73-1.03-2.52-2.32-6.21-3.47-10.73-.2-.75-.38-1.5-.56-2.26v-.02c-.12-.54-.24-1.1-.35-1.66-2.87-13.2-2.63-26.27.28-38.46 0-.04.02-.08.03-.12a89.26 89.26 0 0 1 1.63-5.87c.05-.16.1-.31.16-.47.73-2.25 1.56-4.46 2.47-6.64s.03-.08.05-.12c1.5-3.55 3.22-6.99 5.18-10.29.02-.04.05-.07.07-.11 1.94-3.25 4.07-6.38 6.43-9.35.1-.13.18-.26.28-.39.54-.68 1.25-1.43 1.85-2.14.58-.67 1.13-1.35 1.73-1.99.92-1.01 1.95-2.02 2.99-3.05.63-.62 1.27-1.24 1.92-1.85 1.04-.96 2.12-1.91 3.27-2.86.24-.2.47-.42.71-.62.45-.37.9-.66 1.35-1.01 1.38-1.08 2.76-2.15 4.26-3.19 2.27-1.58 4.54-3.03 6.78-4.31 1.65-.92 3.34-1.8 5.1-2.62.84-.4 1.67-.76 2.5-1.12h.02s.02-.02.03-.02c.5-.21 1.01-.41 1.51-.62 1.88-.77 3.74-1.44 5.59-2.03s0 0 .01 0c.31-.1.61-.2.92-.29h.01a71.54 71.54 0 0 1 5.39-1.41h.03c1.75-.38 3.47-.7 5.17-.94.07 0 .13-.02.2-.03 1.66-.23 3.3-.41 4.91-.53.1 0 .19-.01.28-.02 1.62-.11 3.21-.17 4.77-.18h.22c2.12 0 4.18.08 6.18.25.25.02.49.03.74.05 2.71.25 5.28.63 7.73 1.1.15.03.3.06.46.09 2.42.48 4.71 1.02 6.84 1.62l.21.06c1.73.49 3.36 1 4.87 1.52.08.02.15.05.23.07 1.34.46 2.62.92 3.77 1.37l.11.04c-27.53-17.76-77.17-11.4-104.28 19.49Z",
                            className: "icon_svg__cls-10",
                            style: {
                                fill: '#141526',
                                strokeWidth: 0
                            }
                        })
                    ]
                })
            })
        ]
    });
var $0e54c6b17377038f$export$2e2bcd8739ae039 = $0e54c6b17377038f$var$SvgIcon;



const $af532f2d7e07bf07$var$SvgFullLogo = (props)=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 1000 300",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "full_logo_svg__linear-gradient",
                        x1: 215.09,
                        x2: 374.06,
                        y1: 61.06,
                        y2: -0.41,
                        gradientTransform: "rotate(-8.86 992.89 1045.428)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#36368b"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.07,
                                stopColor: "#563986"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.17,
                                stopColor: "#7e3d7f"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.27,
                                stopColor: "#a1407a"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.38,
                                stopColor: "#bd4376"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#d24573"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.63,
                                stopColor: "#e24670"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.78,
                                stopColor: "#eb476f"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ee486f"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "full_logo_svg__linear-gradient-2",
                        x1: -236.73,
                        x2: -283.6,
                        y1: 787.35,
                        y2: 666.15,
                        gradientTransform: "rotate(81.14 295.919 673.252)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#6db9e7"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.07,
                                stopColor: "#6ca2d7"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.16,
                                stopColor: "#6b8ac6"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.26,
                                stopColor: "#6b79ba"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.37,
                                stopColor: "#6b6fb3"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#6b6cb1"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#062844"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "full_logo_svg__luminosity-invert",
                        width: 174,
                        height: 176,
                        x: 59,
                        y: 62,
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            result: "cm",
                            values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("style", {
                        children: '.full_logo_svg__cls-7,.full_logo_svg__cls-8{stroke-width:0}.full_logo_svg__cls-10{mix-blend-mode:multiply;opacity:.2}.full_logo_svg__cls-7{fill:#062844}.full_logo_svg__cls-8{fill:#ee486f}'
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "full_logo_svg__mask",
                        width: 174,
                        height: 176,
                        x: 59,
                        y: 62,
                        maskUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                            xlinkHref: "data:image/png;base64,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",
                            width: 174,
                            height: 176,
                            style: {
                                filter: 'url(#full_logo_svg__luminosity-invert)'
                            },
                            transform: "translate(59 62)"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    isolation: 'isolate'
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    id: "full_logo_svg__Layer_1",
                    "data-name": "Layer 1",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M223.24 162.47c-2.78-9.23-10.46-11.21-15.36-10.33-1.66.3-3.14.97-4.27 1.62-.52.3-.24 1.1.36 1.02 3.54-.48 9.78-.38 12.85 5.46 1.08 2.04 5.36 10.97-8.32 18.44-7.29 3.99-15.57 2.86-19.24-2.21-2.12 1.28-4.26 2.58-6.49 3.91-5.74-8.12-13.64-5.05-17.35-2.48-.51.35-.13 1.14.46.98 3.66-.98 9.87-1.63 12.96 3.91 2.68 4.8-.64 11.5-7.02 14.77-6.38 3.27-13.98 3.66-16.23-3.36-2.6.95-5.23 1.81-7.89 2.5-2.15-8.24-8.92-8.99-12.78-7.98-.59.16-.52 1.03.09 1.08 2.79.25 6.73 1.29 8.34 5.07 1.29 3.04 1.07 10-9.87 11.38-6.2.78-12.52-1.91-12.36-7.87-2.82-.43-5.63-1.07-8.41-1.96 3-7.24-2.03-11.87-5.61-13.42-.57-.25-1.07.49-.6.9 1.8 1.62 3.86 4.21 3.77 7.5-.52 6.75-7.54 8.74-13.77 5.34-5.15-2.81-8.76-8.26-5.19-13.57-5.57-5.47-10.22-13.44-12.98-21.64-5.4-16.04 0-32.3 11.74-41.82 14.73-11.94 28.99-8.01 35.67-5.41 1.2.47.99 1.62-.37 1.34-.92-.19-2.05-.26-3.05-.32-2.37-.15-4.87 0-6.92.52-6.91 1.76-12.56 9.82-12.99 20.53.13 9.8 4.98 21.2 14.64 24.62 12.97 4.79 24.03-3.88 34.33-11.6 9.2-7.07 18.83-16.21 31.67-24.54 18.78-12.18 37.81-16.57 37.81-16.57-12.06-21.36-32.99-36.74-57.01-41.72a85.104 85.104 0 0 0-30.42-.75c-5.59.87-10.96 2.28-16.09 4.14 0 0-10.89 3.84-19.78 10.31-1 .73-2.2 1.7-3.43 2.76-1.98 1.69-.56 4.91 2.02 4.58 5.25-.68 12.3-.62 20.5 1.83 15.48 4.64 23.5 15.73 27.35 23.11 2.09 4.01-1.81 5.76-4.05 3.51-7.09-7.11-28.64-20.25-53.96-6.91-16.73 8.81-23.05 24.33-24.13 37.26-1.64 19.6 5.61 36.91 10.54 45.61 12.05 21.26 32.79 36.41 56.71 41.41a85.01 85.01 0 0 0 30.57.78c19.2-2.99 35.89-12.19 48.37-25.22a85.59 85.59 0 0 0 13.4-18.34c4.62-8.51 7.83-17.83 9.34-27.62a.976.976 0 0 0-.88-1.11c-3.77-.31-6.67.56-6.67.56Z",
                            style: {
                                strokeWidth: 0,
                                fill: 'url(#full_logo_svg__linear-gradient)'
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            style: {
                                mask: 'url(#full_logo_svg__mask)'
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M223.24 162.47c-2.78-9.23-10.46-11.21-15.36-10.33-1.66.3-3.14.97-4.27 1.62-.52.3-.24 1.1.36 1.02 3.54-.48 9.78-.38 12.85 5.46 1.08 2.04 5.36 10.97-8.32 18.44-7.29 3.99-15.57 2.86-19.24-2.21-2.12 1.28-4.26 2.58-6.49 3.91-5.74-8.12-13.64-5.05-17.35-2.48-.51.35-.13 1.14.46.98 3.66-.98 9.87-1.63 12.96 3.91 2.68 4.8-.64 11.5-7.02 14.77-6.38 3.27-13.98 3.66-16.23-3.36-2.6.95-5.23 1.81-7.89 2.5-2.15-8.24-8.92-8.99-12.78-7.98-.59.16-.52 1.03.09 1.08 2.79.25 6.73 1.29 8.34 5.07 1.29 3.04 1.07 10-9.87 11.38-6.2.78-12.52-1.91-12.36-7.87-2.82-.43-5.63-1.07-8.41-1.96 3-7.24-2.03-11.87-5.61-13.42-.57-.25-1.07.49-.6.9 1.8 1.62 3.86 4.21 3.77 7.5-.52 6.75-7.54 8.74-13.77 5.34-5.15-2.81-8.76-8.26-5.19-13.57-5.57-5.47-10.22-13.44-12.98-21.64-5.4-16.04 0-32.3 11.74-41.82 14.73-11.94 28.99-8.01 35.67-5.41 1.2.47.99 1.62-.37 1.34-.92-.19-2.05-.26-3.05-.32-2.37-.15-4.87 0-6.92.52-6.91 1.76-12.56 9.82-12.99 20.53.13 9.8 4.98 21.2 14.64 24.62 12.97 4.79 24.03-3.88 34.33-11.6 9.2-7.07 18.83-16.21 31.67-24.54 18.78-12.18 37.81-16.57 37.81-16.57-12.06-21.36-32.99-36.74-57.01-41.72a85.104 85.104 0 0 0-30.42-.75c-5.59.87-10.96 2.28-16.09 4.14 0 0-10.89 3.84-19.78 10.31-1 .73-2.2 1.7-3.43 2.76-1.98 1.69-.56 4.91 2.02 4.58 5.25-.68 12.3-.62 20.5 1.83 15.48 4.64 23.5 15.73 27.35 23.11 2.09 4.01-1.81 5.76-4.05 3.51-7.09-7.11-28.64-20.25-53.96-6.91-16.73 8.81-23.05 24.33-24.13 37.26-1.64 19.6 5.61 36.91 10.54 45.61 12.05 21.26 32.79 36.41 56.71 41.41a85.01 85.01 0 0 0 30.57.78c19.2-2.99 35.89-12.19 48.37-25.22a85.59 85.59 0 0 0 13.4-18.34c4.62-8.51 7.83-17.83 9.34-27.62a.976.976 0 0 0-.88-1.11c-3.77-.31-6.67.56-6.67.56Z",
                                className: "full_logo_svg__cls-10",
                                style: {
                                    fill: '#141728',
                                    strokeWidth: 0
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M160.51 192.18c.59 1.15 2 1.56 2.79 1.71 1.86.34 4.09-.06 6.1-1.09 3.48-1.78 5.25-4.87 4.94-6.83-.04-.27-.12-.51-.24-.75-.59-1.15-2-1.56-2.79-1.71-1.86-.34-4.09.06-6.1 1.09-3.48 1.78-5.24 4.87-4.94 6.84.04.27.12.51.24.74ZM126.19 198.8v.04c.24 1.5 2.97 3.37 6.72 2.88 1.9-.25 3.63-1.07 4.74-2.25.34-.37 1.12-1.32.98-2.33-.23-1.5-2.96-3.37-6.72-2.88-1.9.25-3.63 1.07-4.74 2.25-.34.36-1.12 1.32-.99 2.29ZM95.17 186.12c-.06.09-.22.35-.19.93.07 1.36 1.18 3.38 3.48 4.84 1.54.98 3.28 1.47 4.76 1.33.43-.04 1.46-.19 1.86-.82.05-.09.22-.35.19-.92-.07-1.36-1.18-3.38-3.48-4.84-1.54-.98-3.28-1.47-4.76-1.33-.43.04-1.46.19-1.86.81ZM192.78 171.53c.08.49.23.96.46 1.38 1.76 3.27 7.71 3.76 12.74 1.06 4.93-2.65 7.05-6.95 6.6-9.82-.08-.49-.23-.96-.46-1.39-1.76-3.27-7.71-3.76-12.74-1.06-4.93 2.65-7.05 6.95-6.6 9.82Z",
                            className: "full_logo_svg__cls-8"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M183.06 124.84c-12.84 8.33-22.47 17.46-31.67 24.54-10.3 7.72-21.36 16.38-34.33 11.6-9.66-3.41-14.51-14.82-14.64-24.62.43-10.71 5.48-19 22.96-20.73-7.48-1.49-15.3-.32-20.79 3.35-17.41 11.65-14.56 28.85-9.41 39.08 4.93 9.78 17.15 19.03 32 18.99 10.15-.03 22.55-4.05 41.55-18.47 23.26-17.66 42.16-24.24 59.52-24.57.26 0 .52-.05.78-.03.69.04 1.2-.24.92-1.33-.04-.15-.07-.31-.1-.47a84.457 84.457 0 0 0-9-23.91c-1 .22-19.03 4.39-37.81 16.57Z",
                            style: {
                                fill: 'url(#full_logo_svg__linear-gradient-2)',
                                strokeWidth: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M150.02 140.58c-10.3 7.72-20.51 17.91-33.47 13.12-6.84-2.41-12.07-10.37-14.12-17.39v.05c0 .61.03 1.23.08 1.85.04.62.11 1.25.19 1.88 1.15 8.79 5.92 17.9 14.37 20.89 2.43.9 4.79 1.32 7.1 1.37 9.99.2 18.86-6.69 27.23-12.97 2.71-2.09 5.48-4.37 8.34-6.74 6.84-5.67 14.28-11.93 23.33-17.8 18.41-11.94 36.16-16.19 37.79-16.56v-.05a83.974 83.974 0 0 0-5.02-7.83c-7.2 2.36-22.48 8.08-34.14 15.64-12.84 8.33-22.47 17.46-31.67 24.54Z",
                            style: {
                                fill: '#141526',
                                mixBlendMode: 'multiply',
                                opacity: 0.2,
                                strokeWidth: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M79.41 122.96c-5.87 6.69-13.97 26.77-5.83 46.45 2.09 5.05 4.94 10.71 9.44 15.27-.28 1.66-.3 3.31-.05 4.91 1.35 8.69 9.98 13.22 10.42 13.44 8.51 4.06 14.7 1.5 17.27-.03l4.8 1.45c3.5 10.19 17.66 9.19 18.28 9.14 10.41-.78 14.66-6.24 16.1-8.79l3.36-1.11c9.22 8.53 23.01.51 23.61.15 9.57-5.65 10.88-13.82 10.94-17.47l.81-.47c11.76 7.29 25.28-1.23 25.72-1.52 7.94-4.38 10.73-11.17 11.62-14.29 1.09-.27 2.41-.26 3.52-.17.55-2.28 1.02-4.58 1.38-6.91.09-.55-.33-1.06-.88-1.11-.6-.05-1.18-.06-1.73-.06h-.24c-.22 0-.41.02-.61.03l-.7.03c-.08 0-.15.02-.23.03a21.176 21.176 0 0 0-2.23.32c-.12.03-.26.05-.36.07-.36.08-.57.15-.58.15-.31-1.04-.71-1.96-1.13-2.83-.13-.26-.27-.49-.4-.74-.34-.6-.7-1.16-1.08-1.67-.15-.2-.3-.41-.46-.6-1.14-1.35-2.44-2.39-3.8-3.12a13.41 13.41 0 0 0-6.52-1.56c-.68.01-1.34.08-1.95.19-.68.12-1.3.34-1.91.56-.36.14-.73.28-1.07.44-.45.21-.91.41-1.29.63l-.01.01a.49.49 0 0 0-.23.41v.11c.02.16.09.31.22.4.06.04.15.04.23.05.05 0 .09.04.15.03.43-.06.91-.1 1.4-.13s.05 0 .07 0h.01c.27-.02.56-.01.84-.01h.04c.25 0 .49-.02.76 0h.07c.45.02.91.06 1.38.12.23.03.47.08.7.12.28.05.57.11.85.18.33.08.65.18.97.29.24.08.47.18.7.28s.46.18.69.3c.53.27 1.05.57 1.54.94 1.07.82 2.04 1.92 2.81 3.38.02.03.04.09.06.13.23.44.56 1.14.85 2.03.05.14.09.28.14.43.09.31.17.64.23.98 0 .04.02.07.03.11.06.35.11.71.15 1.09.02.23.02.47.02.71v.02c.01.75-.06 1.54-.24 2.37-.02.11-.04.21-.07.32-.04.18-.09.36-.15.55-.18.6-.45 1.22-.77 1.85 0 0 0 .02-.01.03-.22.42-.47.84-.75 1.26-.08.11-.15.23-.23.34-.28.4-.61.79-.96 1.19-.03.03-.05.06-.08.09-.55.61-1.17 1.23-1.9 1.84l-.06.06c-.73.61-1.56 1.22-2.49 1.82-.5.32-1.05.65-1.61.97 0 0-.01 0-.02.01-.15.08-.27.17-.42.25-.04.02-.07.03-.11.05-.31.17-.64.28-.96.43-.47.22-.93.45-1.4.63-.53.21-1.07.35-1.6.51h-.01c-.29.08-.58.18-.87.25-.41.1-.81.18-1.22.25-.38.06-.75.1-1.12.14-.48.05-.95.1-1.42.11s-.09 0-.13 0c-1.02.01-2.01-.08-2.96-.26s-.07-.02-.11-.02c-.8-.15-1.57-.37-2.3-.65-.73-.28-1.42-.62-2.06-1.02-.06-.04-.12-.08-.17-.12-.5-.32-.98-.66-1.4-1.06-.11-.1-.2-.21-.3-.32-.25-.25-.5-.51-.73-.79-.11-.11-.22-.21-.31-.34-2.12 1.28-4.26 2.58-6.49 3.91s-.06-.08-.09-.12c-.03-.04-.06-.07-.09-.11-.35-.47-.7-.91-1.06-1.3-.17-.19-.34-.35-.51-.52-.27-.26-.53-.51-.8-.74a9.335 9.335 0 0 0-1.38-.98c-.09-.05-.18-.11-.27-.16 0 0-.01 0-.02-.01-.09-.05-.18-.11-.27-.16-.34-.18-.68-.32-1.02-.46-.95-.37-1.91-.58-2.85-.66h-.02c-.72-.05-1.42-.03-2.11.04-.27.03-.54.08-.81.13-.03 0-.06 0-.08.01-.13.02-.27.04-.4.07-.03 0-.07.02-.1.03-.06.01-.11.03-.17.04-.45.11-.9.24-1.32.39-.01 0-.02 0-.03.01a14.268 14.268 0 0 0-1.8.76c-.03.02-.06.03-.1.05l-.06.03c-.7.35-1.33.73-1.88 1.1-.01 0-.02.02-.04.02-.02.01-.04.02-.05.04-.12.08-.19.2-.22.31-.02.07 0 .13.01.19v.1c.03.09.09.17.16.23.06.05.12.09.19.12h.04c.06.01.11.02.17.02.03 0 .06.01.09 0 .39-.1.81-.2 1.25-.29.08-.02.15-.04.23-.05.48-.09.98-.16 1.5-.21.09 0 .17-.02.26-.03h.21c.57-.04 1.15-.06 1.74-.03h.02c.58.03 1.17.09 1.75.21.13.03.25.06.37.1.45.11.9.23 1.34.41.13.05.26.13.39.2.41.19.81.39 1.2.65.19.13.35.3.53.45.33.27.66.53.95.86.43.48.84 1.01 1.19 1.65.28.49.45 1.02.6 1.55.08.27.13.55.18.83.07.42.13.85.13 1.28a7 7 0 0 1-.06.79c-.02.22-.07.58-.11.8-.07.38-.15.76-.27 1.14-.12.37-.25.74-.41 1.11-.17.39-.36.76-.58 1.14-.07.13-.15.25-.22.37-.72 1.19-1.65 2.31-2.79 3.32-.28.24-.55.49-.85.72-.81.63-1.68 1.22-2.64 1.71-.56.29-1.14.54-1.71.78-.02 0-.05.02-.07.03-1.2.49-2.41.87-3.61 1.12-.04 0-.08.02-.13.02-2.33.46-4.57.39-6.45-.42-.06-.03-.13-.06-.19-.09a6.79 6.79 0 0 1-1.05-.6c-.07-.05-.15-.1-.22-.15-.38-.28-.73-.6-1.05-.96-.04-.05-.08-.11-.13-.16a8.602 8.602 0 0 1-.93-1.4c-.24-.47-.47-.96-.65-1.52-2.6.95-5.23 1.81-7.89 2.5s0-.01 0-.02v-.03c-.48-1.82-1.21-3.23-2.06-4.38-.09-.12-.16-.27-.25-.39-.08-.1-.16-.19-.25-.28l-.03-.03c-.2-.23-.4-.44-.61-.64-.14-.13-.28-.24-.42-.36-.17-.14-.34-.28-.52-.41-.15-.11-.3-.21-.45-.3-.18-.11-.37-.22-.55-.32-.07-.04-.14-.07-.21-.11-.08-.04-.16-.08-.23-.12-.22-.1-.45-.19-.68-.28 0 0-.02 0-.03-.01h-.01c-.1-.04-.19-.08-.29-.11-.35-.12-.7-.21-1.05-.29-.03 0-.05 0-.08-.01h-.03c-.34-.07-.67-.12-1-.16H138.91c-.32-.03-.65-.05-.96-.05h-.08c-.35 0-.69.01-1.03.04h-.06c-.11.01-.22.02-.33.04-.43.05-.85.13-1.23.23-.05.01-.11.02-.16.04-.14.04-.24.12-.31.22-.06.09-.09.21-.09.32a.722.722 0 0 0 .11.3c.02.03.04.07.07.1.01.01.03.02.05.02.03.02.07.04.11.05.03.02.06.04.09.04.02 0 .04.02.06.02.03 0 .08.02.11.02.77.07 1.61.22 2.47.45s.03 0 .05 0c.03 0 .06.03.1.04.39.11.77.24 1.15.4.02 0 .03.01.05.02.38.15.75.33 1.11.54.74.42 1.43.96 2.02 1.64.11.13.22.25.33.39.34.45.65.93.9 1.5.01.02.03.04.04.06 0 .02.02.05.03.08.12.3.23.63.31 1 .07.3.13.61.16.94v.03c.03.31.04.63.03.96 0 .08-.01.16-.02.24-.01.26-.04.52-.09.79-.01.08-.03.17-.05.25-.06.31-.15.62-.25.93l-.03.09c-.26.72-.66 1.44-1.22 2.12-.03.03-.05.06-.08.09-.27.32-.57.62-.92.92-.02.02-.05.04-.07.06-.76.64-1.71 1.22-2.89 1.7-.08.03-.17.06-.26.09-.51.2-1.06.37-1.65.53-.18.05-.35.09-.53.14-.73.17-1.49.32-2.35.43-.95.12-1.89.13-2.82.09-.09 0-.18-.02-.27-.02-.9-.06-1.77-.19-2.6-.4-.09-.02-.19-.04-.29-.07-.57-.15-1.1-.35-1.62-.58l-.21-.09c-.47-.22-.91-.47-1.33-.74-.09-.06-.17-.12-.25-.18-.39-.28-.76-.59-1.08-.93l-.18-.21c-.32-.37-.62-.75-.86-1.18-.07-.13-.12-.27-.18-.41-.22-.47-.4-.97-.5-1.51-.12-.51-.19-1.04-.18-1.62-1.51-.23-3.02-.54-4.52-.89-1.3-.3-2.6-.66-3.88-1.07.36-.86.6-1.68.74-2.47v-.02a9.75 9.75 0 0 0 .01-3.49c-.01-.06-.03-.11-.04-.17-.09-.41-.21-.8-.34-1.17 0-.02-.02-.04-.02-.06-.03-.07-.06-.15-.09-.22-.13-.33-.28-.64-.44-.94-.03-.05-.05-.11-.08-.16 0 0 0-.02-.01-.03-.2-.35-.42-.68-.66-1l-.15-.18c-.01-.02-.03-.03-.04-.05-.18-.23-.37-.45-.56-.66a.138.138 0 0 1-.03-.04c-.08-.09-.16-.17-.24-.25-.19-.19-.39-.37-.58-.54-.04-.03-.07-.07-.11-.1-.04-.04-.09-.08-.13-.12-.26-.21-.52-.41-.78-.59-.05-.04-.11-.07-.16-.11-.08-.05-.16-.11-.24-.16-.14-.09-.29-.18-.43-.26-.01 0-.02-.01-.03-.02-.11-.06-.21-.12-.31-.18a.405.405 0 0 0-.09-.05c-.13-.07-.26-.13-.39-.19-.12-.06-.25-.12-.37-.18a.559.559 0 0 0-.38-.02c-.02 0-.04.02-.06.03-.05.02-.08.06-.12.1-.03.03-.07.04-.09.07-.01.02-.03.03-.04.05-.06.1-.09.21-.08.32 0 .06.06.12.09.18s.03.12.09.17c.13.12.27.26.41.4l.02.02c.2.2.41.41.61.63.02.02.04.04.06.07.47.53.93 1.11 1.33 1.76.03.04.06.09.09.13.18.3.34.6.48.92.03.06.06.11.09.16 0 .02.01.04.02.06.18.43.32.88.43 1.35l.03.16c.12.58.2 1.18.19 1.81v.01c0 .06-.03.1-.03.16a8.47 8.47 0 0 1-.43 2.04c-.17.5-.43.92-.69 1.34v.01c-.08.12-.13.28-.22.39-.2.28-.44.51-.68.75-.18.18-.35.37-.55.53-.25.21-.52.39-.8.56-.24.15-.49.27-.75.39-.28.13-.55.26-.84.35-.23.08-.49.1-.74.16-.51.11-1.03.2-1.57.22-.47.02-.94.02-1.43-.02-.25-.02-.49-.06-.74-.1-.16-.03-.33-.08-.49-.11-1.04-.21-2.08-.56-3.12-1.06-.22-.1-.44-.17-.65-.28-.58-.32-1.13-.67-1.66-1.05-.15-.11-.3-.23-.45-.34-.38-.29-.75-.6-1.09-.93-1.2-1.13-2.16-2.42-2.75-3.81-.18-.44-.39-1.19-.5-1.65l-.02-.07c-.1-.57-.16-1.15-.12-1.74s0 0 0-.01v-.08c.05-.63.17-1.26.39-1.9.23-.66.56-1.32 1-1.98-1.7-1.68-3.31-3.6-4.81-5.68-.3-.41-.6-.82-.88-1.23-.14-.21-.28-.43-.42-.65-.41-.62-.81-1.24-1.19-1.88-.88-1.45-1.69-2.97-2.46-4.51l-.21-.42c-.76-1.56-1.45-3.14-2.08-4.76-.05-.11-.09-.21-.14-.32-.46-1.12-1.03-2.76-1.54-4.77-.09-.34-.17-.67-.25-1-.05-.24-.1-.49-.16-.74-1.28-5.87-1.17-11.68.13-17.09 0-.02 0-.04.01-.05.21-.88.45-1.75.72-2.61.02-.07.05-.14.07-.21.33-1 .69-1.98 1.1-2.95s.01-.03.02-.05c.67-1.58 1.43-3.11 2.3-4.57.01-.02.02-.03.03-.05a35.94 35.94 0 0 1 2.86-4.15c.04-.06.08-.11.12-.17.24-.3.55-.63.82-.95.26-.3.5-.6.77-.89.41-.45.87-.9 1.33-1.36a32.886 32.886 0 0 1 2.3-2.09c.11-.09.21-.19.32-.28.2-.16.4-.29.6-.45.61-.48 1.23-.95 1.9-1.42 1.01-.7 2.02-1.35 3.02-1.92.73-.41 1.49-.8 2.27-1.17.37-.18.74-.34 1.11-.5s0 0 .01-.01c.22-.09.45-.18.67-.28.84-.34 1.66-.64 2.49-.9.14-.04.27-.09.41-.13.81-.24 1.61-.45 2.4-.63h.02c.78-.17 1.54-.31 2.3-.42.03 0 .06 0 .09-.01.74-.1 1.46-.18 2.18-.23h.13c.72-.05 1.42-.08 2.12-.08h.09c.94 0 1.86.04 2.75.11.11 0 .22.01.33.02 1.2.11 2.35.28 3.44.49.07.01.14.03.2.04 1.08.21 2.09.45 3.04.72s.06.02.09.03c.77.22 1.49.44 2.16.68l.1.03c.6.21 1.16.41 1.67.61.02 0 .03.01.05.02-12.23-7.89-34.3-5.07-46.34 8.66Z",
                            className: "full_logo_svg__cls-10",
                            style: {
                                fill: '#141526',
                                strokeWidth: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M265.72 141.77v-3.21c0-30.43 19.95-51.98 50.08-51.98 26.06 0 43.39 16.45 45.13 40.91h-21.84c-1.6-14.27-10.19-22.86-23.59-22.86-17.47 0-27.37 13.68-27.37 33.92v3.21c0 20.24 10.04 33.77 27.37 33.77 13.98 0 22.71-9.46 23.44-23.88h21.84c-1.6 24.61-18.34 42.08-45.13 42.08-30.58 0-49.94-21.4-49.94-51.98ZM372.73 155.16v-1.9c0-22.85 15-38.43 38.73-38.43 25.62 0 38.29 18.05 36.98 44.26h-54.89c1.02 12.81 6.99 19.07 17.91 19.07 9.17 0 14.41-4.37 16.31-10.19h20.24c-3.64 15.87-16.89 25.77-36.54 25.77-24.17 0-38.73-15.43-38.73-38.58Zm54.89-9.46c-.87-9.47-6.12-15.29-16.31-15.29s-15.73 4.94-17.47 15.29h33.78ZM630.34 170.89c0-12.81 8.15-20.38 21.83-22.28l27.66-3.93v-4.37c0-6.25-4.07-10.04-12.96-10.04-8.3 0-13.53 3.21-14.27 9.61h-19.21c1.16-16.01 14.41-25.04 33.92-25.04s32.17 10.04 32.17 25.77v51.25H680.7l-.73-11.5c-4.52 8.15-13.25 13.39-24.31 13.39-15.15 0-25.33-9.61-25.33-22.86Zm49.5-6.55v-5.97l-20.38 2.76c-6.26.88-9.46 3.49-9.46 8.73s4.37 8.59 11.79 8.59c9.9 0 18.05-5.83 18.05-14.12ZM833.5 155.16v-1.9c0-22.85 15-38.43 38.73-38.43 25.62 0 38.29 18.05 36.98 44.26h-54.89c1.02 12.81 6.99 19.07 17.91 19.07 9.18 0 14.41-4.37 16.31-10.19h20.24c-3.64 15.87-16.89 25.77-36.55 25.77-24.16 0-38.73-15.43-38.73-38.58Zm54.89-9.46c-.88-9.47-6.12-15.29-16.31-15.29s-15.73 4.94-17.48 15.29h33.78ZM504.98 114.83c-12.23 0-20.67 6.7-24.17 13.39l-.58-11.51h-19.07v99.34s20.49-.84 20.53-20.48v-14.35c4.08 6.99 12.23 12.52 22.86 12.52 20.24 0 32.61-16.31 32.61-38.58v-1.9c0-22.13-12.09-38.43-32.18-38.43Zm11.5 40.33c0 14.7-6.12 22.86-17.76 22.86s-17.76-8.16-17.76-22.86v-1.9c0-14.7 6.26-22.85 17.76-22.85s17.76 8.15 17.76 22.85v1.9ZM593.2 114.83c-11.94 0-19.56 6.11-23.5 12.81v-24.08c0-18.74-20.46-19.62-20.46-19.62v107.91h20.37v-41.64c0-11.94 6.41-18.93 15.87-18.93s13.54 6.4 13.54 17.33v43.24h20.24v-48.34c0-16.89-7.43-28.68-26.06-28.68ZM757.42 114.83c-11.06 0-18.93 5.24-23.44 11.94v-22.3h.01c0-19.69-20.53-20.53-20.53-20.53v107.91h19.06l.58-11.79c3.35 6.7 11.36 13.68 23.74 13.68 20.09 0 32.61-16.16 32.61-38.58v-1.9c0-22.13-12.09-38.43-32.04-38.43Zm11.36 40.33c0 14.7-6.11 22.86-17.76 22.86s-17.76-8.16-17.76-22.86v-1.9c0-14.7 6.25-22.85 17.76-22.85s17.76 8.15 17.76 22.85v1.9ZM821.91 103.89c0-18.95-20.38-19.95-20.38-19.95v107.91h20.38v-87.96ZM915.9 193.68v-10.36h-3.55v-2.48h10.13v2.48h-3.53v10.36h-3.05ZM924.26 193.68v-12.84h4.34l2.82 8.97 2.84-8.97h4.11v12.84h-2.88v-9.3l-2.95 9.3h-2.37l-2.98-9.33v9.33h-2.93Z",
                            className: "full_logo_svg__cls-7"
                        })
                    ]
                })
            })
        ]
    });
};
var $af532f2d7e07bf07$export$2e2bcd8739ae039 = $af532f2d7e07bf07$var$SvgFullLogo;



const $5e08dea7b0296858$var$SvgProductEduLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 1200,
        height: 627,
        viewBox: "0 0 900 470.25",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "eduLogoTransparent_svg__a",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "eduLogoTransparent_svg__b",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "eduLogoTransparent_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M.715 89H899.28v291.77H.715Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "eduLogoTransparent_svg__d",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            filter: "url(#eduLogoTransparent_svg__a)",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                filter: "url(#eduLogoTransparent_svg__b)",
                                transform: "matrix(.97345 0 0 .97345 -48.056 88.733)",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                    xlinkHref: "data:image/png;base64,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",
                                    width: 1000,
                                    height: 300
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#eduLogoTransparent_svg__c)",
                mask: "url(#eduLogoTransparent_svg__d)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                    xlinkHref: "data:image/png;base64,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",
                    width: 1000,
                    height: 300,
                    transform: "matrix(.97345 0 0 .97345 -48.056 88.733)"
                })
            })
        ]
    });
var $5e08dea7b0296858$export$2e2bcd8739ae039 = $5e08dea7b0296858$var$SvgProductEduLogo;



const $89f8912dfe9250e1$var$SvgProductPersonalLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 1200,
        height: 627,
        viewBox: "0 0 900 470.25",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "personalLogoTransparent_svg__a",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "personalLogoTransparent_svg__b",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "personalLogoTransparent_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M.715 88.734H899.28V380.77H.715Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "personalLogoTransparent_svg__d",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            filter: "url(#personalLogoTransparent_svg__a)",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                filter: "url(#personalLogoTransparent_svg__b)",
                                transform: "matrix(.97644 0 0 .97594 -38.322 87.774)",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                    xlinkHref: "data:image/png;base64,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",
                                    width: 1000,
                                    height: 300
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#personalLogoTransparent_svg__c)",
                mask: "url(#personalLogoTransparent_svg__d)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                    xlinkHref: "data:image/png;base64,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",
                    width: 1000,
                    height: 300,
                    transform: "matrix(.97644 0 0 .97594 -38.322 87.774)"
                })
            })
        ]
    });
var $89f8912dfe9250e1$export$2e2bcd8739ae039 = $89f8912dfe9250e1$var$SvgProductPersonalLogo;



const $abd4a3f412a40f06$var$SvgProductPlusLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 1200,
        height: 627,
        viewBox: "0 0 112.5 37.5",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "ceph_logo_plus_svg_svg__a",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M23.945 2h87.567v33.559H23.945Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "ceph_logo_plus_svg_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M.492 6H26v25H.492Zm0 0"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#ceph_logo_plus_svg_svg__a)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    mask: "url(#ceph_logo_plus_svg_svg__b)",
                    transform: "matrix(.18873 0 0 .18915 -.627 1.514)",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                            xlinkHref: "data:image/png;base64,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",
                            width: 600,
                            height: 180
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                            id: "ceph_logo_plus_svg_svg__b",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                xlinkHref: "data:image/png;base64,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",
                                width: 600,
                                height: 180
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#ceph_logo_plus_svg_svg__c)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    mask: "url(#ceph_logo_plus_svg_svg__d)",
                    transform: "matrix(.12952 0 0 .12952 .493 5.57)",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                            xlinkHref: "data:image/png;base64,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",
                            width: 200,
                            height: 200
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                            id: "ceph_logo_plus_svg_svg__d",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                xlinkHref: "data:image/png;base64,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",
                                width: 200,
                                height: 200
                            })
                        })
                    ]
                })
            })
        ]
    });
var $abd4a3f412a40f06$export$2e2bcd8739ae039 = $abd4a3f412a40f06$var$SvgProductPlusLogo;



const $444a29ef95e42a89$var$SvgProductProLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 1200,
        height: 627,
        viewBox: "0 0 900 470.25",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "proLogoTransparent_svg__a",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "proLogoTransparent_svg__b",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "proLogoTransparent_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M13.668 119.082h885.613v259.086H13.668Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "proLogoTransparent_svg__d",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            filter: "url(#proLogoTransparent_svg__a)",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                filter: "url(#proLogoTransparent_svg__b)",
                                transform: "matrix(.98767 0 0 .98842 -45.894 86.29)",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                    xlinkHref: "data:image/png;base64,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",
                                    width: 1000,
                                    height: 300
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#proLogoTransparent_svg__c)",
                mask: "url(#proLogoTransparent_svg__d)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                    xlinkHref: "data:image/png;base64,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",
                    width: 1000,
                    height: 300,
                    transform: "matrix(.98767 0 0 .98842 -45.894 86.29)"
                })
            })
        ]
    });
var $444a29ef95e42a89$export$2e2bcd8739ae039 = $444a29ef95e42a89$var$SvgProductProLogo;



const $581166daca419b3f$var$SvgProductSdkLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 1200,
        height: 627,
        viewBox: "0 0 900 470.25",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "sdkLogo_svg__a",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "sdkLogo_svg__b",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "sdkLogo_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M.715 89H899.28v291.762H.715Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "sdkLogo_svg__d",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            filter: "url(#sdkLogo_svg__a)",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                filter: "url(#sdkLogo_svg__b)",
                                transform: "matrix(.97345 0 0 .97345 -36.738 88.73)",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                    xlinkHref: "data:image/png;base64,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",
                                    width: 1000,
                                    height: 300
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#sdkLogo_svg__c)",
                mask: "url(#sdkLogo_svg__d)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                    xlinkHref: "data:image/png;base64,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",
                    width: 1000,
                    height: 300,
                    transform: "matrix(.97345 0 0 .97345 -36.738 88.73)"
                })
            })
        ]
    });
var $581166daca419b3f$export$2e2bcd8739ae039 = $581166daca419b3f$var$SvgProductSdkLogo;



parcelRequire("7fPBF");
// Todo: Add variants for different styles found in images/icons
const $7de7807cf4d66fcd$var$SvgCephy = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 500 500",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient",
                        x1: 4.82,
                        x2: 282.2,
                        y1: 407.51,
                        y2: 247.37,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#062844"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.34,
                                stopColor: "#693b82"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.68,
                                stopColor: "#a3417a"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ed486f"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("filter", {
                        id: "drop-shadow-5",
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feOffset", {
                                dy: 10
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feGaussianBlur", {
                                result: "blur",
                                stdDeviation: 16
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feFlood", {
                                floodColor: "#ed486f",
                                floodOpacity: 0.75
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feComposite", {
                                in2: "blur",
                                operator: "in"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feComposite", {
                                in: "SourceGraphic"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("style", {
                        children: '.cls-4{fill:#fff}.cls-5{fill:#141526;mix-blend-mode:multiply;opacity:.2}'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    fill: 'none',
                    isolation: 'isolate'
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    id: "Layer_1",
                    style: {
                        filter: 'url(#drop-shadow-5)',
                        fill: 'none'
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M319.91 419.59c-14.31 0-33.03-10.47-50.06-28.01-10.08-10.37-15.94-19.86-19.85-26.31-3.91 6.45-9.77 15.93-19.85 26.31-17.04 17.54-35.75 28.01-50.07 28.01-10.87 0-19.47-6.08-22.45-15.87-2.5-8.23.52-14.87 5.39-20.64-9.53 2.81-20.54 4.62-33.22 4.62h-.86c-16.93-.11-27.35-3.21-33.78-10.04-4.19-4.45-6.23-10.1-5.89-16.36.73-13.84 12.67-18.78 23.19-21.01-16.35-6.01-30.87-17.39-43.37-34.03-9.09-13.12-8.6-22.74-6.64-28.56 2.21-6.59 7.37-11.68 14.17-14.02 2.08-.76 4.28-1.15 6.53-1.15 1.2 0 2.36.1 3.49.3-1.1-2.94-1.81-5.9-2.08-8.87-.76-8.09 1.79-15.76 6.99-21.02 3.83-3.9 9.45-6.14 15.39-6.14 8.19 0 15.5 4.12 20.04 11.31 9.9 15.68 21.42 18.93 30.67 21.54 3.67 1.04 8.05 2.28 11.76 4.7-.47-11.87-4.6-31.51-12.68-65.74-5.53-23.44-1.94-58.75 18.57-84.79 11.92-15.14 34.44-33.22 73.96-33.41h.72c39.85 0 62.55 18.1 74.57 33.28 20.61 26.04 24.24 61.41 18.69 84.91-8.09 34.23-12.22 53.88-12.68 65.74 3.71-2.42 8.09-3.66 11.76-4.7 9.26-2.61 20.78-5.87 30.67-21.54 4.54-7.19 11.85-11.31 20.04-11.31 5.94 0 11.56 2.24 15.4 6.15 5.18 5.26 7.73 12.92 6.97 21.01-.28 2.97-.98 5.93-2.08 8.87 1.13-.19 2.3-.3 3.5-.3 2.25 0 4.45.39 6.53 1.15 6.8 2.34 11.95 7.43 14.17 14.02 1.96 5.83 2.46 15.44-6.32 28.13-12.71 16.93-27.32 28.41-43.71 34.46 10.52 2.23 22.47 7.17 23.22 21.02.34 6.25-1.7 11.91-5.89 16.36-6.43 6.83-16.85 9.93-33.78 10.04h-.86c-12.68 0-23.69-1.8-33.23-4.62 4.88 5.77 7.9 12.41 5.4 20.64-2.98 9.79-11.58 15.87-22.45 15.87Z",
                            className: "cls-4"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M418.78 276.51c-6.93-2.73-17.21 10.65-33.08 18.9-14.71 7.66-29.99 8.79-45.62 2.87-31.31-11.86-26.87-31.73-10.09-102.8 8.53-36.13-8.4-101.46-80.01-101.46h-.65c-71.05.33-87.86 65.44-79.35 101.46 16.78 71.07 21.22 90.94-10.09 102.8-15.63 5.92-30.91 4.79-45.62-2.87-15.87-8.26-26.15-21.63-33.08-18.9-5.81 1.91-10.15 8.67-1.22 21.58 40.62 54.06 88.48 24.86 91.4 32.18 2.32 5.34-26.67 19.11-47.86 22-12.03 1.64-20.33 3.68-20.66 9.77-.49 9.16 10.82 11.95 26.16 12.05 56.47.36 74.38-38.5 81.13-34.58 4.07 1.98 2.26 7.41-3.32 16.82-14.47 24.39-39.17 33.63-36.18 43.44 3.91 12.84 27.49 5.22 49.73-17.67 19.49-20.06 20.91-35.61 29.61-35.61s10.12 15.55 29.61 35.61c22.24 22.89 45.82 30.51 49.73 17.67 2.98-9.81-21.72-19.06-36.18-43.44-5.59-9.41-7.4-14.83-3.32-16.82 6.76-3.92 24.67 34.94 81.13 34.58 15.34-.1 26.65-2.88 26.16-12.05-.33-6.1-8.62-8.13-20.66-9.77-21.19-2.89-50.18-16.66-47.86-22 2.93-7.32 50.78 21.89 91.4-32.18 8.93-12.91 4.59-19.67-1.22-21.58Zm-135.01-7.34c-6.04 11-18.83 18.63-33.78 18.63s-27.74-7.63-33.78-18.63c-1.27-2.32.61-5.03 3.57-5.03 0 0 14.59 6.53 30.22 6.53s30.22-6.53 30.22-6.53c2.95 0 4.84 2.71 3.57 5.03Zm52.51 8.89c1.89-7.85 28.72-1.81 48.22-32.68 4.15-6.57 11.54-5.61 14.23-2.88 5.97 6.05 5.08 21.17-15.85 35.65-14.63 10.88-32.21 12.18-41.32 7.91-6.93-3.22-5.27-8-5.27-8Zm-172.59 0c-1.89-7.85-28.72-1.81-48.22-32.68-4.15-6.57-11.54-5.61-14.23-2.88-5.97 6.05-5.08 21.17 15.85 35.65 14.63 10.88 32.21 12.18 41.32 7.91 6.93-3.22 5.27-8 5.27-8Z",
                            style: {
                                fill: 'url(#linear-gradient)'
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M110.52 306.85c15.19 8.49 40.3 10.26 56.26 5.29 32.75-10.19 46.72-36.6 29.87-113.5-10.6-48.37 8.19-100.6 78.54-101.43-7.53-2-15.89-3.13-25.2-3.13h-.65c-71.05.33-87.86 65.44-79.35 101.46 16.78 71.07 21.22 90.94-10.09 102.8-15.63 5.92-30.91 4.79-45.62-2.87-15.87-8.26-26.15-21.63-33.08-18.9-1.39.46-2.68 1.2-3.74 2.22 7.07 7.46 17.66 19.46 33.06 28.07Z",
                            className: "cls-5"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M306.48 192.79c3.47-31.52-15.82-60.49-47.29-66.62-4.67-1-7.76-5.72-6.21-10.36 4.14-10.64 15.94-2.43 22.86.5 19.91 9.82 34.44 29.94 36.69 52.02.98 8.55.78 16.95-.97 25.44-.29 1.4-1.66 2.3-3.06 2.02-1.4-.28-2.26-1.63-2.04-2.99Z",
                            className: "cls-5"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M210.76 240.42c-7.64 0-13.83-7.71-13.83-17.22 0-9.51 6.19-17.22 13.83-17.22 4.95 0 9.26 3.26 11.7 8.12-1.52-1.41-3.38-2.27-5.42-2.27-5.04 0-9.13 5.09-9.13 11.36s4.09 11.36 9.13 11.36c2.04 0 3.9-.86 5.42-2.27-2.44 4.86-6.75 8.12-11.7 8.12ZM291.76 240.42c-7.64 0-13.83-7.71-13.83-17.22s6.19-17.22 13.83-17.22c4.68 0 8.79 2.91 11.3 7.33-1.31-.91-2.8-1.48-4.41-1.48-5.04 0-9.13 5.09-9.13 11.36s4.09 11.36 9.13 11.36c1.61 0 3.1-.56 4.41-1.48-2.5 4.42-6.62 7.33-11.3 7.33Z",
                            className: "cls-4"
                        })
                    ]
                })
            })
        ]
    });
var $7de7807cf4d66fcd$export$2e2bcd8739ae039 = $7de7807cf4d66fcd$var$SvgCephy;



const $41158ab2c4dff680$var$SvgComponent = (props)=>{
    const color = props.color || 'currentColor';
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        id: "Layer_1",
        x: 0,
        y: 0,
        viewBox: "0 0 1000 300",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("style", {
                children: `.st0{fill:${color}}`
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M265.7 141.8v-3.2c0-30.4 20-52 50.1-52 26.1 0 43.4 16.4 45.1 40.9h-21.8c-1.6-14.3-10.2-22.9-23.6-22.9-17.5 0-27.4 13.7-27.4 33.9v3.2c0 20.2 10 33.8 27.4 33.8 14 0 22.7-9.5 23.4-23.9h21.8c-1.6 24.6-18.3 42.1-45.1 42.1-30.5 0-49.9-21.4-49.9-51.9zM372.7 155.2v-1.9c0-22.9 15-38.4 38.7-38.4 25.6 0 38.3 18 37 44.3h-54.9c1 12.8 7 19.1 17.9 19.1 9.2 0 14.4-4.4 16.3-10.2H448c-3.6 15.9-16.9 25.8-36.5 25.8-24.2-.2-38.8-15.6-38.8-38.7zm54.9-9.5c-.9-9.5-6.1-15.3-16.3-15.3s-15.7 4.9-17.5 15.3h33.8zM630.3 170.9c0-12.8 8.2-20.4 21.8-22.3l27.7-3.9v-4.4c0-6.2-4.1-10-13-10-8.3 0-13.5 3.2-14.3 9.6h-19.2c1.2-16 14.4-25 33.9-25s32.2 10 32.2 25.8v51.2h-18.8l-.7-11.5c-4.5 8.1-13.2 13.4-24.3 13.4-15.1 0-25.3-9.7-25.3-22.9zm49.5-6.6v-6l-20.4 2.8c-6.3.9-9.5 3.5-9.5 8.7s4.4 8.6 11.8 8.6c10 0 18.1-5.8 18.1-14.1zM833.5 155.2v-1.9c0-22.9 15-38.4 38.7-38.4 25.6 0 38.3 18 37 44.3h-54.9c1 12.8 7 19.1 17.9 19.1 9.2 0 14.4-4.4 16.3-10.2h20.2c-3.6 15.9-16.9 25.8-36.5 25.8-24.1-.2-38.7-15.6-38.7-38.7zm54.9-9.5c-.9-9.5-6.1-15.3-16.3-15.3s-15.7 4.9-17.5 15.3h33.8zM505 114.8c-12.2 0-20.7 6.7-24.2 13.4l-.6-11.5h-19.1V216s20.5-.8 20.5-20.5v-14.4c4.1 7 12.2 12.5 22.9 12.5 20.2 0 32.6-16.3 32.6-38.6v-1.9c.1-22-12-38.3-32.1-38.3zm11.5 40.4c0 14.7-6.1 22.9-17.8 22.9s-17.8-8.2-17.8-22.9v-1.9c0-14.7 6.3-22.9 17.8-22.9s17.8 8.1 17.8 22.9v1.9zM593.2 114.8c-11.9 0-19.6 6.1-23.5 12.8v-24.1c0-18.7-20.5-19.6-20.5-19.6v107.9h20.4v-41.6c0-11.9 6.4-18.9 15.9-18.9s13.5 6.4 13.5 17.3v43.2h20.2v-48.3c.1-16.9-7.4-28.7-26-28.7zM757.4 114.8c-11.1 0-18.9 5.2-23.4 11.9v-22.3c0-19.7-20.5-20.5-20.5-20.5v107.9h19.1l.6-11.8c3.3 6.7 11.4 13.7 23.7 13.7 20.1 0 32.6-16.2 32.6-38.6v-1.9c-.1-22.1-12.1-38.4-32.1-38.4zm11.4 40.4c0 14.7-6.1 22.9-17.8 22.9s-17.8-8.2-17.8-22.9v-1.9c0-14.7 6.2-22.9 17.8-22.9s17.8 8.1 17.8 22.9v1.9zM821.9 103.9c0-18.9-20.4-19.9-20.4-19.9v107.9h20.4v-88zM915.9 193.7v-10.4h-3.5v-2.5h10.1v2.5H919v10.4h-3.1zM924.3 193.7v-12.8h4.3l2.8 9 2.8-9h4.1v12.8h-2.9v-9.3l-3 9.3H930l-3-9.3v9.3h-2.7zM199.4 161.7c5-2.7 11-2.2 12.7 1.1.2.4.4.9.5 1.4.4 2.9-1.7 7.2-6.6 9.8-5 2.7-11 2.2-12.7-1.1-.2-.4-.4-.9-.5-1.4-.5-2.8 1.6-7.1 6.6-9.8zm-38.9 30.5c.6 1.1 2 1.6 2.8 1.7 1.9.3 4.1-.1 6.1-1.1 3.5-1.8 5.2-4.9 4.9-6.8 0-.3-.1-.5-.2-.8-.6-1.1-2-1.6-2.8-1.7-1.9-.3-4.1.1-6.1 1.1-3.5 1.8-5.2 4.9-4.9 6.8 0 .3.1.5.2.8zm69.4-30.3c-.7-.1-1.3-.1-1.9-.1-.4 0-.9 0-1.3.1-.4 0-.8.1-1.1.1h-.1c-1.4.2-2.2.4-2.2.4-1.4-4.6-4-7.4-6.8-8.9-1.4-.8-2.9-1.2-4.4-1.4-.7-.1-1.4-.1-2.1-.1s-1.3.1-1.9.2c-1.6.3-3.1 1-4.2 1.6-.5.3-.2 1.1.4 1 .4-.1.8-.1 1.3-.1H207.5c.4 0 .9.1 1.4.1.2 0 .5.1.7.1.3.1.6.1.9.2.3.1.6.2 1 .3.2.1.5.2.7.3.2.1.5.2.7.3.3.1.6.3.8.5 1.4.9 2.6 2.1 3.5 3.9v.1c.2.4.6 1.1.9 2 .1.1.1.3.1.4.1.3.2.6.2 1v.2c.1.3.1.7.1 1.1v.7c0 .8-.1 1.5-.2 2.4 0 .1 0 .2-.1.3 0 .2-.1.4-.1.6-.2.6-.4 1.2-.8 1.9-.2.4-.5.8-.8 1.3-.1.1-.1.2-.2.3-.3.4-.6.8-1 1.2l-.1.1c-.6.6-1.2 1.2-1.9 1.8l-.1.1c-.7.6-1.6 1.2-2.5 1.8-.5.3-1.1.6-1.6 1-.1.1-.3.2-.4.2 0 0-.1 0-.1.1-.3.2-.6.3-1 .4-.5.2-.9.4-1.4.6-.5.2-1.1.4-1.6.5-.3.1-.6.2-.9.2-.4.1-.8.2-1.2.2-.4.1-.8.1-1.1.1-.5.1-.9.1-1.4.1h-.1c-1 0-2-.1-3-.3h-.1c-.8-.1-1.6-.4-2.3-.6-.7-.3-1.4-.6-2.1-1-.1 0-.1-.1-.2-.1-.5-.3-1-.7-1.4-1.1l-.3-.3c-.2-.2-.5-.5-.7-.8l-.3-.3c-.9.6-1.9 1.2-2.9 1.8-1.2.7-2.4 1.4-3.6 2.2-5.7-8.1-13.6-5.1-17.3-2.5-.5.4-.1 1.1.5 1 .5-.1 1.1-.3 1.7-.4.4-.1.8-.1 1.3-.2h.5c.6 0 1.1-.1 1.7 0 .6 0 1.2.1 1.8.2.1 0 .2.1.4.1.4.1.9.2 1.3.4.1.1.3.1.4.2l1.2.6c.2.1.4.3.5.4.3.3.7.5.9.9s.6.7.8 1.1c.1.2.2.4.4.6 0 .1.1.1.1.2.2.4.4.9.5 1.3.1.3.1.6.2.8.1.4.1.9.1 1.3 0 .3 0 .5-.1.8 0 .2-.1.6-.1.8-.1.4-.1.8-.3 1.1-.1.4-.2.7-.4 1.1-.2.4-.4.8-.6 1.1-.1.1-.1.2-.2.4-.7 1.2-1.6 2.3-2.8 3.3-.3.2-.6.5-.9.7-.8.6-1.7 1.2-2.6 1.7-.6.3-1.1.5-1.7.8h-.1c-1.2.5-2.4.9-3.6 1.1h-.1c-.9.2-1.7.3-2.5.3h-.9c-.7-.1-1.5-.2-2.1-.4-.1 0-.1 0-.2-.1-.2-.1-.4-.1-.6-.2-.1 0-.1-.1-.2-.1-.4-.2-.7-.4-1.1-.6-.1-.1-.1-.1-.2-.1-.1-.1-.3-.2-.4-.3l-.3-.3-.3-.3-.1-.1-.1-.1c-.3-.3-.5-.7-.8-1.1 0-.1-.1-.1-.1-.1 0-.1-.1-.1-.1-.2l-.3-.6c-.1-.3-.3-.6-.4-.9-2.6.9-5.2 1.8-7.9 2.5-.6-2.2-1.5-3.9-2.6-5.1-.2-.2-.4-.4-.6-.7-.1-.1-.1-.1-.2-.1-.6-.5-1.2-1-1.9-1.3 0 0-.1 0-.1-.1h-.1c-.3-.1-.5-.2-.8-.4-.4-.2-.9-.3-1.4-.4h-.1c-.3-.1-.7-.1-1-.2-.4 0-.7-.1-1.1-.1-.5 0-1 0-1.5.1s-.9.1-1.4.3c-.1 0-.2.1-.3.2-.2.3-.1.8.4.9h.1c.8.1 1.6.2 2.5.4h.2c.4.1.8.2 1.1.4h.1c.4.1.8.3 1.1.5.7.4 1.4 1 2 1.6.1.1.2.2.3.4.3.4.6.9.9 1.5.1.3.2.6.3 1 .1.3.1.6.2.9v1.2c0 .3 0 .5-.1.8 0 .1 0 .2-.1.2-.1.3-.1.6-.2.9v.1c-.3.7-.7 1.4-1.2 2.1l-.1.1-.9.9s-.1 0-.1.1c-.8.6-1.7 1.2-2.9 1.7-.1 0-.2.1-.3.1-.5.2-1.1.4-1.6.5-.2.1-.4.1-.5.1-.7.2-1.5.3-2.4.4-.9.1-1.9.1-2.8.1h-.3c-.9-.1-1.8-.2-2.6-.4-.1 0-.2 0-.3-.1-.6-.1-1.1-.4-1.6-.6-.1 0-.1-.1-.2-.1-.5-.2-.9-.5-1.3-.7-.1-.1-.2-.1-.2-.2-.4-.3-.8-.6-1.1-.9l-.2-.2-.9-1.2c-.1-.1-.1-.3-.2-.4-.2-.5-.4-1-.5-1.5-.1-.5-.2-1-.2-1.6-1.5-.2-3-.5-4.5-.9-1.2-.3-2.4-.6-3.5-1-.1 0-.2-.1-.3-.1.7-1.7 1-3.3.9-4.7 0-.4-.1-.8-.1-1.2v-.2l-.3-1.2v-.1c0-.1-.1-.1-.1-.2-.1-.3-.3-.6-.4-.9 0-.1-.1-.1-.1-.2-.2-.4-.5-.8-.8-1.1l-.1-.1v-.1l-.6-.6-.2-.2c-.8-.8-1.6-1.4-2.4-1.9l-1.2-.6c-.6-.2-1.1.5-.6.9l.4.4.6.6s0 .1.1.1c.2.3.5.5.7.8l.6.9.1.1c.2.3.3.6.5.9.1.3.3.6.4.9.1.2.1.4.2.6v.2c.1.3.1.6.1.8 0 .3.1.6.1 1v.2c-.1.7-.2 1.4-.4 2-.2.5-.4.9-.7 1.3-.1.1-.1.3-.2.4-.2.3-.4.5-.7.8-.2.2-.3.4-.6.5-.2.2-.5.4-.8.6-.2.1-.5.3-.8.4-.3.1-.6.3-.8.4-.2.1-.5.1-.7.2-.5.1-1 .2-1.6.2H102c-.2 0-.5-.1-.7-.1-.2 0-.3-.1-.5-.1-1-.2-2.1-.6-3.1-1.1-.2-.1-.4-.2-.7-.3-.6-.3-1.1-.7-1.7-1.1-.2-.1-.3-.2-.4-.3-.4-.3-.8-.6-1.1-.9-1.2-1.1-2.2-2.4-2.8-3.8-.2-.4-.4-1.2-.5-1.6v-.1c-.1-.6-.2-1.1-.1-1.7v-.1c.1-.6.2-1.3.4-1.9.1-.2.2-.4.2-.5.2-.5.4-1 .8-1.4-.4-.4-.8-.8-1.2-1.3v-.1c-1.2-1.3-2.4-2.8-3.5-4.4l-.9-1.2c-.1-.2-.3-.4-.4-.6-.4-.6-.8-1.2-1.2-1.9-.9-1.4-1.7-3-2.5-4.5-.1-.1-.1-.3-.2-.4-.8-1.6-1.4-3.1-2.1-4.8 0-.1-.1-.1-.1-.2-.3-.8-.6-1.5-.8-2.3-.1-.4-.3-.9-.4-1.3-.1-.4-.2-.9-.4-1.3-.1-.3-.2-.7-.2-1-.1-.2-.1-.5-.2-.7-1.3-5.9-1.2-11.7.1-17.1v-.1c.2-.9.4-1.8.7-2.6 0-.1.1-.1.1-.2.3-1 .7-2 1.1-2.9v-.1c.7-1.6 1.4-3.1 2.3-4.6v-.1c.9-1.4 1.8-2.8 2.9-4.2 0 0 0-.1.1-.1.1-.1.2-.2.2-.3.2-.2.4-.5.7-.8.3-.3.5-.6.8-.9.4-.4.9-.9 1.3-1.4l.8-.8c.5-.4.9-.8 1.4-1.3l.3-.3c.2-.2.4-.3.6-.4.6-.5 1.2-.9 1.9-1.4 1-.7 2-1.3 3-1.9.7-.4 1.5-.8 2.3-1.2.4-.2.7-.3 1.1-.5.2-.1.4-.2.7-.3.8-.3 1.7-.6 2.5-.9.1 0 .3-.1.4-.1l2.4-.6c.8-.2 1.5-.3 2.3-.4h.1c.7-.1 1.5-.2 2.2-.2h.1c.7-.1 1.4-.1 2.1-.1h.1c.9 0 1.9 0 2.8.1h.3c1.2.1 2.3.3 3.4.5h.2c1.1.2 2.1.4 3 .7h.1c.8.2 1.5.4 2.2.7h.1c.6.2 1.2.4 1.7.6 1.2.5 1 1.6-.4 1.3-7.5-1.5-15.3-.3-20.8 3.3-17.4 11.7-14.6 28.8-9.4 39.1 4.9 9.8 17.2 19 32 19 10.1 0 22.6-4.1 41.6-18.5 23.3-17.7 42.2-24.2 59.5-24.6.3 0 .5-.1.8 0 .7 0 1.2-.2.9-1.3 0-.1-.1-.3-.1-.5-1.8-8.6-4.9-16.6-9-23.9-1.6.4-19.4 4.6-37.8 16.6-9.1 5.9-16.5 12.1-23.3 17.8-2.9 2.4-5.6 4.6-8.3 6.7-8.4 6.3-17.2 13.2-27.2 13-2.3-.1-4.7-.5-7.1-1.4-8.4-3-13.2-12.1-14.4-20.9-.1-.6-.2-1.2-.2-1.9-.1-.6-.1-1.2-.1-1.9v-.1c2.1 7 7.3 15 14.1 17.4 13 4.8 23.2-5.4 33.5-13.1 9.2-7.1 18.8-16.2 31.7-24.5 11.7-7.6 26.9-13.3 34.1-15.6-12.4-17.2-31-29.5-52-33.8-9.7-2-20-2.4-30.4-.8-5.6.9-11 2.3-16.1 4.1 0 0-10.9 3.8-19.8 10.3-1 .7-2.2 1.7-3.4 2.8-2 1.7-.6 4.9 2 4.6 5.2-.7 12.3-.6 20.5 1.8 15.5 4.6 23.5 15.7 27.4 23.1 2.1 4-1.8 5.8-4.1 3.5-7.1-7.1-28.6-20.2-54-6.9-16.7 8.8-23 24.3-24.1 37.3-1.6 19.6 5.6 36.9 10.5 45.6 12.1 21.3 32.8 36.4 56.7 41.4 9.8 2.1 20.1 2.4 30.6.8 19.2-3 35.9-12.2 48.4-25.2 5.3-5.5 9.8-11.7 13.4-18.3 4.6-8.5 7.8-17.8 9.3-27.6-.1.1-.5-.4-1.2-.5zm-103.7 36.9c.2 1.5 3 3.4 6.7 2.9 1.9-.2 3.6-1.1 4.7-2.2.3-.4 1.1-1.3 1-2.3-.2-1.5-3-3.4-6.7-2.9-1.9.2-3.6 1.1-4.7 2.2-.4.4-1.1 1.3-1 2.3zM97 185.3c-.4 0-1.5.2-1.9.8-.1.1-.2.4-.2.9.1 1.4 1.2 3.4 3.5 4.8 1.5 1 3.3 1.5 4.8 1.3.4 0 1.5-.2 1.9-.8.1-.1.2-.4.2-.9-.1-1.4-1.2-3.4-3.5-4.8-1.6-1-3.3-1.4-4.8-1.3z",
                className: "st0"
            })
        ]
    });
};
var $41158ab2c4dff680$export$2e2bcd8739ae039 = $41158ab2c4dff680$var$SvgComponent;



parcelRequire("7fPBF");
const $10c818dd7f51e943$var$SvgWave1 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 900,
        height: 600,
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "#EE486F",
            d: "m0 174 21.5-4.7c21.5-4.6 64.5-14 107.3-9 42.9 5 85.5 24.4 128.4 23.4 42.8-1 85.8-22.4 128.6-32.9 42.9-10.5 85.5-10.1 128.4-.6 42.8 9.5 85.8 28.1 128.6 32.5 42.9 4.3 85.5-5.7 128.4-7.7 42.8-2 85.8 4 107.3 7l21.5 3V0H0Z"
        })
    });
var $10c818dd7f51e943$export$2e2bcd8739ae039 = $10c818dd7f51e943$var$SvgWave1;



parcelRequire("7fPBF");
const $9305c41ed80e679e$var$SvgWave2 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 900,
        height: 600,
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "#EE486F",
            d: "m0 112 21.5 4.3c21.5 4.4 64.5 13 107.3 28.7 42.9 15.7 85.5 38.3 128.4 45.7 42.8 7.3 85.8-.7 128.6-13.9 42.9-13.1 85.5-31.5 128.4-27.5 42.8 4 85.8 30.4 128.6 29 42.9-1.3 85.5-30.3 128.4-42.8C814 123 857 127 878.5 129l21.5 2V0H0Z"
        })
    });
var $9305c41ed80e679e$export$2e2bcd8739ae039 = $9305c41ed80e679e$var$SvgWave2;







const $b091aef3a32d2bd8$export$90f89b8a63d85ede = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
    display: -webkit-box;
    word-break: break-all;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;
const $b091aef3a32d2bd8$export$c29b4f740eefd6d8 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
    font-weight: 300;
    font-size: 1rem; // 16px
    line-height: 1.3125rem; // 21px
    letter-spacing: 0.03rem;
`;
const $b091aef3a32d2bd8$export$e6005bbb0c0f31ce = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
    font-weight: 400;
    font-size: 1rem; // 16px
    line-height: 1.3125rem; // 21px
    letter-spacing: 0.03rem;
`;
const $b091aef3a32d2bd8$export$6413e6f2a6a43998 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
    font-weight: 300;
    font-size: 0.875rem; // 14px
    line-height: 1.125rem; // 18px
    letter-spacing: 0.03rem;
`;
const $b091aef3a32d2bd8$export$904d37a5903dadbe = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
    font-weight: 300;
    font-size: 0.75rem; // 12px
    line-height: 1rem; // 16px
`;
const $b091aef3a32d2bd8$export$54800003a6845797 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
    font-weight: 900;
    font-size: 2.875rem; // 46px
    line-height: 3.25rem; // 52px
`;
const $b091aef3a32d2bd8$export$53e784b1f50184bf = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
    font-weight: 900;
    font-size: 2.25rem; // 36px
    line-height: 2.625rem; // 42px
`;
const $b091aef3a32d2bd8$export$51371c1775291179 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
    font-weight: 800;
    font-size: 1.125rem;
    letter-spacing: 0.03rem;
    line-height: 1.313rem;
`;
const $b091aef3a32d2bd8$export$aca8b073d32574b4 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
    font-weight: 900;
    font-size: 3rem; // 52px
    line-height: 3.875rem; // 62px
    letter-spacing: -0.02rem;
    word-break: break-word;
`;
const $b091aef3a32d2bd8$export$e08999835651ba4a = (0, $8de346382d86c747$export$2e2bcd8739ae039).h1`
    ${$b091aef3a32d2bd8$export$aca8b073d32574b4}
    color: ${(props)=>props.theme.color.text};
`;
const $b091aef3a32d2bd8$export$9d43a8e504d2cc74 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($b091aef3a32d2bd8$export$e08999835651ba4a)`
    text-align: center;
`;
const $b091aef3a32d2bd8$export$d0736df568c9b0a1 = (0, $8de346382d86c747$export$2e2bcd8739ae039).h2`
    ${$b091aef3a32d2bd8$export$54800003a6845797}
    color: ${(props)=>props.theme.color.text};
`;
const $b091aef3a32d2bd8$export$eb3d1c5f8a2a1200 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($b091aef3a32d2bd8$export$d0736df568c9b0a1)`
    text-align: center;
    padding: 0.5rem 0 0 0;
`;
const $b091aef3a32d2bd8$export$f83be28a61c8ee22 = (0, $8de346382d86c747$export$2e2bcd8739ae039).h3`
    ${$b091aef3a32d2bd8$export$53e784b1f50184bf}
    color: ${(props)=>props.theme.color.text};
    text-align: center;
`;
const $b091aef3a32d2bd8$export$d9f4918700223049 = (0, $8de346382d86c747$export$2e2bcd8739ae039).h3`
    ${$b091aef3a32d2bd8$export$53e784b1f50184bf}
    color: ${(props)=>props.theme.color.text};
`;
const $b091aef3a32d2bd8$export$1120d81cab3b4d4a = (0, $8de346382d86c747$export$2e2bcd8739ae039).h3`
    font-weight: 900;
    font-size: 1.75rem; // 28px
    color: ${(props)=>props.theme.color.text};
    line-height: 2rem; // 32px
`;
const $b091aef3a32d2bd8$export$b8b202156ead000b = (0, $8de346382d86c747$export$2e2bcd8739ae039).h3`
    ${$b091aef3a32d2bd8$export$51371c1775291179}
    color: ${(props)=>props.theme.color.text};
`;
const $b091aef3a32d2bd8$export$fe91652f4f7f8d90 = (0, $8de346382d86c747$export$2e2bcd8739ae039).h1`
    font-weight: 700;
    font-size: 2rem; // 32px
    color: ${(props)=>props.theme.color.text};
    line-height: 2.625rem; // 42px
`;
const $b091aef3a32d2bd8$export$5c3bdb37a55baa65 = (0, $8de346382d86c747$export$2e2bcd8739ae039).h2`
    font-weight: 700;
    font-size: 1.75rem; // 28px
    color: ${(props)=>props.theme.color.text};
    line-height: 2rem; // 32px
`;
const $b091aef3a32d2bd8$export$2c65789109b698b0 = (0, $8de346382d86c747$export$2e2bcd8739ae039).h3`
    font-weight: 700;
    font-size: 1.25rem; // 24px
    color: ${(props)=>props.theme.color.text};
    line-height: 1.75rem; // 28px
`;
const $b091aef3a32d2bd8$export$68b378fffb2ccca3 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($b091aef3a32d2bd8$export$2c65789109b698b0)`
    ${$b091aef3a32d2bd8$export$90f89b8a63d85ede}
`;
const $b091aef3a32d2bd8$export$509f2eb89cb5202e = (0, $8de346382d86c747$export$2e2bcd8739ae039).p`
    font-weight: 700;
    font-size: 1rem; // 16px
    color: ${(props)=>props.theme.color.text};
    line-height: 1.313rem;
`;
const $b091aef3a32d2bd8$export$7a7caa5e1960fb1c = (0, $8de346382d86c747$export$2e2bcd8739ae039).p`
    font-weight: 700;
    font-size: 0.875rem; // 14px
    color: ${(props)=>props.theme.color.text};
    line-height: 1.125rem; // 18px
`;
const $b091aef3a32d2bd8$export$c1529625596ef638 = (0, $8de346382d86c747$export$2e2bcd8739ae039).p`
    font-weight: 500;
    font-size: 1.5rem; // 24px
    color: ${(props)=>props.theme.color.textBody};
    line-height: 1.75rem; // 28px
`;
const $b091aef3a32d2bd8$export$a35e4d6f9ac473d6 = (0, $8de346382d86c747$export$2e2bcd8739ae039).p`
    font-weight: 500;
    font-size: 1.125rem; // 18px
    color: ${(props)=>props.theme.color.textBody};
    line-height: 1.5rem; // 24px
`;
const $b091aef3a32d2bd8$export$a79389cfbe6f64d = (0, $8de346382d86c747$export$2e2bcd8739ae039).p`
    font-weight: 500;
    font-size: 1rem; // 16px
    color: ${(props)=>props.theme.color.textBody};
    line-height: 1.313rem; // 21px
`;
const $b091aef3a32d2bd8$export$df83f18906197f6b = (0, $8de346382d86c747$export$2e2bcd8739ae039).p`
    font-weight: 500;
    font-size: 0.875rem; // 14px
    color: ${(props)=>props.theme.color.textBody};
    line-height: 1.125rem; // 18px
`;
const $b091aef3a32d2bd8$export$69d65bc555dfaf7 = (0, $8de346382d86c747$export$2e2bcd8739ae039).p`
    font-weight: 400;
    font-size: 2rem; // 32px
    color: ${(props)=>props.theme.color.textBody};
    line-height: 2.625rem;
`;
const $b091aef3a32d2bd8$export$ea6aee68c7b1694f = (0, $8de346382d86c747$export$2e2bcd8739ae039).p`
    font-weight: 400;
    font-size: 1.313rem; // 21px
    color: ${(props)=>props.theme.color.textBody};
    line-height: 2rem; // 32px
`;
const $b091aef3a32d2bd8$export$b312780b0d72eabb = (0, $8de346382d86c747$export$2e2bcd8739ae039).p`
    font-weight: 400;
    font-size: 1.125rem; // 18px
    color: ${(props)=>props.theme.color.textBody};
    line-height: 1.625rem; // 26px
`;
const $b091aef3a32d2bd8$export$476b59e00e6c3fbd = (0, $8de346382d86c747$export$2e2bcd8739ae039).p`
    font-weight: 400;
    font-size: 1rem; // 16px
    color: ${(props)=>props.theme.color.textBody};
    line-height: 1.313rem; // 21px
`;
const $b091aef3a32d2bd8$export$f51cc64edb23e9d6 = (0, $8de346382d86c747$export$2e2bcd8739ae039).p`
    font-weight: 400;
    font-size: 0.875rem; // 12px
    color: ${(props)=>props.theme.color.textBody};
    line-height: 1.1rem; // 18px
`;
const $b091aef3a32d2bd8$export$eda1d74e80a4b8e4 = (0, $8de346382d86c747$export$2e2bcd8739ae039).p`
    font-weight: 300;
    font-size: 2rem; // 32px
    color: ${(props)=>props.theme.color.textBody};
    line-height: 2.5625rem; // 41px
    letter-spacing: 0.03rem;
`;
const $b091aef3a32d2bd8$export$332e4cc0f2c73ebf = (0, $8de346382d86c747$export$2e2bcd8739ae039).p`
    font-weight: 300;
    font-size: 1.565rem; // 25px
    color: ${(props)=>props.theme.color.textBody};
    line-height: 2.5625rem; // 41px
    letter-spacing: 0.03rem;
`;
const $b091aef3a32d2bd8$export$c527f4a83cede337 = (0, $8de346382d86c747$export$2e2bcd8739ae039).p`
    font-weight: 300;
    font-size: 1.3125rem; // 21px
    color: ${(props)=>props.theme.color.textBody};
    line-height: 2rem; // 32px
    letter-spacing: 0.03rem;
`;
const $b091aef3a32d2bd8$export$32a758e2e508ec9f = (0, $8de346382d86c747$export$2e2bcd8739ae039).p`
    font-weight: 300;
    font-size: 1.125rem; // 18px
    color: ${(props)=>props.theme.color.textBody};
    line-height: 1.625rem; // 26px
    letter-spacing: 0.03rem;
`;
const $b091aef3a32d2bd8$export$ddf9e902b54c6c8 = (0, $8de346382d86c747$export$2e2bcd8739ae039).p`
    ${$b091aef3a32d2bd8$export$c29b4f740eefd6d8}
    color: ${(props)=>props.theme.color.textBody};
`;
const $b091aef3a32d2bd8$export$1ef657600983666a = (0, $8de346382d86c747$export$2e2bcd8739ae039).p`
    ${$b091aef3a32d2bd8$export$6413e6f2a6a43998}
    color: ${(props)=>props.theme.color.textBody};
`;
const $b091aef3a32d2bd8$export$aa612d3716e98a87 = (0, $8de346382d86c747$export$2e2bcd8739ae039).p`
    ${$b091aef3a32d2bd8$export$904d37a5903dadbe}
    color: ${(props)=>props.theme.color.textBody};
`;
const $b091aef3a32d2bd8$export$45814810f7000d9e = (0, $8de346382d86c747$export$2e2bcd8739ae039).p`
    font-weight: 200;
    text-align: center;
    font-size: 1rem;
    line-height: 1.313rem;
`;
const $b091aef3a32d2bd8$export$a6cc38c9c1109f8f = (0, $8de346382d86c747$export$2e2bcd8739ae039)($b091aef3a32d2bd8$export$df83f18906197f6b)`
    color: ${(0, $8951886a6b49e92a$export$35e9368ef982300f).success};
    border: 1px solid ${(0, $8951886a6b49e92a$export$35e9368ef982300f).success};
    background-color: #e1e6e1;
    border-radius: 0.375rem;
    padding: 0.25rem 0.5rem;
`;
const $b091aef3a32d2bd8$export$415891f6b2865cea = (0, $8de346382d86c747$export$2e2bcd8739ae039)($b091aef3a32d2bd8$export$df83f18906197f6b)`
    color: ${(0, $8951886a6b49e92a$export$35e9368ef982300f).success};
    border: 1px solid ${(0, $8951886a6b49e92a$export$35e9368ef982300f).success};
    background-color: #e1e6e1;
    border-radius: 0.375rem;
    padding: 0.25rem 0.5rem;
`;









/**
 * SrOnlyText.tsx
 * This is a styled component that is used to hide text from everyone but the screen reader.
 * It should be used with caution as it is always better to have text visible to everyone.
 * However, there are some cases where text is not needed for the user but is needed for the screen reader.
 * In these cases, this component should be used.
 */ const $30af349a5a5f3e57$var$SrOnlyText = (0, $8de346382d86c747$export$2e2bcd8739ae039).span`
    position: absolute !important;
    width: 0px !important;
    height: 0px !important;
    padding: 0 !important;
    overflow: hidden !important;
    white-space: nowrap !important;
    clip: rect(0 0 0 0) !important;
    clip-path: inset(50%) !important;
    border: 0 !important;
`;
var $30af349a5a5f3e57$export$2e2bcd8739ae039 = $30af349a5a5f3e57$var$SrOnlyText;




var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

const $57773c22414cc39f$export$2e2bcd8739ae039 = $7fPBF.forwardRef((s, a)=>{
    const { alt: n, color: r, size: t, weight: o, mirrored: c, children: i, weights: m, ...x } = s, { color: d = "currentColor", size: l, weight: f = "regular", mirrored: g = !1, ...w } = $7fPBF.useContext((0, $1c78e537a9e9e9b0$export$a49f528ae1a4d0ed));
    return /* @__PURE__ */ $7fPBF.createElement("svg", {
        ref: a,
        xmlns: "http://www.w3.org/2000/svg",
        width: t != null ? t : l,
        height: t != null ? t : l,
        fill: r != null ? r : d,
        viewBox: "0 0 256 256",
        transform: c || g ? "scale(-1, 1)" : void 0,
        ...w,
        ...x
    }, !!n && /* @__PURE__ */ $7fPBF.createElement("title", null, n), i, m.get(o != null ? o : f));
});
$57773c22414cc39f$export$2e2bcd8739ae039.displayName = "IconBase";



var $7fPBF = parcelRequire("7fPBF");
const $ed3120622883ea3f$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,36H40A20,20,0,0,0,20,56V200a20,20,0,0,0,20,20H216a20,20,0,0,0,20-20V56A20,20,0,0,0,216,36Zm-4,160H44V60H212ZM60,92a16,16,0,1,1,16,16A16,16,0,0,1,60,92Zm48,0a16,16,0,1,1,16,16A16,16,0,0,1,108,92Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,56V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216A8,8,0,0,1,224,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V56H216V200ZM80,84A12,12,0,1,1,68,72,12,12,0,0,1,80,84Zm40,0a12,12,0,1,1-12-12A12,12,0,0,1,120,84Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM68,96A12,12,0,1,1,80,84,12,12,0,0,1,68,96Zm40,0a12,12,0,1,1,12-12A12,12,0,0,1,108,96Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,42H40A14,14,0,0,0,26,56V200a14,14,0,0,0,14,14H216a14,14,0,0,0,14-14V56A14,14,0,0,0,216,42Zm2,158a2,2,0,0,1-2,2H40a2,2,0,0,1-2-2V56a2,2,0,0,1,2-2H216a2,2,0,0,1,2,2ZM78,84A10,10,0,1,1,68,74,10,10,0,0,1,78,84Zm40,0a10,10,0,1,1-10-10A10,10,0,0,1,118,84Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V56H216V200ZM80,84A12,12,0,1,1,68,72,12,12,0,0,1,80,84Zm40,0a12,12,0,1,1-12-12A12,12,0,0,1,120,84Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,44H40A12,12,0,0,0,28,56V200a12,12,0,0,0,12,12H216a12,12,0,0,0,12-12V56A12,12,0,0,0,216,44Zm4,156a4,4,0,0,1-4,4H40a4,4,0,0,1-4-4V56a4,4,0,0,1,4-4H216a4,4,0,0,1,4,4ZM76,84a8,8,0,1,1-8-8A8,8,0,0,1,76,84Zm40,0a8,8,0,1,1-8-8A8,8,0,0,1,116,84Z"
        }))
    ]
]);


const $dfac1a9d177543ce$export$73674ec7e4bd2217 = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...e,
        weights: (0, $ed3120622883ea3f$export$2e2bcd8739ae039)
    }));
$dfac1a9d177543ce$export$73674ec7e4bd2217.displayName = "AppWindowIcon";
const $dfac1a9d177543ce$export$8bd6e8b7c946a046 = $dfac1a9d177543ce$export$73674ec7e4bd2217;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $9e5b8dd6cfd61d7a$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M204,32V176a12,12,0,0,1-12,12H77l27.52,27.51a12,12,0,0,1-17,17l-48-48a12,12,0,0,1,0-17l48-48a12,12,0,1,1,17,17L77,164H180V32a12,12,0,0,1,24,0Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M96,128v96L48,176Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M192,24a8,8,0,0,0-8,8V168H104V128a8,8,0,0,0-13.66-5.66l-48,48a8,8,0,0,0,0,11.32l48,48A8,8,0,0,0,104,224V184h88a8,8,0,0,0,8-8V32A8,8,0,0,0,192,24ZM88,204.69,59.31,176,88,147.31Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,32V176a8,8,0,0,1-8,8H104v40a8,8,0,0,1-13.66,5.66l-48-48a8,8,0,0,1,0-11.32l48-48A8,8,0,0,1,104,128v40h80V32a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M198,32V176a6,6,0,0,1-6,6H62.49l37.75,37.76a6,6,0,1,1-8.48,8.48l-48-48a6,6,0,0,1,0-8.48l48-48a6,6,0,1,1,8.48,8.48L62.49,170H186V32a6,6,0,0,1,12,0Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,32V176a8,8,0,0,1-8,8H67.31l34.35,34.34a8,8,0,0,1-11.32,11.32l-48-48a8,8,0,0,1,0-11.32l48-48a8,8,0,0,1,11.32,11.32L67.31,168H184V32a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M196,32V176a4,4,0,0,1-4,4H57.66l41.17,41.17a4,4,0,0,1-5.66,5.66l-48-48a4,4,0,0,1,0-5.66l48-48a4,4,0,1,1,5.66,5.66L57.66,172H188V32a4,4,0,0,1,8,0Z"
        }))
    ]
]);


const $67b9a227b3b8fac0$export$13cb63b08462037d = $7fPBF.forwardRef((e, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...e,
        weights: (0, $9e5b8dd6cfd61d7a$export$2e2bcd8739ae039)
    }));
$67b9a227b3b8fac0$export$13cb63b08462037d.displayName = "ArrowElbowDownLeftIcon";
const $67b9a227b3b8fac0$export$ced96cfba709fc2c = $67b9a227b3b8fac0$export$13cb63b08462037d;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $d8816807b786f33b$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224.49,184.49l-48,48a12,12,0,0,1-17-17L187,188H72a12,12,0,0,1-12-12V32a12,12,0,0,1,24,0V164H187l-27.52-27.51a12,12,0,1,1,17-17l48,48A12,12,0,0,1,224.49,184.49Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,176l-48,48V128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M221.66,170.34l-48-48A8,8,0,0,0,160,128v40H80V32a8,8,0,0,0-16,0V176a8,8,0,0,0,8,8h88v40a8,8,0,0,0,13.66,5.66l48-48A8,8,0,0,0,221.66,170.34ZM176,204.69V147.31L204.69,176Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M221.66,181.66l-48,48A8,8,0,0,1,160,224V184H72a8,8,0,0,1-8-8V32a8,8,0,0,1,16,0V168h80V128a8,8,0,0,1,13.66-5.66l48,48A8,8,0,0,1,221.66,181.66Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220.24,180.24l-48,48a6,6,0,0,1-8.48-8.48L201.51,182H72a6,6,0,0,1-6-6V32a6,6,0,0,1,12,0V170H201.51l-37.75-37.76a6,6,0,1,1,8.48-8.48l48,48A6,6,0,0,1,220.24,180.24Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M221.66,181.66l-48,48a8,8,0,0,1-11.32-11.32L196.69,184H72a8,8,0,0,1-8-8V32a8,8,0,0,1,16,0V168H196.69l-34.35-34.34a8,8,0,0,1,11.32-11.32l48,48A8,8,0,0,1,221.66,181.66Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M218.83,178.83l-48,48a4,4,0,0,1-5.66-5.66L206.34,180H72a4,4,0,0,1-4-4V32a4,4,0,0,1,8,0V172H206.34l-41.17-41.17a4,4,0,1,1,5.66-5.66l48,48A4,4,0,0,1,218.83,178.83Z"
        }))
    ]
]);


const $6637b5fdc104c1c9$export$56519a0a31438e20 = $7fPBF.forwardRef((t, w)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: w,
        ...t,
        weights: (0, $d8816807b786f33b$export$2e2bcd8739ae039)
    }));
$6637b5fdc104c1c9$export$56519a0a31438e20.displayName = "ArrowElbowDownRightIcon";
const $6637b5fdc104c1c9$export$677a03fdc17dcb49 = $6637b5fdc104c1c9$export$56519a0a31438e20;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $c1220d732e68f3d1$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232.49,111.51l-96-96a12,12,0,0,0-17,0l-96,96A12,12,0,0,0,32,132H68v4a12,12,0,0,0,12,12h96a12,12,0,0,0,12-12v-4h36a12,12,0,0,0,8.49-20.49ZM176,108a12,12,0,0,0-12,12v4H92v-4a12,12,0,0,0-12-12H61l67-67,67,67Zm12,108a12,12,0,0,1-12,12H80a12,12,0,0,1,0-24h96A12,12,0,0,1,188,216Zm0-40a12,12,0,0,1-12,12H80a12,12,0,0,1,0-24h96A12,12,0,0,1,188,176Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,120H176v32H80V120H32l96-96Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M229.66,114.34l-96-96a8,8,0,0,0-11.32,0l-96,96A8,8,0,0,0,32,128H72v24a8,8,0,0,0,8,8h96a8,8,0,0,0,8-8V128h40a8,8,0,0,0,5.66-13.66ZM176,112a8,8,0,0,0-8,8v24H88V120a8,8,0,0,0-8-8H51.31L128,35.31,204.69,112Zm8,104a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h96A8,8,0,0,1,184,216Zm0-32a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h96A8,8,0,0,1,184,184Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184,216a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h96A8,8,0,0,1,184,216Zm45.66-101.66-96-96a8,8,0,0,0-11.32,0l-96,96A8,8,0,0,0,32,128H72v24a8,8,0,0,0,8,8h96a8,8,0,0,0,8-8V128h40a8,8,0,0,0,5.66-13.66ZM176,176H80a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228.24,115.76l-96-96a6,6,0,0,0-8.48,0l-96,96A6,6,0,0,0,32,126H74v26a6,6,0,0,0,6,6h96a6,6,0,0,0,6-6V126h42a6,6,0,0,0,4.24-10.24ZM176,114a6,6,0,0,0-6,6v26H86V120a6,6,0,0,0-6-6H46.49L128,32.49,209.51,114Zm6,102a6,6,0,0,1-6,6H80a6,6,0,0,1,0-12h96A6,6,0,0,1,182,216Zm0-32a6,6,0,0,1-6,6H80a6,6,0,0,1,0-12h96A6,6,0,0,1,182,184Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M229.66,114.34l-96-96a8,8,0,0,0-11.32,0l-96,96A8,8,0,0,0,32,128H72v24a8,8,0,0,0,8,8h96a8,8,0,0,0,8-8V128h40a8,8,0,0,0,5.66-13.66ZM176,112a8,8,0,0,0-8,8v24H88V120a8,8,0,0,0-8-8H51.31L128,35.31,204.69,112Zm8,104a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h96A8,8,0,0,1,184,216Zm0-32a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h96A8,8,0,0,1,184,184Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M226.83,117.17l-96-96a4,4,0,0,0-5.66,0l-96,96A4,4,0,0,0,32,124H76v28a4,4,0,0,0,4,4h96a4,4,0,0,0,4-4V124h44a4,4,0,0,0,2.83-6.83ZM176,116a4,4,0,0,0-4,4v28H84V120a4,4,0,0,0-4-4H41.66L128,29.66,214.34,116Zm4,100a4,4,0,0,1-4,4H80a4,4,0,0,1,0-8h96A4,4,0,0,1,180,216Zm0-32a4,4,0,0,1-4,4H80a4,4,0,0,1,0-8h96A4,4,0,0,1,180,184Z"
        }))
    ]
]);


const $77361cab3d35eb70$export$d4c1fa49fa5d23e1 = $7fPBF.forwardRef((e, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...e,
        weights: (0, $c1220d732e68f3d1$export$2e2bcd8739ae039)
    }));
$77361cab3d35eb70$export$d4c1fa49fa5d23e1.displayName = "ArrowFatLinesUpIcon";
const $77361cab3d35eb70$export$9cba9f8b627cd7c4 = $77361cab3d35eb70$export$d4c1fa49fa5d23e1;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $92d218368e7786d0$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M87.51,64.49a12,12,0,0,1,0-17l32-32a12,12,0,0,1,17,0l32,32a12,12,0,0,1-17,17L140,53V96a12,12,0,0,1-24,0V53L104.49,64.49A12,12,0,0,1,87.51,64.49Zm64,127L140,203V160a12,12,0,0,0-24,0v43l-11.51-11.52a12,12,0,0,0-17,17l32,32a12,12,0,0,0,17,0l32-32a12,12,0,0,0-17-17Zm89-72-32-32a12,12,0,0,0-17,17L203,116H160a12,12,0,0,0,0,24h43l-11.52,11.51a12,12,0,0,0,17,17l32-32A12,12,0,0,0,240.49,119.51ZM53,140H96a12,12,0,0,0,0-24H53l11.52-11.51a12,12,0,1,0-17-17l-32,32a12,12,0,0,0,0,17l32,32a12,12,0,1,0,17-17Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,128,128,232,24,128,128,24Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M90.34,61.66a8,8,0,0,1,0-11.32l32-32a8,8,0,0,1,11.32,0l32,32a8,8,0,0,1-11.32,11.32L136,43.31V96a8,8,0,0,1-16,0V43.31L101.66,61.66A8,8,0,0,1,90.34,61.66Zm64,132.68L136,212.69V160a8,8,0,0,0-16,0v52.69l-18.34-18.35a8,8,0,0,0-11.32,11.32l32,32a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Zm83.32-72-32-32a8,8,0,0,0-11.32,11.32L212.69,120H160a8,8,0,0,0,0,16h52.69l-18.35,18.34a8,8,0,0,0,11.32,11.32l32-32A8,8,0,0,0,237.66,122.34ZM43.31,136H96a8,8,0,0,0,0-16H43.31l18.35-18.34A8,8,0,0,0,50.34,90.34l-32,32a8,8,0,0,0,0,11.32l32,32a8,8,0,0,0,11.32-11.32Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M96,136H64v24a8,8,0,0,1-13.66,5.66l-32-32a8,8,0,0,1,0-11.32l32-32A8,8,0,0,1,64,96v24H96a8,8,0,0,1,0,16Zm0-72h24V96a8,8,0,0,0,16,0V64h24a8,8,0,0,0,5.66-13.66l-32-32a8,8,0,0,0-11.32,0l-32,32A8,8,0,0,0,96,64Zm141.66,58.34-32-32A8,8,0,0,0,192,96v24H160a8,8,0,0,0,0,16h32v24a8,8,0,0,0,13.66,5.66l32-32A8,8,0,0,0,237.66,122.34ZM160,192H136V160a8,8,0,0,0-16,0v32H96a8,8,0,0,0-5.66,13.66l32,32a8,8,0,0,0,11.32,0l32-32A8,8,0,0,0,160,192Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M91.76,60.24a6,6,0,0,1,0-8.48l32-32a6,6,0,0,1,8.48,0l32,32a6,6,0,1,1-8.48,8.48L134,38.49V96a6,6,0,0,1-12,0V38.49L100.24,60.24A6,6,0,0,1,91.76,60.24Zm64,135.52L134,217.51V160a6,6,0,0,0-12,0v57.51l-21.76-21.75a6,6,0,0,0-8.48,8.48l32,32a6,6,0,0,0,8.48,0l32-32a6,6,0,0,0-8.48-8.48Zm80.48-72-32-32a6,6,0,0,0-8.48,8.48L217.51,122H160a6,6,0,0,0,0,12h57.51l-21.75,21.76a6,6,0,1,0,8.48,8.48l32-32A6,6,0,0,0,236.24,123.76ZM38.49,134H96a6,6,0,0,0,0-12H38.49l21.75-21.76a6,6,0,0,0-8.48-8.48l-32,32a6,6,0,0,0,0,8.48l32,32a6,6,0,0,0,8.48-8.48Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M90.34,61.66a8,8,0,0,1,0-11.32l32-32a8,8,0,0,1,11.32,0l32,32a8,8,0,0,1-11.32,11.32L136,43.31V96a8,8,0,0,1-16,0V43.31L101.66,61.66A8,8,0,0,1,90.34,61.66Zm64,132.68L136,212.69V160a8,8,0,0,0-16,0v52.69l-18.34-18.35a8,8,0,0,0-11.32,11.32l32,32a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Zm83.32-72-32-32a8,8,0,0,0-11.32,11.32L212.69,120H160a8,8,0,0,0,0,16h52.69l-18.35,18.34a8,8,0,0,0,11.32,11.32l32-32A8,8,0,0,0,237.66,122.34ZM43.31,136H96a8,8,0,0,0,0-16H43.31l18.35-18.34A8,8,0,0,0,50.34,90.34l-32,32a8,8,0,0,0,0,11.32l32,32a8,8,0,0,0,11.32-11.32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M93.17,58.83a4,4,0,0,1,0-5.66l32-32a4,4,0,0,1,5.66,0l32,32a4,4,0,0,1-5.66,5.66L132,33.66V96a4,4,0,0,1-8,0V33.66L98.83,58.83A4,4,0,0,1,93.17,58.83Zm64,138.34L132,222.34V160a4,4,0,0,0-8,0v62.34L98.83,197.17a4,4,0,0,0-5.66,5.66l32,32a4,4,0,0,0,5.66,0l32-32a4,4,0,0,0-5.66-5.66Zm77.66-72-32-32a4,4,0,0,0-5.66,5.66L222.34,124H160a4,4,0,0,0,0,8h62.34l-25.17,25.17a4,4,0,0,0,5.66,5.66l32-32A4,4,0,0,0,234.83,125.17ZM33.66,132H96a4,4,0,0,0,0-8H33.66L58.83,98.83a4,4,0,0,0-5.66-5.66l-32,32a4,4,0,0,0,0,5.66l32,32a4,4,0,1,0,5.66-5.66Z"
        }))
    ]
]);


const $262c01eb267814c7$export$a851e5e12081274c = $7fPBF.forwardRef((a, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...a,
        weights: (0, $92d218368e7786d0$export$2e2bcd8739ae039)
    }));
$262c01eb267814c7$export$a851e5e12081274c.displayName = "ArrowsOutCardinalIcon";
const $262c01eb267814c7$export$5c8fcb1141eeb696 = $262c01eb267814c7$export$a851e5e12081274c;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $5edf2742067d7e74$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228,128a12,12,0,0,1-12,12H40a12,12,0,0,1,0-24H216A12,12,0,0,1,228,128ZM104.49,56.48,116,45V88a12,12,0,0,0,24,0V45l11.51,11.51a12,12,0,0,0,17-17l-32-32a12,12,0,0,0-17,0l-32,32a12,12,0,0,0,17,17Zm47,143L140,211V168a12,12,0,0,0-24,0v43l-11.51-11.52a12,12,0,0,0-17,17l32,32a12,12,0,0,0,17,0l32-32a12,12,0,0,0-17-17Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,32V224a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V32A16,16,0,0,1,56,16H200A16,16,0,0,1,216,32Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM101.66,53.66,120,35.31V96a8,8,0,0,0,16,0V35.31l18.34,18.35a8,8,0,0,0,11.32-11.32l-32-32a8,8,0,0,0-11.32,0l-32,32a8,8,0,0,0,11.32,11.32Zm52.68,148.68L136,220.69V160a8,8,0,0,0-16,0v60.69l-18.34-18.35a8,8,0,0,0-11.32,11.32l32,32a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M88.61,51.06a8,8,0,0,1,1.73-8.72l32-32a8,8,0,0,1,11.32,0l32,32A8,8,0,0,1,160,56H136V96a8,8,0,0,1-16,0V56H96A8,8,0,0,1,88.61,51.06ZM216,120H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm-56,80H136V160a8,8,0,0,0-16,0v40H96a8,8,0,0,0-5.66,13.66l32,32a8,8,0,0,0,11.32,0l32-32A8,8,0,0,0,160,200Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M222,128a6,6,0,0,1-6,6H40a6,6,0,0,1,0-12H216A6,6,0,0,1,222,128ZM100.24,52.24,122,30.49V96a6,6,0,0,0,12,0V30.49l21.76,21.75a6,6,0,0,0,8.48-8.48l-32-32a6,6,0,0,0-8.48,0l-32,32a6,6,0,0,0,8.48,8.48Zm55.52,151.52L134,225.51V160a6,6,0,0,0-12,0v65.51l-21.76-21.75a6,6,0,0,0-8.48,8.48l32,32a6,6,0,0,0,8.48,0l32-32a6,6,0,0,0-8.48-8.48Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM101.66,53.66,120,35.31V96a8,8,0,0,0,16,0V35.31l18.34,18.35a8,8,0,0,0,11.32-11.32l-32-32a8,8,0,0,0-11.32,0l-32,32a8,8,0,0,0,11.32,11.32Zm52.68,148.68L136,220.69V160a8,8,0,0,0-16,0v60.69l-18.34-18.35a8,8,0,0,0-11.32,11.32l32,32a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220,128a4,4,0,0,1-4,4H40a4,4,0,0,1,0-8H216A4,4,0,0,1,220,128ZM98.83,50.83,124,25.66V96a4,4,0,0,0,8,0V25.66l25.17,25.17a4,4,0,1,0,5.66-5.66l-32-32a4,4,0,0,0-5.66,0l-32,32a4,4,0,0,0,5.66,5.66Zm58.34,154.34L132,230.34V160a4,4,0,0,0-8,0v70.34L98.83,205.17a4,4,0,0,0-5.66,5.66l32,32a4,4,0,0,0,5.66,0l32-32a4,4,0,0,0-5.66-5.66Z"
        }))
    ]
]);


const $c1cd2f9ed3ccb6f1$export$83609ace955a79f = $7fPBF.forwardRef((o, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...o,
        weights: (0, $5edf2742067d7e74$export$2e2bcd8739ae039)
    }));
$c1cd2f9ed3ccb6f1$export$83609ace955a79f.displayName = "ArrowsOutLineVerticalIcon";
const $c1cd2f9ed3ccb6f1$export$720d58d5890ffa04 = $c1cd2f9ed3ccb6f1$export$83609ace955a79f;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $5a58d2012a64e35d$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,28H48A20,20,0,0,0,28,48V208a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V48A20,20,0,0,0,208,28Zm-4,176H52V52H204ZM87.51,144.49a12,12,0,1,1,17-17L116,139V88a12,12,0,0,1,24,0v51l11.51-11.52a12,12,0,1,1,17,17l-32,32a12,12,0,0,1-17,0Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,48V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208A8,8,0,0,1,216,48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208Zm-42.34-77.66a8,8,0,0,1,0,11.32l-32,32a8,8,0,0,1-11.32,0l-32-32a8,8,0,0,1,11.32-11.32L120,148.69V88a8,8,0,0,1,16,0v60.69l18.34-18.35A8,8,0,0,1,165.66,130.34Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM165.66,141.66l-32,32a8,8,0,0,1-11.32,0l-32-32a8,8,0,0,1,11.32-11.32L120,148.69V88a8,8,0,0,1,16,0v60.69l18.34-18.35a8,8,0,0,1,11.32,11.32Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,34H48A14,14,0,0,0,34,48V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V48A14,14,0,0,0,208,34Zm2,174a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V48a2,2,0,0,1,2-2H208a2,2,0,0,1,2,2Zm-45.76-76.24a6,6,0,0,1,0,8.48l-32,32a6,6,0,0,1-8.48,0l-32-32a6,6,0,0,1,8.48-8.48L122,153.51V88a6,6,0,0,1,12,0v65.51l21.76-21.75A6,6,0,0,1,164.24,131.76Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208Zm-42.34-77.66a8,8,0,0,1,0,11.32l-32,32a8,8,0,0,1-11.32,0l-32-32a8,8,0,0,1,11.32-11.32L120,148.69V88a8,8,0,0,1,16,0v60.69l18.34-18.35A8,8,0,0,1,165.66,130.34Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,36H48A12,12,0,0,0,36,48V208a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V48A12,12,0,0,0,208,36Zm4,172a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V48a4,4,0,0,1,4-4H208a4,4,0,0,1,4,4Zm-49.17-74.83a4,4,0,0,1,0,5.66l-32,32a4,4,0,0,1-5.66,0l-32-32a4,4,0,0,1,5.66-5.66L124,158.34V88a4,4,0,0,1,8,0v70.34l25.17-25.17A4,4,0,0,1,162.83,133.17Z"
        }))
    ]
]);


const $31ad35f89b420139$export$39cd7ca4553bb068 = $7fPBF.forwardRef((e, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: a,
        ...e,
        weights: (0, $5a58d2012a64e35d$export$2e2bcd8739ae039)
    }));
$31ad35f89b420139$export$39cd7ca4553bb068.displayName = "ArrowSquareDownIcon";
const $31ad35f89b420139$export$b18b91a77b42e903 = $31ad35f89b420139$export$39cd7ca4553bb068;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $26dc86d55555543b$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228,104a12,12,0,0,1-24,0V69l-59.51,59.51a12,12,0,0,1-17-17L187,52H152a12,12,0,0,1,0-24h64a12,12,0,0,1,12,12Zm-44,24a12,12,0,0,0-12,12v64H52V84h64a12,12,0,0,0,0-24H48A20,20,0,0,0,28,80V208a20,20,0,0,0,20,20H176a20,20,0,0,0,20-20V140A12,12,0,0,0,184,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184,80V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8H176A8,8,0,0,1,184,80Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,104a8,8,0,0,1-16,0V59.32l-66.33,66.34a8,8,0,0,1-11.32-11.32L196.68,48H152a8,8,0,0,1,0-16h64a8,8,0,0,1,8,8Zm-40,24a8,8,0,0,0-8,8v72H48V80h72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,80V208a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V136A8,8,0,0,0,184,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M192,136v72a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64h72a8,8,0,0,1,0,16H48V208H176V136a8,8,0,0,1,16,0Zm32-96a8,8,0,0,0-8-8H152a8,8,0,0,0-5.66,13.66L172.69,72l-42.35,42.34a8,8,0,0,0,11.32,11.32L184,83.31l26.34,26.35A8,8,0,0,0,224,104Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M222,104a6,6,0,0,1-12,0V54.49l-69.75,69.75a6,6,0,0,1-8.48-8.48L201.51,46H152a6,6,0,0,1,0-12h64a6,6,0,0,1,6,6Zm-38,26a6,6,0,0,0-6,6v72a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V80a2,2,0,0,1,2-2h72a6,6,0,0,0,0-12H48A14,14,0,0,0,34,80V208a14,14,0,0,0,14,14H176a14,14,0,0,0,14-14V136A6,6,0,0,0,184,130Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,104a8,8,0,0,1-16,0V59.32l-66.33,66.34a8,8,0,0,1-11.32-11.32L196.68,48H152a8,8,0,0,1,0-16h64a8,8,0,0,1,8,8Zm-40,24a8,8,0,0,0-8,8v72H48V80h72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,80V208a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V136A8,8,0,0,0,184,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220,104a4,4,0,0,1-8,0V49.66l-73.16,73.17a4,4,0,0,1-5.66-5.66L206.34,44H152a4,4,0,0,1,0-8h64a4,4,0,0,1,4,4Zm-36,28a4,4,0,0,0-4,4v72a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V80a4,4,0,0,1,4-4h72a4,4,0,0,0,0-8H48A12,12,0,0,0,36,80V208a12,12,0,0,0,12,12H176a12,12,0,0,0,12-12V136A4,4,0,0,0,184,132Z"
        }))
    ]
]);


const $2c52d04e0b586f6c$export$8a7958b7fd68e86d = $7fPBF.forwardRef((e, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...e,
        weights: (0, $26dc86d55555543b$export$2e2bcd8739ae039)
    }));
$2c52d04e0b586f6c$export$8a7958b7fd68e86d.displayName = "ArrowSquareOutIcon";
const $2c52d04e0b586f6c$export$1453825ca7ef66c = $2c52d04e0b586f6c$export$8a7958b7fd68e86d;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $dce9f61ad8b609ff$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,28H48A20,20,0,0,0,28,48V208a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V48A20,20,0,0,0,208,28Zm-4,176H52V52H204ZM87.51,128.49a12,12,0,0,1,0-17l32-32a12,12,0,0,1,17,0l32,32a12,12,0,0,1-17,17L140,117v51a12,12,0,0,1-24,0V117l-11.51,11.52A12,12,0,0,1,87.51,128.49Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,48V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208A8,8,0,0,1,216,48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208ZM90.34,125.66a8,8,0,0,1,0-11.32l32-32a8,8,0,0,1,11.32,0l32,32a8,8,0,0,1-11.32,11.32L136,107.31V168a8,8,0,0,1-16,0V107.31l-18.34,18.35A8,8,0,0,1,90.34,125.66Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm-42.34,93.66a8,8,0,0,1-11.32,0L136,107.31V168a8,8,0,0,1-16,0V107.31l-18.34,18.35a8,8,0,0,1-11.32-11.32l32-32a8,8,0,0,1,11.32,0l32,32A8,8,0,0,1,165.66,125.66Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,34H48A14,14,0,0,0,34,48V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V48A14,14,0,0,0,208,34Zm2,174a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V48a2,2,0,0,1,2-2H208a2,2,0,0,1,2,2Zm-45.76-92.24a6,6,0,1,1-8.48,8.48L134,102.49V168a6,6,0,0,1-12,0V102.49l-21.76,21.75a6,6,0,0,1-8.48-8.48l32-32a6,6,0,0,1,8.48,0Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208ZM90.34,125.66a8,8,0,0,1,0-11.32l32-32a8,8,0,0,1,11.32,0l32,32a8,8,0,0,1-11.32,11.32L136,107.31V168a8,8,0,0,1-16,0V107.31l-18.34,18.35A8,8,0,0,1,90.34,125.66Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,36H48A12,12,0,0,0,36,48V208a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V48A12,12,0,0,0,208,36Zm4,172a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V48a4,4,0,0,1,4-4H208a4,4,0,0,1,4,4Zm-49.17-90.83a4,4,0,0,1-5.66,5.66L132,97.66V168a4,4,0,0,1-8,0V97.66L98.83,122.83a4,4,0,0,1-5.66-5.66l32-32a4,4,0,0,1,5.66,0Z"
        }))
    ]
]);


const $618411f7e75dbf5e$export$877fb05cb295590c = $7fPBF.forwardRef((e, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: a,
        ...e,
        weights: (0, $dce9f61ad8b609ff$export$2e2bcd8739ae039)
    }));
$618411f7e75dbf5e$export$877fb05cb295590c.displayName = "ArrowSquareUpIcon";
const $618411f7e75dbf5e$export$426afd5b5ba0f986 = $618411f7e75dbf5e$export$877fb05cb295590c;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $69e3a2c3922c842b$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M225.29,165.93C216.61,151,212,129.57,212,104a84,84,0,0,0-168,0c0,25.58-4.59,47-13.27,61.93A20.08,20.08,0,0,0,30.66,186,19.77,19.77,0,0,0,48,196H84.18a44,44,0,0,0,87.64,0H208a19.77,19.77,0,0,0,17.31-10A20.08,20.08,0,0,0,225.29,165.93ZM128,212a20,20,0,0,1-19.6-16h39.2A20,20,0,0,1,128,212ZM54.66,172C63.51,154,68,131.14,68,104a60,60,0,0,1,120,0c0,27.13,4.48,50,13.33,68Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,192H48a8,8,0,0,1-6.88-12C47.71,168.6,56,139.81,56,104a72,72,0,0,1,144,0c0,35.82,8.3,64.6,14.9,76A8,8,0,0,1,208,192Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M221.8,175.94C216.25,166.38,208,139.33,208,104a80,80,0,1,0-160,0c0,35.34-8.26,62.38-13.81,71.94A16,16,0,0,0,48,200H88.81a40,40,0,0,0,78.38,0H208a16,16,0,0,0,13.8-24.06ZM128,216a24,24,0,0,1-22.62-16h45.24A24,24,0,0,1,128,216ZM48,184c7.7-13.24,16-43.92,16-80a64,64,0,1,1,128,0c0,36.05,8.28,66.73,16,80Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M221.8,175.94C216.25,166.38,208,139.33,208,104a80,80,0,1,0-160,0c0,35.34-8.26,62.38-13.81,71.94A16,16,0,0,0,48,200H88.81a40,40,0,0,0,78.38,0H208a16,16,0,0,0,13.8-24.06ZM128,216a24,24,0,0,1-22.62-16h45.24A24,24,0,0,1,128,216Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220.07,176.94C214.41,167.2,206,139.73,206,104a78,78,0,1,0-156,0c0,35.74-8.42,63.2-14.08,72.94A14,14,0,0,0,48,198H90.48a38,38,0,0,0,75,0H208a14,14,0,0,0,12.06-21.06ZM128,218a26,26,0,0,1-25.29-20h50.58A26,26,0,0,1,128,218Zm81.71-33a1.9,1.9,0,0,1-1.7,1H48a1.9,1.9,0,0,1-1.7-1,2,2,0,0,1,0-2C53.87,170,62,139.69,62,104a66,66,0,1,1,132,0c0,35.68,8.14,65.95,15.71,79A2,2,0,0,1,209.71,185Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M221.8,175.94C216.25,166.38,208,139.33,208,104a80,80,0,1,0-160,0c0,35.34-8.26,62.38-13.81,71.94A16,16,0,0,0,48,200H88.81a40,40,0,0,0,78.38,0H208a16,16,0,0,0,13.8-24.06ZM128,216a24,24,0,0,1-22.62-16h45.24A24,24,0,0,1,128,216ZM48,184c7.7-13.24,16-43.92,16-80a64,64,0,1,1,128,0c0,36.05,8.28,66.73,16,80Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M218.35,178C212.58,168,204,140.13,204,104a76,76,0,1,0-152,0c0,36.13-8.59,64-14.36,73.95A12,12,0,0,0,48,196H92.23a36,36,0,0,0,71.54,0H208A12,12,0,0,0,218.35,178ZM128,220a28,28,0,0,1-27.71-24h55.42A28,28,0,0,1,128,220Zm83.45-34a3.91,3.91,0,0,1-3.44,2H48a3.91,3.91,0,0,1-3.44-2,4,4,0,0,1,0-4C52,169.17,60,139.32,60,104a68,68,0,1,1,136,0c0,35.31,8,65.17,15.44,78A4,4,0,0,1,211.45,186Z"
        }))
    ]
]);


const $19062bd64dded0d3$export$2235404cc2cfe93c = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...r,
        weights: (0, $69e3a2c3922c842b$export$2e2bcd8739ae039)
    }));
$19062bd64dded0d3$export$2235404cc2cfe93c.displayName = "BellIcon";
const $19062bd64dded0d3$export$84dc348f90a995ec = $19062bd64dded0d3$export$2235404cc2cfe93c;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $4cce3d1130cf8b91$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M225.29,165.93C216.61,151,212,129.57,212,104a84,84,0,0,0-168,0c0,25.58-4.59,47-13.27,61.93A20.08,20.08,0,0,0,30.66,186,19.77,19.77,0,0,0,48,196H208a19.77,19.77,0,0,0,17.31-10A20.08,20.08,0,0,0,225.29,165.93ZM54.66,172C63.51,154,68,131.14,68,104a60,60,0,0,1,120,0c0,27.13,4.48,50,13.33,68ZM172,224a12,12,0,0,1-12,12H96a12,12,0,0,1,0-24h64A12,12,0,0,1,172,224Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,192H48a8,8,0,0,1-6.88-12C47.71,168.6,56,139.81,56,104a72,72,0,0,1,144,0c0,35.82,8.3,64.6,14.9,76A8,8,0,0,1,208,192Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,224a8,8,0,0,1-8,8H96a8,8,0,1,1,0-16h64A8,8,0,0,1,168,224Zm53.85-32A15.8,15.8,0,0,1,208,200H48a16,16,0,0,1-13.8-24.06C39.75,166.38,48,139.34,48,104a80,80,0,1,1,160,0c0,35.33,8.26,62.38,13.81,71.94A15.89,15.89,0,0,1,221.84,192ZM208,184c-7.73-13.27-16-43.95-16-80a64,64,0,1,0-128,0c0,36.06-8.28,66.74-16,80Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,224a8,8,0,0,1-8,8H96a8,8,0,1,1,0-16h64A8,8,0,0,1,168,224Zm53.81-48.06C216.25,166.38,208,139.33,208,104a80,80,0,1,0-160,0c0,35.34-8.26,62.38-13.81,71.94A16,16,0,0,0,48,200H208a16,16,0,0,0,13.8-24.06Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M166,224a6,6,0,0,1-6,6H96a6,6,0,0,1,0-12h64A6,6,0,0,1,166,224Zm54.11-33a13.83,13.83,0,0,1-12.1,7H48a14,14,0,0,1-12.06-21.06C41.59,167.2,50,139.74,50,104a78,78,0,1,1,156,0c0,35.73,8.42,63.2,14.08,72.94A13.9,13.9,0,0,1,220.11,191Zm-10.41-8C202.13,170,194,139.68,194,104a66,66,0,1,0-132,0c0,35.69-8.14,66-15.71,79a2,2,0,0,0,0,2,1.9,1.9,0,0,0,1.7,1H208a1.9,1.9,0,0,0,1.7-1A2,2,0,0,0,209.7,183Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,224a8,8,0,0,1-8,8H96a8,8,0,1,1,0-16h64A8,8,0,0,1,168,224Zm53.85-32A15.8,15.8,0,0,1,208,200H48a16,16,0,0,1-13.8-24.06C39.75,166.38,48,139.34,48,104a80,80,0,1,1,160,0c0,35.33,8.26,62.38,13.81,71.94A15.89,15.89,0,0,1,221.84,192ZM208,184c-7.73-13.27-16-43.95-16-80a64,64,0,1,0-128,0c0,36.06-8.28,66.74-16,80Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M164,224a4,4,0,0,1-4,4H96a4,4,0,0,1,0-8h64A4,4,0,0,1,164,224Zm54.38-34A11.84,11.84,0,0,1,208,196H48A12,12,0,0,1,37.65,178C43.42,168,52,140.13,52,104a76,76,0,1,1,152,0c0,36.13,8.59,64,14.36,73.95A11.92,11.92,0,0,1,218.38,190Zm-6.95-8C204,169.17,196,139.31,196,104a68,68,0,1,0-136,0c0,35.32-8,65.17-15.44,78a4,4,0,0,0,0,4A3.91,3.91,0,0,0,48,188H208a3.91,3.91,0,0,0,3.44-2A4,4,0,0,0,211.43,182Z"
        }))
    ]
]);


const $59680ec94e4e297e$export$d7b686e8afc4bc7e = $7fPBF.forwardRef((l, m)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: m,
        ...l,
        weights: (0, $4cce3d1130cf8b91$export$2e2bcd8739ae039)
    }));
$59680ec94e4e297e$export$d7b686e8afc4bc7e.displayName = "BellSimpleIcon";
const $59680ec94e4e297e$export$6f47cc5865c763be = $59680ec94e4e297e$export$d7b686e8afc4bc7e;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $6091c3ffa0dc6a23$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M199.2,166.4,148,128l51.2-38.4a12,12,0,0,0,0-19.2l-64-48A12,12,0,0,0,116,32v72L71.2,70.4A12,12,0,0,0,56.8,89.6L108,128,56.8,166.4a12,12,0,1,0,14.4,19.2L116,152v72a12,12,0,0,0,19.2,9.6l64-48a12,12,0,0,0,0-19.2ZM140,56l32,24-32,24Zm0,144V152l32,24Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M192,80l-64,48V32ZM128,224l64-48-64-48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M196.8,169.6,141.33,128,196.8,86.4a8,8,0,0,0,0-12.8l-64-48A8,8,0,0,0,120,32v80L68.8,73.6a8,8,0,0,0-9.6,12.8L114.67,128,59.2,169.6a8,8,0,1,0,9.6,12.8L120,144v80a8,8,0,0,0,12.8,6.4l64-48a8,8,0,0,0,0-12.8ZM136,48l42.67,32L136,112Zm0,160V144l42.67,32Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,176a8,8,0,0,1-3.2,6.4l-64,48A8,8,0,0,1,128,232a8,8,0,0,1-8-8V144L68.8,182.4a8,8,0,0,1-9.6-12.8L114.67,128,59.2,86.4a8,8,0,0,1,9.6-12.8L120,112V32a8,8,0,0,1,12.8-6.4l64,48a8,8,0,0,1,0,12.8L141.33,128l55.47,41.6A8,8,0,0,1,200,176Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M195.6,171.2,138,128l57.6-43.2a6,6,0,0,0,0-9.6l-64-48A6,6,0,0,0,122,32v84L67.6,75.2a6,6,0,0,0-7.2,9.6L118,128,60.4,171.2a6,6,0,1,0,7.2,9.6L122,140v84a6,6,0,0,0,9.6,4.8l64-48a6,6,0,0,0,0-9.6ZM134,44l48,36-48,36Zm0,168V140l48,36Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M196.8,169.6,141.33,128,196.8,86.4a8,8,0,0,0,0-12.8l-64-48A8,8,0,0,0,120,32v80L68.8,73.6a8,8,0,0,0-9.6,12.8L114.67,128,59.2,169.6a8,8,0,1,0,9.6,12.8L120,144v80a8,8,0,0,0,12.8,6.4l64-48a8,8,0,0,0,0-12.8ZM136,48l42.67,32L136,112Zm0,160V144l42.67,32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M194.4,172.8,134.67,128,194.4,83.2a4,4,0,0,0,0-6.4l-64-48A4,4,0,0,0,124,32v88L66.4,76.8a4,4,0,0,0-4.8,6.4L121.33,128,61.6,172.8a4,4,0,0,0,4.8,6.4L124,136v88a4,4,0,0,0,6.4,3.2l64-48a4,4,0,0,0,0-6.4ZM132,40l53.33,40L132,120Zm0,176V136l53.33,40Z"
        }))
    ]
]);


const $0589edc71e767746$export$263c50ea203500d6 = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...e,
        weights: (0, $6091c3ffa0dc6a23$export$2e2bcd8739ae039)
    }));
$0589edc71e767746$export$263c50ea203500d6.displayName = "BluetoothIcon";
const $0589edc71e767746$export$3f015ab66c3e5653 = $0589edc71e767746$export$263c50ea203500d6;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $c277c708123709f8$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,160a12,12,0,0,0,0-24H212V120h12a12,12,0,0,0,0-24H210.45a83.7,83.7,0,0,0-18.78-38.7l16.82-16.81a12,12,0,1,0-17-17l-18,18a83.7,83.7,0,0,0-91.1,0l-18-18a12,12,0,0,0-17,17L64.33,57.3A83.7,83.7,0,0,0,45.55,96H32a12,12,0,0,0,0,24H44v16H32a12,12,0,0,0,0,24H44a83.55,83.55,0,0,0,1.55,16H32a12,12,0,0,0,0,24H54.15a84,84,0,0,0,147.7,0H224a12,12,0,0,0,0-24H210.45A83.55,83.55,0,0,0,212,160ZM128,52a60.1,60.1,0,0,1,57.82,44H70.18A60.1,60.1,0,0,1,128,52Zm12,166.79V148a12,12,0,0,0-24,0v70.79A60.09,60.09,0,0,1,68,160V120H188v40A60.09,60.09,0,0,1,140,218.79Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,112v48a72,72,0,0,1-72,72h0a72,72,0,0,1-72-72V112Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,152h16a8,8,0,0,0,0-16H208V120h16a8,8,0,0,0,0-16H207.6a79.76,79.76,0,0,0-21.44-46.85l19.5-19.49a8,8,0,0,0-11.32-11.32l-20.29,20.3a79.74,79.74,0,0,0-92.1,0L61.66,26.34A8,8,0,0,0,50.34,37.66l19.5,19.49A79.76,79.76,0,0,0,48.4,104H32a8,8,0,0,0,0,16H48v16H32a8,8,0,0,0,0,16H48v8c0,2.7.14,5.37.4,8H32a8,8,0,0,0,0,16H51.68a80,80,0,0,0,152.64,0H224a8,8,0,0,0,0-16H207.6c.26-2.63.4-5.3.4-8ZM128,48a64.07,64.07,0,0,1,63.48,56h-127A64.07,64.07,0,0,1,128,48Zm8,175.48V144a8,8,0,0,0-16,0v79.48A64.07,64.07,0,0,1,64,160V120H192v40A64.07,64.07,0,0,1,136,223.48Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,120H208V104h16a8,8,0,0,1,0,16ZM32,104a8,8,0,0,0,0,16H48V104Zm176,56c0,2.7-.14,5.37-.4,8H224a8,8,0,0,1,0,16H204.32a80,80,0,0,1-152.64,0H32a8,8,0,0,1,0-16H48.4c-.26-2.63-.4-5.3-.4-8v-8H32a8,8,0,0,1,0-16H48V120H208v16h16a8,8,0,0,1,0,16H208Zm-72-16a8,8,0,0,0-16,0v64a8,8,0,0,0,16,0ZM69.84,57.15A79.76,79.76,0,0,0,48.4,104H207.6a79.76,79.76,0,0,0-21.44-46.85l19.5-19.49a8,8,0,0,0-11.32-11.32l-20.29,20.3a79.74,79.74,0,0,0-92.1,0L61.66,26.34A8,8,0,0,0,50.34,37.66Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M206,150h18a6,6,0,0,0,0-12H206V118h18a6,6,0,0,0,0-12H205.75a77.81,77.81,0,0,0-22.38-48.88l20.87-20.88a6,6,0,1,0-8.48-8.48L174.27,49.25a77.8,77.8,0,0,0-92.53,0L60.24,27.76a6,6,0,0,0-8.48,8.48L72.64,57.12A77.76,77.76,0,0,0,50.25,106H32a6,6,0,0,0,0,12H50v20H32a6,6,0,0,0,0,12H50v10a78.6,78.6,0,0,0,.66,10H32a6,6,0,0,0,0,12H53.18a78,78,0,0,0,149.64,0H224a6,6,0,0,0,0-12H205.34a78.6,78.6,0,0,0,.66-10ZM128,46a66.07,66.07,0,0,1,65.71,60H62.29A66.07,66.07,0,0,1,128,46Zm6,179.71V144a6,6,0,0,0-12,0v81.71A66.07,66.07,0,0,1,62,160V118H194v42A66.07,66.07,0,0,1,134,225.71Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,152h16a8,8,0,0,0,0-16H208V120h16a8,8,0,0,0,0-16H207.6a79.76,79.76,0,0,0-21.44-46.85l19.5-19.49a8,8,0,0,0-11.32-11.32l-20.29,20.3a79.74,79.74,0,0,0-92.1,0L61.66,26.34A8,8,0,0,0,50.34,37.66l19.5,19.49A79.76,79.76,0,0,0,48.4,104H32a8,8,0,0,0,0,16H48v16H32a8,8,0,0,0,0,16H48v8c0,2.7.14,5.37.4,8H32a8,8,0,0,0,0,16H51.68a80,80,0,0,0,152.64,0H224a8,8,0,0,0,0-16H207.6c.26-2.63.4-5.3.4-8ZM128,48a64.07,64.07,0,0,1,63.48,56h-127A64.07,64.07,0,0,1,128,48Zm8,175.48V144a8,8,0,0,0-16,0v79.48A64.07,64.07,0,0,1,64,160V120H192v40A64.07,64.07,0,0,1,136,223.48Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M204,148h20a4,4,0,0,0,0-8H204V116h20a4,4,0,0,0,0-8H203.89a75.8,75.8,0,0,0-23.37-50.86l22.31-22.31a4,4,0,1,0-5.66-5.66L174.44,51.9a75.77,75.77,0,0,0-92.88,0L58.83,29.17a4,4,0,0,0-5.66,5.66L75.48,57.14A75.8,75.8,0,0,0,52.11,108H32a4,4,0,0,0,0,8H52v24H32a4,4,0,0,0,0,8H52v12a75.41,75.41,0,0,0,1,12H32a4,4,0,0,0,0,8H54.69a76,76,0,0,0,146.62,0H224a4,4,0,0,0,0-8H203a75.41,75.41,0,0,0,1-12ZM128,44a68.08,68.08,0,0,1,67.87,64H60.13A68.08,68.08,0,0,1,128,44Zm4,183.87V144a4,4,0,0,0-8,0v83.87A68.08,68.08,0,0,1,60,160V116H196v44A68.08,68.08,0,0,1,132,227.87Z"
        }))
    ]
]);


const $c308ce43177e2521$export$3724a79860e51b2a = $7fPBF.forwardRef((t, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...t,
        weights: (0, $c277c708123709f8$export$2e2bcd8739ae039)
    }));
$c308ce43177e2521$export$3724a79860e51b2a.displayName = "BugBeetleIcon";
const $c308ce43177e2521$export$c8b6e8f31cd340e = $c308ce43177e2521$export$3724a79860e51b2a;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $d7bd9c45db31d082$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,28H188V24a12,12,0,0,0-24,0v4H92V24a12,12,0,0,0-24,0v4H48A20,20,0,0,0,28,48V208a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V48A20,20,0,0,0,208,28ZM68,52a12,12,0,0,0,24,0h72a12,12,0,0,0,24,0h16V76H52V52ZM52,204V100H204V204Zm60-80v56a12,12,0,0,1-24,0V143.32a12,12,0,0,1-9.37-22l16-8A12,12,0,0,1,112,124Zm61.49,33.88L163.9,168H168a12,12,0,0,1,0,24H136a12,12,0,0,1-8.71-20.25L155.45,142a4,4,0,0,0,.55-2,4,4,0,0,0-7.47-2,12,12,0,0,1-20.78-12A28,28,0,0,1,180,140a27.77,27.77,0,0,1-5.64,16.86A10.63,10.63,0,0,1,173.49,157.88Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,48V88H40V48a8,8,0,0,1,8-8H208A8,8,0,0,1,216,48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-96-88v64a8,8,0,0,1-16,0V132.94l-4.42,2.22a8,8,0,0,1-7.16-14.32l16-8A8,8,0,0,1,112,120Zm59.16,30.45L152,176h16a8,8,0,0,1,0,16H136a8,8,0,0,1-6.4-12.8l28.78-38.37A8,8,0,1,0,145.07,132a8,8,0,1,1-13.85-8A24,24,0,0,1,176,136,23.76,23.76,0,0,1,171.16,150.45Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM112,184a8,8,0,0,1-16,0V132.94l-4.42,2.22a8,8,0,0,1-7.16-14.32l16-8A8,8,0,0,1,112,120Zm56-8a8,8,0,0,1,0,16H136a8,8,0,0,1-6.4-12.8l28.78-38.37A8,8,0,1,0,145.07,132a8,8,0,1,1-13.85-8A24,24,0,0,1,176,136a23.76,23.76,0,0,1-4.84,14.45L152,176ZM48,80V48H72v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,34H182V24a6,6,0,0,0-12,0V34H86V24a6,6,0,0,0-12,0V34H48A14,14,0,0,0,34,48V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V48A14,14,0,0,0,208,34ZM48,46H74V56a6,6,0,0,0,12,0V46h84V56a6,6,0,0,0,12,0V46h26a2,2,0,0,1,2,2V82H46V48A2,2,0,0,1,48,46ZM208,210H48a2,2,0,0,1-2-2V94H210V208A2,2,0,0,1,208,210Zm-98-90v64a6,6,0,0,1-12,0V129.71l-7.32,3.66a6,6,0,1,1-5.36-10.74l16-8A6,6,0,0,1,110,120Zm59.57,29.25L148,178h20a6,6,0,0,1,0,12H136a6,6,0,0,1-4.8-9.6L160,142a10,10,0,1,0-16.65-11A6,6,0,1,1,133,125a22,22,0,1,1,36.62,24.26Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-96-88v64a8,8,0,0,1-16,0V132.94l-4.42,2.22a8,8,0,0,1-7.16-14.32l16-8A8,8,0,0,1,112,120Zm59.16,30.45L152,176h16a8,8,0,0,1,0,16H136a8,8,0,0,1-6.4-12.8l28.78-38.37A8,8,0,1,0,145.07,132a8,8,0,1,1-13.85-8A24,24,0,0,1,176,136,23.76,23.76,0,0,1,171.16,150.45Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,36H180V24a4,4,0,0,0-8,0V36H84V24a4,4,0,0,0-8,0V36H48A12,12,0,0,0,36,48V208a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V48A12,12,0,0,0,208,36ZM48,44H76V56a4,4,0,0,0,8,0V44h88V56a4,4,0,0,0,8,0V44h28a4,4,0,0,1,4,4V84H44V48A4,4,0,0,1,48,44ZM208,212H48a4,4,0,0,1-4-4V92H212V208A4,4,0,0,1,208,212ZM108,120v64a4,4,0,0,1-8,0V126.47l-10.21,5.11a4,4,0,0,1-3.58-7.16l16-8A4,4,0,0,1,108,120Zm60,28-24,32h24a4,4,0,0,1,0,8H136a4,4,0,0,1-3.2-6.4l28.78-38.37A11.88,11.88,0,0,0,164,136a12,12,0,0,0-22.4-6,4,4,0,0,1-6.92-4A20,20,0,0,1,172,136,19.79,19.79,0,0,1,168,148Z"
        }))
    ]
]);


const $8abaaeeab67664a2$export$5fda1783bb83f57b = $7fPBF.forwardRef((o, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...o,
        weights: (0, $d7bd9c45db31d082$export$2e2bcd8739ae039)
    }));
$8abaaeeab67664a2$export$5fda1783bb83f57b.displayName = "CalendarIcon";
const $8abaaeeab67664a2$export$e1aef45b828286de = $8abaaeeab67664a2$export$5fda1783bb83f57b;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $0e126998741e0efb$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,52H182.42L170,33.34A12,12,0,0,0,160,28H96a12,12,0,0,0-10,5.34L73.57,52H48A28,28,0,0,0,20,80V192a28,28,0,0,0,28,28H208a28,28,0,0,0,28-28V80A28,28,0,0,0,208,52Zm4,140a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V80a4,4,0,0,1,4-4H80a12,12,0,0,0,10-5.34L102.42,52h51.15L166,70.66A12,12,0,0,0,176,76h32a4,4,0,0,1,4,4Zm-32-92v20a12,12,0,0,1-12,12H148a12,12,0,0,1-7.76-21.14,28.07,28.07,0,0,0-29,2.73A12,12,0,0,1,96.79,94.4a52.28,52.28,0,0,1,61.14-.91A12,12,0,0,1,180,100Zm-18.41,52.8a12,12,0,0,1-2.38,16.8,51.71,51.71,0,0,1-31.13,10.34,52.3,52.3,0,0,1-30-9.44A12,12,0,0,1,76,164V144a12,12,0,0,1,12-12h20a12,12,0,0,1,7.76,21.14,28.07,28.07,0,0,0,29-2.73A12,12,0,0,1,161.59,152.8Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,80V192a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H80L96,40h64l16,24h32A16,16,0,0,1,224,80Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,56H180.28L166.65,35.56A8,8,0,0,0,160,32H96a8,8,0,0,0-6.65,3.56L75.71,56H48A24,24,0,0,0,24,80V192a24,24,0,0,0,24,24H208a24,24,0,0,0,24-24V80A24,24,0,0,0,208,56Zm8,136a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8H80a8,8,0,0,0,6.66-3.56L100.28,48h55.43l13.63,20.44A8,8,0,0,0,176,72h32a8,8,0,0,1,8,8ZM176,96v24a8,8,0,0,1-8,8H144a8,8,0,0,1,0-16h5.15a32.12,32.12,0,0,0-40.34-1.61A8,8,0,0,1,99.19,97.6,48.21,48.21,0,0,1,160,100.23V96a8,8,0,0,1,16,0Zm-17.61,59.2a8,8,0,0,1-1.58,11.2A48.21,48.21,0,0,1,96,163.77V168a8,8,0,0,1-16,0V144a8,8,0,0,1,8-8h24a8,8,0,0,1,0,16h-5.15a32.12,32.12,0,0,0,40.34,1.61A8,8,0,0,1,158.39,155.2Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,56H180.28L166.65,35.56A8,8,0,0,0,160,32H96a8,8,0,0,0-6.65,3.56L75.71,56H48A24,24,0,0,0,24,80V192a24,24,0,0,0,24,24H208a24,24,0,0,0,24-24V80A24,24,0,0,0,208,56ZM156.81,166.4A48.21,48.21,0,0,1,96,163.77V168a8,8,0,0,1-16,0V144a8,8,0,0,1,8-8h24a8,8,0,0,1,0,16h-5.15a32.12,32.12,0,0,0,40.34,1.61,8,8,0,0,1,9.62,12.79ZM176,120a8,8,0,0,1-8,8H144a8,8,0,0,1,0-16h5.15a32.12,32.12,0,0,0-40.34-1.61A8,8,0,0,1,99.19,97.6,48.21,48.21,0,0,1,160,100.23V96a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,58H179.21L165,36.67A6,6,0,0,0,160,34H96a6,6,0,0,0-5,2.67L76.78,58H48A22,22,0,0,0,26,80V192a22,22,0,0,0,22,22H208a22,22,0,0,0,22-22V80A22,22,0,0,0,208,58Zm10,134a10,10,0,0,1-10,10H48a10,10,0,0,1-10-10V80A10,10,0,0,1,48,70H80a6,6,0,0,0,5-2.67L99.21,46h57.57L171,67.33A6,6,0,0,0,176,70h32a10,10,0,0,1,10,10ZM174,96v24a6,6,0,0,1-6,6H144a6,6,0,0,1,0-12h10l-2-2.09a34.12,34.12,0,0,0-44.38-3.12,6,6,0,1,1-7.22-9.59,46.2,46.2,0,0,1,60.14,4.27.47.47,0,0,0,.1.1L162,105V96a6,6,0,0,1,12,0Zm-17.2,60.4a6,6,0,0,1-1.19,8.4,46.18,46.18,0,0,1-60.14-4.27l-.1-.1L94,159v9a6,6,0,0,1-12,0V144a6,6,0,0,1,6-6h24a6,6,0,0,1,0,12H102l2,2.09a34.12,34.12,0,0,0,44.38,3.12A6,6,0,0,1,156.8,156.4Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,56H180.28L166.65,35.56A8,8,0,0,0,160,32H96a8,8,0,0,0-6.65,3.56L75.71,56H48A24,24,0,0,0,24,80V192a24,24,0,0,0,24,24H208a24,24,0,0,0,24-24V80A24,24,0,0,0,208,56Zm8,136a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8H80a8,8,0,0,0,6.66-3.56L100.28,48h55.43l13.63,20.44A8,8,0,0,0,176,72h32a8,8,0,0,1,8,8ZM176,96v24a8,8,0,0,1-8,8H144a8,8,0,0,1,0-16h5.15a32.12,32.12,0,0,0-40.34-1.61A8,8,0,0,1,99.19,97.6,48.21,48.21,0,0,1,160,100.23V96a8,8,0,0,1,16,0Zm-17.61,59.2a8,8,0,0,1-1.58,11.2A48.21,48.21,0,0,1,96,163.77V168a8,8,0,0,1-16,0V144a8,8,0,0,1,8-8h24a8,8,0,0,1,0,16h-5.15a32.12,32.12,0,0,0,40.34,1.61A8,8,0,0,1,158.39,155.2Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,60H178.13L163.32,37.78A4,4,0,0,0,160,36H96a4,4,0,0,0-3.32,1.78L77.85,60H48A20,20,0,0,0,28,80V192a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V80A20,20,0,0,0,208,60Zm12,132a12,12,0,0,1-12,12H48a12,12,0,0,1-12-12V80A12,12,0,0,1,48,68H80a4,4,0,0,0,3.33-1.78L98.13,44h59.72l14.82,22.22A4,4,0,0,0,176,68h32a12,12,0,0,1,12,12ZM172,96v24a4,4,0,0,1-4,4H144a4,4,0,0,1,0-8h14.66l-5.27-5.52a36.12,36.12,0,0,0-47-3.29,4,4,0,1,1-4.8-6.39,44.17,44.17,0,0,1,57.51,4.09L164,110V96a4,4,0,0,1,8,0Zm-16.8,61.6a4,4,0,0,1-.8,5.6,44.15,44.15,0,0,1-57.51-4.09L92,154v14a4,4,0,0,1-8,0V144a4,4,0,0,1,4-4h24a4,4,0,0,1,0,8H97.34l5.27,5.52a36.12,36.12,0,0,0,47,3.29A4,4,0,0,1,155.2,157.6Z"
        }))
    ]
]);


const $940356a37dfbb440$export$7b925291abba066b = $7fPBF.forwardRef((o, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...o,
        weights: (0, $0e126998741e0efb$export$2e2bcd8739ae039)
    }));
$940356a37dfbb440$export$7b925291abba066b.displayName = "CameraRotateIcon";
const $940356a37dfbb440$export$4bbb8c37660b6717 = $940356a37dfbb440$export$7b925291abba066b;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $2643605d26f5be01$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,96H48a20,20,0,0,0-20,20v84a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V116A20,20,0,0,0,208,96Zm-4,100H52V120H204ZM44,68A12,12,0,0,1,56,56H200a12,12,0,0,1,0,24H56A12,12,0,0,1,44,68ZM60,28A12,12,0,0,1,72,16H184a12,12,0,0,1,0,24H72A12,12,0,0,1,60,28Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,104v96a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H208A8,8,0,0,1,216,104Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,88H48a16,16,0,0,0-16,16v96a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V104A16,16,0,0,0,208,88Zm0,112H48V104H208v96ZM48,64a8,8,0,0,1,8-8H200a8,8,0,0,1,0,16H56A8,8,0,0,1,48,64ZM64,32a8,8,0,0,1,8-8H184a8,8,0,0,1,0,16H72A8,8,0,0,1,64,32Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,104v96a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V104A16,16,0,0,1,48,88H208A16,16,0,0,1,224,104ZM56,72H200a8,8,0,0,0,0-16H56a8,8,0,0,0,0,16ZM72,40H184a8,8,0,0,0,0-16H72a8,8,0,0,0,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,90H48a14,14,0,0,0-14,14v96a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V104A14,14,0,0,0,208,90Zm2,110a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V104a2,2,0,0,1,2-2H208a2,2,0,0,1,2,2ZM50,64a6,6,0,0,1,6-6H200a6,6,0,0,1,0,12H56A6,6,0,0,1,50,64ZM66,32a6,6,0,0,1,6-6H184a6,6,0,0,1,0,12H72A6,6,0,0,1,66,32Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,88H48a16,16,0,0,0-16,16v96a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V104A16,16,0,0,0,208,88Zm0,112H48V104H208v96ZM48,64a8,8,0,0,1,8-8H200a8,8,0,0,1,0,16H56A8,8,0,0,1,48,64ZM64,32a8,8,0,0,1,8-8H184a8,8,0,0,1,0,16H72A8,8,0,0,1,64,32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,92H48a12,12,0,0,0-12,12v96a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V104A12,12,0,0,0,208,92Zm4,108a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V104a4,4,0,0,1,4-4H208a4,4,0,0,1,4,4ZM52,64a4,4,0,0,1,4-4H200a4,4,0,0,1,0,8H56A4,4,0,0,1,52,64ZM68,32a4,4,0,0,1,4-4H184a4,4,0,0,1,0,8H72A4,4,0,0,1,68,32Z"
        }))
    ]
]);


const $bbcdd9ecba689979$export$2bc1d0180119f574 = $7fPBF.forwardRef((o, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: a,
        ...o,
        weights: (0, $2643605d26f5be01$export$2e2bcd8739ae039)
    }));
$bbcdd9ecba689979$export$2bc1d0180119f574.displayName = "CardsThreeIcon";
const $bbcdd9ecba689979$export$13d1513b60ca1919 = $bbcdd9ecba689979$export$2bc1d0180119f574;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $43b3b75f290c6bfc$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216.49,104.49l-80,80a12,12,0,0,1-17,0l-80-80a12,12,0,0,1,17-17L128,159l71.51-71.52a12,12,0,0,1,17,17Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,96l-80,80L48,96Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M215.39,92.94A8,8,0,0,0,208,88H48a8,8,0,0,0-5.66,13.66l80,80a8,8,0,0,0,11.32,0l80-80A8,8,0,0,0,215.39,92.94ZM128,164.69,67.31,104H188.69Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,48,88H208a8,8,0,0,1,5.66,13.66Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M212.24,100.24l-80,80a6,6,0,0,1-8.48,0l-80-80a6,6,0,0,1,8.48-8.48L128,167.51l75.76-75.75a6,6,0,0,1,8.48,8.48Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M210.83,98.83l-80,80a4,4,0,0,1-5.66,0l-80-80a4,4,0,0,1,5.66-5.66L128,170.34l77.17-77.17a4,4,0,1,1,5.66,5.66Z"
        }))
    ]
]);


const $8d78174bfef35f91$export$73a4c78a4a00962 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...r,
        weights: (0, $43b3b75f290c6bfc$export$2e2bcd8739ae039)
    }));
$8d78174bfef35f91$export$73a4c78a4a00962.displayName = "CaretDownIcon";
const $8d78174bfef35f91$export$14643e45770079c3 = $8d78174bfef35f91$export$73a4c78a4a00962;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $90708e3e8c4a10f7$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168.49,199.51a12,12,0,0,1-17,17l-80-80a12,12,0,0,1,0-17l80-80a12,12,0,0,1,17,17L97,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M160,48V208L80,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M163.06,40.61a8,8,0,0,0-8.72,1.73l-80,80a8,8,0,0,0,0,11.32l80,80A8,8,0,0,0,168,208V48A8,8,0,0,0,163.06,40.61ZM152,188.69,91.31,128,152,67.31Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,48V208a8,8,0,0,1-13.66,5.66l-80-80a8,8,0,0,1,0-11.32l80-80A8,8,0,0,1,168,48Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M164.24,203.76a6,6,0,1,1-8.48,8.48l-80-80a6,6,0,0,1,0-8.48l80-80a6,6,0,0,1,8.48,8.48L88.49,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M162.83,205.17a4,4,0,0,1-5.66,5.66l-80-80a4,4,0,0,1,0-5.66l80-80a4,4,0,1,1,5.66,5.66L85.66,128Z"
        }))
    ]
]);


const $2fa01b25bab55864$export$810196a5854768f3 = $7fPBF.forwardRef((o, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...o,
        weights: (0, $90708e3e8c4a10f7$export$2e2bcd8739ae039)
    }));
$2fa01b25bab55864$export$810196a5854768f3.displayName = "CaretLeftIcon";
const $2fa01b25bab55864$export$9de62fa342934f27 = $2fa01b25bab55864$export$810196a5854768f3;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $749a178e5963403e$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M152.49,119.51a12,12,0,0,1,0,17l-80,80a12,12,0,0,1-17-17L127,128,55.51,56.49a12,12,0,0,1,17-17ZM184,36a12,12,0,0,0-12,12V208a12,12,0,0,0,24,0V48A12,12,0,0,0,184,36Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,128,64,208V48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M69.66,42.34A8,8,0,0,0,56,48V208a8,8,0,0,0,13.66,5.66l80-80a8,8,0,0,0,0-11.32ZM72,188.69V67.31L132.69,128ZM192,48V208a8,8,0,0,1-16,0V48a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M149.66,122.34a8,8,0,0,1,0,11.32l-80,80A8,8,0,0,1,56,208V48a8,8,0,0,1,13.66-5.66ZM184,40a8,8,0,0,0-8,8V208a8,8,0,0,0,16,0V48A8,8,0,0,0,184,40Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M148.24,123.76a6,6,0,0,1,0,8.48l-80,80a6,6,0,0,1-8.48-8.48L135.51,128,59.76,52.24a6,6,0,0,1,8.48-8.48ZM184,42a6,6,0,0,0-6,6V208a6,6,0,0,0,12,0V48A6,6,0,0,0,184,42Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M149.66,122.34a8,8,0,0,1,0,11.32l-80,80a8,8,0,0,1-11.32-11.32L132.69,128,58.34,53.66A8,8,0,0,1,69.66,42.34ZM184,40a8,8,0,0,0-8,8V208a8,8,0,0,0,16,0V48A8,8,0,0,0,184,40Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M146.83,125.17a4,4,0,0,1,0,5.66l-80,80a4,4,0,0,1-5.66-5.66L138.34,128,61.17,50.83a4,4,0,0,1,5.66-5.66ZM184,44a4,4,0,0,0-4,4V208a4,4,0,0,0,8,0V48A4,4,0,0,0,184,44Z"
        }))
    ]
]);


const $26629d2c54ba0e90$export$2e28bad6de91f83d = $7fPBF.forwardRef((o, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...o,
        weights: (0, $749a178e5963403e$export$2e2bcd8739ae039)
    }));
$26629d2c54ba0e90$export$2e28bad6de91f83d.displayName = "CaretLineRightIcon";
const $26629d2c54ba0e90$export$ca4804c692a5f0a5 = $26629d2c54ba0e90$export$2e28bad6de91f83d;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $6d3de71f942312b8$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184.49,136.49l-80,80a12,12,0,0,1-17-17L159,128,87.51,56.49a12,12,0,1,1,17-17l80,80A12,12,0,0,1,184.49,136.49Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,128,96,208V48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M181.66,122.34l-80-80A8,8,0,0,0,88,48V208a8,8,0,0,0,13.66,5.66l80-80A8,8,0,0,0,181.66,122.34ZM104,188.69V67.31L164.69,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M181.66,133.66l-80,80A8,8,0,0,1,88,208V48a8,8,0,0,1,13.66-5.66l80,80A8,8,0,0,1,181.66,133.66Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M180.24,132.24l-80,80a6,6,0,0,1-8.48-8.48L167.51,128,91.76,52.24a6,6,0,0,1,8.48-8.48l80,80A6,6,0,0,1,180.24,132.24Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M178.83,130.83l-80,80a4,4,0,0,1-5.66-5.66L170.34,128,93.17,50.83a4,4,0,0,1,5.66-5.66l80,80A4,4,0,0,1,178.83,130.83Z"
        }))
    ]
]);


const $cf227e7e52862ade$export$5e4a7579d3e78657 = $7fPBF.forwardRef((o, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...o,
        weights: (0, $6d3de71f942312b8$export$2e2bcd8739ae039)
    }));
$cf227e7e52862ade$export$5e4a7579d3e78657.displayName = "CaretRightIcon";
const $cf227e7e52862ade$export$98ac0f496a0846de = $cf227e7e52862ade$export$5e4a7579d3e78657;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $71bf1e9ef2637518$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216.49,168.49a12,12,0,0,1-17,0L128,97,56.49,168.49a12,12,0,0,1-17-17l80-80a12,12,0,0,1,17,0l80,80A12,12,0,0,1,216.49,168.49Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,160H48l80-80Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,154.34l-80-80a8,8,0,0,0-11.32,0l-80,80A8,8,0,0,0,48,168H208a8,8,0,0,0,5.66-13.66ZM67.31,152,128,91.31,188.69,152Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M215.39,163.06A8,8,0,0,1,208,168H48a8,8,0,0,1-5.66-13.66l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,215.39,163.06Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M212.24,164.24a6,6,0,0,1-8.48,0L128,88.49,52.24,164.24a6,6,0,0,1-8.48-8.48l80-80a6,6,0,0,1,8.48,0l80,80A6,6,0,0,1,212.24,164.24Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,165.66a8,8,0,0,1-11.32,0L128,91.31,53.66,165.66a8,8,0,0,1-11.32-11.32l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,213.66,165.66Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M210.83,162.83a4,4,0,0,1-5.66,0L128,85.66,50.83,162.83a4,4,0,0,1-5.66-5.66l80-80a4,4,0,0,1,5.66,0l80,80A4,4,0,0,1,210.83,162.83Z"
        }))
    ]
]);


const $f193c00afed960f7$export$7d1b8b90f61377d1 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...r,
        weights: (0, $71bf1e9ef2637518$export$2e2bcd8739ae039)
    }));
$f193c00afed960f7$export$7d1b8b90f61377d1.displayName = "CaretUpIcon";
const $f193c00afed960f7$export$b67edd7bdacb81b5 = $f193c00afed960f7$export$7d1b8b90f61377d1;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $cb65ce36cf0f87ae$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,196h-4V40a12,12,0,0,0-12-12H152a12,12,0,0,0-12,12V76H96A12,12,0,0,0,84,88v36H48a12,12,0,0,0-12,12v60H32a12,12,0,0,0,0,24H224a12,12,0,0,0,0-24ZM164,52h32V196H164Zm-56,48h32v96H108ZM60,148H84v48H60Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,40V208H152V40Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,200h-8V40a8,8,0,0,0-8-8H152a8,8,0,0,0-8,8V80H96a8,8,0,0,0-8,8v40H48a8,8,0,0,0-8,8v64H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16ZM160,48h40V200H160ZM104,96h40V200H104ZM56,144H88v56H56Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,208a8,8,0,0,1-8,8H32a8,8,0,0,1,0-16h8V136a8,8,0,0,1,8-8H72a8,8,0,0,1,8,8v64H96V88a8,8,0,0,1,8-8h32a8,8,0,0,1,8,8V200h16V40a8,8,0,0,1,8-8h40a8,8,0,0,1,8,8V200h8A8,8,0,0,1,232,208Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,202H214V40a6,6,0,0,0-6-6H152a6,6,0,0,0-6,6V82H96a6,6,0,0,0-6,6v42H48a6,6,0,0,0-6,6v66H32a6,6,0,0,0,0,12H224a6,6,0,0,0,0-12ZM158,46h44V202H158ZM102,94h44V202H102ZM54,142H90v60H54Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,200h-8V40a8,8,0,0,0-8-8H152a8,8,0,0,0-8,8V80H96a8,8,0,0,0-8,8v40H48a8,8,0,0,0-8,8v64H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16ZM160,48h40V200H160ZM104,96h40V200H104ZM56,144H88v56H56Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,204H212V40a4,4,0,0,0-4-4H152a4,4,0,0,0-4,4V84H96a4,4,0,0,0-4,4v44H48a4,4,0,0,0-4,4v68H32a4,4,0,0,0,0,8H224a4,4,0,0,0,0-8ZM156,44h48V204H156ZM100,92h48V204H100ZM52,140H92v64H52Z"
        }))
    ]
]);


const $352ea393a631b359$export$9da4f9d7ed027300 = $7fPBF.forwardRef((o, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...o,
        weights: (0, $cb65ce36cf0f87ae$export$2e2bcd8739ae039)
    }));
$352ea393a631b359$export$9da4f9d7ed027300.displayName = "ChartBarIcon";
const $352ea393a631b359$export$315c6d0a25056c5d = $352ea393a631b359$export$9da4f9d7ed027300;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $09c48903b64b5253$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,20A108,108,0,0,0,31.85,177.23L21,209.66A20,20,0,0,0,46.34,235l32.43-10.81A108,108,0,1,0,128,20Zm0,192a84,84,0,0,1-42.06-11.27,12,12,0,0,0-6-1.62,12.1,12.1,0,0,0-3.8.62l-29.79,9.93,9.93-29.79a12,12,0,0,0-1-9.81A84,84,0,1,1,128,212Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128A96,96,0,0,1,79.93,211.11h0L42.54,223.58a8,8,0,0,1-10.12-10.12l12.47-37.39h0A96,96,0,1,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,0,0,36.18,176.88L24.83,210.93a16,16,0,0,0,20.24,20.24l34.05-11.35A104,104,0,1,0,128,24Zm0,192a87.87,87.87,0,0,1-44.06-11.81,8,8,0,0,0-6.54-.67L40,216,52.47,178.6a8,8,0,0,0-.66-6.54A88,88,0,1,1,128,216Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,128A104,104,0,0,1,79.12,219.82L45.07,231.17a16,16,0,0,1-20.24-20.24l11.35-34.05A104,104,0,1,1,232,128Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,26A102,102,0,0,0,38.35,176.69L26.73,211.56a14,14,0,0,0,17.71,17.71l34.87-11.62A102,102,0,1,0,128,26Zm0,192a90,90,0,0,1-45.06-12.08,6.09,6.09,0,0,0-3-.81,6.2,6.2,0,0,0-1.9.31L40.65,217.88a2,2,0,0,1-2.53-2.53L50.58,178a6,6,0,0,0-.5-4.91A90,90,0,1,1,128,218Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,0,0,36.18,176.88L24.83,210.93a16,16,0,0,0,20.24,20.24l34.05-11.35A104,104,0,1,0,128,24Zm0,192a87.87,87.87,0,0,1-44.06-11.81,8,8,0,0,0-6.54-.67L40,216,52.47,178.6a8,8,0,0,0-.66-6.54A88,88,0,1,1,128,216Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,28A100,100,0,0,0,40.53,176.5l-11.9,35.69a12,12,0,0,0,15.18,15.18l35.69-11.9A100,100,0,1,0,128,28Zm0,192a92,92,0,0,1-46.07-12.35,4.05,4.05,0,0,0-2-.54,3.93,3.93,0,0,0-1.27.21L41.28,219.78a4,4,0,0,1-5.06-5.06l12.46-37.38a4,4,0,0,0-.33-3.27A92,92,0,1,1,128,220Z"
        }))
    ]
]);


const $ffea4d92108488a3$export$9a3f119425fb8c38 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...r,
        weights: (0, $09c48903b64b5253$export$2e2bcd8739ae039)
    }));
$ffea4d92108488a3$export$9a3f119425fb8c38.displayName = "ChatCircleIcon";
const $ffea4d92108488a3$export$462e72eb5fb8428c = $ffea4d92108488a3$export$9a3f119425fb8c38;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $510bd3db97d89352$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M88,128a16,16,0,1,1,16,16A16,16,0,0,1,88,128Zm64,16a16,16,0,1,0-16-16A16,16,0,0,0,152,144Zm84-80V192a20,20,0,0,1-20,20H84.47L53,239.17l-.12.11A19.91,19.91,0,0,1,40.05,244a20.14,20.14,0,0,1-8.49-1.9A19.82,19.82,0,0,1,20,224V64A20,20,0,0,1,40,44H216A20,20,0,0,1,236,64Zm-24,4H44V215.23l28.16-24.32A11.93,11.93,0,0,1,80,188H212Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,64V192a8,8,0,0,1-8,8H80L45.15,230.11A8,8,0,0,1,32,224V64a8,8,0,0,1,8-8H216A8,8,0,0,1,224,64Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M116,128a12,12,0,1,1,12,12A12,12,0,0,1,116,128ZM84,140a12,12,0,1,0-12-12A12,12,0,0,0,84,140Zm88,0a12,12,0,1,0-12-12A12,12,0,0,0,172,140Zm60-76V192a16,16,0,0,1-16,16H83l-32.6,28.16-.09.07A15.89,15.89,0,0,1,40,240a16.13,16.13,0,0,1-6.8-1.52A15.85,15.85,0,0,1,24,224V64A16,16,0,0,1,40,48H216A16,16,0,0,1,232,64ZM40,224h0ZM216,64H40V224l34.77-30A8,8,0,0,1,80,192H216Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,48H40A16,16,0,0,0,24,64V224a15.84,15.84,0,0,0,9.25,14.5A16.05,16.05,0,0,0,40,240a15.89,15.89,0,0,0,10.25-3.78l.09-.07L83,208H216a16,16,0,0,0,16-16V64A16,16,0,0,0,216,48ZM84,140a12,12,0,1,1,12-12A12,12,0,0,1,84,140Zm44,0a12,12,0,1,1,12-12A12,12,0,0,1,128,140Zm44,0a12,12,0,1,1,12-12A12,12,0,0,1,172,140Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M138,128a10,10,0,1,1-10-10A10,10,0,0,1,138,128ZM84,118a10,10,0,1,0,10,10A10,10,0,0,0,84,118Zm88,0a10,10,0,1,0,10,10A10,10,0,0,0,172,118Zm58-54V192a14,14,0,0,1-14,14H82.23L49.07,234.64l-.06.05A13.87,13.87,0,0,1,40,238a14.11,14.11,0,0,1-5.95-1.33A13.88,13.88,0,0,1,26,224V64A14,14,0,0,1,40,50H216A14,14,0,0,1,230,64Zm-12,0a2,2,0,0,0-2-2H40a2,2,0,0,0-2,2V224a2,2,0,0,0,3.26,1.55l34.82-30.08A6,6,0,0,1,80,194H216a2,2,0,0,0,2-2Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M116,128a12,12,0,1,1,12,12A12,12,0,0,1,116,128ZM84,140a12,12,0,1,0-12-12A12,12,0,0,0,84,140Zm88,0a12,12,0,1,0-12-12A12,12,0,0,0,172,140Zm60-76V192a16,16,0,0,1-16,16H83l-32.6,28.16-.09.07A15.89,15.89,0,0,1,40,240a16.13,16.13,0,0,1-6.8-1.52A15.85,15.85,0,0,1,24,224V64A16,16,0,0,1,40,48H216A16,16,0,0,1,232,64ZM40,224h0ZM216,64H40V224l34.77-30A8,8,0,0,1,80,192H216Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M136,128a8,8,0,1,1-8-8A8,8,0,0,1,136,128Zm-52-8a8,8,0,1,0,8,8A8,8,0,0,0,84,120Zm88,0a8,8,0,1,0,8,8A8,8,0,0,0,172,120Zm56-56V192a12,12,0,0,1-12,12H81.49L47.76,233.13l0,0A11.89,11.89,0,0,1,40,236a12.17,12.17,0,0,1-5.1-1.14A11.89,11.89,0,0,1,28,224V64A12,12,0,0,1,40,52H216A12,12,0,0,1,228,64Zm-8,0a4,4,0,0,0-4-4H40a4,4,0,0,0-4,4V224a4,4,0,0,0,6.56,3.08L77.38,197A4,4,0,0,1,80,196H216a4,4,0,0,0,4-4Z"
        }))
    ]
]);


const $32c43b5d35c7f6a5$export$2aab0b35a50deea3 = $7fPBF.forwardRef((a, e)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: e,
        ...a,
        weights: (0, $510bd3db97d89352$export$2e2bcd8739ae039)
    }));
$32c43b5d35c7f6a5$export$2aab0b35a50deea3.displayName = "ChatDotsIcon";
const $32c43b5d35c7f6a5$export$bf6e891555e140d1 = $32c43b5d35c7f6a5$export$2aab0b35a50deea3;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $3b183db6a49d61ab$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M236.34,187.09A84,84,0,0,0,172.29,68.9,84,84,0,0,0,19.66,139.09l-6.84,23.26a20,20,0,0,0,24.83,24.83l23.26-6.84a83.94,83.94,0,0,0,22.76,6.74,84.06,84.06,0,0,0,111.42,41.26l23.26,6.84a20,20,0,0,0,24.83-24.83ZM62,155.5a11.88,11.88,0,0,0-3.39.49l-20.72,6.09L44,141.35a12,12,0,0,0-.93-9A60,60,0,1,1,67.7,156.92,12,12,0,0,0,62,155.5Zm150.89,24.8a12,12,0,0,0-.93,9l6.09,20.73L197.36,204a12,12,0,0,0-9.06.93A60,60,0,0,1,111,186.63a83.93,83.93,0,0,0,68.55-91.37,60,60,0,0,1,33.38,85Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M231.66,213.73a8,8,0,0,1-9.93,9.93L194,215.5A72.05,72.05,0,0,1,92.06,175.89h0c1.31.07,2.62.11,3.94.11a72,72,0,0,0,67.93-95.88h0A72,72,0,0,1,223.5,186Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232.07,186.76a80,80,0,0,0-62.5-114.17A80,80,0,1,0,23.93,138.76l-7.27,24.71a16,16,0,0,0,19.87,19.87l24.71-7.27a80.39,80.39,0,0,0,25.18,7.35,80,80,0,0,0,108.34,40.65l24.71,7.27a16,16,0,0,0,19.87-19.86ZM62,159.5a8.28,8.28,0,0,0-2.26.32L32,168l8.17-27.76a8,8,0,0,0-.63-6,64,64,0,1,1,26.26,26.26A8,8,0,0,0,62,159.5Zm153.79,28.73L224,216l-27.76-8.17a8,8,0,0,0-6,.63,64.05,64.05,0,0,1-85.87-24.88A79.93,79.93,0,0,0,174.7,89.71a64,64,0,0,1,41.75,92.48A8,8,0,0,0,215.82,188.23Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232.07,186.76a80,80,0,0,0-62.5-114.17A80,80,0,1,0,23.93,138.76l-7.27,24.71a16,16,0,0,0,19.87,19.87l24.71-7.27a80.39,80.39,0,0,0,25.18,7.35,80,80,0,0,0,108.34,40.65l24.71,7.27a16,16,0,0,0,19.87-19.86Zm-16.25,1.47L224,216l-27.76-8.17a8,8,0,0,0-6,.63,64.05,64.05,0,0,1-85.87-24.88A79.93,79.93,0,0,0,174.7,89.71a64,64,0,0,1,41.75,92.48A8,8,0,0,0,215.82,188.23Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M229.93,186.58A78,78,0,0,0,168.16,74.42,78,78,0,1,0,26.07,138.58L18.58,164A14,14,0,0,0,36,181.42l25.46-7.49a78,78,0,0,0,26.39,7.63,78,78,0,0,0,106.77,40.37L220,229.42A14,14,0,0,0,237.42,212ZM62,161.5a6.05,6.05,0,0,0-1.69.24l-27.77,8.17a2,2,0,0,1-2.48-2.48l8.17-27.77a6.05,6.05,0,0,0-.47-4.53,66,66,0,1,1,27.08,27.08A6,6,0,0,0,62,161.5Zm155.71,26.16,8.17,27.77a2,2,0,0,1-2.48,2.48l-27.77-8.17a6.06,6.06,0,0,0-4.53.47,66,66,0,0,1-90-28.4,77.92,77.92,0,0,0,71-94.68,66,66,0,0,1,46.07,96A6.05,6.05,0,0,0,217.74,187.66Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232.07,186.76a80,80,0,0,0-62.5-114.17A80,80,0,1,0,23.93,138.76l-7.27,24.71a16,16,0,0,0,19.87,19.87l24.71-7.27a80.39,80.39,0,0,0,25.18,7.35,80,80,0,0,0,108.34,40.65l24.71,7.27a16,16,0,0,0,19.87-19.86ZM62,159.5a8.28,8.28,0,0,0-2.26.32L32,168l8.17-27.76a8,8,0,0,0-.63-6,64,64,0,1,1,26.26,26.26A8,8,0,0,0,62,159.5Zm153.79,28.73L224,216l-27.76-8.17a8,8,0,0,0-6,.63,64.05,64.05,0,0,1-85.87-24.88A79.93,79.93,0,0,0,174.7,89.71a64,64,0,0,1,41.75,92.48A8,8,0,0,0,215.82,188.23Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M227.79,186.39a76,76,0,0,0-61-110.07A76,76,0,1,0,28.21,138.39L20.5,164.6a12,12,0,0,0,14.9,14.9l26.21-7.71a75.93,75.93,0,0,0,27.6,7.9,76,76,0,0,0,105.18,40.1l26.21,7.71a12,12,0,0,0,14.9-14.9ZM60.9,163.66l-27.76,8.17a4,4,0,0,1-5-5l8.17-27.76a4.07,4.07,0,0,0-.31-3A68,68,0,1,1,63.92,164,4.06,4.06,0,0,0,60.9,163.66Zm165.92,55.16a4,4,0,0,1-4,1l-27.76-8.17a4.07,4.07,0,0,0-3,.31A68,68,0,0,1,98,180a76,76,0,0,0,71.5-95.28A68,68,0,0,1,220,184.08a4.07,4.07,0,0,0-.31,3l8.17,27.76A4,4,0,0,1,226.82,218.82Z"
        }))
    ]
]);


const $137fb85d062916e7$export$932ca73f3598151a = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...r,
        weights: (0, $3b183db6a49d61ab$export$2e2bcd8739ae039)
    }));
$137fb85d062916e7$export$932ca73f3598151a.displayName = "ChatsCircleIcon";
const $137fb85d062916e7$export$780ef68a19ac1891 = $137fb85d062916e7$export$932ca73f3598151a;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $5abba7d5db964d4b$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M56.88,31.93A12,12,0,0,0,36.8,44.28,20,20,0,0,0,20,64V224A19.82,19.82,0,0,0,31.56,242.1a20.14,20.14,0,0,0,8.49,1.9,19.91,19.91,0,0,0,12.82-4.72l.12-.11L84.47,212H188.15l11,12.07a12,12,0,0,0,17.76-16.15ZM80,188a11.93,11.93,0,0,0-7.84,2.92L44,215.23V68H57.24L166.33,188ZM236,64V174.12a12,12,0,0,1-24,0V68H116.6a12,12,0,0,1,0-24H216A20,20,0,0,1,236,64Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,64V192a8,8,0,0,1-8,8H80L45.15,230.11A8,8,0,0,1,32,224V64a8,8,0,0,1,8-8H216A8,8,0,0,1,224,64Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M53.92,34.62A8,8,0,1,0,42.08,45.38L44.46,48H40A16,16,0,0,0,24,64V224a15.85,15.85,0,0,0,9.24,14.5A16.13,16.13,0,0,0,40,240a15.94,15.94,0,0,0,10.26-3.78l.08-.07L83,208H189.92l12.16,13.38a8,8,0,1,0,11.84-10.76ZM80,192a8,8,0,0,0-5.23,1.95L40,224V64H59L175.37,192ZM232,64V186a8,8,0,0,1-16,0V64H105.79a8,8,0,0,1,0-16H216A16,16,0,0,1,232,64Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.92,210.61a8,8,0,1,1-11.84,10.76L189.92,208H83l-32.6,28.16-.08.07A15.94,15.94,0,0,1,40,240a16.13,16.13,0,0,1-6.8-1.52A15.85,15.85,0,0,1,24,224V64A16,16,0,0,1,40,48h4.46l-2.38-2.62A8,8,0,1,1,53.92,34.62ZM216,48H96.75a4,4,0,0,0-3,6.69L225,199.06a4,4,0,0,0,7-2.69V64A16,16,0,0,0,216,48Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M52.44,36A6,6,0,0,0,43.56,44L49,50H40A14,14,0,0,0,26,64V224a13.86,13.86,0,0,0,8.09,12.69,13.89,13.89,0,0,0,15-2L82.23,206H190.8l12.76,14a6,6,0,1,0,8.88-8.07ZM80,194a6,6,0,0,0-3.92,1.46l-34.79,30A2,2,0,0,1,38,224V64a2,2,0,0,1,2-2H59.89l120,132ZM230,64V186a6,6,0,0,1-12,0V64a2,2,0,0,0-2-2H105.79a6,6,0,0,1,0-12H216A14,14,0,0,1,230,64Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M53.92,34.62A8,8,0,1,0,42.08,45.38L44.46,48H40A16,16,0,0,0,24,64V224a15.85,15.85,0,0,0,9.24,14.5A16.13,16.13,0,0,0,40,240a15.94,15.94,0,0,0,10.26-3.78l.08-.07L83,208H189.92l12.16,13.38a8,8,0,1,0,11.84-10.76ZM80,192a8,8,0,0,0-5.23,1.95L40,224V64H59L175.37,192ZM232,64V186a8,8,0,0,1-16,0V64H105.79a8,8,0,0,1,0-16H216A16,16,0,0,1,232,64Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M51,37.31A4,4,0,0,0,45,42.69L53.5,52H40A12,12,0,0,0,28,64V224a11.89,11.89,0,0,0,6.93,10.88A12.09,12.09,0,0,0,40,236a12,12,0,0,0,7.74-2.87L81.49,204H191.68L205,218.69a4,4,0,0,0,3,1.31,4,4,0,0,0,3-6.69ZM80,196a4,4,0,0,0-2.61,1L42.57,227A4,4,0,0,1,36,224V64a4,4,0,0,1,4-4H60.78L184.41,196ZM228,64V186a4,4,0,0,1-8,0V64a4,4,0,0,0-4-4H105.79a4,4,0,0,1,0-8H216A12,12,0,0,1,228,64Z"
        }))
    ]
]);


const $1498f3d123581ef7$export$d9c1abf94e64825b = $7fPBF.forwardRef((t, e)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: e,
        ...t,
        weights: (0, $5abba7d5db964d4b$export$2e2bcd8739ae039)
    }));
$1498f3d123581ef7$export$d9c1abf94e64825b.displayName = "ChatSlashIcon";
const $1498f3d123581ef7$export$c636dc4beb98032e = $1498f3d123581ef7$export$d9c1abf94e64825b;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $f6e732a5308dce0a$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176.49,95.51a12,12,0,0,1,0,17l-56,56a12,12,0,0,1-17,0l-24-24a12,12,0,1,1,17-17L112,143l47.51-47.52A12,12,0,0,1,176.49,95.51ZM236,128A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm45.66,85.66-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35a8,8,0,0,1,11.32,11.32Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76ZM230,128A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M170.83,101.17a4,4,0,0,1,0,5.66l-56,56a4,4,0,0,1-5.66,0l-24-24a4,4,0,0,1,5.66-5.66L112,154.34l53.17-53.17A4,4,0,0,1,170.83,101.17ZM228,128A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z"
        }))
    ]
]);


const $07440da420a178a0$export$f6dd727656c97851 = $7fPBF.forwardRef((o, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...o,
        weights: (0, $f6e732a5308dce0a$export$2e2bcd8739ae039)
    }));
$07440da420a178a0$export$f6dd727656c97851.displayName = "CheckCircleIcon";
const $07440da420a178a0$export$c20155506fb9b45c = $07440da420a178a0$export$f6dd727656c97851;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $9f7121a1062dd511$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M152.41,88.56l-89.6,88a12,12,0,0,1-16.82,0L7.59,138.85a12,12,0,0,1,16.82-17.13l30,29.46,81.19-79.74a12,12,0,0,1,16.82,17.12Zm96.15-17a12,12,0,0,0-17-.15L150.4,151.18l-7.88-7.74a12,12,0,0,0-16.82,17.12l16.29,16a12,12,0,0,0,16.82,0l89.6-88A12,12,0,0,0,248.56,71.59Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240,64V192a16,16,0,0,1-16,16H32a16,16,0,0,1-16-16V64A16,16,0,0,1,32,48H224A16,16,0,0,1,240,64Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M149.61,85.71l-89.6,88a8,8,0,0,1-11.22,0L10.39,136a8,8,0,1,1,11.22-11.41L54.4,156.79l84-82.5a8,8,0,1,1,11.22,11.42Zm96.1-11.32a8,8,0,0,0-11.32-.1l-84,82.5-18.83-18.5a8,8,0,0,0-11.21,11.42l24.43,24a8,8,0,0,0,11.22,0l89.6-88A8,8,0,0,0,245.71,74.39Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48ZM72,168a8,8,0,0,1-5.66-2.34l-24-24a8,8,0,0,1,11.32-11.32L72,148.69l58.34-58.35a8,8,0,0,1,11.32,11.32l-64,64A8,8,0,0,1,72,168Zm141.66-66.34-64,64a8,8,0,0,1-11.32,0l-16-16a8,8,0,0,1,11.32-11.32L144,148.69l58.34-58.35a8,8,0,0,1,11.32,11.32Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M148.2,84.28l-89.6,88a6,6,0,0,1-8.4,0L11.8,134.57A6,6,0,1,1,20.2,126l34.2,33.58,85.4-83.87a6,6,0,1,1,8.4,8.56Zm96.08-8.48a6,6,0,0,0-8.48-.08l-85.4,83.87-20.23-19.87a6,6,0,1,0-8.41,8.56l24.44,24a6,6,0,0,0,8.4,0l89.6-88A6,6,0,0,0,244.28,75.8Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M149.61,85.71l-89.6,88a8,8,0,0,1-11.22,0L10.39,136a8,8,0,1,1,11.22-11.41L54.4,156.79l84-82.5a8,8,0,1,1,11.22,11.42Zm96.1-11.32a8,8,0,0,0-11.32-.1l-84,82.5-18.83-18.5a8,8,0,0,0-11.21,11.42l24.43,24a8,8,0,0,0,11.22,0l89.6-88A8,8,0,0,0,245.71,74.39Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M146.8,82.85l-89.6,88a4,4,0,0,1-5.6,0L13.2,133.14a4,4,0,0,1,5.6-5.71l35.6,35,86.8-85.24a4,4,0,0,1,5.6,5.7Zm96-5.65a4,4,0,0,0-5.65,0l-86.8,85.24-21.63-21.24a4,4,0,1,0-5.61,5.7l24.44,24a4,4,0,0,0,5.6,0l89.6-88A4,4,0,0,0,242.85,77.2Z"
        }))
    ]
]);


const $c629337a707d5c1c$export$e7072e36fe002dd0 = $7fPBF.forwardRef((c, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...c,
        weights: (0, $9f7121a1062dd511$export$2e2bcd8739ae039)
    }));
$c629337a707d5c1c$export$e7072e36fe002dd0.displayName = "ChecksIcon";
const $c629337a707d5c1c$export$e9b38990dca3b63b = $c629337a707d5c1c$export$e7072e36fe002dd0;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $e46f00882ed4cde2$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,128A104,104,0,1,1,128,24,104.13,104.13,0,0,1,232,128Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Z"
        }))
    ]
]);


const $8671267bc76a08e9$export$9c1c3f5a4a271817 = $7fPBF.forwardRef((r, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: c,
        ...r,
        weights: (0, $e46f00882ed4cde2$export$2e2bcd8739ae039)
    }));
$8671267bc76a08e9$export$9c1c3f5a4a271817.displayName = "CircleIcon";
const $8671267bc76a08e9$export$c89a927ffc67e6fa = $8671267bc76a08e9$export$9c1c3f5a4a271817;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $7ba036b5ce8417bd$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,28H48A20,20,0,0,0,28,48V208a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V48A20,20,0,0,0,208,28ZM52,52H76v95.22a24,24,0,1,0,24,0V125l40,40v39H52ZM204,204H164V160a12,12,0,0,0-3.51-8.49L100,91V52h24V72a12,12,0,0,0,3.51,8.49l17.31,17.3a24,24,0,1,0,17-17L148,67V52h56Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,40H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V48A8,8,0,0,0,208,40ZM88,184a16,16,0,1,1,16-16A16,16,0,0,1,88,184Zm80-64a16,16,0,1,1,16-16A16,16,0,0,1,168,120Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM88,160a8,8,0,1,1-8,8A8,8,0,0,1,88,160ZM48,48H80v97.38a24,24,0,1,0,16,0V115.31l48,48V208H48ZM208,208H160V160a8,8,0,0,0-2.34-5.66L96,92.69V48h32V72a8,8,0,0,0,2.34,5.66l16,16A23.74,23.74,0,0,0,144,104a24,24,0,1,0,24-24,23.74,23.74,0,0,0-10.34,2.35L144,68.69V48h64V208ZM168,96a8,8,0,1,1-8,8A8,8,0,0,1,168,96Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M88,111.31l48,48V220a4,4,0,0,1-4,4H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H68a4,4,0,0,1,4,4V153.38a24,24,0,1,0,16,0ZM80,184a8,8,0,1,0-8-8A8,8,0,0,0,80,184Zm104-80a8,8,0,1,0-8,8A8,8,0,0,0,184,104Zm24-72H156a4,4,0,0,0-4,4V68.69l13.66,13.66a24,24,0,1,1-11.31,11.31l-16-16A8,8,0,0,1,136,72V36a4,4,0,0,0-4-4H92a4,4,0,0,0-4,4V88.69l61.66,61.65A8,8,0,0,1,152,156v64a4,4,0,0,0,4,4h52a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,34H48A14,14,0,0,0,34,48V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V48A14,14,0,0,0,208,34ZM88,158a10,10,0,1,1-10,10A10,10,0,0,1,88,158ZM46,208V48a2,2,0,0,1,2-2H82V146.84a22,22,0,1,0,12,0V110.49l52,52V210H48A2,2,0,0,1,46,208Zm164,0a2,2,0,0,1-2,2H158V160a6,6,0,0,0-1.76-4.24L94,93.51V46h36V72a6,6,0,0,0,1.76,4.24l17,17a22,22,0,1,0,8.48-8.48L142,69.51V46h66a2,2,0,0,1,2,2ZM168,94a10,10,0,1,1-10,10A10,10,0,0,1,168,94Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM88,160a8,8,0,1,1-8,8A8,8,0,0,1,88,160ZM48,48H80v97.38a24,24,0,1,0,16,0V115.31l48,48V208H48ZM208,208H160V160a8,8,0,0,0-2.34-5.66L96,92.69V48h32V72a8,8,0,0,0,2.34,5.66l16,16A23.74,23.74,0,0,0,144,104a24,24,0,1,0,24-24,23.74,23.74,0,0,0-10.34,2.35L144,68.69V48h64V208ZM168,96a8,8,0,1,1-8,8A8,8,0,0,1,168,96Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,36H48A12,12,0,0,0,36,48V208a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V48A12,12,0,0,0,208,36ZM88,156a12,12,0,1,1-12,12A12,12,0,0,1,88,156ZM44,208V48a4,4,0,0,1,4-4H84V148.4a20,20,0,1,0,8,0V105.66l56,56V212H48A4,4,0,0,1,44,208Zm168,0a4,4,0,0,1-4,4H156V160a4,4,0,0,0-1.17-2.83L92,94.34V44h40V72a4,4,0,0,0,1.17,2.83L151.33,93A20,20,0,1,0,157,87.33l-17-17V44h68a4,4,0,0,1,4,4ZM168,92a12,12,0,1,1-12,12A12,12,0,0,1,168,92Z"
        }))
    ]
]);


const $b2c91a69e5d67ec9$export$ae8a512ee3f09294 = $7fPBF.forwardRef((t, i)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: i,
        ...t,
        weights: (0, $7ba036b5ce8417bd$export$2e2bcd8739ae039)
    }));
$b2c91a69e5d67ec9$export$ae8a512ee3f09294.displayName = "CircuitryIcon";
const $b2c91a69e5d67ec9$export$aef0eb479eab3688 = $b2c91a69e5d67ec9$export$ae8a512ee3f09294;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $e0d88aab804f6cdc$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M172,164a12,12,0,0,1-12,12H96a12,12,0,0,1,0-24h64A12,12,0,0,1,172,164Zm-12-52H96a12,12,0,0,0,0,24h64a12,12,0,0,0,0-24Zm60-64V216a20,20,0,0,1-20,20H56a20,20,0,0,1-20-20V48A20,20,0,0,1,56,28H90.53a51.88,51.88,0,0,1,74.94,0H200A20,20,0,0,1,220,48ZM100.29,60h55.42a28,28,0,0,0-55.42,0ZM196,52H178.59A52.13,52.13,0,0,1,180,64v8a12,12,0,0,1-12,12H88A12,12,0,0,1,76,72V64a52.13,52.13,0,0,1,1.41-12H60V212H196Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,48V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H96a39.83,39.83,0,0,0-8,24v8h80V64a39.83,39.83,0,0,0-8-24h40A8,8,0,0,1,208,48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,152a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,152Zm-8-40H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm56-64V216a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V48A16,16,0,0,1,56,32H92.26a47.92,47.92,0,0,1,71.48,0H200A16,16,0,0,1,216,48ZM96,64h64a32,32,0,0,0-64,0ZM200,48H173.25A47.93,47.93,0,0,1,176,64v8a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V64a47.93,47.93,0,0,1,2.75-16H56V216H200Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,32H163.74a47.92,47.92,0,0,0-71.48,0H56A16,16,0,0,0,40,48V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V48A16,16,0,0,0,200,32Zm-72,0a32,32,0,0,1,32,32H96A32,32,0,0,1,128,32Zm32,128H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M166,152a6,6,0,0,1-6,6H96a6,6,0,0,1,0-12h64A6,6,0,0,1,166,152Zm-6-38H96a6,6,0,0,0,0,12h64a6,6,0,0,0,0-12Zm54-66V216a14,14,0,0,1-14,14H56a14,14,0,0,1-14-14V48A14,14,0,0,1,56,34H93.17a45.91,45.91,0,0,1,69.66,0H200A14,14,0,0,1,214,48ZM94,64v2h68V64a34,34,0,0,0-68,0ZM202,48a2,2,0,0,0-2-2H170.33A45.77,45.77,0,0,1,174,64v8a6,6,0,0,1-6,6H88a6,6,0,0,1-6-6V64a45.77,45.77,0,0,1,3.67-18H56a2,2,0,0,0-2,2V216a2,2,0,0,0,2,2H200a2,2,0,0,0,2-2Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,152a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,152Zm-8-40H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm56-64V216a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V48A16,16,0,0,1,56,32H92.26a47.92,47.92,0,0,1,71.48,0H200A16,16,0,0,1,216,48ZM96,64h64a32,32,0,0,0-64,0ZM200,48H173.25A47.93,47.93,0,0,1,176,64v8a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V64a47.93,47.93,0,0,1,2.75-16H56V216H200Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M164,152a4,4,0,0,1-4,4H96a4,4,0,0,1,0-8h64A4,4,0,0,1,164,152Zm-4-36H96a4,4,0,0,0,0,8h64a4,4,0,0,0,0-8Zm52-68V216a12,12,0,0,1-12,12H56a12,12,0,0,1-12-12V48A12,12,0,0,1,56,36H94.08a44,44,0,0,1,67.84,0H200A12,12,0,0,1,212,48ZM92,64v4h72V64a36,36,0,0,0-72,0ZM204,48a4,4,0,0,0-4-4H167.17A43.71,43.71,0,0,1,172,64v8a4,4,0,0,1-4,4H88a4,4,0,0,1-4-4V64a43.71,43.71,0,0,1,4.83-20H56a4,4,0,0,0-4,4V216a4,4,0,0,0,4,4H200a4,4,0,0,0,4-4Z"
        }))
    ]
]);


const $79c58fd630e9f542$export$5ea4e40e738fba70 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...r,
        weights: (0, $e0d88aab804f6cdc$export$2e2bcd8739ae039)
    }));
$79c58fd630e9f542$export$5ea4e40e738fba70.displayName = "ClipboardTextIcon";
const $79c58fd630e9f542$export$f3f2822f093d328a = $79c58fd630e9f542$export$5ea4e40e738fba70;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $19e26159d964e9d2$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M84,76A12,12,0,0,1,96,64h64a12,12,0,0,1,0,24H96A12,12,0,0,1,84,76Zm12,52h64a12,12,0,0,0,0-24H96a12,12,0,0,0,0,24ZM212,40V216a20,20,0,0,1-20,20H64a20,20,0,0,1-20-20V40A20,20,0,0,1,64,20H192A20,20,0,0,1,212,40Zm-24,4H68V212H188ZM128,168a16,16,0,1,0,16,16A16,16,0,0,0,128,168Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,40V216a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8H192A8,8,0,0,1,200,40Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M88,72a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H96A8,8,0,0,1,88,72Zm8,40h64a8,8,0,0,0,0-16H96a8,8,0,0,0,0,16ZM208,40V216a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V40A16,16,0,0,1,64,24H192A16,16,0,0,1,208,40Zm-16,0H64V216H192ZM128,168a12,12,0,1,0,12,12A12,12,0,0,0,128,168Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M192,24H64A16,16,0,0,0,48,40V216a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V40A16,16,0,0,0,192,24ZM128,192a12,12,0,1,1,12-12A12,12,0,0,1,128,192Zm32-80H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M166,72a6,6,0,0,1-6,6H96a6,6,0,0,1,0-12h64A6,6,0,0,1,166,72Zm-6,26H96a6,6,0,0,0,0,12h64a6,6,0,0,0,0-12Zm46-58V216a14,14,0,0,1-14,14H64a14,14,0,0,1-14-14V40A14,14,0,0,1,64,26H192A14,14,0,0,1,206,40Zm-12,0a2,2,0,0,0-2-2H64a2,2,0,0,0-2,2V216a2,2,0,0,0,2,2H192a2,2,0,0,0,2-2ZM128,170a10,10,0,1,0,10,10A10,10,0,0,0,128,170Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M88,72a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H96A8,8,0,0,1,88,72Zm8,40h64a8,8,0,0,0,0-16H96a8,8,0,0,0,0,16ZM208,40V216a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V40A16,16,0,0,1,64,24H192A16,16,0,0,1,208,40Zm-16,0H64V216H192ZM128,168a12,12,0,1,0,12,12A12,12,0,0,0,128,168Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M164,72a4,4,0,0,1-4,4H96a4,4,0,0,1,0-8h64A4,4,0,0,1,164,72Zm-4,28H96a4,4,0,0,0,0,8h64a4,4,0,0,0,0-8Zm44-60V216a12,12,0,0,1-12,12H64a12,12,0,0,1-12-12V40A12,12,0,0,1,64,28H192A12,12,0,0,1,204,40Zm-8,0a4,4,0,0,0-4-4H64a4,4,0,0,0-4,4V216a4,4,0,0,0,4,4H192a4,4,0,0,0,4-4ZM128,172a8,8,0,1,0,8,8A8,8,0,0,0,128,172Z"
        }))
    ]
]);


const $79c2550b6d641714$export$a0dda6738dfadcc6 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...r,
        weights: (0, $19e26159d964e9d2$export$2e2bcd8739ae039)
    }));
$79c2550b6d641714$export$a0dda6738dfadcc6.displayName = "ComputerTowerIcon";
const $79c2550b6d641714$export$4a6c7b5b3bb8a314 = $79c2550b6d641714$export$a0dda6738dfadcc6;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $64d8f6dbf0ee66d8$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,28H88A12,12,0,0,0,76,40V76H40A12,12,0,0,0,28,88V216a12,12,0,0,0,12,12H168a12,12,0,0,0,12-12V180h36a12,12,0,0,0,12-12V40A12,12,0,0,0,216,28ZM156,204H52V100H156Zm48-48H180V88a12,12,0,0,0-12-12H100V52H204Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,40V168H168V88H88V40Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,32H88a8,8,0,0,0-8,8V80H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8V176h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32ZM160,208H48V96H160Zm48-48H176V88a8,8,0,0,0-8-8H96V48H208Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,32H88a8,8,0,0,0-8,8V80H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8V176h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32Zm-8,128H176V88a8,8,0,0,0-8-8H96V48H208Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,34H88a6,6,0,0,0-6,6V82H40a6,6,0,0,0-6,6V216a6,6,0,0,0,6,6H168a6,6,0,0,0,6-6V174h42a6,6,0,0,0,6-6V40A6,6,0,0,0,216,34ZM162,210H46V94H162Zm48-48H174V88a6,6,0,0,0-6-6H94V46H210Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,32H88a8,8,0,0,0-8,8V80H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8V176h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32ZM160,208H48V96H160Zm48-48H176V88a8,8,0,0,0-8-8H96V48H208Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,36H88a4,4,0,0,0-4,4V84H40a4,4,0,0,0-4,4V216a4,4,0,0,0,4,4H168a4,4,0,0,0,4-4V172h44a4,4,0,0,0,4-4V40A4,4,0,0,0,216,36ZM164,212H44V92H164Zm48-48H172V88a4,4,0,0,0-4-4H92V44H212Z"
        }))
    ]
]);


const $db96a5dcfc35585c$export$51b6cd98f8778f0d = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...r,
        weights: (0, $64d8f6dbf0ee66d8$export$2e2bcd8739ae039)
    }));
$db96a5dcfc35585c$export$51b6cd98f8778f0d.displayName = "CopyIcon";
const $db96a5dcfc35585c$export$92ce62e1201c4fc0 = $db96a5dcfc35585c$export$51b6cd98f8778f0d;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $bc46e1eba941e29a$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M180,64H40A12,12,0,0,0,28,76V216a12,12,0,0,0,12,12H180a12,12,0,0,0,12-12V76A12,12,0,0,0,180,64ZM168,204H52V88H168ZM228,40V180a12,12,0,0,1-24,0V52H76a12,12,0,0,1,0-24H216A12,12,0,0,1,228,40Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184,72V216H40V72Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184,64H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V72A8,8,0,0,0,184,64Zm-8,144H48V80H176ZM224,40V184a8,8,0,0,1-16,0V48H72a8,8,0,0,1,0-16H216A8,8,0,0,1,224,40Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M192,72V216a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H184A8,8,0,0,1,192,72Zm24-40H72a8,8,0,0,0,0,16H208V184a8,8,0,0,0,16,0V40A8,8,0,0,0,216,32Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184,66H40a6,6,0,0,0-6,6V216a6,6,0,0,0,6,6H184a6,6,0,0,0,6-6V72A6,6,0,0,0,184,66Zm-6,144H46V78H178ZM222,40V184a6,6,0,0,1-12,0V46H72a6,6,0,0,1,0-12H216A6,6,0,0,1,222,40Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184,64H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V72A8,8,0,0,0,184,64Zm-8,144H48V80H176ZM224,40V184a8,8,0,0,1-16,0V48H72a8,8,0,0,1,0-16H216A8,8,0,0,1,224,40Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184,68H40a4,4,0,0,0-4,4V216a4,4,0,0,0,4,4H184a4,4,0,0,0,4-4V72A4,4,0,0,0,184,68Zm-4,144H44V76H180ZM220,40V184a4,4,0,0,1-8,0V44H72a4,4,0,0,1,0-8H216A4,4,0,0,1,220,40Z"
        }))
    ]
]);


const $c7cfe8b811c67a0e$export$2f845a994f66da8f = $7fPBF.forwardRef((m, p)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: p,
        ...m,
        weights: (0, $bc46e1eba941e29a$export$2e2bcd8739ae039)
    }));
$c7cfe8b811c67a0e$export$2f845a994f66da8f.displayName = "CopySimpleIcon";
const $c7cfe8b811c67a0e$export$580df7a3d0dd33ae = $c7cfe8b811c67a0e$export$2f845a994f66da8f;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $cbcfe2eea08b9f7d$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M252,80a32,32,0,1,0-60,15.45l-20.86,25.66L150.82,74.4a32,32,0,1,0-45.64,0L84.87,121.11,64,95.45a32,32,0,1,0-35,15.78l14,84.06A19.94,19.94,0,0,0,62.78,212H193.22A19.94,19.94,0,0,0,213,195.29l14-84.06A32.05,32.05,0,0,0,252,80Zm-32-8a8,8,0,1,1-8,8A8,8,0,0,1,220,72ZM128,44a8,8,0,1,1-8,8A8,8,0,0,1,128,44ZM36,72a8,8,0,1,1-8,8A8,8,0,0,1,36,72ZM189.83,188H66.17L55.29,122.78l23.4,28.79A12,12,0,0,0,88,156a12.87,12.87,0,0,0,1.63-.11,12,12,0,0,0,9.37-7.1L127.18,84l.82,0,.82,0L157,148.79a12,12,0,0,0,9.37,7.1A12.87,12.87,0,0,0,168,156a12,12,0,0,0,9.31-4.43l23.4-28.79Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216.71,99.73l-15.6,93.59a8,8,0,0,1-7.89,6.68H62.78a8,8,0,0,1-7.89-6.68L39.29,99.73l.08,0a19.82,19.82,0,0,0,9.22-4.16h0L88,144l32-73.65h0a20,20,0,0,0,15.92,0h0L168,144l39.39-48.48h0a19.82,19.82,0,0,0,9.22,4.16Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M248,80a28,28,0,1,0-51.12,15.77l-26.79,33L146,73.4a28,28,0,1,0-36.06,0L85.91,128.74l-26.79-33a28,28,0,1,0-26.6,12L47,194.63A16,16,0,0,0,62.78,208H193.22A16,16,0,0,0,209,194.63l14.47-86.85A28,28,0,0,0,248,80ZM128,40a12,12,0,1,1-12,12A12,12,0,0,1,128,40ZM24,80A12,12,0,1,1,36,92,12,12,0,0,1,24,80ZM193.22,192H62.78L48.86,108.52,81.79,149A8,8,0,0,0,88,152a7.83,7.83,0,0,0,1.08-.07,8,8,0,0,0,6.26-4.74l29.3-67.4a27,27,0,0,0,6.72,0l29.3,67.4a8,8,0,0,0,6.26,4.74A7.83,7.83,0,0,0,168,152a8,8,0,0,0,6.21-3l32.93-40.52ZM220,92a12,12,0,1,1,12-12A12,12,0,0,1,220,92Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M248,80a28,28,0,1,0-51.12,15.77l-26.79,33L146,73.4a28,28,0,1,0-36.06,0L85.91,128.74l-26.79-33a28,28,0,1,0-26.6,12L47,194.63A16,16,0,0,0,62.78,208H193.22A16,16,0,0,0,209,194.63l14.47-86.85A28,28,0,0,0,248,80ZM128,40a12,12,0,1,1-12,12A12,12,0,0,1,128,40ZM24,80A12,12,0,1,1,36,92,12,12,0,0,1,24,80ZM220,92a12,12,0,1,1,12-12A12,12,0,0,1,220,92Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M246,80a26,26,0,1,0-46.6,15.84l-29.83,36.72-26-59.76a26,26,0,1,0-31.16,0l-26,59.76L56.6,95.84a26,26,0,1,0-22.36,10.09L49,194.3A14,14,0,0,0,62.78,206H193.22A14,14,0,0,0,207,194.3l14.73-88.37A26,26,0,0,0,246,80ZM128,38a14,14,0,1,1-14,14A14,14,0,0,1,128,38ZM22,80A14,14,0,1,1,36,94,14,14,0,0,1,22,80ZM195.2,192.33a2,2,0,0,1-2,1.67H62.78a2,2,0,0,1-2-1.67L46.08,104l1.22-.55,36,44.36A6,6,0,0,0,88,150a5.52,5.52,0,0,0,.81-.06,6,6,0,0,0,4.69-3.55l29.92-68.8a25.79,25.79,0,0,0,9.16,0l29.92,68.8a6,6,0,0,0,4.69,3.55,5.52,5.52,0,0,0,.81.06,6,6,0,0,0,4.66-2.22l36-44.36,1.22.55ZM220,94a14,14,0,1,1,14-14A14,14,0,0,1,220,94Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M248,80a28,28,0,1,0-51.12,15.77l-26.79,33L146,73.4a28,28,0,1,0-36.06,0L85.91,128.74l-26.79-33a28,28,0,1,0-26.6,12L47,194.63A16,16,0,0,0,62.78,208H193.22A16,16,0,0,0,209,194.63l14.47-86.85A28,28,0,0,0,248,80ZM128,40a12,12,0,1,1-12,12A12,12,0,0,1,128,40ZM24,80A12,12,0,1,1,36,92,12,12,0,0,1,24,80ZM193.22,192H62.78L48.86,108.52,81.79,149A8,8,0,0,0,88,152a7.83,7.83,0,0,0,1.08-.07,8,8,0,0,0,6.26-4.74l29.3-67.4a27,27,0,0,0,6.72,0l29.3,67.4a8,8,0,0,0,6.26,4.74A7.83,7.83,0,0,0,168,152a8,8,0,0,0,6.21-3l32.93-40.52ZM220,92a12,12,0,1,1,12-12A12,12,0,0,1,220,92Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M244,80a24,24,0,1,0-42,15.83L169,136.37,141.1,72.09a24,24,0,1,0-26.2,0L87,136.37,54,95.83A24,24,0,1,0,35.94,104l15,90a12,12,0,0,0,11.84,10H193.22a12,12,0,0,0,11.84-10l15-90A24,24,0,0,0,244,80ZM128,36a16,16,0,1,1-16,16A16,16,0,0,1,128,36ZM20,80A16,16,0,1,1,36,96,16,16,0,0,1,20,80ZM197.17,192.66a4,4,0,0,1-3.95,3.34H62.78a4,4,0,0,1-4-3.34l-15-90a23.41,23.41,0,0,0,4-1.8L84.9,146.52A4,4,0,0,0,88,148a3.27,3.27,0,0,0,.54,0,4,4,0,0,0,3.13-2.37l30.56-70.3a23.8,23.8,0,0,0,11.54,0l30.56,70.3a4,4,0,0,0,3.13,2.37,3.27,3.27,0,0,0,.54,0,4,4,0,0,0,3.1-1.48l37.09-45.64a23.41,23.41,0,0,0,4,1.8ZM220,96a16,16,0,1,1,16-16A16,16,0,0,1,220,96Z"
        }))
    ]
]);


const $78e34b15ecf2a54e$export$338dfc3083a3d7f0 = $7fPBF.forwardRef((e, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...e,
        weights: (0, $cbcfe2eea08b9f7d$export$2e2bcd8739ae039)
    }));
$78e34b15ecf2a54e$export$338dfc3083a3d7f0.displayName = "CrownIcon";
const $78e34b15ecf2a54e$export$f3f7b84d2fde9b9e = $78e34b15ecf2a54e$export$338dfc3083a3d7f0;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $33b6aa192f910fc4$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M236,48V88a12,12,0,0,1-24,0V60H184a12,12,0,0,1,0-24h40A12,12,0,0,1,236,48ZM72,196H44V168a12,12,0,0,0-24,0v40a12,12,0,0,0,12,12H72a12,12,0,0,0,0-24Zm152-40a12,12,0,0,0-12,12v28H184a12,12,0,0,0,0,24h40a12,12,0,0,0,12-12V168A12,12,0,0,0,224,156ZM32,100A12,12,0,0,0,44,88V60H72a12,12,0,0,0,0-24H32A12,12,0,0,0,20,48V88A12,12,0,0,0,32,100Zm158,70.42-56,32a12,12,0,0,1-11.9,0l-56-32A12,12,0,0,1,60,160V96a12,12,0,0,1,6-10.42l56-32a12,12,0,0,1,11.9,0l56,32A12,12,0,0,1,196,96v64A12,12,0,0,1,190,170.42ZM96.19,96,128,114.18,159.81,96,128,77.82ZM84,153l32,18.28V135L84,116.68Zm88,0V116.68L140,135v36.36Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184,96v64l-56,32L72,160V96l56-32Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,48V88a8,8,0,0,1-16,0V56H184a8,8,0,0,1,0-16h40A8,8,0,0,1,232,48ZM72,200H40V168a8,8,0,0,0-16,0v40a8,8,0,0,0,8,8H72a8,8,0,0,0,0-16Zm152-40a8,8,0,0,0-8,8v32H184a8,8,0,0,0,0,16h40a8,8,0,0,0,8-8V168A8,8,0,0,0,224,160ZM32,96a8,8,0,0,0,8-8V56H72a8,8,0,0,0,0-16H32a8,8,0,0,0-8,8V88A8,8,0,0,0,32,96ZM188,167l-56,32a8,8,0,0,1-7.94,0L68,167A8,8,0,0,1,64,160V96a8,8,0,0,1,4-7l56-32a8,8,0,0,1,7.94,0l56,32a8,8,0,0,1,4,7v64A8,8,0,0,1,188,167ZM88.12,96,128,118.79,167.88,96,128,73.21ZM80,155.36l40,22.85V132.64L80,109.79Zm96,0V109.79l-40,22.85v45.57Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,48V88a8,8,0,0,1-16,0V56H184a8,8,0,0,1,0-16h40A8,8,0,0,1,232,48ZM72,200H40V168a8,8,0,0,0-16,0v40a8,8,0,0,0,8,8H72a8,8,0,0,0,0-16Zm152-40a8,8,0,0,0-8,8v32H184a8,8,0,0,0,0,16h40a8,8,0,0,0,8-8V168A8,8,0,0,0,224,160ZM32,96a8,8,0,0,0,8-8V56H72a8,8,0,0,0,0-16H32a8,8,0,0,0-8,8V88A8,8,0,0,0,32,96ZM177.92,83.31,132,57.05a8,8,0,0,0-7.94,0L78.08,83.31a4,4,0,0,0,0,7L128,118.79l49.92-28.53A4,4,0,0,0,177.92,83.31ZM64,107.53V160A8,8,0,0,0,68,167l46,26.27a4,4,0,0,0,6-3.47V132.64L70,104.06A4,4,0,0,0,64,107.53ZM192,160V107.53a4,4,0,0,0-6-3.47l-50,28.58v57.11a4,4,0,0,0,6,3.47L188,167A8,8,0,0,0,192,160Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M230,48V88a6,6,0,0,1-12,0V54H184a6,6,0,0,1,0-12h40A6,6,0,0,1,230,48ZM72,202H38V168a6,6,0,0,0-12,0v40a6,6,0,0,0,6,6H72a6,6,0,0,0,0-12Zm152-40a6,6,0,0,0-6,6v34H184a6,6,0,0,0,0,12h40a6,6,0,0,0,6-6V168A6,6,0,0,0,224,162ZM32,94a6,6,0,0,0,6-6V54H72a6,6,0,0,0,0-12H32a6,6,0,0,0-6,6V88A6,6,0,0,0,32,94Zm155,71.21-56,32a6,6,0,0,1-6,0l-56-32A6,6,0,0,1,66,160V96a6,6,0,0,1,3-5.21l56-32a6,6,0,0,1,6,0l56,32A6,6,0,0,1,190,96v64A6,6,0,0,1,187,165.21ZM84.09,96,128,121.09,171.91,96,128,70.91ZM78,156.52l44,25.14V131.48L78,106.34Zm100,0V106.34l-44,25.14v50.18Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,48V88a8,8,0,0,1-16,0V56H184a8,8,0,0,1,0-16h40A8,8,0,0,1,232,48ZM72,200H40V168a8,8,0,0,0-16,0v40a8,8,0,0,0,8,8H72a8,8,0,0,0,0-16Zm152-40a8,8,0,0,0-8,8v32H184a8,8,0,0,0,0,16h40a8,8,0,0,0,8-8V168A8,8,0,0,0,224,160ZM32,96a8,8,0,0,0,8-8V56H72a8,8,0,0,0,0-16H32a8,8,0,0,0-8,8V88A8,8,0,0,0,32,96ZM188,167l-56,32a8,8,0,0,1-7.94,0L68,167A8,8,0,0,1,64,160V96a8,8,0,0,1,4-7l56-32a8,8,0,0,1,7.94,0l56,32a8,8,0,0,1,4,7v64A8,8,0,0,1,188,167ZM88.12,96,128,118.79,167.88,96,128,73.21ZM80,155.36l40,22.85V132.64L80,109.79Zm96,0V109.79l-40,22.85v45.57Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228,48V88a4,4,0,0,1-8,0V52H184a4,4,0,0,1,0-8h40A4,4,0,0,1,228,48ZM72,204H36V168a4,4,0,0,0-8,0v40a4,4,0,0,0,4,4H72a4,4,0,0,0,0-8Zm152-40a4,4,0,0,0-4,4v36H184a4,4,0,0,0,0,8h40a4,4,0,0,0,4-4V168A4,4,0,0,0,224,164ZM32,92a4,4,0,0,0,4-4V52H72a4,4,0,0,0,0-8H32a4,4,0,0,0-4,4V88A4,4,0,0,0,32,92Zm154,71.47-56,32a4,4,0,0,1-4,0l-56-32A4,4,0,0,1,68,160V96a4,4,0,0,1,2-3.47l56-32a4,4,0,0,1,4,0l56,32A4,4,0,0,1,188,96v64A4,4,0,0,1,186,163.47ZM80.06,96,128,123.39,175.94,96,128,68.61ZM76,157.68l48,27.43V130.32L76,102.89Zm104,0V102.89l-48,27.43v54.79Z"
        }))
    ]
]);


const $341dc8bc46d90b3a$export$2acbef2959ecd829 = $7fPBF.forwardRef((c, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...c,
        weights: (0, $33b6aa192f910fc4$export$2e2bcd8739ae039)
    }));
$341dc8bc46d90b3a$export$2acbef2959ecd829.displayName = "CubeFocusIcon";
const $341dc8bc46d90b3a$export$57a6c4aa55e25a32 = $341dc8bc46d90b3a$export$2acbef2959ecd829;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $8870271a336384d8$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224.15,179.17l-46.82-46.82,37.92-13.51c.26-.09.51-.19.76-.3a20,20,0,0,0-1.76-37.27L54.16,29A20,20,0,0,0,29,54.16L81.27,214.24A20,20,0,0,0,118.54,216c.11-.25.21-.5.3-.76l13.51-37.92,46.83,46.82a20,20,0,0,0,28.28,0l16.69-16.68A20,20,0,0,0,224.15,179.17Zm-30.83,25.17-48.48-48.48A20,20,0,0,0,130.7,150a20.47,20.47,0,0,0-3.73.35A20,20,0,0,0,112.35,162c-.11.25-.2.5-.3.76L100.4,195.5,54.29,54.29,195.5,100.4l-32.71,11.65c-.25.09-.51.19-.76.3a20,20,0,0,0-6.16,32.48h0l48.48,48.48ZM84,16V12a12,12,0,0,1,24,0v4a12,12,0,0,1-24,0ZM12,108a12,12,0,0,1,0-24h4a12,12,0,0,1,0,24ZM120.62,24.21l4-12a12,12,0,0,1,22.77,7.58l-4,12a12,12,0,0,1-22.77-7.58Zm-81.23,104a12,12,0,0,1-7.59,15.17l-12,4a12,12,0,1,1-7.59-22.76l12-4A12,12,0,0,1,39.39,128.21Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,201,201,213.66a8,8,0,0,1-11.31,0l-51.31-51.31a8,8,0,0,0-13,2.46l-17.82,46.41a8,8,0,0,1-14.85-.71L40.41,50.44a8,8,0,0,1,10-10L210.51,92.68a8,8,0,0,1,.71,14.85l-46.41,17.82a8,8,0,0,0-2.46,13l51.31,51.31A8,8,0,0,1,213.66,201Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M88,24V16a8,8,0,0,1,16,0v8a8,8,0,0,1-16,0ZM16,104h8a8,8,0,0,0,0-16H16a8,8,0,0,0,0,16ZM124.42,39.16a8,8,0,0,0,10.74-3.58l8-16a8,8,0,0,0-14.31-7.16l-8,16A8,8,0,0,0,124.42,39.16Zm-96,81.69-16,8a8,8,0,0,0,7.16,14.31l16-8a8,8,0,1,0-7.16-14.31ZM219.31,184a16,16,0,0,1,0,22.63l-12.68,12.68a16,16,0,0,1-22.63,0L132.7,168,115,214.09c0,.1-.08.21-.13.32a15.83,15.83,0,0,1-14.6,9.59l-.79,0a15.83,15.83,0,0,1-14.41-11L32.8,52.92A16,16,0,0,1,52.92,32.8L213,85.07a16,16,0,0,1,1.41,29.8l-.32.13L168,132.69ZM208,195.31,156.69,144h0a16,16,0,0,1,4.93-26l.32-.14,45.95-17.64L48,48l52.2,159.86,17.65-46c0-.11.08-.22.13-.33a16,16,0,0,1,11.69-9.34,16.72,16.72,0,0,1,3-.28,16,16,0,0,1,11.3,4.69L195.31,208Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220.49,190.83a12,12,0,0,1,0,17L207.8,220.49a12,12,0,0,1-17,0l-56.56-56.57L115,214.09c0,.1-.08.21-.13.32a15.83,15.83,0,0,1-14.6,9.59l-.79,0a15.83,15.83,0,0,1-14.41-11L32.8,52.92A16,16,0,0,1,52.92,32.8L213,85.07a16,16,0,0,1,1.41,29.8l-.32.13-50.17,19.27ZM96,32a8,8,0,0,0,8-8V16a8,8,0,0,0-16,0v8A8,8,0,0,0,96,32ZM16,104h8a8,8,0,0,0,0-16H16a8,8,0,0,0,0,16ZM124.42,39.16a8,8,0,0,0,10.74-3.58l8-16a8,8,0,0,0-14.31-7.16l-8,16A8,8,0,0,0,124.42,39.16Zm-96,81.69-16,8a8,8,0,0,0,7.16,14.31l16-8a8,8,0,1,0-7.16-14.31Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M90,24V16a6,6,0,0,1,12,0v8a6,6,0,0,1-12,0ZM16,102h8a6,6,0,0,0,0-12H16a6,6,0,0,0,0,12ZM125.32,37.37a6,6,0,0,0,8.05-2.69l8-16a6,6,0,0,0-10.74-5.37l-8,16A6,6,0,0,0,125.32,37.37Zm-96,85.26-16,8a6,6,0,0,0,5.36,10.74l16-8a6,6,0,1,0-5.36-10.74ZM217.9,185.41a14,14,0,0,1,0,19.8L205.21,217.9a14,14,0,0,1-19.8,0L134.1,166.59a2,2,0,0,0-3.21.54l-17.75,46.24a2.44,2.44,0,0,0-.1.24A13.85,13.85,0,0,1,100.26,222c-.23,0-.45,0-.68,0A13.85,13.85,0,0,1,87,212.38L34.7,52.3A14,14,0,0,1,52.3,34.7L212.38,87A14,14,0,0,1,213.61,113l-.24.09-46.25,17.76a2,2,0,0,0-.53,3.21Zm-8.49,8.49L158.1,142.59h0a14,14,0,0,1,4.32-22.74l.24-.1L208.91,102a2,2,0,0,0-.26-3.61L48.58,46.11a2.33,2.33,0,0,0-.65-.11,2,2,0,0,0-1.82,2.58L98.38,208.65a1.84,1.84,0,0,0,1.77,1.35,1.81,1.81,0,0,0,1.84-1.09l17.76-46.25.1-.24a14,14,0,0,1,22.74-4.32l51.31,51.31a2,2,0,0,0,2.83,0l12.68-12.68A2,2,0,0,0,209.41,193.9Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M88,24V16a8,8,0,0,1,16,0v8a8,8,0,0,1-16,0ZM16,104h8a8,8,0,0,0,0-16H16a8,8,0,0,0,0,16ZM124.42,39.16a8,8,0,0,0,10.74-3.58l8-16a8,8,0,0,0-14.31-7.16l-8,16A8,8,0,0,0,124.42,39.16Zm-96,81.69-16,8a8,8,0,0,0,7.16,14.31l16-8a8,8,0,1,0-7.16-14.31ZM219.31,184a16,16,0,0,1,0,22.63l-12.68,12.68a16,16,0,0,1-22.63,0L132.7,168,115,214.09c0,.1-.08.21-.13.32a15.83,15.83,0,0,1-14.6,9.59l-.79,0a15.83,15.83,0,0,1-14.41-11L32.8,52.92A16,16,0,0,1,52.92,32.8L213,85.07a16,16,0,0,1,1.41,29.8l-.32.13L168,132.69ZM208,195.31,156.69,144h0a16,16,0,0,1,4.93-26l.32-.14,45.95-17.64L48,48l52.2,159.86,17.65-46c0-.11.08-.22.13-.33a16,16,0,0,1,11.69-9.34,16.72,16.72,0,0,1,3-.28,16,16,0,0,1,11.3,4.69L195.31,208Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M92,24V16a4,4,0,0,1,8,0v8a4,4,0,0,1-8,0ZM16,100h8a4,4,0,0,0,0-8H16a4,4,0,0,0,0,8ZM126.21,35.58a4,4,0,0,0,5.37-1.79l8-16a4,4,0,0,0-7.16-3.58l-8,16A4,4,0,0,0,126.21,35.58Zm-96,88.84-16,8a4,4,0,0,0,3.58,7.16l16-8a4,4,0,1,0-3.58-7.16Zm186.28,62.41a12,12,0,0,1,0,17L203.8,216.49a12,12,0,0,1-17,0l-51.31-51.31a3.93,3.93,0,0,0-3.58-1.11,4,4,0,0,0-2.89,2.27l-17.78,46.31a.77.77,0,0,1-.07.16A11.85,11.85,0,0,1,100.26,220h-.59a11.88,11.88,0,0,1-10.8-8.23L36.6,51.68A12,12,0,0,1,51.68,36.6L211.76,88.87a12,12,0,0,1,1.05,22.33l-.16.07-46.31,17.78a4,4,0,0,0-1.17,6.47Zm-5.66,5.66-51.31-51.32a12,12,0,0,1,3.7-19.49l.16-.06,46.31-17.79a3.95,3.95,0,0,0-.42-7.35L49.2,44.21a4,4,0,0,0-5,5L96.48,209.27a4,4,0,0,0,7.36.42l17.78-46.31a1.11,1.11,0,0,1,.07-.16,12,12,0,0,1,8.76-7,12.21,12.21,0,0,1,2.24-.21,12,12,0,0,1,8.49,3.52l51.31,51.31a4,4,0,0,0,5.65,0l12.69-12.69A4,4,0,0,0,210.83,192.49Z"
        }))
    ]
]);


const $499cedc40c55e7cb$export$e9e98f64fb597ccd = $7fPBF.forwardRef((c, e)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: e,
        ...c,
        weights: (0, $8870271a336384d8$export$2e2bcd8739ae039)
    }));
$499cedc40c55e7cb$export$e9e98f64fb597ccd.displayName = "CursorClickIcon";
const $499cedc40c55e7cb$export$58b4366001b3caa8 = $499cedc40c55e7cb$export$e9e98f64fb597ccd;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $11919b7ee5692f59$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M188,208a12,12,0,0,1-12,12H160a43.86,43.86,0,0,1-32-13.85A43.86,43.86,0,0,1,96,220H80a12,12,0,0,1,0-24H96a20,20,0,0,0,20-20V140H104a12,12,0,0,1,0-24h12V80A20,20,0,0,0,96,60H80a12,12,0,0,1,0-24H96a43.86,43.86,0,0,1,32,13.85A43.86,43.86,0,0,1,160,36h16a12,12,0,0,1,0,24H160a20,20,0,0,0-20,20v36h12a12,12,0,0,1,0,24H140v36a20,20,0,0,0,20,20h16A12,12,0,0,1,188,208Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,48V208H160a32,32,0,0,1-32-32,32,32,0,0,1-32,32H80V48H96a32,32,0,0,1,32,32,32,32,0,0,1,32-32Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184,208a8,8,0,0,1-8,8H160a40,40,0,0,1-32-16,40,40,0,0,1-32,16H80a8,8,0,0,1,0-16H96a24,24,0,0,0,24-24V136H104a8,8,0,0,1,0-16h16V80A24,24,0,0,0,96,56H80a8,8,0,0,1,0-16H96a40,40,0,0,1,32,16,40,40,0,0,1,32-16h16a8,8,0,0,1,0,16H160a24,24,0,0,0-24,24v40h16a8,8,0,0,1,0,16H136v40a24,24,0,0,0,24,24h16A8,8,0,0,1,184,208Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm-64,88a8,8,0,0,1,0,16h-8v24a16,16,0,0,0,16,16h8a8,8,0,0,1,0,16h-8a31.92,31.92,0,0,1-24-10.87A31.92,31.92,0,0,1,104,192H96a8,8,0,0,1,0-16h8a16,16,0,0,0,16-16V136h-8a8,8,0,0,1,0-16h8V96a16,16,0,0,0-16-16H96a8,8,0,0,1,0-16h8a31.92,31.92,0,0,1,24,10.87A31.92,31.92,0,0,1,152,64h8a8,8,0,0,1,0,16h-8a16,16,0,0,0-16,16v24Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M182,208a6,6,0,0,1-6,6H160a38,38,0,0,1-32-17.55A38,38,0,0,1,96,214H80a6,6,0,0,1,0-12H96a26,26,0,0,0,26-26V134H104a6,6,0,0,1,0-12h18V80A26,26,0,0,0,96,54H80a6,6,0,0,1,0-12H96a38,38,0,0,1,32,17.55A38,38,0,0,1,160,42h16a6,6,0,0,1,0,12H160a26,26,0,0,0-26,26v42h18a6,6,0,0,1,0,12H134v42a26,26,0,0,0,26,26h16A6,6,0,0,1,182,208Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184,208a8,8,0,0,1-8,8H160a40,40,0,0,1-32-16,40,40,0,0,1-32,16H80a8,8,0,0,1,0-16H96a24,24,0,0,0,24-24V136H104a8,8,0,0,1,0-16h16V80A24,24,0,0,0,96,56H80a8,8,0,0,1,0-16H96a40,40,0,0,1,32,16,40,40,0,0,1,32-16h16a8,8,0,0,1,0,16H160a24,24,0,0,0-24,24v40h16a8,8,0,0,1,0,16H136v40a24,24,0,0,0,24,24h16A8,8,0,0,1,184,208Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M180,208a4,4,0,0,1-4,4H160a36,36,0,0,1-32-19.54A36,36,0,0,1,96,212H80a4,4,0,0,1,0-8H96a28,28,0,0,0,28-28V132H104a4,4,0,0,1,0-8h20V80A28,28,0,0,0,96,52H80a4,4,0,0,1,0-8H96a36,36,0,0,1,32,19.54A36,36,0,0,1,160,44h16a4,4,0,0,1,0,8H160a28,28,0,0,0-28,28v44h20a4,4,0,0,1,0,8H132v44a28,28,0,0,0,28,28h16A4,4,0,0,1,180,208Z"
        }))
    ]
]);


const $991a051c44f6b41d$export$d665abe9390574dd = $7fPBF.forwardRef((e, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...e,
        weights: (0, $11919b7ee5692f59$export$2e2bcd8739ae039)
    }));
$991a051c44f6b41d$export$d665abe9390574dd.displayName = "CursorTextIcon";
const $991a051c44f6b41d$export$e024e28c94cb249a = $991a051c44f6b41d$export$d665abe9390574dd;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $22c2d7917fb17b0a$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,36H48A28,28,0,0,0,20,64V172a28,28,0,0,0,28,28h68v12H96a12,12,0,0,0,0,24h64a12,12,0,0,0,0-24H140V200h68a28,28,0,0,0,28-28V64A28,28,0,0,0,208,36ZM48,60H208a4,4,0,0,1,4,4v72H44V64A4,4,0,0,1,48,60ZM208,176H48a4,4,0,0,1-4-4V160H212v12A4,4,0,0,1,208,176Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,64v88H32V64A16,16,0,0,1,48,48H208A16,16,0,0,1,224,64Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,40H48A24,24,0,0,0,24,64V176a24,24,0,0,0,24,24h72v16H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16H136V200h72a24,24,0,0,0,24-24V64A24,24,0,0,0,208,40ZM48,56H208a8,8,0,0,1,8,8v80H40V64A8,8,0,0,1,48,56ZM208,184H48a8,8,0,0,1-8-8V160H216v16A8,8,0,0,1,208,184Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,40H48A24,24,0,0,0,24,64V176a24,24,0,0,0,24,24h72v16H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16H136V200h72a24,24,0,0,0,24-24V64A24,24,0,0,0,208,40Zm0,144H48a8,8,0,0,1-8-8V160H216v16A8,8,0,0,1,208,184Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,42H48A22,22,0,0,0,26,64V176a22,22,0,0,0,22,22h74v20H96a6,6,0,0,0,0,12h64a6,6,0,0,0,0-12H134V198h74a22,22,0,0,0,22-22V64A22,22,0,0,0,208,42ZM48,54H208a10,10,0,0,1,10,10v82H38V64A10,10,0,0,1,48,54ZM208,186H48a10,10,0,0,1-10-10V158H218v18A10,10,0,0,1,208,186Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,40H48A24,24,0,0,0,24,64V176a24,24,0,0,0,24,24h72v16H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16H136V200h72a24,24,0,0,0,24-24V64A24,24,0,0,0,208,40ZM48,56H208a8,8,0,0,1,8,8v80H40V64A8,8,0,0,1,48,56ZM208,184H48a8,8,0,0,1-8-8V160H216v16A8,8,0,0,1,208,184Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,44H48A20,20,0,0,0,28,64V176a20,20,0,0,0,20,20h76v24H96a4,4,0,0,0,0,8h64a4,4,0,0,0,0-8H132V196h76a20,20,0,0,0,20-20V64A20,20,0,0,0,208,44ZM48,52H208a12,12,0,0,1,12,12v84H36V64A12,12,0,0,1,48,52ZM208,188H48a12,12,0,0,1-12-12V156H220v20A12,12,0,0,1,208,188Z"
        }))
    ]
]);


const $db0aecd837df835e$export$78a6319cfd8cd037 = $7fPBF.forwardRef((t, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...t,
        weights: (0, $22c2d7917fb17b0a$export$2e2bcd8739ae039)
    }));
$db0aecd837df835e$export$78a6319cfd8cd037.displayName = "DesktopIcon";
const $db0aecd837df835e$export$eb8deef317734844 = $db0aecd837df835e$export$78a6319cfd8cd037;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $a7304b870f6f9cb3$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,12H80A28,28,0,0,0,52,40V216a28,28,0,0,0,28,28h96a28,28,0,0,0,28-28V40A28,28,0,0,0,176,12Zm4,204a4,4,0,0,1-4,4H80a4,4,0,0,1-4-4V40a4,4,0,0,1,4-4h96a4,4,0,0,1,4,4ZM164,64a12,12,0,0,1-12,12H104a12,12,0,0,1,0-24h48A12,12,0,0,1,164,64Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M192,40V216a16,16,0,0,1-16,16H80a16,16,0,0,1-16-16V40A16,16,0,0,1,80,24h96A16,16,0,0,1,192,40Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,16H80A24,24,0,0,0,56,40V216a24,24,0,0,0,24,24h96a24,24,0,0,0,24-24V40A24,24,0,0,0,176,16Zm8,200a8,8,0,0,1-8,8H80a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8ZM168,56a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,56Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,16H80A24,24,0,0,0,56,40V216a24,24,0,0,0,24,24h96a24,24,0,0,0,24-24V40A24,24,0,0,0,176,16ZM160,64H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,18H80A22,22,0,0,0,58,40V216a22,22,0,0,0,22,22h96a22,22,0,0,0,22-22V40A22,22,0,0,0,176,18Zm10,198a10,10,0,0,1-10,10H80a10,10,0,0,1-10-10V40A10,10,0,0,1,80,30h96a10,10,0,0,1,10,10ZM166,56a6,6,0,0,1-6,6H96a6,6,0,0,1,0-12h64A6,6,0,0,1,166,56Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,16H80A24,24,0,0,0,56,40V216a24,24,0,0,0,24,24h96a24,24,0,0,0,24-24V40A24,24,0,0,0,176,16Zm8,200a8,8,0,0,1-8,8H80a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8ZM168,56a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,56Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,20H80A20,20,0,0,0,60,40V216a20,20,0,0,0,20,20h96a20,20,0,0,0,20-20V40A20,20,0,0,0,176,20Zm12,196a12,12,0,0,1-12,12H80a12,12,0,0,1-12-12V40A12,12,0,0,1,80,28h96a12,12,0,0,1,12,12ZM164,56a4,4,0,0,1-4,4H96a4,4,0,0,1,0-8h64A4,4,0,0,1,164,56Z"
        }))
    ]
]);


const $32f3456307b486ee$export$86748a064d6b172 = $7fPBF.forwardRef((r, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: a,
        ...r,
        weights: (0, $a7304b870f6f9cb3$export$2e2bcd8739ae039)
    }));
$32f3456307b486ee$export$86748a064d6b172.displayName = "DeviceMobileSpeakerIcon";
const $32f3456307b486ee$export$381410f2d0f9f87b = $32f3456307b486ee$export$86748a064d6b172;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $e638bac1ebea6382$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,72H212V64a28,28,0,0,0-28-28H40A28,28,0,0,0,12,64v88a28,28,0,0,0,28,28h96v12a28,28,0,0,0,28,28h60a28,28,0,0,0,28-28V100A28,28,0,0,0,224,72ZM40,156a4,4,0,0,1-4-4V64a4,4,0,0,1,4-4H184a4,4,0,0,1,4,4v8H164a28,28,0,0,0-28,28v56Zm188,36a4,4,0,0,1-4,4H164a4,4,0,0,1-4-4V100a4,4,0,0,1,4-4h60a4,4,0,0,1,4,4ZM124,208a12,12,0,0,1-12,12H88a12,12,0,0,1,0-24h24A12,12,0,0,1,124,208Zm88-84a12,12,0,0,1-12,12H188a12,12,0,0,1,0-24h12A12,12,0,0,1,212,124Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,64V80H176a16,16,0,0,0-16,16v80H40a16,16,0,0,1-16-16V64A16,16,0,0,1,40,48H184A16,16,0,0,1,200,64Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,72H208V64a24,24,0,0,0-24-24H40A24,24,0,0,0,16,64v96a24,24,0,0,0,24,24H152v8a24,24,0,0,0,24,24h48a24,24,0,0,0,24-24V96A24,24,0,0,0,224,72ZM40,168a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8v8H176a24,24,0,0,0-24,24v72Zm192,24a8,8,0,0,1-8,8H176a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8Zm-96,16a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h40A8,8,0,0,1,136,208Zm80-96a8,8,0,0,1-8,8H192a8,8,0,0,1,0-16h16A8,8,0,0,1,216,112Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,72H208V64a24,24,0,0,0-24-24H40A24,24,0,0,0,16,64v96a24,24,0,0,0,24,24H152v8a24,24,0,0,0,24,24h48a24,24,0,0,0,24-24V96A24,24,0,0,0,224,72Zm8,120a8,8,0,0,1-8,8H176a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8Zm-96,16a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h40A8,8,0,0,1,136,208Zm80-96a8,8,0,0,1-8,8H192a8,8,0,0,1,0-16h16A8,8,0,0,1,216,112Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,74H206V64a22,22,0,0,0-22-22H40A22,22,0,0,0,18,64v96a22,22,0,0,0,22,22H154v10a22,22,0,0,0,22,22h48a22,22,0,0,0,22-22V96A22,22,0,0,0,224,74ZM40,170a10,10,0,0,1-10-10V64A10,10,0,0,1,40,54H184a10,10,0,0,1,10,10V74H176a22,22,0,0,0-22,22v74Zm194,22a10,10,0,0,1-10,10H176a10,10,0,0,1-10-10V96a10,10,0,0,1,10-10h48a10,10,0,0,1,10,10ZM134,208a6,6,0,0,1-6,6H88a6,6,0,0,1,0-12h40A6,6,0,0,1,134,208Zm80-96a6,6,0,0,1-6,6H192a6,6,0,0,1,0-12h16A6,6,0,0,1,214,112Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,72H208V64a24,24,0,0,0-24-24H40A24,24,0,0,0,16,64v96a24,24,0,0,0,24,24H152v8a24,24,0,0,0,24,24h48a24,24,0,0,0,24-24V96A24,24,0,0,0,224,72ZM40,168a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8v8H176a24,24,0,0,0-24,24v72Zm192,24a8,8,0,0,1-8,8H176a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8Zm-96,16a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h40A8,8,0,0,1,136,208Zm80-96a8,8,0,0,1-8,8H192a8,8,0,0,1,0-16h16A8,8,0,0,1,216,112Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,76H204V64a20,20,0,0,0-20-20H40A20,20,0,0,0,20,64v96a20,20,0,0,0,20,20H156v12a20,20,0,0,0,20,20h48a20,20,0,0,0,20-20V96A20,20,0,0,0,224,76ZM40,172a12,12,0,0,1-12-12V64A12,12,0,0,1,40,52H184a12,12,0,0,1,12,12V76H176a20,20,0,0,0-20,20v76Zm196,20a12,12,0,0,1-12,12H176a12,12,0,0,1-12-12V96a12,12,0,0,1,12-12h48a12,12,0,0,1,12,12ZM132,208a4,4,0,0,1-4,4H88a4,4,0,0,1,0-8h40A4,4,0,0,1,132,208Zm80-96a4,4,0,0,1-4,4H192a4,4,0,0,1,0-8h16A4,4,0,0,1,212,112Z"
        }))
    ]
]);


const $0536198cc436fd7c$export$ba4cac3c471c5034 = $7fPBF.forwardRef((c, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...c,
        weights: (0, $e638bac1ebea6382$export$2e2bcd8739ae039)
    }));
$0536198cc436fd7c$export$ba4cac3c471c5034.displayName = "DevicesIcon";
const $0536198cc436fd7c$export$5dedfd1a2dcba3c6 = $0536198cc436fd7c$export$ba4cac3c471c5034;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $141ac8d6fc74c419$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M124,60.78V16a12,12,0,0,0-24,0V60.78a92,92,0,1,0,24,0ZM178.92,140h-23.4c-1.64-20.74-7.36-37-13.81-49.15A68.23,68.23,0,0,1,178.92,140ZM112,215c-7-8.62-17-25.09-19.45-51h38.9C129,189.9,119,206.37,112,215ZM92.55,140C95,114.1,105,97.63,112,89c7,8.62,17,25.09,19.45,51ZM82.29,90.85C75.84,103,70.12,119.26,68.48,140H45.08A68.23,68.23,0,0,1,82.29,90.85ZM45.08,164h23.4c1.64,20.74,7.36,37,13.81,49.15A68.23,68.23,0,0,1,45.08,164Zm96.63,49.15c6.45-12.15,12.17-28.41,13.81-49.15h23.4A68.23,68.23,0,0,1,141.71,213.15ZM256,88a12,12,0,0,1-12,12h-4v4a12,12,0,0,1-24,0v-4h-4a12,12,0,0,1,0-24h4V72a12,12,0,0,1,24,0v4h4A12,12,0,0,1,256,88ZM148,36a12,12,0,0,1,12-12h8V16a12,12,0,0,1,24,0v8h8a12,12,0,0,1,0,24h-8v8a12,12,0,0,1-24,0V48h-8A12,12,0,0,1,148,36Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M192,152a80,80,0,0,1-80,80s32-24,32-80ZM112,72S80,96,80,152h64C144,96,112,72,112,72Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M120,64.37V16a8,8,0,0,0-16,0V64.37a88,88,0,1,0,16,0ZM183.54,144H151.77c-1.51-28.36-10.79-48.36-19.44-61.06A72.16,72.16,0,0,1,183.54,144Zm-95.3,16h47.52c-2,33.52-16.13,52.95-23.76,61.08C104.36,212.93,90.23,193.51,88.24,160Zm0-16c2-33.52,16.13-52.95,23.76-61.08,7.64,8.15,21.77,27.57,23.76,61.08Zm3.43-61.06C83,95.64,73.74,115.64,72.23,144H40.46A72.16,72.16,0,0,1,91.67,82.94ZM40.46,160H72.23c1.51,28.36,10.79,48.36,19.44,61.06A72.16,72.16,0,0,1,40.46,160Zm91.87,61.06c8.65-12.7,17.93-32.7,19.44-61.06h31.77A72.16,72.16,0,0,1,132.33,221.06ZM256,88a8,8,0,0,1-8,8h-8v8a8,8,0,0,1-16,0V96h-8a8,8,0,0,1,0-16h8V72a8,8,0,0,1,16,0v8h8A8,8,0,0,1,256,88ZM152,40a8,8,0,0,1,8-8h16V16a8,8,0,0,1,16,0V32h16a8,8,0,0,1,0,16H192V64a8,8,0,0,1-16,0V48H160A8,8,0,0,1,152,40Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M120,64.37V16a8,8,0,0,0-16,0V64.37a88,88,0,1,0,16,0ZM183.54,144H151.77c-1.51-28.36-10.79-48.36-19.44-61.06A72.16,72.16,0,0,1,183.54,144Zm-47.78,16c-2,33.52-16.13,52.95-23.76,61.08-7.64-8.15-21.77-27.57-23.76-61.08ZM91.67,82.94C83,95.64,73.74,115.64,72.23,144H40.46A72.16,72.16,0,0,1,91.67,82.94ZM40.46,160H72.23c1.51,28.36,10.79,48.36,19.44,61.06A72.16,72.16,0,0,1,40.46,160ZM256,88a8,8,0,0,1-8,8h-8v8a8,8,0,0,1-16,0V96h-8a8,8,0,0,1,0-16h8V72a8,8,0,0,1,16,0v8h8A8,8,0,0,1,256,88ZM152,40a8,8,0,0,1,8-8h16V16a8,8,0,0,1,16,0V32h16a8,8,0,0,1,0,16H192V64a8,8,0,0,1-16,0V48H160A8,8,0,0,1,152,40Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M118,66.23V16a6,6,0,0,0-12,0V66.23a86,86,0,1,0,12,0ZM185.74,146H149.87c-1.3-32.59-13-54.15-22.36-66.35A74.15,74.15,0,0,1,185.74,146Zm-99.6,12h51.72c-1.63,37.69-18.33,58.46-25.86,66C104.46,216.45,87.77,195.67,86.14,158Zm0-12c1.63-37.69,18.33-58.46,25.86-66,7.54,7.51,24.23,28.29,25.86,66ZM96.49,79.65C87.11,91.85,75.43,113.41,74.13,146H38.26A74.15,74.15,0,0,1,96.49,79.65ZM38.26,158H74.13c1.3,32.59,13,54.15,22.36,66.35A74.15,74.15,0,0,1,38.26,158Zm89.25,66.35c9.38-12.2,21.06-33.76,22.36-66.35h35.87A74.15,74.15,0,0,1,127.51,224.35ZM254,88a6,6,0,0,1-6,6H238v10a6,6,0,0,1-12,0V94H216a6,6,0,0,1,0-12h10V72a6,6,0,0,1,12,0V82h10A6,6,0,0,1,254,88ZM208,46H190V64a6,6,0,0,1-12,0V46H160a6,6,0,0,1,0-12h18V16a6,6,0,0,1,12,0V34h18a6,6,0,0,1,0,12Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M120,64.37V16a8,8,0,0,0-16,0V64.37a88,88,0,1,0,16,0ZM183.54,144H151.77c-1.51-28.36-10.79-48.36-19.44-61.06A72.16,72.16,0,0,1,183.54,144Zm-95.3,16h47.52c-2,33.52-16.13,52.95-23.76,61.08C104.36,212.93,90.23,193.51,88.24,160Zm0-16c2-33.52,16.13-52.95,23.76-61.08,7.64,8.15,21.77,27.57,23.76,61.08Zm3.43-61.06C83,95.64,73.74,115.64,72.23,144H40.46A72.16,72.16,0,0,1,91.67,82.94ZM40.46,160H72.23c1.51,28.36,10.79,48.36,19.44,61.06A72.16,72.16,0,0,1,40.46,160Zm91.87,61.06c8.65-12.7,17.93-32.7,19.44-61.06h31.77A72.16,72.16,0,0,1,132.33,221.06ZM256,88a8,8,0,0,1-8,8h-8v8a8,8,0,0,1-16,0V96h-8a8,8,0,0,1,0-16h8V72a8,8,0,0,1,16,0v8h8A8,8,0,0,1,256,88ZM152,40a8,8,0,0,1,8-8h16V16a8,8,0,0,1,16,0V32h16a8,8,0,0,1,0,16H192V64a8,8,0,0,1-16,0V48H160A8,8,0,0,1,152,40Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M116,68.1V16a4,4,0,0,0-8,0V68.1a84,84,0,1,0,8,0ZM187.89,148h-40c-1-37.34-15.73-60.22-25.35-71.25A76.12,76.12,0,0,1,187.89,148ZM112,226.68C105,220,85.26,197.61,84.06,156h55.88C138.74,197.61,119,220,112,226.68ZM84.06,148c1.2-41.61,21-64,27.94-70.68,7,6.64,26.74,29.07,27.94,70.68Zm17.36-71.25c-9.62,11-24.35,33.91-25.35,71.25h-40A76.12,76.12,0,0,1,101.42,76.75ZM36.11,156h40c1,37.34,15.73,60.22,25.35,71.25A76.12,76.12,0,0,1,36.11,156Zm86.47,71.25c9.62-11,24.35-33.91,25.35-71.25h40A76.12,76.12,0,0,1,122.58,227.25ZM252,88a4,4,0,0,1-4,4H236v12a4,4,0,0,1-8,0V92H216a4,4,0,0,1,0-8h12V72a4,4,0,0,1,8,0V84h12A4,4,0,0,1,252,88ZM212,40a4,4,0,0,1-4,4H188V64a4,4,0,0,1-8,0V44H160a4,4,0,0,1,0-8h20V16a4,4,0,0,1,8,0V36h20A4,4,0,0,1,212,40Z"
        }))
    ]
]);


const $8140d5c711c8dac2$export$f8943b539a4bce42 = $7fPBF.forwardRef((c, e)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: e,
        ...c,
        weights: (0, $141ac8d6fc74c419$export$2e2bcd8739ae039)
    }));
$8140d5c711c8dac2$export$f8943b539a4bce42.displayName = "DiscoBallIcon";
const $8140d5c711c8dac2$export$4edc83027ccd2aaa = $8140d5c711c8dac2$export$f8943b539a4bce42;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $e15b8534886ff13b$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Zm-16-84a16,16,0,1,1-16-16A16,16,0,0,1,112,128Zm64,0a16,16,0,1,1-16-16A16,16,0,0,1,176,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm56-88a12,12,0,1,1-12-12A12,12,0,0,1,184,128Zm-44,0a12,12,0,1,1-12-12A12,12,0,0,1,140,128Zm-44,0a12,12,0,1,1-12-12A12,12,0,0,1,96,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.13,104.13,0,0,0,128,24ZM84,140a12,12,0,1,1,12-12A12,12,0,0,1,84,140Zm44,0a12,12,0,1,1,12-12A12,12,0,0,1,128,140Zm44,0a12,12,0,1,1,12-12A12,12,0,0,1,172,140Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Zm10-90a10,10,0,1,1-10-10A10,10,0,0,1,138,128Zm-44,0a10,10,0,1,1-10-10A10,10,0,0,1,94,128Zm88,0a10,10,0,1,1-10-10A10,10,0,0,1,182,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm12-88a12,12,0,1,1-12-12A12,12,0,0,1,140,128Zm44,0a12,12,0,1,1-12-12A12,12,0,0,1,184,128Zm-88,0a12,12,0,1,1-12-12A12,12,0,0,1,96,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Zm8-92a8,8,0,1,1-8-8A8,8,0,0,1,136,128Zm-44,0a8,8,0,1,1-8-8A8,8,0,0,1,92,128Zm88,0a8,8,0,1,1-8-8A8,8,0,0,1,180,128Z"
        }))
    ]
]);


const $88db7d04aef0c70c$export$fc32f3c5f46e7c02 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...r,
        weights: (0, $e15b8534886ff13b$export$2e2bcd8739ae039)
    }));
$88db7d04aef0c70c$export$fc32f3c5f46e7c02.displayName = "DotsThreeCircleIcon";
const $88db7d04aef0c70c$export$f88267bb2bc25651 = $88db7d04aef0c70c$export$fc32f3c5f46e7c02;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $6ebd1719734e5ea6$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228,144v64a12,12,0,0,1-12,12H40a12,12,0,0,1-12-12V144a12,12,0,0,1,24,0v52H204V144a12,12,0,0,1,24,0Zm-108.49,8.49a12,12,0,0,0,17,0l40-40a12,12,0,0,0-17-17L140,115V32a12,12,0,0,0-24,0v83L96.49,95.51a12,12,0,0,0-17,17Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,48V208H40V48A16,16,0,0,1,56,32H200A16,16,0,0,1,216,48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0Zm-101.66,5.66a8,8,0,0,0,11.32,0l40-40a8,8,0,0,0-11.32-11.32L136,124.69V32a8,8,0,0,0-16,0v92.69L93.66,98.34a8,8,0,0,0-11.32,11.32Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0Zm-101.66,5.66a8,8,0,0,0,11.32,0l40-40A8,8,0,0,0,168,96H136V32a8,8,0,0,0-16,0V96H88a8,8,0,0,0-5.66,13.66Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M222,144v64a6,6,0,0,1-6,6H40a6,6,0,0,1-6-6V144a6,6,0,0,1,12,0v58H210V144a6,6,0,0,1,12,0Zm-98.24,4.24a6,6,0,0,0,8.48,0l40-40a6,6,0,0,0-8.48-8.48L134,129.51V32a6,6,0,0,0-12,0v97.51L92.24,99.76a6,6,0,0,0-8.48,8.48Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0Zm-101.66,5.66a8,8,0,0,0,11.32,0l40-40a8,8,0,0,0-11.32-11.32L136,124.69V32a8,8,0,0,0-16,0v92.69L93.66,98.34a8,8,0,0,0-11.32,11.32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220,144v64a4,4,0,0,1-4,4H40a4,4,0,0,1-4-4V144a4,4,0,0,1,8,0v60H212V144a4,4,0,0,1,8,0Zm-94.83,2.83a4,4,0,0,0,5.66,0l40-40a4,4,0,1,0-5.66-5.66L132,134.34V32a4,4,0,0,0-8,0V134.34L90.83,101.17a4,4,0,0,0-5.66,5.66Z"
        }))
    ]
]);


const $3d7aae5ab6f8c20e$export$5e12dc2d5a33c663 = $7fPBF.forwardRef((a, m)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: m,
        ...a,
        weights: (0, $6ebd1719734e5ea6$export$2e2bcd8739ae039)
    }));
$3d7aae5ab6f8c20e$export$5e12dc2d5a33c663.displayName = "DownloadSimpleIcon";
const $3d7aae5ab6f8c20e$export$4386181bcb914e5a = $3d7aae5ab6f8c20e$export$5e12dc2d5a33c663;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $9796377d97a00c44$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,44H32A12,12,0,0,0,20,56V192a20,20,0,0,0,20,20H216a20,20,0,0,0,20-20V56A12,12,0,0,0,224,44Zm-96,83.72L62.85,68h130.3ZM92.79,128,44,172.72V83.28Zm17.76,16.28,9.34,8.57a12,12,0,0,0,16.22,0l9.34-8.57L193.15,188H62.85ZM163.21,128,212,83.28v89.44Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,56l-96,88L32,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48Zm-96,85.15L52.57,64H203.43ZM98.71,128,40,181.81V74.19Zm11.84,10.85,12,11.05a8,8,0,0,0,10.82,0l12-11.05,58,53.15H52.57ZM157.29,128,216,74.18V181.82Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM98.71,128,40,181.81V74.19Zm11.84,10.85,12,11.05a8,8,0,0,0,10.82,0l12-11.05,58,53.15H52.57ZM157.29,128,216,74.18V181.82Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,50H32a6,6,0,0,0-6,6V192a14,14,0,0,0,14,14H216a14,14,0,0,0,14-14V56A6,6,0,0,0,224,50Zm-96,85.86L47.42,62H208.58ZM101.67,128,38,186.36V69.64Zm8.88,8.14L124,148.42a6,6,0,0,0,8.1,0l13.4-12.28L208.58,194H47.43ZM154.33,128,218,69.64V186.36Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48Zm-96,85.15L52.57,64H203.43ZM98.71,128,40,181.81V74.19Zm11.84,10.85,12,11.05a8,8,0,0,0,10.82,0l12-11.05,58,53.15H52.57ZM157.29,128,216,74.18V181.82Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,52H32a4,4,0,0,0-4,4V192a12,12,0,0,0,12,12H216a12,12,0,0,0,12-12V56A4,4,0,0,0,224,52Zm-96,86.57L42.28,60H213.72ZM104.63,128,36,190.91V65.09Zm5.92,5.43L125.3,147a4,4,0,0,0,5.4,0l14.75-13.52L213.72,196H42.28ZM151.37,128,220,65.09V190.91Z"
        }))
    ]
]);


const $356076885242800f$export$ea4109706c07d076 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...r,
        weights: (0, $9796377d97a00c44$export$2e2bcd8739ae039)
    }));
$356076885242800f$export$ea4109706c07d076.displayName = "EnvelopeIcon";
const $356076885242800f$export$4e2d65a9843399df = $356076885242800f$export$ea4109706c07d076;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $edb6dda74892d4bb$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M251,123.13c-.37-.81-9.13-20.26-28.48-39.61C196.63,57.67,164,44,128,44S59.37,57.67,33.51,83.52C14.16,102.87,5.4,122.32,5,123.13a12.08,12.08,0,0,0,0,9.75c.37.82,9.13,20.26,28.49,39.61C59.37,198.34,92,212,128,212s68.63-13.66,94.48-39.51c19.36-19.35,28.12-38.79,28.49-39.61A12.08,12.08,0,0,0,251,123.13Zm-46.06,33C183.47,177.27,157.59,188,128,188s-55.47-10.73-76.91-31.88A130.36,130.36,0,0,1,29.52,128,130.45,130.45,0,0,1,51.09,99.89C72.54,78.73,98.41,68,128,68s55.46,10.73,76.91,31.89A130.36,130.36,0,0,1,226.48,128,130.45,130.45,0,0,1,204.91,156.12ZM128,84a44,44,0,1,0,44,44A44.05,44.05,0,0,0,128,84Zm0,64a20,20,0,1,1,20-20A20,20,0,0,1,128,148Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,56C48,56,16,128,16,128s32,72,112,72,112-72,112-72S208,56,128,56Zm0,112a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.47,133.47,0,0,1,25,128,133.33,133.33,0,0,1,48.07,97.25C70.33,75.19,97.22,64,128,64s57.67,11.19,79.93,33.25A133.46,133.46,0,0,1,231.05,128C223.84,141.46,192.43,192,128,192Zm0-112a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,168a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M245.48,125.57c-.34-.78-8.66-19.23-27.24-37.81C201,70.54,171.38,50,128,50S55,70.54,37.76,87.76c-18.58,18.58-26.9,37-27.24,37.81a6,6,0,0,0,0,4.88c.34.77,8.66,19.22,27.24,37.8C55,185.47,84.62,206,128,206s73-20.53,90.24-37.75c18.58-18.58,26.9-37,27.24-37.8A6,6,0,0,0,245.48,125.57ZM128,194c-31.38,0-58.78-11.42-81.45-33.93A134.77,134.77,0,0,1,22.69,128,134.56,134.56,0,0,1,46.55,95.94C69.22,73.42,96.62,62,128,62s58.78,11.42,81.45,33.94A134.56,134.56,0,0,1,233.31,128C226.94,140.21,195,194,128,194Zm0-112a46,46,0,1,0,46,46A46.06,46.06,0,0,0,128,82Zm0,80a34,34,0,1,1,34-34A34,34,0,0,1,128,162Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.47,133.47,0,0,1,25,128,133.33,133.33,0,0,1,48.07,97.25C70.33,75.19,97.22,64,128,64s57.67,11.19,79.93,33.25A133.46,133.46,0,0,1,231.05,128C223.84,141.46,192.43,192,128,192Zm0-112a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M243.66,126.38c-.34-.76-8.52-18.89-26.83-37.2C199.87,72.22,170.7,52,128,52S56.13,72.22,39.17,89.18c-18.31,18.31-26.49,36.44-26.83,37.2a4.08,4.08,0,0,0,0,3.25c.34.77,8.52,18.89,26.83,37.2,17,17,46.14,37.17,88.83,37.17s71.87-20.21,88.83-37.17c18.31-18.31,26.49-36.43,26.83-37.2A4.08,4.08,0,0,0,243.66,126.38Zm-32.7,35c-23.07,23-51,34.62-83,34.62s-59.89-11.65-83-34.62A135.71,135.71,0,0,1,20.44,128,135.69,135.69,0,0,1,45,94.62C68.11,71.65,96,60,128,60s59.89,11.65,83,34.62A135.79,135.79,0,0,1,235.56,128,135.71,135.71,0,0,1,211,161.38ZM128,84a44,44,0,1,0,44,44A44.05,44.05,0,0,0,128,84Zm0,80a36,36,0,1,1,36-36A36,36,0,0,1,128,164Z"
        }))
    ]
]);


const $41331bef289ddf9d$export$4b2c798a70974642 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...r,
        weights: (0, $edb6dda74892d4bb$export$2e2bcd8739ae039)
    }));
$41331bef289ddf9d$export$4b2c798a70974642.displayName = "EyeIcon";
const $41331bef289ddf9d$export$c42ab4f9cd72fed3 = $41331bef289ddf9d$export$4b2c798a70974642;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $6d5e934c9d793b75$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M56.88,31.93A12,12,0,1,0,39.12,48.07l16,17.65C20.67,88.66,5.72,121.58,5,123.13a12.08,12.08,0,0,0,0,9.75c.37.82,9.13,20.26,28.49,39.61C59.37,198.34,92,212,128,212a131.34,131.34,0,0,0,51-10l20.09,22.1a12,12,0,0,0,17.76-16.14ZM128,188c-29.59,0-55.47-10.73-76.91-31.88A130.69,130.69,0,0,1,29.52,128c5.27-9.31,18.79-29.9,42-44.29l90.09,99.11A109.33,109.33,0,0,1,128,188Zm123-55.12c-.36.81-9,20-28,39.16a12,12,0,1,1-17-16.9A130.48,130.48,0,0,0,226.48,128a130.36,130.36,0,0,0-21.57-28.12C183.46,78.73,157.59,68,128,68c-3.35,0-6.7.14-10,.42a12,12,0,1,1-2-23.91c3.93-.34,8-.51,12-.51,36,0,68.63,13.67,94.49,39.52,19.35,19.35,28.11,38.8,28.48,39.61A12.08,12.08,0,0,1,251,132.88Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,56C48,56,16,128,16,128s32,72,112,72,112-72,112-72S208,56,128,56Zm0,112a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M53.92,34.62A8,8,0,1,0,42.08,45.38L61.32,66.55C25,88.84,9.38,123.2,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208a127.11,127.11,0,0,0,52.07-10.83l22,24.21a8,8,0,1,0,11.84-10.76Zm47.33,75.84,41.67,45.85a32,32,0,0,1-41.67-45.85ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.16,133.16,0,0,1,25,128c4.69-8.79,19.66-33.39,47.35-49.38l18,19.75a48,48,0,0,0,63.66,70l14.73,16.2A112,112,0,0,1,128,192Zm6-95.43a8,8,0,0,1,3-15.72,48.16,48.16,0,0,1,38.77,42.64,8,8,0,0,1-7.22,8.71,6.39,6.39,0,0,1-.75,0,8,8,0,0,1-8-7.26A32.09,32.09,0,0,0,134,96.57Zm113.28,34.69c-.42.94-10.55,23.37-33.36,43.8a8,8,0,1,1-10.67-11.92A132.77,132.77,0,0,0,231.05,128a133.15,133.15,0,0,0-23.12-30.77C185.67,75.19,158.78,64,128,64a118.37,118.37,0,0,0-19.36,1.57A8,8,0,1,1,106,49.79,134,134,0,0,1,128,48c34.88,0,66.57,13.26,91.66,38.35,18.83,18.83,27.3,37.62,27.65,38.41A8,8,0,0,1,247.31,131.26Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M96.68,57.87a4,4,0,0,1,2.08-6.6A130.13,130.13,0,0,1,128,48c34.88,0,66.57,13.26,91.66,38.35,18.83,18.83,27.3,37.62,27.65,38.41a8,8,0,0,1,0,6.5c-.35.79-8.82,19.57-27.65,38.4q-4.28,4.26-8.79,8.07a4,4,0,0,1-5.55-.36ZM213.92,210.62a8,8,0,1,1-11.84,10.76L180,197.13A127.21,127.21,0,0,1,128,208c-34.88,0-66.57-13.26-91.66-38.34C17.51,150.83,9,132.05,8.69,131.26a8,8,0,0,1,0-6.5C9,124,17.51,105.18,36.34,86.35a135,135,0,0,1,25-19.78L42.08,45.38A8,8,0,1,1,53.92,34.62Zm-65.49-48.25-52.69-58a40,40,0,0,0,52.69,58Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M52.44,36A6,6,0,0,0,43.56,44L64.44,67c-37.28,21.9-53.23,57-53.92,58.57a6,6,0,0,0,0,4.88c.34.77,8.66,19.22,27.24,37.8C55,185.47,84.62,206,128,206a124.91,124.91,0,0,0,52.57-11.25l23,25.29a6,6,0,0,0,8.88-8.08Zm48.62,71.32,45,49.52a34,34,0,0,1-45-49.52ZM128,194c-31.38,0-58.78-11.42-81.45-33.93A134.57,134.57,0,0,1,22.69,128c4.29-8.2,20.1-35.18,50-51.91L92.89,98.3a46,46,0,0,0,61.35,67.48l17.81,19.6A113.47,113.47,0,0,1,128,194Zm6.4-99.4a6,6,0,0,1,2.25-11.79,46.17,46.17,0,0,1,37.15,40.87,6,6,0,0,1-5.42,6.53l-.56,0a6,6,0,0,1-6-5.45A34.1,34.1,0,0,0,134.4,94.6Zm111.08,35.85c-.41.92-10.37,23-32.86,43.12a6,6,0,1,1-8-8.94A134.07,134.07,0,0,0,233.31,128a134.67,134.67,0,0,0-23.86-32.07C186.78,73.42,159.38,62,128,62a120.19,120.19,0,0,0-19.69,1.6,6,6,0,1,1-2-11.83A131.12,131.12,0,0,1,128,50c43.38,0,73,20.54,90.24,37.76,18.58,18.58,26.9,37,27.24,37.81A6,6,0,0,1,245.48,130.45Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M53.92,34.62A8,8,0,1,0,42.08,45.38L61.32,66.55C25,88.84,9.38,123.2,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208a127.11,127.11,0,0,0,52.07-10.83l22,24.21a8,8,0,1,0,11.84-10.76Zm47.33,75.84,41.67,45.85a32,32,0,0,1-41.67-45.85ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.16,133.16,0,0,1,25,128c4.69-8.79,19.66-33.39,47.35-49.38l18,19.75a48,48,0,0,0,63.66,70l14.73,16.2A112,112,0,0,1,128,192Zm6-95.43a8,8,0,0,1,3-15.72,48.16,48.16,0,0,1,38.77,42.64,8,8,0,0,1-7.22,8.71,6.39,6.39,0,0,1-.75,0,8,8,0,0,1-8-7.26A32.09,32.09,0,0,0,134,96.57Zm113.28,34.69c-.42.94-10.55,23.37-33.36,43.8a8,8,0,1,1-10.67-11.92A132.77,132.77,0,0,0,231.05,128a133.15,133.15,0,0,0-23.12-30.77C185.67,75.19,158.78,64,128,64a118.37,118.37,0,0,0-19.36,1.57A8,8,0,1,1,106,49.79,134,134,0,0,1,128,48c34.88,0,66.57,13.26,91.66,38.35,18.83,18.83,27.3,37.62,27.65,38.41A8,8,0,0,1,247.31,131.26Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M51,37.31A4,4,0,0,0,45,42.69L67.59,67.5C29.34,89,13,124.81,12.34,126.38a4.08,4.08,0,0,0,0,3.25c.34.77,8.52,18.89,26.83,37.2,17,17,46.14,37.17,88.83,37.17a122.59,122.59,0,0,0,53.06-11.69l24,26.38a4,4,0,1,0,5.92-5.38ZM149.1,157.16A36,36,0,0,1,101,104.22ZM128,196c-32,0-59.89-11.65-83-34.62A135.81,135.81,0,0,1,20.44,128c3.65-7.23,20.09-36.81,52.68-54.43l22.45,24.7a44,44,0,0,0,59,64.83l20.89,23A114.94,114.94,0,0,1,128,196Zm6.78-103.36a4,4,0,0,1,1.49-7.86,44.15,44.15,0,0,1,35.54,39.09,4,4,0,0,1-3.61,4.35l-.38,0a4,4,0,0,1-4-3.63A36.1,36.1,0,0,0,134.78,92.64Zm108.88,37c-.41.91-10.2,22.58-32.38,42.45a4,4,0,0,1-2.67,1,4,4,0,0,1-2.67-7A136.71,136.71,0,0,0,235.56,128,136.07,136.07,0,0,0,211,94.62C187.89,71.65,160,60,128,60a122,122,0,0,0-20,1.63,4,4,0,0,1-1.32-7.89A129.3,129.3,0,0,1,128,52c42.7,0,71.87,20.22,88.83,37.18,18.31,18.31,26.49,36.44,26.83,37.2A4.08,4.08,0,0,1,243.66,129.63Z"
        }))
    ]
]);


const $0987fb0e4a894127$export$a3d42ccaf02d165b = $7fPBF.forwardRef((a, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...a,
        weights: (0, $6d5e934c9d793b75$export$2e2bcd8739ae039)
    }));
$0987fb0e4a894127$export$a3d42ccaf02d165b.displayName = "EyeSlashIcon";
const $0987fb0e4a894127$export$540b644af6247088 = $0987fb0e4a894127$export$a3d42ccaf02d165b;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $9fa701b2d2a478cb$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M100,152v56a12,12,0,0,1-24,0V190.07l-6.17,8.81a12,12,0,0,1-19.66,0L44,190.07V208a12,12,0,0,1-24,0V152a12,12,0,0,1,21.83-6.88L60,171.07l18.17-25.95A12,12,0,0,1,100,152Zm84,28a40,40,0,0,1-40,40H128a12,12,0,0,1-12-12V152a12,12,0,0,1,12-12h16A40,40,0,0,1,184,180Zm-24,0a16,16,0,0,0-16-16h-4v32h4A16,16,0,0,0,160,180Zm60-92V224a12,12,0,0,1-24,0V104H148a12,12,0,0,1-12-12V44H60v64a12,12,0,0,1-24,0V40A20,20,0,0,1,56,20h96a12,12,0,0,1,8.49,3.52l56,56A12,12,0,0,1,220,88Zm-60-8h23L160,57Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,88H152V32Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40v72a8,8,0,0,0,16,0V40h88V88a8,8,0,0,0,8,8h48V224a8,8,0,0,0,16,0V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM144,144H128a8,8,0,0,0-8,8v56a8,8,0,0,0,8,8h16a36,36,0,0,0,0-72Zm0,56h-8V160h8a20,20,0,0,1,0,40Zm-40-48v56a8,8,0,0,1-16,0V177.38L74.55,196.59a8,8,0,0,1-13.1,0L48,177.38V208a8,8,0,0,1-16,0V152a8,8,0,0,1,14.55-4.59L68,178.05l21.45-30.64A8,8,0,0,1,104,152Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40v76a4,4,0,0,0,4,4H196a4,4,0,0,1,4,4V224a8,8,0,0,0,9.19,7.91,8.15,8.15,0,0,0,6.81-8.16V88A8,8,0,0,0,213.66,82.34ZM152,88V44l44,44Zm-8,56H128a8,8,0,0,0-8,8v56a8,8,0,0,0,8,8h15.32c19.66,0,36.21-15.48,36.67-35.13A36,36,0,0,0,144,144Zm-.49,56H136V160h8a20,20,0,0,1,20,20.77C163.58,191.59,154.34,200,143.51,200ZM104,152v55.73A8.17,8.17,0,0,1,96.53,216,8,8,0,0,1,88,208V177.38l-13.32,19a8.3,8.3,0,0,1-4.2,3.2,8,8,0,0,1-9-3L48,177.38v30.35A8.17,8.17,0,0,1,40.53,216,8,8,0,0,1,32,208V152.31a8.27,8.27,0,0,1,4.56-7.53,8,8,0,0,1,10,2.63L68,178.05l21.27-30.39a8.28,8.28,0,0,1,8.06-3.55A8,8,0,0,1,104,152Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M212.24,83.76l-56-56A6,6,0,0,0,152,26H56A14,14,0,0,0,42,40v72a6,6,0,0,0,12,0V40a2,2,0,0,1,2-2h90V88a6,6,0,0,0,6,6h50V224a6,6,0,0,0,12,0V88A6,6,0,0,0,212.24,83.76ZM158,46.48,193.52,82H158ZM144,146H128a6,6,0,0,0-6,6v56a6,6,0,0,0,6,6h16a34,34,0,0,0,0-68Zm0,56H134V158h10a22,22,0,0,1,0,44Zm-42-50v56a6,6,0,0,1-12,0V171L72.92,195.44a6,6,0,0,1-9.84,0L46,171v37a6,6,0,0,1-12,0V152a6,6,0,0,1,10.92-3.44l23.08,33,23.08-33A6,6,0,0,1,102,152Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40v72a8,8,0,0,0,16,0V40h88V88a8,8,0,0,0,8,8h48V224a8,8,0,0,0,16,0V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM144,144H128a8,8,0,0,0-8,8v56a8,8,0,0,0,8,8h16a36,36,0,0,0,0-72Zm0,56h-8V160h8a20,20,0,0,1,0,40Zm-40-48v56a8,8,0,0,1-16,0V177.38L74.55,196.59a8,8,0,0,1-13.1,0L48,177.38V208a8,8,0,0,1-16,0V152a8,8,0,0,1,14.55-4.59L68,178.05l21.45-30.64A8,8,0,0,1,104,152Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M210.83,85.17l-56-56A4,4,0,0,0,152,28H56A12,12,0,0,0,44,40v72a4,4,0,0,0,8,0V40a4,4,0,0,1,4-4h92V88a4,4,0,0,0,4,4h52V224a4,4,0,0,0,8,0V88A4,4,0,0,0,210.83,85.17ZM156,41.65,198.34,84H156ZM144,148H128a4,4,0,0,0-4,4v56a4,4,0,0,0,4,4h16a32,32,0,0,0,0-64Zm0,56H132V156h12a24,24,0,0,1,0,48Zm-44-52v56a4,4,0,0,1-8,0V164.69l-20.72,29.6a4,4,0,0,1-6.56,0L44,164.69V208a4,4,0,0,1-8,0V152a4,4,0,0,1,7.28-2.29L68,185l24.72-35.31A4,4,0,0,1,100,152Z"
        }))
    ]
]);


const $494752190a3820c3$export$88937d130805b394 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...r,
        weights: (0, $9fa701b2d2a478cb$export$2e2bcd8739ae039)
    }));
$494752190a3820c3$export$88937d130805b394.displayName = "FileMdIcon";
const $494752190a3820c3$export$d249491e34f19cbe = $494752190a3820c3$export$88937d130805b394;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $d212d505b6449501$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216.49,79.51l-56-56A12,12,0,0,0,152,20H56A20,20,0,0,0,36,40V216a20,20,0,0,0,20,20H200a20,20,0,0,0,20-20V88A12,12,0,0,0,216.49,79.51ZM160,57l23,23H160ZM60,212V44h76V92a12,12,0,0,0,12,12h48V212Zm104-60a12,12,0,0,1-12,12H140v12a12,12,0,0,1-24,0V164H104a12,12,0,0,1,0-24h12V128a12,12,0,0,1,24,0v12h12A12,12,0,0,1,164,152Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,88H152V32Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-40-64a8,8,0,0,1-8,8H136v16a8,8,0,0,1-16,0V160H104a8,8,0,0,1,0-16h16V128a8,8,0,0,1,16,0v16h16A8,8,0,0,1,160,152Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM152,160H136v16a8,8,0,0,1-16,0V160H104a8,8,0,0,1,0-16h16V128a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16Zm0-72V43.31L196.69,88Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M212.24,83.76l-56-56A6,6,0,0,0,152,26H56A14,14,0,0,0,42,40V216a14,14,0,0,0,14,14H200a14,14,0,0,0,14-14V88A6,6,0,0,0,212.24,83.76ZM158,46.48,193.52,82H158ZM200,218H56a2,2,0,0,1-2-2V40a2,2,0,0,1,2-2h90V88a6,6,0,0,0,6,6h50V216A2,2,0,0,1,200,218Zm-42-66a6,6,0,0,1-6,6H134v18a6,6,0,0,1-12,0V158H104a6,6,0,0,1,0-12h18V128a6,6,0,0,1,12,0v18h18A6,6,0,0,1,158,152Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-40-64a8,8,0,0,1-8,8H136v16a8,8,0,0,1-16,0V160H104a8,8,0,0,1,0-16h16V128a8,8,0,0,1,16,0v16h16A8,8,0,0,1,160,152Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M210.83,85.17l-56-56A4,4,0,0,0,152,28H56A12,12,0,0,0,44,40V216a12,12,0,0,0,12,12H200a12,12,0,0,0,12-12V88A4,4,0,0,0,210.83,85.17ZM156,41.65,198.34,84H156ZM200,220H56a4,4,0,0,1-4-4V40a4,4,0,0,1,4-4h92V88a4,4,0,0,0,4,4h52V216A4,4,0,0,1,200,220Zm-44-68a4,4,0,0,1-4,4H132v20a4,4,0,0,1-8,0V156H104a4,4,0,0,1,0-8h20V128a4,4,0,0,1,8,0v20h20A4,4,0,0,1,156,152Z"
        }))
    ]
]);


const $34d18705d2aaa06f$export$ca191b730434e9b4 = $7fPBF.forwardRef((r, s)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: s,
        ...r,
        weights: (0, $d212d505b6449501$export$2e2bcd8739ae039)
    }));
$34d18705d2aaa06f$export$ca191b730434e9b4.displayName = "FilePlusIcon";
const $34d18705d2aaa06f$export$399db72a3873366e = $34d18705d2aaa06f$export$ca191b730434e9b4;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $093434f6cb31b9bc$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220.49,59.51l-40-40A12,12,0,0,0,172,16H92A20,20,0,0,0,72,36V56H56A20,20,0,0,0,36,76V216a20,20,0,0,0,20,20H164a20,20,0,0,0,20-20V196h20a20,20,0,0,0,20-20V68A12,12,0,0,0,220.49,59.51ZM160,212H60V80h67l33,33Zm40-40H184V108a12,12,0,0,0-3.51-8.49l-40-40A12,12,0,0,0,132,56H96V40h71l33,33Zm-56-28a12,12,0,0,1-12,12H88a12,12,0,0,1,0-24h44A12,12,0,0,1,144,144Zm0,40a12,12,0,0,1-12,12H88a12,12,0,0,1,0-24h44A12,12,0,0,1,144,184Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,72V184a8,8,0,0,1-8,8H176V104L136,64H80V40a8,8,0,0,1,8-8h80Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,66.34l-40-40A8,8,0,0,0,168,24H88A16,16,0,0,0,72,40V56H56A16,16,0,0,0,40,72V216a16,16,0,0,0,16,16H168a16,16,0,0,0,16-16V200h16a16,16,0,0,0,16-16V72A8,8,0,0,0,213.66,66.34ZM168,216H56V72h76.69L168,107.31v84.53c0,.06,0,.11,0,.16s0,.1,0,.16V216Zm32-32H184V104a8,8,0,0,0-2.34-5.66l-40-40A8,8,0,0,0,136,56H88V40h76.69L200,75.31Zm-56-32a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h48A8,8,0,0,1,144,152Zm0,32a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h48A8,8,0,0,1,144,184Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,66.34l-40-40A8,8,0,0,0,168,24H88A16,16,0,0,0,72,40V56H56A16,16,0,0,0,40,72V216a16,16,0,0,0,16,16H168a16,16,0,0,0,16-16V200h16a16,16,0,0,0,16-16V72A8,8,0,0,0,213.66,66.34ZM136,192H88a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Zm0-32H88a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Zm64,24H184V104a8,8,0,0,0-2.34-5.66l-40-40A8,8,0,0,0,136,56H88V40h76.69L200,75.31Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M212.24,67.76l-40-40A6,6,0,0,0,168,26H88A14,14,0,0,0,74,40V58H56A14,14,0,0,0,42,72V216a14,14,0,0,0,14,14H168a14,14,0,0,0,14-14V198h18a14,14,0,0,0,14-14V72A6,6,0,0,0,212.24,67.76ZM170,216a2,2,0,0,1-2,2H56a2,2,0,0,1-2-2V72a2,2,0,0,1,2-2h77.51L170,106.49Zm32-32a2,2,0,0,1-2,2H182V104a6,6,0,0,0-1.76-4.24l-40-40A6,6,0,0,0,136,58H86V40a2,2,0,0,1,2-2h77.51L202,74.49Zm-60-32a6,6,0,0,1-6,6H88a6,6,0,0,1,0-12h48A6,6,0,0,1,142,152Zm0,32a6,6,0,0,1-6,6H88a6,6,0,0,1,0-12h48A6,6,0,0,1,142,184Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,66.34l-40-40A8,8,0,0,0,168,24H88A16,16,0,0,0,72,40V56H56A16,16,0,0,0,40,72V216a16,16,0,0,0,16,16H168a16,16,0,0,0,16-16V200h16a16,16,0,0,0,16-16V72A8,8,0,0,0,213.66,66.34ZM168,216H56V72h76.69L168,107.31v84.53c0,.06,0,.11,0,.16s0,.1,0,.16V216Zm32-32H184V104a8,8,0,0,0-2.34-5.66l-40-40A8,8,0,0,0,136,56H88V40h76.69L200,75.31Zm-56-32a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h48A8,8,0,0,1,144,152Zm0,32a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h48A8,8,0,0,1,144,184Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M210.83,69.17l-40-40A4,4,0,0,0,168,28H88A12,12,0,0,0,76,40V60H56A12,12,0,0,0,44,72V216a12,12,0,0,0,12,12H168a12,12,0,0,0,12-12V196h20a12,12,0,0,0,12-12V72A4,4,0,0,0,210.83,69.17ZM172,216a4,4,0,0,1-4,4H56a4,4,0,0,1-4-4V72a4,4,0,0,1,4-4h78.34L172,105.66Zm32-32a4,4,0,0,1-4,4H180V104a4,4,0,0,0-1.17-2.83l-40-40A4,4,0,0,0,136,60H84V40a4,4,0,0,1,4-4h78.34L204,73.66Zm-64-32a4,4,0,0,1-4,4H88a4,4,0,0,1,0-8h48A4,4,0,0,1,140,152Zm0,32a4,4,0,0,1-4,4H88a4,4,0,0,1,0-8h48A4,4,0,0,1,140,184Z"
        }))
    ]
]);


const $250558ea9b1ae473$export$e08f3be1829716d = $7fPBF.forwardRef((r, s)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: s,
        ...r,
        weights: (0, $093434f6cb31b9bc$export$2e2bcd8739ae039)
    }));
$250558ea9b1ae473$export$e08f3be1829716d.displayName = "FilesIcon";
const $250558ea9b1ae473$export$9330ab61a7e5c11b = $250558ea9b1ae473$export$e08f3be1829716d;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $a4dd6699f2d4b74c$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M222.14,69.17,186.83,33.86A19.86,19.86,0,0,0,172.69,28H48A20,20,0,0,0,28,48V208a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V83.31A19.86,19.86,0,0,0,222.14,69.17ZM164,204H92V160h72Zm40,0H188V156a20,20,0,0,0-20-20H88a20,20,0,0,0-20,20v48H52V52H171l33,33ZM164,84a12,12,0,0,1-12,12H96a12,12,0,0,1,0-24h56A12,12,0,0,1,164,84Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,83.31V208a8,8,0,0,1-8,8H176V152a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v64H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H172.69a8,8,0,0,1,5.65,2.34l35.32,35.32A8,8,0,0,1,216,83.31Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M219.31,72,184,36.69A15.86,15.86,0,0,0,172.69,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V83.31A15.86,15.86,0,0,0,219.31,72ZM168,208H88V152h80Zm40,0H184V152a16,16,0,0,0-16-16H88a16,16,0,0,0-16,16v56H48V48H172.69L208,83.31ZM160,72a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h56A8,8,0,0,1,160,72Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M219.31,72,184,36.69A15.86,15.86,0,0,0,172.69,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V83.31A15.86,15.86,0,0,0,219.31,72ZM208,208H184V152a16,16,0,0,0-16-16H88a16,16,0,0,0-16,16v56H48V48H172.69L208,83.31ZM160,72a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h56A8,8,0,0,1,160,72Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M217.9,73.42,182.58,38.1a13.9,13.9,0,0,0-9.89-4.1H48A14,14,0,0,0,34,48V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V83.31A13.9,13.9,0,0,0,217.9,73.42ZM170,210H86V152a2,2,0,0,1,2-2h80a2,2,0,0,1,2,2Zm40-2a2,2,0,0,1-2,2H182V152a14,14,0,0,0-14-14H88a14,14,0,0,0-14,14v58H48a2,2,0,0,1-2-2V48a2,2,0,0,1,2-2H172.69a2,2,0,0,1,1.41.58L209.42,81.9a2,2,0,0,1,.58,1.41ZM158,72a6,6,0,0,1-6,6H96a6,6,0,0,1,0-12h56A6,6,0,0,1,158,72Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M219.31,72,184,36.69A15.86,15.86,0,0,0,172.69,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V83.31A15.86,15.86,0,0,0,219.31,72ZM168,208H88V152h80Zm40,0H184V152a16,16,0,0,0-16-16H88a16,16,0,0,0-16,16v56H48V48H172.69L208,83.31ZM160,72a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h56A8,8,0,0,1,160,72Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216.49,74.83,181.17,39.51A11.93,11.93,0,0,0,172.69,36H48A12,12,0,0,0,36,48V208a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V83.31A11.93,11.93,0,0,0,216.49,74.83ZM172,212H84V152a4,4,0,0,1,4-4h80a4,4,0,0,1,4,4Zm40-4a4,4,0,0,1-4,4H180V152a12,12,0,0,0-12-12H88a12,12,0,0,0-12,12v60H48a4,4,0,0,1-4-4V48a4,4,0,0,1,4-4H172.69a4,4,0,0,1,2.82,1.17l35.32,35.32A4,4,0,0,1,212,83.31ZM156,72a4,4,0,0,1-4,4H96a4,4,0,0,1,0-8h56A4,4,0,0,1,156,72Z"
        }))
    ]
]);


const $d09bbb62b804b286$export$72eeb4bb593c0c95 = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...e,
        weights: (0, $a4dd6699f2d4b74c$export$2e2bcd8739ae039)
    }));
$d09bbb62b804b286$export$72eeb4bb593c0c95.displayName = "FloppyDiskIcon";
const $d09bbb62b804b286$export$5df7d345a432f343 = $d09bbb62b804b286$export$72eeb4bb593c0c95;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $69911170e32027f2$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,116H152a12,12,0,0,1,0-24h24a12,12,0,0,1,0,24ZM104,92h-4V88a12,12,0,0,0-24,0v4H72a12,12,0,0,0,0,24h4v4a12,12,0,0,0,24,0v-4h4a12,12,0,0,0,0-24ZM244.76,202.94a40,40,0,0,1-61,5.35,7,7,0,0,1-.53-.56L144.67,164H111.33L72.81,207.73c-.17.19-.35.38-.53.56A40,40,0,0,1,4.62,173.05a1.18,1.18,0,0,1,0-.2L21,88.79A63.88,63.88,0,0,1,83.88,36H172a64.08,64.08,0,0,1,62.93,52.48,1.8,1.8,0,0,1,0,.19l16.36,84.17a1.77,1.77,0,0,1,0,.2A39.74,39.74,0,0,1,244.76,202.94ZM172,140a40,40,0,0,0,0-80H83.89A39.9,39.9,0,0,0,44.62,93.06a1.55,1.55,0,0,0,0,.21l-16.34,84a16,16,0,0,0,13,18.44,16.07,16.07,0,0,0,13.86-4.21L96.9,144.07a12,12,0,0,1,9-4.07Zm55.76,37.31-7-35.95a63.84,63.84,0,0,1-44.27,22.46l24.41,27.72a16,16,0,0,0,26.85-14.23Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216.86,207.57a28,28,0,0,1-24.66-7.77L150.09,152H172a51.94,51.94,0,0,0,51.2-61h0l16.36,84.17A28,28,0,0,1,216.86,207.57Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,112H152a8,8,0,0,1,0-16h24a8,8,0,0,1,0,16ZM104,96H96V88a8,8,0,0,0-16,0v8H72a8,8,0,0,0,0,16h8v8a8,8,0,0,0,16,0v-8h8a8,8,0,0,0,0-16ZM241.48,200.65a36,36,0,0,1-54.94,4.81c-.12-.12-.24-.24-.35-.37L146.48,160h-37L69.81,205.09l-.35.37A36.08,36.08,0,0,1,44,216,36,36,0,0,1,8.56,173.75a.68.68,0,0,1,0-.14L24.93,89.52A59.88,59.88,0,0,1,83.89,40H172a60.08,60.08,0,0,1,59,49.25c0,.06,0,.12,0,.18l16.37,84.17a.68.68,0,0,1,0,.14A35.74,35.74,0,0,1,241.48,200.65ZM172,144a44,44,0,0,0,0-88H83.89A43.9,43.9,0,0,0,40.68,92.37l0,.13L24.3,176.59A20,20,0,0,0,58,194.3l41.92-47.59a8,8,0,0,1,6-2.71Zm59.7,32.59-8.74-45A60,60,0,0,1,172,160h-4.2L198,194.31a20.09,20.09,0,0,0,17.46,5.39,20,20,0,0,0,16.23-23.11Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M247.44,173.75a.68.68,0,0,0,0-.14L231.05,89.44c0-.06,0-.12,0-.18A60.08,60.08,0,0,0,172,40H83.89a59.88,59.88,0,0,0-59,49.52L8.58,173.61a.68.68,0,0,0,0,.14,36,36,0,0,0,60.9,31.71l.35-.37L109.52,160h37l39.71,45.09c.11.13.23.25.35.37A36.08,36.08,0,0,0,212,216a36,36,0,0,0,35.43-42.25ZM104,112H96v8a8,8,0,0,1-16,0v-8H72a8,8,0,0,1,0-16h8V88a8,8,0,0,1,16,0v8h8a8,8,0,0,1,0,16Zm40-8a8,8,0,0,1,8-8h24a8,8,0,0,1,0,16H152A8,8,0,0,1,144,104Zm84.37,87.47a19.84,19.84,0,0,1-12.9,8.23A20.09,20.09,0,0,1,198,194.31L167.8,160H172a60,60,0,0,0,51-28.38l8.74,45A19.82,19.82,0,0,1,228.37,191.47Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,110H152a6,6,0,0,1,0-12h24a6,6,0,0,1,0,12ZM104,98H94V88a6,6,0,0,0-12,0V98H72a6,6,0,0,0,0,12H82v10a6,6,0,0,0,12,0V110h10a6,6,0,0,0,0-12ZM239.84,199.5A34,34,0,0,1,212,214,34.11,34.11,0,0,1,188,204.05l-.26-.28L147.38,158H108.62L68.31,203.76,68,204A34,34,0,0,1,44,214a34,34,0,0,1-33.46-39.91s0-.06,0-.1L26.9,89.88A57.89,57.89,0,0,1,83.89,42H172a58.07,58.07,0,0,1,57.05,47.63c0,.07,0,.12,0,.19L245.46,174s0,.07,0,.11A33.75,33.75,0,0,1,239.84,199.5ZM172,146a46,46,0,0,0,0-92H83.89A45.9,45.9,0,0,0,38.71,92a.36.36,0,0,0,0,.1L22.33,176.23a22,22,0,0,0,37.11,19.45l42-47.65a6,6,0,0,1,4.5-2Zm61.67,30.23-9.79-50.35A58.06,58.06,0,0,1,172,158h-8.63l33.19,37.68a22,22,0,0,0,37.11-19.45Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,112H152a8,8,0,0,1,0-16h24a8,8,0,0,1,0,16ZM104,96H96V88a8,8,0,0,0-16,0v8H72a8,8,0,0,0,0,16h8v8a8,8,0,0,0,16,0v-8h8a8,8,0,0,0,0-16ZM241.48,200.65a36,36,0,0,1-54.94,4.81c-.12-.12-.24-.24-.35-.37L146.48,160h-37L69.81,205.09l-.35.37A36.08,36.08,0,0,1,44,216,36,36,0,0,1,8.56,173.75a.68.68,0,0,1,0-.14L24.93,89.52A59.88,59.88,0,0,1,83.89,40H172a60.08,60.08,0,0,1,59,49.25c0,.06,0,.12,0,.18l16.37,84.17a.68.68,0,0,1,0,.14A35.74,35.74,0,0,1,241.48,200.65ZM172,144a44,44,0,0,0,0-88H83.89A43.9,43.9,0,0,0,40.68,92.37l0,.13L24.3,176.59A20,20,0,0,0,58,194.3l41.92-47.59a8,8,0,0,1,6-2.71Zm59.7,32.59-8.74-45A60,60,0,0,1,172,160h-4.2L198,194.31a20.09,20.09,0,0,0,17.46,5.39,20,20,0,0,0,16.23-23.11Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,108H152a4,4,0,0,1,0-8h24a4,4,0,0,1,0,8Zm-72-8H92V88a4,4,0,0,0-8,0v12H72a4,4,0,0,0,0,8H84v12a4,4,0,0,0,8,0V108h12a4,4,0,0,0,0-8Zm134.21,98.36a32,32,0,0,1-48.84,4.27l-.17-.18L148.29,156H107.72L66.81,202.44l-.18.19A32.08,32.08,0,0,1,44,212a32,32,0,0,1-31.5-37.56L28.87,90.21A55.87,55.87,0,0,1,83.89,44H172a56.07,56.07,0,0,1,55.1,46.1.29.29,0,0,1,0,.1l16.37,84.16A31.86,31.86,0,0,1,238.21,198.36ZM172,148a48,48,0,1,0,0-96H83.9A47.9,47.9,0,0,0,36.74,91.67L20.36,175.9a24,24,0,0,0,19.48,27.73,24,24,0,0,0,21-6.58l42-47.69a4,4,0,0,1,3-1.36Zm63.63,27.83-11-56.66A56.09,56.09,0,0,1,172,156H159l36.16,41.06a24,24,0,0,0,40.52-21.23Z"
        }))
    ]
]);


const $07eb5346ad9d064e$export$67c6cd66cb8e49db = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...r,
        weights: (0, $69911170e32027f2$export$2e2bcd8739ae039)
    }));
$07eb5346ad9d064e$export$67c6cd66cb8e49db.displayName = "GameControllerIcon";
const $07eb5346ad9d064e$export$f3f3f6c0124f08de = $07eb5346ad9d064e$export$67c6cd66cb8e49db;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $6c6004cf2e0c084c$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M209.88,69.83A115.19,115.19,0,0,0,128,36h-.41C63.85,36.22,12,88.76,12,153.13V176a20,20,0,0,0,20,20H224a20,20,0,0,0,20-20V152A115.25,115.25,0,0,0,209.88,69.83ZM220,172H127.32l46.44-65A12,12,0,1,0,154.24,93L97.82,172H36V153.13c0-1.72,0-3.43.14-5.13H56a12,12,0,0,0,0-24H40.62c10.91-33.39,40-58.52,75.38-63.21V80a12,12,0,0,0,24,0V60.8A92,92,0,0,1,215.66,124H200a12,12,0,0,0,0,24h19.9c.06,1.33.1,2.66.1,4Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,152v24a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V153.13C24,95.65,70.15,48.2,127.63,48A104,104,0,0,1,232,152Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M207.06,72.67A111.24,111.24,0,0,0,128,40h-.4C66.07,40.21,16,91,16,153.13V176a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V152A111.25,111.25,0,0,0,207.06,72.67ZM224,176H119.71l54.76-75.3a8,8,0,0,0-12.94-9.42L99.92,176H32V153.13c0-3.08.15-6.12.43-9.13H56a8,8,0,0,0,0-16H35.27c10.32-38.86,44-68.24,84.73-71.66V80a8,8,0,0,0,16,0V56.33A96.14,96.14,0,0,1,221,128H200a8,8,0,0,0,0,16h23.67c.21,2.65.33,5.31.33,8Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240,152v24a16,16,0,0,1-16,16H115.93a4,4,0,0,1-3.24-6.35L174.27,101a8.21,8.21,0,0,0-1.37-11.3,8,8,0,0,0-11.37,1.61l-72,99.06A4,4,0,0,1,86.25,192H32a16,16,0,0,1-16-16V153.13c0-1.79,0-3.57.13-5.33a4,4,0,0,1,4-3.8H48a8,8,0,0,0,8-8.53A8.17,8.17,0,0,0,47.73,128H23.92a4,4,0,0,1-3.87-5c12-43.84,49.66-77.13,95.52-82.28a4,4,0,0,1,4.43,4V72a8,8,0,0,0,8.53,8A8.17,8.17,0,0,0,136,71.73V44.67a4,4,0,0,1,4.43-4A112.18,112.18,0,0,1,236.23,123a4,4,0,0,1-3.88,5H208.27a8.17,8.17,0,0,0-8.25,7.47,8,8,0,0,0,8,8.53h27.92a4,4,0,0,1,4,3.86C240,149.23,240,150.61,240,152Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M205.65,74.08A109.26,109.26,0,0,0,128,42h-.39C67.17,42.21,18,92.06,18,153.13V176a14,14,0,0,0,14,14H224a14,14,0,0,0,14-14V152A109.3,109.3,0,0,0,205.65,74.08ZM226,176a2,2,0,0,1-2,2H115.78l57.07-78.47a6,6,0,0,0-9.7-7.06L100.94,178H32a2,2,0,0,1-2-2V153.13A102.36,102.36,0,0,1,30.62,142H56a6,6,0,0,0,0-12H32.71C42.6,88.4,78.53,56.86,122,54.19V80a6,6,0,0,0,12,0V54.19A98.05,98.05,0,0,1,223.53,130H200a6,6,0,0,0,0,12h25.5c.33,3.3.5,6.64.5,10Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M207.06,72.67A111.24,111.24,0,0,0,128,40h-.4C66.07,40.21,16,91,16,153.13V176a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V152A111.25,111.25,0,0,0,207.06,72.67ZM224,176H119.71l54.76-75.3a8,8,0,0,0-12.94-9.42L99.92,176H32V153.13c0-3.08.15-6.12.43-9.13H56a8,8,0,0,0,0-16H35.27c10.32-38.86,44-68.24,84.73-71.66V80a8,8,0,0,0,16,0V56.33A96.14,96.14,0,0,1,221,128H200a8,8,0,0,0,0,16h23.67c.21,2.65.33,5.31.33,8Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M204.23,75.5A107.37,107.37,0,0,0,127.62,44C68.28,44.21,20,93.16,20,153.13V176a12,12,0,0,0,12,12H224a12,12,0,0,0,12-12V152A107.25,107.25,0,0,0,204.23,75.5ZM228,176a4,4,0,0,1-4,4H111.85l59.38-81.65a4,4,0,1,0-6.46-4.7L102,180H32a4,4,0,0,1-4-4V153.13A103.42,103.42,0,0,1,28.84,140H56a4,4,0,0,0,0-8H30.21C39.59,87.66,77.84,53.93,124,52.09V80a4,4,0,0,0,8,0V52.08A100.08,100.08,0,0,1,226,132H200a4,4,0,0,0,0,8h27.29a101.6,101.6,0,0,1,.71,12Z"
        }))
    ]
]);


const $d545586961bd20bd$export$5ff880ebd1cf0b62 = $7fPBF.forwardRef((a, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...a,
        weights: (0, $6c6004cf2e0c084c$export$2e2bcd8739ae039)
    }));
$d545586961bd20bd$export$5ff880ebd1cf0b62.displayName = "GaugeIcon";
const $d545586961bd20bd$export$be3aa080178503e1 = $d545586961bd20bd$export$5ff880ebd1cf0b62;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $b7a637587bfcf43a$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,116H219.22A91.1,91.1,0,0,0,213,92.79l11.08-6.4a12,12,0,1,0-12-20.78L201,72a92.85,92.85,0,0,0-17-17l6.41-11.11a12,12,0,1,0-20.78-12L163.21,43A91.1,91.1,0,0,0,140,36.78V24a12,12,0,0,0-24,0V36.78A91.1,91.1,0,0,0,92.79,43l-6.4-11.08a12,12,0,0,0-20.78,12L72,55A92.85,92.85,0,0,0,55,72L43.93,65.61a12,12,0,0,0-12,20.78L43,92.79A91.1,91.1,0,0,0,36.78,116H24a12,12,0,0,0,0,24H36.78A91.1,91.1,0,0,0,43,163.21l-11.08,6.4a12,12,0,1,0,12,20.78L55,184a92.85,92.85,0,0,0,17,17l-6.41,11.11a12,12,0,1,0,20.78,12L92.79,213A91.1,91.1,0,0,0,116,219.22V232a12,12,0,0,0,24,0V219.22A91.1,91.1,0,0,0,163.21,213l6.4,11.08a12,12,0,0,0,20.78-12L184,201a92.85,92.85,0,0,0,17-17l11.11,6.41a12,12,0,1,0,12-20.78L213,163.21A91.1,91.1,0,0,0,219.22,140H232a12,12,0,0,0,0-24ZM128,60a68.1,68.1,0,0,1,66.92,56h-60l-30-52A67.61,67.61,0,0,1,128,60ZM60,128A67.9,67.9,0,0,1,84.16,76.07l30,51.93-30,51.93A67.9,67.9,0,0,1,60,128Zm68,68a67.61,67.61,0,0,1-23.07-4l30-52h60A68.1,68.1,0,0,1,128,196Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,128a80,80,0,1,1-80-80A80,80,0,0,1,208,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,120H215.63a87.27,87.27,0,0,0-7.74-28.88l14.18-8.19a8,8,0,0,0-8-13.86l-14.2,8.2a88.78,88.78,0,0,0-21.14-21.14l8.2-14.2a8,8,0,0,0-13.86-8l-8.19,14.18A87.27,87.27,0,0,0,136,40.37V24a8,8,0,0,0-16,0V40.37a87.27,87.27,0,0,0-28.88,7.74L82.93,33.93a8,8,0,0,0-13.86,8l8.2,14.2A88.78,88.78,0,0,0,56.13,77.27l-14.2-8.2a8,8,0,0,0-8,13.86l14.18,8.19A87.27,87.27,0,0,0,40.37,120H24a8,8,0,0,0,0,16H40.37a87.27,87.27,0,0,0,7.74,28.88l-14.18,8.19a8,8,0,0,0,4,14.93,7.92,7.92,0,0,0,4-1.07l14.2-8.2a88.78,88.78,0,0,0,21.14,21.14l-8.2,14.2a8,8,0,0,0,13.86,8l8.19-14.18A87.27,87.27,0,0,0,120,215.63V232a8,8,0,0,0,16,0V215.63a87.27,87.27,0,0,0,28.88-7.74l8.19,14.18a8,8,0,0,0,13.86-8l-8.2-14.2a88.78,88.78,0,0,0,21.14-21.14l14.2,8.2A8,8,0,0,0,225,184a8,8,0,0,0-2.92-10.93l-14.18-8.19A87.27,87.27,0,0,0,215.63,136H232a8,8,0,0,0,0-16ZM85.31,185.94a71.92,71.92,0,0,1,0-115.88L118.76,128ZM128,200A71.58,71.58,0,0,1,99.16,194L132.62,136h66.92A72.08,72.08,0,0,1,128,200Zm4.62-80L99.16,62.05a71.94,71.94,0,0,1,100.38,58Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,120h-8.34a95.07,95.07,0,0,0-8.82-32.9l7.23-4.17a8,8,0,0,0-8-13.86l-7.25,4.19a97,97,0,0,0-24.08-24.08l4.19-7.25a8,8,0,0,0-13.86-8l-4.17,7.23A95.07,95.07,0,0,0,136,32.34V24a8,8,0,0,0-16,0v8.34a95.07,95.07,0,0,0-32.9,8.82l-4.17-7.23a8,8,0,0,0-13.86,8l4.19,7.25A97,97,0,0,0,49.18,73.26l-7.25-4.19a8,8,0,0,0-8,13.86l7.23,4.17A95.07,95.07,0,0,0,32.34,120H24a8,8,0,0,0,0,16h8.34a95.07,95.07,0,0,0,8.82,32.9l-7.23,4.17a8,8,0,0,0,4,14.93,7.92,7.92,0,0,0,4-1.07l7.25-4.19a97,97,0,0,0,24.08,24.08l-4.19,7.25a8,8,0,0,0,13.86,8l4.17-7.23a95.07,95.07,0,0,0,32.9,8.82V232a8,8,0,0,0,16,0v-8.34a95.07,95.07,0,0,0,32.9-8.82l4.17,7.23a8,8,0,0,0,13.86-8l-4.19-7.25a97,97,0,0,0,24.08-24.08l7.25,4.19A8,8,0,0,0,225,184a8,8,0,0,0-2.92-10.93l-7.23-4.17a95.07,95.07,0,0,0,8.82-32.9H232a8,8,0,0,0,0-16ZM72,128A55.91,55.91,0,0,1,93.38,84l25.38,44L93.38,172A55.91,55.91,0,0,1,72,128Zm56,56a55.67,55.67,0,0,1-20.78-4l25.4-44h50.8A56.09,56.09,0,0,1,128,184Zm4.62-64-25.4-44a56,56,0,0,1,76.2,44Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,122H213.77a85.56,85.56,0,0,0-8.49-31.69l15.79-9.11a6,6,0,0,0-6-10.4l-15.8,9.12a86.72,86.72,0,0,0-23.19-23.19l9.12-15.8a6,6,0,0,0-10.4-6l-9.11,15.79A85.56,85.56,0,0,0,134,42.23V24a6,6,0,0,0-12,0V42.23a85.56,85.56,0,0,0-31.69,8.49L81.2,34.93a6,6,0,0,0-10.4,6l9.12,15.8A86.72,86.72,0,0,0,56.73,79.92L40.93,70.8a6,6,0,0,0-6,10.4l15.79,9.11A85.56,85.56,0,0,0,42.23,122H24a6,6,0,0,0,0,12H42.23a85.56,85.56,0,0,0,8.49,31.69L34.93,174.8a6,6,0,0,0,6,10.4l15.8-9.12a86.72,86.72,0,0,0,23.19,23.19l-9.12,15.8a6,6,0,0,0,10.4,6l9.11-15.79A85.56,85.56,0,0,0,122,213.77V232a6,6,0,0,0,12,0V213.77a85.56,85.56,0,0,0,31.69-8.49l9.11,15.79a6,6,0,0,0,5.21,3,5.93,5.93,0,0,0,3-.81,6,6,0,0,0,2.2-8.19l-9.12-15.8a86.72,86.72,0,0,0,23.19-23.19l15.8,9.12a6,6,0,0,0,6-10.4l-15.79-9.11A85.56,85.56,0,0,0,213.77,134H232a6,6,0,0,0,0-12ZM86,188.84A73.9,73.9,0,0,1,86,67.16L121.07,128ZM128,202a73.5,73.5,0,0,1-31.67-7.14L131.46,134h70.28A74.09,74.09,0,0,1,128,202Zm3.46-80L96.33,61.14A73.95,73.95,0,0,1,201.74,122Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,120H215.63a87.27,87.27,0,0,0-7.74-28.88l14.18-8.19a8,8,0,0,0-8-13.86l-14.2,8.2a88.78,88.78,0,0,0-21.14-21.14l8.2-14.2a8,8,0,0,0-13.86-8l-8.19,14.18A87.27,87.27,0,0,0,136,40.37V24a8,8,0,0,0-16,0V40.37a87.27,87.27,0,0,0-28.88,7.74L82.93,33.93a8,8,0,0,0-13.86,8l8.2,14.2A88.78,88.78,0,0,0,56.13,77.27l-14.2-8.2a8,8,0,0,0-8,13.86l14.18,8.19A87.27,87.27,0,0,0,40.37,120H24a8,8,0,0,0,0,16H40.37a87.27,87.27,0,0,0,7.74,28.88l-14.18,8.19a8,8,0,0,0,4,14.93,7.92,7.92,0,0,0,4-1.07l14.2-8.2a88.78,88.78,0,0,0,21.14,21.14l-8.2,14.2a8,8,0,0,0,13.86,8l8.19-14.18A87.27,87.27,0,0,0,120,215.63V232a8,8,0,0,0,16,0V215.63a87.27,87.27,0,0,0,28.88-7.74l8.19,14.18a8,8,0,0,0,13.86-8l-8.2-14.2a88.78,88.78,0,0,0,21.14-21.14l14.2,8.2A8,8,0,0,0,225,184a8,8,0,0,0-2.92-10.93l-14.18-8.19A87.27,87.27,0,0,0,215.63,136H232a8,8,0,0,0,0-16ZM128,56a72.08,72.08,0,0,1,71.54,64H132.62L99.16,62.05A71.58,71.58,0,0,1,128,56ZM56,128A72,72,0,0,1,85.31,70.06L118.76,128,85.31,185.94A72,72,0,0,1,56,128Zm72,72A71.58,71.58,0,0,1,99.16,194L132.62,136h66.92A72.08,72.08,0,0,1,128,200Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,124H211.9a83.35,83.35,0,0,0-9.27-34.47l17.44-10.07a4,4,0,0,0-4-6.92L198.62,82.61a84.54,84.54,0,0,0-25.23-25.23l10.07-17.45a4,4,0,0,0-6.92-4L166.47,53.37A83.35,83.35,0,0,0,132,44.1V24a4,4,0,0,0-8,0V44.1a83.35,83.35,0,0,0-34.47,9.27L79.46,35.93a4,4,0,0,0-6.92,4L82.61,57.38A84.54,84.54,0,0,0,57.38,82.61L39.93,72.54a4,4,0,1,0-4,6.92L53.37,89.53A83.35,83.35,0,0,0,44.1,124H24a4,4,0,0,0,0,8H44.1a83.35,83.35,0,0,0,9.27,34.47L35.93,176.54a4,4,0,0,0,2,7.46,3.9,3.9,0,0,0,2-.54l17.45-10.07a84.54,84.54,0,0,0,25.23,25.23L72.54,216.07A4,4,0,0,0,74,221.53a4,4,0,0,0,5.46-1.46l10.07-17.44A83.35,83.35,0,0,0,124,211.9V232a4,4,0,0,0,8,0V211.9a83.35,83.35,0,0,0,34.47-9.27l10.07,17.44a4,4,0,0,0,6.92-4l-10.07-17.45a84.54,84.54,0,0,0,25.23-25.23l17.45,10.07a3.9,3.9,0,0,0,2,.54,4,4,0,0,0,2-7.46l-17.44-10.07A83.35,83.35,0,0,0,211.9,132H232a4,4,0,0,0,0-8ZM128,52a76.09,76.09,0,0,1,75.89,72H130.31L93.53,60.3A75.59,75.59,0,0,1,128,52ZM52,128A76,76,0,0,1,86.61,64.31L123.38,128,86.61,191.69A76,76,0,0,1,52,128Zm76,76a75.59,75.59,0,0,1-34.47-8.3L130.31,132h73.58A76.09,76.09,0,0,1,128,204Z"
        }))
    ]
]);


const $27341b9e147c07ff$export$9d72c0eeb3943e75 = $7fPBF.forwardRef((r, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: a,
        ...r,
        weights: (0, $b7a637587bfcf43a$export$2e2bcd8739ae039)
    }));
$27341b9e147c07ff$export$9d72c0eeb3943e75.displayName = "GearFineIcon";
const $27341b9e147c07ff$export$69d762f03497352 = $27341b9e147c07ff$export$9d72c0eeb3943e75;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $7fac16834f0e6b11$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,76a52,52,0,1,0,52,52A52.06,52.06,0,0,0,128,76Zm0,80a28,28,0,1,1,28-28A28,28,0,0,1,128,156Zm92-27.21v-1.58l14-17.51a12,12,0,0,0,2.23-10.59A111.75,111.75,0,0,0,225,71.89,12,12,0,0,0,215.89,66L193.61,63.5l-1.11-1.11L190,40.1A12,12,0,0,0,184.11,31a111.67,111.67,0,0,0-27.23-11.27A12,12,0,0,0,146.3,22L128.79,36h-1.58L109.7,22a12,12,0,0,0-10.59-2.23A111.75,111.75,0,0,0,71.89,31.05,12,12,0,0,0,66,40.11L63.5,62.39,62.39,63.5,40.1,66A12,12,0,0,0,31,71.89,111.67,111.67,0,0,0,19.77,99.12,12,12,0,0,0,22,109.7l14,17.51v1.58L22,146.3a12,12,0,0,0-2.23,10.59,111.75,111.75,0,0,0,11.29,27.22A12,12,0,0,0,40.11,190l22.28,2.48,1.11,1.11L66,215.9A12,12,0,0,0,71.89,225a111.67,111.67,0,0,0,27.23,11.27A12,12,0,0,0,109.7,234l17.51-14h1.58l17.51,14a12,12,0,0,0,10.59,2.23A111.75,111.75,0,0,0,184.11,225a12,12,0,0,0,5.91-9.06l2.48-22.28,1.11-1.11L215.9,190a12,12,0,0,0,9.06-5.91,111.67,111.67,0,0,0,11.27-27.23A12,12,0,0,0,234,146.3Zm-24.12-4.89a70.1,70.1,0,0,1,0,8.2,12,12,0,0,0,2.61,8.22l12.84,16.05A86.47,86.47,0,0,1,207,166.86l-20.43,2.27a12,12,0,0,0-7.65,4,69,69,0,0,1-5.8,5.8,12,12,0,0,0-4,7.65L166.86,207a86.47,86.47,0,0,1-10.49,4.35l-16.05-12.85a12,12,0,0,0-7.5-2.62c-.24,0-.48,0-.72,0a70.1,70.1,0,0,1-8.2,0,12.06,12.06,0,0,0-8.22,2.6L99.63,211.33A86.47,86.47,0,0,1,89.14,207l-2.27-20.43a12,12,0,0,0-4-7.65,69,69,0,0,1-5.8-5.8,12,12,0,0,0-7.65-4L49,166.86a86.47,86.47,0,0,1-4.35-10.49l12.84-16.05a12,12,0,0,0,2.61-8.22,70.1,70.1,0,0,1,0-8.2,12,12,0,0,0-2.61-8.22L44.67,99.63A86.47,86.47,0,0,1,49,89.14l20.43-2.27a12,12,0,0,0,7.65-4,69,69,0,0,1,5.8-5.8,12,12,0,0,0,4-7.65L89.14,49a86.47,86.47,0,0,1,10.49-4.35l16.05,12.85a12.06,12.06,0,0,0,8.22,2.6,70.1,70.1,0,0,1,8.2,0,12,12,0,0,0,8.22-2.6l16.05-12.85A86.47,86.47,0,0,1,166.86,49l2.27,20.43a12,12,0,0,0,4,7.65,69,69,0,0,1,5.8,5.8,12,12,0,0,0,7.65,4L207,89.14a86.47,86.47,0,0,1,4.35,10.49l-12.84,16.05A12,12,0,0,0,195.88,123.9Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M207.86,123.18l16.78-21a99.14,99.14,0,0,0-10.07-24.29l-26.7-3a81,81,0,0,0-6.81-6.81l-3-26.71a99.43,99.43,0,0,0-24.3-10l-21,16.77a81.59,81.59,0,0,0-9.64,0l-21-16.78A99.14,99.14,0,0,0,77.91,41.43l-3,26.7a81,81,0,0,0-6.81,6.81l-26.71,3a99.43,99.43,0,0,0-10,24.3l16.77,21a81.59,81.59,0,0,0,0,9.64l-16.78,21a99.14,99.14,0,0,0,10.07,24.29l26.7,3a81,81,0,0,0,6.81,6.81l3,26.71a99.43,99.43,0,0,0,24.3,10l21-16.77a81.59,81.59,0,0,0,9.64,0l21,16.78a99.14,99.14,0,0,0,24.29-10.07l3-26.7a81,81,0,0,0,6.81-6.81l26.71-3a99.43,99.43,0,0,0,10-24.3l-16.77-21A81.59,81.59,0,0,0,207.86,123.18ZM128,168a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,80a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Zm88-29.84q.06-2.16,0-4.32l14.92-18.64a8,8,0,0,0,1.48-7.06,107.6,107.6,0,0,0-10.88-26.25,8,8,0,0,0-6-3.93l-23.72-2.64q-1.48-1.56-3-3L186,40.54a8,8,0,0,0-3.94-6,107.29,107.29,0,0,0-26.25-10.86,8,8,0,0,0-7.06,1.48L130.16,40Q128,40,125.84,40L107.2,25.11a8,8,0,0,0-7.06-1.48A107.6,107.6,0,0,0,73.89,34.51a8,8,0,0,0-3.93,6L67.32,64.27q-1.56,1.49-3,3L40.54,70a8,8,0,0,0-6,3.94,107.71,107.71,0,0,0-10.87,26.25,8,8,0,0,0,1.49,7.06L40,125.84Q40,128,40,130.16L25.11,148.8a8,8,0,0,0-1.48,7.06,107.6,107.6,0,0,0,10.88,26.25,8,8,0,0,0,6,3.93l23.72,2.64q1.49,1.56,3,3L70,215.46a8,8,0,0,0,3.94,6,107.71,107.71,0,0,0,26.25,10.87,8,8,0,0,0,7.06-1.49L125.84,216q2.16.06,4.32,0l18.64,14.92a8,8,0,0,0,7.06,1.48,107.21,107.21,0,0,0,26.25-10.88,8,8,0,0,0,3.93-6l2.64-23.72q1.56-1.48,3-3L215.46,186a8,8,0,0,0,6-3.94,107.71,107.71,0,0,0,10.87-26.25,8,8,0,0,0-1.49-7.06Zm-16.1-6.5a73.93,73.93,0,0,1,0,8.68,8,8,0,0,0,1.74,5.48l14.19,17.73a91.57,91.57,0,0,1-6.23,15L187,173.11a8,8,0,0,0-5.1,2.64,74.11,74.11,0,0,1-6.14,6.14,8,8,0,0,0-2.64,5.1l-2.51,22.58a91.32,91.32,0,0,1-15,6.23l-17.74-14.19a8,8,0,0,0-5-1.75h-.48a73.93,73.93,0,0,1-8.68,0,8.06,8.06,0,0,0-5.48,1.74L100.45,215.8a91.57,91.57,0,0,1-15-6.23L82.89,187a8,8,0,0,0-2.64-5.1,74.11,74.11,0,0,1-6.14-6.14,8,8,0,0,0-5.1-2.64L46.43,170.6a91.32,91.32,0,0,1-6.23-15l14.19-17.74a8,8,0,0,0,1.74-5.48,73.93,73.93,0,0,1,0-8.68,8,8,0,0,0-1.74-5.48L40.2,100.45a91.57,91.57,0,0,1,6.23-15L69,82.89a8,8,0,0,0,5.1-2.64,74.11,74.11,0,0,1,6.14-6.14A8,8,0,0,0,82.89,69L85.4,46.43a91.32,91.32,0,0,1,15-6.23l17.74,14.19a8,8,0,0,0,5.48,1.74,73.93,73.93,0,0,1,8.68,0,8.06,8.06,0,0,0,5.48-1.74L155.55,40.2a91.57,91.57,0,0,1,15,6.23L173.11,69a8,8,0,0,0,2.64,5.1,74.11,74.11,0,0,1,6.14,6.14,8,8,0,0,0,5.1,2.64l22.58,2.51a91.32,91.32,0,0,1,6.23,15l-14.19,17.74A8,8,0,0,0,199.87,123.66Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,130.16q.06-2.16,0-4.32l14.92-18.64a8,8,0,0,0,1.48-7.06,107.6,107.6,0,0,0-10.88-26.25,8,8,0,0,0-6-3.93l-23.72-2.64q-1.48-1.56-3-3L186,40.54a8,8,0,0,0-3.94-6,107.29,107.29,0,0,0-26.25-10.86,8,8,0,0,0-7.06,1.48L130.16,40Q128,40,125.84,40L107.2,25.11a8,8,0,0,0-7.06-1.48A107.6,107.6,0,0,0,73.89,34.51a8,8,0,0,0-3.93,6L67.32,64.27q-1.56,1.49-3,3L40.54,70a8,8,0,0,0-6,3.94,107.71,107.71,0,0,0-10.87,26.25,8,8,0,0,0,1.49,7.06L40,125.84Q40,128,40,130.16L25.11,148.8a8,8,0,0,0-1.48,7.06,107.6,107.6,0,0,0,10.88,26.25,8,8,0,0,0,6,3.93l23.72,2.64q1.49,1.56,3,3L70,215.46a8,8,0,0,0,3.94,6,107.71,107.71,0,0,0,26.25,10.87,8,8,0,0,0,7.06-1.49L125.84,216q2.16.06,4.32,0l18.64,14.92a8,8,0,0,0,7.06,1.48,107.21,107.21,0,0,0,26.25-10.88,8,8,0,0,0,3.93-6l2.64-23.72q1.56-1.48,3-3L215.46,186a8,8,0,0,0,6-3.94,107.71,107.71,0,0,0,10.87-26.25,8,8,0,0,0-1.49-7.06ZM128,168a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,82a46,46,0,1,0,46,46A46.06,46.06,0,0,0,128,82Zm0,80a34,34,0,1,1,34-34A34,34,0,0,1,128,162ZM214,130.84c.06-1.89.06-3.79,0-5.68L229.33,106a6,6,0,0,0,1.11-5.29A105.34,105.34,0,0,0,219.76,74.9a6,6,0,0,0-4.53-3l-24.45-2.71q-1.93-2.07-4-4l-2.72-24.46a6,6,0,0,0-3-4.53,105.65,105.65,0,0,0-25.77-10.66A6,6,0,0,0,150,26.68l-19.2,15.37c-1.89-.06-3.79-.06-5.68,0L106,26.67a6,6,0,0,0-5.29-1.11A105.34,105.34,0,0,0,74.9,36.24a6,6,0,0,0-3,4.53L69.23,65.22q-2.07,1.94-4,4L40.76,72a6,6,0,0,0-4.53,3,105.65,105.65,0,0,0-10.66,25.77A6,6,0,0,0,26.68,106l15.37,19.2c-.06,1.89-.06,3.79,0,5.68L26.67,150.05a6,6,0,0,0-1.11,5.29A105.34,105.34,0,0,0,36.24,181.1a6,6,0,0,0,4.53,3l24.45,2.71q1.94,2.07,4,4L72,215.24a6,6,0,0,0,3,4.53,105.65,105.65,0,0,0,25.77,10.66,6,6,0,0,0,5.29-1.11L125.16,214c1.89.06,3.79.06,5.68,0l19.21,15.38a6,6,0,0,0,3.75,1.31,6.2,6.2,0,0,0,1.54-.2,105.34,105.34,0,0,0,25.76-10.68,6,6,0,0,0,3-4.53l2.71-24.45q2.07-1.93,4-4l24.46-2.72a6,6,0,0,0,4.53-3,105.49,105.49,0,0,0,10.66-25.77,6,6,0,0,0-1.11-5.29Zm-3.1,41.63-23.64,2.63a6,6,0,0,0-3.82,2,75.14,75.14,0,0,1-6.31,6.31,6,6,0,0,0-2,3.82l-2.63,23.63A94.28,94.28,0,0,1,155.14,218l-18.57-14.86a6,6,0,0,0-3.75-1.31h-.36a78.07,78.07,0,0,1-8.92,0,6,6,0,0,0-4.11,1.3L100.87,218a94.13,94.13,0,0,1-17.34-7.17L80.9,187.21a6,6,0,0,0-2-3.82,75.14,75.14,0,0,1-6.31-6.31,6,6,0,0,0-3.82-2l-23.63-2.63A94.28,94.28,0,0,1,38,155.14l14.86-18.57a6,6,0,0,0,1.3-4.11,78.07,78.07,0,0,1,0-8.92,6,6,0,0,0-1.3-4.11L38,100.87a94.13,94.13,0,0,1,7.17-17.34L68.79,80.9a6,6,0,0,0,3.82-2,75.14,75.14,0,0,1,6.31-6.31,6,6,0,0,0,2-3.82l2.63-23.63A94.28,94.28,0,0,1,100.86,38l18.57,14.86a6,6,0,0,0,4.11,1.3,78.07,78.07,0,0,1,8.92,0,6,6,0,0,0,4.11-1.3L155.13,38a94.13,94.13,0,0,1,17.34,7.17l2.63,23.64a6,6,0,0,0,2,3.82,75.14,75.14,0,0,1,6.31,6.31,6,6,0,0,0,3.82,2l23.63,2.63A94.28,94.28,0,0,1,218,100.86l-14.86,18.57a6,6,0,0,0-1.3,4.11,78.07,78.07,0,0,1,0,8.92,6,6,0,0,0,1.3,4.11L218,155.13A94.13,94.13,0,0,1,210.85,172.47Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,80a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Zm88-29.84q.06-2.16,0-4.32l14.92-18.64a8,8,0,0,0,1.48-7.06,107.21,107.21,0,0,0-10.88-26.25,8,8,0,0,0-6-3.93l-23.72-2.64q-1.48-1.56-3-3L186,40.54a8,8,0,0,0-3.94-6,107.71,107.71,0,0,0-26.25-10.87,8,8,0,0,0-7.06,1.49L130.16,40Q128,40,125.84,40L107.2,25.11a8,8,0,0,0-7.06-1.48A107.6,107.6,0,0,0,73.89,34.51a8,8,0,0,0-3.93,6L67.32,64.27q-1.56,1.49-3,3L40.54,70a8,8,0,0,0-6,3.94,107.71,107.71,0,0,0-10.87,26.25,8,8,0,0,0,1.49,7.06L40,125.84Q40,128,40,130.16L25.11,148.8a8,8,0,0,0-1.48,7.06,107.21,107.21,0,0,0,10.88,26.25,8,8,0,0,0,6,3.93l23.72,2.64q1.49,1.56,3,3L70,215.46a8,8,0,0,0,3.94,6,107.71,107.71,0,0,0,26.25,10.87,8,8,0,0,0,7.06-1.49L125.84,216q2.16.06,4.32,0l18.64,14.92a8,8,0,0,0,7.06,1.48,107.21,107.21,0,0,0,26.25-10.88,8,8,0,0,0,3.93-6l2.64-23.72q1.56-1.48,3-3L215.46,186a8,8,0,0,0,6-3.94,107.71,107.71,0,0,0,10.87-26.25,8,8,0,0,0-1.49-7.06Zm-16.1-6.5a73.93,73.93,0,0,1,0,8.68,8,8,0,0,0,1.74,5.48l14.19,17.73a91.57,91.57,0,0,1-6.23,15L187,173.11a8,8,0,0,0-5.1,2.64,74.11,74.11,0,0,1-6.14,6.14,8,8,0,0,0-2.64,5.1l-2.51,22.58a91.32,91.32,0,0,1-15,6.23l-17.74-14.19a8,8,0,0,0-5-1.75h-.48a73.93,73.93,0,0,1-8.68,0,8,8,0,0,0-5.48,1.74L100.45,215.8a91.57,91.57,0,0,1-15-6.23L82.89,187a8,8,0,0,0-2.64-5.1,74.11,74.11,0,0,1-6.14-6.14,8,8,0,0,0-5.1-2.64L46.43,170.6a91.32,91.32,0,0,1-6.23-15l14.19-17.74a8,8,0,0,0,1.74-5.48,73.93,73.93,0,0,1,0-8.68,8,8,0,0,0-1.74-5.48L40.2,100.45a91.57,91.57,0,0,1,6.23-15L69,82.89a8,8,0,0,0,5.1-2.64,74.11,74.11,0,0,1,6.14-6.14A8,8,0,0,0,82.89,69L85.4,46.43a91.32,91.32,0,0,1,15-6.23l17.74,14.19a8,8,0,0,0,5.48,1.74,73.93,73.93,0,0,1,8.68,0,8,8,0,0,0,5.48-1.74L155.55,40.2a91.57,91.57,0,0,1,15,6.23L173.11,69a8,8,0,0,0,2.64,5.1,74.11,74.11,0,0,1,6.14,6.14,8,8,0,0,0,5.1,2.64l22.58,2.51a91.32,91.32,0,0,1,6.23,15l-14.19,17.74A8,8,0,0,0,199.87,123.66Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,84a44,44,0,1,0,44,44A44.05,44.05,0,0,0,128,84Zm0,80a36,36,0,1,1,36-36A36,36,0,0,1,128,164Zm83.93-32.49q.13-3.51,0-7l15.83-19.79a4,4,0,0,0,.75-3.53A103.64,103.64,0,0,0,218,75.9a4,4,0,0,0-3-2l-25.19-2.8c-1.58-1.71-3.24-3.37-4.95-4.95L182.07,41a4,4,0,0,0-2-3A104,104,0,0,0,154.82,27.5a4,4,0,0,0-3.53.74L131.51,44.07q-3.51-.14-7,0L104.7,28.24a4,4,0,0,0-3.53-.75A103.64,103.64,0,0,0,75.9,38a4,4,0,0,0-2,3l-2.8,25.19c-1.71,1.58-3.37,3.24-4.95,4.95L41,73.93a4,4,0,0,0-3,2A104,104,0,0,0,27.5,101.18a4,4,0,0,0,.74,3.53l15.83,19.78q-.14,3.51,0,7L28.24,151.3a4,4,0,0,0-.75,3.53A103.64,103.64,0,0,0,38,180.1a4,4,0,0,0,3,2l25.19,2.8c1.58,1.71,3.24,3.37,4.95,4.95l2.8,25.2a4,4,0,0,0,2,3,104,104,0,0,0,25.28,10.46,4,4,0,0,0,3.53-.74l19.78-15.83q3.51.13,7,0l19.79,15.83a4,4,0,0,0,2.5.88,4,4,0,0,0,1-.13A103.64,103.64,0,0,0,180.1,218a4,4,0,0,0,2-3l2.8-25.19c1.71-1.58,3.37-3.24,4.95-4.95l25.2-2.8a4,4,0,0,0,3-2,104,104,0,0,0,10.46-25.28,4,4,0,0,0-.74-3.53Zm.17,42.83-24.67,2.74a4,4,0,0,0-2.55,1.32,76.2,76.2,0,0,1-6.48,6.48,4,4,0,0,0-1.32,2.55l-2.74,24.66a95.45,95.45,0,0,1-19.64,8.15l-19.38-15.51a4,4,0,0,0-2.5-.87h-.24a73.67,73.67,0,0,1-9.16,0,4,4,0,0,0-2.74.87l-19.37,15.5a95.33,95.33,0,0,1-19.65-8.13l-2.74-24.67a4,4,0,0,0-1.32-2.55,76.2,76.2,0,0,1-6.48-6.48,4,4,0,0,0-2.55-1.32l-24.66-2.74a95.45,95.45,0,0,1-8.15-19.64l15.51-19.38a4,4,0,0,0,.87-2.74,77.76,77.76,0,0,1,0-9.16,4,4,0,0,0-.87-2.74l-15.5-19.37A95.33,95.33,0,0,1,43.9,81.66l24.67-2.74a4,4,0,0,0,2.55-1.32,76.2,76.2,0,0,1,6.48-6.48,4,4,0,0,0,1.32-2.55l2.74-24.66a95.45,95.45,0,0,1,19.64-8.15l19.38,15.51a4,4,0,0,0,2.74.87,73.67,73.67,0,0,1,9.16,0,4,4,0,0,0,2.74-.87l19.37-15.5a95.33,95.33,0,0,1,19.65,8.13l2.74,24.67a4,4,0,0,0,1.32,2.55,76.2,76.2,0,0,1,6.48,6.48,4,4,0,0,0,2.55,1.32l24.66,2.74a95.45,95.45,0,0,1,8.15,19.64l-15.51,19.38a4,4,0,0,0-.87,2.74,77.76,77.76,0,0,1,0,9.16,4,4,0,0,0,.87,2.74l15.5,19.37A95.33,95.33,0,0,1,212.1,174.34Z"
        }))
    ]
]);


const $8dd1c6f3efdeb55a$export$70208e77f6c45b17 = $7fPBF.forwardRef((r, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: a,
        ...r,
        weights: (0, $7fac16834f0e6b11$export$2e2bcd8739ae039)
    }));
$8dd1c6f3efdeb55a$export$70208e77f6c45b17.displayName = "GearIcon";
const $8dd1c6f3efdeb55a$export$e5cc6136f1e14be3 = $8dd1c6f3efdeb55a$export$70208e77f6c45b17;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $01aa45825f23224d$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,187a113.4,113.4,0,0,1-20.39-35h40.82a116.94,116.94,0,0,1-10,20.77A108.61,108.61,0,0,1,128,207Zm-26.49-59a135.42,135.42,0,0,1,0-40h53a135.42,135.42,0,0,1,0,40ZM44,128a83.49,83.49,0,0,1,2.43-20H77.25a160.63,160.63,0,0,0,0,40H46.43A83.49,83.49,0,0,1,44,128Zm84-79a113.4,113.4,0,0,1,20.39,35H107.59a116.94,116.94,0,0,1,10-20.77A108.61,108.61,0,0,1,128,49Zm50.73,59h30.82a83.52,83.52,0,0,1,0,40H178.75a160.63,160.63,0,0,0,0-40Zm20.77-24H173.71a140.82,140.82,0,0,0-15.5-34.36A84.51,84.51,0,0,1,199.52,84ZM97.79,49.64A140.82,140.82,0,0,0,82.29,84H56.48A84.51,84.51,0,0,1,97.79,49.64ZM56.48,172H82.29a140.82,140.82,0,0,0,15.5,34.36A84.51,84.51,0,0,1,56.48,172Zm101.73,34.36A140.82,140.82,0,0,0,173.71,172h25.81A84.51,84.51,0,0,1,158.21,206.36Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24h0A104,104,0,1,0,232,128,104.12,104.12,0,0,0,128,24Zm88,104a87.61,87.61,0,0,1-3.33,24H174.16a157.44,157.44,0,0,0,0-48h38.51A87.61,87.61,0,0,1,216,128ZM102,168H154a115.11,115.11,0,0,1-26,45A115.27,115.27,0,0,1,102,168Zm-3.9-16a140.84,140.84,0,0,1,0-48h59.88a140.84,140.84,0,0,1,0,48ZM40,128a87.61,87.61,0,0,1,3.33-24H81.84a157.44,157.44,0,0,0,0,48H43.33A87.61,87.61,0,0,1,40,128ZM154,88H102a115.11,115.11,0,0,1,26-45A115.27,115.27,0,0,1,154,88Zm52.33,0H170.71a135.28,135.28,0,0,0-22.3-45.6A88.29,88.29,0,0,1,206.37,88ZM107.59,42.4A135.28,135.28,0,0,0,85.29,88H49.63A88.29,88.29,0,0,1,107.59,42.4ZM49.63,168H85.29a135.28,135.28,0,0,0,22.3,45.6A88.29,88.29,0,0,1,49.63,168Zm98.78,45.6a135.28,135.28,0,0,0,22.3-45.6h35.66A88.29,88.29,0,0,1,148.41,213.6Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24h0A104,104,0,1,0,232,128,104.12,104.12,0,0,0,128,24Zm78.36,64H170.71a135.28,135.28,0,0,0-22.3-45.6A88.29,88.29,0,0,1,206.37,88ZM216,128a87.61,87.61,0,0,1-3.33,24H174.16a157.44,157.44,0,0,0,0-48h38.51A87.61,87.61,0,0,1,216,128ZM128,43a115.27,115.27,0,0,1,26,45H102A115.11,115.11,0,0,1,128,43ZM102,168H154a115.11,115.11,0,0,1-26,45A115.27,115.27,0,0,1,102,168Zm-3.9-16a140.84,140.84,0,0,1,0-48h59.88a140.84,140.84,0,0,1,0,48Zm50.35,61.6a135.28,135.28,0,0,0,22.3-45.6h35.66A88.29,88.29,0,0,1,148.41,213.6Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm81.57,64H169.19a132.58,132.58,0,0,0-25.73-50.67A90.29,90.29,0,0,1,209.57,90ZM218,128a89.7,89.7,0,0,1-3.83,26H171.81a155.43,155.43,0,0,0,0-52h42.36A89.7,89.7,0,0,1,218,128Zm-90,87.83a110,110,0,0,1-15.19-19.45A124.24,124.24,0,0,1,99.35,166h57.3a124.24,124.24,0,0,1-13.46,30.38A110,110,0,0,1,128,215.83ZM96.45,154a139.18,139.18,0,0,1,0-52h63.1a139.18,139.18,0,0,1,0,52ZM38,128a89.7,89.7,0,0,1,3.83-26H84.19a155.43,155.43,0,0,0,0,52H41.83A89.7,89.7,0,0,1,38,128Zm90-87.83a110,110,0,0,1,15.19,19.45A124.24,124.24,0,0,1,156.65,90H99.35a124.24,124.24,0,0,1,13.46-30.38A110,110,0,0,1,128,40.17Zm-15.46-.84A132.58,132.58,0,0,0,86.81,90H46.43A90.29,90.29,0,0,1,112.54,39.33ZM46.43,166H86.81a132.58,132.58,0,0,0,25.73,50.67A90.29,90.29,0,0,1,46.43,166Zm97,50.67A132.58,132.58,0,0,0,169.19,166h40.38A90.29,90.29,0,0,1,143.46,216.67Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24h0A104,104,0,1,0,232,128,104.12,104.12,0,0,0,128,24Zm88,104a87.61,87.61,0,0,1-3.33,24H174.16a157.44,157.44,0,0,0,0-48h38.51A87.61,87.61,0,0,1,216,128ZM102,168H154a115.11,115.11,0,0,1-26,45A115.27,115.27,0,0,1,102,168Zm-3.9-16a140.84,140.84,0,0,1,0-48h59.88a140.84,140.84,0,0,1,0,48ZM40,128a87.61,87.61,0,0,1,3.33-24H81.84a157.44,157.44,0,0,0,0,48H43.33A87.61,87.61,0,0,1,40,128ZM154,88H102a115.11,115.11,0,0,1,26-45A115.27,115.27,0,0,1,154,88Zm52.33,0H170.71a135.28,135.28,0,0,0-22.3-45.6A88.29,88.29,0,0,1,206.37,88ZM107.59,42.4A135.28,135.28,0,0,0,85.29,88H49.63A88.29,88.29,0,0,1,107.59,42.4ZM49.63,168H85.29a135.28,135.28,0,0,0,22.3,45.6A88.29,88.29,0,0,1,49.63,168Zm98.78,45.6a135.28,135.28,0,0,0,22.3-45.6h35.66A88.29,88.29,0,0,1,148.41,213.6Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,28h0A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,190.61c-6.33-6.09-23-24.41-31.27-54.61h62.54C151,194.2,134.33,212.52,128,218.61ZM94.82,156a140.42,140.42,0,0,1,0-56h66.36a140.42,140.42,0,0,1,0,56ZM128,37.39c6.33,6.09,23,24.41,31.27,54.61H96.73C105,61.8,121.67,43.48,128,37.39ZM169.41,100h46.23a92.09,92.09,0,0,1,0,56H169.41a152.65,152.65,0,0,0,0-56Zm43.25-8h-45a129.39,129.39,0,0,0-29.19-55.4A92.25,92.25,0,0,1,212.66,92ZM117.54,36.6A129.39,129.39,0,0,0,88.35,92h-45A92.25,92.25,0,0,1,117.54,36.6ZM40.36,100H86.59a152.65,152.65,0,0,0,0,56H40.36a92.09,92.09,0,0,1,0-56Zm3,64h45a129.39,129.39,0,0,0,29.19,55.4A92.25,92.25,0,0,1,43.34,164Zm95.12,55.4A129.39,129.39,0,0,0,167.65,164h45A92.25,92.25,0,0,1,138.46,219.4Z"
        }))
    ]
]);


const $b80ecb83ad6de581$export$a70e2e549144f66 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...r,
        weights: (0, $01aa45825f23224d$export$2e2bcd8739ae039)
    }));
$b80ecb83ad6de581$export$a70e2e549144f66.displayName = "GlobeIcon";
const $b80ecb83ad6de581$export$3bc50e457b7f164b = $b80ecb83ad6de581$export$a70e2e549144f66;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $4bc0af47ad615b1e$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M249.8,85.49l-116-64a12,12,0,0,0-11.6,0l-116,64a12,12,0,0,0,0,21l21.8,12v47.76a19.89,19.89,0,0,0,5.09,13.32C46.63,194.7,77,220,128,220a136.88,136.88,0,0,0,40-5.75V240a12,12,0,0,0,24,0V204.12a119.53,119.53,0,0,0,30.91-24.51A19.89,19.89,0,0,0,228,166.29V118.53l21.8-12a12,12,0,0,0,0-21ZM128,45.71,219.16,96,186,114.3a1.88,1.88,0,0,1-.18-.12l-52-28.69a12,12,0,0,0-11.6,21l39,21.49L128,146.3,36.84,96ZM128,196c-40.42,0-64.65-19.07-76-31.27v-33l70.2,38.74a12,12,0,0,0,11.6,0L168,151.64v37.23A110.46,110.46,0,0,1,128,196Zm76-31.27a93.21,93.21,0,0,1-12,10.81V138.39l12-6.62Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,113.07v53.22a8,8,0,0,1-2,5.31c-11.3,12.59-38.9,36.4-86,36.4s-74.68-23.81-86-36.4a8,8,0,0,1-2-5.31V113.07L128,160Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M251.76,88.94l-120-64a8,8,0,0,0-7.52,0l-120,64a8,8,0,0,0,0,14.12L32,117.87v48.42a15.91,15.91,0,0,0,4.06,10.65C49.16,191.53,78.51,216,128,216a130,130,0,0,0,48-8.76V240a8,8,0,0,0,16,0V199.51a115.63,115.63,0,0,0,27.94-22.57A15.91,15.91,0,0,0,224,166.29V117.87l27.76-14.81a8,8,0,0,0,0-14.12ZM128,200c-43.27,0-68.72-21.14-80-33.71V126.4l76.24,40.66a8,8,0,0,0,7.52,0L176,143.47v46.34C163.4,195.69,147.52,200,128,200Zm80-33.75a97.83,97.83,0,0,1-16,14.25V134.93l16-8.53ZM188,118.94l-.22-.13-56-29.87a8,8,0,0,0-7.52,14.12L171,128l-43,22.93L25,96,128,41.07,231,96Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,207.24a119,119,0,0,0,16-7.73V240a8,8,0,0,1-16,0Zm11.76-88.43-56-29.87a8,8,0,0,0-7.52,14.12L171,128l17-9.06Zm64-29.87-120-64a8,8,0,0,0-7.52,0l-120,64a8,8,0,0,0,0,14.12L32,117.87v48.42a15.91,15.91,0,0,0,4.06,10.65C49.16,191.53,78.51,216,128,216a130,130,0,0,0,48-8.76V130.67L171,128l-43,22.93L43.83,106l0,0L25,96,128,41.07,231,96l-18.78,10-.06,0L188,118.94a8,8,0,0,1,4,6.93v73.64a115.63,115.63,0,0,0,27.94-22.57A15.91,15.91,0,0,0,224,166.29V117.87l27.76-14.81a8,8,0,0,0,0-14.12Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M250.82,90.71l-120-64a5.94,5.94,0,0,0-5.64,0l-120,64a6,6,0,0,0,0,10.58L34,116.67v49.62a14,14,0,0,0,3.55,9.32C50.42,189.94,79.29,214,128,214a127.21,127.21,0,0,0,50-9.73V240a6,6,0,0,0,12,0V198.35a113.18,113.18,0,0,0,28.45-22.75,13.91,13.91,0,0,0,3.55-9.31V116.67l28.82-15.38a6,6,0,0,0,0-10.58ZM128,202c-44,0-70-21.56-81.52-34.41a2,2,0,0,1-.48-1.3V123.07l79.18,42.22a6,6,0,0,0,5.64,0L178,140.13v51C165,197.35,148.45,202,128,202Zm82-35.71a2,2,0,0,1-.48,1.3A100.25,100.25,0,0,1,190,184.3V133.73l20-10.66Zm-22.15-45a6.27,6.27,0,0,0-1-.71l-56-29.86a6,6,0,0,0-5.64,10.58L175.25,128,128,153.2,20.75,96,128,38.8,235.25,96Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M251.76,88.94l-120-64a8,8,0,0,0-7.52,0l-120,64a8,8,0,0,0,0,14.12L32,117.87v48.42a15.91,15.91,0,0,0,4.06,10.65C49.16,191.53,78.51,216,128,216a130,130,0,0,0,48-8.76V240a8,8,0,0,0,16,0V199.51a115.63,115.63,0,0,0,27.94-22.57A15.91,15.91,0,0,0,224,166.29V117.87l27.76-14.81a8,8,0,0,0,0-14.12ZM128,200c-43.27,0-68.72-21.14-80-33.71V126.4l76.24,40.66a8,8,0,0,0,7.52,0L176,143.47v46.34C163.4,195.69,147.52,200,128,200Zm80-33.75a97.83,97.83,0,0,1-16,14.25V134.93l16-8.53ZM188,118.94l-.22-.13-56-29.87a8,8,0,0,0-7.52,14.12L171,128l-43,22.93L25,96,128,41.07,231,96Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M249.88,92.47l-120-64a4,4,0,0,0-3.76,0l-120,64a4,4,0,0,0,0,7.06L36,115.47v50.82a11.92,11.92,0,0,0,3,8c12.65,14.09,41,37.73,89,37.73,21,0,38.2-4.52,52-10.79V240a4,4,0,0,0,8,0V197.18a111.64,111.64,0,0,0,29-22.91,11.94,11.94,0,0,0,3-8V115.47l29.88-15.94a4,4,0,0,0,0-7.06ZM128,204c-44.83,0-71.25-22-83-35.08a3.92,3.92,0,0,1-1-2.63V119.73l82.12,43.8a4,4,0,0,0,3.76,0L180,136.8v55.53C166.58,199,149.39,204,128,204Zm84-37.71a4,4,0,0,1-1,2.64,103.32,103.32,0,0,1-23,19v-55.4l24-12.8Zm-24.59-42.51a4,4,0,0,0-1.53-1.44l-56-29.87a4,4,0,0,0-3.76,7.06L179.5,128,128,155.47,16.5,96,128,36.53,239.5,96Z"
        }))
    ]
]);


const $862061e2a830a35b$export$3ac311e31945509f = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...r,
        weights: (0, $4bc0af47ad615b1e$export$2e2bcd8739ae039)
    }));
$862061e2a830a35b$export$3ac311e31945509f.displayName = "GraduationCapIcon";
const $862061e2a830a35b$export$c94f95e8e2d2bae0 = $862061e2a830a35b$export$3ac311e31945509f;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $07d194764b1c387c$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M250.18,105.17,186.71,41.25a100.11,100.11,0,0,0-141.43,0l-.13.14L31.37,55.61a12,12,0,1,0,17.24,16.7L62.32,58.16A75.68,75.68,0,0,1,77.49,46.43L119,88,25.85,181.16a20,20,0,0,0,0,28.29l20.69,20.69a20,20,0,0,0,28.28,0L168,137l1.51,1.51h0l23.65,23.66a20,20,0,0,0,28.29,0l28.69-28.7A20,20,0,0,0,250.18,105.17ZM60.68,210.34l-15-15L108,133l15,15ZM140,131l-15-15,19.51-19.51a12,12,0,0,0,0-17L102.24,37.24a75.94,75.94,0,0,1,67.47,20.95l31.44,31.67L178,113l-1.51-1.51a12,12,0,0,0-17,0Zm67.32,11.31L195,130l23.09-23.09,12.3,12.39Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M245.66,129,217,157.66a8,8,0,0,1-11.3,0L168.1,120l-28,28-32-32,28-28L80,31.78a87.81,87.81,0,0,1,98.31,18l67.35,67.89A8,8,0,0,1,245.66,129Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M251.34,112,183.88,44.08a96.1,96.1,0,0,0-135.77,0l-.09.09L34.25,58.4A8,8,0,0,0,45.74,69.53L59.47,55.35a79.92,79.92,0,0,1,18.71-13.9L124.68,88l-96,96a16,16,0,0,0,0,22.63l20.69,20.69a16,16,0,0,0,22.63,0l96-96,14.34,14.34h0L200,163.3a16,16,0,0,0,22.63,0l28.69-28.69A16,16,0,0,0,251.34,112ZM60.68,216,40,195.31l68-68L128.68,148ZM162.34,114.32,140,136.67,119.31,116l22.35-22.35a8,8,0,0,0,0-11.32L94.32,35a80,80,0,0,1,78.23,20.41l44.22,44.51L188,128.66l-14.34-14.34A8,8,0,0,0,162.34,114.32Zm49,37.66-12-12L228,111.25l12,12Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M251.34,112,183.88,44.08a96.1,96.1,0,0,0-135.77,0l-.09.09L34.25,58.4A8,8,0,0,0,45.74,69.53L59.47,55.35a79.92,79.92,0,0,1,18.71-13.9L124.68,88l-96,96a16,16,0,0,0,0,22.63l20.69,20.69a16,16,0,0,0,22.63,0l96-96,32,32a16,16,0,0,0,22.63,0l28.69-28.69A16,16,0,0,0,251.34,112Zm-89,2.33L140,136.67,119.31,116l22.35-22.35a8,8,0,0,0,0-11.32L94.32,35a80,80,0,0,1,78.23,20.41l44.22,44.51L188,128.66l-14.34-14.34A8,8,0,0,0,162.34,114.32Zm49,37.66-12-12L228,111.25l12,12Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M249.92,113.4,182.47,45.49a94.12,94.12,0,0,0-133,.06L35.68,59.78a6,6,0,0,0,8.63,8.35L58,54A82,82,0,0,1,78.55,39l49,49L30.09,185.4a14,14,0,0,0,0,19.81L50.78,225.9a14,14,0,0,0,19.8,0L168,128.46l33.42,33.42a14,14,0,0,0,19.8,0l28.68-28.69A14,14,0,0,0,249.92,113.4ZM62.1,217.41a2,2,0,0,1-2.83,0L38.58,196.72a2,2,0,0,1,0-2.83L108,124.46,131.51,148ZM163.76,115.73,140,139.49,116.48,116l23.76-23.76a6,6,0,0,0,0-8.49L90.54,34A82.07,82.07,0,0,1,174,54l45.62,45.93L188,131.49l-15.76-15.76A6,6,0,0,0,163.76,115.73Zm77.66,9-28.69,28.7a2,2,0,0,1-2.83,0L196.49,140l31.56-31.57,13.37,13.46A2,2,0,0,1,241.42,124.7Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M251.34,112,183.88,44.08a96.1,96.1,0,0,0-135.77,0l-.09.09L34.25,58.4A8,8,0,0,0,45.74,69.53L59.47,55.35a79.92,79.92,0,0,1,18.71-13.9L124.68,88l-96,96a16,16,0,0,0,0,22.63l20.69,20.69a16,16,0,0,0,22.63,0l96-96,14.34,14.34h0L200,163.3a16,16,0,0,0,22.63,0l28.69-28.69A16,16,0,0,0,251.34,112ZM60.68,216,40,195.31l68-68L128.68,148ZM162.34,114.32,140,136.67,119.31,116l22.35-22.35a8,8,0,0,0,0-11.32L94.32,35a80,80,0,0,1,78.23,20.41l44.22,44.51L188,128.66l-14.34-14.34A8,8,0,0,0,162.34,114.32Zm49,37.66-12-12L228,111.25l12,12Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M248.5,114.81,181.05,46.9A92.1,92.1,0,0,0,50.9,47L37.12,61.18a4,4,0,1,0,5.75,5.56L56.6,52.56a83.75,83.75,0,0,1,22.34-16L130.34,88,31.51,186.82a12,12,0,0,0,0,17L52.2,224.48a12,12,0,0,0,17,0L168,125.63l17.17,17.18h0l17.66,17.66a12,12,0,0,0,17,0l28.69-28.69A12,12,0,0,0,248.5,114.81Zm-185,104a4,4,0,0,1-5.66,0L37.17,198.14a4,4,0,0,1,0-5.66L108,121.63,134.34,148ZM165.17,117.15,140,142.32,113.65,116,138.83,90.8a4,4,0,0,0,0-5.66l-52-52a84.11,84.11,0,0,1,88.52,19.38l47,47.35L188,134.32l-17.17-17.17A4,4,0,0,0,165.17,117.15Zm77.66,9-28.68,28.69a4,4,0,0,1-5.66,0L193.66,140l34.39-34.4,14.78,14.88A4,4,0,0,1,242.83,126.12Z"
        }))
    ]
]);


const $4d330376fb0bcf89$export$57e3e6ad9de04bb9 = $7fPBF.forwardRef((o, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...o,
        weights: (0, $07d194764b1c387c$export$2e2bcd8739ae039)
    }));
$4d330376fb0bcf89$export$57e3e6ad9de04bb9.displayName = "HammerIcon";
const $4d330376fb0bcf89$export$f8f0760d4a67552c = $4d330376fb0bcf89$export$57e3e6ad9de04bb9;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $64163963d624efaa$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228,156v36c0,13.85-1.63,26.52-4.58,35.68a12,12,0,1,1-22.84-7.36c2.14-6.65,3.42-17.24,3.42-28.32V156a8,8,0,0,0-16,0v4a12,12,0,0,1-24,0V140a8,8,0,0,0-16,0v12a12,12,0,0,1-24,0V84a8,8,0,0,0-16,0V192a12,12,0,0,1-22.18,6.34l-18.68-30-.21-.34A8,8,0,0,0,53,175.92L78.27,217.8a12,12,0,0,1-20.56,12.39l-25.31-42-.12-.2A32,32,0,0,1,84,150.83V84a32,32,0,0,1,64,0v25a32,32,0,0,1,36.78,17A32,32,0,0,1,228,156ZM56,96A12,12,0,0,0,68,84a48,48,0,0,1,96,0,12,12,0,0,0,24,0A72,72,0,0,0,44,84,12,12,0,0,0,56,96Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,148v36c0,24-8,40-8,40H72L42.68,174a20,20,0,0,1,34.64-20L96,184V76a20,20,0,0,1,40,0v56a20,20,0,0,1,40,0v16a20,20,0,0,1,40,0Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M56,76a60,60,0,0,1,120,0,8,8,0,0,1-16,0,44,44,0,0,0-88,0,8,8,0,1,1-16,0Zm140,44a27.9,27.9,0,0,0-13.36,3.39A28,28,0,0,0,144,106.7V76a28,28,0,0,0-56,0v80l-3.82-6.13a28,28,0,0,0-48.41,28.17l29.32,50A8,8,0,1,0,78.89,220L49.6,170a12,12,0,1,1,20.78-12l.14.23,18.68,30A8,8,0,0,0,104,184V76a12,12,0,0,1,24,0v68a8,8,0,1,0,16,0V132a12,12,0,0,1,24,0v20a8,8,0,0,0,16,0v-4a12,12,0,0,1,24,0v36c0,21.61-7.1,36.3-7.16,36.42a8,8,0,0,0,3.58,10.73A7.9,7.9,0,0,0,208,232a8,8,0,0,0,7.16-4.42c.37-.73,8.85-18,8.85-43.58V148A28,28,0,0,0,196,120Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M64,64a48,48,0,0,1,96,0,8,8,0,0,1-16,0,32,32,0,0,0-64,0,8,8,0,0,1-16,0Zm143.23,56c-8.61.4-15.23,7.82-15.23,16.43v7.28a8.17,8.17,0,0,1-7.47,8.25,8,8,0,0,1-8.53-8V120.45c0-8.61-6.62-16-15.23-16.43A16,16,0,0,0,144,120v15.73a8.17,8.17,0,0,1-7.47,8.25,8,8,0,0,1-8.53-8V64.45c0-8.61-6.62-16-15.23-16.43A16,16,0,0,0,96,64V183.74a8.19,8.19,0,0,1-6.72,8.16l-.12,0a6.09,6.09,0,0,1-6-3.09l-21-36.44c-4.3-7.46-13.74-10.57-21.4-6.62A16,16,0,0,0,34.15,168L65.1,228.05A8,8,0,0,0,72,232H208a8,8,0,0,0,7.16-4.42c.36-.72,8.84-15.06,8.84-40.65V136A16,16,0,0,0,207.23,120Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M58,76a58,58,0,0,1,116,0,6,6,0,0,1-12,0,46,46,0,0,0-92,0,6,6,0,0,1-12,0Zm138,46a25.87,25.87,0,0,0-14.59,4.49A26,26,0,0,0,142,110.1V76a26,26,0,0,0-52,0v87l-7.53-12.1a26,26,0,0,0-45,26.13l29.32,50A6,6,0,0,0,77.16,221L47.87,171a14,14,0,0,1,24.25-14,1,1,0,0,0,.1.17l18.68,30A6,6,0,0,0,102,184V76a14,14,0,0,1,28,0v68a6,6,0,0,0,12,0V132a14,14,0,0,1,28,0v20a6,6,0,0,0,12,0v-4a14,14,0,0,1,28,0v36c0,22.13-7.3,37.18-7.37,37.32a6,6,0,0,0,2.69,8A5.83,5.83,0,0,0,208,230a6,6,0,0,0,5.38-3.32c.35-.7,8.63-17.55,8.63-42.68V148A26,26,0,0,0,196,122Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M56,76a60,60,0,0,1,120,0,8,8,0,0,1-16,0,44,44,0,0,0-88,0,8,8,0,1,1-16,0Zm140,44a27.9,27.9,0,0,0-13.36,3.39A28,28,0,0,0,144,106.7V76a28,28,0,0,0-56,0v80l-3.82-6.13a28,28,0,0,0-48.41,28.17l29.32,50A8,8,0,1,0,78.89,220L49.6,170a12,12,0,1,1,20.78-12l.14.23,18.68,30A8,8,0,0,0,104,184V76a12,12,0,0,1,24,0v68a8,8,0,1,0,16,0V132a12,12,0,0,1,24,0v20a8,8,0,0,0,16,0v-4a12,12,0,0,1,24,0v36c0,21.61-7.1,36.3-7.16,36.42a8,8,0,0,0,3.58,10.73A7.9,7.9,0,0,0,208,232a8,8,0,0,0,7.16-4.42c.37-.73,8.85-18,8.85-43.58V148A28,28,0,0,0,196,120Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M60,76a56,56,0,0,1,112,0,4,4,0,0,1-8,0,48,48,0,0,0-96,0,4,4,0,1,1-8,0Zm136,48a23.88,23.88,0,0,0-16.07,6.19A24,24,0,0,0,140,114.13V76a24,24,0,0,0-48,0v94L80.74,151.94A24,24,0,0,0,39.22,176l29.32,50a4,4,0,0,0,6.9-4L46.13,172a16,16,0,0,1,27.72-16l.07.12,18.68,30A4,4,0,0,0,100,184V76a16,16,0,0,1,32,0v68a4,4,0,0,0,8,0V132a16,16,0,0,1,32,0v20a4,4,0,0,0,8,0v-4a16,16,0,0,1,32,0v36c0,22.66-7.51,38.06-7.58,38.21a4,4,0,0,0,1.79,5.37A4.05,4.05,0,0,0,208,228a4,4,0,0,0,3.58-2.21c.34-.69,8.42-17.13,8.42-41.79V148A24,24,0,0,0,196,124Z"
        }))
    ]
]);


const $1ba208388ac239df$export$7caf2e6d06b0e274 = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...e,
        weights: (0, $64163963d624efaa$export$2e2bcd8739ae039)
    }));
$1ba208388ac239df$export$7caf2e6d06b0e274.displayName = "HandTapIcon";
const $1ba208388ac239df$export$bb33fcc3181d329 = $1ba208388ac239df$export$7caf2e6d06b0e274;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $0eebba49a7def99a$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M225.84,54.13A62.07,62.07,0,0,0,138.32,54L128,63.58,117.68,54a62,62,0,0,0-87.58,87.8l89.35,90.65a12,12,0,0,0,17.1,0l89.29-90.59a62,62,0,0,0,0-87.7Zm-17,70.79L128,206.9,47.13,124.85a38,38,0,0,1,53.74-53.74c.1.1.2.2.31.29l18.64,17.36a12,12,0,0,0,16.36,0L154.82,71.4c.11-.09.21-.19.31-.29a38,38,0,1,1,53.68,53.81Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M217.36,133.36,128,224,38.64,133.36a50,50,0,0,1,70.72-70.72L128,80l18.64-17.36a50,50,0,1,1,70.72,70.72Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M223,57a58.07,58.07,0,0,0-81.92-.1L128,69.05,114.91,56.86A58,58,0,0,0,33,139l89.35,90.66a8,8,0,0,0,11.4,0L223,139a58,58,0,0,0,0-82Zm-11.35,70.76L128,212.6,44.3,127.68a42,42,0,0,1,59.4-59.4l.2.2,18.65,17.35a8,8,0,0,0,10.9,0L152.1,68.48l.2-.2a42,42,0,1,1,59.36,59.44Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240,98a57.63,57.63,0,0,1-17,41L133.7,229.62a8,8,0,0,1-11.4,0L33,139a58,58,0,0,1,82-82.1L128,69.05l13.09-12.19A58,58,0,0,1,240,98Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M221.6,58.38a56.06,56.06,0,0,0-79.12-.08L128,71.78,113.52,58.3a56,56,0,0,0-79.15,79.25l89.36,90.66a6,6,0,0,0,8.54,0l89.33-90.62a56,56,0,0,0,0-79.21Zm-8.52,70.75L128,215.45,42.89,129.1a44,44,0,0,1,62.22-62.23,1.07,1.07,0,0,0,.16.14l18.64,17.36a6,6,0,0,0,8.18,0L150.73,67a1.07,1.07,0,0,0,.16-.14,44,44,0,1,1,62.19,62.26Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M223,57a58.07,58.07,0,0,0-81.92-.1L128,69.05,114.91,56.86A58,58,0,0,0,33,139l89.35,90.66a8,8,0,0,0,11.4,0L223,139a58,58,0,0,0,0-82Zm-11.35,70.76L128,212.6,44.3,127.68a42,42,0,0,1,59.4-59.4l.2.2,18.65,17.35a8,8,0,0,0,10.9,0L152.1,68.48l.2-.2a42,42,0,1,1,59.36,59.44Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220.18,59.79a54.05,54.05,0,0,0-76.31,0L128,74.51,112.13,59.74A54,54,0,0,0,35.8,136.15l89.35,90.66a4,4,0,0,0,5.7,0l89.33-90.64a54,54,0,0,0,0-76.38Zm-5.67,70.74L128,218.3,41.47,130.51a46,46,0,0,1,65.06-65.06l.1.1,18.64,17.36a4,4,0,0,0,5.46,0l18.64-17.36.1-.1a46,46,0,1,1,65,65.08Z"
        }))
    ]
]);


const $daf0af796c7daf33$export$44fb2b0459be5849 = $7fPBF.forwardRef((a, e)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: e,
        ...a,
        weights: (0, $0eebba49a7def99a$export$2e2bcd8739ae039)
    }));
$daf0af796c7daf33$export$44fb2b0459be5849.displayName = "HeartStraightIcon";
const $daf0af796c7daf33$export$9245b4499dccac79 = $daf0af796c7daf33$export$44fb2b0459be5849;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $cece1c6e7dde4801$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M222.14,105.85l-80-80a20,20,0,0,0-28.28,0l-80,80A19.86,19.86,0,0,0,28,120v96a12,12,0,0,0,12,12h64a12,12,0,0,0,12-12V164h24v52a12,12,0,0,0,12,12h64a12,12,0,0,0,12-12V120A19.86,19.86,0,0,0,222.14,105.85ZM204,204H164V152a12,12,0,0,0-12-12H104a12,12,0,0,0-12,12v52H52V121.65l76-76,76,76Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,120v96H152V152H104v64H40V120a8,8,0,0,1,2.34-5.66l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,216,120Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M219.31,108.68l-80-80a16,16,0,0,0-22.62,0l-80,80A15.87,15.87,0,0,0,32,120v96a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V160h32v56a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V120A15.87,15.87,0,0,0,219.31,108.68ZM208,208H160V152a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v56H48V120l80-80,80,80Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,120v96a8,8,0,0,1-8,8H160a8,8,0,0,1-8-8V164a4,4,0,0,0-4-4H108a4,4,0,0,0-4,4v52a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V120a16,16,0,0,1,4.69-11.31l80-80a16,16,0,0,1,22.62,0l80,80A16,16,0,0,1,224,120Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M217.9,110.1l-80-80a14,14,0,0,0-19.8,0l-80,80A13.92,13.92,0,0,0,34,120v96a6,6,0,0,0,6,6h64a6,6,0,0,0,6-6V158h36v58a6,6,0,0,0,6,6h64a6,6,0,0,0,6-6V120A13.92,13.92,0,0,0,217.9,110.1ZM210,210H158V152a6,6,0,0,0-6-6H104a6,6,0,0,0-6,6v58H46V120a2,2,0,0,1,.58-1.42l80-80a2,2,0,0,1,2.84,0l80,80A2,2,0,0,1,210,120Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M219.31,108.68l-80-80a16,16,0,0,0-22.62,0l-80,80A15.87,15.87,0,0,0,32,120v96a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V160h32v56a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V120A15.87,15.87,0,0,0,219.31,108.68ZM208,208H160V152a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v56H48V120l80-80,80,80Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216.49,111.51l-80-80a12,12,0,0,0-17,0l-80,80A12,12,0,0,0,36,120v96a4,4,0,0,0,4,4h64a4,4,0,0,0,4-4V156h40v60a4,4,0,0,0,4,4h64a4,4,0,0,0,4-4V120A12,12,0,0,0,216.49,111.51ZM212,212H156V152a4,4,0,0,0-4-4H104a4,4,0,0,0-4,4v60H44V120a4,4,0,0,1,1.17-2.83l80-80a4,4,0,0,1,5.66,0l80,80A4,4,0,0,1,212,120Z"
        }))
    ]
]);


const $7f183d9af8860529$export$f8c453d4287040a2 = $7fPBF.forwardRef((r, s)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: s,
        ...r,
        weights: (0, $cece1c6e7dde4801$export$2e2bcd8739ae039)
    }));
$7f183d9af8860529$export$f8c453d4287040a2.displayName = "HouseIcon";
const $7f183d9af8860529$export$1027d4534a5ce60b = $7f183d9af8860529$export$f8c453d4287040a2;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $a09f93ef63827300$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,20H56A20,20,0,0,0,36,40V216a20,20,0,0,0,20,20H200a20,20,0,0,0,20-20V40A20,20,0,0,0,200,20Zm-4,192H60V44H196ZM84,68A12,12,0,0,1,96,56h64a12,12,0,0,1,0,24H96A12,12,0,0,1,84,68Zm8.8,127.37a48,48,0,0,1,70.4,0,12,12,0,0,0,17.6-16.32,72,72,0,0,0-19.21-14.68,44,44,0,1,0-67.19,0,72.12,72.12,0,0,0-19.2,14.68,12,12,0,0,0,17.6,16.32ZM128,116a20,20,0,1,1-20,20A20,20,0,0,1,128,116Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,32H56a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V40A8,8,0,0,0,200,32ZM128,168a32,32,0,1,1,32-32A32,32,0,0,1,128,168Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M75.19,198.4a8,8,0,0,0,11.21-1.6,52,52,0,0,1,83.2,0,8,8,0,1,0,12.8-9.6A67.88,67.88,0,0,0,155,165.51a40,40,0,1,0-53.94,0A67.88,67.88,0,0,0,73.6,187.2,8,8,0,0,0,75.19,198.4ZM128,112a24,24,0,1,1-24,24A24,24,0,0,1,128,112Zm72-88H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24Zm0,192H56V40H200ZM88,64a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H96A8,8,0,0,1,88,64Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24ZM96,48h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm84.81,150.4a8,8,0,0,1-11.21-1.6,52,52,0,0,0-83.2,0,8,8,0,1,1-12.8-9.6A67.88,67.88,0,0,1,101,165.51a40,40,0,1,1,53.94,0A67.88,67.88,0,0,1,182.4,187.2,8,8,0,0,1,180.81,198.4ZM152,136a24,24,0,1,1-24-24A24,24,0,0,1,152,136Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M151.11,166.13a38,38,0,1,0-46.22,0A65.75,65.75,0,0,0,75.2,188.4a6,6,0,0,0,9.6,7.2,54,54,0,0,1,86.4,0,6,6,0,0,0,9.6-7.2A65.75,65.75,0,0,0,151.11,166.13ZM128,110a26,26,0,1,1-26,26A26,26,0,0,1,128,110Zm72-84H56A14,14,0,0,0,42,40V216a14,14,0,0,0,14,14H200a14,14,0,0,0,14-14V40A14,14,0,0,0,200,26Zm2,190a2,2,0,0,1-2,2H56a2,2,0,0,1-2-2V40a2,2,0,0,1,2-2H200a2,2,0,0,1,2,2ZM90,64a6,6,0,0,1,6-6h64a6,6,0,0,1,0,12H96A6,6,0,0,1,90,64Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M75.19,198.4a8,8,0,0,0,11.21-1.6,52,52,0,0,1,83.2,0,8,8,0,1,0,12.8-9.6A67.88,67.88,0,0,0,155,165.51a40,40,0,1,0-53.94,0A67.88,67.88,0,0,0,73.6,187.2,8,8,0,0,0,75.19,198.4ZM128,112a24,24,0,1,1-24,24A24,24,0,0,1,128,112Zm72-88H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24Zm0,192H56V40H200ZM88,64a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H96A8,8,0,0,1,88,64Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M146.7,166.75a36,36,0,1,0-37.4,0A63.61,63.61,0,0,0,76.8,189.6a4,4,0,0,0,6.4,4.8,56,56,0,0,1,89.6,0,4,4,0,0,0,6.4-4.8A63.65,63.65,0,0,0,146.7,166.75ZM100,136a28,28,0,1,1,28,28A28,28,0,0,1,100,136ZM200,28H56A12,12,0,0,0,44,40V216a12,12,0,0,0,12,12H200a12,12,0,0,0,12-12V40A12,12,0,0,0,200,28Zm4,188a4,4,0,0,1-4,4H56a4,4,0,0,1-4-4V40a4,4,0,0,1,4-4H200a4,4,0,0,1,4,4ZM92,64a4,4,0,0,1,4-4h64a4,4,0,0,1,0,8H96A4,4,0,0,1,92,64Z"
        }))
    ]
]);


const $866da9b1db75c8ee$export$5039d390f8f90df = $7fPBF.forwardRef((t, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: a,
        ...t,
        weights: (0, $a09f93ef63827300$export$2e2bcd8739ae039)
    }));
$866da9b1db75c8ee$export$5039d390f8f90df.displayName = "IdentificationBadgeIcon";
const $866da9b1db75c8ee$export$53bf5a6fb4ebd92 = $866da9b1db75c8ee$export$5039d390f8f90df;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $0c0657dd86cc9c0e$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,144H140V98.32a44,44,0,1,0-24,0V144H48a20,20,0,0,0-20,20v44a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V164A20,20,0,0,0,208,144ZM108,56a20,20,0,1,1,20,20A20,20,0,0,1,108,56Zm96,148H52V168H204ZM172,104h32a12,12,0,0,1,0,24H172a12,12,0,0,1,0-24Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,160v48a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V160a8,8,0,0,1,8-8H208A8,8,0,0,1,216,160ZM128,88A32,32,0,1,0,96,56,32,32,0,0,0,128,88Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,144H136V95.19a40,40,0,1,0-16,0V144H48a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V160A16,16,0,0,0,208,144ZM104,56a24,24,0,1,1,24,24A24,24,0,0,1,104,56ZM208,208H48V160H208v48Zm-40-96h32a8,8,0,0,1,0,16H168a8,8,0,0,1,0-16Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,160v48a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V160a16,16,0,0,1,16-16h72V95.19a40,40,0,1,1,16,0V144h72A16,16,0,0,1,224,160Zm-64-40a8,8,0,0,0,8,8h32a8,8,0,0,0,0-16H168A8,8,0,0,0,160,120Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,146H134V93.52a38,38,0,1,0-12,0V146H48a14,14,0,0,0-14,14v48a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V160A14,14,0,0,0,208,146ZM102,56a26,26,0,1,1,26,26A26,26,0,0,1,102,56ZM210,208a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V160a2,2,0,0,1,2-2H208a2,2,0,0,1,2,2Zm-42-94h32a6,6,0,0,1,0,12H168a6,6,0,0,1,0-12Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,144H136V95.19a40,40,0,1,0-16,0V144H48a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V160A16,16,0,0,0,208,144ZM104,56a24,24,0,1,1,24,24A24,24,0,0,1,104,56ZM208,208H48V160H208v48Zm-40-96h32a8,8,0,0,1,0,16H168a8,8,0,0,1,0-16Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,148H132V91.77a36,36,0,1,0-8,0V148H48a12,12,0,0,0-12,12v48a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V160A12,12,0,0,0,208,148ZM100,56a28,28,0,1,1,28,28A28,28,0,0,1,100,56ZM212,208a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V160a4,4,0,0,1,4-4H208a4,4,0,0,1,4,4Zm-48-88a4,4,0,0,1,4-4h32a4,4,0,0,1,0,8H168A4,4,0,0,1,164,120Z"
        }))
    ]
]);


const $6234b88ab556c79a$export$da69e29052e4731 = $7fPBF.forwardRef((c, e)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: e,
        ...c,
        weights: (0, $0c0657dd86cc9c0e$export$2e2bcd8739ae039)
    }));
$6234b88ab556c79a$export$da69e29052e4731.displayName = "JoystickIcon";
const $6234b88ab556c79a$export$41026bc5091240de = $6234b88ab556c79a$export$da69e29052e4731;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $1ce9eef6e2ab403c$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,44H32A20,20,0,0,0,12,64V192a20,20,0,0,0,20,20H224a20,20,0,0,0,20-20V64A20,20,0,0,0,224,44Zm-4,144H36V68H220ZM52,128a12,12,0,0,1,12-12H192a12,12,0,0,1,0,24H64A12,12,0,0,1,52,128Zm0-36A12,12,0,0,1,64,80H192a12,12,0,0,1,0,24H64A12,12,0,0,1,52,92Zm0,72a12,12,0,0,1,12-12h8a12,12,0,0,1,0,24H64A12,12,0,0,1,52,164Zm108,0a12,12,0,0,1-12,12H108a12,12,0,0,1,0-24h40A12,12,0,0,1,160,164Zm44,0a12,12,0,0,1-12,12h-8a12,12,0,0,1,0-24h8A12,12,0,0,1,204,164Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,64V192a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H224A8,8,0,0,1,232,64Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48Zm0,144H32V64H224V192Zm-16-64a8,8,0,0,1-8,8H56a8,8,0,0,1,0-16H200A8,8,0,0,1,208,128Zm0-32a8,8,0,0,1-8,8H56a8,8,0,0,1,0-16H200A8,8,0,0,1,208,96ZM72,160a8,8,0,0,1-8,8H56a8,8,0,0,1,0-16h8A8,8,0,0,1,72,160Zm96,0a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,160Zm40,0a8,8,0,0,1-8,8h-8a8,8,0,0,1,0-16h8A8,8,0,0,1,208,160Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48ZM64,168H48a8,8,0,0,1,0-16H64a8,8,0,0,1,0,16Zm96,0H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm48,0H192a8,8,0,0,1,0-16h16a8,8,0,0,1,0,16Zm0-32H48a8,8,0,0,1,0-16H208a8,8,0,0,1,0,16Zm0-32H48a8,8,0,0,1,0-16H208a8,8,0,0,1,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,50H32A14,14,0,0,0,18,64V192a14,14,0,0,0,14,14H224a14,14,0,0,0,14-14V64A14,14,0,0,0,224,50Zm2,142a2,2,0,0,1-2,2H32a2,2,0,0,1-2-2V64a2,2,0,0,1,2-2H224a2,2,0,0,1,2,2Zm-20-64a6,6,0,0,1-6,6H56a6,6,0,0,1,0-12H200A6,6,0,0,1,206,128Zm0-32a6,6,0,0,1-6,6H56a6,6,0,0,1,0-12H200A6,6,0,0,1,206,96ZM70,160a6,6,0,0,1-6,6H56a6,6,0,0,1,0-12h8A6,6,0,0,1,70,160Zm96,0a6,6,0,0,1-6,6H96a6,6,0,0,1,0-12h64A6,6,0,0,1,166,160Zm40,0a6,6,0,0,1-6,6h-8a6,6,0,0,1,0-12h8A6,6,0,0,1,206,160Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48Zm0,144H32V64H224V192Zm-16-64a8,8,0,0,1-8,8H56a8,8,0,0,1,0-16H200A8,8,0,0,1,208,128Zm0-32a8,8,0,0,1-8,8H56a8,8,0,0,1,0-16H200A8,8,0,0,1,208,96ZM72,160a8,8,0,0,1-8,8H56a8,8,0,0,1,0-16h8A8,8,0,0,1,72,160Zm96,0a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,160Zm40,0a8,8,0,0,1-8,8h-8a8,8,0,0,1,0-16h8A8,8,0,0,1,208,160Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,52H32A12,12,0,0,0,20,64V192a12,12,0,0,0,12,12H224a12,12,0,0,0,12-12V64A12,12,0,0,0,224,52Zm4,140a4,4,0,0,1-4,4H32a4,4,0,0,1-4-4V64a4,4,0,0,1,4-4H224a4,4,0,0,1,4,4Zm-24-64a4,4,0,0,1-4,4H56a4,4,0,0,1,0-8H200A4,4,0,0,1,204,128Zm0-32a4,4,0,0,1-4,4H56a4,4,0,0,1,0-8H200A4,4,0,0,1,204,96ZM68,160a4,4,0,0,1-4,4H56a4,4,0,0,1,0-8h8A4,4,0,0,1,68,160Zm96,0a4,4,0,0,1-4,4H96a4,4,0,0,1,0-8h64A4,4,0,0,1,164,160Zm40,0a4,4,0,0,1-4,4h-8a4,4,0,0,1,0-8h8A4,4,0,0,1,204,160Z"
        }))
    ]
]);


const $3977927b8e8acd3c$export$97dac707ecee26f6 = $7fPBF.forwardRef((r, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: a,
        ...r,
        weights: (0, $1ce9eef6e2ab403c$export$2e2bcd8739ae039)
    }));
$3977927b8e8acd3c$export$97dac707ecee26f6.displayName = "KeyboardIcon";
const $3977927b8e8acd3c$export$16e4d70cc375e707 = $3977927b8e8acd3c$export$97dac707ecee26f6;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $b91bd6ee26a2f073$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M196,76a16,16,0,1,1-16-16A16,16,0,0,1,196,76Zm48,22.74A84.3,84.3,0,0,1,160.11,180H160a83.52,83.52,0,0,1-23.65-3.38l-7.86,7.87A12,12,0,0,1,120,188H108v12a12,12,0,0,1-12,12H84v12a12,12,0,0,1-12,12H40a20,20,0,0,1-20-20V187.31a19.86,19.86,0,0,1,5.86-14.14l53.52-53.52A84,84,0,1,1,244,98.74ZM202.43,53.57A59.48,59.48,0,0,0,158,36c-32,1-58,27.89-58,59.89a59.69,59.69,0,0,0,4.2,22.19,12,12,0,0,1-2.55,13.21L44,189v23H60V200a12,12,0,0,1,12-12H84V176a12,12,0,0,1,12-12h19l9.65-9.65a12,12,0,0,1,13.22-2.55A59.58,59.58,0,0,0,160,156h.08c32,0,58.87-26.07,59.89-58A59.55,59.55,0,0,0,202.43,53.57Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,98.36C230.73,136.92,198.67,168,160.09,168a71.68,71.68,0,0,1-26.92-5.17h0L120,176H96v24H72v24H40a8,8,0,0,1-8-8V187.31a8,8,0,0,1,2.34-5.65l58.83-58.83h0A71.68,71.68,0,0,1,88,95.91c0-38.58,31.08-70.64,69.64-71.87A72,72,0,0,1,232,98.36Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216.57,39.43A80,80,0,0,0,83.91,120.78L28.69,176A15.86,15.86,0,0,0,24,187.31V216a16,16,0,0,0,16,16H72a8,8,0,0,0,8-8V208H96a8,8,0,0,0,8-8V184h16a8,8,0,0,0,5.66-2.34l9.56-9.57A79.73,79.73,0,0,0,160,176h.1A80,80,0,0,0,216.57,39.43ZM224,98.1c-1.09,34.09-29.75,61.86-63.89,61.9H160a63.7,63.7,0,0,1-23.65-4.51,8,8,0,0,0-8.84,1.68L116.69,168H96a8,8,0,0,0-8,8v16H72a8,8,0,0,0-8,8v16H40V187.31l58.83-58.82a8,8,0,0,0,1.68-8.84A63.72,63.72,0,0,1,96,95.92c0-34.14,27.81-62.8,61.9-63.89A64,64,0,0,1,224,98.1ZM192,76a12,12,0,1,1-12-12A12,12,0,0,1,192,76Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216.57,39.43A80,80,0,0,0,83.91,120.78L28.69,176A15.86,15.86,0,0,0,24,187.31V216a16,16,0,0,0,16,16H72a8,8,0,0,0,8-8V208H96a8,8,0,0,0,8-8V184h16a8,8,0,0,0,5.66-2.34l9.56-9.57A79.73,79.73,0,0,0,160,176h.1A80,80,0,0,0,216.57,39.43ZM180,92a16,16,0,1,1,16-16A16,16,0,0,1,180,92Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M215.15,40.85A78,78,0,0,0,86.2,121.31l-56.1,56.1a13.94,13.94,0,0,0-4.1,9.9V216a14,14,0,0,0,14,14H72a6,6,0,0,0,6-6V206H96a6,6,0,0,0,6-6V182h18a6,6,0,0,0,4.24-1.76l10.45-10.44A77.59,77.59,0,0,0,160,174h.1A78,78,0,0,0,215.15,40.85ZM226,98.16c-1.12,35.16-30.67,63.8-65.88,63.84a65.93,65.93,0,0,1-24.51-4.67,6,6,0,0,0-6.64,1.26L117.51,170H96a6,6,0,0,0-6,6v18H72a6,6,0,0,0-6,6v18H40a2,2,0,0,1-2-2V187.31a2,2,0,0,1,.58-1.41l58.83-58.83a6,6,0,0,0,1.26-6.64A65.61,65.61,0,0,1,94,95.92C94,60.71,122.68,31.16,157.83,30A66,66,0,0,1,226,98.16ZM190,76a10,10,0,1,1-10-10A10,10,0,0,1,190,76Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216.57,39.43A80,80,0,0,0,83.91,120.78L28.69,176A15.86,15.86,0,0,0,24,187.31V216a16,16,0,0,0,16,16H72a8,8,0,0,0,8-8V208H96a8,8,0,0,0,8-8V184h16a8,8,0,0,0,5.66-2.34l9.56-9.57A79.73,79.73,0,0,0,160,176h.1A80,80,0,0,0,216.57,39.43ZM224,98.1c-1.09,34.09-29.75,61.86-63.89,61.9H160a63.7,63.7,0,0,1-23.65-4.51,8,8,0,0,0-8.84,1.68L116.69,168H96a8,8,0,0,0-8,8v16H72a8,8,0,0,0-8,8v16H40V187.31l58.83-58.82a8,8,0,0,0,1.68-8.84A63.72,63.72,0,0,1,96,95.92c0-34.14,27.81-62.8,61.9-63.89A64,64,0,0,1,224,98.1ZM192,76a12,12,0,1,1-12-12A12,12,0,0,1,192,76Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.74,42.26A76,76,0,0,0,88.51,121.84l-57,57A11.93,11.93,0,0,0,28,187.31V216a12,12,0,0,0,12,12H72a4,4,0,0,0,4-4V204H96a4,4,0,0,0,4-4V180h20a4,4,0,0,0,2.83-1.17l11.33-11.34A75.72,75.72,0,0,0,160,172h.1A76,76,0,0,0,213.74,42.26Zm14.22,56c-1.15,36.22-31.6,65.72-67.87,65.77H160a67.52,67.52,0,0,1-25.21-4.83,4,4,0,0,0-4.45.83l-12,12H96a4,4,0,0,0-4,4v20H72a4,4,0,0,0-4,4v20H40a4,4,0,0,1-4-4V187.31a4.06,4.06,0,0,1,1.17-2.83L96,125.66a4,4,0,0,0,.83-4.45A67.51,67.51,0,0,1,92,95.91C92,59.64,121.55,29.19,157.77,28A68,68,0,0,1,228,98.23ZM188,76a8,8,0,1,1-8-8A8,8,0,0,1,188,76Z"
        }))
    ]
]);


const $9991baf035cb3560$export$3dc0fe769dc7dcac = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...r,
        weights: (0, $b91bd6ee26a2f073$export$2e2bcd8739ae039)
    }));
$9991baf035cb3560$export$3dc0fe769dc7dcac.displayName = "KeyIcon";
const $9991baf035cb3560$export$cd0f44441c3b7719 = $9991baf035cb3560$export$3dc0fe769dc7dcac;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $b2857ed63604d24d$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,156h-4V72a28,28,0,0,0-28-28H56A28,28,0,0,0,28,72v84H24a12,12,0,0,0-12,12v24a28,28,0,0,0,28,28H216a28,28,0,0,0,28-28V168A12,12,0,0,0,232,156ZM52,72a4,4,0,0,1,4-4H200a4,4,0,0,1,4,4v84H52ZM220,192a4,4,0,0,1-4,4H40a4,4,0,0,1-4-4V180H220ZM156,96a12,12,0,0,1-12,12H112a12,12,0,0,1,0-24h32A12,12,0,0,1,156,96Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,72V176H40V72A16,16,0,0,1,56,56H200A16,16,0,0,1,216,72Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,168h-8V72a24,24,0,0,0-24-24H56A24,24,0,0,0,32,72v96H24a8,8,0,0,0-8,8v16a24,24,0,0,0,24,24H216a24,24,0,0,0,24-24V176A8,8,0,0,0,232,168ZM48,72a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8v96H48ZM224,192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8v-8H224ZM152,88a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16h32A8,8,0,0,1,152,88Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,168h-8V72a24,24,0,0,0-24-24H56A24,24,0,0,0,32,72v96H24a8,8,0,0,0-8,8v16a24,24,0,0,0,24,24H216a24,24,0,0,0,24-24V176A8,8,0,0,0,232,168ZM112,72h32a8,8,0,0,1,0,16H112a8,8,0,0,1,0-16ZM224,192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8v-8H224Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,170H222V72a22,22,0,0,0-22-22H56A22,22,0,0,0,34,72v98H24a6,6,0,0,0-6,6v16a22,22,0,0,0,22,22H216a22,22,0,0,0,22-22V176A6,6,0,0,0,232,170ZM46,72A10,10,0,0,1,56,62H200a10,10,0,0,1,10,10v98H46ZM226,192a10,10,0,0,1-10,10H40a10,10,0,0,1-10-10V182H226ZM150,88a6,6,0,0,1-6,6H112a6,6,0,0,1,0-12h32A6,6,0,0,1,150,88Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,168h-8V72a24,24,0,0,0-24-24H56A24,24,0,0,0,32,72v96H24a8,8,0,0,0-8,8v16a24,24,0,0,0,24,24H216a24,24,0,0,0,24-24V176A8,8,0,0,0,232,168ZM48,72a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8v96H48ZM224,192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8v-8H224ZM152,88a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16h32A8,8,0,0,1,152,88Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,172H220V72a20,20,0,0,0-20-20H56A20,20,0,0,0,36,72V172H24a4,4,0,0,0-4,4v16a20,20,0,0,0,20,20H216a20,20,0,0,0,20-20V176A4,4,0,0,0,232,172ZM44,72A12,12,0,0,1,56,60H200a12,12,0,0,1,12,12V172H44ZM228,192a12,12,0,0,1-12,12H40a12,12,0,0,1-12-12V180H228ZM148,88a4,4,0,0,1-4,4H112a4,4,0,0,1,0-8h32A4,4,0,0,1,148,88Z"
        }))
    ]
]);


const $5a4a10635b84b894$export$b94473071ddf9fbf = $7fPBF.forwardRef((a, p)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: p,
        ...a,
        weights: (0, $b2857ed63604d24d$export$2e2bcd8739ae039)
    }));
$5a4a10635b84b894$export$b94473071ddf9fbf.displayName = "LaptopIcon";
const $5a4a10635b84b894$export$650c7f4d72afd4aa = $5a4a10635b84b894$export$b94473071ddf9fbf;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $0edb934884d7da7c$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M180,232a12,12,0,0,1-12,12H88a12,12,0,0,1,0-24h80A12,12,0,0,1,180,232Zm40-128a92.47,92.47,0,0,1-37,73.73,7.81,7.81,0,0,0-3,6.27,20,20,0,0,1-20,20H96a20,20,0,0,1-20-20v-.23a7.76,7.76,0,0,0-3.25-6.2,91.36,91.36,0,0,1-36.75-73C35.73,54.69,76,13.2,125.79,12A92,92,0,0,1,220,104Zm-24,0a68,68,0,0,0-69.65-68C89.56,36.89,59.8,67.56,60,104.39a67.52,67.52,0,0,0,27.18,54h0A32.14,32.14,0,0,1,99.77,180H116V149L87.51,120.49a12,12,0,0,1,17-17L128,127l23.51-23.51a12,12,0,0,1,17,17L140,149v31h16.25a31.89,31.89,0,0,1,12.41-21.49A67.45,67.45,0,0,0,196,104Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,104a79.86,79.86,0,0,1-30.59,62.92A24.29,24.29,0,0,0,168,186v6a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-6a24.11,24.11,0,0,0-9.3-19A79.87,79.87,0,0,1,48,104.45C47.76,61.09,82.72,25,126.07,24A80,80,0,0,1,208,104Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,232a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,232Zm40-128a87.55,87.55,0,0,1-33.64,69.21A16.24,16.24,0,0,0,176,186v6a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16v-6a16,16,0,0,0-6.23-12.66A87.59,87.59,0,0,1,40,104.5C39.74,56.83,78.26,17.15,125.88,16A88,88,0,0,1,216,104Zm-16,0a72,72,0,0,0-73.74-72c-39,.92-70.47,33.39-70.26,72.39a71.64,71.64,0,0,0,27.64,56.3h0A32,32,0,0,1,96,186v6h24V147.31L90.34,117.66a8,8,0,0,1,11.32-11.32L128,132.69l26.34-26.35a8,8,0,0,1,11.32,11.32L136,147.31V192h24v-6a32.12,32.12,0,0,1,12.47-25.35A71.65,71.65,0,0,0,200,104Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,232a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,232Zm40-128a87.55,87.55,0,0,1-33.64,69.21A16.24,16.24,0,0,0,176,186v6a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16v-6a16,16,0,0,0-6.23-12.66A87.59,87.59,0,0,1,40,104.49C39.74,56.83,78.26,17.14,125.88,16A88,88,0,0,1,216,104Zm-50.34,2.34a8,8,0,0,0-11.32,0L128,132.69l-26.34-26.35a8,8,0,0,0-11.32,11.32L120,147.31V184a8,8,0,0,0,16,0V147.31l29.66-29.65A8,8,0,0,0,165.66,106.34Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M174,232a6,6,0,0,1-6,6H88a6,6,0,0,1,0-12h80A6,6,0,0,1,174,232Zm40-128a85.56,85.56,0,0,1-32.88,67.64A18.23,18.23,0,0,0,174,186v6a14,14,0,0,1-14,14H96a14,14,0,0,1-14-14v-6a18,18,0,0,0-7-14.23h0a85.59,85.59,0,0,1-33-67.25C41.74,57.91,79.39,19.12,125.93,18A86,86,0,0,1,214,104Zm-12,0a74,74,0,0,0-75.79-74C86.17,31,53.78,64.34,54,104.42a73.67,73.67,0,0,0,28.4,57.87A29.92,29.92,0,0,1,94,186v6a2,2,0,0,0,2,2h26V146.49L91.76,116.24a6,6,0,0,1,8.48-8.48L128,135.52l27.76-27.76a6,6,0,0,1,8.48,8.48L134,146.49V194h26a2,2,0,0,0,2-2v-6a30.18,30.18,0,0,1,11.7-23.78A73.59,73.59,0,0,0,202,104Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,232a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,232Zm40-128a87.55,87.55,0,0,1-33.64,69.21A16.24,16.24,0,0,0,176,186v6a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16v-6a16,16,0,0,0-6.23-12.66A87.59,87.59,0,0,1,40,104.5C39.74,56.83,78.26,17.15,125.88,16A88,88,0,0,1,216,104Zm-16,0a72,72,0,0,0-73.74-72c-39,.92-70.47,33.39-70.26,72.39a71.64,71.64,0,0,0,27.64,56.3h0A32,32,0,0,1,96,186v6h24V147.31L90.34,117.66a8,8,0,0,1,11.32-11.32L128,132.69l26.34-26.35a8,8,0,0,1,11.32,11.32L136,147.31V192h24v-6a32.12,32.12,0,0,1,12.47-25.35A71.65,71.65,0,0,0,200,104Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M172,232a4,4,0,0,1-4,4H88a4,4,0,0,1,0-8h80A4,4,0,0,1,172,232Zm40-128a83.59,83.59,0,0,1-32.11,66.06A20.2,20.2,0,0,0,172,186v6a12,12,0,0,1-12,12H96a12,12,0,0,1-12-12v-6a20,20,0,0,0-7.76-15.81A83.58,83.58,0,0,1,44,104.47C43.75,59,80.52,21.09,126,20a84,84,0,0,1,86,84Zm-8,0a76,76,0,0,0-77.84-76C85,29,51.77,63.27,52,104.43a75.62,75.62,0,0,0,29.17,59.43A28,28,0,0,1,92,186v6a4,4,0,0,0,4,4h28V145.66L93.17,114.83a4,4,0,0,1,5.66-5.66L128,138.34l29.17-29.17a4,4,0,1,1,5.66,5.66L132,145.66V196h28a4,4,0,0,0,4-4v-6a28.14,28.14,0,0,1,10.94-22.2A75.62,75.62,0,0,0,204,104Z"
        }))
    ]
]);


const $885e936d56aff1b9$export$f678a184393c5940 = $7fPBF.forwardRef((o, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: a,
        ...o,
        weights: (0, $0edb934884d7da7c$export$2e2bcd8739ae039)
    }));
$885e936d56aff1b9$export$f678a184393c5940.displayName = "LightbulbFilamentIcon";
const $885e936d56aff1b9$export$799e16ecf3c4889e = $885e936d56aff1b9$export$f678a184393c5940;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $93b42e4cb2afcb64$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M219.71,117.38a12,12,0,0,0-7.25-8.52L161.28,88.39l10.59-70.61a12,12,0,0,0-20.64-10l-112,120a12,12,0,0,0,4.31,19.33l51.18,20.47L84.13,238.22a12,12,0,0,0,20.64,10l112-120A12,12,0,0,0,219.71,117.38ZM113.6,203.55l6.27-41.77a12,12,0,0,0-7.41-12.92L68.74,131.37,142.4,52.45l-6.27,41.77a12,12,0,0,0,7.41,12.92l43.72,17.49Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M96,240l16-80L48,136,160,16,144,96l64,24Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M215.79,118.17a8,8,0,0,0-5-5.66L153.18,90.9l14.66-73.33a8,8,0,0,0-13.69-7l-112,120a8,8,0,0,0,3,13l57.63,21.61L88.16,238.43a8,8,0,0,0,13.69,7l112-120A8,8,0,0,0,215.79,118.17ZM109.37,214l10.47-52.38a8,8,0,0,0-5-9.06L62,132.71l84.62-90.66L136.16,94.43a8,8,0,0,0,5,9.06l52.8,19.8Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.85,125.46l-112,120a8,8,0,0,1-13.69-7l14.66-73.33L45.19,143.49a8,8,0,0,1-3-13l112-120a8,8,0,0,1,13.69,7L153.18,90.9l57.63,21.61a8,8,0,0,1,3,12.95Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.84,118.63a6,6,0,0,0-3.73-4.25L150.88,92.17l15-75a6,6,0,0,0-10.27-5.27l-112,120a6,6,0,0,0,2.28,9.71l59.23,22.21-15,75a6,6,0,0,0,3.14,6.52A6.07,6.07,0,0,0,96,246a6,6,0,0,0,4.39-1.91l112-120A6,6,0,0,0,213.84,118.63ZM106,220.46l11.85-59.28a6,6,0,0,0-3.77-6.8l-55.6-20.85,91.46-98L138.12,94.82a6,6,0,0,0,3.77,6.8l55.6,20.85Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M215.79,118.17a8,8,0,0,0-5-5.66L153.18,90.9l14.66-73.33a8,8,0,0,0-13.69-7l-112,120a8,8,0,0,0,3,13l57.63,21.61L88.16,238.43a8,8,0,0,0,13.69,7l112-120A8,8,0,0,0,215.79,118.17ZM109.37,214l10.47-52.38a8,8,0,0,0-5-9.06L62,132.71l84.62-90.66L136.16,94.43a8,8,0,0,0,5,9.06l52.8,19.8Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M211.89,119.09a4,4,0,0,0-2.49-2.84l-60.81-22.8,15.33-76.67a4,4,0,0,0-6.84-3.51l-112,120a4,4,0,0,0-1,3.64,4,4,0,0,0,2.49,2.84l60.81,22.8L92.08,239.22a4,4,0,0,0,6.84,3.51l112-120A4,4,0,0,0,211.89,119.09ZM102.68,227l13.24-66.2a4,4,0,0,0-2.52-4.53L55,134.36,153.32,29l-13.24,66.2a4,4,0,0,0,2.52,4.53L201,121.64Z"
        }))
    ]
]);


const $66907d3d09578e84$export$b9beba9ac1b19787 = $7fPBF.forwardRef((n, i)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: i,
        ...n,
        weights: (0, $93b42e4cb2afcb64$export$2e2bcd8739ae039)
    }));
$66907d3d09578e84$export$b9beba9ac1b19787.displayName = "LightningIcon";
const $66907d3d09578e84$export$71809dd4a5478fb0 = $66907d3d09578e84$export$b9beba9ac1b19787;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $461317875df4d2f6$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M195.8,60.2a28,28,0,0,0-39.51-.09L144.68,72.28a12,12,0,1,1-17.36-16.56L139,43.43l.2-.2a52,52,0,0,1,73.54,73.54l-.2.2-12.29,11.71a12,12,0,0,1-16.56-17.36l12.17-11.61A28,28,0,0,0,195.8,60.2ZM111.32,183.72,99.71,195.89a28,28,0,0,1-39.6-39.6l12.17-11.61a12,12,0,0,0-16.56-17.36L43.43,139l-.2.2a52,52,0,0,0,73.54,73.54l.2-.2,11.71-12.29a12,12,0,1,0-17.36-16.56ZM216,148H192a12,12,0,0,0,0,24h24a12,12,0,0,0,0-24ZM40,108H64a12,12,0,0,0,0-24H40a12,12,0,0,0,0,24Zm120,72a12,12,0,0,0-12,12v24a12,12,0,0,0,24,0V192A12,12,0,0,0,160,180ZM96,76a12,12,0,0,0,12-12V40a12,12,0,0,0-24,0V64A12,12,0,0,0,96,76Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M204.28,108.28l-96,96a40,40,0,0,1-56.56-56.56l96-96a40,40,0,0,1,56.56,56.56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M198.63,57.37a32,32,0,0,0-45.19-.06L141.79,69.52a8,8,0,0,1-11.58-11l11.72-12.29a1.59,1.59,0,0,1,.13-.13,48,48,0,0,1,67.88,67.88,1.59,1.59,0,0,1-.13.13l-12.29,11.72a8,8,0,0,1-11-11.58l12.21-11.65A32,32,0,0,0,198.63,57.37ZM114.21,186.48l-11.65,12.21a32,32,0,0,1-45.25-45.25l12.21-11.65a8,8,0,0,0-11-11.58L46.19,141.93a1.59,1.59,0,0,0-.13.13,48,48,0,0,0,67.88,67.88,1.59,1.59,0,0,0,.13-.13l11.72-12.29a8,8,0,1,0-11.58-11ZM216,152H192a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16ZM40,104H64a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm120,80a8,8,0,0,0-8,8v24a8,8,0,0,0,16,0V192A8,8,0,0,0,160,184ZM96,72a8,8,0,0,0,8-8V40a8,8,0,0,0-16,0V64A8,8,0,0,0,96,72Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM96,64a8,8,0,0,1,16,0V80a8,8,0,0,1-16,0ZM64,96H80a8,8,0,0,1,0,16H64a8,8,0,0,1,0-16Zm64.08,85.66-7.21,7.21a38,38,0,1,1-53.74-53.74l7.21-7.21a8,8,0,1,1,11.32,11.31l-7.22,7.21a22,22,0,0,0,31.12,31.12l7.21-7.22a8,8,0,1,1,11.31,11.32ZM160,192a8,8,0,0,1-16,0V176a8,8,0,0,1,16,0Zm32-32H176a8,8,0,0,1,0-16h16a8,8,0,0,1,0,16Zm-3.13-39.13-7.21,7.21a8,8,0,1,1-11.32-11.31l7.22-7.21a22,22,0,0,0-31.12-31.12l-7.21,7.22a8,8,0,1,1-11.31-11.32l7.21-7.21a38,38,0,1,1,53.74,53.74Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,56a34,34,0,0,0-48-.05L140.34,68.14a6,6,0,1,1-8.68-8.28l11.71-12.28.1-.11a46,46,0,0,1,65.06,65.06l-.11.1-12.28,11.71a6,6,0,1,1-8.28-8.68L200.09,104A34,34,0,0,0,200,56Zm-84.38,131.9L104,200.09A34,34,0,0,1,55.91,152l12.23-11.67a6,6,0,0,0-8.28-8.68L47.58,143.37l-.11.1a46,46,0,0,0,65.06,65.06l.1-.11,11.71-12.28a6,6,0,1,0-8.68-8.28ZM216,154H192a6,6,0,0,0,0,12h24a6,6,0,0,0,0-12ZM40,102H64a6,6,0,0,0,0-12H40a6,6,0,0,0,0,12Zm120,84a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V192A6,6,0,0,0,160,186ZM96,70a6,6,0,0,0,6-6V40a6,6,0,0,0-12,0V64A6,6,0,0,0,96,70Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M198.63,57.37a32,32,0,0,0-45.19-.06L141.79,69.52a8,8,0,0,1-11.58-11l11.72-12.29a1.59,1.59,0,0,1,.13-.13,48,48,0,0,1,67.88,67.88,1.59,1.59,0,0,1-.13.13l-12.29,11.72a8,8,0,0,1-11-11.58l12.21-11.65A32,32,0,0,0,198.63,57.37ZM114.21,186.48l-11.65,12.21a32,32,0,0,1-45.25-45.25l12.21-11.65a8,8,0,0,0-11-11.58L46.19,141.93a1.59,1.59,0,0,0-.13.13,48,48,0,0,0,67.88,67.88,1.59,1.59,0,0,0,.13-.13l11.72-12.29a8,8,0,1,0-11.58-11ZM216,152H192a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16ZM40,104H64a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm120,80a8,8,0,0,0-8,8v24a8,8,0,0,0,16,0V192A8,8,0,0,0,160,184ZM96,72a8,8,0,0,0,8-8V40a8,8,0,0,0-16,0V64A8,8,0,0,0,96,72Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M201.46,54.54a36.06,36.06,0,0,0-50.92,0L138.89,66.76a4,4,0,0,1-5.78-5.52L144.82,49a44,44,0,1,1,62.29,62.15l-12.35,11.78a4,4,0,0,1-5.52-5.78l12.28-11.72A36,36,0,0,0,201.46,54.54Zm-84.35,134.7-11.65,12.22a36,36,0,0,1-51-50.85l12.28-11.72a4,4,0,0,0-5.52-5.78L48.89,144.89A44,44,0,1,0,111.18,207l11.71-12.28a4,4,0,1,0-5.78-5.52ZM216,156H192a4,4,0,0,0,0,8h24a4,4,0,0,0,0-8ZM40,100H64a4,4,0,0,0,0-8H40a4,4,0,0,0,0,8Zm120,88a4,4,0,0,0-4,4v24a4,4,0,0,0,8,0V192A4,4,0,0,0,160,188ZM96,68a4,4,0,0,0,4-4V40a4,4,0,0,0-8,0V64A4,4,0,0,0,96,68Z"
        }))
    ]
]);


const $a7ac72ddd488c3fa$export$3cf6c022d9395be8 = $7fPBF.forwardRef((r, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: a,
        ...r,
        weights: (0, $461317875df4d2f6$export$2e2bcd8739ae039)
    }));
$a7ac72ddd488c3fa$export$3cf6c022d9395be8.displayName = "LinkBreakIcon";
const $a7ac72ddd488c3fa$export$a720e9411394ceb = $a7ac72ddd488c3fa$export$3cf6c022d9395be8;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $bc8e1fdf833b7515$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M76,64A12,12,0,0,1,88,52H216a12,12,0,0,1,0,24H88A12,12,0,0,1,76,64Zm140,52H88a12,12,0,0,0,0,24H216a12,12,0,0,0,0-24Zm0,64H88a12,12,0,0,0,0,24H216a12,12,0,0,0,0-24ZM44,112a16,16,0,1,0,16,16A16,16,0,0,0,44,112Zm0-64A16,16,0,1,0,60,64,16,16,0,0,0,44,48Zm0,128a16,16,0,1,0,16,16A16,16,0,0,0,44,176Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,64V192H88V64Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M80,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H88A8,8,0,0,1,80,64Zm136,56H88a8,8,0,1,0,0,16H216a8,8,0,0,0,0-16Zm0,64H88a8,8,0,1,0,0,16H216a8,8,0,0,0,0-16ZM44,52A12,12,0,1,0,56,64,12,12,0,0,0,44,52Zm0,64a12,12,0,1,0,12,12A12,12,0,0,0,44,116Zm0,64a12,12,0,1,0,12,12A12,12,0,0,0,44,180Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM68,188a12,12,0,1,1,12-12A12,12,0,0,1,68,188Zm0-48a12,12,0,1,1,12-12A12,12,0,0,1,68,140Zm0-48A12,12,0,1,1,80,80,12,12,0,0,1,68,92Zm124,92H104a8,8,0,0,1,0-16h88a8,8,0,0,1,0,16Zm0-48H104a8,8,0,0,1,0-16h88a8,8,0,0,1,0,16Zm0-48H104a8,8,0,0,1,0-16h88a8,8,0,0,1,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M82,64a6,6,0,0,1,6-6H216a6,6,0,0,1,0,12H88A6,6,0,0,1,82,64Zm134,58H88a6,6,0,0,0,0,12H216a6,6,0,0,0,0-12Zm0,64H88a6,6,0,0,0,0,12H216a6,6,0,0,0,0-12ZM44,54A10,10,0,1,0,54,64,10,10,0,0,0,44,54Zm0,128a10,10,0,1,0,10,10A10,10,0,0,0,44,182Zm0-64a10,10,0,1,0,10,10A10,10,0,0,0,44,118Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M80,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H88A8,8,0,0,1,80,64Zm136,56H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,64H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM44,52A12,12,0,1,0,56,64,12,12,0,0,0,44,52Zm0,64a12,12,0,1,0,12,12A12,12,0,0,0,44,116Zm0,64a12,12,0,1,0,12,12A12,12,0,0,0,44,180Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M84,64a4,4,0,0,1,4-4H216a4,4,0,0,1,0,8H88A4,4,0,0,1,84,64Zm132,60H88a4,4,0,0,0,0,8H216a4,4,0,0,0,0-8Zm0,64H88a4,4,0,0,0,0,8H216a4,4,0,0,0,0-8ZM44,120a8,8,0,1,0,8,8A8,8,0,0,0,44,120Zm0-64a8,8,0,1,0,8,8A8,8,0,0,0,44,56Zm0,128a8,8,0,1,0,8,8A8,8,0,0,0,44,184Z"
        }))
    ]
]);


const $e1f565be31fe1992$export$70784bf0c528892c = $7fPBF.forwardRef((o, s)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: s,
        ...o,
        weights: (0, $bc8e1fdf833b7515$export$2e2bcd8739ae039)
    }));
$e1f565be31fe1992$export$70784bf0c528892c.displayName = "ListBulletsIcon";
const $e1f565be31fe1992$export$ab6272c0151aba3a = $e1f565be31fe1992$export$70784bf0c528892c;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $1ca88c68007b06ee$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232.49,215.51,185,168a92.12,92.12,0,1,0-17,17l47.53,47.54a12,12,0,0,0,17-17ZM44,112a68,68,0,1,1,68,68A68.07,68.07,0,0,1,44,112Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M192,112a80,80,0,1,1-80-80A80,80,0,0,1,192,112Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M229.66,218.34,179.6,168.28a88.21,88.21,0,1,0-11.32,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,112a56,56,0,1,1-56-56A56,56,0,0,1,168,112Zm61.66,117.66a8,8,0,0,1-11.32,0l-50.06-50.07a88,88,0,1,1,11.32-11.31l50.06,50.06A8,8,0,0,1,229.66,229.66ZM112,184a72,72,0,1,0-72-72A72.08,72.08,0,0,0,112,184Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228.24,219.76l-51.38-51.38a86.15,86.15,0,1,0-8.48,8.48l51.38,51.38a6,6,0,0,0,8.48-8.48ZM38,112a74,74,0,1,1,74,74A74.09,74.09,0,0,1,38,112Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M226.83,221.17l-52.7-52.7a84.1,84.1,0,1,0-5.66,5.66l52.7,52.7a4,4,0,0,0,5.66-5.66ZM36,112a76,76,0,1,1,76,76A76.08,76.08,0,0,1,36,112Z"
        }))
    ]
]);


const $5394ccda98b8b514$export$f7658c347b037c3f = $7fPBF.forwardRef((s, n)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: n,
        ...s,
        weights: (0, $1ca88c68007b06ee$export$2e2bcd8739ae039)
    }));
$5394ccda98b8b514$export$f7658c347b037c3f.displayName = "MagnifyingGlassIcon";
const $5394ccda98b8b514$export$bdf537af43a20db5 = $5394ccda98b8b514$export$f7658c347b037c3f;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $5792d4d40bf644fc$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220,96A92,92,0,1,0,68,165.69V240a12,12,0,0,0,17.37,10.73L128,229.42l42.64,21.31A12,12,0,0,0,188,240V165.69A91.86,91.86,0,0,0,220,96ZM60,96a68,68,0,1,1,68,68A68.07,68.07,0,0,1,60,96ZM164,220.59l-30.64-15.32a12,12,0,0,0-10.74,0L92,220.58V180.66a92,92,0,0,0,72,0ZM128,148A52,52,0,1,0,76,96,52.06,52.06,0,0,0,128,148Zm0-80a28,28,0,1,1-28,28A28,28,0,0,1,128,68Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,96a48,48,0,1,1-48-48A48,48,0,0,1,176,96Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,96A88,88,0,1,0,72,163.83V240a8,8,0,0,0,11.58,7.16L128,225l44.43,22.21A8.07,8.07,0,0,0,176,248a8,8,0,0,0,8-8V163.83A87.85,87.85,0,0,0,216,96ZM56,96a72,72,0,1,1,72,72A72.08,72.08,0,0,1,56,96ZM168,227.06l-36.43-18.21a8,8,0,0,0-7.16,0L88,227.06V174.37a87.89,87.89,0,0,0,80,0ZM128,152A56,56,0,1,0,72,96,56.06,56.06,0,0,0,128,152Zm0-96A40,40,0,1,1,88,96,40,40,0,0,1,128,56Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,96A88,88,0,1,0,72,163.83V240a8,8,0,0,0,11.58,7.16L128,225l44.43,22.21A8.07,8.07,0,0,0,176,248a8,8,0,0,0,8-8V163.83A87.85,87.85,0,0,0,216,96ZM56,96a72,72,0,1,1,72,72A72.08,72.08,0,0,1,56,96Zm16,0a56,56,0,1,1,56,56A56.06,56.06,0,0,1,72,96Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M214,96A86,86,0,1,0,74,162.87V240a6,6,0,0,0,2.85,5.1A5.93,5.93,0,0,0,80,246a6,6,0,0,0,2.68-.63L128,222.71l45.33,22.66A6,6,0,0,0,182,240V162.87A85.87,85.87,0,0,0,214,96ZM54,96a74,74,0,1,1,74,74A74.09,74.09,0,0,1,54,96ZM170,230.29l-39.33-19.66a6,6,0,0,0-5.36,0L86,230.29V171a85.75,85.75,0,0,0,84,0ZM128,150A54,54,0,1,0,74,96,54.06,54.06,0,0,0,128,150Zm0-96A42,42,0,1,1,86,96,42,42,0,0,1,128,54Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,96A88,88,0,1,0,72,163.83V240a8,8,0,0,0,11.58,7.16L128,225l44.43,22.21A8.07,8.07,0,0,0,176,248a8,8,0,0,0,8-8V163.83A87.85,87.85,0,0,0,216,96ZM56,96a72,72,0,1,1,72,72A72.08,72.08,0,0,1,56,96ZM168,227.06l-36.43-18.21a8,8,0,0,0-7.16,0L88,227.06V174.37a87.89,87.89,0,0,0,80,0ZM128,152A56,56,0,1,0,72,96,56.06,56.06,0,0,0,128,152Zm0-96A40,40,0,1,1,88,96,40,40,0,0,1,128,56Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M212,96A84,84,0,1,0,76,161.9V240a4,4,0,0,0,4,4,4.05,4.05,0,0,0,1.79-.42L128,220.47l46.22,23.11A4,4,0,0,0,180,240V161.9A83.89,83.89,0,0,0,212,96ZM172,233.53l-42.22-21.11a4,4,0,0,0-3.58,0L84,233.53v-66a83.8,83.8,0,0,0,88,0ZM128,172a76,76,0,1,1,76-76A76.08,76.08,0,0,1,128,172Zm0-128a52,52,0,1,0,52,52A52.06,52.06,0,0,0,128,44Zm0,96a44,44,0,1,1,44-44A44.05,44.05,0,0,1,128,140Z"
        }))
    ]
]);


const $a04767458aa408f3$export$f8328d6431f0c3df = $7fPBF.forwardRef((a, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...a,
        weights: (0, $5792d4d40bf644fc$export$2e2bcd8739ae039)
    }));
$a04767458aa408f3$export$f8328d6431f0c3df.displayName = "MedalIcon";
const $a04767458aa408f3$export$f75a880bcbff3a85 = $a04767458aa408f3$export$f8328d6431f0c3df;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $7989cf3dc1bdd743$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,180a52.06,52.06,0,0,0,52-52V64A52,52,0,0,0,76,64v64A52.06,52.06,0,0,0,128,180ZM100,64a28,28,0,0,1,56,0v64a28,28,0,0,1-56,0Zm40,155.22V240a12,12,0,0,1-24,0V219.22A92.14,92.14,0,0,1,36,128a12,12,0,0,1,24,0,68,68,0,0,0,136,0,12,12,0,0,1,24,0A92.14,92.14,0,0,1,140,219.22Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,64v64a40,40,0,0,1-40,40h0a40,40,0,0,1-40-40V64a40,40,0,0,1,40-40h0A40,40,0,0,1,168,64Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,176a48.05,48.05,0,0,0,48-48V64a48,48,0,0,0-96,0v64A48.05,48.05,0,0,0,128,176ZM96,64a32,32,0,0,1,64,0v64a32,32,0,0,1-64,0Zm40,143.6V240a8,8,0,0,1-16,0V207.6A80.11,80.11,0,0,1,48,128a8,8,0,0,1,16,0,64,64,0,0,0,128,0,8,8,0,0,1,16,0A80.11,80.11,0,0,1,136,207.6Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M80,128V64a48,48,0,0,1,96,0v64a48,48,0,0,1-96,0Zm128,0a8,8,0,0,0-16,0,64,64,0,0,1-128,0,8,8,0,0,0-16,0,80.11,80.11,0,0,0,72,79.6V240a8,8,0,0,0,16,0V207.6A80.11,80.11,0,0,0,208,128Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,174a46.06,46.06,0,0,0,46-46V64a46,46,0,0,0-92,0v64A46.06,46.06,0,0,0,128,174ZM94,64a34,34,0,0,1,68,0v64a34,34,0,0,1-68,0Zm40,141.75V240a6,6,0,0,1-12,0V205.75A78.09,78.09,0,0,1,50,128a6,6,0,0,1,12,0,66,66,0,0,0,132,0,6,6,0,0,1,12,0A78.09,78.09,0,0,1,134,205.75Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,176a48.05,48.05,0,0,0,48-48V64a48,48,0,0,0-96,0v64A48.05,48.05,0,0,0,128,176ZM96,64a32,32,0,0,1,64,0v64a32,32,0,0,1-64,0Zm40,143.6V240a8,8,0,0,1-16,0V207.6A80.11,80.11,0,0,1,48,128a8,8,0,0,1,16,0,64,64,0,0,0,128,0,8,8,0,0,1,16,0A80.11,80.11,0,0,1,136,207.6Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,172a44.05,44.05,0,0,0,44-44V64a44,44,0,0,0-88,0v64A44.05,44.05,0,0,0,128,172ZM92,64a36,36,0,0,1,72,0v64a36,36,0,0,1-72,0Zm40,139.89V240a4,4,0,0,1-8,0V203.89A76.09,76.09,0,0,1,52,128a4,4,0,0,1,8,0,68,68,0,0,0,136,0,4,4,0,0,1,8,0A76.09,76.09,0,0,1,132,203.89Z"
        }))
    ]
]);


const $09b782f8de8a3c61$export$d2834cd4e399cf8b = $7fPBF.forwardRef((r, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: c,
        ...r,
        weights: (0, $7989cf3dc1bdd743$export$2e2bcd8739ae039)
    }));
$09b782f8de8a3c61$export$d2834cd4e399cf8b.displayName = "MicrophoneIcon";
const $09b782f8de8a3c61$export$df91f3efeb156795 = $09b782f8de8a3c61$export$d2834cd4e399cf8b;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $0cf5baa2ddd482e9$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M56.88,39.93A12,12,0,1,0,39.12,56.07L76,96.64V128a52,52,0,0,0,72.11,48l11.26,12.39A67.34,67.34,0,0,1,128,196a68.07,68.07,0,0,1-68-68,12,12,0,0,0-24,0,92.14,92.14,0,0,0,80,91.22V240a12,12,0,0,0,24,0V219.23a90.39,90.39,0,0,0,35.92-12.68l23.2,25.52a12,12,0,0,0,17.76-16.14ZM128,156a28,28,0,0,1-28-28v-5l29.9,32.89C129.27,156,128.64,156,128,156Zm63-2.42A67.63,67.63,0,0,0,196,128a12,12,0,0,1,24,0,91.48,91.48,0,0,1-6.74,34.61,12,12,0,0,1-22.23-9ZM85.7,33.75A52,52,0,0,1,180,64v56.54a12,12,0,0,1-24,0V64a28,28,0,0,0-50.79-16.28,12,12,0,0,1-19.51-14Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,64v64a40,40,0,0,1-40,40h0a40,40,0,0,1-40-40V64a40,40,0,0,1,40-40h0A40,40,0,0,1,168,64Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.92,218.62l-160-176A8,8,0,0,0,42.08,53.38L80,95.09V128a48,48,0,0,0,69.11,43.12l11.1,12.2A63.41,63.41,0,0,1,128,192a64.07,64.07,0,0,1-64-64,8,8,0,0,0-16,0,80.11,80.11,0,0,0,72,79.6V240a8,8,0,0,0,16,0V207.59a78.83,78.83,0,0,0,35.16-12.22l30.92,34a8,8,0,1,0,11.84-10.76ZM128,160a32,32,0,0,1-32-32V112.69l41.66,45.82A32,32,0,0,1,128,160Zm57.52-3.91A63.32,63.32,0,0,0,192,128a8,8,0,0,1,16,0,79.16,79.16,0,0,1-8.11,35.12,8,8,0,0,1-7.19,4.49,7.88,7.88,0,0,1-3.51-.82A8,8,0,0,1,185.52,156.09ZM84,44.87A48,48,0,0,1,176,64v64a49.19,49.19,0,0,1-.26,5,8,8,0,0,1-8,7.17,8.13,8.13,0,0,1-.84,0,8,8,0,0,1-7.12-8.79c.11-1.1.17-2.24.17-3.36V64A32,32,0,0,0,98.64,51.25,8,8,0,1,1,84,44.87Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.38,229.92a8,8,0,0,1-11.3-.54l-30.92-34A78.83,78.83,0,0,1,136,207.59V240a8,8,0,0,1-16,0V207.6A80.11,80.11,0,0,1,48,128a8,8,0,0,1,16,0,64.07,64.07,0,0,0,64,64,63.41,63.41,0,0,0,32.21-8.68l-11.1-12.2A48,48,0,0,1,80,128V95.09L42.08,53.38A8,8,0,0,1,53.92,42.62l160,176A8,8,0,0,1,213.38,229.92Zm-24.19-63.13a7.88,7.88,0,0,0,3.51.82,8,8,0,0,0,7.19-4.49A79.16,79.16,0,0,0,208,128a8,8,0,0,0-16,0,63.32,63.32,0,0,1-6.48,28.09A8,8,0,0,0,189.19,166.79Zm-27.33-29.22A8,8,0,0,0,175.74,133a49.49,49.49,0,0,0,.26-5V64A48,48,0,0,0,84,44.87a8,8,0,0,0,1.41,8.57Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M212.44,220,52.44,44A6,6,0,0,0,43.56,52L82,94.32V128a46,46,0,0,0,67.56,40.64l13.75,15.12A65.26,65.26,0,0,1,128,194a66.08,66.08,0,0,1-66-66,6,6,0,0,0-12,0,78.09,78.09,0,0,0,72,77.75V240a6,6,0,0,0,12,0V205.77a76.93,76.93,0,0,0,37.48-13L203.56,228a6,6,0,0,0,8.88-8.08ZM128,162a34,34,0,0,1-34-34V107.52l47.12,51.84A33.82,33.82,0,0,1,128,162Zm59.32-5A65.38,65.38,0,0,0,194,128a6,6,0,0,1,12,0,77.33,77.33,0,0,1-7.9,34.25A6,6,0,1,1,187.32,157ZM85.8,45.67A46,46,0,0,1,174,64v64a45.17,45.17,0,0,1-.25,4.81,6,6,0,0,1-6,5.38q-.31,0-.63,0a6,6,0,0,1-5.34-6.59A35.41,35.41,0,0,0,162,128V64A34,34,0,0,0,96.8,50.45a6,6,0,0,1-11-4.78Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.92,218.62l-160-176A8,8,0,0,0,42.08,53.38L80,95.09V128a48,48,0,0,0,69.11,43.12l11.1,12.2A63.41,63.41,0,0,1,128,192a64.07,64.07,0,0,1-64-64,8,8,0,0,0-16,0,80.11,80.11,0,0,0,72,79.6V240a8,8,0,0,0,16,0V207.59a78.83,78.83,0,0,0,35.16-12.22l30.92,34a8,8,0,1,0,11.84-10.76ZM128,160a32,32,0,0,1-32-32V112.69l41.66,45.82A32,32,0,0,1,128,160Zm57.52-3.91A63.32,63.32,0,0,0,192,128a8,8,0,0,1,16,0,79.16,79.16,0,0,1-8.11,35.12,8,8,0,0,1-7.19,4.49,7.88,7.88,0,0,1-3.51-.82A8,8,0,0,1,185.52,156.09ZM84,44.87A48,48,0,0,1,176,64v64a49.19,49.19,0,0,1-.26,5,8,8,0,0,1-8,7.17,8.13,8.13,0,0,1-.84,0,8,8,0,0,1-7.12-8.79c.11-1.1.17-2.24.17-3.36V64A32,32,0,0,0,98.64,51.25,8,8,0,1,1,84,44.87Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M211,221.31,51,45.31A4,4,0,0,0,45,50.69L84,93.55V128a44,44,0,0,0,66,38.12l16.38,18A67.21,67.21,0,0,1,128,196a68.07,68.07,0,0,1-68-68,4,4,0,0,0-8,0,76.09,76.09,0,0,0,72,75.89V240a4,4,0,0,0,8,0V203.89a75.1,75.1,0,0,0,39.79-13.77L205,226.69a4,4,0,1,0,5.92-5.38ZM128,164a36,36,0,0,1-36-36V102.35L144.43,160A35.83,35.83,0,0,1,128,164Zm61.12-6.15A67.44,67.44,0,0,0,196,128a4,4,0,0,1,8,0,75.28,75.28,0,0,1-7.7,33.37,4,4,0,0,1-7.18-3.52ZM87.63,46.46A44,44,0,0,1,172,64v64a44.2,44.2,0,0,1-.24,4.61,4,4,0,0,1-4,3.58l-.42,0a4,4,0,0,1-3.57-4.39A36.67,36.67,0,0,0,164,128V64A36,36,0,0,0,95,49.66a4,4,0,0,1-7.34-3.2Z"
        }))
    ]
]);


const $2bb6ac751b7724ae$export$8d1357c8e3c4bfd6 = $7fPBF.forwardRef((r, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: a,
        ...r,
        weights: (0, $0cf5baa2ddd482e9$export$2e2bcd8739ae039)
    }));
$2bb6ac751b7724ae$export$8d1357c8e3c4bfd6.displayName = "MicrophoneSlashIcon";
const $2bb6ac751b7724ae$export$ea06b1d4f312e4a2 = $2bb6ac751b7724ae$export$8d1357c8e3c4bfd6;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $458c858cb1919c5a$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240,52H16A12,12,0,0,0,4,64V192a12,12,0,0,0,12,12H240a12,12,0,0,0,12-12V64A12,12,0,0,0,240,52ZM181.21,180H74.79A60.18,60.18,0,0,0,28,133.21V122.79A60.18,60.18,0,0,0,74.79,76H181.21A60.18,60.18,0,0,0,228,122.79v10.42A60.18,60.18,0,0,0,181.21,180ZM228,97.94A36.23,36.23,0,0,1,206.06,76H228ZM49.94,76A36.23,36.23,0,0,1,28,97.94V76ZM28,158.06A36.23,36.23,0,0,1,49.94,180H28ZM206.06,180A36.23,36.23,0,0,1,228,158.06V180ZM128,88a40,40,0,1,0,40,40A40,40,0,0,0,128,88Zm0,56a16,16,0,1,1,16-16A16,16,0,0,1,128,144Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M160,128a32,32,0,1,1-32-32A32,32,0,0,1,160,128Zm40-64a48.85,48.85,0,0,0,40,40V64Zm0,128h40V152A48.85,48.85,0,0,0,200,192ZM16,152v40H56A48.85,48.85,0,0,0,16,152Zm0-48A48.85,48.85,0,0,0,56,64H16Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,88a40,40,0,1,0,40,40A40,40,0,0,0,128,88Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,152ZM240,56H16a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H240a8,8,0,0,0,8-8V64A8,8,0,0,0,240,56ZM24,72H45.37A40.81,40.81,0,0,1,24,93.37Zm0,112V162.63A40.81,40.81,0,0,1,45.37,184Zm208,0H210.63A40.81,40.81,0,0,1,232,162.63Zm0-38.35A56.78,56.78,0,0,0,193.65,184H62.35A56.78,56.78,0,0,0,24,145.65v-35.3A56.78,56.78,0,0,0,62.35,72h131.3A56.78,56.78,0,0,0,232,110.35Zm0-52.28A40.81,40.81,0,0,1,210.63,72H232Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,128a40,40,0,1,1-40-40A40,40,0,0,1,168,128Zm80-64V192a8,8,0,0,1-8,8H16a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H240A8,8,0,0,1,248,64Zm-16,46.35A56.78,56.78,0,0,1,193.65,72H62.35A56.78,56.78,0,0,1,24,110.35v35.3A56.78,56.78,0,0,1,62.35,184h131.3A56.78,56.78,0,0,1,232,145.65Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,166a38,38,0,1,0-38-38A38,38,0,0,0,128,166Zm0-64a26,26,0,1,1-26,26A26,26,0,0,1,128,102ZM240,58H16a6,6,0,0,0-6,6V192a6,6,0,0,0,6,6H240a6,6,0,0,0,6-6V64A6,6,0,0,0,240,58ZM22,108.82A54.73,54.73,0,0,0,60.82,70H195.18A54.73,54.73,0,0,0,234,108.82v38.36A54.73,54.73,0,0,0,195.18,186H60.82A54.73,54.73,0,0,0,22,147.18ZM234,96.29A42.8,42.8,0,0,1,207.71,70H234ZM48.29,70A42.8,42.8,0,0,1,22,96.29V70ZM22,159.71A42.8,42.8,0,0,1,48.29,186H22ZM207.71,186A42.8,42.8,0,0,1,234,159.71V186Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,88a40,40,0,1,0,40,40A40,40,0,0,0,128,88Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,152ZM240,56H16a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H240a8,8,0,0,0,8-8V64A8,8,0,0,0,240,56ZM193.65,184H62.35A56.78,56.78,0,0,0,24,145.65v-35.3A56.78,56.78,0,0,0,62.35,72h131.3A56.78,56.78,0,0,0,232,110.35v35.3A56.78,56.78,0,0,0,193.65,184ZM232,93.37A40.81,40.81,0,0,1,210.63,72H232ZM45.37,72A40.81,40.81,0,0,1,24,93.37V72ZM24,162.63A40.81,40.81,0,0,1,45.37,184H24ZM210.63,184A40.81,40.81,0,0,1,232,162.63V184Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,164a36,36,0,1,0-36-36A36,36,0,0,0,128,164Zm0-64a28,28,0,1,1-28,28A28,28,0,0,1,128,100ZM240,60H16a4,4,0,0,0-4,4V192a4,4,0,0,0,4,4H240a4,4,0,0,0,4-4V64A4,4,0,0,0,240,60ZM20,107.26A52.75,52.75,0,0,0,59.26,68H196.74A52.75,52.75,0,0,0,236,107.26v41.48A52.75,52.75,0,0,0,196.74,188H59.26A52.75,52.75,0,0,0,20,148.74ZM236,99a44.8,44.8,0,0,1-31-31h31ZM51,68A44.8,44.8,0,0,1,20,99V68ZM20,157a44.8,44.8,0,0,1,31,31H20Zm185,31a44.8,44.8,0,0,1,31-31v31Z"
        }))
    ]
]);


const $67a91f296d46ab80$export$fb505dcffad77432 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...r,
        weights: (0, $458c858cb1919c5a$export$2e2bcd8739ae039)
    }));
$67a91f296d46ab80$export$fb505dcffad77432.displayName = "MoneyIcon";
const $67a91f296d46ab80$export$d26bcf891bc220f6 = $67a91f296d46ab80$export$fb505dcffad77432;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $32aea46de550f8dd$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,12H112A68.07,68.07,0,0,0,44,80v96a68.07,68.07,0,0,0,68,68h32a68.07,68.07,0,0,0,68-68V80A68.07,68.07,0,0,0,144,12Zm44,68v20H140V36h4A44.05,44.05,0,0,1,188,80ZM112,36h4v64H68V80A44.05,44.05,0,0,1,112,36Zm32,184H112a44.05,44.05,0,0,1-44-44V124H188v52A44.05,44.05,0,0,1,144,220Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,112v64a56,56,0,0,1-56,56H112a56,56,0,0,1-56-56V112Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm48,64v24H136V32h8A48.05,48.05,0,0,1,192,80ZM112,32h8v72H64V80A48.05,48.05,0,0,1,112,32Zm32,192H112a48.05,48.05,0,0,1-48-48V120H192v56A48.05,48.05,0,0,1,144,224Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm48,64v24H136V32h8A48.05,48.05,0,0,1,192,80ZM112,32h8v72H64V80A48.05,48.05,0,0,1,112,32Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,18H112A62.07,62.07,0,0,0,50,80v96a62.07,62.07,0,0,0,62,62h32a62.07,62.07,0,0,0,62-62V80A62.07,62.07,0,0,0,144,18Zm50,62v26H134V30h10A50.06,50.06,0,0,1,194,80ZM112,30h10v76H62V80A50.06,50.06,0,0,1,112,30Zm32,196H112a50.06,50.06,0,0,1-50-50V118H194v58A50.06,50.06,0,0,1,144,226Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm48,64v24H136V32h8A48.05,48.05,0,0,1,192,80ZM112,32h8v72H64V80A48.05,48.05,0,0,1,112,32Zm32,192H112a48.05,48.05,0,0,1-48-48V120H192v56A48.05,48.05,0,0,1,144,224Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,20H112A60.07,60.07,0,0,0,52,80v96a60.07,60.07,0,0,0,60,60h32a60.07,60.07,0,0,0,60-60V80A60.07,60.07,0,0,0,144,20Zm52,60v28H132V28h12A52.06,52.06,0,0,1,196,80ZM112,28h12v80H60V80A52.06,52.06,0,0,1,112,28Zm32,200H112a52.06,52.06,0,0,1-52-52V116H196v60A52.06,52.06,0,0,1,144,228Z"
        }))
    ]
]);


const $91081726855ec7c6$export$53ac786375585ec0 = $7fPBF.forwardRef((r, s)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: s,
        ...r,
        weights: (0, $32aea46de550f8dd$export$2e2bcd8739ae039)
    }));
$91081726855ec7c6$export$53ac786375585ec0.displayName = "MouseIcon";
const $91081726855ec7c6$export$7caecd373b84cec3 = $91081726855ec7c6$export$53ac786375585ec0;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $67ed3f61d2e76f0b$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,12H112A68.07,68.07,0,0,0,44,80v96a68.07,68.07,0,0,0,68,68h32a68.07,68.07,0,0,0,68-68V80A68.07,68.07,0,0,0,144,12Zm44,68v20H140V36h4A44.05,44.05,0,0,1,188,80ZM68,80a43.63,43.63,0,0,1,2-13L103,100H68Zm48-44V79L83.49,46.52A43.83,43.83,0,0,1,112,36Zm28,184H112a44.05,44.05,0,0,1-44-44V124H188v52A44.05,44.05,0,0,1,144,220Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24v88H56V80a56,56,0,0,1,56-56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm48,64v24H136V32h8A48.05,48.05,0,0,1,192,80Zm-76.69,24-46-46A48.49,48.49,0,0,1,80.51,43.82L120,83.31V104ZM64,80c0-1.51.08-3,.22-4.47L92.69,104H64Zm56-48V60.69L94.59,35.28A47.73,47.73,0,0,1,112,32Zm24,192H112a48.05,48.05,0,0,1-48-48V120H192v56A48.05,48.05,0,0,1,144,224Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm48,64v24H128V32h16A48.05,48.05,0,0,1,192,80ZM144,224H112a48.05,48.05,0,0,1-48-48V120H192v56A48.05,48.05,0,0,1,144,224Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,18H112A62.07,62.07,0,0,0,50,80v96a62.07,62.07,0,0,0,62,62h32a62.07,62.07,0,0,0,62-62V80A62.07,62.07,0,0,0,144,18Zm50,62v26H134V30h10A50.06,50.06,0,0,1,194,80ZM122,30V65.51L91.09,34.6A49.74,49.74,0,0,1,112,30ZM80.62,41.11,122,82.49V106h-7.51L66.9,58.42A50.3,50.3,0,0,1,80.62,41.11ZM62,80a50.17,50.17,0,0,1,.78-8.73L97.51,106H62Zm82,146H112a50.06,50.06,0,0,1-50-50V118H194v58A50.06,50.06,0,0,1,144,226Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm48,64v24H136V32h8A48.05,48.05,0,0,1,192,80Zm-76.69,24-46-46A48.49,48.49,0,0,1,80.51,43.82L120,83.31V104ZM64,80c0-1.51.08-3,.22-4.47L92.69,104H64Zm56-48V60.69L94.59,35.28A47.73,47.73,0,0,1,112,32Zm24,192H112a48.05,48.05,0,0,1-48-48V120H192v56A48.05,48.05,0,0,1,144,224Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,20H112A60.07,60.07,0,0,0,52,80v96a60.07,60.07,0,0,0,60,60h32a60.07,60.07,0,0,0,60-60V80A60.07,60.07,0,0,0,144,20Zm52,60v28H132V28h12A52.06,52.06,0,0,1,196,80ZM124,28V70.34L87.7,34.05A51.61,51.61,0,0,1,112,28ZM80.78,38.44,124,81.66V108H113.66L64.51,58.85A52.5,52.5,0,0,1,80.78,38.44ZM60,80a51.55,51.55,0,0,1,1.59-12.75L102.34,108H60Zm84,148H112a52.06,52.06,0,0,1-52-52V116H196v60A52.06,52.06,0,0,1,144,228Z"
        }))
    ]
]);


const $35ad9356e9e5ec61$export$6b5f666f729352a = $7fPBF.forwardRef((t, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: c,
        ...t,
        weights: (0, $67ed3f61d2e76f0b$export$2e2bcd8739ae039)
    }));
$35ad9356e9e5ec61$export$6b5f666f729352a.displayName = "MouseLeftClickIcon";
const $35ad9356e9e5ec61$export$e0e176aecccaff7a = $35ad9356e9e5ec61$export$6b5f666f729352a;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $515823200a95cddf$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,12H112A68.07,68.07,0,0,0,44,80v96a68.07,68.07,0,0,0,68,68h32a68.07,68.07,0,0,0,68-68V80A68.07,68.07,0,0,0,144,12Zm44,68v20H160V88a20,20,0,0,0-20-20V36h4A44.05,44.05,0,0,1,188,80ZM120,92h16v40H120Zm-8-56h4V68A20,20,0,0,0,96,88v12H68V80A44.05,44.05,0,0,1,112,36Zm32,184H112a44.05,44.05,0,0,1-44-44V124H96v12a20,20,0,0,0,20,20h24a20,20,0,0,0,20-20V124h28v52A44.05,44.05,0,0,1,144,220Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,88v48a8,8,0,0,1-8,8H120a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8h16A8,8,0,0,1,144,88Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm48,64v24H152V88a16,16,0,0,0-16-16V32h8A48.05,48.05,0,0,1,192,80Zm-56,56H120V88h16v23.9a.51.51,0,0,0,0,.2ZM112,32h8V72a16,16,0,0,0-16,16v16H64V80A48.05,48.05,0,0,1,112,32Zm32,192H112a48.05,48.05,0,0,1-48-48V120h40v16a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V120h40v56A48.05,48.05,0,0,1,144,224Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm48,64v24H152V88a16,16,0,0,0-16-16V32h8A48.05,48.05,0,0,1,192,80ZM112,32h8V72a16,16,0,0,0-16,16v16H64V80A48.05,48.05,0,0,1,112,32Zm32,192H112a48.05,48.05,0,0,1-48-48V120h40v16a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V120h40v56A48.05,48.05,0,0,1,144,224Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,18H112A62.07,62.07,0,0,0,50,80v96a62.07,62.07,0,0,0,62,62h32a62.07,62.07,0,0,0,62-62V80A62.07,62.07,0,0,0,144,18Zm50,62v26H150V88a14,14,0,0,0-14-14h-2V30h10A50.06,50.06,0,0,1,194,80Zm-76,8a2,2,0,0,1,2-2h16a2,2,0,0,1,2,2v48a2,2,0,0,1-2,2H120a2,2,0,0,1-2-2Zm-6-58h10V74h-2a14,14,0,0,0-14,14v18H62V80A50.06,50.06,0,0,1,112,30Zm32,196H112a50.06,50.06,0,0,1-50-50V118h44v18a14,14,0,0,0,14,14h16a14,14,0,0,0,14-14V118h44v58A50.06,50.06,0,0,1,144,226Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm48,64v24H152V88a16,16,0,0,0-16-16V32h8A48.05,48.05,0,0,1,192,80Zm-56,56H120V88h16v23.9a.51.51,0,0,0,0,.2ZM112,32h8V72a16,16,0,0,0-16,16v16H64V80A48.05,48.05,0,0,1,112,32Zm32,192H112a48.05,48.05,0,0,1-48-48V120h40v16a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V120h40v56A48.05,48.05,0,0,1,144,224Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,20H112A60.07,60.07,0,0,0,52,80v96a60.07,60.07,0,0,0,60,60h32a60.07,60.07,0,0,0,60-60V80A60.07,60.07,0,0,0,144,20Zm52,60v28H148V88a12,12,0,0,0-12-12h-4V28h12A52.06,52.06,0,0,1,196,80Zm-80,8a4,4,0,0,1,4-4h16a4,4,0,0,1,4,4v48a4,4,0,0,1-4,4H120a4,4,0,0,1-4-4Zm-4-60h12V76h-4a12,12,0,0,0-12,12v20H60V80A52.06,52.06,0,0,1,112,28Zm32,200H112a52.06,52.06,0,0,1-52-52V116h48v20a12,12,0,0,0,12,12h16a12,12,0,0,0,12-12V116h48v60A52.06,52.06,0,0,1,144,228Z"
        }))
    ]
]);


const $d85af3025ef534f2$export$5963dbb4ba2dab8b = $7fPBF.forwardRef((i, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: c,
        ...i,
        weights: (0, $515823200a95cddf$export$2e2bcd8739ae039)
    }));
$d85af3025ef534f2$export$5963dbb4ba2dab8b.displayName = "MouseMiddleClickIcon";
const $d85af3025ef534f2$export$b6d8397e1cc3732d = $d85af3025ef534f2$export$5963dbb4ba2dab8b;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $ebd2a6ece19ff66d$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,12H112A68.07,68.07,0,0,0,44,80v96a68.07,68.07,0,0,0,68,68h32a68.07,68.07,0,0,0,68-68V80A68.07,68.07,0,0,0,144,12Zm42,55a43.63,43.63,0,0,1,2,13v20H153ZM172.51,46.52,140,79V36h4A43.83,43.83,0,0,1,172.51,46.52ZM112,36h4v64H68V80A44.05,44.05,0,0,1,112,36Zm32,184H112a44.05,44.05,0,0,1-44-44V124H188v52A44.05,44.05,0,0,1,144,220Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,80v32H128V24h16A56,56,0,0,1,200,80Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm48,64v24H136V32h8A48.05,48.05,0,0,1,192,80ZM112,32h8v72H64V80A48.05,48.05,0,0,1,112,32Zm32,192H112a48.05,48.05,0,0,1-48-48V120H192v56A48.05,48.05,0,0,1,144,224Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16ZM112,32h16v72H64V80A48.05,48.05,0,0,1,112,32Zm32,192H112a48.05,48.05,0,0,1-48-48V120H192v56A48.05,48.05,0,0,1,144,224Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,18H112A62.07,62.07,0,0,0,50,80v96a62.07,62.07,0,0,0,62,62h32a62.07,62.07,0,0,0,62-62V80A62.07,62.07,0,0,0,144,18Zm50,62v26H158.49l34.73-34.73A50.17,50.17,0,0,1,194,80Zm-4.9-21.58L141.51,106H134V82.49l41.38-41.38A50.3,50.3,0,0,1,189.1,58.42ZM164.91,34.6,134,65.51V30h10A49.74,49.74,0,0,1,164.91,34.6ZM112,30h10v76H62V80A50.06,50.06,0,0,1,112,30Zm32,196H112a50.06,50.06,0,0,1-50-50V118H194v58A50.06,50.06,0,0,1,144,226Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm-8,67.31,39.49-39.49A48.49,48.49,0,0,1,186.66,58l-46,46H136Zm55.78-7.78c.14,1.47.22,3,.22,4.47v24H163.31ZM161.41,35.28,136,60.69V32h8A47.73,47.73,0,0,1,161.41,35.28ZM112,32h8v72H64V80A48.05,48.05,0,0,1,112,32Zm32,192H112a48.05,48.05,0,0,1-48-48V120H192v56A48.05,48.05,0,0,1,144,224Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,20H112A60.07,60.07,0,0,0,52,80v96a60.07,60.07,0,0,0,60,60h32a60.07,60.07,0,0,0,60-60V80A60.07,60.07,0,0,0,144,20Zm52,60v28H153.66l40.75-40.75A51.55,51.55,0,0,1,196,80Zm-4.51-21.15L142.34,108H132V81.66l43.22-43.22A52.5,52.5,0,0,1,191.49,58.85ZM168.3,34.05,132,70.34V28h12A51.61,51.61,0,0,1,168.3,34.05ZM112,28h12v80H60V80A52.06,52.06,0,0,1,112,28Zm32,200H112a52.06,52.06,0,0,1-52-52V116H196v60A52.06,52.06,0,0,1,144,228Z"
        }))
    ]
]);


const $3f8122a9e58d3677$export$50d995ce278ebfd9 = $7fPBF.forwardRef((t, i)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: i,
        ...t,
        weights: (0, $ebd2a6ece19ff66d$export$2e2bcd8739ae039)
    }));
$3f8122a9e58d3677$export$50d995ce278ebfd9.displayName = "MouseRightClickIcon";
const $3f8122a9e58d3677$export$c28954299062c2b4 = $3f8122a9e58d3677$export$50d995ce278ebfd9;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $cded396d2abdab0e$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,12H112A68.07,68.07,0,0,0,44,80v96a68.07,68.07,0,0,0,68,68h32a68.07,68.07,0,0,0,68-68V80A68.07,68.07,0,0,0,144,12Zm44,164a44.05,44.05,0,0,1-44,44H112a44.05,44.05,0,0,1-44-44V80a44.05,44.05,0,0,1,44-44h32a44.05,44.05,0,0,1,44,44ZM140,93V163l3.51-3.52a12,12,0,0,1,17,17l-24,24a12,12,0,0,1-17,0l-24-24a12,12,0,0,1,17-17L116,163V93l-3.51,3.52a12,12,0,0,1-17-17l24-24a12,12,0,0,1,17,0l24,24a12,12,0,0,1-17,17Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,80v96a56,56,0,0,1-56,56H112a56,56,0,0,1-56-56V80a56,56,0,0,1,56-56h32A56,56,0,0,1,200,80Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm48,160a48.05,48.05,0,0,1-48,48H112a48.05,48.05,0,0,1-48-48V80a48.05,48.05,0,0,1,48-48h32a48.05,48.05,0,0,1,48,48ZM136,83.31v89.38l10.34-10.35a8,8,0,0,1,11.32,11.32l-24,24a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L120,172.69V83.31L109.66,93.66A8,8,0,0,1,98.34,82.34l24-24a8,8,0,0,1,11.32,0l24,24a8,8,0,0,1-11.32,11.32Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm2.34,146.34a8,8,0,0,1,11.32,11.32l-24,24a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L120,172.69V83.31L109.66,93.66A8,8,0,0,1,98.34,82.34l24-24a8,8,0,0,1,11.32,0l24,24a8,8,0,0,1-11.32,11.32L136,83.31v89.38Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,18H112A62.07,62.07,0,0,0,50,80v96a62.07,62.07,0,0,0,62,62h32a62.07,62.07,0,0,0,62-62V80A62.07,62.07,0,0,0,144,18Zm50,158a50.06,50.06,0,0,1-50,50H112a50.06,50.06,0,0,1-50-50V80a50.06,50.06,0,0,1,50-50h32a50.06,50.06,0,0,1,50,50ZM134,78.49v99l13.76-13.75a6,6,0,0,1,8.48,8.48l-24,24a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L122,177.51v-99L108.24,92.24a6,6,0,0,1-8.48-8.48l24-24a6,6,0,0,1,8.48,0l24,24a6,6,0,1,1-8.48,8.48Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm48,160a48.05,48.05,0,0,1-48,48H112a48.05,48.05,0,0,1-48-48V80a48.05,48.05,0,0,1,48-48h32a48.05,48.05,0,0,1,48,48ZM136,83.31v89.38l10.34-10.35a8,8,0,0,1,11.32,11.32l-24,24a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L120,172.69V83.31L109.66,93.66A8,8,0,0,1,98.34,82.34l24-24a8,8,0,0,1,11.32,0l24,24a8,8,0,0,1-11.32,11.32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,20H112A60.07,60.07,0,0,0,52,80v96a60.07,60.07,0,0,0,60,60h32a60.07,60.07,0,0,0,60-60V80A60.07,60.07,0,0,0,144,20Zm52,156a52.06,52.06,0,0,1-52,52H112a52.06,52.06,0,0,1-52-52V80a52.06,52.06,0,0,1,52-52h32a52.06,52.06,0,0,1,52,52ZM132,73.66V182.34l17.17-17.17a4,4,0,0,1,5.66,5.66l-24,24a4,4,0,0,1-5.66,0l-24-24a4,4,0,0,1,5.66-5.66L124,182.34V73.66L106.83,90.83a4,4,0,0,1-5.66-5.66l24-24a4,4,0,0,1,5.66,0l24,24a4,4,0,0,1-5.66,5.66Z"
        }))
    ]
]);


const $8fa60ad372f26f07$export$f0907b1c06628174 = $7fPBF.forwardRef((r, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: c,
        ...r,
        weights: (0, $cded396d2abdab0e$export$2e2bcd8739ae039)
    }));
$8fa60ad372f26f07$export$f0907b1c06628174.displayName = "MouseScrollIcon";
const $8fa60ad372f26f07$export$569bc5a16e16ae2a = $8fa60ad372f26f07$export$f0907b1c06628174;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $717c67a0383cc585$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,108H140V92h4a20,20,0,0,0,20-20V40a20,20,0,0,0-20-20H112A20,20,0,0,0,92,40V72a20,20,0,0,0,20,20h4v16H24a12,12,0,0,0,0,24H52v24H48a20,20,0,0,0-20,20v32a20,20,0,0,0,20,20H80a20,20,0,0,0,20-20V176a20,20,0,0,0-20-20H76V132H180v24h-4a20,20,0,0,0-20,20v32a20,20,0,0,0,20,20h32a20,20,0,0,0,20-20V176a20,20,0,0,0-20-20h-4V132h28a12,12,0,0,0,0-24ZM116,44h24V68H116ZM76,204H52V180H76Zm128,0H180V180h24Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M152,40V72a8,8,0,0,1-8,8H112a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h32A8,8,0,0,1,152,40ZM80,168H48a8,8,0,0,0-8,8v32a8,8,0,0,0,8,8H80a8,8,0,0,0,8-8V176A8,8,0,0,0,80,168Zm128,0H176a8,8,0,0,0-8,8v32a8,8,0,0,0,8,8h32a8,8,0,0,0,8-8V176A8,8,0,0,0,208,168Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,112H136V88h8a16,16,0,0,0,16-16V40a16,16,0,0,0-16-16H112A16,16,0,0,0,96,40V72a16,16,0,0,0,16,16h8v24H24a8,8,0,0,0,0,16H56v32H48a16,16,0,0,0-16,16v32a16,16,0,0,0,16,16H80a16,16,0,0,0,16-16V176a16,16,0,0,0-16-16H72V128H184v32h-8a16,16,0,0,0-16,16v32a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V176a16,16,0,0,0-16-16h-8V128h32a8,8,0,0,0,0-16ZM112,40h32V72H112ZM80,208H48V176H80Zm128,0H176V176h32Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240,120a8,8,0,0,1-8,8H200v32h8a16,16,0,0,1,16,16v32a16,16,0,0,1-16,16H176a16,16,0,0,1-16-16V176a16,16,0,0,1,16-16h8V128H72v32h8a16,16,0,0,1,16,16v32a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V176a16,16,0,0,1,16-16h8V128H24a8,8,0,0,1,0-16h96V88h-8A16,16,0,0,1,96,72V40a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V72a16,16,0,0,1-16,16h-8v24h96A8,8,0,0,1,240,120Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,114H134V86h10a14,14,0,0,0,14-14V40a14,14,0,0,0-14-14H112A14,14,0,0,0,98,40V72a14,14,0,0,0,14,14h10v28H24a6,6,0,0,0,0,12H58v36H48a14,14,0,0,0-14,14v32a14,14,0,0,0,14,14H80a14,14,0,0,0,14-14V176a14,14,0,0,0-14-14H70V126H186v36H176a14,14,0,0,0-14,14v32a14,14,0,0,0,14,14h32a14,14,0,0,0,14-14V176a14,14,0,0,0-14-14H198V126h34a6,6,0,0,0,0-12ZM110,72V40a2,2,0,0,1,2-2h32a2,2,0,0,1,2,2V72a2,2,0,0,1-2,2H112A2,2,0,0,1,110,72ZM82,176v32a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V176a2,2,0,0,1,2-2H80A2,2,0,0,1,82,176Zm128,0v32a2,2,0,0,1-2,2H176a2,2,0,0,1-2-2V176a2,2,0,0,1,2-2h32A2,2,0,0,1,210,176Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,112H136V88h8a16,16,0,0,0,16-16V40a16,16,0,0,0-16-16H112A16,16,0,0,0,96,40V72a16,16,0,0,0,16,16h8v24H24a8,8,0,0,0,0,16H56v32H48a16,16,0,0,0-16,16v32a16,16,0,0,0,16,16H80a16,16,0,0,0,16-16V176a16,16,0,0,0-16-16H72V128H184v32h-8a16,16,0,0,0-16,16v32a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V176a16,16,0,0,0-16-16h-8V128h32a8,8,0,0,0,0-16ZM112,40h32V72H112ZM80,208H48V176H80Zm128,0H176V176h32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,116H132V84h12a12,12,0,0,0,12-12V40a12,12,0,0,0-12-12H112a12,12,0,0,0-12,12V72a12,12,0,0,0,12,12h12v32H24a4,4,0,0,0,0,8H60v40H48a12,12,0,0,0-12,12v32a12,12,0,0,0,12,12H80a12,12,0,0,0,12-12V176a12,12,0,0,0-12-12H68V124H188v40H176a12,12,0,0,0-12,12v32a12,12,0,0,0,12,12h32a12,12,0,0,0,12-12V176a12,12,0,0,0-12-12H196V124h36a4,4,0,0,0,0-8ZM108,72V40a4,4,0,0,1,4-4h32a4,4,0,0,1,4,4V72a4,4,0,0,1-4,4H112A4,4,0,0,1,108,72ZM84,176v32a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V176a4,4,0,0,1,4-4H80A4,4,0,0,1,84,176Zm128,0v32a4,4,0,0,1-4,4H176a4,4,0,0,1-4-4V176a4,4,0,0,1,4-4h32A4,4,0,0,1,212,176Z"
        }))
    ]
]);


const $6e819780b9c1274e$export$303836f55ddf2d4b = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...r,
        weights: (0, $717c67a0383cc585$export$2e2bcd8739ae039)
    }));
$6e819780b9c1274e$export$303836f55ddf2d4b.displayName = "NetworkIcon";
const $6e819780b9c1274e$export$95be4ae94445245a = $6e819780b9c1274e$export$303836f55ddf2d4b;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $7ad6262ed34ba9ef$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M56.88,31.93A12,12,0,1,0,39.12,48.07L93.6,108H24a12,12,0,0,0,0,24H52v24H48a20,20,0,0,0-20,20v32a20,20,0,0,0,20,20H80a20,20,0,0,0,20-20V176a20,20,0,0,0-20-20H76V132h39.42l83.7,92.07a12,12,0,0,0,17.76-16.14ZM76,204H52V180H76ZM92,42.14V40a20,20,0,0,1,20-20h32a20,20,0,0,1,20,20V72a20,20,0,0,1-20,20h-5.58a12,12,0,1,1,0-24H140V44H115.86A12,12,0,0,1,92,42.14ZM244,120a12,12,0,0,1-12,12H204v6.94a12,12,0,0,1-24,0V132h-5.21a12,12,0,1,1,0-24H232A12,12,0,0,1,244,120Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M88,176v32a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V176a8,8,0,0,1,8-8H80A8,8,0,0,1,88,176ZM144,32H112a8,8,0,0,0-8,8V72a8,8,0,0,0,8,8h32a8,8,0,0,0,8-8V40A8,8,0,0,0,144,32Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M96,54V40a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V72a16,16,0,0,1-16,16H127.61a8,8,0,0,1,0-16H144V40H112V54a8,8,0,0,1-16,0ZM213.92,210.62a8,8,0,1,1-11.84,10.76L117.19,128H72v32h8a16,16,0,0,1,16,16v32a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V176a16,16,0,0,1,16-16h8V128H24a8,8,0,0,1,0-16h78.64L42.08,45.38A8,8,0,1,1,53.92,34.62ZM80,176H48v32H80Zm152-64H164a8,8,0,0,0,0,16h20v22.83a8,8,0,1,0,16,0V128h32a8,8,0,0,0,0-16Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M98.08,59.41A8,8,0,0,1,96,54V40a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V72a16,16,0,0,1-16,16H127.61a8,8,0,0,1-5.92-2.62ZM53.92,34.62A8,8,0,1,0,42.08,45.38L102.64,112H24a8,8,0,0,0,0,16H56v32H48a16,16,0,0,0-16,16v32a16,16,0,0,0,16,16H80a16,16,0,0,0,16-16V176a16,16,0,0,0-16-16H72V128h45.19l84.89,93.38a8,8,0,1,0,11.84-10.76ZM232,112H164a8,8,0,0,0,0,16h20v22.83a8,8,0,1,0,16,0V128h32a8,8,0,0,0,0-16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M98,54V40a14,14,0,0,1,14-14h32a14,14,0,0,1,14,14V72a14,14,0,0,1-14,14H127.61a6,6,0,0,1,0-12H144a2,2,0,0,0,2-2V40a2,2,0,0,0-2-2H112a2,2,0,0,0-2,2V54a6,6,0,0,1-12,0ZM212.44,212a6,6,0,0,1-8.88,8.08l-85.49-94H70v36H80a14,14,0,0,1,14,14v32a14,14,0,0,1-14,14H48a14,14,0,0,1-14-14V176a14,14,0,0,1,14-14H58V126H24a6,6,0,0,1,0-12h83.16L43.56,44A6,6,0,0,1,52.44,36ZM80,174H48a2,2,0,0,0-2,2v32a2,2,0,0,0,2,2H80a2,2,0,0,0,2-2V176A2,2,0,0,0,80,174Zm152-60H164a6,6,0,0,0,0,12h22v24.83a6,6,0,1,0,12,0V126h34a6,6,0,0,0,0-12Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M96,54V40a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V72a16,16,0,0,1-16,16H127.61a8,8,0,0,1,0-16H144V40H112V54a8,8,0,0,1-16,0ZM213.92,210.62a8,8,0,1,1-11.84,10.76L117.19,128H72v32h8a16,16,0,0,1,16,16v32a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V176a16,16,0,0,1,16-16h8V128H24a8,8,0,0,1,0-16h78.64L42.08,45.38A8,8,0,1,1,53.92,34.62ZM80,176H48v32H80Zm152-64H164a8,8,0,0,0,0,16h20v22.83a8,8,0,1,0,16,0V128h32a8,8,0,0,0,0-16Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M100,54V40a12,12,0,0,1,12-12h32a12,12,0,0,1,12,12V72a12,12,0,0,1-12,12H127.61a4,4,0,0,1,0-8H144a4,4,0,0,0,4-4V40a4,4,0,0,0-4-4H112a4,4,0,0,0-4,4V54a4,4,0,0,1-8,0ZM211,213.31a4,4,0,1,1-5.92,5.38L119,124H68v40H80a12,12,0,0,1,12,12v32a12,12,0,0,1-12,12H48a12,12,0,0,1-12-12V176a12,12,0,0,1,12-12H60V124H24a4,4,0,0,1,0-8h87.68L45,42.69A4,4,0,0,1,51,37.31ZM80,172H48a4,4,0,0,0-4,4v32a4,4,0,0,0,4,4H80a4,4,0,0,0,4-4V176A4,4,0,0,0,80,172Zm152-56H164a4,4,0,0,0,0,8h24v26.83a4,4,0,1,0,8,0V124h36a4,4,0,0,0,0-8Z"
        }))
    ]
]);


const $f2584623c5b466be$export$40ca6aea9c29b1cf = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...r,
        weights: (0, $7ad6262ed34ba9ef$export$2e2bcd8739ae039)
    }));
$f2584623c5b466be$export$40ca6aea9c29b1cf.displayName = "NetworkSlashIcon";
const $f2584623c5b466be$export$c26f2f747fc00de7 = $f2584623c5b466be$export$40ca6aea9c29b1cf;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $c125d905142f537c$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,108H140V92h4a20,20,0,0,0,20-20V40a20,20,0,0,0-20-20H112A20,20,0,0,0,92,40V72a20,20,0,0,0,20,20h4v16H24a12,12,0,0,0,0,24H52v24H48a20,20,0,0,0-20,20v32a20,20,0,0,0,20,20H80a20,20,0,0,0,20-20V176a20,20,0,0,0-20-20H76V132H180v8a12,12,0,0,0,24,0v-8h28a12,12,0,0,0,0-24ZM116,44h24V68H116ZM76,204H52V180H76Zm148.49-27.51L209,192l15.52,15.51a12,12,0,0,1-17,17L192,209l-15.51,15.52a12,12,0,0,1-17-17L175,192l-15.52-15.51a12,12,0,0,1,17-17L192,175l15.51-15.52a12,12,0,0,1,17,17Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M152,40V72a8,8,0,0,1-8,8H112a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h32A8,8,0,0,1,152,40ZM80,168H48a8,8,0,0,0-8,8v32a8,8,0,0,0,8,8H80a8,8,0,0,0,8-8V176A8,8,0,0,0,80,168Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,112H136V88h8a16,16,0,0,0,16-16V40a16,16,0,0,0-16-16H112A16,16,0,0,0,96,40V72a16,16,0,0,0,16,16h8v24H24a8,8,0,0,0,0,16H56v32H48a16,16,0,0,0-16,16v32a16,16,0,0,0,16,16H80a16,16,0,0,0,16-16V176a16,16,0,0,0-16-16H72V128H184v16a8,8,0,0,0,16,0V128h32a8,8,0,0,0,0-16ZM112,40h32V72H112ZM80,208H48V176H80Zm141.65-34.34L203.31,192l18.35,18.34a8,8,0,0,1-11.32,11.32L192,203.31l-18.34,18.35a8,8,0,0,1-11.32-11.32L180.69,192l-18.35-18.34a8,8,0,0,1,11.32-11.32L192,180.69l18.34-18.35a8,8,0,0,1,11.32,11.32Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240,120a8,8,0,0,1-8,8H200v16a8,8,0,0,1-16,0V128H72v32h8a16,16,0,0,1,16,16v32a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V176a16,16,0,0,1,16-16h8V128H24a8,8,0,0,1,0-16h96V88h-8A16,16,0,0,1,96,72V40a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V72a16,16,0,0,1-16,16h-8v24h96A8,8,0,0,1,240,120Zm-18.34,42.34a8,8,0,0,0-11.32,0L192,180.69l-18.34-18.35a8,8,0,0,0-11.32,11.32L180.69,192l-18.35,18.34a8,8,0,0,0,11.32,11.32L192,203.31l18.34,18.35a8,8,0,0,0,11.32-11.32L203.31,192l18.35-18.34A8,8,0,0,0,221.66,162.34Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,114H134V86h10a14,14,0,0,0,14-14V40a14,14,0,0,0-14-14H112A14,14,0,0,0,98,40V72a14,14,0,0,0,14,14h10v28H24a6,6,0,0,0,0,12H58v36H48a14,14,0,0,0-14,14v32a14,14,0,0,0,14,14H80a14,14,0,0,0,14-14V176a14,14,0,0,0-14-14H70V126H186v18a6,6,0,0,0,12,0V126h34a6,6,0,0,0,0-12ZM110,72V40a2,2,0,0,1,2-2h32a2,2,0,0,1,2,2V72a2,2,0,0,1-2,2H112A2,2,0,0,1,110,72ZM82,176v32a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V176a2,2,0,0,1,2-2H80A2,2,0,0,1,82,176Zm138.24-3.76L200.48,192l19.76,19.76a6,6,0,1,1-8.48,8.48L192,200.48l-19.76,19.76a6,6,0,0,1-8.48-8.48L183.52,192l-19.76-19.76a6,6,0,0,1,8.48-8.48L192,183.52l19.76-19.76a6,6,0,0,1,8.48,8.48Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,112H136V88h8a16,16,0,0,0,16-16V40a16,16,0,0,0-16-16H112A16,16,0,0,0,96,40V72a16,16,0,0,0,16,16h8v24H24a8,8,0,0,0,0,16H56v32H48a16,16,0,0,0-16,16v32a16,16,0,0,0,16,16H80a16,16,0,0,0,16-16V176a16,16,0,0,0-16-16H72V128H184v16a8,8,0,0,0,16,0V128h32a8,8,0,0,0,0-16ZM112,40h32V72H112ZM80,208H48V176H80Zm141.65-34.34L203.31,192l18.35,18.34a8,8,0,0,1-11.32,11.32L192,203.31l-18.34,18.35a8,8,0,0,1-11.32-11.32L180.69,192l-18.35-18.34a8,8,0,0,1,11.32-11.32L192,180.69l18.34-18.35a8,8,0,0,1,11.32,11.32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,116H132V84h12a12,12,0,0,0,12-12V40a12,12,0,0,0-12-12H112a12,12,0,0,0-12,12V72a12,12,0,0,0,12,12h12v32H24a4,4,0,0,0,0,8H60v40H48a12,12,0,0,0-12,12v32a12,12,0,0,0,12,12H80a12,12,0,0,0,12-12V176a12,12,0,0,0-12-12H68V124H188v20a4,4,0,0,0,8,0V124h36a4,4,0,0,0,0-8ZM108,72V40a4,4,0,0,1,4-4h32a4,4,0,0,1,4,4V72a4,4,0,0,1-4,4H112A4,4,0,0,1,108,72ZM84,176v32a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V176a4,4,0,0,1,4-4H80A4,4,0,0,1,84,176Zm134.83-5.17L197.66,192l21.17,21.17a4,4,0,0,1-5.66,5.66L192,197.66l-21.17,21.17a4,4,0,0,1-5.66-5.66L186.34,192l-21.17-21.17a4,4,0,0,1,5.66-5.66L192,186.34l21.17-21.17a4,4,0,0,1,5.66,5.66Z"
        }))
    ]
]);


const $22492976e1d4d968$export$55653f8b5a32ba35 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...r,
        weights: (0, $c125d905142f537c$export$2e2bcd8739ae039)
    }));
$22492976e1d4d968$export$55653f8b5a32ba35.displayName = "NetworkXIcon";
const $22492976e1d4d968$export$4317df0e74bb0904 = $22492976e1d4d968$export$55653f8b5a32ba35;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $7ebbc860b68e7970$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M108,108a12,12,0,0,1,12-12h56a12,12,0,0,1,0,24H120A12,12,0,0,1,108,108Zm68,28H120a12,12,0,0,0,0,24h56a12,12,0,0,0,0-24Zm52-88V208a20,20,0,0,1-20,20H48a20,20,0,0,1-20-20V48A20,20,0,0,1,48,28H208A20,20,0,0,1,228,48ZM52,204H68V52H52ZM204,52H92V204H204Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M80,40V216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184,112a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16h64A8,8,0,0,1,184,112Zm-8,24H112a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm48-88V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48ZM48,208H72V48H48Zm160,0V48H88V208H208Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM80,208H48V48H80Zm96-56H112a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H112a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M182,112a6,6,0,0,1-6,6H112a6,6,0,0,1,0-12h64A6,6,0,0,1,182,112Zm-6,26H112a6,6,0,0,0,0,12h64a6,6,0,0,0,0-12Zm46-90V208a14,14,0,0,1-14,14H48a14,14,0,0,1-14-14V48A14,14,0,0,1,48,34H208A14,14,0,0,1,222,48ZM48,210H74V46H48a2,2,0,0,0-2,2V208A2,2,0,0,0,48,210ZM210,48a2,2,0,0,0-2-2H86V210H208a2,2,0,0,0,2-2Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184,112a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16h64A8,8,0,0,1,184,112Zm-8,24H112a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm48-88V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48ZM48,208H72V48H48Zm160,0V48H88V208H208Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M180,112a4,4,0,0,1-4,4H112a4,4,0,0,1,0-8h64A4,4,0,0,1,180,112Zm-4,28H112a4,4,0,0,0,0,8h64a4,4,0,0,0,0-8Zm44-92V208a12,12,0,0,1-12,12H48a12,12,0,0,1-12-12V48A12,12,0,0,1,48,36H208A12,12,0,0,1,220,48ZM48,212H76V44H48a4,4,0,0,0-4,4V208A4,4,0,0,0,48,212ZM212,48a4,4,0,0,0-4-4H84V212H208a4,4,0,0,0,4-4Z"
        }))
    ]
]);


const $da973a188202d04f$export$efdad510605bf5b6 = $7fPBF.forwardRef((t, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...t,
        weights: (0, $7ebbc860b68e7970$export$2e2bcd8739ae039)
    }));
$da973a188202d04f$export$efdad510605bf5b6.displayName = "NotebookIcon";
const $da973a188202d04f$export$9d9b3a199c5437eb = $da973a188202d04f$export$efdad510605bf5b6;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $5106b66d9e325f91$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232.49,55.51l-32-32a12,12,0,0,0-17,0l-96,96A12,12,0,0,0,84,128v32a12,12,0,0,0,12,12h32a12,12,0,0,0,8.49-3.51l96-96A12,12,0,0,0,232.49,55.51ZM192,49l15,15L196,75,181,60Zm-69,99H108V133l56-56,15,15Zm105-7.43V208a20,20,0,0,1-20,20H48a20,20,0,0,1-20-20V48A20,20,0,0,1,48,28h67.43a12,12,0,0,1,0,24H52V204H204V140.57a12,12,0,0,1,24,0Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,88l-72,72H96V128l72-72Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M229.66,58.34l-32-32a8,8,0,0,0-11.32,0l-96,96A8,8,0,0,0,88,128v32a8,8,0,0,0,8,8h32a8,8,0,0,0,5.66-2.34l96-96A8,8,0,0,0,229.66,58.34ZM124.69,152H104V131.31l64-64L188.69,88ZM200,76.69,179.31,56,192,43.31,212.69,64ZM224,128v80a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32h80a8,8,0,0,1,0,16H48V208H208V128a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128v80a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32h80a8,8,0,0,1,0,16H48V208H208V128a8,8,0,0,1,16,0Zm5.66-58.34-96,96A8,8,0,0,1,128,168H96a8,8,0,0,1-8-8V128a8,8,0,0,1,2.34-5.66l96-96a8,8,0,0,1,11.32,0l32,32A8,8,0,0,1,229.66,69.66Zm-17-5.66L192,43.31,179.31,56,200,76.69Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228.24,59.76l-32-32a6,6,0,0,0-8.48,0l-96,96A6,6,0,0,0,90,128v32a6,6,0,0,0,6,6h32a6,6,0,0,0,4.24-1.76l96-96A6,6,0,0,0,228.24,59.76ZM125.51,154H102V130.49l66-66L191.51,88ZM200,79.51,176.49,56,192,40.49,215.51,64ZM222,128v80a14,14,0,0,1-14,14H48a14,14,0,0,1-14-14V48A14,14,0,0,1,48,34h80a6,6,0,0,1,0,12H48a2,2,0,0,0-2,2V208a2,2,0,0,0,2,2H208a2,2,0,0,0,2-2V128a6,6,0,0,1,12,0Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M229.66,58.34l-32-32a8,8,0,0,0-11.32,0l-96,96A8,8,0,0,0,88,128v32a8,8,0,0,0,8,8h32a8,8,0,0,0,5.66-2.34l96-96A8,8,0,0,0,229.66,58.34ZM124.69,152H104V131.31l64-64L188.69,88ZM200,76.69,179.31,56,192,43.31,212.69,64ZM224,128v80a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32h80a8,8,0,0,1,0,16H48V208H208V128a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M226.83,61.17l-32-32a4,4,0,0,0-5.66,0l-96,96A4,4,0,0,0,92,128v32a4,4,0,0,0,4,4h32a4,4,0,0,0,2.83-1.17l96-96A4,4,0,0,0,226.83,61.17ZM126.34,156H100V129.66l68-68L194.34,88ZM200,82.34,173.66,56,192,37.66,218.34,64ZM220,128v80a12,12,0,0,1-12,12H48a12,12,0,0,1-12-12V48A12,12,0,0,1,48,36h80a4,4,0,0,1,0,8H48a4,4,0,0,0-4,4V208a4,4,0,0,0,4,4H208a4,4,0,0,0,4-4V128a4,4,0,0,1,8,0Z"
        }))
    ]
]);


const $69972f0aea86b6a2$export$d07ff5a8e7869743 = $7fPBF.forwardRef((t, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: c,
        ...t,
        weights: (0, $5106b66d9e325f91$export$2e2bcd8739ae039)
    }));
$69972f0aea86b6a2$export$d07ff5a8e7869743.displayName = "NotePencilIcon";
const $69972f0aea86b6a2$export$2fc869517b304253 = $69972f0aea86b6a2$export$d07ff5a8e7869743;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $f27dcf753f4fdcae$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M76,128a52,52,0,1,0,52-52A52.05,52.05,0,0,0,76,128Zm80,0a28,28,0,1,1-28-28A28,28,0,0,1,156,128Zm69.6-65.36-88-48.17a19.91,19.91,0,0,0-19.2,0l-88,48.17A20,20,0,0,0,20,80.19v95.62a20,20,0,0,0,10.4,17.55l88,48.17a19.89,19.89,0,0,0,19.2,0l88-48.17h0A20,20,0,0,0,236,175.81V80.19A20,20,0,0,0,225.6,62.64ZM212,173.44l-84,46-84-46V82.56l84-46,84,46Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M219.84,73.16,131.84,25a8,8,0,0,0-7.68,0l-88,48.18a8,8,0,0,0-4.16,7v95.64a8,8,0,0,0,4.16,7l88,48.18a8,8,0,0,0,7.68,0l88-48.18a8,8,0,0,0,4.16-7V80.18A8,8,0,0,0,219.84,73.16ZM128,168a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,80a48,48,0,1,0,48,48A48.06,48.06,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Zm95.68-93.85L135.68,18a15.88,15.88,0,0,0-15.36,0l-88,48.17a16,16,0,0,0-8.32,14v95.64a16,16,0,0,0,8.32,14l88,48.17a15.88,15.88,0,0,0,15.36,0l88-48.17h0a16,16,0,0,0,8.32-14V80.18A16,16,0,0,0,223.68,66.15ZM128,224,40,175.82V80.18L128,32l88,48.17v95.63Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M223.68,66.15,135.68,18a15.88,15.88,0,0,0-15.36,0l-88,48.17a16,16,0,0,0-8.32,14v95.64a16,16,0,0,0,8.32,14l88,48.17a15.88,15.88,0,0,0,15.36,0l88-48.17a16,16,0,0,0,8.32-14V80.18A16,16,0,0,0,223.68,66.15ZM128,168a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,82a46,46,0,1,0,46,46A46.06,46.06,0,0,0,128,82Zm0,80a34,34,0,1,1,34-34A34,34,0,0,1,128,162Zm94.72-94.09-88-48.18a13.9,13.9,0,0,0-13.44,0l-88,48.18A14,14,0,0,0,26,80.18v95.64a14,14,0,0,0,7.28,12.27l88,48.18a13.92,13.92,0,0,0,13.44,0l88-48.18A14,14,0,0,0,230,175.82V80.18A14,14,0,0,0,222.72,67.91ZM218,175.82a2,2,0,0,1-1,1.75l-88,48.18a2,2,0,0,1-1.92,0L39,177.57a2,2,0,0,1-1-1.75V80.18a2,2,0,0,1,1-1.75l88-48.18a2,2,0,0,1,1.92,0l88,48.18a2,2,0,0,1,1,1.75Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,80a48,48,0,1,0,48,48A48.06,48.06,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Zm95.68-93.85L135.68,18a15.88,15.88,0,0,0-15.36,0l-88,48.17a16,16,0,0,0-8.32,14v95.64a16,16,0,0,0,8.32,14l88,48.17a15.88,15.88,0,0,0,15.36,0l88-48.17h0a16,16,0,0,0,8.32-14V80.18A16,16,0,0,0,223.68,66.15ZM128,224,40,175.82V80.18L128,32l88,48.17v95.64Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,84a44,44,0,1,0,44,44A44.05,44.05,0,0,0,128,84Zm0,80a36,36,0,1,1,36-36A36,36,0,0,1,128,164Zm93.76-94.34-88-48.18a12,12,0,0,0-11.52,0l-88,48.18A12,12,0,0,0,28,80.18v95.64a12,12,0,0,0,6.24,10.52l88,48.18a11.95,11.95,0,0,0,11.52,0l88-48.18h0A12,12,0,0,0,228,175.82V80.18A12,12,0,0,0,221.76,69.66ZM220,175.82a4,4,0,0,1-2.08,3.5l-88,48.18a4,4,0,0,1-3.84,0l-88-48.17A4,4,0,0,1,36,175.82V80.18a4,4,0,0,1,2.08-3.5l88-48.18a3.94,3.94,0,0,1,3.84,0l88,48.18a4,4,0,0,1,2.08,3.5Z"
        }))
    ]
]);


const $25483bd4b980c997$export$49b63808e7fc4751 = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...e,
        weights: (0, $f27dcf753f4fdcae$export$2e2bcd8739ae039)
    }));
$25483bd4b980c997$export$49b63808e7fc4751.displayName = "NutIcon";
const $25483bd4b980c997$export$d3159630907da707 = $25483bd4b980c997$export$49b63808e7fc4751;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $51f23cd55de05d2f$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228.88,113.61A60,60,0,0,0,166,33.42,60,60,0,0,0,65.1,47.83a60,60,0,0,0-38,94.56A60.08,60.08,0,0,0,83.6,223a57.83,57.83,0,0,0,6.45-.36A60,60,0,0,0,190.9,208.17a60,60,0,0,0,38-94.56ZM181.81,58.3a36,36,0,0,1,26.58,37.6L170,73.73a12,12,0,0,0-12,0L120,95.67V81.81L154.5,61.9A35.74,35.74,0,0,1,181.81,58.3ZM136,123.38v9.24l-8,4.62-8-4.62v-9.24l8-4.62ZM84,72a36,36,0,0,1,56.39-29.67L102,64.49a12,12,0,0,0-6,10.39v43.88l-12-6.93ZM44.33,88.93A35.81,35.81,0,0,1,60,74.43v44.33a12,12,0,0,0,6,10.4l38,21.93L92,158,57.5,138.1A36,36,0,0,1,44.33,88.93ZM74.19,197.7a36,36,0,0,1-26.58-37.6L86,182.27a12,12,0,0,0,12,0l38-21.94v13.86L101.5,194.1A35.74,35.74,0,0,1,74.19,197.7ZM172,184a36,36,0,0,1-56.39,29.67L154,191.51a12,12,0,0,0,6-10.39V137.24l12,6.93Zm39.67-16.93A35.81,35.81,0,0,1,196,181.57V137.24a12,12,0,0,0-6-10.4l-38-21.93L164,98l34.5,19.92A36,36,0,0,1,211.67,167.07Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M96,174.19l56-32.33v36.95L107.5,204.5a48,48,0,0,1-66.4-64.08h0A48,48,0,0,0,51.5,148.5ZM204.5,107.5,160,81.81l-32,18.48,56,32.33V184a48,48,0,0,1-1.81,13h0A48,48,0,0,0,204.5,107.5ZM104,77.19,148.5,51.5a47.77,47.77,0,0,1,12.19-5v0A48,48,0,0,0,72,72v51.38l32,18.48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224.32,114.24a56,56,0,0,0-60.07-76.57A56,56,0,0,0,67.93,51.44a56,56,0,0,0-36.25,90.32A56,56,0,0,0,69,217,56.39,56.39,0,0,0,83.59,219a55.75,55.75,0,0,0,8.17-.61,56,56,0,0,0,96.31-13.78,56,56,0,0,0,36.25-90.32ZM182.85,54.43a40,40,0,0,1,28.56,48c-.95-.63-1.91-1.24-2.91-1.81L164,74.88a8,8,0,0,0-8,0l-44,25.41V81.81l40.5-23.38A39.76,39.76,0,0,1,182.85,54.43ZM144,137.24l-16,9.24-16-9.24V118.76l16-9.24,16,9.24ZM80,72a40,40,0,0,1,67.53-29c-1,.51-2,1-3,1.62L100,70.27a8,8,0,0,0-4,6.92V128l-16-9.24ZM40.86,86.93A39.75,39.75,0,0,1,64.12,68.57C64.05,69.71,64,70.85,64,72v51.38a8,8,0,0,0,4,6.93l44,25.4L96,165,55.5,141.57A40,40,0,0,1,40.86,86.93ZM73.15,201.57a40,40,0,0,1-28.56-48c.95.63,1.91,1.24,2.91,1.81L92,181.12a8,8,0,0,0,8,0l44-25.41v18.48l-40.5,23.38A39.76,39.76,0,0,1,73.15,201.57ZM176,184a40,40,0,0,1-67.52,29.05c1-.51,2-1.05,3-1.63L156,185.73a8,8,0,0,0,4-6.92V128l16,9.24Zm39.14-14.93a39.75,39.75,0,0,1-23.26,18.36c.07-1.14.12-2.28.12-3.43V132.62a8,8,0,0,0-4-6.93l-44-25.4,16-9.24,40.5,23.38A40,40,0,0,1,215.14,169.07Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224.32,114.24a56,56,0,0,0-60.07-76.57A56,56,0,0,0,67.93,51.44a56,56,0,0,0-36.25,90.32A56,56,0,0,0,69,217,56.39,56.39,0,0,0,83.59,219a55.75,55.75,0,0,0,8.17-.61,56,56,0,0,0,96.31-13.78,56,56,0,0,0,36.25-90.32Zm-80.32,23-16,9.24-16-9.24V118.76l16-9.24,16,9.24Zm38.85-82.81a40,40,0,0,1,28.56,48c-.95-.63-1.91-1.24-2.91-1.81L164,74.88a8,8,0,0,0-8,0l-44,25.41V81.81l40.5-23.38A39.76,39.76,0,0,1,182.85,54.43Zm-142,32.5A39.75,39.75,0,0,1,64.12,68.57C64.05,69.71,64,70.85,64,72v51.38a8,8,0,0,0,4,6.93l44,25.4L96,165,55.5,141.57A40,40,0,0,1,40.86,86.93ZM136,224a39.79,39.79,0,0,1-27.52-10.95c1-.51,2-1.05,3-1.63L156,185.73a8,8,0,0,0,4-6.92V128l16,9.24V184A40,40,0,0,1,136,224Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M222,114.56a54,54,0,0,0-58.67-74.73,54,54,0,0,0-94,13.46A54,54,0,0,0,34,141.44a54,54,0,0,0,35.56,73.65A54.54,54.54,0,0,0,83.59,217a52.86,52.86,0,0,0,9.06-.78,54,54,0,0,0,94-13.46A54,54,0,0,0,222,114.56ZM183.37,52.5a42,42,0,0,1,29.21,53.14,54.84,54.84,0,0,0-5.08-3.33L163,76.62a6,6,0,0,0-6,0l-47,27.13V80.66l41.5-24A41.73,41.73,0,0,1,183.37,52.5ZM146,138.39l-18,10.39-18-10.39V117.61l18-10.39,18,10.39ZM78,72a42,42,0,0,1,72.92-28.43,56.18,56.18,0,0,0-5.42,2.74L101,72a6,6,0,0,0-3,5.19v54.27L78,119.92ZM39.13,85.93a41.75,41.75,0,0,1,27.22-20A55.09,55.09,0,0,0,66,72v51.38a6,6,0,0,0,3,5.2l47,27.13L96,167.26l-41.5-24A42,42,0,0,1,39.13,85.93ZM72.63,203.5a42,42,0,0,1-29.21-53.14,54.84,54.84,0,0,0,5.08,3.33L93,179.38a6,6,0,0,0,6,0l47-27.13v23.09l-41.5,24A41.73,41.73,0,0,1,72.63,203.5ZM178,184a42,42,0,0,1-72.92,28.43,56.18,56.18,0,0,0,5.42-2.74L155,184a6,6,0,0,0,3-5.19V124.54l20,11.54Zm38.87-13.93a41.75,41.75,0,0,1-27.22,20A55.09,55.09,0,0,0,190,184V132.62a6,6,0,0,0-3-5.2l-47-27.13,20-11.55,41.5,24A42,42,0,0,1,216.87,170.07Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224.32,114.24a56,56,0,0,0-60.07-76.57A56,56,0,0,0,67.93,51.44a56,56,0,0,0-36.25,90.32A56,56,0,0,0,69,217,56.39,56.39,0,0,0,83.59,219a55.75,55.75,0,0,0,8.17-.61,56,56,0,0,0,96.31-13.78,56,56,0,0,0,36.25-90.32ZM182.85,54.43a40,40,0,0,1,28.56,48c-.95-.63-1.91-1.24-2.91-1.81L164,74.88a8,8,0,0,0-8,0l-44,25.41V81.81l40.5-23.38A39.76,39.76,0,0,1,182.85,54.43ZM144,137.24l-16,9.24-16-9.24V118.76l16-9.24,16,9.24ZM80,72a40,40,0,0,1,67.53-29c-1,.51-2,1-3,1.62L100,70.27a8,8,0,0,0-4,6.92V128l-16-9.24ZM40.86,86.93A39.75,39.75,0,0,1,64.12,68.57C64.05,69.71,64,70.85,64,72v51.38a8,8,0,0,0,4,6.93l44,25.4L96,165,55.5,141.57A40,40,0,0,1,40.86,86.93ZM73.15,201.57a40,40,0,0,1-28.56-48c.95.63,1.91,1.24,2.91,1.81L92,181.12a8,8,0,0,0,8,0l44-25.41v18.48l-40.5,23.38A39.76,39.76,0,0,1,73.15,201.57ZM176,184a40,40,0,0,1-67.52,29.05c1-.51,2-1.05,3-1.63L156,185.73a8,8,0,0,0,4-6.92V128l16,9.24Zm39.14-14.93a39.75,39.75,0,0,1-23.26,18.36c.07-1.14.12-2.28.12-3.43V132.62a8,8,0,0,0-4-6.93l-44-25.4,16-9.24,40.5,23.38A40,40,0,0,1,215.14,169.07Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M219.68,114.91A52,52,0,0,0,162.49,42,52,52,0,0,0,70.82,55.15a52,52,0,0,0-34.5,85.94A52,52,0,0,0,70,213.16,52.33,52.33,0,0,0,83.59,215a51.66,51.66,0,0,0,9.93-1,52,52,0,0,0,91.66-13.13,52,52,0,0,0,34.5-85.94Zm-35.8-64.34a44,44,0,0,1,29.66,58.36,51.84,51.84,0,0,0-7-4.89L162,78.35a4,4,0,0,0-4,0l-50,28.87V79.5L150.5,55A43.69,43.69,0,0,1,183.88,50.57Zm-35.88,89-20,11.54-20-11.54v-23.1l20-11.54,20,11.54ZM76,72a44,44,0,0,1,78.25-27.62A52.08,52.08,0,0,0,146.5,48L102,73.73a4,4,0,0,0-2,3.46v57.74L76,121.07ZM37.4,84.93A43.72,43.72,0,0,1,68.71,63.46,52.26,52.26,0,0,0,68,72v51.38a4,4,0,0,0,2,3.46l50,28.87L96,169.57,53.5,145A44,44,0,0,1,37.4,84.93Zm34.72,120.5a44,44,0,0,1-29.66-58.36,51.84,51.84,0,0,0,7,4.89L94,177.65a4,4,0,0,0,4,0l50-28.87V176.5L105.5,201A43.69,43.69,0,0,1,72.12,205.43ZM180,184a44,44,0,0,1-78.26,27.61A51.66,51.66,0,0,0,109.5,208L154,182.27a4,4,0,0,0,2-3.46V121.07l24,13.86Zm38.6-12.93a43.72,43.72,0,0,1-31.31,21.47A52.26,52.26,0,0,0,188,184V132.62a4,4,0,0,0-2-3.46l-50-28.87,24-13.86L202.5,111A44,44,0,0,1,218.6,171.07Z"
        }))
    ]
]);


const $58461f01577d65e9$export$526f06eba48e24ab = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...r,
        weights: (0, $51f23cd55de05d2f$export$2e2bcd8739ae039)
    }));
$58461f01577d65e9$export$526f06eba48e24ab.displayName = "OpenAiLogoIcon";
const $58461f01577d65e9$export$9a82f9e7e505c6ca = $58461f01577d65e9$export$526f06eba48e24ab;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $0b315445029b3b3c$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M203.57,51A107.9,107.9,0,0,0,20,128c0,44.72,27.6,82.25,72,97.94A36,36,0,0,0,140,192a12,12,0,0,1,12-12h46.21a35.79,35.79,0,0,0,35.1-28A108.6,108.6,0,0,0,236,127.09,107.23,107.23,0,0,0,203.57,51Zm6.34,95.67a11.91,11.91,0,0,1-11.7,9.3H152a36,36,0,0,0-36,36,12,12,0,0,1-16,11.3c-16.65-5.88-30.65-15.76-40.48-28.56A76,76,0,0,1,44,128a84,84,0,0,1,83.13-84H128a84.35,84.35,0,0,1,84,83.29A84.72,84.72,0,0,1,209.91,146.71ZM144,76a16,16,0,1,1-16-16A16,16,0,0,1,144,76Zm-44,24A16,16,0,1,1,84,84,16,16,0,0,1,100,100Zm0,56a16,16,0,1,1-16-16A16,16,0,0,1,100,156Zm88-56a16,16,0,1,1-16-16A16,16,0,0,1,188,100Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,127.17a96.48,96.48,0,0,1-2.39,22.18A24,24,0,0,1,198.21,168H152a24,24,0,0,0-24,24,24,24,0,0,1-32,22.61C58.73,201.44,32,169.81,32,128a96,96,0,0,1,95-96C179.84,31.47,223.55,74.35,224,127.17Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200.77,53.89A103.27,103.27,0,0,0,128,24h-1.07A104,104,0,0,0,24,128c0,43,26.58,79.06,69.36,94.17A32,32,0,0,0,136,192a16,16,0,0,1,16-16h46.21a31.81,31.81,0,0,0,31.2-24.88,104.43,104.43,0,0,0,2.59-24A103.28,103.28,0,0,0,200.77,53.89Zm13,93.71A15.89,15.89,0,0,1,198.21,160H152a32,32,0,0,0-32,32,16,16,0,0,1-21.31,15.07C62.49,194.3,40,164,40,128a88,88,0,0,1,87.09-88h.9a88.35,88.35,0,0,1,88,87.25A88.86,88.86,0,0,1,213.81,147.6ZM140,76a12,12,0,1,1-12-12A12,12,0,0,1,140,76ZM96,100A12,12,0,1,1,84,88,12,12,0,0,1,96,100Zm0,56a12,12,0,1,1-12-12A12,12,0,0,1,96,156Zm88-56a12,12,0,1,1-12-12A12,12,0,0,1,184,100Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200.77,53.89A103.27,103.27,0,0,0,128,24h-1.07A104,104,0,0,0,24,128c0,43,26.58,79.06,69.36,94.17A32,32,0,0,0,136,192a16,16,0,0,1,16-16h46.21a31.81,31.81,0,0,0,31.2-24.88,104.43,104.43,0,0,0,2.59-24A103.28,103.28,0,0,0,200.77,53.89ZM84,168a12,12,0,1,1,12-12A12,12,0,0,1,84,168Zm0-56a12,12,0,1,1,12-12A12,12,0,0,1,84,112Zm44-24a12,12,0,1,1,12-12A12,12,0,0,1,128,88Zm44,24a12,12,0,1,1,12-12A12,12,0,0,1,172,112Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M199.37,55.31A101.32,101.32,0,0,0,128,26h-1A102,102,0,0,0,26,128c0,42.09,26.07,77.44,68,92.26A30.21,30.21,0,0,0,104.11,222,30.06,30.06,0,0,0,134,192a18,18,0,0,1,18-18h46.21a29.82,29.82,0,0,0,29.25-23.31A102.71,102.71,0,0,0,230,127.11,101.25,101.25,0,0,0,199.37,55.31ZM215.76,148a17.89,17.89,0,0,1-17.55,14H152a30,30,0,0,0-30,30,18,18,0,0,1-24,17C61,195.86,38,164.85,38,128a90,90,0,0,1,89.07-90H128a90.34,90.34,0,0,1,90,89.22A90.46,90.46,0,0,1,215.76,148ZM138,76a10,10,0,1,1-10-10A10,10,0,0,1,138,76ZM94,100A10,10,0,1,1,84,90,10,10,0,0,1,94,100Zm0,56a10,10,0,1,1-10-10A10,10,0,0,1,94,156Zm88-56a10,10,0,1,1-10-10A10,10,0,0,1,182,100Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200.77,53.89A103.27,103.27,0,0,0,128,24h-1.07A104,104,0,0,0,24,128c0,43,26.58,79.06,69.36,94.17A32,32,0,0,0,136,192a16,16,0,0,1,16-16h46.21a31.81,31.81,0,0,0,31.2-24.88,104.43,104.43,0,0,0,2.59-24A103.28,103.28,0,0,0,200.77,53.89Zm13,93.71A15.89,15.89,0,0,1,198.21,160H152a32,32,0,0,0-32,32,16,16,0,0,1-21.31,15.07C62.49,194.3,40,164,40,128a88,88,0,0,1,87.09-88h.9a88.35,88.35,0,0,1,88,87.25A88.86,88.86,0,0,1,213.81,147.6ZM140,76a12,12,0,1,1-12-12A12,12,0,0,1,140,76ZM96,100A12,12,0,1,1,84,88,12,12,0,0,1,96,100Zm0,56a12,12,0,1,1-12-12A12,12,0,0,1,96,156Zm88-56a12,12,0,1,1-12-12A12,12,0,0,1,184,100Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M198,56.74A99.31,99.31,0,0,0,128,28h-1A100,100,0,0,0,28,128c0,41.22,25.55,75.85,66.69,90.38a28.34,28.34,0,0,0,9.42,1.63A28,28,0,0,0,132,192a20,20,0,0,1,20-20h46.21a27.84,27.84,0,0,0,27.3-21.76,100.37,100.37,0,0,0,2.49-23.1A99.26,99.26,0,0,0,198,56.74Zm19.74,91.72A19.89,19.89,0,0,1,198.21,164H152a28,28,0,0,0-28,28,20,20,0,0,1-26.64,18.83C59.51,197.46,36,165.72,36,128a92,92,0,0,1,91.05-92H128a92,92,0,0,1,89.72,112.46ZM136,76a8,8,0,1,1-8-8A8,8,0,0,1,136,76ZM92,100a8,8,0,1,1-8-8A8,8,0,0,1,92,100Zm0,56a8,8,0,1,1-8-8A8,8,0,0,1,92,156Zm88-56a8,8,0,1,1-8-8A8,8,0,0,1,180,100Z"
        }))
    ]
]);


const $2a77e4a11253c5e2$export$c142a38f581c8178 = $7fPBF.forwardRef((o, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: a,
        ...o,
        weights: (0, $0b315445029b3b3c$export$2e2bcd8739ae039)
    }));
$2a77e4a11253c5e2$export$c142a38f581c8178.displayName = "PaletteIcon";
const $2a77e4a11253c5e2$export$e2fbaa661ec19dbf = $2a77e4a11253c5e2$export$c142a38f581c8178;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $b88211d875b75024$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,164a36.07,36.07,0,0,0-33.94,24H72a28,28,0,0,1,0-56h96a44,44,0,0,0,0-88H72a12,12,0,0,0,0,24h96a20,20,0,0,1,0,40H72a52,52,0,0,0,0,104h94.06A36,36,0,1,0,200,164Zm0,48a12,12,0,1,1,12-12A12,12,0,0,1,200,212Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,200a24,24,0,1,1-24-24A24,24,0,0,1,224,200Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,168a32.06,32.06,0,0,0-31,24H72a32,32,0,0,1,0-64h96a40,40,0,0,0,0-80H72a8,8,0,0,0,0,16h96a24,24,0,0,1,0,48H72a48,48,0,0,0,0,96h97a32,32,0,1,0,31-40Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,200,216Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228,200a28,28,0,0,1-54.83,8H72a48,48,0,0,1,0-96h96a24,24,0,0,0,0-48H72a8,8,0,0,1,0-16h96a40,40,0,0,1,0,80H72a32,32,0,0,0,0,64H173.17A28,28,0,0,1,228,200Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,170a30.05,30.05,0,0,0-29.4,24H72a34,34,0,0,1,0-68h96a38,38,0,0,0,0-76H72a6,6,0,0,0,0,12h96a26,26,0,0,1,0,52H72a46,46,0,0,0,0,92h98.6A30,30,0,1,0,200,170Zm0,48a18,18,0,1,1,18-18A18,18,0,0,1,200,218Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,168a32.06,32.06,0,0,0-31,24H72a32,32,0,0,1,0-64h96a40,40,0,0,0,0-80H72a8,8,0,0,0,0,16h96a24,24,0,0,1,0,48H72a48,48,0,0,0,0,96h97a32,32,0,1,0,31-40Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,200,216Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,172a28,28,0,0,0-27.71,24H72a36,36,0,0,1,0-72h96a36,36,0,0,0,0-72H72a4,4,0,0,0,0,8h96a28,28,0,0,1,0,56H72a44,44,0,0,0,0,88H172.29A28,28,0,1,0,200,172Zm0,48a20,20,0,1,1,20-20A20,20,0,0,1,200,220Z"
        }))
    ]
]);


const $45c37c8e5c384c5e$export$c6d97cdd83a3ef7a = $7fPBF.forwardRef((a, e)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: e,
        ...a,
        weights: (0, $b88211d875b75024$export$2e2bcd8739ae039)
    }));
$45c37c8e5c384c5e$export$c6d97cdd83a3ef7a.displayName = "PathIcon";
const $45c37c8e5c384c5e$export$4b2950bdac9b6ee9 = $45c37c8e5c384c5e$export$c6d97cdd83a3ef7a;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $82241e5135dfa7e2$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212ZM116,96v64a12,12,0,0,1-24,0V96a12,12,0,0,1,24,0Zm48,0v64a12,12,0,0,1-24,0V96a12,12,0,0,1,24,0Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216ZM112,96v64a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.13,104.13,0,0,0,128,24ZM112,160a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Zm48,0a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218ZM110,96v64a6,6,0,0,1-12,0V96a6,6,0,0,1,12,0Zm48,0v64a6,6,0,0,1-12,0V96a6,6,0,0,1,12,0Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216ZM112,96v64a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220ZM108,96v64a4,4,0,0,1-8,0V96a4,4,0,0,1,8,0Zm48,0v64a4,4,0,0,1-8,0V96a4,4,0,0,1,8,0Z"
        }))
    ]
]);


const $67a070e95907d9d1$export$75886cde6273c22e = $7fPBF.forwardRef((r, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: a,
        ...r,
        weights: (0, $82241e5135dfa7e2$export$2e2bcd8739ae039)
    }));
$67a070e95907d9d1$export$75886cde6273c22e.displayName = "PauseCircleIcon";
const $67a070e95907d9d1$export$b5279a29eac7a382 = $67a070e95907d9d1$export$75886cde6273c22e;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $d783a5f5e3b289b6$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,28H160a20,20,0,0,0-20,20V208a20,20,0,0,0,20,20h40a20,20,0,0,0,20-20V48A20,20,0,0,0,200,28Zm-4,176H164V52h32ZM96,28H56A20,20,0,0,0,36,48V208a20,20,0,0,0,20,20H96a20,20,0,0,0,20-20V48A20,20,0,0,0,96,28ZM92,204H60V52H92Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,48V208a8,8,0,0,1-8,8H160a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h40A8,8,0,0,1,208,48ZM96,40H56a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H96a8,8,0,0,0,8-8V48A8,8,0,0,0,96,40Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,32H160a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16h40a16,16,0,0,0,16-16V48A16,16,0,0,0,200,32Zm0,176H160V48h40ZM96,32H56A16,16,0,0,0,40,48V208a16,16,0,0,0,16,16H96a16,16,0,0,0,16-16V48A16,16,0,0,0,96,32Zm0,176H56V48H96Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,48V208a16,16,0,0,1-16,16H160a16,16,0,0,1-16-16V48a16,16,0,0,1,16-16h40A16,16,0,0,1,216,48ZM96,32H56A16,16,0,0,0,40,48V208a16,16,0,0,0,16,16H96a16,16,0,0,0,16-16V48A16,16,0,0,0,96,32Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,34H160a14,14,0,0,0-14,14V208a14,14,0,0,0,14,14h40a14,14,0,0,0,14-14V48A14,14,0,0,0,200,34Zm2,174a2,2,0,0,1-2,2H160a2,2,0,0,1-2-2V48a2,2,0,0,1,2-2h40a2,2,0,0,1,2,2ZM96,34H56A14,14,0,0,0,42,48V208a14,14,0,0,0,14,14H96a14,14,0,0,0,14-14V48A14,14,0,0,0,96,34Zm2,174a2,2,0,0,1-2,2H56a2,2,0,0,1-2-2V48a2,2,0,0,1,2-2H96a2,2,0,0,1,2,2Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,32H160a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16h40a16,16,0,0,0,16-16V48A16,16,0,0,0,200,32Zm0,176H160V48h40ZM96,32H56A16,16,0,0,0,40,48V208a16,16,0,0,0,16,16H96a16,16,0,0,0,16-16V48A16,16,0,0,0,96,32Zm0,176H56V48H96Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,36H160a12,12,0,0,0-12,12V208a12,12,0,0,0,12,12h40a12,12,0,0,0,12-12V48A12,12,0,0,0,200,36Zm4,172a4,4,0,0,1-4,4H160a4,4,0,0,1-4-4V48a4,4,0,0,1,4-4h40a4,4,0,0,1,4,4ZM96,36H56A12,12,0,0,0,44,48V208a12,12,0,0,0,12,12H96a12,12,0,0,0,12-12V48A12,12,0,0,0,96,36Zm4,172a4,4,0,0,1-4,4H56a4,4,0,0,1-4-4V48a4,4,0,0,1,4-4H96a4,4,0,0,1,4,4Z"
        }))
    ]
]);


const $282419a8b70eaf27$export$9b47433640e5db3a = $7fPBF.forwardRef((a, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...a,
        weights: (0, $d783a5f5e3b289b6$export$2e2bcd8739ae039)
    }));
$282419a8b70eaf27$export$9b47433640e5db3a.displayName = "PauseIcon";
const $282419a8b70eaf27$export$59704c468e1a1527 = $282419a8b70eaf27$export$9b47433640e5db3a;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $75f0d0c7c3c88455$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M230.14,70.54,185.46,25.85a20,20,0,0,0-28.29,0L33.86,149.17A19.85,19.85,0,0,0,28,163.31V208a20,20,0,0,0,20,20H92.69a19.86,19.86,0,0,0,14.14-5.86L230.14,98.82a20,20,0,0,0,0-28.28ZM91,204H52V165l84-84,39,39ZM192,103,153,64l18.34-18.34,39,39Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M221.66,90.34,192,120,136,64l29.66-29.66a8,8,0,0,1,11.31,0L221.66,79A8,8,0,0,1,221.66,90.34Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M227.31,73.37,182.63,28.68a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H92.69A15.86,15.86,0,0,0,104,219.31L227.31,96a16,16,0,0,0,0-22.63ZM92.69,208H48V163.31l88-88L180.69,120ZM192,108.68,147.31,64l24-24L216,84.68Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M227.31,73.37,182.63,28.68a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H92.69A15.86,15.86,0,0,0,104,219.31L227.31,96a16,16,0,0,0,0-22.63ZM192,108.68,147.31,64l24-24L216,84.68Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M225.9,74.78,181.21,30.09a14,14,0,0,0-19.8,0L38.1,153.41a13.94,13.94,0,0,0-4.1,9.9V208a14,14,0,0,0,14,14H92.69a13.94,13.94,0,0,0,9.9-4.1L225.9,94.58a14,14,0,0,0,0-19.8ZM94.1,209.41a2,2,0,0,1-1.41.59H48a2,2,0,0,1-2-2V163.31a2,2,0,0,1,.59-1.41L136,72.48,183.51,120ZM217.41,86.1,192,111.51,144.49,64,169.9,38.58a2,2,0,0,1,2.83,0l44.68,44.69a2,2,0,0,1,0,2.83Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M227.31,73.37,182.63,28.68a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H92.69A15.86,15.86,0,0,0,104,219.31L227.31,96a16,16,0,0,0,0-22.63ZM92.69,208H48V163.31l88-88L180.69,120ZM192,108.68,147.31,64l24-24L216,84.68Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224.49,76.2,179.8,31.51a12,12,0,0,0-17,0L133.17,61.17h0L39.52,154.83A11.9,11.9,0,0,0,36,163.31V208a12,12,0,0,0,12,12H92.69a12,12,0,0,0,8.48-3.51L224.48,93.17a12,12,0,0,0,0-17Zm-129,134.63A4,4,0,0,1,92.69,212H48a4,4,0,0,1-4-4V163.31a4,4,0,0,1,1.17-2.83L136,69.65,186.34,120ZM218.83,87.51,192,114.34,141.66,64l26.82-26.83a4,4,0,0,1,5.66,0l44.69,44.68a4,4,0,0,1,0,5.66Z"
        }))
    ]
]);


const $9bcf07f234bdd453$export$97ae7c994680a9ed = $7fPBF.forwardRef((i, m)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: m,
        ...i,
        weights: (0, $75f0d0c7c3c88455$export$2e2bcd8739ae039)
    }));
$9bcf07f234bdd453$export$97ae7c994680a9ed.displayName = "PencilSimpleIcon";
const $9bcf07f234bdd453$export$489de2fc36740036 = $9bcf07f234bdd453$export$97ae7c994680a9ed;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $19cf1837247d50a6$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,154.8l-47.09-21.11-.18-.08a19.94,19.94,0,0,0-19,1.75,13.08,13.08,0,0,0-1.12.84l-22.31,19c-13-7.05-26.43-20.37-33.49-33.21l19.06-22.66a11.76,11.76,0,0,0,.85-1.15,20,20,0,0,0,1.66-18.83,1.42,1.42,0,0,1-.08-.18L101.2,32A20.06,20.06,0,0,0,80.42,20.15,60.27,60.27,0,0,0,28,80c0,81.61,66.39,148,148,148a60.27,60.27,0,0,0,59.85-52.42A20.06,20.06,0,0,0,224,154.8ZM176,204A124.15,124.15,0,0,1,52,80,36.29,36.29,0,0,1,80.48,44.46l18.82,42L80.14,109.28a12,12,0,0,0-.86,1.16A20,20,0,0,0,78,130.08c9.42,19.28,28.83,38.56,48.31,48A20,20,0,0,0,146,176.63a11.63,11.63,0,0,0,1.11-.85l22.43-19.07,42,18.81A36.29,36.29,0,0,1,176,204Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M223.94,174.08A48.33,48.33,0,0,1,176,216,136,136,0,0,1,40,80,48.33,48.33,0,0,1,81.92,32.06a8,8,0,0,1,8.3,4.8l21.13,47.2a8,8,0,0,1-.66,7.53L89.32,117a7.93,7.93,0,0,0-.54,7.81c8.27,16.93,25.77,34.22,42.75,42.41a7.92,7.92,0,0,0,7.83-.59l25-21.3a8,8,0,0,1,7.59-.69l47.16,21.13A8,8,0,0,1,223.94,174.08Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M222.37,158.46l-47.11-21.11-.13-.06a16,16,0,0,0-15.17,1.4,8.12,8.12,0,0,0-.75.56L134.87,160c-15.42-7.49-31.34-23.29-38.83-38.51l20.78-24.71c.2-.25.39-.5.57-.77a16,16,0,0,0,1.32-15.06l0-.12L97.54,33.64a16,16,0,0,0-16.62-9.52A56.26,56.26,0,0,0,32,80c0,79.4,64.6,144,144,144a56.26,56.26,0,0,0,55.88-48.92A16,16,0,0,0,222.37,158.46ZM176,208A128.14,128.14,0,0,1,48,80,40.2,40.2,0,0,1,82.87,40a.61.61,0,0,0,0,.12l21,47L83.2,111.86a6.13,6.13,0,0,0-.57.77,16,16,0,0,0-1,15.7c9.06,18.53,27.73,37.06,46.46,46.11a16,16,0,0,0,15.75-1.14,8.44,8.44,0,0,0,.74-.56L168.89,152l47,21.05h0s.08,0,.11,0A40.21,40.21,0,0,1,176,208Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M231.88,175.08A56.26,56.26,0,0,1,176,224C96.6,224,32,159.4,32,80A56.26,56.26,0,0,1,80.92,24.12a16,16,0,0,1,16.62,9.52l21.12,47.15,0,.12A16,16,0,0,1,117.39,96c-.18.27-.37.52-.57.77L96,121.45c7.49,15.22,23.41,31,38.83,38.51l24.34-20.71a8.12,8.12,0,0,1,.75-.56,16,16,0,0,1,15.17-1.4l.13.06,47.11,21.11A16,16,0,0,1,231.88,175.08Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M221.59,160.3l-47.24-21.17a14,14,0,0,0-13.28,1.22,4.81,4.81,0,0,0-.56.42l-24.69,21a1.88,1.88,0,0,1-1.68.06c-15.87-7.66-32.31-24-40-39.65a1.91,1.91,0,0,1,0-1.68l21.07-25a6.13,6.13,0,0,0,.42-.58,14,14,0,0,0,1.12-13.27L95.73,34.49a14,14,0,0,0-14.56-8.38A54.24,54.24,0,0,0,34,80c0,78.3,63.7,142,142,142a54.25,54.25,0,0,0,53.89-47.17A14,14,0,0,0,221.59,160.3ZM176,210C104.32,210,46,151.68,46,80A42.23,42.23,0,0,1,82.67,38h.23a2,2,0,0,1,1.84,1.31l21.1,47.11a2,2,0,0,1,0,1.67L84.73,113.15a4.73,4.73,0,0,0-.43.57,14,14,0,0,0-.91,13.73c8.87,18.16,27.17,36.32,45.53,45.19a14,14,0,0,0,13.77-1c.19-.13.38-.27.56-.42l24.68-21a1.92,1.92,0,0,1,1.6-.1l47.25,21.17a2,2,0,0,1,1.21,2A42.24,42.24,0,0,1,176,210Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M222.37,158.46l-47.11-21.11-.13-.06a16,16,0,0,0-15.17,1.4,8.12,8.12,0,0,0-.75.56L134.87,160c-15.42-7.49-31.34-23.29-38.83-38.51l20.78-24.71c.2-.25.39-.5.57-.77a16,16,0,0,0,1.32-15.06l0-.12L97.54,33.64a16,16,0,0,0-16.62-9.52A56.26,56.26,0,0,0,32,80c0,79.4,64.6,144,144,144a56.26,56.26,0,0,0,55.88-48.92A16,16,0,0,0,222.37,158.46ZM176,208A128.14,128.14,0,0,1,48,80,40.2,40.2,0,0,1,82.87,40a.61.61,0,0,0,0,.12l21,47L83.2,111.86a6.13,6.13,0,0,0-.57.77,16,16,0,0,0-1,15.7c9.06,18.53,27.73,37.06,46.46,46.11a16,16,0,0,0,15.75-1.14,8.44,8.44,0,0,0,.74-.56L168.89,152l47,21.05h0s.08,0,.11,0A40.21,40.21,0,0,1,176,208Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220.78,162.13,173.56,141A12,12,0,0,0,162.18,142a3.37,3.37,0,0,0-.38.28L137,163.42a3.93,3.93,0,0,1-3.7.21c-16.24-7.84-33.05-24.52-40.89-40.57a3.9,3.9,0,0,1,.18-3.69l21.2-25.21c.1-.12.19-.25.28-.38a12,12,0,0,0,1-11.36L93.9,35.28a12,12,0,0,0-12.48-7.19A52.25,52.25,0,0,0,36,80c0,77.2,62.8,140,140,140a52.25,52.25,0,0,0,51.91-45.42A12,12,0,0,0,220.78,162.13ZM220,173.58A44.23,44.23,0,0,1,176,212C103.22,212,44,152.78,44,80A44.23,44.23,0,0,1,82.42,36a3.87,3.87,0,0,1,.48,0,4,4,0,0,1,3.67,2.49l21.11,47.14a4,4,0,0,1-.23,3.6l-21.19,25.2c-.1.13-.2.25-.29.39a12,12,0,0,0-.78,11.75c8.69,17.79,26.61,35.58,44.6,44.27a12,12,0,0,0,11.79-.87l.37-.28,24.83-21.12a3.93,3.93,0,0,1,3.57-.27l47.21,21.16A4,4,0,0,1,220,173.58Z"
        }))
    ]
]);


const $f9242fb59a025a53$export$54336acd81078d46 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...r,
        weights: (0, $19cf1837247d50a6$export$2e2bcd8739ae039)
    }));
$f9242fb59a025a53$export$54336acd81078d46.displayName = "PhoneIcon";
const $f9242fb59a025a53$export$2de540f0cd7c073a = $f9242fb59a025a53$export$54336acd81078d46;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $f6f26805e5c51ab3$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M234.49,111.07,90.41,22.94A20,20,0,0,0,60,39.87V216.13a20,20,0,0,0,30.41,16.93l144.08-88.13a19.82,19.82,0,0,0,0-33.86ZM84,208.85V47.15L216.16,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228.23,134.69,84.15,222.81A8,8,0,0,1,72,216.12V39.88a8,8,0,0,1,12.15-6.69l144.08,88.12A7.82,7.82,0,0,1,228.23,134.69Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232.4,114.49,88.32,26.35a16,16,0,0,0-16.2-.3A15.86,15.86,0,0,0,64,39.87V216.13A15.94,15.94,0,0,0,80,232a16.07,16.07,0,0,0,8.36-2.35L232.4,141.51a15.81,15.81,0,0,0,0-27ZM80,215.94V40l143.83,88Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240,128a15.74,15.74,0,0,1-7.6,13.51L88.32,229.65a16,16,0,0,1-16.2.3A15.86,15.86,0,0,1,64,216.13V39.87a15.86,15.86,0,0,1,8.12-13.82,16,16,0,0,1,16.2.3L232.4,114.49A15.74,15.74,0,0,1,240,128Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M231.36,116.19,87.28,28.06a14,14,0,0,0-14.18-.27A13.69,13.69,0,0,0,66,39.87V216.13a13.69,13.69,0,0,0,7.1,12.08,14,14,0,0,0,14.18-.27l144.08-88.13a13.82,13.82,0,0,0,0-23.62Zm-6.26,13.38L81,217.7a2,2,0,0,1-2.06,0,1.78,1.78,0,0,1-1-1.61V39.87a1.78,1.78,0,0,1,1-1.61A2.06,2.06,0,0,1,80,38a2,2,0,0,1,1,.31L225.1,126.43a1.82,1.82,0,0,1,0,3.14Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232.4,114.49,88.32,26.35a16,16,0,0,0-16.2-.3A15.86,15.86,0,0,0,64,39.87V216.13A15.94,15.94,0,0,0,80,232a16.07,16.07,0,0,0,8.36-2.35L232.4,141.51a15.81,15.81,0,0,0,0-27ZM80,215.94V40l143.83,88Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M230.32,117.9,86.24,29.79a11.91,11.91,0,0,0-12.17-.23A11.71,11.71,0,0,0,68,39.89V216.11a11.71,11.71,0,0,0,6.07,10.33,11.91,11.91,0,0,0,12.17-.23L230.32,138.1a11.82,11.82,0,0,0,0-20.2Zm-4.18,13.37L82.06,219.39a4,4,0,0,1-4.07.07,3.77,3.77,0,0,1-2-3.35V39.89a3.77,3.77,0,0,1,2-3.35,4,4,0,0,1,4.07.07l144.08,88.12a3.8,3.8,0,0,1,0,6.54Z"
        }))
    ]
]);


const $3771d59d9595d59e$export$a6630b90defda83f = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...e,
        weights: (0, $f6f26805e5c51ab3$export$2e2bcd8739ae039)
    }));
$3771d59d9595d59e$export$a6630b90defda83f.displayName = "PlayIcon";
const $3771d59d9595d59e$export$480db61f4dcd7727 = $3771d59d9595d59e$export$a6630b90defda83f;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $b7c084f51671cbc2$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Zm52-84a12,12,0,0,1-12,12H140v28a12,12,0,0,1-24,0V140H88a12,12,0,0,1,0-24h28V88a12,12,0,0,1,24,0v28h28A12,12,0,0,1,180,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm48-88a8,8,0,0,1-8,8H136v32a8,8,0,0,1-16,0V136H88a8,8,0,0,1,0-16h32V88a8,8,0,0,1,16,0v32h32A8,8,0,0,1,176,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.13,104.13,0,0,0,128,24Zm40,112H136v32a8,8,0,0,1-16,0V136H88a8,8,0,0,1,0-16h32V88a8,8,0,0,1,16,0v32h32a8,8,0,0,1,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Zm46-90a6,6,0,0,1-6,6H134v34a6,6,0,0,1-12,0V134H88a6,6,0,0,1,0-12h34V88a6,6,0,0,1,12,0v34h34A6,6,0,0,1,174,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm48-88a8,8,0,0,1-8,8H136v32a8,8,0,0,1-16,0V136H88a8,8,0,0,1,0-16h32V88a8,8,0,0,1,16,0v32h32A8,8,0,0,1,176,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Zm44-92a4,4,0,0,1-4,4H132v36a4,4,0,0,1-8,0V132H88a4,4,0,0,1,0-8h36V88a4,4,0,0,1,8,0v36h36A4,4,0,0,1,172,128Z"
        }))
    ]
]);


const $dd4d57083c8a9ad0$export$99bb4c5ac5bf5ec5 = $7fPBF.forwardRef((r, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: c,
        ...r,
        weights: (0, $b7c084f51671cbc2$export$2e2bcd8739ae039)
    }));
$dd4d57083c8a9ad0$export$99bb4c5ac5bf5ec5.displayName = "PlusCircleIcon";
const $dd4d57083c8a9ad0$export$d8dd5a6f368a4f30 = $dd4d57083c8a9ad0$export$99bb4c5ac5bf5ec5;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $f2725e8c66d6888f$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,36H140V24a12,12,0,0,0-24,0V36H40A20,20,0,0,0,20,56V176a20,20,0,0,0,20,20H71l-16.4,20.5a12,12,0,0,0,18.74,15l28.4-35.5h52.46l28.4,35.5a12,12,0,0,0,18.74-15L185,196h31a20,20,0,0,0,20-20V56A20,20,0,0,0,216,36Zm-4,136H44V60H212ZM104,120v24a12,12,0,0,1-24,0V120a12,12,0,0,1,24,0Zm24-28a12,12,0,0,1,12,12v40a12,12,0,0,1-24,0V104A12,12,0,0,1,128,92Zm24,52V88a12,12,0,0,1,24,0v56a12,12,0,0,1-24,0Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,56V176a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216A8,8,0,0,1,224,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,40H136V24a8,8,0,0,0-16,0V40H40A16,16,0,0,0,24,56V176a16,16,0,0,0,16,16H79.36L57.75,219a8,8,0,0,0,12.5,10l29.59-37h56.32l29.59,37a8,8,0,1,0,12.5-10l-21.61-27H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,136H40V56H216V176ZM104,120v24a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0Zm32-16v40a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm32-16v56a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,40H136V24a8,8,0,0,0-16,0V40H40A16,16,0,0,0,24,56V176a16,16,0,0,0,16,16H79.36L57.75,219a8,8,0,0,0,12.5,10l29.59-37h56.32l29.59,37a8,8,0,1,0,12.5-10l-21.61-27H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM104,144a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0Zm32,0a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm32,0a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,42H134V24a6,6,0,0,0-12,0V42H40A14,14,0,0,0,26,56V176a14,14,0,0,0,14,14H83.52L59.31,220.25a6,6,0,0,0,9.38,7.5L98.88,190h58.24l30.19,37.75a6,6,0,0,0,9.38-7.5L172.48,190H216a14,14,0,0,0,14-14V56A14,14,0,0,0,216,42Zm2,134a2,2,0,0,1-2,2H40a2,2,0,0,1-2-2V56a2,2,0,0,1,2-2H216a2,2,0,0,1,2,2ZM102,120v24a6,6,0,0,1-12,0V120a6,6,0,0,1,12,0Zm32-16v40a6,6,0,0,1-12,0V104a6,6,0,0,1,12,0Zm32-16v56a6,6,0,0,1-12,0V88a6,6,0,0,1,12,0Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,40H136V24a8,8,0,0,0-16,0V40H40A16,16,0,0,0,24,56V176a16,16,0,0,0,16,16H79.36L57.75,219a8,8,0,0,0,12.5,10l29.59-37h56.32l29.59,37a8,8,0,1,0,12.5-10l-21.61-27H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,136H40V56H216V176ZM104,120v24a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0Zm32-16v40a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm32-16v56a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,44H132V24a4,4,0,0,0-8,0V44H40A12,12,0,0,0,28,56V176a12,12,0,0,0,12,12H87.68l-26.8,33.5a4,4,0,1,0,6.24,5L97.92,188h60.16l30.8,38.5a4,4,0,0,0,6.24-5L168.32,188H216a12,12,0,0,0,12-12V56A12,12,0,0,0,216,44Zm4,132a4,4,0,0,1-4,4H40a4,4,0,0,1-4-4V56a4,4,0,0,1,4-4H216a4,4,0,0,1,4,4ZM100,120v24a4,4,0,0,1-8,0V120a4,4,0,0,1,8,0Zm32-16v40a4,4,0,0,1-8,0V104a4,4,0,0,1,8,0Zm32-16v56a4,4,0,0,1-8,0V88a4,4,0,0,1,8,0Z"
        }))
    ]
]);


const $bbd40d632367bb70$export$efe9d8422aa89449 = $7fPBF.forwardRef((o, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...o,
        weights: (0, $f2725e8c66d6888f$export$2e2bcd8739ae039)
    }));
$bbd40d632367bb70$export$efe9d8422aa89449.displayName = "PresentationChartIcon";
const $bbd40d632367bb70$export$a5e1f3e20d9ba748 = $bbd40d632367bb70$export$efe9d8422aa89449;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $048f1d3f3954f21a$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm84,108a83.6,83.6,0,0,1-16.75,50.28L77.72,60.75A84,84,0,0,1,212,128ZM44,128A83.6,83.6,0,0,1,60.75,77.72L178.28,195.25A84,84,0,0,1,44,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm88,104a87.56,87.56,0,0,1-20.41,56.28L71.72,60.4A88,88,0,0,1,216,128ZM40,128A87.56,87.56,0,0,1,60.41,71.72L184.28,195.6A88,88,0,0,1,40,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,128a71.69,71.69,0,0,1-15.78,44.91L83.09,71.78A71.95,71.95,0,0,1,200,128ZM56,128a71.95,71.95,0,0,0,116.91,56.22L71.78,83.09A71.69,71.69,0,0,0,56,128Zm180,0A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-20,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm90,102a89.6,89.6,0,0,1-22.29,59.22L68.78,60.29A89.95,89.95,0,0,1,218,128ZM38,128A89.6,89.6,0,0,1,60.29,68.78L187.22,195.71A89.95,89.95,0,0,1,38,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm88,104a87.56,87.56,0,0,1-20.41,56.28L71.72,60.4A88,88,0,0,1,216,128ZM40,128A87.56,87.56,0,0,1,60.41,71.72L184.28,195.6A88,88,0,0,1,40,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm92,100a91.67,91.67,0,0,1-24.21,62.13L65.87,60.21A92,92,0,0,1,220,128ZM36,128A91.67,91.67,0,0,1,60.21,65.87L190.13,195.79A92,92,0,0,1,36,128Z"
        }))
    ]
]);


const $7425fd815e1431db$export$852d83c83fe09d93 = $7fPBF.forwardRef((t, i)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: i,
        ...t,
        weights: (0, $048f1d3f3954f21a$export$2e2bcd8739ae039)
    }));
$7425fd815e1431db$export$852d83c83fe09d93.displayName = "ProhibitIcon";
const $7425fd815e1431db$export$7891ead8a87bdea = $7425fd815e1431db$export$852d83c83fe09d93;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $27859a1fbdea2097$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,180a16,16,0,1,1-16-16A16,16,0,0,1,144,180Zm92-52A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128ZM128,64c-24.26,0-44,17.94-44,40v4a12,12,0,0,0,24,0v-4c0-8.82,9-16,20-16s20,7.18,20,16-9,16-20,16a12,12,0,0,0-12,12v8a12,12,0,0,0,23.73,2.56C158.31,137.88,172,122.37,172,104,172,81.94,152.26,64,128,64Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M140,180a12,12,0,1,1-12-12A12,12,0,0,1,140,180ZM128,72c-22.06,0-40,16.15-40,36v4a8,8,0,0,0,16,0v-4c0-11,10.77-20,24-20s24,9,24,20-10.77,20-24,20a8,8,0,0,0-8,8v8a8,8,0,0,0,16,0v-.72c18.24-3.35,32-17.9,32-35.28C168,88.15,150.06,72,128,72Zm104,56A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,168a12,12,0,1,1,12-12A12,12,0,0,1,128,192Zm8-48.72V144a8,8,0,0,1-16,0v-8a8,8,0,0,1,8-8c13.23,0,24-9,24-20s-10.77-20-24-20-24,9-24,20v4a8,8,0,0,1-16,0v-4c0-19.85,17.94-36,40-36s40,16.15,40,36C168,125.38,154.24,139.93,136,143.28Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M138,180a10,10,0,1,1-10-10A10,10,0,0,1,138,180ZM128,74c-21,0-38,15.25-38,34v4a6,6,0,0,0,12,0v-4c0-12.13,11.66-22,26-22s26,9.87,26,22-11.66,22-26,22a6,6,0,0,0-6,6v8a6,6,0,0,0,12,0v-2.42c18.11-2.58,32-16.66,32-33.58C166,89.25,149,74,128,74Zm102,54A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M140,180a12,12,0,1,1-12-12A12,12,0,0,1,140,180ZM128,72c-22.06,0-40,16.15-40,36v4a8,8,0,0,0,16,0v-4c0-11,10.77-20,24-20s24,9,24,20-10.77,20-24,20a8,8,0,0,0-8,8v8a8,8,0,0,0,16,0v-.72c18.24-3.35,32-17.9,32-35.28C168,88.15,150.06,72,128,72Zm104,56A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M136,180a8,8,0,1,1-8-8A8,8,0,0,1,136,180ZM128,76c-19.85,0-36,14.36-36,32v4a4,4,0,0,0,8,0v-4c0-13.23,12.56-24,28-24s28,10.77,28,24-12.56,24-28,24a4,4,0,0,0-4,4v8a4,4,0,0,0,8,0v-4.2c18-1.77,32-15.36,32-31.8C164,90.36,147.85,76,128,76Zm100,52A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z"
        }))
    ]
]);


const $2322f0f5c675ac09$export$f314ed182f5da2a0 = $7fPBF.forwardRef((t, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...t,
        weights: (0, $27859a1fbdea2097$export$2e2bcd8739ae039)
    }));
$2322f0f5c675ac09$export$f314ed182f5da2a0.displayName = "QuestionIcon";
const $2322f0f5c675ac09$export$38435c7d2fecd2f = $2322f0f5c675ac09$export$f314ed182f5da2a0;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $3d7d3c27e9d1b273$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M20,128A76.08,76.08,0,0,1,96,52h99l-3.52-3.51a12,12,0,1,1,17-17l24,24a12,12,0,0,1,0,17l-24,24a12,12,0,0,1-17-17L195,76H96a52.06,52.06,0,0,0-52,52,12,12,0,0,1-24,0Zm204-12a12,12,0,0,0-12,12,52.06,52.06,0,0,1-52,52H61l3.52-3.51a12,12,0,1,0-17-17l-24,24a12,12,0,0,0,0,17l24,24a12,12,0,1,0,17-17L61,204h99a76.08,76.08,0,0,0,76-76A12,12,0,0,0,224,116Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,64v64a64,64,0,0,1-64,64H32V128A64,64,0,0,1,96,64Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M24,128A72.08,72.08,0,0,1,96,56H204.69L194.34,45.66a8,8,0,0,1,11.32-11.32l24,24a8,8,0,0,1,0,11.32l-24,24a8,8,0,0,1-11.32-11.32L204.69,72H96a56.06,56.06,0,0,0-56,56,8,8,0,0,1-16,0Zm200-8a8,8,0,0,0-8,8,56.06,56.06,0,0,1-56,56H51.31l10.35-10.34a8,8,0,0,0-11.32-11.32l-24,24a8,8,0,0,0,0,11.32l24,24a8,8,0,0,0,11.32-11.32L51.31,200H160a72.08,72.08,0,0,0,72-72A8,8,0,0,0,224,120Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M24,128A72.08,72.08,0,0,1,96,56h96V40a8,8,0,0,1,13.66-5.66l24,24a8,8,0,0,1,0,11.32l-24,24A8,8,0,0,1,192,88V72H96a56.06,56.06,0,0,0-56,56,8,8,0,0,1-16,0Zm200-8a8,8,0,0,0-8,8,56.06,56.06,0,0,1-56,56H64V168a8,8,0,0,0-13.66-5.66l-24,24a8,8,0,0,0,0,11.32l24,24A8,8,0,0,0,64,216V200h96a72.08,72.08,0,0,0,72-72A8,8,0,0,0,224,120Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M26,128A70.08,70.08,0,0,1,96,58H209.51L195.76,44.24a6,6,0,0,1,8.48-8.48l24,24a6,6,0,0,1,0,8.48l-24,24a6,6,0,0,1-8.48-8.48L209.51,70H96a58.07,58.07,0,0,0-58,58,6,6,0,0,1-12,0Zm198-6a6,6,0,0,0-6,6,58.07,58.07,0,0,1-58,58H46.49l13.75-13.76a6,6,0,0,0-8.48-8.48l-24,24a6,6,0,0,0,0,8.48l24,24a6,6,0,0,0,8.48-8.48L46.49,198H160a70.08,70.08,0,0,0,70-70A6,6,0,0,0,224,122Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M24,128A72.08,72.08,0,0,1,96,56H204.69L194.34,45.66a8,8,0,0,1,11.32-11.32l24,24a8,8,0,0,1,0,11.32l-24,24a8,8,0,0,1-11.32-11.32L204.69,72H96a56.06,56.06,0,0,0-56,56,8,8,0,0,1-16,0Zm200-8a8,8,0,0,0-8,8,56.06,56.06,0,0,1-56,56H51.31l10.35-10.34a8,8,0,0,0-11.32-11.32l-24,24a8,8,0,0,0,0,11.32l24,24a8,8,0,0,0,11.32-11.32L51.31,200H160a72.08,72.08,0,0,0,72-72A8,8,0,0,0,224,120Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M28,128A68.07,68.07,0,0,1,96,60H214.34L197.17,42.83a4,4,0,0,1,5.66-5.66l24,24a4,4,0,0,1,0,5.66l-24,24a4,4,0,0,1-5.66-5.66L214.34,68H96a60.07,60.07,0,0,0-60,60,4,4,0,0,1-8,0Zm196-4a4,4,0,0,0-4,4,60.07,60.07,0,0,1-60,60H41.66l17.17-17.17a4,4,0,0,0-5.66-5.66l-24,24a4,4,0,0,0,0,5.66l24,24a4,4,0,1,0,5.66-5.66L41.66,196H160a68.07,68.07,0,0,0,68-68A4,4,0,0,0,224,124Z"
        }))
    ]
]);


const $510c9fc2f66cce3f$export$e5f174c029ba02b2 = $7fPBF.forwardRef((t, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: a,
        ...t,
        weights: (0, $3d7d3c27e9d1b273$export$2e2bcd8739ae039)
    }));
$510c9fc2f66cce3f$export$e5f174c029ba02b2.displayName = "RepeatIcon";
const $510c9fc2f66cce3f$export$f9d61a2a6155ab51 = $510c9fc2f66cce3f$export$e5f174c029ba02b2;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $069363012ea1cf6c$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M72,104a16,16,0,1,1,16,16A16,16,0,0,1,72,104Zm96,16a16,16,0,1,0-16-16A16,16,0,0,0,168,120Zm68-40V192a36,36,0,0,1-36,36H56a36,36,0,0,1-36-36V80A36,36,0,0,1,56,44h60V16a12,12,0,0,1,24,0V44h60A36,36,0,0,1,236,80Zm-24,0a12,12,0,0,0-12-12H56A12,12,0,0,0,44,80V192a12,12,0,0,0,12,12H200a12,12,0,0,0,12-12Zm-12,82a30,30,0,0,1-30,30H86a30,30,0,0,1,0-60h84A30,30,0,0,1,200,162Zm-80-6v12h16V156ZM86,168H96V156H86a6,6,0,0,0,0,12Zm90-6a6,6,0,0,0-6-6H160v12h10A6,6,0,0,0,176,162Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,56H56A24,24,0,0,0,32,80V192a24,24,0,0,0,24,24H200a24,24,0,0,0,24-24V80A24,24,0,0,0,200,56ZM164,184H92a20,20,0,0,1,0-40h72a20,20,0,0,1,0,40Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,48H136V16a8,8,0,0,0-16,0V48H56A32,32,0,0,0,24,80V192a32,32,0,0,0,32,32H200a32,32,0,0,0,32-32V80A32,32,0,0,0,200,48Zm16,144a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V80A16,16,0,0,1,56,64H200a16,16,0,0,1,16,16ZM72,108a12,12,0,1,1,12,12A12,12,0,0,1,72,108Zm88,0a12,12,0,1,1,12,12A12,12,0,0,1,160,108Zm4,28H92a28,28,0,0,0,0,56h72a28,28,0,0,0,0-56Zm-24,16v24H116V152ZM80,164a12,12,0,0,1,12-12h8v24H92A12,12,0,0,1,80,164Zm84,12h-8V152h8a12,12,0,0,1,0,24Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,48H136V16a8,8,0,0,0-16,0V48H56A32,32,0,0,0,24,80V192a32,32,0,0,0,32,32H200a32,32,0,0,0,32-32V80A32,32,0,0,0,200,48ZM172,96a12,12,0,1,1-12,12A12,12,0,0,1,172,96ZM96,184H80a16,16,0,0,1,0-32H96ZM84,120a12,12,0,1,1,12-12A12,12,0,0,1,84,120Zm60,64H112V152h32Zm32,0H160V152h16a16,16,0,0,1,0,32Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,50H134V16a6,6,0,0,0-12,0V50H56A30,30,0,0,0,26,80V192a30,30,0,0,0,30,30H200a30,30,0,0,0,30-30V80A30,30,0,0,0,200,50Zm18,142a18,18,0,0,1-18,18H56a18,18,0,0,1-18-18V80A18,18,0,0,1,56,62H200a18,18,0,0,1,18,18ZM74,108a10,10,0,1,1,10,10A10,10,0,0,1,74,108Zm88,0a10,10,0,1,1,10,10A10,10,0,0,1,162,108Zm2,30H92a26,26,0,0,0,0,52h72a26,26,0,0,0,0-52Zm-22,12v28H114V150ZM78,164a14,14,0,0,1,14-14h10v28H92A14,14,0,0,1,78,164Zm86,14H154V150h10a14,14,0,0,1,0,28Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,48H136V16a8,8,0,0,0-16,0V48H56A32,32,0,0,0,24,80V192a32,32,0,0,0,32,32H200a32,32,0,0,0,32-32V80A32,32,0,0,0,200,48Zm16,144a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V80A16,16,0,0,1,56,64H200a16,16,0,0,1,16,16Zm-52-56H92a28,28,0,0,0,0,56h72a28,28,0,0,0,0-56Zm-24,16v24H116V152ZM80,164a12,12,0,0,1,12-12h8v24H92A12,12,0,0,1,80,164Zm84,12h-8V152h8a12,12,0,0,1,0,24ZM72,108a12,12,0,1,1,12,12A12,12,0,0,1,72,108Zm88,0a12,12,0,1,1,12,12A12,12,0,0,1,160,108Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,52H132V16a4,4,0,0,0-8,0V52H56A28,28,0,0,0,28,80V192a28,28,0,0,0,28,28H200a28,28,0,0,0,28-28V80A28,28,0,0,0,200,52Zm20,140a20,20,0,0,1-20,20H56a20,20,0,0,1-20-20V80A20,20,0,0,1,56,60H200a20,20,0,0,1,20,20ZM76,108a8,8,0,1,1,8,8A8,8,0,0,1,76,108Zm88,0a8,8,0,1,1,8,8A8,8,0,0,1,164,108Zm0,32H92a24,24,0,0,0,0,48h72a24,24,0,0,0,0-48Zm-20,8v32H112V148ZM76,164a16,16,0,0,1,16-16h12v32H92A16,16,0,0,1,76,164Zm88,16H152V148h12a16,16,0,0,1,0,32Z"
        }))
    ]
]);


const $b6b769c496a9d5ca$export$5db83f67d50796e6 = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...e,
        weights: (0, $069363012ea1cf6c$export$2e2bcd8739ae039)
    }));
$b6b769c496a9d5ca$export$5db83f67d50796e6.displayName = "RobotIcon";
const $b6b769c496a9d5ca$export$20db0c138a037d2a = $b6b769c496a9d5ca$export$5db83f67d50796e6;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $b0cbad97fe96559c$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M227.85,46.89a20,20,0,0,0-18.74-18.74c-13.13-.77-46.65.42-74.48,28.24L131,60H74.36a19.83,19.83,0,0,0-14.14,5.86L25.87,100.19a20,20,0,0,0,11.35,33.95l37.14,5.18,42.32,42.32,5.19,37.18A19.88,19.88,0,0,0,135.34,235a20.13,20.13,0,0,0,6.37,1,19.9,19.9,0,0,0,14.1-5.87l34.34-34.35A19.85,19.85,0,0,0,196,181.64V125l3.6-3.59C227.43,93.54,228.62,60,227.85,46.89ZM76,84h31L75.75,115.28l-27.23-3.8ZM151.6,73.37A72.27,72.27,0,0,1,204,52a72.17,72.17,0,0,1-21.38,52.41L128,159,97,128ZM172,180l-27.49,27.49-3.8-27.23L172,149Zm-72,22c-8.71,11.85-26.19,26-60,26a12,12,0,0,1-12-12c0-33.84,14.12-51.32,26-60A12,12,0,1,1,68.18,175.3C62.3,179.63,55.51,187.8,53,203c15.21-2.51,23.37-9.3,27.7-15.18A12,12,0,1,1,100,202Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184,120v61.65a8,8,0,0,1-2.34,5.65l-34.35,34.35a8,8,0,0,1-13.57-4.53L128,176ZM136,72H74.35a8,8,0,0,0-5.65,2.34L34.35,108.69a8,8,0,0,0,4.53,13.57L80,128ZM40,216c37.65,0,50.69-19.69,54.56-28.18L68.18,161.44C59.69,165.31,40,178.35,40,216Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M223.85,47.12a16,16,0,0,0-15-15c-12.58-.75-44.73.4-71.41,27.07L132.69,64H74.36A15.91,15.91,0,0,0,63,68.68L28.7,103a16,16,0,0,0,9.07,27.16l38.47,5.37,44.21,44.21,5.37,38.49a15.94,15.94,0,0,0,10.78,12.92,16.11,16.11,0,0,0,5.1.83A15.91,15.91,0,0,0,153,227.3L187.32,193A15.91,15.91,0,0,0,192,181.64V123.31l4.77-4.77C223.45,91.86,224.6,59.71,223.85,47.12ZM74.36,80h42.33L77.16,119.52,40,114.34Zm74.41-9.45a76.65,76.65,0,0,1,59.11-22.47,76.46,76.46,0,0,1-22.42,59.16L128,164.68,91.32,128ZM176,181.64,141.67,216l-5.19-37.17L176,139.31Zm-74.16,9.5C97.34,201,82.29,224,40,224a8,8,0,0,1-8-8c0-42.29,23-57.34,32.86-61.85a8,8,0,0,1,6.64,14.56c-6.43,2.93-20.62,12.36-23.12,38.91,26.55-2.5,36-16.69,38.91-23.12a8,8,0,1,1,14.56,6.64Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M101.85,191.14C97.34,201,82.29,224,40,224a8,8,0,0,1-8-8c0-42.29,23-57.34,32.86-61.85a8,8,0,0,1,6.64,14.56c-6.43,2.93-20.62,12.36-23.12,38.91,26.55-2.5,36-16.69,38.91-23.12a8,8,0,1,1,14.56,6.64Zm122-144a16,16,0,0,0-15-15c-12.58-.75-44.73.4-71.4,27.07h0L88,108.7A8,8,0,0,1,76.67,97.39l26.56-26.57A4,4,0,0,0,100.41,64H74.35A15.9,15.9,0,0,0,63,68.68L28.7,103a16,16,0,0,0,9.07,27.16l38.47,5.37,44.21,44.21,5.37,38.49a15.94,15.94,0,0,0,10.78,12.92,16.11,16.11,0,0,0,5.1.83A15.91,15.91,0,0,0,153,227.3L187.32,193A16,16,0,0,0,192,181.65V155.59a4,4,0,0,0-6.83-2.82l-26.57,26.56a8,8,0,0,1-11.71-.42,8.2,8.2,0,0,1,.6-11.1l49.27-49.27h0C223.45,91.86,224.6,59.71,223.85,47.12Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M221.86,47.24a14,14,0,0,0-13.11-13.1c-12.31-.73-43.77.39-69.88,26.5L133.52,66H74.35a13.9,13.9,0,0,0-9.89,4.1L30.11,104.44a14,14,0,0,0,7.94,23.76l39.13,5.46,45.16,45.16L127.8,218a14,14,0,0,0,23.76,7.92l34.35-34.35a13.91,13.91,0,0,0,4.1-9.89V122.48l5.35-5.35h0C221.46,91,222.59,59.56,221.86,47.24ZM38.11,115a2,2,0,0,1,.49-2L72.94,78.58A2,2,0,0,1,74.35,78h47.17L77.87,121.64l-38.14-5.32A1.93,1.93,0,0,1,38.11,115ZM178,181.65a2,2,0,0,1-.59,1.41L143.08,217.4a2,2,0,0,1-3.4-1.11l-5.32-38.16L178,134.48Zm8.87-73h0L128,167.51,88.49,128l58.87-58.88a78.47,78.47,0,0,1,60.69-23A2,2,0,0,1,209.88,48,78.47,78.47,0,0,1,186.88,108.64ZM100,190.31C95.68,199.84,81.13,222,40,222a6,6,0,0,1-6-6c0-41.13,22.16-55.68,31.69-60a6,6,0,1,1,5,10.92c-7,3.17-22.53,13.52-24.47,42.91,29.39-1.94,39.74-17.52,42.91-24.47a6,6,0,1,1,10.92,5Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M223.85,47.12a16,16,0,0,0-15-15c-12.58-.75-44.73.4-71.41,27.07L132.69,64H74.36A15.91,15.91,0,0,0,63,68.68L28.7,103a16,16,0,0,0,9.07,27.16l38.47,5.37,44.21,44.21,5.37,38.49a15.94,15.94,0,0,0,10.78,12.92,16.11,16.11,0,0,0,5.1.83A15.91,15.91,0,0,0,153,227.3L187.32,193A15.91,15.91,0,0,0,192,181.64V123.31l4.77-4.77C223.45,91.86,224.6,59.71,223.85,47.12ZM74.36,80h42.33L77.16,119.52,40,114.34Zm74.41-9.45a76.65,76.65,0,0,1,59.11-22.47,76.46,76.46,0,0,1-22.42,59.16L128,164.68,91.32,128ZM176,181.64,141.67,216l-5.19-37.17L176,139.31Zm-74.16,9.5C97.34,201,82.29,224,40,224a8,8,0,0,1-8-8c0-42.29,23-57.34,32.86-61.85a8,8,0,0,1,6.64,14.56c-6.43,2.93-20.62,12.36-23.12,38.91,26.55-2.5,36-16.69,38.91-23.12a8,8,0,1,1,14.56,6.64Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M219.86,47.36a12,12,0,0,0-11.22-11.22c-12-.71-42.82.38-68.35,25.91L134.35,68h-60a11.9,11.9,0,0,0-8.48,3.52L31.52,105.85a12,12,0,0,0,6.81,20.37l39.79,5.55,46.11,46.11,5.55,39.81a12,12,0,0,0,20.37,6.79l34.34-34.35a11.9,11.9,0,0,0,3.52-8.48v-60l5.94-5.94C219.48,90.18,220.57,59.41,219.86,47.36ZM36.21,115.6a3.94,3.94,0,0,1,1-4.09L71.53,77.17A4,4,0,0,1,74.35,76h52L78.58,123.76,39.44,118.3A3.94,3.94,0,0,1,36.21,115.6ZM180,181.65a4,4,0,0,1-1.17,2.83l-34.35,34.34a4,4,0,0,1-6.79-2.25l-5.46-39.15L180,129.65Zm-52-11.31L85.66,128l60.28-60.29c23.24-23.24,51.25-24.23,62.22-23.58a3.93,3.93,0,0,1,3.71,3.71c.65,11-.35,39-23.58,62.22ZM98.21,189.48C94,198.66,80,220,40,220a4,4,0,0,1-4-4c0-40,21.34-54,30.52-58.21a4,4,0,0,1,3.32,7.28c-7.46,3.41-24.43,14.66-25.76,46.85,32.19-1.33,43.44-18.3,46.85-25.76a4,4,0,1,1,7.28,3.32Z"
        }))
    ]
]);


const $47547f2fd2eb2527$export$ccc8b9cc502aea29 = $7fPBF.forwardRef((e, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...e,
        weights: (0, $b0cbad97fe96559c$export$2e2bcd8739ae039)
    }));
$47547f2fd2eb2527$export$ccc8b9cc502aea29.displayName = "RocketLaunchIcon";
const $47547f2fd2eb2527$export$a45823549b138975 = $47547f2fd2eb2527$export$ccc8b9cc502aea29;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $6fe7ec134a2e7491$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232.49,112.49l-48,48a12,12,0,0,1-17-17L195,116H165a84,84,0,0,0-81.36,63,12,12,0,1,1-23.24-6A107.94,107.94,0,0,1,165,92H195L167.51,64.48a12,12,0,0,1,17-17l48,48A12,12,0,0,1,232.49,112.49ZM192,204H44V88a12,12,0,0,0-24,0V216a12,12,0,0,0,12,12H192a12,12,0,0,0,0-24Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,104l-48,48V56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M229.66,98.34l-48-48A8,8,0,0,0,168,56V96h-3A103.94,103.94,0,0,0,64.25,174a8,8,0,0,0,15.5,4A88,88,0,0,1,165,112h3v40a8,8,0,0,0,13.66,5.66l48-48A8,8,0,0,0,229.66,98.34ZM184,132.69V75.31L212.69,104ZM200,216a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V88a8,8,0,0,1,16,0V208H192A8,8,0,0,1,200,216Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M229.66,109.66l-48,48A8,8,0,0,1,168,152V112h-3a88,88,0,0,0-85.23,66,8,8,0,0,1-15.5-4A103.94,103.94,0,0,1,165,96h3V56a8,8,0,0,1,13.66-5.66l48,48A8,8,0,0,1,229.66,109.66ZM192,208H40V88a8,8,0,0,0-16,0V216a8,8,0,0,0,8,8H192a8,8,0,0,0,0-16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228.24,108.24l-48,48a6,6,0,0,1-8.48-8.48L209.51,110H165a89.94,89.94,0,0,0-87.17,67.5,6,6,0,0,1-11.62-3A101.94,101.94,0,0,1,165,98h44.53L171.76,60.24a6,6,0,0,1,8.48-8.48l48,48A6,6,0,0,1,228.24,108.24ZM192,210H38V88a6,6,0,0,0-12,0V216a6,6,0,0,0,6,6H192a6,6,0,0,0,0-12Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M229.66,109.66l-48,48a8,8,0,0,1-11.32-11.32L204.69,112H165a88,88,0,0,0-85.23,66,8,8,0,0,1-15.5-4A103.94,103.94,0,0,1,165,96h39.71L170.34,61.66a8,8,0,0,1,11.32-11.32l48,48A8,8,0,0,1,229.66,109.66ZM192,208H40V88a8,8,0,0,0-16,0V216a8,8,0,0,0,8,8H192a8,8,0,0,0,0-16Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M226.83,106.83l-48,48a4,4,0,0,1-5.66-5.66L214.34,108H165a92,92,0,0,0-89.11,69A4,4,0,0,1,72,180a3.87,3.87,0,0,1-1-.13A4,4,0,0,1,68.13,175,99.93,99.93,0,0,1,165,100h49.36L173.17,58.83a4,4,0,0,1,5.66-5.66l48,48A4,4,0,0,1,226.83,106.83ZM192,212H36V88a4,4,0,0,0-8,0V216a4,4,0,0,0,4,4H192a4,4,0,0,0,0-8Z"
        }))
    ]
]);


const $281c4dbdb34445c4$export$40148c7db598e4e0 = $7fPBF.forwardRef((r, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: a,
        ...r,
        weights: (0, $6fe7ec134a2e7491$export$2e2bcd8739ae039)
    }));
$281c4dbdb34445c4$export$40148c7db598e4e0.displayName = "ShareIcon";
const $281c4dbdb34445c4$export$c9915453de10000b = $281c4dbdb34445c4$export$40148c7db598e4e0;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $4858b0c107c10dbf$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,36H48A20,20,0,0,0,28,56v56c0,54.29,26.32,87.22,48.4,105.29,23.71,19.39,47.44,26,48.44,26.29a12.1,12.1,0,0,0,6.32,0c1-.28,24.73-6.9,48.44-26.29,22.08-18.07,48.4-51,48.4-105.29V56A20,20,0,0,0,208,36Zm-4,76c0,35.71-13.09,64.69-38.91,86.15A126.28,126.28,0,0,1,128,219.38a126.14,126.14,0,0,1-37.09-21.23C65.09,176.69,52,147.71,52,112V60H204ZM79.51,144.49a12,12,0,1,1,17-17L112,143l47.51-47.52a12,12,0,0,1,17,17l-56,56a12,12,0,0,1-17,0Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,56v56c0,96-88,120-88,120S40,208,40,112V56a8,8,0,0,1,8-8H208A8,8,0,0,1,216,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,40H48A16,16,0,0,0,32,56v56c0,52.72,25.52,84.67,46.93,102.19,23.06,18.86,46,25.26,47,25.53a8,8,0,0,0,4.2,0c1-.27,23.91-6.67,47-25.53C198.48,196.67,224,164.72,224,112V56A16,16,0,0,0,208,40Zm0,72c0,37.07-13.66,67.16-40.6,89.42A129.3,129.3,0,0,1,128,223.62a128.25,128.25,0,0,1-38.92-21.81C61.82,179.51,48,149.3,48,112l0-56,160,0ZM82.34,141.66a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35a8,8,0,0,1,11.32,11.32l-56,56a8,8,0,0,1-11.32,0Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,40H48A16,16,0,0,0,32,56v56c0,52.72,25.52,84.67,46.93,102.19,23.06,18.86,46,25.26,47,25.53a8,8,0,0,0,4.2,0c1-.27,23.91-6.67,47-25.53C198.48,196.67,224,164.72,224,112V56A16,16,0,0,0,208,40Zm-34.32,69.66-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35a8,8,0,0,1,11.32,11.32Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,42H48A14,14,0,0,0,34,56v56c0,51.94,25.12,83.4,46.2,100.64,22.73,18.6,45.27,24.89,46.22,25.15a6,6,0,0,0,3.16,0c.95-.26,23.49-6.55,46.22-25.15C196.88,195.4,222,163.94,222,112V56A14,14,0,0,0,208,42Zm2,70c0,37.76-13.94,68.39-41.44,91.06A131.17,131.17,0,0,1,128,225.72a130.94,130.94,0,0,1-40.56-22.66C59.94,180.39,46,149.76,46,112V56a2,2,0,0,1,2-2H208a2,2,0,0,1,2,2ZM172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,40H48A16,16,0,0,0,32,56v56c0,52.72,25.52,84.67,46.93,102.19,23.06,18.86,46,25.26,47,25.53a8,8,0,0,0,4.2,0c1-.27,23.91-6.67,47-25.53C198.48,196.67,224,164.72,224,112V56A16,16,0,0,0,208,40Zm0,72c0,37.07-13.66,67.16-40.6,89.42A129.3,129.3,0,0,1,128,223.62a128.25,128.25,0,0,1-38.92-21.81C61.82,179.51,48,149.3,48,112l0-56,160,0ZM82.34,141.66a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35a8,8,0,0,1,11.32,11.32l-56,56a8,8,0,0,1-11.32,0Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,44H48A12,12,0,0,0,36,56v56c0,51.16,24.73,82.12,45.47,99.1,22.4,18.32,44.55,24.5,45.48,24.76a4,4,0,0,0,2.1,0c.93-.26,23.08-6.44,45.48-24.76,20.74-17,45.47-47.94,45.47-99.1V56A12,12,0,0,0,208,44Zm4,68c0,38.44-14.23,69.63-42.29,92.71A132.45,132.45,0,0,1,128,227.82a132.23,132.23,0,0,1-41.71-23.11C58.23,181.63,44,150.44,44,112V56a4,4,0,0,1,4-4H208a4,4,0,0,1,4,4Zm-41.17-10.83a4,4,0,0,1,0,5.66l-56,56a4,4,0,0,1-5.66,0l-24-24a4,4,0,0,1,5.66-5.66L112,154.34l53.17-53.17A4,4,0,0,1,170.83,101.17Z"
        }))
    ]
]);


const $b8a6231e5abb5624$export$da01a61080044588 = $7fPBF.forwardRef((c, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...c,
        weights: (0, $4858b0c107c10dbf$export$2e2bcd8739ae039)
    }));
$b8a6231e5abb5624$export$da01a61080044588.displayName = "ShieldCheckIcon";
const $b8a6231e5abb5624$export$ff080d18434a146e = $b8a6231e5abb5624$export$da01a61080044588;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $0b4cfe2f4b3c9a9c$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M76.86,115.54a12,12,0,0,1,15.6-6.68L116,118.28V96a12,12,0,0,1,24,0v22.28l23.54-9.42a12,12,0,0,1,8.92,22.28L147,141.33,161.6,160.8a12,12,0,1,1-19.2,14.4L128,156l-14.4,19.2a12,12,0,1,1-19.2-14.4L109,141.33,83.54,131.14A12,12,0,0,1,76.86,115.54ZM228,56v56c0,54.29-26.32,87.22-48.4,105.29-23.71,19.39-47.44,26-48.44,26.29a12.1,12.1,0,0,1-6.32,0c-1-.28-24.73-6.9-48.44-26.29C54.32,199.22,28,166.29,28,112V56A20,20,0,0,1,48,36H208A20,20,0,0,1,228,56Zm-24,4H52v52c0,35.71,13.09,64.69,38.91,86.15A126.14,126.14,0,0,0,128,219.38a126.28,126.28,0,0,0,37.09-21.23C190.91,176.69,204,147.71,204,112Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,56v56c0,96-88,120-88,120S40,208,40,112V56a8,8,0,0,1,8-8H208A8,8,0,0,1,216,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M80.57,117A8,8,0,0,1,91,112.57l29,11.61V96a8,8,0,0,1,16,0v28.18l29-11.61A8,8,0,1,1,171,127.43l-30.31,12.12L158.4,163.2a8,8,0,1,1-12.8,9.6L128,149.33,110.4,172.8a8,8,0,1,1-12.8-9.6l17.74-23.65L85,127.43A8,8,0,0,1,80.57,117ZM224,56v56c0,52.72-25.52,84.67-46.93,102.19-23.06,18.86-46,25.27-47,25.53a8,8,0,0,1-4.2,0c-1-.26-23.91-6.67-47-25.53C57.52,196.67,32,164.72,32,112V56A16,16,0,0,1,48,40H208A16,16,0,0,1,224,56Zm-16,0L48,56l0,56c0,37.3,13.82,67.51,41.07,89.81A128.25,128.25,0,0,0,128,223.62a129.3,129.3,0,0,0,39.41-22.2C194.34,179.16,208,149.07,208,112Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,40H48A16,16,0,0,0,32,56v56c0,52.72,25.52,84.67,46.93,102.19,23.06,18.86,46,25.27,47,25.53a8,8,0,0,0,4.2,0c1-.26,23.91-6.67,47-25.53C198.48,196.67,224,164.72,224,112V56A16,16,0,0,0,208,40Zm-37,87.43-30.31,12.12L158.4,163.2a8,8,0,1,1-12.8,9.6L128,149.33,110.4,172.8a8,8,0,1,1-12.8-9.6l17.74-23.65L85,127.43A8,8,0,1,1,91,112.57l29,11.61V96a8,8,0,0,1,16,0v28.18l29-11.61A8,8,0,1,1,171,127.43Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M173.57,117.77a6,6,0,0,1-3.34,7.8L137.5,138.66l19.3,25.74a6,6,0,0,1-9.6,7.2L128,146l-19.2,25.6a6,6,0,1,1-9.6-7.2l19.3-25.74L85.77,125.57a6,6,0,0,1,4.46-11.14L122,127.14V96a6,6,0,0,1,12,0v31.14l31.77-12.71A6,6,0,0,1,173.57,117.77ZM222,56v56c0,51.94-25.12,83.4-46.2,100.64-22.73,18.6-45.27,24.89-46.22,25.15a6,6,0,0,1-3.16,0c-1-.26-23.49-6.55-46.22-25.15C59.12,195.4,34,163.94,34,112V56A14,14,0,0,1,48,42H208A14,14,0,0,1,222,56Zm-12,0a2,2,0,0,0-2-2H48a2,2,0,0,0-2,2v56c0,37.75,13.94,68.39,41.44,91.06A130.94,130.94,0,0,0,128,225.72a131.17,131.17,0,0,0,40.56-22.66C196.06,180.39,210,149.75,210,112Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M80.57,117A8,8,0,0,1,91,112.57l29,11.61V96a8,8,0,0,1,16,0v28.18l29-11.61A8,8,0,1,1,171,127.43l-30.31,12.12L158.4,163.2a8,8,0,1,1-12.8,9.6L128,149.33,110.4,172.8a8,8,0,1,1-12.8-9.6l17.74-23.65L85,127.43A8,8,0,0,1,80.57,117ZM224,56v56c0,52.72-25.52,84.67-46.93,102.19-23.06,18.86-46,25.27-47,25.53a8,8,0,0,1-4.2,0c-1-.26-23.91-6.67-47-25.53C57.52,196.67,32,164.72,32,112V56A16,16,0,0,1,48,40H208A16,16,0,0,1,224,56Zm-16,0L48,56l0,56c0,37.3,13.82,67.51,41.07,89.81A128.25,128.25,0,0,0,128,223.62a129.3,129.3,0,0,0,39.41-22.2C194.34,179.16,208,149.07,208,112Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M171.71,118.51a4,4,0,0,1-2.22,5.2l-35.16,14.07L155.2,165.6a4,4,0,1,1-6.4,4.8L128,142.67,107.2,170.4a4,4,0,0,1-6.4-4.8l20.87-27.82L86.51,123.71a4,4,0,1,1,3-7.42L124,130.09V96a4,4,0,0,1,8,0v34.09l34.51-13.8A4,4,0,0,1,171.71,118.51ZM220,56v56c0,51.16-24.73,82.12-45.47,99.1-22.4,18.32-44.55,24.5-45.48,24.76a4,4,0,0,1-2.1,0c-.93-.26-23.08-6.44-45.48-24.76C60.73,194.12,36,163.16,36,112V56A12,12,0,0,1,48,44H208A12,12,0,0,1,220,56Zm-8,0a4,4,0,0,0-4-4H48a4,4,0,0,0-4,4v56c0,38.44,14.23,69.63,42.29,92.71A132.23,132.23,0,0,0,128,227.82a132.45,132.45,0,0,0,41.71-23.11C197.77,181.63,212,150.44,212,112Z"
        }))
    ]
]);


const $380b00235de4079c$export$2d4a0edcdd78d72c = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...r,
        weights: (0, $0b4cfe2f4b3c9a9c$export$2e2bcd8739ae039)
    }));
$380b00235de4079c$export$2d4a0edcdd78d72c.displayName = "ShieldStarIcon";
const $380b00235de4079c$export$b6b65c1d96069232 = $380b00235de4079c$export$2d4a0edcdd78d72c;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $27387059d51822ae$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M124,216a12,12,0,0,1-12,12H48a12,12,0,0,1-12-12V40A12,12,0,0,1,48,28h64a12,12,0,0,1,0,24H60V204h52A12,12,0,0,1,124,216Zm108.49-96.49-40-40a12,12,0,0,0-17,17L195,116H112a12,12,0,0,0,0,24h83l-19.52,19.51a12,12,0,0,0,17,17l40-40A12,12,0,0,0,232.49,119.51Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,56V200a16,16,0,0,1-16,16H48V40H208A16,16,0,0,1,224,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M120,216a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H56V208h56A8,8,0,0,1,120,216Zm109.66-93.66-40-40a8,8,0,0,0-11.32,11.32L204.69,120H112a8,8,0,0,0,0,16h92.69l-26.35,26.34a8,8,0,0,0,11.32,11.32l40-40A8,8,0,0,0,229.66,122.34Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M120,216a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H56V208h56A8,8,0,0,1,120,216Zm109.66-93.66-40-40A8,8,0,0,0,176,88v32H112a8,8,0,0,0,0,16h64v32a8,8,0,0,0,13.66,5.66l40-40A8,8,0,0,0,229.66,122.34Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M118,216a6,6,0,0,1-6,6H48a6,6,0,0,1-6-6V40a6,6,0,0,1,6-6h64a6,6,0,0,1,0,12H54V210h58A6,6,0,0,1,118,216Zm110.24-92.24-40-40a6,6,0,0,0-8.48,8.48L209.51,122H112a6,6,0,0,0,0,12h97.51l-29.75,29.76a6,6,0,1,0,8.48,8.48l40-40A6,6,0,0,0,228.24,123.76Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M120,216a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H56V208h56A8,8,0,0,1,120,216Zm109.66-93.66-40-40a8,8,0,0,0-11.32,11.32L204.69,120H112a8,8,0,0,0,0,16h92.69l-26.35,26.34a8,8,0,0,0,11.32,11.32l40-40A8,8,0,0,0,229.66,122.34Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M116,216a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V40a4,4,0,0,1,4-4h64a4,4,0,0,1,0,8H52V212h60A4,4,0,0,1,116,216Zm110.83-90.83-40-40a4,4,0,0,0-5.66,5.66L214.34,124H112a4,4,0,0,0,0,8H214.34l-33.17,33.17a4,4,0,0,0,5.66,5.66l40-40A4,4,0,0,0,226.83,125.17Z"
        }))
    ]
]);


const $91f7b26fb1a24ddc$export$5bb2595dc31bfece = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...e,
        weights: (0, $27387059d51822ae$export$2e2bcd8739ae039)
    }));
$91f7b26fb1a24ddc$export$5bb2595dc31bfece.displayName = "SignOutIcon";
const $91f7b26fb1a24ddc$export$8bdd9b9a27ab4764 = $91f7b26fb1a24ddc$export$5bb2595dc31bfece;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $9bf2e1cb9d8049c3$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M199,125.31l-49.88-18.39L130.69,57a19.92,19.92,0,0,0-37.38,0L74.92,106.92,25,125.31a19.92,19.92,0,0,0,0,37.38l49.88,18.39L93.31,231a19.92,19.92,0,0,0,37.38,0l18.39-49.88L199,162.69a19.92,19.92,0,0,0,0-37.38Zm-63.38,35.16a12,12,0,0,0-7.11,7.11L112,212.28l-16.47-44.7a12,12,0,0,0-7.11-7.11L43.72,144l44.7-16.47a12,12,0,0,0,7.11-7.11L112,75.72l16.47,44.7a12,12,0,0,0,7.11,7.11L180.28,144ZM140,40a12,12,0,0,1,12-12h12V16a12,12,0,0,1,24,0V28h12a12,12,0,0,1,0,24H188V64a12,12,0,0,1-24,0V52H152A12,12,0,0,1,140,40ZM252,88a12,12,0,0,1-12,12h-4v4a12,12,0,0,1-24,0v-4h-4a12,12,0,0,1,0-24h4V72a12,12,0,0,1,24,0v4h4A12,12,0,0,1,252,88Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M194.82,151.43l-55.09,20.3-20.3,55.09a7.92,7.92,0,0,1-14.86,0l-20.3-55.09-55.09-20.3a7.92,7.92,0,0,1,0-14.86l55.09-20.3,20.3-55.09a7.92,7.92,0,0,1,14.86,0l20.3,55.09,55.09,20.3A7.92,7.92,0,0,1,194.82,151.43Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M197.58,129.06,146,110l-19-51.62a15.92,15.92,0,0,0-29.88,0L78,110l-51.62,19a15.92,15.92,0,0,0,0,29.88L78,178l19,51.62a15.92,15.92,0,0,0,29.88,0L146,178l51.62-19a15.92,15.92,0,0,0,0-29.88ZM137,164.22a8,8,0,0,0-4.74,4.74L112,223.85,91.78,169A8,8,0,0,0,87,164.22L32.15,144,87,123.78A8,8,0,0,0,91.78,119L112,64.15,132.22,119a8,8,0,0,0,4.74,4.74L191.85,144ZM144,40a8,8,0,0,1,8-8h16V16a8,8,0,0,1,16,0V32h16a8,8,0,0,1,0,16H184V64a8,8,0,0,1-16,0V48H152A8,8,0,0,1,144,40ZM248,88a8,8,0,0,1-8,8h-8v8a8,8,0,0,1-16,0V96h-8a8,8,0,0,1,0-16h8V72a8,8,0,0,1,16,0v8h8A8,8,0,0,1,248,88Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,144a15.78,15.78,0,0,1-10.42,14.94L146,178l-19,51.62a15.92,15.92,0,0,1-29.88,0L78,178l-51.62-19a15.92,15.92,0,0,1,0-29.88L78,110l19-51.62a15.92,15.92,0,0,1,29.88,0L146,110l51.62,19A15.78,15.78,0,0,1,208,144ZM152,48h16V64a8,8,0,0,0,16,0V48h16a8,8,0,0,0,0-16H184V16a8,8,0,0,0-16,0V32H152a8,8,0,0,0,0,16Zm88,32h-8V72a8,8,0,0,0-16,0v8h-8a8,8,0,0,0,0,16h8v8a8,8,0,0,0,16,0V96h8a8,8,0,0,0,0-16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M196.89,130.94,144.4,111.6,125.06,59.11a13.92,13.92,0,0,0-26.12,0L79.6,111.6,27.11,130.94a13.92,13.92,0,0,0,0,26.12L79.6,176.4l19.34,52.49a13.92,13.92,0,0,0,26.12,0L144.4,176.4l52.49-19.34a13.92,13.92,0,0,0,0-26.12Zm-4.15,14.86-55.08,20.3a6,6,0,0,0-3.56,3.56l-20.3,55.08a1.92,1.92,0,0,1-3.6,0L89.9,169.66a6,6,0,0,0-3.56-3.56L31.26,145.8a1.92,1.92,0,0,1,0-3.6l55.08-20.3a6,6,0,0,0,3.56-3.56l20.3-55.08a1.92,1.92,0,0,1,3.6,0l20.3,55.08a6,6,0,0,0,3.56,3.56l55.08,20.3a1.92,1.92,0,0,1,0,3.6ZM146,40a6,6,0,0,1,6-6h18V16a6,6,0,0,1,12,0V34h18a6,6,0,0,1,0,12H182V64a6,6,0,0,1-12,0V46H152A6,6,0,0,1,146,40ZM246,88a6,6,0,0,1-6,6H230v10a6,6,0,0,1-12,0V94H208a6,6,0,0,1,0-12h10V72a6,6,0,0,1,12,0V82h10A6,6,0,0,1,246,88Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M197.58,129.06,146,110l-19-51.62a15.92,15.92,0,0,0-29.88,0L78,110l-51.62,19a15.92,15.92,0,0,0,0,29.88L78,178l19,51.62a15.92,15.92,0,0,0,29.88,0L146,178l51.62-19a15.92,15.92,0,0,0,0-29.88ZM137,164.22a8,8,0,0,0-4.74,4.74L112,223.85,91.78,169A8,8,0,0,0,87,164.22L32.15,144,87,123.78A8,8,0,0,0,91.78,119L112,64.15,132.22,119a8,8,0,0,0,4.74,4.74L191.85,144ZM144,40a8,8,0,0,1,8-8h16V16a8,8,0,0,1,16,0V32h16a8,8,0,0,1,0,16H184V64a8,8,0,0,1-16,0V48H152A8,8,0,0,1,144,40ZM248,88a8,8,0,0,1-8,8h-8v8a8,8,0,0,1-16,0V96h-8a8,8,0,0,1,0-16h8V72a8,8,0,0,1,16,0v8h8A8,8,0,0,1,248,88Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M196.2,132.81l-53.36-19.65L123.19,59.8a11.93,11.93,0,0,0-22.38,0L81.16,113.16,27.8,132.81a11.93,11.93,0,0,0,0,22.38l53.36,19.65,19.65,53.36a11.93,11.93,0,0,0,22.38,0l19.65-53.36,53.36-19.65a11.93,11.93,0,0,0,0-22.38Zm-2.77,14.87L138.35,168a4,4,0,0,0-2.37,2.37l-20.3,55.08a3.92,3.92,0,0,1-7.36,0L88,170.35A4,4,0,0,0,85.65,168l-55.08-20.3a3.92,3.92,0,0,1,0-7.36L85.65,120A4,4,0,0,0,88,117.65l20.3-55.08a3.92,3.92,0,0,1,7.36,0L136,117.65a4,4,0,0,0,2.37,2.37l55.08,20.3a3.92,3.92,0,0,1,0,7.36ZM148,40a4,4,0,0,1,4-4h20V16a4,4,0,0,1,8,0V36h20a4,4,0,0,1,0,8H180V64a4,4,0,0,1-8,0V44H152A4,4,0,0,1,148,40Zm96,48a4,4,0,0,1-4,4H228v12a4,4,0,0,1-8,0V92H208a4,4,0,0,1,0-8h12V72a4,4,0,0,1,8,0V84h12A4,4,0,0,1,244,88Z"
        }))
    ]
]);


const $8899997e3fc20429$export$1019ff5537a7252e = $7fPBF.forwardRef((r, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: a,
        ...r,
        weights: (0, $9bf2e1cb9d8049c3$export$2e2bcd8739ae039)
    }));
$8899997e3fc20429$export$1019ff5537a7252e.displayName = "SparkleIcon";
const $8899997e3fc20429$export$d350d3100fdc0b49 = $8899997e3fc20429$export$1019ff5537a7252e;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $e0d4ef5bb1c55d5b$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M157.27,21.22a12,12,0,0,0-12.64,1.31L75.88,76H32A20,20,0,0,0,12,96v64a20,20,0,0,0,20,20H75.88l68.75,53.47A12,12,0,0,0,164,224V32A12,12,0,0,0,157.27,21.22ZM36,100H68v56H36Zm104,99.46L92,162.13V93.87l48-37.33ZM212,128a44,44,0,0,1-11,29.11,12,12,0,1,1-18-15.88,20,20,0,0,0,0-26.43,12,12,0,0,1,18-15.86A43.94,43.94,0,0,1,212,128Zm40,0a83.87,83.87,0,0,1-21.39,56,12,12,0,0,1-17.89-16,60,60,0,0,0,0-80,12,12,0,1,1,17.88-16A83.87,83.87,0,0,1,252,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M80,88v80H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M155.51,24.81a8,8,0,0,0-8.42.88L77.25,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.25l69.84,54.31A8,8,0,0,0,160,224V32A8,8,0,0,0,155.51,24.81ZM32,96H72v64H32ZM144,207.64,88,164.09V91.91l56-43.55Zm54-106.08a40,40,0,0,1,0,52.88,8,8,0,0,1-12-10.58,24,24,0,0,0,0-31.72,8,8,0,0,1,12-10.58ZM248,128a79.9,79.9,0,0,1-20.37,53.34,8,8,0,0,1-11.92-10.67,64,64,0,0,0,0-85.33,8,8,0,1,1,11.92-10.67A79.83,79.83,0,0,1,248,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M160,32.25V223.69a8.29,8.29,0,0,1-3.91,7.18,8,8,0,0,1-9-.56l-65.57-51A4,4,0,0,1,80,176.16V79.84a4,4,0,0,1,1.55-3.15l65.57-51a8,8,0,0,1,10,.16A8.27,8.27,0,0,1,160,32.25ZM60,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H60a4,4,0,0,0,4-4V84A4,4,0,0,0,60,80Zm126.77,20.84a8,8,0,0,0-.72,11.3,24,24,0,0,1,0,31.72,8,8,0,1,0,12,10.58,40,40,0,0,0,0-52.88A8,8,0,0,0,186.74,100.84Zm40.89-26.17a8,8,0,1,0-11.92,10.66,64,64,0,0,1,0,85.34,8,8,0,1,0,11.92,10.66,80,80,0,0,0,0-106.66Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M154.64,26.61a6,6,0,0,0-6.32.65L77.94,82H32A14,14,0,0,0,18,96v64a14,14,0,0,0,14,14H77.94l70.38,54.74A6,6,0,0,0,158,224V32A6,6,0,0,0,154.64,26.61ZM30,160V96a2,2,0,0,1,2-2H74v68H32A2,2,0,0,1,30,160Zm116,51.73L86,165.07V90.93l60-46.66Zm50.53-108.85a38,38,0,0,1,0,50.24,6,6,0,1,1-9-7.94,26,26,0,0,0,0-34.37,6,6,0,0,1,9-7.93ZM246,128a77.86,77.86,0,0,1-19.86,52,6,6,0,1,1-8.94-8,66,66,0,0,0,0-88,6,6,0,1,1,8.94-8A77.86,77.86,0,0,1,246,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M155.51,24.81a8,8,0,0,0-8.42.88L77.25,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.25l69.84,54.31A8,8,0,0,0,160,224V32A8,8,0,0,0,155.51,24.81ZM32,96H72v64H32ZM144,207.64,88,164.09V91.91l56-43.55Zm54-106.08a40,40,0,0,1,0,52.88,8,8,0,0,1-12-10.58,24,24,0,0,0,0-31.72,8,8,0,0,1,12-10.58ZM248,128a79.9,79.9,0,0,1-20.37,53.34,8,8,0,0,1-11.92-10.67,64,64,0,0,0,0-85.33,8,8,0,1,1,11.92-10.67A79.83,79.83,0,0,1,248,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M153.76,28.41a4,4,0,0,0-4.22.43L78.63,84H32A12,12,0,0,0,20,96v64a12,12,0,0,0,12,12H78.63l70.91,55.16A4.07,4.07,0,0,0,152,228a3.92,3.92,0,0,0,1.76-.41A4,4,0,0,0,156,224V32A4,4,0,0,0,153.76,28.41ZM28,160V96a4,4,0,0,1,4-4H76v72H32A4,4,0,0,1,28,160Zm120,55.82L84,166V90l64-49.78Zm47-111.61a36,36,0,0,1,0,47.59,4,4,0,1,1-6-5.3,28,28,0,0,0,0-37,4,4,0,0,1,6-5.28ZM244,128a75.88,75.88,0,0,1-19.35,50.67,4,4,0,0,1-6-5.34,68,68,0,0,0,0-90.66,4,4,0,0,1,6-5.34A75.88,75.88,0,0,1,244,128Z"
        }))
    ]
]);


const $0972bbebf39666e5$export$951b168b9ecc05fb = $7fPBF.forwardRef((r, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: a,
        ...r,
        weights: (0, $e0d4ef5bb1c55d5b$export$2e2bcd8739ae039)
    }));
$0972bbebf39666e5$export$951b168b9ecc05fb.displayName = "SpeakerHighIcon";
const $0972bbebf39666e5$export$72b5f9f618bcd07d = $0972bbebf39666e5$export$951b168b9ecc05fb;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $7fa1d8e4c3340448$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,36H56A20,20,0,0,0,36,56V200a20,20,0,0,0,20,20H200a20,20,0,0,0,20-20V56A20,20,0,0,0,200,36Zm-60,64h56v16H140Zm0,40h56v16H140Zm56-64H140V60h56ZM60,60h56V196H60Zm80,136V180h56v16Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,56V200a8,8,0,0,1-8,8H128V48h72A8,8,0,0,1,208,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,40H56A16,16,0,0,0,40,56V200a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40ZM56,56h64V200H56ZM200,200H136V56h64V200Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,40H56A16,16,0,0,0,40,56V200a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40ZM56,56h72V200H56Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,42H56A14,14,0,0,0,42,56V200a14,14,0,0,0,14,14H200a14,14,0,0,0,14-14V56A14,14,0,0,0,200,42Zm-66,76h68v20H134Zm0-12V86h68v20Zm0,44h68v20H134Zm68-94V74H134V54h66A2,2,0,0,1,202,56ZM54,200V56a2,2,0,0,1,2-2h66V202H56A2,2,0,0,1,54,200Zm146,2H134V182h68v18A2,2,0,0,1,200,202Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,40H56A16,16,0,0,0,40,56V200a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40Zm-64,80h64v16H136Zm0-16V88h64v16Zm0,48h64v16H136Zm64-80H136V56h64ZM56,56h64V200H56ZM200,200H136V184h64v16Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,44H56A12,12,0,0,0,44,56V200a12,12,0,0,0,12,12H200a12,12,0,0,0,12-12V56A12,12,0,0,0,200,44Zm-68,72h72v24H132Zm0-8V84h72v24Zm0,40h72v24H132Zm72-92V76H132V52h68A4,4,0,0,1,204,56ZM52,200V56a4,4,0,0,1,4-4h68V204H56A4,4,0,0,1,52,200Zm148,4H132V180h72v20A4,4,0,0,1,200,204Z"
        }))
    ]
]);


const $5fffe8c4dc33c750$export$8e4e0663d737f944 = $7fPBF.forwardRef((o, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...o,
        weights: (0, $7fa1d8e4c3340448$export$2e2bcd8739ae039)
    }));
$5fffe8c4dc33c750$export$8e4e0663d737f944.displayName = "SquareHalfIcon";
const $5fffe8c4dc33c750$export$4f91063f4b4992b2 = $5fffe8c4dc33c750$export$8e4e0663d737f944;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $cad6c7dad7d6db52$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M100,36H56A20,20,0,0,0,36,56v44a20,20,0,0,0,20,20h44a20,20,0,0,0,20-20V56A20,20,0,0,0,100,36ZM96,96H60V60H96ZM200,36H156a20,20,0,0,0-20,20v44a20,20,0,0,0,20,20h44a20,20,0,0,0,20-20V56A20,20,0,0,0,200,36Zm-4,60H160V60h36Zm-96,40H56a20,20,0,0,0-20,20v44a20,20,0,0,0,20,20h44a20,20,0,0,0,20-20V156A20,20,0,0,0,100,136Zm-4,60H60V160H96Zm104-60H156a20,20,0,0,0-20,20v44a20,20,0,0,0,20,20h44a20,20,0,0,0,20-20V156A20,20,0,0,0,200,136Zm-4,60H160V160h36Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M112,56v48a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h48A8,8,0,0,1,112,56Zm88-8H152a8,8,0,0,0-8,8v48a8,8,0,0,0,8,8h48a8,8,0,0,0,8-8V56A8,8,0,0,0,200,48Zm-96,96H56a8,8,0,0,0-8,8v48a8,8,0,0,0,8,8h48a8,8,0,0,0,8-8V152A8,8,0,0,0,104,144Zm96,0H152a8,8,0,0,0-8,8v48a8,8,0,0,0,8,8h48a8,8,0,0,0,8-8V152A8,8,0,0,0,200,144Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,136H152a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V152A16,16,0,0,0,200,136Zm0,64H152V152h48v48ZM104,40H56A16,16,0,0,0,40,56v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V56A16,16,0,0,0,104,40Zm0,64H56V56h48v48Zm96-64H152a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40Zm0,64H152V56h48v48Zm-96,32H56a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V152A16,16,0,0,0,104,136Zm0,64H56V152h48v48Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M120,56v48a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V56A16,16,0,0,1,56,40h48A16,16,0,0,1,120,56Zm80-16H152a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40Zm-96,96H56a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V152A16,16,0,0,0,104,136Zm96,0H152a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V152A16,16,0,0,0,200,136Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M104,42H56A14,14,0,0,0,42,56v48a14,14,0,0,0,14,14h48a14,14,0,0,0,14-14V56A14,14,0,0,0,104,42Zm2,62a2,2,0,0,1-2,2H56a2,2,0,0,1-2-2V56a2,2,0,0,1,2-2h48a2,2,0,0,1,2,2Zm94-62H152a14,14,0,0,0-14,14v48a14,14,0,0,0,14,14h48a14,14,0,0,0,14-14V56A14,14,0,0,0,200,42Zm2,62a2,2,0,0,1-2,2H152a2,2,0,0,1-2-2V56a2,2,0,0,1,2-2h48a2,2,0,0,1,2,2Zm-98,34H56a14,14,0,0,0-14,14v48a14,14,0,0,0,14,14h48a14,14,0,0,0,14-14V152A14,14,0,0,0,104,138Zm2,62a2,2,0,0,1-2,2H56a2,2,0,0,1-2-2V152a2,2,0,0,1,2-2h48a2,2,0,0,1,2,2Zm94-62H152a14,14,0,0,0-14,14v48a14,14,0,0,0,14,14h48a14,14,0,0,0,14-14V152A14,14,0,0,0,200,138Zm2,62a2,2,0,0,1-2,2H152a2,2,0,0,1-2-2V152a2,2,0,0,1,2-2h48a2,2,0,0,1,2,2Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M104,40H56A16,16,0,0,0,40,56v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V56A16,16,0,0,0,104,40Zm0,64H56V56h48v48Zm96-64H152a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40Zm0,64H152V56h48v48Zm-96,32H56a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V152A16,16,0,0,0,104,136Zm0,64H56V152h48v48Zm96-64H152a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V152A16,16,0,0,0,200,136Zm0,64H152V152h48v48Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M104,44H56A12,12,0,0,0,44,56v48a12,12,0,0,0,12,12h48a12,12,0,0,0,12-12V56A12,12,0,0,0,104,44Zm4,60a4,4,0,0,1-4,4H56a4,4,0,0,1-4-4V56a4,4,0,0,1,4-4h48a4,4,0,0,1,4,4Zm92-60H152a12,12,0,0,0-12,12v48a12,12,0,0,0,12,12h48a12,12,0,0,0,12-12V56A12,12,0,0,0,200,44Zm4,60a4,4,0,0,1-4,4H152a4,4,0,0,1-4-4V56a4,4,0,0,1,4-4h48a4,4,0,0,1,4,4ZM104,140H56a12,12,0,0,0-12,12v48a12,12,0,0,0,12,12h48a12,12,0,0,0,12-12V152A12,12,0,0,0,104,140Zm4,60a4,4,0,0,1-4,4H56a4,4,0,0,1-4-4V152a4,4,0,0,1,4-4h48a4,4,0,0,1,4,4Zm92-60H152a12,12,0,0,0-12,12v48a12,12,0,0,0,12,12h48a12,12,0,0,0,12-12V152A12,12,0,0,0,200,140Zm4,60a4,4,0,0,1-4,4H152a4,4,0,0,1-4-4V152a4,4,0,0,1,4-4h48a4,4,0,0,1,4,4Z"
        }))
    ]
]);


const $ffc30300995f8d60$export$aa8679e33ed2ffa0 = $7fPBF.forwardRef((e, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: a,
        ...e,
        weights: (0, $cad6c7dad7d6db52$export$2e2bcd8739ae039)
    }));
$ffc30300995f8d60$export$aa8679e33ed2ffa0.displayName = "SquaresFourIcon";
const $ffc30300995f8d60$export$efa0fa8f18fa8e5a = $ffc30300995f8d60$export$aa8679e33ed2ffa0;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $890b1c36b36ed348$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M234.36,170A12,12,0,0,1,230,186.37l-96,56a12,12,0,0,1-12.1,0l-96-56a12,12,0,0,1,12.09-20.74l90,52.48L218,165.63A12,12,0,0,1,234.36,170ZM218,117.63,128,170.11,38.05,117.63A12,12,0,0,0,26,138.37l96,56a12,12,0,0,0,12.1,0l96-56A12,12,0,0,0,218,117.63ZM20,80a12,12,0,0,1,6-10.37l96-56a12.06,12.06,0,0,1,12.1,0l96,56a12,12,0,0,1,0,20.74l-96,56a12,12,0,0,1-12.1,0l-96-56A12,12,0,0,1,20,80Zm35.82,0L128,122.11,200.18,80,128,37.89Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,80l-96,56L32,80l96-56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M230.91,172A8,8,0,0,1,228,182.91l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,36,169.09l92,53.65,92-53.65A8,8,0,0,1,230.91,172ZM220,121.09l-92,53.65L36,121.09A8,8,0,0,0,28,134.91l96,56a8,8,0,0,0,8.06,0l96-56A8,8,0,1,0,220,121.09ZM24,80a8,8,0,0,1,4-6.91l96-56a8,8,0,0,1,8.06,0l96,56a8,8,0,0,1,0,13.82l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,24,80Zm23.88,0L128,126.74,208.12,80,128,33.26Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220,169.09l-92,53.65L36,169.09A8,8,0,0,0,28,182.91l96,56a8,8,0,0,0,8.06,0l96-56A8,8,0,1,0,220,169.09Z"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220,121.09l-92,53.65L36,121.09A8,8,0,0,0,28,134.91l96,56a8,8,0,0,0,8.06,0l96-56A8,8,0,1,0,220,121.09Z"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M28,86.91l96,56a8,8,0,0,0,8.06,0l96-56a8,8,0,0,0,0-13.82l-96-56a8,8,0,0,0-8.06,0l-96,56a8,8,0,0,0,0,13.82Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M229.18,173a6,6,0,0,1-2.16,8.2l-96,56a6,6,0,0,1-6,0l-96-56a6,6,0,0,1,6-10.36l93,54.23,93-54.23A6,6,0,0,1,229.18,173ZM221,122.82l-93,54.23L35,122.82a6,6,0,0,0-6,10.36l96,56a6,6,0,0,0,6,0l96-56a6,6,0,0,0-6-10.36ZM26,80a6,6,0,0,1,3-5.18l96-56a6,6,0,0,1,6,0l96,56a6,6,0,0,1,0,10.36l-96,56a6,6,0,0,1-6,0l-96-56A6,6,0,0,1,26,80Zm17.91,0L128,129.05,212.09,80,128,31Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M230.91,172A8,8,0,0,1,228,182.91l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,36,169.09l92,53.65,92-53.65A8,8,0,0,1,230.91,172ZM220,121.09l-92,53.65L36,121.09A8,8,0,0,0,28,134.91l96,56a8,8,0,0,0,8.06,0l96-56A8,8,0,1,0,220,121.09ZM24,80a8,8,0,0,1,4-6.91l96-56a8,8,0,0,1,8.06,0l96,56a8,8,0,0,1,0,13.82l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,24,80Zm23.88,0L128,126.74,208.12,80,128,33.26Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M227.45,174a4,4,0,0,1-1.44,5.48l-96,56a4,4,0,0,1-4,0l-96-56a4,4,0,0,1,4-6.92l94,54.83,94-54.83A4,4,0,0,1,227.45,174ZM222,124.54l-94,54.83L34,124.54a4,4,0,0,0-4,6.92l96,56a4,4,0,0,0,4,0l96-56a4,4,0,0,0-4-6.92ZM28,80a4,4,0,0,1,2-3.46l96-56a4,4,0,0,1,4,0l96,56a4,4,0,0,1,0,6.92l-96,56a4,4,0,0,1-4,0l-96-56A4,4,0,0,1,28,80Zm11.94,0L128,131.37,216.06,80,128,28.63Z"
        }))
    ]
]);


const $23259387cb66f7b3$export$f95b8a41f9121b54 = $7fPBF.forwardRef((a, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: c,
        ...a,
        weights: (0, $890b1c36b36ed348$export$2e2bcd8739ae039)
    }));
$23259387cb66f7b3$export$f95b8a41f9121b54.displayName = "StackIcon";
const $23259387cb66f7b3$export$694e0d28c7ffc90c = $23259387cb66f7b3$export$f95b8a41f9121b54;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $55de31233c3e3c07$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240,200a12,12,0,0,1-12,12H188a12,12,0,0,1,0-24h40A12,12,0,0,1,240,200ZM218,117.63,128,170.11,38.05,117.63A12,12,0,0,0,26,138.37l96,56a12,12,0,0,0,12.1,0l96-56A12,12,0,1,0,218,117.63ZM20,80a12,12,0,0,1,6-10.37l96-56a12.06,12.06,0,0,1,12.1,0l96,56a12,12,0,0,1,0,20.74l-96,56a12,12,0,0,1-12.1,0l-96-56A12,12,0,0,1,20,80Zm35.82,0L128,122.11,200.18,80,128,37.89ZM138,212.3,128,218.11,38.05,165.63A12,12,0,0,0,26,186.37l96,56a12,12,0,0,0,12.1,0l16-9.34A12,12,0,1,0,138,212.3Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,80l-96,56L32,80l96-56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240,200a8,8,0,0,1-8,8H184a8,8,0,0,1,0-16h48A8,8,0,0,1,240,200Zm-20-78.91-92,53.65L36,121.09A8,8,0,0,0,28,134.91l96,56a8,8,0,0,0,8.06,0l96-56A8,8,0,1,0,220,121.09ZM24,80a8,8,0,0,1,4-6.91l96-56a8,8,0,0,1,8.06,0l96,56a8,8,0,0,1,0,13.82l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,24,80Zm23.88,0L128,126.74,208.12,80,128,33.26ZM140,215.76l-12,7L36,169.09A8,8,0,0,0,28,182.91l96,56a8,8,0,0,0,8.06,0l16-9.33A8,8,0,1,0,140,215.76Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M230.91,124A8,8,0,0,1,228,134.91l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,36,121.09l92,53.65,92-53.65A8,8,0,0,1,230.91,124ZM28,86.91l96,56a8,8,0,0,0,8.06,0l96-56a8,8,0,0,0,0-13.82l-96-56a8,8,0,0,0-8.06,0l-96,56a8,8,0,0,0,0,13.82ZM232,192H184a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Zm-92,23.76-12,7L36,169.09A8,8,0,0,0,28,182.91l96,56a8,8,0,0,0,8.06,0l16-9.33A8,8,0,1,0,140,215.76Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M238,200a6,6,0,0,1-6,6H184a6,6,0,0,1,0-12h48A6,6,0,0,1,238,200Zm-17-77.18-93,54.23L35,122.82a6,6,0,0,0-6,10.36l96,56a6,6,0,0,0,6,0l96-56a6,6,0,0,0-6-10.36ZM26,80a6,6,0,0,1,3-5.18l96-56a6,6,0,0,1,6,0l96,56a6,6,0,0,1,0,10.36l-96,56a6,6,0,0,1-6,0l-96-56A6,6,0,0,1,26,80Zm17.91,0L128,129.05,212.09,80,128,31ZM141,217.48l-13,7.57L35,170.82a6,6,0,0,0-6,10.36l96,56a6,6,0,0,0,6,0l16-9.33a6,6,0,0,0-6-10.37Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M230.91,124A8,8,0,0,1,228,134.91l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,36,121.09l92,53.65,92-53.65A8,8,0,0,1,230.91,124ZM24,80a8,8,0,0,1,4-6.91l96-56a8,8,0,0,1,8.06,0l96,56a8,8,0,0,1,0,13.82l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,24,80Zm23.88,0L128,126.74,208.12,80,128,33.26ZM232,192H184a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Zm-92,23.76-12,7L36,169.09A8,8,0,0,0,28,182.91l96,56a8,8,0,0,0,8.06,0l16-9.33A8,8,0,1,0,140,215.76Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M236,200a4,4,0,0,1-4,4H184a4,4,0,0,1,0-8h48A4,4,0,0,1,236,200Zm-14-75.46-94,54.83L34,124.54a4,4,0,0,0-4,6.92l96,56a4,4,0,0,0,4,0l96-56a4,4,0,1,0-4-6.92ZM28,80a4,4,0,0,1,2-3.46l96-56a4,4,0,0,1,4,0l96,56a4,4,0,0,1,0,6.92l-96,56a4,4,0,0,1-4,0l-96-56A4,4,0,0,1,28,80Zm11.94,0L128,131.37,216.06,80,128,28.63ZM142,219.21l-14,8.16L34,172.54a4,4,0,0,0-4,6.92l96,56a4,4,0,0,0,4,0l16-9.34a4,4,0,1,0-4-6.91Z"
        }))
    ]
]);


const $543fda4ac58ac75f$export$12a3823f287db803 = $7fPBF.forwardRef((a, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: c,
        ...a,
        weights: (0, $55de31233c3e3c07$export$2e2bcd8739ae039)
    }));
$543fda4ac58ac75f$export$12a3823f287db803.displayName = "StackMinusIcon";
const $543fda4ac58ac75f$export$1fcf57074d882402 = $543fda4ac58ac75f$export$12a3823f287db803;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $064bc1fef11ad125$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240,200a12,12,0,0,1-12,12h-8v8a12,12,0,0,1-24,0v-8h-8a12,12,0,0,1,0-24h8v-8a12,12,0,0,1,24,0v8h8A12,12,0,0,1,240,200ZM218,117.63,128,170.11,38.05,117.63A12,12,0,0,0,26,138.37l96,56a12,12,0,0,0,12.1,0l96-56A12,12,0,1,0,218,117.63ZM20,80a12,12,0,0,1,6-10.37l96-56a12.06,12.06,0,0,1,12.1,0l96,56a12,12,0,0,1,0,20.74l-96,56a12,12,0,0,1-12.1,0l-96-56A12,12,0,0,1,20,80Zm35.82,0L128,122.11,200.18,80,128,37.89ZM138,212.3,128,218.11,38.05,165.63A12,12,0,0,0,26,186.37l96,56a12,12,0,0,0,12.1,0l16-9.34A12,12,0,1,0,138,212.3Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,80l-96,56L32,80l96-56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240,200a8,8,0,0,1-8,8H216v16a8,8,0,0,1-16,0V208H184a8,8,0,0,1,0-16h16V176a8,8,0,0,1,16,0v16h16A8,8,0,0,1,240,200Zm-20-78.91-92,53.65L36,121.09A8,8,0,0,0,28,134.91l96,56a8,8,0,0,0,8.06,0l96-56A8,8,0,1,0,220,121.09ZM24,80a8,8,0,0,1,4-6.91l96-56a8,8,0,0,1,8.06,0l96,56a8,8,0,0,1,0,13.82l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,24,80Zm23.88,0L128,126.74,208.12,80,128,33.26ZM140,215.76l-12,7L36,169.09A8,8,0,0,0,28,182.91l96,56a8,8,0,0,0,8.06,0l16-9.33A8,8,0,1,0,140,215.76Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M24,80a8,8,0,0,1,4-6.91l96-56a8,8,0,0,1,8.06,0l96,56a8,8,0,0,1,0,13.82l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,24,80Zm196,41.09-92,53.65L36,121.09A8,8,0,0,0,28,134.91l96,56a8,8,0,0,0,8.06,0l96-56A8,8,0,1,0,220,121.09ZM232,192H216V176a8,8,0,0,0-16,0v16H184a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0V208h16a8,8,0,0,0,0-16Zm-92,23.76-12,7L36,169.09A8,8,0,0,0,28,182.91l96,56a8,8,0,0,0,8.06,0l16-9.33A8,8,0,1,0,140,215.76Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M238,200a6,6,0,0,1-6,6H214v18a6,6,0,0,1-12,0V206H184a6,6,0,0,1,0-12h18V176a6,6,0,0,1,12,0v18h18A6,6,0,0,1,238,200Zm-17-77.18-93,54.23L35,122.82a6,6,0,0,0-6,10.36l96,56a6,6,0,0,0,6,0l96-56a6,6,0,0,0-6-10.36ZM26,80a6,6,0,0,1,3-5.18l96-56a6,6,0,0,1,6,0l96,56a6,6,0,0,1,0,10.36l-96,56a6,6,0,0,1-6,0l-96-56A6,6,0,0,1,26,80Zm17.91,0L128,129.05,212.09,80,128,31ZM141,217.48l-13,7.57L35,170.82a6,6,0,0,0-6,10.36l96,56a6,6,0,0,0,6,0l16-9.33a6,6,0,0,0-6-10.37Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M230.91,124A8,8,0,0,1,228,134.91l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,36,121.09l92,53.65,92-53.65A8,8,0,0,1,230.91,124ZM24,80a8,8,0,0,1,4-6.91l96-56a8,8,0,0,1,8.06,0l96,56a8,8,0,0,1,0,13.82l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,24,80Zm23.88,0L128,126.74,208.12,80,128,33.26ZM232,192H216V176a8,8,0,0,0-16,0v16H184a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0V208h16a8,8,0,0,0,0-16Zm-92,23.76-12,7L36,169.09A8,8,0,0,0,28,182.91l96,56a8,8,0,0,0,8.06,0l16-9.33A8,8,0,1,0,140,215.76Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M236,200a4,4,0,0,1-4,4H212v20a4,4,0,0,1-8,0V204H184a4,4,0,0,1,0-8h20V176a4,4,0,0,1,8,0v20h20A4,4,0,0,1,236,200Zm-14-75.46-94,54.83L34,124.54a4,4,0,0,0-4,6.92l96,56a4,4,0,0,0,4,0l96-56a4,4,0,1,0-4-6.92ZM28,80a4,4,0,0,1,2-3.46l96-56a4,4,0,0,1,4,0l96,56a4,4,0,0,1,0,6.92l-96,56a4,4,0,0,1-4,0l-96-56A4,4,0,0,1,28,80Zm11.94,0L128,131.37,216.06,80,128,28.63ZM142,219.21l-14,8.16L34,172.54a4,4,0,0,0-4,6.92l96,56a4,4,0,0,0,4,0l16-9.34a4,4,0,1,0-4-6.91Z"
        }))
    ]
]);


const $3ae7f63f5859902d$export$64702cae849e08a7 = $7fPBF.forwardRef((a, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: c,
        ...a,
        weights: (0, $064bc1fef11ad125$export$2e2bcd8739ae039)
    }));
$3ae7f63f5859902d$export$64702cae849e08a7.displayName = "StackPlusIcon";
const $3ae7f63f5859902d$export$25792c5f07b8abcb = $3ae7f63f5859902d$export$64702cae849e08a7;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $b3a9c91e7b72c1a6$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,36H56A20,20,0,0,0,36,56V200a20,20,0,0,0,20,20H200a20,20,0,0,0,20-20V56A20,20,0,0,0,200,36Zm-4,160H60V60H196Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,56V200a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H200A8,8,0,0,1,208,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,40H56A16,16,0,0,0,40,56V200a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40Zm0,160H56V56H200V200Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,56V200a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V56A16,16,0,0,1,56,40H200A16,16,0,0,1,216,56Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,42H56A14,14,0,0,0,42,56V200a14,14,0,0,0,14,14H200a14,14,0,0,0,14-14V56A14,14,0,0,0,200,42Zm2,158a2,2,0,0,1-2,2H56a2,2,0,0,1-2-2V56a2,2,0,0,1,2-2H200a2,2,0,0,1,2,2Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,40H56A16,16,0,0,0,40,56V200a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40Zm0,160H56V56H200V200Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,44H56A12,12,0,0,0,44,56V200a12,12,0,0,0,12,12H200a12,12,0,0,0,12-12V56A12,12,0,0,0,200,44Zm4,156a4,4,0,0,1-4,4H56a4,4,0,0,1-4-4V56a4,4,0,0,1,4-4H200a4,4,0,0,1,4,4Z"
        }))
    ]
]);


const $9eef48aaff177bbc$export$dc6949a98411e916 = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...e,
        weights: (0, $b3a9c91e7b72c1a6$export$2e2bcd8739ae039)
    }));
$9eef48aaff177bbc$export$dc6949a98411e916.displayName = "StopIcon";
const $9eef48aaff177bbc$export$ac4156b3386a7c70 = $9eef48aaff177bbc$export$dc6949a98411e916;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $361a2e96ed7b58a9$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228,48V152a20,20,0,0,1-20,20H112.92a12,12,0,0,1-17.41,16.49l-20-20a12,12,0,0,1,0-17l20-20A12,12,0,0,1,112.92,148H204V52H100a12,12,0,0,1-24,0V48A20,20,0,0,1,96,28H208A20,20,0,0,1,228,48ZM168,192a12,12,0,0,0-12,12H52V108h91.08a12,12,0,0,0,17.41,16.49l20-20a12,12,0,0,0,0-17l-20-20A12,12,0,0,0,143.08,84H48a20,20,0,0,0-20,20V208a20,20,0,0,0,20,20H160a20,20,0,0,0,20-20v-4A12,12,0,0,0,168,192Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,48V152a8,8,0,0,1-8,8H168v48a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H88V48a8,8,0,0,1,8-8H208A8,8,0,0,1,216,48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,48V152a16,16,0,0,1-16,16H99.31l10.35,10.34a8,8,0,0,1-11.32,11.32l-24-24a8,8,0,0,1,0-11.32l24-24a8,8,0,0,1,11.32,11.32L99.31,152H208V48H96v8a8,8,0,0,1-16,0V48A16,16,0,0,1,96,32H208A16,16,0,0,1,224,48ZM168,192a8,8,0,0,0-8,8v8H48V104H156.69l-10.35,10.34a8,8,0,0,0,11.32,11.32l24-24a8,8,0,0,0,0-11.32l-24-24a8,8,0,0,0-11.32,11.32L156.69,88H48a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16v-8A8,8,0,0,0,168,192Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,48V152a16,16,0,0,1-16,16H112v16a8,8,0,0,1-13.66,5.66l-24-24a8,8,0,0,1,0-11.32l24-24A8,8,0,0,1,112,136v16h96V48H96v8a8,8,0,0,1-16,0V48A16,16,0,0,1,96,32H208A16,16,0,0,1,224,48ZM168,192a8,8,0,0,0-8,8v8H48V104h96v16a8,8,0,0,0,13.66,5.66l24-24a8,8,0,0,0,0-11.32l-24-24A8,8,0,0,0,144,72V88H48a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16v-8A8,8,0,0,0,168,192Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M222,48V152a14,14,0,0,1-14,14H94.49l13.75,13.76a6,6,0,1,1-8.48,8.48l-24-24a6,6,0,0,1,0-8.48l24-24a6,6,0,0,1,8.48,8.48L94.49,154H208a2,2,0,0,0,2-2V48a2,2,0,0,0-2-2H96a2,2,0,0,0-2,2v8a6,6,0,0,1-12,0V48A14,14,0,0,1,96,34H208A14,14,0,0,1,222,48ZM168,194a6,6,0,0,0-6,6v8a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V104a2,2,0,0,1,2-2H161.51l-13.75,13.76a6,6,0,1,0,8.48,8.48l24-24a6,6,0,0,0,0-8.48l-24-24a6,6,0,0,0-8.48,8.48L161.51,90H48a14,14,0,0,0-14,14V208a14,14,0,0,0,14,14H160a14,14,0,0,0,14-14v-8A6,6,0,0,0,168,194Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,48V152a16,16,0,0,1-16,16H99.31l10.35,10.34a8,8,0,0,1-11.32,11.32l-24-24a8,8,0,0,1,0-11.32l24-24a8,8,0,0,1,11.32,11.32L99.31,152H208V48H96v8a8,8,0,0,1-16,0V48A16,16,0,0,1,96,32H208A16,16,0,0,1,224,48ZM168,192a8,8,0,0,0-8,8v8H48V104H156.69l-10.35,10.34a8,8,0,0,0,11.32,11.32l24-24a8,8,0,0,0,0-11.32l-24-24a8,8,0,0,0-11.32,11.32L156.69,88H48a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16v-8A8,8,0,0,0,168,192Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220,48V152a12,12,0,0,1-12,12H89.66l17.17,17.17a4,4,0,0,1-5.66,5.66l-24-24a4,4,0,0,1,0-5.66l24-24a4,4,0,0,1,5.66,5.66L89.66,156H208a4,4,0,0,0,4-4V48a4,4,0,0,0-4-4H96a4,4,0,0,0-4,4v8a4,4,0,0,1-8,0V48A12,12,0,0,1,96,36H208A12,12,0,0,1,220,48ZM168,196a4,4,0,0,0-4,4v8a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V104a4,4,0,0,1,4-4H166.34l-17.17,17.17a4,4,0,0,0,5.66,5.66l24-24a4,4,0,0,0,0-5.66l-24-24a4,4,0,0,0-5.66,5.66L166.34,92H48a12,12,0,0,0-12,12V208a12,12,0,0,0,12,12H160a12,12,0,0,0,12-12v-8A4,4,0,0,0,168,196Z"
        }))
    ]
]);


const $0626899a8774a822$export$67f45bdc93ca8e23 = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...e,
        weights: (0, $361a2e96ed7b58a9$export$2e2bcd8739ae039)
    }));
$0626899a8774a822$export$67f45bdc93ca8e23.displayName = "SwapIcon";
const $0626899a8774a822$export$bdb5f0a1b77546f4 = $0626899a8774a822$export$67f45bdc93ca8e23;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $9883eaaf5e477b05$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M72.5,150.63,100.79,128,72.5,105.37a12,12,0,1,1,15-18.74l40,32a12,12,0,0,1,0,18.74l-40,32a12,12,0,0,1-15-18.74ZM144,172h32a12,12,0,0,0,0-24H144a12,12,0,0,0,0,24ZM236,56V200a20,20,0,0,1-20,20H40a20,20,0,0,1-20-20V56A20,20,0,0,1,40,36H216A20,20,0,0,1,236,56Zm-24,4H44V196H212Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,56V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216A8,8,0,0,1,224,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,128a8,8,0,0,1-3,6.25l-40,32a8,8,0,1,1-10-12.5L107.19,128,75,102.25a8,8,0,1,1,10-12.5l40,32A8,8,0,0,1,128,128Zm48,24H136a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16Zm56-96V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56ZM216,200V56H40V200H216Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm-91,94.25-40,32a8,8,0,1,1-10-12.5L107.19,128,75,102.25a8,8,0,1,1,10-12.5l40,32a8,8,0,0,1,0,12.5ZM176,168H136a8,8,0,0,1,0-16h40a8,8,0,0,1,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M126,128a6,6,0,0,1-2.25,4.69l-40,32a6,6,0,0,1-7.5-9.38L110.4,128,76.25,100.69a6,6,0,1,1,7.5-9.38l40,32A6,6,0,0,1,126,128Zm50,26H136a6,6,0,0,0,0,12h40a6,6,0,0,0,0-12Zm54-98V200a14,14,0,0,1-14,14H40a14,14,0,0,1-14-14V56A14,14,0,0,1,40,42H216A14,14,0,0,1,230,56Zm-12,0a2,2,0,0,0-2-2H40a2,2,0,0,0-2,2V200a2,2,0,0,0,2,2H216a2,2,0,0,0,2-2Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,128a8,8,0,0,1-3,6.25l-40,32a8,8,0,1,1-10-12.5L107.19,128,75,102.25a8,8,0,1,1,10-12.5l40,32A8,8,0,0,1,128,128Zm48,24H136a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16Zm56-96V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56ZM216,200V56H40V200H216Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M122.5,124.88a4,4,0,0,1,0,6.24l-40,32a4,4,0,0,1-5-6.24L113.6,128,77.5,99.12a4,4,0,0,1,5-6.24ZM176,156H136a4,4,0,0,0,0,8h40a4,4,0,0,0,0-8ZM228,56V200a12,12,0,0,1-12,12H40a12,12,0,0,1-12-12V56A12,12,0,0,1,40,44H216A12,12,0,0,1,228,56Zm-8,0a4,4,0,0,0-4-4H40a4,4,0,0,0-4,4V200a4,4,0,0,0,4,4H216a4,4,0,0,0,4-4Z"
        }))
    ]
]);


const $e673841d74d2fd8a$export$8ee6b256df317f28 = $7fPBF.forwardRef((r, n)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: n,
        ...r,
        weights: (0, $9883eaaf5e477b05$export$2e2bcd8739ae039)
    }));
$e673841d74d2fd8a$export$8ee6b256df317f28.displayName = "TerminalWindowIcon";
const $e673841d74d2fd8a$export$6d10593dc8290a13 = $e673841d74d2fd8a$export$8ee6b256df317f28;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $a85de379556b6dc8$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,44a96,96,0,1,0,96,96A96.11,96.11,0,0,0,128,44Zm0,168a72,72,0,1,1,72-72A72.08,72.08,0,0,1,128,212ZM164.49,99.51a12,12,0,0,1,0,17l-28,28a12,12,0,0,1-17-17l28-28A12,12,0,0,1,164.49,99.51ZM92,16A12,12,0,0,1,104,4h48a12,12,0,0,1,0,24H104A12,12,0,0,1,92,16Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,136a88,88,0,1,1-88-88A88,88,0,0,1,216,136Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,40a96,96,0,1,0,96,96A96.11,96.11,0,0,0,128,40Zm0,176a80,80,0,1,1,80-80A80.09,80.09,0,0,1,128,216ZM173.66,90.34a8,8,0,0,1,0,11.32l-40,40a8,8,0,0,1-11.32-11.32l40-40A8,8,0,0,1,173.66,90.34ZM96,16a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H104A8,8,0,0,1,96,16Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,40a96,96,0,1,0,96,96A96.11,96.11,0,0,0,128,40Zm45.66,61.66-40,40a8,8,0,0,1-11.32-11.32l40-40a8,8,0,0,1,11.32,11.32ZM96,16a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H104A8,8,0,0,1,96,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,42a94,94,0,1,0,94,94A94.11,94.11,0,0,0,128,42Zm0,176a82,82,0,1,1,82-82A82.1,82.1,0,0,1,128,218ZM172.24,91.76a6,6,0,0,1,0,8.48l-40,40a6,6,0,1,1-8.48-8.48l40-40A6,6,0,0,1,172.24,91.76ZM98,16a6,6,0,0,1,6-6h48a6,6,0,0,1,0,12H104A6,6,0,0,1,98,16Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,40a96,96,0,1,0,96,96A96.11,96.11,0,0,0,128,40Zm0,176a80,80,0,1,1,80-80A80.09,80.09,0,0,1,128,216ZM173.66,90.34a8,8,0,0,1,0,11.32l-40,40a8,8,0,0,1-11.32-11.32l40-40A8,8,0,0,1,173.66,90.34ZM96,16a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H104A8,8,0,0,1,96,16Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,44a92,92,0,1,0,92,92A92.1,92.1,0,0,0,128,44Zm0,176a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,220ZM170.83,93.17a4,4,0,0,1,0,5.66l-40,40a4,4,0,1,1-5.66-5.66l40-40A4,4,0,0,1,170.83,93.17ZM100,16a4,4,0,0,1,4-4h48a4,4,0,0,1,0,8H104A4,4,0,0,1,100,16Z"
        }))
    ]
]);


const $ec3dc4d0853d94d0$export$579848c7cccecf3f = $7fPBF.forwardRef((r, m)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: m,
        ...r,
        weights: (0, $a85de379556b6dc8$export$2e2bcd8739ae039)
    }));
$ec3dc4d0853d94d0$export$579848c7cccecf3f.displayName = "TimerIcon";
const $ec3dc4d0853d94d0$export$c57e9b2d8b9e4de = $ec3dc4d0853d94d0$export$579848c7cccecf3f;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $bde6d6167681f1b4$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M250.73,210.63l-56-112a12,12,0,0,0-21.46,0l-20.52,41A84.2,84.2,0,0,1,114,126.22,107.48,107.48,0,0,0,139.33,68H160a12,12,0,0,0,0-24H108V32a12,12,0,0,0-24,0V44H32a12,12,0,0,0,0,24h83.13A83.69,83.69,0,0,1,96,110.35,84,84,0,0,1,83.6,91a12,12,0,1,0-21.81,10A107.55,107.55,0,0,0,78,126.24,83.54,83.54,0,0,1,32,140a12,12,0,0,0,0,24,107.47,107.47,0,0,0,64-21.07,108.4,108.4,0,0,0,45.39,19.44l-24.13,48.26a12,12,0,1,0,21.46,10.73L151.41,196h65.17l12.68,25.36a12,12,0,1,0,21.47-10.73ZM163.41,172,184,130.83,204.58,172Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,184H144l40-80ZM96,127.56h0A95.78,95.78,0,0,0,128,56H64A95.78,95.78,0,0,0,96,127.56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M247.15,212.42l-56-112a8,8,0,0,0-14.31,0l-21.71,43.43A88,88,0,0,1,108,126.93,103.65,103.65,0,0,0,135.69,64H160a8,8,0,0,0,0-16H104V32a8,8,0,0,0-16,0V48H32a8,8,0,0,0,0,16h87.63A87.7,87.7,0,0,1,96,116.35a87.74,87.74,0,0,1-19-31,8,8,0,1,0-15.08,5.34A103.63,103.63,0,0,0,84,127a87.55,87.55,0,0,1-52,17,8,8,0,0,0,0,16,103.46,103.46,0,0,0,64-22.08,104.18,104.18,0,0,0,51.44,21.31l-26.6,53.19a8,8,0,0,0,14.31,7.16L148.94,192h70.11l13.79,27.58A8,8,0,0,0,240,224a8,8,0,0,0,7.15-11.58ZM156.94,176,184,121.89,211.05,176Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M160,129.89,175.06,160H144.94l6.36-12.7v0ZM224,48V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48ZM207.16,188.42l-40-80a8,8,0,0,0-14.32,0L139.66,134.8a62.31,62.31,0,0,1-23.61-10A79.61,79.61,0,0,0,135.6,80H152a8,8,0,0,0,0-16H112V56a8,8,0,0,0-16,0v8H56a8,8,0,0,0,0,16h63.48a63.73,63.73,0,0,1-15.3,34.05,65.93,65.93,0,0,1-9-13.61,8,8,0,0,0-14.32,7.12,81.75,81.75,0,0,0,11.4,17.15A63.62,63.62,0,0,1,56,136a8,8,0,0,0,0,16,79.56,79.56,0,0,0,48.11-16.13,78.33,78.33,0,0,0,28.18,13.66l-19.45,38.89a8,8,0,0,0,14.32,7.16L136.94,176h46.12l9.78,19.58a8,8,0,1,0,14.32-7.16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M245.37,213.32l-56-112a6,6,0,0,0-10.74,0l-22.3,44.6A90,90,0,0,1,105,127.19,101.73,101.73,0,0,0,133.82,62H160a6,6,0,0,0,0-12H102V32a6,6,0,0,0-12,0V50H32a6,6,0,0,0,0,12h89.79A89.71,89.71,0,0,1,96,119.23,89.81,89.81,0,0,1,75.11,86,6,6,0,1,0,63.8,90,101.66,101.66,0,0,0,87,127.2,89.56,89.56,0,0,1,32,146a6,6,0,0,0,0,12,101.55,101.55,0,0,0,64-22.63,102.11,102.11,0,0,0,54.53,22.17l-27.89,55.78a6,6,0,0,0,10.74,5.36L147.71,190h72.58l14.34,28.68A6,6,0,0,0,240,222a5.87,5.87,0,0,0,2.68-.64A6,6,0,0,0,245.37,213.32ZM153.71,178,184,117.42,214.29,178Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M247.15,212.42l-56-112a8,8,0,0,0-14.31,0l-21.71,43.43A88,88,0,0,1,108,126.93,103.65,103.65,0,0,0,135.69,64H160a8,8,0,0,0,0-16H104V32a8,8,0,0,0-16,0V48H32a8,8,0,0,0,0,16h87.63A87.76,87.76,0,0,1,96,116.35a87.74,87.74,0,0,1-19-31,8,8,0,1,0-15.08,5.34A103.63,103.63,0,0,0,84,127a87.55,87.55,0,0,1-52,17,8,8,0,0,0,0,16,103.46,103.46,0,0,0,64-22.08,104.18,104.18,0,0,0,51.44,21.31l-26.6,53.19a8,8,0,0,0,14.31,7.16L148.94,192h70.11l13.79,27.58A8,8,0,0,0,240,224a8,8,0,0,0,7.15-11.58ZM156.94,176,184,121.89,211.05,176Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M243.58,214.21l-56-112a4,4,0,0,0-7.16,0L157.55,148A92.05,92.05,0,0,1,102,127.36,99.68,99.68,0,0,0,131.91,60H160a4,4,0,0,0,0-8H100V32a4,4,0,0,0-8,0V52H32a4,4,0,0,0,0,8h91.91A91.8,91.8,0,0,1,96,122.05,92,92,0,0,1,73.23,86.67a4,4,0,1,0-7.54,2.66,99.59,99.59,0,0,0,24.3,38A91.59,91.59,0,0,1,32,148a4,4,0,0,0,0,8,99.54,99.54,0,0,0,64-23.21,100.09,100.09,0,0,0,57.66,23l-29.22,58.43a4,4,0,1,0,7.16,3.58L146.47,188h75.06l14.89,29.79A4,4,0,0,0,240,220a4.12,4.12,0,0,0,1.79-.42A4,4,0,0,0,243.58,214.21ZM150.47,180,184,112.94,217.53,180Z"
        }))
    ]
]);


const $e0cac562beb02fd2$export$d1fe1d52e2885c4e = $7fPBF.forwardRef((o, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...o,
        weights: (0, $bde6d6167681f1b4$export$2e2bcd8739ae039)
    }));
$e0cac562beb02fd2$export$d1fe1d52e2885c4e.displayName = "TranslateIcon";
const $e0cac562beb02fd2$export$9db2ba50894db2b9 = $e0cac562beb02fd2$export$d1fe1d52e2885c4e;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $c36618c05307c46b$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,48H180V36A28,28,0,0,0,152,8H104A28,28,0,0,0,76,36V48H40a12,12,0,0,0,0,24h4V208a20,20,0,0,0,20,20H192a20,20,0,0,0,20-20V72h4a12,12,0,0,0,0-24ZM100,36a4,4,0,0,1,4-4h48a4,4,0,0,1,4,4V48H100Zm88,168H68V72H188ZM116,104v64a12,12,0,0,1-24,0V104a12,12,0,0,1,24,0Zm48,0v64a12,12,0,0,1-24,0V104a12,12,0,0,1,24,0Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM96,40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm96,168H64V64H192ZM112,104v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM112,168a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm0-120H96V40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,50H174V40a22,22,0,0,0-22-22H104A22,22,0,0,0,82,40V50H40a6,6,0,0,0,0,12H50V208a14,14,0,0,0,14,14H192a14,14,0,0,0,14-14V62h10a6,6,0,0,0,0-12ZM94,40a10,10,0,0,1,10-10h48a10,10,0,0,1,10,10V50H94ZM194,208a2,2,0,0,1-2,2H64a2,2,0,0,1-2-2V62H194ZM110,104v64a6,6,0,0,1-12,0V104a6,6,0,0,1,12,0Zm48,0v64a6,6,0,0,1-12,0V104a6,6,0,0,1,12,0Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM96,40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm96,168H64V64H192ZM112,104v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,52H172V40a20,20,0,0,0-20-20H104A20,20,0,0,0,84,40V52H40a4,4,0,0,0,0,8H52V208a12,12,0,0,0,12,12H192a12,12,0,0,0,12-12V60h12a4,4,0,0,0,0-8ZM92,40a12,12,0,0,1,12-12h48a12,12,0,0,1,12,12V52H92ZM196,208a4,4,0,0,1-4,4H64a4,4,0,0,1-4-4V60H196ZM108,104v64a4,4,0,0,1-8,0V104a4,4,0,0,1,8,0Zm48,0v64a4,4,0,0,1-8,0V104a4,4,0,0,1,8,0Z"
        }))
    ]
]);


const $9819cc275a023cc4$export$d23329de703dffc4 = $7fPBF.forwardRef((a, e)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: e,
        ...a,
        weights: (0, $c36618c05307c46b$export$2e2bcd8739ae039)
    }));
$9819cc275a023cc4$export$d23329de703dffc4.displayName = "TrashIcon";
const $9819cc275a023cc4$export$99442c433de1441d = $9819cc275a023cc4$export$d23329de703dffc4;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $85c705298dad0e62$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M92.38,38.05A12,12,0,0,1,101,23.42a108,108,0,0,1,54,0,12,12,0,1,1-6,23.23,84,84,0,0,0-42,0A12,12,0,0,1,92.38,38.05ZM32.29,113.87a12.2,12.2,0,0,0,3.2.43,12,12,0,0,0,11.56-8.8,84,84,0,0,1,21-36.35A12,12,0,1,0,50.94,52.34a108.1,108.1,0,0,0-27,46.76A12,12,0,0,0,32.29,113.87ZM149,209.35a84,84,0,0,1-42,0,12,12,0,1,0-6,23.23,108,108,0,0,0,54,0,12,12,0,1,0-6-23.23Zm59.95-103.83a12,12,0,0,0,23.12-6.42,108,108,0,0,0-27-46.78A12,12,0,1,0,188,69.15,84,84,0,0,1,208.94,105.52Zm23.15,51.39a107.86,107.86,0,0,1-31.86,51.38,12,12,0,0,1-18.72-3.48,60,60,0,0,0-107,0,12,12,0,0,1-8.5,6.36,12.48,12.48,0,0,1-2.19.2,12,12,0,0,1-8-3.08A107.85,107.85,0,0,1,23.91,156.9,12,12,0,0,1,47,150.49,83.58,83.58,0,0,0,62,180a83.46,83.46,0,0,1,29-23.47,52,52,0,1,1,74,0A83.59,83.59,0,0,1,194,180a83.73,83.73,0,0,0,15-29.49,12,12,0,0,1,23.13,6.42ZM128,148a28,28,0,1,0-28-28A28,28,0,0,0,128,148Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a95.76,95.76,0,0,1-31.8,71.37A72,72,0,0,0,128,160a40,40,0,1,0-40-40,40,40,0,0,0,40,40,72,72,0,0,0-64.2,39.37h0A96,96,0,1,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M96.26,37A8,8,0,0,1,102,27.29a104.11,104.11,0,0,1,52,0,8,8,0,0,1-2,15.75,8.15,8.15,0,0,1-2-.26,88,88,0,0,0-44,0A8,8,0,0,1,96.26,37ZM33.35,110a8,8,0,0,0,9.85-5.57,87.88,87.88,0,0,1,22-38.09A8,8,0,0,0,53.79,55.14a104,104,0,0,0-26,45A8,8,0,0,0,33.35,110ZM150,213.22a88,88,0,0,1-44,0,8,8,0,0,0-4,15.49,104.11,104.11,0,0,0,52,0,8,8,0,0,0-4-15.49Zm62.8-108.77a8,8,0,0,0,15.42-4.28,104,104,0,0,0-26-45,8,8,0,1,0-11.41,11.21A88.14,88.14,0,0,1,212.79,104.45Zm15.44,51.39a103.68,103.68,0,0,1-30.68,49.47A8,8,0,0,1,185.07,203a64,64,0,0,0-114.14,0,8,8,0,0,1-5.67,4.23,8.11,8.11,0,0,1-1.46.14,8,8,0,0,1-5.35-2.05,103.74,103.74,0,0,1-30.68-49.49,8,8,0,0,1,15.42-4.27,87.58,87.58,0,0,0,19,34.88,79.57,79.57,0,0,1,36.1-28.77,48,48,0,1,1,59.38,0,79.57,79.57,0,0,1,36.1,28.77,87.58,87.58,0,0,0,19-34.88,8,8,0,1,1,15.42,4.28ZM128,152a32,32,0,1,0-32-32A32,32,0,0,0,128,152Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M96.26,37A8,8,0,0,1,102,27.29a104.11,104.11,0,0,1,52,0,8,8,0,0,1-2,15.75,8.15,8.15,0,0,1-2-.26,88,88,0,0,0-44,0A8,8,0,0,1,96.26,37ZM33.35,110a8,8,0,0,0,9.85-5.57,88,88,0,0,1,22-38.09A8,8,0,0,0,53.79,55.14a104.05,104.05,0,0,0-26,45A8,8,0,0,0,33.35,110Zm179.44-5.56a8,8,0,0,0,15.42-4.28,104,104,0,0,0-26-45,8,8,0,1,0-11.41,11.22A88,88,0,0,1,212.79,104.45ZM222.66,146a8,8,0,0,0-9.85,5.58,87.61,87.61,0,0,1-19,34.83A79.75,79.75,0,0,0,172,165.11a4,4,0,0,0-4.83.31,59.81,59.81,0,0,1-78.27,0,4,4,0,0,0-4.84-.31,79.52,79.52,0,0,0-22,21.12,87.7,87.7,0,0,1-18.83-34.67,8,8,0,0,0-15.42,4.28,104.07,104.07,0,0,0,200.46,0A8,8,0,0,0,222.66,146ZM128,164a44,44,0,1,0-44-44A44.05,44.05,0,0,0,128,164Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M98.19,36.54a6,6,0,0,1,4.31-7.31,102,102,0,0,1,51,0,6,6,0,1,1-3,11.61,90,90,0,0,0-45,0A6,6,0,0,1,98.19,36.54Zm-64.3,71.54a5.88,5.88,0,0,0,1.6.22,6,6,0,0,0,5.78-4.4A90,90,0,0,1,63.78,65a6,6,0,1,0-8.56-8.41A102.12,102.12,0,0,0,29.7,100.7,6,6,0,0,0,33.89,108.08ZM150.5,215.15a90,90,0,0,1-45,0,6,6,0,1,0-3,11.61,102,102,0,0,0,51,0,6,6,0,0,0-3-11.62Zm64.22-111.24a6,6,0,0,0,5.78,4.4,5.88,5.88,0,0,0,1.6-.22,6,6,0,0,0,4.18-7.38,102,102,0,0,0-25.49-44.18,6,6,0,0,0-8.55,8.41A90.11,90.11,0,0,1,214.72,103.91ZM226.3,155.3a101.75,101.75,0,0,1-30.08,48.53,6,6,0,0,1-9.37-1.74,66,66,0,0,0-117.7,0,6,6,0,0,1-4.26,3.18,5.74,5.74,0,0,1-1.09.1,6,6,0,0,1-4-1.54A101.74,101.74,0,0,1,29.7,155.3a6,6,0,1,1,11.56-3.21,89.79,89.79,0,0,0,21.2,37.59,77.56,77.56,0,0,1,40-31.43,46,46,0,1,1,51,0,77.56,77.56,0,0,1,40,31.43,89.7,89.7,0,0,0,21.2-37.58,6,6,0,1,1,11.56,3.2ZM128,154a34,34,0,1,0-34-34A34,34,0,0,0,128,154Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M96.26,37A8,8,0,0,1,102,27.29a104.11,104.11,0,0,1,52,0,8,8,0,0,1-2,15.75,8.15,8.15,0,0,1-2-.26,88,88,0,0,0-44,0A8,8,0,0,1,96.26,37ZM33.35,110a8,8,0,0,0,9.85-5.57,87.88,87.88,0,0,1,22-38.09A8,8,0,0,0,53.8,55.14a103.92,103.92,0,0,0-26,45A8,8,0,0,0,33.35,110ZM150,213.22a88,88,0,0,1-44,0,8,8,0,0,0-4,15.49,104.11,104.11,0,0,0,52,0,8,8,0,0,0-4-15.49Zm62.8-108.77a8,8,0,0,0,15.42-4.28,104,104,0,0,0-26-45,8,8,0,1,0-11.41,11.21A88.14,88.14,0,0,1,212.79,104.45Zm15.44,51.39a103.68,103.68,0,0,1-30.68,49.47A8,8,0,0,1,185.07,203a64,64,0,0,0-114.14,0,8,8,0,0,1-12.48,2.32,103.74,103.74,0,0,1-30.68-49.49,8,8,0,0,1,15.42-4.27,87.58,87.58,0,0,0,19,34.88,79.57,79.57,0,0,1,36.1-28.77,48,48,0,1,1,59.38,0,79.57,79.57,0,0,1,36.1,28.77,87.58,87.58,0,0,0,19-34.88,8,8,0,1,1,15.42,4.28ZM128,152a32,32,0,1,0-32-32A32,32,0,0,0,128,152Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M100.13,36A4,4,0,0,1,103,31.17a100.09,100.09,0,0,1,50,0,4,4,0,0,1-1,7.88,4.36,4.36,0,0,1-1-.13,92,92,0,0,0-46,0A4,4,0,0,1,100.13,36ZM34.42,106.16a4,4,0,0,0,4.92-2.79,91.92,91.92,0,0,1,23-39.82,4,4,0,0,0-5.71-5.61,100.15,100.15,0,0,0-25,43.3A4,4,0,0,0,34.42,106.16ZM151,217.09a92,92,0,0,1-46,0,4,4,0,0,0-2,7.75,100,100,0,0,0,50,0,4,4,0,1,0-2-7.74Zm65.65-113.71a4,4,0,1,0,7.7-2.14,100.08,100.08,0,0,0-25-43.31,4,4,0,1,0-5.71,5.61A92,92,0,0,1,216.65,103.38Zm7.73,51.39a99.77,99.77,0,0,1-29.5,47.57,4,4,0,0,1-6.24-1.16,68,68,0,0,0-121.28,0,4,4,0,0,1-2.83,2.12,3.61,3.61,0,0,1-.73.07,4,4,0,0,1-2.68-1,99.8,99.8,0,0,1-29.5-47.58,4,4,0,1,1,7.71-2.13A91.89,91.89,0,0,0,62.8,192.91a75.66,75.66,0,0,1,44.54-34.08,44,44,0,1,1,41.32,0,75.66,75.66,0,0,1,44.54,34.08,91.83,91.83,0,0,0,23.47-40.28,4,4,0,0,1,7.71,2.14ZM128,156a36,36,0,1,0-36-36A36,36,0,0,0,128,156Z"
        }))
    ]
]);


const $e71b30b7f3057cfb$export$1ce52e77d13914c6 = $7fPBF.forwardRef((o, s)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: s,
        ...o,
        weights: (0, $85c705298dad0e62$export$2e2bcd8739ae039)
    }));
$e71b30b7f3057cfb$export$1ce52e77d13914c6.displayName = "UserCircleDashedIcon";
const $e71b30b7f3057cfb$export$74ffb04a319734b0 = $e71b30b7f3057cfb$export$1ce52e77d13914c6;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $7338905cfd832840$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M169.57,46.11a12,12,0,0,1,15.12-7.7L188,39.48V36a12,12,0,0,1,24,0v3.48l3.31-1.07a12,12,0,1,1,7.42,22.82l-3.31,1.08,2,2.82a12,12,0,1,1-19.41,14.1L200,76.42,198,79.23a12,12,0,1,1-19.41-14.1l2-2.82-3.31-1.08A12,12,0,0,1,169.57,46.11ZM236,128A108,108,0,1,1,128,20a109.19,109.19,0,0,1,18,1.49,12,12,0,0,1-4,23.67A85,85,0,0,0,128,44,83.94,83.94,0,0,0,62.05,179.94a83.48,83.48,0,0,1,29-23.42,52,52,0,1,1,74,0,83.48,83.48,0,0,1,29,23.42A83.57,83.57,0,0,0,212,128a85.2,85.2,0,0,0-1.16-14,12,12,0,0,1,23.67-4A109,109,0,0,1,236,128ZM128,148a28,28,0,1,0-28-28A28,28,0,0,0,128,148Zm0,64a83.53,83.53,0,0,0,48.43-15.43,60,60,0,0,0-96.86,0A83.53,83.53,0,0,0,128,212Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a95.76,95.76,0,0,1-31.8,71.37A72,72,0,0,0,128,160a40,40,0,1,0-40-40,40,40,0,0,0,40,40,72,72,0,0,0-64.2,39.37h0A96,96,0,0,1,184.92,50.69a16,16,0,0,0,20.39,20.39A95.61,95.61,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228.25,63.07l-4.66-2.69a23.6,23.6,0,0,0,0-8.76l4.66-2.69a8,8,0,0,0-8-13.86l-4.67,2.7A23.92,23.92,0,0,0,208,33.38V28a8,8,0,0,0-16,0v5.38a23.92,23.92,0,0,0-7.58,4.39l-4.67-2.7a8,8,0,1,0-8,13.86l4.66,2.69a23.6,23.6,0,0,0,0,8.76l-4.66,2.69a8,8,0,0,0,4,14.93,7.92,7.92,0,0,0,4-1.07l4.67-2.7A23.92,23.92,0,0,0,192,78.62V84a8,8,0,0,0,16,0V78.62a23.92,23.92,0,0,0,7.58-4.39l4.67,2.7a7.92,7.92,0,0,0,4,1.07,8,8,0,0,0,4-14.93ZM192,56a8,8,0,1,1,8,8A8,8,0,0,1,192,56Zm29.35,48.11a8,8,0,0,0-6.57,9.21A88.85,88.85,0,0,1,216,128a87.62,87.62,0,0,1-22.24,58.41,79.66,79.66,0,0,0-36.06-28.75,48,48,0,1,0-59.4,0,79.66,79.66,0,0,0-36.06,28.75A88,88,0,0,1,128,40a88.76,88.76,0,0,1,14.68,1.22,8,8,0,0,0,2.64-15.78,103.92,103.92,0,1,0,85.24,85.24A8,8,0,0,0,221.35,104.11ZM96,120a32,32,0,1,1,32,32A32,32,0,0,1,96,120ZM74.08,197.5a64,64,0,0,1,107.84,0,87.83,87.83,0,0,1-107.84,0Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228.25,63.07l-4.66-2.69a23.6,23.6,0,0,0,0-8.76l4.66-2.69a8,8,0,0,0-8-13.86l-4.67,2.7A23.92,23.92,0,0,0,208,33.38V28a8,8,0,0,0-16,0v5.38a23.92,23.92,0,0,0-7.58,4.39l-4.67-2.7a8,8,0,1,0-8,13.86l4.66,2.69a23.6,23.6,0,0,0,0,8.76l-4.66,2.69a8,8,0,0,0,4,14.93,7.92,7.92,0,0,0,4-1.07l4.67-2.7A23.92,23.92,0,0,0,192,78.62V84a8,8,0,0,0,16,0V78.62a23.92,23.92,0,0,0,7.58-4.39l4.67,2.7a7.92,7.92,0,0,0,4,1.07,8,8,0,0,0,4-14.93ZM200,64a8,8,0,1,1,8-8A8,8,0,0,1,200,64ZM128,76a44,44,0,1,1-44,44A44,44,0,0,1,128,76Zm102.56,34.68a103.92,103.92,0,1,1-85.24-85.24,8,8,0,0,1-2.64,15.78A88.07,88.07,0,0,0,40,128a87.62,87.62,0,0,0,22.24,58.41A79.71,79.71,0,0,1,84,165.1a4,4,0,0,1,4.83.32,59.81,59.81,0,0,0,78.27,0,4,4,0,0,1,4.84-.32,79.86,79.86,0,0,1,21.79,21.31A87.62,87.62,0,0,0,216,128a88.85,88.85,0,0,0-1.22-14.68,8,8,0,1,1,15.78-2.64Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M227.25,64.8l-5.92-3.41a22,22,0,0,0,0-10.78l5.92-3.41a6,6,0,0,0-6-10.4l-5.93,3.43A22,22,0,0,0,206,34.84V28a6,6,0,0,0-12,0v6.84a22,22,0,0,0-9.32,5.39l-5.93-3.43a6,6,0,0,0-6,10.4l5.92,3.41a22,22,0,0,0,0,10.78l-5.92,3.41a6,6,0,0,0,6,10.4l5.93-3.43A22,22,0,0,0,194,77.16V84a6,6,0,0,0,12,0V77.16a22,22,0,0,0,9.32-5.39l5.93,3.43a6,6,0,0,0,6-10.4ZM200,66a10,10,0,1,1,10-10A10,10,0,0,1,200,66Zm21.68,40.08a6,6,0,0,0-4.92,6.91A91.76,91.76,0,0,1,218,128a89.65,89.65,0,0,1-24.49,61.64,77.53,77.53,0,0,0-40-31.38,46,46,0,1,0-51,0,77.53,77.53,0,0,0-40,31.38A89.95,89.95,0,0,1,128,38a91.66,91.66,0,0,1,15,1.24,6,6,0,1,0,2-11.83,102,102,0,1,0,50,177.44c.65,1.36,1.68,0,2.34-2.11A102,102,0,0,0,228.59,111,6,6,0,0,0,221.68,106.08ZM94,120a34,34,0,1,1,34,34A34,34,0,0,1,94,120ZM71.44,198a66,66,0,0,1,113.12,0,89.8,89.8,0,0,1-113.12,0Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228.25,63.07l-4.66-2.69a23.6,23.6,0,0,0,0-8.76l4.66-2.69a8,8,0,0,0-8-13.86l-4.67,2.7A23.92,23.92,0,0,0,208,33.38V28a8,8,0,0,0-16,0v5.38a23.92,23.92,0,0,0-7.58,4.39l-4.67-2.7a8,8,0,1,0-8,13.86l4.66,2.69a23.6,23.6,0,0,0,0,8.76l-4.66,2.69a8,8,0,0,0,4,14.93,7.92,7.92,0,0,0,4-1.07l4.67-2.7A23.92,23.92,0,0,0,192,78.62V84a8,8,0,0,0,16,0V78.62a23.92,23.92,0,0,0,7.58-4.39l4.67,2.7a7.92,7.92,0,0,0,4,1.07,8,8,0,0,0,4-14.93ZM192,56a8,8,0,1,1,8,8A8,8,0,0,1,192,56Zm29.35,48.11a8,8,0,0,0-6.57,9.21A88.85,88.85,0,0,1,216,128a87.62,87.62,0,0,1-22.24,58.41,79.66,79.66,0,0,0-36.06-28.75,48,48,0,1,0-59.4,0,79.66,79.66,0,0,0-36.06,28.75A88,88,0,0,1,128,40a88.76,88.76,0,0,1,14.68,1.22,8,8,0,0,0,2.64-15.78,103.92,103.92,0,1,0,85.24,85.24A8,8,0,0,0,221.35,104.11ZM96,120a32,32,0,1,1,32,32A32,32,0,0,1,96,120ZM74.08,197.5a64,64,0,0,1,107.84,0,87.83,87.83,0,0,1-107.84,0Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M226.25,66.54,219,62.33a19.78,19.78,0,0,0,0-12.66l7.29-4.21a4,4,0,0,0-4-6.92l-7.31,4.21A20,20,0,0,0,204,36.4V28a4,4,0,0,0-8,0v8.4a20,20,0,0,0-10.94,6.35l-7.31-4.21a4,4,0,1,0-4,6.92L181,49.67a19.78,19.78,0,0,0,0,12.66l-7.29,4.21a4,4,0,0,0,2,7.46,3.92,3.92,0,0,0,2-.54l7.31-4.21A20,20,0,0,0,196,75.6V84a4,4,0,0,0,8,0V75.6a20,20,0,0,0,10.94-6.35l7.31,4.21a3.92,3.92,0,0,0,2,.54,4,4,0,0,0,2-7.46ZM200,68a12,12,0,1,1,12-12A12,12,0,0,1,200,68Zm22,40.06a4,4,0,0,0-3.28,4.6A93.58,93.58,0,0,1,220,128a91.69,91.69,0,0,1-26.83,64.87,75.61,75.61,0,0,0-44.51-34,44,44,0,1,0-41.32,0,75.61,75.61,0,0,0-44.51,34A92,92,0,0,1,128,36a93.4,93.4,0,0,1,15.34,1.27,4,4,0,0,0,1.32-7.89,99.89,99.89,0,1,0,82,82A4,4,0,0,0,222,108.06ZM92,120a36,36,0,1,1,36,36A36,36,0,0,1,92,120ZM68.87,198.42a68,68,0,0,1,118.27,0,91.81,91.81,0,0,1-118.27,0Z"
        }))
    ]
]);


const $2f437e07b97666ee$export$3006507487a721d3 = $7fPBF.forwardRef((o, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: a,
        ...o,
        weights: (0, $7338905cfd832840$export$2e2bcd8739ae039)
    }));
$2f437e07b97666ee$export$3006507487a721d3.displayName = "UserCircleGearIcon";
const $2f437e07b97666ee$export$6ceef15b42e6d619 = $2f437e07b97666ee$export$3006507487a721d3;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $a70125795049fe98$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20ZM79.57,196.57a60,60,0,0,1,96.86,0,83.72,83.72,0,0,1-96.86,0ZM100,120a28,28,0,1,1,28,28A28,28,0,0,1,100,120ZM194,179.94a83.48,83.48,0,0,0-29-23.42,52,52,0,1,0-74,0,83.48,83.48,0,0,0-29,23.42,84,84,0,1,1,131.9,0Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a95.76,95.76,0,0,1-31.8,71.37A72,72,0,0,0,128,160a40,40,0,1,0-40-40,40,40,0,0,0,40,40,72,72,0,0,0-64.2,39.37h0A96,96,0,1,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24ZM74.08,197.5a64,64,0,0,1,107.84,0,87.83,87.83,0,0,1-107.84,0ZM96,120a32,32,0,1,1,32,32A32,32,0,0,1,96,120Zm97.76,66.41a79.66,79.66,0,0,0-36.06-28.75,48,48,0,1,0-59.4,0,79.66,79.66,0,0,0-36.06,28.75,88,88,0,1,1,131.52,0Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M172,120a44,44,0,1,1-44-44A44.05,44.05,0,0,1,172,120Zm60,8A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88.09,88.09,0,0,0-91.47-87.93C77.43,41.89,39.87,81.12,40,128.25a87.65,87.65,0,0,0,22.24,58.16A79.71,79.71,0,0,1,84,165.1a4,4,0,0,1,4.83.32,59.83,59.83,0,0,0,78.28,0,4,4,0,0,1,4.83-.32,79.71,79.71,0,0,1,21.79,21.31A87.62,87.62,0,0,0,216,128Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26ZM71.44,198a66,66,0,0,1,113.12,0,89.8,89.8,0,0,1-113.12,0ZM94,120a34,34,0,1,1,34,34A34,34,0,0,1,94,120Zm99.51,69.64a77.53,77.53,0,0,0-40-31.38,46,46,0,1,0-51,0,77.53,77.53,0,0,0-40,31.38,90,90,0,1,1,131,0Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24ZM74.08,197.5a64,64,0,0,1,107.84,0,87.83,87.83,0,0,1-107.84,0ZM96,120a32,32,0,1,1,32,32A32,32,0,0,1,96,120Zm97.76,66.41a79.66,79.66,0,0,0-36.06-28.75,48,48,0,1,0-59.4,0,79.66,79.66,0,0,0-36.06,28.75,88,88,0,1,1,131.52,0Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28ZM68.87,198.42a68,68,0,0,1,118.26,0,91.8,91.8,0,0,1-118.26,0Zm124.3-5.55a75.61,75.61,0,0,0-44.51-34,44,44,0,1,0-41.32,0,75.61,75.61,0,0,0-44.51,34,92,92,0,1,1,130.34,0ZM128,156a36,36,0,1,1,36-36A36,36,0,0,1,128,156Z"
        }))
    ]
]);


const $0c61379047732f24$export$9daf73c3c6a408a2 = $7fPBF.forwardRef((o, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: c,
        ...o,
        weights: (0, $a70125795049fe98$export$2e2bcd8739ae039)
    }));
$0c61379047732f24$export$9daf73c3c6a408a2.displayName = "UserCircleIcon";
const $0c61379047732f24$export$33256dee473898a = $0c61379047732f24$export$9daf73c3c6a408a2;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $27244bf9a945b438$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M164,56a12,12,0,0,1,12-12h48a12,12,0,0,1,0,24H176A12,12,0,0,1,164,56Zm65.85,36A108,108,0,1,1,128,20a109.19,109.19,0,0,1,18,1.49,12,12,0,0,1-4,23.67A85,85,0,0,0,128,44,83.94,83.94,0,0,0,62.05,179.94a83.48,83.48,0,0,1,29-23.42,52,52,0,1,1,74,0,83.36,83.36,0,0,1,29,23.42A83.94,83.94,0,0,0,207.22,100a12,12,0,0,1,22.63-8ZM128,148a28,28,0,1,0-28-28A28,28,0,0,0,128,148Zm0,64a83.53,83.53,0,0,0,48.43-15.43,60,60,0,0,0-96.86,0A83.53,83.53,0,0,0,128,212Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a95.76,95.76,0,0,1-31.8,71.37A72,72,0,0,0,128,160a40,40,0,1,0-40-40,40,40,0,0,0,40,40,72,72,0,0,0-64.2,39.37h0A96,96,0,1,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,56a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H176A8,8,0,0,1,168,56Zm58.08,37.33a103.93,103.93,0,1,1-80.76-67.89,8,8,0,0,1-2.64,15.78A88.07,88.07,0,0,0,40,128a87.62,87.62,0,0,0,22.24,58.41A79.66,79.66,0,0,1,98.3,157.66a48,48,0,1,1,59.4,0,79.66,79.66,0,0,1,36.06,28.75A88,88,0,0,0,211,98.67a8,8,0,0,1,15.09-5.34ZM128,152a32,32,0,1,0-32-32A32,32,0,0,0,128,152Zm0,64a87.57,87.57,0,0,0,53.92-18.5,64,64,0,0,0-107.84,0A87.57,87.57,0,0,0,128,216Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,76a44,44,0,1,1-44,44A44,44,0,0,1,128,76Zm48-12h48a8,8,0,0,0,0-16H176a8,8,0,0,0,0,16Zm39.87,24.46A8,8,0,0,0,211,98.67a88,88,0,0,1-17.23,87.74A79.86,79.86,0,0,0,172,165.1a4,4,0,0,0-4.84.32,59.81,59.81,0,0,1-78.27,0A4,4,0,0,0,84,165.1a79.71,79.71,0,0,0-21.79,21.31A88,88,0,0,1,128,40a88.76,88.76,0,0,1,14.68,1.22,8,8,0,0,0,2.64-15.78,103.9,103.9,0,1,0,80.76,67.89A8,8,0,0,0,215.87,88.46Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M170,56a6,6,0,0,1,6-6h48a6,6,0,0,1,0,12H176A6,6,0,0,1,170,56Zm54.19,38A101.9,101.9,0,1,1,145,27.41a6,6,0,1,1-2,11.83A91.66,91.66,0,0,0,128,38,89.95,89.95,0,0,0,62.49,189.64a77.53,77.53,0,0,1,40-31.38,46,46,0,1,1,51,0,77.53,77.53,0,0,1,40,31.38A90,90,0,0,0,212.88,98a6,6,0,1,1,11.31-4ZM128,154a34,34,0,1,0-34-34A34,34,0,0,0,128,154Zm0,64A89.58,89.58,0,0,0,184.56,198a66,66,0,0,0-113.12,0A89.58,89.58,0,0,0,128,218Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,56a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H176A8,8,0,0,1,168,56Zm58.08,37.33a103.93,103.93,0,1,1-80.76-67.89,8,8,0,0,1-2.64,15.78A88.07,88.07,0,0,0,40,128a87.62,87.62,0,0,0,22.24,58.41A79.66,79.66,0,0,1,98.3,157.66a48,48,0,1,1,59.4,0,79.66,79.66,0,0,1,36.06,28.75A88,88,0,0,0,211,98.67a8,8,0,0,1,15.09-5.34ZM128,152a32,32,0,1,0-32-32A32,32,0,0,0,128,152Zm0,64a87.57,87.57,0,0,0,53.92-18.5,64,64,0,0,0-107.84,0A87.57,87.57,0,0,0,128,216Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M172,56a4,4,0,0,1,4-4h48a4,4,0,0,1,0,8H176A4,4,0,0,1,172,56Zm50.31,38.67A100,100,0,1,1,128,28a100.69,100.69,0,0,1,16.66,1.38,4,4,0,0,1-1.32,7.89A93.4,93.4,0,0,0,128,36,92,92,0,0,0,62.83,192.87a75.61,75.61,0,0,1,44.51-34,44,44,0,1,1,41.32,0,75.61,75.61,0,0,1,44.51,34,92,92,0,0,0,21.6-95.54,4,4,0,1,1,7.54-2.66ZM128,156a36,36,0,1,0-36-36A36,36,0,0,0,128,156Zm0,64a91.61,91.61,0,0,0,59.14-21.58,68,68,0,0,0-118.27,0A91.56,91.56,0,0,0,128,220Z"
        }))
    ]
]);


const $43867aff44220ee6$export$dcdebfa7a96805c0 = $7fPBF.forwardRef((o, s)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: s,
        ...o,
        weights: (0, $27244bf9a945b438$export$2e2bcd8739ae039)
    }));
$43867aff44220ee6$export$dcdebfa7a96805c0.displayName = "UserCircleMinusIcon";
const $43867aff44220ee6$export$7eba70a43e762324 = $43867aff44220ee6$export$dcdebfa7a96805c0;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $6bc3436cf394e344$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M164,56a12,12,0,0,1,12-12h12V32a12,12,0,0,1,24,0V44h12a12,12,0,0,1,0,24H212V80a12,12,0,0,1-24,0V68H176A12,12,0,0,1,164,56Zm70.51,54A107.88,107.88,0,1,1,146,21.49a12,12,0,0,1-4,23.67A85,85,0,0,0,128,44,83.94,83.94,0,0,0,62.05,179.94a83.48,83.48,0,0,1,29-23.42,52,52,0,1,1,74,0,83.36,83.36,0,0,1,29,23.42A83.52,83.52,0,0,0,212,128a85.2,85.2,0,0,0-1.16-14,12,12,0,0,1,23.67-4ZM128,148a28,28,0,1,0-28-28A28,28,0,0,0,128,148Zm0,64a83.53,83.53,0,0,0,48.43-15.43,60,60,0,0,0-96.86,0A83.53,83.53,0,0,0,128,212Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a95.76,95.76,0,0,1-31.8,71.37A72,72,0,0,0,128,160a40,40,0,1,0-40-40,40,40,0,0,0,40,40,72,72,0,0,0-64.2,39.37h0A96,96,0,1,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,56a8,8,0,0,1,8-8h16V32a8,8,0,0,1,16,0V48h16a8,8,0,0,1,0,16H208V80a8,8,0,0,1-16,0V64H176A8,8,0,0,1,168,56Zm62.56,54.68a103.92,103.92,0,1,1-85.24-85.24,8,8,0,0,1-2.64,15.78A88.07,88.07,0,0,0,40,128a87.62,87.62,0,0,0,22.24,58.41A79.66,79.66,0,0,1,98.3,157.66a48,48,0,1,1,59.4,0,79.66,79.66,0,0,1,36.06,28.75A87.62,87.62,0,0,0,216,128a88.85,88.85,0,0,0-1.22-14.68,8,8,0,1,1,15.78-2.64ZM128,152a32,32,0,1,0-32-32A32,32,0,0,0,128,152Zm0,64a87.57,87.57,0,0,0,53.92-18.5,64,64,0,0,0-107.84,0A87.57,87.57,0,0,0,128,216Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,76a44,44,0,1,1-44,44A44,44,0,0,1,128,76Zm48-12h16V80a8,8,0,0,0,16,0V64h16a8,8,0,0,0,0-16H208V32a8,8,0,0,0-16,0V48H176a8,8,0,0,0,0,16Zm45.35,40.11a8,8,0,0,0-6.57,9.21A88.85,88.85,0,0,1,216,128a87.62,87.62,0,0,1-22.24,58.41A79.86,79.86,0,0,0,172,165.1a4,4,0,0,0-4.84.32,59.81,59.81,0,0,1-78.27,0A4,4,0,0,0,84,165.1a79.71,79.71,0,0,0-21.79,21.31A88,88,0,0,1,128,40a88.76,88.76,0,0,1,14.68,1.22,8,8,0,0,0,2.64-15.78,103.92,103.92,0,1,0,85.24,85.24A8,8,0,0,0,221.35,104.11Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M170,56a6,6,0,0,1,6-6h18V32a6,6,0,0,1,12,0V50h18a6,6,0,0,1,0,12H206V80a6,6,0,0,1-12,0V62H176A6,6,0,0,1,170,56Zm58.59,55A101.9,101.9,0,1,1,145,27.41a6,6,0,1,1-2,11.83A91.66,91.66,0,0,0,128,38,89.95,89.95,0,0,0,62.49,189.64a77.53,77.53,0,0,1,40-31.38,46,46,0,1,1,51,0,77.53,77.53,0,0,1,40,31.38A89.65,89.65,0,0,0,218,128a91.76,91.76,0,0,0-1.24-15,6,6,0,1,1,11.83-2ZM128,154a34,34,0,1,0-34-34A34,34,0,0,0,128,154Zm0,64A89.58,89.58,0,0,0,184.56,198a66,66,0,0,0-113.12,0A89.58,89.58,0,0,0,128,218Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,56a8,8,0,0,1,8-8h16V32a8,8,0,0,1,16,0V48h16a8,8,0,0,1,0,16H208V80a8,8,0,0,1-16,0V64H176A8,8,0,0,1,168,56Zm62.56,54.68a103.92,103.92,0,1,1-85.24-85.24,8,8,0,0,1-2.64,15.78A88.07,88.07,0,0,0,40,128a87.62,87.62,0,0,0,22.24,58.41A79.66,79.66,0,0,1,98.3,157.66a48,48,0,1,1,59.4,0,79.66,79.66,0,0,1,36.06,28.75A87.62,87.62,0,0,0,216,128a88.85,88.85,0,0,0-1.22-14.68,8,8,0,1,1,15.78-2.64ZM128,152a32,32,0,1,0-32-32A32,32,0,0,0,128,152Zm0,64a87.57,87.57,0,0,0,53.92-18.5,64,64,0,0,0-107.84,0A87.57,87.57,0,0,0,128,216Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M172,56a4,4,0,0,1,4-4h20V32a4,4,0,0,1,8,0V52h20a4,4,0,0,1,0,8H204V80a4,4,0,0,1-8,0V60H176A4,4,0,0,1,172,56Zm54.62,55.34a99.89,99.89,0,1,1-82-82,4,4,0,0,1-1.32,7.89A93.4,93.4,0,0,0,128,36,92,92,0,0,0,62.83,192.87a75.61,75.61,0,0,1,44.51-34,44,44,0,1,1,41.32,0,75.61,75.61,0,0,1,44.51,34A91.69,91.69,0,0,0,220,128a93.58,93.58,0,0,0-1.27-15.34,4,4,0,0,1,7.89-1.32ZM128,156a36,36,0,1,0-36-36A36,36,0,0,0,128,156Zm0,64a91.61,91.61,0,0,0,59.14-21.58,68,68,0,0,0-118.27,0A91.56,91.56,0,0,0,128,220Z"
        }))
    ]
]);


const $3a96a83bceac7286$export$237d26d4b8472a = $7fPBF.forwardRef((o, s)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: s,
        ...o,
        weights: (0, $6bc3436cf394e344$export$2e2bcd8739ae039)
    }));
$3a96a83bceac7286$export$237d26d4b8472a.displayName = "UserCirclePlusIcon";
const $3a96a83bceac7286$export$66630ebdd93d8756 = $3a96a83bceac7286$export$237d26d4b8472a;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $e60adf923457164b$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M125.18,156.94a64,64,0,1,0-82.36,0,100.23,100.23,0,0,0-39.49,32,12,12,0,0,0,19.35,14.2,76,76,0,0,1,122.64,0,12,12,0,0,0,19.36-14.2A100.33,100.33,0,0,0,125.18,156.94ZM44,108a40,40,0,1,1,40,40A40,40,0,0,1,44,108Zm206.1,97.67a12,12,0,0,1-16.78-2.57A76.31,76.31,0,0,0,172,172a12,12,0,0,1,0-24,40,40,0,1,0-10.3-78.67,12,12,0,1,1-6.16-23.19,64,64,0,0,1,57.64,110.8,100.23,100.23,0,0,1,39.49,32A12,12,0,0,1,250.1,205.67Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M136,108A52,52,0,1,1,84,56,52,52,0,0,1,136,108Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M117.25,157.92a60,60,0,1,0-66.5,0A95.83,95.83,0,0,0,3.53,195.63a8,8,0,1,0,13.4,8.74,80,80,0,0,1,134.14,0,8,8,0,0,0,13.4-8.74A95.83,95.83,0,0,0,117.25,157.92ZM40,108a44,44,0,1,1,44,44A44.05,44.05,0,0,1,40,108Zm210.14,98.7a8,8,0,0,1-11.07-2.33A79.83,79.83,0,0,0,172,168a8,8,0,0,1,0-16,44,44,0,1,0-16.34-84.87,8,8,0,1,1-5.94-14.85,60,60,0,0,1,55.53,105.64,95.83,95.83,0,0,1,47.22,37.71A8,8,0,0,1,250.14,206.7Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M164.47,195.63a8,8,0,0,1-6.7,12.37H10.23a8,8,0,0,1-6.7-12.37,95.83,95.83,0,0,1,47.22-37.71,60,60,0,1,1,66.5,0A95.83,95.83,0,0,1,164.47,195.63Zm87.91-.15a95.87,95.87,0,0,0-47.13-37.56A60,60,0,0,0,144.7,54.59a4,4,0,0,0-1.33,6A75.83,75.83,0,0,1,147,150.53a4,4,0,0,0,1.07,5.53,112.32,112.32,0,0,1,29.85,30.83,23.92,23.92,0,0,1,3.65,16.47,4,4,0,0,0,3.95,4.64h60.3a8,8,0,0,0,7.73-5.93A8.22,8.22,0,0,0,252.38,195.48Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M112.6,158.43a58,58,0,1,0-57.2,0A93.83,93.83,0,0,0,5.21,196.72a6,6,0,0,0,10.05,6.56,82,82,0,0,1,137.48,0,6,6,0,0,0,10-6.56A93.83,93.83,0,0,0,112.6,158.43ZM38,108a46,46,0,1,1,46,46A46.06,46.06,0,0,1,38,108Zm211,97a6,6,0,0,1-8.3-1.74A81.8,81.8,0,0,0,172,166a6,6,0,0,1,0-12,46,46,0,1,0-17.08-88.73,6,6,0,1,1-4.46-11.14,58,58,0,0,1,50.14,104.3,93.83,93.83,0,0,1,50.19,38.29A6,6,0,0,1,249,205Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M117.25,157.92a60,60,0,1,0-66.5,0A95.83,95.83,0,0,0,3.53,195.63a8,8,0,1,0,13.4,8.74,80,80,0,0,1,134.14,0,8,8,0,0,0,13.4-8.74A95.83,95.83,0,0,0,117.25,157.92ZM40,108a44,44,0,1,1,44,44A44.05,44.05,0,0,1,40,108Zm210.14,98.7a8,8,0,0,1-11.07-2.33A79.83,79.83,0,0,0,172,168a8,8,0,0,1,0-16,44,44,0,1,0-16.34-84.87,8,8,0,1,1-5.94-14.85,60,60,0,0,1,55.53,105.64,95.83,95.83,0,0,1,47.22,37.71A8,8,0,0,1,250.14,206.7Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M107.19,159a56,56,0,1,0-46.38,0A91.83,91.83,0,0,0,6.88,197.81a4,4,0,1,0,6.7,4.37,84,84,0,0,1,140.84,0,4,4,0,1,0,6.7-4.37A91.83,91.83,0,0,0,107.19,159ZM36,108a48,48,0,1,1,48,48A48.05,48.05,0,0,1,36,108Zm212,95.35a4,4,0,0,1-5.53-1.17A83.81,83.81,0,0,0,172,164a4,4,0,0,1,0-8,48,48,0,1,0-17.82-92.58,4,4,0,1,1-3-7.43,56,56,0,0,1,44,103,91.83,91.83,0,0,1,53.93,38.86A4,4,0,0,1,248,203.35Z"
        }))
    ]
]);


const $dc77a89d27a4c55c$export$4e04c809deb7a605 = $7fPBF.forwardRef((r, s)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: s,
        ...r,
        weights: (0, $e60adf923457164b$export$2e2bcd8739ae039)
    }));
$dc77a89d27a4c55c$export$4e04c809deb7a605.displayName = "UsersIcon";
const $dc77a89d27a4c55c$export$a69f017b19597ff5 = $dc77a89d27a4c55c$export$4e04c809deb7a605;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $0d21f9db5f9b92df$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M164.38,181.1a52,52,0,1,0-72.76,0,75.89,75.89,0,0,0-30,28.89,12,12,0,0,0,20.78,12,53,53,0,0,1,91.22,0,12,12,0,1,0,20.78-12A75.89,75.89,0,0,0,164.38,181.1ZM100,144a28,28,0,1,1,28,28A28,28,0,0,1,100,144Zm147.21,9.59a12,12,0,0,1-16.81-2.39c-8.33-11.09-19.85-19.59-29.33-21.64a12,12,0,0,1-1.82-22.91,20,20,0,1,0-24.78-28.3,12,12,0,1,1-21-11.6,44,44,0,1,1,73.28,48.35,92.18,92.18,0,0,1,22.85,21.69A12,12,0,0,1,247.21,153.59Zm-192.28-24c-9.48,2.05-21,10.55-29.33,21.65A12,12,0,0,1,6.41,136.79,92.37,92.37,0,0,1,29.26,115.1a44,44,0,1,1,73.28-48.35,12,12,0,1,1-21,11.6,20,20,0,1,0-24.78,28.3,12,12,0,0,1-1.82,22.91Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,144a40,40,0,1,1-40-40A40,40,0,0,1,168,144ZM64,56A32,32,0,1,0,96,88,32,32,0,0,0,64,56Zm128,0a32,32,0,1,0,32,32A32,32,0,0,0,192,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M244.8,150.4a8,8,0,0,1-11.2-1.6A51.6,51.6,0,0,0,192,128a8,8,0,0,1,0-16,24,24,0,1,0-23.24-30,8,8,0,1,1-15.5-4A40,40,0,1,1,219,117.51a67.94,67.94,0,0,1,27.43,21.68A8,8,0,0,1,244.8,150.4ZM190.92,212a8,8,0,1,1-13.85,8,57,57,0,0,0-98.15,0,8,8,0,1,1-13.84-8,72.06,72.06,0,0,1,33.74-29.92,48,48,0,1,1,58.36,0A72.06,72.06,0,0,1,190.92,212ZM128,176a32,32,0,1,0-32-32A32,32,0,0,0,128,176ZM72,120a8,8,0,0,0-8-8A24,24,0,1,1,87.24,82a8,8,0,1,0,15.5-4A40,40,0,1,0,37,117.51,67.94,67.94,0,0,0,9.6,139.19a8,8,0,1,0,12.8,9.61A51.6,51.6,0,0,1,64,128,8,8,0,0,0,72,120Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M64.12,147.8a4,4,0,0,1-4,4.2H16a8,8,0,0,1-7.8-6.17,8.35,8.35,0,0,1,1.62-6.93A67.79,67.79,0,0,1,37,117.51a40,40,0,1,1,66.46-35.8,3.94,3.94,0,0,1-2.27,4.18A64.08,64.08,0,0,0,64,144C64,145.28,64,146.54,64.12,147.8Zm182-8.91A67.76,67.76,0,0,0,219,117.51a40,40,0,1,0-66.46-35.8,3.94,3.94,0,0,0,2.27,4.18A64.08,64.08,0,0,1,192,144c0,1.28,0,2.54-.12,3.8a4,4,0,0,0,4,4.2H240a8,8,0,0,0,7.8-6.17A8.33,8.33,0,0,0,246.17,138.89Zm-89,43.18a48,48,0,1,0-58.37,0A72.13,72.13,0,0,0,65.07,212,8,8,0,0,0,72,224H184a8,8,0,0,0,6.93-12A72.15,72.15,0,0,0,157.19,182.07Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M243.6,148.8a6,6,0,0,1-8.4-1.2A53.58,53.58,0,0,0,192,126a6,6,0,0,1,0-12,26,26,0,1,0-25.18-32.5,6,6,0,0,1-11.62-3,38,38,0,1,1,59.91,39.63A65.69,65.69,0,0,1,244.8,140.4,6,6,0,0,1,243.6,148.8ZM189.19,213a6,6,0,0,1-2.19,8.2,5.9,5.9,0,0,1-3,.81,6,6,0,0,1-5.2-3,59,59,0,0,0-101.62,0,6,6,0,1,1-10.38-6A70.1,70.1,0,0,1,103,182.55a46,46,0,1,1,50.1,0A70.1,70.1,0,0,1,189.19,213ZM128,178a34,34,0,1,0-34-34A34,34,0,0,0,128,178ZM70,120a6,6,0,0,0-6-6A26,26,0,1,1,89.18,81.49a6,6,0,1,0,11.62-3,38,38,0,1,0-59.91,39.63A65.69,65.69,0,0,0,11.2,140.4a6,6,0,1,0,9.6,7.2A53.58,53.58,0,0,1,64,126,6,6,0,0,0,70,120Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M244.8,150.4a8,8,0,0,1-11.2-1.6A51.6,51.6,0,0,0,192,128a8,8,0,0,1-7.37-4.89,8,8,0,0,1,0-6.22A8,8,0,0,1,192,112a24,24,0,1,0-23.24-30,8,8,0,1,1-15.5-4A40,40,0,1,1,219,117.51a67.94,67.94,0,0,1,27.43,21.68A8,8,0,0,1,244.8,150.4ZM190.92,212a8,8,0,1,1-13.84,8,57,57,0,0,0-98.16,0,8,8,0,1,1-13.84-8,72.06,72.06,0,0,1,33.74-29.92,48,48,0,1,1,58.36,0A72.06,72.06,0,0,1,190.92,212ZM128,176a32,32,0,1,0-32-32A32,32,0,0,0,128,176ZM72,120a8,8,0,0,0-8-8A24,24,0,1,1,87.24,82a8,8,0,1,0,15.5-4A40,40,0,1,0,37,117.51,67.94,67.94,0,0,0,9.6,139.19a8,8,0,1,0,12.8,9.61A51.6,51.6,0,0,1,64,128,8,8,0,0,0,72,120Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M237,147.44a4,4,0,0,1-5.48-1.4c-8.33-14-20.93-22-34.56-22a4,4,0,0,1-1.2-.2,36.76,36.76,0,0,1-3.8.2,4,4,0,0,1,0-8,28,28,0,1,0-27.12-35,4,4,0,0,1-7.75-2,36,36,0,1,1,54,39.48c10.81,3.85,20.51,12,27.31,23.48A4,4,0,0,1,237,147.44ZM187.46,214a4,4,0,0,1-1.46,5.46,3.93,3.93,0,0,1-2,.54,4,4,0,0,1-3.46-2,61,61,0,0,0-105.08,0,4,4,0,0,1-6.92-4,68.35,68.35,0,0,1,39.19-31,44,44,0,1,1,40.54,0A68.35,68.35,0,0,1,187.46,214ZM128,180a36,36,0,1,0-36-36A36,36,0,0,0,128,180ZM64,116A28,28,0,1,1,91.12,81a4,4,0,0,0,7.75-2A36,36,0,1,0,45.3,118.75,63.55,63.55,0,0,0,12.8,141.6a4,4,0,0,0,6.4,4.8A55.55,55.55,0,0,1,64,124a4,4,0,0,0,0-8Z"
        }))
    ]
]);


const $e0b8800b731f944b$export$31f7e9379e51640b = $7fPBF.forwardRef((o, s)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: s,
        ...o,
        weights: (0, $0d21f9db5f9b92df$export$2e2bcd8739ae039)
    }));
$e0b8800b731f944b$export$31f7e9379e51640b.displayName = "UsersThreeIcon";
const $e0b8800b731f944b$export$3a0328dbf8744009 = $e0b8800b731f944b$export$31f7e9379e51640b;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $10b2d763e3e38d62$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Zm-12-80V80a12,12,0,0,1,24,0v52a12,12,0,0,1-24,0Zm28,40a16,16,0,1,1-16-16A16,16,0,0,1,144,172Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-8-80V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,172Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm-8,56a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm8,104a12,12,0,1,1,12-12A12,12,0,0,1,128,184Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Zm-6-82V80a6,6,0,0,1,12,0v56a6,6,0,0,1-12,0Zm16,36a10,10,0,1,1-10-10A10,10,0,0,1,138,172Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-8-80V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,172Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Zm-4-84V80a4,4,0,0,1,8,0v56a4,4,0,0,1-8,0Zm12,36a8,8,0,1,1-8-8A8,8,0,0,1,136,172Z"
        }))
    ]
]);


const $a44ba7e85f055b31$export$9f0af3ec4c4725c2 = $7fPBF.forwardRef((o, n)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: n,
        ...o,
        weights: (0, $10b2d763e3e38d62$export$2e2bcd8739ae039)
    }));
$a44ba7e85f055b31$export$9f0af3ec4c4725c2.displayName = "WarningCircleIcon";
const $a44ba7e85f055b31$export$66bc182bb95bd3c2 = $a44ba7e85f055b31$export$9f0af3ec4c4725c2;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $86f7d1e867e705bf$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240.26,186.1,152.81,34.23h0a28.74,28.74,0,0,0-49.62,0L15.74,186.1a27.45,27.45,0,0,0,0,27.71A28.31,28.31,0,0,0,40.55,228h174.9a28.31,28.31,0,0,0,24.79-14.19A27.45,27.45,0,0,0,240.26,186.1Zm-20.8,15.7a4.46,4.46,0,0,1-4,2.2H40.55a4.46,4.46,0,0,1-4-2.2,3.56,3.56,0,0,1,0-3.73L124,46.2a4.77,4.77,0,0,1,8,0l87.44,151.87A3.56,3.56,0,0,1,219.46,201.8ZM116,136V104a12,12,0,0,1,24,0v32a12,12,0,0,1-24,0Zm28,40a16,16,0,1,1-16-16A16,16,0,0,1,144,176Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M215.46,216H40.54C27.92,216,20,202.79,26.13,192.09L113.59,40.22c6.3-11,22.52-11,28.82,0l87.46,151.87C236,202.79,228.08,216,215.46,216Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM222.93,203.8a8.5,8.5,0,0,1-7.48,4.2H40.55a8.5,8.5,0,0,1-7.48-4.2,7.59,7.59,0,0,1,0-7.72L120.52,44.21a8.75,8.75,0,0,1,15,0l87.45,151.87A7.59,7.59,0,0,1,222.93,203.8ZM120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,180Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM120,104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm8,88a12,12,0,1,1,12-12A12,12,0,0,1,128,192Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M235.07,189.09,147.61,37.22h0a22.75,22.75,0,0,0-39.22,0L20.93,189.09a21.53,21.53,0,0,0,0,21.72A22.35,22.35,0,0,0,40.55,222h174.9a22.35,22.35,0,0,0,19.6-11.19A21.53,21.53,0,0,0,235.07,189.09ZM224.66,204.8a10.46,10.46,0,0,1-9.21,5.2H40.55a10.46,10.46,0,0,1-9.21-5.2,9.51,9.51,0,0,1,0-9.72L118.79,43.21a10.75,10.75,0,0,1,18.42,0l87.46,151.87A9.51,9.51,0,0,1,224.66,204.8ZM122,144V104a6,6,0,0,1,12,0v40a6,6,0,0,1-12,0Zm16,36a10,10,0,1,1-10-10A10,10,0,0,1,138,180Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM222.93,203.8a8.5,8.5,0,0,1-7.48,4.2H40.55a8.5,8.5,0,0,1-7.48-4.2,7.59,7.59,0,0,1,0-7.72L120.52,44.21a8.75,8.75,0,0,1,15,0l87.45,151.87A7.59,7.59,0,0,1,222.93,203.8ZM120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,180Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M233.34,190.09,145.88,38.22h0a20.75,20.75,0,0,0-35.76,0L22.66,190.09a19.52,19.52,0,0,0,0,19.71A20.36,20.36,0,0,0,40.54,220H215.46a20.36,20.36,0,0,0,17.86-10.2A19.52,19.52,0,0,0,233.34,190.09ZM226.4,205.8a12.47,12.47,0,0,1-10.94,6.2H40.54a12.47,12.47,0,0,1-10.94-6.2,11.45,11.45,0,0,1,0-11.72L117.05,42.21a12.76,12.76,0,0,1,21.9,0L226.4,194.08A11.45,11.45,0,0,1,226.4,205.8ZM124,144V104a4,4,0,0,1,8,0v40a4,4,0,0,1-8,0Zm12,36a8,8,0,1,1-8-8A8,8,0,0,1,136,180Z"
        }))
    ]
]);


const $e0770788fd5741d9$export$f7dc499a72baa103 = $7fPBF.forwardRef((n, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: a,
        ...n,
        weights: (0, $86f7d1e867e705bf$export$2e2bcd8739ae039)
    }));
$e0770788fd5741d9$export$f7dc499a72baa103.displayName = "WarningIcon";
const $e0770788fd5741d9$export$c688898c4e3580ee = $e0770788fd5741d9$export$f7dc499a72baa103;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $b20dc302f7630ea4$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M116,132V80a12,12,0,0,1,24,0v52a12,12,0,0,1-24,0ZM236,91.55v72.9a19.86,19.86,0,0,1-5.86,14.14l-51.55,51.55A19.85,19.85,0,0,1,164.45,236H91.55a19.85,19.85,0,0,1-14.14-5.86L25.86,178.59A19.86,19.86,0,0,1,20,164.45V91.55a19.86,19.86,0,0,1,5.86-14.14L77.41,25.86A19.85,19.85,0,0,1,91.55,20h72.9a19.85,19.85,0,0,1,14.14,5.86l51.55,51.55A19.86,19.86,0,0,1,236,91.55Zm-24,1.66L162.79,44H93.21L44,93.21v69.58L93.21,212h69.58L212,162.79ZM128,156a16,16,0,1,0,16,16A16,16,0,0,0,128,156Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,91.55v72.9a8,8,0,0,1-2.34,5.66l-51.55,51.55a8,8,0,0,1-5.66,2.34H91.55a8,8,0,0,1-5.66-2.34L34.34,170.11A8,8,0,0,1,32,164.45V91.55a8,8,0,0,1,2.34-5.66L85.89,34.34A8,8,0,0,1,91.55,32h72.9a8,8,0,0,1,5.66,2.34l51.55,51.55A8,8,0,0,1,224,91.55Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M120,136V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0ZM232,91.55v72.9a15.86,15.86,0,0,1-4.69,11.31l-51.55,51.55A15.86,15.86,0,0,1,164.45,232H91.55a15.86,15.86,0,0,1-11.31-4.69L28.69,175.76A15.86,15.86,0,0,1,24,164.45V91.55a15.86,15.86,0,0,1,4.69-11.31L80.24,28.69A15.86,15.86,0,0,1,91.55,24h72.9a15.86,15.86,0,0,1,11.31,4.69l51.55,51.55A15.86,15.86,0,0,1,232,91.55Zm-16,0L164.45,40H91.55L40,91.55v72.9L91.55,216h72.9L216,164.45ZM128,160a12,12,0,1,0,12,12A12,12,0,0,0,128,160Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M227.31,80.23,175.77,28.69A16.13,16.13,0,0,0,164.45,24H91.55a16.13,16.13,0,0,0-11.32,4.69L28.69,80.23A16.13,16.13,0,0,0,24,91.55v72.9a16.13,16.13,0,0,0,4.69,11.32l51.54,51.54A16.13,16.13,0,0,0,91.55,232h72.9a16.13,16.13,0,0,0,11.32-4.69l51.54-51.54A16.13,16.13,0,0,0,232,164.45V91.55A16.13,16.13,0,0,0,227.31,80.23ZM120,80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm8,104a12,12,0,1,1,12-12A12,12,0,0,1,128,184Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M122,136V80a6,6,0,0,1,12,0v56a6,6,0,0,1-12,0ZM230,91.55v72.9a13.92,13.92,0,0,1-4.1,9.9L174.35,225.9a13.92,13.92,0,0,1-9.9,4.1H91.55a13.92,13.92,0,0,1-9.9-4.1L30.1,174.35a13.92,13.92,0,0,1-4.1-9.9V91.55a13.92,13.92,0,0,1,4.1-9.9L81.65,30.1a13.92,13.92,0,0,1,9.9-4.1h72.9a13.92,13.92,0,0,1,9.9,4.1L225.9,81.65A13.92,13.92,0,0,1,230,91.55Zm-12,0a2,2,0,0,0-.59-1.42L165.87,38.59a2,2,0,0,0-1.42-.59H91.55a2,2,0,0,0-1.41.59L38.58,90.13A2,2,0,0,0,38,91.55v72.9a2,2,0,0,0,.59,1.42l51.54,51.54a2,2,0,0,0,1.42.59h72.9a2,2,0,0,0,1.41-.59l51.56-51.54a2,2,0,0,0,.58-1.42ZM128,162a10,10,0,1,0,10,10A10,10,0,0,0,128,162Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M120,136V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0ZM232,91.55v72.9a15.86,15.86,0,0,1-4.69,11.31l-51.55,51.55A15.86,15.86,0,0,1,164.45,232H91.55a15.86,15.86,0,0,1-11.31-4.69L28.69,175.76A15.86,15.86,0,0,1,24,164.45V91.55a15.86,15.86,0,0,1,4.69-11.31L80.24,28.69A15.86,15.86,0,0,1,91.55,24h72.9a15.86,15.86,0,0,1,11.31,4.69l51.55,51.55A15.86,15.86,0,0,1,232,91.55Zm-16,0L164.45,40H91.55L40,91.55v72.9L91.55,216h72.9L216,164.45ZM128,160a12,12,0,1,0,12,12A12,12,0,0,0,128,160Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M124,136V80a4,4,0,0,1,8,0v56a4,4,0,0,1-8,0ZM228,91.55v72.9a12,12,0,0,1-3.51,8.49l-51.55,51.55a12,12,0,0,1-8.49,3.51H91.55a12,12,0,0,1-8.49-3.51L31.51,172.94A12,12,0,0,1,28,164.45V91.55a12,12,0,0,1,3.51-8.49L83.06,31.51A12,12,0,0,1,91.55,28h72.9a12,12,0,0,1,8.49,3.51l51.55,51.55A12,12,0,0,1,228,91.55Zm-8,0a4,4,0,0,0-1.17-2.83L167.28,37.17A4.06,4.06,0,0,0,164.45,36H91.55a4.06,4.06,0,0,0-2.83,1.17L37.17,88.72A4,4,0,0,0,36,91.55v72.9a4,4,0,0,0,1.17,2.83l51.55,51.55A4.06,4.06,0,0,0,91.55,220h72.9a4.06,4.06,0,0,0,2.83-1.17l51.55-51.55a4,4,0,0,0,1.17-2.83ZM128,164a8,8,0,1,0,8,8A8,8,0,0,0,128,164Z"
        }))
    ]
]);


const $dd4997cb53138a7f$export$d724908cf9d2c1d6 = $7fPBF.forwardRef((a, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...a,
        weights: (0, $b20dc302f7630ea4$export$2e2bcd8739ae039)
    }));
$dd4997cb53138a7f$export$d724908cf9d2c1d6.displayName = "WarningOctagonIcon";
const $dd4997cb53138a7f$export$b3ab82ed3bd4a42 = $dd4997cb53138a7f$export$d724908cf9d2c1d6;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $ad2378bfcea91324$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,104a40,40,0,1,0-40,40A40,40,0,0,0,168,104Zm-56,0a16,16,0,1,1,16,16A16,16,0,0,1,112,104Zm112,92H140v-8.87a84,84,0,1,0-24,0V196H32a12,12,0,0,0,0,24H224a12,12,0,0,0,0-24ZM68,104a60,60,0,1,1,60,60A60.07,60.07,0,0,1,68,104Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,32a72,72,0,1,0,72,72A72,72,0,0,0,128,32Zm0,104a32,32,0,1,1,32-32A32,32,0,0,1,128,136Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,104a40,40,0,1,0-40,40A40,40,0,0,0,168,104Zm-64,0a24,24,0,1,1,24,24A24,24,0,0,1,104,104Zm120,96H136V183.6a80,80,0,1,0-16,0V200H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16ZM64,104a64,64,0,1,1,64,64A64.07,64.07,0,0,1,64,104Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M160,104a32,32,0,1,1-32-32A32,32,0,0,1,160,104Zm72,104a8,8,0,0,1-8,8H32a8,8,0,0,1,0-16h88V183.6a80,80,0,1,1,16,0V200h88A8,8,0,0,1,232,208ZM128,152a48,48,0,1,0-48-48A48.05,48.05,0,0,0,128,152Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M166,104a38,38,0,1,0-38,38A38,38,0,0,0,166,104Zm-64,0a26,26,0,1,1,26,26A26,26,0,0,1,102,104Zm122,98H134V181.75a78,78,0,1,0-12,0V202H32a6,6,0,0,0,0,12H224a6,6,0,0,0,0-12ZM62,104a66,66,0,1,1,66,66A66.08,66.08,0,0,1,62,104Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,104a40,40,0,1,0-40,40A40,40,0,0,0,168,104Zm-64,0a24,24,0,1,1,24,24A24,24,0,0,1,104,104Zm120,96H136V183.6a80,80,0,1,0-16,0V200H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16ZM64,104a64,64,0,1,1,64,64A64.07,64.07,0,0,1,64,104Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M164,104a36,36,0,1,0-36,36A36,36,0,0,0,164,104Zm-64,0a28,28,0,1,1,28,28A28,28,0,0,1,100,104ZM224,204H132V179.89a76,76,0,1,0-8,0V204H32a4,4,0,0,0,0,8H224a4,4,0,0,0,0-8ZM60,104a68,68,0,1,1,68,68A68.07,68.07,0,0,1,60,104Z"
        }))
    ]
]);


const $77a13c24fe4b2b0f$export$e04ff9953a6cd98f = $7fPBF.forwardRef((a, m)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: m,
        ...a,
        weights: (0, $ad2378bfcea91324$export$2e2bcd8739ae039)
    }));
$77a13c24fe4b2b0f$export$e04ff9953a6cd98f.displayName = "WebcamIcon";
const $77a13c24fe4b2b0f$export$8e57ef02c5f4056d = $77a13c24fe4b2b0f$export$e04ff9953a6cd98f;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $44142da105f90d5b$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216.88,207.93l-160-176A12,12,0,1,0,39.12,48.07L53.93,64.36A84,84,0,0,0,116,187.13V196H32a12,12,0,0,0,0,24H195.42l3.7,4.07a12,12,0,0,0,17.76-16.14ZM68,104a59.84,59.84,0,0,1,3.52-20.29l12.91,14.2A44,44,0,0,0,128,148c.64,0,1.28,0,1.92-.05l12.9,14.19A60,60,0,0,1,68,104Zm72,92v-8.87a84.41,84.41,0,0,0,20.42-5.63L173.6,196ZM88.89,42.35a12,12,0,0,1,6.37-15.73A84,84,0,0,1,201.91,143.94a12,12,0,0,1-10.56,6.29,11.84,11.84,0,0,1-5.7-1.45,12,12,0,0,1-4.84-16.26,60,60,0,0,0-76.19-83.8A12,12,0,0,1,88.89,42.35ZM172,103.64a12,12,0,0,1-11.9,12.1H160a12,12,0,0,1-12-11.91A20,20,0,0,0,130.06,84.1a12,12,0,1,1,2.42-23.87A43.92,43.92,0,0,1,172,103.64Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,32a72,72,0,1,0,72,72A72,72,0,0,0,128,32Zm0,104a32,32,0,1,1,32-32A32,32,0,0,1,128,136Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.92,210.62l-160-176A8,8,0,1,0,42.08,45.38L58.82,63.8A80,80,0,0,0,120,183.6V200H32a8,8,0,0,0,0,16H197.19l4.89,5.38a8,8,0,1,0,11.84-10.76ZM64,104a63.65,63.65,0,0,1,6.26-27.62L88.68,96.64A40,40,0,0,0,128,144c1.2,0,2.39-.06,3.58-.17L150,164.11A64,64,0,0,1,64,104Zm72,96V183.59a79.91,79.91,0,0,0,25.44-6.91L182.64,200ZM85.52,45.31a8,8,0,0,1,3-10.91,80,80,0,0,1,105,115.5,8,8,0,1,1-13.1-9.19,64,64,0,0,0-84-92.4A8,8,0,0,1,85.52,45.31Zm65.31,66.12A24,24,0,0,0,128,80a24.17,24.17,0,0,0-5.24.57A8,8,0,1,1,119.3,65,40,40,0,0,1,166,116.38a8,8,0,0,1-15.21-4.95Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M83.34,43.19a4,4,0,0,1,.78-6A80,80,0,0,1,190.39,154a4,4,0,0,1-6.11.22l-16.43-18.08a4,4,0,0,1-.3-5,48,48,0,0,0-62.84-69.11,4,4,0,0,1-4.94-.78ZM126.93,72a31.8,31.8,0,0,0-8.43,1.42A4,4,0,0,0,116.75,80l34.12,37.53a4,4,0,0,0,6.67-1.18A31.84,31.84,0,0,0,160,104,32.36,32.36,0,0,0,126.93,72Zm86.45,149.9a8,8,0,0,1-11.3-.54L197.19,216H32a8,8,0,0,1-8-8.53A8.17,8.17,0,0,1,32.27,200H120V183.6A79.93,79.93,0,0,1,58.86,63.84L42.08,45.38A8,8,0,1,1,53.92,34.62l160,176A8,8,0,0,1,213.38,221.92ZM128,152a48.17,48.17,0,0,0,10-1.06l-13.79-15.17A32,32,0,0,1,96,104.71L82.23,89.55A48,48,0,0,0,128,152Zm54.64,48-21.22-23.34A79.24,79.24,0,0,1,136,183.6V200Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M212.44,212,52.44,36A6,6,0,0,0,43.56,44L61.31,63.56A78,78,0,0,0,122,181.75V202H32a6,6,0,0,0,0,12H198.07l5.49,6a6,6,0,0,0,8.88-8.08Zm-91.67-83a26.05,26.05,0,0,1-18.31-20.15ZM62,104a65.6,65.6,0,0,1,7.78-31.12L90.85,96.06A38,38,0,0,0,128,142a37.59,37.59,0,0,0,4.38-.26l21.06,23.17A66,66,0,0,1,62,104Zm72,98V181.76a78.27,78.27,0,0,0,27.93-7.51L187.16,202ZM87.26,44.32a6,6,0,0,1,2.26-8.18A78,78,0,0,1,191.89,148.75a6,6,0,1,1-9.82-6.89A66,66,0,0,0,95.44,46.57,6,6,0,0,1,87.26,44.32Zm65.47,67.73a26,26,0,0,0-30.4-33.43,6,6,0,1,1-2.6-11.72,38,38,0,0,1,44.41,48.86,6,6,0,0,1-11.41-3.71Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.92,210.62l-160-176A8,8,0,1,0,42.08,45.38L58.82,63.8A80,80,0,0,0,120,183.6V200H32a8,8,0,0,0,0,16H197.19l4.89,5.38a8,8,0,1,0,11.84-10.76ZM64,104a63.65,63.65,0,0,1,6.26-27.62L88.68,96.64A40,40,0,0,0,128,144c1.2,0,2.39-.06,3.58-.17L150,164.11A64,64,0,0,1,64,104Zm72,96V183.59a79.91,79.91,0,0,0,25.44-6.91L182.64,200ZM85.52,45.31a8,8,0,0,1,3-10.91,80,80,0,0,1,105,115.5,8,8,0,1,1-13.1-9.19,64,64,0,0,0-84-92.4A8,8,0,0,1,85.52,45.31Zm65.31,66.12A24,24,0,0,0,128,80a24.17,24.17,0,0,0-5.24.57A8,8,0,1,1,119.3,65,40,40,0,0,1,166,116.38a8,8,0,0,1-15.21-4.95Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M211,213.31,51,37.31A4,4,0,0,0,45,42.69L63.8,63.32A76,76,0,0,0,124,179.89V204H32a4,4,0,0,0,0,8H199l6.08,6.69a4,4,0,1,0,5.92-5.38ZM100,103.18l26.14,28.75A28,28,0,0,1,100,104C100,103.73,100,103.45,100,103.18ZM60,104a67.62,67.62,0,0,1,9.4-34.52L93,95.48a36,36,0,0,0,40.13,44.14l23.63,26A68,68,0,0,1,60,104Zm72,100V179.89a76.09,76.09,0,0,0,30.39-8.11L191.69,204ZM89,43.33a4,4,0,0,1,1.5-5.45A76,76,0,0,1,190.26,147.6a4,4,0,1,1-6.55-4.59A68,68,0,0,0,94.46,44.83,4,4,0,0,1,89,43.33Zm65.63,69.34a28,28,0,0,0-32.73-36,4,4,0,0,1-1.74-7.81,36,36,0,0,1,42.08,46.28,4,4,0,0,1-3.8,2.77,4.12,4.12,0,0,1-1.24-.2A4,4,0,0,1,154.63,112.67Z"
        }))
    ]
]);


const $c7c6d28f1cedca54$export$f058a904087aeb21 = $7fPBF.forwardRef((o, m)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: m,
        ...o,
        weights: (0, $44142da105f90d5b$export$2e2bcd8739ae039)
    }));
$c7c6d28f1cedca54$export$f058a904087aeb21.displayName = "WebcamSlashIcon";
const $c7c6d28f1cedca54$export$2d29d27305fc7b0e = $c7c6d28f1cedca54$export$f058a904087aeb21;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $e7a8b8d2e369a10f$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,84a36,36,0,1,0-36-36A36,36,0,0,0,176,84Zm0-48a12,12,0,1,1-12,12A12,12,0,0,1,176,36Zm29.28,96.39a12,12,0,0,1,2.49,10l-16,80A12,12,0,0,1,180,232a11.87,11.87,0,0,1-2.36-.23,12,12,0,0,1-9.42-14.12L181.36,152H124a12,12,0,0,1-10.4-18l17.92-31.2a76.1,76.1,0,0,0-79.88,10.55A12,12,0,0,1,36.36,94.86a100,100,0,0,1,118.19-6.68,12,12,0,0,1,3.85,16L144.74,128H196A12,12,0,0,1,205.28,132.39Zm-41.47,44.52a64,64,0,1,1-73.64-68.16,12,12,0,0,1,3.66,23.72,40,40,0,1,0,46.05,42.62,12,12,0,1,1,23.93,1.82Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,48a24,24,0,1,1-24-24A24,24,0,0,1,200,48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,80a32,32,0,1,0-32-32A32,32,0,0,0,176,80Zm0-48a16,16,0,1,1-16,16A16,16,0,0,1,176,32Zm-8,136a64,64,0,1,1-64-64,8,8,0,0,1,0,16,48,48,0,1,0,48,48,8,8,0,0,1,16,0Zm38.19-37.07a8,8,0,0,1,1.65,6.64l-16,80A8,8,0,0,1,184,224a7.77,7.77,0,0,1-1.58-.16,8,8,0,0,1-6.27-9.41L190.24,144H128a8,8,0,0,1-6.94-12l20.06-34.9a80.09,80.09,0,0,0-88,9.17A8,8,0,1,1,42.91,94a96,96,0,0,1,113.46-6.42,8,8,0,0,1,2.57,10.69L141.82,128H200A8,8,0,0,1,206.19,130.93Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,48a32,32,0,1,1,32,32A32,32,0,0,1,144,48Zm16,112a8,8,0,0,0-8,8,48,48,0,1,1-48-48,8,8,0,0,0,0-16,64,64,0,1,0,64,64A8,8,0,0,0,160,160Zm40-32H141.82l17.12-29.78a8,8,0,0,0-2.57-10.69A96,96,0,0,0,42.91,94a8,8,0,1,0,10.18,12.33,80.09,80.09,0,0,1,88-9.17L121.06,132A8,8,0,0,0,128,144h62.24l-14.08,70.43a8,8,0,0,0,6.27,9.41A7.77,7.77,0,0,0,184,224a8,8,0,0,0,7.83-6.43l16-80A8,8,0,0,0,200,128Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,78a30,30,0,1,0-30-30A30,30,0,0,0,176,78Zm0-48a18,18,0,1,1-18,18A18,18,0,0,1,176,30ZM166,168a62,62,0,1,1-62-62,6,6,0,0,1,0,12,50,50,0,1,0,50,50,6,6,0,0,1,12,0Zm38.64-35.8a6,6,0,0,1,1.24,5l-16,80A6,6,0,0,1,184,222a6.08,6.08,0,0,1-1.19-.12,6,6,0,0,1-4.7-7.06L192.68,142H128a6,6,0,0,1-5.2-9l21.07-36.68a82.05,82.05,0,0,0-92.05,8.41,6,6,0,1,1-7.64-9.25,94,94,0,0,1,111.1-6.28,6,6,0,0,1,1.92,8L138.37,130H200A6,6,0,0,1,204.64,132.2Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,80a32,32,0,1,0-32-32A32,32,0,0,0,176,80Zm0-48a16,16,0,1,1-16,16A16,16,0,0,1,176,32Zm-8,136a64,64,0,1,1-64-64,8,8,0,0,1,0,16,48,48,0,1,0,48,48,8,8,0,0,1,16,0Zm38.19-37.07a8,8,0,0,1,1.65,6.64l-16,80A8,8,0,0,1,184,224a7.77,7.77,0,0,1-1.58-.16,8,8,0,0,1-6.27-9.41L190.24,144H128a8,8,0,0,1-6.94-12l20.06-34.9a80.09,80.09,0,0,0-88,9.17A8,8,0,1,1,42.91,94a96,96,0,0,1,113.46-6.42,8,8,0,0,1,2.57,10.69L141.82,128H200A8,8,0,0,1,206.19,130.93Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,76a28,28,0,1,0-28-28A28,28,0,0,0,176,76Zm0-48a20,20,0,1,1-20,20A20,20,0,0,1,176,28ZM164,168a60,60,0,1,1-60-60,4,4,0,0,1,0,8,52,52,0,1,0,52,52,4,4,0,0,1,8,0Zm39.09-34.54a4,4,0,0,1,.83,3.32l-16,80A4,4,0,0,1,184,220a3.44,3.44,0,0,1-.78-.08,4,4,0,0,1-3.14-4.7l15-75.22H128a4,4,0,0,1-3.47-6l22.08-38.42a84.05,84.05,0,0,0-96.06,7.61A4,4,0,0,1,45.45,97a92,92,0,0,1,108.73-6.15,4,4,0,0,1,1.29,5.34L134.91,132H200A4,4,0,0,1,203.09,133.46Z"
        }))
    ]
]);


const $47d7fdd528e7358c$export$70f2a162da142226 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: t,
        ...r,
        weights: (0, $e7a8b8d2e369a10f$export$2e2bcd8739ae039)
    }));
$47d7fdd528e7358c$export$70f2a162da142226.displayName = "WheelchairMotionIcon";
const $47d7fdd528e7358c$export$e9d9aed032f78cf2 = $47d7fdd528e7358c$export$70f2a162da142226;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $dc69b3668a951ff0$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,204a16,16,0,1,1-16-16A16,16,0,0,1,144,204ZM239.61,83.91a176,176,0,0,0-223.22,0,12,12,0,1,0,15.23,18.55,152,152,0,0,1,192.76,0,12,12,0,1,0,15.23-18.55Zm-32.16,35.73a128,128,0,0,0-158.9,0,12,12,0,0,0,14.9,18.81,104,104,0,0,1,129.1,0,12,12,0,0,0,14.9-18.81ZM175.07,155.3a80.05,80.05,0,0,0-94.14,0,12,12,0,0,0,14.14,19.4,56,56,0,0,1,65.86,0,12,12,0,1,0,14.14-19.4Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M238.2,87.69l-104,125.43a8,8,0,0,1-12.3,0L17.8,87.69a7.79,7.79,0,0,1,1.31-11.21,180.75,180.75,0,0,1,217.78,0A7.79,7.79,0,0,1,238.2,87.69Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M247.89,80.91a15.93,15.93,0,0,0-6.17-10.81A186.67,186.67,0,0,0,128,32,186.67,186.67,0,0,0,14.28,70.1,15.93,15.93,0,0,0,8.11,80.91,15.65,15.65,0,0,0,11.65,92.8l104,125.43A15.93,15.93,0,0,0,128,224h0a15.93,15.93,0,0,0,12.31-5.77l104-125.43A15.65,15.65,0,0,0,247.89,80.91ZM128,208,24.09,82.74A170.76,170.76,0,0,1,128,48,170.76,170.76,0,0,1,231.91,82.74Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M244.35,92.8l-104,125.43A15.93,15.93,0,0,1,128,224h0a15.93,15.93,0,0,1-12.31-5.77L11.65,92.8A15.65,15.65,0,0,1,8.11,80.91,15.93,15.93,0,0,1,14.28,70.1,186.67,186.67,0,0,1,128,32,186.67,186.67,0,0,1,241.72,70.1a15.93,15.93,0,0,1,6.17,10.81A15.65,15.65,0,0,1,244.35,92.8Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M138,204a10,10,0,1,1-10-10A10,10,0,0,1,138,204ZM235.81,88.55a170,170,0,0,0-215.62,0,6,6,0,1,0,7.62,9.27,158,158,0,0,1,200.38,0,6,6,0,1,0,7.62-9.27Zm-32.08,35.79a122,122,0,0,0-151.46,0,6,6,0,0,0,7.46,9.41,110,110,0,0,1,136.54,0A6,6,0,0,0,200,135a6,6,0,0,0,3.73-10.7Zm-32.2,35.81a74,74,0,0,0-87.06,0,6,6,0,0,0,7.06,9.7,62,62,0,0,1,72.94,0,6,6,0,0,0,8.38-1.32A6,6,0,0,0,171.53,160.15Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M140,204a12,12,0,1,1-12-12A12,12,0,0,1,140,204ZM237.08,87A172,172,0,0,0,18.92,87,8,8,0,0,0,29.08,99.37a156,156,0,0,1,197.84,0A8,8,0,0,0,237.08,87ZM205,122.77a124,124,0,0,0-153.94,0A8,8,0,0,0,61,135.31a108,108,0,0,1,134.06,0,8,8,0,0,0,11.24-1.3A8,8,0,0,0,205,122.77Zm-32.26,35.76a76.05,76.05,0,0,0-89.42,0,8,8,0,0,0,9.42,12.94,60,60,0,0,1,70.58,0,8,8,0,1,0,9.42-12.94Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M136,204a8,8,0,1,1-8-8A8,8,0,0,1,136,204ZM234.54,90.1a168,168,0,0,0-213.08,0,4,4,0,1,0,5.08,6.18,160,160,0,0,1,202.92,0,4,4,0,0,0,5.08-6.18Zm-32.06,35.81a120,120,0,0,0-149,0,4,4,0,0,0,5,6.27,112,112,0,0,1,139,0,4,4,0,0,0,5-6.27Zm-32.13,35.86a72,72,0,0,0-84.7,0,4,4,0,1,0,4.7,6.46,64.07,64.07,0,0,1,75.3,0,4,4,0,0,0,5.58-.87A4,4,0,0,0,170.35,161.77Z"
        }))
    ]
]);


const $e1dc4c4bf0ea2b94$export$bb1fb2a6f6348cd5 = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: r,
        ...e,
        weights: (0, $dc69b3668a951ff0$export$2e2bcd8739ae039)
    }));
$e1dc4c4bf0ea2b94$export$bb1fb2a6f6348cd5.displayName = "WifiHighIcon";
const $e1dc4c4bf0ea2b94$export$d379813183cf10c8 = $e1dc4c4bf0ea2b94$export$bb1fb2a6f6348cd5;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $747258aaf7db1bda$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M230.47,67.5a12,12,0,0,0-19.26-4.32L172.43,99l-12.68-2.72L157,83.57l35.79-38.78a12,12,0,0,0-4.32-19.26A76.07,76.07,0,0,0,88.41,121.64L30.92,174.18a4.68,4.68,0,0,0-.39.38,36,36,0,0,0,50.91,50.91l.38-.39,52.54-57.49A76.05,76.05,0,0,0,230.47,67.5ZM160,148a51.5,51.5,0,0,1-23.35-5.52,12,12,0,0,0-14.26,2.62L64.31,208.66a12,12,0,0,1-17-17l63.55-58.07a12,12,0,0,0,2.62-14.26A51.5,51.5,0,0,1,108,96a52.06,52.06,0,0,1,52-52h.89L135.17,71.87a12,12,0,0,0-2.91,10.65l5.66,26.35a12,12,0,0,0,9.21,9.21l26.35,5.66a12,12,0,0,0,10.65-2.91L212,95.12c0,.3,0,.59,0,.89A52.06,52.06,0,0,1,160,148Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,96a64,64,0,0,1-94.94,56L73,217A24,24,0,0,1,39,183L104,126.94a64,64,0,0,1,80-90.29L144,80l5.66,26.34L176,112l43.35-40A63.8,63.8,0,0,1,224,96Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M226.76,69a8,8,0,0,0-12.84-2.88l-40.3,37.19-17.23-3.7-3.7-17.23,37.19-40.3A8,8,0,0,0,187,29.24,72,72,0,0,0,88,96,72.34,72.34,0,0,0,94,124.94L33.79,177c-.15.12-.29.26-.43.39a32,32,0,0,0,45.26,45.26c.13-.13.27-.28.39-.42L131.06,162A72,72,0,0,0,232,96,71.56,71.56,0,0,0,226.76,69ZM160,152a56.14,56.14,0,0,1-27.07-7,8,8,0,0,0-9.92,1.77L67.11,211.51a16,16,0,0,1-22.62-22.62L109.18,133a8,8,0,0,0,1.77-9.93,56,56,0,0,1,58.36-82.31l-31.2,33.81a8,8,0,0,0-1.94,7.1L141.83,108a8,8,0,0,0,6.14,6.14l26.35,5.66a8,8,0,0,0,7.1-1.94l33.81-31.2A56.06,56.06,0,0,1,160,152Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,96a72,72,0,0,1-100.94,66L79,222.22c-.12.14-.26.29-.39.42a32,32,0,0,1-45.26-45.26c.14-.13.28-.27.43-.39L94,124.94a72.07,72.07,0,0,1,83.54-98.78,8,8,0,0,1,3.93,13.19L144,80l5.66,26.35L176,112l40.65-37.52a8,8,0,0,1,13.19,3.93A72.6,72.6,0,0,1,232,96Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224.91,69.75a6,6,0,0,0-9.63-2.16l-41.07,37.9L154.7,101.3l-4.19-19.51,37.9-41.07a6,6,0,0,0-2.16-9.63,70,70,0,0,0-89.77,94.39l-61.39,53c-.11.09-.21.19-.32.3A30,30,0,0,0,77.2,221.23c.11-.11.21-.21.3-.32l53-61.39a70,70,0,0,0,94.39-89.77ZM160,154a58,58,0,0,1-28-7.22,6,6,0,0,0-7.45,1.33L68.57,212.88a18,18,0,0,1-25.45-25.45l64.76-55.94A6,6,0,0,0,109.2,124a58,58,0,0,1,64-84.53L139.58,75.93a6,6,0,0,0-1.45,5.33l5.65,26.35a6,6,0,0,0,4.61,4.61l26.35,5.65a6,6,0,0,0,5.33-1.45L216.49,82.8A58.06,58.06,0,0,1,160,154Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M226.76,69a8,8,0,0,0-12.84-2.88l-40.3,37.19-17.23-3.7-3.7-17.23,37.19-40.3A8,8,0,0,0,187,29.24,72,72,0,0,0,88,96,72.34,72.34,0,0,0,94,124.94L33.79,177c-.15.12-.29.26-.43.39a32,32,0,0,0,45.26,45.26c.13-.13.27-.28.39-.42L131.06,162A72,72,0,0,0,232,96,71.56,71.56,0,0,0,226.76,69ZM160,152a56.14,56.14,0,0,1-27.07-7,8,8,0,0,0-9.92,1.77L67.11,211.51a16,16,0,0,1-22.62-22.62L109.18,133a8,8,0,0,0,1.77-9.93,56,56,0,0,1,58.36-82.31l-31.2,33.81a8,8,0,0,0-1.94,7.1L141.83,108a8,8,0,0,0,6.14,6.14l26.35,5.66a8,8,0,0,0,7.1-1.94l33.81-31.2A56.06,56.06,0,0,1,160,152Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M223.05,70.5a4,4,0,0,0-6.42-1.44l-41.82,38.6L153,103l-4.68-21.79,38.6-41.82a4,4,0,0,0-1.44-6.43A68,68,0,0,0,98.94,126L36.4,180l-.21.2a28,28,0,0,0,39.6,39.6l.2-.21,54-62.54A68,68,0,0,0,228,96,67.51,67.51,0,0,0,223.05,70.5ZM160,156a60,60,0,0,1-29-7.47,4,4,0,0,0-5,.89L70,214.25A20,20,0,0,1,41.75,186l64.82-56a4,4,0,0,0,.89-5,60,60,0,0,1,69.46-86.59L141.05,77.29a4,4,0,0,0-1,3.55l5.66,26.35a4,4,0,0,0,3.07,3.07l26.35,5.66a4,4,0,0,0,3.55-1l38.87-35.87A60.05,60.05,0,0,1,160,156Z"
        }))
    ]
]);


const $52a0c24a3d3e2214$export$bc176c2a10341979 = $7fPBF.forwardRef((r, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: c,
        ...r,
        weights: (0, $747258aaf7db1bda$export$2e2bcd8739ae039)
    }));
$52a0c24a3d3e2214$export$bc176c2a10341979.displayName = "WrenchIcon";
const $52a0c24a3d3e2214$export$4421f7c88022a750 = $52a0c24a3d3e2214$export$bc176c2a10341979;


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $a0c0ddd5f94cc7bc$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168.49,104.49,145,128l23.52,23.51a12,12,0,0,1-17,17L128,145l-23.51,23.52a12,12,0,0,1-17-17L111,128,87.51,104.49a12,12,0,0,1,17-17L128,111l23.51-23.52a12,12,0,0,1,17,17ZM236,128A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M165.66,101.66,139.31,128l26.35,26.34a8,8,0,0,1-11.32,11.32L128,139.31l-26.34,26.35a8,8,0,0,1-11.32-11.32L116.69,128,90.34,101.66a8,8,0,0,1,11.32-11.32L128,116.69l26.34-26.35a8,8,0,0,1,11.32,11.32ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm37.66,130.34a8,8,0,0,1-11.32,11.32L128,139.31l-26.34,26.35a8,8,0,0,1-11.32-11.32L116.69,128,90.34,101.66a8,8,0,0,1,11.32-11.32L128,116.69l26.34-26.35a8,8,0,0,1,11.32,11.32L139.31,128Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M164.24,100.24,136.48,128l27.76,27.76a6,6,0,1,1-8.48,8.48L128,136.48l-27.76,27.76a6,6,0,0,1-8.48-8.48L119.52,128,91.76,100.24a6,6,0,0,1,8.48-8.48L128,119.52l27.76-27.76a6,6,0,0,1,8.48,8.48ZM230,128A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M165.66,101.66,139.31,128l26.35,26.34a8,8,0,0,1-11.32,11.32L128,139.31l-26.34,26.35a8,8,0,0,1-11.32-11.32L116.69,128,90.34,101.66a8,8,0,0,1,11.32-11.32L128,116.69l26.34-26.35a8,8,0,0,1,11.32,11.32ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M162.83,98.83,133.66,128l29.17,29.17a4,4,0,0,1-5.66,5.66L128,133.66,98.83,162.83a4,4,0,0,1-5.66-5.66L122.34,128,93.17,98.83a4,4,0,0,1,5.66-5.66L128,122.34l29.17-29.17a4,4,0,1,1,5.66,5.66ZM228,128A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z"
        }))
    ]
]);


const $99a54942b2884ad1$export$a5090bbd7fc88fde = $7fPBF.forwardRef((r, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), {
        ref: c,
        ...r,
        weights: (0, $a0c0ddd5f94cc7bc$export$2e2bcd8739ae039)
    }));
$99a54942b2884ad1$export$a5090bbd7fc88fde.displayName = "XCircleIcon";
const $99a54942b2884ad1$export$b60d12aebd1d3ca4 = $99a54942b2884ad1$export$a5090bbd7fc88fde;



parcelRequire("7fPBF");
const $00b3ccebbd02c720$var$SvgAirbnb = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 3c-2.722 0-5.478 1.427-6.9 4.215a1470.458 1470.458 0 0 0-8.717 17.172 395.607 395.607 0 0 0-3.174 6.498c-.82 1.731-1.347 2.88-1.563 3.566l-.001.002v.002c-.287.932-.594 2.026-.594 3.256C4.05 42.832 8.23 47 13.359 47c5.674 0 9.677-4.539 11.553-6.69l.088.114.088-.113C26.964 42.46 30.968 47 36.64 47c5.128 0 9.308-4.168 9.308-9.29 0-1.229-.307-2.323-.594-3.255v-.002l-.001-.002c-.216-.686-.743-1.835-1.563-3.566a395.62 395.62 0 0 0-3.174-6.498c-2.52-5.066-5.71-11.335-8.717-17.172l-.002-.002C30.476 4.427 27.721 3 25 3zm0 2c2.038 0 4.042 1.013 5.12 3.125v.002h.001a1470.142 1470.142 0 0 1 8.707 17.15 393.642 393.642 0 0 1 3.156 6.463c.81 1.71 1.358 2.984 1.46 3.305.273.888.505 1.776.505 2.666A7.281 7.281 0 0 1 36.641 45c-4.577 0-8.45-4.147-10.332-6.252l1.058-1.353C29.07 35.216 32 31.09 32 26.959 32 23.127 28.848 20 25 20s-7 3.127-7 6.959c0 4.14 2.932 8.263 4.633 10.437l1.058 1.354C21.808 40.855 17.935 45 13.36 45a7.281 7.281 0 0 1-7.308-7.29c0-.89.232-1.777.506-2.665.1-.32.65-1.596 1.459-3.305.81-1.71 1.899-3.936 3.156-6.463a1470.142 1470.142 0 0 1 8.707-17.15h.002v-.002C20.958 6.013 22.96 5 25 5zm0 17c2.77 0 5 2.219 5 4.959 0 3.111-2.609 7.157-4.209 9.205L25 37.178l-.793-1.014C22.608 34.12 20 30.083 20 26.96 20 24.219 22.23 22 25 22z"
        })
    });
var $00b3ccebbd02c720$export$2e2bcd8739ae039 = $00b3ccebbd02c720$var$SvgAirbnb;



parcelRequire("7fPBF");
const $c8355b7723d13ecc$var$SvgAmazon = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25.406 3c-6.101 0-12.82 2.313-14.218 9.813-.2.8.406 1.18.906 1.28l6.219.595c.601 0 .988-.586 1.187-1.188.5-2.602 2.695-3.906 5.094-3.906 1.3 0 2.793.52 3.593 1.719.899 1.3.72 3.093.72 4.593v.906c-3.7.399-8.5.688-12 2.188-4 1.7-6.813 5.207-6.813 10.406 0 6.602 4.199 9.907 9.5 9.907 4.5 0 7-1.118 10.5-4.72 1.199 1.7 1.617 2.512 3.718 4.313.2.102.395.188.594.188.301 0 .606-.082.907-.282v.094c1.3-1.101 3.574-3.21 4.874-4.312.5-.399.399-1.086 0-1.688-1.199-1.5-2.374-2.906-2.374-5.906v-9.906c0-4.2.289-8.102-2.813-11C32.5 3.793 28.508 3 25.406 3Zm0 2c2.7 0 6.188.695 8.188 2.594 2.101 2 2.218 4.5 2.218 8.5V27c0 3.3 1.274 5.094 2.376 6.594-.301.199-.575.511-.876.812v-.093l-2.906 2.593c-1.101-1-1.52-1.593-2.218-2.593-.102-.2-.301-.418-.5-.72l-1.375-2-1.72 1.72c-3.1 3.199-5.1 4.093-9 4.093-4.698 0-7.5-3.008-7.5-7.906 0-4 1.993-6.992 5.595-8.594 2.601-1.101 6.3-1.511 9.5-1.812.699-.102 1.304-.086 1.906-.188l1.812-.218V15.5c0-1.602.008-3.488-1.093-5.187-1.102-1.602-3.02-2.626-5.22-2.626-3.398 0-6.105 1.907-6.905 4.907l-4.188-.406C15.102 5.988 21.605 5 25.406 5Zm1.688 15c-7.899.5-9.594 4.805-9.594 8.406C17.398 32.305 19.813 35 23.313 35c2.5 0 4.789-1.508 6.187-3.906 1.398-2.5 1.406-4.79 1.406-7.188V20Zm0 2h1.812v1.406c0 2.5.082 4.489-1.218 6.688-1 1.8-2.676 2.906-4.375 2.906-2.399 0-3.907-1.793-3.907-4.594 0-4.699 3.688-6.105 7.688-6.406Zm17.594 14.594c-1.602 0-3.477.406-4.876 1.406-.398.3-.406.688.094.688 1.602-.2 5.207-.68 5.907.218.601.801-.711 4.18-1.313 5.782-.2.5.195.613.594.312 2.699-2.3 3.406-6.992 2.906-7.594-.3-.5-1.71-.812-3.312-.812ZM2.313 37.5c-.301 0-.524.512-.126.813C8.188 43.71 16.2 47 25 47c6.3 0 13.586-1.988 18.688-5.687.8-.602.113-1.618-.688-1.22-5.7 2.4-11.805 3.594-17.406 3.594-8.301 0-16.282-2.3-22.781-6-.2-.199-.399-.187-.5-.187Z"
        })
    });
var $c8355b7723d13ecc$export$2e2bcd8739ae039 = $c8355b7723d13ecc$var$SvgAmazon;



parcelRequire("7fPBF");
const $5433efa7792edf57$var$SvgAmazonMusic = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14 4C8.489 4 4 8.489 4 14v22c0 5.511 4.489 10 10 10h22c5.511 0 10-4.489 10-10V14c0-5.511-4.489-10-10-10H14zm0 2h22c4.43 0 8 3.57 8 8v22c0 4.43-3.57 8-8 8H14c-4.43 0-8-3.57-8-8V14c0-4.43 3.57-8 8-8zm20 12.01a1 1 0 0 0 0 2 1 1 0 0 0 0-2zm-24.75 3v7h1.5v-5.14c.493-.12.987-.234 1.477-.364.5-.136.975.234 1.017.66l.008 4.844h1.5l.002-2.5.006-1.25-.006-.625-.004-.317a2.47 2.47 0 0 0-.06-.433c.512-.124 1.027-.244 1.537-.38.5-.136.975.236 1.017.661l.008 4.844h1.5l.002-2.5.006-1.25-.006-.625-.004-.317a2.223 2.223 0 0 0-1.158-1.879 2.179 2.179 0 0 0-1.733-.14c-.566.193-1.127.402-1.69.61a2.178 2.178 0 0 0-.577-.47 2.179 2.179 0 0 0-1.733-.14c-.371.127-.74.266-1.109.4v-.69h-1.5zm12.5 0-1.498.002.002 2.42c-.01.823-.017 1.577.01 2.457.043.614.376 1.173.818 1.529.445.361.991.55 1.533.586a2.776 2.776 0 0 0 1.516-.344c.04-.02.079-.045.119-.066v.234h1.5v-6.816h-1.5v5.353c-.212.074-.425.143-.633.225-.352.149-.579.174-.885.14-.574-.07-1.011-.527-.976-.918.009-.732.012-1.592-.002-2.382l-.004-2.42zm11.5 0v7h1.5v-7h-1.5zm5.975.004c-.355.02-.71.1-1.036.24-1.32.578-1.969 1.937-1.939 3.148.01.568.1 1.163.35 1.75.26.57.72 1.137 1.35 1.463.62.335 1.32.43 1.95.383.38-.037.75-.103 1.1-.215V26.76c-.89.14-1.77.14-2.33-.242-.63-.391-.93-1.23-.92-2.133-.02-.82.38-1.603 1.06-1.977.64-.345 1.47-.205 2.19.29v-1.231c-.23-.14-.47-.25-.74-.334a3.025 3.025 0 0 0-1.035-.12zm-9.52.011a3.707 3.707 0 0 0-.785.157c-.883.278-1.515.873-1.602 1.482-.162 1.14.672 1.806 1.082 1.99.41.222.78.32 1.12.416.69.165 1.128.352 1.287.598a.675.675 0 0 1 .123.418c0 .18-.04.341-.23.457-.39.213-1.06.29-1.67.223-.61-.058-1.39-.33-2.03-.59v1.074c.59.367 1.22.562 1.87.678.77.106 1.56.174 2.45-.213.43-.174.951-.563.951-1.621 0-1.104-.8-1.59-1.2-1.783-.4-.203-.77-.3-1.11-.407-.33-.107-1.201-.249-1.201-1 0-.313.33-.487.58-.564.84-.28 1.83-.065 2.66.361v-1.238a4.447 4.447 0 0 0-2.295-.438zm9.899 9.985c-1.111 0-2.43.28-3.403.98-.278.21-.278.49.069.49 1.11-.14 3.611-.49 4.097.14.417.56-.485 2.942-.902 4.062-.14.35.14.419.418.209 1.875-1.611 2.361-4.903 2.013-5.323-.208-.349-1.181-.558-2.292-.558zm-30.641.761a.249.249 0 0 0-.147.088.253.253 0 0 0 .038.354c2.06 1.668 4.39 2.94 6.857 3.93 2.474.958 5.097 1.614 7.785 1.794a25.292 25.292 0 0 0 7.986-.73c2.597-.672 5.072-1.705 7.286-3.275a.5.5 0 0 0-.498-.862l-.04.018c-2.265 1.043-4.727 1.775-7.17 2.28-2.451.51-4.964.703-7.449.616-2.49-.1-4.965-.597-7.398-1.289-2.414-.74-4.82-1.671-7.068-2.888l-.016-.01a.248.248 0 0 0-.166-.026z"
        })
    });
var $5433efa7792edf57$export$2e2bcd8739ae039 = $5433efa7792edf57$var$SvgAmazonMusic;



parcelRequire("7fPBF");
const $a3a92e462d72dd79$var$SvgAndroidOs = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M16.375-.031c-.043.008-.086.02-.125.031a1.004 1.004 0 0 0-.719.621.99.99 0 0 0 .125.942l2.125 3.187c-3.597 1.89-6.18 5.152-6.781 9.031V14c-.004.05-.004.105 0 .156v1.406A3.93 3.93 0 0 0 9 15c-2.2 0-4 1.8-4 4v12c0 2.2 1.8 4 4 4a3.93 3.93 0 0 0 2-.562V37c0 1.645 1.355 3 3 3h1v6c0 2.2 1.8 4 4 4s4-1.8 4-4v-6h4v6c0 2.2 1.8 4 4 4s4-1.8 4-4v-6h1c1.645 0 3-1.355 3-3v-2.562A3.93 3.93 0 0 0 41 35c2.2 0 4-1.8 4-4V19c0-2.2-1.8-4-4-4a3.93 3.93 0 0 0-2 .563v-1.376a1.13 1.13 0 0 0 0-.28v-.063c-.582-3.906-3.164-7.196-6.781-9.094l2.125-3.187a.993.993 0 0 0 .023-1.137 1 1 0 0 0-1.68.012l-2.343 3.468C28.695 3.312 26.883 3 25 3c-1.883 0-3.695.313-5.344.906L17.313.438c-.2-.32-.563-.5-.938-.47ZM25 5c1.879 0 3.64.367 5.188 1.031a.879.879 0 0 0 .093.032C33.411 7.433 35.688 10 36.563 13H13.436c.864-2.957 3.094-5.492 6.157-6.875a.842.842 0 0 0 .187-.094C21.336 5.36 23.11 5 25 5Zm-5.5 3c-.832 0-1.5.672-1.5 1.5 0 .832.668 1.5 1.5 1.5a1.5 1.5 0 0 0 0-3Zm11 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM13 15h24v22c0 .563-.437 1-1 1h-7.812a1.016 1.016 0 0 0-.407 0H16.188a1.016 1.016 0 0 0-.407 0H14c-.562 0-1-.437-1-1Zm-4 2c1.117 0 2 .883 2 2v12c0 1.117-.883 2-2 2s-2-.883-2-2V19c0-1.117.883-2 2-2Zm32 0c1.117 0 2 .883 2 2v12c0 1.117-.883 2-2 2s-2-.883-2-2V19c0-1.117.883-2 2-2ZM17 40h4v6c0 1.117-.883 2-2 2s-2-.883-2-2Zm12 0h4v6c0 1.117-.883 2-2 2s-2-.883-2-2Z"
        })
    });
var $a3a92e462d72dd79$export$2e2bcd8739ae039 = $a3a92e462d72dd79$var$SvgAndroidOs;



parcelRequire("7fPBF");
const $319817bcb0975b64$var$SvgAndroidTablet = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M6.906 7.969A.88.88 0 0 0 6.813 8H3c-1.645 0-3 1.355-3 3v28c0 1.645 1.355 3 3 3h44c1.645 0 3-1.355 3-3V11c0-1.645-1.355-3-3-3h-2.812a.972.972 0 0 0-.282-.031c-.043.008-.086.02-.125.031H7.22a.936.936 0 0 0-.313-.031ZM3 10h3v30H3c-.555 0-1-.445-1-1V11c0-.555.445-1 1-1Zm5 0h35v30H8Zm37 0h2c.555 0 1 .445 1 1v28c0 .555-.445 1-1 1h-2Zm-22.594 6.969a.311.311 0 0 0-.062.031.498.498 0 0 0-.309.293.493.493 0 0 0 .027.426l.532 1.093a3.967 3.967 0 0 0-1.563 2.907c-.004.054-.031.101-.031.156A.668.668 0 0 0 21 22v6c0 .523.184 1.059.563 1.438.128.128.28.226.437.312V32c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879v-2h2v2c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879v-2.25c.156-.086.309-.184.438-.312.378-.38.562-.915.562-1.438v-5.844c.004-.05.004-.105 0-.156v-.125c0-.055-.027-.102-.031-.156a3.967 3.967 0 0 0-1.563-2.907l.532-1.093a.5.5 0 0 0-.563-.719.496.496 0 0 0-.312.281l-.5 1.032A4.013 4.013 0 0 0 25 18c-.55 0-1.082.11-1.562.313l-.5-1.032a.496.496 0 0 0-.47-.312h-.062ZM25 20c.809 0 1.43.387 1.75 1h-3.5c.32-.613.941-1 1.75-1Zm-21.094.969c-.043.008-.086.02-.125.031A1.002 1.002 0 0 0 3 22v6c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879v-6a1 1 0 0 0-1.094-1.031Zm15 0c-.043.008-.086.02-.125.031A1.002 1.002 0 0 0 18 22v5c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879v-5a1 1 0 0 0-1.094-1.031Zm12 0c-.043.008-.086.02-.125.031A1.002 1.002 0 0 0 30 22v5c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879v-5a1 1 0 0 0-1.094-1.031ZM23 23h4v4.969h-.094a.88.88 0 0 0-.093.031h-3.594a1.019 1.019 0 0 0-.219-.031Z"
        })
    });
var $319817bcb0975b64$export$2e2bcd8739ae039 = $319817bcb0975b64$var$SvgAndroidTablet;



parcelRequire("7fPBF");
const $7562bb96cc645793$var$SvgAppleFitness = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14 3.99c-5.51 0-10 4.49-10 10v22c0 5.51 4.49 10 10 10h22c5.51 0 10-4.49 10-10v-22c0-5.51-4.49-10-10-10H14zm0 2h22c4.41 0 8 3.59 8 8v22c0 4.41-3.59 8-8 8H14c-4.41 0-8-3.59-8-8v-22c0-4.41 3.59-8 8-8zM25 8C15.63 8 8 15.63 8 25c0 9.37 7.63 17 17 17 .81 0 1.6-.06 2.38-.17C35.63 40.67 42 33.56 42 25c0-8.56-6.37-15.67-14.62-16.83.38.51.62 1.15.62 1.83 0 .85-.36 1.62-.93 2.17C33.26 13.16 38 18.53 38 25s-4.74 11.84-10.93 12.83c-.68.11-1.37.17-2.07.17-7.17 0-13-5.83-13-13s5.83-13 13-13c1.1 0 2-.9 2-2s-.9-2-2-2zm0 5c-6.62 0-12 5.38-12 12s5.38 12 12 12c.07 0 .14 0 .2-.01.76 0 1.5-.09 2.22-.23h.01C32.89 35.63 37 30.79 37 25s-4.11-10.63-9.57-11.76c.36.5.57 1.11.57 1.76 0 .89-.4 1.7-1.02 2.25C30.44 18.14 33 21.28 33 25c0 3.72-2.56 6.86-6.02 7.75-.63.16-1.3.25-1.98.25-4.41 0-8-3.59-8-8s3.59-8 8-8c1.1 0 2-.9 2-2 0-.13-.01-.25-.04-.38v-.02c-.02-.11-.05-.21-.09-.31-.03-.09-.08-.17-.12-.25-.04-.08-.09-.15-.14-.22-.12-.16-.25-.3-.41-.42-.01 0-.01-.01-.02-.02-.07-.05-.15-.09-.23-.14-.14-.07-.29-.13-.44-.17-.1-.03-.2-.05-.31-.06-.06-.01-.13-.01-.2-.01zm0 5c-3.86 0-7 3.14-7 7s3.14 7 7 7c.07 0 .14 0 .21-.01h.02c.01 0 .03 0 .04-.01h.02c.82-.02 1.59-.19 2.31-.49A6.99 6.99 0 0 0 32 25a6.99 6.99 0 0 0-4.4-6.49c.25.44.4.95.4 1.49 0 1.04-.54 1.96-1.34 2.5.8.54 1.34 1.46 1.34 2.5s-.54 1.96-1.34 2.5c-.48.31-1.05.5-1.66.5-1.65 0-3-1.35-3-3s1.35-3 3-3c1.1 0 2-.9 2-2 0-.13-.01-.25-.04-.38v-.02c-.02-.11-.05-.21-.09-.31-.01-.02-.02-.05-.03-.07-.04-.1-.09-.19-.14-.27-.05-.08-.1-.15-.16-.22a2.32 2.32 0 0 0-.32-.31c-.04-.04-.09-.06-.13-.09-.05-.03-.09-.06-.14-.09-.08-.04-.16-.07-.24-.11l-.21-.06c-.06-.02-.14-.04-.21-.05h-.02c-.01-.01-.03-.01-.04-.01h-.02C25.14 18 25.07 18 25 18z"
        })
    });
var $7562bb96cc645793$export$2e2bcd8739ae039 = $7562bb96cc645793$var$SvgAppleFitness;



parcelRequire("7fPBF");
const $960c6f50f044d54a$var$SvgAppleLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M33.375 0c-2.836.191-5.871 1.879-7.75 4.156-1.645 2.004-3.023 4.946-2.5 8-.469-.144-.895-.16-1.406-.344-1.395-.496-2.989-1.03-4.969-1.03-3.934 0-7.96 2.34-10.5 6.25C2.555 22.71 3.297 32.706 8.906 41.25c.989 1.5 2.14 3.137 3.563 4.438 1.422 1.3 3.14 2.292 5.156 2.312 1.723.02 2.922-.555 4-1.031 1.078-.477 2.082-.899 3.969-.907h.031c1.879-.015 2.852.399 3.906.876 1.055.476 2.242 1.078 3.969 1.062 2.055-.016 3.8-1.14 5.25-2.531 1.45-1.39 2.64-3.098 3.625-4.594 1.41-2.148 1.977-3.32 3.063-5.719a1.001 1.001 0 0 0-.562-1.344c-3.556-1.343-5.583-4.488-5.876-7.812-.293-3.324 1.113-6.746 4.656-8.687.262-.141.446-.387.508-.676a1.007 1.007 0 0 0-.195-.825c-2.543-3.16-6.121-5.03-9.625-5.03-2.235 0-3.875.527-5.219 1.03-.223.086-.387.079-.594.157 1.364-.719 2.567-1.715 3.469-2.875 1.64-2.106 2.906-5.102 2.438-8.25A.999.999 0 0 0 33.375 0Zm-1.062 2.375c-.067 2.02-.758 3.996-1.907 5.469-1.203 1.547-3.226 2.617-5.187 2.937.035-1.941.8-3.953 1.968-5.375 1.227-1.484 3.258-2.554 5.125-3.031ZM16.75 12.781c1.613 0 2.906.418 4.281.906 1.375.489 2.824 1.063 4.532 1.063 1.667 0 2.988-.578 4.28-1.062 1.294-.485 2.583-.907 4.5-.907 2.505 0 5.212 1.301 7.344 3.563-3.414 2.41-5.011 6.168-4.687 9.812.324 3.684 2.543 7.18 6.188 9-.79 1.719-1.31 2.856-2.47 4.625-.956 1.457-2.093 3.051-3.343 4.25-1.25 1.2-2.574 1.957-3.906 1.969-1.285.012-2.016-.371-3.125-.875-1.11-.504-2.543-1.082-4.75-1.062-2.203.011-3.657.566-4.782 1.062-1.125.496-1.863.887-3.156.875-1.367-.012-2.636-.676-3.843-1.781-1.208-1.106-2.297-2.614-3.25-4.063-5.25-8-5.672-17.398-2.657-22.031 2.211-3.402 5.723-5.344 8.844-5.344Z"
        })
    });
var $960c6f50f044d54a$export$2e2bcd8739ae039 = $960c6f50f044d54a$var$SvgAppleLogo;



parcelRequire("7fPBF");
const $c05f531d54f5030b$var$SvgAppleNews = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14 3.99c-5.511 0-10 4.49-10 10v22c0 5.511 4.489 10 10 10h22c5.511 0 10-4.489 10-10v-22c0-5.51-4.489-10-10-10H14zm0 2h22c4.431 0 8 3.57 8 8v22c0 4.431-3.569 8-8 8H14c-4.431 0-8-3.569-8-8v-22c0-4.43 3.569-8 8-8zm-.25 6.26c-.827 0-1.5.673-1.5 1.5v6.31c0 .405.158.783.443 1.067l16.178 16.18c.285.286.664.443 1.068.443h6.311c.827 0 1.5-.673 1.5-1.5v-6.38c0-.398-.158-.774-.443-1.058l-16.121-16.12a1.487 1.487 0 0 0-1.055-.442H13.75zm13.12 0c-.604 0-1.145.362-1.397.963a1.514 1.514 0 0 0 .338 1.594l.18.14a28.377 28.377 0 0 1 9.062 9.065l.138.174c.283.284.661.435 1.057.435.192 0 .39-.035.58-.11.56-.235.92-.777.92-1.38V13.75c0-.827-.673-1.5-1.5-1.5h-9.379zm-12.62 2h5.666L35.75 30.084v5.666h-5.605L14.25 19.855V14.25zm14.299 0h7.201v7.203a30.219 30.219 0 0 0-7.201-7.203zM13.615 25.385a1.627 1.627 0 0 0-.445.103c-.56.236-.92.778-.92 1.381v9.381c0 .827.673 1.5 1.5 1.5h9.38a1.5 1.5 0 0 0 1.382-.922l.015-.04a1.514 1.514 0 0 0-.338-1.595l-.18-.14a28.377 28.377 0 0 1-9.062-9.065l-.138-.174a1.488 1.488 0 0 0-1.194-.43zm.635 3.162a30.219 30.219 0 0 0 7.201 7.203H14.25v-7.203z"
        })
    });
var $c05f531d54f5030b$export$2e2bcd8739ae039 = $c05f531d54f5030b$var$SvgAppleNews;



parcelRequire("7fPBF");
const $596bbe84e95bafd3$var$SvgApplePay = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9.984 15.002c-.835.04-1.866.571-2.455 1.318-.54.644-1.001 1.69-.884 2.672.943.082 1.885-.492 2.474-1.219.58-.747.963-1.748.865-2.771zM18 17v15h2.375v-5h3.25c2.983 0 5.125-2.075 5.125-5s-2.103-5-5.047-5H18zm-8.266 2c-.8 0-1.465.214-1.95.395-.487.18-.855.27-.745.27.099 0-.241-.083-.678-.259-.436-.176-1.021-.402-1.738-.402-1.625 0-3.087.966-3.88 2.371-.799 1.383-.869 2.992-.61 4.467.259 1.474.845 2.844 1.556 3.879.317.465.684.983 1.176 1.43.492.445 1.167.841 1.979.841H4.88c.638-.024 1.12-.237 1.424-.361.304-.124.456-.19.845-.19.383 0 .54.07.873.205.334.136.86.354 1.541.354.803 0 1.478-.405 1.938-.854.46-.447.782-.948 1.082-1.388l.002-.002a8.858 8.858 0 0 0 1.127-2.37l.248-.882-.86-.322s-1.27-.372-1.283-1.989v-.002a2.087 2.087 0 0 1 .512-1.412 2.689 2.689 0 0 1 .518-.478c.033-.023-.04.04.12-.084l.749-.572-.526-.782C12.088 19.224 10.405 19 9.734 19zm10.641 0h2.75c2.047 0 3.25 1.105 3.25 3s-1.193 3-3.25 3h-2.75v-6zm-10.64 2c.133 0 .62.143 1.115.443-.023.026-.04.035-.063.063a4.184 4.184 0 0 0-.969 2.705c.015 1.805.928 2.69 1.686 3.227-.123.338-.18.62-.57 1.19l-.002.003c-.307.45-.586.852-.825 1.084-.238.232-.357.285-.543.285-.305 0-.435-.062-.787-.205-.351-.143-.907-.354-1.627-.354-.703 0-1.252.196-1.601.338-.338.138-.468.194-.719.207-.173-.003-.354-.074-.621-.316-.273-.247-.577-.648-.867-1.074v-.002l-.002-.002c-.527-.766-1.032-1.932-1.236-3.096-.205-1.164-.11-2.296.37-3.125l.005-.006.001-.004c.455-.806 1.354-1.357 2.143-1.357.271 0 .609.104.99.258.382.154.755.402 1.426.402.674 0 1.033-.243 1.441-.394.41-.152.81-.27 1.254-.27zm24.464 0c-2.489 0-4.328 1.395-4.396 3.314h2.11c.173-.912 1.036-1.51 2.218-1.51 1.433 0 2.242.657 2.242 1.864l.002.832-2.932.154c-2.72.161-4.193 1.255-4.193 3.155 0 1.919 1.52 3.193 3.7 3.193 1.471 0 2.837-.732 3.456-1.89h.05v1.775h2.167v-7.371c.001-2.14-1.74-3.516-4.424-3.516zm5.301 0 4.008 10.95-.215.665c-.362 1.13-.948 1.563-1.994 1.563-.18 0-.518-.018-.674-.037v1.804c.158.035.708.055.879.055 2.307 0 3.393-.868 4.342-3.502L50 21h-2.404l-2.787 8.885h-.05L41.974 21H39.5zm-3.125 6-.008.867c0 1.387-1.2 2.375-2.789 2.375-1.249 0-2.043-.588-2.043-1.49 0-.931.766-1.473 2.229-1.559L36.375 27z"
        })
    });
var $596bbe84e95bafd3$export$2e2bcd8739ae039 = $596bbe84e95bafd3$var$SvgApplePay;



parcelRequire("7fPBF");
const $3079e7169fff8540$var$SvgAppleTv = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4C6.25 4 4 6.25 4 9v32c0 2.75 2.25 5 5 5h32c2.75 0 5-2.25 5-5V9c0-2.75-2.25-5-5-5H9zm0 2h32c1.668 0 3 1.332 3 3v32c0 1.668-1.332 3-3 3H9c-1.668 0-3-1.332-3-3V9c0-1.668 1.332-3 3-3zm9.076 12c-.705.097-1.51.483-2.014 1.064-.504.58-.807 1.259-.605 1.936.805 0 1.512-.388 2.016-.969.403-.484.704-1.257.603-2.031zm8.725 0L25 18.5V21h-1.5v1.375H25V27.6c0 1.2.2 2 .7 2.6.5.5 1.2.8 2 .8.7 0 1.3-.1 1.6-.2l-.1-1.4c-.2.1-.5.1-1 .1-1.1 0-1.4-.7-1.4-1.9v-5.225h2.6V21h-2.6v-3zm-13.46 3c-1.007 0-2.015.6-2.72 1.6-1.007 1.5-.806 4.3.705 6.6.504.9 1.21 1.8 2.217 1.8.907.1 1.107-.5 2.316-.5 1.108-.1 1.31.5 2.217.5s1.713-1.1 2.317-1.9c.303-.6.504-.9.906-1.6-2.216-.9-2.619-4-.403-5.2-.705-.8-1.61-1.3-2.517-1.3-1.208 0-1.714.6-2.52.6s-1.51-.6-2.517-.6zm17.284 0 3.79 10h1.694L40 21h-1.895l-1.894 5.6c-.3 1-.6 1.8-.799 2.6h-.1c-.2-.9-.497-1.7-.796-2.6L32.52 21h-1.895z"
        })
    });
var $3079e7169fff8540$export$2e2bcd8739ae039 = $3079e7169fff8540$var$SvgAppleTv;



parcelRequire("7fPBF");
const $9d1f4a65eeeeac6d$var$SvgAppleWatch = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25.063 0C22.5 0 20.59.09 19.156.406c-.718.16-1.332.387-1.843.75-.512.364-.918.926-1 1.563-.051.379-.06.367-.157.656-.097.29-.218.754-.375 1.688-.476 2.863-1.976 2.558-3.281 4.093C10.996 10.25 10 12.008 10 14v22c0 1.992.996 3.75 2.5 4.844l.031.031c.043.031.082.066.125.094 1.25 1.343 2.606 1.234 3.125 4 .156.84.29 1.261.375 1.531.086.27.098.34.157.781.078.617.472 1.168.968 1.532.496.363 1.078.585 1.782.75 1.406.328 3.308.437 5.875.437 2.562 0 4.472-.09 5.906-.406.718-.16 1.332-.387 1.843-.75.512-.364.918-.926 1-1.563.051-.379.06-.367.157-.656.097-.29.218-.754.375-1.687.457-2.762 1.851-2.606 3.125-3.97.043-.027.082-.062.125-.093l.031-.031C39.004 39.75 40 37.992 40 36v-2c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1v-3a2.17 2.17 0 0 0 2-2.156v-3.688A2.17 2.17 0 0 0 40 15v-1c0-1.992-.996-3.75-2.5-4.844l-.031-.031c-.043-.031-.082-.066-.125-.094-1.25-1.344-2.606-1.234-3.125-4-.157-.84-.29-1.261-.375-1.531-.086-.27-.098-.34-.157-.781-.078-.617-.472-1.168-.968-1.531-.496-.364-1.078-.586-1.782-.75C29.532.108 27.63 0 25.063 0Zm0 2c2.503 0 4.343.121 5.437.375.547.129.871.29 1.031.406.16.117.145.14.157.219.07.535.167.836.25 1.094.082.258.167.535.312 1.312A6.769 6.769 0 0 0 33.313 8H16.719a6.544 6.544 0 0 0 1.031-2.625c.145-.867.238-1.156.313-1.375.074-.219.183-.496.25-1 .011-.086-.012-.098.156-.219.168-.12.527-.281 1.093-.406 1.13-.25 2.993-.375 5.5-.375ZM16 10h18c2.219 0 4 1.781 4 4v2.156c-.332.617-.562 1.508-.562 2.844 0 1.332.234 2.223.562 2.844V36c0 2.219-1.781 4-4 4H16c-2.219 0-4-1.781-4-4V14c0-2.219 1.781-4 4-4Zm23.844 7c.101 0 .156.055.156.156v3.688c0 .101-.055.156-.156.156h-.032c-.011-.016-.015-.008-.03-.031-.134-.215-.344-.762-.344-1.969s.242-1.758.374-1.969c.02-.031.016-.011.032-.031ZM16.688 42H33.28a6.544 6.544 0 0 0-1.031 2.625c-.145.867-.238 1.156-.312 1.375-.075.219-.184.496-.25 1-.012.086.011.098-.157.219-.168.12-.527.281-1.093.406-1.13.25-2.993.375-5.5.375-2.504 0-4.344-.121-5.438-.375-.547-.129-.871-.29-1.031-.406-.16-.117-.145-.14-.157-.219-.07-.535-.167-.836-.25-1.094-.082-.258-.167-.535-.312-1.312A6.769 6.769 0 0 0 16.688 42Z"
        })
    });
var $9d1f4a65eeeeac6d$export$2e2bcd8739ae039 = $9d1f4a65eeeeac6d$var$SvgAppleWatch;



parcelRequire("7fPBF");
const $d7ddc2c7594bdb77$var$SvgAppStore = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14 3.99c-5.511 0-10 4.489-10 10v22c0 5.512 4.489 10 10 10h22c5.511 0 10-4.488 10-10v-22c0-5.511-4.489-10-10-10H14zm0 2h22c4.43 0 8 3.57 8 8v22c0 4.43-3.57 8-8 8H14c-4.43 0-8-3.57-8-8v-22c0-4.43 3.57-8 8-8zm8.572 5.903A2.001 2.001 0 0 0 20.72 14.9l1.811 3.09L16.666 28H12a2 2 0 0 0 0 4h15.412a3.328 3.328 0 0 0-.379-2.355l-.004-.004A4.911 4.911 0 0 0 25.48 28h-4.177l7.676-13.102a2 2 0 0 0-3.452-2.021l-.677 1.156-.678-1.156a1.998 1.998 0 0 0-1.6-.984zm5.739 8.048-.827 1.373a4.99 4.99 0 0 0-.107 4.942l6.297 10.746c.372.636 1.04.988 1.726.988a1.998 1.998 0 0 0 1.723-3.01L35.377 32H38a2 2 0 0 0 0-4h-4.967l-4.722-8.059zM14.625 34.004a4.895 4.895 0 0 0-1.613.232l-.446.758a2 2 0 1 0 3.452 2.022l1.076-1.836a3.334 3.334 0 0 0-2.463-1.176h-.006z"
        })
    });
var $d7ddc2c7594bdb77$export$2e2bcd8739ae039 = $d7ddc2c7594bdb77$var$SvgAppStore;



parcelRequire("7fPBF");
const $63c6023a46e87011$var$SvgAtlassianConfluence = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M37.047 2.988c-1.5.1-1.735 1.858-2.658 3.057-4.1 7.309-7.903 5.192-14.366 2.19L10.61 4.13a1.465 1.465 0 0 0-1.966.728L4.12 14.705a1.46 1.46 0 0 0 .73 1.912c1.987.934 5.939 2.795 9.495 4.51 13.85 6.941 25.32 4.993 33.449-10.1a1.458 1.458 0 0 0-.488-1.984l-9.495-5.838a1.456 1.456 0 0 0-.765-.217zm.182 2.207 8.564 5.266C34.741 30.079 21.715 22.61 6.176 15.029l4.072-8.873 8.943 3.899c7.667 4.012 12.847 4.552 16.924-3.004.41-.678.769-1.278 1.114-1.856zM21.48 25c-7.716-.274-14.573 5.235-19.277 13.96a1.459 1.459 0 0 0 .49 1.985l9.494 5.838c1.933.953 2.437-1.488 3.424-2.838 4.1-7.309 7.903-5.192 14.366-2.19l9.414 4.104a1.464 1.464 0 0 0 1.964-.73l4.522-9.846a1.46 1.46 0 0 0-.73-1.912c-1.987-.934-5.939-2.793-9.495-4.508C30.618 26.42 25.88 25 21.48 25zm0 2c3.871 0 8.221 1.198 13.303 3.664 3.445 1.661 7.28 3.468 9.041 4.297l-4.072 8.871-8.943-3.896c-7.667-4.012-12.847-4.554-16.924 3.002-.408.676-.767 1.277-1.112 1.855l-8.566-5.266C8.239 32.04 14.487 26.715 21.48 27z"
        })
    });
var $63c6023a46e87011$export$2e2bcd8739ae039 = $63c6023a46e87011$var$SvgAtlassianConfluence;



parcelRequire("7fPBF");
const $d3c505b5d5c9a2b9$var$SvgAudible = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 10c-8.086 0-15.266 4.625-18.758 11.36-.015.019-.035.03-.05.05l.007.008c-.023.047-.066.082-.09.129a.999.999 0 0 0 .371 1.305c.442.27 1.02.156 1.329-.262C11.16 17.98 15.539 15 24 15c5.367 0 8.977 2.055 11.332 4.16 2.355 2.106 3.414 4.281 3.477 4.414.113.242.32.43.574.516.254.09.535.07.773-.05l2.89-1.446c.24-.121.423-.332.505-.59a1.006 1.006 0 0 0-.07-.774C39.964 14.625 33.01 10 25 10Zm0 2c6.871 0 12.793 3.832 16.11 9.324l-1.016.512c-.516-.91-1.453-2.402-3.426-4.168C34.028 15.308 29.883 13 24 13c-2.71 0-4.984.402-7.074.98C19.418 12.812 22.106 12 25 12Zm0 5c-4.914 0-9.48 2.2-12.844 7.46-.27.423-.183.981.2 1.306a1 1 0 0 0 1.32-.028C16.906 22.781 20.09 22 23 22c4.453 0 7.852 1.547 9.906 4.676.278.426.828.574 1.282.351L37.3 25.47c.25-.125.437-.352.515-.625.075-.27.032-.563-.117-.801C35.047 19.82 30.352 17 25 17Zm0 2c4.246 0 7.926 2.094 10.297 5.234l-1.324.66C31.473 21.665 27.59 20 23 20c-1.363 0-2.824.23-4.312.66C20.62 19.52 22.723 19 25 19ZM2.047 23A1 1 0 0 0 1 24v4c0 .387.223.734.57.902l22.996 11c.274.13.594.13.868 0l23-11c.343-.168.566-.515.566-.902v-4c0-.27-.11-.527-.305-.719a.995.995 0 0 0-1.129-.183L25 33.89 2.43 23.098A.99.99 0 0 0 2.047 23ZM25 24c-2.746 0-5.371 1.227-6.832 3.45a.994.994 0 0 0 .129 1.253c.332.336.86.39 1.254.129C20.41 28.27 21.707 28 23 28a5.95 5.95 0 0 1 4.227 1.746c.304.3.77.375 1.152.18l2.605-1.301a.992.992 0 0 0 .344-1.504A7.976 7.976 0 0 0 25 24ZM3 25.59l21.566 10.312c.274.13.594.13.868 0L47 25.59v1.781l-22 10.52L3 27.37ZM25 26c1.469 0 2.707.637 3.746 1.512l-.762.379c-1.105-.907-2.441-1.473-3.922-1.676.325-.047.602-.215.938-.215Z"
        })
    });
var $d3c505b5d5c9a2b9$export$2e2bcd8739ae039 = $d3c505b5d5c9a2b9$var$SvgAudible;



parcelRequire("7fPBF");
const $18f555e019f9ab0b$var$SvgBing = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10 4c3.148.96 6.3 1.922 9.445 2.89-.004 7.774.008 15.548-.004 23.32-3.058 2.708-6.101 5.435-9.152 8.153 7.457-3.918 14.91-7.843 22.367-11.77-2.07-.94-4.14-1.866-6.21-2.812-1.391-3.035-2.794-6.062-4.188-9.097 6.914 2.113 13.828 4.234 20.742 6.355v10.137c-7.867 4.691-15.742 9.375-23.61 14.066-3.128-2.191-6.257-4.387-9.39-6.578V4m0-2a2 2 0 0 0-2 2v34.66c0 .656.316 1.266.852 1.64 2.128 1.49 4.257 2.981 6.382 4.473l3.008 2.11a2.008 2.008 0 0 0 2.172.078c4.348-2.594 8.695-5.184 13.047-7.773l10.562-6.293c.606-.36.977-1.012.977-1.72V26.11l-.004-5.07c0-.879-.57-1.652-1.41-1.91l-4.582-1.406c-5.387-1.653-10.777-3.305-16.164-4.95a2.027 2.027 0 0 0-1.395.082v-5.96c0-.88-.57-1.653-1.41-1.915-3.148-.968-6.3-1.933-9.453-2.89A1.865 1.865 0 0 0 10 2Zm11.441 28.238v-.027c.004-4.164.004-8.332.004-12.5.25.535.496 1.074.746 1.61l2.438 5.296c.2.438.55.79.988.988l2.485 1.125-1.645.868-5.016 2.64Z"
        })
    });
var $18f555e019f9ab0b$export$2e2bcd8739ae039 = $18f555e019f9ab0b$var$SvgBing;



parcelRequire("7fPBF");
const $4b6a21eb2740d1a0$var$SvgCallOfDutyBlackOps3 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M4 5v8.334l3 4v15.332l-3 4V45h13V5H4zm15 0v40h12V5H19zm14 0v40h13v-8.334l-3-4V17.334l3-4V5H33zM6 7h9v36H6v-5.666l3-4V16.666l-3-4V7zm15 0h8v36h-8V7zm14 0h9v5.666l-3 4v16.668l3 4V43h-9V7z"
        })
    });
var $4b6a21eb2740d1a0$export$2e2bcd8739ae039 = $4b6a21eb2740d1a0$var$SvgCallOfDutyBlackOps3;



parcelRequire("7fPBF");
const $65c1d56f8fc276a2$var$SvgCallOfDutyMobile = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M24.523.686A1 1 0 0 0 24 .818L3.5 12.654a1 1 0 0 0-.5.867v23.67a1 1 0 0 0 .5.868L24 49.895a1 1 0 0 0 1 0l20.5-11.836a1 1 0 0 0 .5-.868v-23.67a1 1 0 0 0-.5-.867L25 .818a1 1 0 0 0-.477-.132zM24.5 2.84 44 14.098v22.517L24.5 47.873 5 36.615V14.098L24.5 2.84zM14.041 13a1 1 0 0 0-.555.143l-3 1.796a1 1 0 0 0-.486.86v20.01a1 1 0 0 0 .52.877l4 2.191a1 1 0 0 0 1.08-.076l4-3A1 1 0 0 0 20 35v-5.168l3.945 2.537a1 1 0 0 0 .026.016l.015.01a1 1 0 0 0 1.006.013l.016-.008a1 1 0 0 0 .05-.03L29 29.833V35a1 1 0 0 0 .4.8l4 3a1 1 0 0 0 1.08.077l4-2.191a1 1 0 0 0 .52-.877v-20.01a1 1 0 0 0-.486-.86l-3-1.796a1 1 0 0 0-1.028 0l-4.98 2.988a1 1 0 0 0-.02.012 1 1 0 0 0-.004.002L24.5 19.15l-4.945-2.982a1 1 0 0 0-.04-.023 1 1 0 0 0-.001-.002l-5-3A1 1 0 0 0 14.04 13zM14 15.166l4 2.4V34.5l-3.084 2.313L12 35.217V16.365l2-1.199zm21 0 2 1.2v18.85l-2.916 1.596L31 34.5V17.566l4-2.4zM20 18.77l3.984 2.406a1 1 0 0 0 1.034 0L29 18.77v8.684l-4.498 2.895L20 27.455V18.77z"
        })
    });
var $65c1d56f8fc276a2$export$2e2bcd8739ae039 = $65c1d56f8fc276a2$var$SvgCallOfDutyMobile;



parcelRequire("7fPBF");
const $c435ded412ce4cee$var$SvgChrome = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2C12.31 2 2 12.31 2 25s10.31 23 23 23 23-10.31 23-23S37.69 2 25 2zm0 2c7.988 0 14.926 4.445 18.477 11H25a1 1 0 0 0-.113.006c-5.148.058-9.375 4.03-9.84 9.072L8.035 12.65C11.852 7.414 18.015 4 25 4zM6.824 14.502l9.653 15.728a1 1 0 0 0 .115.159 1 1 0 0 0 .002.004C18.375 33.159 21.474 35 25 35a9.926 9.926 0 0 0 3.977-.83L22.32 45.824C11.98 44.51 4 35.701 4 25c0-3.83 1.038-7.408 2.824-10.498zM25 17c4.43 0 8 3.57 8 8 0 1.421-.37 2.752-1.016 3.906a1 1 0 0 0-.002.002 1 1 0 0 0-.035.059A7.978 7.978 0 0 1 25 33c-4.43 0-8-3.57-8-8s3.57-8 8-8zm5.973 0h13.449A20.965 20.965 0 0 1 46 25c0 11.61-9.39 21-21 21-.158 0-.314-.008-.47-.012l9.154-16.029a1 1 0 0 0 .058-.117A9.928 9.928 0 0 0 35 25c0-3.271-1.589-6.174-4.027-8z"
        })
    });
var $c435ded412ce4cee$export$2e2bcd8739ae039 = $c435ded412ce4cee$var$SvgChrome;



parcelRequire("7fPBF");
const $46a011279831d90c$var$SvgChromebook = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M5.951 4.006c-1.051 0-1.945.86-1.945 1.926v25.08c0 .358.096.684.252.968a1.853 1.853 0 0 0-.168.374.896.896 0 0 0-.002.001l-2.822 8.997A.98.98 0 0 0 1.02 42v3c0 1.06.855 1.98 1.937 1.98h44.084c1.082 0 1.94-.92 1.94-1.98v-3a.98.98 0 0 0-.247-.648l-2.822-8.997a1.839 1.839 0 0 0-.17-.376c.156-.285.252-.61.252-.967V5.932c0-1.065-.894-1.926-1.945-1.926H5.95zm.043 1.988h38.012v25.018c0-.098-.079-.006-.006-.006h-4.898A1 1 0 0 0 39 31H11a1 1 0 0 0-.1.006H6c.073 0-.006-.092-.006.006V5.994zM25 10c-4.959 0-9 4.041-9 9 0 3.193 1.68 5.997 4.197 7.596a1 1 0 0 0 .684.396A8.928 8.928 0 0 0 25 28c4.959 0 9-4.041 9-9s-4.041-9-9-9zm0 2a6.979 6.979 0 0 1 5.748 3h-5.605a1 1 0 0 0-.086.004c-.012 0-.022-.004-.034-.004-1.271 0-2.394.621-3.123 1.563l-1.445-2.89A6.97 6.97 0 0 1 25 12zm-5.957 3.324 2.047 4.092a4.022 4.022 0 0 0 2.437 3.281l-2.547 2.037A6.979 6.979 0 0 1 18 19c0-1.352.385-2.608 1.043-3.676zM25.023 17c1.1 0 1.977.88 1.977 2s-.877 2-1.977 2-1.976-.88-1.976-2 .877-2 1.976-2zm3.418 0h3.266c.188.634.293 1.304.293 2 0 3.878-3.122 7-7 7a7.036 7.036 0 0 1-2.025-.299l3.65-2.92a1 1 0 0 0 .23-.256C28.122 21.853 29 20.528 29 19c0-.73-.213-1.408-.559-2zM5.771 32.973h.014c.002.007.01.004.018.002.066.006.129.02.197.02h3.72l-.69 2.763A1 1 0 0 0 10 37h30a1 1 0 0 0 .97-1.242l-.69-2.764H44c.067 0 .129-.012.193-.017.01.004.021.005.024-.004h.012l2.525 8.047H3.246l2.525-8.047zm6.01.027H38.22l.5 2H11.28l.5-2zM21 38l-1 2h10l-1-2h-8zM2.98 42.98h44.04V45c0 .045 0 .02.021.02H2.979L2.98 45v-2.02z"
        })
    });
var $46a011279831d90c$export$2e2bcd8739ae039 = $46a011279831d90c$var$SvgChromebook;



parcelRequire("7fPBF");
const $1421cc100a791107$var$SvgCnn = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.148 4C8.103 4 4 8.103 4 13.148v23.704C4 41.897 8.103 46 13.148 46h23.704C41.897 46 46 41.897 46 36.852V13.148C46 8.103 41.897 4 36.852 4H13.148zm0 2h23.704A7.156 7.156 0 0 1 44 13.148v23.704A7.156 7.156 0 0 1 36.852 44H13.148A7.156 7.156 0 0 1 6 36.852V13.148A7.156 7.156 0 0 1 13.148 6zm16.45 11.941a2.578 2.578 0 0 0-.856.135c-1.059.356-1.742 1.346-1.742 2.52v2.908l-3.107-4.3c-.813-1.075-2.02-1.506-3.15-1.128-1.06.356-1.743 1.346-1.743 2.52V28h-3.5a2.503 2.503 0 0 1-2.5-2.5c0-1.378 1.122-2.5 2.5-2.5h2.346v-2H15.5a4.505 4.505 0 0 0-4.5 4.5c0 2.481 2.019 4.5 4.5 4.5H21v-9.404c0-.31.142-.543.379-.623.297-.1.636.067.906.422L29 29.688v-9.092c0-.31.142-.543.379-.625.297-.1.637.067.906.422L37 29.686V18.393h-2v5.11l-3.107-4.3c-.61-.805-1.441-1.25-2.295-1.262zM15.5 18C11.364 18 8 21.364 8 25.5s3.364 7.5 7.5 7.5H21c1.654 0 3-1.346 3-3v-2.17l2.838 3.932c.757 1.09 2.038 1.548 3.266 1.164 1.15-.36 1.896-1.35 1.896-2.522V27.83l2.838 3.932c.579.835 1.464 1.297 2.398 1.297.287 0 .579-.043.868-.133 1.15-.36 1.896-1.35 1.896-2.522v-12.01h-2v12.01c0 .425-.377.577-.492.614-.145.045-.647.15-1.037-.413L30 21.643v8.761c0 .425-.377.577-.492.614-.145.045-.648.15-1.037-.413L22 21.643V30c0 .551-.449 1-1 1h-5.5a5.506 5.506 0 0 1-5.5-5.5c0-3.033 2.467-5.5 5.5-5.5h2.441v-2H15.5z"
        })
    });
var $1421cc100a791107$export$2e2bcd8739ae039 = $1421cc100a791107$var$SvgCnn;



parcelRequire("7fPBF");
const $1cce39a8b578ff0a$var$SvgContacts = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13 4c-4.959 0-9 4.041-9 9v24c0 4.959 4.041 9 9 9h24c4.959 0 9-4.041 9-9V13c0-4.959-4.041-9-9-9H13zm0 2h24c.355 0 .66.15 1 .201V43.8c-.34.05-.645.201-1 .201H13c-3.877 0-7-3.123-7-7V13c0-3.877 3.123-7 7-7zm27 .73c2.352 1.126 4 3.48 4 6.27v1h-4V6.73zM22 12c-7.168 0-13 5.832-13 13s5.832 13 13 13 13-5.832 13-13-5.832-13-13-13zm0 2c6.087 0 11 4.913 11 11 0 2.822-1.065 5.383-2.805 7.328C28.17 30.272 25.24 29 22 29c-3.241 0-6.166 1.277-8.191 3.334A10.95 10.95 0 0 1 11 25c0-6.087 4.913-11 11-11zm18 2h4v8h-4v-8zm-18 2c-1.583 0-2.898.63-3.748 1.586C17.402 20.542 17 21.778 17 23s.402 2.458 1.252 3.414S20.417 28 22 28c1.583 0 2.898-.63 3.748-1.586C26.598 25.458 27 24.222 27 23s-.402-2.458-1.252-3.414S23.583 18 22 18zm0 2c1.083 0 1.769.37 2.252.914.483.544.748 1.308.748 2.086 0 .778-.265 1.542-.748 2.086-.483.544-1.169.914-2.252.914-1.083 0-1.769-.37-2.252-.914C19.265 24.542 19 23.778 19 23c0-.778.265-1.542.748-2.086C20.231 20.37 20.917 20 22 20zm18 6h4v8h-4v-8zm-18 5c2.694 0 5.093 1.056 6.73 2.695A10.949 10.949 0 0 1 22 36c-2.538 0-4.866-.863-6.725-2.3C16.913 32.06 19.305 31 22 31zm18 5h4v1c0 2.79-1.648 5.144-4 6.27V36z"
        })
    });
var $1cce39a8b578ff0a$export$2e2bcd8739ae039 = $1cce39a8b578ff0a$var$SvgContacts;



parcelRequire("7fPBF");
const $e4698ad62cc1274e$var$SvgCounterStrike = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M27.635 4.041c-.284-.046-.6.03-.908.072a1 1 0 0 0-.373.002c-.027.005-.043.028-.069.033-.028.01-.053-.004-.082.006a1 1 0 0 0-.351.203c-1.03.371-1.854 1.104-2.27 2.036-.285.637-.368 1.342-.324 2.048a5.62 5.62 0 0 0-.822.106 1 1 0 0 0-.086.025c-1.483.5-2.336 1.793-2.766 3.016-.417 1.132-.431 2.264-.357 3.348-.242.01-.512.007-.88.134a1 1 0 0 0-.67.909c-.036.998-.1 1.968-.265 2.9a1 1 0 0 0-.006.037c-.035.257-.173.762.063 1.387a1 1 0 0 0 .314.427c-.113 1.306.137 2.34.213 3.276-.19.185-.367.384-.432.553-.17.447-.167.78-.181.847a1 1 0 0 0 .066.608 1 1 0 0 0 .002.533c.002.005.012.167.055.463.016.11.172.278.226.427-.167 1.036-.359 2.097-.474 3.2-.056.435.04.73.07.879.012.059.01.07.012.078-.035.098-.272.498-.45 1.004-.498.592-.832 1.23-1.08 1.7-.41.736-.353 1.312-.392 1.667-.258.403-.788 1.025-.773 2.037-.004.112-.028.308.003.605.011.102.137.233.176.356-.213 1.057-.538 2.138-.81 3.3a1 1 0 0 0-.022.13c-.046.475-.131 1.172.238 1.904a1 1 0 0 0 .62.512c1.153.328 2.218.163 3.093.095a1 1 0 0 0 .912-.845c.066-.43.092-1.009-.154-1.592-.225-.802-.003-1.795.467-2.647.168-.136.423-.205.52-.355.223-.347.31-.668.376-.91a1 1 0 0 0 .002-.004c.195-.714.844-1.556 1.106-2.83a1 1 0 0 0 .01-.057c.058-.402-.025-.66-.045-.773.15-.333.217-.45.129-.393.526-.344.727-.803.865-1.144.098-.064.39-.205.623-.612.26-.452.295-.875.326-1.148.031-.274.06-.407.076-.438a1 1 0 0 0 .028-.054c.339-.796.51-1.326.77-1.663a1 1 0 0 0 .075.038c.276.119.36.074.543.085.541.795 1.078 1.594 1.617 2.397l-.023-.04c.36.59.92.785 1.498.825-.018.164-.034.328-.049.506-.261.372-.47.824-.363 1.39l-.012-.07c.08.688.144 1.382.198 2.078a1 1 0 0 0 .011.092c.122.712.286 1.052.274 1.178a1 1 0 0 0 .28.791c.025.637.09 1.25.05 1.633-.37.85-.397 1.627-.533 2.146a1 1 0 0 0 .209.905c.454.529 1.154.671 1.6.664.426-.008.718-.063.845-.065.32.054.913.42 1.894.367.731-.008 1.59.076 2.551-.101a1 1 0 0 0 .803-.803c.066-.36.124-.868-.096-1.412a1 1 0 0 0-.385-.467 5.598 5.598 0 0 0-1.435-.658 1 1 0 0 0-.041-.012c.041.01-.121-.152-.455-.506-.342-.443-.487-.62-.483-.578a1 1 0 0 0 0-.004c-.054-.498-.032-1.067-.013-1.672.085-.111.248-.36.265-.904.061-.448.027-.861-.02-1.119-.054-.3-.061-.45-.05-.502a1 1 0 0 0 .01-.055c.212-1.348.389-2.75.343-4.197a1 1 0 0 0-.181-.545l-.059-.084-.04-.402a1 1 0 0 0-.546-.79h-.002a34.297 34.297 0 0 0-1.297-3.1 1 1 0 0 0-.017-.036c-.485-.916-1.114-1.712-1.768-2.46.265-.058.566-.199.758-.417a1 1 0 0 0 .086-.115c.35-.536.715-1.247.668-2.121v.05c-.003-.676.185-1.607.11-2.658.547.24 1.12.467 1.788.532.67.088 1.279-.218 1.608-.479.333-.264.529-.463.601-.506a1 1 0 0 0 .079-.049c.627-.446.85-1.135.945-1.609.055-.276.08-.382.113-.555l.06-.017a1 1 0 0 0 .712-1.12c-.107-.67-.212-1.063-.26-1.439.202-.162.36-.404.54-.678l.03-.013c.963-.01 1.942.005 2.947-.008l-.064-.002c.284.015.719-.129.947-.39.037-.043.02-.062.047-.102.156-.012.323.103.467.062a1 1 0 0 0 .041-.013c.194-.064.628-.027 1.238-.05h.03c.223.005.377-.004.437-.001a1 1 0 0 0 .738.164c.314-.054.698-.054 1.147-.047a1 1 0 0 0 1.014-.965l.019-.531a1 1 0 0 0-1.002-1.04c-.28.002-.565.006-.85.01l-.138-.054a1 1 0 0 0-.924.105c-.37.018-.79.014-1.205.008-.07-.156-.038-.305-.17-.427a1 1 0 0 0-.107-.084L41.6 8.94a1 1 0 0 0-1.016-.994c-.088.002-.215.004-.303.008a1 1 0 0 0-.957 1.002v.117c-2.284-.015-4.56-.004-6.828-.011a1 1 0 0 0-.336-.198c-.04-.158.007-.252-.092-.426a1 1 0 0 0-1.07-.482 4.286 4.286 0 0 0-.24-1.46 1 1 0 0 0-.096-.69c-.043-.081-.116-.21-.137-.248a1 1 0 0 0-.529-.467c-.312-.118-.654-.33-1.055-.588a1 1 0 0 0-.097-.057 4.34 4.34 0 0 0-1.21-.406zm-.563 1.969c.242-.008.558.068.887.23.219.141.509.277.775.42a1 1 0 0 0 .063.195c.226.515.244.967.172 1.336-.05.012.021-.038-.233.047a1 1 0 0 0-.681.946c-.002.474.064.866.091 1.183a1 1 0 0 0 .838.9c.584.095 1.053-.063 1.36-.16.306-.096.464-.129.525-.125a1 1 0 0 0 .44-.072 1 1 0 0 0 .521.15c1.363.008 2.712.01 4.068.008l-.015.008a1 1 0 0 0-.512.582c-.012.038-.221.26-.615.555a1 1 0 0 0-.078.066c-.038-.15-.049-.298-.112-.447a1 1 0 0 0-.939-.611c-.164.003-.325.007-.48.008a1 1 0 0 0-.518.148c-.128.079-.355.156-.598.553-.034.056-.02.162-.047.236.08-.065-.02-.013-.242.123-.12.073-.282.18-.44.404a1.353 1.353 0 0 0-.204.91 1 1 0 0 0 .136.364c.17.273.316.558.436.853a1 1 0 0 0 1.56.397c.492-.404.846-.913 1.125-1.446l.112-.113c.038.264.053.492.11.707a1 1 0 0 0-.43.48c-.241.568-.253 1.044-.313 1.342-.06.3-.088.331-.145.372l.079-.05c-.453.264-.694.549-.842.667-.149.118-.064.078-.092.074a1 1 0 0 0-.057-.008c-.926-.082-1.952-.747-3.152-1.363a1 1 0 0 0-1.445.725 8.27 8.27 0 0 1-.196.826 1 1 0 0 0 .78 1.25c.05.01.042.009.04.01.089.666-.145 1.538-.14 2.667a1 1 0 0 0 .002.05c.007.122-.117.313-.178.472-.08-.02-.057-.033-.172-.049a1 1 0 0 0-1.029.533c-.074.145-.147.287-.217.428a1 1 0 0 0-.076.678c.068.28.103.702.277 1.21a1 1 0 0 0 .206.346c.655.724 1.232 1.493 1.668 2.313.48 1.003.912 2.03 1.287 3.078l-.041-.16c.055.308.262.52.443.695l.025.248a1 1 0 0 0 .168.463l.016.024c.013 1.164-.107 2.35-.299 3.568l.01-.055c-.118.547-.016.989.037 1.281.053.293.057.435.045.487a1 1 0 0 0-.025.281c-.01-.172-.04-.112-.235.416a1 1 0 0 0-.062.316c-.019.624-.055 1.314.025 2.051.103.976.763 1.428.91 1.62a1 1 0 0 0 .067.076c.102.108.307.37.603.63-.045 0-.071.004-.117.004a1 1 0 0 0-.04.002c-.233.013-.717-.263-1.612-.367a1 1 0 0 0-.09-.006c-.278-.007-.397.018-.573.04.066-.345.136-.804.245-1.014a1 1 0 0 0 .1-.315c.151-1.042-.08-1.852-.048-2.406a1 1 0 0 0-.357-.826l-.025-.022c-.08-.378-.143-.85-.176-1.01a55.957 55.957 0 0 0-.2-2.091c.004 0 .01-.008.047-.043a1 1 0 0 0 .315-.674c.019-.343.069-.722.11-1.139a1 1 0 0 0-.022-.322c-.148-.64-.482-.904-.51-.951a1 1 0 0 0-1.244-.408c-.039.016-.105-.023-.049.07a1 1 0 0 0-.023-.037c-.618-.918-1.235-1.839-1.864-2.758a1 1 0 0 0-.76-.434c-.182-.012-.137-.002-.203-.005-.073-.124-.135-.226-.277-.504a1 1 0 0 0-1.637-.21c-.297.335-.378.65-.431.798-.026.07-.039.094-.04.097-.878.856-1.04 1.892-1.294 2.49l.025-.054c-.227.452-.248.852-.277 1.107-.024.21-.044.27-.059.31l-.021.016c-.148.099-.515.342-.676.826l.02-.056c-.113.28-.194.365-.182.357a1 1 0 0 0-.004.002c-.737.482-.832 1.183-.914 1.371a1 1 0 0 0 0 .002c-.187.433-.124.825-.09 1.024.03.173.025.186.033.134-.152.686-.736 1.474-1.062 2.67v-.004a1.757 1.757 0 0 1-.117.323 1 1 0 0 0-.588.468c-.651 1.163-1.031 2.624-.66 4.086-.268.01-.544.014-.778-.007 0-.103-.021-.131-.01-.266.264-1.105.621-2.248.854-3.488a1 1 0 0 0-.2-.805c0-.051.004-.14.007-.33a1 1 0 0 0 0-.03c-.003-.161.215-.492.576-1.12a1 1 0 0 0 .111-.291c.154-.73.144-1.146.225-1.29a1 1 0 0 0 .011-.021c.35-.66.595-1.196.9-1.498a1 1 0 0 0 .274-.498c.016-.072.281-.383.498-1.047.164-.457.094-.86.051-1.078-.044-.222-.043-.3-.05-.238a1 1 0 0 0 .003-.024c.112-1.08.313-2.186.494-3.326a1 1 0 0 0-.254-.836c-.005-.039-.036-.195-.043-.28.015-.028.023-.056.04-.085a1 1 0 0 0 .064-.861 1 1 0 0 0 .488-.829c.04-1.378-.238-2.421-.24-3.369.057-.017.119-.054.174-.064a1 1 0 0 0-.055-1.973c-.156-.02-.353-.073-.523-.11.129-.76.166-1.504.209-2.247.286-.016.668-.031 1.1-.237a1 1 0 0 0 .562-1.025c-.15-1.208-.163-2.37.2-3.352a1 1 0 0 0 .007-.017c.295-.844.828-1.537 1.502-1.776.202-.044.39-.076.46-.074a1 1 0 0 0 1.432.09l.305-.281a1 1 0 0 0 .215-1.186c-.252-.501-.242-1.218.027-1.82.269-.601.736-1.02 1.297-1.123l.002-.002a1 1 0 0 0 .084-.018 1 1 0 0 0 .014-.003 1 1 0 0 0 .052-.018.734.734 0 0 1 .215-.035zm7.385 7.592.002.005-.045.065c.012-.024.031-.046.043-.07zM5 20a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2 1 1 0 0 0-1-1H6v-7h8a1 1 0 0 0 1-1 2 2 0 0 0-2-2H5zm32 0a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h7v2h-8a1 1 0 0 0-1 1 2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-5a1 1 0 0 0-1-1h-8.23v-2H46a1 1 0 0 0 1-1 2 2 0 0 0-2-2h-8z"
        })
    });
var $e4698ad62cc1274e$export$2e2bcd8739ae039 = $e4698ad62cc1274e$var$SvgCounterStrike;



const $b4c041254446cc77$var$SvgDictationPause = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 256 256",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                    id: "dictation-pause_svg__a",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        fill: "none",
                        d: "M0 256V0h256v187.392c0-5.222-3.994-9.216-9.216-9.216h-12.288c-5.222 0-9.216 3.994-9.216 9.216 0-5.222-3.994-9.216-9.216-9.216h-12.288c-5.222 0-9.216 3.994-9.216 9.216v55.296c0 5.222 3.994 9.216 9.216 9.216h12.288c5.222 0 9.216-3.994 9.216-9.216 0 5.222 3.994 9.216 9.216 9.216h12.288c5.222 0 9.216-3.994 9.216-9.216V256z"
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                strokeMiterlimit: 10,
                fontFamily: "none",
                fontSize: "none",
                fontWeight: "none",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                        fill: "none",
                        clipPath: "url(#dictation-pause_svg__a)",
                        style: {
                            mixBlendMode: 'normal'
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            fill: "currentColor",
                            d: "M189.12 14.56c0 15.84-3.7 22.84-8.48 26.72-4.78 3.88-12.06 5.1-20.32 6.24-8.26 1.14-17.48 2.2-25.12 8.32-6.34 5.08-10.72 13.48-12 26.08H20.48C9.22 81.92 0 91.14 0 102.4v102.4c0 11.26 9.22 20.48 20.48 20.48h215.04c11.26 0 20.48-9.22 20.48-20.48V102.4c0-11.26-9.22-20.48-20.48-20.48H133.6c1.1-9.92 4.18-15.02 8-18.08 4.76-3.82 11.88-4.94 20.16-6.08 8.28-1.14 17.64-2.26 25.28-8.48 7.64-6.22 12.32-17.18 12.32-34.72zM20.48 92.16h215.04c5.72 0 10.24 4.52 10.24 10.24v102.4c0 5.72-4.52 10.24-10.24 10.24H20.48c-5.72 0-10.24-4.52-10.24-10.24V102.4c0-5.72 4.52-10.24 10.24-10.24zm5.12 20.48v20.48h20.48v-20.48zm30.72 0v20.48H76.8v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zM25.6 143.36v20.48h35.84v-20.48zm46.08 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h35.84v-20.48zM25.6 174.08v20.48h20.48v-20.48zm30.72 0v20.48H76.8v-20.48zm30.72 0v20.48h81.92v-20.48zm92.16 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48z"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        d: "M5 0H1C.4 0 0 .4 0 1v18c0 .6.4 1 1 1h4c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zM4 18H2V2h2zM15 0h-4c-.6 0-1 .4-1 1v18c0 .6.4 1 1 1h4c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-1 18h-2V2h2z",
                        style: {
                            mixBlendMode: 'normal'
                        },
                        transform: "translate(200.704 184.32)scale(3.072)"
                    })
                ]
            })
        ]
    });
var $b4c041254446cc77$export$2e2bcd8739ae039 = $b4c041254446cc77$var$SvgDictationPause;



const $7bd416e9f38b8977$var$SvgDictationPlay = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 256 256",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                    id: "dictation-play_svg__a",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        fill: "none",
                        d: "M0 256V0h256v256zm243.37-53.59-48.127-23.893c-1.366-.682-3.072-1.024-4.438-1.024-7.509 0-13.312 6.144-13.312 13.312v48.128c0 7.51 5.803 13.654 13.312 13.654 1.707 0 3.072-.342 4.438-1.024l47.786-23.894c6.144-2.73 9.558-7.168 9.558-12.629 0-6.144-4.779-10.581-9.216-12.63z"
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                strokeMiterlimit: 10,
                fontFamily: "none",
                fontSize: "none",
                fontWeight: "none",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                        fill: "none",
                        clipPath: "url(#dictation-play_svg__a)",
                        style: {
                            mixBlendMode: 'normal'
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            fill: "currentColor",
                            d: "M189.12 14.56c0 15.84-3.7 22.84-8.48 26.72-4.78 3.88-12.06 5.1-20.32 6.24-8.26 1.14-17.48 2.2-25.12 8.32-6.34 5.08-10.72 13.48-12 26.08H20.48C9.22 81.92 0 91.14 0 102.4v102.4c0 11.26 9.22 20.48 20.48 20.48h215.04c11.26 0 20.48-9.22 20.48-20.48V102.4c0-11.26-9.22-20.48-20.48-20.48H133.6c1.1-9.92 4.18-15.02 8-18.08 4.76-3.82 11.88-4.94 20.16-6.08 8.28-1.14 17.64-2.26 25.28-8.48 7.64-6.22 12.32-17.18 12.32-34.72zM20.48 92.16h215.04c5.72 0 10.24 4.52 10.24 10.24v102.4c0 5.72-4.52 10.24-10.24 10.24H20.48c-5.72 0-10.24-4.52-10.24-10.24V102.4c0-5.72 4.52-10.24 10.24-10.24zm5.12 20.48v20.48h20.48v-20.48zm30.72 0v20.48H76.8v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zM25.6 143.36v20.48h35.84v-20.48zm46.08 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h35.84v-20.48zM25.6 174.08v20.48h20.48v-20.48zm30.72 0v20.48H76.8v-20.48zm30.72 0v20.48h81.92v-20.48zm92.16 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48z"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        d: "M1.9 18c-1 0-1.9-.9-1.9-1.9V1.9C0 .9.8 0 1.9 0c.1 0 .3 0 .4.1l14.1 7c.4.2 1.6.8 1.6 1.9 0 1.1-1.2 1.7-1.6 1.9l-14.1 7c-.1.1-.3.1-.4.1zM2 2.2v13.7l13.6-6.7c.1 0 .1-.1.2-.1-.1 0-.1-.1-.2-.1z",
                        style: {
                            mixBlendMode: 'normal'
                        },
                        transform: "translate(184.32 184.32)scale(3.41333)"
                    })
                ]
            })
        ]
    });
var $7bd416e9f38b8977$export$2e2bcd8739ae039 = $7bd416e9f38b8977$var$SvgDictationPlay;



parcelRequire("7fPBF");
const $f3679bbefd6a2cdc$var$SvgDiscord = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M18.906 7s-6.367.438-10.531 3.781a.466.466 0 0 0-.062.031C7.59 11.48 7.047 12.517 6.375 14c-.672 1.484-1.383 3.395-2.031 5.531C3.05 23.81 2 29.06 2 34a.971.971 0 0 0 .125.5c1.46 2.566 4.148 4.117 6.656 5.094 2.508.976 4.824 1.367 6 1.406.332.012.649-.14.844-.406l2.438-3.375c1.964.465 4.269.781 6.937.781s4.973-.316 6.938-.781l2.437 3.375c.195.265.512.418.844.406 1.176-.04 3.492-.43 6-1.406 2.508-.977 5.195-2.528 6.656-5.094A.971.971 0 0 0 48 34c0-4.941-1.05-10.191-2.344-14.469-.648-2.136-1.36-4.047-2.031-5.531-.672-1.484-1.215-2.52-1.937-3.187a.466.466 0 0 0-.063-.032C37.461 7.437 31.094 7 31.094 7a1.024 1.024 0 0 0-.219 0 1 1 0 0 0-.781.594s-.34.746-.563 1.812C27.582 9.094 25.941 9 25 9c-.941 0-2.582.094-4.531.406-.223-1.066-.563-1.812-.563-1.812a1.002 1.002 0 0 0-1-.594Zm-.625 2.156c.074.203.125.395.188.625-2.254.524-4.723 1.38-7.032 2.813a1.004 1.004 0 0 0-.613.898c-.008.39.215.754.567.926.355.168.777.117 1.078-.137C17.102 11.411 22.996 11 25 11c2.004 0 7.898.41 12.531 3.281.301.254.723.305 1.078.137.352-.172.575-.535.567-.926a1.004 1.004 0 0 0-.614-.898c-2.308-1.434-4.777-2.29-7.03-2.813.062-.23.113-.422.187-.625 1.14.14 5.574.739 8.593 3.125.196.18.876 1.18 1.5 2.563.626 1.383 1.282 3.183 1.907 5.25 1.218 4.031 2.203 9.004 2.25 13.562-1.137 1.84-3.27 3.207-5.469 4.063-2 .777-3.867 1.125-4.844 1.218l-1.687-2.28a24.85 24.85 0 0 0 2.312-.876c2.524-1.11 3.875-2.281 3.875-2.281a1.007 1.007 0 0 0-1.343-1.5s-1.047.957-3.344 1.969c-.844.37-1.867.738-3.032 1.062-.269-.031-.539.047-.75.219-1.863.453-4.078.75-6.687.75-2.629 0-4.848-.324-6.719-.781a.996.996 0 0 0-.718-.157 22.582 22.582 0 0 1-3.032-1.093C12.234 32.957 11.187 32 11.187 32a.996.996 0 0 0-.843-.25.999.999 0 0 0-.5 1.75s1.351 1.172 3.875 2.281c.68.297 1.453.598 2.312.875l-1.687 2.282c-.977-.094-2.844-.442-4.844-1.22-2.2-.855-4.332-2.222-5.469-4.062.047-4.558 1.032-9.531 2.25-13.562.625-2.067 1.282-3.867 1.907-5.25.624-1.383 1.304-2.383 1.5-2.563 3.019-2.386 7.453-2.984 8.593-3.125ZM18.5 21c-2.55 0-4.5 2.316-4.5 5s1.95 5 4.5 5 4.5-2.316 4.5-5-1.95-5-4.5-5Zm13 0c-2.55 0-4.5 2.316-4.5 5s1.95 5 4.5 5 4.5-2.316 4.5-5-1.95-5-4.5-5Zm-13 2c1.316 0 2.5 1.266 2.5 3s-1.184 3-2.5 3-2.5-1.266-2.5-3 1.184-3 2.5-3Zm13 0c1.316 0 2.5 1.266 2.5 3s-1.184 3-2.5 3-2.5-1.266-2.5-3 1.184-3 2.5-3Z"
        })
    });
var $f3679bbefd6a2cdc$export$2e2bcd8739ae039 = $f3679bbefd6a2cdc$var$SvgDiscord;



parcelRequire("7fPBF");
const $c67d20bd69d9f8ef$var$SvgDisneyMovies = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M28.848 8c-.047.016-.094.066-.133.086-.242.121-.477.273-.715.414v.117c.238.121.477.25.719.36.093.043.195.054.246-.188a1.59 1.59 0 0 0 .004-.637c-.032-.136-.074-.164-.121-.152Zm-.328 2c-.782 1.656-1.641 3.281-2.52 4.918.29.062.535.078.781.082h3.516c.8-.008.84-.05.508-.715-.68-1.36-1.38-2.71-2.07-4.066-.044-.078-.06-.18-.215-.219Zm-5.536 5.086c-.023 0-.047 0-.07.004C10.641 16.148 1 26.46 1 39v2h.832c.11.02.219.02.324 0H3v-2c0-11.516 8.828-20.95 20.086-21.918a1 1 0 0 0-.102-1.996Zm7.086.918s-2.55-.012-3.07.008c-.441.015-.54.133-.55.593-.012.29-.02.582-.227.805-.262.285-.278.602-.13.934.255.562.485.582.794.601.937.059 1.875.078 2.812.055.746-.02.926-.363 1.067-.531.312-.36.289-.746.07-1.14-.145-.263-.29-.524-.277-.833.007-.363-.172-.492-.489-.492Zm3.934.82a.994.994 0 0 0-.996.797c-.098.473.156.945.601 1.129C41.477 22.098 47 29.898 47 39v2h.832c.11.02.219.02.324 0H49v-2c0-9.914-6.02-18.437-14.61-22.094a1.01 1.01 0 0 0-.386-.082ZM23.89 18a.266.266 0 0 0-.133.031c-.254.106-.504.23-.758.344v.148c.242.141.48.29.723.415.09.046.218.144.25-.079.035-.222.03-.488.004-.718-.012-.098-.047-.133-.086-.141Zm2.437 2c-.215-.004-.305.07-.328.266-.04.32 0 .547 0 .84 0 .273-.035.199-.035.695 0 .25-.914.21-1.176.199-.277 0-.352-.105-.367-.258-.3-.836-.242-.601-.563-1.324-.093-.211-.234-.426-.468-.418-.227.012-.352.25-.407.45-.199.76-.402.905-.765 1.722-.004.11-.082.215-.14.312-.145.254-.095.399.19.442.294.043.59.07.887.074h7.578c.11 0 .274.055.266-.168-.02-.676.098-2.219 0-2.566-.055-.203-.14-.266-.344-.266-.941.012-3.386.016-4.328 0Zm6.563 0a.266.266 0 0 0-.133.031c-.254.106-.504.23-.758.344v.148c.242.141.48.29.723.415.09.046.218.144.25-.079.035-.222.03-.488.004-.718-.012-.098-.047-.133-.086-.141Zm-16 1a.266.266 0 0 0-.133.031c-.254.106-.504.23-.758.344v.148c.242.141.48.29.723.415.09.046.218.144.25-.079.035-.222.03-.488.004-.718-.012-.098-.047-.133-.086-.141ZM33 22c-.027.094-.95 2.594-.965 2.648-.055.13-.035.258-.015.387.14.934.183.969 1.093.965h.45c.214 0 .347-.074.39-.328.05-.297.074-.582-.012-.875-.058-.207-.18-.629-.18-.629l-.003-.012c-.024-.09-.656-2.004-.758-2.156Zm-16.621 1c-.195.012-.383.133-.488.363-.34.735-.618 1.508-.864 2.301-.058.188-.027.258.141.277.437.055.875.055 1.316.059.418-.008.84.012 1.258-.047.301-.047.309-.043.172-.402-.191-.5-.402-.988-.602-1.48-.109-.274-.218-.548-.382-.778-.149-.207-.356-.305-.551-.293Zm4.016 0c-.075-.004-.09.14-.106.238-.11.625-.18 1.266-.242 1.907-.09.87-.09.87.437.851.106 0 .215-.004.317 0 .183 0 .234-.113.176-.422-.149-.793-.301-1.582-.493-2.351-.023-.082-.027-.22-.09-.223Zm16.496 0a.266.266 0 0 0-.133.031c-.254.106-.504.23-.758.344v.148c.242.141.48.29.723.415.09.046.218.144.25-.079.035-.222.03-.488.004-.718-.012-.098-.047-.133-.086-.141Zm-14.532 1c-.195 0-.257.05-.25.246.028.602-.027.469-.09 1.067-.054.578-.03.683.544.687h8.734c.398-.016.285-.445.285-.445s.02-.371-.14-.93c-.165-.562-.157-.613-.743-.625Zm14.657 1.008c-.09-.016-.114.117-.141.207a144.11 144.11 0 0 0-.898 3.52c-.032.152 0 .21.148.226.29.031.582.055.875.039.21 0 .422.012.629-.004.371-.027.375-.031.293-.402a6.807 6.807 0 0 0-.113-.469c-.059-.187-.625-2.383-.715-2.89-.012-.09-.008-.212-.078-.227ZM19.684 27c-.2 0-.305.059-.391.234-.125.27-.27.532-.477.746-.128.133-.27.325-.48.196-.219-.133-.184-.356-.113-.567.023-.062.054-.117.086-.172.195-.367.164-.433-.243-.437h-3.898c-.16 0-.2.008-.148.172.148.43.207.883.214 1.34.004.468.008.488.47.488h20.058c.199-.004.293-.094.175-.316-.19-.368-.32-.762-.44-1.153-.095-.312-.286-.52-.626-.531Zm-8.793 1a.266.266 0 0 0-.133.031c-.254.106-.504.23-.758.344v.148c.242.141.48.29.723.415.09.046.218.144.25-.079.035-.222.03-.488.004-.718-.012-.098-.047-.133-.086-.141Zm3.64 2c-.234 0-.351.074-.41.285-.152.555-.086.844-.121 1.418-.016.238.059.3.297.297 1.375-.02 25.375 0 25.375 0 .36-.004.394-.047.246-.379-.16-.355-.11-.652-.23-1.023a1.091 1.091 0 0 0-.297-.442c-.192-.183-.383-.21-.582-.015-.125.117-.204.234-.332.343-.114.102-.243.121-.317-.03-.172-.356-.48-.45-.82-.454 0 0-16.531.012-22.809 0Zm-3.656 0a.409.409 0 0 0-.328.242c-.219.465-.379.953-.531 1.445-.043.141-.012.22.156.254.289.059.574.051.89.059.243-.016.516.008.786-.047.117-.023.187-.058.132-.203-.21-.54-.44-1.07-.75-1.562a.395.395 0 0 0-.355-.188Zm-1.367 3c-.149 0-.281.031-.387.184-.32.457-.668.894-.996 1.351-.195.278-.176.426.172.465h14.418c.77-.613 1.73-1 2.785-1 1.059 0 2.016.383 2.785 1h11.262c.793 0 1.324.02 2.113-.062.356-.036.414-.133.246-.442-.195-.367-.457-.687-.703-1.016-.226-.308-.516-.48-.894-.48Zm19.726 3c.391.582.633 1.27.715 2h11.207c.242.004.305-.05.266-.3-.059-.368-.23-1.048-.223-1.415.004-.258-.09-.285-.308-.285ZM9.063 36c-.22 0-.317.027-.31.285.009.367-.163 1.05-.222 1.414-.039.25.028.305.266.301H21.05c.082-.73.324-1.418.715-2Zm-.547 3c-.184.004-.282.098-.313.3-.062.388-.144 1.009-.23 1.388-.047.218-.02.316.246.312H21v-2ZM30 39v2h11.734c.266.004.293-.094.246-.312-.085-.38-.167-1-.23-1.387-.027-.203-.129-.297-.312-.301Z"
        })
    });
var $c67d20bd69d9f8ef$export$2e2bcd8739ae039 = $c67d20bd69d9f8ef$var$SvgDisneyMovies;



parcelRequire("7fPBF");
const $92aaa8e9b3c9a4fd$var$SvgDoomLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "m48.994 9.965-6 .037a1 1 0 0 0-.924.629L41 13.309l-1.07-2.68A1.001 1.001 0 0 0 39 10h-4v1l-.408-.408a2.02 2.02 0 0 0-1.43-.592h-7.16c-.641 0-1.256.254-1.709.707L24 11l-.3-.3a2.385 2.385 0 0 0-1.688-.7H13v1l-.293-.293A2.411 2.411 0 0 0 11.002 10H1a1 1 0 0 0-.707 1.707L2 13.414V36a1 1 0 0 0 1.613.79l9-7c.032-.027.064-.053.094-.083.401-.401.67-.747.861-1.064l6.014 4.334a1.003 1.003 0 0 0 1.186-.01L24 30.54l3.232 2.426a.997.997 0 0 0 1.186.01l6.57-4.737L38.4 30.8A1 1 0 0 0 40 30v-2l.977 1.953h.046L42 28v5c0 .314.148.61.4.799l4 3.002A1 1 0 0 0 48 36V13.408l1.713-1.744a1 1 0 0 0 .209-1.09 1 1 0 0 0-.922-.61h-.006zm-2.392 2.014-.315.32A1 1 0 0 0 46 13v21l-2-1.5V25a1 1 0 0 0-1.895-.447L41 26.763l-1.105-2.21A1 1 0 0 0 38 25v3l-2-1.5V12h2.322l1.748 4.371c.153.38.521.629.93.629.409 0 .777-.25.93-.629l1.75-4.375 2.922-.017zM3.414 12H11c.432 0 1 .629 1 1v14c0 .37 0 .577-.664 1.25L4 33.955V13a.997.997 0 0 0-.293-.707L3.414 12zM14 12h9v16.793l-2.846 2.133L14 26.488V12zm11 0h9v14.488l-6.154 4.438L25 28.793V12zM7 15v10l3-2v-8H7zm10 0v8l3 2V15h-3zm11 0v10l3-2v-8h-3z"
        })
    });
var $92aaa8e9b3c9a4fd$export$2e2bcd8739ae039 = $92aaa8e9b3c9a4fd$var$SvgDoomLogo;



const $0b863f60fd8ea76e$var$SvgEduLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 1200,
        height: 627,
        viewBox: "0 0 900 470.25",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "eduLogoTransparent_svg__a",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "eduLogoTransparent_svg__b",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "eduLogoTransparent_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M.715 89H899.28v291.77H.715Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "eduLogoTransparent_svg__d",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            filter: "url(#eduLogoTransparent_svg__a)",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                filter: "url(#eduLogoTransparent_svg__b)",
                                transform: "matrix(.97345 0 0 .97345 -48.056 88.733)",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                    xlinkHref: "data:image/png;base64,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",
                                    width: 1000,
                                    height: 300
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#eduLogoTransparent_svg__c)",
                mask: "url(#eduLogoTransparent_svg__d)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                    xlinkHref: "data:image/png;base64,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",
                    width: 1000,
                    height: 300,
                    transform: "matrix(.97345 0 0 .97345 -48.056 88.733)"
                })
            })
        ]
    });
var $0b863f60fd8ea76e$export$2e2bcd8739ae039 = $0b863f60fd8ea76e$var$SvgEduLogo;



const $793a6d9e0f3eb994$var$SvgEduLogoWhite = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 1200,
        height: 627,
        viewBox: "0 0 900 470.25",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "eduLogoWhite_svg__a",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "eduLogoWhite_svg__b",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "eduLogoWhite_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M.715 89H899.28v291.77H.715Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "eduLogoWhite_svg__d",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            filter: "url(#eduLogoWhite_svg__a)",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                filter: "url(#eduLogoWhite_svg__b)",
                                transform: "matrix(.97345 0 0 .97345 -48.056 88.733)",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                    xlinkHref: "data:image/png;base64,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",
                                    width: 1000,
                                    height: 300
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#eduLogoWhite_svg__c)",
                mask: "url(#eduLogoWhite_svg__d)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                    xlinkHref: "data:image/png;base64,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",
                    width: 1000,
                    height: 300,
                    transform: "matrix(.97345 0 0 .97345 -48.056 88.733)"
                })
            })
        ]
    });
var $793a6d9e0f3eb994$export$2e2bcd8739ae039 = $793a6d9e0f3eb994$var$SvgEduLogoWhite;



parcelRequire("7fPBF");
const $512b1d6277a77d97$var$SvgEpicGames = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10 3C6.698 3 4 5.698 4 9v32.244l21 6.3 21-6.3V9c0-3.302-2.698-6-6-6H10zm0 2h30c2.22 0 4 1.78 4 4v30.756l-19 5.7-19-5.7V9c0-2.22 1.78-4 4-4zm1 3a3 3 0 0 0-3 3v17a3 3 0 0 0 3 3h4v-3h-4v-7h3v-3h-3v-7h4V8h-4zm6 0v23h3V21h3a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3h-6zm11 0v23h3V8h-3zm8 0a3 3 0 0 0-3 3v17a3 3 0 0 0 3 3h3a3 3 0 0 0 3-3v-4h-3v4h-3V11h3v4h3v-4a3 3 0 0 0-3-3h-3zm-16 3h3v7h-3v-7zM9 33a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-2h-2v1h1v.75a.25.25 0 0 1-.25.25h-3.5a.25.25 0 0 1-.25-.25v-3.5a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25V35h1v-1a1 1 0 0 0-1-1H9zm9 0-3 6h1l.5-1h4l.5 1h1l-3-6h-1zm5 0v6h1v-4l1.5 3h1l1.5-3v4h1v-6h-1l-2 4-2-4h-1zm7 0v6h5v-1h-4v-1.5h2v-1h-2V34h4v-1h-5zm7 0a1 1 0 0 0-1 1v1.5a1 1 0 0 0 1 1h3.75a.25.25 0 0 1 .25.25v1a.25.25 0 0 1-.25.25h-3.5a.25.25 0 0 1-.25-.25v-.25h-1v.5a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1.5a1 1 0 0 0-1-1h-3.75a.25.25 0 0 1-.25-.25v-1a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25v.25h1V34a1 1 0 0 0-1-1h-4zm-18.5 1 1.5 3h-3l1.5-3z"
        })
    });
var $512b1d6277a77d97$export$2e2bcd8739ae039 = $512b1d6277a77d97$var$SvgEpicGames;



parcelRequire("7fPBF");
const $f83f391ed40890b1$var$SvgExpression = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "none",
        viewBox: "0 0 90 100",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#B6B7BD",
                fillRule: "evenodd",
                d: "M8.555 37.947C10.52 31.708 16.908 23.08 29.73 23.08c3.41 0 6.37.528 8.927 1.416.89-.45 1.834-.85 2.837-1.193-3.226-1.468-7.12-2.383-11.764-2.383-14.015 0-21.07 9.503-23.235 16.378-.721 2.29-.537 4.668-.186 6.827L8.476 57.46a25.082 25.082 0 0 0 9.593 15.956l1.95 1.48a17.809 17.809 0 0 0 9.37 3.568c.108.036.222.055.341.055.176 0 .352-.003.528-.008.176.005.352.008.528.008.119 0 .233-.02.34-.055a17.81 17.81 0 0 0 9.372-3.569l.662-.503a16.878 16.878 0 0 1-.489-.357l-1.306-.992-.173.132a15.648 15.648 0 0 1-8.934 3.175 15.649 15.649 0 0 1-8.934-3.175l-1.95-1.48a22.922 22.922 0 0 1-8.766-14.582L8.441 43.78c-.336-2.069-.451-4.037.114-5.832Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "M32.204 65.008c-4.015.533-7.459-.92-9.514-2.528a1.35 1.35 0 0 0-1.664 2.126c2.74 2.144 7.424 4.005 12.743 2.876a24.013 24.013 0 0 1-1.565-2.474Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#B6B7BD",
                fillRule: "evenodd",
                d: "M61.481 24.491c2.411-.885 5.184-1.411 8.349-1.411 13.811 0 20.272 8.664 22.231 14.868.567 1.793.45 3.761.114 5.83l-2.167 13.336a22.922 22.922 0 0 1-8.767 14.582l-1.95 1.48a15.65 15.65 0 0 1-8.933 3.175 15.65 15.65 0 0 1-8.934-3.175l-.223-.17-1.356 1.03c-.145.11-.29.216-.438.32l.711.54a17.81 17.81 0 0 0 9.371 3.57c.107.035.222.054.34.054.177 0 .353-.003.529-.008.175.005.351.008.528.008.119 0 .233-.02.34-.055a17.81 17.81 0 0 0 9.371-3.569l1.95-1.48a25.082 25.082 0 0 0 9.593-15.955l2.167-13.336c.35-2.158.537-4.538-.186-6.828C91.94 30.388 84.772 20.92 69.83 20.92c-4.393 0-8.103.934-11.192 2.428 1.005.33 1.952.715 2.843 1.143Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "M68.124 65.343h9.984a1.35 1.35 0 1 0 0-2.7h-8.659c-.385.928-.828 1.83-1.325 2.7Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M49.858 23.35c-12.673 0-18.978 8.519-20.918 14.678-.546 1.733-.439 3.65-.105 5.707l2.167 13.336a22.652 22.652 0 0 0 8.664 14.41l1.95 1.48a15.38 15.38 0 0 0 8.77 3.12 15.38 15.38 0 0 0 8.77-3.12l1.95-1.48a22.652 22.652 0 0 0 8.663-14.41l2.167-13.336c.334-2.058.443-3.974-.104-5.706C69.9 31.913 63.528 23.35 49.858 23.35Zm1.449 55.382a18.079 18.079 0 0 0 9.482-3.62l1.95-1.48a25.352 25.352 0 0 0 9.695-16.128l2.167-13.336c.353-2.168.549-4.6-.194-6.952-2.21-6.997-9.465-16.566-24.549-16.566-14.164 0-21.303 9.613-23.493 16.567-.74 2.35-.547 4.781-.194 6.951l2.166 13.336a25.352 25.352 0 0 0 9.696 16.128l1.95 1.48a18.079 18.079 0 0 0 9.482 3.62c.124.038.256.058.393.058.176 0 .352-.003.528-.008.175.005.351.008.528.008.136 0 .268-.02.393-.058Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "M45.75 62.476c-1.142.684-1.542 1.442-1.542 2.024 0 .582.4 1.34 1.541 2.024 1.114.669 2.74 1.126 4.609 1.126 1.868 0 3.495-.457 4.609-1.126 1.14-.684 1.54-1.442 1.54-2.024 0-.582-.4-1.34-1.54-2.024-1.114-.669-2.74-1.126-4.61-1.126-1.867 0-3.494.457-4.608 1.126Zm-1.39-2.316c1.6-.96 3.724-1.51 5.998-1.51s4.397.55 5.998 1.51c1.573.945 2.852 2.437 2.852 4.34s-1.279 3.395-2.852 4.34c-1.6.96-3.724 1.51-5.998 1.51s-4.397-.55-5.998-1.51c-1.574-.945-2.852-2.437-2.852-4.34s1.278-3.395 2.852-4.34Z",
                clipRule: "evenodd"
            })
        ]
    });
var $f83f391ed40890b1$export$2e2bcd8739ae039 = $f83f391ed40890b1$var$SvgExpression;



parcelRequire("7fPBF");
const $878338a7c05872f6$var$SvgEyebrowRaise = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#FBFDFE",
                d: "m63.321 77.626-2.384 1.81a20.461 20.461 0 0 1-11.726 4.152 20.462 20.462 0 0 1-11.725-4.153l-2.385-1.81a29.356 29.356 0 0 1-11.227-18.674l-2.65-16.311c-.42-2.585-.604-5.243.183-7.741 2.526-8.02 10.747-19.107 27.159-19.107 17.584 0 25.917 11.088 28.45 19.107.789 2.497.603 5.156.183 7.741l-2.65 16.31A29.357 29.357 0 0 1 63.32 77.627Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M48.566 17.442c-15.5 0-23.212 10.42-25.584 17.953-.668 2.12-.537 4.464-.128 6.98l2.65 16.31A27.706 27.706 0 0 0 36.1 76.31l2.384 1.81a18.81 18.81 0 0 0 10.727 3.816 18.81 18.81 0 0 0 10.727-3.816l2.385-1.81a27.705 27.705 0 0 0 10.595-17.625l2.65-16.31c.41-2.517.543-4.861-.126-6.98-2.363-7.48-10.157-17.953-26.876-17.953Zm1.771 67.736a22.112 22.112 0 0 0 11.598-4.428l2.384-1.81a31.008 31.008 0 0 0 11.86-19.725l2.65-16.31c.43-2.653.67-5.628-.238-8.504-2.704-8.557-11.577-20.26-30.025-20.26-17.324 0-26.055 11.756-28.734 20.262-.906 2.875-.67 5.848-.238 8.502l2.65 16.31a31.007 31.007 0 0 0 11.86 19.725l2.383 1.81c3.374 2.56 7.4 4.091 11.598 4.429.152.046.313.07.48.07.216 0 .431-.002.646-.009.215.007.43.01.646.01.167 0 .328-.025.48-.072Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "M38.956 36.628c-1.327.051-2.902.893-4.966 2.958a1.651 1.651 0 0 1-2.336-2.336c2.217-2.216 4.556-3.82 7.174-3.922 2.69-.104 5.114 1.387 7.452 3.985a1.651 1.651 0 1 1-2.455 2.21c-2.064-2.295-3.615-2.944-4.87-2.895ZM58.525 36.628c-1.327.051-2.902.893-4.966 2.958a1.651 1.651 0 0 1-2.335-2.336c2.216-2.216 4.555-3.82 7.173-3.922 2.69-.104 5.114 1.387 7.452 3.985a1.651 1.651 0 0 1-2.454 2.21c-2.065-2.295-3.616-2.944-4.87-2.895Z",
                clipRule: "evenodd"
            })
        ]
    });
var $878338a7c05872f6$export$2e2bcd8739ae039 = $878338a7c05872f6$var$SvgEyebrowRaise;



parcelRequire("7fPBF");
const $a6e3afa557217638$var$SvgFacebook = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4C6.25 4 4 6.25 4 9v32c0 2.75 2.25 5 5 5h16.832a1 1 0 0 0 .326 0h5.674a1 1 0 0 0 .326 0H41c2.75 0 5-2.25 5-5V9c0-2.75-2.25-5-5-5H9zm0 2h32c1.668 0 3 1.332 3 3v32c0 1.668-1.332 3-3 3h-8V30h3.82l1.4-7H33v-2c0-.557.053-.601.24-.723.187-.121.766-.277 1.76-.277h3v-5.63l-.57-.272S35.133 13 32 13c-2.25 0-4.098.896-5.281 2.375C25.536 16.854 25 18.833 25 21v2h-3v7h3v14H9c-1.668 0-3-1.332-3-3V9c0-1.668 1.332-3 3-3zm23 9c2.08 0 3.387.458 4 .701V18h-1c-1.15 0-2.073.095-2.85.6-.776.504-1.15 1.461-1.15 2.4v4h4.78l-.6 3H31v16h-4V28h-3v-3h3v-4c0-1.833.464-3.354 1.281-4.375S30.25 15 32 15z"
        })
    });
var $a6e3afa557217638$export$2e2bcd8739ae039 = $a6e3afa557217638$var$SvgFacebook;



parcelRequire("7fPBF");
const $0de5ad6202c372c1$var$SvgFacebookMessenger = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2C12.348 2 2 11.598 2 23.5c0 6.508 3.133 12.285 8 16.219v8.937l1.469-.781 7.219-3.75C20.703 44.665 22.8 45 25 45c12.652 0 23-9.598 23-21.5S37.652 2 25 2Zm0 2c11.645 0 21 8.758 21 19.5S36.645 43 25 43c-2.164 0-4.258-.312-6.219-.875l-.375-.094-.343.188L12 45.375v-6.562l-.375-.282C6.961 34.941 4 29.54 4 23.5 4 12.758 13.355 4 25 4Zm-2.281 13.719-12.032 12.75L21.5 24.406l5.781 6.188 11.875-12.875-10.531 5.906Z"
        })
    });
var $0de5ad6202c372c1$export$2e2bcd8739ae039 = $0de5ad6202c372c1$var$SvgFacebookMessenger;



parcelRequire("7fPBF");
const $e8f8716714af8e2c$var$SvgFaceExpression = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#B6B7BD",
                fillRule: "evenodd",
                d: "M8.555 37.947C10.52 31.708 16.908 23.08 29.73 23.08c3.41 0 6.37.528 8.927 1.416.89-.45 1.834-.85 2.837-1.193-3.226-1.468-7.12-2.383-11.764-2.383-14.015 0-21.07 9.503-23.235 16.378-.721 2.29-.537 4.668-.186 6.827L8.476 57.46a25.082 25.082 0 0 0 9.593 15.956l1.95 1.48a17.809 17.809 0 0 0 9.37 3.568c.108.036.222.055.341.055.176 0 .352-.003.528-.008.176.005.352.008.528.008.119 0 .233-.02.34-.055a17.81 17.81 0 0 0 9.372-3.569l.662-.503a16.878 16.878 0 0 1-.489-.357l-1.306-.992-.173.132a15.648 15.648 0 0 1-8.934 3.175 15.649 15.649 0 0 1-8.934-3.175l-1.95-1.48a22.922 22.922 0 0 1-8.766-14.582L8.441 43.78c-.336-2.069-.451-4.037.114-5.832Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "M32.204 65.008c-4.015.533-7.459-.92-9.514-2.528a1.35 1.35 0 0 0-1.664 2.126c2.74 2.144 7.424 4.005 12.743 2.876a24.013 24.013 0 0 1-1.565-2.474Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#B6B7BD",
                fillRule: "evenodd",
                d: "M61.481 24.491c2.411-.885 5.184-1.411 8.349-1.411 13.811 0 20.272 8.664 22.231 14.868.567 1.793.45 3.761.114 5.83l-2.167 13.336a22.922 22.922 0 0 1-8.767 14.582l-1.95 1.48a15.65 15.65 0 0 1-8.933 3.175 15.65 15.65 0 0 1-8.934-3.175l-.223-.17-1.356 1.03c-.145.11-.29.216-.438.32l.711.54a17.81 17.81 0 0 0 9.371 3.57c.107.035.222.054.34.054.177 0 .353-.003.529-.008.175.005.351.008.528.008.119 0 .233-.02.34-.055a17.81 17.81 0 0 0 9.371-3.569l1.95-1.48a25.082 25.082 0 0 0 9.593-15.955l2.167-13.336c.35-2.158.537-4.538-.186-6.828C91.94 30.388 84.772 20.92 69.83 20.92c-4.393 0-8.103.934-11.192 2.428 1.005.33 1.952.715 2.843 1.143Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "M68.124 65.343h9.984a1.35 1.35 0 1 0 0-2.7h-8.659c-.385.928-.828 1.83-1.325 2.7Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M49.858 23.35c-12.673 0-18.978 8.519-20.918 14.678-.546 1.733-.439 3.65-.105 5.707l2.167 13.336a22.652 22.652 0 0 0 8.664 14.41l1.95 1.48a15.38 15.38 0 0 0 8.77 3.12 15.38 15.38 0 0 0 8.77-3.12l1.95-1.48a22.652 22.652 0 0 0 8.663-14.41l2.167-13.336c.334-2.058.443-3.974-.104-5.706C69.9 31.913 63.528 23.35 49.858 23.35Zm1.449 55.382a18.079 18.079 0 0 0 9.482-3.62l1.95-1.48a25.352 25.352 0 0 0 9.695-16.128l2.167-13.336c.353-2.168.549-4.6-.194-6.952-2.21-6.997-9.465-16.566-24.549-16.566-14.164 0-21.303 9.613-23.493 16.567-.74 2.35-.547 4.781-.194 6.951l2.166 13.336a25.352 25.352 0 0 0 9.696 16.128l1.95 1.48a18.079 18.079 0 0 0 9.482 3.62c.124.038.256.058.393.058.176 0 .352-.003.528-.008.175.005.351.008.528.008.136 0 .268-.02.393-.058Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "M45.75 62.476c-1.142.684-1.542 1.442-1.542 2.024 0 .582.4 1.34 1.541 2.024 1.114.669 2.74 1.126 4.609 1.126 1.868 0 3.495-.457 4.609-1.126 1.14-.684 1.54-1.442 1.54-2.024 0-.582-.4-1.34-1.54-2.024-1.114-.669-2.74-1.126-4.61-1.126-1.867 0-3.494.457-4.608 1.126Zm-1.39-2.316c1.6-.96 3.724-1.51 5.998-1.51s4.397.55 5.998 1.51c1.573.945 2.852 2.437 2.852 4.34s-1.279 3.395-2.852 4.34c-1.6.96-3.724 1.51-5.998 1.51s-4.397-.55-5.998-1.51c-1.574-.945-2.852-2.437-2.852-4.34s1.278-3.395 2.852-4.34Z",
                clipRule: "evenodd"
            })
        ]
    });
var $e8f8716714af8e2c$export$2e2bcd8739ae039 = $e8f8716714af8e2c$var$SvgFaceExpression;



parcelRequire("7fPBF");
const $27eac4e6b224d0c7$var$SvgFacetime = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14 5c-4.953 0-9 4.047-9 9v22c0 4.953 4.047 9 9 9h22c4.953 0 9-4.047 9-9V14c0-4.953-4.047-9-9-9H14zm0 2h22c3.869 0 7 3.131 7 7v22c0 3.869-3.131 7-7 7H14c-3.869 0-7-3.131-7-7V14c0-3.869 3.131-7 7-7zm.025 9A4.042 4.042 0 0 0 10 20.025v9.95A4.042 4.042 0 0 0 14.025 34h11.95A4.042 4.042 0 0 0 30 29.975v-9.95A4.042 4.042 0 0 0 25.975 16h-11.95zm24.065 1.012c-.457 0-.925.19-1.256.486L32 21.812v6.375l4.836 4.315v.002c.33.294.797.484 1.254.484.95 0 1.91-.793 1.91-1.904V18.916c0-1.111-.96-1.904-1.91-1.904zM14.025 18h11.95C27.1 18 28 18.9 28 20.025v9.95C28 31.1 27.1 32 25.975 32h-11.95C12.9 32 12 31.1 12 29.975v-9.95C12 18.9 12.9 18 14.025 18zM38 19.14v11.721l-4-3.57v-4.584l4-3.566z"
        })
    });
var $27eac4e6b224d0c7$export$2e2bcd8739ae039 = $27eac4e6b224d0c7$var$SvgFacetime;



parcelRequire("7fPBF");
const $25abb7d8311d1b5e$var$SvgFindIphone = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14 4C8.489 4 4 8.489 4 14v22c0 5.511 4.489 10 10 10h22c5.511 0 10-4.489 10-10V14c0-5.511-4.489-10-10-10H14zm0 2h22c4.43 0 8 3.57 8 8v22c0 4.43-3.57 8-8 8H14c-4.43 0-8-3.57-8-8V14c0-4.43 3.57-8 8-8zm11 2C15.623 8 8 15.623 8 25c0 9.377 7.623 17 17 17 9.377 0 17-7.623 17-17 0-9.377-7.623-17-17-17zm0 2c2.379 0 4.617.567 6.613 1.549l-4.705 8.836C26.328 20.163 25.703 20 25 20c-.703 0-1.328.163-1.908.385l-4.705-8.836A14.936 14.936 0 0 1 25 10zm-8.354 2.535 1.877 3.524C15.786 18.06 14 21.29 14 24.934c0 6.063 4.937 11 11 11s11-4.937 11-11c0-3.643-1.785-6.873-4.521-8.875l1.875-3.524A14.972 14.972 0 0 1 40 25c0 8.296-6.704 15-15 15s-15-6.704-15-15c0-5.201 2.636-9.775 6.646-12.465zm2.825 5.303 1.935 3.637c-.043.044-.113.065-.154.11C20.402 22.543 20 23.779 20 25s.402 2.458 1.252 3.414S23.417 30 25 30c1.583 0 2.898-.63 3.748-1.586C29.598 27.458 30 26.222 30 25s-.402-2.458-1.252-3.414c-.041-.046-.111-.067-.154-.111l1.935-3.637A8.975 8.975 0 0 1 34 24.934c0 4.982-4.017 9-9 9s-9-4.018-9-9c0-2.89 1.362-5.45 3.47-7.096zM25 22c1.083 0 1.769.37 2.252.914.483.544.748 1.308.748 2.086 0 .778-.265 1.542-.748 2.086-.483.544-1.169.914-2.252.914-1.083 0-1.769-.37-2.252-.914C22.265 26.542 22 25.778 22 25c0-.778.265-1.542.748-2.086C23.231 22.37 23.917 22 25 22z"
        })
    });
var $25abb7d8311d1b5e$export$2e2bcd8739ae039 = $25abb7d8311d1b5e$var$SvgFindIphone;



parcelRequire("7fPBF");
const $4d66404571458338$var$SvgFireTv = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M6 4c-1.093 0-2 .907-2 2v38c0 1.093.907 2 2 2h38c1.093 0 2-.907 2-2V6c0-1.093-.907-2-2-2H6zm0 2h38v38H6V6zm6.898 9c-.64 0-1.184.22-1.617.648-.43.43-.648 1.015-.648 1.74v.852H9.52v1.276h1.113v5.566h1.431v-5.566h1.53V18.24h-1.53v-.8c0-1.05.513-1.17.899-1.17.227 0 .42.046.594.146l.297.166v-1.4l-.124-.051c-.21-.088-.484-.131-.832-.131zm2.155.26a.876.876 0 0 0-.621.248.838.838 0 0 0-.256.62c0 .246.085.456.258.622a.856.856 0 0 0 .615.244.87.87 0 0 0 .625-.252.832.832 0 0 0 .262-.613.828.828 0 0 0-.262-.621.893.893 0 0 0-.621-.248zm17.418 1-1.442.457v1.523H29.91v1.276h1.12v3.619c0 1.725 1.04 2.088 1.91 2.088.43 0 .79-.079 1.068-.229l.103-.053V23.55l-.318.238a.91.91 0 0 1-.563.17c-.279 0-.474-.065-.582-.201-.08-.1-.177-.323-.177-.803v-3.437h1.64V18.24h-1.64v-1.98zm-7.885 1.826a2.97 2.97 0 0 0-2.287 1.018c-.606.664-.914 1.532-.914 2.582 0 1.106.284 1.982.84 2.603.564.626 1.344.945 2.318.945.978 0 1.782-.22 2.387-.656l.082-.058v-1.475l-.32.25c-.584.455-1.205.676-1.901.676-.603 0-1.06-.173-1.396-.526-.302-.314-.478-.763-.522-1.33h4.592v-.738c0-1.012-.253-1.82-.748-2.402-.506-.59-1.221-.89-2.131-.89zm-4.143.039c-.422 0-.807.144-1.15.428-.142.12-.27.258-.38.414v-.727h-1.44v6.842h1.44v-3.484c0-.675.137-1.21.41-1.584.261-.365.574-.543.956-.543.298 0 .523.056.668.166l.319.244v-1.6l-.123-.05c-.172-.07-.402-.106-.7-.106zm-6.127.115v6.842h1.442V18.24h-1.442zm20.016 0 2.62 6.842h1.294L41 18.24h-1.533l-1.778 4.842a2.348 2.348 0 0 0-.037.11c-.014-.044-.03-.087-.047-.133l-1.7-4.819h-1.573zm-9.766 1.112c.453 0 .792.141 1.043.43.22.254.35.612.381 1.064h-3.076c.093-.414.275-.76.541-1.032a1.488 1.488 0 0 1 1.111-.462zm13.809 8.804c-1.109.017-2.417.286-3.41 1.053-.304.235-.25.56.088.516 1.118-.147 3.607-.477 4.05.148.448.623-.488 3.203-.908 4.354-.127.348.143.488.428.224 1.86-1.71 2.342-5.3 1.961-5.818-.19-.257-1.1-.494-2.209-.477zm-29.143.686c-.232.034-.335.339-.091.582C13.3 33.532 18.8 36 24.904 36c4.357 0 9.412-1.495 12.903-4.312.576-.466.083-1.167-.506-.895-3.913 1.816-8.165 2.693-12.03 2.693-5.734 0-11.28-1.723-15.769-4.58a.396.396 0 0 0-.27-.064z"
        })
    });
var $4d66404571458338$export$2e2bcd8739ae039 = $4d66404571458338$var$SvgFireTv;



parcelRequire("7fPBF");
const $195bb2aa60406de1$var$SvgFortnite = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4C6.25 4 4 6.25 4 9v32c0 2.75 2.25 5 5 5h32c2.75 0 5-2.25 5-5V9c0-2.75-2.25-5-5-5H9zm0 2h32c1.668 0 3 1.332 3 3v32c0 1.668-1.332 3-3 3H9c-1.668 0-3-1.332-3-3V9c0-1.668 1.332-3 3-3zm8 3v3h-7l1 8-1 18 7-2v6l9-2v-5l14 1-1-17 1-7h-7.666L33 9H17zm2 2h11.508l-1.112 5H24v7h5v5h-5v10.396l-5 1.112V11zm-6.734 3H17v19.92l-4.848 1.385.856-15.373L12.266 14zm19.623 0h5.804l-.7 4.916.876 14.928L26 33v-3h5v-9h-5v-3h5l.889-4z"
        })
    });
var $195bb2aa60406de1$export$2e2bcd8739ae039 = $195bb2aa60406de1$var$SvgFortnite;



parcelRequire("7fPBF");
const $3e61990689ecc79a$var$SvgGithub = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2C12.311 2 2 12.311 2 25s10.311 23 23 23 23-10.311 23-23S37.689 2 25 2zm0 2c11.607 0 21 9.393 21 21 0 .071-.005.142-.006.213a39.758 39.758 0 0 0-2.318-.149 59.326 59.326 0 0 0-4.903.061c.07-.49.12-.988.122-1.498.096-1.873-.532-3.625-1.555-5.172.247-.854.537-1.94.61-3.172.082-1.404-.04-2.961-1.167-4.013l-.289-.27H36.1c-2.683 0-4.52 1.123-5.643 2.014A15.026 15.026 0 0 0 25 12a15.82 15.82 0 0 0-5.553 1.018C18.325 12.127 16.487 11 13.801 11h-.393l-.289.268c-1.098 1.02-1.2 2.534-1.13 3.931.06 1.233.333 2.353.575 3.248-1.04 1.578-1.664 3.375-1.664 5.153 0 .511.048 1.01.118 1.502-1.806-.084-3.416-.1-4.694-.055-.94.033-1.679.089-2.318.148 0-.065-.006-.13-.006-.195C4 13.393 13.393 4 25 4zm-10.604 9.13c2.018.192 3.536 1.093 4.239 1.718l.469.414.578-.237C21.263 14.375 23.027 14 25 14c1.973 0 3.737.376 5.2 1.016l.585.257.479-.425c.703-.625 2.223-1.526 4.242-1.717.268.445.501 1.078.445 2.035-.067 1.146-.374 2.394-.605 3.135l-.15.482.298.408c.99 1.35 1.494 2.81 1.408 4.354l-.002.027v.028c0 2.495-.898 4.492-2.812 5.972C32.174 31.052 29.153 32 24.9 32c-4.252 0-7.275-.948-9.19-2.428-1.913-1.48-2.81-3.477-2.81-5.972 0-1.465.53-3.076 1.506-4.409l.293-.398-.14-.475c-.232-.788-.516-2.064-.573-3.216-.047-.96.18-1.565.41-1.971zM8.885 26.022c.706.01 1.516.048 2.328.088.077.312.166.619.273.918-3.307.07-5.781.403-7.306.688-.065-.5-.116-1.005-.145-1.516a44.845 44.845 0 0 1 4.85-.178zm32.23.016c2.133-.027 3.72.071 4.848.178-.029.503-.08 1-.143 1.494-1.58-.29-4.12-.622-7.513-.676.105-.293.193-.595.27-.9a64.2 64.2 0 0 1 2.538-.096zM11.912 28.02a9.029 9.029 0 0 0 2.576 3.134c1.54 1.192 3.544 2.024 5.989 2.469-.32.329-.611.69-.87 1.07l-.06-.052c.005-.007-.497.245-1.248.312S16.622 35 15.8 35c-1.225 0-1.765-.579-2.627-1.633a7.098 7.098 0 0 0-1.625-1.56c-.579-.406-1.073-.691-1.684-.793L9.783 31H9.7c-.466 0-.918.034-1.34.516-.21.24-.356.687-.261 1.064.094.378.333.61.547.752 1.366.911 1.608 2.715 2.464 4.318.8 1.594 2.527 2.35 4.291 2.35H18v4.803c-7.032-2.482-12.335-8.598-13.668-16.1 1.53-.288 4.095-.635 7.58-.683zm25.97.007c3.564.03 6.199.377 7.788.67C44.339 36.202 39.034 42.32 32 44.803V39.6c0-1.585-.52-3.332-1.426-4.79a7.52 7.52 0 0 0-.959-1.236c2.315-.457 4.217-1.275 5.698-2.42a9.004 9.004 0 0 0 2.57-3.127zM23.7 34.1H26.5c.813 0 1.68.647 2.375 1.765C29.57 36.983 30 38.485 30 39.6v5.798a21.078 21.078 0 0 1-10 0V39.6c0-1.091.468-2.589 1.209-3.711.741-1.123 1.677-1.79 2.49-1.79zM12.31 35.28C13.174 36.18 14.223 37 15.8 37c.779 0 1.751.028 2.676-.055l.01-.002c-.122.35-.213.703-.29 1.057H15.4c-1.233 0-2.104-.446-2.505-1.248l-.008-.014-.006-.011c-.165-.306-.38-.916-.572-1.446z"
        })
    });
var $3e61990689ecc79a$export$2e2bcd8739ae039 = $3e61990689ecc79a$var$SvgGithub;



parcelRequire("7fPBF");
const $792bc4d5598bcd37$var$SvgGmail = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M43.754 6.402A5.478 5.478 0 0 0 40.27 7.47l-2.746 2.027L25 18.756 12.592 9.584a1 1 0 0 0-.643-.283h.25L9.734 7.477a5.48 5.48 0 0 0-3.486-1.07 5.034 5.034 0 0 0-3.34 1.439A6.403 6.403 0 0 0 1 12.41v3.434a1 1 0 0 0 0 .295V39.5C1 41.421 2.579 43 4.5 43H12a1 1 0 0 0 1-1V25.373l11.406 8.432a1 1 0 0 0 1.188 0L37 25.373V42a1 1 0 0 0 1 1h7.5c1.921 0 3.5-1.579 3.5-3.5V16.12a1 1 0 0 0 0-.26v-3.45a6.414 6.414 0 0 0-1.902-4.566 1 1 0 0 0-.006-.006 5.037 5.037 0 0 0-3.338-1.436zm-.11 1.998c.757.03 1.49.317 2.045.864l.024.023A4.402 4.402 0 0 1 47 12.41v3.086l-8 5.912V11a1 1 0 0 0-.004-.102l2.463-1.82a1 1 0 0 0 .002 0 3.461 3.461 0 0 1 2.184-.678zm-37.287.006a3.464 3.464 0 0 1 2.188.678l2.459 1.818A1 1 0 0 0 11 11v10.408l-8-5.912V12.41c0-1.236.502-2.341 1.313-3.14a3.059 3.059 0 0 1 2.044-.864zM37 12.371v10.516l-12 8.869-12-8.87V12.374l11.406 8.432a1 1 0 0 0 1.188 0L37 12.37zM3 17.982l8 5.914V41H4.5c-.84 0-1.5-.66-1.5-1.5V17.982zm44 0V39.5c0 .84-.66 1.5-1.5 1.5H39V23.896l8-5.914z"
        })
    });
var $792bc4d5598bcd37$export$2e2bcd8739ae039 = $792bc4d5598bcd37$var$SvgGmail;



parcelRequire("7fPBF");
const $75745da5fba927e0$var$SvgGmailLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M5.5 7C3.031 7 1.012 9.016 1 11.484V38.5C1 40.973 3.027 43 5.5 43h39c2.473 0 4.5-2.027 4.5-4.5V11.484C48.988 9.016 46.969 7 44.5 7Zm2.602 2h33.8L25 20.781Zm-3.329.117L25 23.22 45.23 9.117A2.477 2.477 0 0 1 47 11.488c-.004.211-.219.633-.531.973-.317.344-.625.559-.625.559l-.004.007L25 27.777 4.16 13.027l-.004-.007s-.308-.215-.625-.56c-.312-.339-.527-.76-.531-.972a2.476 2.476 0 0 1 1.773-2.37ZM3 14.652l.008.008.008.004v.004L6 16.778V41h-.5C4.11 41 3 39.89 3 38.5Zm44 0V38.5c0 1.39-1.11 2.5-2.5 2.5H44V16.777l2.984-2.109v-.004l.016-.012Zm-39 3.54 17 12.03 17-12.03V41H8Z"
        })
    });
var $75745da5fba927e0$export$2e2bcd8739ae039 = $75745da5fba927e0$var$SvgGmailLogo;



parcelRequire("7fPBF");
const $c6371eb2aedbedde$var$SvgGoogle = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M26 2C13.309 2 3 12.309 3 25s10.309 23 23 23c9.918 0 15.973-4.562 19.125-10.219 3.152-5.656 3.55-12.3 2.594-16.843l-.188-.782h-.781L26 20.125h-1v10.406h11.438c-1.727 4-5.243 6.75-10.438 6.75-6.79 0-12.281-5.492-12.281-12.281 0-6.79 5.492-12.281 12.281-12.281 3.05 0 5.82 1.129 7.969 2.969l.718.593 6.844-6.843.719-.75L41.5 8C37.414 4.277 31.96 2 26 2Zm0 2c5.074 0 9.652 1.855 13.281 4.844l-4.812 4.812c-2.38-1.777-5.27-2.937-8.469-2.937-7.871 0-14.281 6.41-14.281 14.281S18.129 39.281 26 39.281c6.55 0 11.262-4.015 12.938-9.468l.406-1.282H27v-6.406l18.844.031c.664 4.035.222 9.828-2.469 14.657C40.515 41.937 35.32 46 26 46 14.387 46 5 36.61 5 25S14.387 4 26 4Z"
        })
    });
var $c6371eb2aedbedde$export$2e2bcd8739ae039 = $c6371eb2aedbedde$var$SvgGoogle;



parcelRequire("7fPBF");
const $d6a3e630182db681$var$SvgGoogleCalendar = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9.66 5.959c-1.442 0-2.642 1.183-2.642 2.627v4.678A4.439 4.439 0 0 0 5.02 14.65a4.418 4.418 0 0 0-.91 3.686L6.414 29.49 4.12 40.615c-.27 1.31.068 2.671.914 3.705a4.476 4.476 0 0 0 3.46 1.635h32.91a4.531 4.531 0 0 0 3.501-1.654h.002a4.495 4.495 0 0 0 .926-3.754l-2.281-11.059c.048-.235 1.37-6.662 2.299-11.162a4.405 4.405 0 0 0-2.852-5.043V8.586c0-1.444-1.2-2.627-2.643-2.627H9.66zm0 2h30.695c.372 0 .643.275.643.627v4.437H9.018V8.586c0-.352.27-.627.642-.627zm-1.197 7.064h33.045c.733 0 1.425.326 1.887.89v.001c.462.564.642 1.3.496 2.01h.002L41.55 29.287l-.041.201.04.203 2.323 11.258a2.485 2.485 0 0 1-.514 2.082 2.527 2.527 0 0 1-1.957.924H8.492a2.469 2.469 0 0 1-1.912-.902 2.431 2.431 0 0 1-.502-2.033L8.414 29.69l.041-.203-.04-.2S7.016 22.512 6.07 17.931a2.406 2.406 0 0 1 .498-2.014l.002-.002a2.445 2.445 0 0 1 1.893-.893zm11.525 6.88c-4.429 0-4.824 4.021-4.847 5h1.873c.028-.675.338-3.298 2.974-3.298 2.468 0 2.81 1.702 2.81 2.553 0 .426-.256 2.553-2.98 2.553h-.765v1.617c.34-.085.68-.086 1.105-.086.425 0 3.32.087 3.32 2.98 0 2.809-2.979 3.063-3.404 3.063-1.509 0-3.257-.916-3.31-3.383h-1.88c.018 1.227.39 5 5.19 5 .936 0 5.362-.254 5.362-4.765 0-2.808-1.873-3.66-2.809-3.83v-.084c.596-.34 2.129-1.364 2.129-3.15 0-.682-.172-4.17-4.768-4.17zm12.557.113c-.25 1.1-.746 1.855-1.486 2.265-.74.41-1.74.615-3.002.615v1.409h3.916v11.287h2.045V22.016h-1.473z"
        })
    });
var $d6a3e630182db681$export$2e2bcd8739ae039 = $d6a3e630182db681$var$SvgGoogleCalendar;



parcelRequire("7fPBF");
const $b2a655191d7c12f7$var$SvgGoogleClassroom = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M6 5C3.8 5 2 6.8 2 9v32c0 2.2 1.8 4 4 4h38c2.2 0 4-1.8 4-4V9c0-2.2-1.8-4-4-4Zm0 2h38c1.117 0 2 .883 2 2v32c0 1.117-.883 2-2 2H6c-1.117 0-2-.883-2-2V9c0-1.117.883-2 2-2Zm.813 2A1 1 0 0 0 6 10v30c0 .55.45 1 1 1h36.094A.996.996 0 0 0 44 40V10c0-.55-.45-1-1-1H6.813ZM8 11h34v28h-4v-2h-9v2H8Zm17 6c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4Zm0 2c1.117 0 2 .883 2 2s-.883 2-2 2-2-.883-2-2 .883-2 2-2Zm-8 2c-1.645 0-3 1.355-3 3s1.355 3 3 3 3-1.355 3-3-1.355-3-3-3Zm16 0c-1.645 0-3 1.355-3 3s1.355 3 3 3 3-1.355 3-3-1.355-3-3-3Zm-16 2c.563 0 1 .438 1 1 0 .563-.437 1-1 1-.562 0-1-.437-1-1 0-.562.438-1 1-1Zm16 0c.563 0 1 .438 1 1 0 .563-.437 1-1 1-.562 0-1-.437-1-1 0-.562.438-1 1-1Zm-8 3c-2.727 0-4.918 1.262-5.969 2A6.446 6.446 0 0 0 17 27.656c-2.707 0-4.656 1.782-4.656 1.782L12 29.75V33h26v-3.25l-.344-.312S35.707 27.656 33 27.656c-.746 0-1.43.145-2.031.344-1.051-.738-3.242-2-5.969-2Zm0 2c2.613 0 4.55 1.457 5 1.813V31H20v-1.187c.45-.356 2.387-1.813 5-1.813Zm-8 1.656c.348 0 .676.074 1 .157V31h-4v-.281c.406-.301 1.508-1.063 3-1.063Zm16 0c1.492 0 2.594.762 3 1.063V31h-4v-1.187c.324-.083.652-.157 1-.157Z"
        })
    });
var $b2a655191d7c12f7$export$2e2bcd8739ae039 = $b2a655191d7c12f7$var$SvgGoogleClassroom;



parcelRequire("7fPBF");
const $713e9c2c47877792$var$SvgGoogleDocs = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M28.906 1.969c-.043.008-.086.02-.125.031H11.5C9.586 2 8 3.559 8 5.469v38.437C8 46.16 9.867 48 12.125 48h25.75C40.133 48 42 46.16 42 43.906V15.188a1.016 1.016 0 0 0 0-.407V14.5a.99.99 0 0 0-.281-.719l-11.5-11.5A.99.99 0 0 0 29.5 2h-.312a.972.972 0 0 0-.282-.031ZM11.5 4H28v8.344A3.666 3.666 0 0 0 31.656 16H40v27.906C40 45.074 39.055 46 37.875 46h-25.75C10.945 46 10 45.074 10 43.906V5.47C10 4.645 10.66 4 11.5 4Zm18.5.938L39.063 14h-7.407A1.633 1.633 0 0 1 30 12.344ZM17 24v2h16v-2Zm0 4v2h16v-2Zm0 4v2h16v-2Zm0 4v2h9v-2Z"
        })
    });
var $713e9c2c47877792$export$2e2bcd8739ae039 = $713e9c2c47877792$var$SvgGoogleDocs;



parcelRequire("7fPBF");
const $e950c6997d469e51$var$SvgGoogleDrawing = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M28.906 1.969c-.043.008-.086.02-.125.031H11.5C9.586 2 8 3.559 8 5.469v38.437C8 46.16 9.867 48 12.125 48h25.75C40.133 48 42 46.16 42 43.906V15.188a1.016 1.016 0 0 0 0-.407V14.5a.99.99 0 0 0-.281-.719l-11.5-11.5A.99.99 0 0 0 29.5 2h-.312a.972.972 0 0 0-.282-.031ZM11.5 4H28v8.344A3.666 3.666 0 0 0 31.656 16H40v27.906C40 45.074 39.055 46 37.875 46h-25.75C10.945 46 10 45.074 10 43.906V5.47C10 4.645 10.66 4 11.5 4Zm18.5.938L39.063 14h-7.407A1.633 1.633 0 0 1 30 12.344ZM21 22c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6Zm0 2c2.223 0 4 1.777 4 4s-1.777 4-4 4-4-1.777-4-4 1.777-4 4-4Zm7.406 7A7.979 7.979 0 0 1 25 34.906V40h9v-9Z"
        })
    });
var $e950c6997d469e51$export$2e2bcd8739ae039 = $e950c6997d469e51$var$SvgGoogleDrawing;



parcelRequire("7fPBF");
const $28402c28da4b8b2b$var$SvgGoogleDrive = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M16.406 4a1.009 1.009 0 0 0-.656.469l-15.594 25a.996.996 0 0 0-.062.968l7.812 16c.168.348.52.567.907.563h31.5c.367-.004.703-.207.874-.531l8.688-16a1.005 1.005 0 0 0-.031-1l-15.594-25A.993.993 0 0 0 33.406 4H16.406Zm.875 2h15.563L47.53 29.563 29.406 24Zm-.343.375 4.156 17.031L9.375 44.938 2.156 30.062Zm7.875 15.031L29.688 29h-9.375Zm23 8.657L39.719 45H9.938L25 31.5Z"
        })
    });
var $28402c28da4b8b2b$export$2e2bcd8739ae039 = $28402c28da4b8b2b$var$SvgGoogleDrive;



parcelRequire("7fPBF");
const $52d4718a69ac94c7$var$SvgGoogleEarth = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2a22.87 22.87 0 0 0-12.68 3.82c-.209.12-.417.24-.613.375a1 1 0 0 0-.228.213C5.739 10.593 2 17.363 2 25c0 12.689 10.311 23 23 23 6.151 0 11.727-2.44 15.855-6.383a1 1 0 0 0 .307-.297c3.541-3.51 5.964-8.145 6.639-13.336a1 1 0 0 0 .017-.152c.115-.929.182-1.873.182-2.832 0-2.16-.304-4.25-.863-6.234a1 1 0 0 0-.084-.293 1 1 0 0 0-.004-.008C44.228 8.954 35.419 2 25 2zm0 2c9.251 0 17.089 5.969 19.893 14.268l-.014.021c-.064.105-.111.19-.158.266-.189.304-.194.445-.721.445-.638 0-1.536-.642-2.646-1.982-1.11-1.341-2.37-3.228-3.918-5.147-2.968-3.678-7.145-7.522-13.588-7.838C24.229 4.013 24.613 4 25 4zm-4 1.996A1 1 0 0 0 21 6a1 1 0 0 0 1 1 1 1 0 0 0 1-1c1.543 0 2.933.217 4.2.6a1 1 0 0 0 .001 0A1 1 0 0 0 28 7a1 1 0 0 0 .248-.033c.812.32 1.567.71 2.277 1.154A1 1 0 0 0 30 9a1 1 0 0 0 1 1 1 1 0 0 0 .988-.846A20.434 20.434 0 0 1 33.994 11 1 1 0 0 0 33 12a1 1 0 0 0 1 1 1 1 0 0 0 .996-.914c.3.345.599.691.883 1.043.255.316.494.632.736.947A1 1 0 0 0 36 15a1 1 0 0 0 1 1 1 1 0 0 0 .78-.375c.473.643.929 1.256 1.376 1.836A1 1 0 0 0 39 18a1 1 0 0 0 1 1 1 1 0 0 0 .377-.074c.56.62 1.137 1.173 1.775 1.545A1 1 0 0 0 42 21a1 1 0 0 0 1 1 1 1 0 0 0 1-1c.645 0 1.13-.225 1.512-.506.179.82.305 1.66.386 2.512A1 1 0 0 0 45 24a1 1 0 0 0 1 1c0 .562-.029 1.117-.072 1.668-1.358-.27-3.142-1.105-5.008-2.28A1 1 0 0 0 41 24a1 1 0 0 0-1-1 1 1 0 0 0-.707.295 52.774 52.774 0 0 1-1.873-1.389A1 1 0 0 0 38 21a1 1 0 0 0-1-1 1 1 0 0 0-.979.795 84.57 84.57 0 0 1-2.126-1.8A1 1 0 0 0 34 19a1 1 0 0 0 1-1 1 1 0 0 0-1-1 1 1 0 0 0-1 1 1 1 0 0 0 .027.232c-.778-.685-1.612-1.491-2.474-2.337A1 1 0 0 0 31 16a1 1 0 0 0 1-1 1 1 0 0 0-1-1 1 1 0 0 0-1 1 1 1 0 0 0 .117.465c-1.398-1.375-2.89-2.837-4.494-4.17C22.805 8.953 19.618 7 16 7c-.58 0-1.115.032-1.627.08.312-.117.644-.22.984-.316A1 1 0 0 0 16 7a1 1 0 0 0 .912-.596c.71-.133 1.428-.234 2.11-.297.738-.067 1.389-.095 1.978-.11zM25 8a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm-9 1c2.886 0 5.68 1.621 8.344 3.834 2.663 2.213 5.135 4.963 7.459 6.99 2.267 2.026 4.923 4.223 7.535 5.94 2.196 1.443 4.334 2.575 6.338 2.904-.12.681-.273 1.35-.457 2.008-7.316-.215-12.785-4.076-17.781-8.106C22.298 18.424 17.704 14 12 14c-2.46 0-4.435.882-5.912 1.912a20.977 20.977 0 0 1 3.025-4.627 1 1 0 0 0 .211-.193s.326-.432 1.367-.975C11.733 9.575 13.424 9 16 9zm12 2a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm-16 5c1.456 0 2.883.391 4.318 1.055A1 1 0 0 0 16 17a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-.436-.824c3.048 1.473 6.14 4.147 9.618 6.951a74.639 74.639 0 0 0 3.82 2.912A1 1 0 0 0 31 28a1 1 0 0 0 .348-.064c.67.438 1.359.856 2.064 1.255A1 1 0 0 0 33 30a1 1 0 0 0 1 1 1 1 0 0 0 .998-.95c2.204 1.09 4.59 1.927 7.209 2.343A1 1 0 0 0 42 33a1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-.086-.402c.215.018.426.042.645.054a20.88 20.88 0 0 1-1.766 3.471C42.535 36.258 39.132 38 35 38c-5.075 0-8.941-.705-12.06-1.662A1 1 0 0 0 23 36a1 1 0 0 0-1-1 1 1 0 0 0-.951.697 39.949 39.949 0 0 1-2.688-1.107c-1.763-.805-3.248-1.633-4.656-2.299a1 1 0 0 0-.633-.289h-.002C11.714 31.407 10.413 31 9 31c-1.7 0-2.907.773-3.6 1.545a21.076 21.076 0 0 1-.627-1.912A1 1 0 0 0 5 30a1 1 0 0 0-.59-.91A20.976 20.976 0 0 1 4 25a1 1 0 0 0 1-1 1 1 0 0 0-.896-.994c.088-.927.23-1.838.433-2.727a1 1 0 0 0 .078-.11S7.221 16 12 16zm-2 1a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm-3 3a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm-9 3a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zM7 26a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm-15 3a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm-9 3a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zM9 33c2.187 0 4.617 1.623 8.531 3.41C21.446 38.197 26.82 40 35 40c2.088 0 3.98-.4 5.492-.852-.254.279-.516.549-.785.813C39.417 40.118 35.831 42 30 42c-2.998 0-5.342-.706-7.38-1.441C20.58 39.823 18.856 39 17 39c-1.164 0-2.172.54-2.572 1.379-.4.838-.288 1.69-.104 2.447.026.106.066.2.096.303a21.093 21.093 0 0 1-8.043-8.44c.029-.085.144-.397.492-.793C7.27 33.443 7.852 33 9 33zm19 2a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm-23 6c1.204 0 2.824.677 4.941 1.441C24.06 43.206 26.685 44 30 44c1.792 0 3.39-.182 4.797-.437-.901.478-1.843.89-2.817 1.236A1 1 0 0 0 31 44a1 1 0 0 0-1 1 1 1 0 0 0 .072.373c-1.624.405-3.32.627-5.072.627a1 1 0 0 0 1-1 1 1 0 0 0-1-1 1 1 0 0 0-1 1 1 1 0 0 0 .924.998 21.002 21.002 0 0 1-4.996-.627A1 1 0 0 0 20 45a1 1 0 0 0-1-1 1 1 0 0 0-.98.805 20.77 20.77 0 0 1-.875-.338c-.12-.214-.437-.807-.704-1.572A1 1 0 0 0 17 42a1 1 0 0 0-.627-.928c.095-.044.27-.072.627-.072z"
        })
    });
var $52d4718a69ac94c7$export$2e2bcd8739ae039 = $52d4718a69ac94c7$var$SvgGoogleEarth;



parcelRequire("7fPBF");
const $6ee8c38486294b4f$var$SvgGoogleForms = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M28.906 1.969c-.043.008-.086.02-.125.031H11.5C9.586 2 8 3.559 8 5.469v38.437C8 46.16 9.867 48 12.125 48h25.75C40.133 48 42 46.16 42 43.906V15.188a1.016 1.016 0 0 0 0-.407V14.5a.99.99 0 0 0-.281-.719l-11.5-11.5A.99.99 0 0 0 29.5 2h-.312a.972.972 0 0 0-.282-.031ZM11.5 4H28v8.344A3.666 3.666 0 0 0 31.656 16H40v27.906C40 45.074 39.055 46 37.875 46h-25.75C10.945 46 10 45.074 10 43.906V5.47C10 4.645 10.66 4 11.5 4Zm18.5.938L39.063 14h-7.407A1.633 1.633 0 0 1 30 12.344ZM17 25c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm4 0v2h12v-2Zm-4 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm4 0v2h12v-2Zm-4 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm4 0v2h12v-2Z"
        })
    });
var $6ee8c38486294b4f$export$2e2bcd8739ae039 = $6ee8c38486294b4f$var$SvgGoogleForms;



parcelRequire("7fPBF");
const $11b2a8be749657ee$var$SvgGoogleMeet = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M12.97 6a1 1 0 0 0-.07.006 1 1 0 0 0-.082.012 1 1 0 0 0-.025.003 1 1 0 0 0-.068.018 1 1 0 0 0-.036.012 1 1 0 0 0-.025.01 1 1 0 0 0-.08.03 1 1 0 0 0-.063.032 1 1 0 0 0-.06.035 1 1 0 0 0-.047.031 1 1 0 0 0-.006.004 1 1 0 0 0-.068.057 1 1 0 0 0-.047.043 1 1 0 0 0-.01.01l-9.99 9.99a1 1 0 0 0-.004.004 1 1 0 0 0-.045.05 1 1 0 0 0-.021.024 1 1 0 0 0-.034.045 1 1 0 0 0-.027.037 1 1 0 0 0-.017.031 1 1 0 0 0-.036.063 1 1 0 0 0-.035.08 1 1 0 0 0-.021.06 1 1 0 0 0-.014.04 1 1 0 0 0-.002.005 1 1 0 0 0-.02.084 1 1 0 0 0-.013.098A1 1 0 0 0 2 17a1 1 0 0 0 0 .016V40c0 2.197 1.803 4 4 4h29c2.197 0 4-1.803 4-4v-4.336l6.703 5.697c1.244 1.059 3.297.11 3.297-1.523V10.162c0-1.225-1.154-2.064-2.256-1.96a1.86 1.86 0 0 0-1.04.437L39 14.336V10c0-2.197-1.803-4-4-4H13a1 1 0 0 0-.008 0 1 1 0 0 0-.021 0zM14 8h21c1.117 0 2 .883 2 2v6.037l-8 6.8V17a1 1 0 0 0-1-1H14V8zm-2 1.414V16H5.414L12 9.414zm35 .748v29.676l-8-6.8V16.962l8-6.8zM4 18h8v14H4V18zm10 0h13v14H14V18zm23 .662v12.676L29.545 25 37 18.662zm-8 8.5 8 6.8V40c0 1.117-.883 2-2 2H14v-8h14a1 1 0 0 0 1-1v-5.838zM4 34h8v8H6c-1.117 0-2-.883-2-2v-6z"
        })
    });
var $11b2a8be749657ee$export$2e2bcd8739ae039 = $11b2a8be749657ee$var$SvgGoogleMeet;



parcelRequire("7fPBF");
const $611cb8c6b8793355$var$SvgGooglePixel6 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M15 1c-1.645 0-3 1.355-3 3v42c0 1.645 1.355 3 3 3h20c1.645 0 3-1.355 3-3V4c0-1.645-1.355-3-3-3H15zm0 2h20c.565 0 1 .435 1 1v42c0 .565-.435 1-1 1H15c-.565 0-1-.435-1-1V4c0-.565.435-1 1-1zm10 2a1 1 0 0 0 0 2 1 1 0 0 0 0-2z"
        })
    });
var $611cb8c6b8793355$export$2e2bcd8739ae039 = $611cb8c6b8793355$var$SvgGooglePixel6;



parcelRequire("7fPBF");
const $480150230dd592ca$var$SvgGooglePlay = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M6.781 2c-.011.004-.02.027-.031.031-.027.004-.066-.008-.094 0-.21.024-.406.11-.562.25C5.422 2.648 5 3.402 5 4.22V46c0 .621.273 1.273.781 1.656.235.262.59.38.938.313.457.023.937-.078 1.343-.313.848-.492 18.157-10.5 18.157-10.5l9.031-5.218a.466.466 0 0 0 .063-.032l.124-.062s.122-.063.126-.063l.03-.031 8.688-5c.703-.406 1.262-1.066 1.25-1.875-.011-.809-.582-1.437-1.218-1.781a372.197 372.197 0 0 1-4.75-2.719c-2.118-1.227-4.126-2.406-4.126-2.406l-9.218-5.313-17.75-10.25c-.348-.199-.742-.36-1.125-.406a1.939 1.939 0 0 0-.563 0ZM7 4.688l20.375 20.218L7 45.125Zm4.75 1.906c5.086 2.937 13.469 7.781 13.469 7.781l8.062 4.656-4.5 4.469Zm23.313 13.468c.48.282 1.703.993 3.5 2.032 2.117 1.226 4.289 2.468 4.812 2.75.05.027.035.043.063.062-.04.028-.051.035-.157.094-.96.555-7.191 4.172-8.187 4.75l-4.907-4.844Zm-6.282 6.22 4.532 4.5-8.094 4.656s-8.164 4.71-13.438 7.75Z"
        })
    });
var $480150230dd592ca$export$2e2bcd8739ae039 = $480150230dd592ca$var$SvgGooglePlay;



parcelRequire("7fPBF");
const $f49bc59318865ee6$var$SvgGooglePlayMusic = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M7.385 1c-.939 0-1.843.34-2.463 1.008C4.302 2.675 4 3.607 4 4.635v40.728c0 1.029.302 1.962.922 2.63C5.542 48.66 6.446 49 7.385 49c.991 0 1.827-.284 2.63-.748l18.131-10.377 4.354-2.49 12.27-7.024h.001C45.865 27.731 47 26.626 47 25c0-1.626-1.134-2.732-2.232-3.363l-2.565-1.475C39.901 12.565 32.842 7.02 24.5 7.02c-1.497 0-2.945.198-4.34.535L10.016 1.748C9.213 1.284 8.376 1 7.385 1zm0 2c.676 0 .99.11 1.629.48h.002l8.558 4.897C10.796 11.124 6 17.764 6 25.52c0 7.357 4.305 13.717 10.54 16.695L9.017 46.52h-.002c-.641.37-.955.48-1.631.48-.493 0-.782-.138-.996-.37C6.174 46.4 6 46.014 6 45.364V4.635c0-.65.174-1.035.389-1.266.214-.23.503-.369.996-.369zM24.5 9.02c9.125 0 16.5 7.375 16.5 16.5 0 .974-.104 1.92-.266 2.847l-5.191 2.97A12.415 12.415 0 0 0 37 25.5C37 18.608 31.392 13 24.5 13S12 18.608 12 25.5c0 6.706 5.315 12.182 11.951 12.473l-5.242 3C12.456 38.629 8 32.603 8 25.52c0-9.125 7.375-16.5 16.5-16.5zm0 5.98C30.31 15 35 19.69 35 25.5S30.31 36 24.5 36 14 31.31 14 25.5 18.69 15 24.5 15zm.5 4v7.045a2.704 2.704 0 0 0-1.344-.371A2.654 2.654 0 0 0 21 28.336C21 29.826 22.168 31 23.625 31c1.486 0 2.875-1.164 2.875-2.625v-6.5H29V19h-4zm17.777 3.799.994.572C44.595 23.844 45 24.23 45 25s-.405 1.153-1.227 1.627l-.845.484c.044-.525.072-1.055.072-1.591 0-.927-.09-1.83-.223-2.721z"
        })
    });
var $f49bc59318865ee6$export$2e2bcd8739ae039 = $f49bc59318865ee6$var$SvgGooglePlayMusic;



parcelRequire("7fPBF");
const $a80e63067819b2a7$var$SvgGooglePlus = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M17.188 10.938C9.422 10.938 3.124 17.234 3.124 25c0 7.766 6.297 14.063 14.063 14.063 7.765 0 14.062-6.297 14.062-14.063 0-.965-.105-1.906-.29-2.812l-.077-.313H17.188v4.688h9.375c-.747 4.433-4.731 7.812-9.375 7.812A9.372 9.372 0 0 1 7.813 25a9.372 9.372 0 0 1 9.375-9.375c2.343 0 4.48.867 6.125 2.29l3.359-3.29a13.997 13.997 0 0 0-9.484-3.687Zm21.875 6.25v4.687h-4.688V25h4.688v4.688h3.124V25h4.688v-3.125h-4.687v-4.687Z"
        })
    });
var $a80e63067819b2a7$export$2e2bcd8739ae039 = $a80e63067819b2a7$var$SvgGooglePlus;



parcelRequire("7fPBF");
const $2e1061f35716bd07$var$SvgGoogleSheets = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M28.906 1.969c-.043.008-.086.02-.125.031H11.5C9.586 2 8 3.559 8 5.469v38.437C8 46.16 9.867 48 12.125 48h25.75C40.133 48 42 46.16 42 43.906V15.188a1.016 1.016 0 0 0 0-.407V14.5a.99.99 0 0 0-.281-.719l-11.5-11.5A.99.99 0 0 0 29.5 2h-.312a.972.972 0 0 0-.282-.031ZM11.5 4H28v8.344A3.666 3.666 0 0 0 31.656 16H40v27.906C40 45.074 39.055 46 37.875 46h-25.75C10.945 46 10 45.074 10 43.906V5.47C10 4.645 10.66 4 11.5 4Zm18.5.938L39.063 14h-7.407A1.633 1.633 0 0 1 30 12.344ZM17 24v14h16V24Zm2 2h5v2h-5Zm7 0h5v2h-5Zm-7 4h5v2h-5Zm7 0h5v2h-5Zm-7 4h5v2h-5Zm7 0h5v2h-5Z"
        })
    });
var $2e1061f35716bd07$export$2e2bcd8739ae039 = $2e1061f35716bd07$var$SvgGoogleSheets;



parcelRequire("7fPBF");
const $e30adf1bb2f794b5$var$SvgGoogleSlides = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M28.906 1.969c-.043.008-.086.02-.125.031H11.5C9.586 2 8 3.559 8 5.469v38.437C8 46.16 9.867 48 12.125 48h25.75C40.133 48 42 46.16 42 43.906V15.188a1.016 1.016 0 0 0 0-.407V14.5a.99.99 0 0 0-.281-.719l-11.5-11.5A.99.99 0 0 0 29.5 2h-.312a.972.972 0 0 0-.282-.031ZM11.5 4H28v8.344A3.666 3.666 0 0 0 31.656 16H40v27.906C40 45.074 39.055 46 37.875 46h-25.75C10.945 46 10 45.074 10 43.906V5.47C10 4.645 10.66 4 11.5 4Zm18.5.938L39.063 14h-7.407A1.633 1.633 0 0 1 30 12.344ZM18.938 22A2.952 2.952 0 0 0 16 24.938v12.125A2.95 2.95 0 0 0 18.938 40h12.125A2.95 2.95 0 0 0 34 37.063V24.937A2.952 2.952 0 0 0 31.063 22Zm0 2h12.125a.92.92 0 0 1 .937.938V26H18v-1.062a.92.92 0 0 1 .938-.938ZM18 28h14v6H18Zm0 8h14v1.063a.92.92 0 0 1-.937.937H18.938a.92.92 0 0 1-.938-.937Z"
        })
    });
var $e30adf1bb2f794b5$export$2e2bcd8739ae039 = $e30adf1bb2f794b5$var$SvgGoogleSlides;



parcelRequire("7fPBF");
const $a3ace68bbd1278b8$var$SvgGrammarly = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2C12.31 2 2 12.31 2 25s10.31 23 23 23 23-10.31 23-23S37.69 2 25 2zm0 2c11.61 0 21 9.39 21 21s-9.39 21-21 21S4 36.61 4 25 13.39 4 25 4zm0 8c-7.162 0-13 5.838-13 13s5.838 13 13 13c4.017 0 7.615-1.834 10-4.709V36.5a1.5 1.5 0 0 0 3 0V29a1 1 0 0 0-1-1h-7.5a1.5 1.5 0 0 0 0 3h3.484c-1.821 2.426-4.707 4-7.984 4-5.54 0-10-4.46-10-10s4.46-10 10-10c3.433 0 6.438 1.724 8.242 4.35a1.5 1.5 0 1 0 2.473-1.7C33.373 14.242 29.44 12 25 12z"
        })
    });
var $a3ace68bbd1278b8$export$2e2bcd8739ae039 = $a3ace68bbd1278b8$var$SvgGrammarly;



parcelRequire("7fPBF");
const $13c1584923501bf3$var$SvgHboMax = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14 3.99c-5.511 0-10 4.49-10 10v22c0 5.511 4.489 10 10 10h22c5.511 0 10-4.489 10-10v-22c0-5.51-4.489-10-10-10H14zm0 2h22c4.431 0 8 3.57 8 8v22c0 4.431-3.569 8-8 8H14c-4.431 0-8-3.569-8-8v-22c0-4.43 3.569-8 8-8zm-1.613 7.823v10.923h2.73v-4.095h2.047v4.095h2.732V13.813h-2.732v4.095h-2.047v-4.096h-2.73zm8.191 0v10.921h2.64v.002h1.98c1.98 0 3.3-1.213 3.3-2.73 0-.35-.05-.681-.135-.988a5.434 5.434 0 0 0 5.176 3.718A5.44 5.44 0 0 0 39 19.273a5.438 5.438 0 0 0-5.46-5.46 5.432 5.432 0 0 0-5.157 3.666c.07-.292.115-.606.115-.936 0-1.517-1.32-2.73-3.3-2.73h-4.62zm2.73 2.732h1.495c.478 0 .894.396.894.851 0 .455-.416.856-.894.856h-1.494v-1.707zm10.23 0a2.706 2.706 0 0 1 2.732 2.73 2.706 2.706 0 0 1-2.733 2.73 2.704 2.704 0 0 1-2.73-2.73 2.704 2.704 0 0 1 2.73-2.73zm0 1.057c-.937 0-1.673.734-1.673 1.671s.736 1.672 1.672 1.672c.936 0 1.674-.735 1.674-1.672 0-.936-.738-1.671-1.674-1.671zm-5.263.222a5.53 5.53 0 0 0-.199 1.45c0 .538.08 1.057.223 1.548-.313-.917-.975-1.549-1.781-1.549.823.001 1.445-.587 1.757-1.449zM23.31 20.3h1.494c.478 0 .894.4.894.853 0 .454-.416.854-.894.854h-1.494v-1.707zm3.412 5.273c-2.574 0-4.666 2.38-4.666 5.307 0 2.927 2.093 5.307 4.666 5.307 1.21 0 2.31-.531 3.14-1.393v.248c0 .528.427.955.955.955h.957V25.758h-.957a.954.954 0 0 0-.955.955v.248c-.83-.86-1.931-1.389-3.14-1.389zm5.234.188 3.229 4.375c.355.482.355 1.139 0 1.62l-3.08 4.175h1.685a1.37 1.37 0 0 0 1.1-.555l1.752-2.373a.41.41 0 0 1 .66 0l1.752 2.373c.258.349.665.555 1.1.555h1.683l-3.078-4.174a1.368 1.368 0 0 1-.002-1.621l3.226-4.375H40.3a1.37 1.37 0 0 0-1.1.554l-1.898 2.573a.41.41 0 0 1-.66 0l-1.9-2.573a1.363 1.363 0 0 0-1.098-.554h-1.688zm-14.209.068a3.969 3.969 0 0 0-.9.072c-.852.165-1.57.637-2.102 1.27a3.822 3.822 0 0 0-3.658-1.27c-1.82.355-3.068 2.061-3.068 3.916v5.227c0 .528.429.955.957.955h.955v-6.336c0-1.06.862-1.924 1.922-1.924s1.923.863 1.923 1.924v5.381c0 .528.43.955.957.955h.954v-6.336c0-1.06.862-1.924 1.923-1.924 1.06 0 1.924.863 1.924 1.924v5.381c0 .528.428.955.957.955h.955v-6.336a3.838 3.838 0 0 0-3.699-3.834zm8.975 1.654c1.519 0 2.758 1.523 2.758 3.397 0 1.874-1.237 3.394-2.758 3.394s-2.754-1.52-2.754-3.394c0-1.873 1.235-3.397 2.754-3.397z"
        })
    });
var $13c1584923501bf3$export$2e2bcd8739ae039 = $13c1584923501bf3$var$SvgHboMax;



parcelRequire("7fPBF");
const $a40ac44443616e4e$var$SvgHeadMovement = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillOpacity: 0.3,
                fillRule: "evenodd",
                d: "m60.786 78.88-1.175.892a16.729 16.729 0 0 1-9.587 3.396c-.97-.03-1.932-.146-2.874-.341a22.922 22.922 0 0 1-16.298-4.14L19.89 70.789c-1.7-1.225-3.175-2.534-4.043-4.203-3.001-5.773-4.56-16.467 5.207-26.233 3.98-3.98 8.259-5.908 12.298-6.562a21.803 21.803 0 0 1 3.096-2.425c-5.385.051-11.43 1.968-16.921 7.46C8.96 49.392 10.588 61.154 13.93 67.582c1.107 2.13 2.923 3.682 4.697 4.96l10.961 7.897a25.082 25.082 0 0 0 18.066 4.5l2.425-.333a17.81 17.81 0 0 0 9.15-4.103c.1-.05.196-.118.28-.202.124-.124.247-.25.367-.378.128-.12.255-.243.38-.368.083-.084.15-.179.201-.28.111-.13.22-.262.328-.395Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M49.496 29.086c-12.673 0-18.978 8.52-20.917 14.678-.546 1.733-.44 3.65-.105 5.707l2.167 13.336a22.652 22.652 0 0 0 8.663 14.41l1.95 1.48a15.38 15.38 0 0 0 8.77 3.12 15.38 15.38 0 0 0 8.77-3.12l1.95-1.48a22.653 22.653 0 0 0 8.664-14.41l2.166-13.336c.335-2.058.443-3.974-.104-5.706-1.931-6.116-8.303-14.679-21.974-14.679Zm1.449 55.382a18.079 18.079 0 0 0 9.482-3.62l1.95-1.48a25.352 25.352 0 0 0 9.696-16.128l2.167-13.336c.352-2.168.548-4.6-.195-6.952-2.21-6.997-9.465-16.566-24.549-16.566-14.164 0-21.303 9.613-23.493 16.567-.74 2.35-.547 4.781-.194 6.951l2.167 13.336a25.352 25.352 0 0 0 9.696 16.128l1.95 1.48a18.079 18.079 0 0 0 9.481 3.62c.125.038.257.058.393.058.176 0 .352-.002.528-.008.176.006.352.008.528.008.137 0 .269-.02.393-.058Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "m9.918 27.667-.22-3.962a1.35 1.35 0 0 0-2.696.15l.409 7.356 7.686 1.618a1.35 1.35 0 1 0 .556-2.642l-3.658-.77C16.941 24.768 30.075 16.7 49.448 16.7c19.2 0 33.117 8.332 38.402 12.739l-3.553.748a1.35 1.35 0 0 0 .556 2.642l7.686-1.618.409-7.356a1.35 1.35 0 0 0-2.696-.15l-.224 4.042C84.638 23.068 69.89 14 49.448 14c-20.329 0-34.226 8.552-39.53 13.667Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillOpacity: 0.3,
                fillRule: "evenodd",
                d: "M53.182 82.765a16.73 16.73 0 0 1-3.158.403 16.73 16.73 0 0 1-8.236-2.471 17.81 17.81 0 0 0 8.92 3.91l2.425.332a25.082 25.082 0 0 0 18.065-4.5l10.962-7.897c1.773-1.278 3.59-2.83 4.697-4.96 3.342-6.428 4.97-18.19-5.596-28.756-5.831-5.832-12.286-7.632-17.913-7.448a22.078 22.078 0 0 1 3.05 2.271c4.338.48 9.013 2.381 13.335 6.704 9.767 9.766 8.209 20.46 5.207 26.233-.867 1.669-2.342 2.978-4.043 4.203l-10.962 7.897a22.922 22.922 0 0 1-16.51 4.112l-.243-.033Z",
                clipRule: "evenodd"
            })
        ]
    });
var $a40ac44443616e4e$export$2e2bcd8739ae039 = $a40ac44443616e4e$var$SvgHeadMovement;



parcelRequire("7fPBF");
const $f3215e388a4926a3$var$SvgHeadMovement1 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillOpacity: 0.3,
                fillRule: "evenodd",
                d: "m62.192 82.689-1.328 1.008a18.905 18.905 0 0 1-10.833 3.837 18.897 18.897 0 0 1-3.248-.386c-6.507.83-13.09-.84-18.417-4.678L15.98 73.545c-1.922-1.384-3.588-2.863-4.568-4.749-3.392-6.523-5.152-18.608 5.884-29.643 4.497-4.498 9.332-6.676 13.896-7.416a24.636 24.636 0 0 1 3.499-2.74c-6.086.058-12.916 2.224-19.121 8.43-11.94 11.94-10.1 25.231-6.324 32.495 1.252 2.407 3.303 4.16 5.307 5.604L26.94 84.45a28.343 28.343 0 0 0 20.414 5.084l2.74-.375a20.125 20.125 0 0 0 10.34-4.636 1.22 1.22 0 0 0 .315-.229c.141-.14.28-.283.416-.428.144-.136.287-.274.428-.415a1.22 1.22 0 0 0 .228-.316c.126-.147.25-.296.37-.447Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M49.434 26.421c-14.32 0-21.445 9.627-23.637 16.586-.617 1.96-.496 4.125-.118 6.45l2.448 15.069a25.597 25.597 0 0 0 9.79 16.283l2.203 1.672a17.38 17.38 0 0 0 9.91 3.526 17.38 17.38 0 0 0 9.911-3.526l2.203-1.672a25.597 25.597 0 0 0 9.79-16.283l2.448-15.07c.378-2.325.501-4.49-.117-6.447-2.183-6.912-9.384-16.588-24.83-16.588Zm1.637 62.582a20.43 20.43 0 0 0 10.715-4.091l2.203-1.672a28.648 28.648 0 0 0 10.956-18.225l2.449-15.07c.398-2.45.62-5.198-.22-7.855-2.497-7.907-10.695-18.72-27.74-18.72-16.005 0-24.072 10.863-26.547 18.72-.837 2.657-.618 5.404-.22 7.856l2.449 15.07A28.648 28.648 0 0 0 36.072 83.24l2.203 1.672a20.43 20.43 0 0 0 10.715 4.09c.14.044.29.067.444.067.2 0 .398-.003.597-.01.198.007.397.01.596.01.154 0 .304-.023.444-.066Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "m4.71 24.817-.248-4.476a1.526 1.526 0 1 0-3.046.17l.461 8.311 8.686 1.829a1.525 1.525 0 1 0 .629-2.986l-4.134-.87c5.588-5.253 20.43-14.37 42.322-14.37 21.696 0 37.422 9.415 43.394 14.395l-4.016.845a1.525 1.525 0 1 0 .629 2.986l8.686-1.829.462-8.312a1.526 1.526 0 1 0-3.047-.169l-.254 4.567C89.145 19.62 72.48 9.374 49.38 9.374c-22.972 0-38.676 9.664-44.67 15.443Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillOpacity: 0.3,
                fillRule: "evenodd",
                d: "M53.6 87.079a18.91 18.91 0 0 1-3.57.455 18.906 18.906 0 0 1-9.306-2.793 20.125 20.125 0 0 0 10.08 4.418l2.74.375a28.343 28.343 0 0 0 20.413-5.084l12.387-8.924c2.004-1.444 4.056-3.197 5.308-5.604 3.776-7.264 5.616-20.556-6.324-32.495-6.59-6.59-13.882-8.624-20.24-8.416a24.95 24.95 0 0 1 3.446 2.567c4.901.541 10.184 2.69 15.068 7.575 11.036 11.035 9.276 23.12 5.884 29.643-.98 1.886-2.646 3.365-4.568 4.75L72.53 82.47a25.902 25.902 0 0 1-18.657 4.646l-.275-.037Z",
                clipRule: "evenodd"
            })
        ]
    });
var $f3215e388a4926a3$export$2e2bcd8739ae039 = $f3215e388a4926a3$var$SvgHeadMovement1;



parcelRequire("7fPBF");
const $8cbedcd5de46db09$var$SvgHeadTurning = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                clipPath: "url(#Head-Turning_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeOpacity: 0.3,
                        strokeWidth: 2.16,
                        d: "M41.407 30.004c-12.382-4.311-21.141 1.038-25.315 6.123-1.655 2.017-2.154 4.667-2.206 7.275l-.077 3.888a6.918 6.918 0 0 1-1.36 3.983l-5.276 7.118c-1.358 1.831.019 4.419 2.297 4.315a2.706 2.706 0 0 1 2.789 2.24l.473 2.724.945 4.535c.162.78.4 1.543.708 2.278l.672 1.598a8.52 8.52 0 0 0 6.415 5.098l.701.12c1.065.183 2.145.264 3.225.244l.056-.001a17.716 17.716 0 0 0 5.158-.872l3.954-1.29a25.2 25.2 0 0 0 14.347-11.97l5.657-10.462c1.016-1.878 1.872-3.879 1.922-6.014.154-6.571-3.086-16.752-15.085-20.93Z"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeOpacity: 0.3,
                        strokeWidth: 2.16,
                        d: "M58.843 30.004c12.382-4.311 21.141 1.038 25.314 6.123 1.656 2.017 2.155 4.667 2.207 7.275l.077 3.888a6.918 6.918 0 0 0 1.36 3.983l5.276 7.118c1.358 1.831-.019 4.419-2.297 4.315a2.706 2.706 0 0 0-2.79 2.24l-.472 2.724-.945 4.535c-.162.78-.4 1.543-.708 2.278l-.672 1.598a8.52 8.52 0 0 1-6.415 5.098l-.702.12a17.133 17.133 0 0 1-3.224.244l-.056-.001a17.715 17.715 0 0 1-5.158-.872l-3.955-1.29a25.2 25.2 0 0 1-14.346-11.97L45.68 56.948c-1.016-1.878-1.872-3.879-1.922-6.014-.154-6.571 3.086-16.752 15.084-20.93Z"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        fill: "#FBFDFE",
                        d: "m61.186 76.942-1.95 1.48a16.73 16.73 0 0 1-9.586 3.396 16.73 16.73 0 0 1-9.587-3.396l-1.95-1.48a24.002 24.002 0 0 1-9.18-15.268l-2.166-13.336c-.343-2.114-.493-4.287.15-6.33 2.065-6.556 8.786-15.622 22.205-15.622 14.377 0 21.19 9.066 23.261 15.622.645 2.042.493 4.216.15 6.33l-2.167 13.335a24.002 24.002 0 0 1-9.18 15.27Z"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeWidth: 2.7,
                        d: "M49.122 81.826v0c3.653 0 7.205-1.195 10.115-3.404l1.95-1.48a24.002 24.002 0 0 0 9.179-15.268l2.167-13.336c.343-2.114.495-4.288-.15-6.33-2.07-6.556-8.884-15.622-23.26-15.622-13.42 0-20.141 9.066-22.206 15.622-.643 2.043-.493 4.216-.15 6.33l2.167 13.335a24.002 24.002 0 0 0 9.18 15.27l1.95 1.48a16.73 16.73 0 0 0 10.114 3.403v0"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        fill: "#E51546",
                        d: "M3.293 15.293a1 1 0 0 0 0 1.414l6.364 6.364a1 1 0 0 0 1.414-1.414L5.414 16l5.657-5.657A1 1 0 1 0 9.657 8.93l-6.364 6.364Zm93.414 1.414a1 1 0 0 0 0-1.414l-6.364-6.364a1 1 0 0 0-1.414 1.414L94.586 16l-5.657 5.657a1 1 0 0 0 1.414 1.414l6.364-6.364ZM4 17h92v-2H4v2Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                    id: "Head-Turning_svg__a",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h100v100H0z"
                    })
                })
            })
        ]
    });
var $8cbedcd5de46db09$export$2e2bcd8739ae039 = $8cbedcd5de46db09$var$SvgHeadTurning;



parcelRequire("7fPBF");
const $95fa162f48833150$var$SvgHeadUpAndDown = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                opacity: 0.9,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeOpacity: 0.3,
                        strokeWidth: 2.16,
                        d: "M49.872 72.44v0a16.73 16.73 0 0 0 10.115-3.404l1.95-1.48a24.002 24.002 0 0 0 9.179-15.269l2.167-13.335c.343-2.114.495-4.288-.15-6.33C71.064 26.066 64.25 17 49.873 17c-13.42 0-20.141 9.066-22.206 15.622-.643 2.042-.493 4.216-.15 6.33l2.167 13.335a24.002 24.002 0 0 0 9.18 15.27l1.95 1.479a16.729 16.729 0 0 0 10.114 3.404v0"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        fill: "#FBFDFE",
                        d: "m38.856 77.942 1.95 1.48a16.73 16.73 0 0 0 9.587 3.396 16.73 16.73 0 0 0 9.587-3.396l1.95-1.48a24.002 24.002 0 0 0 9.179-15.268l2.166-13.336c.344-2.114.494-4.287-.15-6.33-2.064-6.556-8.786-15.622-22.204-15.622-14.377 0-21.19 9.066-23.262 15.622-.645 2.042-.492 4.216-.15 6.33l2.168 13.335a24.002 24.002 0 0 0 9.18 15.27Z"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeWidth: 2.7,
                        d: "M50.92 82.826v0a16.729 16.729 0 0 1-10.114-3.404l-1.95-1.48a24.002 24.002 0 0 1-9.18-15.268L27.51 49.338c-.344-2.114-.496-4.288.15-6.33 2.07-6.556 8.884-15.622 23.26-15.622 13.42 0 20.14 9.066 22.206 15.622.643 2.043.493 4.216.15 6.33l-2.167 13.335a24.002 24.002 0 0 1-9.18 15.27l-1.95 1.48a16.73 16.73 0 0 1-10.114 3.403v0"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                stroke: "#E51546",
                strokeLinecap: "round",
                strokeWidth: 3,
                d: "M8 78.116v-47M3 32.884l4.864-4.367 5.136 4.6M92 28v47M87 73.232l4.864 4.367L97 73"
            })
        ]
    });
var $95fa162f48833150$export$2e2bcd8739ae039 = $95fa162f48833150$var$SvgHeadUpAndDown;



parcelRequire("7fPBF");
const $d6570d7c790cde0b$var$SvgHealth = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14 3.99c-5.511 0-10 4.489-10 10v22c0 5.512 4.489 10 10 10h22c5.511 0 10-4.488 10-10v-22c0-5.511-4.489-10-10-10H14zm0 2h22c4.43 0 8 3.57 8 8v22c0 4.43-3.57 8-8 8H14c-4.43 0-8-3.57-8-8v-22c0-4.43 3.57-8 8-8zm10.453 5.188C22.055 11.335 20 13.163 20 16.154c0 4.158 3.265 8.787 9.008 11.729.305.156.678.156.984 0C35.735 24.942 39 20.313 39 16.154c0-4.786-5.26-6.594-8.771-3.345a1.067 1.067 0 0 1-1.458 0c-1.317-1.219-2.879-1.726-4.318-1.631z"
        })
    });
var $d6570d7c790cde0b$export$2e2bcd8739ae039 = $d6570d7c790cde0b$var$SvgHealth;



parcelRequire("7fPBF");
const $32705bcb0cd360a7$var$SvgHulu = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M33.816 16.836V32h-3.64V16.836h3.64m-28.175 0v4.941s.105-.043.32-.105l.918-.11h2.523c.707 0 1.356.13 1.95.387.617.254 1.105.66 1.488 1.211.363.578.555 1.32.555 2.238V32H9.754v-6.133c-.024-.258-.11-.512-.3-.683a1.036 1.036 0 0 0-.68-.278h-2.13c-.3 0-.511.11-.703.278-.195.171-.277.425-.3.683V32H2V16.836h3.64M48 21.566v6.43c0 .766-.148 1.469-.445 2.067a3.284 3.284 0 0 1-1.239 1.406c-.55.316-1.21.488-1.976.488V32H40.78a5.108 5.108 0 0 1-2.191-.469c-.621-.297-1.086-.746-1.45-1.343-.363-.594-.511-1.34-.535-2.192v-6.43h3.665v6.11c0 .277.105.512.277.703.172.172.406.258.703.277h2.129c.277-.02.512-.105.684-.277.167-.192.277-.426.277-.703v-6.11H48m-20.594 0v6.43c-.02.766-.172 1.469-.445 2.067a3.516 3.516 0 0 1-1.258 1.406c-.535.316-1.191.488-1.96.488V32h-3.579a5.044 5.044 0 0 1-2.191-.469 3.259 3.259 0 0 1-1.45-1.343c-.34-.594-.511-1.34-.511-2.192v-6.43h3.644v6.11c.02.277.106.512.297.703.168.172.406.258.68.277h2.133a1.15 1.15 0 0 0 .703-.277 1.15 1.15 0 0 0 .273-.703v-6.11h3.664m6.41-6.73h-3.64c-1.106 0-2 .894-2 2v2.883a1.946 1.946 0 0 0-.77-.153h-3.664c-1.105 0-2 .895-2 2v5.09h-.09v-5.09c0-1.105-.894-2-2-2h-3.64c-1.063 0-1.93.825-1.996 1.868a5.295 5.295 0 0 0-1.903-1.332c-.812-.356-1.734-.54-2.71-.54H7.64v-2.726c0-1.106-.895-2-2-2H2c-1.105 0-2 .894-2 2V32c0 1.105.895 2 2 2h3.64c1.106 0 2-.895 2-2v-5.094h.114V32c0 1.105.894 2 2 2h3.64c1.09 0 1.981-.875 2-1.965a5.24 5.24 0 0 0 1.711 1.297c.97.453 1.961.668 3.06.668h3.577c.168 0 .328-.02.485-.059.93-.066 1.77-.32 2.503-.757a5.441 5.441 0 0 0 1.445-1.309V32c0 1.105.895 2 2 2h3.641c1.106 0 2-.895 2-2v-.21a5.276 5.276 0 0 0 1.903 1.542A7.18 7.18 0 0 0 40.78 34h3.559c.164 0 .328-.02.484-.059a5.695 5.695 0 0 0 2.492-.742l.082-.047a5.272 5.272 0 0 0 1.957-2.222c.426-.867.645-1.856.645-2.934v-6.433c0-1.102-.895-2-2-2h-3.664c-1.106 0-2 .898-2 2v5.093h-.066v-5.093c0-1.102-.895-2-2-2h-3.665c-.28 0-.546.058-.789.164v-2.891c0-1.106-.894-2-2-2Z"
        })
    });
var $32705bcb0cd360a7$export$2e2bcd8739ae039 = $32705bcb0cd360a7$var$SvgHulu;



parcelRequire("7fPBF");
const $45cda0bdf909d545$var$SvgIcloud = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M28.5 11c-4.291 0-8.021 2.22-10.27 5.521-.715-.25-1.428-.521-2.23-.521-3.336 0-6.056 2.386-6.748 5.523C5.645 22.698 3 26.012 3 30c0 4.959 4.041 9 9 9h27c4.406 0 8-3.594 8-8 0-3.705-2.581-6.723-6.012-7.625C40.92 16.542 35.348 11 28.5 11zm0 2C34.31 13 39 17.69 39 23.5c0 .125-.017.297-.027.527a1 1 0 0 0 .861 1.04A5.984 5.984 0 0 1 45 31c0 3.326-2.674 6-6 6H12c-3.877 0-7-3.123-7-7a6.988 6.988 0 0 1 5.295-6.781 1 1 0 0 0 .75-.846 4.986 4.986 0 0 1 7.148-3.86 1 1 0 0 0 1.3-.384C21.326 15.06 24.66 13 28.5 13z"
        })
    });
var $45cda0bdf909d545$export$2e2bcd8739ae039 = $45cda0bdf909d545$var$SvgIcloud;



parcelRequire("7fPBF");
const $0fa071542d1ff183$var$SvgImovie = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25.031 1a1 1 0 0 0-.974.668L18.293 18H1a1 1 0 0 0-.617 1.787l13.445 10.565-5.777 17.332a1 1 0 0 0 1.515 1.14L25 38.213l15.434 10.611a1 1 0 0 0 1.515-1.14l-5.777-17.332 13.445-10.565A1 1 0 0 0 49 18H31.707L25.943 1.668A1 1 0 0 0 25.031 1zM25 5.004l5.057 14.328A1 1 0 0 0 31 20h15.107l-11.724 9.213a1 1 0 0 0-.332 1.103l5.056 15.168-13.54-9.308a1 1 0 0 0-1.133 0l-13.541 9.308 5.056-15.168a1 1 0 0 0-.332-1.103L3.893 20H19a1 1 0 0 0 .943-.668L25 5.004zM20 22c-1.093 0-2 .907-2 2h-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h.5v4c0 1.093.907 2 2 2h8c1.093 0 2-.907 2-2v-2l3 2v-6l-3 2v-2c0-1.093-.907-2-2-2h-8zm0 2h8v6h-8v-6z"
        })
    });
var $0fa071542d1ff183$export$2e2bcd8739ae039 = $0fa071542d1ff183$var$SvgImovie;



parcelRequire("7fPBF");
const $655e3e5c364148e2$var$SvgInstagram = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M16 3C8.832 3 3 8.832 3 16v18c0 7.168 5.832 13 13 13h18c7.168 0 13-5.832 13-13V16c0-7.168-5.832-13-13-13H16zm0 2h18c6.086 0 11 4.914 11 11v18c0 6.086-4.914 11-11 11H16C9.914 45 5 40.086 5 34V16C5 9.914 9.914 5 16 5zm21 6a2 2 0 0 0-2 2 2 2 0 0 0 2 2 2 2 0 0 0 2-2 2 2 0 0 0-2-2zm-12 3c-6.063 0-11 4.937-11 11s4.937 11 11 11 11-4.937 11-11-4.937-11-11-11zm0 2c4.982 0 9 4.018 9 9s-4.018 9-9 9-9-4.018-9-9 4.018-9 9-9z"
        })
    });
var $655e3e5c364148e2$export$2e2bcd8739ae039 = $655e3e5c364148e2$var$SvgInstagram;



parcelRequire("7fPBF");
const $9bb0f831af78c332$var$SvgIosLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M15 3C8.385 3 3 8.385 3 15v20c0 6.615 5.385 12 12 12h20c6.615 0 12-5.385 12-12V15c0-6.615-5.385-12-12-12H15zm0 2h20c5.535 0 10 4.465 10 10v20c0 5.535-4.465 10-10 10H15C9.465 45 5 40.535 5 35V15C5 9.465 9.465 5 15 5zm-3.385 13.066c-.703 0-1.22.502-1.22 1.16 0 .65.517 1.151 1.22 1.151s1.223-.5 1.223-1.15c0-.66-.52-1.16-1.223-1.16zm10.422.57c-3.639 0-5.924 2.55-5.924 6.645 0 4.087 2.241 6.653 5.924 6.653 3.674 0 5.906-2.575 5.906-6.653 0-4.087-2.25-6.643-5.906-6.644zm12.93 0c-2.768 0-4.615 1.503-4.615 3.762 0 1.863 1.045 2.972 3.34 3.508l1.634.397c1.68.395 2.418.974 2.418 1.941 0 1.125-1.16 1.942-2.742 1.942-1.695 0-2.873-.764-3.041-1.967h-1.953c.14 2.268 2.03 3.717 4.842 3.717 3.006 0 4.886-1.52 4.886-3.946 0-1.907-1.072-2.962-3.673-3.568l-1.397-.344c-1.652-.387-2.32-.905-2.32-1.81 0-1.143 1.037-1.89 2.593-1.89 1.477 0 2.495.728 2.68 1.897h1.916c-.114-2.136-1.993-3.638-4.568-3.638zm-12.93 1.837c2.41 0 3.895 1.864 3.895 4.808 0 2.926-1.487 4.817-3.895 4.817-2.434 0-3.91-1.89-3.91-4.817 0-2.944 1.52-4.807 3.91-4.808zm-11.361 1.584v9.57h1.88v-9.57h-1.88z"
        })
    });
var $9bb0f831af78c332$export$2e2bcd8739ae039 = $9bb0f831af78c332$var$SvgIosLogo;



parcelRequire("7fPBF");
const $142e6c76da9ebc8b$var$SvgIosPhotos = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 1c-3.566 0-6.566 2.36-7.594 5.594a7.984 7.984 0 0 0-3.718-.907c-2.051 0-4.098.786-5.657 2.344a8.019 8.019 0 0 0-1.437 9.375C3.359 18.434 1 21.434 1 25c0 3.57 2.355 6.602 5.594 7.625-1.567 3.016-1.086 6.82 1.437 9.344 2.524 2.523 6.328 3.004 9.344 1.437C18.398 46.645 21.43 49 25 49c3.57 0 6.602-2.355 7.625-5.594 3.016 1.567 6.82 1.086 9.344-1.437a8.019 8.019 0 0 0 1.437-9.375C46.641 31.566 49 28.566 49 25c0-3.566-2.36-6.566-5.594-7.594.004-.008-.004-.023 0-.031 1.567-3.016 1.086-6.82-1.437-9.344a7.977 7.977 0 0 0-9.344-1.437c0-.004-.031.004-.031 0C31.566 3.359 28.566 1 25 1Zm0 2a5.97 5.97 0 0 1 5.875 4.813c-.074.07-.145.144-.219.218l-4.25 4.25A8.04 8.04 0 0 0 25 14.156a8.04 8.04 0 0 0-1.406-1.875l-4.25-4.25c-.074-.074-.145-.148-.219-.219A5.97 5.97 0 0 1 25 3ZM13.688 7.688C14.836 7.688 16 8 17 8.656c-.004.114 0 .227 0 .344v6c0 .828.14 1.625.375 2.375A7.952 7.952 0 0 0 15 17H9c-.117 0-.23-.004-.344 0a6.012 6.012 0 0 1 5.031-9.312Zm22.624 0A6.012 6.012 0 0 1 41.344 17c-.113-.005-.226-.001-.343-.001h-6c-.828 0-1.625.14-2.375.375.234-.75.375-1.547.375-2.375V9c0-.117.004-.23 0-.344 1-.656 2.164-.969 3.313-.969ZM19 10.5l3.188 3.188a5.982 5.982 0 0 1 1.062 7.03A5.966 5.966 0 0 1 19 15Zm12 0V15c0 2.71-1.79 4.973-4.25 5.719a5.98 5.98 0 0 1 1.063-7.032ZM10.5 19H15c2.71 0 4.973 1.79 5.719 4.25a5.98 5.98 0 0 1-7.032-1.062ZM35 19h4.5l-3.187 3.188a5.982 5.982 0 0 1-7.032 1.062A5.966 5.966 0 0 1 35 19Zm-27.219.125c.012-.004.02.004.032 0 .07.074.144.145.218.219l4.25 4.25A8.04 8.04 0 0 0 14.156 25a8.151 8.151 0 0 0-1.875 1.406l-4.25 4.25c-.074.074-.148.145-.219.219A5.97 5.97 0 0 1 3 25a5.977 5.977 0 0 1 4.781-5.875Zm34.407 0A5.97 5.97 0 0 1 47 25a5.97 5.97 0 0 1-4.812 5.875c-.07-.074-.145-.145-.22-.219l-4.25-4.25A8.151 8.151 0 0 0 35.845 25a8.04 8.04 0 0 0 1.875-1.406l4.25-4.25c.074-.074.148-.145.218-.219Zm-18 3.844c.269.027.535.031.812.031s.543-.004.813-.031c.18.222.386.418.593.625.207.207.403.414.625.593-.027.27-.031.536-.031.813 0 .277.004.543.031.813-.222.18-.418.386-.625.593-.207.207-.414.403-.593.625A7.983 7.983 0 0 0 25 27c-.277 0-.543.004-.812.031-.18-.222-.387-.418-.594-.625-.207-.207-.403-.414-.625-.593.027-.27.031-.536.031-.813 0-.277-.004-.543-.031-.812.222-.18.418-.387.625-.594.207-.207.414-.403.593-.625Zm-6.25 3.093c.957 0 1.917.231 2.78.688A5.966 5.966 0 0 1 15 31h-4.5l3.188-3.187a5.98 5.98 0 0 1 4.25-1.75Zm14.125 0a5.98 5.98 0 0 1 4.25 1.75L39.5 31H35a5.966 5.966 0 0 1-5.719-4.25 5.991 5.991 0 0 1 2.782-.687Zm-8.844 3.22c.008-.005.023.003.031 0a5.98 5.98 0 0 1-1.062 7.03L19 39.5V35a5.976 5.976 0 0 1 4.219-5.719Zm3.531 0A5.966 5.966 0 0 1 31 35v4.5l-3.187-3.187a5.982 5.982 0 0 1-1.063-7.032Zm-9.375 3.343A7.952 7.952 0 0 0 17 35v6c0 .117-.004.23 0 .344a6.012 6.012 0 0 1-7.562-.782A6.012 6.012 0 0 1 8.656 33c.114.004.227 0 .344 0h6c.828 0 1.625-.14 2.375-.375Zm15.25 0c.75.234 1.547.375 2.375.375h6c.117 0 .23.004.344 0a6.012 6.012 0 0 1-.782 7.563 6.012 6.012 0 0 1-7.562.78c.004-.113 0-.226 0-.343v-6c0-.828-.14-1.625-.375-2.375ZM25 35.844a8.04 8.04 0 0 0 1.406 1.875l4.25 4.25c.074.074.145.148.219.218A5.97 5.97 0 0 1 25 47a5.97 5.97 0 0 1-5.875-4.812c.074-.07.145-.145.219-.22l4.25-4.25A8.04 8.04 0 0 0 25 35.845Z"
        })
    });
var $142e6c76da9ebc8b$export$2e2bcd8739ae039 = $142e6c76da9ebc8b$var$SvgIosPhotos;



parcelRequire("7fPBF");
const $37d29f22d8db03a3$var$SvgItunes = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2C12.31 2 2 12.31 2 25s10.31 23 23 23 23-10.31 23-23S37.69 2 25 2zm0 2c11.61 0 21 9.39 21 21s-9.39 21-21 21S4 36.61 4 25 13.39 4 25 4zm9.053 8a1.012 1.012 0 0 0-.227.016l-13.695 2.593A1.366 1.366 0 0 0 19 15.955v13.268a1 1 0 0 1-.754.968l-3.445.88-.291.07a3.513 3.513 0 0 0-2.47 3.882C12.311 36.786 13.98 38 15.765 38h.1C18.7 38 21 35.7 21 32.865V22.328c0-.676.485-1.254 1.15-1.371l9.676-1.883A1 1 0 0 1 33 20.06v6.164a1 1 0 0 1-.754.968l-3.445.88-.291.07a3.513 3.513 0 0 0-2.47 3.882C26.311 33.786 27.98 35 29.765 35h.1C32.7 35 35 32.7 35 29.865V13a1 1 0 0 0-.947-1z"
        })
    });
var $37d29f22d8db03a3$export$2e2bcd8739ae039 = $37d29f22d8db03a3$var$SvgItunes;



const $c25bb468cbb9a994$var$SvgJavaScript = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M13.336 8C10.414 8 8 10.414 8 13.336v73.328C8 89.586 10.414 92 13.336 92h73.328C89.586 92 92 89.594 92 86.664V13.336C92 10.414 89.594 8 86.664 8zm0 4h73.328A1.33 1.33 0 0 1 88 13.336v73.328A1.33 1.33 0 0 1 86.664 88H13.336A1.33 1.33 0 0 1 12 86.664V13.336A1.33 1.33 0 0 1 13.336 12M46 46v25.148C46 75.008 44.54 76 42 76c-2.656 0-4.5-1.656-5.719-3.805L30 76c1.82 3.852 6.281 8 12.469 8C49.312 84 54 80.36 54 72.367V46zm24.906 0c-6.812 0-11.18 4.36-11.18 10.086 0 6.21 3.665 9.148 9.172 11.492l1.907.82C74.28 69.922 76 70.852 76 73.468c0 2.18-1.656 3.759-4.82 3.759-3.766 0-5.547-2.555-7.18-5.227l-6 4c2.242 4.43 6.266 8 13.352 8C78.602 84 84 80.234 84 73.367c0-6.375-3.656-9.21-10.148-11.992l-1.907-.812c-3.273-1.422-4.695-2.344-4.695-4.633 0-1.852 1.422-3.274 3.656-3.274 2.196 0 3.602.93 4.906 3.274l5.946-3.813c-2.508-4.43-6-6.117-10.852-6.117"
        })
    });
var $c25bb468cbb9a994$export$2e2bcd8739ae039 = $c25bb468cbb9a994$var$SvgJavaScript;



parcelRequire("7fPBF");
const $c44bfc9fc6a27ffb$var$SvgJira = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 44.343 46",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M22.156 0a1 1 0 0 0-.691.293l-.02.02L.88 20.879a3.015 3.015 0 0 0 0 4.242l20.586 20.586a1 1 0 0 0 1.414 0l.02-.02 20.566-20.566a3.015 3.015 0 0 0 0-4.242L22.879.293A1 1 0 0 0 22.156 0zm.078 2.477 19.817 19.816a.985.985 0 0 1 0 1.414L25.934 39.824c.118-.582.204-1.172.236-1.771a1 1 0 0 0 0-.106 12.046 12.046 0 0 0-2.633-6.896l7.342-7.344a1 1 0 0 0 0-1.414l-7.98-7.98A10.036 10.036 0 0 1 20.181 8a10.048 10.048 0 0 1 2.052-5.523zM18.41 6.176a12.023 12.023 0 0 0-.236 1.771 1 1 0 0 0 0 .106 12.044 12.044 0 0 0 2.635 6.896l-7.344 7.344a1 1 0 0 0 0 1.414l8 8.002A10.036 10.036 0 0 1 24.162 38a10.048 10.048 0 0 1-2.053 5.523L2.293 23.707a.985.985 0 0 1 0-1.414L18.41 6.176zm3.762 10.238L28.758 23l-6.586 6.586L15.586 23l6.586-6.586z"
        })
    });
var $c44bfc9fc6a27ffb$export$2e2bcd8739ae039 = $c44bfc9fc6a27ffb$var$SvgJira;



parcelRequire("7fPBF");
const $a632d8591d1e8129$var$SvgKey0 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.598 4C8.863 4 5 7.863 5 12.598v25.804C5 43.137 8.863 47 13.598 47h22.804C41.137 47 45 43.137 45 38.402V12.598C45 7.863 41.137 4 36.402 4Zm0 2h22.804A6.582 6.582 0 0 1 43 12.598v18.804A6.582 6.582 0 0 1 36.402 38H13.598A6.582 6.582 0 0 1 7 31.402V12.598A6.582 6.582 0 0 1 13.598 6Zm11.394 7.945c-1.531 0-2.746.543-3.644 1.63C20.449 16.66 20 18.206 20 20.214v3.523c0 2.016.453 3.567 1.355 4.645.899 1.078 2.122 1.617 3.66 1.617 1.536 0 2.75-.54 3.641-1.613.895-1.075 1.344-2.625 1.344-4.649v-3.523c0-2.008-.45-3.555-1.355-4.64-.903-1.087-2.122-1.63-3.653-1.63Zm.004 1.672c.805 0 1.426.36 1.86 1.082.43.723.648 1.79.648 3.207v4.133c0 1.422-.215 2.496-.645 3.223-.43.726-1.043 1.086-1.843 1.086-.805 0-1.426-.364-1.86-1.094-.43-.727-.644-1.797-.644-3.211v-4.137c0-1.41.21-2.476.633-3.203.425-.723 1.043-1.086 1.851-1.086ZM7 36.902A8.585 8.585 0 0 0 13.598 40h22.804A8.585 8.585 0 0 0 43 36.902v1.5A6.582 6.582 0 0 1 36.402 45H13.598A6.582 6.582 0 0 1 7 38.402Z"
        })
    });
var $a632d8591d1e8129$export$2e2bcd8739ae039 = $a632d8591d1e8129$var$SvgKey0;



parcelRequire("7fPBF");
const $8df11c1882a1a51b$var$SvgKey1 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.598 4C8.863 4 5 7.863 5 12.598v25.804C5 43.137 8.863 47 13.598 47h22.804C41.137 47 45 43.137 45 38.402V12.598C45 7.863 41.137 4 36.402 4Zm0 2h22.804A6.582 6.582 0 0 1 43 12.598v18.804A6.582 6.582 0 0 1 36.402 38H13.598A6.582 6.582 0 0 1 7 31.402V12.598A6.582 6.582 0 0 1 13.598 6Zm11.941 9.152c-.43 2.399-2.14 2.91-4.539 3v1.54h4.11v11.222h1.886V15.152ZM7 36.902A8.585 8.585 0 0 0 13.598 40h22.804A8.585 8.585 0 0 0 43 36.902v1.5A6.582 6.582 0 0 1 36.402 45H13.598A6.582 6.582 0 0 1 7 38.402Z"
        })
    });
var $8df11c1882a1a51b$export$2e2bcd8739ae039 = $8df11c1882a1a51b$var$SvgKey1;



parcelRequire("7fPBF");
const $1e1ea149a9060c6a$var$SvgKey2 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.598 4C8.863 4 5 7.863 5 12.598v25.804C5 43.137 8.863 47 13.598 47h22.804C41.137 47 45 43.137 45 38.402V12.598C45 7.863 41.137 4 36.402 4Zm0 2h22.804A6.582 6.582 0 0 1 43 12.598v18.804A6.582 6.582 0 0 1 36.402 38H13.598A6.582 6.582 0 0 1 7 31.402V12.598A6.582 6.582 0 0 1 13.598 6Zm11.793 9c-4.621 0-5.047 3.89-4.965 5.707h1.887c0-.52.167-3.977 3.078-3.977 2.738 0 3.082 2.422 3.082 2.852C28.473 24.426 20 24.254 20 31h10.266v-1.73H22.14c.425-3.547 8.214-4.239 8.214-9.688 0-.777-.343-4.582-4.964-4.582ZM7 36.902A8.585 8.585 0 0 0 13.598 40h22.804A8.585 8.585 0 0 0 43 36.902v1.5A6.582 6.582 0 0 1 36.402 45H13.598A6.582 6.582 0 0 1 7 38.402Z"
        })
    });
var $1e1ea149a9060c6a$export$2e2bcd8739ae039 = $1e1ea149a9060c6a$var$SvgKey2;



parcelRequire("7fPBF");
const $f0c42c8087af715b$var$SvgKey3 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.598 4C8.863 4 5 7.863 5 12.598v25.804C5 43.137 8.863 47 13.598 47h22.804C41.137 47 45 43.137 45 38.402V12.598C45 7.863 41.137 4 36.402 4Zm0 2h22.804A6.582 6.582 0 0 1 43 12.598v18.804A6.582 6.582 0 0 1 36.402 38H13.598A6.582 6.582 0 0 1 7 31.402V12.598A6.582 6.582 0 0 1 13.598 6Zm11.453 8c-4.426 0-4.824 4.023-4.848 5h1.875c.027-.676.34-3.297 2.973-3.297 2.469 0 2.808 1.703 2.808 2.55 0 .43-.254 2.556-2.976 2.556h-.766v1.617c.34-.086.68-.086 1.106-.086.425 0 3.32.086 3.32 2.976 0 2.809-2.98 3.067-3.402 3.067-1.512 0-3.258-.914-3.313-3.383H19.95c.016 1.227.39 5 5.192 5 .933 0 5.359-.254 5.359-4.766 0-2.808-1.871-3.66-2.809-3.828v-.09c.598-.34 2.125-1.359 2.125-3.144 0-.684-.168-4.172-4.765-4.172ZM7 36.902A8.585 8.585 0 0 0 13.598 40h22.804A8.585 8.585 0 0 0 43 36.902v1.5A6.582 6.582 0 0 1 36.402 45H13.598A6.582 6.582 0 0 1 7 38.402Z"
        })
    });
var $f0c42c8087af715b$export$2e2bcd8739ae039 = $f0c42c8087af715b$var$SvgKey3;



parcelRequire("7fPBF");
const $d4f76112c461b32f$var$SvgKey4 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.598 4C8.863 4 5 7.863 5 12.598v25.804C5 43.137 8.863 47 13.598 47h22.804C41.137 47 45 43.137 45 38.402V12.598C45 7.863 41.137 4 36.402 4Zm0 2h22.804A6.582 6.582 0 0 1 43 12.598v18.804A6.582 6.582 0 0 1 36.402 38H13.598A6.582 6.582 0 0 1 7 31.402V12.598A6.582 6.582 0 0 1 13.598 6Zm12.707 8L19 24.172V26h7.047v4h1.824v-4H30v-1.652h-2.129V14Zm-.176 3v7.262H21ZM7 36.902A8.585 8.585 0 0 0 13.598 40h22.804A8.585 8.585 0 0 0 43 36.902v1.5A6.582 6.582 0 0 1 36.402 45H13.598A6.582 6.582 0 0 1 7 38.402Z"
        })
    });
var $d4f76112c461b32f$export$2e2bcd8739ae039 = $d4f76112c461b32f$var$SvgKey4;



parcelRequire("7fPBF");
const $02bb6564be985baa$var$SvgKey5 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.598 4C8.863 4 5 7.863 5 12.598v25.804C5 43.137 8.863 47 13.598 47h22.804C41.137 47 45 43.137 45 38.402V12.598C45 7.863 41.137 4 36.402 4Zm0 2h22.804A6.582 6.582 0 0 1 43 12.598v18.804A6.582 6.582 0 0 1 36.402 38H13.598A6.582 6.582 0 0 1 7 31.402V12.598A6.582 6.582 0 0 1 13.598 6ZM22 14.855l-1.5 8.301 1.598.098c.3-.5 1.3-1.5 2.902-1.5.8 0 3.598.402 3.598 3.605 0 .696-.2 3.797-3.399 3.797-1.5 0-3.398-.898-3.398-2.797H20c0 1.297.898 4.594 5.098 4.594 1.804 0 5.5-.898 5.5-5.2 0-.796-.399-5.398-5.196-5.398-1.804 0-2.601.7-2.902 1.098l-.098-.098.899-4.601 6.5-.195v-1.704ZM7 36.902A8.585 8.585 0 0 0 13.598 40h22.804A8.585 8.585 0 0 0 43 36.902v1.5A6.582 6.582 0 0 1 36.402 45H13.598A6.582 6.582 0 0 1 7 38.402Z"
        })
    });
var $02bb6564be985baa$export$2e2bcd8739ae039 = $02bb6564be985baa$var$SvgKey5;



parcelRequire("7fPBF");
const $11ba4ce477af0c9a$var$SvgKey6 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.598 4C8.863 4 5 7.863 5 12.598v25.804C5 43.137 8.863 47 13.598 47h22.804C41.137 47 45 43.137 45 38.402V12.598C45 7.863 41.137 4 36.402 4Zm0 2h22.804A6.582 6.582 0 0 1 43 12.598v18.804A6.582 6.582 0 0 1 36.402 38H13.598A6.582 6.582 0 0 1 7 31.402V12.598A6.582 6.582 0 0 1 13.598 6Zm12.218 8.953c-5.902 0-5.816 7.363-5.816 8.473 0 6.59 3.168 7.527 5.39 7.527 4.192 0 5.305-3.25 5.305-5.3.004-.77-.258-5.137-4.789-5.137-2.484 0-3.508 1.37-3.937 2.054l-.086-.086c0-.597 0-5.988 3.851-5.988 2.121 0 2.559 1.598 2.649 2.457h1.883c-.09-1.289-.79-4-4.45-4Zm-.253 7.106c2.996 0 3.167 3.078 3.167 3.593 0 1.114-.515 3.508-3.168 3.508-1.027 0-3.25-.598-3.25-3.508 0-.43.172-3.507 3.25-3.593ZM7 36.902A8.585 8.585 0 0 0 13.598 40h22.804A8.585 8.585 0 0 0 43 36.902v1.5A6.582 6.582 0 0 1 36.402 45H13.598A6.582 6.582 0 0 1 7 38.402Z"
        })
    });
var $11ba4ce477af0c9a$export$2e2bcd8739ae039 = $11ba4ce477af0c9a$var$SvgKey6;



parcelRequire("7fPBF");
const $2d8a61a07fbe0860$var$SvgKey7 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.598 4C8.863 4 5 7.863 5 12.598v25.804C5 43.137 8.863 47 13.598 47h22.804C41.137 47 45 43.137 45 38.402V12.598C45 7.863 41.137 4 36.402 4Zm0 2h22.804A6.582 6.582 0 0 1 43 12.598v18.804A6.582 6.582 0 0 1 36.402 38H13.598A6.582 6.582 0 0 1 7 31.402V12.598A6.582 6.582 0 0 1 13.598 6ZM20 14v2h8c-5.922 6.277-5.91 12.586-6 14h2c.09-1.324.344-7.902 6-14v-2ZM7 36.902A8.585 8.585 0 0 0 13.598 40h22.804A8.585 8.585 0 0 0 43 36.902v1.5A6.582 6.582 0 0 1 36.402 45H13.598A6.582 6.582 0 0 1 7 38.402Z"
        })
    });
var $2d8a61a07fbe0860$export$2e2bcd8739ae039 = $2d8a61a07fbe0860$var$SvgKey7;



parcelRequire("7fPBF");
const $cb6bb042edf63b5c$var$SvgKey8 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.598 4C8.863 4 5 7.863 5 12.598v25.804C5 43.137 8.863 47 13.598 47h22.804C41.137 47 45 43.137 45 38.402V12.598C45 7.863 41.137 4 36.402 4Zm0 2h22.804A6.582 6.582 0 0 1 43 12.598v18.804A6.582 6.582 0 0 1 36.402 38H13.598A6.582 6.582 0 0 1 7 31.402V12.598A6.582 6.582 0 0 1 13.598 6Zm11.535 8c-3.594 0-4.617 2.566-4.617 4.02 0 1.968 1.539 2.996 2.222 3.253-.855.344-2.738 1.286-2.738 3.934C20 27.434 21.371 30 25.39 30c1.54 0 5.22-.77 5.22-4.793 0-2.734-1.883-3.676-2.825-3.934.598-.257 2.137-1.285 2.137-3.253 0-.77-.254-4.02-4.79-4.02Zm.086 1.715c2.308 0 2.652 1.62 2.652 2.394 0 .856-.426 2.567-2.566 2.567-2.653 0-2.825-2.14-2.825-2.567 0-.343.172-2.394 2.739-2.394Zm.086 6.586c2.566 0 3.25 2.308 3.25 2.996 0 1.453-1.11 3.078-3.25 3.078-1.625 0-3.336-.855-3.336-3.078 0-1.285.855-2.996 3.336-2.996ZM7 36.902A8.585 8.585 0 0 0 13.598 40h22.804A8.585 8.585 0 0 0 43 36.902v1.5A6.582 6.582 0 0 1 36.402 45H13.598A6.582 6.582 0 0 1 7 38.402Z"
        })
    });
var $cb6bb042edf63b5c$export$2e2bcd8739ae039 = $cb6bb042edf63b5c$var$SvgKey8;



parcelRequire("7fPBF");
const $0440a6aa4628c945$var$SvgKey9 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.598 4C8.863 4 5 7.863 5 12.598v25.804C5 43.137 8.863 47 13.598 47h22.804C41.137 47 45 43.137 45 38.402V12.598C45 7.863 41.137 4 36.402 4Zm0 2h22.804A6.582 6.582 0 0 1 43 12.598v18.804A6.582 6.582 0 0 1 36.402 38H13.598A6.582 6.582 0 0 1 7 31.402V12.598A6.582 6.582 0 0 1 13.598 6Zm11.62 8C20.942 14 20 17.422 20 19.137c0 4.277 3.078 5.3 4.965 5.3 2.137 0 3.336-1.453 3.676-2.136l.09.086c-.09 2.054-.43 6.074-3.594 6.074-1.79 0-2.813-1.102-2.907-2.461h-1.886c.097 1.965 1.383 4 4.793 4 2.82 0 5.472-1.71 5.472-8.469 0-1.457.086-7.531-5.39-7.531Zm-.081 1.797c2.992 0 3.25 3.078 3.25 3.594 0 .855-.516 3.507-3.25 3.507a3.218 3.218 0 0 1-3.082-3.335c0-.516.086-3.766 3.082-3.766ZM7 36.902A8.585 8.585 0 0 0 13.598 40h22.804A8.585 8.585 0 0 0 43 36.902v1.5A6.582 6.582 0 0 1 36.402 45H13.598A6.582 6.582 0 0 1 7 38.402Z"
        })
    });
var $0440a6aa4628c945$export$2e2bcd8739ae039 = $0440a6aa4628c945$var$SvgKey9;



parcelRequire("7fPBF");
const $d905b0a6418e110d$var$SvgKeyA = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm10.423 8.08-5.845 15.854h2.076l1.594-4.538h6.306l1.592 4.538h2.078L25.98 14.08h-1.956zm.891 2.56h.176l2.482 7.075h-5.14l2.482-7.074zM7 36.903A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $d905b0a6418e110d$export$2e2bcd8739ae039 = $d905b0a6418e110d$var$SvgKeyA;



parcelRequire("7fPBF");
const $30670d6961572f0f$var$SvgKeyAlt = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4c-4.957 0-9 4.043-9 9v24c0 4.957 4.043 9 9 9h32c4.957 0 9-4.043 9-9V13c0-4.957-4.043-9-9-9Zm0 2h32c3.879 0 7 3.121 7 7v24c0 3.879-3.121 7-7 7H9c-3.879 0-7-3.121-7-7V13c0-3.879 3.121-7 7-7Zm17.375 13.344v10.343h1.688V19.345Zm-7.094.5-3.5 9.843h1.813l.843-2.5h3.625l.844 2.5h1.875l-3.5-9.843Zm11.469.593v1.844h-1.219v1.344h1.219v4.094c0 1.449.691 2.031 2.406 2.031.328 0 .637-.047.875-.094v-1.343c-.199.019-.324.062-.562.062-.711 0-1.032-.355-1.032-1.094v-3.656h1.626v-1.344h-1.626v-1.843ZM20.188 21.72h.125l1.343 4.062h-2.812Z"
        })
    });
var $30670d6961572f0f$export$2e2bcd8739ae039 = $30670d6961572f0f$var$SvgKeyAlt;



parcelRequire("7fPBF");
const $93014453a15abd8b$var$SvgKeyAltgr = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4c-4.957 0-9 4.043-9 9v24c0 4.957 4.043 9 9 9h32c4.957 0 9-4.043 9-9V13c0-4.957-4.043-9-9-9Zm0 2h32c3.879 0 7 3.121 7 7v24c0 3.879-3.121 7-7 7H9c-3.879 0-7-3.121-7-7V13c0-3.879 3.121-7 7-7Zm9.219 13.344v10.343h1.687V19.345Zm13.718.25c-2.808 0-4.593 2.031-4.593 5.187 0 3.2 1.77 5.157 4.625 5.157 2.633 0 4.312-1.625 4.312-4.188V24.5h-4.093v1.406h2.374v.188c-.027 1.36-1.058 2.281-2.562 2.281-1.758 0-2.875-1.383-2.875-3.625 0-2.215 1.09-3.594 2.813-3.594 1.265 0 2.144.63 2.5 1.75h1.75c-.317-2.015-1.973-3.312-4.25-3.312Zm-20.812.25-3.5 9.843h1.781l.875-2.5h3.625l.813 2.5h1.906l-3.5-9.843Zm11.469.593v1.844h-1.219v1.344h1.219v4.094c0 1.449.691 2.031 2.406 2.031.328 0 .637-.047.875-.094v-1.343c-.2.019-.324.062-.562.062-.711 0-1.032-.355-1.032-1.094v-3.656h1.625v-1.344h-1.625v-1.843ZM12.03 21.72h.125L13.5 25.78h-2.812Zm29.813.375c-.957 0-1.735.543-1.938 1.281h-.125v-1.156h-1.625v7.468h1.688v-4.312c0-1.047.758-1.719 1.843-1.719.266 0 .747.047.876.094v-1.562a3.118 3.118 0 0 0-.72-.094Z"
        })
    });
var $93014453a15abd8b$export$2e2bcd8739ae039 = $93014453a15abd8b$var$SvgKeyAltgr;



parcelRequire("7fPBF");
const $9c3c343fdfab7ac2$var$SvgKeyAsterisk = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zM24 13v7.227l-6.186-3.739-1.035 1.713L23.064 22l-6.285 3.799 1.035 1.713L24 23.773V31h2v-7.227l6.186 3.739 1.035-1.713L26.936 22l6.285-3.799-1.035-1.713L26 20.227V13h-2zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $9c3c343fdfab7ac2$export$2e2bcd8739ae039 = $9c3c343fdfab7ac2$var$SvgKeyAsterisk;



parcelRequire("7fPBF");
const $8df7a3bd0475c986$var$SvgKeyB = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm6.029 8.08v15.856h6.185c3.372 0 5.372-1.66 5.372-4.452 0-2.098-1.374-3.58-3.538-3.855v-.176c1.526-.275 2.737-1.77 2.737-3.418 0-2.428-1.78-3.955-4.692-3.955H19.63zm1.976 1.746h3.67c1.965 0 3.11.936 3.11 2.551 0 1.682-1.22 2.537-3.615 2.537h-3.165v-5.088zm.002 6.79h3.725c2.526 0 3.822.934 3.822 2.769s-1.252 2.802-3.636 2.802v-.001h-3.91v-5.57zM7 36.901A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $8df7a3bd0475c986$export$2e2bcd8739ae039 = $8df7a3bd0475c986$var$SvgKeyB;



parcelRequire("7fPBF");
const $027d46a574c94474$var$SvgKeyBackspace = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 7c-4.957 0-9 4.043-9 9v18c0 4.957 4.043 9 9 9h32c4.957 0 9-4.043 9-9V16c0-4.957-4.043-9-9-9Zm0 2h32c3.879 0 7 3.121 7 7v18c0 3.879-3.121 7-7 7H9c-3.879 0-7-3.121-7-7V16c0-3.879 3.121-7 7-7Zm11.375 6.5a1.008 1.008 0 0 0-.594.281l-8.5 8.5a.999.999 0 0 0 0 1.438l8.5 8.5c.399.398 1.04.398 1.438 0a1.014 1.014 0 0 0 0-1.438L14.437 26H40c.36.004.695-.184.879-.496a1.01 1.01 0 0 0 0-1.008c-.184-.312-.52-.5-.879-.496H14.438l6.78-6.781c.325-.301.41-.778.216-1.172a.996.996 0 0 0-1.059-.547Z"
        })
    });
var $027d46a574c94474$export$2e2bcd8739ae039 = $027d46a574c94474$var$SvgKeyBackspace;



parcelRequire("7fPBF");
const $4348b719525840f3$var$SvgKeyC = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm11.742 7.705c-4.306 0-6.988 3.188-6.988 8.307 0 5.109 2.693 8.296 7 8.295 3.373 0 5.877-1.88 6.404-4.791h-2.012c-.505 1.835-2.185 2.966-4.394 2.966-3.054 0-4.965-2.492-4.965-6.47 0-3.976 1.912-6.483 4.955-6.483 2.186 0 3.877 1.287 4.404 3.33h2.012c-.473-3.054-3.076-5.154-6.416-5.154zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $4348b719525840f3$export$2e2bcd8739ae039 = $4348b719525840f3$var$SvgKeyC;



parcelRequire("7fPBF");
const $6921955218308c40$var$SvgKeyCapsLock = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11 7c-2.75 0-5 2.25-5 5v26c0 2.75 2.25 5 5 5h28c2.75 0 5-2.25 5-5V12c0-2.75-2.25-5-5-5H11zm0 2h28c1.668 0 3 1.332 3 3v26c0 1.668-1.332 3-3 3H11c-1.668 0-3-1.332-3-3V12c0-1.668 1.332-3 3-3zm7.504 8.293a1 1 0 0 0-.725.305l-5.5 5.709A1 1 0 0 0 13 25h2v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3h2a1 1 0 0 0 .72-1.693l-5.5-5.71a1 1 0 0 0-.716-.304zm-.004 2.441L21.646 23H21a1 1 0 0 0-1 1v3h-3v-3a1 1 0 0 0-1-1h-.646l3.146-3.266zM16 31a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-5zm1 2h3v2h-3v-2z"
        })
    });
var $6921955218308c40$export$2e2bcd8739ae039 = $6921955218308c40$var$SvgKeyCapsLock;



parcelRequire("7fPBF");
const $31e3b501c850f2fe$var$SvgKeyCapslockText = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.6 8C5.862 8 2 11.862 2 16.6v17.8c0 4.738 3.862 8.6 8.6 8.6h28.8c4.738 0 8.6-3.862 8.6-8.6V16.6c0-4.738-3.862-8.6-8.6-8.6H10.6zm0 2h28.8c3.656 0 6.6 2.943 6.6 6.6v10.8c0 3.656-2.943 6.6-6.6 6.6H10.6A6.584 6.584 0 0 1 4 27.4V16.6c0-3.657 2.943-6.6 6.6-6.6zm6.416 3.78c-1.842 0-2.975 1.268-2.975 3.33 0 2.065 1.138 3.335 2.975 3.335 1.529 0 2.645-.943 2.755-2.314H18.48c-.127.699-.698 1.146-1.46 1.146-1.001 0-1.62-.832-1.62-2.168 0-1.336.619-2.162 1.617-2.162.756 0 1.332.48 1.459 1.21h1.293c-.097-1.38-1.25-2.378-2.752-2.378zm5.892 1.55c-1.217 0-2.04.563-2.123 1.46h1.18c.105-.29.412-.448.873-.448.527 0 .818.229.818.633v.394l-1.174.07c-1.204.07-1.877.58-1.877 1.46 0 .887.656 1.458 1.588 1.458.628 0 1.156-.263 1.407-.707h.078v.633h1.24v-3.308c0-1.038-.727-1.645-2.01-1.645zm10.99 0c-1.208 0-2.015.611-2.017 1.53 0 .746.457 1.195 1.396 1.402l.88.197c.425.093.61.238.61.475 0 .312-.342.52-.84.52-.51 0-.82-.19-.917-.52h-1.248c.088.932.861 1.455 2.14 1.455 1.27 0 2.135-.633 2.135-1.6 0-.725-.422-1.12-1.361-1.326l-.91-.2c-.448-.1-.655-.245-.655-.482 0-.307.338-.513.795-.513.475 0 .771.191.836.503h1.184c-.07-.927-.798-1.44-2.028-1.44zm-4.925.025c-.668 0-1.217.33-1.48.875h-.08v-.794h-1.24v6.363h1.28v-2.26h.078c.238.514.77.818 1.463.818 1.213 0 1.957-.936 1.957-2.5 0-1.568-.751-2.5-1.978-2.502zm-.43 1.075c.681 0 1.094.54 1.094 1.427 0 .897-.409 1.432-1.1 1.432-.677 0-1.098-.54-1.098-1.428 0-.888.422-1.431 1.104-1.431zm-4.887 1.74v.355c0 .493-.449.87-1.04.87-.445 0-.757-.22-.757-.58 0-.348.268-.545.817-.585l.98-.06zm7.32 4.416v6.697h1.28v-1.607l.351-.362 1.414 1.97h1.516l-1.973-2.768 1.846-2.08h-1.455l-1.623 1.894h-.076v-3.744h-1.28zm-15.912.355v6.342h4.149V28.13H16.39V22.94h-1.327zm7.155 1.39c-1.477 0-2.387.957-2.387 2.526 0 1.587.897 2.533 2.387 2.532 1.49 0 2.386-.946 2.386-2.532 0-1.573-.91-2.527-2.386-2.527zm5.558 0c-1.516 0-2.369.91-2.369 2.519 0 1.626.857 2.539 2.37 2.539 1.26 0 2.05-.699 2.156-1.784h-1.196c-.097.48-.439.735-.96.735-.686 0-1.079-.523-1.079-1.49 0-.954.388-1.47 1.078-1.47.545 0 .873.305.961.766h1.196c-.105-1.103-.874-1.816-2.157-1.816zm-5.558 1.046c.676 0 1.072.548 1.072 1.48 0 .941-.392 1.486-1.072 1.485-.685 0-1.073-.54-1.073-1.485 0-.932.39-1.48 1.073-1.48zM4 32.902A8.585 8.585 0 0 0 10.6 36h28.8a8.587 8.587 0 0 0 6.6-3.098V34.4c0 3.656-2.943 6.6-6.6 6.6H10.6A6.584 6.584 0 0 1 4 34.4v-1.498z"
        })
    });
var $31e3b501c850f2fe$export$2e2bcd8739ae039 = $31e3b501c850f2fe$var$SvgKeyCapslockText;



parcelRequire("7fPBF");
const $e784f7a02803758d$var$SvgKeyCmd = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.598 4C5.863 4 2 7.863 2 12.598v25.804C2 43.137 5.863 47 10.598 47h28.804C44.137 47 48 43.137 48 38.402V12.598C48 7.863 44.137 4 39.402 4Zm0 2h28.804A6.582 6.582 0 0 1 46 12.598v18.804A6.582 6.582 0 0 1 39.402 38H10.598A6.582 6.582 0 0 1 4 31.402V12.598A6.582 6.582 0 0 1 10.598 6Zm3.812 11.285c-2.543 0-4.605 2.39-4.605 5.34 0 2.945 2.062 5.336 4.605 5.336 2.219 0 4.508-1.438 4.512-4.242h-1.64c-.352 1.62-1.169 2.808-2.766 2.804-1.59-.003-2.88-1.75-2.88-3.902s1.29-3.91 2.88-3.902c1.375.008 2.023.808 2.515 2h1.684c-.184-2.18-2.34-3.434-4.305-3.434Zm22.942.227v3.758c-.606-.77-1.461-1.254-2.414-1.254-1.829 0-3.317 1.793-3.317 3.996 0 2.199 1.488 3.988 3.317 3.988.949 0 1.808-.48 2.414-1.25v.969H39V17.512Zm-13.723 2.61c-.926.03-1.535.53-1.992 1.19v-.992H20v7.399h1.637v-4.895l.004.535c.086-1.03.437-1.84 1.652-1.949.977-.101 1.246.695 1.316 1.395v4.914h1.547v-4.383l.02.023c.086-1.027.375-1.91 1.59-1.941 1.57-.043 1.328 1.879 1.343 2.309l.024-.02v4.012h1.574v-5.387l.027-.02s.133-2.316-2.629-2.183c-.898-.067-1.664.574-2.171 1.172-.192-.43-.754-1.235-2.305-1.18Zm11.723 1.194c.984 0 1.808.918 2 2.137v1.07c-.192 1.215-1.016 2.133-2 2.133-1.125 0-2.04-1.199-2.04-2.672 0-1.468.915-2.668 2.04-2.668ZM4 36.902A8.585 8.585 0 0 0 10.598 40h28.804A8.585 8.585 0 0 0 46 36.902v1.5A6.582 6.582 0 0 1 39.402 45H10.598A6.582 6.582 0 0 1 4 38.402Z"
        })
    });
var $e784f7a02803758d$export$2e2bcd8739ae039 = $e784f7a02803758d$var$SvgKeyCmd;



parcelRequire("7fPBF");
const $d5b77224cfca79fc$var$SvgKeyCoinsButton = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm7.9 5c-5.235 0-9.5 4.265-9.5 9.5s4.265 9.5 9.5 9.5a9.42 9.42 0 0 0 4.037-.914 6.515 6.515 0 0 0 2.71 3.043 1 1 0 0 0 .001 0A6.49 6.49 0 0 0 31.5 33c3.578 0 6.5-2.922 6.5-6.5S35.078 20 31.5 20c-.179 0-.349.029-.523.043C30.735 15.021 26.58 11 21.5 11zm0 2c4.154 0 7.5 3.346 7.5 7.5S25.654 28 21.5 28a7.485 7.485 0 0 1-7.5-7.5c0-4.154 3.346-7.5 7.5-7.5zm-1.805 3.412-.808 4.543h1.502c.165-.228.512-.658 1.256-.658.266 0 1.42.104 1.42 1.539 0 .509-.303 1.582-1.42 1.582-1.04 0-1.311-.857-1.35-1.232h-1.668c-.016.987.696 2.593 3.053 2.593 2.239 0 3.05-1.861 3.05-2.943 0-.568-.299-2.795-2.535-2.795-.945 0-1.381.408-1.607.635l-.026-.026.329-1.863h3.394v-1.375h-4.59zM31.5 22c2.496 0 4.5 2.004 4.5 4.5S33.996 31 31.5 31c-.824 0-1.588-.22-2.252-.604a4.521 4.521 0 0 1-1.975-2.373 9.497 9.497 0 0 0 3.588-5.97c.21-.03.423-.053.639-.053zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $d5b77224cfca79fc$export$2e2bcd8739ae039 = $d5b77224cfca79fc$var$SvgKeyCoinsButton;



parcelRequire("7fPBF");
const $0606a21a12ea54c0$var$SvgKeyCommand = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11 7c-2.75 0-5 2.25-5 5v26c0 2.75 2.25 5 5 5h28c2.75 0 5-2.25 5-5V12c0-2.75-2.25-5-5-5H11zm0 2h28c1.668 0 3 1.332 3 3v26c0 1.668-1.332 3-3 3H11c-1.668 0-3-1.332-3-3V12c0-1.668 1.332-3 3-3zm16 4c-1.645 0-3 1.355-3 3s1.355 3 3 3h1v2h-1c-1.645 0-3 1.355-3 3s1.355 3 3 3 3-1.355 3-3v-1h2v1c0 1.645 1.355 3 3 3s3-1.355 3-3-1.355-3-3-3h-1v-2h1c1.645 0 3-1.355 3-3s-1.355-3-3-3-3 1.355-3 3v1h-2v-1c0-1.645-1.355-3-3-3zm0 2c.565 0 1 .435 1 1v1h-1c-.565 0-1-.435-1-1s.435-1 1-1zm8 0c.565 0 1 .435 1 1s-.435 1-1 1h-1v-1c0-.565.435-1 1-1zm-5 4h2v2h-2v-2zm-3 4h1v1c0 .565-.435 1-1 1s-1-.435-1-1 .435-1 1-1zm7 0h1c.565 0 1 .435 1 1s-.435 1-1 1-1-.435-1-1v-1z"
        })
    });
var $0606a21a12ea54c0$export$2e2bcd8739ae039 = $0606a21a12ea54c0$var$SvgKeyCommand;



parcelRequire("7fPBF");
const $49250ec78a20638c$var$SvgKeyControl = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11 7c-2.75 0-5 2.25-5 5v26c0 2.75 2.25 5 5 5h28c2.75 0 5-2.25 5-5V12c0-2.75-2.25-5-5-5H11zm0 2h28c1.668 0 3 1.332 3 3v26c0 1.668-1.332 3-3 3H11c-1.668 0-3-1.332-3-3V12c0-1.668 1.332-3 3-3zm19.984 4a1 1 0 0 0-.691.293l-6 6a1 1 0 1 0 1.414 1.414L31 15.414l5.293 5.293a1 1 0 1 0 1.414-1.414l-6-6a1 1 0 0 0-.723-.293z"
        })
    });
var $49250ec78a20638c$export$2e2bcd8739ae039 = $49250ec78a20638c$var$SvgKeyControl;



parcelRequire("7fPBF");
const $1940e6fd7db13266$var$SvgKeyCtrl = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4c-4.957 0-9 4.043-9 9v24c0 4.957 4.043 9 9 9h32c4.957 0 9-4.043 9-9V13c0-4.957-4.043-9-9-9Zm0 2h32c3.879 0 7 3.121 7 7v24c0 3.879-3.121 7-7 7H9c-3.879 0-7-3.121-7-7V13c0-3.879 3.121-7 7-7Zm25.906 13.344v10.343h1.688V19.345Zm-17.281.25c-2.797 0-4.531 1.98-4.531 5.187 0 3.192 1.734 5.157 4.531 5.157 2.277 0 3.957-1.36 4.188-3.375h-1.75c-.239 1.109-1.188 1.812-2.438 1.812-1.684 0-2.719-1.367-2.719-3.594 0-2.222 1.043-3.625 2.719-3.625 1.242 0 2.191.785 2.438 1.969h1.718c-.203-2.059-1.914-3.531-4.156-3.531Zm6.5.843v1.844h-1.219v1.344h1.219v4.094c0 1.449.691 2.031 2.406 2.031.328 0 .637-.047.875-.094v-1.343c-.199.019-.324.062-.562.062-.711 0-1.032-.355-1.032-1.094v-3.656h1.625v-1.344h-1.625v-1.843Zm8.688 1.657c-.958 0-1.766.543-1.97 1.281h-.093v-1.156h-1.656v7.468h1.718v-4.312c0-1.047.758-1.719 1.844-1.719.266 0 .715.047.844.094v-1.562a2.837 2.837 0 0 0-.687-.094Z"
        })
    });
var $1940e6fd7db13266$export$2e2bcd8739ae039 = $1940e6fd7db13266$var$SvgKeyCtrl;



parcelRequire("7fPBF");
const $4b9831ccf8f478fd$var$SvgKeyD = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm5.255 8.08v15.854h5.438c4.712 0 7.48-2.933 7.48-7.932 0-4.988-2.778-7.922-7.48-7.922h-5.438zm1.977 1.78h3.328c3.516 0 5.594 2.285 5.594 6.163 0 3.867-2.057 6.131-5.594 6.131h-3.328V15.86zM7 36.901A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $4b9831ccf8f478fd$export$2e2bcd8739ae039 = $4b9831ccf8f478fd$var$SvgKeyD;



parcelRequire("7fPBF");
const $a0e0005e3eb8a47f$var$SvgKeyDelete = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm19.859 10.365v10.37h1.695v-10.37H33.46zm-18.498.506v9.865h3.697c2.954 0 4.643-1.811 4.643-4.976 0-3.097-1.71-4.889-4.643-4.889h-3.697zm1.764 1.524h1.703c1.934 0 3.076 1.237 3.076 3.39 0 2.201-1.114 3.426-3.076 3.426h-1.703v-6.816zm11.552.71c-2.167 0-3.513 1.512-3.513 3.918s1.326 3.862 3.527 3.862c1.763 0 3.001-.847 3.322-2.207h-1.605c-.246.553-.827.86-1.668.86-1.114 0-1.832-.778-1.873-2.022v-.09h5.222v-.547c0-2.358-1.279-3.774-3.412-3.774zm-.006 1.348c1.02 0 1.69.711 1.723 1.818h-3.521c.075-1.094.786-1.818 1.798-1.818zM7 36.903A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $a0e0005e3eb8a47f$export$2e2bcd8739ae039 = $a0e0005e3eb8a47f$var$SvgKeyDelete;



parcelRequire("7fPBF");
const $b6575f368334c18a$var$SvgKeyDelete2 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11 7c-2.75 0-5 2.25-5 5v26c0 2.75 2.25 5 5 5h28c2.75 0 5-2.25 5-5V12c0-2.75-2.25-5-5-5H11zm0 2h28c1.668 0 3 1.332 3 3v26c0 1.668-1.332 3-3 3H11c-1.668 0-3-1.332-3-3V12c0-1.668 1.332-3 3-3zm14.57 15a1 1 0 0 0-.767.361l-4.573 5.5a1 1 0 0 0 0 1.278l4.573 5.5a1 1 0 0 0 .767.361H37a1 1 0 0 0 1-1V25a1 1 0 0 0-1-1H25.57zm.471 2H36v9h-9.959l-3.74-4.5 3.74-4.5zm1.95.99a1 1 0 0 0-.698 1.717l1.793 1.793-1.793 1.793a1 1 0 1 0 1.414 1.414l1.793-1.793 1.793 1.793a1 1 0 1 0 1.414-1.414L31.914 30.5l1.793-1.793a1 1 0 0 0-.727-1.717 1 1 0 0 0-.687.303L30.5 29.086l-1.793-1.793a1 1 0 0 0-.717-.303z"
        })
    });
var $b6575f368334c18a$export$2e2bcd8739ae039 = $b6575f368334c18a$var$SvgKeyDelete2;



parcelRequire("7fPBF");
const $335196af04c84a31$var$SvgKeyDot = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zM25 20.5a1.5 1.5 0 0 0 0 3 1.5 1.5 0 0 0 0-3zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $335196af04c84a31$export$2e2bcd8739ae039 = $335196af04c84a31$var$SvgKeyDot;



parcelRequire("7fPBF");
const $fbebede1d622f77a$var$SvgKeyE = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm6.72 8.08v15.854h9.823v-1.78h-7.846v-5.449h7.437v-1.758h-7.437V15.86h7.846V14.08H20.32zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $fbebede1d622f77a$export$2e2bcd8739ae039 = $fbebede1d622f77a$var$SvgKeyE;



parcelRequire("7fPBF");
const $22a251f88571b84a$var$SvgKeyEndButton = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4a9.017 9.017 0 0 0-9 9v24a9.017 9.017 0 0 0 9 9h32a9.017 9.017 0 0 0 9-9V13a9.017 9.017 0 0 0-9-9H9zm0 2h32a6.983 6.983 0 0 1 7 7v24a6.983 6.983 0 0 1-7 7H9a6.983 6.983 0 0 1-7-7V13a6.983 6.983 0 0 1 7-7zm30.03 11A1 1 0 0 0 38 18v14a1 1 0 0 0 1 1 1 1 0 0 0 1-1V18a1 1 0 0 0-.97-1zm-10.046 2.004A1 1 0 0 0 28 20v4H11a1 1 0 0 0 0 2h17v4a1 1 0 0 0 1.555.832l6-5a1.021 1.021 0 0 0 .117-.1l.047-.04a1 1 0 0 0 .181-.274c.011-.023.019-.046.028-.07a.9.9 0 0 0 0-.696c-.01-.024-.017-.047-.028-.07a1 1 0 0 0-.185-.273c-.015-.015-.03-.025-.045-.04a1.021 1.021 0 0 0-.117-.1l-6-5a1 1 0 0 0-.569-.165z"
        })
    });
var $22a251f88571b84a$export$2e2bcd8739ae039 = $22a251f88571b84a$var$SvgKeyEndButton;



parcelRequire("7fPBF");
const $ebbe86d494ff9bbc$var$SvgKeyEnter = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2c-2.75 0-5 2.25-5 5v13H7c-2.75 0-5 2.25-5 5v18c0 2.75 2.25 5 5 5h36c2.75 0 5-2.25 5-5V7c0-2.75-2.25-5-5-5Zm0 2h18c1.668 0 3 1.332 3 3v36c0 1.668-1.332 3-3 3H7c-1.668 0-3-1.332-3-3V25c0-1.668 1.332-3 3-3h13c1.094 0 2-.906 2-2V7c0-1.668 1.332-3 3-3Zm8.906 10.969c-.043.008-.086.02-.125.031A1.002 1.002 0 0 0 33 16v12c0 2.773-2.227 5-5 5H13.438l4.28-4.281c.325-.301.41-.778.216-1.172A.996.996 0 0 0 16.875 27a1.008 1.008 0 0 0-.594.281l-5.843 5.875a.954.954 0 0 0-.157.125.472.472 0 0 0-.062.063 1.204 1.204 0 0 0-.156.25v.031a.466.466 0 0 0-.032.063c-.011.039-.023.082-.031.124a1.048 1.048 0 0 0 0 .313v.093c.008.02.02.044.031.063v.032c.008.019.02.042.031.062.008.02.02.043.032.063v.03c.035.067.078.13.125.188a.472.472 0 0 0 .156.125l5.906 5.938c.399.398 1.04.398 1.438 0a1.014 1.014 0 0 0 0-1.438L13.437 35H28c3.855 0 7-3.145 7-7V16a1 1 0 0 0-1.094-1.031Z"
        })
    });
var $ebbe86d494ff9bbc$export$2e2bcd8739ae039 = $ebbe86d494ff9bbc$var$SvgKeyEnter;



parcelRequire("7fPBF");
const $37dbda8c254edf97$var$SvgKeyEnterMac = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11 7c-2.75 0-5 2.25-5 5v26c0 2.75 2.25 5 5 5h28c2.75 0 5-2.25 5-5V12c0-2.75-2.25-5-5-5H11zm0 2h28c1.668 0 3 1.332 3 3v26c0 1.668-1.332 3-3 3H11c-1.668 0-3-1.332-3-3V12c0-1.668 1.332-3 3-3zm23 16a1 1 0 1 0 0 2h2v4h-9.586l2.293-2.293a1 1 0 0 0-.727-1.717 1 1 0 0 0-.687.303l-3.912 3.912a1 1 0 0 0-.004 1.588 1 1 0 0 0 .006.004l3.91 3.91a1 1 0 1 0 1.414-1.414L26.414 33H37a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-3z"
        })
    });
var $37dbda8c254edf97$export$2e2bcd8739ae039 = $37dbda8c254edf97$var$SvgKeyEnterMac;



parcelRequire("7fPBF");
const $487d6e36dcafcb2d$var$SvgKeyEqual = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm3.433 12v2h15.942v-2H17.033zm.057 6v2h15.943v-2H17.09zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $487d6e36dcafcb2d$export$2e2bcd8739ae039 = $487d6e36dcafcb2d$var$SvgKeyEqual;



parcelRequire("7fPBF");
const $c6d465961f631267$var$SvgKeyEsc = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.6 4C5.862 4 2 7.862 2 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h28.8c4.738 0 8.6-3.862 8.6-8.6V12.6C48 7.862 44.138 4 39.4 4H10.6zm0 2h28.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H10.6A6.585 6.585 0 0 1 4 31.4V12.6C4 8.943 6.943 6 10.6 6zM14 17v9.863h6.385V25.34h-4.621v-2.762h4.369v-1.435h-4.37v-2.62h4.622V17H14zm11.219 2.236c-1.764 0-2.995.936-2.996 2.29 0 1.127.677 1.79 2.113 2.119l1.324.306c.711.158 1.033.426 1.033.85 0 .554-.595.93-1.449.93-.848 0-1.375-.33-1.539-.883h-1.674c.13 1.36 1.305 2.168 3.172 2.168 1.867 0 3.186-.959 3.186-2.395 0-1.1-.663-1.714-2.092-2.035l-1.318-.303c-.752-.17-1.108-.43-1.108-.853 0-.54.582-.909 1.354-.909.793 0 1.293.336 1.416.862h1.591c-.123-1.36-1.236-2.147-3.013-2.147zm8.086 0c-2.25 0-3.569 1.442-3.569 3.87 0 2.46 1.326 3.91 3.575 3.91 1.894 0 3.068-1.055 3.253-2.62h-1.613c-.177.78-.764 1.198-1.646 1.198-1.156 0-1.854-.917-1.854-2.489 0-1.55.692-2.447 1.854-2.447.929 0 1.49.52 1.646 1.244h1.613c-.178-1.572-1.338-2.666-3.26-2.666zM4 36.902A8.588 8.588 0 0 0 10.6 40h28.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H10.6A6.585 6.585 0 0 1 4 38.4v-1.498z"
        })
    });
var $c6d465961f631267$export$2e2bcd8739ae039 = $c6d465961f631267$var$SvgKeyEsc;



parcelRequire("7fPBF");
const $e0708247861041f7$var$SvgKeyEscMac = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11 7c-2.75 0-5 2.25-5 5v26c0 2.75 2.25 5 5 5h28c2.75 0 5-2.25 5-5V12c0-2.75-2.25-5-5-5H11zm0 2h28c1.668 0 3 1.332 3 3v26c0 1.668-1.332 3-3 3H11c-1.668 0-3-1.332-3-3V12c0-1.668 1.332-3 3-3zm14.096 11.967c-.982 0-1.744.246-2.285.74-.541.495-.813 1.085-.813 1.773 0 .583.175 1.03.522 1.34.346.314.942.577 1.789.787 1.177.278 1.855.474 2.037.588a.552.552 0 0 1 .273.498c0 .228-.113.4-.34.514-.227.114-.532.172-.916.172-.656 0-1.104-.13-1.347-.39-.138-.146-.227-.392-.268-.739h-1.977c0 .766.28 1.396.84 1.89.56.495 1.426.743 2.6.743 1.15 0 2.002-.234 2.553-.701.55-.468.824-1.071.824-1.809 0-.56-.191-1.026-.574-1.4-.388-.37-.97-.645-1.744-.828-1.165-.255-1.845-.436-2.036-.54a.508.508 0 0 1-.287-.486c0-.178.092-.333.272-.465.18-.132.483-.197.908-.197.517 0 .88.132 1.096.397.114.146.186.342.213.593h1.949c-.087-.91-.425-1.553-1.012-1.924-.587-.372-1.345-.556-2.277-.556zm-7.545.013c-1.092 0-1.98.345-2.664 1.034-.684.689-1.026 1.677-1.026 2.968 0 1.377.379 2.372 1.137 2.983a4.064 4.064 0 0 0 2.625.918c1.201 0 2.136-.363 2.803-1.088.43-.456.67-.906.722-1.348H19.16c-.116.22-.25.39-.4.514-.277.228-.64.342-1.082.342-.42 0-.777-.093-1.074-.28-.49-.3-.75-.825-.78-1.572h5.428c.01-.644-.011-1.136-.064-1.478a3.657 3.657 0 0 0-.594-1.541 3.022 3.022 0 0 0-1.287-1.104c-.52-.233-1.105-.349-1.756-.348zm15.572.02c-1.1 0-1.962.357-2.588 1.068-.626.711-.937 1.705-.937 2.983 0 1.133.283 2.054.85 2.765.564.711 1.447 1.067 2.646 1.067 1.2 0 2.106-.425 2.717-1.278.383-.529.598-1.088.644-1.681h-1.988c-.041.392-.16.71-.352.957-.193.246-.515.367-.972.367-.643 0-1.084-.31-1.317-.93-.128-.332-.19-.768-.19-1.314 0-.572.062-1.031.19-1.377.243-.652.694-.979 1.352-.979.46 0 .801.15 1.021.452.15.224.244.474.281.752h1.997c-.11-1.062-.461-1.804-1.057-2.223-.595-.42-1.361-.629-2.297-.629zm-15.568 1.586c.46 0 .843.132 1.154.4.311.27.484.66.52 1.178h-3.356c.071-.485.245-.868.52-1.152.275-.284.663-.426 1.162-.426z"
        })
    });
var $e0708247861041f7$export$2e2bcd8739ae039 = $e0708247861041f7$var$SvgKeyEscMac;



parcelRequire("7fPBF");
const $97c5c43afd0584a8$var$SvgKeyF = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm6.986 8.08v15.854h1.977v-6.868h7.021V21.31h-7.021v-5.45h7.646V14.08h-9.623zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $97c5c43afd0584a8$export$2e2bcd8739ae039 = $97c5c43afd0584a8$var$SvgKeyF;



parcelRequire("7fPBF");
const $d770639ab656fa18$var$SvgKeyF1 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.602 4C5.862 4 2 7.862 2 12.602v25.796C2 43.138 5.862 47 10.602 47h28.796C44.138 47 48 43.138 48 38.398V12.602C48 7.862 44.138 4 39.398 4H10.602zm0 2h28.796A6.584 6.584 0 0 1 46 12.602v18.796A6.584 6.584 0 0 1 39.398 38H10.602A6.584 6.584 0 0 1 4 31.398V12.602A6.584 6.584 0 0 1 10.602 6zm5.878 8.88v14.24h1.88v-6.58h6.6v-1.58h-6.6v-4.439h7.48v-1.64h-9.36zm15.7.079c-.227 1-.677 1.688-1.35 2.06-.674.374-1.584.561-2.73.561v1.28h3.56v10.26h1.86V14.958h-1.34zM4 36.902A8.589 8.589 0 0 0 10.602 40h28.796A8.588 8.588 0 0 0 46 36.902v1.496A6.584 6.584 0 0 1 39.398 45H10.602A6.584 6.584 0 0 1 4 38.398v-1.496z"
        })
    });
var $d770639ab656fa18$export$2e2bcd8739ae039 = $d770639ab656fa18$var$SvgKeyF1;



parcelRequire("7fPBF");
const $332524047e7a4ac5$var$SvgKeyF10 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.602 4C5.862 4 2 7.862 2 12.602v25.796C2 43.138 5.862 47 10.602 47h28.796C44.138 47 48 43.138 48 38.398V12.602C48 7.862 44.138 4 39.398 4H10.602zm0 2h28.796A6.584 6.584 0 0 1 46 12.602v18.796A6.584 6.584 0 0 1 39.398 38H10.602A6.584 6.584 0 0 1 4 31.398V12.602A6.584 6.584 0 0 1 10.602 6zm-1.243 8.74v14.24h1.881V22.4h6.6v-1.58h-6.6v-4.44h7.48v-1.64H9.36zm26.541.06c-.707 0-1.329.102-1.869.302s-.975.491-1.308.878a5.75 5.75 0 0 0-.82 1.23c-.215.434-.371.96-.471 1.58-.1.62-.167 1.178-.2 1.67-.033.494-.05 1.073-.05 1.74 0 .773.026 1.457.08 2.05.053.594.176 1.22.369 1.88.193.66.458 1.205.79 1.632.335.426.803.782 1.41 1.068.605.287 1.322.432 2.15.432.785 0 1.467-.141 2.04-.42.573-.28 1.027-.637 1.36-1.07.334-.435.596-.978.789-1.631.193-.653.32-1.28.38-1.88.06-.6.09-1.274.09-2.02 0-.814-.02-1.51-.06-2.09-.04-.58-.153-1.235-.34-1.962-.187-.727-.439-1.316-.76-1.77-.32-.452-.784-.836-1.39-1.15-.607-.313-1.336-.468-2.19-.468zm-10.84.018c-.226 1-.676 1.69-1.35 2.063-.673.373-1.584.558-2.73.558v1.282h3.56v10.26h1.86V14.817h-1.34zm10.838 1.502c.413 0 .781.078 1.1.23.321.155.58.33.78.524.2.2.374.494.52.881.148.386.252.714.311.98a8.9 8.9 0 0 1 .15 1.14c.04.493.06.841.06 1.04v1c0 .427-.003.75-.01.97-.007.22-.028.56-.061 1.02-.033.46-.082.829-.148 1.102a8.384 8.384 0 0 1-.313.961c-.14.367-.309.649-.51.85a2.668 2.668 0 0 1-.77.52c-.312.147-.67.22-1.07.22-.465 0-.877-.083-1.23-.25a1.9 1.9 0 0 1-.828-.74 6.927 6.927 0 0 1-.5-.98c-.133-.327-.226-.736-.28-1.23a19.711 19.711 0 0 1-.101-1.199c-.013-.306-.02-.693-.02-1.16v-1.03c0-.206.02-.56.06-1.06.04-.5.089-.881.15-1.148.06-.266.163-.596.31-.99s.322-.693.522-.893c.2-.199.459-.374.779-.527a2.52 2.52 0 0 1 1.1-.23zM4 36.902A8.589 8.589 0 0 0 10.602 40h28.796A8.588 8.588 0 0 0 46 36.902v1.496A6.584 6.584 0 0 1 39.398 45H10.602A6.584 6.584 0 0 1 4 38.398v-1.496z"
        })
    });
var $332524047e7a4ac5$export$2e2bcd8739ae039 = $332524047e7a4ac5$var$SvgKeyF10;



parcelRequire("7fPBF");
const $ca5f38dbd83f3721$var$SvgKeyF11 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.602 4C5.862 4 2 7.862 2 12.602v25.796C2 43.138 5.862 47 10.602 47h28.796C44.138 47 48 43.138 48 38.398V12.602C48 7.862 44.138 4 39.398 4H10.602zm0 2h28.796A6.584 6.584 0 0 1 46 12.602v18.796A6.584 6.584 0 0 1 39.398 38H10.602A6.584 6.584 0 0 1 4 31.398V12.602A6.584 6.584 0 0 1 10.602 6zm.318 8.88v14.24h1.88v-6.58h6.6v-1.58h-6.6v-4.439h7.48v-1.64h-9.36zm15.7.079c-.228 1-.677 1.688-1.35 2.06-.674.374-1.585.561-2.73.561v1.28h3.56v10.26h1.86V14.958h-1.34zm11.12 0c-.228 1-.677 1.688-1.351 2.06-.672.374-1.583.561-2.729.561v1.28h3.56v10.26h1.86V14.958h-1.34zM4 36.902A8.589 8.589 0 0 0 10.602 40h28.796A8.588 8.588 0 0 0 46 36.902v1.496A6.584 6.584 0 0 1 39.398 45H10.602A6.584 6.584 0 0 1 4 38.398v-1.496z"
        })
    });
var $ca5f38dbd83f3721$export$2e2bcd8739ae039 = $ca5f38dbd83f3721$var$SvgKeyF11;



parcelRequire("7fPBF");
const $e9a184e77d9537a4$var$SvgKeyF12 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.602 4C5.862 4 2 7.862 2 12.602v25.796C2 43.138 5.862 47 10.602 47h28.796C44.138 47 48 43.138 48 38.398V12.602C48 7.862 44.138 4 39.398 4H10.602zm0 2h28.796A6.584 6.584 0 0 1 46 12.602v18.796A6.584 6.584 0 0 1 39.398 38H10.602A6.584 6.584 0 0 1 4 31.398V12.602A6.584 6.584 0 0 1 10.602 6zM9.57 14.88v14.24h1.88v-6.58h6.6v-1.58h-6.6v-4.439h7.48v-1.64H9.57zm26.44.06c-1.374 0-2.478.426-3.31 1.279-.834.854-1.25 1.98-1.25 3.38v.381h1.72c.027-1.028.25-1.876.67-2.55.42-.673 1.116-1.01 2.09-1.01.812 0 1.471.25 1.978.75.507.5.762 1.143.762 1.93 0 .892-.373 1.706-1.12 2.44-.36.36-1.115.898-2.26 1.618-.734.453-1.3.834-1.7 1.14-.4.309-.81.698-1.23 1.17a4.617 4.617 0 0 0-.93 1.593c-.2.587-.32 1.272-.36 2.058h9.24V27.58h-7.28c.145-.613.473-1.167.98-1.66.36-.36 1.085-.867 2.18-1.52a43.74 43.74 0 0 0 1.26-.79 15.52 15.52 0 0 0 1.109-.83c.446-.362.779-.7 1-1.02a5.6 5.6 0 0 0 .6-1.19c.18-.474.27-.976.27-1.51 0-1.253-.399-2.253-1.199-3-.8-.746-1.874-1.12-3.22-1.12zm-10.74.019c-.227 1-.677 1.688-1.35 2.06-.673.374-1.585.561-2.73.561v1.28h3.56v10.26h1.86V14.958h-1.34zM4 36.902A8.589 8.589 0 0 0 10.602 40h28.796A8.588 8.588 0 0 0 46 36.902v1.496A6.584 6.584 0 0 1 39.398 45H10.602A6.584 6.584 0 0 1 4 38.398v-1.496z"
        })
    });
var $e9a184e77d9537a4$export$2e2bcd8739ae039 = $e9a184e77d9537a4$var$SvgKeyF12;



parcelRequire("7fPBF");
const $377584932bdac7fe$var$SvgKeyF1 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 400 400",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M77.974 32.072C50.09 34.552 26.957 53.788 18.171 81.8l-2.155 6.872v230.469l2.155 6.872c7.744 24.69 25.529 41.905 50.06 48.456l6.378 1.703h250.782l6.378-1.703c24.531-6.551 42.316-23.766 50.06-48.456l2.155-6.872V90.234l-1.767-6.64c-7.655-28.772-31.59-48.921-61.228-51.545-10.462-.926-232.582-.905-243.015.023m248.175 17.546c19.117 4.05 35.054 19.598 40.03 39.054 2.132 8.333 2.157 166.725.028 174.609-5.316 19.687-21.496 35.38-40.426 39.208-8.909 1.801-246.374 1.478-253.125-.345-19.241-5.195-33.667-19.621-38.863-38.863-2.129-7.884-2.104-166.276.028-174.609 4.95-19.352 20.782-34.925 39.673-39.021 7.735-1.678 244.745-1.708 252.655-.033M120.313 176.172v57.422h16.406v-53.125h52.344V167.188h-52.344v-34.375h59.375V118.75h-75.781v57.422m111.718-55.578c-15.064 4.101-25 17.715-25 34.258v5.304H220.904l.891-5.989c2.364-15.897 9.688-22.815 23.24-21.954 20.859 1.325 26.233 27.07 8.646 41.428-1.81 1.477-9.45 6.762-16.979 11.744-23.978 15.866-32.796 28.083-32.796 45.441v2.768h74.219V220.313h-28.906c-15.899 0-28.906-.215-28.906-.477 0-5.617 8.804-14.088 25.461-24.496 27.887-17.427 35.561-28.708 33.063-48.605-2.527-20.127-24.277-32.274-46.806-26.141M46.824 309.005c7.405 4.79 15.411 8.088 23.878 9.835 10.906 2.252 247.69 2.252 258.596 0 12.703-2.621 24.905-9.045 34.021-17.91l4.65-4.522-.006 4.726c-.035 27.405-12.435 46.778-35.513 55.483l-6.278 2.367-123.828.23c-137.644.255-128.85.568-140.235-4.983-18.689-9.111-28.553-25.164-29.8-48.495l-.511-9.555 4.767 4.635c2.621 2.55 7.238 6.235 10.259 8.189"
        })
    });
var $377584932bdac7fe$export$2e2bcd8739ae039 = $377584932bdac7fe$var$SvgKeyF1;



parcelRequire("7fPBF");
const $fd4b812de9ff4851$var$SvgKeyF3 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.602 4C5.862 4 2 7.862 2 12.602v25.796C2 43.138 5.862 47 10.602 47h28.796C44.138 47 48 43.138 48 38.398V12.602C48 7.862 44.138 4 39.398 4H10.602zm0 2h28.796A6.584 6.584 0 0 1 46 12.602v18.796A6.584 6.584 0 0 1 39.398 38H10.602A6.584 6.584 0 0 1 4 31.398V12.602A6.584 6.584 0 0 1 10.602 6zm4.337 8.74v14.24h1.881V22.4h6.602v-1.58H16.82v-4.44h7.48v-1.64h-9.36zm15.301.06c-1.4 0-2.49.4-3.27 1.2-.78.8-1.19 1.933-1.23 3.4h1.658c.027-1 .281-1.77.76-2.31.48-.54 1.146-.81 2-.81.747 0 1.345.213 1.791.64.447.427.67.987.67 1.68 0 .72-.256 1.29-.77 1.71-.513.42-1.21.63-2.09.63-.2 0-.392-.007-.58-.02v1.44c.374-.054.68-.08.92-.08.96 0 1.723.247 2.29.74s.85 1.152.85 1.978c0 .813-.284 1.477-.85 1.99-.567.514-1.303.772-2.21.772-.947 0-1.687-.274-2.22-.82-.534-.548-.82-1.326-.86-2.34h-1.68v.261c0 1.347.43 2.418 1.29 3.211.859.794 2.01 1.19 3.45 1.19 1.452 0 2.636-.402 3.55-1.21.912-.806 1.364-1.862 1.35-3.17 0-.866-.234-1.609-.7-2.222-.466-.613-1.097-1.01-1.898-1.197a3.031 3.031 0 0 0 1.43-1.172c.34-.526.51-1.122.51-1.789 0-1.107-.38-2.002-1.14-2.682-.76-.68-1.767-1.02-3.02-1.02zM4 36.903A8.589 8.589 0 0 0 10.602 40h28.796A8.588 8.588 0 0 0 46 36.902v1.496A6.584 6.584 0 0 1 39.398 45H10.602A6.584 6.584 0 0 1 4 38.398v-1.496z"
        })
    });
var $fd4b812de9ff4851$export$2e2bcd8739ae039 = $fd4b812de9ff4851$var$SvgKeyF3;



parcelRequire("7fPBF");
const $6b573a3566bd3206$var$SvgKeyF4 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.602 4C5.862 4 2 7.862 2 12.602v25.796C2 43.138 5.862 47 10.602 47h28.796C44.138 47 48 43.138 48 38.398V12.602C48 7.862 44.138 4 39.398 4H10.602zm0 2h28.796A6.584 6.584 0 0 1 46 12.602v18.796A6.584 6.584 0 0 1 39.398 38H10.602A6.584 6.584 0 0 1 4 31.398V12.602A6.584 6.584 0 0 1 10.602 6zm4.308 8.88v14.24h1.88v-6.58h6.6v-1.58h-6.6v-4.439h7.48v-1.64h-9.36zm16.88.06-6.44 9.16v1.6h6.22v3.42h1.6V25.7h1.92v-1.44h-1.92v-9.32h-1.38zm-.22 2.5v6.82h-4.72l4.72-6.82zM4 36.901A8.589 8.589 0 0 0 10.602 40h28.796A8.588 8.588 0 0 0 46 36.902v1.496A6.584 6.584 0 0 1 39.398 45H10.602A6.584 6.584 0 0 1 4 38.398v-1.496z"
        })
    });
var $6b573a3566bd3206$export$2e2bcd8739ae039 = $6b573a3566bd3206$var$SvgKeyF4;



parcelRequire("7fPBF");
const $41d8574f644e60ac$var$SvgKeyF5 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.602 4C5.862 4 2 7.862 2 12.602v25.796C2 43.138 5.862 47 10.602 47h28.796C44.138 47 48 43.138 48 38.398V12.602C48 7.862 44.138 4 39.398 4H10.602zm0 2h28.796A6.584 6.584 0 0 1 46 12.602v18.796A6.584 6.584 0 0 1 39.398 38H10.602A6.584 6.584 0 0 1 4 31.398V12.602A6.584 6.584 0 0 1 10.602 6zm4.369 8.74v14.24h1.879V22.4h6.6v-1.58h-6.6v-4.44h7.48v-1.64h-9.36zm12.3.32-1.32 7.362 1.46.1c.64-.92 1.547-1.381 2.72-1.381.92 0 1.667.31 2.24.93.573.62.86 1.423.86 2.41 0 .946-.292 1.74-.88 2.38-.586.64-1.32.96-2.2.96-.788 0-1.446-.247-1.98-.74-.532-.494-.834-1.134-.9-1.92h-1.72c.04 1.24.477 2.233 1.31 2.98.833.747 1.923 1.12 3.27 1.12 1.453 0 2.635-.466 3.54-1.4.907-.933 1.358-2.121 1.358-3.56 0-1.373-.41-2.492-1.236-3.352-.828-.859-1.91-1.289-3.242-1.289-1.214 0-2.167.373-2.86 1.12l.84-4.22h5.739v-1.5H27.27zM4 36.903A8.589 8.589 0 0 0 10.602 40h28.796A8.588 8.588 0 0 0 46 36.902v1.496A6.584 6.584 0 0 1 39.398 45H10.602A6.584 6.584 0 0 1 4 38.398v-1.496z"
        })
    });
var $41d8574f644e60ac$export$2e2bcd8739ae039 = $41d8574f644e60ac$var$SvgKeyF5;



parcelRequire("7fPBF");
const $62856496d756886b$var$SvgKeyF6 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.602 4C5.862 4 2 7.862 2 12.602v25.796C2 43.138 5.862 47 10.602 47h28.796C44.138 47 48 43.138 48 38.398V12.602C48 7.862 44.138 4 39.398 4H10.602zm0 2h28.796A6.584 6.584 0 0 1 46 12.602v18.796A6.584 6.584 0 0 1 39.398 38H10.602A6.584 6.584 0 0 1 4 31.398V12.602A6.584 6.584 0 0 1 10.602 6zm4.267 8.74v14.24h1.881V22.4h6.6v-1.58h-6.6v-4.44h7.48v-1.64h-9.36zm15.799.063c-.8 0-1.51.149-2.13.449-.62.301-1.115.69-1.49 1.17a5.967 5.967 0 0 0-.91 1.728 10.15 10.15 0 0 0-.48 1.99 15.77 15.77 0 0 0-.13 2.08c0 4.694 1.648 7.042 4.94 7.042 1.414 0 2.543-.455 3.391-1.362.846-.906 1.27-2.059 1.27-3.459 0-1.36-.404-2.457-1.211-3.29-.806-.834-1.87-1.25-3.19-1.25-1.572 0-2.746.62-3.519 1.86.026-.426.053-.79.08-1.09.026-.3.08-.691.16-1.171.08-.48.2-.887.36-1.22a6.74 6.74 0 0 1 .59-.99c.232-.327.54-.577.92-.75.38-.174.81-.26 1.29-.26.693 0 1.244.196 1.65.59.408.392.659.93.75 1.61h1.739c-.093-1.16-.499-2.064-1.219-2.709-.72-.647-1.674-.968-2.861-.968zm-.238 6.578c.893 0 1.6.288 2.12.867.52.58.78 1.366.78 2.352 0 .96-.265 1.725-.79 2.29-.528.568-1.216.85-2.07.85-.88 0-1.59-.294-2.13-.88-.54-.588-.81-1.366-.81-2.34 0-.934.266-1.692.8-2.272.533-.579 1.233-.867 2.1-.867zM4 36.902A8.589 8.589 0 0 0 10.602 40h28.796A8.588 8.588 0 0 0 46 36.902v1.496A6.584 6.584 0 0 1 39.398 45H10.602A6.584 6.584 0 0 1 4 38.398v-1.496z"
        })
    });
var $62856496d756886b$export$2e2bcd8739ae039 = $62856496d756886b$var$SvgKeyF6;



parcelRequire("7fPBF");
const $47c4a943b3e5ccd3$var$SvgKeyF7 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.602 4C5.862 4 2 7.862 2 12.602v25.796C2 43.138 5.862 47 10.602 47h28.796C44.138 47 48 43.138 48 38.398V12.602C48 7.862 44.138 4 39.398 4H10.602zm0 2h28.796A6.584 6.584 0 0 1 46 12.602v18.796A6.584 6.584 0 0 1 39.398 38H10.602A6.584 6.584 0 0 1 4 31.398V12.602A6.584 6.584 0 0 1 10.602 6zm4.418 8.88v14.24h1.88v-6.58h6.6v-1.58h-6.6v-4.439h7.48v-1.64h-9.36zm10.798.32v1.62h7.42a22.9 22.9 0 0 0-3.83 5.8c-.993 2.145-1.568 4.312-1.728 6.5h1.88c.522-4.774 2.326-8.927 5.42-12.46V15.2h-9.162zM4 36.901A8.589 8.589 0 0 0 10.602 40h28.796A8.588 8.588 0 0 0 46 36.902v1.496A6.584 6.584 0 0 1 39.398 45H10.602A6.584 6.584 0 0 1 4 38.398v-1.496z"
        })
    });
var $47c4a943b3e5ccd3$export$2e2bcd8739ae039 = $47c4a943b3e5ccd3$var$SvgKeyF7;



parcelRequire("7fPBF");
const $9e8ae470d5334fbf$var$SvgKeyF8 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.602 4C5.862 4 2 7.862 2 12.602v25.796C2 43.138 5.862 47 10.602 47h28.796C44.138 47 48 43.138 48 38.398V12.602C48 7.862 44.138 4 39.398 4H10.602zm0 2h28.796A6.584 6.584 0 0 1 46 12.602v18.796A6.584 6.584 0 0 1 39.398 38H10.602A6.584 6.584 0 0 1 4 31.398V12.602A6.584 6.584 0 0 1 10.602 6zm4.308 8.74v14.24h1.88V22.4h6.6v-1.58h-6.6v-4.44h7.48v-1.64h-9.36zm15.44.06c-1.24 0-2.253.338-3.04 1.01-.786.674-1.181 1.543-1.181 2.61 0 .694.17 1.297.512 1.81.34.514.823.903 1.449 1.17-.8.294-1.417.75-1.85 1.37-.433.62-.65 1.356-.65 2.21 0 1.293.432 2.33 1.29 3.11.86.779 1.996 1.17 3.41 1.17 1.466 0 2.632-.396 3.5-1.19.866-.793 1.302-1.864 1.302-3.21 0-1.72-.835-2.873-2.502-3.46 1.294-.6 1.94-1.621 1.94-3.06 0-1.04-.392-1.89-1.17-2.55-.782-.66-1.783-.99-3.01-.99zm0 1.518c.746 0 1.34.202 1.779.602.44.4.66.94.66 1.617 0 .667-.224 1.205-.67 1.611-.447.407-1.037.61-1.77.61-.746 0-1.347-.203-1.8-.61-.453-.406-.68-.944-.68-1.61 0-.667.227-1.202.68-1.608.453-.407 1.054-.612 1.8-.612zm-.06 5.823c.892 0 1.62.259 2.18.779.56.519.839 1.2.839 2.04 0 .84-.276 1.527-.829 2.06-.553.533-1.27.8-2.15.8-.866 0-1.578-.27-2.13-.81-.555-.54-.83-1.23-.83-2.07 0-.815.272-1.484.82-2.01.546-.526 1.245-.79 2.1-.79zM4 36.902A8.589 8.589 0 0 0 10.602 40h28.796A8.588 8.588 0 0 0 46 36.902v1.496A6.584 6.584 0 0 1 39.398 45H10.602A6.584 6.584 0 0 1 4 38.398v-1.496z"
        })
    });
var $9e8ae470d5334fbf$export$2e2bcd8739ae039 = $9e8ae470d5334fbf$var$SvgKeyF8;



parcelRequire("7fPBF");
const $f638f7603c3f0297$var$SvgKeyF9 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.602 4C5.862 4 2 7.862 2 12.602v25.796C2 43.138 5.862 47 10.602 47h28.796C44.138 47 48 43.138 48 38.398V12.602C48 7.862 44.138 4 39.398 4H10.602zm0 2h28.796A6.584 6.584 0 0 1 46 12.602v18.796A6.584 6.584 0 0 1 39.398 38H10.602A6.584 6.584 0 0 1 4 31.398V12.602A6.584 6.584 0 0 1 10.602 6zm4.337 8.74v14.24h1.881V22.4h6.6v-1.58h-6.6v-4.44h7.48v-1.64h-9.36zm15.24.06c-1.386 0-2.511.44-3.378 1.32-.867.878-1.301 2.028-1.301 3.44 0 1.374.4 2.484 1.2 3.33.8.848 1.847 1.27 3.14 1.27 1.506 0 2.66-.646 3.46-1.94 0 .347-.013.661-.038.94-.254 3.08-1.308 4.62-3.162 4.62-.72 0-1.31-.197-1.77-.59-.46-.395-.737-.936-.83-1.63h-1.68c.08 1.16.503 2.065 1.27 2.72.766.652 1.75.98 2.95.98.785 0 1.484-.16 2.09-.48a4.044 4.044 0 0 0 1.448-1.24 6.638 6.638 0 0 0 .883-1.79c.227-.687.383-1.353.47-2 .087-.646.13-1.322.13-2.03 0-4.612-1.628-6.92-4.881-6.92zm-.08 1.52c.868 0 1.567.293 2.1.88.533.586.799 1.366.799 2.34 0 .933-.265 1.683-.799 2.25-.533.567-1.232.85-2.1.85-.892 0-1.583-.296-2.07-.89-.487-.593-.728-1.343-.728-2.25 0-.96.255-1.73.77-2.31.512-.58 1.189-.87 2.029-.87zM4 36.902A8.589 8.589 0 0 0 10.602 40h28.796A8.588 8.588 0 0 0 46 36.902v1.496A6.584 6.584 0 0 1 39.398 45H10.602A6.584 6.584 0 0 1 4 38.398v-1.496z"
        })
    });
var $f638f7603c3f0297$export$2e2bcd8739ae039 = $f638f7603c3f0297$var$SvgKeyF9;



parcelRequire("7fPBF");
const $1253f9538fc416fa$var$SvgKeyFn = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.6 4C5.862 4 2 7.862 2 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h28.8c4.738 0 8.6-3.862 8.6-8.6V12.6C48 7.862 44.138 4 39.4 4H10.6zm0 2h28.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H10.6A6.585 6.585 0 0 1 4 31.4V12.6C4 8.943 6.943 6 10.6 6zm7.14 10.871v9.863h1.764v-3.998h4.137v-1.47h-4.137v-2.871h4.525V16.87H17.74zm12.162 2.234c-1.122 0-1.996.512-2.351 1.346h-.117v-1.195H25.8v7.476h1.695V22.38c0-1.101.683-1.799 1.777-1.799 1.025 0 1.545.575 1.545 1.717v4.437h1.688v-4.84c0-1.783-.936-2.789-2.604-2.789zM4 36.902A8.588 8.588 0 0 0 10.6 40h28.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H10.6A6.585 6.585 0 0 1 4 38.4v-1.498z"
        })
    });
var $1253f9538fc416fa$export$2e2bcd8739ae039 = $1253f9538fc416fa$var$SvgKeyFn;



parcelRequire("7fPBF");
const $e7c04b832cc34ee7$var$SvgKeyFunctionMac = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11 7c-2.75 0-5 2.25-5 5v26c0 2.75 2.25 5 5 5h28c2.75 0 5-2.25 5-5V12c0-2.75-2.25-5-5-5H11zm0 2h28c1.668 0 3 1.332 3 3v26c0 1.668-1.332 3-3 3H11c-1.668 0-3-1.332-3-3V12c0-1.668 1.332-3 3-3zm4.469 17.783c-1.08 0-1.76.224-2.043.67-.27.3-.405.849-.405 1.647v.478h-1.066v1.375h1.096v6.01h1.933v-6.01h1.28v-1.375h-1.28v-.629a.62.62 0 0 1 .149-.398c.098-.12.274-.178.531-.17.257.006.442.015.55.03v-1.587a31.08 31.08 0 0 0-.41-.03 4.254 4.254 0 0 0-.335-.01zm6.043 2.551c-.613 0-1.12.15-1.52.451-.223.17-.457.443-.707.826v-1.086h-1.887v7.438h1.948V32.93c0-.46.063-.84.19-1.135.244-.561.695-.842 1.35-.842.534 0 .897.191 1.087.574.104.21.156.51.156.903v4.533h1.994v-5.02c0-.935-.242-1.604-.73-2.006-.488-.404-1.115-.604-1.881-.603z"
        })
    });
var $e7c04b832cc34ee7$export$2e2bcd8739ae039 = $e7c04b832cc34ee7$var$SvgKeyFunctionMac;



parcelRequire("7fPBF");
const $721bb2247b62229e$var$SvgKeyG = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm11.591 7.705c-4.339 0-7.183 3.287-7.183 8.297 0 5.076 2.8 8.305 7.183 8.305 4.055 0 6.737-2.592 6.737-6.502v-1.936h-6.426v1.736h4.459v.385c0 2.681-1.924 4.494-4.758 4.494-3.186 0-5.164-2.483-5.164-6.482 0-3.945 2.01-6.47 5.152-6.47 2.352 0 3.945 1.13 4.627 3.273h2.01c-.573-3.142-3.12-5.1-6.637-5.1zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $721bb2247b62229e$export$2e2bcd8739ae039 = $721bb2247b62229e$var$SvgKeyG;



parcelRequire("7fPBF");
const $40c08a9bfd143af3$var$SvgKeyH = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm5.072 8.08v15.854h1.978v-7.217h8.702v7.217h1.976V14.08h-1.976v6.856H20.65V14.08h-1.978zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $40c08a9bfd143af3$export$2e2bcd8739ae039 = $40c08a9bfd143af3$var$SvgKeyH;



parcelRequire("7fPBF");
const $9df36942c9a98cf6$var$SvgKeyHashtag = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm7.357 7-.338 4h-3.762l-.107 2h3.7l-.507 6h-3.836L16 27h3.773l-.337 4h2.005l.338-4h6.03l-.338 4h2.008l.337-4h3.327l.107-2h-3.264l.506-6h3.4L34 17h-3.338L31 13h-2.008l-.338 4h-6.027l.338-4h-2.008zm1.5 6h6.027l-.505 6h-6.03l.508-6zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $9df36942c9a98cf6$export$2e2bcd8739ae039 = $9df36942c9a98cf6$var$SvgKeyHashtag;



parcelRequire("7fPBF");
const $e90a70d42b6dc2e5$var$SvgKeyHomeButton = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4a9.017 9.017 0 0 0-9 9v24a9.017 9.017 0 0 0 9 9h32a9.017 9.017 0 0 0 9-9V13a9.017 9.017 0 0 0-9-9H9zm0 2h32a6.983 6.983 0 0 1 7 7v24a6.983 6.983 0 0 1-7 7H9a6.983 6.983 0 0 1-7-7V13a6.983 6.983 0 0 1 7-7zm2 11a1 1 0 0 0-1 1v14a1 1 0 0 0 2 0V18a1 1 0 0 0-1-1zm9.97 2a1 1 0 0 0-.525.168l-6 5a1.021 1.021 0 0 0-.117.1l-.047.04a1 1 0 0 0-.181.274c-.011.023-.019.046-.028.07a.9.9 0 0 0 0 .696c.01.024.017.047.028.07a1 1 0 0 0 .185.273c.015.015.03.025.045.04a1.021 1.021 0 0 0 .117.1l6 5A1 1 0 0 0 22 30v-4h17a1 1 0 0 0 0-2H22v-4a1 1 0 0 0-1.03-1z"
        })
    });
var $e90a70d42b6dc2e5$export$2e2bcd8739ae039 = $e90a70d42b6dc2e5$var$SvgKeyHomeButton;



parcelRequire("7fPBF");
const $31af271f439f7f10$var$SvgKeyI = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm10.414 8.08v15.854h1.976V14.08h-1.976zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $31af271f439f7f10$export$2e2bcd8739ae039 = $31af271f439f7f10$var$SvgKeyI;



parcelRequire("7fPBF");
const $c2e5ff91a41ba25e$var$SvgKeyJ = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm13.455 8.08v11.426c0 1.944-.957 2.976-2.649 2.976-1.493 0-2.504-.92-2.549-2.25h-1.964c0 2.428 1.868 4.077 4.527 4.077 2.867 0 4.611-1.77 4.611-4.791V14.08h-1.976zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $c2e5ff91a41ba25e$export$2e2bcd8739ae039 = $c2e5ff91a41ba25e$var$SvgKeyJ;



parcelRequire("7fPBF");
const $eed7a945fc76c2bd$var$SvgKeyK = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm6.011 8.08v15.854h1.979v-5.538l1.898-2.097 5.725 7.635h2.56l-6.921-9.008 6.34-6.846h-2.483l-6.943 7.701h-.176v-7.7H19.61zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $eed7a945fc76c2bd$export$2e2bcd8739ae039 = $eed7a945fc76c2bd$var$SvgKeyK;



parcelRequire("7fPBF");
const $babff20b0d4654ba$var$SvgKeyL = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm7.033 8.08v15.854h9.625v-1.78H22.61V14.08h-1.978zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $babff20b0d4654ba$export$2e2bcd8739ae039 = $babff20b0d4654ba$var$SvgKeyL;



parcelRequire("7fPBF");
const $28380b67fbfe727d$var$SvgKeyLeftAngleParentheses = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm16.416 8.498-12.032 6.959v1.941l12.032 6.96v-2.544l-9.68-5.277v-.219l9.68-5.277v-2.543zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $28380b67fbfe727d$export$2e2bcd8739ae039 = $28380b67fbfe727d$var$SvgKeyLeftAngleParentheses;



parcelRequire("7fPBF");
const $eeaf776f967e20c6$var$SvgKeyM = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm3.588 8.08v15.854h1.845V17.826h.133l4.998 11.998h1.672l4.998-11.998h.13v12.108h1.847V14.08h-2.295l-5.428 13.117h-.176L19.484 14.08h-2.297zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $eeaf776f967e20c6$export$2e2bcd8739ae039 = $eeaf776f967e20c6$var$SvgKeyM;



parcelRequire("7fPBF");
const $dcb0c3efc1457ecf$var$SvgKeyMinus = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.643 4c-4.738 0-8.6 3.862-8.6 8.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6c0-4.738-3.862-8.6-8.6-8.6h-22.8zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6h-22.8a6.585 6.585 0 0 1-6.6-6.6V12.6c0-3.657 2.943-6.6 6.6-6.6zm3.4 15v2h16v-2h-16zm-10 15.902a8.588 8.588 0 0 0 6.6 3.098h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6h-22.8a6.585 6.585 0 0 1-6.6-6.6v-1.498z"
        })
    });
var $dcb0c3efc1457ecf$export$2e2bcd8739ae039 = $dcb0c3efc1457ecf$var$SvgKeyMinus;



parcelRequire("7fPBF");
const $e13a1775e3b494bc$var$SvgKeyN = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm5.072 8.08v15.854h1.955V17.64h.176l8.603 12.293h1.922V14.08h-1.955v12.338h-.176L20.596 14.08h-1.924zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $e13a1775e3b494bc$export$2e2bcd8739ae039 = $e13a1775e3b494bc$var$SvgKeyN;



parcelRequire("7fPBF");
const $4c0f13b7e9c863f6$var$SvgKeyO = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm11.418 7.705c-4.482 0-7.286 3.199-7.286 8.297 0 5.076 2.737 8.305 7.286 8.305 4.526 0 7.25-3.241 7.25-8.305 0-5.086-2.746-8.296-7.25-8.297zm0 1.824c3.24 0 5.216 2.507 5.216 6.473 0 3.933-1.964 6.48-5.216 6.48-3.296 0-5.252-2.547-5.252-6.48 0-3.965 2.02-6.472 5.252-6.473zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $4c0f13b7e9c863f6$export$2e2bcd8739ae039 = $4c0f13b7e9c863f6$var$SvgKeyO;



parcelRequire("7fPBF");
const $f785a1fe04b59464$var$SvgKeyOption = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11 7c-2.75 0-5 2.25-5 5v26c0 2.75 2.25 5 5 5h28c2.75 0 5-2.25 5-5V12c0-2.75-2.25-5-5-5H11zm0 2h28c1.668 0 3 1.332 3 3v26c0 1.668-1.332 3-3 3H11c-1.668 0-3-1.332-3-3V12c0-1.668 1.332-3 3-3zm11 4a1 1 0 1 0 0 2h2.213l3.75 7H37a1 1 0 1 0 0-2h-7.84l-3.75-7H22zm6.563 0a1 1 0 1 0 0 2H37a1 1 0 1 0 0-2h-8.437z"
        })
    });
var $f785a1fe04b59464$export$2e2bcd8739ae039 = $f785a1fe04b59464$var$SvgKeyOption;



parcelRequire("7fPBF");
const $f857acdec584cd37$var$SvgKeyP = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm6.273 8.08v15.854h1.979v-5.659h3.988c2.978 0 5.098-2.098 5.098-5.064 0-3.021-2.078-5.13-5.077-5.13h-5.988zm1.98 1.758h3.493c2.297 0 3.56 1.198 3.56 3.373 0 2.098-1.307 3.307-3.56 3.307h-3.492v-6.68zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $f857acdec584cd37$export$2e2bcd8739ae039 = $f857acdec584cd37$var$SvgKeyP;



parcelRequire("7fPBF");
const $e99cc5022343e76f$var$SvgKeyPageDownButton = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4a9.017 9.017 0 0 0-9 9v24a9.017 9.017 0 0 0 9 9h32a9.017 9.017 0 0 0 9-9V13a9.017 9.017 0 0 0-9-9H9zm0 2h32a6.983 6.983 0 0 1 7 7v24a6.983 6.983 0 0 1-7 7H9a6.983 6.983 0 0 1-7-7V13a6.983 6.983 0 0 1 7-7zm15.97 4a1 1 0 0 0-.97 1v17h-4a1 1 0 0 0-.832 1.555l5 6a1.021 1.021 0 0 0 .1.117c.014.015.026.033.04.047a.978.978 0 0 0 .274.183.707.707 0 0 0 .07.028.9.9 0 0 0 .694 0 .707.707 0 0 0 .068-.028.978.978 0 0 0 .275-.183c.015-.014.027-.032.041-.047a1.021 1.021 0 0 0 .1-.117l5-6a1 1 0 0 0 .053-1.028A1 1 0 0 0 30 28h-4V11a1 1 0 0 0-1.03-1zM17.96 38A1 1 0 0 0 18 40h14a1 1 0 0 0 0-2H18a1 1 0 0 0-.041 0z"
        })
    });
var $e99cc5022343e76f$export$2e2bcd8739ae039 = $e99cc5022343e76f$var$SvgKeyPageDownButton;



parcelRequire("7fPBF");
const $2a844d4ba0847ea6$var$SvgKeyPageUpButton = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4a9.017 9.017 0 0 0-9 9v24a9.017 9.017 0 0 0 9 9h32a9.017 9.017 0 0 0 9-9V13a9.017 9.017 0 0 0-9-9H9zm0 2h32a6.983 6.983 0 0 1 7 7v24a6.983 6.983 0 0 1-7 7H9a6.983 6.983 0 0 1-7-7V13a6.983 6.983 0 0 1 7-7zm8.959 4A1 1 0 0 0 18 12h14a1 1 0 0 0 0-2H18a1 1 0 0 0-.041 0zm6.99 4.002a.961.961 0 0 0-.728.398c-.014.02-.04.025-.053.045l-5 6A1 1 0 0 0 20 22h4v17a1 1 0 0 0 2 0V22h4a1 1 0 0 0 .832-1.555l-5-6c-.013-.02-.039-.026-.053-.045a.961.961 0 0 0-.83-.398z"
        })
    });
var $2a844d4ba0847ea6$export$2e2bcd8739ae039 = $2a844d4ba0847ea6$var$SvgKeyPageUpButton;



parcelRequire("7fPBF");
const $5047847f9449d0d7$var$SvgKeyPlus = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.664 4c-4.737 0-8.6 3.862-8.6 8.6v25.8c0 4.738 3.863 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6c0-4.738-3.862-8.6-8.6-8.6h-22.8zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6h-22.8a6.585 6.585 0 0 1-6.6-6.6V12.6c0-3.657 2.944-6.6 6.6-6.6zm10.4 8v7h-7v2h7v7h2v-7h7v-2h-7v-7h-2zm-17 22.902a8.588 8.588 0 0 0 6.6 3.098h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6h-22.8a6.585 6.585 0 0 1-6.6-6.6v-1.498z"
        })
    });
var $5047847f9449d0d7$export$2e2bcd8739ae039 = $5047847f9449d0d7$var$SvgKeyPlus;



parcelRequire("7fPBF");
const $6604f2ab651791da$var$SvgKeyQ = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm11.416 7.705c-4.482 0-7.284 3.188-7.284 8.307 0 5.142 2.768 8.295 7.284 8.295 1.022 0 1.988-.165 2.834-.483l1.396 1.9h2.219l-2.01-2.79c1.801-1.297 2.813-3.77 2.813-6.922 0-5.11-2.792-8.307-7.252-8.307zm0 1.826c3.208 0 5.218 2.504 5.218 6.48 0 2.418-.691 4.309-1.933 5.298l-1.44-1.913h-2.24l2.098 2.846c-.55.165-1.11.24-1.692.24-3.252 0-5.263-2.471-5.263-6.47 0-3.987 2.022-6.48 5.252-6.48zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $6604f2ab651791da$export$2e2bcd8739ae039 = $6604f2ab651791da$var$SvgKeyQ;



parcelRequire("7fPBF");
const $756d3ddc5105ca4d$var$SvgKeyR = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm6.072 8.08v15.854h1.976v-6.272h3.9l3.395 6.274h2.319l-3.67-6.582c1.99-.627 3.187-2.341 3.187-4.55 0-2.856-2-4.724-5.054-4.724h-6.053zm1.978 1.76h3.813c2.043 0 3.271 1.13 3.271 3.031 0 1.944-1.153 3.031-3.185 3.031H21.65V15.84zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $756d3ddc5105ca4d$export$2e2bcd8739ae039 = $756d3ddc5105ca4d$var$SvgKeyR;



parcelRequire("7fPBF");
const $cdc0aa5cadea8c33$var$SvgKeyRightAngleParentheses = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm6.384 8.498v2.543l9.68 5.277v.22l-9.68 5.276v2.543l12.032-6.959v-1.941l-12.032-6.959zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $cdc0aa5cadea8c33$export$2e2bcd8739ae039 = $cdc0aa5cadea8c33$var$SvgKeyRightAngleParentheses;



parcelRequire("7fPBF");
const $39f8b5dc7ed29ffc$var$SvgKeyS = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm11.56 7.707c-3.35 0-5.603 1.825-5.603 4.516 0 2.252 1.241 3.548 4.109 4.273l2.031.527c2.187.55 3.176 1.406 3.176 2.758 0 1.572-1.57 2.725-3.701 2.725-2.252 0-3.834-1.054-4.076-2.713v-.002h-1.998c.208 2.736 2.526 4.516 5.888 4.516 3.625 0 5.92-1.856 5.92-4.768 0-2.329-1.317-3.604-4.601-4.428l-1.66-.437c-2.187-.56-3.055-1.276-3.055-2.518 0-1.604 1.397-2.658 3.506-2.658 1.978 0 3.317.968 3.592 2.594h1.988c-.164-2.56-2.45-4.385-5.516-4.385zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $39f8b5dc7ed29ffc$export$2e2bcd8739ae039 = $39f8b5dc7ed29ffc$var$SvgKeyS;



parcelRequire("7fPBF");
const $8378efa8f631e6e6$var$SvgKeySolidus = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm12.347 7.512-4.13 17.04h2.197l4.17-17.04h-2.237zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $8378efa8f631e6e6$export$2e2bcd8739ae039 = $8378efa8f631e6e6$var$SvgKeySolidus;



parcelRequire("7fPBF");
const $20566c6a075b51f1$var$SvgKeySpace = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M6 12c-3.302 0-6 2.698-6 6v15c0 3.302 2.698 6 6 6h38c3.302 0 6-2.698 6-6V18c0-3.302-2.698-6-6-6H6zm0 2h38c2.22 0 4 1.78 4 4v10c0 2.22-1.78 4-4 4H6c-2.22 0-4-1.78-4-4V18c0-2.22 1.78-4 4-4zM2 32.455A5.967 5.967 0 0 0 6 34h38a5.967 5.967 0 0 0 4-1.545V33c0 2.22-1.78 4-4 4H6c-2.22 0-4-1.78-4-4v-.545z"
        })
    });
var $20566c6a075b51f1$export$2e2bcd8739ae039 = $20566c6a075b51f1$var$SvgKeySpace;



parcelRequire("7fPBF");
const $441acdbafb1bd1ee$var$SvgKeyT = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm5.304 8.08v1.78h5.11v14.074h1.976V15.859h5.11V14.08H18.904zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $441acdbafb1bd1ee$export$2e2bcd8739ae039 = $441acdbafb1bd1ee$var$SvgKeyT;



parcelRequire("7fPBF");
const $eb7fda30618d887d$var$SvgKeyTab = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.6 4C5.862 4 2 7.862 2 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h28.8c4.738 0 8.6-3.862 8.6-8.6V12.6C48 7.862 44.138 4 39.4 4H10.6zm0 2h28.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H10.6A6.585 6.585 0 0 1 4 31.4V12.6C4 8.943 6.943 6 10.6 6zM32 12v8h2v-8h-2zm0 4a.57.57 0 0 0-.043-.217c-.006-.015-.01-.028-.018-.043a.624.624 0 0 0-.115-.172c-.009-.009-.02-.014-.03-.023a.628.628 0 0 0-.071-.065l-3.752-3.125a.626.626 0 0 0-.971.518V15H16v2h11v2.127a.625.625 0 0 0 .973.52l3.752-3.126a.628.628 0 0 0 .072-.064c.009-.009.02-.014.03-.023a.633.633 0 0 0 .112-.172c.007-.014.012-.03.018-.045A.57.57 0 0 0 32 16zm-16 7v8h2v-8h-2zm2 4a.57.57 0 0 0 .043.217c.006.015.01.028.018.043a.624.624 0 0 0 .115.172c.009.009.02.014.03.023a.628.628 0 0 0 .071.065l3.752 3.125a.626.626 0 0 0 .971-.518V28h11v-2H23v-2.127a.625.625 0 0 0-.973-.52l-3.752 3.126a.628.628 0 0 0-.072.064c-.009.009-.02.014-.03.023a.633.633 0 0 0-.112.172c-.007.014-.012.03-.018.045A.57.57 0 0 0 18 27zM4 36.902A8.588 8.588 0 0 0 10.6 40h28.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H10.6A6.585 6.585 0 0 1 4 38.4v-1.498z"
        })
    });
var $eb7fda30618d887d$export$2e2bcd8739ae039 = $eb7fda30618d887d$var$SvgKeyTab;



parcelRequire("7fPBF");
const $0674e1fc2efa4c50$var$SvgKeyU = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm5.105 8.08v10.404c0 3.384 2.364 5.825 6.297 5.825 3.934 0 6.295-2.44 6.295-5.825V14.08h-1.979v10.274c0 2.395-1.569 4.13-4.316 4.13-2.746 0-4.318-1.735-4.318-4.13V14.08h-1.979zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $0674e1fc2efa4c50$export$2e2bcd8739ae039 = $0674e1fc2efa4c50$var$SvgKeyU;



parcelRequire("7fPBF");
const $300d4a3a425ff969$var$SvgKeyV = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm4.578 8.08 5.845 15.854h1.956l5.843-15.854h-2.076l-4.658 13.293h-.176L20.254 14.08h-2.076zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $300d4a3a425ff969$export$2e2bcd8739ae039 = $300d4a3a425ff969$var$SvgKeyV;



parcelRequire("7fPBF");
const $673e0b4aaae7ef63$var$SvgKeyW = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm1.502 8.08 4.318 15.854h1.865l3.649-12.514h.13l3.649 12.514h1.867l4.318-15.854h-2.066L29.68 26.97h-.131L26 14.08h-2L20.451 26.97h-.133L17.166 14.08h-2.064zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $673e0b4aaae7ef63$export$2e2bcd8739ae039 = $673e0b4aaae7ef63$var$SvgKeyW;



parcelRequire("7fPBF");
const $cfc8508a0d8a5a06$var$SvgKeyWindows = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.6 4C5.862 4 2 7.862 2 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h28.8c4.738 0 8.6-3.862 8.6-8.6V12.6C48 7.862 44.138 4 39.4 4H10.6zm0 2h28.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H10.6A6.585 6.585 0 0 1 4 31.4V12.6C4 8.943 6.943 6 10.6 6zm16.998 10.166c-.615 0-1.045.398-1.045.938 0 .54.429.935 1.045.935.622 0 1.047-.394 1.047-.935s-.425-.938-1.047-.938zm-15.217.705 2.646 9.863h1.66l1.995-6.986h.103l2.01 6.986h1.654l2.647-9.863H23.27l-1.688 7.342h-.096l-1.968-7.342H17.95l-1.94 7.342h-.103l-1.687-7.342h-1.84zm22.265 2.234c-1.122 0-1.996.512-2.351 1.346h-.117v-1.195h-1.633v7.476h1.695V22.38c0-1.101.684-1.799 1.778-1.799 1.025 0 1.544.575 1.544 1.717v4.437h1.688v-4.84c0-1.783-.936-2.789-2.604-2.789zm-7.888.15v7.48h1.687v-7.48h-1.687zM4 36.903A8.588 8.588 0 0 0 10.6 40h28.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H10.6A6.585 6.585 0 0 1 4 38.4v-1.498z"
        })
    });
var $cfc8508a0d8a5a06$export$2e2bcd8739ae039 = $cfc8508a0d8a5a06$var$SvgKeyWindows;



parcelRequire("7fPBF");
const $bded3da25f49952b$var$SvgKeyX = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm4.82 8.08 5.361 7.877-5.426 7.977h2.24l4.231-6.25h.176l4.152 6.25h2.373l-5.373-7.887 5.494-7.967h-2.252l-4.242 6.307h-.175l-4.174-6.307H18.42zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $bded3da25f49952b$export$2e2bcd8739ae039 = $bded3da25f49952b$var$SvgKeyX;



parcelRequire("7fPBF");
const $d240e40e324119ef$var$SvgKeyY = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm4.789 8.08 5.625 9.031v6.823h1.974V23.11l5.625-9.03h-2.252l-4.271 7.042h-.178l-4.271-7.043h-2.252zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $d240e40e324119ef$export$2e2bcd8739ae039 = $d240e40e324119ef$var$SvgKeyY;



parcelRequire("7fPBF");
const $1401a11666a30a5e$var$SvgKeyZ = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm5.847 8.08v1.78h8.668v.175l-8.974 12.492v1.407h11.722v-1.78h-9.119v-.175l8.932-12.493V14.08H19.447zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    });
var $1401a11666a30a5e$export$2e2bcd8739ae039 = $1401a11666a30a5e$var$SvgKeyZ;



parcelRequire("7fPBF");
const $46e8d4dadea67077$var$SvgLeanFrontToBack = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#fff",
                d: "m65.164 45.724-1.322 1.01a11.015 11.015 0 0 1-6.342 2.26 11.015 11.015 0 0 1-6.342-2.26l-1.322-1.01a15.93 15.93 0 0 1-6.05-10.117l-1.276-7.921c-.339-2.098-.504-4.275.284-6.248C44.488 17.194 48.915 12 57.15 12c8.824 0 13.347 5.195 15.055 9.438.793 1.972.624 4.15.285 6.248l-1.277 7.92a15.93 15.93 0 0 1-6.05 10.118Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeOpacity: 0.3,
                strokeWidth: 2.16,
                d: "M57.15 49v0c2.42 0 4.77-.796 6.692-2.266l1.322-1.01a15.93 15.93 0 0 0 6.05-10.117l1.276-7.921c.339-2.098.508-4.276-.285-6.248C70.497 17.195 65.975 12 57.15 12c-8.235 0-12.662 5.194-14.356 9.438-.788 1.973-.623 4.15-.284 6.248l1.277 7.92a15.93 15.93 0 0 0 6.05 10.118l1.321 1.01A11.015 11.015 0 0 0 57.85 49v0"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#fff",
                d: "m56.177 63.81-1.712 1.322a13.752 13.752 0 0 1-7.965 2.861 13.752 13.752 0 0 1-7.965-2.86l-1.712-1.322a20.09 20.09 0 0 1-7.56-12.734L27.5 40.042c-.332-2.079-.484-4.22.19-6.214C29.558 28.31 35.156 21 46.06 21c11.685 0 17.374 7.31 19.25 12.828.677 1.993.522 4.135.19 6.214l-1.763 11.035a20.09 20.09 0 0 1-7.56 12.734Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeOpacity: 0.3,
                strokeWidth: 2.16,
                d: "M46.06 68v0c3.042 0 5.998-1.008 8.405-2.868l1.712-1.321a20.09 20.09 0 0 0 7.56-12.734L65.5 40.042c.332-2.079.487-4.221-.19-6.214C63.433 28.31 57.744 21 46.06 21c-10.905 0-16.503 7.31-18.37 12.828-.674 1.994-.522 4.135-.19 6.214l1.763 11.035a20.09 20.09 0 0 0 7.56 12.734l1.712 1.321A13.752 13.752 0 0 0 46.94 68v0"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#FBFDFE",
                d: "m45.936 82.556-1.95 1.48a16.73 16.73 0 0 1-9.586 3.396 16.73 16.73 0 0 1-9.587-3.396l-1.95-1.48a24.002 24.002 0 0 1-9.179-15.269l-2.167-13.335c-.343-2.114-.493-4.288.15-6.33C13.732 41.066 20.454 32 33.872 32c14.377 0 21.19 9.066 23.262 15.622.645 2.042.492 4.216.149 6.33l-2.167 13.335a24.002 24.002 0 0 1-9.18 15.27Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeWidth: 2.7,
                d: "M33.872 87.44v0a16.73 16.73 0 0 0 10.115-3.404l1.95-1.48a24.002 24.002 0 0 0 9.179-15.269l2.167-13.335c.343-2.114.495-4.288-.15-6.33C55.064 41.066 48.25 32 33.874 32c-13.42 0-20.141 9.066-22.206 15.622-.643 2.042-.493 4.216-.15 6.33l2.167 13.335a24.002 24.002 0 0 0 9.18 15.27l1.95 1.479a16.73 16.73 0 0 0 10.114 3.404v0"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                d: "M67.072 82.874a1 1 0 0 0 1.302.554l8.348-3.363a1 1 0 0 0-.747-1.855l-7.421 2.989-2.989-7.42a1 1 0 0 0-1.855.746l3.362 8.349Zm23.356-51.248a1 1 0 0 0-1.302-.554l-8.348 3.363a1 1 0 0 0 .747 1.855l7.421-2.989 2.989 7.42a1 1 0 0 0 1.855-.746l-3.362-8.349ZM68.92 82.892l21.5-50.5-1.84-.784-21.5 50.5 1.84.784Z"
            })
        ]
    });
var $46e8d4dadea67077$export$2e2bcd8739ae039 = $46e8d4dadea67077$var$SvgLeanFrontToBack;



parcelRequire("7fPBF");
const $788da9ed54ecd493$var$SvgLinkedin = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4C6.25 4 4 6.25 4 9v32c0 2.75 2.25 5 5 5h32c2.75 0 5-2.25 5-5V9c0-2.75-2.25-5-5-5H9zm0 2h32c1.668 0 3 1.332 3 3v32c0 1.668-1.332 3-3 3H9c-1.668 0-3-1.332-3-3V9c0-1.668 1.332-3 3-3zm5 5.012c-1.095 0-2.08.327-2.81.941a3.297 3.297 0 0 0-1.178 2.514c0 1.867 1.62 3.323 3.68 3.467a.988.988 0 0 0 .003.002.988.988 0 0 0 .305.052c2.273 0 3.988-1.592 3.988-3.521a.988.988 0 0 0-.002-.053c-.101-1.9-1.796-3.402-3.986-3.402zm0 1.976c1.392 0 1.942.622 2.002 1.504-.012.856-.542 1.52-2.002 1.52-1.385 0-2.012-.71-2.012-1.545 0-.418.153-.733.473-1.002.32-.27.834-.477 1.539-.477zM11 19a1 1 0 0 0-1 1v19a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V20a1 1 0 0 0-1-1h-6zm9 0a1 1 0 0 0-1 1v19a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V29c0-.83.226-1.655.625-2.195.399-.54.901-.865 1.857-.848.986.017 1.508.355 1.903.885S32 28.167 32 29v10a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V28.262c0-2.962-.877-5.308-2.38-6.895C36.114 19.78 34.023 19 31.812 19A8.729 8.729 0 0 0 27 20.424V20a1 1 0 0 0-1-1h-6zm-8 2h4v17h-4V21zm9 0h4v1.56a1 1 0 0 0 1.799.602S28.369 21 31.813 21c1.753 0 3.256.583 4.355 1.742 1.099 1.16 1.832 2.946 1.832 5.52V38h-4v-9c0-1.167-.28-2.373-1.01-3.354-.73-.98-1.958-1.663-3.472-1.689-1.522-.027-2.77.67-3.502 1.662C25.284 26.611 25 27.83 25 29v9h-4V21z"
        })
    });
var $788da9ed54ecd493$export$2e2bcd8739ae039 = $788da9ed54ecd493$var$SvgLinkedin;



const $0e324a98afaf32e9$var$SvgComponent = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        "data-name": "Layer 1",
        viewBox: "0 0 500 500",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M382.92 279.27c12.57-6.76 27.45-5.52 31.84 2.65.58 1.07.96 2.23 1.16 3.47 1.12 7.19-4.19 17.93-16.5 24.55-12.57 6.76-27.45 5.51-31.85-2.65-.57-1.06-.96-2.23-1.15-3.46-1.12-7.19 4.19-17.94 16.5-24.56Zm-97.19 76.18c1.47 2.87 5 3.91 6.98 4.27 4.66.85 10.21-.14 15.25-2.72 8.71-4.46 13.12-12.18 12.36-17.08-.1-.67-.3-1.28-.61-1.87-1.47-2.87-5-3.91-6.98-4.27-4.66-.85-10.22.14-15.26 2.72-8.71 4.46-13.11 12.19-12.35 17.09.1.67.29 1.28.6 1.86Zm173.51-75.68a50.45 50.45 0 0 0-4.83-.16H454.26c-1.12.02-2.19.07-3.19.15h-.12c-.97.08-1.88.18-2.71.29h-.05c-.04 0-.08.01-.12.02-3.4.46-5.51 1.09-5.51 1.09-3.45-11.48-9.94-18.47-17.1-22.33-.04-.02-.07-.05-.11-.07-3.6-1.92-7.37-3.06-11-3.57-1.82-.26-3.6-.36-5.31-.33-1.71.03-3.35.2-4.88.47-.04 0-.07.02-.11.03-4.1.76-7.76 2.42-10.56 4.02-1.31.75-.6 2.75.89 2.55 1-.14 2.09-.25 3.23-.33.09 0 .18-.02.28-.02.06 0 .12 0 .19-.01h.03c.67-.04 1.39-.03 2.09-.04h.1c.63 0 1.24-.04 1.89-.02s.02 0 .03 0c.06 0 .11.01.17.01 1.12.04 2.28.14 3.44.29.59.08 1.17.2 1.76.3.71.13 1.42.28 2.14.46.82.2 1.62.44 2.43.72.59.2 1.17.46 1.75.7.58.23 1.15.45 1.72.74.69.35 1.38.73 2.05 1.14 3.4 2.15 6.48 5.25 8.82 9.69.03.06.07.14.11.21.01.03.03.06.04.09.57 1.1 1.39 2.84 2.12 5.07.12.36.23.7.34 1.08.22.77.42 1.59.58 2.46.01.06.03.12.04.18.01.06.02.13.04.19.15.84.27 1.71.35 2.62v.03c.05.57.04 1.17.05 1.77v.05c.03 1.86-.16 3.85-.6 5.91-.06.27-.1.53-.17.8-.11.45-.23.91-.38 1.37-.46 1.51-1.12 3.05-1.92 4.61-.01.02-.02.05-.03.07-.54 1.04-1.17 2.09-1.89 3.15-.19.28-.38.56-.58.84-.71.99-1.52 1.98-2.4 2.98-.07.07-.13.15-.19.22a46.354 46.354 0 0 1-4.74 4.59c-.05.05-.1.1-.16.15-1.83 1.52-3.9 3.04-6.23 4.54h-.01c-1.26.81-2.61 1.62-4.03 2.42-.02 0-.03.02-.04.03-.37.21-.67.42-1.06.63-.09.05-.18.09-.28.13-.79.43-1.59.71-2.39 1.08-1.16.55-2.32 1.14-3.5 1.59-1.34.51-2.67.88-4.01 1.26h-.03c-.72.21-1.45.44-2.17.61h-.02c-1.02.24-2.03.45-3.05.62-.94.15-1.87.25-2.81.35-1.2.12-2.38.25-3.56.28h-.01c-.11 0-.22-.01-.33-.01h-.01c-2.55.03-5.01-.21-7.4-.65-.1-.02-.19-.04-.28-.06-2.01-.38-3.92-.92-5.76-1.62h-.02c-1.83-.7-3.55-1.55-5.16-2.56-.15-.09-.29-.2-.43-.29-1.24-.81-2.44-1.66-3.51-2.65-.27-.24-.5-.54-.74-.81-.63-.63-1.25-1.27-1.81-1.97-.27-.27-.55-.53-.78-.84-2.39 1.44-4.79 2.9-7.22 4.37-2.96 1.79-5.95 3.59-9.01 5.42 0 0 0-.01-.01-.02-14.34-20.24-34.02-12.63-43.31-6.21-.01 0-.03.02-.04.02-.02.01-.03.03-.04.04-1.19.89-.27 2.81 1.2 2.42a49.71 49.71 0 0 1 7.44-1.4c.22-.02.44-.05.66-.07h.01c.17-.02.35 0 .53-.02 1.42-.11 2.87-.14 4.34-.08h.05c1.46.06 2.92.23 4.38.52.32.06.63.16.94.25 1.13.27 2.25.57 3.35 1.01.34.14.65.34.98.49 0 0 .01 0 .02.01 1.02.47 2.04.96 3 1.62.46.32.88.74 1.32 1.12.82.67 1.64 1.32 2.39 2.16.73.82 1.42 1.74 2.08 2.72.31.47.62.91.91 1.42.1.17.16.35.25.53.53 1.08.93 2.19 1.25 3.32.2.68.33 1.37.45 2.07.18 1.06.32 2.12.32 3.2 0 .66-.08 1.32-.16 1.99-.06.55-.17 1.45-.27 1.99-.18.95-.38 1.9-.67 2.85-.29.94-.63 1.86-1.03 2.78-.42.97-.91 1.91-1.44 2.85-.18.31-.37.62-.56.93-1.8 2.98-4.13 5.78-6.97 8.31-.7.61-1.38 1.23-2.13 1.81-2.03 1.58-4.19 3.05-6.6 4.28l-.06.03c-1.4.71-2.82 1.35-4.26 1.95-.07.03-.13.06-.2.08-2.99 1.23-6.02 2.18-9.01 2.79-.11.02-.23.04-.34.07-2.16.42-4.28.66-6.34.7h-.11c-.65 0-1.29 0-1.93-.04-.11 0-.21-.02-.31-.02-1.86-.12-3.64-.43-5.34-.94-.18-.05-.36-.11-.54-.17-.52-.17-1.03-.35-1.53-.57-.17-.07-.33-.16-.49-.24-.92-.42-1.79-.92-2.63-1.5-.19-.13-.38-.24-.56-.38-.36-.27-.7-.56-1.04-.86-.26-.23-.51-.46-.76-.71-.28-.28-.57-.54-.83-.84l-.12-.15c-.07-.08-.13-.18-.2-.26-.68-.81-1.3-1.72-1.87-2.7-.07-.11-.13-.23-.2-.35-.09-.16-.18-.3-.26-.46-.24-.47-.47-.96-.7-1.45-.33-.75-.65-1.5-.91-2.33 0-.01 0-.02-.01-.03-6.51 2.37-13.08 4.52-19.73 6.25-1.44-5.51-3.71-9.64-6.44-12.74s-.02-.03-.03-.04c-.51-.58-1.02-1.14-1.56-1.64-.13-.12-.27-.23-.41-.35a22.868 22.868 0 0 0-5-3.39c-.07-.03-.14-.07-.21-.11-.68-.33-1.36-.62-2.05-.88h-.02c-.01 0-.03-.01-.04-.02-1.13-.42-2.27-.77-3.42-1.02l-.19-.03h-.01c-.85-.18-1.7-.31-2.55-.4h-.07c-.92-.1-1.82-.14-2.71-.15h-.03c-1.28 0-2.52.06-3.7.2h-.03c-1.22.15-2.38.36-3.45.64h-.02c-.35.09-.6.3-.76.54-.52.78-.14 2.05 1.01 2.15.08 0 .16.02.23.02.02 0 .04 0 .06.01 1.91.18 4.02.54 6.17 1.12s.09.01.13.02c.08.02.16.06.24.09.96.27 1.92.61 2.87.99.04.02.08.03.12.05.94.39 1.86.84 2.77 1.35h.02a19.62 19.62 0 0 1 5.06 4.09c.28.32.55.64.82.98.85 1.12 1.63 2.33 2.24 3.74 0 0 0 .01.01.02.01.03.03.06.05.09.01.03.03.06.04.08l.03.09c0 .03.02.06.03.09v.01c.3.75.56 1.59.77 2.49.17.75.32 1.52.4 2.35v.08c.08.77.09 1.57.07 2.39 0 .2-.03.4-.04.6-.04.65-.11 1.31-.22 1.97-.04.21-.07.41-.11.62-.16.77-.36 1.55-.63 2.33-.03.08-.04.15-.07.23-.65 1.81-1.65 3.6-3.05 5.3-.06.08-.13.15-.2.23-.67.79-1.43 1.56-2.29 2.3-.06.05-.12.1-.18.16-1.9 1.6-4.28 3.04-7.23 4.24-.2.08-.43.16-.64.24h-.02c-1.27.49-2.64.93-4.12 1.32-.44.12-.87.24-1.33.35-1.82.43-3.73.81-5.86 1.08-2.37.3-4.73.32-7.05.22-.23-.01-.45-.04-.67-.06a36.23 36.23 0 0 1-6.51-1h-.01c-.24-.06-.48-.11-.71-.18-1.42-.39-2.75-.87-4.04-1.44-.17-.08-.34-.15-.51-.23-1.18-.55-2.28-1.16-3.32-1.86-.22-.15-.42-.31-.64-.46-.98-.71-1.89-1.47-2.7-2.33-.16-.17-.29-.36-.44-.53-.81-.92-1.55-1.88-2.14-2.96-.18-.33-.3-.68-.44-1.03-.55-1.18-.99-2.42-1.25-3.78-.29-1.27-.48-2.59-.44-4.04-3.78-.58-7.55-1.34-11.3-2.23-2.96-.69-5.91-1.5-8.84-2.42-.29-.09-.58-.17-.87-.26v-.01c1.79-4.32 2.41-8.26 2.24-11.83-.05-1.06-.16-2.1-.35-3.09-.03-.14-.07-.28-.1-.42-.22-1.02-.52-2-.86-2.95l-.06-.15c-.07-.18-.14-.37-.21-.55-.33-.81-.7-1.6-1.1-2.35-.07-.13-.14-.27-.21-.41l-.03-.06c-.57-.99-1.21-1.93-1.89-2.81l-.12-.15c-.03-.04-.06-.08-.1-.12l-.02-.02c-.45-.56-.91-1.11-1.39-1.62s-.06-.06-.08-.09c-.2-.21-.4-.43-.61-.64-1.92-1.93-4.03-3.5-6.1-4.71-.03-.02-.06-.03-.08-.05 0 0-.02 0-.03-.01-.99-.57-1.96-1.08-2.89-1.48-1.43-.62-2.66 1.21-1.5 2.26.36.32.73.69 1.09 1.04.5.49 1 1.01 1.5 1.55.05.06.11.12.16.17 0 .01.02.02.03.03.59.65 1.17 1.35 1.72 2.08 0 0 0 .01.01.02.55.73 1.08 1.5 1.58 2.31.07.11.15.22.22.33.44.74.84 1.51 1.2 2.31.35.77.65 1.56.91 2.38.16.51.3 1.02.42 1.55l.09.41c.15.68.26 1.38.35 2.09.08.81.15 1.62.12 2.46-.01.14-.07.25-.08.4-.18 1.84-.52 3.56-1.07 5.1-.44 1.24-1.09 2.29-1.73 3.34 0 0 0 .02-.02.03-.2.31-.32.69-.54.99-.5.7-1.1 1.27-1.69 1.88v.01c-.45.46-.88.92-1.38 1.32-.64.52-1.3.98-2 1.4-.6.36-1.24.67-1.88.96-.7.31-1.37.65-2.11.88-.59.19-1.23.26-1.84.4-1.28.28-2.56.5-3.93.56H142c-1.17.06-2.35.05-3.56-.06-.62-.06-1.23-.16-1.86-.26-.41-.06-.82-.19-1.23-.28-2.59-.52-5.2-1.39-7.8-2.64-.55-.26-1.09-.41-1.64-.71-1.45-.79-2.82-1.69-4.15-2.63-.39-.28-.75-.57-1.13-.85-.96-.73-1.86-1.51-2.73-2.31h-.01c-3.01-2.81-5.4-6.04-6.87-9.53v-.02c-.46-1.1-.97-2.97-1.26-4.12l-.04-.17c-.25-1.42-.4-2.85-.31-4.32v-.06c0-.02.01-.05.01-.08 0-.04.02-.08.02-.11.12-1.57.42-3.15.98-4.75.15-.44.37-.89.57-1.33.52-1.2 1.14-2.41 1.94-3.62a86.592 86.592 0 0 1-3.11-3.22c-.04-.04-.07-.08-.1-.12-3.08-3.35-6.01-7.01-8.81-10.87v-.01c-.75-1.02-1.5-2.04-2.21-3.07-.36-.53-.7-1.07-1.06-1.61v-.02c-1.03-1.54-2.03-3.09-2.98-4.68-2.2-3.63-4.24-7.41-6.15-11.28-.17-.35-.35-.7-.52-1.06-1.89-3.9-3.63-7.86-5.19-11.89-.07-.17-.14-.33-.21-.5-.73-1.91-1.43-3.83-2.08-5.76-.36-1.07-.69-2.13-1.01-3.2-.3-1.05-.61-2.13-.9-3.27-.22-.84-.42-1.67-.62-2.51v-.02c-.14-.6-.26-1.22-.39-1.84-3.19-14.67-2.92-29.19.31-42.73l.03-.13c.53-2.2 1.13-4.37 1.81-6.52.05-.17.12-.35.17-.52v-.01c.81-2.5 1.73-4.96 2.74-7.37s.04-.09.05-.13c1.66-3.95 3.58-7.76 5.76-11.43.03-.04.05-.08.08-.13 2.15-3.61 4.52-7.09 7.15-10.38.06-.08.11-.15.16-.23.18-.23.37-.46.56-.69.53-.62 1.11-1.26 1.64-1.89.64-.74 1.26-1.5 1.92-2.22 1.03-1.12 2.16-2.25 3.33-3.39.7-.69 1.41-1.38 2.14-2.05 1.16-1.07 2.36-2.12 3.63-3.18.27-.22.52-.47.79-.69.5-.41 1-.73 1.5-1.12 1.53-1.2 3.06-2.38 4.74-3.54 2.53-1.76 5.04-3.37 7.54-4.79 1.83-1.02 3.71-2 5.67-2.91.93-.45 1.86-.85 2.78-1.25 0 0 .02 0 .02-.01.01 0 .02 0 .04-.01.55-.24 1.12-.46 1.68-.69 2.09-.85 4.16-1.61 6.21-2.26h.02c.34-.11.68-.22 1.02-.32h.01c2.02-.61 4.02-1.13 5.99-1.57h.04c1.94-.43 3.86-.78 5.75-1.05l.22-.03c1.85-.26 3.66-.46 5.45-.59.11 0 .21-.01.32-.02 1.8-.12 3.56-.19 5.3-.2h.25c2.35 0 4.65.09 6.87.27h.01l.82.06c3.01.28 5.87.7 8.59 1.22.17.03.34.06.51.1 2.69.53 5.23 1.13 7.6 1.8.08.02.15.04.23.07 1.92.54 3.73 1.11 5.41 1.69.08.03.17.05.25.08 1.49.51 2.91 1.03 4.18 1.52.02 0 .04.02.07.02.02 0 .04.02.06.02 3 1.17 2.48 4.05-.92 3.35-18.69-3.74-38.26-.81-51.97 8.37-43.51 29.14-36.41 72.13-23.51 97.69 12.33 24.45 42.87 47.58 80.01 47.49 25.37-.06 56.37-10.12 103.87-46.19C364.65 227.26 411.88 210.8 455.3 210c.66-.01 1.31-.12 1.95-.08 1.72.09 3-.6 2.3-3.32-.1-.39-.16-.78-.25-1.17-4.56-21.44-12.23-41.51-22.49-59.78h-.06c-4.06.94-48.43 11.56-94.46 41.41-22.62 14.67-41.24 30.33-58.33 44.5-7.15 5.93-14.06 11.63-20.84 16.85-20.92 15.68-43.1 32.92-68.06 32.42-5.76-.12-11.67-1.18-17.75-3.42-21.13-7.46-33.06-30.23-35.93-52.21a84.69 84.69 0 0 1-.48-4.69c-.11-1.56-.18-3.1-.2-4.63 0-.04.01-.08.01-.12 5.13 17.55 18.21 37.44 35.3 43.47 32.42 11.96 57.93-13.5 83.68-32.81 22.99-17.68 47.08-40.53 79.17-61.35 29.15-18.91 67.34-33.2 85.35-39.1-31.04-43.1-77.55-73.75-129.93-84.62-24.36-5.05-50.02-5.93-76.05-1.87-13.98 2.18-27.41 5.7-40.22 10.36 0 0-27.22 9.59-49.45 25.77-2.49 1.82-5.49 4.25-8.59 6.89-4.96 4.23-1.4 12.29 5.06 11.45 13.13-1.69 30.76-1.56 51.26 4.59 38.69 11.6 58.76 39.32 68.38 57.77 5.23 10.03-4.54 14.39-10.13 8.78-17.71-17.77-71.61-50.63-134.91-17.29-41.83 22.03-57.62 60.83-60.33 93.14-4.11 49 14.04 92.27 26.36 114.02 30.11 53.14 81.98 91.02 141.76 103.53 24.47 5.12 50.25 6.03 76.41 1.95 48.01-7.48 89.73-30.48 120.92-63.06a214.286 214.286 0 0 0 33.49-45.86c11.56-21.27 19.57-44.57 23.34-69.04.21-1.37-.81-2.65-2.19-2.77ZM199.94 372l.02.1c.59 3.75 7.41 8.42 16.79 7.21 4.76-.62 9.08-2.67 11.85-5.63.85-.91 2.8-3.3 2.46-5.82-.58-3.75-7.41-8.42-16.79-7.21-4.76.62-9.08 2.67-11.84 5.63-.85.91-2.8 3.3-2.47 5.72Zm-72.9-33.74c-1.07.1-3.65.48-4.64 2.04-.14.22-.56.87-.48 2.31.18 3.4 2.94 8.46 8.7 12.11 3.86 2.45 8.2 3.66 11.9 3.33 1.07-.09 3.66-.48 4.65-2.05.13-.22.55-.87.48-2.3-.18-3.39-2.94-8.45-8.7-12.11-3.86-2.45-8.2-3.66-11.9-3.33Z",
            style: {
                fill: 'currentColor',
                strokeWidth: 0
            }
        })
    });
var $0e324a98afaf32e9$export$2e2bcd8739ae039 = $0e324a98afaf32e9$var$SvgComponent;



parcelRequire("7fPBF");
const $4c0ef6c1c64a1357$var$SvgLogo2KLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4a1 1 0 0 0-.982.809l-8 41A1 1 0 0 0 1 47h40a1 1 0 0 0 .982-.809l8-41A1 1 0 0 0 49 4H9zm.824 2h37.961l-7.61 39H2.216l7.61-39zM21 8c-3.774 0-6.54 1.231-8.338 2.848C10.864 12.464 10 14.393 10 16a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1c0 .093-.013-.41.404-.895C17.822 14.62 18.723 14 21 14c.886 0 1.778.168 2.342.42.282.126.472.27.562.373.013.015.004.017.014.03l-.002.001c-.24.14-.687.318-1.201.479-1.028.32-2.317.59-3.213.818-2.22.563-4.874 1.19-7.12 2.406-2.245 1.217-4.136 3.179-4.359 6.114a1 1 0 0 0 0 .002c-.054.741-.023 2.37-.023 2.37A1 1 0 0 0 9 28h12.865l-2.842 12.783A1 1 0 0 0 20 42h5a1 1 0 0 0 .977-.783l1.03-4.647.766-.67 3.37 5.614A1 1 0 0 0 32 42h6a1 1 0 0 0 .863-1.504l-5.521-9.467 8.316-7.277A1 1 0 0 0 41 22h-6a1 1 0 0 0-.633.227l-5.097 4.17.707-3.18A1 1 0 0 0 29 22h-8.207c.08-.02.105-.042.186-.062 1.917-.487 4.284-1.01 6.275-1.971.995-.481 1.909-1.078 2.603-1.893A4.71 4.71 0 0 0 31 15c0-2.567-1.56-4.449-3.521-5.518C25.517 8.414 23.136 8 21 8zm0 2c1.864 0 3.983.4 5.521 1.238C28.061 12.077 29 13.196 29 15c0 .735-.227 1.264-.664 1.777-.438.514-1.114.984-1.951 1.389-1.675.81-3.942 1.335-5.899 1.832-2.51.637-4.643 1.21-6.222 2.14A1 1 0 0 0 14.77 24H27.754l-1.063 4.783a1 1 0 0 0 1.61.99L35.357 24h2.983l-6.936 6.068a1 1 0 0 0-.207 1.256L36.26 40h-3.694l-3.693-6.154a1 1 0 0 0-1.516-.239l-1.912 1.674a1 1 0 0 0-.318.535L24.197 40h-2.95l2.84-12.783A1 1 0 0 0 23.112 26H10.008c0-.534-.007-.988.01-1.207v-.002c.166-2.188 1.41-3.473 3.316-4.506 1.907-1.033 4.424-1.657 6.66-2.224.81-.206 2.146-.482 3.319-.848.586-.183 1.13-.382 1.609-.66.24-.14.466-.299.674-.535.207-.237.404-.597.404-1.018 0-.582-.244-1.13-.592-1.525-.347-.396-.782-.67-1.25-.88C23.222 12.177 22.114 12 21 12c-2.666 0-4.265.817-5.111 1.8-.366.426-.532.834-.659 1.2h-2.949a5.84 5.84 0 0 1 1.717-2.664C15.42 11.057 17.655 10 21 10z"
        })
    });
var $4c0ef6c1c64a1357$export$2e2bcd8739ae039 = $4c0ef6c1c64a1357$var$SvgLogo2KLogo;



parcelRequire("7fPBF");
const $dc242ec31876a589$var$SvgMastercard = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M5 7c-2.75 0-5 2.25-5 5v26c0 2.75 2.25 5 5 5h40c2.75 0 5-2.25 5-5V12c0-2.75-2.25-5-5-5Zm0 2h40c1.668 0 3 1.332 3 3v26c0 1.668-1.332 3-3 3H5c-1.668 0-3-1.332-3-3V12c0-1.668 1.332-3 3-3Zm12 4c-6.617 0-12 5.383-12 12s5.383 12 12 12c3.078 0 5.875-1.184 8-3.094C27.125 35.816 29.926 37 33 37c6.617 0 12-5.383 12-12s-5.383-12-12-12c-3.074 0-5.875 1.184-8 3.094C22.875 14.184 20.078 13 17 13Zm0 2c.785 0 1.55.11 2.281.281-.18.18-.281.442-.281.719 0 .55.45 1 1 1s1-.45 1-1c0-.059-.023-.102-.031-.156 1.09.476 2.09 1.125 2.937 1.937a.993.993 0 0 0 .782.782 9.867 9.867 0 0 1 1.5 2.5C26.12 21.047 26.07 21 26 21c-.55 0-1 .45-1 1s.45 1 1 1c.277 0 .54-.102.719-.281.168.738.281 1.492.281 2.281 0 .79-.11 1.543-.281 2.281A1.016 1.016 0 0 0 26 27c-.55 0-1 .45-1 1s.45 1 1 1c.066 0 .125-.02.188-.031a10.09 10.09 0 0 1-1.532 2.468.993.993 0 0 0-.75.782 9.916 9.916 0 0 1-2.968 1.968c.015-.066.062-.117.062-.187 0-.55-.45-1-1-1s-1 .45-1 1c0 .293.113.566.313.75-.743.176-1.52.25-2.313.25-.793 0-1.57-.074-2.312-.25.199-.184.312-.457.312-.75 0-.55-.45-1-1-1s-1 .45-1 1c0 .07.047.121.063.188a9.945 9.945 0 0 1-5.25-5.25c.066.015.117.062.187.062.55 0 1-.45 1-1s-.45-1-1-1c-.293 0-.566.113-.75.313A10.04 10.04 0 0 1 7 25c0-.793.074-1.57.25-2.312.184.199.457.312.75.312.55 0 1-.45 1-1s-.45-1-1-1c-.07 0-.121.047-.187.063a9.945 9.945 0 0 1 5.25-5.25c-.016.066-.063.117-.063.187 0 .55.45 1 1 1s1-.45 1-1c0-.293-.113-.566-.312-.75A10.04 10.04 0 0 1 17 15Zm16 0c5.535 0 10 4.465 10 10s-4.465 10-10 10c-2.555 0-4.89-.934-6.656-2.5A11.95 11.95 0 0 0 29 25a11.95 11.95 0 0 0-2.656-7.5C28.109 15.934 30.445 15 33 15Zm-22 3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm6 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm6 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm-9 3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm6 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm-9 3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm6 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm6 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm-9 3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm6 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm-9 3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm6 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm6 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Z"
        })
    });
var $dc242ec31876a589$export$2e2bcd8739ae039 = $dc242ec31876a589$var$SvgMastercard;



parcelRequire("7fPBF");
const $3fbee013cad25ded$var$SvgMessages = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14 4C8.489 4 4 8.489 4 14v22c0 5.511 4.489 10 10 10h22c5.511 0 10-4.489 10-10V14c0-5.511-4.489-10-10-10H14zm0 2h22c4.43 0 8 3.57 8 8v22c0 4.43-3.57 8-8 8H14c-4.43 0-8-3.57-8-8V14c0-4.43 3.57-8 8-8zm11 5c-8.194 0-15 5.724-15 12.963 0 4.46 2.681 8.282 6.572 10.598a15.462 15.462 0 0 1-2.271 2.824 1 1 0 0 0 .873 1.699c2.308-.41 4.72-1.258 6.705-2.486 1.007.188 2.04.328 3.121.328 8.194 0 15-5.725 15-12.963C40 16.724 33.194 11 25 11zm0 2c7.27 0 13 4.99 13 10.963 0 5.973-5.73 10.963-13 10.963-1.064 0-2.095-.12-3.096-.328a1 1 0 0 0-.756.146c-.926.613-2.052 1.118-3.236 1.535.367-.497.753-.985 1.01-1.543a1 1 0 0 0-.465-1.314C14.552 31.494 12 27.968 12 23.962 12 17.99 17.73 13 25 13z"
        })
    });
var $3fbee013cad25ded$export$2e2bcd8739ae039 = $3fbee013cad25ded$var$SvgMessages;



parcelRequire("7fPBF");
const $a0ca46ae71da4c2a$var$SvgMicrosoftEdge = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M24.375 2c-5.68 0-9.965 1.98-13.062 4.344-7.86 5.992-8.625 16.125-8.625 16.125a1.001 1.001 0 0 0 1.843.625s2.887-4.469 7.907-7.594c1.699-1.059 3.867-1.832 6.062-2.375-.867.387-3.863 1.836-6.687 5.125-2.551 2.969-4 7.012-4 11.25 0 1.066-.02 3.113.593 5.281.57 2.02 1.672 3.98 2.688 5.469 2.941 4.305 7.265 6.105 9.344 6.781 2.394.778 4.855.969 7.125.969 8.128 0 13.562-3.344 13.562-3.344a1 1 0 0 0 .469-.875v-9.25a1 1 0 0 0-1.563-.843s-2.133 1.453-4.187 2.062c-1.547.46-2.809 1.063-7.125 1.063-6.11 0-8.692-2.118-9.938-4.157-.793-1.3-1-2.363-1.062-3.125h26.594c.55 0 1-.449 1-1v-4.625s-.09-3.566-.844-6.656c-.403-1.648-1.02-3.34-1.844-4.719-1.773-2.976-3.523-5.203-7.5-7.656C31.015 2.34 26.539 2 24.375 2Zm0 2c1.93 0 6.066.36 9.688 2.594 3.757 2.316 5.132 4.101 6.843 6.969.68 1.144 1.262 2.675 1.625 4.156.676 2.77.782 6.218.782 6.218v3.594H16.687a1 1 0 0 0-1 .938s-.218 2.613 1.376 5.218c1.593 2.606 5.058 5.126 11.656 5.126 4.523 0 6.328-.754 7.687-1.157 1.2-.355 2.32-.902 3.188-1.375v6.875C38.937 43.54 34.598 46 27.562 46c-2.156 0-4.394-.191-6.5-.875-1.851-.602-5.746-2.242-8.312-6-.93-1.363-1.96-3.187-2.437-4.875-.52-1.84-.5-3.672-.5-4.75 0-3.781 1.296-7.402 3.5-9.969 1.078-1.258 2.214-2.18 3.28-2.937-.015.031-.015.027-.03.062-.848 2-1.063 3.969-1.063 3.969a.999.999 0 0 0 1 1.094h15.594a.998.998 0 0 0 1-.875s.261-2.555-.844-5.157c-1.105-2.601-3.809-5.28-9-5.28-3.902 0-8.512 1.312-11.875 3.406-2.453 1.527-4.352 3.312-5.781 4.843.926-3.187 2.789-7.558 6.937-10.718C15.36 5.78 19.156 4 24.375 4Zm-1.125 8.406c4.55 0 6.281 2.004 7.156 4.063a8.37 8.37 0 0 1 .688 3.25H17.78c.114-.637.149-1.157.625-2.282.703-1.66 1.875-3.062 1.875-3.062a.997.997 0 0 0-.187-1.5c1.078-.187 2.18-.469 3.156-.469Z"
        })
    });
var $a0ca46ae71da4c2a$export$2e2bcd8739ae039 = $a0ca46ae71da4c2a$var$SvgMicrosoftEdge;



parcelRequire("7fPBF");
const $073cb9bb3a09c7d7$var$SvgMicrosoftExcel = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M28.875 0a.466.466 0 0 0-.062.031l-28 5.313a1 1 0 0 0-.813 1v37.312a1 1 0 0 0 .813 1l28 5.313c.289.054.59-.02.82-.207.226-.188.363-.465.367-.762v-5h17c1.094 0 2-.906 2-2V8c0-1.094-.906-2-2-2H30V1a1.004 1.004 0 0 0-1.125-1ZM28 2.188V6.53a1.01 1.01 0 0 0 0 .875v35.407a1.016 1.016 0 0 0 0 .406v4.593L2 42.845V7.156ZM30 8h17v34H30v-5h4v-2h-4v-6h4v-2h-4v-5h4v-2h-4v-5h4v-2h-4Zm6 5v2h8v-2ZM6.688 15.688l5.468 9.343-5.969 9.344h5l3.25-6.031c.227-.582.376-1.028.438-1.313h.031c.13.61.254 1.024.375 1.25l3.25 6.094H23.5l-5.75-9.437 5.594-9.25h-4.688l-2.968 5.53a20.942 20.942 0 0 0-.594 1.657h-.031a9.492 9.492 0 0 0-.563-1.594l-2.687-5.593ZM36 20v2h8v-2Zm0 7v2h8v-2Zm0 8v2h8v-2Z"
        })
    });
var $073cb9bb3a09c7d7$export$2e2bcd8739ae039 = $073cb9bb3a09c7d7$var$SvgMicrosoftExcel;



parcelRequire("7fPBF");
const $c9b5ae76a6c0d9c1$var$SvgMicrosoftOnenote = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M28.875 0a.466.466 0 0 0-.062.031l-28 5.313a1 1 0 0 0-.813 1v37.312a1 1 0 0 0 .813 1l28 5.313c.289.054.59-.02.82-.207.226-.188.363-.465.367-.762v-3h18c1.094 0 2-.906 2-2V33c0-.36-.11-.707-.281-1 .172-.293.281-.64.281-1V20c0-.36-.11-.707-.281-1 .172-.293.281-.64.281-1V7c0-1.094-.906-2-2-2H30V1a1.004 1.004 0 0 0-1.125-1ZM28 2.188v3.5a1.025 1.025 0 0 0 0 .593v38.532a1.016 1.016 0 0 0 0 .406v2.593L2 42.845V7.156ZM30 7h18v11h-4.094a1 1 0 0 0-.812.5v.031c-.13.227-.16.496-.094.75v12.407a1.025 1.025 0 0 0 0 .593V44H30v-7h8v-2h-8v-3h8v-2h-8v-3h8v-2h-8v-3h8v-2h-8v-3h8v-2h-8ZM6.531 15.688V34.25h3.5V24.031c0-1.347-.031-2.343-.094-3H10c.152.348.414.88.813 1.563l6.75 11.656h3.75V15.688h-3.5v10.25c0 1.269.03 2.128.093 2.562h-.031c-.25-.5-.547-.992-.844-1.5l-6.5-11.312ZM45 20h3v11h-3Zm0 13h3v11h-3Z"
        })
    });
var $c9b5ae76a6c0d9c1$export$2e2bcd8739ae039 = $c9b5ae76a6c0d9c1$var$SvgMicrosoftOnenote;



parcelRequire("7fPBF");
const $ddc5edcab4e76c4a$var$SvgMicrosoftOnenote2 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M28.875 0a.466.466 0 0 0-.062.031l-28 5.313a1 1 0 0 0-.813 1v37.312a1 1 0 0 0 .813 1l28 5.313c.289.054.59-.02.82-.207.226-.188.363-.465.367-.762v-3h18c1.094 0 2-.906 2-2V33c0-.36-.11-.707-.281-1 .172-.293.281-.64.281-1V20c0-.36-.11-.707-.281-1 .172-.293.281-.64.281-1V7c0-1.094-.906-2-2-2H30V1a1.004 1.004 0 0 0-1.125-1ZM28 2.188v3.5a1.025 1.025 0 0 0 0 .593v38.532a1.016 1.016 0 0 0 0 .406v2.593L2 42.845V7.156ZM30 7h18v11h-4.094a1 1 0 0 0-.812.5v.031c-.13.227-.16.496-.094.75v12.407a1.025 1.025 0 0 0 0 .593V44H30v-7h8v-2h-8v-3h8v-2h-8v-3h8v-2h-8v-3h8v-2h-8v-3h8v-2h-8ZM6.531 15.688V34.25h3.5V24.031c0-1.347-.031-2.343-.094-3H10c.152.348.414.88.813 1.563l6.75 11.656h3.75V15.688h-3.5v10.25c0 1.269.03 2.128.093 2.562h-.031c-.25-.5-.547-.992-.844-1.5l-6.5-11.312ZM45 20h3v11h-3Zm0 13h3v11h-3Z"
        })
    });
var $ddc5edcab4e76c4a$export$2e2bcd8739ae039 = $ddc5edcab4e76c4a$var$SvgMicrosoftOnenote2;



parcelRequire("7fPBF");
const $9b7e1a52af65fadf$var$SvgMicrosoftOutlook = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M28.875 0a.466.466 0 0 0-.062.031l-28 5.313a1 1 0 0 0-.813 1v37.312a1 1 0 0 0 .813 1l28 5.313c.289.054.59-.02.82-.207.226-.188.363-.465.367-.762V38h4.063c-.043.332-.063.66-.063 1 0 4.406 3.594 8 8 8 4.406 0 8-3.594 8-8 0-1.39-.371-2.703-1-3.844.004-.05.004-.105 0-.156V17.656a.991.991 0 0 0 0-.687V12c0-.55-.45-1-1-1H30V1a1.004 1.004 0 0 0-1.125-1ZM28 2.188v9.5a1.025 1.025 0 0 0 0 .593v24.407a1.025 1.025 0 0 0 0 .593v10.532l-26-4.97V7.157ZM30 13h17v3.781l-13.25 7.844L30 21.531Zm-15.156 2.531c-2.52 0-4.535.875-6.063 2.656-1.527 1.782-2.281 4.118-2.281 7 0 2.731.746 4.958 2.25 6.657 1.504 1.699 3.457 2.562 5.844 2.562 2.449 0 4.414-.902 5.937-2.656 1.524-1.758 2.282-4.07 2.282-6.937 0-2.79-.72-5.012-2.188-6.72-1.469-1.702-3.402-2.562-5.781-2.562Zm-.094 3.531c1.277 0 2.293.543 3.031 1.594.739 1.051 1.094 2.516 1.094 4.407 0 1.816-.398 3.23-1.156 4.25-.762 1.023-1.77 1.53-3.063 1.53-1.258 0-2.285-.511-3.062-1.562-.774-1.05-1.156-2.508-1.156-4.312 0-1.782.378-3.2 1.156-4.282.773-1.082 1.84-1.625 3.156-1.625Zm32.25.063v13.656A7.982 7.982 0 0 0 42 31c-3.34 0-6.21 2.082-7.406 5H30V24.094l3.031 2.5a1 1 0 0 0 1.157.093ZM42 33c3.324 0 6 2.676 6 6s-2.676 6-6 6-6-2.676-6-6 2.676-6 6-6Zm-1 1v7h5v-2h-3v-5Z"
        })
    });
var $9b7e1a52af65fadf$export$2e2bcd8739ae039 = $9b7e1a52af65fadf$var$SvgMicrosoftOutlook;



parcelRequire("7fPBF");
const $043753d569a8f872$var$SvgMicrosoftPowerpoint = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M28.875 0a.466.466 0 0 0-.062.031l-28 5.313a1 1 0 0 0-.813 1v37.312a1 1 0 0 0 .813 1l28 5.313c.289.054.59-.02.82-.207.226-.188.363-.465.367-.762v-5h17c1.094 0 2-.906 2-2V8c0-1.094-.906-2-2-2H30V1a1.004 1.004 0 0 0-1.125-1ZM28 2.188v4.5a1.025 1.025 0 0 0 0 .593v35.532a1.016 1.016 0 0 0 0 .406v4.593L2 42.845V7.156ZM30 8h17v34H30v-5h10v-2H30v-5.562c.922.367 1.95.562 3 .562 4.406 0 8-3.594 8-8v-1h-7v-7h-1c-1.059 0-2.07.191-3 .563Zm5 3v9h9v-1c0-4.406-3.594-8-8-8Zm2 2.188A5.84 5.84 0 0 1 41.813 18H37ZM8.156 15.656v18.719h4.219v-6.437h2c2.262 0 4.086-.59 5.438-1.75 1.351-1.16 2.03-2.684 2.03-4.563 0-3.977-2.378-5.969-7.093-5.969ZM32 16.25V23h6.813c-.489 2.828-2.84 5-5.813 5a5.956 5.956 0 0 1-2.875-.75 1.243 1.243 0 0 0-.125-.062V16.813c.031-.02.063-.04.094-.063.566-.316 1.246-.383 1.906-.5Zm-19.625 2.656h1.656c2.242 0 3.375.953 3.375 2.875 0 1.965-1.133 2.938-3.375 2.938h-1.656Z"
        })
    });
var $043753d569a8f872$export$2e2bcd8739ae039 = $043753d569a8f872$var$SvgMicrosoftPowerpoint;



parcelRequire("7fPBF");
const $d612a33d3bd29557$var$SvgMicrosoftTeams2019 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M27 4c-3.854 0-7 3.146-7 7 0 .694.11 1.364.299 2H5c-1.645 0-3 1.355-3 3v18c0 1.645 1.355 3 3 3h11.05c.509 5.596 5.224 10 10.95 10 5.12 0 9.241-3.59 10.46-8.336C38.644 39.441 39.985 40 41.5 40c4.13 0 7.5-3.37 7.5-7.5V21a1 1 0 0 0-1-1H26v-2.076c.328.047.66.076 1 .076 3.854 0 7-3.146 7-7s-3.146-7-7-7zm0 2c2.774 0 5 2.226 5 5s-2.226 5-5 5a5.02 5.02 0 0 1-1.012-.111C25.928 14.295 24.607 13 23 13h-.578A4.953 4.953 0 0 1 22 11c0-2.774 2.226-5 5-5zm15 2c-1.583 0-2.898.63-3.748 1.586C37.402 10.542 37 11.778 37 13s.402 2.458 1.252 3.414S40.417 18 42 18c1.583 0 2.898-.63 3.748-1.586C46.598 15.458 47 14.222 47 13s-.402-2.458-1.252-3.414S43.583 8 42 8zm0 2c1.083 0 1.769.37 2.252.914.483.544.748 1.308.748 2.086 0 .778-.265 1.542-.748 2.086-.483.544-1.169.914-2.252.914-1.083 0-1.769-.37-2.252-.914C39.265 14.542 39 13.778 39 13c0-.778.265-1.542.748-2.086C40.231 10.37 40.917 10 42 10zM5 15h18c.565 0 1 .435 1 1v.365a1 1 0 0 0 0 .555v3.912a1 1 0 0 0 0 .326V34c0 .565-.435 1-1 1h-5.832a1 1 0 0 0-.326 0H5c-.565 0-1-.435-1-1V16c0-.565.435-1 1-1zm4 4v2h4v10h2V21h4v-2H9zm17 3h10v14c0 4.983-4.017 9-9 9a8.981 8.981 0 0 1-8.941-8H23c1.645 0 3-1.355 3-3V22zm12 0h9v10.5c0 3.05-2.45 5.5-5.5 5.5-1.403 0-2.649-.549-3.62-1.408.013-.207.12-.382.12-.592V22z"
        })
    });
var $d612a33d3bd29557$export$2e2bcd8739ae039 = $d612a33d3bd29557$var$SvgMicrosoftTeams2019;



parcelRequire("7fPBF");
const $4690868c4c694c15$var$SvgMicrosoftToDoApp = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M39.672 7.01c-.697 0-1.394.264-1.916.793l-16.912 17.16-8.58-8.705a2.745 2.745 0 0 0-1.961-.815c-.714 0-1.426.272-1.961.815H8.34l-6.533 6.63a2.817 2.817 0 0 0 0 3.938L18.88 44.152c.016.017.036.027.053.043.12.116.244.223.378.313 1.05.73 2.525.628 3.452-.313l.04-.043 5.66-5.74.878-.89 18.873-19.149a2.752 2.752 0 0 0-.002-3.846h.002l-6.63-6.724a2.676 2.676 0 0 0-1.913-.793zm0 1.98c.174 0 .348.073.49.217l6.627 6.725h.002a.737.737 0 0 1-.002 1.039L27.918 36.119l-.002-.002-6.535 6.631a.724.724 0 0 1-1.053.014l-6.598-6.696a.735.735 0 0 1 0-1.037L39.18 9.207a.69.69 0 0 1 .492-.217zm-29.37 8.434c.192 0 .383.079.538.236l8.6 8.727-7.133 7.238h-.002a2.674 2.674 0 0 0-.422.578l-8.653-8.78a.803.803 0 0 1 0-1.13v-.002l6.536-6.63a.753.753 0 0 1 .537-.237z"
        })
    });
var $4690868c4c694c15$export$2e2bcd8739ae039 = $4690868c4c694c15$var$SvgMicrosoftToDoApp;



parcelRequire("7fPBF");
const $be2fbecbfbe47448$var$SvgMicrosoftWord = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M28.875 0a.466.466 0 0 0-.062.031l-28 5.313a1 1 0 0 0-.813 1v37.312a1 1 0 0 0 .813 1l28 5.313c.289.054.59-.02.82-.207.226-.188.363-.465.367-.762v-5h17c1.094 0 2-.906 2-2V8c0-1.094-.906-2-2-2H30V1a1.004 1.004 0 0 0-1.125-1ZM28 2.188v4.5a1.025 1.025 0 0 0 0 .593v35.532a1.016 1.016 0 0 0 0 .406v4.593L2 42.845V7.156ZM30 8h17v34H30v-5h14v-2H30v-6h14v-2H30v-5h14v-2H30v-5h14v-2H30ZM4.625 15.656l3.813 18.688h3.75l2.468-11.969c.114-.55.219-1.273.281-2.125h.032c.027.773.09 1.5.219 2.125l2.406 11.969h3.625l3.843-18.688H21.75l-2 12.469a16.853 16.853 0 0 0-.219 2.094H19.5c-.066-.88-.133-1.54-.219-2l-2.375-12.563h-3.5l-2.625 12.407c-.168.792-.285 1.519-.312 2.187h-.063c-.039-.895-.097-1.625-.187-2.156L8.188 15.656Z"
        })
    });
var $be2fbecbfbe47448$export$2e2bcd8739ae039 = $be2fbecbfbe47448$var$SvgMicrosoftWord;



parcelRequire("7fPBF");
const $a9622dbe0a0baaaf$var$SvgMotionControl = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "none",
        viewBox: "0 0 100 100",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillOpacity: 0.3,
                d: "m23.528 38.31 7.865-2.689.667 1.95-7.865 2.69-.667-1.95Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillOpacity: 0.3,
                fillRule: "evenodd",
                d: "m48.63 77 19.197 6.563a4.26 4.26 0 0 0 5.41-2.653L86.572 41.9a4.26 4.26 0 0 0-2.653-5.409L63.353 29.46c.393.556.63 1.232.646 1.964l19.388 6.628a2.611 2.611 0 0 1 1.626 3.316l-13.337 39.01a2.611 2.611 0 0 1-3.315 1.626L53.727 77h-5.098Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillOpacity: 0.3,
                fillRule: "evenodd",
                d: "M35.498 29.716A3.431 3.431 0 0 0 35 31.5v.129L16.213 38.05a2.611 2.611 0 0 0-1.626 3.316l13.337 39.01a2.611 2.611 0 0 0 3.316 1.626L45.873 77h5.098l-19.198 6.563a4.26 4.26 0 0 1-5.41-2.653L13.028 41.9a4.26 4.26 0 0 1 2.653-5.409l19.818-6.776Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M34.34 32.483c0-2.467 2-4.467 4.466-4.467h21.988c2.467 0 4.466 2 4.466 4.467V73.71c0 2.466-2 4.466-4.466 4.466H38.806c-2.466 0-4.466-2-4.466-4.466V32.483Zm4.466-2.405a2.405 2.405 0 0 0-2.405 2.405V73.71a2.405 2.405 0 0 0 2.405 2.404h21.988a2.405 2.405 0 0 0 2.405-2.404V32.483a2.405 2.405 0 0 0-2.405-2.405H38.806Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                d: "M44.99 32.483h9.62v2.06h-9.62v-2.06Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "m9.918 27.667-.22-3.962a1.35 1.35 0 0 0-2.696.15l.409 7.356 7.686 1.618a1.35 1.35 0 1 0 .556-2.642l-3.658-.77C16.941 24.768 30.075 16.7 49.448 16.7c19.2 0 33.117 8.332 38.402 12.739l-3.553.748a1.35 1.35 0 0 0 .556 2.642l7.686-1.618.409-7.356a1.35 1.35 0 0 0-2.696-.15l-.224 4.042C84.638 23.068 69.89 14 49.448 14c-20.329 0-34.226 8.552-39.53 13.667Z",
                clipRule: "evenodd"
            })
        ]
    });
var $a9622dbe0a0baaaf$export$2e2bcd8739ae039 = $a9622dbe0a0baaaf$var$SvgMotionControl;



const $0fccc9e464ae15bb$var$SvgMotionControl1 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                width: 33.6,
                height: 56,
                x: 22.4,
                y: 35.269,
                fill: "#FBFDFE",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeOpacity: 0.3,
                strokeWidth: 1.92,
                rx: 4,
                transform: "rotate(-18.875 22.4 35.27)"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#141526",
                fillOpacity: 0.3,
                d: "m35.012 35.185 9.157-3.13.776 2.27-9.157 3.131z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                width: 33.6,
                height: 56,
                x: 48.8,
                y: 24.4,
                fill: "#FBFDFE",
                stroke: "#141526",
                strokeLinecap: "round",
                strokeWidth: 2.4,
                rx: 4
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#141526",
                d: "M60 28.4h11.2v2.4H60z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                stroke: "#E51546",
                strokeLinecap: "round",
                strokeWidth: 2.4,
                d: "M20 21c3.532-3.333 14.89-10 32.07-10C69.252 11 71.5 12.5 82 17.5"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                stroke: "#E51546",
                strokeLinecap: "round",
                strokeWidth: 2.4,
                d: "m18 15.6.4 7.2 7.6 1.6"
            })
        ]
    });
var $0fccc9e464ae15bb$export$2e2bcd8739ae039 = $0fccc9e464ae15bb$var$SvgMotionControl1;



parcelRequire("7fPBF");
const $9ca35a7fde0d51c6$var$SvgComponent = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                width: 33.6,
                height: 56,
                fill: "#FBFDFE",
                stroke: "#141526",
                strokeLinecap: "round",
                strokeOpacity: 0.3,
                strokeWidth: 1.92,
                rx: 4,
                transform: "scale(-1 1) rotate(-18.875 67.294 251.063)"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#141526",
                fillOpacity: 0.3,
                d: "m64.988 35.185-9.157-3.13-.776 2.27 9.156 3.13z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                width: 33.6,
                height: 56,
                fill: "#FBFDFE",
                stroke: "#141526",
                strokeLinecap: "round",
                strokeWidth: 2.4,
                rx: 4,
                transform: "matrix(-1 0 0 1 51.2 24.4)"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#141526",
                d: "M40 28.4H28.8v2.4H40z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                stroke: "#E51546",
                strokeLinecap: "round",
                strokeWidth: 2.4,
                d: "M80 21c-3.532-3.333-14.89-10-32.07-10C30.748 11 28.5 12.5 18 17.5"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                stroke: "#E51546",
                strokeLinecap: "round",
                strokeWidth: 2.4,
                d: "m82 15.6-.4 7.2-7.6 1.6"
            })
        ]
    });
var $9ca35a7fde0d51c6$export$2e2bcd8739ae039 = $9ca35a7fde0d51c6$var$SvgComponent;



parcelRequire("7fPBF");
const $311040ba1740986f$var$SvgMusic = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13 4c-4.959 0-9 4.041-9 9v24c0 4.959 4.041 9 9 9h24c4.959 0 9-4.041 9-9V13c0-4.959-4.041-9-9-9H13zm0 2h24c3.877 0 7 3.123 7 7v24c0 3.877-3.123 7-7 7H13c-3.877 0-7-3.123-7-7V13c0-3.877 3.123-7 7-7zm20.56 5.002a1.44 1.44 0 0 0-.335.023h-.002L20.63 13.387A2.012 2.012 0 0 0 19 15.354v13.632A1 1 0 0 0 19 29c0 1.117-.883 2-2 2h-1.83c-2.123 0-4.05 1.594-4.164 3.787C10.886 37.074 12.732 39 15 39h.5c3.026 0 5.5-2.474 5.5-5.5V20.455l12-2.25V26c0 1.117-.883 2-2 2h-1.83c-2.123 0-4.05 1.594-4.164 3.787C24.886 34.074 26.732 36 29 36h.5c3.026 0 5.5-2.474 5.5-5.5v-18c0-.803-.668-1.46-1.44-1.498zM33 13.104v3.066l-12 2.25v-3.066l12-2.25zm0 16.277V30.5c0 1.944-1.556 3.5-3.5 3.5H29a1.984 1.984 0 0 1-1.998-2.11c.055-1.052 1.043-1.89 2.168-1.89H31c.743 0 1.402-.262 2-.62zm-14 3V33.5c0 1.944-1.556 3.5-3.5 3.5H15a1.984 1.984 0 0 1-1.998-2.11c.055-1.052 1.043-1.89 2.168-1.89H17c.743 0 1.402-.262 2-.62z"
        })
    });
var $311040ba1740986f$export$2e2bcd8739ae039 = $311040ba1740986f$var$SvgMusic;



parcelRequire("7fPBF");
const $9cedd24a1acdd63f$var$SvgNetflix = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M27 6v10.75L23.48 6H14v38.15l9-1.28V32.58l3.24 10.34 6.14.72 3.62.51V6h-9zm2 2h5v30.13l-5-15.27V8zM17.39 8h4.64l.97 2.96 4 12.22 2 6.12 4.06 12.4-.54-.06-4.76-.56-.76-2.42-4-12.76-2-6.38L17.39 8zM21 41.13l-5 .72V10.24l5 15.96v14.93z"
        })
    });
var $9cedd24a1acdd63f$export$2e2bcd8739ae039 = $9cedd24a1acdd63f$var$SvgNetflix;



parcelRequire("7fPBF");
const $7e5ab08ff1b567f0$var$SvgNewYorkTimes = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 48 48",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M12 3c-4.959 0-9 4.041-9 9v24c0 4.959 4.041 9 9 9h24c4.959 0 9-4.041 9-9V12c0-4.959-4.041-9-9-9H12zm0 2h24c3.877 0 7 3.123 7 7v24c0 3.877-3.123 7-7 7H12c-3.877 0-7-3.123-7-7V12c0-3.877 3.123-7 7-7zm18 3v2c.913 0 1.29.686 1.346.828-.014.012-.018.019-.069.05-.154.098-.475.206-.877.206-.768 0-3.34-.622-5.072-1.252h-.002c-2.152-.828-4.184-1.537-6.086-1.537-1.814 0-3.56.457-4.922 1.406C12.957 10.651 12 12.171 12 14c0 1.542.949 2.67 1.898 3.326a7.26 7.26 0 0 0 2.03.965c-2.53 2.312-4.252 5.547-4.252 9.219 0 7.111 5.874 12.49 12.49 12.49 7.095 0 11.83-5.73 11.83-11.67v-1H32.94l-.205.73c-.283 1.016-.649 1.86-1.074 2.567v-3.34l2.778-2.258v-1.111L31.66 21.66v-3.81c.994-.177 1.954-.56 2.756-1.211 1.139-.926 1.906-2.405 1.906-4.227 0-1.932-1.043-3.292-2.34-3.853C32.686 7.997 31.25 8 30 8zm-10.76 2.295c1.375 0 3.278.6 5.385 1.41l.01.002.008.004c1.878.684 4.228 1.373 5.757 1.373.728 0 1.392-.168 1.94-.512.548-.343 1.03-.942 1.03-1.697 0-.187-.19-.31-.23-.488.012.004.036 0 .047.006.75.324 1.135.668 1.135 2.02 0 1.295-.46 2.098-1.168 2.673-.707.574-1.718.887-2.754.887h-.412c-1.326-.166-3.703-.455-5.879-1.077-2.604-.814-4.578-1.513-6.345-1.513-.872 0-1.545.025-2.192.33-.554.261-.91.899-1.017 1.51-.32-.336-.555-.709-.555-1.223 0-1.171.523-2.004 1.46-2.658.94-.654 2.313-1.047 3.78-1.047zm-1.476 5.088c.532 0 1.244.137 2.084.347-.573.25-1.13.546-1.67.874l-.768-.454s-.306-.182-.596-.418c-.098-.08-.163-.152-.232-.224.16-.048.502-.125 1.182-.125zm5.629 1.387c.054.017.089.025.144.043l.012.003.012.004c2.348.67 4.77.962 6.1 1.127v3.698l-2.645 2.293v1.072l2.644 2.293v5.453c-1.103.72-2.351 1.007-3.611 1.025a8.685 8.685 0 0 1-3.867-.875 6.436 6.436 0 0 1-1.327-.869l5.143-2.51V18.324l-6.77 2.969c.75-1.078 1.937-2.113 3.772-3.041l.809-.41-.416-1.072zm-3.768 1.396c-2.835 2.373-3.706 5.322-3.502 7.83.128 1.572.585 2.968 1.045 4.025.435 1.002.794 1.574 1.062 1.932.6 1.16 1.707 2.077 3.069 2.748a10.574 10.574 0 0 0 4.78 1.078c2.7-.04 5.524-1.365 7.32-4.345C32.163 35.052 28.884 38 24.165 38c-5.534 0-10.49-4.48-10.49-10.49 0-4.018 2.621-7.466 5.949-9.344zM24 21.201v7.301l-2 .977v-7.4l2-.878zm-4 1.754v7.5l-.281.137a10.174 10.174 0 0 1-.715-1.367c-.396-.911-.785-2.114-.889-3.391a7.961 7.961 0 0 1 .096-2.094L20 22.955zm10.66.47 1.291 1.05-1.29 1.046-1.21-1.046 1.21-1.05z"
        })
    });
var $7e5ab08ff1b567f0$export$2e2bcd8739ae039 = $7e5ab08ff1b567f0$var$SvgNewYorkTimes;



parcelRequire("7fPBF");
const $2081ab8da1be49dc$var$SvgNintendoSwitchLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14.53 4c-3.584 0-6.32 1.058-8.071 3.11C4.708 9.16 4 12.048 4 15.524v20C4 41.545 8.41 46 14.53 46H24V4h-9.47zM26 4v42h9.47C41.59 46 46 41.546 46 35.525v-20c0-3.476-.708-6.364-2.459-8.416C41.79 5.058 39.054 4 35.471 4H26zM14.53 6H22v38h-7.47C9.332 44 6 40.617 6 35.525v-20c0-3.203.663-5.575 1.979-7.117C9.295 6.867 11.324 6 14.529 6zM28 6h7.47c3.206 0 5.235.867 6.551 2.408C43.337 9.95 44 12.322 44 15.525v20C44 40.617 40.667 44 35.47 44H28V6zm-13.5 4c-1.417 0-2.606.567-3.373 1.43C10.36 12.292 10 13.403 10 14.5c0 1.097.36 2.208 1.127 3.07.767.863 1.956 1.43 3.373 1.43 1.417 0 2.606-.567 3.373-1.43C18.64 16.708 19 15.597 19 14.5c0-1.097-.36-2.208-1.127-3.07-.767-.863-1.956-1.43-3.373-1.43zm0 2c.917 0 1.477.308 1.877.758.4.45.623 1.09.623 1.742 0 .653-.223 1.292-.623 1.742-.4.45-.96.758-1.877.758s-1.477-.308-1.877-.758c-.4-.45-.623-1.09-.623-1.742 0-.653.223-1.292.623-1.742.4-.45.96-.758 1.877-.758zm21 12c-1.417 0-2.606.567-3.373 1.43C31.36 26.292 31 27.403 31 28.5c0 1.097.36 2.208 1.127 3.07.767.863 1.956 1.43 3.373 1.43 1.417 0 2.606-.567 3.373-1.43C39.64 30.708 40 29.597 40 28.5c0-1.097-.36-2.208-1.127-3.07-.767-.863-1.956-1.43-3.373-1.43zm0 2c.917 0 1.477.308 1.877.758.4.45.623 1.09.623 1.742 0 .653-.223 1.292-.623 1.742-.4.45-.96.758-1.877.758s-1.477-.308-1.877-.758c-.4-.45-.623-1.09-.623-1.742 0-.653.223-1.292.623-1.742.4-.45.96-.758 1.877-.758z"
        })
    });
var $2081ab8da1be49dc$export$2e2bcd8739ae039 = $2081ab8da1be49dc$var$SvgNintendoSwitchLogo;



parcelRequire("7fPBF");
const $0b823c4a4b1403fe$var$SvgNod = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "none",
        viewBox: "0 0 90 100 ",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillOpacity: 0.3,
                fillRule: "evenodd",
                d: "m60.786 78.88-1.175.892a16.729 16.729 0 0 1-9.587 3.396c-.97-.03-1.932-.146-2.874-.341a22.922 22.922 0 0 1-16.298-4.14L19.89 70.789c-1.7-1.225-3.175-2.534-4.043-4.203-3.001-5.773-4.56-16.467 5.207-26.233 3.98-3.98 8.259-5.908 12.298-6.562a21.803 21.803 0 0 1 3.096-2.425c-5.385.051-11.43 1.968-16.921 7.46C8.96 49.392 10.588 61.154 13.93 67.582c1.107 2.13 2.923 3.682 4.697 4.96l10.961 7.897a25.082 25.082 0 0 0 18.066 4.5l2.425-.333a17.81 17.81 0 0 0 9.15-4.103c.1-.05.196-.118.28-.202.124-.124.247-.25.367-.378.128-.12.255-.243.38-.368.083-.084.15-.179.201-.28.111-.13.22-.262.328-.395Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M49.496 29.086c-12.673 0-18.978 8.52-20.917 14.678-.546 1.733-.44 3.65-.105 5.707l2.167 13.336a22.652 22.652 0 0 0 8.663 14.41l1.95 1.48a15.38 15.38 0 0 0 8.77 3.12 15.38 15.38 0 0 0 8.77-3.12l1.95-1.48a22.653 22.653 0 0 0 8.664-14.41l2.166-13.336c.335-2.058.443-3.974-.104-5.706-1.931-6.116-8.303-14.679-21.974-14.679Zm1.449 55.382a18.079 18.079 0 0 0 9.482-3.62l1.95-1.48a25.352 25.352 0 0 0 9.696-16.128l2.167-13.336c.352-2.168.548-4.6-.195-6.952-2.21-6.997-9.465-16.566-24.549-16.566-14.164 0-21.303 9.613-23.493 16.567-.74 2.35-.547 4.781-.194 6.951l2.167 13.336a25.352 25.352 0 0 0 9.696 16.128l1.95 1.48a18.079 18.079 0 0 0 9.481 3.62c.125.038.257.058.393.058.176 0 .352-.002.528-.008.176.006.352.008.528.008.137 0 .269-.02.393-.058Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "m9.918 27.667-.22-3.962a1.35 1.35 0 0 0-2.696.15l.409 7.356 7.686 1.618a1.35 1.35 0 1 0 .556-2.642l-3.658-.77C16.941 24.768 30.075 16.7 49.448 16.7c19.2 0 33.117 8.332 38.402 12.739l-3.553.748a1.35 1.35 0 0 0 .556 2.642l7.686-1.618.409-7.356a1.35 1.35 0 0 0-2.696-.15l-.224 4.042C84.638 23.068 69.89 14 49.448 14c-20.329 0-34.226 8.552-39.53 13.667Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillOpacity: 0.3,
                fillRule: "evenodd",
                d: "M53.182 82.765a16.73 16.73 0 0 1-3.158.403 16.73 16.73 0 0 1-8.236-2.471 17.81 17.81 0 0 0 8.92 3.91l2.425.332a25.082 25.082 0 0 0 18.065-4.5l10.962-7.897c1.773-1.278 3.59-2.83 4.697-4.96 3.342-6.428 4.97-18.19-5.596-28.756-5.831-5.832-12.286-7.632-17.913-7.448a22.077 22.077 0 0 1 3.05 2.271c4.338.48 9.013 2.381 13.335 6.704 9.767 9.766 8.209 20.46 5.207 26.233-.867 1.669-2.342 2.978-4.043 4.203l-10.962 7.897a22.922 22.922 0 0 1-16.51 4.112l-.243-.033Z",
                clipRule: "evenodd"
            })
        ]
    });
var $0b823c4a4b1403fe$export$2e2bcd8739ae039 = $0b823c4a4b1403fe$var$SvgNod;



parcelRequire("7fPBF");
const $85b17b826eab10ce$var$SvgOctopus = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 100,
        height: 100,
        viewBox: "0 0 500 500",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "octopus_svg__linear-gradient",
                        x1: 87.69,
                        x2: 445.37,
                        y1: 515.02,
                        y2: 376.71,
                        gradientTransform: "rotate(-8.86 -1005.607 449.555)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#36368b"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.07,
                                stopColor: "#563986"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.17,
                                stopColor: "#7e3d7f"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.27,
                                stopColor: "#a1407a"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.38,
                                stopColor: "#bd4376"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#d24573"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.63,
                                stopColor: "#e24670"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.78,
                                stopColor: "#eb476f"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ee486f"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "octopus_svg__linear-gradient-2",
                        x1: -1214.8,
                        x2: -1320.26,
                        y1: -1720.35,
                        y2: -1993.07,
                        gradientTransform: "rotate(81.14 -1702.827 77.309)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#6db9e7"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.07,
                                stopColor: "#6ca2d7"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.16,
                                stopColor: "#6b8ac6"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.26,
                                stopColor: "#6b79ba"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.37,
                                stopColor: "#6b6fb3"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#6b6cb1"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#062844"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "octopus_svg__luminosity-invert",
                        width: 386,
                        height: 388,
                        x: 57.27,
                        y: 56.08,
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            result: "cm",
                            values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("style", {
                        children: '.octopus_svg__cls-8{stroke-width:0}.octopus_svg__cls-10{mix-blend-mode:multiply;opacity:.2}.octopus_svg__cls-8{fill:currentColor}'
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "octopus_svg__mask",
                        width: 386,
                        height: 388,
                        x: 57.27,
                        y: 56.08,
                        maskUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                            xlinkHref: "data:image/png;base64,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",
                            width: 386,
                            height: 388,
                            style: {
                                filter: 'url(#octopus_svg__luminosity-invert)'
                            },
                            transform: "translate(57.27 56.08)"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    isolation: 'isolate'
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    id: "octopus_svg__Layer_1",
                    "data-name": "Layer 1",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            cx: 250,
                            cy: 250,
                            r: 218.04,
                            style: {
                                fill: 'none',
                                strokeWidth: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M423.3 278.06c-6.24-20.76-23.53-25.23-34.56-23.23-3.73.68-7.06 2.19-9.6 3.65-1.18.68-.54 2.48.8 2.29 7.95-1.09 22-.85 28.92 12.28 2.42 4.6 12.06 24.68-18.71 41.5-16.41 8.97-35.03 6.43-43.28-4.98-4.76 2.88-9.59 5.81-14.61 8.81-12.93-18.26-30.68-11.37-39.03-5.58-1.14.79-.3 2.57 1.04 2.21 8.24-2.21 22.21-3.67 29.17 8.79 6.02 10.79-1.44 25.88-15.8 33.23-14.36 7.35-31.45 8.24-36.53-7.56-5.86 2.13-11.77 4.06-17.76 5.63-4.84-18.54-20.06-20.22-28.74-17.95-1.34.35-1.18 2.31.2 2.43 6.28.56 15.15 2.91 18.77 11.41 2.9 6.83 2.42 22.51-22.21 25.61-13.96 1.76-28.18-4.3-27.8-17.71-6.35-.98-12.67-2.4-18.91-4.42 6.76-16.28-4.56-26.7-12.61-30.2-1.29-.56-2.4 1.09-1.35 2.03 4.06 3.65 8.69 9.47 8.47 16.88-1.17 15.18-16.96 19.66-30.98 12.01-11.58-6.32-19.7-18.59-11.68-30.53-12.52-12.32-23-30.24-29.21-48.7-12.14-36.08 0-72.66 26.42-94.1 33.14-26.87 65.23-18.02 80.26-12.18 2.7 1.05 2.23 3.64-.83 3.01-2.06-.43-4.6-.58-6.87-.72-5.33-.34-10.96 0-15.57 1.17-15.55 3.96-28.26 22.1-29.23 46.19.29 22.04 11.21 47.71 32.94 55.39 29.17 10.77 54.06-8.72 77.23-26.1 20.69-15.92 42.37-36.48 71.26-55.21 42.25-27.4 85.07-37.27 85.07-37.27-27.13-48.06-74.23-82.66-128.27-93.87-21.93-4.55-45.02-5.34-68.45-1.69a192.795 192.795 0 0 0-36.2 9.32s-24.5 8.63-44.5 23.19c-2.25 1.63-4.94 3.83-7.73 6.2-4.46 3.8-1.26 11.06 4.55 10.31 11.82-1.52 27.68-1.4 46.13 4.13 34.82 10.44 52.88 35.39 61.54 52 4.7 9.03-4.08 12.95-9.12 7.9-15.94-15.99-64.45-45.57-121.42-15.56-37.65 19.83-51.86 54.75-54.29 83.82-3.7 44.1 12.63 83.05 23.73 102.62 27.1 47.83 73.78 81.92 127.59 93.18 22.02 4.61 45.23 5.43 68.77 1.76 43.21-6.73 80.75-27.43 108.83-56.75a193.006 193.006 0 0 0 30.14-41.27c10.4-19.14 17.61-40.12 21.01-62.13a2.18 2.18 0 0 0-1.97-2.49c-8.48-.7-15.01 1.26-15.01 1.26Z",
                            style: {
                                strokeWidth: 0,
                                fill: 'currentColor'
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            style: {
                                mask: 'url(#octopus_svg__mask)'
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M423.3 278.06c-6.24-20.76-23.53-25.23-34.56-23.23-3.73.68-7.06 2.19-9.6 3.65-1.18.68-.54 2.48.8 2.29 7.95-1.09 22-.85 28.92 12.28 2.42 4.6 12.06 24.68-18.71 41.5-16.41 8.97-35.03 6.43-43.28-4.98-4.76 2.88-9.59 5.81-14.61 8.81-12.93-18.26-30.68-11.37-39.03-5.58-1.14.79-.3 2.57 1.04 2.21 8.24-2.21 22.21-3.67 29.17 8.79 6.02 10.79-1.44 25.88-15.8 33.23-14.36 7.35-31.45 8.24-36.53-7.56-5.86 2.13-11.77 4.06-17.76 5.63-4.84-18.54-20.06-20.22-28.74-17.95-1.34.35-1.18 2.31.2 2.43 6.28.56 15.15 2.91 18.77 11.41 2.9 6.83 2.42 22.51-22.21 25.61-13.96 1.76-28.18-4.3-27.8-17.71-6.35-.98-12.67-2.4-18.91-4.42 6.76-16.28-4.56-26.7-12.61-30.2-1.29-.56-2.4 1.09-1.35 2.03 4.06 3.65 8.69 9.47 8.47 16.88-1.17 15.18-16.96 19.66-30.98 12.01-11.58-6.32-19.7-18.59-11.68-30.53-12.52-12.32-23-30.24-29.21-48.7-12.14-36.08 0-72.66 26.42-94.1 33.14-26.87 65.23-18.02 80.26-12.18 2.7 1.05 2.23 3.64-.83 3.01-2.06-.43-4.6-.58-6.87-.72-5.33-.34-10.96 0-15.57 1.17-15.55 3.96-28.26 22.1-29.23 46.19.29 22.04 11.21 47.71 32.94 55.39 29.17 10.77 54.06-8.72 77.23-26.1 20.69-15.92 42.37-36.48 71.26-55.21 42.25-27.4 85.07-37.27 85.07-37.27-27.13-48.06-74.23-82.66-128.27-93.87-21.93-4.55-45.02-5.34-68.45-1.69a192.795 192.795 0 0 0-36.2 9.32s-24.5 8.63-44.5 23.19c-2.25 1.63-4.94 3.83-7.73 6.2-4.46 3.8-1.26 11.06 4.55 10.31 11.82-1.52 27.68-1.4 46.13 4.13 34.82 10.44 52.88 35.39 61.54 52 4.7 9.03-4.08 12.95-9.12 7.9-15.94-15.99-64.45-45.57-121.42-15.56-37.65 19.83-51.86 54.75-54.29 83.82-3.7 44.1 12.63 83.05 23.73 102.62 27.1 47.83 73.78 81.92 127.59 93.18 22.02 4.61 45.23 5.43 68.77 1.76 43.21-6.73 80.75-27.43 108.83-56.75a193.006 193.006 0 0 0 30.14-41.27c10.4-19.14 17.61-40.12 21.01-62.13a2.18 2.18 0 0 0-1.97-2.49c-8.48-.7-15.01 1.26-15.01 1.26Z",
                                className: "octopus_svg__cls-10",
                                style: {
                                    fill: 'currentColor',
                                    strokeWidth: 0
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M282.16 344.9c1.32 2.58 4.5 3.52 6.28 3.84 4.19.77 9.19-.13 13.73-2.45 7.84-4.01 11.81-10.96 11.12-15.38-.09-.6-.27-1.15-.55-1.68-1.32-2.58-4.5-3.52-6.28-3.84-4.19-.77-9.19.13-13.73 2.45-7.84 4.01-11.8 10.97-11.11 15.38.09.6.27 1.15.54 1.67ZM204.94 359.8v.09c.54 3.38 6.68 7.58 15.12 6.49 4.29-.56 8.17-2.41 10.67-5.07.77-.82 2.52-2.97 2.21-5.23-.53-3.37-6.67-7.58-15.11-6.49-4.29.56-8.17 2.41-10.66 5.07-.77.82-2.52 2.97-2.23 5.14ZM135.15 331.26c-.13.2-.5.79-.43 2.08.16 3.06 2.65 7.61 7.83 10.9 3.47 2.2 7.38 3.3 10.71 3 .96-.08 3.29-.44 4.18-1.84.12-.2.5-.78.43-2.07-.16-3.05-2.65-7.61-7.83-10.9-3.47-2.2-7.38-3.3-10.71-3-.96.09-3.29.44-4.17 1.83ZM354.77 298.44c.17 1.11.52 2.16 1.03 3.12 3.96 7.35 17.35 8.47 28.67 2.39 11.08-5.96 15.86-15.63 14.85-22.1a9.572 9.572 0 0 0-1.04-3.12c-3.95-7.35-17.34-8.47-28.66-2.39-11.08 5.96-15.86 15.63-14.85 22.1Z",
                            className: "octopus_svg__cls-8"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M332.91 193.39c-28.88 18.73-50.56 39.3-71.26 55.21-23.17 17.37-48.06 36.86-77.23 26.1-21.74-7.68-32.65-33.34-32.94-55.39.97-24.09 12.32-42.76 51.67-46.63-16.82-3.36-34.43-.73-46.78 7.54-39.16 26.22-32.77 64.92-21.16 87.92 11.09 22 38.58 42.82 72.01 42.74 22.84-.06 50.73-9.11 93.49-41.57 52.34-39.73 94.85-54.55 133.93-55.27.59-.01 1.18-.11 1.75-.07 1.55.08 2.7-.54 2.07-2.99-.09-.35-.15-.7-.22-1.05-4.11-19.3-11.01-37.36-20.24-53.81-2.25.51-42.83 9.87-85.07 37.27Z",
                            style: {
                                fill: 'currentColor',
                                strokeWidth: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M258.57 228.81c-23.17 17.37-46.14 40.29-75.31 29.52-15.38-5.43-27.15-23.33-31.77-39.13 0 .04 0 .07-.01.11.02 1.38.08 2.77.18 4.17.1 1.4.24 2.81.43 4.22 2.58 19.78 13.32 40.27 32.34 46.99 5.47 2.02 10.79 2.97 15.97 3.08 22.47.45 42.43-15.06 61.26-29.17 6.11-4.7 12.33-9.82 18.76-15.16 15.38-12.76 32.13-26.84 52.49-40.05 41.43-26.87 81.37-36.42 85.02-37.26v-.11a191.01 191.01 0 0 0-11.29-17.62c-16.21 5.31-50.57 18.18-76.81 35.19-28.88 18.73-50.56 39.29-71.25 55.21Z",
                            style: {
                                fill: 'currentColor',
                                mixBlendMode: 'multiply',
                                opacity: 0.2,
                                strokeWidth: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M99.69 189.16c-13.2 15.05-31.43 60.23-13.11 104.52 4.7 11.37 11.11 24.1 21.23 34.37-.64 3.74-.68 7.44-.12 11.05 3.05 19.55 22.46 29.74 23.45 30.25 19.15 9.13 33.08 3.38 38.85-.06l10.79 3.27c7.88 22.93 39.73 20.67 41.12 20.56 23.42-1.76 33-14.04 36.22-19.78l7.55-2.49c20.74 19.19 51.76 1.14 53.12.33 21.54-12.7 24.48-31.1 24.62-39.32l1.83-1.06c26.46 16.4 56.87-2.77 57.87-3.43 17.86-9.84 24.13-25.13 26.15-32.16 2.45-.6 5.42-.59 7.91-.37 1.24-5.12 2.29-10.3 3.11-15.55.19-1.24-.73-2.39-1.98-2.49-1.35-.11-2.65-.15-3.89-.14-.17 0-.36-.01-.53 0-.48 0-.92.04-1.38.07-.52.02-1.08.03-1.56.07-.19.01-.34.04-.53.06-.71.06-1.41.13-2.04.22-1.2.16-2.16.34-2.96.51-.28.06-.58.12-.81.17-.82.19-1.29.33-1.29.33-.71-2.34-1.59-4.42-2.55-6.36-.29-.58-.6-1.11-.91-1.66-.76-1.35-1.57-2.6-2.43-3.75-.34-.45-.68-.93-1.03-1.35-2.57-3.05-5.48-5.38-8.55-7.02a29.867 29.867 0 0 0-9.9-3.21c-1.63-.23-3.24-.32-4.78-.29-1.54.03-3.02.18-4.39.43-1.53.28-2.93.76-4.29 1.25-.82.31-1.64.63-2.4.98-1.01.46-2.05.92-2.9 1.41-.01 0-.01.02-.02.03-.36.23-.5.57-.53.91v.24c.05.35.19.7.5.91.14.09.34.09.53.11.12.02.2.09.33.07.96-.13 2.04-.23 3.16-.3h.2c.6-.04 1.25-.02 1.88-.03h.09c.57 0 1.11-.04 1.7-.02s.02 0 .02 0c.05 0 .1.01.15.01 1.01.04 2.05.13 3.1.26.53.07 1.05.18 1.58.27.64.12 1.28.25 1.92.41.73.18 1.45.39 2.19.65.53.18 1.05.42 1.58.63s1.04.4 1.55.66c1.19.6 2.36 1.28 3.47 2.13 2.42 1.85 4.59 4.33 6.32 7.61.04.07.09.2.14.28.51.99 1.25 2.55 1.9 4.56.1.32.21.63.3.97.2.7.37 1.43.53 2.21.02.08.04.16.06.25.14.78.26 1.6.33 2.46v.02c.04.51.04 1.06.05 1.59v.04c.03 1.68-.14 3.46-.54 5.32-.05.24-.09.48-.15.72-.1.41-.21.82-.34 1.23-.42 1.36-1.01 2.75-1.73 4.15l-.03.06c-.49.94-1.05 1.88-1.7 2.84-.17.26-.34.51-.52.76-.64.89-1.37 1.78-2.16 2.68-.06.07-.12.13-.17.2a41.236 41.236 0 0 1-4.27 4.13c-.05.04-.09.09-.14.13a58.12 58.12 0 0 1-5.6 4.09h-.01c-1.13.73-2.35 1.45-3.63 2.18-.01 0-.03.01-.04.02-.33.19-.61.38-.95.57-.08.04-.17.08-.25.11-.71.38-1.43.64-2.15.98-1.05.5-2.09 1.02-3.15 1.43-1.2.46-2.4.79-3.61 1.14h-.02c-.65.19-1.3.4-1.95.55h-.02c-.92.22-1.83.4-2.75.56-.85.14-1.69.23-2.53.31-1.08.11-2.15.23-3.2.25h-.01c-.1 0-.2-.01-.3-.01-2.3.02-4.51-.19-6.66-.58-.09-.02-.17-.04-.25-.05-1.81-.34-3.53-.83-5.18-1.46h-.02a26.38 26.38 0 0 1-4.64-2.3c-.13-.08-.26-.18-.39-.27-1.12-.73-2.19-1.49-3.16-2.38-.25-.22-.45-.48-.67-.73-.57-.57-1.13-1.14-1.63-1.77-.24-.25-.5-.48-.7-.76-4.76 2.88-9.59 5.81-14.61 8.81-.07-.1-.14-.17-.21-.27-.07-.08-.13-.16-.2-.25-.78-1.06-1.57-2.04-2.38-2.93-.38-.42-.77-.78-1.15-1.16a30.6 30.6 0 0 0-1.81-1.66c-.43-.35-.85-.69-1.28-1.01-.6-.44-1.21-.83-1.81-1.2-.2-.12-.41-.24-.61-.36-.01 0-.03-.01-.04-.02-.2-.12-.4-.25-.61-.36-.76-.4-1.52-.73-2.29-1.02-2.14-.83-4.29-1.31-6.41-1.48h-.03c-1.61-.12-3.2-.08-4.75.1s-.01 0-.02 0c-.62.07-1.22.18-1.83.29-.06 0-.13.02-.19.03-.3.05-.6.1-.89.16l-.22.06c-.13.03-.25.07-.38.1-1.02.25-2.02.55-2.98.88-.03 0-.05.02-.08.03-.13.04-.26.09-.39.13-1.29.47-2.52 1-3.68 1.57-.07.03-.14.07-.22.11-.05.02-.09.04-.14.07-1.57.8-3 1.64-4.23 2.48-.03.02-.05.03-.08.05-.04.03-.08.05-.12.08-.27.19-.42.44-.49.7-.04.15 0 .29.02.44v.08c0 .05 0 .09.02.14.07.19.19.37.35.52.12.12.27.21.43.28h.09c.12.03.25.05.39.04.07 0 .13.02.2 0 .87-.23 1.83-.45 2.81-.65.18-.04.34-.09.52-.12 1.07-.21 2.22-.36 3.38-.48l.59-.06c.16-.01.32 0 .48-.02 1.28-.1 2.58-.13 3.91-.07h.04c1.31.06 2.63.21 3.94.46.28.06.56.14.84.22 1.02.24 2.03.52 3.01.91.3.12.59.3.88.44h.02c.92.43 1.83.87 2.7 1.46.42.28.79.67 1.19 1.01.74.6 1.48 1.19 2.15 1.94.97 1.08 1.89 2.28 2.69 3.72.62 1.11 1.01 2.29 1.34 3.48.18.61.3 1.23.41 1.86.16.95.29 1.9.29 2.88 0 .6-.07 1.19-.14 1.79-.06.49-.15 1.3-.24 1.79-.16.86-.34 1.71-.6 2.57-.26.84-.56 1.67-.92 2.5-.37.87-.82 1.72-1.29 2.57-.16.28-.33.56-.5.84-1.62 2.68-3.72 5.2-6.27 7.48-.63.55-1.24 1.11-1.92 1.63-1.83 1.42-3.77 2.75-5.94 3.85s-.01.01-.02.01c-1.27.65-2.56 1.22-3.85 1.76-.05.02-.11.04-.16.07h-.01c-2.69 1.11-5.42 1.96-8.12 2.51h-.01c-.09.02-.19.04-.28.05-5.24 1.03-10.29.87-14.5-.94-.15-.06-.28-.14-.43-.21-.83-.38-1.62-.83-2.37-1.35-.16-.11-.34-.22-.5-.34a16.09 16.09 0 0 1-2.37-2.17c-.1-.12-.19-.25-.29-.37-.61-.73-1.17-1.55-1.68-2.43-.14-.24-.28-.47-.41-.72-.55-1.05-1.06-2.17-1.46-3.43-5.86 2.13-11.77 4.07-17.76 5.63s0-.03-.01-.04c0-.02-.01-.04-.02-.06-1.08-4.1-2.72-7.27-4.63-9.85-.2-.27-.37-.61-.57-.89-.18-.24-.37-.43-.56-.63s-.04-.05-.07-.07c-.45-.51-.9-1-1.37-1.44-.31-.29-.63-.54-.94-.8-.39-.32-.78-.64-1.18-.92-.34-.24-.68-.47-1.02-.68-.41-.26-.83-.5-1.24-.72-.16-.09-.32-.17-.48-.25-.18-.09-.35-.19-.53-.27-.5-.23-1.01-.43-1.52-.63-.02 0-.04-.02-.07-.02-.01 0-.02 0-.03-.01-.22-.08-.43-.18-.65-.25-.79-.26-1.58-.48-2.37-.65l-.17-.03h-.06c-.75-.15-1.51-.27-2.25-.35h-.12c-.07 0-.15-.01-.22-.02-.73-.07-1.45-.11-2.16-.11h-.19c-.79 0-1.56.03-2.31.1h-.13c-.25.02-.5.05-.75.08-.98.12-1.91.29-2.78.51-.12.03-.25.05-.37.08-.32.08-.54.27-.69.49-.14.21-.2.46-.19.72v.01c0 .07.02.15.04.22.03.16.1.3.19.44.05.08.1.15.17.22.03.02.07.03.11.05.07.05.16.08.25.12.07.04.13.08.21.1.05.01.09.05.14.05.08 0 .17.04.25.05 1.72.17 3.62.49 5.55 1.01s.08 0 .12.02c.07.02.15.06.22.08.87.25 1.73.55 2.59.89.04.01.07.03.11.05.85.35 1.68.75 2.49 1.21h.02c1.67.95 3.21 2.16 4.55 3.68.25.29.5.57.73.88.77 1.01 1.46 2.1 2.02 3.37s0 0 0 .02c.02.05.06.09.08.14.02.05.04.12.06.17.27.67.51 1.43.7 2.24.16.67.29 1.37.36 2.11v.08c.07.69.08 1.41.06 2.15 0 .18-.02.36-.03.54-.03.58-.1 1.17-.2 1.77-.03.19-.06.37-.1.56-.14.7-.33 1.39-.57 2.09l-.06.21c-.59 1.63-1.49 3.24-2.74 4.77-.06.07-.12.14-.18.2-.6.71-1.29 1.4-2.06 2.07-.06.05-.11.09-.16.14-1.71 1.44-3.85 2.74-6.5 3.82-.18.07-.39.14-.58.21h-.02c-1.14.44-2.38.83-3.71 1.19-.4.11-.79.21-1.2.31-1.64.38-3.36.73-5.28.97-2.13.27-4.25.29-6.35.2-.21-.01-.4-.04-.61-.05-2.03-.13-3.98-.43-5.86-.9h-.01c-.21-.05-.43-.1-.64-.16-1.27-.35-2.47-.79-3.63-1.29-.16-.07-.31-.13-.46-.2a22.76 22.76 0 0 1-2.99-1.67c-.2-.13-.38-.28-.57-.41-.88-.64-1.7-1.33-2.43-2.1-.14-.15-.26-.32-.4-.48-.73-.83-1.4-1.69-1.93-2.66-.16-.29-.27-.62-.4-.93-.49-1.07-.89-2.18-1.13-3.4-.26-1.14-.44-2.33-.4-3.64-3.4-.53-6.8-1.21-10.17-2.01-2.93-.68-5.84-1.48-8.74-2.41s0 0 0-.01c.8-1.94 1.34-3.78 1.67-5.55v-.03c.32-1.77.42-3.46.34-5.07-.05-.96-.15-1.89-.32-2.79-.02-.13-.06-.25-.09-.38-.2-.92-.46-1.79-.77-2.64-.02-.04-.03-.09-.05-.13-.06-.17-.13-.33-.19-.5-.3-.73-.63-1.44-1-2.12-.06-.12-.12-.25-.19-.37l-.03-.06c-.45-.79-.95-1.54-1.48-2.25-.11-.14-.22-.28-.33-.41-.03-.04-.06-.07-.09-.11-.41-.51-.83-1.01-1.27-1.48-.02-.03-.05-.05-.08-.08-.18-.19-.36-.39-.55-.57-.43-.43-.87-.83-1.31-1.22-.08-.07-.17-.15-.25-.23l-.3-.27c-.58-.48-1.16-.91-1.75-1.33-.12-.09-.24-.16-.37-.24l-.54-.36c-.32-.21-.64-.41-.96-.59-.03-.01-.05-.03-.08-.04-.24-.14-.47-.27-.71-.4l-.21-.12c-.29-.16-.58-.29-.87-.43-.28-.13-.56-.28-.83-.4-.3-.13-.59-.12-.85-.05-.05.01-.09.04-.13.06-.11.05-.19.14-.28.22-.07.06-.16.09-.21.17-.03.04-.07.08-.09.12-.13.22-.21.47-.19.72.02.14.14.27.21.4.07.13.08.28.2.39.3.27.61.59.92.89.01.01.03.03.05.04.46.45.91.92 1.37 1.42l.02.02c.04.05.09.1.13.15 1.07 1.18 2.09 2.51 2.98 3.96.06.1.13.19.19.3.4.67.75 1.36 1.08 2.08.06.12.14.24.19.37.02.04.02.09.04.13.41.96.72 1.99.97 3.04.03.12.05.24.08.37.28 1.3.46 2.65.42 4.07v.02c-.01.13-.06.23-.08.36-.16 1.66-.47 3.2-.97 4.59-.39 1.12-.98 2.06-1.56 3.01 0 0 0 .02-.01.03-.18.28-.29.62-.48.89-.45.63-.99 1.15-1.52 1.69-.4.41-.8.83-1.24 1.19-.57.47-1.17.88-1.8 1.26-.54.33-1.11.6-1.69.87-.63.28-1.23.58-1.9.8-.53.17-1.11.23-1.66.36-1.15.25-2.31.45-3.53.5h-.02c-1.05.05-2.11.05-3.21-.05-.56-.05-1.11-.14-1.67-.23-.37-.06-.74-.17-1.11-.25-2.33-.47-4.68-1.25-7.02-2.38-.49-.23-.99-.37-1.47-.64-1.3-.71-2.54-1.52-3.74-2.37-.35-.25-.68-.51-1.01-.77-.86-.66-1.68-1.36-2.46-2.08-2.71-2.53-4.86-5.44-6.18-8.58v-.02c-.41-.99-.88-2.67-1.14-3.71l-.04-.16c-.23-1.28-.36-2.58-.28-3.91s0-.02 0-.03c0-.02.01-.04.01-.07 0-.03.02-.07.02-.1.11-1.41.38-2.84.89-4.27.52-1.48 1.26-2.97 2.25-4.46-3.83-3.77-7.44-8.11-10.82-12.78-.67-.91-1.35-1.83-1.99-2.76-.32-.48-.63-.97-.95-1.45-.92-1.4-1.82-2.8-2.67-4.23-1.98-3.27-3.81-6.67-5.53-10.15-.16-.32-.31-.63-.47-.95-1.7-3.51-3.27-7.07-4.67-10.7-.1-.25-.21-.47-.31-.73-1.03-2.52-2.32-6.21-3.47-10.73-.2-.75-.38-1.5-.56-2.26v-.02c-.12-.54-.24-1.1-.35-1.66-2.87-13.2-2.63-26.27.28-38.46 0-.04.02-.08.03-.12a89.26 89.26 0 0 1 1.63-5.87c.05-.16.1-.31.16-.47.73-2.25 1.56-4.46 2.47-6.64s.03-.08.05-.12c1.5-3.55 3.22-6.99 5.18-10.29.02-.04.05-.07.07-.11 1.94-3.25 4.07-6.38 6.43-9.35.1-.13.18-.26.28-.39.54-.68 1.25-1.43 1.85-2.14.58-.67 1.13-1.35 1.73-1.99.92-1.01 1.95-2.02 2.99-3.05.63-.62 1.27-1.24 1.92-1.85 1.04-.96 2.12-1.91 3.27-2.86.24-.2.47-.42.71-.62.45-.37.9-.66 1.35-1.01 1.38-1.08 2.76-2.15 4.26-3.19 2.27-1.58 4.54-3.03 6.78-4.31 1.65-.92 3.34-1.8 5.1-2.62.84-.4 1.67-.76 2.5-1.12h.02s.02-.02.03-.02c.5-.21 1.01-.41 1.51-.62 1.88-.77 3.74-1.44 5.59-2.03s0 0 .01 0c.31-.1.61-.2.92-.29h.01a71.54 71.54 0 0 1 5.39-1.41h.03c1.75-.38 3.47-.7 5.17-.94.07 0 .13-.02.2-.03 1.66-.23 3.3-.41 4.91-.53.1 0 .19-.01.28-.02 1.62-.11 3.21-.17 4.77-.18h.22c2.12 0 4.18.08 6.18.25.25.02.49.03.74.05 2.71.25 5.28.63 7.73 1.1.15.03.3.06.46.09 2.42.48 4.71 1.02 6.84 1.62l.21.06c1.73.49 3.36 1 4.87 1.52.08.02.15.05.23.07 1.34.46 2.62.92 3.77 1.37l.11.04c-27.53-17.76-77.17-11.4-104.28 19.49Z",
                            className: "octopus_svg__cls-10",
                            style: {
                                fill: 'currentColor',
                                strokeWidth: 0
                            }
                        })
                    ]
                })
            })
        ]
    });
var $85b17b826eab10ce$export$2e2bcd8739ae039 = $85b17b826eab10ce$var$SvgOctopus;



parcelRequire("7fPBF");
const $4262604d9c082a54$var$SvgOffice365 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M31.547 2a1 1 0 0 0-.283.055l-25.59 8.799A1 1 0 0 0 5 11.8v26.398a1 1 0 0 0 .006.1 1 1 0 0 0 0 .002 1 1 0 0 0 .039.193 1 1 0 0 0 0 .002 1 1 0 0 0 .078.184 1 1 0 0 0 .18.236 1 1 0 0 0 .076.066 1 1 0 0 0 .168.11 1 1 0 0 0 .09.04 1 1 0 0 0 .002 0 1 1 0 0 0 .035.014l25.59 8.8a1 1 0 0 0 .582.02l12.412-3.3a1 1 0 0 0 .742-.967V6.301a1 1 0 0 0-.742-.967l-12.412-3.3a1 1 0 0 0-.3-.034zm.078 2.045L43 7.068v35.864l-11.375 3.023-15.871-5.459 15.115 1.996A1 1 0 0 0 32 41.5V9.6a1 1 0 0 0-1.201-.979l-16 3.299a1 1 0 0 0-.799.98v21.301L7 36.77V12.514l24.625-8.47zM30 10.828V40.36L10.158 37.74l5.186-1.9A1 1 0 0 0 16 34.9V13.715l14-2.887z"
        })
    });
var $4262604d9c082a54$export$2e2bcd8739ae039 = $4262604d9c082a54$var$SvgOffice365;



parcelRequire("7fPBF");
const $97f91bf195707c03$var$SvgOpenCloseMouth = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#FBFDFE",
                d: "m64.11 77.485-2.385 1.81A20.462 20.462 0 0 1 50 83.448a20.462 20.462 0 0 1-11.726-4.153l-2.384-1.81A29.356 29.356 0 0 1 24.662 58.81l-2.65-16.31c-.42-2.585-.603-5.244.183-7.742 2.526-8.019 10.747-19.107 27.159-19.107 17.584 0 25.917 11.088 28.45 19.107.79 2.497.603 5.157.183 7.742l-2.65 16.31a29.356 29.356 0 0 1-11.228 18.675Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M49.354 17.302c-15.5 0-23.211 10.42-25.584 17.953-.668 2.12-.537 4.464-.128 6.98l2.65 16.31A27.705 27.705 0 0 0 36.888 76.17l2.384 1.81A18.81 18.81 0 0 0 50 81.796a18.81 18.81 0 0 0 10.727-3.816l2.384-1.81a27.705 27.705 0 0 0 10.596-17.625l2.65-16.31c.41-2.517.542-4.861-.127-6.98-2.363-7.48-10.157-17.953-26.876-17.953Zm1.772 67.736a22.113 22.113 0 0 0 11.597-4.428l2.385-1.81a31.007 31.007 0 0 0 11.858-19.725l2.65-16.31c.432-2.653.671-5.628-.237-8.504C76.676 25.703 67.803 14 49.354 14 32.03 14 23.299 25.757 20.62 34.262c-.905 2.876-.669 5.849-.238 8.502l2.65 16.311A31.007 31.007 0 0 0 34.893 78.8l2.384 1.81c3.373 2.56 7.4 4.091 11.597 4.428.152.047.314.072.48.072.216 0 .432-.004.646-.01.215.006.43.01.646.01.167 0 .329-.025.48-.072Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "M44.485 65.156c-1.396.837-1.885 1.764-1.885 2.476s.49 1.638 1.885 2.476c1.362.817 3.351 1.376 5.637 1.376 2.285 0 4.274-.559 5.636-1.376 1.396-.838 1.886-1.764 1.886-2.476s-.49-1.639-1.886-2.476c-1.362-.818-3.351-1.377-5.636-1.377-2.286 0-4.275.56-5.637 1.377Zm-1.7-2.832c1.958-1.174 4.556-1.847 7.337-1.847 2.78 0 5.378.673 7.336 1.847 1.924 1.155 3.488 2.98 3.488 5.308s-1.564 4.153-3.488 5.307c-1.958 1.175-4.555 1.848-7.336 1.848-2.781 0-5.379-.673-7.336-1.848-1.925-1.154-3.489-2.98-3.489-5.307 0-2.328 1.564-4.153 3.489-5.308Z",
                clipRule: "evenodd"
            })
        ]
    });
var $97f91bf195707c03$export$2e2bcd8739ae039 = $97f91bf195707c03$var$SvgOpenCloseMouth;



parcelRequire("7fPBF");
const $6e649c234c8975d4$var$SvgPandoraApp = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10 6a1 1 0 0 0-1 1v36a1 1 0 0 0 1 1h8c1.645 0 3-1.355 3-3v-6h6.12c7.78 0 14.497-5.991 14.864-13.8C42.376 12.89 35.728 6 27.5 6H10zm1 2h16.5a12.483 12.483 0 0 1 12.486 13.105C39.67 27.818 33.876 33 27.12 33H20a1 1 0 0 0-1 1v7c0 .565-.435 1-1 1h-7V8z"
        })
    });
var $6e649c234c8975d4$export$2e2bcd8739ae039 = $6e649c234c8975d4$var$SvgPandoraApp;



parcelRequire("7fPBF");
const $6efa39f11e16b5aa$var$SvgPaypal = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11.438 2c-1.051 0-1.934.762-2.157 1.719v.031S3.406 30.715 2.25 36.094v.031c-.172.86 0 1.691.5 2.219.5.527 1.133.656 1.656.656h8.563c-.27 1.219-.57 2.559-.781 3.531-.192.88-.356 1.594-.47 2.125-.113.532-.155.774-.187.938-.082.433-.062.93.281 1.468.344.54 1.098.938 1.938.938h8.938c1.074 0 1.933-.75 2.156-1.75 0 0 .535-2.41 1.062-4.844.262-1.218.512-2.426.719-3.375.207-.949.375-1.687.375-1.687.05-.215.094-.309.094-.313 0-.004-.098-.031.187-.031h5.125C39.79 36 46 31.555 47.656 23.813c.934-4.38-.183-7.711-2.312-9.813-1.88-1.855-4.461-2.738-6.938-2.937-.297-2.973-1.71-5.293-3.625-6.782C32.77 2.72 30.277 2 27.906 2Zm0 2h16.468c1.953 0 4.051.625 5.657 1.875 1.464 1.14 2.449 2.836 2.75 5.125H20.937c-.261 0-.55-.031-1 .094-.449.125-1 .648-1.125 1.187l-3.25 14.625v.063L13.313 37H4.406c-.152 0-.226-.04-.218-.031.007.008-.032-.07.03-.438.005-.027-.007 0 0-.031 1.16-5.39 7.02-32.262 7.032-32.312v-.032c.031-.101.09-.156.188-.156Zm9.25 9c.085-.004.082 0 .25 0h15.468a14.977 14.977 0 0 1-.312 2.188c-.742 3.476-2.246 5.851-4.438 7.437C29.465 24.211 26.52 25 22.938 25H18.53c-.152 0-.34.043-.531.063Zm17.625.156c2.066.184 4.18.856 5.624 2.281 1.653 1.633 2.579 4.086 1.75 7.97C44.208 30.32 39.017 34 32.408 34H27.28c-.746 0-1.398.332-1.75.781-.351.45-.43.926-.468 1.094-.047.191-.168.77-.375 1.719-.208.949-.489 2.187-.75 3.406-.528 2.434-1.032 4.813-1.032 4.813-.02.082-.183.187-.218.187H13.75c-.168 0-.227-.023-.25-.031l.188-.875c.113-.532.277-1.278.468-2.157.38-1.761.875-4.07 1.375-6.374 1-4.61 2-9.188 2-9.188.047-.145.082-.18.25-.25.188-.078.508-.125.75-.125h4.407c3.878 0 7.253-.855 9.875-2.75 2.62-1.895 4.425-4.805 5.25-8.656.187-.88.199-1.649.25-2.438Z"
        })
    });
var $6efa39f11e16b5aa$export$2e2bcd8739ae039 = $6efa39f11e16b5aa$var$SvgPaypal;



const $2f65eb00043ec877$var$SvgPersonalLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 1200,
        height: 627,
        viewBox: "0 0 900 470.25",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "personalLogoTransparent_svg__a",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "personalLogoTransparent_svg__b",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "personalLogoTransparent_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M.715 88.734H899.28V380.77H.715Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "personalLogoTransparent_svg__d",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            filter: "url(#personalLogoTransparent_svg__a)",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                filter: "url(#personalLogoTransparent_svg__b)",
                                transform: "matrix(.97644 0 0 .97594 -38.322 87.774)",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                    xlinkHref: "data:image/png;base64,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",
                                    width: 1000,
                                    height: 300
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#personalLogoTransparent_svg__c)",
                mask: "url(#personalLogoTransparent_svg__d)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                    xlinkHref: "data:image/png;base64,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",
                    width: 1000,
                    height: 300,
                    transform: "matrix(.97644 0 0 .97594 -38.322 87.774)"
                })
            })
        ]
    });
var $2f65eb00043ec877$export$2e2bcd8739ae039 = $2f65eb00043ec877$var$SvgPersonalLogo;



const $710403c951aed9ee$var$SvgPersonalLogoWhite = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 1200,
        height: 627,
        viewBox: "0 0 900 470.25",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "personalLogoWhite_svg__a",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "personalLogoWhite_svg__b",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "personalLogoWhite_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M.715 89H899.28v291.77H.715Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "personalLogoWhite_svg__d",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            filter: "url(#personalLogoWhite_svg__a)",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                filter: "url(#personalLogoWhite_svg__b)",
                                transform: "matrix(.97345 0 0 .97345 -48.056 88.733)",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                    xlinkHref: "data:image/png;base64,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",
                                    width: 1000,
                                    height: 300
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#personalLogoWhite_svg__c)",
                mask: "url(#personalLogoWhite_svg__d)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                    xlinkHref: "data:image/png;base64,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",
                    width: 1000,
                    height: 300,
                    transform: "matrix(.97345 0 0 .97345 -48.056 88.733)"
                })
            })
        ]
    });
var $710403c951aed9ee$export$2e2bcd8739ae039 = $710403c951aed9ee$var$SvgPersonalLogoWhite;



parcelRequire("7fPBF");
const $dc51cba71cb43570$var$SvgPlaystation = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M18.813 4A1 1 0 0 0 18 5v21l-2.844 1.063-9.281 3.28-.031.032-1.594.594a.466.466 0 0 0-.062.031C1.59 32.191 0 33.82 0 35.688c0 1.484.438 2.835 1.313 3.843s2.136 1.657 3.656 1.969c3.035.625 7.148.031 12.343-1.75.215-.07.38-.14.688-.25v2.094c-.004.449.29.843.719.968l7.718 2.313a.879.879 0 0 0 .094.031c.09.047.184.078.282.094.093.012.187.012.28 0h.032c.074-.012.148-.035.219-.062.043-.008.086-.02.125-.032l.031-.031 6.125-2.125 10.813-3.812c.03-.008.062-.02.093-.032l1.219-.562c.027-.012.035-.02.063-.032 1.32-.511 2.332-1.05 3.062-1.718.746-.684 1.2-1.614 1.125-2.563-.082-.96-.684-1.773-1.5-2.375-.816-.601-1.875-1.078-3.187-1.5-3.036-1.047-6.043-1.355-8.75-1.25-2.56.102-5.239.5-7.907 1.313l-.062.031-.594.156V13.531c.578.317 1 .82 1 1.469v11.094c-.004.336.16.652.438.843 0 0 .457.305 1.218.563.762.258 1.883.5 3.344.5 2.71 0 4.426-1.645 5.188-3.469.761-1.824.812-3.836.812-5.125 0-6.086-3.68-10.25-8.719-11.75l-12-3.625A1.012 1.012 0 0 0 18.906 4h-.093ZM20 6.344l10.719 3.218C35.079 10.864 38 14.095 38 19.407c0 1.211-.094 2.992-.656 4.344C36.78 25.102 35.988 26 34 26c-1.238 0-2.121-.215-2.687-.406-.235-.078-.196-.07-.313-.125V15c0-1.629-1.094-2.96-2.531-3.5-.016-.004-.016-.027-.032-.031-1.175-.446-2.437.465-2.437 1.719v18.374a1.024 1.024 0 0 0 0 .22v4.624a1.016 1.016 0 0 0 0 .407v2.437a1.025 1.025 0 0 0 0 .594v2.812l-6-1.781v-2.531a1.025 1.025 0 0 0 0-.594v-3.187a1.014 1.014 0 0 0 0-.813v-2.062a1.01 1.01 0 0 0 0-.875v-4a1.048 1.048 0 0 0 0-.313Zm-2 21.781v2.469c-.473.164-1.398.5-2.875 1.031-.906.324-1.82.676-2.562.938-.743.261-1.376.449-1.438.468a.466.466 0 0 0-.062.032c-1.434.53-2.356 1.054-2.938 1.656-.293.3-.535.64-.594 1.125-.043.36.254.676.5.968l-.125.094s.172.149.282.25c.085.078.101.117.218.188.27.168.653.316 1.156.406 1 .176 2.465.059 4.657-.719.011-.004.02.004.031 0 1.262-.441 2.664-.96 3.75-1.375v1.719c-.457.16-.934.344-1.312.469-5.008 1.718-8.899 2.187-11.313 1.687-1.207-.25-2.031-.703-2.562-1.312C2.28 37.609 2 36.8 2 35.687c0-.535.828-1.867 3.031-2.874l1.5-.563h.032l9.28-3.312Zm18.625 2.781c2.496-.097 5.297.172 8.063 1.125v.032c1.187.378 2.09.789 2.624 1.187.536.398.668.7.688.938.027.351-.04.542-.469.937-.43.395-1.261.867-2.5 1.344a.466.466 0 0 0-.062.031l-1.188.563-.093.03-10.72 3.75L28 42.594v-2.406c.984-.355 9.043-3.273 10.844-3.937 1.511-.555 2.453-.937 3.093-1.281.32-.172.57-.324.813-.594.242-.27.414-.812.313-1.219a1.028 1.028 0 0 0-.126-.312c-.312-.469-1-.785-1.75-.938l.032-.062s-.137-.02-.188-.032c-.097-.023-.18-.046-.375-.062a7.132 7.132 0 0 0-1.25.031c-1.14.11-2.922.457-5.625 1.375a384.404 384.404 0 0 0-5.781 2V32.47l1.156-.313h.032a29.21 29.21 0 0 1 7.437-1.25ZM18 32.75v.781c-.79.301-2.816 1.059-4.437 1.625-1.797.64-2.81.688-3.407.625.34-.238.668-.484 1.531-.812.036-.012.028-.02.063-.032a33.14 33.14 0 0 0 1.469-.5c.75-.261 1.687-.582 2.594-.906 1.12-.402 1.523-.539 2.187-.781Zm21.594 1.031c-.473.192-.684.317-1.438.594-1.668.613-8.379 3.043-10.156 3.688v-.75c.621-.231 2.188-.817 6.406-2.25 2.598-.883 4.254-1.192 5.188-1.282Z"
        })
    });
var $dc51cba71cb43570$export$2e2bcd8739ae039 = $dc51cba71cb43570$var$SvgPlaystation;



parcelRequire("7fPBF");
const $4a9ffda3eb6c05e1$var$SvgPlaystore = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2c-4.066 0-7.437 3.066-7.937 7H8c-.55 0-1 .45-1 1v37c0 .55.45 1 1 1h34.094A.996.996 0 0 0 43 47V10c0-.55-.45-1-1-1h-9.062c-.5-3.934-3.872-7-7.938-7Zm0 2a5.97 5.97 0 0 1 5.906 5H19.094A5.97 5.97 0 0 1 25 4ZM9 11h8v2.281c-.598.348-1 .98-1 1.719a1.999 1.999 0 1 0 4 0c0-.738-.402-1.371-1-1.719V11h12v2.281c-.598.348-1 .98-1 1.719a1.999 1.999 0 1 0 4 0c0-.738-.402-1.371-1-1.719V11h8v35H9Zm10.844 11A.998.998 0 0 0 19 23v14a.997.997 0 0 0 .496.871.993.993 0 0 0 1.004.004l12-7c.316-.176.516-.512.516-.875s-.2-.7-.516-.875l-12-7a.99.99 0 0 0-.656-.125ZM21 24.75 30 30l-9 5.25Z"
        })
    });
var $4a9ffda3eb6c05e1$export$2e2bcd8739ae039 = $4a9ffda3eb6c05e1$var$SvgPlaystore;



parcelRequire("7fPBF");
const $b0f91621c24890df$var$SvgCephLogoPlusSvg = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 150,
        height: 50,
        viewBox: "0 0 112.5 37.5",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "ceph_logo_plus_svg_svg__a",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M23.945 2h87.567v33.559H23.945Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "ceph_logo_plus_svg_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M.492 6H26v25H.492Zm0 0"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#ceph_logo_plus_svg_svg__a)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    mask: "url(#ceph_logo_plus_svg_svg__b)",
                    transform: "matrix(.18873 0 0 .18915 -.627 1.514)",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                            xlinkHref: "data:image/png;base64,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",
                            width: 600,
                            height: 180
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                            id: "ceph_logo_plus_svg_svg__b",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                xlinkHref: "data:image/png;base64,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",
                                width: 600,
                                height: 180
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#ceph_logo_plus_svg_svg__c)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    mask: "url(#ceph_logo_plus_svg_svg__d)",
                    transform: "matrix(.12952 0 0 .12952 .493 5.57)",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                            xlinkHref: "data:image/png;base64,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",
                            width: 200,
                            height: 200
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                            id: "ceph_logo_plus_svg_svg__d",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                xlinkHref: "data:image/png;base64,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",
                                width: 200,
                                height: 200
                            })
                        })
                    ]
                })
            })
        ]
    });
var $b0f91621c24890df$export$2e2bcd8739ae039 = $b0f91621c24890df$var$SvgCephLogoPlusSvg;



const $a4996e3fa9df448c$var$SvgCephLogoPlusWhite = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 150,
        height: 50,
        viewBox: "0 0 112.5 37.5",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                    id: "ceph_logo_plus_white_svg__a",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        d: "M.492.324h111.02V36.59H.492Zm0 0"
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#ceph_logo_plus_white_svg__a)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    mask: "url(#ceph_logo_plus_white_svg__b)",
                    transform: "matrix(.1734 0 0 .1727 -4.592 .325)",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                            xlinkHref: "data:image/png;base64,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",
                            width: 700,
                            height: 210
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                            id: "ceph_logo_plus_white_svg__b",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                xlinkHref: "data:image/png;base64,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",
                                width: 700,
                                height: 210
                            })
                        })
                    ]
                })
            })
        ]
    });
var $a4996e3fa9df448c$export$2e2bcd8739ae039 = $a4996e3fa9df448c$var$SvgCephLogoPlusWhite;



parcelRequire("7fPBF");
const $67599b84b2002306$var$SvgPowerBi = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M8 7c-3.31 0-6 2.69-6 6v20a5.99 5.99 0 0 0 5 5.91v-2.04A3.99 3.99 0 0 1 4 33V13c0-2.21 1.79-4 4-4h33c2.21 0 4 1.79 4 4v20a3.99 3.99 0 0 1-3 3.87v2.04c2.84-.47 5-2.94 5-5.91V13c0-3.31-2.69-6-6-6H8zm28.5 8a2.5 2.5 0 0 0-2.5 2.5v24a2.5 2.5 0 1 0 5 0v-24a2.5 2.5 0 0 0-2.5-2.5zm-16 6a2.5 2.5 0 0 0-2.5 2.5v18a2.5 2.5 0 1 0 5 0v-18a2.5 2.5 0 0 0-2.5-2.5zm8 4a2.5 2.5 0 0 0-2.5 2.5v14a2.5 2.5 0 1 0 5 0v-14a2.5 2.5 0 0 0-2.5-2.5zm-16 5a2.5 2.5 0 0 0-2.5 2.5v9a2.5 2.5 0 1 0 5 0v-9a2.5 2.5 0 0 0-2.5-2.5z"
        })
    });
var $67599b84b2002306$export$2e2bcd8739ae039 = $67599b84b2002306$var$SvgPowerBi;



parcelRequire("7fPBF");
const $cef83b92ad455ae8$var$SvgPreferences = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 7c-1.852 0-3.406 1.285-3.855 3H3a1.006 1.006 0 0 0-.879.496 1.01 1.01 0 0 0 0 1.008c.184.312.52.5.879.496h18.145c.449 1.715 2.003 3 3.855 3 1.852 0 3.406-1.285 3.855-3H47c.36.004.695-.184.879-.496a1.01 1.01 0 0 0 0-1.008c-.184-.312-.52-.5-.879-.496H28.855C28.406 8.285 26.852 7 25 7Zm0 2c1.086 0 1.941.836 1.988 1.91a1.44 1.44 0 0 0 0 .184A1.975 1.975 0 0 1 25 13a1.976 1.976 0 0 1-1.988-1.91 1.44 1.44 0 0 0 0-.184A1.975 1.975 0 0 1 25 9Zm14 12c-1.852 0-3.406 1.285-3.855 3H3a1.006 1.006 0 0 0-.879.496 1.01 1.01 0 0 0 0 1.008c.184.312.52.5.879.496h32.145c.449 1.715 2.003 3 3.855 3 1.852 0 3.406-1.285 3.855-3H47c.36.004.695-.184.879-.496a1.01 1.01 0 0 0 0-1.008c-.184-.312-.52-.5-.879-.496h-4.145c-.449-1.715-2.003-3-3.855-3Zm0 2c1.086 0 1.941.836 1.988 1.91a1.44 1.44 0 0 0 0 .184A1.975 1.975 0 0 1 39 27a1.976 1.976 0 0 1-1.988-1.91 1.44 1.44 0 0 0 0-.184A1.975 1.975 0 0 1 39 23ZM14 35c-1.852 0-3.406 1.285-3.855 3H3a1.006 1.006 0 0 0-.879.496 1.01 1.01 0 0 0 0 1.008c.184.312.52.5.879.496h7.145c.449 1.715 2.003 3 3.855 3 1.852 0 3.406-1.285 3.855-3H47c.36.004.695-.184.879-.496a1.01 1.01 0 0 0 0-1.008c-.184-.312-.52-.5-.879-.496H17.855c-.449-1.715-2.003-3-3.855-3Zm0 2c1.086 0 1.941.836 1.988 1.91a1.44 1.44 0 0 0 0 .184A1.975 1.975 0 0 1 14 41a1.976 1.976 0 0 1-1.988-1.91 1.44 1.44 0 0 0 0-.184A1.975 1.975 0 0 1 14 37Z"
        })
    });
var $cef83b92ad455ae8$export$2e2bcd8739ae039 = $cef83b92ad455ae8$var$SvgPreferences;



const $24f5c501f2475f6f$var$SvgProLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 1200,
        height: 627,
        viewBox: "0 0 900 470.25",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "proLogoTransparent_svg__a",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "proLogoTransparent_svg__b",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "proLogoTransparent_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M13.668 119.082h885.613v259.086H13.668Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "proLogoTransparent_svg__d",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            filter: "url(#proLogoTransparent_svg__a)",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                filter: "url(#proLogoTransparent_svg__b)",
                                transform: "matrix(.98767 0 0 .98842 -45.894 86.29)",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                    xlinkHref: "data:image/png;base64,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",
                                    width: 1000,
                                    height: 300
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#proLogoTransparent_svg__c)",
                mask: "url(#proLogoTransparent_svg__d)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                    xlinkHref: "data:image/png;base64,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",
                    width: 1000,
                    height: 300,
                    transform: "matrix(.98767 0 0 .98842 -45.894 86.29)"
                })
            })
        ]
    });
var $24f5c501f2475f6f$export$2e2bcd8739ae039 = $24f5c501f2475f6f$var$SvgProLogo;



const $15669c683dd043b1$var$SvgProLogoWhite = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 1200,
        height: 627,
        viewBox: "0 0 900 470.25",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "proLogoWhite_svg__a",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "proLogoWhite_svg__b",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "proLogoWhite_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M.715 89H899.28v291.77H.715Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "proLogoWhite_svg__d",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            filter: "url(#proLogoWhite_svg__a)",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                filter: "url(#proLogoWhite_svg__b)",
                                transform: "matrix(.97794 0 0 .97844 -48.056 88.733)",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                    xlinkHref: "data:image/png;base64,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",
                                    width: 1000,
                                    height: 300
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#proLogoWhite_svg__c)",
                mask: "url(#proLogoWhite_svg__d)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                    xlinkHref: "data:image/png;base64,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",
                    width: 1000,
                    height: 300,
                    transform: "matrix(.97794 0 0 .97844 -48.056 88.733)"
                })
            })
        ]
    });
var $15669c683dd043b1$export$2e2bcd8739ae039 = $15669c683dd043b1$var$SvgProLogoWhite;



parcelRequire("7fPBF");
const $7efcdfa101ef1389$var$SvgPs4 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M1 19a1 1 0 1 0 0 2h11.5c.84 0 1.5.66 1.5 1.5s-.66 1.5-1.5 1.5H3c-1.645 0-3 1.355-3 3v3a1 1 0 1 0 2 0v-3c0-.565.435-1 1-1h9.5c1.785 0 3.22-1.381 3.422-3.115A1 1 0 0 0 16 22.5c0-1.921-1.579-3.5-3.5-3.5H1zm25 0c-1.645 0-3 1.355-3 3v6c0 .565-.435 1-1 1h-6a1 1 0 1 0 0 2h6c1.645 0 3-1.355 3-3v-6c0-.565.435-1 1-1h6a1 1 0 1 0 0-2h-6zm20.97 0a1 1 0 0 0-.466.13l-14 8A1 1 0 0 0 33 29h13v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1v-7a1 1 0 0 0-1.03-1zM46 21.725V27h-9.232L46 21.725z"
        })
    });
var $7efcdfa101ef1389$export$2e2bcd8739ae039 = $7efcdfa101ef1389$var$SvgPs4;



const $3ddc512c8843c2cb$var$SvgReactNative = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M69.11 7.969c-1.56-.053-3.192.22-4.829.75-3.273 1.06-6.703 3.129-10.222 5.992-1.38 1.122-2.772 2.405-4.168 3.766-1.366-1.327-2.73-2.579-4.078-3.676-3.518-2.861-6.938-4.926-10.204-5.985-3.265-1.058-6.515-1.091-9.183.45s-4.265 4.369-4.98 7.726c-.717 3.358-.642 7.356.077 11.832.25 1.555.61 3.186 1.016 4.848-1.525.462-3.006.948-4.379 1.484-4.144 1.619-7.573 3.555-10.07 5.86-2.497 2.304-4.11 5.1-4.11 8.172 0 3.07 1.613 5.863 4.11 8.167 2.497 2.305 5.926 4.245 10.07 5.864 1.468.573 3.058 1.09 4.7 1.578-.59 2.206-1.07 4.346-1.395 6.375-.72 4.48-.796 8.478-.078 11.844.717 3.365 2.314 6.21 4.996 7.757 2.682 1.549 5.945 1.51 9.219.45s6.699-3.126 10.218-5.989c1.367-1.111 2.75-2.38 4.133-3.726 1.39 1.354 2.78 2.63 4.152 3.746 3.518 2.86 6.942 4.926 10.208 5.984 3.265 1.059 6.51 1.092 9.18-.449 2.668-1.54 4.264-4.369 4.98-7.727.716-3.357.637-7.355-.082-11.831-.327-2.035-.806-4.179-1.399-6.391 1.695-.5 3.335-1.03 4.848-1.621 4.144-1.619 7.573-3.56 10.07-5.864s4.11-5.097 4.11-8.167c0-3.071-1.613-5.868-4.11-8.172s-5.926-4.241-10.07-5.86c-1.393-.544-2.897-1.036-4.446-1.504.41-1.672.773-3.314 1.024-4.879.72-4.48.796-8.482.078-11.847-.717-3.365-2.318-6.206-5-7.754-1.34-.774-2.827-1.15-4.387-1.203m-.184 4.07c.978.027 1.813.26 2.527.672 1.428.824 2.484 2.43 3.047 5.07s.544 6.21-.121 10.348c-.228 1.417-.558 2.918-.934 4.457-4.09-.984-8.571-1.715-13.347-2.145-2.4-3.324-4.866-6.348-7.352-9.035 1.314-1.283 2.62-2.483 3.895-3.52 3.251-2.644 6.33-4.444 8.898-5.277 1.284-.416 2.408-.597 3.387-.57m-37.953.012c.984-.028 2.11.152 3.398.57 2.576.835 5.66 2.634 8.914 5.281 1.249 1.016 2.526 2.19 3.813 3.442-2.504 2.707-4.988 5.763-7.403 9.117-4.759.437-9.224 1.175-13.297 2.164-.373-1.531-.699-3.027-.925-4.437-.666-4.142-.682-7.715-.117-10.364.564-2.649 1.628-4.261 3.07-5.094.72-.416 1.563-.652 2.547-.68m18.98 12.234a90 90 0 0 1 4.875 5.8A116 116 0 0 0 50 29.98c-1.665 0-3.303.041-4.922.11a90 90 0 0 1 4.875-5.805M50 34.02c2.72 0 5.37.111 7.95.3a114 114 0 0 1 5.16 8.114 114 114 0 0 1 3.96 7.504 114 114 0 0 1-4.015 7.605 114 114 0 0 1-4.024 6.43c-2.912.243-5.93.379-9.031.379-3.175 0-6.261-.144-9.238-.399a115 115 0 0 1-3.957-6.336 114 114 0 0 1-4.004-7.586 114 114 0 0 1 4.023-7.633 114 114 0 0 1 5.137-8.07A109 109 0 0 1 50 34.02m13.102.8c3.295.412 6.39.983 9.27 1.668a90 90 0 0 1-3.184 8.75c-.829-1.597-1.687-3.199-2.614-4.804a120 120 0 0 0-3.472-5.614m-26.414.032a120 120 0 0 0-3.399 5.504 121 121 0 0 0-2.652 4.867 90 90 0 0 1-3.16-8.7 86 86 0 0 1 9.21-1.672m39.64 2.699c1.418.429 2.787.876 4.043 1.367 3.82 1.492 6.842 3.259 8.8 5.066 1.96 1.808 2.81 3.531 2.81 5.203s-.85 3.396-2.81 5.204c-1.958 1.807-4.98 3.574-8.8 5.066-1.396.545-2.93 1.04-4.523 1.508-1.138-3.518-2.59-7.187-4.317-10.934 1.987-4.3 3.591-8.494 4.797-12.48m-52.723.02c1.193 3.945 2.777 8.097 4.735 12.355-1.74 3.768-3.198 7.459-4.34 10.996-1.538-.456-3.02-.937-4.371-1.465-3.82-1.492-6.842-3.259-8.8-5.066-1.96-1.808-2.81-3.531-2.81-5.203s.85-3.396 2.81-5.204c1.958-1.807 4.98-3.574 8.8-5.066 1.236-.483 2.583-.924 3.976-1.348M50 40c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10m0 4c3.337 0 6 2.663 6 6s-2.663 6-6 6a5.97 5.97 0 0 1-6-6c0-3.337 2.663-6 6-6m19.238 10.727a93 93 0 0 1 2.727 7.254 86 86 0 0 1-7.66 1.398 122 122 0 0 0 2.289-3.793 121 121 0 0 0 2.644-4.86m-38.554.004a121 121 0 0 0 2.66 4.886 122 122 0 0 0 2.258 3.75 86 86 0 0 1-7.637-1.402 93 93 0 0 1 2.719-7.235m-3.872 11.117c3.62.857 7.543 1.516 11.704 1.945 2.777 4.017 5.67 7.626 8.582 10.781-1.302 1.27-2.593 2.461-3.856 3.489-3.251 2.644-6.333 4.44-8.902 5.273s-4.486.723-5.914-.102c-1.428-.824-2.48-2.429-3.043-5.07s-.548-6.206.117-10.344c.302-1.877.752-3.887 1.313-5.972m46.31.015c.564 2.097 1.016 4.117 1.32 6.004.665 4.142.681 7.71.117 10.36-.565 2.648-1.626 4.265-3.067 5.097s-3.373.945-5.949.11c-2.576-.836-5.66-2.638-8.914-5.286-1.272-1.034-2.572-2.231-3.883-3.511 2.931-3.168 5.845-6.796 8.64-10.836 4.171-.427 8.106-1.081 11.735-1.938m-29.388 2.34c2.054.112 4.134.188 6.266.188 2.061 0 4.074-.071 6.063-.176a92 92 0 0 1-6.169 7.48 92 92 0 0 1-6.16-7.492"
        })
    });
var $3ddc512c8843c2cb$export$2e2bcd8739ae039 = $3ddc512c8843c2cb$var$SvgReactNative;



parcelRequire("7fPBF");
const $f16a8074acc9fc02$var$SvgReminders = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13 4c-4.959 0-9 4.041-9 9v24c0 4.959 4.041 9 9 9h24c4.959 0 9-4.041 9-9V13c0-4.959-4.041-9-9-9H13zm0 2h24c3.877 0 7 3.123 7 7v24c0 3.877-3.123 7-7 7H13c-3.877 0-7-3.123-7-7V13c0-3.877 3.123-7 7-7zm0 5c-1.292 0-2.323.502-2.998 1.262C9.327 13.022 9 14.014 9 15s.327 1.979 1.002 2.738C10.677 18.498 11.708 19 13 19c1.292 0 2.323-.502 2.998-1.262C16.673 16.978 17 15.986 17 15s-.327-1.979-1.002-2.738C15.323 11.502 14.292 11 13 11zm0 1c1.042 0 1.76.373 2.252.926.492.553.748 1.31.748 2.074 0 .764-.256 1.521-.748 2.074-.492.553-1.21.926-2.252.926-1.042 0-1.76-.373-2.252-.926C10.256 16.521 10 15.764 10 15c0-.764.256-1.521.748-2.074C11.24 12.373 11.958 12 13 12zm0 1a2 2 0 0 0 0 4 2 2 0 0 0 0-4zm8 1a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H21zm-8 7c-1.292 0-2.323.502-2.998 1.262C9.327 23.022 9 24.014 9 25s.327 1.979 1.002 2.738C10.677 28.498 11.708 29 13 29c1.292 0 2.323-.502 2.998-1.262C16.673 26.978 17 25.986 17 25s-.327-1.979-1.002-2.738C15.323 21.502 14.292 21 13 21zm0 1c1.042 0 1.76.373 2.252.926.492.553.748 1.31.748 2.074 0 .764-.256 1.521-.748 2.074-.492.553-1.21.926-2.252.926-1.042 0-1.76-.373-2.252-.926C10.256 26.521 10 25.764 10 25c0-.764.256-1.521.748-2.074C11.24 22.373 11.958 22 13 22zm0 1a2 2 0 0 0 0 4 2 2 0 0 0 0-4zm8 1a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H21zm-8 7c-1.292 0-2.323.502-2.998 1.262C9.327 33.022 9 34.014 9 35s.327 1.979 1.002 2.738C10.677 38.498 11.708 39 13 39c1.292 0 2.323-.502 2.998-1.262C16.673 36.978 17 35.986 17 35s-.327-1.979-1.002-2.738C15.323 31.502 14.292 31 13 31zm0 1c1.042 0 1.76.373 2.252.926.492.553.748 1.31.748 2.074 0 .764-.256 1.521-.748 2.074-.492.553-1.21.926-2.252.926-1.042 0-1.76-.373-2.252-.926C10.256 36.521 10 35.764 10 35c0-.764.256-1.521.748-2.074C11.24 32.373 11.958 32 13 32zm0 1a2 2 0 0 0 0 4 2 2 0 0 0 0-4zm8 1a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H21z"
        })
    });
var $f16a8074acc9fc02$export$2e2bcd8739ae039 = $f16a8074acc9fc02$var$SvgReminders;



parcelRequire("7fPBF");
const $fabb58c67223cc99$var$SvgRockstarGames = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M12 3c-4.959 0-9 4.041-9 9v26c0 4.959 4.041 9 9 9h26c4.959 0 9-4.041 9-9V12c0-4.959-4.041-9-9-9H12zm0 2h26c3.877 0 7 3.123 7 7v26c0 3.877-3.123 7-7 7H12c-3.877 0-7-3.123-7-7V12c0-3.877 3.123-7 7-7zm3.723 5a1 1 0 0 0-.977.79l-3.867 18a1 1 0 0 0 .976 1.21h4.27a1 1 0 0 0 .977-.785l1.37-6.217h2.067c.939 0 1.122.156 1.36.73.237.575.304 1.766.101 3.407a1 1 0 0 0 0 .002 5.454 5.454 0 0 0 .021 1.597c.002.011.006.017.008.028a1 1 0 0 0 .291.972l3.37 3.116-2.6 5.738a1 1 0 0 0 1.43 1.266l5.58-3.393 4.287 3.328a1 1 0 0 0 1.595-.98L34.9 33.25l4.694-3.47A1 1 0 0 0 39 27.974h-4.863l-.817-5.133a1 1 0 0 0-.976-.842 1 1 0 0 0-.887.514l-2.771 4.994c-.06-.584-.073-1.467.064-2.828.15-1.48.012-2.642-.176-3.448-.065-.278-.088-.257-.158-.457.31-.168.407-.123.777-.494.802-.801 1.593-2.177 1.746-4.263.167-2.257-.554-3.976-1.92-4.905C27.655 10.184 25.908 10 24 10h-8.277zm.808 2H24c1.75 0 3.126.246 3.893.768.766.521 1.187 1.275 1.052 3.103-.122 1.667-.683 2.514-1.166 2.996-.482.483-.816.56-.816.56a1 1 0 0 0-.604 1.442s.125.21.266.817c.14.605.262 1.537.135 2.79a1 1 0 0 0 0 .003c-.166 1.644-.131 2.713-.012 3.521h-2.76c-.01-.186-.038-.325-.002-.62.22-1.776.257-3.214-.24-4.415s-1.755-1.967-3.207-1.967h-2.87a1 1 0 0 0-.976.785L15.323 28h-2.23l3.438-16zm2.762 1.031a1 1 0 0 0-.98.805l-.981 4.937a1 1 0 0 0 .98 1.196h4.471c.785 0 1.651-.12 2.442-.576.79-.457 1.45-1.303 1.677-2.414.234-1.142-.071-2.219-.722-2.918-.651-.7-1.565-1.03-2.475-1.03h-4.412zm.82 2h3.592c.418 0 .794.16 1.01.39.215.232.355.53.226 1.157-.129.626-.364.879-.716 1.082-.353.204-.88.309-1.442.309H19.53l.584-2.938zM31.801 26.02l.496 3.113a1 1 0 0 0 .986.842h2.686l-2.764 2.043a1 1 0 0 0-.389.994l.694 3.564-2.727-2.117a1 1 0 0 0-1.133-.064l-3.404 2.07 1.563-3.445a1 1 0 0 0-.233-1.149L25.555 30H29a1 1 0 0 0 .875-.514l1.926-3.466z"
        })
    });
var $fabb58c67223cc99$export$2e2bcd8739ae039 = $fabb58c67223cc99$var$SvgRockstarGames;



parcelRequire("7fPBF");
const $7cb0e7963ddb95ec$var$SvgSafari = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 1.92C12.265 1.92 1.92 12.265 1.92 25c0 12.735 10.345 23.08 23.08 23.08 12.735 0 23.08-10.345 23.08-23.08C48.08 12.265 37.735 1.92 25 1.92zm0 2c11.654 0 21.08 9.426 21.08 21.08 0 11.654-9.426 21.08-21.08 21.08-11.654 0-21.08-9.426-21.08-21.08 0-.364.01-.726.027-1.086C4.511 12.766 13.71 3.92 25 3.92zM25 6C14.518 6 6 14.518 6 25s8.518 19 19 19 19-8.518 19-19S35.482 6 25 6zm0 2a16.92 16.92 0 0 1 11.26 4.28l-14.774 8.863a1 1 0 0 0-.343.343L12.279 36.26A16.92 16.92 0 0 1 8 25c0-9.4 7.6-17 17-17zm-.016.986A1 1 0 0 0 24 10v1a1 1 0 1 0 2 0v-1a1 1 0 0 0-1.016-1.014zm5.74 1.143a1 1 0 0 0-.908.63l-.382.925a1 1 0 1 0 1.847.765l.383-.924a1 1 0 0 0-.94-1.396zm-11.49.004a1 1 0 0 0-.908 1.396l.383.924a1 1 0 1 0 1.848-.767l-.385-.924a1 1 0 0 0-.938-.63zm-4.861 3.26a1 1 0 0 0-.695 1.718l.709.705a1 1 0 1 0 1.412-1.416l-.71-.705a1 1 0 0 0-.716-.302zm23.348.347A16.92 16.92 0 0 1 42 25c0 9.4-7.6 17-17 17a16.92 16.92 0 0 1-11.26-4.28l14.774-8.863a1 1 0 0 0 .343-.343l8.864-14.774zm-3.635 2.174L27.27 27.271l-11.357 6.815 6.815-11.357 11.357-6.815zm4.73 2.3a1 1 0 0 0-.359.083l-.924.385a1 1 0 1 0 .772 1.845l.922-.384a1 1 0 0 0-.41-1.928zm-27.681.042a1 1 0 0 0-.377 1.93l.924.382a1 1 0 1 0 .765-1.847l-.924-.383a1 1 0 0 0-.388-.082zM25 23a2 2 0 0 0-2 2 2 2 0 0 0 2 2 2 2 0 0 0 2-2 2 2 0 0 0-2-2zm-15 1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2h-1zm29 0a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2h-1zm-1.07 5.35a1 1 0 0 0-.377 1.93l.924.382a1 1 0 1 0 .765-1.848l-.924-.382a1 1 0 0 0-.388-.082zm-25.875.04a1 1 0 0 0-.36.083l-.922.384a1 1 0 1 0 .77 1.846l.924-.385a1 1 0 0 0-.412-1.927zm22.841 4.49a1 1 0 0 0-.695 1.72l.71.705a1 1 0 1 0 1.411-1.416l-.709-.705a1 1 0 0 0-.717-.303zm-4.542 3.036a1 1 0 0 0-.91 1.398l.384.924a1 1 0 1 0 1.846-.767l-.383-.924a1 1 0 0 0-.937-.631zm-10.729.006a1 1 0 0 0-.906.629l-.383.924a1 1 0 1 0 1.848.765l.382-.924a1 1 0 0 0-.941-1.394zm5.36 1.064A1 1 0 0 0 24 39v1a1 1 0 1 0 2 0v-1a1 1 0 0 0-1.016-1.014z"
        })
    });
var $7cb0e7963ddb95ec$export$2e2bcd8739ae039 = $7cb0e7963ddb95ec$var$SvgSafari;



parcelRequire("7fPBF");
const $566b6e2d6ce5c43b$var$SvgSanAndreas = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M32 5v1c-.286.039-.426.143-.66.238-.222-.092-.505-.238-.85-.238h-8.537c-.477 0-.893.077-1.252.21A3.567 3.567 0 0 0 19.45 6h-7.44C9.943 6 9 7.442 9 8.781V18h4v4.219c0 .585.176 1.183.535 1.68a2.725 2.725 0 0 0-.539.326c-.653.519-1.012 1.291-1.012 2.177v4.784c0 .26.047.522.118.779a14.058 14.058 0 0 1-.852-.297l-.494.59c-.266-.091-.533-.193-.799-.293a33.424 33.424 0 0 0-.912-.332l-1.549-.531s-2.041 3.728-2.154 4.003l-.045.108-.031.074-.026.078c-.109.335-.187.67-.234 1.002-.183.285-.33.593-.438.914a4.665 4.665 0 0 0-.3 1.592c0 .626.134 1.118.25 1.477l.017.054.022.055c.03.076.063.15.1.225l-.06.105A4.37 4.37 0 0 0 4 42.97c0 .777.247 1.457.752 2.08l.057.07.062.065A2.658 2.658 0 0 0 6.79 46c.383 0 .766-.08 1.139-.238.505-.194 1-.552 1.55-1.116l1.254.428.881-1.066c.154-.187.312-.381.469-.578l.068.082.963 1.15 1.366-1.398 1.119.574.416-.61.78.801 1.058-1.447 1.199.738.578-.761a2.123 2.123 0 0 0 .625-.047 2.123 2.123 0 0 0 .764-.307l1.252.772.501-.618 1.342 1.65.774-1.585.779.933 1.033-1.238 1.059.87 1.037-1.065 1.246 1.494 1.42-1.459 1.713 2.637 1.217-2.082c.068.083.13.154.19.215l1.567 1.609.752-.928.217.113.19.096.076.04 1.38.706.163-.183 1.261 1.295.168-.233.092-.125.707.727.348-.532 1.34 2.065 1.361-2.799h1.492v-5.506l-.347-.51a7.108 7.108 0 0 0-.149-.21l.018-.038c.104-.209.21-.42.314-.636l.037-.075.03-.076c.094-.24.2-.515.27-.799.012-.055.027-.134.042-.2.045-.204.092-.444.092-.74a3.834 3.834 0 0 0-.125-.913c-.018-.071-.03-.148-.05-.215l-.083-.252-.142-.22a2.836 2.836 0 0 0-.452-.542 2.43 2.43 0 0 0-.543-.382l-.43-.221h-.482c-.376 0-.73.092-1.039.264l-1.08-1.291-.666 1.365-.74-.762-.016-.014-.353.54-1.436-1.178-.51 1.05-.152-.078-.111.116-.924-1.707-1.254 1.287-.459-1.037c.02-.143.045-.286.045-.436l.018-4.33c0-.803-.343-1.635-1.045-2.186.422.216.932.352 1.55.352h2.504C40.07 25 41 23.558 41 22.219V15h-3V5h-6zm1.906 1.521H36V14h-3.55c-.674 0-1.009-.223-1.009-.744V8.79h-.002c0-.521.337-.781 1.01-.781h1.457V6.52zM12.01 8h3.476v7.256c0 .52-.336.744-1.01.744H11v-1.488h2.506V14H12.01c-.674 0-1.01-.223-1.01-.744V8.78c0-.52.337-.781 1.01-.781zm4.101 0H19.59c.673 0 1.01.26 1.01.781v1.6c0 .298-.188.52-.524.633.336.112.524.297.524.632v3.35l1.513.004v1.865l1.44-.006c.673 0 1.008.26 1.008.782V23l-1.963.006v-4.578h-.487v4.578L20.076 23v-6.516h-.486c-.224 0-.45-.036-.637-.185-.224-.15-.373-.336-.373-.559v-3.98h-.45v2.232h-2.019V8zm6.182.01h2.482c.677 0 1.018.26 1.018.781V14h-3.498c-.677 0-1.018-.223-1.018-.744v-2.233h-.002c0-.484.341-.744 1.018-.744h1.467v-.744h-.451v.371h-2.032V8.791c0-.521.339-.781 1.016-.781zm4.137 0h1.98v.408c.336-.26.821-.408 1.494-.408.224 0 .45.073.674.222.224.15.336.334.336.557V14h-2.02V9.535h-.484V14h-1.98V8.01zM13.02 9.525v2.987h.486V9.525h-.486zm5.113 0v.745h.447v-.745h-.447zm15.289.01v2.977h.486V9.535h-.486zm-10.115 2.233v.744h.45v-.744h-.45zm2.81 5.23h2.447c.621 0 .952.257.952.766v2.98h-2.412v.766h.474v-.365h1.938v1.091c0 .51-.33.764-.952.764h-2.447c-.658 0-.986-.255-.986-.764v-4.472c0-.51.33-.766.986-.766zM14.984 17h1.973v.4h2.41v1.49h-2.41v2.62h.475v-2.256h1.935v2.982c0 .51-.328.764-.949.764h-2.447c-.658 0-.987-.255-.987-.764v-3.345h-.474V17.4h.474V17zM31 17h2.668v1.527h-1.719v.364h1.719v1.492h-1.719V23h-1.935v-5.236c0-.473.329-.727.986-.764zm3.615 0h1.975v.4H39v1.49h-2.41v2.62h.474v-2.256H39v2.982c0 .51-.291.764-.95.764h-2.448c-.658 0-.987-.255-.987-.764v-3.345h-.474V17.4h.474V17zm-7.511 1.527v.727h.474v-.727h-.474zM14.939 26h2.348c.64 0 .961.255.961.764V32h-3.309c-.64 0-.96-.255-.96-.764V28.98c0-.473.32-.726.96-.726h1.424v-.764H15.9v.365H13.98v-1.091c0-.51.32-.764.96-.764zm3.795 0h1.885v4.346l-.014.008c-.173.069-.345.136-.51.232-.096.057-.186.132-.279.197-.142.101-.284.2-.416.322-.09.085-.172.186-.26.28-.09.099-.19.186-.275.295a.766.766 0 0 1-.13-.444V26zm2.352 0h1.883v4.215a3.523 3.523 0 0 0-.948-.145 3.67 3.67 0 0 0-.343.016h-.002c-.202.014-.395.064-.59.113V26zm2.945 0h1.885v.363h2.348v1.492h-2.348v1.846l-1.795.342-.09.021v-2.209h-.498v-1.492h.498V26zm5.625 0h2.383c.641 0 .961.255.961.764v4.472a.709.709 0 0 1-.174.487l-.299-.307-.498.584h-.851l-1.016-1.137-.596-.668h-.836v-3.431c0-.51.321-.764.926-.764zm.961 1.49v3.02h.461v-3.02h-.46zm-4.238.766h1.885v1.94h-1.67l-.07-.608-.145.025v-1.357zM15.9 29.744v.766h.461v-.766h-.46zm8.625 2.254v.04a1.824 1.824 0 0 0-.38.39 1.2 1.2 0 0 0-.19.625v4.918c0 .234.038.468.076.625.038.195.114.31.19.31.152-.039.304-.076.418-.232.038.078.077.115.115.154-.19.237-.343.434-.457.55-.304.39-.495.702-.61.936-.19-.234-.341-.429-.417-.664-.038-.117-.115-.35-.229-.78a11.31 11.31 0 0 0-.646.741c-.19.234-.382.508-.573.743-.19-.117-.494-.352-.95-.704-.343-.273-.532-.388-.608-.388-.114 0-.19.039-.229.117-.076.078-.113.194-.113.35 0 .078.036.156.074.234.038.078.04.156.04.234 0 .078-.002.196-.04.235-.038.078-.074.117-.15.117-.076.039-.154 0-.192-.117-.076-.078-.076-.196-.076-.352 0-.156.115-.548.381-1.133.076-.195.305-.702.686-1.482-.342-.468-.534-.703-.534-.781-.304-.43-.418-1.014-.418-1.756 0-.664.19-1.29.647-1.875.418-.625.95-.938 1.521-.977a1.63 1.63 0 0 1 1.067.274c.114.039.341.195.646.468.114-.312.304-.547.57-.703a1.52 1.52 0 0 1 .381-.117zm4.07.2h.077l1.254 1.404c.418.508.838.977 1.256 1.484 0-.04-.001-.117.037-.195s.038-.118.076-.157c.038-.078.113-.117.19-.195 0 .04.038.078.076.117a1.81 1.81 0 0 0-.114.35c-.038.156-.039.312-.039.508v3.982c-.114.04-.227.117-.379.195a1.323 1.323 0 0 0-.341.235c-.076.039-.152.115-.266.232-.114.078-.192.196-.268.274a6.14 6.14 0 0 0-.722-.703c-.114-.078-.227-.157-.38-.196a1.385 1.385 0 0 0-.417-.193v-.078l-.04-.04c.077-.077.116-.156.116-.195.076-.234.113-.468.113-.742V35.201c.038 0 .115-.039.229-.078a.284.284 0 0 0 .19-.076l.228-.117c.076-.078.112-.157.15-.235l-1.025-1.172v-1.326zm-6.962.78c-.38.04-.724.274-1.104.665-.342.468-.533.975-.533 1.482 0 .429.038.82.152 1.172.114.312.343.623.61.857.229-.392.42-.82.61-1.25.19-.39.38-.82.609-1.21-.076-.079-.116-.157-.192-.196-.038-.078-.112-.076-.226-.076-.266 0-.496.234-.686.664v-.156c0-.273.077-.548.229-.782.19-.234.38-.39.609-.39h.342c.114.039.188.078.302.078.076-.117.153-.274.229-.43-.076-.117-.228-.232-.418-.31a1.19 1.19 0 0 0-.533-.117zm-11.297.465a.822.822 0 0 1 .19.118c-.115.429-.267.899-.419 1.328-.152.468-.303.897-.455 1.365a.333.333 0 0 1 .19-.04c.038-.038.113-.038.19-.077.57-.117 1.027-.039 1.445.234.494.351.761.975.761 1.873 0 .547-.114 1.056-.304 1.64-.19.469-.456.976-.8 1.483-.303.43-.646.86-1.064 1.367-.114-.039-.229-.078-.38-.156-.153-.078-.228-.117-.266-.117a2.736 2.736 0 0 0-.533-.156c-.304.35-.57.664-.836.937-.342.351-.647.586-.875.664-.342.156-.647.117-.875-.117-.19-.234-.305-.468-.305-.82 0-.39.114-.82.342-1.21.228-.428.496-.702.762-.78.228-.078.418-.157.533-.157.114-.039.228-.039.418-.039.076-.273.113-.507.19-.742-.419.117-.725.195-.915.234-.152 0-.341-.039-.494-.078a.985.985 0 0 1-.418-.468 2.658 2.658 0 0 1-.152-.86c0-.312.075-.623.19-.935.113-.351.304-.626.495-.82 0-.39.076-.783.19-1.134.114-.273.267-.662.533-1.17.228-.467.494-.899.722-1.289.57.195 1.14.43 1.711.625l.229-.703zm12.44.198c-.229.507-.496 1.014-.762 1.56-.228.506-.494 1.055-.723 1.563.571-.04 1.142-.078 1.713-.078v-2.694l-.229-.351zm4.372.505c.228.273.456.548.647.86.152-.195.267-.352.38-.508a.539.539 0 0 0 .114.156c-.19.312-.305.508-.305.547-.076.117-.076.235-.076.39v3.319c0 .117.001.235.04.313 0 .078.037.117.113.117l.152-.078.113-.117c.038.078.115.117.153.195-.303.31-.57.623-.874.935a1.204 1.204 0 0 1-.418-.625c-.038-.117-.076-.193-.076-.31v-.664c0-.508-.037-.978-.037-1.485V35.67c-.114-.195-.266-.39-.418-.586-.19.234-.38.429-.57.664v1.639c0 .547.037 1.093.037 1.64.076.117.152.235.266.352-.266.312-.495.584-.723.857a7.259 7.259 0 0 1-.646-.857c.076-.117.151-.274.265-.39v-1.641c0-.507-.039-1.054-.039-1.6 0-.195.001-.313-.037-.43 0-.117-.076-.156-.152-.156-.038 0-.077.04-.153.078l-.037.04c-.038-.04-.075-.118-.113-.157.266-.351.533-.663.799-.975.152.156.265.312.379.547.038.156.115.35.115.545 0 .078.037.157.037.274.152-.156.266-.312.418-.508a1.49 1.49 0 0 0 .19-.235c.265-.39.418-.586.456-.625zm5.48.239c.077.078.152.156.19.234.038.04.076.118.114.274.076.078.114.193.152.35.038.155.037.273.037.39l.914-1.17c.19.429.419.819.61 1.248-.192.232-.422.465-.612.66a6.344 6.344 0 0 1-.494-.857c-.152.117-.266.232-.418.35v3.359c.152.156.266.35.418.547.114-.117.228-.196.342-.313.038.078.114.156.152.234l-.531.547c-.152.195-.306.351-.42.547-.076-.117-.152-.234-.266-.351-.114-.156-.226-.272-.302-.39-.114-.116-.19-.195-.229-.273-.076-.039-.151-.117-.265-.195a.92.92 0 0 0 .226-.351c.038-.117.04-.312.04-.586v-2.926a.509.509 0 0 0-.04-.234c0-.04-.037-.079-.113-.079-.038 0-.075.04-.113.079 0 .039-.039.039-.077.117a.858.858 0 0 0-.115-.196c.266-.35.535-.703.8-1.015zm-14.57.152c.229.234.456.508.647.781.152-.195.267-.35.38-.547.039.04.076.118.114.157-.19.35-.304.508-.304.547-.076.117-.077.271-.077.427V39.223c0 .156.04.232.04.31.037.078.075.117.113.117 0 0 .076-.039.152-.117l.113-.115.153.154c-.266.352-.57.743-.836 1.094-.19-.117-.341-.312-.455-.547-.038-.117-.039-.234-.077-.351v-.625c0-.508-.039-1.015-.039-1.522v-1.56c-.152-.156-.266-.351-.418-.547-.19.273-.379.507-.57.78v1.679c0 .547.037 1.093.037 1.68.076.077.154.195.268.312-.228.35-.497.662-.725.974-.228-.234-.417-.507-.646-.742.076-.156.19-.31.265-.467v-1.68c0-.546-.037-1.132-.037-1.679 0-.195 0-.31-.039-.428 0-.117-.074-.156-.15-.156-.038 0-.077.04-.153.078 0 .04-.039.04-.039.078-.038-.039-.075-.117-.113-.156.266-.35.532-.743.799-1.094.152.117.305.313.38.508.077.156.114.351.114.547 0 .078.037.156.037.273.152-.156.266-.35.418-.546.038-.04.116-.157.192-.274.266-.429.418-.625.457-.664zm18.145.158c.38.703.76 1.366 1.14 2.069l-.761.779a8.087 8.087 0 0 0-.76.86v1.404c.228.195.418.39.647.586l.57-.467c.038.078.076.154.152.271-.19.117-.264.196-.302.235a1.683 1.683 0 0 0-.268.234c-.228.234-.416.43-.607.664-.076-.078-.153-.195-.305-.351-.114-.117-.229-.235-.305-.274a1.087 1.087 0 0 0-.379-.232.822.822 0 0 0-.19-.118.306.306 0 0 1-.038-.156c.076-.117.151-.234.19-.351.037-.117.038-.312.038-.586V35.67l.38-.195a1.07 1.07 0 0 1 .19-.157c.115-.117.19-.156.227-.195 0 0 .115-.155.381-.428zM8.32 34.85c-.19.039-.342.156-.494.312-.19.234-.265.507-.265.82 0 .234.038.43.152.586.152.195.38.274.683.196.266-.078.419-.118.534-.157.114-.078.265-.156.455-.273.114-.312.19-.585.304-.898a1.897 1.897 0 0 0-.722-.467c-.265-.118-.457-.158-.647-.12zm21.569.078c-.114.118-.191.234-.305.351 0 .585.037 1.17.037 1.756v1.719c.152.117.342.234.533.351l.457.35v-3.67c-.228-.312-.494-.584-.722-.857zm-15.864.08c.38.195.761.35 1.141.547.076-.117.19-.235.266-.352.038 0 .077.04.115.04-.114.35-.23.546-.268.663-.038.195-.076.39-.076.586v3.24a.74.74 0 0 0 .076.274c.038.078.077.115.153.076a.081.081 0 0 0 .076-.076c.038 0 .039-.04.039-.078a.294.294 0 0 0 .15.154c-.265.388-.492.779-.758 1.17a1.018 1.018 0 0 1-.228-.195c-.038-.078-.114-.196-.152-.313-.114-.195-.153-.466-.153-.818v-.04l-1.14 1.757-.037.039a3.004 3.004 0 0 1-.497-.782c-.076-.273-.152-.584-.152-.896 0-.39.077-.821.229-1.25.114-.39.341-.858.646-1.326-.152-.547-.304-1.133-.457-1.719 0-.039.038-.078.076-.117.038 0 .115-.04.153-.04.076 0 .151-.038.265-.077.076-.04.19-.079.229-.118a.302.302 0 0 0 .152-.156c.076-.039.114-.115.152-.193zm29.674.039a.648.648 0 0 1 .229.232c.035.116.072.312.072.508 0 .156-.038.313-.076.469a4.79 4.79 0 0 1-.19.545c-.304.625-.609 1.21-.875 1.797.266.35.57.701.836 1.091V42.578a.69.69 0 0 0-.265.078c-.114 0-.189.04-.303.117-.114.078-.19.157-.305.274-.114.117-.19.193-.228.271a3.371 3.371 0 0 0-.418-.547c-.114-.156-.265-.232-.38-.31-.113-.04-.19-.04-.228-.078-.19-.04-.304-.04-.418 0-.114.039-.228.154-.304.271-.076-.078-.115-.193-.153-.271.19-.351.382-.704.573-1.094.19-.35.379-.743.57-1.094-.304-.39-.572-.74-.838-1.13v-2.303a.41.41 0 0 0 .268-.117c.152-.117.226-.196.302-.274.038-.039.153-.156.229-.312.076-.117.152-.233.228-.39.228.274.456.506.647.702.19.195.381.313.496.352a.43.43 0 0 0 .379-.078c.114-.117.19-.233.19-.428 0 0-.075-.157-.151-.43a1.168 1.168 0 0 1-.076-.351c0-.117-.001-.196.037-.274.038-.078.076-.115.152-.115zm-4.644.076c.38.312.76.626 1.14.977.076-.117.192-.196.268-.313l.113.117c-.114.312-.227.546-.265.664-.038.195-.077.39-.077.586V40.785c0 .117.039.235.077.352a.42.42 0 0 0 .113.195c.038 0 .075 0 .113-.039 0 0 .04-.04.04-.078l.112.234c-.228.31-.492.624-.72.936a.816.816 0 0 1-.229-.39c-.076-.118-.113-.274-.19-.391a4.023 4.023 0 0 1-.114-.975v-.078c-.38.468-.761.897-1.141 1.326l-.076-.04a3.406 3.406 0 0 1-.457-1.015 3.128 3.128 0 0 1-.153-1.013c0-.39.077-.782.229-1.172.114-.39.341-.78.646-1.131l-.455-1.992c.038-.04.038-.079.076-.118.076.04.115.04.153.04h.265c.114 0 .191 0 .229-.04.076-.039.113-.078.19-.117a.539.539 0 0 0 .113-.156zm-3.233.469v2.342c.266-.273.532-.548.8-.86a51.083 51.083 0 0 1-.8-1.482zm2.473.195c.113.546.19 1.093.305 1.639.266.312.532.586.836.898v-1.56a25.37 25.37 0 0 0-1.141-.977zm-25.03.078c.077.508.19.976.303 1.444.266.195.534.351.838.507 0-.468-.039-.938-.039-1.445-.38-.156-.72-.31-1.101-.506zm28.493 1.016v1.834c.152.195.341.429.494.625.304-.586.609-1.17.875-1.795h-.305c-.116-.001-.23-.002-.267-.041-.114 0-.265-.078-.38-.195-.113-.117-.265-.233-.417-.428zm-31.322.455a1.633 1.633 0 0 0-.329.05c-.152 0-.266.04-.418.079-.152.039-.303.117-.455.195-.114.273-.19.547-.265.82.152-.078.304-.117.418-.156.114-.039.227-.078.379-.117.076 0 .115-.039.115-.039.266-.039.532-.039.76.039.304.117.494.39.494.82 0 .312-.076.665-.266.977a6.613 6.613 0 0 1-.799.975c.228.078.494.156.723.234.19-.234.417-.626.57-1.094.19-.507.268-.897.268-1.248 0-.547-.152-.977-.418-1.25-.2-.205-.465-.3-.777-.285zm-3.409.012c-.038.117-.113.232-.113.31-.076.117-.076.274-.076.43 0 .35.076.625.228.781.19.195.533.234.989.078.114-.039.19-.078.304-.117a3.34 3.34 0 0 0 .303-.193c.114-.273.192-.587.268-.86-.114.078-.23.118-.381.196-.152.078-.266.117-.342.156a.652.652 0 0 1-.646-.117c-.152-.117-.306-.351-.534-.664zm15.977.156c-.686.039-1.408.078-2.131.117-.114.234-.19.43-.305.664a26.79 26.79 0 0 1 1.79 1.016c.227-.273.456-.508.685-.742 0-.351-.04-.704-.04-1.055zm-9.473.04a3.422 3.422 0 0 0-.152.663c-.038.273-.037.508-.037.742 0 .351.037.626.113.86.076.234.19.429.342.664.19-.312.418-.587.61-.899v-1.482c-.305-.195-.572-.351-.876-.547zm25.03.116c-.037.196-.115.391-.153.664a4.86 4.86 0 0 0-.039.742c0 .351.04.665.115.938.038.273.152.584.342.857l.61-.625v-1.638c-.304-.312-.571-.626-.875-.938zM10.09 39.393a.83.83 0 0 0-.248.062c-.342.078-.57.156-.723.195-.114.078-.341.157-.57.313-.114.234-.19.507-.229.781.456.04.95.117 1.407.156.114-.078.228-.234.38-.507.153-.273.229-.468.229-.586 0-.195-.037-.35-.113-.389-.02-.02-.067-.03-.133-.025zm32.35.101c-.343.664-.684 1.29-.989 1.914h.305c.114.04.228.04.342.078.304.117.57.352.875.782v-2.032c-.19-.234-.344-.468-.534-.742zM7.712 42.11c-.343.001-.572.08-.762.12-.114.078-.267.154-.38.31-.115.117-.151.274-.151.469 0 .234.074.39.226.547.152.117.306.156.497.078a2.62 2.62 0 0 0 .912-.703c.076-.078.267-.312.533-.664-.266-.117-.57-.157-.875-.157z"
        })
    });
var $566b6e2d6ce5c43b$export$2e2bcd8739ae039 = $566b6e2d6ce5c43b$var$SvgSanAndreas;



const $6bbbdeadab023461$var$SvgSdkLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 1200,
        height: 627,
        viewBox: "0 0 900 470.25",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "sdkLogo_svg__a",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "sdkLogo_svg__b",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "sdkLogo_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M.715 89H899.28v291.762H.715Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "sdkLogo_svg__d",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            filter: "url(#sdkLogo_svg__a)",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                filter: "url(#sdkLogo_svg__b)",
                                transform: "matrix(.97345 0 0 .97345 -36.738 88.73)",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                    xlinkHref: "data:image/png;base64,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",
                                    width: 1000,
                                    height: 300
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#sdkLogo_svg__c)",
                mask: "url(#sdkLogo_svg__d)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                    xlinkHref: "data:image/png;base64,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",
                    width: 1000,
                    height: 300,
                    transform: "matrix(.97345 0 0 .97345 -36.738 88.73)"
                })
            })
        ]
    });
var $6bbbdeadab023461$export$2e2bcd8739ae039 = $6bbbdeadab023461$var$SvgSdkLogo;



const $8f033889ae95cbbe$var$SvgSdkLogoWhite = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 1200,
        height: 627,
        viewBox: "0 0 900 470.25",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "sdkLogoWhite_svg__a",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "sdkLogoWhite_svg__b",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "sdkLogoWhite_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M.715 89H899.28v291.762H.715Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "sdkLogoWhite_svg__d",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            filter: "url(#sdkLogoWhite_svg__a)",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                filter: "url(#sdkLogoWhite_svg__b)",
                                transform: "matrix(.97345 0 0 .97345 -36.738 88.73)",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                    xlinkHref: "data:image/png;base64,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",
                                    width: 1000,
                                    height: 300
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#sdkLogoWhite_svg__c)",
                mask: "url(#sdkLogoWhite_svg__d)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA+gAAAEsCAIAAADfJw44AAAABmJLR0QA/wD/AP+gvaeTAAAgAElEQVR4nOzde5ylV1kn+t/zrPW+e1dVV19yJ9xMDPcgIYIBBZUE5IAcZlDnOOjxg3g544zoGccZP3LUYXTmI+pnjuPH4zjqzPHICModvBAkhIuIkAghCAmEJIQknU6n73Xf+33Xep7n/LHevWtX3+huurqrqp/vp9Kp3r1rX9b7VtVvr/2sZwHOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzm06dL4fwAXNzM73QzgNRH62OOecc86dN3y+H4BzzjnnnHPu6/Pg7pxzzjnn3Cbgwd0555xzzrlNwIO7c84555xzm4AHd+ecc8455zYBD+7OOeecc85tAh7cnXPOOeec2wS8M/eZ2Fz9188X7/vunHPOOXcW+Yy7c84555xzm4AHd+ecc8455zYBD+7OOeecc85tAh7cnXPOOeec2wQ8uDvnnHPOObcJeHB3zjnnnHNuE/Dgvp4M8L6RzjnnnHPubPBO28BZ7cuuAMavh8qt0gn+9VTY8T5OdM1j0cQnkx+Y+GTD8L7vzjnnnHMnEc/3A9hSdJSfdW0619Ena/51FOvNzMyY1+R5kZbBxBFqaAQKSLkhhhEOHmx3765DBQAl73a3Vj43MCNnPOdbAAUZyECKyKgDAoEMRFArX2IQMyOiU47OjDN4EeKcc845574BHtzXGa0GXD3RVYjICAIAUEANaiEziOWBrx3a/eiBhx4ZzC8uH5prFpYOPvpoXXJzlioE7l4KGCbeN6hiJOa2bcXMetTbNjOza0c1O/34q7/Jpqorn/ykqac+FdPTABAIFYiZVMBAJMBOZSb+RM/FOeecc86tEy9OANapVGY0od5dckzZDAAYVFqmCGO0hkHCg48c/sr9hx7ac+Bruw888ijUauJoZKKkBrUqBEgmoipEImIDGcxMCTqK00ScUgpEWXOoGaRiZoTMSCKZjDhuu/jS3vadT376Ux5/7dPxzU/CjhlMRUiLfkQYPz5e83To6Lx+dqfbvVTGOeecc+4kPCoBZzW4j25x4nOauGRcK1OqalRhhN177rvjC498+SsPf/Ge6YR+Ri2oW+1TMLVeVWvObCAikAKIIRKTZTUzNjCRERQw6rJvltzr9aTNqqnXD6JZVbMKMSURMyOOjZLGOGRbYW3ruP3Ky6559jMve8qTd3z7CxABAgLADF5TDe/B3TnnnHPufPGoBJyt4H7sbYgCXfxVVWaGAVmRCSsJd9939yc/fd+dX8zLQ2rSVBWrZMEQFMFQcVcGwwCDJ4P7WACN/1QC1mZfBgA1k/Kv3ay82ejKrAQhGGFg2QiZIMwrRldd+6xn3HB9//pr8bhdIMFUMBOikGE0vrs193J2eHB3zjnnnDsJj0rAWQ/u4yl2A9RABAaSQAwU0xe/8sW/+9TXPnfX4LFDO6iuh20PITJHYoaSgdeEbwYQaDWgW1dz0yXmEuhpdNd8bPYdZX0xAyDHvLwQmBFMS6DnQVKpq0N5kGbqK697xtNecP0l1z0Ll1yEirqpdxFUwYO7c84559w55lEJONulMmvarSgghqHg0OKDH/nE7R/+qM4t1QOZrevctlOxnjIOpqWxTMURQEnhVVg9NCW4g8eXKI0n448O7scL0qQAVPW4z7QEdzHrpuGNWtOWtSWzuk4MifTkZz/rmS97CZ79DEwRAhCgtFr4frZ4cHfOOeecO4kLKyqd9UWoOGbKWce9EhUYCmJIX7rv9ls+dt/f37FDQz1MMck0WFKKdV2FIE0TQByYiGKI5dbIUAUaza2PEm3pF0mCUbgvK1OZeBzciY89oDr53M26v5YbVyqdIKFmRgAgRiklriKY2iSxVw/aJtXVfB1nnvS4573yxtkXvwCVdXXwpRT+eNPueryROf5Vvx4P9M4555xz8OB+ZkpTdSupFQbA1CIzADMhMJSwJPmOu2591/sPPfRoT7TKWgmCIZj2KIbSNd26KfPIgYgCWSmVYaIKAAQAEZcimWND+epE+8me1vE7N5pZKXMHoGY6mvUHoAQVFdioTaWJUWZuSYcRSzWe98qbHv/Km3DFxbAWbAIKVU9VGQyDEZQAAq1tR1PaXYbTz+4e3J1zzjnn4MH9zIxjaOm5wijN1wEjMNDYwx/86N+9/2Y6vNwb5iniSsCGYACUDSGGAApgqAIYpXYi0wAipoBS7y6l9KVUrh+bXyfz+gmzOx0d3Ed/Z4yWtAIwM9Puv/LXsp51XBnPxmImjGHEYg/D2erpL37hNa/+Hly8E5rR7xkREZcSeiMoA+WFjQd355xzzrmz4cKKROtRKoNxbYwALVY+ftsH/+w9C/sO1tmmEWojqNSxqonJwFAAFUc2EE/OuDMANjAocgCUTCLBzDh0lTDHLjylY4L7cTLuMcF99PhX8/N4rr18YqplDes4uwtMR6talSCBllS0F9NU/YyXvPDxr/le7JpCzWDqNnYlSKnrOaYHvJfKOOecc86dmQsrEp3NRajjDZUUSIBg4fbPf+qvPnTgrntnNVKTmIiyxhCqfi81g+mqFxTExKYlr3MIJbWXspmS2gMxEbEpSAMM6PI91jm4T35S0ruYYtSFRmBZtdxLSfNgSpKlVy9UdqhH13//K69+zfeCFIHBALMyYRzTj7v51Cnz4O6cc845Bw/uZ04NBgRCA3xt3y1/9JaHvnBPL+kMV5WADLGkbWYljRz6IQZFafjYLUJVK3XtzExqAKoQGURqgHKAWfdPa5IrrVldCqzpKnMcJwjurEfPfR8V38eT7gBMjaFmqgQFWsliZqYZ1AQMIw8qVFdcctPrfwjPfQZqoCprV7ub6h7/mcZ3D+7OOeecc/DgfoZ0FEMT7vif77rrg3+b981t53oqVqpKhgpdGYwSuOIA6nEICoKyIcZIBjMLIGKLxGZGhirEACoPkgPM5KwH99VSeFsN7sTEtjo4Wnq6TwZ3MyqrVwlKyCrZtFTRZBMDa+CVyI/q8uNf8Nzv+Okfw0XbEQKYYIbwjZ5jHtydc8455+DB/QwJsKK498H3/eFbDj+we7vFKltNLG1mZgBlA9TITCGAjQylxp3Y2FCFiFEzxxDAoPLXyCGMjgixAVoy69q58dUgThPlMV2pzInbQRYTa1jX3Opk9O8CunYNIpW1bM9kZiBVQFVK9/esSgaBZZAwhqrLgdKuqRf98x+Yfel3YiqADAxhRbcN1XFq3L9u7bsHd+ecc845bNXgfnY3VFpjtAj1jre84+/fd/NFWlWt1kaRunIXAIEoKMhQVRVRqYLvgnugriQGo+AeGaXAHeiCOxlAWiL22Q3uazvPTMy4HzNaRrBxy3fq1qqKWVlcm7UrmzHqvlZhXQP4ujePfLii+pnf/LJ/89OYnUJUTEUBjg3uRy/wPU1bL9Cv43k7YeuNm9tczuw89/N2szi7P8c273H3cXDrZGueCmfxGyYlCRw4wDIoAgo8vPC2N715Zc+BfkalGhQRVJaZdn+im0SvqgoAkbEhgoICpGyoqtD1kwEC88SMO4XRN2cpfznqe5UBIjtuYcxkKD9efD9aOJ1BUEI2Gf+19I7MpmaqopioqEmwBFkhzJHSZbte+rp/Hr/j+ZgNqpk5jBbzAl21EetkS83TtPV+kHlwdxcCD+5bmwfWwsfBrZOteSqcxW+YrIg8SpsZzT0P/fGv/EZvbti3EAxsytb1ewkgNoSJnusxVjwR3Nm6poi9GACU7B6Zx0XqkSmAus1TTxDcGcd/ausa3AFkE117q2amoqqiZjraucnMsmombYnaftzP+Zkv/+6nvO61mK1AgAlGj60E9+4Be3AH4MHdXRg8uG9tHlgLHwe3TrbmqXAWN1oiQMveSQ0e+MuPvP+//clsi529ac0CnDC4j2fc2UBkVHq0G4iNDFUVSp0MGziMNka1LriXuw4bPrhjNPWuqgJFyeJm2VTMWsuNoa1o2KvC4y6+8effgKsuR3+cz88gqB9t6/0g8+DuLgQe3Lc2D6yFj4NbJ1vzVDiLwT0bagISHrj103/1X/5oV0NTFjRnhACATQEEIrIuuJdSmTKJ3osVSoinrgk6ETE0xoqhXXZnDqMi9cg0LpsJEwUx4+/Y8xvcj7pktQsNQaWrgzeCiGRTCiywNumQta3i0o7eK/7Pn8S3PBVTNQK69xW8v/taHtzdhcCD+9bmgbXwcXDr5CxMfG5hDNTlmyXhU7d8hAfKQm3bEpGK5JSyCQc2tZxSiapK3IhlRah6wzanJDmnnEQFYqQEBbc5JVExMmIxZO3+KauIqcKUIEZmpYSEzah8qNqkczkUkcL4I4ACKBKXjwCK3H1Sdn6NxGbChj7TjIXtGqYOrNz8678/+MCn0DLabhtWg8EMatBz+lycc8455zajeL4fwEYnrYQ6wNDmTFUgCQxbado4VSPUIGtEY8UaYgpQEFSJQYwkGQQxA4yIVIWYQzYlCmQCmGUBRQoKC0RGFIhgSgaAmRhHbWAEAAzYUR0ez7sAKm8xqCrMALIQzFRVGcwozyFODfSTb3nn4x5+6Nqffj1MUTNZN91utEXf+nHOOeecO3t8xv2kDCEEZKCPG//JK3ONuXZpyJZrbipepDxv7UrQpaCDmua0WWZtWSwisw6sTSTGKjCBKcFUs4mqZlNVLTsaZZOyk5GqqqioqplssGgOgCY/7OgPlBL/UvZDyrBIIRAxlIhSytFoysLUiuy99R+++Bt/gCMNclcqUzZ1cs4555xzJ7e5E9O6l4sYYKMehorHbrn9039zK7JeddVVYbqfoBfv2vG4x10ZiIaD4aOPPDJcWelTPPDo3oMHD80fOJQGw2hUgYKiNgqKiNJhhrnUxJMxERMFEBEHsrLUNYB6VVzdG5Vp/Hkgo3GD9XHt+9phWI8a98lbND36dUW3VVPp/q553PddVUoVUBKrq34yG+R8qIJdfcXLf+Xf4OIZVAyGMGjUTgfYOrXv57icaZ1snPF0W4PX/m5tvlan8HFw62RzH/JzGowMyBNVKjQxeLb2ajb65ODckYd2P/ClLx188JF99zxo8yvTCFW2KeNKAbUqMNiIKGKc3YkNDAoBVVjtFDlewNp1mxlNck/csR533jqc4Lua6PhvtrCd+WT/eMsmJSQRMxN0nd4FZkpGyMRDwqAfh5due9mbfh5X7EKEQhBrlDeAbG1wP/0zdOP8IPPg7tyxPLhvbR5YCx8Ht0429yHfBMEoA6JIhhzwlQfuve2z933+rrlH9lbJeuDaqCYKZNEoEDFCAAcQSAOMA6oQx80iR9ldwzjNj1rQKEHp+IH7vAR3AALLqiW7m6mYdReCymLchT6Wn3zxK//DL+LSWUAQQ9mMac1LI3hwP/82zni6rcGD+9bmgbXwcXDrZHMf8g0ZjFYfkubE3cagBGWIIjCWWxxeuPPmW+//zOfzgfnZVqfEiMbBnQI4kBG0MuLAFccw2i01EJXgjlJoTqslNBstuGMiu5cSmtIwRwQCSpKXRJamYv+aJ37Xm34Ou6bRI9B4up3POLVjI/0g25Dn52nbOOPptgYP7lubB9bCx8Gtk819yDdkMJoI7ipEXWN3AKrKzAAwEFgAMP+x2z/1FzfPP/xYX6mvVFtXM8Pg2oyhAcSBq8AB45oZO2qbp5LdN2Bwxyi7l08AKKxtW4QIpuWm1ao+SBnXXP7yX/zXuPIiVKuP4hs5MTfOD7INeX6eto0znm5r8OC+tXlgLXwc3DrZ3Id8QwajEz2kiaHW0RUFaGXuc3fd9t4PHrj7qxdZVSWzNm3r9/ohBNMyEx9AkQORkaGkeYwS+XibphN9904G8RMtWp0M8d9IcKfR0wIA1bJitVuoOlquKpIzLDOSmCkNVBaCzn7LU17wpp/Djj40SyTqXpDw6o2e1sPYMD/INuT5edo2zni6rcGD+9bmgbXwcXDrZHMf8g0ZjI5+SF3p9tqhFnQPPYKw3KIJ+MJXbn7rO+cf3LMd1YxR3yyONlst2xtFJiIiaOlIg7XZfQMGdwBG3TEqDTEBJElJsxCLGZSSaCN6uM9X3PRt173hx9Ez9KJCGYAH941h44yn2xo8uG9tHlgLHwe3Tjb3Id+AwUi7vHmsNUNdKr8BqGgVAhKgwFDu+8CHb3/nX88sNruUp5UBBFBkCsyBETkwGU+sTB1XwpyouOTcB/fuCU60jCx7wZZinmza5mRmoKBGSSyZrBDm6vC477juuf/2J1ErYgR5cN8oNs54uq3Bg/vW5oG18HFw62RzH/INGYxOoVRm4pHbODWXoJuA+x79+P/7Z4e/+JXtyn2lYIiEyCHCqhBCN+/eTcZ3jWU2fHAHoKRKUFgS0ZwVrAQ1EpgQL6stztTPfd0/ufRVL0FFCIDxmp6bp/4wzvkPsg15Hq47/4XhzowH963NA2vh4+DWyeY+5FswMJVu8S0efe8Hb/2f77ok0VRGv4rBtIcQQFTHEAKDSk93Khs5TRS74+jv5NUAzROXT17jdIP7yU+ayd2gyn6xpWBGCUpQMzVLklVVCUYQMwENs82ldmlb/Zpf+Gm84FpMc3nEZ3CKenA/N/wXhjszHty3Ng+shY+DWycnKOtw5wsBFdDHla96yQ/+4s8s75wazlTDCItBCI3mNufWZFR8AoFlUzGzzfDNW/aFBcDMR/24qUPc1Z+5TKpb/vBP8eghtAZmdHuwOuecc845D+7nhU18HFcAdvV7L7zun/37n8NVl80jDySlAGG0kJRyVlGYqWH0glvVNua8LzEDoBEuHxPBnZiIaJiGgZlzxqHFD//W72MhQ4AYNvl7Qs4555xzZ40H9w0qq6IGnvbEV/zSz/WedNlcpQMSIahZNmlyFpFsqptkrn1SKbVn5snSnX5Vm2Q21KK699CX/+QdGMjJXts455xzzl1gPLifOR2tvxRYEgGgaz8w6l/eXS1L9ydh9eMEIjMCoR9x2ewr/uO/6z39yUumTe7u0cyyqSnMSFQFBjAhwBjGptR9rJ2DL/Xl5WPy8omLz3xlKkolzPFzNq9+GMO6T9So9NZhA4MCEcfIzLTcfObmW/bf+kksCwySRfUbemDOOeecc1uAB/czVLZBVVUzC4oqBCh4FF67CGsIGcgGAIYQg4mGGE7pDkoCDkDFuHj7K37hZ6pvuny5Ty2bmgm0ZHcpk+4jx9wIb+RDHJg5MEaLeIapnVtenFuYX15YtMXBe/7gT3BwARkhhm7HWeecc865C5jnoTPFXLI7GcEIQ0UGVhRDYDDxkQiJMDQ0CUDZE/Tr17iPr6MMAqLh0m0v//c/p9906TJ1c89Z1cxEVcvi1BNl9w3MzHKWtm1XmuG+wwcPLS0MtUEVWgjU4pHld//6b0Ohqm3bnu8H65xzzjl3nm2O+uhznUcn743WXl6KYMoVMkDYe8cXBovLe3c/wmKP7n4krQwmb+miiy7auXNnnOo9+dqnbrtoZ++JTwAM3AV4MBBO8OppXBvCKtIGBCy3eHDvu970n3cs6ZRSrRQINXGEReJoMRCVzu6TDVuIbbIj5Fg4QQ+pU3k74CQnzVG9IFFegFj3VwOUkMmyajZdGQ5bSW07HKbcqrRELakYGbGYhbo6GPUVv/Avr7npxdhWWwaFr3f3J3/Y33DbrM31uuh88fZk7uS8HeTW5m0QCx8Ht042xyE/F98A5R4IMEAUkaGwnFDF7hujARSIwFf2fe0f77r3C3fv3f3IwX37+6EyEaixGKlhtBcSj7qolJsPVVgeLoeZ/o7LLrnmWU9/0jdfdcW1z8TlF6MGKgIDTGAqs/jWJqorAEBX3M0ABGgVn7vnLf/pty9NcVZDHxRhPXAEBQ4BREyM1V2ZANhpBvfJK6/t73709Y7z9Ws3jTUCEZWByCKSczZtyZalHeR2mNNKahQGNTNTIJMpWGBqMBNlHQZe3jHzs//9v+GyneiVe9XRHZ/2m0Ue3M8N/0XiTs6D+9bmgbXwcXDrZHMc8nMamGw0KlaysiAGCOa+9MDnPv6pu2+7Y3hwrm/cA1PODAQQGZsoG8wsYLXx4fgm2crWQ2KRtQpDyzmQxbD9ysuuu+lFz/iOG3DlJUiCSOixNS1VlQYygKDjR8QAMrCSv/r+D33uzz9wcYs+UBt64MooMhPxZHY/v8G99LoRqJhRCEmzZGkhi8PBQNNQshCGksotl+2ZBGYEMbJSxg8kxoDDs172khe98V9jCoBOrOj14L5B+S8Sd3Ie3Lc2D6yFj4NbJ5vjkK/zN8BqVcr4vkioK4l58PCn/+bWz3/qM8PDC1hpprhigEGkFkt0VDMztm7v0hKdj70LUmEyhWXVqq6T5F6vN8itVSSBLn3yE2646bsue8H1uGwH+oxAZa59/DYAY6Imflk/8sbfXLr7q7u4mgLVRhU4EEUKRBRoddIdp18qc+rBfVJ3W8arV2NqIY1Kq5nqaiU1C4OVYduMC2aU0OYS3LkL7mbGKmXprRLAQtBocxW97s2/uuuG5yDkibh+2utuPbifG/6LxJ2cB/etzQNr4ePg1snmOOTnLrjbqJC9xd7Pfen2Wz7x+b/91M44TcPcQ+wbm+Ykua5rk1xVFaAppRBDCaxsJxpQDWSqORDHGKFWc0g5kyEEKFMKWCIJF29/6guvf/4rbqRvegJiVwGv43zavRVAyMBjK+/4Vz+/c0V2KNXGFXHA6qR7ye5MRHaOgjvKQxvNuBvBIg8lDSUPJR1eWkhkQl1zzHHj+bZtiQhgM4OxQIw1wTKQQZliZs51OKDt9muf+m9/780ggDO6IfHgvkH5LxJ3ch7ctzYPrIWPg1snm+OQr983gJmtOe8bQHDgM1/6q7e+67H7H+oJB+FgYAMZBxBDAZCBkccZl4jKQkw2VMRViNaVbY+VyhclQyAOIKiZKalxIDBlgjASQyu2Ol5z/bNf8MM/gCddhmkGFGoiOYSoKmYWqh4Wmn23/N0n/+Ctl6Vqhqt+iGoSQCGEMt1eFqqygen4wX0yiK99i+CMZtyZwATjLFlFNdBCbpZzszIcJhXloAQN1HXCKW9SZEWJ+OUtDuO2bXtTdcs21zRpqn8k60pdPdqmI4wD2v6LN/zU63/kVVBTFu4qZjy4b0T+i8SdnAf3rc0Da+Hj4NbJ5jjk6/QNUFK7mZERMpAh+xb+8Lf+y8F7Huq31leyZFWsxgGxi8IGkNYRGHVmFDMASmUjIUBNZW1WJq0jA8oAi/VCxYZSzWIY7dxEABCYU07Siws9PO+VN173v70as33M1MhSFrCaKHGAAgvtx/6v3xx+5aGLqBfa3K8rAJGZiQNxoK5aJpDR8bZVOrvBXaACM7AxDdtmYbCymJtEZgRjMnBWFVg2MUDNSl27mQlMCAlolajfX26bNvCwqh48cnC5il+bX9jbNMO61xI98fGX/OMn3keKjNbM6tA7+cE9lgf3c8N/kbiT8+C+tXlgLXwc3DrZHId83WfcBdhvH/7T937ybz40Y5EG7XTdgxqbUlaMUjURcRdhtaR2JQWwtLLctT4kRAqD4UBE6qpevRtSQHt17FdVn2IFrkA1xwAqqzDLl8cYoNaLlZg1kKYmnZ161etfO/ui56NSTNddkbsqmGGEex595xt/9dJl7LQqmJbymMihBPfyMuMsBvfxewiTlxNTVkkijWaL1eJgeSU1SlhpGyUQMZgElFUUNn59UoJ7Nm1NhiZLTHP96YXYOzgcNnX9jw892AROkXhqaiG1wyS9eirq8M2/8u9e/9pXTQzr6fHgfm74LxJ3ch7ctzYPrIWPg1snm+OQn8E3wGoXxRNdUkrGEwDs+cxX3vY7bxnune+Llv7oJsIxam4jBzYtcROhFHUAwPLSkpIqQVjbnIShBCFwxUrYvn37pZdeOnnnqml5cWlhbj4kiYqZUE9XvZq4Zo6GoCDDVL/fNs1UrJumAWCRqV/PhXzFdU9/6Rt+EpfMwhKqgMACDW0L9O/8r//fY7fcvnOIPnFFfG6Cu03sY0phtZZ9cTA0pmTS5kxcCmM0K5QAY2Mtwd2IhTgxD4BFyJK0cxz2qN1/+PAigvSn5iVJjEmEIuecRYSZK82Xz/Y+eevNj5ulicL/0+DB/dzYquO8VZ/X2XLq4+PjcHIbc3z8+BYbbRz8fLsAbY6hOd0T6+h+LBOXBECzcAwyzIEjWnzg/3nrJz/wse1WV4qgYIOaMRGAEJm41HVIlpwtLw8GVRXbttXAqMKwHVhEyzZ7yc7n3PC8J15z9ZVXPeEJ3/oc8Kib5HgJJRmMoGgefvTBe+/fc98D93zu83vue2BHqHbG/sXVVA9BxLo2jmpsKK8KhDBkw46pV77+h7bf+EJMERiCZGaRajw2/4Gf/uVth4bbue5xYBATB+6WqJba+uMG9xOZXLRagjubjiN7eYfBCGrdMtMB6UIzWGzbQdswAjEZk4oKyFQFFrgCWEREUpKMOq6AVqo4R2E/Y0/T7h2sHBHJVd0YMlEC1CybKsHUAGTJCmPYdKBf/eVf+LEfvKk+gwr3rfsDbqPZquO8VZ/X2bLRAs35slXPEz++xUYbBz/fLkCbY2jOOLiHiUtK9owY9Y0hDO47+Lu/9p8Huz0djm8AACAASURBVA9jKc3W/agAQEzMoWtDbmbIOSeVVkVVc6vZSFuyYeQU9NLLL/vOm77rRd/zkvrqKxFG9ze5++i4K7wCgAmorKsUIAEZD3z4k1+5/bP333bnzlDNUKwUUCG1OlYYBWWIoFcdqfT6//Wmp/3w92E2glLXqH1Zvvxb/+PgbXdtE+6BIwUebZ4aiNj0RItTT+QkwV0JgBpBYALLqsnswPLi0PLQBCFWRmamZtlEjWz0BWrUmglhEChNTR0R2TtY2b28Ml9VcyEsMg85GGBmoqP7UjU1NWNoVklQIkJKVz3h8ts/+mcVUG/d4L5+P7A2y+Pfqr9INubzOls2WqA5X7bqeeLHt9ho4+Dn2wUonu8HsC6OrocZZfVVgiN37fmdX/p1LDSVgMs0dylkB4igQJacRIbaqGbVFBRVYCIaSEpT8aKnPeH7X/fDz3rRDRBFn2FAmNi5iQwgyyCC8moL9ozucQQgVECFq7/3RVd/z4vQYP6jn/38X9+ysnsvQYmsJgBQYgB1CJJMs975ng8tHzhy/U/+EC6fQTCYIsarn/HUx26/S2n0YuVsUyplNSqjJ4YQB+3gyGB5uWlbEw1sIaA0YlfNUCVuRQELCnBomJeYDzMfruJusX2NLmbQ7M6FpkngrMQEMOXSXobYTInIYEykAIVAamZGgR9+ZPefv/fW133fSzfiTxrnnHPOufW0NYM7cHSKXdM+MOGzf/X3b/2d/74thb7ydK+v1Bogo22EFJZTalObJGVLZdo7BR0iNZyvec4zXvnaH7j6u29ABCqU1uLZrCZiQAyBAJAYsmHfvvTgw7v375s7sH/+kYf2mFmEUVbKaiIk7bba6raZBV5w1dO2TW9LIaRWt81MS5sAMEAGSamua9OgWe7/xD/s27v3FW/8GeyaBhOUDz3ymOXMOONFm6c4nGwwJRjhwOHDQ8sDk8xsIRCTmFqWrqCG2MAZlokt8DDyAocDoo+l9rGm3UNhWFUWZrLkMDWjZjAlM9HugJUZ97L1rKnBGKRd8x8io/C7v/cHr/2+l/LaNzacc84557a8zfFmxGm/lTPeZJRgKPO4o4n3jDve96m3/9c/6Q3R4yooQLlrJU4UYyDipmlSSjk3ZiaaA8MqLGoz+/hLfuxnf+op33MDMhC7VwMCCAADqYVACmTD/n34zGe/eveX7l9cGTbNgCmEqtY2T7WpGi7Paq6Gy6Ft6nbIg5VekiC5b+gbKlWGBkUgA2BMmFhIKgTUvGhp5kmXv/gVL4vfet2BD33kjnd/8GKpeqUXJCgQR+JxqQytVgmd0ntPYZSHibh0zjFTMQPTIMuKpKVmMMitUFlmitYgppkMaixGahpCgmXYHNl+DvspHORwxLCsGFIYMDfluYiWYS/LXpMmdLvQmmm5365fpJkIRDVBiZFJhu/40/9x0/Of0WcASClVVXUqJ8VmeUvRS2W26lu3G/N5nS0brYTgfNmq54kf32KjjYOfbxegzTE0Zx7cGQAkS4gBYkh0+/s+8We//yc7qB8aY2Y2lGhLgc1MVVNKbduWog8l5YDWklR42fe/6tU/8xOoCb3R3p0EwBRgUAvUQCO498Hl227/wj337Alxtk3EYjVSpdlyU+dULa/Q/JHecNBvB5U0fckzYj0LFYMNxjbqA4NoimOCO4BYhRVpG2gTkGuuBLsSV61O9+sACuCjatzPOLgDACkRExGYllJabIcLzWAxDSgEJZSq9ESaVc1KExvOoBWmAYcls4Nqj7Id4DjP1QpxEksAmLOadWU1Nj6yqqkkdQA559GFWoK7kqqmSFXKDbR99cu/822/+x9Zlfk0Ct03yw84D+5b9RfJxnxeZ8tGCzTny1Y9T/z4FhttHPx8uwBtjqE5kxPLUCI5SnpXoJXbb/7bP/+9t9OiTffroBj3YQSpBlPVtm3btlUtX6fC2kSdvWzn6372XzzzxhvAQBxHdnQT+EBGpcDhI7j5Q5/58lcfTplVq36cNtGqGfYWF2cGi/XiPls4HNq8LcQZDixSZtb7asG6FpNcEYAAY4BM2UqXFmAiu2dLFEJmNJJQBahti73aKJgGcCBiEBvOSnC3kZbsscHCirStiEIVrAQ1U1YpDTUzA5yoXmI+UOmB0NuP/hHDsmpL2hJlUFYVkCKqqWhmNlEVyOQUe/kzi5hq6V1Tpt0NqRS5q4pqS+383Z/4m6uvvKQ8zmNbfx7XZvkB58F9q/4i2ZjP62zZaIHmfNmq54kf32KjjYOfbxegrVvjPjroDCADhH1feuBtv/cWzGFbb6fkxIEUICqBjwfDgUBM1AgKGJfUnq+45om/+n//Bi6bQQXYsfEwKgjAl+9bfu/7P7LSkOgMFMG4anO1tBiXF6v5w72lw9uahW2WKwWlZirWAGAMIBjCaNlsjYDRy43AxAYy8NoZdwpRRaKijj0osimrEYdgKKl98sEpdVXyp6trqkNo27zSDAaS5/NKjgwGURBRE8tkqmpsCs4hJq7nhI9w2AvdBzoS6xVE02yWzQzlR4MRCExsTAARWTASAphVpHuCRIE5qwJgIum+kIk05cTMoeqRTf31LR/52R/9wdN+Ym4j2Zi/ME7kRI/Wf8EUPj6ny8//zWjjj8PmOq9OZOOP83m0OYbgDE/E8TY9GfLI8s+/7l+FFe7zDMClV0qvqkk1Z2nawXKzAlI2BrTXq5Zkue3lb73x23/q196ICLCOWkwyxssiDUYYCP7ylvvuuOMeWK1Koqg5VE2aXRn0Hn1oauEIy3IvN9tgUcGGiigyl2oWAIGIDZFWI3ssryTKnZVKd5Pxc+o6vFAZEyWiEJjBtXUT7QDC+LCSEtlxp6LLxLwec/zZ0OasBFRhpU1NaldS06i0psIw0mwCNQBNaZdJ2oQ4F3pHQv8A1QfB84xl5sxVa1BVQM1UVUW1pHAKrOUCE3Tz+qIqNlqfKhBRVRUAYtRNupsIzEyJmNFe9biLbrvlHdOA5pZjPTrUJ9uZabPMTFw4M+5b4xfMhfZ8T9ex47O1x+FCOx8utON7IudrHC608ffgjq08445RpTsBLX7zl99cN71tvZm2lVHlu1rULNK0TdJRUTUpgKU8sOnwgz/xwy/9odeg0m7XIaAkfoCl9KghLLT403fcfv+DRyzMBpDmNBWrethMD1fkoQe2Ly9ODxZAbS9QJWBD4BBAJffz+HUAAHST6+PLabS4FmvP1PJZQLfklpkJHEDdzk0TXwUAxiDTY/q4d5tSHe/8b02pF9V0kJu5leVGpdGsgUFspK2ZGTFIYC14wDbgein0Dof+4bp3kMMiwgCUycRKv5jyhLTUxAPAxC6tTKTdjxgmMrCW7E5MbGTEZro66Y7SHJLNFBS/uvuxz9/32POfckUV6+4Z2WZ5Heqcc845dya2cnDXkhJbvPd33n7gvv09rtusXTwmAEgiTdtkaXIWUFcLLoymth/68R+58Yf/KWK5HACH7ssEgIIF2DOHd/7l7Xv2Llk9G0IlIr1+FZrhTDuID311+9z+vkm0HEIIYCJlplKz3m1EumarIyIC2bgP/HGUzVy7a3SrQbn8R0SQ437RCUeGCEdVz5cuMVaHocriYGluaSkTlFmroASBippaAKCqLdES05HQ31dPz8V6icJyCAMOGaSaYTZ62bRaXk9EPNFNn8pOVGajlyU0OU1Qrm/WvWkwjuREBLBpBvjt73z3c3/pDafUUMY555xzbvM73d0nN41cEqLh3tvu+dgHPkYpalIKa55v0zSSc84i0gJQQqlrf82PvvbG1/5TBKAK2lW282isuMy4H1rBH77lAw/vW0o0baFOYkSUlxdmm4E8/LX+3IHZtBKlCZEih9AF0bM8Ibya2s+Ijb5OR70dE+PQ8uL++SPz7QD9KDHkSMIQRlITIyPOHBdidTD2DlTbHutte6w3va+eOhzrJYqJWYlZmdE9ZS5daSb+GA9Fty3r2o1aqczHGxN3XwOAeTK1g4iM2Th86JaP6uSrHDqNDWKdc8455zadLTvjzgxW5MfyH//OH5NUFJhgucmlwSIRVCVJTpINhhCUzAhDtM/7rm//3h//Z6gAhpnYatlJmfblDMwnvP3mzy3ajHGPLKq0ZFpxtZ3Y7v/yzMF9VbtslqjXA3GABSYyJqJSD1NXNUaV6F1JzDGT7CWkjiMrSmN1lP6TiLEcuFEzFsNJy0SO8/LMGFzefSCknDVQNltJ6eDyUtej3SyrJDOFqVJOVvWmmjRcifWh/vTh2D8Y+0uxWiYIMRgMhRiU6tBTwlAaQAAys4BgYCZVqEBILYCsrDMwHTX/CUC33RIgKMNFREDZSHU8LGZGFMTy3gOHv3z/3muveVz/1E8L55xzzrlNa8vOuLMaGtzy3g/P712EcWnhMq7qNlUVTTl3CyI5JFFhPPEZ3/wvf+2NiLBgwiajZoqKLjxnYDHjnX/xmQcfW8jcQ4gcQIECaTVcxJF98fCBmWaxNqk4Utfnkc+gr8t6U9Gsmk2zqQZqyebawb6FIy1pIs2kCdpCVVXVMiiF6rDY/OyOPfXU/v6Off3th/rT81W/5ZhCWRugTFYqjsyM106olyl2DqM59VNYYlLm6MvnzEdfmWOtHP7y5g95qYxzzjnnLhBbNLgbwLSwZ/49b/sLpBpgZRUzgYAZzAJrNauZEcBUlk5SP/yH3/ttbAOCrV24yQAEGALLwK23Pbz7YGNUhxAokrBaRCTpLx3RfbtZF4klxsiBo2kwwKKhPvlQE48LSL5OnA0hhBBOfp1TGqGuVwsl0NDswNLivuW5AUkyldICpmyPpGZmwliq4v7p6a/NXvTVHRftmZ6d6/VzqIjJOBBCeeBGCjZhBRuPa2WOyu68mt25K9OfePajv018SVcwU65bPjGCGLLio3/7idQ9Ia+Tcc4559wWt0VLZQxIeNsf/TmlECkColTKTlgJYiqmjWRQSYEmrE0tb3zTG7GDkcwqjBoLMo+qWBRIwH0PDe780kOtTSsrjFVNRGKk2mxqZaE5sr+vEiIzuNS0TFptx94VhExcfkxcLyU6SuWr+ATBdPXyyVca4/DPtto+8qhHImpGyGSZsf/w4RVJbSCwqXRdd8QMxkI0CFiKUwfj1OL2nY9yb6mqBdEMVjrHjJqzAwQTdJ1ktJSim0rpBVOuSUQEZoZCTY2IcNLGVUQUjMQMBmYy4a6bjlkdowJfvveB/QvyhO2B1w7pcZ16X9it3U7r3Nva4+n9ht2kC+182Nrf3afOx+HcuNC+v45rqwX30m4FjIV7lz/78Ttrnh42w6leDwYFg1QlZ9MmNSJ5uq7atgXQcHrhq7/76d9zPXjU93HU/ZwIqsrMCiTFhz9xd9Ip5QqmZiQkxLECeikNvvq1i5q2T8YWjAzGRGAEYiOAEZkmMrqxQtnAJWarGVCmom3UA3LicwWYTQGoxfELAGIbZ3ejyWhv4/+FUgtUOsYwlSgfGTBroHO5PTi/ZGbCDEgSKVuXwliJTW0Q64O96UP96UO97Uv1VOLIzCLW9ewhMEgNQA0zI9XVlyvKzKYBLKxQ0nGb9qOQMcxKhbvAwBKMDdp1rycqrTJNFUQwFhgRZNiqSu7V//CPd1/54m8pk/gKLU3wv5FTyDnnnHNuY9pSEUd1tIpxiHe/9T19noHoaB1nWdnJAkvSimYAbduaWSahqfijb/gJBKScsLacOg0TcxRDI7jtc3PLTUhamkRyaVLOAEmaMfTaZto0Ggci6ua5+diSm1NktDrpPka2ZhfV437J5EdpF7NmiAgCW9HcQJctHWmWByKpbKVkBiUzE9PEPAxxsbftcH/H4emdR/oXzfdml2M/cTzOsyhLCIyZItGaMh5iXm0Rc0yd+gmeRrcgoawQCKCyRxUAQigvPNgQY9w2Pa1in77ts6M2+zzR/GcToBM49/d4dq3f43fOOecucJsm5ZyYAlqahpciDACH98x99CMf11F5BrpVkqVOxrJliJAhZ0Eg6fGP/B+v7188bWZVdfRax9irxWCElvCFex9YzmpMqhmkJaWQ6TS4XZqHaKn2LncXwqmOrY1myLvm57TaqPEbV5o5jsdBzVYgC5oPqxxYGQyScmCFKcxE2QBj5XoQ+EjV27Pz4t07Lz04felSf0ei1TdnSh/6ktI4ME8WqU/kNi77Q416OJbsflR3yPEfmIyVTEQMJiMY2CgYB+MIUmIjMkDN0kqzooJPf/K28t4EFFA+tj+Pc84559zWsAWC+ypVBQMN/uLdH4gUVRWAqkwWaSRty+UA6l5srZ3aNX3T970c3EXbUjwzVrJoC9x+5+75QWt1zb2qlQyAoWwIBrSDub2PMcq2ouNGKF9/CenkjPh6BE4jiJGYCUNgiKFlW7G8YnZoaWm5yQCYKzETIwMrYsP1cpw+XO/YP7XzwNTOw1PbF3tTbazk1M4UnlhaWtDa7H5Uyh9n95Pf6GpfzNK4hhSBY4ix6t1zz73dK58tdS4755xzzh1tq9S4GzBa9ogaH/ubvw0UYIAxcyi5LoSo2qa2BSlTIGiTGuvh1a99Dbat3lJd15M3LIZEaIHP3/fQkGtlEpG634MazEBaB55pdXH+SC9WaWW5ClzCvpkdN48S01EpvWR3Nki53AxAGD8vnLRF+9cdGIKUMM2UVOcHg4Vm0GYxUQLUrE1DMQKIuS+xWhSb780e3H7xyradwxCFWAwKi4ii3WrUGKKo2qicnZhMjYkEtjrpbgwgQAnlJQFKCx9Q2eK1VLGDQELEgBGZWWn2DlC5nhkbyIiMrewsK1nYLKkYhcDRREPgv//MXd/+vGt7gBrY47tzzjnntqjNHtx11FaFAWTVoPzpm+/MK1aPnhoRjafeRWT8lUbgXh13hFe89lU48eR4ICTgq49isQ3KMcGIwCGo5RKng2rPpMoJWRgB4/Wtp/tM6CSP4syZkjGpSZPyILdLaThQAcMMAZZNRJEBoWpoWFJemd05P7VjaWbnoJ4SM4UaFAYODKBkd2IKYNGuZoaZS5eYco9MLLY6zkR07Crw8YVEhO4TBrRsJaWiXQN8qMKCkZqQpUCWkChY0Bzqvskw57ZiUZPyYuEU3uRwzjnnnNusNntwx6hvIwBEZgAfv/UTlJgCY6I/OgARadu2WzYKGGOYmp/4338c9QlvGoCZMdH9ew5ob9ZyZjVFAEXkTEQMCqZ9Ys4ZmqvT77A+LmcnWy2bOckK1NPFzNl0IHmxHa5o0+aUTRUIgbJmUVXALAzI5qf6h3vbhrsuX65n28CmxgCMM2AQYCK7YzW7lxdOJbszqKwPLgO+2gKSiMEKLT1/GFAGGYPU1IgJCgak9PNhUiOA6lAFWJDh5Zdd9MQnPv6yS3ZeecVlvZqf8+xnVb3YWEopVUYvfP51YdRSU7Nw9PDunHPOua1pYwX3M+qEulobYQpS3HXnlyQDgTHqvUhMAhOVNpc1lgziTNqy3PTq/wXjJpLHfUhEy4ZHD8wttaM6DApGpRRES5F6BaOcIRNVImXfUDu27rrMx/Po9cba1uNdM/Lulo/p+85GqseJ9cfr8j5qZ4lATcqL7XApNQ0EDBWk1OYYS+LOiAuZVvozS7suarddNOjvaqnKlpGVjAFlQ/c8SEt2Lx3cjzPvPlo8cLxJ96Mf9HjSPZAI5aASSMzU1F50w/Me/8Qrn/60pz3pCVc877orKoBGhzkAybqK9xZtRJA85NgLRFDz1O6c25i8z7dz7qzYWMH99HWtA0t2JcWnbvm8NDbd22ZdDYZplhCjqjYqqCJV1crKUh2pzfmGG1+AXYQIOnEV+dBwZBn7jxwJ1c4kWbs7DSGq5mxMGqjJqapiu9wmUL/rO172YuXSbJ0AEMNYSYOxkAawQcu+RTT6ec6w8noAYBjBupceSsbGSsrGZjpOxDRK5wwSjHomGqoqpqRZBRXNDxYX2+FybhooApfNkJirrADXwrxE9aGZbc2uS4YXX7zMvWEmNSIExGDZACZIMLHRRk4cOGTV0asdpQCwWbdal8jEQGwEw6ipezNs+lN9ZGRtxSTGgISUc1XFpI3IYFuPr3/mN9/wrddd++xrn3vdN41fiBhWy4fGL4HqrmU7+qgBxNi177GTHEXnnHPOuc1vswf3tRR33Xk3UTBVoILBTAlmZgITWDZpV9pApEAm+bYXf9vJ68oViIT9R5YRa2KGMIHMGASiABIwDJxU2qQWK80KI5BRl9rXKMmypHWBdWtmrbwzsDpl3uV4YiWw6Si7g0d/0jETNwpmsjIZb4QmCQKDw4qkhTRcyk2CipmpQhSWTSmHqqW4wv250Gsvefzytp1LHBNHJaVRixZjhVqZGideLVUnYowm1JlIJmaSiAilroZYIOWhTk1P5ZSZmY1NEyzDZKYX+lP4zhd/9w03XH/9/8/em4dbdlXl3u8Yc6619t6nSzWppNpUKn1XlYaEQEICJHShFbwQOkXkivdTrt1FfZ774ffoVVHUe68NKCqPiqKioiKICNJIE4IYmjSkJy2pJNVXnXP23mvNOd7vj7n2OafaVEgIVafm79lP6tQ5p9Zea669d9411jvesen04yfgCIutQH/MFtP9fyEniB/jHP4LYHHXPvM6JI61dTjWjvdg5HV4asjr/D1kcQn3BrfcfHsMDIR3SG4TAoFm0YJZMCu9B6yxxnfcFc959mP2kRqwc3pGfWFULTQGk+QNUVHnYghUGRIzsV7hS8RgcoD8dkpr2mm1O+a0u2C/UnFyvR/iPTGf8r7gl1pln/7iMLR6ejDcOZgdSFOL0RgYGQgYjBSdJXcCM1NL3cqT6qLb0AnEi0TEuc1ShGAKbGT7RiUAdUrOF91FBFDSVJUc9ZICEKZhqCTUuyY0RKxKdCv3jGdc+KzLLr3yGeeYoVBoOhSBeljMPaaZTCaTyWQyB+DoF+5z4pWo+7jv3m9X2nWuSJHuc47wwBgYATQxEo0r9YR1q/S4x3BXGDAAoN4EJFQ1ttrYMBd9qDIEBzTxAhWT+SFKBhWhQV0KSxFokulMrZxpaxQizQ1qL0xlbhwT2hlSSMmNArFDSHoTQGBAzWb3YHb3bL9mNMcIwqLRIkl1VB06P110bPkqW7Jmtx+j70RSSQARe3nTRQUpnJ5CzrvV9yu6Y+G/mguKIRtFTOE/lHrTprNfcNVlz7t6oxcQKNsuVVggYFo45GSYTCaTyWQymYNw9Av3uVQZ4tabH2hqcQC8M6YcQyHEqQyamoJIRqtFGYwbLzgfeGxPhgJbtm03SpLdzquRAhqhSnWO0aGqZsnpuj+mQhqppmImIkYqlREiQkeLgKNQTCgRphQKQcTkbZ+zrM97uxUAzVLqDChxQWuqLOhJ1Whwbiixtrh1184IMzEKY4RIai+VBq4WH3xnVzFWr1ozGFuKzhKBa1hDIAIHNHsffhsC014ESbpcacNhJBnmMVd0F5Wmrn3h634tzonCkSJ1t5IXPf+Ka1549do1427Bkqczp4ArBHALkz0zmUwmk8lkMvtw1Av3hVrvqzfcKFII3GAwqIrSmVLMqEJEkqSRzvmGA1V33vnnQQ5pSRltP4gG1aSTRURkLjweqeIuVc+Pjc1s3xrLDuFNoAIDVWALAtqTdWdB3b19ivS1PTHFak5NODMcbJ/dEwURhNBIS2OdBCZuqH4Xy1ntTZxy5vTY1KyrxBxNKC4Z0yl7JcAkaY4DGdRERbiv051G55yIlKUf1jNlwbVrl73mVS97zhVn0dAt2sNNG8DCyB0CEhZsPmv3TCaTyWQymX056oX7Qh7e/GjpKgvwviCNBGEEaDCzCIuMRakxCsnzNm1coNp5QAnP1hMDAiYQFQHEC5J1JkXGqLIsJk9Y0X/0oT6tU43PRzGO2H+40j4Npkm7p8mpraP8ICzMfZx3CQki4449u3cP+1FBlUgSJBiE6UCGTnaKmx1bUqw5dWs53tfK4FXS0SmgkCCApINMm6Uln4xSrG2ObX3tc0V3QlI0pLReGm3qoXPN5Ref8oIXXHHl0880LDx2ArC2IVfbA2p7cxdegh34dGQymUwmk8kcyywi4U7s3L4rBqmKwsMhRBMDoES0mCJlAMRo4v2A/c5yB9cmLx56wyMZrQQoUUXMEcQoxcX1oePHr9ylN+4ZDCc6kyKtd0dTO+feRvo2HXL/3RfM9ZdS2gJ8W4wfleqR3CpJOidH+6jndfOOnU0MkULRYBYJMsXpSFAdOD/tO/3ekuKEk/rdqb4UUXyrn9sMSgAKMVGZm4EKQEW4oOau1Nh63A1piBIiQKE5ic5FkXjWpjNf8dKrNm1cWqQLnqZRdaLtvs8ffArSSUo+8z3lye36/17F++TsgsyxTH79H5t8r857fr19D1kMwr2NO4+4+467EX2ARVpP27K3CYyce5EZ2Fh9yhnr4FNhN3WxHticIUABdJxzwmDmFQoHjU5dUIMJaOYcxye7K1Y9FH0/1ltndh8/uUQJRjqICGLyhUOF0upymqbW09Y+DpW5SrO26eeSmkUNgEtm9gUjmQLNjChdE2MdmplBfzrWNBE61jSlgUoxIECnpdhZTcalK3XF6mntEKUThSmhQkDgwGhNaj/VkdGeZISJiEtCHUL4KHCkOmfW1GHWVz7W4oQWmsLVZ5+5/mUvueqSC1c3Boek0um9b48srajsF5Ope/0xWvhMJpPJZDKZzF4c9cJdIYDQIIrBoC5dNSoktx2rEDMSVBUPCdHqslOW3fJwDj21Tq48fnnxyEMd70NofdgUJ0KqpNp038S7sjhuSb0jzMTYqwd0RQk1M1VEIPlIBCBocz2oj4e5DHgHiFOnKk6GsemHenYwmG2aSIGoQkkGo4lFIKjbrX532dOVJzcTy2f8WJTSpSFSpm0Jv7150B6xKOcq7iKapqKKOJLJOiTiLEaalb6Ioe4UGAymT1q74mUvfd6Vl59SKAQodd/L8bkIy30luWBvyZ6r75nMU8RBx0XnWtp3gf1X+uc51gAAIABJREFUO6/zEyEP7sgcsxz1wj1JPxI7twWnbi7MMHm8ozB9Os4JRxVHi8uXL3/MBPeEA2IzZGy07LXPJw5KcY4hJE+LE0FVrjjltC3/uV2t7tfDTuXgXIzRqypTrGNSvm2+4xxpL9rIeUu+eQAQztfXZfSHikShCc1CQ+6Zme6Hug5Go0JN0IAmMCqBqNhTlNvHlnTXbRhUk7XrRHju3Rc7v4ijD0GS6hSARROVFIijgKmAcKbGSKMXNQuFoizrN1z78he/cBMILzAzi0G9/06r5rktNZPJZDKZTObALALhDgNUcf/99wNJ+1IgJnAHkubO+f5wsHzZCkQcemwqRhX3E1csLe542ApvIVjcK0+mzVoXmLplp2x44Oav94ZxZtivxJW9IhLBDKoglWQb9gJHHWUhzheY95mKmlR7Er+U9vcbmHo3CPXsYDBs6n49pIDqoIIAkkEYRAzaaNn3uqvsjZ927g6pzHUaOLKNt6HAxPZvosV+ZYwFRfc2bUbBomDTzDqJV17xtNe9/tlFiRDghHAiNIEyGqApo+bQK5z8+of+TiaTyWQymUwGi0C4BzNVBdA0TbQ4J0VpEiFpZml/WEMlGaybGMqybEJzmBVhAcYqeMVMPSgKV1vqFTWkXk6AQAjmxsb2zO4OS5YMt9V1DLuHQxE3XhQgjFaKCghCVEEIzEv61+3+CtsuUQE0DSwFhTARAGVZDodDs8ACwzDcM5jt9/vDpoZTgcICCVIoINmIG/pyB0oevyoed/wOTDTwjJ6iAgBmC9tDqQBExCUzjMCYOgKoTlP8u1FJs2CAFYUDhc30BRs3vPral6xd41Mrgab7CBEiHtLe3hA89l2NhZX+9HUW7plMJpPJZDIH5KgX7vtgtNToaQKlQpB6QDHSkqpOhGOd3mG6qUlMdjHe6cwMQYj33jhKMFQRA0F1WgPdJUtPufiS+//1n8Yr35jsGswqOihSvTzJWHUGiEQyeU/maDU12sxFXfA1gOn+jCsKODeMzfbBTD8ODIbCW6vEY7oACJQ+3LS4ftntrjl1undcXY5FlFHas9wObKK2iS6HZG4AalpX50lryH6vo695wyuf9az1qmm3DTCIb9eTQCu7yUPK732Ueqrok1TNbplMJpPJZDKZA7DYhDsAajtXyUZi3UaDlnTkfR8MBofpplaiKzjx+OVbv709gqpqEoyAUoxUBaUQN2yGNTG5fFn3+OX11kdgVsfGDWmCrhYmXg0OiKIgPNqBULog+iZ5YxZOa7I2Yd1MtInNzGBmT3+2LlhbI4B3nmS0SNIsimnjq35nfE9vonfyGdNlb7qJTp2JayMYxZK2FuKAJpk55greSUw7EQLDMHR+cP75G173upevmGq3R1Da7lKDKve6HHiMgvs+9XWzICKqQkbs5djJOj6TyWQymUwGWFzCXSOo0gaaUA8wxsigFgLQPLpt6wKD+6GGljqgAU5cPnnLfQ/DexFR7y0EUE0oIhAEi84XdDoMnePPPuuBL27rDvrjjoPYYGBRu+MeDl4B1VTwpoNE0GheFmp3FViS7HM1eECn+zMzg/6wGQQ10dKYrEFBnRJCoFHXN8dqSb30eEwtnR6b2hXY7Y7Z3FyjtsS+QFnLqPp+cBxEQKKhDI+bxBt/8PXnnrei40CYA6EC6oIkdmOa5zT/FPP9tfNwNNcqXUUEQHHfV7/WhOG6dSeVxx8vAJy27QW6mHX7wTIlvntOoZxikcl8r8jvvkwm86SwCIT7vLIj1AQOCoi1n5IEGFOaSwot9wXVtmzZhgjo3D8+qHY3oIlYsxzjFXdFg3pAVbw1kFQtFoOaERAXqk735NOKbz/U3H4bh1ELF4X9MAghStUjioIWwTL1zgIp5V0JRgAIoRER50VFh2iGTaxDbJomGCJgzkUADSE+gvDar5tgdM7NSLl7YkVn9QZdtjSor1k4782ScjaFITWYYjTDqTXnpzBIFTiIpcZYoSOlqeuy9LQw6O/qdMKFF5z+lh95foreRLtsNj+2aeHayV4XB/tK0DQRVYBd9Y6v3vwfH/vE/bfftXXr1m5ZkRwOh1VVTS5buuGs059z7atw9kmoA0qFIobo/OFdaWUymUwmk8ksUhaBcJ8nphlCMMjILgOAimR2JyBGqGoxHDSHKf1EMKaYdFh1XG/PtmiiqV4s4ggDCBVjGwgTnNuuxeoLLr7n4UeaPbubphZjSrfZMb276ztV4bu+NNCJiNDDKcSN9rSoPI21hcCmHwZ1iCFEiprBEE0jSZgBoDKa1lrGstxF+GVrJtedNeN7Q6cBEqkKFSpgwgPZ2TnS4PtV3H3hwzB6L81wpiiGq07svvbal56zcalrfz8tCr5D5SwAsPXO+/7yf79n+q4H/a6ZCVcudV0bhjisx8XLMDS7Nn/zgUe//rkvnXnF01/0xldjzUpUzhUpSP4pyu7N+daZI5/cw53I65DJZI4pFpVwt5TXPhJXcz2pnFfx8KUCes+37oWlOMjHEKDJsrIEOGvdyru232diJoAKVNVoqc9TFDQK4LwVvTBZrLvsud/69Ce1abzVMIVCfNG3pt8fTEM6zlW+KErvLMqoR1WJZjAkaRaiRZs/jAhBRIxsTKBQpSLQVAe+M9OZqNZuaCaWDarx2TrSrNvp1XWAoZ3SuqAH1trJSqPRVHO0RholGZugToTRd+M556197bXPm5iYi6Uc/f4h5etjKnpzsnPP7rXr16Hfrwq/Z2Z6++ZHxr2vaysjOq6IlDLI3Z+87revu+GaN7/2tFdcA6GUDrBU59fDep5MJpPJZDKZRcWiEu4pliSCoGmafDTCzCAGGE2iNYA+es+uFadNHVYoJOGJ9cf70movVS0KutbSHWkCSUV3gqJwfibE7rITVl10ydbrPquwkvQxxojG1CsgOj3oD13tg6t80TTN3M4rDIAqRMQEJNuOVW1lOAWBNJHg/KzrhKXH91au708s6WsRQHrnIXVdp1o791HbCxbjIIepImZWwwadMVx99WXPveoUbdPq45PlN4/gig3rfuF9v49BAAhRKBBsxxeu++rnrrv1hpsGe/odczqIY0Rg89E//POz77r7BT//Eyif+JNnMplMJpPJHMUc9cLdK+KBC8BqYq0ud8rYlo3rpvbOxyFvvunW555y6WNrUQKEAyYVZ65dccO9W7VzXN+MKkqlUgwigKjBlBBxrqgi3NjJp8XpPbvvuLkzs7vXWKkKQaAJ4Z1GEEmyz410haSCePLCJLNPI0YSlm4HlzQ2kN2Q6Wqst/5UXb5yj+sElKZqECgQ22ZRShuqI1xQZZ9j7zjIGExEyVAUoq5euWrs2tdfc9KayojU6isUyJOg2tOVFVRQpCgaAgEKdHXJcy++6qpnXLV9z7++909v+8SXxk1IqLGYGd70yX9ftnL50970WlQCJ6O8mr1uGTzxfctkMplMJpM5wlkUfoMICFavXs0R+/zcORXR9KPCF867oujdcuNt6ac0WDz4xqUt1TvggtOWTRXR4gCjyaki0kpkFWmlrZmTWFb1+MTx51+wZNNFu6qxmaIcCKMiCBpYEEZBIxzGpokhPYYWAuPcI30zhhAsRtEBdDdlq7nt5Vhzwuol5z0tHL9qd9EbuDKqEmpQUNsQyZGOnZPv+x4RMBfsQhN14j3LyiB7Lnn66W972/etW1M1oVFEwCTNS30yEJE0sSkqUSgqh0pQODhBr0RXccLUC97+tpf+yBunK2kYFdKD7zb4+Pv/Zvt1N8BEHytlMpPJZDKZTGaxctQL90iIAIaVq3siQpU2FxzRwDQGVNWpmz/S4Wwf0G/eclszAAgq4qG0oAIKUQWOr3DW6uWVBOdFU0eUahoepKoUmFh0IWoIanVRbC/Hx8/edMrVL9h93FS/8EPE4NAoamEtrB1q4RDWjB4BDGCQGMAIkoSRlCFle+TWbmd27drmnE3FuZdMTyztSyXiFSpqKlZAnIiIQCQqTIzSSnOTVqQzafqFDan0Io6MJv1Od3jta69+zeueVnVBwvtCxO0fqbkv3FdI24G9OAYYGRuryeggIBCGsJB2DYihGUCBjm541Quf99bXW6+MIZjFjslxtfzV7/wBRAGhhVxiz2QymUwmcwxy1FtlnABu5MEGQIUKOT/SKCEiAgcCxqLomMX77v12f7rxnUI91B1SCLbTnLQLXHjqipsf3FZrEaUwpzFGdU5IkKoEnFEMVLVgGp2nYHLVmvNe/NJ7v/CF7Q9vdjFUkCqGEvTtY9QyChgk9bpSBPSmMEFQnXFF98RVS1euihOTM9X4TnoHxzQHam4f2WYkmprYXNFd969PUyDzw1MNYt43q1dPXXvti05cCQc0sSl9QQPl0MNPDx9DBIKJoQiGosRMH488CgXGO5icQOmg9FQIIcR4efb3XXPrv395y013VqZi7Kqb3rb7pr/5x/O+/yVSFogNXPHk7Fomc3Ty1M8ByGQymcz3nCPrI/47j9uLgOGHr/31e+/Z6p0fDGbGqsqNRgM5YV0PYjMUpVhMZovo6h/9yTe+8gevwWEpwAioQfrAv9+560u3Phh7y4b0g/7Qq5NAjSSjMSKGyEaiCCFGCeasrmLokfWO7Y/eddf0tx8o9+wZj03XmsqCi1GZZrsKgCjRYmzggh+bFZGJ8YlVayZXrx1qORQXxTcQQo2ihNmc6UVpSbjvZY1RgjYamwogjnLYgRiHohQadHD55We/+MUXVF24NjSTe13ztCb5/V4q+5yr+YlRo+eYowkwxe4GX/761ptvm35468yjWzSSlH5T91YsOe7UdSuvuBjnnoZKkfLa+xG3P/h/fuynx4csowGYKWGrlv34+9+LDlAoQsrd0Tab8glcgR6+0Hlq4iCP9gFM++//sRmj+b1ahyf++nly9/O7vQ5H2vFmnhryec8s5JgqWBz1FfcWBYjueKeJjRS+6HRBUCzlq4BKCilCAZKfXYV68zdufWW4hgI5rGUwhesAl5w2tfmRbXds26md47wKAFVnFiACCkRdKCgRpKjAaxPLIL4vKJedcOLUsnDyKd1+f/jI5u333/PIo1vHfCUwppJ+MZrMqm7lhjOWdCcwOT5wfpu4IJ7JSt+W2blAoc+JZMNoxlH7d5n/WrhQaZtoJIbdMbn22pdt3DjhFWlpDjBv9juirf83EYMaQ+74zBfv+8z15fbpXpCqiVPRpAGgpuXgoZmdj9z04C13nPmiKyZe8mwQUAcRnLL2tGdc+MDnvlJGmKCImH105+zn/qP3zAvRn9l8+51CgBoVq887F1O9w7sAyyxa8v/IM5lM5sklf64egRxZ1yjf+QkmEPGuX/rQxz7yOYPCpOsLT0sVaC8yrPuxbtSZYAgA9CbmOsO//egHxla5w9h6KiW7YBgqtjT4u8/eub0ug/raVKSIganpFBbVokVjjDAqAKNFEzMwOjMfo6sbbRppGjTBNcERJgagDo2IaOEFjvCmRePQZ4xGIZxBSFDTKhkpC7wyey1dqsRTgTaqJp3m9vepkNDYjrPPXvv9r3nO8qUAIYQRAEW4MFp+joO+e+dHMo2eHAAQ4rB0FXYH3PPw7X/y13hoWzW0HgSMGqMa1RTQCIsCln7Wml3HdTa+9dX6tI2oFACauOsrN/7p239xcgioBLCGuapAVQyHQ2sIwERrhxPOPv3N//fX4IiO7LMzh0OuuD+55EpzIq9DIlfcM98N8nl/ajha1jlX3I9OBGNjVbRGtCrLAgaDKkAYRefm9izwvmto+MmPf/rl1z5PeofY7sLXHL2KgFNOnnnuKf/2n7f3ped9FVPiOkGqE4OKQg0gohlVRUxMQKgphoCWXnyHZSOEj1TCSIzSEoM1YiLUGGigK8pQ1z7Zfp7AG0AJIggMYtDB97/8qmc+a7UvEFmrOVFXKOpgC7t4D4v93iwKgCjNYbau//0/b/zbj01t7y+XQgJhIWXSp52hiUWoU63tOJOwu777+q+ddsEmNEQhZDO16ZzGIYAqIoYu1A/JwbBrtNi6gvoFHrn7XgAQGdX5M5lMJpPJZBYhi0DmzM8YveTSC4tCRGXQrykOgEEBFXFFUUJdE0nonMkkBv3kJz4jHQAHzBhcGJiSdH8EgkOcUpy3Up91zjpnQ1840eicic7no9veFei5WEaKAhoVQWHOmXONdwOVoBpUo3PROWhh6ijQQrx4BlRSKjzoRYp0OEj5kyNwwMtNMQDOexE3HDQiBIYq0yed1PmJ//5fnvuc1Z0CHqikcI5OzADvnUAE4iAOIns/xWPTLpihiZgFP//1W/7iIyt2NpNwjAEwURaUgvP77L14UGMofdER/9Atd6IfYQApZQEva08+yVIcp9BTNNIZHEQdVFUVqjqxdEnrsDceYfeQMplMJpPJZJ40FkXFXQxUCNauXdkf7Kk6naLwAEycMqUTKsU7VxobQAlL1hRS7rj97gdu37L2rOMP53nm6rkKK4I+bcPY1sHKmx7cGsSZqIgSiKAKyDZ7UQTClK1uphSmUJeF21SqRFLS7FWkeMtoiO1zpe+3GY4HGXp6IEgCMQYKrPBGTve68fnPv+KKK05ye592nd/y476QO3A3agBuuvPLH/iHNUNUg8Z5VUL23nkRhYCj71m0oNYtJ6Ctc4kCSZc9JEbrkJaOI+sPqCa27MTlAOCgRZbtmUwmk8lkFi2LoOIOoK0un7BKJo6bIJmmEaWBRIAjqeLEKUWtzWU3iKkDjO99zx8B+1TcOWrynHskNEIN3qCFQw+48uyJjWvGur5JVwIiIk6hIirS/kfgCKU5MGlPZfqRg1fxUFkY2CIiqpQ5d7kYxASmNBWYmKoDTPWxT1yqlPtSnG/Kbv+U05f99P943XOeM1Lte+Wv6+jxOJjLa+eCJgAQiILtu2/724+unKGra18UcycIMNtnJpRYVIuKWuNQ44oN61C0HbVJozvCwbkUyalGNbi0PgaAalGx4ewz9jpLmUwmk8lkMouRRVFxTwjEY92Gld+88WE1Z84LTQymMCjEKM650hgNqjAAKmLmPv+Z63fcP1yyujq8p9Gk6J2AwFLg2WevGIi7/aEdsyEG9QBIEVh7vQADnCidiYmKQC1CoBj5TwgAIkLQRv2g1BTGPsqmF1ANAKx13UiSv3MTUucaSZkc5qOZSxJi7C9b2nvZS198zjlTpYIG2Xf2aLshfVz1/AOSKuQNdtxwS/PAI0sHBFD1inrQjG4y7HNtYCYmogGGwtclNpxzGooInau3q1Lbew5plUb3KxQALYpGwdpTN6AgjIgKPeoVfG6Z+s44/Fzzxb3CeR0yxwL5df7UkOdFHIEsgor7qFosgGLT+WcQjXMuxgAoBTSkGrx4l8rhJgjiTTRGwKTC2F/+6QcBWASISBgEYDvQc69nUge4uVlPgAA94BVnLXv+ORuO87VHv/AeqsZYlh6O5tREVcoCvqQ4M6/ihBRQnKXivFKUKfgdYm2p3qkJgsBUgoBeKY6uMKj6kqLqyygaRYOqqXOFF5HkgBdVatAyFJ2ZF73o/P/xU6/cdO5UUvaSdn2fGwn7LuXjWnc4pLUHADTEDO7//Fd6lGT67/dnnMFZurRIQlyVWGCdt6oqAojxsfLijehoexWiDsN68+aHRSUueAYASpSuSIk9dV2vOu9sCHPRPZPJZDKZzOLmyBLuchAO998rzjz3VDIGmkEjaSQFcSTAxXmDpg5RUL0rFE7o/+Wjn5zZ2ihg1kYptitzyAt1BRxCB1YC556gL770jOVlKMN0xUZhgC3ws6igEHGAtqV+kdYEr5wvIS9cClXd+8CTsdsEBk05lxQQbWBOiBEAJNBmRGZFps/fuOZnfuIHXnDVuWNdqLRzjb5L7HWgD22J2/c4A2ALj8Bkr0MkGSEiStquwezOjm58+QvRU2MDrzAi4pZPfNqGNTCv8uec7gIU0ELdmrWrMDUGJR4rD+eJvroymUzmSCV/sh2b5PN+DHLUW2Vsrz/14ksu0EKdKRZ0MZJmIiqiqfGRrSukrpui8CIMw+Yv/vRvf/jHX+fHDnYpc5C5oQKFFeSkuDOmsOy5Z3/x6w/cvXnHHi33zPZ7nXHGOnk+zDmTghCxCAXTUFMBDCoASaEjJTViAgKaUqOhzV8RwCBIByCiIISqBKhEJEUQvRs6N7t21dTLXv7CdWvH5sw2AGKg89/dt7SZqShm+/VguM/CUdoFi62DXdM0qUBTV9h40XvamXjO0zCujQSJTYkSM7jx3z7vW3VvMqfaRRywpNeD+qHDyRdeCAFU5s5IJpPJZDKZzKLkqBfuCzAAExO6avWJmx+cEXrAgUxi10jRpLY1Rb8A6HbH+v2ZsW63MfvHD33smpe+aO2pS0yohRy61r4ABSCkgj2REwtcc/Ha2x9d88nrv1F2yhAHIgggBYSnCiiW1LYaCbEImKhEYv+JpSKavtva15OHXExTwgxVGQETCY7mXGNx9ozT1j77WReedVqXaVoTDGgr7d9t1d4SDN0KheN8Xv7e4ZgCZbIiQcpyehAwXnH9CSe/4VXoASoFKnVAjfs+8q9bbv1Wx0wJESjhICAFEMIRIloXsmLt6ra7N0v2TCaTyWQyi5ojyyrzBFBAiegcLr5kU7QhxSigaIoxoSCSUCl8a1kB1CKKomya6KUa7g5//O4/YwOFIB7GE863dKqpowgBBxTAWSvkh645//mb1o/bzJhj5eic0AZe6ZxLTnSoFwdzYk6iQEVFBCpUSXub7DRJknovFKOjIULZWB0Js0jGopSyE5zfdcmFa9/6lmve8kOXbTi5a8nLngLZDwMLsZ2bmmaymtnIMFTX9eGfAxGBAutP9EsnjAYzxlh43zAGi7QmWhMYzQmhwxB39Qd7emX59HNP/rEfwPJJlD6mZgUTPLLln9//V50mFgaBJdUuhBOxEJdOLSnojZx1svw5l2fJnslkMplM5lhgMVXcNeWfX3nlZX/3wY+r68TWKSOiApoDowDOq5lZAEFQ4EDGyNJ1PvupL37581df+oJzD0u4A/t7MxQoAQKlx9T63slrL7z+64/eevf9M8GcK5pQM6qTgqlwrEpQTAFSQUJICkGmsjSFImKIERCoJsGPoM4cAjQGm53sdi666NxnXHLSkkkIQANYK8rHt3Cq6QpBRDBs1HmIoAFiLOEQwdhIWTzmdkQEpSBg49XPuuOD/1TAKuieZugKrwQJAwcKcxYdBqXq8snzXv1yXHouxhw8CXUg6ohHdr73f/5y2L5zAo60dhoUoYAQ3bJyIqoSlZNrTsDU2BMKos9kMplMJpM5SlgEwn1+zL1CI3DpZSdOTvVmZsxxZDJJhWSBA5wW0DYvhgyqnmhIKllp8d53/8mlV/1Wu2F5LCkorVpUwVwuerKneKgnlglecdGKKy9Y8Y3bt3/tjnt2D+J0HaMF9R2Ixja1XUGAVBETExIgyXRUFIqA0QjxaVBoaEofVPtnn37SxvNOPfP0CbUk6FEbIVYVZbsih65Dc2E8vbR/JeAKDIk6QgTqIEATpVvs9fuHQICC5eXnnx5mb/zYJ3u767IvpYoSCjQqs4JpF8fXr1mz8eypK56OpZMoFMohgxfnomLbrj/+uf+vuWfzUtfhYOCc+HTfgEajUzfW7aoqyKHamRdtRNfN2Yy48NWQyWQymUwms7hYBMIdc2otpqmjgvMvOPOLX7jTRJVmArQG99ZZreqpsEBASRMRUkmqlt++f8t73vXX/8/br02/CDEcQLGOvsOF32mRFI9IgtIDmoZLCrnsrKXnn7X0kT246+6td9z9wK49042ppUhyusAoTJNFY7oA4MiMT4nQyNB4hYoWynPPXH/maWs3nttToAmQCOfaJfBqAkGaIvu4aAgRRNz5uetuuv4r377znkfve9AGtSuLyWVLTjxp7ekXnnfJq18JvyALc+GhLxy/5AUO8FY++9KnXbjJrv/ao3fdy0GdpLVXnLFhvZ5xKtavxHiFjhpNvQKo0l2CBx7+o1/4VTy0vZwdmku19nZVOboAq6oKRCPsSzz5wnOhEdqm12fRntmfnOKcyOuwuMnnN5HX4anhSFvn7/b+HFFxPUfQrhyCwzwlZpYK2H//oet//Vc+CBsXjQ4UpYOo0EGdiKNZqC00iI0ohTY3hhOw6Orf/+PfOO2C1aNI833q7gTCKL78EHu819+iwICINhp+6048unX35ke2bNs+/ci23f1BaJpAphFLNLNoxlD3xrpLJrpj3XLD2lUrjl+ybs1Ut9PulMxl2rRfcN9X1dwOHPIMD4fDih7R3fqhj/7rhz48/eh2NVNCI4UwJ64oAs2cdCfGXv3WN69+yRXwiLF2rgSIENFEoJj9xq3XX3/9c//rG9EpEGp4D2M7W3WfqU4kCoUQIaBTkCKiqAMGzY4vf+0D//s9fnrYjSiSyd5MRNsEeqDUYqzsdKoKQACHKydf+O5fwlQFMt3BSEtyMPH+xN94R9pH1ZFJHoCSyOuQ+G6vQ35fZ45l8ufMU0MW7o+bw38hJu2+bStf9Lwfj2HK4rDbrRSWhLsSTtRBGBsLDa0Ra1QIWLLDQwxSn7BuyR/8yW/3lio8DiLcARzE832IPRVLY4hIREIVEWgILxhEbNuGfr/23leVFgWmpuAWzDYSwsuhlkIOdiof6wzf+41vvu8X32WP7upGlRCrqjIzC8GaqCKVL4SIIdR1HcerjS+88mVv/+8YV8QIKGrDzukPv/uPbvr0F1xRnH75xa96x89CIhBR+AUTkfbX0gQEgRBBTWzb+ak/+rNbP3fd2FCLEB1N9z7KlAXZK7q9qlM4F8C+45nXXLn+v74SY0Wqyz8Fwv1gHJsflIe/nnl9EnkdElm4ZxYf36v3e/6ceWo4ooT74rDKtJBUVQDHLZGLn77xK/9xd1mUqgIDmfwnAiqE6hwYjYpR1jsAiAmNgi2bt/3Wr//uO975EyPzxUIPhnyHiyYwJEdHKu+nsHZnmT7wAAAgAElEQVSoQIAJh/EVkFFTqQIN2x+59DUQmSrL85vUJ/D2ZGydRPfce8+MhZNOW7/xrHOC2YazTt+2fdvmBx+aeWTbnTd8Q0LUSCfS6XZBufGfPxN2z77yf/0cCsWewc0f/pd/+eCHbMf0RABnh/d95vp/mvmll739bZjqtpcd6apHDDI/iNYl58uwAQrMhns//m8f/tM/L/p1MVOzjkXVbVfZYLQ0OEoju77ouaIS50wasT1o1l/5TJQFSRmlQeaPq0wmk8lkMouYI+ga4hA83ivIpsHH/+X2X/lf71FWKgUsKqEiDqlLUp3QrLE4ZGyEjSTriZjQIKEOoRjTN/+317/mTS+GS12qh22ePuCeSqtgR8q1VbGRVo6UeBqQRFsozQnQDFRxEABNjLpgPuhC4f6dVNyJNJkKDdAYRODaaVGAIACbt37p7//pC5/4tM0MXDBPmDF2i0tefvVlVz7rr977J5vv+FbZsIroiBORQaxDx9mSsate84pzXvWKeTORjm4cAGgadCpM19i89Suf+PR//ttn6i07K5PCTAdhoujAaGpp1hJGl7kauWzquILOeQ9gB+r+6qmX/favYsrBtYX90Z2Rg56pXHF/cskV90OTK2GJXHHPHAvkivvi5oiquB9Bu3IIHu8L0YimxvOf9+ODPYVFVxWlEip0EKUqoEpYKJzG0G9CbdaMxnMaYM65iGaI6V/6tXc860UXxAj3eIrs1lC9zGXOtMk2utB2vtD6fYBNK/c2qY/K1elsHViZHmyF5NA/BgAMa4jAuZF9p4EQrkADiO6+8dbffscvd/bUVcNmMPRViUJMUECcwRkc4SAkTczAIAgO7rjx9aefevrGc45fdeLU+ZvQ62B6un7wwcGu6Vu++vUbr/uP4Y7dlYmnKTTFtDtaGVUJE6PASDHruKIUP151ur4MwZzTQQzbKm56w8tOetWL0HNAe3qycH+KycL90OT/oSaycM8cC2ThvrjJwv1x87iFOxACfu2dH/jIh74oHCvUOxGhiYqja5tOxSoPWgj1bBOGIqKEEAqrQxCh+aackN989zvP2rROH6c7hmG+cJ523XTecCPzbZt6KOHO0ZineeFuBxWmT0S4m0EdSDQRcHACBWhIUZVDTt90++/93C9W000R4YiivYAQGdXF0w0BUwPgDEm+W6H0bogYwSZGqHhFSfERVYSnOkKJqKAKYM5QmIoxIiQVXkDHfJVUuxOJlKGFRrFj0r/8D96JEyfRDFB20tFl4f4Uk4X7ocn/Q01k4Z45FsjCfXFzRAn3RRufV3r8wJuujYgko9k+i06BSjueVH0hbuTqoAfL0pWkOFTDGbztx97+zVsebGpYO5VpTlMfhIjdO2YWTixNT2wLUxMBQBV6UJUpc02p8zYbAZ6k82XJDRPmUxwFg4A9DfpAH5g2DMLI+2+oZPzMU173Yz8yLCQwCuEgBcUZ2ko5JNF+7cQXrlKtmljMDCZnw5IhV1qxIrjJfuzM1J1hKEL0MShNHRTU+W5Uo5KqXt2kryaLznhVdgvvIQAibQgblrJ+01lYPgUxegeGJ2NNMplMJpPJZI50FlVz6hwKGHDSWnf2OafecesWixbMBHSmhJiI0iLEqyCqiHeuiDZME5oMYIzOi1cfrYkNrv/il885d828Fk8KngSkjX1ZwGc/9dlff+dvXH3Fs3/6p39aug4KKE0ByJwUH+nvQ6rw0WYXpik+GbKdo02ZAmiAAOwZNDd989u33jWcHlgI1eT4mvPOLC88Bx2HUiFAr1h39ZVTH/xQuO9RGcQ0car1oKuAHN1JSMdJEL1Od9gfEE3hi2YwVGfiHFAkha6y142ANBU1bVCJwvvKFeOuLNU51/r7Y4zDuokd1/c49/JnwNFAHC33jDKZTCaTyWSeMItTuKMdyISXvPjqX/36ews3TqIUjaDIfM9kaEwApXrXcQ79mWk4iFG8ARZi7ZQT490f/qFX2dy/oqAG+gNA4YnKoRCIEAJAIE+78JI1S1Z++Z+/8KPX3fb//uovrL3wpJQ0uf/kovn9PPwjOgSPIWDbH0cYQAeCAbXg3i27P/HFb33hhl4wITxRVd09g9l7vnwbTrrujB//AUx69Log0dWLn33ll/7iQybRnBjgDA4iikq9hQjACFE6igJhMHQi4jyMVVUtOIz2SsTQRv0UhXOi9WBYqHMiHjLZGyvFFxAYATGBEwIqqv2mrtasd5dsAkTSyRxdAyzam0eZTCaTyWQyABaxcIfBIr7/VRe8/8+XPPLQENCImHooCVC9wCLTqFGvDElRqhiF8xOOYM+87BKp4BQMEAEe2nXvxz/VbNk+GMxMrVi+7vyzcc5ZmOxIjKYQ78aX9n7/3e950yvesPPhbe/4mf/5i7/1yyddvP6JH02rSvef4vp4IKMTDWxgRIP4mS/d9A+f7G2ZWT3UKsLEAKA/0zFyONgaN2/+9OdXft/zUTfoFIhYteGkYdN4wARKUEBjoQ7GiaJDskYTzJy0NXLgAHub0m+Ybm6oIBqaaIwTZUdC7BTleHeskHQeABUKAAaaibqqiGKXvuDZqAS0I6fYfjD32+LwGj5xb19en2OBvA6HJnuRM08Nx9rn7eI4rsfF4i1TKrSEePzQD7161AaqAAIYRSkwgQmIua8V6gyakmXY/o5dcvnFyZwuAuzEdb/zvp2f/g989bbONx/Y85mv3v3ef7znV96Lb25GrUoYAIVfXv7MO36u6JXD3dPv+Kmfe/Suh5/YcSxQ7TzQLNLDRkTMoheHITf/4d/c+oF/nto+nGy0sLkLFSjRcUUBol9vuf/bEI+qSOunVeGrAkDBBb52gw9c0uktqXrHlb2eK+Z+pBCFUzgVURFRERVoO75WxHlKqa7ryzFfTrlq9eSyFRNLCoODaNL3JGOAxUgLsBmG3srly6++EjraY81aIZPJZDKZzLHC4hXuQF0HAlc99wKVgSIAZqKARjAYIyHiqJLkuyENSFKjmCQ/h5qg0y1AQIEIKNxsPTFolgzCkr6t6GNiyzRue+Brv/5ufPHr6DcakprEBc+7aOOlF4La393/zV96F+ITGA6UxHoAmgWPetRbeshG2f0QNWDA4Re++vAXvr5kVyx29IvGUvl8jqZposWi8qvXroFFBCAY+ox1MxwOe1VHiPRoNwqMlZ2xopqsupO+0xHvCEf4uUdqY7X5RxFRRLjGevBLyu4JY1PLuxMlxTWxct6nGyMkSZiJGYDGYbaSy17xEhSAO9DBZTKZTCaTySxqFq9VBlaWCuC4pXjjG1/5l3/5sbqRsugZ4ahJdRopIMEIc74E+iZAKvRSIoykS+VtAxzgseyMk7l1O2eHzpcwkDYefWdP/Pr7/ub83utx0TkAoIjCV73pNdd/9vpKyvtuuefbX71n9UUnf4fWDgI1/vZ3/+D+m2/riO/PDsenJjeccdqFl126fNOZcEBxuP6ZGBtnBbYPbv+HTy2ptRNMyqq9UTAywESLFHVVuasZnHrReSiIIl0n2P2339WrOqzNsW3/daIkq7SRYGNlMdYtrDdBwWw9jBZjbKLF0IS5q4vS+7IsO2WlhFfxok5EiNg0rUHJMIhhrpSe7ofEJtRF0Rw/0Xv+5fBCUdF8Yz6TyWQymcyxxSIW7glT6Jve9Px/+PA/97fHYCigJKMQIEQUMLb3HVLVOVKcqEkbf3LjN265+PLz23UqcOo1V3/ja7dUQ+s25mERKMzKYRxrwg1/+Y8XbViPZWNWiDk75ayTp5YeN9g+qwH/+pFPvPnCt37nx7B7z0c/+tGiH7rqObSqKG//2o0f+bu/X7Vh/Wve8oMbLr8I5WFtx7kSNXHdDW7LdKeBG4lpkwVfeNd4txX9s15wJVYvR6kAUqD7LdffEAa1SKmAQlUlTU0qnBPCi6bQRjWYoDc2GWFkXOg/k1FujBJGOiFG3apx711N/0pESJgZCjerdvkrr4GPUC/Of+eGoUwmk8lkMpmjk0VrlbHWHK4Axifxhje8uOy2bZHJ3W4AaUYjjSRFRYQy3/pgAlD/6cMfgyDWNDMoseK4Td//ks0dHXg1gcIABMYxV/qtu/GfN4JUByeEx+pVqwtf0eSu2791SEPLIc0uCj1u4s8+/dFfef8fvuFnf/KcKy8dOotN6ARsufP+3/z5X/z8X3wYM4epY4nh8J6bb/WR6QDTo/2ZICoCbIc04YwTey+9ApOddo6UAHfft/VbD/TUK+HEedVCtIJWJhOuVKD0BbRNcy8ocVhLHX1gSVn46EBLioeUowlVMfWeqkaBCcI+L0njoKmnGTorlqx49jNROTh5AsajTCaTyWQymaOVRSvcF0LgTW9+/tRk2cQ9EU1ENDKCtrfZgurA+UZQAIDO7g4f//AXQFFVE2Dc4fJLLnnL6zdP6Nae7qx0T6kzBWbVULj+7AxiYzAZzROanZlR6r333XfIvXus/fcwwwlnrnv6y67+b7/6C7/3wQ8843nP6TdNQe0EfPAP/+T6D31s35L1gREURTkxFpw0bv6JCQTFwOl0qY92Zfz80zf91FuxYgrDIWgA0ODv3vf+rkmpvigKFUmXN0IUkI4rYHRO0yBVIWBMvnav6sUJoZEaKUY2kdHSQ4wk5y4e5r6QBbk06kutejucXflfXoFeB2KAmB3W0WYymUwmk8ksJhatcJ+bxAmFK+A8fvJtb+5VzaDeadL4wpnN16hNQNI7vzDEBYCIG/b1937rD/c8WqMPhSHWqCKu2HTxu35+xatf8OgJU4/03I7xaktPZ1ZOVaesQadQCE1AbN+xVUVKX0izfyPpXhNYLX1tjE2TvhPBCAKIIYpCHQDEEFACx4+/9ld+9hU/+oPTEpzznVr++j1/fNtnvgwi5akDQJizrgOAmZkZQChWX3jO7GRnlhZVYzAjasEesT1dt2v5xPpXv3TN296CJVOIAvEwxRC3feQT3775tiqamBljBA0RSjh2yqoqyqqqYhyNYVWDa287MJqFIBYBE5rQRDj3mDtTSnA0PJVkOzeWsEiLbnfEik0byyueAS9QD1DVYf6Oyj6PXIzPZDKZTCazODm6G/wOld/ZRp4nNakAEPHmH37nDV+7ryqmGLRwzisUJjSFiQhgsQmx6acIGoGJiFKj9VetW/o77/2NZau6VEjyuxsxJGaBbz2IYYPK49S1mFIIo8BBtt+9/Udf/daidgqsPPnEd/3d/0UBYG7J999zMppAIA7BEAgKItsBQzR4RaGt2z4CAZ/6o7/+xF99iLuHRa/snbLyf77vd9EDAAwaVAXmrhaSoPUwmlKwY4Ab77j5Ix+vH9lRQQEMYcvXr1n3tI0470ysWoESkP+/vTuPsuyu6gX+3Xv/zrm3hu4OmRkSIpABkiZAIGF8TMl6DyUvIKI4oLieLkXBMAmCT0BBwQjqew8VZxc+BxzgKaAo4pAIRBMwCSSGkBCSkJC5h6Srq+45v73fH79zbt3uTne6K51Qt+/3s3qlq29V3brn3HNuvnfXPvuHbhXZFvd84aoP/MzPL2xdWQirTE1Ew01EVQcuRw8WNw0XKrXI3vWsw7H7sFXH6mj8yVujvGXKERmO7rLggIdHtJEbSIPqtjpe+p6fxBMfg3ryLvZ66E7vPOmHZh4t98++PXj75+A+/m/WPOPpPX6mBZ/HtXmwz69ZMy3H4bQ8zoPo0L04dY/1NFvgta/7oVe96q3urmqeUaYaApERBiSrQj00wcfD0lW1AvCNW7ad/9qf/uDv/vLikeP7F1TAYYJTj4MHVDAQtKMwNUlo8Ae/9gdVDLxtdCDHHvdw6G5R8z4OAhHB0jJGhpvvvvNfPtPese0b116H7MMNC0c/+lFHnH4qznwiFhTDCkkBvPC7v+uiv/1Us7xFG7/t6uuu/tRFp7z4ORAgVWiAjK2fv/pfP/XpSy6/7Kf+zy/OHXe4iiKAh83hmaed9qzTsXMFW7ZjYRELc/AMC1Spe1wJWAm4bL3k8t/5+fcvLuUaqiqq0q0TG9CAig6HQwARYaZYUweLC3J4Lr30bXj2jMjwNnxF5Z4qTjvn2TjtMYfwoUpERES0P2YlDeWAGh7/hKO+57tf8hcf/nSEVlWdvQ2EIiQkQyTDNEE95xbjSyfbFhDV6obrbv3hV53/tre/cfOZx+cGNgCSAMC8ABItxACpBUDg2kuu/dw/XVyNqirVTbOyefPpcCAD0v+ZNO6aMcP25Rs//Ik7L/vycPvOjaiO3jmqNK1s3bL9tm03X3alffazp77xRzAYoAEUGMo55734b373j3znaMNg7p8/+vFTnvccGG67+pp//Pgnr73sS9tvvnPedVn8H/70r8/98VdhHhCEhgzNgbau6sOOKo8qu7aKWiFlraoGCLntwn/7vV/634vLPp8lIAqRgJbmFsACVq5Jbd3dq6paQ+t5V2LvnqOQCAEiPCNaiZ2G9sjFE19xHhBca4mIiIhm3HSHof38FYmP/w698w583yvefNedO+u0KGIagLQKV5hBTBC5yc1Oj5GEi4aijYiQypFHo+VqTl549rNf/4ZXbziqr+VL35Zj3T8v/tjnfv29H8w7PIU1zcgGeMZznvn8F73g8c9+AhRYBJYBRaTxuwMAjpFjxa/+5d9srrju4TGM5ab0fLsgBA64YMucpqedevKPvQoJqADFLRd/5X0/9pPDUdSLg+Xcbn7qU278+k333L1FAuZIrurRuvuG4Tt+7ZfsCcfCECtZFKis24U5ADS5reu6699ZCazEv/7G71300b+bDx0CKSSpSSApkmOQrIbC44jFjRvTwBwRoZC9t8oAq60yE5cWIDK6Ppks6u4RObKP2sYFbnLHAC/66ddXTzoFcwmpLJV1/4svratfaR2QGfyV3wGZ9v3DVhnaH3we14atMgfXtByH0/I4D6J19FDW4ICDO9Qb/Ntnv/G61769bQbDuU0AFK0EkqQS3BEjzyu5HSEypDXJJbgDMLU2L0Pa+QV54pNO/vaXfdvTzjoDw/JQAMHVn7/2z//kw/9+4cWLscGXXdWqYdWMRoOFQZMbl/akU0468dQTn3Tmk0874zRsABxIyBoaLqOMy7566fs/+PAdsbFRACFoRcv8yjKtZcuc3nDU/At+8Z1YFACogO04/7nnHZnmcpsjcjm2kqr2+VYD7u4mw4cf+aYP/hKOmUeg67aPDC899IYmozI0AZFL/uQj//yXH8ed98w3WockhYiIaBIVeOUYqJjjyE0Pm0t1HVLWqJLAgQb3HJ4ROdwFHtKGR+TsWcxWkLebb9p84lk/8wYs1hCEwkXA4P6Acf/sG4P7gf5cOrj4PK4Ng/vBNS3H4bQ8zoNoHT2UNTiwJ6x8rcAz3v3OP/3Exy5S3QiohgtgEIOYhAqQV5p2JXyEbrCjR4SImJkhIG3Trli0Jac+9jEnDgaD3DTXXnvtoErhI+Q8r4veBDRERV3VNCOHuCVdWdk5mK9z9k2HbXjZD3znC7/nnDaFwG1n/voH/nDp4qsOW2oHTYhVXn689O32oXfMa/v0k0579SuxmCJDBNuuue3dr3ztYKkZztXhkd1NVUWSqLlqAKqi0rbtsrR29IaX/uD3Pf7c56MGckAAEbSOAFTjmhsu+ttPXf6ZS5ptO7DSpBxDsSqkMgUQKiZi7hVkKDpX1Ydv2JQgqY3ym4EHEtwjIodkRBtt6zmH363N1iOH3/Mrv4Bjjsi19k+dSLlqIfZ15K6rE+yAzOAL0AGZ9v3D4E77g8/j2jC4H1zTchxOy+M8iGalx32sXHb6lre+4j++8MVbb11GlII5Squ1Q0QEWql6jjKP0EW06093b7JHeKXVXFrQ8LaNG75yi0RWyEDnqlZyuEmV2xjU9UqzLBARM5hZisjmkWzesuRRs3TrPXfeePvqdBmV4WGH3SF5WKdkGv10RQcaQ6u6Ytgyh2e8/FwMbfwm5PqrvlyZDSrJo6wqIlKnKnIed6IH0KyMqqqS5Z2yZelD7//A4EMf2nzWGcefcPzxjz7+jjvu+MaNX7/7lttu/Mp1S3dtHTaYD63bMk4HlkTVVKBlarvDApXaoKo2Li5GzojdL7ndH9F/R47I4QBad3QzIZEdS/DlYf3y81+Now6DIcrvSsqMyAfy3BMREa3JQxMQH2zfrDf8dBDNUnAXoIxGVGiFd/zcG3/iNe/atmXboKoX5xea5RWoBiwCilTVVmHo7ajNTaBFFkAiXDVpuATakYuYSUBMYBpQQ4aL1QhYlVrAqloAjTKD3U2AiCQK96Qmpjd+7atoAAtRQWVHnnv2lq1bb7/kymalHYqm1i08my7XcpssHfPU057xipfgERtRSUZYKxjhkn+8EE1Wrayq3duhJQCqQDism+FeDRIQw/l5D9+AlO9a+uLf/POVfZlcAYOk0I1iCZFENXXXgRrURFRQOubFIwED0SMWN5qXMe5dkp4c9ehQAFJ2tzj6mfp9XlcXhEdGtECEZERIV0ZvHU2dliw94flPr049FVVV7sgAmbwiYB299SUiIiJ6iMxScB8TaMITNx/+Yz/+yve997dSqkejUUBziCEyIGqlsUZTnSzl3ARaiVbCJGfAFKFaAS4iEq4QiAsUIggg3BUaEEkSEC3zEyXKGHWJCKjJysryVZd/8fbrbz765Ed2o9Y3zZ34o9+P51y39XOX3nvrXbffcqs5jnjEsccef+xjnvx4nH4iaoFkIMrCotf9yyVXX/rFeVdRAZAkYY9x6eO31waxkAqGDMAQeaLFpSyFKgYx7SN3QMrvHxAAvM1zqdowHC7Oz5clk9YWnldTe2SPcIQjAuFA6zESWRLYcUef8kPfjyECARGN9fVbqgfPjGzmmnH/7Bv3z6GBz+PacL+tZw/eszODz/t0b/BafsUTEx8o3vqm37nw01e0oyqlOYOJhEkkFcAloBqAO1oNeNuIZ3ggWg1YaYKRKOs3AWW0OkoPdwnWg6rWLkm7eCBytxSRhnsb7j7ASWec/FO/+g7UgAJthjdIiqUVRIVUA8BohGHdrS+qComyjOrydbf/wuvelu9YqpZjrqrDHYBK6ZBxuc+wK6v95SKhfb1cIQYRKSXt0qGuGlBTVQU8BRYibaiHi/PDQVWjaUpw1+i2tLxbEF19Omyi4r7L7vfICPecI3JJ7RGtZxcst54H1faN1X9/10/isY9Abdmzmh7oaTmDpzFNBfbgEk2vQ6OlhNfGHAKme1eu8YAbf5MAju99+btuuP7uyHOCSjUEXplqdIt9luwugHgLz+GteEi4BkTDIALXcIgn0XFniIhKYG5Q91VtFw9HjsjurYioQUVG3rTWPuU5T/uJC96ACjEKGQBoPFw8ARpde4/0s96ljIG/6TNf+uAFvzK6bZut+KbBBgXCHR5JRQMW5V2HSHQNKl18ltXLRkWjVLK1X01JtATv8gZARUoBXiGeQo7d8LD5amASZfMtugaYvQX3bj/seksA2b2N3MV3RI5wz204qrQkcTua73rLa/GMzViwNR+cfIGg9YnBnWh6Mbgf3J9Lazbdu3JNB5wDin5EOhzbtuDl3/6abXfLoNoUEd20crW+Ju0AkqhKmITCo3VvR5Ed4gZRuET3MeB1qipLVZU0UGlSERUReG7bph3lPGpzIyIiASDUl5vlNFcd/9jjXvOW84848eiyRhJaRwTMoAjvn6QGAEZfufXPf/+PvnDhvw0yNPtA65SqEtzVQ8LnUj1XpcpsICklu2d556htmrYFkNLq010egIgqoJhoRxEfR/m5VA+qalinWtOC1RooE27KHJ77De67UZGMcG9b75pkWvc2smd3k9bsLvOnvvK8417yIsyXaZYM7nRIYXAnml4M7gf359KaTfeuXGtwRxlPUmaV5Iwrr7j7/Ne8Y7RchxuiG6dYmZYUqwGFKDCokngrgIYbdLXiDge8jDk3CMSTmAZURAOqWqayrIx2jkbLbW5EpR9vAzMsNyuhbWN+6tNPP+s5Zz73+c/WjXOogAYQYAC0uOHz/3nFxZdedenlN335+qHLQtTSuqgkM1UTdxUV91p1oRosVNVArbIkIk34cjNqRqOmbcYnTgg8WvQ7wqAleWvAvaksDS1VljbMzQ8k1ZVqoFyN2l8fev/B3XEfT014ZLTZvdTa28juniOaZFsqPOKszWe+6dXYkPo+fQZ3OqQwuBNNLwb3g/tzac2me1c+gOBedPEdjk9+4qq3//QFEgtVWhBPJqHWJtUkAw1IuAJ10tLdDvdBVQN9xb0EdzUN72vSMIiJJOkysdU2apaXl5dHo2WIozTYoLSvOCxW2hEs3BurbOOmxcMPP8JMR6PRzh1LW+68a1DVo53Lg2qAJs9Xg9S4BmA6SJWFwz2ZWmC+GmwYzs2pJUgFAdAoWveIGI1GO5d3rO6CibYZg4zfZmyq6lpTXVeVpVQ63ctvHvqx7+UxjyO6TRxCZdtLc054+ZWClOcootvt2dtxX3tGtO4icneN+aee8vyfeg0WBxCHdrNqDvzJBfgCQesVgzvR9GJwP7g/l9ZsunflAwvuDshKu1KlYbgK8JE/u/SC934QPp8wJyKmWRWV1SXXSqAyMwmDKry0lyTVcnGqSJiICRRRrqY0RFIt3wigqqqIvDLauXN5KedRqbgHsgRCHED2dq4ehDcioaKj0QhAZTaoagDIrajknAEMq7rZsbOqrEopqWluBRhalUIW5uY3DOYG0hXIUaa4dPfv7j7e/KWVnejfYyzMzXfvLhybBgMLKAR9Tb1cdDsZ3DVWrzq13Q6h/vbJ4O6euz0ucG/HqT1HjDSWa9HjjznnXW/GkfNICZDVtbLWhC8QtD4xuBNNr0MjuE87vu5hJoP7mPffrggRBQIf+fMr3n/Bb/somQ1Lz3oyTyoGE9ekWlZXlUBS6z/upsqYhCGsjEEJmHTBHXCFKqCqEXnULN1z7zbAzaAmuS9Fl1EwXZiGR6yuSKpq2gfu8hi6Mj58kMywiBYAABPrSURBVKqkSFkHrW6cW5gb1qtvJ8rQGFOgK5Bb92yXGThd14tEd6Fq+Q2Awsaj2buVUGN1Tg7QTVVHvxZS6OQhNDG1xgNAhgPI6IJ7qf27Z/doJdpot9VhJz78RW97A47aiGHVp/YHdFjyxKb1icGdaHoxuK8HfN3DtM9x39tTuH8nmK7Ol5EAkEO+/Tue+JVrXvCRD39SXAfVgoeHr7RwSDJB66V6rQkRHlGq0gIv17CGuob2d+tQByBd3Rqhkd1MhtVQNsbKys6cR55D+7ZxKbNcuvTsZXqMBCCl5q3jy2QBKFTggzRs8yi3GJhtnFsYWK2hlZZh9Aq4AykAdHcr/WYDMC/LJDkAy6u33+9JUYbs7PMyVKB0wQORIyOkXATgXgZBRkSWaBTbJQ++5RHn/OybsXGIgU3U2vcLT2AiIiKaKdMd3A+essYocthb3vbS7Vu3febCy5ZHS0lqQx3ujlBVgUfAw11UIYC6ol/OU13Cou8xER+HShcVKOABtJ7VZChDQ6ysSM7Zu4q7a6goNMpMSZ2c8QItQdkkugnrAtfQyF57mhtUhy0sDqIy1107+Pe5wQKNrrgdAokuak+G+8mvHG/POLKXnzSZtScvSC1N7dG3vTsiQ7K7SwTCBaOFyo47+px3vhmbBqjKOwbWM4iIiIj26tCsWe7nr7QmvszbPEopCRIg0eBDv3/Rr3/gQ8k2JNQGK9Mek4pCNNQgtfVtMyJJy4REF5GkZggFRKLvgIeImrsCQAYgaM0kIvKo2bF0T3kECpe+4g5xMUWXkj2p9iVsGKT0r1v44vzCfF0Nq7qCapbKDHBvc9+VvtoSU+7WuqnwDkA1jb+mtMSUjC17tMpMLilVmHTzIgFgolUmewNAVAGEe0ZEREnzZYZMjoiIxtDMVaOjFl78s2/GkYsYyMibupqbeGb267BkxZ2mC1tliKYXW2XWA77uYcaD+65Wx0QCiBZ/9ZEvvO+C30QM1WsASdQgSa0bDSmWoOWa1KQYj3Ivve8ATKJMfwdgAi2LIgFArqzreylN7Tm3TTNCRG5H8IC4uycrneQQeHiYhKqaaBIdWlVXmkQXBgNzKNwcVjrPxcscetxfcI/yzgDdSlLlkWhAxMp1qAAMsfr1fUDXQOnyH+/q1WJ8uZfolJgegia3Ll2rDICdc1V+3DHnvvV8HLkRFaDlMJQDPRp5AtN0YXAnml4M7usBX/fAVpkJq+0hTZOT2bnnPQX44V98z6855ixqrRY859ZzUlMEYC6wMilFuvAZgoA6ROEOzSEiIkAOh6jCPaAwQBBdylXTpFqnKnKLwVA8e7h7Wx7POHyLIKmqxCBVFcplsqGhCtc4gA6ZSWWMfdmKcbeM3e93CaRs73gRq/GnusmP4YiyxBIEGe6CUGnbPNJo54fyyCPO/Z+vx2FD1JN7nWcjERER0b4cmmnpAVbcwyFlydLARRdd/553/eqO7UCukpTVQ9ukMpAqwUTCoElLWdpVJEmyMs1FpEyEFAmBTxbdK7USfDUc0hpErUyPKReUOjyqqkLfUB65FZUkMJEUYqIaGYBKWRzKJfpWlgOpuJev136qDLr7sW6azR4V9zKgvbTQrHa6R7lId/VfEeEejnBBhrfuntFGTpa2WPvw557x9Df+CAZlXav7fZuwL3znTdOFFXei6cWK+3rA1z0wuE/YtVXG4R6WpG1x5Rfv+Pl3/srNN22vZMFgipEEBjpMIaJhiLL0UmmVMUkmogERqax015Q8XbI7LHYJ7hFZJcxU+5Rs0HJX49VMRcUQampANG0JzQpPVdXPcOzmypcx6kkxbn1R036spKv2PfQTR7/CRaRv3fFxcEff+tLd7UQvu0LG4ynHu9qByQaZkto9e0aMRJajXankaeee8+j/8XIMASuPQ4FdLoQ9IDyBabowuBNNLwb39YCve2Bwv/+7cgiw9W686Q3vvvrK29RrwIdWp0hJ1SSLiEFMupWYkqRKtCyqaqJJIX0TvAIGlUCFGIdyS1LK3hpuqhretZ6X0e8TSyBJX0HvquNAmljHNKlIoH/z0F1UKgHt/1UCej9uEiKTrTjAeDTkxCGxOvNRvLLV6nj2dvypMq+9LBjb+Kjvbw8HTKRdGUldbcFodNjwrO988aNf9iIokB5AWp/AE5imC4M70fRicF8P+LqHQzW4783aTrzchiWB4z0/9+FPfPwfE4YaqcIgiZqEaBhKdocEKoiJWndNatdI02d3KJBCS6tJydMplQszS/juyvAKdH/uK7hjInCXsF6Ce7kfESljbfppMIa+H72bHtO1zdx/cJ+UdDXHZ2/Ht4+DewhGJbh7REQbWVNqcrs9mg0nHvfffvQH8PjjMTSYHWhq54lKh4Z9v/7wOCdaz9ZncN/zdeOb+zgf7MfD10kwuO8HBzQyPEMV//JPV7//vb91z91NpXMVKtOkEorWICJmUAuvBFZ61uEGEUUZL5OkK6JXpZemFMIr6eey30dwB7pW8HEPer/iaff1WA390t0uMtmbfrCCu05c/xqRJ3ZPlNTugtyOIqI0ui/nZqWS7XUcf8Zpz3vdj+CIBVSAZ8jefsJe8USlQwODO9H0YnDfHwzuD4HZ2gVrPoC66eoKBLbejre84b3XfvmmhGHCnIqoZi2XdUKqUmhXqEjfHhMqmhQGKY0upqKBkt21Kis2ldYXLVeaanjfewOU1VLLSkwo7TQo1fRSBZfuY+l62TUM0n+v7xrcpaR/wA80uEfkcaG8zGtHWV/Jo/tA0HgjHh7eSCxZ+MMWnveKlxzzX5+LBYUFPBwhYgd64vFEpUMDgzvR9GJw3x8M7g+B2doFD+gAiokPMv749//hz/7vx3fcG3PVQngbOZva3GAorVtAJaxMbARKv3vqpjpKUjV3E+0jsouKQRRiEgYpFXRFtyrrLlNfdu9r7y9CBdLElBjr2lrKxBiRAELLmlDlSlMJiMR4jrslHd++912XJ1plVoN7G25m7r60sqxJHNG6Lw1keNKjXvr6V+P4YxAj1KmMmwSwhkkyPFHp0MDgTjS9GNz3B4P7Q2C2dsHBOYACCKDFnbfgnW+/4GvXfd0bsTC4iGO+GhhUSsuKwiDduMau310NohIG0YBKF7E1oCKlKl+WN+obZspkyfI1u/S1Y1xx72633abK9KuiCgDxifspK6dOtNOUNpuJNaHuc9et9rV73+PugtxmmErEirc7pW1rbeaq573s3EeddzaqwMKgjbacaV13EIM7zSoGd6LpxeC+PxjcHwKztQsOWnAH0HYrGH34Dz/5F3/0saVtXlUb88hr6EBNtJt3nkRLvdzCDSKiSTUhNGAQERFVAIYoc9OTqkkopB8vU7K7ly6XbtVSka6tRcLQdb9Yd1+7j4OUMj4mVAJaVkgts9tl9eNSs++7aPa261b72n0ixLdtGxFQyYO0LTWbTjnh237ih/HIozAQRNfIXxZM7Tp5hMGdZhSDO9H0YnDfHwzuD4HZ2gUHeADtthxp3+NdCtuhCECBjJVteN97f/szF30+RlpFVUudzMqQGRPphs+Mr1UVTX1XDFDCe1dlNyl98DARRWj016cCqtJfVBrdiPcy673vojERxWpwx/giVJRq92rFvYR+6RdREnhEjOfB73VfTAZ3b8uCqSFocrucm6hT3jj8th98xaYXPhOD6BbkVS3vchjcicDgTjTNGNzXs5l6/ZyhTcXBWJhp17vr/86QhCsv/9rv/cYfXnfZLcnn4JEkicdAk0IGKQGAZ3Qz1MUA7SN7aY8pqxoZtNTptYyMFFFABON6eb+6U0jf+95V9MstgnHnOgAJyPii1UC/+GkJ7t2CTRrw0r/eVd/32HZxAD6x68K9Da8G9b3NynJyOWz+yWf/lyd869k4elOZ0R56MM+imToh6RDG4E40vdZnIGZwL2bq9XOGNnUf9nmg7z24o1Tfd/nayy+84YJ3/68td25dGC6YJ2mQJFVWm3YLoHp0ORuAQU1hfXwvYb3U3UsffKmXJ5UIF7iIJlHxGPfQl2K5qCQBPHZdBhXlR4wf/WRfe9d3Xraue0exZ7ndXbo9IN591gVN+EhjlGRbXjnjBc96xqu+F4fNYSCwbvRMecuxP3t+0kydeERENEXWZyBmcC9mKj/M0KbuwwM80N1dVQF4AzUg8Ik/u+gv/+T/3XPXTl/WxXpj02RVsbIMk4iGS9ewLinKFatR2mNMRMNVuok0ZVlW0RjXyw1aquzjW0QmKu5950xJ6hJ9Zb2bTrN6YWt/u2vAkccjJssXez+7xgFIBiAeGnBBo9gWo6X5dPIzzzj75efh0cfC0F2xa1LmQmLvYyX3YaZOPCIimiLrMxAzuBczlR9maFP34YEc6BEREaVVffVWB1Zw4d9f8Td/9ffXXPVVyWYwFUliJpIEFugHy0g/bWb37K7hfauMdNekhvetMqXlJiZaaEqU765bLT3rEqU5Huir4H0x3mViIaeIVvqPV7dAEKVJplT4I7KiUSwnPPNbzzn17GfjhGMhwHC8I4AIBnciIjr0rM9AzOBezFR+mKFN3YeDOW1m/HEALWC45qo7/uKPP3rJhZdaTgM1uFShFqit9jYnqxRigqSq4eUaVgnUJuMOdZEyNCY00PW+993tElCBoHsbUG7pIri4BFRsNbiP58EHujo8XIGIPJ4HHx4A0qC+Z8e9kiCibTRepx2a0xEbv/W7v+NRzzwT8wmVoQJkrz1E3d44kONrpk48IiKaIuszEDO4FzOVH2ZoU/fhYAb3MnCm6FZYgjcYbcff/tWnP/aXf90sjWIEaVHbQFwMliSphEEVucxfF6A2lejq1qXcbgIAfR986VYPYNwuL7prF3s/KCahT9eGXabKYI8edxeM2kZMbViveF6OkZu4xenPOPMpz3vWwuZTMFdhgG5oDADvt3F8HO22IxnciYho+q3PQMzgXsxUfpihTd2HB+lAz222ZE3TVKmKDBGgwU3X3vbJj/7dpZ/7j3u27ECjc5ivJKWJpZpK3b1Kqn2HumiMO92tm0uzWnHvpspAdpvUXirru1bcMV6kaXKOe1dxFw9BTjpK2OHNaGDfcvrJT3zW0x737KejTjDBEGgnUvve9tlkrZ3BnYiIpt/6DMQM7sVM5YcZ2tR9eBAOdAfg7oCrppXRzkFdA6nb4cuA4IYv3v73n/jUZRdfsePue02thmrpSg+Yo7JUOuABlPb3XVplRLsBMn18tz7Ko5/gXqrpBsN4wszECqxhALou9owyl91bxZI0Jz9p8+azzjjhrKfi6EUYUCHnsCTjDVvtjrnf3cbgTkRE0282A/G0mKn8MEObug8P0gkZERG5HE/9UaXdBMkyXNEB4K5r7/33z37uqsu+dNXl/xmtpjBpfaEeovHKkudsouO1VCVQmZla5KYL7pIEXlmZBRkAdu7cMb8wj9xGhISW0TTaL6IknkMFFi1ym2RF2qjs8EceddLm0044+TEnPO8saN+8LhMfPPhm6sQjIqIpwuC+ns1UfpihTV2DB3iiTn77fR9V0RetHRgBilu+dNsN19/45S9dff01137j6zcnSRZAlqSWVM0hHpFzEkvJFAKoQeGtog2UNwkuIjk3lkyjr497ZERK6kCgDfENRx3x6Med8KjHnnDc40448qTHYtMQNdBmDPeYB3Owj5GZOsGIiOgQwOC+ns1UrpihTV2DBz24F7kvbLf9PwEYANx41dduvenWr3752h3bl7bdedeOrffecdOtSSoNZHcNiIqFCby0wZSKuyOraZub0hm/YePGI44+auGwjY884fjDjznikccdt+mYw/W4TWiAGlgBrH8AuseSUmBwJyKiWcfgvp7NVK6YoU1dg4cmuHsTALQSBNpRmwYJgHurmuCBMpl93GDTAA7ctXLzjTeJqrqWWe/tqIG4igCeEapw90c8+QnQfvZLv3oqDEho0M1aT7s8lgDkgUyG2R8zdYIREdEhgMF9PZupXDFDm7oGD+6JGhP/LWQ/nhDftcHmPpX72fOeBRAvPyJDy3dr//nu4z23mMGdiIhmG4P7ejZTuSLd/5fQQ2P31O4Tf8n436KC8azF8efG97D674lQvzpX3gF4PxjmvpdOkv2YFUNEREREDzkG92+ePSad+y4flj8a0L4cLtgtVEsgZLcA7lidBQkAMfkUlyq7Yo8yuk7+cOm+hgmeiIiIaP1gcP8m813+1l1uAzDRnY49P4cyoV0mPrtap9fxHcbEfd8X3WvPDRERERGtFzPUFbQG39SetnGY3nvivv9vX9v3PrhmqheNiIgOAexxX89mKlfM0KY+BGbzxJ6pE4aIiGhsbf/f5/83ud/WbD1WZImIiIiIaDcM7kREREREU4DBnYiIiIhoCjC4ExERERFNAQZ3IiIiIqIpwOBORERERDQFGNyJiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiI6FD2/wH8kkApP6vusQAAAABJRU5ErkJggg==",
                    width: 1000,
                    height: 300,
                    transform: "matrix(.97345 0 0 .97345 -36.738 88.73)"
                })
            })
        ]
    });
var $8f033889ae95cbbe$export$2e2bcd8739ae039 = $8f033889ae95cbbe$var$SvgSdkLogoWhite;



parcelRequire("7fPBF");
const $99cdf9595233aa23$var$SvgSelfServiceKiosk = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M7 4C5.355 4 4 5.355 4 7v36c0 1.645 1.355 3 3 3h36.006a3.015 3.015 0 0 0 3-2.992L46.1 7.002a1 1 0 0 0 0-.002c0-1.645-1.355-3-3-3H7zm0 2h36.1c.565 0 1 .435 1 1l-.094 36.002a.985.985 0 0 1-1 .998H7c-.565 0-1-.435-1-1V7c0-.565.435-1 1-1zm3 3a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1H10zm1 2h28v20H11V11zm-1 24a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h2.291c.233.495.561.938 1.012 1.242.736.497 1.67.758 2.697.758 1.026 0 1.961-.261 2.697-.758.45-.304.78-.747 1.012-1.242H22a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H10zm18 0a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H28zm-17 2h10v1h-2a1 1 0 0 0-1 1c0 .156-.083.355-.422.584-.339.229-.904.416-1.578.416s-1.24-.187-1.578-.416c-.34-.229-.422-.428-.422-.584a1 1 0 0 0-1-1h-2v-1zm18 0h10v1H29v-1z"
        })
    });
var $99cdf9595233aa23$export$2e2bcd8739ae039 = $99cdf9595233aa23$var$SvgSelfServiceKiosk;



parcelRequire("7fPBF");
const $fbf8be4ed6bd1575$var$SvgSensitivity = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M.906-.031C.863-.023.82-.011.781 0A1.002 1.002 0 0 0 0 1v48c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879V26h1v17c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879V26h1v7c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879v-7h1v11.5c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879V26h1v5c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879v-5h1v18c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879V26h1v7c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879v-7h1v23c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879V26h1v4c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879v-4h1v15c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879V9a1 1 0 0 0-1.094-1.031c-.043.008-.086.02-.125.031A1.002 1.002 0 0 0 27 9v15h-1v-4a1 1 0 0 0-1.094-1.031c-.043.008-.086.02-.125.031A1.002 1.002 0 0 0 24 20v4h-1V1a1 1 0 0 0-1.094-1.031c-.043.008-.086.02-.125.031A1.002 1.002 0 0 0 21 1v23h-1v-7a1 1 0 0 0-1.094-1.031c-.043.008-.086.02-.125.031A1.002 1.002 0 0 0 18 17v7h-1V6a1 1 0 0 0-1.094-1.031c-.043.008-.086.02-.125.031A1.002 1.002 0 0 0 15 6v18h-1v-5a1 1 0 0 0-1.094-1.031c-.043.008-.086.02-.125.031A1.002 1.002 0 0 0 12 19v5h-1V12.5a1 1 0 0 0-1.094-1.031c-.043.008-.086.02-.125.031a1.002 1.002 0 0 0-.781 1V24H8v-7a1 1 0 0 0-1.094-1.031c-.043.008-.086.02-.125.031A1.002 1.002 0 0 0 6 17v7H5V7a1 1 0 0 0-1.094-1.031c-.043.008-.086.02-.125.031A1.002 1.002 0 0 0 3 7v17H2V1A1 1 0 0 0 .906-.031ZM39 0v2h9v6h-5v2h5v6h-5v2h5v6h-9v2h9v6h-5v2h5v6h-5v2h5v6h-9v2h11V0Z"
        })
    });
var $fbf8be4ed6bd1575$export$2e2bcd8739ae039 = $fbf8be4ed6bd1575$var$SvgSensitivity;



parcelRequire("7fPBF");
const $f7d13e33d82d990b$var$SvgShakePhone = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillOpacity: 0.3,
                d: "m23.528 38.31 7.865-2.689.667 1.95-7.865 2.69-.667-1.95Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillOpacity: 0.3,
                fillRule: "evenodd",
                d: "m48.63 77 19.197 6.563a4.26 4.26 0 0 0 5.41-2.653L86.572 41.9a4.26 4.26 0 0 0-2.653-5.409L63.353 29.46c.393.556.63 1.232.646 1.964l19.388 6.628a2.611 2.611 0 0 1 1.626 3.316l-13.337 39.01a2.611 2.611 0 0 1-3.315 1.626L53.727 77h-5.098Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillOpacity: 0.3,
                fillRule: "evenodd",
                d: "M35.498 29.716A3.431 3.431 0 0 0 35 31.5v.129L16.213 38.05a2.611 2.611 0 0 0-1.626 3.316l13.337 39.01a2.611 2.611 0 0 0 3.316 1.626L45.873 77h5.098l-19.198 6.563a4.26 4.26 0 0 1-5.41-2.653L13.028 41.9a4.26 4.26 0 0 1 2.653-5.409l19.818-6.776Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M34.34 32.483c0-2.467 2-4.467 4.466-4.467h21.988c2.467 0 4.466 2 4.466 4.467V73.71c0 2.466-2 4.466-4.466 4.466H38.806c-2.466 0-4.466-2-4.466-4.466V32.483Zm4.466-2.405a2.405 2.405 0 0 0-2.405 2.405V73.71a2.405 2.405 0 0 0 2.405 2.404h21.988a2.405 2.405 0 0 0 2.405-2.404V32.483a2.405 2.405 0 0 0-2.405-2.405H38.806Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                d: "M44.99 32.483h9.62v2.06h-9.62v-2.06Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "m9.918 27.667-.22-3.962a1.35 1.35 0 0 0-2.696.15l.409 7.356 7.686 1.618a1.35 1.35 0 1 0 .556-2.642l-3.658-.77C16.941 24.768 30.075 16.7 49.448 16.7c19.2 0 33.117 8.332 38.402 12.739l-3.553.748a1.35 1.35 0 0 0 .556 2.642l7.686-1.618.409-7.356a1.35 1.35 0 0 0-2.696-.15l-.224 4.042C84.638 23.068 69.89 14 49.448 14c-20.329 0-34.226 8.552-39.53 13.667Z",
                clipRule: "evenodd"
            })
        ]
    });
var $f7d13e33d82d990b$export$2e2bcd8739ae039 = $f7d13e33d82d990b$var$SvgShakePhone;



parcelRequire("7fPBF");
const $f3b7e121ae3cb925$var$SvgShazam = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2C12.31 2 2 12.31 2 25s10.31 23 23 23 23-10.31 23-23S37.69 2 25 2zm0 2c11.61 0 21 9.39 21 21s-9.39 21-21 21S4 36.61 4 25 13.39 4 25 4zm-1.93 5.873a1.955 1.955 0 0 0-1.293.574v.002l-7.547 7.559a8.99 8.99 0 0 0-.617.68v.001c-.191.235-.37.476-.535.725v.002a8.89 8.89 0 0 0-.453.764v.002c-.137.26-.26.526-.37.797v.001c-.109.27-.206.545-.288.823v.002a9 9 0 0 0-.37 2.566 9.079 9.079 0 0 0 .659 3.39v.003a8.943 8.943 0 0 0 1.975 2.977v.001a8.977 8.977 0 0 0 6.367 2.623 9.046 9.046 0 0 0 4.191-1.025 8.915 8.915 0 0 0 2.176-1.598v-.002l3.771-3.773h.002a1.894 1.894 0 0 0 .06-2.672 1.891 1.891 0 0 0-2.671-.06v.001l-.06.059v.002l-3.774 3.771a5.192 5.192 0 0 1-7.39 0 5.347 5.347 0 0 1-.942-1.271 5.206 5.206 0 0 1-.217-.463v-.002a5.178 5.178 0 0 1-.387-1.963v-.002a5.184 5.184 0 0 1 .604-2.428v-.002c.08-.151.17-.3.266-.445v-.002a5.267 5.267 0 0 1 .675-.822v-.002l7.547-7.547a1.909 1.909 0 0 0 .57-1.326 1.898 1.898 0 0 0-.126-.711v-.002a1.905 1.905 0 0 0-1.823-1.207zm6.338 6.756a9.147 9.147 0 0 0-3.398.656 8.878 8.878 0 0 0-1.567.824 8.89 8.89 0 0 0-1.408 1.155l-3.773 3.773c-.378.36-.572.84-.582 1.324-.01.484.162.971.521 1.348a1.91 1.91 0 0 0 1.688.545c.357-.062.701-.227.984-.496.024-.012.037-.037.06-.049l3.774-3.785a5.342 5.342 0 0 1 1.272-.936 5.21 5.21 0 0 1 6.119.936 5.296 5.296 0 0 1 1.45 2.705 5.184 5.184 0 0 1-.001 1.994 5.197 5.197 0 0 1-.774 1.879c-.096.145-.2.288-.312.426-.113.137-.235.27-.363.398l-7.547 7.547a1.893 1.893 0 0 0-.455 2.04 1.875 1.875 0 0 0 .408.632 1.886 1.886 0 0 0 2.031.46 1.86 1.86 0 0 0 .627-.4c.024-.024.049-.036.06-.06l7.548-7.547a9 9 0 0 0 1.603-2.174 8.918 8.918 0 0 0 .658-1.625 9.08 9.08 0 0 0-.287-5.96 8.914 8.914 0 0 0-1.974-2.975 8.94 8.94 0 0 0-6.362-2.635z"
        })
    });
var $f3b7e121ae3cb925$export$2e2bcd8739ae039 = $f3b7e121ae3cb925$var$SvgShazam;



parcelRequire("7fPBF");
const $303639901bf99dc0$var$SvgShift = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.6 8C5.862 8 2 11.862 2 16.6v17.8c0 4.738 3.862 8.6 8.6 8.6h28.8c4.738 0 8.6-3.862 8.6-8.6V16.6c0-4.738-3.862-8.6-8.6-8.6H10.6zm0 2h28.8c3.656 0 6.6 2.943 6.6 6.6v10.8c0 3.656-2.943 6.6-6.6 6.6H10.6A6.584 6.584 0 0 1 4 27.4V16.6c0-3.657 2.943-6.6 6.6-6.6zM25 17a.57.57 0 0 0-.217.043c-.015.006-.028.01-.043.018a.624.624 0 0 0-.172.115c-.009.009-.014.02-.023.03a.628.628 0 0 0-.065.071l-3.125 3.752a.626.626 0 0 0 .518.971H24v5a1 1 0 0 0 2 .027V22h2.127a.625.625 0 0 0 .52-.973l-3.126-3.752a.628.628 0 0 0-.064-.072c-.009-.009-.014-.02-.023-.03a.633.633 0 0 0-.172-.112c-.014-.007-.03-.012-.045-.018A.57.57 0 0 0 25 17zM4 32.902A8.585 8.585 0 0 0 10.6 36h28.8a8.587 8.587 0 0 0 6.6-3.098V34.4c0 3.656-2.943 6.6-6.6 6.6H10.6A6.584 6.584 0 0 1 4 34.4v-1.498z"
        })
    });
var $303639901bf99dc0$export$2e2bcd8739ae039 = $303639901bf99dc0$var$SvgShift;



parcelRequire("7fPBF");
const $a105b007c217e587$var$SvgShift2 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.6 4C5.862 4 2 7.862 2 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h28.8c4.738 0 8.6-3.862 8.6-8.6V12.6C48 7.862 44.138 4 39.4 4H10.6zm0 2h28.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H10.6A6.585 6.585 0 0 1 4 31.4V12.6C4 8.943 6.943 6 10.6 6zM25 13l-5 5h4v13a1 1 0 1 0 2 0V18h4l-5-5zM4 36.902A8.588 8.588 0 0 0 10.6 40h28.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H10.6A6.585 6.585 0 0 1 4 38.4v-1.498z"
        })
    });
var $a105b007c217e587$export$2e2bcd8739ae039 = $a105b007c217e587$var$SvgShift2;



parcelRequire("7fPBF");
const $6c173fbd5231fa4f$var$SvgShiftMac = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11 7c-2.75 0-5 2.25-5 5v26c0 2.75 2.25 5 5 5h28c2.75 0 5-2.25 5-5V12c0-2.75-2.25-5-5-5H11zm0 2h28c1.668 0 3 1.332 3 3v26c0 1.668-1.332 3-3 3H11c-1.668 0-3-1.332-3-3V12c0-1.668 1.332-3 3-3zm7.504 14.293a1 1 0 0 0-.725.305l-5.5 5.709A1 1 0 0 0 13 31h2v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5h2a1 1 0 0 0 .72-1.693l-5.5-5.71a1 1 0 0 0-.716-.304zm-.004 2.441L21.646 29H21a1 1 0 0 0-1 1v5h-3v-5a1 1 0 0 0-1-1h-.646l3.146-3.266z"
        })
    });
var $6c173fbd5231fa4f$export$2e2bcd8739ae039 = $6c173fbd5231fa4f$var$SvgShiftMac;



parcelRequire("7fPBF");
const $7bcdb42b48fb49f4$var$SvgShowtime = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        clipRule: "evenodd",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2C18.21 2 12.097 4.95 7.889 9.635l-1.106 1.23 1.604.406c2.368.602 3.414 2.013 4.006 3.586.428 1.14.525 2.234.562 3.143H9.844c-.037-.437.007-.632-.201-1.299-.185-.59-.464-1.223-.967-1.76A3.012 3.012 0 0 0 6.5 14c-.81 0-1.483.33-1.93.695v.002h-.002c-.388.32-.727.776-.931 1.574-.356 1.4-.214 3.833 2.199 5.977 1.555 1.382 3.642 2.572 5.299 4.12C12.79 27.913 14 29.688 14 32.374c0 4.183-2.897 6.216-5.299 6.566l-1.879.274 1.29 1.394C12.311 45.151 18.33 48 25 48c6.745 0 12.825-2.91 17.031-7.543l1.135-1.25-1.64-.395c-2.076-.498-3.663-2.05-4.794-4.484C35.602 31.894 35 28.617 35 25c0-3.617.602-6.894 1.732-9.328 1.13-2.434 2.718-3.986 4.793-4.485l1.641-.394-1.135-1.25A22.952 22.952 0 0 0 25 2zm0 2c5.627 0 10.661 2.28 14.43 5.879-1.96.98-3.482 2.733-4.512 4.951C33.616 17.634 33 21.165 33 25s.616 7.366 1.918 10.17c1.03 2.218 2.552 3.97 4.512 4.951C35.66 43.72 30.627 46 25 46c-5.517 0-10.459-2.199-14.205-5.674C13.51 39.211 16 36.574 16 32.375c0-3.314-1.618-5.711-3.5-7.469-1.882-1.757-4.043-3.005-5.336-4.154-1.92-1.707-1.807-3.128-1.59-3.984v-.002c.084-.323.37-.608.264-.522.192-.157.35-.244.662-.244.358 0 .515.095.715.309.2.213.39.58.517.99C7.988 18.118 8 19 8 19v1h7v-1c0-.875.016-2.85-.734-4.846A7.642 7.642 0 0 0 10.48 9.97C14.258 6.318 19.327 4 25 4zm-9 28.375V41h7V28.5h3V41h7V10h-7v11.5h-3V10h-7v22.375zM18 12h3v11.5h7V12h3v27h-3V26.5h-7V39h-3V12zm25 2c-.89 0-1.68.461-2.283 1.1-.604.638-1.08 1.47-1.475 2.457C38.453 19.529 38 22.13 38 25c0 2.87.453 5.47 1.242 7.443.395.987.871 1.82 1.475 2.457C41.32 35.54 42.11 36 43 36c.89 0 1.68-.461 2.283-1.1.604-.638 1.08-1.47 1.475-2.457C47.547 30.471 48 27.87 48 25c0-2.87-.453-5.47-1.242-7.443-.395-.987-.871-1.82-1.475-2.457C44.68 14.46 43.89 14 43 14zm0 2c.215 0 .476.099.83.473s.741 1.004 1.07 1.828C45.56 19.948 46 22.347 46 25c0 2.653-.44 5.052-1.1 6.7-.329.823-.716 1.453-1.07 1.827-.354.374-.615.473-.83.473-.215 0-.476-.099-.83-.473s-.741-1.004-1.07-1.828C40.44 30.052 40 27.653 40 25c0-2.653.44-5.052 1.1-6.7.329-.823.716-1.453 1.07-1.827.354-.374.615-.473.83-.473zM2.031 22.117 2 24.487s-.096 3.724.666 6.296c.52 1.757 1.08 3.014 1.893 3.906C5.37 35.582 6.487 36 7.625 36c.93 0 1.864-.384 2.477-1.133.612-.749.898-1.773.898-2.992 0-1.534-.808-2.778-1.766-3.73-.957-.953-2.1-1.691-3.04-2.342-1.555-1.077-2.487-2.01-2.487-2.01l-1.676-1.676zm2.045 4.535c.424.347.38.379.98.795.972.672 2.016 1.37 2.768 2.117C8.576 30.312 9 31.031 9 31.875c0 .906-.214 1.444-.445 1.727-.231.282-.485.398-.93.398-.737 0-1.121-.144-1.59-.658-.468-.514-.971-1.507-1.451-3.125-.29-.98-.434-2.392-.508-3.565z"
        })
    });
var $7bcdb42b48fb49f4$export$2e2bcd8739ae039 = $7bcdb42b48fb49f4$var$SvgShowtime;



const $b5b42c3034b41cbc$var$SvgSidebar = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M39.969 9.973a2 2 0 0 0-.29.027H10c-3.29 0-6 2.71-6 6v68c0 3.29 2.71 6 6 6h29.664a2 2 0 0 0 .652 0H90c3.29 0 6-2.71 6-6V16c0-3.29-2.71-6-6-6H40.309a2 2 0 0 0-.34-.027M10 14h28v72H10c-1.11 0-2-.89-2-2V16c0-1.11.89-2 2-2m32 0h48c1.11 0 2 .89 2 2v68c0 1.11-.89 2-2 2H42zm-28 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4m8 0a2 2 0 1 0 0 4h10a2.002 2.002 0 0 0 1.874-2.772A2 2 0 0 0 32 22zm27.98 1.98a2 2 0 0 0-1.394 3.434L57.172 36l-8.586 8.586a2 2 0 1 0 2.828 2.828l10-10a2 2 0 0 0 0-2.828l-10-10a2 2 0 0 0-1.434-.605M14 30a2 2 0 1 0 0 4 2 2 0 0 0 0-4m8 0a2 2 0 1 0 0 4h10a2.002 2.002 0 0 0 1.874-2.772A2 2 0 0 0 32 30zm-8 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4m8 0a2 2 0 1 0 0 4h10a2.002 2.002 0 0 0 1.874-2.772A2 2 0 0 0 32 38zm-8 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4m8 0a2 2 0 1 0 0 4h10a2.002 2.002 0 0 0 1.874-2.772A2 2 0 0 0 32 46z"
        })
    });
var $b5b42c3034b41cbc$export$2e2bcd8739ae039 = $b5b42c3034b41cbc$var$SvgSidebar;



parcelRequire("7fPBF");
const $e5994517905e023d$var$SvgSignalApp = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "m25 2-.219.002.016 2L25 4c1.529 0 3.054.165 4.533.492l.434-1.953A23.074 23.074 0 0 0 25 2zm-2.305.113c-1.74.174-3.453.548-5.097 1.11l.644 1.892a20.791 20.791 0 0 1 4.653-1.011l-.2-1.99zm9.29.973-.608 1.904a20.393 20.393 0 0 1 4.328 1.967l1.035-1.71a22.399 22.399 0 0 0-4.756-2.161zm-16.337.906a22.248 22.248 0 0 0-4.476 2.686l1.223 1.582a20.243 20.243 0 0 1 4.076-2.446l-.823-1.822zm22.829 2.42L37.285 8.02a19.763 19.763 0 0 1 3.447 3.263l1.541-1.273a21.774 21.774 0 0 0-3.796-3.598zM25 7C15.626 7 8 14.178 8 23c0 5.129 2.606 9.926 7 12.938V41a.998.998 0 0 0 1.498.865l5.432-3.127A18.13 18.13 0 0 0 25 39c9.374 0 17-7.178 17-16S34.374 7 25 7zM9.578 8.037a21.362 21.362 0 0 0-3.35 4.02l1.684 1.08a19.344 19.344 0 0 1 3.035-3.643L9.578 8.037zM25 9c8.271 0 15 6.28 15 14s-6.729 14-15 14a16.19 16.19 0 0 1-3.062-.293 1.006 1.006 0 0 0-.69.115L17 39.27V35.4a1 1 0 0 0-.463-.841C12.443 31.942 10 27.62 10 23c0-7.72 6.729-14 15-14zm18.53 2.69-1.66 1.115a18.59 18.59 0 0 1 2.118 4.226l1.89-.66a20.68 20.68 0 0 0-2.349-4.682zM5.185 13.878a20.192 20.192 0 0 0-1.748 4.943l1.957.416a18.16 18.16 0 0 1 1.574-4.455l-1.783-.904zm41.28 4.514-1.946.457a18.115 18.115 0 0 1 .47 4.699l2 .06a20.174 20.174 0 0 0-.523-5.217zM3.11 20.9a20.106 20.106 0 0 0 .137 5.242l1.977-.312a18.193 18.193 0 0 1-.125-4.723L3.109 20.9zm41.727 4.538a18.046 18.046 0 0 1-1.24 4.556l1.845.774a20.03 20.03 0 0 0 1.377-5.063l-1.982-.267zm-39.22 2.246-1.932.515a20.376 20.376 0 0 0 1.994 4.85l1.736-.992a18.458 18.458 0 0 1-1.799-4.373zm37.16 4.02a19.076 19.076 0 0 1-2.77 3.845l1.467 1.36a21.156 21.156 0 0 0 3.058-4.249l-1.756-.957zM8.437 33.655 6.81 34.818a21.264 21.264 0 0 0 3.236 3.586l.41 4.024 1.992-.203-.453-4.418a1.005 1.005 0 0 0-.348-.66 19.33 19.33 0 0 1-3.21-3.49zm30.208 3.221a20.165 20.165 0 0 1-3.9 2.71l.941 1.765a22.211 22.211 0 0 0 4.288-2.98l-1.329-1.495zm-5.623 3.525c-1.46.61-3 1.053-4.572 1.315l.328 1.972a22.723 22.723 0 0 0 5.016-1.441l-.772-1.846zm-10.175 1.489a1.04 1.04 0 0 0-.508.08l-1.014.449.813 1.828.771-.344c1.27.115 2.554.124 3.795.033l-.146-1.994a21.624 21.624 0 0 1-3.711-.052zM19.5 43.232l-4.572 2.028.81 1.828 4.573-2.027-.811-1.829zm-6.848.98-1.99.206.344 3.336a1 1 0 0 0 1.398.81l1.506-.668-.81-1.828-.246.11-.202-1.965z"
        })
    });
var $e5994517905e023d$export$2e2bcd8739ae039 = $e5994517905e023d$var$SvgSignalApp;



parcelRequire("7fPBF");
const $0f464a6a2f00d4b8$var$SvgSiri = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2C12.31 2 2 12.31 2 25c0 3.347.723 6.526 2.012 9.396a1 1 0 0 0 .199.44C7.902 42.613 15.828 48 25 48c12.69 0 23-10.31 23-23S37.69 2 25 2zm0 2c11.61 0 21 9.39 21 21 0 .482-.02.96-.053 1.434C42.36 21.88 37.885 18 32 18c-4.775 0-9.209 3.172-13.652 6.518-.159.119-.318.228-.477.347-.027-.01-.037-.024-.064-.033-3.465-1.166-8.32-1.45-13.752 1.623A21.313 21.313 0 0 1 4 25C4 13.39 13.39 4 25 4zm7 16c4.065 0 7.454 2.246 10.41 5.398a20.727 20.727 0 0 0-7.972-2.365c-4.302-.385-8.552.501-12.424 1.89-.598.215-1.171.458-1.752.692C24.402 22.54 28.359 20 32 20zm.73 4.893c4.26.055 8.564 1.436 12.686 5.027-.138.576-.3 1.143-.484 1.7-2.997-1.561-6.024-2.388-9.053-2.509-5.493-.218-10.995 1.868-16.352 5.996-3.152-1.795-6.15-2.47-8.73-2.59.577-.312 1.166-.633 1.795-.972 2.142-1.157 4.556-2.43 7.133-3.55 1.594.88 2.568 1.712 2.568 1.712a1 1 0 1 0 1.414-1.414s-.695-.529-1.746-1.2c.244-.092.48-.198.727-.286 3.235-1.161 6.623-1.96 10.042-1.914zm-20.779 1.154c1.387-.07 2.662.083 3.819.353-3.447 2.586-6.906 5.062-10.356 6.182a20.85 20.85 0 0 1-1.096-3.95c2.824-1.752 5.379-2.47 7.633-2.585zm22.307 4.994c3.3-.143 6.599.674 9.94 2.459a21.004 21.004 0 0 1-4.378 6.385c-4.884 1.637-11.358 2.004-17.195-2.666-.432-.346-.863-.66-1.293-.961 4.379-3.252 8.654-5.032 12.926-5.217zM9.893 34.465c2.24-.015 4.922.445 7.816 1.928-3.468 2.214-6.375 2.566-8.65 2.263a20.989 20.989 0 0 1-2.6-3.79 15.939 15.939 0 0 1 3.434-.401zm9.709 3.043c.586.384 1.176.796 1.773 1.273 4.832 3.866 10.153 4.621 14.756 4.008A20.888 20.888 0 0 1 25 46c-5.338 0-10.192-2.002-13.895-5.275 2.477-.137 5.371-1.037 8.497-3.217z"
        })
    });
var $0f464a6a2f00d4b8$export$2e2bcd8739ae039 = $0f464a6a2f00d4b8$var$SvgSiri;



parcelRequire("7fPBF");
const $2005106e9deaac4d$var$SvgSlack = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M27.96 3.016a4.506 4.506 0 0 0-1.796.226c-2.492.805-3.707 3.508-2.922 5.887l1.117 3.398-5.285 1.93-1.07-3.25c-.59-1.887-2.25-3.059-4.043-3.191a4.61 4.61 0 0 0-1.79.226c-2.5.805-3.714 3.508-2.929 5.895l1.149 3.492-3.336 1.219c-2.356.832-3.598 3.496-2.836 5.91C4.848 26.75 6.629 28 8.489 28c.577 0 1.07-.14 1.433-.27h.008l3.383-1.238 1.624 4.934-3.863 1.414c-2.449.816-3.594 3.531-2.844 5.914C8.848 40.71 10.566 42 12.492 42c.535 0 .957-.14 1.36-.246l.043-.008 3.968-1.434 1.153 3.485v.012C19.684 45.69 21.453 47 23.39 47c.582 0 1.086-.137 1.46-.262 2.403-.808 3.715-3.472 2.919-5.89l-1.211-3.676 5.289-1.91 1.168 3.535v.008c.668 1.883 2.437 3.191 4.375 3.191.582 0 1.086-.137 1.46-.262 2.403-.812 3.715-3.476 2.919-5.89l-1.227-3.723 2.488-.898.016-.008c2.3-.945 3.547-3.602 2.672-6.024-.582-1.796-2.164-3.02-3.91-3.175a4.24 4.24 0 0 0-1.778.226l-.004.004-2.445.895-1.617-4.922 2.957-1.078c2.45-.817 3.598-3.524 2.848-5.907a4.473 4.473 0 0 0-3.938-3.21 4.297 4.297 0 0 0-1.766.226l-.004.004-3.019 1.101-1.04-3.152c-.589-1.887-2.25-3.058-4.042-3.187Zm-.132 1.976c1.012.059 1.922.696 2.266 1.805l.004.008 1.066 3.238-4.922 1.797-1.101-3.336c-.461-1.402.195-2.902 1.64-3.363h.012l.004-.004c.344-.117.691-.16 1.031-.145Zm9.875 5.004c.953.05 1.817.684 2.156 1.816v.016c.453 1.43-.203 2.957-1.57 3.414l-.012.004-2.941 1.074-1.668-5.062 3.062-1.117c.325-.118.653-.16.973-.145ZM13.828 10c1.012.055 1.922.695 2.266 1.805l.004.008 1.097 3.332-4.922 1.796-1.132-3.433c-.461-1.403.195-2.899 1.64-3.363h.012l.004-.004A2.7 2.7 0 0 1 13.828 10Zm17.961 1.941 1.668 5.063-4.922 1.8-1.668-5.066Zm-6.8 2.485 1.667 5.062-5.285 1.934-1.668-5.063Zm-7.165 2.62 1.664 5.063-4.922 1.797-1.664-5.062Zm16.258 1.86 1.621 4.922-4.922 1.797-1.62-4.922Zm-23.062.625 1.668 5.063-3.43 1.25a2.5 2.5 0 0 1-.77.156c-.953 0-1.984-.656-2.36-1.844-.44-1.402.329-2.976 1.59-3.422Zm16.261 1.86 1.621 4.922-5.285 1.937-1.62-4.926Zm-7.168 2.617 1.625 4.93-4.922 1.8-1.625-4.93Zm21.543 0c.95.086 1.836.758 2.168 1.808l.004.028.008.02c.512 1.394-.242 2.96-1.543 3.5h-.004l-2.371.855-1.711-5.18 2.492-.91c.313-.11.637-.149.957-.121Zm-5.328 1.719 1.707 5.175-4.93 1.782-1.699-5.157Zm-6.797 2.488 1.692 5.144-5.29 1.91-1.687-5.117Zm-7.168 2.625 1.684 5.113-4.926 1.777-1.68-5.09ZM38.66 32.8l1.211 3.669c.45 1.37-.32 2.918-1.656 3.37-.25.083-.578.157-.824.157-.973 0-2.11-.793-2.485-1.855l-1.176-3.563Zm-23.097.528 1.675 5.082-3.918 1.414c-.39.102-.761.176-.828.176-1.082 0-1.969-.617-2.355-1.844h.004c-.453-1.433.203-2.965 1.566-3.418l.012-.004Zm9.113 4.524 1.195 3.625c.45 1.367-.32 2.914-1.656 3.367-.25.082-.578.156-.824.156-.973 0-2.11-.797-2.485-1.855l-.004-.004-1.156-3.512Z"
        })
    });
var $2005106e9deaac4d$export$2e2bcd8739ae039 = $2005106e9deaac4d$var$SvgSlack;



parcelRequire("7fPBF");
const $02d2ce069a187b72$var$SvgSmartWatch = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25.063 0C22.5 0 20.59.09 19.156.406c-.718.16-1.332.387-1.843.75-.512.364-.918.926-1 1.563-.051.379-.06.367-.157.656-.097.29-.218.754-.375 1.688-.457 2.761-1.851 2.605-3.125 3.968-.047.051-.11.07-.156.125C10.996 10.25 10 12.008 10 14v22c0 1.992.996 3.75 2.5 4.844l.031.031c.043.031.082.066.125.094 1.25 1.343 2.606 1.234 3.125 4 .156.84.29 1.261.375 1.531.086.27.098.34.157.781.078.617.472 1.168.968 1.532.496.363 1.078.585 1.782.75 1.406.328 3.308.437 5.875.437 2.562 0 4.472-.09 5.906-.406.718-.16 1.332-.387 1.843-.75.512-.364.918-.926 1-1.563.051-.379.06-.367.157-.656.097-.29.218-.754.375-1.687.457-2.762 1.851-2.606 3.125-3.97.043-.027.082-.062.125-.093l.031-.031C39.004 39.75 40 37.992 40 36v-2c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1v-3a2.17 2.17 0 0 0 2-2.156v-3.688A2.17 2.17 0 0 0 40 15v-1c0-1.992-.996-3.75-2.5-4.844l-.031-.031c-.043-.031-.082-.066-.125-.094-1.25-1.344-2.606-1.234-3.125-4-.157-.84-.29-1.261-.375-1.531-.086-.27-.098-.34-.157-.781-.078-.617-.472-1.168-.968-1.531-.496-.364-1.078-.586-1.782-.75C29.532.108 27.63 0 25.063 0Zm0 2c2.503 0 4.343.121 5.437.375.547.129.871.29 1.031.406.16.117.145.14.157.219.07.535.167.836.25 1.094.082.258.167.535.312 1.312A6.769 6.769 0 0 0 33.313 8H16.719a6.544 6.544 0 0 0 1.031-2.625c.145-.867.238-1.156.313-1.375.074-.219.183-.496.25-1 .011-.086-.012-.098.156-.219.168-.12.527-.281 1.093-.406 1.13-.25 2.993-.375 5.5-.375ZM16 10h18c2.219 0 4 1.781 4 4v2.156c-.332.617-.562 1.508-.562 2.844 0 1.332.234 2.223.562 2.844V36c0 2.219-1.781 4-4 4H16c-2.219 0-4-1.781-4-4V14c0-2.219 1.781-4 4-4Zm13 4c-1.645 0-3 1.355-3 3s1.355 3 3 3 3-1.355 3-3-1.355-3-3-3Zm-7.5 1a2.518 2.518 0 0 0-2.5 2.5c0 1.367 1.133 2.5 2.5 2.5s2.5-1.133 2.5-2.5-1.133-2.5-2.5-2.5Zm7.5 1c.563 0 1 .438 1 1 0 .563-.437 1-1 1-.562 0-1-.437-1-1 0-.562.438-1 1-1Zm-12.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm5 0c.29 0 .5.21.5.5 0 .29-.21.5-.5.5-.29 0-.5-.21-.5-.5 0-.29.21-.5.5-.5Zm18.344 0c.101 0 .156.055.156.156v3.688c0 .101-.055.156-.156.156h-.032c-.011-.016-.015-.008-.03-.031-.134-.215-.344-.762-.344-1.969s.242-1.758.374-1.969c.02-.031.016-.011.032-.031ZM25 21c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4Zm-8 1c-1.645 0-3 1.355-3 3s1.355 3 3 3 3-1.355 3-3-1.355-3-3-3Zm16 0c-1.645 0-3 1.355-3 3s1.355 3 3 3 3-1.355 3-3-1.355-3-3-3Zm-8 1c1.117 0 2 .883 2 2s-.883 2-2 2-2-.883-2-2 .883-2 2-2Zm-8 1c.563 0 1 .438 1 1 0 .563-.437 1-1 1-.562 0-1-.437-1-1 0-.562.438-1 1-1Zm16 0c.563 0 1 .438 1 1 0 .563-.437 1-1 1-.562 0-1-.437-1-1 0-.562.438-1 1-1Zm.5 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM21 30c-1.645 0-3 1.355-3 3s1.355 3 3 3 3-1.355 3-3-1.355-3-3-3Zm7.5 0a2.518 2.518 0 0 0-2.5 2.5c0 1.367 1.133 2.5 2.5 2.5s2.5-1.133 2.5-2.5-1.133-2.5-2.5-2.5ZM21 32c.563 0 1 .438 1 1 0 .563-.437 1-1 1-.562 0-1-.437-1-1 0-.562.438-1 1-1Zm7.5 0c.29 0 .5.21.5.5 0 .29-.21.5-.5.5-.29 0-.5-.21-.5-.5 0-.29.21-.5.5-.5ZM16.688 42H33.28a6.544 6.544 0 0 0-1.031 2.625c-.145.867-.238 1.156-.312 1.375-.075.219-.184.496-.25 1-.012.086.011.098-.157.219-.168.12-.527.281-1.093.406-1.13.25-2.993.375-5.5.375-2.504 0-4.344-.121-5.438-.375-.547-.129-.871-.29-1.031-.406-.16-.117-.145-.14-.157-.219-.07-.535-.167-.836-.25-1.094-.082-.258-.167-.535-.312-1.312A6.769 6.769 0 0 0 16.688 42Z"
        })
    });
var $02d2ce069a187b72$export$2e2bcd8739ae039 = $02d2ce069a187b72$var$SvgSmartWatch;



parcelRequire("7fPBF");
const $086b5e67479dbabb$var$SvgSmile = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#FBFDFE",
                d: "m64.266 77.858-2.41 1.83a20.688 20.688 0 0 1-11.857 4.199 20.689 20.689 0 0 1-11.855-4.2l-2.411-1.83A29.682 29.682 0 0 1 24.38 58.976L21.7 42.483c-.424-2.614-.61-5.302.186-7.828 2.553-8.108 10.866-19.32 27.46-19.32 17.78 0 26.207 11.212 28.768 19.32.797 2.525.61 5.214.184 7.828l-2.68 16.492a29.683 29.683 0 0 1-11.352 18.883Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#000",
                fillRule: "evenodd",
                d: "M49.347 16.671c-15.857 0-23.758 10.67-26.187 18.386-.7 2.22-.557 4.654-.141 7.212l2.68 16.492A28.347 28.347 0 0 0 36.54 76.794l2.411 1.83A19.354 19.354 0 0 0 50 82.551a19.354 19.354 0 0 0 11.049-3.927l2.41-1.83A28.347 28.347 0 0 0 74.3 58.76l2.68-16.492c.416-2.56.56-4.993-.14-7.211-2.423-7.673-10.413-18.387-27.493-18.387Zm1.726 68.494a22.024 22.024 0 0 0 11.59-4.413l2.41-1.83a31.02 31.02 0 0 0 11.864-19.733l2.68-16.492c.433-2.668.665-5.612-.23-8.444C76.69 25.71 67.826 14 49.347 14c-17.332 0-26.058 11.753-28.735 20.254-.892 2.831-.663 5.774-.23 8.443l2.68 16.492a31.02 31.02 0 0 0 11.863 19.733l2.411 1.83a22.024 22.024 0 0 0 11.59 4.413c.132.044.273.068.42.068.219 0 .436-.003.654-.01.217.007.434.01.652.01.147 0 .289-.024.421-.068Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#EE486F",
                fillRule: "evenodd",
                d: "M62.69 65.765c.523.76.33 1.8-.43 2.322-9.637 6.626-18.975 3.62-23.678-.061a1.67 1.67 0 1 1 2.058-2.63c3.83 2.998 11.559 5.557 19.73-.06a1.67 1.67 0 0 1 2.32.43Z",
                clipRule: "evenodd"
            })
        ]
    });
var $086b5e67479dbabb$export$2e2bcd8739ae039 = $086b5e67479dbabb$var$SvgSmile;



parcelRequire("7fPBF");
const $bd1ce7d657321c94$var$SvgSoundcloud = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M30 11c-3.602 0-7 1.79-9 4.688v3.5l.313.218.375-1c1.398-3.3 4.718-5.406 8.218-5.406 5 0 9 4 9 9v2l1.5-.594c.7-.3 1.395-.406 2.094-.406 3 0 5.5 2.5 5.5 5.5S45.5 34 42.5 34H21v2h21.5c4.102 0 7.5-3.398 7.5-7.5S46.602 21 42.5 21c-.5 0-1 .086-1.5.188C40.5 15.488 35.8 11 30 11Zm-13 5c-.7 0-1.398.086-2 .188V36h2Zm1 0v20h2V16.5c-.602-.2-1.3-.398-2-.5Zm-4 .5c-.7.3-1.398.602-2 1V36h2Zm-3 1.813c-.8.699-1.5 1.593-2 2.593V36h2ZM6.5 22a1.993 1.993 0 0 0-.5.094v13.812c.3.102.7.094 1 .094h1V22.094C7.7 21.992 7.3 22 7 22c-.148 0-.324-.012-.5 0Zm-1.5.313c-.7.199-1.398.5-2 1v11.375c.602.398 1.3.8 2 1Zm-3 1.78C.8 25.396 0 27.103 0 29c0 1.898.8 3.605 2 4.906Z"
        })
    });
var $bd1ce7d657321c94$export$2e2bcd8739ae039 = $bd1ce7d657321c94$var$SvgSoundcloud;



parcelRequire("7fPBF");
const $c5ccfc72ed9852e5$var$SvgSpotify = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 1.99C12.267 1.99 1.99 12.267 1.99 25c0 12.733 10.277 23.01 23.01 23.01 12.733 0 23.01-10.277 23.01-23.01C48.01 12.267 37.733 1.99 25 1.99zm0 2.02c11.65 0 20.99 9.34 20.99 20.99 0 11.65-9.34 20.99-20.99 20.99-11.65 0-20.99-9.34-20.99-20.99C4.01 13.35 13.35 4.01 25 4.01zM21.934 14C16 14 11.536 15.027 11.318 15.078h-.002v.002c-1.6.374-2.61 2-2.238 3.6.372 1.601 1.998 2.609 3.598 2.242h.008l.005-.002c-.113.028.05-.012.17-.037a41.216 41.216 0 0 1 2.486-.422c1.664-.23 3.98-.461 6.589-.461h.062c4.313.006 10.51.668 15.484 3.588h.002v.002a3.01 3.01 0 0 0 4.105-1.072 3.016 3.016 0 0 0-1.067-4.106C34.276 14.747 27.009 14.007 22.004 14h-.07zm0 2h.07c4.805.007 11.748.758 17.502 4.137a.986.986 0 0 1 .357 1.369.992.992 0 0 1-.865.494.993.993 0 0 1-.504-.137l-.004-.002C33.013 18.647 26.504 18.006 21.998 18h-.064c-2.726 0-5.128.24-6.862.48-.867.12-1.568.24-2.056.332a27.35 27.35 0 0 0-.569.114c-.125.026-.116.022-.217.047a.986.986 0 0 1-1.205-.746.984.984 0 0 1 .745-1.2C11.922 16.992 16.232 16 21.934 16zm.058 6.002c-2.506.02-4.67.255-6.25.496s-2.477.459-2.765.541a2.733 2.733 0 0 0-1.873 3.356 2.73 2.73 0 0 0 3.355 1.87l.006-.001h.004l.119-.028a35.347 35.347 0 0 1 2.152-.393 40.441 40.441 0 0 1 5.582-.452c3.864-.034 8.246.533 12.522 3.197.446.28.949.414 1.437.414.906 0 1.797-.46 2.309-1.28a2.732 2.732 0 0 0-.87-3.743c-5.384-3.355-11.16-4.015-15.728-3.977zM22.01 24c4.361-.036 9.715.598 14.654 3.676a.703.703 0 0 1 .229.988.71.71 0 0 1-.612.338.69.69 0 0 1-.375-.107l-.002-.002c-4.691-2.924-9.523-3.538-13.6-3.502a42.32 42.32 0 0 0-7.65.789c-.214.043-.384.078-.504.105l-.142.033c-.036.009.02-.01-.106.028l.01-.004a.71.71 0 0 1-.885-.494.702.702 0 0 1 .494-.885h.002c-.011.003 1.018-.26 2.52-.488A42.38 42.38 0 0 1 22.01 24zm.49 5.002c-4.359.001-7.586 1.06-7.791 1.129a2.514 2.514 0 0 0-1.58 3.162c.433 1.299 1.864 2.02 3.166 1.578l-.016.006c.1-.032.16-.053.463-.135.304-.081.75-.19 1.307-.3a23.341 23.341 0 0 1 4.451-.44c4.337-.001 7.299 1.038 9.613 2.58v-.002c.424.283.91.422 1.385.422.807 0 1.605-.399 2.082-1.115a2.515 2.515 0 0 0-.693-3.465C31.242 29.992 27.14 29 22.5 29.002zm0 2c4.36-.002 7.995.896 11.277 3.084.239.16.298.455.139.693a.49.49 0 0 1-.418.223.48.48 0 0 1-.275-.084v-.002c-2.634-1.755-6.06-2.915-10.723-2.914-1.939 0-3.624.237-4.838.477-.607.12-1.097.24-1.44.332-.342.092-.64.19-.554.162l-.008.002-.008.002a.483.483 0 0 1-.627-.317.487.487 0 0 1 .317-.633c.058-.02 3.127-1.024 7.158-1.025z"
        })
    });
var $c5ccfc72ed9852e5$export$2e2bcd8739ae039 = $c5ccfc72ed9852e5$var$SvgSpotify;



parcelRequire("7fPBF");
const $46b7fb5cd67a058d$var$SvgSsd = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M7.688 0c-.958 0-1.72.66-1.875 1.594L.093 35.406C.036 35.594 0 35.796 0 36v12c0 1.094.906 2 2 2h46c1.094 0 2-.906 2-2V36c0-.297-.066-.59-.187-.844L44.187 1.594C44.032.66 43.27 0 42.314 0Zm.093 2H42.22l5.375 32H2.375ZM2 36h45.969c.008.02.02.043.031.063V48H2Zm5 4v5h27v-5h-2v3h-3v-3h-2v3h-3v-3h-2v3h-3v-3h-2v3h-3v-3h-2v3H9v-3Zm34 0a1.999 1.999 0 1 0 0 4 1.999 1.999 0 1 0 0-4Z"
        })
    });
var $46b7fb5cd67a058d$export$2e2bcd8739ae039 = $46b7fb5cd67a058d$var$SvgSsd;



parcelRequire("7fPBF");
const $28ab7c56405aa7ea$var$SvgSvgCephy = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 500 500",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "svg-cephy_svg__linear-gradient",
                        x1: 4.82,
                        x2: 282.2,
                        y1: 407.51,
                        y2: 247.37,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#062844"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.34,
                                stopColor: "#693b82"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.68,
                                stopColor: "#a3417a"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ed486f"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("filter", {
                        id: "svg-cephy_svg__drop-shadow-5",
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feOffset", {
                                dy: 10
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feGaussianBlur", {
                                result: "blur",
                                stdDeviation: 16
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feFlood", {
                                floodColor: "#ed486f",
                                floodOpacity: 0.75
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feComposite", {
                                in2: "blur",
                                operator: "in"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feComposite", {
                                in: "SourceGraphic"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("style", {
                        children: '.svg-cephy_svg__cls-4{fill:#fff}.svg-cephy_svg__cls-5{fill:#141526;mix-blend-mode:multiply;opacity:.2}'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    fill: 'none',
                    isolation: 'isolate'
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    id: "svg-cephy_svg__Layer_1",
                    style: {
                        filter: 'url(#svg-cephy_svg__drop-shadow-5)',
                        fill: 'none'
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M319.91 419.59c-14.31 0-33.03-10.47-50.06-28.01-10.08-10.37-15.94-19.86-19.85-26.31-3.91 6.45-9.77 15.93-19.85 26.31-17.04 17.54-35.75 28.01-50.07 28.01-10.87 0-19.47-6.08-22.45-15.87-2.5-8.23.52-14.87 5.39-20.64-9.53 2.81-20.54 4.62-33.22 4.62h-.86c-16.93-.11-27.35-3.21-33.78-10.04-4.19-4.45-6.23-10.1-5.89-16.36.73-13.84 12.67-18.78 23.19-21.01-16.35-6.01-30.87-17.39-43.37-34.03-9.09-13.12-8.6-22.74-6.64-28.56 2.21-6.59 7.37-11.68 14.17-14.02 2.08-.76 4.28-1.15 6.53-1.15 1.2 0 2.36.1 3.49.3-1.1-2.94-1.81-5.9-2.08-8.87-.76-8.09 1.79-15.76 6.99-21.02 3.83-3.9 9.45-6.14 15.39-6.14 8.19 0 15.5 4.12 20.04 11.31 9.9 15.68 21.42 18.93 30.67 21.54 3.67 1.04 8.05 2.28 11.76 4.7-.47-11.87-4.6-31.51-12.68-65.74-5.53-23.44-1.94-58.75 18.57-84.79 11.92-15.14 34.44-33.22 73.96-33.41h.72c39.85 0 62.55 18.1 74.57 33.28 20.61 26.04 24.24 61.41 18.69 84.91-8.09 34.23-12.22 53.88-12.68 65.74 3.71-2.42 8.09-3.66 11.76-4.7 9.26-2.61 20.78-5.87 30.67-21.54 4.54-7.19 11.85-11.31 20.04-11.31 5.94 0 11.56 2.24 15.4 6.15 5.18 5.26 7.73 12.92 6.97 21.01-.28 2.97-.98 5.93-2.08 8.87 1.13-.19 2.3-.3 3.5-.3 2.25 0 4.45.39 6.53 1.15 6.8 2.34 11.95 7.43 14.17 14.02 1.96 5.83 2.46 15.44-6.32 28.13-12.71 16.93-27.32 28.41-43.71 34.46 10.52 2.23 22.47 7.17 23.22 21.02.34 6.25-1.7 11.91-5.89 16.36-6.43 6.83-16.85 9.93-33.78 10.04h-.86c-12.68 0-23.69-1.8-33.23-4.62 4.88 5.77 7.9 12.41 5.4 20.64-2.98 9.79-11.58 15.87-22.45 15.87Z",
                            className: "svg-cephy_svg__cls-4"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M418.78 276.51c-6.93-2.73-17.21 10.65-33.08 18.9-14.71 7.66-29.99 8.79-45.62 2.87-31.31-11.86-26.87-31.73-10.09-102.8 8.53-36.13-8.4-101.46-80.01-101.46h-.65c-71.05.33-87.86 65.44-79.35 101.46 16.78 71.07 21.22 90.94-10.09 102.8-15.63 5.92-30.91 4.79-45.62-2.87-15.87-8.26-26.15-21.63-33.08-18.9-5.81 1.91-10.15 8.67-1.22 21.58 40.62 54.06 88.48 24.86 91.4 32.18 2.32 5.34-26.67 19.11-47.86 22-12.03 1.64-20.33 3.68-20.66 9.77-.49 9.16 10.82 11.95 26.16 12.05 56.47.36 74.38-38.5 81.13-34.58 4.07 1.98 2.26 7.41-3.32 16.82-14.47 24.39-39.17 33.63-36.18 43.44 3.91 12.84 27.49 5.22 49.73-17.67 19.49-20.06 20.91-35.61 29.61-35.61s10.12 15.55 29.61 35.61c22.24 22.89 45.82 30.51 49.73 17.67 2.98-9.81-21.72-19.06-36.18-43.44-5.59-9.41-7.4-14.83-3.32-16.82 6.76-3.92 24.67 34.94 81.13 34.58 15.34-.1 26.65-2.88 26.16-12.05-.33-6.1-8.62-8.13-20.66-9.77-21.19-2.89-50.18-16.66-47.86-22 2.93-7.32 50.78 21.89 91.4-32.18 8.93-12.91 4.59-19.67-1.22-21.58Zm-135.01-7.34c-6.04 11-18.83 18.63-33.78 18.63s-27.74-7.63-33.78-18.63c-1.27-2.32.61-5.03 3.57-5.03 0 0 14.59 6.53 30.22 6.53s30.22-6.53 30.22-6.53c2.95 0 4.84 2.71 3.57 5.03Zm52.51 8.89c1.89-7.85 28.72-1.81 48.22-32.68 4.15-6.57 11.54-5.61 14.23-2.88 5.97 6.05 5.08 21.17-15.85 35.65-14.63 10.88-32.21 12.18-41.32 7.91-6.93-3.22-5.27-8-5.27-8Zm-172.59 0c-1.89-7.85-28.72-1.81-48.22-32.68-4.15-6.57-11.54-5.61-14.23-2.88-5.97 6.05-5.08 21.17 15.85 35.65 14.63 10.88 32.21 12.18 41.32 7.91 6.93-3.22 5.27-8 5.27-8Z",
                            style: {
                                fill: 'url(#svg-cephy_svg__linear-gradient)'
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M110.52 306.85c15.19 8.49 40.3 10.26 56.26 5.29 32.75-10.19 46.72-36.6 29.87-113.5-10.6-48.37 8.19-100.6 78.54-101.43-7.53-2-15.89-3.13-25.2-3.13h-.65c-71.05.33-87.86 65.44-79.35 101.46 16.78 71.07 21.22 90.94-10.09 102.8-15.63 5.92-30.91 4.79-45.62-2.87-15.87-8.26-26.15-21.63-33.08-18.9-1.39.46-2.68 1.2-3.74 2.22 7.07 7.46 17.66 19.46 33.06 28.07Z",
                            className: "svg-cephy_svg__cls-5"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M306.48 192.79c3.47-31.52-15.82-60.49-47.29-66.62-4.67-1-7.76-5.72-6.21-10.36 4.14-10.64 15.94-2.43 22.86.5 19.91 9.82 34.44 29.94 36.69 52.02.98 8.55.78 16.95-.97 25.44-.29 1.4-1.66 2.3-3.06 2.02-1.4-.28-2.26-1.63-2.04-2.99Z",
                            className: "svg-cephy_svg__cls-5"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M210.76 240.42c-7.64 0-13.83-7.71-13.83-17.22 0-9.51 6.19-17.22 13.83-17.22 4.95 0 9.26 3.26 11.7 8.12-1.52-1.41-3.38-2.27-5.42-2.27-5.04 0-9.13 5.09-9.13 11.36s4.09 11.36 9.13 11.36c2.04 0 3.9-.86 5.42-2.27-2.44 4.86-6.75 8.12-11.7 8.12ZM291.76 240.42c-7.64 0-13.83-7.71-13.83-17.22s6.19-17.22 13.83-17.22c4.68 0 8.79 2.91 11.3 7.33-1.31-.91-2.8-1.48-4.41-1.48-5.04 0-9.13 5.09-9.13 11.36s4.09 11.36 9.13 11.36c1.61 0 3.1-.56 4.41-1.48-2.5 4.42-6.62 7.33-11.3 7.33Z",
                            className: "svg-cephy_svg__cls-4"
                        })
                    ]
                })
            })
        ]
    });
var $28ab7c56405aa7ea$export$2e2bcd8739ae039 = $28ab7c56405aa7ea$var$SvgSvgCephy;



parcelRequire("7fPBF");
const $3e1a50be14ab9a9e$var$SvgSwitchControl = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M50 77.353c15.107 0 27.353-12.246 27.353-27.353 0-15.107-12.246-27.353-27.353-27.353-15.107 0-27.353 12.246-27.353 27.353 0 15.107 12.246 27.353 27.353 27.353ZM50 80c16.569 0 30-13.431 30-30 0-16.568-13.431-30-30-30-16.568 0-30 13.432-30 30 0 16.569 13.432 30 30 30Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                d: "M72 50c0 12.15-9.85 22-22 22s-22-9.85-22-22 9.85-22 22-22 22 9.85 22 22Z"
            })
        ]
    });
var $3e1a50be14ab9a9e$export$2e2bcd8739ae039 = $3e1a50be14ab9a9e$var$SvgSwitchControl;



parcelRequire("7fPBF");
const $78046ad711fac15d$var$SvgSwitchControl1 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: 50,
                cy: 50,
                r: 32.5,
                stroke: "#000",
                strokeWidth: 3
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: 50,
                cy: 50,
                r: 42.5,
                stroke: "#000",
                strokeWidth: 3,
                opacity: 0.1
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: 50,
                cy: 50,
                r: 25,
                fill: "#E51546"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#FBFDFE",
                d: "M74.813 67.203v6.89A15.313 15.313 0 0 1 59.5 89.407c-8.456 0-10.682-4.594-17.862-17.226a3.828 3.828 0 0 1 6.63-3.828l3.576 5.742V53.422a3.828 3.828 0 1 1 7.656 0V64.14a3.828 3.828 0 1 1 7.656 0v3.062a3.828 3.828 0 1 1 7.656 0Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                d: "M70.984 61.844a5.333 5.333 0 0 0-2.555.649 5.359 5.359 0 0 0-7.398-3.195v-5.876a5.36 5.36 0 0 0-10.719 0v15.312l-.73-1.173a5.363 5.363 0 0 0-9.274 5.384l.894 1.576c6.586 11.61 9.311 16.417 18.298 16.417a16.863 16.863 0 0 0 16.844-16.844v-6.89a5.36 5.36 0 0 0-5.36-5.36Zm2.297 12.25A13.797 13.797 0 0 1 59.5 87.875c-7.203 0-9.157-3.445-15.634-14.868l-.898-1.583v-.01a2.297 2.297 0 0 1 .837-3.137 2.273 2.273 0 0 1 1.148-.306 2.297 2.297 0 0 1 2.02 1.192l3.573 5.742a1.53 1.53 0 0 0 2.829-.811V53.422a2.297 2.297 0 0 1 4.594 0v13.016a1.531 1.531 0 1 0 3.062 0V64.14a2.297 2.297 0 0 1 4.594 0v3.828a1.531 1.531 0 0 0 3.062 0v-.766a2.297 2.297 0 0 1 4.594 0v6.89Z"
            })
        ]
    });
var $78046ad711fac15d$export$2e2bcd8739ae039 = $78046ad711fac15d$var$SvgSwitchControl1;



parcelRequire("7fPBF");
const $4bb4296f4d314913$var$SvgSwitchControl2 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: 50,
                cy: 50,
                r: 32.5,
                stroke: "#000",
                strokeWidth: 3
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: 50,
                cy: 50,
                r: 42.5,
                stroke: "#000",
                strokeWidth: 3,
                opacity: 0.1
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: 50,
                cy: 50,
                r: 25,
                fill: "#E51546"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#FBFDFE",
                d: "M74.813 67.203v6.89A15.313 15.313 0 0 1 59.5 89.407c-8.456 0-10.682-4.594-17.862-17.226a3.828 3.828 0 0 1 6.63-3.828l3.576 5.742V53.422a3.828 3.828 0 1 1 7.656 0V64.14a3.828 3.828 0 1 1 7.656 0v3.062a3.828 3.828 0 1 1 7.656 0Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                d: "M70.984 61.844a5.333 5.333 0 0 0-2.555.649 5.359 5.359 0 0 0-7.398-3.195v-5.876a5.36 5.36 0 0 0-10.719 0v15.312l-.73-1.173a5.363 5.363 0 0 0-9.274 5.384l.894 1.576c6.586 11.61 9.311 16.417 18.298 16.417a16.863 16.863 0 0 0 16.844-16.844v-6.89a5.36 5.36 0 0 0-5.36-5.36Zm2.297 12.25A13.797 13.797 0 0 1 59.5 87.875c-7.203 0-9.157-3.445-15.634-14.868l-.898-1.583v-.01a2.297 2.297 0 0 1 .837-3.137 2.273 2.273 0 0 1 1.148-.306 2.297 2.297 0 0 1 2.02 1.192l3.573 5.742a1.53 1.53 0 0 0 2.829-.811V53.422a2.297 2.297 0 0 1 4.594 0v13.016a1.531 1.531 0 1 0 3.062 0V64.14a2.297 2.297 0 0 1 4.594 0v3.828a1.531 1.531 0 0 0 3.062 0v-.766a2.297 2.297 0 0 1 4.594 0v6.89Z"
            })
        ]
    });
var $4bb4296f4d314913$export$2e2bcd8739ae039 = $4bb4296f4d314913$var$SvgSwitchControl2;



parcelRequire("7fPBF");
const $6b7947571a956063$var$SvgSwitchSimple = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M10 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm0 1.5a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: 10,
                cy: 10,
                r: 5,
                fill: "currentColor"
            })
        ]
    });
var $6b7947571a956063$export$2e2bcd8739ae039 = $6b7947571a956063$var$SvgSwitchSimple;



parcelRequire("7fPBF");
const $d4753e72983465a2$var$SvgSymantec = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M46 2v2h2V2Zm0 2h-4v2h4Zm-8 2v4h2V6Zm2 4v2h2v-2Zm2 0h2V8h-2Zm-2 2h-2v2h-2v2h-2v-2h2v-2h-2v1.598C30.602 10.699 26.3 9 21.5 9 10.7 9 2 17.7 2 28.5S10.7 48 21.5 48 41 39.3 41 28.5c0-3.8-1.102-7.3-3-10.3V16h2Zm-4 0h2v-2h-2Zm-14.5-1c3.898 0 7.602 1.3 10.5 3.5V16h-2v.8C27.602 15 24.7 14 21.5 14 13.5 14 7 20.5 7 28.5S13.5 43 21.5 43 36 36.5 36 28.5c0-2.7-.7-5.2-2-7.3V20h-2v-2h2v2h2.8c1.4 2.5 2.2 5.398 2.2 8.5C39 38.102 31.102 46 21.5 46S4 38.102 4 28.5 11.898 11 21.5 11Zm0 5c2.8 0 5.398.898 7.5 2.5v.5h-2s-4.102 8-5 10c0 0-5-7-8-7 0 0-1-.102-1 1s1 2 1 2 4.102 3.5 6 10c.2.7.8 2 2.5 2 1 0 1.898-.8 2.5-2 1-2 2.102-6.2 5-10v-1h2v-2h.2c1.198 1.898 1.8 4.102 1.8 6.5C34 35.398 28.398 41 21.5 41S9 35.398 9 28.5 14.602 16 21.5 16Z"
        })
    });
var $d4753e72983465a2$export$2e2bcd8739ae039 = $d4753e72983465a2$var$SvgSymantec;



parcelRequire("7fPBF");
const $e0ea924b4f8fb967$var$SvgTabKey2 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.6 4C5.862 4 2 7.862 2 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h28.8c4.738 0 8.6-3.862 8.6-8.6V12.6C48 7.862 44.138 4 39.4 4H10.6zm0 2h28.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H10.6A6.585 6.585 0 0 1 4 31.4V12.6C4 8.943 6.943 6 10.6 6zm19.125 10.365v10.37h1.632v-1.182h.118c.423.82 1.29 1.304 2.336 1.304 1.886 0 3.07-1.482 3.07-3.86 0-2.393-1.176-3.862-3.07-3.862-1.025 0-1.886.497-2.276 1.31h-.115v-4.08h-1.695zm-16.633.506v1.524h3.035v8.34h1.764v-8.34h3.043V16.87h-7.842zm11.525 2.234c-1.777 0-3.013.842-3.15 2.16h1.6c.157-.505.69-.779 1.468-.779.916 0 1.408.412 1.408 1.143v.629l-1.927.115c-1.818.109-2.836.888-2.836 2.242 0 1.367 1.03 2.243 2.472 2.242.978 0 1.798-.423 2.215-1.148h.117v1.025h1.633V21.63c0-1.585-1.079-2.524-3-2.524zm8.662 1.471c1.155 0 1.86.916 1.86 2.42s-.698 2.42-1.86 2.42c-1.162 0-1.886-.93-1.886-2.42 0-1.49.731-2.42 1.886-2.42zm-7.336 2.822v.596c0 .868-.765 1.531-1.79 1.531-.753 0-1.294-.376-1.294-1.005 0-.61.447-.95 1.397-1.012l1.687-.11zM4 36.902A8.588 8.588 0 0 0 10.6 40h28.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H10.6A6.585 6.585 0 0 1 4 38.4v-1.498z"
        })
    });
var $e0ea924b4f8fb967$export$2e2bcd8739ae039 = $e0ea924b4f8fb967$var$SvgTabKey2;



parcelRequire("7fPBF");
const $02e80b1c53448aa7$var$SvgTabMac = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11 7c-2.75 0-5 2.25-5 5v26c0 2.75 2.25 5 5 5h28c2.75 0 5-2.25 5-5V12c0-2.75-2.25-5-5-5H11zm0 2h28c1.668 0 3 1.332 3 3v26c0 1.668-1.332 3-3 3H11c-1.668 0-3-1.332-3-3V12c0-1.668 1.332-3 3-3zm16.984 11.986A1 1 0 0 0 27 22v14a1 1 0 1 0 2 0V22a1 1 0 0 0-1.016-1.014zM19.99 23.99a1 1 0 0 0-.697 1.717L21.586 28H13a1 1 0 1 0 0 2h8.586l-2.293 2.293a1 1 0 1 0 1.414 1.414l3.912-3.912a1 1 0 0 0-.002-1.592l-3.91-3.91a1 1 0 0 0-.717-.303z"
        })
    });
var $02e80b1c53448aa7$export$2e2bcd8739ae039 = $02e80b1c53448aa7$var$SvgTabMac;



const $ac547a61f677026b$var$SvgTapPause = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: 50,
                cy: 50,
                r: 26.5,
                stroke: "currentColor",
                strokeWidth: 3
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                width: 3,
                height: 18,
                x: 43,
                y: 41,
                fill: "currentColor",
                rx: 1.5
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                width: 3,
                height: 18,
                x: 54,
                y: 41,
                fill: "currentColor",
                rx: 1.5
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#FBFDFE",
                d: "M83.125 67.031v5.906A13.125 13.125 0 0 1 70 86.064c-7.248 0-9.156-3.938-15.31-14.766a3.281 3.281 0 0 1 5.683-3.281l3.065 4.921V55.22a3.281 3.281 0 1 1 6.562 0v9.187a3.281 3.281 0 0 1 6.563 0v2.625a3.281 3.281 0 0 1 6.562 0Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                d: "M79.844 62.438c-.765-.001-1.518.19-2.19.556a4.594 4.594 0 0 0-6.341-2.739V55.22a4.594 4.594 0 1 0-9.188 0v13.125l-.627-1.006a4.596 4.596 0 0 0-7.949 4.615l.767 1.35C59.96 83.255 62.297 87.375 70 87.375a14.454 14.454 0 0 0 14.438-14.437V67.03a4.594 4.594 0 0 0-4.594-4.594Zm1.969 10.5A11.826 11.826 0 0 1 70 84.75c-6.174 0-7.849-2.953-13.4-12.744l-.77-1.357v-.008a1.969 1.969 0 0 1 .717-2.69c.299-.173.639-.263.984-.262a1.969 1.969 0 0 1 1.731 1.022l3.063 4.922a1.313 1.313 0 0 0 2.425-.695v-17.72a1.969 1.969 0 1 1 3.938 0v11.157a1.313 1.313 0 0 0 2.624 0v-1.969a1.969 1.969 0 1 1 3.938 0v3.281a1.313 1.313 0 0 0 2.625 0v-.656a1.969 1.969 0 1 1 3.938 0v5.906Z"
            })
        ]
    });
var $ac547a61f677026b$export$2e2bcd8739ae039 = $ac547a61f677026b$var$SvgTapPause;



const $27e318183cdf78bd$var$SvgTapPlay = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: 50,
                cy: 50,
                r: 26.5,
                stroke: "currentColor",
                strokeWidth: 3
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                d: "m61 50-16.5 9.526V40.474L61 50Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#FBFDFE",
                d: "M83.125 67.031v5.906A13.125 13.125 0 0 1 70 86.064c-7.248 0-9.156-3.938-15.31-14.766a3.281 3.281 0 0 1 5.683-3.281l3.065 4.921V55.22a3.281 3.281 0 1 1 6.562 0v9.187a3.281 3.281 0 0 1 6.563 0v2.625a3.281 3.281 0 0 1 6.562 0Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                d: "M79.844 62.438c-.765-.001-1.518.19-2.19.556a4.594 4.594 0 0 0-6.341-2.739V55.22a4.594 4.594 0 1 0-9.188 0v13.125l-.627-1.006a4.596 4.596 0 0 0-7.949 4.615l.767 1.35C59.96 83.255 62.297 87.375 70 87.375a14.454 14.454 0 0 0 14.438-14.437V67.03a4.594 4.594 0 0 0-4.594-4.594Zm1.969 10.5A11.826 11.826 0 0 1 70 84.75c-6.174 0-7.849-2.953-13.4-12.744l-.77-1.357v-.008a1.969 1.969 0 0 1 .717-2.69c.299-.173.639-.263.984-.262a1.969 1.969 0 0 1 1.731 1.022l3.063 4.922a1.313 1.313 0 0 0 2.425-.695v-17.72a1.969 1.969 0 1 1 3.938 0v11.157a1.313 1.313 0 0 0 2.624 0v-1.969a1.969 1.969 0 1 1 3.938 0v3.281a1.313 1.313 0 0 0 2.625 0v-.656a1.969 1.969 0 1 1 3.938 0v5.906Z"
            })
        ]
    });
var $27e318183cdf78bd$export$2e2bcd8739ae039 = $27e318183cdf78bd$var$SvgTapPlay;



const $0b5a1ec4c31772a9$var$SvgTapStop = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: 50,
                cy: 50,
                r: 26.5,
                stroke: "currentColor",
                strokeWidth: 3
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#FBFDFE",
                d: "M83.125 67.031v5.906A13.125 13.125 0 0 1 70 86.064c-7.248 0-9.156-3.938-15.31-14.766a3.281 3.281 0 0 1 5.683-3.281l3.065 4.921V55.22a3.281 3.281 0 1 1 6.562 0v9.187a3.281 3.281 0 0 1 6.563 0v2.625a3.281 3.281 0 0 1 6.562 0Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                d: "M79.844 62.438c-.765-.001-1.518.19-2.19.556a4.594 4.594 0 0 0-6.341-2.739V55.22a4.594 4.594 0 1 0-9.188 0v13.125l-.627-1.006a4.596 4.596 0 0 0-7.949 4.615l.767 1.35C59.96 83.255 62.297 87.375 70 87.375a14.454 14.454 0 0 0 14.438-14.437V67.03a4.594 4.594 0 0 0-4.594-4.594Zm1.969 10.5A11.826 11.826 0 0 1 70 84.75c-6.174 0-7.849-2.953-13.4-12.744l-.77-1.357v-.008a1.969 1.969 0 0 1 .717-2.69c.299-.173.639-.263.984-.262a1.969 1.969 0 0 1 1.731 1.022l3.063 4.922a1.313 1.313 0 0 0 2.425-.695v-17.72a1.969 1.969 0 1 1 3.938 0v11.157a1.313 1.313 0 0 0 2.624 0v-1.969a1.969 1.969 0 1 1 3.938 0v3.281a1.313 1.313 0 0 0 2.625 0v-.656a1.969 1.969 0 1 1 3.938 0v5.906Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                d: "M42 42h16v16H42z"
            })
        ]
    });
var $0b5a1ec4c31772a9$export$2e2bcd8739ae039 = $0b5a1ec4c31772a9$var$SvgTapStop;



parcelRequire("7fPBF");
const $39440ba5457cc20b$var$SvgTiktok = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4C6.25 4 4 6.25 4 9v32c0 2.75 2.25 5 5 5h32c2.75 0 5-2.25 5-5V9c0-2.75-2.25-5-5-5H9zm0 2h32c1.672 0 3 1.328 3 3v32c0 1.672-1.328 3-3 3H9c-1.672 0-3-1.328-3-3V9c0-1.672 1.328-3 3-3zm17.043 4a1 1 0 0 0-1 .998l-.022 9.762-.015 6.73L25 30.594c0 1.815-1.649 3.299-3.527 3.299a3.337 3.337 0 0 1-3.352-3.354 3.335 3.335 0 0 1 3.352-3.352c.063 0 .19.021.408.047A1 1 0 0 0 23 26.24v-4.2a1 1 0 0 0-.937-.999c-.156-.01-.352-.03-.59-.03-5.25 0-9.528 4.279-9.528 9.528 0 5.25 4.278 9.527 9.528 9.527 5.249 0 9.527-4.277 9.527-9.527V21.49c1.455 1.164 3.268 1.9 5.27 1.9.273 0 .532-.016.78-.038a1 1 0 0 0 .909-.997v-4.67a1 1 0 0 0-.928-.997 6.478 6.478 0 0 1-5.978-5.792 1 1 0 0 0-.994-.896h-4.016zm.998 2h2.281a8.35 8.35 0 0 0 6.637 6.445v2.866c-2.139-.11-4.018-1.176-5.123-2.858a1 1 0 0 0-1.836.55V30.54a7.513 7.513 0 0 1-7.527 7.527 7.513 7.513 0 0 1-7.528-7.527c0-4 3.121-7.176 7.055-7.432v2.176c-2.714.253-4.879 2.48-4.879 5.256 0 2.944 2.407 5.354 5.352 5.354 2.929 0 5.527-2.307 5.527-5.3l.006-3.099.015-6.73.02-8.764z"
        })
    });
var $39440ba5457cc20b$export$2e2bcd8739ae039 = $39440ba5457cc20b$var$SvgTiktok;



parcelRequire("7fPBF");
const $e3d15c36ae3535e8$var$SvgTodoist = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M6 4c-1.09 0-2 .91-2 2v38c0 1.09.91 2 2 2h38c1.09 0 2-.91 2-2V6c0-1.09-.91-2-2-2H6zm0 2h38v38H6v-9.13l5.89 3.12c.3.16.67.16.96-.01L30 28.21c.6-.34.68-1.19.14-1.63l-1.35-1.13c-.32-.27-.78-.3-1.15-.09l-14.79 8.37c-.3.17-.66.18-.96.02L6 30.666v-2.734l5.76 3.058c.31.16.67.16.97-.01l17.14-9.77c.61-.34.68-1.19.15-1.63l-1.35-1.13c-.33-.27-.79-.3-1.15-.09l-14.8 8.37a.976.976 0 0 1-.95.02L6 23.734V21l5.64 2.99c.3.16.67.16.96-.01l17.15-9.77c.6-.34.68-1.19.14-1.63l-1.35-1.13c-.32-.27-.78-.3-1.15-.09L12.6 19.73c-.3.17-.66.18-.96.02L6 16.797V6z"
        })
    });
var $e3d15c36ae3535e8$export$2e2bcd8739ae039 = $e3d15c36ae3535e8$var$SvgTodoist;



parcelRequire("7fPBF");
const $5c13e7fb415e096f$var$SvgToggleKey = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M12.906 2.969a1.169 1.169 0 0 0-.219.062.88.88 0 0 0-.093.031 1.204 1.204 0 0 0-.188.126.949.949 0 0 0-.125.093.954.954 0 0 0-.125.156l-7.875 7.844a1.014 1.014 0 0 0 0 1.438c.399.398 1.04.398 1.438 0L12 6.438V38c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879V6.438l6.281 6.28c.399.4 1.04.4 1.438 0a1.014 1.014 0 0 0 0-1.437l-7.875-7.844A1.022 1.022 0 0 0 13.188 3a.972.972 0 0 0-.282-.031ZM37 3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm-.094 3.969c-.043.008-.086.02-.125.031A1.002 1.002 0 0 0 36 12v31.563l-6.281-6.282A1.007 1.007 0 0 0 28.78 37a.994.994 0 0 0-.781.703c-.105.367.004.758.281 1.016l7.875 7.843c.02.032.04.063.063.094l.062.063c.02.023.04.043.063.062h.031c.066.063.14.114.219.157h.031c.02.011.043.023.063.03h.03a.879.879 0 0 0 .094.032c.106.016.208.016.313 0h.063a.967.967 0 0 0 .25-.094c.132-.066.25-.164.343-.281l7.938-7.906a1.014 1.014 0 0 0 0-1.438 1.014 1.014 0 0 0-1.438 0L38 43.563V12a1 1 0 0 0-1.094-1.031ZM13 41c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Z"
        })
    });
var $5c13e7fb415e096f$export$2e2bcd8739ae039 = $5c13e7fb415e096f$var$SvgToggleKey;



parcelRequire("7fPBF");
const $722cd4719e6bada2$var$SvgTools = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M38.5-.094c-.297.008-.605.028-.906.063-1.2.136-2.438.465-3.625.906C31.594 1.758 29.406 3.094 28 4.5c-1.52 1.52-2.266 3.375-2.25 5.281.012 1.649.629 3.313 1.531 4.906L25 17a1.004 1.004 0 0 0-.348 1.004c.086.371.38.664.75.75.375.086.762-.05 1.004-.348l2.813-2.812a.999.999 0 0 0 .125-1.25c-1.024-1.582-1.582-3.145-1.594-4.563-.012-1.418.477-2.695 1.656-3.875 1.094-1.093 3.157-2.363 5.282-3.156a11.749 11.749 0 0 1 3.78-.719l-3.78 3.75a.466.466 0 0 0-.032.063c-1.027 1.172-1.074 2.957.032 4.062L40 15.22l.031.031c1.172 1.027 2.957 1.074 4.063-.031l3.781-3.781a11.623 11.623 0 0 1-.719 3.812c-.789 2.113-2.058 4.152-3.156 5.25-1.18 1.18-2.434 1.613-3.844 1.594-1.41-.02-3.008-.574-4.656-1.563a1 1 0 0 0-1.219.157l-1.593 1.593a1.006 1.006 0 0 0 1.406 1.438l1.125-1.125c1.625.87 3.258 1.476 4.906 1.5 1.89.027 3.762-.668 5.281-2.188 1.403-1.402 2.742-3.574 3.625-5.937.883-2.364 1.348-4.926.625-7.094a1.001 1.001 0 0 0-.722-.648A1.005 1.005 0 0 0 48 8.5l-5.312 5.281c-.282.281-.86.32-1.282 0-.02-.015-.043-.015-.062-.031l-5.25-5.25c-.297-.297-.313-.918.062-1.344l5.25-5.25c.246-.242.348-.593.274-.933A1.001 1.001 0 0 0 41.03.25c-.8-.273-1.644-.371-2.531-.344ZM3.344 0c-.211.031-.41.129-.563.281l-2.5 2.5A1 1 0 0 0 .125 4l4.219 7.313a1 1 0 0 0 1 .468l2.187-.344L21.094 25l-.5.5a2.827 2.827 0 0 0 0 4l.687.719c.797.797 1.895.793 2.875.468l1.688 1.657c-.114 1.347.281 2.687 1.25 3.656L39.28 48.219a6.318 6.318 0 0 0 8.938 0v-.032c2.37-2.492 2.402-6.503 0-8.906L36 27.094c-1.008-1.008-2.348-1.32-3.656-1.25l-1.657-1.688c.325-.98.329-2.078-.468-2.875l-.719-.687a2.835 2.835 0 0 0-2-.844c-.727 0-1.45.293-2 .844l-.5.5L11.438 7.53l.343-2.187a1 1 0 0 0-.469-1L4 .125A.979.979 0 0 0 3.438 0h-.094Zm.344 2.25 6.03 3.469-.312 2.031c-.043.309.063.621.281.844L23.595 22.5 22.5 23.594 8.594 9.687a1.009 1.009 0 0 0-.844-.28l-2.031.312L2.25 3.688ZM27.5 21.781c.223 0 .445.07.594.219l.687.719a.83.83 0 0 1 .063 1.125 1 1 0 0 0 .062 1.375l2.282 2.281c.23.23.554.336.875.281.925-.152 1.894.082 2.53.719l12.188 12.219c1.594 1.593 1.61 4.351 0 6.062-1.73 1.73-4.332 1.73-6.062 0L28.5 34.594c-.664-.664-.926-1.606-.719-2.438a.996.996 0 0 0-.281-.968l-2.281-2.282a1 1 0 0 0-1.375-.062.83.83 0 0 1-1.125-.063L22 28.094c-.297-.297-.297-.89 0-1.188L26.906 22c.149-.148.371-.219.594-.219Zm-9.812 3a1.005 1.005 0 0 0-.594.313l-4.75 4.75c-.68-.133-1.348-.25-2.031-.25-5.637 0-10.22 4.582-10.22 10.218C.094 45.45 4.677 50 10.314 50 15.949 50 20.5 45.45 20.5 39.813c0-.731-.164-1.454-.344-2.157l3.438-3.437a1.006 1.006 0 0 0-1.407-1.438l-3.78 3.813a1.006 1.006 0 0 0-.25 1.062c.25.664.343 1.332.343 2.157A8.136 8.136 0 0 1 10.313 48c-4.563 0-8.22-3.625-8.22-8.187a8.189 8.189 0 0 1 8.22-8.22c.714 0 1.433.102 2.156.282.34.074.695-.031.937-.281L18.5 26.5a1.002 1.002 0 0 0-.719-1.719h-.093Zm14.03 5.5-1.437 1.438 12 12 1.438-1.438ZM11.376 34a1.006 1.006 0 0 0-.156.031L6.53 35.344a.998.998 0 0 0-.687.687L4.53 40.72a.997.997 0 0 0 .25 1l3.5 3.5c.254.25.625.347.969.25l4.813-1.313a1 1 0 0 0 .718-.718l1.188-4.688a.997.997 0 0 0-.25-.969l-3.5-3.5a1.009 1.009 0 0 0-.844-.281Zm-.187 2.125 2.687 2.688-.906 3.593-3.656.969-2.688-2.687.969-3.594Z"
        })
    });
var $722cd4719e6bada2$export$2e2bcd8739ae039 = $722cd4719e6bada2$var$SvgTools;



parcelRequire("7fPBF");
const $7fccdf11ae80529b$var$SvgTouchpad = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M5.008 5A4.023 4.023 0 0 0 1 9.008v25.984A4.023 4.023 0 0 0 5.008 39H12a1 1 0 1 0 0-2H5.008A1.994 1.994 0 0 1 3 34.992V9.008C3 7.888 3.887 7 5.008 7h39.984C46.112 7 47 7.889 47 9.008v25.984c0 1.12-.889 2.008-2.008 2.008H42a1 1 0 1 0 0 2h2.992A4.023 4.023 0 0 0 49 34.992V9.008A4.024 4.024 0 0 0 44.992 5H5.008zM24 12c-6.063 0-11 4.937-11 11 0 .48.031.955.092 1.422a1 1 0 1 0 1.982-.256A9.066 9.066 0 0 1 15 23c0-4.983 4.017-9 9-9s9 4.017 9 9c0 .437-.032.865-.092 1.283a1 1 0 0 0 1.98.283c.075-.513.112-1.035.112-1.566 0-6.063-4.937-11-11-11zm0 4c-3.854 0-7 3.146-7 7a1 1 0 1 0 2 0c0-2.774 2.226-5 5-5s5 2.226 5 5a1 1 0 1 0 2 0c0-3.854-3.146-7-7-7zm0 4c-1.645 0-3 1.355-3 3v12.258l-1.06-1.06a3.015 3.015 0 0 0-4.243 0 3.015 3.015 0 0 0 0 4.241l5.596 5.596a1 1 0 0 0 .008.008s.74.723 1.781 1.443C24.124 46.206 25.474 47 27 47h4.777c3.8 0 6.927-2.962 7.196-6.7.007-.042.027-.125.027-.3v-7c0-1.645-1.355-3-3-3-.607 0-1.088.337-1.562.652C33.923 29.73 33.12 29 32 29c-.607 0-1.088.337-1.562.652C29.923 28.73 29.12 28 28 28c-.388 0-.658.279-1 .416V23c0-1.645-1.355-3-3-3zm0 2c.565 0 1 .435 1 1v9a1 1 0 1 0 2 0v-.986A1 1 0 0 0 27 31c0-.565.435-1 1-1s1 .435 1 1v1a1 1 0 0 0 .049.295 1 1 0 0 0 .035.094 1 1 0 0 0 .1.173 1 1 0 0 0 .06.079 1 1 0 0 0 .069.072 1 1 0 0 0 .158.123 1 1 0 0 0 .088.047 1 1 0 0 0 .187.07 1 1 0 0 0 .098.022 1 1 0 0 0 .199.01 1 1 0 0 0 .293-.057 1 1 0 0 0 .094-.04 1 1 0 0 0 .088-.046 1 1 0 0 0 .228-.192 1 1 0 0 0 .065-.078 1 1 0 0 0 .136-.265 1 1 0 0 0 .053-.293A1 1 0 0 0 31 32c0-.565.435-1 1-1s1 .435 1 1v1a1 1 0 0 0 2 0c0-.565.435-1 1-1s1 .435 1 1v7c0-.047-.001-.019-.016.102a1 1 0 0 0-.005.05A5.204 5.204 0 0 1 31.777 45H27c-.74 0-1.89-.542-2.781-1.158a12.889 12.889 0 0 1-1.512-1.22l-.008-.009-5.588-5.588a.985.985 0 0 1 0-1.414.985.985 0 0 1 1.414 0l2.768 2.768A1 1 0 0 0 23 37.672V23c0-.565.435-1 1-1z"
        })
    });
var $7fccdf11ae80529b$export$2e2bcd8739ae039 = $7fccdf11ae80529b$var$SvgTouchpad;



parcelRequire("7fPBF");
const $f481633bf928acdb$var$SvgTrello = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4C6.25 4 4 6.25 4 9v32c0 2.75 2.25 5 5 5h32c2.75 0 5-2.25 5-5V9c0-2.75-2.25-5-5-5H9zm0 2h32c1.668 0 3 1.332 3 3v32c0 1.668-1.332 3-3 3H9c-1.668 0-3-1.332-3-3V9c0-1.668 1.332-3 3-3zm3 3c-1.645 0-3 1.355-3 3v24c0 1.645 1.355 3 3 3h7c1.645 0 3-1.355 3-3V12c0-1.645-1.355-3-3-3h-7zm19 0c-1.645 0-3 1.355-3 3v12c0 1.645 1.355 3 3 3h7c1.645 0 3-1.355 3-3V12c0-1.645-1.355-3-3-3h-7zm-19 2h7c.565 0 1 .435 1 1v24c0 .565-.435 1-1 1h-7c-.565 0-1-.435-1-1V12c0-.565.435-1 1-1zm19 0h7c.565 0 1 .435 1 1v12c0 .565-.435 1-1 1h-7c-.565 0-1-.435-1-1V12c0-.565.435-1 1-1z"
        })
    });
var $f481633bf928acdb$export$2e2bcd8739ae039 = $f481633bf928acdb$var$SvgTrello;



parcelRequire("7fPBF");
const $fe23b5827fb90960$var$SvgTripadvisor = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 11c-5.832 0-11.156 1.512-15.21 4H2s1.754 2.152 2.578 4.578A11.952 11.952 0 0 0 2 27c0 6.629 5.371 12 12 12 3.496 0 6.637-1.508 8.828-3.895L25 38l2.172-2.895C29.363 37.492 32.504 39 36 39c6.629 0 12-5.371 12-12 0-2.805-.969-5.379-2.578-7.422C46.246 17.152 48 15 48 15h-7.797c-4.055-2.488-9.375-4-15.203-4Zm0 2c3.883 0 7.586.707 10.8 2.012A11.99 11.99 0 0 0 25 22.215a11.985 11.985 0 0 0-10.828-7.203l.07-.024C17.453 13.7 21.145 13 25 13Zm-11 4c5.523 0 10 4.477 10 10s-4.477 10-10 10S4 32.523 4 27s4.477-10 10-10Zm22 0c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10Zm-22 4c-3.312 0-6 2.688-6 6 0 3.313 2.688 6 6 6 3.313 0 6-2.687 6-6 0-3.312-2.687-6-6-6Zm22 0c-3.312 0-6 2.688-6 6 0 3.313 2.688 6 6 6 3.313 0 6-2.687 6-6 0-3.312-2.687-6-6-6Zm-22 2c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4Zm22 0c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4Zm-22 2a1.999 1.999 0 1 0 0 4 1.999 1.999 0 1 0 0-4Zm22 0a1.999 1.999 0 1 0 0 4 1.999 1.999 0 1 0 0-4Z"
        })
    });
var $fe23b5827fb90960$export$2e2bcd8739ae039 = $fe23b5827fb90960$var$SvgTripadvisor;



parcelRequire("7fPBF");
const $1695f1b8e4452b4e$var$SvgTv = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M0 7v32h50V7Zm2 2h46v28H2Zm8.813 32c-.551.05-.958.543-.907 1.094.051.55.543.957 1.094.906h28c.36.004.695-.184.879-.496a1.01 1.01 0 0 0 0-1.008c-.184-.312-.52-.5-.879-.496H10.812Z"
        })
    });
var $1695f1b8e4452b4e$export$2e2bcd8739ae039 = $1695f1b8e4452b4e$var$SvgTv;



parcelRequire("7fPBF");
const $0c48daaee27f5aac$var$SvgTwitch = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "m5.313 1-.25.656-3 8L2 9.812V43h11v6h7.406l.313-.281L26.437 43h8.97l.312-.281L48 30.437V1Zm1.375 2H46v26.594L34.594 41h-9l-6 6H15v-6H4V10.188ZM10 5v30h8v7.406l1.719-1.687L25.437 35h11.97l.312-.281 6-6 .281-.313V5Zm2 2h30v20.563L36.563 33h-11.97l-.312.281L20 37.563V33h-8Zm8 6v14h6V13Zm10 0v14h6V13Zm-8 2h2v10h-2Zm10 0h2v10h-2Z"
        })
    });
var $0c48daaee27f5aac$export$2e2bcd8739ae039 = $0c48daaee27f5aac$var$SvgTwitch;



parcelRequire("7fPBF");
const $d417e5b9a3bf4ea5$var$SvgTwitterx = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11 4c-3.854 0-7 3.146-7 7v28c0 3.854 3.146 7 7 7h28c3.854 0 7-3.146 7-7V11c0-3.854-3.146-7-7-7H11zm0 2h28c2.774 0 5 2.226 5 5v28c0 2.774-2.226 5-5 5H11c-2.774 0-5-2.226-5-5V11c0-2.774 2.226-5 5-5zm2.086 7 9.223 13.104L13 37h2.5l7.938-9.293L29.977 37h7.937L27.79 22.613 36 13h-2.5l-6.84 8.01L21.023 13h-7.937zm3.828 2h3.065l14.107 20H31.02L16.914 15z"
        })
    });
var $d417e5b9a3bf4ea5$export$2e2bcd8739ae039 = $d417e5b9a3bf4ea5$var$SvgTwitterx;



parcelRequire("7fPBF");
const $418d4e99ed245825$var$SvgUber = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14.5 20c-.277 0-.5.223-.5.5v9c0 .277.223.5.5.5H21c1.207 0 3-.8 3-3 0-1.277-.61-2.07-1.348-2.52.211-.402.348-.886.348-1.48 0-2.2-1.793-3-3-3Zm14 0c-.277 0-.5.223-.5.5v9c0 .277.223.5.5.5h7.387c.11 0 .215-.062.265-.168l.836-1.691c.035-.063-.011-.141-.086-.141H30v-1.5c0-.277.223-.5.5-.5h3.375a.292.292 0 0 0 .266-.168l.847-1.687a.099.099 0 0 0-.086-.145H30v-2h5.86c.109 0 .21-.062.265-.16l.863-1.695a.098.098 0 0 0-.086-.145Zm11.996 0a.495.495 0 0 0-.496.5v9.2c0 .163.137.3.3.3H42v-2c0-.55.45-1 1-1h2.984l1.7 2.848a.3.3 0 0 0 .257.152h1.961c.075 0 .121-.082.082-.152l-1.879-3.188C49.285 26.14 50 25.02 50 23.5c0-2.125-1.375-3.5-3.5-3.5Zm-40.195.074c-.164 0-.301.137-.301.301V26c0 1.512 1.047 4.375 5 4.375 3.953 0 5-2.863 5-4.375v-5.926H8.3c-.163 0-.3.137-.3.301v5.613c-.008.399-.187 2.387-3 2.387-2.812 0-2.992-1.984-3-2.375v-5.926ZM16 22h3.988c.461.012 1.012.195 1.012 1 0 .746-.473.957-.898.996-.055 0-.079 0-.114.004H16Zm26 0h4.5c1.344 0 1.5.855 1.5 1.5s-.156 1.5-1.5 1.5H42Zm-25.5 4h4.488c.461.012 1.012.195 1.012 1 0 .805-.55.988-1.012 1H16v-1.5c0-.277.223-.5.5-.5Z"
        })
    });
var $418d4e99ed245825$export$2e2bcd8739ae039 = $418d4e99ed245825$var$SvgUber;



parcelRequire("7fPBF");
const $6eacdd29be96605e$var$SvgUnity = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M40.45 3a.934.934 0 0 0-.274.031l-16.41 4a.98.98 0 0 0-.692.598L21.324 12H16a.994.994 0 0 0-.734.324l-12 13a.992.992 0 0 0 .046 1.399l12.579 12c.187.18.433.277.691.277h5.742l1.75 4.371a.986.986 0 0 0 .754.613l17.461 3a1.002 1.002 0 0 0 1.148-.77l3.54-16.23c.054-.25.011-.515-.122-.734l-2.328-3.82 2.375-5a.982.982 0 0 0 .04-.758l-5.583-16c-.136-.39-.5-.656-.91-.672Zm-.68 2.188 5.152 14.753-1.477 3.106-3.492-11.344a.997.997 0 0 0-.98-.703 1.006 1.006 0 0 0-.868.55l-7 14c-.16.321-.136.7.06.997l8 12.21c.218.337.62.505 1.015.434a.995.995 0 0 0 .793-.761l2.48-10.914 1.484 2.433-3.25 14.903-15.968-2.743-1.117-2.797 11.582 2.153a1.001 1.001 0 0 0 1.011-1.543l-8.367-12.48A1.002 1.002 0 0 0 28 27H12a.999.999 0 0 0-.672 1.738L20.414 37h-3.43L5.402 25.953 16.437 14h3.301l-8.476 9.328a.995.995 0 0 0-.176 1.078c.16.36.52.594.914.594h16c.379 0 .727-.215.895-.55l7-14A1 1 0 0 0 35.03 9a.919.919 0 0 0-.254.023l-11.136 2.57 1.093-2.741Zm-6.614 6.265L27.383 23H14.262l8.27-9.094Zm5.625 3.227 3.184 10.36-2.418 10.651-6.395-9.757ZM14.586 29h12.883l6.742 10.063-10.746-1.997Z"
        })
    });
var $6eacdd29be96605e$export$2e2bcd8739ae039 = $6eacdd29be96605e$var$SvgUnity;



parcelRequire("7fPBF");
const $6506a335d289da77$var$SvgUnrealEngine = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2C12.309 2 2 12.309 2 25s10.309 23 23 23 23-10.309 23-23S37.691 2 25 2Zm0 2c11.61 0 21 9.39 21 21s-9.39 21-21 21S4 36.61 4 25 13.39 4 25 4Zm-1.36 6.45c-.074 0-.148.01-.218.027-3.953.941-8.027 3.71-11.09 7.132-3.059 3.426-5.168 7.532-4.7 11.371.056.426.376.774.802.86.421.082.851-.113 1.066-.492 1.953-3.453 3.57-5.364 4.723-6.38 1.152-1.019 1.894-1.109 1.836-1.109.074 0 .093.004.113.004-.024-.023.015-.004.015.246v10.485c0 .12 0 .09.004.078-.128.031-.55.016-.953-.047a1.006 1.006 0 0 0-.992.457.994.994 0 0 0 .016 1.09c3.484 5.195 11.105 5.375 11.105 5.375a.98.98 0 0 0 .778-.32l2.582-2.805 2.382 2.039c.34.289.825.32 1.196.078 2.504-1.621 4.539-3.766 5.968-5.621a22.262 22.262 0 0 0 1.676-2.477c.196-.347.352-.656.469-.93.117-.277.223-.452.223-.882a.997.997 0 0 0-1.738-.672c-1.102 1.211-2.094 1.902-2.84 2.29-.747.382-1.36.444-1.239.444-.09 0-.117-.011-.191-.02v-12.1c0 .19.078-.243.34-.692a19.66 19.66 0 0 1 1.07-1.582c.836-1.137 1.797-2.3 2.285-2.926a1.001 1.001 0 0 0-1.035-1.586c-3.215.844-5.469 2.074-6.93 3.117-1.031.735-1.242 1.051-1.539 1.38-.078-.036-.062-.044-.152-.075-.54-.191-1.324-.371-2.356-.371-.418 0-.789.262-.937.652a1 1 0 0 0 .289 1.106c.586.504 1.297 1.402 1.297 2.136v10.844c-.195.13-.29.207-.66.414-.602.336-1.39.61-1.575.61-.453 0-.777-.11-.914-.2-.132-.09-.128-.074-.128-.214v-13.61a.996.996 0 0 0-1.512-.86c-.078-.194-.188-.667-.188-1.464 0-.375.473-1.23 1.07-1.887.598-.652 1.204-1.117 1.204-1.117.343-.266.48-.715.34-1.125a1.006 1.006 0 0 0-.961-.672Zm-3.308 3.585c-.152.387-.344.754-.344 1.215 0 .957.106 1.66.34 2.23.238.57.688 1.032 1.195 1.2.067.023.102-.016.165-.004v12.508c0 .765.433 1.488 1.019 1.878.59.391 1.285.536 2.023.536 1.008 0 1.836-.465 2.551-.864.715-.398 1.266-.797 1.266-.797.262-.19.418-.492.418-.812V19.73c0-.543-.254-.94-.434-1.382.426.218.95.101 1.246-.278 0 0 .473-.633 1.75-1.539.739-.527 1.82-1.11 3.102-1.672-.078.102-.125.153-.2.254-.44.602-.859 1.203-1.179 1.758-.324.555-.617.969-.617 1.7v12.44c0 .352.129.735.347 1.005.22.265.489.414.723.504.465.18.852.171 1.121.171.36 0 .883-.246 1.356-.421-1.16 1.414-2.653 2.898-4.399 4.136l-2.488-2.129a.997.997 0 0 0-1.387.082l-2.86 3.11c-.585-.047-4.874-.59-7.8-3.2.18-.109.375-.144.52-.328.293-.37.422-.859.422-1.347V22.109c0-.582-.141-1.18-.56-1.625-.413-.449-1.023-.625-1.57-.625h-.003c-.797 0-1.774.391-3.153 1.61-.73.64-1.566 1.57-2.476 2.781.734-1.79 1.894-3.625 3.398-5.305 1.867-2.086 4.176-3.68 6.508-4.91Z"
        })
    });
var $6506a335d289da77$export$2e2bcd8739ae039 = $6506a335d289da77$var$SvgUnrealEngine;



const $18715178eb9fa0d1$var$SvgComponent = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 50 50",
        fill: "currentColor",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2C12.31 2 2 12.31 2 25s10.31 23 23 23 23-10.31 23-23S37.69 2 25 2zm0 2c11.61 0 21 9.39 21 21s-9.39 21-21 21S4 36.61 4 25 13.39 4 25 4zm-.066 3L25 9c.624 0 1.247.035 1.855.105l.233-1.986C26.403 7.04 25.7 7 25 7h-.066zm-4.15.496c-.682.164-1.357.369-2.005.608l.692 1.876a15.962 15.962 0 0 1 1.779-.539l-.467-1.945zm10.372.584-.683 1.88c.582.213 1.156.46 1.707.737l.9-1.785a17.717 17.717 0 0 0-1.924-.832zM15.055 9.994c-.577.383-1.141.808-1.674 1.258l1.293 1.525a15.5 15.5 0 0 1 1.484-1.115l-1.103-1.668zm21.511 1.215-1.285 1.531c.475.398.93.829 1.352 1.276l1.455-1.371a17.814 17.814 0 0 0-1.522-1.436zm-26.039 3.088c-.415.559-.8 1.149-1.146 1.752l1.734.996a16.02 16.02 0 0 1 1.02-1.557l-1.608-1.191zM25 14.586l-8.041 8.039 1.416 1.416L24 18.414V35h2V18.414l5.625 5.627 1.416-1.416L25 14.585zm15.586 1.404-1.73 1.002c.308.534.59 1.093.835 1.66l1.834-.795a18.207 18.207 0 0 0-.94-1.867zm-32.852 3.9a17.704 17.704 0 0 0-.474 2.042l1.97.338c.105-.61.247-1.218.422-1.811l-1.918-.568zm34.993 1.967-1.97.348c.108.61.18 1.23.216 1.848l1.996-.116a17.786 17.786 0 0 0-.242-2.08zM9.029 25.98l-1.996.12c.042.696.124 1.394.246 2.077l1.969-.35a16.084 16.084 0 0 1-.219-1.847zm31.733 1.785c-.107.61-.248 1.216-.424 1.808l1.916.57c.198-.664.357-1.35.478-2.035l-1.97-.343zm-30.44 3.615-1.834.797c.277.637.596 1.264.946 1.865l1.728-1.006a15.88 15.88 0 0 1-.84-1.656zM38.87 32.98a16.126 16.126 0 0 1-1.02 1.555l1.604 1.194c.414-.554.8-1.144 1.149-1.749l-1.733-1zm-25.48 3.026-1.451 1.377c.48.507.993.988 1.523 1.431l1.283-1.535a16.09 16.09 0 0 1-1.355-1.273zM35.3 37.242c-.474.4-.974.774-1.489 1.112l1.102 1.67a17.586 17.586 0 0 0 1.676-1.253l-1.29-1.529zM17.85 39.316l-.897 1.79c.621.31 1.269.589 1.924.826l.682-1.881a15.953 15.953 0 0 1-1.71-.735zm12.65.715c-.58.212-1.178.39-1.781.535l.465 1.946c.677-.162 1.35-.365 2.002-.602l-.686-1.879zm-7.324.867-.229 1.987A18.21 18.21 0 0 0 25 43h.033L25 41c-.61 0-1.224-.034-1.824-.102z"
        })
    });
var $18715178eb9fa0d1$export$2e2bcd8739ae039 = $18715178eb9fa0d1$var$SvgComponent;



parcelRequire("7fPBF");
const $7594f1f4d24bde25$var$SvgUsb2 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M15 2v15c-1.645 0-3 1.355-3 3v17c0 2.75 2.25 5 5 5h4v6h2v-6h4v6h2v-6h4c2.75 0 5-2.25 5-5V20c0-1.645-1.355-3-3-3V2H15zm2 2h16v13H17V4zm2 5v3h4V9h-4zm8 0v3h4V9h-4zM15 19h20c.565 0 1 .435 1 1v17c0 1.668-1.332 3-3 3H17c-1.668 0-3-1.332-3-3V20c0-.565.435-1 1-1z"
        })
    });
var $7594f1f4d24bde25$export$2e2bcd8739ae039 = $7594f1f4d24bde25$var$SvgUsb2;



parcelRequire("7fPBF");
const $afd76c8e7b7affb8$var$SvgUsbC = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M19 0c-2.75 0-5 2.25-5 5 0 .053.006.104.008.156V14h-.992c-2.75 0-5 2.25-5 5v25.96c0 2.75 2.25 5 5 5H39c2.75 0 5-2.25 5-5V19c0-2.75-2.25-5-5-5h-1V5a1 1 0 0 0-.006-.111C37.934 2.19 35.712 0 33 0H19zm0 2h14c1.668 0 3 1.332 3 3s-1.332 3-3 3H19a2.98 2.98 0 0 1-2.992-2.922V5a1 1 0 0 0-.002-.057A2.982 2.982 0 0 1 19 2zm0 2a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H19zm17 4.97v5.862a1 1 0 0 0 0 .326V19c0 1.117-.883 2-2 2H18.008c-1.117 0-2-.883-2-2v-3.898a1 1 0 0 0 0-.217V8.977A4.948 4.948 0 0 0 19 10h14c1.128 0 2.16-.393 3-1.03zM13.016 16h.992v3c0 2.197 1.802 4 4 4H34c2.197 0 4-1.803 4-4v-3h1c1.668 0 3 1.332 3 3v3.96c0 1.67-1.332 3-3 3H13.016c-1.669 0-3-1.33-3-3V19c0-1.668 1.331-3 3-3zm-3 10.932a4.948 4.948 0 0 0 3 1.029H39c1.128 0 2.16-.393 3-1.03v18.03c0 1.668-1.332 3-3 3H13.016c-1.669 0-3-1.332-3-3V26.93z"
        })
    });
var $afd76c8e7b7affb8$export$2e2bcd8739ae039 = $afd76c8e7b7affb8$var$SvgUsbC;



parcelRequire("7fPBF");
const $f45133cdb78263ed$var$SvgUsbOff = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M15 2v15c-1.645 0-3 1.355-3 3v17c0 2.75 2.25 5 5 5h4v6h2v-6h4v6h2v-6h4c2.75 0 5-2.25 5-5V20c0-1.645-1.355-3-3-3V2H15zm2 2h16v13H17V4zm2 6v3h4v-3h-4zm8 0v3h4v-3h-4zm-12 9h20c.565 0 1 .435 1 1v17c0 1.668-1.332 3-3 3H17c-1.668 0-3-1.332-3-3V20c0-.565.435-1 1-1zm10 3c-1.645 0-3 1.355-3 3s1.355 3 3 3 3-1.355 3-3-1.355-3-3-3zm0 2c.564 0 1 .436 1 1 0 .564-.436 1-1 1-.564 0-1-.436-1-1 0-.564.436-1 1-1z"
        })
    });
var $f45133cdb78263ed$export$2e2bcd8739ae039 = $f45133cdb78263ed$var$SvgUsbOff;



const $121fda4f624e73fb$var$SvgVector = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 505,
        height: 581,
        viewBox: "0 0 505 581",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "url(#Vector_svg__a)",
                d: "M457.684 1500.32c-30.12-243.44-94.261-446.21-131.864-628.43-39.122-202.555-86.469-422.65 73.305-576.105 116.836-115.344 315.292-105.303 457.472-38.511 151.373 81.241 235.493 212.117 137.965 476.192 73.888-97.375 111.808-218.289 97.368-323.135C1045.97 77.757 778.061-1.681 594.512.871c-175.52 2.533-394.476 113.857-497.94 328.182-70.68 146.511-99.608 353.409-24.858 728.307 91.609 459.01 54.045 777.53-62.825 1030.07-1.822 3.75-2.923 7.85-5.032 11.45-5.411 9.67-4.948 18.98 12.726 22.58 2.443.48 4.96 1.17 7.476 1.85 136.433 33.89 273.551 45.83 407.721 37.81 3.835-15.95 70.045-305.05 26.044-661.09l-.14.29Z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                    id: "Vector_svg__a",
                    x1: 459.422,
                    x2: 192.952,
                    y1: 41.475,
                    y2: 633.478,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                            stopColor: "#6DB9E7"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                            offset: 0.07,
                            stopColor: "#6CA2D7"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                            offset: 0.16,
                            stopColor: "#6B8AC6"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                            offset: 0.26,
                            stopColor: "#6B79BA"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                            offset: 0.37,
                            stopColor: "#6B6FB3"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                            offset: 0.5,
                            stopColor: "#6B6CB1"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                            offset: 1,
                            stopColor: "#062844"
                        })
                    ]
                })
            })
        ]
    });
var $121fda4f624e73fb$export$2e2bcd8739ae039 = $121fda4f624e73fb$var$SvgVector;



const $fa3e65f55eb3500f$var$SvgVirtualApps = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 50 50",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                d: "M48 36h-2.561A3.939 3.939 0 0 0 46 34V12c0-2.197-1.803-4-4-4h-4.625v2H42c1.117 0 2 .883 2 2v22c0 1.117-.883 2-2 2H8c-1.117 0-2-.883-2-2V12c0-1.117.883-2 2-2h4V8H8c-2.197 0-4 1.803-4 4v22c0 .731.214 1.408.561 2H2a1 1 0 0 0-1 1c0 2.75 2.25 5 5 5h38c2.75 0 5-2.25 5-5a1 1 0 0 0-1-1zm-4 4H6c-1.276 0-2.151-.888-2.588-2h43.176c-.437 1.112-1.312 2-2.588 2z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                d: "M24 28h2v6h-2zM35.734 7.419a2.39 2.39 0 0 0-1.213-1.259l-8.196-3.864a3.102 3.102 0 0 0-2.654.001L15.476 6.16A2.578 2.578 0 0 0 14 8.485v10.601c0 .959.529 1.831 1.38 2.276l8.177 4.283c.444.232.943.355 1.443.355.499 0 .998-.123 1.444-.355l8.174-4.281a2.562 2.562 0 0 0 1.381-2.277V9.493L36 9.329c.002-.596.005-1.27-.266-1.91zM24.523 4.106a1.117 1.117 0 0 1 .951-.001l7.818 3.686-8.295 4.094-8.347-4.068 7.873-3.711zm-8.216 15.485a.571.571 0 0 1-.307-.505V9.725l8 3.901v9.995l-7.693-4.03zm17.384 0L26 23.619v-9.997l8-3.95-.001 9.414a.568.568 0 0 1-.308.505z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                d: "m32.627 32.936-2.549-2.509V26h2v3.589l1.951 1.921zM17.452 32.936l-1.404-1.426L18 29.589V26h2v4.427z"
            })
        ]
    });
var $fa3e65f55eb3500f$export$2e2bcd8739ae039 = $fa3e65f55eb3500f$var$SvgVirtualApps;



parcelRequire("7fPBF");
const $faa4b1f11be8231d$var$SvgVirtualButton = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M30 22.85A5.85 5.85 0 0 1 35.85 17h28.8a5.85 5.85 0 0 1 5.85 5.85v54a5.85 5.85 0 0 1-5.85 5.85h-28.8A5.85 5.85 0 0 1 30 76.85v-54Zm5.85-3.15a3.15 3.15 0 0 0-3.15 3.15v54A3.15 3.15 0 0 0 35.85 80h28.8a3.15 3.15 0 0 0 3.15-3.15v-54a3.15 3.15 0 0 0-3.15-3.15h-28.8Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                d: "M36.75 33.65a1.8 1.8 0 0 1 1.8-1.8h8.1a1.8 1.8 0 0 1 1.8 1.8v8.1a1.8 1.8 0 0 1-1.8 1.8h-8.1a1.8 1.8 0 0 1-1.8-1.8v-8.1ZM36.75 48.05a1.8 1.8 0 0 1 1.8-1.8h8.1a1.8 1.8 0 0 1 1.8 1.8v8.1a1.8 1.8 0 0 1-1.8 1.8h-8.1a1.8 1.8 0 0 1-1.8-1.8v-8.1ZM36.75 62.45a1.8 1.8 0 0 1 1.8-1.8h8.1a1.8 1.8 0 0 1 1.8 1.8v8.1a1.8 1.8 0 0 1-1.8 1.8h-8.1a1.8 1.8 0 0 1-1.8-1.8v-8.1ZM52.05 33.65a1.8 1.8 0 0 1 1.8-1.8h8.1a1.8 1.8 0 0 1 1.8 1.8v8.1a1.8 1.8 0 0 1-1.8 1.8h-8.1a1.8 1.8 0 0 1-1.8-1.8v-8.1ZM52.05 48.05a1.8 1.8 0 0 1 1.8-1.8h8.1a1.8 1.8 0 0 1 1.8 1.8v8.1a1.8 1.8 0 0 1-1.8 1.8h-8.1a1.8 1.8 0 0 1-1.8-1.8v-8.1ZM52.05 62.45a1.8 1.8 0 0 1 1.8-1.8h8.1a1.8 1.8 0 0 1 1.8 1.8v8.1a1.8 1.8 0 0 1-1.8 1.8h-8.1a1.8 1.8 0 0 1-1.8-1.8v-8.1Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                d: "M43.95 22.85h12.6v2.7h-12.6v-2.7Z"
            })
        ]
    });
var $faa4b1f11be8231d$export$2e2bcd8739ae039 = $faa4b1f11be8231d$var$SvgVirtualButton;



parcelRequire("7fPBF");
const $24e6d56f54bae8bf$var$SvgVirtualReality = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10 8c-2.547 0-4.668 1.938-4.969 4.406C3.254 13.176 2 14.95 2 17v20c0 2.75 2.25 5 5 5h11.375a4.993 4.993 0 0 0 4.563-3h4.125a4.993 4.993 0 0 0 4.562 3H43c2.75 0 5-2.25 5-5V17c0-2.05-1.254-3.824-3.031-4.594C44.668 9.937 42.547 8 40 8Zm0 2h30c1.32 0 2.438.828 2.844 2H7.156A2.992 2.992 0 0 1 10 10Zm-3 4h36c1.668 0 3 1.332 3 3v20c0 1.668-1.332 3-3 3H31.625a2.977 2.977 0 0 1-2.75-1.812l-1.562-3.657A2.528 2.528 0 0 0 25 33c-1.004 0-1.918.61-2.312 1.531l-1.563 3.657A2.977 2.977 0 0 1 18.375 40H7c-1.668 0-3-1.332-3-3V17c0-1.668 1.332-3 3-3Zm7.5 7C10.922 21 8 23.922 8 27.5s2.922 6.5 6.5 6.5 6.5-2.922 6.5-6.5-2.922-6.5-6.5-6.5Zm21 0c-3.578 0-6.5 2.922-6.5 6.5s2.922 6.5 6.5 6.5 6.5-2.922 6.5-6.5-2.922-6.5-6.5-6.5Zm-21 2c2.496 0 4.5 2.004 4.5 4.5S16.996 32 14.5 32a4.486 4.486 0 0 1-4.5-4.5c0-2.496 2.004-4.5 4.5-4.5Zm21 0c2.496 0 4.5 2.004 4.5 4.5S37.996 32 35.5 32a4.486 4.486 0 0 1-4.5-4.5c0-2.496 2.004-4.5 4.5-4.5ZM25 35c.21 0 .387.121.469.313L26.187 37h-2.375l.72-1.687A.502.502 0 0 1 25 35Z"
        })
    });
var $24e6d56f54bae8bf$export$2e2bcd8739ae039 = $24e6d56f54bae8bf$var$SvgVirtualReality;



parcelRequire("7fPBF");
const $00343718cdb9cc97$var$SvgVisualStudio = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M35.5 2a2.5 2.5 0 0 0-1.668.639 4.685 4.685 0 0 0-.125.127l-.137.154-.504.559-1.763 1.97c-1.455 1.625-3.386 3.785-5.315 5.942l-7.068 7.906-5.13-4.166-3.23-2.623-.915-.746-.247-.201-.056-.045-.002-.002h-.002A2.011 2.011 0 0 0 8 11c-.389 0-.493.079-.691.15a9.876 9.876 0 0 0-.649.268c-.472.21-1.022.481-1.555.75-1.065.538-2.056 1.072-2.056 1.072l.006.012A2.007 2.007 0 0 0 2 15v21c0 .784.47 1.466 1.137 1.793l-.004.008s.918.468 1.885.955c.483.243.979.491 1.378.69.4.197.623.314.854.408.23.093.487.146.75.146.352 0 .692-.096.984-.262l.002.002.104-.068.023-.016c.01-.007.014-.013.02-.017l.033-.026.098-.08.345-.287a6851.457 6851.457 0 0 0 4.863-4.066l4.58-3.834A39683.096 39683.096 0 0 0 32.435 45.86l.97 1.05.266.286.078.08c.02.022-.043-.029.088.088l.002.002c.44.393 1.03.633 1.662.633.37 0 .721-.088 1.04-.236l.003.007s2.405-1.244 4.846-2.51c1.22-.632 2.45-1.27 3.392-1.761.472-.245.872-.455 1.164-.607.292-.153.41-.211.543-.288A3.006 3.006 0 0 0 48 40V10a3.003 3.003 0 0 0-1.322-2.486c-.136-.092-.15-.091-.244-.143a194.527 194.527 0 0 0-1.549-.82A1057.4 1057.4 0 0 0 41.46 4.77C39 3.495 36.586 2.249 36.584 2.248h-.002A2.506 2.506 0 0 0 35.5 2zm0 2c.11 0 .198.03.28.084A.49.49 0 0 1 36 4.5v10.033l-11.291 9.465-1.182-.959-3.052-2.478A16164.07 16164.07 0 0 1 32.793 6.78l1.764-1.967c.214-.238.381-.427.498-.556l.12-.135A.482.482 0 0 1 35.5 4zM38 5.232c.922.477 1.26.649 2.541 1.313 1.229.637 2.468 1.282 3.418 1.78a198.057 198.057 0 0 1 1.514.8c.082.045.18.11.084.045h.002v.002c.265.18.441.476.441.828v30c0 .38-.204.697-.506.87.06-.036-.187.1-.476.251l-1.159.604c-.941.49-2.172 1.129-3.392 1.761L38 44.764V5.232zM8.027 13.023l.036.03.068.056.25.204.916.746 3.23 2.625 9.74 7.908L36 35.738V45.5a.482.482 0 0 1-.252.43l-.07.037A.524.524 0 0 1 35.5 46a.48.48 0 0 1-.326-.123l-.043-.047-.262-.281-.967-1.045-3.402-3.688c-2.804-3.04-6.526-7.079-10.244-11.115-3.719-4.036-7.433-8.07-10.225-11.097-1.395-1.515-2.56-2.778-3.379-3.665l-.826-.892c.091-.047.087-.047.18-.094a36.69 36.69 0 0 1 1.469-.709c.21-.093.393-.168.515-.213.016-.005.022-.004.037-.008zM4 15.018l.23.248c.221.238.545.586.954 1.029L7 18.265v14.376l-2.996 3.353C4.002 35.997 4.002 36 4 36V15.018zm32 2.125v16.02l-9.709-7.882L36 17.143zM9 20.436l4.52 4.906L9 30.4v-9.964zm5.88 6.382c.987 1.07 1.794 1.949 2.815 3.057l-4.506 3.771c-1.325 1.11-2.651 2.219-3.65 3.053L8.33 37.71l-.342.283-.002.002c.032.012-.318-.151-.703-.342-.392-.194-.884-.439-1.365-.681l-.072-.037 9.035-10.116zM8.01 37.994l.46.824-.472-.816L8 38l.01-.006z"
        })
    });
var $00343718cdb9cc97$export$2e2bcd8739ae039 = $00343718cdb9cc97$var$SvgVisualStudio;



parcelRequire("7fPBF");
const $33b5e9a8ed1b53a5$var$SvgVoice = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 90 100",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "M80.088 44.766a1.784 1.784 0 0 1 2.347.927C90.33 63.915 78.85 78.52 72.238 83.512a1.784 1.784 0 0 1-2.15-2.849c5.995-4.524 16.021-17.515 9.073-33.55a1.784 1.784 0 0 1 .927-2.347Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M48.62 17.652a1.284 1.284 0 0 1 2.554.264c-.333 3.221.427 11.087 6.032 16.424 1.587 1.512 2.53 2.973 2.756 4.411.24 1.528-.367 2.774-1.3 3.684-.893.87-2.108 1.468-3.286 1.877-.687.238-1.397.424-2.084.564l-.381.077-.248 4.96a2.544 2.544 0 0 1-2.377 2.412l-9.392.606-.128.255a2.46 2.46 0 0 0-.125 1.972c.397 1.106 1.782 2.729 5.786 4.247l.094.036.088.05c.481.276.733.724.809 1.171a2.5 2.5 0 0 1-.044.933c-.052.24-.13.5-.2.733l-.032.105v.003c-.065.213-.13.428-.195.666-.292 1.073-.544 2.5-.087 4.33.423 1.69.314 3.834-.405 5.683-.726 1.866-2.164 3.625-4.514 4.095-1.065.213-3.077.27-5.504.111a52.624 52.624 0 0 1-8.56-1.28c-6.095-1.445-12.876-4.314-16.19-9.772a1.284 1.284 0 0 1 2.195-1.333c2.752 4.532 8.64 7.195 14.588 8.605a50.067 50.067 0 0 0 8.134 1.217c2.38.155 4.114.077 4.833-.067 1.215-.243 2.099-1.156 2.624-2.507.53-1.362.599-2.965.308-4.13-.602-2.406-.259-4.31.1-5.627.048-.177.097-.345.143-.5l.127-.424-.406-.177c-3.517-1.532-5.411-3.356-6.11-5.3-.79-2.198.092-4.132 1.098-5.215l.348-.375 10.43-.673.354-7.077 1.078-.127c.936-.11 2.013-.33 3.003-.674 1.008-.35 1.824-.792 2.335-1.29.223-.217.391-.443.487-.697.099-.261.106-.511.068-.75-.098-.628-.58-1.605-1.99-2.948-6.385-6.082-7.195-14.869-6.815-18.548Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "M57.636 52.088a1.784 1.784 0 0 1 2.489.415c2.51 3.514 2.493 6.846 1.234 9.53-1.19 2.534-3.397 4.314-5.048 5.209a1.784 1.784 0 0 1-1.7-3.138c1.204-.652 2.745-1.942 3.517-3.588.703-1.497.865-3.459-.907-5.94a1.784 1.784 0 0 1 .415-2.488ZM69.444 47.952a1.784 1.784 0 0 1 2.31 1.014c4.98 12.762-2.88 22.648-7.378 25.99a1.784 1.784 0 0 1-2.128-2.865c3.828-2.844 10.337-11.18 6.182-21.828a1.784 1.784 0 0 1 1.014-2.31Z",
                clipRule: "evenodd"
            })
        ]
    });
var $33b5e9a8ed1b53a5$export$2e2bcd8739ae039 = $33b5e9a8ed1b53a5$var$SvgVoice;



parcelRequire("7fPBF");
const $acd55902513cc2be$var$SvgVoiceControl = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "M80.088 44.766a1.784 1.784 0 0 1 2.347.927C90.33 63.915 78.85 78.52 72.238 83.512a1.784 1.784 0 0 1-2.15-2.849c5.995-4.524 16.021-17.515 9.073-33.55a1.784 1.784 0 0 1 .927-2.347Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M48.62 17.652a1.284 1.284 0 0 1 2.554.264c-.333 3.221.427 11.087 6.032 16.424 1.587 1.512 2.53 2.973 2.756 4.411.24 1.528-.367 2.774-1.3 3.684-.893.87-2.108 1.468-3.286 1.877-.687.238-1.397.424-2.084.564l-.381.077-.248 4.96a2.544 2.544 0 0 1-2.377 2.412l-9.392.606-.128.255a2.46 2.46 0 0 0-.125 1.972c.397 1.106 1.782 2.729 5.786 4.247l.094.036.088.05c.481.276.733.724.809 1.171a2.5 2.5 0 0 1-.044.933c-.052.24-.13.5-.2.733l-.032.105v.003c-.065.213-.13.428-.195.666-.292 1.073-.544 2.5-.087 4.33.423 1.69.314 3.834-.405 5.683-.726 1.866-2.164 3.625-4.514 4.095-1.065.213-3.077.27-5.504.111a52.624 52.624 0 0 1-8.56-1.28c-6.095-1.445-12.876-4.314-16.19-9.772a1.284 1.284 0 0 1 2.195-1.333c2.752 4.532 8.64 7.195 14.588 8.605a50.067 50.067 0 0 0 8.134 1.217c2.38.155 4.114.077 4.833-.067 1.215-.243 2.099-1.156 2.624-2.507.53-1.362.599-2.965.308-4.13-.602-2.406-.259-4.31.1-5.627.048-.177.097-.345.143-.5l.127-.424-.406-.177c-3.517-1.532-5.411-3.356-6.11-5.3-.79-2.198.092-4.132 1.098-5.215l.348-.375 10.43-.673.354-7.077 1.078-.127c.936-.11 2.013-.33 3.003-.674 1.008-.35 1.824-.792 2.335-1.29.223-.217.391-.443.487-.697.099-.261.106-.511.068-.75-.098-.628-.58-1.605-1.99-2.948-6.385-6.082-7.195-14.869-6.815-18.548Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "M57.636 52.088a1.784 1.784 0 0 1 2.489.415c2.51 3.514 2.493 6.846 1.234 9.53-1.19 2.534-3.397 4.314-5.048 5.209a1.784 1.784 0 0 1-1.7-3.138c1.204-.652 2.745-1.942 3.517-3.588.703-1.497.865-3.459-.907-5.94a1.784 1.784 0 0 1 .415-2.488ZM69.444 47.952a1.784 1.784 0 0 1 2.31 1.014c4.98 12.762-2.88 22.648-7.378 25.99a1.784 1.784 0 0 1-2.128-2.865c3.828-2.844 10.337-11.18 6.182-21.828a1.784 1.784 0 0 1 1.014-2.31Z",
                clipRule: "evenodd"
            })
        ]
    });
var $acd55902513cc2be$export$2e2bcd8739ae039 = $acd55902513cc2be$var$SvgVoiceControl;



parcelRequire("7fPBF");
const $34aed62813af1122$var$SvgVoiceMemos = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13 3C7.489 3 3 7.489 3 13v24c0 5.511 4.489 10 10 10h24c5.511 0 10-4.489 10-10V13c0-5.511-4.489-10-10-10H13zm0 2h24c4.43 0 8 3.57 8 8v24c0 4.43-3.57 8-8 8H13c-4.43 0-8-3.57-8-8V13c0-4.43 3.57-8 8-8zm15 2a2 2 0 0 0-1 3.73v28.54A2 2 0 0 0 28 43a2 2 0 0 0 1-3.73V10.73A2 2 0 0 0 28 7zm-9.016 3.986A1 1 0 0 0 18 12v26a1 1 0 1 0 2 0V12a1 1 0 0 0-1.016-1.014zm3 3A1 1 0 0 0 21 15v20a1 1 0 1 0 2 0V15a1 1 0 0 0-1.016-1.014zm-6 1A1 1 0 0 0 15 16v18a1 1 0 1 0 2 0V16a1 1 0 0 0-1.016-1.014zm9 3A1 1 0 0 0 24 19v12a1 1 0 1 0 2 0V19a1 1 0 0 0-1.016-1.014zm-12 1A1 1 0 0 0 12 20v10a1 1 0 1 0 2 0V20a1 1 0 0 0-1.016-1.014zm18 0A1 1 0 0 0 30 20v10a1 1 0 1 0 2 0V20a1 1 0 0 0-1.016-1.014zm-21 3A1 1 0 0 0 9 23v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1.016-1.014zm24 0A1 1 0 0 0 33 23v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1.016-1.014zm6 1A1 1 0 0 0 39 24v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1.016-1.014zm-33 .5A1 1 0 0 0 6 24.5v1a1 1 0 1 0 2 0v-1a1 1 0 0 0-1.016-1.014zm30 0A1 1 0 0 0 36 24.5v1a1 1 0 1 0 2 0v-1a1 1 0 0 0-1.016-1.014zm6 0A1 1 0 0 0 42 24.5v1a1 1 0 1 0 2 0v-1a1 1 0 0 0-1.016-1.014z"
        })
    });
var $34aed62813af1122$export$2e2bcd8739ae039 = $34aed62813af1122$var$SvgVoiceMemos;



parcelRequire("7fPBF");
const $c3ac36ea1b4137a8$var$SvgWaze = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14 3.99c-5.511 0-10 4.489-10 10v22c0 5.512 4.489 10 10 10h22c5.511 0 10-4.488 10-10v-22c0-5.511-4.489-10-10-10H14zm0 2h22c4.43 0 8 3.57 8 8v22c0 4.43-3.57 8-8 8H14c-4.43 0-8-3.57-8-8v-22c0-4.43 3.57-8 8-8zM25.969 13c-6.093 0-11.033 5.073-11.032 11.277 0 .734-.025 1.746-.255 2.436-.115.345-.267.587-.432.73-.165.143-.348.239-.76.239a1 1 0 0 0-.922 1.386c1.047 2.486 2.73 4.177 4.946 5.166A3 3 0 0 0 20.5 37a3 3 0 0 0 2.617-1.541 1 1 0 0 0 .084.008c.872.061 1.797.086 2.768.086.156 0 .31-.011.465-.018A2.99 2.99 0 0 0 29 37c1.656 0 3-1.344 3-3 0-.097-.014-.19-.023-.285A11.318 11.318 0 0 0 37 24.277C37 18.073 32.061 13 25.969 13zm0 2C30.954 15 35 19.128 35 24.277c0 3.401-1.772 6.355-4.406 7.971a1 1 0 0 0-.002 0c-.463.284-.96.513-1.47.709l-.876.283c-.524.14-1.06.247-1.617.287a1 1 0 0 0-.01 0 7.822 7.822 0 0 1-.65.026c-.9 0-1.737-.025-2.52-.076A3 3 0 0 0 20.5 31a3 3 0 0 0-2.447 1.271c-1.336-.681-2.292-1.704-3.073-3.113.177-.096.432-.076.579-.203.523-.453.83-1.037 1.021-1.61.382-1.145.358-2.334.358-3.068-.001-5.149 4.045-9.277 9.03-9.277zm-2.043 5a1.223 1.223 0 1 0 0 2.445 1.223 1.223 0 1 0 0-2.445zm6.851 0a1.223 1.223 0 1 0 0 2.445 1.223 1.223 0 1 0 0-2.445zm-7.05 5.22a1 1 0 0 0-.875 1.42s1.347 2.796 4.584 2.796c3.236 0 4.584-2.795 4.584-2.795a1 1 0 0 0-1.829-.813s-.61 1.608-2.755 1.608c-2.146 0-2.756-1.608-2.756-1.608a1 1 0 0 0-.953-.607z"
        })
    });
var $c3ac36ea1b4137a8$export$2e2bcd8739ae039 = $c3ac36ea1b4137a8$var$SvgWaze;



parcelRequire("7fPBF");
const $0a85044c5feaf17c$var$SvgWeather = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14 4C8.489 4 4 8.489 4 14v22c0 5.511 4.489 10 10 10h22c5.511 0 10-4.489 10-10V14c0-5.511-4.489-10-10-10H14zm0 2h22c4.43 0 8 3.57 8 8v22c0 4.43-3.57 8-8 8H14c-4.43 0-8-3.57-8-8V14c0-4.43 3.57-8 8-8zm18 7c-3.168 0-5.906 1.858-7.2 4.543A7.696 7.696 0 0 0 22 17c-3.877 0-7.036 2.81-7.76 6.484-2.458.928-4.24 3.242-4.24 6.016 0 3.218 2.384 5.838 5.467 6.346A1 1 0 0 0 16 36h13c3.854 0 7-3.146 7-7 0-.35-.035-.691-.086-1.027A8.003 8.003 0 0 0 40 21c0-4.406-3.594-8-8-8zm0 2c3.326 0 6 2.674 6 6a5.978 5.978 0 0 1-2.697 4.998 7.032 7.032 0 0 0-5.951-3.928 8.19 8.19 0 0 0-2.793-3.586A5.99 5.99 0 0 1 32 15zm-10 4a5.99 5.99 0 0 1 5.75 4.299 1 1 0 0 0 1.012.715c.132-.007.208-.014.238-.014 2.774 0 5 2.226 5 5s-2.226 5-5 5H16.887l.103.855a1 1 0 0 0-.902-.876A4.488 4.488 0 0 1 12 29.5a4.49 4.49 0 0 1 3.313-4.336 1 1 0 0 0 .73-.852A5.987 5.987 0 0 1 22 19z"
        })
    });
var $0a85044c5feaf17c$export$2e2bcd8739ae039 = $0a85044c5feaf17c$var$SvgWeather;



parcelRequire("7fPBF");
const $b62ebb210c573784$var$SvgWechat = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M19 6C9.746 6 2 12.36 2 20.5c0 4.395 2.293 8.18 5.836 10.824l-2.656 7.98 8.293-5.136c1.714.539 3.609.832 5.527.832.746 0 1.473-.055 2.195-.137C23.38 39.105 28.328 42 34 42c1.723 0 3.316-.324 4.797-.766l6.848 3.832-1.91-6.55C46.312 36.375 48 33.395 48 30c0-6.21-5.402-11.164-12.25-11.895C34.398 11.125 27.324 6 19 6Zm0 2c7.309 0 13.328 4.352 14.703 10.012C26.183 18.148 20 23.355 20 30c0 1.02.16 2.004.438 2.941-.473.04-.954.059-1.438.059-1.898 0-3.8-.29-5.367-.844l-.45-.156-4.363 2.7 1.367-4.106-.624-.422C6.082 27.82 4 24.445 4 20.5 4 13.64 10.656 8 19 8Zm-6 6c-1.102 0-2 .898-2 2 0 1.102.898 2 2 2 1.102 0 2-.898 2-2 0-1.102-.898-2-2-2Zm12 0c-1.102 0-2 .898-2 2 0 1.102.898 2 2 2 1.102 0 2-.898 2-2 0-1.102-.898-2-2-2Zm9 6c6.746 0 12 4.535 12 10 0 2.957-1.508 5.55-3.996 7.395l-.559.417.91 3.122-3.25-1.825-.421.141c-1.399.469-2.996.75-4.684.75-6.746 0-12-4.535-12-10s5.254-10 12-10Zm-4.5 6c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.7-1.5-1.5-1.5Zm9 0c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.7-1.5-1.5-1.5Z"
        })
    });
var $b62ebb210c573784$export$2e2bcd8739ae039 = $b62ebb210c573784$var$SvgWechat;



parcelRequire("7fPBF");
const $af66a6393cd41f93$var$SvgWellsfargo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13 4c-4.962 0-9 4.037-9 9v24c0 4.963 4.038 9 9 9h24c4.962 0 9-4.037 9-9V13c0-4.963-4.038-9-9-9H13zm0 2h24c3.86 0 7 3.141 7 7v24c0 3.859-3.14 7-7 7H13c-3.86 0-7-3.141-7-7V13c0-3.859 3.14-7 7-7zm25.002 10.84c-1.509 0-2.48.724-2.48 1.889 0 .9.565 1.56 1.65 1.798l1.121.248c.715.16.978.44.978.909 0 .574-.431.89-1.296.89-.98 0-1.483-.388-1.704-1.129l-.115-.379h-.635v1.73a5.497 5.497 0 0 0 2.604.573c1.482 0 2.453-.74 2.453-1.896 0-.972-.592-1.643-1.703-1.899l-1.121-.256c-.653-.15-.926-.406-.926-.838 0-.52.416-.845 1.227-.845.81 0 1.286.29 1.472.978l.08.3h.635v-1.526a4.93 4.93 0 0 0-2.24-.547zm-28.842.176v.767h.707l1.553 5.41h1.226l1.288-4.482 1.254 4.482h1.224l1.545-5.41h1.217v4.643h-.75v.767h5.303v-2.109h-.635l-.072.31c-.177.786-.432 1.032-1.006 1.032h-1.526v-1.914h1.774a.926.926 0 0 0 .097-.442.877.877 0 0 0-.097-.424h-1.774v-1.863h1.465c.591 0 .794.257.988.998l.063.239h.635v-2.004h-7.483v.767h.865l-1.013 3.733-1.264-4.5h-1.27l-1.234 4.492-1.033-3.725h.83v-.767H9.16zm15.21 0v.767h.75v4.64h-.75v.768h5.003v-2.109h-.635l-.07.31c-.177.786-.426 1.032-1.008 1.032h-1.224v-4.64h.837v-.768H24.37zm5.558 0v.767h.75v4.64h-.75v.768h5.004v-2.109h-.635l-.072.31c-.176.786-.424 1.032-1.006 1.032h-1.227v-4.64h.838v-.768h-2.902zm.638 9.466c-1.94 0-3.246 1.299-3.246 3.284 0 1.994 1.27 3.263 3.246 3.263a5.553 5.553 0 0 0 2.471-.652v-2.754H30.69a.828.828 0 0 0-.095.414c-.006.15.026.3.095.434h1.051v1.56c-.33.136-.684.205-1.04.203-1.27 0-1.932-.908-1.932-2.478 0-1.57.66-2.479 1.86-2.479a1.532 1.532 0 0 1 1.546 1.084l.096.248h.634v-1.58a5.159 5.159 0 0 0-2.338-.547zm6.567.002a3.28 3.28 0 0 0-3.281 3.272 3.28 3.28 0 0 0 6.562 0 3.28 3.28 0 0 0-3.281-3.272zm-27.178.192v.767h.75v4.643h-.75v.768h2.947v-.768h-.882v-1.8h1.818a.926.926 0 0 0 .098-.442.88.88 0 0 0-.098-.424H12.02v-1.977h1.57c.59 0 .794.257.988.998l.063.239h.634v-2.004h-5.32zm7.227.002-2.162 5.408h-.62v.768h2.338v-.768h-.74l.406-1.104h2.293l.407 1.104h-.723v.768h5.549v-.768h-.838v-1.879h.484c.971 0 1.263.343 1.37 1.234l.034.311c.097.82.512 1.172 1.368 1.172.23 0 .46-.013.687-.043a.865.865 0 0 0 0-.725 1.042 1.042 0 0 1-.185.018c-.406 0-.512-.23-.565-.742l-.035-.327c-.08-.697-.406-1.147-1.209-1.209v-.025c.794-.036 1.615-.565 1.615-1.562 0-1.006-.82-1.631-2.082-1.631h-3.547v.767h.75v4.64h-1.216l-2.207-5.407h-1.172zm19.95.607c1.192 0 1.837.909 1.837 2.47 0 1.57-.636 2.472-1.836 2.472-1.2 0-1.834-.901-1.834-2.471 0-1.561.643-2.47 1.834-2.47zm-14.04.158h1.04c.795 0 1.192.345 1.192.989 0 .636-.406.998-1.191.998h-1.041v-1.987zm-5.541.452.865 2.337h-1.73l.865-2.337z"
        })
    });
var $af66a6393cd41f93$export$2e2bcd8739ae039 = $af66a6393cd41f93$var$SvgWellsfargo;



parcelRequire("7fPBF");
const $b418400b3516f49e$var$SvgWhatsapp = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2C12.31 2 2 12.31 2 25c0 4.08 1.119 7.886 2.984 11.209L2.037 46.73a1 1 0 0 0 1.203 1.24l10.97-2.718C17.436 46.972 21.094 48 25 48c12.69 0 23-10.31 23-23S37.69 2 25 2zm0 2c11.61 0 21 9.39 21 21s-9.39 21-21 21c-3.722 0-7.208-.97-10.238-2.666a1 1 0 0 0-.729-.098l-9.607 2.381 2.576-9.191a1 1 0 0 0-.1-.78A20.88 20.88 0 0 1 4 25C4 13.39 13.39 4 25 4zm-8.357 9c-.641 0-1.557.238-2.309 1.049-.452.487-2.334 2.32-2.334 5.545 0 3.361 2.331 6.262 2.613 6.635h.002v.001a31.669 31.669 0 0 0 3.004 3.684c1.804 1.899 4.34 4.093 7.486 5.436 1.45.617 2.593.99 3.46 1.261 1.605.504 3.067.428 4.165.266.823-.121 1.727-.516 2.622-1.082.894-.566 1.771-1.27 2.158-2.34a8.25 8.25 0 0 0 .469-2.059 4.72 4.72 0 0 0 .01-.787c-.02-.238 0-.42-.221-.785-.466-.764-.993-.784-1.543-1.056a183.29 183.29 0 0 0-2.05-.993c-.871-.415-1.626-.783-2.091-.949-.294-.106-.652-.258-1.17-.199-.517.059-1.029.432-1.326.873-.282.418-1.418 1.758-1.764 2.152-.004-.002.026.011-.111-.056-.428-.212-.952-.392-1.727-.801a14.283 14.283 0 0 1-2.804-1.947v-.002c-1.579-1.39-2.685-3.135-3.034-3.721.024-.028-.002.006.047-.043l.002-.002c.357-.351.673-.77.94-1.078.378-.436.545-.82.726-1.18.361-.716.16-1.503-.049-1.918v-.002c.015.029-.112-.252-.25-.576l-.5-1.195c-.374-.898-.792-1.906-1.04-2.496v-.002c-.293-.695-.69-1.196-1.208-1.438-.518-.241-.975-.173-.994-.174h-.002A26.2 26.2 0 0 0 16.643 13zm0 2c.385 0 .765.005 1.084.02.327.016.307.017.244-.012-.064-.03.023-.04.209.402.243.578.663 1.59 1.039 2.49.188.451.363.874.504 1.205.14.332.216.517.304.694v.002l.002.002c.087.17.08.061.05.12-.212.42-.24.522-.454.768-.325.375-.657.792-.832.965-.154.151-.43.386-.604.846-.173.46-.092 1.093.186 1.564.37.629 1.59 2.613 3.484 4.282a16.35 16.35 0 0 0 3.194 2.216c.888.469 1.611.743 1.773.823.385.19.805.338 1.293.279.489-.059.91-.355 1.178-.658l.002-.002c.357-.405 1.417-1.615 1.926-2.361.021.007.014.001.183.062v.002h.002c.077.027 1.044.46 1.906.871.863.41 1.738.838 2.022.979.41.203.604.335.654.336a2.35 2.35 0 0 1-.006.328 6.365 6.365 0 0 1-.357 1.552c-.105.292-.654.893-1.346 1.33-.692.438-1.534.748-1.846.793-.937.139-2.05.189-3.273-.195a33.421 33.421 0 0 1-3.273-1.193c-2.776-1.184-5.135-3.198-6.82-4.973a29.716 29.716 0 0 1-1.999-2.338c-.48-.623-.688-.948-.863-1.178l-.002-.001c-.31-.41-2.207-3.05-2.207-5.426 0-2.516 1.168-3.503 1.8-4.184.333-.358.696-.41.843-.41z"
        })
    });
var $b418400b3516f49e$export$2e2bcd8739ae039 = $b418400b3516f49e$var$SvgWhatsapp;



parcelRequire("7fPBF");
const $d752c8bed9966dc3$var$SvgWindows11 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M4 4v20h20V4H4zm22 0v20h20V4H26zM6 6h16v16H6V6zm22 0h16v16H28V6zM4 26v20h20V26H4zm22 0v20h20V26H26zM6 28h16v16H6V28zm22 0h16v16H28V28z"
        })
    });
var $d752c8bed9966dc3$export$2e2bcd8739ae039 = $d752c8bed9966dc3$var$SvgWindows11;



const $cbdf5641ddee00a3$var$SvgWindowsXp = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M37.172 6.137c-1.732.02-3.342.194-4.805.465-5.85 1.082-9.539 3.726-9.539 3.726a2 2 0 0 0-.773 1.164l-6.477 27.543a2 2 0 0 0 2.426 2.399c6.85-1.698 17.135-2.465 27.773 3.48a2.002 2.002 0 0 0 2.914-1.25l7.594-29.77a2 2 0 0 0-.863-2.18c-6.756-4.307-13.054-5.637-18.25-5.577m.047 3.98a25 25 0 0 1 4.785.39c3.033.54 6.421 1.836 10.016 3.934l-6.633 26c-9.445-4.52-18.412-4.651-25.223-3.433l5.586-23.762c.681-.45 3.016-1.914 7.344-2.715a25 25 0 0 1 4.125-.414m24.062 6.274a2 2 0 0 0-1.89 1.504L51.844 47.48a2 2 0 0 0 .77 2.117c13.308 9.562 26.952 6.189 32.628 4.023a2 2 0 0 0 1.235-1.41l7.468-31.754a2 2 0 0 0-3.12-2.074s-2.933 2.143-8.016 3.074c-5.084.93-12.132.626-20.387-4.742a2 2 0 0 0-1.14-.324m1.364 4.937c8.118 4.51 15.502 5.048 20.882 4.063 2.344-.43 4.017-1.151 5.579-1.817l-6.258 26.594c-5.207 1.833-15.816 3.925-26.739-3.234zM27.434 44.242c-5.486.038-10.037 1.365-12.743 2.399a2 2 0 0 0-1.234 1.41L6.055 79.543A2 2 0 0 0 6 80v.09a2 2 0 0 0 3.172 1.62s2.755-2.005 7.574-2.968 11.514-.849 19.387 3.793a2 2 0 0 0 2.957-1.23l7.535-29.543a2 2 0 0 0-.855-2.18c-6.431-4.126-12.851-5.377-18.336-5.34m-.075 3.985c4.482-.044 9.698 1.11 14.98 4.156L35.81 77.98c-7.759-3.87-14.76-4.177-19.848-3.16-2.14.427-3.637 1.092-5.09 1.71l6.219-26.445c2.432-.855 5.925-1.817 10.27-1.86m24.239 5.937a2 2 0 0 0-1.84 1.504L42.21 85.234a2 2 0 0 0 .793 2.133c9.362 6.54 17.96 7.264 24.117 6.23s10.05-3.84 10.05-3.84A2 2 0 0 0 78 88.232v-.004l6.356-27a2 2 0 0 0-2.43-2.399 40.7 40.7 0 0 1-9.77 1.215c-5.849 0-12.57-1.363-19.414-5.582a2 2 0 0 0-1.144-.297m1.46 4.746c6.692 3.551 13.321 5.133 19.098 5.133 2.895 0 5.251-.507 7.649-.95l-5.59 23.77c-.724.479-3.201 2.025-7.754 2.79-5.04.846-11.964.304-19.996-4.9z"
        })
    });
var $cbdf5641ddee00a3$export$2e2bcd8739ae039 = $cbdf5641ddee00a3$var$SvgWindowsXp;



parcelRequire("7fPBF");
const $e1fdb89e8a7f1773$var$SvgXfinity = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.373 16.637c-1.566 0-2.5 1.025-2.5 2.734l-.002.879h-.965l-1.117 1.6h2.084v7.8h2.045v-7.8h2.086v-1.6h-2.086v-.91c0-.688.286-.967.98-.967.4 0 .813.078 1.106.158v-1.646c-.42-.15-1.001-.248-1.631-.248zm24.15.42-2.039 1.039v2.156h-1.488v1.598h1.488v5.254c0 1.715.933 2.73 2.495 2.73.518 0 1.033-.063 1.423-.184l.248-1.63a4.229 4.229 0 0 1-.923.132c-.851 0-1.202-.34-1.202-1.187V21.85h2.35l-.611-1.598h-1.74v-3.195zm-12.546 3.006c-.962 0-1.88.405-2.356 1.037v-.85h-2.045v9.4h2.045v-5.486c0-1.524.659-2.365 1.858-2.365 1.3 0 1.857.76 1.857 2.543v5.308h2.039v-5.38c.001-2.754-1.17-4.207-3.398-4.207zM.225 20.25l3.193 4.537L0 29.65h2.346l2.2-3.218 4.57 6.533h2.251L5.67 24.787l3.195-4.537H6.521l-1.974 2.893L2.57 20.25H.225zm16.123 0v9.4h2.045v-9.4h-2.045zm14.119 0v9.4h2.053v-9.4h-2.053zm9.683 0 3.15 8.195-2.437 4.52h2.158L50 20.25h-2.207l-3.28 5.99-2.243-5.99h-2.12z"
        })
    });
var $e1fdb89e8a7f1773$export$2e2bcd8739ae039 = $e1fdb89e8a7f1773$var$SvgXfinity;



parcelRequire("7fPBF");
const $9d8b2252c9d0cc9d$var$SvgYelp = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M21.61 2C18.933 2 12.8 3.813 11.5 5.156c-.48.457-.602 1.145-.48 1.602.238.457 9.968 15.222 9.968 15.222 1.059 1.68 1.746 1.989 2.18 1.989.156 0 .277-.04.375-.067.36-.117 1.562-.547 1.32-3.293-.117-3.093-1.078-16.71-1.199-17.398-.238-.57-.602-1.031-1.32-1.148A3.573 3.573 0 0 0 21.609 2Zm0 2h.124c.227 2.582 1.02 13.84 1.13 16.688l.007.093c.016.172.02.324.024.461a8.547 8.547 0 0 1-.239-.363c-3.293-4.996-8.086-12.293-9.504-14.492C14.445 5.547 19.27 4 21.61 4Zm15.128 11.996c-.316 0-.613.086-.879.274-.75.738-.484.214-4.8 5.933l-2.043 2.629c-.48.574-.368 1.527.113 2.215.398.57.918.918 1.605.918.141 0 .286-.012.442-.043.36-.113 1.082-.23 2.402-.574 8.277-1.828 8.352-1.813 8.715-2.04.477-.343.719-.804.719-1.492v-.113c-.239-1.828-3.793-6.746-5.473-7.547-.27-.101-.539-.16-.8-.16Zm.121 2.078c1.137.809 3.578 4.168 4.086 5.586-.629.156-1.945.445-4.168.934l-3.632.8-.036.012-.035.008c-.699.18-1.219.293-1.605.379-.262.059-.477.105-.668.156a.184.184 0 0 0-.035-.047c-.008-.011-.012-.023-.02-.039l1.906-2.457c3.336-4.41 3.852-4.992 4.207-5.332ZM9.402 23.97c-.48 0-1.082.23-1.441.8-.84 1.149-1.102 4.801-.86 7.32.118.802.239 1.454.477 1.911.36.574.84.918 1.442.918.359 0 .09-.105 7.293-2.164l3.246-1.031c.84-.23 1.425-.801 1.425-1.72 0-.913-.445-1.671-1.285-2.015l-2.281-.914C9.609 23.98 9.762 23.97 9.402 23.97Zm.11 2.11c.36.136.937.37 1.71.679 1.15.46 2.864 1.144 5.45 2.168l2.25.902-3.188 1.012c-3.96 1.133-5.664 1.672-6.476 1.941-.074-.304-.14-.718-.172-.937-.219-2.387.098-5 .426-5.766Zm21.383 5.937c-.543 0-1.051.172-1.442.593-.39.426-.683 1.621-.203 2.309l1.32 1.945c4.325 6.64 4.348 6.98 4.707 7.211.282.266.602.38.942.38.242 0 .492-.06.738-.153 1.926-.688 5.684-5.239 5.922-7.067.121-.574-.117-1.148-.598-1.718-.242-.23-.742-.313-7.468-2.403l-3.079-.976a3.185 3.185 0 0 0-.84-.121Zm-8.13 2c-.527 0-1.015.156-1.316.59l-1.562 1.828c-5.407 6.066-5.645 6.41-5.766 6.754-.121.23-.121.457-.121.687.121.34.242.57.484.914C15.707 46.062 20.813 48 23.082 48c.176 0 .336-.012.477-.035.601-.117 1.082-.461 1.32-1.031.121-.344.121-.57.121-7.782v-3.324c0-1-.441-1.332-1.281-1.676a3.649 3.649 0 0 0-.953-.136Zm8.301.015c.032.008.07.016.11.028l3.043.964c2.113.657 3.613 1.118 4.683 1.446.883.27 1.567.476 1.97.61-.372 1.288-3.134 4.57-4.43 5.265-.118-.184-.274-.434-.454-.719-.593-.95-1.703-2.723-3.761-5.887Zm-8.199 1.989c.035.003.082.007.133.015v3.117c0 4 0 6.016-.02 6.848-1.777-.059-5.527-1.52-6.761-2.36.707-.859 2.543-2.94 5.187-5.91Z"
        })
    });
var $9d8b2252c9d0cc9d$export$2e2bcd8739ae039 = $9d8b2252c9d0cc9d$var$SvgYelp;



parcelRequire("7fPBF");
const $3c010517a0bd62c4$var$SvgYoutube = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M24.402 9c-6.601 0-12.8.5-16.101 1.2-2.2.5-4.102 2-4.5 4.3C3.402 16.898 3 20.5 3 25s.398 8 .898 10.5c.403 2.2 2.301 3.8 4.5 4.3 3.504.7 9.5 1.2 16.102 1.2s12.598-.5 16.098-1.2c2.203-.5 4.101-2 4.5-4.3.402-2.5.902-6.098 1-10.598 0-4.5-.5-8.101-1-10.601-.399-2.2-2.297-3.801-4.5-4.301-3.5-.5-9.598-1-16.196-1Zm0 2c7.2 0 12.996.598 15.797 1.098 1.5.402 2.7 1.402 2.899 2.703.601 3.199 1 6.601 1 10.101C44 29.2 43.5 32.7 43.098 35.2c-.297 1.899-2.297 2.5-2.899 2.703-3.601.7-9.601 1.196-15.601 1.196S12.5 38.699 9 37.902C7.5 37.5 6.3 36.5 6.102 35.2 5.3 32.4 5 28.7 5 25c0-4.602.402-8 .8-10.098C6.103 13 8.2 12.398 8.7 12.2 12 11.5 18.101 11 24.401 11ZM19 17v16l14-8Zm2 3.402L29 25l-8 4.598Z"
        })
    });
var $3c010517a0bd62c4$export$2e2bcd8739ae039 = $3c010517a0bd62c4$var$SvgYoutube;



parcelRequire("7fPBF");
const $a567b0078c16856f$var$SvgZoom = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M16.38 4C9.556 4 4 9.555 4 16.38v17.24C4 40.444 9.555 46 16.38 46h17.24C40.444 46 46 40.445 46 33.62V16.38C46 9.556 40.445 4 33.62 4H16.38zm0 2h17.24C39.364 6 44 10.635 44 16.38v17.24C44 39.364 39.365 44 33.62 44H16.38A10.365 10.365 0 0 1 6 33.62V16.38C6 10.636 10.635 6 16.38 6zm20.823 10.629a1.648 1.648 0 0 0-.896.252l-5.633 3.52C29.994 18.44 28.178 17 25.994 17H13a1 1 0 0 0-1 1v9.994C12 30.747 14.253 33 17.006 33H30a1 1 0 0 0 1-1v-3.197l5.307 3.316c1.128.705 2.693-.162 2.693-1.492V18.373c0-.998-.88-1.735-1.797-1.744zM37 18.805v11.39l-6-3.75v-3.89l6-3.75zM14 19h11.994A2.991 2.991 0 0 1 29 22.006V31H17.006A2.991 2.991 0 0 1 14 27.994V19z"
        })
    });
var $a567b0078c16856f$export$2e2bcd8739ae039 = $a567b0078c16856f$var$SvgZoom;




const $3adbcb77e640770e$export$6d49a893c897b0cc = {
    handTap: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1ba208388ac239df$export$7caf2e6d06b0e274), {}),
    cursorClick: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $499cedc40c55e7cb$export$e9e98f64fb597ccd), {}),
    cursorText: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $991a051c44f6b41d$export$d665abe9390574dd), {}),
    appWindow: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dfac1a9d177543ce$export$73674ec7e4bd2217), {}),
    translate: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e0cac562beb02fd2$export$d1fe1d52e2885c4e), {}),
    robot: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b6b769c496a9d5ca$export$5db83f67d50796e6), {}),
    openAiLogo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $58461f01577d65e9$export$526f06eba48e24ab), {}),
    addRow: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ae7f63f5859902d$export$64702cae849e08a7), {}),
    ai: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b2c91a69e5d67ec9$export$ae8a512ee3f09294), {}),
    airbnb: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $00b3ccebbd02c720$export$2e2bcd8739ae039), {}),
    alert: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $59680ec94e4e297e$export$d7b686e8afc4bc7e), {}),
    amazon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c8355b7723d13ecc$export$2e2bcd8739ae039), {}),
    amazonMusic: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5433efa7792edf57$export$2e2bcd8739ae039), {}),
    presentationChart: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbd40d632367bb70$export$efe9d8422aa89449), {}),
    androidOs: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a3a92e462d72dd79$export$2e2bcd8739ae039), {}),
    androidTablet: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $319817bcb0975b64$export$2e2bcd8739ae039), {}),
    appStore: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d7ddc2c7594bdb77$export$2e2bcd8739ae039), {}),
    appleFitness: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7562bb96cc645793$export$2e2bcd8739ae039), {}),
    appleLogo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $960c6f50f044d54a$export$2e2bcd8739ae039), {}),
    appleNews: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c05f531d54f5030b$export$2e2bcd8739ae039), {}),
    applePay: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $596bbe84e95bafd3$export$2e2bcd8739ae039), {}),
    appleTv: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3079e7169fff8540$export$2e2bcd8739ae039), {}),
    appleWatch: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9d1f4a65eeeeac6d$export$2e2bcd8739ae039), {}),
    atlassianConfluence: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63c6023a46e87011$export$2e2bcd8739ae039), {}),
    audible: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d3c505b5d5c9a2b9$export$2e2bcd8739ae039), {}),
    automation: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8dd1c6f3efdeb55a$export$70208e77f6c45b17), {}),
    award: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a04767458aa408f3$export$f8328d6431f0c3df), {}),
    back: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2fa01b25bab55864$export$810196a5854768f3), {}),
    bing: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18f555e019f9ab0b$export$2e2bcd8739ae039), {}),
    bluetooth2: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0589edc71e767746$export$263c50ea203500d6), {}),
    bug: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c308ce43177e2521$export$3724a79860e51b2a), {}),
    build: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d330376fb0bcf89$export$57e3e6ad9de04bb9), {}),
    calendar: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8abaaeeab67664a2$export$5fda1783bb83f57b), {}),
    callOfDutyBlackOps3: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4b6a21eb2740d1a0$export$2e2bcd8739ae039), {}),
    callOfDutyMobile: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65c1d56f8fc276a2$export$2e2bcd8739ae039), {}),
    camera: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77a13c24fe4b2b0f$export$e04ff9953a6cd98f), {}),
    cameraOff: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c7c6d28f1cedca54$export$f058a904087aeb21), {}),
    cameraSwitch: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $940356a37dfbb440$export$7b925291abba066b), {}),
    cancel: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7425fd815e1431db$export$852d83c83fe09d93), {}),
    cancel2: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $99a54942b2884ad1$export$a5090bbd7fc88fde), {}),
    chat: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ffea4d92108488a3$export$9a3f119425fb8c38), {}),
    check: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $07440da420a178a0$export$f6dd727656c97851), {}),
    chrome: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c435ded412ce4cee$export$2e2bcd8739ae039), {}),
    chromebook: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $46a011279831d90c$export$2e2bcd8739ae039), {}),
    circle: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8671267bc76a08e9$export$9c1c3f5a4a271817), {}),
    close: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $99a54942b2884ad1$export$a5090bbd7fc88fde), {}),
    clipboard: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $79c58fd630e9f542$export$5ea4e40e738fba70), {}),
    cnn: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1421cc100a791107$export$2e2bcd8739ae039), {}),
    code: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e673841d74d2fd8a$export$8ee6b256df317f28), {}),
    collapseArrow: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f193c00afed960f7$export$7d1b8b90f61377d1), {}),
    communicate: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $137fb85d062916e7$export$932ca73f3598151a), {}),
    connect: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $22492976e1d4d968$export$55653f8b5a32ba35), {}),
    connectionOffline: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f2584623c5b466be$export$40ca6aea9c29b1cf), {}),
    connectionStatusOn: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6e819780b9c1274e$export$303836f55ddf2d4b), {}),
    compress: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $26629d2c54ba0e90$export$2e28bad6de91f83d), {}),
    computerMouse: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $91081726855ec7c6$export$53ac786375585ec0), {}),
    contacts: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1cce39a8b578ff0a$export$2e2bcd8739ae039), {}),
    counterStrike: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4698ad62cc1274e$export$2e2bcd8739ae039), {}),
    createOrder: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $34d18705d2aaa06f$export$ca191b730434e9b4), {}),
    crown: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $78e34b15ecf2a54e$export$338dfc3083a3d7f0), {}),
    dataSecure: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b8a6231e5abb5624$export$da01a61080044588), {}),
    delete: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9819cc275a023cc4$export$d23329de703dffc4), {}),
    deleteRow: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $543fda4ac58ac75f$export$12a3823f287db803), {}),
    details: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e1f565be31fe1992$export$70784bf0c528892c), {}),
    deviceManager: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0536198cc436fd7c$export$ba4cac3c471c5034), {}),
    dictationOff: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1498f3d123581ef7$export$d9c1abf94e64825b), {}),
    dictationOn: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $32c43b5d35c7f6a5$export$2aab0b35a50deea3), {}),
    dictationPause: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b4c041254446cc77$export$2e2bcd8739ae039), {}),
    dictationPlay: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7bd416e9f38b8977$export$2e2bcd8739ae039), {}),
    discoball: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8140d5c711c8dac2$export$f8943b539a4bce42), {}),
    discord: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f3679bbefd6a2cdc$export$2e2bcd8739ae039), {}),
    disneyMovies: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c67d20bd69d9f8ef$export$2e2bcd8739ae039), {}),
    doomLogo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $92aaa8e9b3c9a4fd$export$2e2bcd8739ae039), {}),
    downLeftArrow: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67b9a227b3b8fac0$export$13cb63b08462037d), {}),
    downRightArrow: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6637b5fdc104c1c9$export$56519a0a31438e20), {}),
    download: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3d7aae5ab6f8c20e$export$5e12dc2d5a33c663), {}),
    duplicate: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db96a5dcfc35585c$export$51b6cd98f8778f0d), {}),
    edit: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9bcf07f234bdd453$export$97ae7c994680a9ed), {}),
    eduLogo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0b863f60fd8ea76e$export$2e2bcd8739ae039), {}),
    eduLogoWhite: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $793a6d9e0f3eb994$export$2e2bcd8739ae039), {}),
    epicGames: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $512b1d6277a77d97$export$2e2bcd8739ae039), {}),
    expandArrow: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d78174bfef35f91$export$73a4c78a4a00962), {}),
    expression: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f83f391ed40890b1$export$2e2bcd8739ae039), {}),
    externalLink: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2c52d04e0b586f6c$export$8a7958b7fd68e86d), {}),
    eye: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $41331bef289ddf9d$export$4b2c798a70974642), {}),
    eyebrowRaise: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $878338a7c05872f6$export$2e2bcd8739ae039), {}),
    faceExpression: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e8f8716714af8e2c$export$2e2bcd8739ae039), {}),
    facebook: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a6e3afa557217638$export$2e2bcd8739ae039), {}),
    facebookMessenger: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0de5ad6202c372c1$export$2e2bcd8739ae039), {}),
    facetime: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $27eac4e6b224d0c7$export$2e2bcd8739ae039), {}),
    fileMd: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $494752190a3820c3$export$88937d130805b394), {}),
    files: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $250558ea9b1ae473$export$e08f3be1829716d), {}),
    findIphone: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $25abb7d8311d1b5e$export$2e2bcd8739ae039), {}),
    fireTv: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d66404571458338$export$2e2bcd8739ae039), {}),
    fortnite: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $195bb2aa60406de1$export$2e2bcd8739ae039), {}),
    forward: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cf227e7e52862ade$export$5e4a7579d3e78657), {}),
    futures: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $352ea393a631b359$export$9da4f9d7ed027300), {}),
    game: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $07eb5346ad9d064e$export$67c6cd66cb8e49db), {}),
    github: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e61990689ecc79a$export$2e2bcd8739ae039), {}),
    globe: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b80ecb83ad6de581$export$a70e2e549144f66), {}),
    gmail: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $792bc4d5598bcd37$export$2e2bcd8739ae039), {}),
    gmailLogo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $75745da5fba927e0$export$2e2bcd8739ae039), {}),
    google: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c6371eb2aedbedde$export$2e2bcd8739ae039), {}),
    googleCalendar: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d6a3e630182db681$export$2e2bcd8739ae039), {}),
    googleClassroom: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b2a655191d7c12f7$export$2e2bcd8739ae039), {}),
    googleDocs: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $713e9c2c47877792$export$2e2bcd8739ae039), {}),
    googleDrawing: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e950c6997d469e51$export$2e2bcd8739ae039), {}),
    googleDrive: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28402c28da4b8b2b$export$2e2bcd8739ae039), {}),
    googleEarth: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $52d4718a69ac94c7$export$2e2bcd8739ae039), {}),
    googleForms: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6ee8c38486294b4f$export$2e2bcd8739ae039), {}),
    googleMeet: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $11b2a8be749657ee$export$2e2bcd8739ae039), {}),
    googlePixel6: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $611cb8c6b8793355$export$2e2bcd8739ae039), {}),
    googlePlay: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $480150230dd592ca$export$2e2bcd8739ae039), {}),
    googlePlayMusic: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f49bc59318865ee6$export$2e2bcd8739ae039), {}),
    googlePlus: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a80e63067819b2a7$export$2e2bcd8739ae039), {}),
    googleSheets: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2e1061f35716bd07$export$2e2bcd8739ae039), {}),
    googleSlides: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e30adf1bb2f794b5$export$2e2bcd8739ae039), {}),
    grammarly: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a3ace68bbd1278b8$export$2e2bcd8739ae039), {}),
    hboMax: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $13c1584923501bf3$export$2e2bcd8739ae039), {}),
    heart: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $daf0af796c7daf33$export$44fb2b0459be5849), {}),
    headMovement: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a40ac44443616e4e$export$2e2bcd8739ae039), {}),
    headMovement1: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f3215e388a4926a3$export$2e2bcd8739ae039), {}),
    headTurning: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbedcd5de46db09$export$2e2bcd8739ae039), {}),
    headUpAndDown: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $95fa162f48833150$export$2e2bcd8739ae039), {}),
    health: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d6570d7c790cde0b$export$2e2bcd8739ae039), {}),
    help: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2322f0f5c675ac09$export$f314ed182f5da2a0), {}),
    hide: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0987fb0e4a894127$export$a3d42ccaf02d165b), {}),
    hideSidepanel: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5fffe8c4dc33c750$export$8e4e0663d737f944), {}),
    home: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f183d9af8860529$export$f8c453d4287040a2), {}),
    hub: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $25483bd4b980c997$export$49b63808e7fc4751), {}),
    hulu: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $32705bcb0cd360a7$export$2e2bcd8739ae039), {}),
    icloud: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45cda0bdf909d545$export$2e2bcd8739ae039), {}),
    idea: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $885e936d56aff1b9$export$f678a184393c5940), {}),
    imac: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db0aecd837df835e$export$78a6319cfd8cd037), {}),
    imovie: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0fa071542d1ff183$export$2e2bcd8739ae039), {}),
    insertRow: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1cd2f9ed3ccb6f1$export$83609ace955a79f), {}),
    insertRowAbove: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1cd2f9ed3ccb6f1$export$83609ace955a79f), {}),
    instagram: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $655e3e5c364148e2$export$2e2bcd8739ae039), {}),
    iosLogo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9bb0f831af78c332$export$2e2bcd8739ae039), {}),
    iosPhotos: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $142e6c76da9ebc8b$export$2e2bcd8739ae039), {}),
    iphone: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $32f3456307b486ee$export$86748a064d6b172), {}),
    itunes: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $37d29f22d8db03a3$export$2e2bcd8739ae039), {}),
    javaScript: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c25bb468cbb9a994$export$2e2bcd8739ae039), {}),
    jira: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c44bfc9fc6a27ffb$export$2e2bcd8739ae039), {}),
    joystick: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6234b88ab556c79a$export$da69e29052e4731), {}),
    key0: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a632d8591d1e8129$export$2e2bcd8739ae039), {}),
    key1: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8df11c1882a1a51b$export$2e2bcd8739ae039), {}),
    key2: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1e1ea149a9060c6a$export$2e2bcd8739ae039), {}),
    key3: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f0c42c8087af715b$export$2e2bcd8739ae039), {}),
    key4: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d4f76112c461b32f$export$2e2bcd8739ae039), {}),
    key5: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $02bb6564be985baa$export$2e2bcd8739ae039), {}),
    key6: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $11ba4ce477af0c9a$export$2e2bcd8739ae039), {}),
    key7: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2d8a61a07fbe0860$export$2e2bcd8739ae039), {}),
    key8: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb6bb042edf63b5c$export$2e2bcd8739ae039), {}),
    key9: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0440a6aa4628c945$export$2e2bcd8739ae039), {}),
    keyA: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d905b0a6418e110d$export$2e2bcd8739ae039), {}),
    keyAlt: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30670d6961572f0f$export$2e2bcd8739ae039), {}),
    keyAltgr: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $93014453a15abd8b$export$2e2bcd8739ae039), {}),
    keyAsterisk: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c3c343fdfab7ac2$export$2e2bcd8739ae039), {}),
    keyB: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8df7a3bd0475c986$export$2e2bcd8739ae039), {}),
    keyBackspace: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $027d46a574c94474$export$2e2bcd8739ae039), {}),
    keyC: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4348b719525840f3$export$2e2bcd8739ae039), {}),
    keyCapsLock: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6921955218308c40$export$2e2bcd8739ae039), {}),
    keyCapslockText: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $31e3b501c850f2fe$export$2e2bcd8739ae039), {}),
    keyCmd: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e784f7a02803758d$export$2e2bcd8739ae039), {}),
    keyCoinsButton: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d5b77224cfca79fc$export$2e2bcd8739ae039), {}),
    keyCommand: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0606a21a12ea54c0$export$2e2bcd8739ae039), {}),
    keyControl: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $49250ec78a20638c$export$2e2bcd8739ae039), {}),
    keyCtrl: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1940e6fd7db13266$export$2e2bcd8739ae039), {}),
    keyD: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4b9831ccf8f478fd$export$2e2bcd8739ae039), {}),
    keyDelete: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0e0005e3eb8a47f$export$2e2bcd8739ae039), {}),
    keyDelete2: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b6575f368334c18a$export$2e2bcd8739ae039), {}),
    keyDot: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $335196af04c84a31$export$2e2bcd8739ae039), {}),
    keyE: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fbebede1d622f77a$export$2e2bcd8739ae039), {}),
    keyEndButton: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $22a251f88571b84a$export$2e2bcd8739ae039), {}),
    keyEnter: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebbe86d494ff9bbc$export$2e2bcd8739ae039), {}),
    keyEnterMac: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $37dbda8c254edf97$export$2e2bcd8739ae039), {}),
    keyEqual: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $487d6e36dcafcb2d$export$2e2bcd8739ae039), {}),
    keyEsc: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c6d465961f631267$export$2e2bcd8739ae039), {}),
    keyEscMac: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e0708247861041f7$export$2e2bcd8739ae039), {}),
    keyF: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $97c5c43afd0584a8$export$2e2bcd8739ae039), {}),
    keyF1: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d770639ab656fa18$export$2e2bcd8739ae039), {}),
    keyF10: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $332524047e7a4ac5$export$2e2bcd8739ae039), {}),
    keyF11: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ca5f38dbd83f3721$export$2e2bcd8739ae039), {}),
    keyF12: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e9a184e77d9537a4$export$2e2bcd8739ae039), {}),
    keyF2: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $377584932bdac7fe$export$2e2bcd8739ae039), {}),
    keyF3: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fd4b812de9ff4851$export$2e2bcd8739ae039), {}),
    keyF4: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6b573a3566bd3206$export$2e2bcd8739ae039), {}),
    keyF5: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $41d8574f644e60ac$export$2e2bcd8739ae039), {}),
    keyF6: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62856496d756886b$export$2e2bcd8739ae039), {}),
    keyF7: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $47c4a943b3e5ccd3$export$2e2bcd8739ae039), {}),
    keyF8: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9e8ae470d5334fbf$export$2e2bcd8739ae039), {}),
    keyF9: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f638f7603c3f0297$export$2e2bcd8739ae039), {}),
    keyFn: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1253f9538fc416fa$export$2e2bcd8739ae039), {}),
    keyFunctionMac: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e7c04b832cc34ee7$export$2e2bcd8739ae039), {}),
    keyG: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $721bb2247b62229e$export$2e2bcd8739ae039), {}),
    keyH: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40c08a9bfd143af3$export$2e2bcd8739ae039), {}),
    keyHashtag: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9df36942c9a98cf6$export$2e2bcd8739ae039), {}),
    keyHomeButton: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e90a70d42b6dc2e5$export$2e2bcd8739ae039), {}),
    keyI: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $31af271f439f7f10$export$2e2bcd8739ae039), {}),
    keyJ: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c2e5ff91a41ba25e$export$2e2bcd8739ae039), {}),
    keyK: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $eed7a945fc76c2bd$export$2e2bcd8739ae039), {}),
    keyL: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $babff20b0d4654ba$export$2e2bcd8739ae039), {}),
    keyLeftAngleParentheses: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28380b67fbfe727d$export$2e2bcd8739ae039), {}),
    keyM: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $eeaf776f967e20c6$export$2e2bcd8739ae039), {}),
    keyMinus: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dcb0c3efc1457ecf$export$2e2bcd8739ae039), {}),
    keyN: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e13a1775e3b494bc$export$2e2bcd8739ae039), {}),
    keyO: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4c0f13b7e9c863f6$export$2e2bcd8739ae039), {}),
    keyOption: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f785a1fe04b59464$export$2e2bcd8739ae039), {}),
    keyP: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f857acdec584cd37$export$2e2bcd8739ae039), {}),
    keyPageDownButton: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e99cc5022343e76f$export$2e2bcd8739ae039), {}),
    keyPageUpButton: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2a844d4ba0847ea6$export$2e2bcd8739ae039), {}),
    keyPlus: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5047847f9449d0d7$export$2e2bcd8739ae039), {}),
    keyQ: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6604f2ab651791da$export$2e2bcd8739ae039), {}),
    keyR: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $756d3ddc5105ca4d$export$2e2bcd8739ae039), {}),
    keyRightAngleParentheses: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cdc0aa5cadea8c33$export$2e2bcd8739ae039), {}),
    keyS: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $39f8b5dc7ed29ffc$export$2e2bcd8739ae039), {}),
    keySolidus: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8378efa8f631e6e6$export$2e2bcd8739ae039), {}),
    keySpace: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $20566c6a075b51f1$export$2e2bcd8739ae039), {}),
    keyT: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $441acdbafb1bd1ee$export$2e2bcd8739ae039), {}),
    keyTab: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $eb7fda30618d887d$export$2e2bcd8739ae039), {}),
    keyU: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0674e1fc2efa4c50$export$2e2bcd8739ae039), {}),
    keyV: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $300d4a3a425ff969$export$2e2bcd8739ae039), {}),
    keyW: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $673e0b4aaae7ef63$export$2e2bcd8739ae039), {}),
    keyWindows: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cfc8508a0d8a5a06$export$2e2bcd8739ae039), {}),
    keyX: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bded3da25f49952b$export$2e2bcd8739ae039), {}),
    keyY: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d240e40e324119ef$export$2e2bcd8739ae039), {}),
    keyZ: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1401a11666a30a5e$export$2e2bcd8739ae039), {}),
    keyboard: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3977927b8e8acd3c$export$97dac707ecee26f6), {}),
    launchpad: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $47547f2fd2eb2527$export$ccc8b9cc502aea29), {}),
    layers: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $23259387cb66f7b3$export$f95b8a41f9121b54), {}),
    leanFrontToBack: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $46e8d4dadea67077$export$2e2bcd8739ae039), {}),
    library: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $862061e2a830a35b$export$3ac311e31945509f), {}),
    linkedin: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $788da9ed54ecd493$export$2e2bcd8739ae039), {}),
    linkBreak: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a7ac72ddd488c3fa$export$3cf6c022d9395be8), {}),
    lightning: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $66907d3d09578e84$export$b9beba9ac1b19787), {}),
    logo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0e324a98afaf32e9$export$2e2bcd8739ae039), {}),
    logo2KLogo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4c0ef6c1c64a1357$export$2e2bcd8739ae039), {}),
    logout: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $91f7b26fb1a24ddc$export$5bb2595dc31bfece), {}),
    macbookProM1: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5a4a10635b84b894$export$b94473071ddf9fbf), {}),
    mail: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $356076885242800f$export$ea4109706c07d076), {}),
    mastercard: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dc242ec31876a589$export$2e2bcd8739ae039), {}),
    messages: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3fbee013cad25ded$export$2e2bcd8739ae039), {}),
    microphone: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $09b782f8de8a3c61$export$d2834cd4e399cf8b), {}),
    microphoneOff: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2bb6ac751b7724ae$export$8d1357c8e3c4bfd6), {}),
    microsoftEdge: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0ca46ae71da4c2a$export$2e2bcd8739ae039), {}),
    microsoftExcel: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $073cb9bb3a09c7d7$export$2e2bcd8739ae039), {}),
    microsoftOnenote: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9b5ae76a6c0d9c1$export$2e2bcd8739ae039), {}),
    microsoftOnenote2: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ddc5edcab4e76c4a$export$2e2bcd8739ae039), {}),
    microsoftOutlook: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9b7e1a52af65fadf$export$2e2bcd8739ae039), {}),
    microsoftPowerpoint: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $043753d569a8f872$export$2e2bcd8739ae039), {}),
    microsoftTeams2019: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d612a33d3bd29557$export$2e2bcd8739ae039), {}),
    microsoftToDoApp: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4690868c4c694c15$export$2e2bcd8739ae039), {}),
    microsoftWord: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $be2fbecbfbe47448$export$2e2bcd8739ae039), {}),
    motionControl: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a9622dbe0a0baaaf$export$2e2bcd8739ae039), {}),
    motionControl1: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0fccc9e464ae15bb$export$2e2bcd8739ae039), {}),
    motionControl2: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9ca35a7fde0d51c6$export$2e2bcd8739ae039), {}),
    money: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a91f296d46ab80$export$fb505dcffad77432), {}),
    more: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $88db7d04aef0c70c$export$fc32f3c5f46e7c02), {}),
    motherboard: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $79c2550b6d641714$export$a0dda6738dfadcc6), {}),
    mouse: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $91081726855ec7c6$export$53ac786375585ec0), {}),
    mouseLeftClick: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $35ad9356e9e5ec61$export$6b5f666f729352a), {}),
    mouseMiddleClick: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d85af3025ef534f2$export$5963dbb4ba2dab8b), {}),
    mouseRightClick: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3f8122a9e58d3677$export$50d995ce278ebfd9), {}),
    mouseScrolling: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8fa60ad372f26f07$export$f0907b1c06628174), {}),
    move: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $262c01eb267814c7$export$a851e5e12081274c), {}),
    moveDown: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $31ad35f89b420139$export$39cd7ca4553bb068), {}),
    moveUp: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $618411f7e75dbf5e$export$877fb05cb295590c), {}),
    multipleDevices: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0536198cc436fd7c$export$ba4cac3c471c5034), {}),
    music: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $311040ba1740986f$export$2e2bcd8739ae039), {}),
    naturalUserInterface2: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1ba208388ac239df$export$7caf2e6d06b0e274), {}),
    netflix: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9cedd24a1acdd63f$export$2e2bcd8739ae039), {}),
    newYorkTimes: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7e5ab08ff1b567f0$export$2e2bcd8739ae039), {}),
    nintendoSwitchLogo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2081ab8da1be49dc$export$2e2bcd8739ae039), {}),
    nod: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0b823c4a4b1403fe$export$2e2bcd8739ae039), {}),
    notes: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69972f0aea86b6a2$export$d07ff5a8e7869743), {}),
    notification: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $19062bd64dded0d3$export$2235404cc2cfe93c), {}),
    octopus: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $85b17b826eab10ce$export$2e2bcd8739ae039), {}),
    office365: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4262604d9c082a54$export$2e2bcd8739ae039), {}),
    openCloseMouth: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $97f91bf195707c03$export$2e2bcd8739ae039), {}),
    orgAdmin: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $380b00235de4079c$export$2d4a0edcdd78d72c), {}),
    orgAuthClient: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9991baf035cb3560$export$3dc0fe769dc7dcac), {}),
    orgCompany: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $866da9b1db75c8ee$export$5039d390f8f90df), {}),
    orgDeleteUser: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $43867aff44220ee6$export$dcdebfa7a96805c0), {}),
    orgInvite: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3a96a83bceac7286$export$237d26d4b8472a), {}),
    orgInviteExpired: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e71b30b7f3057cfb$export$1ce52e77d13914c6), {}),
    orgMembers: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dc77a89d27a4c55c$export$4e04c809deb7a605), {}),
    orgPermissions: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2f437e07b97666ee$export$3006507487a721d3), {}),
    orgTransaction: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a91f296d46ab80$export$fb505dcffad77432), {}),
    pandoraApp: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6e649c234c8975d4$export$2e2bcd8739ae039), {}),
    palette: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2a77e4a11253c5e2$export$c142a38f581c8178), {}),
    pause: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $282419a8b70eaf27$export$9b47433640e5db3a), {}),
    pause2: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a070e95907d9d1$export$75886cde6273c22e), {}),
    paypal: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6efa39f11e16b5aa$export$2e2bcd8739ae039), {}),
    personalLogo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2f65eb00043ec877$export$2e2bcd8739ae039), {}),
    personalLogoWhite: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $710403c951aed9ee$export$2e2bcd8739ae039), {}),
    phone: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f9242fb59a025a53$export$54336acd81078d46), {}),
    play: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3771d59d9595d59e$export$a6630b90defda83f), {}),
    playstation: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dc51cba71cb43570$export$2e2bcd8739ae039), {}),
    playstore: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a9ffda3eb6c05e1$export$2e2bcd8739ae039), {}),
    plus: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd4d57083c8a9ad0$export$99bb4c5ac5bf5ec5), {}),
    plusLight: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd4d57083c8a9ad0$export$99bb4c5ac5bf5ec5), {}),
    plusLogo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b0f91621c24890df$export$2e2bcd8739ae039), {}),
    plusLogoWhite: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a4996e3fa9df448c$export$2e2bcd8739ae039), {}),
    powerBi: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67599b84b2002306$export$2e2bcd8739ae039), {}),
    preferences: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cef83b92ad455ae8$export$2e2bcd8739ae039), {}),
    preview: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $41331bef289ddf9d$export$4b2c798a70974642), {}),
    previous: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2fa01b25bab55864$export$810196a5854768f3), {}),
    proLogo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $24f5c501f2475f6f$export$2e2bcd8739ae039), {}),
    proLogoWhite: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $15669c683dd043b1$export$2e2bcd8739ae039), {}),
    process: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45c37c8e5c384c5e$export$c6d97cdd83a3ef7a), {}),
    ps4: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7efcdfa101ef1389$export$2e2bcd8739ae039), {}),
    purchaseOrder: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $da973a188202d04f$export$efdad510605bf5b6), {}),
    reactNative: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ddc512c8843c2cb$export$2e2bcd8739ae039), {}),
    read: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c629337a707d5c1c$export$e7072e36fe002dd0), {}),
    releaseKey: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77361cab3d35eb70$export$d4c1fa49fa5d23e1), {}),
    reminders: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f16a8074acc9fc02$export$2e2bcd8739ae039), {}),
    repeat: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $510c9fc2f66cce3f$export$e5f174c029ba02b2), {}),
    replicateRows: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c7cfe8b811c67a0e$export$2f845a994f66da8f), {}),
    rockstarGames: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fabb58c67223cc99$export$2e2bcd8739ae039), {}),
    safari: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7cb0e7963ddb95ec$export$2e2bcd8739ae039), {}),
    sanAndreas: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $566b6e2d6ce5c43b$export$2e2bcd8739ae039), {}),
    save: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d09bbb62b804b286$export$72eeb4bb593c0c95), {}),
    sdk: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $341dc8bc46d90b3a$export$2acbef2959ecd829), {}),
    sdkLogo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6bbbdeadab023461$export$2e2bcd8739ae039), {}),
    sdkLogoWhite: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8f033889ae95cbbe$export$2e2bcd8739ae039), {}),
    search: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5394ccda98b8b514$export$f7658c347b037c3f), {}),
    selfServiceKiosk: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $99cdf9595233aa23$export$2e2bcd8739ae039), {}),
    sensitivity: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fbf8be4ed6bd1575$export$2e2bcd8739ae039), {}),
    settings: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $27341b9e147c07ff$export$9d72c0eeb3943e75), {}),
    shakePhone: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7d13e33d82d990b$export$2e2bcd8739ae039), {}),
    share: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $281c4dbdb34445c4$export$40148c7db598e4e0), {}),
    shazam: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f3b7e121ae3cb925$export$2e2bcd8739ae039), {}),
    shift: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $303639901bf99dc0$export$2e2bcd8739ae039), {}),
    shift2: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a105b007c217e587$export$2e2bcd8739ae039), {}),
    shiftMac: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6c173fbd5231fa4f$export$2e2bcd8739ae039), {}),
    showtime: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7bcdb42b48fb49f4$export$2e2bcd8739ae039), {}),
    sidebar: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b5b42c3034b41cbc$export$2e2bcd8739ae039), {}),
    signalApp: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5994517905e023d$export$2e2bcd8739ae039), {}),
    siri: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0f464a6a2f00d4b8$export$2e2bcd8739ae039), {}),
    slack: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2005106e9deaac4d$export$2e2bcd8739ae039), {}),
    smartWatch: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $02d2ce069a187b72$export$2e2bcd8739ae039), {}),
    smile: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $086b5e67479dbabb$export$2e2bcd8739ae039), {}),
    soundcloud: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bd1ce7d657321c94$export$2e2bcd8739ae039), {}),
    sparkles: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8899997e3fc20429$export$1019ff5537a7252e), {}),
    speaker: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0972bbebf39666e5$export$951b168b9ecc05fb), {}),
    speedometer: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d545586961bd20bd$export$5ff880ebd1cf0b62), {}),
    spotify: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c5ccfc72ed9852e5$export$2e2bcd8739ae039), {}),
    squaredMenu: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ffc30300995f8d60$export$aa8679e33ed2ffa0), {}),
    ssd: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $46b7fb5cd67a058d$export$2e2bcd8739ae039), {}),
    stop: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9eef48aaff177bbc$export$dc6949a98411e916), {}),
    svgCephy: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28ab7c56405aa7ea$export$2e2bcd8739ae039), {}),
    switchControl: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e1a50be14ab9a9e$export$2e2bcd8739ae039), {}),
    switchControl1: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $78046ad711fac15d$export$2e2bcd8739ae039), {}),
    switchControl2: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4bb4296f4d314913$export$2e2bcd8739ae039), {}),
    switchSimple: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6b7947571a956063$export$2e2bcd8739ae039), {}),
    symantec: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d4753e72983465a2$export$2e2bcd8739ae039), {}),
    sync: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0626899a8774a822$export$67f45bdc93ca8e23), {}),
    tabKey2: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e0ea924b4f8fb967$export$2e2bcd8739ae039), {}),
    tabMac: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $02e80b1c53448aa7$export$2e2bcd8739ae039), {}),
    tapPause: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ac547a61f677026b$export$2e2bcd8739ae039), {}),
    tapPlay: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $27e318183cdf78bd$export$2e2bcd8739ae039), {}),
    tapStop: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0b5a1ec4c31772a9$export$2e2bcd8739ae039), {}),
    tiktok: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $39440ba5457cc20b$export$2e2bcd8739ae039), {}),
    timer: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ec3dc4d0853d94d0$export$579848c7cccecf3f), {}),
    todoist: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e3d15c36ae3535e8$export$2e2bcd8739ae039), {}),
    toggleKey: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c13e7fb415e096f$export$2e2bcd8739ae039), {}),
    tools: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $52a0c24a3d3e2214$export$bc176c2a10341979), {}),
    touchpad: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fccdf11ae80529b$export$2e2bcd8739ae039), {}),
    trello: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f481633bf928acdb$export$2e2bcd8739ae039), {}),
    tripadvisor: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fe23b5827fb90960$export$2e2bcd8739ae039), {}),
    tv: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1695f1b8e4452b4e$export$2e2bcd8739ae039), {}),
    twitch: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0c48daaee27f5aac$export$2e2bcd8739ae039), {}),
    twitterx: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d417e5b9a3bf4ea5$export$2e2bcd8739ae039), {}),
    uber: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $418d4e99ed245825$export$2e2bcd8739ae039), {}),
    unity: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6eacdd29be96605e$export$2e2bcd8739ae039), {}),
    unrealEngine: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6506a335d289da77$export$2e2bcd8739ae039), {}),
    upgrade: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18715178eb9fa0d1$export$2e2bcd8739ae039), {}),
    usb2: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7594f1f4d24bde25$export$2e2bcd8739ae039), {}),
    usbC: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $afd76c8e7b7affb8$export$2e2bcd8739ae039), {}),
    usbOff: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f45133cdb78263ed$export$2e2bcd8739ae039), {}),
    user: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0c61379047732f24$export$9daf73c3c6a408a2), {}),
    userGroups: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e0b8800b731f944b$export$31f7e9379e51640b), {}),
    variant: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbcdd9ecba689979$export$2bc1d0180119f574), {}),
    vector: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $121fda4f624e73fb$export$2e2bcd8739ae039), {}),
    virtualApps: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fa3e65f55eb3500f$export$2e2bcd8739ae039), {}),
    virtualButton: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $faa4b1f11be8231d$export$2e2bcd8739ae039), {}),
    virtualReality: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $24e6d56f54bae8bf$export$2e2bcd8739ae039), {}),
    visualStudio: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $00343718cdb9cc97$export$2e2bcd8739ae039), {}),
    voice: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $33b5e9a8ed1b53a5$export$2e2bcd8739ae039), {}),
    voiceControl: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $acd55902513cc2be$export$2e2bcd8739ae039), {}),
    voiceMemos: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $34aed62813af1122$export$2e2bcd8739ae039), {}),
    wheelchairMotion: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $47d7fdd528e7358c$export$70f2a162da142226), {}),
    warning: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a44ba7e85f055b31$export$9f0af3ec4c4725c2), {}),
    warningFilled: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd4997cb53138a7f$export$d724908cf9d2c1d6), {}),
    warningTriangle: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e0770788fd5741d9$export$f7dc499a72baa103), {}),
    waze: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c3ac36ea1b4137a8$export$2e2bcd8739ae039), {}),
    weather: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a85044c5feaf17c$export$2e2bcd8739ae039), {}),
    wechat: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b62ebb210c573784$export$2e2bcd8739ae039), {}),
    wellsfargo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af66a6393cd41f93$export$2e2bcd8739ae039), {}),
    whatsapp: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b418400b3516f49e$export$2e2bcd8739ae039), {}),
    wiFi: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e1dc4c4bf0ea2b94$export$bb1fb2a6f6348cd5), {}),
    windows11: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d752c8bed9966dc3$export$2e2bcd8739ae039), {}),
    windowsXp: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cbdf5641ddee00a3$export$2e2bcd8739ae039), {}),
    xfinity: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e1fdb89e8a7f1773$export$2e2bcd8739ae039), {}),
    yelp: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9d8b2252c9d0cc9d$export$2e2bcd8739ae039), {}),
    youtube: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c010517a0bd62c4$export$2e2bcd8739ae039), {}),
    zoom: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a567b0078c16856f$export$2e2bcd8739ae039), {})
};


/**
 * This is a wrapper component for the icons defined in the IconMap.tsx file.
 * This has the flexibility to change the size and color of the icons.
 * By default the size is 24px and color is inherit -- which means that it will inherit the text color of the parent element when no color prop is passed.
 * Icons can be enhanced to have hover and active states if needed. An example of adding a hover state is below where the parent component is extended and the svg element is targeted to change the size and color.
 *
 *      const IconButtonLinkWithHover = styled(IconButtonLink)`
 *          :hover {
 *              svg {
 *                  height: 26px;
 *                  width: 26px;
 *                  color: ${color.bg_light};
 *              }
 *          }
 *      `;
 *
 *
 *
 *
 * It is important to note that the svg jsx components must have fill and stroke values set to 'currentcolor' for color changes to work.
 *
 *  */ function $f7580c2fb20f0ef1$var$Icons({ ariaLabel: ariaLabel = '', name: name, size: size = 24, color: color = '', ...restProps }) {
    const svgToRender = (0, $3adbcb77e640770e$export$6d49a893c897b0cc)[name] || null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($f7580c2fb20f0ef1$var$IconContainer, {
        "aria-hidden": ariaLabel ? 'false' : 'true',
        $size: size,
        $color: color,
        ...restProps,
        children: [
            svgToRender,
            ariaLabel && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30af349a5a5f3e57$export$2e2bcd8739ae039), {
                children: ariaLabel
            })
        ]
    });
}
const $f7580c2fb20f0ef1$var$IconContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039)('span')`
    color: ${(props)=>props.$color || 'inherit'};
    display: inline-block;
    line-height: 0;
    pointer-events: auto;
    svg {
        width: ${(props)=>props.$size + 'px'};
        height: ${(props)=>props.$size + 'px'};
    }
`;
var $f7580c2fb20f0ef1$export$2e2bcd8739ae039 = $f7580c2fb20f0ef1$var$Icons;



var $7fPBF = parcelRequire("7fPBF");
/**
 * react-router v7.13.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");
var $5ec159caebd3ae22$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-LFPYN7LY.mjs"
});
var $5ec159caebd3ae22$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $5ec159caebd3ae22$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $5ec159caebd3ae22$var$__typeError("Cannot " + msg);
var $5ec159caebd3ae22$var$__privateGet = (obj, member, getter)=>($5ec159caebd3ae22$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $5ec159caebd3ae22$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $5ec159caebd3ae22$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
// lib/router/history.ts
var $5ec159caebd3ae22$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($5ec159caebd3ae22$export$e19cd5f9376f8cee || {});
var $5ec159caebd3ae22$var$PopStateEventType = "popstate";
function $5ec159caebd3ae22$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $5ec159caebd3ae22$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.unstable_mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, unstable_mask) {
        let location = $5ec159caebd3ae22$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, unstable_mask);
        $5ec159caebd3ae22$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $5ec159caebd3ae22$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $5ec159caebd3ae22$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $5ec159caebd3ae22$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $5ec159caebd3ae22$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $5ec159caebd3ae22$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $5ec159caebd3ae22$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $5ec159caebd3ae22$export$fe53371bee54353d(to);
    }
    return $5ec159caebd3ae22$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $5ec159caebd3ae22$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $5ec159caebd3ae22$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $5ec159caebd3ae22$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $5ec159caebd3ae22$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $5ec159caebd3ae22$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $5ec159caebd3ae22$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $5ec159caebd3ae22$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $5ec159caebd3ae22$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $5ec159caebd3ae22$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $5ec159caebd3ae22$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.unstable_mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $5ec159caebd3ae22$var$createLocation(current, to, state = null, key, unstable_mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $5ec159caebd3ae22$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $5ec159caebd3ae22$var$createKey(),
        unstable_mask: unstable_mask
    };
    return location;
}
function $5ec159caebd3ae22$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $5ec159caebd3ae22$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $5ec159caebd3ae22$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $5ec159caebd3ae22$var$isLocation(to) ? to : $5ec159caebd3ae22$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $5ec159caebd3ae22$var$getHistoryState(location, index);
        let url = history.createHref(location.unstable_mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $5ec159caebd3ae22$var$isLocation(to) ? to : $5ec159caebd3ae22$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $5ec159caebd3ae22$var$getHistoryState(location, index);
        let url = history.createHref(location.unstable_mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $5ec159caebd3ae22$var$createBrowserURLImpl(to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($5ec159caebd3ae22$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($5ec159caebd3ae22$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $5ec159caebd3ae22$var$createBrowserURLImpl(to, isAbsolute = false) {
    let base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    $5ec159caebd3ae22$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $5ec159caebd3ae22$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $5ec159caebd3ae22$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $5ec159caebd3ae22$var$_map;
var $5ec159caebd3ae22$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $5ec159caebd3ae22$var$__privateAdd(this, $5ec159caebd3ae22$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($5ec159caebd3ae22$var$__privateGet(this, $5ec159caebd3ae22$var$_map).has(context)) return $5ec159caebd3ae22$var$__privateGet(this, $5ec159caebd3ae22$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $5ec159caebd3ae22$var$__privateGet(this, $5ec159caebd3ae22$var$_map).set(context, value);
    }
};
$5ec159caebd3ae22$var$_map = new WeakMap();
var $5ec159caebd3ae22$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $5ec159caebd3ae22$var$isUnsupportedLazyRouteObjectKey(key) {
    return $5ec159caebd3ae22$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $5ec159caebd3ae22$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $5ec159caebd3ae22$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $5ec159caebd3ae22$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $5ec159caebd3ae22$var$isIndexRoute(route) {
    return route.index === true;
}
function $5ec159caebd3ae22$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $5ec159caebd3ae22$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $5ec159caebd3ae22$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($5ec159caebd3ae22$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $5ec159caebd3ae22$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $5ec159caebd3ae22$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $5ec159caebd3ae22$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $5ec159caebd3ae22$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $5ec159caebd3ae22$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $5ec159caebd3ae22$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $5ec159caebd3ae22$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $5ec159caebd3ae22$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $5ec159caebd3ae22$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $5ec159caebd3ae22$var$flattenRoutes(routes);
    $5ec159caebd3ae22$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $5ec159caebd3ae22$var$decodePath(pathname);
        matches = $5ec159caebd3ae22$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $5ec159caebd3ae22$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $5ec159caebd3ae22$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $5ec159caebd3ae22$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $5ec159caebd3ae22$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $5ec159caebd3ae22$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $5ec159caebd3ae22$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $5ec159caebd3ae22$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $5ec159caebd3ae22$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $5ec159caebd3ae22$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $5ec159caebd3ae22$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $5ec159caebd3ae22$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $5ec159caebd3ae22$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $5ec159caebd3ae22$var$paramRe = /^:[\w-]+$/;
var $5ec159caebd3ae22$var$dynamicSegmentValue = 3;
var $5ec159caebd3ae22$var$indexRouteValue = 2;
var $5ec159caebd3ae22$var$emptySegmentValue = 1;
var $5ec159caebd3ae22$var$staticSegmentValue = 10;
var $5ec159caebd3ae22$var$splatPenalty = -2;
var $5ec159caebd3ae22$var$isSplat = (s)=>s === "*";
function $5ec159caebd3ae22$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($5ec159caebd3ae22$var$isSplat)) initialScore += $5ec159caebd3ae22$var$splatPenalty;
    if (index) initialScore += $5ec159caebd3ae22$var$indexRouteValue;
    return segments.filter((s)=>!$5ec159caebd3ae22$var$isSplat(s)).reduce((score, segment)=>score + ($5ec159caebd3ae22$var$paramRe.test(segment) ? $5ec159caebd3ae22$var$dynamicSegmentValue : segment === "" ? $5ec159caebd3ae22$var$emptySegmentValue : $5ec159caebd3ae22$var$staticSegmentValue), initialScore);
}
function $5ec159caebd3ae22$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $5ec159caebd3ae22$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $5ec159caebd3ae22$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $5ec159caebd3ae22$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $5ec159caebd3ae22$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $5ec159caebd3ae22$var$normalizePathname($5ec159caebd3ae22$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $5ec159caebd3ae22$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $5ec159caebd3ae22$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $5ec159caebd3ae22$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify2(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $5ec159caebd3ae22$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $5ec159caebd3ae22$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $5ec159caebd3ae22$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $5ec159caebd3ae22$var$compilePath(path, caseSensitive = false, end = true) {
    $5ec159caebd3ae22$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $5ec159caebd3ae22$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $5ec159caebd3ae22$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $5ec159caebd3ae22$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $5ec159caebd3ae22$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $5ec159caebd3ae22$var$joinPaths([
        basename,
        pathname
    ]);
}
var $5ec159caebd3ae22$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $5ec159caebd3ae22$var$isAbsoluteUrl = (url)=>$5ec159caebd3ae22$var$ABSOLUTE_URL_REGEX.test(url);
function $5ec159caebd3ae22$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $5ec159caebd3ae22$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = toPathname.replace(/\/\/+/g, "/");
        if (toPathname.startsWith("/")) pathname = $5ec159caebd3ae22$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $5ec159caebd3ae22$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $5ec159caebd3ae22$var$normalizeSearch(search),
        hash: $5ec159caebd3ae22$var$normalizeHash(hash)
    };
}
function $5ec159caebd3ae22$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $5ec159caebd3ae22$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $5ec159caebd3ae22$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $5ec159caebd3ae22$var$getResolveToMatches(matches) {
    let pathMatches = $5ec159caebd3ae22$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $5ec159caebd3ae22$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $5ec159caebd3ae22$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $5ec159caebd3ae22$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $5ec159caebd3ae22$var$getInvalidPathError("?", "pathname", "search", to));
        $5ec159caebd3ae22$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $5ec159caebd3ae22$var$getInvalidPathError("#", "pathname", "hash", to));
        $5ec159caebd3ae22$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $5ec159caebd3ae22$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $5ec159caebd3ae22$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $5ec159caebd3ae22$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var $5ec159caebd3ae22$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var $5ec159caebd3ae22$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $5ec159caebd3ae22$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $5ec159caebd3ae22$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $5ec159caebd3ae22$export$4051a07651545597(data2, init) {
    return new $5ec159caebd3ae22$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $5ec159caebd3ae22$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $5ec159caebd3ae22$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $5ec159caebd3ae22$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $5ec159caebd3ae22$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $5ec159caebd3ae22$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $5ec159caebd3ae22$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $5ec159caebd3ae22$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $5ec159caebd3ae22$var$getRoutePattern(matches) {
    return matches.map((m)=>m.route.path).filter(Boolean).join("/").replace(/\/\/*/g, "/") || "/";
}
var $5ec159caebd3ae22$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $5ec159caebd3ae22$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$5ec159caebd3ae22$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($5ec159caebd3ae22$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
        let path = $5ec159caebd3ae22$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $5ec159caebd3ae22$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $5ec159caebd3ae22$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $5ec159caebd3ae22$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $5ec159caebd3ae22$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $5ec159caebd3ae22$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$5ec159caebd3ae22$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $5ec159caebd3ae22$var$wrapImpl(aggregated[key], original, (...args)=>$5ec159caebd3ae22$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$5ec159caebd3ae22$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$5ec159caebd3ae22$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $5ec159caebd3ae22$var$wrapImpl(aggregated.middleware, original, (...args)=>$5ec159caebd3ae22$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$5ec159caebd3ae22$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $5ec159caebd3ae22$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$5ec159caebd3ae22$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $5ec159caebd3ae22$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $5ec159caebd3ae22$export$fe53371bee54353d(to) : ".",
                ...$5ec159caebd3ae22$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$5ec159caebd3ae22$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$5ec159caebd3ae22$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $5ec159caebd3ae22$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$5ec159caebd3ae22$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$5ec159caebd3ae22$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $5ec159caebd3ae22$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $5ec159caebd3ae22$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $5ec159caebd3ae22$var$getReadonlyRequest(request),
            context: context != null ? $5ec159caebd3ae22$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $5ec159caebd3ae22$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $5ec159caebd3ae22$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $5ec159caebd3ae22$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $5ec159caebd3ae22$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $5ec159caebd3ae22$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $5ec159caebd3ae22$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, unstable_pattern: unstable_pattern } = args;
    return {
        request: $5ec159caebd3ae22$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        unstable_pattern: unstable_pattern,
        context: $5ec159caebd3ae22$var$getReadonlyContext(context)
    };
}
function $5ec159caebd3ae22$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $5ec159caebd3ae22$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $5ec159caebd3ae22$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $5ec159caebd3ae22$var$getReadonlyContext(context) {
    if ($5ec159caebd3ae22$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $5ec159caebd3ae22$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $5ec159caebd3ae22$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $5ec159caebd3ae22$var$objectProtoNames;
}
// lib/router/router.ts
var $5ec159caebd3ae22$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $5ec159caebd3ae22$var$validMutationMethods = new Set($5ec159caebd3ae22$var$validMutationMethodsArr);
var $5ec159caebd3ae22$var$validRequestMethodsArr = [
    "GET",
    ...$5ec159caebd3ae22$var$validMutationMethodsArr
];
var $5ec159caebd3ae22$var$validRequestMethods = new Set($5ec159caebd3ae22$var$validRequestMethodsArr);
var $5ec159caebd3ae22$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $5ec159caebd3ae22$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $5ec159caebd3ae22$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $5ec159caebd3ae22$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $5ec159caebd3ae22$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $5ec159caebd3ae22$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $5ec159caebd3ae22$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $5ec159caebd3ae22$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $5ec159caebd3ae22$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $5ec159caebd3ae22$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $5ec159caebd3ae22$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.unstable_instrumentations) {
        let instrumentations = init.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$5ec159caebd3ae22$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = $5ec159caebd3ae22$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $5ec159caebd3ae22$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $5ec159caebd3ae22$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $5ec159caebd3ae22$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $5ec159caebd3ae22$var$getShortCircuitMatches(dataRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$5ec159caebd3ae22$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = relevantMatches.every((m)=>{
                let status = $5ec159caebd3ae22$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                return !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $5ec159caebd3ae22$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $5ec159caebd3ae22$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $5ec159caebd3ae22$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $5ec159caebd3ae22$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$5ec159caebd3ae22$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $5ec159caebd3ae22$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $5ec159caebd3ae22$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $5ec159caebd3ae22$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $5ec159caebd3ae22$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $5ec159caebd3ae22$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $5ec159caebd3ae22$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $5ec159caebd3ae22$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $5ec159caebd3ae22$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.unstable_mask) {
            let partialPath = typeof opts.unstable_mask === "string" ? $5ec159caebd3ae22$export$8ccf933b0513f8d0(opts.unstable_mask) : {
                ...state.location.unstable_mask,
                ...opts.unstable_mask
            };
            maskPath = {
                pathname: "",
                search: "",
                hash: "",
                ...partialPath
            };
        }
        let currentLocation = state.location;
        let nextLocation = $5ec159caebd3ae22$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $5ec159caebd3ae22$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $5ec159caebd3ae22$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.unstable_defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $5ec159caebd3ae22$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $5ec159caebd3ae22$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $5ec159caebd3ae22$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $5ec159caebd3ae22$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $5ec159caebd3ae22$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $5ec159caebd3ae22$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $5ec159caebd3ae22$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $5ec159caebd3ae22$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($5ec159caebd3ae22$var$isErrorResult(result) && $5ec159caebd3ae22$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $5ec159caebd3ae22$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $5ec159caebd3ae22$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$5ec159caebd3ae22$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $5ec159caebd3ae22$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $5ec159caebd3ae22$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $5ec159caebd3ae22$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $5ec159caebd3ae22$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $5ec159caebd3ae22$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $5ec159caebd3ae22$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($5ec159caebd3ae22$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $5ec159caebd3ae22$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($5ec159caebd3ae22$var$isErrorResult(result)) {
            let boundaryMatch = $5ec159caebd3ae22$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $5ec159caebd3ae22$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $5ec159caebd3ae22$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $5ec159caebd3ae22$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $5ec159caebd3ae22$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $5ec159caebd3ae22$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $5ec159caebd3ae22$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$5ec159caebd3ae22$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $5ec159caebd3ae22$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $5ec159caebd3ae22$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $5ec159caebd3ae22$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$5ec159caebd3ae22$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $5ec159caebd3ae22$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $5ec159caebd3ae22$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $5ec159caebd3ae22$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $5ec159caebd3ae22$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $5ec159caebd3ae22$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $5ec159caebd3ae22$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $5ec159caebd3ae22$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.unstable_defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $5ec159caebd3ae22$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $5ec159caebd3ae22$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $5ec159caebd3ae22$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $5ec159caebd3ae22$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $5ec159caebd3ae22$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $5ec159caebd3ae22$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($5ec159caebd3ae22$var$isRedirectResult(actionResult) || $5ec159caebd3ae22$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $5ec159caebd3ae22$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($5ec159caebd3ae22$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $5ec159caebd3ae22$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $5ec159caebd3ae22$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($5ec159caebd3ae22$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $5ec159caebd3ae22$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $5ec159caebd3ae22$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $5ec159caebd3ae22$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $5ec159caebd3ae22$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $5ec159caebd3ae22$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $5ec159caebd3ae22$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        if (state.fetchers.has(key)) {
            let doneFetcher = $5ec159caebd3ae22$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let redirect2 = $5ec159caebd3ae22$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $5ec159caebd3ae22$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $5ec159caebd3ae22$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $5ec159caebd3ae22$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $5ec159caebd3ae22$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $5ec159caebd3ae22$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $5ec159caebd3ae22$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $5ec159caebd3ae22$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $5ec159caebd3ae22$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $5ec159caebd3ae22$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $5ec159caebd3ae22$var$getDoneFetcher(void 0));
            return;
        }
        if ($5ec159caebd3ae22$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $5ec159caebd3ae22$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($5ec159caebd3ae22$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $5ec159caebd3ae22$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $5ec159caebd3ae22$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $5ec159caebd3ae22$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $5ec159caebd3ae22$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($5ec159caebd3ae22$var$isAbsoluteUrl(location)) {
                const url = $5ec159caebd3ae22$var$createBrowserURLImpl(location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $5ec159caebd3ae22$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $5ec159caebd3ae22$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($5ec159caebd3ae22$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $5ec159caebd3ae22$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $5ec159caebd3ae22$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $5ec159caebd3ae22$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$5ec159caebd3ae22$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($5ec159caebd3ae22$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $5ec159caebd3ae22$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $5ec159caebd3ae22$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $5ec159caebd3ae22$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $5ec159caebd3ae22$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $5ec159caebd3ae22$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $5ec159caebd3ae22$var$getDoneFetcher(null));
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $5ec159caebd3ae22$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $5ec159caebd3ae22$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $5ec159caebd3ae22$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $5ec159caebd3ae22$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $5ec159caebd3ae22$export$386d57f03f0b2883;
        $5ec159caebd3ae22$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $5ec159caebd3ae22$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $5ec159caebd3ae22$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $5ec159caebd3ae22$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $5ec159caebd3ae22$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$5ec159caebd3ae22$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) {
                let fogMatches = $5ec159caebd3ae22$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $5ec159caebd3ae22$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $5ec159caebd3ae22$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $5ec159caebd3ae22$export$2708184779ceb39d(routesToUse, pathname, basename);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $5ec159caebd3ae22$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $5ec159caebd3ae22$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $5ec159caebd3ae22$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $5ec159caebd3ae22$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.unstable_instrumentations) router = $5ec159caebd3ae22$var$instrumentClientSideRouter(router, init.unstable_instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $5ec159caebd3ae22$export$3336b097a6fbc59a(routes, opts) {
    $5ec159caebd3ae22$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $5ec159caebd3ae22$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (opts?.unstable_instrumentations) {
        let instrumentations = opts.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$5ec159caebd3ae22$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $5ec159caebd3ae22$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $5ec159caebd3ae22$var$createLocation("", $5ec159caebd3ae22$export$fe53371bee54353d(url), null, "default");
        let matches = $5ec159caebd3ae22$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $5ec159caebd3ae22$export$b8d3e69d4b3eff04();
        if (!$5ec159caebd3ae22$var$isValidMethod(method) && method !== "HEAD") {
            let error = $5ec159caebd3ae22$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $5ec159caebd3ae22$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $5ec159caebd3ae22$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $5ec159caebd3ae22$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $5ec159caebd3ae22$export$f5708dca728d7177(requestContext instanceof $5ec159caebd3ae22$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $5ec159caebd3ae22$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $5ec159caebd3ae22$var$runServerMiddlewarePipeline({
                    request: request,
                    unstable_pattern: $5ec159caebd3ae22$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($5ec159caebd3ae22$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($5ec159caebd3ae22$export$6e80290866a84dd4(error)) return error;
                    if ($5ec159caebd3ae22$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $5ec159caebd3ae22$export$f2680fa305b734ca(error.status, error.statusText, await $5ec159caebd3ae22$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($5ec159caebd3ae22$export$e0163cfdf7bc9cfa(error)) error = $5ec159caebd3ae22$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $5ec159caebd3ae22$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $5ec159caebd3ae22$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $5ec159caebd3ae22$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $5ec159caebd3ae22$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $5ec159caebd3ae22$export$f5708dca728d7177($5ec159caebd3ae22$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($5ec159caebd3ae22$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($5ec159caebd3ae22$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $5ec159caebd3ae22$var$createLocation("", $5ec159caebd3ae22$export$fe53371bee54353d(url), null, "default");
        let matches = $5ec159caebd3ae22$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $5ec159caebd3ae22$export$b8d3e69d4b3eff04();
        if (!$5ec159caebd3ae22$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $5ec159caebd3ae22$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $5ec159caebd3ae22$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $5ec159caebd3ae22$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $5ec159caebd3ae22$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $5ec159caebd3ae22$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $5ec159caebd3ae22$export$f5708dca728d7177(requestContext instanceof $5ec159caebd3ae22$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $5ec159caebd3ae22$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $5ec159caebd3ae22$var$runServerMiddlewarePipeline({
                request: request,
                unstable_pattern: $5ec159caebd3ae22$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $5ec159caebd3ae22$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($5ec159caebd3ae22$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($5ec159caebd3ae22$var$dataWithResponseInitToResponse(error));
                if ($5ec159caebd3ae22$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($5ec159caebd3ae22$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $5ec159caebd3ae22$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($5ec159caebd3ae22$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, matches, routeMatch || $5ec159caebd3ae22$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $5ec159caebd3ae22$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($5ec159caebd3ae22$var$isDataStrategyResult(e) && $5ec159caebd3ae22$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($5ec159caebd3ae22$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $5ec159caebd3ae22$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $5ec159caebd3ae22$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $5ec159caebd3ae22$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($5ec159caebd3ae22$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($5ec159caebd3ae22$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($5ec159caebd3ae22$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $5ec159caebd3ae22$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $5ec159caebd3ae22$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($5ec159caebd3ae22$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $5ec159caebd3ae22$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $5ec159caebd3ae22$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $5ec159caebd3ae22$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $5ec159caebd3ae22$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $5ec159caebd3ae22$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $5ec159caebd3ae22$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $5ec159caebd3ae22$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, false);
                return $5ec159caebd3ae22$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $5ec159caebd3ae22$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $5ec159caebd3ae22$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $5ec159caebd3ae22$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $5ec159caebd3ae22$var$callDataStrategyImpl(dataStrategy || $5ec159caebd3ae22$var$defaultDataStrategy, request, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($5ec159caebd3ae22$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $5ec159caebd3ae22$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($5ec159caebd3ae22$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($5ec159caebd3ae22$export$e0163cfdf7bc9cfa(result.result)) throw $5ec159caebd3ae22$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $5ec159caebd3ae22$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $5ec159caebd3ae22$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $5ec159caebd3ae22$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $5ec159caebd3ae22$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $5ec159caebd3ae22$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $5ec159caebd3ae22$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $5ec159caebd3ae22$var$resolveTo(to ? to : ".", $5ec159caebd3ae22$var$getResolveToMatches(contextualMatches), $5ec159caebd3ae22$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $5ec159caebd3ae22$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $5ec159caebd3ae22$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $5ec159caebd3ae22$export$fe53371bee54353d(path);
}
function $5ec159caebd3ae22$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$5ec159caebd3ae22$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$5ec159caebd3ae22$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $5ec159caebd3ae22$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $5ec159caebd3ae22$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $5ec159caebd3ae22$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$5ec159caebd3ae22$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$5ec159caebd3ae22$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $5ec159caebd3ae22$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $5ec159caebd3ae22$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $5ec159caebd3ae22$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $5ec159caebd3ae22$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $5ec159caebd3ae22$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($5ec159caebd3ae22$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $5ec159caebd3ae22$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $5ec159caebd3ae22$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $5ec159caebd3ae22$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $5ec159caebd3ae22$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $5ec159caebd3ae22$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $5ec159caebd3ae22$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $5ec159caebd3ae22$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$5ec159caebd3ae22$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $5ec159caebd3ae22$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($5ec159caebd3ae22$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $5ec159caebd3ae22$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($5ec159caebd3ae22$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $5ec159caebd3ae22$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $5ec159caebd3ae22$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $5ec159caebd3ae22$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $5ec159caebd3ae22$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $5ec159caebd3ae22$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $5ec159caebd3ae22$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $5ec159caebd3ae22$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($5ec159caebd3ae22$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $5ec159caebd3ae22$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $5ec159caebd3ae22$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $5ec159caebd3ae22$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$5ec159caebd3ae22$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $5ec159caebd3ae22$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $5ec159caebd3ae22$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $5ec159caebd3ae22$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $5ec159caebd3ae22$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $5ec159caebd3ae22$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$5ec159caebd3ae22$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $5ec159caebd3ae22$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $5ec159caebd3ae22$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
}
function $5ec159caebd3ae22$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$5ec159caebd3ae22$var$isSameRoute(aChild, bChild))) ?? false;
}
var $5ec159caebd3ae22$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $5ec159caebd3ae22$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $5ec159caebd3ae22$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $5ec159caebd3ae22$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $5ec159caebd3ae22$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $5ec159caebd3ae22$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $5ec159caebd3ae22$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $5ec159caebd3ae22$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $5ec159caebd3ae22$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $5ec159caebd3ae22$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $5ec159caebd3ae22$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $5ec159caebd3ae22$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $5ec159caebd3ae22$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $5ec159caebd3ae22$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $5ec159caebd3ae22$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $5ec159caebd3ae22$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $5ec159caebd3ae22$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $5ec159caebd3ae22$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $5ec159caebd3ae22$var$isNonNullable(value) {
    return value !== void 0;
}
function $5ec159caebd3ae22$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $5ec159caebd3ae22$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($5ec159caebd3ae22$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $5ec159caebd3ae22$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $5ec159caebd3ae22$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $5ec159caebd3ae22$var$defaultDataStrategy(args);
    return $5ec159caebd3ae22$var$runClientMiddlewarePipeline(args, ()=>$5ec159caebd3ae22$var$defaultDataStrategy(args));
}
function $5ec159caebd3ae22$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $5ec159caebd3ae22$var$runMiddlewarePipeline(args, handler, processResult, $5ec159caebd3ae22$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $5ec159caebd3ae22$export$e0163cfdf7bc9cfa(result) ? $5ec159caebd3ae22$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $5ec159caebd3ae22$var$runClientMiddlewarePipeline(args, handler) {
    return $5ec159caebd3ae22$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($5ec159caebd3ae22$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $5ec159caebd3ae22$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $5ec159caebd3ae22$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $5ec159caebd3ae22$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, request: request, params: params, context: context, unstable_pattern: unstable_pattern } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $5ec159caebd3ae22$var$callRouteMiddleware({
        request: request,
        params: params,
        context: context,
        unstable_pattern: unstable_pattern
    }, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $5ec159caebd3ae22$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $5ec159caebd3ae22$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $5ec159caebd3ae22$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $5ec159caebd3ae22$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $5ec159caebd3ae22$var$loadLazyRoute(match.route, $5ec159caebd3ae22$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $5ec159caebd3ae22$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, unstable_pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $5ec159caebd3ae22$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $5ec159caebd3ae22$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $5ec159caebd3ae22$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $5ec159caebd3ae22$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$5ec159caebd3ae22$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($5ec159caebd3ae22$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $5ec159caebd3ae22$var$callLoaderOrAction({
                request: request,
                unstable_pattern: unstable_pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $5ec159caebd3ae22$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $5ec159caebd3ae22$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $5ec159caebd3ae22$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, $5ec159caebd3ae22$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $5ec159caebd3ae22$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        unstable_pattern: $5ec159caebd3ae22$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $5ec159caebd3ae22$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $5ec159caebd3ae22$var$callLoaderOrAction({ request: request, unstable_pattern: unstable_pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $5ec159caebd3ae22$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                unstable_pattern: unstable_pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $5ec159caebd3ae22$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $5ec159caebd3ae22$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $5ec159caebd3ae22$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $5ec159caebd3ae22$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($5ec159caebd3ae22$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $5ec159caebd3ae22$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $5ec159caebd3ae22$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($5ec159caebd3ae22$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $5ec159caebd3ae22$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $5ec159caebd3ae22$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $5ec159caebd3ae22$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($5ec159caebd3ae22$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $5ec159caebd3ae22$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $5ec159caebd3ae22$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$5ec159caebd3ae22$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $5ec159caebd3ae22$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function $5ec159caebd3ae22$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($5ec159caebd3ae22$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $5ec159caebd3ae22$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $5ec159caebd3ae22$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($5ec159caebd3ae22$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $5ec159caebd3ae22$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $5ec159caebd3ae22$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $5ec159caebd3ae22$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $5ec159caebd3ae22$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $5ec159caebd3ae22$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $5ec159caebd3ae22$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $5ec159caebd3ae22$export$f5708dca728d7177(!$5ec159caebd3ae22$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($5ec159caebd3ae22$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $5ec159caebd3ae22$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $5ec159caebd3ae22$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $5ec159caebd3ae22$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $5ec159caebd3ae22$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $5ec159caebd3ae22$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $5ec159caebd3ae22$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($5ec159caebd3ae22$var$isErrorResult(result)) {
            let boundaryMatch = $5ec159caebd3ae22$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($5ec159caebd3ae22$var$isRedirectResult(result)) $5ec159caebd3ae22$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $5ec159caebd3ae22$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $5ec159caebd3ae22$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $5ec159caebd3ae22$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $5ec159caebd3ae22$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $5ec159caebd3ae22$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $5ec159caebd3ae22$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $5ec159caebd3ae22$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $5ec159caebd3ae22$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $5ec159caebd3ae22$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $5ec159caebd3ae22$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($5ec159caebd3ae22$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $5ec159caebd3ae22$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $5ec159caebd3ae22$export$8ccf933b0513f8d0(path) : path;
    return $5ec159caebd3ae22$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $5ec159caebd3ae22$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $5ec159caebd3ae22$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $5ec159caebd3ae22$var$dataWithResponseInitToErrorResponse(data2) {
    return new $5ec159caebd3ae22$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $5ec159caebd3ae22$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $5ec159caebd3ae22$var$isDataStrategyResult(value));
}
function $5ec159caebd3ae22$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $5ec159caebd3ae22$var$isRedirectDataStrategyResult(result) {
    return $5ec159caebd3ae22$export$3f1eb41d9a6a6a27(result.result) && $5ec159caebd3ae22$var$redirectStatusCodes.has(result.result.status);
}
function $5ec159caebd3ae22$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $5ec159caebd3ae22$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $5ec159caebd3ae22$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $5ec159caebd3ae22$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $5ec159caebd3ae22$export$794b2760043cf8cd(statusCode) {
    return $5ec159caebd3ae22$var$redirectStatusCodes.has(statusCode);
}
function $5ec159caebd3ae22$export$6e80290866a84dd4(result) {
    return $5ec159caebd3ae22$export$3f1eb41d9a6a6a27(result) && $5ec159caebd3ae22$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $5ec159caebd3ae22$var$isValidMethod(method) {
    return $5ec159caebd3ae22$var$validRequestMethods.has(method.toUpperCase());
}
function $5ec159caebd3ae22$export$cbae47800eb95bc3(method) {
    return $5ec159caebd3ae22$var$validMutationMethods.has(method.toUpperCase());
}
function $5ec159caebd3ae22$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $5ec159caebd3ae22$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $5ec159caebd3ae22$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $5ec159caebd3ae22$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $5ec159caebd3ae22$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $5ec159caebd3ae22$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $5ec159caebd3ae22$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $5ec159caebd3ae22$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $5ec159caebd3ae22$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $5ec159caebd3ae22$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $5ec159caebd3ae22$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $5ec159caebd3ae22$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($5ec159caebd3ae22$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $5ec159caebd3ae22$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($5ec159caebd3ae22$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $5ec159caebd3ae22$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $5ec159caebd3ae22$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $5ec159caebd3ae22$export$2eeee58951ff3c1c = $7fPBF.createContext(null);
$5ec159caebd3ae22$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $5ec159caebd3ae22$export$315e3ffb01f217 = $7fPBF.createContext(null);
$5ec159caebd3ae22$export$315e3ffb01f217.displayName = "DataRouterState";
var $5ec159caebd3ae22$export$717f757c655223f1 = $7fPBF.createContext(false);
function $5ec159caebd3ae22$var$useIsRSCRouterContext() {
    return $7fPBF.useContext($5ec159caebd3ae22$export$717f757c655223f1);
}
var $5ec159caebd3ae22$export$3681f408decb40d1 = $7fPBF.createContext({
    isTransitioning: false
});
$5ec159caebd3ae22$export$3681f408decb40d1.displayName = "ViewTransition";
var $5ec159caebd3ae22$export$cb3f1df1bef00a39 = $7fPBF.createContext(/* @__PURE__ */ new Map());
$5ec159caebd3ae22$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $5ec159caebd3ae22$var$AwaitContext = $7fPBF.createContext(null);
$5ec159caebd3ae22$var$AwaitContext.displayName = "Await";
var $5ec159caebd3ae22$export$2666c20e15407622 = (props)=>$7fPBF.createElement($5ec159caebd3ae22$var$AwaitContext.Provider, props);
var $5ec159caebd3ae22$export$3044ab7fdabeaee6 = $7fPBF.createContext(null);
$5ec159caebd3ae22$export$3044ab7fdabeaee6.displayName = "Navigation";
var $5ec159caebd3ae22$export$e6a44b110a0c44d3 = $7fPBF.createContext(null);
$5ec159caebd3ae22$export$e6a44b110a0c44d3.displayName = "Location";
var $5ec159caebd3ae22$export$aac280ed165a4397 = $7fPBF.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$5ec159caebd3ae22$export$aac280ed165a4397.displayName = "Route";
var $5ec159caebd3ae22$var$RouteErrorContext = $7fPBF.createContext(null);
$5ec159caebd3ae22$var$RouteErrorContext.displayName = "RouteError";
var $5ec159caebd3ae22$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $5ec159caebd3ae22$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $5ec159caebd3ae22$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $5ec159caebd3ae22$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $5ec159caebd3ae22$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$5ec159caebd3ae22$var$ERROR_DIGEST_BASE}:${$5ec159caebd3ae22$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $5ec159caebd3ae22$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$5ec159caebd3ae22$var$ERROR_DIGEST_BASE}:${$5ec159caebd3ae22$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $5ec159caebd3ae22$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $5ec159caebd3ae22$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $5ec159caebd3ae22$export$f5708dca728d7177($5ec159caebd3ae22$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $7fPBF.useContext($5ec159caebd3ae22$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $5ec159caebd3ae22$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $5ec159caebd3ae22$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $5ec159caebd3ae22$export$9c954a9d03d32f4a() {
    return $7fPBF.useContext($5ec159caebd3ae22$export$e6a44b110a0c44d3) != null;
}
function $5ec159caebd3ae22$export$45d76561a5302f2b() {
    $5ec159caebd3ae22$export$f5708dca728d7177($5ec159caebd3ae22$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $7fPBF.useContext($5ec159caebd3ae22$export$e6a44b110a0c44d3).location;
}
function $5ec159caebd3ae22$export$1b3f31771c5d07c() {
    return $7fPBF.useContext($5ec159caebd3ae22$export$e6a44b110a0c44d3).navigationType;
}
function $5ec159caebd3ae22$export$6c330e8992e8a295(pattern) {
    $5ec159caebd3ae22$export$f5708dca728d7177($5ec159caebd3ae22$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $5ec159caebd3ae22$export$45d76561a5302f2b();
    return $7fPBF.useMemo(()=>$5ec159caebd3ae22$export$81336c211d5ff295(pattern, $5ec159caebd3ae22$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $5ec159caebd3ae22$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $5ec159caebd3ae22$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $7fPBF.useContext($5ec159caebd3ae22$export$3044ab7fdabeaee6).static;
    if (!isStatic) $7fPBF.useLayoutEffect(cb);
}
function $5ec159caebd3ae22$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $7fPBF.useContext($5ec159caebd3ae22$export$aac280ed165a4397);
    return isDataRoute ? $5ec159caebd3ae22$var$useNavigateStable() : $5ec159caebd3ae22$var$useNavigateUnstable();
}
function $5ec159caebd3ae22$var$useNavigateUnstable() {
    $5ec159caebd3ae22$export$f5708dca728d7177($5ec159caebd3ae22$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $7fPBF.useContext($5ec159caebd3ae22$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $7fPBF.useContext($5ec159caebd3ae22$export$3044ab7fdabeaee6);
    let { matches: matches } = $7fPBF.useContext($5ec159caebd3ae22$export$aac280ed165a4397);
    let { pathname: locationPathname } = $5ec159caebd3ae22$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($5ec159caebd3ae22$var$getResolveToMatches(matches));
    let activeRef = $7fPBF.useRef(false);
    $5ec159caebd3ae22$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback((to, options = {})=>{
        $5ec159caebd3ae22$var$warning(activeRef.current, $5ec159caebd3ae22$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $5ec159caebd3ae22$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $5ec159caebd3ae22$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $5ec159caebd3ae22$var$OutletContext = $7fPBF.createContext(null);
function $5ec159caebd3ae22$export$4138103a3ae699cc() {
    return $7fPBF.useContext($5ec159caebd3ae22$var$OutletContext);
}
function $5ec159caebd3ae22$export$a3be3530d8e40d0b(context) {
    let outlet = $7fPBF.useContext($5ec159caebd3ae22$export$aac280ed165a4397).outlet;
    return $7fPBF.useMemo(()=>outlet && /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $5ec159caebd3ae22$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $7fPBF.useContext($5ec159caebd3ae22$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function $5ec159caebd3ae22$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $7fPBF.useContext($5ec159caebd3ae22$export$aac280ed165a4397);
    let { pathname: locationPathname } = $5ec159caebd3ae22$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($5ec159caebd3ae22$var$getResolveToMatches(matches));
    return $7fPBF.useMemo(()=>$5ec159caebd3ae22$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $5ec159caebd3ae22$export$5d3fca4a98652595(routes, locationArg) {
    return $5ec159caebd3ae22$var$useRoutesImpl(routes, locationArg);
}
function $5ec159caebd3ae22$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $5ec159caebd3ae22$export$f5708dca728d7177($5ec159caebd3ae22$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $7fPBF.useContext($5ec159caebd3ae22$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $7fPBF.useContext($5ec159caebd3ae22$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($5ec159caebd3ae22$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $5ec159caebd3ae22$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $5ec159caebd3ae22$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $5ec159caebd3ae22$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $5ec159caebd3ae22$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = $5ec159caebd3ae22$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($5ec159caebd3ae22$export$945fecf35a8ef089) {
        $5ec159caebd3ae22$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $5ec159caebd3ae22$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $5ec159caebd3ae22$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $5ec159caebd3ae22$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $5ec159caebd3ae22$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                unstable_mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $5ec159caebd3ae22$var$DefaultErrorComponent() {
    let error = $5ec159caebd3ae22$export$ed527bf60f6e05f2();
    let message = $5ec159caebd3ae22$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($5ec159caebd3ae22$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $7fPBF.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $7fPBF.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $7fPBF.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $7fPBF.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $7fPBF.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $5ec159caebd3ae22$var$defaultErrorElement = /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$var$DefaultErrorComponent, null);
var $5ec159caebd3ae22$var$RenderErrorBoundary = class extends $7fPBF.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $5ec159caebd3ae22$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$5ec159caebd3ae22$var$RenderErrorBoundary.contextType = $5ec159caebd3ae22$export$717f757c655223f1;
var $5ec159caebd3ae22$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $5ec159caebd3ae22$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename } = $7fPBF.useContext($5ec159caebd3ae22$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $5ec159caebd3ae22$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $5ec159caebd3ae22$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $5ec159caebd3ae22$var$parseToInfo(redirect2.location, basename);
            if ($5ec159caebd3ae22$var$isBrowser && !$5ec159caebd3ae22$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = parsed.absoluteURL || parsed.to;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $5ec159caebd3ae22$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $7fPBF.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${parsed.absoluteURL || parsed.to}`
            });
        }
    }
    return children;
}
function $5ec159caebd3ae22$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $7fPBF.useContext($5ec159caebd3ae22$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $5ec159caebd3ae22$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $5ec159caebd3ae22$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            unstable_pattern: $5ec159caebd3ae22$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $5ec159caebd3ae22$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $5ec159caebd3ae22$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $7fPBF.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $5ec159caebd3ae22$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $5ec159caebd3ae22$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext($5ec159caebd3ae22$export$2eeee58951ff3c1c);
    $5ec159caebd3ae22$export$f5708dca728d7177(ctx, $5ec159caebd3ae22$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $5ec159caebd3ae22$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext($5ec159caebd3ae22$export$315e3ffb01f217);
    $5ec159caebd3ae22$export$f5708dca728d7177(state, $5ec159caebd3ae22$var$getDataRouterConsoleError(hookName));
    return state;
}
function $5ec159caebd3ae22$var$useRouteContext(hookName) {
    let route = $7fPBF.useContext($5ec159caebd3ae22$export$aac280ed165a4397);
    $5ec159caebd3ae22$export$f5708dca728d7177(route, $5ec159caebd3ae22$var$getDataRouterConsoleError(hookName));
    return route;
}
function $5ec159caebd3ae22$var$useCurrentRouteId(hookName) {
    let route = $5ec159caebd3ae22$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $5ec159caebd3ae22$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $5ec159caebd3ae22$var$useRouteId() {
    return $5ec159caebd3ae22$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $5ec159caebd3ae22$export$d0fd4b7106de2769() {
    let state = $5ec159caebd3ae22$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $5ec159caebd3ae22$export$600dc272ed516c15() {
    let dataRouterContext = $5ec159caebd3ae22$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $5ec159caebd3ae22$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $7fPBF.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $7fPBF.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $5ec159caebd3ae22$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $5ec159caebd3ae22$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $7fPBF.useMemo(()=>matches.map((m)=>$5ec159caebd3ae22$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $5ec159caebd3ae22$export$1448a5050d252c4d() {
    let state = $5ec159caebd3ae22$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $5ec159caebd3ae22$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $5ec159caebd3ae22$export$fd5d37484eab868d(routeId) {
    let state = $5ec159caebd3ae22$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $5ec159caebd3ae22$export$fdc00f3f26066d5e() {
    let state = $5ec159caebd3ae22$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $5ec159caebd3ae22$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $5ec159caebd3ae22$export$ed527bf60f6e05f2() {
    let error = $7fPBF.useContext($5ec159caebd3ae22$var$RouteErrorContext);
    let state = $5ec159caebd3ae22$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $5ec159caebd3ae22$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $5ec159caebd3ae22$export$78a72ddb39bdd145() {
    let value = $7fPBF.useContext($5ec159caebd3ae22$var$AwaitContext);
    return value?._data;
}
function $5ec159caebd3ae22$export$17f53340677d5831() {
    let value = $7fPBF.useContext($5ec159caebd3ae22$var$AwaitContext);
    return value?._error;
}
var $5ec159caebd3ae22$var$blockerId = 0;
function $5ec159caebd3ae22$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $5ec159caebd3ae22$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $5ec159caebd3ae22$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $7fPBF.useState("");
    let blockerFunction = $7fPBF.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $5ec159caebd3ae22$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $5ec159caebd3ae22$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $7fPBF.useEffect(()=>{
        let key = String(++$5ec159caebd3ae22$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $7fPBF.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $5ec159caebd3ae22$export$386d57f03f0b2883;
}
function $5ec159caebd3ae22$var$useNavigateStable() {
    let { router: router } = $5ec159caebd3ae22$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $5ec159caebd3ae22$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $7fPBF.useRef(false);
    $5ec159caebd3ae22$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback(async (to, options = {})=>{
        $5ec159caebd3ae22$var$warning(activeRef.current, $5ec159caebd3ae22$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $5ec159caebd3ae22$var$alreadyWarned = {};
function $5ec159caebd3ae22$var$warningOnce(key, cond, message) {
    if (!cond && !$5ec159caebd3ae22$var$alreadyWarned[key]) {
        $5ec159caebd3ae22$var$alreadyWarned[key] = true;
        $5ec159caebd3ae22$var$warning(false, message);
    }
}
function $5ec159caebd3ae22$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $5ec159caebd3ae22$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $5ec159caebd3ae22$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
// lib/server-runtime/warnings.ts
var $5ec159caebd3ae22$var$alreadyWarned2 = {};
function $5ec159caebd3ae22$export$5b28268982f175ba(condition, message) {
    if (!condition && !$5ec159caebd3ae22$var$alreadyWarned2[message]) {
        $5ec159caebd3ae22$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $5ec159caebd3ae22$var$USE_OPTIMISTIC = "useOptimistic";
var $5ec159caebd3ae22$var$useOptimisticImpl = $7fPBF[$5ec159caebd3ae22$var$USE_OPTIMISTIC];
var $5ec159caebd3ae22$var$stableUseOptimisticSetter = ()=>void 0;
function $5ec159caebd3ae22$var$useOptimisticSafe(val) {
    if ($5ec159caebd3ae22$var$useOptimisticImpl) return $5ec159caebd3ae22$var$useOptimisticImpl(val);
    else return [
        val,
        $5ec159caebd3ae22$var$stableUseOptimisticSetter
    ];
}
function $5ec159caebd3ae22$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($5ec159caebd3ae22$export$945fecf35a8ef089) {
            if (route.element) $5ec159caebd3ae22$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $7fPBF.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($5ec159caebd3ae22$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $5ec159caebd3ae22$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $7fPBF.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($5ec159caebd3ae22$export$945fecf35a8ef089) {
            if (route.errorElement) $5ec159caebd3ae22$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $7fPBF.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $5ec159caebd3ae22$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $5ec159caebd3ae22$export$f30f7e456d254e83(routes, opts) {
    return $5ec159caebd3ae22$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $5ec159caebd3ae22$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $5ec159caebd3ae22$export$e2fd2c03906469db,
        mapRouteProperties: $5ec159caebd3ae22$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
var $5ec159caebd3ae22$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $5ec159caebd3ae22$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, unstable_useTransitions: unstable_useTransitions }) {
    let unstable_rsc = $5ec159caebd3ae22$var$useIsRSCRouterContext();
    unstable_useTransitions = unstable_rsc || unstable_useTransitions;
    let [_state, setStateImpl] = $7fPBF.useState(router.state);
    let [state, setOptimisticState] = $5ec159caebd3ae22$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $7fPBF.useState();
    let [vtContext, setVtContext] = $7fPBF.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $7fPBF.useState();
    let [transition, setTransition] = $7fPBF.useState();
    let [interruption, setInterruption] = $7fPBF.useState();
    let fetcherData = $7fPBF.useRef(/* @__PURE__ */ new Map());
    let setState = $7fPBF.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                unstable_pattern: $5ec159caebd3ae22$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $5ec159caebd3ae22$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $5ec159caebd3ae22$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (unstable_useTransitions === false) setStateImpl(newState);
            else $7fPBF.startTransition(()=>{
                if (unstable_useTransitions === true) setOptimisticState((s)=>$5ec159caebd3ae22$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        unstable_useTransitions,
        setOptimisticState,
        onError
    ]);
    $7fPBF.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $7fPBF.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $5ec159caebd3ae22$var$Deferred());
    }, [
        vtContext
    ]);
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (unstable_useTransitions === false) setStateImpl(newState);
                else $7fPBF.startTransition(()=>{
                    if (unstable_useTransitions === true) setOptimisticState((s)=>$5ec159caebd3ae22$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        unstable_useTransitions,
        setOptimisticState
    ]);
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $7fPBF.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $7fPBF.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7fPBF.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        unstable_useTransitions: unstable_useTransitions
    }, /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $5ec159caebd3ae22$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $5ec159caebd3ae22$var$MemoizedDataRoutes = $7fPBF.memo($5ec159caebd3ae22$var$DataRoutes);
function $5ec159caebd3ae22$var$DataRoutes({ routes: routes, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $5ec159caebd3ae22$var$useRoutesImpl(routes, void 0, {
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $5ec159caebd3ae22$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, unstable_useTransitions: unstable_useTransitions }) {
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = $5ec159caebd3ae22$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7fPBF.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $7fPBF.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $5ec159caebd3ae22$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $5ec159caebd3ae22$export$f5708dca728d7177($5ec159caebd3ae22$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $7fPBF.useContext($5ec159caebd3ae22$export$3044ab7fdabeaee6);
    $5ec159caebd3ae22$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $7fPBF.useContext($5ec159caebd3ae22$export$aac280ed165a4397);
    let { pathname: locationPathname } = $5ec159caebd3ae22$export$45d76561a5302f2b();
    let navigate = $5ec159caebd3ae22$export$9770f232ac06a008();
    let path = $5ec159caebd3ae22$var$resolveTo(to, $5ec159caebd3ae22$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $7fPBF.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $5ec159caebd3ae22$export$910ae8079b2c2852(props) {
    return $5ec159caebd3ae22$export$a3be3530d8e40d0b(props.context);
}
function $5ec159caebd3ae22$export$e7b0ac011bb776c6(props) {
    $5ec159caebd3ae22$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $5ec159caebd3ae22$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, unstable_useTransitions: unstable_useTransitions }) {
    $5ec159caebd3ae22$export$f5708dca728d7177(!$5ec159caebd3ae22$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $7fPBF.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            unstable_useTransitions: unstable_useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        unstable_useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $5ec159caebd3ae22$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", unstable_mask: unstable_mask } = locationProp;
    let locationContext = $7fPBF.useMemo(()=>{
        let trailingPathname = $5ec159caebd3ae22$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                unstable_mask: unstable_mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        unstable_mask
    ]);
    $5ec159caebd3ae22$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $5ec159caebd3ae22$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $5ec159caebd3ae22$export$5d3fca4a98652595($5ec159caebd3ae22$export$16da398f5434bdec(children), location);
}
function $5ec159caebd3ae22$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $7fPBF.useContext($5ec159caebd3ae22$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $7fPBF.useContext($5ec159caebd3ae22$export$315e3ffb01f217);
    let onError = $7fPBF.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            unstable_pattern: $5ec159caebd3ae22$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$var$ResolveAwait, null, children));
}
var $5ec159caebd3ae22$var$AwaitErrorBoundary = class extends $7fPBF.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $5ec159caebd3ae22$var$ResolveAwait({ children: children }) {
    let data2 = $5ec159caebd3ae22$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, toRender);
}
function $5ec159caebd3ae22$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $7fPBF.Children.forEach(children, (element, index)=>{
        if (!$7fPBF.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $7fPBF.Fragment) {
            routes.push.apply(routes, $5ec159caebd3ae22$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $5ec159caebd3ae22$export$f5708dca728d7177(element.type === $5ec159caebd3ae22$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $5ec159caebd3ae22$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $5ec159caebd3ae22$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $5ec159caebd3ae22$export$9b5b6d122dea0c88 = $5ec159caebd3ae22$export$16da398f5434bdec;
function $5ec159caebd3ae22$export$daf73786167a7f72(matches) {
    return $5ec159caebd3ae22$var$_renderMatches(matches);
}
function $5ec159caebd3ae22$var$useRouteComponentProps() {
    return {
        params: $5ec159caebd3ae22$export$99eaa27ddbbb95ef(),
        loaderData: $5ec159caebd3ae22$export$1448a5050d252c4d(),
        actionData: $5ec159caebd3ae22$export$fdc00f3f26066d5e(),
        matches: $5ec159caebd3ae22$export$2378eb7f5ff86053()
    };
}
function $5ec159caebd3ae22$export$6c4f3826290c37af({ children: children }) {
    const props = $5ec159caebd3ae22$var$useRouteComponentProps();
    return $7fPBF.cloneElement(children, props);
}
function $5ec159caebd3ae22$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $5ec159caebd3ae22$var$useRouteComponentProps();
        return $7fPBF.createElement(Component4, props);
    };
}
function $5ec159caebd3ae22$var$useHydrateFallbackProps() {
    return {
        params: $5ec159caebd3ae22$export$99eaa27ddbbb95ef(),
        loaderData: $5ec159caebd3ae22$export$1448a5050d252c4d(),
        actionData: $5ec159caebd3ae22$export$fdc00f3f26066d5e()
    };
}
function $5ec159caebd3ae22$export$f8cff34f39c1932a({ children: children }) {
    const props = $5ec159caebd3ae22$var$useHydrateFallbackProps();
    return $7fPBF.cloneElement(children, props);
}
function $5ec159caebd3ae22$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $5ec159caebd3ae22$var$useHydrateFallbackProps();
        return $7fPBF.createElement(HydrateFallback, props);
    };
}
function $5ec159caebd3ae22$var$useErrorBoundaryProps() {
    return {
        params: $5ec159caebd3ae22$export$99eaa27ddbbb95ef(),
        loaderData: $5ec159caebd3ae22$export$1448a5050d252c4d(),
        actionData: $5ec159caebd3ae22$export$fdc00f3f26066d5e(),
        error: $5ec159caebd3ae22$export$ed527bf60f6e05f2()
    };
}
function $5ec159caebd3ae22$export$e5afde5c4b6d747b({ children: children }) {
    const props = $5ec159caebd3ae22$var$useErrorBoundaryProps();
    return $7fPBF.cloneElement(children, props);
}
function $5ec159caebd3ae22$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $5ec159caebd3ae22$var$useErrorBoundaryProps();
        return $7fPBF.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $5ec159caebd3ae22$var$defaultMethod = "get";
var $5ec159caebd3ae22$var$defaultEncType = "application/x-www-form-urlencoded";
function $5ec159caebd3ae22$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $5ec159caebd3ae22$var$isButtonElement(object) {
    return $5ec159caebd3ae22$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $5ec159caebd3ae22$var$isFormElement(object) {
    return $5ec159caebd3ae22$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $5ec159caebd3ae22$var$isInputElement(object) {
    return $5ec159caebd3ae22$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $5ec159caebd3ae22$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $5ec159caebd3ae22$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$5ec159caebd3ae22$var$isModifiedEvent(event);
}
function $5ec159caebd3ae22$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $5ec159caebd3ae22$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $5ec159caebd3ae22$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $5ec159caebd3ae22$var$_formDataSupportsSubmitter = null;
function $5ec159caebd3ae22$var$isFormDataSubmitterSupported() {
    if ($5ec159caebd3ae22$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $5ec159caebd3ae22$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $5ec159caebd3ae22$var$_formDataSupportsSubmitter = true;
    }
    return $5ec159caebd3ae22$var$_formDataSupportsSubmitter;
}
var $5ec159caebd3ae22$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $5ec159caebd3ae22$var$getFormEncType(encType) {
    if (encType != null && !$5ec159caebd3ae22$var$supportedFormEncTypes.has(encType)) {
        $5ec159caebd3ae22$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$5ec159caebd3ae22$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $5ec159caebd3ae22$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($5ec159caebd3ae22$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $5ec159caebd3ae22$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $5ec159caebd3ae22$var$defaultMethod;
        encType = $5ec159caebd3ae22$var$getFormEncType(target.getAttribute("enctype")) || $5ec159caebd3ae22$var$defaultEncType;
        formData = new FormData(target);
    } else if ($5ec159caebd3ae22$var$isButtonElement(target) || $5ec159caebd3ae22$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $5ec159caebd3ae22$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $5ec159caebd3ae22$var$defaultMethod;
        encType = $5ec159caebd3ae22$var$getFormEncType(target.getAttribute("formenctype")) || $5ec159caebd3ae22$var$getFormEncType(form.getAttribute("enctype")) || $5ec159caebd3ae22$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$5ec159caebd3ae22$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($5ec159caebd3ae22$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $5ec159caebd3ae22$var$defaultMethod;
        action = null;
        encType = $5ec159caebd3ae22$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $5ec159caebd3ae22$var$HOLE = -1;
var $5ec159caebd3ae22$var$NAN = -2;
var $5ec159caebd3ae22$var$NEGATIVE_INFINITY = -3;
var $5ec159caebd3ae22$var$NEGATIVE_ZERO = -4;
var $5ec159caebd3ae22$var$NULL = -5;
var $5ec159caebd3ae22$var$POSITIVE_INFINITY = -6;
var $5ec159caebd3ae22$var$UNDEFINED = -7;
var $5ec159caebd3ae22$var$TYPE_BIGINT = "B";
var $5ec159caebd3ae22$var$TYPE_DATE = "D";
var $5ec159caebd3ae22$var$TYPE_ERROR = "E";
var $5ec159caebd3ae22$var$TYPE_MAP = "M";
var $5ec159caebd3ae22$var$TYPE_NULL_OBJECT = "N";
var $5ec159caebd3ae22$var$TYPE_PROMISE = "P";
var $5ec159caebd3ae22$var$TYPE_REGEXP = "R";
var $5ec159caebd3ae22$var$TYPE_SET = "S";
var $5ec159caebd3ae22$var$TYPE_SYMBOL = "Y";
var $5ec159caebd3ae22$var$TYPE_URL = "U";
var $5ec159caebd3ae22$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $5ec159caebd3ae22$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $5ec159caebd3ae22$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
function $5ec159caebd3ae22$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $5ec159caebd3ae22$var$UNDEFINED;
    if (input === null) return $5ec159caebd3ae22$var$NULL;
    if (Number.isNaN(input)) return $5ec159caebd3ae22$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $5ec159caebd3ae22$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $5ec159caebd3ae22$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $5ec159caebd3ae22$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    $5ec159caebd3ae22$var$stringify.call(this, input, index);
    return index;
}
function $5ec159caebd3ae22$var$stringify(input, index) {
    const { deferred: deferred, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input2, index2] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${$5ec159caebd3ae22$var$flatten.call(this, k)}":${$5ec159caebd3ae22$var$flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input2){
            case "boolean":
            case "number":
            case "string":
                str[index2] = JSON.stringify(input2);
                break;
            case "bigint":
                str[index2] = `["${$5ec159caebd3ae22$var$TYPE_BIGINT}","${input2}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input2);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index2] = `["${$5ec159caebd3ae22$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input2) {
                        str[index2] = `${$5ec159caebd3ae22$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$5ec159caebd3ae22$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input2.length; i++)result += (i ? "," : "") + (i in input2 ? $5ec159caebd3ae22$var$flatten.call(this, input2[i]) : $5ec159caebd3ae22$var$HOLE);
                            str[index2] = `${result}]`;
                        } else if (input2 instanceof Date) {
                            const dateTime = input2.getTime();
                            str[index2] = `["${$5ec159caebd3ae22$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input2 instanceof URL) str[index2] = `["${$5ec159caebd3ae22$var$TYPE_URL}",${JSON.stringify(input2.href)}]`;
                        else if (input2 instanceof RegExp) str[index2] = `["${$5ec159caebd3ae22$var$TYPE_REGEXP}",${JSON.stringify(input2.source)},${JSON.stringify(input2.flags)}]`;
                        else if (input2 instanceof Set) {
                            if (input2.size > 0) str[index2] = `["${$5ec159caebd3ae22$var$TYPE_SET}",${[
                                ...input2
                            ].map((val)=>$5ec159caebd3ae22$var$flatten.call(this, val)).join(",")}]`;
                            else str[index2] = `["${$5ec159caebd3ae22$var$TYPE_SET}"]`;
                        } else if (input2 instanceof Map) {
                            if (input2.size > 0) str[index2] = `["${$5ec159caebd3ae22$var$TYPE_MAP}",${[
                                ...input2
                            ].flatMap(([k, v])=>[
                                    $5ec159caebd3ae22$var$flatten.call(this, k),
                                    $5ec159caebd3ae22$var$flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index2] = `["${$5ec159caebd3ae22$var$TYPE_MAP}"]`;
                        } else if (input2 instanceof Promise) {
                            str[index2] = `["${$5ec159caebd3ae22$var$TYPE_PROMISE}",${index2}]`;
                            deferred[index2] = input2;
                        } else if (input2 instanceof Error) {
                            str[index2] = `["${$5ec159caebd3ae22$var$TYPE_ERROR}",${JSON.stringify(input2.message)}`;
                            if (input2.name !== "Error") str[index2] += `,${JSON.stringify(input2.name)}`;
                            str[index2] += "]";
                        } else if (Object.getPrototypeOf(input2) === null) str[index2] = `["${$5ec159caebd3ae22$var$TYPE_NULL_OBJECT}",{${partsForObj(input2)}}]`;
                        else if ($5ec159caebd3ae22$var$isPlainObject2(input2)) str[index2] = `{${partsForObj(input2)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$5ec159caebd3ae22$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input2);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index2] += `,${rest.map((v)=>$5ec159caebd3ae22$var$flatten.call(this, v)).join(",")}`;
                    str[index2] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $5ec159caebd3ae22$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $5ec159caebd3ae22$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $5ec159caebd3ae22$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $5ec159caebd3ae22$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $5ec159caebd3ae22$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $5ec159caebd3ae22$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $5ec159caebd3ae22$var$hydrate.call(this, startIndex);
}
function $5ec159caebd3ae22$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $5ec159caebd3ae22$var$UNDEFINED:
                set(void 0);
                continue;
            case $5ec159caebd3ae22$var$NULL:
                set(null);
                continue;
            case $5ec159caebd3ae22$var$NAN:
                set(NaN);
                continue;
            case $5ec159caebd3ae22$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $5ec159caebd3ae22$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $5ec159caebd3ae22$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $5ec159caebd3ae22$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $5ec159caebd3ae22$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $5ec159caebd3ae22$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $5ec159caebd3ae22$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $5ec159caebd3ae22$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $5ec159caebd3ae22$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $5ec159caebd3ae22$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $5ec159caebd3ae22$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $5ec159caebd3ae22$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $5ec159caebd3ae22$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $5ec159caebd3ae22$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $5ec159caebd3ae22$var$globalObj && $5ec159caebd3ae22$var$globalObj[errorType] ? new $5ec159caebd3ae22$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $5ec159caebd3ae22$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $5ec159caebd3ae22$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $5ec159caebd3ae22$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $5ec159caebd3ae22$var$Deferred2();
    const reader = readable.pipeThrough($5ec159caebd3ae22$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $5ec159caebd3ae22$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $5ec159caebd3ae22$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $5ec159caebd3ae22$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $5ec159caebd3ae22$var$unflatten.call(this, line)
    };
}
async function $5ec159caebd3ae22$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $5ec159caebd3ae22$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $5ec159caebd3ae22$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $5ec159caebd3ae22$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $5ec159caebd3ae22$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $5ec159caebd3ae22$export$c564cdbbe6da493(input, options) {
    const { plugins: plugins, postPlugins: postPlugins, signal: signal, onComplete: onComplete } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = $5ec159caebd3ae22$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            const id2 = $5ec159caebd3ae22$var$flatten.call(encoder, resolved);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$5ec159caebd3ae22$var$TYPE_PROMISE}${deferredId}:[["${$5ec159caebd3ae22$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$5ec159caebd3ae22$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$5ec159caebd3ae22$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }, (reason)=>{
                            if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                            const id2 = $5ec159caebd3ae22$var$flatten.call(encoder, reason);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$5ec159caebd3ae22$var$TYPE_ERROR}${deferredId}:[["${$5ec159caebd3ae22$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$5ec159caebd3ae22$var$TYPE_ERROR}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$5ec159caebd3ae22$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            onComplete?.();
            controller.close();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $5ec159caebd3ae22$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $5ec159caebd3ae22$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $5ec159caebd3ae22$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $5ec159caebd3ae22$export$4cf11838cdc2a8a8(html) {
    return html.replace($5ec159caebd3ae22$var$ESCAPE_REGEX, (match)=>$5ec159caebd3ae22$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $5ec159caebd3ae22$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $5ec159caebd3ae22$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $5ec159caebd3ae22$var$SingleFetchNoResultError = class extends Error {
};
var $5ec159caebd3ae22$export$ae9272e641ead836 = 202;
var $5ec159caebd3ae22$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $5ec159caebd3ae22$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $7fPBF.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$5ec159caebd3ae22$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, scriptTag, /* @__PURE__ */ $7fPBF.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, scriptTag, /* @__PURE__ */ $7fPBF.createElement($7fPBF.Suspense, null, /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $5ec159caebd3ae22$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $5ec159caebd3ae22$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $5ec159caebd3ae22$var$invariant2(manifestRoute, "Route not found in manifest");
        let routeModule = routeModules[match.route.id];
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader,
            hasShouldRevalidate: Boolean(routeModule?.shouldRevalidate)
        };
    }, $5ec159caebd3ae22$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $5ec159caebd3ae22$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $5ec159caebd3ae22$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $5ec159caebd3ae22$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $5ec159caebd3ae22$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $5ec159caebd3ae22$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $5ec159caebd3ae22$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $5ec159caebd3ae22$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $5ec159caebd3ae22$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($5ec159caebd3ae22$export$3f1eb41d9a6a6a27(result.result) || $5ec159caebd3ae22$export$972111febbeef05b(result.result) || $5ec159caebd3ae22$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $5ec159caebd3ae22$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $5ec159caebd3ae22$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $5ec159caebd3ae22$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $5ec159caebd3ae22$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$5ec159caebd3ae22$var$createDeferred2());
    let singleFetchDfd = $5ec159caebd3ae22$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader, hasShouldRevalidate: hasShouldRevalidate } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader && // for a route with a server loader,
                hasShouldRevalidate === true);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $5ec159caebd3ae22$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $5ec159caebd3ae22$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $5ec159caebd3ae22$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $5ec159caebd3ae22$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $5ec159caebd3ae22$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $5ec159caebd3ae22$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $5ec159caebd3ae22$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $5ec159caebd3ae22$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $5ec159caebd3ae22$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $5ec159caebd3ae22$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $5ec159caebd3ae22$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${basename.replace(/\/$/, "")}/_root.${extension}`;
        else url.pathname = `${url.pathname.replace(/\/$/, "")}.${extension}`;
    }
    return url;
}
async function $5ec159caebd3ae22$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $5ec159caebd3ae22$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $5ec159caebd3ae22$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $5ec159caebd3ae22$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $5ec159caebd3ae22$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $5ec159caebd3ae22$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($5ec159caebd3ae22$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $5ec159caebd3ae22$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $5ec159caebd3ae22$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($5ec159caebd3ae22$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$5ec159caebd3ae22$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $5ec159caebd3ae22$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $5ec159caebd3ae22$export$4023ad4ecd4126a2(body, global) {
    return $5ec159caebd3ae22$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $5ec159caebd3ae22$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$5ec159caebd3ae22$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $5ec159caebd3ae22$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $5ec159caebd3ae22$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $5ec159caebd3ae22$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $5ec159caebd3ae22$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $5ec159caebd3ae22$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $5ec159caebd3ae22$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $5ec159caebd3ae22$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $5ec159caebd3ae22$var$getModuleLinkHrefs(matches, manifest);
    return $5ec159caebd3ae22$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $5ec159caebd3ae22$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $5ec159caebd3ae22$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $5ec159caebd3ae22$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($5ec159caebd3ae22$var$prefetchStyleLink));
}
async function $5ec159caebd3ae22$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$5ec159caebd3ae22$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$5ec159caebd3ae22$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$5ec159caebd3ae22$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($5ec159caebd3ae22$var$prefetchStyleLink));
}
async function $5ec159caebd3ae22$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $5ec159caebd3ae22$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $5ec159caebd3ae22$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $5ec159caebd3ae22$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $5ec159caebd3ae22$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $5ec159caebd3ae22$var$dedupeLinkDescriptors(links.flat(1).filter($5ec159caebd3ae22$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $5ec159caebd3ae22$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $5ec159caebd3ae22$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $5ec159caebd3ae22$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $5ec159caebd3ae22$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $5ec159caebd3ae22$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $5ec159caebd3ae22$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$5ec159caebd3ae22$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($5ec159caebd3ae22$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $5ec159caebd3ae22$var$_isPreloadSupported;
function $5ec159caebd3ae22$var$isPreloadSupported() {
    if ($5ec159caebd3ae22$var$_isPreloadSupported !== void 0) return $5ec159caebd3ae22$var$_isPreloadSupported;
    let el = document.createElement("link");
    $5ec159caebd3ae22$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $5ec159caebd3ae22$var$_isPreloadSupported;
}
function $5ec159caebd3ae22$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $5ec159caebd3ae22$export$945fecf35a8ef089 ? /* @__PURE__ */ $7fPBF.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $5ec159caebd3ae22$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $5ec159caebd3ae22$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $5ec159caebd3ae22$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $5ec159caebd3ae22$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$var$RemixRootDefaultErrorBoundary, {
            error: $5ec159caebd3ae22$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $7fPBF.createElement(routeModule.Layout, null, /* @__PURE__ */ $7fPBF.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $7fPBF.createElement(routeModule.Layout, null, /* @__PURE__ */ $7fPBF.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $7fPBF.createElement(routeModule.Layout, null, /* @__PURE__ */ $7fPBF.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $5ec159caebd3ae22$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $5ec159caebd3ae22$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $5ec159caebd3ae22$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$5ec159caebd3ae22$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $5ec159caebd3ae22$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $5ec159caebd3ae22$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $5ec159caebd3ae22$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $5ec159caebd3ae22$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $5ec159caebd3ae22$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $5ec159caebd3ae22$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $5ec159caebd3ae22$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $5ec159caebd3ae22$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $5ec159caebd3ae22$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $5ec159caebd3ae22$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $5ec159caebd3ae22$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $5ec159caebd3ae22$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $5ec159caebd3ae22$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$5ec159caebd3ae22$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $5ec159caebd3ae22$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $5ec159caebd3ae22$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            context: context,
                            unstable_pattern: unstable_pattern,
                            async serverLoader () {
                                $5ec159caebd3ae22$var$preventInvalidServerHandlerCall("loader", route);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $5ec159caebd3ae22$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $5ec159caebd3ae22$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $5ec159caebd3ae22$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        unstable_pattern: unstable_pattern,
                        async serverAction () {
                            $5ec159caebd3ae22$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $5ec159caebd3ae22$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $5ec159caebd3ae22$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $5ec159caebd3ae22$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $5ec159caebd3ae22$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $5ec159caebd3ae22$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $5ec159caebd3ae22$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $5ec159caebd3ae22$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $5ec159caebd3ae22$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $5ec159caebd3ae22$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $5ec159caebd3ae22$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $5ec159caebd3ae22$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $5ec159caebd3ae22$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $5ec159caebd3ae22$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $5ec159caebd3ae22$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $5ec159caebd3ae22$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $5ec159caebd3ae22$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $5ec159caebd3ae22$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $5ec159caebd3ae22$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $5ec159caebd3ae22$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $5ec159caebd3ae22$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $5ec159caebd3ae22$var$nextPaths = /* @__PURE__ */ new Set();
var $5ec159caebd3ae22$var$discoveredPathsMaxSize = 1e3;
var $5ec159caebd3ae22$var$discoveredPaths = /* @__PURE__ */ new Set();
var $5ec159caebd3ae22$var$URL_LIMIT = 7680;
function $5ec159caebd3ae22$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $5ec159caebd3ae22$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $5ec159caebd3ae22$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $5ec159caebd3ae22$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$5ec159caebd3ae22$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($5ec159caebd3ae22$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $5ec159caebd3ae22$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $5ec159caebd3ae22$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $5ec159caebd3ae22$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $7fPBF.useEffect(()=>{
        if (!$5ec159caebd3ae22$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$5ec159caebd3ae22$var$discoveredPaths.has(pathname)) $5ec159caebd3ae22$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($5ec159caebd3ae22$var$nextPaths.keys()).filter((path)=>{
                if ($5ec159caebd3ae22$var$discoveredPaths.has(path)) {
                    $5ec159caebd3ae22$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $5ec159caebd3ae22$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $5ec159caebd3ae22$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $5ec159caebd3ae22$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    if (basename == null) return manifestPath;
    return `${basename}${manifestPath}`.replace(/\/+/g, "/");
}
var $5ec159caebd3ae22$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $5ec159caebd3ae22$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($5ec159caebd3ae22$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $5ec159caebd3ae22$var$URL_LIMIT) {
        $5ec159caebd3ae22$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($5ec159caebd3ae22$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($5ec159caebd3ae22$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($5ec159caebd3ae22$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$5ec159caebd3ae22$var$addToFifoQueue(p, $5ec159caebd3ae22$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $5ec159caebd3ae22$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $5ec159caebd3ae22$var$addToFifoQueue(path, queue) {
    if (queue.size >= $5ec159caebd3ae22$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $5ec159caebd3ae22$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $5ec159caebd3ae22$var$useDataRouterContext2() {
    let context = $7fPBF.useContext($5ec159caebd3ae22$export$2eeee58951ff3c1c);
    $5ec159caebd3ae22$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $5ec159caebd3ae22$var$useDataRouterStateContext() {
    let context = $7fPBF.useContext($5ec159caebd3ae22$export$315e3ffb01f217);
    $5ec159caebd3ae22$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $5ec159caebd3ae22$export$208d6a3bc3aa62bd = $7fPBF.createContext(void 0);
$5ec159caebd3ae22$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $5ec159caebd3ae22$var$useFrameworkContext() {
    let context = $7fPBF.useContext($5ec159caebd3ae22$export$208d6a3bc3aa62bd);
    $5ec159caebd3ae22$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $5ec159caebd3ae22$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $7fPBF.useContext($5ec159caebd3ae22$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $7fPBF.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $7fPBF.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $7fPBF.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $5ec159caebd3ae22$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $5ec159caebd3ae22$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $5ec159caebd3ae22$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $5ec159caebd3ae22$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $5ec159caebd3ae22$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $5ec159caebd3ae22$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $5ec159caebd3ae22$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$5ec159caebd3ae22$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $5ec159caebd3ae22$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $5ec159caebd3ae22$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $5ec159caebd3ae22$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $5ec159caebd3ae22$var$useDataRouterStateContext();
    let matches = $5ec159caebd3ae22$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $7fPBF.useMemo(()=>$5ec159caebd3ae22$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $7fPBF.createElement("style", {
        [$5ec159caebd3ae22$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $7fPBF.createElement("link", {
        [$5ec159caebd3ae22$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$5ec159caebd3ae22$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $7fPBF.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $5ec159caebd3ae22$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let { router: router } = $5ec159caebd3ae22$var$useDataRouterContext2();
    let matches = $7fPBF.useMemo(()=>$5ec159caebd3ae22$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $5ec159caebd3ae22$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $5ec159caebd3ae22$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $7fPBF.useState([]);
    $7fPBF.useEffect(()=>{
        let interrupted = false;
        $5ec159caebd3ae22$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $5ec159caebd3ae22$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $5ec159caebd3ae22$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $5ec159caebd3ae22$var$useFrameworkContext();
    let { basename: basename } = $5ec159caebd3ae22$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $5ec159caebd3ae22$var$useDataRouterStateContext();
    let newMatchesForData = $7fPBF.useMemo(()=>$5ec159caebd3ae22$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $7fPBF.useMemo(()=>$5ec159caebd3ae22$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $7fPBF.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $5ec159caebd3ae22$export$7b977381851b2c(page, basename, future.unstable_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.unstable_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $7fPBF.useMemo(()=>$5ec159caebd3ae22$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $5ec159caebd3ae22$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $7fPBF.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $7fPBF.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $7fPBF.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $5ec159caebd3ae22$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $5ec159caebd3ae22$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $5ec159caebd3ae22$var$useDataRouterStateContext();
    let location = $5ec159caebd3ae22$export$45d76561a5302f2b();
    let _matches = $5ec159caebd3ae22$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$5ec159caebd3ae22$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $7fPBF.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $7fPBF.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $7fPBF.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $7fPBF.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $5ec159caebd3ae22$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $7fPBF.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $5ec159caebd3ae22$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $5ec159caebd3ae22$var$isHydrated = false;
function $5ec159caebd3ae22$export$3be068dde909e563() {
    $5ec159caebd3ae22$var$isHydrated = true;
}
function $5ec159caebd3ae22$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $5ec159caebd3ae22$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $5ec159caebd3ae22$var$useDataRouterContext2();
    let { matches: routerMatches } = $5ec159caebd3ae22$var$useDataRouterStateContext();
    let isRSCRouterContext = $5ec159caebd3ae22$var$useIsRSCRouterContext();
    let enableFogOfWar = $5ec159caebd3ae22$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $5ec159caebd3ae22$var$getActiveMatches(routerMatches, null, isSpaMode);
    $7fPBF.useEffect(()=>{
        $5ec159caebd3ae22$export$3be068dde909e563();
    }, []);
    let initialScripts = $7fPBF.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $5ec159caebd3ae22$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($5ec159caebd3ae22$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $7fPBF.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $5ec159caebd3ae22$var$isHydrated || isRSCRouterContext ? [] : $5ec159caebd3ae22$var$dedupe(manifest.entry.imports.concat($5ec159caebd3ae22$var$getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    })));
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $5ec159caebd3ae22$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $5ec159caebd3ae22$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $7fPBF.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $7fPBF.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $7fPBF.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $7fPBF.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            suppressHydrationWarning: true
        })), initialScripts);
}
function $5ec159caebd3ae22$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $5ec159caebd3ae22$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $5ec159caebd3ae22$export$32e57f52df4b6e34 = class extends $7fPBF.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $5ec159caebd3ae22$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $7fPBF.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($5ec159caebd3ae22$export$972111febbeef05b(error)) return /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $7fPBF.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $5ec159caebd3ae22$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $7fPBF.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $7fPBF.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $5ec159caebd3ae22$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $5ec159caebd3ae22$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $7fPBF.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $7fPBF.createElement("head", null, /* @__PURE__ */ $7fPBF.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $7fPBF.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $7fPBF.createElement("title", null, title)), /* @__PURE__ */ $7fPBF.createElement("body", null, /* @__PURE__ */ $7fPBF.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$export$ff0bf87698939488, null) : null)));
}
var $5ec159caebd3ae22$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($5ec159caebd3ae22$var$isBrowser2) window.__reactRouterVersion = "7.13.1";
} catch (e) {}
function $5ec159caebd3ae22$export$1f3f55432a00e06d(routes, opts) {
    return $5ec159caebd3ae22$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $5ec159caebd3ae22$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $5ec159caebd3ae22$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $5ec159caebd3ae22$export$9269a41d8c4635e,
        hydrationRouteProperties: $5ec159caebd3ae22$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $5ec159caebd3ae22$export$1ba7ed8a3a7b3765(routes, opts) {
    return $5ec159caebd3ae22$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $5ec159caebd3ae22$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $5ec159caebd3ae22$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $5ec159caebd3ae22$export$9269a41d8c4635e,
        hydrationRouteProperties: $5ec159caebd3ae22$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $5ec159caebd3ae22$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $5ec159caebd3ae22$var$deserializeErrors(state.errors)
    };
    return state;
}
function $5ec159caebd3ae22$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $5ec159caebd3ae22$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $5ec159caebd3ae22$export$9ba4e89fdfa1fc54({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = $5ec159caebd3ae22$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7fPBF.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $7fPBF.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $5ec159caebd3ae22$export$7221d69dcfc8e36b({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = $5ec159caebd3ae22$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7fPBF.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $7fPBF.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $5ec159caebd3ae22$export$de73885c9336221c({ basename: basename, children: children, history: history, unstable_useTransitions: unstable_useTransitions }) {
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7fPBF.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $7fPBF.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
$5ec159caebd3ae22$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $5ec159caebd3ae22$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $5ec159caebd3ae22$export$a6c7ac8248d6e38a = $7fPBF.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, unstable_mask: unstable_mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, unstable_useTransitions: unstable_useTransitions } = $7fPBF.useContext($5ec159caebd3ae22$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $5ec159caebd3ae22$var$ABSOLUTE_URL_REGEX2.test(to);
    let parsed = $5ec159caebd3ae22$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $5ec159caebd3ae22$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $5ec159caebd3ae22$export$45d76561a5302f2b();
    let maskedHref = null;
    if (unstable_mask) {
        let resolved = $5ec159caebd3ae22$var$resolveTo(unstable_mask, [], location.unstable_mask ? location.unstable_mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $5ec159caebd3ae22$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $5ec159caebd3ae22$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $5ec159caebd3ae22$export$67621102c14d847(to, {
        replace: replace2,
        unstable_mask: unstable_mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate,
        unstable_useTransitions: unstable_useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $7fPBF.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $5ec159caebd3ae22$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, link, /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$5ec159caebd3ae22$export$a6c7ac8248d6e38a.displayName = "Link";
var $5ec159caebd3ae22$export$b0d92dbee9b5b60d = $7fPBF.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $5ec159caebd3ae22$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $5ec159caebd3ae22$export$45d76561a5302f2b();
    let routerState = $7fPBF.useContext($5ec159caebd3ae22$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $7fPBF.useContext($5ec159caebd3ae22$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $5ec159caebd3ae22$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $5ec159caebd3ae22$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$5ec159caebd3ae22$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $5ec159caebd3ae22$export$a7fed597f4b8afd8 = $7fPBF.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $5ec159caebd3ae22$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { unstable_useTransitions: unstable_useTransitions } = $7fPBF.useContext($5ec159caebd3ae22$export$3044ab7fdabeaee6);
    let submit = $5ec159caebd3ae22$export$47c85c6e3a081d3();
    let formAction = $5ec159caebd3ae22$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $5ec159caebd3ae22$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate
            });
        if (unstable_useTransitions && navigate !== false) $7fPBF.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $7fPBF.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$5ec159caebd3ae22$export$a7fed597f4b8afd8.displayName = "Form";
function $5ec159caebd3ae22$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $7fPBF.useContext($5ec159caebd3ae22$export$208d6a3bc3aa62bd);
    let { basename: basename } = $7fPBF.useContext($5ec159caebd3ae22$export$3044ab7fdabeaee6);
    let location = $5ec159caebd3ae22$export$45d76561a5302f2b();
    let matches = $5ec159caebd3ae22$export$2378eb7f5ff86053();
    $5ec159caebd3ae22$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $7fPBF.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $5ec159caebd3ae22$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $7fPBF.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$5ec159caebd3ae22$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $5ec159caebd3ae22$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$5ec159caebd3ae22$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$5ec159caebd3ae22$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $5ec159caebd3ae22$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $5ec159caebd3ae22$var$useDataRouterContext3(hookName) {
    let ctx = $7fPBF.useContext($5ec159caebd3ae22$export$2eeee58951ff3c1c);
    $5ec159caebd3ae22$export$f5708dca728d7177(ctx, $5ec159caebd3ae22$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $5ec159caebd3ae22$var$useDataRouterState2(hookName) {
    let state = $7fPBF.useContext($5ec159caebd3ae22$export$315e3ffb01f217);
    $5ec159caebd3ae22$export$f5708dca728d7177(state, $5ec159caebd3ae22$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $5ec159caebd3ae22$export$67621102c14d847(to, { target: target, replace: replaceProp, unstable_mask: unstable_mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, unstable_useTransitions: unstable_useTransitions } = {}) {
    let navigate = $5ec159caebd3ae22$export$9770f232ac06a008();
    let location = $5ec159caebd3ae22$export$45d76561a5302f2b();
    let path = $5ec159caebd3ae22$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $7fPBF.useCallback((event)=>{
        if ($5ec159caebd3ae22$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $5ec159caebd3ae22$export$fe53371bee54353d(location) === $5ec159caebd3ae22$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    unstable_mask: unstable_mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate
                });
            if (unstable_useTransitions) $7fPBF.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        unstable_mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        unstable_defaultShouldRevalidate,
        unstable_useTransitions
    ]);
}
function $5ec159caebd3ae22$export$f1a78c17382fe22a(defaultInit) {
    $5ec159caebd3ae22$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $7fPBF.useRef($5ec159caebd3ae22$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $7fPBF.useRef(false);
    let location = $5ec159caebd3ae22$export$45d76561a5302f2b();
    let searchParams = $7fPBF.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $5ec159caebd3ae22$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $5ec159caebd3ae22$export$9770f232ac06a008();
    let setSearchParams = $7fPBF.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $5ec159caebd3ae22$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $5ec159caebd3ae22$var$fetcherId = 0;
var $5ec159caebd3ae22$var$getUniqueFetcherId = ()=>`__${String(++$5ec159caebd3ae22$var$fetcherId)}__`;
function $5ec159caebd3ae22$export$47c85c6e3a081d3() {
    let { router: router } = $5ec159caebd3ae22$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $7fPBF.useContext($5ec159caebd3ae22$export$3044ab7fdabeaee6);
    let currentRouteId = $5ec159caebd3ae22$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $7fPBF.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $5ec159caebd3ae22$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $5ec159caebd3ae22$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                unstable_defaultShouldRevalidate: options.unstable_defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            unstable_defaultShouldRevalidate: options.unstable_defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $5ec159caebd3ae22$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $7fPBF.useContext($5ec159caebd3ae22$export$3044ab7fdabeaee6);
    let routeContext = $7fPBF.useContext($5ec159caebd3ae22$export$aac280ed165a4397);
    $5ec159caebd3ae22$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$5ec159caebd3ae22$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $5ec159caebd3ae22$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $5ec159caebd3ae22$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $5ec159caebd3ae22$export$fe53371bee54353d(path);
}
function $5ec159caebd3ae22$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $5ec159caebd3ae22$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $5ec159caebd3ae22$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $7fPBF.useContext($5ec159caebd3ae22$export$cb3f1df1bef00a39);
    let route = $7fPBF.useContext($5ec159caebd3ae22$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $5ec159caebd3ae22$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $5ec159caebd3ae22$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $5ec159caebd3ae22$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $7fPBF.useId();
    let [fetcherKey, setFetcherKey] = $7fPBF.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $7fPBF.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $7fPBF.useCallback(async (href, opts)=>{
        $5ec159caebd3ae22$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $5ec159caebd3ae22$export$47c85c6e3a081d3();
    let submit = $7fPBF.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $7fPBF.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $7fPBF.useMemo(()=>{
        let FetcherForm2 = $7fPBF.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $5ec159caebd3ae22$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $7fPBF.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $5ec159caebd3ae22$export$fa996778a3a31087() {
    let state = $5ec159caebd3ae22$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $5ec159caebd3ae22$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $5ec159caebd3ae22$var$savedScrollPositions = {};
function $5ec159caebd3ae22$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $5ec159caebd3ae22$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $5ec159caebd3ae22$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $5ec159caebd3ae22$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $5ec159caebd3ae22$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $7fPBF.useContext($5ec159caebd3ae22$export$3044ab7fdabeaee6);
    let location = $5ec159caebd3ae22$export$45d76561a5302f2b();
    let matches = $5ec159caebd3ae22$export$2378eb7f5ff86053();
    let navigation = $5ec159caebd3ae22$export$d0fd4b7106de2769();
    $7fPBF.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $5ec159caebd3ae22$var$usePageHide($7fPBF.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $5ec159caebd3ae22$var$getScrollRestorationKey(location, matches, basename, getKey);
            $5ec159caebd3ae22$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $5ec159caebd3ae22$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($5ec159caebd3ae22$var$savedScrollPositions));
        } catch (error) {
            $5ec159caebd3ae22$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $7fPBF.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $5ec159caebd3ae22$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $5ec159caebd3ae22$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $7fPBF.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($5ec159caebd3ae22$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$5ec159caebd3ae22$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $7fPBF.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $5ec159caebd3ae22$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $5ec159caebd3ae22$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $5ec159caebd3ae22$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $5ec159caebd3ae22$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $5ec159caebd3ae22$export$b273b3273281a049(when);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $5ec159caebd3ae22$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $7fPBF.useContext($5ec159caebd3ae22$export$3681f408decb40d1);
    $5ec159caebd3ae22$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $5ec159caebd3ae22$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $5ec159caebd3ae22$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $5ec159caebd3ae22$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $5ec159caebd3ae22$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $5ec159caebd3ae22$export$81336c211d5ff295(path.pathname, nextPath) != null || $5ec159caebd3ae22$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $5ec159caebd3ae22$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $5ec159caebd3ae22$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        unstable_mask: void 0
    };
    let staticNavigator = $5ec159caebd3ae22$var$getStatelessNavigator();
    return /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        unstable_useTransitions: false
    });
}
function $5ec159caebd3ae22$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $5ec159caebd3ae22$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $5ec159caebd3ae22$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $5ec159caebd3ae22$var$serializeErrors(context.errors)
        };
        let json = $5ec159caebd3ae22$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        unstable_useTransitions: false
    }, /* @__PURE__ */ $7fPBF.createElement($5ec159caebd3ae22$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $7fPBF.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $5ec159caebd3ae22$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($5ec159caebd3ae22$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $5ec159caebd3ae22$var$getStatelessNavigator() {
    return {
        createHref: $5ec159caebd3ae22$var$createHref,
        encodeLocation: $5ec159caebd3ae22$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $5ec159caebd3ae22$export$69163f0b72ec60d9(routes, opts) {
    return $5ec159caebd3ae22$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $5ec159caebd3ae22$export$9269a41d8c4635e
    });
}
function $5ec159caebd3ae22$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $5ec159caebd3ae22$export$87cb1a9238dc3fba(routes, $5ec159caebd3ae22$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $5ec159caebd3ae22$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $5ec159caebd3ae22$var$createHref,
        encodeLocation: $5ec159caebd3ae22$var$encodeLocation,
        getFetcher () {
            return $5ec159caebd3ae22$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $5ec159caebd3ae22$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $5ec159caebd3ae22$var$createHref(to) {
    return typeof to === "string" ? to : $5ec159caebd3ae22$export$fe53371bee54353d(to);
}
function $5ec159caebd3ae22$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $5ec159caebd3ae22$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $5ec159caebd3ae22$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $5ec159caebd3ae22$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;


// styles/buttonStyles.ts



const $2e997290a21e7a60$export$9d2da132b8db8494 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
    text-align: center;
    border-radius: 0.5rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer !important;
    position: relative;
    padding: 0.5rem 1rem;
    gap: 0.5rem;
    text-underline-offset: 0.15rem;
    @media (prefers-reduced-motion: no-preference) {
        transition: all 0.1s ease-out;
        & * {
            transition: ease-out 0.1s;
        }
    }
    transform-origin: center;
    ${(0, $19e0bc52fddd02b4$export$87f1b08a59e6d1dd)}
`;
const $2e997290a21e7a60$export$8aee7c0c79d62b1e = {
    small: (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
        font-size: 0.875rem;
        min-height: 2.5rem;
        padding: 0 0.625rem;
    `,
    medium: (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
        font-size: 1rem;
        line-height: 1.313rem;
        width: 240px;
        max-width: 100%;
        padding: 0.625rem;
    `,
    large: (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
        font-size: 1.25rem;
        line-height: 1.625rem;
        width: 100%;
        padding: 0.875rem;
    `,
    quick: (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
        font-size: 1rem;
        line-height: 1.313rem;
        padding: 0.625rem 0.875rem;
    `
};
const $2e997290a21e7a60$export$e163c4626827e48 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
    cursor: not-allowed;
    opacity: 0.9;
    color: #666;
    border-color: #666;
    &:hover {
        background: #ccc;
        color: #666;
    }
`;
const $2e997290a21e7a60$export$7e36e2f4770bc64d = (0, $8de346382d86c747$export$2e2bcd8739ae039).button`
    padding: 8px 16px;
    border: none;
    background: ${(props)=>props.isActive ? props.theme.color.accent : props.theme.color.cardHover};
    color: ${(props)=>props.isActive ? props.theme.color.background : props.theme.button.secondary.text};
    cursor: pointer;
    border-radius: 50px;
    transition: all 0.2s ease;
    &:hover {
        background: ${(props)=>props.theme.button.secondary.text};
        color: ${(props)=>props.theme.color.background};
    }
    ${(0, $19e0bc52fddd02b4$export$87f1b08a59e6d1dd)}
`;
const $2e997290a21e7a60$export$eed545bf41e40386 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    gap: 10px;
    margin: 10px 0;
`;


const $bc5329fe346ebf22$var$Button = /*#__PURE__*/ (0, $7fPBF.forwardRef)(({ type: type = 'button', $color: $color = 'primary', $size: $size = 'medium', disabled: disabled = false, onClick: onClick, href: href, to: to, target: target, iconSize: iconSize = 24, startIcon: startIcon, endIcon: endIcon, startComponent: startComponent, endComponent: endComponent, children: children, ...restProps }, ref)=>{
    const commonProps = {
        $color: $color,
        disabled: disabled,
        target: target,
        $size: $size
    };
    endIcon = target === '_blank' && href?.startsWith('http') ? 'externalLink' : endIcon;
    if (href && !target) target = '_self';
    const ButtonComponent = {
        primary: $bc5329fe346ebf22$var$PrimaryButton,
        secondary: $bc5329fe346ebf22$var$SecondaryButton,
        accent: $bc5329fe346ebf22$var$AccentButton,
        simple: $bc5329fe346ebf22$var$SimpleButton,
        quick: $bc5329fe346ebf22$var$QuickButton,
        dashedAccent: $bc5329fe346ebf22$var$DashedAccentButton,
        solidAccent: $bc5329fe346ebf22$var$SolidAccentButton
    };
    const LinkComponent = {
        primary: $bc5329fe346ebf22$var$PrimaryLink,
        secondary: $bc5329fe346ebf22$var$SecondaryLink,
        accent: $bc5329fe346ebf22$var$AccentLink,
        simple: $bc5329fe346ebf22$var$SimpleLink,
        quick: $bc5329fe346ebf22$var$QuickLink,
        dashedAccent: $bc5329fe346ebf22$var$DashedAccentLink,
        solidAccent: $bc5329fe346ebf22$var$SolidAccentLink
    };
    const NavLinkComponent = {
        primary: $bc5329fe346ebf22$var$PrimaryNavLink,
        secondary: $bc5329fe346ebf22$var$SecondaryNavLink,
        accent: $bc5329fe346ebf22$var$AccentNavLink,
        simple: $bc5329fe346ebf22$var$SimpleNavLink,
        quick: $bc5329fe346ebf22$var$QuickNavLink,
        dashedAccent: $bc5329fe346ebf22$var$DashedAccentNavLink,
        solidAccent: $bc5329fe346ebf22$var$SolidAccentNavLink
    };
    if (href) {
        const StyledLink = LinkComponent[$color];
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(StyledLink, {
            as: "a",
            ref: ref,
            className: "core-button",
            href: href,
            ...commonProps,
            ...restProps,
            children: [
                startComponent,
                startIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                    name: startIcon,
                    size: iconSize
                }),
                children,
                endComponent,
                endIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                    name: endIcon,
                    size: iconSize
                })
            ]
        });
    } else if (to) {
        const { $color: _color, ...safeProps } = {
            ...commonProps,
            ...restProps
        };
        const StyledNavLink = NavLinkComponent[_color];
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(StyledNavLink, {
            ref: ref,
            className: "core-button",
            viewTransition: true,
            to: to,
            ...commonProps,
            ...safeProps,
            children: [
                startIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                    name: startIcon,
                    size: iconSize
                }),
                startComponent,
                children,
                endIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                    name: endIcon,
                    size: iconSize
                }),
                endComponent
            ]
        });
    } else {
        const StyledButton = ButtonComponent[$color];
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(StyledButton, {
            ref: ref,
            className: "core-button",
            type: type,
            onClick: onClick,
            ...commonProps,
            ...restProps,
            children: [
                startComponent,
                startIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                    name: startIcon,
                    size: iconSize
                }),
                children,
                endComponent,
                endIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                    name: endIcon,
                    size: iconSize
                })
            ]
        });
    }
});
const $bc5329fe346ebf22$var$PrimaryButton = (0, $8de346382d86c747$export$2e2bcd8739ae039)('button', {
    shouldForwardProp: (prop)=>prop !== '$size' && prop !== '$color'
})(({ theme: theme, $size: $size, disabled: disabled })=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
        ${0, $2e997290a21e7a60$export$9d2da132b8db8494}
        font-weight: 700;
        background: ${theme.button.primary.background};
        ${theme.button.primary.backgroundImage && `background-image: linear-gradient(54deg, #062844 4.52%, #4b2b8e 59.43%, #ee486f 125.41%)`};
        text-decoration: none;
        border: 1px solid ${theme.button.primary.border};
        color: ${theme.button.primary.text};
        &:hover {
            svg {
                color: ${theme.button.primary.icon};
            }
            color: ${theme.button.primary.hoverText};
            background: ${theme.button.primary.hoverBackground};
        }
        ${$size && (0, $2e997290a21e7a60$export$8aee7c0c79d62b1e)[$size]}
        ${disabled && (0, $2e997290a21e7a60$export$e163c4626827e48)}
    `);
const $bc5329fe346ebf22$var$SecondaryButton = (0, $8de346382d86c747$export$2e2bcd8739ae039)('button', {
    shouldForwardProp: (prop)=>prop !== '$size' && prop !== '$color'
})(({ theme: theme, $size: $size, disabled: disabled })=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
        ${0, $2e997290a21e7a60$export$9d2da132b8db8494}
        font-weight: 700;
        text-decoration: none;
        background: ${theme.button.secondary.background};
        border: solid 1px ${theme.button.secondary.border};
        color: ${theme.button.secondary.text};
        &:hover {
            svg {
                color: ${theme.button.secondary.icon};
            }
            color: ${theme.button.secondary.hoverText};
            background: ${theme.button.secondary.hoverBackground};
        }
        ${$size && (0, $2e997290a21e7a60$export$8aee7c0c79d62b1e)[$size]}
        ${disabled && (0, $2e997290a21e7a60$export$e163c4626827e48)}
    `);
const $bc5329fe346ebf22$var$AccentButton = (0, $8de346382d86c747$export$2e2bcd8739ae039)('button', {
    shouldForwardProp: (prop)=>prop !== '$size' && prop !== '$color'
})(({ theme: theme, $size: $size, disabled: disabled })=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
        ${0, $2e997290a21e7a60$export$9d2da132b8db8494}
        background: ${theme.button.accent.background};
        color: ${theme.button.accent.text};
        text-decoration: none;
        border-radius: 2rem;
        border: transparent 1px solid;
        font-weight: 300;
        &:hover {
            border: ${theme.button.accent.border} 1px solid;
            background: ${theme.button.accent.hoverBackground};
            color: ${theme.button.accent.hoverText};
            svg {
                color: ${theme.button.accent.icon};
            }
        }

        ${$size && (0, $2e997290a21e7a60$export$8aee7c0c79d62b1e)['quick']}
        ${disabled && (0, $2e997290a21e7a60$export$e163c4626827e48)}
    `);
const $bc5329fe346ebf22$var$SimpleButton = (0, $8de346382d86c747$export$2e2bcd8739ae039)('button', {
    shouldForwardProp: (prop)=>prop !== '$size' && prop !== '$color'
})(({ theme: theme, $size: $size, disabled: disabled })=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
        ${0, $2e997290a21e7a60$export$9d2da132b8db8494}
        background: ${theme.button.simple.background};
        color: ${theme.button.simple.text};
        text-decoration: underline !important;
        text-decoration-color: ${theme.button.simple.text};
        border: none;
        &:hover {
            text-decoration-color: ${theme.button.simple.hoverText} !important;
            filter: none;
            box-shadow: 0px 0px 0px 1px ${theme.button.simple.text};
        }
        ${(0, $2e997290a21e7a60$export$8aee7c0c79d62b1e)[$size]}
        ${disabled && (0, $2e997290a21e7a60$export$e163c4626827e48)}
        font-size: 1rem;
        min-width: fit-content;
    `);
const $bc5329fe346ebf22$var$QuickButton = (0, $8de346382d86c747$export$2e2bcd8739ae039)('button', {
    shouldForwardProp: (prop)=>prop !== '$size' && prop !== '$color'
})(({ theme: theme, $size: $size, disabled: disabled })=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
        ${0, $2e997290a21e7a60$export$9d2da132b8db8494}
        padding: 0.625rem 0.875rem;
        border-radius: 1.875rem;
        background: ${theme.button.quick.background};
        color: ${theme.button.quick.text};
        text-decoration: none;
        border: ${theme.button.quick.border} 1px solid;
        font-weight: 400;
        font-family: 'Archivo', sans-serif;
        font-size: 1rem;
        svg {
            color: ${theme.button.quick.border};
        }
        &:hover {
            border: ${theme.button.quick.border} 1px solid;
            background: ${theme.button.quick.hoverBackground};
            color: ${theme.button.quick.hoverText};
            text-decoration: underline !important;
            text-decoration-color: ${theme.button.quick.border};
            svg {
                color: ${theme.button.quick.icon};
            }
        }
        ${$size && (0, $2e997290a21e7a60$export$8aee7c0c79d62b1e)[$size]}
        ${disabled && (0, $2e997290a21e7a60$export$e163c4626827e48)}
    `);
const $bc5329fe346ebf22$var$DashedAccentButton = (0, $8de346382d86c747$export$2e2bcd8739ae039)('button', {
    shouldForwardProp: (prop)=>prop !== '$size' && prop !== '$color'
})(({ theme: theme, $size: $size, disabled: disabled })=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
        ${0, $2e997290a21e7a60$export$9d2da132b8db8494}
        background: ${theme.button.accent.background};
        color: ${theme.color.accent};
        text-decoration: none;
        border-radius: 2rem;
        min-width: fit-content;
        border: ${theme.color.accent} 1px dashed;
        font-weight: 300;
        &:hover {
            border: ${theme.button.accent.border} 1px dashed;
            background: ${theme.button.accent.hoverBackground};
            color: ${theme.button.accent.border};
            svg {
                color: ${theme.button.accent.border};
            }
        }

        ${$size && (0, $2e997290a21e7a60$export$8aee7c0c79d62b1e)['quick']}
        ${disabled && (0, $2e997290a21e7a60$export$e163c4626827e48)}
    `);
const $bc5329fe346ebf22$var$SolidAccentButton = (0, $8de346382d86c747$export$2e2bcd8739ae039)('button', {
    shouldForwardProp: (prop)=>prop !== '$size' && prop !== '$color'
})(({ theme: theme, $size: $size, disabled: disabled })=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
        ${0, $2e997290a21e7a60$export$9d2da132b8db8494}
        background: ${theme.button.accent.background};
        color: ${theme.color.accent};
        text-decoration: none;
        border-radius: 2rem;
        border: ${theme.color.accent} 1px solid;
        font-weight: 300;
        &:hover {
            border: ${theme.button.accent.border} 1px solid;
            background: ${theme.button.accent.hoverBackground};
            color: ${theme.button.accent.border};
            svg {
                color: ${theme.button.accent.border};
            }
        }

        ${$size && (0, $2e997290a21e7a60$export$8aee7c0c79d62b1e)['quick']}
        ${disabled && (0, $2e997290a21e7a60$export$e163c4626827e48)}
    `);
const $bc5329fe346ebf22$var$PrimaryLink = (0, $8de346382d86c747$export$2e2bcd8739ae039)($bc5329fe346ebf22$var$PrimaryButton.withComponent('a'))``;
const $bc5329fe346ebf22$var$SecondaryLink = (0, $8de346382d86c747$export$2e2bcd8739ae039)($bc5329fe346ebf22$var$SecondaryButton.withComponent('a'))``;
const $bc5329fe346ebf22$var$AccentLink = (0, $8de346382d86c747$export$2e2bcd8739ae039)($bc5329fe346ebf22$var$AccentButton.withComponent('a'))``;
const $bc5329fe346ebf22$var$SimpleLink = (0, $8de346382d86c747$export$2e2bcd8739ae039)($bc5329fe346ebf22$var$SimpleButton.withComponent('a'))``;
const $bc5329fe346ebf22$var$QuickLink = (0, $8de346382d86c747$export$2e2bcd8739ae039)($bc5329fe346ebf22$var$QuickButton.withComponent('a'))``;
const $bc5329fe346ebf22$var$DashedAccentLink = (0, $8de346382d86c747$export$2e2bcd8739ae039)($bc5329fe346ebf22$var$DashedAccentButton.withComponent('a'))``;
const $bc5329fe346ebf22$var$SolidAccentLink = (0, $8de346382d86c747$export$2e2bcd8739ae039)($bc5329fe346ebf22$var$SolidAccentButton.withComponent('a'))``;
const $bc5329fe346ebf22$var$PrimaryNavLink = (0, $8de346382d86c747$export$2e2bcd8739ae039)($bc5329fe346ebf22$var$PrimaryButton.withComponent((0, $5ec159caebd3ae22$export$b0d92dbee9b5b60d)))``;
const $bc5329fe346ebf22$var$SecondaryNavLink = (0, $8de346382d86c747$export$2e2bcd8739ae039)($bc5329fe346ebf22$var$SecondaryButton.withComponent((0, $5ec159caebd3ae22$export$b0d92dbee9b5b60d)))``;
const $bc5329fe346ebf22$var$AccentNavLink = (0, $8de346382d86c747$export$2e2bcd8739ae039)($bc5329fe346ebf22$var$AccentButton.withComponent((0, $5ec159caebd3ae22$export$b0d92dbee9b5b60d)))``;
const $bc5329fe346ebf22$var$SimpleNavLink = (0, $8de346382d86c747$export$2e2bcd8739ae039)($bc5329fe346ebf22$var$SimpleButton.withComponent((0, $5ec159caebd3ae22$export$b0d92dbee9b5b60d)))``;
const $bc5329fe346ebf22$var$QuickNavLink = (0, $8de346382d86c747$export$2e2bcd8739ae039)($bc5329fe346ebf22$var$QuickButton.withComponent((0, $5ec159caebd3ae22$export$b0d92dbee9b5b60d)))``;
const $bc5329fe346ebf22$var$DashedAccentNavLink = (0, $8de346382d86c747$export$2e2bcd8739ae039)($bc5329fe346ebf22$var$DashedAccentButton.withComponent((0, $5ec159caebd3ae22$export$b0d92dbee9b5b60d)))``;
const $bc5329fe346ebf22$var$SolidAccentNavLink = (0, $8de346382d86c747$export$2e2bcd8739ae039)($bc5329fe346ebf22$var$SolidAccentButton.withComponent((0, $5ec159caebd3ae22$export$b0d92dbee9b5b60d)))``;
var $bc5329fe346ebf22$export$2e2bcd8739ae039 = $bc5329fe346ebf22$var$Button;



const $2b7126a11f803509$var$SplashLoader = ({ text: text, className: className, children: children, refreshButton: refreshButton = false })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($2b7126a11f803509$var$SplashLoaderWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2b7126a11f803509$var$StyledCephableIcon, {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2b7126a11f803509$export$b1ae020268e0b4d5, {}),
            text && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2b7126a11f803509$var$StyledLabelXLarge, {
                children: text
            }),
            children,
            refreshButton && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    window.location.reload();
                },
                children: t('common:reload')
            })
        ]
    });
};
const $2b7126a11f803509$var$StyledCephableIcon = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $0e54c6b17377038f$export$2e2bcd8739ae039))`
    height: 128px;
    width: 128px;
`;
const $2b7126a11f803509$var$StyledLabelXLarge = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$c1529625596ef638))`
    color: ${(props)=>props.theme.color.text};
`;
const $2b7126a11f803509$export$b1ae020268e0b4d5 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $d513166e63c42433$export$2e2bcd8739ae039))`
    margin: 16px;
`;
const $2b7126a11f803509$var$SplashLoaderWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    min-height: 90vh;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    ${(0, $19e0bc52fddd02b4$export$29c8ed22df400735)}
    img {
        height: 128px;
        width: 128px;
    }
`;
var $2b7126a11f803509$export$2e2bcd8739ae039 = $2b7126a11f803509$var$SplashLoader;





var $7fPBF = parcelRequire("7fPBF");


const $f6147295756e879a$var$LOGIN_PATH = '../login';
const $f6147295756e879a$var$HOME_PATH = '../';
const $f6147295756e879a$var$AuthCallbackPage = ()=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const [searchParams] = (0, $5ec159caebd3ae22$export$f1a78c17382fe22a)();
    const queryCode = searchParams.get('code');
    const authContainer = (0, $455682785eac4c5b$export$2e2bcd8739ae039).useContainer();
    const alertsContainer = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const tryInitializeFromStorage = async ()=>{
        try {
            const result = await authContainer.initializeFromStorage();
            if (result) navigate($f6147295756e879a$var$HOME_PATH, {
                replace: true,
                viewTransition: true
            });
            else errorReset();
        } catch (error) {
            errorReset();
        }
    };
    const errorReset = ()=>{
        alertsContainer.showError(t('common:login.error'));
        if (!authContainer.isLoading) navigate($f6147295756e879a$var$LOGIN_PATH, {
            replace: true,
            viewTransition: true
        });
    };
    const fetchData = async ()=>{
        try {
            const result = await authContainer.loginFromCode(queryCode || '');
            if (result?.resultType == 'Ok') navigate($f6147295756e879a$var$HOME_PATH, {
                replace: true,
                viewTransition: true
            });
            else tryInitializeFromStorage();
        } catch (error) {
            errorReset();
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        if (!queryCode) navigate($f6147295756e879a$var$LOGIN_PATH, {
            replace: true,
            viewTransition: true
        });
        if (!authContainer.isAuthenticatedRef.current) fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {
        text: t('common:authenticating'),
        refreshButton: true
    });
};
var $f6147295756e879a$export$2e2bcd8739ae039 = $f6147295756e879a$var$AuthCallbackPage;













function $746bf81c54a0dba3$export$2e2bcd8739ae039({ items: items }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($746bf81c54a0dba3$var$BreadcrumbNav, {
        "aria-label": "Breadcrumb",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($746bf81c54a0dba3$var$BreadcrumbList, {
            children: items.map((item, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($746bf81c54a0dba3$var$BreadcrumbItem, {
                    children: index < items.length - 1 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($746bf81c54a0dba3$var$BreadcrumbLink, {
                        viewTransition: true,
                        to: item.href,
                        children: item.label
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        "aria-current": "page",
                        children: item.label
                    })
                }, index))
        })
    });
}
// Styled components
const $746bf81c54a0dba3$var$BreadcrumbNav = (0, $8de346382d86c747$export$2e2bcd8739ae039).nav`
    ${(0, $b091aef3a32d2bd8$export$e6005bbb0c0f31ce)}
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: ${({ theme: theme })=>theme.color.textBody};
    position: sticky;
    top: 0;
    z-index: 1000;
    padding: 0.5rem 0 0 0;
    width: 100%;
    background-color: ${({ theme: theme })=>theme.color.background};
`;
const $746bf81c54a0dba3$var$BreadcrumbList = (0, $8de346382d86c747$export$2e2bcd8739ae039).ol`
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    margin: 0;
`;
const $746bf81c54a0dba3$var$BreadcrumbItem = (0, $8de346382d86c747$export$2e2bcd8739ae039).li`
    display: flex;
    align-items: center;

    &::after {
        content: '/';
        margin: 0 0.5rem;
        color: ${({ theme: theme })=>theme.color.border};
    }

    &:last-child::after {
        content: '';
    }
`;
const $746bf81c54a0dba3$var$BreadcrumbLink = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $5ec159caebd3ae22$export$b0d92dbee9b5b60d))`
    text-decoration: none;
    color: ${({ theme: theme })=>theme.color.link};

    &:hover,
    &:focus {
        text-decoration: underline;
        outline: none;
    }

    ${(0, $19e0bc52fddd02b4$export$87f1b08a59e6d1dd)}
`;










function $8cbaab975a9dfe13$var$TextButton({ type: type = 'button', variant: variant = 'default', disabled: disabled = false, onClick: onClick, href: href, to: to, target: target, startIcon: startIcon, endIcon: endIcon, children: children, ...restProps }) {
    const theme = (0, $d62c6f18f523e962$export$3b14a55fb2447963)();
    const commonProps = {
        variant: variant,
        disabled: disabled,
        target: target
    };
    const buttonBaseStyles = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
        align-items: center;
        background-color: transparent;
        border: none;
        cursor: pointer;
        font-family: 'Archivo', sans-serif;
        padding: 0.25rem 1rem 0.25rem 0;
        ${(0, $19e0bc52fddd02b4$export$87f1b08a59e6d1dd)}
        @media (prefers-reduced-motion: no-preference) {
            transition: all 0.1s ease-out;
        }
        svg {
            vertical-align: middle;
            scale: 0.8;
        }
        :disabled,
        :disabled * {
            cursor: not-allowed !important;
            opacity: 0.9;
            color: #666;
            border-color: #666;
            &:hover {
                color: #666;
            }
        }
    `;
    const controlButtonStyles = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
        align-items: center;
        color: ${theme.color.textBody};
        display: inline-flex;
        font-size: 1rem; // 16px
        font-weight: 500;
        justify-content: center;
        line-height: 1.313rem; // 21px
        :hover {
            cursor: pointer;
            color: ${theme.color.link};
            text-decoration: underline;
        }
    `;
    const subsectionButtonStyles = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
        align-items: center;
        color: ${theme.color.link};
        display: inline-flex;
        font-size: 1rem; // 16px
        font-weight: 400;
        justify-content: center;
        line-height: 1.313rem; // 21px
        text-decoration: underline !important;
        :hover {
            cursor: pointer;
            color: ${theme.color.link};
            text-decoration: underline;
        }
    `;
    const defaultButtonStyles = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
        align-items: center;
        color: ${theme.color.textBody};
        display: inline-flex;
        font-size: 0.875rem;
        font-weight: 500;
        gap: 0.25rem;
        justify-content: center;
        :hover {
            color: ${theme.color.link};
            text-decoration: underline;
        }
    `;
    const contextButtonStyles = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
        color: ${theme.color.link};
        font-size: 1.125rem;
        font-weight: 400;
        line-height: 1.625rem;
        text-decoration: underline !important;
        :hover {
            color: ${theme.color.text};
            text-decoration: none;
        }
    `;
    const negativeButtonStyles = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
        align-items: center;
        color: ${theme.banner.error.linkText};
        display: inline-flex;
        font-size: 0.875rem;
        font-weight: 500;
        gap: 0.25rem;
        justify-content: center;
        :hover {
            color: ${theme.color.link};
            text-decoration: underline;
        }
    `;
    const StyledButton = (0, $8de346382d86c747$export$2e2bcd8739ae039).button`
        ${buttonBaseStyles}
        ${(props)=>props.variant === 'default' && defaultButtonStyles}
        ${(props)=>props.variant === 'context' && contextButtonStyles}
        ${(props)=>props.variant === 'control' && controlButtonStyles}
        ${(props)=>props.variant === 'negative' && negativeButtonStyles}
        ${(props)=>props.variant === 'subsection' && subsectionButtonStyles}
    `;
    const StyledLink = (0, $8de346382d86c747$export$2e2bcd8739ae039).a`
        ${buttonBaseStyles}
        ${(props)=>props.variant === 'default' && defaultButtonStyles}
        ${(props)=>props.variant === 'context' && contextButtonStyles}
        ${(props)=>props.variant === 'control' && controlButtonStyles}
        ${(props)=>props.variant === 'negative' && negativeButtonStyles}
        ${(props)=>props.variant === 'subsection' && subsectionButtonStyles}

        visibility: ${(props)=>props.disabled ? 'hidden' : 'visible'};
    `;
    const StyledNavLink = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $5ec159caebd3ae22$export$b0d92dbee9b5b60d))`
        ${buttonBaseStyles}
        ${(props)=>props.variant === 'default' && defaultButtonStyles}
        ${(props)=>props.variant === 'context' && contextButtonStyles}
        ${(props)=>props.variant === 'control' && controlButtonStyles}
        ${(props)=>props.variant === 'negative' && negativeButtonStyles}
        ${(props)=>props.variant === 'subsection' && subsectionButtonStyles}
    `;
    endIcon = target === '_blank' ? 'externalLink' : endIcon;
    if (to) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(StyledNavLink, {
        className: "text-button",
        to: to,
        ...commonProps,
        ...restProps,
        children: [
            startIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                name: startIcon
            }),
            children,
            endIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                name: endIcon
            })
        ]
    });
    if (href) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(StyledLink, {
        className: "text-button",
        href: href,
        ...commonProps,
        ...restProps,
        children: [
            startIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                name: startIcon
            }),
            children,
            endIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                name: endIcon
            })
        ]
    });
    else return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(StyledButton, {
        className: "text-button",
        type: type,
        onClick: onClick,
        ...commonProps,
        ...restProps,
        children: [
            startIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                name: startIcon
            }),
            children,
            endIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                name: endIcon
            })
        ]
    });
}
var $8cbaab975a9dfe13$export$2e2bcd8739ae039 = $8cbaab975a9dfe13$var$TextButton;



const $9926e0d0274623af$export$ce6636bfa4e9f0e8 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    width: 100%;
    max-width: 1000px;
    padding: 3rem 2rem;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
`;
const $9926e0d0274623af$export$a0a5e8e630ce7261 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($9926e0d0274623af$export$ce6636bfa4e9f0e8)`
    display: flex;
    margin: auto;
    justify-content: center;
    align-items: center;
`;
const $9926e0d0274623af$export$1d02c21cd5285ce0 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    flex-direction: column;
    display: flex;
    flex-wrap: wrap;
    margin: 2rem 0;
`;
const $9926e0d0274623af$export$155581e8dc02007a = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$e08999835651ba4a))`
    padding: 0.5rem 0;
`;
const $9926e0d0274623af$export$b8851b0fad634649 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$a79389cfbe6f64d))`
    padding: 1rem 0 0.5rem 0;
`;
const $9926e0d0274623af$export$aaf6264d06ddc4ce = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$5c3bdb37a55baa65))`
    padding: 2rem 0 0.5rem 0;
`;
const $9926e0d0274623af$export$1373bbbab1727c6f = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$2c65789109b698b0))`
    padding: 1rem 0 0.5rem 0;
`;
const $9926e0d0274623af$export$2f7dd73b133adfb7 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb))`
    color: ${(props)=>props.theme.color.textBody};
    display: inline-block;
`;
const $9926e0d0274623af$export$154f0ea7dcc0c8c6 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039))`
    margin: 2rem 0;
`;
const $9926e0d0274623af$export$da51057063e69428 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039))`
    display: inline-block;
    padding-left: 0.5rem;
`;
const $9926e0d0274623af$export$646b80a994b34028 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb))`
    padding: 0rem 0 0.5rem 0;
`;
const $9926e0d0274623af$export$a6c3c9410ede5653 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb))`
    padding: 0rem 0 0.5rem 0;
`;
const $9926e0d0274623af$export$a4cc130c20be0091 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$2c65789109b698b0))`
    padding: 0rem 0 1rem 0;
    font-weight: 300;
`;
const $9926e0d0274623af$export$61d973530a8ddc92 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039))`
    font-weight: 700;
    font-size: 1.5rem;
    color: ${(props)=>props.theme.color.text};
    :hover {
        color: ${(props)=>props.theme.color.link};
    }
`;
const $9926e0d0274623af$export$3288d34c523a1192 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: block;
    margin: 0.5rem 0;
    width: min-content;
    color: ${(props)=>props.theme.tag.text};
    background-color: ${(props)=>props.theme.tag.background};
    padding: 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    border-radius: 0.375rem;
`;
const $9926e0d0274623af$export$86956144d6970eff = (0, $8de346382d86c747$export$2e2bcd8739ae039)($9926e0d0274623af$export$3288d34c523a1192)`
    margin-left: 5px;
    font-size: 0.8rem;
    display: inline-block;
    white-space: nowrap;
`;






const $b341816979fee99b$export$489b03dc3e6c3fea = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$ddf9e902b54c6c8))`
    max-width: 800px;
`;
const $b341816979fee99b$export$ac90896a1379b2ac = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    padding: 0 0 0.5rem 0;
    flex: 1;
    min-width: 60%; // ensure the header text doesn't get too small and takes up appropriate portion of header
`;
const $b341816979fee99b$export$128b0389825fe3d5 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;
const $b341816979fee99b$export$1e86fd0e1db89578 = (0, $8de346382d86c747$export$2e2bcd8739ae039).header`
    flex-basis: 100%;
    height: fit-content;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 10px 10px 20px;
    border-bottom: ${({ theme: theme })=>`1px solid ${theme.color.sidebarDivider}`};
`;
const $b341816979fee99b$export$8e6b12661156fe2f = (0, $8de346382d86c747$export$2e2bcd8739ae039).a`
    color: ${({ theme: theme })=>theme.color.text};
    display: flex;
    height: 42px;
    ${(0, $19e0bc52fddd02b4$export$87f1b08a59e6d1dd)}
`;
const $b341816979fee99b$export$eddf54ea3db8d0f0 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    gap: 1rem;
`;


function $dbcf46d7f0dc128d$export$2e2bcd8739ae039({ title: title = '', description: description, children: children, prefix: prefix, tag: tag, items: items, licenseTag: licenseTag }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { managedOrgId: managedOrgId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    if (managedOrgId) tag = t('common:organization.managed.titleShort');
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            items && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $746bf81c54a0dba3$export$2e2bcd8739ae039), {
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($dbcf46d7f0dc128d$var$HeaderWrapper, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $b341816979fee99b$export$ac90896a1379b2ac), {
                        children: [
                            prefix && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$ddf9e902b54c6c8), {
                                children: prefix
                            }),
                            tag && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9926e0d0274623af$export$3288d34c523a1192), {
                                children: tag
                            }),
                            licenseTag,
                            typeof title == 'string' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$e08999835651ba4a), {
                                children: title
                            }) : title,
                            description && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                                children: description
                            })
                        ]
                    }),
                    children && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b341816979fee99b$export$128b0389825fe3d5), {
                        children: children
                    })
                ]
            })
        ]
    });
}
const $dbcf46d7f0dc128d$var$HeaderWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1rem;
`;


function $3bdd92f3efb1b659$export$2e2bcd8739ae039({ pageTitle: pageTitle }) {
    const params = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: pageTitle
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: pageTitle
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: params && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("pre", {
                    children: JSON.stringify(params, null, 2)
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: "This page has not been created yet."
            })
        ]
    });
}












const $6392222d2b8fb222$export$474db65c3c394e1c = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$fe91652f4f7f8d90))`
    font-weight: ${(props)=>props.fontWeight || 400};
    text-transform: capitalize;
`;
const $6392222d2b8fb222$export$2d914cb1a3b0bf58 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($6392222d2b8fb222$export$474db65c3c394e1c)`
    text-align: center;
    display: flex;
    align-items: center;
    align-self: center;
    gap: 0.5rem;
`;
const $6392222d2b8fb222$export$f37ee4cff56f2c69 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb))`
    font-weight: ${(props)=>props.fontWeight || 400};
`;
const $6392222d2b8fb222$export$68ed3e0616d4c778 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($6392222d2b8fb222$export$f37ee4cff56f2c69)`
    text-align: center;
    display: flex;
    align-self: center;
`;
const $6392222d2b8fb222$export$cd24fb4f2042953 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$df83f18906197f6b))`
    color: ${(props)=>props.theme.color.text};
`;
const $6392222d2b8fb222$export$d14d08fa0d83d69d = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$df83f18906197f6b))`
    color: ${(props)=>props.theme.color.textBody};
    margin-bottom: 0.875rem;
`;






parcelRequire("7fPBF");



function $5292444ccdcf3a91$export$2e2bcd8739ae039({ as: as, title: title, description: description, icon: icon, iconSize: iconSize = 100, fullHeight: fullHeight = false, children: children, ...restProps }) {
    // try to appropriately set the heading level based on the fullHeight prop
    if (fullHeight) as = as || 'h1';
    else as = as || 'h3';
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($5292444ccdcf3a91$var$BannerCard, {
        $fullHeight: fullHeight,
        ...restProps,
        children: [
            icon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                name: icon,
                size: iconSize
            }),
            title && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$5c3bdb37a55baa65), {
                as: as,
                children: title
            }),
            description && typeof description === 'string' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                children: description
            }) : description,
            children
        ]
    });
}
const $5292444ccdcf3a91$var$BannerCard = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    max-width: 600px;
    text-align: center;
    gap: 10px;
    flex-grow: 1;
    padding: 20px;
    ${({ $fullHeight: $fullHeight })=>$fullHeight && $5292444ccdcf3a91$var$FullHeight};
    ${(0, $19e0bc52fddd02b4$export$db407487374f02c9)};
`;
const $5292444ccdcf3a91$var$FullHeight = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
    height: 100%;
`;


const $347ffda0d89c401a$export$a30053b04ba33ef5 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    border-radius: 0.375rem;
    border: 1px solid ${(props)=>props.theme.color.border};
`;
const $347ffda0d89c401a$export$8ffb7ce587ade322 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    flex-basis: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 0.5rem;
    align-self: stretch;
    padding: 0.75rem 0;
    > svg {
        padding-top: 1rem;
    }
    &:not(:last-of-type) {
        border-bottom: 1px solid ${(props)=>props.theme.color.border};
    }
`;
const $347ffda0d89c401a$export$a27f3c48b2f1c458 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    gap: 0.5rem;
    &:not(:last-of-type) {
        border-bottom: 1px solid ${(props)=>props.theme.color.border};
    }
`;
const $347ffda0d89c401a$export$401042fa3f49d26 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    position: relative;
    width: 16rem;
    min-height: 16rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    align-self: stretch;
    border-radius: 0.375rem;
    border: 1px solid ${(props)=>props.theme.color.border};
`;
const $347ffda0d89c401a$export$1056953590c5547a = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    padding: 2.25rem;
    gap: 0.5rem;
    border-radius: 0.375rem;
    width: 24.625rem;
    max-width: 100vw;
    border: 1px solid ${(props)=>props.theme.input.background};
    background: ${(props)=>props.theme.color.background};
`;
const $347ffda0d89c401a$export$70dfb9c5a6f2c300 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-basis: 100%;
    flex-direction: column;
    padding: 2.25rem;
    gap: 0.5rem;
    border-radius: 0.375rem;
    background: ${(props)=>props.theme.color.background};
`;
const $347ffda0d89c401a$export$f2e4196c0d2b5bb8 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    padding: 1.25rem 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 10rem;
`;
const $347ffda0d89c401a$export$9ee67e6e3f51a5ed = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    margin: 0;
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
`;
const $347ffda0d89c401a$export$9de46b28c4f6c978 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    flex-basis: 100%;
    padding: 1.25rem 1.25rem 1.75rem 1.25rem;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    align-self: stretch;
`;
const $347ffda0d89c401a$export$e258f2838ef6407 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    justify-self: space-between;
    align-self: stretch;
    flex-grow: 1;
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 0.5rem;
    justify-content: flex-end;
    align-items: stretch;
`;
const $347ffda0d89c401a$export$564cbe3426fc093a = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
`;
const $347ffda0d89c401a$export$56d6cb3330e62b54 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($347ffda0d89c401a$export$564cbe3426fc093a)`
    justify-content: center;
    margin: 1rem 0 2rem 0;
`;
const $347ffda0d89c401a$export$7a6f0da2e354fd03 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    margin-bottom: 0.5rem;
`;
const $347ffda0d89c401a$export$fd5345d4562e9833 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$a6cc38c9c1109f8f))`
    position: absolute;
    top: -0.8rem;
    left: 50%;
    transform: translateX(-50%);
`;
const $347ffda0d89c401a$export$989506d4e6ea852a = (0, $6392222d2b8fb222$export$d14d08fa0d83d69d).withComponent('li');
const $347ffda0d89c401a$export$cd7bba038e96e3a1 = (0, $8de346382d86c747$export$2e2bcd8739ae039).ul`
    padding: 10px;
    columns: 2;
`;
const $347ffda0d89c401a$export$cdfe17842e70350d = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039))`
    border-radius: 0.375rem;
    background: ${(props)=>props.theme.color.accentCard};
    margin-top: 2rem;
    margin-bottom: 2rem;
`;


const $8d7313a1e2f7db62$var$CardStack = ({ id: id, title: title, description: description, name: name, size: size = 50, statusText: tag, tagNode: tagNode, children: children, ...restProps })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $347ffda0d89c401a$export$8ffb7ce587ade322), {
        id: id,
        children: [
            name && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                name: name,
                size: size,
                ...restProps
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($8d7313a1e2f7db62$var$StackWrapCardText, {
                children: [
                    tag && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8d7313a1e2f7db62$var$CustomTag, {
                        children: tag
                    }),
                    tagNode ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($8d7313a1e2f7db62$var$CustomTagNode, {
                        children: [
                            tagNode,
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$2c65789109b698b0), {
                                children: title
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$2c65789109b698b0), {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                        children: description
                    }),
                    children
                ]
            })
        ]
    });
};
// TODO: Did not want to change this because this at the time (Release)
// Should replace this with import of shared tag component: InlineTagNodeWrap
const $8d7313a1e2f7db62$var$CustomTagNode = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
`;
const $8d7313a1e2f7db62$var$CustomTag = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $9926e0d0274623af$export$3288d34c523a1192))`
    margin: 0;
`;
const $8d7313a1e2f7db62$var$StackWrapCardText = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $347ffda0d89c401a$export$9de46b28c4f6c978))`
    padding: 0 1.25rem 1.25rem 1.25rem;
`;
var $8d7313a1e2f7db62$export$2e2bcd8739ae039 = $8d7313a1e2f7db62$var$CardStack;



const $348d9e775387b4da$export$8a73847ccc40addf = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin: 0 auto;
    padding: 0 0 0 2rem;
`;
const $348d9e775387b4da$export$5c96f0521c6e1626 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    max-width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    padding: 2rem;
    margin: 0 auto;
    & > * {
        flex: 1 1 auto;
    }
`;
const $348d9e775387b4da$export$85a4c3b5f32264b8 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    max-width: 100%;
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));
    grid-column-gap: 1rem;
    margin: 1rem 0;
    & > * {
        display: block;
        min-width: 100%;
    }
`;
const $348d9e775387b4da$export$b684108872a6efff = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    max-width: 100vw;
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    grid-column-gap: 1rem;
    margin: 1rem 2rem;
    justify-items: center;
    & > * {
        display: block;
        min-width: 100%;
    }
`;





var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
function $8971fd60a8b100cf$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($7fPBF.version, 10) >= 19) return element?.props?.ref || null;
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return element?.ref || null;
}

function $35e4b0c27d76b933$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


var $7fPBF = parcelRequire("7fPBF");
'use client';
function $e7adb12ba33c17bd$export$2e2bcd8739ae039(...refs) {
    const cleanupRef = $7fPBF.useRef(undefined);
    const refEffect = $7fPBF.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup?.());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $7fPBF.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}



'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $8e062765deddb857$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $8e062765deddb857$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://issues.chromium.org/issues/41283952
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $8e062765deddb857$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $8e062765deddb857$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $8e062765deddb857$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $8e062765deddb857$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($8e062765deddb857$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $8e062765deddb857$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$8e062765deddb857$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $8e062765deddb857$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $8e062765deddb857$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $8e062765deddb857$var$defaultGetTabbable, isEnabled: isEnabled = $8e062765deddb857$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $7fPBF.useRef(false);
    const sentinelStart = $7fPBF.useRef(null);
    const sentinelEnd = $7fPBF.useRef(null);
    const nodeToRestore = $7fPBF.useRef(null);
    const reactFocusEventTarget = $7fPBF.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $7fPBF.useRef(false);
    const rootRef = $7fPBF.useRef(null);
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)((0, $8971fd60a8b100cf$export$2e2bcd8739ae039)(children), rootRef);
    const lastKeydown = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $7fPBF.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $7fPBF.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                const isShiftTab = Boolean(lastKeydown.current?.shiftKey && lastKeydown.current?.key === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $7fPBF.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $8e062765deddb857$export$2e2bcd8739ae039 = $8e062765deddb857$var$FocusTrap;



var $7fPBF = parcelRequire("7fPBF");


/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $e91b37e03c9e5276$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


'use client';
function $7aea8adc1cf7298d$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://v6.mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://v6.mui.com/material-ui/api/portal/)
 */ const $7aea8adc1cf7298d$var$Portal = /*#__PURE__*/ $7fPBF.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $7fPBF.useState(null);
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(/*#__PURE__*/ $7fPBF.isValidElement(children) ? (0, $8971fd60a8b100cf$export$2e2bcd8739ae039)(children) : null, forwardedRef);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($7aea8adc1cf7298d$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $e91b37e03c9e5276$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $e91b37e03c9e5276$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $7fPBF.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $7fPBF.cloneElement(children, newProps);
        }
        return children;
    }
    return mountNode ? /*#__PURE__*/ $b4ba1c853f6e1116$exports.createPortal(children, mountNode) : mountNode;
});
var $7aea8adc1cf7298d$export$2e2bcd8739ae039 = $7aea8adc1cf7298d$var$Portal;






var $7fPBF = parcelRequire("7fPBF");






/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $b4522a0df256fb21$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $b4522a0df256fb21$export$2e2bcd8739ae039 = $b4522a0df256fb21$var$isHostComponent;


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $4520d0f80a3f7305$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $b4522a0df256fb21$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $4520d0f80a3f7305$export$2e2bcd8739ae039 = $4520d0f80a3f7305$var$appendOwnerState;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $ae0f0ccae9f4b3cc$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $ae0f0ccae9f4b3cc$export$2e2bcd8739ae039 = $ae0f0ccae9f4b3cc$var$resolveComponentProps;



/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $7a075a443b93da2d$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $7a075a443b93da2d$export$2e2bcd8739ae039 = $7a075a443b93da2d$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $16d23e6599aa60ec$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $16d23e6599aa60ec$export$2e2bcd8739ae039 = $16d23e6599aa60ec$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $a945a7a9a1371b8c$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $7a075a443b93da2d$export$2e2bcd8739ae039)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $16d23e6599aa60ec$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $16d23e6599aa60ec$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $a945a7a9a1371b8c$export$2e2bcd8739ae039 = $a945a7a9a1371b8c$var$mergeSlotProps;


'use client';
function $6a8e6231295d6b22$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, internalForwardedProps: internalForwardedProps, shouldForwardComponentProp: shouldForwardComponentProp = false, ...useSlotPropsParams } = parameters;
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    }, ...other } = externalForwardedProps;
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $ae0f0ccae9f4b3cc$export$2e2bcd8739ae039)(slotProps[name], ownerState);
    const { props: { component: slotComponent, ...mergedProps }, internalRef: internalRef } = (0, $a945a7a9a1371b8c$export$2e2bcd8739ae039)({
        className: className,
        ...useSlotPropsParams,
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps?.ref, parameters.ref);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $4520d0f80a3f7305$export$2e2bcd8739ae039)(elementType, {
        ...name === 'root' && !rootComponent && !slots[name] && internalForwardedProps,
        ...name !== 'root' && !slots[name] && internalForwardedProps,
        ...mergedProps,
        ...LeafComponent && !shouldForwardComponentProp && {
            as: LeafComponent
        },
        ...LeafComponent && shouldForwardComponentProp && {
            component: LeafComponent
        },
        ref: ref
    }, ownerState);
    return [
        elementType,
        props
    ];
}



var $7fPBF = parcelRequire("7fPBF");


function $da27c96857818bcc$export$2e2bcd8739ae039(t, e) {
    return $da27c96857818bcc$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $da27c96857818bcc$export$2e2bcd8739ae039(t, e);
}


function $146ee816144a450d$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $da27c96857818bcc$export$2e2bcd8739ae039)(t, o);
}




var $7fPBF = parcelRequire("7fPBF");

var $8a9a7006a9b8efe4$export$2e2bcd8739ae039 = {
    disabled: false
};




var $7fPBF = parcelRequire("7fPBF");
var $61c94efb1735eff6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);


var $f1bbb084f2fb10b7$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $623678cbb6daf054$export$bb38bb9a1161268 = 'unmounted';
var $623678cbb6daf054$export$84cbff306f539230 = 'exited';
var $623678cbb6daf054$export$df38205c966be359 = 'entering';
var $623678cbb6daf054$export$78e9e6e3e014d60a = 'entered';
var $623678cbb6daf054$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $623678cbb6daf054$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $146ee816144a450d$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $623678cbb6daf054$export$84cbff306f539230;
                _this.appearStatus = $623678cbb6daf054$export$df38205c966be359;
            } else initialStatus = $623678cbb6daf054$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $623678cbb6daf054$export$bb38bb9a1161268;
        else initialStatus = $623678cbb6daf054$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $623678cbb6daf054$export$bb38bb9a1161268) return {
            status: $623678cbb6daf054$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $623678cbb6daf054$export$df38205c966be359 && status !== $623678cbb6daf054$export$78e9e6e3e014d60a) nextStatus = $623678cbb6daf054$export$df38205c966be359;
            } else if (status === $623678cbb6daf054$export$df38205c966be359 || status === $623678cbb6daf054$export$78e9e6e3e014d60a) nextStatus = $623678cbb6daf054$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $623678cbb6daf054$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($b4ba1c853f6e1116$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $f1bbb084f2fb10b7$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $623678cbb6daf054$export$84cbff306f539230) this.setState({
            status: $623678cbb6daf054$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($b4ba1c853f6e1116$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $8a9a7006a9b8efe4$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $623678cbb6daf054$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $623678cbb6daf054$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $623678cbb6daf054$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($b4ba1c853f6e1116$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $8a9a7006a9b8efe4$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $623678cbb6daf054$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $623678cbb6daf054$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $623678cbb6daf054$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($b4ba1c853f6e1116$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $623678cbb6daf054$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $61c94efb1735eff6$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$623678cbb6daf054$var$Transition.contextType = (0, $61c94efb1735eff6$export$2e2bcd8739ae039);
$623678cbb6daf054$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $623678cbb6daf054$var$noop() {}
$623678cbb6daf054$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $623678cbb6daf054$var$noop,
    onEntering: $623678cbb6daf054$var$noop,
    onEntered: $623678cbb6daf054$var$noop,
    onExit: $623678cbb6daf054$var$noop,
    onExiting: $623678cbb6daf054$var$noop,
    onExited: $623678cbb6daf054$var$noop
};
$623678cbb6daf054$var$Transition.UNMOUNTED = $623678cbb6daf054$export$bb38bb9a1161268;
$623678cbb6daf054$var$Transition.EXITED = $623678cbb6daf054$export$84cbff306f539230;
$623678cbb6daf054$var$Transition.ENTERING = $623678cbb6daf054$export$df38205c966be359;
$623678cbb6daf054$var$Transition.ENTERED = $623678cbb6daf054$export$78e9e6e3e014d60a;
$623678cbb6daf054$var$Transition.EXITING = $623678cbb6daf054$export$4aacc83d4d59139f;
var $623678cbb6daf054$export$2e2bcd8739ae039 = $623678cbb6daf054$var$Transition;




parcelRequire("7fPBF");



'use client';
function $bc16b792e42cac5d$export$2e2bcd8739ae039() {
    const theme = (0, $c44ae2e7a62d29e0$export$2e2bcd8739ae039)((0, $726fe1d2377a5002$export$2e2bcd8739ae039));
    return theme[0, $e35ef6915a224202$export$2e2bcd8739ae039] || theme;
}


const $1ae2edacd7be6319$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $1ae2edacd7be6319$export$8cb1e9b404609ae9(props, options) {
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === 'number' ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}



'use client';
var $4f30d4c1188a58e6$export$2e2bcd8739ae039 = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039);



'use client';
const $68214be7242cbfc8$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $68214be7242cbfc8$var$Fade = /*#__PURE__*/ $7fPBF.forwardRef(function Fade(props, ref) {
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $623678cbb6daf054$export$2e2bcd8739ae039), ...other } = props;
    const enableStrictModeCompat = true;
    const nodeRef = $7fPBF.useRef(null);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(nodeRef, (0, $8971fd60a8b100cf$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $1ae2edacd7be6319$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $7fPBF.cloneElement(children, {
                style: {
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$68214be7242cbfc8$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
var $68214be7242cbfc8$export$2e2bcd8739ae039 = $68214be7242cbfc8$var$Fade;




function $36421d1d94159248$export$9927a91fd93152bd(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiBackdrop', slot);
}
const $36421d1d94159248$var$backdropClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $36421d1d94159248$export$2e2bcd8739ae039 = $36421d1d94159248$var$backdropClasses;



'use client';
const $e70e583d684cb5f4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $36421d1d94159248$export$9927a91fd93152bd), classes);
};
const $e70e583d684cb5f4$var$BackdropRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})({
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent',
    variants: [
        {
            props: {
                invisible: true
            },
            style: {
                backgroundColor: 'transparent'
            }
        }
    ]
});
const $e70e583d684cb5f4$var$Backdrop = /*#__PURE__*/ $7fPBF.forwardRef(function Backdrop(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', invisible: invisible = false, open: open, components: components = {}, componentsProps: componentsProps = {}, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        invisible: invisible
    };
    const classes = $e70e583d684cb5f4$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        root: components.Root,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        ...componentsProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('root', {
        elementType: $e70e583d684cb5f4$var$BackdropRoot,
        externalForwardedProps: externalForwardedProps,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $68214be7242cbfc8$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TransitionSlot, {
        in: open,
        timeout: transitionDuration,
        ...other,
        ...transitionProps,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(RootSlot, {
            "aria-hidden": true,
            ...rootProps,
            classes: classes,
            ref: ref,
            children: children
        })
    });
});
var $e70e583d684cb5f4$export$2e2bcd8739ae039 = $e70e583d684cb5f4$var$Backdrop;



var $7fPBF = parcelRequire("7fPBF");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $d6e7ffad706c848e$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}


var $7fPBF = parcelRequire("7fPBF");

'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $bddccca9f6cee29b$var$useEventCallback(fn) {
    const ref = $7fPBF.useRef(fn);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $7fPBF.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $bddccca9f6cee29b$export$2e2bcd8739ae039 = $bddccca9f6cee29b$var$useEventCallback;



// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $5f729e410b274c00$export$2e2bcd8739ae039(win = window) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = win.document.documentElement.clientWidth;
    return win.innerWidth - documentWidth;
}


function $c1e4563498af7952$export$2e2bcd8739ae039(node) {
    const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


// Is a vertical scrollbar displayed?
function $6368973433f2cfde$var$isOverflowing(container) {
    const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $c1e4563498af7952$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $6368973433f2cfde$export$e1bd0c6150f13d96(element, hide) {
    if (hide) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $6368973433f2cfde$var$getPaddingRight(element) {
    return parseInt((0, $c1e4563498af7952$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $6368973433f2cfde$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.includes(element.tagName);
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $6368973433f2cfde$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, hide) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = !blacklist.includes(element);
        const isNotForbiddenElement = !$6368973433f2cfde$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $6368973433f2cfde$export$e1bd0c6150f13d96(element, hide);
    });
}
function $6368973433f2cfde$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $6368973433f2cfde$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($6368973433f2cfde$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $5f729e410b274c00$export$2e2bcd8739ae039)((0, $c1e4563498af7952$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$6368973433f2cfde$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$6368973433f2cfde$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $c1e4563498af7952$export$2e2bcd8739ae039)(container);
            scrollContainer = parent?.nodeName === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $6368973433f2cfde$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $6368973433f2cfde$export$ce11c4ecd08cea67 {
    constructor(){
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $6368973433f2cfde$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $6368973433f2cfde$var$getHiddenSiblings(container);
        $6368973433f2cfde$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $6368973433f2cfde$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $6368973433f2cfde$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $6368973433f2cfde$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $6368973433f2cfde$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $6368973433f2cfde$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $6368973433f2cfde$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $6368973433f2cfde$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


'use client';
function $bb037c33603903c5$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $bb037c33603903c5$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
const $bb037c33603903c5$var$noop = ()=>{};
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $bb037c33603903c5$var$manager = new (0, $6368973433f2cfde$export$ce11c4ecd08cea67)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $bb037c33603903c5$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $7fPBF.useRef({});
    const mountNodeRef = $7fPBF.useRef(null);
    const modalRef = $7fPBF.useRef(null);
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $7fPBF.useState(!open);
    const hasTransition = $bb037c33603903c5$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        $bb037c33603903c5$var$manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $bb037c33603903c5$var$getContainer(container) || getDoc().body;
        $bb037c33603903c5$var$manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = ()=>$bb037c33603903c5$var$manager.isTopModal(getModal());
    const handlePortalRef = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $6368973433f2cfde$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $7fPBF.useCallback(()=>{
        $bb037c33603903c5$var$manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp
    ]);
    $7fPBF.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $7fPBF.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            otherHandlers.onKeyDown?.(event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            otherHandlers.onClick?.(event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $7a075a443b93da2d$export$2e2bcd8739ae039)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = {
            ...propsEventHandlers,
            ...otherHandlers
        };
        return {
            /*
       * Marking an element with the role presentation indicates to assistive technology
       * that this element should be ignored; it exists to support the web application and
       * is not meant for humans to interact with directly.
       * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
       */ role: 'presentation',
            ...externalEventHandlers,
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        };
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return {
            'aria-hidden': true,
            ...externalEventHandlers,
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        };
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $d6e7ffad706c848e$export$2e2bcd8739ae039)(handleEnter, children?.props.onEnter ?? $bb037c33603903c5$var$noop),
            onExited: (0, $d6e7ffad706c848e$export$2e2bcd8739ae039)(handleExited, children?.props.onExited ?? $bb037c33603903c5$var$noop)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $bb037c33603903c5$export$2e2bcd8739ae039 = $bb037c33603903c5$var$useModal;




function $1581382eb39c1df6$export$67960e22b12a638d(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiModal', slot);
}
const $1581382eb39c1df6$var$modalClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $1581382eb39c1df6$export$2e2bcd8739ae039 = $1581382eb39c1df6$var$modalClasses;




'use client';
const $a65b89a1133e1fe4$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $1581382eb39c1df6$export$67960e22b12a638d), classes);
};
const $a65b89a1133e1fe4$var$ModalRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open && ownerState.exited,
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $a65b89a1133e1fe4$var$ModalBackdrop = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $e70e583d684cb5f4$export$2e2bcd8739ae039), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $a65b89a1133e1fe4$var$Modal = /*#__PURE__*/ $7fPBF.forwardRef(function Modal(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $a65b89a1133e1fe4$var$ModalBackdrop, BackdropProps: BackdropProps, classes: classesProp, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, onClose: onClose, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, open: open, slotProps: slotProps = {}, slots: slots = {}, theme: // eslint-disable-next-line react/prop-types
    theme, ...other } = props;
    const propsWithDefaults = {
        ...props,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    };
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $bb037c33603903c5$export$2e2bcd8739ae039)({
        ...propsWithDefaults,
        rootRef: ref
    });
    const ownerState = {
        ...propsWithDefaults,
        exited: exited
    };
    const classes = $a65b89a1133e1fe4$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const externalForwardedProps = {
        slots: {
            root: components.Root,
            backdrop: components.Backdrop,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $a65b89a1133e1fe4$var$ModalRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        getSlotProps: getRootProps,
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(className, classes?.root, !ownerState.open && ownerState.exited && classes?.hidden)
    });
    const [BackdropSlot, backdropProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('backdrop', {
        ref: BackdropProps?.ref,
        elementType: BackdropComponent,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps({
                ...otherHandlers,
                onClick: (event)=>{
                    if (onBackdropClick) onBackdropClick(event);
                    if (otherHandlers?.onClick) otherHandlers.onClick(event);
                }
            });
        },
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(BackdropProps?.className, classes?.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7aea8adc1cf7298d$export$2e2bcd8739ae039), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(RootSlot, {
            ...rootProps,
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(BackdropSlot, {
                    ...backdropProps
                }) : null,
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8e062765deddb857$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $7fPBF.cloneElement(children, childProps)
                })
            ]
        })
    });
});
var $a65b89a1133e1fe4$export$2e2bcd8739ae039 = $a65b89a1133e1fe4$var$Modal;




var $7fPBF = parcelRequire("7fPBF");












function $bde3e2fffcaea664$export$29cdb466b9b6f20b(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPaper', slot);
}
const $bde3e2fffcaea664$var$paperClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $bde3e2fffcaea664$export$2e2bcd8739ae039 = $bde3e2fffcaea664$var$paperClasses;



'use client';
const $74e245c78e363f11$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $bde3e2fffcaea664$export$29cdb466b9b6f20b), classes);
};
const $74e245c78e363f11$var$PaperRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow'),
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.square,
                style: {
                    borderRadius: theme.shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    variant: 'elevation'
                },
                style: {
                    boxShadow: 'var(--Paper-shadow)',
                    backgroundImage: 'var(--Paper-overlay)'
                }
            }
        ]
    })));
const $74e245c78e363f11$var$Paper = /*#__PURE__*/ $7fPBF.forwardRef(function Paper(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiPaper'
    });
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    };
    const classes = $74e245c78e363f11$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($74e245c78e363f11$var$PaperRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ...other,
        style: {
            ...variant === 'elevation' && {
                '--Paper-shadow': (theme.vars || theme).shadows[elevation],
                ...theme.vars && {
                    '--Paper-overlay': theme.vars.overlays?.[elevation]
                },
                ...!theme.vars && theme.palette.mode === 'dark' && {
                    '--Paper-overlay': `linear-gradient(${(0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)('#fff', (0, $8fa7ddbbf42193a7$export$2e2bcd8739ae039)(elevation))}, ${(0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)('#fff', (0, $8fa7ddbbf42193a7$export$2e2bcd8739ae039)(elevation))})`
                }
            },
            ...other.style
        }
    });
});
var $74e245c78e363f11$export$2e2bcd8739ae039 = $74e245c78e363f11$var$Paper;




function $8523c8ab2139cf2c$export$2177af0aa15c34c2(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiDialog', slot);
}
const $8523c8ab2139cf2c$var$dialogClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $8523c8ab2139cf2c$export$2e2bcd8739ae039 = $8523c8ab2139cf2c$var$dialogClasses;



var $7fPBF = parcelRequire("7fPBF");
'use client';
const $40596d25b0f9c334$var$DialogContext = /*#__PURE__*/ $7fPBF.createContext({});
var $40596d25b0f9c334$export$2e2bcd8739ae039 = $40596d25b0f9c334$var$DialogContext;








'use client';
const $7f096abd658f7c85$var$DialogBackdrop = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $e70e583d684cb5f4$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $7f096abd658f7c85$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(scroll)}`,
            `paperWidth${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $8523c8ab2139cf2c$export$2177af0aa15c34c2), classes);
};
const $7f096abd658f7c85$var$DialogRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $a65b89a1133e1fe4$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $7f096abd658f7c85$var$DialogContainer = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.scroll)}`]
        ];
    }
})({
    height: '100%',
    '@media print': {
        height: 'auto'
    },
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    variants: [
        {
            props: {
                scroll: 'paper'
            },
            style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }
        },
        {
            props: {
                scroll: 'body'
            },
            style: {
                overflowY: 'auto',
                overflowX: 'hidden',
                textAlign: 'center',
                '&::after': {
                    content: '""',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    height: '100%',
                    width: '0'
                }
            }
        }
    ]
});
const $7f096abd658f7c85$var$DialogPaper = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        },
        variants: [
            {
                props: {
                    scroll: 'paper'
                },
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    scroll: 'body'
                },
                style: {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    textAlign: 'initial'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.maxWidth,
                style: {
                    maxWidth: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    maxWidth: 'xs'
                },
                style: {
                    maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
                    [`&.${(0, $8523c8ab2139cf2c$export$2e2bcd8739ae039).paperScrollBody}`]: {
                        [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                            maxWidth: 'calc(100% - 64px)'
                        }
                    }
                }
            },
            ...Object.keys(theme.breakpoints.values).filter((maxWidth)=>maxWidth !== 'xs').map((maxWidth)=>({
                    props: {
                        maxWidth: maxWidth
                    },
                    style: {
                        maxWidth: `${theme.breakpoints.values[maxWidth]}${theme.breakpoints.unit}`,
                        [`&.${(0, $8523c8ab2139cf2c$export$2e2bcd8739ae039).paperScrollBody}`]: {
                            [theme.breakpoints.down(theme.breakpoints.values[maxWidth] + 64)]: {
                                maxWidth: 'calc(100% - 64px)'
                            }
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: 'calc(100% - 64px)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullScreen,
                style: {
                    margin: 0,
                    width: '100%',
                    maxWidth: '100%',
                    height: '100%',
                    maxHeight: 'none',
                    borderRadius: 0,
                    [`&.${(0, $8523c8ab2139cf2c$export$2e2bcd8739ae039).paperScrollBody}`]: {
                        margin: 0,
                        maxWidth: '100%'
                    }
                }
            }
        ]
    })));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $7f096abd658f7c85$var$Dialog = /*#__PURE__*/ $7fPBF.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, 'aria-modal': ariaModal = true, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onBackdropClick: onBackdropClick, onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $74e245c78e363f11$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = 'paper', slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponent = (0, $68214be7242cbfc8$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps, ...other } = props;
    const ownerState = {
        ...props,
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    };
    const classes = $7f096abd658f7c85$var$useUtilityClasses(ownerState);
    const backdropClick = $7fPBF.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $46f5b561912058f9$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $7fPBF.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    const backwardCompatibleSlots = {
        transition: TransitionComponent,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        transition: TransitionProps,
        paper: PaperProps,
        backdrop: BackdropProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootSlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('root', {
        elementType: $7f096abd658f7c85$var$DialogRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref
    });
    const [BackdropSlot, backdropSlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('backdrop', {
        elementType: $7f096abd658f7c85$var$DialogBackdrop,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [PaperSlot, paperSlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('paper', {
        elementType: $7f096abd658f7c85$var$DialogPaper,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.paper, PaperProps.className)
    });
    const [ContainerSlot, containerSlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('container', {
        elementType: $7f096abd658f7c85$var$DialogContainer,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.container)
    });
    const [TransitionSlot, transitionSlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $68214be7242cbfc8$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: 'presentation'
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(RootSlot, {
        closeAfterTransition: true,
        slots: {
            backdrop: BackdropSlot
        },
        slotProps: {
            backdrop: {
                transitionDuration: transitionDuration,
                as: BackdropComponent,
                ...backdropSlotProps
            }
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        onClick: handleBackdropClick,
        ...rootSlotProps,
        ...other,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ContainerSlot, {
                onMouseDown: handleMouseDown,
                ...containerSlotProps,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(PaperSlot, {
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby,
                    "aria-modal": ariaModal,
                    ...paperSlotProps,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40596d25b0f9c334$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                })
            })
        })
    });
});
var $7f096abd658f7c85$export$2e2bcd8739ae039 = $7f096abd658f7c85$var$Dialog;







var $7fPBF = parcelRequire("7fPBF");

const $1bb13d1f471bb27c$var$IconsButton = /*#__PURE__*/ (0, $7fPBF.forwardRef)(({ label: label, circle: circle = false, $color: $color = 'secondary', hideBorder: hideBorder = false, ...restProps }, ref)=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1bb13d1f471bb27c$var$StyledButton, {
        ref: ref,
        $color: $color,
        $size: "quick",
        $borderRadius: circle,
        $hideBorder: hideBorder,
        ...restProps,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30af349a5a5f3e57$export$2e2bcd8739ae039), {
            children: label
        })
    });
});
const $1bb13d1f471bb27c$var$StyledButton = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== '$borderRadius' && prop !== '$hideBorder'
})`
    height: min-content;
    gap: 0;
    padding: 0;
    max-width: min-content;
    ${(props)=>props.$hideBorder ? 'border: none;' : ''}
    ${(props)=>props.$borderRadius ? 'border-radius: 50%;' : ''}
    svg {
        padding: 0.5rem;
    }
`;
var $1bb13d1f471bb27c$export$2e2bcd8739ae039 = $1bb13d1f471bb27c$var$IconsButton;







var $7fPBF = parcelRequire("7fPBF");







function $38158dbfc23b097a$export$5e57a444791c63be(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiDialogActions', slot);
}
const $38158dbfc23b097a$var$dialogActionsClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $38158dbfc23b097a$export$2e2bcd8739ae039 = $38158dbfc23b097a$var$dialogActionsClasses;



'use client';
const $6282a3c293a0d8c9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $38158dbfc23b097a$export$5e57a444791c63be), classes);
};
const $6282a3c293a0d8c9$var$DialogActionsRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    flex: '0 0 auto',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disableSpacing,
            style: {
                '& > :not(style) ~ :not(style)': {
                    marginLeft: 8
                }
            }
        }
    ]
});
const $6282a3c293a0d8c9$var$DialogActions = /*#__PURE__*/ $7fPBF.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false, ...other } = props;
    const ownerState = {
        ...props,
        disableSpacing: disableSpacing
    };
    const classes = $6282a3c293a0d8c9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6282a3c293a0d8c9$var$DialogActionsRoot, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $6282a3c293a0d8c9$export$2e2bcd8739ae039 = $6282a3c293a0d8c9$var$DialogActions;


var $7fPBF = parcelRequire("7fPBF");








function $64f614045184fa19$export$61b0ee1f05fb344e(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiDialogContent', slot);
}
const $64f614045184fa19$var$dialogContentClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $64f614045184fa19$export$2e2bcd8739ae039 = $64f614045184fa19$var$dialogContentClasses;




function $18611d95980659c6$export$f5d2ec7e4c47e088(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiDialogTitle', slot);
}
const $18611d95980659c6$var$dialogTitleClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiDialogTitle', [
    'root'
]);
var $18611d95980659c6$export$2e2bcd8739ae039 = $18611d95980659c6$var$dialogTitleClasses;



'use client';
const $634ad3fd5060cf75$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $64f614045184fa19$export$61b0ee1f05fb344e), classes);
};
const $634ad3fd5060cf75$var$DialogContentRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.dividers,
                style: {
                    padding: '16px 24px',
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dividers,
                style: {
                    [`.${(0, $18611d95980659c6$export$2e2bcd8739ae039).root} + &`]: {
                        paddingTop: 0
                    }
                }
            }
        ]
    })));
const $634ad3fd5060cf75$var$DialogContent = /*#__PURE__*/ $7fPBF.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false, ...other } = props;
    const ownerState = {
        ...props,
        dividers: dividers
    };
    const classes = $634ad3fd5060cf75$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($634ad3fd5060cf75$var$DialogContentRoot, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $634ad3fd5060cf75$export$2e2bcd8739ae039 = $634ad3fd5060cf75$var$DialogContent;


var $7fPBF = parcelRequire("7fPBF");







var $7fPBF = parcelRequire("7fPBF");



parcelRequire("7fPBF");


const $8eb9ca5f8e856bd1$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? (0, $8563e7d5caf9f77c$export$2e2bcd8739ae039);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $8eb9ca5f8e856bd1$export$2e2bcd8739ae039(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $8eb9ca5f8e856bd1$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $291e2c063c5d6173$export$53b83ca8eaab0383)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}



parcelRequire("7fPBF");





'use client';
function $a50e20ff7f02e09b$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a68fc7f0d1abfe1c$export$2e2bcd8739ae039), {
        ...props,
        defaultTheme: (0, $726fe1d2377a5002$export$2e2bcd8739ae039),
        themeId: (0, $e35ef6915a224202$export$2e2bcd8739ae039)
    });
}
var $a50e20ff7f02e09b$export$2e2bcd8739ae039 = $a50e20ff7f02e09b$var$GlobalStyles;





function $1f6ac09903fa2f15$export$db53682eef82cc11(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, $824c049f32d4395d$exports.jsx)((0, $a50e20ff7f02e09b$export$2e2bcd8739ae039), {
            styles: typeof styles === 'function' ? (theme)=>styles({
                    theme: theme,
                    ...props
                }) : styles
        }));
    };
}
function $1f6ac09903fa2f15$export$7e7f5719ff4debb1() {
    return 0, $8eb9ca5f8e856bd1$export$2e2bcd8739ae039;
}








function $d9914d0380157c73$export$24c1f8f60cbac79e(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiTypography', slot);
}
const $d9914d0380157c73$var$typographyClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $d9914d0380157c73$export$2e2bcd8739ae039 = $d9914d0380157c73$var$typographyClasses;



'use client';
const $26f68e516ee75fc4$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $26f68e516ee75fc4$var$extendSxProp = (0, $1f6ac09903fa2f15$export$7e7f5719ff4debb1)();
const $26f68e516ee75fc4$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $d9914d0380157c73$export$24c1f8f60cbac79e), classes);
};
const $26f68e516ee75fc4$export$140e2f5526d3cad8 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        margin: 0,
        variants: [
            {
                props: {
                    variant: 'inherit'
                },
                style: {
                    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
                    font: 'inherit',
                    lineHeight: 'inherit',
                    letterSpacing: 'inherit'
                }
            },
            ...Object.entries(theme.typography).filter(([variant, value])=>variant !== 'inherit' && value && typeof value === 'object').map(([variant, value])=>({
                    props: {
                        variant: variant
                    },
                    style: value
                })),
            ...Object.entries(theme.palette).filter((0, $061b5988a3817e26$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette?.text || {}).filter(([, value])=>typeof value === 'string').map(([color])=>({
                    props: {
                        color: `text${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`
                    },
                    style: {
                        color: (theme.vars || theme).palette.text[color]
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.align !== 'inherit',
                style: {
                    textAlign: 'var(--Typography-textAlign)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.noWrap,
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.gutterBottom,
                style: {
                    marginBottom: '0.35em'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.paragraph,
                style: {
                    marginBottom: 16
                }
            }
        ]
    })));
const $26f68e516ee75fc4$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
const $26f68e516ee75fc4$var$Typography = /*#__PURE__*/ $7fPBF.forwardRef(function Typography(inProps, ref) {
    const { color: color, ...themeProps } = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTypography'
    });
    const isSxColor = !$26f68e516ee75fc4$var$v6Colors[color];
    // TODO: Remove `extendSxProp` in v7
    const props = $26f68e516ee75fc4$var$extendSxProp({
        ...themeProps,
        ...isSxColor && {
            color: color
        }
    });
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $26f68e516ee75fc4$var$defaultVariantMapping, ...other } = props;
    const ownerState = {
        ...props,
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    };
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $26f68e516ee75fc4$var$defaultVariantMapping[variant]) || 'span';
    const classes = $26f68e516ee75fc4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($26f68e516ee75fc4$export$140e2f5526d3cad8, {
        as: Component,
        ref: ref,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ...other,
        ownerState: ownerState,
        style: {
            ...align !== 'inherit' && {
                '--Typography-textAlign': align
            },
            ...other.style
        }
    });
});
var $26f68e516ee75fc4$export$2e2bcd8739ae039 = $26f68e516ee75fc4$var$Typography;




function $b03b9298fa0c5ca0$export$d9c6dc45f75b0e4f(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiDialogContentText', slot);
}
const $b03b9298fa0c5ca0$var$dialogContentTextClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiDialogContentText', [
    'root'
]);
var $b03b9298fa0c5ca0$export$2e2bcd8739ae039 = $b03b9298fa0c5ca0$var$dialogContentTextClasses;



'use client';
const $2e2eabdc21c2ded9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $b03b9298fa0c5ca0$export$d9c6dc45f75b0e4f), classes);
    return {
        ...classes,
        // forward classes to the Typography
        ...composedClasses
    };
};
const $2e2eabdc21c2ded9$var$DialogContentTextRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $0820e164eb5fbaff$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiDialogContentText',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $2e2eabdc21c2ded9$var$DialogContentText = /*#__PURE__*/ $7fPBF.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialogContentText'
    });
    const { children: children, className: className, ...ownerState } = props;
    const classes = $2e2eabdc21c2ded9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2e2eabdc21c2ded9$var$DialogContentTextRoot, {
        component: "p",
        variant: "body1",
        color: "textSecondary",
        ref: ref,
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ...props,
        classes: classes
    });
});
var $2e2eabdc21c2ded9$export$2e2bcd8739ae039 = $2e2eabdc21c2ded9$var$DialogContentText;


var $7fPBF = parcelRequire("7fPBF");









'use client';
const $ac75506ecdb312f1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $18611d95980659c6$export$f5d2ec7e4c47e088), classes);
};
const $ac75506ecdb312f1$var$DialogTitleRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
    name: 'MuiDialogTitle',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $ac75506ecdb312f1$var$DialogTitle = /*#__PURE__*/ $7fPBF.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp, ...other } = props;
    const ownerState = props;
    const classes = $ac75506ecdb312f1$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $7fPBF.useContext((0, $40596d25b0f9c334$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ac75506ecdb312f1$var$DialogTitleRoot, {
        component: "h2",
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp ?? titleId,
        ...other
    });
});
var $ac75506ecdb312f1$export$2e2bcd8739ae039 = $ac75506ecdb312f1$var$DialogTitle;



const $082accbd174d656b$export$a821680a90fed6 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $ac75506ecdb312f1$export$2e2bcd8739ae039))`
    flex: 0 1 auto;
    padding: 0;
    margin: 0;
    align-self: center;
    font-weight: 900;
    font-size: 1.75rem; // 28px
    color: ${(props)=>props.theme.color.text};
    line-height: 2rem; // 32px
    word-break: break-word;
`;
const $082accbd174d656b$export$6f975883ded828a4 = (0, $8de346382d86c747$export$2e2bcd8739ae039)('div')`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    padding: 1.5rem 1.5rem 0 1.5rem;
    gap: 0.5rem;
`;
const $082accbd174d656b$export$5a0bc68f6657e9db = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039))`
    padding: 0.25rem 1.5rem 1rem 1.5rem;
`;
const $082accbd174d656b$export$174d4944f63edcc7 = (0, $8de346382d86c747$export$2e2bcd8739ae039)('div')`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    margin-top: 1rem;
`;
const $082accbd174d656b$export$d6e3240af6047b76 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $2e2eabdc21c2ded9$export$2e2bcd8739ae039))`
    padding: 0.25rem 1.5rem 1.5rem 1.5rem;
`;
const $082accbd174d656b$export$e1b02e289332d3a3 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $9926e0d0274623af$export$3288d34c523a1192))`
    word-break: keep-all;
    font-size: 0.875rem;
    line-height: 1.125rem; // 20px
`;
const $082accbd174d656b$export$b54ac9d7963ef6f6 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039))`
    padding: 0 1.5rem 1.5rem 1.5rem;
    align-items: center;
`;


function $54aed6520e5f6aee$export$2e2bcd8739ae039({ title: title, description: description, onCancel: onCancel, cancelButtonText: cancelButtonText, onConfirm: onConfirm, onClose: onClose, confirmButtonText: confirmButtonText, confirmIcon: confirmIcon, cancelIcon: cancelIcon, children: children, scroll: scroll = 'paper', dialogTag: dialogTag, ...restProps }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const theme = (0, $d62c6f18f523e962$export$3b14a55fb2447963)();
    const randomId = (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)();
    const cancelText = cancelButtonText ?? t('common:cancel');
    const confirmText = confirmButtonText ?? t('common:save');
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7f096abd658f7c85$export$2e2bcd8739ae039), {
        sx: {
            '& .MuiPaper-root': {
                borderStyle: 'solid',
                borderWidth: '1px',
                borderColor: theme.color.border,
                background: theme.color.background
            }
        },
        scroll: scroll,
        onClose: onClose,
        "aria-labelledby": `dialog-title-${randomId}`,
        "aria-describedby": description ? `dialog-description-${randomId}` : undefined,
        ...restProps,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$6f975883ded828a4), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$a821680a90fed6), {
                        id: `dialog-title-${randomId}`,
                        children: [
                            dialogTag && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $082accbd174d656b$export$e1b02e289332d3a3), {
                                as: "span",
                                children: dialogTag
                            }),
                            title
                        ]
                    }),
                    onClose && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bb13d1f471bb27c$export$2e2bcd8739ae039), {
                        label: 'Close',
                        startIcon: "close",
                        $color: "accent",
                        onClick: onClose
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$5a0bc68f6657e9db), {
                children: [
                    description && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                        id: `dialog-description-${randomId}`,
                        children: description
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$b54ac9d7963ef6f6), {
                children: [
                    cancelText && onCancel && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        $size: "small",
                        $color: "simple",
                        startIcon: cancelIcon,
                        onClick: onCancel,
                        children: cancelText
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        $size: "small",
                        $color: "secondary",
                        startIcon: confirmIcon,
                        onClick: onConfirm,
                        children: confirmText
                    })
                ]
            })
        ]
    });
}


const $0609c53c7172c5fc$export$da6d2f7032b7150b = (route)=>{
    // we use a hash router for web and desktop so local routes need "#" in front of them
    return '#' + route;
};





var $7fPBF = parcelRequire("7fPBF");


function $e30fe951f2edb943$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const location = (0, $5ec159caebd3ae22$export$45d76561a5302f2b)();
    const { organizationId: organizationId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const editProfileContainer = (0, $697752726c88b03c$export$2e2bcd8739ae039).useContainer();
    const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] = (0, $7fPBF.useState)(false);
    const handleDelete = async ()=>{
        if (!editProfileContainer.id) return;
        (0, $e7df95de73caec26$export$89b472e03be495df)('userProfileDeleted', {
            profileId: editProfileContainer.id
        });
        if (organizationId) navigate(`/org/${organizationId}/profiles`, {
            replace: true
        });
        else navigate('/profiles', {
            replace: true
        });
    };
    if (!editProfileContainer.commandKeyMappings) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $348d9e775387b4da$export$8a73847ccc40addf), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
                        name: "touchpad",
                        title: t('common:keys.title'),
                        description: t('common:keys.description'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                            variant: "context",
                            href: (0, $0609c53c7172c5fc$export$da6d2f7032b7150b)(`${location.pathname}/keybindings`),
                            children: t('common:keys.edit')
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
                        name: "virtualButton",
                        title: t('common:hotkey.titlePlural'),
                        description: t('common:hotkey.description'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                            variant: "context",
                            href: (0, $0609c53c7172c5fc$export$da6d2f7032b7150b)(`${location.pathname}/hotkeys`),
                            children: t('common:hotkey.edit')
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
                        name: "dictationPlay",
                        title: t('common:dictation.title'),
                        description: t('common:dictation.description'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                            variant: "context",
                            href: (0, $0609c53c7172c5fc$export$da6d2f7032b7150b)(`${location.pathname}/dictation`),
                            children: t('common:dictation.edit')
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
                        name: "ai",
                        title: t('common:suggestedPrompts.title'),
                        description: t('common:suggestedPrompts.description'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                            variant: "context",
                            href: (0, $0609c53c7172c5fc$export$da6d2f7032b7150b)(`${location.pathname}/suggested-prompts`),
                            children: t('common:suggestedPrompts.edit')
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
                        name: "details",
                        title: t('common:profile.summary.title'),
                        description: t('common:profile.summary.description'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                            variant: "context",
                            href: (0, $0609c53c7172c5fc$export$da6d2f7032b7150b)(`${location.pathname}/summary`),
                            disabled: editProfileContainer.isPreview,
                            children: t('common:profile.summary.view')
                        })
                    }),
                    editProfileContainer?.id && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
                        name: "share",
                        title: t('common:share'),
                        description: t('common:profile.share.description'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                            variant: "context",
                            href: (0, $0609c53c7172c5fc$export$da6d2f7032b7150b)(`${location.pathname}/share`),
                            children: t('common:profile.share.title')
                        })
                    }),
                    editProfileContainer?.id && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
                        name: "delete",
                        title: t('common:dangerZone'),
                        description: t('common:profile.delete.description'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                            variant: "context",
                            onClick: ()=>setIsDeleteConfirmationOpen(true),
                            children: t('common:profile.delete.title')
                        })
                    })
                ]
            }),
            isDeleteConfirmationOpen && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
                open: isDeleteConfirmationOpen,
                onCancel: ()=>setIsDeleteConfirmationOpen(false),
                title: t('common:profile.delete.confirm'),
                description: t('common:profile.delete.confirmLong'),
                onConfirm: handleDelete,
                confirmButtonText: t('common:profile.delete.confirmButton'),
                cancelButtonText: t('common:cancel'),
                confirmIcon: "delete"
            })
        ]
    });
}






function $6f812bcbdad827c6$var$insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert('', serialized, cache.sheet, true);
}
function $6f812bcbdad827c6$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $48e4b1fcfcd646c1$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $6f812bcbdad827c6$export$2e2bcd8739ae039 = function createEmotion(options) {
    var cache = (0, $0bb108cf9f15301b$export$2e2bcd8739ae039)(options);
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)(args, cache.registered, undefined);
        (0, $48e4b1fcfcd646c1$export$6f077d94b33a01aa)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        $6f812bcbdad827c6$var$insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)(args, cache.registered);
        $6f812bcbdad827c6$var$insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $6f812bcbdad827c6$var$merge(cache.registered, css, $6f812bcbdad827c6$var$classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, $48e4b1fcfcd646c1$export$95d99596f328fd52).bind(null, cache.registered),
        merge: $6f812bcbdad827c6$var$merge.bind(null, cache.registered, css)
    };
};
var $6f812bcbdad827c6$var$classnames = function classnames(args) {
    var cls = '';
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};





var $d77565acc82ac668$var$_createEmotion = (0, $6f812bcbdad827c6$export$2e2bcd8739ae039)({
    key: 'css'
}), $d77565acc82ac668$export$4909b86c8034bf73 = $d77565acc82ac668$var$_createEmotion.flush, $d77565acc82ac668$export$fa8d919ba61d84db = $d77565acc82ac668$var$_createEmotion.hydrate, $d77565acc82ac668$export$a274e22fb40f762e = $d77565acc82ac668$var$_createEmotion.cx, $d77565acc82ac668$export$4950aa0f605343fb = $d77565acc82ac668$var$_createEmotion.merge, $d77565acc82ac668$export$95d99596f328fd52 = $d77565acc82ac668$var$_createEmotion.getRegisteredStyles, $d77565acc82ac668$export$efb9f5caaa2ca0c7 = $d77565acc82ac668$var$_createEmotion.injectGlobal, $d77565acc82ac668$export$d25ddfdf17c3ad3e = $d77565acc82ac668$var$_createEmotion.keyframes, $d77565acc82ac668$export$dbf350e5966cf602 = $d77565acc82ac668$var$_createEmotion.css, $d77565acc82ac668$export$995990c5c04c46f0 = $d77565acc82ac668$var$_createEmotion.sheet, $d77565acc82ac668$export$69a3209f1a06c04d = $d77565acc82ac668$var$_createEmotion.cache;










// TODO DEPRECATE we now use Card from cards/Card.tsx
const $184b8f5fc607fb11$var$LegacyCard = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    transition: ${(0, $8951886a6b49e92a$export$66bb15e2994e6a26).default};
    overflow: hidden;
    border-radius: 10px;
`;
const $184b8f5fc607fb11$export$eeffb7d514a37123 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    transition: ${(0, $8951886a6b49e92a$export$66bb15e2994e6a26).default};
    background-color: ${(props)=>props.theme.color.background};
    border-radius: 10px;
`;
const $184b8f5fc607fb11$export$e0b30d1797fa97ad = (0, $8de346382d86c747$export$2e2bcd8739ae039)($184b8f5fc607fb11$var$LegacyCard)`
    cursor: pointer;
    &:hover {
        box-shadow: ${(0, $8951886a6b49e92a$export$16e1fc8de5cd9687).hover};
    }
    &:focus-within {
        outline: ${(0, $8951886a6b49e92a$export$35e9368ef982300f).accent} auto 2px;
    }
`;
var $184b8f5fc607fb11$export$2e2bcd8739ae039 = $184b8f5fc607fb11$var$LegacyCard;


const $30f62651b17206ee$var$ActionCardWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $184b8f5fc607fb11$export$2e2bcd8739ae039))`
    border: 1px solid ${(0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_light};
    box-shadow: none;
    display: flex;
    overflow: visible;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 380px;
    max-width: 800px;
    width: 100%;
    padding: 16px;
    background-color: ${(props)=>props.theme.color.background};
    color: ${(props)=>props.theme.color.text};
    > * {
        margin: 8px 16px;
    }
`;
var $30f62651b17206ee$export$2e2bcd8739ae039 = $30f62651b17206ee$var$ActionCardWrapper;



const $e5f1d53bbf8fecdc$var$ChipButtonContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
`;
var $e5f1d53bbf8fecdc$export$2e2bcd8739ae039 = $e5f1d53bbf8fecdc$var$ChipButtonContainer;



// TODO MOVE TO COMPONENTS
const $4f907cce853cc2ff$var$MenuCardContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 64px 32px;
    flex: 1;
    width: 100%;
    gap: 0.5rem;
`;
var $4f907cce853cc2ff$export$2e2bcd8739ae039 = $4f907cce853cc2ff$var$MenuCardContainer;







const $73229ceea4361fb2$var$FieldContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    padding: 0 16px;
    margin: 16px 0;

    input {
        margin-top: 4px;
        width: calc(100% - 32px);
    }
`;
var $73229ceea4361fb2$export$2e2bcd8739ae039 = $73229ceea4361fb2$var$FieldContainer;




var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $c285f587ed4585eb$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}



'use client';
function $fb9bd25a2238f701$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $fb9bd25a2238f701$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $fb9bd25a2238f701$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $fb9bd25a2238f701$var$isEmpty(obj) {
    return $fb9bd25a2238f701$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://v6.mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://v6.mui.com/material-ui/api/textarea-autosize/)
 */ const $fb9bd25a2238f701$var$TextareaAutosize = /*#__PURE__*/ $7fPBF.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value, ...other } = props;
    const { current: isControlled } = $7fPBF.useRef(value != null);
    const textareaRef = $7fPBF.useRef(null);
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(forwardedRef, textareaRef);
    const heightRef = $7fPBF.useRef(null);
    const hiddenTextareaRef = $7fPBF.useRef(null);
    const calculateTextareaStyles = $7fPBF.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $c1e4563498af7952$export$2e2bcd8739ae039)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $fb9bd25a2238f701$var$getStyleValue(computedStyle.paddingBottom) + $fb9bd25a2238f701$var$getStyleValue(computedStyle.paddingTop);
        const border = $fb9bd25a2238f701$var$getStyleValue(computedStyle.borderBottomWidth) + $fb9bd25a2238f701$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $fb9bd25a2238f701$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $7fPBF.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $fb9bd25a2238f701$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $7fPBF.useRef(-1);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        const debouncedHandleResize = (0, $c285f587ed4585eb$export$2e2bcd8739ae039)(syncHeight);
        const textarea = textareaRef?.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $c1e4563498af7952$export$2e2bcd8739ae039)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", {
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style,
                ...other
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: {
                    ...$fb9bd25a2238f701$var$styles.shadow,
                    ...style,
                    paddingTop: 0,
                    paddingBottom: 0
                }
            })
        ]
    });
});
var $fb9bd25a2238f701$export$2e2bcd8739ae039 = $fb9bd25a2238f701$var$TextareaAutosize;


/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $1a5b8306608cd33a$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $1a5b8306608cd33a$export$2e2bcd8739ae039 = $1a5b8306608cd33a$var$isHostComponent;


function $e570c333aacea667$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $7fPBF = parcelRequire("7fPBF");
'use client';
/**
 * @ignore - internal component.
 */ const $f29d66cab44a33c0$var$FormControlContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
var $f29d66cab44a33c0$export$2e2bcd8739ae039 = $f29d66cab44a33c0$var$FormControlContext;



var $7fPBF = parcelRequire("7fPBF");

'use client';
function $1af6f86e160474f0$export$2e2bcd8739ae039() {
    return $7fPBF.useContext((0, $f29d66cab44a33c0$export$2e2bcd8739ae039));
}








'use client';
var $cfde3819487a0686$export$2e2bcd8739ae039 = (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039);


// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $5e9f5ca6e3e911fc$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $5e9f5ca6e3e911fc$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($5e9f5ca6e3e911fc$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $5e9f5ca6e3e911fc$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $5e9f5ca6e3e911fc$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}




function $2b15682cef07fc0a$export$ef57d5c8ca2278f6(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiInputBase', slot);
}
const $2b15682cef07fc0a$var$inputBaseClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $2b15682cef07fc0a$export$2e2bcd8739ae039 = $2b15682cef07fc0a$var$inputBaseClasses;



'use client';
var $ba9f7182d6802613$var$_InputGlobalStyles;
const $ba9f7182d6802613$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $ba9f7182d6802613$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $ba9f7182d6802613$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $2b15682cef07fc0a$export$ef57d5c8ca2278f6), classes);
};
const $ba9f7182d6802613$export$298a043133d72a38 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $ba9f7182d6802613$export$965edad20a84fa75
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body1,
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $2b15682cef07fc0a$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '4px 0 5px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: '100%'
                }
            }
        ]
    })));
const $ba9f7182d6802613$export$ee10465db6ff6017 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $ba9f7182d6802613$export$cf507b112810e72d
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = {
        color: 'currentColor',
        ...theme.vars ? {
            opacity: theme.vars.opacity.inputPlaceholder
        } : {
            opacity: light ? 0.42 : 0.5
        },
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    };
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return {
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $2b15682cef07fc0a$export$2e2bcd8739ae039).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $2b15682cef07fc0a$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInjectingGlobalStyles,
                style: {
                    animationName: 'mui-auto-fill-cancel',
                    animationDuration: '10ms',
                    '&:-webkit-autofill': {
                        animationDuration: '5000s',
                        animationName: 'mui-auto-fill'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    height: 'auto',
                    resize: 'none',
                    padding: 0,
                    paddingTop: 0
                }
            },
            {
                props: {
                    type: 'search'
                },
                style: {
                    MozAppearance: 'textfield' // Improve type search style.
                }
            }
        ]
    };
}));
const $ba9f7182d6802613$var$InputGlobalStyles = (0, $1f6ac09903fa2f15$export$db53682eef82cc11)({
    '@keyframes mui-auto-fill': {
        from: {
            display: 'block'
        }
    },
    '@keyframes mui-auto-fill-cancel': {
        from: {
            display: 'block'
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $ba9f7182d6802613$var$InputBase = /*#__PURE__*/ $7fPBF.forwardRef(function InputBase(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, color: color, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, error: error, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, margin: margin, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, size: size, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp, ...other } = props;
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $7fPBF.useRef(value != null);
    const inputRef = $7fPBF.useRef();
    const handleInputRefWarning = $7fPBF.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $7fPBF.useState(false);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $7fPBF.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $7fPBF.useCallback((obj)=>{
        if ((0, $5e9f5ca6e3e911fc$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $cfde3819487a0686$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $9afc3518733c6a5e$export$2e2bcd8739ae039)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $7fPBF.useEffect(()=>{
        checkDirty(inputRef.current);
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = {
            type: undefined,
            minRows: rows,
            maxRows: rows,
            ...inputProps
        };
        else inputProps = {
            type: undefined,
            maxRows: maxRows,
            minRows: minRows,
            ...inputProps
        };
        InputComponent = (0, $fb9bd25a2238f701$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $7fPBF.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    };
    const classes = $ba9f7182d6802613$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $ba9f7182d6802613$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $ba9f7182d6802613$export$ee10465db6ff6017;
    inputProps = {
        ...inputProps,
        ...slotProps.input ?? componentsProps.input
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
        children: [
            !disableInjectingGlobalStyles && typeof $ba9f7182d6802613$var$InputGlobalStyles === 'function' && // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
            ($ba9f7182d6802613$var$_InputGlobalStyles || ($ba9f7182d6802613$var$_InputGlobalStyles = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ba9f7182d6802613$var$InputGlobalStyles, {}))),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(Root, {
                ...rootProps,
                ref: ref,
                onClick: handleClick,
                ...other,
                ...!(0, $1a5b8306608cd33a$export$2e2bcd8739ae039)(Root) && {
                    ownerState: {
                        ...ownerState,
                        ...rootProps.ownerState
                    }
                },
                className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f29d66cab44a33c0$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Input, {
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type,
                            ...inputProps,
                            ...!(0, $1a5b8306608cd33a$export$2e2bcd8739ae039)(Input) && {
                                as: InputComponent,
                                ownerState: {
                                    ...ownerState,
                                    ...inputProps.ownerState
                                }
                            },
                            ref: handleInputRef,
                            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        })
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix({
                        ...fcs,
                        startAdornment: startAdornment
                    }) : null
                ]
            })
        ]
    });
});
var $ba9f7182d6802613$export$2e2bcd8739ae039 = $ba9f7182d6802613$var$InputBase;










function $aadd2b32ac43594b$export$cdb270390122322b(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiInput', slot);
}
const $aadd2b32ac43594b$var$inputClasses = {
    ...(0, $2b15682cef07fc0a$export$2e2bcd8739ae039),
    ...(0, $32447174989d1976$export$2e2bcd8739ae039)('MuiInput', [
        'root',
        'underline',
        'input'
    ])
};
var $aadd2b32ac43594b$export$2e2bcd8739ae039 = $aadd2b32ac43594b$var$inputClasses;




'use client';
const $e0d49bb29c2f8b76$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $aadd2b32ac43594b$export$cdb270390122322b), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $e0d49bb29c2f8b76$var$InputRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $ba9f7182d6802613$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $0820e164eb5fbaff$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $ba9f7182d6802613$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return {
        position: 'relative',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    'label + &': {
                        marginTop: 16
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $aadd2b32ac43594b$export$2e2bcd8739ae039).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $aadd2b32ac43594b$export$2e2bcd8739ae039).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $aadd2b32ac43594b$export$2e2bcd8739ae039).disabled}, .${(0, $aadd2b32ac43594b$export$2e2bcd8739ae039).error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${(0, $aadd2b32ac43594b$export$2e2bcd8739ae039).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $061b5988a3817e26$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                }))
        ]
    };
}));
const $e0d49bb29c2f8b76$var$InputInput = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $ba9f7182d6802613$export$ee10465db6ff6017), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $ba9f7182d6802613$export$cf507b112810e72d)
})({});
const $e0d49bb29c2f8b76$var$Input = /*#__PURE__*/ $7fPBF.forwardRef(function Input(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const classes = $e0d49bb29c2f8b76$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $291e2c063c5d6173$export$2e2bcd8739ae039)(slotProps ?? componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $e0d49bb29c2f8b76$var$InputRoot;
    const InputSlot = slots.input ?? components.Input ?? $e0d49bb29c2f8b76$var$InputInput;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ba9f7182d6802613$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$e0d49bb29c2f8b76$var$Input.muiName = 'Input';
var $e0d49bb29c2f8b76$export$2e2bcd8739ae039 = $e0d49bb29c2f8b76$var$Input;



var $7fPBF = parcelRequire("7fPBF");













function $c2b262889cde4af1$export$3331e419f1a48437(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiFilledInput', slot);
}
const $c2b262889cde4af1$var$filledInputClasses = {
    ...(0, $2b15682cef07fc0a$export$2e2bcd8739ae039),
    ...(0, $32447174989d1976$export$2e2bcd8739ae039)('MuiFilledInput', [
        'root',
        'underline',
        'input',
        'adornedStart',
        'adornedEnd',
        'sizeSmall',
        'multiline',
        'hiddenLabel'
    ])
};
var $c2b262889cde4af1$export$2e2bcd8739ae039 = $c2b262889cde4af1$var$filledInputClasses;





'use client';
const $faf35b44bb61ebfd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline, startAdornment: startAdornment, endAdornment: endAdornment, size: size, hiddenLabel: hiddenLabel, multiline: multiline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            size === 'small' && `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            hiddenLabel && 'hiddenLabel',
            multiline && 'multiline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $c2b262889cde4af1$export$3331e419f1a48437), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $faf35b44bb61ebfd$var$FilledInputRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $ba9f7182d6802613$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $0820e164eb5fbaff$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $ba9f7182d6802613$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).disabled}, .${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $061b5988a3817e26$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        disableUnderline: false,
                        color: color
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '25px 12px 8px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            }
        ]
    };
}));
const $faf35b44bb61ebfd$var$FilledInputInput = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $ba9f7182d6802613$export$ee10465db6ff6017), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $ba9f7182d6802613$export$cf507b112810e72d)
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12,
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0
                }
            }
        ]
    })));
const $faf35b44bb61ebfd$var$FilledInput = /*#__PURE__*/ $7fPBF.forwardRef(function FilledInput(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const ownerState = {
        ...props,
        disableUnderline: disableUnderline,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    };
    const classes = $faf35b44bb61ebfd$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $291e2c063c5d6173$export$2e2bcd8739ae039)(filledInputComponentsProps, slotProps ?? componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $faf35b44bb61ebfd$var$FilledInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $faf35b44bb61ebfd$var$FilledInputInput;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ba9f7182d6802613$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$faf35b44bb61ebfd$var$FilledInput.muiName = 'Input';
var $faf35b44bb61ebfd$export$2e2bcd8739ae039 = $faf35b44bb61ebfd$var$FilledInput;



var $7fPBF = parcelRequire("7fPBF");



parcelRequire("7fPBF");





'use client';
var $ae700d9709d2b786$var$_span;
const $ae700d9709d2b786$var$NotchedOutlineRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('fieldset', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $0820e164eb5fbaff$export$2e2bcd8739ae039)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $ae700d9709d2b786$var$NotchedOutlineLegend = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('legend', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $0820e164eb5fbaff$export$2e2bcd8739ae039)
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.withLabel,
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel,
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel && ownerState.notched,
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    })));
function $ae700d9709d2b786$export$2e2bcd8739ae039(props) {
    const { children: children, classes: classes, className: className, label: label, notched: notched, ...other } = props;
    const withLabel = label != null && label !== '';
    const ownerState = {
        ...props,
        notched: notched,
        withLabel: withLabel
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ae700d9709d2b786$var$NotchedOutlineRoot, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ae700d9709d2b786$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                children: label
            }) : $ae700d9709d2b786$var$_span || ($ae700d9709d2b786$var$_span = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                className: "notranslate",
                "aria-hidden": true,
                children: "\u200B"
            }))
        })
    });
}












function $fbe32ff46b8bf823$export$89922944c7227687(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiOutlinedInput', slot);
}
const $fbe32ff46b8bf823$var$outlinedInputClasses = {
    ...(0, $2b15682cef07fc0a$export$2e2bcd8739ae039),
    ...(0, $32447174989d1976$export$2e2bcd8739ae039)('MuiOutlinedInput', [
        'root',
        'notchedOutline',
        'input'
    ])
};
var $fbe32ff46b8bf823$export$2e2bcd8739ae039 = $fbe32ff46b8bf823$var$outlinedInputClasses;





'use client';
const $50e7e9efec2c0b8c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $fbe32ff46b8bf823$export$89922944c7227687), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $50e7e9efec2c0b8c$var$OutlinedInputRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $ba9f7182d6802613$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $0820e164eb5fbaff$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $ba9f7182d6802613$export$965edad20a84fa75)
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).focused} .${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderWidth: 2
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $061b5988a3817e26$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).focused} .${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).notchedOutline}`]: {
                            borderColor: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                // to overide the above style
                style: {
                    [`&.${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).error} .${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.error.main
                    },
                    [`&.${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).disabled} .${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.action.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '16.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    padding: '8.5px 14px'
                }
            }
        ]
    };
}));
const $50e7e9efec2c0b8c$var$NotchedOutlineRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $ae700d9709d2b786$export$2e2bcd8739ae039), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
}));
const $50e7e9efec2c0b8c$var$OutlinedInputInput = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $ba9f7182d6802613$export$ee10465db6ff6017), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $ba9f7182d6802613$export$cf507b112810e72d)
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        padding: '16.5px 14px',
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '8.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            }
        ]
    })));
const $50e7e9efec2c0b8c$var$OutlinedInput = /*#__PURE__*/ $7fPBF.forwardRef(function OutlinedInput(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, slotProps: slotProps = {}, type: type = 'text', ...other } = props;
    const classes = $50e7e9efec2c0b8c$var$useUtilityClasses(props);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    };
    const RootSlot = slots.root ?? components.Root ?? $50e7e9efec2c0b8c$var$OutlinedInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $50e7e9efec2c0b8c$var$OutlinedInputInput;
    const [NotchedSlot, notchedProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('notchedOutline', {
        elementType: $50e7e9efec2c0b8c$var$NotchedOutlineRoot,
        className: classes.notchedOutline,
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps
        },
        additionalProps: {
            label: label != null && label !== '' && fcs.required ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
                children: [
                    label,
                    "\u2009",
                    '*'
                ]
            }) : label
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ba9f7182d6802613$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: slotProps,
        renderSuffix: (state)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(NotchedSlot, {
                ...notchedProps,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: {
            ...classes,
            notchedOutline: null
        }
    });
});
$50e7e9efec2c0b8c$var$OutlinedInput.muiName = 'Input';
var $50e7e9efec2c0b8c$export$2e2bcd8739ae039 = $50e7e9efec2c0b8c$var$OutlinedInput;



var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");












function $94ffd68a66aaae7e$export$f7d501e40371cd17(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiFormLabel', slot);
}
const $94ffd68a66aaae7e$var$formLabelClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $94ffd68a66aaae7e$export$2e2bcd8739ae039 = $94ffd68a66aaae7e$var$formLabelClasses;



'use client';
const $90370d1df15229dd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $94ffd68a66aaae7e$export$f7d501e40371cd17), classes);
};
const $90370d1df15229dd$export$aa5bc7f8a4705b27 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color === 'secondary' && styles.colorSecondary,
            ownerState.filled && styles.filled
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.body1,
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        variants: [
            ...Object.entries(theme.palette).filter((0, $061b5988a3817e26$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $94ffd68a66aaae7e$export$2e2bcd8739ae039).focused}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                style: {
                    [`&.${(0, $94ffd68a66aaae7e$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    },
                    [`&.${(0, $94ffd68a66aaae7e$export$2e2bcd8739ae039).error}`]: {
                        color: (theme.vars || theme).palette.error.main
                    }
                }
            }
        ]
    })));
const $90370d1df15229dd$var$AsteriskComponent = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        [`&.${(0, $94ffd68a66aaae7e$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const $90370d1df15229dd$var$FormLabel = /*#__PURE__*/ $7fPBF.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, color: color, component: component = 'label', disabled: disabled, error: error, filled: filled, focused: focused, required: required, ...other } = props;
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    const classes = $90370d1df15229dd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($90370d1df15229dd$export$aa5bc7f8a4705b27, {
        as: component,
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ...other,
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($90370d1df15229dd$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    });
});
var $90370d1df15229dd$export$2e2bcd8739ae039 = $90370d1df15229dd$var$FormLabel;









function $2b0d2ae144238f59$export$c1c4b4545ad2ea5f(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiInputLabel', slot);
}
const $2b0d2ae144238f59$var$inputLabelClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $2b0d2ae144238f59$export$2e2bcd8739ae039 = $2b0d2ae144238f59$var$inputLabelClasses;



'use client';
const $fcd80672e9993aad$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'normal' && `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $2b0d2ae144238f59$export$c1c4b4545ad2ea5f), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the FormLabel
        ...composedClasses
    };
};
const $fcd80672e9993aad$var$InputLabelRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $90370d1df15229dd$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $0820e164eb5fbaff$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $94ffd68a66aaae7e$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    // slight alteration to spec spacing to match visual spec result
                    transform: 'translate(0, 20px) scale(1)'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    // Compensation for the `Input.inputSizeSmall` style.
                    transform: 'translate(0, 17px) scale(1)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.shrink,
                style: {
                    transform: 'translate(0, -1.5px) scale(0.75)',
                    transformOrigin: 'top left',
                    maxWidth: '133%'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableAnimation,
                style: {
                    transition: theme.transitions.create([
                        'color',
                        'transform',
                        'max-width'
                    ], {
                        duration: theme.transitions.duration.shorter,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    // Chrome's autofill feature gives the input field a yellow background.
                    // Since the input field is behind the label in the HTML tree,
                    // the input field is drawn last and hides the label with an opaque background color.
                    // zIndex: 1 will raise the label above opaque background-colors of input.
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(12px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'filled',
                    size: 'small'
                },
                style: {
                    transform: 'translate(12px, 13px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'filled' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    transform: 'translate(12px, 7px) scale(0.75)',
                    maxWidth: 'calc(133% - 24px)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState, size: size })=>variant === 'filled' && ownerState.shrink && size === 'small',
                style: {
                    transform: 'translate(12px, 4px) scale(0.75)'
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    // see comment above on filled.zIndex
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(14px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'outlined',
                    size: 'small'
                },
                style: {
                    transform: 'translate(14px, 9px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'outlined' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    // Theoretically, we should have (8+5)*2/0.75 = 34px
                    // but it feels a better when it bleeds a bit on the left, so 32px.
                    maxWidth: 'calc(133% - 32px)',
                    transform: 'translate(14px, -9px) scale(0.75)'
                }
            }
        ]
    })));
const $fcd80672e9993aad$var$InputLabel = /*#__PURE__*/ $7fPBF.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, margin: margin, shrink: shrinkProp, variant: variant, className: className, ...other } = props;
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = {
        ...props,
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    };
    const classes = $fcd80672e9993aad$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($fcd80672e9993aad$var$InputLabelRoot, {
        "data-shrink": shrink,
        ref: ref,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ...other,
        ownerState: ownerState,
        classes: classes
    });
});
var $fcd80672e9993aad$export$2e2bcd8739ae039 = $fcd80672e9993aad$var$InputLabel;



var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");
function $de2da0b284b1a3c2$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $7fPBF.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}


var $6926d37cb7ff7774$export$2e2bcd8739ae039 = (0, $de2da0b284b1a3c2$export$2e2bcd8739ae039);





function $6fa629ce89e8ad57$export$149c8b8bab2289d1(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiFormControl', slot);
}
const $6fa629ce89e8ad57$var$formControlClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $6fa629ce89e8ad57$export$2e2bcd8739ae039 = $6fa629ce89e8ad57$var$formControlClasses;



'use client';
const $26a8e925f0aa9998$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $6fa629ce89e8ad57$export$149c8b8bab2289d1), classes);
};
const $26a8e925f0aa9998$var$FormControlRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`margin${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.margin)}`],
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})({
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top',
    // Fix alignment issue on Safari.
    variants: [
        {
            props: {
                margin: 'normal'
            },
            style: {
                marginTop: 16,
                marginBottom: 8
            }
        },
        {
            props: {
                margin: 'dense'
            },
            style: {
                marginTop: 8,
                marginBottom: 4
            }
        },
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        }
    ]
});
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $26a8e925f0aa9998$var$FormControl = /*#__PURE__*/ $7fPBF.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    };
    const classes = $26a8e925f0aa9998$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $7fPBF.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $7fPBF.Children.forEach(children, (child)=>{
            if (!(0, $6926d37cb7ff7774$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $6926d37cb7ff7774$export$2e2bcd8739ae039)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $5e9f5ca6e3e911fc$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $7fPBF.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $7fPBF.Children.forEach(children, (child)=>{
            if (!(0, $6926d37cb7ff7774$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $5e9f5ca6e3e911fc$export$d652b828d7fdeff8)(child.props, true) || (0, $5e9f5ca6e3e911fc$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $7fPBF.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const registeredInput = $7fPBF.useRef(false);
    const onFilled = $7fPBF.useCallback(()=>{
        setFilled(true);
    }, []);
    const onEmpty = $7fPBF.useCallback(()=>{
        setFilled(false);
    }, []);
    const childContext = $7fPBF.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            onEmpty: onEmpty,
            onFilled: onFilled,
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        onEmpty,
        onFilled,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f29d66cab44a33c0$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($26a8e925f0aa9998$var$FormControlRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref,
            ...other,
            children: children
        })
    });
});
var $26a8e925f0aa9998$export$2e2bcd8739ae039 = $26a8e925f0aa9998$var$FormControl;



var $7fPBF = parcelRequire("7fPBF");











function $10a7abfeb1405549$export$a394fa61b1d583a9(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiFormHelperText', slot);
}
const $10a7abfeb1405549$var$formHelperTextClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $10a7abfeb1405549$export$2e2bcd8739ae039 = $10a7abfeb1405549$var$formHelperTextClasses;



'use client';
var $0321a2cb63129955$var$_span;
const $0321a2cb63129955$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $10a7abfeb1405549$export$a394fa61b1d583a9), classes);
};
const $0321a2cb63129955$var$FormHelperTextRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.caption,
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $10a7abfeb1405549$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $10a7abfeb1405549$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginTop: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.contained,
                style: {
                    marginLeft: 14,
                    marginRight: 14
                }
            }
        ]
    })));
const $0321a2cb63129955$var$FormHelperText = /*#__PURE__*/ $7fPBF.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p', disabled: disabled, error: error, filled: filled, focused: focused, margin: margin, required: required, variant: variant, ...other } = props;
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = $0321a2cb63129955$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0321a2cb63129955$var$FormHelperTextRoot, {
        as: component,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: children === ' ' ? $0321a2cb63129955$var$_span || ($0321a2cb63129955$var$_span = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
            className: "notranslate",
            "aria-hidden": true,
            children: "\u200B"
        })) : children
    });
});
var $0321a2cb63129955$export$2e2bcd8739ae039 = $0321a2cb63129955$var$FormHelperText;



var $7fPBF = parcelRequire("7fPBF");







var $7fPBF = parcelRequire("7fPBF");







var $9502daaf177b272b$export$2e2bcd8739ae039 = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039);




var $7fPBF = parcelRequire("7fPBF");










'use client';
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $a70b740322660959$var$useSlotProps(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $ae0f0ccae9f4b3cc$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $a945a7a9a1371b8c$export$2e2bcd8739ae039)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $4520d0f80a3f7305$export$2e2bcd8739ae039)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $a70b740322660959$export$2e2bcd8739ae039 = $a70b740322660959$var$useSlotProps;



var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");
'use client';
/**
 * @ignore - internal component.
 */ const $94e271e17fd22222$var$ListContext = /*#__PURE__*/ $7fPBF.createContext({});
var $94e271e17fd22222$export$2e2bcd8739ae039 = $94e271e17fd22222$var$ListContext;




function $d56e26d1d10ff784$export$c6bd6795ed6e3203(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiList', slot);
}
const $d56e26d1d10ff784$var$listClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $d56e26d1d10ff784$export$2e2bcd8739ae039 = $d56e26d1d10ff784$var$listClasses;



'use client';
const $fb70212a09473954$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $d56e26d1d10ff784$export$c6bd6795ed6e3203), classes);
};
const $fb70212a09473954$var$ListRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
            style: {
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.subheader,
            style: {
                paddingTop: 0
            }
        }
    ]
});
const $fb70212a09473954$var$List = /*#__PURE__*/ $7fPBF.forwardRef(function List(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader, ...other } = props;
    const context = $7fPBF.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = {
        ...props,
        component: component,
        dense: dense,
        disablePadding: disablePadding
    };
    const classes = $fb70212a09473954$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $94e271e17fd22222$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($fb70212a09473954$var$ListRoot, {
            as: component,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref,
            ownerState: ownerState,
            ...other,
            children: [
                subheader,
                children
            ]
        })
    });
});
var $fb70212a09473954$export$2e2bcd8739ae039 = $fb70212a09473954$var$List;



var $15bf9ba27fbfc052$export$2e2bcd8739ae039 = (0, $5f729e410b274c00$export$2e2bcd8739ae039);





var $6cb2f4180c9526e0$export$2e2bcd8739ae039 = (0, $c1e4563498af7952$export$2e2bcd8739ae039);



'use client';
function $9cb95136bc90d127$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $9cb95136bc90d127$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $9cb95136bc90d127$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.startsWith(textCriteria.keys.join(''));
}
function $9cb95136bc90d127$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$9cb95136bc90d127$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $9cb95136bc90d127$var$MenuList = /*#__PURE__*/ $7fPBF.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu', ...other } = props;
    const listRef = $7fPBF.useRef(null);
    const textCriteriaRef = $7fPBF.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $cfde3819487a0686$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $7fPBF.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $15bf9ba27fbfc052$export$2e2bcd8739ae039)((0, $6cb2f4180c9526e0$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        const isModifierKeyPressed = event.ctrlKey || event.metaKey || event.altKey;
        if (isModifierKeyPressed) {
            if (onKeyDown) onKeyDown(event);
            return;
        }
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $9502daaf177b272b$export$2e2bcd8739ae039)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $9cb95136bc90d127$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $9cb95136bc90d127$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $9cb95136bc90d127$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $7fPBF.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $7fPBF.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $7fPBF.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb70212a09473954$export$2e2bcd8739ae039), {
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1,
        ...other,
        children: items
    });
});
var $9cb95136bc90d127$export$2e2bcd8739ae039 = $9cb95136bc90d127$var$MenuList;



var $7fPBF = parcelRequire("7fPBF");












var $3aadd01758bd49c1$export$2e2bcd8739ae039 = (0, $c285f587ed4585eb$export$2e2bcd8739ae039);





var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
'use client';
const $890b21ec8e20082a$var$UNINITIALIZED = {};
function $890b21ec8e20082a$export$2e2bcd8739ae039(init, initArg) {
    const ref = $7fPBF.useRef($890b21ec8e20082a$var$UNINITIALIZED);
    if (ref.current === $890b21ec8e20082a$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $7fPBF = parcelRequire("7fPBF");
'use client';
const $1d2095ad20314533$var$EMPTY = [];
function $1d2095ad20314533$export$2e2bcd8739ae039(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $7fPBF.useEffect(fn, $1d2095ad20314533$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


'use client';
class $9a1088a9a7141b09$export$786b4da70f00938b {
    static create() {
        return new $9a1088a9a7141b09$export$786b4da70f00938b();
    }
    currentId = null;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    clear = ()=>{
        if (this.currentId !== null) {
            clearTimeout(this.currentId);
            this.currentId = null;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
function $9a1088a9a7141b09$export$2e2bcd8739ae039() {
    const timeout = (0, $890b21ec8e20082a$export$2e2bcd8739ae039)($9a1088a9a7141b09$export$786b4da70f00938b.create).current;
    (0, $1d2095ad20314533$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}









'use client';
function $7ec2c0aa92d4d29c$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $7ec2c0aa92d4d29c$var$styles = {
    entering: {
        opacity: 1,
        transform: $7ec2c0aa92d4d29c$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $7ec2c0aa92d4d29c$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $7ec2c0aa92d4d29c$var$Grow = /*#__PURE__*/ $7fPBF.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $623678cbb6daf054$export$2e2bcd8739ae039), ...other } = props;
    const timer = (0, $9a1088a9a7141b09$export$2e2bcd8739ae039)();
    const autoTimeout = $7fPBF.useRef();
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const nodeRef = $7fPBF.useRef(null);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(nodeRef, (0, $8971fd60a8b100cf$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $1ae2edacd7be6319$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $7ec2c0aa92d4d29c$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $7ec2c0aa92d4d29c$var$isWebKit154 ? duration : duration * 0.666,
                delay: $7ec2c0aa92d4d29c$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $7ec2c0aa92d4d29c$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $7fPBF.cloneElement(children, {
                style: {
                    opacity: 0,
                    transform: $7ec2c0aa92d4d29c$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$7ec2c0aa92d4d29c$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
if ($7ec2c0aa92d4d29c$var$Grow) $7ec2c0aa92d4d29c$var$Grow.muiSupportAuto = true;
var $7ec2c0aa92d4d29c$export$2e2bcd8739ae039 = $7ec2c0aa92d4d29c$var$Grow;






function $a5a68170633995c3$export$88f455dd56c95edb(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPopover', slot);
}
const $a5a68170633995c3$var$popoverClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPopover', [
    'root',
    'paper'
]);
var $a5a68170633995c3$export$2e2bcd8739ae039 = $a5a68170633995c3$var$popoverClasses;




function $4ae0554ab82ec1b4$export$2e2bcd8739ae039(externalSlotProps, defaultSlotProps) {
    if (!externalSlotProps) return defaultSlotProps;
    if (typeof externalSlotProps === 'function' || typeof defaultSlotProps === 'function') return (ownerState)=>{
        const defaultSlotPropsValue = typeof defaultSlotProps === 'function' ? defaultSlotProps(ownerState) : defaultSlotProps;
        const externalSlotPropsValue = typeof externalSlotProps === 'function' ? externalSlotProps({
            ...ownerState,
            ...defaultSlotPropsValue
        }) : externalSlotProps;
        const className = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(ownerState?.className, defaultSlotPropsValue?.className, externalSlotPropsValue?.className);
        return {
            ...defaultSlotPropsValue,
            ...externalSlotPropsValue,
            ...!!className && {
                className: className
            },
            ...defaultSlotPropsValue?.style && externalSlotPropsValue?.style && {
                style: {
                    ...defaultSlotPropsValue.style,
                    ...externalSlotPropsValue.style
                }
            },
            ...defaultSlotPropsValue?.sx && externalSlotPropsValue?.sx && {
                sx: [
                    ...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [
                        defaultSlotPropsValue.sx
                    ],
                    ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [
                        externalSlotPropsValue.sx
                    ]
                ]
            }
        };
    };
    const typedDefaultSlotProps = defaultSlotProps;
    const className = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(typedDefaultSlotProps?.className, externalSlotProps?.className);
    return {
        ...defaultSlotProps,
        ...externalSlotProps,
        ...!!className && {
            className: className
        },
        ...typedDefaultSlotProps?.style && externalSlotProps?.style && {
            style: {
                ...typedDefaultSlotProps.style,
                ...externalSlotProps.style
            }
        },
        ...typedDefaultSlotProps?.sx && externalSlotProps?.sx && {
            sx: [
                ...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [
                    typedDefaultSlotProps.sx
                ],
                ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [
                    externalSlotProps.sx
                ]
            ]
        }
    };
}



'use client';
function $77b3b30833fb8c12$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $77b3b30833fb8c12$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $77b3b30833fb8c12$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $77b3b30833fb8c12$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $77b3b30833fb8c12$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $a5a68170633995c3$export$88f455dd56c95edb), classes);
};
const $77b3b30833fb8c12$export$bcce13685275fc99 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $a65b89a1133e1fe4$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $77b3b30833fb8c12$export$821346c38a2d9390 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $77b3b30833fb8c12$var$Popover = /*#__PURE__*/ $7fPBF.forwardRef(function Popover(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: // TODO: remove in v7
    slots = {}, slotProps: slotProps = {}, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent, // TODO: remove in v7
    transitionDuration: transitionDurationProp = 'auto', TransitionProps: TransitionProps = {}, disableScrollLock: // TODO: remove in v7
    disableScrollLock = false, ...other } = props;
    const paperRef = $7fPBF.useRef();
    const ownerState = {
        ...props,
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    };
    const classes = $77b3b30833fb8c12$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $7fPBF.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $77b3b30833fb8c12$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $9502daaf177b272b$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $77b3b30833fb8c12$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $77b3b30833fb8c12$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $7fPBF.useCallback((elemRect)=>{
        return {
            vertical: $77b3b30833fb8c12$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $77b3b30833fb8c12$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $7fPBF.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $77b3b30833fb8c12$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $6cb2f4180c9526e0$export$2e2bcd8739ae039)($77b3b30833fb8c12$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $77b3b30833fb8c12$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $7fPBF.useState(open);
    const setPositioningStyles = $7fPBF.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.setProperty('top', positioning.top);
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $7fPBF.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = ()=>{
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $7fPBF.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $7fPBF.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $7fPBF.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $3aadd01758bd49c1$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $6cb2f4180c9526e0$export$2e2bcd8739ae039)($77b3b30833fb8c12$var$resolveAnchorEl(anchorEl));
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            transition: TransitionProps,
            paper: PaperPropsProp,
            ...slotProps
        }
    };
    const [TransitionSlot, transitionSlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $7ec2c0aa92d4d29c$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onEntering: (element, isAppearing)=>{
                    handlers.onEntering?.(element, isAppearing);
                    handleEntering();
                },
                onExited: (element)=>{
                    handlers.onExited?.(element);
                    handleExited();
                }
            }),
        additionalProps: {
            appear: true,
            in: open
        }
    });
    if (transitionDurationProp === 'auto' && !TransitionSlot.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $9502daaf177b272b$export$2e2bcd8739ae039)($77b3b30833fb8c12$var$resolveAnchorEl(anchorEl)).body : undefined);
    const [RootSlot, { slots: rootSlotsProp, slotProps: rootSlotPropsProp, ...rootProps }] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $77b3b30833fb8c12$export$bcce13685275fc99,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        shouldForwardComponentProp: true,
        additionalProps: {
            slots: {
                backdrop: slots.backdrop
            },
            slotProps: {
                backdrop: (0, $4ae0554ab82ec1b4$export$2e2bcd8739ae039)(typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop, {
                    invisible: true
                })
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className)
    });
    const [PaperSlot, paperProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('paper', {
        ref: paperRef,
        className: classes.paper,
        elementType: $77b3b30833fb8c12$export$821346c38a2d9390,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: {
            elevation: elevation,
            style: isPositioned ? undefined : {
                opacity: 0
            }
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(RootSlot, {
        ...rootProps,
        ...!(0, $1a5b8306608cd33a$export$2e2bcd8739ae039)(RootSlot) && {
            slots: rootSlotsProp,
            slotProps: rootSlotPropsProp,
            disableScrollLock: disableScrollLock
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            timeout: transitionDuration,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(PaperSlot, {
                ...paperProps,
                children: children
            })
        })
    });
});
var $77b3b30833fb8c12$export$2e2bcd8739ae039 = $77b3b30833fb8c12$var$Popover;







function $a942fdfc6e6c5d42$export$2cf86a63a84fe23d(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiMenu', slot);
}
const $a942fdfc6e6c5d42$var$menuClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $a942fdfc6e6c5d42$export$2e2bcd8739ae039 = $a942fdfc6e6c5d42$var$menuClasses;




'use client';
const $c415fb7f3f0f9d08$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $c415fb7f3f0f9d08$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $c415fb7f3f0f9d08$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $a942fdfc6e6c5d42$export$2cf86a63a84fe23d), classes);
};
const $c415fb7f3f0f9d08$var$MenuRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $77b3b30833fb8c12$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $0820e164eb5fbaff$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $c415fb7f3f0f9d08$export$4f7c51a5920c9f33 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $77b3b30833fb8c12$export$821346c38a2d9390), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $c415fb7f3f0f9d08$var$MenuMenuList = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $9cb95136bc90d127$export$2e2bcd8739ae039), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $c415fb7f3f0f9d08$var$Menu = /*#__PURE__*/ $7fPBF.forwardRef(function Menu(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering, ...TransitionProps } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $0459201d2cf8a80b$export$b2dd014b6c321cb)();
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    };
    const classes = $c415fb7f3f0f9d08$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $7fPBF.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $7fPBF.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            list: MenuListProps,
            transition: TransitionProps,
            paper: PaperProps,
            ...slotProps
        }
    };
    const rootSlotProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const [PaperSlot, paperSlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('paper', {
        className: classes.paper,
        elementType: $c415fb7f3f0f9d08$export$4f7c51a5920c9f33,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        ownerState: ownerState
    });
    const [ListSlot, listSlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('list', {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.list, MenuListProps.className),
        elementType: $c415fb7f3f0f9d08$var$MenuMenuList,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleListKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            }),
        ownerState: ownerState
    });
    const resolvedTransitionProps = typeof externalForwardedProps.slotProps.transition === 'function' ? externalForwardedProps.slotProps.transition(ownerState) : externalForwardedProps.slotProps.transition;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c415fb7f3f0f9d08$var$MenuRoot, {
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $c415fb7f3f0f9d08$var$RTL_ORIGIN : $c415fb7f3f0f9d08$var$LTR_ORIGIN,
        slots: {
            root: slots.root,
            paper: PaperSlot,
            backdrop: slots.backdrop,
            ...slots.transition && {
                // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
                transition: slots.transition
            }
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps,
            backdrop: typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop,
            transition: {
                ...resolvedTransitionProps,
                onEntering: (...args)=>{
                    handleEntering(...args);
                    resolvedTransitionProps?.onEntering?.(...args);
                }
            }
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        ownerState: ownerState,
        ...other,
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ListSlot, {
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant,
            ...listSlotProps,
            children: children
        })
    });
});
var $c415fb7f3f0f9d08$export$2e2bcd8739ae039 = $c415fb7f3f0f9d08$var$Menu;



var $7fPBF = parcelRequire("7fPBF");







function $a5651256592f6f65$export$1ee13051fd9e2ab5(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiNativeSelect', slot);
}
const $a5651256592f6f65$var$nativeSelectClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $a5651256592f6f65$export$2e2bcd8739ae039 = $a5651256592f6f65$var$nativeSelectClasses;





'use client';
const $7a6261f84c63d345$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $a5651256592f6f65$export$1ee13051fd9e2ab5), classes);
};
const $7a6261f84c63d345$export$50b3545a8ccd87af = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('select', {
    name: 'MuiNativeSelect'
})(({ theme: theme })=>({
        // Reset
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        // Reset
        borderRadius: 0,
        cursor: 'pointer',
        '&:focus': {
            // Reset Chrome style
            borderRadius: 0
        },
        [`&.${(0, $a5651256592f6f65$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'filled' && ownerState.variant !== 'outlined',
                style: {
                    // Bump specificity to allow extending custom inputs
                    '&&&': {
                        paddingRight: 24,
                        minWidth: 16 // So it doesn't collapse.
                    }
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    '&&&': {
                        paddingRight: 32
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius,
                    '&:focus': {
                        borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
                    },
                    '&&&': {
                        paddingRight: 32
                    }
                }
            }
        ]
    }));
const $7a6261f84c63d345$var$NativeSelectSelect = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)($7a6261f84c63d345$export$50b3545a8ccd87af, {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $0820e164eb5fbaff$export$2e2bcd8739ae039),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $a5651256592f6f65$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})({});
const $7a6261f84c63d345$export$7dd4d92f143902e3 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('svg', {
    name: 'MuiNativeSelect'
})(({ theme: theme })=>({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        // Center vertically, height is 1em
        top: 'calc(50% - .5em)',
        // Don't block pointer events on the select under the icon.
        pointerEvents: 'none',
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $a5651256592f6f65$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.open,
                style: {
                    transform: 'rotate(180deg)'
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    right: 7
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    right: 7
                }
            }
        ]
    }));
const $7a6261f84c63d345$var$NativeSelectIcon = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)($7a6261f84c63d345$export$7dd4d92f143902e3, {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
/**
 * @ignore - internal component.
 */ const $7a6261f84c63d345$var$NativeSelectInput = /*#__PURE__*/ $7fPBF.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        variant: variant,
        error: error
    };
    const classes = $7a6261f84c63d345$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7a6261f84c63d345$var$NativeSelectSelect, {
                ownerState: ownerState,
                className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref,
                ...other
            }),
            props.multiple ? null : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7a6261f84c63d345$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $7a6261f84c63d345$export$2e2bcd8739ae039 = $7a6261f84c63d345$var$NativeSelectInput;







var $7fPBF = parcelRequire("7fPBF");
'use client';
function $bc6c881cebb96954$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $7fPBF.useRef(controlled !== undefined);
    const [valueState, setValue] = $7fPBF.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $7fPBF.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


'use client';
var $3b64539a8a5729fa$export$2e2bcd8739ae039 = (0, $bc6c881cebb96954$export$2e2bcd8739ae039);




function $5ea8b5d2968b699c$export$2c0c1ee5a3392e(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiSelect', slot);
}
const $5ea8b5d2968b699c$var$selectClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $5ea8b5d2968b699c$export$2e2bcd8739ae039 = $5ea8b5d2968b699c$var$selectClasses;



'use client';
var $59b8977b1194262f$var$_span;
const $59b8977b1194262f$var$SelectSelect = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $7a6261f84c63d345$export$50b3545a8ccd87af), {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $5ea8b5d2968b699c$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $5ea8b5d2968b699c$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $5ea8b5d2968b699c$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $5ea8b5d2968b699c$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})({
    // Win specificity over the input base
    [`&.${(0, $5ea8b5d2968b699c$export$2e2bcd8739ae039).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $59b8977b1194262f$var$SelectIcon = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $7a6261f84c63d345$export$7dd4d92f143902e3), {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
const $59b8977b1194262f$var$SelectNativeInput = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('input', {
    shouldForwardProp: (prop)=>(0, $066f83798075d563$export$2e2bcd8739ae039)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $59b8977b1194262f$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $59b8977b1194262f$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $59b8977b1194262f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $5ea8b5d2968b699c$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $59b8977b1194262f$var$SelectInput = /*#__PURE__*/ $7fPBF.forwardRef(function SelectInput(props, ref) {
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, required: required, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, type: // catching `type` from Input which makes no sense for SelectInput
    type, value: valueProp, variant: variant = 'standard', ...other } = props;
    const [value, setValueState] = (0, $3b64539a8a5729fa$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $3b64539a8a5729fa$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $7fPBF.useRef(null);
    const displayRef = $7fPBF.useRef(null);
    const [displayNode, setDisplayNode] = $7fPBF.useState(null);
    const { current: isOpenControlled } = $7fPBF.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $7fPBF.useState();
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $7fPBF.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode?.parentNode;
    $7fPBF.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $7fPBF.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $7fPBF.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $7fPBF.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $9502daaf177b272b$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $7fPBF.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.includes(event.key)) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $5e9f5ca6e3e911fc$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $9afc3518733c6a5e$export$2e2bcd8739ae039)(2));
            selected = value.some((v)=>$59b8977b1194262f$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $59b8977b1194262f$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $7fPBF.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = {
        ...props,
        variant: variant,
        value: value,
        open: open,
        error: error
    };
    const classes = $59b8977b1194262f$var$useUtilityClasses(ownerState);
    const paperProps = {
        ...MenuProps.PaperProps,
        ...MenuProps.slotProps?.paper
    };
    const listboxId = (0, $46f5b561912058f9$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($59b8977b1194262f$var$SelectSelect, {
                as: "div",
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": open ? listboxId : undefined,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                "aria-required": required ? 'true' : undefined,
                "aria-invalid": error ? 'true' : undefined,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus,
                ...SelectDisplayProps,
                ownerState: ownerState,
                className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $59b8977b1194262f$var$isEmpty(display) ? $59b8977b1194262f$var$_span || ($59b8977b1194262f$var$_span = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    className: "notranslate",
                    "aria-hidden": true,
                    children: "\u200B"
                })) : display
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($59b8977b1194262f$var$SelectNativeInput, {
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                required: required,
                ...other,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($59b8977b1194262f$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                ...MenuProps,
                slotProps: {
                    ...MenuProps.slotProps,
                    list: {
                        'aria-labelledby': labelId,
                        role: 'listbox',
                        'aria-multiselectable': multiple ? 'true' : undefined,
                        disableListWrap: true,
                        id: listboxId,
                        ...MenuProps.MenuListProps
                    },
                    paper: {
                        ...paperProps,
                        style: {
                            minWidth: menuMinWidth,
                            ...paperProps != null ? paperProps.style : null
                        }
                    }
                },
                children: items
            })
        ]
    });
});
var $59b8977b1194262f$export$2e2bcd8739ae039 = $59b8977b1194262f$var$SelectInput;




parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");









function $50c5d2f6ad13a504$export$c7c50641356bdfa5(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiSvgIcon', slot);
}
const $50c5d2f6ad13a504$var$svgIconClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $50c5d2f6ad13a504$export$2e2bcd8739ae039 = $50c5d2f6ad13a504$var$svgIconClasses;



'use client';
const $b3d4ccc5f426d62a$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            `fontSize${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(fontSize)}`
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $50c5d2f6ad13a504$export$c7c50641356bdfa5), classes);
};
const $b3d4ccc5f426d62a$var$SvgIconRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`fontSize${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.fontSize)}`]
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0,
        transition: theme.transitions?.create?.('fill', {
            duration: (theme.vars ?? theme).transitions?.duration?.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(20) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(24) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(35) || '2.1875rem'
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries((theme.vars ?? theme).palette).filter(([, value])=>value && value.main).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars ?? theme).palette?.[color]?.main
                    }
                })),
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ]
    })));
const $b3d4ccc5f426d62a$var$SvgIcon = /*#__PURE__*/ $7fPBF.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24', ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ $7fPBF.isValidElement(children) && children.type === 'svg';
    const ownerState = {
        ...props,
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $b3d4ccc5f426d62a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($b3d4ccc5f426d62a$var$SvgIconRoot, {
        as: component,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
$b3d4ccc5f426d62a$var$SvgIcon.muiName = 'SvgIcon';
var $b3d4ccc5f426d62a$export$2e2bcd8739ae039 = $b3d4ccc5f426d62a$var$SvgIcon;



'use client';
function $4f9bc8f83648f682$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b3d4ccc5f426d62a$export$2e2bcd8739ae039), {
            "data-testid": `${displayName}Icon`,
            ref: ref,
            ...props,
            children: path
        });
    }
    Component.muiName = (0, $b3d4ccc5f426d62a$export$2e2bcd8739ae039).muiName;
    return /*#__PURE__*/ $7fPBF.memo(/*#__PURE__*/ $7fPBF.forwardRef(Component));
}



'use client';
var $7cc16c93aade5bc5$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');












'use client';
const $e07ff65b28ac412d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $5ea8b5d2968b699c$export$2c0c1ee5a3392e), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $e07ff65b28ac412d$var$styledRootConfig = {
    name: 'MuiSelect',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $0820e164eb5fbaff$export$2e2bcd8739ae039)(prop) && prop !== 'variant',
    slot: 'Root'
};
const $e07ff65b28ac412d$var$StyledInput = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $e0d49bb29c2f8b76$export$2e2bcd8739ae039), $e07ff65b28ac412d$var$styledRootConfig)('');
const $e07ff65b28ac412d$var$StyledOutlinedInput = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $50e7e9efec2c0b8c$export$2e2bcd8739ae039), $e07ff65b28ac412d$var$styledRootConfig)('');
const $e07ff65b28ac412d$var$StyledFilledInput = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $faf35b44bb61ebfd$export$2e2bcd8739ae039), $e07ff65b28ac412d$var$styledRootConfig)('');
const $e07ff65b28ac412d$var$Select = /*#__PURE__*/ $7fPBF.forwardRef(function Select(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $7cc16c93aade5bc5$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined', ...other } = props;
    const inputComponent = native ? (0, $7a6261f84c63d345$export$2e2bcd8739ae039) : (0, $59b8977b1194262f$export$2e2bcd8739ae039);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = {
        ...props,
        variant: variant,
        classes: classesProp
    };
    const classes = $e07ff65b28ac412d$var$useUtilityClasses(ownerState);
    const { root: root, ...restOfClasses } = classes;
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e07ff65b28ac412d$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e07ff65b28ac412d$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e07ff65b28ac412d$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(ref, (0, $8971fd60a8b100cf$export$2e2bcd8739ae039)(InputComponent));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7fPBF.Fragment, {
        children: /*#__PURE__*/ $7fPBF.cloneElement(InputComponent, {
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: {
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple,
                ...native ? {
                    id: id
                } : {
                    autoWidth: autoWidth,
                    defaultOpen: defaultOpen,
                    displayEmpty: displayEmpty,
                    labelId: labelId,
                    MenuProps: MenuProps,
                    onClose: onClose,
                    onOpen: onOpen,
                    open: open,
                    renderValue: renderValue,
                    SelectDisplayProps: {
                        id: id,
                        ...SelectDisplayProps
                    }
                },
                ...inputProps,
                classes: inputProps ? (0, $291e2c063c5d6173$export$2e2bcd8739ae039)(restOfClasses, inputProps.classes) : restOfClasses,
                ...input ? input.props.inputProps : {}
            },
            ...(multiple && native || displayEmpty) && variant === 'outlined' ? {
                notched: true
            } : {},
            ref: inputComponentRef,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(InputComponent.props.className, className, classes.root),
            // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
            ...!input && {
                variant: variant
            },
            ...other
        })
    });
});
$e07ff65b28ac412d$var$Select.muiName = 'Select';
var $e07ff65b28ac412d$export$2e2bcd8739ae039 = $e07ff65b28ac412d$var$Select;




function $16716b95f6c79ff6$export$c1bdcbaf0596aeda(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiTextField', slot);
}
const $16716b95f6c79ff6$var$textFieldClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiTextField', [
    'root'
]);
var $16716b95f6c79ff6$export$2e2bcd8739ae039 = $16716b95f6c79ff6$var$textFieldClasses;




'use client';
const $afe2b905acb8b9f6$var$variantComponent = {
    standard: (0, $e0d49bb29c2f8b76$export$2e2bcd8739ae039),
    filled: (0, $faf35b44bb61ebfd$export$2e2bcd8739ae039),
    outlined: (0, $50e7e9efec2c0b8c$export$2e2bcd8739ae039)
};
const $afe2b905acb8b9f6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $16716b95f6c79ff6$export$c1bdcbaf0596aeda), classes);
};
const $afe2b905acb8b9f6$var$TextFieldRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $26a8e925f0aa9998$export$2e2bcd8739ae039), {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $afe2b905acb8b9f6$var$TextField = /*#__PURE__*/ $7fPBF.forwardRef(function TextField(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextPropsProp, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelPropsProp, inputProps: inputPropsProp, InputProps: InputPropsProp, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectPropsProp, slots: slots = {}, slotProps: slotProps = {}, type: type, value: value, variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    };
    const classes = $afe2b905acb8b9f6$var$useUtilityClasses(ownerState);
    const id = (0, $46f5b561912058f9$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $afe2b905acb8b9f6$var$variantComponent[variant];
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: InputPropsProp,
            inputLabel: InputLabelPropsProp,
            htmlInput: inputPropsProp,
            formHelperText: FormHelperTextPropsProp,
            select: SelectPropsProp,
            ...slotProps
        }
    };
    const inputAdditionalProps = {};
    const inputLabelSlotProps = externalForwardedProps.slotProps.inputLabel;
    if (variant === 'outlined') {
        if (inputLabelSlotProps && typeof inputLabelSlotProps.shrink !== 'undefined') inputAdditionalProps.notched = inputLabelSlotProps.shrink;
        inputAdditionalProps.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectPropsProp || !SelectPropsProp.native) inputAdditionalProps.id = undefined;
        inputAdditionalProps['aria-describedby'] = undefined;
    }
    const [RootSlot, rootProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('root', {
        elementType: $afe2b905acb8b9f6$var$TextFieldRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        additionalProps: {
            disabled: disabled,
            error: error,
            fullWidth: fullWidth,
            required: required,
            color: color,
            variant: variant
        }
    });
    const [InputSlot, inputProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('input', {
        elementType: InputComponent,
        externalForwardedProps: externalForwardedProps,
        additionalProps: inputAdditionalProps,
        ownerState: ownerState
    });
    const [InputLabelSlot, inputLabelProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('inputLabel', {
        elementType: (0, $fcd80672e9993aad$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [HtmlInputSlot, htmlInputProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('htmlInput', {
        elementType: 'input',
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [FormHelperTextSlot, formHelperTextProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('formHelperText', {
        elementType: (0, $0321a2cb63129955$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SelectSlot, selectProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('select', {
        elementType: (0, $e07ff65b28ac412d$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const InputElement = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(InputSlot, {
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: htmlInputProps,
        slots: {
            input: slots.htmlInput ? HtmlInputSlot : undefined
        },
        ...inputProps
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(InputLabelSlot, {
                htmlFor: id,
                id: inputLabelId,
                ...inputLabelProps,
                children: label
            }),
            select ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(SelectSlot, {
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement,
                ...selectProps,
                children: children
            }) : InputElement,
            helperText && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(FormHelperTextSlot, {
                id: helperTextId,
                ...formHelperTextProps,
                children: helperText
            })
        ]
    });
});
var $afe2b905acb8b9f6$export$2e2bcd8739ae039 = $afe2b905acb8b9f6$var$TextField;


const $62386b9deba6bf98$var$StyledTextField = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039))`
    input {
        &:focus {
            outline: none;
        }
    }
`;
var $62386b9deba6bf98$export$2e2bcd8739ae039 = $62386b9deba6bf98$var$StyledTextField;



function $40551a8a102d1426$var$TalkBackField({ value: value, onChange: onChange, disabled: disabled }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $73229ceea4361fb2$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
            fullWidth: true,
            disabled: disabled,
            type: "text",
            value: value,
            label: t('common:talkback.title'),
            placeholder: t('common:talkback.question'),
            onChange: (e)=>onChange(e.target.value)
        })
    });
}
var $40551a8a102d1426$export$2e2bcd8739ae039 = $40551a8a102d1426$var$TalkBackField;




var $7fPBF = parcelRequire("7fPBF");










var $7fPBF = parcelRequire("7fPBF");





/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function $0d3c83b1c3920329$export$2e2bcd8739ae039(element) {
    try {
        return element.matches(':focus-visible');
    } catch (error) {}
    return false;
}






'use client';
var $16db65b1f19e65f7$export$2e2bcd8739ae039 = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039);



var $7fPBF = parcelRequire("7fPBF");

'use client';
class $4215af10cb5e802b$export$f5de0641c7db4154 {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new $4215af10cb5e802b$export$f5de0641c7db4154();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, $890b21ec8e20082a$export$2e2bcd8739ae039)($4215af10cb5e802b$export$f5de0641c7db4154.create).current;
        const [shouldMount, setShouldMount] = $7fPBF.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $7fPBF.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    constructor(){
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $4215af10cb5e802b$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    mountEffect = ()=>{
        if (this.shouldMount && !this.didMount) {
            if (this.ref.current !== null) {
                this.didMount = true;
                this.mounted.resolve();
            }
        }
    };
    /* Ripple API */ start(...args) {
        this.mount().then(()=>this.ref.current?.start(...args));
    }
    stop(...args) {
        this.mount().then(()=>this.ref.current?.stop(...args));
    }
    pulsate(...args) {
        this.mount().then(()=>this.ref.current?.pulsate(...args));
    }
}
function $4215af10cb5e802b$export$2e2bcd8739ae039() {
    return $4215af10cb5e802b$export$f5de0641c7db4154.use();
}
function $4215af10cb5e802b$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}



var $7fPBF = parcelRequire("7fPBF");



function $298ff58efa174465$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}





var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
function $2a31251aa5f7eb4f$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $7fPBF.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $7fPBF.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $2a31251aa5f7eb4f$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $2a31251aa5f7eb4f$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $2a31251aa5f7eb4f$export$fa71e2345c31d7a2(props, onExited) {
    return $2a31251aa5f7eb4f$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $2a31251aa5f7eb4f$var$getProp(child, 'appear', props),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', props),
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', props)
        });
    });
}
function $2a31251aa5f7eb4f$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $2a31251aa5f7eb4f$export$bbc8a025727ea824(nextProps.children);
    var children = $2a31251aa5f7eb4f$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $7fPBF.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $7fPBF.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', nextProps),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $7fPBF.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', nextProps),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $30921f11ad4ef55c$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $30921f11ad4ef55c$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $30921f11ad4ef55c$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $146ee816144a450d$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $2a31251aa5f7eb4f$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $2a31251aa5f7eb4f$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $2a31251aa5f7eb4f$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $30921f11ad4ef55c$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $61c94efb1735eff6$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $61c94efb1735eff6$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$30921f11ad4ef55c$var$TransitionGroup.propTypes = {};
$30921f11ad4ef55c$var$TransitionGroup.defaultProps = $30921f11ad4ef55c$var$defaultProps;
var $30921f11ad4ef55c$export$2e2bcd8739ae039 = $30921f11ad4ef55c$var$TransitionGroup;







var $7fPBF = parcelRequire("7fPBF");



'use client';
function $3d4a0ced9cf2c3c7$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $7fPBF.useState(false);
    const rippleClassName = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $7fPBF.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
            className: childClassName
        })
    });
}
var $3d4a0ced9cf2c3c7$export$2e2bcd8739ae039 = $3d4a0ced9cf2c3c7$var$Ripple;




function $fbda7a0931c56f58$export$b464606f735ab902(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiTouchRipple', slot);
}
const $fbda7a0931c56f58$var$touchRippleClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $fbda7a0931c56f58$export$2e2bcd8739ae039 = $fbda7a0931c56f58$var$touchRippleClasses;



'use client';
const $3f5ffa895ad4456e$var$DURATION = 550;
const $3f5ffa895ad4456e$export$95d0c9356b2231a3 = 80;
const $3f5ffa895ad4456e$var$enterKeyframe = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const $3f5ffa895ad4456e$var$exitKeyframe = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const $3f5ffa895ad4456e$var$pulsateKeyframe = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const $3f5ffa895ad4456e$export$f6b7418508c72c25 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $3f5ffa895ad4456e$export$676cfe7b12693c4b = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $3d4a0ced9cf2c3c7$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})`
  opacity: 0;
  position: absolute;

  &.${(0, $fbda7a0931c56f58$export$2e2bcd8739ae039).rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${$3f5ffa895ad4456e$var$enterKeyframe};
    animation-duration: ${$3f5ffa895ad4456e$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  &.${(0, $fbda7a0931c56f58$export$2e2bcd8739ae039).ripplePulsate} {
    animation-duration: ${({ theme: theme })=>theme.transitions.duration.shorter}ms;
  }

  & .${(0, $fbda7a0931c56f58$export$2e2bcd8739ae039).child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${(0, $fbda7a0931c56f58$export$2e2bcd8739ae039).childLeaving} {
    opacity: 0;
    animation-name: ${$3f5ffa895ad4456e$var$exitKeyframe};
    animation-duration: ${$3f5ffa895ad4456e$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  & .${(0, $fbda7a0931c56f58$export$2e2bcd8739ae039).childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${$3f5ffa895ad4456e$var$pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $3f5ffa895ad4456e$var$TouchRipple = /*#__PURE__*/ $7fPBF.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className, ...other } = props;
    const [ripples, setRipples] = $7fPBF.useState([]);
    const nextKey = $7fPBF.useRef(0);
    const rippleCallback = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $7fPBF.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $9a1088a9a7141b09$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $7fPBF.useRef(null);
    const container = $7fPBF.useRef(null);
    const startCommit = $7fPBF.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3f5ffa895ad4456e$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.ripple, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.rippleVisible, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.ripplePulsate, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.child, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.childLeaving, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.childPulsate, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $3f5ffa895ad4456e$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $7fPBF.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if (event?.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event?.type === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event?.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($3f5ffa895ad4456e$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $7fPBF.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $7fPBF.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event?.type === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $7fPBF.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3f5ffa895ad4456e$export$f6b7418508c72c25, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)((0, $fbda7a0931c56f58$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container,
        ...other,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30921f11ad4ef55c$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    });
});
var $3f5ffa895ad4456e$export$2e2bcd8739ae039 = $3f5ffa895ad4456e$var$TouchRipple;




function $d365e8bde1350eb0$export$fccb0498dcd99783(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiButtonBase', slot);
}
const $d365e8bde1350eb0$var$buttonBaseClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $d365e8bde1350eb0$export$2e2bcd8739ae039 = $d365e8bde1350eb0$var$buttonBaseClasses;



'use client';
const $2d0c76ae9ca5c817$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $d365e8bde1350eb0$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $2d0c76ae9ca5c817$export$7ec0dcc5e3cdcd36 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $d365e8bde1350eb0$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $2d0c76ae9ca5c817$var$ButtonBase = /*#__PURE__*/ $7fPBF.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type, ...other } = props;
    const buttonRef = $7fPBF.useRef(null);
    const ripple = (0, $4215af10cb5e802b$export$2e2bcd8739ae039)();
    const handleRippleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $7fPBF.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $7fPBF.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $7fPBF.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = $2d0c76ae9ca5c817$var$useRippleHandler(ripple, 'start', onMouseDown, disableTouchRipple);
    const handleContextMenu = $2d0c76ae9ca5c817$var$useRippleHandler(ripple, 'stop', onContextMenu, disableTouchRipple);
    const handleDragLeave = $2d0c76ae9ca5c817$var$useRippleHandler(ripple, 'stop', onDragLeave, disableTouchRipple);
    const handleMouseUp = $2d0c76ae9ca5c817$var$useRippleHandler(ripple, 'stop', onMouseUp, disableTouchRipple);
    const handleMouseLeave = $2d0c76ae9ca5c817$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = $2d0c76ae9ca5c817$var$useRippleHandler(ripple, 'start', onTouchStart, disableTouchRipple);
    const handleTouchEnd = $2d0c76ae9ca5c817$var$useRippleHandler(ripple, 'stop', onTouchEnd, disableTouchRipple);
    const handleTouchMove = $2d0c76ae9ca5c817$var$useRippleHandler(ripple, 'stop', onTouchMove, disableTouchRipple);
    const handleBlur = $2d0c76ae9ca5c817$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (!(0, $0d3c83b1c3920329$export$2e2bcd8739ae039)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if ((0, $0d3c83b1c3920329$export$2e2bcd8739ae039)(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    const handleKeyDown = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === ' ') ripple.stop(event, ()=>{
            ripple.start(event);
        });
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    };
    const classes = $2d0c76ae9ca5c817$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($2d0c76ae9ca5c817$export$7ec0dcc5e3cdcd36, {
        as: ComponentProp,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type,
        ...buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3f5ffa895ad4456e$export$2e2bcd8739ae039), {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
function $2d0c76ae9ca5c817$var$useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var $2d0c76ae9ca5c817$export$2e2bcd8739ae039 = $2d0c76ae9ca5c817$var$ButtonBase;






function $be601d991ccbe49a$export$46f01d01378ec5a2(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiDivider', slot);
}
const $be601d991ccbe49a$var$dividerClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $be601d991ccbe49a$export$2e2bcd8739ae039 = $be601d991ccbe49a$var$dividerClasses;




function $7a8a9052410fb062$export$81478e24460c57f2(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiListItemIcon', slot);
}
const $7a8a9052410fb062$var$listItemIconClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $7a8a9052410fb062$export$2e2bcd8739ae039 = $7a8a9052410fb062$var$listItemIconClasses;




function $2a8a1c268392e331$export$1061006a0db3aeb5(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiListItemText', slot);
}
const $2a8a1c268392e331$var$listItemTextClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $2a8a1c268392e331$export$2e2bcd8739ae039 = $2a8a1c268392e331$var$listItemTextClasses;




function $81e9a11bd449f186$export$515f8c67b5305377(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiMenuItem', slot);
}
const $81e9a11bd449f186$var$menuItemClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $81e9a11bd449f186$export$2e2bcd8739ae039 = $81e9a11bd449f186$var$menuItemClasses;



'use client';
const $3bdbe9250415b022$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $3bdbe9250415b022$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $81e9a11bd449f186$export$515f8c67b5305377), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $3bdbe9250415b022$var$MenuItemRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $0820e164eb5fbaff$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $3bdbe9250415b022$export$4334bb34c76fef24
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body1,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $81e9a11bd449f186$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $81e9a11bd449f186$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $81e9a11bd449f186$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $81e9a11bd449f186$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $81e9a11bd449f186$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $be601d991ccbe49a$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $be601d991ccbe49a$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $2a8a1c268392e331$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $2a8a1c268392e331$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $7a8a9052410fb062$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dense,
                style: {
                    [theme.breakpoints.up('sm')]: {
                        minHeight: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: {
                    minHeight: 32,
                    // https://m2.material.io/components/menus#specs > Dense
                    paddingTop: 4,
                    paddingBottom: 4,
                    ...theme.typography.body2,
                    [`& .${(0, $7a8a9052410fb062$export$2e2bcd8739ae039).root} svg`]: {
                        fontSize: '1.25rem'
                    }
                }
            }
        ]
    })));
const $3bdbe9250415b022$var$MenuItem = /*#__PURE__*/ $7fPBF.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className, ...other } = props;
    const context = $7fPBF.useContext((0, $94e271e17fd22222$export$2e2bcd8739ae039));
    const childContext = $7fPBF.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $7fPBF.useRef(null);
    (0, $cfde3819487a0686$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    };
    const classes = $3bdbe9250415b022$var$useUtilityClasses(props);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $94e271e17fd22222$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3bdbe9250415b022$var$MenuItemRoot, {
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
            ...other,
            ownerState: ownerState,
            classes: classes
        })
    });
});
var $3bdbe9250415b022$export$2e2bcd8739ae039 = $3bdbe9250415b022$var$MenuItem;





function $b1109042f38aaa6d$var$ExpressionControlField({ value: value, onChange: onChange, disabled: disabled }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const fieldId = (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $26a8e925f0aa9998$export$2e2bcd8739ae039), {
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcd80672e9993aad$export$2e2bcd8739ae039), {
                id: fieldId,
                children: t('common:expression.label')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                disabled: disabled,
                labelId: fieldId,
                value: value,
                label: t('common:expression.label'),
                onChange: (e)=>onChange(e.target.value),
                children: (0, $f44f3a5bc46b1c4c$export$c64c937c3a3522ea).map((c)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        value: c.value,
                        children: t(c.title)
                    }, c.value))
            })
        ]
    });
}
var $b1109042f38aaa6d$export$2e2bcd8739ae039 = $b1109042f38aaa6d$var$ExpressionControlField;







function $c32407a418a9484e$var$ExternalKeyControlField({ value: value, onChange: onChange, disabled: disabled }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const fieldId = (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $26a8e925f0aa9998$export$2e2bcd8739ae039), {
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcd80672e9993aad$export$2e2bcd8739ae039), {
                id: fieldId,
                children: t('common:keys.label')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                disabled: disabled,
                labelId: fieldId,
                value: value,
                label: t('common:keys.label'),
                onChange: (e)=>onChange(e.target.value),
                children: (0, $f44f3a5bc46b1c4c$export$71d467a5c4a5cf9f).map((c)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        value: c.value,
                        children: c.translationKey ? t(c.translationKey) : c.title
                    }, c.value))
            })
        ]
    });
}
var $c32407a418a9484e$export$2e2bcd8739ae039 = $c32407a418a9484e$var$ExternalKeyControlField;







function $c0e1046edce6d946$var$HeadControlField({ value: value, onChange: onChange, disabled: disabled }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const fieldId = (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $26a8e925f0aa9998$export$2e2bcd8739ae039), {
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcd80672e9993aad$export$2e2bcd8739ae039), {
                id: fieldId,
                children: t('common:head.label')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                labelId: 'head',
                value: value,
                label: t('common:head.label'),
                onChange: (e)=>onChange(e.target.value),
                disabled: disabled,
                children: (0, $f44f3a5bc46b1c4c$export$b47f0ea920cae9ed).map((c)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        value: c.value,
                        children: t(c.title)
                    }, c.value))
            })
        ]
    });
}
var $c0e1046edce6d946$export$2e2bcd8739ae039 = $c0e1046edce6d946$var$HeadControlField;






function $5f22d2958842cad1$var$HotkeyControlField({ value: value, onChange: onChange, disabled: disabled, ...restProps }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    value = value.replace((0, $f44f3a5bc46b1c4c$export$b617c310e3426257), '');
    const handleChange = (value)=>{
        value = value.replace((0, $f44f3a5bc46b1c4c$export$b617c310e3426257), '');
        onChange('hotkey_' + value);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
        fullWidth: true,
        disabled: disabled,
        type: "text",
        value: value,
        label: t('common:hotkey.label'),
        placeholder: t('common:hotkey.placeholder'),
        onChange: (e)=>handleChange(e.target.value),
        ...restProps
    });
}
var $5f22d2958842cad1$export$2e2bcd8739ae039 = $5f22d2958842cad1$var$HotkeyControlField;





function $3f5241a464a7fe52$var$OtherControlField({ value: value, onChange: onChange, disabled: disabled }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
        fullWidth: true,
        disabled: disabled,
        type: "text",
        value: value,
        label: t('common:other.label'),
        placeholder: t('common:other.placeholder'),
        onChange: (e)=>onChange(e.target.value)
    });
}
var $3f5241a464a7fe52$export$2e2bcd8739ae039 = $3f5241a464a7fe52$var$OtherControlField;







function $573d96641b0a52c8$var$TiltControlField({ value: value, onChange: onChange, disabled: disabled }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const fieldId = (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)();
    disabled = true;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $26a8e925f0aa9998$export$2e2bcd8739ae039), {
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fcd80672e9993aad$export$2e2bcd8739ae039), {
                id: fieldId,
                children: [
                    t('common:motion.title'),
                    " - ",
                    t('common:deprecated')
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                disabled: disabled,
                labelId: fieldId,
                value: value,
                label: t('common:motion.title'),
                onChange: (e)=>onChange(e.target.value),
                children: (0, $f44f3a5bc46b1c4c$export$6ed006bdf26d1b97).map((c)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        value: c.value,
                        children: t(c.title)
                    }, c.value))
            })
        ]
    });
}
var $573d96641b0a52c8$export$2e2bcd8739ae039 = $573d96641b0a52c8$var$TiltControlField;





function $2ed5e210cedb5cf5$var$VoiceControlField({ value: value, onChange: onChange, disabled: disabled }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
        disabled: disabled,
        fullWidth: true,
        value: value,
        label: t('common:voice.title'),
        placeholder: t('common:voice.placeholder'),
        onChange: (e)=>onChange(e.target.value)
    });
}
var $2ed5e210cedb5cf5$export$2e2bcd8739ae039 = $2ed5e210cedb5cf5$var$VoiceControlField;


const $00051b104a6506d5$var$controlTypeRenderMap = {
    expression: (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b1109042f38aaa6d$export$2e2bcd8739ae039), {
            ...props
        }),
    externalKeyboard: (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c32407a418a9484e$export$2e2bcd8739ae039), {
            ...props
        }),
    head: (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c0e1046edce6d946$export$2e2bcd8739ae039), {
            ...props
        }),
    motion: (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $573d96641b0a52c8$export$2e2bcd8739ae039), {
            ...props
        }),
    spoken: (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40551a8a102d1426$export$2e2bcd8739ae039), {
            ...props
        }),
    tilt: (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $573d96641b0a52c8$export$2e2bcd8739ae039), {
            ...props
        }),
    hotkey: (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5f22d2958842cad1$export$2e2bcd8739ae039), {
            ...props
        }),
    voice: (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2ed5e210cedb5cf5$export$2e2bcd8739ae039), {
            ...props
        }),
    other: (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3f5241a464a7fe52$export$2e2bcd8739ae039), {
            ...props
        })
};
function $00051b104a6506d5$export$43ee9de14381bd97({ control: control, value: value, onChange: onChange, disabled: disabled, ...restProps }) {
    const controlTypeComponent = $00051b104a6506d5$var$controlTypeRenderMap[control];
    if (controlTypeComponent) {
        const controlProps = {
            value: value,
            onChange: onChange,
            disabled: disabled,
            ...restProps
        };
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
            children: controlTypeComponent(controlProps)
        });
    }
    return null;
}





var $7fPBF = parcelRequire("7fPBF");













function $565e939c768ed837$export$69aecd24bc2cf7e3(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiAlert', slot);
}
const $565e939c768ed837$var$alertClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiAlert', [
    'root',
    'action',
    'icon',
    'message',
    'filled',
    'colorSuccess',
    'colorInfo',
    'colorWarning',
    'colorError',
    'filledSuccess',
    'filledInfo',
    'filledWarning',
    'filledError',
    'outlined',
    'outlinedSuccess',
    'outlinedInfo',
    'outlinedWarning',
    'outlinedError',
    'standard',
    'standardSuccess',
    'standardInfo',
    'standardWarning',
    'standardError'
]);
var $565e939c768ed837$export$2e2bcd8739ae039 = $565e939c768ed837$var$alertClasses;



var $7fPBF = parcelRequire("7fPBF");





'use client';
var $8631184a92cee7e5$export$2e2bcd8739ae039 = (0, $46f5b561912058f9$export$2e2bcd8739ae039);












function $0bca18aab596affa$export$5e8702d71474f093(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiIconButton', slot);
}
const $0bca18aab596affa$var$iconButtonClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'loading',
    'loadingIndicator',
    'loadingWrapper'
]);
var $0bca18aab596affa$export$2e2bcd8739ae039 = $0bca18aab596affa$var$iconButtonClasses;



'use client';
const $67a243c492197f3b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size, loading: loading } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            edge && `edge${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(edge)}`,
            `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $0bca18aab596affa$export$5e8702d71474f093), classes);
};
const $67a243c492197f3b$var$IconButtonRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.loading && styles.loading,
            ownerState.color !== 'default' && styles[`color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.edge)}`],
            styles[`size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: (props)=>!props.disableRipple,
                style: {
                    '--IconButton-hoverBg': theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                    '&:hover': {
                        backgroundColor: 'var(--IconButton-hoverBg)',
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: {
                    edge: 'start'
                },
                style: {
                    marginLeft: -12
                }
            },
            {
                props: {
                    edge: 'start',
                    size: 'small'
                },
                style: {
                    marginLeft: -3
                }
            },
            {
                props: {
                    edge: 'end'
                },
                style: {
                    marginRight: -12
                }
            },
            {
                props: {
                    edge: 'end',
                    size: 'small'
                },
                style: {
                    marginRight: -3
                }
            }
        ]
    })), (0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            ...Object.entries(theme.palette).filter((0, $061b5988a3817e26$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $061b5988a3817e26$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--IconButton-hoverBg': theme.vars ? `rgba(${(theme.vars || theme).palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)((theme.vars || theme).palette[color].main, theme.palette.action.hoverOpacity)
                    }
                })),
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 5,
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 12,
                    fontSize: theme.typography.pxToRem(28)
                }
            }
        ],
        [`&.${(0, $0bca18aab596affa$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        },
        [`&.${(0, $0bca18aab596affa$export$2e2bcd8739ae039).loading}`]: {
            color: 'transparent'
        }
    })));
const $67a243c492197f3b$var$IconButtonLoadingIndicator = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiIconButton',
    slot: 'LoadingIndicator',
    overridesResolver: (props, styles)=>styles.loadingIndicator
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: (theme.vars || theme).palette.action.disabled,
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            }
        ]
    }));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $67a243c492197f3b$var$IconButton = /*#__PURE__*/ $7fPBF.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium', id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, ...other } = props;
    const loadingId = (0, $8631184a92cee7e5$export$2e2bcd8739ae039)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d513166e63c42433$export$2e2bcd8739ae039), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        loading: loading,
        loadingIndicator: loadingIndicator,
        size: size
    };
    const classes = $67a243c492197f3b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($67a243c492197f3b$var$IconButtonRoot, {
        id: loading ? loadingId : idProp,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled || loading,
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: [
            typeof loading === 'boolean' && /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
            (0, $824c049f32d4395d$exports.jsx)("span", {
                className: classes.loadingWrapper,
                style: {
                    display: 'contents'
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($67a243c492197f3b$var$IconButtonLoadingIndicator, {
                    className: classes.loadingIndicator,
                    ownerState: ownerState,
                    children: loading && loadingIndicator
                })
            }),
            children
        ]
    });
});
var $67a243c492197f3b$export$2e2bcd8739ae039 = $67a243c492197f3b$var$IconButton;


parcelRequire("7fPBF");


'use client';
var $4b1f521fdeb04ba7$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');


parcelRequire("7fPBF");


'use client';
var $a8adb66ebb93bcb3$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');


parcelRequire("7fPBF");


'use client';
var $ac73453dd233d58d$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');


parcelRequire("7fPBF");


'use client';
var $f3c8ba0a935153e4$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');


parcelRequire("7fPBF");


'use client';
var $8b028f185c60f26d$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');



'use client';
const $c181cff0789717b3$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color || severity)}`,
            `${variant}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ],
        action: [
            'action'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $565e939c768ed837$export$69aecd24bc2cf7e3), classes);
};
const $c181cff0789717b3$var$AlertRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color || ownerState.severity)}`]
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const getColor = theme.palette.mode === 'light' ? (0, $4afad3ab73a4d920$export$4b073707ff63303) : (0, $4afad3ab73a4d920$export$c0816ed86df316af);
    const getBackgroundColor = theme.palette.mode === 'light' ? (0, $4afad3ab73a4d920$export$c0816ed86df316af) : (0, $4afad3ab73a4d920$export$4b073707ff63303);
    return {
        ...theme.typography.body2,
        backgroundColor: 'transparent',
        display: 'flex',
        padding: '6px 16px',
        variants: [
            ...Object.entries(theme.palette).filter((0, $061b5988a3817e26$export$2e2bcd8739ae039)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'standard'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, $565e939c768ed837$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $061b5988a3817e26$export$2e2bcd8739ae039)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'outlined'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, $565e939c768ed837$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $061b5988a3817e26$export$2e2bcd8739ae039)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'filled'
                    },
                    style: {
                        fontWeight: theme.typography.fontWeightMedium,
                        ...theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}FilledColor`],
                            backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                        } : {
                            backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
                            color: theme.palette.getContrastText(theme.palette[color].main)
                        }
                    }
                }))
        ]
    };
}));
const $c181cff0789717b3$var$AlertIcon = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiAlert',
    slot: 'Icon',
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
});
const $c181cff0789717b3$var$AlertMessage = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiAlert',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0',
    minWidth: 0,
    overflow: 'auto'
});
const $c181cff0789717b3$var$AlertAction = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiAlert',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
});
const $c181cff0789717b3$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4b1f521fdeb04ba7$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a8adb66ebb93bcb3$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ac73453dd233d58d$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f3c8ba0a935153e4$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $c181cff0789717b3$var$Alert = /*#__PURE__*/ $7fPBF.forwardRef(function Alert(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiAlert'
    });
    const { action: action, children: children, className: className, closeText: closeText = 'Close', color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $c181cff0789717b3$var$defaultIconMapping, onClose: onClose, role: role = 'alert', severity: severity = 'success', slotProps: slotProps = {}, slots: slots = {}, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    };
    const classes = $c181cff0789717b3$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('root', {
        ref: ref,
        shouldForwardComponentProp: true,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $c181cff0789717b3$var$AlertRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            role: role,
            elevation: 0
        }
    });
    const [IconSlot, iconSlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('icon', {
        className: classes.icon,
        elementType: $c181cff0789717b3$var$AlertIcon,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [MessageSlot, messageSlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('message', {
        className: classes.message,
        elementType: $c181cff0789717b3$var$AlertMessage,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ActionSlot, actionSlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('action', {
        className: classes.action,
        elementType: $c181cff0789717b3$var$AlertAction,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseButtonSlot, closeButtonProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('closeButton', {
        elementType: (0, $67a243c492197f3b$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('closeIcon', {
        elementType: (0, $8b028f185c60f26d$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            icon !== false ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(IconSlot, {
                ...iconSlotProps,
                children: icon || iconMapping[severity] || $c181cff0789717b3$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(MessageSlot, {
                ...messageSlotProps,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(CloseButtonSlot, {
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose,
                    ...closeButtonProps,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(CloseIconSlot, {
                        fontSize: "small",
                        ...closeIconProps
                    })
                })
            }) : null
        ]
    });
});
var $c181cff0789717b3$export$2e2bcd8739ae039 = $c181cff0789717b3$var$Alert;


var $7fPBF = parcelRequire("7fPBF");









function $833ef9b800b82ea7$export$f3b76d2cce458caa(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiCard', slot);
}
const $833ef9b800b82ea7$var$cardClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiCard', [
    'root'
]);
var $833ef9b800b82ea7$export$2e2bcd8739ae039 = $833ef9b800b82ea7$var$cardClasses;



'use client';
const $bfb223886c302418$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $833ef9b800b82ea7$export$f3b76d2cce458caa), classes);
};
const $bfb223886c302418$var$CardRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: 'MuiCard',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    overflow: 'hidden'
});
const $bfb223886c302418$var$Card = /*#__PURE__*/ $7fPBF.forwardRef(function Card(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCard'
    });
    const { className: className, raised: raised = false, ...other } = props;
    const ownerState = {
        ...props,
        raised: raised
    };
    const classes = $bfb223886c302418$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($bfb223886c302418$var$CardRoot, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $bfb223886c302418$export$2e2bcd8739ae039 = $bfb223886c302418$var$Card;


var $7fPBF = parcelRequire("7fPBF");












function $7d55f5085d222c99$export$717666c39ec07e12(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiFormControlLabel', slot);
}
const $7d55f5085d222c99$var$formControlLabelClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $7d55f5085d222c99$export$2e2bcd8739ae039 = $7d55f5085d222c99$var$formControlLabelClasses;





'use client';
const $206020d7e70b2617$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $7d55f5085d222c99$export$717666c39ec07e12), classes);
};
const $206020d7e70b2617$export$1b479270917a5676 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $7d55f5085d222c99$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.labelPlacement)}`]
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $7d55f5085d222c99$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        [`& .${(0, $7d55f5085d222c99$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $7d55f5085d222c99$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        },
        variants: [
            {
                props: {
                    labelPlacement: 'start'
                },
                style: {
                    flexDirection: 'row-reverse',
                    marginRight: -11
                }
            },
            {
                props: {
                    labelPlacement: 'top'
                },
                style: {
                    flexDirection: 'column-reverse'
                }
            },
            {
                props: {
                    labelPlacement: 'bottom'
                },
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ labelPlacement: labelPlacement })=>labelPlacement === 'start' || labelPlacement === 'top' || labelPlacement === 'bottom',
                style: {
                    marginLeft: 16 // used for row presentation of radio/checkbox
                }
            }
        ]
    })));
const $206020d7e70b2617$var$AsteriskComponent = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        [`&.${(0, $7d55f5085d222c99$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $206020d7e70b2617$var$FormControlLabel = /*#__PURE__*/ $7fPBF.forwardRef(function FormControlLabel(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { checked: checked, className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, inputRef: inputRef, label: labelProp, labelPlacement: labelPlacement = 'end', name: name, onChange: onChange, required: requiredProp, slots: slots = {}, slotProps: slotProps = {}, value: value, ...other } = props;
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const disabled = disabledProp ?? control.props.disabled ?? muiFormControl?.disabled;
    const required = requiredProp ?? control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = {
        ...props,
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    };
    const classes = $206020d7e70b2617$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [TypographySlot, typographySlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('typography', {
        elementType: (0, $26f68e516ee75fc4$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    let label = labelProp;
    if (label != null && label.type !== (0, $26f68e516ee75fc4$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TypographySlot, {
        component: "span",
        ...typographySlotProps,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.label, typographySlotProps?.className),
        children: label
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($206020d7e70b2617$export$1b479270917a5676, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: [
            /*#__PURE__*/ $7fPBF.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    label,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($206020d7e70b2617$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    });
});
var $206020d7e70b2617$export$2e2bcd8739ae039 = $206020d7e70b2617$var$FormControlLabel;


var $7fPBF = parcelRequire("7fPBF");







function $812fc58290adb713$export$d72d4cbdc30b331f(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiFormGroup', slot);
}
const $812fc58290adb713$var$formGroupClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiFormGroup', [
    'root',
    'row',
    'error'
]);
var $812fc58290adb713$export$2e2bcd8739ae039 = $812fc58290adb713$var$formGroupClasses;





'use client';
const $cd2b84e36aef1fba$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $812fc58290adb713$export$d72d4cbdc30b331f), classes);
};
const $cd2b84e36aef1fba$var$FormGroupRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiFormGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})({
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    variants: [
        {
            props: {
                row: true
            },
            style: {
                flexDirection: 'row'
            }
        }
    ]
});
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $cd2b84e36aef1fba$var$FormGroup = /*#__PURE__*/ $7fPBF.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormGroup'
    });
    const { className: className, row: row = false, ...other } = props;
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = {
        ...props,
        row: row,
        error: fcs.error
    };
    const classes = $cd2b84e36aef1fba$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($cd2b84e36aef1fba$var$FormGroupRoot, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $cd2b84e36aef1fba$export$2e2bcd8739ae039 = $cd2b84e36aef1fba$var$FormGroup;


var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");











function $5928be47f00793d2$export$baa0faa0c7ad8085(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('PrivateSwitchBase', slot);
}
const $5928be47f00793d2$var$switchBaseClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $5928be47f00793d2$export$2e2bcd8739ae039 = $5928be47f00793d2$var$switchBaseClasses;




'use client';
const $69935e2350f58c79$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $5928be47f00793d2$export$baa0faa0c7ad8085), classes);
};
const $69935e2350f58c79$var$SwitchBaseRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    name: 'MuiSwitchBase'
})({
    padding: 9,
    borderRadius: '50%',
    variants: [
        {
            props: {
                edge: 'start',
                size: 'small'
            },
            style: {
                marginLeft: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'start' && ownerState.size !== 'small',
            style: {
                marginLeft: -12
            }
        },
        {
            props: {
                edge: 'end',
                size: 'small'
            },
            style: {
                marginRight: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'end' && ownerState.size !== 'small',
            style: {
                marginRight: -12
            }
        }
    ]
});
const $69935e2350f58c79$var$SwitchBaseInput = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('input', {
    name: 'MuiSwitchBase',
    shouldForwardProp: (0, $0820e164eb5fbaff$export$2e2bcd8739ae039)
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $69935e2350f58c79$var$SwitchBase = /*#__PURE__*/ $7fPBF.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const [checked, setCheckedState] = (0, $3b64539a8a5729fa$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = {
        ...props,
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    };
    const classes = $69935e2350f58c79$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: inputProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $69935e2350f58c79$var$SwitchBaseRoot,
        className: classes.root,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            component: 'span',
            ...other
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onFocus: (event)=>{
                    handlers.onFocus?.(event);
                    handleFocus(event);
                },
                onBlur: (event)=>{
                    handlers.onBlur?.(event);
                    handleBlur(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            centerRipple: true,
            focusRipple: !disableFocusRipple,
            disabled: disabled,
            role: undefined,
            tabIndex: null
        }
    });
    const [InputSlot, inputSlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('input', {
        ref: inputRef,
        elementType: $69935e2350f58c79$var$SwitchBaseInput,
        className: classes.input,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                onChange: (event)=>{
                    handlers.onChange?.(event);
                    handleInputChange(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            autoFocus: autoFocus,
            checked: checkedProp,
            defaultChecked: defaultChecked,
            disabled: disabled,
            id: hasLabelFor ? id : undefined,
            name: name,
            readOnly: readOnly,
            required: required,
            tabIndex: tabIndex,
            type: type,
            ...type === 'checkbox' && value === undefined ? {} : {
                value: value
            }
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(InputSlot, {
                ...inputSlotProps
            }),
            checked ? checkedIcon : icon
        ]
    });
});
var $69935e2350f58c79$export$2e2bcd8739ae039 = $69935e2350f58c79$var$SwitchBase;


parcelRequire("7fPBF");

parcelRequire("7fPBF");


'use client';
var $ac707a057545a407$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');


parcelRequire("7fPBF");


'use client';
var $37003fd2171922a7$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');






'use client';
const $96b9a35dc7d8e11f$var$RadioButtonIconRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiRadioButtonIcon',
    shouldForwardProp: (0, $0820e164eb5fbaff$export$2e2bcd8739ae039)
})({
    position: 'relative',
    display: 'flex'
});
const $96b9a35dc7d8e11f$var$RadioButtonIconBackground = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $ac707a057545a407$export$2e2bcd8739ae039), {
    name: 'MuiRadioButtonIcon'
})({
    // Scale applied to prevent dot misalignment in Safari
    transform: 'scale(1)'
});
const $96b9a35dc7d8e11f$var$RadioButtonIconDot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $37003fd2171922a7$export$2e2bcd8739ae039), {
    name: 'MuiRadioButtonIcon'
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        left: 0,
        position: 'absolute',
        transform: 'scale(0)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    checked: true
                },
                style: {
                    transform: 'scale(1)',
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeOut,
                        duration: theme.transitions.duration.shortest
                    })
                }
            }
        ]
    })));
/**
 * @ignore - internal component.
 */ function $96b9a35dc7d8e11f$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = {
        ...props,
        checked: checked
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($96b9a35dc7d8e11f$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($96b9a35dc7d8e11f$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($96b9a35dc7d8e11f$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var $96b9a35dc7d8e11f$export$2e2bcd8739ae039 = $96b9a35dc7d8e11f$var$RadioButtonIcon;




var $0e6a2af606f99b7f$export$2e2bcd8739ae039 = (0, $d6e7ffad706c848e$export$2e2bcd8739ae039);




var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
'use client';
/**
 * @ignore - internal component.
 */ const $81ff23480207fa97$var$RadioGroupContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
var $81ff23480207fa97$export$2e2bcd8739ae039 = $81ff23480207fa97$var$RadioGroupContext;


'use client';
function $bd8bfb8e1742ab4f$export$2e2bcd8739ae039() {
    return $7fPBF.useContext((0, $81ff23480207fa97$export$2e2bcd8739ae039));
}




function $e9a5de8192a35b89$export$192f7b2363c77155(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiRadio', slot);
}
const $e9a5de8192a35b89$var$radioClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiRadio', [
    'root',
    'checked',
    'disabled',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall'
]);
var $e9a5de8192a35b89$export$2e2bcd8739ae039 = $e9a5de8192a35b89$var$radioClasses;









'use client';
const $de28970229c88fa7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            size !== 'medium' && `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`
        ]
    };
    return {
        ...classes,
        ...(0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $e9a5de8192a35b89$export$192f7b2363c77155), classes)
    };
};
const $de28970229c88fa7$var$RadioRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $69935e2350f58c79$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $0820e164eb5fbaff$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiRadio',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size !== 'medium' && styles[`size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`],
            styles[`color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $e9a5de8192a35b89$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    color: 'default',
                    disabled: false,
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $061b5988a3817e26$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disabled: false,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $061b5988a3817e26$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disabled: false
                    },
                    style: {
                        [`&.${(0, $e9a5de8192a35b89$export$2e2bcd8739ae039).checked}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
function $de28970229c88fa7$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $de28970229c88fa7$var$defaultCheckedIcon = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $96b9a35dc7d8e11f$export$2e2bcd8739ae039), {
    checked: true
});
const $de28970229c88fa7$var$defaultIcon = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $96b9a35dc7d8e11f$export$2e2bcd8739ae039), {});
const $de28970229c88fa7$var$Radio = /*#__PURE__*/ $7fPBF.forwardRef(function Radio(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiRadio'
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $de28970229c88fa7$var$defaultCheckedIcon, color: color = 'primary', icon: icon = $de28970229c88fa7$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = 'medium', className: className, disabled: disabledProp, disableRipple: disableRipple = false, slots: slots = {}, slotProps: slotProps = {}, inputProps: inputProps, ...other } = props;
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    disabled ??= false;
    const ownerState = {
        ...props,
        disabled: disabled,
        disableRipple: disableRipple,
        color: color,
        size: size
    };
    const classes = $de28970229c88fa7$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $bd8bfb8e1742ab4f$export$2e2bcd8739ae039)();
    let checked = checkedProp;
    const onChange = (0, $0e6a2af606f99b7f$export$2e2bcd8739ae039)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === 'undefined') checked = $de28970229c88fa7$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === 'undefined') name = radioGroup.name;
    }
    const externalInputProps = slotProps.input ?? inputProps;
    const [RootSlot, rootSlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $de28970229c88fa7$var$RadioRoot,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            ...other
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onChange: (event, ...args)=>{
                    handlers.onChange?.(event, ...args);
                    onChange(event, ...args);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            type: 'radio',
            icon: /*#__PURE__*/ $7fPBF.cloneElement(icon, {
                fontSize: icon.props.fontSize ?? size
            }),
            checkedIcon: /*#__PURE__*/ $7fPBF.cloneElement(checkedIcon, {
                fontSize: checkedIcon.props.fontSize ?? size
            }),
            disabled: disabled,
            name: name,
            checked: checked,
            slots: slots,
            slotProps: {
                // Do not forward `slotProps.root` again because it's already handled by the `RootSlot` in this file.
                input: typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps
            }
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(RootSlot, {
        ...rootSlotProps,
        classes: classes
    });
});
var $de28970229c88fa7$export$2e2bcd8739ae039 = $de28970229c88fa7$var$Radio;


var $7fPBF = parcelRequire("7fPBF");






function $1f316e1fd8da9f4a$export$c4cff3a43f7cabb6(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiRadioGroup', slot);
}
const $1f316e1fd8da9f4a$var$radioGroupClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiRadioGroup', [
    'root',
    'row',
    'error'
]);
var $1f316e1fd8da9f4a$export$2e2bcd8739ae039 = $1f316e1fd8da9f4a$var$radioGroupClasses;







'use client';
const $e1f776e3a27ad5dc$var$useUtilityClasses = (props)=>{
    const { classes: classes, row: row, error: error } = props;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $1f316e1fd8da9f4a$export$c4cff3a43f7cabb6), classes);
};
const $e1f776e3a27ad5dc$var$RadioGroup = /*#__PURE__*/ $7fPBF.forwardRef(function RadioGroup(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, children: children, className: className, defaultValue: defaultValue, name: nameProp, onChange: onChange, value: valueProp, ...other } = props;
    const rootRef = $7fPBF.useRef(null);
    const classes = $e1f776e3a27ad5dc$var$useUtilityClasses(props);
    const [value, setValueState] = (0, $3b64539a8a5729fa$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'RadioGroup'
    });
    $7fPBF.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector('input:not(:disabled):checked');
                if (!input) input = rootRef.current.querySelector('input:not(:disabled)');
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(ref, rootRef);
    const name = (0, $8631184a92cee7e5$export$2e2bcd8739ae039)(nameProp);
    const contextValue = $7fPBF.useMemo(()=>({
            name: name,
            onChange (event) {
                setValueState(event.target.value);
                if (onChange) onChange(event, event.target.value);
            },
            value: value
        }), [
        name,
        onChange,
        setValueState,
        value
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $81ff23480207fa97$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cd2b84e36aef1fba$export$2e2bcd8739ae039), {
            role: "radiogroup",
            ref: handleRef,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
            ...other,
            children: children
        })
    });
});
var $e1f776e3a27ad5dc$export$2e2bcd8739ae039 = $e1f776e3a27ad5dc$var$RadioGroup;








function $5c09a12afb55a78a$var$DeleteIconButton({ children: children, $color: $color = 'simple', $size: $size = 'small', onClick: onClick }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5c09a12afb55a78a$var$StyledButton, {
        $color: $color,
        $size: $size,
        startIcon: "delete",
        onClick: onClick,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30af349a5a5f3e57$export$2e2bcd8739ae039), {
            children: children
        })
    });
}
const $5c09a12afb55a78a$var$StyledButton = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039))`
    width: 42px;
    height: 42px;
    gap: 0;
    color: ${(0, $8951886a6b49e92a$export$35e9368ef982300f).error};
    border-radius: 50%;
    :hover {
        background-color: ${(0, $8951886a6b49e92a$export$35e9368ef982300f).error};
        box-shadow: none;
        color: white;
        svg {
            fill: white;
        }
    }
`;
var $5c09a12afb55a78a$export$2e2bcd8739ae039 = $5c09a12afb55a78a$var$DeleteIconButton;




const $6e48650aa2ed148e$var$HorizontalFieldContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    margin: 1rem 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.25rem;
    input {
        flex: 1;
        margin-top: 4px;
        flex-grow: 1;
    }
`;
var $6e48650aa2ed148e$export$2e2bcd8739ae039 = $6e48650aa2ed148e$var$HorizontalFieldContainer;







const $98e7e100f470a300$export$7f714e6c560938e5 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd))`
    color: ${(0, $8951886a6b49e92a$export$35e9368ef982300f).error};
    text-align: center;
`;
const $98e7e100f470a300$export$d953939534de1974 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$a79389cfbe6f64d))`
    color: ${(props)=>props.theme.color.text};
    text-align: left;
    margin-bottom: 4px;
    margin-top: 1rem;
`.withComponent('legend');
const $98e7e100f470a300$export$1acdcf5a973a8414 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e))`
    text-align: left;
    margin-bottom: 4px;
    margin-top: 16px;
`.withComponent('label');









var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");





'use client';
function $430105663683d7ec$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $d1cc2e8a071de52d$export$2e2bcd8739ae039)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $c202727e06c030fc$export$2e2bcd8739ae039));
    const Box = /*#__PURE__*/ $7fPBF.forwardRef(function Box(inProps, ref) {
        const theme = (0, $c44ae2e7a62d29e0$export$2e2bcd8739ae039)(defaultTheme);
        const { className: className, component: component = 'div', ...other } = (0, $8eb9ca5f8e856bd1$export$2e2bcd8739ae039)(inProps);
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(BoxRoot, {
            as: component,
            ref: ref,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme,
            ...other
        });
    });
    return Box;
}







const $9dbabfa00f5ea67f$var$boxClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiBox', [
    'root'
]);
var $9dbabfa00f5ea67f$export$2e2bcd8739ae039 = $9dbabfa00f5ea67f$var$boxClasses;


'use client';
const $77ec199cefd4182a$var$defaultTheme = (0, $ca3239ce6bf6e490$export$2e2bcd8739ae039)();
const $77ec199cefd4182a$var$Box = (0, $430105663683d7ec$export$2e2bcd8739ae039)({
    themeId: (0, $e35ef6915a224202$export$2e2bcd8739ae039),
    defaultTheme: $77ec199cefd4182a$var$defaultTheme,
    defaultClassName: (0, $9dbabfa00f5ea67f$export$2e2bcd8739ae039).root,
    generateClassName: (0, $f37dfc12e5d89c96$export$2e2bcd8739ae039).generate
});
var $77ec199cefd4182a$export$2e2bcd8739ae039 = $77ec199cefd4182a$var$Box;


var $7fPBF = parcelRequire("7fPBF");







function $c2cdbecd165cb878$export$964336739a8c7119(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiCardContent', slot);
}
const $c2cdbecd165cb878$var$cardContentClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiCardContent', [
    'root'
]);
var $c2cdbecd165cb878$export$2e2bcd8739ae039 = $c2cdbecd165cb878$var$cardContentClasses;



'use client';
const $8bffaacbbee0c705$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $c2cdbecd165cb878$export$964336739a8c7119), classes);
};
const $8bffaacbbee0c705$var$CardContentRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiCardContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: 16,
    '&:last-child': {
        paddingBottom: 24
    }
});
const $8bffaacbbee0c705$var$CardContent = /*#__PURE__*/ $7fPBF.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCardContent'
    });
    const { className: className, component: component = 'div', ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $8bffaacbbee0c705$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8bffaacbbee0c705$var$CardContentRoot, {
        as: component,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $8bffaacbbee0c705$export$2e2bcd8739ae039 = $8bffaacbbee0c705$var$CardContent;


var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");
const $3af1e05012cfa2ee$var$visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
};
var $3af1e05012cfa2ee$export$2e2bcd8739ae039 = $3af1e05012cfa2ee$var$visuallyHidden;



function $d7d98442edb7a81d$var$areArraysEqual(array1, array2, itemComparer = (a, b)=>a === b) {
    return array1.length === array2.length && array1.every((value, index)=>itemComparer(value, array2[index]));
}
var $d7d98442edb7a81d$export$2e2bcd8739ae039 = $d7d98442edb7a81d$var$areArraysEqual;


'use client';
const $8ba901b5e0df8f0f$var$INTENTIONAL_DRAG_COUNT_THRESHOLD = 2;
function $8ba901b5e0df8f0f$var$getNewValue(currentValue, step, direction, min, max) {
    return direction === 1 ? Math.min(currentValue + step, max) : Math.max(currentValue - step, min);
}
function $8ba901b5e0df8f0f$var$asc(a, b) {
    return a - b;
}
function $8ba901b5e0df8f0f$var$findClosest(values, currentValue) {
    const { index: closestIndex } = values.reduce((acc, value, index)=>{
        const distance = Math.abs(currentValue - value);
        if (acc === null || distance < acc.distance || distance === acc.distance) return {
            distance: distance,
            index: index
        };
        return acc;
    }, null) ?? {};
    return closestIndex;
}
function $8ba901b5e0df8f0f$var$trackFinger(event, touchId) {
    // The event is TouchEvent
    if (touchId.current !== undefined && event.changedTouches) {
        const touchEvent = event;
        for(let i = 0; i < touchEvent.changedTouches.length; i += 1){
            const touch = touchEvent.changedTouches[i];
            if (touch.identifier === touchId.current) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    // The event is MouseEvent
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $8ba901b5e0df8f0f$export$83ce4bc8280540e6(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function $8ba901b5e0df8f0f$var$percentToValue(percent, min, max) {
    return (max - min) * percent + min;
}
function $8ba901b5e0df8f0f$var$getDecimalPrecision(num) {
    // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
    // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
    if (Math.abs(num) < 1) {
        const parts = num.toExponential().split('e-');
        const matissaDecimalPart = parts[0].split('.')[1];
        return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
    }
    const decimalPart = num.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
}
function $8ba901b5e0df8f0f$var$roundValueToStep(value, step, min) {
    const nearest = Math.round((value - min) / step) * step + min;
    return Number(nearest.toFixed($8ba901b5e0df8f0f$var$getDecimalPrecision(step)));
}
function $8ba901b5e0df8f0f$var$setValueIndex({ values: values, newValue: newValue, index: index }) {
    const output = values.slice();
    output[index] = newValue;
    return output.sort($8ba901b5e0df8f0f$var$asc);
}
function $8ba901b5e0df8f0f$var$focusThumb({ sliderRef: sliderRef, activeIndex: activeIndex, setActive: setActive }) {
    const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(sliderRef.current);
    if (!sliderRef.current?.contains(doc.activeElement) || Number(doc?.activeElement?.getAttribute('data-index')) !== activeIndex) sliderRef.current?.querySelector(`[type="range"][data-index="${activeIndex}"]`).focus();
    if (setActive) setActive(activeIndex);
}
function $8ba901b5e0df8f0f$var$areValuesEqual(newValue, oldValue) {
    if (typeof newValue === 'number' && typeof oldValue === 'number') return newValue === oldValue;
    if (typeof newValue === 'object' && typeof oldValue === 'object') return (0, $d7d98442edb7a81d$export$2e2bcd8739ae039)(newValue, oldValue);
    return false;
}
const $8ba901b5e0df8f0f$var$axisProps = {
    horizontal: {
        offset: (percent)=>({
                left: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    'horizontal-reverse': {
        offset: (percent)=>({
                right: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    vertical: {
        offset: (percent)=>({
                bottom: `${percent}%`
            }),
        leap: (percent)=>({
                height: `${percent}%`
            })
    }
};
const $8ba901b5e0df8f0f$export$544bf02140fa9a77 = (x)=>x;
// TODO: remove support for Safari < 13.
// https://caniuse.com/#search=touch-action
//
// Safari, on iOS, supports touch action since v13.
// Over 80% of the iOS phones are compatible
// in August 2020.
// Utilizing the CSS.supports method to check if touch-action is supported.
// Since CSS.supports is supported on all but Edge@12 and IE and touch-action
// is supported on both Edge@12 and IE if CSS.supports is not available that means that
// touch-action will be supported
let $8ba901b5e0df8f0f$var$cachedSupportsTouchActionNone;
function $8ba901b5e0df8f0f$var$doesSupportTouchActionNone() {
    if ($8ba901b5e0df8f0f$var$cachedSupportsTouchActionNone === undefined) {
        if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function') $8ba901b5e0df8f0f$var$cachedSupportsTouchActionNone = CSS.supports('touch-action', 'none');
        else $8ba901b5e0df8f0f$var$cachedSupportsTouchActionNone = true;
    }
    return $8ba901b5e0df8f0f$var$cachedSupportsTouchActionNone;
}
function $8ba901b5e0df8f0f$export$56b2c08e277f365(parameters) {
    const { 'aria-labelledby': ariaLabelledby, defaultValue: defaultValue, disabled: disabled = false, disableSwap: disableSwap = false, isRtl: isRtl = false, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = 'horizontal', rootRef: ref, scale: scale = $8ba901b5e0df8f0f$export$544bf02140fa9a77, step: step = 1, shiftStep: shiftStep = 10, tabIndex: tabIndex, value: valueProp } = parameters;
    const touchId = $7fPBF.useRef(undefined);
    // We can't use the :active browser pseudo-classes.
    // - The active state isn't triggered when clicking on the rail.
    // - The active state isn't transferred when inversing a range slider.
    const [active, setActive] = $7fPBF.useState(-1);
    const [open, setOpen] = $7fPBF.useState(-1);
    const [dragging, setDragging] = $7fPBF.useState(false);
    const moveCount = $7fPBF.useRef(0);
    // lastChangedValue is updated whenever onChange is triggered.
    const lastChangedValue = $7fPBF.useRef(null);
    const [valueDerived, setValueState] = (0, $bc6c881cebb96954$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue ?? min,
        name: 'Slider'
    });
    const handleChange = onChange && ((event, value, thumbIndex)=>{
        // Redefine target to allow name and value to be read.
        // This allows seamless integration with the most popular form libraries.
        // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
        // Clone the event to not override `target` of the original event.
        const nativeEvent = event.nativeEvent || event;
        // @ts-ignore The nativeEvent is function, not object
        const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
        Object.defineProperty(clonedEvent, 'target', {
            writable: true,
            value: {
                value: value,
                name: name
            }
        });
        lastChangedValue.current = value;
        onChange(clonedEvent, value, thumbIndex);
    });
    const range = Array.isArray(valueDerived);
    let values = range ? valueDerived.slice().sort($8ba901b5e0df8f0f$var$asc) : [
        valueDerived
    ];
    values = values.map((value)=>value == null ? min : (0, $3e74852d812b8b64$export$2e2bcd8739ae039)(value, min, max));
    const marks = marksProp === true && step !== null ? [
        ...Array(Math.floor((max - min) / step) + 1)
    ].map((_, index)=>({
            value: min + step * index
        })) : marksProp || [];
    const marksValues = marks.map((mark)=>mark.value);
    const [focusedThumbIndex, setFocusedThumbIndex] = $7fPBF.useState(-1);
    const sliderRef = $7fPBF.useRef(null);
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(ref, sliderRef);
    const createHandleHiddenInputFocus = (otherHandlers)=>(event)=>{
            const index = Number(event.currentTarget.getAttribute('data-index'));
            if ((0, $0d3c83b1c3920329$export$2e2bcd8739ae039)(event.target)) setFocusedThumbIndex(index);
            setOpen(index);
            otherHandlers?.onFocus?.(event);
        };
    const createHandleHiddenInputBlur = (otherHandlers)=>(event)=>{
            if (!(0, $0d3c83b1c3920329$export$2e2bcd8739ae039)(event.target)) setFocusedThumbIndex(-1);
            setOpen(-1);
            otherHandlers?.onBlur?.(event);
        };
    const changeValue = (event, valueInput)=>{
        const index = Number(event.currentTarget.getAttribute('data-index'));
        const value = values[index];
        const marksIndex = marksValues.indexOf(value);
        let newValue = valueInput;
        if (marks && step == null) {
            const maxMarksValue = marksValues[marksValues.length - 1];
            if (newValue >= maxMarksValue) newValue = maxMarksValue;
            else if (newValue <= marksValues[0]) newValue = marksValues[0];
            else newValue = newValue < value ? marksValues[marksIndex - 1] : marksValues[marksIndex + 1];
        }
        newValue = (0, $3e74852d812b8b64$export$2e2bcd8739ae039)(newValue, min, max);
        if (range) {
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $3e74852d812b8b64$export$2e2bcd8739ae039)(newValue, values[index - 1] || -Infinity, values[index + 1] || Infinity);
            const previousValue = newValue;
            newValue = $8ba901b5e0df8f0f$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: index
            });
            let activeIndex = index;
            // Potentially swap the index if needed.
            if (!disableSwap) activeIndex = newValue.indexOf(previousValue);
            $8ba901b5e0df8f0f$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex
            });
        }
        setValueState(newValue);
        setFocusedThumbIndex(index);
        if (handleChange && !$8ba901b5e0df8f0f$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, index);
        if (onChangeCommitted) onChangeCommitted(event, lastChangedValue.current ?? newValue);
    };
    const createHandleHiddenInputKeyDown = (otherHandlers)=>(event)=>{
            if ([
                'ArrowUp',
                'ArrowDown',
                'ArrowLeft',
                'ArrowRight',
                'PageUp',
                'PageDown',
                'Home',
                'End'
            ].includes(event.key)) {
                event.preventDefault();
                const index = Number(event.currentTarget.getAttribute('data-index'));
                const value = values[index];
                let newValue = null;
                // Keys actions that change the value by more than the most granular `step`
                // value are only applied if the step not `null`.
                // When step is `null`, the `marks` prop is used instead to define valid values.
                if (step != null) {
                    const stepSize = event.shiftKey ? shiftStep : step;
                    switch(event.key){
                        case 'ArrowUp':
                            newValue = $8ba901b5e0df8f0f$var$getNewValue(value, stepSize, 1, min, max);
                            break;
                        case 'ArrowRight':
                            newValue = $8ba901b5e0df8f0f$var$getNewValue(value, stepSize, isRtl ? -1 : 1, min, max);
                            break;
                        case 'ArrowDown':
                            newValue = $8ba901b5e0df8f0f$var$getNewValue(value, stepSize, -1, min, max);
                            break;
                        case 'ArrowLeft':
                            newValue = $8ba901b5e0df8f0f$var$getNewValue(value, stepSize, isRtl ? 1 : -1, min, max);
                            break;
                        case 'PageUp':
                            newValue = $8ba901b5e0df8f0f$var$getNewValue(value, shiftStep, 1, min, max);
                            break;
                        case 'PageDown':
                            newValue = $8ba901b5e0df8f0f$var$getNewValue(value, shiftStep, -1, min, max);
                            break;
                        case 'Home':
                            newValue = min;
                            break;
                        case 'End':
                            newValue = max;
                            break;
                        default:
                            break;
                    }
                } else if (marks) {
                    const maxMarksValue = marksValues[marksValues.length - 1];
                    const currentMarkIndex = marksValues.indexOf(value);
                    const decrementKeys = [
                        isRtl ? 'ArrowRight' : 'ArrowLeft',
                        'ArrowDown',
                        'PageDown',
                        'Home'
                    ];
                    const incrementKeys = [
                        isRtl ? 'ArrowLeft' : 'ArrowRight',
                        'ArrowUp',
                        'PageUp',
                        'End'
                    ];
                    if (decrementKeys.includes(event.key)) {
                        if (currentMarkIndex === 0) newValue = marksValues[0];
                        else newValue = marksValues[currentMarkIndex - 1];
                    } else if (incrementKeys.includes(event.key)) {
                        if (currentMarkIndex === marksValues.length - 1) newValue = maxMarksValue;
                        else newValue = marksValues[currentMarkIndex + 1];
                    }
                }
                if (newValue != null) changeValue(event, newValue);
            }
            otherHandlers?.onKeyDown?.(event);
        };
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        if (disabled && sliderRef.current.contains(document.activeElement)) // This is necessary because Firefox and Safari will keep focus
        // on a disabled element:
        // https://codesandbox.io/p/sandbox/mui-pr-22247-forked-h151h?file=/src/App.js
        // @ts-ignore
        document.activeElement?.blur();
    }, [
        disabled
    ]);
    if (disabled && active !== -1) setActive(-1);
    if (disabled && focusedThumbIndex !== -1) setFocusedThumbIndex(-1);
    const createHandleHiddenInputChange = (otherHandlers)=>(event)=>{
            otherHandlers.onChange?.(event);
            // this handles value change by Pointer or Touch events
            // @ts-ignore
            changeValue(event, event.target.valueAsNumber);
        };
    const previousIndex = $7fPBF.useRef(undefined);
    let axis = orientation;
    if (isRtl && orientation === 'horizontal') axis += '-reverse';
    const getFingerNewValue = ({ finger: finger, move: move = false })=>{
        const { current: slider } = sliderRef;
        const { width: width, height: height, bottom: bottom, left: left } = slider.getBoundingClientRect();
        let percent;
        if (axis.startsWith('vertical')) percent = (bottom - finger.y) / height;
        else percent = (finger.x - left) / width;
        if (axis.includes('-reverse')) percent = 1 - percent;
        let newValue;
        newValue = $8ba901b5e0df8f0f$var$percentToValue(percent, min, max);
        if (step) newValue = $8ba901b5e0df8f0f$var$roundValueToStep(newValue, step, min);
        else {
            const closestIndex = $8ba901b5e0df8f0f$var$findClosest(marksValues, newValue);
            newValue = marksValues[closestIndex];
        }
        newValue = (0, $3e74852d812b8b64$export$2e2bcd8739ae039)(newValue, min, max);
        let activeIndex = 0;
        if (range) {
            if (!move) activeIndex = $8ba901b5e0df8f0f$var$findClosest(values, newValue);
            else activeIndex = previousIndex.current;
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $3e74852d812b8b64$export$2e2bcd8739ae039)(newValue, values[activeIndex - 1] || -Infinity, values[activeIndex + 1] || Infinity);
            const previousValue = newValue;
            newValue = $8ba901b5e0df8f0f$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: activeIndex
            });
            // Potentially swap the index if needed.
            if (!(disableSwap && move)) {
                activeIndex = newValue.indexOf(previousValue);
                previousIndex.current = activeIndex;
            }
        }
        return {
            newValue: newValue,
            activeIndex: activeIndex
        };
    };
    const handleTouchMove = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $8ba901b5e0df8f0f$var$trackFinger(nativeEvent, touchId);
        if (!finger) return;
        moveCount.current += 1;
        // Cancel move in case some other element consumed a mouseup event and it was not fired.
        // @ts-ignore buttons doesn't not exists on touch event
        if (nativeEvent.type === 'mousemove' && nativeEvent.buttons === 0) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            handleTouchEnd(nativeEvent);
            return;
        }
        const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
            finger: finger,
            move: true
        });
        $8ba901b5e0df8f0f$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (!dragging && moveCount.current > $8ba901b5e0df8f0f$var$INTENTIONAL_DRAG_COUNT_THRESHOLD) setDragging(true);
        if (handleChange && !$8ba901b5e0df8f0f$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
    });
    const handleTouchEnd = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $8ba901b5e0df8f0f$var$trackFinger(nativeEvent, touchId);
        setDragging(false);
        if (!finger) return;
        const { newValue: newValue } = getFingerNewValue({
            finger: finger,
            move: true
        });
        setActive(-1);
        if (nativeEvent.type === 'touchend') setOpen(-1);
        if (onChangeCommitted) onChangeCommitted(nativeEvent, lastChangedValue.current ?? newValue);
        touchId.current = undefined;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
    });
    const handleTouchStart = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((nativeEvent)=>{
        if (disabled) return;
        // If touch-action: none; is not supported we need to prevent the scroll manually.
        if (!$8ba901b5e0df8f0f$var$doesSupportTouchActionNone()) nativeEvent.preventDefault();
        const touch = nativeEvent.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        const finger = $8ba901b5e0df8f0f$var$trackFinger(nativeEvent, touchId);
        if (finger !== false) {
            const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                finger: finger
            });
            $8ba901b5e0df8f0f$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex,
                setActive: setActive
            });
            setValueState(newValue);
            if (handleChange && !$8ba901b5e0df8f0f$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
        }
        moveCount.current = 0;
        const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(sliderRef.current);
        doc.addEventListener('touchmove', handleTouchMove, {
            passive: true
        });
        doc.addEventListener('touchend', handleTouchEnd, {
            passive: true
        });
    });
    const stopListening = $7fPBF.useCallback(()=>{
        const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(sliderRef.current);
        doc.removeEventListener('mousemove', handleTouchMove);
        doc.removeEventListener('mouseup', handleTouchEnd);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
    }, [
        handleTouchEnd,
        handleTouchMove
    ]);
    $7fPBF.useEffect(()=>{
        const { current: slider } = sliderRef;
        slider.addEventListener('touchstart', handleTouchStart, {
            passive: $8ba901b5e0df8f0f$var$doesSupportTouchActionNone()
        });
        return ()=>{
            slider.removeEventListener('touchstart', handleTouchStart);
            stopListening();
        };
    }, [
        stopListening,
        handleTouchStart
    ]);
    $7fPBF.useEffect(()=>{
        if (disabled) stopListening();
    }, [
        disabled,
        stopListening
    ]);
    const createHandleMouseDown = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseDown?.(event);
            if (disabled) return;
            if (event.defaultPrevented) return;
            // Only handle left clicks
            if (event.button !== 0) return;
            // Avoid text selection
            event.preventDefault();
            const finger = $8ba901b5e0df8f0f$var$trackFinger(event, touchId);
            if (finger !== false) {
                const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                    finger: finger
                });
                $8ba901b5e0df8f0f$var$focusThumb({
                    sliderRef: sliderRef,
                    activeIndex: activeIndex,
                    setActive: setActive
                });
                setValueState(newValue);
                if (handleChange && !$8ba901b5e0df8f0f$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, activeIndex);
            }
            moveCount.current = 0;
            const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(sliderRef.current);
            doc.addEventListener('mousemove', handleTouchMove, {
                passive: true
            });
            doc.addEventListener('mouseup', handleTouchEnd);
        };
    const trackOffset = $8ba901b5e0df8f0f$export$83ce4bc8280540e6(range ? values[0] : min, min, max);
    const trackLeap = $8ba901b5e0df8f0f$export$83ce4bc8280540e6(values[values.length - 1], min, max) - trackOffset;
    const getRootProps = (externalProps = {})=>{
        const externalHandlers = (0, $7a075a443b93da2d$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onMouseDown: createHandleMouseDown(externalHandlers || {})
        };
        const mergedEventHandlers = {
            ...externalHandlers,
            ...ownEventHandlers
        };
        return {
            ...externalProps,
            ref: handleRef,
            ...mergedEventHandlers
        };
    };
    const createHandleMouseOver = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseOver?.(event);
            const index = Number(event.currentTarget.getAttribute('data-index'));
            setOpen(index);
        };
    const createHandleMouseLeave = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseLeave?.(event);
            setOpen(-1);
        };
    const getThumbProps = (externalProps = {})=>{
        const externalHandlers = (0, $7a075a443b93da2d$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onMouseOver: createHandleMouseOver(externalHandlers || {}),
            onMouseLeave: createHandleMouseLeave(externalHandlers || {})
        };
        return {
            ...externalProps,
            ...externalHandlers,
            ...ownEventHandlers
        };
    };
    const getThumbStyle = (index)=>{
        return {
            // So the non active thumb doesn't show its label on hover.
            pointerEvents: active !== -1 && active !== index ? 'none' : undefined
        };
    };
    let cssWritingMode;
    if (orientation === 'vertical') cssWritingMode = isRtl ? 'vertical-rl' : 'vertical-lr';
    const getHiddenInputProps = (externalProps = {})=>{
        const externalHandlers = (0, $7a075a443b93da2d$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onChange: createHandleHiddenInputChange(externalHandlers || {}),
            onFocus: createHandleHiddenInputFocus(externalHandlers || {}),
            onBlur: createHandleHiddenInputBlur(externalHandlers || {}),
            onKeyDown: createHandleHiddenInputKeyDown(externalHandlers || {})
        };
        const mergedEventHandlers = {
            ...externalHandlers,
            ...ownEventHandlers
        };
        return {
            tabIndex: tabIndex,
            'aria-labelledby': ariaLabelledby,
            'aria-orientation': orientation,
            'aria-valuemax': scale(max),
            'aria-valuemin': scale(min),
            name: name,
            type: 'range',
            min: parameters.min,
            max: parameters.max,
            step: parameters.step === null && parameters.marks ? 'any' : parameters.step ?? undefined,
            disabled: disabled,
            ...externalProps,
            ...mergedEventHandlers,
            style: {
                ...(0, $3af1e05012cfa2ee$export$2e2bcd8739ae039),
                direction: isRtl ? 'rtl' : 'ltr',
                // So that VoiceOver's focus indicator matches the thumb's dimensions
                width: '100%',
                height: '100%',
                writingMode: cssWritingMode
            }
        };
    };
    return {
        active: active,
        axis: axis,
        axisProps: $8ba901b5e0df8f0f$var$axisProps,
        dragging: dragging,
        focusedThumbIndex: focusedThumbIndex,
        getHiddenInputProps: getHiddenInputProps,
        getRootProps: getRootProps,
        getThumbProps: getThumbProps,
        marks: marks,
        open: open,
        range: range,
        rootRef: handleRef,
        trackLeap: trackLeap,
        trackOffset: trackOffset,
        values: values,
        getThumbStyle: getThumbStyle
    };
}








const $2e9e574fd19888e1$var$shouldSpreadAdditionalProps = (Slot)=>{
    return !Slot || !(0, $1a5b8306608cd33a$export$2e2bcd8739ae039)(Slot);
};
var $2e9e574fd19888e1$export$2e2bcd8739ae039 = $2e9e574fd19888e1$var$shouldSpreadAdditionalProps;





var $7fPBF = parcelRequire("7fPBF");




function $1bfdb8c086e1325d$export$9f59f2622d5cbc2a(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiSlider', slot);
}
const $1bfdb8c086e1325d$var$sliderClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiSlider', [
    'root',
    'active',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'dragging',
    'focusVisible',
    'mark',
    'markActive',
    'marked',
    'markLabel',
    'markLabelActive',
    'rail',
    'sizeSmall',
    'thumb',
    'thumbColorPrimary',
    'thumbColorSecondary',
    'thumbColorError',
    'thumbColorSuccess',
    'thumbColorInfo',
    'thumbColorWarning',
    'track',
    'trackInverted',
    'trackFalse',
    'thumbSizeSmall',
    'valueLabel',
    'valueLabelOpen',
    'valueLabelCircle',
    'valueLabelLabel',
    'vertical'
]);
var $1bfdb8c086e1325d$export$2e2bcd8739ae039 = $1bfdb8c086e1325d$var$sliderClasses;



'use client';
const $cbbb03245ede8542$var$useValueLabelClasses = (props)=>{
    const { open: open } = props;
    const utilityClasses = {
        offset: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(open && (0, $1bfdb8c086e1325d$export$2e2bcd8739ae039).valueLabelOpen),
        circle: (0, $1bfdb8c086e1325d$export$2e2bcd8739ae039).valueLabelCircle,
        label: (0, $1bfdb8c086e1325d$export$2e2bcd8739ae039).valueLabelLabel
    };
    return utilityClasses;
};
function $cbbb03245ede8542$export$2e2bcd8739ae039(props) {
    const { children: children, className: className, value: value } = props;
    const classes = $cbbb03245ede8542$var$useValueLabelClasses(props);
    if (!children) return null;
    return /*#__PURE__*/ $7fPBF.cloneElement(children, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(children.props.className)
    }, /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
        children: [
            children.props.children,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.offset, className),
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    className: classes.circle,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: classes.label,
                        children: value
                    })
                })
            })
        ]
    }));
}




'use client';
function $3f15ab21d190f284$var$Identity(x) {
    return x;
}
const $3f15ab21d190f284$export$c1a21b3b4da66aa1 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiSlider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.marked && styles.marked,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.track === 'inverted' && styles.trackInverted,
            ownerState.track === false && styles.trackFalse
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        borderRadius: 12,
        boxSizing: 'content-box',
        display: 'inline-block',
        position: 'relative',
        cursor: 'pointer',
        touchAction: 'none',
        WebkitTapHighlightColor: 'transparent',
        '@media print': {
            colorAdjust: 'exact'
        },
        [`&.${(0, $1bfdb8c086e1325d$export$2e2bcd8739ae039).disabled}`]: {
            pointerEvents: 'none',
            cursor: 'default',
            color: (theme.vars || theme).palette.grey[400]
        },
        [`&.${(0, $1bfdb8c086e1325d$export$2e2bcd8739ae039).dragging}`]: {
            [`& .${(0, $1bfdb8c086e1325d$export$2e2bcd8739ae039).thumb}, & .${(0, $1bfdb8c086e1325d$export$2e2bcd8739ae039).track}`]: {
                transition: 'none'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $061b5988a3817e26$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 4,
                    width: '100%',
                    padding: '13px 0',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '20px 0'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    size: 'small'
                },
                style: {
                    height: 2
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    marked: true
                },
                style: {
                    marginBottom: 20
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    width: 4,
                    padding: '0 13px',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '0 20px'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    width: 2
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    marked: true
                },
                style: {
                    marginRight: 44
                }
            }
        ]
    })));
const $3f15ab21d190f284$export$b02fde61a3559c2 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiSlider',
    slot: 'Rail',
    overridesResolver: (props, styles)=>styles.rail
})({
    display: 'block',
    position: 'absolute',
    borderRadius: 'inherit',
    backgroundColor: 'currentColor',
    opacity: 0.38,
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: '100%',
                height: 'inherit',
                top: '50%',
                transform: 'translateY(-50%)'
            }
        },
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                height: '100%',
                width: 'inherit',
                left: '50%',
                transform: 'translateX(-50%)'
            }
        },
        {
            props: {
                track: 'inverted'
            },
            style: {
                opacity: 1
            }
        }
    ]
});
const $3f15ab21d190f284$export$105594979f116971 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiSlider',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>{
    return {
        display: 'block',
        position: 'absolute',
        borderRadius: 'inherit',
        border: '1px solid currentColor',
        backgroundColor: 'currentColor',
        transition: theme.transitions.create([
            'left',
            'width',
            'bottom',
            'height'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    border: 'none'
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'inherit',
                    top: '50%',
                    transform: 'translateY(-50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    width: 'inherit',
                    left: '50%',
                    transform: 'translateX(-50%)'
                }
            },
            {
                props: {
                    track: false
                },
                style: {
                    display: 'none'
                }
            },
            ...Object.entries(theme.palette).filter((0, $061b5988a3817e26$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        track: 'inverted'
                    },
                    style: {
                        ...theme.vars ? {
                            backgroundColor: theme.vars.palette.Slider[`${color}Track`],
                            borderColor: theme.vars.palette.Slider[`${color}Track`]
                        } : {
                            backgroundColor: (0, $4afad3ab73a4d920$export$c0816ed86df316af)(theme.palette[color].main, 0.62),
                            borderColor: (0, $4afad3ab73a4d920$export$c0816ed86df316af)(theme.palette[color].main, 0.62),
                            ...theme.applyStyles('dark', {
                                backgroundColor: (0, $4afad3ab73a4d920$export$4b073707ff63303)(theme.palette[color].main, 0.5)
                            }),
                            ...theme.applyStyles('dark', {
                                borderColor: (0, $4afad3ab73a4d920$export$4b073707ff63303)(theme.palette[color].main, 0.5)
                            })
                        }
                    }
                }))
        ]
    };
}));
const $3f15ab21d190f284$export$2c1b491743890dec = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiSlider',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.thumb,
            styles[`thumbColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`thumbSize${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'absolute',
        width: 20,
        height: 20,
        boxSizing: 'border-box',
        borderRadius: '50%',
        outline: 0,
        backgroundColor: 'currentColor',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: theme.transitions.create([
            'box-shadow',
            'left',
            'bottom'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        '&::before': {
            position: 'absolute',
            content: '""',
            borderRadius: 'inherit',
            width: '100%',
            height: '100%',
            boxShadow: (theme.vars || theme).shadows[2]
        },
        '&::after': {
            position: 'absolute',
            content: '""',
            borderRadius: '50%',
            // 42px is the hit target
            width: 42,
            height: 42,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        },
        [`&.${(0, $1bfdb8c086e1325d$export$2e2bcd8739ae039).disabled}`]: {
            '&:hover': {
                boxShadow: 'none'
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    width: 12,
                    height: 12,
                    '&::before': {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-50%, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 50%)'
                }
            },
            ...Object.entries(theme.palette).filter((0, $061b5988a3817e26$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&:hover, &.${(0, $1bfdb8c086e1325d$export$2e2bcd8739ae039).focusVisible}`]: {
                            ...theme.vars ? {
                                boxShadow: `0px 0px 0px 8px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
                            } : {
                                boxShadow: `0px 0px 0px 8px ${(0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette[color].main, 0.16)}`
                            },
                            '@media (hover: none)': {
                                boxShadow: 'none'
                            }
                        },
                        [`&.${(0, $1bfdb8c086e1325d$export$2e2bcd8739ae039).active}`]: {
                            ...theme.vars ? {
                                boxShadow: `0px 0px 0px 14px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
                            } : {
                                boxShadow: `0px 0px 0px 14px ${(0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette[color].main, 0.16)}`
                            }
                        }
                    }
                }))
        ]
    })));
const $3f15ab21d190f284$export$6453176f504d54f0 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $cbbb03245ede8542$export$2e2bcd8739ae039), {
    name: 'MuiSlider',
    slot: 'ValueLabel',
    overridesResolver: (props, styles)=>styles.valueLabel
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        zIndex: 1,
        whiteSpace: 'nowrap',
        ...theme.typography.body2,
        fontWeight: 500,
        transition: theme.transitions.create([
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        position: 'absolute',
        backgroundColor: (theme.vars || theme).palette.grey[600],
        borderRadius: 2,
        color: (theme.vars || theme).palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.25rem 0.75rem',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    transform: 'translateY(-100%) scale(0)',
                    top: '-10px',
                    transformOrigin: 'bottom center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, 50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        bottom: 0,
                        left: '50%'
                    },
                    [`&.${(0, $1bfdb8c086e1325d$export$2e2bcd8739ae039).valueLabelOpen}`]: {
                        transform: 'translateY(-100%) scale(1)'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    transform: 'translateY(-50%) scale(0)',
                    right: '30px',
                    top: '50%',
                    transformOrigin: 'right center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, -50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        right: -8,
                        top: '50%'
                    },
                    [`&.${(0, $1bfdb8c086e1325d$export$2e2bcd8739ae039).valueLabelOpen}`]: {
                        transform: 'translateY(-50%) scale(1)'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(12),
                    padding: '0.25rem 0.5rem'
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    right: '20px'
                }
            }
        ]
    })));
const $3f15ab21d190f284$export$6f85f6a3c5da6f62 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiSlider',
    slot: 'Mark',
    shouldForwardProp: (prop)=>(0, $066f83798075d563$export$2e2bcd8739ae039)(prop) && prop !== 'markActive',
    overridesResolver: (props, styles)=>{
        const { markActive: markActive } = props;
        return [
            styles.mark,
            markActive && styles.markActive
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'absolute',
        width: 2,
        height: 2,
        borderRadius: 1,
        backgroundColor: 'currentColor',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-1px, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 1px)'
                }
            },
            {
                props: {
                    markActive: true
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.background.paper,
                    opacity: 0.8
                }
            }
        ]
    })));
const $3f15ab21d190f284$export$e6cd369965e5aa95 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiSlider',
    slot: 'MarkLabel',
    shouldForwardProp: (prop)=>(0, $066f83798075d563$export$2e2bcd8739ae039)(prop) && prop !== 'markLabelActive',
    overridesResolver: (props, styles)=>styles.markLabel
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body2,
        color: (theme.vars || theme).palette.text.secondary,
        position: 'absolute',
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: 30,
                    transform: 'translateX(-50%)',
                    '@media (pointer: coarse)': {
                        top: 40
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: 36,
                    transform: 'translateY(50%)',
                    '@media (pointer: coarse)': {
                        left: 44
                    }
                }
            },
            {
                props: {
                    markLabelActive: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            }
        ]
    })));
const $3f15ab21d190f284$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dragging: dragging, marked: marked, orientation: orientation, track: track, classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            dragging && 'dragging',
            marked && 'marked',
            orientation === 'vertical' && 'vertical',
            track === 'inverted' && 'trackInverted',
            track === false && 'trackFalse',
            color && `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            size && `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`
        ],
        rail: [
            'rail'
        ],
        track: [
            'track'
        ],
        mark: [
            'mark'
        ],
        markActive: [
            'markActive'
        ],
        markLabel: [
            'markLabel'
        ],
        markLabelActive: [
            'markLabelActive'
        ],
        valueLabel: [
            'valueLabel'
        ],
        thumb: [
            'thumb',
            disabled && 'disabled',
            size && `thumbSize${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            color && `thumbColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`
        ],
        active: [
            'active'
        ],
        disabled: [
            'disabled'
        ],
        focusVisible: [
            'focusVisible'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $1bfdb8c086e1325d$export$9f59f2622d5cbc2a), classes);
};
const $3f15ab21d190f284$var$Forward = ({ children: children })=>children;
const $3f15ab21d190f284$var$Slider = /*#__PURE__*/ $7fPBF.forwardRef(function Slider(inputProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inputProps,
        name: 'MuiSlider'
    });
    const isRtl = (0, $0459201d2cf8a80b$export$b2dd014b6c321cb)();
    const { 'aria-label': ariaLabel, 'aria-valuetext': ariaValuetext, 'aria-labelledby': ariaLabelledby, component: // eslint-disable-next-line react/prop-types
    component = 'span', components: components = {}, componentsProps: componentsProps = {}, color: color = 'primary', classes: classesProp, className: className, disableSwap: disableSwap = false, disabled: disabled = false, getAriaLabel: getAriaLabel, getAriaValueText: getAriaValueText, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = 'horizontal', shiftStep: shiftStep = 10, size: size = 'medium', step: step = 1, scale: scale = $3f15ab21d190f284$var$Identity, slotProps: slotProps, slots: slots, tabIndex: tabIndex, track: track = 'normal', value: valueProp, valueLabelDisplay: valueLabelDisplay = 'off', valueLabelFormat: valueLabelFormat = $3f15ab21d190f284$var$Identity, ...other } = props;
    const ownerState = {
        ...props,
        isRtl: isRtl,
        max: max,
        min: min,
        classes: classesProp,
        disabled: disabled,
        disableSwap: disableSwap,
        orientation: orientation,
        marks: marksProp,
        color: color,
        size: size,
        step: step,
        shiftStep: shiftStep,
        scale: scale,
        track: track,
        valueLabelDisplay: valueLabelDisplay,
        valueLabelFormat: valueLabelFormat
    };
    const { axisProps: axisProps, getRootProps: getRootProps, getHiddenInputProps: getHiddenInputProps, getThumbProps: getThumbProps, open: open, active: active, axis: axis, focusedThumbIndex: focusedThumbIndex, range: range, dragging: dragging, marks: marks, values: values, trackOffset: trackOffset, trackLeap: trackLeap, getThumbStyle: getThumbStyle } = (0, $8ba901b5e0df8f0f$export$56b2c08e277f365)({
        ...ownerState,
        rootRef: ref
    });
    ownerState.marked = marks.length > 0 && marks.some((mark)=>mark.label);
    ownerState.dragging = dragging;
    ownerState.focusedThumbIndex = focusedThumbIndex;
    const classes = $3f15ab21d190f284$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = slots?.root ?? components.Root ?? $3f15ab21d190f284$export$c1a21b3b4da66aa1;
    const RailSlot = slots?.rail ?? components.Rail ?? $3f15ab21d190f284$export$b02fde61a3559c2;
    const TrackSlot = slots?.track ?? components.Track ?? $3f15ab21d190f284$export$105594979f116971;
    const ThumbSlot = slots?.thumb ?? components.Thumb ?? $3f15ab21d190f284$export$2c1b491743890dec;
    const ValueLabelSlot = slots?.valueLabel ?? components.ValueLabel ?? $3f15ab21d190f284$export$6453176f504d54f0;
    const MarkSlot = slots?.mark ?? components.Mark ?? $3f15ab21d190f284$export$6f85f6a3c5da6f62;
    const MarkLabelSlot = slots?.markLabel ?? components.MarkLabel ?? $3f15ab21d190f284$export$e6cd369965e5aa95;
    const InputSlot = slots?.input ?? components.Input ?? 'input';
    const rootSlotProps = slotProps?.root ?? componentsProps.root;
    const railSlotProps = slotProps?.rail ?? componentsProps.rail;
    const trackSlotProps = slotProps?.track ?? componentsProps.track;
    const thumbSlotProps = slotProps?.thumb ?? componentsProps.thumb;
    const valueLabelSlotProps = slotProps?.valueLabel ?? componentsProps.valueLabel;
    const markSlotProps = slotProps?.mark ?? componentsProps.mark;
    const markLabelSlotProps = slotProps?.markLabel ?? componentsProps.markLabel;
    const inputSlotProps = slotProps?.input ?? componentsProps.input;
    const rootProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        getSlotProps: getRootProps,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: {
            ...(0, $2e9e574fd19888e1$export$2e2bcd8739ae039)(RootSlot) && {
                as: component
            }
        },
        ownerState: {
            ...ownerState,
            ...rootSlotProps?.ownerState
        },
        className: [
            classes.root,
            className
        ]
    });
    const railProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: RailSlot,
        externalSlotProps: railSlotProps,
        ownerState: ownerState,
        className: classes.rail
    });
    const trackProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: TrackSlot,
        externalSlotProps: trackSlotProps,
        additionalProps: {
            style: {
                ...axisProps[axis].offset(trackOffset),
                ...axisProps[axis].leap(trackLeap)
            }
        },
        ownerState: {
            ...ownerState,
            ...trackSlotProps?.ownerState
        },
        className: classes.track
    });
    const thumbProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: ThumbSlot,
        getSlotProps: getThumbProps,
        externalSlotProps: thumbSlotProps,
        ownerState: {
            ...ownerState,
            ...thumbSlotProps?.ownerState
        },
        className: classes.thumb
    });
    const valueLabelProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: ValueLabelSlot,
        externalSlotProps: valueLabelSlotProps,
        ownerState: {
            ...ownerState,
            ...valueLabelSlotProps?.ownerState
        },
        className: classes.valueLabel
    });
    const markProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: MarkSlot,
        externalSlotProps: markSlotProps,
        ownerState: ownerState,
        className: classes.mark
    });
    const markLabelProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: MarkLabelSlot,
        externalSlotProps: markLabelSlotProps,
        ownerState: ownerState,
        className: classes.markLabel
    });
    const inputSliderProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: InputSlot,
        getSlotProps: getHiddenInputProps,
        externalSlotProps: inputSlotProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(RailSlot, {
                ...railProps
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TrackSlot, {
                ...trackProps
            }),
            marks.filter((mark)=>mark.value >= min && mark.value <= max).map((mark, index)=>{
                const percent = (0, $8ba901b5e0df8f0f$export$83ce4bc8280540e6)(mark.value, min, max);
                const style = axisProps[axis].offset(percent);
                let markActive;
                if (track === false) markActive = values.includes(mark.value);
                else markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(MarkSlot, {
                            "data-index": index,
                            ...markProps,
                            ...!(0, $1a5b8306608cd33a$export$2e2bcd8739ae039)(MarkSlot) && {
                                markActive: markActive
                            },
                            style: {
                                ...style,
                                ...markProps.style
                            },
                            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(markProps.className, markActive && classes.markActive)
                        }),
                        mark.label != null ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(MarkLabelSlot, {
                            "aria-hidden": true,
                            "data-index": index,
                            ...markLabelProps,
                            ...!(0, $1a5b8306608cd33a$export$2e2bcd8739ae039)(MarkLabelSlot) && {
                                markLabelActive: markActive
                            },
                            style: {
                                ...style,
                                ...markLabelProps.style
                            },
                            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.markLabel, markLabelProps.className, markActive && classes.markLabelActive),
                            children: mark.label
                        }) : null
                    ]
                }, index);
            }),
            values.map((value, index)=>{
                const percent = (0, $8ba901b5e0df8f0f$export$83ce4bc8280540e6)(value, min, max);
                const style = axisProps[axis].offset(percent);
                const ValueLabelComponent = valueLabelDisplay === 'off' ? $3f15ab21d190f284$var$Forward : ValueLabelSlot;
                return /*#__PURE__*/ /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */ (0, $824c049f32d4395d$exports.jsx)(ValueLabelComponent, {
                    ...!(0, $1a5b8306608cd33a$export$2e2bcd8739ae039)(ValueLabelComponent) && {
                        valueLabelFormat: valueLabelFormat,
                        valueLabelDisplay: valueLabelDisplay,
                        value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
                        index: index,
                        open: open === index || active === index || valueLabelDisplay === 'on',
                        disabled: disabled
                    },
                    ...valueLabelProps,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ThumbSlot, {
                        "data-index": index,
                        ...thumbProps,
                        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.thumb, thumbProps.className, active === index && classes.active, focusedThumbIndex === index && classes.focusVisible),
                        style: {
                            ...style,
                            ...getThumbStyle(index),
                            ...thumbProps.style
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(InputSlot, {
                            "data-index": index,
                            "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
                            "aria-valuenow": scale(value),
                            "aria-labelledby": ariaLabelledby,
                            "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
                            value: values[index],
                            ...inputSliderProps
                        })
                    })
                }, index);
            })
        ]
    });
});
var $3f15ab21d190f284$export$2e2bcd8739ae039 = $3f15ab21d190f284$var$Slider;


var $7fPBF = parcelRequire("7fPBF");



















var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

function $5a7577945ba4d648$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $f3e95cf60f991b3e$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $f3e95cf60f991b3e$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $f3e95cf60f991b3e$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $cb70389d1b75072d$export$8960430cfd85939f = Math.max;
var $cb70389d1b75072d$export$96ec731ed4dcb222 = Math.min;
var $cb70389d1b75072d$export$2077e0241d6afd3c = Math.round;



function $c76403bd29ed319a$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $b48f13af3862f004$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $c76403bd29ed319a$export$2e2bcd8739ae039)());
}


function $e7afd89efa353b85$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(element) ? (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $b48f13af3862f004$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $e95acb4acf5ee909$export$2e2bcd8739ae039(node) {
    var win = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $6923eaccf7a43aef$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $fa62512f527d34a4$export$2e2bcd8739ae039(node) {
    if (node === (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node) || !(0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(node)) return (0, $e95acb4acf5ee909$export$2e2bcd8739ae039)(node);
    else return (0, $6923eaccf7a43aef$export$2e2bcd8739ae039)(node);
}


function $b8ce8e5214ef2302$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $7d9656f011992b2b$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $e0a76d77d33c9d6e$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $e7afd89efa353b85$export$2e2bcd8739ae039)((0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element)).left + (0, $e95acb4acf5ee909$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $3e40145ffd569d9c$export$2e2bcd8739ae039(element) {
    return (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $998896b7349c78b7$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $585037a155f95873$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $585037a155f95873$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(offsetParent) && $585037a155f95873$var$isElementScaled(offsetParent);
    var documentElement = (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $998896b7349c78b7$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $fa62512f527d34a4$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $e0a76d77d33c9d6e$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $790f3bf845b39e8e$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $9906540837c752ea$export$2e2bcd8739ae039(element) {
    if ((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $f3e95cf60f991b3e$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $1d462f2c86b4c65a$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(node) && (0, $998896b7349c78b7$export$2e2bcd8739ae039)(node)) return node;
    return $1d462f2c86b4c65a$export$2e2bcd8739ae039((0, $9906540837c752ea$export$2e2bcd8739ae039)(node));
}





function $3d1bbe7c8c599173$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $1d462f2c86b4c65a$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $998896b7349c78b7$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($3d1bbe7c8c599173$export$2e2bcd8739ae039((0, $9906540837c752ea$export$2e2bcd8739ae039)(target)));
}







function $08ccc1de57d53c59$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(element)) >= 0;
}




function $6ebea87f6f98e49c$var$getTrueOffsetParent(element) {
    if (!(0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $6ebea87f6f98e49c$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $c76403bd29ed319a$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $c76403bd29ed319a$export$2e2bcd8739ae039)());
    if (isIE && (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $9906540837c752ea$export$2e2bcd8739ae039)(element);
    if ((0, $f3e95cf60f991b3e$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $6ebea87f6f98e49c$export$2e2bcd8739ae039(element) {
    var window = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(element);
    var offsetParent = $6ebea87f6f98e49c$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $08ccc1de57d53c59$export$2e2bcd8739ae039)(offsetParent) && (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $6ebea87f6f98e49c$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $6ebea87f6f98e49c$var$getContainingBlock(element) || window;
}


var $7c96f63dd602b579$export$1e95b668f3b82d = 'top';
var $7c96f63dd602b579$export$40e543e69a8b3fbb = 'bottom';
var $7c96f63dd602b579$export$79ffe56a765070d2 = 'right';
var $7c96f63dd602b579$export$eabcd2c8791e7bf4 = 'left';
var $7c96f63dd602b579$export$dfb5619354ba860 = 'auto';
var $7c96f63dd602b579$export$aec2ce47c367b8c3 = [
    $7c96f63dd602b579$export$1e95b668f3b82d,
    $7c96f63dd602b579$export$40e543e69a8b3fbb,
    $7c96f63dd602b579$export$79ffe56a765070d2,
    $7c96f63dd602b579$export$eabcd2c8791e7bf4
];
var $7c96f63dd602b579$export$b3571188c770cc5a = 'start';
var $7c96f63dd602b579$export$bd5df0f255a350f8 = 'end';
var $7c96f63dd602b579$export$390fd549c5303b4d = 'clippingParents';
var $7c96f63dd602b579$export$d7b7311ec04a3e8f = 'viewport';
var $7c96f63dd602b579$export$ae5ab1c730825774 = 'popper';
var $7c96f63dd602b579$export$ca50aac9f3ba507f = 'reference';
var $7c96f63dd602b579$export$368f9a87e87fa4e1 = /*#__PURE__*/ $7c96f63dd602b579$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $7c96f63dd602b579$export$b3571188c770cc5a,
        placement + "-" + $7c96f63dd602b579$export$bd5df0f255a350f8
    ]);
}, []);
var $7c96f63dd602b579$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($7c96f63dd602b579$export$aec2ce47c367b8c3, [
    $7c96f63dd602b579$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $7c96f63dd602b579$export$b3571188c770cc5a,
        placement + "-" + $7c96f63dd602b579$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $7c96f63dd602b579$export$421679a7c3d56e = 'beforeRead';
var $7c96f63dd602b579$export$aafa59e2e03f2942 = 'read';
var $7c96f63dd602b579$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $7c96f63dd602b579$export$c65e99957a05207c = 'beforeMain';
var $7c96f63dd602b579$export$f22da7240b7add18 = 'main';
var $7c96f63dd602b579$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $7c96f63dd602b579$export$8d4d2d70e7d46032 = 'beforeWrite';
var $7c96f63dd602b579$export$68d8715fc104d294 = 'write';
var $7c96f63dd602b579$export$70a6e5159acce2e6 = 'afterWrite';
var $7c96f63dd602b579$export$d087d3878fdf71d5 = [
    $7c96f63dd602b579$export$421679a7c3d56e,
    $7c96f63dd602b579$export$aafa59e2e03f2942,
    $7c96f63dd602b579$export$6964f6c886723980,
    $7c96f63dd602b579$export$c65e99957a05207c,
    $7c96f63dd602b579$export$f22da7240b7add18,
    $7c96f63dd602b579$export$bab79516f2d662fe,
    $7c96f63dd602b579$export$8d4d2d70e7d46032,
    $7c96f63dd602b579$export$68d8715fc104d294,
    $7c96f63dd602b579$export$70a6e5159acce2e6
];


function $13c27cceb4b24b2f$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $13c27cceb4b24b2f$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $13c27cceb4b24b2f$var$order(modifiers); // order based on phase
    return (0, $7c96f63dd602b579$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $4c8edc0cb4d5666b$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $320e6f4d2835a922$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $879850b738b0fd85$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $879850b738b0fd85$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $879850b738b0fd85$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $879850b738b0fd85$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $879850b738b0fd85$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(reference) ? (0, $3d1bbe7c8c599173$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $3d1bbe7c8c599173$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $3d1bbe7c8c599173$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $13c27cceb4b24b2f$export$2e2bcd8739ae039)((0, $320e6f4d2835a922$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$879850b738b0fd85$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $585037a155f95873$export$2e2bcd8739ae039)(reference, (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $790f3bf845b39e8e$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $4c8edc0cb4d5666b$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$879850b738b0fd85$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $879850b738b0fd85$export$8f7491d57c8f97a9 = /*#__PURE__*/ $879850b738b0fd85$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $1564186ea0096528$var$passive = {
    passive: true
};
function $1564186ea0096528$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $1564186ea0096528$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $1564186ea0096528$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $1564186ea0096528$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $1564186ea0096528$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $1564186ea0096528$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $1564186ea0096528$var$effect,
    data: {}
};



function $2e8856bdb677ff8e$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $cd593f453867f36a$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $334987ecb6fc56c7$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $c2c9d9550c09d816$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $cd593f453867f36a$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $7c96f63dd602b579$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $7c96f63dd602b579$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $7c96f63dd602b579$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $7c96f63dd602b579$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $334987ecb6fc56c7$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $7c96f63dd602b579$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $7c96f63dd602b579$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $e0848fa64ca744df$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $c2c9d9550c09d816$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e0848fa64ca744df$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $e0848fa64ca744df$var$popperOffsets,
    data: {}
};










var $adff49e8d09ee1e5$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $adff49e8d09ee1e5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $adff49e8d09ee1e5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4);
    var sideY = (0, $7c96f63dd602b579$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(popper);
            if ((0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $7c96f63dd602b579$export$1e95b668f3b82d) || (placement === (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4) || placement === (0, $7c96f63dd602b579$export$79ffe56a765070d2)) && variation === (0, $7c96f63dd602b579$export$bd5df0f255a350f8)) {
            sideY = (0, $7c96f63dd602b579$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4) || (placement === (0, $7c96f63dd602b579$export$1e95b668f3b82d) || placement === (0, $7c96f63dd602b579$export$40e543e69a8b3fbb)) && variation === (0, $7c96f63dd602b579$export$bd5df0f255a350f8)) {
            sideX = (0, $7c96f63dd602b579$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $adff49e8d09ee1e5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $adff49e8d09ee1e5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $adff49e8d09ee1e5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $cd593f453867f36a$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $adff49e8d09ee1e5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $adff49e8d09ee1e5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $adff49e8d09ee1e5$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $adff49e8d09ee1e5$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $5bfb95a331f35baa$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element) || !(0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $5bfb95a331f35baa$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element) || !(0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $5bfb95a331f35baa$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $5bfb95a331f35baa$var$applyStyles,
    effect: $5bfb95a331f35baa$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $a984b8b647b41eeb$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4),
        (0, $7c96f63dd602b579$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4),
        (0, $7c96f63dd602b579$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $a984b8b647b41eeb$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $7c96f63dd602b579$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $a984b8b647b41eeb$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a984b8b647b41eeb$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $a984b8b647b41eeb$var$offset
};


var $690483208b9a3207$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $690483208b9a3207$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $690483208b9a3207$var$hash[matched];
    });
}



var $13515282412eb271$var$hash = {
    start: 'end',
    end: 'start'
};
function $13515282412eb271$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $13515282412eb271$var$hash[matched];
    });
}







function $05957f974ad3b041$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(element);
    var html = (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $b48f13af3862f004$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $e0a76d77d33c9d6e$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $f2541b971d258cf0$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $e95acb4acf5ee909$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $cb70389d1b75072d$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $cb70389d1b75072d$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $e0a76d77d33c9d6e$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $cb70389d1b75072d$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $fa38ef77d76834a0$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $f3e95cf60f991b3e$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $18107b7e48021ffa$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $86796f3d3717fc99$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $86796f3d3717fc99$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $7c96f63dd602b579$export$d7b7311ec04a3e8f) ? (0, $18107b7e48021ffa$export$2e2bcd8739ae039)((0, $05957f974ad3b041$export$2e2bcd8739ae039)(element, strategy)) : (0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(clippingParent) ? $86796f3d3717fc99$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $18107b7e48021ffa$export$2e2bcd8739ae039)((0, $f2541b971d258cf0$export$2e2bcd8739ae039)((0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $86796f3d3717fc99$var$getClippingParents(element) {
    var clippingParents = (0, $3d1bbe7c8c599173$export$2e2bcd8739ae039)((0, $9906540837c752ea$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element) ? (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(clippingParent) && (0, $fa38ef77d76834a0$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $86796f3d3717fc99$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $86796f3d3717fc99$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $86796f3d3717fc99$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $cb70389d1b75072d$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $cb70389d1b75072d$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $cb70389d1b75072d$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cb70389d1b75072d$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $86796f3d3717fc99$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $1e806166c2cdf48d$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $ff6dcd1b0906e9b8$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $1e806166c2cdf48d$export$2e2bcd8739ae039)(), paddingObject);
}


function $c8d699eb93b3090c$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $52693e6050d55014$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $7c96f63dd602b579$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $7c96f63dd602b579$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $7c96f63dd602b579$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $ff6dcd1b0906e9b8$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c8d699eb93b3090c$export$2e2bcd8739ae039)(padding, (0, $7c96f63dd602b579$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $7c96f63dd602b579$export$ae5ab1c730825774) ? (0, $7c96f63dd602b579$export$ca50aac9f3ba507f) : (0, $7c96f63dd602b579$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $86796f3d3717fc99$export$2e2bcd8739ae039)((0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $c2c9d9550c09d816$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $18107b7e48021ffa$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $7c96f63dd602b579$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $7c96f63dd602b579$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $7c96f63dd602b579$export$79ffe56a765070d2),
                (0, $7c96f63dd602b579$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $7c96f63dd602b579$export$1e95b668f3b82d),
                (0, $7c96f63dd602b579$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $a935996b3496591b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $7c96f63dd602b579$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $cd593f453867f36a$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $7c96f63dd602b579$export$368f9a87e87fa4e1) : (0, $7c96f63dd602b579$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $cd593f453867f36a$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $7c96f63dd602b579$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $a97241372b70cd07$var$getExpandedFallbackPlacements(placement) {
    if ((0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement) === (0, $7c96f63dd602b579$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $690483208b9a3207$export$2e2bcd8739ae039)(placement);
    return [
        (0, $13515282412eb271$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $13515282412eb271$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $a97241372b70cd07$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $690483208b9a3207$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $a97241372b70cd07$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement) === (0, $7c96f63dd602b579$export$dfb5619354ba860) ? (0, $a935996b3496591b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $cd593f453867f36a$export$2e2bcd8739ae039)(placement) === (0, $7c96f63dd602b579$export$b3571188c770cc5a);
        var isVertical = [
            (0, $7c96f63dd602b579$export$1e95b668f3b82d),
            (0, $7c96f63dd602b579$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $7c96f63dd602b579$export$79ffe56a765070d2) : (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $7c96f63dd602b579$export$40e543e69a8b3fbb) : (0, $7c96f63dd602b579$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $690483208b9a3207$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $690483208b9a3207$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $a97241372b70cd07$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $a97241372b70cd07$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $8d60439f259d6a8c$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $14b5cb667dce379f$export$f28d906d67a997f3(min, value, max) {
    return (0, $cb70389d1b75072d$export$8960430cfd85939f)(min, (0, $cb70389d1b75072d$export$96ec731ed4dcb222)(value, max));
}
function $14b5cb667dce379f$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $14b5cb667dce379f$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $cf968237b9d7dd4a$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $cd593f453867f36a$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $334987ecb6fc56c7$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $8d60439f259d6a8c$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $7c96f63dd602b579$export$1e95b668f3b82d) : (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $7c96f63dd602b579$export$40e543e69a8b3fbb) : (0, $7c96f63dd602b579$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $7c96f63dd602b579$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $7c96f63dd602b579$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $790f3bf845b39e8e$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $1e806166c2cdf48d$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $14b5cb667dce379f$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $14b5cb667dce379f$export$f28d906d67a997f3)(tether ? (0, $cb70389d1b75072d$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $cb70389d1b75072d$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $7c96f63dd602b579$export$1e95b668f3b82d) : (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $7c96f63dd602b579$export$40e543e69a8b3fbb) : (0, $7c96f63dd602b579$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $7c96f63dd602b579$export$1e95b668f3b82d),
            (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $14b5cb667dce379f$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $14b5cb667dce379f$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $cf968237b9d7dd4a$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $cf968237b9d7dd4a$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $e7f3cf13e0769248$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $ff6dcd1b0906e9b8$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c8d699eb93b3090c$export$2e2bcd8739ae039)(padding, (0, $7c96f63dd602b579$export$aec2ce47c367b8c3)));
};
function $e7f3cf13e0769248$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $334987ecb6fc56c7$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4),
        (0, $7c96f63dd602b579$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $e7f3cf13e0769248$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $790f3bf845b39e8e$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $7c96f63dd602b579$export$1e95b668f3b82d) : (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $7c96f63dd602b579$export$40e543e69a8b3fbb) : (0, $7c96f63dd602b579$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $14b5cb667dce379f$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $e7f3cf13e0769248$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $fa38ef77d76834a0$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $e7f3cf13e0769248$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $e7f3cf13e0769248$var$arrow,
    effect: $e7f3cf13e0769248$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $74f12d998f890694$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $74f12d998f890694$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $7c96f63dd602b579$export$1e95b668f3b82d),
        (0, $7c96f63dd602b579$export$79ffe56a765070d2),
        (0, $7c96f63dd602b579$export$40e543e69a8b3fbb),
        (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $74f12d998f890694$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $74f12d998f890694$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $74f12d998f890694$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $74f12d998f890694$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $74f12d998f890694$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $74f12d998f890694$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $74f12d998f890694$var$hide
};




var $a5ed26444bdb4d3e$export$d34966752335dd47 = [
    (0, $1564186ea0096528$export$2e2bcd8739ae039),
    (0, $e0848fa64ca744df$export$2e2bcd8739ae039),
    (0, $adff49e8d09ee1e5$export$2e2bcd8739ae039),
    (0, $5bfb95a331f35baa$export$2e2bcd8739ae039),
    (0, $a984b8b647b41eeb$export$2e2bcd8739ae039),
    (0, $a97241372b70cd07$export$2e2bcd8739ae039),
    (0, $cf968237b9d7dd4a$export$2e2bcd8739ae039),
    (0, $e7f3cf13e0769248$export$2e2bcd8739ae039),
    (0, $74f12d998f890694$export$2e2bcd8739ae039)
];
var $a5ed26444bdb4d3e$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $879850b738b0fd85$export$ed5e13716264f202)({
    defaultModifiers: $a5ed26444bdb4d3e$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules








function $55931a0909067857$export$1b69b6cd0fa638a1(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPopper', slot);
}
const $55931a0909067857$var$popperClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPopper', [
    'root'
]);
var $55931a0909067857$export$2e2bcd8739ae039 = $55931a0909067857$var$popperClasses;



'use client';
function $c9d5b2e364679937$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $c9d5b2e364679937$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $c9d5b2e364679937$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $c9d5b2e364679937$var$isVirtualElement(element) {
    return !$c9d5b2e364679937$var$isHTMLElement(element);
}
const $c9d5b2e364679937$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $55931a0909067857$export$1b69b6cd0fa638a1), classes);
};
const $c9d5b2e364679937$var$defaultPopperOptions = {};
const $c9d5b2e364679937$var$PopperTooltip = /*#__PURE__*/ $7fPBF.forwardRef(function PopperTooltip(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps, // @ts-ignore internal logic
    ownerState: ownerStateProp, // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...other } = props;
    const tooltipRef = $7fPBF.useRef(null);
    const ownRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $7fPBF.useRef(null);
    const handlePopperRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $7fPBF.useRef(handlePopperRef);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $7fPBF.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $c9d5b2e364679937$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $7fPBF.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $7fPBF.useState($c9d5b2e364679937$var$resolveAnchorEl(anchorEl));
    $7fPBF.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $7fPBF.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($c9d5b2e364679937$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $a5ed26444bdb4d3e$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, {
            placement: rtlPlacement,
            ...popperOptions,
            modifiers: popperModifiers
        });
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $c9d5b2e364679937$var$useUtilityClasses(props);
    const Root = slots.root ?? 'div';
    const rootProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Root, {
        ...rootProps,
        children: typeof children === 'function' ? children(childProps) : children
    });
});
/**
 * @ignore - internal component.
 */ const $c9d5b2e364679937$var$Popper = /*#__PURE__*/ $7fPBF.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $c9d5b2e364679937$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const [exited, setExited] = $7fPBF.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $c9d5b2e364679937$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $c9d5b2e364679937$var$isHTMLElement(resolvedAnchorEl) ? (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7aea8adc1cf7298d$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9d5b2e364679937$var$PopperTooltip, {
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots,
            ...other,
            style: {
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display,
                ...style
            },
            TransitionProps: transitionProps,
            children: children
        })
    });
});
var $c9d5b2e364679937$export$2e2bcd8739ae039 = $c9d5b2e364679937$var$Popper;





'use client';
const $2ecffc9bd505b8cc$var$PopperRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $c9d5b2e364679937$export$2e2bcd8739ae039), {
    name: 'MuiPopper',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://v6.mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://v6.mui.com/material-ui/react-menu/)
 * - [Popper](https://v6.mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://v6.mui.com/material-ui/api/popper/)
 */ const $2ecffc9bd505b8cc$var$Popper = /*#__PURE__*/ $7fPBF.forwardRef(function Popper(inProps, ref) {
    const isRtl = (0, $0459201d2cf8a80b$export$b2dd014b6c321cb)();
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps, ...other } = props;
    const RootComponent = slots?.root ?? components?.Root;
    const otherProps = {
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition,
        ...other
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2ecffc9bd505b8cc$var$PopperRoot, {
        as: component,
        direction: isRtl ? 'rtl' : 'ltr',
        slots: {
            root: RootComponent
        },
        slotProps: slotProps ?? componentsProps,
        ...otherProps,
        ref: ref
    });
});
var $2ecffc9bd505b8cc$export$2e2bcd8739ae039 = $2ecffc9bd505b8cc$var$Popper;









function $684603ff395d34b1$export$837848f5f6cee923(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiTooltip', slot);
}
const $684603ff395d34b1$var$tooltipClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $684603ff395d34b1$export$2e2bcd8739ae039 = $684603ff395d34b1$var$tooltipClasses;



'use client';
function $ea99f2520fe8509d$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $ea99f2520fe8509d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $684603ff395d34b1$export$837848f5f6cee923), classes);
};
const $ea99f2520fe8509d$var$TooltipPopper = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $2ecffc9bd505b8cc$export$2e2bcd8739ae039), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInteractive,
                style: {
                    pointerEvents: 'auto'
                }
            },
            {
                props: ({ open: open })=>!open,
                style: {
                    pointerEvents: 'none'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    [`&[data-popper-placement*="bottom"] .${(0, $684603ff395d34b1$export$2e2bcd8739ae039).arrow}`]: {
                        top: 0,
                        marginTop: '-0.71em',
                        '&::before': {
                            transformOrigin: '0 100%'
                        }
                    },
                    [`&[data-popper-placement*="top"] .${(0, $684603ff395d34b1$export$2e2bcd8739ae039).arrow}`]: {
                        bottom: 0,
                        marginBottom: '-0.71em',
                        '&::before': {
                            transformOrigin: '100% 0'
                        }
                    },
                    [`&[data-popper-placement*="right"] .${(0, $684603ff395d34b1$export$2e2bcd8739ae039).arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '100% 100%'
                        }
                    },
                    [`&[data-popper-placement*="left"] .${(0, $684603ff395d34b1$export$2e2bcd8739ae039).arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '0 0'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${(0, $684603ff395d34b1$export$2e2bcd8739ae039).arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${(0, $684603ff395d34b1$export$2e2bcd8739ae039).arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${(0, $684603ff395d34b1$export$2e2bcd8739ae039).arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${(0, $684603ff395d34b1$export$2e2bcd8739ae039).arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            }
        ]
    })));
const $ea99f2520fe8509d$var$TooltipTooltip = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.placement.split('-')[0])}`]
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium,
        [`.${(0, $684603ff395d34b1$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
            transformOrigin: 'right center'
        },
        [`.${(0, $684603ff395d34b1$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
            transformOrigin: 'left center'
        },
        [`.${(0, $684603ff395d34b1$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: {
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        },
        [`.${(0, $684603ff395d34b1$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: {
            transformOrigin: 'center top',
            marginTop: '14px'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    position: 'relative',
                    margin: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    padding: '8px 16px',
                    fontSize: theme.typography.pxToRem(14),
                    lineHeight: `${$ea99f2520fe8509d$var$round(16 / 14)}em`,
                    fontWeight: theme.typography.fontWeightRegular
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl,
                style: {
                    [`.${(0, $684603ff395d34b1$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '14px'
                    },
                    [`.${(0, $684603ff395d34b1$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${(0, $684603ff395d34b1$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '24px'
                    },
                    [`.${(0, $684603ff395d34b1$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl,
                style: {
                    [`.${(0, $684603ff395d34b1$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '14px'
                    },
                    [`.${(0, $684603ff395d34b1$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${(0, $684603ff395d34b1$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '24px'
                    },
                    [`.${(0, $684603ff395d34b1$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $684603ff395d34b1$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: {
                        marginBottom: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $684603ff395d34b1$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: {
                        marginTop: '24px'
                    }
                }
            }
        ]
    })));
const $ea99f2520fe8509d$var$TooltipArrow = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow',
    overridesResolver: (props, styles)=>styles.arrow
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    })));
let $ea99f2520fe8509d$var$hystersisOpen = false;
const $ea99f2520fe8509d$var$hystersisTimer = new (0, $9a1088a9a7141b09$export$786b4da70f00938b)();
let $ea99f2520fe8509d$var$cursorPosition = {
    x: 0,
    y: 0
};
function $ea99f2520fe8509d$export$b9ee5a7ace0541f8() {
    $ea99f2520fe8509d$var$hystersisOpen = false;
    $ea99f2520fe8509d$var$hystersisTimer.clear();
}
function $ea99f2520fe8509d$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $ea99f2520fe8509d$var$Tooltip = /*#__PURE__*/ $7fPBF.forwardRef(function Tooltip(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, classes: classesProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionProps, ...other } = props;
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $7fPBF.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isRtl = (0, $0459201d2cf8a80b$export$b2dd014b6c321cb)();
    const [childNode, setChildNode] = $7fPBF.useState();
    const [arrowRef, setArrowRef] = $7fPBF.useState(null);
    const ignoreNonTouchEvents = $7fPBF.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $9a1088a9a7141b09$export$2e2bcd8739ae039)();
    const enterTimer = (0, $9a1088a9a7141b09$export$2e2bcd8739ae039)();
    const leaveTimer = (0, $9a1088a9a7141b09$export$2e2bcd8739ae039)();
    const touchTimer = (0, $9a1088a9a7141b09$export$2e2bcd8739ae039)();
    const [openState, setOpenState] = (0, $3b64539a8a5729fa$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $8631184a92cee7e5$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $7fPBF.useRef();
    const stopTouchInteraction = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $7fPBF.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $ea99f2520fe8509d$var$hystersisTimer.clear();
        $ea99f2520fe8509d$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $ea99f2520fe8509d$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $ea99f2520fe8509d$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $ea99f2520fe8509d$var$hystersisOpen && enterNextDelay) enterTimer.start($ea99f2520fe8509d$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const [, setChildIsFocusVisible] = $7fPBF.useState(false);
    const handleBlur = (event)=>{
        if (!(0, $0d3c83b1c3920329$export$2e2bcd8739ae039)(event.target)) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        if ((0, $0d3c83b1c3920329$export$2e2bcd8739ae039)(event.target)) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $7fPBF.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (nativeEvent.key === 'Escape') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)((0, $8971fd60a8b100cf$export$2e2bcd8739ae039)(children), setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $7fPBF.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $ea99f2520fe8509d$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = {
        ...nameOrDescProps,
        ...other,
        ...children.props,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef,
        ...followCursor ? {
            onMouseMove: handleMouseMove
        } : {}
    };
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $ea99f2520fe8509d$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $ea99f2520fe8509d$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $ea99f2520fe8509d$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $ea99f2520fe8509d$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const ownerState = {
        ...props,
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    };
    const resolvedPopperProps = typeof slotProps.popper === 'function' ? slotProps.popper(ownerState) : slotProps.popper;
    const popperOptions = $7fPBF.useMemo(()=>{
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if (PopperProps.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        if (resolvedPopperProps?.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(resolvedPopperProps.popperOptions.modifiers);
        return {
            ...PopperProps.popperOptions,
            ...resolvedPopperProps?.popperOptions,
            modifiers: tooltipModifiers
        };
    }, [
        arrowRef,
        PopperProps.popperOptions,
        resolvedPopperProps?.popperOptions
    ]);
    const classes = $ea99f2520fe8509d$var$useUtilityClasses(ownerState);
    const resolvedTransitionProps = typeof slotProps.transition === 'function' ? slotProps.transition(ownerState) : slotProps.transition;
    const externalForwardedProps = {
        slots: {
            popper: components.Popper,
            transition: components.Transition ?? TransitionComponentProp,
            tooltip: components.Tooltip,
            arrow: components.Arrow,
            ...slots
        },
        slotProps: {
            arrow: slotProps.arrow ?? componentsProps.arrow,
            popper: {
                ...PopperProps,
                ...resolvedPopperProps ?? componentsProps.popper
            },
            // resolvedPopperProps can be spread because it's already an object
            tooltip: slotProps.tooltip ?? componentsProps.tooltip,
            transition: {
                ...TransitionProps,
                ...resolvedTransitionProps ?? componentsProps.transition
            }
        }
    };
    const [PopperSlot, popperSlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('popper', {
        elementType: $ea99f2520fe8509d$var$TooltipPopper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.popper, PopperProps?.className)
    });
    const [TransitionSlot, transitionSlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $7ec2c0aa92d4d29c$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [TooltipSlot, tooltipSlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('tooltip', {
        elementType: $ea99f2520fe8509d$var$TooltipTooltip,
        className: classes.tooltip,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ArrowSlot, arrowSlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('arrow', {
        elementType: $ea99f2520fe8509d$var$TooltipArrow,
        className: classes.arrow,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        ref: setArrowRef
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ $7fPBF.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(PopperSlot, {
                as: PopperComponentProp ?? (0, $2ecffc9bd505b8cc$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $ea99f2520fe8509d$var$cursorPosition.y,
                            left: $ea99f2520fe8509d$var$cursorPosition.x,
                            right: $ea99f2520fe8509d$var$cursorPosition.x,
                            bottom: $ea99f2520fe8509d$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true,
                ...interactiveWrapperListeners,
                ...popperSlotProps,
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TransitionSlot, {
                        timeout: theme.transitions.duration.shorter,
                        ...TransitionPropsInner,
                        ...transitionSlotProps,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(TooltipSlot, {
                            ...tooltipSlotProps,
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ArrowSlot, {
                                    ...arrowSlotProps
                                }) : null
                            ]
                        })
                    })
            })
        ]
    });
});
var $ea99f2520fe8509d$export$2e2bcd8739ae039 = $ea99f2520fe8509d$var$Tooltip;







const $cbb6bb91774a9b44$export$b1a401d0eced3e7 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 1rem;
    align-items: center;
`;
const $cbb6bb91774a9b44$export$c14c794fcd73bed8 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0.5rem;
    justify-content: space-between;
    padding: 2rem 2rem 0;
    max-width: 800px;
    width: calc(100% - 3rem);
`;
const $cbb6bb91774a9b44$export$cd7bba038e96e3a1 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 2rem;
    align-items: center;
`;
const $cbb6bb91774a9b44$export$eff72ff865909d33 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: inline-block;
`;
const $cbb6bb91774a9b44$export$cc2315a10717ef53 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $9926e0d0274623af$export$ce6636bfa4e9f0e8))`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0;
    padding-bottom: 0;
    max-width: 100%;
    gap: 1rem;
    align-items: center;
    justify-content: space-between;
`;
const $cbb6bb91774a9b44$export$4e88b920c7e5fd9 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039))`
    float: right;
    height: min-content;
`;






var $7fPBF = parcelRequire("7fPBF");

const $fd343a4c977deb5d$var$JOYSTICK_RADIUS = 100;
const $fd343a4c977deb5d$var$STICK_RADIUS = 30;
const $fd343a4c977deb5d$var$JOYSTICK_MOVEMENT_SCALE = $fd343a4c977deb5d$var$JOYSTICK_RADIUS - $fd343a4c977deb5d$var$STICK_RADIUS;
function $fd343a4c977deb5d$export$2e2bcd8739ae039({ macro: macro, event: event, eventIndex: eventIndex, onChange: onChange }) {
    const [config, setConfig] = (0, $7fPBF.useState)({
        joystickLeftMoveX: event.joystickLeftMoveX ? event.joystickLeftMoveX / 100 : 0,
        joystickLeftMoveY: event.joystickLeftMoveY ? event.joystickLeftMoveY / 100 : 0,
        joystickRightMoveX: event.joystickRightMoveX ? event.joystickRightMoveX / 100 : 0,
        joystickRightMoveY: event.joystickRightMoveY ? event.joystickRightMoveY / 100 : 0,
        holdTimeMilliseconds: event.holdTimeMilliseconds || 100,
        isKeyLatch: event.isKeyLatch ? event.isKeyLatch : event.holdTimeMilliseconds != undefined
    });
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const theme = (0, $d62c6f18f523e962$export$3b14a55fb2447963)();
    const muiTheme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const scaleJoystickValue = (value)=>{
        if (!value) return 0;
        value = value * 100; // Scale to percentage
        const clampedValue = Math.max(-100, Math.min(100, value));
        return Math.round(clampedValue);
    };
    const clampToUnitCircle = (x, y)=>{
        const mag = Math.sqrt(x * x + y * y);
        if (mag > 1) return {
            x: x / mag,
            y: y / mag
        };
        return {
            x: x,
            y: y
        };
    };
    const clampAndFloatValue = (value)=>{
        if (value === undefined) return 0;
        let clampedValue = Math.max(-1, Math.min(1, value));
        return clampedValue.toFixed(2) ? parseFloat(clampedValue.toFixed(2)) : 0;
    };
    const handleTimeChange = (isLatched, value)=>{
        const updatedMacro = {
            ...macro
        };
        const eventToUpdate = {
            ...updatedMacro.events[eventIndex]
        };
        const holdTime = value ?? 0;
        eventToUpdate.holdTimeMilliseconds = isLatched ? undefined : holdTime;
        eventToUpdate.isKeyLatch = isLatched;
        setConfig((prev)=>({
                ...prev,
                holdTimeMilliseconds: isLatched ? 0 : holdTime
            }));
        updatedMacro.events[eventIndex] = eventToUpdate;
        onChange(updatedMacro);
    };
    const handleJoystickMove = (0, $7fPBF.useCallback)((stick, x, y)=>{
        const updatedMacro = {
            ...macro
        };
        const eventToUpdate = {
            ...updatedMacro.events[eventIndex]
        };
        const scaledX = scaleJoystickValue(x);
        const scaledY = scaleJoystickValue(y);
        if (stick === 'leftStick') {
            eventToUpdate.joystickLeftMoveX = scaledX;
            eventToUpdate.joystickLeftMoveY = scaledY;
            setConfig((prev)=>({
                    ...prev,
                    joystickLeftMoveX: x,
                    joystickLeftMoveY: y
                }));
        } else {
            eventToUpdate.joystickRightMoveX = scaledX;
            eventToUpdate.joystickRightMoveY = scaledY;
            setConfig((prev)=>({
                    ...prev,
                    joystickRightMoveX: x,
                    joystickRightMoveY: y
                }));
        }
        updatedMacro.events[eventIndex] = eventToUpdate;
        if (!eventToUpdate.isKeyLatch && !eventToUpdate.holdTimeMilliseconds) eventToUpdate.isKeyLatch = true;
        onChange(updatedMacro);
    }, [
        macro,
        eventIndex,
        onChange
    ]);
    const handleMouseDown = (stick, event)=>{
        const rect = event.currentTarget.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;
        const handleMouseMove = (e)=>{
            let x = (e.clientX - centerX) / $fd343a4c977deb5d$var$JOYSTICK_MOVEMENT_SCALE;
            let y = -(e.clientY - centerY) / $fd343a4c977deb5d$var$JOYSTICK_MOVEMENT_SCALE;
            x = clampAndFloatValue(x);
            y = clampAndFloatValue(y);
            handleJoystickMove(stick, x, y);
        };
        const handleMouseUp = ()=>{
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };
    const resetJoystick = (stick)=>{
        handleJoystickMove(stick, 0, 0);
    };
    const clampedLeft = clampToUnitCircle(config.joystickLeftMoveX, config.joystickLeftMoveY);
    const clampedRight = clampToUnitCircle(config.joystickRightMoveX, config.joystickRightMoveY);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $8bffaacbbee0c705$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($fd343a4c977deb5d$var$JoystickContainer, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($fd343a4c977deb5d$var$JoystickWrapper, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b8b202156ead000b), {
                                    children: t('common:event.joystickMove.left')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($fd343a4c977deb5d$var$JoystickBase, {
                                    onMouseDown: (e)=>handleMouseDown('leftStick', e),
                                    color: muiTheme.palette.primary.main,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($fd343a4c977deb5d$var$JoystickStick, {
                                        x: clampedLeft.x,
                                        y: clampedLeft.y,
                                        active: !!(config.joystickLeftMoveX || config.joystickLeftMoveY),
                                        color: muiTheme.palette.primary.main
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($fd343a4c977deb5d$var$StatusIndicator, {
                                            active: !!(config.joystickLeftMoveX || config.joystickLeftMoveY)
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $b091aef3a32d2bd8$export$1ef657600983666a), {
                                            children: [
                                                "X: ",
                                                config.joystickLeftMoveX.toFixed(2),
                                                ", Y: ",
                                                config.joystickLeftMoveY.toFixed(2)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                                            title: t('common:reset'),
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                                                size: "small",
                                                onClick: ()=>resetJoystick('leftStick'),
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                    name: "sync",
                                                    size: 18,
                                                    color: theme.color.textBody
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($fd343a4c977deb5d$var$JoystickWrapper, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b8b202156ead000b), {
                                    children: t('common:event.joystickMove.right')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($fd343a4c977deb5d$var$JoystickBase, {
                                    onMouseDown: (e)=>handleMouseDown('rightStick', e),
                                    color: muiTheme.palette.secondary.main,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($fd343a4c977deb5d$var$JoystickStick, {
                                        x: clampedRight.x,
                                        y: clampedRight.y,
                                        active: !!(config.joystickRightMoveX || config.joystickRightMoveY),
                                        color: muiTheme.palette.secondary.main
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($fd343a4c977deb5d$var$StatusIndicator, {
                                            active: !!(config.joystickRightMoveX || config.joystickRightMoveY)
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $b091aef3a32d2bd8$export$1ef657600983666a), {
                                            children: [
                                                "X: ",
                                                config.joystickRightMoveX.toFixed(2),
                                                ", Y: ",
                                                config.joystickRightMoveY.toFixed(2)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                                            title: "Reset Position",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                                                size: "small",
                                                onClick: ()=>resetJoystick('rightStick'),
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                    name: "sync",
                                                    size: 18,
                                                    color: theme.color.textBody
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($fd343a4c977deb5d$var$AxisControl, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                                    id: `leftX${macro.id}`,
                                    variant: "body2",
                                    sx: {
                                        minWidth: 70
                                    },
                                    children: [
                                        t('common:event.joystickMove.leftX'),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3f15ab21d190f284$export$2e2bcd8739ae039), {
                                    "aria-labelledby": `leftX${macro.id}`,
                                    value: config.joystickLeftMoveX,
                                    onChange: (_, value)=>handleJoystickMove('leftStick', value, config.joystickLeftMoveY || 0),
                                    min: -1,
                                    max: 1,
                                    step: 0.01,
                                    sx: {
                                        flex: 1
                                    },
                                    color: "primary"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                                    variant: "body2",
                                    sx: {
                                        minWidth: 50,
                                        textAlign: 'right'
                                    },
                                    children: config.joystickLeftMoveX || 0
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($fd343a4c977deb5d$var$AxisControl, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                                    id: `leftY${macro.id}`,
                                    variant: "body2",
                                    sx: {
                                        minWidth: 70
                                    },
                                    children: [
                                        t('common:event.joystickMove.leftY'),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3f15ab21d190f284$export$2e2bcd8739ae039), {
                                    "aria-labelledby": `leftY${macro.id}`,
                                    value: config.joystickLeftMoveY,
                                    onChange: (_, value)=>handleJoystickMove('leftStick', config.joystickLeftMoveX || 0, value),
                                    min: -1,
                                    max: 1,
                                    step: 0.01,
                                    sx: {
                                        flex: 1
                                    },
                                    color: "primary"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                                    variant: "body2",
                                    sx: {
                                        minWidth: 50,
                                        textAlign: 'right'
                                    },
                                    children: config.joystickLeftMoveY
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($fd343a4c977deb5d$var$AxisControl, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                                    id: `rightX${macro.id}`,
                                    variant: "body2",
                                    sx: {
                                        minWidth: 70
                                    },
                                    children: [
                                        t('common:event.joystickMove.rightX'),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3f15ab21d190f284$export$2e2bcd8739ae039), {
                                    "aria-labelledby": `rightX${macro.id}`,
                                    value: config.joystickRightMoveX,
                                    onChange: (_, value)=>handleJoystickMove('rightStick', value, config.joystickRightMoveY || 0),
                                    min: -1,
                                    max: 1,
                                    step: 0.01,
                                    sx: {
                                        flex: 1
                                    },
                                    color: "secondary"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                                    variant: "body2",
                                    sx: {
                                        minWidth: 50,
                                        textAlign: 'right'
                                    },
                                    children: config.joystickRightMoveX
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($fd343a4c977deb5d$var$AxisControl, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                                    id: `rightY${macro.id}`,
                                    variant: "body2",
                                    sx: {
                                        minWidth: 70
                                    },
                                    children: [
                                        t('common:event.joystickMove.rightY'),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3f15ab21d190f284$export$2e2bcd8739ae039), {
                                    "aria-labelledby": `rightY${macro.id}`,
                                    value: config.joystickRightMoveY,
                                    onChange: (_, value)=>handleJoystickMove('rightStick', config.joystickRightMoveX || 0, value),
                                    min: -1,
                                    max: 1,
                                    step: 0.01,
                                    sx: {
                                        flex: 1
                                    },
                                    color: "secondary"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                                    variant: "body2",
                                    sx: {
                                        minWidth: 50,
                                        textAlign: 'right'
                                    },
                                    children: config.joystickRightMoveY
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cbb6bb91774a9b44$export$b1a401d0eced3e7), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($fd343a4c977deb5d$var$StyledRow, {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2e997290a21e7a60$export$7e36e2f4770bc64d), {
                                            isActive: !!event.isKeyLatch || event.isKeyLatch == undefined,
                                            onClick: ()=>handleTimeChange(true),
                                            children: t('common:event.keyPress.latch')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2e997290a21e7a60$export$7e36e2f4770bc64d), {
                                            isActive: !(event.isKeyLatch || event.isKeyLatch == undefined) && event.holdTimeMilliseconds != undefined,
                                            onClick: ()=>handleTimeChange(false, 0),
                                            children: t('common:event.keyPress.hold')
                                        })
                                    ]
                                }),
                                !event.isKeyLatch && event.isKeyLatch != undefined ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    label: t('common:event.hold'),
                                    type: "number",
                                    value: config.holdTimeMilliseconds,
                                    placeholder: t('common:event.hold'),
                                    onChange: (e)=>handleTimeChange(false, Number(e.target.value))
                                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                    children: [
                                        t('common:event.joystickMove.latch'),
                                        " "
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
const $fd343a4c977deb5d$var$JoystickContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    gap: 40px;
    justify-content: space-between;
    margin: 1rem auto;
    flex-wrap: wrap;
    max-width: 600px;
    justify-self: center;
`;
const $fd343a4c977deb5d$var$JoystickWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    gap: 16px;
`;
const $fd343a4c977deb5d$var$JoystickBase = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    width: 200px;
    height: 200px;
    border-radius: 50%;
    background: ${(props)=>props.color}20;
    border: 2px solid ${(props)=>props.color};
    position: relative;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        border: 2px solid ${(props)=>props.color};
    }
`;
const $fd343a4c977deb5d$var$JoystickStick = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: ${(props)=>props.active ? props.color || props.theme.color.secondary : props.theme.color.textBody};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(
        calc(-50% + ${(props)=>props.x * $fd343a4c977deb5d$var$JOYSTICK_MOVEMENT_SCALE}px),
        calc(-50% + ${(props)=>-props.y * $fd343a4c977deb5d$var$JOYSTICK_MOVEMENT_SCALE}px)
    );
    transition: all 0.2s ease;
    cursor: grab;

    &:active {
        cursor: grabbing;
        transform: translate(
                calc(-50% + ${(props)=>props.x * $fd343a4c977deb5d$var$JOYSTICK_MOVEMENT_SCALE}px),
                calc(-50% + ${(props)=>-props.y * $fd343a4c977deb5d$var$JOYSTICK_MOVEMENT_SCALE}px)
            )
            scale(0.95);
    }
`;
const $fd343a4c977deb5d$var$AxisControl = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem;
`;
const $fd343a4c977deb5d$var$StatusIndicator = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: ${(props)=>props.active ? (0, $8951886a6b49e92a$export$35e9368ef982300f).success : props.theme.color.textBody};
    transition: all 0.3s ease;
`;
const $fd343a4c977deb5d$var$StyledRow = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0.5rem;
    align-items: center;
    justify-content: flex-start;
    padding-bottom: 0.5rem;
`;








var $7fPBF = parcelRequire("7fPBF");

function $f9d7c8960dba7b88$export$2e2bcd8739ae039({ macro: macro, event: event, eventIndex: eventIndex, isPreview: isPreview = false, onChange: onChange }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const initMouseMoveX = event.mouseMoveX ?? 0;
    const initDirectionX = initMouseMoveX <= 0 ? 'left' : 'right';
    const initPixelsX = Math.abs(initMouseMoveX);
    const initMouseMoveY = event.mouseMoveY ?? 0;
    const initDirectionY = initMouseMoveY >= 0 ? 'down' : 'up';
    const initPixelsY = Math.abs(initMouseMoveY);
    const [moveX, setMoveX] = (0, $7fPBF.useState)(initMouseMoveX ? initMouseMoveX : 0);
    const [directionX, setDirectionX] = (0, $7fPBF.useState)(initDirectionX ? initDirectionX : 'right');
    const [pixelsX, setPixelsX] = (0, $7fPBF.useState)(initPixelsX ? initPixelsX : 0);
    const [moveY, setMoveY] = (0, $7fPBF.useState)(initMouseMoveY ? initMouseMoveY : 0);
    const [directionY, setDirectionY] = (0, $7fPBF.useState)(initDirectionY ? initDirectionY : 'up');
    const [pixelsY, setPixelsY] = (0, $7fPBF.useState)(initPixelsY ? initPixelsY : 0);
    const handleEventMouseXLeftRight = (value)=>{
        const newMoveX = pixelsX * (value === 'left' ? -1 : 1);
        macro.events[eventIndex].mouseMoveX = newMoveX;
        onChange({
            ...macro
        });
        setMoveX(newMoveX);
        setDirectionX(value);
    };
    const handleEventMouseXChange = (value)=>{
        setPixelsX(Number(value));
        const newMoveX = Number(value) * (directionX === 'left' ? -1 : 1);
        macro.events[eventIndex].mouseMoveX = newMoveX;
        onChange({
            ...macro
        });
        setMoveX(newMoveX);
    };
    const handleEventMouseYUpDown = (value)=>{
        const newMoveY = moveY * -1;
        macro.events[eventIndex].mouseMoveY = newMoveY;
        onChange({
            ...macro
        });
        setMoveY(newMoveY);
        setDirectionY(value);
    };
    const handleEventMouseYChange = (value)=>{
        setPixelsY(Number(value));
        const newMoveY = Number(value) * (directionY === 'down' ? 1 : -1);
        macro.events[eventIndex].mouseMoveY = newMoveY;
        onChange({
            ...macro
        });
        setMoveY(newMoveY);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($f9d7c8960dba7b88$var$Section, {
        "data-id": "mouse-move-step",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$d953939534de1974), {
                        children: t('common:event.mouseMove.moveX')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($f9d7c8960dba7b88$var$Set, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($f9d7c8960dba7b88$var$StyledRadioGroup, {
                                name: `${eventIndex}-horizontal-mouse`,
                                defaultValue: directionX,
                                onChange: (e)=>handleEventMouseXLeftRight(e.target.value),
                                value: directionX,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
                                        value: "right",
                                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $de28970229c88fa7$export$2e2bcd8739ae039), {
                                            disabled: isPreview
                                        }),
                                        label: t('common:event.directions.right')
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
                                        value: "left",
                                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $de28970229c88fa7$export$2e2bcd8739ae039), {
                                            disabled: isPreview
                                        }),
                                        label: t('common:event.directions.left')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                                disabled: isPreview,
                                type: "number",
                                fullWidth: true,
                                inputProps: {
                                    min: 0
                                },
                                value: pixelsX,
                                label: t('common:event.mouseMove.numberMoveX'),
                                placeholder: t('common:event.mouseMove.numberMoveX'),
                                onChange: (e)=>handleEventMouseXChange(e.target.value)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$d953939534de1974), {
                        children: t('common:event.mouseMove.moveY')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($f9d7c8960dba7b88$var$Set, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($f9d7c8960dba7b88$var$StyledRadioGroup, {
                                name: `${eventIndex}-vertical-mouse`,
                                defaultValue: directionY,
                                onChange: (e)=>handleEventMouseYUpDown(e.target.value),
                                value: directionY,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
                                        value: "up",
                                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $de28970229c88fa7$export$2e2bcd8739ae039), {
                                            disabled: isPreview
                                        }),
                                        label: t('common:event.directions.up')
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
                                        value: "down",
                                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $de28970229c88fa7$export$2e2bcd8739ae039), {
                                            disabled: isPreview
                                        }),
                                        label: t('common:event.directions.down')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                                disabled: isPreview,
                                type: "number",
                                label: t('common:event.mouseMove.numberMoveY'),
                                fullWidth: true,
                                inputProps: {
                                    min: 0
                                },
                                value: pixelsY,
                                placeholder: t('common:event.mouseMove.numberMoveY'),
                                onChange: (e)=>handleEventMouseYChange(e.target.value)
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $f9d7c8960dba7b88$var$StyledRadioGroup = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $e1f776e3a27ad5dc$export$2e2bcd8739ae039))`
    margin-bottom: 1rem;
`;
const $f9d7c8960dba7b88$var$Section = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 100%;
`;
const $f9d7c8960dba7b88$var$Set = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    padding: 0 0.5rem;
`;


const $3546a67590dd0db1$var$MacroStepEditor = ({ macro: macro, step: step, stepIndex: stepIndex, isPreview: isPreview, onChange: onChange })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const globalCustomControlsContainer = (0, $b8d2d4cc121e033d$export$2e2bcd8739ae039).useContainer();
    const editProfileContainer = (0, $697752726c88b03c$export$2e2bcd8739ae039).useContainer();
    const locale = editProfileContainer.defaultLocaleRef.current;
    const defaultKeyMapping = (0, $9a9874d925dad9cc$export$2f002ae08ac7e997)(locale, editProfileContainer.originalProfileRef.current?.platform);
    const [showStepOptions, setShowStepOptions] = (0, $7fPBF.useState)(false);
    const handleMoveStepUp = (eventIndex)=>{
        if (eventIndex == 0) return;
        const temp = macro.events[eventIndex - 1];
        macro.events[eventIndex - 1] = macro.events[eventIndex];
        macro.events[eventIndex] = temp;
        onChange({
            ...macro
        });
    };
    const profileCustomControls = editProfileContainer.availableCustomControls?.length ? editProfileContainer.availableCustomControls : globalCustomControlsContainer.profileCustomControls;
    const getCustomControlAllowsHold = (controlId)=>{
        const controls = editProfileContainer.availableCustomControls?.length > 0 ? editProfileContainer.availableCustomControls : globalCustomControlsContainer.profileCustomControls ?? [];
        for (const deviceControls of controls){
            const control = deviceControls.controls.find((c)=>c.id === controlId);
            if (control) return control.allowsHold;
        }
        return false;
    };
    const isDeviceAvailable = (deviceTypeId)=>{
        const controls = editProfileContainer.availableCustomControls?.length > 0 ? editProfileContainer.availableCustomControls : globalCustomControlsContainer.profileCustomControls ?? [];
        if (!deviceTypeId || controls.length === 0) return true;
        return controls.some((device)=>device.deviceTypeId === deviceTypeId);
    };
    const handleMoveStepDown = (eventIndex)=>{
        if (eventIndex == macro.events.length - 1) return;
        const temp = macro.events[eventIndex + 1];
        macro.events[eventIndex + 1] = macro.events[eventIndex];
        macro.events[eventIndex] = temp;
        onChange({
            ...macro
        });
    };
    const handleCopyStep = (eventIndex)=>{
        const clonedMacro = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).cloneDeep(macro);
        macro.events.push({
            ...clonedMacro.events[eventIndex]
        });
        onChange({
            ...macro
        });
    };
    const handleInsertStep = (eventIndex)=>{
        macro.events.splice(eventIndex + 1, 0, {
            eventType: 'KeyPress',
            keys: [
                ''
            ],
            holdTimeMilliseconds: 0
        });
        onChange({
            ...macro
        });
    };
    const handleRemoveStep = (eventIndex)=>{
        macro.events.splice(eventIndex, 1);
        onChange({
            ...macro
        });
    };
    const handleEventFieldTypeChange = (eventIndex, value)=>{
        macro.events[eventIndex].eventType = value;
        onChange({
            ...macro
        });
    };
    const handleEventHoldChange = (eventIndex, value)=>{
        macro.events[eventIndex].holdTimeMilliseconds = value ? Number(value) : undefined;
        onChange({
            ...macro
        });
    };
    const handleEventTypeChange = (eventIndex, value)=>{
        macro.events[eventIndex].typedPhrase = value;
        onChange({
            ...macro
        });
    };
    const handleEventAudioChange = (eventIndex, value)=>{
        macro.events[eventIndex].outputSpeech = value;
        onChange({
            ...macro
        });
    };
    const handleEventDeviceTypeCustomActionIdChange = (eventIndex, event)=>{
        if (editProfileContainer.availableCustomControls || globalCustomControlsContainer.profileCustomControls) {
            const controls = editProfileContainer.availableCustomControls.length > 0 ? editProfileContainer.availableCustomControls : globalCustomControlsContainer.profileCustomControls ? globalCustomControlsContainer.profileCustomControls : [];
            const deviceTypeId = controls.find((control)=>control.controls.some((c)=>c.id === event.target.value))?.deviceTypeId;
            macro.events[eventIndex].deviceTypeCustomActionId = event.target.value;
            macro.events[eventIndex].deviceTypeId = deviceTypeId;
            onChange({
                ...macro
            });
        }
    };
    const handleAddKey = (eventIndex)=>{
        if (macro?.events?.[eventIndex]?.keys) macro?.events?.[eventIndex]?.keys?.push('');
        onChange({
            ...macro
        });
    };
    const handleKeyValueChange = (eventIndex, keyIndex, value)=>{
        if (macro.events && macro.events[eventIndex] && macro.events[eventIndex].keys) {
            if (macro.events?.[eventIndex]?.keys?.[keyIndex] !== undefined) macro.events[eventIndex].keys[keyIndex] = value;
        }
        onChange({
            ...macro
        });
    };
    const handleRemoveKey = (eventIndex, keyIndex)=>{
        if (macro?.events?.[eventIndex]?.keys) macro.events[eventIndex].keys.splice(keyIndex, 1);
        onChange({
            ...macro
        });
    };
    const uuId = (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)();
    const handleKeyPressTypeChange = (eventIndex, value)=>{
        if (value == 'tap') {
            macro.events[eventIndex].holdTimeMilliseconds = undefined;
            macro.events[eventIndex].isKeyLatch = false;
            macro.events[eventIndex].isCustomToggle = false;
            macro.events[eventIndex].isCustomRelease = false;
        } else if (value == 'latch') {
            macro.events[eventIndex].holdTimeMilliseconds = undefined;
            macro.events[eventIndex].isKeyLatch = true;
            macro.events[eventIndex].isCustomToggle = false;
            macro.events[eventIndex].isCustomRelease = false;
        } else if (value == 'hold') {
            macro.events[eventIndex].holdTimeMilliseconds = 1000;
            macro.events[eventIndex].isKeyLatch = false;
            macro.events[eventIndex].isCustomToggle = false;
            macro.events[eventIndex].isCustomRelease = false;
        } else if (value == 'toggle') {
            macro.events[eventIndex].isKeyLatch = false;
            macro.events[eventIndex].holdTimeMilliseconds = 0;
            macro.events[eventIndex].isCustomToggle = true;
            macro.events[eventIndex].isCustomRelease = false;
        } else if (value == 'release') {
            macro.events[eventIndex].isKeyLatch = false;
            macro.events[eventIndex].holdTimeMilliseconds = 0;
            macro.events[eventIndex].isCustomToggle = false;
            macro.events[eventIndex].isCustomRelease = true;
        }
        onChange({
            ...macro
        });
    };
    const getKeyPressType = (eventIndex)=>{
        if (macro.events[eventIndex].isCustomToggle) return 'toggle';
        if (macro.events[eventIndex].isCustomRelease) return 'release';
        if (macro.events[eventIndex].isKeyLatch) return 'latch';
        if (macro.events[eventIndex].holdTimeMilliseconds != null) return 'hold';
        return 'tap';
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($3546a67590dd0db1$var$StepCard, {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $26a8e925f0aa9998$export$2e2bcd8739ae039), {
                    fullWidth: true,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcd80672e9993aad$export$2e2bcd8739ae039), {
                            id: `step-${stepIndex}`,
                            children: t('common:event.stepType')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                            disabled: isPreview,
                            labelId: `step-${stepIndex}`,
                            value: step.eventType,
                            label: t('common:event.stepType'),
                            onChange: (e)=>handleEventFieldTypeChange(stepIndex, e.target.value),
                            children: (0, $03a56fb167cf9474$export$caaa93ee9052213c).map((c)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                    value: c.eventType,
                                    children: t(c.displayName)
                                }, c.eventType))
                        })
                    ]
                }),
                step.eventType == 'DeviceTypeCustomAction' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$1acdcf5a973a8414), {
                            children: t('common:event.deviceTypeCustomAction.title')
                        }),
                        !isDeviceAvailable(step.deviceTypeId) && step.deviceTypeId ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    label: t('common:event.deviceTypeCustomAction.title'),
                                    disabled: true,
                                    value: step.deviceTypeCustomActionId || '',
                                    id: 'custom_' + uuId,
                                    slotProps: {
                                        htmlInput: {
                                            readOnly: true
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c181cff0789717b3$export$2e2bcd8739ae039), {
                                    severity: "info",
                                    children: [
                                        t('common:customControls.noDevice'),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                                            to: `/extensions/new/${step.deviceTypeId}`,
                                            startIcon: "deviceManager",
                                            children: t('common:device.add.action')
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $26a8e925f0aa9998$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcd80672e9993aad$export$2e2bcd8739ae039), {
                                    id: 'custom_' + uuId,
                                    children: t('common:event.deviceTypeCustomAction.title')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                    labelId: 'custom_' + uuId,
                                    fullWidth: true,
                                    value: step.deviceTypeCustomActionId || '',
                                    label: t('common:event.deviceTypeCustomAction.title'),
                                    onChange: (event)=>{
                                        handleEventDeviceTypeCustomActionIdChange(stepIndex, event);
                                    },
                                    children: profileCustomControls?.flatMap((d)=>[
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3546a67590dd0db1$var$DeviceSubheader, {
                                                children: d.name
                                            }, d.deviceTypeId),
                                            d.controls.map((c)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                    value: c.id,
                                                    "data-device": d.deviceTypeId,
                                                    children: c.name
                                                }, c.id))
                                        ])
                                })
                            ]
                        }),
                        getCustomControlAllowsHold(step.deviceTypeCustomActionId) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("fieldset", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$d953939534de1974), {
                                    children: t('common:event.keyPress.timing')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e1f776e3a27ad5dc$export$2e2bcd8739ae039), {
                                    row: true,
                                    name: `${stepIndex}-key-press-type`,
                                    defaultValue: "right",
                                    onChange: (e)=>handleKeyPressTypeChange(stepIndex, e.target.value),
                                    value: getKeyPressType(stepIndex),
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3546a67590dd0db1$var$StyledFormControlLabel, {
                                            value: "tap",
                                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $de28970229c88fa7$export$2e2bcd8739ae039), {
                                                disabled: isPreview
                                            }),
                                            label: t('common:event.keyPress.tapLong')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3546a67590dd0db1$var$StyledFormControlLabel, {
                                            value: "hold",
                                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $de28970229c88fa7$export$2e2bcd8739ae039), {
                                                disabled: isPreview
                                            }),
                                            label: t('common:event.keyPress.holdLong')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3546a67590dd0db1$var$StyledFormControlLabel, {
                                            value: "latch",
                                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $de28970229c88fa7$export$2e2bcd8739ae039), {
                                                disabled: isPreview
                                            }),
                                            label: t('common:event.keyPress.latchLong')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3546a67590dd0db1$var$StyledFormControlLabel, {
                                            value: "toggle",
                                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $de28970229c88fa7$export$2e2bcd8739ae039), {
                                                disabled: isPreview
                                            }),
                                            label: t('common:event.keyPress.toggleLong')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3546a67590dd0db1$var$StyledFormControlLabel, {
                                            value: "release",
                                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $de28970229c88fa7$export$2e2bcd8739ae039), {
                                                disabled: isPreview
                                            }),
                                            label: t('common:event.keyPress.releaseLong')
                                        })
                                    ]
                                }),
                                getCustomControlAllowsHold(step.deviceTypeCustomActionId) && getKeyPressType(stepIndex) === 'hold' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    label: t('common:event.hold'),
                                    disabled: isPreview,
                                    type: "number",
                                    value: step.holdTimeMilliseconds ?? 0,
                                    id: `${stepIndex}hold`,
                                    placeholder: t('common:event.hold'),
                                    onChange: (e)=>handleEventHoldChange(stepIndex, e.target.value)
                                })
                            ]
                        })
                    ]
                }),
                step.eventType == 'KeyPress' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$1acdcf5a973a8414), {
                            children: t('common:event.keyPress.fieldSet')
                        }),
                        step.keys?.map((k, ki)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6e48650aa2ed148e$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $26a8e925f0aa9998$export$2e2bcd8739ae039), {
                                        fullWidth: true,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcd80672e9993aad$export$2e2bcd8739ae039), {
                                                id: 'key_' + uuId + ki,
                                                children: t('common:event.keyPress.label')
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                                labelId: 'key_' + uuId + ki,
                                                value: (0, $9a9874d925dad9cc$export$38eb86f225c9e34c)(k, locale),
                                                label: t('common:event.keyPress.label'),
                                                onChange: (e)=>handleKeyValueChange(stepIndex, ki, e.target.value),
                                                children: defaultKeyMapping.map((c)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                        value: c.key,
                                                        children: c.displayName
                                                    }, c.key))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c09a12afb55a78a$export$2e2bcd8739ae039), {
                                        disabled: isPreview,
                                        onClick: ()=>handleRemoveKey(stepIndex, ki),
                                        showLabel: false,
                                        children: t('common:event.keyPress.remove')
                                    })
                                ]
                            }, uuId + ki)),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                                startIcon: "touchpad",
                                disabled: isPreview,
                                onClick: ()=>handleAddKey(stepIndex),
                                children: t('common:event.keyPress.add')
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("fieldset", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$d953939534de1974), {
                                    children: t('common:event.keyPress.timing')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e1f776e3a27ad5dc$export$2e2bcd8739ae039), {
                                    row: true,
                                    name: `${stepIndex}-key-press-type`,
                                    defaultValue: "right",
                                    onChange: (e)=>handleKeyPressTypeChange(stepIndex, e.target.value),
                                    value: getKeyPressType(stepIndex),
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3546a67590dd0db1$var$StyledFormControlLabel, {
                                            value: "tap",
                                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $de28970229c88fa7$export$2e2bcd8739ae039), {
                                                disabled: isPreview
                                            }),
                                            label: t('common:event.keyPress.tapLong')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3546a67590dd0db1$var$StyledFormControlLabel, {
                                            value: "hold",
                                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $de28970229c88fa7$export$2e2bcd8739ae039), {
                                                disabled: isPreview
                                            }),
                                            label: t('common:event.keyPress.holdLong')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3546a67590dd0db1$var$StyledFormControlLabel, {
                                            value: "latch",
                                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $de28970229c88fa7$export$2e2bcd8739ae039), {
                                                disabled: isPreview
                                            }),
                                            label: t('common:event.keyPress.latchLong')
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                step.eventType == 'KeyRelease' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$1acdcf5a973a8414), {
                            children: t('common:event.keyRelease.title')
                        }),
                        step.keys?.map((k, ki)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6e48650aa2ed148e$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $26a8e925f0aa9998$export$2e2bcd8739ae039), {
                                        fullWidth: true,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcd80672e9993aad$export$2e2bcd8739ae039), {
                                                id: 'release' + uuId + ki,
                                                children: t('common:event.keyRelease.title')
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                                labelId: 'release' + uuId + ki,
                                                value: (0, $9a9874d925dad9cc$export$38eb86f225c9e34c)(k, locale),
                                                label: t('common:event.keyRelease.title'),
                                                onChange: (e)=>handleKeyValueChange(stepIndex, ki, e.target.value),
                                                children: defaultKeyMapping.map((c)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                        value: c.key,
                                                        children: c.displayName
                                                    }, c.key))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c09a12afb55a78a$export$2e2bcd8739ae039), {
                                        disabled: isPreview,
                                        onClick: ()=>handleRemoveKey(stepIndex, ki),
                                        showLabel: false,
                                        children: t('common:event.keyRelease.remove')
                                    })
                                ]
                            }, uuId + ki)),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                                startIcon: "touchpad",
                                disabled: isPreview,
                                onClick: ()=>handleAddKey(stepIndex),
                                children: t('common:event.keyRelease.add')
                            })
                        })
                    ]
                }),
                step.eventType == 'KeyToggle' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$1acdcf5a973a8414), {
                            children: t('common:event.keyToggle.title')
                        }),
                        step.keys?.map((k, ki)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6e48650aa2ed148e$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $26a8e925f0aa9998$export$2e2bcd8739ae039), {
                                        fullWidth: true,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcd80672e9993aad$export$2e2bcd8739ae039), {
                                                id: `key-${ki}`,
                                                children: t('common:event.keyToggle.title')
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                                labelId: `key-${ki}`,
                                                value: (0, $9a9874d925dad9cc$export$38eb86f225c9e34c)(k, locale),
                                                label: t('common:event.keyToggle.selected'),
                                                onChange: (e)=>handleKeyValueChange(stepIndex, ki, e.target.value),
                                                children: defaultKeyMapping.map((c)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                        value: c.key,
                                                        children: c.displayName
                                                    }, c.key))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c09a12afb55a78a$export$2e2bcd8739ae039), {
                                        disabled: isPreview,
                                        onClick: ()=>handleRemoveKey(stepIndex, ki),
                                        showLabel: false,
                                        children: t('common:event.keyToggle.remove')
                                    })
                                ]
                            }, ki)),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                                startIcon: "touchpad",
                                disabled: isPreview,
                                onClick: ()=>handleAddKey(stepIndex),
                                children: t('common:event.keyToggle.add')
                            })
                        })
                    ]
                }),
                step.eventType == 'Type' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        multiline: true,
                        minRows: 3,
                        label: t('common:event.type.field'),
                        disabled: isPreview,
                        type: "text",
                        value: step.typedPhrase,
                        id: uuId,
                        placeholder: t('common:event.type.placeholder'),
                        onChange: (e)=>handleEventTypeChange(stepIndex, e.target.value)
                    })
                }),
                step.eventType == 'PlayAudio' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        label: t('common:event.playAudio.title'),
                        disabled: isPreview,
                        value: step.outputSpeech,
                        id: uuId,
                        placeholder: t('common:event.playAudio.placeholder'),
                        onChange: (e)=>handleEventAudioChange(stepIndex, e.target.value)
                    })
                }),
                step.eventType == 'StopOutputs' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$1acdcf5a973a8414), {
                        htmlFor: `${stepIndex}speak`,
                        children: t('common:event.stopOutputs.titleLong')
                    })
                }),
                step.eventType == 'JoysticksMove' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fd343a4c977deb5d$export$2e2bcd8739ae039), {
                    event: step,
                    eventIndex: stepIndex,
                    macro: macro,
                    isPreview: isPreview,
                    onChange: onChange
                }),
                step.eventType == 'MouseMove' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f9d7c8960dba7b88$export$2e2bcd8739ae039), {
                    event: step,
                    eventIndex: stepIndex,
                    macro: macro,
                    isPreview: isPreview,
                    onChange: onChange
                }),
                (0, $03a56fb167cf9474$export$7e8bcaa1250bba4e)(step) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cd2b84e36aef1fba$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            label: t('common:event.hold'),
                            disabled: isPreview,
                            type: "number",
                            value: step.holdTimeMilliseconds ?? 0,
                            id: `${stepIndex}hold`,
                            placeholder: t('common:event.hold'),
                            onChange: (e)=>handleEventHoldChange(stepIndex, e.target.value)
                        })
                    })
                }),
                showStepOptions ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039), {
                    style: {
                        marginTop: 32
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                            onClick: ()=>setShowStepOptions(false),
                            children: t('common:event.hideOptions')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                            startIcon: "moveUp",
                            onClick: ()=>handleMoveStepUp(stepIndex),
                            disabled: stepIndex == 0,
                            children: t('common:event.stepUp')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                            startIcon: "moveDown",
                            disabled: isPreview,
                            onClick: ()=>handleMoveStepDown(stepIndex),
                            children: t('common:event.stepDown')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                            startIcon: "duplicate",
                            disabled: isPreview,
                            onClick: ()=>handleCopyStep(stepIndex),
                            children: t('common:event.stepCopy')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                            startIcon: "insertRow",
                            disabled: isPreview,
                            onClick: ()=>handleInsertStep(stepIndex),
                            children: t('common:event.insertStep')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                            startIcon: "delete",
                            disabled: isPreview,
                            onClick: ()=>handleRemoveStep(stepIndex),
                            children: t('common:event.stepRemove')
                        })
                    ]
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039), {
                    style: {
                        marginTop: 8
                    },
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        $color: "simple",
                        onClick: ()=>setShowStepOptions(true),
                        children: t('common:event.showOptions')
                    })
                })
            ]
        })
    });
};
const $3546a67590dd0db1$var$StyledFormControlLabel = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $206020d7e70b2617$export$2e2bcd8739ae039))`
    align-self: flex-start;
`;
const $3546a67590dd0db1$var$StepCard = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $bfb223886c302418$export$2e2bcd8739ae039))`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 1rem auto;
    gap: 16px;
    padding: 32px 16px;
    width: calc(100% - 32px);
`;
const $3546a67590dd0db1$var$DeviceSubheader = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$a35e4d6f9ac473d6))`
    margin: 1rem 0.5rem;
`.withComponent('h3');
var $3546a67590dd0db1$export$2e2bcd8739ae039 = $3546a67590dd0db1$var$MacroStepEditor;








var $7fPBF = parcelRequire("7fPBF");


function $8f0c21677a1de5b0$export$2e2bcd8739ae039() {
    const { index: index } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const editProfileContainer = (0, $697752726c88b03c$export$2e2bcd8739ae039).useContainer();
    const alertsContainer = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const isNew = index?.toLowerCase() == 'new';
    const [macro, setMacro] = (0, $7fPBF.useState)(isNew ? {
        commands: [],
        events: [],
        id: (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)()
    } : editProfileContainer.macros[Number(index)]);
    const [stage, setStage] = (0, $7fPBF.useState)(0);
    const handleFinish = async ()=>{
        if (macro.commands.filter((c)=>c.command?.length > 0)?.length < 1) {
            alertsContainer.showError(t('common:event.error'));
            return;
        }
        if (macro.events.length < 1) alertsContainer.showError(t('common:event.error'));
        if (macro.commands.some((c)=>c.commandType == 'hotkey')) {
            const originalValue = macro.commands?.[0]?.command;
            const hotkeyCommand = macro.commands?.[0]?.command;
            const hotkeyId = editProfileContainer.updateHotkeyFromMacro(hotkeyCommand, macro, 0, originalValue);
            macro.commands[0].hotkeyLocalId = hotkeyId ?? undefined;
        }
        const macros = editProfileContainer.macrosRef.current;
        if (isNew) macros.unshift({
            ...macro,
            name: (0, $9d76aba0a210d2c6$export$a9e54ec0b37334dc)(macro.commands?.[0]?.command, t)
        });
        else macros[Number(index)] = macro;
        // update macros in profile
        editProfileContainer.updateMacros(macros);
        editProfileContainer.setHasChanges(true);
        navigate(-1);
    };
    const handleAddStep = (eventType)=>{
        setStage(3);
        macro.events.push({
            eventType: eventType ?? 'KeyPress',
            keys: [
                ''
            ],
            holdTimeMilliseconds: undefined
        });
        setMacro({
            ...macro
        });
    };
    const handleCommandChange = (value, index)=>{
        macro.commands[index].command = value;
        setMacro({
            ...macro
        });
    };
    const selectCommandType = (commandType)=>{
        if (macro.commands.length < 2) macro.commands = [
            {
                commandType: commandType,
                command: ''
            }
        ];
        else macro.commands.push({
            commandType: commandType,
            command: ''
        });
        setStage(1);
    };
    const goBack = ()=>{
        setStage(stage - 1);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4f907cce853cc2ff$export$2e2bcd8739ae039), {
            children: [
                stage == 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($8f0c21677a1de5b0$var$StyledActionCardWrapper, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6392222d2b8fb222$export$474db65c3c394e1c), {
                            children: [
                                t('common:input.select'),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                            children: t('common:input.question')
                        }),
                        (0, $f44f3a5bc46b1c4c$export$6c5a93cb3986a928).map((c, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                id: c,
                                $color: "secondary",
                                startIcon: (0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)[c].icon,
                                onClick: ()=>selectCommandType(c),
                                children: t((0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)[c].title)
                            }, `commandType-${i}`))
                    ]
                }),
                stage == 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($8f0c21677a1de5b0$var$StyledActionCardWrapper, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6392222d2b8fb222$export$474db65c3c394e1c), {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                name: (0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)[macro.commands?.[0]?.commandType].icon
                                            }),
                                            t((0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)[macro.commands?.[0]?.commandType].title)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                        children: t((0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)[macro.commands?.[0]?.commandType].question)
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $00051b104a6506d5$export$43ee9de14381bd97), {
                                        id: "input-command-field",
                                        control: macro.commands?.[0]?.commandType,
                                        value: macro.commands?.[0]?.command,
                                        onChange: (e)=>handleCommandChange(e, 0)
                                    }),
                                    (0, $f44f3a5bc46b1c4c$export$48c02457e332140e).find((e)=>e.value == macro.commands?.[0]?.command) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                        children: t((0, $f44f3a5bc46b1c4c$export$48c02457e332140e).find((e)=>e.value == macro.commands?.[0]?.command)?.description)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                id: "macro-edit-next",
                                onClick: ()=>{
                                    if (macro.commands?.[0]?.command?.length > 0) setStage(2);
                                },
                                children: t('common:next')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                $color: "simple",
                                onClick: goBack,
                                children: t('common:back')
                            })
                        ]
                    })
                }),
                stage == 2 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($8f0c21677a1de5b0$var$StyledActionCardWrapper, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6392222d2b8fb222$export$474db65c3c394e1c), {
                            children: t('common:event.select')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                            children: t('common:event.question')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            onClick: ()=>handleAddStep('KeyPress'),
                            children: t('common:event.keyPress.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            onClick: ()=>handleAddStep('KeyRelease'),
                            children: t('common:event.keyRelease.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            onClick: ()=>handleAddStep('KeyToggle'),
                            children: t('common:event.keyToggle.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            id: "event-type",
                            $color: "secondary",
                            onClick: ()=>handleAddStep('Type'),
                            children: t('common:event.type.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            onClick: ()=>handleAddStep('MouseMove'),
                            children: t('common:event.mouseMove.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            onClick: ()=>handleAddStep('JoysticksMove'),
                            children: t('common:event.joystickMove.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            onClick: ()=>handleAddStep('PlayAudio'),
                            children: t('common:event.playAudio.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            onClick: ()=>handleAddStep('StopOutputs'),
                            children: t('common:event.stopOutputs.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            onClick: ()=>handleAddStep('DeviceTypeCustomAction'),
                            children: t('common:event.deviceTypeCustomAction.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            onClick: ()=>{
                                handleAddStep();
                                handleAddStep();
                            },
                            children: t('common:event.multiple')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "simple",
                            onClick: goBack,
                            children: t('common:back')
                        })
                    ]
                }),
                stage == 3 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($8f0c21677a1de5b0$var$StyledActionCardWrapper, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6392222d2b8fb222$export$474db65c3c394e1c), {
                                    children: t('common:event.setup')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                    children: t('common:event.question')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                    onClick: ()=>handleFinish(),
                                    children: t('common:finish')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                    $color: "simple",
                                    onClick: goBack,
                                    children: t('common:back')
                                })
                            ]
                        }),
                        macro.events?.map((e, ei)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3546a67590dd0db1$export$2e2bcd8739ae039), {
                                macro: macro,
                                step: e,
                                stepIndex: ei,
                                onChange: (macro)=>setMacro(macro)
                            }, ei)),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039), {
                            className: (0, $d77565acc82ac668$export$dbf350e5966cf602)`
                                margin: 16px;
                                width: calc(100% - 32px);
                            `,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                                startIcon: "plus",
                                disabled: editProfileContainer.isPreview,
                                onClick: ()=>handleAddStep(),
                                children: t('common:event.add')
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039), {
                            className: (0, $d77565acc82ac668$export$dbf350e5966cf602)`
                                margin: 16px;
                                width: calc(100% - 32px);
                            `,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                id: "finish-macro-edit",
                                onClick: ()=>handleFinish(),
                                children: t('common:finish')
                            })
                        })
                    ]
                })
            ]
        })
    });
}
const $8f0c21677a1de5b0$var$StyledActionCardWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $30f62651b17206ee$export$2e2bcd8739ae039))`
    margin: 16px;
    width: calc(100% - 32px);
`;







parcelRequire("7fPBF");


const $bfe72387f1b141ea$var$HeaderCreateButton = ({ label: label, disabled: disabled, ...restProps })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($bfe72387f1b141ea$var$AddHeaderContainer, {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
            $color: "dashedAccent",
            startIcon: "plus",
            ...restProps,
            children: label
        })
    });
};
const $bfe72387f1b141ea$var$AddHeaderContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px;
    width: calc(100% - 32);
    > * {
        margin: 4px;
    }
`;
var $bfe72387f1b141ea$export$2e2bcd8739ae039 = $bfe72387f1b141ea$var$HeaderCreateButton;





const $fcaddb9c30332041$export$a14e0b54e46f6871 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    height: calc(100dvh - ${(props)=>props.$offset ? props.$offset : 0}px);
    display: flex;
    flex: 1;
    flex-direction: column;
`;
const $fcaddb9c30332041$export$d6b9c1bba5ee845 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    flex-shrink: 0; /* Prevent shrinking */
    width: 100%;
`;
const $fcaddb9c30332041$export$2264cf7efee465f9 = (0, $8de346382d86c747$export$2e2bcd8739ae039).main`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    overflow-y: auto;
    flex: 1;
    &[data-managed='true'] {
        border-left: 10px solid ${(props)=>props.theme.color.indicator};
    }
`;
const $fcaddb9c30332041$export$5b061f6699ff1c06 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    flex: 1;
    display: flex;
    overflow: hidden;
    overflow-y: auto;
    scrollbar-color: ${(props)=>props.theme.color.accent} ${(props)=>props.theme.color.cardHover};
    scrollbar-width: thin;
`;
const $fcaddb9c30332041$export$de401b45f203ff7f = (0, $8de346382d86c747$export$2e2bcd8739ae039)('div')`
    background-color: ${({ theme: theme })=>theme.color.background};
    position: sticky;
    bottom: 0;
    padding: 1rem 0;
    display: flex;
    justify-content: ${({ contentPosition: contentPosition })=>contentPosition || 'flex-end'};

    ${({ $visuallyHide: $visuallyHide })=>$visuallyHide && (0, $19e0bc52fddd02b4$export$15b02e474f045d64)}
`;
const $fcaddb9c30332041$export$7df9baccf69a86b2 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($fcaddb9c30332041$export$de401b45f203ff7f)`
    flex: 1;
    width: 100%;
`;
const $fcaddb9c30332041$export$6ce170286acaa8d3 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    padding: 1rem 1rem 2rem 1rem;
`;
const $fcaddb9c30332041$export$ef8a3f74a07f9d23 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    opacity: 0.5;
    pointer-events: none;
    user-select: none;
    position: relative;

    .interaction-blocker {
        position: absolute;
        inset: 0;
        z-index: 1;
        background: transparent;
        cursor: not-allowed;
    }
`;





/** NOTE: not included in ControlTypeField */ function $368a38ffb0c2a5b2$var$DictationControlField({ value: value, onChange: onChange, disabled: disabled }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
        disabled: disabled,
        fullWidth: true,
        value: value,
        label: t('common:dictation.title'),
        placeholder: t('common:dictation.question'),
        onChange: (e)=>onChange(e.target.value)
    });
}
var $368a38ffb0c2a5b2$export$2e2bcd8739ae039 = $368a38ffb0c2a5b2$var$DictationControlField;




var $7fPBF = parcelRequire("7fPBF");

function $c3060ab743a09b93$export$3bd2a898ef2fa88e({ shouldBlock: shouldBlock, onConfirm: onConfirm }) {
    const location = (0, $5ec159caebd3ae22$export$45d76561a5302f2b)();
    const blocker = (0, $5ec159caebd3ae22$export$b273b3273281a049)(shouldBlock);
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        if (blocker.state === 'blocked') {
            const destination = blocker.location.pathname;
            if (destination.includes(location.pathname)) {
                // If the destination is a deeper route of the current path, allow navigation without blocking
                blocker.proceed?.();
                return;
            }
            console.log('Navigation attempt to:', destination);
            setOpen(true);
        }
    }, [
        blocker,
        location
    ]);
    return {
        openDialog: open,
        handleConfirm: async ()=>{
            await onConfirm();
            if (blocker.state === 'blocked') blocker.proceed?.();
            setOpen(false);
        },
        handleCancel: ()=>{
            blocker.reset?.();
            setOpen(false);
        },
        handleContinue: ()=>{
            if (blocker.state === 'blocked') blocker.proceed?.();
            setOpen(false);
        }
    };
}




function $258cb68b976e3a51$export$2e2bcd8739ae039({ hasChanges: hasChanges, setHasChanges: setHasChanges, onSave: onSave, title: title, description: description, confirmButtonText: confirmButtonText, cancelButtonText: cancelButtonText, ...restProps }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { openDialog: openDialog, handleConfirm: handleConfirm, handleCancel: handleCancel, handleContinue: handleContinue } = (0, $c3060ab743a09b93$export$3bd2a898ef2fa88e)({
        shouldBlock: hasChanges,
        onConfirm: onSave
    });
    const handleContinueWithState = async ()=>{
        await handleContinue();
        setHasChanges(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        open: openDialog,
        title: title ?? t('common:unsaved.title'),
        description: description ?? t('common:unsaved.description'),
        confirmButtonText: confirmButtonText ?? t('common:unsaved.confirm'),
        cancelButtonText: cancelButtonText ?? t('common:unsaved.cancel'),
        onConfirm: handleConfirm,
        onCancel: handleContinueWithState,
        onClose: handleCancel,
        ...restProps
    });
}




var $7fPBF = parcelRequire("7fPBF");


function $013893ecb4f625ea$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const editProfileContainer = (0, $697752726c88b03c$export$2e2bcd8739ae039).useContainer();
    const [dictationCommands, setDictationCommands] = (0, $7fPBF.useState)(editProfileContainer.dictationCommands || []);
    (0, $7fPBF.useEffect)(()=>{
        if (editProfileContainer.dictationCommands) setDictationCommands([
            ...editProfileContainer.dictationCommands
        ]);
    }, [
        editProfileContainer.dictationCommands
    ]);
    const handleCommandChange = (value, index)=>{
        dictationCommands[index] = value;
        setDictationCommands([
            ...dictationCommands
        ]);
        editProfileContainer.setHasChanges(true);
    };
    const handleRemoveDictationCommand = (index)=>{
        dictationCommands.splice(index, 1);
        setDictationCommands([
            ...dictationCommands
        ]);
        editProfileContainer.setHasChanges(true);
    };
    const handleAddDictationCommand = ()=>{
        dictationCommands.unshift('');
        setDictationCommands([
            ...dictationCommands
        ]);
        editProfileContainer.setHasChanges(true);
    };
    const handleSave = async ()=>{
        const filteredCommands = dictationCommands.filter((command)=>command.length > 0);
        editProfileContainer.updateDictationCommands(filteredCommands);
        if (organizationId) editProfileContainer.organizationIdRef.current = organizationId;
        await editProfileContainer.saveChanges();
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfe72387f1b141ea$export$2e2bcd8739ae039), {
                onClick: ()=>handleAddDictationCommand(),
                label: t('common:dictation.add')
            }),
            dictationCommands?.map((h, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6e48650aa2ed148e$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $368a38ffb0c2a5b2$export$2e2bcd8739ae039), {
                            value: h,
                            onChange: (e)=>handleCommandChange(e, i),
                            disabled: editProfileContainer.isPreview
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c09a12afb55a78a$export$2e2bcd8739ae039), {
                            disabled: editProfileContainer.isPreview,
                            onClick: ()=>handleRemoveDictationCommand(i),
                            children: t('common:dictation.remove')
                        })
                    ]
                }, i)),
            editProfileContainer.hasChanges && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $258cb68b976e3a51$export$2e2bcd8739ae039), {
                hasChanges: editProfileContainer.hasChanges,
                setHasChanges: editProfileContainer.setHasChanges,
                onSave: handleSave
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$de401b45f203ff7f), {
                contentPosition: "center",
                $visuallyHide: !editProfileContainer.hasChanges && editProfileContainer.id !== undefined,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    $color: "primary",
                    $size: "large",
                    startIcon: "save",
                    onClick: handleSave,
                    children: t('common:saveAndFinish')
                })
            })
        ]
    });
}














function $2a7f35c066805bff$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const editProfileContainer = (0, $697752726c88b03c$export$2e2bcd8739ae039).useContainer();
    const moveHotkeyUp = (hotkey)=>{
        const hotkeys = editProfileContainer.hotkeys;
        const index = hotkeys.indexOf(hotkey);
        if (index == 0) return;
        const temp = hotkeys[index - 1];
        hotkeys[index - 1] = hotkeys[index];
        hotkeys[index] = temp;
        editProfileContainer.updateHotkeys([
            ...hotkeys
        ]);
        editProfileContainer.setHasChanges(true);
    };
    const moveHotkeyDown = (hotkey)=>{
        const hotkeys = editProfileContainer.hotkeys;
        const index = hotkeys.indexOf(hotkey);
        if (index == hotkeys.length - 1) return;
        const temp = hotkeys[index + 1];
        hotkeys[index + 1] = hotkeys[index];
        hotkeys[index] = temp;
        editProfileContainer.updateHotkeys([
            ...hotkeys
        ]);
        editProfileContainer.setHasChanges(true);
    };
    const handleSave = async ()=>{
        const result = await editProfileContainer.saveChanges();
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            editProfileContainer.hotkeys?.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($2a7f35c066805bff$var$HotkeyWrapper, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2a7f35c066805bff$var$StyledSubtitleText, {
                        children: t('common:hotkey.reorder')
                    }),
                    editProfileContainer.hotkeys?.map((h, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($2a7f35c066805bff$var$Card, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($2a7f35c066805bff$var$Content, {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                            name: "virtualButton",
                                            size: 24
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                                            children: h.displayName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($2a7f35c066805bff$var$ButtonsContainer, {
                                    children: [
                                        i > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2a7f35c066805bff$var$StyledButton, {
                                            $color: "simple",
                                            $size: "small",
                                            disabled: editProfileContainer.isPreview,
                                            onClick: ()=>moveHotkeyUp(h),
                                            startIcon: "moveUp",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30af349a5a5f3e57$export$2e2bcd8739ae039), {
                                                children: t('common:event.options.moveUp')
                                            })
                                        }),
                                        i < editProfileContainer.hotkeys.length - 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2a7f35c066805bff$var$StyledButton, {
                                            $color: "simple",
                                            $size: "small",
                                            disabled: editProfileContainer.isPreview,
                                            onClick: ()=>moveHotkeyDown(h),
                                            startIcon: "moveDown",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30af349a5a5f3e57$export$2e2bcd8739ae039), {
                                                children: t('common:event.options.moveDown')
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, i))
                ]
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2a7f35c066805bff$var$HotkeyWrapper, {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2a7f35c066805bff$var$Message, {
                    children: t('common:hotkey.empty')
                })
            }),
            editProfileContainer.hasChanges && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $258cb68b976e3a51$export$2e2bcd8739ae039), {
                hasChanges: editProfileContainer.hasChanges,
                setHasChanges: editProfileContainer.setHasChanges,
                onSave: handleSave
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$de401b45f203ff7f), {
                contentPosition: "center",
                $visuallyHide: !editProfileContainer.hasChanges || editProfileContainer.id !== undefined && editProfileContainer.originatedByProfileId !== undefined,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    $color: "primary",
                    $size: "large",
                    startIcon: "save",
                    onClick: handleSave,
                    children: t('common:saveAndFinish')
                })
            })
        ]
    });
}
const $2a7f35c066805bff$var$Message = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    min-height: 40vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;
const $2a7f35c066805bff$var$StyledIcons = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039))`
    top: 5px;
    position: relative;
`;
const $2a7f35c066805bff$var$HotkeyWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: center;
    margin: 1rem;
`;
const $2a7f35c066805bff$var$StyledButton = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039))`
    gap: 0;
`;
const $2a7f35c066805bff$var$Card = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $184b8f5fc607fb11$export$eeffb7d514a37123))`
    padding: 0.5rem;
    width: 45%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    flex-grow: 1;
    justify-content: space-between;

    border: 1px solid ${(props)=>props.theme.color.neutral};
    background: ${(props)=>props.theme.color.accentCard};
    &:last-child:nth-of-type(odd) {
        width: 90%;
        height: 100px;
    }
`;
const $2a7f35c066805bff$var$ButtonsContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    align-self: center;
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: space-between;
    gap: 0.25rem;
`;
const $2a7f35c066805bff$var$Content = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    flex: 1;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
`;
const $2a7f35c066805bff$var$StyledSubtitleText = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$45814810f7000d9e))`
    padding: 1rem 0;
    width: 100%;
`;
const $2a7f35c066805bff$export$7e45b7e9a9d29a91 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    border: solid 1px ${(0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark}40;
    border-radius: 10px;
    margin: -2rem 0 1rem 0;
    padding: 1rem;
    width: 100%;
    > * {
        max-width: calc(100% - 2rem);
    }
`;











var $7fPBF = parcelRequire("7fPBF");

const $67d08281aa8666ad$var$ExpanderCard = ({ title: title, startExpanded: startExpanded, children: children, leftIcons: leftIcons, id: id, rightComponent: rightComponent })=>{
    const [isExpanded, setIsExpanded] = (0, $7fPBF.useState)(startExpanded);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($67d08281aa8666ad$var$MarginWrapper, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($67d08281aa8666ad$var$WrapperButton, {
                id: id,
                onClick: ()=>setIsExpanded(!isExpanded),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($67d08281aa8666ad$export$2061af696e09df60, {
                    "data-expanded": isExpanded,
                    children: [
                        leftIcons && leftIcons.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($67d08281aa8666ad$var$IconContainer, {
                            children: leftIcons?.map((icon, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                                    title: icon.tooltip,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($67d08281aa8666ad$var$CardIcon, {
                                        src: icon.src,
                                        alt: icon.alt
                                    })
                                }, index))
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($67d08281aa8666ad$export$f4ebac71945699fe, {
                            children: title
                        }),
                        rightComponent && rightComponent()
                    ]
                })
            }),
            isExpanded && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($67d08281aa8666ad$var$ExpandedSection, {
                children: children
            })
        ]
    });
};
const $67d08281aa8666ad$var$MarginWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    margin-bottom: 16px;
`;
const $67d08281aa8666ad$var$IconContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-right: auto;
    margin-left: 16px;
    position: absolute;
    left: 16px;
`;
const $67d08281aa8666ad$var$CardIcon = (0, $8de346382d86c747$export$2e2bcd8739ae039).img`
    width: 32px;
    height: 32px;
    margin-right: 8px;
`;
const $67d08281aa8666ad$var$WrapperButton = (0, $8de346382d86c747$export$2e2bcd8739ae039).button`
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    width: 100%;
    position: relative;
`;
const $67d08281aa8666ad$var$ExpandedSection = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    background-color: ${(props)=>props.theme.color.accentCard};
    animation: float 0.25s ease-in-out;
    margin: 0 16px 32px 16px;
    padding: 1rem 1rem 2rem 1rem;
    border-radius: 0 0 10px 10px;
    @keyframes float {
        0% {
            opacity: 0;
            transform: translatey(0px);
        }
        100% {
            transform: translatey(0px);
            opacity: 1;
        }
    }
    @keyframes fade {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
`;
const $67d08281aa8666ad$export$f4ebac71945699fe = (0, $8de346382d86c747$export$2e2bcd8739ae039).h3`
    font-size: ${(0, $8951886a6b49e92a$export$7536ca5ba8ef94f0).card_title};
    font-weight: lighter;
    color: ${(props)=>props.theme.color.text};
    margin: 0 88px;
    flex: 1;
`;
const $67d08281aa8666ad$export$2061af696e09df60 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $184b8f5fc607fb11$export$e0b30d1797fa97ad))`
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-self: center;
    cursor: pointer;
    width: calc(100% - 32px);
    min-width: 380px;
    padding: 16px;
    margin: 0 16px;
    background-color: ${(props)=>props.theme.color.accentCard};
    color: ${(0, $8951886a6b49e92a$export$35e9368ef982300f).secondary};
    &[data-expanded='true'] {
        box-shadow: none;
        border: 1px solid ${(0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark}40;
        border-radius: 10px 10px 0 0;
        border-bottom: none;
    }
`;
var $67d08281aa8666ad$export$2e2bcd8739ae039 = $67d08281aa8666ad$var$ExpanderCard;











parcelRequire("7fPBF");


const $0cb68ea454bd64de$var$CommandField = ({ value: value, onChange: onChange, onRemove: onRemove, commandType: commandType, startIcon: startIcon, disabled: disabled })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const fallbackIcon = startIcon || (0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)[commandType]?.icon;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6e48650aa2ed148e$export$2e2bcd8739ae039), {
        children: [
            fallbackIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                size: 42,
                name: fallbackIcon
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $00051b104a6506d5$export$43ee9de14381bd97), {
                control: commandType,
                value: value,
                onChange: onChange,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c09a12afb55a78a$export$2e2bcd8739ae039), {
                onClick: onRemove,
                showLabel: false,
                children: t('common:input.remove')
            })
        ]
    });
};
var $0cb68ea454bd64de$export$2e2bcd8739ae039 = $0cb68ea454bd64de$var$CommandField;




var $7fPBF = parcelRequire("7fPBF");














function $0ca5a1e6788dced6$export$5682c366c0c669d9(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiListItem', slot);
}
const $0ca5a1e6788dced6$var$listItemClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiListItem', [
    'root',
    'container',
    'dense',
    'alignItemsFlexStart',
    'divider',
    'gutters',
    'padding',
    'secondaryAction'
]);
var $0ca5a1e6788dced6$export$2e2bcd8739ae039 = $0ca5a1e6788dced6$var$listItemClasses;




function $5af8cd7874d684d8$export$c09531d8563c67a5(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiListItemButton', slot);
}
const $5af8cd7874d684d8$var$listItemButtonClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $5af8cd7874d684d8$export$2e2bcd8739ae039 = $5af8cd7874d684d8$var$listItemButtonClasses;



var $7fPBF = parcelRequire("7fPBF");








function $90836af743b99227$export$ccdb26aeba48a86e(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiListItemSecondaryAction', slot);
}
const $90836af743b99227$var$listItemSecondaryActionClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $90836af743b99227$export$2e2bcd8739ae039 = $90836af743b99227$var$listItemSecondaryActionClasses;



'use client';
const $a4e848490d2ab66f$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $90836af743b99227$export$ccdb26aeba48a86e), classes);
};
const $a4e848490d2ab66f$var$ListItemSecondaryActionRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})({
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.disableGutters,
            style: {
                right: 0
            }
        }
    ]
});
/**
 * Must be used as the last child of ListItem to function properly.
 *
 * @deprecated Use the `secondaryAction` prop in the `ListItem` component instead. This component will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
 */ const $a4e848490d2ab66f$var$ListItemSecondaryAction = /*#__PURE__*/ $7fPBF.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className, ...other } = props;
    const context = $7fPBF.useContext((0, $94e271e17fd22222$export$2e2bcd8739ae039));
    const ownerState = {
        ...props,
        disableGutters: context.disableGutters
    };
    const classes = $a4e848490d2ab66f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a4e848490d2ab66f$var$ListItemSecondaryActionRoot, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
$a4e848490d2ab66f$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $a4e848490d2ab66f$export$2e2bcd8739ae039 = $a4e848490d2ab66f$var$ListItemSecondaryAction;



'use client';
const $2c1b031ce0fa2278$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $2c1b031ce0fa2278$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction'
        ],
        container: [
            'container'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $0ca5a1e6788dced6$export$5682c366c0c669d9), classes);
};
const $2c1b031ce0fa2278$export$aed538f7519abe89 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $2c1b031ce0fa2278$export$4334bb34c76fef24
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
                style: {
                    paddingTop: 8,
                    paddingBottom: 8
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !!ownerState.secondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.secondaryAction,
                style: {
                    [`& > .${(0, $5af8cd7874d684d8$export$2e2bcd8739ae039).root}`]: {
                        paddingRight: 48
                    }
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.button,
                style: {
                    transition: theme.transitions.create('background-color', {
                        duration: theme.transitions.duration.shortest
                    }),
                    '&:hover': {
                        textDecoration: 'none',
                        backgroundColor: (theme.vars || theme).palette.action.hover,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasSecondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            }
        ]
    })));
const $2c1b031ce0fa2278$var$ListItemContainer = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('li', {
    name: 'MuiListItem',
    slot: 'Container',
    overridesResolver: (props, styles)=>styles.container
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $2c1b031ce0fa2278$var$ListItem = /*#__PURE__*/ $7fPBF.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = 'li', ContainerProps: { className: ContainerClassName, ...ContainerProps } = {}, dense: dense = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, secondaryAction: secondaryAction, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const context = $7fPBF.useContext((0, $94e271e17fd22222$export$2e2bcd8739ae039));
    const childContext = $7fPBF.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $7fPBF.useRef(null);
    const children = $7fPBF.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v6, will be removed in v7
    const hasSecondaryAction = children.length && (0, $6926d37cb7ff7774$export$2e2bcd8739ae039)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = {
        ...props,
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction
    };
    const classes = $2c1b031ce0fa2278$var$useUtilityClasses(ownerState);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(listItemRef, ref);
    const Root = slots.root || components.Root || $2c1b031ce0fa2278$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, rootProps.className, className),
        ...other
    };
    let Component = componentProp || 'li';
    // v4 implementation, deprecated in v6, will be removed in v7
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $94e271e17fd22222$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($2c1b031ce0fa2278$var$ListItemContainer, {
                as: ContainerComponent,
                className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState,
                ...ContainerProps,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Root, {
                        ...rootProps,
                        ...!(0, $1a5b8306608cd33a$export$2e2bcd8739ae039)(Root) && {
                            as: Component,
                            ownerState: {
                                ...ownerState,
                                ...rootProps.ownerState
                            }
                        },
                        ...componentProps,
                        children: children
                    }),
                    children.pop()
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $94e271e17fd22222$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(Root, {
            ...rootProps,
            as: Component,
            ref: handleRef,
            ...!(0, $1a5b8306608cd33a$export$2e2bcd8739ae039)(Root) && {
                ownerState: {
                    ...ownerState,
                    ...rootProps.ownerState
                }
            },
            ...componentProps,
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a4e848490d2ab66f$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        })
    });
});
var $2c1b031ce0fa2278$export$2e2bcd8739ae039 = $2c1b031ce0fa2278$var$ListItem;


var $7fPBF = parcelRequire("7fPBF");














'use client';
const $37a9e765f5011e1f$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $37a9e765f5011e1f$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, divider: divider, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            divider && 'divider',
            disabled && 'disabled',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $5af8cd7874d684d8$export$c09531d8563c67a5), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $37a9e765f5011e1f$var$ListItemButtonRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $0820e164eb5fbaff$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiListItemButton',
    slot: 'Root',
    overridesResolver: $37a9e765f5011e1f$export$4334bb34c76fef24
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minWidth: 0,
        boxSizing: 'border-box',
        textAlign: 'left',
        paddingTop: 8,
        paddingBottom: 8,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $5af8cd7874d684d8$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $5af8cd7874d684d8$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $5af8cd7874d684d8$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $5af8cd7874d684d8$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $5af8cd7874d684d8$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            }
        ]
    })));
const $37a9e765f5011e1f$var$ListItemButton = /*#__PURE__*/ $7fPBF.forwardRef(function ListItemButton(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItemButton'
    });
    const { alignItems: alignItems = 'center', autoFocus: autoFocus = false, component: component = 'div', children: children, dense: dense = false, disableGutters: disableGutters = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, selected: selected = false, className: className, ...other } = props;
    const context = $7fPBF.useContext((0, $94e271e17fd22222$export$2e2bcd8739ae039));
    const childContext = $7fPBF.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $7fPBF.useRef(null);
    (0, $cfde3819487a0686$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        divider: divider,
        selected: selected
    };
    const classes = $37a9e765f5011e1f$var$useUtilityClasses(ownerState);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(listItemRef, ref);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $94e271e17fd22222$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($37a9e765f5011e1f$var$ListItemButtonRoot, {
            ref: handleRef,
            href: other.href || other.to,
            component: (other.href || other.to) && component === 'div' ? 'button' : component,
            focusVisibleClassName: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
            ownerState: ownerState,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
            ...other,
            classes: classes,
            children: children
        })
    });
});
var $37a9e765f5011e1f$export$2e2bcd8739ae039 = $37a9e765f5011e1f$var$ListItemButton;


var $7fPBF = parcelRequire("7fPBF");










'use client';
const $9dc4208e00f56723$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $2a8a1c268392e331$export$1061006a0db3aeb5), classes);
};
const $9dc4208e00f56723$var$ListItemTextRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $2a8a1c268392e331$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $2a8a1c268392e331$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})({
    flex: '1 1 auto',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4,
    [`.${(0, $d9914d0380157c73$export$2e2bcd8739ae039).root}:where(& .${(0, $2a8a1c268392e331$export$2e2bcd8739ae039).primary})`]: {
        display: 'block'
    },
    [`.${(0, $d9914d0380157c73$export$2e2bcd8739ae039).root}:where(& .${(0, $2a8a1c268392e331$export$2e2bcd8739ae039).secondary})`]: {
        display: 'block'
    },
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.primary && ownerState.secondary,
            style: {
                marginTop: 6,
                marginBottom: 6
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.inset,
            style: {
                paddingLeft: 56
            }
        }
    ]
});
const $9dc4208e00f56723$var$ListItemText = /*#__PURE__*/ $7fPBF.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const { dense: dense } = $7fPBF.useContext((0, $94e271e17fd22222$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = {
        ...props,
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    };
    const classes = $9dc4208e00f56723$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            primary: primaryTypographyProps,
            secondary: secondaryTypographyProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('root', {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $9dc4208e00f56723$var$ListItemTextRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        ref: ref
    });
    const [PrimarySlot, primarySlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('primary', {
        className: classes.primary,
        elementType: (0, $26f68e516ee75fc4$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SecondarySlot, secondarySlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('secondary', {
        className: classes.secondary,
        elementType: (0, $26f68e516ee75fc4$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    if (primary != null && primary.type !== (0, $26f68e516ee75fc4$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(PrimarySlot, {
        variant: dense ? 'body2' : 'body1',
        component: primarySlotProps?.variant ? undefined : 'span',
        ...primarySlotProps,
        children: primary
    });
    if (secondary != null && secondary.type !== (0, $26f68e516ee75fc4$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(SecondarySlot, {
        variant: "body2",
        color: "textSecondary",
        ...secondarySlotProps,
        children: secondary
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            primary,
            secondary
        ]
    });
});
var $9dc4208e00f56723$export$2e2bcd8739ae039 = $9dc4208e00f56723$var$ListItemText;



parcelRequire("7fPBF");



const $4321e97835f672ea$var$CommandPickerDialog = ({ open: open, onClose: onClose, onCommandTypeSelected: onCommandTypeSelected })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    // write a function to check if the commandType is 'tilt' or 'hotkey' and return true or false
    const isMobileOnly = (commandType)=>{
        return commandType === 'tilt';
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7f096abd658f7c85$export$2e2bcd8739ae039), {
            open: open,
            onClose: onClose,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ac75506ecdb312f1$export$2e2bcd8739ae039), {
                    children: t('common:input.typeLabel')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb70212a09473954$export$2e2bcd8739ae039), {
                    children: (0, $f44f3a5bc46b1c4c$export$6c5a93cb3986a928).map((c, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2c1b031ce0fa2278$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                                onClick: ()=>onCommandTypeSelected(c),
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4321e97835f672ea$var$StyledIcons, {
                                        size: 35,
                                        name: (0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)[c].icon
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                        children: t((0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)[c].title)
                                    }),
                                    isMobileOnly(c) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9926e0d0274623af$export$86956144d6970eff), {
                                        children: t('common:mobileApp.title')
                                    })
                                ]
                            })
                        }, `commandtype-${i}`))
                })
            ]
        })
    });
};
const $4321e97835f672ea$var$StyledIcons = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039))`
    padding-right: 5px;
`;
var $4321e97835f672ea$export$2e2bcd8739ae039 = $4321e97835f672ea$var$CommandPickerDialog;






var $7fPBF = parcelRequire("7fPBF");

function $48f7f3d9d01bd5f7$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [keyToAddCommand, setKeyToAddCommand] = (0, $7fPBF.useState)();
    const [isResetConfirmationOpen, setIsResetConfirmationOpen] = (0, $7fPBF.useState)(false);
    const [resetOption, setResetOption] = (0, $7fPBF.useState)('default');
    const editProfileContainer = (0, $697752726c88b03c$export$2e2bcd8739ae039).useContainer();
    const handleCommandChange = (value, keybind, index)=>{
        keybind.commands[index].command = value;
        editProfileContainer.setHasChanges(true);
        editProfileContainer.updateCommandKeyMappings([
            ...editProfileContainer.commandKeyMappings
        ]);
    };
    const handleRemoveCommand = (command, keybind, index)=>{
        keybind.commands.splice(index, 1);
        editProfileContainer.setHasChanges(true);
        editProfileContainer.updateCommandKeyMappings([
            ...editProfileContainer.commandKeyMappings
        ]);
    };
    const handleAddCommand = (keybind)=>{
        editProfileContainer.setHasChanges(true);
        setKeyToAddCommand(keybind);
    };
    const handleAddCommandWithType = (keybind, commandType)=>{
        setKeyToAddCommand(undefined);
        editProfileContainer.setHasChanges(true);
        keybind.commands.push({
            command: '',
            commandType: commandType
        });
        editProfileContainer.updateCommandKeyMappings([
            ...editProfileContainer.commandKeyMappings
        ]);
    };
    const handleSave = async ()=>{
        const result = await editProfileContainer.saveChanges();
    };
    const handleReset = ()=>{
        if (resetOption === 'default') editProfileContainer.resetKeybindingsToDefault();
        else editProfileContainer.resetKeybindingsToEmpty();
        setIsResetConfirmationOpen(false);
        setResetOption('default');
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                    startIcon: "repeat",
                    disabled: editProfileContainer.isPreview,
                    onClick: ()=>{
                        setResetOption('default');
                        setIsResetConfirmationOpen(true);
                    },
                    children: t('common:keys.reset.title')
                })
            }),
            editProfileContainer?.commandKeyMappings?.map((k, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $67d08281aa8666ad$export$2e2bcd8739ae039), {
                    title: k.displayName ?? k.key,
                    id: k.key,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$1acdcf5a973a8414), {
                            children: t('common:macros.title')
                        }),
                        k.commands?.map((c, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0cb68ea454bd64de$export$2e2bcd8739ae039), {
                                disabled: editProfileContainer.isPreview,
                                value: c.command,
                                commandType: c.commandType,
                                startIcon: (0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)[c.commandType].icon,
                                onChange: (value)=>handleCommandChange(value, k, i),
                                onRemove: ()=>handleRemoveCommand(c.command, k, i)
                            }, i)),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                                startIcon: "plus",
                                disabled: editProfileContainer.isPreview,
                                onClick: ()=>handleAddCommand(k),
                                children: t('common:input.add')
                            })
                        })
                    ]
                }, i)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4321e97835f672ea$export$2e2bcd8739ae039), {
                open: !!keyToAddCommand,
                onClose: ()=>setKeyToAddCommand(undefined),
                onCommandTypeSelected: (commandType)=>{
                    if (keyToAddCommand) handleAddCommandWithType(keyToAddCommand, commandType);
                }
            }),
            editProfileContainer.hasChanges && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $258cb68b976e3a51$export$2e2bcd8739ae039), {
                hasChanges: editProfileContainer.hasChanges,
                setHasChanges: editProfileContainer.setHasChanges,
                onSave: async ()=>{
                    await editProfileContainer.saveChanges();
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$de401b45f203ff7f), {
                contentPosition: "center",
                $visuallyHide: !editProfileContainer.hasChanges && editProfileContainer.id !== undefined,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    $color: "primary",
                    $size: "large",
                    startIcon: "save",
                    onClick: handleSave,
                    children: t('common:saveAndFinish')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
                open: isResetConfirmationOpen,
                onCancel: ()=>{
                    setIsResetConfirmationOpen(false);
                    setResetOption('default');
                },
                onClose: ()=>{
                    setIsResetConfirmationOpen(false);
                    setResetOption('default');
                },
                title: t('common:keys.reset.confirm'),
                description: t('common:keys.reset.confirmDescription'),
                onConfirm: handleReset,
                confirmButtonText: t('common:keys.reset.confirmButton'),
                cancelButtonText: t('common:cancel'),
                confirmIcon: "repeat",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e1f776e3a27ad5dc$export$2e2bcd8739ae039), {
                    name: "resetOption",
                    value: resetOption,
                    onChange: (e)=>setResetOption(e.target.value),
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
                            value: "default",
                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $de28970229c88fa7$export$2e2bcd8739ae039), {}),
                            label: t('common:keys.reset.defaultOption')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
                            value: "empty",
                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $de28970229c88fa7$export$2e2bcd8739ae039), {}),
                            label: t('common:keys.reset.emptyOption')
                        })
                    ]
                })
            })
        ]
    });
}






var $7fPBF = parcelRequire("7fPBF");












function $3347e858a7e1bb40$export$4b135a4b3a6c4550(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiInputAdornment', slot);
}
const $3347e858a7e1bb40$var$inputAdornmentClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $3347e858a7e1bb40$export$2e2bcd8739ae039 = $3347e858a7e1bb40$var$inputAdornmentClasses;



'use client';
var $a1383c8904b71ac9$var$_span;
const $a1383c8904b71ac9$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $a1383c8904b71ac9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $3347e858a7e1bb40$export$4b135a4b3a6c4550), classes);
};
const $a1383c8904b71ac9$var$InputAdornmentRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $a1383c8904b71ac9$var$overridesResolver
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'flex',
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active,
        variants: [
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    [`&.${(0, $3347e858a7e1bb40$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $3347e858a7e1bb40$export$2e2bcd8739ae039).hiddenLabel})`]: {
                        marginTop: 16
                    }
                }
            },
            {
                props: {
                    position: 'start'
                },
                style: {
                    marginRight: 8
                }
            },
            {
                props: {
                    position: 'end'
                },
                style: {
                    marginLeft: 8
                }
            },
            {
                props: {
                    disablePointerEvents: true
                },
                style: {
                    pointerEvents: 'none'
                }
            }
        ]
    })));
const $a1383c8904b71ac9$var$InputAdornment = /*#__PURE__*/ $7fPBF.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp, ...other } = props;
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = {
        ...props,
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    };
    const classes = $a1383c8904b71ac9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f29d66cab44a33c0$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a1383c8904b71ac9$var$InputAdornmentRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref,
            ...other,
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                color: "textSecondary",
                children: children
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $a1383c8904b71ac9$var$_span || ($a1383c8904b71ac9$var$_span = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "notranslate",
                        "aria-hidden": true,
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        })
    });
});
var $a1383c8904b71ac9$export$2e2bcd8739ae039 = $a1383c8904b71ac9$var$InputAdornment;





function $51af5a17187af6b5$var$SearchField({ label: label, placeholder: placeholder = '', value: value = '', onChange: onChange, onClear: onClear }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    label = label || t('common:search');
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($51af5a17187af6b5$var$StyledTextField, {
            onChange: onChange,
            fullWidth: true,
            variant: "outlined",
            placeholder: placeholder,
            label: label,
            value: value,
            InputProps: {
                startAdornment: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a1383c8904b71ac9$export$2e2bcd8739ae039), {
                    position: "start",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                        name: "search",
                        color: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary_updated
                    })
                }),
                endAdornment: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a1383c8904b71ac9$export$2e2bcd8739ae039), {
                    position: "end",
                    children: value && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($51af5a17187af6b5$var$CloseButton, {
                        onClick: onClear,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                            name: "cancel2",
                            ariaLabel: t('common:close')
                        })
                    })
                })
            }
        })
    });
}
const $51af5a17187af6b5$var$StyledTextField = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039))`
    margin: 1rem 0;
    background: ${(props)=>props.theme.color.background};
    input {
        &:focus {
            outline: none;
        }
    }
`;
const $51af5a17187af6b5$var$CloseButton = (0, $8de346382d86c747$export$2e2bcd8739ae039).button`
    background: none;
    border: none;
    color: ${(props)=>props.theme.color.text};
`;
var $51af5a17187af6b5$export$2e2bcd8739ae039 = $51af5a17187af6b5$var$SearchField;





















const $4d0153946beed1fa$var$getJoystickMoveLabel = (event, isLeft)=>{
    let label = '';
    const xValueToCheck = (isLeft ? event.joystickLeftMoveX : event.joystickRightMoveX) ?? 0;
    const yValueToCheck = (isLeft ? event.joystickLeftMoveY : event.joystickRightMoveY) ?? 0;
    // if we have X and Y as non zero add both details to the label
    if (xValueToCheck != 0 && yValueToCheck != 0) label += `${Math.abs(xValueToCheck)}% ${xValueToCheck < 0 ? 'left' : 'right'} and ${Math.abs(yValueToCheck)}% ${yValueToCheck > 0 ? 'up' : 'down'}`;
    else if (xValueToCheck != 0) label += `${Math.abs(xValueToCheck)}% ${xValueToCheck < 0 ? 'left' : 'right'}`;
    else if (yValueToCheck != 0) label += `${Math.abs(yValueToCheck)}% ${yValueToCheck > 0 ? 'up' : 'down'}`;
    return label;
};
const $4d0153946beed1fa$var$getMouseMoveLabel = (event)=>{
    let label = '';
    let mouseEvents = [];
    if (event.mouseMoveX != 0 && event.mouseMoveX !== undefined) {
        const directionX = event.mouseMoveX >= 0 ? 'right' : 'left';
        mouseEvents.push(`${Math.abs(event.mouseMoveX) ?? 0}px ${directionX}`);
    }
    if (event.mouseMoveY != 0 && event.mouseMoveY !== undefined) {
        const directionY = event.mouseMoveY <= 0 ? 'up' : 'down';
        mouseEvents.push(`${Math.abs(event.mouseMoveY) ?? 0}px ${directionY}`);
    }
    label = mouseEvents.join(' and ');
    return label;
};
const $4d0153946beed1fa$var$checkJoystick = (target)=>target !== 0 && target !== undefined && target !== null;
function $4d0153946beed1fa$var$MacroEventDescription({ event: event }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const globalCustomControlsContainer = (0, $b8d2d4cc121e033d$export$2e2bcd8739ae039).useContainer();
    const editProfileContainer = (0, $697752726c88b03c$export$2e2bcd8739ae039).useContainer();
    const locale = editProfileContainer.defaultLocaleRef.current;
    const getDeviceControlDisplayName = (controlId)=>{
        const control = globalCustomControlsContainer.getDeviceControlName(controlId);
        return control;
    };
    const getKeyPressLabel = (event)=>{
        const keys = event.keys?.map((k)=>(0, $9a9874d925dad9cc$export$a23a68036192c276)(k, locale))?.join(" \xb7 ");
        if (event.holdTimeMilliseconds && event.holdTimeMilliseconds > 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce), {
            children: t('common:event.keyPress.pressLabel', 'Press keys', {
                value: keys,
                time: event.holdTimeMilliseconds
            })
        });
        else if (event.isKeyLatch) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce), {
            children: t('common:event.keyPress.latchLabel', 'Latch keys', {
                value: keys
            })
        });
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce), {
            children: t('common:event.keyPress.tapLabel', 'Tap keys', {
                value: keys
            })
        });
    };
    const eventLabels = {
        KeyPress: (event)=>{
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                children: getKeyPressLabel(event)
            });
        },
        KeyRelease: (event)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce), {
                children: t('common:event.keyRelease.label', 'Release', {
                    value: event.keys?.map((k)=>(0, $9a9874d925dad9cc$export$a23a68036192c276)(k, locale))?.join(" \xb7 ")
                })
            }),
        KeyToggle: (event)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce), {
                children: t('common:event.keyToggle.label', 'Toggle', {
                    value: event.keys?.map((k)=>(0, $9a9874d925dad9cc$export$a23a68036192c276)(k, locale))?.join(" \xb7 ")
                })
            }),
        Type: (event)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce), {
                children: t('common:event.type.label', 'Type', {
                    value: event.typedPhrase
                })
            }),
        PlayAudio: (event)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce), {
                children: t('common:event.playAudio.label', 'Speak', {
                    value: event.outputSpeech
                })
            }),
        JoysticksMove: (event)=>{
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            ($4d0153946beed1fa$var$checkJoystick(event.joystickLeftMoveX) || $4d0153946beed1fa$var$checkJoystick(event.joystickLeftMoveY)) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: t('common:event.joystickMove.labelLeft')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("b", {
                                children: $4d0153946beed1fa$var$getJoystickMoveLabel(event, true)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            ($4d0153946beed1fa$var$checkJoystick(event.joystickRightMoveX) || $4d0153946beed1fa$var$checkJoystick(event.joystickRightMoveY)) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: t('common:event.joystickMove.labelRight')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("b", {
                                children: $4d0153946beed1fa$var$getJoystickMoveLabel(event, false)
                            }),
                            event.holdTimeMilliseconds && event.holdTimeMilliseconds > 0 ? ` for ${event.holdTimeMilliseconds} milliseconds` : null
                        ]
                    })
                ]
            });
        },
        MouseMove: (event)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce), {
                children: t('common:event.mouseMove.label', 'Move mouse', {
                    value: $4d0153946beed1fa$var$getMouseMoveLabel(event)
                })
            }),
        Pause: (event)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce), {
                children: t('common:event.pause.label', 'Pause', {
                    value: event.holdTimeMilliseconds
                })
            }),
        StopOutputs: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                children: t('common:event.stopOutputs.label')
            }),
        DeviceTypeCustomAction: (event)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                children: event.deviceTypeCustomActionId && getDeviceControlDisplayName(event.deviceTypeCustomActionId)
            })
    };
    const labelGenerator = eventLabels[event.eventType];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4d0153946beed1fa$var$TextWrap, {
        children: labelGenerator ? labelGenerator(event) : ''
    });
}
const $4d0153946beed1fa$var$TextWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    word-break: break-all; // forces breaks within words if needed
`;
var $4d0153946beed1fa$export$2e2bcd8739ae039 = $4d0153946beed1fa$var$MacroEventDescription;









const $d10a5e3fe02cf217$var$otherEventTypeToIconMap = {
    MouseMove: {
        title: 'Move the mouse',
        icon: 'computerMouse'
    },
    JoysticksMove: {
        title: 'Move the joystick',
        icon: 'joystick'
    },
    PlayAudio: {
        title: 'Speak',
        icon: 'speaker'
    },
    Type: {
        title: 'Type',
        icon: 'keyboard'
    },
    Pause: {
        title: 'Pause',
        icon: 'timer'
    },
    StopOutputs: {
        title: 'Stop All',
        icon: 'stop'
    },
    DeviceTypeCustomAction: {
        title: 'Custom',
        icon: 'hub'
    }
};
function $d10a5e3fe02cf217$export$2e2bcd8739ae039({ event: event, iconSize: iconSize = 28 }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const editProfileContainer = (0, $697752726c88b03c$export$2e2bcd8739ae039).useContainer();
    const locale = editProfileContainer.defaultLocaleRef.current;
    const getOtherView = (step)=>{
        const eventType = step.eventType;
        const eventInfo = $d10a5e3fe02cf217$var$otherEventTypeToIconMap[eventType];
        const { title: title, icon: icon } = eventInfo;
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
            title: title,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d10a5e3fe02cf217$var$SingleStepContainer, {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                    name: icon,
                    size: iconSize
                })
            })
        });
    };
    const getOverflowView = ()=>{
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
            title: t('common:event.expand'),
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d10a5e3fe02cf217$var$SingleStepContainer, {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                    name: "layers",
                    size: iconSize
                })
            })
        });
    };
    const getKeysView = (step)=>{
        let eventTypeDescription;
        if (step.eventType === 'KeyToggle') eventTypeDescription = t('common:event.keyToggle.short');
        else if (step.eventType === 'KeyRelease') eventTypeDescription = t('common:event.keyRelease.short');
        else eventTypeDescription = t('common:event.keyPress.short');
        const keysDescription = step.keys?.map((k)=>(0, $9a9874d925dad9cc$export$a23a68036192c276)(k, locale))?.join(" \xb7 ") ?? '';
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
            title: `${eventTypeDescription} ${keysDescription}`,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d10a5e3fe02cf217$var$SingleStepContainer, {
                children: [
                    step.keys?.slice(0, 2).map((key, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                            name: (0, $9a9874d925dad9cc$export$fbe8b56204f00600)(key, locale),
                            size: iconSize
                        }, index)),
                    step.keys && step.keys.length > 2 && getOverflowView()
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: event?.eventType === 'KeyPress' || event?.eventType == 'KeyRelease' || event?.eventType == 'KeyToggle' ? getKeysView(event) : getOtherView(event)
    });
}
const $d10a5e3fe02cf217$var$SingleStepContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;


function $81c5d0a00b454a03$export$2e2bcd8739ae039({ id: id, macro: macro, showTitle: showTitle = true, children: children, ...restProps }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const getIconsForCommand = (commandType)=>{
        return (0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)[commandType] || null;
    };
    const macroName = macro.name ? macro.name : (0, $9d76aba0a210d2c6$export$61a248617ae833c4)(macro.commands?.[0]?.command, t);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($81c5d0a00b454a03$var$Card, {
        ...restProps,
        id: id,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($81c5d0a00b454a03$var$Content, {
            children: [
                showTitle && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6392222d2b8fb222$export$474db65c3c394e1c), {
                    children: macroName
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($81c5d0a00b454a03$var$SummaryLeft, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($81c5d0a00b454a03$var$SummarySectionText, {
                            children: t('common:when')
                        }),
                        macro.commands?.map((c, i)=>{
                            const icon = getIconsForCommand(c.commandType);
                            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($81c5d0a00b454a03$var$StepWrapperLeft, {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                        size: 32,
                                        name: icon.icon,
                                        ariaLabel: icon.alt
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($81c5d0a00b454a03$var$SummaryDetailText, {
                                        "data-testid": c.command,
                                        children: (0, $9d76aba0a210d2c6$export$a9e54ec0b37334dc)(c.command, t)
                                    })
                                ]
                            }, `mcCommands_${i}`);
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($81c5d0a00b454a03$var$SummaryRight, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($81c5d0a00b454a03$var$SummarySectionText, {
                            children: t('common:thenMacro')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($81c5d0a00b454a03$var$MacroName, {
                            children: [
                                macroName,
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                    name: "logo",
                                    size: 32
                                })
                            ]
                        }),
                        macro.events?.map((e, i)=>{
                            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($81c5d0a00b454a03$var$StepWrapperRight, {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d10a5e3fe02cf217$export$2e2bcd8739ae039), {
                                        event: e,
                                        iconSize: 24
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0153946beed1fa$export$2e2bcd8739ae039), {
                                        event: e
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($81c5d0a00b454a03$var$IconStep, {
                                        name: "downLeftArrow",
                                        size: 18
                                    })
                                ]
                            }, `mcEvents_${i}`);
                        })
                    ]
                }),
                children
            ]
        })
    });
}
const $81c5d0a00b454a03$var$Content = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    margin: auto;
    max-width: 800px;
    align-self: center;
`;
const $81c5d0a00b454a03$var$IconStep = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039))`
    position: relative;
    top: -0.2em;
`;
const $81c5d0a00b454a03$var$MacroName = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $6392222d2b8fb222$export$68ed3e0616d4c778))`
    padding: 0 0 0.5rem 0;
    vertical-align: middle;
    gap: 0.2rem;
    justify-content: right;
    font-weight: 500;
`;
const $81c5d0a00b454a03$var$Card = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $184b8f5fc607fb11$export$eeffb7d514a37123))`
    padding: 0.5rem 2rem 2rem 2rem;
    width: 100%;
`;
const $81c5d0a00b454a03$var$StepWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    vertical-align: middle;
    align-items: center;
    gap: 0.2rem;
    width: 100%;
    padding: 0.2rem 0;
    color: ${(props)=>props.theme.color.text};
`;
const $81c5d0a00b454a03$var$StepWrapperLeft = (0, $8de346382d86c747$export$2e2bcd8739ae039)($81c5d0a00b454a03$var$StepWrapper)`
    justify-content: left;
`;
const $81c5d0a00b454a03$var$StepWrapperRight = (0, $8de346382d86c747$export$2e2bcd8739ae039)($81c5d0a00b454a03$var$StepWrapper)`
    justify-content: right;
`;
const $81c5d0a00b454a03$var$SummaryLeft = (0, $8de346382d86c747$export$2e2bcd8739ae039).div``;
const $81c5d0a00b454a03$var$SummaryRight = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    text-align: right;
`;
const $81c5d0a00b454a03$var$SummarySectionText = (0, $8de346382d86c747$export$2e2bcd8739ae039).p`
    margin: 1em 0 0.5em;
    font-size: ${(0, $8951886a6b49e92a$export$7536ca5ba8ef94f0).default};
    font-weight: lighter;
`;
const $81c5d0a00b454a03$var$SummaryDetailText = (0, $8de346382d86c747$export$2e2bcd8739ae039).p`
    white-space: pre-wrap;
`;



const $2169ab088e8080bb$export$54c2e3dc7acea9f5 = (0, $8de346382d86c747$export$2e2bcd8739ae039).ul`
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
`;
const $2169ab088e8080bb$export$a4164a4373c4965b = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    font-style: italic;
    font-weight: 300;
    grid-column: 1 / span 2;
    padding: 1rem;
    text-align: center;
`;
const $2169ab088e8080bb$export$7c6e2c02157bb7d2 = (0, $8de346382d86c747$export$2e2bcd8739ae039).td`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    :nth-of-type(even) {
        grid-column: 2;
        justify-content: flex-end;
        text-align: right;
    }
    :nth-of-type(odd) {
        grid-column: 1;
        justify-content: flex-start;
        text-align: left;
    }
`;
const $2169ab088e8080bb$export$54ec01a60f47d33d = (0, $8de346382d86c747$export$2e2bcd8739ae039).table`
    width: 100%;
`;
const $2169ab088e8080bb$export$204d9105ce9ffb5d = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$45814810f7000d9e))`
    text-align: inherit;
`;
const $2169ab088e8080bb$export$67152d26d4f56ee8 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $184b8f5fc607fb11$export$eeffb7d514a37123))`
    align-items: center;
    display: flex;
    flex-direction: column;
    margin: 0 1rem;
    max-width: 800px;
    width: calc(100% - 2rem);
    padding: 40px;
`;
const $2169ab088e8080bb$export$3122aab815c89f9a = (0, $8de346382d86c747$export$2e2bcd8739ae039).tr`
    display: grid;
    gap: 1rem;
    grid-template-columns: auto auto;
    padding: 1rem 0;
    width: 100%;
    :not(:only-child):not(:last-child) {
        border-bottom: solid 1px ${(0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark}20;
    }
`;
const $2169ab088e8080bb$export$12253aa05c1176e2 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    margin: 1rem;
    display: flex;
    width: calc(100% - 2rem);
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    padding-bottom: 1rem;
`;
const $2169ab088e8080bb$export$f2170af9598ce20e = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $81c5d0a00b454a03$export$2e2bcd8739ae039))`
    background-color: ${(props)=>props.theme.color.accentCard};
    box-shadow: none;
    border-top: none !important;
`;









var $7fPBF = parcelRequire("7fPBF");







const $0b0745218a11d1f7$var$getIconsForCommand = (commandType)=>{
    return (0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)[commandType] || null;
};
function $0b0745218a11d1f7$export$2e2bcd8739ae039({ commands: commands, ...restProps }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    //Dedupe command types for icons
    const uniqueCommandTypesArray = [
        ...new Set(commands.map(({ commandType: commandType })=>commandType))
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0b0745218a11d1f7$var$IconContainer, {
        ...restProps,
        children: uniqueCommandTypesArray.map((c, i)=>{
            const command = $0b0745218a11d1f7$var$getIconsForCommand(c);
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                title: t('common:input.toolTip', 'This uses inputs', {
                    alt: command.alt
                }),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0b0745218a11d1f7$var$IconHover, {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                        name: command.icon,
                        ariaLabel: command.alt,
                        size: 34
                    })
                })
            }, `mcPreview_${i}`);
        })
    });
}
const $0b0745218a11d1f7$var$IconContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    margin-right: auto;
    padding: 0.5rem 0;
    left: 1rem;
`;
const $0b0745218a11d1f7$var$IconHover = (0, $8de346382d86c747$export$2e2bcd8739ae039).div``;







var $7fPBF = parcelRequire("7fPBF");


// TODO: mave OverflowView a component shared with MacroStepIcons possibly unify with getOtherView
const $e12bbab59ef21f05$var$MacroPreviewIcons = ({ macro: macro })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const getOverflowView = ()=>{
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
            title: t('common:event.expand'),
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e12bbab59ef21f05$var$SingleStepContainer, {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                    name: "layers"
                })
            })
        });
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($e12bbab59ef21f05$var$IconContainerView, {
        children: [
            macro?.events?.slice(0, 2).map((event, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fPBF.Fragment), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d10a5e3fe02cf217$export$2e2bcd8739ae039), {
                        event: event
                    })
                }, index)),
            macro?.events?.length > 2 && getOverflowView()
        ]
    });
};
const $e12bbab59ef21f05$var$SingleStepContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;
const $e12bbab59ef21f05$var$IconContainerView = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    position: absolute;
    right: 24px;
    left: auto;

    img {
        width: 32px;
        margin: 0 2px;
    }
`;
var $e12bbab59ef21f05$export$2e2bcd8739ae039 = $e12bbab59ef21f05$var$MacroPreviewIcons;


//TODO: update to properly announce expanded state to SR https://www.w3.org/WAI/ARIA/apg/patterns/accordion/examples/accordion/
function $cfa8aa82a863cabd$var$MacroExpanderCard({ id: id, macro: macro, startExpanded: startExpanded, alwaysShowIcons: alwaysShowIcons = true, children: children }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [isExpanded, setIsExpanded] = (0, $7fPBF.useState)(startExpanded);
    const iconShow = alwaysShowIcons === true ? false : isExpanded;
    const macroName = macro.name ? macro.name : (0, $9d76aba0a210d2c6$export$61a248617ae833c4)(macro.commands?.[0]?.command, t);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($cfa8aa82a863cabd$var$WrapperMacro, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($cfa8aa82a863cabd$var$WrapperButton, {
                id: id,
                onClick: ()=>setIsExpanded(!isExpanded),
                "aria-pressed": isExpanded,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($cfa8aa82a863cabd$export$2061af696e09df60, {
                    "data-expanded": isExpanded,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($cfa8aa82a863cabd$var$StyledMacroCommandPreview, {
                            "data-expanded": iconShow,
                            commands: macro.commands,
                            iconSize: 32
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$2c65789109b698b0), {
                            children: macroName
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e12bbab59ef21f05$export$2e2bcd8739ae039), {
                            macro: macro
                        })
                    ]
                })
            }),
            isExpanded && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($cfa8aa82a863cabd$var$ExpandedSection, {
                children: children
            })
        ]
    });
}
const $cfa8aa82a863cabd$var$WrapperMacro = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    width: 100%;
`;
const $cfa8aa82a863cabd$var$WrapperButton = (0, $8de346382d86c747$export$2e2bcd8739ae039).button`
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    position: relative;
    width: 100%;
`;
const $cfa8aa82a863cabd$var$StyledMacroCommandPreview = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $0b0745218a11d1f7$export$2e2bcd8739ae039))`
    position: absolute;
    left: 24px;
    &[data-expanded='true'] {
        border: none;
        display: none;
    }
`;
const $cfa8aa82a863cabd$var$ExpandedSection = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${(props)=>props.theme.color.accentCard};
    animation: all 0.5s ease-in-out;
    border: 1px solid ${(0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark}40;
    border-top: none;
    border-radius: 0 0 10px 10px;
    margin-top: -0.5rem;
    width: 100%;
`;
const $cfa8aa82a863cabd$export$2061af696e09df60 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    box-shadow: none;
    border: 1px solid ${(0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark}40;
    border-radius: 10px;
    width: 100%;
    z-index: 100;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    min-width: 380px;
    padding: 16px;
    background-color: ${(props)=>props.theme.color.accentCard};
    color: ${(props)=>props.theme.color.text};
    &[data-expanded='true'] {
        box-shadow: none;
        border: 1px solid ${(0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark}40;
        border-bottom: none !important;
        border-radius: 10px 10px 0 0;
    }
    :hover {
        background-color: ${(props)=>props.theme.color.accent}40;
        text-decoration: underline;
    }
`;
var $cfa8aa82a863cabd$export$2e2bcd8739ae039 = $cfa8aa82a863cabd$var$MacroExpanderCard;


function $031c6e7d94ce0aa0$var$MacroListing({ macros: macros, startExpanded: startExpanded = false }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return macros && macros.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$12253aa05c1176e2), {
        children: macros.map((macro, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cfa8aa82a863cabd$export$2e2bcd8739ae039), {
                macro: macro,
                startExpanded: startExpanded,
                id: macro.id,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$f2170af9598ce20e), {
                    macro: macro,
                    showTitle: false
                })
            }, `macro_${i}`))
    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$a4164a4373c4965b), {
        children: t('common:macroEmpty')
    });
}
var $031c6e7d94ce0aa0$export$2e2bcd8739ae039 = $031c6e7d94ce0aa0$var$MacroListing;








function $c0e241dbffe40cae$var$AssociatedProgramsListing({ programNames: programNames, profileName: profileName, showDescription: showDescription = true }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$67152d26d4f56ee8), {
        children: programNames.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6392222d2b8fb222$export$2d914cb1a3b0bf58), {
                    children: t('common:profile.autoProfileSwitching.associatedPrograms.title', '', {
                        profileName: profileName
                    })
                }),
                showDescription && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                    children: t('common:profile.autoProfileSwitching.associatedPrograms.description.short')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$45814810f7000d9e), {
                    children: t('common:profile.autoProfileSwitching.associatedPrograms.when', `Cephable will automatically switch my profile to ${profileName} when I use...`, {
                        profileName: profileName
                    })
                }),
                programNames.map((name, i)=>{
                    if (name === '') return null;
                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$3122aab815c89f9a), {
                        as: "span",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                            as: "span",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                    name: "virtualApps",
                                    size: 24,
                                    ariaLabel: t('common:profile.autoProfileSwitching.associatedPrograms.title')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    children: name
                                })
                            ]
                        })
                    }, `associated_program_${i}`);
                })
            ]
        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$a4164a4373c4965b), {
            children: t('common:profile.autoProfileSwitching.associatedPrograms.emptySearch')
        })
    });
}
var $c0e241dbffe40cae$export$2e2bcd8739ae039 = $c0e241dbffe40cae$var$AssociatedProgramsListing;










function $d1f6ba63b9e90a78$var$DictationListing({ dictationCommands: dictationCommands, showDescription: showDescription = true }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const icon = (0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)['dictation'];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$67152d26d4f56ee8), {
        children: dictationCommands.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6392222d2b8fb222$export$2d914cb1a3b0bf58), {
                    children: t('common:dictation.title')
                }),
                showDescription && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                    children: t('common:dictation.description')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$54ec01a60f47d33d), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$3122aab815c89f9a), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                        as: "th",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$204d9105ce9ffb5d), {
                                            children: t('common:voice.when')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                        as: "th",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$204d9105ce9ffb5d), {
                                            children: t('common:dictation.thenMacro')
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("tbody", {
                            children: dictationCommands.map((command, i)=>{
                                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$3122aab815c89f9a), {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                    name: icon.icon,
                                                    size: 24,
                                                    ariaLabel: t(icon.title)
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    children: command
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d1f6ba63b9e90a78$var$Transcribe, {
                                                    children: t('common:dictation.type')
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                    name: "keyboard",
                                                    size: 24,
                                                    ariaLabel: t('common:steps')
                                                })
                                            ]
                                        })
                                    ]
                                }, `commandKeyMappings_${i}_${command}`);
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$a4164a4373c4965b), {
            children: t('common:dictation.empty')
        })
    });
}
const $d1f6ba63b9e90a78$var$Transcribe = (0, $8de346382d86c747$export$2e2bcd8739ae039).p`
    font-weight: 100;
    font-style: italic;
`;
var $d1f6ba63b9e90a78$export$2e2bcd8739ae039 = $d1f6ba63b9e90a78$var$DictationListing;









function $4bb13f250ef3167a$var$HotkeysListing({ hotkeys: hotkeys, showDescription: showDescription = true }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$67152d26d4f56ee8), {
        children: hotkeys.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6392222d2b8fb222$export$2d914cb1a3b0bf58), {
                    children: t('common:hotkey.titlePlural')
                }),
                showDescription && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                    children: t('common:hotkey.description')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$54ec01a60f47d33d), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$3122aab815c89f9a), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                        as: "th",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$204d9105ce9ffb5d), {
                                            children: t('common:hotkey.when')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                        as: "th",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$204d9105ce9ffb5d), {
                                            children: t('common:thenMacro')
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("tbody", {
                            children: hotkeys.map((hotkey, i)=>{
                                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$3122aab815c89f9a), {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                    name: "virtualButton",
                                                    size: 24,
                                                    ariaLabel: t('common:hotkey.title')
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    children: hotkey.displayName
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4bb13f250ef3167a$var$MacroTitle, {
                                                    children: hotkey.macroName ? hotkey.macroName : hotkey.command
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                    name: "logo",
                                                    size: 24,
                                                    ariaLabel: t('common:steps')
                                                })
                                            ]
                                        })
                                    ]
                                }, `hotkey_${i}`);
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$a4164a4373c4965b), {
            children: t('common:hotkey.emptySearch')
        })
    });
}
const $4bb13f250ef3167a$var$MacroTitle = (0, $8de346382d86c747$export$2e2bcd8739ae039).p`
    text-transform: capitalize;
`;
var $4bb13f250ef3167a$export$2e2bcd8739ae039 = $4bb13f250ef3167a$var$HotkeysListing;










function $51f16c3433a05d99$var$KeyCommandListing({ commandKeyMappings: commandKeyMappings, showDescription: showDescription = true }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$67152d26d4f56ee8), {
        children: commandKeyMappings.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6392222d2b8fb222$export$2d914cb1a3b0bf58), {
                    children: t('common:keys.title')
                }),
                showDescription && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                    children: t('common:keys.description')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$54ec01a60f47d33d), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$3122aab815c89f9a), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                        as: "th",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$204d9105ce9ffb5d), {
                                            children: t('common:when')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                        as: "th",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$204d9105ce9ffb5d), {
                                            children: t('common:keys.then')
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("tbody", {
                            children: commandKeyMappings.map((e, i)=>{
                                const commands = e.commands;
                                return commands.map((c, commandId)=>{
                                    const icon = (0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)[c.commandType];
                                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$3122aab815c89f9a), {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                        name: icon.icon,
                                                        size: 24,
                                                        ariaLabel: t(icon.title)
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        children: (0, $9d76aba0a210d2c6$export$a9e54ec0b37334dc)(c.command, t)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        children: e.displayName
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                        name: e.icon,
                                                        size: 24,
                                                        ariaLabel: t('common:steps')
                                                    })
                                                ]
                                            })
                                        ]
                                    }, `commandKeyMappings_${i}_${commandId}`);
                                });
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$a4164a4373c4965b), {
            children: t('common:keys.empty')
        })
    });
}
var $51f16c3433a05d99$export$2e2bcd8739ae039 = $51f16c3433a05d99$var$KeyCommandListing;










function $c8ea9f037cb7aa38$var$TalkbackListing({ audioEvents: audioEvents, showDescription: showDescription = true }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$67152d26d4f56ee8), {
        children: audioEvents.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6392222d2b8fb222$export$2d914cb1a3b0bf58), {
                    children: t('common:talkback.title')
                }),
                showDescription && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                    children: t('common:talkback.description')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$54ec01a60f47d33d), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$3122aab815c89f9a), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                        as: "th",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$204d9105ce9ffb5d), {
                                            children: t('common:when')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                        as: "th",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$204d9105ce9ffb5d), {
                                            children: t('common:talkback.thenMacro')
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("tbody", {
                            children: audioEvents.map((e, i)=>{
                                const commands = e.commands;
                                return commands.map((c, commandId)=>{
                                    const icon = (0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)[c.commandType];
                                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$3122aab815c89f9a), {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                        name: icon.icon,
                                                        size: 24,
                                                        ariaLabel: t(icon.title)
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        children: (0, $9d76aba0a210d2c6$export$a9e54ec0b37334dc)(c.command, t)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        children: e.outputSpeech
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                        name: "speaker",
                                                        size: 24,
                                                        ariaLabel: t('common:steps')
                                                    })
                                                ]
                                            })
                                        ]
                                    }, `audioEvents_${i}_${commandId}`);
                                });
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$a4164a4373c4965b), {
            children: t('common:talkback.empty')
        })
    });
}
var $c8ea9f037cb7aa38$export$2e2bcd8739ae039 = $c8ea9f037cb7aa38$var$TalkbackListing;





var $7fPBF = parcelRequire("7fPBF");


let $7ac5e11d07b654ce$var$lastShareCode = null;
let $7ac5e11d07b654ce$var$lastShareProfileId = null;
let $7ac5e11d07b654ce$var$lastProfileId = null;
function $7ac5e11d07b654ce$export$2e2bcd8739ae039({ isDeepLink: isDeepLink = false }) {
    const { shareCode: shareCode, profileId: profileId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const editProfileContainer = (0, $697752726c88b03c$export$2e2bcd8739ae039).useContainer();
    const [filter, setFilter] = (0, $7fPBF.useState)('');
    const [loadingError, setLoadingError] = (0, $7fPBF.useState)(false);
    const { allProfilesRef: allProfilesRef } = (0, $60065a32b4a31650$export$2e2bcd8739ae039).useContainer();
    const filteredMacros = (0, $7fPBF.useMemo)(()=>{
        if (loadingError) return [];
        return editProfileContainer.macros.filter((m)=>{
            const macroName = m.name?.toLowerCase() || t('common:noName');
            const commandMatches = m.commands?.some((c)=>c.command.toLowerCase().includes(filter));
            return commandMatches || macroName.includes(filter) || !filter;
        });
    }, [
        filter,
        editProfileContainer.macros,
        loadingError,
        t
    ]);
    const filteredHotkeys = (0, $7fPBF.useMemo)(()=>{
        if (loadingError) return [];
        return editProfileContainer.hotkeys.filter((h)=>{
            const hotkeyName = h.displayName?.toLowerCase().includes(filter);
            const hotkeyCommandMatches = h.command?.toLowerCase().includes(filter);
            return hotkeyCommandMatches || hotkeyName || !filter;
        });
    }, [
        filter,
        editProfileContainer.hotkeys,
        loadingError
    ]);
    const filteredTalkback = (0, $7fPBF.useMemo)(()=>{
        if (loadingError) return [];
        return editProfileContainer.audioEvents.filter((a)=>{
            const talkbackName = a.outputSpeech?.toLowerCase().includes(filter);
            const talkbackCommandMatches = a.commands?.some((c)=>c.command.toLowerCase().includes(filter));
            return talkbackCommandMatches || talkbackName || !filter;
        });
    }, [
        filter,
        editProfileContainer.audioEvents,
        loadingError
    ]);
    const filteredDictation = (0, $7fPBF.useMemo)(()=>{
        if (loadingError) return [];
        return editProfileContainer.dictationCommands.filter((d)=>{
            const dictationName = d?.toLowerCase().includes(filter);
            return dictationName || !filter;
        });
    }, [
        filter,
        editProfileContainer.dictationCommands,
        loadingError
    ]);
    const filteredKeyCommands = (0, $7fPBF.useMemo)(()=>{
        if (loadingError) return [];
        return editProfileContainer.commandKeyMappings.filter((k)=>{
            const keyCommandName = k.displayName?.toLowerCase().includes(filter);
            const keyCommandCommandMatches = k.commands?.some((c)=>c.command.toLowerCase().includes(filter));
            return keyCommandCommandMatches || keyCommandName || !filter;
        });
    }, [
        filter,
        editProfileContainer.commandKeyMappings,
        loadingError
    ]);
    const handleSearchChange = (e)=>{
        const query = e.target.value;
        setFilter(query);
    };
    const handleClearSearch = ()=>{
        setFilter('');
    };
    (0, $7fPBF.useEffect)(()=>{
        if ($7ac5e11d07b654ce$var$lastShareCode === shareCode && shareCode != null && $7ac5e11d07b654ce$var$lastShareProfileId === editProfileContainer.idRef.current) return;
        if ($7ac5e11d07b654ce$var$lastProfileId === profileId && profileId != null && !shareCode) return;
        $7ac5e11d07b654ce$var$lastShareCode = shareCode ?? null;
        $7ac5e11d07b654ce$var$lastProfileId = profileId ?? null;
        const loadProfile = async ()=>{
            editProfileContainer.setIsPreview(true);
            if (shareCode) {
                const result = await editProfileContainer.loadPreview(shareCode);
                if (result.resultType !== 'Ok') {
                    editProfileContainer.setDefaultProfile('en-US');
                    setLoadingError(true);
                }
                $7ac5e11d07b654ce$var$lastShareProfileId = result.data?.id ?? null;
            } else if (profileId) {
                const profile = allProfilesRef.current.find((p)=>p.id === profileId);
                if (profile) editProfileContainer.updateProfileState({
                    ...profile,
                    userId: undefined
                });
                else editProfileContainer.loadPublicPreview(profileId);
                $7ac5e11d07b654ce$var$lastShareProfileId = null;
            }
        };
        loadProfile();
    }, [
        profileId,
        shareCode
    ]);
    function hasKeyCommands(commandKeyMappings) {
        return commandKeyMappings.some((item)=>item.commands.length > 0);
    }
    if (loadingError) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
            children: t('common:profile.previewLoadError')
        })
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $51af5a17187af6b5$export$2e2bcd8739ae039), {
                value: filter,
                onChange: handleSearchChange,
                onClear: handleClearSearch
            }),
            editProfileContainer.macros.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $031c6e7d94ce0aa0$export$2e2bcd8739ae039), {
                macros: filteredMacros
            }),
            editProfileContainer.hotkeys.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4bb13f250ef3167a$export$2e2bcd8739ae039), {
                hotkeys: filteredHotkeys
            }),
            editProfileContainer.audioEvents.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c8ea9f037cb7aa38$export$2e2bcd8739ae039), {
                audioEvents: filteredTalkback
            }),
            editProfileContainer.dictationCommands.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d1f6ba63b9e90a78$export$2e2bcd8739ae039), {
                dictationCommands: filteredDictation
            }),
            hasKeyCommands(editProfileContainer.commandKeyMappings) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $51f16c3433a05d99$export$2e2bcd8739ae039), {
                commandKeyMappings: filteredKeyCommands
            }),
            editProfileContainer.associatedPrograms.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c0e241dbffe40cae$export$2e2bcd8739ae039), {
                profileName: editProfileContainer.name,
                programNames: editProfileContainer.associatedPrograms
            })
        ]
    });
}








var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");
var $1bfc5778dcd4841a$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bfc5778dcd4841a$var$ReactIs, $1bfc5778dcd4841a$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$1bfc5778dcd4841a$exports = (parcelRequire("iDep4"))();




const $c597a968c23d62fb$var$refType = (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object
]);
var $c597a968c23d62fb$export$2e2bcd8739ae039 = $c597a968c23d62fb$var$refType;



const $e85b1ef30fae45b1$export$f07872cd524bec98 = (views, expectedViews)=>{
    if (views.length !== expectedViews.length) return false;
    return expectedViews.every((expectedView)=>views.includes(expectedView));
};
const $e85b1ef30fae45b1$export$bdf8d867ddc968e = ({ openTo: openTo, defaultOpenTo: defaultOpenTo, views: views, defaultViews: defaultViews })=>{
    const viewsWithDefault = views ?? defaultViews;
    let openToWithDefault;
    if (openTo != null) openToWithDefault = openTo;
    else if (viewsWithDefault.includes(defaultOpenTo)) openToWithDefault = defaultOpenTo;
    else if (viewsWithDefault.length > 0) openToWithDefault = viewsWithDefault[0];
    else throw new Error('MUI X: The `views` prop must contain at least one view.');
    return {
        views: viewsWithDefault,
        openTo: openToWithDefault
    };
};


const $4d1fa529a9a32e76$export$a98b123b8f29e004 = (utils, dateParam, timeParam)=>{
    let mergedDate = dateParam;
    mergedDate = utils.setHours(mergedDate, utils.getHours(timeParam));
    mergedDate = utils.setMinutes(mergedDate, utils.getMinutes(timeParam));
    mergedDate = utils.setSeconds(mergedDate, utils.getSeconds(timeParam));
    mergedDate = utils.setMilliseconds(mergedDate, utils.getMilliseconds(timeParam));
    return mergedDate;
};
const $4d1fa529a9a32e76$export$ca1f317ae8db2ee8 = ({ date: date, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, isDateDisabled: isDateDisabled, utils: utils, timezone: timezone })=>{
    const today = $4d1fa529a9a32e76$export$a98b123b8f29e004(utils, utils.date(undefined, timezone), date);
    if (disablePast && utils.isBefore(minDate, today)) minDate = today;
    if (disableFuture && utils.isAfter(maxDate, today)) maxDate = today;
    let forward = date;
    let backward = date;
    if (utils.isBefore(date, minDate)) {
        forward = minDate;
        backward = null;
    }
    if (utils.isAfter(date, maxDate)) {
        if (backward) backward = maxDate;
        forward = null;
    }
    while(forward || backward){
        if (forward && utils.isAfter(forward, maxDate)) forward = null;
        if (backward && utils.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!isDateDisabled(forward)) return forward;
            forward = utils.addDays(forward, 1);
        }
        if (backward) {
            if (!isDateDisabled(backward)) return backward;
            backward = utils.addDays(backward, -1);
        }
    }
    return null;
};
const $4d1fa529a9a32e76$export$36ca889e039badd5 = (utils, value)=>value == null || !utils.isValid(value) ? null : value;
const $4d1fa529a9a32e76$export$eb73579ccade48fd = (utils, value, defaultValue)=>{
    if (value == null || !utils.isValid(value)) return defaultValue;
    return value;
};
const $4d1fa529a9a32e76$export$8fabf9a4cbada414 = (utils, a, b)=>{
    if (!utils.isValid(a) && a != null && !utils.isValid(b) && b != null) return true;
    return utils.isEqual(a, b);
};
const $4d1fa529a9a32e76$export$62591b96a734eacd = (utils, year)=>{
    const firstMonth = utils.startOfYear(year);
    const months = [
        firstMonth
    ];
    while(months.length < 12){
        const prevMonth = months[months.length - 1];
        months.push(utils.addMonths(prevMonth, 1));
    }
    return months;
};
const $4d1fa529a9a32e76$export$1118e4272ea1e258 = (utils, timezone, valueType)=>valueType === 'date' ? utils.startOfDay(utils.date(undefined, timezone)) : utils.date(undefined, timezone);
const $4d1fa529a9a32e76$export$fae94c0a662107ef = (utils, meridiem)=>{
    const date = utils.setHours(utils.date(), meridiem === 'am' ? 2 : 14);
    return utils.format(date, 'meridiem');
};
const $4d1fa529a9a32e76$var$dateViews = [
    'year',
    'month',
    'day'
];
const $4d1fa529a9a32e76$export$b32dfef9f07dea64 = (view)=>$4d1fa529a9a32e76$var$dateViews.includes(view);
const $4d1fa529a9a32e76$export$bb1c921f313ec928 = (utils, { format: format, views: views }, isInToolbar)=>{
    if (format != null) return format;
    const formats = utils.formats;
    if ((0, $e85b1ef30fae45b1$export$f07872cd524bec98)(views, [
        'year'
    ])) return formats.year;
    if ((0, $e85b1ef30fae45b1$export$f07872cd524bec98)(views, [
        'month'
    ])) return formats.month;
    if ((0, $e85b1ef30fae45b1$export$f07872cd524bec98)(views, [
        'day'
    ])) return formats.dayOfMonth;
    if ((0, $e85b1ef30fae45b1$export$f07872cd524bec98)(views, [
        'month',
        'year'
    ])) return `${formats.month} ${formats.year}`;
    if ((0, $e85b1ef30fae45b1$export$f07872cd524bec98)(views, [
        'day',
        'month'
    ])) return `${formats.month} ${formats.dayOfMonth}`;
    if (isInToolbar) // Little localization hack (Google is doing the same for android native pickers):
    // For english localization it is convenient to include weekday into the date "Mon, Jun 1".
    // For other locales using strings like "June 1", without weekday.
    return /en/.test(utils.getCurrentLocaleCode()) ? formats.normalDateWithWeekday : formats.normalDate;
    return formats.keyboardDate;
};
const $4d1fa529a9a32e76$export$24c38139da66592d = (utils, date)=>{
    const start = utils.startOfWeek(date);
    return [
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ].map((diff)=>utils.addDays(start, diff));
};



const $cd9924d2cafbe16d$var$timeViews = [
    'hours',
    'minutes',
    'seconds'
];
const $cd9924d2cafbe16d$export$8f04d380cefd5a0d = (view)=>$cd9924d2cafbe16d$var$timeViews.includes(view);
const $cd9924d2cafbe16d$export$a3328136ac50623d = (view)=>$cd9924d2cafbe16d$var$timeViews.includes(view) || view === 'meridiem';
const $cd9924d2cafbe16d$export$c3352ead7b032236 = (date, utils)=>{
    if (!date) return null;
    return utils.getHours(date) >= 12 ? 'pm' : 'am';
};
const $cd9924d2cafbe16d$export$4159dc823695870e = (value, meridiem, ampm)=>{
    if (ampm) {
        const currentMeridiem = value >= 12 ? 'pm' : 'am';
        if (currentMeridiem !== meridiem) return meridiem === 'am' ? value - 12 : value + 12;
    }
    return value;
};
const $cd9924d2cafbe16d$export$c368d4ff66779998 = (time, meridiem, ampm, utils)=>{
    const newHoursAmount = $cd9924d2cafbe16d$export$4159dc823695870e(utils.getHours(time), meridiem, ampm);
    return utils.setHours(time, newHoursAmount);
};
const $cd9924d2cafbe16d$export$888a1ce13aa61986 = (date, utils)=>{
    return utils.getHours(date) * 3600 + utils.getMinutes(date) * 60 + utils.getSeconds(date);
};
const $cd9924d2cafbe16d$export$fb87c80b35a46b89 = (disableIgnoringDatePartForTimeValidation, utils)=>(dateLeft, dateRight)=>{
        if (disableIgnoringDatePartForTimeValidation) return utils.isAfter(dateLeft, dateRight);
        return $cd9924d2cafbe16d$export$888a1ce13aa61986(dateLeft, utils) > $cd9924d2cafbe16d$export$888a1ce13aa61986(dateRight, utils);
    };
const $cd9924d2cafbe16d$export$3a6776b3863772fe = (utils, { format: format, views: views, ampm: ampm })=>{
    if (format != null) return format;
    const formats = utils.formats;
    if ((0, $e85b1ef30fae45b1$export$f07872cd524bec98)(views, [
        'hours'
    ])) return ampm ? `${formats.hours12h} ${formats.meridiem}` : formats.hours24h;
    if ((0, $e85b1ef30fae45b1$export$f07872cd524bec98)(views, [
        'minutes'
    ])) return formats.minutes;
    if ((0, $e85b1ef30fae45b1$export$f07872cd524bec98)(views, [
        'seconds'
    ])) return formats.seconds;
    if ((0, $e85b1ef30fae45b1$export$f07872cd524bec98)(views, [
        'minutes',
        'seconds'
    ])) return `${formats.minutes}:${formats.seconds}`;
    if ((0, $e85b1ef30fae45b1$export$f07872cd524bec98)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) return ampm ? `${formats.hours12h}:${formats.minutes}:${formats.seconds} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}:${formats.seconds}`;
    return ampm ? `${formats.hours12h}:${formats.minutes} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}`;
};



const $03cf12356675f79b$export$8f74e8f4ed8ae0ac = {
    year: 1,
    month: 2,
    day: 3,
    hours: 4,
    minutes: 5,
    seconds: 6,
    milliseconds: 7
};
const $03cf12356675f79b$export$3f2547ddf892237a = (sections)=>Math.max(...sections.map((section)=>$03cf12356675f79b$export$8f74e8f4ed8ae0ac[section.type] ?? 1));
const $03cf12356675f79b$var$roundDate = (utils, granularity, date)=>{
    if (granularity === $03cf12356675f79b$export$8f74e8f4ed8ae0ac.year) return utils.startOfYear(date);
    if (granularity === $03cf12356675f79b$export$8f74e8f4ed8ae0ac.month) return utils.startOfMonth(date);
    if (granularity === $03cf12356675f79b$export$8f74e8f4ed8ae0ac.day) return utils.startOfDay(date);
    // We don't have startOfHour / startOfMinute / startOfSecond
    let roundedDate = date;
    if (granularity < $03cf12356675f79b$export$8f74e8f4ed8ae0ac.minutes) roundedDate = utils.setMinutes(roundedDate, 0);
    if (granularity < $03cf12356675f79b$export$8f74e8f4ed8ae0ac.seconds) roundedDate = utils.setSeconds(roundedDate, 0);
    if (granularity < $03cf12356675f79b$export$8f74e8f4ed8ae0ac.milliseconds) roundedDate = utils.setMilliseconds(roundedDate, 0);
    return roundedDate;
};
const $03cf12356675f79b$export$6a31d56794238e4e = ({ props: props, utils: utils, granularity: granularity, timezone: timezone, getTodayDate: inGetTodayDate })=>{
    let referenceDate = inGetTodayDate ? inGetTodayDate() : $03cf12356675f79b$var$roundDate(utils, granularity, (0, $4d1fa529a9a32e76$export$1118e4272ea1e258)(utils, timezone));
    if (props.minDate != null && utils.isAfterDay(props.minDate, referenceDate)) referenceDate = $03cf12356675f79b$var$roundDate(utils, granularity, props.minDate);
    if (props.maxDate != null && utils.isBeforeDay(props.maxDate, referenceDate)) referenceDate = $03cf12356675f79b$var$roundDate(utils, granularity, props.maxDate);
    const isAfter = (0, $cd9924d2cafbe16d$export$fb87c80b35a46b89)(props.disableIgnoringDatePartForTimeValidation ?? false, utils);
    if (props.minTime != null && isAfter(props.minTime, referenceDate)) referenceDate = $03cf12356675f79b$var$roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.minTime : (0, $4d1fa529a9a32e76$export$a98b123b8f29e004)(utils, referenceDate, props.minTime));
    if (props.maxTime != null && isAfter(referenceDate, props.maxTime)) referenceDate = $03cf12356675f79b$var$roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.maxTime : (0, $4d1fa529a9a32e76$export$a98b123b8f29e004)(utils, referenceDate, props.maxTime));
    return referenceDate;
};



const $7692508c11d587c8$export$2f3c5fac7a2a65f6 = (utils, formatToken)=>{
    const config = utils.formatTokenMap[formatToken];
    if (config == null) throw new Error([
        `MUI X: The token "${formatToken}" is not supported by the Date and Time Pickers.`,
        'Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported.'
    ].join('\n'));
    if (typeof config === 'string') return {
        type: config,
        contentType: config === 'meridiem' ? 'letter' : 'digit',
        maxLength: undefined
    };
    return {
        type: config.sectionType,
        contentType: config.contentType,
        maxLength: config.maxLength
    };
};
const $7692508c11d587c8$var$getDeltaFromKeyCode = (keyCode)=>{
    switch(keyCode){
        case 'ArrowUp':
            return 1;
        case 'ArrowDown':
            return -1;
        case 'PageUp':
            return 5;
        case 'PageDown':
            return -5;
        default:
            return 0;
    }
};
const $7692508c11d587c8$export$c65c7173f879039f = (utils, format)=>{
    const elements = [];
    const now = utils.date(undefined, 'default');
    const startDate = utils.startOfWeek(now);
    const endDate = utils.endOfWeek(now);
    let current = startDate;
    while(utils.isBefore(current, endDate)){
        elements.push(current);
        current = utils.addDays(current, 1);
    }
    return elements.map((weekDay)=>utils.formatByString(weekDay, format));
};
const $7692508c11d587c8$export$3ee1e7e19c2b047a = (utils, timezone, sectionType, format)=>{
    switch(sectionType){
        case 'month':
            return (0, $4d1fa529a9a32e76$export$62591b96a734eacd)(utils, utils.date(undefined, timezone)).map((month)=>utils.formatByString(month, format));
        case 'weekDay':
            return $7692508c11d587c8$export$c65c7173f879039f(utils, format);
        case 'meridiem':
            {
                const now = utils.date(undefined, timezone);
                return [
                    utils.startOfDay(now),
                    utils.endOfDay(now)
                ].map((date)=>utils.formatByString(date, format));
            }
        default:
            return [];
    }
};
const $7692508c11d587c8$export$b918512475916205 = 's';
const $7692508c11d587c8$var$NON_LOCALIZED_DIGITS = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9'
];
const $7692508c11d587c8$export$b42be9ae7016ef5d = (utils)=>{
    const today = utils.date(undefined);
    const formattedZero = utils.formatByString(utils.setSeconds(today, 0), $7692508c11d587c8$export$b918512475916205);
    if (formattedZero === '0') return $7692508c11d587c8$var$NON_LOCALIZED_DIGITS;
    return Array.from({
        length: 10
    }).map((_, index)=>utils.formatByString(utils.setSeconds(today, index), $7692508c11d587c8$export$b918512475916205));
};
const $7692508c11d587c8$export$7dd321105a319e8 = (valueStr, localizedDigits)=>{
    if (localizedDigits[0] === '0') return valueStr;
    const digits = [];
    let currentFormattedDigit = '';
    for(let i = 0; i < valueStr.length; i += 1){
        currentFormattedDigit += valueStr[i];
        const matchingDigitIndex = localizedDigits.indexOf(currentFormattedDigit);
        if (matchingDigitIndex > -1) {
            digits.push(matchingDigitIndex.toString());
            currentFormattedDigit = '';
        }
    }
    return digits.join('');
};
const $7692508c11d587c8$export$80dbbc19eba82070 = (valueStr, localizedDigits)=>{
    if (localizedDigits[0] === '0') return valueStr;
    return valueStr.split('').map((char)=>localizedDigits[Number(char)]).join('');
};
const $7692508c11d587c8$export$c28be6c4c9d8f124 = (valueStr, localizedDigits)=>{
    const nonLocalizedValueStr = $7692508c11d587c8$export$7dd321105a319e8(valueStr, localizedDigits);
    // `Number(' ')` returns `0` even if ' ' is not a valid number.
    return nonLocalizedValueStr !== ' ' && !Number.isNaN(Number(nonLocalizedValueStr));
};
const $7692508c11d587c8$export$713c6d756c12fc27 = (valueStr, size)=>{
    let cleanValueStr = valueStr;
    // Remove the leading zeros
    cleanValueStr = Number(cleanValueStr).toString();
    // Add enough leading zeros to fill the section
    while(cleanValueStr.length < size)cleanValueStr = `0${cleanValueStr}`;
    return cleanValueStr;
};
const $7692508c11d587c8$export$ef88db4bceade9fd = (utils, value, sectionBoundaries, localizedDigits, section)=>{
    if (section.type === 'day' && section.contentType === 'digit-with-letter') {
        const date = utils.setDate(sectionBoundaries.longestMonth, value);
        return utils.formatByString(date, section.format);
    }
    // queryValue without leading `0` (`01` => `1`)
    let valueStr = value.toString();
    if (section.hasLeadingZerosInInput) valueStr = $7692508c11d587c8$export$713c6d756c12fc27(valueStr, section.maxLength);
    return $7692508c11d587c8$export$80dbbc19eba82070(valueStr, localizedDigits);
};
const $7692508c11d587c8$export$5ed0f22513e58fe3 = (utils, timezone, section, keyCode, sectionsValueBoundaries, localizedDigits, activeDate, stepsAttributes)=>{
    const delta = $7692508c11d587c8$var$getDeltaFromKeyCode(keyCode);
    const isStart = keyCode === 'Home';
    const isEnd = keyCode === 'End';
    const shouldSetAbsolute = section.value === '' || isStart || isEnd;
    const adjustDigitSection = ()=>{
        const sectionBoundaries = sectionsValueBoundaries[section.type]({
            currentDate: activeDate,
            format: section.format,
            contentType: section.contentType
        });
        const getCleanValue = (value)=>$7692508c11d587c8$export$ef88db4bceade9fd(utils, value, sectionBoundaries, localizedDigits, section);
        const step = section.type === 'minutes' && stepsAttributes?.minutesStep ? stepsAttributes.minutesStep : 1;
        let newSectionValueNumber;
        if (shouldSetAbsolute) {
            if (section.type === 'year' && !isEnd && !isStart) return utils.formatByString(utils.date(undefined, timezone), section.format);
            if (delta > 0 || isStart) newSectionValueNumber = sectionBoundaries.minimum;
            else newSectionValueNumber = sectionBoundaries.maximum;
        } else {
            const currentSectionValue = parseInt($7692508c11d587c8$export$7dd321105a319e8(section.value, localizedDigits), 10);
            newSectionValueNumber = currentSectionValue + delta * step;
        }
        if (newSectionValueNumber % step !== 0) {
            if (delta < 0 || isStart) newSectionValueNumber += step - (step + newSectionValueNumber) % step; // for JS -3 % 5 = -3 (should be 2)
            if (delta > 0 || isEnd) newSectionValueNumber -= newSectionValueNumber % step;
        }
        if (newSectionValueNumber > sectionBoundaries.maximum) return getCleanValue(sectionBoundaries.minimum + (newSectionValueNumber - sectionBoundaries.maximum - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        if (newSectionValueNumber < sectionBoundaries.minimum) return getCleanValue(sectionBoundaries.maximum - (sectionBoundaries.minimum - newSectionValueNumber - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        return getCleanValue(newSectionValueNumber);
    };
    const adjustLetterSection = ()=>{
        const options = $7692508c11d587c8$export$3ee1e7e19c2b047a(utils, timezone, section.type, section.format);
        if (options.length === 0) return section.value;
        if (shouldSetAbsolute) {
            if (delta > 0 || isStart) return options[0];
            return options[options.length - 1];
        }
        const currentOptionIndex = options.indexOf(section.value);
        const newOptionIndex = (currentOptionIndex + delta) % options.length;
        const clampedIndex = (newOptionIndex + options.length) % options.length;
        return options[clampedIndex];
    };
    if (section.contentType === 'digit' || section.contentType === 'digit-with-letter') return adjustDigitSection();
    return adjustLetterSection();
};
const $7692508c11d587c8$export$85daa91f6c6e875f = (section, target, localizedDigits)=>{
    let value = section.value || section.placeholder;
    const hasLeadingZeros = target === 'non-input' ? section.hasLeadingZerosInFormat : section.hasLeadingZerosInInput;
    if (target === 'non-input' && section.hasLeadingZerosInInput && !section.hasLeadingZerosInFormat) value = Number($7692508c11d587c8$export$7dd321105a319e8(value, localizedDigits)).toString();
    // In the input, we add an empty character at the end of each section without leading zeros.
    // This makes sure that `onChange` will always be fired.
    // Otherwise, when your input value equals `1/dd/yyyy` (format `M/DD/YYYY` on DayJs),
    // If you press `1`, on the first section, the new value is also `1/dd/yyyy`,
    // So the browser will not fire the input `onChange`.
    const shouldAddInvisibleSpace = [
        'input-rtl',
        'input-ltr'
    ].includes(target) && section.contentType === 'digit' && !hasLeadingZeros && value.length === 1;
    if (shouldAddInvisibleSpace) value = `${value}\u200e`;
    if (target === 'input-rtl') value = `\u2068${value}\u2069`;
    return value;
};
const $7692508c11d587c8$export$2816862a602354ce = (utils, valueStr, currentFormat, newFormat)=>{
    return utils.formatByString(utils.parse(valueStr, currentFormat), newFormat);
};
const $7692508c11d587c8$var$isFourDigitYearFormat = (utils, format)=>utils.formatByString(utils.date(undefined, 'system'), format).length === 4;
const $7692508c11d587c8$export$78b5830e2dd2de49 = (utils, contentType, sectionType, format)=>{
    if (contentType !== 'digit') return false;
    const now = utils.date(undefined, 'default');
    switch(sectionType){
        // We can't use `changeSectionValueFormat`, because  `utils.parse('1', 'YYYY')` returns `1971` instead of `1`.
        case 'year':
            // Remove once https://github.com/iamkun/dayjs/pull/2847 is merged and bump dayjs version
            if (utils.lib === 'dayjs' && format === 'YY') return true;
            return utils.formatByString(utils.setYear(now, 1), format).startsWith('0');
        case 'month':
            return utils.formatByString(utils.startOfYear(now), format).length > 1;
        case 'day':
            return utils.formatByString(utils.startOfMonth(now), format).length > 1;
        case 'weekDay':
            return utils.formatByString(utils.startOfWeek(now), format).length > 1;
        case 'hours':
            return utils.formatByString(utils.setHours(now, 1), format).length > 1;
        case 'minutes':
            return utils.formatByString(utils.setMinutes(now, 1), format).length > 1;
        case 'seconds':
            return utils.formatByString(utils.setSeconds(now, 1), format).length > 1;
        default:
            throw new Error('Invalid section type');
    }
};
const $7692508c11d587c8$export$b0c1bfd065bfe742 = (utils, sections, localizedDigits)=>{
    // If we have both a day and a weekDay section,
    // Then we skip the weekDay in the parsing because libraries like dayjs can't parse complicated formats containing a weekDay.
    // dayjs(dayjs().format('dddd MMMM D YYYY'), 'dddd MMMM D YYYY')) // returns `Invalid Date` even if the format is valid.
    const shouldSkipWeekDays = sections.some((section)=>section.type === 'day');
    const sectionFormats = [];
    const sectionValues = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const shouldSkip = shouldSkipWeekDays && section.type === 'weekDay';
        if (!shouldSkip) {
            sectionFormats.push(section.format);
            sectionValues.push($7692508c11d587c8$export$85daa91f6c6e875f(section, 'non-input', localizedDigits));
        }
    }
    const formatWithoutSeparator = sectionFormats.join(' ');
    const dateWithoutSeparatorStr = sectionValues.join(' ');
    return utils.parse(dateWithoutSeparatorStr, formatWithoutSeparator);
};
const $7692508c11d587c8$export$9e6af343db7dd2 = (sections)=>sections.map((section)=>{
        return `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`;
    }).join('');
const $7692508c11d587c8$export$7ffdf006c6dc825f = (sections, localizedDigits, isRtl)=>{
    const formattedSections = sections.map((section)=>{
        const dateValue = $7692508c11d587c8$export$85daa91f6c6e875f(section, isRtl ? 'input-rtl' : 'input-ltr', localizedDigits);
        return `${section.startSeparator}${dateValue}${section.endSeparator}`;
    });
    const dateStr = formattedSections.join('');
    if (!isRtl) return dateStr;
    // \u2066: start left-to-right isolation
    // \u2067: start right-to-left isolation
    // \u2068: start first strong character isolation
    // \u2069: pop isolation
    // wrap into an isolated group such that separators can split the string in smaller ones by adding \u2069\u2068
    return `\u2066${dateStr}\u2069`;
};
const $7692508c11d587c8$export$360600f456ea7d5f = (utils, localizedDigits, timezone)=>{
    const today = utils.date(undefined, timezone);
    const endOfYear = utils.endOfYear(today);
    const endOfDay = utils.endOfDay(today);
    const { maxDaysInMonth: maxDaysInMonth, longestMonth: longestMonth } = (0, $4d1fa529a9a32e76$export$62591b96a734eacd)(utils, today).reduce((acc, month)=>{
        const daysInMonth = utils.getDaysInMonth(month);
        if (daysInMonth > acc.maxDaysInMonth) return {
            maxDaysInMonth: daysInMonth,
            longestMonth: month
        };
        return acc;
    }, {
        maxDaysInMonth: 0,
        longestMonth: null
    });
    return {
        year: ({ format: format })=>({
                minimum: 0,
                maximum: $7692508c11d587c8$var$isFourDigitYearFormat(utils, format) ? 9999 : 99
            }),
        month: ()=>({
                minimum: 1,
                // Assumption: All years have the same amount of months
                maximum: utils.getMonth(endOfYear) + 1
            }),
        day: ({ currentDate: currentDate })=>({
                minimum: 1,
                maximum: currentDate != null && utils.isValid(currentDate) ? utils.getDaysInMonth(currentDate) : maxDaysInMonth,
                longestMonth: longestMonth
            }),
        weekDay: ({ format: format, contentType: contentType })=>{
            if (contentType === 'digit') {
                const daysInWeek = $7692508c11d587c8$export$c65c7173f879039f(utils, format).map(Number);
                return {
                    minimum: Math.min(...daysInWeek),
                    maximum: Math.max(...daysInWeek)
                };
            }
            return {
                minimum: 1,
                maximum: 7
            };
        },
        hours: ({ format: format })=>{
            const lastHourInDay = utils.getHours(endOfDay);
            const hasMeridiem = $7692508c11d587c8$export$7dd321105a319e8(utils.formatByString(utils.endOfDay(today), format), localizedDigits) !== lastHourInDay.toString();
            if (hasMeridiem) return {
                minimum: 1,
                maximum: Number($7692508c11d587c8$export$7dd321105a319e8(utils.formatByString(utils.startOfDay(today), format), localizedDigits))
            };
            return {
                minimum: 0,
                maximum: lastHourInDay
            };
        },
        minutes: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of minutes
                maximum: utils.getMinutes(endOfDay)
            }),
        seconds: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of seconds
                maximum: utils.getSeconds(endOfDay)
            }),
        meridiem: ()=>({
                minimum: 0,
                maximum: 1
            }),
        empty: ()=>({
                minimum: 0,
                maximum: 0
            })
    };
};
let $7692508c11d587c8$var$warnedOnceInvalidSection = false;
const $7692508c11d587c8$export$ef6fbc09372bd65c = (sections, valueType)=>{};
const $7692508c11d587c8$var$transferDateSectionValue = (utils, section, dateToTransferFrom, dateToTransferTo)=>{
    switch(section.type){
        case 'year':
            return utils.setYear(dateToTransferTo, utils.getYear(dateToTransferFrom));
        case 'month':
            return utils.setMonth(dateToTransferTo, utils.getMonth(dateToTransferFrom));
        case 'weekDay':
            {
                const formattedDaysInWeek = $7692508c11d587c8$export$c65c7173f879039f(utils, section.format);
                const dayInWeekStrOfActiveDate = utils.formatByString(dateToTransferFrom, section.format);
                const dayInWeekOfActiveDate = formattedDaysInWeek.indexOf(dayInWeekStrOfActiveDate);
                const dayInWeekOfNewSectionValue = formattedDaysInWeek.indexOf(section.value);
                const diff = dayInWeekOfNewSectionValue - dayInWeekOfActiveDate;
                return utils.addDays(dateToTransferFrom, diff);
            }
        case 'day':
            return utils.setDate(dateToTransferTo, utils.getDate(dateToTransferFrom));
        case 'meridiem':
            {
                const isAM = utils.getHours(dateToTransferFrom) < 12;
                const mergedDateHours = utils.getHours(dateToTransferTo);
                if (isAM && mergedDateHours >= 12) return utils.addHours(dateToTransferTo, -12);
                if (!isAM && mergedDateHours < 12) return utils.addHours(dateToTransferTo, 12);
                return dateToTransferTo;
            }
        case 'hours':
            return utils.setHours(dateToTransferTo, utils.getHours(dateToTransferFrom));
        case 'minutes':
            return utils.setMinutes(dateToTransferTo, utils.getMinutes(dateToTransferFrom));
        case 'seconds':
            return utils.setSeconds(dateToTransferTo, utils.getSeconds(dateToTransferFrom));
        default:
            return dateToTransferTo;
    }
};
const $7692508c11d587c8$var$reliableSectionModificationOrder = {
    year: 1,
    month: 2,
    day: 3,
    weekDay: 4,
    hours: 5,
    minutes: 6,
    seconds: 7,
    meridiem: 8,
    empty: 9
};
const $7692508c11d587c8$export$6c6df982c77f60a9 = (utils, dateToTransferFrom, sections, referenceDate, shouldLimitToEditedSections)=>// cloning sections before sort to avoid mutating it
    [
        ...sections
    ].sort((a, b)=>$7692508c11d587c8$var$reliableSectionModificationOrder[a.type] - $7692508c11d587c8$var$reliableSectionModificationOrder[b.type]).reduce((mergedDate, section)=>{
        if (!shouldLimitToEditedSections || section.modified) return $7692508c11d587c8$var$transferDateSectionValue(utils, section, dateToTransferFrom, mergedDate);
        return mergedDate;
    }, referenceDate);
const $7692508c11d587c8$export$a11b0059900ceec8 = ()=>navigator.userAgent.toLowerCase().includes('android');
const $7692508c11d587c8$export$7725fd6fe0a2aadf = (sections, shouldApplyRTL)=>{
    const neighbors = {};
    if (!shouldApplyRTL) {
        sections.forEach((_, index)=>{
            const leftIndex = index === 0 ? null : index - 1;
            const rightIndex = index === sections.length - 1 ? null : index + 1;
            neighbors[index] = {
                leftIndex: leftIndex,
                rightIndex: rightIndex
            };
        });
        return {
            neighbors: neighbors,
            startIndex: 0,
            endIndex: sections.length - 1
        };
    }
    const rtl2ltr = {};
    const ltr2rtl = {};
    let groupedSectionsStart = 0;
    let groupedSectionsEnd = 0;
    let RTLIndex = sections.length - 1;
    while(RTLIndex >= 0){
        groupedSectionsEnd = sections.findIndex(// eslint-disable-next-line @typescript-eslint/no-loop-func
        (section, index)=>index >= groupedSectionsStart && section.endSeparator?.includes(' ') && // Special case where the spaces were not there in the initial input
            section.endSeparator !== ' / ');
        if (groupedSectionsEnd === -1) groupedSectionsEnd = sections.length - 1;
        for(let i = groupedSectionsEnd; i >= groupedSectionsStart; i -= 1){
            ltr2rtl[i] = RTLIndex;
            rtl2ltr[RTLIndex] = i;
            RTLIndex -= 1;
        }
        groupedSectionsStart = groupedSectionsEnd + 1;
    }
    sections.forEach((_, index)=>{
        const rtlIndex = ltr2rtl[index];
        const leftIndex = rtlIndex === 0 ? null : rtl2ltr[rtlIndex - 1];
        const rightIndex = rtlIndex === sections.length - 1 ? null : rtl2ltr[rtlIndex + 1];
        neighbors[index] = {
            leftIndex: leftIndex,
            rightIndex: rightIndex
        };
    });
    return {
        neighbors: neighbors,
        startIndex: rtl2ltr[0],
        endIndex: rtl2ltr[sections.length - 1]
    };
};
const $7692508c11d587c8$export$b31f27a6e35a0b27 = (selectedSections, sections)=>{
    if (selectedSections == null) return null;
    if (selectedSections === 'all') return 'all';
    if (typeof selectedSections === 'string') {
        const index = sections.findIndex((section)=>section.type === selectedSections);
        return index === -1 ? null : index;
    }
    return selectedSections;
};
const $7692508c11d587c8$export$b5e30842500b6cab = (section, utils)=>{
    if (!section.value) return undefined;
    switch(section.type){
        case 'month':
            {
                if (section.contentType === 'digit') return utils.format(utils.setMonth(utils.date(), Number(section.value) - 1), 'month');
                const parsedDate = utils.parse(section.value, section.format);
                return parsedDate ? utils.format(parsedDate, 'month') : undefined;
            }
        case 'day':
            return section.contentType === 'digit' ? utils.format(utils.setDate(utils.startOfYear(utils.date()), Number(section.value)), 'dayOfMonthFull') : section.value;
        case 'weekDay':
            // TODO: improve by providing the label of the week day
            return undefined;
        default:
            return undefined;
    }
};
const $7692508c11d587c8$export$b46fd324c5adcf31 = (section, utils)=>{
    if (!section.value) return undefined;
    switch(section.type){
        case 'weekDay':
            if (section.contentType === 'letter') // TODO: improve by resolving the week day number from a letter week day
            return undefined;
            return Number(section.value);
        case 'meridiem':
            {
                const parsedDate = utils.parse(`01:00 ${section.value}`, `${utils.formats.hours12h}:${utils.formats.minutes} ${section.format}`);
                if (parsedDate) return utils.getHours(parsedDate) >= 12 ? 1 : 0;
                return undefined;
            }
        case 'day':
            return section.contentType === 'digit-with-letter' ? parseInt(section.value, 10) : Number(section.value);
        case 'month':
            {
                if (section.contentType === 'digit') return Number(section.value);
                const parsedDate = utils.parse(section.value, section.format);
                return parsedDate ? utils.getMonth(parsedDate) + 1 : undefined;
            }
        default:
            return section.contentType !== 'letter' ? Number(section.value) : undefined;
    }
};


const $841d6de1e4809c9b$var$_excluded = [
    "value",
    "referenceDate"
];
const $841d6de1e4809c9b$export$2764b246aa3b75ba = {
    emptyValue: null,
    getTodayValue: (0, $4d1fa529a9a32e76$export$1118e4272ea1e258),
    getInitialReferenceValue: (_ref)=>{
        let { value: value, referenceDate: referenceDate } = _ref, params = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $841d6de1e4809c9b$var$_excluded);
        if (value != null && params.utils.isValid(value)) return value;
        if (referenceDate != null) return referenceDate;
        return (0, $03cf12356675f79b$export$6a31d56794238e4e)(params);
    },
    cleanValue: (0, $4d1fa529a9a32e76$export$36ca889e039badd5),
    areValuesEqual: (0, $4d1fa529a9a32e76$export$8fabf9a4cbada414),
    isSameError: (a, b)=>a === b,
    hasError: (error)=>error != null,
    defaultErrorState: null,
    getTimezone: (utils, value)=>value == null || !utils.isValid(value) ? null : utils.getTimezone(value),
    setTimezone: (utils, timezone, value)=>value == null ? null : utils.setTimezone(value, timezone)
};
const $841d6de1e4809c9b$export$b602c94f557316b4 = {
    updateReferenceValue: (utils, value, prevReferenceValue)=>value == null || !utils.isValid(value) ? prevReferenceValue : value,
    getSectionsFromValue: (utils, date, prevSections, getSectionsFromDate)=>{
        const shouldReUsePrevDateSections = !utils.isValid(date) && !!prevSections;
        if (shouldReUsePrevDateSections) return prevSections;
        return getSectionsFromDate(date);
    },
    getV7HiddenInputValueFromSections: (0, $7692508c11d587c8$export$9e6af343db7dd2),
    getV6InputValueFromSections: (0, $7692508c11d587c8$export$7ffdf006c6dc825f),
    getActiveDateManager: (utils, state)=>({
            date: state.value,
            referenceDate: state.referenceValue,
            getSections: (sections)=>sections,
            getNewValuesFromNewActiveDate: (newActiveDate)=>({
                    value: newActiveDate,
                    referenceValue: newActiveDate == null || !utils.isValid(newActiveDate) ? state.referenceValue : newActiveDate
                })
        }),
    parseValueStr: (valueStr, referenceValue, parseDate)=>parseDate(valueStr.trim(), referenceValue)
};




var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");


const $85ebbb99b2811e17$export$67c96d35a1b010b3 = (pickersTranslations)=>{
    return {
        components: {
            MuiLocalizationProvider: {
                defaultProps: {
                    localeText: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, pickersTranslations)
                }
            }
        }
    };
};
const $85ebbb99b2811e17$export$7eae96bf9dd7ca56 = (params)=>{
    const { utils: utils, formatKey: formatKey, contextTranslation: contextTranslation, propsTranslation: propsTranslation } = params;
    return (value)=>{
        const formattedValue = value !== null && utils.isValid(value) ? utils.format(value, formatKey) : null;
        const translation = propsTranslation ?? contextTranslation;
        return translation(value, utils, formattedValue);
    };
};


// This object is not Partial<PickersLocaleText> because it is the default values
const $ae7ac3a23918bc42$var$enUSPickers = {
    // Calendar navigation
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    // View navigation
    openPreviousView: 'Open previous view',
    openNextView: 'Open next view',
    calendarViewSwitchingButtonAriaLabel: (view)=>view === 'year' ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view',
    // DateRange labels
    start: 'Start',
    end: 'End',
    startDate: 'Start date',
    startTime: 'Start time',
    endDate: 'End date',
    endTime: 'End time',
    // Action bar
    cancelButtonLabel: 'Cancel',
    clearButtonLabel: 'Clear',
    okButtonLabel: 'OK',
    todayButtonLabel: 'Today',
    // Toolbar titles
    datePickerToolbarTitle: 'Select date',
    dateTimePickerToolbarTitle: 'Select date & time',
    timePickerToolbarTitle: 'Select time',
    dateRangePickerToolbarTitle: 'Select date range',
    // Clock labels
    clockLabelText: (view, time, utils, formattedTime)=>`Select ${view}. ${!formattedTime && (time === null || !utils.isValid(time)) ? 'No time selected' : `Selected time is ${formattedTime ?? utils.format(time, 'fullTime')}`}`,
    hoursClockNumberText: (hours)=>`${hours} hours`,
    minutesClockNumberText: (minutes)=>`${minutes} minutes`,
    secondsClockNumberText: (seconds)=>`${seconds} seconds`,
    // Digital clock labels
    selectViewText: (view)=>`Select ${view}`,
    // Calendar labels
    calendarWeekNumberHeaderLabel: 'Week number',
    calendarWeekNumberHeaderText: '#',
    calendarWeekNumberAriaLabelText: (weekNumber)=>`Week ${weekNumber}`,
    calendarWeekNumberText: (weekNumber)=>`${weekNumber}`,
    // Open picker labels
    openDatePickerDialogue: (value, utils, formattedDate)=>formattedDate || value !== null && utils.isValid(value) ? `Choose date, selected date is ${formattedDate ?? utils.format(value, 'fullDate')}` : 'Choose date',
    openTimePickerDialogue: (value, utils, formattedTime)=>formattedTime || value !== null && utils.isValid(value) ? `Choose time, selected time is ${formattedTime ?? utils.format(value, 'fullTime')}` : 'Choose time',
    fieldClearLabel: 'Clear',
    // Table labels
    timeTableLabel: 'pick time',
    dateTableLabel: 'pick date',
    // Field section placeholders
    fieldYearPlaceholder: (params)=>'Y'.repeat(params.digitAmount),
    fieldMonthPlaceholder: (params)=>params.contentType === 'letter' ? 'MMMM' : 'MM',
    fieldDayPlaceholder: ()=>'DD',
    fieldWeekDayPlaceholder: (params)=>params.contentType === 'letter' ? 'EEEE' : 'EE',
    fieldHoursPlaceholder: ()=>'hh',
    fieldMinutesPlaceholder: ()=>'mm',
    fieldSecondsPlaceholder: ()=>'ss',
    fieldMeridiemPlaceholder: ()=>'aa',
    // View names
    year: 'Year',
    month: 'Month',
    day: 'Day',
    weekDay: 'Week day',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
    meridiem: 'Meridiem',
    // Common
    empty: 'Empty'
};
const $ae7ac3a23918bc42$export$1af4c7e47ad72f44 = $ae7ac3a23918bc42$var$enUSPickers;
const $ae7ac3a23918bc42$export$137380d9ce54f7f = (0, $85ebbb99b2811e17$export$67c96d35a1b010b3)($ae7ac3a23918bc42$var$enUSPickers);


const $6945e6366bb58773$export$4b5a24245de9f7f9 = ()=>{
    const localization = $7fPBF.useContext((0, $cbc6c65ed9f8bf86$export$544976378534cf9));
    if (localization === null) throw new Error([
        'MUI X: Can not find the date and time pickers localization context.',
        'It looks like you forgot to wrap your component in LocalizationProvider.',
        'This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package'
    ].join('\n'));
    if (localization.utils === null) throw new Error([
        'MUI X: Can not find the date and time pickers adapter from its localization context.',
        'It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider.'
    ].join('\n'));
    const localeText = $7fPBF.useMemo(()=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $ae7ac3a23918bc42$export$1af4c7e47ad72f44), localization.localeText), [
        localization.localeText
    ]);
    return $7fPBF.useMemo(()=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, localization, {
            localeText: localeText
        }), [
        localization,
        localeText
    ]);
};
const $6945e6366bb58773$export$1163b47e39508a46 = ()=>$6945e6366bb58773$export$4b5a24245de9f7f9().utils;
const $6945e6366bb58773$export$7c38da3a2e90fa83 = ()=>$6945e6366bb58773$export$4b5a24245de9f7f9().defaultDates;
const $6945e6366bb58773$export$3a404aece3dff2fa = (timezone)=>{
    const utils = $6945e6366bb58773$export$1163b47e39508a46();
    const now = $7fPBF.useRef(undefined);
    if (now.current === undefined) now.current = utils.date(undefined, timezone);
    return now.current;
};







var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");





function $f7d55096f286ac82$export$b109c489973c3d80(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPickersToolbar', slot);
}
const $f7d55096f286ac82$export$59f09e5e2b3d9913 = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPickersToolbar', [
    'root',
    'content'
]);



const $f6120d886b3f245b$var$_excluded = [
    "children",
    "className",
    "toolbarTitle",
    "hidden",
    "titleId",
    "isLandscape",
    "classes",
    "landscapeDirection"
];
const $f6120d886b3f245b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        content: [
            'content'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $f7d55096f286ac82$export$b109c489973c3d80), classes);
};
const $f6120d886b3f245b$var$PickersToolbarRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 3),
        variants: [
            {
                props: {
                    isLandscape: true
                },
                style: {
                    height: 'auto',
                    maxWidth: 160,
                    padding: 16,
                    justifyContent: 'flex-start',
                    flexWrap: 'wrap'
                }
            }
        ]
    }));
const $f6120d886b3f245b$var$PickersToolbarContent = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})({
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    flex: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    variants: [
        {
            props: {
                isLandscape: true
            },
            style: {
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                flexDirection: 'column'
            }
        },
        {
            props: {
                isLandscape: true,
                landscapeDirection: 'row'
            },
            style: {
                flexDirection: 'row'
            }
        }
    ]
});
const $f6120d886b3f245b$export$eb3c4d84783d6feb = /*#__PURE__*/ $7fPBF.forwardRef(function PickersToolbar(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersToolbar'
    });
    const { children: children, className: className, toolbarTitle: toolbarTitle, hidden: hidden, titleId: titleId } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $f6120d886b3f245b$var$_excluded);
    const ownerState = props;
    const classes = $f6120d886b3f245b$var$useUtilityClasses(ownerState);
    if (hidden) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($f6120d886b3f245b$var$PickersToolbarRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                color: "text.secondary",
                variant: "overline",
                id: titleId,
                children: toolbarTitle
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($f6120d886b3f245b$var$PickersToolbarContent, {
                className: classes.content,
                ownerState: ownerState,
                children: children
            })
        ]
    }));
});



'use client';
const $7fcfc9681bf68f23$export$3cdcc56057891b44 = ()=>(0, $6945e6366bb58773$export$4b5a24245de9f7f9)().localeText;




function $1f1136919bda5dde$export$a1c3879af2c3b694(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiDatePickerToolbar', slot);
}
const $1f1136919bda5dde$export$2e35fa7d24ef4179 = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiDatePickerToolbar', [
    'root',
    'title'
]);




'use client';
const $8c89a4c7302d5b4a$var$_excluded = [
    "value",
    "isLandscape",
    "onChange",
    "toolbarFormat",
    "toolbarPlaceholder",
    "views",
    "className",
    "onViewChange",
    "view"
];
const $8c89a4c7302d5b4a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        title: [
            'title'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $1f1136919bda5dde$export$a1c3879af2c3b694), classes);
};
const $8c89a4c7302d5b4a$var$DatePickerToolbarRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $f6120d886b3f245b$export$eb3c4d84783d6feb), {
    name: 'MuiDatePickerToolbar',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({});
const $8c89a4c7302d5b4a$var$DatePickerToolbarTitle = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
    name: 'MuiDatePickerToolbar',
    slot: 'Title',
    overridesResolver: (_, styles)=>styles.title
})({
    variants: [
        {
            props: {
                isLandscape: true
            },
            style: {
                margin: 'auto 16px auto auto'
            }
        }
    ]
});
const $8c89a4c7302d5b4a$export$21b7f8ea763109eb = /*#__PURE__*/ $7fPBF.forwardRef(function DatePickerToolbar(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDatePickerToolbar'
    });
    const { value: value, isLandscape: isLandscape, toolbarFormat: toolbarFormat, toolbarPlaceholder: toolbarPlaceholder = "\u2013\u2013", views: views, className: className } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $8c89a4c7302d5b4a$var$_excluded);
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const translations = (0, $7fcfc9681bf68f23$export$3cdcc56057891b44)();
    const classes = $8c89a4c7302d5b4a$var$useUtilityClasses(props);
    const dateText = $7fPBF.useMemo(()=>{
        if (!value) return toolbarPlaceholder;
        const formatFromViews = (0, $4d1fa529a9a32e76$export$bb1c921f313ec928)(utils, {
            format: toolbarFormat,
            views: views
        }, true);
        return utils.formatByString(value, formatFromViews);
    }, [
        value,
        toolbarFormat,
        toolbarPlaceholder,
        utils,
        views
    ]);
    const ownerState = props;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8c89a4c7302d5b4a$var$DatePickerToolbarRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: ref,
        toolbarTitle: translations.datePickerToolbarTitle,
        isLandscape: isLandscape,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8c89a4c7302d5b4a$var$DatePickerToolbarTitle, {
            variant: "h4",
            align: isLandscape ? 'left' : 'center',
            ownerState: ownerState,
            className: classes.title,
            children: dateText
        })
    }));
});


function $53ebcde7c448f3c9$export$a552c17ed3587731(props, name) {
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const defaultDates = (0, $6945e6366bb58773$export$7c38da3a2e90fa83)();
    const themeProps = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    const localeText = $7fPBF.useMemo(()=>{
        if (themeProps.localeText?.toolbarTitle == null) return themeProps.localeText;
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, themeProps.localeText, {
            datePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, themeProps, {
        localeText: localeText
    }, (0, $e85b1ef30fae45b1$export$bdf8d867ddc968e)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            'year',
            'day'
        ],
        defaultOpenTo: 'day'
    }), {
        disableFuture: themeProps.disableFuture ?? false,
        disablePast: themeProps.disablePast ?? false,
        minDate: (0, $4d1fa529a9a32e76$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $4d1fa529a9a32e76$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate),
        slots: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            toolbar: (0, $8c89a4c7302d5b4a$export$21b7f8ea763109eb)
        }, themeProps.slots)
    });
}




const $f613678a0229c7f5$export$430d9fc64cf058d6 = [
    'disablePast',
    'disableFuture',
    'minDate',
    'maxDate',
    'shouldDisableDate',
    'shouldDisableMonth',
    'shouldDisableYear'
];
const $f613678a0229c7f5$export$fd5e0f8b4115a8c7 = [
    'disablePast',
    'disableFuture',
    'minTime',
    'maxTime',
    'shouldDisableTime',
    'minutesStep',
    'ampm',
    'disableIgnoringDatePartForTimeValidation'
];
const $f613678a0229c7f5$export$1df62d3ba2121371 = [
    'minDateTime',
    'maxDateTime'
];
const $f613678a0229c7f5$var$VALIDATION_PROP_NAMES = [
    ...$f613678a0229c7f5$export$430d9fc64cf058d6,
    ...$f613678a0229c7f5$export$fd5e0f8b4115a8c7,
    ...$f613678a0229c7f5$export$1df62d3ba2121371
];
const $f613678a0229c7f5$export$5890f750904acddb = (props)=>$f613678a0229c7f5$var$VALIDATION_PROP_NAMES.reduce((extractedProps, propName)=>{
        if (props.hasOwnProperty(propName)) extractedProps[propName] = props[propName];
        return extractedProps;
    }, {});



const $c885b418e3c240b8$export$ffb3d0046ef3a2 = ({ props: props, value: value, timezone: timezone, adapter: adapter })=>{
    if (value === null) return null;
    const { shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, disablePast: disablePast, disableFuture: disableFuture } = props;
    const now = adapter.utils.date(undefined, timezone);
    const minDate = (0, $4d1fa529a9a32e76$export$eb73579ccade48fd)(adapter.utils, props.minDate, adapter.defaultDates.minDate);
    const maxDate = (0, $4d1fa529a9a32e76$export$eb73579ccade48fd)(adapter.utils, props.maxDate, adapter.defaultDates.maxDate);
    switch(true){
        case !adapter.utils.isValid(value):
            return 'invalidDate';
        case Boolean(shouldDisableDate && shouldDisableDate(value)):
            return 'shouldDisableDate';
        case Boolean(shouldDisableMonth && shouldDisableMonth(value)):
            return 'shouldDisableMonth';
        case Boolean(shouldDisableYear && shouldDisableYear(value)):
            return 'shouldDisableYear';
        case Boolean(disableFuture && adapter.utils.isAfterDay(value, now)):
            return 'disableFuture';
        case Boolean(disablePast && adapter.utils.isBeforeDay(value, now)):
            return 'disablePast';
        case Boolean(minDate && adapter.utils.isBeforeDay(value, minDate)):
            return 'minDate';
        case Boolean(maxDate && adapter.utils.isAfterDay(value, maxDate)):
            return 'maxDate';
        default:
            return null;
    }
};
$c885b418e3c240b8$export$ffb3d0046ef3a2.valueManager = (0, $841d6de1e4809c9b$export$2764b246aa3b75ba);





var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");









function $54266f2fc78d1fbb$export$5519b4d4bf80ce6f(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPickersPopper', slot);
}
const $54266f2fc78d1fbb$export$46e9184c9b1af0ce = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPickersPopper', [
    'root',
    'paper'
]);


/* Use it instead of .includes method for IE support */ function $e21804eb4bb13208$export$22012a5c726bef55(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every((item)=>array.indexOf(item) !== -1);
    return array.indexOf(itemOrItems) !== -1;
}
const $e21804eb4bb13208$export$4467fe8634707c85 = (innerFn, externalEvent)=>(event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            innerFn(event);
            // prevent any side effects
            event.preventDefault();
            event.stopPropagation();
        }
        if (externalEvent) externalEvent(event);
    };
const $e21804eb4bb13208$export$2e03bc8dde24716b = (fn)=>{
    setTimeout(fn, 0);
};
const $e21804eb4bb13208$export$cd4e5573fbe2b576 = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $e21804eb4bb13208$export$cd4e5573fbe2b576(activeEl.shadowRoot);
    return activeEl;
};
const $e21804eb4bb13208$export$4165ccf43f4d7767 = (listElement)=>{
    const children = Array.from(listElement.children);
    return children.indexOf($e21804eb4bb13208$export$cd4e5573fbe2b576(document));
};
const $e21804eb4bb13208$export$9ae5b19305db48ce = '@media (pointer: fine)';



const $015921b28af57dd9$var$PREFERS_REDUCED_MOTION = '@media (prefers-reduced-motion: reduce)';
// detect if user agent has Android version < 10 or iOS version < 13
const $015921b28af57dd9$var$mobileVersionMatches = typeof navigator !== 'undefined' && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i);
const $015921b28af57dd9$var$androidVersion = $015921b28af57dd9$var$mobileVersionMatches && $015921b28af57dd9$var$mobileVersionMatches[1] ? parseInt($015921b28af57dd9$var$mobileVersionMatches[1], 10) : null;
const $015921b28af57dd9$var$iOSVersion = $015921b28af57dd9$var$mobileVersionMatches && $015921b28af57dd9$var$mobileVersionMatches[2] ? parseInt($015921b28af57dd9$var$mobileVersionMatches[2], 10) : null;
const $015921b28af57dd9$export$7e3b2a595fb375e5 = $015921b28af57dd9$var$androidVersion && $015921b28af57dd9$var$androidVersion < 10 || $015921b28af57dd9$var$iOSVersion && $015921b28af57dd9$var$iOSVersion < 13 || false;
const $015921b28af57dd9$export$ce40fb97be7f02d9 = ()=>{
    const prefersReduced = (0, $d692658be43721e5$export$2e2bcd8739ae039)($015921b28af57dd9$var$PREFERS_REDUCED_MOTION, {
        defaultMatches: false
    });
    return prefersReduced || $015921b28af57dd9$export$7e3b2a595fb375e5;
};



const $df2366d35b337352$var$_excluded = [
    "PaperComponent",
    "popperPlacement",
    "ownerState",
    "children",
    "paperSlotProps",
    "paperClasses",
    "onPaperClick",
    "onPaperTouchStart"
];
const $df2366d35b337352$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $54266f2fc78d1fbb$export$5519b4d4bf80ce6f), classes);
};
const $df2366d35b337352$var$PickersPopperRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $2ecffc9bd505b8cc$export$2e2bcd8739ae039), {
    name: 'MuiPickersPopper',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        zIndex: theme.zIndex.modal
    }));
const $df2366d35b337352$var$PickersPopperPaper = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: 'MuiPickersPopper',
    slot: 'Paper',
    overridesResolver: (_, styles)=>styles.paper
})({
    outline: 0,
    transformOrigin: 'top center',
    variants: [
        {
            props: ({ placement: placement })=>[
                    'top',
                    'top-start',
                    'top-end'
                ].includes(placement),
            style: {
                transformOrigin: 'bottom center'
            }
        }
    ]
});
function $df2366d35b337352$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Based on @mui/material/ClickAwayListener without the customization.
 * We can probably strip away even more since children won't be portaled.
 * @param {boolean} active Only listen to clicks when the popper is opened.
 * @param {(event: MouseEvent | TouchEvent) => void} onClickAway The callback to call when clicking outside the popper.
 * @returns {Array} The ref and event handler to listen to the outside clicks.
 */ function $df2366d35b337352$var$useClickAwayListener(active, onClickAway) {
    const movedRef = $7fPBF.useRef(false);
    const syntheticEventRef = $7fPBF.useRef(false);
    const nodeRef = $7fPBF.useRef(null);
    const activatedRef = $7fPBF.useRef(false);
    $7fPBF.useEffect(()=>{
        if (!active) return undefined;
        // Ensure that this hook is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        function armClickAwayListener() {
            activatedRef.current = true;
        }
        document.addEventListener('mousedown', armClickAwayListener, true);
        document.addEventListener('touchstart', armClickAwayListener, true);
        return ()=>{
            document.removeEventListener('mousedown', armClickAwayListener, true);
            document.removeEventListener('touchstart', armClickAwayListener, true);
            activatedRef.current = false;
        };
    }, [
        active
    ]);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event)=>{
        if (!activatedRef.current) return;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!nodeRef.current || // is a TouchEvent?
        'clientX' in event && $df2366d35b337352$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        if (!insideDOM && !insideReactTree) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const handleSynthetic = ()=>{
        syntheticEventRef.current = true;
    };
    $7fPBF.useEffect(()=>{
        if (active) {
            const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener('touchstart', handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener('touchstart', handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    $7fPBF.useEffect(()=>{
        // TODO This behavior is not tested automatically
        // It's unclear whether this is due to different update semantics in test (batched in act() vs discrete on click).
        // Or if this is a timing related issues due to different Transition components
        // Once we get rid of all the manual scheduling (for example setTimeout(update, 0)) we can revisit this code+test.
        if (active) {
            const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener('click', handleClickAway);
            return ()=>{
                doc.removeEventListener('click', handleClickAway);
                // cleanup `handleClickAway`
                syntheticEventRef.current = false;
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    return [
        nodeRef,
        handleSynthetic,
        handleSynthetic
    ];
}
const $df2366d35b337352$var$PickersPopperPaperWrapper = /*#__PURE__*/ $7fPBF.forwardRef((props, ref)=>{
    const { PaperComponent: PaperComponent, popperPlacement: popperPlacement, ownerState: inOwnerState, children: children, paperSlotProps: paperSlotProps, paperClasses: paperClasses, onPaperClick: onPaperClick, onPaperTouchStart: onPaperTouchStart } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $df2366d35b337352$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, inOwnerState, {
        placement: popperPlacement
    });
    const paperProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: PaperComponent,
        externalSlotProps: paperSlotProps,
        additionalProps: {
            tabIndex: -1,
            elevation: 8,
            ref: ref
        },
        className: paperClasses,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(PaperComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, other, paperProps, {
        onClick: (event)=>{
            onPaperClick(event);
            paperProps.onClick?.(event);
        },
        onTouchStart: (event)=>{
            onPaperTouchStart(event);
            paperProps.onTouchStart?.(event);
        },
        ownerState: ownerState,
        children: children
    }));
});
function $df2366d35b337352$export$96ce8482474de8a5(inProps) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersPopper'
    });
    const { anchorEl: anchorEl, children: children, containerRef: containerRef = null, shouldRestoreFocus: shouldRestoreFocus, onBlur: onBlur, onDismiss: onDismiss, open: open, role: role, placement: placement, slots: slots, slotProps: slotProps, reduceAnimations: inReduceAnimations } = props;
    $7fPBF.useEffect(()=>{
        function handleKeyDown(nativeEvent) {
            if (open && nativeEvent.key === 'Escape') onDismiss();
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        onDismiss,
        open
    ]);
    const lastFocusedElementRef = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        if (role === 'tooltip' || shouldRestoreFocus && !shouldRestoreFocus()) return;
        if (open) lastFocusedElementRef.current = (0, $e21804eb4bb13208$export$cd4e5573fbe2b576)(document);
        else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) // make sure the button is flushed with updated label, before returning focus to it
        // avoids issue, where screen reader could fail to announce selected date after selection
        setTimeout(()=>{
            if (lastFocusedElementRef.current instanceof HTMLElement) lastFocusedElementRef.current.focus();
        });
    }, [
        open,
        role,
        shouldRestoreFocus
    ]);
    const [clickAwayRef, onPaperClick, onPaperTouchStart] = $df2366d35b337352$var$useClickAwayListener(open, onBlur ?? onDismiss);
    const paperRef = $7fPBF.useRef(null);
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(paperRef, containerRef);
    const handlePaperRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(handleRef, clickAwayRef);
    const ownerState = props;
    const classes = $df2366d35b337352$var$useUtilityClasses(ownerState);
    const defaultReduceAnimations = (0, $015921b28af57dd9$export$ce40fb97be7f02d9)();
    const reduceAnimations = inReduceAnimations ?? defaultReduceAnimations;
    const handleKeyDown = (event)=>{
        if (event.key === 'Escape') {
            // stop the propagation to avoid closing parent modal
            event.stopPropagation();
            onDismiss();
        }
    };
    const Transition = slots?.desktopTransition ?? reduceAnimations ? (0, $68214be7242cbfc8$export$2e2bcd8739ae039) : (0, $7ec2c0aa92d4d29c$export$2e2bcd8739ae039);
    const FocusTrap = slots?.desktopTrapFocus ?? (0, $8e062765deddb857$export$2e2bcd8739ae039);
    const Paper = slots?.desktopPaper ?? $df2366d35b337352$var$PickersPopperPaper;
    const Popper = slots?.popper ?? $df2366d35b337352$var$PickersPopperRoot;
    const popperProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: Popper,
        externalSlotProps: slotProps?.popper,
        additionalProps: {
            transition: true,
            role: role,
            open: open,
            anchorEl: anchorEl,
            placement: placement,
            onKeyDown: handleKeyDown
        },
        className: classes.root,
        ownerState: props
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Popper, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, popperProps, {
        children: ({ TransitionProps: TransitionProps, placement: popperPlacement })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(FocusTrap, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                open: open,
                disableAutoFocus: true,
                disableRestoreFocus: true,
                disableEnforceFocus: role === 'tooltip',
                isEnabled: ()=>true
            }, slotProps?.desktopTrapFocus, {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Transition, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, TransitionProps, slotProps?.desktopTransition, {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($df2366d35b337352$var$PickersPopperPaperWrapper, {
                        PaperComponent: Paper,
                        ownerState: ownerState,
                        popperPlacement: popperPlacement,
                        ref: handlePaperRef,
                        onPaperClick: onPaperClick,
                        onPaperTouchStart: onPaperTouchStart,
                        paperClasses: classes.paper,
                        paperSlotProps: slotProps?.desktopPaper,
                        children: children
                    })
                }))
            }))
    }));
}





var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $97abccf8a6b96579$export$7d3a09d5141ab1f4 = ({ open: open, onOpen: onOpen, onClose: onClose })=>{
    const isControllingOpenProp = $7fPBF.useRef(typeof open === 'boolean').current;
    const [openState, setIsOpenState] = $7fPBF.useState(false);
    // It is required to update inner state in useEffect in order to avoid situation when
    // Our component is not mounted yet, but `open` state is set to `true` (for example initially opened)
    $7fPBF.useEffect(()=>{
        if (isControllingOpenProp) {
            if (typeof open !== 'boolean') throw new Error('You must not mix controlling and uncontrolled mode for `open` prop');
            setIsOpenState(open);
        }
    }, [
        isControllingOpenProp,
        open
    ]);
    const setIsOpen = $7fPBF.useCallback((newIsOpen)=>{
        if (!isControllingOpenProp) setIsOpenState(newIsOpen);
        if (newIsOpen && onOpen) onOpen();
        if (!newIsOpen && onClose) onClose();
    }, [
        isControllingOpenProp,
        onOpen,
        onClose
    ]);
    return {
        isOpen: openState,
        setIsOpen: setIsOpen
    };
};




var $7fPBF = parcelRequire("7fPBF");


'use client';
function $0f340c8acb692073$export$87fe492f99f25a20(options) {
    const { props: props, validator: validator, value: value, timezone: timezone, onError: onError } = options;
    const adapter = (0, $6945e6366bb58773$export$4b5a24245de9f7f9)();
    const previousValidationErrorRef = $7fPBF.useRef(validator.valueManager.defaultErrorState);
    const validationError = validator({
        adapter: adapter,
        value: value,
        timezone: timezone,
        props: props
    });
    const hasValidationError = validator.valueManager.hasError(validationError);
    $7fPBF.useEffect(()=>{
        if (onError && !validator.valueManager.isSameError(validationError, previousValidationErrorRef.current)) onError(validationError, value);
        previousValidationErrorRef.current = validationError;
    }, [
        validator,
        onError,
        validationError,
        value
    ]);
    const getValidationErrorForNewValue = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((newValue)=>{
        return validator({
            adapter: adapter,
            value: newValue,
            timezone: timezone,
            props: props
        });
    });
    return {
        validationError: validationError,
        hasValidationError: hasValidationError,
        getValidationErrorForNewValue: getValidationErrorForNewValue
    };
}



var $7fPBF = parcelRequire("7fPBF");



const $a30ec645234d5ab0$export$c7e050e908c1b2bc = ({ timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, valueManager: valueManager })=>{
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const firstDefaultValue = $7fPBF.useRef(defaultValue);
    const inputValue = valueProp ?? firstDefaultValue.current ?? valueManager.emptyValue;
    const inputTimezone = $7fPBF.useMemo(()=>valueManager.getTimezone(utils, inputValue), [
        utils,
        valueManager,
        inputValue
    ]);
    const setInputTimezone = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((newValue)=>{
        if (inputTimezone == null) return newValue;
        return valueManager.setTimezone(utils, inputTimezone, newValue);
    });
    let timezoneToRender;
    if (timezoneProp) timezoneToRender = timezoneProp;
    else if (inputTimezone) timezoneToRender = inputTimezone;
    else if (referenceDate) timezoneToRender = utils.getTimezone(referenceDate);
    else timezoneToRender = 'default';
    const valueWithTimezoneToRender = $7fPBF.useMemo(()=>valueManager.setTimezone(utils, timezoneToRender, inputValue), [
        valueManager,
        utils,
        timezoneToRender,
        inputValue
    ]);
    const handleValueChange = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((newValue, ...otherParams)=>{
        const newValueWithInputTimezone = setInputTimezone(newValue);
        onChange?.(newValueWithInputTimezone, ...otherParams);
    });
    return {
        value: valueWithTimezoneToRender,
        handleValueChange: handleValueChange,
        timezone: timezoneToRender
    };
};
const $a30ec645234d5ab0$export$174d749f3b4c0f49 = ({ name: name, timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChangeProp, valueManager: valueManager })=>{
    const [valueWithInputTimezone, setValue] = (0, $bc6c881cebb96954$export$2e2bcd8739ae039)({
        name: name,
        state: 'value',
        controlled: valueProp,
        default: defaultValue ?? valueManager.emptyValue
    });
    const onChange = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((newValue, ...otherParams)=>{
        setValue(newValue);
        onChangeProp?.(newValue, ...otherParams);
    });
    return $a30ec645234d5ab0$export$c7e050e908c1b2bc({
        timezone: timezoneProp,
        value: valueWithInputTimezone,
        defaultValue: undefined,
        referenceDate: referenceDate,
        onChange: onChange,
        valueManager: valueManager
    });
};


/**
 * Decide if the new value should be published
 * The published value will be passed to `onChange` if defined.
 */ const $476ea41559631918$var$shouldPublishValue = (params)=>{
    const { action: action, hasChanged: hasChanged, dateState: dateState, isControlled: isControlled } = params;
    const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
    // The field is responsible for only calling `onChange` when needed.
    if (action.name === 'setValueFromField') return true;
    if (action.name === 'setValueFromAction') {
        // If the component is not controlled, and the value has not been modified since the mount,
        // Then we want to publish the default value whenever the user pressed the "Accept", "Today" or "Clear" button.
        if (isCurrentValueTheDefaultValue && [
            'accept',
            'today',
            'clear'
        ].includes(action.pickerAction)) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    if (action.name === 'setValueFromView' && action.selectionState !== 'shallow') {
        // On the first view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onChange`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    if (action.name === 'setValueFromShortcut') {
        // On the first view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onChange`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    return false;
};
/**
 * Decide if the new value should be committed.
 * The committed value will be passed to `onAccept` if defined.
 * It will also be used as a reset target when calling the `cancel` picker action (when clicking on the "Cancel" button).
 */ const $476ea41559631918$var$shouldCommitValue = (params)=>{
    const { action: action, hasChanged: hasChanged, dateState: dateState, isControlled: isControlled, closeOnSelect: closeOnSelect } = params;
    const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
    if (action.name === 'setValueFromAction') {
        // If the component is not controlled, and the value has not been modified since the mount,
        // Then we want to commit the default value whenever the user pressed the "Accept", "Today" or "Clear" button.
        if (isCurrentValueTheDefaultValue && [
            'accept',
            'today',
            'clear'
        ].includes(action.pickerAction)) return true;
        return hasChanged(dateState.lastCommittedValue);
    }
    if (action.name === 'setValueFromView' && action.selectionState === 'finish' && closeOnSelect) {
        // On picker where the 1st view is also the last view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onAccept`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastCommittedValue);
    }
    if (action.name === 'setValueFromShortcut') return action.changeImportance === 'accept' && hasChanged(dateState.lastCommittedValue);
    return false;
};
/**
 * Decide if the picker should be closed after the value is updated.
 */ const $476ea41559631918$var$shouldClosePicker = (params)=>{
    const { action: action, closeOnSelect: closeOnSelect } = params;
    if (action.name === 'setValueFromAction') return true;
    if (action.name === 'setValueFromView') return action.selectionState === 'finish' && closeOnSelect;
    if (action.name === 'setValueFromShortcut') return action.changeImportance === 'accept';
    return false;
};
const $476ea41559631918$export$799b22a7b7fffaa3 = ({ props: props, valueManager: valueManager, valueType: valueType, wrapperVariant: wrapperVariant, validator: validator })=>{
    const { onAccept: onAccept, onChange: onChange, value: inValueWithoutRenderTimezone, defaultValue: inDefaultValue, closeOnSelect: closeOnSelect = wrapperVariant === 'desktop', timezone: timezoneProp, referenceDate: referenceDate } = props;
    const { current: defaultValue } = $7fPBF.useRef(inDefaultValue);
    const { current: isControlled } = $7fPBF.useRef(inValueWithoutRenderTimezone !== undefined);
    const [previousTimezoneProp, setPreviousTimezoneProp] = $7fPBF.useState(timezoneProp);
    /* eslint-enable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const adapter = (0, $6945e6366bb58773$export$4b5a24245de9f7f9)();
    const { isOpen: isOpen, setIsOpen: setIsOpen } = (0, $97abccf8a6b96579$export$7d3a09d5141ab1f4)(props);
    const { timezone: timezone, value: inValueWithTimezoneToRender, handleValueChange: handleValueChange } = (0, $a30ec645234d5ab0$export$c7e050e908c1b2bc)({
        timezone: timezoneProp,
        value: inValueWithoutRenderTimezone,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        valueManager: valueManager
    });
    const [dateState, setDateState] = $7fPBF.useState(()=>{
        let initialValue;
        if (inValueWithTimezoneToRender !== undefined) initialValue = inValueWithTimezoneToRender;
        else if (defaultValue !== undefined) initialValue = defaultValue;
        else initialValue = valueManager.emptyValue;
        return {
            draft: initialValue,
            lastPublishedValue: initialValue,
            lastCommittedValue: initialValue,
            lastControlledValue: inValueWithoutRenderTimezone,
            hasBeenModifiedSinceMount: false
        };
    });
    const timezoneFromDraftValue = valueManager.getTimezone(utils, dateState.draft);
    if (previousTimezoneProp !== timezoneProp) {
        setPreviousTimezoneProp(timezoneProp);
        if (timezoneProp && timezoneFromDraftValue && timezoneProp !== timezoneFromDraftValue) setDateState((prev)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prev, {
                draft: valueManager.setTimezone(utils, timezoneProp, prev.draft)
            }));
    }
    const { getValidationErrorForNewValue: getValidationErrorForNewValue } = (0, $0f340c8acb692073$export$87fe492f99f25a20)({
        props: props,
        validator: validator,
        timezone: timezone,
        value: dateState.draft,
        onError: props.onError
    });
    const updateDate = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((action)=>{
        const updaterParams = {
            action: action,
            dateState: dateState,
            hasChanged: (comparison)=>!valueManager.areValuesEqual(utils, action.value, comparison),
            isControlled: isControlled,
            closeOnSelect: closeOnSelect
        };
        const shouldPublish = $476ea41559631918$var$shouldPublishValue(updaterParams);
        const shouldCommit = $476ea41559631918$var$shouldCommitValue(updaterParams);
        const shouldClose = $476ea41559631918$var$shouldClosePicker(updaterParams);
        setDateState((prev)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prev, {
                draft: action.value,
                lastPublishedValue: shouldPublish ? action.value : prev.lastPublishedValue,
                lastCommittedValue: shouldCommit ? action.value : prev.lastCommittedValue,
                hasBeenModifiedSinceMount: true
            }));
        let cachedContext = null;
        const getContext = ()=>{
            if (!cachedContext) {
                const validationError = action.name === 'setValueFromField' ? action.context.validationError : getValidationErrorForNewValue(action.value);
                cachedContext = {
                    validationError: validationError
                };
                if (action.name === 'setValueFromShortcut') cachedContext.shortcut = action.shortcut;
            }
            return cachedContext;
        };
        if (shouldPublish) handleValueChange(action.value, getContext());
        if (shouldCommit && onAccept) onAccept(action.value, getContext());
        if (shouldClose) setIsOpen(false);
    });
    if (dateState.lastControlledValue !== inValueWithoutRenderTimezone) {
        const isUpdateComingFromPicker = valueManager.areValuesEqual(utils, dateState.draft, inValueWithTimezoneToRender);
        setDateState((prev)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prev, {
                lastControlledValue: inValueWithoutRenderTimezone
            }, isUpdateComingFromPicker ? {} : {
                lastCommittedValue: inValueWithTimezoneToRender,
                lastPublishedValue: inValueWithTimezoneToRender,
                draft: inValueWithTimezoneToRender,
                hasBeenModifiedSinceMount: true
            }));
    }
    const handleClear = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: valueManager.emptyValue,
            name: 'setValueFromAction',
            pickerAction: 'clear'
        });
    });
    const handleAccept = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastPublishedValue,
            name: 'setValueFromAction',
            pickerAction: 'accept'
        });
    });
    const handleDismiss = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastPublishedValue,
            name: 'setValueFromAction',
            pickerAction: 'dismiss'
        });
    });
    const handleCancel = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastCommittedValue,
            name: 'setValueFromAction',
            pickerAction: 'cancel'
        });
    });
    const handleSetToday = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: valueManager.getTodayValue(utils, timezone, valueType),
            name: 'setValueFromAction',
            pickerAction: 'today'
        });
    });
    const handleOpen = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event)=>{
        event.preventDefault();
        setIsOpen(true);
    });
    const handleClose = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event)=>{
        event?.preventDefault();
        setIsOpen(false);
    });
    const handleChange = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((newValue, selectionState = 'partial')=>updateDate({
            name: 'setValueFromView',
            value: newValue,
            selectionState: selectionState
        }));
    const handleSelectShortcut = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((newValue, changeImportance, shortcut)=>updateDate({
            name: 'setValueFromShortcut',
            value: newValue,
            changeImportance: changeImportance,
            shortcut: shortcut
        }));
    const handleChangeFromField = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((newValue, context)=>updateDate({
            name: 'setValueFromField',
            value: newValue,
            context: context
        }));
    const actions = {
        onClear: handleClear,
        onAccept: handleAccept,
        onDismiss: handleDismiss,
        onCancel: handleCancel,
        onSetToday: handleSetToday,
        onOpen: handleOpen,
        onClose: handleClose
    };
    const fieldResponse = {
        value: dateState.draft,
        onChange: handleChangeFromField
    };
    const viewValue = $7fPBF.useMemo(()=>valueManager.cleanValue(utils, dateState.draft), [
        utils,
        valueManager,
        dateState.draft
    ]);
    const viewResponse = {
        value: viewValue,
        onChange: handleChange,
        onClose: handleClose,
        open: isOpen
    };
    const isValid = (testedValue)=>{
        const error = validator({
            adapter: adapter,
            value: testedValue,
            timezone: timezone,
            props: props
        });
        return !valueManager.hasError(error);
    };
    const layoutResponse = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, actions, {
        value: viewValue,
        onChange: handleChange,
        onSelectShortcut: handleSelectShortcut,
        isValid: isValid
    });
    const contextValue = $7fPBF.useMemo(()=>({
            onOpen: handleOpen,
            onClose: handleClose,
            open: isOpen
        }), [
        isOpen,
        handleClose,
        handleOpen
    ]);
    return {
        open: isOpen,
        fieldProps: fieldResponse,
        viewProps: viewResponse,
        layoutProps: layoutResponse,
        actions: actions,
        contextValue: contextValue
    };
};





var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");


let $577bcba5433b0e3c$var$warnedOnceNotValidView = false;
function $577bcba5433b0e3c$export$9b46cba8f8ccd954({ onChange: onChange, onViewChange: onViewChange, openTo: openTo, view: inView, views: views, autoFocus: autoFocus, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange }) {
    const previousOpenTo = $7fPBF.useRef(openTo);
    const previousViews = $7fPBF.useRef(views);
    const defaultView = $7fPBF.useRef(views.includes(openTo) ? openTo : views[0]);
    const [view, setView] = (0, $bc6c881cebb96954$export$2e2bcd8739ae039)({
        name: 'useViews',
        state: 'view',
        controlled: inView,
        default: defaultView.current
    });
    const defaultFocusedView = $7fPBF.useRef(autoFocus ? view : null);
    const [focusedView, setFocusedView] = (0, $bc6c881cebb96954$export$2e2bcd8739ae039)({
        name: 'useViews',
        state: 'focusedView',
        controlled: inFocusedView,
        default: defaultFocusedView.current
    });
    $7fPBF.useEffect(()=>{
        // Update the current view when `openTo` or `views` props change
        if (previousOpenTo.current && previousOpenTo.current !== openTo || previousViews.current && previousViews.current.some((previousView)=>!views.includes(previousView))) {
            setView(views.includes(openTo) ? openTo : views[0]);
            previousViews.current = views;
            previousOpenTo.current = openTo;
        }
    }, [
        openTo,
        setView,
        view,
        views
    ]);
    const viewIndex = views.indexOf(view);
    const previousView = views[viewIndex - 1] ?? null;
    const nextView = views[viewIndex + 1] ?? null;
    const handleFocusedViewChange = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((viewToFocus, hasFocus)=>{
        if (hasFocus) // Focus event
        setFocusedView(viewToFocus);
        else // Blur event
        setFocusedView((prevFocusedView)=>viewToFocus === prevFocusedView ? null : prevFocusedView // If false the blur is due to view switching
        );
        onFocusedViewChange?.(viewToFocus, hasFocus);
    });
    const handleChangeView = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((newView)=>{
        // always keep the focused view in sync
        handleFocusedViewChange(newView, true);
        if (newView === view) return;
        setView(newView);
        if (onViewChange) onViewChange(newView);
    });
    const goToNextView = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)(()=>{
        if (nextView) handleChangeView(nextView);
    });
    const setValueAndGoToNextView = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((value, currentViewSelectionState, selectedView)=>{
        const isSelectionFinishedOnCurrentView = currentViewSelectionState === 'finish';
        const hasMoreViews = selectedView ? // handles case like `DateTimePicker`, where a view might return a `finish` selection state
        // but when it's not the final view given all `views` -> overall selection state should be `partial`.
        views.indexOf(selectedView) < views.length - 1 : Boolean(nextView);
        const globalSelectionState = isSelectionFinishedOnCurrentView && hasMoreViews ? 'partial' : currentViewSelectionState;
        onChange(value, globalSelectionState, selectedView);
        // Detects if the selected view is not the active one.
        // Can happen if multiple views are displayed, like in `DesktopDateTimePicker` or `MultiSectionDigitalClock`.
        if (selectedView && selectedView !== view) {
            const nextViewAfterSelected = views[views.indexOf(selectedView) + 1];
            if (nextViewAfterSelected) // move to next view after the selected one
            handleChangeView(nextViewAfterSelected);
        } else if (isSelectionFinishedOnCurrentView) goToNextView();
    });
    return {
        view: view,
        setView: handleChangeView,
        focusedView: focusedView,
        setFocusedView: handleFocusedViewChange,
        nextView: nextView,
        previousView: previousView,
        // Always return up-to-date default view instead of the initial one (i.e. defaultView.current)
        defaultView: views.includes(openTo) ? openTo : views[0],
        goToNextView: goToNextView,
        setValueAndGoToNextView: setValueAndGoToNextView
    };
}



const $91b52a6f82eabdf2$var$_excluded = [
    "className",
    "sx"
];
const $91b52a6f82eabdf2$export$c0a71b697a2df210 = ({ props: props, propsFromPickerValue: propsFromPickerValue, additionalViewProps: additionalViewProps, autoFocusView: autoFocusView, rendererInterceptor: rendererInterceptor, fieldRef: fieldRef })=>{
    const { onChange: onChange, open: open, onClose: onClose } = propsFromPickerValue;
    const { view: inView, views: views, openTo: openTo, onViewChange: onViewChange, viewRenderers: viewRenderers, timezone: timezone } = props;
    const propsToForwardToView = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $91b52a6f82eabdf2$var$_excluded);
    const { view: view, setView: setView, defaultView: defaultView, focusedView: focusedView, setFocusedView: setFocusedView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $577bcba5433b0e3c$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onChange: onChange,
        onViewChange: onViewChange,
        autoFocus: autoFocusView
    });
    const { hasUIView: hasUIView, viewModeLookup: viewModeLookup } = $7fPBF.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            let viewMode;
            if (viewRenderers[viewForReduce] != null) viewMode = 'UI';
            else viewMode = 'field';
            acc.viewModeLookup[viewForReduce] = viewMode;
            if (viewMode === 'UI') acc.hasUIView = true;
            return acc;
        }, {
            hasUIView: false,
            viewModeLookup: {}
        }), [
        viewRenderers,
        views
    ]);
    const timeViewsCount = $7fPBF.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            if (viewRenderers[viewForReduce] != null && (0, $cd9924d2cafbe16d$export$8f04d380cefd5a0d)(viewForReduce)) return acc + 1;
            return acc;
        }, 0), [
        viewRenderers,
        views
    ]);
    const currentViewMode = viewModeLookup[view];
    const shouldRestoreFocus = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)(()=>currentViewMode === 'UI');
    const [popperView, setPopperView] = $7fPBF.useState(currentViewMode === 'UI' ? view : null);
    if (popperView !== view && viewModeLookup[view] === 'UI') setPopperView(view);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        // Handle case of `DateTimePicker` without time renderers
        if (currentViewMode === 'field' && open) {
            onClose();
            setTimeout(()=>{
                fieldRef?.current?.setSelectedSections(view);
                // focusing the input before the range selection is done
                // calling it outside of timeout results in an inconsistent behavior between Safari And Chrome
                fieldRef?.current?.focusField(view);
            });
        }
    }, [
        view
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        if (!open) return;
        let newView = view;
        // If the current view is a field view, go to the last popper view
        if (currentViewMode === 'field' && popperView != null) newView = popperView;
        // If the current view is not the default view and both are UI views
        if (newView !== defaultView && viewModeLookup[newView] === 'UI' && viewModeLookup[defaultView] === 'UI') newView = defaultView;
        if (newView !== view) setView(newView);
        setFocusedView(newView, true);
    }, [
        open
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const layoutProps = {
        views: views,
        view: popperView,
        onViewChange: setView
    };
    return {
        hasUIView: hasUIView,
        shouldRestoreFocus: shouldRestoreFocus,
        layoutProps: layoutProps,
        renderCurrentView: ()=>{
            if (popperView == null) return null;
            const renderer = viewRenderers[popperView];
            if (renderer == null) return null;
            const rendererProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, propsToForwardToView, additionalViewProps, propsFromPickerValue, {
                views: views,
                timezone: timezone,
                onChange: setValueAndGoToNextView,
                view: popperView,
                onViewChange: setView,
                focusedView: focusedView,
                onFocusedViewChange: setFocusedView,
                showViewSwitcher: timeViewsCount > 1,
                timeViewsCount: timeViewsCount
            });
            if (rendererInterceptor) return rendererInterceptor(viewRenderers, popperView, rendererProps);
            return renderer(rendererProps);
        }
    };
};




var $7fPBF = parcelRequire("7fPBF");


'use client';
const $ef654b446fc390d6$var$RtlContext = /*#__PURE__*/ $7fPBF.createContext();
function $ef654b446fc390d6$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ef654b446fc390d6$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $ef654b446fc390d6$export$b2dd014b6c321cb = ()=>{
    const value = $7fPBF.useContext($ef654b446fc390d6$var$RtlContext);
    return value ?? false;
};
var $ef654b446fc390d6$export$2e2bcd8739ae039 = $ef654b446fc390d6$var$RtlProvider;



var $7fPBF = parcelRequire("7fPBF");


function $09cfc8723d2df359$var$getOrientation() {
    if (typeof window === 'undefined') return 'portrait';
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
    // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
    return 'portrait';
}
const $09cfc8723d2df359$export$6f60b24e37af6448 = (views, customOrientation)=>{
    const [orientation, setOrientation] = $7fPBF.useState($09cfc8723d2df359$var$getOrientation);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        const eventHandler = ()=>{
            setOrientation($09cfc8723d2df359$var$getOrientation());
        };
        window.addEventListener('orientationchange', eventHandler);
        return ()=>{
            window.removeEventListener('orientationchange', eventHandler);
        };
    }, []);
    if ((0, $e21804eb4bb13208$export$22012a5c726bef55)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) // could not display 13:34:44 in landscape mode
    return false;
    const orientationToUse = customOrientation || orientation;
    return orientationToUse === 'landscape';
};


const $42c3212b5eaac64d$export$4e5139e5825b7b27 = ({ props: props, propsFromPickerValue: propsFromPickerValue, propsFromPickerViews: propsFromPickerViews, wrapperVariant: wrapperVariant })=>{
    const { orientation: orientation } = props;
    const isLandscape = (0, $09cfc8723d2df359$export$6f60b24e37af6448)(propsFromPickerViews.views, orientation);
    const isRtl = (0, $ef654b446fc390d6$export$b2dd014b6c321cb)();
    const layoutProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, propsFromPickerViews, propsFromPickerValue, {
        isLandscape: isLandscape,
        isRtl: isRtl,
        wrapperVariant: wrapperVariant,
        disabled: props.disabled,
        readOnly: props.readOnly
    });
    return {
        layoutProps: layoutProps
    };
};



var $7fPBF = parcelRequire("7fPBF");
function $70bddc858039903f$export$cfaabb8dcad411b(parameters) {
    const { props: props, pickerValueResponse: pickerValueResponse } = parameters;
    return $7fPBF.useMemo(()=>({
            value: pickerValueResponse.viewProps.value,
            open: pickerValueResponse.open,
            disabled: props.disabled ?? false,
            readOnly: props.readOnly ?? false
        }), [
        pickerValueResponse.viewProps.value,
        pickerValueResponse.open,
        props.disabled,
        props.readOnly
    ]);
}


const $c317bbaffa35b5af$export$fc3313977ac596c4 = ({ props: props, valueManager: valueManager, valueType: valueType, wrapperVariant: wrapperVariant, additionalViewProps: additionalViewProps, validator: validator, autoFocusView: autoFocusView, rendererInterceptor: rendererInterceptor, fieldRef: fieldRef })=>{
    const pickerValueResponse = (0, $476ea41559631918$export$799b22a7b7fffaa3)({
        props: props,
        valueManager: valueManager,
        valueType: valueType,
        wrapperVariant: wrapperVariant,
        validator: validator
    });
    const pickerViewsResponse = (0, $91b52a6f82eabdf2$export$c0a71b697a2df210)({
        props: props,
        additionalViewProps: additionalViewProps,
        autoFocusView: autoFocusView,
        fieldRef: fieldRef,
        propsFromPickerValue: pickerValueResponse.viewProps,
        rendererInterceptor: rendererInterceptor
    });
    const pickerLayoutResponse = (0, $42c3212b5eaac64d$export$4e5139e5825b7b27)({
        props: props,
        wrapperVariant: wrapperVariant,
        propsFromPickerValue: pickerValueResponse.layoutProps,
        propsFromPickerViews: pickerViewsResponse.layoutProps
    });
    const pickerOwnerState = (0, $70bddc858039903f$export$cfaabb8dcad411b)({
        props: props,
        pickerValueResponse: pickerValueResponse
    });
    return {
        // Picker value
        open: pickerValueResponse.open,
        actions: pickerValueResponse.actions,
        fieldProps: pickerValueResponse.fieldProps,
        // Picker views
        renderCurrentView: pickerViewsResponse.renderCurrentView,
        hasUIView: pickerViewsResponse.hasUIView,
        shouldRestoreFocus: pickerViewsResponse.shouldRestoreFocus,
        // Picker layout
        layoutProps: pickerLayoutResponse.layoutProps,
        // Picker context
        contextValue: pickerValueResponse.contextValue,
        // Picker owner state
        ownerState: pickerOwnerState
    };
};



var $7fPBF = parcelRequire("7fPBF");






function $fca8ed2355aa4314$export$1671c31de798d429(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPickersLayout', slot);
}
const $fca8ed2355aa4314$export$7a6dac186703fe4c = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPickersLayout', [
    'root',
    'landscape',
    'contentWrapper',
    'toolbar',
    'actionBar',
    'tabs',
    'shortcuts'
]);



parcelRequire("7fPBF");




parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
















function $bf96407f1f5b4126$export$5a6f9035944c8119(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiButton', slot);
}
const $bf96407f1f5b4126$var$buttonClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge',
    'loading',
    'loadingWrapper',
    'loadingIconPlaceholder',
    'loadingIndicator',
    'loadingPositionCenter',
    'loadingPositionStart',
    'loadingPositionEnd'
]);
var $bf96407f1f5b4126$export$2e2bcd8739ae039 = $bf96407f1f5b4126$var$buttonClasses;



var $7fPBF = parcelRequire("7fPBF");
'use client';
/**
 * @ignore - internal component.
 */ const $40ed7573a59c2be9$var$ButtonGroupContext = /*#__PURE__*/ $7fPBF.createContext({});
var $40ed7573a59c2be9$export$2e2bcd8739ae039 = $40ed7573a59c2be9$var$ButtonGroupContext;



var $7fPBF = parcelRequire("7fPBF");
'use client';
/**
 * @ignore - internal component.
 */ const $e319f5c3a4402058$var$ButtonGroupButtonContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
var $e319f5c3a4402058$export$2e2bcd8739ae039 = $e319f5c3a4402058$var$ButtonGroupButtonContext;



'use client';
const $45be1777d6a28263$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            variant,
            `${variant}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            `${variant}Size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth',
            loading && `loadingPosition${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(loadingPosition)}`
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $bf96407f1f5b4126$export$5a6f9035944c8119), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $45be1777d6a28263$var$commonIconStyles = [
    {
        props: {
            size: 'small'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 18
            }
        }
    },
    {
        props: {
            size: 'medium'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 20
            }
        }
    },
    {
        props: {
            size: 'large'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 22
            }
        }
    }
];
const $45be1777d6a28263$var$ButtonRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $0820e164eb5fbaff$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth,
            ownerState.loading && styles.loading
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return {
        ...theme.typography.button,
        minWidth: 64,
        padding: '6px 16px',
        border: 0,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            textDecoration: 'none'
        },
        [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    color: `var(--variant-containedColor)`,
                    backgroundColor: `var(--variant-containedBg)`,
                    boxShadow: (theme.vars || theme).shadows[2],
                    '&:hover': {
                        boxShadow: (theme.vars || theme).shadows[4],
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            boxShadow: (theme.vars || theme).shadows[2]
                        }
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[8]
                    },
                    [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).focusVisible}`]: {
                        boxShadow: (theme.vars || theme).shadows[6]
                    },
                    [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.action.disabled,
                        boxShadow: (theme.vars || theme).shadows[0],
                        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    padding: '5px 15px',
                    border: '1px solid currentColor',
                    borderColor: `var(--variant-outlinedBorder, currentColor)`,
                    backgroundColor: `var(--variant-outlinedBg)`,
                    color: `var(--variant-outlinedColor)`,
                    [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).disabled}`]: {
                        border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    padding: '6px 8px',
                    color: `var(--variant-textColor)`,
                    backgroundColor: `var(--variant-textBg)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $061b5988a3817e26$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--variant-textColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedBorder': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.5)` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette[color].main, 0.5),
                        '--variant-containedColor': (theme.vars || theme).palette[color].contrastText,
                        '--variant-containedBg': (theme.vars || theme).palette[color].main,
                        '@media (hover: hover)': {
                            '&:hover': {
                                '--variant-containedBg': (theme.vars || theme).palette[color].dark,
                                '--variant-textBg': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '--variant-outlinedBorder': (theme.vars || theme).palette[color].main,
                                '--variant-outlinedBg': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                            }
                        }
                    }
                })),
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit',
                    borderColor: 'currentColor',
                    '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
                    '@media (hover: hover)': {
                        '&:hover': {
                            '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
                            '--variant-textBg': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                            '--variant-outlinedBg': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
                        }
                    }
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'text'
                },
                style: {
                    padding: '4px 5px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'text'
                },
                style: {
                    padding: '8px 11px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'outlined'
                },
                style: {
                    padding: '3px 9px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'outlined'
                },
                style: {
                    padding: '7px 21px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'contained'
                },
                style: {
                    padding: '4px 10px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'contained'
                },
                style: {
                    padding: '8px 22px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).focusVisible}`]: {
                        boxShadow: 'none'
                    },
                    '&:active': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).disabled}`]: {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    transition: theme.transitions.create([
                        'background-color',
                        'box-shadow',
                        'border-color'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).loading}`]: {
                        color: 'transparent'
                    }
                }
            }
        ]
    };
}));
const $45be1777d6a28263$var$ButtonStartIcon = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            ownerState.loading && styles.startIconLoadingStart,
            styles[`iconSize${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginLeft: -2
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginRight: -8
                }
            },
            ...$45be1777d6a28263$var$commonIconStyles
        ]
    }));
const $45be1777d6a28263$var$ButtonEndIcon = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            ownerState.loading && styles.endIconLoadingEnd,
            styles[`iconSize${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginRight: -2
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginLeft: -8
                }
            },
            ...$45be1777d6a28263$var$commonIconStyles
        ]
    }));
const $45be1777d6a28263$var$ButtonLoadingIndicator = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'LoadingIndicator',
    overridesResolver: (props, styles)=>styles.loadingIndicator
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            },
            {
                props: {
                    loadingPosition: 'start'
                },
                style: {
                    left: 14
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    size: 'small'
                },
                style: {
                    left: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'start'
                },
                style: {
                    left: 6
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%)',
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    loadingPosition: 'end'
                },
                style: {
                    right: 14
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    size: 'small'
                },
                style: {
                    right: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'end'
                },
                style: {
                    right: 6
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    left: -10
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    right: -10
                }
            }
        ]
    }));
const $45be1777d6a28263$var$ButtonLoadingIconPlaceholder = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'LoadingIconPlaceholder',
    overridesResolver: (props, styles)=>styles.loadingIconPlaceholder
})({
    display: 'inline-block',
    width: '1em',
    height: '1em'
});
const $45be1777d6a28263$var$Button = /*#__PURE__*/ $7fPBF.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $7fPBF.useContext((0, $40ed7573a59c2be9$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $7fPBF.useContext((0, $e319f5c3a4402058$export$2e2bcd8739ae039));
    const resolvedProps = (0, $bdfe01df7c24351f$export$2e2bcd8739ae039)(contextProps, inProps);
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = 'center', size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text', ...other } = props;
    const loadingId = (0, $8631184a92cee7e5$export$2e2bcd8739ae039)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d513166e63c42433$export$2e2bcd8739ae039), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        size: size,
        type: type,
        variant: variant
    };
    const classes = $45be1777d6a28263$var$useUtilityClasses(ownerState);
    const startIcon = (startIconProp || loading && loadingPosition === 'start') && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($45be1777d6a28263$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp || /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($45be1777d6a28263$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const endIcon = (endIconProp || loading && loadingPosition === 'end') && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($45be1777d6a28263$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp || /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($45be1777d6a28263$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    const loader = typeof loading === 'boolean' ? /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
    (0, $824c049f32d4395d$exports.jsx)("span", {
        className: classes.loadingWrapper,
        style: {
            display: 'contents'
        },
        children: loading && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($45be1777d6a28263$var$ButtonLoadingIndicator, {
            className: classes.loadingIndicator,
            ownerState: ownerState,
            children: loadingIndicator
        })
    }) : null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($45be1777d6a28263$var$ButtonRoot, {
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled || loading,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type,
        id: loading ? loadingId : idProp,
        ...other,
        classes: classes,
        children: [
            startIcon,
            loadingPosition !== 'end' && loader,
            children,
            loadingPosition === 'end' && loader,
            endIcon
        ]
    });
});
var $45be1777d6a28263$export$2e2bcd8739ae039 = $45be1777d6a28263$var$Button;





'use client';
const $8facba742bfbb34f$var$_excluded = [
    "onAccept",
    "onClear",
    "onCancel",
    "onSetToday",
    "actions"
];
/**
 * Demos:
 *
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersActionBar API](https://mui.com/x/api/date-pickers/pickers-action-bar/)
 */ function $8facba742bfbb34f$export$72ffda3bb7ecf665(props) {
    const { onAccept: onAccept, onClear: onClear, onCancel: onCancel, onSetToday: onSetToday, actions: actions } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $8facba742bfbb34f$var$_excluded);
    const translations = (0, $7fcfc9681bf68f23$export$3cdcc56057891b44)();
    if (actions == null || actions.length === 0) return null;
    const buttons = actions?.map((actionType)=>{
        switch(actionType){
            case 'clear':
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                    onClick: onClear,
                    children: translations.clearButtonLabel
                }, actionType);
            case 'cancel':
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                    onClick: onCancel,
                    children: translations.cancelButtonLabel
                }, actionType);
            case 'accept':
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                    onClick: onAccept,
                    children: translations.okButtonLabel
                }, actionType);
            case 'today':
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                    onClick: onSetToday,
                    children: translations.todayButtonLabel
                }, actionType);
            default:
                return null;
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, other, {
        children: buttons
    }));
}





parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");




parcelRequire("7fPBF");


'use client';
var $7a7f4684365c8e73$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');












function $d358322d03e9d644$export$31444911e4ee6fdd(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiChip', slot);
}
const $d358322d03e9d644$var$chipClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorDefault',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var $d358322d03e9d644$export$2e2bcd8739ae039 = $d358322d03e9d644$var$chipClasses;



'use client';
const $1a9e4fb2f535b4c3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            `${variant}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`
        ],
        label: [
            'label',
            `label${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            `avatarColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            `iconColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            `deleteIconColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            `deleteIcon${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(variant)}Color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $d358322d03e9d644$export$31444911e4ee6fdd), classes);
};
const $1a9e4fb2f535b4c3$var$ChipRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`]
            },
            {
                [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(iconColor)}`]
            },
            {
                [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`]
            },
            {
                [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(variant)}Color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`]
            },
            styles.root,
            styles[`size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`],
            styles[`color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`]
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return {
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${(0, $d358322d03e9d644$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 5,
            marginRight: -6
        },
        [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).deleteIcon}`]: {
            WebkitTapHighlightColor: 'transparent',
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.text.primary, 0.4)
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    height: 24,
                    [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).icon}`]: {
                        fontSize: 18,
                        marginLeft: 4,
                        marginRight: -4
                    },
                    [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).deleteIcon}`]: {
                        fontSize: 16,
                        marginRight: 4,
                        marginLeft: -4
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $061b5988a3817e26$export$2e2bcd8739ae039)([
                'contrastText'
            ])).map(([color])=>{
                return {
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText,
                        [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).deleteIcon}`]: {
                            color: theme.vars ? `rgba(${theme.vars.palette[color].contrastTextChannel} / 0.7)` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette[color].contrastText, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].contrastText
                            }
                        }
                    }
                };
            }),
            {
                props: (props)=>props.iconColor === props.color,
                style: {
                    [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).icon}`]: {
                        color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
                    }
                }
            },
            {
                props: (props)=>props.iconColor === props.color && props.color !== 'default',
                style: {
                    [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).icon}`]: {
                        color: 'inherit'
                    }
                }
            },
            {
                props: {
                    onDelete: true
                },
                style: {
                    [`&.${(0, $d358322d03e9d644$export$2e2bcd8739ae039).focusVisible}`]: {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $061b5988a3817e26$export$2e2bcd8739ae039)([
                'dark'
            ])).map(([color])=>{
                return {
                    props: {
                        color: color,
                        onDelete: true
                    },
                    style: {
                        [`&.${(0, $d358322d03e9d644$export$2e2bcd8739ae039).focusVisible}`]: {
                            background: (theme.vars || theme).palette[color].dark
                        }
                    }
                };
            }),
            {
                props: {
                    clickable: true
                },
                style: {
                    userSelect: 'none',
                    WebkitTapHighlightColor: 'transparent',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
                    },
                    [`&.${(0, $d358322d03e9d644$export$2e2bcd8739ae039).focusVisible}`]: {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[1]
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $061b5988a3817e26$export$2e2bcd8739ae039)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        color: color,
                        clickable: true
                    },
                    style: {
                        [`&:hover, &.${(0, $d358322d03e9d644$export$2e2bcd8739ae039).focusVisible}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                })),
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    backgroundColor: 'transparent',
                    border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
                    [`&.${(0, $d358322d03e9d644$export$2e2bcd8739ae039).clickable}:hover`]: {
                        backgroundColor: (theme.vars || theme).palette.action.hover
                    },
                    [`&.${(0, $d358322d03e9d644$export$2e2bcd8739ae039).focusVisible}`]: {
                        backgroundColor: (theme.vars || theme).palette.action.focus
                    },
                    [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).avatar}`]: {
                        marginLeft: 4
                    },
                    [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).avatarSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).icon}`]: {
                        marginLeft: 4
                    },
                    [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).iconSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).deleteIcon}`]: {
                        marginRight: 5
                    },
                    [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).deleteIconSmall}`]: {
                        marginRight: 3
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $061b5988a3817e26$export$2e2bcd8739ae039)()) // no need to check for mainChannel as it's calculated from main
            .map(([color])=>({
                    props: {
                        variant: 'outlined',
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main,
                        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.7)` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette[color].main, 0.7)}`,
                        [`&.${(0, $d358322d03e9d644$export$2e2bcd8739ae039).clickable}:hover`]: {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                        },
                        [`&.${(0, $d358322d03e9d644$export$2e2bcd8739ae039).focusVisible}`]: {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette[color].main, theme.palette.action.focusOpacity)
                        },
                        [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).deleteIcon}`]: {
                            color: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.7)` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette[color].main, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].main
                            }
                        }
                    }
                }))
        ]
    };
}));
const $1a9e4fb2f535b4c3$var$ChipLabel = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`]
        ];
    }
})({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingLeft: 12,
    paddingRight: 12,
    whiteSpace: 'nowrap',
    variants: [
        {
            props: {
                variant: 'outlined'
            },
            style: {
                paddingLeft: 11,
                paddingRight: 11
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                paddingLeft: 8,
                paddingRight: 8
            }
        },
        {
            props: {
                size: 'small',
                variant: 'outlined'
            },
            style: {
                paddingLeft: 7,
                paddingRight: 7
            }
        }
    ]
});
function $1a9e4fb2f535b4c3$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $1a9e4fb2f535b4c3$var$Chip = /*#__PURE__*/ $7fPBF.forwardRef(function Chip(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = 'medium', variant: variant = 'filled', tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false, // TODO v6: Rename to `focusableWhenDisabled`.
    ...other } = props;
    const chipRef = $7fPBF.useRef(null);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $1a9e4fb2f535b4c3$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $1a9e4fb2f535b4c3$var$isDeleteKeyboardEvent(event)) onDelete(event);
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039) : ComponentProp || 'div';
    const ownerState = {
        ...props,
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $7fPBF.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    };
    const classes = $1a9e4fb2f535b4c3$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039) ? {
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible,
        ...onDelete && {
            disableRipple: true
        }
    } : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $7fPBF.isValidElement(deleteIconProp) ? /*#__PURE__*/ $7fPBF.cloneElement(deleteIconProp, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7a7f4684365c8e73$export$2e2bcd8739ae039), {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $7fPBF.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $7fPBF.cloneElement(avatarProp, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $7fPBF.isValidElement(iconProp)) icon = /*#__PURE__*/ $7fPBF.cloneElement(iconProp, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($1a9e4fb2f535b4c3$var$ChipRoot, {
        as: component,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState,
        ...moreProps,
        ...other,
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1a9e4fb2f535b4c3$var$ChipLabel, {
                className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    });
});
var $1a9e4fb2f535b4c3$export$2e2bcd8739ae039 = $1a9e4fb2f535b4c3$var$Chip;


const $f49d2ca225f7bed5$export$3f0060ce4cc8f4d0 = 36;
const $f49d2ca225f7bed5$export$dde58b009b497666 = 2;
const $f49d2ca225f7bed5$export$ee46b8a74d6c94d3 = 320;
const $f49d2ca225f7bed5$export$73724491020e90c7 = 280;
const $f49d2ca225f7bed5$export$f2fef360e2df0cb7 = 336;
const $f49d2ca225f7bed5$export$1c2eabda4acea0e4 = 232;
const $f49d2ca225f7bed5$export$a462ceb9cfdb5d71 = 48;



'use client';
const $7e72c47dc598913d$var$_excluded = [
    "items",
    "changeImportance",
    "isLandscape",
    "onChange",
    "isValid"
], $7e72c47dc598913d$var$_excluded2 = [
    "getValue"
];
/**
 * Demos:
 *
 * - [Shortcuts](https://mui.com/x/react-date-pickers/shortcuts/)
 *
 * API:
 *
 * - [PickersShortcuts API](https://mui.com/x/api/date-pickers/pickers-shortcuts/)
 */ function $7e72c47dc598913d$export$8ba8fc65919fa1fe(props) {
    const { items: items, changeImportance: changeImportance = 'accept', onChange: onChange, isValid: isValid } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $7e72c47dc598913d$var$_excluded);
    if (items == null || items.length === 0) return null;
    const resolvedItems = items.map((_ref)=>{
        let { getValue: getValue } = _ref, item = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $7e72c47dc598913d$var$_excluded2);
        const newValue = getValue({
            isValid: isValid
        });
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, item, {
            label: item.label,
            onClick: ()=>{
                onChange(newValue, changeImportance, item);
            },
            disabled: !isValid(newValue)
        });
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb70212a09473954$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        dense: true,
        sx: [
            {
                maxHeight: (0, $f49d2ca225f7bed5$export$f2fef360e2df0cb7),
                maxWidth: 200,
                overflow: 'auto'
            },
            ...Array.isArray(other.sx) ? other.sx : [
                other.sx
            ]
        ]
    }, other, {
        children: resolvedItems.map((item)=>{
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2c1b031ce0fa2278$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a9e4fb2f535b4c3$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, item))
            }, item.id ?? item.label);
        })
    }));
}



'use client';
function $8110d6ade26cbc5c$var$toolbarHasView(toolbarProps) {
    return toolbarProps.view !== null;
}
const $8110d6ade26cbc5c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isLandscape: isLandscape } = ownerState;
    const slots = {
        root: [
            'root',
            isLandscape && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ],
        toolbar: [
            'toolbar'
        ],
        actionBar: [
            'actionBar'
        ],
        tabs: [
            'tabs'
        ],
        landscape: [
            'landscape'
        ],
        shortcuts: [
            'shortcuts'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $fca8ed2355aa4314$export$1671c31de798d429), classes);
};
const $8110d6ade26cbc5c$var$usePickerLayout = (props)=>{
    const { wrapperVariant: wrapperVariant, onAccept: onAccept, onClear: onClear, onCancel: onCancel, onSetToday: onSetToday, view: view, views: views, onViewChange: onViewChange, value: value, onChange: onChange, onSelectShortcut: onSelectShortcut, isValid: isValid, isLandscape: isLandscape, disabled: disabled, readOnly: readOnly, children: children, slots: slots, slotProps: slotProps } = props;
    const classes = $8110d6ade26cbc5c$var$useUtilityClasses(props);
    // Action bar
    const ActionBar = slots?.actionBar ?? (0, $8facba742bfbb34f$export$72ffda3bb7ecf665);
    const actionBarProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: ActionBar,
        externalSlotProps: slotProps?.actionBar,
        additionalProps: {
            onAccept: onAccept,
            onClear: onClear,
            onCancel: onCancel,
            onSetToday: onSetToday,
            actions: wrapperVariant === 'desktop' ? [] : [
                'cancel',
                'accept'
            ]
        },
        className: classes.actionBar,
        ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
            wrapperVariant: wrapperVariant
        })
    });
    const actionBar = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ActionBar, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, actionBarProps));
    // Toolbar
    const Toolbar = slots?.toolbar;
    const toolbarProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: Toolbar,
        externalSlotProps: slotProps?.toolbar,
        additionalProps: {
            isLandscape: isLandscape,
            onChange: onChange,
            value: value,
            view: view,
            onViewChange: onViewChange,
            views: views,
            disabled: disabled,
            readOnly: readOnly
        },
        className: classes.toolbar,
        ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
            wrapperVariant: wrapperVariant
        })
    });
    const toolbar = $8110d6ade26cbc5c$var$toolbarHasView(toolbarProps) && !!Toolbar ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Toolbar, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, toolbarProps)) : null;
    // Content
    const content = children;
    // Tabs
    const Tabs = slots?.tabs;
    const tabs = view && Tabs ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Tabs, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        view: view,
        onViewChange: onViewChange,
        className: classes.tabs
    }, slotProps?.tabs)) : null;
    // Shortcuts
    const Shortcuts = slots?.shortcuts ?? (0, $7e72c47dc598913d$export$8ba8fc65919fa1fe);
    const shortcutsProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: Shortcuts,
        externalSlotProps: slotProps?.shortcuts,
        additionalProps: {
            isValid: isValid,
            isLandscape: isLandscape,
            onChange: onSelectShortcut
        },
        className: classes.shortcuts,
        ownerState: {
            isValid: isValid,
            isLandscape: isLandscape,
            onChange: onSelectShortcut,
            wrapperVariant: wrapperVariant
        }
    });
    const shortcuts = view && !!Shortcuts ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Shortcuts, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, shortcutsProps)) : null;
    return {
        toolbar: toolbar,
        content: content,
        tabs: tabs,
        actionBar: actionBar,
        shortcuts: shortcuts
    };
};
var $8110d6ade26cbc5c$export$2e2bcd8739ae039 = $8110d6ade26cbc5c$var$usePickerLayout;



'use client';
const $0ea30ea295446df9$var$useUtilityClasses = (ownerState)=>{
    const { isLandscape: isLandscape, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            isLandscape && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $fca8ed2355aa4314$export$1671c31de798d429), classes);
};
const $0ea30ea295446df9$export$9a9363506c13836 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersLayout',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'grid',
    gridAutoColumns: 'max-content auto max-content',
    gridAutoRows: 'max-content auto max-content',
    [`& .${(0, $fca8ed2355aa4314$export$7a6dac186703fe4c).actionBar}`]: {
        gridColumn: '1 / 4',
        gridRow: 3
    },
    variants: [
        {
            props: {
                isLandscape: true
            },
            style: {
                [`& .${(0, $fca8ed2355aa4314$export$7a6dac186703fe4c).toolbar}`]: {
                    gridColumn: 1,
                    gridRow: '2 / 3'
                },
                [`.${(0, $fca8ed2355aa4314$export$7a6dac186703fe4c).shortcuts}`]: {
                    gridColumn: '2 / 4',
                    gridRow: 1
                }
            }
        },
        {
            props: {
                isLandscape: true,
                isRtl: true
            },
            style: {
                [`& .${(0, $fca8ed2355aa4314$export$7a6dac186703fe4c).toolbar}`]: {
                    gridColumn: 3
                }
            }
        },
        {
            props: {
                isLandscape: false
            },
            style: {
                [`& .${(0, $fca8ed2355aa4314$export$7a6dac186703fe4c).toolbar}`]: {
                    gridColumn: '2 / 4',
                    gridRow: 1
                },
                [`& .${(0, $fca8ed2355aa4314$export$7a6dac186703fe4c).shortcuts}`]: {
                    gridColumn: 1,
                    gridRow: '2 / 3'
                }
            }
        },
        {
            props: {
                isLandscape: false,
                isRtl: true
            },
            style: {
                [`& .${(0, $fca8ed2355aa4314$export$7a6dac186703fe4c).shortcuts}`]: {
                    gridColumn: 3
                }
            }
        }
    ]
});
const $0ea30ea295446df9$export$bc1494d918129235 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersLayout',
    slot: 'ContentWrapper',
    overridesResolver: (props, styles)=>styles.contentWrapper
})({
    gridColumn: 2,
    gridRow: 2,
    display: 'flex',
    flexDirection: 'column'
});
/**
 * Demos:
 *
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersLayout API](https://mui.com/x/api/date-pickers/pickers-layout/)
 */ const $0ea30ea295446df9$export$647f604ea2397c05 = /*#__PURE__*/ $7fPBF.forwardRef(function PickersLayout(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersLayout'
    });
    const { toolbar: toolbar, content: content, tabs: tabs, actionBar: actionBar, shortcuts: shortcuts } = (0, $8110d6ade26cbc5c$export$2e2bcd8739ae039)(props);
    const { sx: sx, className: className, isLandscape: isLandscape, wrapperVariant: wrapperVariant } = props;
    const classes = $0ea30ea295446df9$var$useUtilityClasses(props);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($0ea30ea295446df9$export$9a9363506c13836, {
        ref: ref,
        sx: sx,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: props,
        children: [
            isLandscape ? shortcuts : toolbar,
            isLandscape ? toolbar : shortcuts,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0ea30ea295446df9$export$bc1494d918129235, {
                className: classes.contentWrapper,
                children: wrapperVariant === 'desktop' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
                    children: [
                        content,
                        tabs
                    ]
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
                    children: [
                        tabs,
                        content
                    ]
                })
            }),
            actionBar
        ]
    });
});



var $7fPBF = parcelRequire("7fPBF");


const $71a24d8fbea898bf$export$38de57b7f4a44eea = /*#__PURE__*/ $7fPBF.createContext(null);
function $71a24d8fbea898bf$export$38e969d523d4d57f(props) {
    const { contextValue: contextValue, localeText: localeText, children: children } = props;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($71a24d8fbea898bf$export$38de57b7f4a44eea.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cbc6c65ed9f8bf86$export$dc45bdc734ce6f1e), {
            localeText: localeText,
            children: children
        })
    });
}



const $c74981cd2400164c$var$_excluded = [
    "props",
    "getOpenDialogAriaText"
], $c74981cd2400164c$var$_excluded2 = [
    "ownerState"
], $c74981cd2400164c$var$_excluded3 = [
    "ownerState"
];
const $c74981cd2400164c$export$b1b70bc56ac5be0e = (_ref)=>{
    let { props: props, getOpenDialogAriaText: getOpenDialogAriaText } = _ref, pickerParams = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $c74981cd2400164c$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, className: className, sx: sx, format: format, formatDensity: formatDensity, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure, selectedSections: selectedSections, onSelectedSectionsChange: onSelectedSectionsChange, timezone: timezone, name: name, label: label, inputRef: inputRef, readOnly: readOnly, disabled: disabled, autoFocus: autoFocus, localeText: localeText, reduceAnimations: reduceAnimations } = props;
    const containerRef = $7fPBF.useRef(null);
    const fieldRef = $7fPBF.useRef(null);
    const labelId = (0, $46f5b561912058f9$export$2e2bcd8739ae039)();
    const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
    const { open: open, actions: actions, hasUIView: hasUIView, layoutProps: layoutProps, renderCurrentView: renderCurrentView, shouldRestoreFocus: shouldRestoreFocus, fieldProps: pickerFieldProps, contextValue: contextValue, ownerState: ownerState } = (0, $c317bbaffa35b5af$export$fc3313977ac596c4)((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, pickerParams, {
        props: props,
        fieldRef: fieldRef,
        autoFocusView: true,
        additionalViewProps: {},
        wrapperVariant: 'desktop'
    }));
    const InputAdornment = slots.inputAdornment ?? (0, $a1383c8904b71ac9$export$2e2bcd8739ae039);
    const _useSlotProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: InputAdornment,
        externalSlotProps: innerSlotProps?.inputAdornment,
        additionalProps: {
            position: 'end'
        },
        ownerState: props
    }), inputAdornmentProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useSlotProps, $c74981cd2400164c$var$_excluded2);
    const OpenPickerButton = slots.openPickerButton ?? (0, $67a243c492197f3b$export$2e2bcd8739ae039);
    const _useSlotProps2 = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: OpenPickerButton,
        externalSlotProps: innerSlotProps?.openPickerButton,
        additionalProps: {
            disabled: disabled || readOnly,
            onClick: open ? actions.onClose : actions.onOpen,
            'aria-label': getOpenDialogAriaText(pickerFieldProps.value),
            edge: inputAdornmentProps.position
        },
        ownerState: props
    }), openPickerButtonProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useSlotProps2, $c74981cd2400164c$var$_excluded3);
    const OpenPickerIcon = slots.openPickerIcon;
    const openPickerIconProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: OpenPickerIcon,
        externalSlotProps: innerSlotProps?.openPickerIcon,
        ownerState: ownerState
    });
    const Field = slots.field;
    const fieldProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: Field,
        externalSlotProps: innerSlotProps?.field,
        additionalProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, pickerFieldProps, isToolbarHidden && {
            id: labelId
        }, {
            readOnly: readOnly,
            disabled: disabled,
            className: className,
            sx: sx,
            format: format,
            formatDensity: formatDensity,
            enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            selectedSections: selectedSections,
            onSelectedSectionsChange: onSelectedSectionsChange,
            timezone: timezone,
            label: label,
            name: name,
            autoFocus: autoFocus && !props.open,
            focused: open ? true : undefined
        }, inputRef ? {
            inputRef: inputRef
        } : {}),
        ownerState: props
    });
    // TODO: Move to `useSlotProps` when https://github.com/mui/material-ui/pull/35088 will be merged
    if (hasUIView) fieldProps.InputProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, fieldProps.InputProps, {
        ref: containerRef
    }, !props.disableOpenPicker && {
        [`${inputAdornmentProps.position}Adornment`]: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(InputAdornment, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, inputAdornmentProps, {
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(OpenPickerButton, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, openPickerButtonProps, {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(OpenPickerIcon, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, openPickerIconProps))
            }))
        }))
    });
    const slotsForField = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        textField: slots.textField,
        clearIcon: slots.clearIcon,
        clearButton: slots.clearButton
    }, fieldProps.slots);
    const Layout = slots.layout ?? (0, $0ea30ea295446df9$export$647f604ea2397c05);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, innerSlotProps, {
        toolbar: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, innerSlotProps?.toolbar, {
            titleId: labelId
        }),
        popper: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            'aria-labelledby': labelledById
        }, innerSlotProps?.popper)
    });
    const handleFieldRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(fieldRef, fieldProps.unstableFieldRef);
    const renderPicker = ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $71a24d8fbea898bf$export$38e969d523d4d57f), {
            contextValue: contextValue,
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Field, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, fieldProps, {
                    slots: slotsForField,
                    slotProps: slotProps,
                    unstableFieldRef: handleFieldRef
                })),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $df2366d35b337352$export$96ce8482474de8a5), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    role: "dialog",
                    placement: "bottom-start",
                    anchorEl: containerRef.current
                }, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    shouldRestoreFocus: shouldRestoreFocus,
                    reduceAnimations: reduceAnimations,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Layout, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, layoutProps, slotProps?.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker: renderPicker
    };
};




var $7fPBF = parcelRequire("7fPBF");

const $27f114a7ae98fe28$export$ed0fe318cc298673 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');
const $27f114a7ae98fe28$export$8afed21ef5c2afa5 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'ArrowLeft');
const $27f114a7ae98fe28$export$9ca09caa9c849d9c = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'ArrowRight');
const $27f114a7ae98fe28$export$5fda1783bb83f57b = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), 'Calendar');
const $27f114a7ae98fe28$export$8099ab97743c966c = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
    children: [
        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Clock');
const $27f114a7ae98fe28$export$90a8eab2a2411720 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), 'DateRange');
const $27f114a7ae98fe28$export$7e95adcf912503e3 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
    children: [
        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Time');
const $27f114a7ae98fe28$export$cefbac224a47f32 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');





var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");







const $3596328593c3ace4$var$expandFormat = ({ utils: utils, format: format })=>{
    // Expand the provided format
    let formatExpansionOverflow = 10;
    let prevFormat = format;
    let nextFormat = utils.expandFormat(format);
    while(nextFormat !== prevFormat){
        prevFormat = nextFormat;
        nextFormat = utils.expandFormat(prevFormat);
        formatExpansionOverflow -= 1;
        if (formatExpansionOverflow < 0) throw new Error('MUI X: The format expansion seems to be in an infinite loop. Please open an issue with the format passed to the picker component.');
    }
    return nextFormat;
};
const $3596328593c3ace4$var$getEscapedPartsFromFormat = ({ utils: utils, expandedFormat: expandedFormat })=>{
    const escapedParts = [];
    const { start: startChar, end: endChar } = utils.escapedCharacters;
    const regExp = new RegExp(`(\\${startChar}[^\\${endChar}]*\\${endChar})+`, 'g');
    let match = null;
    // eslint-disable-next-line no-cond-assign
    while(match = regExp.exec(expandedFormat))escapedParts.push({
        start: match.index,
        end: regExp.lastIndex - 1
    });
    return escapedParts;
};
const $3596328593c3ace4$var$getSectionPlaceholder = (utils, localeText, sectionConfig, sectionFormat)=>{
    switch(sectionConfig.type){
        case 'year':
            return localeText.fieldYearPlaceholder({
                digitAmount: utils.formatByString(utils.date(undefined, 'default'), sectionFormat).length,
                format: sectionFormat
            });
        case 'month':
            return localeText.fieldMonthPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case 'day':
            return localeText.fieldDayPlaceholder({
                format: sectionFormat
            });
        case 'weekDay':
            return localeText.fieldWeekDayPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case 'hours':
            return localeText.fieldHoursPlaceholder({
                format: sectionFormat
            });
        case 'minutes':
            return localeText.fieldMinutesPlaceholder({
                format: sectionFormat
            });
        case 'seconds':
            return localeText.fieldSecondsPlaceholder({
                format: sectionFormat
            });
        case 'meridiem':
            return localeText.fieldMeridiemPlaceholder({
                format: sectionFormat
            });
        default:
            return sectionFormat;
    }
};
const $3596328593c3ace4$var$createSection = ({ utils: utils, date: date, shouldRespectLeadingZeros: shouldRespectLeadingZeros, localeText: localeText, localizedDigits: localizedDigits, now: now, token: token, startSeparator: startSeparator })=>{
    if (token === '') throw new Error('MUI X: Should not call `commitToken` with an empty token');
    const sectionConfig = (0, $7692508c11d587c8$export$2f3c5fac7a2a65f6)(utils, token);
    const hasLeadingZerosInFormat = (0, $7692508c11d587c8$export$78b5830e2dd2de49)(utils, sectionConfig.contentType, sectionConfig.type, token);
    const hasLeadingZerosInInput = shouldRespectLeadingZeros ? hasLeadingZerosInFormat : sectionConfig.contentType === 'digit';
    const isValidDate = date != null && utils.isValid(date);
    let sectionValue = isValidDate ? utils.formatByString(date, token) : '';
    let maxLength = null;
    if (hasLeadingZerosInInput) {
        if (hasLeadingZerosInFormat) maxLength = sectionValue === '' ? utils.formatByString(now, token).length : sectionValue.length;
        else {
            if (sectionConfig.maxLength == null) throw new Error(`MUI X: The token ${token} should have a 'maxDigitNumber' property on it's adapter`);
            maxLength = sectionConfig.maxLength;
            if (isValidDate) sectionValue = (0, $7692508c11d587c8$export$80dbbc19eba82070)((0, $7692508c11d587c8$export$713c6d756c12fc27)((0, $7692508c11d587c8$export$7dd321105a319e8)(sectionValue, localizedDigits), maxLength), localizedDigits);
        }
    }
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, sectionConfig, {
        format: token,
        maxLength: maxLength,
        value: sectionValue,
        placeholder: $3596328593c3ace4$var$getSectionPlaceholder(utils, localeText, sectionConfig, token),
        hasLeadingZerosInFormat: hasLeadingZerosInFormat,
        hasLeadingZerosInInput: hasLeadingZerosInInput,
        startSeparator: startSeparator,
        endSeparator: '',
        modified: false
    });
};
const $3596328593c3ace4$var$buildSections = (params)=>{
    const { utils: utils, expandedFormat: expandedFormat, escapedParts: escapedParts } = params;
    const now = utils.date(undefined);
    const sections = [];
    let startSeparator = '';
    // This RegExp tests if the beginning of a string corresponds to a supported token
    const validTokens = Object.keys(utils.formatTokenMap).sort((a, b)=>b.length - a.length); // Sort to put longest word first
    const regExpFirstWordInFormat = /^([a-zA-Z]+)/;
    const regExpWordOnlyComposedOfTokens = new RegExp(`^(${validTokens.join('|')})*$`);
    const regExpFirstTokenInWord = new RegExp(`^(${validTokens.join('|')})`);
    const getEscapedPartOfCurrentChar = (i)=>escapedParts.find((escapeIndex)=>escapeIndex.start <= i && escapeIndex.end >= i);
    let i = 0;
    while(i < expandedFormat.length){
        const escapedPartOfCurrentChar = getEscapedPartOfCurrentChar(i);
        const isEscapedChar = escapedPartOfCurrentChar != null;
        const firstWordInFormat = regExpFirstWordInFormat.exec(expandedFormat.slice(i))?.[1];
        // The first word in the format is only composed of tokens.
        // We extract those tokens to create a new sections.
        if (!isEscapedChar && firstWordInFormat != null && regExpWordOnlyComposedOfTokens.test(firstWordInFormat)) {
            let word = firstWordInFormat;
            while(word.length > 0){
                const firstWord = regExpFirstTokenInWord.exec(word)[1];
                word = word.slice(firstWord.length);
                sections.push($3596328593c3ace4$var$createSection((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, params, {
                    now: now,
                    token: firstWord,
                    startSeparator: startSeparator
                })));
                startSeparator = '';
            }
            i += firstWordInFormat.length;
        } else {
            const char = expandedFormat[i];
            // If we are on the opening or closing character of an escaped part of the format,
            // Then we ignore this character.
            const isEscapeBoundary = isEscapedChar && escapedPartOfCurrentChar?.start === i || escapedPartOfCurrentChar?.end === i;
            if (!isEscapeBoundary) {
                if (sections.length === 0) startSeparator += char;
                else sections[sections.length - 1].endSeparator += char;
            }
            i += 1;
        }
    }
    if (sections.length === 0 && startSeparator.length > 0) sections.push({
        type: 'empty',
        contentType: 'letter',
        maxLength: null,
        format: '',
        value: '',
        placeholder: '',
        hasLeadingZerosInFormat: false,
        hasLeadingZerosInInput: false,
        startSeparator: startSeparator,
        endSeparator: '',
        modified: false
    });
    return sections;
};
const $3596328593c3ace4$var$postProcessSections = ({ isRtl: isRtl, formatDensity: formatDensity, sections: sections })=>{
    return sections.map((section)=>{
        const cleanSeparator = (separator)=>{
            let cleanedSeparator = separator;
            if (isRtl && cleanedSeparator !== null && cleanedSeparator.includes(' ')) cleanedSeparator = `\u2069${cleanedSeparator}\u2066`;
            if (formatDensity === 'spacious' && [
                '/',
                '.',
                '-'
            ].includes(cleanedSeparator)) cleanedSeparator = ` ${cleanedSeparator} `;
            return cleanedSeparator;
        };
        section.startSeparator = cleanSeparator(section.startSeparator);
        section.endSeparator = cleanSeparator(section.endSeparator);
        return section;
    });
};
const $3596328593c3ace4$export$34084be60bfe3b3b = (params)=>{
    let expandedFormat = $3596328593c3ace4$var$expandFormat(params);
    if (params.isRtl && params.enableAccessibleFieldDOMStructure) expandedFormat = expandedFormat.split(' ').reverse().join(' ');
    const escapedParts = $3596328593c3ace4$var$getEscapedPartsFromFormat((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, params, {
        expandedFormat: expandedFormat
    }));
    const sections = $3596328593c3ace4$var$buildSections((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, params, {
        expandedFormat: expandedFormat,
        escapedParts: escapedParts
    }));
    return $3596328593c3ace4$var$postProcessSections((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, params, {
        sections: sections
    }));
};




const $ab6e023aa9d06979$export$4e8d6353e50062e7 = (params)=>{
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const translations = (0, $7fcfc9681bf68f23$export$3cdcc56057891b44)();
    const adapter = (0, $6945e6366bb58773$export$4b5a24245de9f7f9)();
    const isRtl = (0, $ef654b446fc390d6$export$b2dd014b6c321cb)();
    const { valueManager: valueManager, fieldValueManager: fieldValueManager, valueType: valueType, validator: validator, internalProps: internalProps, internalProps: { value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, onChange: onChange, format: format, formatDensity: formatDensity = 'dense', selectedSections: selectedSectionsProp, onSelectedSectionsChange: onSelectedSectionsChange, shouldRespectLeadingZeros: shouldRespectLeadingZeros = false, timezone: timezoneProp, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure = false } } = params;
    const { timezone: timezone, value: valueFromTheOutside, handleValueChange: handleValueChange } = (0, $a30ec645234d5ab0$export$c7e050e908c1b2bc)({
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: valueManager
    });
    const localizedDigits = $7fPBF.useMemo(()=>(0, $7692508c11d587c8$export$b42be9ae7016ef5d)(utils), [
        utils
    ]);
    const sectionsValueBoundaries = $7fPBF.useMemo(()=>(0, $7692508c11d587c8$export$360600f456ea7d5f)(utils, localizedDigits, timezone), [
        utils,
        localizedDigits,
        timezone
    ]);
    const getSectionsFromValue = $7fPBF.useCallback((value, fallbackSections = null)=>fieldValueManager.getSectionsFromValue(utils, value, fallbackSections, (date)=>(0, $3596328593c3ace4$export$34084be60bfe3b3b)({
                utils: utils,
                localeText: translations,
                localizedDigits: localizedDigits,
                format: format,
                date: date,
                formatDensity: formatDensity,
                shouldRespectLeadingZeros: shouldRespectLeadingZeros,
                enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
                isRtl: isRtl
            })), [
        fieldValueManager,
        format,
        translations,
        localizedDigits,
        isRtl,
        shouldRespectLeadingZeros,
        utils,
        formatDensity,
        enableAccessibleFieldDOMStructure
    ]);
    const [state, setState] = $7fPBF.useState(()=>{
        const sections = getSectionsFromValue(valueFromTheOutside);
        (0, $7692508c11d587c8$export$ef6fbc09372bd65c)(sections, valueType);
        const stateWithoutReferenceDate = {
            sections: sections,
            value: valueFromTheOutside,
            referenceValue: valueManager.emptyValue,
            tempValueStrAndroid: null
        };
        const granularity = (0, $03cf12356675f79b$export$3f2547ddf892237a)(sections);
        const referenceValue = valueManager.getInitialReferenceValue({
            referenceDate: referenceDateProp,
            value: valueFromTheOutside,
            utils: utils,
            props: internalProps,
            granularity: granularity,
            timezone: timezone
        });
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, stateWithoutReferenceDate, {
            referenceValue: referenceValue
        });
    });
    const [selectedSections, innerSetSelectedSections] = (0, $bc6c881cebb96954$export$2e2bcd8739ae039)({
        controlled: selectedSectionsProp,
        default: null,
        name: 'useField',
        state: 'selectedSections'
    });
    const setSelectedSections = (newSelectedSections)=>{
        innerSetSelectedSections(newSelectedSections);
        onSelectedSectionsChange?.(newSelectedSections);
    };
    const parsedSelectedSections = $7fPBF.useMemo(()=>(0, $7692508c11d587c8$export$b31f27a6e35a0b27)(selectedSections, state.sections), [
        selectedSections,
        state.sections
    ]);
    const activeSectionIndex = parsedSelectedSections === 'all' ? 0 : parsedSelectedSections;
    const publishValue = ({ value: value, referenceValue: referenceValue, sections: sections })=>{
        setState((prevState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prevState, {
                sections: sections,
                value: value,
                referenceValue: referenceValue,
                tempValueStrAndroid: null
            }));
        if (valueManager.areValuesEqual(utils, state.value, value)) return;
        const context = {
            validationError: validator({
                adapter: adapter,
                value: value,
                timezone: timezone,
                props: internalProps
            })
        };
        handleValueChange(value, context);
    };
    const setSectionValue = (sectionIndex, newSectionValue)=>{
        const newSections = [
            ...state.sections
        ];
        newSections[sectionIndex] = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, newSections[sectionIndex], {
            value: newSectionValue,
            modified: true
        });
        return newSections;
    };
    const clearValue = ()=>{
        publishValue({
            value: valueManager.emptyValue,
            referenceValue: state.referenceValue,
            sections: getSectionsFromValue(valueManager.emptyValue)
        });
    };
    const clearActiveSection = ()=>{
        if (activeSectionIndex == null) return;
        const activeSection = state.sections[activeSectionIndex];
        const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
        const nonEmptySectionCountBefore = activeDateManager.getSections(state.sections).filter((section)=>section.value !== '').length;
        const hasNoOtherNonEmptySections = nonEmptySectionCountBefore === (activeSection.value === '' ? 0 : 1);
        const newSections = setSectionValue(activeSectionIndex, '');
        const newActiveDate = hasNoOtherNonEmptySections ? null : utils.getInvalidDate();
        const newValues = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
        publishValue((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, newValues, {
            sections: newSections
        }));
    };
    const updateValueFromValueStr = (valueStr)=>{
        const parseDateStr = (dateStr, referenceDate)=>{
            const date = utils.parse(dateStr, format);
            if (date == null || !utils.isValid(date)) return null;
            const sections = (0, $3596328593c3ace4$export$34084be60bfe3b3b)({
                utils: utils,
                localeText: translations,
                localizedDigits: localizedDigits,
                format: format,
                date: date,
                formatDensity: formatDensity,
                shouldRespectLeadingZeros: shouldRespectLeadingZeros,
                enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
                isRtl: isRtl
            });
            return (0, $7692508c11d587c8$export$6c6df982c77f60a9)(utils, date, sections, referenceDate, false);
        };
        const newValue = fieldValueManager.parseValueStr(valueStr, state.referenceValue, parseDateStr);
        const newReferenceValue = fieldValueManager.updateReferenceValue(utils, newValue, state.referenceValue);
        publishValue({
            value: newValue,
            referenceValue: newReferenceValue,
            sections: getSectionsFromValue(newValue, state.sections)
        });
    };
    const updateSectionValue = ({ activeSection: activeSection, newSectionValue: newSectionValue, shouldGoToNextSection: shouldGoToNextSection })=>{
        /**
     * 1. Decide which section should be focused
     */ if (shouldGoToNextSection && activeSectionIndex < state.sections.length - 1) setSelectedSections(activeSectionIndex + 1);
        /**
     * 2. Try to build a valid date from the new section value
     */ const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
        const newSections = setSectionValue(activeSectionIndex, newSectionValue);
        const newActiveDateSections = activeDateManager.getSections(newSections);
        const newActiveDate = (0, $7692508c11d587c8$export$b0c1bfd065bfe742)(utils, newActiveDateSections, localizedDigits);
        let values;
        let shouldPublish;
        /**
     * If the new date is valid,
     * Then we merge the value of the modified sections into the reference date.
     * This makes sure that we don't lose some information of the initial date (like the time on a date field).
     */ if (newActiveDate != null && utils.isValid(newActiveDate)) {
            const mergedDate = (0, $7692508c11d587c8$export$6c6df982c77f60a9)(utils, newActiveDate, newActiveDateSections, activeDateManager.referenceDate, true);
            values = activeDateManager.getNewValuesFromNewActiveDate(mergedDate);
            shouldPublish = true;
        } else {
            values = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
            shouldPublish = (newActiveDate != null && !utils.isValid(newActiveDate)) !== (activeDateManager.date != null && !utils.isValid(activeDateManager.date));
        }
        /**
     * Publish or update the internal state with the new value and sections.
     */ if (shouldPublish) return publishValue((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, values, {
            sections: newSections
        }));
        return setState((prevState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prevState, values, {
                sections: newSections,
                tempValueStrAndroid: null
            }));
    };
    const setTempAndroidValueStr = (tempValueStrAndroid)=>setState((prev)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prev, {
                tempValueStrAndroid: tempValueStrAndroid
            }));
    $7fPBF.useEffect(()=>{
        const sections = getSectionsFromValue(state.value);
        (0, $7692508c11d587c8$export$ef6fbc09372bd65c)(sections, valueType);
        setState((prevState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prevState, {
                sections: sections
            }));
    }, [
        format,
        utils.locale,
        isRtl
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    $7fPBF.useEffect(()=>{
        let shouldUpdate;
        if (!valueManager.areValuesEqual(utils, state.value, valueFromTheOutside)) shouldUpdate = true;
        else shouldUpdate = valueManager.getTimezone(utils, state.value) !== valueManager.getTimezone(utils, valueFromTheOutside);
        if (shouldUpdate) setState((prevState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prevState, {
                value: valueFromTheOutside,
                referenceValue: fieldValueManager.updateReferenceValue(utils, valueFromTheOutside, prevState.referenceValue),
                sections: getSectionsFromValue(valueFromTheOutside)
            }));
    }, [
        valueFromTheOutside
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        state: state,
        activeSectionIndex: activeSectionIndex,
        parsedSelectedSections: parsedSelectedSections,
        setSelectedSections: setSelectedSections,
        clearValue: clearValue,
        clearActiveSection: clearActiveSection,
        updateSectionValue: updateSectionValue,
        updateValueFromValueStr: updateValueFromValueStr,
        setTempAndroidValueStr: setTempAndroidValueStr,
        getSectionsFromValue: getSectionsFromValue,
        sectionsValueBoundaries: sectionsValueBoundaries,
        localizedDigits: localizedDigits,
        timezone: timezone
    };
};




var $7fPBF = parcelRequire("7fPBF");



/**
 * The letter editing and the numeric editing each define a `CharacterEditingApplier`.
 * This function decides what the new section value should be and if the focus should switch to the next section.
 *
 * If it returns `null`, then the section value is not updated and the focus does not move.
 */ /**
 * Function called by `applyQuery` which decides:
 * - what is the new section value ?
 * - should the query used to get this value be stored for the next key press ?
 *
 * If it returns `{ sectionValue: string; shouldGoToNextSection: boolean }`,
 * Then we store the query and update the section with the new value.
 *
 * If it returns `{ saveQuery: true` },
 * Then we store the query and don't update the section.
 *
 * If it returns `{ saveQuery: false },
 * Then we do nothing.
 */ const $de4ce65a55c75bbb$var$QUERY_LIFE_DURATION_MS = 5000;
const $de4ce65a55c75bbb$var$isQueryResponseWithoutValue = (response)=>response.saveQuery != null;
const $de4ce65a55c75bbb$export$66d00048b8bb82f6 = ({ sections: sections, updateSectionValue: updateSectionValue, sectionsValueBoundaries: sectionsValueBoundaries, localizedDigits: localizedDigits, setTempAndroidValueStr: setTempAndroidValueStr, timezone: timezone })=>{
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const [query, setQuery] = $7fPBF.useState(null);
    const resetQuery = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)(()=>setQuery(null));
    $7fPBF.useEffect(()=>{
        if (query != null && sections[query.sectionIndex]?.type !== query.sectionType) resetQuery();
    }, [
        sections,
        query,
        resetQuery
    ]);
    $7fPBF.useEffect(()=>{
        if (query != null) {
            const timeout = setTimeout(()=>resetQuery(), $de4ce65a55c75bbb$var$QUERY_LIFE_DURATION_MS);
            return ()=>{
                clearTimeout(timeout);
            };
        }
        return ()=>{};
    }, [
        query,
        resetQuery
    ]);
    const applyQuery = ({ keyPressed: keyPressed, sectionIndex: sectionIndex }, getFirstSectionValueMatchingWithQuery, isValidQueryValue)=>{
        const cleanKeyPressed = keyPressed.toLowerCase();
        const activeSection = sections[sectionIndex];
        // The current query targets the section being editing
        // We can try to concatenate the value
        if (query != null && (!isValidQueryValue || isValidQueryValue(query.value)) && query.sectionIndex === sectionIndex) {
            const concatenatedQueryValue = `${query.value}${cleanKeyPressed}`;
            const queryResponse = getFirstSectionValueMatchingWithQuery(concatenatedQueryValue, activeSection);
            if (!$de4ce65a55c75bbb$var$isQueryResponseWithoutValue(queryResponse)) {
                setQuery({
                    sectionIndex: sectionIndex,
                    value: concatenatedQueryValue,
                    sectionType: activeSection.type
                });
                return queryResponse;
            }
        }
        const queryResponse = getFirstSectionValueMatchingWithQuery(cleanKeyPressed, activeSection);
        if ($de4ce65a55c75bbb$var$isQueryResponseWithoutValue(queryResponse) && !queryResponse.saveQuery) {
            resetQuery();
            return null;
        }
        setQuery({
            sectionIndex: sectionIndex,
            value: cleanKeyPressed,
            sectionType: activeSection.type
        });
        if ($de4ce65a55c75bbb$var$isQueryResponseWithoutValue(queryResponse)) return null;
        return queryResponse;
    };
    const applyLetterEditing = (params)=>{
        const findMatchingOptions = (format, options, queryValue)=>{
            const matchingValues = options.filter((option)=>option.toLowerCase().startsWith(queryValue));
            if (matchingValues.length === 0) return {
                saveQuery: false
            };
            return {
                sectionValue: matchingValues[0],
                shouldGoToNextSection: matchingValues.length === 1
            };
        };
        const testQueryOnFormatAndFallbackFormat = (queryValue, activeSection, fallbackFormat, formatFallbackValue)=>{
            const getOptions = (format)=>(0, $7692508c11d587c8$export$3ee1e7e19c2b047a)(utils, timezone, activeSection.type, format);
            if (activeSection.contentType === 'letter') return findMatchingOptions(activeSection.format, getOptions(activeSection.format), queryValue);
            // When editing a digit-format month / weekDay and the user presses a letter,
            // We can support the letter editing by using the letter-format month / weekDay and re-formatting the result.
            // We just have to make sure that the default month / weekDay format is a letter format,
            if (fallbackFormat && formatFallbackValue != null && (0, $7692508c11d587c8$export$2f3c5fac7a2a65f6)(utils, fallbackFormat).contentType === 'letter') {
                const fallbackOptions = getOptions(fallbackFormat);
                const response = findMatchingOptions(fallbackFormat, fallbackOptions, queryValue);
                if ($de4ce65a55c75bbb$var$isQueryResponseWithoutValue(response)) return {
                    saveQuery: false
                };
                return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, response, {
                    sectionValue: formatFallbackValue(response.sectionValue, fallbackOptions)
                });
            }
            return {
                saveQuery: false
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            switch(activeSection.type){
                case 'month':
                    {
                        const formatFallbackValue = (fallbackValue)=>(0, $7692508c11d587c8$export$2816862a602354ce)(utils, fallbackValue, utils.formats.month, activeSection.format);
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.month, formatFallbackValue);
                    }
                case 'weekDay':
                    {
                        const formatFallbackValue = (fallbackValue, fallbackOptions)=>fallbackOptions.indexOf(fallbackValue).toString();
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.weekday, formatFallbackValue);
                    }
                case 'meridiem':
                    return testQueryOnFormatAndFallbackFormat(queryValue, activeSection);
                default:
                    return {
                        saveQuery: false
                    };
            }
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery);
    };
    const applyNumericEditing = (params)=>{
        const getNewSectionValue = (queryValue, section)=>{
            const cleanQueryValue = (0, $7692508c11d587c8$export$7dd321105a319e8)(queryValue, localizedDigits);
            const queryValueNumber = Number(cleanQueryValue);
            const sectionBoundaries = sectionsValueBoundaries[section.type]({
                currentDate: null,
                format: section.format,
                contentType: section.contentType
            });
            if (queryValueNumber > sectionBoundaries.maximum) return {
                saveQuery: false
            };
            // If the user types `0` on a month section,
            // It is below the minimum, but we want to store the `0` in the query,
            // So that when he pressed `1`, it will store `01` and move to the next section.
            if (queryValueNumber < sectionBoundaries.minimum) return {
                saveQuery: true
            };
            const shouldGoToNextSection = queryValueNumber * 10 > sectionBoundaries.maximum || cleanQueryValue.length === sectionBoundaries.maximum.toString().length;
            const newSectionValue = (0, $7692508c11d587c8$export$ef88db4bceade9fd)(utils, queryValueNumber, sectionBoundaries, localizedDigits, section);
            return {
                sectionValue: newSectionValue,
                shouldGoToNextSection: shouldGoToNextSection
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            if (activeSection.contentType === 'digit' || activeSection.contentType === 'digit-with-letter') return getNewSectionValue(queryValue, activeSection);
            // When editing a letter-format month and the user presses a digit,
            // We can support the numeric editing by using the digit-format month and re-formatting the result.
            if (activeSection.type === 'month') {
                const hasLeadingZerosInFormat = (0, $7692508c11d587c8$export$78b5830e2dd2de49)(utils, 'digit', 'month', 'MM');
                const response = getNewSectionValue(queryValue, {
                    type: activeSection.type,
                    format: 'MM',
                    hasLeadingZerosInFormat: hasLeadingZerosInFormat,
                    hasLeadingZerosInInput: true,
                    contentType: 'digit',
                    maxLength: 2
                });
                if ($de4ce65a55c75bbb$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $7692508c11d587c8$export$2816862a602354ce)(utils, response.sectionValue, 'MM', activeSection.format);
                return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, response, {
                    sectionValue: formattedValue
                });
            }
            // When editing a letter-format weekDay and the user presses a digit,
            // We can support the numeric editing by returning the nth day in the week day array.
            if (activeSection.type === 'weekDay') {
                const response = getNewSectionValue(queryValue, activeSection);
                if ($de4ce65a55c75bbb$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $7692508c11d587c8$export$c65c7173f879039f)(utils, activeSection.format)[Number(response.sectionValue) - 1];
                return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, response, {
                    sectionValue: formattedValue
                });
            }
            return {
                saveQuery: false
            };
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery, (queryValue)=>(0, $7692508c11d587c8$export$c28be6c4c9d8f124)(queryValue, localizedDigits));
    };
    const applyCharacterEditing = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((params)=>{
        const activeSection = sections[params.sectionIndex];
        const isNumericEditing = (0, $7692508c11d587c8$export$c28be6c4c9d8f124)(params.keyPressed, localizedDigits);
        const response = isNumericEditing ? applyNumericEditing((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, params, {
            keyPressed: (0, $7692508c11d587c8$export$80dbbc19eba82070)(params.keyPressed, localizedDigits)
        })) : applyLetterEditing(params);
        if (response == null) {
            setTempAndroidValueStr(null);
            return;
        }
        updateSectionValue({
            activeSection: activeSection,
            newSectionValue: response.sectionValue,
            shouldGoToNextSection: response.shouldGoToNextSection
        });
    });
    return {
        applyCharacterEditing: applyCharacterEditing,
        resetCharacterQuery: resetQuery
    };
};



var $7fPBF = parcelRequire("7fPBF");








const $72c187043bef017e$export$3b5f62b9baf9717e = (params)=>{
    const { internalProps: { disabled: disabled, readOnly: readOnly = false }, forwardedProps: { sectionListRef: inSectionListRef, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onInput: onInput, onPaste: onPaste, focused: focusedProp, autoFocus: autoFocus = false }, fieldValueManager: fieldValueManager, applyCharacterEditing: applyCharacterEditing, resetCharacterQuery: resetCharacterQuery, setSelectedSections: setSelectedSections, parsedSelectedSections: parsedSelectedSections, state: state, clearActiveSection: clearActiveSection, clearValue: clearValue, updateSectionValue: updateSectionValue, updateValueFromValueStr: updateValueFromValueStr, sectionOrder: sectionOrder, areAllSectionsEmpty: areAllSectionsEmpty, sectionsValueBoundaries: sectionsValueBoundaries } = params;
    const sectionListRef = $7fPBF.useRef(null);
    const handleSectionListRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(inSectionListRef, sectionListRef);
    const translations = (0, $7fcfc9681bf68f23$export$3cdcc56057891b44)();
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const id = (0, $46f5b561912058f9$export$2e2bcd8739ae039)();
    const [focused, setFocused] = $7fPBF.useState(false);
    const interactions = $7fPBF.useMemo(()=>({
            syncSelectionToDOM: ()=>{
                if (!sectionListRef.current) return;
                const selection = document.getSelection();
                if (!selection) return;
                if (parsedSelectedSections == null) {
                    // If the selection contains an element inside the field, we reset it.
                    if (selection.rangeCount > 0 && sectionListRef.current.getRoot().contains(selection.getRangeAt(0).startContainer)) selection.removeAllRanges();
                    if (focused) sectionListRef.current.getRoot().blur();
                    return;
                }
                // On multi input range pickers we want to update selection range only for the active input
                if (!sectionListRef.current.getRoot().contains((0, $e21804eb4bb13208$export$cd4e5573fbe2b576)(document))) return;
                const range = new window.Range();
                let target;
                if (parsedSelectedSections === 'all') target = sectionListRef.current.getRoot();
                else {
                    const section = state.sections[parsedSelectedSections];
                    if (section.type === 'empty') target = sectionListRef.current.getSectionContainer(parsedSelectedSections);
                    else target = sectionListRef.current.getSectionContent(parsedSelectedSections);
                }
                range.selectNodeContents(target);
                target.focus();
                selection.removeAllRanges();
                selection.addRange(range);
            },
            getActiveSectionIndexFromDOM: ()=>{
                const activeElement = (0, $e21804eb4bb13208$export$cd4e5573fbe2b576)(document);
                if (!activeElement || !sectionListRef.current || !sectionListRef.current.getRoot().contains(activeElement)) return null;
                return sectionListRef.current.getSectionIndexFromDOMElement(activeElement);
            },
            focusField: (newSelectedSections = 0)=>{
                if (!sectionListRef.current || // if the field is already focused, we don't need to focus it again
                interactions.getActiveSectionIndexFromDOM() != null) return;
                const newParsedSelectedSections = (0, $7692508c11d587c8$export$b31f27a6e35a0b27)(newSelectedSections, state.sections);
                setFocused(true);
                sectionListRef.current.getSectionContent(newParsedSelectedSections).focus();
            },
            setSelectedSections: (newSelectedSections)=>{
                if (!sectionListRef.current) return;
                const newParsedSelectedSections = (0, $7692508c11d587c8$export$b31f27a6e35a0b27)(newSelectedSections, state.sections);
                const newActiveSectionIndex = newParsedSelectedSections === 'all' ? 0 : newParsedSelectedSections;
                setFocused(newActiveSectionIndex !== null);
                setSelectedSections(newSelectedSections);
            },
            isFieldFocused: ()=>{
                const activeElement = (0, $e21804eb4bb13208$export$cd4e5573fbe2b576)(document);
                return !!sectionListRef.current && sectionListRef.current.getRoot().contains(activeElement);
            }
        }), [
        parsedSelectedSections,
        setSelectedSections,
        state.sections,
        focused
    ]);
    /**
   * If a section content has been updated with a value we don't want to keep,
   * Then we need to imperatively revert it (we can't let React do it because the value did not change in his internal representation).
   */ const revertDOMSectionChange = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((sectionIndex)=>{
        if (!sectionListRef.current) return;
        const section = state.sections[sectionIndex];
        sectionListRef.current.getSectionContent(sectionIndex).innerHTML = section.value || section.placeholder;
        interactions.syncSelectionToDOM();
    });
    const handleContainerClick = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, ...args)=>{
        // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
        // We avoid this by checking if the call of `handleContainerClick` is actually intended, or a side effect.
        if (event.isDefaultPrevented() || !sectionListRef.current) return;
        setFocused(true);
        onClick?.(event, ...args);
        if (parsedSelectedSections === 'all') setTimeout(()=>{
            const cursorPosition = document.getSelection().getRangeAt(0).startOffset;
            if (cursorPosition === 0) {
                setSelectedSections(sectionOrder.startIndex);
                return;
            }
            let sectionIndex = 0;
            let cursorOnStartOfSection = 0;
            while(cursorOnStartOfSection < cursorPosition && sectionIndex < state.sections.length){
                const section = state.sections[sectionIndex];
                sectionIndex += 1;
                cursorOnStartOfSection += `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`.length;
            }
            setSelectedSections(sectionIndex - 1);
        });
        else if (!focused) {
            setFocused(true);
            setSelectedSections(sectionOrder.startIndex);
        } else {
            const hasClickedOnASection = sectionListRef.current.getRoot().contains(event.target);
            if (!hasClickedOnASection) setSelectedSections(sectionOrder.startIndex);
        }
    });
    const handleContainerInput = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event)=>{
        onInput?.(event);
        if (!sectionListRef.current || parsedSelectedSections !== 'all') return;
        const target = event.target;
        const keyPressed = target.textContent ?? '';
        sectionListRef.current.getRoot().innerHTML = state.sections.map((section)=>`${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`).join('');
        interactions.syncSelectionToDOM();
        if (keyPressed.length === 0 || keyPressed.charCodeAt(0) === 10) {
            resetCharacterQuery();
            clearValue();
            setSelectedSections('all');
        } else if (keyPressed.length > 1) updateValueFromValueStr(keyPressed);
        else {
            if (parsedSelectedSections === 'all') setSelectedSections(0);
            applyCharacterEditing({
                keyPressed: keyPressed,
                sectionIndex: 0
            });
        }
    });
    const handleContainerPaste = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event)=>{
        onPaste?.(event);
        if (readOnly || parsedSelectedSections !== 'all') {
            event.preventDefault();
            return;
        }
        const pastedValue = event.clipboardData.getData('text');
        event.preventDefault();
        resetCharacterQuery();
        updateValueFromValueStr(pastedValue);
    });
    const handleContainerFocus = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((...args)=>{
        onFocus?.(...args);
        if (focused || !sectionListRef.current) return;
        setFocused(true);
        const isFocusInsideASection = sectionListRef.current.getSectionIndexFromDOMElement((0, $e21804eb4bb13208$export$cd4e5573fbe2b576)(document)) != null;
        if (!isFocusInsideASection) setSelectedSections(sectionOrder.startIndex);
    });
    const handleContainerBlur = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((...args)=>{
        onBlur?.(...args);
        setTimeout(()=>{
            if (!sectionListRef.current) return;
            const activeElement = (0, $e21804eb4bb13208$export$cd4e5573fbe2b576)(document);
            const shouldBlur = !sectionListRef.current.getRoot().contains(activeElement);
            if (shouldBlur) {
                setFocused(false);
                setSelectedSections(null);
            }
        });
    });
    const getInputContainerClickHandler = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((sectionIndex)=>(event)=>{
            // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
            // We avoid this by checking if the call to this function is actually intended, or a side effect.
            if (event.isDefaultPrevented()) return;
            setSelectedSections(sectionIndex);
        });
    const handleInputContentMouseUp = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event)=>{
        // Without this, the browser will remove the selected when clicking inside an already-selected section.
        event.preventDefault();
    });
    const getInputContentFocusHandler = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((sectionIndex)=>()=>{
            setSelectedSections(sectionIndex);
        });
    const handleInputContentPaste = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event)=>{
        // prevent default to avoid the input `onInput` handler being called
        event.preventDefault();
        if (readOnly || disabled || typeof parsedSelectedSections !== 'number') return;
        const activeSection = state.sections[parsedSelectedSections];
        const pastedValue = event.clipboardData.getData('text');
        const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
        const digitsOnly = /^[0-9]+$/.test(pastedValue);
        const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
        const isValidPastedValue = activeSection.contentType === 'letter' && lettersOnly || activeSection.contentType === 'digit' && digitsOnly || activeSection.contentType === 'digit-with-letter' && digitsAndLetterOnly;
        if (isValidPastedValue) {
            resetCharacterQuery();
            updateSectionValue({
                activeSection: activeSection,
                newSectionValue: pastedValue,
                shouldGoToNextSection: true
            });
        } else if (!lettersOnly && !digitsOnly) {
            resetCharacterQuery();
            updateValueFromValueStr(pastedValue);
        }
    });
    const handleInputContentDragOver = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event)=>{
        event.preventDefault();
        event.dataTransfer.dropEffect = 'none';
    });
    const handleInputContentInput = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event)=>{
        if (!sectionListRef.current) return;
        const target = event.target;
        const keyPressed = target.textContent ?? '';
        const sectionIndex = sectionListRef.current.getSectionIndexFromDOMElement(target);
        const section = state.sections[sectionIndex];
        if (readOnly || !sectionListRef.current) {
            revertDOMSectionChange(sectionIndex);
            return;
        }
        if (keyPressed.length === 0) {
            if (section.value === '') {
                revertDOMSectionChange(sectionIndex);
                return;
            }
            const inputType = event.nativeEvent.inputType;
            if (inputType === 'insertParagraph' || inputType === 'insertLineBreak') {
                revertDOMSectionChange(sectionIndex);
                return;
            }
            resetCharacterQuery();
            clearActiveSection();
            return;
        }
        applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: sectionIndex
        });
        // The DOM value needs to remain the one React is expecting.
        revertDOMSectionChange(sectionIndex);
    });
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        if (!focused || !sectionListRef.current) return;
        if (parsedSelectedSections === 'all') sectionListRef.current.getRoot().focus();
        else if (typeof parsedSelectedSections === 'number') {
            const domElement = sectionListRef.current.getSectionContent(parsedSelectedSections);
            if (domElement) domElement.focus();
        }
    }, [
        parsedSelectedSections,
        focused
    ]);
    const sectionBoundaries = $7fPBF.useMemo(()=>{
        return state.sections.reduce((acc, next)=>{
            acc[next.type] = sectionsValueBoundaries[next.type]({
                currentDate: null,
                contentType: next.contentType,
                format: next.format
            });
            return acc;
        }, {});
    }, [
        sectionsValueBoundaries,
        state.sections
    ]);
    const isContainerEditable = parsedSelectedSections === 'all';
    const elements = $7fPBF.useMemo(()=>{
        return state.sections.map((section, index)=>{
            const isEditable = !isContainerEditable && !disabled && !readOnly;
            return {
                container: {
                    'data-sectionindex': index,
                    onClick: getInputContainerClickHandler(index)
                },
                content: {
                    tabIndex: isContainerEditable || index > 0 ? -1 : 0,
                    contentEditable: !isContainerEditable && !disabled && !readOnly,
                    role: 'spinbutton',
                    id: `${id}-${section.type}`,
                    'aria-labelledby': `${id}-${section.type}`,
                    'aria-readonly': readOnly,
                    'aria-valuenow': (0, $7692508c11d587c8$export$b46fd324c5adcf31)(section, utils),
                    'aria-valuemin': sectionBoundaries[section.type].minimum,
                    'aria-valuemax': sectionBoundaries[section.type].maximum,
                    'aria-valuetext': section.value ? (0, $7692508c11d587c8$export$b5e30842500b6cab)(section, utils) : translations.empty,
                    'aria-label': translations[section.type],
                    'aria-disabled': disabled,
                    spellCheck: isEditable ? false : undefined,
                    autoCapitalize: isEditable ? 'off' : undefined,
                    autoCorrect: isEditable ? 'off' : undefined,
                    [parseInt($7fPBF.version, 10) >= 17 ? 'enterKeyHint' : 'enterkeyhint']: isEditable ? 'next' : undefined,
                    children: section.value || section.placeholder,
                    onInput: handleInputContentInput,
                    onPaste: handleInputContentPaste,
                    onFocus: getInputContentFocusHandler(index),
                    onDragOver: handleInputContentDragOver,
                    onMouseUp: handleInputContentMouseUp,
                    inputMode: section.contentType === 'letter' ? 'text' : 'numeric'
                },
                before: {
                    children: section.startSeparator
                },
                after: {
                    children: section.endSeparator
                }
            };
        });
    }, [
        state.sections,
        getInputContentFocusHandler,
        handleInputContentPaste,
        handleInputContentDragOver,
        handleInputContentInput,
        getInputContainerClickHandler,
        handleInputContentMouseUp,
        disabled,
        readOnly,
        isContainerEditable,
        translations,
        utils,
        sectionBoundaries,
        id
    ]);
    const handleValueStrChange = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event)=>{
        updateValueFromValueStr(event.target.value);
    });
    const valueStr = $7fPBF.useMemo(()=>areAllSectionsEmpty ? '' : fieldValueManager.getV7HiddenInputValueFromSections(state.sections), [
        areAllSectionsEmpty,
        state.sections,
        fieldValueManager
    ]);
    $7fPBF.useEffect(()=>{
        if (sectionListRef.current == null) throw new Error([
            'MUI X: The `sectionListRef` prop has not been initialized by `PickersSectionList`',
            'You probably tried to pass a component to the `textField` slot that contains an `<input />` element instead of a `PickersSectionList`.',
            '',
            'If you want to keep using an `<input />` HTML element for the editing, please remove the `enableAccessibleFieldDOMStructure` prop from your picker or field component:',
            '',
            '<DatePicker slots={{ textField: MyCustomTextField }} />',
            '',
            'Learn more about the field accessible DOM structure on the MUI documentation: https://mui.com/x/react-date-pickers/fields/#fields-to-edit-a-single-element'
        ].join('\n'));
        if (autoFocus && sectionListRef.current) sectionListRef.current.getSectionContent(sectionOrder.startIndex).focus();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        interactions: interactions,
        returnedValue: {
            autoFocus: // Forwarded
            autoFocus,
            readOnly: readOnly,
            focused: focusedProp ?? focused,
            sectionListRef: handleSectionListRef,
            onBlur: handleContainerBlur,
            onClick: handleContainerClick,
            onFocus: handleContainerFocus,
            onInput: handleContainerInput,
            onPaste: handleContainerPaste,
            // Additional
            enableAccessibleFieldDOMStructure: true,
            elements: elements,
            // TODO v7: Try to set to undefined when there is a section selected.
            tabIndex: parsedSelectedSections === 0 ? -1 : 0,
            contentEditable: isContainerEditable,
            value: valueStr,
            onChange: handleValueStrChange,
            areAllSectionsEmpty: areAllSectionsEmpty
        }
    };
};




var $7fPBF = parcelRequire("7fPBF");





const $8c68876baf2ab0fe$var$cleanString = (dirtyString)=>dirtyString.replace(/[\u2066\u2067\u2068\u2069]/g, '');
const $8c68876baf2ab0fe$export$8bb5d1c9951d10ca = (sections, localizedDigits, isRtl)=>{
    let position = 0;
    let positionInInput = isRtl ? 1 : 0;
    const newSections = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const renderedValue = (0, $7692508c11d587c8$export$85daa91f6c6e875f)(section, isRtl ? 'input-rtl' : 'input-ltr', localizedDigits);
        const sectionStr = `${section.startSeparator}${renderedValue}${section.endSeparator}`;
        const sectionLength = $8c68876baf2ab0fe$var$cleanString(sectionStr).length;
        const sectionLengthInInput = sectionStr.length;
        // The ...InInput values consider the unicode characters but do include them in their indexes
        const cleanedValue = $8c68876baf2ab0fe$var$cleanString(renderedValue);
        const startInInput = positionInInput + (cleanedValue === '' ? 0 : renderedValue.indexOf(cleanedValue[0])) + section.startSeparator.length;
        const endInInput = startInInput + cleanedValue.length;
        newSections.push((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, section, {
            start: position,
            end: position + sectionLength,
            startInInput: startInInput,
            endInInput: endInInput
        }));
        position += sectionLength;
        // Move position to the end of string associated to the current section
        positionInInput += sectionLengthInInput;
    }
    return newSections;
};
const $8c68876baf2ab0fe$export$4995d3b7b56fcd3f = (params)=>{
    const isRtl = (0, $ef654b446fc390d6$export$b2dd014b6c321cb)();
    const focusTimeoutRef = $7fPBF.useRef(undefined);
    const selectionSyncTimeoutRef = $7fPBF.useRef(undefined);
    const { forwardedProps: { onFocus: onFocus, onClick: onClick, onPaste: onPaste, onBlur: onBlur, inputRef: inputRefProp, placeholder: inPlaceholder }, internalProps: { readOnly: readOnly = false, disabled: disabled = false }, parsedSelectedSections: parsedSelectedSections, activeSectionIndex: activeSectionIndex, state: state, fieldValueManager: fieldValueManager, valueManager: valueManager, applyCharacterEditing: applyCharacterEditing, resetCharacterQuery: resetCharacterQuery, updateSectionValue: updateSectionValue, updateValueFromValueStr: updateValueFromValueStr, clearActiveSection: clearActiveSection, clearValue: clearValue, setTempAndroidValueStr: setTempAndroidValueStr, setSelectedSections: setSelectedSections, getSectionsFromValue: getSectionsFromValue, areAllSectionsEmpty: areAllSectionsEmpty, localizedDigits: localizedDigits } = params;
    const inputRef = $7fPBF.useRef(null);
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(inputRefProp, inputRef);
    const sections = $7fPBF.useMemo(()=>$8c68876baf2ab0fe$export$8bb5d1c9951d10ca(state.sections, localizedDigits, isRtl), [
        state.sections,
        localizedDigits,
        isRtl
    ]);
    const interactions = $7fPBF.useMemo(()=>({
            syncSelectionToDOM: ()=>{
                if (!inputRef.current) return;
                if (parsedSelectedSections == null) {
                    if (inputRef.current.scrollLeft) // Ensure that input content is not marked as selected.
                    // setting selection range to 0 causes issues in Safari.
                    // https://bugs.webkit.org/show_bug.cgi?id=224425
                    inputRef.current.scrollLeft = 0;
                    return;
                }
                // On multi input range pickers we want to update selection range only for the active input
                // This helps to avoid the focus jumping on Safari https://github.com/mui/mui-x/issues/9003
                // because WebKit implements the `setSelectionRange` based on the spec: https://bugs.webkit.org/show_bug.cgi?id=224425
                if (inputRef.current !== (0, $e21804eb4bb13208$export$cd4e5573fbe2b576)(document)) return;
                // Fix scroll jumping on iOS browser: https://github.com/mui/mui-x/issues/8321
                const currentScrollTop = inputRef.current.scrollTop;
                if (parsedSelectedSections === 'all') inputRef.current.select();
                else {
                    const selectedSection = sections[parsedSelectedSections];
                    const selectionStart = selectedSection.type === 'empty' ? selectedSection.startInInput - selectedSection.startSeparator.length : selectedSection.startInInput;
                    const selectionEnd = selectedSection.type === 'empty' ? selectedSection.endInInput + selectedSection.endSeparator.length : selectedSection.endInInput;
                    if (selectionStart !== inputRef.current.selectionStart || selectionEnd !== inputRef.current.selectionEnd) {
                        if (inputRef.current === (0, $e21804eb4bb13208$export$cd4e5573fbe2b576)(document)) inputRef.current.setSelectionRange(selectionStart, selectionEnd);
                    }
                    clearTimeout(selectionSyncTimeoutRef.current);
                    selectionSyncTimeoutRef.current = setTimeout(()=>{
                        // handle case when the selection is not updated correctly
                        // could happen on Android
                        if (inputRef.current && inputRef.current === (0, $e21804eb4bb13208$export$cd4e5573fbe2b576)(document) && // The section might loose all selection, where `selectionStart === selectionEnd`
                        // https://github.com/mui/mui-x/pull/13652
                        inputRef.current.selectionStart === inputRef.current.selectionEnd && (inputRef.current.selectionStart !== selectionStart || inputRef.current.selectionEnd !== selectionEnd)) interactions.syncSelectionToDOM();
                    });
                }
                // Even reading this variable seems to do the trick, but also setting it just to make use of it
                inputRef.current.scrollTop = currentScrollTop;
            },
            getActiveSectionIndexFromDOM: ()=>{
                const browserStartIndex = inputRef.current.selectionStart ?? 0;
                const browserEndIndex = inputRef.current.selectionEnd ?? 0;
                if (browserStartIndex === 0 && browserEndIndex === 0) return null;
                const nextSectionIndex = browserStartIndex <= sections[0].startInInput ? 1 // Special case if browser index is in invisible characters at the beginning.
                 : sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
                return nextSectionIndex === -1 ? sections.length - 1 : nextSectionIndex - 1;
            },
            focusField: (newSelectedSection = 0)=>{
                if ((0, $e21804eb4bb13208$export$cd4e5573fbe2b576)(document) === inputRef.current) return;
                inputRef.current?.focus();
                setSelectedSections(newSelectedSection);
            },
            setSelectedSections: (newSelectedSections)=>setSelectedSections(newSelectedSections),
            isFieldFocused: ()=>inputRef.current === (0, $e21804eb4bb13208$export$cd4e5573fbe2b576)(document)
        }), [
        inputRef,
        parsedSelectedSections,
        sections,
        setSelectedSections
    ]);
    const syncSelectionFromDOM = ()=>{
        const browserStartIndex = inputRef.current.selectionStart ?? 0;
        let nextSectionIndex;
        if (browserStartIndex <= sections[0].startInInput) // Special case if browser index is in invisible characters at the beginning
        nextSectionIndex = 1;
        else if (browserStartIndex >= sections[sections.length - 1].endInInput) // If the click is after the last character of the input, then we want to select the 1st section.
        nextSectionIndex = 1;
        else nextSectionIndex = sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
        const sectionIndex = nextSectionIndex === -1 ? sections.length - 1 : nextSectionIndex - 1;
        setSelectedSections(sectionIndex);
    };
    const handleInputFocus = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((...args)=>{
        onFocus?.(...args);
        // The ref is guaranteed to be resolved at this point.
        const input = inputRef.current;
        clearTimeout(focusTimeoutRef.current);
        focusTimeoutRef.current = setTimeout(()=>{
            // The ref changed, the component got remounted, the focus event is no longer relevant.
            if (!input || input !== inputRef.current) return;
            if (activeSectionIndex != null) return;
            if (// avoid selecting all sections when focusing empty field without value
            input.value.length && Number(input.selectionEnd) - Number(input.selectionStart) === input.value.length) setSelectedSections('all');
            else syncSelectionFromDOM();
        });
    });
    const handleInputClick = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, ...args)=>{
        // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
        // We avoid this by checking if the call of `handleInputClick` is actually intended, or a side effect.
        if (event.isDefaultPrevented()) return;
        onClick?.(event, ...args);
        syncSelectionFromDOM();
    });
    const handleInputPaste = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event)=>{
        onPaste?.(event);
        // prevent default to avoid the input `onChange` handler being called
        event.preventDefault();
        if (readOnly || disabled) return;
        const pastedValue = event.clipboardData.getData('text');
        if (typeof parsedSelectedSections === 'number') {
            const activeSection = state.sections[parsedSelectedSections];
            const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
            const digitsOnly = /^[0-9]+$/.test(pastedValue);
            const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
            const isValidPastedValue = activeSection.contentType === 'letter' && lettersOnly || activeSection.contentType === 'digit' && digitsOnly || activeSection.contentType === 'digit-with-letter' && digitsAndLetterOnly;
            if (isValidPastedValue) {
                resetCharacterQuery();
                updateSectionValue({
                    activeSection: activeSection,
                    newSectionValue: pastedValue,
                    shouldGoToNextSection: true
                });
                return;
            }
            if (lettersOnly || digitsOnly) // The pasted value corresponds to a single section, but not the expected type,
            // skip the modification
            return;
        }
        resetCharacterQuery();
        updateValueFromValueStr(pastedValue);
    });
    const handleContainerBlur = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((...args)=>{
        onBlur?.(...args);
        setSelectedSections(null);
    });
    const handleInputChange = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event)=>{
        if (readOnly) return;
        const targetValue = event.target.value;
        if (targetValue === '') {
            resetCharacterQuery();
            clearValue();
            return;
        }
        const eventData = event.nativeEvent.data;
        // Calling `.fill(04/11/2022)` in playwright will trigger a change event with the requested content to insert in `event.nativeEvent.data`
        // usual changes have only the currently typed character in the `event.nativeEvent.data`
        const shouldUseEventData = eventData && eventData.length > 1;
        const valueStr = shouldUseEventData ? eventData : targetValue;
        const cleanValueStr = $8c68876baf2ab0fe$var$cleanString(valueStr);
        if (parsedSelectedSections === 'all') setSelectedSections(activeSectionIndex);
        // If no section is selected or eventData should be used, we just try to parse the new value
        // This line is mostly triggered by imperative code / application tests.
        if (activeSectionIndex == null || shouldUseEventData) {
            updateValueFromValueStr(shouldUseEventData ? eventData : cleanValueStr);
            return;
        }
        let keyPressed;
        if (parsedSelectedSections === 'all' && cleanValueStr.length === 1) keyPressed = cleanValueStr;
        else {
            const prevValueStr = $8c68876baf2ab0fe$var$cleanString(fieldValueManager.getV6InputValueFromSections(sections, localizedDigits, isRtl));
            let startOfDiffIndex = -1;
            let endOfDiffIndex = -1;
            for(let i = 0; i < prevValueStr.length; i += 1){
                if (startOfDiffIndex === -1 && prevValueStr[i] !== cleanValueStr[i]) startOfDiffIndex = i;
                if (endOfDiffIndex === -1 && prevValueStr[prevValueStr.length - i - 1] !== cleanValueStr[cleanValueStr.length - i - 1]) endOfDiffIndex = i;
            }
            const activeSection = sections[activeSectionIndex];
            const hasDiffOutsideOfActiveSection = startOfDiffIndex < activeSection.start || prevValueStr.length - endOfDiffIndex - 1 > activeSection.end;
            if (hasDiffOutsideOfActiveSection) // TODO: Support if the new date is valid
            return;
            // The active section being selected, the browser has replaced its value with the key pressed by the user.
            const activeSectionEndRelativeToNewValue = cleanValueStr.length - prevValueStr.length + activeSection.end - $8c68876baf2ab0fe$var$cleanString(activeSection.endSeparator || '').length;
            keyPressed = cleanValueStr.slice(activeSection.start + $8c68876baf2ab0fe$var$cleanString(activeSection.startSeparator || '').length, activeSectionEndRelativeToNewValue);
        }
        if (keyPressed.length === 0) {
            if ((0, $7692508c11d587c8$export$a11b0059900ceec8)()) setTempAndroidValueStr(valueStr);
            resetCharacterQuery();
            clearActiveSection();
            return;
        }
        applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: activeSectionIndex
        });
    });
    const placeholder = $7fPBF.useMemo(()=>{
        if (inPlaceholder !== undefined) return inPlaceholder;
        return fieldValueManager.getV6InputValueFromSections(getSectionsFromValue(valueManager.emptyValue), localizedDigits, isRtl);
    }, [
        inPlaceholder,
        fieldValueManager,
        getSectionsFromValue,
        valueManager.emptyValue,
        localizedDigits,
        isRtl
    ]);
    const valueStr = $7fPBF.useMemo(()=>state.tempValueStrAndroid ?? fieldValueManager.getV6InputValueFromSections(state.sections, localizedDigits, isRtl), [
        state.sections,
        fieldValueManager,
        state.tempValueStrAndroid,
        localizedDigits,
        isRtl
    ]);
    $7fPBF.useEffect(()=>{
        // Select all the sections when focused on mount (`autoFocus = true` on the input)
        if (inputRef.current && inputRef.current === (0, $e21804eb4bb13208$export$cd4e5573fbe2b576)(document)) setSelectedSections('all');
        return ()=>{
            clearTimeout(focusTimeoutRef.current);
            clearTimeout(selectionSyncTimeoutRef.current);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    const inputMode = $7fPBF.useMemo(()=>{
        if (activeSectionIndex == null) return 'text';
        if (state.sections[activeSectionIndex].contentType === 'letter') return 'text';
        return 'numeric';
    }, [
        activeSectionIndex,
        state.sections
    ]);
    const inputHasFocus = inputRef.current && inputRef.current === (0, $e21804eb4bb13208$export$cd4e5573fbe2b576)(document);
    const shouldShowPlaceholder = !inputHasFocus && areAllSectionsEmpty;
    return {
        interactions: interactions,
        returnedValue: {
            readOnly: // Forwarded
            readOnly,
            onBlur: handleContainerBlur,
            onClick: handleInputClick,
            onFocus: handleInputFocus,
            onPaste: handleInputPaste,
            inputRef: handleRef,
            // Additional
            enableAccessibleFieldDOMStructure: false,
            placeholder: placeholder,
            inputMode: inputMode,
            autoComplete: 'off',
            value: shouldShowPlaceholder ? '' : valueStr,
            onChange: handleInputChange
        }
    };
};


const $2a09a13200d5a2c7$export$294aa081a6c6f55d = (params)=>{
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const { internalProps: internalProps, internalProps: { unstableFieldRef: unstableFieldRef, minutesStep: minutesStep, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure = false, disabled: disabled = false, readOnly: readOnly = false }, forwardedProps: { onKeyDown: onKeyDown, error: error, clearable: clearable, onClear: onClear }, fieldValueManager: fieldValueManager, valueManager: valueManager, validator: validator } = params;
    const isRtl = (0, $ef654b446fc390d6$export$b2dd014b6c321cb)();
    const stateResponse = (0, $ab6e023aa9d06979$export$4e8d6353e50062e7)(params);
    const { state: state, activeSectionIndex: activeSectionIndex, parsedSelectedSections: parsedSelectedSections, setSelectedSections: setSelectedSections, clearValue: clearValue, clearActiveSection: clearActiveSection, updateSectionValue: updateSectionValue, setTempAndroidValueStr: setTempAndroidValueStr, sectionsValueBoundaries: sectionsValueBoundaries, localizedDigits: localizedDigits, timezone: timezone } = stateResponse;
    const characterEditingResponse = (0, $de4ce65a55c75bbb$export$66d00048b8bb82f6)({
        sections: state.sections,
        updateSectionValue: updateSectionValue,
        sectionsValueBoundaries: sectionsValueBoundaries,
        localizedDigits: localizedDigits,
        setTempAndroidValueStr: setTempAndroidValueStr,
        timezone: timezone
    });
    const { resetCharacterQuery: resetCharacterQuery } = characterEditingResponse;
    const areAllSectionsEmpty = valueManager.areValuesEqual(utils, state.value, valueManager.emptyValue);
    const useFieldTextField = enableAccessibleFieldDOMStructure ? (0, $72c187043bef017e$export$3b5f62b9baf9717e) : (0, $8c68876baf2ab0fe$export$4995d3b7b56fcd3f);
    const sectionOrder = $7fPBF.useMemo(()=>(0, $7692508c11d587c8$export$7725fd6fe0a2aadf)(state.sections, isRtl && !enableAccessibleFieldDOMStructure), [
        state.sections,
        isRtl,
        enableAccessibleFieldDOMStructure
    ]);
    const { returnedValue: returnedValue, interactions: interactions } = useFieldTextField((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, params, stateResponse, characterEditingResponse, {
        areAllSectionsEmpty: areAllSectionsEmpty,
        sectionOrder: sectionOrder
    }));
    const handleContainerKeyDown = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event)=>{
        onKeyDown?.(event);
        if (disabled) return;
        // eslint-disable-next-line default-case
        switch(true){
            // Select all
            case (event.ctrlKey || event.metaKey) && String.fromCharCode(event.keyCode) === 'A' && !event.shiftKey && !event.altKey:
                // prevent default to make sure that the next line "select all" while updating
                // the internal state at the same time.
                event.preventDefault();
                setSelectedSections('all');
                break;
            // Move selection to next section
            case event.key === 'ArrowRight':
                event.preventDefault();
                if (parsedSelectedSections == null) setSelectedSections(sectionOrder.startIndex);
                else if (parsedSelectedSections === 'all') setSelectedSections(sectionOrder.endIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].rightIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Move selection to previous section
            case event.key === 'ArrowLeft':
                event.preventDefault();
                if (parsedSelectedSections == null) setSelectedSections(sectionOrder.endIndex);
                else if (parsedSelectedSections === 'all') setSelectedSections(sectionOrder.startIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].leftIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Reset the value of the selected section
            case event.key === 'Delete':
                event.preventDefault();
                if (readOnly) break;
                if (parsedSelectedSections == null || parsedSelectedSections === 'all') clearValue();
                else clearActiveSection();
                resetCharacterQuery();
                break;
            // Increment / decrement the selected section value
            case [
                'ArrowUp',
                'ArrowDown',
                'Home',
                'End',
                'PageUp',
                'PageDown'
            ].includes(event.key):
                {
                    event.preventDefault();
                    if (readOnly || activeSectionIndex == null) break;
                    // if all sections are selected, mark the currently editing one as selected
                    if (parsedSelectedSections === 'all') setSelectedSections(activeSectionIndex);
                    const activeSection = state.sections[activeSectionIndex];
                    const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
                    const newSectionValue = (0, $7692508c11d587c8$export$5ed0f22513e58fe3)(utils, timezone, activeSection, event.key, sectionsValueBoundaries, localizedDigits, activeDateManager.date, {
                        minutesStep: minutesStep
                    });
                    updateSectionValue({
                        activeSection: activeSection,
                        newSectionValue: newSectionValue,
                        shouldGoToNextSection: false
                    });
                    break;
                }
        }
    });
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        interactions.syncSelectionToDOM();
    });
    const { hasValidationError: hasValidationError } = (0, $0f340c8acb692073$export$87fe492f99f25a20)({
        props: internalProps,
        validator: validator,
        timezone: timezone,
        value: state.value,
        onError: internalProps.onError
    });
    const inputError = $7fPBF.useMemo(()=>{
        // only override when `error` is undefined.
        // in case of multi input fields, the `error` value is provided externally and will always be defined.
        if (error !== undefined) return error;
        return hasValidationError;
    }, [
        hasValidationError,
        error
    ]);
    $7fPBF.useEffect(()=>{
        if (!inputError && activeSectionIndex == null) resetCharacterQuery();
    }, [
        state.referenceValue,
        activeSectionIndex,
        inputError
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // If `tempValueStrAndroid` is still defined for some section when running `useEffect`,
    // Then `onChange` has only been called once, which means the user pressed `Backspace` to reset the section.
    // This causes a small flickering on Android,
    // But we can't use `useEnhancedEffect` which is always called before the second `onChange` call and then would cause false positives.
    $7fPBF.useEffect(()=>{
        if (state.tempValueStrAndroid != null && activeSectionIndex != null) {
            resetCharacterQuery();
            clearActiveSection();
        }
    }, [
        state.sections
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    $7fPBF.useImperativeHandle(unstableFieldRef, ()=>({
            getSections: ()=>state.sections,
            getActiveSectionIndex: interactions.getActiveSectionIndexFromDOM,
            setSelectedSections: interactions.setSelectedSections,
            focusField: interactions.focusField,
            isFieldFocused: interactions.isFieldFocused
        }));
    const handleClearValue = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, ...args)=>{
        event.preventDefault();
        onClear?.(event, ...args);
        clearValue();
        if (!interactions.isFieldFocused()) // setSelectedSections is called internally
        interactions.focusField(0);
        else setSelectedSections(sectionOrder.startIndex);
    });
    const commonForwardedProps = {
        onKeyDown: handleContainerKeyDown,
        onClear: handleClearValue,
        error: inputError,
        clearable: Boolean(clearable && !areAllSectionsEmpty && !readOnly && !disabled)
    };
    const commonAdditionalProps = {
        disabled: disabled,
        readOnly: readOnly
    };
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, params.forwardedProps, commonForwardedProps, commonAdditionalProps, returnedValue);
};





var $7fPBF = parcelRequire("7fPBF");

'use client';
const $b34e9eed9957bc05$var$SHARED_FIELD_INTERNAL_PROP_NAMES = [
    'value',
    'defaultValue',
    'referenceDate',
    'format',
    'formatDensity',
    'onChange',
    'timezone',
    'onError',
    'shouldRespectLeadingZeros',
    'selectedSections',
    'onSelectedSectionsChange',
    'unstableFieldRef',
    'enableAccessibleFieldDOMStructure',
    'disabled',
    'readOnly',
    'dateSeparator'
];
const $b34e9eed9957bc05$export$be857fabf132acea = (props, valueType)=>{
    return $7fPBF.useMemo(()=>{
        const forwardedProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props);
        const internalProps = {};
        const extractProp = (propName)=>{
            if (forwardedProps.hasOwnProperty(propName)) {
                // @ts-ignore
                internalProps[propName] = forwardedProps[propName];
                delete forwardedProps[propName];
            }
        };
        $b34e9eed9957bc05$var$SHARED_FIELD_INTERNAL_PROP_NAMES.forEach(extractProp);
        if (valueType === 'date') (0, $f613678a0229c7f5$export$430d9fc64cf058d6).forEach(extractProp);
        else if (valueType === 'time') (0, $f613678a0229c7f5$export$fd5e0f8b4115a8c7).forEach(extractProp);
        else if (valueType === 'date-time') {
            (0, $f613678a0229c7f5$export$430d9fc64cf058d6).forEach(extractProp);
            (0, $f613678a0229c7f5$export$fd5e0f8b4115a8c7).forEach(extractProp);
            (0, $f613678a0229c7f5$export$1df62d3ba2121371).forEach(extractProp);
        }
        return {
            forwardedProps: forwardedProps,
            internalProps: internalProps
        };
    }, [
        props,
        valueType
    ]);
};





const $734a6ce30d81b00a$export$c04f15aa68a6177a = (props)=>{
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const defaultDates = (0, $6945e6366bb58773$export$7c38da3a2e90fa83)();
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        disablePast: props.disablePast ?? false,
        disableFuture: props.disableFuture ?? false,
        format: props.format ?? utils.formats.keyboardDate,
        minDate: (0, $4d1fa529a9a32e76$export$eb73579ccade48fd)(utils, props.minDate, defaultDates.minDate),
        maxDate: (0, $4d1fa529a9a32e76$export$eb73579ccade48fd)(utils, props.maxDate, defaultDates.maxDate)
    });
};
const $734a6ce30d81b00a$export$e740b972b66c04cd = (props)=>{
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const ampm = props.ampm ?? utils.is12HourCycleInCurrentLocale();
    const defaultFormat = ampm ? utils.formats.fullTime12h : utils.formats.fullTime24h;
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        disablePast: props.disablePast ?? false,
        disableFuture: props.disableFuture ?? false,
        format: props.format ?? defaultFormat
    });
};
const $734a6ce30d81b00a$export$ae5b8d06aeae1db3 = (props)=>{
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const defaultDates = (0, $6945e6366bb58773$export$7c38da3a2e90fa83)();
    const ampm = props.ampm ?? utils.is12HourCycleInCurrentLocale();
    const defaultFormat = ampm ? utils.formats.keyboardDateTime12h : utils.formats.keyboardDateTime24h;
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        disablePast: props.disablePast ?? false,
        disableFuture: props.disableFuture ?? false,
        format: props.format ?? defaultFormat,
        disableIgnoringDatePartForTimeValidation: Boolean(props.minDateTime || props.maxDateTime),
        minDate: (0, $4d1fa529a9a32e76$export$eb73579ccade48fd)(utils, props.minDateTime ?? props.minDate, defaultDates.minDate),
        maxDate: (0, $4d1fa529a9a32e76$export$eb73579ccade48fd)(utils, props.maxDateTime ?? props.maxDate, defaultDates.maxDate),
        minTime: props.minDateTime ?? props.minTime,
        maxTime: props.maxDateTime ?? props.maxTime
    });
};


'use client';
const $da4099eec06cd7d9$export$5591b0b878c1a989 = (inProps)=>{
    const props = (0, $734a6ce30d81b00a$export$c04f15aa68a6177a)(inProps);
    const { forwardedProps: forwardedProps, internalProps: internalProps } = (0, $b34e9eed9957bc05$export$be857fabf132acea)(props, 'date');
    return (0, $2a09a13200d5a2c7$export$294aa081a6c6f55d)({
        forwardedProps: forwardedProps,
        internalProps: internalProps,
        valueManager: (0, $841d6de1e4809c9b$export$2764b246aa3b75ba),
        fieldValueManager: (0, $841d6de1e4809c9b$export$b602c94f557316b4),
        validator: (0, $c885b418e3c240b8$export$ffb3d0046ef3a2),
        valueType: 'date'
    });
};





var $7fPBF = parcelRequire("7fPBF");






'use client';
const $f8c7cbeb7c9ac09c$var$_excluded = [
    "clearable",
    "onClear",
    "InputProps",
    "sx",
    "slots",
    "slotProps"
], $f8c7cbeb7c9ac09c$var$_excluded2 = [
    "ownerState"
];
const $f8c7cbeb7c9ac09c$export$db9644cdb7e3d432 = (props)=>{
    const translations = (0, $7fcfc9681bf68f23$export$3cdcc56057891b44)();
    const { clearable: clearable, onClear: onClear, InputProps: InputProps, sx: sx, slots: slots, slotProps: slotProps } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $f8c7cbeb7c9ac09c$var$_excluded);
    const IconButton = slots?.clearButton ?? (0, $67a243c492197f3b$export$2e2bcd8739ae039);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: IconButton,
        externalSlotProps: slotProps?.clearButton,
        ownerState: {},
        className: 'clearButton',
        additionalProps: {
            title: translations.fieldClearLabel
        }
    }), iconButtonProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useSlotProps, $f8c7cbeb7c9ac09c$var$_excluded2);
    const EndClearIcon = slots?.clearIcon ?? (0, $27f114a7ae98fe28$export$cefbac224a47f32);
    const endClearIconProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: EndClearIcon,
        externalSlotProps: slotProps?.clearIcon,
        ownerState: {}
    });
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, other, {
        InputProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, InputProps, {
            endAdornment: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
                children: [
                    clearable && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a1383c8904b71ac9$export$2e2bcd8739ae039), {
                        position: "end",
                        sx: {
                            marginRight: InputProps?.endAdornment ? -1 : -1.5
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(IconButton, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, iconButtonProps, {
                            onClick: onClear,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(EndClearIcon, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                                fontSize: "small"
                            }, endClearIconProps))
                        }))
                    }),
                    InputProps?.endAdornment
                ]
            })
        }),
        sx: [
            {
                '& .clearButton': {
                    opacity: 1
                },
                '@media (pointer: fine)': {
                    '& .clearButton': {
                        opacity: 0
                    },
                    '&:hover, &:focus-within': {
                        '.clearButton': {
                            opacity: 1
                        }
                    }
                }
            },
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    });
};





var $7fPBF = parcelRequire("7fPBF");












function $573d364d56ce6842$export$d99678ed7aad1677(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPickersTextField', slot);
}
const $573d364d56ce6842$export$284739773a7ae972 = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPickersTextField', [
    'root',
    'focused',
    'disabled',
    'error',
    'required'
]);





var $7fPBF = parcelRequire("7fPBF");










function $4e34e4f453eed645$export$3821cb625ac26962(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPickersInputBase', slot);
}
const $4e34e4f453eed645$export$f20b5ba262568322 = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPickersInputBase', [
    'root',
    'focused',
    'disabled',
    'error',
    'notchedOutline',
    'sectionContent',
    'sectionBefore',
    'sectionAfter',
    'adornedStart',
    'adornedEnd',
    'input'
]);


function $8c3ad5e4e359ce7c$export$c0dd951a3959ac7f(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPickersOutlinedInput', slot);
}
const $8c3ad5e4e359ce7c$export$a7da60486bcc91df = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $4e34e4f453eed645$export$f20b5ba262568322), (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPickersOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));




parcelRequire("7fPBF");


const $0ad3ff537e5870c2$var$_excluded = [
    "children",
    "className",
    "label",
    "notched",
    "shrink"
];
const $0ad3ff537e5870c2$var$OutlineRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('fieldset', {
    name: 'MuiPickersOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        textAlign: 'left',
        position: 'absolute',
        bottom: 0,
        right: 0,
        top: -5,
        left: 0,
        margin: 0,
        padding: '0 8px',
        pointerEvents: 'none',
        borderRadius: 'inherit',
        borderStyle: 'solid',
        borderWidth: 1,
        overflow: 'hidden',
        minWidth: '0%',
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $0ad3ff537e5870c2$var$OutlineLabel = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span')(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit'
    }));
const $0ad3ff537e5870c2$var$OutlineLegend = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('legend')(({ theme: theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: {
                    withLabel: false
                },
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    withLabel: true
                },
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: {
                    withLabel: true,
                    notched: true
                },
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    }));
function $0ad3ff537e5870c2$export$2e2bcd8739ae039(props) {
    const { className: className, label: label } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $0ad3ff537e5870c2$var$_excluded);
    const withLabel = label != null && label !== '';
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0ad3ff537e5870c2$var$OutlineRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        "aria-hidden": true,
        className: className
    }, other, {
        ownerState: ownerState,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0ad3ff537e5870c2$var$OutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0ad3ff537e5870c2$var$OutlineLabel, {
                children: label
            }) : /*#__PURE__*/ // notranslate needed while Google Translate will not fix zero-width space issue
            (0, $824c049f32d4395d$exports.jsx)($0ad3ff537e5870c2$var$OutlineLabel, {
                className: "notranslate",
                children: "\u200B"
            })
        })
    }));
}





var $7fPBF = parcelRequire("7fPBF");














var $7fPBF = parcelRequire("7fPBF");







function $b40da9d7b3a01f05$export$f891a98d04ce6513(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPickersSectionList', slot);
}
const $b40da9d7b3a01f05$export$8455939b33d2ee90 = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPickersSectionList', [
    'root',
    'section',
    'sectionContent'
]);



'use client';
const $4a33d698435abb15$var$_excluded = [
    "slots",
    "slotProps",
    "elements",
    "sectionListRef"
];
const $4a33d698435abb15$export$4ee86b293725486c = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersSectionList',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    direction: 'ltr /*! @noflip */',
    outline: 'none'
});
const $4a33d698435abb15$export$30e7187e386feb4f = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiPickersSectionList',
    slot: 'Section',
    overridesResolver: (props, styles)=>styles.section
})({});
const $4a33d698435abb15$export$c403b59604f63120 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiPickersSectionList',
    slot: 'SectionSeparator',
    overridesResolver: (props, styles)=>styles.sectionSeparator
})({
    whiteSpace: 'pre'
});
const $4a33d698435abb15$export$1f2c61561fe3d6 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiPickersSectionList',
    slot: 'SectionContent',
    overridesResolver: (props, styles)=>styles.sectionContent
})({
    outline: 'none'
});
const $4a33d698435abb15$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        section: [
            'section'
        ],
        sectionContent: [
            'sectionContent'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $b40da9d7b3a01f05$export$f891a98d04ce6513), classes);
};
function $4a33d698435abb15$var$PickersSection(props) {
    const { slots: slots, slotProps: slotProps, element: element, classes: classes } = props;
    const Section = slots?.section ?? $4a33d698435abb15$export$30e7187e386feb4f;
    const sectionProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: Section,
        externalSlotProps: slotProps?.section,
        externalForwardedProps: element.container,
        className: classes.section,
        ownerState: {}
    });
    const SectionContent = slots?.sectionContent ?? $4a33d698435abb15$export$1f2c61561fe3d6;
    const sectionContentProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: SectionContent,
        externalSlotProps: slotProps?.sectionContent,
        externalForwardedProps: element.content,
        additionalProps: {
            suppressContentEditableWarning: true
        },
        className: classes.sectionContent,
        ownerState: {}
    });
    const SectionSeparator = slots?.sectionSeparator ?? $4a33d698435abb15$export$c403b59604f63120;
    const sectionSeparatorBeforeProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: SectionSeparator,
        externalSlotProps: slotProps?.sectionSeparator,
        externalForwardedProps: element.before,
        ownerState: {
            position: 'before'
        }
    });
    const sectionSeparatorAfterProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: SectionSeparator,
        externalSlotProps: slotProps?.sectionSeparator,
        externalForwardedProps: element.after,
        ownerState: {
            position: 'after'
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(Section, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, sectionProps, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(SectionSeparator, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, sectionSeparatorBeforeProps)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(SectionContent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, sectionContentProps)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(SectionSeparator, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, sectionSeparatorAfterProps))
        ]
    }));
}
/**
 * Demos:
 *
 * - [Custom field](https://mui.com/x/react-date-pickers/custom-field/)
 *
 * API:
 *
 * - [PickersSectionList API](https://mui.com/x/api/date-pickers/pickers-section-list/)
 */ const $4a33d698435abb15$export$847fd4b97819700 = /*#__PURE__*/ $7fPBF.forwardRef(function PickersSectionList(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersSectionList'
    });
    const { slots: slots, slotProps: slotProps, elements: elements, sectionListRef: sectionListRef } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $4a33d698435abb15$var$_excluded);
    const classes = $4a33d698435abb15$var$useUtilityClasses(props);
    const rootRef = $7fPBF.useRef(null);
    const handleRootRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(ref, rootRef);
    const getRoot = (methodName)=>{
        if (!rootRef.current) throw new Error(`MUI X: Cannot call sectionListRef.${methodName} before the mount of the component.`);
        return rootRef.current;
    };
    $7fPBF.useImperativeHandle(sectionListRef, ()=>({
            getRoot () {
                return getRoot('getRoot');
            },
            getSectionContainer (index) {
                const root = getRoot('getSectionContainer');
                return root.querySelector(`.${(0, $b40da9d7b3a01f05$export$8455939b33d2ee90).section}[data-sectionindex="${index}"]`);
            },
            getSectionContent (index) {
                const root = getRoot('getSectionContent');
                return root.querySelector(`.${(0, $b40da9d7b3a01f05$export$8455939b33d2ee90).section}[data-sectionindex="${index}"] .${(0, $b40da9d7b3a01f05$export$8455939b33d2ee90).sectionContent}`);
            },
            getSectionIndexFromDOMElement (element) {
                const root = getRoot('getSectionIndexFromDOMElement');
                if (element == null || !root.contains(element)) return null;
                let sectionContainer = null;
                if (element.classList.contains((0, $b40da9d7b3a01f05$export$8455939b33d2ee90).section)) sectionContainer = element;
                else if (element.classList.contains((0, $b40da9d7b3a01f05$export$8455939b33d2ee90).sectionContent)) sectionContainer = element.parentElement;
                if (sectionContainer == null) return null;
                return Number(sectionContainer.dataset.sectionindex);
            }
        }));
    const Root = slots?.root ?? $4a33d698435abb15$export$4ee86b293725486c;
    const rootProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps?.root,
        externalForwardedProps: other,
        additionalProps: {
            ref: handleRootRef,
            suppressContentEditableWarning: true
        },
        className: classes.root,
        ownerState: {}
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Root, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, rootProps, {
        children: rootProps.contentEditable ? elements.map(({ content: content, before: before, after: after })=>`${before.children}${content.children}${after.children}`).join('') : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7fPBF.Fragment, {
            children: elements.map((element, elementIndex)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4a33d698435abb15$var$PickersSection, {
                    slots: slots,
                    slotProps: slotProps,
                    element: element,
                    classes: classes
                }, elementIndex))
        })
    }));
});



const $dc4fd6b984f9cff5$var$_excluded = [
    "elements",
    "areAllSectionsEmpty",
    "defaultValue",
    "label",
    "value",
    "onChange",
    "id",
    "autoFocus",
    "endAdornment",
    "startAdornment",
    "renderSuffix",
    "slots",
    "slotProps",
    "contentEditable",
    "tabIndex",
    "onInput",
    "onPaste",
    "onKeyDown",
    "fullWidth",
    "name",
    "readOnly",
    "inputProps",
    "inputRef",
    "sectionListRef"
];
const $dc4fd6b984f9cff5$var$round = (value)=>Math.round(value * 1e5) / 1e5;
const $dc4fd6b984f9cff5$export$ddc18880178d980e = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersInputBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        cursor: 'text',
        padding: 0,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        letterSpacing: `${$dc4fd6b984f9cff5$var$round(0.15 / 16)}em`,
        variants: [
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            }
        ]
    }));
const $dc4fd6b984f9cff5$export$52f3fbbfe9321824 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $4a33d698435abb15$export$4ee86b293725486c), {
    name: 'MuiPickersInputBase',
    slot: 'SectionsContainer',
    overridesResolver: (props, styles)=>styles.sectionsContainer
})(({ theme: theme })=>({
        padding: '4px 0 5px',
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit',
        lineHeight: '1.4375em',
        // 23px
        flexGrow: 1,
        outline: 'none',
        display: 'flex',
        flexWrap: 'nowrap',
        overflow: 'hidden',
        letterSpacing: 'inherit',
        // Baseline behavior
        width: '182px',
        variants: [
            {
                props: {
                    isRtl: true
                },
                style: {
                    textAlign: 'right /*! @noflip */'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: {
                    adornedStart: false,
                    focused: false,
                    filled: false
                },
                style: {
                    color: 'currentColor',
                    opacity: 0
                }
            },
            {
                // Can't use the object notation because label can be null or undefined
                props: ({ adornedStart: adornedStart, focused: focused, filled: filled, label: label })=>!adornedStart && !focused && !filled && label == null,
                style: theme.vars ? {
                    opacity: theme.vars.opacity.inputPlaceholder
                } : {
                    opacity: theme.palette.mode === 'light' ? 0.42 : 0.5
                }
            }
        ]
    }));
const $dc4fd6b984f9cff5$var$PickersInputBaseSection = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $4a33d698435abb15$export$30e7187e386feb4f), {
    name: 'MuiPickersInputBase',
    slot: 'Section',
    overridesResolver: (props, styles)=>styles.section
})(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit',
        letterSpacing: 'inherit',
        lineHeight: '1.4375em',
        // 23px
        display: 'inline-block',
        whiteSpace: 'nowrap'
    }));
const $dc4fd6b984f9cff5$var$PickersInputBaseSectionContent = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $4a33d698435abb15$export$1f2c61561fe3d6), {
    name: 'MuiPickersInputBase',
    slot: 'SectionContent',
    overridesResolver: (props, styles)=>styles.content
})(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        lineHeight: '1.4375em',
        // 23px
        letterSpacing: 'inherit',
        width: 'fit-content',
        outline: 'none'
    }));
const $dc4fd6b984f9cff5$var$PickersInputBaseSectionSeparator = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $4a33d698435abb15$export$c403b59604f63120), {
    name: 'MuiPickersInputBase',
    slot: 'Separator',
    overridesResolver: (props, styles)=>styles.separator
})(()=>({
        whiteSpace: 'pre',
        letterSpacing: 'inherit'
    }));
const $dc4fd6b984f9cff5$var$PickersInputBaseInput = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('input', {
    name: 'MuiPickersInputBase',
    slot: 'Input',
    overridesResolver: (props, styles)=>styles.hiddenInput
})((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $3af1e05012cfa2ee$export$2e2bcd8739ae039)));
const $dc4fd6b984f9cff5$var$useUtilityClasses = (ownerState)=>{
    const { focused: focused, disabled: disabled, error: error, classes: classes, fullWidth: fullWidth, readOnly: readOnly, color: color, size: size, endAdornment: endAdornment, startAdornment: startAdornment } = ownerState;
    const slots = {
        root: [
            'root',
            focused && !disabled && 'focused',
            disabled && 'disabled',
            readOnly && 'readOnly',
            error && 'error',
            fullWidth && 'fullWidth',
            `color${(0, $d8da749d88f71122$export$2e2bcd8739ae039)(color)}`,
            size === 'small' && 'inputSizeSmall',
            Boolean(startAdornment) && 'adornedStart',
            Boolean(endAdornment) && 'adornedEnd'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ],
        sectionsContainer: [
            'sectionsContainer'
        ],
        sectionContent: [
            'sectionContent'
        ],
        sectionBefore: [
            'sectionBefore'
        ],
        sectionAfter: [
            'sectionAfter'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $4e34e4f453eed645$export$3821cb625ac26962), classes);
};
/**
 * @ignore - internal component.
 */ const $dc4fd6b984f9cff5$export$ff827734ba831074 = /*#__PURE__*/ $7fPBF.forwardRef(function PickersInputBase(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersInputBase'
    });
    const { elements: elements, areAllSectionsEmpty: areAllSectionsEmpty, value: value, onChange: onChange, id: id, endAdornment: endAdornment, startAdornment: startAdornment, renderSuffix: renderSuffix, slots: slots, slotProps: slotProps, contentEditable: contentEditable, tabIndex: tabIndex, onInput: onInput, onPaste: onPaste, onKeyDown: onKeyDown, name: name, readOnly: readOnly, inputProps: inputProps, inputRef: inputRef, sectionListRef: sectionListRef } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $dc4fd6b984f9cff5$var$_excluded);
    const rootRef = $7fPBF.useRef(null);
    const handleRootRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(ref, rootRef);
    const handleInputRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(inputProps?.ref, inputRef);
    const isRtl = (0, $ef654b446fc390d6$export$b2dd014b6c321cb)();
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    if (!muiFormControl) throw new Error('MUI X: PickersInputBase should always be used inside a PickersTextField component');
    const handleInputFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (muiFormControl.disabled) {
            event.stopPropagation();
            return;
        }
        muiFormControl.onFocus?.(event);
    };
    $7fPBF.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    $7fPBF.useEffect(()=>{
        if (!muiFormControl) return;
        if (areAllSectionsEmpty) muiFormControl.onEmpty();
        else muiFormControl.onFilled();
    }, [
        muiFormControl,
        areAllSectionsEmpty
    ]);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, muiFormControl, {
        isRtl: isRtl
    });
    const classes = $dc4fd6b984f9cff5$var$useUtilityClasses(ownerState);
    const InputRoot = slots?.root || $dc4fd6b984f9cff5$export$ddc18880178d980e;
    const inputRootProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: InputRoot,
        externalSlotProps: slotProps?.root,
        externalForwardedProps: other,
        additionalProps: {
            'aria-invalid': muiFormControl.error,
            ref: handleRootRef
        },
        className: classes.root,
        ownerState: ownerState
    });
    const InputSectionsContainer = slots?.input || $dc4fd6b984f9cff5$export$52f3fbbfe9321824;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(InputRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, inputRootProps, {
        children: [
            startAdornment,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a33d698435abb15$export$847fd4b97819700), {
                sectionListRef: sectionListRef,
                elements: elements,
                contentEditable: contentEditable,
                tabIndex: tabIndex,
                className: classes.sectionsContainer,
                onFocus: handleInputFocus,
                onBlur: muiFormControl.onBlur,
                onInput: onInput,
                onPaste: onPaste,
                onKeyDown: onKeyDown,
                slots: {
                    root: InputSectionsContainer,
                    section: $dc4fd6b984f9cff5$var$PickersInputBaseSection,
                    sectionContent: $dc4fd6b984f9cff5$var$PickersInputBaseSectionContent,
                    sectionSeparator: $dc4fd6b984f9cff5$var$PickersInputBaseSectionSeparator
                },
                slotProps: {
                    root: {
                        ownerState: ownerState
                    },
                    sectionContent: {
                        className: (0, $4e34e4f453eed645$export$f20b5ba262568322).sectionContent
                    },
                    sectionSeparator: ({ position: position })=>({
                            className: position === 'before' ? (0, $4e34e4f453eed645$export$f20b5ba262568322).sectionBefore : (0, $4e34e4f453eed645$export$f20b5ba262568322).sectionAfter
                        })
                }
            }),
            endAdornment,
            renderSuffix ? renderSuffix((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, muiFormControl)) : null,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($dc4fd6b984f9cff5$var$PickersInputBaseInput, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                name: name,
                className: classes.input,
                value: value,
                onChange: onChange,
                id: id,
                "aria-hidden": "true",
                tabIndex: -1,
                readOnly: readOnly,
                required: muiFormControl.required,
                disabled: muiFormControl.disabled
            }, inputProps, {
                ref: handleInputRef
            }))
        ]
    }));
});




const $b7ef63051cb6a88b$var$_excluded = [
    "label",
    "autoFocus",
    "ownerState",
    "notched"
];
const $b7ef63051cb6a88b$var$PickersOutlinedInputRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $dc4fd6b984f9cff5$export$ddc18880178d980e), {
    name: 'MuiPickersOutlinedInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        padding: '0 14px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $8c3ad5e4e359ce7c$export$a7da60486bcc91df).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $8c3ad5e4e359ce7c$export$a7da60486bcc91df).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $8c3ad5e4e359ce7c$export$a7da60486bcc91df).focused} .${(0, $8c3ad5e4e359ce7c$export$a7da60486bcc91df).notchedOutline}`]: {
            borderStyle: 'solid',
            borderWidth: 2
        },
        [`&.${(0, $8c3ad5e4e359ce7c$export$a7da60486bcc91df).disabled}`]: {
            [`& .${(0, $8c3ad5e4e359ce7c$export$a7da60486bcc91df).notchedOutline}`]: {
                borderColor: (theme.vars || theme).palette.action.disabled
            },
            '*': {
                color: (theme.vars || theme).palette.action.disabled
            }
        },
        [`&.${(0, $8c3ad5e4e359ce7c$export$a7da60486bcc91df).error} .${(0, $8c3ad5e4e359ce7c$export$a7da60486bcc91df).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        variants: Object.keys((theme.vars ?? theme).palette)// @ts-ignore
        .filter((key)=>(theme.vars ?? theme).palette[key]?.main ?? false).map((color)=>({
                props: {
                    color: color
                },
                style: {
                    [`&.${(0, $8c3ad5e4e359ce7c$export$a7da60486bcc91df).focused}:not(.${(0, $8c3ad5e4e359ce7c$export$a7da60486bcc91df).error}) .${(0, $8c3ad5e4e359ce7c$export$a7da60486bcc91df).notchedOutline}`]: {
                        // @ts-ignore
                        borderColor: (theme.vars || theme).palette[color].main
                    }
                }
            }))
    };
});
const $b7ef63051cb6a88b$var$PickersOutlinedInputSectionsContainer = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $dc4fd6b984f9cff5$export$52f3fbbfe9321824), {
    name: 'MuiPickersOutlinedInput',
    slot: 'SectionsContainer',
    overridesResolver: (props, styles)=>styles.sectionsContainer
})({
    padding: '16.5px 0',
    variants: [
        {
            props: {
                size: 'small'
            },
            style: {
                padding: '8.5px 0'
            }
        }
    ]
});
const $b7ef63051cb6a88b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $8c3ad5e4e359ce7c$export$c0dd951a3959ac7f), classes);
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $b7ef63051cb6a88b$export$44d4d00edb0c710f = /*#__PURE__*/ $7fPBF.forwardRef(function PickersOutlinedInput(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersOutlinedInput'
    });
    const { label: label, ownerState: ownerStateProp, notched: notched } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $b7ef63051cb6a88b$var$_excluded);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, ownerStateProp, muiFormControl, {
        color: muiFormControl?.color || 'primary'
    });
    const classes = $b7ef63051cb6a88b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dc4fd6b984f9cff5$export$ff827734ba831074), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        slots: {
            root: $b7ef63051cb6a88b$var$PickersOutlinedInputRoot,
            input: $b7ef63051cb6a88b$var$PickersOutlinedInputSectionsContainer
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0ad3ff537e5870c2$export$2e2bcd8739ae039), {
                shrink: Boolean(notched || state.adornedStart || state.focused || state.filled),
                notched: Boolean(notched || state.adornedStart || state.focused || state.filled),
                className: classes.notchedOutline,
                label: label != null && label !== '' && muiFormControl?.required ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                }) : label,
                ownerState: ownerState
            })
    }, other, {
        label: label,
        classes: classes,
        ref: ref
    }));
});
$b7ef63051cb6a88b$export$44d4d00edb0c710f.muiName = 'Input';





var $7fPBF = parcelRequire("7fPBF");



/**
 * @mui/styled-engine v7.3.9
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 




'use client';
function $0275daee3ffe340c$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $8de346382d86c747$export$2e2bcd8739ae039)(tag, options);
    var styles, style;
    return stylesFactory;
}
function $0275daee3ffe340c$export$592c7226e4cb0171(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $0275daee3ffe340c$var$wrapper = [];
function $0275daee3ffe340c$export$13a2d3ef13012b32(styles) {
    $0275daee3ffe340c$var$wrapper[0] = styles;
    return (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)($0275daee3ffe340c$var$wrapper);
}



var $7fPBF = parcelRequire("7fPBF");

function $e8430d81ac377dda$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $e8430d81ac377dda$var$deepClone(source) {
    if (/*#__PURE__*/ $7fPBF.isValidElement(source) || (0, $dddaf6f84c717660$exports.isValidElementType)(source) || !$e8430d81ac377dda$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $e8430d81ac377dda$var$deepClone(source[key]);
    });
    return output;
}
function $e8430d81ac377dda$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($e8430d81ac377dda$export$53b83ca8eaab0383(target) && $e8430d81ac377dda$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $7fPBF.isValidElement(source[key]) || (0, $dddaf6f84c717660$exports.isValidElementType)(source[key])) output[key] = source[key];
        else if ($e8430d81ac377dda$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $e8430d81ac377dda$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $e8430d81ac377dda$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $e8430d81ac377dda$export$53b83ca8eaab0383(source[key]) ? $e8430d81ac377dda$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}


/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $75c3c68e9fac2910$export$2e2bcd8739ae039(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}


function $cdb179da000bc841$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $75c3c68e9fac2910$export$2e2bcd8739ae039)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}



function $ecc4900d9897c775$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $ecc4900d9897c775$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $ecc4900d9897c775$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $ecc4900d9897c775$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $ecc4900d9897c775$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $dddaf6f84c717660$exports.ForwardRef:
            return $ecc4900d9897c775$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $dddaf6f84c717660$exports.Memo:
            return $ecc4900d9897c775$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}



// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $ee7482569024fa37$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $ee7482569024fa37$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $ee7482569024fa37$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $ee7482569024fa37$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}


/**
 * For using in `sx` prop to sort the breakpoint from low to high.
 * Note: this function does not work and will not support multiple units.
 *       e.g. input: { '@container (min-width:300px)': '1rem', '@container (min-width:40rem)': '2rem' }
 *            output: { '@container (min-width:40rem)': '2rem', '@container (min-width:300px)': '1rem' } // since 40 < 300 even though 40rem > 300px
 */ function $2325fbc34513c7d9$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $2325fbc34513c7d9$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $2325fbc34513c7d9$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $2325fbc34513c7d9$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}


const $f637f3037d6dee04$var$shape = {
    borderRadius: 4
};
var $f637f3037d6dee04$export$2e2bcd8739ae039 = $f637f3037d6dee04$var$shape;






function $625ef458e0e03ef7$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $e8430d81ac377dda$export$2e2bcd8739ae039)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $625ef458e0e03ef7$export$2e2bcd8739ae039 = $625ef458e0e03ef7$var$merge;



const $4a0a613f758c442e$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $4a0a613f758c442e$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$4a0a613f758c442e$export$68c286be0e7e55b7[key]}px)`
};
const $4a0a613f758c442e$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $4a0a613f758c442e$export$68c286be0e7e55b7[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $4a0a613f758c442e$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $4a0a613f758c442e$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $4a0a613f758c442e$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $2325fbc34513c7d9$export$77c7c3e357f440e7)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $2325fbc34513c7d9$export$10a9745dfa00d15)(theme.containerQueries ? theme : $4a0a613f758c442e$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $4a0a613f758c442e$export$68c286be0e7e55b7).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $4a0a613f758c442e$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $4a0a613f758c442e$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $625ef458e0e03ef7$export$2e2bcd8739ae039)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $4a0a613f758c442e$export$1f2600516e91381f(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $4a0a613f758c442e$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $4a0a613f758c442e$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $4a0a613f758c442e$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $e8430d81ac377dda$export$2e2bcd8739ae039)(prev, next), {});
    return $4a0a613f758c442e$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $4a0a613f758c442e$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $4a0a613f758c442e$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $4a0a613f758c442e$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $4a0a613f758c442e$export$2e2bcd8739ae039 = $4a0a613f758c442e$var$breakpoints;





function $0e15c04d427b6a62$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $0e15c04d427b6a62$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $0e15c04d427b6a62$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $0e15c04d427b6a62$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $0e15c04d427b6a62$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $0e15c04d427b6a62$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $0e15c04d427b6a62$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $cdb179da000bc841$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $4a0a613f758c442e$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $0e15c04d427b6a62$export$2e2bcd8739ae039 = $0e15c04d427b6a62$var$style;



function $3c30d62673f7d703$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


const $99c8f593f1790ef1$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $99c8f593f1790ef1$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $99c8f593f1790ef1$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $99c8f593f1790ef1$var$getCssProperties = (0, $3c30d62673f7d703$export$2e2bcd8739ae039)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($99c8f593f1790ef1$var$aliases[prop]) prop = $99c8f593f1790ef1$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $99c8f593f1790ef1$var$properties[a];
    const direction = $99c8f593f1790ef1$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $99c8f593f1790ef1$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $99c8f593f1790ef1$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $99c8f593f1790ef1$var$spacingKeys = [
    ...$99c8f593f1790ef1$export$aab52a0dde05ad8a,
    ...$99c8f593f1790ef1$export$f8397d44f03ab6ad
];
function $99c8f593f1790ef1$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $0e15c04d427b6a62$export$2aa3fd96c49a84a8)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $99c8f593f1790ef1$export$1def6f833384e3d1(theme) {
    return $99c8f593f1790ef1$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $99c8f593f1790ef1$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $99c8f593f1790ef1$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $99c8f593f1790ef1$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $99c8f593f1790ef1$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $99c8f593f1790ef1$var$getCssProperties(prop);
    const styleFromPropValue = $99c8f593f1790ef1$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $4a0a613f758c442e$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
}
function $99c8f593f1790ef1$var$style(props, keys) {
    const transformer = $99c8f593f1790ef1$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$99c8f593f1790ef1$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $625ef458e0e03ef7$export$2e2bcd8739ae039), {});
}
function $99c8f593f1790ef1$export$7ede87f9b603dd3c(props) {
    return $99c8f593f1790ef1$var$style(props, $99c8f593f1790ef1$export$aab52a0dde05ad8a);
}
$99c8f593f1790ef1$export$7ede87f9b603dd3c.propTypes = {};
$99c8f593f1790ef1$export$7ede87f9b603dd3c.filterProps = $99c8f593f1790ef1$export$aab52a0dde05ad8a;
function $99c8f593f1790ef1$export$6f98e8eaf0be1996(props) {
    return $99c8f593f1790ef1$var$style(props, $99c8f593f1790ef1$export$f8397d44f03ab6ad);
}
$99c8f593f1790ef1$export$6f98e8eaf0be1996.propTypes = {};
$99c8f593f1790ef1$export$6f98e8eaf0be1996.filterProps = $99c8f593f1790ef1$export$f8397d44f03ab6ad;
function $99c8f593f1790ef1$var$spacing(props) {
    return $99c8f593f1790ef1$var$style(props, $99c8f593f1790ef1$var$spacingKeys);
}
$99c8f593f1790ef1$var$spacing.propTypes = {};
$99c8f593f1790ef1$var$spacing.filterProps = $99c8f593f1790ef1$var$spacingKeys;
var $99c8f593f1790ef1$export$2e2bcd8739ae039 = $99c8f593f1790ef1$var$spacing;


function $0808b5e3ab0ab6d4$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $99c8f593f1790ef1$export$1def6f833384e3d1)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}











function $652eabee641972a2$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $625ef458e0e03ef7$export$2e2bcd8739ae039)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $652eabee641972a2$export$2e2bcd8739ae039 = $652eabee641972a2$var$compose;




function $e295d9da0e132c01$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $e295d9da0e132c01$var$createBorderStyle(prop, transform) {
    return (0, $0e15c04d427b6a62$export$2e2bcd8739ae039)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $e295d9da0e132c01$export$1edee58a52776cd9 = $e295d9da0e132c01$var$createBorderStyle('border', $e295d9da0e132c01$export$34e2febe53ae29cc);
const $e295d9da0e132c01$export$f9a7b6bd24892946 = $e295d9da0e132c01$var$createBorderStyle('borderTop', $e295d9da0e132c01$export$34e2febe53ae29cc);
const $e295d9da0e132c01$export$5abca33e6be905d2 = $e295d9da0e132c01$var$createBorderStyle('borderRight', $e295d9da0e132c01$export$34e2febe53ae29cc);
const $e295d9da0e132c01$export$e2ce9f12a980a822 = $e295d9da0e132c01$var$createBorderStyle('borderBottom', $e295d9da0e132c01$export$34e2febe53ae29cc);
const $e295d9da0e132c01$export$47658cca1a909427 = $e295d9da0e132c01$var$createBorderStyle('borderLeft', $e295d9da0e132c01$export$34e2febe53ae29cc);
const $e295d9da0e132c01$export$e7fb0694ba2404fc = $e295d9da0e132c01$var$createBorderStyle('borderColor');
const $e295d9da0e132c01$export$126a92c968acdb85 = $e295d9da0e132c01$var$createBorderStyle('borderTopColor');
const $e295d9da0e132c01$export$85cc51cb8fbb8c0e = $e295d9da0e132c01$var$createBorderStyle('borderRightColor');
const $e295d9da0e132c01$export$340b0327727f6d1a = $e295d9da0e132c01$var$createBorderStyle('borderBottomColor');
const $e295d9da0e132c01$export$60beef91a985b4bf = $e295d9da0e132c01$var$createBorderStyle('borderLeftColor');
const $e295d9da0e132c01$export$f9258c55612cbed7 = $e295d9da0e132c01$var$createBorderStyle('outline', $e295d9da0e132c01$export$34e2febe53ae29cc);
const $e295d9da0e132c01$export$621fe586efeb64b9 = $e295d9da0e132c01$var$createBorderStyle('outlineColor');
const $e295d9da0e132c01$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $99c8f593f1790ef1$export$cb5ee237cce814a2)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $99c8f593f1790ef1$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $4a0a613f758c442e$export$88347efdb2e19abd)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$e295d9da0e132c01$export$7a57f79000377ca2.propTypes = {};
$e295d9da0e132c01$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $e295d9da0e132c01$var$borders = (0, $652eabee641972a2$export$2e2bcd8739ae039)($e295d9da0e132c01$export$1edee58a52776cd9, $e295d9da0e132c01$export$f9a7b6bd24892946, $e295d9da0e132c01$export$5abca33e6be905d2, $e295d9da0e132c01$export$e2ce9f12a980a822, $e295d9da0e132c01$export$47658cca1a909427, $e295d9da0e132c01$export$e7fb0694ba2404fc, $e295d9da0e132c01$export$126a92c968acdb85, $e295d9da0e132c01$export$85cc51cb8fbb8c0e, $e295d9da0e132c01$export$340b0327727f6d1a, $e295d9da0e132c01$export$60beef91a985b4bf, $e295d9da0e132c01$export$7a57f79000377ca2, $e295d9da0e132c01$export$f9258c55612cbed7, $e295d9da0e132c01$export$621fe586efeb64b9);
var $e295d9da0e132c01$export$2e2bcd8739ae039 = $e295d9da0e132c01$var$borders;







const $8a7d7fc795cee191$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $99c8f593f1790ef1$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $99c8f593f1790ef1$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $4a0a613f758c442e$export$88347efdb2e19abd)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$8a7d7fc795cee191$export$5df9adcb0db95e1e.propTypes = {};
$8a7d7fc795cee191$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $8a7d7fc795cee191$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $99c8f593f1790ef1$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $99c8f593f1790ef1$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $4a0a613f758c442e$export$88347efdb2e19abd)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$8a7d7fc795cee191$export$ec60d70ff941a580.propTypes = {};
$8a7d7fc795cee191$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $8a7d7fc795cee191$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $99c8f593f1790ef1$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $99c8f593f1790ef1$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $4a0a613f758c442e$export$88347efdb2e19abd)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$8a7d7fc795cee191$export$8a833ffa5f5dbeda.propTypes = {};
$8a7d7fc795cee191$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $8a7d7fc795cee191$export$baf44164ca3a34e8 = (0, $0e15c04d427b6a62$export$2e2bcd8739ae039)({
    prop: 'gridColumn'
});
const $8a7d7fc795cee191$export$8f7213a1cd01e832 = (0, $0e15c04d427b6a62$export$2e2bcd8739ae039)({
    prop: 'gridRow'
});
const $8a7d7fc795cee191$export$b0e0abbc49ba668 = (0, $0e15c04d427b6a62$export$2e2bcd8739ae039)({
    prop: 'gridAutoFlow'
});
const $8a7d7fc795cee191$export$bcd8b929d4b4142 = (0, $0e15c04d427b6a62$export$2e2bcd8739ae039)({
    prop: 'gridAutoColumns'
});
const $8a7d7fc795cee191$export$e5039a674e14c828 = (0, $0e15c04d427b6a62$export$2e2bcd8739ae039)({
    prop: 'gridAutoRows'
});
const $8a7d7fc795cee191$export$42bd9088661ffb03 = (0, $0e15c04d427b6a62$export$2e2bcd8739ae039)({
    prop: 'gridTemplateColumns'
});
const $8a7d7fc795cee191$export$920682ae05b999bc = (0, $0e15c04d427b6a62$export$2e2bcd8739ae039)({
    prop: 'gridTemplateRows'
});
const $8a7d7fc795cee191$export$1b88fbdd482fd33a = (0, $0e15c04d427b6a62$export$2e2bcd8739ae039)({
    prop: 'gridTemplateAreas'
});
const $8a7d7fc795cee191$export$bdb486e40d52d26f = (0, $0e15c04d427b6a62$export$2e2bcd8739ae039)({
    prop: 'gridArea'
});
const $8a7d7fc795cee191$var$grid = (0, $652eabee641972a2$export$2e2bcd8739ae039)($8a7d7fc795cee191$export$5df9adcb0db95e1e, $8a7d7fc795cee191$export$ec60d70ff941a580, $8a7d7fc795cee191$export$8a833ffa5f5dbeda, $8a7d7fc795cee191$export$baf44164ca3a34e8, $8a7d7fc795cee191$export$8f7213a1cd01e832, $8a7d7fc795cee191$export$b0e0abbc49ba668, $8a7d7fc795cee191$export$bcd8b929d4b4142, $8a7d7fc795cee191$export$e5039a674e14c828, $8a7d7fc795cee191$export$42bd9088661ffb03, $8a7d7fc795cee191$export$920682ae05b999bc, $8a7d7fc795cee191$export$1b88fbdd482fd33a, $8a7d7fc795cee191$export$bdb486e40d52d26f);
var $8a7d7fc795cee191$export$2e2bcd8739ae039 = $8a7d7fc795cee191$var$grid;




function $feae45a63d0d7592$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $feae45a63d0d7592$export$35e9368ef982300f = (0, $0e15c04d427b6a62$export$2e2bcd8739ae039)({
    prop: 'color',
    themeKey: 'palette',
    transform: $feae45a63d0d7592$export$dbaffd4420ea0ac6
});
const $feae45a63d0d7592$export$2506f56c10355b33 = (0, $0e15c04d427b6a62$export$2e2bcd8739ae039)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $feae45a63d0d7592$export$dbaffd4420ea0ac6
});
const $feae45a63d0d7592$export$8c5a050822fd698c = (0, $0e15c04d427b6a62$export$2e2bcd8739ae039)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $feae45a63d0d7592$export$dbaffd4420ea0ac6
});
const $feae45a63d0d7592$var$palette = (0, $652eabee641972a2$export$2e2bcd8739ae039)($feae45a63d0d7592$export$35e9368ef982300f, $feae45a63d0d7592$export$2506f56c10355b33, $feae45a63d0d7592$export$8c5a050822fd698c);
var $feae45a63d0d7592$export$2e2bcd8739ae039 = $feae45a63d0d7592$var$palette;





function $692eaea4660c42f3$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $692eaea4660c42f3$export$7e3df82ee760448c = (0, $0e15c04d427b6a62$export$2e2bcd8739ae039)({
    prop: 'width',
    transform: $692eaea4660c42f3$export$8afece71750ec241
});
const $692eaea4660c42f3$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || (0, $4a0a613f758c442e$export$68c286be0e7e55b7)[propValue];
            if (!breakpoint) return {
                maxWidth: $692eaea4660c42f3$export$8afece71750ec241(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $4a0a613f758c442e$export$88347efdb2e19abd)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$692eaea4660c42f3$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $692eaea4660c42f3$export$ee148fbbe8357dd2 = (0, $0e15c04d427b6a62$export$2e2bcd8739ae039)({
    prop: 'minWidth',
    transform: $692eaea4660c42f3$export$8afece71750ec241
});
const $692eaea4660c42f3$export$ac607276a8fe9f0a = (0, $0e15c04d427b6a62$export$2e2bcd8739ae039)({
    prop: 'height',
    transform: $692eaea4660c42f3$export$8afece71750ec241
});
const $692eaea4660c42f3$export$dc0d8bd0b94f8570 = (0, $0e15c04d427b6a62$export$2e2bcd8739ae039)({
    prop: 'maxHeight',
    transform: $692eaea4660c42f3$export$8afece71750ec241
});
const $692eaea4660c42f3$export$a43cf604e12f3b17 = (0, $0e15c04d427b6a62$export$2e2bcd8739ae039)({
    prop: 'minHeight',
    transform: $692eaea4660c42f3$export$8afece71750ec241
});
const $692eaea4660c42f3$export$ffed9f14fb65e276 = (0, $0e15c04d427b6a62$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'width',
    transform: $692eaea4660c42f3$export$8afece71750ec241
});
const $692eaea4660c42f3$export$905076ed6620e671 = (0, $0e15c04d427b6a62$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'height',
    transform: $692eaea4660c42f3$export$8afece71750ec241
});
const $692eaea4660c42f3$export$6ccc93f785106a58 = (0, $0e15c04d427b6a62$export$2e2bcd8739ae039)({
    prop: 'boxSizing'
});
const $692eaea4660c42f3$var$sizing = (0, $652eabee641972a2$export$2e2bcd8739ae039)($692eaea4660c42f3$export$7e3df82ee760448c, $692eaea4660c42f3$export$488fda99655ff65a, $692eaea4660c42f3$export$ee148fbbe8357dd2, $692eaea4660c42f3$export$ac607276a8fe9f0a, $692eaea4660c42f3$export$dc0d8bd0b94f8570, $692eaea4660c42f3$export$a43cf604e12f3b17, $692eaea4660c42f3$export$6ccc93f785106a58);
var $692eaea4660c42f3$export$2e2bcd8739ae039 = $692eaea4660c42f3$var$sizing;


const $d138c1b003d294d5$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $e295d9da0e132c01$export$34e2febe53ae29cc)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $e295d9da0e132c01$export$34e2febe53ae29cc)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $e295d9da0e132c01$export$34e2febe53ae29cc)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $e295d9da0e132c01$export$34e2febe53ae29cc)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $e295d9da0e132c01$export$34e2febe53ae29cc)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $e295d9da0e132c01$export$34e2febe53ae29cc)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $e295d9da0e132c01$export$7a57f79000377ca2)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $feae45a63d0d7592$export$dbaffd4420ea0ac6)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $feae45a63d0d7592$export$dbaffd4420ea0ac6)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $feae45a63d0d7592$export$dbaffd4420ea0ac6)
    },
    // spacing
    p: {
        style: (0, $99c8f593f1790ef1$export$6f98e8eaf0be1996)
    },
    pt: {
        style: (0, $99c8f593f1790ef1$export$6f98e8eaf0be1996)
    },
    pr: {
        style: (0, $99c8f593f1790ef1$export$6f98e8eaf0be1996)
    },
    pb: {
        style: (0, $99c8f593f1790ef1$export$6f98e8eaf0be1996)
    },
    pl: {
        style: (0, $99c8f593f1790ef1$export$6f98e8eaf0be1996)
    },
    px: {
        style: (0, $99c8f593f1790ef1$export$6f98e8eaf0be1996)
    },
    py: {
        style: (0, $99c8f593f1790ef1$export$6f98e8eaf0be1996)
    },
    padding: {
        style: (0, $99c8f593f1790ef1$export$6f98e8eaf0be1996)
    },
    paddingTop: {
        style: (0, $99c8f593f1790ef1$export$6f98e8eaf0be1996)
    },
    paddingRight: {
        style: (0, $99c8f593f1790ef1$export$6f98e8eaf0be1996)
    },
    paddingBottom: {
        style: (0, $99c8f593f1790ef1$export$6f98e8eaf0be1996)
    },
    paddingLeft: {
        style: (0, $99c8f593f1790ef1$export$6f98e8eaf0be1996)
    },
    paddingX: {
        style: (0, $99c8f593f1790ef1$export$6f98e8eaf0be1996)
    },
    paddingY: {
        style: (0, $99c8f593f1790ef1$export$6f98e8eaf0be1996)
    },
    paddingInline: {
        style: (0, $99c8f593f1790ef1$export$6f98e8eaf0be1996)
    },
    paddingInlineStart: {
        style: (0, $99c8f593f1790ef1$export$6f98e8eaf0be1996)
    },
    paddingInlineEnd: {
        style: (0, $99c8f593f1790ef1$export$6f98e8eaf0be1996)
    },
    paddingBlock: {
        style: (0, $99c8f593f1790ef1$export$6f98e8eaf0be1996)
    },
    paddingBlockStart: {
        style: (0, $99c8f593f1790ef1$export$6f98e8eaf0be1996)
    },
    paddingBlockEnd: {
        style: (0, $99c8f593f1790ef1$export$6f98e8eaf0be1996)
    },
    m: {
        style: (0, $99c8f593f1790ef1$export$7ede87f9b603dd3c)
    },
    mt: {
        style: (0, $99c8f593f1790ef1$export$7ede87f9b603dd3c)
    },
    mr: {
        style: (0, $99c8f593f1790ef1$export$7ede87f9b603dd3c)
    },
    mb: {
        style: (0, $99c8f593f1790ef1$export$7ede87f9b603dd3c)
    },
    ml: {
        style: (0, $99c8f593f1790ef1$export$7ede87f9b603dd3c)
    },
    mx: {
        style: (0, $99c8f593f1790ef1$export$7ede87f9b603dd3c)
    },
    my: {
        style: (0, $99c8f593f1790ef1$export$7ede87f9b603dd3c)
    },
    margin: {
        style: (0, $99c8f593f1790ef1$export$7ede87f9b603dd3c)
    },
    marginTop: {
        style: (0, $99c8f593f1790ef1$export$7ede87f9b603dd3c)
    },
    marginRight: {
        style: (0, $99c8f593f1790ef1$export$7ede87f9b603dd3c)
    },
    marginBottom: {
        style: (0, $99c8f593f1790ef1$export$7ede87f9b603dd3c)
    },
    marginLeft: {
        style: (0, $99c8f593f1790ef1$export$7ede87f9b603dd3c)
    },
    marginX: {
        style: (0, $99c8f593f1790ef1$export$7ede87f9b603dd3c)
    },
    marginY: {
        style: (0, $99c8f593f1790ef1$export$7ede87f9b603dd3c)
    },
    marginInline: {
        style: (0, $99c8f593f1790ef1$export$7ede87f9b603dd3c)
    },
    marginInlineStart: {
        style: (0, $99c8f593f1790ef1$export$7ede87f9b603dd3c)
    },
    marginInlineEnd: {
        style: (0, $99c8f593f1790ef1$export$7ede87f9b603dd3c)
    },
    marginBlock: {
        style: (0, $99c8f593f1790ef1$export$7ede87f9b603dd3c)
    },
    marginBlockStart: {
        style: (0, $99c8f593f1790ef1$export$7ede87f9b603dd3c)
    },
    marginBlockEnd: {
        style: (0, $99c8f593f1790ef1$export$7ede87f9b603dd3c)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $8a7d7fc795cee191$export$5df9adcb0db95e1e)
    },
    rowGap: {
        style: (0, $8a7d7fc795cee191$export$8a833ffa5f5dbeda)
    },
    columnGap: {
        style: (0, $8a7d7fc795cee191$export$ec60d70ff941a580)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $692eaea4660c42f3$export$8afece71750ec241)
    },
    maxWidth: {
        style: (0, $692eaea4660c42f3$export$488fda99655ff65a)
    },
    minWidth: {
        transform: (0, $692eaea4660c42f3$export$8afece71750ec241)
    },
    height: {
        transform: (0, $692eaea4660c42f3$export$8afece71750ec241)
    },
    maxHeight: {
        transform: (0, $692eaea4660c42f3$export$8afece71750ec241)
    },
    minHeight: {
        transform: (0, $692eaea4660c42f3$export$8afece71750ec241)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $d138c1b003d294d5$export$2e2bcd8739ae039 = $d138c1b003d294d5$var$defaultSxConfig;


function $663795ec7cbfcd06$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $663795ec7cbfcd06$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $663795ec7cbfcd06$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $0e15c04d427b6a62$export$2aa3fd96c49a84a8)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $0e15c04d427b6a62$export$741ad47189a64aa0)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $0e15c04d427b6a62$export$741ad47189a64aa0)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $cdb179da000bc841$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $4a0a613f758c442e$export$88347efdb2e19abd)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? (0, $d138c1b003d294d5$export$2e2bcd8739ae039);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $4a0a613f758c442e$export$1f2600516e91381f)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $663795ec7cbfcd06$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $625ef458e0e03ef7$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $4a0a613f758c442e$export$88347efdb2e19abd)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($663795ec7cbfcd06$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $625ef458e0e03ef7$export$2e2bcd8739ae039)(css, breakpointsValues);
                        }
                    } else css = (0, $625ef458e0e03ef7$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $2325fbc34513c7d9$export$456f6c1142f990db)(theme, (0, $4a0a613f758c442e$export$8922c90b6e020726)(breakpointsKeys, css))
            };
            return (0, $2325fbc34513c7d9$export$456f6c1142f990db)(theme, (0, $4a0a613f758c442e$export$8922c90b6e020726)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $663795ec7cbfcd06$var$styleFunctionSx = $663795ec7cbfcd06$export$7d53d8bf2911e013();
$663795ec7cbfcd06$var$styleFunctionSx.filterProps = [
    'sx'
];
var $663795ec7cbfcd06$export$2e2bcd8739ae039 = $663795ec7cbfcd06$var$styleFunctionSx;



/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $3b88b157d6186746$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}


function $1f34940f58017e5f$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $ee7482569024fa37$export$2e2bcd8739ae039)(breakpointsInput);
    const spacing = (0, $0808b5e3ab0ab6d4$export$2e2bcd8739ae039)(spacingInput);
    let muiTheme = (0, $e8430d81ac377dda$export$2e2bcd8739ae039)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $f637f3037d6dee04$export$2e2bcd8739ae039),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $2325fbc34513c7d9$export$2e2bcd8739ae039)(muiTheme);
    muiTheme.applyStyles = (0, $3b88b157d6186746$export$2e2bcd8739ae039);
    muiTheme = args.reduce((acc, argument)=>(0, $e8430d81ac377dda$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $d138c1b003d294d5$export$2e2bcd8739ae039),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $663795ec7cbfcd06$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $1f34940f58017e5f$export$2e2bcd8739ae039 = $1f34940f58017e5f$var$createTheme;




function $a1569aad1198ad2f$export$2e2bcd8739ae039(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $0275daee3ffe340c$export$13a2d3ef13012b32)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $0275daee3ffe340c$export$13a2d3ef13012b32)(variant.style);
    });
    return result;
}


const $53a046746a0f000c$export$35e57303dbd8a66 = (0, $1f34940f58017e5f$export$2e2bcd8739ae039)();
function $53a046746a0f000c$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $53a046746a0f000c$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
function $53a046746a0f000c$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $53a046746a0f000c$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $53a046746a0f000c$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $53a046746a0f000c$var$processStyle(props, style, layerName) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$53a046746a0f000c$var$processStyle(props, subStyle, layerName));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = layerName ? $53a046746a0f000c$var$shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = layerName ? $53a046746a0f000c$var$shallowLayer((0, $0275daee3ffe340c$export$13a2d3ef13012b32)(otherStyles), layerName) : otherStyles;
        }
        return $53a046746a0f000c$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ], layerName);
    }
    if (resolvedStyle?.isProcessed) return layerName ? $53a046746a0f000c$var$shallowLayer((0, $0275daee3ffe340c$export$13a2d3ef13012b32)(resolvedStyle.style), layerName) : resolvedStyle.style;
    return layerName ? $53a046746a0f000c$var$shallowLayer((0, $0275daee3ffe340c$export$13a2d3ef13012b32)(resolvedStyle), layerName) : resolvedStyle;
}
function $53a046746a0f000c$var$processStyleVariants(props, variants, results = [], layerName) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            results.push(layerName ? $53a046746a0f000c$var$shallowLayer((0, $0275daee3ffe340c$export$13a2d3ef13012b32)(variant.style(mergedState)), layerName) : variant.style(mergedState));
        } else results.push(layerName ? $53a046746a0f000c$var$shallowLayer((0, $0275daee3ffe340c$export$13a2d3ef13012b32)(variant.style), layerName) : variant.style);
    }
    return results;
}
function $53a046746a0f000c$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $53a046746a0f000c$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $53a046746a0f000c$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $53a046746a0f000c$export$3ba67b570e26eea0 } = input;
    function styleAttachTheme(props) {
        $53a046746a0f000c$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $0275daee3ffe340c$export$592c7226e4cb0171)(tag, (styles)=>styles.filter((style)=>style !== (0, $663795ec7cbfcd06$export$2e2bcd8739ae039)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $53a046746a0f000c$var$defaultOverridesResolver($53a046746a0f000c$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $53a046746a0f000c$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($53a046746a0f000c$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $0275daee3ffe340c$export$2e2bcd8739ae039)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $53a046746a0f000c$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return $53a046746a0f000c$var$processStyle(props, style, props.theme.modularCssLayers ? layerName : undefined);
            };
            if ((0, $e8430d81ac377dda$export$53b83ca8eaab0383)(style)) {
                const serialized = (0, $a1569aad1198ad2f$export$2e2bcd8739ae039)(style);
                return function styleObjectProcessor(props) {
                    if (!serialized.variants) return props.theme.modularCssLayers ? $53a046746a0f000c$var$shallowLayer(serialized.style, layerName) : serialized.style;
                    return $53a046746a0f000c$var$processStyle(props, serialized, props.theme.modularCssLayers ? layerName : undefined);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $53a046746a0f000c$var$processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? 'theme' : undefined);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $53a046746a0f000c$var$processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsTail.push((0, $663795ec7cbfcd06$export$2e2bcd8739ae039));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $53a046746a0f000c$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $cdb179da000bc841$export$2e2bcd8739ae039)(componentSlot || '')}`;
    return `Styled(${(0, $ecc4900d9897c775$export$2e2bcd8739ae039)(tag)})`;
}
function $53a046746a0f000c$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $53a046746a0f000c$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $53a046746a0f000c$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $53a046746a0f000c$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}








function $d06c97123b871a27$export$6cb188bdacb35d0e(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPickersFilledInput', slot);
}
const $d06c97123b871a27$export$3964d3188824d772 = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $4e34e4f453eed645$export$f20b5ba262568322), (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPickersFilledInput', [
    'root',
    'underline',
    'input'
]));





const $516b2ec73c7e64bf$var$_excluded = [
    "label",
    "autoFocus",
    "disableUnderline",
    "ownerState"
];
const $516b2ec73c7e64bf$var$PickersFilledInputRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $dc4fd6b984f9cff5$export$ddc18880178d980e), {
    name: 'MuiPickersFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $53a046746a0f000c$export$3ba67b570e26eea0)(prop) && prop !== 'disableUnderline'
})(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $d06c97123b871a27$export$3964d3188824d772).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $d06c97123b871a27$export$3964d3188824d772).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            ...Object.keys((theme.vars ?? theme).palette)// @ts-ignore
            .filter((key)=>(theme.vars ?? theme).palette[key].main).map((color)=>({
                    props: {
                        color: color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            // @ts-ignore
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: {
                    disableUnderline: false
                },
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $d06c97123b871a27$export$3964d3188824d772).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $d06c97123b871a27$export$3964d3188824d772).error}`]: {
                        '&:before, &:after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $d06c97123b871a27$export$3964d3188824d772).disabled}, .${(0, $d06c97123b871a27$export$3964d3188824d772).error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${(0, $d06c97123b871a27$export$3964d3188824d772).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            {
                props: ({ startAdornment: startAdornment })=>!!startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ endAdornment: endAdornment })=>!!endAdornment,
                style: {
                    paddingRight: 12
                }
            }
        ]
    };
});
const $516b2ec73c7e64bf$var$PickersFilledSectionsContainer = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $dc4fd6b984f9cff5$export$52f3fbbfe9321824), {
    name: 'MuiPickersFilledInput',
    slot: 'sectionsContainer',
    overridesResolver: (props, styles)=>styles.sectionsContainer
})({
    paddingTop: 25,
    paddingRight: 12,
    paddingBottom: 8,
    paddingLeft: 12,
    variants: [
        {
            props: {
                size: 'small'
            },
            style: {
                paddingTop: 21,
                paddingBottom: 4
            }
        },
        {
            props: ({ startAdornment: startAdornment })=>!!startAdornment,
            style: {
                paddingLeft: 0
            }
        },
        {
            props: ({ endAdornment: endAdornment })=>!!endAdornment,
            style: {
                paddingRight: 0
            }
        },
        {
            props: {
                hiddenLabel: true
            },
            style: {
                paddingTop: 16,
                paddingBottom: 17
            }
        },
        {
            props: {
                hiddenLabel: true,
                size: 'small'
            },
            style: {
                paddingTop: 8,
                paddingBottom: 9
            }
        }
    ]
});
const $516b2ec73c7e64bf$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $d06c97123b871a27$export$6cb188bdacb35d0e), classes);
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $516b2ec73c7e64bf$export$8cc8c624890b5045 = /*#__PURE__*/ $7fPBF.forwardRef(function PickersFilledInput(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersFilledInput'
    });
    const { label: label, disableUnderline: disableUnderline = false, ownerState: ownerStateProp } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $516b2ec73c7e64bf$var$_excluded);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, ownerStateProp, muiFormControl, {
        color: muiFormControl?.color || 'primary'
    });
    const classes = $516b2ec73c7e64bf$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dc4fd6b984f9cff5$export$ff827734ba831074), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        slots: {
            root: $516b2ec73c7e64bf$var$PickersFilledInputRoot,
            input: $516b2ec73c7e64bf$var$PickersFilledSectionsContainer
        },
        slotProps: {
            root: {
                disableUnderline: disableUnderline
            }
        }
    }, other, {
        label: label,
        classes: classes,
        ref: ref
    }));
});
$516b2ec73c7e64bf$export$8cc8c624890b5045.muiName = 'Input';





var $7fPBF = parcelRequire("7fPBF");









function $4a92735f2b47f732$export$defbb17803ff7cff(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPickersFilledInput', slot);
}
const $4a92735f2b47f732$export$f5c5ba079c8bb9dd = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $4e34e4f453eed645$export$f20b5ba262568322), (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPickersInput', [
    'root',
    'input'
]));





const $a081066542264dbf$var$_excluded = [
    "label",
    "autoFocus",
    "disableUnderline",
    "ownerState"
];
const $a081066542264dbf$var$PickersInputRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $dc4fd6b984f9cff5$export$ddc18880178d980e), {
    name: 'MuiPickersInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return {
        'label + &': {
            marginTop: 16
        },
        variants: [
            ...Object.keys((theme.vars ?? theme).palette)// @ts-ignore
            .filter((key)=>(theme.vars ?? theme).palette[key].main).map((color)=>({
                    props: {
                        color: color
                    },
                    style: {
                        '&::after': {
                            // @ts-ignore
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                })),
            {
                props: {
                    disableUnderline: false
                },
                style: {
                    '&::after': {
                        background: 'red',
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $4a92735f2b47f732$export$f5c5ba079c8bb9dd).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $4a92735f2b47f732$export$f5c5ba079c8bb9dd).error}`]: {
                        '&:before, &:after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $4a92735f2b47f732$export$f5c5ba079c8bb9dd).disabled}, .${(0, $4a92735f2b47f732$export$f5c5ba079c8bb9dd).error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${(0, $4a92735f2b47f732$export$f5c5ba079c8bb9dd).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            }
        ]
    };
});
const $a081066542264dbf$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $4a92735f2b47f732$export$defbb17803ff7cff), classes);
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $a081066542264dbf$export$7c4ebb2cfaf4f474 = /*#__PURE__*/ $7fPBF.forwardRef(function PickersInput(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersInput'
    });
    const { label: label, disableUnderline: disableUnderline = false, ownerState: ownerStateProp } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $a081066542264dbf$var$_excluded);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, ownerStateProp, muiFormControl, {
        disableUnderline: disableUnderline,
        color: muiFormControl?.color || 'primary'
    });
    const classes = $a081066542264dbf$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dc4fd6b984f9cff5$export$ff827734ba831074), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        slots: {
            root: $a081066542264dbf$var$PickersInputRoot
        }
    }, other, {
        label: label,
        classes: classes,
        ref: ref
    }));
});
$a081066542264dbf$export$7c4ebb2cfaf4f474.muiName = 'Input';



'use client';
const $d89a2c87fd730b02$var$_excluded = [
    "onFocus",
    "onBlur",
    "className",
    "color",
    "disabled",
    "error",
    "variant",
    "required",
    "InputProps",
    "inputProps",
    "inputRef",
    "sectionListRef",
    "elements",
    "areAllSectionsEmpty",
    "onClick",
    "onKeyDown",
    "onKeyUp",
    "onPaste",
    "onInput",
    "endAdornment",
    "startAdornment",
    "tabIndex",
    "contentEditable",
    "focused",
    "value",
    "onChange",
    "fullWidth",
    "id",
    "name",
    "helperText",
    "FormHelperTextProps",
    "label",
    "InputLabelProps"
];
const $d89a2c87fd730b02$var$VARIANT_COMPONENT = {
    standard: (0, $a081066542264dbf$export$7c4ebb2cfaf4f474),
    filled: (0, $516b2ec73c7e64bf$export$8cc8c624890b5045),
    outlined: (0, $b7ef63051cb6a88b$export$44d4d00edb0c710f)
};
const $d89a2c87fd730b02$var$PickersTextFieldRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $26a8e925f0aa9998$export$2e2bcd8739ae039), {
    name: 'MuiPickersTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    maxWidth: '100%'
});
const $d89a2c87fd730b02$var$useUtilityClasses = (ownerState)=>{
    const { focused: focused, disabled: disabled, classes: classes, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            focused && !disabled && 'focused',
            disabled && 'disabled',
            required && 'required'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $573d364d56ce6842$export$d99678ed7aad1677), classes);
};
const $d89a2c87fd730b02$export$b3e9b101d92e4d4d = /*#__PURE__*/ $7fPBF.forwardRef(function PickersTextField(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersTextField'
    });
    const { onFocus: // Props used by FormControl
    onFocus, onBlur: onBlur, className: className, color: color = 'primary', disabled: disabled = false, error: error = false, variant: variant = 'outlined', required: required = false, InputProps: // Props used by PickersInput
    InputProps, inputProps: inputProps, inputRef: inputRef, sectionListRef: sectionListRef, elements: elements, areAllSectionsEmpty: areAllSectionsEmpty, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onPaste: onPaste, onInput: onInput, endAdornment: endAdornment, startAdornment: startAdornment, tabIndex: tabIndex, contentEditable: contentEditable, focused: focused, value: value, onChange: onChange, fullWidth: fullWidth, id: idProp, name: name, helperText: // Props used by FormHelperText
    helperText, FormHelperTextProps: FormHelperTextProps, label: // Props used by InputLabel
    label, InputLabelProps: InputLabelProps } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $d89a2c87fd730b02$var$_excluded);
    const rootRef = $7fPBF.useRef(null);
    const handleRootRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(ref, rootRef);
    const id = (0, $46f5b561912058f9$export$2e2bcd8739ae039)(idProp);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        color: color,
        disabled: disabled,
        error: error,
        focused: focused,
        required: required,
        variant: variant
    });
    const classes = $d89a2c87fd730b02$var$useUtilityClasses(ownerState);
    const PickersInputComponent = $d89a2c87fd730b02$var$VARIANT_COMPONENT[variant];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d89a2c87fd730b02$var$PickersTextFieldRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: handleRootRef,
        focused: focused,
        onFocus: onFocus,
        onBlur: onBlur,
        disabled: disabled,
        variant: variant,
        error: error,
        color: color,
        fullWidth: fullWidth,
        required: required,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcd80672e9993aad$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(PickersInputComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                elements: elements,
                areAllSectionsEmpty: areAllSectionsEmpty,
                onClick: onClick,
                onKeyDown: onKeyDown,
                onKeyUp: onKeyUp,
                onInput: onInput,
                onPaste: onPaste,
                endAdornment: endAdornment,
                startAdornment: startAdornment,
                tabIndex: tabIndex,
                contentEditable: contentEditable,
                value: value,
                onChange: onChange,
                id: id,
                fullWidth: fullWidth,
                inputProps: inputProps,
                inputRef: inputRef,
                sectionListRef: sectionListRef,
                label: label,
                name: name,
                role: "group",
                "aria-labelledby": inputLabelId,
                "aria-describedby": helperTextId,
                "aria-live": helperTextId ? 'polite' : undefined
            }, InputProps)),
            helperText && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0321a2cb63129955$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});




const $1fdb61029ea16c41$var$_excluded = [
    "enableAccessibleFieldDOMStructure"
], $1fdb61029ea16c41$var$_excluded2 = [
    "InputProps",
    "readOnly"
], $1fdb61029ea16c41$var$_excluded3 = [
    "onPaste",
    "onKeyDown",
    "inputMode",
    "readOnly",
    "InputProps",
    "inputProps",
    "inputRef"
];
const $1fdb61029ea16c41$export$20bf15d9b24b4dad = (_ref)=>{
    let { enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure } = _ref, fieldResponse = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $1fdb61029ea16c41$var$_excluded);
    if (enableAccessibleFieldDOMStructure) {
        const { InputProps: InputProps, readOnly: readOnly } = fieldResponse, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(fieldResponse, $1fdb61029ea16c41$var$_excluded2);
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, other, {
            InputProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, InputProps ?? {}, {
                readOnly: readOnly
            })
        });
    }
    const { onPaste: onPaste, onKeyDown: onKeyDown, inputMode: inputMode, readOnly: readOnly, InputProps: InputProps, inputProps: inputProps, inputRef: inputRef } = fieldResponse, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(fieldResponse, $1fdb61029ea16c41$var$_excluded3);
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, other, {
        InputProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, InputProps ?? {}, {
            readOnly: readOnly
        }),
        inputProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, inputProps ?? {}, {
            inputMode: inputMode,
            onPaste: onPaste,
            onKeyDown: onKeyDown,
            ref: inputRef
        })
    });
};



'use client';
const $5945f8b72dcc769b$var$_excluded = [
    "slots",
    "slotProps",
    "InputProps",
    "inputProps"
];
/**
 * Demos:
 *
 * - [DateField](http://mui.com/x/react-date-pickers/date-field/)
 * - [Fields](https://mui.com/x/react-date-pickers/fields/)
 *
 * API:
 *
 * - [DateField API](https://mui.com/x/api/date-pickers/date-field/)
 */ const $5945f8b72dcc769b$export$d9781c7894a82487 = /*#__PURE__*/ $7fPBF.forwardRef(function DateField(inProps, inRef) {
    const themeProps = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDateField'
    });
    const { slots: slots, slotProps: slotProps, InputProps: InputProps, inputProps: inputProps } = themeProps, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(themeProps, $5945f8b72dcc769b$var$_excluded);
    const ownerState = themeProps;
    const TextField = slots?.textField ?? (inProps.enableAccessibleFieldDOMStructure ? (0, $d89a2c87fd730b02$export$b3e9b101d92e4d4d) : (0, $afe2b905acb8b9f6$export$2e2bcd8739ae039));
    const textFieldProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: TextField,
        externalSlotProps: slotProps?.textField,
        externalForwardedProps: other,
        additionalProps: {
            ref: inRef
        },
        ownerState: ownerState
    });
    // TODO: Remove when mui/material-ui#35088 will be merged
    textFieldProps.inputProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, inputProps, textFieldProps.inputProps);
    textFieldProps.InputProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, InputProps, textFieldProps.InputProps);
    const fieldResponse = (0, $da4099eec06cd7d9$export$5591b0b878c1a989)(textFieldProps);
    const convertedFieldResponse = (0, $1fdb61029ea16c41$export$20bf15d9b24b4dad)(fieldResponse);
    const processedFieldProps = (0, $f8c7cbeb7c9ac09c$export$db9644cdb7e3d432)((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, convertedFieldResponse, {
        slots: slots,
        slotProps: slotProps
    }));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TextField, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, processedFieldProps));
});


parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");







var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");


'use client';
const $272960e2556e540f$export$7d1a419f34475191 = ({ shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, minDate: minDate, maxDate: maxDate, disableFuture: disableFuture, disablePast: disablePast, timezone: timezone })=>{
    const adapter = (0, $6945e6366bb58773$export$4b5a24245de9f7f9)();
    return $7fPBF.useCallback((day)=>(0, $c885b418e3c240b8$export$ffb3d0046ef3a2)({
            adapter: adapter,
            value: day,
            timezone: timezone,
            props: {
                shouldDisableDate: shouldDisableDate,
                shouldDisableMonth: shouldDisableMonth,
                shouldDisableYear: shouldDisableYear,
                minDate: minDate,
                maxDate: maxDate,
                disableFuture: disableFuture,
                disablePast: disablePast
            }
        }) !== null, [
        adapter,
        shouldDisableDate,
        shouldDisableMonth,
        shouldDisableYear,
        minDate,
        maxDate,
        disableFuture,
        disablePast,
        timezone
    ]);
};





'use client';
const $b7c44e28b3ec1424$export$2aba07ea6b6cf430 = (reduceAnimations, disableSwitchToMonthOnDayFocus, utils)=>(state, action)=>{
        switch(action.type){
            case 'changeMonth':
                return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state, {
                    slideDirection: action.direction,
                    currentMonth: action.newMonth,
                    isMonthSwitchingAnimating: !reduceAnimations
                });
            case 'changeMonthTimezone':
                {
                    const newTimezone = action.newTimezone;
                    if (utils.getTimezone(state.currentMonth) === newTimezone) return state;
                    let newCurrentMonth = utils.setTimezone(state.currentMonth, newTimezone);
                    if (utils.getMonth(newCurrentMonth) !== utils.getMonth(state.currentMonth)) newCurrentMonth = utils.setMonth(newCurrentMonth, utils.getMonth(state.currentMonth));
                    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state, {
                        currentMonth: newCurrentMonth
                    });
                }
            case 'finishMonthSwitchingAnimation':
                return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state, {
                    isMonthSwitchingAnimating: false
                });
            case 'changeFocusedDay':
                {
                    if (state.focusedDay != null && action.focusedDay != null && utils.isSameDay(action.focusedDay, state.focusedDay)) return state;
                    const needMonthSwitch = action.focusedDay != null && !disableSwitchToMonthOnDayFocus && !utils.isSameMonth(state.currentMonth, action.focusedDay);
                    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state, {
                        focusedDay: action.focusedDay,
                        isMonthSwitchingAnimating: needMonthSwitch && !reduceAnimations && !action.withoutMonthSwitchingAnimation,
                        currentMonth: needMonthSwitch ? utils.startOfMonth(action.focusedDay) : state.currentMonth,
                        slideDirection: action.focusedDay != null && utils.isAfterDay(action.focusedDay, state.currentMonth) ? 'left' : 'right'
                    });
                }
            default:
                throw new Error('missing support');
        }
    };
const $b7c44e28b3ec1424$export$6d095e787d2b5e1f = (params)=>{
    const { value: value, referenceDate: referenceDateProp, disableFuture: disableFuture, disablePast: disablePast, disableSwitchToMonthOnDayFocus: disableSwitchToMonthOnDayFocus = false, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, timezone: timezone } = params;
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const reducerFn = $7fPBF.useRef($b7c44e28b3ec1424$export$2aba07ea6b6cf430(Boolean(reduceAnimations), disableSwitchToMonthOnDayFocus, utils)).current;
    const referenceDate = $7fPBF.useMemo(()=>{
        return (0, $841d6de1e4809c9b$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            timezone: timezone,
            props: params,
            referenceDate: referenceDateProp,
            granularity: (0, $03cf12356675f79b$export$8f74e8f4ed8ae0ac).day
        });
    }, // We want the `referenceDate` to update on prop and `timezone` change (https://github.com/mui/mui-x/issues/10804)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        referenceDateProp,
        timezone
    ]);
    const [calendarState, dispatch] = $7fPBF.useReducer(reducerFn, {
        isMonthSwitchingAnimating: false,
        focusedDay: referenceDate,
        currentMonth: utils.startOfMonth(referenceDate),
        slideDirection: 'left'
    });
    // Ensure that `calendarState.currentMonth` timezone is updated when `referenceDate` (or timezone changes)
    // https://github.com/mui/mui-x/issues/10804
    $7fPBF.useEffect(()=>{
        dispatch({
            type: 'changeMonthTimezone',
            newTimezone: utils.getTimezone(referenceDate)
        });
    }, [
        referenceDate,
        utils
    ]);
    const handleChangeMonth = $7fPBF.useCallback((payload)=>{
        dispatch((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            type: 'changeMonth'
        }, payload));
        if (onMonthChange) onMonthChange(payload.newMonth);
    }, [
        onMonthChange
    ]);
    const changeMonth = $7fPBF.useCallback((newDate)=>{
        const newDateRequested = newDate;
        if (utils.isSameMonth(newDateRequested, calendarState.currentMonth)) return;
        handleChangeMonth({
            newMonth: utils.startOfMonth(newDateRequested),
            direction: utils.isAfterDay(newDateRequested, calendarState.currentMonth) ? 'left' : 'right'
        });
    }, [
        calendarState.currentMonth,
        handleChangeMonth,
        utils
    ]);
    const isDateDisabled = (0, $272960e2556e540f$export$7d1a419f34475191)({
        shouldDisableDate: shouldDisableDate,
        minDate: minDate,
        maxDate: maxDate,
        disableFuture: disableFuture,
        disablePast: disablePast,
        timezone: timezone
    });
    const onMonthSwitchingAnimationEnd = $7fPBF.useCallback(()=>{
        dispatch({
            type: 'finishMonthSwitchingAnimation'
        });
    }, []);
    const changeFocusedDay = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((newFocusedDate, withoutMonthSwitchingAnimation)=>{
        if (!isDateDisabled(newFocusedDate)) dispatch({
            type: 'changeFocusedDay',
            focusedDay: newFocusedDate,
            withoutMonthSwitchingAnimation: withoutMonthSwitchingAnimation
        });
    });
    return {
        referenceDate: referenceDate,
        calendarState: calendarState,
        changeMonth: changeMonth,
        changeFocusedDay: changeFocusedDay,
        isDateDisabled: isDateDisabled,
        onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
        handleChangeMonth: handleChangeMonth
    };
};



parcelRequire("7fPBF");






const $aaad891d0da306eb$export$5b0bb0174eb448ca = (slot)=>(0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPickersFadeTransitionGroup', slot);
const $aaad891d0da306eb$export$1461f245817ac559 = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPickersFadeTransitionGroup', [
    'root'
]);



const $966d54c4b5737349$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $aaad891d0da306eb$export$5b0bb0174eb448ca), classes);
};
const $966d54c4b5737349$var$PickersFadeTransitionGroupRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $30921f11ad4ef55c$export$2e2bcd8739ae039), {
    name: 'MuiPickersFadeTransitionGroup',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({
    display: 'block',
    position: 'relative'
});
function $966d54c4b5737349$export$5262185daf493fee(inProps) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersFadeTransitionGroup'
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, transKey: transKey } = props;
    const classes = $966d54c4b5737349$var$useUtilityClasses(props);
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    if (reduceAnimations) return children;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($966d54c4b5737349$var$PickersFadeTransitionGroupRoot, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $68214be7242cbfc8$export$2e2bcd8739ae039), {
            appear: false,
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: {
                appear: theme.transitions.duration.enteringScreen,
                enter: theme.transitions.duration.enteringScreen,
                exit: 0
            },
            children: children
        }, transKey)
    });
}





var $7fPBF = parcelRequire("7fPBF");










var $7fPBF = parcelRequire("7fPBF");








function $7704811ff6d1667b$export$4b25deb0350d3e53(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPickersDay', slot);
}
const $7704811ff6d1667b$export$68b221ad3c35e288 = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPickersDay', [
    'root',
    'dayWithMargin',
    'dayOutsideMonth',
    'hiddenDaySpacingFiller',
    'today',
    'selected',
    'disabled'
]);



'use client';
const $d64849e0226d1a8f$var$_excluded = [
    "autoFocus",
    "className",
    "day",
    "disabled",
    "disableHighlightToday",
    "disableMargin",
    "hidden",
    "isAnimating",
    "onClick",
    "onDaySelect",
    "onFocus",
    "onBlur",
    "onKeyDown",
    "onMouseDown",
    "onMouseEnter",
    "outsideCurrentMonth",
    "selected",
    "showDaysOutsideCurrentMonth",
    "children",
    "today",
    "isFirstVisibleCell",
    "isLastVisibleCell"
];
const $d64849e0226d1a8f$var$useUtilityClasses = (ownerState)=>{
    const { selected: selected, disableMargin: disableMargin, disableHighlightToday: disableHighlightToday, today: today, disabled: disabled, outsideCurrentMonth: outsideCurrentMonth, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, classes: classes } = ownerState;
    const isHiddenDaySpacingFiller = outsideCurrentMonth && !showDaysOutsideCurrentMonth;
    const slots = {
        root: [
            'root',
            selected && !isHiddenDaySpacingFiller && 'selected',
            disabled && 'disabled',
            !disableMargin && 'dayWithMargin',
            !disableHighlightToday && today && 'today',
            outsideCurrentMonth && showDaysOutsideCurrentMonth && 'dayOutsideMonth',
            isHiddenDaySpacingFiller && 'hiddenDaySpacingFiller'
        ],
        hiddenDaySpacingFiller: [
            'hiddenDaySpacingFiller'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $7704811ff6d1667b$export$4b25deb0350d3e53), classes);
};
const $d64849e0226d1a8f$var$styleArg = ({ theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, theme.typography.caption, {
        width: (0, $f49d2ca225f7bed5$export$3f0060ce4cc8f4d0),
        height: (0, $f49d2ca225f7bed5$export$3f0060ce4cc8f4d0),
        borderRadius: '50%',
        padding: 0,
        // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
        backgroundColor: 'transparent',
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.short
        }),
        color: (theme.vars || theme).palette.text.primary,
        '@media (pointer: fine)': {
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
            }
        },
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.focusOpacity),
            [`&.${(0, $7704811ff6d1667b$export$68b221ad3c35e288).selected}`]: {
                willChange: 'background-color',
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, $7704811ff6d1667b$export$68b221ad3c35e288).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            '&:hover': {
                willChange: 'background-color',
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, $7704811ff6d1667b$export$68b221ad3c35e288).disabled}:not(.${(0, $7704811ff6d1667b$export$68b221ad3c35e288).selected})`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $7704811ff6d1667b$export$68b221ad3c35e288).disabled}&.${(0, $7704811ff6d1667b$export$68b221ad3c35e288).selected}`]: {
            opacity: 0.6
        },
        variants: [
            {
                props: {
                    disableMargin: false
                },
                style: {
                    margin: `0 ${(0, $f49d2ca225f7bed5$export$dde58b009b497666)}px`
                }
            },
            {
                props: {
                    outsideCurrentMonth: true,
                    showDaysOutsideCurrentMonth: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary
                }
            },
            {
                props: {
                    disableHighlightToday: false,
                    today: true
                },
                style: {
                    [`&:not(.${(0, $7704811ff6d1667b$export$68b221ad3c35e288).selected})`]: {
                        border: `1px solid ${(theme.vars || theme).palette.text.secondary}`
                    }
                }
            }
        ]
    });
const $d64849e0226d1a8f$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        !ownerState.disableMargin && styles.dayWithMargin,
        !ownerState.disableHighlightToday && ownerState.today && styles.today,
        !ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth,
        ownerState.outsideCurrentMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller
    ];
};
const $d64849e0226d1a8f$var$PickersDayRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver: $d64849e0226d1a8f$var$overridesResolver
})($d64849e0226d1a8f$var$styleArg);
const $d64849e0226d1a8f$var$PickersDayFiller = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver: $d64849e0226d1a8f$var$overridesResolver
})(({ theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $d64849e0226d1a8f$var$styleArg({
        theme: theme
    }), {
        // visibility: 'hidden' does not work here as it hides the element from screen readers as well
        opacity: 0,
        pointerEvents: 'none'
    }));
const $d64849e0226d1a8f$var$noop = ()=>{};
const $d64849e0226d1a8f$var$PickersDayRaw = /*#__PURE__*/ $7fPBF.forwardRef(function PickersDay(inProps, forwardedRef) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersDay'
    });
    const { autoFocus: autoFocus = false, className: className, day: day, disabled: disabled = false, disableHighlightToday: disableHighlightToday = false, disableMargin: disableMargin = false, isAnimating: isAnimating, onClick: onClick, onDaySelect: onDaySelect, onFocus: onFocus = $d64849e0226d1a8f$var$noop, onBlur: onBlur = $d64849e0226d1a8f$var$noop, onKeyDown: onKeyDown = $d64849e0226d1a8f$var$noop, onMouseDown: onMouseDown = $d64849e0226d1a8f$var$noop, onMouseEnter: onMouseEnter = $d64849e0226d1a8f$var$noop, outsideCurrentMonth: outsideCurrentMonth, selected: selected = false, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth = false, children: children, today: isToday = false } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $d64849e0226d1a8f$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        autoFocus: autoFocus,
        disabled: disabled,
        disableHighlightToday: disableHighlightToday,
        disableMargin: disableMargin,
        selected: selected,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        today: isToday
    });
    const classes = $d64849e0226d1a8f$var$useUtilityClasses(ownerState);
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const ref = $7fPBF.useRef(null);
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(ref, forwardedRef);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) // ref.current being null would be a bug in MUI
        ref.current.focus();
    }, [
        autoFocus,
        disabled,
        isAnimating,
        outsideCurrentMonth
    ]);
    // For a day outside the current month, move the focus from mouseDown to mouseUp
    // Goal: have the onClick ends before sliding to the new month
    const handleMouseDown = (event)=>{
        onMouseDown(event);
        if (outsideCurrentMonth) event.preventDefault();
    };
    const handleClick = (event)=>{
        if (!disabled) onDaySelect(day);
        if (outsideCurrentMonth) event.currentTarget.focus();
        if (onClick) onClick(event);
    };
    if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d64849e0226d1a8f$var$PickersDayFiller, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, classes.hiddenDaySpacingFiller, className),
        ownerState: ownerState,
        role: other.role
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d64849e0226d1a8f$var$PickersDayRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: handleRef,
        centerRipple: true,
        disabled: disabled,
        tabIndex: selected ? 0 : -1,
        onKeyDown: (event)=>onKeyDown(event, day),
        onFocus: (event)=>onFocus(event, day),
        onBlur: (event)=>onBlur(event, day),
        onMouseEnter: (event)=>onMouseEnter(event, day),
        onClick: handleClick,
        onMouseDown: handleMouseDown
    }, other, {
        ownerState: ownerState,
        children: !children ? utils.format(day, 'dayOfMonth') : children
    }));
});
const $d64849e0226d1a8f$export$d7378e6e864346fa = /*#__PURE__*/ $7fPBF.memo($d64849e0226d1a8f$var$PickersDayRaw);








var $7fPBF = parcelRequire("7fPBF");







/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $5e2f8ad2f75c6c7a$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $1e3f901d29816e8c$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $5e2f8ad2f75c6c7a$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}


function $89edc8a1840ff9c1$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $89edc8a1840ff9c1$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $89edc8a1840ff9c1$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $89edc8a1840ff9c1$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



var $7fPBF = parcelRequire("7fPBF");



var $f9e47e451b39ae9f$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $1e3f901d29816e8c$export$2e2bcd8739ae039)(node, c);
    });
};
var $f9e47e451b39ae9f$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $89edc8a1840ff9c1$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $f9e47e451b39ae9f$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $146ee816144a450d$export$2e2bcd8739ae039)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $f1bbb084f2fb10b7$export$7d26bbb1236dafd6)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $f9e47e451b39ae9f$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $f9e47e451b39ae9f$var$removeClass(node, baseClassName);
        if (activeClassName) $f9e47e451b39ae9f$var$removeClass(node, activeClassName);
        if (doneClassName) $f9e47e451b39ae9f$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $623678cbb6daf054$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$f9e47e451b39ae9f$var$CSSTransition.defaultProps = {
    classNames: ''
};
$f9e47e451b39ae9f$var$CSSTransition.propTypes = {};
var $f9e47e451b39ae9f$export$2e2bcd8739ae039 = $f9e47e451b39ae9f$var$CSSTransition;



const $b250f2b85e5b8968$export$e98c1b6c3bbc3c59 = (slot)=>(0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPickersSlideTransition', slot);
const $b250f2b85e5b8968$export$d251a58673156a67 = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPickersSlideTransition', [
    'root',
    'slideEnter-left',
    'slideEnter-right',
    'slideEnterActive',
    'slideExit',
    'slideExitActiveLeft-left',
    'slideExitActiveLeft-right'
]);



const $56e2eef78447d2ae$var$_excluded = [
    "children",
    "className",
    "reduceAnimations",
    "slideDirection",
    "transKey",
    "classes"
];
const $56e2eef78447d2ae$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, slideDirection: slideDirection } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        exit: [
            'slideExit'
        ],
        enterActive: [
            'slideEnterActive'
        ],
        enter: [
            `slideEnter-${slideDirection}`
        ],
        exitActive: [
            `slideExitActiveLeft-${slideDirection}`
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $b250f2b85e5b8968$export$e98c1b6c3bbc3c59), classes);
};
const $56e2eef78447d2ae$var$PickersSlideTransitionRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $30921f11ad4ef55c$export$2e2bcd8739ae039), {
    name: 'MuiPickersSlideTransition',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`.${(0, $b250f2b85e5b8968$export$d251a58673156a67)['slideEnter-left']}`]: styles['slideEnter-left']
            },
            {
                [`.${(0, $b250f2b85e5b8968$export$d251a58673156a67)['slideEnter-right']}`]: styles['slideEnter-right']
            },
            {
                [`.${(0, $b250f2b85e5b8968$export$d251a58673156a67).slideEnterActive}`]: styles.slideEnterActive
            },
            {
                [`.${(0, $b250f2b85e5b8968$export$d251a58673156a67).slideExit}`]: styles.slideExit
            },
            {
                [`.${(0, $b250f2b85e5b8968$export$d251a58673156a67)['slideExitActiveLeft-left']}`]: styles['slideExitActiveLeft-left']
            },
            {
                [`.${(0, $b250f2b85e5b8968$export$d251a58673156a67)['slideExitActiveLeft-right']}`]: styles['slideExitActiveLeft-right']
            }
        ]
})(({ theme: theme })=>{
    const slideTransition = theme.transitions.create('transform', {
        duration: theme.transitions.duration.complex,
        easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
    });
    return {
        display: 'block',
        position: 'relative',
        overflowX: 'hidden',
        '& > *': {
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0
        },
        [`& .${(0, $b250f2b85e5b8968$export$d251a58673156a67)['slideEnter-left']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            zIndex: 1
        },
        [`& .${(0, $b250f2b85e5b8968$export$d251a58673156a67)['slideEnter-right']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            zIndex: 1
        },
        [`& .${(0, $b250f2b85e5b8968$export$d251a58673156a67).slideEnterActive}`]: {
            transform: 'translate(0%)',
            transition: slideTransition
        },
        [`& .${(0, $b250f2b85e5b8968$export$d251a58673156a67).slideExit}`]: {
            transform: 'translate(0%)'
        },
        [`& .${(0, $b250f2b85e5b8968$export$d251a58673156a67)['slideExitActiveLeft-left']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            transition: slideTransition,
            zIndex: 0
        },
        [`& .${(0, $b250f2b85e5b8968$export$d251a58673156a67)['slideExitActiveLeft-right']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            transition: slideTransition,
            zIndex: 0
        }
    };
});
function $56e2eef78447d2ae$export$e868fcc7557d3a06(inProps) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersSlideTransition'
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, transKey: transKey } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $56e2eef78447d2ae$var$_excluded);
    const classes = $56e2eef78447d2ae$var$useUtilityClasses(props);
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    if (reduceAnimations) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        children: children
    });
    const transitionClasses = {
        exit: classes.exit,
        enterActive: classes.enterActive,
        enter: classes.enter,
        exitActive: classes.exitActive
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($56e2eef78447d2ae$var$PickersSlideTransitionRoot, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        childFactory: (element)=>/*#__PURE__*/ $7fPBF.cloneElement(element, {
                classNames: transitionClasses
            }),
        role: "presentation",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f9e47e451b39ae9f$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: theme.transitions.duration.complex,
            classNames: transitionClasses
        }, other, {
            children: children
        }), transKey)
    });
}





const $ae6a8d447141a6ad$export$fbe827982a69894a = (slot)=>(0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiDayCalendar', slot);
const $ae6a8d447141a6ad$export$b3f91ee59da1294a = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiDayCalendar', [
    'root',
    'header',
    'weekDayLabel',
    'loadingContainer',
    'slideTransition',
    'monthContainer',
    'weekContainer',
    'weekNumberLabel',
    'weekNumber'
]);



'use client';
const $c2d389da60812d08$var$_excluded = [
    "parentProps",
    "day",
    "focusableDay",
    "selectedDays",
    "isDateDisabled",
    "currentMonthNumber",
    "isViewFocused"
], $c2d389da60812d08$var$_excluded2 = [
    "ownerState"
];
const $c2d389da60812d08$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        header: [
            'header'
        ],
        weekDayLabel: [
            'weekDayLabel'
        ],
        loadingContainer: [
            'loadingContainer'
        ],
        slideTransition: [
            'slideTransition'
        ],
        monthContainer: [
            'monthContainer'
        ],
        weekContainer: [
            'weekContainer'
        ],
        weekNumberLabel: [
            'weekNumberLabel'
        ],
        weekNumber: [
            'weekNumber'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $ae6a8d447141a6ad$export$fbe827982a69894a), classes);
};
const $c2d389da60812d08$var$weeksContainerHeight = ((0, $f49d2ca225f7bed5$export$3f0060ce4cc8f4d0) + (0, $f49d2ca225f7bed5$export$dde58b009b497666) * 2) * 6;
const $c2d389da60812d08$var$PickersCalendarDayRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiDayCalendar',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({});
const $c2d389da60812d08$var$PickersCalendarDayHeader = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiDayCalendar',
    slot: 'Header',
    overridesResolver: (_, styles)=>styles.header
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $c2d389da60812d08$var$PickersCalendarWeekDayLabel = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
    name: 'MuiDayCalendar',
    slot: 'WeekDayLabel',
    overridesResolver: (_, styles)=>styles.weekDayLabel
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: (theme.vars || theme).palette.text.secondary
    }));
const $c2d389da60812d08$var$PickersCalendarWeekNumberLabel = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
    name: 'MuiDayCalendar',
    slot: 'WeekNumberLabel',
    overridesResolver: (_, styles)=>styles.weekNumberLabel
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: theme.palette.text.disabled
    }));
const $c2d389da60812d08$var$PickersCalendarWeekNumber = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
    name: 'MuiDayCalendar',
    slot: 'WeekNumber',
    overridesResolver: (_, styles)=>styles.weekNumber
})(({ theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, theme.typography.caption, {
        width: (0, $f49d2ca225f7bed5$export$3f0060ce4cc8f4d0),
        height: (0, $f49d2ca225f7bed5$export$3f0060ce4cc8f4d0),
        padding: 0,
        margin: `0 ${(0, $f49d2ca225f7bed5$export$dde58b009b497666)}px`,
        color: theme.palette.text.disabled,
        fontSize: '0.75rem',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'inline-flex'
    }));
const $c2d389da60812d08$var$PickersCalendarLoadingContainer = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiDayCalendar',
    slot: 'LoadingContainer',
    overridesResolver: (_, styles)=>styles.loadingContainer
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: $c2d389da60812d08$var$weeksContainerHeight
});
const $c2d389da60812d08$var$PickersCalendarSlideTransition = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $56e2eef78447d2ae$export$e868fcc7557d3a06), {
    name: 'MuiDayCalendar',
    slot: 'SlideTransition',
    overridesResolver: (_, styles)=>styles.slideTransition
})({
    minHeight: $c2d389da60812d08$var$weeksContainerHeight
});
const $c2d389da60812d08$var$PickersCalendarWeekContainer = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiDayCalendar',
    slot: 'MonthContainer',
    overridesResolver: (_, styles)=>styles.monthContainer
})({
    overflow: 'hidden'
});
const $c2d389da60812d08$var$PickersCalendarWeek = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiDayCalendar',
    slot: 'WeekContainer',
    overridesResolver: (_, styles)=>styles.weekContainer
})({
    margin: `${(0, $f49d2ca225f7bed5$export$dde58b009b497666)}px 0`,
    display: 'flex',
    justifyContent: 'center'
});
function $c2d389da60812d08$var$WrappedDay(_ref) {
    let { parentProps: parentProps, day: day, focusableDay: focusableDay, selectedDays: selectedDays, isDateDisabled: isDateDisabled, currentMonthNumber: currentMonthNumber, isViewFocused: isViewFocused } = _ref, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $c2d389da60812d08$var$_excluded);
    const { disabled: disabled, disableHighlightToday: disableHighlightToday, isMonthSwitchingAnimating: isMonthSwitchingAnimating, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, slots: slots, slotProps: slotProps, timezone: timezone } = parentProps;
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const now = (0, $6945e6366bb58773$export$3a404aece3dff2fa)(timezone);
    const isFocusableDay = focusableDay !== null && utils.isSameDay(day, focusableDay);
    const isSelected = selectedDays.some((selectedDay)=>utils.isSameDay(selectedDay, day));
    const isToday = utils.isSameDay(day, now);
    const Day = slots?.day ?? (0, $d64849e0226d1a8f$export$d7378e6e864346fa);
    // We don't want to pass to ownerState down, to avoid re-rendering all the day whenever a prop changes.
    const _useSlotProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: Day,
        externalSlotProps: slotProps?.day,
        additionalProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            disableHighlightToday: disableHighlightToday,
            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
            role: 'gridcell',
            isAnimating: isMonthSwitchingAnimating,
            // it is used in date range dragging logic by accessing `dataset.timestamp`
            'data-timestamp': utils.toJsDate(day).valueOf()
        }, other),
        ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, parentProps, {
            day: day,
            selected: isSelected
        })
    }), dayProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useSlotProps, $c2d389da60812d08$var$_excluded2);
    const isDisabled = $7fPBF.useMemo(()=>disabled || isDateDisabled(day), [
        disabled,
        isDateDisabled,
        day
    ]);
    const outsideCurrentMonth = $7fPBF.useMemo(()=>utils.getMonth(day) !== currentMonthNumber, [
        utils,
        day,
        currentMonthNumber
    ]);
    const isFirstVisibleCell = $7fPBF.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(utils.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return utils.isSameDay(day, startOfMonth);
        return utils.isSameDay(day, utils.startOfWeek(startOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        utils
    ]);
    const isLastVisibleCell = $7fPBF.useMemo(()=>{
        const endOfMonth = utils.endOfMonth(utils.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return utils.isSameDay(day, endOfMonth);
        return utils.isSameDay(day, utils.endOfWeek(endOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        utils
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Day, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, dayProps, {
        day: day,
        disabled: isDisabled,
        autoFocus: isViewFocused && isFocusableDay,
        today: isToday,
        outsideCurrentMonth: outsideCurrentMonth,
        isFirstVisibleCell: isFirstVisibleCell,
        isLastVisibleCell: isLastVisibleCell,
        selected: isSelected,
        tabIndex: isFocusableDay ? 0 : -1,
        "aria-selected": isSelected,
        "aria-current": isToday ? 'date' : undefined
    }));
}
function $c2d389da60812d08$export$8fb56b32a5df6314(inProps) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDayCalendar'
    });
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const { onFocusedDayChange: onFocusedDayChange, className: className, currentMonth: currentMonth, selectedDays: selectedDays, focusedDay: focusedDay, loading: loading, onSelectedDaysChange: onSelectedDaysChange, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd, readOnly: readOnly, reduceAnimations: reduceAnimations, renderLoading: renderLoading = ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
            children: "..."
        }), slideDirection: slideDirection, TransitionProps: TransitionProps, disablePast: disablePast, disableFuture: disableFuture, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, dayOfWeekFormatter: dayOfWeekFormatter = (date)=>utils.format(date, 'weekdayShort').charAt(0).toUpperCase(), hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, gridLabelId: gridLabelId, displayWeekNumber: displayWeekNumber, fixedWeekNumber: fixedWeekNumber, autoFocus: autoFocus, timezone: timezone } = props;
    const now = (0, $6945e6366bb58773$export$3a404aece3dff2fa)(timezone);
    const classes = $c2d389da60812d08$var$useUtilityClasses(props);
    const isRtl = (0, $ef654b446fc390d6$export$b2dd014b6c321cb)();
    const isDateDisabled = (0, $272960e2556e540f$export$7d1a419f34475191)({
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        minDate: minDate,
        maxDate: maxDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    const translations = (0, $7fcfc9681bf68f23$export$3cdcc56057891b44)();
    const [internalHasFocus, setInternalHasFocus] = (0, $bc6c881cebb96954$export$2e2bcd8739ae039)({
        name: 'DayCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const [internalFocusedDay, setInternalFocusedDay] = $7fPBF.useState(()=>focusedDay || now);
    const handleDaySelect = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((day)=>{
        if (readOnly) return;
        onSelectedDaysChange(day);
    });
    const focusDay = (day)=>{
        if (!isDateDisabled(day)) {
            onFocusedDayChange(day);
            setInternalFocusedDay(day);
            onFocusedViewChange?.(true);
            setInternalHasFocus(true);
        }
    };
    const handleKeyDown = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, day)=>{
        switch(event.key){
            case 'ArrowUp':
                focusDay(utils.addDays(day, -7));
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusDay(utils.addDays(day, 7));
                event.preventDefault();
                break;
            case 'ArrowLeft':
                {
                    const newFocusedDayDefault = utils.addDays(day, isRtl ? 1 : -1);
                    const nextAvailableMonth = utils.addMonths(day, isRtl ? 1 : -1);
                    const closestDayToFocus = (0, $4d1fa529a9a32e76$export$ca1f317ae8db2ee8)({
                        utils: utils,
                        date: newFocusedDayDefault,
                        minDate: isRtl ? newFocusedDayDefault : utils.startOfMonth(nextAvailableMonth),
                        maxDate: isRtl ? utils.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'ArrowRight':
                {
                    const newFocusedDayDefault = utils.addDays(day, isRtl ? -1 : 1);
                    const nextAvailableMonth = utils.addMonths(day, isRtl ? -1 : 1);
                    const closestDayToFocus = (0, $4d1fa529a9a32e76$export$ca1f317ae8db2ee8)({
                        utils: utils,
                        date: newFocusedDayDefault,
                        minDate: isRtl ? utils.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        maxDate: isRtl ? newFocusedDayDefault : utils.endOfMonth(nextAvailableMonth),
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'Home':
                focusDay(utils.startOfWeek(day));
                event.preventDefault();
                break;
            case 'End':
                focusDay(utils.endOfWeek(day));
                event.preventDefault();
                break;
            case 'PageUp':
                focusDay(utils.addMonths(day, 1));
                event.preventDefault();
                break;
            case 'PageDown':
                focusDay(utils.addMonths(day, -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleFocus = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, day)=>focusDay(day));
    const handleBlur = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, day)=>{
        if (internalHasFocus && utils.isSameDay(internalFocusedDay, day)) onFocusedViewChange?.(false);
    });
    const currentMonthNumber = utils.getMonth(currentMonth);
    const currentYearNumber = utils.getYear(currentMonth);
    const validSelectedDays = $7fPBF.useMemo(()=>selectedDays.filter((day)=>!!day).map((day)=>utils.startOfDay(day)), [
        utils,
        selectedDays
    ]);
    // need a new ref whenever the `key` of the transition changes: https://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.
    const transitionKey = `${currentYearNumber}-${currentMonthNumber}`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const slideNodeRef = $7fPBF.useMemo(()=>/*#__PURE__*/ $7fPBF.createRef(), [
        transitionKey
    ]);
    const focusableDay = $7fPBF.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(currentMonth);
        const endOfMonth = utils.endOfMonth(currentMonth);
        if (isDateDisabled(internalFocusedDay) || utils.isAfterDay(internalFocusedDay, endOfMonth) || utils.isBeforeDay(internalFocusedDay, startOfMonth)) return (0, $4d1fa529a9a32e76$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: internalFocusedDay,
            minDate: startOfMonth,
            maxDate: endOfMonth,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        });
        return internalFocusedDay;
    }, [
        currentMonth,
        disableFuture,
        disablePast,
        internalFocusedDay,
        isDateDisabled,
        utils,
        timezone
    ]);
    const weeksToDisplay = $7fPBF.useMemo(()=>{
        const toDisplay = utils.getWeekArray(currentMonth);
        let nextMonth = utils.addMonths(currentMonth, 1);
        while(fixedWeekNumber && toDisplay.length < fixedWeekNumber){
            const additionalWeeks = utils.getWeekArray(nextMonth);
            const hasCommonWeek = utils.isSameDay(toDisplay[toDisplay.length - 1][0], additionalWeeks[0][0]);
            additionalWeeks.slice(hasCommonWeek ? 1 : 0).forEach((week)=>{
                if (toDisplay.length < fixedWeekNumber) toDisplay.push(week);
            });
            nextMonth = utils.addMonths(nextMonth, 1);
        }
        return toDisplay;
    }, [
        currentMonth,
        fixedWeekNumber,
        utils
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($c2d389da60812d08$var$PickersCalendarDayRoot, {
        role: "grid",
        "aria-labelledby": gridLabelId,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($c2d389da60812d08$var$PickersCalendarDayHeader, {
                role: "row",
                className: classes.header,
                children: [
                    displayWeekNumber && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c2d389da60812d08$var$PickersCalendarWeekNumberLabel, {
                        variant: "caption",
                        role: "columnheader",
                        "aria-label": translations.calendarWeekNumberHeaderLabel,
                        className: classes.weekNumberLabel,
                        children: translations.calendarWeekNumberHeaderText
                    }),
                    (0, $4d1fa529a9a32e76$export$24c38139da66592d)(utils, now).map((weekday, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c2d389da60812d08$var$PickersCalendarWeekDayLabel, {
                            variant: "caption",
                            role: "columnheader",
                            "aria-label": utils.format(weekday, 'weekday'),
                            className: classes.weekDayLabel,
                            children: dayOfWeekFormatter(weekday)
                        }, i.toString()))
                ]
            }),
            loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c2d389da60812d08$var$PickersCalendarLoadingContainer, {
                className: classes.loadingContainer,
                children: renderLoading()
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c2d389da60812d08$var$PickersCalendarSlideTransition, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                transKey: transitionKey,
                onExited: onMonthSwitchingAnimationEnd,
                reduceAnimations: reduceAnimations,
                slideDirection: slideDirection,
                className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(className, classes.slideTransition)
            }, TransitionProps, {
                nodeRef: slideNodeRef,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c2d389da60812d08$var$PickersCalendarWeekContainer, {
                    ref: slideNodeRef,
                    role: "rowgroup",
                    className: classes.monthContainer,
                    children: weeksToDisplay.map((week, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($c2d389da60812d08$var$PickersCalendarWeek, {
                            role: "row",
                            className: classes.weekContainer,
                            "aria-rowindex": index + 1,
                            children: [
                                displayWeekNumber && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c2d389da60812d08$var$PickersCalendarWeekNumber, {
                                    className: classes.weekNumber,
                                    role: "rowheader",
                                    "aria-label": translations.calendarWeekNumberAriaLabelText(utils.getWeekNumber(week[0])),
                                    children: translations.calendarWeekNumberText(utils.getWeekNumber(week[0]))
                                }),
                                week.map((day, dayIndex)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c2d389da60812d08$var$WrappedDay, {
                                        parentProps: props,
                                        day: day,
                                        selectedDays: validSelectedDays,
                                        focusableDay: focusableDay,
                                        onKeyDown: handleKeyDown,
                                        onFocus: handleFocus,
                                        onBlur: handleBlur,
                                        onDaySelect: handleDaySelect,
                                        isDateDisabled: isDateDisabled,
                                        currentMonthNumber: currentMonthNumber,
                                        isViewFocused: internalHasFocus,
                                        "aria-colindex": dayIndex + 1
                                    }, day.toString()))
                            ]
                        }, `week-${week[0]}`))
                })
            }))
        ]
    });
}





var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");






function $b78805cd45b35333$export$db90a620ac957a73(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPickersMonth', slot);
}
const $b78805cd45b35333$export$911e3973fa70a12b = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPickersMonth', [
    'root',
    'monthButton',
    'disabled',
    'selected'
]);



const $e23e94166bf12d18$var$_excluded = [
    "autoFocus",
    "className",
    "children",
    "disabled",
    "selected",
    "value",
    "tabIndex",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "aria-current",
    "aria-label",
    "monthsPerRow",
    "slots",
    "slotProps"
];
const $e23e94166bf12d18$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        monthButton: [
            'monthButton',
            disabled && 'disabled',
            selected && 'selected'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $b78805cd45b35333$export$db90a620ac957a73), classes);
};
const $e23e94166bf12d18$var$PickersMonthRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersMonth',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root
        ]
})({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexBasis: '33.3%',
    variants: [
        {
            props: {
                monthsPerRow: 4
            },
            style: {
                flexBasis: '25%'
            }
        }
    ]
});
const $e23e94166bf12d18$var$MonthCalendarButton = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('button', {
    name: 'MuiPickersMonth',
    slot: 'MonthButton',
    overridesResolver: (_, styles)=>[
            styles.monthButton,
            {
                [`&.${(0, $b78805cd45b35333$export$911e3973fa70a12b).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $b78805cd45b35333$export$911e3973fa70a12b).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: '8px 0',
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${(0, $b78805cd45b35333$export$911e3973fa70a12b).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $b78805cd45b35333$export$911e3973fa70a12b).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $e23e94166bf12d18$export$bc52fdb7f02f591a = /*#__PURE__*/ $7fPBF.memo(function PickersMonth(inProps) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersMonth'
    });
    const { autoFocus: autoFocus, className: className, children: children, disabled: disabled, selected: selected, value: value, tabIndex: tabIndex, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, 'aria-current': ariaCurrent, 'aria-label': ariaLabel, slots: slots, slotProps: slotProps } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $e23e94166bf12d18$var$_excluded);
    const ref = $7fPBF.useRef(null);
    const classes = $e23e94166bf12d18$var$useUtilityClasses(props);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current?.focus();
    }, [
        autoFocus
    ]);
    const MonthButton = slots?.monthButton ?? $e23e94166bf12d18$var$MonthCalendarButton;
    const monthButtonProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: MonthButton,
        externalSlotProps: slotProps?.monthButton,
        additionalProps: {
            children: children,
            disabled: disabled,
            tabIndex: tabIndex,
            ref: ref,
            type: 'button',
            role: 'radio',
            'aria-current': ariaCurrent,
            'aria-checked': selected,
            'aria-label': ariaLabel,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value)
        },
        ownerState: props,
        className: classes.monthButton
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e23e94166bf12d18$var$PickersMonthRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: props
    }, other, {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(MonthButton, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, monthButtonProps))
    }));
});




function $1196436c7c3fe2c3$export$da0c97315339ebd9(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiMonthCalendar', slot);
}
const $1196436c7c3fe2c3$export$edf77d5566c7007c = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiMonthCalendar', [
    'root'
]);








'use client';
const $4bccd319eb983de3$var$_excluded = [
    "className",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "shouldDisableMonth",
    "readOnly",
    "disableHighlightToday",
    "autoFocus",
    "onMonthFocus",
    "hasFocus",
    "onFocusedViewChange",
    "monthsPerRow",
    "timezone",
    "gridLabelId",
    "slots",
    "slotProps"
];
const $4bccd319eb983de3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $1196436c7c3fe2c3$export$da0c97315339ebd9), classes);
};
function $4bccd319eb983de3$export$5b6e066572408095(props, name) {
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const defaultDates = (0, $6945e6366bb58773$export$7c38da3a2e90fa83)();
    const themeProps = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        disableFuture: false,
        disablePast: false
    }, themeProps, {
        minDate: (0, $4d1fa529a9a32e76$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $4d1fa529a9a32e76$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $4bccd319eb983de3$var$MonthCalendarRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiMonthCalendar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'stretch',
    padding: '0 4px',
    width: (0, $f49d2ca225f7bed5$export$ee46b8a74d6c94d3),
    // avoid padding increasing width over defined
    boxSizing: 'border-box'
});
const $4bccd319eb983de3$export$d7a7c85c0f5afc4a = /*#__PURE__*/ $7fPBF.forwardRef(function MonthCalendar(inProps, ref) {
    const props = $4bccd319eb983de3$export$5b6e066572408095(inProps, 'MuiMonthCalendar');
    const { className: className, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, shouldDisableMonth: shouldDisableMonth, readOnly: readOnly, autoFocus: autoFocus = false, onMonthFocus: onMonthFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, monthsPerRow: monthsPerRow = 3, timezone: timezoneProp, gridLabelId: gridLabelId, slots: slots, slotProps: slotProps } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $4bccd319eb983de3$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $a30ec645234d5ab0$export$174d749f3b4c0f49)({
        name: 'MonthCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: (0, $841d6de1e4809c9b$export$2764b246aa3b75ba)
    });
    const now = (0, $6945e6366bb58773$export$3a404aece3dff2fa)(timezone);
    const isRtl = (0, $ef654b446fc390d6$export$b2dd014b6c321cb)();
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const referenceDate = $7fPBF.useMemo(()=>(0, $841d6de1e4809c9b$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $03cf12356675f79b$export$8f74e8f4ed8ae0ac).month
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const ownerState = props;
    const classes = $4bccd319eb983de3$var$useUtilityClasses(ownerState);
    const todayMonth = $7fPBF.useMemo(()=>utils.getMonth(now), [
        utils,
        now
    ]);
    const selectedMonth = $7fPBF.useMemo(()=>{
        if (value != null) return utils.getMonth(value);
        return null;
    }, [
        value,
        utils
    ]);
    const [focusedMonth, setFocusedMonth] = $7fPBF.useState(()=>selectedMonth || utils.getMonth(referenceDate));
    const [internalHasFocus, setInternalHasFocus] = (0, $bc6c881cebb96954$export$2e2bcd8739ae039)({
        name: 'MonthCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const changeHasFocus = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isMonthDisabled = $7fPBF.useCallback((dateToValidate)=>{
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        const monthToValidate = utils.startOfMonth(dateToValidate);
        if (utils.isBefore(monthToValidate, firstEnabledMonth)) return true;
        if (utils.isAfter(monthToValidate, lastEnabledMonth)) return true;
        if (!shouldDisableMonth) return false;
        return shouldDisableMonth(monthToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableMonth,
        utils
    ]);
    const handleMonthSelection = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, month)=>{
        if (readOnly) return;
        const newDate = utils.setMonth(value ?? referenceDate, month);
        handleValueChange(newDate);
    });
    const focusMonth = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((month)=>{
        if (!isMonthDisabled(utils.setMonth(value ?? referenceDate, month))) {
            setFocusedMonth(month);
            changeHasFocus(true);
            if (onMonthFocus) onMonthFocus(month);
        }
    });
    $7fPBF.useEffect(()=>{
        setFocusedMonth((prevFocusedMonth)=>selectedMonth !== null && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
    }, [
        selectedMonth
    ]);
    const handleKeyDown = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, month)=>{
        const monthsInYear = 12;
        const monthsInRow = 3;
        switch(event.key){
            case 'ArrowUp':
                focusMonth((monthsInYear + month - monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusMonth((monthsInYear + month + monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusMonth((monthsInYear + month + (isRtl ? 1 : -1)) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusMonth((monthsInYear + month + (isRtl ? -1 : 1)) % monthsInYear);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleMonthFocus = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, month)=>{
        focusMonth(month);
    });
    const handleMonthBlur = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, month)=>{
        if (focusedMonth === month) changeHasFocus(false);
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4bccd319eb983de3$var$MonthCalendarRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId
    }, other, {
        children: (0, $4d1fa529a9a32e76$export$62591b96a734eacd)(utils, value ?? referenceDate).map((month)=>{
            const monthNumber = utils.getMonth(month);
            const monthText = utils.format(month, 'monthShort');
            const monthLabel = utils.format(month, 'month');
            const isSelected = monthNumber === selectedMonth;
            const isDisabled = disabled || isMonthDisabled(month);
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e23e94166bf12d18$export$bc52fdb7f02f591a), {
                selected: isSelected,
                value: monthNumber,
                onClick: handleMonthSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && monthNumber === focusedMonth,
                disabled: isDisabled,
                tabIndex: monthNumber === focusedMonth && !isDisabled ? 0 : -1,
                onFocus: handleMonthFocus,
                onBlur: handleMonthBlur,
                "aria-current": todayMonth === monthNumber ? 'date' : undefined,
                "aria-label": monthLabel,
                monthsPerRow: monthsPerRow,
                slots: slots,
                slotProps: slotProps,
                children: monthText
            }, monthText);
        })
    }));
});





var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");






function $a3ff649e8dd46250$export$183c9f339a61cd79(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPickersYear', slot);
}
const $a3ff649e8dd46250$export$4ef58a3d9c6f4296 = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPickersYear', [
    'root',
    'yearButton',
    'selected',
    'disabled'
]);



const $0f4dbb6707104d23$var$_excluded = [
    "autoFocus",
    "className",
    "children",
    "disabled",
    "selected",
    "value",
    "tabIndex",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "aria-current",
    "yearsPerRow",
    "slots",
    "slotProps"
];
const $0f4dbb6707104d23$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        yearButton: [
            'yearButton',
            disabled && 'disabled',
            selected && 'selected'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $a3ff649e8dd46250$export$183c9f339a61cd79), classes);
};
const $0f4dbb6707104d23$var$PickersYearRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersYear',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root
        ]
})({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexBasis: '33.3%',
    variants: [
        {
            props: {
                yearsPerRow: 4
            },
            style: {
                flexBasis: '25%'
            }
        }
    ]
});
const $0f4dbb6707104d23$var$YearCalendarButton = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('button', {
    name: 'MuiPickersYear',
    slot: 'YearButton',
    overridesResolver: (_, styles)=>[
            styles.yearButton,
            {
                [`&.${(0, $a3ff649e8dd46250$export$4ef58a3d9c6f4296).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $a3ff649e8dd46250$export$4ef58a3d9c6f4296).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: '6px 0',
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.focusOpacity)
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${(0, $a3ff649e8dd46250$export$4ef58a3d9c6f4296).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $a3ff649e8dd46250$export$4ef58a3d9c6f4296).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $0f4dbb6707104d23$export$261f3fbd5fd5814d = /*#__PURE__*/ $7fPBF.memo(function PickersYear(inProps) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersYear'
    });
    const { autoFocus: autoFocus, className: className, children: children, disabled: disabled, selected: selected, value: value, tabIndex: tabIndex, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, 'aria-current': ariaCurrent, slots: slots, slotProps: slotProps } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $0f4dbb6707104d23$var$_excluded);
    const ref = $7fPBF.useRef(null);
    const classes = $0f4dbb6707104d23$var$useUtilityClasses(props);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current?.focus();
    }, [
        autoFocus
    ]);
    const YearButton = slots?.yearButton ?? $0f4dbb6707104d23$var$YearCalendarButton;
    const yearButtonProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: YearButton,
        externalSlotProps: slotProps?.yearButton,
        additionalProps: {
            children: children,
            disabled: disabled,
            tabIndex: tabIndex,
            ref: ref,
            type: 'button',
            role: 'radio',
            'aria-current': ariaCurrent,
            'aria-checked': selected,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value)
        },
        ownerState: props,
        className: classes.yearButton
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0f4dbb6707104d23$var$PickersYearRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: props
    }, other, {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(YearButton, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, yearButtonProps))
    }));
});




function $2249f5f50aa75a9e$export$4477acc520094dec(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiYearCalendar', slot);
}
const $2249f5f50aa75a9e$export$e42d427cd9fe5fd7 = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiYearCalendar', [
    'root'
]);








'use client';
const $5cb2e1cea88096ca$var$_excluded = [
    "autoFocus",
    "className",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "readOnly",
    "shouldDisableYear",
    "disableHighlightToday",
    "onYearFocus",
    "hasFocus",
    "onFocusedViewChange",
    "yearsOrder",
    "yearsPerRow",
    "timezone",
    "gridLabelId",
    "slots",
    "slotProps"
];
const $5cb2e1cea88096ca$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $2249f5f50aa75a9e$export$4477acc520094dec), classes);
};
function $5cb2e1cea88096ca$var$useYearCalendarDefaultizedProps(props, name) {
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const defaultDates = (0, $6945e6366bb58773$export$7c38da3a2e90fa83)();
    const themeProps = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        disablePast: false,
        disableFuture: false
    }, themeProps, {
        yearsPerRow: themeProps.yearsPerRow ?? 3,
        minDate: (0, $4d1fa529a9a32e76$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $4d1fa529a9a32e76$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $5cb2e1cea88096ca$var$YearCalendarRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiYearCalendar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflowY: 'auto',
    height: '100%',
    padding: '0 4px',
    width: (0, $f49d2ca225f7bed5$export$ee46b8a74d6c94d3),
    maxHeight: (0, $f49d2ca225f7bed5$export$73724491020e90c7),
    // avoid padding increasing width over defined
    boxSizing: 'border-box',
    position: 'relative'
});
const $5cb2e1cea88096ca$export$657f9200591b2b71 = /*#__PURE__*/ $7fPBF.forwardRef(function YearCalendar(inProps, ref) {
    const props = $5cb2e1cea88096ca$var$useYearCalendarDefaultizedProps(inProps, 'MuiYearCalendar');
    const { autoFocus: autoFocus, className: className, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, readOnly: readOnly, shouldDisableYear: shouldDisableYear, onYearFocus: onYearFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, yearsOrder: yearsOrder = 'asc', yearsPerRow: yearsPerRow, timezone: timezoneProp, gridLabelId: gridLabelId, slots: slots, slotProps: slotProps } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $5cb2e1cea88096ca$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $a30ec645234d5ab0$export$174d749f3b4c0f49)({
        name: 'YearCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: (0, $841d6de1e4809c9b$export$2764b246aa3b75ba)
    });
    const now = (0, $6945e6366bb58773$export$3a404aece3dff2fa)(timezone);
    const isRtl = (0, $ef654b446fc390d6$export$b2dd014b6c321cb)();
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const referenceDate = $7fPBF.useMemo(()=>(0, $841d6de1e4809c9b$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $03cf12356675f79b$export$8f74e8f4ed8ae0ac).year
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const ownerState = props;
    const classes = $5cb2e1cea88096ca$var$useUtilityClasses(ownerState);
    const todayYear = $7fPBF.useMemo(()=>utils.getYear(now), [
        utils,
        now
    ]);
    const selectedYear = $7fPBF.useMemo(()=>{
        if (value != null) return utils.getYear(value);
        return null;
    }, [
        value,
        utils
    ]);
    const [focusedYear, setFocusedYear] = $7fPBF.useState(()=>selectedYear || utils.getYear(referenceDate));
    const [internalHasFocus, setInternalHasFocus] = (0, $bc6c881cebb96954$export$2e2bcd8739ae039)({
        name: 'YearCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const changeHasFocus = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isYearDisabled = $7fPBF.useCallback((dateToValidate)=>{
        if (disablePast && utils.isBeforeYear(dateToValidate, now)) return true;
        if (disableFuture && utils.isAfterYear(dateToValidate, now)) return true;
        if (minDate && utils.isBeforeYear(dateToValidate, minDate)) return true;
        if (maxDate && utils.isAfterYear(dateToValidate, maxDate)) return true;
        if (!shouldDisableYear) return false;
        const yearToValidate = utils.startOfYear(dateToValidate);
        return shouldDisableYear(yearToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableYear,
        utils
    ]);
    const handleYearSelection = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, year)=>{
        if (readOnly) return;
        const newDate = utils.setYear(value ?? referenceDate, year);
        handleValueChange(newDate);
    });
    const focusYear = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((year)=>{
        if (!isYearDisabled(utils.setYear(value ?? referenceDate, year))) {
            setFocusedYear(year);
            changeHasFocus(true);
            onYearFocus?.(year);
        }
    });
    $7fPBF.useEffect(()=>{
        setFocusedYear((prevFocusedYear)=>selectedYear !== null && prevFocusedYear !== selectedYear ? selectedYear : prevFocusedYear);
    }, [
        selectedYear
    ]);
    const verticalDirection = yearsOrder !== 'desc' ? yearsPerRow * 1 : yearsPerRow * -1;
    const horizontalDirection = isRtl && yearsOrder === 'asc' || !isRtl && yearsOrder === 'desc' ? -1 : 1;
    const handleKeyDown = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, year)=>{
        switch(event.key){
            case 'ArrowUp':
                focusYear(year - verticalDirection);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusYear(year + verticalDirection);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusYear(year - horizontalDirection);
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusYear(year + horizontalDirection);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleYearFocus = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, year)=>{
        focusYear(year);
    });
    const handleYearBlur = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, year)=>{
        if (focusedYear === year) changeHasFocus(false);
    });
    const scrollerRef = $7fPBF.useRef(null);
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(ref, scrollerRef);
    $7fPBF.useEffect(()=>{
        if (autoFocus || scrollerRef.current === null) return;
        const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
        if (!tabbableButton) return;
        // Taken from useScroll in x-data-grid, but vertically centered
        const offsetHeight = tabbableButton.offsetHeight;
        const offsetTop = tabbableButton.offsetTop;
        const clientHeight = scrollerRef.current.clientHeight;
        const scrollTop = scrollerRef.current.scrollTop;
        const elementBottom = offsetTop + offsetHeight;
        if (offsetHeight > clientHeight || offsetTop < scrollTop) // Button already visible
        return;
        scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
    }, [
        autoFocus
    ]);
    const yearRange = utils.getYearRange([
        minDate,
        maxDate
    ]);
    if (yearsOrder === 'desc') yearRange.reverse();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5cb2e1cea88096ca$var$YearCalendarRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: handleRef,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId
    }, other, {
        children: yearRange.map((year)=>{
            const yearNumber = utils.getYear(year);
            const isSelected = yearNumber === selectedYear;
            const isDisabled = disabled || isYearDisabled(year);
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0f4dbb6707104d23$export$261f3fbd5fd5814d), {
                selected: isSelected,
                value: yearNumber,
                onClick: handleYearSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && yearNumber === focusedYear,
                disabled: isDisabled,
                tabIndex: yearNumber === focusedYear && !isDisabled ? 0 : -1,
                onFocus: handleYearFocus,
                onBlur: handleYearBlur,
                "aria-current": todayYear === yearNumber ? 'date' : undefined,
                yearsPerRow: yearsPerRow,
                slots: slots,
                slotProps: slotProps,
                children: utils.format(year, 'year')
            }, utils.format(year, 'year'));
        })
    }));
});






var $7fPBF = parcelRequire("7fPBF");














var $7fPBF = parcelRequire("7fPBF");









function $6b883f9bf65a96c2$export$cef978c25740de90(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPickersArrowSwitcher', slot);
}
const $6b883f9bf65a96c2$export$f8819209558cd362 = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPickersArrowSwitcher', [
    'root',
    'spacer',
    'button',
    'previousIconButton',
    'nextIconButton',
    'leftArrowIcon',
    'rightArrowIcon'
]);



const $ea7213ea38575b9f$var$_excluded = [
    "children",
    "className",
    "slots",
    "slotProps",
    "isNextDisabled",
    "isNextHidden",
    "onGoToNext",
    "nextLabel",
    "isPreviousDisabled",
    "isPreviousHidden",
    "onGoToPrevious",
    "previousLabel",
    "labelId"
], $ea7213ea38575b9f$var$_excluded2 = [
    "ownerState"
], $ea7213ea38575b9f$var$_excluded3 = [
    "ownerState"
];
const $ea7213ea38575b9f$var$PickersArrowSwitcherRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex'
});
const $ea7213ea38575b9f$var$PickersArrowSwitcherSpacer = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Spacer',
    overridesResolver: (props, styles)=>styles.spacer
})(({ theme: theme })=>({
        width: theme.spacing(3)
    }));
const $ea7213ea38575b9f$var$PickersArrowSwitcherButton = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Button',
    overridesResolver: (props, styles)=>styles.button
})({
    variants: [
        {
            props: {
                hidden: true
            },
            style: {
                visibility: 'hidden'
            }
        }
    ]
});
const $ea7213ea38575b9f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        spacer: [
            'spacer'
        ],
        button: [
            'button'
        ],
        previousIconButton: [
            'previousIconButton'
        ],
        nextIconButton: [
            'nextIconButton'
        ],
        leftArrowIcon: [
            'leftArrowIcon'
        ],
        rightArrowIcon: [
            'rightArrowIcon'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $6b883f9bf65a96c2$export$cef978c25740de90), classes);
};
const $ea7213ea38575b9f$export$597b7cbdb7b2a24c = /*#__PURE__*/ $7fPBF.forwardRef(function PickersArrowSwitcher(inProps, ref) {
    const isRtl = (0, $ef654b446fc390d6$export$b2dd014b6c321cb)();
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersArrowSwitcher'
    });
    const { children: children, className: className, slots: slots, slotProps: slotProps, isNextDisabled: isNextDisabled, isNextHidden: isNextHidden, onGoToNext: onGoToNext, nextLabel: nextLabel, isPreviousDisabled: isPreviousDisabled, isPreviousHidden: isPreviousHidden, onGoToPrevious: onGoToPrevious, previousLabel: previousLabel, labelId: labelId } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $ea7213ea38575b9f$var$_excluded);
    const ownerState = props;
    const classes = $ea7213ea38575b9f$var$useUtilityClasses(ownerState);
    const nextProps = {
        isDisabled: isNextDisabled,
        isHidden: isNextHidden,
        goTo: onGoToNext,
        label: nextLabel
    };
    const previousProps = {
        isDisabled: isPreviousDisabled,
        isHidden: isPreviousHidden,
        goTo: onGoToPrevious,
        label: previousLabel
    };
    const PreviousIconButton = slots?.previousIconButton ?? $ea7213ea38575b9f$var$PickersArrowSwitcherButton;
    const previousIconButtonProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: PreviousIconButton,
        externalSlotProps: slotProps?.previousIconButton,
        additionalProps: {
            size: 'medium',
            title: previousProps.label,
            'aria-label': previousProps.label,
            disabled: previousProps.isDisabled,
            edge: 'end',
            onClick: previousProps.goTo
        },
        ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState, {
            hidden: previousProps.isHidden
        }),
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.button, classes.previousIconButton)
    });
    const NextIconButton = slots?.nextIconButton ?? $ea7213ea38575b9f$var$PickersArrowSwitcherButton;
    const nextIconButtonProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: NextIconButton,
        externalSlotProps: slotProps?.nextIconButton,
        additionalProps: {
            size: 'medium',
            title: nextProps.label,
            'aria-label': nextProps.label,
            disabled: nextProps.isDisabled,
            edge: 'start',
            onClick: nextProps.goTo
        },
        ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState, {
            hidden: nextProps.isHidden
        }),
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.button, classes.nextIconButton)
    });
    const LeftArrowIcon = slots?.leftArrowIcon ?? (0, $27f114a7ae98fe28$export$8afed21ef5c2afa5);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: LeftArrowIcon,
        externalSlotProps: slotProps?.leftArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState: ownerState,
        className: classes.leftArrowIcon
    }), leftArrowIconProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useSlotProps, $ea7213ea38575b9f$var$_excluded2);
    const RightArrowIcon = slots?.rightArrowIcon ?? (0, $27f114a7ae98fe28$export$9ca09caa9c849d9c);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps2 = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: RightArrowIcon,
        externalSlotProps: slotProps?.rightArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState: ownerState,
        className: classes.rightArrowIcon
    }), rightArrowIconProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useSlotProps2, $ea7213ea38575b9f$var$_excluded3);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($ea7213ea38575b9f$var$PickersArrowSwitcherRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(PreviousIconButton, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, previousIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(RightArrowIcon, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, rightArrowIconProps)) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(LeftArrowIcon, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, leftArrowIconProps))
            })),
            children ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                component: "span",
                id: labelId,
                children: children
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ea7213ea38575b9f$var$PickersArrowSwitcherSpacer, {
                className: classes.spacer,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(NextIconButton, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, nextIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(LeftArrowIcon, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, leftArrowIconProps)) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(RightArrowIcon, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, rightArrowIconProps))
            }))
        ]
    }));
});



var $7fPBF = parcelRequire("7fPBF");


function $5d866238f9e5c9d0$export$923e8cc135843169(month, { disableFuture: disableFuture, maxDate: maxDate, timezone: timezone }) {
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    return $7fPBF.useMemo(()=>{
        const now = utils.date(undefined, timezone);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        return !utils.isAfter(lastEnabledMonth, month);
    }, [
        disableFuture,
        maxDate,
        month,
        utils,
        timezone
    ]);
}
function $5d866238f9e5c9d0$export$3b46d38ff4932cf7(month, { disablePast: disablePast, minDate: minDate, timezone: timezone }) {
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    return $7fPBF.useMemo(()=>{
        const now = utils.date(undefined, timezone);
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        return !utils.isBefore(firstEnabledMonth, month);
    }, [
        disablePast,
        minDate,
        month,
        utils,
        timezone
    ]);
}
function $5d866238f9e5c9d0$export$6aaabc31cb076d17(date, ampm, onChange, selectionState) {
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const meridiemMode = (0, $cd9924d2cafbe16d$export$c3352ead7b032236)(date, utils);
    const handleMeridiemChange = $7fPBF.useCallback((mode)=>{
        const timeWithMeridiem = date == null ? null : (0, $cd9924d2cafbe16d$export$c368d4ff66779998)(date, mode, Boolean(ampm), utils);
        onChange(timeWithMeridiem, selectionState ?? 'partial');
    }, [
        ampm,
        date,
        onChange,
        selectionState,
        utils
    ]);
    return {
        meridiemMode: meridiemMode,
        handleMeridiemChange: handleMeridiemChange
    };
}



const $ea834bcc9ade85be$export$457ac4d3a1ad92b4 = (slot)=>(0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPickersCalendarHeader', slot);
const $ea834bcc9ade85be$export$63db7afb9247cb91 = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPickersCalendarHeader', [
    'root',
    'labelContainer',
    'label',
    'switchViewButton',
    'switchViewIcon'
]);



'use client';
const $7d8eda0f006682a1$var$_excluded = [
    "slots",
    "slotProps",
    "currentMonth",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onMonthChange",
    "onViewChange",
    "view",
    "reduceAnimations",
    "views",
    "labelId",
    "className",
    "timezone",
    "format"
], $7d8eda0f006682a1$var$_excluded2 = [
    "ownerState"
];
const $7d8eda0f006682a1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        labelContainer: [
            'labelContainer'
        ],
        label: [
            'label'
        ],
        switchViewButton: [
            'switchViewButton'
        ],
        switchViewIcon: [
            'switchViewIcon'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $ea834bcc9ade85be$export$457ac4d3a1ad92b4), classes);
};
const $7d8eda0f006682a1$var$PickersCalendarHeaderRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({
    display: 'flex',
    alignItems: 'center',
    marginTop: 12,
    marginBottom: 4,
    paddingLeft: 24,
    paddingRight: 12,
    // prevent jumping in safari
    maxHeight: 40,
    minHeight: 40
});
const $7d8eda0f006682a1$var$PickersCalendarHeaderLabelContainer = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'LabelContainer',
    overridesResolver: (_, styles)=>styles.labelContainer
})(({ theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        display: 'flex',
        overflow: 'hidden',
        alignItems: 'center',
        cursor: 'pointer',
        marginRight: 'auto'
    }, theme.typography.body1, {
        fontWeight: theme.typography.fontWeightMedium
    }));
const $7d8eda0f006682a1$var$PickersCalendarHeaderLabel = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Label',
    overridesResolver: (_, styles)=>styles.label
})({
    marginRight: 6
});
const $7d8eda0f006682a1$var$PickersCalendarHeaderSwitchViewButton = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewButton',
    overridesResolver: (_, styles)=>styles.switchViewButton
})({
    marginRight: 'auto',
    variants: [
        {
            props: {
                view: 'year'
            },
            style: {
                [`.${(0, $ea834bcc9ade85be$export$63db7afb9247cb91).switchViewIcon}`]: {
                    transform: 'rotate(180deg)'
                }
            }
        }
    ]
});
const $7d8eda0f006682a1$var$PickersCalendarHeaderSwitchViewIcon = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $27f114a7ae98fe28$export$ed0fe318cc298673), {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewIcon',
    overridesResolver: (_, styles)=>styles.switchViewIcon
})(({ theme: theme })=>({
        willChange: 'transform',
        transition: theme.transitions.create('transform'),
        transform: 'rotate(0deg)'
    }));
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 * - [DateRangeCalendar](https://mui.com/x/react-date-pickers/date-range-calendar/)
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [PickersCalendarHeader API](https://mui.com/x/api/date-pickers/pickers-calendar-header/)
 */ const $7d8eda0f006682a1$export$6801ffebb353f473 = /*#__PURE__*/ $7fPBF.forwardRef(function PickersCalendarHeader(inProps, ref) {
    const translations = (0, $7fcfc9681bf68f23$export$3cdcc56057891b44)();
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersCalendarHeader'
    });
    const { slots: slots, slotProps: slotProps, currentMonth: month, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, onViewChange: onViewChange, view: view, reduceAnimations: reduceAnimations, views: views, labelId: labelId, className: className, timezone: timezone, format: format = `${utils.formats.month} ${utils.formats.year}` } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $7d8eda0f006682a1$var$_excluded);
    const ownerState = props;
    const classes = $7d8eda0f006682a1$var$useUtilityClasses(props);
    const SwitchViewButton = slots?.switchViewButton ?? $7d8eda0f006682a1$var$PickersCalendarHeaderSwitchViewButton;
    const switchViewButtonProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: SwitchViewButton,
        externalSlotProps: slotProps?.switchViewButton,
        additionalProps: {
            size: 'small',
            'aria-label': translations.calendarViewSwitchingButtonAriaLabel(view)
        },
        ownerState: ownerState,
        className: classes.switchViewButton
    });
    const SwitchViewIcon = slots?.switchViewIcon ?? $7d8eda0f006682a1$var$PickersCalendarHeaderSwitchViewIcon;
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: SwitchViewIcon,
        externalSlotProps: slotProps?.switchViewIcon,
        ownerState: ownerState,
        className: classes.switchViewIcon
    }), switchViewIconProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useSlotProps, $7d8eda0f006682a1$var$_excluded2);
    const selectNextMonth = ()=>onMonthChange(utils.addMonths(month, 1), 'left');
    const selectPreviousMonth = ()=>onMonthChange(utils.addMonths(month, -1), 'right');
    const isNextMonthDisabled = (0, $5d866238f9e5c9d0$export$923e8cc135843169)(month, {
        disableFuture: disableFuture,
        maxDate: maxDate,
        timezone: timezone
    });
    const isPreviousMonthDisabled = (0, $5d866238f9e5c9d0$export$3b46d38ff4932cf7)(month, {
        disablePast: disablePast,
        minDate: minDate,
        timezone: timezone
    });
    const handleToggleView = ()=>{
        if (views.length === 1 || !onViewChange || disabled) return;
        if (views.length === 2) onViewChange(views.find((el)=>el !== view) || views[0]);
        else {
            // switching only between first 2
            const nextIndexToOpen = views.indexOf(view) !== 0 ? 0 : 1;
            onViewChange(views[nextIndexToOpen]);
        }
    };
    // No need to display more information
    if (views.length === 1 && views[0] === 'year') return null;
    const label = utils.formatByString(month, format);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7d8eda0f006682a1$var$PickersCalendarHeaderRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, other, {
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7d8eda0f006682a1$var$PickersCalendarHeaderLabelContainer, {
                role: "presentation",
                onClick: handleToggleView,
                ownerState: ownerState,
                "aria-live": "polite",
                className: classes.labelContainer,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $966d54c4b5737349$export$5262185daf493fee), {
                        reduceAnimations: reduceAnimations,
                        transKey: label,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7d8eda0f006682a1$var$PickersCalendarHeaderLabel, {
                            id: labelId,
                            ownerState: ownerState,
                            className: classes.label,
                            children: label
                        })
                    }),
                    views.length > 1 && !disabled && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(SwitchViewButton, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, switchViewButtonProps, {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(SwitchViewIcon, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, switchViewIconProps))
                    }))
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $68214be7242cbfc8$export$2e2bcd8739ae039), {
                in: view === 'day',
                appear: !reduceAnimations,
                enter: !reduceAnimations,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea7213ea38575b9f$export$597b7cbdb7b2a24c), {
                    slots: slots,
                    slotProps: slotProps,
                    onGoToPrevious: selectPreviousMonth,
                    isPreviousDisabled: isPreviousMonthDisabled,
                    previousLabel: translations.previousMonth,
                    onGoToNext: selectNextMonth,
                    isNextDisabled: isNextMonthDisabled,
                    nextLabel: translations.nextMonth
                })
            })
        ]
    }));
});





const $451797722941b1b3$export$512b066b8abdfde4 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div')({
    overflow: 'hidden',
    width: (0, $f49d2ca225f7bed5$export$ee46b8a74d6c94d3),
    maxHeight: (0, $f49d2ca225f7bed5$export$f2fef360e2df0cb7),
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto'
});




const $eb26373463fec8d8$export$da8c2318897a6672 = (slot)=>(0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiDateCalendar', slot);
const $eb26373463fec8d8$export$d0237e2bb9598e8d = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiDateCalendar', [
    'root',
    'viewTransitionContainer'
]);






'use client';
const $c515574e4bff3014$var$_excluded = [
    "autoFocus",
    "onViewChange",
    "value",
    "defaultValue",
    "referenceDate",
    "disableFuture",
    "disablePast",
    "onChange",
    "onYearChange",
    "onMonthChange",
    "reduceAnimations",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear",
    "view",
    "views",
    "openTo",
    "className",
    "disabled",
    "readOnly",
    "minDate",
    "maxDate",
    "disableHighlightToday",
    "focusedView",
    "onFocusedViewChange",
    "showDaysOutsideCurrentMonth",
    "fixedWeekNumber",
    "dayOfWeekFormatter",
    "slots",
    "slotProps",
    "loading",
    "renderLoading",
    "displayWeekNumber",
    "yearsOrder",
    "yearsPerRow",
    "monthsPerRow",
    "timezone"
];
const $c515574e4bff3014$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        viewTransitionContainer: [
            'viewTransitionContainer'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $eb26373463fec8d8$export$da8c2318897a6672), classes);
};
function $c515574e4bff3014$var$useDateCalendarDefaultizedProps(props, name) {
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const defaultDates = (0, $6945e6366bb58773$export$7c38da3a2e90fa83)();
    const defaultReduceAnimations = (0, $015921b28af57dd9$export$ce40fb97be7f02d9)();
    const themeProps = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, themeProps, {
        loading: themeProps.loading ?? false,
        disablePast: themeProps.disablePast ?? false,
        disableFuture: themeProps.disableFuture ?? false,
        openTo: themeProps.openTo ?? 'day',
        views: themeProps.views ?? [
            'year',
            'day'
        ],
        reduceAnimations: themeProps.reduceAnimations ?? defaultReduceAnimations,
        renderLoading: themeProps.renderLoading ?? (()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                children: "..."
            })),
        minDate: (0, $4d1fa529a9a32e76$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $4d1fa529a9a32e76$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $c515574e4bff3014$var$DateCalendarRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $451797722941b1b3$export$512b066b8abdfde4), {
    name: 'MuiDateCalendar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexDirection: 'column',
    height: (0, $f49d2ca225f7bed5$export$f2fef360e2df0cb7)
});
const $c515574e4bff3014$var$DateCalendarViewTransitionContainer = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $966d54c4b5737349$export$5262185daf493fee), {
    name: 'MuiDateCalendar',
    slot: 'ViewTransitionContainer',
    overridesResolver: (props, styles)=>styles.viewTransitionContainer
})({});
const $c515574e4bff3014$export$68078fe5d2bf8909 = /*#__PURE__*/ $7fPBF.forwardRef(function DateCalendar(inProps, ref) {
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const id = (0, $46f5b561912058f9$export$2e2bcd8739ae039)();
    const props = $c515574e4bff3014$var$useDateCalendarDefaultizedProps(inProps, 'MuiDateCalendar');
    const { autoFocus: autoFocus, onViewChange: onViewChange, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableFuture: disableFuture, disablePast: disablePast, onChange: onChange, onYearChange: onYearChange, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, view: inView, views: views, openTo: openTo, className: className, disabled: disabled, readOnly: readOnly, minDate: minDate, maxDate: maxDate, disableHighlightToday: disableHighlightToday, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, fixedWeekNumber: fixedWeekNumber, dayOfWeekFormatter: dayOfWeekFormatter, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, displayWeekNumber: displayWeekNumber, yearsOrder: yearsOrder, yearsPerRow: yearsPerRow, monthsPerRow: monthsPerRow, timezone: timezoneProp } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $c515574e4bff3014$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $a30ec645234d5ab0$export$174d749f3b4c0f49)({
        name: 'DateCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: (0, $841d6de1e4809c9b$export$2764b246aa3b75ba)
    });
    const { view: view, setView: setView, focusedView: focusedView, setFocusedView: setFocusedView, goToNextView: goToNextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $577bcba5433b0e3c$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onChange: handleValueChange,
        onViewChange: onViewChange,
        autoFocus: autoFocus,
        focusedView: inFocusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const { referenceDate: referenceDate, calendarState: calendarState, changeFocusedDay: changeFocusedDay, changeMonth: changeMonth, handleChangeMonth: handleChangeMonth, isDateDisabled: isDateDisabled, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd } = (0, $b7c44e28b3ec1424$export$6d095e787d2b5e1f)({
        value: value,
        referenceDate: referenceDateProp,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    // When disabled, limit the view to the selected date
    const minDateWithDisabled = disabled && value || minDate;
    const maxDateWithDisabled = disabled && value || maxDate;
    const gridLabelId = `${id}-grid-label`;
    const hasFocus = focusedView !== null;
    const CalendarHeader = slots?.calendarHeader ?? (0, $7d8eda0f006682a1$export$6801ffebb353f473);
    const calendarHeaderProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: CalendarHeader,
        externalSlotProps: slotProps?.calendarHeader,
        additionalProps: {
            views: views,
            view: view,
            currentMonth: calendarState.currentMonth,
            onViewChange: setView,
            onMonthChange: (newMonth, direction)=>handleChangeMonth({
                    newMonth: newMonth,
                    direction: direction
                }),
            minDate: minDateWithDisabled,
            maxDate: maxDateWithDisabled,
            disabled: disabled,
            disablePast: disablePast,
            disableFuture: disableFuture,
            reduceAnimations: reduceAnimations,
            timezone: timezone,
            labelId: gridLabelId
        },
        ownerState: props
    });
    const handleDateMonthChange = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((newDate)=>{
        const startOfMonth = utils.startOfMonth(newDate);
        const endOfMonth = utils.endOfMonth(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $4d1fa529a9a32e76$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
            maxDate: utils.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            onMonthChange?.(startOfMonth);
        } else {
            goToNextView();
            changeMonth(startOfMonth);
        }
        changeFocusedDay(closestEnabledDate, true);
    });
    const handleDateYearChange = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((newDate)=>{
        const startOfYear = utils.startOfYear(newDate);
        const endOfYear = utils.endOfYear(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $4d1fa529a9a32e76$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfYear) ? startOfYear : minDate,
            maxDate: utils.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            onYearChange?.(closestEnabledDate);
        } else {
            goToNextView();
            changeMonth(startOfYear);
        }
        changeFocusedDay(closestEnabledDate, true);
    });
    const handleSelectedDayChange = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((day)=>{
        if (day) // If there is a date already selected, then we want to keep its time
        return handleValueChange((0, $4d1fa529a9a32e76$export$a98b123b8f29e004)(utils, day, value ?? referenceDate), 'finish', view);
        return handleValueChange(day, 'finish', view);
    });
    $7fPBF.useEffect(()=>{
        if (value != null && utils.isValid(value)) changeMonth(value);
    }, [
        value
    ]); // eslint-disable-line
    const ownerState = props;
    const classes = $c515574e4bff3014$var$useUtilityClasses(ownerState);
    const baseDateValidationProps = {
        disablePast: disablePast,
        disableFuture: disableFuture,
        maxDate: maxDate,
        minDate: minDate
    };
    const commonViewProps = {
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        timezone: timezone,
        gridLabelId: gridLabelId,
        slots: slots,
        slotProps: slotProps
    };
    const prevOpenViewRef = $7fPBF.useRef(view);
    $7fPBF.useEffect(()=>{
        // If the view change and the focus was on the previous view
        // Then we update the focus.
        if (prevOpenViewRef.current === view) return;
        if (focusedView === prevOpenViewRef.current) setFocusedView(view, true);
        prevOpenViewRef.current = view;
    }, [
        focusedView,
        setFocusedView,
        view
    ]);
    const selectedDays = $7fPBF.useMemo(()=>[
            value
        ], [
        value
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($c515574e4bff3014$var$DateCalendarRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(CalendarHeader, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, calendarHeaderProps, {
                slots: slots,
                slotProps: slotProps
            })),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c515574e4bff3014$var$DateCalendarViewTransitionContainer, {
                reduceAnimations: reduceAnimations,
                className: classes.viewTransitionContainer,
                transKey: view,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    children: [
                        view === 'year' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5cb2e1cea88096ca$export$657f9200591b2b71), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, baseDateValidationProps, commonViewProps, {
                            value: value,
                            onChange: handleDateYearChange,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('year', isViewFocused),
                            yearsOrder: yearsOrder,
                            yearsPerRow: yearsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === 'month' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4bccd319eb983de3$export$d7a7c85c0f5afc4a), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, baseDateValidationProps, commonViewProps, {
                            hasFocus: hasFocus,
                            className: className,
                            value: value,
                            onChange: handleDateMonthChange,
                            shouldDisableMonth: shouldDisableMonth,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('month', isViewFocused),
                            monthsPerRow: monthsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === 'day' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c2d389da60812d08$export$8fb56b32a5df6314), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, calendarState, baseDateValidationProps, commonViewProps, {
                            onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
                            onFocusedDayChange: changeFocusedDay,
                            reduceAnimations: reduceAnimations,
                            selectedDays: selectedDays,
                            onSelectedDaysChange: handleSelectedDayChange,
                            shouldDisableDate: shouldDisableDate,
                            shouldDisableMonth: shouldDisableMonth,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('day', isViewFocused),
                            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
                            fixedWeekNumber: fixedWeekNumber,
                            dayOfWeekFormatter: dayOfWeekFormatter,
                            displayWeekNumber: displayWeekNumber,
                            loading: loading,
                            renderLoading: renderLoading
                        }))
                    ]
                })
            })
        ]
    }));
});




const $02ad17f0efd035e0$export$69888ffe06193e5e = ({ view: view, onViewChange: onViewChange, views: views, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, reduceAnimations: reduceAnimations, onMonthChange: onMonthChange, monthsPerRow: monthsPerRow, onYearChange: onYearChange, yearsOrder: yearsOrder, yearsPerRow: yearsPerRow, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, disableHighlightToday: disableHighlightToday, readOnly: readOnly, disabled: disabled, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, dayOfWeekFormatter: dayOfWeekFormatter, sx: sx, autoFocus: autoFocus, fixedWeekNumber: fixedWeekNumber, displayWeekNumber: displayWeekNumber, timezone: timezone })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c515574e4bff3014$export$68078fe5d2bf8909), {
        view: view,
        onViewChange: onViewChange,
        views: views.filter((0, $4d1fa529a9a32e76$export$b32dfef9f07dea64)),
        focusedView: focusedView && (0, $4d1fa529a9a32e76$export$b32dfef9f07dea64)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        monthsPerRow: monthsPerRow,
        onYearChange: onYearChange,
        yearsOrder: yearsOrder,
        yearsPerRow: yearsPerRow,
        slots: slots,
        slotProps: slotProps,
        loading: loading,
        renderLoading: renderLoading,
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        dayOfWeekFormatter: dayOfWeekFormatter,
        sx: sx,
        autoFocus: autoFocus,
        fixedWeekNumber: fixedWeekNumber,
        displayWeekNumber: displayWeekNumber,
        timezone: timezone
    });




'use client';
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DesktopDatePicker API](https://mui.com/x/api/date-pickers/desktop-date-picker/)
 */ const $03b7231526638e49$export$5a73641f0156e1e4 = /*#__PURE__*/ $7fPBF.forwardRef(function DesktopDatePicker(inProps, ref) {
    const translations = (0, $7fcfc9681bf68f23$export$3cdcc56057891b44)();
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, $53ebcde7c448f3c9$export$a552c17ed3587731)(inProps, 'MuiDesktopDatePicker');
    const viewRenderers = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        day: (0, $02ad17f0efd035e0$export$69888ffe06193e5e),
        month: (0, $02ad17f0efd035e0$export$69888ffe06193e5e),
        year: (0, $02ad17f0efd035e0$export$69888ffe06193e5e)
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the desktop variant
    const props = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $4d1fa529a9a32e76$export$bb1c921f313ec928)(utils, defaultizedProps, false),
        yearsPerRow: defaultizedProps.yearsPerRow ?? 4,
        slots: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            openPickerIcon: (0, $27f114a7ae98fe28$export$5fda1783bb83f57b),
            field: (0, $5945f8b72dcc769b$export$d9781c7894a82487)
        }, defaultizedProps.slots),
        slotProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $ae0f0ccae9f4b3cc$export$2e2bcd8739ae039)(defaultizedProps.slotProps?.field, ownerState), (0, $f613678a0229c7f5$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                }),
            toolbar: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                hidden: true
            }, defaultizedProps.slotProps?.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $c74981cd2400164c$export$b1b70bc56ac5be0e)({
        props: props,
        valueManager: (0, $841d6de1e4809c9b$export$2764b246aa3b75ba),
        valueType: 'date',
        getOpenDialogAriaText: (0, $85ebbb99b2811e17$export$7eae96bf9dd7ca56)({
            utils: utils,
            formatKey: 'fullDate',
            contextTranslation: translations.openDatePickerDialogue,
            propsTranslation: props.localeText?.openDatePickerDialogue
        }),
        validator: (0, $c885b418e3c240b8$export$ffb3d0046ef3a2)
    });
    return renderPicker();
});
$03b7231526638e49$export$5a73641f0156e1e4.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * @default false
   */ enableAccessibleFieldDOMStructure: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $c597a968c23d62fb$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
        'landscape',
        'portrait'
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
            'all',
            'day',
            'empty',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
        'day',
        'month',
        'year'
    ]).isRequired),
    /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */ yearsOrder: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
        'asc',
        'desc'
    ]),
    /**
   * Years rendered per row.
   * @default 4
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
        3,
        4
    ])
};




var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");




parcelRequire("7fPBF");






const $52c169ad4ec0e8fd$var$PickersModalDialogRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $7f096abd658f7c85$export$2e2bcd8739ae039))({
    [`& .${(0, $8523c8ab2139cf2c$export$2e2bcd8739ae039).container}`]: {
        outline: 0
    },
    [`& .${(0, $8523c8ab2139cf2c$export$2e2bcd8739ae039).paper}`]: {
        outline: 0,
        minWidth: (0, $f49d2ca225f7bed5$export$ee46b8a74d6c94d3)
    }
});
const $52c169ad4ec0e8fd$var$PickersModalDialogContent = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039))({
    '&:first-of-type': {
        padding: 0
    }
});
function $52c169ad4ec0e8fd$export$99f83c99e1491f77(props) {
    const { children: children, onDismiss: onDismiss, open: open, slots: slots, slotProps: slotProps } = props;
    const Dialog = slots?.dialog ?? $52c169ad4ec0e8fd$var$PickersModalDialogRoot;
    const Transition = slots?.mobileTransition ?? (0, $68214be7242cbfc8$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Dialog, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        open: open,
        onClose: onDismiss
    }, slotProps?.dialog, {
        TransitionComponent: Transition,
        TransitionProps: slotProps?.mobileTransition,
        PaperComponent: slots?.mobilePaper,
        PaperProps: slotProps?.mobilePaper,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($52c169ad4ec0e8fd$var$PickersModalDialogContent, {
            children: children
        })
    }));
}







const $d282c2379e3abcb7$var$_excluded = [
    "props",
    "getOpenDialogAriaText"
];
const $d282c2379e3abcb7$export$5ca0153a626a7dd7 = (_ref)=>{
    let { props: props, getOpenDialogAriaText: getOpenDialogAriaText } = _ref, pickerParams = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $d282c2379e3abcb7$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, className: className, sx: sx, format: format, formatDensity: formatDensity, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure, selectedSections: selectedSections, onSelectedSectionsChange: onSelectedSectionsChange, timezone: timezone, name: name, label: label, inputRef: inputRef, readOnly: readOnly, disabled: disabled, localeText: localeText } = props;
    const fieldRef = $7fPBF.useRef(null);
    const labelId = (0, $46f5b561912058f9$export$2e2bcd8739ae039)();
    const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
    const { open: open, actions: actions, layoutProps: layoutProps, renderCurrentView: renderCurrentView, fieldProps: pickerFieldProps, contextValue: contextValue } = (0, $c317bbaffa35b5af$export$fc3313977ac596c4)((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, pickerParams, {
        props: props,
        fieldRef: fieldRef,
        autoFocusView: true,
        additionalViewProps: {},
        wrapperVariant: 'mobile'
    }));
    const Field = slots.field;
    const fieldProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: Field,
        externalSlotProps: innerSlotProps?.field,
        additionalProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, pickerFieldProps, isToolbarHidden && {
            id: labelId
        }, !(disabled || readOnly) && {
            onClick: actions.onOpen,
            onKeyDown: (0, $e21804eb4bb13208$export$4467fe8634707c85)(actions.onOpen)
        }, {
            readOnly: readOnly ?? true,
            disabled: disabled,
            className: className,
            sx: sx,
            format: format,
            formatDensity: formatDensity,
            enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            selectedSections: selectedSections,
            onSelectedSectionsChange: onSelectedSectionsChange,
            timezone: timezone,
            label: label,
            name: name
        }, inputRef ? {
            inputRef: inputRef
        } : {}),
        ownerState: props
    });
    // TODO: Move to `useSlotProps` when https://github.com/mui/material-ui/pull/35088 will be merged
    fieldProps.inputProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, fieldProps.inputProps, {
        'aria-label': getOpenDialogAriaText(pickerFieldProps.value)
    });
    const slotsForField = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        textField: slots.textField
    }, fieldProps.slots);
    const Layout = slots.layout ?? (0, $0ea30ea295446df9$export$647f604ea2397c05);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, innerSlotProps, {
        toolbar: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, innerSlotProps?.toolbar, {
            titleId: labelId
        }),
        mobilePaper: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            'aria-labelledby': labelledById
        }, innerSlotProps?.mobilePaper)
    });
    const handleFieldRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(fieldRef, fieldProps.unstableFieldRef);
    const renderPicker = ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $71a24d8fbea898bf$export$38e969d523d4d57f), {
            contextValue: contextValue,
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Field, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, fieldProps, {
                    slots: slotsForField,
                    slotProps: slotProps,
                    unstableFieldRef: handleFieldRef
                })),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $52c169ad4ec0e8fd$export$99f83c99e1491f77), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Layout, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, layoutProps, slotProps?.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker: renderPicker
    };
};











'use client';
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [MobileDatePicker API](https://mui.com/x/api/date-pickers/mobile-date-picker/)
 */ const $080f12ab26da8443$export$97b476d7a92fee62 = /*#__PURE__*/ $7fPBF.forwardRef(function MobileDatePicker(inProps, ref) {
    const translations = (0, $7fcfc9681bf68f23$export$3cdcc56057891b44)();
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, $53ebcde7c448f3c9$export$a552c17ed3587731)(inProps, 'MuiMobileDatePicker');
    const viewRenderers = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        day: (0, $02ad17f0efd035e0$export$69888ffe06193e5e),
        month: (0, $02ad17f0efd035e0$export$69888ffe06193e5e),
        year: (0, $02ad17f0efd035e0$export$69888ffe06193e5e)
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the mobile variant
    const props = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $4d1fa529a9a32e76$export$bb1c921f313ec928)(utils, defaultizedProps, false),
        slots: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            field: (0, $5945f8b72dcc769b$export$d9781c7894a82487)
        }, defaultizedProps.slots),
        slotProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $ae0f0ccae9f4b3cc$export$2e2bcd8739ae039)(defaultizedProps.slotProps?.field, ownerState), (0, $f613678a0229c7f5$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                }),
            toolbar: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                hidden: false
            }, defaultizedProps.slotProps?.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $d282c2379e3abcb7$export$5ca0153a626a7dd7)({
        props: props,
        valueManager: (0, $841d6de1e4809c9b$export$2764b246aa3b75ba),
        valueType: 'date',
        getOpenDialogAriaText: (0, $85ebbb99b2811e17$export$7eae96bf9dd7ca56)({
            utils: utils,
            formatKey: 'fullDate',
            contextTranslation: translations.openDatePickerDialogue,
            propsTranslation: props.localeText?.openDatePickerDialogue
        }),
        validator: (0, $c885b418e3c240b8$export$ffb3d0046ef3a2)
    });
    return renderPicker();
});
$080f12ab26da8443$export$97b476d7a92fee62.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * @default false
   */ enableAccessibleFieldDOMStructure: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $c597a968c23d62fb$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
        'landscape',
        'portrait'
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
            'all',
            'day',
            'empty',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
        'day',
        'month',
        'year'
    ]).isRequired),
    /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */ yearsOrder: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
        'asc',
        'desc'
    ]),
    /**
   * Years rendered per row.
   * @default 3
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
        3,
        4
    ])
};




'use client';
const $fdd8f108deea5d70$var$_excluded = [
    "desktopModeMediaQuery"
];
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DatePicker API](https://mui.com/x/api/date-pickers/date-picker/)
 */ const $fdd8f108deea5d70$export$5109c6dd95d8fb00 = /*#__PURE__*/ $7fPBF.forwardRef(function DatePicker(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDatePicker'
    });
    const { desktopModeMediaQuery: desktopModeMediaQuery = (0, $e21804eb4bb13208$export$9ae5b19305db48ce) } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $fdd8f108deea5d70$var$_excluded);
    // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, $d692658be43721e5$export$2e2bcd8739ae039)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $03b7231526638e49$export$5a73641f0156e1e4), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: ref
    }, other));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $080f12ab26da8443$export$97b476d7a92fee62), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: ref
    }, other));
});












function $61f23b7617a6c4bc$export$2e2bcd8739ae039({ icon: icon = 'duplicate', iconSize: iconSize = 32, onClick: onClick, inputLabel: inputLabel, actionLabel: actionLabel, value: value, readOnly: readOnly }) {
    const id = (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $26a8e925f0aa9998$export$2e2bcd8739ae039), {
            sx: {
                marginTop: '16px',
                marginBottom: '8px'
            },
            fullWidth: true,
            variant: "outlined",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcd80672e9993aad$export$2e2bcd8739ae039), {
                    htmlFor: id,
                    children: inputLabel
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $50e7e9efec2c0b8c$export$2e2bcd8739ae039), {
                    id: id,
                    type: "text",
                    value: value,
                    onClick: onClick,
                    readOnly: readOnly,
                    endAdornment: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($61f23b7617a6c4bc$var$StyledInputAdornment, {
                        position: "end",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($61f23b7617a6c4bc$var$Button, {
                            "aria-label": actionLabel,
                            onClick: onClick,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                name: icon,
                                size: iconSize
                            })
                        })
                    }),
                    label: inputLabel
                })
            ]
        })
    });
}
const $61f23b7617a6c4bc$var$Button = (0, $8de346382d86c747$export$2e2bcd8739ae039).button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
`;
const $61f23b7617a6c4bc$var$StyledInputAdornment = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $a1383c8904b71ac9$export$2e2bcd8739ae039))`
    background-color: ${(0, $8951886a6b49e92a$export$35e9368ef982300f).border};
    color: ${(0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark};
    padding: 28px 14px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-left: 1px solid ${(0, $8951886a6b49e92a$export$35e9368ef982300f).border};
`;









var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

function $5a6c6a7624f41526$var$_extends() {
    return $5a6c6a7624f41526$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5a6c6a7624f41526$var$_extends.apply(null, arguments);
}
var $5a6c6a7624f41526$var$reservedModifierKeywords = [
    'shift',
    'alt',
    'meta',
    'mod',
    'ctrl'
];
var $5a6c6a7624f41526$var$mappedKeys = {
    esc: 'escape',
    "return": 'enter',
    '.': 'period',
    ',': 'comma',
    '-': 'slash',
    ' ': 'space',
    '`': 'backquote',
    '#': 'backslash',
    '+': 'bracketright',
    ShiftLeft: 'shift',
    ShiftRight: 'shift',
    AltLeft: 'alt',
    AltRight: 'alt',
    MetaLeft: 'meta',
    MetaRight: 'meta',
    OSLeft: 'meta',
    OSRight: 'meta',
    ControlLeft: 'ctrl',
    ControlRight: 'ctrl'
};
function $5a6c6a7624f41526$var$mapKey(key) {
    return (key && $5a6c6a7624f41526$var$mappedKeys[key] || key || '').trim().toLowerCase().replace(/key|digit|numpad|arrow/, '');
}
function $5a6c6a7624f41526$var$isHotkeyModifier(key) {
    return $5a6c6a7624f41526$var$reservedModifierKeywords.includes(key);
}
function $5a6c6a7624f41526$var$parseKeysHookInput(keys, splitKey) {
    if (splitKey === void 0) splitKey = ',';
    return keys.split(splitKey);
}
function $5a6c6a7624f41526$var$parseHotkey(hotkey, combinationKey, description) {
    if (combinationKey === void 0) combinationKey = '+';
    var keys = hotkey.toLocaleLowerCase().split(combinationKey).map(function(k) {
        return $5a6c6a7624f41526$var$mapKey(k);
    });
    var modifiers = {
        alt: keys.includes('alt'),
        ctrl: keys.includes('ctrl') || keys.includes('control'),
        shift: keys.includes('shift'),
        meta: keys.includes('meta'),
        mod: keys.includes('mod')
    };
    var singleCharKeys = keys.filter(function(k) {
        return !$5a6c6a7624f41526$var$reservedModifierKeywords.includes(k);
    });
    return $5a6c6a7624f41526$var$_extends({}, modifiers, {
        keys: singleCharKeys,
        description: description,
        hotkey: hotkey
    });
}
(function() {
    if (typeof document !== 'undefined') {
        document.addEventListener('keydown', function(e) {
            if (e.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
            return;
            $5a6c6a7624f41526$var$pushToCurrentlyPressedKeys([
                $5a6c6a7624f41526$var$mapKey(e.key),
                $5a6c6a7624f41526$var$mapKey(e.code)
            ]);
        });
        document.addEventListener('keyup', function(e) {
            if (e.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
            return;
            $5a6c6a7624f41526$var$removeFromCurrentlyPressedKeys([
                $5a6c6a7624f41526$var$mapKey(e.key),
                $5a6c6a7624f41526$var$mapKey(e.code)
            ]);
        });
    }
    if (typeof window !== 'undefined') window.addEventListener('blur', function() {
        $5a6c6a7624f41526$var$currentlyPressedKeys.clear();
    });
})();
var $5a6c6a7624f41526$var$currentlyPressedKeys = /*#__PURE__*/ new Set();
// https://github.com/microsoft/TypeScript/issues/17002
function $5a6c6a7624f41526$var$isReadonlyArray(value) {
    return Array.isArray(value);
}
function $5a6c6a7624f41526$export$eae3d25ef8fab782(key, splitKey) {
    if (splitKey === void 0) splitKey = ',';
    var hotkeyArray = $5a6c6a7624f41526$var$isReadonlyArray(key) ? key : key.split(splitKey);
    return hotkeyArray.every(function(hotkey) {
        return $5a6c6a7624f41526$var$currentlyPressedKeys.has(hotkey.trim().toLowerCase());
    });
}
function $5a6c6a7624f41526$var$pushToCurrentlyPressedKeys(key) {
    var hotkeyArray = Array.isArray(key) ? key : [
        key
    ];
    /*
  Due to a weird behavior on macOS we need to clear the set if the user pressed down the meta key and presses another key.
  https://stackoverflow.com/questions/11818637/why-does-javascript-drop-keyup-events-when-the-metakey-is-pressed-on-mac-browser
  Otherwise the set will hold all ever pressed keys while the meta key is down which leads to wrong results.
   */ if ($5a6c6a7624f41526$var$currentlyPressedKeys.has('meta')) $5a6c6a7624f41526$var$currentlyPressedKeys.forEach(function(key) {
        return !$5a6c6a7624f41526$var$isHotkeyModifier(key) && $5a6c6a7624f41526$var$currentlyPressedKeys["delete"](key.toLowerCase());
    });
    hotkeyArray.forEach(function(hotkey) {
        return $5a6c6a7624f41526$var$currentlyPressedKeys.add(hotkey.toLowerCase());
    });
}
function $5a6c6a7624f41526$var$removeFromCurrentlyPressedKeys(key) {
    var hotkeyArray = Array.isArray(key) ? key : [
        key
    ];
    /*
  Due to a weird behavior on macOS we need to clear the set if the user pressed down the meta key and presses another key.
  https://stackoverflow.com/questions/11818637/why-does-javascript-drop-keyup-events-when-the-metakey-is-pressed-on-mac-browser
  Otherwise the set will hold all ever pressed keys while the meta key is down which leads to wrong results.
   */ if (key === 'meta') $5a6c6a7624f41526$var$currentlyPressedKeys.clear();
    else hotkeyArray.forEach(function(hotkey) {
        return $5a6c6a7624f41526$var$currentlyPressedKeys["delete"](hotkey.toLowerCase());
    });
}
function $5a6c6a7624f41526$var$maybePreventDefault(e, hotkey, preventDefault) {
    if (typeof preventDefault === 'function' && preventDefault(e, hotkey) || preventDefault === true) e.preventDefault();
}
function $5a6c6a7624f41526$var$isHotkeyEnabled(e, hotkey, enabled) {
    if (typeof enabled === 'function') return enabled(e, hotkey);
    return enabled === true || enabled === undefined;
}
function $5a6c6a7624f41526$var$isKeyboardEventTriggeredByInput(ev) {
    return $5a6c6a7624f41526$var$isHotkeyEnabledOnTag(ev, [
        'input',
        'textarea',
        'select'
    ]);
}
function $5a6c6a7624f41526$var$isHotkeyEnabledOnTag(event, enabledOnTags) {
    if (enabledOnTags === void 0) enabledOnTags = false;
    var target = event.target, composed = event.composed;
    var targetTagName = null;
    if ($5a6c6a7624f41526$var$isCustomElement(target) && composed) targetTagName = event.composedPath()[0] && event.composedPath()[0].tagName;
    else targetTagName = target && target.tagName;
    if ($5a6c6a7624f41526$var$isReadonlyArray(enabledOnTags)) return Boolean(targetTagName && enabledOnTags && enabledOnTags.some(function(tag) {
        var _targetTagName;
        return tag.toLowerCase() === ((_targetTagName = targetTagName) == null ? void 0 : _targetTagName.toLowerCase());
    }));
    return Boolean(targetTagName && enabledOnTags && enabledOnTags);
}
function $5a6c6a7624f41526$var$isCustomElement(element) {
    // We just do a basic check w/o any complex RegEx or validation against the list of legacy names containing a hyphen,
    // as none of them is likely to be an event target, and it won't hurt anyway if we miss.
    // see: https://html.spec.whatwg.org/multipage/custom-elements.html#prod-potentialcustomelementname
    return !!element.tagName && !element.tagName.startsWith("-") && element.tagName.includes("-");
}
function $5a6c6a7624f41526$var$isScopeActive(activeScopes, scopes) {
    if (activeScopes.length === 0 && scopes) {
        console.warn('A hotkey has the "scopes" option set, however no active scopes were found. If you want to use the global scopes feature, you need to wrap your app in a <HotkeysProvider>');
        return true;
    }
    if (!scopes) return true;
    return activeScopes.some(function(scope) {
        return scopes.includes(scope);
    }) || activeScopes.includes('*');
}
var $5a6c6a7624f41526$var$isHotkeyMatchingKeyboardEvent = function isHotkeyMatchingKeyboardEvent(e, hotkey, ignoreModifiers) {
    if (ignoreModifiers === void 0) ignoreModifiers = false;
    var alt = hotkey.alt, meta = hotkey.meta, mod = hotkey.mod, shift = hotkey.shift, ctrl = hotkey.ctrl, keys = hotkey.keys;
    var pressedKeyUppercase = e.key, code = e.code, ctrlKey = e.ctrlKey, metaKey = e.metaKey, shiftKey = e.shiftKey, altKey = e.altKey;
    var keyCode = $5a6c6a7624f41526$var$mapKey(code);
    var pressedKey = pressedKeyUppercase.toLowerCase();
    if (!(keys != null && keys.includes(keyCode)) && !(keys != null && keys.includes(pressedKey)) && ![
        'ctrl',
        'control',
        'unknown',
        'meta',
        'alt',
        'shift',
        'os'
    ].includes(keyCode)) return false;
    if (!ignoreModifiers) {
        // We check the pressed keys for compatibility with the keyup event. In keyup events the modifier flags are not set.
        if (alt === !altKey && pressedKey !== 'alt') return false;
        if (shift === !shiftKey && pressedKey !== 'shift') return false;
        // Mod is a special key name that is checking for meta on macOS and ctrl on other platforms
        if (mod) {
            if (!metaKey && !ctrlKey) return false;
        } else {
            if (meta === !metaKey && pressedKey !== 'meta' && pressedKey !== 'os') return false;
            if (ctrl === !ctrlKey && pressedKey !== 'ctrl' && pressedKey !== 'control') return false;
        }
    }
    // All modifiers are correct, now check the key
    // If the key is set, we check for the key
    if (keys && keys.length === 1 && (keys.includes(pressedKey) || keys.includes(keyCode))) return true;
    else if (keys) // Check if all keys are present in pressedDownKeys set
    return $5a6c6a7624f41526$export$eae3d25ef8fab782(keys);
    else if (!keys) // If the key is not set, we only listen for modifiers, that check went alright, so we return true
    return true;
    // There is nothing that matches.
    return false;
};
var $5a6c6a7624f41526$var$BoundHotkeysProxyProvider = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);
var $5a6c6a7624f41526$var$useBoundHotkeysProxy = function useBoundHotkeysProxy() {
    return (0, $7fPBF.useContext)($5a6c6a7624f41526$var$BoundHotkeysProxyProvider);
};
function $5a6c6a7624f41526$var$BoundHotkeysProxyProviderProvider(_ref) {
    var addHotkey = _ref.addHotkey, removeHotkey = _ref.removeHotkey, children = _ref.children;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5a6c6a7624f41526$var$BoundHotkeysProxyProvider.Provider, {
        value: {
            addHotkey: addHotkey,
            removeHotkey: removeHotkey
        },
        children: children
    });
}
function $5a6c6a7624f41526$var$deepEqual(x, y) {
    //@ts-ignore
    return x && y && typeof x === 'object' && typeof y === 'object' ? Object.keys(x).length === Object.keys(y).length && //@ts-ignore
    Object.keys(x).reduce(function(isEqual, key) {
        return isEqual && $5a6c6a7624f41526$var$deepEqual(x[key], y[key]);
    }, true) : x === y;
}
var $5a6c6a7624f41526$var$HotkeysContext = /*#__PURE__*/ (0, $7fPBF.createContext)({
    hotkeys: [],
    enabledScopes: [],
    toggleScope: function toggleScope() {},
    enableScope: function enableScope() {},
    disableScope: function disableScope() {}
});
var $5a6c6a7624f41526$export$183c7bf336967877 = function useHotkeysContext() {
    return (0, $7fPBF.useContext)($5a6c6a7624f41526$var$HotkeysContext);
};
var $5a6c6a7624f41526$export$9d58aaad435254c0 = function HotkeysProvider(_ref) {
    var _ref$initiallyActiveS = _ref.initiallyActiveScopes, initiallyActiveScopes = _ref$initiallyActiveS === void 0 ? [
        '*'
    ] : _ref$initiallyActiveS, children = _ref.children;
    var _useState = (0, $7fPBF.useState)((initiallyActiveScopes == null ? void 0 : initiallyActiveScopes.length) > 0 ? initiallyActiveScopes : [
        '*'
    ]), internalActiveScopes = _useState[0], setInternalActiveScopes = _useState[1];
    var _useState2 = (0, $7fPBF.useState)([]), boundHotkeys = _useState2[0], setBoundHotkeys = _useState2[1];
    var enableScope = (0, $7fPBF.useCallback)(function(scope) {
        setInternalActiveScopes(function(prev) {
            if (prev.includes('*')) return [
                scope
            ];
            return Array.from(new Set([].concat(prev, [
                scope
            ])));
        });
    }, []);
    var disableScope = (0, $7fPBF.useCallback)(function(scope) {
        setInternalActiveScopes(function(prev) {
            if (prev.filter(function(s) {
                return s !== scope;
            }).length === 0) return [
                '*'
            ];
            else return prev.filter(function(s) {
                return s !== scope;
            });
        });
    }, []);
    var toggleScope = (0, $7fPBF.useCallback)(function(scope) {
        setInternalActiveScopes(function(prev) {
            if (prev.includes(scope)) {
                if (prev.filter(function(s) {
                    return s !== scope;
                }).length === 0) return [
                    '*'
                ];
                else return prev.filter(function(s) {
                    return s !== scope;
                });
            } else {
                if (prev.includes('*')) return [
                    scope
                ];
                return Array.from(new Set([].concat(prev, [
                    scope
                ])));
            }
        });
    }, []);
    var addBoundHotkey = (0, $7fPBF.useCallback)(function(hotkey) {
        setBoundHotkeys(function(prev) {
            return [].concat(prev, [
                hotkey
            ]);
        });
    }, []);
    var removeBoundHotkey = (0, $7fPBF.useCallback)(function(hotkey) {
        setBoundHotkeys(function(prev) {
            return prev.filter(function(h) {
                return !$5a6c6a7624f41526$var$deepEqual(h, hotkey);
            });
        });
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5a6c6a7624f41526$var$HotkeysContext.Provider, {
        value: {
            enabledScopes: internalActiveScopes,
            hotkeys: boundHotkeys,
            enableScope: enableScope,
            disableScope: disableScope,
            toggleScope: toggleScope
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5a6c6a7624f41526$var$BoundHotkeysProxyProviderProvider, {
            addHotkey: addBoundHotkey,
            removeHotkey: removeBoundHotkey,
            children: children
        })
    });
};
function $5a6c6a7624f41526$var$useDeepEqualMemo(value) {
    var ref = (0, $7fPBF.useRef)(undefined);
    if (!$5a6c6a7624f41526$var$deepEqual(ref.current, value)) ref.current = value;
    return ref.current;
}
var $5a6c6a7624f41526$var$stopPropagation = function stopPropagation(e) {
    e.stopPropagation();
    e.preventDefault();
    e.stopImmediatePropagation();
};
var $5a6c6a7624f41526$var$useSafeLayoutEffect = typeof window !== 'undefined' ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);
function $5a6c6a7624f41526$export$1b0c17123b4f3646(keys, callback, options, dependencies) {
    var _useState = (0, $7fPBF.useState)(null), ref = _useState[0], setRef = _useState[1];
    var hasTriggeredRef = (0, $7fPBF.useRef)(false);
    var _options = !(options instanceof Array) ? options : !(dependencies instanceof Array) ? dependencies : undefined;
    var _keys = $5a6c6a7624f41526$var$isReadonlyArray(keys) ? keys.join(_options == null ? void 0 : _options.splitKey) : keys;
    var _deps = options instanceof Array ? options : dependencies instanceof Array ? dependencies : undefined;
    var memoisedCB = (0, $7fPBF.useCallback)(callback, _deps != null ? _deps : []);
    var cbRef = (0, $7fPBF.useRef)(memoisedCB);
    if (_deps) cbRef.current = memoisedCB;
    else cbRef.current = callback;
    var memoisedOptions = $5a6c6a7624f41526$var$useDeepEqualMemo(_options);
    var _useHotkeysContext = $5a6c6a7624f41526$export$183c7bf336967877(), enabledScopes = _useHotkeysContext.enabledScopes;
    var proxy = $5a6c6a7624f41526$var$useBoundHotkeysProxy();
    $5a6c6a7624f41526$var$useSafeLayoutEffect(function() {
        if ((memoisedOptions == null ? void 0 : memoisedOptions.enabled) === false || !$5a6c6a7624f41526$var$isScopeActive(enabledScopes, memoisedOptions == null ? void 0 : memoisedOptions.scopes)) return;
        var listener = function listener(e, isKeyUp) {
            var _e$target;
            if (isKeyUp === void 0) isKeyUp = false;
            if ($5a6c6a7624f41526$var$isKeyboardEventTriggeredByInput(e) && !$5a6c6a7624f41526$var$isHotkeyEnabledOnTag(e, memoisedOptions == null ? void 0 : memoisedOptions.enableOnFormTags)) return;
            // TODO: SINCE THE EVENT IS NOW ATTACHED TO THE REF, THE ACTIVE ELEMENT CAN NEVER BE INSIDE THE REF. THE HOTKEY ONLY TRIGGERS IF THE
            // REF IS THE ACTIVE ELEMENT. THIS IS A PROBLEM SINCE FOCUSED SUB COMPONENTS WON'T TRIGGER THE HOTKEY.
            if (ref !== null) {
                var rootNode = ref.getRootNode();
                if ((rootNode instanceof Document || rootNode instanceof ShadowRoot) && rootNode.activeElement !== ref && !ref.contains(rootNode.activeElement)) {
                    $5a6c6a7624f41526$var$stopPropagation(e);
                    return;
                }
            }
            if ((_e$target = e.target) != null && _e$target.isContentEditable && !(memoisedOptions != null && memoisedOptions.enableOnContentEditable)) return;
            $5a6c6a7624f41526$var$parseKeysHookInput(_keys, memoisedOptions == null ? void 0 : memoisedOptions.splitKey).forEach(function(key) {
                var _hotkey$keys;
                var hotkey = $5a6c6a7624f41526$var$parseHotkey(key, memoisedOptions == null ? void 0 : memoisedOptions.combinationKey);
                if ($5a6c6a7624f41526$var$isHotkeyMatchingKeyboardEvent(e, hotkey, memoisedOptions == null ? void 0 : memoisedOptions.ignoreModifiers) || (_hotkey$keys = hotkey.keys) != null && _hotkey$keys.includes('*')) {
                    if (memoisedOptions != null && memoisedOptions.ignoreEventWhen != null && memoisedOptions.ignoreEventWhen(e)) return;
                    if (isKeyUp && hasTriggeredRef.current) return;
                    $5a6c6a7624f41526$var$maybePreventDefault(e, hotkey, memoisedOptions == null ? void 0 : memoisedOptions.preventDefault);
                    if (!$5a6c6a7624f41526$var$isHotkeyEnabled(e, hotkey, memoisedOptions == null ? void 0 : memoisedOptions.enabled)) {
                        $5a6c6a7624f41526$var$stopPropagation(e);
                        return;
                    }
                    // Execute the user callback for that hotkey
                    cbRef.current(e, hotkey);
                    if (!isKeyUp) hasTriggeredRef.current = true;
                }
            });
        };
        var handleKeyDown = function handleKeyDown(event) {
            if (event.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
            return;
            $5a6c6a7624f41526$var$pushToCurrentlyPressedKeys($5a6c6a7624f41526$var$mapKey(event.code));
            if ((memoisedOptions == null ? void 0 : memoisedOptions.keydown) === undefined && (memoisedOptions == null ? void 0 : memoisedOptions.keyup) !== true || memoisedOptions != null && memoisedOptions.keydown) listener(event);
        };
        var handleKeyUp = function handleKeyUp(event) {
            if (event.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
            return;
            $5a6c6a7624f41526$var$removeFromCurrentlyPressedKeys($5a6c6a7624f41526$var$mapKey(event.code));
            hasTriggeredRef.current = false;
            if (memoisedOptions != null && memoisedOptions.keyup) listener(event, true);
        };
        var domNode = ref || (_options == null ? void 0 : _options.document) || document;
        // @ts-ignore
        domNode.addEventListener('keyup', handleKeyUp, _options == null ? void 0 : _options.eventListenerOptions);
        // @ts-ignore
        domNode.addEventListener('keydown', handleKeyDown, _options == null ? void 0 : _options.eventListenerOptions);
        if (proxy) $5a6c6a7624f41526$var$parseKeysHookInput(_keys, memoisedOptions == null ? void 0 : memoisedOptions.splitKey).forEach(function(key) {
            return proxy.addHotkey($5a6c6a7624f41526$var$parseHotkey(key, memoisedOptions == null ? void 0 : memoisedOptions.combinationKey, memoisedOptions == null ? void 0 : memoisedOptions.description));
        });
        return function() {
            // @ts-ignore
            domNode.removeEventListener('keyup', handleKeyUp, _options == null ? void 0 : _options.eventListenerOptions);
            // @ts-ignore
            domNode.removeEventListener('keydown', handleKeyDown, _options == null ? void 0 : _options.eventListenerOptions);
            if (proxy) $5a6c6a7624f41526$var$parseKeysHookInput(_keys, memoisedOptions == null ? void 0 : memoisedOptions.splitKey).forEach(function(key) {
                return proxy.removeHotkey($5a6c6a7624f41526$var$parseHotkey(key, memoisedOptions == null ? void 0 : memoisedOptions.combinationKey, memoisedOptions == null ? void 0 : memoisedOptions.description));
            });
        };
    }, [
        ref,
        _keys,
        memoisedOptions,
        enabledScopes
    ]);
    return setRef;
}
function $5a6c6a7624f41526$export$175b3984f625ab17() {
    var _useState = (0, $7fPBF.useState)(new Set()), keys = _useState[0], setKeys = _useState[1];
    var _useState2 = (0, $7fPBF.useState)(false), isRecording = _useState2[0], setIsRecording = _useState2[1];
    var handler = (0, $7fPBF.useCallback)(function(event) {
        if (event.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
        return;
        event.preventDefault();
        event.stopPropagation();
        setKeys(function(prev) {
            var newKeys = new Set(prev);
            newKeys.add($5a6c6a7624f41526$var$mapKey(event.code));
            return newKeys;
        });
    }, []);
    var stop = (0, $7fPBF.useCallback)(function() {
        if (typeof document !== 'undefined') {
            document.removeEventListener('keydown', handler);
            setIsRecording(false);
        }
    }, [
        handler
    ]);
    var start = (0, $7fPBF.useCallback)(function() {
        setKeys(new Set());
        if (typeof document !== 'undefined') {
            stop();
            document.addEventListener('keydown', handler);
            setIsRecording(true);
        }
    }, [
        handler,
        stop
    ]);
    var resetKeys = (0, $7fPBF.useCallback)(function() {
        setKeys(new Set());
    }, []);
    return [
        keys,
        {
            start: start,
            stop: stop,
            resetKeys: resetKeys,
            isRecording: isRecording
        }
    ];
}




function $7a1bf8f9f1406bc7$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { profileId: profileId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const editProfileContainer = (0, $697752726c88b03c$export$2e2bcd8739ae039).useContainer();
    const profilesContainer = (0, $60065a32b4a31650$export$2e2bcd8739ae039).useContainer();
    const [shareLink, setShareLink] = (0, $7fPBF.useState)('');
    const [hasExpiration, setHasExpiration] = (0, $7fPBF.useState)(false);
    const [isSingleUse, setIsSingleUse] = (0, $7fPBF.useState)(false);
    const [expirationDate, setExpirationDate] = (0, $7fPBF.useState)((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().add(1, 'day'));
    const [existingShares, setExistingShares] = (0, $7fPBF.useState)([]);
    const createLink = async ()=>{
        const result = await profilesContainer.createShareLink(profileId, isSingleUse, hasExpiration ? expirationDate : null);
        if (result?.resultType == 'Ok' && result.data?.accessCode) {
            const shareLink = `https://share.cephable.com/profileshare/copy/${result.data.accessCode}`;
            setShareLink(shareLink);
            navigator.clipboard.writeText(shareLink);
        }
    };
    const loadShares = async ()=>{
        const result = await profilesContainer.getShares(profileId);
        if (result?.resultType == 'Ok') setExistingShares(result.data?.filter((s)=>s.isDisabled != true) ?? []);
    };
    const deleteShare = async (id)=>{
        const result = await profilesContainer.deleteShare(id);
        if (result?.resultType == 'Ok') loadShares();
    };
    (0, $7fPBF.useEffect)(()=>{
        loadShares();
    }, []);
    // listens to ctrl+c or cmd+c
    (0, $5a6c6a7624f41526$export$1b0c17123b4f3646)([
        'mod+c'
    ], ()=>{
        navigator.clipboard.writeText(JSON.stringify(editProfileContainer.getUserDeviceProfileFromState()));
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $347ffda0d89c401a$export$a30053b04ba33ef5), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9926e0d0274623af$export$ce6636bfa4e9f0e8), {
                    children: shareLink ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $61f23b7617a6c4bc$export$2e2bcd8739ae039), {
                        value: shareLink,
                        readOnly: true,
                        onClick: ()=>navigator.clipboard.writeText(shareLink),
                        inputLabel: t('common:profile.share.link'),
                        actionLabel: t('common:profile.share.copy')
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $26a8e925f0aa9998$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$1acdcf5a973a8414), {
                                    children: t('common:profile.share.usage')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e1f776e3a27ad5dc$export$2e2bcd8739ae039), {
                                    name: "isSingleUse",
                                    defaultValue: "right",
                                    onChange: (e)=>setIsSingleUse(e.target.value == 'true'),
                                    value: isSingleUse ? 'true' : 'false',
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
                                            value: "true",
                                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $de28970229c88fa7$export$2e2bcd8739ae039), {}),
                                            label: t('common:profile.share.expiration.once')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
                                            value: "false",
                                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $de28970229c88fa7$export$2e2bcd8739ae039), {}),
                                            label: t('common:profile.share.expiration.unlimited')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$1acdcf5a973a8414), {
                                    children: t('common:profile.share.expiration.title')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e1f776e3a27ad5dc$export$2e2bcd8739ae039), {
                                    name: "hasExpiration",
                                    defaultValue: "right",
                                    onChange: (e)=>setHasExpiration(e.target.value == 'true'),
                                    value: hasExpiration ? 'true' : 'false',
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
                                            value: "false",
                                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $de28970229c88fa7$export$2e2bcd8739ae039), {}),
                                            label: t('common:profile.share.expiration.no')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
                                            value: "true",
                                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $de28970229c88fa7$export$2e2bcd8739ae039), {}),
                                            label: t('common:profile.share.expiration.dateDescription')
                                        })
                                    ]
                                }),
                                hasExpiration && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fdd8f108deea5d70$export$5109c6dd95d8fb00), {
                                    label: t('common:profile.share.expiration.date'),
                                    value: expirationDate,
                                    onChange: (e)=>setExpirationDate(e)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                    onClick: createLink,
                                    children: t('common:profile.share.add')
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $9926e0d0274623af$export$ce6636bfa4e9f0e8), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9926e0d0274623af$export$aaf6264d06ddc4ce), {
                        children: t('common:profile.share.manage')
                    }),
                    existingShares?.length > 0 ? existingShares.map((share, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7a1bf8f9f1406bc7$var$ShareCard, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$ea6aee68c7b1694f), {
                                    children: t('common:profile.share.created', 'created', {
                                        value: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(share.createdDate)?.format('dddd MMMM DD, YYYY')
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c09a12afb55a78a$export$2e2bcd8739ae039), {
                                    onClick: ()=>deleteShare(share.id),
                                    children: "Remove"
                                })
                            ]
                        }, index)) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                        children: t('common:profile.share.empty')
                    })
                ]
            })
        ]
    });
}
const $7a1bf8f9f1406bc7$var$ShareCard = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $184b8f5fc607fb11$export$2e2bcd8739ae039))`
    margin: 8px;
    padding: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    background: ${(props)=>props.theme.color.accentCard};
    > button {
        margin-left: auto;
        margin-right: 0;
    }
`;











/** NOTE: not included in ControlTypeField */ function $17c3db2e0b73f463$var$SuggestedPromptField({ value: value, onChange: onChange, disabled: disabled, placeholder: placeholder }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
        disabled: disabled,
        fullWidth: true,
        value: value,
        label: t('common:suggestedPrompts.title'),
        placeholder: placeholder,
        onChange: (e)=>onChange(e.target.value)
    });
}
var $17c3db2e0b73f463$export$2e2bcd8739ae039 = $17c3db2e0b73f463$var$SuggestedPromptField;





var $7fPBF = parcelRequire("7fPBF");

function $7d3c7fab6a83fa5f$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const editProfileContainer = (0, $697752726c88b03c$export$2e2bcd8739ae039).useContainer();
    const [activeTab, setActiveTab] = (0, $7fPBF.useState)('generate');
    const [createButtonLabel, setCreateButtonLabel] = (0, $7fPBF.useState)(t('common:suggestedPrompts.addGenerate'));
    const [placeholderText, setPlaceholderText] = (0, $7fPBF.useState)(t('common:suggestedPrompts.generatePlaceholder'));
    const [prompts, setPrompts] = (0, $7fPBF.useState)(editProfileContainer.suggestedGeneratePrompts || []);
    (0, $7fPBF.useEffect)(()=>{
        if (activeTab === 'generate') {
            setCreateButtonLabel(t('common:suggestedPrompts.addGenerate'));
            setPlaceholderText(t('common:suggestedPrompts.generatePlaceholder'));
            setPrompts(editProfileContainer.suggestedGeneratePrompts || []);
        } else {
            setCreateButtonLabel(t('common:suggestedPrompts.addRewrite'));
            setPlaceholderText(t('common:suggestedPrompts.rewritePlaceholder'));
            setPrompts(editProfileContainer.suggestedRewritePrompts || []);
        }
    }, [
        activeTab
    ]);
    const activeTabIsGenerate = activeTab === 'generate';
    const setUpdates = (prompts)=>{
        if (activeTabIsGenerate) editProfileContainer.updateSuggestedGeneratePrompts([
            ...prompts
        ]);
        else editProfileContainer.updateSuggestedRewritePrompts([
            ...prompts
        ]);
        editProfileContainer.setHasChanges(true);
    };
    const updatePrompts = (value, index)=>{
        prompts[index] = value;
        setUpdates(prompts);
    };
    const removePrompts = (index)=>{
        prompts.splice(index, 1);
        setUpdates(prompts);
    };
    const addPrompts = ()=>{
        prompts.unshift('');
        setUpdates(prompts);
    };
    const handleSave = async ()=>{
        const result = await editProfileContainer.saveChanges();
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2e997290a21e7a60$export$eed545bf41e40386), {
                role: "tablist",
                "aria-label": "Profile Tabs",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2e997290a21e7a60$export$7e36e2f4770bc64d), {
                        role: "tab",
                        style: {
                            padding: '16px 32px'
                        },
                        "aria-selected": activeTab === 'generate',
                        onClick: ()=>setActiveTab('generate'),
                        isActive: activeTab === 'generate',
                        children: t('common:suggestedPrompts.generate')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2e997290a21e7a60$export$7e36e2f4770bc64d), {
                        role: "tab",
                        style: {
                            padding: '16px 32px'
                        },
                        "aria-selected": activeTab === 'rewrite',
                        onClick: ()=>setActiveTab('rewrite'),
                        isActive: activeTab === 'rewrite',
                        children: t('common:suggestedPrompts.rewrite')
                    })
                ]
            }),
            prompts.map((prompt, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6e48650aa2ed148e$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $17c3db2e0b73f463$export$2e2bcd8739ae039), {
                            value: prompt,
                            onChange: (value)=>updatePrompts(value, i),
                            disabled: editProfileContainer.isPreview,
                            placeholder: placeholderText
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c09a12afb55a78a$export$2e2bcd8739ae039), {
                            disabled: editProfileContainer.isPreview,
                            onClick: ()=>removePrompts(i),
                            children: t('common:suggestedPrompts.remove')
                        })
                    ]
                }, i)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                    $size: "large",
                    startIcon: "plus",
                    onClick: addPrompts,
                    children: createButtonLabel
                })
            }),
            editProfileContainer.hasChanges && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $258cb68b976e3a51$export$2e2bcd8739ae039), {
                hasChanges: editProfileContainer.hasChanges,
                setHasChanges: editProfileContainer.setHasChanges,
                onSave: handleSave
            })
        ]
    });
}














var $7fPBF = parcelRequire("7fPBF");
const $138dae19c52184af$var$useFilterProfileConfigurations = ({ profile: profile, filter: filter, selectedCommandType: selectedCommandType = '' })=>{
    const [filteredMacros, setFilteredMacros] = (0, $7fPBF.useState)(profile?.macros ? profile.macros : []);
    const [filteredKeybinds, setFilteredKeybinds] = (0, $7fPBF.useState)(profile?.commandKeyMappings ? profile.commandKeyMappings : []);
    const [filteredHotkeys, setFilteredHotkeys] = (0, $7fPBF.useState)(profile?.hotkeys ? profile.hotkeys : []);
    (0, $7fPBF.useEffect)(()=>{
        if (!profile) return;
        const filterNormalized = filter?.toLowerCase().trim();
        setFilteredMacros(profile.macros.filter((m)=>m.commands.some((c)=>(c.commandType === selectedCommandType || !selectedCommandType) && (c.command?.toLowerCase().includes(filterNormalized) || !filterNormalized)) || m.name?.toLowerCase().includes(filterNormalized) || !filterNormalized));
        setFilteredKeybinds(profile.commandKeyMappings.filter((m)=>m.commands.some((c)=>(c.commandType == selectedCommandType || !selectedCommandType) && (c.command?.toLowerCase().includes(filterNormalized) || !filterNormalized))));
        setFilteredHotkeys(profile.hotkeys.filter((m)=>m.command?.toLowerCase().includes(filterNormalized) || m.displayName?.toLowerCase().includes(filterNormalized) || !filterNormalized));
    }, [
        selectedCommandType,
        filter,
        profile?.id,
        profile?.hotkeys,
        profile?.macros,
        profile?.commandKeyMappings
    ]);
    if (!profile) return {
        filteredMacros: null,
        filteredKeybinds: [],
        filteredHotkeys: []
    };
    return {
        filteredMacros: filteredMacros,
        filteredKeybinds: filteredKeybinds,
        filteredHotkeys: filteredHotkeys
    };
};
var $138dae19c52184af$export$2e2bcd8739ae039 = $138dae19c52184af$var$useFilterProfileConfigurations;



var $7fPBF = parcelRequire("7fPBF");

function $4025efcf1cd15ab4$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const editProfileContainer = (0, $697752726c88b03c$export$2e2bcd8739ae039).useContainer();
    const [selectedCommandType, setSelectedCommandType] = (0, $7fPBF.useState)('');
    const [filter, setFilter] = (0, $7fPBF.useState)('');
    const { filteredMacros: filteredMacros, filteredHotkeys: filteredHotkeys, filteredKeybinds: filteredKeybinds } = (0, $138dae19c52184af$export$2e2bcd8739ae039)({
        profile: editProfileContainer,
        filter: filter,
        selectedCommandType: selectedCommandType || undefined
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9926e0d0274623af$export$ce6636bfa4e9f0e8), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $26a8e925f0aa9998$export$2e2bcd8739ae039), {
                    fullWidth: true,
                    style: {
                        marginTop: 32
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcd80672e9993aad$export$2e2bcd8739ae039), {
                            id: "command-type",
                            children: t('common:input.filter')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                            labelId: `command-type`,
                            value: selectedCommandType,
                            label: t('common:input.filter'),
                            onChange: (e)=>setSelectedCommandType(e.target.value),
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                    value: '',
                                    children: t('common:all')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                    value: "other",
                                    children: t('common:voice.title')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                    value: "expression",
                                    children: t('common:expression.title')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                    value: "tilt",
                                    children: t('common:motion.title')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                    value: "external_keyboard",
                                    children: t('common:hotkey.title')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$1acdcf5a973a8414), {
                            htmlFor: `filter`,
                            children: t('common:profile.summary.filter')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                            value: filter ?? '',
                            name: `filter`,
                            placeholder: t('common:profile.summary.placeholder'),
                            onChange: (e)=>setFilter(e.target.value)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($4025efcf1cd15ab4$var$ListingContentWrapper, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $031c6e7d94ce0aa0$export$2e2bcd8739ae039), {
                        macros: filteredMacros,
                        startExpanded: true
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $51f16c3433a05d99$export$2e2bcd8739ae039), {
                        commandKeyMappings: filteredKeybinds,
                        showDescription: false
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4bb13f250ef3167a$export$2e2bcd8739ae039), {
                        hotkeys: filteredHotkeys,
                        showDescription: false
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c0e241dbffe40cae$export$2e2bcd8739ae039), {
                        programNames: editProfileContainer.associatedPrograms,
                        profileName: editProfileContainer.name,
                        showDescription: false
                    })
                ]
            })
        ]
    });
}
const $4025efcf1cd15ab4$var$ListingContentWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    margin: 0 2rem;
    display: flex;
    gap: 1rem;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;














var $7fPBF = parcelRequire("7fPBF");










function $6e4c204c2f850d70$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const alertsContainer = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const authContainer = (0, $455682785eac4c5b$export$2e2bcd8739ae039).useContainer();
    const currentUserContainer = (0, $8a1185b15e8317ab$export$2e2bcd8739ae039).useContainer();
    const deviceContainer = (0, $57ef534a0961ba07$export$2e2bcd8739ae039).useContainer();
    const currentDeviceContainer = (0, $43d630686eddb628$export$2e2bcd8739ae039).useContainer();
    const profilesContainer = (0, $60065a32b4a31650$export$2e2bcd8739ae039).useContainer();
    const publicProfileContainer = (0, $ba024c453c69bc05$export$2e2bcd8739ae039).useContainer();
    const globalCustomControlsContainer = (0, $b8d2d4cc121e033d$export$2e2bcd8739ae039).useContainer();
    const [isShowingSignoutConfirmation, setIsShowingSignoutConfirmation] = (0, $7fPBF.useState)(false);
    const hideSignoutConfirmation = (0, $7fPBF.useCallback)(()=>{
        setIsShowingSignoutConfirmation(false);
    }, []);
    const showSignoutConfirmation = (0, $7fPBF.useCallback)(()=>{
        setIsShowingSignoutConfirmation(true);
    }, []);
    const clearAndReload = (0, $7fPBF.useCallback)(()=>{
        // Perform all necessary cleanup operations
        authContainer.logout();
        deviceContainer.clearDevices();
        currentDeviceContainer.clearAll();
        profilesContainer.clearProfiles();
        publicProfileContainer.clearProfiles();
        currentUserContainer.clearCurrentUser();
        globalCustomControlsContainer.clear();
        // Clear upgrade modal dismissal so it shows again on next login
        localStorage.removeItem((0, $4a3c7ab711a29dd4$export$ee420f2304181127));
        navigate('../login');
        window.location.reload(); // Reload the page to ensure all changes take effect
    }, []);
    const signout = async ()=>{
        console.log('signout');
        // remove everything from local storage, navigate to home page, refresh page
        // delete virtual device then clear
        authContainer.handleIsLoading(true);
        hideSignoutConfirmation();
        if (deviceContainer.virtualDeviceIdRef.current) try {
            const result = await deviceContainer.disableDevice(deviceContainer.virtualDeviceIdRef.current);
            if (result?.resultType != 'Ok') alertsContainer.showError(t('common:device.error.deleteLong'));
        } catch (error) {
            alertsContainer.showError(t('common:device.error.deleteLong'));
        }
        clearAndReload();
        authContainer.handleIsLoading(false);
    };
    return {
        signout: signout,
        isSignOutConfirmationVisible: isShowingSignoutConfirmation,
        showSignoutConfirmation: showSignoutConfirmation,
        hideSignoutConfirmation: hideSignoutConfirmation,
        clearAndReload: clearAndReload
    };
}



var $7fPBF = parcelRequire("7fPBF");









var $7fPBF = parcelRequire("7fPBF");












const $6c98c9e4544fab35$export$59a533f935b3ed74 = ()=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    function getLocaleDisplayName(locale) {
        return t(`common:localization.locales.${locale}`, locale);
    }
    return getLocaleDisplayName;
};



function $bdbd121ff5ebdd35$var$LocalizationLanguageField({ value: value, onChange: onChange, disabled: disabled, variant: variant }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const fieldId = (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)();
    const inputLabel = t(`common:localization.${variant}.title`);
    const getLocaleDisplayName = (0, $6c98c9e4544fab35$export$59a533f935b3ed74)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $26a8e925f0aa9998$export$2e2bcd8739ae039), {
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcd80672e9993aad$export$2e2bcd8739ae039), {
                id: fieldId,
                children: inputLabel
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                labelId: `${variant}_language_field`,
                value: value,
                label: inputLabel,
                onChange: (e)=>onChange(e.target.value),
                disabled: disabled,
                children: (0, $3ecd3f7dea3d56de$export$df1c34db1371eeed)[variant].map((locale)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        value: locale,
                        children: getLocaleDisplayName(locale)
                    }, `${locale}_${variant}`))
            })
        ]
    });
}
var $bdbd121ff5ebdd35$export$2e2bcd8739ae039 = $bdbd121ff5ebdd35$var$LocalizationLanguageField;


function $1078910feab41cef$var$LocalizationFieldCard({ variant: variant, value: value, onChange: onChange }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
        title: (0, $1e580fbd50c9e2d3$export$625550452a3fa3ec)(`common:localization.${variant}.title`),
        description: (0, $1e580fbd50c9e2d3$export$625550452a3fa3ec)(`common:localization.${variant}.description`),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1078910feab41cef$var$TextWrap, {
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bdbd121ff5ebdd35$export$2e2bcd8739ae039), {
                variant: variant,
                value: value,
                onChange: onChange
            })
        })
    });
}
const $1078910feab41cef$var$TextWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    padding-top: 2rem;
    width: 100%;
`;
var $1078910feab41cef$export$2e2bcd8739ae039 = $1078910feab41cef$var$LocalizationFieldCard;


function $ccbc7a02b152347e$var$LocalizationEditDialog({ open: open, onClose: onClose, description: description, customSave: customSave = null, ...restProps }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const authContainer = (0, $455682785eac4c5b$export$2e2bcd8739ae039).useContainer();
    const alertsContainer = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const currentUserContainer = (0, $8a1185b15e8317ab$export$2e2bcd8739ae039).useContainer();
    const getCurrentUserLocales = ()=>{
        return {
            defaultLocale: currentUserContainer.userLocalePreferences.defaultLocale,
            defaultVoiceLocale: currentUserContainer.userLocalePreferences.defaultVoiceLocale
        };
    };
    const [userLocalePreferences, setUserLocalePreferences] = (0, $7fPBF.useState)(getCurrentUserLocales());
    const handleCancel = ()=>{
        onClose();
        setUserLocalePreferences(getCurrentUserLocales());
    };
    const handleSave = async ()=>{
        if (authContainer.isAuthenticated) {
            const result = await currentUserContainer.saveUserLocales(userLocalePreferences);
            if (result?.resultType == 'Ok') {
                onClose();
                alertsContainer.showSuccess(t('common:localization.save.success'), 5000);
            } else alertsContainer.showError(t('common:localization.save.error'), 5000);
        } else {
            // handle case when locale is changed pre-auth.
            currentUserContainer.updateUserLocales(userLocalePreferences, false);
            onClose();
            alertsContainer.showSuccess(t('common:localization.save.success'), 5000);
        }
    };
    const handleLanguageSelection = (variant, value)=>{
        const newLocalePreferences = {
            ...userLocalePreferences
        };
        if (variant == 'display') newLocalePreferences.defaultLocale = value;
        else if (variant == 'voice') newLocalePreferences.defaultVoiceLocale = value;
        setUserLocalePreferences(newLocalePreferences);
    };
    (0, $7fPBF.useEffect)(()=>{
        setUserLocalePreferences(getCurrentUserLocales());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentUserContainer.userLocalePreferences
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        "data-testid": "localization-edit-dialog",
        title: t('common:localization.title'),
        description: description ?? '',
        open: open,
        onConfirm: ()=>customSave ? customSave(userLocalePreferences.defaultLocale) : handleSave(),
        onCancel: handleCancel,
        onClose: handleCancel,
        ...restProps,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $348d9e775387b4da$export$8a73847ccc40addf), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1078910feab41cef$export$2e2bcd8739ae039), {
                    variant: "display",
                    value: userLocalePreferences.defaultLocale,
                    onChange: (value)=>handleLanguageSelection('display', value)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1078910feab41cef$export$2e2bcd8739ae039), {
                    variant: "voice",
                    value: userLocalePreferences.defaultVoiceLocale,
                    onChange: (value)=>handleLanguageSelection('voice', value)
                })
            ]
        })
    });
}
var $ccbc7a02b152347e$export$2e2bcd8739ae039 = $ccbc7a02b152347e$var$LocalizationEditDialog;


function $4d34bf1fa9080e8b$export$2e2bcd8739ae039({ settingsHref: settingsHref, notificationHref: notificationHref, skipConfirmation: skipConfirmation = true }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [anchorEl, setAnchorEl] = (0, $7fPBF.useState)(null);
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const { isAuthenticated: isAuthenticated } = (0, $455682785eac4c5b$export$2e2bcd8739ae039).useContainer();
    const { isEmailVerified: isEmailVerified } = (0, $8a1185b15e8317ab$export$2e2bcd8739ae039).useContainer();
    const { signout: signout, isSignOutConfirmationVisible: isSignOutConfirmationVisible, showSignoutConfirmation: showSignoutConfirmation, hideSignoutConfirmation: hideSignoutConfirmation } = (0, $6e4c204c2f850d70$export$2e2bcd8739ae039)();
    const { unreadNotifications: unreadNotifications } = (0, $3521ff40d609c2ed$export$2e2bcd8739ae039).useContainer();
    const [showLocalizationDialog, setShowLocalizationDialog] = (0, $7fPBF.useState)(false);
    function handleClick(event) {
        if (anchorEl !== event.currentTarget) setAnchorEl(event.currentTarget);
    }
    function handleClose() {
        setAnchorEl(null);
    }
    function handleSettingsClick() {
        handleClose();
        navigate(settingsHref);
    }
    function handleLogoutClick() {
        handleClose();
        showSignoutConfirmation();
    }
    function handleNotificationClick() {
        handleClose();
        navigate(notificationHref);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($4d34bf1fa9080e8b$var$StyledButton, {
                id: "user-menu",
                "aria-haspopup": "true",
                "aria-expanded": anchorEl ? 'true' : 'false',
                onClick: handleClick,
                onMouseOver: handleClick,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30af349a5a5f3e57$export$2e2bcd8739ae039), {
                        children: t('common:account.menu')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                        size: 30,
                        name: "user"
                    }),
                    unreadNotifications.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4d34bf1fa9080e8b$var$NotificationIndicator, {
                        "aria-hidden": "true"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                closeAfterTransition: false,
                "aria-labelledby": "user-menu",
                anchorEl: anchorEl,
                open: Boolean(anchorEl),
                onClose: handleClose,
                MenuListProps: {
                    onMouseLeave: handleClose
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($4d34bf1fa9080e8b$var$StyledMenuItem, {
                        onClick: ()=>setShowLocalizationDialog(true),
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                name: "globe",
                                size: 20
                            }),
                            t('common:localization.titleShort')
                        ]
                    }),
                    isAuthenticated && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            isEmailVerified && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($4d34bf1fa9080e8b$var$StyledMenuItem, {
                                        onClick: handleNotificationClick,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                name: "alert",
                                                size: 20
                                            }),
                                            t('common:notifications.title')
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($4d34bf1fa9080e8b$var$StyledMenuItem, {
                                        onClick: handleSettingsClick,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                name: "settings",
                                                size: 20
                                            }),
                                            t('common:account.settings')
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($4d34bf1fa9080e8b$var$SignOutMenuItem, {
                                onClick: skipConfirmation ? signout : handleLogoutClick,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                        name: "logout"
                                    }),
                                    t('common:account.signout.title')
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ccbc7a02b152347e$export$2e2bcd8739ae039), {
                open: showLocalizationDialog,
                onClose: ()=>setShowLocalizationDialog(false)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
                open: isSignOutConfirmationVisible,
                onCancel: hideSignoutConfirmation,
                title: t('common:account.signout.question'),
                description: t('common:account.signout.description'),
                onConfirm: signout,
                confirmButtonText: t('common:account.signout.confirm'),
                cancelButtonText: t('common:cancel')
            })
        ]
    });
}
const $4d34bf1fa9080e8b$var$StyledMenuItem = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $3bdbe9250415b022$export$2e2bcd8739ae039))`
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 300;
    font-size: 0.875rem; // 14px
    line-height: 1.1rem; // 18px
    letter-spacing: 0.03rem;
    &:hover {
        color: ${(props)=>props.theme.color.accent};
        text-decoration: underline;
    }
`;
const $4d34bf1fa9080e8b$var$SignOutMenuItem = (0, $8de346382d86c747$export$2e2bcd8739ae039)($4d34bf1fa9080e8b$var$StyledMenuItem)`
    margin-top: 1rem;
    padding-top: 0.5rem;
    border-top: 1px solid ${(props)=>props.theme.input.border};
`;
const $4d34bf1fa9080e8b$var$StyledButton = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $45be1777d6a28263$export$2e2bcd8739ae039))`
    color: ${(props)=>props.theme.color.text};
    ${(0, $19e0bc52fddd02b4$export$87f1b08a59e6d1dd)}
`;
const $4d34bf1fa9080e8b$var$NotificationIndicator = (0, $8de346382d86c747$export$2e2bcd8739ae039).span`
    position: absolute;
    top: 5px;
    right: 5px;
    width: 10px;
    height: 10px;
    background-color: ${(props)=>props.theme.color.link};
    border-radius: 50%;
    pointer-events: none; /* Ensure it doesn't interfere with clicks */
`;






function $e4b0152a6024286a$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $b341816979fee99b$export$1e86fd0e1db89578), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $b341816979fee99b$export$8e6b12661156fe2f), {
                href: "#/",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $41158ab2c4dff680$export$2e2bcd8739ae039), {
                        width: 125
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30af349a5a5f3e57$export$2e2bcd8739ae039), {
                        children: t('common:home.title')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b341816979fee99b$export$eddf54ea3db8d0f0), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d34bf1fa9080e8b$export$2e2bcd8739ae039), {
                    settingsHref: '../my-account',
                    notificationHref: '../notifications'
                })
            })
        ]
    });
}








var $7fPBF = parcelRequire("7fPBF");
const $b1f35a815c258980$var$useReduceMotion = ()=>{
    const [isReducedMotion, setIsReducedMotion] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        const handleReduceMotionChange = ()=>{
            setIsReducedMotion(mediaQuery.matches);
        };
        handleReduceMotionChange();
        mediaQuery.addEventListener('change', handleReduceMotionChange);
        return ()=>{
            mediaQuery.removeEventListener('change', handleReduceMotionChange);
        };
    }, []);
    return isReducedMotion;
};
var $b1f35a815c258980$export$2e2bcd8739ae039 = $b1f35a815c258980$var$useReduceMotion;



function $546e295734ca2def$export$2e2bcd8739ae039({ scrollToId: scrollToId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const isReducedMotion = (0, $b1f35a815c258980$export$2e2bcd8739ae039)();
    const handleClick = ()=>{
        const element = document.getElementById(scrollToId);
        if (element) {
            element.focus();
            element.scrollIntoView({
                behavior: isReducedMotion ? 'instant' : 'smooth'
            });
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($546e295734ca2def$var$SkipToMainLink, {
        onClick: handleClick,
        children: t('common:skipToMain')
    });
}
const $546e295734ca2def$var$SkipToMainLink = (0, $8de346382d86c747$export$2e2bcd8739ae039).button`
    position: absolute;
    top: -40px;
    left: 0;
    background: ${({ theme: theme })=>theme.color.text};
    color: ${({ theme: theme })=>theme.color.background};
    padding: 0.5rem 1rem;
    z-index: 100;
    text-decoration: none;
    font-weight: 700;
    transition: top 0.3s;
    &:focus {
        top: 0;
    }
`;


function $2bae683e05e61603$export$2e2bcd8739ae039({ children: children, headerContent: headerContent, offset: offset = 0 }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fcaddb9c30332041$export$a14e0b54e46f6871), {
        $offset: offset,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $546e295734ca2def$export$2e2bcd8739ae039), {
                scrollToId: (0, $14e4f1609944ac39$export$18d6475ce2e9bfe8)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$d6b9c1bba5ee845), {
                children: headerContent
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$5b061f6699ff1c06), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$2264cf7efee465f9), {
                    id: (0, $14e4f1609944ac39$export$18d6475ce2e9bfe8),
                    tabIndex: -1,
                    children: children
                })
            })
        ]
    });
}


parcelRequire("7fPBF");
function $d308289446e38196$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2bae683e05e61603$export$2e2bcd8739ae039), {
        headerContent: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4b0152a6024286a$export$2e2bcd8739ae039), {}),
        children: children
    });
}







var $7fPBF = parcelRequire("7fPBF");

const $fdf6d68b1a7a3435$var$TokenRefresher = ()=>{
    const authContainer = (0, $455682785eac4c5b$export$2e2bcd8739ae039).useContainer();
    const currentUserContainer = (0, $8a1185b15e8317ab$export$2e2bcd8739ae039).useContainer();
    const REFRESH_MS = 1500000; // 25 mins
    (0, $7fPBF.useEffect)(()=>{
        const interval = setInterval(async ()=>{
            if (!authContainer.isLoadingRef.current) {
                await authContainer.getNewToken();
                await currentUserContainer.loadUserLicenseAccess();
                (0, $e7df95de73caec26$export$89b472e03be495df)('force-reconnect');
            }
        }, REFRESH_MS);
        return ()=>clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {});
};
var $fdf6d68b1a7a3435$export$2e2bcd8739ae039 = $fdf6d68b1a7a3435$var$TokenRefresher;








var $7fPBF = parcelRequire("7fPBF");










var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");


'use client';
/**
 * The basic building block for creating custom snackbar.
 *
 * Demos:
 *
 * - [Snackbar](https://mui.com/base-ui/react-snackbar/#hook)
 *
 * API:
 *
 * - [useSnackbar API](https://mui.com/base-ui/react-snackbar/hooks-api/#use-snackbar)
 */ function $fbecd6c36e5e044e$var$useSnackbar(parameters = {}) {
    const { autoHideDuration: autoHideDuration = null, disableWindowBlurListener: disableWindowBlurListener = false, onClose: onClose, open: open, resumeHideDuration: resumeHideDuration } = parameters;
    const timerAutoHide = (0, $9a1088a9a7141b09$export$2e2bcd8739ae039)();
    $7fPBF.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) {
                if (nativeEvent.key === 'Escape') // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                onClose?.(nativeEvent, 'escapeKeyDown');
            }
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    const handleClose = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, reason)=>{
        onClose?.(event, reason);
    });
    const setAutoHideTimer = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        timerAutoHide.start(autoHideDurationParam, ()=>{
            handleClose(null, 'timeout');
        });
    });
    $7fPBF.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return timerAutoHide.clear;
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer,
        timerAutoHide
    ]);
    const handleClickAway = (event)=>{
        onClose?.(event, 'clickaway');
    };
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = timerAutoHide.clear;
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $7fPBF.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const createHandleBlur = (otherHandlers)=>(event)=>{
            const onBlurCallback = otherHandlers.onBlur;
            onBlurCallback?.(event);
            handleResume();
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            const onFocusCallback = otherHandlers.onFocus;
            onFocusCallback?.(event);
            handlePause();
        };
    const createMouseEnter = (otherHandlers)=>(event)=>{
            const onMouseEnterCallback = otherHandlers.onMouseEnter;
            onMouseEnterCallback?.(event);
            handlePause();
        };
    const createMouseLeave = (otherHandlers)=>(event)=>{
            const onMouseLeaveCallback = otherHandlers.onMouseLeave;
            onMouseLeaveCallback?.(event);
            handleResume();
        };
    $7fPBF.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener('focus', handleResume);
            window.addEventListener('blur', handlePause);
            return ()=>{
                window.removeEventListener('focus', handleResume);
                window.removeEventListener('blur', handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        open,
        handleResume,
        handlePause
    ]);
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = {
            ...(0, $7a075a443b93da2d$export$2e2bcd8739ae039)(parameters),
            ...(0, $7a075a443b93da2d$export$2e2bcd8739ae039)(externalProps)
        };
        return {
            // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            // See https://github.com/mui/material-ui/issues/29080
            role: 'presentation',
            ...externalProps,
            ...externalEventHandlers,
            onBlur: createHandleBlur(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onMouseEnter: createMouseEnter(externalEventHandlers),
            onMouseLeave: createMouseLeave(externalEventHandlers)
        };
    };
    return {
        getRootProps: getRootProps,
        onClickAway: handleClickAway
    };
}
var $fbecd6c36e5e044e$export$2e2bcd8739ae039 = $fbecd6c36e5e044e$var$useSnackbar;



var $7fPBF = parcelRequire("7fPBF");



'use client';
// TODO: return `EventHandlerName extends `on${infer EventName}` ? Lowercase<EventName> : never` once generatePropTypes runs with TS 4.1
function $feb114cb8fcb331a$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $feb114cb8fcb331a$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://v6.mui.com/material-ui/react-click-away-listener/)
 * - [Menu](https://v6.mui.com/material-ui/react-menu/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://v6.mui.com/material-ui/api/click-away-listener/)
 */ function $feb114cb8fcb331a$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = 'onClick', onClickAway: onClickAway, touchEvent: touchEvent = 'onTouchEnd' } = props;
    const movedRef = $7fPBF.useRef(false);
    const nodeRef = $7fPBF.useRef(null);
    const activatedRef = $7fPBF.useRef(false);
    const syntheticEventRef = $7fPBF.useRef(false);
    $7fPBF.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)((0, $8971fd60a8b100cf$export$2e2bcd8739ae039)(children), nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || 'clientX' in event && $feb114cb8fcb331a$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().includes(nodeRef.current);
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $7fPBF.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $feb114cb8fcb331a$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $7fPBF.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $feb114cb8fcb331a$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ $7fPBF.cloneElement(children, childrenProps);
}








var $7fPBF = parcelRequire("7fPBF");










function $58be9cb10f53ed84$export$def81488db1a3216(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiSnackbarContent', slot);
}
const $58be9cb10f53ed84$var$snackbarContentClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiSnackbarContent', [
    'root',
    'message',
    'action'
]);
var $58be9cb10f53ed84$export$2e2bcd8739ae039 = $58be9cb10f53ed84$var$snackbarContentClasses;



'use client';
const $7f3b829aa55dc1b3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        action: [
            'action'
        ],
        message: [
            'message'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $58be9cb10f53ed84$export$def81488db1a3216), classes);
};
const $7f3b829aa55dc1b3$var$SnackbarContentRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: 'MuiSnackbarContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const emphasis = theme.palette.mode === 'light' ? 0.8 : 0.98;
    const backgroundColor = (0, $4afad3ab73a4d920$export$e665714f76e581fd)(theme.palette.background.default, emphasis);
    return {
        ...theme.typography.body2,
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(backgroundColor),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : backgroundColor,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        flexGrow: 1,
        [theme.breakpoints.up('sm')]: {
            flexGrow: 'initial',
            minWidth: 288
        }
    };
}));
const $7f3b829aa55dc1b3$var$SnackbarContentMessage = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0'
});
const $7f3b829aa55dc1b3$var$SnackbarContentAction = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: 16,
    marginRight: -8
});
const $7f3b829aa55dc1b3$var$SnackbarContent = /*#__PURE__*/ $7fPBF.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSnackbarContent'
    });
    const { action: action, className: className, message: message, role: role = 'alert', ...other } = props;
    const ownerState = props;
    const classes = $7f3b829aa55dc1b3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7f3b829aa55dc1b3$var$SnackbarContentRoot, {
        role: role,
        square: true,
        elevation: 6,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7f3b829aa55dc1b3$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7f3b829aa55dc1b3$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    });
});
var $7f3b829aa55dc1b3$export$2e2bcd8739ae039 = $7f3b829aa55dc1b3$var$SnackbarContent;




function $4645864a9a0034f9$export$6cb096457f5926f4(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiSnackbar', slot);
}
const $4645864a9a0034f9$var$snackbarClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiSnackbar', [
    'root',
    'anchorOriginTopCenter',
    'anchorOriginBottomCenter',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft'
]);
var $4645864a9a0034f9$export$2e2bcd8739ae039 = $4645864a9a0034f9$var$snackbarClasses;




'use client';
const $ac8294fb74a722b7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            'root',
            `anchorOrigin${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(anchorOrigin.vertical)}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $4645864a9a0034f9$export$6cb096457f5926f4), classes);
};
const $ac8294fb74a722b7$var$SnackbarRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiSnackbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.anchorOrigin.vertical)}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: 'fixed',
        display: 'flex',
        left: 8,
        right: 8,
        justifyContent: 'center',
        alignItems: 'center',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top',
                style: {
                    top: 8,
                    [theme.breakpoints.up('sm')]: {
                        top: 24
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical !== 'top',
                style: {
                    bottom: 8,
                    [theme.breakpoints.up('sm')]: {
                        bottom: 24
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.horizontal === 'left',
                style: {
                    justifyContent: 'flex-start',
                    [theme.breakpoints.up('sm')]: {
                        left: 24,
                        right: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.horizontal === 'right',
                style: {
                    justifyContent: 'flex-end',
                    [theme.breakpoints.up('sm')]: {
                        right: 24,
                        left: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.horizontal === 'center',
                style: {
                    [theme.breakpoints.up('sm')]: {
                        left: '50%',
                        right: 'auto',
                        transform: 'translateX(-50%)'
                    }
                }
            }
        ]
    })));
const $ac8294fb74a722b7$var$Snackbar = /*#__PURE__*/ $7fPBF.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSnackbar'
    });
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: 'bottom',
        horizontal: 'left'
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, ClickAwayListenerProps: ClickAwayListenerPropsProp, ContentProps: ContentPropsProp, disableWindowBlurListener: disableWindowBlurListener = false, message: message, onBlur: onBlur, onClose: onClose, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, open: open, resumeHideDuration: resumeHideDuration, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter: onEnter, onExited: onExited, ...TransitionPropsProp } = {}, ...other } = props;
    const ownerState = {
        ...props,
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        TransitionComponent: TransitionComponentProp,
        transitionDuration: transitionDuration
    };
    const classes = $ac8294fb74a722b7$var$useUtilityClasses(ownerState);
    const { getRootProps: getRootProps, onClickAway: onClickAway } = (0, $fbecd6c36e5e044e$export$2e2bcd8739ae039)({
        ...ownerState
    });
    const [exited, setExited] = $7fPBF.useState(true);
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponentProp,
            ...slots
        },
        slotProps: {
            content: ContentPropsProp,
            clickAwayListener: ClickAwayListenerPropsProp,
            transition: TransitionPropsProp,
            ...slotProps
        }
    };
    const [Root, rootProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('root', {
        ref: ref,
        className: [
            classes.root,
            className
        ],
        elementType: $ac8294fb74a722b7$var$SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState
    });
    const [ClickAwaySlot, { ownerState: clickAwayOwnerStateProp, ...clickAwayListenerProps }] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('clickAwayListener', {
        elementType: (0, $feb114cb8fcb331a$export$58385c17fee43f89),
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                onClickAway: (...params)=>{
                    handlers.onClickAway?.(...params);
                    onClickAway(...params);
                }
            }),
        ownerState: ownerState
    });
    const [ContentSlot, contentSlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('content', {
        elementType: (0, $7f3b829aa55dc1b3$export$2e2bcd8739ae039),
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            message: message,
            action: action
        },
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $7ec2c0aa92d4d29c$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                onEnter: (...params)=>{
                    handlers.onEnter?.(...params);
                    handleEnter(...params);
                },
                onExited: (...params)=>{
                    handlers.onExited?.(...params);
                    handleExited(...params);
                }
            }),
        additionalProps: {
            appear: true,
            in: open,
            timeout: transitionDuration,
            direction: vertical === 'top' ? 'down' : 'up'
        },
        ownerState: ownerState
    });
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ClickAwaySlot, {
        ...clickAwayListenerProps,
        ...slots.clickAwayListener && {
            ownerState: clickAwayOwnerStateProp
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Root, {
            ...rootProps,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TransitionSlot, {
                ...transitionProps,
                children: children || /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ContentSlot, {
                    ...contentSlotProps
                })
            })
        })
    });
});
var $ac8294fb74a722b7$export$2e2bcd8739ae039 = $ac8294fb74a722b7$var$Snackbar;


function $137bd7d08cdd39ae$export$2e2bcd8739ae039({ severity: severity, message: message }) {
    if (message === '') return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($137bd7d08cdd39ae$var$ToolbarSnackbar, {
        open: true,
        anchorOrigin: {
            vertical: 'top',
            horizontal: 'right'
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c181cff0789717b3$export$2e2bcd8739ae039), {
            severity: severity,
            sx: {
                width: '100%'
            },
            children: message
        })
    });
}
const $137bd7d08cdd39ae$var$ToolbarSnackbar = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $ac8294fb74a722b7$export$2e2bcd8739ae039))`
    margin-top: 52px;
`;


function $9ee98a180c3fcf7a$export$2e2bcd8739ae039(props) {
    const alertsContainer = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            alertsContainer.error && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $137bd7d08cdd39ae$export$2e2bcd8739ae039), {
                severity: "error",
                message: alertsContainer.error
            }),
            alertsContainer.success && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $137bd7d08cdd39ae$export$2e2bcd8739ae039), {
                severity: "success",
                message: alertsContainer.success
            }),
            alertsContainer.warning && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $137bd7d08cdd39ae$export$2e2bcd8739ae039), {
                severity: "warning",
                message: alertsContainer.warning
            })
        ]
    });
}








function $020e06f09a693c51$export$133e74ed0ce62600(href) {
    if (!href) return '/';
    return href.startsWith('/') ? href : '/' + href;
}
function $020e06f09a693c51$export$2e2bcd8739ae039(href) {
    const location = (0, $5ec159caebd3ae22$export$45d76561a5302f2b)();
    const correctedHref = $020e06f09a693c51$export$133e74ed0ce62600(href);
    return {
        startMatch: location.pathname.startsWith(correctedHref),
        exactMatch: location.pathname === correctedHref,
        getCorrectedHref: $020e06f09a693c51$export$133e74ed0ce62600
    };
}



var $7fPBF = parcelRequire("7fPBF");







const $52f85d4476d77156$export$70c67a3f7d0c5d9 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
    text-decoration: none;

    ${(0, $19e0bc52fddd02b4$export$87f1b08a59e6d1dd)}
    &:hover,
    &:focus {
        text-decoration: underline;
    }
`;
const $52f85d4476d77156$export$a56d8f56d2a61cdc = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
    display: flex;
    align-items: center;
`;
const $52f85d4476d77156$export$b3f4db470d6087f0 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
    @media (max-width: 768px) {
        clip: rect(0 0 0 0);
        clip-path: inset(50%);
        height: 0px;
        overflow: hidden;
        position: absolute;
        white-space: nowrap;
        width: 0px;
        padding: 0;
        margin: 0;
    }
`;
const $52f85d4476d77156$export$5a9b97e708ad0766 = (0, $8de346382d86c747$export$2e2bcd8739ae039).span`
    flex-shrink: 0;
    width: 6px;
    min-width: 6px;
    max-width: 6px;
    height: 30px;
    margin: 0.25rem 0;
    background-color: ${(props)=>props.isActive ? props.theme.color.accent : 'transparent'};
`;
const $52f85d4476d77156$export$6f1fd8501043f18d = (0, $8de346382d86c747$export$2e2bcd8739ae039).span`
    ${(0, $b091aef3a32d2bd8$export$90f89b8a63d85ede)}
    padding: 0 0.25rem 0 0;
    ${$52f85d4476d77156$export$b3f4db470d6087f0}
`;








function $3825d73ff67b3ed3$export$2e2bcd8739ae039({ item: item }) {
    const { exactMatch: exactMatch } = (0, $020e06f09a693c51$export$2e2bcd8739ae039)(item.href);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $52f85d4476d77156$export$5a9b97e708ad0766), {
                isActive: exactMatch,
                isSubActive: !!item.activeSub
            }),
            item.href ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3825d73ff67b3ed3$var$MenuItemLink, {
                id: item.id,
                role: "menuitem",
                to: item.href,
                target: item.target,
                viewTransition: true,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($3825d73ff67b3ed3$var$MenuLabel, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                            name: item.icon,
                            size: 24
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $52f85d4476d77156$export$6f1fd8501043f18d), {
                            children: item.label
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($3825d73ff67b3ed3$var$MenuLabel, {
                id: item.id,
                role: "menuitem",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                        name: item.icon,
                        size: 24
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $52f85d4476d77156$export$6f1fd8501043f18d), {
                        children: item.label
                    })
                ]
            })
        ]
    });
}
const $3825d73ff67b3ed3$var$MenuLabel = (0, $8de346382d86c747$export$2e2bcd8739ae039).span`
    ${(0, $52f85d4476d77156$export$a56d8f56d2a61cdc)}
    gap: 0.5rem;
    justify-items: center;
`;
const $3825d73ff67b3ed3$var$MenuItemLink = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $5ec159caebd3ae22$export$b0d92dbee9b5b60d))`
    ${(0, $52f85d4476d77156$export$70c67a3f7d0c5d9)}
    padding:0 0.5rem;
    flex: 1;
    color: inherit;
    justify-self: center;
    &.active {
        color: ${(props)=>props.theme.color.accent};
    }
`;







function $d3cd096afaede658$export$2e2bcd8739ae039({ subItem: subItem }) {
    const { startMatch: startMatch, exactMatch: exactMatch } = (0, $020e06f09a693c51$export$2e2bcd8739ae039)(subItem.href);
    const isActive = !subItem.activeStateMatchCriteria || subItem.activeStateMatchCriteria == 'start' ? startMatch : exactMatch;
    const matchUrlExactly = subItem.activeStateMatchCriteria == 'exact' || subItem.activeStateMatchCriteria == 'end';
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d3cd096afaede658$var$SubmenuItem, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d3cd096afaede658$var$SubMenuActiveBar, {
                isActive: isActive,
                isSubActive: false
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d3cd096afaede658$var$SubmenuLink, {
                to: subItem.href,
                role: "menuitem",
                end: matchUrlExactly,
                viewTransition: true,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $52f85d4476d77156$export$6f1fd8501043f18d), {
                    children: subItem.label
                })
            })
        ]
    });
}
const $d3cd096afaede658$var$SubmenuItem = (0, $8de346382d86c747$export$2e2bcd8739ae039).span`
    ${(0, $52f85d4476d77156$export$a56d8f56d2a61cdc)}
    padding: 0 0 0 0px;
    &:hover,
    &:focus {
        background-color: ${(props)=>props.theme.banner.accent.background};
        outline: none;
    }
`;
const $d3cd096afaede658$var$SubmenuLink = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $5ec159caebd3ae22$export$b0d92dbee9b5b60d))`
    ${(0, $52f85d4476d77156$export$70c67a3f7d0c5d9)}
    padding: 1rem 0.5rem 1rem 40px;
    font-size: 14px;
    color: ${(props)=>props.theme.color.text};
    &.active {
        color: ${(props)=>props.theme.color.accent};
    }
`;
const $d3cd096afaede658$var$SubMenuActiveBar = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $52f85d4476d77156$export$5a9b97e708ad0766))``;


function $2eb3a8db99bc4b3a$export$2e2bcd8739ae039({ topMenuItems: topMenuItems, bottomMenuItems: bottomMenuItems }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const location = (0, $5ec159caebd3ae22$export$45d76561a5302f2b)();
    const [openMenus, setOpenMenus] = (0, $7fPBF.useState)({});
    const [manualToggles, setManualToggles] = (0, $7fPBF.useState)({});
    // Automatically open menus based on location.pathname, respecting manual toggles
    (0, $7fPBF.useEffect)(()=>{
        const updatedOpenMenus = {
            ...openMenus
        };
        [
            ...topMenuItems,
            ...bottomMenuItems
        ].forEach((item)=>{
            if (item.submenu) {
                const correctedHref = (0, $020e06f09a693c51$export$133e74ed0ce62600)(item.href);
                if (location.pathname.startsWith(correctedHref)) {
                    updatedOpenMenus[item.label] = true;
                    manualToggles[item.label] = true;
                }
            }
        });
        setOpenMenus(updatedOpenMenus);
    }, [
        location.pathname,
        topMenuItems,
        bottomMenuItems
    ]);
    const toggleMenu = (label)=>{
        setManualToggles((prevState)=>({
                ...prevState,
                [label]: !prevState[label]
            }));
        setOpenMenus((prevState)=>({
                ...prevState,
                [label]: !prevState[label]
            }));
    };
    const checkActiveSub = (item)=>{
        return openMenus[item.label] || false;
    };
    const renderMenuItems = (menuItems)=>{
        return menuItems.map((item, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($2eb3a8db99bc4b3a$var$MenuItemWrapper, {
                role: "none",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($2eb3a8db99bc4b3a$var$MenuItemContainer, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3825d73ff67b3ed3$export$2e2bcd8739ae039), {
                                item: item
                            }),
                            item.submenu && !item.activeSub && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2eb3a8db99bc4b3a$var$ExpandButton, {
                                    role: "menuitem",
                                    "aria-expanded": checkActiveSub(item),
                                    "aria-haspopup": "true",
                                    "aria-label": t('common:menu.expand'),
                                    onClick: ()=>toggleMenu(item.label),
                                    children: "\u25BE"
                                })
                            })
                        ]
                    }),
                    item.submenu && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2eb3a8db99bc4b3a$var$Submenu, {
                        role: "menu",
                        isOpen: checkActiveSub(item),
                        children: item.submenu.map((subItem, subIndex)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d3cd096afaede658$export$2e2bcd8739ae039), {
                                subItem: subItem
                            }, subIndex))
                    })
                ]
            }, index));
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($2eb3a8db99bc4b3a$var$SidebarNav, {
        "aria-label": "Sidebar Navigation",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2eb3a8db99bc4b3a$var$TopSection, {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2eb3a8db99bc4b3a$var$MenuList, {
                    role: "menubar",
                    children: renderMenuItems(topMenuItems)
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2eb3a8db99bc4b3a$var$BottomSection, {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2eb3a8db99bc4b3a$var$MenuList, {
                    role: "menubar",
                    children: renderMenuItems(bottomMenuItems)
                })
            })
        ]
    });
}
// Styled Components
const $2eb3a8db99bc4b3a$var$TopSection = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    scrollbar-width: none;
    margin-bottom: auto;
`;
const $2eb3a8db99bc4b3a$var$BottomSection = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    width: 100%;
    display: flex;
    flex-direction: column;
    border-top: 1px solid ${(props)=>props.theme.color.sidebarDivider};
`;
const $2eb3a8db99bc4b3a$var$SidebarNav = (0, $8de346382d86c747$export$2e2bcd8739ae039).nav`
    max-width: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-right: 1px solid ${(props)=>props.theme.color.sidebarDivider};
`;
const $2eb3a8db99bc4b3a$var$MenuList = (0, $8de346382d86c747$export$2e2bcd8739ae039).ul`
    list-style: none;
    margin: 0;
    padding: 0;
`;
const $2eb3a8db99bc4b3a$var$MenuItemWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).li``;
const $2eb3a8db99bc4b3a$var$MenuItemContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    padding: 0.75rem 0 0 0;
    display: flex;
    align-items: center;
    background: none;
    text-align: left;
    font-size: 16px;
    color: ${(props)=>props.theme.color.text};
    &:hover,
    &:focus {
        background-color: ${(props)=>props.theme.banner.accent.background};
        outline: none;
    }

    ${(0, $19e0bc52fddd02b4$export$87f1b08a59e6d1dd)}
`;
const $2eb3a8db99bc4b3a$var$ExpandButton = (0, $8de346382d86c747$export$2e2bcd8739ae039).button`
    margin-left: auto;
    height: 30px;
    min-width: 30px;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 16px;
    color: inherit;
    &:hover,
    &:focus {
        outline: none;
    }

    transform: rotate(0deg);
    transition: transform 0.3s ease-in-out;

    &[aria-expanded='true'] {
        transform: rotate(180deg);
        ${(0, $19e0bc52fddd02b4$export$87f1b08a59e6d1dd)}
    }
    ${(0, $52f85d4476d77156$export$b3f4db470d6087f0)}
`;
const $2eb3a8db99bc4b3a$var$Submenu = (0, $8de346382d86c747$export$2e2bcd8739ae039).ul`
    list-style: none;
    margin: 0;
    padding: 0;
    display: ${(props)=>props.isOpen ? 'block' : 'none'};
    padding-bottom: 20px;
    ${(0, $52f85d4476d77156$export$b3f4db470d6087f0)}
`;





var $7fPBF = parcelRequire("7fPBF");

const $ff0a0decfce0b174$var$ScrollToTop = ()=>{
    const location = (0, $5ec159caebd3ae22$export$45d76561a5302f2b)();
    (0, $7fPBF.useEffect)(()=>{
        setTimeout(()=>{
            const contentElement = document.getElementById((0, $14e4f1609944ac39$export$18d6475ce2e9bfe8));
            if (contentElement) contentElement.scrollTop = 0;
            else window.scrollTo(0, 0);
        }, 100); // timeout due to view transitions
    }, [
        location
    ]);
    return null;
};
var $ff0a0decfce0b174$export$2e2bcd8739ae039 = $ff0a0decfce0b174$var$ScrollToTop;



function $064a5b98a9970d8a$export$2e2bcd8739ae039({ isLoading: isLoading, headerContent: headerContent, topItems: topItems = [], bottomItems: bottomItems = [], managed: managed = false, children: children, offset: offset = 0 }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fcaddb9c30332041$export$a14e0b54e46f6871), {
        $offset: offset,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $546e295734ca2def$export$2e2bcd8739ae039), {
                scrollToId: (0, $14e4f1609944ac39$export$18d6475ce2e9bfe8)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$d6b9c1bba5ee845), {
                children: headerContent
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fcaddb9c30332041$export$5b061f6699ff1c06), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9ee98a180c3fcf7a$export$2e2bcd8739ae039), {}),
                    isLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {
                        text: t('common:authenticating'),
                        refreshButton: true
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2eb3a8db99bc4b3a$export$2e2bcd8739ae039), {
                                topMenuItems: topItems,
                                bottomMenuItems: bottomItems
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fcaddb9c30332041$export$2264cf7efee465f9), {
                                id: (0, $14e4f1609944ac39$export$18d6475ce2e9bfe8),
                                tabIndex: -1,
                                "data-managed": !!managed,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ff0a0decfce0b174$export$2e2bcd8739ae039), {}),
                                    children
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}






var $7fPBF = parcelRequire("7fPBF");





parcelRequire("7fPBF");


'use client';
var $4f4e3692f5c75417$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');


parcelRequire("7fPBF");


'use client';
var $dc941e595b205c8e$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');


parcelRequire("7fPBF");


'use client';
var $d54af422e767409d$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');






function $5350254b5a4e1ee2$export$6c57c6e16b4063b(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiCheckbox', slot);
}
const $5350254b5a4e1ee2$var$checkboxClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $5350254b5a4e1ee2$export$2e2bcd8739ae039 = $5350254b5a4e1ee2$var$checkboxClasses;









'use client';
const $4d99e6d55ec7d57a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $5350254b5a4e1ee2$export$6c57c6e16b4063b), classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const $4d99e6d55ec7d57a$var$CheckboxRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $69935e2350f58c79$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $0820e164eb5fbaff$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        variants: [
            {
                props: {
                    color: 'default',
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $061b5988a3817e26$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $061b5988a3817e26$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $5350254b5a4e1ee2$export$2e2bcd8739ae039).checked}, &.${(0, $5350254b5a4e1ee2$export$2e2bcd8739ae039).indeterminate}`]: {
                            color: (theme.vars || theme).palette[color].main
                        },
                        [`&.${(0, $5350254b5a4e1ee2$export$2e2bcd8739ae039).disabled}`]: {
                            color: (theme.vars || theme).palette.action.disabled
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
const $4d99e6d55ec7d57a$var$defaultCheckedIcon = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dc941e595b205c8e$export$2e2bcd8739ae039), {});
const $4d99e6d55ec7d57a$var$defaultIcon = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f4e3692f5c75417$export$2e2bcd8739ae039), {});
const $4d99e6d55ec7d57a$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d54af422e767409d$export$2e2bcd8739ae039), {});
const $4d99e6d55ec7d57a$var$Checkbox = /*#__PURE__*/ $7fPBF.forwardRef(function Checkbox(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $4d99e6d55ec7d57a$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $4d99e6d55ec7d57a$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $4d99e6d55ec7d57a$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = 'medium', disableRipple: disableRipple = false, className: className, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = {
        ...props,
        disableRipple: disableRipple,
        color: color,
        indeterminate: indeterminate,
        size: size
    };
    const classes = $4d99e6d55ec7d57a$var$useUtilityClasses(ownerState);
    const externalInputProps = slotProps.input ?? inputProps;
    const [RootSlot, rootSlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $4d99e6d55ec7d57a$var$CheckboxRoot,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            type: 'checkbox',
            icon: /*#__PURE__*/ $7fPBF.cloneElement(icon, {
                fontSize: icon.props.fontSize ?? size
            }),
            checkedIcon: /*#__PURE__*/ $7fPBF.cloneElement(indeterminateIcon, {
                fontSize: indeterminateIcon.props.fontSize ?? size
            }),
            disableRipple: disableRipple,
            slots: slots,
            slotProps: {
                input: (0, $4ae0554ab82ec1b4$export$2e2bcd8739ae039)(typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps, {
                    'data-indeterminate': indeterminate
                })
            }
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(RootSlot, {
        ...rootSlotProps,
        classes: classes
    });
});
var $4d99e6d55ec7d57a$export$2e2bcd8739ae039 = $4d99e6d55ec7d57a$var$Checkbox;






var $7fPBF = parcelRequire("7fPBF");




function $c6b91e65655da099$export$2e2bcd8739ae039({ open: open, tosConfig: tosConfig, onAccepted: onAccepted }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const theme = (0, $d62c6f18f523e962$export$3b14a55fb2447963)();
    const [isSubmitting, setIsSubmitting] = (0, $7fPBF.useState)(false);
    const [hasError, setHasError] = (0, $7fPBF.useState)(false);
    const [hasAcceptedTerms, setHasAcceptedTerms] = (0, $7fPBF.useState)(false);
    const handleAccept = async ()=>{
        setIsSubmitting(true);
        setHasError(false);
        try {
            const result = await $1a4c36336f303477$export$c2c1fd00af0fe210({
                version: tosConfig.requiredVersion,
                // IP address is intentionally left empty; the server infers it from the request
                ipAddress: ''
            });
            if (result?.resultType === 'Ok') onAccepted();
            else setHasError(true);
        } catch (e) {
            console.error('Failed to accept TOS', e);
            setHasError(true);
        } finally{
            setIsSubmitting(false);
        }
    };
    const formattedDate = tosConfig.effectiveDate ? new Date(tosConfig.effectiveDate).toLocaleDateString() : '';
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7f096abd658f7c85$export$2e2bcd8739ae039), {
        open: open,
        disableEscapeKeyDown: true,
        sx: {
            '& .MuiPaper-root': {
                borderStyle: 'solid',
                borderWidth: '1px',
                borderColor: theme.color.border,
                background: theme.color.background
            }
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $082accbd174d656b$export$6f975883ded828a4), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($c6b91e65655da099$var$TitleRow, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $082accbd174d656b$export$a821680a90fed6), {
                            children: t('common:tos.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d34bf1fa9080e8b$export$2e2bcd8739ae039), {
                            settingsHref: "#",
                            notificationHref: "#",
                            skipConfirmation: false
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $082accbd174d656b$export$5a0bc68f6657e9db), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$174d4944f63edcc7), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                            children: t('common:tos.description')
                        }),
                        formattedDate && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                            children: t('common:tos.effectiveDate', {
                                date: formattedDate
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                            $size: "small",
                            href: "https://cephable.com/terms-of-use/",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: t('common:tos.viewInBrowser')
                        }),
                        hasError && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                            children: t('common:tos.loadError')
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$b54ac9d7963ef6f6), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d99e6d55ec7d57a$export$2e2bcd8739ae039), {
                            checked: hasAcceptedTerms,
                            onChange: (e)=>setHasAcceptedTerms(e.target.checked)
                        }),
                        label: t('common:tos.acceptCheckbox')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        $size: "small",
                        $color: "secondary",
                        onClick: handleAccept,
                        disabled: isSubmitting || !hasAcceptedTerms,
                        children: t('common:tos.accept')
                    })
                ]
            })
        ]
    });
}
const $c6b91e65655da099$var$TitleRow = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 1rem;
`;








var $7fPBF = parcelRequire("7fPBF");
function $f17ba869eb5b6a67$export$bdf7755e6d5d402a() {
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(true);
    const authContainer = (0, $455682785eac4c5b$export$2e2bcd8739ae039).useContainer();
    const currentUserContainer = (0, $8a1185b15e8317ab$export$2e2bcd8739ae039).useContainer();
    const organizationContainer = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const alertContainer = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    (0, $7fPBF.useEffect)(()=>{
        const initialize = async ()=>{
            try {
                const userResult = await currentUserContainer.loadCurrentUser();
                if (userResult?.resultType === 'Ok') await currentUserContainer.checkAndUpdatePendingTos();
                await currentUserContainer.loadUserLicenseAccess();
                await organizationContainer.initializeFromRemote();
            } catch (error) {
                alertContainer.showError('Error initializing data');
            } finally{
                setIsLoading(false);
            }
        };
        if (currentUserContainer.currentUser === null && authContainer.isAuthenticated === true) initialize();
    }, [
        currentUserContainer.currentUser,
        authContainer.isAuthenticated
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (authContainer.isAuthenticated && currentUserContainer.currentUser && !organizationContainer.loading) setIsLoading(false);
    }, [
        authContainer.isAuthenticated,
        currentUserContainer.currentUser,
        organizationContainer.loading
    ]);
    return {
        isLoading: isLoading
    };
}


function $d0493a8b121d95e9$export$3aa18b5a5694efe6(organization) {
    if (organization.isDeveloperAccess) return 'sdk';
    if (organization.isEmployeeAccess) return 'orgCompany';
    if (organization.isStudentAccess) return 'library';
    if (organization.isReseller) return 'globe';
    if (organization.isPlusAccess) return 'plusLight';
    return 'orgCompany';
}





var $7fPBF = parcelRequire("7fPBF");

function $d248d2e07e495df9$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { memberships: memberships } = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const { currentUser: currentUser, isLicenseExpired: isLicenseExpired } = (0, $8a1185b15e8317ab$export$2e2bcd8739ae039).useContainer();
    const [topItems, setTopItems] = (0, $7fPBF.useState)([]);
    const [bottomItems, setBottomItems] = (0, $7fPBF.useState)([]);
    const getSubmenuItems = (membership)=>{
        let subMenu = [];
        const isOrgMultipleMembers = (membership.organization.maxMembers ?? 0) > 1;
        const originatedByOrganizationId = membership.organization.originatedByOrganizationId;
        const isManagedOrganization = originatedByOrganizationId != undefined && originatedByOrganizationId != null && originatedByOrganizationId.length > 0;
        // User is one of many members of an organization
        if (isOrgMultipleMembers || isManagedOrganization) subMenu = [
            ...membership.canViewMembers || membership.isAdmin ? [
                {
                    label: t('common:organization.member.titlePlural'),
                    href: `org/${membership.organization.id}/members`,
                    activeStateMatchCriteria: 'end'
                }
            ] : [],
            ...membership.canInviteMembers || membership.isAdmin ? [
                {
                    label: t('common:organization.invite.titlePlural'),
                    href: `org/${membership.organization.id}/members/invites`,
                    activeStateMatchCriteria: 'end'
                }
            ] : [],
            // {
            //     label: t('common:organization.metrics.title'),
            //     href: `org/${membership.organization.id}/metrics`,
            // },
            ...membership.canAccessOrganizationProfiles || membership.canEditOrganizationProfiles || membership.isAdmin ? [
                {
                    label: t('common:organization.profiles.titleShort'),
                    href: `org/${membership.organization.id}/profiles`
                }
            ] : [],
            ...membership.organization.isReseller && (membership.canManageChildOrganizations || membership.isAdmin) ? [
                {
                    label: t('common:organization.managed.title'),
                    href: `org/${membership.organization.id}/managed`
                },
                {
                    label: t('common:license.key.title'),
                    href: `org/${membership.organization.id}/licensekey`
                },
                {
                    label: t('common:license.key.product.title'),
                    href: `org/${membership.organization.id}/purchase`
                }
            ] : [],
            ...membership.canCreateAuthClients || membership.canViewAuthClients || membership.isAdmin ? [
                {
                    label: t('common:organization.projects.title'),
                    href: `org/${membership.organization.id}/projects`
                }
            ] : [],
            {
                label: t('common:settings.title'),
                href: `org/${membership.organization.id}/settings`
            }
        ];
        else // User is the only member of a single organization -> show direct billing
        subMenu = [
            {
                label: isLicenseExpired ? t('common:upgrade') : t('common:license.key.product.Subscription.title'),
                href: `org/${membership.organizationId}/billing/redirect/upgrade`
            }
        ];
        return subMenu;
    };
    // Helper to generate organization menu items
    const generateOrgItems = (0, $7fPBF.useCallback)(()=>{
        if (memberships.length === 0 || !currentUser?.isEmailVerified) return [];
        return memberships.map((membership)=>({
                icon: (0, $d0493a8b121d95e9$export$3aa18b5a5694efe6)(membership.organization),
                label: membership.organization.name,
                href: `org/${membership.organization.id}`,
                submenu: getSubmenuItems(membership)
            }));
    }, [
        memberships,
        t
    ]);
    // Generate default top menu items
    const generateDefaultItems = (0, $7fPBF.useCallback)(()=>[
            {
                icon: 'squaredMenu',
                label: t('common:dashboard.title'),
                href: '/'
            }
        ], [
        t
    ]);
    // Generate bottom menu items
    const generateBottomItems = (0, $7fPBF.useCallback)(()=>[
            {
                icon: 'code',
                label: t('common:developer.title'),
                href: '/developer'
            },
            {
                icon: 'help',
                label: t('common:support.title'),
                href: 'https://cephable.com/free-trial/support/'
            }
        ], [
        t
    ]);
    // Consolidated effect to set menu items
    (0, $7fPBF.useEffect)(()=>{
        setTopItems([
            ...generateDefaultItems(),
            ...generateOrgItems()
        ]);
        setBottomItems(generateBottomItems());
    }, [
        generateDefaultItems,
        generateOrgItems,
        generateBottomItems
    ]);
    return {
        topItems: topItems,
        bottomItems: bottomItems
    };
}



function $97c83f16300f0c22$export$2e2bcd8739ae039() {
    const { isLoading: isLoading } = (0, $f17ba869eb5b6a67$export$bdf7755e6d5d402a)();
    const { topItems: topItems, bottomItems: bottomItems } = (0, $d248d2e07e495df9$export$2e2bcd8739ae039)();
    const { managedOrgId: managedOrgId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const { pendingTosConfig: pendingTosConfig, setPendingTosConfig: setPendingTosConfig } = (0, $8a1185b15e8317ab$export$2e2bcd8739ae039).useContainer();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $064a5b98a9970d8a$export$2e2bcd8739ae039), {
        isLoading: isLoading,
        headerContent: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4b0152a6024286a$export$2e2bcd8739ae039), {}),
        topItems: topItems,
        bottomItems: bottomItems,
        managed: !!managedOrgId,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fcaddb9c30332041$export$6ce170286acaa8d3), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5ec159caebd3ae22$export$910ae8079b2c2852), {}),
                pendingTosConfig && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c6b91e65655da099$export$2e2bcd8739ae039), {
                    open: true,
                    tosConfig: pendingTosConfig,
                    onAccepted: ()=>setPendingTosConfig(null)
                })
            ]
        })
    });
}


function $18eb3fb4329f0ffa$export$2e2bcd8739ae039({ authRedirect: authRedirect = '../login', children: children }) {
    const { isAuthenticated: isAuthenticated, getNewToken: getNewToken, isInitializedRef: isInitializedRef, isInitialized: isInitialized } = (0, $455682785eac4c5b$export$2e2bcd8739ae039).useContainer();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const [searchParams] = (0, $5ec159caebd3ae22$export$f1a78c17382fe22a)();
    const tokenRefresh = localStorage.getItem((0, $db3063bd3b6d501e$export$f849a8e4906d2051));
    const { initializeFromRemote: initializeNotifications } = (0, $3521ff40d609c2ed$export$2e2bcd8739ae039).useContainer();
    (0, $7fPBF.useEffect)(()=>{
        if (!isAuthenticated && tokenRefresh && !isInitializedRef.current) getNewToken();
        else if (searchParams.get('code')) navigate(`../authcallback?code=${searchParams.get('code')}`, {
            replace: true,
            viewTransition: true
        });
        else if (!isAuthenticated) navigate(authRedirect, {
            replace: true,
            viewTransition: true
        });
        const unsubNavigateTo = (0, $e7df95de73caec26$export$ec068583843480e7)('navigateTo', (data)=>{
            if (data.path) {
                const url = data.params ? (0, $13d0c8a27a7be22f$export$990cf17cc7759dd4)(data.path, data.params) : data.path;
                navigate(url, {
                    replace: false,
                    viewTransition: true
                });
            }
        });
        return ()=>{
            unsubNavigateTo();
        };
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        if (!isInitialized) return;
        initializeNotifications();
        const intervalId = setInterval(()=>{
            initializeNotifications();
        }, 1800000); // 30 minutes in milliseconds
        return ()=>clearInterval(intervalId);
    }, [
        isInitialized
    ]);
    if (!isInitialized || !isAuthenticated) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fdf6d68b1a7a3435$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $97c83f16300f0c22$export$2e2bcd8739ae039), {})
        ]
    });
}



var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");



parcelRequire("7fPBF");
const $a22a182679eb182e$var$SvgFullLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 1000 300",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "full_logo_svg__linear-gradient",
                        x1: 215.09,
                        x2: 374.06,
                        y1: 61.06,
                        y2: -0.41,
                        gradientTransform: "rotate(-8.86 992.89 1045.428)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#36368b"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.07,
                                stopColor: "#563986"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.17,
                                stopColor: "#7e3d7f"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.27,
                                stopColor: "#a1407a"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.38,
                                stopColor: "#bd4376"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#d24573"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.63,
                                stopColor: "#e24670"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.78,
                                stopColor: "#eb476f"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ee486f"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "full_logo_svg__linear-gradient-2",
                        x1: -236.73,
                        x2: -283.6,
                        y1: 787.35,
                        y2: 666.15,
                        gradientTransform: "rotate(81.14 295.919 673.252)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#6db9e7"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.07,
                                stopColor: "#6ca2d7"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.16,
                                stopColor: "#6b8ac6"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.26,
                                stopColor: "#6b79ba"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.37,
                                stopColor: "#6b6fb3"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#6b6cb1"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#062844"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "full_logo_svg__luminosity-invert",
                        width: 174,
                        height: 176,
                        x: 59,
                        y: 62,
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            result: "cm",
                            values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("style", {
                        children: '.full_logo_svg__cls-7,.full_logo_svg__cls-8{stroke-width:0}.full_logo_svg__cls-10{mix-blend-mode:multiply;opacity:.2}.full_logo_svg__cls-7{fill:#fff}.full_logo_svg__cls-8{fill:#ee486f}'
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "full_logo_svg__mask",
                        width: 174,
                        height: 176,
                        x: 59,
                        y: 62,
                        maskUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                            xlinkHref: "data:image/png;base64,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",
                            width: 174,
                            height: 176,
                            style: {
                                filter: 'url(#full_logo_svg__luminosity-invert)'
                            },
                            transform: "translate(59 62)"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    isolation: 'isolate'
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    id: "full_logo_svg__Layer_1",
                    "data-name": "Layer 1",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            cx: 148,
                            cy: 150,
                            r: 90,
                            style: {
                                fill: '#fff',
                                strokeWidth: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M223.24 162.47c-2.78-9.23-10.46-11.21-15.36-10.33-1.66.3-3.14.97-4.27 1.62-.52.3-.24 1.1.36 1.02 3.54-.48 9.78-.38 12.85 5.46 1.08 2.04 5.36 10.97-8.32 18.44-7.29 3.99-15.57 2.86-19.24-2.21-2.12 1.28-4.26 2.58-6.49 3.91-5.74-8.12-13.64-5.05-17.35-2.48-.51.35-.13 1.14.46.98 3.66-.98 9.87-1.63 12.96 3.91 2.68 4.8-.64 11.5-7.02 14.77-6.38 3.27-13.98 3.66-16.23-3.36-2.6.95-5.23 1.81-7.89 2.5-2.15-8.24-8.92-8.99-12.78-7.98-.59.16-.52 1.03.09 1.08 2.79.25 6.73 1.29 8.34 5.07 1.29 3.04 1.07 10-9.87 11.38-6.2.78-12.52-1.91-12.36-7.87-2.82-.43-5.63-1.07-8.41-1.96 3-7.24-2.03-11.87-5.61-13.42-.57-.25-1.07.49-.6.9 1.8 1.62 3.86 4.21 3.77 7.5-.52 6.75-7.54 8.74-13.77 5.34-5.15-2.81-8.76-8.26-5.19-13.57-5.57-5.47-10.22-13.44-12.98-21.64-5.4-16.04 0-32.3 11.74-41.82 14.73-11.94 28.99-8.01 35.67-5.41 1.2.47.99 1.62-.37 1.34-.92-.19-2.05-.26-3.05-.32-2.37-.15-4.87 0-6.92.52-6.91 1.76-12.56 9.82-12.99 20.53.13 9.8 4.98 21.2 14.64 24.62 12.97 4.79 24.03-3.88 34.33-11.6 9.2-7.07 18.83-16.21 31.67-24.54 18.78-12.18 37.81-16.57 37.81-16.57-12.06-21.36-32.99-36.74-57.01-41.72a85.104 85.104 0 0 0-30.42-.75c-5.59.87-10.96 2.28-16.09 4.14 0 0-10.89 3.84-19.78 10.31-1 .73-2.2 1.7-3.43 2.76-1.98 1.69-.56 4.91 2.02 4.58 5.25-.68 12.3-.62 20.5 1.83 15.48 4.64 23.5 15.73 27.35 23.11 2.09 4.01-1.81 5.76-4.05 3.51-7.09-7.11-28.64-20.25-53.96-6.91-16.73 8.81-23.05 24.33-24.13 37.26-1.64 19.6 5.61 36.91 10.54 45.61 12.05 21.26 32.79 36.41 56.71 41.41a85.01 85.01 0 0 0 30.57.78c19.2-2.99 35.89-12.19 48.37-25.22a85.59 85.59 0 0 0 13.4-18.34c4.62-8.51 7.83-17.83 9.34-27.62a.976.976 0 0 0-.88-1.11c-3.77-.31-6.67.56-6.67.56Z",
                            style: {
                                strokeWidth: 0,
                                fill: 'url(#full_logo_svg__linear-gradient)'
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            style: {
                                mask: 'url(#full_logo_svg__mask)'
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M223.24 162.47c-2.78-9.23-10.46-11.21-15.36-10.33-1.66.3-3.14.97-4.27 1.62-.52.3-.24 1.1.36 1.02 3.54-.48 9.78-.38 12.85 5.46 1.08 2.04 5.36 10.97-8.32 18.44-7.29 3.99-15.57 2.86-19.24-2.21-2.12 1.28-4.26 2.58-6.49 3.91-5.74-8.12-13.64-5.05-17.35-2.48-.51.35-.13 1.14.46.98 3.66-.98 9.87-1.63 12.96 3.91 2.68 4.8-.64 11.5-7.02 14.77-6.38 3.27-13.98 3.66-16.23-3.36-2.6.95-5.23 1.81-7.89 2.5-2.15-8.24-8.92-8.99-12.78-7.98-.59.16-.52 1.03.09 1.08 2.79.25 6.73 1.29 8.34 5.07 1.29 3.04 1.07 10-9.87 11.38-6.2.78-12.52-1.91-12.36-7.87-2.82-.43-5.63-1.07-8.41-1.96 3-7.24-2.03-11.87-5.61-13.42-.57-.25-1.07.49-.6.9 1.8 1.62 3.86 4.21 3.77 7.5-.52 6.75-7.54 8.74-13.77 5.34-5.15-2.81-8.76-8.26-5.19-13.57-5.57-5.47-10.22-13.44-12.98-21.64-5.4-16.04 0-32.3 11.74-41.82 14.73-11.94 28.99-8.01 35.67-5.41 1.2.47.99 1.62-.37 1.34-.92-.19-2.05-.26-3.05-.32-2.37-.15-4.87 0-6.92.52-6.91 1.76-12.56 9.82-12.99 20.53.13 9.8 4.98 21.2 14.64 24.62 12.97 4.79 24.03-3.88 34.33-11.6 9.2-7.07 18.83-16.21 31.67-24.54 18.78-12.18 37.81-16.57 37.81-16.57-12.06-21.36-32.99-36.74-57.01-41.72a85.104 85.104 0 0 0-30.42-.75c-5.59.87-10.96 2.28-16.09 4.14 0 0-10.89 3.84-19.78 10.31-1 .73-2.2 1.7-3.43 2.76-1.98 1.69-.56 4.91 2.02 4.58 5.25-.68 12.3-.62 20.5 1.83 15.48 4.64 23.5 15.73 27.35 23.11 2.09 4.01-1.81 5.76-4.05 3.51-7.09-7.11-28.64-20.25-53.96-6.91-16.73 8.81-23.05 24.33-24.13 37.26-1.64 19.6 5.61 36.91 10.54 45.61 12.05 21.26 32.79 36.41 56.71 41.41a85.01 85.01 0 0 0 30.57.78c19.2-2.99 35.89-12.19 48.37-25.22a85.59 85.59 0 0 0 13.4-18.34c4.62-8.51 7.83-17.83 9.34-27.62a.976.976 0 0 0-.88-1.11c-3.77-.31-6.67.56-6.67.56Z",
                                className: "full_logo_svg__cls-10",
                                style: {
                                    fill: '#141728',
                                    strokeWidth: 0
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M160.51 192.18c.59 1.15 2 1.56 2.79 1.71 1.86.34 4.09-.06 6.1-1.09 3.48-1.78 5.25-4.87 4.94-6.83-.04-.27-.12-.51-.24-.75-.59-1.15-2-1.56-2.79-1.71-1.86-.34-4.09.06-6.1 1.09-3.48 1.78-5.24 4.87-4.94 6.84.04.27.12.51.24.74ZM126.19 198.8v.04c.24 1.5 2.97 3.37 6.72 2.88 1.9-.25 3.63-1.07 4.74-2.25.34-.37 1.12-1.32.98-2.33-.23-1.5-2.96-3.37-6.72-2.88-1.9.25-3.63 1.07-4.74 2.25-.34.36-1.12 1.32-.99 2.29ZM95.17 186.12c-.06.09-.22.35-.19.93.07 1.36 1.18 3.38 3.48 4.84 1.54.98 3.28 1.47 4.76 1.33.43-.04 1.46-.19 1.86-.82.05-.09.22-.35.19-.92-.07-1.36-1.18-3.38-3.48-4.84-1.54-.98-3.28-1.47-4.76-1.33-.43.04-1.46.19-1.86.81ZM192.78 171.53c.08.49.23.96.46 1.38 1.76 3.27 7.71 3.76 12.74 1.06 4.93-2.65 7.05-6.95 6.6-9.82-.08-.49-.23-.96-.46-1.39-1.76-3.27-7.71-3.76-12.74-1.06-4.93 2.65-7.05 6.95-6.6 9.82Z",
                            className: "full_logo_svg__cls-8"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M183.06 124.84c-12.84 8.33-22.47 17.46-31.67 24.54-10.3 7.72-21.36 16.38-34.33 11.6-9.66-3.41-14.51-14.82-14.64-24.62.43-10.71 5.48-19 22.96-20.73-7.48-1.49-15.3-.32-20.79 3.35-17.41 11.65-14.56 28.85-9.41 39.08 4.93 9.78 17.15 19.03 32 18.99 10.15-.03 22.55-4.05 41.55-18.47 23.26-17.66 42.16-24.24 59.52-24.57.26 0 .52-.05.78-.03.69.04 1.2-.24.92-1.33-.04-.15-.07-.31-.1-.47a84.457 84.457 0 0 0-9-23.91c-1 .22-19.03 4.39-37.81 16.57Z",
                            style: {
                                fill: 'url(#full_logo_svg__linear-gradient-2)',
                                strokeWidth: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M150.02 140.58c-10.3 7.72-20.51 17.91-33.47 13.12-6.84-2.41-12.07-10.37-14.12-17.39v.05c0 .61.03 1.23.08 1.85.04.62.11 1.25.19 1.88 1.15 8.79 5.92 17.9 14.37 20.89 2.43.9 4.79 1.32 7.1 1.37 9.99.2 18.86-6.69 27.23-12.97 2.71-2.09 5.48-4.37 8.34-6.74 6.84-5.67 14.28-11.93 23.33-17.8 18.41-11.94 36.16-16.19 37.79-16.56v-.05a83.974 83.974 0 0 0-5.02-7.83c-7.2 2.36-22.48 8.08-34.14 15.64-12.84 8.33-22.47 17.46-31.67 24.54Z",
                            style: {
                                fill: '#141526',
                                mixBlendMode: 'multiply',
                                opacity: 0.2,
                                strokeWidth: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M79.41 122.96c-5.87 6.69-13.97 26.77-5.83 46.45 2.09 5.05 4.94 10.71 9.44 15.27-.28 1.66-.3 3.31-.05 4.91 1.35 8.69 9.98 13.22 10.42 13.44 8.51 4.06 14.7 1.5 17.27-.03l4.8 1.45c3.5 10.19 17.66 9.19 18.28 9.14 10.41-.78 14.66-6.24 16.1-8.79l3.36-1.11c9.22 8.53 23.01.51 23.61.15 9.57-5.65 10.88-13.82 10.94-17.47l.81-.47c11.76 7.29 25.28-1.23 25.72-1.52 7.94-4.38 10.73-11.17 11.62-14.29 1.09-.27 2.41-.26 3.52-.17.55-2.28 1.02-4.58 1.38-6.91.09-.55-.33-1.06-.88-1.11-.6-.05-1.18-.06-1.73-.06h-.24c-.22 0-.41.02-.61.03l-.7.03c-.08 0-.15.02-.23.03a21.176 21.176 0 0 0-2.23.32c-.12.03-.26.05-.36.07-.36.08-.57.15-.58.15-.31-1.04-.71-1.96-1.13-2.83-.13-.26-.27-.49-.4-.74-.34-.6-.7-1.16-1.08-1.67-.15-.2-.3-.41-.46-.6-1.14-1.35-2.44-2.39-3.8-3.12a13.41 13.41 0 0 0-6.52-1.56c-.68.01-1.34.08-1.95.19-.68.12-1.3.34-1.91.56-.36.14-.73.28-1.07.44-.45.21-.91.41-1.29.63l-.01.01a.49.49 0 0 0-.23.41v.11c.02.16.09.31.22.4.06.04.15.04.23.05.05 0 .09.04.15.03.43-.06.91-.1 1.4-.13s.05 0 .07 0h.01c.27-.02.56-.01.84-.01h.04c.25 0 .49-.02.76 0h.07c.45.02.91.06 1.38.12.23.03.47.08.7.12.28.05.57.11.85.18.33.08.65.18.97.29.24.08.47.18.7.28s.46.18.69.3c.53.27 1.05.57 1.54.94 1.07.82 2.04 1.92 2.81 3.38.02.03.04.09.06.13.23.44.56 1.14.85 2.03.05.14.09.28.14.43.09.31.17.64.23.98 0 .04.02.07.03.11.06.35.11.71.15 1.09.02.23.02.47.02.71v.02c.01.75-.06 1.54-.24 2.37-.02.11-.04.21-.07.32-.04.18-.09.36-.15.55-.18.6-.45 1.22-.77 1.85 0 0 0 .02-.01.03-.22.42-.47.84-.75 1.26-.08.11-.15.23-.23.34-.28.4-.61.79-.96 1.19-.03.03-.05.06-.08.09-.55.61-1.17 1.23-1.9 1.84l-.06.06c-.73.61-1.56 1.22-2.49 1.82-.5.32-1.05.65-1.61.97 0 0-.01 0-.02.01-.15.08-.27.17-.42.25-.04.02-.07.03-.11.05-.31.17-.64.28-.96.43-.47.22-.93.45-1.4.63-.53.21-1.07.35-1.6.51h-.01c-.29.08-.58.18-.87.25-.41.1-.81.18-1.22.25-.38.06-.75.1-1.12.14-.48.05-.95.1-1.42.11s-.09 0-.13 0c-1.02.01-2.01-.08-2.96-.26s-.07-.02-.11-.02c-.8-.15-1.57-.37-2.3-.65-.73-.28-1.42-.62-2.06-1.02-.06-.04-.12-.08-.17-.12-.5-.32-.98-.66-1.4-1.06-.11-.1-.2-.21-.3-.32-.25-.25-.5-.51-.73-.79-.11-.11-.22-.21-.31-.34-2.12 1.28-4.26 2.58-6.49 3.91s-.06-.08-.09-.12c-.03-.04-.06-.07-.09-.11-.35-.47-.7-.91-1.06-1.3-.17-.19-.34-.35-.51-.52-.27-.26-.53-.51-.8-.74a9.335 9.335 0 0 0-1.38-.98c-.09-.05-.18-.11-.27-.16 0 0-.01 0-.02-.01-.09-.05-.18-.11-.27-.16-.34-.18-.68-.32-1.02-.46-.95-.37-1.91-.58-2.85-.66h-.02c-.72-.05-1.42-.03-2.11.04-.27.03-.54.08-.81.13-.03 0-.06 0-.08.01-.13.02-.27.04-.4.07-.03 0-.07.02-.1.03-.06.01-.11.03-.17.04-.45.11-.9.24-1.32.39-.01 0-.02 0-.03.01a14.268 14.268 0 0 0-1.8.76c-.03.02-.06.03-.1.05l-.06.03c-.7.35-1.33.73-1.88 1.1-.01 0-.02.02-.04.02-.02.01-.04.02-.05.04-.12.08-.19.2-.22.31-.02.07 0 .13.01.19v.1c.03.09.09.17.16.23.06.05.12.09.19.12h.04c.06.01.11.02.17.02.03 0 .06.01.09 0 .39-.1.81-.2 1.25-.29.08-.02.15-.04.23-.05.48-.09.98-.16 1.5-.21.09 0 .17-.02.26-.03h.21c.57-.04 1.15-.06 1.74-.03h.02c.58.03 1.17.09 1.75.21.13.03.25.06.37.1.45.11.9.23 1.34.41.13.05.26.13.39.2.41.19.81.39 1.2.65.19.13.35.3.53.45.33.27.66.53.95.86.43.48.84 1.01 1.19 1.65.28.49.45 1.02.6 1.55.08.27.13.55.18.83.07.42.13.85.13 1.28a7 7 0 0 1-.06.79c-.02.22-.07.58-.11.8-.07.38-.15.76-.27 1.14-.12.37-.25.74-.41 1.11-.17.39-.36.76-.58 1.14-.07.13-.15.25-.22.37-.72 1.19-1.65 2.31-2.79 3.32-.28.24-.55.49-.85.72-.81.63-1.68 1.22-2.64 1.71-.56.29-1.14.54-1.71.78-.02 0-.05.02-.07.03-1.2.49-2.41.87-3.61 1.12-.04 0-.08.02-.13.02-2.33.46-4.57.39-6.45-.42-.06-.03-.13-.06-.19-.09a6.79 6.79 0 0 1-1.05-.6c-.07-.05-.15-.1-.22-.15-.38-.28-.73-.6-1.05-.96-.04-.05-.08-.11-.13-.16a8.602 8.602 0 0 1-.93-1.4c-.24-.47-.47-.96-.65-1.52-2.6.95-5.23 1.81-7.89 2.5s0-.01 0-.02v-.03c-.48-1.82-1.21-3.23-2.06-4.38-.09-.12-.16-.27-.25-.39-.08-.1-.16-.19-.25-.28l-.03-.03c-.2-.23-.4-.44-.61-.64-.14-.13-.28-.24-.42-.36-.17-.14-.34-.28-.52-.41-.15-.11-.3-.21-.45-.3-.18-.11-.37-.22-.55-.32-.07-.04-.14-.07-.21-.11-.08-.04-.16-.08-.23-.12-.22-.1-.45-.19-.68-.28 0 0-.02 0-.03-.01h-.01c-.1-.04-.19-.08-.29-.11-.35-.12-.7-.21-1.05-.29-.03 0-.05 0-.08-.01h-.03c-.34-.07-.67-.12-1-.16H138.91c-.32-.03-.65-.05-.96-.05h-.08c-.35 0-.69.01-1.03.04h-.06c-.11.01-.22.02-.33.04-.43.05-.85.13-1.23.23-.05.01-.11.02-.16.04-.14.04-.24.12-.31.22-.06.09-.09.21-.09.32a.722.722 0 0 0 .11.3c.02.03.04.07.07.1.01.01.03.02.05.02.03.02.07.04.11.05.03.02.06.04.09.04.02 0 .04.02.06.02.03 0 .08.02.11.02.77.07 1.61.22 2.47.45s.03 0 .05 0c.03 0 .06.03.1.04.39.11.77.24 1.15.4.02 0 .03.01.05.02.38.15.75.33 1.11.54.74.42 1.43.96 2.02 1.64.11.13.22.25.33.39.34.45.65.93.9 1.5.01.02.03.04.04.06 0 .02.02.05.03.08.12.3.23.63.31 1 .07.3.13.61.16.94v.03c.03.31.04.63.03.96 0 .08-.01.16-.02.24-.01.26-.04.52-.09.79-.01.08-.03.17-.05.25-.06.31-.15.62-.25.93l-.03.09c-.26.72-.66 1.44-1.22 2.12-.03.03-.05.06-.08.09-.27.32-.57.62-.92.92-.02.02-.05.04-.07.06-.76.64-1.71 1.22-2.89 1.7-.08.03-.17.06-.26.09-.51.2-1.06.37-1.65.53-.18.05-.35.09-.53.14-.73.17-1.49.32-2.35.43-.95.12-1.89.13-2.82.09-.09 0-.18-.02-.27-.02-.9-.06-1.77-.19-2.6-.4-.09-.02-.19-.04-.29-.07-.57-.15-1.1-.35-1.62-.58l-.21-.09c-.47-.22-.91-.47-1.33-.74-.09-.06-.17-.12-.25-.18-.39-.28-.76-.59-1.08-.93l-.18-.21c-.32-.37-.62-.75-.86-1.18-.07-.13-.12-.27-.18-.41-.22-.47-.4-.97-.5-1.51-.12-.51-.19-1.04-.18-1.62-1.51-.23-3.02-.54-4.52-.89-1.3-.3-2.6-.66-3.88-1.07.36-.86.6-1.68.74-2.47v-.02a9.75 9.75 0 0 0 .01-3.49c-.01-.06-.03-.11-.04-.17-.09-.41-.21-.8-.34-1.17 0-.02-.02-.04-.02-.06-.03-.07-.06-.15-.09-.22-.13-.33-.28-.64-.44-.94-.03-.05-.05-.11-.08-.16 0 0 0-.02-.01-.03-.2-.35-.42-.68-.66-1l-.15-.18c-.01-.02-.03-.03-.04-.05-.18-.23-.37-.45-.56-.66a.138.138 0 0 1-.03-.04c-.08-.09-.16-.17-.24-.25-.19-.19-.39-.37-.58-.54-.04-.03-.07-.07-.11-.1-.04-.04-.09-.08-.13-.12-.26-.21-.52-.41-.78-.59-.05-.04-.11-.07-.16-.11-.08-.05-.16-.11-.24-.16-.14-.09-.29-.18-.43-.26-.01 0-.02-.01-.03-.02-.11-.06-.21-.12-.31-.18a.405.405 0 0 0-.09-.05c-.13-.07-.26-.13-.39-.19-.12-.06-.25-.12-.37-.18a.559.559 0 0 0-.38-.02c-.02 0-.04.02-.06.03-.05.02-.08.06-.12.1-.03.03-.07.04-.09.07-.01.02-.03.03-.04.05-.06.1-.09.21-.08.32 0 .06.06.12.09.18s.03.12.09.17c.13.12.27.26.41.4l.02.02c.2.2.41.41.61.63.02.02.04.04.06.07.47.53.93 1.11 1.33 1.76.03.04.06.09.09.13.18.3.34.6.48.92.03.06.06.11.09.16 0 .02.01.04.02.06.18.43.32.88.43 1.35l.03.16c.12.58.2 1.18.19 1.81v.01c0 .06-.03.1-.03.16a8.47 8.47 0 0 1-.43 2.04c-.17.5-.43.92-.69 1.34v.01c-.08.12-.13.28-.22.39-.2.28-.44.51-.68.75-.18.18-.35.37-.55.53-.25.21-.52.39-.8.56-.24.15-.49.27-.75.39-.28.13-.55.26-.84.35-.23.08-.49.1-.74.16-.51.11-1.03.2-1.57.22-.47.02-.94.02-1.43-.02-.25-.02-.49-.06-.74-.1-.16-.03-.33-.08-.49-.11-1.04-.21-2.08-.56-3.12-1.06-.22-.1-.44-.17-.65-.28-.58-.32-1.13-.67-1.66-1.05-.15-.11-.3-.23-.45-.34-.38-.29-.75-.6-1.09-.93-1.2-1.13-2.16-2.42-2.75-3.81-.18-.44-.39-1.19-.5-1.65l-.02-.07c-.1-.57-.16-1.15-.12-1.74s0 0 0-.01v-.08c.05-.63.17-1.26.39-1.9.23-.66.56-1.32 1-1.98-1.7-1.68-3.31-3.6-4.81-5.68-.3-.41-.6-.82-.88-1.23-.14-.21-.28-.43-.42-.65-.41-.62-.81-1.24-1.19-1.88-.88-1.45-1.69-2.97-2.46-4.51l-.21-.42c-.76-1.56-1.45-3.14-2.08-4.76-.05-.11-.09-.21-.14-.32-.46-1.12-1.03-2.76-1.54-4.77-.09-.34-.17-.67-.25-1-.05-.24-.1-.49-.16-.74-1.28-5.87-1.17-11.68.13-17.09 0-.02 0-.04.01-.05.21-.88.45-1.75.72-2.61.02-.07.05-.14.07-.21.33-1 .69-1.98 1.1-2.95s.01-.03.02-.05c.67-1.58 1.43-3.11 2.3-4.57.01-.02.02-.03.03-.05a35.94 35.94 0 0 1 2.86-4.15c.04-.06.08-.11.12-.17.24-.3.55-.63.82-.95.26-.3.5-.6.77-.89.41-.45.87-.9 1.33-1.36a32.886 32.886 0 0 1 2.3-2.09c.11-.09.21-.19.32-.28.2-.16.4-.29.6-.45.61-.48 1.23-.95 1.9-1.42 1.01-.7 2.02-1.35 3.02-1.92.73-.41 1.49-.8 2.27-1.17.37-.18.74-.34 1.11-.5s0 0 .01-.01c.22-.09.45-.18.67-.28.84-.34 1.66-.64 2.49-.9.14-.04.27-.09.41-.13.81-.24 1.61-.45 2.4-.63h.02c.78-.17 1.54-.31 2.3-.42.03 0 .06 0 .09-.01.74-.1 1.46-.18 2.18-.23h.13c.72-.05 1.42-.08 2.12-.08h.09c.94 0 1.86.04 2.75.11.11 0 .22.01.33.02 1.2.11 2.35.28 3.44.49.07.01.14.03.2.04 1.08.21 2.09.45 3.04.72s.06.02.09.03c.77.22 1.49.44 2.16.68l.1.03c.6.21 1.16.41 1.67.61.02 0 .03.01.05.02-12.23-7.89-34.3-5.07-46.34 8.66Z",
                            className: "full_logo_svg__cls-10",
                            style: {
                                fill: '#141526',
                                strokeWidth: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M265.72 141.77v-3.21c0-30.43 19.95-51.98 50.08-51.98 26.06 0 43.39 16.45 45.13 40.91h-21.84c-1.6-14.27-10.19-22.86-23.59-22.86-17.47 0-27.37 13.68-27.37 33.92v3.21c0 20.24 10.04 33.77 27.37 33.77 13.98 0 22.71-9.46 23.44-23.88h21.84c-1.6 24.61-18.34 42.08-45.13 42.08-30.58 0-49.94-21.4-49.94-51.98ZM372.73 155.16v-1.9c0-22.85 15-38.43 38.73-38.43 25.62 0 38.29 18.05 36.98 44.26h-54.89c1.02 12.81 6.99 19.07 17.91 19.07 9.17 0 14.41-4.37 16.31-10.19h20.24c-3.64 15.87-16.89 25.77-36.54 25.77-24.17 0-38.73-15.43-38.73-38.58Zm54.89-9.46c-.87-9.47-6.12-15.29-16.31-15.29s-15.73 4.94-17.47 15.29h33.78ZM630.34 170.89c0-12.81 8.15-20.38 21.83-22.28l27.66-3.93v-4.37c0-6.25-4.07-10.04-12.96-10.04-8.3 0-13.53 3.21-14.27 9.61h-19.21c1.16-16.01 14.41-25.04 33.92-25.04s32.17 10.04 32.17 25.77v51.25H680.7l-.73-11.5c-4.52 8.15-13.25 13.39-24.31 13.39-15.15 0-25.33-9.61-25.33-22.86Zm49.5-6.55v-5.97l-20.38 2.76c-6.26.88-9.46 3.49-9.46 8.73s4.37 8.59 11.79 8.59c9.9 0 18.05-5.83 18.05-14.12ZM833.5 155.16v-1.9c0-22.85 15-38.43 38.73-38.43 25.62 0 38.29 18.05 36.98 44.26h-54.89c1.02 12.81 6.99 19.07 17.91 19.07 9.18 0 14.41-4.37 16.31-10.19h20.24c-3.64 15.87-16.89 25.77-36.55 25.77-24.16 0-38.73-15.43-38.73-38.58Zm54.89-9.46c-.88-9.47-6.12-15.29-16.31-15.29s-15.73 4.94-17.48 15.29h33.78ZM504.98 114.83c-12.23 0-20.67 6.7-24.17 13.39l-.58-11.51h-19.07v99.34s20.49-.84 20.53-20.48v-14.35c4.08 6.99 12.23 12.52 22.86 12.52 20.24 0 32.61-16.31 32.61-38.58v-1.9c0-22.13-12.09-38.43-32.18-38.43Zm11.5 40.33c0 14.7-6.12 22.86-17.76 22.86s-17.76-8.16-17.76-22.86v-1.9c0-14.7 6.26-22.85 17.76-22.85s17.76 8.15 17.76 22.85v1.9ZM593.2 114.83c-11.94 0-19.56 6.11-23.5 12.81v-24.08c0-18.74-20.46-19.62-20.46-19.62v107.91h20.37v-41.64c0-11.94 6.41-18.93 15.87-18.93s13.54 6.4 13.54 17.33v43.24h20.24v-48.34c0-16.89-7.43-28.68-26.06-28.68ZM757.42 114.83c-11.06 0-18.93 5.24-23.44 11.94v-22.3h.01c0-19.69-20.53-20.53-20.53-20.53v107.91h19.06l.58-11.79c3.35 6.7 11.36 13.68 23.74 13.68 20.09 0 32.61-16.16 32.61-38.58v-1.9c0-22.13-12.09-38.43-32.04-38.43Zm11.36 40.33c0 14.7-6.11 22.86-17.76 22.86s-17.76-8.16-17.76-22.86v-1.9c0-14.7 6.25-22.85 17.76-22.85s17.76 8.15 17.76 22.85v1.9ZM821.91 103.89c0-18.95-20.38-19.95-20.38-19.95v107.91h20.38v-87.96ZM915.9 193.68v-10.36h-3.55v-2.48h10.13v2.48h-3.53v10.36h-3.05ZM924.26 193.68v-12.84h4.34l2.82 8.97 2.84-8.97h4.11v12.84h-2.88v-9.3l-2.95 9.3h-2.37l-2.98-9.33v9.33h-2.93Z",
                            className: "full_logo_svg__cls-7"
                        })
                    ]
                })
            })
        ]
    });
var $a22a182679eb182e$export$2e2bcd8739ae039 = $a22a182679eb182e$var$SvgFullLogo;



const $aa23c6db410f15d5$export$b59bdbef9ce70de2 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
    width: 100%;
`;
const $aa23c6db410f15d5$export$54fb318478ce42e9 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    padding: 0 2rem;
`;
const $aa23c6db410f15d5$export$9f629bf691066a45 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    padding: 0 1rem;
    gap: 2rem;
    width: 100%;
    max-width: 775px;
    margin: 2rem auto;
`;
const $aa23c6db410f15d5$export$168e1409b442d455 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($aa23c6db410f15d5$export$9f629bf691066a45)`
    gap: 0;
`;
const $aa23c6db410f15d5$export$a334180936c1c286 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    padding: 0 1rem;
    width: 100%;
    max-width: 775px;
    margin: 1rem auto;
    gap: 0.5rem;
`;
const $aa23c6db410f15d5$export$562f981f17d360a4 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    & > * {
        transition: all 0.2s ease-in-out;
    }
`;
const $aa23c6db410f15d5$export$81ea29a9084db687 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    margin: 1rem 0;
`;
const $aa23c6db410f15d5$export$20dc64867e1691d0 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
`;
const $aa23c6db410f15d5$export$bdcd69dc79c387fe = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    flex-grow: 1;
    min-width: 0;
    padding: 0 0.5rem;
`;








const $9ad04432e4bd50f2$export$2eca4db030987fb4 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$ea6aee68c7b1694f))`
    text-align: center;
    position: relative;
    top: -15px;
`;
const $9ad04432e4bd50f2$export$aa34b0733809f7c9 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $9926e0d0274623af$export$154f0ea7dcc0c8c6))`
    z-index: 2;
    position: relative;
    margin: 1rem 0 0.5rem 0;
`;
const $9ad04432e4bd50f2$export$2391059582428a3f = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039))`
    z-index: 2;
    font-size: 1.125rem; // 18px
    font-weight: 400;
    text-decoration: underline !important;
    :hover {
        text-decoration: none !important;
    }
`;
const $9ad04432e4bd50f2$export$276e2d5aebf03c9a = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    position: relative;
    flex: 1;
    max-width: 800px;
    align-self: stretch;
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    justify-content: center;
    margin: auto;
    background-color: transparent;
    @media (prefers-reduced-motion: no-preference) {
        animation-name: ${(0, $8951886a6b49e92a$export$f6e93140e4a16f4b)};
        animation-duration: 3.5s;
    }
`;
const $9ad04432e4bd50f2$export$94008d681fbde3e7 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    // height minutes the height of the footer and toolbar
    min-height: calc(100vh - 230px);
    flex: 1;
    width: 100%;
    display: flex;
    align-items: stretch;
    flex-direction: column;
    justify-content: space-between;
    background-color: ${(props)=>props.theme.color.background};
    animation-name: ${(0, $8951886a6b49e92a$export$a63bc229d382c303)};

    animation-duration: 300ms;
    :before {
        background-image: ${(0, $8951886a6b49e92a$export$29bb14a8b9f2803e)};
        background-size: 100%;
        position: fixed;
        top: 60vh;
        right: -60vw;
        display: inline-block;
        height: 1500px;
        width: 1500px;
        content: '';
        pointer-events: none;
    }
    :after {
        transform: rotate(180deg);
        background-image: ${(0, $8951886a6b49e92a$export$29bb14a8b9f2803e)};
        background-size: 100%;
        position: fixed;
        top: -1000px;
        left: -70vw;
        display: inline-block;
        height: 1500px;
        width: 1500px;
        content: '';
        pointer-events: none;
    }
`;
const $9ad04432e4bd50f2$export$6c854e2ebdd9e349 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $9926e0d0274623af$export$2f7dd73b133adfb7))`
    display: inline-block;
    text-align: center;
    font-weight: 400;
    z-index: 2;
    position: relative;
`;
const $9ad04432e4bd50f2$export$866b79548f9e5b64 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    background-color: ${(props)=>props.theme.color.background}90;
    padding: 2rem;
    border-radius: 8px;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;



function $d906f0ec45e15ad7$export$2e2bcd8739ae039({ isExperimentalDevice: isExperimentalDevice, isLoading: isLoading, showLoading: showLoading, signInUrl: signInUrl, signUpUrl: signUpUrl }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { theme: theme } = (0, $7fPBF.useContext)((0, $c6dc2c2d62651942$export$2c657da244d00bd6));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9ad04432e4bd50f2$export$94008d681fbde3e7), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $9ad04432e4bd50f2$export$276e2d5aebf03c9a), {
            children: [
                isExperimentalDevice && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d906f0ec45e15ad7$var$StyledTag, {
                    children: t('common:beta')
                }),
                theme == 'light' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af532f2d7e07bf07$export$2e2bcd8739ae039), {
                    width: 350
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a22a182679eb182e$export$2e2bcd8739ae039), {
                    width: 350
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9ad04432e4bd50f2$export$2eca4db030987fb4), {
                    children: t('common:login.description')
                }),
                isLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$ea6aee68c7b1694f), {
                    children: t('common:login.loading')
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9ad04432e4bd50f2$export$aa34b0733809f7c9), {
                            href: signUpUrl,
                            children: t('common:login.create')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$562f981f17d360a4), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9ad04432e4bd50f2$export$6c854e2ebdd9e349), {
                                    children: t('common:login.existingAccount')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9ad04432e4bd50f2$export$2391059582428a3f), {
                                    variant: "context",
                                    onClick: showLoading,
                                    href: signInUrl,
                                    children: t('common:login.signIn')
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
const $d906f0ec45e15ad7$var$StyledTag = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $9926e0d0274623af$export$3288d34c523a1192))`
    position: relative;
    top: 30px;
`;







var $7fPBF = parcelRequire("7fPBF");

function $3fc44e910064c4f6$export$2e2bcd8739ae039() {
    const currentUserContainer = (0, $8a1185b15e8317ab$export$2e2bcd8739ae039).useContainer();
    const authContainer = (0, $455682785eac4c5b$export$2e2bcd8739ae039).useContainer();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const [queryParams] = (0, $5ec159caebd3ae22$export$f1a78c17382fe22a)();
    (0, $7fPBF.useEffect)(()=>{
        const queryCode = queryParams.get('code');
        if (queryCode) navigate(`../authcallback?code=${queryCode}`);
        if (authContainer.isAuthenticatedRef.current == true) navigate('../');
    }, []);
    const signInUrl = `${(0, $07546889aef07ebc$export$df8e085683bf7fe4)()}/signin?client_id=${(0, $db3063bd3b6d501e$export$666167f3cc1c081a)()}&redirect_uri=${(0, $07546889aef07ebc$export$b0c2c82d7aa8a735)()}`;
    const signUpUrl = `${(0, $07546889aef07ebc$export$df8e085683bf7fe4)()}/signup/v2?client_id=${(0, $db3063bd3b6d501e$export$666167f3cc1c081a)()}&redirect_uri=${(0, $07546889aef07ebc$export$b0c2c82d7aa8a735)()}&culture=${currentUserContainer.userLocalePreferencesRef.current.defaultLocale}`;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: !authContainer.isAuthenticated && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d906f0ec45e15ad7$export$2e2bcd8739ae039), {
            signInUrl: signInUrl,
            signUpUrl: signUpUrl
        })
    });
}



const $427978696205d868$export$5122f57547dc8eca = (organization)=>{
    if (!organization) return 'personal';
    // professional licenses
    if (organization.isEmployeeAccess) return 'isEmployeeAccess';
    if (organization.isDeveloperAccess) return 'isDeveloperAccess';
    if (organization.isStudentAccess) return 'isStudentAccess';
    if (organization.isPlusAccess) return 'isPlusAccess';
    // default placeholder, in case it is unrecognized license type
    return 'isEmployeeAccess';
};



var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");

function $748d28edcc8cedba$export$2e2bcd8739ae039() {
    const { organizationId: organizationId, managedOrgId: managedOrgId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const currentOrgId = (0, $7fPBF.useMemo)(()=>{
        return managedOrgId || organizationId;
    }, [
        managedOrgId,
        organizationId
    ]);
    return {
        organizationId: currentOrgId,
        parentOrgId: organizationId,
        managedOrgId: managedOrgId
    };
}


function $b194594edd326788$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId, managedOrgId: managedOrgId } = (0, $748d28edcc8cedba$export$2e2bcd8739ae039)();
    const alertsContainer = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const { loadingDataRef: loadingDataRef, loadingData: loadingData, handleLoadingDataChange: handleLoadingDataChange, currentOrg: currentOrg, currentOrgRef: currentOrgRef, memberships: memberships, membershipsRef: membershipsRef, getOrganizationMembership: getOrganizationMembership, loadCurrentOrganizationDetails: loadCurrentOrganizationDetails } = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const fetchOrgDetailData = (0, $7fPBF.useCallback)(async ()=>{
        if (!organizationId || currentOrgRef.current?.id == organizationId || loadingDataRef.current.currentOrg) return;
        try {
            handleLoadingDataChange('currentOrg', true);
            const result = await loadCurrentOrganizationDetails(organizationId);
            if (result.resultType != 'Ok') throw new Error('Error fetching organization data');
        } catch (error) {
            alertsContainer.showError(t('common:organization.error'));
        } finally{
            handleLoadingDataChange('currentOrg', false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        organizationId
    ]);
    (0, $7fPBF.useEffect)(()=>{
        fetchOrgDetailData();
    }, [
        fetchOrgDetailData
    ]);
    const remainingSeats = (0, $7fPBF.useMemo)(()=>{
        if (!currentOrg || currentOrg.currentMemberCount == null || !currentOrg.maxMembers) return 0;
        if (currentOrg.maxMembers < currentOrg.currentMemberCount) return 0;
        return currentOrg.maxMembers - currentOrg.currentMemberCount;
    }, [
        currentOrg
    ]);
    const isExpiredOrg = (0, $7fPBF.useMemo)(()=>{
        if (!currentOrg || !currentOrg.licenseExpirationDate) return false;
        return currentOrg.licenseExpirationDate && new Date(currentOrg.licenseExpirationDate) < new Date();
    }, [
        currentOrg
    ]);
    const licenseType = (0, $7fPBF.useMemo)(()=>{
        return (0, $427978696205d868$export$5122f57547dc8eca)(currentOrg);
    }, [
        currentOrg
    ]);
    const currentMembership = (0, $7fPBF.useMemo)(()=>{
        if (!membershipsRef?.current || !organizationId) return null;
        return getOrganizationMembership(organizationId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        organizationId,
        memberships
    ]);
    const originatingOrgMembership = (0, $7fPBF.useMemo)(()=>{
        if (!membershipsRef?.current || !currentOrg || !currentOrg.originatedByOrganizationId) return null;
        return getOrganizationMembership(currentOrg.originatedByOrganizationId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentOrg,
        memberships
    ]);
    const membership = (0, $7fPBF.useMemo)(()=>{
        if (!organizationId) return null;
        if (currentMembership) return currentMembership;
        if (originatingOrgMembership) {
            const newMembership = {
                ...originatingOrgMembership
            };
            newMembership.organizationId = organizationId;
            newMembership.isAdmin = true;
            return newMembership;
        }
        return null;
    }, [
        currentMembership,
        originatingOrgMembership,
        organizationId
    ]);
    const hasSomeMemberEditPermissions = (0, $7fPBF.useMemo)(()=>{
        return !!(currentMembership?.isAdmin || currentMembership?.canRemoveMembers || currentMembership?.canChangeMemberPermissions || originatingOrgMembership?.isAdmin || originatingOrgMembership?.canManageChildOrganizations);
    }, [
        currentMembership,
        originatingOrgMembership
    ]);
    const canManageBilling = (0, $7fPBF.useMemo)(()=>{
        return !!(currentMembership?.canManageBilling || currentMembership?.isAdmin || originatingOrgMembership?.canManageChildOrganizations || originatingOrgMembership?.isAdmin);
    }, [
        currentMembership,
        originatingOrgMembership
    ]);
    //     canAccessOrganizationProfiles: boolean;
    // canEditOrganizationProfiles: boolean;
    const canAccessOrganizationProfiles = (0, $7fPBF.useMemo)(()=>{
        return !!(currentMembership?.canAccessOrganizationProfiles || currentMembership?.isAdmin || originatingOrgMembership?.canManageChildOrganizations || originatingOrgMembership?.isAdmin);
    }, [
        currentMembership,
        originatingOrgMembership
    ]);
    const canEditOrganizationProfiles = (0, $7fPBF.useMemo)(()=>{
        return !!(currentMembership?.canEditOrganizationProfiles || currentMembership?.isAdmin || originatingOrgMembership?.canManageChildOrganizations || originatingOrgMembership?.isAdmin);
    }, [
        currentMembership,
        originatingOrgMembership
    ]);
    const canInviteMembers = (0, $7fPBF.useMemo)(()=>{
        return !!(currentMembership?.canInviteMembers || currentMembership?.isAdmin || originatingOrgMembership?.canManageChildOrganizations || originatingOrgMembership?.isAdmin);
    }, [
        currentMembership,
        originatingOrgMembership
    ]);
    const canViewMembers = (0, $7fPBF.useMemo)(()=>{
        return !!(currentMembership?.canViewMembers || currentMembership?.isAdmin || originatingOrgMembership?.canManageChildOrganizations || originatingOrgMembership?.isAdmin);
    }, [
        currentMembership,
        originatingOrgMembership
    ]);
    const canCreateAuthClients = (0, $7fPBF.useMemo)(()=>{
        return !!(currentMembership?.canCreateAuthClients || currentMembership?.isAdmin || originatingOrgMembership?.canManageChildOrganizations || originatingOrgMembership?.isAdmin);
    }, [
        currentMembership,
        originatingOrgMembership
    ]);
    const canViewAuthClients = (0, $7fPBF.useMemo)(()=>{
        return !!(currentMembership?.canViewAuthClients || currentMembership?.isAdmin || originatingOrgMembership?.canManageChildOrganizations || originatingOrgMembership?.isAdmin);
    }, [
        currentMembership,
        originatingOrgMembership
    ]);
    const canManageChildOrganizations = (0, $7fPBF.useMemo)(()=>{
        return !!(currentMembership?.canManageChildOrganizations || currentMembership?.isAdmin || originatingOrgMembership?.canManageChildOrganizations || originatingOrgMembership?.isAdmin);
    }, [
        currentMembership,
        originatingOrgMembership
    ]);
    const canViewOrgDetails = (0, $7fPBF.useMemo)(()=>{
        return !!(managedOrgId || (currentOrg?.maxMembers ?? 0) > 1);
    }, [
        currentOrg,
        managedOrgId
    ]);
    const isManagedOrg = (0, $7fPBF.useMemo)(()=>{
        return !!(managedOrgId || currentOrg?.originatedByOrganizationId);
    }, [
        managedOrgId,
        currentOrg
    ]);
    return {
        isLoading: loadingData.currentOrg,
        currentOrg: currentOrg,
        membership: membership,
        remainingSeats: remainingSeats,
        isExpiredOrg: isExpiredOrg,
        licenseType: licenseType,
        hasSomeMemberEditPermissions: hasSomeMemberEditPermissions,
        canManageBilling: canManageBilling,
        canCreateAuthClients: canCreateAuthClients,
        canViewAuthClients: canViewAuthClients,
        canInviteMembers: canInviteMembers,
        canViewMembers: canViewMembers,
        canManageChildOrganizations: canManageChildOrganizations,
        canViewOrgDetails: canViewOrgDetails,
        canAccessOrganizationProfiles: canAccessOrganizationProfiles,
        canEditOrganizationProfiles: canEditOrganizationProfiles,
        isManagedOrg: isManagedOrg
    };
}




function $f5559fd1343df4e9$export$2e2bcd8739ae039() {
    const matches = (0, $5ec159caebd3ae22$export$2378eb7f5ff86053)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId, managedOrgId: managedOrgId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)(); // Get the dynamic params
    const { currentOrg: currentOrg } = (0, $b194594edd326788$export$2e2bcd8739ae039)(); // Get current organization details
    const items = matches.filter((match)=>match.handle?.crumbKey).map((match)=>{
        let crumbKey = match.handle?.crumbKey || '';
        // Replace :organizationId or :managedOrgId with the actual organization name if available
        let dynamicLabel = '';
        if (organizationId && !managedOrgId && currentOrg?.name) dynamicLabel = crumbKey.replace('common:organization.title', currentOrg.name);
        if (managedOrgId && currentOrg?.name) dynamicLabel = crumbKey.replace('common:organization.managed.title', currentOrg.name);
        const breadcrumbLabel = t(dynamicLabel || crumbKey);
        return {
            label: String(breadcrumbLabel) || '',
            href: match.pathname ? `${match.pathname}` : ''
        };
    });
    return {
        items: items,
        matches: matches
    };
}







const $2dfada774612a323$export$bab42a9f58782ce1 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    // height minus the height of the footer and toolbar
    min-height: calc(100vh - 186px);
    width: 100%;
    display: flex;
    align-items: stretch;
    flex-direction: column;
    justify-content: space-between;
    animation-name: ${(0, $8951886a6b49e92a$export$a63bc229d382c303)};
    animation-duration: 300ms;
    :before {
        z-index: -1;
        background-image: ${(0, $8951886a6b49e92a$export$29bb14a8b9f2803e)};
        background-size: 100% 100%;
        position: fixed;
        top: 60vh;
        right: -60vw;
        display: inline-block;
        height: 1500px;
        width: 1500px;
        content: '';
    }
    :after {
        z-index: -1;
        transform: rotate(180deg);
        background-image: ${(0, $8951886a6b49e92a$export$29bb14a8b9f2803e)};
        background-size: 100% 100%;
        position: fixed;
        top: -1000px;
        left: -70vw;
        display: inline-block;
        height: 1500px;
        width: 1500px;
        content: '';
    }
`;





function $0a32b82ac174a6a1$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2dfada774612a323$export$bab42a9f58782ce1), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9926e0d0274623af$export$a0a5e8e630ce7261), {
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $9ad04432e4bd50f2$export$276e2d5aebf03c9a), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$fe91652f4f7f8d90), {
                        children: "404."
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$ea6aee68c7b1694f), {
                        children: t('common:notFoundDescription')
                    })
                ]
            })
        })
    });
}



function $b4fdfd1bcb4375a9$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:notFound'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a32b82ac174a6a1$export$2e2bcd8739ae039), {})
        ]
    });
}















parcelRequire("7fPBF");



function $d955c60ca6420e2e$export$2e2bcd8739ae039({ title: title = '', prefixElement: prefixElement, children: children, description: description, complete: complete, number: number, tabIndex: tabIndex, scrollId: scrollId, as: as = 'h2', variant: variant = 'default', ...restProps }) {
    if (complete) variant = 'small';
    const BodyComponent = variant == 'small' || !!complete ? (0, $b091aef3a32d2bd8$export$c527f4a83cede337) : (0, $b091aef3a32d2bd8$export$5c3bdb37a55baa65);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d955c60ca6420e2e$var$RowWrapper, {
        ...restProps,
        $variant: variant,
        children: [
            (number || complete) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d955c60ca6420e2e$var$Step, {
                children: complete ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                    name: "check"
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d955c60ca6420e2e$var$StyledTitleSmall, {
                    as: "span",
                    children: number
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $b341816979fee99b$export$ac90896a1379b2ac), {
                children: [
                    prefixElement,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(BodyComponent, {
                        as: as,
                        tabIndex: tabIndex,
                        id: scrollId,
                        children: title
                    }),
                    description && variant != 'small' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b341816979fee99b$export$489b03dc3e6c3fea), {
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b341816979fee99b$export$128b0389825fe3d5), {
                children: children
            })
        ]
    });
}
const $d955c60ca6420e2e$var$RowWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: row;
    gap: 1rem;
    position: ${(props)=>props.$sticky ? 'sticky' : 'static'};
    top: 1.5rem;
    padding-top: ${(props)=>props.$variant == 'small' ? '0.25rem' : '0.5rem'};
    padding-bottom: ${(props)=>props.$variant == 'small' ? '0.25rem' : '0.5rem'};
    margin: ${(props)=>props.$variant == 'small' ? '1rem 0 0 0' : '2rem 0 0 0'};
    border-bottom-width: ${(props)=>props.$variant == 'small' ? 1 : 2}px;
    border-style: solid;
    border-color: ${(props)=>props.$variant == 'small' ? props.theme.color.border : props.theme.color.textBody};
    background-color: ${(props)=>props.theme.color.background};
    z-index: 10;
`;
const $d955c60ca6420e2e$var$Step = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    background-color: ${(props)=>props.theme.color.text};
    color: ${(props)=>props.theme.color.background};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 2rem;
    width: 2rem;
    flex-shrink: 0;
    margin-top: 0.25rem;
`;
const $d955c60ca6420e2e$var$StyledTitleSmall = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$2c65789109b698b0))`
    color: ${(props)=>props.theme.color.background};
`;






var $7fPBF = parcelRequire("7fPBF");







const $14974ae7e6038f2e$export$1ff01c4069d6f31d = 'sales@cephable.com';
const $14974ae7e6038f2e$export$5032a7d4ffcc1d13 = 'My Team';
const $14974ae7e6038f2e$var$licenseMap = {
    isDeveloperAccess: 'SDK',
    isStudentAccess: 'Education',
    isEmployeeAccess: 'Professional',
    isPlusAccess: 'Plus',
    personal: 'Basic'
};
const $14974ae7e6038f2e$var$getLicenseInformation = (organization)=>{
    const orgName = organization.name || $14974ae7e6038f2e$export$5032a7d4ffcc1d13;
    const licenseType = (0, $427978696205d868$export$5122f57547dc8eca)(organization);
    const license = $14974ae7e6038f2e$var$licenseMap[licenseType];
    return {
        orgName: orgName,
        license: license
    };
};
const $14974ae7e6038f2e$export$42aa67c76dc56b07 = (organization)=>{
    const { orgName: orgName, license: license } = $14974ae7e6038f2e$var$getLicenseInformation(organization);
    const subject = `Request for License Upgrade - ${orgName}`;
    let body;
    if (organization.maxMembers === 1) body = `Hi,\n\nI hope this email finds you well. My name is [Your Name]. I have been using Cephable ${license} Free Trial and have been very satisfied with the value it has brought to me.\n\n I am having trouble upgrading and was redirected to email you. Could you please provide me with the next steps to facilitate this process? \n\nThank you, and looking forward to hearing from you soon.\n\nBest regards,\n[Your Full Name]\n[Your Position]\n${orgName}\n[Your Contact Information]`;
    body = `Hi,\n\nI hope this email finds you well. My name is [Your Name], and I am the [Your Position] at ${orgName}. We have been using Cephable ${license} Free Trial and have been very satisfied with the value it has brought to our team.\n\nWe would like to explore the available options for upgrading from the free trial to a full license. Could you please provide us with the next steps to facilitate this process? \n\nThank you, and looking forward to hearing from you soon.\n\nBest regards,\n[Your Full Name]\n[Your Position]\n${orgName}\n[Your Contact Information]`;
    return `mailto:${$14974ae7e6038f2e$export$1ff01c4069d6f31d}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};
const $14974ae7e6038f2e$export$de627014b138b76f = (organization)=>{
    const { orgName: orgName, license: license } = $14974ae7e6038f2e$var$getLicenseInformation(organization);
    const subject = `Request for License Subscription Management - ${orgName}`;
    let body;
    if (organization.maxMembers === 1) body = `Hi,\n\nI hope this email finds you well. My name is [Your Name]. I have been using Cephable ${license} and was trying to manage my billing, however was not able to get to a billing portal link. Could you please provide me with the next steps to facilitate this process? \n\nThank you, and looking forward to hearing from you soon.\n\nBest regards,\n[Your Full Name]\n[Your Position]\n${orgName}\n[Your Contact Information]`;
    else body = `Hi,\n\nI hope this email finds you well. My name is [Your Name], and I am the [Your Position] at ${orgName}. We have been using Cephable ${license} and were trying to manage our billing, however were not able to get to a billing portal link. [Add Additional Information about Your Subscriptions] \n\nCould you please provide us with the next steps to facilitate this process? \n\nThank you, and looking forward to hearing from you soon.\n\nBest regards,\n[Your Full Name]\n[Your Position]\n${orgName}\n[Your Contact Information]`;
    return `mailto:${$14974ae7e6038f2e$export$1ff01c4069d6f31d}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};






var $7fPBF = parcelRequire("7fPBF");





var $e26231f066199887$var$LicenseActivationSteps = /*#__PURE__*/ function(LicenseActivationSteps) {
    LicenseActivationSteps[LicenseActivationSteps["LicenseKey"] = 0] = "LicenseKey";
    LicenseActivationSteps[LicenseActivationSteps["OrganizationDetails"] = 1] = "OrganizationDetails";
    return LicenseActivationSteps;
}($e26231f066199887$var$LicenseActivationSteps || {});
function $e26231f066199887$export$2e2bcd8739ae039({ open: open, onCancel: onCancel, organizationId: organizationId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const alertsContainer = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const organizationContainer = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const [errorMessage, setErrorMessage] = (0, $7fPBF.useState)(null);
    const [licenseKey, setLicenseKey] = (0, $7fPBF.useState)('');
    const [orgName, setOrgName] = (0, $7fPBF.useState)('');
    const [orgDescription, setOrgDescription] = (0, $7fPBF.useState)('');
    const [currentStep, setCurrentStep] = (0, $7fPBF.useState)(0);
    const description = organizationId ? t('common:license.activate.description') : t('common:license.activate.descriptionLong');
    /** Activation Logic */ const processResult = (result)=>{
        if (result.resultType == 'Ok' && result.data) {
            // navigate to activate license page
            navigate(`/org/${result.data.id}/license`, {
                replace: true
            });
            // show success message
            const licenseType = (0, $427978696205d868$export$5122f57547dc8eca)(result.data);
            alertsContainer.showSuccess(t('common:license.activate.success', {
                license: t(`common:billing.${licenseType}.titleLong`)
            }));
            (0, $e7df95de73caec26$export$89b472e03be495df)('license-trial-started');
            // remove dialog
            onDismiss();
        } else setErrorMessage(t('common:license.activate.invalid.key'));
    };
    // free user is upgrading to a licensed organization
    const activateNewOrg = async (name, description)=>{
        // validation
        if (name == '') {
            setErrorMessage(t('common:license.activate.invalid.empty.name'));
            return;
        }
        // submit
        const result = await organizationContainer.activateNewOrgLicenseKey({
            name: name,
            description: description,
            key: licenseKey
        });
        processResult(result);
    };
    // existing org is activating a license key
    const activateExistingOrg = async ()=>{
        // permission check
        if (!organizationId) {
            alertsContainer.showError(t('common:organization.error'));
            onDismiss();
            return;
        }
        // submit
        const result = await organizationContainer.activateExistingOrgLicenseKey(organizationId, {
            key: licenseKey
        });
        processResult(result);
    };
    // custom activation logic based on user type
    const onActivate = async ()=>{
        if (currentStep === 0) {
            // validate license key
            if (licenseKey === '') {
                setErrorMessage(t('common:license.activate.invalid.empty.key'));
                return;
            }
            let validateResult = null;
            if (organizationId) validateResult = await organizationContainer.validateLicenseKeyForOrganization(organizationId, licenseKey);
            else validateResult = await organizationContainer.validateLicenseKey(licenseKey);
            if (validateResult?.resultType === 'Ok' && validateResult.data && validateResult.data?.isValid) {
                // upgrade
                if (organizationId) await activateExistingOrg();
                else if (validateResult.data.maxMembers <= 1) {
                    const licenseType = (0, $427978696205d868$export$5122f57547dc8eca)(validateResult.data);
                    const description = t(`common:billing.${licenseType}.description`);
                    await activateNewOrg((0, $14974ae7e6038f2e$export$5032a7d4ffcc1d13), description);
                } else // proceed to next step
                setCurrentStep(1);
            } else {
                setErrorMessage(t('common:license.activate.invalid.key'));
                return;
            }
        }
        if (currentStep === 1) await activateNewOrg(orgName, orgDescription);
    };
    /** UI State Management */ const clearError = ()=>{
        if (errorMessage) setErrorMessage(null);
    };
    const onLicenseKeyChange = (e)=>{
        clearError();
        setLicenseKey(e.target.value);
    };
    const onOrgNameChange = (e)=>{
        clearError();
        setOrgName(e.target.value);
    };
    const onOrgDescriptionChange = (e)=>{
        clearError();
        setOrgDescription(e.target.value);
    };
    const onDismiss = ()=>{
        setErrorMessage(null);
        setLicenseKey('');
        setOrgName('');
        setOrgDescription('');
        setCurrentStep(0);
        onCancel();
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        title: t('common:license.activate.title'),
        description: description,
        open: open,
        onClose: onDismiss,
        onCancel: onDismiss,
        onConfirm: onActivate,
        confirmButtonText: t('common:license.activate.button'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
            children: [
                currentStep === 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039), {
                    label: t('common:license.activate.fieldLabel'),
                    placeholder: t('common:license.activate.placeholder'),
                    required: true,
                    value: licenseKey,
                    onChange: onLicenseKeyChange,
                    fullWidth: true
                }),
                currentStep === 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039), {
                            label: t('common:organization.new.name.label'),
                            placeholder: t('common:organization.new.name.placeholder'),
                            required: true,
                            value: orgName,
                            onChange: onOrgNameChange,
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039), {
                            label: t('common:organization.new.description.label'),
                            placeholder: t('common:organization.new.description.placeholder'),
                            value: orgDescription,
                            onChange: onOrgDescriptionChange,
                            fullWidth: true
                        })
                    ]
                }),
                errorMessage && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$7f714e6c560938e5), {
                    children: errorMessage
                })
            ]
        })
    });
}



function $0b175acfd81bea10$export$2e2bcd8739ae039({ center: center = true, organizationId: organizationId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [showDialog, setShowDialog] = (0, $7fPBF.useState)(false);
    const currentUserContainer = (0, $8a1185b15e8317ab$export$2e2bcd8739ae039).useContainer();
    const onClick = ()=>{
        setShowDialog(true);
    };
    const onCancel = ()=>{
        setShowDialog(false);
    };
    const RowWrapper = center ? (0, $aa23c6db410f15d5$export$562f981f17d360a4) : $0b175acfd81bea10$var$StyledRow;
    if (!currentUserContainer.currentUser?.isEmailVerified) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(RowWrapper, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9ad04432e4bd50f2$export$6c854e2ebdd9e349), {
                        children: t('common:license.activate.question')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9ad04432e4bd50f2$export$2391059582428a3f), {
                        variant: "context",
                        onClick: onClick,
                        children: t('common:license.activate.button')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e26231f066199887$export$2e2bcd8739ae039), {
                open: showDialog,
                onCancel: onCancel,
                organizationId: organizationId
            })
        ]
    });
}
const $0b175acfd81bea10$var$StyledRow = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $aa23c6db410f15d5$export$b59bdbef9ce70de2))`
    align-items: center;
    justify-content: flex-start;
`;


function $e1e9eb2af1eb4d35$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const currentUserContainer = (0, $8a1185b15e8317ab$export$2e2bcd8739ae039).useContainer();
    // option to activate license and create new organization only available to free users who have verified emails
    if (!currentUserContainer.hasNoOrgMemberships || !currentUserContainer.isEmailVerified) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:license.upgrade.generic.title'),
                description: t('common:license.upgrade.generic.description')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0b175acfd81bea10$export$2e2bcd8739ae039), {
                        center: false
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        to: "/upgrade",
                        $color: "secondary",
                        children: t('common:billing.viewProducts')
                    })
                ]
            })
        ]
    });
}






var $7fPBF = parcelRequire("7fPBF");












var $7fPBF = parcelRequire("7fPBF");


function $cd171fdb3e7df3d1$export$2e2bcd8739ae039({ open: open, onCancel: onCancel }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const organizationsContainer = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const alertsContainer = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const availableMemberships = (0, $7fPBF.useMemo)(()=>{
        return organizationsContainer.membershipsRef.current.filter((membership)=>membership.canManageBilling || membership.isAdmin);
    }, [
        organizationsContainer.memberships
    ]);
    const [memberIndex, setMemberIndex] = (0, $7fPBF.useState)(0);
    const handleRadioSelectionClick = async (value)=>{
        setMemberIndex(value);
    };
    const onConfirm = async ()=>{
        const member = availableMemberships[memberIndex];
        organizationsContainer.currentOrgIdRef.current = member.organizationId;
        navigate(`/org/${member?.organizationId}/billing/redirect/upgrade`);
        onDismiss();
    };
    const onDismiss = ()=>{
        setMemberIndex(0);
        onCancel();
    };
    if (availableMemberships.length === 0) {
        onDismiss();
        alertsContainer.showError(t('common:organization.error'));
        return null;
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        title: t('common:organization.expired.dialog.title'),
        description: t('common:organization.expired.dialog.description'),
        open: open,
        onCancel: onDismiss,
        onClose: onDismiss,
        onConfirm: onConfirm,
        confirmButtonText: t('common:upgrade'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e1f776e3a27ad5dc$export$2e2bcd8739ae039), {
            name: t('common:organization.titlePlural'),
            onChange: (e)=>handleRadioSelectionClick(parseInt(e.target.value)),
            value: memberIndex,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9926e0d0274623af$export$1d02c21cd5285ce0), {
                children: availableMemberships.map((membership, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
                        value: i,
                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $de28970229c88fa7$export$2e2bcd8739ae039), {
                            sx: {
                                padding: '0 9'
                            }
                        }),
                        label: membership.organization.name
                    }, i))
            })
        })
    });
}



function $bf6564604dc78833$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const organizationContainer = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const currentUserContainer = (0, $8a1185b15e8317ab$export$2e2bcd8739ae039).useContainer();
    const [showDialog, setShowDialog] = (0, $7fPBF.useState)(false);
    const isSingleMembership = organizationContainer.memberships.length == 1;
    if (!currentUserContainer.isEmailVerified || !currentUserContainer.isLicenseExpired) return null;
    const getTitle = ()=>{
        return isSingleMembership ? t('common:organization.expired.title') : t('common:organization.expired.titlePlural');
    };
    const getDescription = ()=>{
        if (isSingleMembership) {
            const { isAdmin: isAdmin, canManageBilling: canManageBilling } = organizationContainer.memberships[0];
            return canManageBilling || isAdmin ? t('common:organization.expired.admin') : t('common:organization.expired.user');
        }
        return t('common:organization.expired.multiple');
    };
    const handleClick = ()=>{
        if (isSingleMembership) navigate(`/org/${organizationContainer.memberships[0].organizationId}/billing/redirect/upgrade/`);
        else setShowDialog(true);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: getTitle(),
                description: getDescription()
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: isSingleMembership ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0b175acfd81bea10$export$2e2bcd8739ae039), {
                            organizationId: organizationContainer.memberships[0].organizationId,
                            center: false
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            onClick: handleClick,
                            $color: "secondary",
                            children: t('common:upgrade')
                        })
                    ]
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            onClick: handleClick,
                            $color: "secondary",
                            children: t('common:organization.viewOrganization')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cd171fdb3e7df3d1$export$2e2bcd8739ae039), {
                            open: showDialog,
                            onCancel: ()=>setShowDialog(false)
                        })
                    ]
                })
            })
        ]
    });
}





var $7fPBF = parcelRequire("7fPBF");









var $7fPBF = parcelRequire("7fPBF");

function $f2d327d1efeb1ca4$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('common');
    const { deleteCurrentUser: deleteCurrentUser } = (0, $8a1185b15e8317ab$export$2e2bcd8739ae039).useContainer();
    const [showDialog, setShowDialog] = (0, $7fPBF.useState)(false);
    const { clearAndReload: clearAndReload } = (0, $6e4c204c2f850d70$export$2e2bcd8739ae039)();
    const handleDeleteAccount = async ()=>{
        const result = await deleteCurrentUser();
        if (result?.resultType === 'Ok') clearAndReload();
    };
    const showDeleteConfirmation = ()=>{
        setShowDialog(true);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('dangerZone')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($f2d327d1efeb1ca4$var$StyledButton, {
                startIcon: "delete",
                $size: "quick",
                $color: "quick",
                onClick: showDeleteConfirmation,
                children: t('account.delete.button')
            }),
            showDialog && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
                open: showDialog,
                onClose: ()=>setShowDialog(false),
                onCancel: ()=>setShowDialog(false),
                onConfirm: handleDeleteAccount,
                confirmButtonText: t('account.delete.confirm'),
                title: t('account.delete.title'),
                description: t('account.delete.description')
            })
        ]
    });
}
const $f2d327d1efeb1ca4$var$StyledButton = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039))`
    width: fit-content;
    margin: auto;
`;




var $7fPBF = parcelRequire("7fPBF");













function $b585c34ca23c4f44$export$39f6debbec19b3ba(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiSwitch', slot);
}
const $b585c34ca23c4f44$var$switchClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiSwitch', [
    'root',
    'edgeStart',
    'edgeEnd',
    'switchBase',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium',
    'checked',
    'disabled',
    'input',
    'thumb',
    'track'
]);
var $b585c34ca23c4f44$export$2e2bcd8739ae039 = $b585c34ca23c4f44$var$switchClasses;




'use client';
const $01917f736960ab46$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            edge && `edge${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(edge)}`,
            `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`
        ],
        switchBase: [
            'switchBase',
            `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            checked && 'checked',
            disabled && 'disabled'
        ],
        thumb: [
            'thumb'
        ],
        track: [
            'track'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $b585c34ca23c4f44$export$39f6debbec19b3ba), classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const $01917f736960ab46$var$SwitchRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.edge)}`],
            styles[`size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})({
    display: 'inline-flex',
    width: 58,
    height: 38,
    overflow: 'hidden',
    padding: 12,
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: 'middle',
    // For correct alignment with the text.
    '@media print': {
        colorAdjust: 'exact'
    },
    variants: [
        {
            props: {
                edge: 'start'
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: 'end'
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).switchBase}`]: {
                    padding: 4,
                    [`&.${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).checked}`]: {
                        transform: 'translateX(16px)'
                    }
                }
            }
        }
    ]
});
const $01917f736960ab46$var$SwitchSwitchBase = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $69935e2350f58c79$export$2e2bcd8739ae039), {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).input}`]: styles.input
            },
            ownerState.color !== 'default' && styles[`color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            'left',
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).checked}`]: {
            transform: 'translateX(20px)'
        },
        [`&.${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).checked} + .${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).disabled} + .${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
        },
        [`& .${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).input}`]: {
            left: '-100%',
            width: '300%'
        }
    })), (0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $061b5988a3817e26$export$2e2bcd8739ae039)([
                'light'
            ])) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === 'light' ? (0, $4afad3ab73a4d920$export$c0816ed86df316af)(theme.palette[color].main, 0.62) : (0, $4afad3ab73a4d920$export$4b073707ff63303)(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).checked} + .${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    })));
const $01917f736960ab46$var$SwitchTrack = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiSwitch',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        height: '100%',
        width: '100%',
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            'opacity',
            'background-color'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
    })));
const $01917f736960ab46$var$SwitchThumb = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiSwitch',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>styles.thumb
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: 'currentColor',
        width: 20,
        height: 20,
        borderRadius: '50%'
    })));
const $01917f736960ab46$var$Switch = /*#__PURE__*/ $7fPBF.forwardRef(function Switch(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSwitch'
    });
    const { className: className, color: color = 'primary', edge: edge = false, size: size = 'medium', sx: sx, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        edge: edge,
        size: size
    };
    const classes = $01917f736960ab46$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('root', {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $01917f736960ab46$var$SwitchRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            sx: sx
        }
    });
    const [ThumbSlot, thumbSlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('thumb', {
        className: classes.thumb,
        elementType: $01917f736960ab46$var$SwitchThumb,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const icon = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ThumbSlot, {
        ...thumbSlotProps
    });
    const [TrackSlot, trackSlotProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('track', {
        className: classes.track,
        elementType: $01917f736960ab46$var$SwitchTrack,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($01917f736960ab46$var$SwitchSwitchBase, {
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState,
                ...other,
                classes: {
                    ...classes,
                    root: classes.switchBase
                },
                slots: {
                    ...slots.switchBase && {
                        root: slots.switchBase
                    },
                    ...slots.input && {
                        input: slots.input
                    }
                },
                slotProps: {
                    ...slotProps.switchBase && {
                        root: typeof slotProps.switchBase === 'function' ? slotProps.switchBase(ownerState) : slotProps.switchBase
                    },
                    ...slotProps.input && {
                        input: typeof slotProps.input === 'function' ? slotProps.input(ownerState) : slotProps.input
                    }
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TrackSlot, {
                ...trackSlotProps
            })
        ]
    });
});
var $01917f736960ab46$export$2e2bcd8739ae039 = $01917f736960ab46$var$Switch;






var $7fPBF = parcelRequire("7fPBF");



const $61af229c8d46419f$export$ff809762241d8927 = ()=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const alertsContainer = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const currentUserContainer = (0, $8a1185b15e8317ab$export$2e2bcd8739ae039).useContainer();
    const [isEmailOptIn, setIsEmailOptIn] = (0, $7fPBF.useState)(currentUserContainer.currentUser?.isEmailOptIn ?? false);
    const handleSaveEmailPreferences = async ()=>{
        try {
            const result = await currentUserContainer.updateEmailPreferences({
                isEmailOptIn: isEmailOptIn
            });
            if (result?.resultType === 'Ok') alertsContainer.showSuccess(t('common:account.success.marketing'));
            else alertsContainer.showError(result?.errors?.join(', ') ?? t('common:account.error.marketing'));
        } catch (error) {
            console.error('Failed to update email preferences:', error);
            alertsContainer.showError(t('common:account.error.generic'));
        }
    };
    return {
        isEmailOptIn: isEmailOptIn,
        setIsEmailOptIn: setIsEmailOptIn,
        handleSaveEmailPreferences: handleSaveEmailPreferences
    };
};



function $590356dd036c873d$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { isEmailOptIn: isEmailOptIn, setIsEmailOptIn: setIsEmailOptIn, handleSaveEmailPreferences: handleSaveEmailPreferences } = (0, $61af229c8d46419f$export$ff809762241d8927)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:account.marketing.title'),
                description: t('common:account.marketing.description')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
                        value: "start",
                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $01917f736960ab46$export$2e2bcd8739ae039), {
                            checked: isEmailOptIn,
                            onChange: ()=>{
                                setIsEmailOptIn(!isEmailOptIn);
                            }
                        }),
                        label: t('common:account.marketing.optIn'),
                        labelPlacement: "end"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        onClick: handleSaveEmailPreferences,
                        children: t('common:save')
                    })
                ]
            })
        ]
    });
}








var $7fPBF = parcelRequire("7fPBF");



const $db4834f7df953e0a$export$aff464d60fdfb505 = ()=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const alertsContainer = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const currentUserContainer = (0, $8a1185b15e8317ab$export$2e2bcd8739ae039).useContainer();
    const [oldPassword, setOldPassword] = (0, $7fPBF.useState)('');
    const [newPassword, setNewPassword] = (0, $7fPBF.useState)('');
    const [confirmNewPassword, setConfirmNewPassword] = (0, $7fPBF.useState)('');
    const handleSavePassword = async ()=>{
        try {
            if (!validatePasswordInputs()) return;
            const result = await currentUserContainer.updatePassword(oldPassword, newPassword, confirmNewPassword);
            handlePasswordSaveResult(result);
        } catch (error) {
            console.error('Failed to update password:', error);
            alertsContainer.showError(t('common:account.error.generic'));
        }
    };
    const validatePasswordInputs = ()=>{
        if (!oldPassword) {
            alertsContainer.showError(t('common:account.error.old'));
            return false;
        }
        if (!newPassword) {
            alertsContainer.showError(t('common:account.error.new'));
            return false;
        }
        if (newPassword !== confirmNewPassword) {
            alertsContainer.showError(t('common:account.error.match'));
            return false;
        }
        return true;
    };
    const handlePasswordSaveResult = (result)=>{
        if (result?.resultType === 'Ok') {
            alertsContainer.showSuccess(t('common:account.success.password'));
            resetPasswordFields();
        } else alertsContainer.showError(result?.errors?.join(', ') ?? t('common:account.error.password'));
    };
    const resetPasswordFields = ()=>{
        setOldPassword('');
        setNewPassword('');
        setConfirmNewPassword('');
    };
    return {
        oldPassword: oldPassword,
        newPassword: newPassword,
        confirmNewPassword: confirmNewPassword,
        setOldPassword: setOldPassword,
        setNewPassword: setNewPassword,
        setConfirmNewPassword: setConfirmNewPassword,
        handleSavePassword: handleSavePassword
    };
};



function $97d862a8a3c72e2c$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { oldPassword: oldPassword, setOldPassword: setOldPassword, newPassword: newPassword, setNewPassword: setNewPassword, confirmNewPassword: confirmNewPassword, setConfirmNewPassword: setConfirmNewPassword, handleSavePassword: handleSavePassword } = (0, $db4834f7df953e0a$export$aff464d60fdfb505)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:account.password.change'),
                description: t('common:account.password.description')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        label: t('common:account.password.old'),
                        type: "password",
                        placeholder: t('common:account.password.current'),
                        value: oldPassword,
                        onChange: (e)=>setOldPassword(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        label: t('common:account.password.new'),
                        type: "password",
                        placeholder: t('common:account.password.desired'),
                        value: newPassword,
                        onChange: (e)=>setNewPassword(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        label: t('common:account.password.confirm'),
                        type: "password",
                        placeholder: t('common:account.password.desired'),
                        value: confirmNewPassword,
                        onChange: (e)=>setConfirmNewPassword(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        onClick: handleSavePassword,
                        children: t('common:save')
                    })
                ]
            })
        ]
    });
}













var $7fPBF = parcelRequire("7fPBF");


function $2c3144704a635922$export$2e2bcd8739ae039(initialFlags) {
    const [featureFlags, setFeatureFlags, featureFlagRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(initialFlags);
    const initialFlagsRef = (0, $7fPBF.useRef)(initialFlags);
    const deviceContainer = (0, $57ef534a0961ba07$export$2e2bcd8739ae039).useContainer();
    const updateFeatureFlags = (flagName, isEnabled)=>{
        setFeatureFlags((prevFlags)=>{
            const hasFlag = prevFlags.includes(flagName);
            if (isEnabled && !hasFlag) return [
                ...prevFlags,
                flagName
            ];
            else if (!isEnabled && hasFlag) return prevFlags.filter((flag)=>flag !== flagName);
            return prevFlags;
        });
    };
    const handleEnabledFeatureFlagChange = async ()=>{
        // TODO HEAD MOUSE: Add head mouse settings when the feature flag is enabled
        if (initialFlagsRef.current.includes((0, $eec5c3b697f8e81e$export$19e7a64c17ac6a78)) && !featureFlagRef.current.includes((0, $eec5c3b697f8e81e$export$19e7a64c17ac6a78))) for (const device of deviceContainer.devicesRef.current){
            if (device.expressionSettings.mouseMoveMode == undefined || device.expressionSettings.mouseMoveMode === 'Off') continue;
            try {
                await deviceContainer.updateDevice(device.id, {
                    ...device,
                    expressionSettings: {
                        ...device.expressionSettings,
                        mouseMoveLeftExpression: undefined,
                        mouseMoveRightExpression: undefined,
                        mouseMoveUpExpression: undefined,
                        mouseMoveDownExpression: undefined,
                        mouseMoveMode: 'Off'
                    }
                });
            } catch (error) {
                return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
            }
        }
        return new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)((0, $eec5c3b697f8e81e$export$19e7a64c17ac6a78));
    };
    /**
     * Handles the extended feature flag change on user preference save
     * Use this when you need other functionality to be triggered when a feature flag is changed using if conditions
     * @returns A result indicating the success or failure of the operation
     */ const handleExtendedFeatureFlagChange = async ()=>{
        const flagHandlers = {
            [(0, $eec5c3b697f8e81e$export$19e7a64c17ac6a78)]: handleEnabledFeatureFlagChange
        };
        try {
            const results = await Promise.all(Object.entries(flagHandlers).map(([flag, handler])=>{
                if (featureFlagRef.current.includes(flag) || initialFlagsRef.current.includes(flag)) return handler(); // Call the handler if the feature flag is has existed in initial or current flags
                return Promise.resolve(new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)('')); // Resolve with a SuccessResult if not enabled
            }));
            // Check for any UnexpectedResults and return the first one found
            const unexpectedResult = results.find((result)=>result instanceof (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039));
            if (unexpectedResult) return unexpectedResult; // Return the UnexpectedResult if found
            // Reset the initial flags to the current flags after handling since those have been saved.
            // This ensures the next 'save' click behaves as expected.
            initialFlagsRef.current = featureFlagRef.current;
            return new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)(''); // Return a generic success result
        } catch (error) {
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    return {
        featureFlags: featureFlags,
        updateFeatureFlags: updateFeatureFlags,
        handleExtendedFeatureFlagChange: handleExtendedFeatureFlagChange
    };
}



var $7fPBF = parcelRequire("7fPBF");



function $6bb82cbdc861c255$export$2e2bcd8739ae039({ flagName: flagName, isEnabled: isEnabled, onToggle: onToggle, label: label }) {
    const handleToggle = ()=>{
        onToggle(flagName, !isEnabled);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
        value: "start",
        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $01917f736960ab46$export$2e2bcd8739ae039), {
            checked: isEnabled,
            onChange: handleToggle
        }),
        label: label,
        labelPlacement: "end"
    });
}


function $4d95bdbd61412061$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const alertsContainer = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const currentUserContainer = (0, $8a1185b15e8317ab$export$2e2bcd8739ae039).useContainer();
    const [isWarningOptOut, setIsWarningOptOut] = (0, $7fPBF.useState)(currentUserContainer?.currentUser?.userPreferences?.isWarningConflictIndicatorsOptOut ?? false);
    const initialFeatureFlags = currentUserContainer.currentUser?.userPreferences?.featureFlags ?? [];
    const { featureFlags: featureFlags, updateFeatureFlags: updateFeatureFlags, handleExtendedFeatureFlagChange: handleExtendedFeatureFlagChange } = (0, $2c3144704a635922$export$2e2bcd8739ae039)(initialFeatureFlags);
    const handleSaveUserPreferences = async ()=>{
        try {
            const preferences = {
                isWarningConflictIndicatorsOptOut: isWarningOptOut,
                featureFlags: featureFlags
            };
            const result = await currentUserContainer.updateUserPreferences(preferences);
            if (result?.resultType === 'Ok') {
                const featureFlagResult = await handleExtendedFeatureFlagChange();
                if (featureFlagResult.resultType === 'Unexpected') {
                    alertsContainer.showError(t('common:account.error.userPreferences'));
                    return;
                }
                alertsContainer.showSuccess(t('common:account.success.userPreferences'));
            } else alertsContainer.showError(result?.errors?.join(', ') ?? t('common:account.error.userPreferences'));
        } catch (error) {
            console.error('Error saving user preferences:', error);
            alertsContainer.showError(t('common:account.error.unexpected')); // Provide a generic fallback error message
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:account.userPreferences.title'),
                description: t('common:account.userPreferences.description')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
                        value: "start",
                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $01917f736960ab46$export$2e2bcd8739ae039), {
                            checked: isWarningOptOut,
                            onChange: ()=>{
                                setIsWarningOptOut(!isWarningOptOut);
                            }
                        }),
                        label: t('common:account.userPreferences.warningOptOut'),
                        labelPlacement: "end"
                    }),
                    currentUserContainer.userBetaFeatureFlags.map((flag)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6bb82cbdc861c255$export$2e2bcd8739ae039), {
                            flagName: flag,
                            isEnabled: featureFlags.includes(flag),
                            onToggle: updateFeatureFlags,
                            label: t(`common:account.userPreferences.${flag}`)
                        }, flag)),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        onClick: handleSaveUserPreferences,
                        children: t('common:save')
                    })
                ]
            })
        ]
    });
}


function $1655878af8403289$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(true);
    const currentUserContainer = (0, $8a1185b15e8317ab$export$2e2bcd8739ae039).useContainer();
    (0, $7fPBF.useEffect)(()=>{
        const fetchUserData = async ()=>{
            await currentUserContainer.loadCurrentUser();
            setIsLoading(false);
        };
        fetchUserData();
    }, []);
    if (isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$168e1409b442d455), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $9926e0d0274623af$export$a4cc130c20be0091), {
                        as: "p",
                        children: [
                            t('common:account.usernameLabel'),
                            ' ',
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$2c65789109b698b0), {
                                as: "span",
                                children: currentUserContainer.currentUser?.username
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $9926e0d0274623af$export$a4cc130c20be0091), {
                        as: "p",
                        children: [
                            t('common:account.emailLabel'),
                            ' ',
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$2c65789109b698b0), {
                                as: "span",
                                children: currentUserContainer.currentUser?.email
                            })
                        ]
                    })
                ]
            }),
            currentUserContainer.hasNoOrgMemberships ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e1e9eb2af1eb4d35$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bf6564604dc78833$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $97d862a8a3c72e2c$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $590356dd036c873d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d95bdbd61412061$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f2d327d1efeb1ca4$export$2e2bcd8739ae039), {})
        ]
    });
}



function $6895f6b5d8df95cd$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:account.settings'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1655878af8403289$export$2e2bcd8739ae039), {})
        ]
    });
}













function $ae034d1fd76a0328$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { memberships: memberships } = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    if (memberships.length > 0) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
        description: t('common:organization.noOrg.description'),
        fullHeight: true,
        icon: "orgCompany",
        title: t('common:organization.noOrg.title'),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                href: `${(0, $07546889aef07ebc$export$df8e085683bf7fe4)()}/trial/`,
                startIcon: "plusLight",
                children: t('common:license.trial.start')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0b175acfd81bea10$export$2e2bcd8739ae039), {})
        ]
    });
}







var $7fPBF = parcelRequire("7fPBF");

function $b8d9a8d0ea07c335$export$2e2bcd8739ae039() {
    const { showSuccess: showSuccess, showError: showError } = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const { requestEmailVerificationResend: requestEmailVerificationResend } = (0, $8a1185b15e8317ab$export$2e2bcd8739ae039).useContainer();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const handleResendVerification = (0, $7fPBF.useCallback)(async ()=>{
        try {
            const result = await requestEmailVerificationResend();
            if (result?.resultType === 'Ok') showSuccess(t('common:account.isEmailVerified.success'));
            else showError(t('common:account.isEmailVerified.error'));
        } catch (error) {
            showError(t('common:account.isEmailVerified.error'));
        }
    }, [
        t
    ]);
    return {
        handleResendVerification: handleResendVerification
    };
}





function $16382b6bee5ea13e$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { handleResendVerification: handleResendVerification } = (0, $b8d9a8d0ea07c335$export$2e2bcd8739ae039)();
    const { currentUser: currentUser, isLoading: isLoading } = (0, $8a1185b15e8317ab$export$2e2bcd8739ae039).useContainer();
    if (!currentUser || isLoading || currentUser.isEmailVerified) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
        description: t('common:account.isEmailVerified.org'),
        fullHeight: true,
        icon: "orgInvite",
        title: t('common:account.isEmailVerified.title'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
            onClick: handleResendVerification,
            startIcon: "sync",
            children: t('common:account.isEmailVerified.resend')
        })
    });
}














const $28d9662e98370ec0$export$bc7adc8ef74607f = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    border-bottom-width: 1px;
    border-style: solid;
    flex-basis: 100%;
    border-color: ${(props)=>props.theme.color.border};
`;
const $28d9662e98370ec0$export$25f993d99f705cbc = (0, $8de346382d86c747$export$2e2bcd8739ae039).div``;
const $28d9662e98370ec0$export$e9f274a1a8d32886 = (0, $8de346382d86c747$export$2e2bcd8739ae039).span`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;
const $28d9662e98370ec0$export$23f145dc49963d58 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    margin-top: 0.5rem;
`;
const $28d9662e98370ec0$export$ec763714b6894364 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039))`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
`;
const $28d9662e98370ec0$export$d210d4f1518e7142 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039))`
    /* margin-top: 0.4rem; */
`;
const $28d9662e98370ec0$export$27894facc6548d4b = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    padding: 0 1rem;
    display: flex;
    flex-direction: column;
`;
const $28d9662e98370ec0$export$ab02e7e1b80b05a4 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    flex-grow: 1;
    gap: 0.5rem;
    display: flex;
    flex-direction: row;
    padding: 1rem;
    text-align: left;
    text-decoration: none;
    border: none;
    font-weight: inherit;
    background-color: ${(props)=>props.theme.color.background};
    transition:
        background-color 0.2s ease-in-out,
        border-color 0.2s ease-in-out;
    opacity: ${({ disabled: disabled })=>disabled ? 0.6 : 1};
    &:hover {
        background-color: ${(props)=>props.disabled ? 'transparent' : props.theme.color.cardHover};
    }
    color: ${(props)=>props.theme.color.text};
    ${(0, $19e0bc52fddd02b4$export$87f1b08a59e6d1dd)};
`;
const $28d9662e98370ec0$export$c40b407fe7288f21 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($28d9662e98370ec0$export$ab02e7e1b80b05a4.withComponent('a'))`
    &:hover {
        color: ${(props)=>props.disabled ? props.theme.color.textBody : props.theme.color.link};
        cursor: pointer;
    }
`;
const $28d9662e98370ec0$export$564cbe3426fc093a = (0, $8de346382d86c747$export$2e2bcd8739ae039)($28d9662e98370ec0$export$ab02e7e1b80b05a4.withComponent('button'))`
    &:hover {
        color: ${(props)=>props.disabled ? props.theme.color.textBody : props.theme.color.link};
        cursor: pointer;
    }
`;
const $28d9662e98370ec0$export$6ca0cf093d0e7859 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($28d9662e98370ec0$export$ab02e7e1b80b05a4.withComponent((0, $5ec159caebd3ae22$export$a6c7ac8248d6e38a)))`
    background-color: ${(props)=>props.theme.color.cardHover};
    margin-top: 0.5rem;
    border-radius: 10px;
    border: 1px solid ${(props)=>props.theme.color.border};
    &:hover {
        background-color: ${(props)=>props.theme.color.card};
        cursor: pointer;
    }
`;
const $28d9662e98370ec0$export$f2a3559b50aabeed = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    flex-basis: 100%;
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    & > * {
        flex: 1;
    }
`;


function $4f034ea975db3d0b$export$2e2bcd8739ae039({ title: title, description: description, disabled: disabled = false, startComponent: startComponent, startIcon: startIcon, endIcon: endIcon = 'forward', href: href, iconSize: iconSize = 42, onClick: onClick, children: children, tagNode: tagNode, ...restProps }) {
    const commonProps = {
        disabled: disabled
    };
    if (!href && !onClick) throw new Error('ActionRow requires either an href or onClick prop');
    if (href) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28d9662e98370ec0$export$bc7adc8ef74607f), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $28d9662e98370ec0$export$c40b407fe7288f21), {
            href: href,
            ...commonProps,
            ...restProps,
            children: [
                startIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28d9662e98370ec0$export$d210d4f1518e7142), {
                    name: startIcon,
                    size: iconSize
                }),
                startComponent,
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $28d9662e98370ec0$export$e9f274a1a8d32886), {
                    children: [
                        tagNode ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($4f034ea975db3d0b$var$ActionRowTitle, {
                            as: "span",
                            children: [
                                tagNode,
                                " ",
                                title
                            ]
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4f034ea975db3d0b$var$ActionRowTitle, {
                            as: "span",
                            children: title
                        }),
                        description && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$1ef657600983666a), {
                            as: "span",
                            children: description
                        }),
                        children && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28d9662e98370ec0$export$23f145dc49963d58), {
                            children: children
                        })
                    ]
                }),
                endIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28d9662e98370ec0$export$ec763714b6894364), {
                    name: endIcon,
                    size: iconSize
                })
            ]
        })
    });
    else return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28d9662e98370ec0$export$bc7adc8ef74607f), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $28d9662e98370ec0$export$564cbe3426fc093a), {
            onClick: onClick,
            ...commonProps,
            ...restProps,
            children: [
                startIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28d9662e98370ec0$export$d210d4f1518e7142), {
                    name: startIcon,
                    size: iconSize
                }),
                startComponent,
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $28d9662e98370ec0$export$e9f274a1a8d32886), {
                    children: [
                        tagNode ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $347ffda0d89c401a$export$9ee67e6e3f51a5ed), {
                            children: [
                                tagNode,
                                " ",
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4f034ea975db3d0b$var$ActionRowTitle, {
                                    as: "span",
                                    children: title
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4f034ea975db3d0b$var$ActionRowTitle, {
                            as: "span",
                            children: title
                        }),
                        description && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$1ef657600983666a), {
                            as: "span",
                            children: description
                        }),
                        children && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28d9662e98370ec0$export$23f145dc49963d58), {
                            children: children
                        })
                    ]
                }),
                endIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28d9662e98370ec0$export$ec763714b6894364), {
                    name: endIcon,
                    size: iconSize
                })
            ]
        })
    });
}
const $4f034ea975db3d0b$var$ActionRowTitle = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$a35e4d6f9ac473d6))`
    color: inherit;
`;


function $d352f17b0797ff29$export$2e2bcd8739ae039({ membership: membership }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const handleNavigate = ()=>{
        navigate(`../org/${membership.organizationId}`);
    };
    if (!membership || !membership.organization || !membership.organizationId) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f034ea975db3d0b$export$2e2bcd8739ae039), {
        iconSize: 24,
        startIcon: (0, $d0493a8b121d95e9$export$3aa18b5a5694efe6)(membership.organization),
        title: membership.organization.name,
        description: membership.organization.description,
        onClick: handleNavigate
    });
}





function $1571b35751ed6eec$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { memberships: memberships } = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const { currentUser: currentUser } = (0, $8a1185b15e8317ab$export$2e2bcd8739ae039).useContainer();
    // part of multiple orgs or single org with multiple members
    const canViewOrganizationDetails = memberships.length > 1 || memberships.length === 1 && (memberships[0].organization.maxMembers ?? 0) > 1;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:welcome'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16382b6bee5ea13e$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ae034d1fd76a0328$export$2e2bcd8739ae039), {}),
            memberships?.length > 0 && currentUser?.isEmailVerified && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: canViewOrganizationDetails ? t('common:organization.titlePlural') : t('common:license.titlePlural'),
                description: canViewOrganizationDetails ? t('common:organization.description') : t('common:billing.description')
            }),
            memberships && currentUser?.isEmailVerified && memberships.map((membership)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d352f17b0797ff29$export$2e2bcd8739ae039), {
                    membership: membership
                }, membership.organizationId))
        ]
    });
}











function $0bebe83a624352a6$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($0bebe83a624352a6$var$SplashLoaderWrapper, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0bebe83a624352a6$export$b1ae020268e0b4d5, {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                $color: "quick",
                $size: "small",
                onClick: ()=>{
                    window.location.reload();
                },
                children: t('common:reload')
            })
        ]
    });
}
const $0bebe83a624352a6$export$b1ae020268e0b4d5 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $d513166e63c42433$export$2e2bcd8739ae039))`
    margin: 16px;
`;
const $0bebe83a624352a6$var$SplashLoaderWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    min-height: 90vh;
    flex: 1;
    background-color: transparent;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    ${(0, $19e0bc52fddd02b4$export$29c8ed22df400735)}
    img {
        height: 128px;
        width: 128px;
    }
`;






function $8dc4863d22c2164a$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { currentOrg: currentOrg } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {
        text: "Coming soon."
    });
// if (!currentOrg || isInviteLoading) return <SplashLoader />;
// if (!(currentOrg.isAdmin || currentOrg.canCreateAuthClients)) return <OrgNoAccessBanner />;
// return (
//     <>
//         <CardSmallGrid>
//             {invites && (
//                 <NumberStatCard
//                     title={invites.length.toString() ?? '0'}
//                     description={t('common:organization.invite.stat', {
//                         value: currentOrg.organization.maxMembers,
//                     })}
//                 />
//             )}
//         </CardSmallGrid>
//     </>
// );
}




function $71606fe9d87fd62f$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { currentOrg: currentOrg, isLoading: isLoading } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    if (!currentOrg || isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:organization.metrics.orgTitle', {
                    value: currentOrg?.name
                }),
                description: t('common:organization.metrics.description'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8dc4863d22c2164a$export$2e2bcd8739ae039), {})
        ]
    });
}











const $12a7318cc7b914d5$export$7c05dc9bbd6db060 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0.5rem;
    gap: 0.5rem;
`;
const $12a7318cc7b914d5$export$bdfe625add29c644 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($12a7318cc7b914d5$export$7c05dc9bbd6db060)`
    border: 2px solid ${(props)=>props.theme.banner[props.$color || 'default'].border};
    border-radius: 6px;
    background-color: ${(props)=>props.theme.banner[props.$color || 'default'].background};
    color: ${(props)=>props.theme.banner[props.$color || 'default'].text};
    ${(props)=>props.$borderless && (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
            border: none;
            padding: 0;
            background-color: transparent;
        `}
`;
const $12a7318cc7b914d5$export$e30e93a3651e4e64 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem;
`;
const $12a7318cc7b914d5$export$4a703ded2a7a3e59 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    max-width: 1000px;
    width: 100%;
    margin: 1rem auto;
    padding: 2rem;
    border-radius: 6px;
    border: 2px solid ${(props)=>props.theme.color.secondary};
    background-color: ${(props)=>props.theme.color.secondary}25;
    &[data-isread='true'] {
        background-color: ${(props)=>props.theme.color.accentCard};
        border: none;
        & * {
            color: ${(props)=>props.theme.color.textBody};
        }
    }
    justify-self: center;
`;
const $12a7318cc7b914d5$export$7cee909993ddd8b7 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    margin: 0 2rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    justify-content: center;
`;
const $12a7318cc7b914d5$export$e47d9fd7cf4256ee = (0, $8de346382d86c747$export$2e2bcd8739ae039)($12a7318cc7b914d5$export$7cee909993ddd8b7)`
    padding: 0;
    margin: 1rem 0;
    justify-content: center;
`;
const $12a7318cc7b914d5$export$8e508ed4a13b5a61 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($12a7318cc7b914d5$export$4a703ded2a7a3e59)`
    border: 2px solid ${(props)=>props.theme.banner[props.$color ?? 'default'].border};
    background-color: ${(props)=>props.theme.banner[props.$color ?? 'default'].background};
`;
const $12a7318cc7b914d5$var$sharedStyles = (props)=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
    .core-button {
        color: ${props.theme.banner[props.$color].buttonText ?? props.theme.banner[props.$color].text};
        border-color: transparent;
        background: ${props.theme.banner[props.$color || 'default'].border};

        :hover {
            color: ${props.theme.banner[props.$color].buttonText ?? props.theme.banner[props.$color || 'default'].text};
            border-color: transparent;
            background: ${props.theme.banner[props.$color || 'default'].border};
            text-decoration: underline;
        }
    }
    .text-button {
        color: ${props.theme.banner[props.$color || 'default'].linkText};
    }
`;
const $12a7318cc7b914d5$export$503892287317b6c8 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    align-content: center;
    ${(props)=>props.$color !== 'default' && $12a7318cc7b914d5$var$sharedStyles(props)};
`;
const $12a7318cc7b914d5$export$dc254ddf4c41e5d7 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    ${(props)=>props.$color !== 'default' && $12a7318cc7b914d5$var$sharedStyles(props)};
`;
const $12a7318cc7b914d5$export$1a9858f2fb62c3f2 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039))`
    color: ${(props)=>props.theme.banner.default.text};
    font-size: 0.8rem;
    line-height: 1.1rem;
    padding: 0 0.5rem;
    :hover {
        text-decoration: none !important;
    }
`;







function $1e6a0781013949e7$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    function getRelativeTime(inputDate) {
        const currentDate = new Date();
        const inputDateObj = new Date(inputDate);
        const timeDifference = currentDate.getTime() - inputDateObj.getTime();
        const absDifference = Math.abs(timeDifference);
        const isFuture = timeDifference < 0;
        const minutes = Math.floor(absDifference / 60000);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);
        const months = Math.floor(days / 30);
        const years = Math.floor(days / 365);
        let relativeTime = '';
        if (absDifference < 86400000) {
            if (minutes < 60) relativeTime = isFuture ? t('common:time.minutesAhead', 'in {count} minutes', {
                count: minutes
            }) : t('common:time.minutesAgo', '{count} minutes ago', {
                count: minutes
            });
            else relativeTime = isFuture ? t('common:time.todayAhead', 'later today') : t('common:time.today', 'today');
        } else if (absDifference < 172800000) relativeTime = isFuture ? t('common:time.tomorrow', 'tomorrow') : t('common:time.yesterday', 'yesterday');
        else if (absDifference < 2592000000) relativeTime = isFuture ? t('common:time.daysAhead', 'in {count} days', {
            count: days
        }) : t('common:time.daysAgo', '{count} days ago', {
            count: days
        });
        else if (absDifference < 31536000000) relativeTime = isFuture ? t('common:time.monthsAhead', 'in {count} months', {
            count: months
        }) : t('common:time.monthsAgo', '{count} months ago', {
            count: months
        });
        else relativeTime = isFuture ? t('common:time.yearsAhead', 'in {count} years', {
            count: years
        }) : t('common:time.yearsAgo', '{count} years ago', {
            count: years
        });
        return relativeTime;
    }
    return getRelativeTime;
}



/**
 * @import {Element, ElementContent, Nodes, Parents, Root} from 'hast'
 * @import {Root as MdastRoot} from 'mdast'
 * @import {ComponentProps, ElementType, ReactElement} from 'react'
 * @import {Options as RemarkRehypeOptions} from 'remark-rehype'
 * @import {BuildVisitor} from 'unist-util-visit'
 * @import {PluggableList, Processor} from 'unified'
 */ /**
 * @callback AllowElement
 *   Filter elements.
 * @param {Readonly<Element>} element
 *   Element to check.
 * @param {number} index
 *   Index of `element` in `parent`.
 * @param {Readonly<Parents> | undefined} parent
 *   Parent of `element`.
 * @returns {boolean | null | undefined}
 *   Whether to allow `element` (default: `false`).
 */ /**
 * @typedef ExtraProps
 *   Extra fields we pass.
 * @property {Element | undefined} [node]
 *   passed when `passNode` is on.
 */ /**
 * @typedef {{
 *   [Key in Extract<ElementType, string>]?: ElementType<ComponentProps<Key> & ExtraProps>
 * }} Components
 *   Map tag names to components.
 */ /**
 * @typedef Deprecation
 *   Deprecation.
 * @property {string} from
 *   Old field.
 * @property {string} id
 *   ID in readme.
 * @property {keyof Options} [to]
 *   New field.
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {AllowElement | null | undefined} [allowElement]
 *   Filter elements (optional);
 *   `allowedElements` / `disallowedElements` is used first.
 * @property {ReadonlyArray<string> | null | undefined} [allowedElements]
 *   Tag names to allow (default: all tag names);
 *   cannot combine w/ `disallowedElements`.
 * @property {string | null | undefined} [children]
 *   Markdown.
 * @property {string | null | undefined} [className]
 *   Wrap in a `div` with this class name.
 * @property {Components | null | undefined} [components]
 *   Map tag names to components.
 * @property {ReadonlyArray<string> | null | undefined} [disallowedElements]
 *   Tag names to disallow (default: `[]`);
 *   cannot combine w/ `allowedElements`.
 * @property {PluggableList | null | undefined} [rehypePlugins]
 *   List of rehype plugins to use.
 * @property {PluggableList | null | undefined} [remarkPlugins]
 *   List of remark plugins to use.
 * @property {Readonly<RemarkRehypeOptions> | null | undefined} [remarkRehypeOptions]
 *   Options to pass through to `remark-rehype`.
 * @property {boolean | null | undefined} [skipHtml=false]
 *   Ignore HTML in markdown completely (default: `false`).
 * @property {boolean | null | undefined} [unwrapDisallowed=false]
 *   Extract (unwrap) what’s in disallowed elements (default: `false`);
 *   normally when say `strong` is not allowed, it and it’s children are dropped,
 *   with `unwrapDisallowed` the element itself is replaced by its children.
 * @property {UrlTransform | null | undefined} [urlTransform]
 *   Change URLs (default: `defaultUrlTransform`)
 */ /**
 * @callback UrlTransform
 *   Transform all URLs.
 * @param {string} url
 *   URL.
 * @param {string} key
 *   Property name (example: `'href'`).
 * @param {Readonly<Element>} node
 *   Node.
 * @returns {string | null | undefined}
 *   Transformed URL (optional).
 */ function $5f7e7f29fdd0c06b$export$b680e6b2c82f8c2f(fn) {
    return fn;
}
function $5f7e7f29fdd0c06b$export$411ce8e5a71e3069() {}
function $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49() {}
function $5f7e7f29fdd0c06b$export$565e9d9bd6b6e0d4() {}


/**
 * @import {Identifier, Literal, MemberExpression} from 'estree'
 * @import {Jsx, JsxDev, Options, Props} from 'hast-util-to-jsx-runtime'
 * @import {Element, Nodes, Parents, Root, Text} from 'hast'
 * @import {MdxFlowExpressionHast, MdxTextExpressionHast} from 'mdast-util-mdx-expression'
 * @import {MdxJsxFlowElementHast, MdxJsxTextElementHast} from 'mdast-util-mdx-jsx'
 * @import {MdxjsEsmHast} from 'mdast-util-mdxjs-esm'
 * @import {Position} from 'unist'
 * @import {Child, Create, Field, JsxElement, State, Style} from './types.js'
 */ /**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */ /**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */ /**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $9323934601145f2e$export$98e6a39c04603d36(value) {
    /** @type {Array<string>} */ const tokens = [];
    const input = String(value || '');
    let index = input.indexOf(',');
    let start = 0;
    /** @type {boolean} */ let end = false;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        const token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(',', start);
    }
    return tokens;
}
function $9323934601145f2e$export$fac44ee5b035f737(values, options) {
    const settings = options || {};
    // Ensure the last empty entry is seen.
    const input = values[values.length - 1] === '' ? [
        ...values,
        ''
    ] : values;
    return input.join((settings.padRight ? ' ' : '') + ',' + (settings.padLeft === false ? '' : ' ')).trim();
}



/**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [jsx=false]
 *   Support JSX identifiers (default: `false`).
 */ const $8ae047d5df63cb7f$var$startRe = /[$_\p{ID_Start}]/u;
const $8ae047d5df63cb7f$var$contRe = /[$_\u{200C}\u{200D}\p{ID_Continue}]/u;
const $8ae047d5df63cb7f$var$contReJsx = /[-$_\u{200C}\u{200D}\p{ID_Continue}]/u;
const $8ae047d5df63cb7f$var$nameRe = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u;
const $8ae047d5df63cb7f$var$nameReJsx = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u;
/** @type {Options} */ const $8ae047d5df63cb7f$var$emptyOptions = {};
function $8ae047d5df63cb7f$export$b3571188c770cc5a(code) {
    return code ? $8ae047d5df63cb7f$var$startRe.test(String.fromCodePoint(code)) : false;
}
function $8ae047d5df63cb7f$export$10eb6dc47bf009dc(code, options) {
    const settings = options || $8ae047d5df63cb7f$var$emptyOptions;
    const re = settings.jsx ? $8ae047d5df63cb7f$var$contReJsx : $8ae047d5df63cb7f$var$contRe;
    return code ? re.test(String.fromCodePoint(code)) : false;
}
function $8ae047d5df63cb7f$export$a8ff84c12d48cfa6(name, options) {
    const settings = options || $8ae047d5df63cb7f$var$emptyOptions;
    const re = settings.jsx ? $8ae047d5df63cb7f$var$nameReJsx : $8ae047d5df63cb7f$var$nameRe;
    return re.test(name);
}


/**
 * @typedef {import('hast').Nodes} Nodes
 */ // HTML whitespace expression.
// See <https://infra.spec.whatwg.org/#ascii-whitespace>.
const $99728b3b7e804493$var$re = /[ \t\n\f\r]/g;
function $99728b3b7e804493$export$7af1228ff777d175(thing) {
    return typeof thing === 'object' ? thing.type === 'text' ? $99728b3b7e804493$var$empty(thing.value) : false : $99728b3b7e804493$var$empty(thing);
}
/**
 * @param {string} value
 * @returns {boolean}
 */ function $99728b3b7e804493$var$empty(value) {
    return value.replace($99728b3b7e804493$var$re, '') === '';
}


/**
 * @import {Schema} from 'property-information'
 */ /**
 * @import {Space} from 'property-information'
 */ /**
 * @import {Info as InfoType} from 'property-information'
 */ /** @type {InfoType} */ class $f5a64e1dc26e2922$export$c4868e4a24d48fad {
    /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */ constructor(property, attribute){
        this.attribute = attribute;
        this.property = property;
    }
}
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.attribute = '';
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.booleanish = false;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.boolean = false;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.defined = false;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.number = false;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.property = '';
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.space = undefined;


var $6327116045afe73c$exports = {};

$parcel$export($6327116045afe73c$exports, "boolean", function () { return $6327116045afe73c$export$4a21f16c33752377; });
$parcel$export($6327116045afe73c$exports, "booleanish", function () { return $6327116045afe73c$export$55e9e1fbc638dc8f; });
$parcel$export($6327116045afe73c$exports, "overloadedBoolean", function () { return $6327116045afe73c$export$242ac3d3042558aa; });
$parcel$export($6327116045afe73c$exports, "number", function () { return $6327116045afe73c$export$98e628dec113755e; });
$parcel$export($6327116045afe73c$exports, "spaceSeparated", function () { return $6327116045afe73c$export$ab8645c862eb5a3e; });
$parcel$export($6327116045afe73c$exports, "commaSeparated", function () { return $6327116045afe73c$export$9c8d678629b3d3; });
$parcel$export($6327116045afe73c$exports, "commaOrSpaceSeparated", function () { return $6327116045afe73c$export$2ad25cfebf36cacd; });
let $6327116045afe73c$var$powers = 0;
const $6327116045afe73c$export$4a21f16c33752377 = $6327116045afe73c$var$increment();
const $6327116045afe73c$export$55e9e1fbc638dc8f = $6327116045afe73c$var$increment();
const $6327116045afe73c$export$242ac3d3042558aa = $6327116045afe73c$var$increment();
const $6327116045afe73c$export$98e628dec113755e = $6327116045afe73c$var$increment();
const $6327116045afe73c$export$ab8645c862eb5a3e = $6327116045afe73c$var$increment();
const $6327116045afe73c$export$9c8d678629b3d3 = $6327116045afe73c$var$increment();
const $6327116045afe73c$export$2ad25cfebf36cacd = $6327116045afe73c$var$increment();
function $6327116045afe73c$var$increment() {
    return 2 ** ++$6327116045afe73c$var$powers;
}


const $e9abde33d3611e8d$var$checks = /** @type {ReadonlyArray<keyof typeof types>} */ Object.keys($6327116045afe73c$exports);
class $e9abde33d3611e8d$export$ea6b9f0064e88c9b extends (0, $f5a64e1dc26e2922$export$c4868e4a24d48fad) {
    /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $e9abde33d3611e8d$var$mark(this, 'space', space);
        if (typeof mask === 'number') while(++index < $e9abde33d3611e8d$var$checks.length){
            const check = $e9abde33d3611e8d$var$checks[index];
            $e9abde33d3611e8d$var$mark(this, $e9abde33d3611e8d$var$checks[index], (mask & $6327116045afe73c$exports[check]) === $6327116045afe73c$exports[check]);
        }
    }
}
$e9abde33d3611e8d$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @template {keyof DefinedInfo} Key
 *   Key type.
 * @param {DefinedInfo} values
 *   Info.
 * @param {Key} key
 *   Key.
 * @param {DefinedInfo[Key]} value
 *   Value.
 * @returns {undefined}
 *   Nothing.
 */ function $e9abde33d3611e8d$var$mark(values, key, value) {
    if (value) values[key] = value;
}



/**
 * Get the cleaned case insensitive form of an attribute or property.
 *
 * @param {string} value
 *   An attribute-like or property-like name.
 * @returns {string}
 *   Value that can be used to look up the properly cased property on a
 *   `Schema`.
 */ function $e193cc6bfb75f539$export$a3295358bff77e(value) {
    return value.toLowerCase();
}


const $84669bfd2b988556$var$cap = /[A-Z]/g;
const $84669bfd2b988556$var$dash = /-[a-z]/g;
const $84669bfd2b988556$var$valid = /^data[-\w.:]+$/i;
function $84669bfd2b988556$export$71aa6c912b956294(schema, value) {
    const normal = (0, $e193cc6bfb75f539$export$a3295358bff77e)(value);
    let property = value;
    let Type = (0, $f5a64e1dc26e2922$export$c4868e4a24d48fad);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === 'data' && $84669bfd2b988556$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === '-') {
            // Turn it into a property.
            const rest = value.slice(5).replace($84669bfd2b988556$var$dash, $84669bfd2b988556$var$camelcase);
            property = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$84669bfd2b988556$var$dash.test(rest)) {
                let dashes = rest.replace($84669bfd2b988556$var$cap, $84669bfd2b988556$var$kebab);
                if (dashes.charAt(0) !== '-') dashes = '-' + dashes;
                value = 'data' + dashes;
            }
        }
        Type = (0, $e9abde33d3611e8d$export$ea6b9f0064e88c9b);
    }
    return new Type(property, value);
}
/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Kebab.
 */ function $84669bfd2b988556$var$kebab($0) {
    return '-' + $0.toLowerCase();
}
/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Camel.
 */ function $84669bfd2b988556$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}

/**
 * Special cases for React (`Record<string, string>`).
 *
 * `hast` is close to `React` but differs in a couple of cases.
 * To get a React property from a hast property,
 * check if it is in `hastToReact`.
 * If it is, use the corresponding value;
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */ const $a1ae9812302ca8ea$export$d8abd7e5fb6871f9 = {
    classId: 'classID',
    dataType: 'datatype',
    itemId: 'itemID',
    strokeDashArray: 'strokeDasharray',
    strokeDashOffset: 'strokeDashoffset',
    strokeLineCap: 'strokeLinecap',
    strokeLineJoin: 'strokeLinejoin',
    strokeMiterLimit: 'strokeMiterlimit',
    typeOf: 'typeof',
    xLinkActuate: 'xlinkActuate',
    xLinkArcRole: 'xlinkArcrole',
    xLinkHref: 'xlinkHref',
    xLinkRole: 'xlinkRole',
    xLinkShow: 'xlinkShow',
    xLinkTitle: 'xlinkTitle',
    xLinkType: 'xlinkType',
    xmlnsXLink: 'xmlnsXlink'
};

// Note: types exposed from `index.d.ts`.
/**
 * @import {Info, Space} from 'property-information'
 */ /**
 * @import {Schema as SchemaType, Space} from 'property-information'
 */ /** @type {SchemaType} */ class $3f644418d59ec988$export$19342e026b58ebb7 {
    /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */ constructor(property, normal, space){
        this.normal = normal;
        this.property = property;
        if (space) this.space = space;
    }
}
$3f644418d59ec988$export$19342e026b58ebb7.prototype.normal = {};
$3f644418d59ec988$export$19342e026b58ebb7.prototype.property = {};
$3f644418d59ec988$export$19342e026b58ebb7.prototype.space = undefined;


function $f22be46171b10c63$export$4950aa0f605343fb(definitions, space) {
    /** @type {Record<string, Info>} */ const property = {};
    /** @type {Record<string, string>} */ const normal = {};
    for (const definition of definitions){
        Object.assign(property, definition.property);
        Object.assign(normal, definition.normal);
    }
    return new (0, $3f644418d59ec988$export$19342e026b58ebb7)(property, normal, space);
}


/**
 * @import {Info, Space} from 'property-information'
 */ /**
 * @typedef Definition
 *   Definition of a schema.
 * @property {Record<string, string> | undefined} [attributes]
 *   Normalzed names to special attribute case.
 * @property {ReadonlyArray<string> | undefined} [mustUseProperty]
 *   Normalized names that must be set as properties.
 * @property {Record<string, number | null>} properties
 *   Property names to their types.
 * @property {Space | undefined} [space]
 *   Space.
 * @property {Transform} transform
 *   Transform a property name.
 */ /**
 * @callback Transform
 *   Transform.
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} property
 *   Property.
 * @returns {string}
 *   Attribute.
 */ 


function $9241b59662c8e4b9$export$185802fd694ee1f5(definition) {
    /** @type {Record<string, Info>} */ const properties = {};
    /** @type {Record<string, string>} */ const normals = {};
    for (const [property, value] of Object.entries(definition.properties)){
        const info = new (0, $e9abde33d3611e8d$export$ea6b9f0064e88c9b)(property, definition.transform(definition.attributes || {}, property), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(property)) info.mustUseProperty = true;
        properties[property] = info;
        normals[(0, $e193cc6bfb75f539$export$a3295358bff77e)(property)] = property;
        normals[(0, $e193cc6bfb75f539$export$a3295358bff77e)(info.attribute)] = property;
    }
    return new (0, $3f644418d59ec988$export$19342e026b58ebb7)(properties, normals, definition.space);
}



const $f6c2d7ac952f45ea$export$4d2d26490572750a = (0, $9241b59662c8e4b9$export$185802fd694ee1f5)({
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaAutoComplete: null,
        ariaBusy: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaChecked: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaColCount: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaColIndex: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaColSpan: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaControls: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        ariaCurrent: null,
        ariaDescribedBy: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        ariaDetails: null,
        ariaDisabled: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaDropEffect: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        ariaErrorMessage: null,
        ariaExpanded: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaFlowTo: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        ariaGrabbed: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaHasPopup: null,
        ariaHidden: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        ariaLevel: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaLive: null,
        ariaModal: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaMultiLine: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaMultiSelectable: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaOrientation: null,
        ariaOwns: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaPressed: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaReadOnly: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaRelevant: null,
        ariaRequired: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaRoleDescription: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        ariaRowCount: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaRowIndex: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaRowSpan: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaSelected: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaSetSize: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaSort: null,
        ariaValueMax: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaValueMin: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaValueNow: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaValueText: null,
        role: null
    },
    transform (_, property) {
        return property === 'role' ? property : 'aria-' + property.slice(4).toLowerCase();
    }
});


/**
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} attribute
 *   Attribute.
 * @returns {string}
 *   Transformed attribute.
 */ function $57102789fbb4388b$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


function $f66392ca00ae8b5e$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $57102789fbb4388b$export$5b10b3bc32d7efbc)(attributes, property.toLowerCase());
}




const $aed0b684443ef64e$export$c0bb0b647f701bb5 = (0, $9241b59662c8e4b9$export$185802fd694ee1f5)({
    attributes: {
        acceptcharset: 'accept-charset',
        classname: 'class',
        htmlfor: 'for',
        httpequiv: 'http-equiv'
    },
    mustUseProperty: [
        'checked',
        'multiple',
        'muted',
        'selected'
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $6327116045afe73c$export$9c8d678629b3d3),
        acceptCharset: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        accessKey: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        action: null,
        allow: null,
        allowFullScreen: (0, $6327116045afe73c$export$4a21f16c33752377),
        allowPaymentRequest: (0, $6327116045afe73c$export$4a21f16c33752377),
        allowUserMedia: (0, $6327116045afe73c$export$4a21f16c33752377),
        alt: null,
        as: null,
        async: (0, $6327116045afe73c$export$4a21f16c33752377),
        autoCapitalize: null,
        autoComplete: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        autoFocus: (0, $6327116045afe73c$export$4a21f16c33752377),
        autoPlay: (0, $6327116045afe73c$export$4a21f16c33752377),
        blocking: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        capture: null,
        charSet: null,
        checked: (0, $6327116045afe73c$export$4a21f16c33752377),
        cite: null,
        className: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        cols: (0, $6327116045afe73c$export$98e628dec113755e),
        colSpan: null,
        content: null,
        contentEditable: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        controls: (0, $6327116045afe73c$export$4a21f16c33752377),
        controlsList: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        coords: (0, $6327116045afe73c$export$98e628dec113755e) | (0, $6327116045afe73c$export$9c8d678629b3d3),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $6327116045afe73c$export$4a21f16c33752377),
        defer: (0, $6327116045afe73c$export$4a21f16c33752377),
        dir: null,
        dirName: null,
        disabled: (0, $6327116045afe73c$export$4a21f16c33752377),
        download: (0, $6327116045afe73c$export$242ac3d3042558aa),
        draggable: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        encType: null,
        enterKeyHint: null,
        fetchPriority: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $6327116045afe73c$export$4a21f16c33752377),
        formTarget: null,
        headers: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        height: (0, $6327116045afe73c$export$98e628dec113755e),
        hidden: (0, $6327116045afe73c$export$242ac3d3042558aa),
        high: (0, $6327116045afe73c$export$98e628dec113755e),
        href: null,
        hrefLang: null,
        htmlFor: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        httpEquiv: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inert: (0, $6327116045afe73c$export$4a21f16c33752377),
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $6327116045afe73c$export$4a21f16c33752377),
        itemId: null,
        itemProp: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        itemRef: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        itemScope: (0, $6327116045afe73c$export$4a21f16c33752377),
        itemType: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $6327116045afe73c$export$4a21f16c33752377),
        low: (0, $6327116045afe73c$export$98e628dec113755e),
        manifest: null,
        max: null,
        maxLength: (0, $6327116045afe73c$export$98e628dec113755e),
        media: null,
        method: null,
        min: null,
        minLength: (0, $6327116045afe73c$export$98e628dec113755e),
        multiple: (0, $6327116045afe73c$export$4a21f16c33752377),
        muted: (0, $6327116045afe73c$export$4a21f16c33752377),
        name: null,
        nonce: null,
        noModule: (0, $6327116045afe73c$export$4a21f16c33752377),
        noValidate: (0, $6327116045afe73c$export$4a21f16c33752377),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeToggle: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $6327116045afe73c$export$4a21f16c33752377),
        optimum: (0, $6327116045afe73c$export$98e628dec113755e),
        pattern: null,
        ping: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        placeholder: null,
        playsInline: (0, $6327116045afe73c$export$4a21f16c33752377),
        popover: null,
        popoverTarget: null,
        popoverTargetAction: null,
        poster: null,
        preload: null,
        readOnly: (0, $6327116045afe73c$export$4a21f16c33752377),
        referrerPolicy: null,
        rel: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        required: (0, $6327116045afe73c$export$4a21f16c33752377),
        reversed: (0, $6327116045afe73c$export$4a21f16c33752377),
        rows: (0, $6327116045afe73c$export$98e628dec113755e),
        rowSpan: (0, $6327116045afe73c$export$98e628dec113755e),
        sandbox: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        scope: null,
        scoped: (0, $6327116045afe73c$export$4a21f16c33752377),
        seamless: (0, $6327116045afe73c$export$4a21f16c33752377),
        selected: (0, $6327116045afe73c$export$4a21f16c33752377),
        shadowRootClonable: (0, $6327116045afe73c$export$4a21f16c33752377),
        shadowRootDelegatesFocus: (0, $6327116045afe73c$export$4a21f16c33752377),
        shadowRootMode: null,
        shape: null,
        size: (0, $6327116045afe73c$export$98e628dec113755e),
        sizes: null,
        slot: null,
        span: (0, $6327116045afe73c$export$98e628dec113755e),
        spellCheck: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $6327116045afe73c$export$98e628dec113755e),
        step: null,
        style: null,
        tabIndex: (0, $6327116045afe73c$export$98e628dec113755e),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $6327116045afe73c$export$4a21f16c33752377),
        useMap: null,
        value: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        width: (0, $6327116045afe73c$export$98e628dec113755e),
        wrap: null,
        writingSuggestions: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $6327116045afe73c$export$98e628dec113755e),
        borderColor: null,
        bottomMargin: (0, $6327116045afe73c$export$98e628dec113755e),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $6327116045afe73c$export$4a21f16c33752377),
        declare: (0, $6327116045afe73c$export$4a21f16c33752377),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $6327116045afe73c$export$98e628dec113755e),
        leftMargin: (0, $6327116045afe73c$export$98e628dec113755e),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $6327116045afe73c$export$98e628dec113755e),
        marginWidth: (0, $6327116045afe73c$export$98e628dec113755e),
        noResize: (0, $6327116045afe73c$export$4a21f16c33752377),
        noHref: (0, $6327116045afe73c$export$4a21f16c33752377),
        noShade: (0, $6327116045afe73c$export$4a21f16c33752377),
        noWrap: (0, $6327116045afe73c$export$4a21f16c33752377),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $6327116045afe73c$export$98e628dec113755e),
        rules: null,
        scheme: null,
        scrolling: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $6327116045afe73c$export$98e628dec113755e),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $6327116045afe73c$export$98e628dec113755e),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: (0, $6327116045afe73c$export$4a21f16c33752377),
        disableRemotePlayback: (0, $6327116045afe73c$export$4a21f16c33752377),
        prefix: null,
        property: null,
        results: (0, $6327116045afe73c$export$98e628dec113755e),
        security: null,
        unselectable: null
    },
    space: 'html',
    transform: (0, $f66392ca00ae8b5e$export$32b9e4cec9c208e1)
});





const $098f3c17bccabf6d$export$7ed1367e7fa1ad68 = (0, $9241b59662c8e4b9$export$185802fd694ee1f5)({
    attributes: {
        accentHeight: 'accent-height',
        alignmentBaseline: 'alignment-baseline',
        arabicForm: 'arabic-form',
        baselineShift: 'baseline-shift',
        capHeight: 'cap-height',
        className: 'class',
        clipPath: 'clip-path',
        clipRule: 'clip-rule',
        colorInterpolation: 'color-interpolation',
        colorInterpolationFilters: 'color-interpolation-filters',
        colorProfile: 'color-profile',
        colorRendering: 'color-rendering',
        crossOrigin: 'crossorigin',
        dataType: 'datatype',
        dominantBaseline: 'dominant-baseline',
        enableBackground: 'enable-background',
        fillOpacity: 'fill-opacity',
        fillRule: 'fill-rule',
        floodColor: 'flood-color',
        floodOpacity: 'flood-opacity',
        fontFamily: 'font-family',
        fontSize: 'font-size',
        fontSizeAdjust: 'font-size-adjust',
        fontStretch: 'font-stretch',
        fontStyle: 'font-style',
        fontVariant: 'font-variant',
        fontWeight: 'font-weight',
        glyphName: 'glyph-name',
        glyphOrientationHorizontal: 'glyph-orientation-horizontal',
        glyphOrientationVertical: 'glyph-orientation-vertical',
        hrefLang: 'hreflang',
        horizAdvX: 'horiz-adv-x',
        horizOriginX: 'horiz-origin-x',
        horizOriginY: 'horiz-origin-y',
        imageRendering: 'image-rendering',
        letterSpacing: 'letter-spacing',
        lightingColor: 'lighting-color',
        markerEnd: 'marker-end',
        markerMid: 'marker-mid',
        markerStart: 'marker-start',
        navDown: 'nav-down',
        navDownLeft: 'nav-down-left',
        navDownRight: 'nav-down-right',
        navLeft: 'nav-left',
        navNext: 'nav-next',
        navPrev: 'nav-prev',
        navRight: 'nav-right',
        navUp: 'nav-up',
        navUpLeft: 'nav-up-left',
        navUpRight: 'nav-up-right',
        onAbort: 'onabort',
        onActivate: 'onactivate',
        onAfterPrint: 'onafterprint',
        onBeforePrint: 'onbeforeprint',
        onBegin: 'onbegin',
        onCancel: 'oncancel',
        onCanPlay: 'oncanplay',
        onCanPlayThrough: 'oncanplaythrough',
        onChange: 'onchange',
        onClick: 'onclick',
        onClose: 'onclose',
        onCopy: 'oncopy',
        onCueChange: 'oncuechange',
        onCut: 'oncut',
        onDblClick: 'ondblclick',
        onDrag: 'ondrag',
        onDragEnd: 'ondragend',
        onDragEnter: 'ondragenter',
        onDragExit: 'ondragexit',
        onDragLeave: 'ondragleave',
        onDragOver: 'ondragover',
        onDragStart: 'ondragstart',
        onDrop: 'ondrop',
        onDurationChange: 'ondurationchange',
        onEmptied: 'onemptied',
        onEnd: 'onend',
        onEnded: 'onended',
        onError: 'onerror',
        onFocus: 'onfocus',
        onFocusIn: 'onfocusin',
        onFocusOut: 'onfocusout',
        onHashChange: 'onhashchange',
        onInput: 'oninput',
        onInvalid: 'oninvalid',
        onKeyDown: 'onkeydown',
        onKeyPress: 'onkeypress',
        onKeyUp: 'onkeyup',
        onLoad: 'onload',
        onLoadedData: 'onloadeddata',
        onLoadedMetadata: 'onloadedmetadata',
        onLoadStart: 'onloadstart',
        onMessage: 'onmessage',
        onMouseDown: 'onmousedown',
        onMouseEnter: 'onmouseenter',
        onMouseLeave: 'onmouseleave',
        onMouseMove: 'onmousemove',
        onMouseOut: 'onmouseout',
        onMouseOver: 'onmouseover',
        onMouseUp: 'onmouseup',
        onMouseWheel: 'onmousewheel',
        onOffline: 'onoffline',
        onOnline: 'ononline',
        onPageHide: 'onpagehide',
        onPageShow: 'onpageshow',
        onPaste: 'onpaste',
        onPause: 'onpause',
        onPlay: 'onplay',
        onPlaying: 'onplaying',
        onPopState: 'onpopstate',
        onProgress: 'onprogress',
        onRateChange: 'onratechange',
        onRepeat: 'onrepeat',
        onReset: 'onreset',
        onResize: 'onresize',
        onScroll: 'onscroll',
        onSeeked: 'onseeked',
        onSeeking: 'onseeking',
        onSelect: 'onselect',
        onShow: 'onshow',
        onStalled: 'onstalled',
        onStorage: 'onstorage',
        onSubmit: 'onsubmit',
        onSuspend: 'onsuspend',
        onTimeUpdate: 'ontimeupdate',
        onToggle: 'ontoggle',
        onUnload: 'onunload',
        onVolumeChange: 'onvolumechange',
        onWaiting: 'onwaiting',
        onZoom: 'onzoom',
        overlinePosition: 'overline-position',
        overlineThickness: 'overline-thickness',
        paintOrder: 'paint-order',
        panose1: 'panose-1',
        pointerEvents: 'pointer-events',
        referrerPolicy: 'referrerpolicy',
        renderingIntent: 'rendering-intent',
        shapeRendering: 'shape-rendering',
        stopColor: 'stop-color',
        stopOpacity: 'stop-opacity',
        strikethroughPosition: 'strikethrough-position',
        strikethroughThickness: 'strikethrough-thickness',
        strokeDashArray: 'stroke-dasharray',
        strokeDashOffset: 'stroke-dashoffset',
        strokeLineCap: 'stroke-linecap',
        strokeLineJoin: 'stroke-linejoin',
        strokeMiterLimit: 'stroke-miterlimit',
        strokeOpacity: 'stroke-opacity',
        strokeWidth: 'stroke-width',
        tabIndex: 'tabindex',
        textAnchor: 'text-anchor',
        textDecoration: 'text-decoration',
        textRendering: 'text-rendering',
        transformOrigin: 'transform-origin',
        typeOf: 'typeof',
        underlinePosition: 'underline-position',
        underlineThickness: 'underline-thickness',
        unicodeBidi: 'unicode-bidi',
        unicodeRange: 'unicode-range',
        unitsPerEm: 'units-per-em',
        vAlphabetic: 'v-alphabetic',
        vHanging: 'v-hanging',
        vIdeographic: 'v-ideographic',
        vMathematical: 'v-mathematical',
        vectorEffect: 'vector-effect',
        vertAdvY: 'vert-adv-y',
        vertOriginX: 'vert-origin-x',
        vertOriginY: 'vert-origin-y',
        wordSpacing: 'word-spacing',
        writingMode: 'writing-mode',
        xHeight: 'x-height',
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: 'playbackorder',
        timelineBegin: 'timelinebegin'
    },
    properties: {
        about: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        accentHeight: (0, $6327116045afe73c$export$98e628dec113755e),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $6327116045afe73c$export$98e628dec113755e),
        amplitude: (0, $6327116045afe73c$export$98e628dec113755e),
        arabicForm: null,
        ascent: (0, $6327116045afe73c$export$98e628dec113755e),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $6327116045afe73c$export$98e628dec113755e),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $6327116045afe73c$export$98e628dec113755e),
        by: null,
        calcMode: null,
        capHeight: (0, $6327116045afe73c$export$98e628dec113755e),
        className: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $6327116045afe73c$export$98e628dec113755e),
        diffuseConstant: (0, $6327116045afe73c$export$98e628dec113755e),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $6327116045afe73c$export$98e628dec113755e),
        dominantBaseline: null,
        download: (0, $6327116045afe73c$export$4a21f16c33752377),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $6327116045afe73c$export$98e628dec113755e),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $6327116045afe73c$export$98e628dec113755e),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $6327116045afe73c$export$98e628dec113755e),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $6327116045afe73c$export$9c8d678629b3d3),
        g2: (0, $6327116045afe73c$export$9c8d678629b3d3),
        glyphName: (0, $6327116045afe73c$export$9c8d678629b3d3),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $6327116045afe73c$export$98e628dec113755e),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $6327116045afe73c$export$98e628dec113755e),
        horizOriginX: (0, $6327116045afe73c$export$98e628dec113755e),
        horizOriginY: (0, $6327116045afe73c$export$98e628dec113755e),
        id: null,
        ideographic: (0, $6327116045afe73c$export$98e628dec113755e),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $6327116045afe73c$export$98e628dec113755e),
        k: (0, $6327116045afe73c$export$98e628dec113755e),
        k1: (0, $6327116045afe73c$export$98e628dec113755e),
        k2: (0, $6327116045afe73c$export$98e628dec113755e),
        k3: (0, $6327116045afe73c$export$98e628dec113755e),
        k4: (0, $6327116045afe73c$export$98e628dec113755e),
        kernelMatrix: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $6327116045afe73c$export$98e628dec113755e),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $6327116045afe73c$export$98e628dec113755e),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $6327116045afe73c$export$98e628dec113755e),
        overlineThickness: (0, $6327116045afe73c$export$98e628dec113755e),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $6327116045afe73c$export$98e628dec113755e),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $6327116045afe73c$export$98e628dec113755e),
        pointsAtY: (0, $6327116045afe73c$export$98e628dec113755e),
        pointsAtZ: (0, $6327116045afe73c$export$98e628dec113755e),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        rev: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        requiredFeatures: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        requiredFonts: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        requiredFormats: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $6327116045afe73c$export$98e628dec113755e),
        specularExponent: (0, $6327116045afe73c$export$98e628dec113755e),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $6327116045afe73c$export$98e628dec113755e),
        strikethroughThickness: (0, $6327116045afe73c$export$98e628dec113755e),
        string: null,
        stroke: null,
        strokeDashArray: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $6327116045afe73c$export$98e628dec113755e),
        strokeOpacity: (0, $6327116045afe73c$export$98e628dec113755e),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $6327116045afe73c$export$98e628dec113755e),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        tabIndex: (0, $6327116045afe73c$export$98e628dec113755e),
        tableValues: null,
        target: null,
        targetX: (0, $6327116045afe73c$export$98e628dec113755e),
        targetY: (0, $6327116045afe73c$export$98e628dec113755e),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        to: null,
        transform: null,
        transformOrigin: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $6327116045afe73c$export$98e628dec113755e),
        underlineThickness: (0, $6327116045afe73c$export$98e628dec113755e),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $6327116045afe73c$export$98e628dec113755e),
        values: null,
        vAlphabetic: (0, $6327116045afe73c$export$98e628dec113755e),
        vMathematical: (0, $6327116045afe73c$export$98e628dec113755e),
        vectorEffect: null,
        vHanging: (0, $6327116045afe73c$export$98e628dec113755e),
        vIdeographic: (0, $6327116045afe73c$export$98e628dec113755e),
        version: null,
        vertAdvY: (0, $6327116045afe73c$export$98e628dec113755e),
        vertOriginX: (0, $6327116045afe73c$export$98e628dec113755e),
        vertOriginY: (0, $6327116045afe73c$export$98e628dec113755e),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $6327116045afe73c$export$98e628dec113755e),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    },
    space: 'svg',
    transform: (0, $57102789fbb4388b$export$5b10b3bc32d7efbc)
});



const $f7b1fe9153b66aca$export$2bd1230ec7600845 = (0, $9241b59662c8e4b9$export$185802fd694ee1f5)({
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    },
    space: 'xlink',
    transform (_, property) {
        return 'xlink:' + property.slice(5).toLowerCase();
    }
});




const $d677600be62c9ee2$export$e20c24a128671213 = (0, $9241b59662c8e4b9$export$185802fd694ee1f5)({
    attributes: {
        xmlnsxlink: 'xmlns:xlink'
    },
    properties: {
        xmlnsXLink: null,
        xmlns: null
    },
    space: 'xmlns',
    transform: (0, $f66392ca00ae8b5e$export$32b9e4cec9c208e1)
});



const $2258d34ea2045e6e$export$f2913fe8983302e = (0, $9241b59662c8e4b9$export$185802fd694ee1f5)({
    properties: {
        xmlBase: null,
        xmlLang: null,
        xmlSpace: null
    },
    space: 'xml',
    transform (_, property) {
        return 'xml:' + property.slice(3).toLowerCase();
    }
});





const $cad208d20be39d74$export$c0bb0b647f701bb5 = (0, $f22be46171b10c63$export$4950aa0f605343fb)([
    (0, $f6c2d7ac952f45ea$export$4d2d26490572750a),
    (0, $aed0b684443ef64e$export$c0bb0b647f701bb5),
    (0, $f7b1fe9153b66aca$export$2bd1230ec7600845),
    (0, $d677600be62c9ee2$export$e20c24a128671213),
    (0, $2258d34ea2045e6e$export$f2913fe8983302e)
], 'html');
const $cad208d20be39d74$export$7ed1367e7fa1ad68 = (0, $f22be46171b10c63$export$4950aa0f605343fb)([
    (0, $f6c2d7ac952f45ea$export$4d2d26490572750a),
    (0, $098f3c17bccabf6d$export$7ed1367e7fa1ad68),
    (0, $f7b1fe9153b66aca$export$2bd1230ec7600845),
    (0, $d677600be62c9ee2$export$e20c24a128671213),
    (0, $2258d34ea2045e6e$export$f2913fe8983302e)
], 'svg');


/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $0d98344a9bfa0653$export$98e6a39c04603d36(value) {
    const input = String(value || '').trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $0d98344a9bfa0653$export$fac44ee5b035f737(values) {
    return values.join(' ').trim();
}


var $f27ef1e87b7b8987$exports = {};
"use strict";
var $f27ef1e87b7b8987$var$__importDefault = $f27ef1e87b7b8987$exports && $f27ef1e87b7b8987$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};

var $f27ef1e87b7b8987$var$style_to_object_1 = $f27ef1e87b7b8987$var$__importDefault((parcelRequire("iBNfx")));
var $e3fbc6aceeefe6b0$exports = {};
"use strict";
Object.defineProperty($e3fbc6aceeefe6b0$exports, "__esModule", {
    value: true
});
$e3fbc6aceeefe6b0$exports.camelCase = void 0;
var $e3fbc6aceeefe6b0$var$CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9_-]+$/;
var $e3fbc6aceeefe6b0$var$HYPHEN_REGEX = /-([a-z])/g;
var $e3fbc6aceeefe6b0$var$NO_HYPHEN_REGEX = /^[^-]+$/;
var $e3fbc6aceeefe6b0$var$VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
var $e3fbc6aceeefe6b0$var$MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
/**
 * Checks whether to skip camelCase.
 */ var $e3fbc6aceeefe6b0$var$skipCamelCase = function(property) {
    return !property || $e3fbc6aceeefe6b0$var$NO_HYPHEN_REGEX.test(property) || $e3fbc6aceeefe6b0$var$CUSTOM_PROPERTY_REGEX.test(property);
};
/**
 * Replacer that capitalizes first character.
 */ var $e3fbc6aceeefe6b0$var$capitalize = function(match, character) {
    return character.toUpperCase();
};
/**
 * Replacer that removes beginning hyphen of vendor prefix property.
 */ var $e3fbc6aceeefe6b0$var$trimHyphen = function(match, prefix) {
    return "".concat(prefix, "-");
};
/**
 * CamelCases a CSS property.
 */ var $e3fbc6aceeefe6b0$var$camelCase = function(property, options) {
    if (options === void 0) options = {};
    if ($e3fbc6aceeefe6b0$var$skipCamelCase(property)) return property;
    property = property.toLowerCase();
    if (options.reactCompat) // `-ms` vendor prefix should not be capitalized
    property = property.replace($e3fbc6aceeefe6b0$var$MS_VENDOR_PREFIX_REGEX, $e3fbc6aceeefe6b0$var$trimHyphen);
    else // for non-React, remove first hyphen so vendor prefix is not capitalized
    property = property.replace($e3fbc6aceeefe6b0$var$VENDOR_PREFIX_REGEX, $e3fbc6aceeefe6b0$var$trimHyphen);
    return property.replace($e3fbc6aceeefe6b0$var$HYPHEN_REGEX, $e3fbc6aceeefe6b0$var$capitalize);
};
$e3fbc6aceeefe6b0$exports.camelCase = $e3fbc6aceeefe6b0$var$camelCase;


/**
 * Parses CSS inline style to JavaScript object (camelCased).
 */ function $f27ef1e87b7b8987$var$StyleToJS(style, options) {
    var output = {};
    if (!style || typeof style !== 'string') return output;
    (0, $f27ef1e87b7b8987$var$style_to_object_1.default)(style, function(property, value) {
        // skip CSS comment
        if (property && value) output[(0, $e3fbc6aceeefe6b0$exports.camelCase)(property, options)] = value;
    });
    return output;
}
$f27ef1e87b7b8987$var$StyleToJS.default = $f27ef1e87b7b8987$var$StyleToJS;
$f27ef1e87b7b8987$exports = $f27ef1e87b7b8987$var$StyleToJS;


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Get the ending point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */ const $9861e7b4f8df2806$export$da309cdce9dc2a25 = $9861e7b4f8df2806$var$point('end');
const $9861e7b4f8df2806$export$771bf3e4949bfbee = $9861e7b4f8df2806$var$point('start');
/**
 * Get the positional info of `node`.
 *
 * @param {'end' | 'start'} type
 *   Side.
 * @returns
 *   Getter.
 */ function $9861e7b4f8df2806$var$point(type) {
    return point;
    /**
   * Get the point info of `node` at a bound side.
   *
   * @param {Node | NodeLike | null | undefined} [node]
   * @returns {Point | undefined}
   */ function point(node) {
        const point = node && node.position && node.position[type] || {};
        if (typeof point.line === 'number' && point.line > 0 && typeof point.column === 'number' && point.column > 0) return {
            line: point.line,
            column: point.column,
            offset: typeof point.offset === 'number' && point.offset > -1 ? point.offset : undefined
        };
    }
}
function $9861e7b4f8df2806$export$5880b8b5730aff45(node) {
    const start = $9861e7b4f8df2806$export$771bf3e4949bfbee(node);
    const end = $9861e7b4f8df2806$export$da309cdce9dc2a25(node);
    if (start && end) return {
        start: start,
        end: end
    };
}


/**
 * @import {Node, Point, Position} from 'unist'
 */ /**
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef Options
 *   Configuration.
 * @property {Array<Node> | null | undefined} [ancestors]
 *   Stack of (inclusive) ancestor nodes surrounding the message (optional).
 * @property {Error | null | undefined} [cause]
 *   Original error cause of the message (optional).
 * @property {Point | Position | null | undefined} [place]
 *   Place of message (optional).
 * @property {string | null | undefined} [ruleId]
 *   Category of message (optional, example: `'my-rule'`).
 * @property {string | null | undefined} [source]
 *   Namespace of who sent the message (optional, example: `'my-package'`).
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Point | PointLike | Position | PositionLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $451965882c5a8799$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== 'object') return '';
    // Node.
    if ('position' in value || 'type' in value) return $451965882c5a8799$var$position(value.position);
    // Position.
    if ('start' in value || 'end' in value) return $451965882c5a8799$var$position(value);
    // Point.
    if ('line' in value || 'column' in value) return $451965882c5a8799$var$point(value);
    // ?
    return '';
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $451965882c5a8799$var$point(point) {
    return $451965882c5a8799$var$index(point && point.line) + ':' + $451965882c5a8799$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $451965882c5a8799$var$position(pos) {
    return $451965882c5a8799$var$point(pos && pos.start) + '-' + $451965882c5a8799$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $451965882c5a8799$var$index(value) {
    return value && typeof value === 'number' ? value : 1;
}


class $0aa9ed7423c10921$export$752e5c445fe834ef extends Error {
    /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */ // eslint-disable-next-line complexity
    constructor(causeOrReason, optionsOrParentOrPlace, origin){
        super();
        if (typeof optionsOrParentOrPlace === 'string') {
            origin = optionsOrParentOrPlace;
            optionsOrParentOrPlace = undefined;
        }
        /** @type {string} */ let reason = '';
        /** @type {Options} */ let options = {};
        let legacyCause = false;
        if (optionsOrParentOrPlace) {
            // Point.
            if ('line' in optionsOrParentOrPlace && 'column' in optionsOrParentOrPlace) options = {
                place: optionsOrParentOrPlace
            };
            else if ('start' in optionsOrParentOrPlace && 'end' in optionsOrParentOrPlace) options = {
                place: optionsOrParentOrPlace
            };
            else if ('type' in optionsOrParentOrPlace) options = {
                ancestors: [
                    optionsOrParentOrPlace
                ],
                place: optionsOrParentOrPlace.position
            };
            else options = {
                ...optionsOrParentOrPlace
            };
        }
        if (typeof causeOrReason === 'string') reason = causeOrReason;
        else if (!options.cause && causeOrReason) {
            legacyCause = true;
            reason = causeOrReason.message;
            options.cause = causeOrReason;
        }
        if (!options.ruleId && !options.source && typeof origin === 'string') {
            const index = origin.indexOf(':');
            if (index === -1) options.ruleId = origin;
            else {
                options.source = origin.slice(0, index);
                options.ruleId = origin.slice(index + 1);
            }
        }
        if (!options.place && options.ancestors && options.ancestors) {
            const parent = options.ancestors[options.ancestors.length - 1];
            if (parent) options.place = parent.position;
        }
        const start = options.place && 'start' in options.place ? options.place.start : options.place;
        /**
     * Stack of ancestor nodes surrounding the message.
     *
     * @type {Array<Node> | undefined}
     */ this.ancestors = options.ancestors || undefined;
        /**
     * Original error cause of the message.
     *
     * @type {Error | undefined}
     */ this.cause = options.cause || undefined;
        /**
     * Starting column of message.
     *
     * @type {number | undefined}
     */ this.column = start ? start.column : undefined;
        /**
     * State of problem.
     *
     * * `true` — error, file not usable
     * * `false` — warning, change may be needed
     * * `undefined` — change likely not needed
     *
     * @type {boolean | null | undefined}
     */ this.fatal = undefined;
        /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | undefined}
     */ this.file = '';
        // Field from `Error`.
        /**
     * Reason for message.
     *
     * @type {string}
     */ this.message = reason;
        /**
     * Starting line of error.
     *
     * @type {number | undefined}
     */ this.line = start ? start.line : undefined;
        // Field from `Error`.
        /**
     * Serialized positional info of message.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */ this.name = (0, $451965882c5a8799$export$c304dd45fe166145)(options.place) || '1:1';
        /**
     * Place of message.
     *
     * @type {Point | Position | undefined}
     */ this.place = options.place || undefined;
        /**
     * Reason for message, should use markdown.
     *
     * @type {string}
     */ this.reason = this.message;
        /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | undefined}
     */ this.ruleId = options.ruleId || undefined;
        /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | undefined}
     */ this.source = options.source || undefined;
        // Field from `Error`.
        /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */ this.stack = legacyCause && options.cause && typeof options.cause.stack === 'string' ? options.cause.stack : '';
        // The following fields are “well known”.
        // Not standard.
        // Feel free to add other non-standard fields to your messages.
        /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | undefined}
     */ this.actual = undefined;
        /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | undefined}
     */ this.expected = undefined;
        /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | undefined}
     */ this.note = undefined;
        /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | undefined}
     */ this.url = undefined;
    }
}
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.file = '';
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.name = '';
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.reason = '';
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.message = '';
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.stack = '';
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.column = undefined;
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.line = undefined;
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.ancestors = undefined;
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.cause = undefined;
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.fatal = undefined;
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.place = undefined;
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.ruleId = undefined;
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.source = undefined;


// To do: next major: `Object.hasOwn`.
const $bcaef7e086af7de5$var$own = {}.hasOwnProperty;
/** @type {Map<string, number>} */ const $bcaef7e086af7de5$var$emptyMap = new Map();
const $bcaef7e086af7de5$var$cap = /[A-Z]/g;
// `react-dom` triggers a warning for *any* white space in tables.
// To follow GFM, `mdast-util-to-hast` injects line endings between elements.
// Other tools might do so too, but they don’t do here, so we remove all of
// that.
// See: <https://github.com/facebook/react/pull/7081>.
// See: <https://github.com/facebook/react/pull/7515>.
// See: <https://github.com/remarkjs/remark-react/issues/64>.
// See: <https://github.com/rehypejs/rehype-react/pull/29>.
// See: <https://github.com/rehypejs/rehype-react/pull/32>.
// See: <https://github.com/rehypejs/rehype-react/pull/45>.
const $bcaef7e086af7de5$var$tableElements = new Set([
    'table',
    'tbody',
    'thead',
    'tfoot',
    'tr'
]);
const $bcaef7e086af7de5$var$tableCellElement = new Set([
    'td',
    'th'
]);
const $bcaef7e086af7de5$var$docs = 'https://github.com/syntax-tree/hast-util-to-jsx-runtime';
function $bcaef7e086af7de5$export$59c10052b2dee561(tree, options) {
    if (!options || options.Fragment === undefined) throw new TypeError('Expected `Fragment` in options');
    const filePath = options.filePath || undefined;
    /** @type {Create} */ let create;
    if (options.development) {
        if (typeof options.jsxDEV !== 'function') throw new TypeError('Expected `jsxDEV` in options when `development: true`');
        create = $bcaef7e086af7de5$var$developmentCreate(filePath, options.jsxDEV);
    } else {
        if (typeof options.jsx !== 'function') throw new TypeError('Expected `jsx` in production options');
        if (typeof options.jsxs !== 'function') throw new TypeError('Expected `jsxs` in production options');
        create = $bcaef7e086af7de5$var$productionCreate(filePath, options.jsx, options.jsxs);
    }
    /** @type {State} */ const state = {
        Fragment: options.Fragment,
        ancestors: [],
        components: options.components || {},
        create: create,
        elementAttributeNameCase: options.elementAttributeNameCase || 'react',
        evaluater: options.createEvaluater ? options.createEvaluater() : undefined,
        filePath: filePath,
        ignoreInvalidStyle: options.ignoreInvalidStyle || false,
        passKeys: options.passKeys !== false,
        passNode: options.passNode || false,
        schema: options.space === 'svg' ? (0, $cad208d20be39d74$export$7ed1367e7fa1ad68) : (0, $cad208d20be39d74$export$c0bb0b647f701bb5),
        stylePropertyNameCase: options.stylePropertyNameCase || 'dom',
        tableCellAlignToStyle: options.tableCellAlignToStyle !== false
    };
    const result = $bcaef7e086af7de5$var$one(state, tree, undefined);
    // JSX element.
    if (result && typeof result !== 'string') return result;
    // Text node or something that turned into nothing.
    return state.create(tree, state.Fragment, {
        children: result || undefined
    }, undefined);
}
/**
 * Transform a node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Nodes} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $bcaef7e086af7de5$var$one(state, node, key) {
    if (node.type === 'element') return $bcaef7e086af7de5$var$element(state, node, key);
    if (node.type === 'mdxFlowExpression' || node.type === 'mdxTextExpression') return $bcaef7e086af7de5$var$mdxExpression(state, node);
    if (node.type === 'mdxJsxFlowElement' || node.type === 'mdxJsxTextElement') return $bcaef7e086af7de5$var$mdxJsxElement(state, node, key);
    if (node.type === 'mdxjsEsm') return $bcaef7e086af7de5$var$mdxEsm(state, node);
    if (node.type === 'root') return $bcaef7e086af7de5$var$root(state, node, key);
    if (node.type === 'text') return $bcaef7e086af7de5$var$text(state, node);
}
/**
 * Handle element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Element} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $bcaef7e086af7de5$var$element(state, node, key) {
    const parentSchema = state.schema;
    let schema = parentSchema;
    if (node.tagName.toLowerCase() === 'svg' && parentSchema.space === 'html') {
        schema = (0, $cad208d20be39d74$export$7ed1367e7fa1ad68);
        state.schema = schema;
    }
    state.ancestors.push(node);
    const type = $bcaef7e086af7de5$var$findComponentFromName(state, node.tagName, false);
    const props = $bcaef7e086af7de5$var$createElementProps(state, node);
    let children = $bcaef7e086af7de5$var$createChildren(state, node);
    if ($bcaef7e086af7de5$var$tableElements.has(node.tagName)) children = children.filter(function(child) {
        return typeof child === 'string' ? !(0, $99728b3b7e804493$export$7af1228ff777d175)(child) : true;
    });
    $bcaef7e086af7de5$var$addNode(state, props, type, node);
    $bcaef7e086af7de5$var$addChildren(props, children);
    // Restore.
    state.ancestors.pop();
    state.schema = parentSchema;
    return state.create(node, type, props, key);
}
/**
 * Handle MDX expression.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxFlowExpressionHast | MdxTextExpressionHast} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $bcaef7e086af7de5$var$mdxExpression(state, node) {
    if (node.data && node.data.estree && state.evaluater) {
        const program = node.data.estree;
        const expression = program.body[0];
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(expression.type === 'ExpressionStatement');
        // Assume result is a child.
        return /** @type {Child | undefined} */ state.evaluater.evaluateExpression(expression.expression);
    }
    $bcaef7e086af7de5$var$crashEstree(state, node.position);
}
/**
 * Handle MDX ESM.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxjsEsmHast} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $bcaef7e086af7de5$var$mdxEsm(state, node) {
    if (node.data && node.data.estree && state.evaluater) // Assume result is a child.
    return /** @type {Child | undefined} */ state.evaluater.evaluateProgram(node.data.estree);
    $bcaef7e086af7de5$var$crashEstree(state, node.position);
}
/**
 * Handle MDX JSX.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxJsxFlowElementHast | MdxJsxTextElementHast} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $bcaef7e086af7de5$var$mdxJsxElement(state, node, key) {
    const parentSchema = state.schema;
    let schema = parentSchema;
    if (node.name === 'svg' && parentSchema.space === 'html') {
        schema = (0, $cad208d20be39d74$export$7ed1367e7fa1ad68);
        state.schema = schema;
    }
    state.ancestors.push(node);
    const type = node.name === null ? state.Fragment : $bcaef7e086af7de5$var$findComponentFromName(state, node.name, true);
    const props = $bcaef7e086af7de5$var$createJsxElementProps(state, node);
    const children = $bcaef7e086af7de5$var$createChildren(state, node);
    $bcaef7e086af7de5$var$addNode(state, props, type, node);
    $bcaef7e086af7de5$var$addChildren(props, children);
    // Restore.
    state.ancestors.pop();
    state.schema = parentSchema;
    return state.create(node, type, props, key);
}
/**
 * Handle root.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Root} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $bcaef7e086af7de5$var$root(state, node, key) {
    /** @type {Props} */ const props = {};
    $bcaef7e086af7de5$var$addChildren(props, $bcaef7e086af7de5$var$createChildren(state, node));
    return state.create(node, state.Fragment, props, key);
}
/**
 * Handle text.
 *
 * @param {State} _
 *   Info passed around.
 * @param {Text} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $bcaef7e086af7de5$var$text(_, node) {
    return node.value;
}
/**
 * Add `node` to props.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Props} props
 *   Props.
 * @param {unknown} type
 *   Type.
 * @param {Element | MdxJsxFlowElementHast | MdxJsxTextElementHast} node
 *   Node.
 * @returns {undefined}
 *   Nothing.
 */ function $bcaef7e086af7de5$var$addNode(state, props, type, node) {
    // If this is swapped out for a component:
    if (typeof type !== 'string' && type !== state.Fragment && state.passNode) props.node = node;
}
/**
 * Add children to props.
 *
 * @param {Props} props
 *   Props.
 * @param {Array<Child>} children
 *   Children.
 * @returns {undefined}
 *   Nothing.
 */ function $bcaef7e086af7de5$var$addChildren(props, children) {
    if (children.length > 0) {
        const value = children.length > 1 ? children : children[0];
        if (value) props.children = value;
    }
}
/**
 * @param {string | undefined} _
 *   Path to file.
 * @param {Jsx} jsx
 *   Dynamic.
 * @param {Jsx} jsxs
 *   Static.
 * @returns {Create}
 *   Create a production element.
 */ function $bcaef7e086af7de5$var$productionCreate(_, jsx, jsxs) {
    return create;
    /** @type {Create} */ function create(_, type, props, key) {
        // Only an array when there are 2 or more children.
        const isStaticChildren = Array.isArray(props.children);
        const fn = isStaticChildren ? jsxs : jsx;
        return key ? fn(type, props, key) : fn(type, props);
    }
}
/**
 * @param {string | undefined} filePath
 *   Path to file.
 * @param {JsxDev} jsxDEV
 *   Development.
 * @returns {Create}
 *   Create a development element.
 */ function $bcaef7e086af7de5$var$developmentCreate(filePath, jsxDEV) {
    return create;
    /** @type {Create} */ function create(node, type, props, key) {
        // Only an array when there are 2 or more children.
        const isStaticChildren = Array.isArray(props.children);
        const point = (0, $9861e7b4f8df2806$export$771bf3e4949bfbee)(node);
        return jsxDEV(type, props, key, isStaticChildren, {
            columnNumber: point ? point.column - 1 : undefined,
            fileName: filePath,
            lineNumber: point ? point.line : undefined
        }, undefined);
    }
}
/**
 * Create props from an element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Element} node
 *   Current element.
 * @returns {Props}
 *   Props.
 */ function $bcaef7e086af7de5$var$createElementProps(state, node) {
    /** @type {Props} */ const props = {};
    /** @type {string | undefined} */ let alignValue;
    /** @type {string} */ let prop;
    for(prop in node.properties)if (prop !== 'children' && $bcaef7e086af7de5$var$own.call(node.properties, prop)) {
        const result = $bcaef7e086af7de5$var$createProperty(state, prop, node.properties[prop]);
        if (result) {
            const [key, value] = result;
            if (state.tableCellAlignToStyle && key === 'align' && typeof value === 'string' && $bcaef7e086af7de5$var$tableCellElement.has(node.tagName)) alignValue = value;
            else props[key] = value;
        }
    }
    if (alignValue) {
        // Assume style is an object.
        const style = /** @type {Style} */ props.style || (props.style = {});
        style[state.stylePropertyNameCase === 'css' ? 'text-align' : 'textAlign'] = alignValue;
    }
    return props;
}
/**
 * Create props from a JSX element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxJsxFlowElementHast | MdxJsxTextElementHast} node
 *   Current JSX element.
 * @returns {Props}
 *   Props.
 */ function $bcaef7e086af7de5$var$createJsxElementProps(state, node) {
    /** @type {Props} */ const props = {};
    for (const attribute of node.attributes)if (attribute.type === 'mdxJsxExpressionAttribute') {
        if (attribute.data && attribute.data.estree && state.evaluater) {
            const program = attribute.data.estree;
            const expression = program.body[0];
            (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(expression.type === 'ExpressionStatement');
            const objectExpression = expression.expression;
            (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(objectExpression.type === 'ObjectExpression');
            const property = objectExpression.properties[0];
            (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(property.type === 'SpreadElement');
            Object.assign(props, state.evaluater.evaluateExpression(property.argument));
        } else $bcaef7e086af7de5$var$crashEstree(state, node.position);
    } else {
        // For JSX, the author is responsible of passing in the correct values.
        const name = attribute.name;
        /** @type {unknown} */ let value;
        if (attribute.value && typeof attribute.value === 'object') {
            if (attribute.value.data && attribute.value.data.estree && state.evaluater) {
                const program = attribute.value.data.estree;
                const expression = program.body[0];
                (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(expression.type === 'ExpressionStatement');
                value = state.evaluater.evaluateExpression(expression.expression);
            } else $bcaef7e086af7de5$var$crashEstree(state, node.position);
        } else value = attribute.value === null ? true : attribute.value;
        // Assume a prop.
        props[name] = /** @type {Props[keyof Props]} */ value;
    }
    return props;
}
/**
 * Create children.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Parents} node
 *   Current element.
 * @returns {Array<Child>}
 *   Children.
 */ function $bcaef7e086af7de5$var$createChildren(state, node) {
    /** @type {Array<Child>} */ const children = [];
    let index = -1;
    /** @type {Map<string, number>} */ // Note: test this when Solid doesn’t want to merge my upcoming PR.
    /* c8 ignore next */ const countsByName = state.passKeys ? new Map() : $bcaef7e086af7de5$var$emptyMap;
    while(++index < node.children.length){
        const child = node.children[index];
        /** @type {string | undefined} */ let key;
        if (state.passKeys) {
            const name = child.type === 'element' ? child.tagName : child.type === 'mdxJsxFlowElement' || child.type === 'mdxJsxTextElement' ? child.name : undefined;
            if (name) {
                const count = countsByName.get(name) || 0;
                key = name + '-' + count;
                countsByName.set(name, count + 1);
            }
        }
        const result = $bcaef7e086af7de5$var$one(state, child, key);
        if (result !== undefined) children.push(result);
    }
    return children;
}
/**
 * Handle a property.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} prop
 *   Key.
 * @param {Array<number | string> | boolean | number | string | null | undefined} value
 *   hast property value.
 * @returns {Field | undefined}
 *   Field for runtime, optional.
 */ function $bcaef7e086af7de5$var$createProperty(state, prop, value) {
    const info = (0, $84669bfd2b988556$export$71aa6c912b956294)(state.schema, prop);
    // Ignore nullish and `NaN` values.
    if (value === null || value === undefined || typeof value === 'number' && Number.isNaN(value)) return;
    if (Array.isArray(value)) // Accept `array`.
    // Most props are space-separated.
    value = info.commaSeparated ? (0, $9323934601145f2e$export$fac44ee5b035f737)(value) : (0, $0d98344a9bfa0653$export$fac44ee5b035f737)(value);
    // React only accepts `style` as object.
    if (info.property === 'style') {
        let styleObject = typeof value === 'object' ? value : $bcaef7e086af7de5$var$parseStyle(state, String(value));
        if (state.stylePropertyNameCase === 'css') styleObject = $bcaef7e086af7de5$var$transformStylesToCssCasing(styleObject);
        return [
            'style',
            styleObject
        ];
    }
    return [
        state.elementAttributeNameCase === 'react' && info.space ? (0, $a1ae9812302ca8ea$export$d8abd7e5fb6871f9)[info.property] || info.property : info.attribute,
        value
    ];
}
/**
 * Parse a CSS declaration to an object.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} value
 *   CSS declarations.
 * @returns {Style}
 *   Properties.
 * @throws
 *   Throws `VFileMessage` when CSS cannot be parsed.
 */ function $bcaef7e086af7de5$var$parseStyle(state, value) {
    try {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f27ef1e87b7b8987$exports)))(value, {
            reactCompat: true
        });
    } catch (error) {
        if (state.ignoreInvalidStyle) return {};
        const cause = /** @type {Error} */ error;
        const message = new (0, $0aa9ed7423c10921$export$752e5c445fe834ef)('Cannot parse `style` attribute', {
            ancestors: state.ancestors,
            cause: cause,
            ruleId: 'style',
            source: 'hast-util-to-jsx-runtime'
        });
        message.file = state.filePath || undefined;
        message.url = $bcaef7e086af7de5$var$docs + '#cannot-parse-style-attribute';
        throw message;
    }
}
/**
 * Create a JSX name from a string.
 *
 * @param {State} state
 *   To do.
 * @param {string} name
 *   Name.
 * @param {boolean} allowExpression
 *   Allow member expressions and identifiers.
 * @returns {unknown}
 *   To do.
 */ function $bcaef7e086af7de5$var$findComponentFromName(state, name, allowExpression) {
    /** @type {Identifier | Literal | MemberExpression} */ let result;
    if (!allowExpression) result = {
        type: 'Literal',
        value: name
    };
    else if (name.includes('.')) {
        const identifiers = name.split('.');
        let index = -1;
        /** @type {Identifier | Literal | MemberExpression | undefined} */ let node;
        while(++index < identifiers.length){
            /** @type {Identifier | Literal} */ const prop = (0, $8ae047d5df63cb7f$export$a8ff84c12d48cfa6)(identifiers[index]) ? {
                type: 'Identifier',
                name: identifiers[index]
            } : {
                type: 'Literal',
                value: identifiers[index]
            };
            node = node ? {
                type: 'MemberExpression',
                object: node,
                property: prop,
                computed: Boolean(index && prop.type === 'Literal'),
                optional: false
            } : prop;
        }
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(node, 'always a result');
        result = node;
    } else result = (0, $8ae047d5df63cb7f$export$a8ff84c12d48cfa6)(name) && !/^[a-z]/.test(name) ? {
        type: 'Identifier',
        name: name
    } : {
        type: 'Literal',
        value: name
    };
    // Only literals can be passed in `components` currently.
    // No identifiers / member expressions.
    if (result.type === 'Literal') {
        const name = /** @type {string | number} */ result.value;
        return $bcaef7e086af7de5$var$own.call(state.components, name) ? state.components[name] : name;
    }
    // Assume component.
    if (state.evaluater) return state.evaluater.evaluateExpression(result);
    $bcaef7e086af7de5$var$crashEstree(state);
}
/**
 * @param {State} state
 * @param {Position | undefined} [place]
 * @returns {never}
 */ function $bcaef7e086af7de5$var$crashEstree(state, place) {
    const message = new (0, $0aa9ed7423c10921$export$752e5c445fe834ef)('Cannot handle MDX estrees without `createEvaluater`', {
        ancestors: state.ancestors,
        place: place,
        ruleId: 'mdx-estree',
        source: 'hast-util-to-jsx-runtime'
    });
    message.file = state.filePath || undefined;
    message.url = $bcaef7e086af7de5$var$docs + '#cannot-handle-mdx-estrees-without-createevaluater';
    throw message;
}
/**
 * Transform a DOM casing style object to a CSS casing style object.
 *
 * @param {Style} domCasing
 * @returns {Style}
 */ function $bcaef7e086af7de5$var$transformStylesToCssCasing(domCasing) {
    /** @type {Style} */ const cssCasing = {};
    /** @type {string} */ let from;
    for(from in domCasing)if ($bcaef7e086af7de5$var$own.call(domCasing, from)) cssCasing[$bcaef7e086af7de5$var$transformStyleToCssCasing(from)] = domCasing[from];
    return cssCasing;
}
/**
 * Transform a DOM casing style field to a CSS casing style field.
 *
 * @param {string} from
 * @returns {string}
 */ function $bcaef7e086af7de5$var$transformStyleToCssCasing(from) {
    let to = from.replace($bcaef7e086af7de5$var$cap, $bcaef7e086af7de5$var$toDash);
    // Handle `ms-xxx` -> `-ms-xxx`.
    if (to.slice(0, 3) === 'ms-') to = '-' + to;
    return to;
}
/**
 * Make `$0` dash cased.
 *
 * @param {string} $0
 *   Capitalized ASCII leter.
 * @returns {string}
 *   Dash and lower letter.
 */ function $bcaef7e086af7de5$var$toDash($0) {
    return '-' + $0.toLowerCase();
}


/**
 * HTML URL properties.
 *
 * Each key is a property name and each value is a list of tag names it applies
 * to or `null` if it applies to all elements.
 *
 * @type {Record<string, Array<string> | null>}
 */ const $1389ec48924c67a6$export$de3e062aedff083a = {
    action: [
        'form'
    ],
    cite: [
        'blockquote',
        'del',
        'ins',
        'q'
    ],
    data: [
        'object'
    ],
    formAction: [
        'button',
        'input'
    ],
    href: [
        'a',
        'area',
        'base',
        'link'
    ],
    icon: [
        'menuitem'
    ],
    itemId: null,
    manifest: [
        'html'
    ],
    ping: [
        'a',
        'area'
    ],
    poster: [
        'video'
    ],
    src: [
        'audio',
        'embed',
        'iframe',
        'img',
        'input',
        'script',
        'source',
        'track',
        'video'
    ]
};




var $7fPBF = parcelRequire("7fPBF");
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} FromMarkdownOptions
 * @typedef {import('unified').Parser<Root>} Parser
 * @typedef {import('unified').Processor<Root>} Processor
 */ /**
 * @typedef {Omit<FromMarkdownOptions, 'extensions' | 'mdastExtensions'>} Options
 */ /**
 * @import {
 *   Break,
 *   Blockquote,
 *   Code,
 *   Definition,
 *   Emphasis,
 *   Heading,
 *   Html,
 *   Image,
 *   InlineCode,
 *   Link,
 *   ListItem,
 *   List,
 *   Nodes,
 *   Paragraph,
 *   PhrasingContent,
 *   ReferenceType,
 *   Root,
 *   Strong,
 *   Text,
 *   ThematicBreak
 * } from 'mdast'
 * @import {
 *   Encoding,
 *   Event,
 *   Token,
 *   Value
 * } from 'micromark-util-types'
 * @import {Point} from 'unist'
 * @import {
 *   CompileContext,
 *   CompileData,
 *   Config,
 *   Extension,
 *   Handle,
 *   OnEnterError,
 *   Options
 * } from './types.js'
 */ /**
 * @typedef {import('mdast').Nodes} Nodes
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s (default: `true`).
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML (default: `true`).
 */ /** @type {Options} */ const $da74a7bb5b052f79$var$emptyOptions = {};
function $da74a7bb5b052f79$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $da74a7bb5b052f79$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === 'boolean' ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === 'boolean' ? settings.includeHtml : true;
    return $da74a7bb5b052f79$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $da74a7bb5b052f79$var$one(value, includeImageAlt, includeHtml) {
    if ($da74a7bb5b052f79$var$node(value)) {
        if ('value' in value) return value.type === 'html' && !includeHtml ? '' : value.value;
        if (includeImageAlt && 'alt' in value && value.alt) return value.alt;
        if ('children' in value) return $da74a7bb5b052f79$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $da74a7bb5b052f79$var$all(value, includeImageAlt, includeHtml);
    return '';
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $da74a7bb5b052f79$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $da74a7bb5b052f79$var$one(values[index], includeImageAlt, includeHtml);
    return result.join('');
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Nodes}
 *   Whether `value` is a node.
 */ function $da74a7bb5b052f79$var$node(value) {
    return Boolean(value && typeof value === 'object');
}


/**
 * @import {Encoding, Value} from 'micromark-util-types'
 */ /**
 * @typedef {import('micromark-util-types').Options} Options
 */ /**
 * While micromark is a lexer/tokenizer, the common case of going from markdown
 * to html is currently built in as this module, even though the parts can be
 * used separately to build ASTs, CSTs, or many other output formats.
 *
 * Having an HTML compiler built in is useful because it allows us to check for
 * compliancy to CommonMark, the de facto norm of markdown, specified in roughly
 * 600 input/output cases.
 *
 * This module has an interface that accepts lists of events instead of the
 * whole at once, however, because markdown can’t be truly streaming, we buffer
 * events before processing and outputting the final result.
 */ /**
 * @import {
 *   CompileContext,
 *   CompileData,
 *   CompileOptions,
 *   Compile,
 *   Definition,
 *   Event,
 *   Handle,
 *   HtmlExtension,
 *   LineEnding,
 *   NormalizedHtmlExtension,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @typedef Media
 * @property {boolean | undefined} [image]
 * @property {string | undefined} [labelId]
 * @property {string | undefined} [label]
 * @property {string | undefined} [referenceId]
 * @property {string | undefined} [destination]
 * @property {string | undefined} [title]
 */ /// <reference lib="dom" />
/* global document */ const $b2bf0a6c22a4700b$var$element = document.createElement('i');
function $b2bf0a6c22a4700b$export$289b6a6320f709b4(value) {
    const characterReference = '&' + value + ';';
    $b2bf0a6c22a4700b$var$element.innerHTML = characterReference;
    const character = $b2bf0a6c22a4700b$var$element.textContent;
    // Some named character references do not require the closing semicolon
    // (`&not`, for instance), which leads to situations where parsing the assumed
    // named reference of `&notit;` will result in the string `¬it;`.
    // When we encounter a trailing semicolon after parsing, and the character
    // reference to decode was not a semicolon (`&semi;`), we can assume that the
    // matching was not complete.
    if (character.charCodeAt(character.length - 1) === 59 /* `;` */  && value !== 'semi') return false;
    // If the decoded string is equal to the input, the character reference was
    // not valid.
    return character === characterReference ? false : character;
}


/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {undefined}
 *   Nothing.
 */ function $6d957c9e6a169a49$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $6d957c9e6a169a49$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $6d957c9e6a169a49$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}


/**
 * @import {
 *   Extension,
 *   Handles,
 *   HtmlExtension,
 *   NormalizedExtension
 * } from 'micromark-util-types'
 */ 
const $1c4ab323543eb9b7$var$hasOwnProperty = {}.hasOwnProperty;
function $1c4ab323543eb9b7$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$1c4ab323543eb9b7$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $1c4ab323543eb9b7$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $1c4ab323543eb9b7$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$1c4ab323543eb9b7$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $1c4ab323543eb9b7$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 *   List of constructs to merge into.
 * @param {Array<unknown>} list
 *   List of constructs to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $1c4ab323543eb9b7$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === 'after' ? existing : before).push(list[index]);
    (0, $6d957c9e6a169a49$export$869882364835d202)(existing, 0, 0, before);
}
function $1c4ab323543eb9b7$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$1c4ab323543eb9b7$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $1c4ab323543eb9b7$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $1c4ab323543eb9b7$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}


/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCodePoint(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $a72b41c19fbe228c$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || /* eslint-disable no-bitwise */ (code & 65535) === 65535 || (code & 65535) === 65534 || /* eslint-enable no-bitwise */ // Out of range
    code > 1114111) return "\uFFFD";
    return String.fromCodePoint(code);
}


const $1730a6ab3d7ab9f0$var$characterReferences = {
    '"': 'quot',
    '&': 'amp',
    '<': 'lt',
    '>': 'gt'
};
function $1730a6ab3d7ab9f0$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   *   Value to replace.
   * @returns {string}
   *   Encoded value.
   */ function replace(value) {
        return '&' + $1730a6ab3d7ab9f0$var$characterReferences[/** @type {keyof typeof characterReferences} */ value] + ';';
    }
}


/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $c580fc709a668807$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ")// Trim.
    .replace(/^ | $/g, '')// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}


/**
 * @import {Code} from 'micromark-util-types'
 */ /**
 * Check whether the character code represents an ASCII alpha (`a` through `z`,
 * case insensitive).
 *
 * An **ASCII alpha** is an ASCII upper alpha or ASCII lower alpha.
 *
 * An **ASCII upper alpha** is a character in the inclusive range U+0041 (`A`)
 * to U+005A (`Z`).
 *
 * An **ASCII lower alpha** is a character in the inclusive range U+0061 (`a`)
 * to U+007A (`z`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */ const $9a96cd0c036af4eb$export$d65d6b62c24d5436 = $9a96cd0c036af4eb$var$regexCheck(/[A-Za-z]/);
const $9a96cd0c036af4eb$export$75c76db11865a9f4 = $9a96cd0c036af4eb$var$regexCheck(/[\dA-Za-z]/);
const $9a96cd0c036af4eb$export$4397998b34fe597d = $9a96cd0c036af4eb$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $9a96cd0c036af4eb$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $9a96cd0c036af4eb$export$ca8b5b1a6c320e6e = $9a96cd0c036af4eb$var$regexCheck(/\d/);
const $9a96cd0c036af4eb$export$eca2752363989806 = $9a96cd0c036af4eb$var$regexCheck(/[\dA-Fa-f]/);
const $9a96cd0c036af4eb$export$35794a7d1db99380 = $9a96cd0c036af4eb$var$regexCheck(/[!-/:-@[-`{-~]/);
function $9a96cd0c036af4eb$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $9a96cd0c036af4eb$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $9a96cd0c036af4eb$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
const $9a96cd0c036af4eb$export$aa04114dd888a7a0 = $9a96cd0c036af4eb$var$regexCheck(/\p{P}|\p{S}/u);
const $9a96cd0c036af4eb$export$a0ff789c034ffdf4 = $9a96cd0c036af4eb$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 *   Expression.
 * @returns {(code: Code) => boolean}
 *   Check.
 */ function $9a96cd0c036af4eb$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && code > -1 && regex.test(String.fromCharCode(code));
    }
}



function $b82d09afb4bbc7a9$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $1730a6ab3d7ab9f0$export$c564cdbbe6da493)($b82d09afb4bbc7a9$export$e42a3e39590d28b5(url || ''));
    if (!protocol) return value;
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return '';
}
function $b82d09afb4bbc7a9$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = '';
        // A correct percent encoded value.
        if (code === 37 && (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(value.charCodeAt(index + 1)) && (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = "\uFFFD";
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = '';
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join('') + value.slice(start);
}


const $76c598c95b20c009$var$hasOwnProperty = {}.hasOwnProperty;
/**
 * These two are allowlists of safe protocols for full URLs in respectively the
 * `href` (on `<a>`) and `src` (on `<img>`) attributes.
 * They are based on what is allowed on GitHub,
 * <https://github.com/syntax-tree/hast-util-sanitize/blob/9275b21/lib/github.json#L31>
 */ const $76c598c95b20c009$var$protocolHref = /^(https?|ircs?|mailto|xmpp)$/i;
const $76c598c95b20c009$var$protocolSource = /^https?$/i;
function $76c598c95b20c009$export$ef7acd7185315e22(options) {
    const settings = options || {};
    /**
   * Tags is needed because according to markdown, links and emphasis and
   * whatnot can exist in images, however, as HTML doesn’t allow content in
   * images, the tags are ignored in the `alt` attribute, but the content
   * remains.
   *
   * @type {boolean | undefined}
   */ let tags = true;
    /**
   * An object to track identifiers to media (URLs and titles) defined with
   * definitions.
   *
   * @type {Record<string, Definition>}
   */ const definitions = {};
    /**
   * A lot of the handlers need to capture some of the output data, modify it
   * somehow, and then deal with it.
   * We do that by tracking a stack of buffers, that can be opened (with
   * `buffer`) and closed (with `resume`) to access them.
   *
   * @type {Array<Array<string>>}
   */ const buffers = [
        []
    ];
    /**
   * As we can have links in images and the other way around, where the deepest
   * ones are closed first, we need to track which one we’re in.
   *
   * @type {Array<Media>}
   */ const mediaStack = [];
    /**
   * Same as `mediaStack` for tightness, which is specific to lists.
   * We need to track if we’re currently in a tight or loose container.
   *
   * @type {Array<boolean>}
   */ const tightStack = [];
    /** @type {HtmlExtension} */ const defaultHandlers = {
        enter: {
            blockQuote: onenterblockquote,
            codeFenced: onentercodefenced,
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: onentercodeindented,
            codeText: onentercodetext,
            content: onentercontent,
            definition: onenterdefinition,
            definitionDestinationString: onenterdefinitiondestinationstring,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: onenteremphasis,
            htmlFlow: onenterhtmlflow,
            htmlText: onenterhtml,
            image: onenterimage,
            label: buffer,
            link: onenterlink,
            listItemMarker: onenterlistitemmarker,
            listItemValue: onenterlistitemvalue,
            listOrdered: onenterlistordered,
            listUnordered: onenterlistunordered,
            paragraph: onenterparagraph,
            reference: buffer,
            resource: onenterresource,
            resourceDestinationString: onenterresourcedestinationstring,
            resourceTitleString: buffer,
            setextHeading: onentersetextheading,
            strong: onenterstrong
        },
        exit: {
            atxHeading: onexitatxheading,
            atxHeadingSequence: onexitatxheadingsequence,
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: onexitblockquote,
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: onexitflowcode,
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onresumedrop,
            codeFlowValue: onexitcodeflowvalue,
            codeIndented: onexitflowcode,
            codeText: onexitcodetext,
            codeTextData: onexitdata,
            data: onexitdata,
            definition: onexitdefinition,
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: onexitemphasis,
            hardBreakEscape: onexithardbreak,
            hardBreakTrailing: onexithardbreak,
            htmlFlow: onexithtml,
            htmlFlowData: onexitdata,
            htmlText: onexithtml,
            htmlTextData: onexitdata,
            image: onexitmedia,
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: onexitmedia,
            listOrdered: onexitlistordered,
            listUnordered: onexitlistunordered,
            paragraph: onexitparagraph,
            reference: onresumedrop,
            referenceString: onexitreferencestring,
            resource: onresumedrop,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            setextHeading: onexitsetextheading,
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: onexitstrong,
            thematicBreak: onexitthematicbreak
        }
    };
    /**
   * Combine the HTML extensions with the default handlers.
   * An HTML extension is an object whose fields are either `enter` or `exit`
   * (reflecting whether a token is entered or exited).
   * The values at such objects are names of tokens mapping to handlers.
   * Handlers are called, respectively when a token is opener or closed, with
   * that token, and a context as `this`.
   */ const handlers = /** @type {NormalizedHtmlExtension} */ (0, $1c4ab323543eb9b7$export$eaf8c406dfb0a620)([
        defaultHandlers,
        ...settings.htmlExtensions || []
    ]);
    /**
   * Handlers do often need to keep track of some state.
   * That state is provided here as a key-value store (an object).
   *
   * @type {CompileData}
   */ const data = {
        definitions: definitions,
        tightStack: tightStack
    };
    /**
   * The context for handlers references a couple of useful functions.
   * In handlers from extensions, those can be accessed at `this`.
   * For the handlers here, they can be accessed directly.
   *
   * @type {Omit<CompileContext, 'sliceSerialize'>}
   */ const context = {
        buffer: buffer,
        encode: encode,
        getData: getData,
        lineEndingIfNeeded: lineEndingIfNeeded,
        options: settings,
        raw: raw,
        resume: resume,
        setData: setData,
        tag: tag
    };
    /**
   * Generally, micromark copies line endings (`'\r'`, `'\n'`, `'\r\n'`) in the
   * markdown document over to the compiled HTML.
   * In some cases, such as `> a`, CommonMark requires that extra line endings
   * are added: `<blockquote>\n<p>a</p>\n</blockquote>`.
   * This variable hold the default line ending when given (or `undefined`),
   * and in the latter case will be updated to the first found line ending if
   * there is one.
   */ let lineEndingStyle = settings.defaultLineEnding;
    // Return the function that handles a slice of events.
    return compile;
    /**
   * Deal w/ a slice of events.
   * Return either the empty string if there’s nothing of note to return, or the
   * result when done.
   *
   * @param {ReadonlyArray<Event>} events
   * @returns {string}
   */ function compile(events) {
        let index = -1;
        let start = 0;
        /** @type {Array<number>} */ const listStack = [];
        // As definitions can come after references, we need to figure out the media
        // (urls and titles) defined by them before handling the references.
        // So, we do sort of what HTML does: put metadata at the start (in head), and
        // then put content after (`body`).
        /** @type {Array<Event>} */ let head = [];
        /** @type {Array<Event>} */ let body = [];
        while(++index < events.length){
            // Figure out the line ending style used in the document.
            if (!lineEndingStyle && (events[index][1].type === "lineEnding" || events[index][1].type === "lineEndingBlank")) lineEndingStyle = /** @type {LineEnding} */ events[index][2].sliceSerialize(events[index][1]);
            // Preprocess lists to infer whether the list is loose or not.
            if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
                if (events[index][0] === 'enter') listStack.push(index);
                else prepareList(events.slice(listStack.pop(), index));
            }
            // Move definitions to the front.
            if (events[index][1].type === "definition") {
                if (events[index][0] === 'enter') {
                    body = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(body, events.slice(start, index));
                    start = index;
                } else {
                    head = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(head, events.slice(start, index + 1));
                    start = index + 1;
                }
            }
        }
        head = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(head, body);
        head = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(head, events.slice(start));
        index = -1;
        const result = head;
        // Handle the start of the document, if defined.
        if (handlers.enter.null) handlers.enter.null.call(context);
        // Handle all events.
        while(++index < events.length){
            const handles = handlers[result[index][0]];
            const kind = result[index][1].type;
            const handle = handles[kind];
            if ($76c598c95b20c009$var$hasOwnProperty.call(handles, kind) && handle) handle.call({
                sliceSerialize: result[index][2].sliceSerialize,
                ...context
            }, result[index][1]);
        }
        // Handle the end of the document, if defined.
        if (handlers.exit.null) handlers.exit.null.call(context);
        return buffers[0].join('');
    }
    /**
   * Figure out whether lists are loose or not.
   *
   * @param {ReadonlyArray<Event>} slice
   * @returns {undefined}
   */ function prepareList(slice) {
        const length = slice.length;
        let index = 0; // Skip open.
        let containerBalance = 0;
        let loose = false;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index < length){
            const event = slice[index];
            if (event[1]._container) {
                atMarker = undefined;
                if (event[0] === 'enter') containerBalance++;
                else containerBalance--;
            } else switch(event[1].type){
                case "listItemPrefix":
                    if (event[0] === 'exit') atMarker = true;
                    break;
                case "linePrefix":
                    break;
                case "lineEndingBlank":
                    if (event[0] === 'enter' && !containerBalance) {
                        if (atMarker) atMarker = undefined;
                        else loose = true;
                    }
                    break;
                default:
                    atMarker = undefined;
            }
        }
        slice[0][1]._loose = loose;
    }
    /**
   * @type {CompileContext['setData']}
   */ function setData(key, value) {
        // @ts-expect-error: assume `value` is omitted (`undefined` is passed) only
        // if allowed.
        data[key] = value;
    }
    /**
   * @type {CompileContext['getData']}
   */ function getData(key) {
        return data[key];
    }
    /** @type {CompileContext['buffer']} */ function buffer() {
        buffers.push([]);
    }
    /** @type {CompileContext['resume']} */ function resume() {
        const buf = buffers.pop();
        return buf.join('');
    }
    /** @type {CompileContext['tag']} */ function tag(value) {
        if (!tags) return;
        setData('lastWasTag', true);
        buffers[buffers.length - 1].push(value);
    }
    /** @type {CompileContext['raw']} */ function raw(value) {
        setData('lastWasTag');
        buffers[buffers.length - 1].push(value);
    }
    /**
   * Output an extra line ending.
   *
   * @returns {undefined}
   */ function lineEnding() {
        raw(lineEndingStyle || '\n');
    }
    /** @type {CompileContext['lineEndingIfNeeded']} */ function lineEndingIfNeeded() {
        const buffer = buffers[buffers.length - 1];
        const slice = buffer[buffer.length - 1];
        const previous = slice ? slice.charCodeAt(slice.length - 1) : null;
        if (previous === 10 || previous === 13 || previous === null) return;
        lineEnding();
    }
    /** @type {CompileContext['encode']} */ function encode(value) {
        return getData('ignoreEncode') ? value : (0, $1730a6ab3d7ab9f0$export$c564cdbbe6da493)(value);
    }
    //
    // Handlers.
    //
    /**
   * @returns {undefined}
   */ function onresumedrop() {
        resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ol');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistunordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ul');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData('expectFirstItem')) {
            const value = Number.parseInt(this.sliceSerialize(token), 10);
            if (value !== 1) tag(' start="' + encode(String(value)) + '"');
        }
    }
    /**
   * @returns {undefined}
   */ function onenterlistitemmarker() {
        if (getData('expectFirstItem')) tag('>');
        else onexitlistitem();
        lineEndingIfNeeded();
        tag('<li>');
        setData('expectFirstItem');
        // “Hack” to prevent a line ending from showing up if the item is empty.
        setData('lastWasTag');
    }
    /**
   * @returns {undefined}
   */ function onexitlistordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ol>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistunordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ul>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistitem() {
        if (getData('lastWasTag') && !getData('slurpAllLineEndings')) lineEndingIfNeeded();
        tag('</li>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterblockquote() {
        tightStack.push(false);
        lineEndingIfNeeded();
        tag('<blockquote>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitblockquote() {
        tightStack.pop();
        lineEndingIfNeeded();
        tag('</blockquote>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterparagraph() {
        if (!tightStack[tightStack.length - 1]) {
            lineEndingIfNeeded();
            tag('<p>');
        }
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitparagraph() {
        if (tightStack[tightStack.length - 1]) setData('slurpAllLineEndings', true);
        else tag('</p>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodefenced() {
        lineEndingIfNeeded();
        tag('<pre><code');
        setData('fencesCount', 0);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const value = resume();
        tag(' class="language-' + value + '"');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        const count = getData('fencesCount') || 0;
        if (!count) {
            tag('>');
            setData('slurpOneLineEnding', true);
        }
        setData('fencesCount', count + 1);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodeindented() {
        lineEndingIfNeeded();
        tag('<pre><code>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitflowcode() {
        const count = getData('fencesCount');
        // One special case is if we are inside a container, and the fenced code was
        // not closed (meaning it runs to the end).
        // In that case, the following line ending, is considered *outside* the
        // fenced code and block quote by micromark, but CM wants to treat that
        // ending as part of the code.
        if (count !== undefined && count < 2 && data.tightStack.length > 0 && !getData('lastWasTag')) lineEnding();
        // But in most cases, it’s simpler: when we’ve seen some data, emit an extra
        // line ending when needed.
        if (getData('flowCodeSeenData')) lineEndingIfNeeded();
        tag('</code></pre>');
        if (count !== undefined && count < 2) lineEndingIfNeeded();
        setData('flowCodeSeenData');
        setData('fencesCount');
        setData('slurpOneLineEnding');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterimage() {
        mediaStack.push({
            image: true
        });
        tags = undefined; // Disallow tags.
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlink() {
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        mediaStack[mediaStack.length - 1].label = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        mediaStack[mediaStack.length - 1].referenceId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresource() {
        buffer(); // We can have line endings in the resource, ignore them.
        mediaStack[mediaStack.length - 1].destination = '';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresourcedestinationstring() {
        buffer();
        // Ignore encoding the result, as we’ll first percent encode the url and
        // encode manually after.
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitmedia() {
        let index = mediaStack.length - 1; // Skip current.
        const media = mediaStack[index];
        const id = media.referenceId || media.labelId;
        const context = media.destination === undefined ? definitions[(0, $c580fc709a668807$export$806d55e226cfcd08)(id)] : media;
        tags = true;
        while(index--)if (mediaStack[index].image) {
            tags = undefined;
            break;
        }
        if (media.image) {
            tag('<img src="' + (0, $b82d09afb4bbc7a9$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $76c598c95b20c009$var$protocolSource) + '" alt="');
            raw(media.label);
            tag('"');
        } else tag('<a href="' + (0, $b82d09afb4bbc7a9$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $76c598c95b20c009$var$protocolHref) + '"');
        tag(context.title ? ' title="' + context.title + '"' : '');
        if (media.image) tag(' />');
        else {
            tag('>');
            raw(media.label);
            tag('</a>');
        }
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinition() {
        buffer();
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        // Discard label, use the source content instead.
        resume();
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinitiondestinationstring() {
        buffer();
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinition() {
        const media = mediaStack[mediaStack.length - 1];
        const id = (0, $c580fc709a668807$export$806d55e226cfcd08)(media.labelId);
        resume();
        if (!$76c598c95b20c009$var$hasOwnProperty.call(definitions, id)) definitions[id] = mediaStack[mediaStack.length - 1];
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercontent() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        // Exit for further sequences.
        if (getData('headingRank')) return;
        setData('headingRank', this.sliceSerialize(token).length);
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentersetextheading() {
        buffer();
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheading() {
        tag('</h' + getData('headingRank') + '>');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        setData('headingRank', this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        const value = resume();
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
        raw(value);
        tag('</h' + getData('headingRank') + '>');
        setData('slurpAllLineEndings');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        if (getData('slurpAllLineEndings')) return;
        if (getData('slurpOneLineEnding')) {
            setData('slurpOneLineEnding');
            return;
        }
        if (getData('inCodeText')) {
            raw(' ');
            return;
        }
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeflowvalue(token) {
        raw(encode(this.sliceSerialize(token)));
        setData('flowCodeSeenData', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        tag('<br />');
    }
    /**
   * @returns {undefined}
   */ function onenterhtmlflow() {
        lineEndingIfNeeded();
        onenterhtml();
    }
    /**
   * @returns {undefined}
   */ function onexithtml() {
        setData('ignoreEncode');
    }
    /**
   * @returns {undefined}
   */ function onenterhtml() {
        if (settings.allowDangerousHtml) setData('ignoreEncode', true);
    }
    /**
   * @returns {undefined}
   */ function onenteremphasis() {
        tag('<em>');
    }
    /**
   * @returns {undefined}
   */ function onenterstrong() {
        tag('<strong>');
    }
    /**
   * @returns {undefined}
   */ function onentercodetext() {
        setData('inCodeText', true);
        tag('<code>');
    }
    /**
   * @returns {undefined}
   */ function onexitcodetext() {
        setData('inCodeText');
        tag('</code>');
    }
    /**
   * @returns {undefined}
   */ function onexitemphasis() {
        tag('</em>');
    }
    /**
   * @returns {undefined}
   */ function onexitstrong() {
        tag('</strong>');
    }
    /**
   * @returns {undefined}
   */ function onexitthematicbreak() {
        lineEndingIfNeeded();
        tag('<hr />');
    }
    /**
   * @this {CompileContext}
   * @param {Token} token
   * @returns {undefined}
   */ function onexitcharacterreferencemarker(token) {
        setData('characterReferenceType', token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const value = this.sliceSerialize(token);
        const decoded = getData('characterReferenceType') ? (0, $a72b41c19fbe228c$export$15a69557afac2c20)(value, getData('characterReferenceType') === "characterReferenceMarkerNumeric" ? 10 : 16) : (0, $b2bf0a6c22a4700b$export$289b6a6320f709b4)(value);
        // `decodeNamedCharacterReference` can return `false` for invalid named
        // character references,
        // but everything we’ve tokenized is valid.
        raw(encode(/** @type {string} */ decoded));
        setData('characterReferenceType');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $b82d09afb4bbc7a9$export$d130a2d684099e5a)(uri, settings.allowDangerousProtocol ? undefined : $76c598c95b20c009$var$protocolHref) + '">');
        raw(encode(uri));
        tag('</a>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $b82d09afb4bbc7a9$export$d130a2d684099e5a)('mailto:' + uri) + '">');
        raw(encode(uri));
        tag('</a>');
    }
}


/**
 * @import {
 *   Create,
 *   FullNormalizedExtension,
 *   InitialConstruct,
 *   ParseContext,
 *   ParseOptions
 * } from 'micromark-util-types'
 */ 
/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */ 
function $a27bcbb6afb3eadb$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}



const $145b6cb5bda265c1$export$a7db06668cad9adb = {
    tokenize: $145b6cb5bda265c1$var$initializeContent
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Initializer}
 *   Content.
 */ function $145b6cb5bda265c1$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, contentStart, "linePrefix");
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}


/**
 * @import {
 *   Construct,
 *   ContainerState,
 *   InitialConstruct,
 *   Initializer,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 *   Construct and its state.
 */ 


const $3d8796971204dffa$export$5a7bfc01df82fcd1 = {
    tokenize: $3d8796971204dffa$var$initializeDocument
};
/** @type {Construct} */ const $3d8796971204dffa$var$containerConstruct = {
    tokenize: $3d8796971204dffa$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */ function $3d8796971204dffa$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = {
                    ...point
                };
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $6d957c9e6a169a49$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($3d8796971204dffa$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($3d8796971204dffa$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            _tokenizer: childFlow,
            contentType: "flow",
            previous: childToken
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit("chunkFlow"), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            writeToChild(effects.exit("chunkFlow"));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   *   Token.
   * @param {boolean | undefined} [endOfFile]
   *   Whether the token is at the end of the file (default: `false`).
   * @returns {undefined}
   *   Nothing.
   */ function writeToChild(token, endOfFile) {
        const stream = self.sliceStream(token);
        if (endOfFile) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = {
                    ...point
                };
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $6d957c9e6a169a49$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   *   Size.
   * @returns {undefined}
   *   Nothing.
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 *   Tokenizer.
 */ function $3d8796971204dffa$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4);
}


/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */ /**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $30b85425f5f538a1$export$d50d28ce3ab2a612 = {
    partial: true,
    tokenize: $30b85425f5f538a1$var$tokenizeBlankLine
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $30b85425f5f538a1$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, after, "linePrefix")(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 

/**
 * @import {Chunk, Event, Token} from 'micromark-util-types'
 */ 
/**
 * Some of the internal operations of micromark do lots of editing
 * operations on very large arrays. This runs into problems with two
 * properties of most circa-2020 JavaScript interpreters:
 *
 *  - Array-length modifications at the high end of an array (push/pop) are
 *    expected to be common and are implemented in (amortized) time
 *    proportional to the number of elements added or removed, whereas
 *    other operations (shift/unshift and splice) are much less efficient.
 *  - Function arguments are passed on the stack, so adding tens of thousands
 *    of elements to an array with `arr.push(...newElements)` will frequently
 *    cause stack overflows. (see <https://stackoverflow.com/questions/22123769/rangeerror-maximum-call-stack-size-exceeded-why>)
 *
 * SpliceBuffers are an implementation of gap buffers, which are a
 * generalization of the "queue made of two stacks" idea. The splice buffer
 * maintains a cursor, and moving the cursor has cost proportional to the
 * distance the cursor moves, but inserting, deleting, or splicing in
 * new information at the cursor is as efficient as the push/pop operation.
 * This allows for an efficient sequence of splices (or pushes, pops, shifts,
 * or unshifts) as long such edits happen at the same part of the array or
 * generally sweep through the array from the beginning to the end.
 *
 * The interface for splice buffers also supports large numbers of inputs by
 * passing a single array argument rather passing multiple arguments on the
 * function call stack.
 *
 * @template T
 *   Item type.
 */ class $151e2065d6a4ba72$export$bd596157370df26e {
    /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */ constructor(initial){
        /** @type {Array<T>} */ this.left = initial ? [
            ...initial
        ] : [];
        /** @type {Array<T>} */ this.right = [];
    }
    /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */ get(index) {
        if (index < 0 || index >= this.left.length + this.right.length) throw new RangeError('Cannot access index `' + index + '` in a splice buffer of size `' + (this.left.length + this.right.length) + '`');
        if (index < this.left.length) return this.left[index];
        return this.right[this.right.length - index + this.left.length - 1];
    }
    /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */ get length() {
        return this.left.length + this.right.length;
    }
    /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ shift() {
        this.setCursor(0);
        return this.right.pop();
    }
    /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */ slice(start, end) {
        /** @type {number} */ const stop = end === null || end === undefined ? Number.POSITIVE_INFINITY : end;
        if (stop < this.left.length) return this.left.slice(start, stop);
        if (start > this.left.length) return this.right.slice(this.right.length - stop + this.left.length, this.right.length - start + this.left.length).reverse();
        return this.left.slice(start).concat(this.right.slice(this.right.length - stop + this.left.length).reverse());
    }
    /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */ splice(start, deleteCount, items) {
        /** @type {number} */ const count = deleteCount || 0;
        this.setCursor(Math.trunc(start));
        const removed = this.right.splice(this.right.length - count, Number.POSITIVE_INFINITY);
        if (items) $151e2065d6a4ba72$var$chunkedPush(this.left, items);
        return removed.reverse();
    }
    /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ pop() {
        this.setCursor(Number.POSITIVE_INFINITY);
        return this.left.pop();
    }
    /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ push(item) {
        this.setCursor(Number.POSITIVE_INFINITY);
        this.left.push(item);
    }
    /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ pushMany(items) {
        this.setCursor(Number.POSITIVE_INFINITY);
        $151e2065d6a4ba72$var$chunkedPush(this.left, items);
    }
    /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ unshift(item) {
        this.setCursor(0);
        this.right.push(item);
    }
    /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ unshiftMany(items) {
        this.setCursor(0);
        $151e2065d6a4ba72$var$chunkedPush(this.right, items.reverse());
    }
    /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */ setCursor(n) {
        if (n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0) return;
        if (n < this.left.length) {
            // Move cursor to the this.left
            const removed = this.left.splice(n, Number.POSITIVE_INFINITY);
            $151e2065d6a4ba72$var$chunkedPush(this.right, removed.reverse());
        } else {
            // Move cursor to the this.right
            const removed = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
            $151e2065d6a4ba72$var$chunkedPush(this.left, removed.reverse());
        }
    }
}
/**
 * Avoid stack overflow by pushing items onto the stack in segments
 *
 * @template T
 *   Item type.
 * @param {Array<T>} list
 *   List to inject into.
 * @param {ReadonlyArray<T>} right
 *   Items to inject.
 * @return {undefined}
 *   Nothing.
 */ function $151e2065d6a4ba72$var$chunkedPush(list, right) {
    /** @type {number} */ let chunkStart = 0;
    if (right.length < 10000) list.push(...right);
    else while(chunkStart < right.length){
        list.push(...right.slice(chunkStart, chunkStart + 10000));
        chunkStart += 10000;
    }
}


function $7901602e44e77495$export$12949d1dd00fddf4(eventsArray) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    const events = new (0, $151e2065d6a4ba72$export$bd596157370df26e)(eventsArray);
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events.get(index);
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events.get(index - 1)[1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === 'enter') {
            if (event[1].contentType) {
                Object.assign(jumps, $7901602e44e77495$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events.get(otherIndex);
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === 'enter') {
                        if (lineIndex) events.get(lineIndex)[1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else if (otherEvent[1].type === "linePrefix" || otherEvent[1].type === "listItemIndent") ;
                else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = {
                    ...events.get(lineIndex)[1].start
                };
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                events.splice(lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    // The changes to the `events` buffer must be copied back into the eventsArray
    (0, $6d957c9e6a169a49$export$869882364835d202)(eventsArray, 0, Number.POSITIVE_INFINITY, events.slice(0));
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {SpliceBuffer<Event>} events
 *   Events.
 * @param {number} eventIndex
 *   Index.
 * @returns {Record<string, number>}
 *   Gaps.
 */ function $7901602e44e77495$var$subcontent(events, eventIndex) {
    const token = events.get(eventIndex)[1];
    const context = events.get(eventIndex)[2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    let tokenizer = token._tokenizer;
    if (!tokenizer) {
        tokenizer = context.parser[token.contentType](token.start);
        if (token._contentTypeTextTrailing) tokenizer._contentTypeTextTrailing = true;
    }
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events.get(++startPosition)[1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === 'exit' && childEvents[index - 1][0] === 'enter' && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.push([
            start,
            start + slice.length - 1
        ]);
        events.splice(start, 2, slice);
    }
    jumps.reverse();
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}


const $728ee34a4e233cee$export$a7db06668cad9adb = {
    resolve: $728ee34a4e233cee$var$resolveContent,
    tokenize: $728ee34a4e233cee$var$tokenizeContent
};
/** @type {Construct} */ const $728ee34a4e233cee$var$continuationConstruct = {
    partial: true,
    tokenize: $728ee34a4e233cee$var$tokenizeContinuation
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $728ee34a4e233cee$var$resolveContent(events) {
    (0, $7901602e44e77495$export$12949d1dd00fddf4)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $728ee34a4e233cee$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return effects.check($728ee34a4e233cee$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $728ee34a4e233cee$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, prefixed, "linePrefix");
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes('codeIndented') && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}




const $4320be06d95fd4d0$export$ccc7b0636abaffc3 = {
    tokenize: $4320be06d95fd4d0$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */ function $4320be06d95fd4d0$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $30b85425f5f538a1$export$d50d28ce3ab2a612), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $728ee34a4e233cee$export$a7db06668cad9adb), afterConstruct)), "linePrefix")));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}


/**
 * @import {
 *   Code,
 *   InitialConstruct,
 *   Initializer,
 *   Resolver,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */ const $009f2a13a0d178f2$export$50397835cbfdbc24 = {
    resolveAll: $009f2a13a0d178f2$var$createResolver()
};
const $009f2a13a0d178f2$export$22b082955e083ec3 = $009f2a13a0d178f2$var$initializeFactory('string');
const $009f2a13a0d178f2$export$6f093cfa640b7166 = $009f2a13a0d178f2$var$initializeFactory('text');
/**
 * @param {'string' | 'text'} field
 *   Field.
 * @returns {InitialConstruct}
 *   Construct.
 */ function $009f2a13a0d178f2$var$initializeFactory(field) {
    return {
        resolveAll: $009f2a13a0d178f2$var$createResolver(field === 'text' ? $009f2a13a0d178f2$var$resolveAllLineSuffixes : undefined),
        tokenize: initializeText
    };
    /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     *   Code.
     * @returns {boolean}
     *   Whether the code is a break.
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 *   Resolver.
 * @returns {Resolver}
 *   Resolver.
 */ function $009f2a13a0d178f2$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $009f2a13a0d178f2$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0; // Skip first.
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === 'string') {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        // Allow final trailing whitespace.
        if (context._contentTypeTextTrailing && eventIndex === events.length) size = 0;
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex,
                    _index: data.start._index + index,
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size
                },
                end: {
                    ...data.end
                }
            };
            data.end = {
                ...token.start
            };
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    'enter',
                    token,
                    context
                ], [
                    'exit',
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}


var $f81d41200564ef26$exports = {};

$parcel$export($f81d41200564ef26$exports, "document", function () { return $f81d41200564ef26$export$5a7bfc01df82fcd1; });
$parcel$export($f81d41200564ef26$exports, "contentInitial", function () { return $f81d41200564ef26$export$5a2181fb44b58173; });
$parcel$export($f81d41200564ef26$exports, "flowInitial", function () { return $f81d41200564ef26$export$cf8bead395eff824; });
$parcel$export($f81d41200564ef26$exports, "flow", function () { return $f81d41200564ef26$export$ccc7b0636abaffc3; });
$parcel$export($f81d41200564ef26$exports, "string", function () { return $f81d41200564ef26$export$22b082955e083ec3; });
$parcel$export($f81d41200564ef26$exports, "text", function () { return $f81d41200564ef26$export$6f093cfa640b7166; });
$parcel$export($f81d41200564ef26$exports, "insideSpan", function () { return $f81d41200564ef26$export$d44f260a3f9b69f5; });
$parcel$export($f81d41200564ef26$exports, "attentionMarkers", function () { return $f81d41200564ef26$export$b9c0b60d74426aea; });
$parcel$export($f81d41200564ef26$exports, "disable", function () { return $f81d41200564ef26$export$e20fbacbb41798b; });
/**
 * @import {Extension} from 'micromark-util-types'
 */ /**
 * @import {
 *   Code,
 *   Construct,
 *   Event,
 *   Point,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 
/**
 * @import {Code} from 'micromark-util-types'
 */ 
function $cae7fc7dfc0e8dc7$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) || (0, $9a96cd0c036af4eb$export$a0ff789c034ffdf4)(code)) return 1;
    if ((0, $9a96cd0c036af4eb$export$aa04114dd888a7a0)(code)) return 2;
}


/**
 * @import {Event, Resolver, TokenizeContext} from 'micromark-util-types'
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {ReadonlyArray<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $a0bda62677f8e9a6$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}


const $ea09a4790e991212$export$45b92471da762af7 = {
    name: 'attention',
    resolveAll: $ea09a4790e991212$var$resolveAllAttention,
    tokenize: $ea09a4790e991212$var$tokenizeAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ // eslint-disable-next-line complexity
function $ea09a4790e991212$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === 'enter' && events[index][1].type === 'attentionSequence' && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === 'exit' && events[open][1].type === 'attentionSequence' && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = {
                ...events[open][1].end
            };
            const end = {
                ...events[index][1].start
            };
            $ea09a4790e991212$var$movePoint(start, -use);
            $ea09a4790e991212$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: {
                    ...events[open][1].end
                }
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: {
                    ...events[index][1].start
                },
                end: end
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: {
                    ...events[open][1].end
                },
                end: {
                    ...events[index][1].start
                }
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: {
                    ...openingSequence.start
                },
                end: {
                    ...closingSequence.end
                }
            };
            events[open][1].end = {
                ...openingSequence.start
            };
            events[index][1].start = {
                ...closingSequence.end
            };
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    events[open][1],
                    context
                ],
                [
                    'exit',
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    group,
                    context
                ],
                [
                    'enter',
                    openingSequence,
                    context
                ],
                [
                    'exit',
                    openingSequence,
                    context
                ],
                [
                    'enter',
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(nextEvents, (0, $a0bda62677f8e9a6$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(nextEvents, [
                [
                    'exit',
                    text,
                    context
                ],
                [
                    'enter',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(nextEvents, [
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $6d957c9e6a169a49$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === 'attentionSequence') events[index][1].type = 'data';
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $ea09a4790e991212$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $cae7fc7dfc0e8dc7$export$e3902bc0d835cad0)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter('attentionSequence');
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit('attentionSequence');
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $cae7fc7dfc0e8dc7$export$e3902bc0d835cad0)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 *   Point.
 * @param {number} offset
 *   Amount to move.
 * @returns {undefined}
 *   Nothing.
 */ function $ea09a4790e991212$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $5d74961dcf69642f$export$17ddf85e4c916ad6 = {
    name: 'autolink',
    tokenize: $5d74961dcf69642f$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $5d74961dcf69642f$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        if (code === 64) return nok(code);
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $9a96cd0c036af4eb$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $9a96cd0c036af4eb$export$4397998b34fe597d)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $5b7191973b2dcb30$export$200dcd0a5903c968 = {
    continuation: {
        tokenize: $5b7191973b2dcb30$var$tokenizeBlockQuoteContinuation
    },
    exit: $5b7191973b2dcb30$var$exit,
    name: 'blockQuote',
    tokenize: $5b7191973b2dcb30$var$tokenizeBlockQuoteStart
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $5b7191973b2dcb30$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $5b7191973b2dcb30$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) // Always populated by defaults.
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($5b7191973b2dcb30$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $5b7191973b2dcb30$var$exit(effects) {
    effects.exit("blockQuote");
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $be85b25963329d93$export$2005478564e78d96 = {
    name: 'characterEscape',
    tokenize: $be85b25963329d93$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $be85b25963329d93$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $9a96cd0c036af4eb$export$35794a7d1db99380)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $3f5b13d75c9b46b1$export$e31905600aaf3d8e = {
    name: 'characterReference',
    tokenize: $3f5b13d75c9b46b1$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $3f5b13d75c9b46b1$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $9a96cd0c036af4eb$export$75c76db11865a9f4);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $9a96cd0c036af4eb$export$eca2752363989806);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $9a96cd0c036af4eb$export$ca8b5b1a6c320e6e);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit("characterReferenceValue");
            if (test === (0, $9a96cd0c036af4eb$export$75c76db11865a9f4) && !(0, $b2bf0a6c22a4700b$export$289b6a6320f709b4)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

/** @type {Construct} */ const $834069fabf19784a$var$nonLazyContinuation = {
    partial: true,
    tokenize: $834069fabf19784a$var$tokenizeNonLazyContinuation
};
const $834069fabf19784a$export$c23e4921f8d87e7c = {
    concrete: true,
    name: 'codeFenced',
    tokenize: $834069fabf19784a$var$tokenizeCodeFenced
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $834069fabf19784a$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        partial: true,
        tokenize: tokenizeCloseStart
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit("codeFencedFenceSequence");
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, infoBefore, "whitespace")(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFencedFence");
            return self.interrupt ? ok(code) : effects.check($834069fabf19784a$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return infoBefore(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, metaBefore, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return infoBefore(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return effects.check($834069fabf19784a$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter("codeFlowValue");
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter("codeFencedFence");
            return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter("codeFencedFenceSequence");
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit("codeFencedFenceSequence");
                return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $834069fabf19784a$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $7dbe9fe18b3b23b2$export$47910b7ab28d1853 = {
    name: 'codeIndented',
    tokenize: $7dbe9fe18b3b23b2$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $7dbe9fe18b3b23b2$var$furtherStart = {
    partial: true,
    tokenize: $7dbe9fe18b3b23b2$var$tokenizeFurtherStart
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $7dbe9fe18b3b23b2$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter("codeIndented");
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return effects.attempt($7dbe9fe18b3b23b2$var$furtherStart, atBreak, after)(code);
        effects.enter("codeFlowValue");
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $7dbe9fe18b3b23b2$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code) ? furtherStart(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Previous,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 
const $23d5e8c756b561fa$export$d24f93e715f9df88 = {
    name: 'codeText',
    previous: $23d5e8c756b561fa$var$previous,
    resolve: $23d5e8c756b561fa$var$resolveCodeText,
    tokenize: $23d5e8c756b561fa$var$tokenizeCodeText
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $23d5e8c756b561fa$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === 'space') && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === 'space')) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Previous}
 */ function $23d5e8c756b561fa$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $23d5e8c756b561fa$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeTextSequence");
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter('space');
            effects.consume(code);
            effects.exit('space');
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return between;
        }
        // Data.
        effects.enter("codeTextData");
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("codeTextData");
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ /**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */ 
function $a5b0165eceaa5b2a$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $9a96cd0c036af4eb$export$67dbf494fc8394df)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code))) {
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $9a96cd0c036af4eb$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}


/**
 * @import {
 *   Effects,
 *   State,
 *   TokenizeContext,
 *   TokenType
 * } from 'micromark-util-types'
 */ 
function $5b1b1349c9302e3d$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && '_hiddenFootnoteSupport' in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}



/**
 * @import {
 *   Code,
 *   Effects,
 *   State,
 *   TokenType
 * } from 'micromark-util-types'
 */ 

function $3b751ecfea53c49c$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, atBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}


/**
 * @import {Effects, State} from 'micromark-util-types'
 */ 

function $65f43375f77b595c$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}




const $03db4060f53ac021$export$69f215ed977cdb73 = {
    name: 'definition',
    tokenize: $03db4060f53ac021$var$tokenizeDefinition
};
/** @type {Construct} */ const $03db4060f53ac021$var$titleBefore = {
    partial: true,
    tokenize: $03db4060f53ac021$var$tokenizeTitleBefore
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $03db4060f53ac021$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter("definition");
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $5b1b1349c9302e3d$export$7b768614d8ba97a7).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $c580fc709a668807$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) ? (0, $65f43375f77b595c$export$1f27bd1aa33ce173)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $a5b0165eceaa5b2a$export$2e6c8deaa96af245)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($03db4060f53ac021$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("definition");
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $03db4060f53ac021$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) ? (0, $65f43375f77b595c$export$1f27bd1aa33ce173)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $3b751ecfea53c49c$export$f970569cc855e483)(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $2db70170e88ebee0$export$86c573ab9e06f418 = {
    name: 'hardBreakEscape',
    tokenize: $2db70170e88ebee0$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $2db70170e88ebee0$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 


const $83113747934b3ae6$export$3871e9deb360695c = {
    name: 'headingAtx',
    resolve: $83113747934b3ae6$var$resolveHeadingAtx,
    tokenize: $83113747934b3ae6$var$tokenizeHeadingAtx
};
/** @type {Resolver} */ function $83113747934b3ae6$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        (0, $6d957c9e6a169a49$export$869882364835d202)(events, contentStart, contentEnd - contentStart + 1, [
            [
                'enter',
                content,
                context
            ],
            [
                'enter',
                text,
                context
            ],
            [
                'exit',
                text,
                context
            ],
            [
                'exit',
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $83113747934b3ae6$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter("atxHeading");
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("atxHeadingSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingSequence");
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequenceFurther(code);
        }
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("atxHeading");
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter("atxHeadingText");
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit("atxHeadingSequence");
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingText");
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $b9e56abd53b703db$export$7364aee1c59d1879 = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'search',
    'section',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];
const $b9e56abd53b703db$export$948e66da505d080 = [
    'pre',
    'script',
    'style',
    'textarea'
];



const $bc2cbab316b16c92$export$476ac411cb7d0d8f = {
    concrete: true,
    name: 'htmlFlow',
    resolveTo: $bc2cbab316b16c92$var$resolveToHtmlFlow,
    tokenize: $bc2cbab316b16c92$var$tokenizeHtmlFlow
};
/** @type {Construct} */ const $bc2cbab316b16c92$var$blankLineBefore = {
    partial: true,
    tokenize: $bc2cbab316b16c92$var$tokenizeBlankLineBefore
};
const $bc2cbab316b16c92$var$nonLazyContinuationStart = {
    partial: true,
    tokenize: $bc2cbab316b16c92$var$tokenizeNonLazyContinuationStart
};
/** @type {Resolver} */ function $bc2cbab316b16c92$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === 'enter' && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $bc2cbab316b16c92$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            // Always the case.
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            // Always the case.
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $b9e56abd53b703db$export$948e66da505d080).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $b9e56abd53b703db$export$7364aee1c59d1879).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code) && (marker === 6 || marker === 7)) {
            effects.exit("htmlFlowData");
            return effects.check($bc2cbab316b16c92$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($bc2cbab316b16c92$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return continuationStart(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = '';
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $b9e56abd53b703db$export$948e66da505d080).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code) && buffer.length < 8) {
            // Always the case.
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit("htmlFlow");
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $bc2cbab316b16c92$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $bc2cbab316b16c92$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return effects.attempt((0, $30b85425f5f538a1$export$d50d28ce3ab2a612), ok, nok);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $d4159befe711bc18$export$398af27f284914fe = {
    name: 'htmlText',
    tokenize: $d4159befe711bc18$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $d4159befe711bc18$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Event,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 







const $2761660aaca3721f$export$470a5dafbbf62654 = {
    name: 'labelEnd',
    resolveAll: $2761660aaca3721f$var$resolveAllLabelEnd,
    resolveTo: $2761660aaca3721f$var$resolveToLabelEnd,
    tokenize: $2761660aaca3721f$var$tokenizeLabelEnd
};
/** @type {Construct} */ const $2761660aaca3721f$var$resourceConstruct = {
    tokenize: $2761660aaca3721f$var$tokenizeResource
};
/** @type {Construct} */ const $2761660aaca3721f$var$referenceFullConstruct = {
    tokenize: $2761660aaca3721f$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $2761660aaca3721f$var$referenceCollapsedConstruct = {
    tokenize: $2761660aaca3721f$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $2761660aaca3721f$var$resolveAllLabelEnd(events) {
    let index = -1;
    /** @type {Array<Event>} */ const newEvents = [];
    while(++index < events.length){
        const token = events[index][1];
        newEvents.push(events[index]);
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            const offset = token.type === "labelImage" ? 4 : 2;
            token.type = "data";
            index += offset;
        }
    }
    // If the events are equal, we don't have to copy newEvents to events
    if (events.length !== newEvents.length) (0, $6d957c9e6a169a49$export$869882364835d202)(events, 0, events.length, newEvents);
    return events;
}
/** @type {Resolver} */ function $2761660aaca3721f$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === 'enter' && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === 'enter' && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    const group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: {
            ...events[open][1].start
        },
        end: {
            ...events[events.length - 1][1].end
        }
    };
    const label = {
        type: "label",
        start: {
            ...events[open][1].start
        },
        end: {
            ...events[close][1].end
        }
    };
    const text = {
        type: "labelText",
        start: {
            ...events[open + offset + 2][1].end
        },
        end: {
            ...events[close - 2][1].start
        }
    };
    media = [
        [
            'enter',
            group,
            context
        ],
        [
            'enter',
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(media, [
        [
            'enter',
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(media, (0, $a0bda62677f8e9a6$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(media, [
        [
            'exit',
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            'exit',
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(media, events.slice(close + 1));
    // Media close.
    media = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(media, [
        [
            'exit',
            group,
            context
        ]
    ]);
    (0, $6d957c9e6a169a49$export$869882364835d202)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $2761660aaca3721f$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $c580fc709a668807$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($2761660aaca3721f$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($2761660aaca3721f$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($2761660aaca3721f$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $2761660aaca3721f$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) ? (0, $65f43375f77b595c$export$1f27bd1aa33ce173)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $a5b0165eceaa5b2a$export$2e6c8deaa96af245)(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) ? (0, $65f43375f77b595c$export$1f27bd1aa33ce173)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $3b751ecfea53c49c$export$f970569cc855e483)(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) ? (0, $65f43375f77b595c$export$1f27bd1aa33ce173)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $2761660aaca3721f$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $5b1b1349c9302e3d$export$7b768614d8ba97a7).call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $c580fc709a668807$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $2761660aaca3721f$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $39595bc63cd49799$export$3d754936e25aa5f5 = {
    name: 'labelStartImage',
    resolveAll: (0, $2761660aaca3721f$export$470a5dafbbf62654).resolveAll,
    tokenize: $39595bc63cd49799$var$tokenizeLabelStartImage
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $39595bc63cd49799$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $036fa9de6a4e2994$export$5c0cee0701a3b584 = {
    name: 'labelStartLink',
    resolveAll: (0, $2761660aaca3721f$export$470a5dafbbf62654).resolveAll,
    tokenize: $036fa9de6a4e2994$var$tokenizeLabelStartLink
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $036fa9de6a4e2994$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $309179153cfedf16$export$8e62e0ad51c97b2 = {
    name: 'lineEnding',
    tokenize: $309179153cfedf16$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $309179153cfedf16$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, ok, "linePrefix");
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 


/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $e46429feccf3186d$export$ba7b13e047416c03 = {
    name: 'thematicBreak',
    tokenize: $e46429feccf3186d$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $e46429feccf3186d$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("thematicBreak");
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code))) {
            effects.exit("thematicBreak");
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code) : atBreak(code);
    }
}


const $3c31a37b3e3d082a$export$8837f4fc672e936d = {
    continuation: {
        tokenize: $3c31a37b3e3d082a$var$tokenizeListContinuation
    },
    exit: $3c31a37b3e3d082a$var$tokenizeListEnd,
    name: 'list',
    tokenize: $3c31a37b3e3d082a$var$tokenizeListStart
};
/** @type {Construct} */ const $3c31a37b3e3d082a$var$listItemPrefixWhitespaceConstruct = {
    partial: true,
    tokenize: $3c31a37b3e3d082a$var$tokenizeListItemPrefixWhitespace
};
/** @type {Construct} */ const $3c31a37b3e3d082a$var$indentConstruct = {
    partial: true,
    tokenize: $3c31a37b3e3d082a$var$tokenizeIndent
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $3c31a37b3e3d082a$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $9a96cd0c036af4eb$export$ca8b5b1a6c320e6e)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $e46429feccf3186d$export$ba7b13e047416c03), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $9a96cd0c036af4eb$export$ca8b5b1a6c320e6e)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $30b85425f5f538a1$export$d50d28ce3ab2a612), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($3c31a37b3e3d082a$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $3c31a37b3e3d082a$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $30b85425f5f538a1$export$d50d28ce3ab2a612), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($3c31a37b3e3d082a$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, effects.attempt($3c31a37b3e3d082a$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $3c31a37b3e3d082a$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Exiter}
 */ function $3c31a37b3e3d082a$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $3c31a37b3e3d082a$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $151c8a7318d441a4$export$e104e2de391dfde9 = {
    name: 'setextUnderline',
    resolveTo: $151c8a7318d441a4$var$resolveToSetextUnderline,
    tokenize: $151c8a7318d441a4$var$tokenizeSetextUnderline
};
/** @type {Resolver} */ function $151c8a7318d441a4$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === 'enter') {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    const heading = {
        type: "setextHeading",
        start: {
            ...events[content][1].start
        },
        end: {
            ...events[events.length - 1][1].end
        }
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = "setextHeadingText";
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            'enter',
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            'exit',
            events[content][1],
            context
        ]);
        events[content][1].end = {
            ...events[definition][1].end
        };
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        'exit',
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $151c8a7318d441a4$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
            paragraph = self.events[index][1].type === "paragraph";
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("setextHeadingLineSequence");
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, after, "lineSuffix")(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}



const $f81d41200564ef26$export$5a7bfc01df82fcd1 = {
    [42]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [43]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [45]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [48]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [49]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [50]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [51]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [52]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [53]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [54]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [55]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [56]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [57]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [62]: (0, $5b7191973b2dcb30$export$200dcd0a5903c968)
};
const $f81d41200564ef26$export$5a2181fb44b58173 = {
    [91]: (0, $03db4060f53ac021$export$69f215ed977cdb73)
};
const $f81d41200564ef26$export$cf8bead395eff824 = {
    [-2]: (0, $7dbe9fe18b3b23b2$export$47910b7ab28d1853),
    [-1]: (0, $7dbe9fe18b3b23b2$export$47910b7ab28d1853),
    [32]: (0, $7dbe9fe18b3b23b2$export$47910b7ab28d1853)
};
const $f81d41200564ef26$export$ccc7b0636abaffc3 = {
    [35]: (0, $83113747934b3ae6$export$3871e9deb360695c),
    [42]: (0, $e46429feccf3186d$export$ba7b13e047416c03),
    [45]: [
        (0, $151c8a7318d441a4$export$e104e2de391dfde9),
        (0, $e46429feccf3186d$export$ba7b13e047416c03)
    ],
    [60]: (0, $bc2cbab316b16c92$export$476ac411cb7d0d8f),
    [61]: (0, $151c8a7318d441a4$export$e104e2de391dfde9),
    [95]: (0, $e46429feccf3186d$export$ba7b13e047416c03),
    [96]: (0, $834069fabf19784a$export$c23e4921f8d87e7c),
    [126]: (0, $834069fabf19784a$export$c23e4921f8d87e7c)
};
const $f81d41200564ef26$export$22b082955e083ec3 = {
    [38]: (0, $3f5b13d75c9b46b1$export$e31905600aaf3d8e),
    [92]: (0, $be85b25963329d93$export$2005478564e78d96)
};
const $f81d41200564ef26$export$6f093cfa640b7166 = {
    [-5]: (0, $309179153cfedf16$export$8e62e0ad51c97b2),
    [-4]: (0, $309179153cfedf16$export$8e62e0ad51c97b2),
    [-3]: (0, $309179153cfedf16$export$8e62e0ad51c97b2),
    [33]: (0, $39595bc63cd49799$export$3d754936e25aa5f5),
    [38]: (0, $3f5b13d75c9b46b1$export$e31905600aaf3d8e),
    [42]: (0, $ea09a4790e991212$export$45b92471da762af7),
    [60]: [
        (0, $5d74961dcf69642f$export$17ddf85e4c916ad6),
        (0, $d4159befe711bc18$export$398af27f284914fe)
    ],
    [91]: (0, $036fa9de6a4e2994$export$5c0cee0701a3b584),
    [92]: [
        (0, $2db70170e88ebee0$export$86c573ab9e06f418),
        (0, $be85b25963329d93$export$2005478564e78d96)
    ],
    [93]: (0, $2761660aaca3721f$export$470a5dafbbf62654),
    [95]: (0, $ea09a4790e991212$export$45b92471da762af7),
    [96]: (0, $23d5e8c756b561fa$export$d24f93e715f9df88)
};
const $f81d41200564ef26$export$d44f260a3f9b69f5 = {
    null: [
        (0, $ea09a4790e991212$export$45b92471da762af7),
        (0, $009f2a13a0d178f2$export$50397835cbfdbc24)
    ]
};
const $f81d41200564ef26$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $f81d41200564ef26$export$e20fbacbb41798b = {
    null: []
};


/**
 * @import {
 *   Chunk,
 *   Code,
 *   ConstructRecord,
 *   Construct,
 *   Effects,
 *   InitialConstruct,
 *   ParseContext,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @callback Restore
 *   Restore the state.
 * @returns {undefined}
 *   Nothing.
 *
 * @typedef Info
 *   Info.
 * @property {Restore} restore
 *   Restore.
 * @property {number} from
 *   From.
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 *   Construct.
 * @param {Info} info
 *   Info.
 * @returns {undefined}
 *   Nothing.
 */ 


function $e090088a8e1afd2b$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = {
        _bufferIndex: -1,
        _index: 0,
        line: from && from.line || 1,
        column: from && from.column || 1,
        offset: from && from.offset || 0
    };
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        consume: consume,
        enter: enter,
        exit: exit,
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        code: null,
        containerState: {},
        defineSkip: defineSkip,
        events: [],
        now: now,
        parser: parser,
        previous: null,
        sliceSerialize: sliceSerialize,
        sliceStream: sliceStream,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | undefined}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $a0bda62677f8e9a6$export$3ff61ec196ff408b)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $e090088a8e1afd2b$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $e090088a8e1afd2b$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { _bufferIndex: _bufferIndex, _index: _index, line: line, column: column, offset: offset } = point;
        return {
            _bufferIndex: _bufferIndex,
            _index: _index,
            line: line,
            column: column,
            offset: offset
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {undefined}
   *   Nothing.
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === 'string') {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   *   Code.
   * @returns {undefined}
   *   Nothing.
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            if (point._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
            // strings.
            /** @type {string} */ chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            'enter',
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            'exit',
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   *   Callback.
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   *   Fields.
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | ConstructRecord | Construct} constructs
     *   Constructs.
     * @param {State} returnState
     *   State.
     * @param {State | undefined} [bogusState]
     *   State.
     * @returns {State}
     *   State.
     */ function hook(constructs, returnState, bogusState) {
            /** @type {ReadonlyArray<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? /* c8 ignore next 1 */ handleListOfConstructs(constructs) : 'tokenize' in constructs ? // Looks like a construct.
            handleListOfConstructs([
                /** @type {Construct} */ constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       *   Constructs.
       * @returns {State}
       *   State.
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const left = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(left) ? left : left ? [
                            left
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {ReadonlyArray<Construct>} list
       *   Constructs.
       * @returns {State}
       *   State.
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       *   Construct.
       * @returns {State}
       *   State.
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   *   Construct.
   * @param {number} from
   *   From.
   * @returns {undefined}
   *   Nothing.
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $6d957c9e6a169a49$export$869882364835d202)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   *   Info.
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            from: startEventsIndex,
            restore: restore
        };
        /**
     * Restore state.
     *
     * @returns {undefined}
     *   Nothing.
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {undefined}
   *   Nothing.
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {Pick<Token, 'end' | 'start'>} token
 *   Token.
 * @returns {Array<Chunk>}
 *   Chunks.
 */ function $e090088a8e1afd2b$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === 'string') view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {boolean | undefined} [expandTabs=false]
 *   Whether to expand tabs (default: `false`).
 * @returns {string}
 *   Result.
 */ function $e090088a8e1afd2b$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === 'string') value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? " " : "\t";
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join('');
}


function $9dfba146f4c3c794$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $1c4ab323543eb9b7$export$86a865d89ef3c690)([
        $f81d41200564ef26$exports,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        constructs: constructs,
        content: create((0, $145b6cb5bda265c1$export$a7db06668cad9adb)),
        defined: [],
        document: create((0, $3d8796971204dffa$export$5a7bfc01df82fcd1)),
        flow: create((0, $4320be06d95fd4d0$export$ccc7b0636abaffc3)),
        lazy: {},
        string: create((0, $009f2a13a0d178f2$export$22b082955e083ec3)),
        text: create((0, $009f2a13a0d178f2$export$6f093cfa640b7166))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   *   Construct to start with.
   * @returns {Create}
   *   Create a tokenizer.
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $e090088a8e1afd2b$export$ae34f10ee4b29837)(parser, initial, from);
        }
    }
}


/**
 * @import {Event} from 'micromark-util-types'
 */ 
function $faf817751c9db3c6$export$bd0e6e1378a871d7(events) {
    while(!(0, $7901602e44e77495$export$12949d1dd00fddf4)(events));
    return events;
}


/**
 * @import {Chunk, Code, Encoding, Value} from 'micromark-util-types'
 */ /**
 * @callback Preprocessor
 *   Preprocess a value.
 * @param {Value} value
 *   Value.
 * @param {Encoding | null | undefined} [encoding]
 *   Encoding when `value` is a typed array (optional).
 * @param {boolean | null | undefined} [end=false]
 *   Whether this is the last chunk (default: `false`).
 * @returns {Array<Chunk>}
 *   Chunks.
 */ const $2dbc8c8d3cee1d06$var$search = /[\0\t\n\r]/g;
function $2dbc8c8d3cee1d06$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = '';
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ // eslint-disable-next-line complexity
    function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        value = buffer + (typeof value === 'string' ? value.toString() : new TextDecoder(encoding || undefined).decode(value));
        startPosition = 0;
        buffer = '';
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $2dbc8c8d3cee1d06$var$search.lastIndex = startPosition;
            match = $2dbc8c8d3cee1d06$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}


function $b990c273e4f741f3$export$eb6d260b88819962(value, encoding, options) {
    if (typeof encoding !== 'string') {
        options = encoding;
        encoding = undefined;
    }
    return (0, $76c598c95b20c009$export$ef7acd7185315e22)(options)((0, $faf817751c9db3c6$export$bd0e6e1378a871d7)((0, $9dfba146f4c3c794$export$98e6a39c04603d36)(options).document().write((0, $2dbc8c8d3cee1d06$export$fc37fe19dfda43ee)()(value, encoding, true))));
}





const $516ec3b0ba9da2c8$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $516ec3b0ba9da2c8$export$a0fb664af7d0cc44(value) {
    return value.replace($516ec3b0ba9da2c8$var$characterEscapeOrReference, $516ec3b0ba9da2c8$var$decode);
}
/**
 * @param {string} $0
 *   Match.
 * @param {string} $1
 *   Character escape.
 * @param {string} $2
 *   Character reference.
 * @returns {string}
 *   Decoded value
 */ function $516ec3b0ba9da2c8$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $a72b41c19fbe228c$export$15a69557afac2c20)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $b2bf0a6c22a4700b$export$289b6a6320f709b4)($2) || $0;
}





const $dc140a31dd8ab4b3$var$own = {}.hasOwnProperty;
function $dc140a31dd8ab4b3$export$d744d789c09bfde6(value, encoding, options) {
    if (encoding && typeof encoding === 'object') {
        options = encoding;
        encoding = undefined;
    }
    return $dc140a31dd8ab4b3$var$compiler(options)((0, $faf817751c9db3c6$export$bd0e6e1378a871d7)((0, $9dfba146f4c3c794$export$98e6a39c04603d36)(options).document().write((0, $2dbc8c8d3cee1d06$export$fc37fe19dfda43ee)()(value, encoding, true))));
}
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $dc140a31dd8ab4b3$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            'emphasis',
            'fragment',
            'heading',
            'paragraph',
            'strong'
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            characterReference: onexitcharacterreference,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $dc140a31dd8ab4b3$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: 'root',
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            data: data
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === 'enter') listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($dc140a31dd8ab4b3$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $dc140a31dd8ab4b3$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $dc140a31dd8ab4b3$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $dc140a31dd8ab4b3$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            switch(event[1].type){
                case "listUnordered":
                case "listOrdered":
                case "blockQuote":
                    if (event[0] === 'enter') containerBalance++;
                    else containerBalance--;
                    atMarker = undefined;
                    break;
                case "lineEndingBlank":
                    if (event[0] === 'enter') {
                        if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                        atMarker = undefined;
                    }
                    break;
                case "linePrefix":
                case "listItemValue":
                case "listItemMarker":
                case "listItemPrefix":
                case "listItemPrefixWhitespace":
                    break;
                default:
                    atMarker = undefined;
            }
            if (!containerBalance && event[0] === 'enter' && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === 'exit' && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === 'exit') continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        'exit',
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    /** @type {Token} */ const item = {
                        type: 'listItem',
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    listItem = item;
                    events.splice(index, 0, [
                        'enter',
                        item,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Nodes} create
   *   Create a node.
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @type {CompileContext['buffer']}
   */ function buffer() {
        this.stack.push({
            type: 'fragment',
            children: []
        });
    }
    /**
   * @type {CompileContext['enter']}
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = parent.children;
        siblings.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler || undefined
        ]);
        node.position = {
            start: $dc140a31dd8ab4b3$var$point(token.start),
            // @ts-expect-error: `end` will be patched later.
            end: undefined
        };
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @type {CompileContext['exit']}
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error('Cannot close `' + token.type + '` (' + (0, $451965882c5a8799$export$c304dd45fe166145)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $dc140a31dd8ab4b3$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $dc140a31dd8ab4b3$var$point(token.end);
    }
    /**
   * @type {CompileContext['resume']}
   */ function resume() {
        return (0, $da74a7bb5b052f79$export$f84e8e69fd4488a5)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        this.data.expectingFirstListItemValue = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (this.data.expectingFirstListItemValue) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            this.data.expectingFirstListItemValue = undefined;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (this.data.flowCodeInside) return;
        this.buffer();
        this.data.flowCodeInside = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '');
        this.data.flowCodeInside = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, '');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $c580fc709a668807$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        this.data.setextHeadingSlurpLineEnding = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).codePointAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        this.data.setextHeadingSlurpLineEnding = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = node.children;
        let tail = siblings[siblings.length - 1];
        if (!tail || tail.type !== 'text') {
            // Add a new text node.
            tail = text();
            tail.position = {
                start: $dc140a31dd8ab4b3$var$point(token.start),
                // @ts-expect-error: we’ll add `end` later.
                end: undefined
            };
            siblings.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $dc140a31dd8ab4b3$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (this.data.atHardBreak) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $dc140a31dd8ab4b3$var$point(token.end);
            this.data.atHardBreak = undefined;
            return;
        }
        if (!this.data.setextHeadingSlurpLineEnding && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        this.data.atHardBreak = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $516ec3b0ba9da2c8$export$a0fb664af7d0cc44)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $c580fc709a668807$export$806d55e226cfcd08)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        this.data.inReference = true;
        if (node.type === 'link') {
            /** @type {Array<PhrasingContent>} */ const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        this.data.inReference = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        this.data.referenceType = 'collapsed';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $c580fc709a668807$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
        this.data.referenceType = 'full';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        this.data.characterReferenceType = token.type;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = this.data.characterReferenceType;
        /** @type {string} */ let value;
        if (type) {
            value = (0, $a72b41c19fbe228c$export$15a69557afac2c20)(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            this.data.characterReferenceType = undefined;
        } else {
            const result = (0, $b2bf0a6c22a4700b$export$289b6a6320f709b4)(data);
            value = result;
        }
        const tail = this.stack[this.stack.length - 1];
        tail.value += value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreference(token) {
        const tail = this.stack.pop();
        tail.position.end = $dc140a31dd8ab4b3$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = 'mailto:' + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: 'blockquote',
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: 'code',
            lang: null,
            meta: null,
            value: ''
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: 'inlineCode',
            value: ''
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: 'definition',
            identifier: '',
            label: null,
            title: null,
            url: ''
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: 'emphasis',
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        return {
            type: 'heading',
            // @ts-expect-error `depth` will be set later.
            depth: 0,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: 'break'
        };
    }
    /** @returns {Html} */ function html() {
        return {
            type: 'html',
            value: ''
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: 'image',
            title: null,
            url: '',
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: 'link',
            title: null,
            url: '',
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: 'list',
            ordered: token.type === 'listOrdered',
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: 'listItem',
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: 'paragraph',
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: 'strong',
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: 'text',
            value: ''
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: 'thematicBreak'
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $dc140a31dd8ab4b3$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Array<Extension> | Extension>} extensions
 * @returns {undefined}
 */ function $dc140a31dd8ab4b3$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $dc140a31dd8ab4b3$var$configure(combined, value);
        else $dc140a31dd8ab4b3$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {undefined}
 */ function $dc140a31dd8ab4b3$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($dc140a31dd8ab4b3$var$own.call(extension, key)) switch(key){
        case 'canContainEols':
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case 'transforms':
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case 'enter':
        case 'exit':
            {
                const right = extension[key];
                if (right) Object.assign(combined[key], right);
                break;
            }
    }
}
/** @type {OnEnterError} */ function $dc140a31dd8ab4b3$var$defaultOnError(left, right) {
    if (left) throw new Error('Cannot close `' + left.type + '` (' + (0, $451965882c5a8799$export$c304dd45fe166145)({
        start: left.start,
        end: left.end
    }) + '): a different token (`' + right.type + '`, ' + (0, $451965882c5a8799$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is open');
    else throw new Error('Cannot close document, a token (`' + right.type + '`, ' + (0, $451965882c5a8799$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is still open');
}


function $4f339a22525673d0$export$2e2bcd8739ae039(options) {
    /** @type {Processor} */ // @ts-expect-error: TS in JSDoc generates wrong types if `this` is typed regularly.
    const self = this;
    self.parser = parser;
    /**
   * @type {Parser}
   */ function parser(doc) {
        return (0, $dc140a31dd8ab4b3$export$d744d789c09bfde6)(doc, {
            ...self.data('settings'),
            ...options,
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: self.data('micromarkExtensions') || [],
            mdastExtensions: self.data('fromMarkdownExtensions') || []
        });
    }
}


/**
 * @import {Root as HastRoot} from 'hast'
 * @import {Root as MdastRoot} from 'mdast'
 * @import {Options as ToHastOptions} from 'mdast-util-to-hast'
 * @import {Processor} from 'unified'
 * @import {VFile} from 'vfile'
 */ /**
 * @typedef {Omit<ToHastOptions, 'file'>} Options
 *
 * @callback TransformBridge
 *   Bridge-mode.
 *
 *   Runs the destination with the new hast tree.
 *   Discards result.
 * @param {MdastRoot} tree
 *   Tree.
 * @param {VFile} file
 *   File.
 * @returns {Promise<undefined>}
 *   Nothing.
 *
 * @callback TransformMutate
 *  Mutate-mode.
 *
 *  Further transformers run on the hast tree.
 * @param {MdastRoot} tree
 *   Tree.
 * @param {VFile} file
 *   File.
 * @returns {HastRoot}
 *   Tree (hast).
 */ /**
 * @import {Nodes as HastNodes} from 'hast'
 * @import {Nodes as MdastNodes} from 'mdast'
 * @import {Options} from './state.js'
 */ 
/**
 * @import {ElementContent, Element} from 'hast'
 * @import {State} from './state.js'
 */ /**
 * @callback FootnoteBackContentTemplate
 *   Generate content for the backreference dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   *  `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   *  `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   *  `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {Array<ElementContent> | ElementContent | string}
 *   Content for the backreference when linking back from definitions to their
 *   reference.
 *
 * @callback FootnoteBackLabelTemplate
 *   Generate a back label dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   *  `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   *  `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   *  `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {string}
 *   Back label to use when linking back from definitions to their reference.
 */ const $2b1365c4997070ae$export$1cd1943b3a73bbe8 = -1;
const $2b1365c4997070ae$export$a44b4f3d5b73db95 = 0;
const $2b1365c4997070ae$export$b119f07080a207ba = 1;
const $2b1365c4997070ae$export$8b8a958a7f6f130c = 2;
const $2b1365c4997070ae$export$501a7fac1df67a49 = 3;
const $2b1365c4997070ae$export$cd2b220b1ea851b2 = 4;
const $2b1365c4997070ae$export$ce970371e0e850bc = 5;
const $2b1365c4997070ae$export$5e8f180ef0142226 = 6;
const $2b1365c4997070ae$export$103bedf43ba882db = 7;
const $2b1365c4997070ae$export$9f2207c8fceeefa8 = 8; // export const SYMBOL = 9;


const $293fd6bfda9276e2$var$env = typeof self === 'object' ? self : globalThis;
const $293fd6bfda9276e2$var$deserializer = ($, _)=>{
    const as = (out, index)=>{
        $.set(index, out);
        return out;
    };
    const unpair = (index)=>{
        if ($.has(index)) return $.get(index);
        const [type, value] = _[index];
        switch(type){
            case 0, $2b1365c4997070ae$export$a44b4f3d5b73db95:
            case 0, $2b1365c4997070ae$export$1cd1943b3a73bbe8:
                return as(value, index);
            case 0, $2b1365c4997070ae$export$b119f07080a207ba:
                {
                    const arr = as([], index);
                    for (const index of value)arr.push(unpair(index));
                    return arr;
                }
            case 0, $2b1365c4997070ae$export$8b8a958a7f6f130c:
                {
                    const object = as({}, index);
                    for (const [key, index] of value)object[unpair(key)] = unpair(index);
                    return object;
                }
            case 0, $2b1365c4997070ae$export$501a7fac1df67a49:
                return as(new Date(value), index);
            case 0, $2b1365c4997070ae$export$cd2b220b1ea851b2:
                {
                    const { source: source, flags: flags } = value;
                    return as(new RegExp(source, flags), index);
                }
            case 0, $2b1365c4997070ae$export$ce970371e0e850bc:
                {
                    const map = as(new Map, index);
                    for (const [key, index] of value)map.set(unpair(key), unpair(index));
                    return map;
                }
            case 0, $2b1365c4997070ae$export$5e8f180ef0142226:
                {
                    const set = as(new Set, index);
                    for (const index of value)set.add(unpair(index));
                    return set;
                }
            case 0, $2b1365c4997070ae$export$103bedf43ba882db:
                {
                    const { name: name, message: message } = value;
                    return as(new $293fd6bfda9276e2$var$env[name](message), index);
                }
            case 0, $2b1365c4997070ae$export$9f2207c8fceeefa8:
                return as(BigInt(value), index);
            case 'BigInt':
                return as(Object(BigInt(value)), index);
            case 'ArrayBuffer':
                return as(new Uint8Array(value).buffer, value);
            case 'DataView':
                {
                    const { buffer: buffer } = new Uint8Array(value);
                    return as(new DataView(buffer), value);
                }
        }
        return as(new $293fd6bfda9276e2$var$env[type](value), index);
    };
    return unpair;
};
const $293fd6bfda9276e2$export$efcd34ab6248d3cd = (serialized)=>$293fd6bfda9276e2$var$deserializer(new Map, serialized)(0);



const $623b953cac82f88a$var$EMPTY = '';
const { toString: $623b953cac82f88a$var$toString } = {};
const { keys: $623b953cac82f88a$var$keys } = Object;
const $623b953cac82f88a$var$typeOf = (value)=>{
    const type = typeof value;
    if (type !== 'object' || !value) return [
        (0, $2b1365c4997070ae$export$a44b4f3d5b73db95),
        type
    ];
    const asString = $623b953cac82f88a$var$toString.call(value).slice(8, -1);
    switch(asString){
        case 'Array':
            return [
                (0, $2b1365c4997070ae$export$b119f07080a207ba),
                $623b953cac82f88a$var$EMPTY
            ];
        case 'Object':
            return [
                (0, $2b1365c4997070ae$export$8b8a958a7f6f130c),
                $623b953cac82f88a$var$EMPTY
            ];
        case 'Date':
            return [
                (0, $2b1365c4997070ae$export$501a7fac1df67a49),
                $623b953cac82f88a$var$EMPTY
            ];
        case 'RegExp':
            return [
                (0, $2b1365c4997070ae$export$cd2b220b1ea851b2),
                $623b953cac82f88a$var$EMPTY
            ];
        case 'Map':
            return [
                (0, $2b1365c4997070ae$export$ce970371e0e850bc),
                $623b953cac82f88a$var$EMPTY
            ];
        case 'Set':
            return [
                (0, $2b1365c4997070ae$export$5e8f180ef0142226),
                $623b953cac82f88a$var$EMPTY
            ];
        case 'DataView':
            return [
                (0, $2b1365c4997070ae$export$b119f07080a207ba),
                asString
            ];
    }
    if (asString.includes('Array')) return [
        (0, $2b1365c4997070ae$export$b119f07080a207ba),
        asString
    ];
    if (asString.includes('Error')) return [
        (0, $2b1365c4997070ae$export$103bedf43ba882db),
        asString
    ];
    return [
        (0, $2b1365c4997070ae$export$8b8a958a7f6f130c),
        asString
    ];
};
const $623b953cac82f88a$var$shouldSkip = ([TYPE, type])=>TYPE === (0, $2b1365c4997070ae$export$a44b4f3d5b73db95) && (type === 'function' || type === 'symbol');
const $623b953cac82f88a$var$serializer = (strict, json, $, _)=>{
    const as = (out, value)=>{
        const index = _.push(out) - 1;
        $.set(value, index);
        return index;
    };
    const pair = (value)=>{
        if ($.has(value)) return $.get(value);
        let [TYPE, type] = $623b953cac82f88a$var$typeOf(value);
        switch(TYPE){
            case 0, $2b1365c4997070ae$export$a44b4f3d5b73db95:
                {
                    let entry = value;
                    switch(type){
                        case 'bigint':
                            TYPE = (0, $2b1365c4997070ae$export$9f2207c8fceeefa8);
                            entry = value.toString();
                            break;
                        case 'function':
                        case 'symbol':
                            if (strict) throw new TypeError('unable to serialize ' + type);
                            entry = null;
                            break;
                        case 'undefined':
                            return as([
                                (0, $2b1365c4997070ae$export$1cd1943b3a73bbe8)
                            ], value);
                    }
                    return as([
                        TYPE,
                        entry
                    ], value);
                }
            case 0, $2b1365c4997070ae$export$b119f07080a207ba:
                {
                    if (type) {
                        let spread = value;
                        if (type === 'DataView') spread = new Uint8Array(value.buffer);
                        else if (type === 'ArrayBuffer') spread = new Uint8Array(value);
                        return as([
                            type,
                            [
                                ...spread
                            ]
                        ], value);
                    }
                    const arr = [];
                    const index = as([
                        TYPE,
                        arr
                    ], value);
                    for (const entry of value)arr.push(pair(entry));
                    return index;
                }
            case 0, $2b1365c4997070ae$export$8b8a958a7f6f130c:
                {
                    if (type) switch(type){
                        case 'BigInt':
                            return as([
                                type,
                                value.toString()
                            ], value);
                        case 'Boolean':
                        case 'Number':
                        case 'String':
                            return as([
                                type,
                                value.valueOf()
                            ], value);
                    }
                    if (json && 'toJSON' in value) return pair(value.toJSON());
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const key of $623b953cac82f88a$var$keys(value))if (strict || !$623b953cac82f88a$var$shouldSkip($623b953cac82f88a$var$typeOf(value[key]))) entries.push([
                        pair(key),
                        pair(value[key])
                    ]);
                    return index;
                }
            case 0, $2b1365c4997070ae$export$501a7fac1df67a49:
                return as([
                    TYPE,
                    value.toISOString()
                ], value);
            case 0, $2b1365c4997070ae$export$cd2b220b1ea851b2:
                {
                    const { source: source, flags: flags } = value;
                    return as([
                        TYPE,
                        {
                            source: source,
                            flags: flags
                        }
                    ], value);
                }
            case 0, $2b1365c4997070ae$export$ce970371e0e850bc:
                {
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const [key, entry] of value)if (strict || !($623b953cac82f88a$var$shouldSkip($623b953cac82f88a$var$typeOf(key)) || $623b953cac82f88a$var$shouldSkip($623b953cac82f88a$var$typeOf(entry)))) entries.push([
                        pair(key),
                        pair(entry)
                    ]);
                    return index;
                }
            case 0, $2b1365c4997070ae$export$5e8f180ef0142226:
                {
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const entry of value)if (strict || !$623b953cac82f88a$var$shouldSkip($623b953cac82f88a$var$typeOf(entry))) entries.push(pair(entry));
                    return index;
                }
        }
        const { message: message } = value;
        return as([
            TYPE,
            {
                name: type,
                message: message
            }
        ], value);
    };
    return pair;
};
const $623b953cac82f88a$export$dfdc1655ccc5b9cb = (value, { json: json, lossy: lossy } = {})=>{
    const _ = [];
    return $623b953cac82f88a$var$serializer(!(json || lossy), !!json, new Map, _)(value), _;
};


var /**
 * @typedef {Array<string,any>} Record a type representation
 */ /**
 * Returns an array of serialized Records.
 * @param {any} any a serializable value.
 * @param {{transfer?: any[], json?: boolean, lossy?: boolean}?} options an object with
 * a transfer option (ignored when polyfilled) and/or non standard fields that
 * fallback to the polyfill if present.
 * @returns {Record[]}
 */ $e46c0242ff031819$export$2e2bcd8739ae039 = typeof structuredClone === "function" ? /* c8 ignore start */ (any, options)=>options && ('json' in options || 'lossy' in options) ? (0, $293fd6bfda9276e2$export$efcd34ab6248d3cd)((0, $623b953cac82f88a$export$dfdc1655ccc5b9cb)(any, options)) : structuredClone(any) : (any, options)=>(0, $293fd6bfda9276e2$export$efcd34ab6248d3cd)((0, $623b953cac82f88a$export$dfdc1655ccc5b9cb)(any, options));



function $5f8ac0136b7180f6$export$4a6e1c4b9e5bc5d1(_, rereferenceIndex) {
    /** @type {Array<ElementContent>} */ const result = [
        {
            type: 'text',
            value: "\u21A9"
        }
    ];
    if (rereferenceIndex > 1) result.push({
        type: 'element',
        tagName: 'sup',
        properties: {},
        children: [
            {
                type: 'text',
                value: String(rereferenceIndex)
            }
        ]
    });
    return result;
}
function $5f8ac0136b7180f6$export$d83e66a407212d3b(referenceIndex, rereferenceIndex) {
    return 'Back to reference ' + (referenceIndex + 1) + (rereferenceIndex > 1 ? '-' + rereferenceIndex : '');
}
function $5f8ac0136b7180f6$export$adb608be33961c98(state) {
    const clobberPrefix = typeof state.options.clobberPrefix === 'string' ? state.options.clobberPrefix : 'user-content-';
    const footnoteBackContent = state.options.footnoteBackContent || $5f8ac0136b7180f6$export$4a6e1c4b9e5bc5d1;
    const footnoteBackLabel = state.options.footnoteBackLabel || $5f8ac0136b7180f6$export$d83e66a407212d3b;
    const footnoteLabel = state.options.footnoteLabel || 'Footnotes';
    const footnoteLabelTagName = state.options.footnoteLabelTagName || 'h2';
    const footnoteLabelProperties = state.options.footnoteLabelProperties || {
        className: [
            'sr-only'
        ]
    };
    /** @type {Array<ElementContent>} */ const listItems = [];
    let referenceIndex = -1;
    while(++referenceIndex < state.footnoteOrder.length){
        const definition = state.footnoteById.get(state.footnoteOrder[referenceIndex]);
        if (!definition) continue;
        const content = state.all(definition);
        const id = String(definition.identifier).toUpperCase();
        const safeId = (0, $b82d09afb4bbc7a9$export$e42a3e39590d28b5)(id.toLowerCase());
        let rereferenceIndex = 0;
        /** @type {Array<ElementContent>} */ const backReferences = [];
        const counts = state.footnoteCounts.get(id);
        // eslint-disable-next-line no-unmodified-loop-condition
        while(counts !== undefined && ++rereferenceIndex <= counts){
            if (backReferences.length > 0) backReferences.push({
                type: 'text',
                value: ' '
            });
            let children = typeof footnoteBackContent === 'string' ? footnoteBackContent : footnoteBackContent(referenceIndex, rereferenceIndex);
            if (typeof children === 'string') children = {
                type: 'text',
                value: children
            };
            backReferences.push({
                type: 'element',
                tagName: 'a',
                properties: {
                    href: '#' + clobberPrefix + 'fnref-' + safeId + (rereferenceIndex > 1 ? '-' + rereferenceIndex : ''),
                    dataFootnoteBackref: '',
                    ariaLabel: typeof footnoteBackLabel === 'string' ? footnoteBackLabel : footnoteBackLabel(referenceIndex, rereferenceIndex),
                    className: [
                        'data-footnote-backref'
                    ]
                },
                children: Array.isArray(children) ? children : [
                    children
                ]
            });
        }
        const tail = content[content.length - 1];
        if (tail && tail.type === 'element' && tail.tagName === 'p') {
            const tailTail = tail.children[tail.children.length - 1];
            if (tailTail && tailTail.type === 'text') tailTail.value += ' ';
            else tail.children.push({
                type: 'text',
                value: ' '
            });
            tail.children.push(...backReferences);
        } else content.push(...backReferences);
        /** @type {Element} */ const listItem = {
            type: 'element',
            tagName: 'li',
            properties: {
                id: clobberPrefix + 'fn-' + safeId
            },
            children: state.wrap(content, true)
        };
        state.patch(definition, listItem);
        listItems.push(listItem);
    }
    if (listItems.length === 0) return;
    return {
        type: 'element',
        tagName: 'section',
        properties: {
            dataFootnotes: true,
            className: [
                'footnotes'
            ]
        },
        children: [
            {
                type: 'element',
                tagName: footnoteLabelTagName,
                properties: {
                    ...(0, $e46c0242ff031819$export$2e2bcd8739ae039)(footnoteLabelProperties),
                    id: 'footnote-label'
                },
                children: [
                    {
                        type: 'text',
                        value: footnoteLabel
                    }
                ]
            },
            {
                type: 'text',
                value: '\n'
            },
            {
                type: 'element',
                tagName: 'ol',
                properties: {},
                children: state.wrap(listItems, true)
            },
            {
                type: 'text',
                value: '\n'
            }
        ]
    };
}


/**
 * @import {
 *   ElementContent as HastElementContent,
 *   Element as HastElement,
 *   Nodes as HastNodes,
 *   Properties as HastProperties,
 *   RootContent as HastRootContent,
 *   Text as HastText
 * } from 'hast'
 * @import {
 *   Definition as MdastDefinition,
 *   FootnoteDefinition as MdastFootnoteDefinition,
 *   Nodes as MdastNodes,
 *   Parents as MdastParents
 * } from 'mdast'
 * @import {VFile} from 'vfile'
 * @import {
 *   FootnoteBackContentTemplate,
 *   FootnoteBackLabelTemplate
 * } from './footer.js'
 */ /**
 * @callback Handler
 *   Handle a node.
 * @param {State} state
 *   Info passed around.
 * @param {any} node
 *   mdast node to handle.
 * @param {MdastParents | undefined} parent
 *   Parent of `node`.
 * @returns {Array<HastElementContent> | HastElementContent | undefined}
 *   hast node.
 *
 * @typedef {Partial<Record<MdastNodes['type'], Handler>>} Handlers
 *   Handle nodes.
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Whether to persist raw HTML in markdown in the hast tree (default:
 *   `false`).
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` property on footnotes to prevent them from
 *   *clobbering* (default: `'user-content-'`).
 *
 *   Pass `''` for trusted markdown and when you are careful with
 *   polyfilling.
 *   You could pass a different prefix.
 *
 *   DOM clobbering is this:
 *
 *   ```html
 *   <p id="x"></p>
 *   <script>alert(x) // `x` now refers to the `p#x` DOM element</script>
 *   ```
 *
 *   The above example shows that elements are made available by browsers, by
 *   their ID, on the `window` object.
 *   This is a security risk because you might be expecting some other variable
 *   at that place.
 *   It can also break polyfills.
 *   Using a prefix solves these problems.
 * @property {VFile | null | undefined} [file]
 *   Corresponding virtual file representing the input document (optional).
 * @property {FootnoteBackContentTemplate | string | null | undefined} [footnoteBackContent]
 *   Content of the backreference back to references (default: `defaultFootnoteBackContent`).
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultFootnoteBackContent(_, rereferenceIndex) {
 *     const result = [{type: 'text', value: '↩'}]
 *
 *     if (rereferenceIndex > 1) {
 *       result.push({
 *         type: 'element',
 *         tagName: 'sup',
 *         properties: {},
 *         children: [{type: 'text', value: String(rereferenceIndex)}]
 *       })
 *     }
 *
 *     return result
 *   }
 *   ```
 *
 *   This content is used in the `a` element of each backreference (the `↩`
 *   links).
 * @property {FootnoteBackLabelTemplate | string | null | undefined} [footnoteBackLabel]
 *   Label to describe the backreference back to references (default:
 *   `defaultFootnoteBackLabel`).
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultFootnoteBackLabel(referenceIndex, rereferenceIndex) {
 *    return (
 *      'Back to reference ' +
 *      (referenceIndex + 1) +
 *      (rereferenceIndex > 1 ? '-' + rereferenceIndex : '')
 *    )
 *   }
 *   ```
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is used in the `ariaLabel` property on each backreference
 *   (the `↩` links).
 *   It affects users of assistive technology.
 * @property {string | null | undefined} [footnoteLabel='Footnotes']
 *   Textual label to use for the footnotes section (default: `'Footnotes'`).
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different properties with the `footnoteLabelProperties` option.
 * @property {HastProperties | null | undefined} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label (default: `{className:
 *   ['sr-only']}`).
 *
 *   Change it to show the label and add other properties.
 *
 *   This label is typically hidden visually (assuming an `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass an empty string.
 *   You can also add different properties.
 *
 *   > **Note**: `id: 'footnote-label'` is always added, because footnote
 *   > calls use it with `aria-describedby` to provide an accessible label.
 * @property {string | null | undefined} [footnoteLabelTagName='h2']
 *   HTML tag name to use for the footnote label element (default: `'h2'`).
 *
 *   Change it to match your document structure.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different properties with the `footnoteLabelProperties` option.
 * @property {Handlers | null | undefined} [handlers]
 *   Extra handlers for nodes (optional).
 * @property {Array<MdastNodes['type']> | null | undefined} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast (note that
 *   the node itself is passed, but eventual children are transformed)
 *   (optional).
 * @property {Handler | null | undefined} [unknownHandler]
 *   Handler for all unknown nodes (optional).
 *
 * @typedef State
 *   Info passed around.
 * @property {(node: MdastNodes) => Array<HastElementContent>} all
 *   Transform the children of an mdast parent to hast.
 * @property {<Type extends HastNodes>(from: MdastNodes, to: Type) => HastElement | Type} applyData
 *   Honor the `data` of `from`, and generate an element instead of `node`.
 * @property {Map<string, MdastDefinition>} definitionById
 *   Definitions by their identifier.
 * @property {Map<string, MdastFootnoteDefinition>} footnoteById
 *   Footnote definitions by their identifier.
 * @property {Map<string, number>} footnoteCounts
 *   Counts for how often the same footnote was called.
 * @property {Array<string>} footnoteOrder
 *   Identifiers of order when footnote calls first appear in tree order.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {(node: MdastNodes, parent: MdastParents | undefined) => Array<HastElementContent> | HastElementContent | undefined} one
 *   Transform an mdast node to hast.
 * @property {Options} options
 *   Configuration.
 * @property {(from: MdastNodes, node: HastNodes) => undefined} patch
 *   Copy a node’s positional info.
 * @property {<Type extends HastRootContent>(nodes: Array<Type>, loose?: boolean | undefined) => Array<HastText | Type>} wrap
 *   Wrap `nodes` with line endings between each node, adds initial/final line endings when `loose`.
 */ 
/**
 * @import {Node as UnistNode, Parent as UnistParent} from 'unist'
 * @import {VisitorResult} from 'unist-util-visit-parents'
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ // To do: use types from `unist-util-visit-parents` when it’s released.
/**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends ReadonlyArray<any>
 *   ? MatchesOne<Value, Check[number]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends UnistNode ? number | undefined : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends UnistParent ? Ancestor | undefined : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [Ancestor=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Visited, Parent<Ancestor, Visited>>} BuildVisitorFromMatch
 *   Build a typed `Visitor` function from a node and all possible parents.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Visited
 *   Node type.
 * @template {UnistParent} Ancestor
 *   Parent type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     Matches<Descendant, Check>,
 *     Extract<Descendant, UnistParent>
 *   >
 * )} BuildVisitorFromDescendants
 *   Build a typed `Visitor` function from a list of descendants and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Node type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ /**
 * @import {Node as UnistNode, Parent as UnistParent} from 'unist'
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ /**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends ReadonlyArray<infer T>
 *   ? MatchesOne<Value, T>
 *   : Check extends Array<infer T>
 *   ? MatchesOne<Value, T>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {InternalAncestor<InclusiveDescendant<Tree>, Child>} Ancestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {'skip' | boolean} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<VisitedParents>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [VisitedParents=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Matches<InclusiveDescendant<Tree>, Check>, Ancestor<Tree, Matches<InclusiveDescendant<Tree>, Check>>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Tree type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ /**
 * @import {Node, Parent} from 'unist'
 */ /**
 * @template Fn
 * @template Fallback
 * @typedef {Fn extends (value: any) => value is infer Thing ? Thing : Fallback} Predicate
 */ /**
 * @callback Check
 *   Check that an arbitrary value is a node.
 * @param {unknown} this
 *   The given context.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 *
 * @typedef {Record<string, unknown> | Node} Props
 *   Object to check for equivalence.
 *
 *   Note: `Node` is included as it is common but is not indexable.
 *
 * @typedef {Array<Props | TestFunction | string> | ReadonlyArray<Props | TestFunction | string> | Props | TestFunction | string | null | undefined} Test
 *   Check for an arbitrary node.
 *
 * @callback TestFunction
 *   Check if a node passes a test.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | undefined | void}
 *   Whether this node passes the test.
 *
 *   Note: `void` is included until TS sees no return as `undefined`.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param {unknown} node
 *   Thing to check, typically `Node`.
 * @param {Test} test
 *   A check for a specific node.
 * @param {number | null | undefined} index
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} parent
 *   The node’s parent.
 * @param {unknown} context
 *   Context object (`this`) to pass to `test` functions.
 * @returns {boolean}
 *   Whether `node` is a node and passes a test.
 */ const $312c10cea7b70433$export$226b3eccf92c9ed9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends ReadonlyArray<string>>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition[number]}) &
   *   (<Condition extends Array<string>>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition[number]}) &
   *   (<Condition extends string>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((node?: null | undefined) => false) &
   *   ((node: unknown, test?: null | undefined, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((node: unknown, test?: Test, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function(node, test, index, parent, context) {
    const check = $312c10cea7b70433$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== 'number' || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error('Expected positive finite index');
    if (parent !== undefined && parent !== null && (!$312c10cea7b70433$export$226b3eccf92c9ed9(parent) || !parent.children)) throw new Error('Expected parent node');
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error('Expected both parent and index');
    return $312c10cea7b70433$var$looksLikeANode(node) ? check.call(context, node, index, parent) : false;
};
const $312c10cea7b70433$export$9c68d69a4c5bbcf9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {Check}
     */ function(test) {
    if (test === null || test === undefined) return $312c10cea7b70433$var$ok;
    if (typeof test === 'function') return $312c10cea7b70433$var$castFactory(test);
    if (typeof test === 'object') return Array.isArray(test) ? $312c10cea7b70433$var$anyFactory(test) : // narrows to `Array`.
    $312c10cea7b70433$var$propertiesFactory(/** @type {Props} */ test);
    if (typeof test === 'string') return $312c10cea7b70433$var$typeFactory(test);
    throw new Error('Expected function, string, or object as test');
};
/**
 * @param {Array<Props | TestFunction | string>} tests
 * @returns {Check}
 */ function $312c10cea7b70433$var$anyFactory(tests) {
    /** @type {Array<Check>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $312c10cea7b70433$export$9c68d69a4c5bbcf9(tests[index]);
    return $312c10cea7b70433$var$castFactory(any);
    /**
   * @this {unknown}
   * @type {TestFunction}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {Check}
 */ function $312c10cea7b70433$var$propertiesFactory(check) {
    const checkAsRecord = /** @type {Record<string, unknown>} */ check;
    return $312c10cea7b70433$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        const nodeAsRecord = /** @type {unknown} */ node;
        /** @type {string} */ let key;
        for(key in check){
            if (nodeAsRecord[key] !== checkAsRecord[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {Check}
 */ function $312c10cea7b70433$var$typeFactory(check) {
    return $312c10cea7b70433$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunction} testFunction
 * @returns {Check}
 */ function $312c10cea7b70433$var$castFactory(testFunction) {
    return check;
    /**
   * @this {unknown}
   * @type {Check}
   */ function check(value, index, parent) {
        return Boolean($312c10cea7b70433$var$looksLikeANode(value) && testFunction.call(this, value, typeof index === 'number' ? index : undefined, parent || undefined));
    }
}
function $312c10cea7b70433$var$ok() {
    return true;
}
/**
 * @param {unknown} value
 * @returns {value is Node}
 */ function $312c10cea7b70433$var$looksLikeANode(value) {
    return value !== null && typeof value === 'object' && 'type' in value;
}


/**
 * @param {string} d
 * @returns {string}
 */ function $1e49ba1db9d29029$export$35e9368ef982300f(d) {
    return d;
}


/** @type {Readonly<ActionTuple>} */ const $9ef2eaca0b34953c$var$empty = [];
const $9ef2eaca0b34953c$export$f4d8133c446fe484 = true;
const $9ef2eaca0b34953c$export$7f100f842f565dc9 = false;
const $9ef2eaca0b34953c$export$8773f85c2fb2c116 = 'skip';
function $9ef2eaca0b34953c$export$70008a21eb6de899(tree, test, visitor, reverse) {
    /** @type {Test} */ let check;
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
    } else // @ts-expect-error visitor given, so `test` isn’t a visitor.
    check = test;
    const is = (0, $312c10cea7b70433$export$9c68d69a4c5bbcf9)(check);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
   * @param {UnistNode} node
   * @param {number | undefined} index
   * @param {Array<UnistParent>} parents
   */ function factory(node, index, parents) {
        const value = /** @type {Record<string, unknown>} */ node && typeof node === 'object' ? node : {};
        if (typeof value.type === 'string') {
            const name = // `hast`
            typeof value.tagName === 'string' ? value.tagName : typeof value.name === 'string' ? value.name : undefined;
            Object.defineProperty(visit, 'name', {
                value: 'node (' + (0, $1e49ba1db9d29029$export$35e9368ef982300f)(node.type + (name ? '<' + name + '>' : '')) + ')'
            });
        }
        return visit;
        function visit() {
            /** @type {Readonly<ActionTuple>} */ let result = $9ef2eaca0b34953c$var$empty;
            /** @type {Readonly<ActionTuple>} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<UnistParent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || undefined)) {
                // @ts-expect-error: `visitor` is now a visitor.
                result = $9ef2eaca0b34953c$var$toResult(visitor(node, parents));
                if (result[0] === $9ef2eaca0b34953c$export$7f100f842f565dc9) return result;
            }
            if ('children' in node && node.children) {
                const nodeAsParent = /** @type {UnistParent} */ node;
                if (nodeAsParent.children && result[0] !== $9ef2eaca0b34953c$export$8773f85c2fb2c116) {
                    offset = (reverse ? nodeAsParent.children.length : -1) + step;
                    grandparents = parents.concat(nodeAsParent);
                    while(offset > -1 && offset < nodeAsParent.children.length){
                        const child = nodeAsParent.children[offset];
                        subresult = factory(child, offset, grandparents)();
                        if (subresult[0] === $9ef2eaca0b34953c$export$7f100f842f565dc9) return subresult;
                        offset = typeof subresult[1] === 'number' ? subresult[1] : offset + step;
                    }
                }
            }
            return result;
        }
    }
}
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {Readonly<ActionTuple>}
 *   Clean result.
 */ function $9ef2eaca0b34953c$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === 'number') return [
        $9ef2eaca0b34953c$export$f4d8133c446fe484,
        value
    ];
    return value === null || value === undefined ? $9ef2eaca0b34953c$var$empty : [
        value
    ];
}


function $2ca43c18c27b56fa$export$bf638b60ea8b89b7(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
    /** @type {boolean | null | undefined} */ let reverse;
    /** @type {Test} */ let test;
    /** @type {Visitor} */ let visitor;
    if (typeof testOrVisitor === 'function' && typeof visitorOrReverse !== 'function') {
        test = undefined;
        visitor = testOrVisitor;
        reverse = visitorOrReverse;
    } else {
        // @ts-expect-error: assume the overload with test was given.
        test = testOrVisitor;
        // @ts-expect-error: assume the overload with test was given.
        visitor = visitorOrReverse;
        reverse = maybeReverse;
    }
    (0, $9ef2eaca0b34953c$export$70008a21eb6de899)(tree, test, overload, reverse);
    /**
   * @param {UnistNode} node
   * @param {Array<UnistParent>} parents
   */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        const index = parent ? parent.children.indexOf(node) : undefined;
        return visitor(node, index, parent);
    }
}



/**
 * @import {Handlers} from '../state.js'
 */ /**
 * @import {Element} from 'hast'
 * @import {Blockquote} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `blockquote` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Blockquote} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $2009e735e4920922$export$67dc04e652a298ca(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'blockquote',
        properties: {},
        children: state.wrap(state.all(node), true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element, Text} from 'hast'
 * @import {Break} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `break` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Break} node
 *   mdast node.
 * @returns {Array<Element | Text>}
 *   hast element content.
 */ function $caf09a68931aae43$export$371da9dd35aba193(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'br',
        properties: {},
        children: []
    };
    state.patch(node, result);
    return [
        state.applyData(node, result),
        {
            type: 'text',
            value: '\n'
        }
    ];
}


/**
 * @import {Element, Properties} from 'hast'
 * @import {Code} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `code` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Code} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $b5c217a518855008$export$6565f9f03506010b(state, node) {
    const value = node.value ? node.value + '\n' : '';
    /** @type {Properties} */ const properties = {};
    // Someone can write `js&#x20;python&#x9;ruby`.
    const language = node.lang ? node.lang.split(/\s+/) : [];
    // GH/CM still drop the non-first languages.
    if (language.length > 0) properties.className = [
        'language-' + language[0]
    ];
    // Create `<code>`.
    /** @type {Element} */ let result = {
        type: 'element',
        tagName: 'code',
        properties: properties,
        children: [
            {
                type: 'text',
                value: value
            }
        ]
    };
    if (node.meta) result.data = {
        meta: node.meta
    };
    state.patch(node, result);
    result = state.applyData(node, result);
    // Create `<pre>`.
    result = {
        type: 'element',
        tagName: 'pre',
        properties: {},
        children: [
            result
        ]
    };
    state.patch(node, result);
    return result;
}


/**
 * @import {Element} from 'hast'
 * @import {Delete} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `delete` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Delete} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $9739c1e1cf800b5e$export$19426ff118fe8be(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'del',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {Emphasis} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `emphasis` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Emphasis} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $c0bba787c55d4212$export$bef81ba411953b51(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'em',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {FootnoteReference} from 'mdast'
 * @import {State} from '../state.js'
 */ 
function $5af8976c830555c1$export$7f87ee744075c1ba(state, node) {
    const clobberPrefix = typeof state.options.clobberPrefix === 'string' ? state.options.clobberPrefix : 'user-content-';
    const id = String(node.identifier).toUpperCase();
    const safeId = (0, $b82d09afb4bbc7a9$export$e42a3e39590d28b5)(id.toLowerCase());
    const index = state.footnoteOrder.indexOf(id);
    /** @type {number} */ let counter;
    let reuseCounter = state.footnoteCounts.get(id);
    if (reuseCounter === undefined) {
        reuseCounter = 0;
        state.footnoteOrder.push(id);
        counter = state.footnoteOrder.length;
    } else counter = index + 1;
    reuseCounter += 1;
    state.footnoteCounts.set(id, reuseCounter);
    /** @type {Element} */ const link = {
        type: 'element',
        tagName: 'a',
        properties: {
            href: '#' + clobberPrefix + 'fn-' + safeId,
            id: clobberPrefix + 'fnref-' + safeId + (reuseCounter > 1 ? '-' + reuseCounter : ''),
            dataFootnoteRef: true,
            ariaDescribedBy: [
                'footnote-label'
            ]
        },
        children: [
            {
                type: 'text',
                value: String(counter)
            }
        ]
    };
    state.patch(node, link);
    /** @type {Element} */ const sup = {
        type: 'element',
        tagName: 'sup',
        properties: {},
        children: [
            link
        ]
    };
    state.patch(node, sup);
    return state.applyData(node, sup);
}


/**
 * @import {Element} from 'hast'
 * @import {Heading} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `heading` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Heading} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $9b6df163a26bd000$export$46e4a324ac90507f(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'h' + node.depth,
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {Html} from 'mdast'
 * @import {State} from '../state.js'
 * @import {Raw} from '../../index.js'
 */ /**
 * Turn an mdast `html` node into hast (`raw` node in dangerous mode, otherwise
 * nothing).
 *
 * @param {State} state
 *   Info passed around.
 * @param {Html} node
 *   mdast node.
 * @returns {Element | Raw | undefined}
 *   hast node.
 */ function $f59721a0d8aa9c1f$export$c0bb0b647f701bb5(state, node) {
    if (state.options.allowDangerousHtml) {
        /** @type {Raw} */ const result = {
            type: 'raw',
            value: node.value
        };
        state.patch(node, result);
        return state.applyData(node, result);
    }
    return undefined;
}


/**
 * @import {ElementContent, Element, Properties} from 'hast'
 * @import {ImageReference} from 'mdast'
 * @import {State} from '../state.js'
 */ 
/**
 * @import {ElementContent} from 'hast'
 * @import {Reference, Nodes} from 'mdast'
 * @import {State} from './state.js'
 */ /**
 * Return the content of a reference without definition as plain text.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Extract<Nodes, Reference>} node
 *   Reference node (image, link).
 * @returns {Array<ElementContent>}
 *   hast content.
 */ function $adeec68f555ea12e$export$3fdd26f3d9e7dc78(state, node) {
    const subtype = node.referenceType;
    let suffix = ']';
    if (subtype === 'collapsed') suffix += '[]';
    else if (subtype === 'full') suffix += '[' + (node.label || node.identifier) + ']';
    if (node.type === 'imageReference') return [
        {
            type: 'text',
            value: '![' + node.alt + suffix
        }
    ];
    const contents = state.all(node);
    const head = contents[0];
    if (head && head.type === 'text') head.value = '[' + head.value;
    else contents.unshift({
        type: 'text',
        value: '['
    });
    const tail = contents[contents.length - 1];
    if (tail && tail.type === 'text') tail.value += suffix;
    else contents.push({
        type: 'text',
        value: suffix
    });
    return contents;
}


function $b377321b20712ea8$export$f281796f6bc3b8db(state, node) {
    const id = String(node.identifier).toUpperCase();
    const definition = state.definitionById.get(id);
    if (!definition) return (0, $adeec68f555ea12e$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        src: (0, $b82d09afb4bbc7a9$export$e42a3e39590d28b5)(definition.url || ''),
        alt: node.alt
    };
    if (definition.title !== null && definition.title !== undefined) properties.title = definition.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'img',
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element, Properties} from 'hast'
 * @import {Image} from 'mdast'
 * @import {State} from '../state.js'
 */ 
function $2bb84a02d2957974$export$5c452ff88e35e47d(state, node) {
    /** @type {Properties} */ const properties = {
        src: (0, $b82d09afb4bbc7a9$export$e42a3e39590d28b5)(node.url)
    };
    if (node.alt !== null && node.alt !== undefined) properties.alt = node.alt;
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'img',
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element, Text} from 'hast'
 * @import {InlineCode} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `inlineCode` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {InlineCode} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $772ddadd8e054087$export$91b9bee19a0d8569(state, node) {
    /** @type {Text} */ const text = {
        type: 'text',
        value: node.value.replace(/\r?\n|\r/g, ' ')
    };
    state.patch(node, text);
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'code',
        properties: {},
        children: [
            text
        ]
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {ElementContent, Element, Properties} from 'hast'
 * @import {LinkReference} from 'mdast'
 * @import {State} from '../state.js'
 */ 

function $63d9a7473ae80c48$export$e6c469b1b7b2bc6a(state, node) {
    const id = String(node.identifier).toUpperCase();
    const definition = state.definitionById.get(id);
    if (!definition) return (0, $adeec68f555ea12e$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        href: (0, $b82d09afb4bbc7a9$export$e42a3e39590d28b5)(definition.url || '')
    };
    if (definition.title !== null && definition.title !== undefined) properties.title = definition.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'a',
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element, Properties} from 'hast'
 * @import {Link} from 'mdast'
 * @import {State} from '../state.js'
 */ 
function $a668870950e44a11$export$9c30223ca0a664fb(state, node) {
    /** @type {Properties} */ const properties = {
        href: (0, $b82d09afb4bbc7a9$export$e42a3e39590d28b5)(node.url)
    };
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'a',
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {ElementContent, Element, Properties} from 'hast'
 * @import {ListItem, Parents} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `listItem` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ListItem} node
 *   mdast node.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $eb748566f942a1fa$export$76c7e83ecc9cdf05(state, node, parent) {
    const results = state.all(node);
    const loose = parent ? $eb748566f942a1fa$var$listLoose(parent) : $eb748566f942a1fa$var$listItemLoose(node);
    /** @type {Properties} */ const properties = {};
    /** @type {Array<ElementContent>} */ const children = [];
    if (typeof node.checked === 'boolean') {
        const head = results[0];
        /** @type {Element} */ let paragraph;
        if (head && head.type === 'element' && head.tagName === 'p') paragraph = head;
        else {
            paragraph = {
                type: 'element',
                tagName: 'p',
                properties: {},
                children: []
            };
            results.unshift(paragraph);
        }
        if (paragraph.children.length > 0) paragraph.children.unshift({
            type: 'text',
            value: ' '
        });
        paragraph.children.unshift({
            type: 'element',
            tagName: 'input',
            properties: {
                type: 'checkbox',
                checked: node.checked,
                disabled: true
            },
            children: []
        });
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        properties.className = [
            'task-list-item'
        ];
    }
    let index = -1;
    while(++index < results.length){
        const child = results[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.type !== 'element' || child.tagName !== 'p') children.push({
            type: 'text',
            value: '\n'
        });
        if (child.type === 'element' && child.tagName === 'p' && !loose) children.push(...child.children);
        else children.push(child);
    }
    const tail = results[results.length - 1];
    // Add a final eol.
    if (tail && (loose || tail.type !== 'element' || tail.tagName !== 'p')) children.push({
        type: 'text',
        value: '\n'
    });
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'li',
        properties: properties,
        children: children
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
/**
 * @param {Parents} node
 * @return {Boolean}
 */ function $eb748566f942a1fa$var$listLoose(node) {
    let loose = false;
    if (node.type === 'list') {
        loose = node.spread || false;
        const children = node.children;
        let index = -1;
        while(!loose && ++index < children.length)loose = $eb748566f942a1fa$var$listItemLoose(children[index]);
    }
    return loose;
}
/**
 * @param {ListItem} node
 * @return {Boolean}
 */ function $eb748566f942a1fa$var$listItemLoose(node) {
    const spread = node.spread;
    return spread === null || spread === undefined ? node.children.length > 1 : spread;
}


/**
 * @import {Element, Properties} from 'hast'
 * @import {List} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `list` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {List} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $7581156d9e04fe28$export$8837f4fc672e936d(state, node) {
    /** @type {Properties} */ const properties = {};
    const results = state.all(node);
    let index = -1;
    if (typeof node.start === 'number' && node.start !== 1) properties.start = node.start;
    // Like GitHub, add a class for custom styling.
    while(++index < results.length){
        const child = results[index];
        if (child.type === 'element' && child.tagName === 'li' && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes('task-list-item')) {
            properties.className = [
                'contains-task-list'
            ];
            break;
        }
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: node.ordered ? 'ol' : 'ul',
        properties: properties,
        children: state.wrap(results, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {Paragraph} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `paragraph` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Paragraph} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $20fbb56018958335$export$9c206ddddb32a9b(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'p',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Parents as HastParents, Root as HastRoot} from 'hast'
 * @import {Root as MdastRoot} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `root` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastRoot} node
 *   mdast node.
 * @returns {HastParents}
 *   hast node.
 */ function $2af4be4c3af73f2b$export$e8e78c978b129247(state, node) {
    /** @type {HastRoot} */ const result = {
        type: 'root',
        children: state.wrap(state.all(node))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {Strong} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `strong` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Strong} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $8df89fc7fe3cfe9c$export$59ae2c325a998f89(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'strong',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Table} from 'mdast'
 * @import {Element} from 'hast'
 * @import {State} from '../state.js'
 */ 
function $9257848335846de3$export$9852986a3ec5f6a0(state, node) {
    const rows = state.all(node);
    const firstRow = rows.shift();
    /** @type {Array<Element>} */ const tableContent = [];
    if (firstRow) {
        /** @type {Element} */ const head = {
            type: 'element',
            tagName: 'thead',
            properties: {},
            children: state.wrap([
                firstRow
            ], true)
        };
        state.patch(node.children[0], head);
        tableContent.push(head);
    }
    if (rows.length > 0) {
        /** @type {Element} */ const body = {
            type: 'element',
            tagName: 'tbody',
            properties: {},
            children: state.wrap(rows, true)
        };
        const start = (0, $9861e7b4f8df2806$export$771bf3e4949bfbee)(node.children[1]);
        const end = (0, $9861e7b4f8df2806$export$da309cdce9dc2a25)(node.children[node.children.length - 1]);
        if (start && end) body.position = {
            start: start,
            end: end
        };
        tableContent.push(body);
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'table',
        properties: {},
        children: state.wrap(tableContent, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element, ElementContent, Properties} from 'hast'
 * @import {Parents, TableRow} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `tableRow` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableRow} node
 *   mdast node.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $06793005ec3da281$export$ce666bf02318c957(state, node, parent) {
    const siblings = parent ? parent.children : undefined;
    // Generate a body row when without parent.
    const rowIndex = siblings ? siblings.indexOf(node) : 1;
    const tagName = rowIndex === 0 ? 'th' : 'td';
    // To do: option to use `style`?
    const align = parent && parent.type === 'table' ? parent.align : undefined;
    const length = align ? align.length : node.children.length;
    let cellIndex = -1;
    /** @type {Array<ElementContent>} */ const cells = [];
    while(++cellIndex < length){
        // Note: can also be undefined.
        const cell = node.children[cellIndex];
        /** @type {Properties} */ const properties = {};
        const alignValue = align ? align[cellIndex] : undefined;
        if (alignValue) properties.align = alignValue;
        /** @type {Element} */ let result = {
            type: 'element',
            tagName: tagName,
            properties: properties,
            children: []
        };
        if (cell) {
            result.children = state.all(cell);
            state.patch(cell, result);
            result = state.applyData(cell, result);
        }
        cells.push(result);
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'tr',
        properties: {},
        children: state.wrap(cells, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {TableCell} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `tableCell` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableCell} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $6181448ff3679c4d$export$e1e720e5f4603e6a(state, node) {
    // Note: this function is normally not called: see `table-row` for how rows
    // and their cells are compiled.
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'td',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element as HastElement, Text as HastText} from 'hast'
 * @import {Text as MdastText} from 'mdast'
 * @import {State} from '../state.js'
 */ const $012eac5e07020bbc$var$tab = 9 /* `\t` */ ;
const $012eac5e07020bbc$var$space = 32 /* ` ` */ ;
function $012eac5e07020bbc$export$a771f20bdd13def9(value) {
    const source = String(value);
    const search = /\r?\n|\r/g;
    let match = search.exec(source);
    let last = 0;
    /** @type {Array<string>} */ const lines = [];
    while(match){
        lines.push($012eac5e07020bbc$var$trimLine(source.slice(last, match.index), last > 0, true), match[0]);
        last = match.index + match[0].length;
        match = search.exec(source);
    }
    lines.push($012eac5e07020bbc$var$trimLine(source.slice(last), last > 0, false));
    return lines.join('');
}
/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */ function $012eac5e07020bbc$var$trimLine(value, start, end) {
    let startIndex = 0;
    let endIndex = value.length;
    if (start) {
        let code = value.codePointAt(startIndex);
        while(code === $012eac5e07020bbc$var$tab || code === $012eac5e07020bbc$var$space){
            startIndex++;
            code = value.codePointAt(startIndex);
        }
    }
    if (end) {
        let code = value.codePointAt(endIndex - 1);
        while(code === $012eac5e07020bbc$var$tab || code === $012eac5e07020bbc$var$space){
            endIndex--;
            code = value.codePointAt(endIndex - 1);
        }
    }
    return endIndex > startIndex ? value.slice(startIndex, endIndex) : '';
}


function $32a26ed6da9265ed$export$6f093cfa640b7166(state, node) {
    /** @type {HastText} */ const result = {
        type: 'text',
        value: (0, $012eac5e07020bbc$export$a771f20bdd13def9)(String(node.value))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {ThematicBreak} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `thematicBreak` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ThematicBreak} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $eb5ff7d2182720ae$export$ba7b13e047416c03(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'hr',
        properties: {},
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


const $e276fa0624fad11d$export$455ce229eb3d2472 = {
    blockquote: $2009e735e4920922$export$67dc04e652a298ca,
    break: (0, $caf09a68931aae43$export$371da9dd35aba193),
    code: $b5c217a518855008$export$6565f9f03506010b,
    delete: (0, $9739c1e1cf800b5e$export$19426ff118fe8be),
    emphasis: $c0bba787c55d4212$export$bef81ba411953b51,
    footnoteReference: $5af8976c830555c1$export$7f87ee744075c1ba,
    heading: $9b6df163a26bd000$export$46e4a324ac90507f,
    html: $f59721a0d8aa9c1f$export$c0bb0b647f701bb5,
    imageReference: $b377321b20712ea8$export$f281796f6bc3b8db,
    image: $2bb84a02d2957974$export$5c452ff88e35e47d,
    inlineCode: $772ddadd8e054087$export$91b9bee19a0d8569,
    linkReference: $63d9a7473ae80c48$export$e6c469b1b7b2bc6a,
    link: $a668870950e44a11$export$9c30223ca0a664fb,
    listItem: $eb748566f942a1fa$export$76c7e83ecc9cdf05,
    list: $7581156d9e04fe28$export$8837f4fc672e936d,
    paragraph: $20fbb56018958335$export$9c206ddddb32a9b,
    root: // @ts-expect-error: root is different, but hard to type.
    $2af4be4c3af73f2b$export$e8e78c978b129247,
    strong: $8df89fc7fe3cfe9c$export$59ae2c325a998f89,
    table: $9257848335846de3$export$9852986a3ec5f6a0,
    tableCell: $6181448ff3679c4d$export$e1e720e5f4603e6a,
    tableRow: $06793005ec3da281$export$ce666bf02318c957,
    text: $32a26ed6da9265ed$export$6f093cfa640b7166,
    thematicBreak: $eb5ff7d2182720ae$export$ba7b13e047416c03,
    toml: $e276fa0624fad11d$var$ignore,
    yaml: $e276fa0624fad11d$var$ignore,
    definition: $e276fa0624fad11d$var$ignore,
    footnoteDefinition: $e276fa0624fad11d$var$ignore
};
// Return nothing for nodes that are ignored.
function $e276fa0624fad11d$var$ignore() {
    return undefined;
}


const $e7336a21b70de7b0$var$own = {}.hasOwnProperty;
/** @type {Options} */ const $e7336a21b70de7b0$var$emptyOptions = {};
function $e7336a21b70de7b0$export$e6a0daad8304de(tree, options) {
    const settings = options || $e7336a21b70de7b0$var$emptyOptions;
    /** @type {Map<string, MdastDefinition>} */ const definitionById = new Map();
    /** @type {Map<string, MdastFootnoteDefinition>} */ const footnoteById = new Map();
    /** @type {Map<string, number>} */ const footnoteCounts = new Map();
    /** @type {Handlers} */ // @ts-expect-error: the root handler returns a root.
    // Hard to type.
    const handlers = {
        ...(0, $e276fa0624fad11d$export$455ce229eb3d2472),
        ...settings.handlers
    };
    /** @type {State} */ const state = {
        all: all,
        applyData: $e7336a21b70de7b0$var$applyData,
        definitionById: definitionById,
        footnoteById: footnoteById,
        footnoteCounts: footnoteCounts,
        footnoteOrder: [],
        handlers: handlers,
        one: one,
        options: settings,
        patch: $e7336a21b70de7b0$var$patch,
        wrap: $e7336a21b70de7b0$export$4997ffc0176396a6
    };
    (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(tree, function(node) {
        if (node.type === 'definition' || node.type === 'footnoteDefinition') {
            const map = node.type === 'definition' ? definitionById : footnoteById;
            const id = String(node.identifier).toUpperCase();
            // Mimick CM behavior of link definitions.
            // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/9032189/lib/index.js#L20-L21>.
            if (!map.has(id)) // @ts-expect-error: node type matches map.
            map.set(id, node);
        }
    });
    return state;
    /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | undefined} [parent]
   *   Parent of `node`.
   * @returns {Array<HastElementContent> | HastElementContent | undefined}
   *   Resulting hast node.
   */ function one(node, parent) {
        const type = node.type;
        const handle = state.handlers[type];
        if ($e7336a21b70de7b0$var$own.call(state.handlers, type) && handle) return handle(state, node, parent);
        if (state.options.passThrough && state.options.passThrough.includes(type)) {
            if ('children' in node) {
                const { children: children, ...shallow } = node;
                const result = (0, $e46c0242ff031819$export$2e2bcd8739ae039)(shallow);
                // @ts-expect-error: TS doesn’t understand…
                result.children = state.all(node);
                // @ts-expect-error: TS doesn’t understand…
                return result;
            }
            // @ts-expect-error: it’s custom.
            return (0, $e46c0242ff031819$export$2e2bcd8739ae039)(node);
        }
        const unknown = state.options.unknownHandler || $e7336a21b70de7b0$var$defaultUnknownHandler;
        return unknown(state, node, parent);
    }
    /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */ function all(parent) {
        /** @type {Array<HastElementContent>} */ const values = [];
        if ('children' in parent) {
            const nodes = parent.children;
            let index = -1;
            while(++index < nodes.length){
                const result = state.one(nodes[index], parent);
                // To do: see if we van clean this? Can we merge texts?
                if (result) {
                    if (index && nodes[index - 1].type === 'break') {
                        if (!Array.isArray(result) && result.type === 'text') result.value = $e7336a21b70de7b0$var$trimMarkdownSpaceStart(result.value);
                        if (!Array.isArray(result) && result.type === 'element') {
                            const head = result.children[0];
                            if (head && head.type === 'text') head.value = $e7336a21b70de7b0$var$trimMarkdownSpaceStart(head.value);
                        }
                    }
                    if (Array.isArray(result)) values.push(...result);
                    else values.push(result);
                }
            }
        }
        return values;
    }
}
/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {undefined}
 *   Nothing.
 */ function $e7336a21b70de7b0$var$patch(from, to) {
    if (from.position) to.position = (0, $9861e7b4f8df2806$export$5880b8b5730aff45)(from);
}
/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {HastElement | Type}
 *   Nothing.
 */ function $e7336a21b70de7b0$var$applyData(from, to) {
    /** @type {HastElement | Type} */ let result = to;
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (from && from.data) {
        const hName = from.data.hName;
        const hChildren = from.data.hChildren;
        const hProperties = from.data.hProperties;
        if (typeof hName === 'string') {
            // Transforming the node resulted in an element with a different name
            // than wanted:
            if (result.type === 'element') result.tagName = hName;
            else {
                /** @type {Array<HastElementContent>} */ // @ts-expect-error: assume no doctypes in `root`.
                const children = 'children' in result ? result.children : [
                    result
                ];
                result = {
                    type: 'element',
                    tagName: hName,
                    properties: {},
                    children: children
                };
            }
        }
        if (result.type === 'element' && hProperties) Object.assign(result.properties, (0, $e46c0242ff031819$export$2e2bcd8739ae039)(hProperties));
        if ('children' in result && result.children && hChildren !== null && hChildren !== undefined) result.children = hChildren;
    }
    return result;
}
/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastElement | HastText}
 *   Resulting hast node.
 */ function $e7336a21b70de7b0$var$defaultUnknownHandler(state, node) {
    const data = node.data || {};
    /** @type {HastElement | HastText} */ const result = 'value' in node && !($e7336a21b70de7b0$var$own.call(data, 'hProperties') || $e7336a21b70de7b0$var$own.call(data, 'hChildren')) ? {
        type: 'text',
        value: node.value
    } : {
        type: 'element',
        tagName: 'div',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
function $e7336a21b70de7b0$export$4997ffc0176396a6(nodes, loose) {
    /** @type {Array<HastText | Type>} */ const result = [];
    let index = -1;
    if (loose) result.push({
        type: 'text',
        value: '\n'
    });
    while(++index < nodes.length){
        if (index) result.push({
            type: 'text',
            value: '\n'
        });
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push({
        type: 'text',
        value: '\n'
    });
    return result;
}
/**
 * Trim spaces and tabs at the start of `value`.
 *
 * @param {string} value
 *   Value to trim.
 * @returns {string}
 *   Result.
 */ function $e7336a21b70de7b0$var$trimMarkdownSpaceStart(value) {
    let index = 0;
    let code = value.charCodeAt(index);
    while(code === 9 || code === 32){
        index++;
        code = value.charCodeAt(index);
    }
    return value.slice(index);
}


function $43774b39a057500d$export$c0e4c5cf07538633(tree, options) {
    const state = (0, $e7336a21b70de7b0$export$e6a0daad8304de)(tree, options);
    const node = state.one(tree, undefined);
    const foot = (0, $5f8ac0136b7180f6$export$adb608be33961c98)(state);
    /** @type {HastNodes} */ const result = Array.isArray(node) ? {
        type: 'root',
        children: node
    } : node || {
        type: 'root',
        children: []
    };
    if (foot) {
        // If there’s a footer, there were definitions, meaning block
        // content.
        // So `result` is a parent node.
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)('children' in result);
        result.children.push({
            type: 'text',
            value: '\n'
        }, foot);
    }
    return result;
}


function $74ce0141155f6a3a$export$2e2bcd8739ae039(destination, options) {
    if (destination && 'run' in destination) /**
     * @type {TransformBridge}
     */ return async function(tree, file) {
        // Cast because root in -> root out.
        const hastTree = /** @type {HastRoot} */ (0, $43774b39a057500d$export$c0e4c5cf07538633)(tree, {
            file: file,
            ...options
        });
        await destination.run(hastTree, file);
    };
    /**
   * @type {TransformMutate}
   */ return function(tree, file) {
        // Cast because root in -> root out.
        // To do: in the future, disallow ` || options` fallback.
        // With `unified-engine`, `destination` can be `undefined` but
        // `options` will be the file set.
        // We should not pass that as `options`.
        return /** @type {HastRoot} */ (0, $43774b39a057500d$export$c0e4c5cf07538633)(tree, {
            file: file,
            ...destination || options
        });
    };
}


/**
 * @typedef {import('trough').Pipeline} Pipeline
 *
 * @typedef {import('unist').Node} Node
 *
 * @typedef {import('vfile').Compatible} Compatible
 * @typedef {import('vfile').Value} Value
 *
 * @typedef {import('../index.js').CompileResultMap} CompileResultMap
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Settings} Settings
 */ /**
 * @typedef {CompileResultMap[keyof CompileResultMap]} CompileResults
 *   Acceptable results from compilers.
 *
 *   To register custom results, add them to
 *   {@linkcode CompileResultMap}.
 */ /**
 * @template {Node} [Tree=Node]
 *   The node that the compiler receives (default: `Node`).
 * @template {CompileResults} [Result=CompileResults]
 *   The thing that the compiler yields (default: `CompileResults`).
 * @callback Compiler
 *   A **compiler** handles the compiling of a syntax tree to something else
 *   (in most cases, text) (TypeScript type).
 *
 *   It is used in the stringify phase and called with a {@linkcode Node}
 *   and {@linkcode VFile} representation of the document to compile.
 *   It should return the textual representation of the given tree (typically
 *   `string`).
 *
 *   > **Note**: unified typically compiles by serializing: most compilers
 *   > return `string` (or `Uint8Array`).
 *   > Some compilers, such as the one configured with
 *   > [`rehype-react`][rehype-react], return other values (in this case, a
 *   > React tree).
 *   > If you’re using a compiler that doesn’t serialize, expect different
 *   > result values.
 *   >
 *   > To register custom results in TypeScript, add them to
 *   > {@linkcode CompileResultMap}.
 *
 *   [rehype-react]: https://github.com/rehypejs/rehype-react
 * @param {Tree} tree
 *   Tree to compile.
 * @param {VFile} file
 *   File associated with `tree`.
 * @returns {Result}
 *   New content: compiled text (`string` or `Uint8Array`, for `file.value`) or
 *   something else (for `file.result`).
 */ /**
 * @template {Node} [Tree=Node]
 *   The node that the parser yields (default: `Node`)
 * @callback Parser
 *   A **parser** handles the parsing of text to a syntax tree.
 *
 *   It is used in the parse phase and is called with a `string` and
 *   {@linkcode VFile} of the document to parse.
 *   It must return the syntax tree representation of the given file
 *   ({@linkcode Node}).
 * @param {string} document
 *   Document to parse.
 * @param {VFile} file
 *   File associated with `document`.
 * @returns {Tree}
 *   Node representing the given file.
 */ /**
 * @typedef {(
 *   Plugin<Array<any>, any, any> |
 *   PluginTuple<Array<any>, any, any> |
 *   Preset
 * )} Pluggable
 *   Union of the different ways to add plugins and settings.
 */ /**
 * @typedef {Array<Pluggable>} PluggableList
 *   List of plugins and presets.
 */ // Note: we can’t use `callback` yet as it messes up `this`:
//  <https://github.com/microsoft/TypeScript/issues/55197>.
/**
 * @template {Array<unknown>} [PluginParameters=[]]
 *   Arguments passed to the plugin (default: `[]`, the empty tuple).
 * @template {Node | string | undefined} [Input=Node]
 *   Value that is expected as input (default: `Node`).
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node it expects.
 *   *   If the plugin sets a {@linkcode Parser}, this should be
 *       `string`.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be the
 *       node it expects.
 * @template [Output=Input]
 *   Value that is yielded as output (default: `Input`).
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node that that yields.
 *   *   If the plugin sets a {@linkcode Parser}, this should be the
 *       node that it yields.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be
 *       result it yields.
 * @typedef {(
 *   (this: Processor, ...parameters: PluginParameters) =>
 *     Input extends string ? // Parser.
 *        Output extends Node | undefined ? undefined | void : never :
 *     Output extends CompileResults ? // Compiler.
 *        Input extends Node | undefined ? undefined | void : never :
 *     Transformer<
 *       Input extends Node ? Input : Node,
 *       Output extends Node ? Output : Node
 *     > | undefined | void
 * )} Plugin
 *   Single plugin.
 *
 *   Plugins configure the processors they are applied on in the following
 *   ways:
 *
 *   *   they change the processor, such as the parser, the compiler, or by
 *       configuring data
 *   *   they specify how to handle trees and files
 *
 *   In practice, they are functions that can receive options and configure the
 *   processor (`this`).
 *
 *   > **Note**: plugins are called when the processor is *frozen*, not when
 *   > they are applied.
 */ /**
 * Tuple of a plugin and its configuration.
 *
 * The first item is a plugin, the rest are its parameters.
 *
 * @template {Array<unknown>} [TupleParameters=[]]
 *   Arguments passed to the plugin (default: `[]`, the empty tuple).
 * @template {Node | string | undefined} [Input=undefined]
 *   Value that is expected as input (optional).
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node it expects.
 *   *   If the plugin sets a {@linkcode Parser}, this should be
 *       `string`.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be the
 *       node it expects.
 * @template [Output=undefined] (optional).
 *   Value that is yielded as output.
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node that that yields.
 *   *   If the plugin sets a {@linkcode Parser}, this should be the
 *       node that it yields.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be
 *       result it yields.
 * @typedef {(
 *   [
 *     plugin: Plugin<TupleParameters, Input, Output>,
 *     ...parameters: TupleParameters
 *   ]
 * )} PluginTuple
 */ /**
 * @typedef Preset
 *   Sharable configuration.
 *
 *   They can contain plugins and settings.
 * @property {PluggableList | undefined} [plugins]
 *   List of plugins and presets (optional).
 * @property {Settings | undefined} [settings]
 *   Shared settings for parsers and compilers (optional).
 */ /**
 * @template {VFile} [File=VFile]
 *   The file that the callback receives (default: `VFile`).
 * @callback ProcessCallback
 *   Callback called when the process is done.
 *
 *   Called with either an error or a result.
 * @param {Error | undefined} [error]
 *   Fatal error (optional).
 * @param {File | undefined} [file]
 *   Processed file (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Tree=Node]
 *   The tree that the callback receives (default: `Node`).
 * @callback RunCallback
 *   Callback called when transformers are done.
 *
 *   Called with either an error or results.
 * @param {Error | undefined} [error]
 *   Fatal error (optional).
 * @param {Tree | undefined} [tree]
 *   Transformed tree (optional).
 * @param {VFile | undefined} [file]
 *   File (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Output=Node]
 *   Node type that the transformer yields (default: `Node`).
 * @callback TransformCallback
 *   Callback passed to transforms.
 *
 *   If the signature of a `transformer` accepts a third argument, the
 *   transformer may perform asynchronous operations, and must call it.
 * @param {Error | undefined} [error]
 *   Fatal error to stop the process (optional).
 * @param {Output | undefined} [tree]
 *   New, changed, tree (optional).
 * @param {VFile | undefined} [file]
 *   New, changed, file (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Input=Node]
 *   Node type that the transformer expects (default: `Node`).
 * @template {Node} [Output=Input]
 *   Node type that the transformer yields (default: `Input`).
 * @callback Transformer
 *   Transformers handle syntax trees and files.
 *
 *   They are functions that are called each time a syntax tree and file are
 *   passed through the run phase.
 *   When an error occurs in them (either because it’s thrown, returned,
 *   rejected, or passed to `next`), the process stops.
 *
 *   The run phase is handled by [`trough`][trough], see its documentation for
 *   the exact semantics of these functions.
 *
 *   > **Note**: you should likely ignore `next`: don’t accept it.
 *   > it supports callback-style async work.
 *   > But promises are likely easier to reason about.
 *
 *   [trough]: https://github.com/wooorm/trough#function-fninput-next
 * @param {Input} tree
 *   Tree to handle.
 * @param {VFile} file
 *   File to handle.
 * @param {TransformCallback<Output>} next
 *   Callback.
 * @returns {(
 *   Promise<Output | undefined | void> |
 *   Promise<never> | // For some reason this is needed separately.
 *   Output |
 *   Error |
 *   undefined |
 *   void
 * )}
 *   If you accept `next`, nothing.
 *   Otherwise:
 *
 *   *   `Error` — fatal error to stop the process
 *   *   `Promise<undefined>` or `undefined` — the next transformer keeps using
 *       same tree
 *   *   `Promise<Node>` or `Node` — new, changed, tree
 */ /**
 * @template {Node | undefined} ParseTree
 *   Output of `parse`.
 * @template {Node | undefined} HeadTree
 *   Input for `run`.
 * @template {Node | undefined} TailTree
 *   Output for `run`.
 * @template {Node | undefined} CompileTree
 *   Input of `stringify`.
 * @template {CompileResults | undefined} CompileResult
 *   Output of `stringify`.
 * @template {Node | string | undefined} Input
 *   Input of plugin.
 * @template Output
 *   Output of plugin (optional).
 * @typedef {(
 *   Input extends string
 *     ? Output extends Node | undefined
 *       ? // Parser.
 *         Processor<
 *           Output extends undefined ? ParseTree : Output,
 *           HeadTree,
 *           TailTree,
 *           CompileTree,
 *           CompileResult
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : Output extends CompileResults
 *     ? Input extends Node | undefined
 *       ? // Compiler.
 *         Processor<
 *           ParseTree,
 *           HeadTree,
 *           TailTree,
 *           Input extends undefined ? CompileTree : Input,
 *           Output extends undefined ? CompileResult : Output
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : Input extends Node | undefined
 *     ? Output extends Node | undefined
 *       ? // Transform.
 *         Processor<
 *           ParseTree,
 *           HeadTree extends undefined ? Input : HeadTree,
 *           Output extends undefined ? TailTree : Output,
 *           CompileTree,
 *           CompileResult
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : // Unknown.
 *       Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 * )} UsePlugin
 *   Create a processor based on the input/output of a {@link Plugin plugin}.
 */ /**
 * @template {CompileResults | undefined} Result
 *   Node type that the transformer yields.
 * @typedef {(
 *   Result extends Value | undefined ?
 *     VFile :
 *     VFile & {result: Result}
 *   )} VFileWithOutput
 *   Type to generate a {@linkcode VFile} corresponding to a compiler result.
 *
 *   If a result that is not acceptable on a `VFile` is used, that will
 *   be stored on the `result` field of {@linkcode VFile}.
 */ /**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */ function $2fd75206f7b34a41$export$dd911e13ecb11e05(error) {
    if (error) throw error;
}


var $ce3b58bef1324512$exports = {};
'use strict';
var $ce3b58bef1324512$var$hasOwn = Object.prototype.hasOwnProperty;
var $ce3b58bef1324512$var$toStr = Object.prototype.toString;
var $ce3b58bef1324512$var$defineProperty = Object.defineProperty;
var $ce3b58bef1324512$var$gOPD = Object.getOwnPropertyDescriptor;
var $ce3b58bef1324512$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === 'function') return Array.isArray(arr);
    return $ce3b58bef1324512$var$toStr.call(arr) === '[object Array]';
};
var $ce3b58bef1324512$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $ce3b58bef1324512$var$toStr.call(obj) !== '[object Object]') return false;
    var hasOwnConstructor = $ce3b58bef1324512$var$hasOwn.call(obj, 'constructor');
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $ce3b58bef1324512$var$hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === 'undefined' || $ce3b58bef1324512$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $ce3b58bef1324512$var$setProperty = function setProperty(target, options) {
    if ($ce3b58bef1324512$var$defineProperty && options.name === '__proto__') $ce3b58bef1324512$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $ce3b58bef1324512$var$getProperty = function getProperty(obj, name) {
    if (name === '__proto__') {
        if (!$ce3b58bef1324512$var$hasOwn.call(obj, name)) return void 0;
        else if ($ce3b58bef1324512$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $ce3b58bef1324512$var$gOPD(obj, name).value;
    }
    return obj[name];
};
$ce3b58bef1324512$exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === 'boolean') {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== 'object' && typeof target !== 'function') target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $ce3b58bef1324512$var$getProperty(target, name);
            copy = $ce3b58bef1324512$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($ce3b58bef1324512$var$isPlainObject(copy) || (copyIsArray = $ce3b58bef1324512$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $ce3b58bef1324512$var$isArray(src) ? src : [];
                    } else clone = src && $ce3b58bef1324512$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $ce3b58bef1324512$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== 'undefined') $ce3b58bef1324512$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};



function $89bf888846328aa6$export$2e2bcd8739ae039(value) {
    if (typeof value !== 'object' || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}


// To do: remove `void`s
// To do: remove `null` from output of our APIs, allow it as user APIs.
/**
 * @typedef {(error?: Error | null | undefined, ...output: Array<any>) => void} Callback
 *   Callback.
 *
 * @typedef {(...input: Array<any>) => any} Middleware
 *   Ware.
 *
 * @typedef Pipeline
 *   Pipeline.
 * @property {Run} run
 *   Run the pipeline.
 * @property {Use} use
 *   Add middleware.
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 *
 *   Calls `done` on completion with either an error or the output of the
 *   last middleware.
 *
 *   > 👉 **Note**: as the length of input defines whether async functions get a
 *   > `next` function,
 *   > it’s recommended to keep `input` at one value normally.

 *
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add middleware.
 */ /**
 * Create new middleware.
 *
 * @returns {Pipeline}
 *   Pipeline.
 */ function $f4c69d6c22bcde86$export$91b56f5ca106aa43() {
    /** @type {Array<Middleware>} */ const fns = [];
    /** @type {Pipeline} */ const pipeline = {
        run: run,
        use: use
    };
    return pipeline;
    /** @type {Run} */ function run(...values) {
        let middlewareIndex = -1;
        /** @type {Callback} */ const callback = values.pop();
        if (typeof callback !== 'function') throw new TypeError('Expected function as last argument, not ' + callback);
        next(null, ...values);
        /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error | null | undefined} error
     * @param {Array<any>} output
     */ function next(error, ...output) {
            const fn = fns[++middlewareIndex];
            let index = -1;
            if (error) {
                callback(error);
                return;
            }
            // Copy non-nullish input into values.
            while(++index < values.length)if (output[index] === null || output[index] === undefined) output[index] = values[index];
            // Save the newly created `output` for the next call.
            values = output;
            // Next or done.
            if (fn) $f4c69d6c22bcde86$export$4997ffc0176396a6(fn, next)(...output);
            else callback(null, ...output);
        }
    }
    /** @type {Use} */ function use(middelware) {
        if (typeof middelware !== 'function') throw new TypeError('Expected `middelware` to be a function, not ' + middelware);
        fns.push(middelware);
        return pipeline;
    }
}
function $f4c69d6c22bcde86$export$4997ffc0176396a6(middleware, callback) {
    /** @type {boolean} */ let called;
    return wrapped;
    /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */ function wrapped(...parameters) {
        const fnExpectsCallback = middleware.length > parameters.length;
        /** @type {any} */ let result;
        if (fnExpectsCallback) parameters.push(done);
        try {
            result = middleware.apply(this, parameters);
        } catch (error) {
            const exception = /** @type {Error} */ error;
            // Well, this is quite the pickle.
            // `middleware` received a callback and called it synchronously, but that
            // threw an error.
            // The only thing left to do is to throw the thing instead.
            if (fnExpectsCallback && called) throw exception;
            return done(exception);
        }
        if (!fnExpectsCallback) {
            if (result && result.then && typeof result.then === 'function') result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    /**
   * Call `callback`, only once.
   *
   * @type {Callback}
   */ function done(error, ...output) {
        if (!called) {
            called = true;
            callback(error, ...output);
        }
    }
    /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */ function then(value) {
        done(null, value);
    }
}


/**
 * @import {Node, Point, Position} from 'unist'
 * @import {Options as MessageOptions} from 'vfile-message'
 * @import {Compatible, Data, Map, Options, Value} from 'vfile'
 */ /**
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 */ 
// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
const $3f77da5648f21d15$export$500c965389abde9c = {
    basename: $3f77da5648f21d15$var$basename,
    dirname: $3f77da5648f21d15$var$dirname,
    extname: $3f77da5648f21d15$var$extname,
    join: $3f77da5648f21d15$var$join,
    sep: '/'
};
/* eslint-disable max-depth, complexity */ /**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | null | undefined} [extname]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */ function $3f77da5648f21d15$var$basename(path, extname) {
    if (extname !== undefined && typeof extname !== 'string') throw new TypeError('"ext" argument must be a string');
    $3f77da5648f21d15$var$assertPath(path);
    let start = 0;
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let seenNonSlash;
    if (extname === undefined || extname.length === 0 || extname.length > path.length) {
        while(index--){
            if (path.codePointAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? '' : path.slice(start, end);
    }
    if (extname === path) return '';
    let firstNonSlashEnd = -1;
    let extnameIndex = extname.length - 1;
    while(index--){
        if (path.codePointAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extnameIndex > -1) {
                // Try to match the explicit extension.
                if (path.codePointAt(index) === extname.codePointAt(extnameIndex--)) {
                    if (extnameIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extnameIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ function $3f77da5648f21d15$var$dirname(path) {
    $3f77da5648f21d15$var$assertPath(path);
    if (path.length === 0) return '.';
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.codePointAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.codePointAt(0) === 47 /* `/` */  ? '/' : '.' : end === 1 && path.codePointAt(0) === 47 /* `/` */  ? '//' : path.slice(0, end);
}
/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */ function $3f77da5648f21d15$var$extname(path) {
    $3f77da5648f21d15$var$assertPath(path);
    let index = path.length;
    let end = -1;
    let startPart = 0;
    let startDot = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    let preDotState = 0;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    while(index--){
        const code = path.codePointAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
    return path.slice(startDot, end);
}
/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */ function $3f77da5648f21d15$var$join(...segments) {
    let index = -1;
    /** @type {string | undefined} */ let joined;
    while(++index < segments.length){
        $3f77da5648f21d15$var$assertPath(segments[index]);
        if (segments[index]) joined = joined === undefined ? segments[index] : joined + '/' + segments[index];
    }
    return joined === undefined ? '.' : $3f77da5648f21d15$var$normalize(joined);
}
/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ // Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $3f77da5648f21d15$var$normalize(path) {
    $3f77da5648f21d15$var$assertPath(path);
    const absolute = path.codePointAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    let value = $3f77da5648f21d15$var$normalizeString(path, !absolute);
    if (value.length === 0 && !absolute) value = '.';
    if (value.length > 0 && path.codePointAt(path.length - 1) === 47 /* / */ ) value += '/';
    return absolute ? '/' + value : value;
}
/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */ function $3f77da5648f21d15$var$normalizeString(path, allowAboveRoot) {
    let result = '';
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let index = -1;
    /** @type {number | undefined} */ let code;
    /** @type {number} */ let lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.codePointAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.codePointAt(result.length - 1) !== 46 /* `.` */  || result.codePointAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf('/');
                        if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = '';
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf('/');
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length > 0) {
                        result = '';
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length > 0 ? result + '/..' : '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length > 0) result += '/' + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $3f77da5648f21d15$var$assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
} /* eslint-enable max-depth, complexity */ 


// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const $1faf6772e03c3c94$export$77f0ef6e088922ec = {
    cwd: $1faf6772e03c3c94$var$cwd
};
function $1faf6772e03c3c94$var$cwd() {
    return '/';
}


/**
 * Checks if a value has the shape of a WHATWG URL object.
 *
 * Using a symbol or instanceof would not be able to recognize URL objects
 * coming from other implementations (e.g. in Electron), so instead we are
 * checking some well known properties for a lack of a better test.
 *
 * We use `href` and `protocol` as they are the only properties that are
 * easy to retrieve and calculate due to the lazy nature of the getters.
 *
 * We check for auth attribute to distinguish legacy url instance with
 * WHATWG URL instance.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */ // From: <https://github.com/nodejs/node/blob/6a3403c/lib/internal/url.js#L720>
function $95cef6ea1b5451c9$export$8304a22d431f958(fileUrlOrPath) {
    return Boolean(fileUrlOrPath !== null && typeof fileUrlOrPath === 'object' && 'href' in fileUrlOrPath && fileUrlOrPath.href && 'protocol' in fileUrlOrPath && fileUrlOrPath.protocol && // @ts-expect-error: indexing is fine.
    fileUrlOrPath.auth === undefined);
}


function $fefa7e5b02919ba3$export$9b2b676c902de799(path) {
    if (typeof path === 'string') path = new URL(path);
    else if (!(0, $95cef6ea1b5451c9$export$8304a22d431f958)(path)) {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + path + '`');
        error.code = 'ERR_INVALID_ARG_TYPE';
        throw error;
    }
    if (path.protocol !== 'file:') {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The URL must be of scheme file');
        error.code = 'ERR_INVALID_URL_SCHEME';
        throw error;
    }
    return $fefa7e5b02919ba3$var$getPathFromURLPosix(path);
}
/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */ function $fefa7e5b02919ba3$var$getPathFromURLPosix(url) {
    if (url.hostname !== '') {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL host must be "localhost" or empty on darwin');
        error.code = 'ERR_INVALID_FILE_URL_HOST';
        throw error;
    }
    const pathname = url.pathname;
    let index = -1;
    while(++index < pathname.length)if (pathname.codePointAt(index) === 37 /* `%` */  && pathname.codePointAt(index + 1) === 50 /* `2` */ ) {
        const third = pathname.codePointAt(index + 2);
        if (third === 70 /* `F` */  || third === 102 /* `f` */ ) {
            /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL path must not include encoded / characters');
            error.code = 'ERR_INVALID_FILE_URL_PATH';
            throw error;
        }
    }
    return decodeURIComponent(pathname);
}


/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 */ const $365ad175729fa366$var$order = /** @type {const} */ [
    'history',
    'path',
    'basename',
    'stem',
    'extname',
    'dirname'
];
class $365ad175729fa366$export$93dff69eb10dc7ce {
    /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */ constructor(value){
        /** @type {Options | VFile} */ let options;
        if (!value) options = {};
        else if ((0, $95cef6ea1b5451c9$export$8304a22d431f958)(value)) options = {
            path: value
        };
        else if (typeof value === 'string' || $365ad175729fa366$var$isUint8Array(value)) options = {
            value: value
        };
        else options = value;
        /* eslint-disable no-unused-expressions */ /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */ // Prevent calling `cwd` (which could be expensive) if it’s not needed;
        // the empty string will be overridden in the next block.
        this.cwd = 'cwd' in options ? '' : (0, $1faf6772e03c3c94$export$77f0ef6e088922ec).cwd();
        /**
     * Place to store custom info (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */ this.data = {};
        /**
     * List of file paths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */ this.history = [];
        /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */ this.messages = [];
        /**
     * Raw value.
     *
     * @type {Value}
     */ this.value;
        // The below are non-standard, they are “well-known”.
        // As in, used in several tools.
        /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */ this.map;
        /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */ this.result;
        /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */ this.stored;
        /* eslint-enable no-unused-expressions */ // Set path related properties in the correct order.
        let index = -1;
        while(++index < $365ad175729fa366$var$order.length){
            const field = $365ad175729fa366$var$order[index];
            // Note: we specifically use `in` instead of `hasOwnProperty` to accept
            // `vfile`s too.
            if (field in options && options[field] !== undefined && options[field] !== null) // @ts-expect-error: TS doesn’t understand basic reality.
            this[field] = field === 'history' ? [
                ...options[field]
            ] : options[field];
        }
        /** @type {string} */ let field;
        // Set non-path related properties.
        for(field in options)// @ts-expect-error: fine to set other things.
        if (!$365ad175729fa366$var$order.includes(field)) // @ts-expect-error: fine to set other things.
        this[field] = options[field];
    }
    /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */ get basename() {
        return typeof this.path === 'string' ? (0, $3f77da5648f21d15$export$500c965389abde9c).basename(this.path) : undefined;
    }
    /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */ set basename(basename) {
        $365ad175729fa366$var$assertNonEmpty(basename, 'basename');
        $365ad175729fa366$var$assertPart(basename, 'basename');
        this.path = (0, $3f77da5648f21d15$export$500c965389abde9c).join(this.dirname || '', basename);
    }
    /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */ get dirname() {
        return typeof this.path === 'string' ? (0, $3f77da5648f21d15$export$500c965389abde9c).dirname(this.path) : undefined;
    }
    /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */ set dirname(dirname) {
        $365ad175729fa366$var$assertPath(this.basename, 'dirname');
        this.path = (0, $3f77da5648f21d15$export$500c965389abde9c).join(dirname || '', this.basename);
    }
    /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */ get extname() {
        return typeof this.path === 'string' ? (0, $3f77da5648f21d15$export$500c965389abde9c).extname(this.path) : undefined;
    }
    /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */ set extname(extname) {
        $365ad175729fa366$var$assertPart(extname, 'extname');
        $365ad175729fa366$var$assertPath(this.dirname, 'extname');
        if (extname) {
            if (extname.codePointAt(0) !== 46 /* `.` */ ) throw new Error('`extname` must start with `.`');
            if (extname.includes('.', 1)) throw new Error('`extname` cannot contain multiple dots');
        }
        this.path = (0, $3f77da5648f21d15$export$500c965389abde9c).join(this.dirname, this.stem + (extname || ''));
    }
    /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */ get path() {
        return this.history[this.history.length - 1];
    }
    /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */ set path(path) {
        if ((0, $95cef6ea1b5451c9$export$8304a22d431f958)(path)) path = (0, $fefa7e5b02919ba3$export$9b2b676c902de799)(path);
        $365ad175729fa366$var$assertNonEmpty(path, 'path');
        if (this.path !== path) this.history.push(path);
    }
    /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */ get stem() {
        return typeof this.path === 'string' ? (0, $3f77da5648f21d15$export$500c965389abde9c).basename(this.path, this.extname) : undefined;
    }
    /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */ set stem(stem) {
        $365ad175729fa366$var$assertNonEmpty(stem, 'stem');
        $365ad175729fa366$var$assertPart(stem, 'stem');
        this.path = (0, $3f77da5648f21d15$export$500c965389abde9c).join(this.dirname || '', stem + (this.extname || ''));
    }
    // Normal prototypal methods.
    /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */ fail(causeOrReason, optionsOrParentOrPlace, origin) {
        // @ts-expect-error: the overloads are fine.
        const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
        message.fatal = true;
        throw message;
    }
    /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ info(causeOrReason, optionsOrParentOrPlace, origin) {
        // @ts-expect-error: the overloads are fine.
        const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
        message.fatal = undefined;
        return message;
    }
    /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ message(causeOrReason, optionsOrParentOrPlace, origin) {
        const message = new (0, $0aa9ed7423c10921$export$752e5c445fe834ef)(// @ts-expect-error: the overloads are fine.
        causeOrReason, optionsOrParentOrPlace, origin);
        if (this.path) {
            message.name = this.path + ':' + message.name;
            message.file = this.path;
        }
        message.fatal = false;
        this.messages.push(message);
        return message;
    }
    /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */ toString(encoding) {
        if (this.value === undefined) return '';
        if (typeof this.value === 'string') return this.value;
        const decoder = new TextDecoder(encoding || undefined);
        return decoder.decode(this.value);
    }
}
/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {undefined}
 *   Nothing.
 */ function $365ad175729fa366$var$assertPart(part, name) {
    if (part && part.includes((0, $3f77da5648f21d15$export$500c965389abde9c).sep)) throw new Error('`' + name + '` cannot be a path: did not expect `' + (0, $3f77da5648f21d15$export$500c965389abde9c).sep + '`');
}
/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */ function $365ad175729fa366$var$assertNonEmpty(part, name) {
    if (!part) throw new Error('`' + name + '` cannot be empty');
}
/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $365ad175729fa366$var$assertPath(path, name) {
    if (!path) throw new Error('Setting `' + name + '` requires `path` to be set too');
}
/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */ function $365ad175729fa366$var$isUint8Array(value) {
    return Boolean(value && typeof value === 'object' && 'byteLength' in value && 'byteOffset' in value);
}


const $e4c6cc9ff888c1a4$export$b7de1db558410812 = /** @type {unknown} */ /**
       * @this {Function}
       * @param {string | symbol} property
       * @returns {(...parameters: Array<unknown>) => unknown}
       */ function(property) {
    const self = this;
    const constr = self.constructor;
    const proto = /** @type {Record<string | symbol, Function>} */ // Prototypes do exist.
    // type-coverage:ignore-next-line
    constr.prototype;
    const value = proto[property];
    /** @type {(...parameters: Array<unknown>) => unknown} */ const apply = function() {
        return value.apply(apply, arguments);
    };
    Object.setPrototypeOf(apply, proto);
    // Not needed for us in `unified`: we only call this on the `copy`
    // function,
    // and we don't need to add its fields (`length`, `name`)
    // over.
    // See also: GH-246.
    // const names = Object.getOwnPropertyNames(value)
    //
    // for (const p of names) {
    //   const descriptor = Object.getOwnPropertyDescriptor(value, p)
    //   if (descriptor) Object.defineProperty(apply, p, descriptor)
    // }
    return apply;
};


// To do: next major: drop `Compiler`, `Parser`: prefer lowercase.
// To do: we could start yielding `never` in TS when a parser is missing and
// `parse` is called.
// Currently, we allow directly setting `processor.parser`, which is untyped.
const $82354957eb1a51f9$var$own = {}.hasOwnProperty;
class $82354957eb1a51f9$export$c30cd198d731db19 extends (0, $e4c6cc9ff888c1a4$export$b7de1db558410812) {
    /**
   * Create a processor.
   */ constructor(){
        // If `Processor()` is called (w/o new), `copy` is called instead.
        super('copy');
        /**
     * Compiler to use (deprecated).
     *
     * @deprecated
     *   Use `compiler` instead.
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */ this.Compiler = undefined;
        /**
     * Parser to use (deprecated).
     *
     * @deprecated
     *   Use `parser` instead.
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */ this.Parser = undefined;
        // Note: the following fields are considered private.
        // However, they are needed for tests, and TSC generates an untyped
        // `private freezeIndex` field for, which trips `type-coverage` up.
        // Instead, we use `@deprecated` to visualize that they shouldn’t be used.
        /**
     * Internal list of configured plugins.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Array<PluginTuple<Array<unknown>>>}
     */ this.attachers = [];
        /**
     * Compiler to use.
     *
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */ this.compiler = undefined;
        /**
     * Internal state to track where we are while freezing.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {number}
     */ this.freezeIndex = -1;
        /**
     * Internal state to track whether we’re frozen.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {boolean | undefined}
     */ this.frozen = undefined;
        /**
     * Internal state.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Data}
     */ this.namespace = {};
        /**
     * Parser to use.
     *
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */ this.parser = undefined;
        /**
     * Internal list of configured transformers.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Pipeline}
     */ this.transformers = (0, $f4c69d6c22bcde86$export$91b56f5ca106aa43)();
    }
    /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */ copy() {
        // Cast as the type parameters will be the same after attaching.
        const destination = /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */ new $82354957eb1a51f9$export$c30cd198d731db19();
        let index = -1;
        while(++index < this.attachers.length){
            const attacher = this.attachers[index];
            destination.use(...attacher);
        }
        destination.data((0, (/*@__PURE__*/$parcel$interopDefault($ce3b58bef1324512$exports)))(true, {}, this.namespace));
        return destination;
    }
    /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */ data(key, value) {
        if (typeof key === 'string') {
            // Set `key`.
            if (arguments.length === 2) {
                $82354957eb1a51f9$var$assertUnfrozen('data', this.frozen);
                this.namespace[key] = value;
                return this;
            }
            // Get `key`.
            return $82354957eb1a51f9$var$own.call(this.namespace, key) && this.namespace[key] || undefined;
        }
        // Set space.
        if (key) {
            $82354957eb1a51f9$var$assertUnfrozen('data', this.frozen);
            this.namespace = key;
            return this;
        }
        // Get space.
        return this.namespace;
    }
    /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */ freeze() {
        if (this.frozen) return this;
        // Cast so that we can type plugins easier.
        // Plugins are supposed to be usable on different processors, not just on
        // this exact processor.
        const self = /** @type {unknown} */ this;
        while(++this.freezeIndex < this.attachers.length){
            const [attacher, ...options] = this.attachers[this.freezeIndex];
            if (options[0] === false) continue;
            if (options[0] === true) options[0] = undefined;
            const transformer = attacher.call(self, ...options);
            if (typeof transformer === 'function') this.transformers.use(transformer);
        }
        this.frozen = true;
        this.freezeIndex = Number.POSITIVE_INFINITY;
        return this;
    }
    /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */ parse(file) {
        this.freeze();
        const realFile = $82354957eb1a51f9$var$vfile(file);
        const parser = this.parser || this.Parser;
        $82354957eb1a51f9$var$assertParser('parse', parser);
        return parser(String(realFile), realFile);
    }
    /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ process(file, done) {
        const self = this;
        this.freeze();
        $82354957eb1a51f9$var$assertParser('process', this.parser || this.Parser);
        $82354957eb1a51f9$var$assertCompiler('process', this.compiler || this.Compiler);
        return done ? executor(undefined, done) : new Promise(executor);
        // Note: `void`s needed for TS.
        /**
     * @param {((file: VFileWithOutput<CompileResult>) => undefined | void) | undefined} resolve
     * @param {(error: Error | undefined) => undefined | void} reject
     * @returns {undefined}
     */ function executor(resolve, reject) {
            const realFile = $82354957eb1a51f9$var$vfile(file);
            // Assume `ParseTree` (the result of the parser) matches `HeadTree` (the
            // input of the first transform).
            const parseTree = /** @type {unknown} */ self.parse(realFile);
            self.run(parseTree, realFile, function(error, tree, file) {
                if (error || !tree || !file) return realDone(error);
                // Assume `TailTree` (the output of the last transform) matches
                // `CompileTree` (the input of the compiler).
                const compileTree = /** @type {unknown} */ tree;
                const compileResult = self.stringify(compileTree, file);
                if ($82354957eb1a51f9$var$looksLikeAValue(compileResult)) file.value = compileResult;
                else file.result = compileResult;
                realDone(error, /** @type {VFileWithOutput<CompileResult>} */ file);
            });
            /**
       * @param {Error | undefined} error
       * @param {VFileWithOutput<CompileResult> | undefined} [file]
       * @returns {undefined}
       */ function realDone(error, file) {
                if (error || !file) reject(error);
                else if (resolve) resolve(file);
                else {
                    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(done, '`done` is defined if `resolve` is not');
                    done(undefined, file);
                }
            }
        }
    }
    /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ processSync(file) {
        /** @type {boolean} */ let complete = false;
        /** @type {VFileWithOutput<CompileResult> | undefined} */ let result;
        this.freeze();
        $82354957eb1a51f9$var$assertParser('processSync', this.parser || this.Parser);
        $82354957eb1a51f9$var$assertCompiler('processSync', this.compiler || this.Compiler);
        this.process(file, realDone);
        $82354957eb1a51f9$var$assertDone('processSync', 'process', complete);
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(result, 'we either bailed on an error or have a tree');
        return result;
        /**
     * @type {ProcessCallback<VFileWithOutput<CompileResult>>}
     */ function realDone(error, file) {
            complete = true;
            (0, $2fd75206f7b34a41$export$dd911e13ecb11e05)(error);
            result = file;
        }
    }
    /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */ run(tree, file, done) {
        $82354957eb1a51f9$var$assertNode(tree);
        this.freeze();
        const transformers = this.transformers;
        if (!done && typeof file === 'function') {
            done = file;
            file = undefined;
        }
        return done ? executor(undefined, done) : new Promise(executor);
        // Note: `void`s needed for TS.
        /**
     * @param {(
     *   ((tree: TailTree extends undefined ? Node : TailTree) => undefined | void) |
     *   undefined
     * )} resolve
     * @param {(error: Error) => undefined | void} reject
     * @returns {undefined}
     */ function executor(resolve, reject) {
            (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(typeof file !== 'function', "`file` can\u2019t be a `done` anymore, we checked");
            const realFile = $82354957eb1a51f9$var$vfile(file);
            transformers.run(tree, realFile, realDone);
            /**
       * @param {Error | undefined} error
       * @param {Node} outputTree
       * @param {VFile} file
       * @returns {undefined}
       */ function realDone(error, outputTree, file) {
                const resultingTree = /** @type {TailTree extends undefined ? Node : TailTree} */ outputTree || tree;
                if (error) reject(error);
                else if (resolve) resolve(resultingTree);
                else {
                    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(done, '`done` is defined if `resolve` is not');
                    done(undefined, resultingTree, file);
                }
            }
        }
    }
    /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */ runSync(tree, file) {
        /** @type {boolean} */ let complete = false;
        /** @type {(TailTree extends undefined ? Node : TailTree) | undefined} */ let result;
        this.run(tree, file, realDone);
        $82354957eb1a51f9$var$assertDone('runSync', 'run', complete);
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(result, 'we either bailed on an error or have a tree');
        return result;
        /**
     * @type {RunCallback<TailTree extends undefined ? Node : TailTree>}
     */ function realDone(error, tree) {
            (0, $2fd75206f7b34a41$export$dd911e13ecb11e05)(error);
            result = tree;
            complete = true;
        }
    }
    /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ stringify(tree, file) {
        this.freeze();
        const realFile = $82354957eb1a51f9$var$vfile(file);
        const compiler = this.compiler || this.Compiler;
        $82354957eb1a51f9$var$assertCompiler('stringify', compiler);
        $82354957eb1a51f9$var$assertNode(tree);
        return compiler(tree, realFile);
    }
    /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */ use(value, ...parameters) {
        const attachers = this.attachers;
        const namespace = this.namespace;
        $82354957eb1a51f9$var$assertUnfrozen('use', this.frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === 'function') addPlugin(value, parameters);
        else if (typeof value === 'object') {
            if (Array.isArray(value)) addList(value);
            else addPreset(value);
        } else throw new TypeError('Expected usable value, not `' + value + '`');
        return this;
        /**
     * @param {Pluggable} value
     * @returns {undefined}
     */ function add(value) {
            if (typeof value === 'function') addPlugin(value, []);
            else if (typeof value === 'object') {
                if (Array.isArray(value)) {
                    const [plugin, ...parameters] = /** @type {PluginTuple<Array<unknown>>} */ value;
                    addPlugin(plugin, parameters);
                } else addPreset(value);
            } else throw new TypeError('Expected usable value, not `' + value + '`');
        }
        /**
     * @param {Preset} result
     * @returns {undefined}
     */ function addPreset(result) {
            if (!('plugins' in result) && !('settings' in result)) throw new Error('Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither');
            addList(result.plugins);
            if (result.settings) namespace.settings = (0, (/*@__PURE__*/$parcel$interopDefault($ce3b58bef1324512$exports)))(true, namespace.settings, result.settings);
        }
        /**
     * @param {PluggableList | null | undefined} plugins
     * @returns {undefined}
     */ function addList(plugins) {
            let index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (Array.isArray(plugins)) while(++index < plugins.length){
                const thing = plugins[index];
                add(thing);
            }
            else throw new TypeError('Expected a list of plugins, not `' + plugins + '`');
        }
        /**
     * @param {Plugin} plugin
     * @param {Array<unknown>} parameters
     * @returns {undefined}
     */ function addPlugin(plugin, parameters) {
            let index = -1;
            let entryIndex = -1;
            while(++index < attachers.length)if (attachers[index][0] === plugin) {
                entryIndex = index;
                break;
            }
            if (entryIndex === -1) attachers.push([
                plugin,
                ...parameters
            ]);
            else if (parameters.length > 0) {
                let [primary, ...rest] = parameters;
                const currentPrimary = attachers[entryIndex][1];
                if ((0, $89bf888846328aa6$export$2e2bcd8739ae039)(currentPrimary) && (0, $89bf888846328aa6$export$2e2bcd8739ae039)(primary)) primary = (0, (/*@__PURE__*/$parcel$interopDefault($ce3b58bef1324512$exports)))(true, currentPrimary, primary);
                attachers[entryIndex] = [
                    plugin,
                    primary,
                    ...rest
                ];
            }
        }
    }
}
const $82354957eb1a51f9$export$7cc1b2fe10c52bb = new $82354957eb1a51f9$export$c30cd198d731db19().freeze();
/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */ function $82354957eb1a51f9$var$assertParser(name, value) {
    if (typeof value !== 'function') throw new TypeError('Cannot `' + name + '` without `parser`');
}
/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */ function $82354957eb1a51f9$var$assertCompiler(name, value) {
    if (typeof value !== 'function') throw new TypeError('Cannot `' + name + '` without `compiler`');
}
/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */ function $82354957eb1a51f9$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error('Cannot call `' + name + '` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.');
}
/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */ function $82354957eb1a51f9$var$assertNode(node) {
    // `isPlainObj` unfortunately uses `any` instead of `unknown`.
    // type-coverage:ignore-next-line
    if (!(0, $89bf888846328aa6$export$2e2bcd8739ae039)(node) || typeof node.type !== 'string') throw new TypeError('Expected node, got `' + node + '`');
}
/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */ function $82354957eb1a51f9$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error('`' + name + '` finished async. Use `' + asyncName + '` instead');
}
/**
 * @param {Compatible | undefined} [value]
 * @returns {VFile}
 */ function $82354957eb1a51f9$var$vfile(value) {
    return $82354957eb1a51f9$var$looksLikeAVFile(value) ? value : new (0, $365ad175729fa366$export$93dff69eb10dc7ce)(value);
}
/**
 * @param {Compatible | undefined} [value]
 * @returns {value is VFile}
 */ function $82354957eb1a51f9$var$looksLikeAVFile(value) {
    return Boolean(value && typeof value === 'object' && 'message' in value && 'messages' in value);
}
/**
 * @param {unknown} [value]
 * @returns {value is Value}
 */ function $82354957eb1a51f9$var$looksLikeAValue(value) {
    return typeof value === 'string' || $82354957eb1a51f9$var$isUint8Array(value);
}
/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */ function $82354957eb1a51f9$var$isUint8Array(value) {
    return Boolean(value && typeof value === 'object' && 'byteLength' in value && 'byteOffset' in value);
}




const $09cf8ac2a6e57519$var$changelog = 'https://github.com/remarkjs/react-markdown/blob/main/changelog.md';
/** @type {PluggableList} */ const $09cf8ac2a6e57519$var$emptyPlugins = [];
/** @type {Readonly<RemarkRehypeOptions>} */ const $09cf8ac2a6e57519$var$emptyRemarkRehypeOptions = {
    allowDangerousHtml: true
};
const $09cf8ac2a6e57519$var$safeProtocol = /^(https?|ircs?|mailto|xmpp)$/i;
// Mutable because we `delete` any time it’s used and a message is sent.
/** @type {ReadonlyArray<Readonly<Deprecation>>} */ const $09cf8ac2a6e57519$var$deprecations = [
    {
        from: 'astPlugins',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'allowDangerousHtml',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'allowNode',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'allowElement'
    },
    {
        from: 'allowedTypes',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'allowedElements'
    },
    {
        from: 'disallowedTypes',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'disallowedElements'
    },
    {
        from: 'escapeHtml',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'includeElementIndex',
        id: '#remove-includeelementindex'
    },
    {
        from: 'includeNodeIndex',
        id: 'change-includenodeindex-to-includeelementindex'
    },
    {
        from: 'linkTarget',
        id: 'remove-linktarget'
    },
    {
        from: 'plugins',
        id: 'change-plugins-to-remarkplugins',
        to: 'remarkPlugins'
    },
    {
        from: 'rawSourcePos',
        id: '#remove-rawsourcepos'
    },
    {
        from: 'renderers',
        id: 'change-renderers-to-components',
        to: 'components'
    },
    {
        from: 'source',
        id: 'change-source-to-children',
        to: 'children'
    },
    {
        from: 'sourcePos',
        id: '#remove-sourcepos'
    },
    {
        from: 'transformImageUri',
        id: '#add-urltransform',
        to: 'urlTransform'
    },
    {
        from: 'transformLinkUri',
        id: '#add-urltransform',
        to: 'urlTransform'
    }
];
function $09cf8ac2a6e57519$export$7460c8b7e4ce9582(options) {
    const processor = $09cf8ac2a6e57519$var$createProcessor(options);
    const file = $09cf8ac2a6e57519$var$createFile(options);
    return $09cf8ac2a6e57519$var$post(processor.runSync(processor.parse(file), file), options);
}
async function $09cf8ac2a6e57519$export$445edbd7f2c65a8c(options) {
    const processor = $09cf8ac2a6e57519$var$createProcessor(options);
    const file = $09cf8ac2a6e57519$var$createFile(options);
    const tree = await processor.run(processor.parse(file), file);
    return $09cf8ac2a6e57519$var$post(tree, options);
}
function $09cf8ac2a6e57519$export$915021c692d253a2(options) {
    const processor = $09cf8ac2a6e57519$var$createProcessor(options);
    const [error, setError] = (0, $7fPBF.useState)(/** @type {Error | undefined} */ undefined);
    const [tree, setTree] = (0, $7fPBF.useState)(/** @type {Root | undefined} */ undefined);
    (0, $7fPBF.useEffect)(/* c8 ignore next 7 -- hooks are client-only. */ function() {
        const file = $09cf8ac2a6e57519$var$createFile(options);
        processor.run(processor.parse(file), file, function(error, tree) {
            setError(error);
            setTree(tree);
        });
    }, [
        options.children,
        options.rehypePlugins,
        options.remarkPlugins,
        options.remarkRehypeOptions
    ]);
    /* c8 ignore next -- hooks are client-only. */ if (error) throw error;
    /* c8 ignore next -- hooks are client-only. */ return tree ? $09cf8ac2a6e57519$var$post(tree, options) : (0, $7fPBF.createElement)((0, $824c049f32d4395d$exports.Fragment));
}
/**
 * Set up the `unified` processor.
 *
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {Processor<MdastRoot, MdastRoot, Root, undefined, undefined>}
 *   Result.
 */ function $09cf8ac2a6e57519$var$createProcessor(options) {
    const rehypePlugins = options.rehypePlugins || $09cf8ac2a6e57519$var$emptyPlugins;
    const remarkPlugins = options.remarkPlugins || $09cf8ac2a6e57519$var$emptyPlugins;
    const remarkRehypeOptions = options.remarkRehypeOptions ? {
        ...options.remarkRehypeOptions,
        ...$09cf8ac2a6e57519$var$emptyRemarkRehypeOptions
    } : $09cf8ac2a6e57519$var$emptyRemarkRehypeOptions;
    const processor = (0, $82354957eb1a51f9$export$7cc1b2fe10c52bb)().use((0, $4f339a22525673d0$export$2e2bcd8739ae039)).use(remarkPlugins).use((0, $74ce0141155f6a3a$export$2e2bcd8739ae039), remarkRehypeOptions).use(rehypePlugins);
    return processor;
}
/**
 * Set up the virtual file.
 *
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {VFile}
 *   Result.
 */ function $09cf8ac2a6e57519$var$createFile(options) {
    const children = options.children || '';
    const file = new (0, $365ad175729fa366$export$93dff69eb10dc7ce)();
    if (typeof children === 'string') file.value = children;
    else (0, $5f7e7f29fdd0c06b$export$565e9d9bd6b6e0d4)('Unexpected value `' + children + '` for `children` prop, expected `string`');
    return file;
}
/**
 * Process the result from unified some more.
 *
 * @param {Nodes} tree
 *   Tree.
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {ReactElement}
 *   React element.
 */ function $09cf8ac2a6e57519$var$post(tree, options) {
    const allowedElements = options.allowedElements;
    const allowElement = options.allowElement;
    const components = options.components;
    const disallowedElements = options.disallowedElements;
    const skipHtml = options.skipHtml;
    const unwrapDisallowed = options.unwrapDisallowed;
    const urlTransform = options.urlTransform || $09cf8ac2a6e57519$export$ca5e94754123e2f3;
    for (const deprecation of $09cf8ac2a6e57519$var$deprecations)if (Object.hasOwn(options, deprecation.from)) (0, $5f7e7f29fdd0c06b$export$565e9d9bd6b6e0d4)('Unexpected `' + deprecation.from + '` prop, ' + (deprecation.to ? 'use `' + deprecation.to + '` instead' : 'remove it') + ' (see <' + $09cf8ac2a6e57519$var$changelog + '#' + deprecation.id + '> for more info)');
    if (allowedElements && disallowedElements) (0, $5f7e7f29fdd0c06b$export$565e9d9bd6b6e0d4)('Unexpected combined `allowedElements` and `disallowedElements`, expected one or the other');
    // Wrap in `div` if there’s a class name.
    if (options.className) tree = {
        type: 'element',
        tagName: 'div',
        properties: {
            className: options.className
        },
        // Assume no doctypes.
        children: /** @type {Array<ElementContent>} */ tree.type === 'root' ? tree.children : [
            tree
        ]
    };
    (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(tree, transform);
    return (0, $bcaef7e086af7de5$export$59c10052b2dee561)(tree, {
        Fragment: $824c049f32d4395d$exports.Fragment,
        components: // @ts-expect-error
        // React components are allowed to return numbers,
        // but not according to the types in hast-util-to-jsx-runtime
        components,
        ignoreInvalidStyle: true,
        jsx: $824c049f32d4395d$exports.jsx,
        jsxs: $824c049f32d4395d$exports.jsxs,
        passKeys: true,
        passNode: true
    });
    /** @type {BuildVisitor<Root>} */ function transform(node, index, parent) {
        if (node.type === 'raw' && parent && typeof index === 'number') {
            if (skipHtml) parent.children.splice(index, 1);
            else parent.children[index] = {
                type: 'text',
                value: node.value
            };
            return index;
        }
        if (node.type === 'element') {
            /** @type {string} */ let key;
            for(key in 0, $1389ec48924c67a6$export$de3e062aedff083a)if (Object.hasOwn((0, $1389ec48924c67a6$export$de3e062aedff083a), key) && Object.hasOwn(node.properties, key)) {
                const value = node.properties[key];
                const test = (0, $1389ec48924c67a6$export$de3e062aedff083a)[key];
                if (test === null || test.includes(node.tagName)) node.properties[key] = urlTransform(String(value || ''), key, node);
            }
        }
        if (node.type === 'element') {
            let remove = allowedElements ? !allowedElements.includes(node.tagName) : disallowedElements ? disallowedElements.includes(node.tagName) : false;
            if (!remove && allowElement && typeof index === 'number') remove = !allowElement(node, index, parent);
            if (remove && parent && typeof index === 'number') {
                if (unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
                else parent.children.splice(index, 1);
                return index;
            }
        }
    }
}
function $09cf8ac2a6e57519$export$ca5e94754123e2f3(value) {
    // Same as:
    // <https://github.com/micromark/micromark/blob/929275e/packages/micromark-util-sanitize-uri/dev/index.js#L34>
    // But without the `encode` part.
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash !== -1 && colon > slash || questionMark !== -1 && colon > questionMark || numberSign !== -1 && colon > numberSign || // It is a protocol, it should be allowed.
    $09cf8ac2a6e57519$var$safeProtocol.test(value.slice(0, colon))) return value;
    return '';
}


/**
 * @import {Root} from 'mdast'
 * @import {Options} from 'remark-gfm'
 * @import {} from 'remark-parse'
 * @import {} from 'remark-stringify'
 * @import {Processor} from 'unified'
 */ /**
 * @import {Extension as FromMarkdownExtension} from 'mdast-util-from-markdown'
 * @import {Options} from 'mdast-util-gfm'
 * @import {Options as ToMarkdownExtension} from 'mdast-util-to-markdown'
 */ /**
 * @import {RegExpMatchObject, ReplaceFunction} from 'mdast-util-find-and-replace'
 * @import {CompileContext, Extension as FromMarkdownExtension, Handle as FromMarkdownHandle, Transform as FromMarkdownTransform} from 'mdast-util-from-markdown'
 * @import {ConstructName, Options as ToMarkdownExtension} from 'mdast-util-to-markdown'
 * @import {Link, PhrasingContent} from 'mdast'
 */ /**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */ function $b227513681bd728a$export$fa42eaa97a352e23(value, character) {
    const source = String(value);
    if (typeof character !== 'string') throw new TypeError('Expected character');
    let count = 0;
    let index = source.indexOf(character);
    while(index !== -1){
        count++;
        index = source.indexOf(character, index + character.length);
    }
    return count;
}




/**
 * @import {Nodes, Parents, PhrasingContent, Root, Text} from 'mdast'
 * @import {BuildVisitor, Test, VisitorResult} from 'unist-util-visit-parents'
 */ /**
 * @typedef RegExpMatchObject
 *   Info on the match.
 * @property {number} index
 *   The index of the search at which the result was found.
 * @property {string} input
 *   A copy of the search string in the text node.
 * @property {[...Array<Parents>, Text]} stack
 *   All ancestors of the text node, where the last node is the text itself.
 *
 * @typedef {RegExp | string} Find
 *   Pattern to find.
 *
 *   Strings are escaped and then turned into global expressions.
 *
 * @typedef {Array<FindAndReplaceTuple>} FindAndReplaceList
 *   Several find and replaces, in array form.
 *
 * @typedef {[Find, Replace?]} FindAndReplaceTuple
 *   Find and replace in tuple form.
 *
 * @typedef {ReplaceFunction | string | null | undefined} Replace
 *   Thing to replace with.
 *
 * @callback ReplaceFunction
 *   Callback called when a search matches.
 * @param {...any} parameters
 *   The parameters are the result of corresponding search expression:
 *
 *   * `value` (`string`) — whole match
 *   * `...capture` (`Array<string>`) — matches from regex capture groups
 *   * `match` (`RegExpMatchObject`) — info on the match
 * @returns {Array<PhrasingContent> | PhrasingContent | string | false | null | undefined}
 *   Thing to replace with.
 *
 *   * when `null`, `undefined`, `''`, remove the match
 *   * …or when `false`, do not replace at all
 *   * …or when `string`, replace with a text node of that value
 *   * …or when `Node` or `Array<Node>`, replace with those nodes
 *
 * @typedef {[RegExp, ReplaceFunction]} Pair
 *   Normalized find and replace.
 *
 * @typedef {Array<Pair>} Pairs
 *   All find and replaced.
 *
 * @typedef Options
 *   Configuration.
 * @property {Test | null | undefined} [ignore]
 *   Test for which nodes to ignore (optional).
 */ function $439fd7e08f00e217$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new TypeError('Expected a string');
    // Escape characters with special meaning either inside or outside character sets.
    // Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
    return string.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}




function $10de114def6cf069$export$fb306ebf003fc574(tree, list, options) {
    const settings = options || {};
    const ignored = (0, $312c10cea7b70433$export$9c68d69a4c5bbcf9)(settings.ignore || []);
    const pairs = $10de114def6cf069$var$toPairs(list);
    let pairIndex = -1;
    while(++pairIndex < pairs.length)(0, $9ef2eaca0b34953c$export$70008a21eb6de899)(tree, 'text', visitor);
    /** @type {BuildVisitor<Root, 'text'>} */ function visitor(node, parents) {
        let index = -1;
        /** @type {Parents | undefined} */ let grandparent;
        while(++index < parents.length){
            const parent = parents[index];
            /** @type {Array<Nodes> | undefined} */ const siblings = grandparent ? grandparent.children : undefined;
            if (ignored(parent, siblings ? siblings.indexOf(parent) : undefined, grandparent)) return;
            grandparent = parent;
        }
        if (grandparent) return handler(node, parents);
    }
    /**
   * Handle a text node which is not in an ignored parent.
   *
   * @param {Text} node
   *   Text node.
   * @param {Array<Parents>} parents
   *   Parents.
   * @returns {VisitorResult}
   *   Result.
   */ function handler(node, parents) {
        const parent = parents[parents.length - 1];
        const find = pairs[pairIndex][0];
        const replace = pairs[pairIndex][1];
        let start = 0;
        /** @type {Array<Nodes>} */ const siblings = parent.children;
        const index = siblings.indexOf(node);
        let change = false;
        /** @type {Array<PhrasingContent>} */ let nodes = [];
        find.lastIndex = 0;
        let match = find.exec(node.value);
        while(match){
            const position = match.index;
            /** @type {RegExpMatchObject} */ const matchObject = {
                index: match.index,
                input: match.input,
                stack: [
                    ...parents,
                    node
                ]
            };
            let value = replace(...match, matchObject);
            if (typeof value === 'string') value = value.length > 0 ? {
                type: 'text',
                value: value
            } : undefined;
            // It wasn’t a match after all.
            if (value === false) // False acts as if there was no match.
            // So we need to reset `lastIndex`, which currently being at the end of
            // the current match, to the beginning.
            find.lastIndex = position + 1;
            else {
                if (start !== position) nodes.push({
                    type: 'text',
                    value: node.value.slice(start, position)
                });
                if (Array.isArray(value)) nodes.push(...value);
                else if (value) nodes.push(value);
                start = position + match[0].length;
                change = true;
            }
            if (!find.global) break;
            match = find.exec(node.value);
        }
        if (change) {
            if (start < node.value.length) nodes.push({
                type: 'text',
                value: node.value.slice(start)
            });
            parent.children.splice(index, 1, ...nodes);
        } else nodes = [
            node
        ];
        return index + nodes.length;
    }
}
/**
 * Turn a tuple or a list of tuples into pairs.
 *
 * @param {FindAndReplaceList | FindAndReplaceTuple} tupleOrList
 *   Schema.
 * @returns {Pairs}
 *   Clean pairs.
 */ function $10de114def6cf069$var$toPairs(tupleOrList) {
    /** @type {Pairs} */ const result = [];
    if (!Array.isArray(tupleOrList)) throw new TypeError('Expected find and replace tuple or list of tuples');
    /** @type {FindAndReplaceList} */ // @ts-expect-error: correct.
    const list = !tupleOrList[0] || Array.isArray(tupleOrList[0]) ? tupleOrList : [
        tupleOrList
    ];
    let index = -1;
    while(++index < list.length){
        const tuple = list[index];
        result.push([
            $10de114def6cf069$var$toExpression(tuple[0]),
            $10de114def6cf069$var$toFunction(tuple[1])
        ]);
    }
    return result;
}
/**
 * Turn a find into an expression.
 *
 * @param {Find} find
 *   Find.
 * @returns {RegExp}
 *   Expression.
 */ function $10de114def6cf069$var$toExpression(find) {
    return typeof find === 'string' ? new RegExp((0, $439fd7e08f00e217$export$2e2bcd8739ae039)(find), 'g') : find;
}
/**
 * Turn a replace into a function.
 *
 * @param {Replace} replace
 *   Replace.
 * @returns {ReplaceFunction}
 *   Function.
 */ function $10de114def6cf069$var$toFunction(replace) {
    return typeof replace === 'function' ? replace : function() {
        return replace;
    };
}


/** @type {ConstructName} */ const $a508b14f9fabfff1$var$inConstruct = 'phrasing';
/** @type {Array<ConstructName>} */ const $a508b14f9fabfff1$var$notInConstruct = [
    'autolink',
    'link',
    'image',
    'label'
];
function $a508b14f9fabfff1$export$b6afdfff2163546f() {
    return {
        transforms: [
            $a508b14f9fabfff1$var$transformGfmAutolinkLiterals
        ],
        enter: {
            literalAutolink: $a508b14f9fabfff1$var$enterLiteralAutolink,
            literalAutolinkEmail: $a508b14f9fabfff1$var$enterLiteralAutolinkValue,
            literalAutolinkHttp: $a508b14f9fabfff1$var$enterLiteralAutolinkValue,
            literalAutolinkWww: $a508b14f9fabfff1$var$enterLiteralAutolinkValue
        },
        exit: {
            literalAutolink: $a508b14f9fabfff1$var$exitLiteralAutolink,
            literalAutolinkEmail: $a508b14f9fabfff1$var$exitLiteralAutolinkEmail,
            literalAutolinkHttp: $a508b14f9fabfff1$var$exitLiteralAutolinkHttp,
            literalAutolinkWww: $a508b14f9fabfff1$var$exitLiteralAutolinkWww
        }
    };
}
function $a508b14f9fabfff1$export$d3ace9096b01c39d() {
    return {
        unsafe: [
            {
                character: '@',
                before: '[+\\-.\\w]',
                after: '[\\-.\\w]',
                inConstruct: $a508b14f9fabfff1$var$inConstruct,
                notInConstruct: $a508b14f9fabfff1$var$notInConstruct
            },
            {
                character: '.',
                before: '[Ww]',
                after: '[\\-.\\w]',
                inConstruct: $a508b14f9fabfff1$var$inConstruct,
                notInConstruct: $a508b14f9fabfff1$var$notInConstruct
            },
            {
                character: ':',
                before: '[ps]',
                after: '\\/',
                inConstruct: $a508b14f9fabfff1$var$inConstruct,
                notInConstruct: $a508b14f9fabfff1$var$notInConstruct
            }
        ]
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a508b14f9fabfff1$var$enterLiteralAutolink(token) {
    this.enter({
        type: 'link',
        title: null,
        url: '',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a508b14f9fabfff1$var$enterLiteralAutolinkValue(token) {
    this.config.enter.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a508b14f9fabfff1$var$exitLiteralAutolinkHttp(token) {
    this.config.exit.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a508b14f9fabfff1$var$exitLiteralAutolinkWww(token) {
    this.config.exit.data.call(this, token);
    const node = this.stack[this.stack.length - 1];
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(node.type === 'link');
    node.url = 'http://' + this.sliceSerialize(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a508b14f9fabfff1$var$exitLiteralAutolinkEmail(token) {
    this.config.exit.autolinkEmail.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a508b14f9fabfff1$var$exitLiteralAutolink(token) {
    this.exit(token);
}
/** @type {FromMarkdownTransform} */ function $a508b14f9fabfff1$var$transformGfmAutolinkLiterals(tree) {
    (0, $10de114def6cf069$export$fb306ebf003fc574)(tree, [
        [
            /(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi,
            $a508b14f9fabfff1$var$findUrl
        ],
        [
            /(?<=^|\s|\p{P}|\p{S})([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/gu,
            $a508b14f9fabfff1$var$findEmail
        ]
    ], {
        ignore: [
            'link',
            'linkReference'
        ]
    });
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} protocol
 * @param {string} domain
 * @param {string} path
 * @param {RegExpMatchObject} match
 * @returns {Array<PhrasingContent> | Link | false}
 */ // eslint-disable-next-line max-params
function $a508b14f9fabfff1$var$findUrl(_, protocol, domain, path, match) {
    let prefix = '';
    // Not an expected previous character.
    if (!$a508b14f9fabfff1$var$previous(match)) return false;
    // Treat `www` as part of the domain.
    if (/^w/i.test(protocol)) {
        domain = protocol + domain;
        protocol = '';
        prefix = 'http://';
    }
    if (!$a508b14f9fabfff1$var$isCorrectDomain(domain)) return false;
    const parts = $a508b14f9fabfff1$var$splitUrl(domain + path);
    if (!parts[0]) return false;
    /** @type {Link} */ const result = {
        type: 'link',
        title: null,
        url: prefix + protocol + parts[0],
        children: [
            {
                type: 'text',
                value: protocol + parts[0]
            }
        ]
    };
    if (parts[1]) return [
        result,
        {
            type: 'text',
            value: parts[1]
        }
    ];
    return result;
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} atext
 * @param {string} label
 * @param {RegExpMatchObject} match
 * @returns {Link | false}
 */ function $a508b14f9fabfff1$var$findEmail(_, atext, label, match) {
    if (// Not an expected previous character.
    !$a508b14f9fabfff1$var$previous(match, true) || // Label ends in not allowed character.
    /[-\d_]$/.test(label)) return false;
    return {
        type: 'link',
        title: null,
        url: 'mailto:' + atext + '@' + label,
        children: [
            {
                type: 'text',
                value: atext + '@' + label
            }
        ]
    };
}
/**
 * @param {string} domain
 * @returns {boolean}
 */ function $a508b14f9fabfff1$var$isCorrectDomain(domain) {
    const parts = domain.split('.');
    if (parts.length < 2 || parts[parts.length - 1] && (/_/.test(parts[parts.length - 1]) || !/[a-zA-Z\d]/.test(parts[parts.length - 1])) || parts[parts.length - 2] && (/_/.test(parts[parts.length - 2]) || !/[a-zA-Z\d]/.test(parts[parts.length - 2]))) return false;
    return true;
}
/**
 * @param {string} url
 * @returns {[string, string | undefined]}
 */ function $a508b14f9fabfff1$var$splitUrl(url) {
    const trailExec = /[!"&'),.:;<>?\]}]+$/.exec(url);
    if (!trailExec) return [
        url,
        undefined
    ];
    url = url.slice(0, trailExec.index);
    let trail = trailExec[0];
    let closingParenIndex = trail.indexOf(')');
    const openingParens = (0, $b227513681bd728a$export$fa42eaa97a352e23)(url, '(');
    let closingParens = (0, $b227513681bd728a$export$fa42eaa97a352e23)(url, ')');
    while(closingParenIndex !== -1 && openingParens > closingParens){
        url += trail.slice(0, closingParenIndex + 1);
        trail = trail.slice(closingParenIndex + 1);
        closingParenIndex = trail.indexOf(')');
        closingParens++;
    }
    return [
        url,
        trail
    ];
}
/**
 * @param {RegExpMatchObject} match
 * @param {boolean | null | undefined} [email=false]
 * @returns {boolean}
 */ function $a508b14f9fabfff1$var$previous(match, email) {
    const code = match.input.charCodeAt(match.index - 1);
    return (match.index === 0 || (0, $9a96cd0c036af4eb$export$a0ff789c034ffdf4)(code) || (0, $9a96cd0c036af4eb$export$aa04114dd888a7a0)(code)) && // If it’s an email, the previous character should not be a slash.
    (!email || code !== 47);
}


/**
 * @import {
 *   CompileContext,
 *   Extension as FromMarkdownExtension,
 *   Handle as FromMarkdownHandle
 * } from 'mdast-util-from-markdown'
 * @import {ToMarkdownOptions} from 'mdast-util-gfm-footnote'
 * @import {
 *   Handle as ToMarkdownHandle,
 *   Map,
 *   Options as ToMarkdownExtension
 * } from 'mdast-util-to-markdown'
 * @import {FootnoteDefinition, FootnoteReference} from 'mdast'
 */ 

$c376fab83e3ca8f4$var$footnoteReference.peek = $c376fab83e3ca8f4$var$footnoteReferencePeek;
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c376fab83e3ca8f4$var$enterFootnoteCallString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c376fab83e3ca8f4$var$enterFootnoteCall(token) {
    this.enter({
        type: 'footnoteReference',
        identifier: '',
        label: ''
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c376fab83e3ca8f4$var$enterFootnoteDefinitionLabelString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c376fab83e3ca8f4$var$enterFootnoteDefinition(token) {
    this.enter({
        type: 'footnoteDefinition',
        identifier: '',
        label: '',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c376fab83e3ca8f4$var$exitFootnoteCallString(token) {
    const label = this.resume();
    const node = this.stack[this.stack.length - 1];
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(node.type === 'footnoteReference');
    node.identifier = (0, $c580fc709a668807$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    node.label = label;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c376fab83e3ca8f4$var$exitFootnoteCall(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c376fab83e3ca8f4$var$exitFootnoteDefinitionLabelString(token) {
    const label = this.resume();
    const node = this.stack[this.stack.length - 1];
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(node.type === 'footnoteDefinition');
    node.identifier = (0, $c580fc709a668807$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    node.label = label;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c376fab83e3ca8f4$var$exitFootnoteDefinition(token) {
    this.exit(token);
}
/** @type {ToMarkdownHandle} */ function $c376fab83e3ca8f4$var$footnoteReferencePeek() {
    return '[';
}
/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteReference} node
 */ function $c376fab83e3ca8f4$var$footnoteReference(node, _, state, info) {
    const tracker = state.createTracker(info);
    let value = tracker.move('[^');
    const exit = state.enter('footnoteReference');
    const subexit = state.enter('reference');
    value += tracker.move(state.safe(state.associationId(node), {
        after: ']',
        before: value
    }));
    subexit();
    exit();
    value += tracker.move(']');
    return value;
}
function $c376fab83e3ca8f4$export$c9d5ad4bdf6ff801() {
    return {
        enter: {
            gfmFootnoteCallString: $c376fab83e3ca8f4$var$enterFootnoteCallString,
            gfmFootnoteCall: $c376fab83e3ca8f4$var$enterFootnoteCall,
            gfmFootnoteDefinitionLabelString: $c376fab83e3ca8f4$var$enterFootnoteDefinitionLabelString,
            gfmFootnoteDefinition: $c376fab83e3ca8f4$var$enterFootnoteDefinition
        },
        exit: {
            gfmFootnoteCallString: $c376fab83e3ca8f4$var$exitFootnoteCallString,
            gfmFootnoteCall: $c376fab83e3ca8f4$var$exitFootnoteCall,
            gfmFootnoteDefinitionLabelString: $c376fab83e3ca8f4$var$exitFootnoteDefinitionLabelString,
            gfmFootnoteDefinition: $c376fab83e3ca8f4$var$exitFootnoteDefinition
        }
    };
}
function $c376fab83e3ca8f4$export$3727766a73a6c09f(options) {
    // To do: next major: change default.
    let firstLineBlank = false;
    if (options && options.firstLineBlank) firstLineBlank = true;
    return {
        handlers: {
            footnoteDefinition: footnoteDefinition,
            footnoteReference: $c376fab83e3ca8f4$var$footnoteReference
        },
        // This is on by default already.
        unsafe: [
            {
                character: '[',
                inConstruct: [
                    'label',
                    'phrasing',
                    'reference'
                ]
            }
        ]
    };
    /**
   * @type {ToMarkdownHandle}
   * @param {FootnoteDefinition} node
   */ function footnoteDefinition(node, _, state, info) {
        const tracker = state.createTracker(info);
        let value = tracker.move('[^');
        const exit = state.enter('footnoteDefinition');
        const subexit = state.enter('label');
        value += tracker.move(state.safe(state.associationId(node), {
            before: value,
            after: ']'
        }));
        subexit();
        value += tracker.move(']:');
        if (node.children && node.children.length > 0) {
            tracker.shift(4);
            value += tracker.move((firstLineBlank ? '\n' : ' ') + state.indentLines(state.containerFlow(node, tracker.current()), firstLineBlank ? $c376fab83e3ca8f4$var$mapAll : $c376fab83e3ca8f4$var$mapExceptFirst));
        }
        exit();
        return value;
    }
}
/** @type {Map} */ function $c376fab83e3ca8f4$var$mapExceptFirst(line, index, blank) {
    return index === 0 ? line : $c376fab83e3ca8f4$var$mapAll(line, index, blank);
}
/** @type {Map} */ function $c376fab83e3ca8f4$var$mapAll(line, index, blank) {
    return (blank ? '' : '    ') + line;
}


/**
 * @typedef {import('mdast').Delete} Delete
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */ /**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain strikethrough.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * Note: keep in sync with: <https://github.com/syntax-tree/mdast-util-to-markdown/blob/8ce8dbf/lib/unsafe.js#L14>
 *
 * @type {Array<ConstructName>}
 */ const $09e40cfc169f6d05$var$constructsWithoutStrikethrough = [
    'autolink',
    'destinationLiteral',
    'destinationRaw',
    'reference',
    'titleQuote',
    'titleApostrophe'
];
$09e40cfc169f6d05$var$handleDelete.peek = $09e40cfc169f6d05$var$peekDelete;
function $09e40cfc169f6d05$export$34d64e709dd0b9bb() {
    return {
        canContainEols: [
            'delete'
        ],
        enter: {
            strikethrough: $09e40cfc169f6d05$var$enterStrikethrough
        },
        exit: {
            strikethrough: $09e40cfc169f6d05$var$exitStrikethrough
        }
    };
}
function $09e40cfc169f6d05$export$1632835bd2c84956() {
    return {
        unsafe: [
            {
                character: '~',
                inConstruct: 'phrasing',
                notInConstruct: $09e40cfc169f6d05$var$constructsWithoutStrikethrough
            }
        ],
        handlers: {
            delete: $09e40cfc169f6d05$var$handleDelete
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $09e40cfc169f6d05$var$enterStrikethrough(token) {
    this.enter({
        type: 'delete',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $09e40cfc169f6d05$var$exitStrikethrough(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 */ function $09e40cfc169f6d05$var$handleDelete(node, _, state, info) {
    const tracker = state.createTracker(info);
    const exit = state.enter('strikethrough');
    let value = tracker.move('~~');
    value += state.containerPhrasing(node, {
        ...tracker.current(),
        before: value,
        after: '~'
    });
    value += tracker.move('~~');
    exit();
    return value;
}
/** @type {ToMarkdownHandle} */ function $09e40cfc169f6d05$var$peekDelete() {
    return '~';
}


/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('mdast').TableRow} TableRow
 *
 * @typedef {import('markdown-table').Options} MarkdownTableOptions
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').State} State
 * @typedef {import('mdast-util-to-markdown').Info} Info
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [tableCellPadding=true]
 *   Whether to add a space of padding between delimiters and cells (default:
 *   `true`).
 * @property {boolean | null | undefined} [tablePipeAlign=true]
 *   Whether to align the delimiters (default: `true`).
 * @property {MarkdownTableOptions['stringLength'] | null | undefined} [stringLength]
 *   Function to detect the length of table cell content, used when aligning
 *   the delimiters between cells (optional).
 */ 
// To do: next major: remove.
/**
 * @typedef {Options} MarkdownTableOptions
 *   Configuration.
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [alignDelimiters=true]
 *   Whether to align the delimiters (default: `true`);
 *   they are aligned by default:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   Pass `false` to make them staggered:
 *
 *   ```markdown
 *   | Alpha | B |
 *   | - | - |
 *   | C | Delta |
 *   ```
 * @property {ReadonlyArray<string | null | undefined> | string | null | undefined} [align]
 *   How to align columns (default: `''`);
 *   one style for all columns or styles for their respective columns;
 *   each style is either `'l'` (left), `'r'` (right), or `'c'` (center);
 *   other values are treated as `''`, which doesn’t place the colon in the
 *   alignment row but does align left;
 *   *only the lowercased first character is used, so `Right` is fine.*
 * @property {boolean | null | undefined} [delimiterEnd=true]
 *   Whether to end each row with the delimiter (default: `true`).
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B
 *   | ----- | -----
 *   | C     | Delta
 *   ```
 * @property {boolean | null | undefined} [delimiterStart=true]
 *   Whether to begin each row with the delimiter (default: `true`).
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are starting delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no starting delimiters:
 *
 *   ```markdown
 *   Alpha | B     |
 *   ----- | ----- |
 *   C     | Delta |
 *   ```
 * @property {boolean | null | undefined} [padding=true]
 *   Whether to add a space of padding between delimiters and cells
 *   (default: `true`).
 *
 *   When `true`, there is padding:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there is no padding:
 *
 *   ```markdown
 *   |Alpha|B    |
 *   |-----|-----|
 *   |C    |Delta|
 *   ```
 * @property {((value: string) => number) | null | undefined} [stringLength]
 *   Function to detect the length of table cell content (optional);
 *   this is used when aligning the delimiters (`|`) between table cells;
 *   full-width characters and emoji mess up delimiter alignment when viewing
 *   the markdown source;
 *   to fix this, you can pass this function,
 *   which receives the cell content and returns its “visible” size;
 *   note that what is and isn’t visible depends on where the text is displayed.
 *
 *   Without such a function, the following:
 *
 *   ```js
 *   markdownTable([
 *     ['Alpha', 'Bravo'],
 *     ['中文', 'Charlie'],
 *     ['👩‍❤️‍👩', 'Delta']
 *   ])
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo |
 *   | - | - |
 *   | 中文 | Charlie |
 *   | 👩‍❤️‍👩 | Delta |
 *   ```
 *
 *   With [`string-width`](https://github.com/sindresorhus/string-width):
 *
 *   ```js
 *   import stringWidth from 'string-width'
 *
 *   markdownTable(
 *     [
 *       ['Alpha', 'Bravo'],
 *       ['中文', 'Charlie'],
 *       ['👩‍❤️‍👩', 'Delta']
 *     ],
 *     {stringLength: stringWidth}
 *   )
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo   |
 *   | ----- | ------- |
 *   | 中文  | Charlie |
 *   | 👩‍❤️‍👩    | Delta   |
 *   ```
 */ /**
 * @param {string} value
 *   Cell value.
 * @returns {number}
 *   Cell size.
 */ function $04345556f6d0def5$var$defaultStringLength(value) {
    return value.length;
}
function $04345556f6d0def5$export$cdb7288612c4f3d6(table, options) {
    const settings = options || {};
    // To do: next major: change to spread.
    const align = (settings.align || []).concat();
    const stringLength = settings.stringLength || $04345556f6d0def5$var$defaultStringLength;
    /** @type {Array<number>} Character codes as symbols for alignment per column. */ const alignments = [];
    /** @type {Array<Array<string>>} Cells per row. */ const cellMatrix = [];
    /** @type {Array<Array<number>>} Sizes of each cell per row. */ const sizeMatrix = [];
    /** @type {Array<number>} */ const longestCellByColumn = [];
    let mostCellsPerRow = 0;
    let rowIndex = -1;
    // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
    // do superfluous work when aligning, so optimize for aligning.
    while(++rowIndex < table.length){
        /** @type {Array<string>} */ const row = [];
        /** @type {Array<number>} */ const sizes = [];
        let columnIndex = -1;
        if (table[rowIndex].length > mostCellsPerRow) mostCellsPerRow = table[rowIndex].length;
        while(++columnIndex < table[rowIndex].length){
            const cell = $04345556f6d0def5$var$serialize(table[rowIndex][columnIndex]);
            if (settings.alignDelimiters !== false) {
                const size = stringLength(cell);
                sizes[columnIndex] = size;
                if (longestCellByColumn[columnIndex] === undefined || size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            }
            row.push(cell);
        }
        cellMatrix[rowIndex] = row;
        sizeMatrix[rowIndex] = sizes;
    }
    // Figure out which alignments to use.
    let columnIndex = -1;
    if (typeof align === 'object' && 'length' in align) while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = $04345556f6d0def5$var$toAlignment(align[columnIndex]);
    else {
        const code = $04345556f6d0def5$var$toAlignment(align);
        while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = code;
    }
    // Inject the alignment row.
    columnIndex = -1;
    /** @type {Array<string>} */ const row = [];
    /** @type {Array<number>} */ const sizes = [];
    while(++columnIndex < mostCellsPerRow){
        const code = alignments[columnIndex];
        let before = '';
        let after = '';
        if (code === 99 /* `c` */ ) {
            before = ':';
            after = ':';
        } else if (code === 108 /* `l` */ ) before = ':';
        else if (code === 114 /* `r` */ ) after = ':';
        // There *must* be at least one hyphen-minus in each alignment cell.
        let size = settings.alignDelimiters === false ? 1 : Math.max(1, longestCellByColumn[columnIndex] - before.length - after.length);
        const cell = before + '-'.repeat(size) + after;
        if (settings.alignDelimiters !== false) {
            size = before.length + size + after.length;
            if (size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            sizes[columnIndex] = size;
        }
        row[columnIndex] = cell;
    }
    // Inject the alignment row.
    cellMatrix.splice(1, 0, row);
    sizeMatrix.splice(1, 0, sizes);
    rowIndex = -1;
    /** @type {Array<string>} */ const lines = [];
    while(++rowIndex < cellMatrix.length){
        const row = cellMatrix[rowIndex];
        const sizes = sizeMatrix[rowIndex];
        columnIndex = -1;
        /** @type {Array<string>} */ const line = [];
        while(++columnIndex < mostCellsPerRow){
            const cell = row[columnIndex] || '';
            let before = '';
            let after = '';
            if (settings.alignDelimiters !== false) {
                const size = longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0);
                const code = alignments[columnIndex];
                if (code === 114 /* `r` */ ) before = ' '.repeat(size);
                else if (code === 99 /* `c` */ ) {
                    if (size % 2) {
                        before = ' '.repeat(size / 2 + 0.5);
                        after = ' '.repeat(size / 2 - 0.5);
                    } else {
                        before = ' '.repeat(size / 2);
                        after = before;
                    }
                } else after = ' '.repeat(size);
            }
            if (settings.delimiterStart !== false && !columnIndex) line.push('|');
            if (settings.padding !== false && // Don’t add the opening space if we’re not aligning and the cell is
            // empty: there will be a closing space.
            !(settings.alignDelimiters === false && cell === '') && (settings.delimiterStart !== false || columnIndex)) line.push(' ');
            if (settings.alignDelimiters !== false) line.push(before);
            line.push(cell);
            if (settings.alignDelimiters !== false) line.push(after);
            if (settings.padding !== false) line.push(' ');
            if (settings.delimiterEnd !== false || columnIndex !== mostCellsPerRow - 1) line.push('|');
        }
        lines.push(settings.delimiterEnd === false ? line.join('').replace(/ +$/, '') : line.join(''));
    }
    return lines.join('\n');
}
/**
 * @param {string | null | undefined} [value]
 *   Value to serialize.
 * @returns {string}
 *   Result.
 */ function $04345556f6d0def5$var$serialize(value) {
    return value === null || value === undefined ? '' : String(value);
}
/**
 * @param {string | null | undefined} value
 *   Value.
 * @returns {number}
 *   Alignment.
 */ function $04345556f6d0def5$var$toAlignment(value) {
    const code = typeof value === 'string' ? value.codePointAt(0) : 0;
    return code === 67 /* `C` */  || code === 99 /* `c` */  ? 99 /* `c` */  : code === 76 /* `L` */  || code === 108 /* `l` */  ? 108 /* `l` */  : code === 82 /* `R` */  || code === 114 /* `r` */  ? 114 /* `r` */  : 0;
}


/**
 * @import {Blockquote, Parents} from 'mdast'
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {Blockquote} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $c22d6b26d8763f1a$export$67dc04e652a298ca(node, _, state, info) {
    const exit = state.enter('blockquote');
    const tracker = state.createTracker(info);
    tracker.move('> ');
    tracker.shift(2);
    const value = state.indentLines(state.containerFlow(node, tracker.current()), $c22d6b26d8763f1a$var$map);
    exit();
    return value;
}
/** @type {Map} */ function $c22d6b26d8763f1a$var$map(line, _, blank) {
    return '>' + (blank ? '' : ' ') + line;
}


/**
 * @import {Break, Parents} from 'mdast'
 * @import {Info, State} from 'mdast-util-to-markdown'
 */ /**
 * @import {ConstructName, Unsafe} from 'mdast-util-to-markdown'
 */ /**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe} pattern
 * @returns {boolean}
 */ function $faa99a565617de42$export$78221a09424368d(stack, pattern) {
    return $faa99a565617de42$var$listInScope(stack, pattern.inConstruct, true) && !$faa99a565617de42$var$listInScope(stack, pattern.notInConstruct, false);
}
/**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe['inConstruct']} list
 * @param {boolean} none
 * @returns {boolean}
 */ function $faa99a565617de42$var$listInScope(stack, list, none) {
    if (typeof list === 'string') list = [
        list
    ];
    if (!list || list.length === 0) return none;
    let index = -1;
    while(++index < list.length){
        if (stack.includes(list[index])) return true;
    }
    return false;
}


function $b44c63001bb6e43e$export$371da9dd35aba193(_, _1, state, info) {
    let index = -1;
    while(++index < state.unsafe.length){
        // If we can’t put eols in this construct (setext headings, tables), use a
        // space instead.
        if (state.unsafe[index].character === '\n' && (0, $faa99a565617de42$export$78221a09424368d)(state.stack, state.unsafe[index])) return /[ \t]/.test(info.before) ? '' : ' ';
    }
    return '\\\n';
}


/**
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 * @import {Code, Parents} from 'mdast'
 */ /**
 * Get the count of the longest repeating streak of `substring` in `value`.
 *
 * @param {string} value
 *   Content to search in.
 * @param {string} substring
 *   Substring to look for, typically one character.
 * @returns {number}
 *   Count of most frequent adjacent `substring`s in `value`.
 */ function $b732c3de0f6b9a59$export$711675ff42d864f2(value, substring) {
    const source = String(value);
    let index = source.indexOf(substring);
    let expected = index;
    let count = 0;
    let max = 0;
    if (typeof substring !== 'string') throw new TypeError('Expected substring');
    while(index !== -1){
        if (index === expected) {
            if (++count > max) max = count;
        } else count = 1;
        expected = index + substring.length;
        index = source.indexOf(substring, expected);
    }
    return max;
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Code} from 'mdast'
 */ /**
 * @param {Code} node
 * @param {State} state
 * @returns {boolean}
 */ function $976a1661809365d1$export$8c0df78a8cad9f4b(node, state) {
    return Boolean(state.options.fences === false && node.value && // If there’s no info…
    !node.lang && // And there’s a non-whitespace character…
    /[^ \r\n]/.test(node.value) && // And the value doesn’t start or end in a blank…
    !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(node.value));
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['fence'], null | undefined>}
 */ function $16d1e1d0e9bb535c$export$7487ee7cbb2e2919(state) {
    const marker = state.options.fence || '`';
    if (marker !== '`' && marker !== '~') throw new Error('Cannot serialize code with `' + marker + '` for `options.fence`, expected `` ` `` or `~`');
    return marker;
}


function $c9de17fde5da4e09$export$6565f9f03506010b(node, _, state, info) {
    const marker = (0, $16d1e1d0e9bb535c$export$7487ee7cbb2e2919)(state);
    const raw = node.value || '';
    const suffix = marker === '`' ? 'GraveAccent' : 'Tilde';
    if ((0, $976a1661809365d1$export$8c0df78a8cad9f4b)(node, state)) {
        const exit = state.enter('codeIndented');
        const value = state.indentLines(raw, $c9de17fde5da4e09$var$map);
        exit();
        return value;
    }
    const tracker = state.createTracker(info);
    const sequence = marker.repeat(Math.max((0, $b732c3de0f6b9a59$export$711675ff42d864f2)(raw, marker) + 1, 3));
    const exit = state.enter('codeFenced');
    let value = tracker.move(sequence);
    if (node.lang) {
        const subexit = state.enter(`codeFencedLang${suffix}`);
        value += tracker.move(state.safe(node.lang, {
            before: value,
            after: ' ',
            encode: [
                '`'
            ],
            ...tracker.current()
        }));
        subexit();
    }
    if (node.lang && node.meta) {
        const subexit = state.enter(`codeFencedMeta${suffix}`);
        value += tracker.move(' ');
        value += tracker.move(state.safe(node.meta, {
            before: value,
            after: '\n',
            encode: [
                '`'
            ],
            ...tracker.current()
        }));
        subexit();
    }
    value += tracker.move('\n');
    if (raw) value += tracker.move(raw + '\n');
    value += tracker.move(sequence);
    exit();
    return value;
}
/** @type {Map} */ function $c9de17fde5da4e09$var$map(line, _, blank) {
    return (blank ? '' : '    ') + line;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Definition, Parents} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['quote'], null | undefined>}
 */ function $ce55bd1707ed4560$export$7aeba63896b2719(state) {
    const marker = state.options.quote || '"';
    if (marker !== '"' && marker !== "'") throw new Error('Cannot serialize title with `' + marker + '` for `options.quote`, expected `"`, or `\'`');
    return marker;
}


function $de907278b9522dcf$export$69f215ed977cdb73(node, _, state, info) {
    const quote = (0, $ce55bd1707ed4560$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const exit = state.enter('definition');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('[');
    value += tracker.move(state.safe(state.associationId(node), {
        before: value,
        after: ']',
        ...tracker.current()
    }));
    value += tracker.move(']: ');
    subexit();
    if (// If there’s no url, or…
    !node.url || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? ' ' : '\n',
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    exit();
    return value;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Emphasis, Parents} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['emphasis'], null | undefined>}
 */ function $75785ad8dfd7e058$export$f967eb786dea04e7(state) {
    const marker = state.options.emphasis || '*';
    if (marker !== '*' && marker !== '_') throw new Error('Cannot serialize emphasis with `' + marker + '` for `options.emphasis`, expected `*`, or `_`');
    return marker;
}


/**
 * Encode a code point as a character reference.
 *
 * @param {number} code
 *   Code point to encode.
 * @returns {string}
 *   Encoded character reference.
 */ function $ef164935741e67b3$export$5810cf1e579e9d5b(code) {
    return '&#x' + code.toString(16).toUpperCase() + ';';
}


/**
 * @import {EncodeSides} from '../types.js'
 */ 
function $e3ad60aa0bb5edc4$export$b444be54825dd0b6(outside, inside, marker) {
    const outsideKind = (0, $cae7fc7dfc0e8dc7$export$e3902bc0d835cad0)(outside);
    const insideKind = (0, $cae7fc7dfc0e8dc7$export$e3902bc0d835cad0)(inside);
    // Letter outside:
    if (outsideKind === undefined) return insideKind === undefined ? // we have to encode *both* letters for `_` as it is looser.
    // it already forms for `*` (and GFMs `~`).
    marker === '_' ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: true
    };
    // Whitespace outside:
    if (outsideKind === 1) return insideKind === undefined ? {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: false
    };
    // Punctuation outside:
    return insideKind === undefined ? {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: false
    } : {
        inside: false,
        outside: false
    };
}


$5363ce757c0f934c$export$bef81ba411953b51.peek = $5363ce757c0f934c$var$emphasisPeek;
function $5363ce757c0f934c$export$bef81ba411953b51(node, _, state, info) {
    const marker = (0, $75785ad8dfd7e058$export$f967eb786dea04e7)(state);
    const exit = state.enter('emphasis');
    const tracker = state.createTracker(info);
    const before = tracker.move(marker);
    let between = tracker.move(state.containerPhrasing(node, {
        after: marker,
        before: before,
        ...tracker.current()
    }));
    const betweenHead = between.charCodeAt(0);
    const open = (0, $e3ad60aa0bb5edc4$export$b444be54825dd0b6)(info.before.charCodeAt(info.before.length - 1), betweenHead, marker);
    if (open.inside) between = (0, $ef164935741e67b3$export$5810cf1e579e9d5b)(betweenHead) + between.slice(1);
    const betweenTail = between.charCodeAt(between.length - 1);
    const close = (0, $e3ad60aa0bb5edc4$export$b444be54825dd0b6)(info.after.charCodeAt(0), betweenTail, marker);
    if (close.inside) between = between.slice(0, -1) + (0, $ef164935741e67b3$export$5810cf1e579e9d5b)(betweenTail);
    const after = tracker.move(marker);
    exit();
    state.attentionEncodeSurroundingInfo = {
        after: close.outside,
        before: open.outside
    };
    return before + between + after;
}
/**
 * @param {Emphasis} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */ function $5363ce757c0f934c$var$emphasisPeek(_, _1, state) {
    return state.options.emphasis || '*';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Heading, Parents} from 'mdast'
 */ 
/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Heading} from 'mdast'
 */ 

function $57ca23d123f29cd8$export$78863676235adfbc(node, state) {
    let literalWithBreak = false;
    // Look for literals with a line break.
    // Note that this also
    (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(node, function(node) {
        if ('value' in node && /\r?\n|\r/.test(node.value) || node.type === 'break') {
            literalWithBreak = true;
            return 0, $9ef2eaca0b34953c$export$7f100f842f565dc9;
        }
    });
    return Boolean((!node.depth || node.depth < 3) && (0, $da74a7bb5b052f79$export$f84e8e69fd4488a5)(node) && (state.options.setext || literalWithBreak));
}


function $b9838158d361d84b$export$46e4a324ac90507f(node, _, state, info) {
    const rank = Math.max(Math.min(6, node.depth || 1), 1);
    const tracker = state.createTracker(info);
    if ((0, $57ca23d123f29cd8$export$78863676235adfbc)(node, state)) {
        const exit = state.enter('headingSetext');
        const subexit = state.enter('phrasing');
        const value = state.containerPhrasing(node, {
            ...tracker.current(),
            before: '\n',
            after: '\n'
        });
        subexit();
        exit();
        return value + '\n' + (rank === 1 ? '=' : '-').repeat(// The whole size…
        value.length - // Minus the position of the character after the last EOL (or
        // 0 if there is none)…
        (Math.max(value.lastIndexOf('\r'), value.lastIndexOf('\n')) + 1));
    }
    const sequence = '#'.repeat(rank);
    const exit = state.enter('headingAtx');
    const subexit = state.enter('phrasing');
    // Note: for proper tracking, we should reset the output positions when there
    // is no content returned, because then the space is not output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    tracker.move(sequence + ' ');
    let value = state.containerPhrasing(node, {
        before: '# ',
        after: '\n',
        ...tracker.current()
    });
    if (/^[\t ]/.test(value)) // To do: what effect has the character reference on tracking?
    value = (0, $ef164935741e67b3$export$5810cf1e579e9d5b)(value.charCodeAt(0)) + value.slice(1);
    value = value ? sequence + ' ' + value : sequence;
    if (state.options.closeAtx) value += ' ' + sequence;
    subexit();
    exit();
    return value;
}


/**
 * @import {Html} from 'mdast'
 */ $9a83b6191accc866$export$c0bb0b647f701bb5.peek = $9a83b6191accc866$var$htmlPeek;
function $9a83b6191accc866$export$c0bb0b647f701bb5(node) {
    return node.value || '';
}
/**
 * @returns {string}
 */ function $9a83b6191accc866$var$htmlPeek() {
    return '<';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Image, Parents} from 'mdast'
 */ 
$d5640795fae1711f$export$5c452ff88e35e47d.peek = $d5640795fae1711f$var$imagePeek;
function $d5640795fae1711f$export$5c452ff88e35e47d(node, _, state, info) {
    const quote = (0, $ce55bd1707ed4560$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const exit = state.enter('image');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('![');
    value += tracker.move(state.safe(node.alt, {
        before: value,
        after: ']',
        ...tracker.current()
    }));
    value += tracker.move('](');
    subexit();
    if (// If there’s no url but there is a title…
    !node.url && node.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? ' ' : ')',
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    value += tracker.move(')');
    exit();
    return value;
}
/**
 * @returns {string}
 */ function $d5640795fae1711f$var$imagePeek() {
    return '!';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {ImageReference, Parents} from 'mdast'
 */ $9ab1f1e75e4d33d3$export$f281796f6bc3b8db.peek = $9ab1f1e75e4d33d3$var$imageReferencePeek;
function $9ab1f1e75e4d33d3$export$f281796f6bc3b8db(node, _, state, info) {
    const type = node.referenceType;
    const exit = state.enter('imageReference');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('![');
    const alt = state.safe(node.alt, {
        before: value,
        after: ']',
        ...tracker.current()
    });
    value += tracker.move(alt + '][');
    subexit();
    // Hide the fact that we’re in phrasing, because escapes don’t work.
    const stack = state.stack;
    state.stack = [];
    subexit = state.enter('reference');
    // Note: for proper tracking, we should reset the output positions when we end
    // up making a `shortcut` reference, because then there is no brace output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    const reference = state.safe(state.associationId(node), {
        before: value,
        after: ']',
        ...tracker.current()
    });
    subexit();
    state.stack = stack;
    exit();
    if (type === 'full' || !alt || alt !== reference) value += tracker.move(reference + ']');
    else if (type === 'shortcut') // Remove the unwanted `[`.
    value = value.slice(0, -1);
    else value += tracker.move(']');
    return value;
}
/**
 * @returns {string}
 */ function $9ab1f1e75e4d33d3$var$imageReferencePeek() {
    return '!';
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {InlineCode, Parents} from 'mdast'
 */ $d83732a415638d5c$export$91b9bee19a0d8569.peek = $d83732a415638d5c$var$inlineCodePeek;
function $d83732a415638d5c$export$91b9bee19a0d8569(node, _, state) {
    let value = node.value || '';
    let sequence = '`';
    let index = -1;
    // If there is a single grave accent on its own in the code, use a fence of
    // two.
    // If there are two in a row, use one.
    while(new RegExp('(^|[^`])' + sequence + '([^`]|$)').test(value))sequence += '`';
    // If this is not just spaces or eols (tabs don’t count), and either the
    // first or last character are a space, eol, or tick, then pad with spaces.
    if (/[^ \r\n]/.test(value) && (/^[ \r\n]/.test(value) && /[ \r\n]$/.test(value) || /^`|`$/.test(value))) value = ' ' + value + ' ';
    // We have a potential problem: certain characters after eols could result in
    // blocks being seen.
    // For example, if someone injected the string `'\n# b'`, then that would
    // result in an ATX heading.
    // We can’t escape characters in `inlineCode`, but because eols are
    // transformed to spaces when going from markdown to HTML anyway, we can swap
    // them out.
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        const expression = state.compilePattern(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        // Only look for `atBreak`s.
        // Btw: note that `atBreak` patterns will always start the regex at LF or
        // CR.
        if (!pattern.atBreak) continue;
        while(match = expression.exec(value)){
            let position = match.index;
            // Support CRLF (patterns only look for one of the characters).
            if (value.charCodeAt(position) === 10 /* `\n` */  && value.charCodeAt(position - 1) === 13 /* `\r` */ ) position--;
            value = value.slice(0, position) + ' ' + value.slice(match.index + 1);
        }
    }
    return sequence + value + sequence;
}
/**
 * @returns {string}
 */ function $d83732a415638d5c$var$inlineCodePeek() {
    return '`';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Link, Parents} from 'mdast'
 * @import {Exit} from '../types.js'
 */ 
/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Link} from 'mdast'
 */ 
function $fa39aaa691787db5$export$74cae3045e3179ed(node, state) {
    const raw = (0, $da74a7bb5b052f79$export$f84e8e69fd4488a5)(node);
    return Boolean(!state.options.resourceLink && // If there’s a url…
    node.url && // And there’s a no title…
    !node.title && // And the content of `node` is a single text node…
    node.children && node.children.length === 1 && node.children[0].type === 'text' && // And if the url is the same as the content…
    (raw === node.url || 'mailto:' + raw === node.url) && // And that starts w/ a protocol…
    /^[a-z][a-z+.-]+:/i.test(node.url) && // And that doesn’t contain ASCII control codes (character escapes and
    // references don’t work), space, or angle brackets…
    !/[\0- <>\u007F]/.test(node.url));
}


$44386f6ce5814f19$export$9c30223ca0a664fb.peek = $44386f6ce5814f19$var$linkPeek;
function $44386f6ce5814f19$export$9c30223ca0a664fb(node, _, state, info) {
    const quote = (0, $ce55bd1707ed4560$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const tracker = state.createTracker(info);
    /** @type {Exit} */ let exit;
    /** @type {Exit} */ let subexit;
    if ((0, $fa39aaa691787db5$export$74cae3045e3179ed)(node, state)) {
        // Hide the fact that we’re in phrasing, because escapes don’t work.
        const stack = state.stack;
        state.stack = [];
        exit = state.enter('autolink');
        let value = tracker.move('<');
        value += tracker.move(state.containerPhrasing(node, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
        exit();
        state.stack = stack;
        return value;
    }
    exit = state.enter('link');
    subexit = state.enter('label');
    let value = tracker.move('[');
    value += tracker.move(state.containerPhrasing(node, {
        before: value,
        after: '](',
        ...tracker.current()
    }));
    value += tracker.move('](');
    subexit();
    if (// If there’s no url but there is a title…
    !node.url && node.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? ' ' : ')',
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    value += tracker.move(')');
    exit();
    return value;
}
/**
 * @param {Link} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @returns {string}
 */ function $44386f6ce5814f19$var$linkPeek(node, _, state) {
    return (0, $fa39aaa691787db5$export$74cae3045e3179ed)(node, state) ? '<' : '[';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {LinkReference, Parents} from 'mdast'
 */ $6fcde372b87d3fed$export$e6c469b1b7b2bc6a.peek = $6fcde372b87d3fed$var$linkReferencePeek;
function $6fcde372b87d3fed$export$e6c469b1b7b2bc6a(node, _, state, info) {
    const type = node.referenceType;
    const exit = state.enter('linkReference');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('[');
    const text = state.containerPhrasing(node, {
        before: value,
        after: ']',
        ...tracker.current()
    });
    value += tracker.move(text + '][');
    subexit();
    // Hide the fact that we’re in phrasing, because escapes don’t work.
    const stack = state.stack;
    state.stack = [];
    subexit = state.enter('reference');
    // Note: for proper tracking, we should reset the output positions when we end
    // up making a `shortcut` reference, because then there is no brace output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    const reference = state.safe(state.associationId(node), {
        before: value,
        after: ']',
        ...tracker.current()
    });
    subexit();
    state.stack = stack;
    exit();
    if (type === 'full' || !text || text !== reference) value += tracker.move(reference + ']');
    else if (type === 'shortcut') // Remove the unwanted `[`.
    value = value.slice(0, -1);
    else value += tracker.move(']');
    return value;
}
/**
 * @returns {string}
 */ function $6fcde372b87d3fed$var$linkReferencePeek() {
    return '[';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {List, Parents} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bullet'], null | undefined>}
 */ function $f52261392897ff44$export$7425517207a4d0ae(state) {
    const marker = state.options.bullet || '*';
    if (marker !== '*' && marker !== '+' && marker !== '-') throw new Error('Cannot serialize items with `' + marker + '` for `options.bullet`, expected `*`, `+`, or `-`');
    return marker;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ 
function $ae37c79b31867a05$export$e6803bf0889262a1(state) {
    const bullet = (0, $f52261392897ff44$export$7425517207a4d0ae)(state);
    const bulletOther = state.options.bulletOther;
    if (!bulletOther) return bullet === '*' ? '-' : '*';
    if (bulletOther !== '*' && bulletOther !== '+' && bulletOther !== '-') throw new Error('Cannot serialize items with `' + bulletOther + '` for `options.bulletOther`, expected `*`, `+`, or `-`');
    if (bulletOther === bullet) throw new Error('Expected `bullet` (`' + bullet + '`) and `bulletOther` (`' + bulletOther + '`) to be different');
    return bulletOther;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bulletOrdered'], null | undefined>}
 */ function $82eeac05fc7d31a0$export$98d522b78eddc19b(state) {
    const marker = state.options.bulletOrdered || '.';
    if (marker !== '.' && marker !== ')') throw new Error('Cannot serialize items with `' + marker + '` for `options.bulletOrdered`, expected `.` or `)`');
    return marker;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['rule'], null | undefined>}
 */ function $01ecb0fec064563b$export$d8d533ef24dba866(state) {
    const marker = state.options.rule || '*';
    if (marker !== '*' && marker !== '-' && marker !== '_') throw new Error('Cannot serialize rules with `' + marker + '` for `options.rule`, expected `*`, `-`, or `_`');
    return marker;
}


function $83184e8a3561368a$export$8837f4fc672e936d(node, parent, state, info) {
    const exit = state.enter('list');
    const bulletCurrent = state.bulletCurrent;
    /** @type {string} */ let bullet = node.ordered ? (0, $82eeac05fc7d31a0$export$98d522b78eddc19b)(state) : (0, $f52261392897ff44$export$7425517207a4d0ae)(state);
    /** @type {string} */ const bulletOther = node.ordered ? bullet === '.' ? ')' : '.' : (0, $ae37c79b31867a05$export$e6803bf0889262a1)(state);
    let useDifferentMarker = parent && state.bulletLastUsed ? bullet === state.bulletLastUsed : false;
    if (!node.ordered) {
        const firstListItem = node.children ? node.children[0] : undefined;
        // If there’s an empty first list item directly in two list items,
        // we have to use a different bullet:
        //
        // ```markdown
        // * - *
        // ```
        //
        // …because otherwise it would become one big thematic break.
        if (// Bullet could be used as a thematic break marker:
        (bullet === '*' || bullet === '-') && // Empty first list item:
        firstListItem && (!firstListItem.children || !firstListItem.children[0]) && // Directly in two other list items:
        state.stack[state.stack.length - 1] === 'list' && state.stack[state.stack.length - 2] === 'listItem' && state.stack[state.stack.length - 3] === 'list' && state.stack[state.stack.length - 4] === 'listItem' && // That are each the first child.
        state.indexStack[state.indexStack.length - 1] === 0 && state.indexStack[state.indexStack.length - 2] === 0 && state.indexStack[state.indexStack.length - 3] === 0) useDifferentMarker = true;
        // If there’s a thematic break at the start of the first list item,
        // we have to use a different bullet:
        //
        // ```markdown
        // * ---
        // ```
        //
        // …because otherwise it would become one big thematic break.
        if ((0, $01ecb0fec064563b$export$d8d533ef24dba866)(state) === bullet && firstListItem) {
            let index = -1;
            while(++index < node.children.length){
                const item = node.children[index];
                if (item && item.type === 'listItem' && item.children && item.children[0] && item.children[0].type === 'thematicBreak') {
                    useDifferentMarker = true;
                    break;
                }
            }
        }
    }
    if (useDifferentMarker) bullet = bulletOther;
    state.bulletCurrent = bullet;
    const value = state.containerFlow(node, info);
    state.bulletLastUsed = bullet;
    state.bulletCurrent = bulletCurrent;
    exit();
    return value;
}


/**
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 * @import {ListItem, Parents} from 'mdast'
 */ 
/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['listItemIndent'], null | undefined>}
 */ function $902901864b46e6e0$export$2d5358b63da92261(state) {
    const style = state.options.listItemIndent || 'one';
    if (style !== 'tab' && style !== 'one' && style !== 'mixed') throw new Error('Cannot serialize items with `' + style + '` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`');
    return style;
}


function $6e73d61bc3f6f849$export$76c7e83ecc9cdf05(node, parent, state, info) {
    const listItemIndent = (0, $902901864b46e6e0$export$2d5358b63da92261)(state);
    let bullet = state.bulletCurrent || (0, $f52261392897ff44$export$7425517207a4d0ae)(state);
    // Add the marker value for ordered lists.
    if (parent && parent.type === 'list' && parent.ordered) bullet = (typeof parent.start === 'number' && parent.start > -1 ? parent.start : 1) + (state.options.incrementListMarker === false ? 0 : parent.children.indexOf(node)) + bullet;
    let size = bullet.length + 1;
    if (listItemIndent === 'tab' || listItemIndent === 'mixed' && (parent && parent.type === 'list' && parent.spread || node.spread)) size = Math.ceil(size / 4) * 4;
    const tracker = state.createTracker(info);
    tracker.move(bullet + ' '.repeat(size - bullet.length));
    tracker.shift(size);
    const exit = state.enter('listItem');
    const value = state.indentLines(state.containerFlow(node, tracker.current()), map);
    exit();
    return value;
    /** @type {Map} */ function map(line, index, blank) {
        if (index) return (blank ? '' : ' '.repeat(size)) + line;
        return (blank ? bullet : bullet + ' '.repeat(size - bullet.length)) + line;
    }
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Paragraph, Parents} from 'mdast'
 */ /**
 * @param {Paragraph} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $5dcdf38c0853bd5d$export$9c206ddddb32a9b(node, _, state, info) {
    const exit = state.enter('paragraph');
    const subexit = state.enter('phrasing');
    const value = state.containerPhrasing(node, info);
    subexit();
    exit();
    return value;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Root} from 'mdast'
 */ /**
 * @typedef {import('mdast').Html} Html
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 */ 
const $76e22c02785b163c$export$444c9dec66a6f08c = /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */ (0, $312c10cea7b70433$export$9c68d69a4c5bbcf9)([
    'break',
    'delete',
    'emphasis',
    // To do: next major: removed since footnotes were added to GFM.
    'footnote',
    'footnoteReference',
    'image',
    'imageReference',
    'inlineCode',
    // Enabled by `mdast-util-math`:
    'inlineMath',
    'link',
    'linkReference',
    // Enabled by `mdast-util-mdx`:
    'mdxJsxTextElement',
    // Enabled by `mdast-util-mdx`:
    'mdxTextExpression',
    'strong',
    'text',
    // Enabled by `mdast-util-directive`:
    'textDirective'
]);


function $ec9cfa703f4340b2$export$e8e78c978b129247(node, _, state, info) {
    // Note: `html` nodes are ambiguous.
    const hasPhrasing = node.children.some(function(d) {
        return (0, $76e22c02785b163c$export$444c9dec66a6f08c)(d);
    });
    const container = hasPhrasing ? state.containerPhrasing : state.containerFlow;
    return container.call(state, node, info);
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Strong} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['strong'], null | undefined>}
 */ function $6d8e2a72f1cdda8f$export$b7ce17905d66a6c3(state) {
    const marker = state.options.strong || '*';
    if (marker !== '*' && marker !== '_') throw new Error('Cannot serialize strong with `' + marker + '` for `options.strong`, expected `*`, or `_`');
    return marker;
}




$50fff993476f6ef3$export$59ae2c325a998f89.peek = $50fff993476f6ef3$var$strongPeek;
function $50fff993476f6ef3$export$59ae2c325a998f89(node, _, state, info) {
    const marker = (0, $6d8e2a72f1cdda8f$export$b7ce17905d66a6c3)(state);
    const exit = state.enter('strong');
    const tracker = state.createTracker(info);
    const before = tracker.move(marker + marker);
    let between = tracker.move(state.containerPhrasing(node, {
        after: marker,
        before: before,
        ...tracker.current()
    }));
    const betweenHead = between.charCodeAt(0);
    const open = (0, $e3ad60aa0bb5edc4$export$b444be54825dd0b6)(info.before.charCodeAt(info.before.length - 1), betweenHead, marker);
    if (open.inside) between = (0, $ef164935741e67b3$export$5810cf1e579e9d5b)(betweenHead) + between.slice(1);
    const betweenTail = between.charCodeAt(between.length - 1);
    const close = (0, $e3ad60aa0bb5edc4$export$b444be54825dd0b6)(info.after.charCodeAt(0), betweenTail, marker);
    if (close.inside) between = between.slice(0, -1) + (0, $ef164935741e67b3$export$5810cf1e579e9d5b)(betweenTail);
    const after = tracker.move(marker + marker);
    exit();
    state.attentionEncodeSurroundingInfo = {
        after: close.outside,
        before: open.outside
    };
    return before + between + after;
}
/**
 * @param {Strong} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */ function $50fff993476f6ef3$var$strongPeek(_, _1, state) {
    return state.options.strong || '*';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Text} from 'mdast'
 */ /**
 * @param {Text} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $7d79792942bf3874$export$6f093cfa640b7166(node, _, state, info) {
    return state.safe(node.value, info);
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Parents, ThematicBreak} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['ruleRepetition'], null | undefined>}
 */ function $9c901976bd352085$export$72f02155834d89c4(state) {
    const repetition = state.options.ruleRepetition || 3;
    if (repetition < 3) throw new Error('Cannot serialize rules with repetition `' + repetition + '` for `options.ruleRepetition`, expected `3` or more');
    return repetition;
}



function $8f3edd6f95dc34f7$export$ba7b13e047416c03(_, _1, state) {
    const value = ((0, $01ecb0fec064563b$export$d8d533ef24dba866)(state) + (state.options.ruleSpaces ? ' ' : '')).repeat((0, $9c901976bd352085$export$72f02155834d89c4)(state));
    return state.options.ruleSpaces ? value.slice(0, -1) : value;
}


const $da19da82921559d2$export$8f34ce051745d39e = {
    blockquote: $c22d6b26d8763f1a$export$67dc04e652a298ca,
    break: (0, $b44c63001bb6e43e$export$371da9dd35aba193),
    code: $c9de17fde5da4e09$export$6565f9f03506010b,
    definition: $de907278b9522dcf$export$69f215ed977cdb73,
    emphasis: $5363ce757c0f934c$export$bef81ba411953b51,
    hardBreak: $b44c63001bb6e43e$export$371da9dd35aba193,
    heading: $b9838158d361d84b$export$46e4a324ac90507f,
    html: $9a83b6191accc866$export$c0bb0b647f701bb5,
    image: $d5640795fae1711f$export$5c452ff88e35e47d,
    imageReference: $9ab1f1e75e4d33d3$export$f281796f6bc3b8db,
    inlineCode: $d83732a415638d5c$export$91b9bee19a0d8569,
    link: $44386f6ce5814f19$export$9c30223ca0a664fb,
    linkReference: $6fcde372b87d3fed$export$e6c469b1b7b2bc6a,
    list: $83184e8a3561368a$export$8837f4fc672e936d,
    listItem: $6e73d61bc3f6f849$export$76c7e83ecc9cdf05,
    paragraph: $5dcdf38c0853bd5d$export$9c206ddddb32a9b,
    root: $ec9cfa703f4340b2$export$e8e78c978b129247,
    strong: $50fff993476f6ef3$export$59ae2c325a998f89,
    text: $7d79792942bf3874$export$6f093cfa640b7166,
    thematicBreak: $8f3edd6f95dc34f7$export$ba7b13e047416c03
};


function $27370860b3e1d456$export$8bd0ec8ecf6adb7d() {
    return {
        enter: {
            table: $27370860b3e1d456$var$enterTable,
            tableData: $27370860b3e1d456$var$enterCell,
            tableHeader: $27370860b3e1d456$var$enterCell,
            tableRow: $27370860b3e1d456$var$enterRow
        },
        exit: {
            codeText: $27370860b3e1d456$var$exitCodeText,
            table: $27370860b3e1d456$var$exitTable,
            tableData: $27370860b3e1d456$var$exit,
            tableHeader: $27370860b3e1d456$var$exit,
            tableRow: $27370860b3e1d456$var$exit
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $27370860b3e1d456$var$enterTable(token) {
    const align = token._align;
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(align, 'expected `_align` on table');
    this.enter({
        type: 'table',
        align: align.map(function(d) {
            return d === 'none' ? null : d;
        }),
        children: []
    }, token);
    this.data.inTable = true;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $27370860b3e1d456$var$exitTable(token) {
    this.exit(token);
    this.data.inTable = undefined;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $27370860b3e1d456$var$enterRow(token) {
    this.enter({
        type: 'tableRow',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $27370860b3e1d456$var$exit(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $27370860b3e1d456$var$enterCell(token) {
    this.enter({
        type: 'tableCell',
        children: []
    }, token);
}
// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $27370860b3e1d456$var$exitCodeText(token) {
    let value = this.resume();
    if (this.data.inTable) value = value.replace(/\\([\\|])/g, $27370860b3e1d456$var$replace);
    const node = this.stack[this.stack.length - 1];
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(node.type === 'inlineCode');
    node.value = value;
    this.exit(token);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $27370860b3e1d456$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === '|' ? $1 : $0;
}
function $27370860b3e1d456$export$dafcad76ea6e0045(options) {
    const settings = options || {};
    const padding = settings.tableCellPadding;
    const alignDelimiters = settings.tablePipeAlign;
    const stringLength = settings.stringLength;
    const around = padding ? ' ' : '|';
    return {
        unsafe: [
            {
                character: '\r',
                inConstruct: 'tableCell'
            },
            {
                character: '\n',
                inConstruct: 'tableCell'
            },
            // A pipe, when followed by a tab or space (padding), or a dash or colon
            // (unpadded delimiter row), could result in a table.
            {
                atBreak: true,
                character: '|',
                after: '[\t :-]'
            },
            // A pipe in a cell must be encoded.
            {
                character: '|',
                inConstruct: 'tableCell'
            },
            // A colon must be followed by a dash, in which case it could start a
            // delimiter row.
            {
                atBreak: true,
                character: ':',
                after: '-'
            },
            // A delimiter row can also start with a dash, when followed by more
            // dashes, a colon, or a pipe.
            // This is a stricter version than the built in check for lists, thematic
            // breaks, and setex heading underlines though:
            // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
            {
                atBreak: true,
                character: '-',
                after: '[:|-]'
            }
        ],
        handlers: {
            inlineCode: inlineCodeWithTable,
            table: handleTable,
            tableCell: handleTableCell,
            tableRow: handleTableRow
        }
    };
    /**
   * @type {ToMarkdownHandle}
   * @param {Table} node
   */ function handleTable(node, _, state, info) {
        return serializeData(handleTableAsData(node, state, info), node.align);
    }
    /**
   * This function isn’t really used normally, because we handle rows at the
   * table level.
   * But, if someone passes in a table row, this ensures we make somewhat sense.
   *
   * @type {ToMarkdownHandle}
   * @param {TableRow} node
   */ function handleTableRow(node, _, state, info) {
        const row = handleTableRowAsData(node, state, info);
        const value = serializeData([
            row
        ]);
        // `markdown-table` will always add an align row
        return value.slice(0, value.indexOf('\n'));
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {TableCell} node
   */ function handleTableCell(node, _, state, info) {
        const exit = state.enter('tableCell');
        const subexit = state.enter('phrasing');
        const value = state.containerPhrasing(node, {
            ...info,
            before: around,
            after: around
        });
        subexit();
        exit();
        return value;
    }
    /**
   * @param {Array<Array<string>>} matrix
   * @param {Array<string | null | undefined> | null | undefined} [align]
   */ function serializeData(matrix, align) {
        return (0, $04345556f6d0def5$export$cdb7288612c4f3d6)(matrix, {
            align: align,
            alignDelimiters: // @ts-expect-error: `markdown-table` types should support `null`.
            alignDelimiters,
            padding: // @ts-expect-error: `markdown-table` types should support `null`.
            padding,
            stringLength: // @ts-expect-error: `markdown-table` types should support `null`.
            stringLength
        });
    }
    /**
   * @param {Table} node
   * @param {State} state
   * @param {Info} info
   */ function handleTableAsData(node, state, info) {
        const children = node.children;
        let index = -1;
        /** @type {Array<Array<string>>} */ const result = [];
        const subexit = state.enter('table');
        while(++index < children.length)result[index] = handleTableRowAsData(children[index], state, info);
        subexit();
        return result;
    }
    /**
   * @param {TableRow} node
   * @param {State} state
   * @param {Info} info
   */ function handleTableRowAsData(node, state, info) {
        const children = node.children;
        let index = -1;
        /** @type {Array<string>} */ const result = [];
        const subexit = state.enter('tableRow');
        while(++index < children.length)// Note: the positional info as used here is incorrect.
        // Making it correct would be impossible due to aligning cells?
        // And it would need copy/pasting `markdown-table` into this project.
        result[index] = handleTableCell(children[index], node, state, info);
        subexit();
        return result;
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {InlineCode} node
   */ function inlineCodeWithTable(node, parent, state) {
        let value = (0, $da19da82921559d2$export$8f34ce051745d39e).inlineCode(node, parent, state);
        if (state.stack.includes('tableCell')) value = value.replace(/\|/g, '\\$&');
        return value;
    }
}


/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */ 

function $d3a60ff58d98f77f$export$a427a608608b215f() {
    return {
        exit: {
            taskListCheckValueChecked: $d3a60ff58d98f77f$var$exitCheck,
            taskListCheckValueUnchecked: $d3a60ff58d98f77f$var$exitCheck,
            paragraph: $d3a60ff58d98f77f$var$exitParagraphWithTaskListItem
        }
    };
}
function $d3a60ff58d98f77f$export$9975722e7e834b78() {
    return {
        unsafe: [
            {
                atBreak: true,
                character: '-',
                after: '[:|-]'
            }
        ],
        handlers: {
            listItem: $d3a60ff58d98f77f$var$listItemWithTaskListItem
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $d3a60ff58d98f77f$var$exitCheck(token) {
    // We’re always in a paragraph, in a list item.
    const node = this.stack[this.stack.length - 2];
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(node.type === 'listItem');
    node.checked = token.type === 'taskListCheckValueChecked';
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $d3a60ff58d98f77f$var$exitParagraphWithTaskListItem(token) {
    const parent = this.stack[this.stack.length - 2];
    if (parent && parent.type === 'listItem' && typeof parent.checked === 'boolean') {
        const node = this.stack[this.stack.length - 1];
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(node.type === 'paragraph');
        const head = node.children[0];
        if (head && head.type === 'text') {
            const siblings = parent.children;
            let index = -1;
            /** @type {Paragraph | undefined} */ let firstParaghraph;
            while(++index < siblings.length){
                const sibling = siblings[index];
                if (sibling.type === 'paragraph') {
                    firstParaghraph = sibling;
                    break;
                }
            }
            if (firstParaghraph === node) {
                // Must start with a space or a tab.
                head.value = head.value.slice(1);
                if (head.value.length === 0) node.children.shift();
                else if (node.position && head.position && typeof head.position.start.offset === 'number') {
                    head.position.start.column++;
                    head.position.start.offset++;
                    node.position.start = Object.assign({}, head.position.start);
                }
            }
        }
    }
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {ListItem} node
 */ function $d3a60ff58d98f77f$var$listItemWithTaskListItem(node, parent, state, info) {
    const head = node.children[0];
    const checkable = typeof node.checked === 'boolean' && head && head.type === 'paragraph';
    const checkbox = '[' + (node.checked ? 'x' : ' ') + '] ';
    const tracker = state.createTracker(info);
    if (checkable) tracker.move(checkbox);
    let value = (0, $da19da82921559d2$export$8f34ce051745d39e).listItem(node, parent, state, {
        ...info,
        ...tracker.current()
    });
    if (checkable) value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
    return value;
    /**
   * @param {string} $0
   * @returns {string}
   */ function check($0) {
        return $0 + checkbox;
    }
}


function $fa527d008df0ac0a$export$95adae814eb7433e() {
    return [
        (0, $a508b14f9fabfff1$export$b6afdfff2163546f)(),
        (0, $c376fab83e3ca8f4$export$c9d5ad4bdf6ff801)(),
        (0, $09e40cfc169f6d05$export$34d64e709dd0b9bb)(),
        (0, $27370860b3e1d456$export$8bd0ec8ecf6adb7d)(),
        (0, $d3a60ff58d98f77f$export$a427a608608b215f)()
    ];
}
function $fa527d008df0ac0a$export$ea77de6901e7c72b(options) {
    return {
        extensions: [
            (0, $a508b14f9fabfff1$export$d3ace9096b01c39d)(),
            (0, $c376fab83e3ca8f4$export$3727766a73a6c09f)(options),
            (0, $09e40cfc169f6d05$export$1632835bd2c84956)(),
            (0, $27370860b3e1d456$export$dafcad76ea6e0045)(options),
            (0, $d3a60ff58d98f77f$export$9975722e7e834b78)()
        ]
    };
}


/**
 * @typedef {import('micromark-extension-gfm-footnote').HtmlOptions} HtmlOptions
 * @typedef {import('micromark-extension-gfm-strikethrough').Options} Options
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ 
/**
 * @import {Code, ConstructRecord, Event, Extension, Previous, State, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 
const $2c344f86004a8679$var$wwwPrefix = {
    tokenize: $2c344f86004a8679$var$tokenizeWwwPrefix,
    partial: true
};
const $2c344f86004a8679$var$domain = {
    tokenize: $2c344f86004a8679$var$tokenizeDomain,
    partial: true
};
const $2c344f86004a8679$var$path = {
    tokenize: $2c344f86004a8679$var$tokenizePath,
    partial: true
};
const $2c344f86004a8679$var$trail = {
    tokenize: $2c344f86004a8679$var$tokenizeTrail,
    partial: true
};
const $2c344f86004a8679$var$emailDomainDotTrail = {
    tokenize: $2c344f86004a8679$var$tokenizeEmailDomainDotTrail,
    partial: true
};
const $2c344f86004a8679$var$wwwAutolink = {
    name: 'wwwAutolink',
    tokenize: $2c344f86004a8679$var$tokenizeWwwAutolink,
    previous: $2c344f86004a8679$var$previousWww
};
const $2c344f86004a8679$var$protocolAutolink = {
    name: 'protocolAutolink',
    tokenize: $2c344f86004a8679$var$tokenizeProtocolAutolink,
    previous: $2c344f86004a8679$var$previousProtocol
};
const $2c344f86004a8679$var$emailAutolink = {
    name: 'emailAutolink',
    tokenize: $2c344f86004a8679$var$tokenizeEmailAutolink,
    previous: $2c344f86004a8679$var$previousEmail
};
/** @type {ConstructRecord} */ const $2c344f86004a8679$var$text = {};
function $2c344f86004a8679$export$608123d9b549151() {
    return {
        text: $2c344f86004a8679$var$text
    };
}
/** @type {Code} */ let $2c344f86004a8679$var$code = 48;
// Add alphanumerics.
while($2c344f86004a8679$var$code < 123){
    $2c344f86004a8679$var$text[$2c344f86004a8679$var$code] = $2c344f86004a8679$var$emailAutolink;
    $2c344f86004a8679$var$code++;
    if ($2c344f86004a8679$var$code === 58) $2c344f86004a8679$var$code = 65;
    else if ($2c344f86004a8679$var$code === 91) $2c344f86004a8679$var$code = 97;
}
$2c344f86004a8679$var$text[43] = $2c344f86004a8679$var$emailAutolink;
$2c344f86004a8679$var$text[45] = $2c344f86004a8679$var$emailAutolink;
$2c344f86004a8679$var$text[46] = $2c344f86004a8679$var$emailAutolink;
$2c344f86004a8679$var$text[95] = $2c344f86004a8679$var$emailAutolink;
$2c344f86004a8679$var$text[72] = [
    $2c344f86004a8679$var$emailAutolink,
    $2c344f86004a8679$var$protocolAutolink
];
$2c344f86004a8679$var$text[104] = [
    $2c344f86004a8679$var$emailAutolink,
    $2c344f86004a8679$var$protocolAutolink
];
$2c344f86004a8679$var$text[87] = [
    $2c344f86004a8679$var$emailAutolink,
    $2c344f86004a8679$var$wwwAutolink
];
$2c344f86004a8679$var$text[119] = [
    $2c344f86004a8679$var$emailAutolink,
    $2c344f86004a8679$var$wwwAutolink
];
// To do: perform email autolink literals on events, afterwards.
// That’s where `markdown-rs` and `cmark-gfm` perform it.
// It should look for `@`, then for atext backwards, and then for a label
// forwards.
// To do: `mailto:`, `xmpp:` protocol as prefix.
/**
 * Email autolink literal.
 *
 * ```markdown
 * > | a contact@example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2c344f86004a8679$var$tokenizeEmailAutolink(effects, ok, nok) {
    const self = this;
    /** @type {boolean | undefined} */ let dot;
    /** @type {boolean} */ let data;
    return start;
    /**
   * Start of email autolink literal.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (!$2c344f86004a8679$var$gfmAtext(code) || !$2c344f86004a8679$var$previousEmail.call(self, self.previous) || $2c344f86004a8679$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter('literalAutolink');
        effects.enter('literalAutolinkEmail');
        return atext(code);
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function atext(code) {
        if ($2c344f86004a8679$var$gfmAtext(code)) {
            effects.consume(code);
            return atext;
        }
        if (code === 64) {
            effects.consume(code);
            return emailDomain;
        }
        return nok(code);
    }
    /**
   * In email domain.
   *
   * The reference code is a bit overly complex as it handles the `@`, of which
   * there may be just one.
   * Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L318>
   *
   * ```markdown
   * > | a contact@example.org b
   *               ^
   * ```
   *
   * @type {State}
   */ function emailDomain(code) {
        // Dot followed by alphanumerical (not `-` or `_`).
        if (code === 46) return effects.check($2c344f86004a8679$var$emailDomainDotTrail, emailDomainAfter, emailDomainDot)(code);
        // Alphanumerical, `-`, and `_`.
        if (code === 45 || code === 95 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) {
            data = true;
            effects.consume(code);
            return emailDomain;
        }
        // To do: `/` if xmpp.
        // Note: normally we’d truncate trailing punctuation from the link.
        // However, email autolink literals cannot contain any of those markers,
        // except for `.`, but that can only occur if it isn’t trailing.
        // So we can ignore truncating!
        return emailDomainAfter(code);
    }
    /**
   * In email domain, on dot that is not a trail.
   *
   * ```markdown
   * > | a contact@example.org b
   *                      ^
   * ```
   *
   * @type {State}
   */ function emailDomainDot(code) {
        effects.consume(code);
        dot = true;
        return emailDomain;
    }
    /**
   * After email domain.
   *
   * ```markdown
   * > | a contact@example.org b
   *                          ^
   * ```
   *
   * @type {State}
   */ function emailDomainAfter(code) {
        // Domain must not be empty, must include a dot, and must end in alphabetical.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L332>.
        if (data && dot && (0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(self.previous)) {
            effects.exit('literalAutolinkEmail');
            effects.exit('literalAutolink');
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * `www` autolink literal.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2c344f86004a8679$var$tokenizeWwwAutolink(effects, ok, nok) {
    const self = this;
    return wwwStart;
    /**
   * Start of www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function wwwStart(code) {
        if (code !== 87 && code !== 119 || !$2c344f86004a8679$var$previousWww.call(self, self.previous) || $2c344f86004a8679$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter('literalAutolink');
        effects.enter('literalAutolinkWww');
        // Note: we *check*, so we can discard the `www.` we parsed.
        // If it worked, we consider it as a part of the domain.
        return effects.check($2c344f86004a8679$var$wwwPrefix, effects.attempt($2c344f86004a8679$var$domain, effects.attempt($2c344f86004a8679$var$path, wwwAfter), nok), nok)(code);
    }
    /**
   * After a www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *                          ^
   * ```
   *
   * @type {State}
   */ function wwwAfter(code) {
        effects.exit('literalAutolinkWww');
        effects.exit('literalAutolink');
        return ok(code);
    }
}
/**
 * Protocol autolink literal.
 *
 * ```markdown
 * > | a https://example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2c344f86004a8679$var$tokenizeProtocolAutolink(effects, ok, nok) {
    const self = this;
    let buffer = '';
    let seen = false;
    return protocolStart;
    /**
   * Start of protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function protocolStart(code) {
        if ((code === 72 || code === 104) && $2c344f86004a8679$var$previousProtocol.call(self, self.previous) && !$2c344f86004a8679$var$previousUnbalanced(self.events)) {
            effects.enter('literalAutolink');
            effects.enter('literalAutolinkHttp');
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        return nok(code);
    }
    /**
   * In protocol.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^^^^^
   * ```
   *
   * @type {State}
   */ function protocolPrefixInside(code) {
        // `5` is size of `https`
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code) && buffer.length < 5) {
            // @ts-expect-error: definitely number.
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        if (code === 58) {
            const protocol = buffer.toLowerCase();
            if (protocol === 'http' || protocol === 'https') {
                effects.consume(code);
                return protocolSlashesInside;
            }
        }
        return nok(code);
    }
    /**
   * In slashes.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *           ^^
   * ```
   *
   * @type {State}
   */ function protocolSlashesInside(code) {
        if (code === 47) {
            effects.consume(code);
            if (seen) return afterProtocol;
            seen = true;
            return protocolSlashesInside;
        }
        return nok(code);
    }
    /**
   * After protocol, before domain.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *             ^
   * ```
   *
   * @type {State}
   */ function afterProtocol(code) {
        // To do: this is different from `markdown-rs`:
        // https://github.com/wooorm/markdown-rs/blob/b3a921c761309ae00a51fe348d8a43adbc54b518/src/construct/gfm_autolink_literal.rs#L172-L182
        return code === null || (0, $9a96cd0c036af4eb$export$67dbf494fc8394df)(code) || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) || (0, $9a96cd0c036af4eb$export$a0ff789c034ffdf4)(code) || (0, $9a96cd0c036af4eb$export$aa04114dd888a7a0)(code) ? nok(code) : effects.attempt($2c344f86004a8679$var$domain, effects.attempt($2c344f86004a8679$var$path, protocolAfter), nok)(code);
    }
    /**
   * After a protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *                              ^
   * ```
   *
   * @type {State}
   */ function protocolAfter(code) {
        effects.exit('literalAutolinkHttp');
        effects.exit('literalAutolink');
        return ok(code);
    }
}
/**
 * `www` prefix.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2c344f86004a8679$var$tokenizeWwwPrefix(effects, ok, nok) {
    let size = 0;
    return wwwPrefixInside;
    /**
   * In www prefix.
   *
   * ```markdown
   * > | www.example.com
   *     ^^^^
   * ```
   *
   * @type {State}
   */ function wwwPrefixInside(code) {
        if ((code === 87 || code === 119) && size < 3) {
            size++;
            effects.consume(code);
            return wwwPrefixInside;
        }
        if (code === 46 && size === 3) {
            effects.consume(code);
            return wwwPrefixAfter;
        }
        return nok(code);
    }
    /**
   * After www prefix.
   *
   * ```markdown
   * > | www.example.com
   *         ^
   * ```
   *
   * @type {State}
   */ function wwwPrefixAfter(code) {
        // If there is *anything*, we can link.
        return code === null ? nok(code) : ok(code);
    }
}
/**
 * Domain.
 *
 * ```markdown
 * > | a https://example.org b
 *               ^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2c344f86004a8679$var$tokenizeDomain(effects, ok, nok) {
    /** @type {boolean | undefined} */ let underscoreInLastSegment;
    /** @type {boolean | undefined} */ let underscoreInLastLastSegment;
    /** @type {boolean | undefined} */ let seen;
    return domainInside;
    /**
   * In domain.
   *
   * ```markdown
   * > | https://example.com/a
   *             ^^^^^^^^^^^
   * ```
   *
   * @type {State}
   */ function domainInside(code) {
        // Check whether this marker, which is a trailing punctuation
        // marker, optionally followed by more trailing markers, and then
        // followed by an end.
        if (code === 46 || code === 95) return effects.check($2c344f86004a8679$var$trail, domainAfter, domainAtPunctuation)(code);
        // GH documents that only alphanumerics (other than `-`, `.`, and `_`) can
        // occur, which sounds like ASCII only, but they also support `www.點看.com`,
        // so that’s Unicode.
        // Instead of some new production for Unicode alphanumerics, markdown
        // already has that for Unicode punctuation and whitespace, so use those.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L12>.
        if (code === null || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) || (0, $9a96cd0c036af4eb$export$a0ff789c034ffdf4)(code) || code !== 45 && (0, $9a96cd0c036af4eb$export$aa04114dd888a7a0)(code)) return domainAfter(code);
        seen = true;
        effects.consume(code);
        return domainInside;
    }
    /**
   * In domain, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com
   *                    ^
   * ```
   *
   * @type {State}
   */ function domainAtPunctuation(code) {
        // There is an underscore in the last segment of the domain
        if (code === 95) underscoreInLastSegment = true;
        else {
            underscoreInLastLastSegment = underscoreInLastSegment;
            underscoreInLastSegment = undefined;
        }
        effects.consume(code);
        return domainInside;
    }
    /**
   * After domain.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^
   * ```
   *
   * @type {State} */ function domainAfter(code) {
        // Note: that’s GH says a dot is needed, but it’s not true:
        // <https://github.com/github/cmark-gfm/issues/279>
        if (underscoreInLastLastSegment || underscoreInLastSegment || !seen) return nok(code);
        return ok(code);
    }
}
/**
 * Path.
 *
 * ```markdown
 * > | a https://example.org/stuff b
 *                          ^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2c344f86004a8679$var$tokenizePath(effects, ok) {
    let sizeOpen = 0;
    let sizeClose = 0;
    return pathInside;
    /**
   * In path.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^^
   * ```
   *
   * @type {State}
   */ function pathInside(code) {
        if (code === 40) {
            sizeOpen++;
            effects.consume(code);
            return pathInside;
        }
        // To do: `markdown-rs` also needs this.
        // If this is a paren, and there are less closings than openings,
        // we don’t check for a trail.
        if (code === 41 && sizeClose < sizeOpen) return pathAtPunctuation(code);
        // Check whether this trailing punctuation marker is optionally
        // followed by more trailing markers, and then followed
        // by an end.
        if (code === 33 || code === 34 || code === 38 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 60 || code === 63 || code === 93 || code === 95 || code === 126) return effects.check($2c344f86004a8679$var$trail, ok, pathAtPunctuation)(code);
        if (code === null || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) || (0, $9a96cd0c036af4eb$export$a0ff789c034ffdf4)(code)) return ok(code);
        effects.consume(code);
        return pathInside;
    }
    /**
   * In path, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com/a"b
   *                          ^
   * ```
   *
   * @type {State}
   */ function pathAtPunctuation(code) {
        // Count closing parens.
        if (code === 41) sizeClose++;
        effects.consume(code);
        return pathInside;
    }
}
/**
 * Trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the entire trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | https://example.com").
 *                        ^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2c344f86004a8679$var$tokenizeTrail(effects, ok, nok) {
    return trail;
    /**
   * In trail of domain or path.
   *
   * ```markdown
   * > | https://example.com").
   *                        ^
   * ```
   *
   * @type {State}
   */ function trail(code) {
        // Regular trailing punctuation.
        if (code === 33 || code === 34 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 63 || code === 95 || code === 126) {
            effects.consume(code);
            return trail;
        }
        // `&` followed by one or more alphabeticals and then a `;`, is
        // as a whole considered as trailing punctuation.
        // In all other cases, it is considered as continuation of the URL.
        if (code === 38) {
            effects.consume(code);
            return trailCharacterReferenceStart;
        }
        // Needed because we allow literals after `[`, as we fix:
        // <https://github.com/github/cmark-gfm/issues/278>.
        // Check that it is not followed by `(` or `[`.
        if (code === 93) {
            effects.consume(code);
            return trailBracketAfter;
        }
        if (// `<` is an end.
        code === 60 || // So is whitespace.
        code === null || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) || (0, $9a96cd0c036af4eb$export$a0ff789c034ffdf4)(code)) return ok(code);
        return nok(code);
    }
    /**
   * In trail, after `]`.
   *
   * > 👉 **Note**: this deviates from `cmark-gfm` to fix a bug.
   * > See end of <https://github.com/github/cmark-gfm/issues/278> for more.
   *
   * ```markdown
   * > | https://example.com](
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailBracketAfter(code) {
        // Whitespace or something that could start a resource or reference is the end.
        // Switch back to trail otherwise.
        if (code === null || code === 40 || code === 91 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) || (0, $9a96cd0c036af4eb$export$a0ff789c034ffdf4)(code)) return ok(code);
        return trail(code);
    }
    /**
   * In character-reference like trail, after `&`.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharacterReferenceStart(code) {
        // When non-alpha, it’s not a trail.
        return (0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code) ? trailCharacterReferenceInside(code) : nok(code);
    }
    /**
   * In character-reference like trail.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharacterReferenceInside(code) {
        // Switch back to trail if this is well-formed.
        if (code === 59) {
            effects.consume(code);
            return trail;
        }
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return trailCharacterReferenceInside;
        }
        // It’s not a trail.
        return nok(code);
    }
}
/**
 * Dot in email domain trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | contact@example.org.
 *                        ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2c344f86004a8679$var$tokenizeEmailDomainDotTrail(effects, ok, nok) {
    return start;
    /**
   * Dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                    ^   ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Must be dot.
        effects.consume(code);
        return after;
    }
    /**
   * After dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                     ^   ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Not a trail if alphanumeric.
        return (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code) ? nok(code) : ok(code);
    }
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L156>.
 *
 * @type {Previous}
 */ function $2c344f86004a8679$var$previousWww(code) {
    return code === null || code === 40 || code === 42 || code === 95 || code === 91 || code === 93 || code === 126 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code);
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L214>.
 *
 * @type {Previous}
 */ function $2c344f86004a8679$var$previousProtocol(code) {
    return !(0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code);
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $2c344f86004a8679$var$previousEmail(code) {
    // Do not allow a slash “inside” atext.
    // The reference code is a bit weird, but that’s what it results in.
    // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L307>.
    // Other than slash, every preceding character is allowed.
    return !(code === 47 || $2c344f86004a8679$var$gfmAtext(code));
}
/**
 * @param {Code} code
 * @returns {boolean}
 */ function $2c344f86004a8679$var$gfmAtext(code) {
    return code === 43 || code === 45 || code === 46 || code === 95 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code);
}
/**
 * @param {Array<Event>} events
 * @returns {boolean}
 */ function $2c344f86004a8679$var$previousUnbalanced(events) {
    let index = events.length;
    let result = false;
    while(index--){
        const token = events[index][1];
        if ((token.type === 'labelLink' || token.type === 'labelImage') && !token._balanced) {
            result = true;
            break;
        }
        // If we’ve seen this token, and it was marked as not having any unbalanced
        // bracket before it, we can exit.
        if (token._gfmAutolinkLiteralWalkedInto) {
            result = false;
            break;
        }
    }
    if (events.length > 0 && !result) // Mark the last token as “walked into” w/o finding
    // anything.
    events[events.length - 1][1]._gfmAutolinkLiteralWalkedInto = true;
    return result;
}

/**
 * @import {CompileContext, Handle, HtmlExtension, Token} from 'micromark-util-types'
 */ 
function $0682bb87e6ae324b$export$999603f1f1c3d2f9() {
    return {
        exit: {
            literalAutolinkEmail: $0682bb87e6ae324b$var$literalAutolinkEmail,
            literalAutolinkHttp: $0682bb87e6ae324b$var$literalAutolinkHttp,
            literalAutolinkWww: $0682bb87e6ae324b$var$literalAutolinkWww
        }
    };
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $0682bb87e6ae324b$var$literalAutolinkWww(token) {
    $0682bb87e6ae324b$var$anchorFromToken.call(this, token, 'http://');
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $0682bb87e6ae324b$var$literalAutolinkEmail(token) {
    $0682bb87e6ae324b$var$anchorFromToken.call(this, token, 'mailto:');
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $0682bb87e6ae324b$var$literalAutolinkHttp(token) {
    $0682bb87e6ae324b$var$anchorFromToken.call(this, token);
}
/**
 * @this CompileContext
 * @param {Token} token
 * @param {string | null | undefined} [protocol]
 * @returns {undefined}
 */ function $0682bb87e6ae324b$var$anchorFromToken(token, protocol) {
    const url = this.sliceSerialize(token);
    this.tag('<a href="' + (0, $b82d09afb4bbc7a9$export$d130a2d684099e5a)((protocol || '') + url) + '">');
    this.raw(this.encode(url));
    this.tag('</a>');
}


/**
 * @import {Event, Exiter, Extension, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 



const $f74b812b1b41bff1$var$indent = {
    tokenize: $f74b812b1b41bff1$var$tokenizeIndent,
    partial: true
};
function $f74b812b1b41bff1$export$c82499b6656305df() {
    /** @type {Extension} */ return {
        document: {
            [91]: {
                name: 'gfmFootnoteDefinition',
                tokenize: $f74b812b1b41bff1$var$tokenizeDefinitionStart,
                continuation: {
                    tokenize: $f74b812b1b41bff1$var$tokenizeDefinitionContinuation
                },
                exit: $f74b812b1b41bff1$var$gfmFootnoteDefinitionEnd
            }
        },
        text: {
            [91]: {
                name: 'gfmFootnoteCall',
                tokenize: $f74b812b1b41bff1$var$tokenizeGfmFootnoteCall
            },
            [93]: {
                name: 'gfmPotentialFootnoteCall',
                add: 'after',
                tokenize: $f74b812b1b41bff1$var$tokenizePotentialGfmFootnoteCall,
                resolveTo: $f74b812b1b41bff1$var$resolveToPotentialGfmFootnoteCall
            }
        }
    };
}
// To do: remove after micromark update.
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $f74b812b1b41bff1$var$tokenizePotentialGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {Token} */ let labelStart;
    // Find an opening.
    while(index--){
        const token = self.events[index][1];
        if (token.type === "labelImage") {
            labelStart = token;
            break;
        }
        // Exit if we’ve walked far enough.
        if (token.type === 'gfmFootnoteCall' || token.type === "labelLink" || token.type === "label" || token.type === "image" || token.type === "link") break;
    }
    return start;
    /**
   * @type {State}
   */ function start(code) {
        if (!labelStart || !labelStart._balanced) return nok(code);
        const id = (0, $c580fc709a668807$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        }));
        if (id.codePointAt(0) !== 94 || !defined.includes(id.slice(1))) return nok(code);
        effects.enter('gfmFootnoteCallLabelMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteCallLabelMarker');
        return ok(code);
    }
}
// To do: remove after micromark update.
/** @type {Resolver} */ function $f74b812b1b41bff1$var$resolveToPotentialGfmFootnoteCall(events, context) {
    let index = events.length;
    /** @type {Token | undefined} */ let labelStart;
    // Find an opening.
    while(index--)if (events[index][1].type === "labelImage" && events[index][0] === 'enter') {
        labelStart = events[index][1];
        break;
    }
    // Change the `labelImageMarker` to a `data`.
    events[index + 1][1].type = "data";
    events[index + 3][1].type = 'gfmFootnoteCallLabelMarker';
    // The whole (without `!`):
    /** @type {Token} */ const call = {
        type: 'gfmFootnoteCall',
        start: Object.assign({}, events[index + 3][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // The `^` marker
    /** @type {Token} */ const marker = {
        type: 'gfmFootnoteCallMarker',
        start: Object.assign({}, events[index + 3][1].end),
        end: Object.assign({}, events[index + 3][1].end)
    };
    // Increment the end 1 character.
    marker.end.column++;
    marker.end.offset++;
    marker.end._bufferIndex++;
    /** @type {Token} */ const string = {
        type: 'gfmFootnoteCallString',
        start: Object.assign({}, marker.end),
        end: Object.assign({}, events[events.length - 1][1].start)
    };
    /** @type {Token} */ const chunk = {
        type: "chunkString",
        contentType: 'string',
        start: Object.assign({}, string.start),
        end: Object.assign({}, string.end)
    };
    /** @type {Array<Event>} */ const replacement = [
        // Take the `labelImageMarker` (now `data`, the `!`)
        events[index + 1],
        events[index + 2],
        [
            'enter',
            call,
            context
        ],
        // The `[`
        events[index + 3],
        events[index + 4],
        // The `^`.
        [
            'enter',
            marker,
            context
        ],
        [
            'exit',
            marker,
            context
        ],
        // Everything in between.
        [
            'enter',
            string,
            context
        ],
        [
            'enter',
            chunk,
            context
        ],
        [
            'exit',
            chunk,
            context
        ],
        [
            'exit',
            string,
            context
        ],
        // The ending (`]`, properly parsed and labelled).
        events[events.length - 2],
        events[events.length - 1],
        [
            'exit',
            call,
            context
        ]
    ];
    events.splice(index, events.length - index + 1, ...replacement);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $f74b812b1b41bff1$var$tokenizeGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    let size = 0;
    /** @type {boolean} */ let data;
    // Note: the implementation of `markdown-rs` is different, because it houses
    // core *and* extensions in one project.
    // Therefore, it can include footnote logic inside `label-end`.
    // We can’t do that, but luckily, we can parse footnotes in a simpler way than
    // needed for labels.
    return start;
    /**
   * Start of footnote label.
   *
   * ```markdown
   * > | a [^b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('gfmFootnoteCall');
        effects.enter('gfmFootnoteCallLabelMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteCallLabelMarker');
        return callStart;
    }
    /**
   * After `[`, at `^`.
   *
   * ```markdown
   * > | a [^b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function callStart(code) {
        if (code !== 94) return nok(code);
        effects.enter('gfmFootnoteCallMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteCallMarker');
        effects.enter('gfmFootnoteCallString');
        effects.enter('chunkString').contentType = 'string';
        return callData;
    }
    /**
   * In label.
   *
   * ```markdown
   * > | a [^b] c
   *         ^
   * ```
   *
   * @type {State}
   */ function callData(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) return nok(code);
        if (code === 93) {
            effects.exit('chunkString');
            const token = effects.exit('gfmFootnoteCallString');
            if (!defined.includes((0, $c580fc709a668807$export$806d55e226cfcd08)(self.sliceSerialize(token)))) return nok(code);
            effects.enter('gfmFootnoteCallLabelMarker');
            effects.consume(code);
            effects.exit('gfmFootnoteCallLabelMarker');
            effects.exit('gfmFootnoteCall');
            return ok;
        }
        if (!(0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? callEscape : callData;
    }
    /**
   * On character after escape.
   *
   * ```markdown
   * > | a [^b\c] d
   *           ^
   * ```
   *
   * @type {State}
   */ function callEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return callData;
        }
        return callData(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $f74b812b1b41bff1$var$tokenizeDefinitionStart(effects, ok, nok) {
    const self = this;
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {string} */ let identifier;
    let size = 0;
    /** @type {boolean | undefined} */ let data;
    return start;
    /**
   * Start of GFM footnote definition.
   *
   * ```markdown
   * > | [^a]: b
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('gfmFootnoteDefinition')._container = true;
        effects.enter('gfmFootnoteDefinitionLabel');
        effects.enter('gfmFootnoteDefinitionLabelMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteDefinitionLabelMarker');
        return labelAtMarker;
    }
    /**
   * In label, at caret.
   *
   * ```markdown
   * > | [^a]: b
   *      ^
   * ```
   *
   * @type {State}
   */ function labelAtMarker(code) {
        if (code === 94) {
            effects.enter('gfmFootnoteDefinitionMarker');
            effects.consume(code);
            effects.exit('gfmFootnoteDefinitionMarker');
            effects.enter('gfmFootnoteDefinitionLabelString');
            effects.enter('chunkString').contentType = 'string';
            return labelInside;
        }
        return nok(code);
    }
    /**
   * In label.
   *
   * > 👉 **Note**: `cmark-gfm` prevents whitespace from occurring in footnote
   * > definition labels.
   *
   * ```markdown
   * > | [^a]: b
   *       ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) return nok(code);
        if (code === 93) {
            effects.exit('chunkString');
            const token = effects.exit('gfmFootnoteDefinitionLabelString');
            identifier = (0, $c580fc709a668807$export$806d55e226cfcd08)(self.sliceSerialize(token));
            effects.enter('gfmFootnoteDefinitionLabelMarker');
            effects.consume(code);
            effects.exit('gfmFootnoteDefinitionLabelMarker');
            effects.exit('gfmFootnoteDefinitionLabel');
            return labelAfter;
        }
        if (!(0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * > 👉 **Note**: `cmark-gfm` currently does not support escaped brackets:
   * > <https://github.com/github/cmark-gfm/issues/240>
   *
   * ```markdown
   * > | [^a\*b]: c
   *         ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
    /**
   * After definition label.
   *
   * ```markdown
   * > | [^a]: b
   *         ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        if (code === 58) {
            effects.enter('definitionMarker');
            effects.consume(code);
            effects.exit('definitionMarker');
            if (!defined.includes(identifier)) defined.push(identifier);
            // Any whitespace after the marker is eaten, forming indented code
            // is not possible.
            // No space is also fine, just like a block quote marker.
            return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, whitespaceAfter, 'gfmFootnoteDefinitionWhitespace');
        }
        return nok(code);
    }
    /**
   * After definition prefix.
   *
   * ```markdown
   * > | [^a]: b
   *           ^
   * ```
   *
   * @type {State}
   */ function whitespaceAfter(code) {
        // `markdown-rs` has a wrapping token for the prefix that is closed here.
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $f74b812b1b41bff1$var$tokenizeDefinitionContinuation(effects, ok, nok) {
    /// Start of footnote definition continuation.
    ///
    /// ```markdown
    ///   | [^a]: b
    /// > |     c
    ///     ^
    /// ```
    //
    // Either a blank line, which is okay, or an indented thing.
    return effects.check((0, $30b85425f5f538a1$export$d50d28ce3ab2a612), ok, effects.attempt($f74b812b1b41bff1$var$indent, ok, nok));
}
/** @type {Exiter} */ function $f74b812b1b41bff1$var$gfmFootnoteDefinitionEnd(effects) {
    effects.exit('gfmFootnoteDefinition');
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $f74b812b1b41bff1$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, afterPrefix, 'gfmFootnoteDefinitionIndent', 5);
    /**
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === 'gfmFootnoteDefinitionIndent' && tail[2].sliceSerialize(tail[1], true).length === 4 ? ok(code) : nok(code);
    }
}

/**
 * @import {HtmlOptions as Options} from 'micromark-extension-gfm-footnote'
 * @import {HtmlExtension} from 'micromark-util-types'
 */ 

const $e3a6d41f5be8d102$var$own = {}.hasOwnProperty;
/** @type {Options} */ const $e3a6d41f5be8d102$var$emptyOptions = {};
function $e3a6d41f5be8d102$export$a18c77a47f4154b6(referenceIndex, rereferenceIndex) {
    return 'Back to reference ' + (referenceIndex + 1) + (rereferenceIndex > 1 ? '-' + rereferenceIndex : '');
}
function $e3a6d41f5be8d102$export$a731a1f6cf81900c(options) {
    const config = options || $e3a6d41f5be8d102$var$emptyOptions;
    const label = config.label || 'Footnotes';
    const labelTagName = config.labelTagName || 'h2';
    const labelAttributes = config.labelAttributes === null || config.labelAttributes === undefined ? 'class="sr-only"' : config.labelAttributes;
    const backLabel = config.backLabel || $e3a6d41f5be8d102$export$a18c77a47f4154b6;
    const clobberPrefix = config.clobberPrefix === null || config.clobberPrefix === undefined ? 'user-content-' : config.clobberPrefix;
    return {
        enter: {
            gfmFootnoteDefinition () {
                const stack = this.getData('tightStack');
                stack.push(false);
            },
            gfmFootnoteDefinitionLabelString () {
                this.buffer();
            },
            gfmFootnoteCallString () {
                this.buffer();
            }
        },
        exit: {
            gfmFootnoteDefinition () {
                let definitions = this.getData('gfmFootnoteDefinitions');
                const footnoteStack = this.getData('gfmFootnoteDefinitionStack');
                const tightStack = this.getData('tightStack');
                const current = footnoteStack.pop();
                const value = this.resume();
                if (!definitions) this.setData('gfmFootnoteDefinitions', definitions = {});
                if (!$e3a6d41f5be8d102$var$own.call(definitions, current)) definitions[current] = value;
                tightStack.pop();
                this.setData('slurpOneLineEnding', true);
                // “Hack” to prevent a line ending from showing up if we’re in a definition in
                // an empty list item.
                this.setData('lastWasTag');
            },
            gfmFootnoteDefinitionLabelString (token) {
                let footnoteStack = this.getData('gfmFootnoteDefinitionStack');
                if (!footnoteStack) this.setData('gfmFootnoteDefinitionStack', footnoteStack = []);
                footnoteStack.push((0, $c580fc709a668807$export$806d55e226cfcd08)(this.sliceSerialize(token)));
                this.resume(); // Drop the label.
                this.buffer(); // Get ready for a value.
            },
            gfmFootnoteCallString (token) {
                let calls = this.getData('gfmFootnoteCallOrder');
                let counts = this.getData('gfmFootnoteCallCounts');
                const id = (0, $c580fc709a668807$export$806d55e226cfcd08)(this.sliceSerialize(token));
                /** @type {number} */ let counter;
                this.resume();
                if (!calls) this.setData('gfmFootnoteCallOrder', calls = []);
                if (!counts) this.setData('gfmFootnoteCallCounts', counts = {});
                const index = calls.indexOf(id);
                const safeId = (0, $b82d09afb4bbc7a9$export$d130a2d684099e5a)(id.toLowerCase());
                if (index === -1) {
                    calls.push(id);
                    counts[id] = 1;
                    counter = calls.length;
                } else {
                    counts[id]++;
                    counter = index + 1;
                }
                const reuseCounter = counts[id];
                this.tag('<sup><a href="#' + clobberPrefix + 'fn-' + safeId + '" id="' + clobberPrefix + 'fnref-' + safeId + (reuseCounter > 1 ? '-' + reuseCounter : '') + '" data-footnote-ref="" aria-describedby="footnote-label">' + String(counter) + '</a></sup>');
            },
            null () {
                const calls = this.getData('gfmFootnoteCallOrder') || [];
                const counts = this.getData('gfmFootnoteCallCounts') || {};
                const definitions = this.getData('gfmFootnoteDefinitions') || {};
                let index = -1;
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag('<section data-footnotes="" class="footnotes"><' + labelTagName + ' id="footnote-label"' + (labelAttributes ? ' ' + labelAttributes : '') + '>');
                    this.raw(this.encode(label));
                    this.tag('</' + labelTagName + '>');
                    this.lineEndingIfNeeded();
                    this.tag('<ol>');
                }
                while(++index < calls.length){
                    // Called definitions are always defined.
                    const id = calls[index];
                    const safeId = (0, $b82d09afb4bbc7a9$export$d130a2d684099e5a)(id.toLowerCase());
                    let referenceIndex = 0;
                    /** @type {Array<string>} */ const references = [];
                    while(++referenceIndex <= counts[id])references.push('<a href="#' + clobberPrefix + 'fnref-' + safeId + (referenceIndex > 1 ? '-' + referenceIndex : '') + '" data-footnote-backref="" aria-label="' + this.encode(typeof backLabel === 'string' ? backLabel : backLabel(index, referenceIndex)) + '" class="data-footnote-backref">\u21A9' + (referenceIndex > 1 ? '<sup>' + referenceIndex + '</sup>' : '') + '</a>');
                    const reference = references.join(' ');
                    let injected = false;
                    this.lineEndingIfNeeded();
                    this.tag('<li id="' + clobberPrefix + 'fn-' + safeId + '">');
                    this.lineEndingIfNeeded();
                    this.tag(definitions[id].replace(/<\/p>(?:\r?\n|\r)?$/, function($0) {
                        injected = true;
                        return ' ' + reference + $0;
                    }));
                    if (!injected) {
                        this.lineEndingIfNeeded();
                        this.tag(reference);
                    }
                    this.lineEndingIfNeeded();
                    this.tag('</li>');
                }
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag('</ol>');
                    this.lineEndingIfNeeded();
                    this.tag('</section>');
                }
            }
        }
    };
}


/**
 * @import {Options} from 'micromark-extension-gfm-strikethrough'
 * @import {Event, Extension, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 


function $0f83fff5c7ab5a13$export$8bbec8ea1400a00e(options) {
    const options_ = options || {};
    let single = options_.singleTilde;
    const tokenizer = {
        name: 'strikethrough',
        tokenize: tokenizeStrikethrough,
        resolveAll: resolveAllStrikethrough
    };
    if (single === null || single === undefined) single = true;
    return {
        text: {
            [126]: tokenizer
        },
        insideSpan: {
            null: [
                tokenizer
            ]
        },
        attentionMarkers: {
            null: [
                126
            ]
        }
    };
    /**
   * Take events and resolve strikethrough.
   *
   * @type {Resolver}
   */ function resolveAllStrikethrough(events, context) {
        let index = -1;
        // Walk through all events.
        while(++index < events.length)// Find a token that can close.
        if (events[index][0] === 'enter' && events[index][1].type === 'strikethroughSequenceTemporary' && events[index][1]._close) {
            let open = index;
            // Now walk back to find an opener.
            while(open--)// Find a token that can open the closer.
            if (events[open][0] === 'exit' && events[open][1].type === 'strikethroughSequenceTemporary' && events[open][1]._open && // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
                events[index][1].type = 'strikethroughSequence';
                events[open][1].type = 'strikethroughSequence';
                /** @type {Token} */ const strikethrough = {
                    type: 'strikethrough',
                    start: Object.assign({}, events[open][1].start),
                    end: Object.assign({}, events[index][1].end)
                };
                /** @type {Token} */ const text = {
                    type: 'strikethroughText',
                    start: Object.assign({}, events[open][1].end),
                    end: Object.assign({}, events[index][1].start)
                };
                // Opening.
                /** @type {Array<Event>} */ const nextEvents = [
                    [
                        'enter',
                        strikethrough,
                        context
                    ],
                    [
                        'enter',
                        events[open][1],
                        context
                    ],
                    [
                        'exit',
                        events[open][1],
                        context
                    ],
                    [
                        'enter',
                        text,
                        context
                    ]
                ];
                const insideSpan = context.parser.constructs.insideSpan.null;
                if (insideSpan) // Between.
                (0, $6d957c9e6a169a49$export$869882364835d202)(nextEvents, nextEvents.length, 0, (0, $a0bda62677f8e9a6$export$3ff61ec196ff408b)(insideSpan, events.slice(open + 1, index), context));
                // Closing.
                (0, $6d957c9e6a169a49$export$869882364835d202)(nextEvents, nextEvents.length, 0, [
                    [
                        'exit',
                        text,
                        context
                    ],
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        strikethrough,
                        context
                    ]
                ]);
                (0, $6d957c9e6a169a49$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
                index = open + nextEvents.length - 2;
                break;
            }
        }
        index = -1;
        while(++index < events.length)if (events[index][1].type === 'strikethroughSequenceTemporary') events[index][1].type = "data";
        return events;
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeStrikethrough(effects, ok, nok) {
        const previous = this.previous;
        const events = this.events;
        let size = 0;
        return start;
        /** @type {State} */ function start(code) {
            if (previous === 126 && events[events.length - 1][1].type !== "characterEscape") return nok(code);
            effects.enter('strikethroughSequenceTemporary');
            return more(code);
        }
        /** @type {State} */ function more(code) {
            const before = (0, $cae7fc7dfc0e8dc7$export$e3902bc0d835cad0)(previous);
            if (code === 126) {
                // If this is the third marker, exit.
                if (size > 1) return nok(code);
                effects.consume(code);
                size++;
                return more;
            }
            if (size < 2 && !single) return nok(code);
            const token = effects.exit('strikethroughSequenceTemporary');
            const after = (0, $cae7fc7dfc0e8dc7$export$e3902bc0d835cad0)(code);
            token._open = !after || after === 2 && Boolean(before);
            token._close = !before || before === 2 && Boolean(after);
            return ok(code);
        }
    }
}

/**
 * @import {HtmlExtension} from 'micromark-util-types'
 */ /**
 * Create an HTML extension for `micromark` to support GFM strikethrough when
 * serializing to HTML.
 *
 * @returns {HtmlExtension}
 *   Extension for `micromark` that can be passed in `htmlExtensions`, to
 *   support GFM strikethrough when serializing to HTML.
 */ function $5d0cc46fa6aace08$export$58acedca46108820() {
    return {
        enter: {
            strikethrough () {
                this.tag('<del>');
            }
        },
        exit: {
            strikethrough () {
                this.tag('</del>');
            }
        }
    };
}


/**
 * @import {Event, Extension, Point, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ /**
 * @typedef {[number, number, number, number]} Range
 *   Cell info.
 *
 * @typedef {0 | 1 | 2 | 3} RowKind
 *   Where we are: `1` for head row, `2` for delimiter row, `3` for body row.
 */ 

/**
 * @import {Event} from 'micromark-util-types'
 */ // Port of `edit_map.rs` from `markdown-rs`.
// This should move to `markdown-js` later.
// Deal with several changes in events, batching them together.
//
// Preferably, changes should be kept to a minimum.
// Sometimes, it’s needed to change the list of events, because parsing can be
// messy, and it helps to expose a cleaner interface of events to the compiler
// and other users.
// It can also help to merge many adjacent similar events.
// And, in other cases, it’s needed to parse subcontent: pass some events
// through another tokenizer and inject the result.
/**
 * @typedef {[number, number, Array<Event>]} Change
 * @typedef {[number, number, number]} Jump
 */ /**
 * Tracks a bunch of edits.
 */ class $fb088f9b3e1902f4$export$9348908dd4518b4a {
    /**
   * Create a new edit map.
   */ constructor(){
        /**
     * Record of changes.
     *
     * @type {Array<Change>}
     */ this.map = [];
    }
    /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */ add(index, remove, add) {
        $fb088f9b3e1902f4$var$addImplementation(this, index, remove, add);
    }
    // To do: add this when moving to `micromark`.
    // /**
    //  * Create an edit: but insert `add` before existing additions.
    //  *
    //  * @param {number} index
    //  * @param {number} remove
    //  * @param {Array<Event>} add
    //  * @returns {undefined}
    //  */
    // addBefore(index, remove, add) {
    //   addImplementation(this, index, remove, add, true)
    // }
    /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */ consume(events) {
        this.map.sort(function(a, b) {
            return a[0] - b[0];
        });
        /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (this.map.length === 0) return;
        // To do: if links are added in events, like they are in `markdown-rs`,
        // this is needed.
        // // Calculate jumps: where items in the current list move to.
        // /** @type {Array<Jump>} */
        // const jumps = []
        // let index = 0
        // let addAcc = 0
        // let removeAcc = 0
        // while (index < this.map.length) {
        //   const [at, remove, add] = this.map[index]
        //   removeAcc += remove
        //   addAcc += add.length
        //   jumps.push([at, removeAcc, addAcc])
        //   index += 1
        // }
        //
        // . shiftLinks(events, jumps)
        let index = this.map.length;
        /** @type {Array<Array<Event>>} */ const vecs = [];
        while(index > 0){
            index -= 1;
            vecs.push(events.slice(this.map[index][0] + this.map[index][1]), this.map[index][2]);
            // Truncate rest.
            events.length = this.map[index][0];
        }
        vecs.push(events.slice());
        events.length = 0;
        let slice = vecs.pop();
        while(slice){
            for (const element of slice)events.push(element);
            slice = vecs.pop();
        }
        // Truncate everything.
        this.map.length = 0;
    }
}
/**
 * Create an edit.
 *
 * @param {EditMap} editMap
 * @param {number} at
 * @param {number} remove
 * @param {Array<Event>} add
 * @returns {undefined}
 */ function $fb088f9b3e1902f4$var$addImplementation(editMap, at, remove, add) {
    let index = 0;
    /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (remove === 0 && add.length === 0) return;
    while(index < editMap.map.length){
        if (editMap.map[index][0] === at) {
            editMap.map[index][1] += remove;
            // To do: before not used by tables, use when moving to micromark.
            // if (before) {
            //   add.push(...editMap.map[index][2])
            //   editMap.map[index][2] = add
            // } else {
            editMap.map[index][2].push(...add);
            // }
            return;
        }
        index += 1;
    }
    editMap.map.push([
        at,
        remove,
        add
    ]);
} // /**
 //  * Shift `previous` and `next` links according to `jumps`.
 //  *
 //  * This fixes links in case there are events removed or added between them.
 //  *
 //  * @param {Array<Event>} events
 //  * @param {Array<Jump>} jumps
 //  */
 // function shiftLinks(events, jumps) {
 //   let jumpIndex = 0
 //   let index = 0
 //   let add = 0
 //   let rm = 0
 //   while (index < events.length) {
 //     const rmCurr = rm
 //     while (jumpIndex < jumps.length && jumps[jumpIndex][0] <= index) {
 //       add = jumps[jumpIndex][2]
 //       rm = jumps[jumpIndex][1]
 //       jumpIndex += 1
 //     }
 //     // Ignore items that will be removed.
 //     if (rm > rmCurr) {
 //       index += rm - rmCurr
 //     } else {
 //       // ?
 //       // if let Some(link) = &events[index].link {
 //       //     if let Some(next) = link.next {
 //       //         events[next].link.as_mut().unwrap().previous = Some(index + add - rm);
 //       //         while jumpIndex < jumps.len() && jumps[jumpIndex].0 <= next {
 //       //             add = jumps[jumpIndex].2;
 //       //             rm = jumps[jumpIndex].1;
 //       //             jumpIndex += 1;
 //       //         }
 //       //         events[index].link.as_mut().unwrap().next = Some(next + add - rm);
 //       //         index = next;
 //       //         continue;
 //       //     }
 //       // }
 //       index += 1
 //     }
 //   }
 // }


/**
 * @import {Event} from 'micromark-util-types'
 */ /**
 * @typedef {'center' | 'left' | 'none' | 'right'} Align
 */ /**
 * Figure out the alignment of a GFM table.
 *
 * @param {Readonly<Array<Event>>} events
 *   List of events.
 * @param {number} index
 *   Table enter event.
 * @returns {Array<Align>}
 *   List of aligns.
 */ function $b6d029dbee6a13e7$export$bbf4fe2c547a4878(events, index) {
    let inDelimiterRow = false;
    /** @type {Array<Align>} */ const align = [];
    while(index < events.length){
        const event = events[index];
        if (inDelimiterRow) {
            if (event[0] === 'enter') // Start of alignment value: set a new column.
            // To do: `markdown-rs` uses `tableDelimiterCellValue`.
            {
                if (event[1].type === 'tableContent') align.push(events[index + 1][1].type === 'tableDelimiterMarker' ? 'left' : 'none');
            } else if (event[1].type === 'tableContent') {
                if (events[index - 1][1].type === 'tableDelimiterMarker') {
                    const alignIndex = align.length - 1;
                    align[alignIndex] = align[alignIndex] === 'left' ? 'center' : 'right';
                }
            } else if (event[1].type === 'tableDelimiterRow') break;
        } else if (event[0] === 'enter' && event[1].type === 'tableDelimiterRow') inDelimiterRow = true;
        index += 1;
    }
    return align;
}


function $fe86da6860750184$export$e36cebda627bf2dd() {
    return {
        flow: {
            null: {
                name: 'table',
                tokenize: $fe86da6860750184$var$tokenizeTable,
                resolveAll: $fe86da6860750184$var$resolveTable
            }
        }
    };
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $fe86da6860750184$var$tokenizeTable(effects, ok, nok) {
    const self = this;
    let size = 0;
    let sizeB = 0;
    /** @type {boolean | undefined} */ let seen;
    return start;
    /**
   * Start of a GFM table.
   *
   * If there is a valid table row or table head before, then we try to parse
   * another row.
   * Otherwise, we try to parse a head.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   * > | | b |
   *     ^
   * ```
   * @type {State}
   */ function start(code) {
        let index = self.events.length - 1;
        while(index > -1){
            const type = self.events[index][1].type;
            if (type === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
            type === "linePrefix") index--;
            else break;
        }
        const tail = index > -1 ? self.events[index][1].type : null;
        const next = tail === 'tableHead' || tail === 'tableRow' ? bodyRowStart : headRowBefore;
        // Don’t allow lazy body rows.
        if (next === bodyRowStart && self.parser.lazy[self.now().line]) return nok(code);
        return next(code);
    }
    /**
   * Before table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBefore(code) {
        effects.enter('tableHead');
        effects.enter('tableRow');
        return headRowStart(code);
    }
    /**
   * Before table head row, after whitespace.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowStart(code) {
        if (code === 124) return headRowBreak(code);
        // To do: micromark-js should let us parse our own whitespace in extensions,
        // like `markdown-rs`:
        //
        // ```js
        // // 4+ spaces.
        // if (markdownSpace(code)) {
        //   return nok(code)
        // }
        // ```
        seen = true;
        // Count the first character, that isn’t a pipe, double.
        sizeB += 1;
        return headRowBreak(code);
    }
    /**
   * At break in table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *       ^
   *         ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBreak(code) {
        if (code === null) // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            // If anything other than one pipe (ignoring whitespace) was used, it’s fine.
            if (sizeB > 1) {
                sizeB = 0;
                // To do: check if this works.
                // Feel free to interrupt:
                self.interrupt = true;
                effects.exit('tableRow');
                effects.enter("lineEnding");
                effects.consume(code);
                effects.exit("lineEnding");
                return headDelimiterStart;
            }
            // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
            return nok(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) // To do: check if this is fine.
        // effects.attempt(State::Next(StateName::GfmTableHeadRowBreak), State::Nok)
        // State::Retry(space_or_tab(tokenizer))
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, headRowBreak, "whitespace")(code);
        sizeB += 1;
        if (seen) {
            seen = false;
            // Header cell count.
            size += 1;
        }
        if (code === 124) {
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            // Whether a delimiter was seen.
            seen = true;
            return headRowBreak;
        }
        // Anything else is cell data.
        effects.enter("data");
        return headRowData(code);
    }
    /**
   * In table head row data.
   *
   * ```markdown
   * > | | a |
   *       ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowData(code) {
        if (code === null || code === 124 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return headRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? headRowEscape : headRowData;
    }
    /**
   * In table head row escape.
   *
   * ```markdown
   * > | | a\-b |
   *         ^
   *   | | ---- |
   *   | | c    |
   * ```
   *
   * @type {State}
   */ function headRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return headRowData;
        }
        return headRowData(code);
    }
    /**
   * Before delimiter row.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterStart(code) {
        // Reset `interrupt`.
        self.interrupt = false;
        // Note: in `markdown-rs`, we need to handle piercing here too.
        if (self.parser.lazy[self.now().line]) return nok(code);
        effects.enter('tableDelimiterRow');
        // Track if we’ve seen a `:` or `|`.
        seen = false;
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, headDelimiterBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return headDelimiterBefore(code);
    }
    /**
   * Before delimiter row, after optional whitespace.
   *
   * Reused when a `|` is found later, to parse another cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterBefore(code) {
        if (code === 45 || code === 58) return headDelimiterValueBefore(code);
        if (code === 124) {
            seen = true;
            // If we start with a pipe, we open a cell marker.
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            return headDelimiterCellBefore;
        }
        // More whitespace / empty row not allowed at start.
        return headDelimiterNok(code);
    }
    /**
   * After `|`, before delimiter cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *      ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellBefore(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, headDelimiterValueBefore, "whitespace")(code);
        return headDelimiterValueBefore(code);
    }
    /**
   * Before delimiter cell value.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterValueBefore(code) {
        // Align: left.
        if (code === 58) {
            sizeB += 1;
            seen = true;
            effects.enter('tableDelimiterMarker');
            effects.consume(code);
            effects.exit('tableDelimiterMarker');
            return headDelimiterLeftAlignmentAfter;
        }
        // Align: none.
        if (code === 45) {
            sizeB += 1;
            // To do: seems weird that this *isn’t* left aligned, but that state is used?
            return headDelimiterLeftAlignmentAfter(code);
        }
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return headDelimiterCellAfter(code);
        return headDelimiterNok(code);
    }
    /**
   * After delimiter cell left alignment marker.
   *
   * ```markdown
   *   | | a  |
   * > | | :- |
   *        ^
   * ```
   *
   * @type {State}
   */ function headDelimiterLeftAlignmentAfter(code) {
        if (code === 45) {
            effects.enter('tableDelimiterFiller');
            return headDelimiterFiller(code);
        }
        // Anything else is not ok after the left-align colon.
        return headDelimiterNok(code);
    }
    /**
   * In delimiter cell filler.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterFiller(code) {
        if (code === 45) {
            effects.consume(code);
            return headDelimiterFiller;
        }
        // Align is `center` if it was `left`, `right` otherwise.
        if (code === 58) {
            seen = true;
            effects.exit('tableDelimiterFiller');
            effects.enter('tableDelimiterMarker');
            effects.consume(code);
            effects.exit('tableDelimiterMarker');
            return headDelimiterRightAlignmentAfter;
        }
        effects.exit('tableDelimiterFiller');
        return headDelimiterRightAlignmentAfter(code);
    }
    /**
   * After delimiter cell right alignment marker.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *         ^
   * ```
   *
   * @type {State}
   */ function headDelimiterRightAlignmentAfter(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, headDelimiterCellAfter, "whitespace")(code);
        return headDelimiterCellAfter(code);
    }
    /**
   * After delimiter cell.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *          ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellAfter(code) {
        if (code === 124) return headDelimiterBefore(code);
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            // Exit when:
            // * there was no `:` or `|` at all (it’s a thematic break or setext
            //   underline instead)
            // * the header cell count is not the delimiter cell count
            if (!seen || size !== sizeB) return headDelimiterNok(code);
            // Note: in markdown-rs`, a reset is needed here.
            effects.exit('tableDelimiterRow');
            effects.exit('tableHead');
            // To do: in `markdown-rs`, resolvers need to be registered manually.
            // effects.register_resolver(ResolveName::GfmTable)
            return ok(code);
        }
        return headDelimiterNok(code);
    }
    /**
   * In delimiter row, at a disallowed byte.
   *
   * ```markdown
   *   | | a |
   * > | | x |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterNok(code) {
        // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
    }
    /**
   * Before table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   * ```
   *
   * @type {State}
   */ function bodyRowStart(code) {
        // Note: in `markdown-rs` we need to manually take care of a prefix,
        // but in `micromark-js` that is done for us, so if we’re here, we’re
        // never at whitespace.
        effects.enter('tableRow');
        return bodyRowBreak(code);
    }
    /**
   * At break in table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   *       ^
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowBreak(code) {
        if (code === 124) {
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            return bodyRowBreak;
        }
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit('tableRow');
            return ok(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, bodyRowBreak, "whitespace")(code);
        // Anything else is cell content.
        effects.enter("data");
        return bodyRowData(code);
    }
    /**
   * In table body row data.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *       ^
   * ```
   *
   * @type {State}
   */ function bodyRowData(code) {
        if (code === null || code === 124 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return bodyRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? bodyRowEscape : bodyRowData;
    }
    /**
   * In table body row escape.
   *
   * ```markdown
   *   | | a    |
   *   | | ---- |
   * > | | b\-c |
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return bodyRowData;
        }
        return bodyRowData(code);
    }
}
/** @type {Resolver} */ function $fe86da6860750184$var$resolveTable(events, context) {
    let index = -1;
    let inFirstCellAwaitingPipe = true;
    /** @type {RowKind} */ let rowKind = 0;
    /** @type {Range} */ let lastCell = [
        0,
        0,
        0,
        0
    ];
    /** @type {Range} */ let cell = [
        0,
        0,
        0,
        0
    ];
    let afterHeadAwaitingFirstBodyRow = false;
    let lastTableEnd = 0;
    /** @type {Token | undefined} */ let currentTable;
    /** @type {Token | undefined} */ let currentBody;
    /** @type {Token | undefined} */ let currentCell;
    const map = new (0, $fb088f9b3e1902f4$export$9348908dd4518b4a)();
    while(++index < events.length){
        const event = events[index];
        const token = event[1];
        if (event[0] === 'enter') {
            // Start of head.
            if (token.type === 'tableHead') {
                afterHeadAwaitingFirstBodyRow = false;
                // Inject previous (body end and) table end.
                if (lastTableEnd !== 0) {
                    $fe86da6860750184$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
                    currentBody = undefined;
                    lastTableEnd = 0;
                }
                // Inject table start.
                currentTable = {
                    type: 'table',
                    start: Object.assign({}, token.start),
                    // Note: correct end is set later.
                    end: Object.assign({}, token.end)
                };
                map.add(index, 0, [
                    [
                        'enter',
                        currentTable,
                        context
                    ]
                ]);
            } else if (token.type === 'tableRow' || token.type === 'tableDelimiterRow') {
                inFirstCellAwaitingPipe = true;
                currentCell = undefined;
                lastCell = [
                    0,
                    0,
                    0,
                    0
                ];
                cell = [
                    0,
                    index + 1,
                    0,
                    0
                ];
                // Inject table body start.
                if (afterHeadAwaitingFirstBodyRow) {
                    afterHeadAwaitingFirstBodyRow = false;
                    currentBody = {
                        type: 'tableBody',
                        start: Object.assign({}, token.start),
                        // Note: correct end is set later.
                        end: Object.assign({}, token.end)
                    };
                    map.add(index, 0, [
                        [
                            'enter',
                            currentBody,
                            context
                        ]
                    ]);
                }
                rowKind = token.type === 'tableDelimiterRow' ? 2 : currentBody ? 3 : 1;
            } else if (rowKind && (token.type === "data" || token.type === 'tableDelimiterMarker' || token.type === 'tableDelimiterFiller')) {
                inFirstCellAwaitingPipe = false;
                // First value in cell.
                if (cell[2] === 0) {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $fe86da6860750184$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                        lastCell = [
                            0,
                            0,
                            0,
                            0
                        ];
                    }
                    cell[2] = index;
                }
            } else if (token.type === 'tableCellDivider') {
                if (inFirstCellAwaitingPipe) inFirstCellAwaitingPipe = false;
                else {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $fe86da6860750184$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                    }
                    lastCell = cell;
                    cell = [
                        lastCell[1],
                        index,
                        0,
                        0
                    ];
                }
            }
        } else if (token.type === 'tableHead') {
            afterHeadAwaitingFirstBodyRow = true;
            lastTableEnd = index;
        } else if (token.type === 'tableRow' || token.type === 'tableDelimiterRow') {
            lastTableEnd = index;
            if (lastCell[1] !== 0) {
                cell[0] = cell[1];
                currentCell = $fe86da6860750184$var$flushCell(map, context, lastCell, rowKind, index, currentCell);
            } else if (cell[1] !== 0) currentCell = $fe86da6860750184$var$flushCell(map, context, cell, rowKind, index, currentCell);
            rowKind = 0;
        } else if (rowKind && (token.type === "data" || token.type === 'tableDelimiterMarker' || token.type === 'tableDelimiterFiller')) cell[3] = index;
    }
    if (lastTableEnd !== 0) $fe86da6860750184$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
    map.consume(context.events);
    // To do: move this into `html`, when events are exposed there.
    // That’s what `markdown-rs` does.
    // That needs updates to `mdast-util-gfm-table`.
    index = -1;
    while(++index < context.events.length){
        const event = context.events[index];
        if (event[0] === 'enter' && event[1].type === 'table') event[1]._align = (0, $b6d029dbee6a13e7$export$bbf4fe2c547a4878)(context.events, index);
    }
    return events;
}
/**
 * Generate a cell.
 *
 * @param {EditMap} map
 * @param {Readonly<TokenizeContext>} context
 * @param {Readonly<Range>} range
 * @param {RowKind} rowKind
 * @param {number | undefined} rowEnd
 * @param {Token | undefined} previousCell
 * @returns {Token | undefined}
 */ // eslint-disable-next-line max-params
function $fe86da6860750184$var$flushCell(map, context, range, rowKind, rowEnd, previousCell) {
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCell' : 'tableCell'
    const groupName = rowKind === 1 ? 'tableHeader' : rowKind === 2 ? 'tableDelimiter' : 'tableData';
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCellValue' : 'tableCellText'
    const valueName = 'tableContent';
    // Insert an exit for the previous cell, if there is one.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //          ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[0] !== 0) {
        previousCell.end = Object.assign({}, $fe86da6860750184$var$getPoint(context.events, range[0]));
        map.add(range[0], 0, [
            [
                'exit',
                previousCell,
                context
            ]
        ]);
    }
    // Insert enter of this cell.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //           ^-- enter
    //           ^^^^-- this cell
    // ```
    const now = $fe86da6860750184$var$getPoint(context.events, range[1]);
    previousCell = {
        type: groupName,
        start: Object.assign({}, now),
        // Note: correct end is set later.
        end: Object.assign({}, now)
    };
    map.add(range[1], 0, [
        [
            'enter',
            previousCell,
            context
        ]
    ]);
    // Insert text start at first data start and end at last data end, and
    // remove events between.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //            ^-- enter
    //             ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[2] !== 0) {
        const relatedStart = $fe86da6860750184$var$getPoint(context.events, range[2]);
        const relatedEnd = $fe86da6860750184$var$getPoint(context.events, range[3]);
        /** @type {Token} */ const valueToken = {
            type: valueName,
            start: Object.assign({}, relatedStart),
            end: Object.assign({}, relatedEnd)
        };
        map.add(range[2], 0, [
            [
                'enter',
                valueToken,
                context
            ]
        ]);
        if (rowKind !== 2) {
            // Fix positional info on remaining events
            const start = context.events[range[2]];
            const end = context.events[range[3]];
            start[1].end = Object.assign({}, end[1].end);
            start[1].type = "chunkText";
            start[1].contentType = "text";
            // Remove if needed.
            if (range[3] > range[2] + 1) {
                const a = range[2] + 1;
                const b = range[3] - range[2] - 1;
                map.add(a, b, []);
            }
        }
        map.add(range[3] + 1, 0, [
            [
                'exit',
                valueToken,
                context
            ]
        ]);
    }
    // Insert an exit for the last cell, if at the row end.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //                    ^-- exit
    //               ^^^^^^-- this cell (the last one contains two “between” parts)
    // ```
    if (rowEnd !== undefined) {
        previousCell.end = Object.assign({}, $fe86da6860750184$var$getPoint(context.events, rowEnd));
        map.add(rowEnd, 0, [
            [
                'exit',
                previousCell,
                context
            ]
        ]);
        previousCell = undefined;
    }
    return previousCell;
}
/**
 * Generate table end (and table body end).
 *
 * @param {Readonly<EditMap>} map
 * @param {Readonly<TokenizeContext>} context
 * @param {number} index
 * @param {Token} table
 * @param {Token | undefined} tableBody
 */ // eslint-disable-next-line max-params
function $fe86da6860750184$var$flushTableEnd(map, context, index, table, tableBody) {
    /** @type {Array<Event>} */ const exits = [];
    const related = $fe86da6860750184$var$getPoint(context.events, index);
    if (tableBody) {
        tableBody.end = Object.assign({}, related);
        exits.push([
            'exit',
            tableBody,
            context
        ]);
    }
    table.end = Object.assign({}, related);
    exits.push([
        'exit',
        table,
        context
    ]);
    map.add(index + 1, 0, exits);
}
/**
 * @param {Readonly<Array<Event>>} events
 * @param {number} index
 * @returns {Readonly<Point>}
 */ function $fe86da6860750184$var$getPoint(events, index) {
    const event = events[index];
    const side = event[0] === 'enter' ? 'start' : 'end';
    return event[1][side];
}

/**
 * @import {HtmlExtension} from 'micromark-util-types'
 */ const $d05dddf934c23ce5$var$alignment = {
    none: '',
    left: ' align="left"',
    right: ' align="right"',
    center: ' align="center"'
};
function $d05dddf934c23ce5$export$c64626c032567c7f() {
    return {
        enter: {
            table (token) {
                const tableAlign = token._align;
                this.lineEndingIfNeeded();
                this.tag('<table>');
                this.setData('tableAlign', tableAlign);
            },
            tableBody () {
                this.tag('<tbody>');
            },
            tableData () {
                const tableAlign = this.getData('tableAlign');
                const tableColumn = this.getData('tableColumn');
                const align = $d05dddf934c23ce5$var$alignment[tableAlign[tableColumn]];
                if (align === undefined) // Capture results to ignore them.
                this.buffer();
                else {
                    this.lineEndingIfNeeded();
                    this.tag('<td' + align + '>');
                }
            },
            tableHead () {
                this.lineEndingIfNeeded();
                this.tag('<thead>');
            },
            tableHeader () {
                const tableAlign = this.getData('tableAlign');
                const tableColumn = this.getData('tableColumn');
                const align = $d05dddf934c23ce5$var$alignment[tableAlign[tableColumn]];
                this.lineEndingIfNeeded();
                this.tag('<th' + align + '>');
            },
            tableRow () {
                this.setData('tableColumn', 0);
                this.lineEndingIfNeeded();
                this.tag('<tr>');
            }
        },
        exit: {
            // Overwrite the default code text data handler to unescape escaped pipes when
            // they are in tables.
            codeTextData (token) {
                let value = this.sliceSerialize(token);
                if (this.getData('tableAlign')) value = value.replace(/\\([\\|])/g, $d05dddf934c23ce5$var$replace);
                this.raw(this.encode(value));
            },
            table () {
                this.setData('tableAlign');
                // Note: we don’t set `slurpAllLineEndings` anymore, in delimiter rows,
                // but we do need to reset it to match a funky newline GH generates for
                // list items combined with tables.
                this.setData('slurpAllLineEndings');
                this.lineEndingIfNeeded();
                this.tag('</table>');
            },
            tableBody () {
                this.lineEndingIfNeeded();
                this.tag('</tbody>');
            },
            tableData () {
                const tableAlign = this.getData('tableAlign');
                const tableColumn = this.getData('tableColumn');
                if (tableColumn in tableAlign) {
                    this.tag('</td>');
                    this.setData('tableColumn', tableColumn + 1);
                } else // Stop capturing.
                this.resume();
            },
            tableHead () {
                this.lineEndingIfNeeded();
                this.tag('</thead>');
            },
            tableHeader () {
                const tableColumn = this.getData('tableColumn');
                this.tag('</th>');
                this.setData('tableColumn', tableColumn + 1);
            },
            tableRow () {
                const tableAlign = this.getData('tableAlign');
                let tableColumn = this.getData('tableColumn');
                while(tableColumn < tableAlign.length){
                    this.lineEndingIfNeeded();
                    this.tag('<td' + $d05dddf934c23ce5$var$alignment[tableAlign[tableColumn]] + '></td>');
                    tableColumn++;
                }
                this.setData('tableColumn', tableColumn);
                this.lineEndingIfNeeded();
                this.tag('</tr>');
            }
        }
    };
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $d05dddf934c23ce5$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === '|' ? $1 : $0;
}


/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ // An opening or closing tag start, followed by a case-insensitive specific tag name,
// followed by HTML whitespace, a greater than, or a slash.
const $a41dbafcf7a614bf$var$reFlow = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|title|textarea|xmp)(?=[\t\n\f\r />])/gi;
// As HTML (text) parses tags separately (and very strictly), we don’t need to be
// global.
const $a41dbafcf7a614bf$var$reText = new RegExp('^' + $a41dbafcf7a614bf$var$reFlow.source, 'i');
function $a41dbafcf7a614bf$export$c9bf87ea36d00682() {
    return {
        exit: {
            htmlFlowData (token) {
                $a41dbafcf7a614bf$var$exitHtmlData.call(this, token, $a41dbafcf7a614bf$var$reFlow);
            },
            htmlTextData (token) {
                $a41dbafcf7a614bf$var$exitHtmlData.call(this, token, $a41dbafcf7a614bf$var$reText);
            }
        }
    };
}
/**
 * @this {CompileContext}
 * @param {Token} token
 * @param {RegExp} filter
 * @returns {undefined}
 */ function $a41dbafcf7a614bf$var$exitHtmlData(token, filter) {
    let value = this.sliceSerialize(token);
    if (this.options.allowDangerousHtml) value = value.replace(filter, '&lt;$1$2');
    this.raw(this.encode(value));
}


/**
 * @import {Extension, State, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 

const $783b238101f8100d$var$tasklistCheck = {
    name: 'tasklistCheck',
    tokenize: $783b238101f8100d$var$tokenizeTasklistCheck
};
function $783b238101f8100d$export$2912e8b2802475ff() {
    return {
        text: {
            [91]: $783b238101f8100d$var$tasklistCheck
        }
    };
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $783b238101f8100d$var$tokenizeTasklistCheck(effects, ok, nok) {
    const self = this;
    return open;
    /**
   * At start of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (// Exit if there’s stuff before.
        self.previous !== null || // Exit if not in the first content that is the first child of a list
        // item.
        !self._gfmTasklistFirstContentOfListItem) return nok(code);
        effects.enter('taskListCheck');
        effects.enter('taskListCheckMarker');
        effects.consume(code);
        effects.exit('taskListCheckMarker');
        return inside;
    }
    /**
   * In task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *        ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // Currently we match how GH works in files.
        // To match how GH works in comments, use `markdownSpace` (`[\t ]`) instead
        // of `markdownLineEndingOrSpace` (`[\t\n\r ]`).
        if ((0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) {
            effects.enter('taskListCheckValueUnchecked');
            effects.consume(code);
            effects.exit('taskListCheckValueUnchecked');
            return close;
        }
        if (code === 88 || code === 120) {
            effects.enter('taskListCheckValueChecked');
            effects.consume(code);
            effects.exit('taskListCheckValueChecked');
            return close;
        }
        return nok(code);
    }
    /**
   * At close of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *         ^
   * ```
   *
   * @type {State}
   */ function close(code) {
        if (code === 93) {
            effects.enter('taskListCheckMarker');
            effects.consume(code);
            effects.exit('taskListCheckMarker');
            effects.exit('taskListCheck');
            return after;
        }
        return nok(code);
    }
    /**
   * @type {State}
   */ function after(code) {
        // EOL in paragraph means there must be something else after it.
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return ok(code);
        // Space or tab?
        // Check what comes after.
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return effects.check({
            tokenize: $783b238101f8100d$var$spaceThenNonSpace
        }, ok, nok)(code);
        // EOF, or non-whitespace, both wrong.
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $783b238101f8100d$var$spaceThenNonSpace(effects, ok, nok) {
    return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, after, "whitespace");
    /**
   * After whitespace, after task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *           ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // EOF means there was nothing, so bad.
        // EOL means there’s content after it, so good.
        // Impossible to have more spaces.
        // Anything else is good.
        return code === null ? nok(code) : ok(code);
    }
}

/**
 * @import {HtmlExtension} from 'micromark-util-types'
 */ /**
 * Create an HTML extension for `micromark` to support GFM task list items when
 * serializing to HTML.
 *
 * @returns {HtmlExtension}
 *   Extension for `micromark` that can be passed in `htmlExtensions` to
 *   support GFM task list items when serializing to HTML.
 */ function $300c8f9ec1306002$export$4b6a13e2af1b08ed() {
    return {
        enter: {
            taskListCheck () {
                this.tag('<input type="checkbox" disabled="" ');
            }
        },
        exit: {
            taskListCheck () {
                this.tag('/>');
            },
            taskListCheckValueChecked () {
                this.tag('checked="" ');
            }
        }
    };
}


function $0e954356959e94f6$export$59ffe8c4d7a4aab2(options) {
    return (0, $1c4ab323543eb9b7$export$86a865d89ef3c690)([
        (0, $2c344f86004a8679$export$608123d9b549151)(),
        (0, $f74b812b1b41bff1$export$c82499b6656305df)(),
        (0, $0f83fff5c7ab5a13$export$8bbec8ea1400a00e)(options),
        (0, $fe86da6860750184$export$e36cebda627bf2dd)(),
        (0, $783b238101f8100d$export$2912e8b2802475ff)()
    ]);
}
function $0e954356959e94f6$export$6983b82e6105d62a(options) {
    return (0, $1c4ab323543eb9b7$export$eaf8c406dfb0a620)([
        (0, $0682bb87e6ae324b$export$999603f1f1c3d2f9)(),
        (0, $e3a6d41f5be8d102$export$a731a1f6cf81900c)(options),
        (0, $5d0cc46fa6aace08$export$58acedca46108820)(),
        (0, $d05dddf934c23ce5$export$c64626c032567c7f)(),
        (0, $a41dbafcf7a614bf$export$c9bf87ea36d00682)(),
        (0, $300c8f9ec1306002$export$4b6a13e2af1b08ed)()
    ]);
}


/** @type {Options} */ const $78aec921ddca40c1$var$emptyOptions = {};
function $78aec921ddca40c1$export$2e2bcd8739ae039(options) {
    // @ts-expect-error: TS is wrong about `this`.
    // eslint-disable-next-line unicorn/no-this-assignment
    const self = /** @type {Processor<Root>} */ this;
    const settings = options || $78aec921ddca40c1$var$emptyOptions;
    const data = self.data();
    const micromarkExtensions = data.micromarkExtensions || (data.micromarkExtensions = []);
    const fromMarkdownExtensions = data.fromMarkdownExtensions || (data.fromMarkdownExtensions = []);
    const toMarkdownExtensions = data.toMarkdownExtensions || (data.toMarkdownExtensions = []);
    micromarkExtensions.push((0, $0e954356959e94f6$export$59ffe8c4d7a4aab2)(settings));
    fromMarkdownExtensions.push((0, $fa527d008df0ac0a$export$95adae814eb7433e)());
    toMarkdownExtensions.push((0, $fa527d008df0ac0a$export$ea77de6901e7c72b)(settings));
}





const $10952db78fee7c4f$export$5c24b9f68c75af1d = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $09cf8ac2a6e57519$export$7460c8b7e4ce9582))`
    font-weight: 400;
    font-size: 1.313rem; // 21px
    color: ${(props)=>props.theme.color.textBody};
    line-height: 2rem; // 32px
    a {
        font-size: 1.125rem; // 18px
        line-height: 1.625rem; // 26px
        display: block;
        color: ${(props)=>props.theme.color.secondary};
        text-decoration: underline;
        :hover {
            color: ${(props)=>props.theme.color.secondary};
            text-decoration: none;
        }
    }
`;
const $10952db78fee7c4f$export$2def7183994512e9 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    ${(0, $b091aef3a32d2bd8$export$c29b4f740eefd6d8)};
    color: ${(props)=>props.theme.color.textBody};
    padding: 2rem 0;
    line-height: 2rem; // 32px
    & a,
    * a {
        font-size: 1.125rem; // 18px
        line-height: 1.625rem; // 26px
        display: block;
        color: ${(props)=>props.theme.color.link};
        text-decoration: underline;
        :hover {
            color: ${(props)=>props.theme.color.link};
            text-decoration: none;
        }
    }
    & code,
    * code {
        background-color: ${(props)=>props.theme.color.background + 90};
        font-family: 'Courier New', Courier, monospace;
    }
    & pre,
    * pre {
        overflow-x: auto;
        background-color: ${(props)=>props.theme.color.card};
        border-radius: 0.5rem;
        padding: 1rem 1rem 1rem 1rem !important;
    }
    & h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        color: ${(props)=>props.theme.color.text};
        font-weight: 900;
    }
    & h1 {
        ${(0, $b091aef3a32d2bd8$export$53e784b1f50184bf)};
    }
    & h2 {
        font-size: 1.75rem; // 28px
        line-height: 2.25rem; // 36px
    }
    & h3 {
        font-size: 1.5rem; // 24px
        line-height: 2rem; // 32px
    }
    & h4 {
        font-size: 1.25rem; // 20px
        line-height: 1.75rem; // 28px
    }
    & h5 {
        font-size: 1.125rem; // 18px
        line-height: 1.625rem; // 26px
    }
    & h6 {
        font-size: 1rem; // 16px
        line-height: 1.313rem; // 21px
    }
    & ul,
    ol,
    * ul,
    * ol {
        padding-left: 2rem;
    }
`;


const $c88a36d69c05f5c8$var$MarkdownLinkRenderer = (props)=>{
    if (props.href.startsWith('http')) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
        href: props.href,
        target: "_blank",
        rel: "noopener noreferrer",
        children: props.children
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
        href: props.href,
        children: props.children
    });
};
const $c88a36d69c05f5c8$var$NotificationCard = (props)=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const getRelativeTime = (0, $1e6a0781013949e7$export$2e2bcd8739ae039)();
    let { isRead: isRead, id: id, title: title, subtitle: subtitle, markdown: markdown, notificationType: notificationType, isDisabled: isDisabled, startDate: startDate } = props;
    const notificationContainer = (0, $3521ff40d609c2ed$export$2e2bcd8739ae039).useContainer();
    const handleMarkAsRead = ()=>{
        isRead = true;
        notificationContainer.markNotificationRead(id);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $12a7318cc7b914d5$export$4a703ded2a7a3e59), {
        "data-isread": isRead,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($c88a36d69c05f5c8$var$ContentWrap, {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$d9f4918700223049), {
                    as: "h2",
                    children: title
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$ea6aee68c7b1694f), {
                    children: subtitle
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $10952db78fee7c4f$export$2def7183994512e9), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $09cf8ac2a6e57519$export$7460c8b7e4ce9582), {
                        remarkPlugins: [
                            (0, $78aec921ddca40c1$export$2e2bcd8739ae039)
                        ],
                        components: {
                            a: $c88a36d69c05f5c8$var$MarkdownLinkRenderer
                        },
                        children: markdown
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $12a7318cc7b914d5$export$e30e93a3651e4e64), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $b091aef3a32d2bd8$export$a79389cfbe6f64d), {
                            children: [
                                "Posted: ",
                                getRelativeTime(new Date(startDate))
                            ]
                        }),
                        isRead ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$a79389cfbe6f64d), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                name: "read",
                                size: 16,
                                ariaLabel: t('common:notifications.seen')
                            })
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                            variant: "control",
                            disabled: isRead,
                            onClick: handleMarkAsRead,
                            children: isRead ? t('common:notifications.seen') : t('common:notifications.markAsRead')
                        })
                    ]
                })
            ]
        })
    });
};
const $c88a36d69c05f5c8$var$ContentWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039).div``;
var $c88a36d69c05f5c8$export$2e2bcd8739ae039 = $c88a36d69c05f5c8$var$NotificationCard;




const $5fd89f49783ce974$var$NotificationListing = ({ notifications: notifications })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    if (!notifications) return null;
    if (notifications.length < 1) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
        title: t('common:notifications.empty')
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        children: notifications.map((notification)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c88a36d69c05f5c8$export$2e2bcd8739ae039), {
                ...notification
            }, notification.id))
    });
};
var $5fd89f49783ce974$export$2e2bcd8739ae039 = $5fd89f49783ce974$var$NotificationListing;




function $9a22a8e524cd97e1$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { notifications: notifications } = (0, $3521ff40d609c2ed$export$2e2bcd8739ae039).useContainer();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:notifications.center'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5fd89f49783ce974$export$2e2bcd8739ae039), {
                notifications: notifications
            })
        ]
    });
}








const $3d257c68ce43608e$export$d79fc0b00008bd8d = 'https://cephable.com/pricing/#matrix';
const $3d257c68ce43608e$export$ed2c078912602c20 = {
    personal: {
        icon: {
            light: 'personalLogo',
            dark: 'personalLogoWhite'
        },
        title: 'common:billing.personal.titleLong',
        description: 'common:billing.personal.description',
        licenseType: 'personal'
    },
    isPlusAccess: {
        icon: {
            light: 'plusLogo',
            dark: 'plusLogoWhite'
        },
        title: 'common:billing.isPlusAccess.titleLong',
        description: 'common:billing.isPlusAccess.description',
        // trial: `${getBaseApiUrl()}/trial/plus`,
        licenseType: 'isPlusAccess'
    },
    isEmployeeAccess: {
        icon: {
            light: 'proLogo',
            dark: 'proLogoWhite'
        },
        title: 'common:billing.isEmployeeAccess.titleLong',
        description: 'common:billing.isEmployeeAccess.description',
        trial: `${(0, $07546889aef07ebc$export$df8e085683bf7fe4)()}/trial`,
        licenseType: 'isEmployeeAccess'
    },
    isStudentAccess: {
        icon: {
            light: 'eduLogo',
            dark: 'eduLogoWhite'
        },
        title: 'common:billing.isStudentAccess.titleLong',
        description: 'common:billing.isStudentAccess.description',
        // trial: `${getBaseApiUrl()}/trial/education`,
        licenseType: 'isStudentAccess'
    },
    isDeveloperAccess: {
        icon: {
            light: 'sdkLogo',
            dark: 'sdkLogoWhite'
        },
        title: 'common:billing.isDeveloperAccess.titleLong',
        description: 'common:billing.isDeveloperAccess.description',
        // trial: `${getBaseApiUrl()}/trial/developers`,
        licenseType: 'isDeveloperAccess'
    }
};
const $3d257c68ce43608e$export$3dc32300594beeaf = [
    'common:billing.isPlusAccess.supportedFeatures.features.0',
    'common:billing.isPlusAccess.supportedFeatures.features.1',
    'common:billing.isPlusAccess.supportedFeatures.features.2',
    'common:billing.isPlusAccess.supportedFeatures.features.3'
];






var $7fPBF = parcelRequire("7fPBF");












const $a5e039f9955fc75e$var$CardCenteredContent = ({ title: title, description: description, name: name, size: size = 50, children: children, ...restProps })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $347ffda0d89c401a$export$401042fa3f49d26), {
        ...restProps,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($a5e039f9955fc75e$var$CenteredCardText, {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                    name: name,
                    size: size,
                    ...restProps
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$2c65789109b698b0), {
                    children: title
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                    children: description
                }),
                children
            ]
        })
    });
};
const $a5e039f9955fc75e$var$CenteredCardText = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $347ffda0d89c401a$export$9de46b28c4f6c978))`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-grow: 1;
`;
var $a5e039f9955fc75e$export$2e2bcd8739ae039 = $a5e039f9955fc75e$var$CardCenteredContent;





var $7fPBF = parcelRequire("7fPBF");

function $fd9b8885d8abdd3b$export$2e2bcd8739ae039({ organizationId: organizationId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [showDialog, setShowDialog] = (0, $7fPBF.useState)(false);
    const currentUserContainer = (0, $8a1185b15e8317ab$export$2e2bcd8739ae039).useContainer();
    const onDialogCancel = ()=>{
        setShowDialog(false);
    };
    if (!currentUserContainer.currentUser?.isEmailVerified) return null;
    const description = organizationId ? t('common:license.activate.description') : t('common:license.activate.descriptionLong');
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a5e039f9955fc75e$export$2e2bcd8739ae039), {
                title: t('common:license.activate.title'),
                description: description,
                name: "orgAuthClient",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    $color: "secondary",
                    startIcon: "plusLight",
                    onClick: ()=>setShowDialog(true),
                    children: t('common:license.activate.button')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e26231f066199887$export$2e2bcd8739ae039), {
                open: showDialog,
                onCancel: onDialogCancel,
                organizationId: organizationId
            })
        ]
    });
}
















var $7fPBF = parcelRequire("7fPBF");


function $d0f22230e48d02ba$export$2e2bcd8739ae039({ licenseType: licenseType, size: size = 250, ...restProps }) {
    const { theme: theme } = (0, $7fPBF.useContext)((0, $c6dc2c2d62651942$export$2c657da244d00bd6));
    const isLightMode = theme === 'light';
    const iconName = isLightMode ? (0, $3d257c68ce43608e$export$ed2c078912602c20)[licenseType].icon.light : (0, $3d257c68ce43608e$export$ed2c078912602c20)[licenseType].icon.dark;
    const svgToRender = (0, $3adbcb77e640770e$export$6d49a893c897b0cc)[iconName] ?? null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d0f22230e48d02ba$var$IconContainer, {
        $size: size,
        ...restProps,
        children: [
            svgToRender,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30af349a5a5f3e57$export$2e2bcd8739ae039), {
                children: (0, $3d257c68ce43608e$export$ed2c078912602c20)[licenseType].title
            })
        ]
    });
}
const $d0f22230e48d02ba$var$IconContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039)('span')`
    color: ${(props)=>props.$color || 'inherit'};
    display: inline-block;
    line-height: 0;
    svg {
        width: ${(props)=>props.$size + 'px'};
        height: 100%;
    }
`;



function $d4c1fc4a3d4947e8$export$2e2bcd8739ae039({ product: product, purchaseOption: purchaseOption, supportedFeatures: supportedFeatures, statusText: statusText, $variant: $variant = 'default', organizationId: organizationId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const { hasNoOrgMemberships: hasNoOrgMemberships, userLicenseAccess: userLicenseAccess, userLicenseType: userLicenseType } = (0, $8a1185b15e8317ab$export$2e2bcd8739ae039).useContainer();
    // Determine if we should show trial upgrade option (ie Plus Trial -> Pro Trial)
    const currPriorityIdx = (0, $eec5c3b697f8e81e$export$9e1a6fca7c3450cd).indexOf(userLicenseType);
    const nextPriorityIdx = (0, $eec5c3b697f8e81e$export$9e1a6fca7c3450cd).indexOf(product.licenseType);
    const isTrialUpgrade = currPriorityIdx !== -1 && nextPriorityIdx !== -1 && nextPriorityIdx > currPriorityIdx;
    const showTrial = hasNoOrgMemberships || isTrialUpgrade;
    let label = t('common:billing.subscription.billedMonthly');
    if (purchaseOption?.type === 'yearly') label = t('common:billing.subscription.billedYearly');
    const onPurchaseClickForOrg = ()=>{
        // user has orgs
        navigate(`/`, {
            replace: true
        }); // reset current path to home page and then redirect to billing upgrade page
        if (userLicenseAccess?.hasLicense) navigate(`/org/${organizationId}/billing/redirect/upgrade/product/${purchaseOption?.productId}`);
        else navigate(`/org/${organizationId}/trial/redirect/upgrade/product/${purchaseOption?.productId}`);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $347ffda0d89c401a$export$401042fa3f49d26), {
        title: t(product.title),
        children: [
            statusText && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $347ffda0d89c401a$export$fd5345d4562e9833), {
                children: statusText
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d4c1fc4a3d4947e8$var$StyledIconWrap, {
                $variant: $variant,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d0f22230e48d02ba$export$2e2bcd8739ae039), {
                    licenseType: product.licenseType,
                    size: 150
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d4c1fc4a3d4947e8$var$StyledWrapCardText, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$2c65789109b698b0), {
                        children: t(product.title)
                    }),
                    purchaseOption && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $b091aef3a32d2bd8$export$5c3bdb37a55baa65), {
                        as: "p",
                        children: [
                            "$",
                            purchaseOption.price,
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$ddf9e902b54c6c8), {
                                as: "span",
                                children: label
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d4c1fc4a3d4947e8$var$FeatureWrap, {
                        children: supportedFeatures.map((sf, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d4c1fc4a3d4947e8$var$FeatureGroup, {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$a79389cfbe6f64d), {
                                        children: sf.tag
                                    }),
                                    sf.features.map((feature, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d4c1fc4a3d4947e8$var$FeatureItem, {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                    name: "check",
                                                    size: 16
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$1ef657600983666a), {
                                                    children: t(feature)
                                                })
                                            ]
                                        }, `feature_${feature}_${idx}`))
                                ]
                            }, `supportedFeature_${sf.tag}_${index}`))
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d4c1fc4a3d4947e8$var$Footer, {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d4c1fc4a3d4947e8$var$FooterLinks, {
                            children: [
                                purchaseOption && (hasNoOrgMemberships ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                    href: purchaseOption.defaultPaymentLink,
                                    target: "_blank",
                                    $color: "secondary",
                                    children: t('common:purchase')
                                }, 'purchaseLink') : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                    onClick: ()=>onPurchaseClickForOrg(),
                                    $color: "secondary",
                                    children: t('common:purchase')
                                }, 'purchaseLink')),
                                product.trial && showTrial && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                    href: product.trial,
                                    target: "_blank",
                                    $color: "simple",
                                    children: t('common:license.trial.start')
                                }, 'trialLink')
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
const $d4c1fc4a3d4947e8$var$Footer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    flex-grow: 1;
    width: 100%;
`;
const $d4c1fc4a3d4947e8$var$FooterLinks = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    align-items: center; /* Center-align the links horizontally */
`;
const $d4c1fc4a3d4947e8$var$FeatureWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 2rem;
    flex-grow: 1;
    margin: 1rem 0;
`;
const $d4c1fc4a3d4947e8$var$FeatureGroup = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;
const $d4c1fc4a3d4947e8$var$FeatureItem = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    color: ${({ theme: theme })=>theme.color.link};
`;
const $d4c1fc4a3d4947e8$var$StyledIconWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $347ffda0d89c401a$export$f2e4196c0d2b5bb8))`
    padding: 0 0;
    min-height: auto;
    svg {
        padding: ${(props)=>props.$variant === 'small' ? '0.75rem' : '0'};
    }
`;
const $d4c1fc4a3d4947e8$var$StyledWrapCardText = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $347ffda0d89c401a$export$9de46b28c4f6c978))`
    padding: 0.5rem 1.25rem 1.75rem 1.25rem;
`;


function $05f7c300601947a5$export$2e2bcd8739ae039({ variant: variant = 'default' }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const { organizationId: organizationId, managedOrgId: managedOrgId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const BodyComponent = variant == 'default' ? (0, $348d9e775387b4da$export$5c96f0521c6e1626) : (0, $348d9e775387b4da$export$85a4c3b5f32264b8);
    const organizationContainer = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const currentUserContainer = (0, $8a1185b15e8317ab$export$2e2bcd8739ae039).useContainer();
    const [publicProducts, setPublicProducts] = (0, $7fPBF.useState)([]);
    const [purchaseOption, setPurchaseOption] = (0, $7fPBF.useState)('monthly');
    const locale = currentUserContainer.userLocalePreferencesRef.current.defaultLocale;
    (0, $7fPBF.useEffect)(()=>{
        if (!currentUserContainer.hasNoOrgMemberships && !organizationId) {
            // user is part of an org, and is on the generic upgrade page meant for free users
            const isSingleOrgMember = currentUserContainer.userLicenseAccessRef.current?.organizationLicenses?.length === 1;
            const originatedByOrganizationId = isSingleOrgMember ? currentUserContainer.userLicenseAccessRef.current?.organizationLicenses?.[0]?.originatedByOrganizationId : undefined;
            const isManagedOrg = managedOrgId || originatedByOrganizationId !== undefined && originatedByOrganizationId !== null && originatedByOrganizationId.length > 0;
            let upgradePath = '';
            if (!isManagedOrg && isSingleOrgMember) upgradePath = `/org/${organizationContainer.membershipsRef.current[0]?.organization.id}/billing/redirect/upgrade`;
            else upgradePath = '/org';
            // force user to upgrade with an associated org to avoid unnecessary creation of multiple orgs
            navigate(upgradePath, {
                replace: true
            });
            return;
        }
        const fetchProducts = async ()=>{
            const products = await organizationContainer.loadAvailableProducts();
            setPublicProducts(products);
        };
        fetchProducts();
    }, []);
    const getPurchaseOption = (licenseType, subscription)=>{
        const locale = currentUserContainer.userLocalePreferencesRef.current.defaultLocale;
        const products = publicProducts.filter((p)=>{
            // when checking for locale, display locale english is "en" and payment default is "en-us", hence only checking for language right now
            return p[licenseType] && p.isPublic && (p.locale === locale || (0, $eeb1a4bb5a11a603$export$d44f5da3b0eb939f)(p.locale) === (0, $eeb1a4bb5a11a603$export$d44f5da3b0eb939f)(locale) || (0, $eeb1a4bb5a11a603$export$d44f5da3b0eb939f)(p.locale) === (0, $eeb1a4bb5a11a603$export$d44f5da3b0eb939f)((0, $3ecd3f7dea3d56de$export$c89f3ba9a8ee8018)));
        });
        if (products.length === 0) return undefined;
        // sorted by billing cycle, so that the default payment link is always the first one
        const sortedProducts = products.sort((a, b)=>(a.billingCycle ?? '').localeCompare(b.billingCycle ?? ''));
        const purchaseOption = {
            price: sortedProducts[0].price,
            defaultPaymentLink: sortedProducts[0].defaultPaymentLink,
            type: subscription,
            productId: sortedProducts[0].id
        };
        if (subscription === 'yearly' && sortedProducts.length > 1) {
            purchaseOption.price = sortedProducts[1].price;
            purchaseOption.defaultPaymentLink = sortedProducts[1].defaultPaymentLink;
            purchaseOption.productId = sortedProducts[1].id;
        }
        return purchaseOption;
    };
    const getTranslatedFeatures = (featureKey)=>{
        const translatedFeatures = t(featureKey, {
            returnObjects: true,
            lng: locale
        });
        const jsonTranslatedCommands = JSON.parse(JSON.stringify(translatedFeatures));
        const features = [];
        for(const key in jsonTranslatedCommands)features.push(jsonTranslatedCommands[key]);
        return features;
    };
    const products = [
        {
            product: (0, $3d257c68ce43608e$export$ed2c078912602c20).isPlusAccess,
            supportedFeatures: [
                {
                    tag: t('common:billing.isPlusAccess.supportedFeatures.tag'),
                    features: getTranslatedFeatures('common:billing.isPlusAccess.supportedFeatures.features')
                }
            ],
            statusText: t('common:billing.mostPopular'),
            $variant: 'small'
        },
        {
            product: (0, $3d257c68ce43608e$export$ed2c078912602c20).isEmployeeAccess,
            supportedFeatures: [
                {
                    tag: t('common:billing.isEmployeeAccess.supportedFeatures.tag'),
                    features: getTranslatedFeatures('common:billing.isEmployeeAccess.supportedFeatures.features')
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($05f7c300601947a5$var$TabContainer, {
                role: "tablist",
                "aria-label": t('common:billing.subscription.title'),
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2e997290a21e7a60$export$7e36e2f4770bc64d), {
                        role: "tab",
                        "aria-selected": purchaseOption === 'monthly',
                        onClick: ()=>setPurchaseOption('monthly'),
                        isActive: purchaseOption === 'monthly',
                        children: t('common:billing.subscription.monthly')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2e997290a21e7a60$export$7e36e2f4770bc64d), {
                        role: "tab",
                        "aria-selected": purchaseOption === 'yearly',
                        onClick: ()=>setPurchaseOption('yearly'),
                        isActive: purchaseOption === 'yearly',
                        children: t('common:billing.subscription.yearly')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(BodyComponent, {
                children: [
                    products.map((product, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d4c1fc4a3d4947e8$export$2e2bcd8739ae039), {
                            ...product,
                            purchaseOption: getPurchaseOption(product.product.licenseType, purchaseOption),
                            organizationId: organizationId
                        }, 'product_' + i)),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fd9b8885d8abdd3b$export$2e2bcd8739ae039), {
                        organizationId: organizationId
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($05f7c300601947a5$export$6aedc35c4b1b61dc, {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    href: (0, $3d257c68ce43608e$export$d79fc0b00008bd8d),
                    endIcon: "externalLink",
                    target: "_blank",
                    children: t('common:learnMore')
                })
            })
        ]
    });
}
const $05f7c300601947a5$export$6aedc35c4b1b61dc = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1rem 0;
`;
const $05f7c300601947a5$var$TabContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039)($05f7c300601947a5$export$6aedc35c4b1b61dc)`
    display: flex;
    gap: 10px;
    margin: 1rem 0;
`;



function $8fb8c11d74adb839$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:billing.upgrade.compare'),
                description: t('common:billing.upgrade.description')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $05f7c300601947a5$export$2e2bcd8739ae039), {})
        ]
    });
}












function $030ccdeb6cb3fc1a$export$2e2bcd8739ae039() {
    const { currentOrg: currentOrg } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    if (!currentOrg) return null;
    const getMailTo = ()=>{
        return currentOrg.hasLicense ? (0, $14974ae7e6038f2e$export$de627014b138b76f)(currentOrg) : (0, $14974ae7e6038f2e$export$42aa67c76dc56b07)(currentOrg);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
        startIcon: "externalLink",
        href: getMailTo(),
        children: t('common:upgrade')
    });
}




function $572ce21afb4be0ad$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { currentOrg: currentOrg, canViewOrgDetails: canViewOrgDetails, isManagedOrg: isManagedOrg } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    if (!currentOrg) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:billing.title'),
                items: canViewOrgDetails ? items : []
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
                title: t('common:license.upgrade.fallback.title'),
                description: isManagedOrg ? t('common:billing.error') : t('common:license.upgrade.fallback.description'),
                fullHeight: true,
                icon: "money",
                children: !isManagedOrg && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $030ccdeb6cb3fc1a$export$2e2bcd8739ae039), {})
            })
        ]
    });
}











var $7fPBF = parcelRequire("7fPBF");


function $52d9b4cf6ab1d6c0$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId, productId: productId, managedOrgId: managedOrgId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const alertsContainer = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const organizationContainer = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const openBillingLink = (billingLink, errorRedirect)=>{
        if (billingLink) {
            window.open(billingLink, '_blank', 'noopener,noreferrer');
            navigate(-1); // redirect to previous page to maintain context
            alertsContainer.showSuccess(t('common:license.redirect.external'));
        } else navigate(errorRedirect, {
            replace: true
        });
    };
    const getBillingLinkForProduct = async (productId, org, trialId)=>{
        let billingLink = null;
        if (org.organization.isReseller) // reseller portal - purchase license keys
        billingLink = await organizationContainer.getOrganizationProductLink(org.organizationId, productId);
        else if (org.organization.hasLicense) // licensed org upgrade to a specific product
        billingLink = await organizationContainer.getBillingLinkForOrgByProduct(org.organizationId, productId);
        else if (trialId !== null) // trial upgrade link for specific product
        billingLink = await organizationContainer.getTrialUpgradeLinkForProduct(org.organizationId, trialId, productId);
        return billingLink;
    };
    const getOrgBillingLink = async (org, trialId, isStripeTrial)=>{
        let billingLink = null;
        const organizationId = org.organizationId;
        if (org.organization.hasLicense || isStripeTrial) billingLink = await organizationContainer.getBillingLink(organizationId);
        else if (trialId !== null) billingLink = await organizationContainer.getTrialUpgradeLink(organizationId, trialId);
        return billingLink;
    };
    const getTrial = (org)=>{
        // most recently active trial at the beginning
        const sortedTrials = org.organization.trials?.sort((a, b)=>new Date(b.expirationDate).setHours(0, 0, 0, 0) - new Date(a.expirationDate).setHours(0, 0, 0, 0)) || [];
        return sortedTrials.length > 0 ? sortedTrials[0] : null;
    };
    const loadBillingLink = async ()=>{
        if (!organizationId || organizationContainer.loading) return false;
        const org = organizationContainer.getOrganizationMembership(organizationId);
        if (!org) return false;
        if (!(productId || managedOrgId && org.canManageChildOrganizations || org.isAdmin || org.canManageBilling)) // billing permissions
        return false;
        let billingLink = null;
        let errorRedirect = org.organization.hasLicense ? `/org/${organizationId}/billing/redirect/error` : `/org/${organizationId}/trial/redirect/error`;
        const trial = getTrial(org);
        const trialId = trial ? trial.id : null;
        const isStripeTrial = !org.organization.hasLicense && trial?.isAutoUpdate === true && trial.isCreatedFromStripe === true;
        const isActiveLicense = org.organization.hasLicense && (!org.organization.licenseExpirationDate || new Date(org.organization.licenseExpirationDate) >= new Date());
        if (productId) // product specific billing link
        billingLink = await getBillingLinkForProduct(productId, org, trialId);
        else if (managedOrgId) {
            // reseller org managing subscription for managed org
            billingLink = await organizationContainer.getBillingLinkForManagedOrg(organizationId, managedOrgId);
            errorRedirect = `/org/${organizationId}/managed/${managedOrgId}/billing/redirect/error`;
        } else if (org.organization.customBillingUrl || isActiveLicense || isStripeTrial) // org custom billing URL or licensed org is active
        billingLink = await getOrgBillingLink(org, trialId, isStripeTrial);
        else {
            // redirect to explore billing page
            navigate(`/org/${organizationId}/billing/compare`, {
                replace: true
            });
            return true;
        }
        openBillingLink(billingLink, errorRedirect);
        return true;
    };
    (0, $7fPBF.useEffect)(()=>{
        const manageBillingLink = async ()=>{
            const hasBillingPermissions = await loadBillingLink();
            if (!hasBillingPermissions) {
                alertsContainer.showError(t('common:organization.canManageBilling.error'));
                navigate(-1);
            }
        };
        manageBillingLink();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        organizationId
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
        startIcon: "repeat",
        onClick: ()=>loadBillingLink(),
        children: t('common:reload')
    });
}




var $7fPBF = parcelRequire("7fPBF");


function $70228be3ff15ddce$export$f08c2f745253d47b() {
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const { organizationId: organizationId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const organizationContainer = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    (0, $7fPBF.useEffect)(()=>{
        const handlePermissionChangeRedirect = ()=>{
            if (!organizationContainer?.membershipsRef?.current || organizationContainer.membershipsRef.current?.length < 1) {
                navigate('/', {
                    replace: true
                });
                return;
            }
            const currentMember = organizationContainer.getOrganizationMembership(organizationId);
            if (!currentMember) navigate('/', {
                replace: true
            });
        };
        const handleOrgNullRedirect = ()=>{
            if (!organizationId) navigate('/', {
                replace: true
            });
        };
        handlePermissionChangeRedirect();
        handleOrgNullRedirect();
    }, [
        organizationId,
        organizationContainer.memberships
    ]);
}



function $fa7643c656d80855$export$2e2bcd8739ae039() {
    (0, $70228be3ff15ddce$export$f08c2f745253d47b)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { canViewOrgDetails: canViewOrgDetails } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:billing.title'),
                items: canViewOrgDetails ? items : []
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
                title: t('common:license.redirect.title'),
                description: t('common:license.redirect.description'),
                icon: "money",
                fullHeight: true,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $52d9b4cf6ab1d6c0$export$2e2bcd8739ae039), {})
            })
        ]
    });
}

















function $d1ebcf00b940bfdd$export$2e2bcd8739ae039({ canManageBilling: canManageBilling, organizationId: organizationId, isManagedOrg: isManagedOrg, customBillingUrl: customBillingUrl }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { managedOrgId: managedOrgId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    // show billing link if: not a managed org, or is a managed org with custom billing but not viewed by a reseller admin
    const showBillingLink = !isManagedOrg || !managedOrgId && !!customBillingUrl;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
        icon: "cancel",
        fullHeight: true,
        title: t('common:organization.expired.title'),
        description: canManageBilling ? t('common:organization.expired.admin') : t('common:organization.expired.user'),
        children: canManageBilling && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                showBillingLink && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    href: `#/org/${organizationId}/billing/redirect/upgrade`,
                    endIcon: "externalLink",
                    children: t('common:billing.view')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0b175acfd81bea10$export$2e2bcd8739ae039), {
                    organizationId: organizationId
                })
            ]
        })
    });
}











const $6601f3edf09b4a92$var$CardIcon = ({ title: title, description: description, name: name, size: size = 100, children: children, ...restProps })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $347ffda0d89c401a$export$401042fa3f49d26), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $347ffda0d89c401a$export$f2e4196c0d2b5bb8), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                    name: name,
                    size: size,
                    ...restProps
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $347ffda0d89c401a$export$9de46b28c4f6c978), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$2c65789109b698b0), {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                        children: description
                    }),
                    children
                ]
            })
        ]
    });
};
var $6601f3edf09b4a92$export$2e2bcd8739ae039 = $6601f3edf09b4a92$var$CardIcon;




var $7fPBF = parcelRequire("7fPBF");





function $9588f4c9a4c5209d$export$2e2bcd8739ae039({ variant: variant, organizationId: organizationId, textOverride: textOverride }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: parentOrgId, managedOrgId: managedOrgId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    let url;
    let textKey = 'common:other.title';
    let endIcon;
    let appendManagedOrg = false;
    if (!variant || !organizationId) return null;
    // handle for reseller managed org navigation
    if (organizationId !== parentOrgId && parentOrgId && organizationId === managedOrgId) {
        organizationId = parentOrgId;
        appendManagedOrg = true;
    }
    switch(variant){
        case 'orgMembers':
            url = `/members`;
            textKey = 'common:organization.canViewMembers.title';
            break;
        case 'orgBilling':
            url = `/billing`;
            textKey = 'common:organization.canManageBilling.title';
            break;
        case 'orgDetails':
            url = `/`;
            textKey = 'common:organization.titleLong';
            break;
        case 'orgInvites':
            url = `/members/invites`;
            textKey = 'common:organization.invite.view';
            break;
        case 'orgMe':
            url = `/`;
            textKey = 'common:organization.member.me';
            break;
        case 'orgAuthClient':
            url = `/projects`;
            textKey = 'common:organization.canCreateAuthClients.title';
            break;
        case 'orgMetrics':
            url = `/metrics`;
            textKey = 'common:organization.metrics.view';
            break;
        case 'orgProjects':
            url = `/projects`;
            textKey = 'common:organization.projects.view';
            break;
        case 'orgBillingRedirect':
            url = `/billing/redirect/upgrade`;
            textKey = 'common:billing.view';
            endIcon = 'externalLink';
            break;
        case 'orgTrialBillingRedirect':
            url = `/trial/redirect/upgrade`;
            textKey = 'common:billing.view';
            endIcon = 'externalLink';
            break;
        case 'orgSettings':
            url = `/settings`;
            textKey = 'common:settings.title';
            break;
        case 'orgLicenseKeys':
            url = `/licensekey`;
            textKey = 'common:license.key.titlePlural';
            break;
        case 'orgManagedOrgs':
            url = `/managed`;
            textKey = 'common:organization.managed.title';
            break;
        case 'orgProduct':
            url = `/purchase`;
            textKey = 'common:license.key.product.title';
            break;
        case 'orgProfiles':
            url = `/profiles`;
            textKey = 'common:organization.profiles.title';
            break;
        default:
            return null;
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
        variant: "subsection",
        to: appendManagedOrg ? `/org/${organizationId}/managed/${managedOrgId}` + url : `/org/${organizationId}` + url,
        viewTransition: true,
        endIcon: endIcon,
        children: textOverride ?? t(textKey)
    });
}


function $e8b8e2208f47c8d7$export$2e2bcd8739ae039({ orgId: orgId, isLicensed: isLicensed }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [showDialog, setShowDialog] = (0, $7fPBF.useState)(false);
    const onClick = ()=>{
        setShowDialog(true);
    };
    const onCancel = ()=>{
        setShowDialog(false);
    };
    if (!orgId) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6601f3edf09b4a92$export$2e2bcd8739ae039), {
        name: "money",
        title: t('common:billing.title'),
        description: t('common:billing.description'),
        children: isLicensed ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9588f4c9a4c5209d$export$2e2bcd8739ae039), {
            organizationId: orgId,
            variant: "orgBillingRedirect"
        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9588f4c9a4c5209d$export$2e2bcd8739ae039), {
                    organizationId: orgId,
                    variant: "orgTrialBillingRedirect"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                    variant: "subsection",
                    onClick: onClick,
                    children: t('common:license.activate.title')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e26231f066199887$export$2e2bcd8739ae039), {
                    open: showDialog,
                    onCancel: onCancel,
                    organizationId: orgId
                })
            ]
        })
    });
}





function $ba0132d00fab9151$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a5e039f9955fc75e$export$2e2bcd8739ae039), {
        name: "orgTransaction",
        title: t('common:billing.title'),
        description: t('common:billing.error')
    });
}


function $d6e1b40cb257f60f$export$2e2bcd8739ae039({ currentOrg: currentOrg, canManageBilling: canManageBilling }) {
    const showBilling = canManageBilling && !currentOrg?.originatedByOrganizationId || currentOrg?.originatedByOrganizationId && currentOrg?.customBillingUrl;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d6e1b40cb257f60f$var$Row, {
        children: [
            showBilling && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e8b8e2208f47c8d7$export$2e2bcd8739ae039), {
                orgId: currentOrg.id,
                isLicensed: !!currentOrg.hasLicense
            }),
            canManageBilling && !showBilling && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ba0132d00fab9151$export$2e2bcd8739ae039), {})
        ]
    });
}
const $d6e1b40cb257f60f$var$Row = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    margin: 1rem;
`;






function $3b15295b8744e383$export$2e2bcd8739ae039({ orgId: orgId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    if (!orgId) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
        name: "orgInvite",
        title: t('common:organization.canInviteMembers.title'),
        description: t('common:organization.canInviteMembers.description'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9588f4c9a4c5209d$export$2e2bcd8739ae039), {
            variant: "orgInvites",
            organizationId: orgId
        })
    });
}






function $e94b26966f7e8b34$export$2e2bcd8739ae039({ orgId: orgId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    if (!orgId) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
        name: "orgAuthClient",
        title: t('common:license.key.titlePlural'),
        description: t('common:license.key.description'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9588f4c9a4c5209d$export$2e2bcd8739ae039), {
            organizationId: orgId,
            variant: 'orgLicenseKeys'
        })
    });
}






function $b48e4cf00b3bcbc6$export$2e2bcd8739ae039({ orgId: orgId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    if (!orgId) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
        name: "orgCompany",
        title: t('common:organization.managed.titlePlural'),
        description: t('common:organization.managed.description'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9588f4c9a4c5209d$export$2e2bcd8739ae039), {
            organizationId: orgId,
            variant: 'orgManagedOrgs'
        })
    });
}






function $0f540dd632df425d$export$2e2bcd8739ae039({ orgId: orgId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    if (!orgId) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
        name: "orgMembers",
        title: t('common:organization.member.viewAll.title'),
        description: t('common:organization.member.viewAll.description'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9588f4c9a4c5209d$export$2e2bcd8739ae039), {
            organizationId: orgId,
            variant: 'orgMembers'
        })
    });
}






function $ede53a4d18dfd239$export$2e2bcd8739ae039({ orgId: orgId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    if (!orgId) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
        name: "purchaseOrder",
        title: t('common:organization.profiles.title'),
        description: t('common:organization.profiles.description'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9588f4c9a4c5209d$export$2e2bcd8739ae039), {
            variant: "orgProfiles",
            organizationId: orgId
        })
    });
}






function $f9629eea5f62c57b$export$2e2bcd8739ae039({ orgId: orgId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    if (!orgId) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
        name: "orgTransaction",
        title: t('common:license.key.product.titleLong'),
        description: t('common:license.key.product.description'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9588f4c9a4c5209d$export$2e2bcd8739ae039), {
            organizationId: orgId,
            variant: 'orgProduct'
        })
    });
}








function $af0cebb6e8b6c0e3$export$2e2bcd8739ae039({ orgId: orgId, projects: projects }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    if (!orgId) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: projects ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
            name: "virtualApps",
            title: t('common:organization.projects.title'),
            description: t('common:organization.projects.description'),
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9588f4c9a4c5209d$export$2e2bcd8739ae039), {
                organizationId: orgId,
                variant: 'orgProjects'
            })
        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $347ffda0d89c401a$export$8ffb7ce587ade322), {
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
                name: "virtualApps",
                title: t('common:organization.projects.title'),
                description: t('common:organization.projects.upgrade.shortDescription'),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    href: `https://cephable.com/sdk-trial/`,
                    startIcon: "plusLight",
                    $color: "secondary",
                    children: t('common:upgrade')
                })
            })
        })
    });
}






function $27edc0649b04e14f$export$2e2bcd8739ae039({ orgId: orgId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    if (!orgId) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
        name: "settings",
        title: t('common:settings.title'),
        description: t('common:organization.settings.description'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9588f4c9a4c5209d$export$2e2bcd8739ae039), {
            organizationId: orgId,
            variant: 'orgSettings'
        })
    });
}


function $8692271737acf203$export$2e2bcd8739ae039({ isAdminPortal: isAdminPortal = false }) {
    const { canAccessOrganizationProfiles: canAccessOrganizationProfiles, canCreateAuthClients: canCreateAuthClients, canEditOrganizationProfiles: canEditOrganizationProfiles, canInviteMembers: canInviteMembers, canManageBilling: canManageBilling, canManageChildOrganizations: canManageChildOrganizations, canViewMembers: canViewMembers, canViewOrgDetails: canViewOrgDetails, currentOrg: currentOrg, hasSomeMemberEditPermissions: hasSomeMemberEditPermissions, isExpiredOrg: isExpiredOrg, isLoading: isLoading, isManagedOrg: isManagedOrg } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const { managedOrgId: managedOrgId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    if (!currentOrg) return null;
    if (isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {});
    if (isExpiredOrg) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d1ebcf00b940bfdd$export$2e2bcd8739ae039), {
        organizationId: currentOrg.id,
        canManageBilling: canManageBilling,
        isManagedOrg: isManagedOrg,
        customBillingUrl: currentOrg.customBillingUrl
    });
    if (!canViewOrgDetails) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $348d9e775387b4da$export$85a4c3b5f32264b8), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d6e1b40cb257f60f$export$2e2bcd8739ae039), {
            currentOrg: currentOrg,
            canManageBilling: canManageBilling
        })
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            (canViewMembers || hasSomeMemberEditPermissions) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0f540dd632df425d$export$2e2bcd8739ae039), {
                orgId: currentOrg.id
            }),
            canInviteMembers && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b15295b8744e383$export$2e2bcd8739ae039), {
                orgId: currentOrg.id
            }),
            (canAccessOrganizationProfiles || canEditOrganizationProfiles) && isAdminPortal && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ede53a4d18dfd239$export$2e2bcd8739ae039), {
                orgId: currentOrg.id
            }),
            !managedOrgId && currentOrg.isReseller && canManageChildOrganizations && isAdminPortal && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b48e4cf00b3bcbc6$export$2e2bcd8739ae039), {
                        orgId: currentOrg.id
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e94b26966f7e8b34$export$2e2bcd8739ae039), {
                        orgId: currentOrg.id
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f9629eea5f62c57b$export$2e2bcd8739ae039), {
                        orgId: currentOrg.id
                    })
                ]
            }),
            canCreateAuthClients && isAdminPortal && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af0cebb6e8b6c0e3$export$2e2bcd8739ae039), {
                orgId: currentOrg.id,
                projects: currentOrg.canCreateAuthClients
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $27edc0649b04e14f$export$2e2bcd8739ae039), {
                orgId: currentOrg.id
            })
        ]
    });
}













function $e82a2233d2b7ec37$export$2e2bcd8739ae039({ color: color = 'default', title: title, subtitle: subtitle, subtitleAction: subtitleAction, icon: icon, children: children, borderless: borderless = false }) {
    const theme = (0, $d62c6f18f523e962$export$3b14a55fb2447963)();
    if (!title) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $12a7318cc7b914d5$export$bdfe625add29c644), {
        $color: color,
        $borderless: borderless,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($e82a2233d2b7ec37$var$FlexRow, {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($e82a2233d2b7ec37$var$FlexWrap, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($e82a2233d2b7ec37$var$IconRow, {
                            children: [
                                icon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                    size: 18,
                                    name: icon,
                                    color: theme.banner[color].icon
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e), {
                                    as: "h2",
                                    children: title
                                })
                            ]
                        }),
                        subtitle && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $12a7318cc7b914d5$export$dc254ddf4c41e5d7), {
                            $color: color,
                            children: [
                                subtitle && typeof subtitle === 'string' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e82a2233d2b7ec37$var$StyledLightXSmall, {
                                    children: subtitle
                                }) : subtitle,
                                subtitleAction
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $12a7318cc7b914d5$export$503892287317b6c8), {
                    $color: color,
                    children: children
                })
            ]
        })
    });
}
const $e82a2233d2b7ec37$var$FlexWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    flex-wrap: wrap;
`;
const $e82a2233d2b7ec37$var$FlexRow = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    width: 100%;
    flex: 1;
    display: flex;
    gap: 0.5rem;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;
const $e82a2233d2b7ec37$var$IconRow = (0, $8de346382d86c747$export$2e2bcd8739ae039)($e82a2233d2b7ec37$var$FlexRow)`
    justify-content: flex-start;
`;
const $e82a2233d2b7ec37$var$StyledLightXSmall = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$1ef657600983666a))`
    display: inline;
`;










const $04208d5c79c2b652$export$b6125dcde81daafc = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding-bottom: 0.5rem;
`;
const $04208d5c79c2b652$export$422de0a0421e1558 = (0, $8de346382d86c747$export$2e2bcd8739ae039).ul`
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;
const $04208d5c79c2b652$export$989506d4e6ea852a = (0, $8de346382d86c747$export$2e2bcd8739ae039).li`
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    color: ${({ theme: theme })=>theme.color.link};
`;




var $7fPBF = parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");

function $0f5d8549378ffa13$export$17a459df3f7c4dec() {
    const organizationContainer = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const [freeTrialOrg, setFreeTrialOrg] = (0, $7fPBF.useState)(null);
    const [mostRecentTrial, setMostRecentTrial] = (0, $7fPBF.useState)(null);
    const canManageBilling = (0, $7fPBF.useMemo)(()=>{
        if (!freeTrialOrg) return false;
        return freeTrialOrg.isAdmin || freeTrialOrg.canManageBilling;
    }, [
        freeTrialOrg
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const isMemberPartOfOrganization = organizationContainer.membershipsRef.current?.length > 0;
        if (isMemberPartOfOrganization) {
            let mostRecentTrialOrg = null;
            let mostRecentTrial = null;
            let found = false;
            for (const org of organizationContainer.membershipsRef.current){
                if (found) break;
                if (!org.organization.hasLicense && org.organization.trials) {
                    const activeTrial = org.organization.trials.find((trial)=>new Date(trial.expirationDate) > new Date());
                    if (activeTrial) {
                        mostRecentTrialOrg = org;
                        mostRecentTrial = activeTrial;
                    }
                    // if no active trial, set most recent trial
                    const recentTrial = org.organization.trials.reduce((latest, trial)=>{
                        return new Date(trial.expirationDate) > new Date(latest.expirationDate) ? trial : latest;
                    }, org.organization.trials[0]);
                    if (!mostRecentTrial || new Date(recentTrial.expirationDate) > new Date(mostRecentTrial.expirationDate)) {
                        mostRecentTrialOrg = org;
                        mostRecentTrial = recentTrial;
                    }
                    if (mostRecentTrial && mostRecentTrialOrg) {
                        found = true;
                        break;
                    }
                }
            }
            setFreeTrialOrg(mostRecentTrialOrg);
            setMostRecentTrial(mostRecentTrial);
        }
    }, [
        organizationContainer.memberships
    ]);
    return {
        mostRecentTrial: mostRecentTrial,
        freeTrialOrg: freeTrialOrg,
        canManageBilling: canManageBilling
    };
}


function $0ffdb47bc7ff01de$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId, managedOrgId: managedOrgId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const location = (0, $5ec159caebd3ae22$export$45d76561a5302f2b)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const currentUserContainer = (0, $8a1185b15e8317ab$export$2e2bcd8739ae039).useContainer();
    const organizationContainer = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const { mostRecentTrial: mostRecentTrial, freeTrialOrg: freeTrialOrg, canManageBilling: canManageBilling } = (0, $0f5d8549378ffa13$export$17a459df3f7c4dec)();
    // days left calculation
    const today = new Date();
    const daysLeft = mostRecentTrial ? Math.ceil((new Date(mostRecentTrial.expirationDate).getTime() - today.getTime()) / 86400000) : 0;
    const isOnHomePage = location.pathname === '/';
    const getTrialProductName = ()=>{
        if (!mostRecentTrial) return '';
        // this logic is based on current product naming conventions and may need to be updated if new products are added or names change
        if (mostRecentTrial.isEmployeeAccess || mostRecentTrial.isStudentAccess) return t('common:billing.isEmployeeAccess.titleLong');
        else if (mostRecentTrial.isPlusAccess) return t('common:billing.isPlusAccess.titleLong');
        else return 'Cephable';
    };
    const handleFreeTrial = (0, $7fPBF.useCallback)(async ()=>{
        // validation
        if (!freeTrialOrg) {
            handleFreeTrialExpiration();
            return;
        }
        // remaining users calculation
        const maxMembers = freeTrialOrg?.organization.maxMembers ?? 0;
        let currMembers = 0;
        if (organizationContainer.currentOrg?.id === freeTrialOrg.organizationId) currMembers = organizationContainer.currentOrg.currentMemberCount ?? 0;
        else {
            const result = await organizationContainer.getOrganizationDetails(freeTrialOrg.organizationId);
            currMembers = result?.resultType === 'Ok' && result.data ? result.data.currentMemberCount ?? 0 : 0;
        }
        const remainingUsers = Math.max(0, maxMembers - currMembers);
        const isMultiUserOrg = maxMembers > 1;
        const handleUpgrade = ()=>{
            // upgrade button
            if (isOnHomePage && isMultiUserOrg) navigate(`/org/${freeTrialOrg.organizationId}`);
            else navigate(`/org/${freeTrialOrg.organizationId}/trial/redirect/upgrade`);
        };
        const ActionComponent = canManageBilling && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
            $size: "small",
            startIcon: "upgrade",
            onClick: handleUpgrade,
            children: t('common:upgrade')
        });
        // current org member
        const canInviteMembers = freeTrialOrg?.canInviteMembers || freeTrialOrg?.isAdmin;
        let subtitle = remainingUsers == 0 ? t('common:license.trial.noUsersSubtitle') : t('common:license.trial.subtitle', {
            count: remainingUsers
        });
        if (maxMembers === 1) subtitle = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $04208d5c79c2b652$export$b6125dcde81daafc), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$1ef657600983666a), {
                    children: t('billing.upgrade.longDescription')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $04208d5c79c2b652$export$422de0a0421e1558), {
                    children: (0, $3d257c68ce43608e$export$3dc32300594beeaf).map((feature, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $04208d5c79c2b652$export$989506d4e6ea852a), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                    name: "check",
                                    size: 16
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$1ef657600983666a), {
                                    children: t(feature)
                                })
                            ]
                        }, index))
                })
            ]
        });
        // prevent inviting members if email is not verified
        const SubtitleAction = remainingUsers > 0 && canInviteMembers ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $12a7318cc7b914d5$export$1a9858f2fb62c3f2), {
            disabled: currentUserContainer.currentUser?.isEmailVerified == false,
            variant: "context",
            to: `/org/${freeTrialOrg.organizationId}/members/invites`,
            children: t('common:organization.canInviteMembers.title')
        }) : null;
        const title = organizationContainer.memberships.length > 1 && isOnHomePage ? t('common:license.trial.title.multiple', {
            days: daysLeft,
            organization: freeTrialOrg.organization.name,
            productName: getTrialProductName()
        }) : t('common:license.trial.title.single', {
            days: daysLeft,
            productName: getTrialProductName()
        });
        const freeTrialBanner = {
            id: 'freeTrial',
            title: title,
            subtitle: subtitle,
            children: ActionComponent,
            subtitleAction: SubtitleAction
        };
        currentUserContainer.addUpgradeBanner(freeTrialBanner);
    }, [
        currentUserContainer.addUpgradeBanner,
        t,
        freeTrialOrg,
        mostRecentTrial
    ]);
    const handleFreeTrialExpiration = (0, $7fPBF.useCallback)(()=>{
        currentUserContainer.removeUpgradeBanner('freeTrial');
    }, [
        currentUserContainer.removeUpgradeBanner
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (currentUserContainer.userLicenseAccess === null || currentUserContainer.userLicenseAccess === undefined) return;
        const isTrial = currentUserContainer.currentUser && freeTrialOrg && mostRecentTrial && daysLeft > 0 && !currentUserContainer.userLicenseAccess.hasLicense;
        const isValidPage = isOnHomePage || organizationId && (freeTrialOrg?.organizationId === organizationId && !managedOrgId || freeTrialOrg?.organizationId === managedOrgId);
        if (isTrial && isValidPage && !currentUserContainer.isFreeUser()) handleFreeTrial();
        else handleFreeTrialExpiration();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        freeTrialOrg,
        mostRecentTrial,
        organizationId,
        currentUserContainer.userLicenseAccess
    ]);
}


function $a31cb358b2102a46$export$2e2bcd8739ae039() {
    const { upgradeBannersArray: upgradeBannersArray } = (0, $8a1185b15e8317ab$export$2e2bcd8739ae039).useContainer();
    (0, $0ffdb47bc7ff01de$export$2e2bcd8739ae039)();
    if (upgradeBannersArray.length === 0) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a31cb358b2102a46$var$StyledNotificationListingWrap, {
        as: "section",
        children: upgradeBannersArray.map((banner)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e82a2233d2b7ec37$export$2e2bcd8739ae039), {
                ...banner
            }, banner.id))
    });
}
const $a31cb358b2102a46$var$StyledNotificationListingWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $12a7318cc7b914d5$export$7cee909993ddd8b7))`
    margin: 2rem 0;
`;


function $e8ddd06b3da44631$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a31cb358b2102a46$export$2e2bcd8739ae039), {}),
            children
        ]
    });
}



function $6da00e256676a096$export$2e2bcd8739ae039() {
    (0, $70228be3ff15ddce$export$f08c2f745253d47b)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { currentOrg: currentOrg, isLoading: isLoading } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    if (!currentOrg || isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e8ddd06b3da44631$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: currentOrg?.name ?? t('common:organization.title'),
                description: currentOrg?.description ?? t('common:organization.description'),
                items: items,
                children: (currentOrg?.customResourcesMarkdown || currentOrg?.managedResourcesMarkdown) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    $color: "secondary",
                    href: `#/org/${currentOrg?.id}/documentation`,
                    children: t('common:resources.title')
                })
            }),
            currentOrg && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8692271737acf203$export$2e2bcd8739ae039), {
                isAdminPortal: true
            })
        ]
    });
}












/**
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast-util-sanitize').Schema} Schema
 */ /**
 * @import {
 *   Comment,
 *   Doctype,
 *   ElementContent,
 *   Element,
 *   Nodes,
 *   Properties,
 *   RootContent,
 *   Root,
 *   Text
 * } from 'hast'
 */ /**
 * @typedef {[string, ...Array<Exclude<Properties[keyof Properties], Array<any>> | RegExp>] | string} PropertyDefinition
 *   Definition for a property.
 *
 * @typedef Schema
 *   Schema that defines what nodes and properties are allowed.
 *
 *   The default schema is `defaultSchema`, which follows how GitHub cleans.
 *   If any top-level key is missing in the given schema, the corresponding
 *   value of the default schema is used.
 *
 *   To extend the standard schema with a few changes, clone `defaultSchema`
 *   like so:
 *
 *   ```js
 *   import deepmerge from 'deepmerge'
 *   import {h} from 'hastscript'
 *   import {defaultSchema, sanitize} from 'hast-util-sanitize'
 *
 *   // This allows `className` on all elements.
 *   const schema = deepmerge(defaultSchema, {attributes: {'*': ['className']}})
 *
 *   const tree = sanitize(h('div', {className: ['foo']}), schema)
 *
 *   // `tree` still has `className`.
 *   console.log(tree)
 *   // {
 *   //   type: 'element',
 *   //   tagName: 'div',
 *   //   properties: {className: ['foo']},
 *   //   children: []
 *   // }
 *   ```
 * @property {boolean | null | undefined} [allowComments=false]
 *   Whether to allow comment nodes (default: `false`).
 *
 *   For example:
 *
 *   ```js
 *   allowComments: true
 *   ```
 * @property {boolean | null | undefined} [allowDoctypes=false]
 *   Whether to allow doctype nodes (default: `false`).
 *
 *   For example:
 *
 *   ```js
 *   allowDoctypes: true
 *   ```
 * @property {Record<string, Array<string>> | null | undefined} [ancestors]
 *   Map of tag names to a list of tag names which are required ancestors
 *   (default: `defaultSchema.ancestors`).
 *
 *   Elements with these tag names will be ignored if they occur outside of one
 *   of their allowed parents.
 *
 *   For example:
 *
 *   ```js
 *   ancestors: {
 *     tbody: ['table'],
 *     // …
 *     tr: ['table']
 *   }
 *   ```
 * @property {Record<string, Array<PropertyDefinition>> | null | undefined} [attributes]
 *   Map of tag names to allowed property names (default:
 *   `defaultSchema.attributes`).
 *
 *   The special key `'*'` as a tag name defines property names allowed on all
 *   elements.
 *
 *   The special value `'data*'` as a property name can be used to allow all
 *   `data` properties.
 *
 *   For example:
 *
 *   ```js
 *   attributes: {
 *     'ariaDescribedBy', 'ariaLabel', 'ariaLabelledBy', …, 'href'
 *     // …
 *     '*': [
 *       'abbr',
 *       'accept',
 *       'acceptCharset',
 *       // …
 *       'vAlign',
 *       'value',
 *       'width'
 *     ]
 *   }
 *   ```
 *
 *   Instead of a single string in the array, which allows any property value
 *   for the field, you can use an array to allow several values.
 *   For example, `input: ['type']` allows `type` set to any value on `input`s.
 *   But `input: [['type', 'checkbox', 'radio']]` allows `type` when set to
 *   `'checkbox'` or `'radio'`.
 *
 *   You can use regexes, so for example `span: [['className', /^hljs-/]]`
 *   allows any class that starts with `hljs-` on `span`s.
 *
 *   When comma- or space-separated values are used (such as `className`), each
 *   value in is checked individually.
 *   For example, to allow certain classes on `span`s for syntax highlighting,
 *   use `span: [['className', 'number', 'operator', 'token']]`.
 *   This will allow `'number'`, `'operator'`, and `'token'` classes, but drop
 *   others.
 * @property {Array<string> | null | undefined} [clobber]
 *   List of property names that clobber (default: `defaultSchema.clobber`).
 *
 *   For example:
 *
 *   ```js
 *   clobber: ['ariaDescribedBy', 'ariaLabelledBy', 'id', 'name']
 *   ```
 * @property {string | null | undefined} [clobberPrefix]
 *   Prefix to use before clobbering properties (default:
 *   `defaultSchema.clobberPrefix`).
 *
 *   For example:
 *
 *   ```js
 *   clobberPrefix: 'user-content-'
 *   ```
 * @property {Record<string, Array<string> | null | undefined> | null | undefined} [protocols]
 *   Map of *property names* to allowed protocols (default:
 *   `defaultSchema.protocols`).
 *
 *   This defines URLs that are always allowed to have local URLs (relative to
 *   the current website, such as `this`, `#this`, `/this`, or `?this`), and
 *   only allowed to have remote URLs (such as `https://example.com`) if they
 *   use a known protocol.
 *
 *   For example:
 *
 *   ```js
 *   protocols: {
 *     cite: ['http', 'https'],
 *     // …
 *     src: ['http', 'https']
 *   }
 *   ```
 * @property {Record<string, Record<string, Properties[keyof Properties]>> | null | undefined} [required]
 *   Map of tag names to required property names with a default value
 *   (default: `defaultSchema.required`).
 *
 *   This defines properties that must be set.
 *   If a field does not exist (after the element was made safe), these will be
 *   added with the given value.
 *
 *   For example:
 *
 *   ```js
 *   required: {
 *     input: {disabled: true, type: 'checkbox'}
 *   }
 *   ```
 *
 *   > 👉 **Note**: properties are first checked based on `schema.attributes`,
 *   > then on `schema.required`.
 *   > That means properties could be removed by `attributes` and then added
 *   > again with `required`.
 * @property {Array<string> | null | undefined} [strip]
 *   List of tag names to strip from the tree (default: `defaultSchema.strip`).
 *
 *   By default, unsafe elements (those not in `schema.tagNames`) are replaced
 *   by what they contain.
 *   This option can drop their contents.
 *
 *   For example:
 *
 *   ```js
 *   strip: ['script']
 *   ```
 * @property {Array<string> | null | undefined} [tagNames]
 *   List of allowed tag names (default: `defaultSchema.tagNames`).
 *
 *   For example:
 *
 *   ```js
 *   tagNames: [
 *     'a',
 *     'b',
 *     // …
 *     'ul',
 *     'var'
 *   ]
 *   ```
 *
 * @typedef State
 *   Info passed around.
 * @property {Readonly<Schema>} schema
 *   Schema.
 * @property {Array<string>} stack
 *   Tag names of ancestors.
 */ 

/**
 * @import {Schema} from 'hast-util-sanitize'
 */ // Couple of ARIA attributes allowed in several, but not all, places.
const $b4cfe5f2a3f70524$var$aria = [
    'ariaDescribedBy',
    'ariaLabel',
    'ariaLabelledBy'
];
const $b4cfe5f2a3f70524$export$1db618b7b2275ea1 = {
    ancestors: {
        tbody: [
            'table'
        ],
        td: [
            'table'
        ],
        th: [
            'table'
        ],
        thead: [
            'table'
        ],
        tfoot: [
            'table'
        ],
        tr: [
            'table'
        ]
    },
    attributes: {
        a: [
            ...$b4cfe5f2a3f70524$var$aria,
            // Note: these 3 are used by GFM footnotes, they do work on all links.
            'dataFootnoteBackref',
            'dataFootnoteRef',
            [
                'className',
                'data-footnote-backref'
            ],
            'href'
        ],
        blockquote: [
            'cite'
        ],
        // Note: this class is not normally allowed by GH, when manually writing
        // `code` as HTML in markdown, they adds it some other way.
        // We can’t do that, so we have to allow it.
        code: [
            [
                'className',
                /^language-./
            ]
        ],
        del: [
            'cite'
        ],
        div: [
            'itemScope',
            'itemType'
        ],
        dl: [
            ...$b4cfe5f2a3f70524$var$aria
        ],
        // Note: this is used by GFM footnotes.
        h2: [
            [
                'className',
                'sr-only'
            ]
        ],
        img: [
            ...$b4cfe5f2a3f70524$var$aria,
            'longDesc',
            'src'
        ],
        // Note: `input` is not normally allowed by GH, when manually writing
        // it in markdown, they add it from tasklists some other way.
        // We can’t do that, so we have to allow it.
        input: [
            [
                'disabled',
                true
            ],
            [
                'type',
                'checkbox'
            ]
        ],
        ins: [
            'cite'
        ],
        // Note: this class is not normally allowed by GH, when manually writing
        // `li` as HTML in markdown, they adds it some other way.
        // We can’t do that, so we have to allow it.
        li: [
            [
                'className',
                'task-list-item'
            ]
        ],
        // Note: this class is not normally allowed by GH, when manually writing
        // `ol` as HTML in markdown, they adds it some other way.
        // We can’t do that, so we have to allow it.
        ol: [
            ...$b4cfe5f2a3f70524$var$aria,
            [
                'className',
                'contains-task-list'
            ]
        ],
        q: [
            'cite'
        ],
        section: [
            'dataFootnotes',
            [
                'className',
                'footnotes'
            ]
        ],
        source: [
            'srcSet'
        ],
        summary: [
            ...$b4cfe5f2a3f70524$var$aria
        ],
        table: [
            ...$b4cfe5f2a3f70524$var$aria
        ],
        // Note: this class is not normally allowed by GH, when manually writing
        // `ol` as HTML in markdown, they adds it some other way.
        // We can’t do that, so we have to allow it.
        ul: [
            ...$b4cfe5f2a3f70524$var$aria,
            [
                'className',
                'contains-task-list'
            ]
        ],
        '*': [
            'abbr',
            'accept',
            'acceptCharset',
            'accessKey',
            'action',
            'align',
            'alt',
            'axis',
            'border',
            'cellPadding',
            'cellSpacing',
            'char',
            'charOff',
            'charSet',
            'checked',
            'clear',
            'colSpan',
            'color',
            'cols',
            'compact',
            'coords',
            'dateTime',
            'dir',
            // Note: `disabled` is technically allowed on all elements by GH.
            // But it is useless on everything except `input`.
            // Because `input`s are normally not allowed, but we allow them for
            // checkboxes due to tasklists, we allow `disabled` only there.
            'encType',
            'frame',
            'hSpace',
            'headers',
            'height',
            'hrefLang',
            'htmlFor',
            'id',
            'isMap',
            'itemProp',
            'label',
            'lang',
            'maxLength',
            'media',
            'method',
            'multiple',
            'name',
            'noHref',
            'noShade',
            'noWrap',
            'open',
            'prompt',
            'readOnly',
            'rev',
            'rowSpan',
            'rows',
            'rules',
            'scope',
            'selected',
            'shape',
            'size',
            'span',
            'start',
            'summary',
            'tabIndex',
            'title',
            'useMap',
            'vAlign',
            'value',
            'width'
        ]
    },
    clobber: [
        'ariaDescribedBy',
        'ariaLabelledBy',
        'id',
        'name'
    ],
    clobberPrefix: 'user-content-',
    protocols: {
        cite: [
            'http',
            'https'
        ],
        href: [
            'http',
            'https',
            'irc',
            'ircs',
            'mailto',
            'xmpp'
        ],
        longDesc: [
            'http',
            'https'
        ],
        src: [
            'http',
            'https'
        ]
    },
    required: {
        input: {
            disabled: true,
            type: 'checkbox'
        }
    },
    strip: [
        'script'
    ],
    tagNames: [
        'a',
        'b',
        'blockquote',
        'br',
        'code',
        'dd',
        'del',
        'details',
        'div',
        'dl',
        'dt',
        'em',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'hr',
        'i',
        'img',
        // Note: `input` is not normally allowed by GH, when manually writing
        // it in markdown, they add it from tasklists some other way.
        // We can’t do that, so we have to allow it.
        'input',
        'ins',
        'kbd',
        'li',
        'ol',
        'p',
        'picture',
        'pre',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'source',
        'span',
        'strike',
        'strong',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'tfoot',
        'th',
        'thead',
        'tr',
        'tt',
        'ul',
        'var'
    ]
};


const $d53ef575c839fd46$var$own = {}.hasOwnProperty;
function $d53ef575c839fd46$export$83d2e9e3e4ee39ed(node, options) {
    /** @type {Nodes} */ let result = {
        type: 'root',
        children: []
    };
    /** @type {State} */ const state = {
        schema: options ? {
            ...(0, $b4cfe5f2a3f70524$export$1db618b7b2275ea1),
            ...options
        } : (0, $b4cfe5f2a3f70524$export$1db618b7b2275ea1),
        stack: []
    };
    const replace = $d53ef575c839fd46$var$transform(state, node);
    if (replace) {
        if (Array.isArray(replace)) {
            if (replace.length === 1) result = replace[0];
            else result.children = replace;
        } else result = replace;
    }
    return result;
}
/**
 * Sanitize `node`.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<unknown>} node
 *   Unsafe node.
 * @returns {Array<ElementContent> | Nodes | undefined}
 *   Safe result.
 */ function $d53ef575c839fd46$var$transform(state, node) {
    if (node && typeof node === 'object') {
        const unsafe = /** @type {Record<string, Readonly<unknown>>} */ node;
        const type = typeof unsafe.type === 'string' ? unsafe.type : '';
        switch(type){
            case 'comment':
                return $d53ef575c839fd46$var$comment(state, unsafe);
            case 'doctype':
                return $d53ef575c839fd46$var$doctype(state, unsafe);
            case 'element':
                return $d53ef575c839fd46$var$element(state, unsafe);
            case 'root':
                return $d53ef575c839fd46$var$root(state, unsafe);
            case 'text':
                return $d53ef575c839fd46$var$text(state, unsafe);
            default:
        }
    }
}
/**
 * Make a safe comment.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<Record<string, Readonly<unknown>>>} unsafe
 *   Unsafe comment-like value.
 * @returns {Comment | undefined}
 *   Safe comment (if with `allowComments`).
 */ function $d53ef575c839fd46$var$comment(state, unsafe) {
    if (state.schema.allowComments) {
        // See <https://html.spec.whatwg.org/multipage/parsing.html#serialising-html-fragments>
        const result = typeof unsafe.value === 'string' ? unsafe.value : '';
        const index = result.indexOf('-->');
        const value = index < 0 ? result : result.slice(0, index);
        /** @type {Comment} */ const node = {
            type: 'comment',
            value: value
        };
        $d53ef575c839fd46$var$patch(node, unsafe);
        return node;
    }
}
/**
 * Make a safe doctype.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<Record<string, Readonly<unknown>>>} unsafe
 *   Unsafe doctype-like value.
 * @returns {Doctype | undefined}
 *   Safe doctype (if with `allowDoctypes`).
 */ function $d53ef575c839fd46$var$doctype(state, unsafe) {
    if (state.schema.allowDoctypes) {
        /** @type {Doctype} */ const node = {
            type: 'doctype'
        };
        $d53ef575c839fd46$var$patch(node, unsafe);
        return node;
    }
}
/**
 * Make a safe element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<Record<string, Readonly<unknown>>>} unsafe
 *   Unsafe element-like value.
 * @returns {Array<ElementContent> | Element | undefined}
 *   Safe element.
 */ function $d53ef575c839fd46$var$element(state, unsafe) {
    const name = typeof unsafe.tagName === 'string' ? unsafe.tagName : '';
    state.stack.push(name);
    const content = /** @type {Array<ElementContent>} */ $d53ef575c839fd46$var$children(state, unsafe.children);
    const properties_ = $d53ef575c839fd46$var$properties(state, unsafe.properties);
    state.stack.pop();
    let safeElement = false;
    if (name && name !== '*' && (!state.schema.tagNames || state.schema.tagNames.includes(name))) {
        safeElement = true;
        // Some nodes can break out of their context if they don’t have a certain
        // ancestor.
        if (state.schema.ancestors && $d53ef575c839fd46$var$own.call(state.schema.ancestors, name)) {
            const ancestors = state.schema.ancestors[name];
            let index = -1;
            safeElement = false;
            while(++index < ancestors.length)if (state.stack.includes(ancestors[index])) safeElement = true;
        }
    }
    if (!safeElement) return state.schema.strip && !state.schema.strip.includes(name) ? content : undefined;
    /** @type {Element} */ const node = {
        type: 'element',
        tagName: name,
        properties: properties_,
        children: content
    };
    $d53ef575c839fd46$var$patch(node, unsafe);
    return node;
}
/**
 * Make a safe root.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<Record<string, Readonly<unknown>>>} unsafe
 *   Unsafe root-like value.
 * @returns {Root}
 *   Safe root.
 */ function $d53ef575c839fd46$var$root(state, unsafe) {
    const content = /** @type {Array<RootContent>} */ $d53ef575c839fd46$var$children(state, unsafe.children);
    /** @type {Root} */ const node = {
        type: 'root',
        children: content
    };
    $d53ef575c839fd46$var$patch(node, unsafe);
    return node;
}
/**
 * Make a safe text.
 *
 * @param {State} _
 *   Info passed around.
 * @param {Readonly<Record<string, Readonly<unknown>>>} unsafe
 *   Unsafe text-like value.
 * @returns {Text}
 *   Safe text.
 */ function $d53ef575c839fd46$var$text(_, unsafe) {
    const value = typeof unsafe.value === 'string' ? unsafe.value : '';
    /** @type {Text} */ const node = {
        type: 'text',
        value: value
    };
    $d53ef575c839fd46$var$patch(node, unsafe);
    return node;
}
/**
 * Make children safe.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<unknown>} children
 *   Unsafe value.
 * @returns {Array<Nodes>}
 *   Safe children.
 */ function $d53ef575c839fd46$var$children(state, children) {
    /** @type {Array<Nodes>} */ const results = [];
    if (Array.isArray(children)) {
        const childrenUnknown = /** @type {Array<Readonly<unknown>>} */ children;
        let index = -1;
        while(++index < childrenUnknown.length){
            const value = $d53ef575c839fd46$var$transform(state, childrenUnknown[index]);
            if (value) {
                if (Array.isArray(value)) results.push(...value);
                else results.push(value);
            }
        }
    }
    return results;
}
/**
 * Make element properties safe.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<unknown>} properties
 *   Unsafe value.
 * @returns {Properties}
 *   Safe value.
 */ function $d53ef575c839fd46$var$properties(state, properties) {
    const tagName = state.stack[state.stack.length - 1];
    const attributes = state.schema.attributes;
    const required = state.schema.required;
    const specific = attributes && $d53ef575c839fd46$var$own.call(attributes, tagName) ? attributes[tagName] : undefined;
    const defaults = attributes && $d53ef575c839fd46$var$own.call(attributes, '*') ? attributes['*'] : undefined;
    const properties_ = /** @type {Readonly<Record<string, Readonly<unknown>>>} */ properties && typeof properties === 'object' ? properties : {};
    /** @type {Properties} */ const result = {};
    /** @type {string} */ let key;
    for(key in properties_)if ($d53ef575c839fd46$var$own.call(properties_, key)) {
        const unsafe = properties_[key];
        let safe = $d53ef575c839fd46$var$propertyValue(state, $d53ef575c839fd46$var$findDefinition(specific, key), key, unsafe);
        if (safe === null || safe === undefined) safe = $d53ef575c839fd46$var$propertyValue(state, $d53ef575c839fd46$var$findDefinition(defaults, key), key, unsafe);
        if (safe !== null && safe !== undefined) result[key] = safe;
    }
    if (required && $d53ef575c839fd46$var$own.call(required, tagName)) {
        const properties = required[tagName];
        for(key in properties)if ($d53ef575c839fd46$var$own.call(properties, key) && !$d53ef575c839fd46$var$own.call(result, key)) result[key] = properties[key];
    }
    return result;
}
/**
 * Sanitize a property value.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<PropertyDefinition> | undefined} definition
 *   Definition.
 * @param {string} key
 *   Field name.
 * @param {Readonly<unknown>} value
 *   Unsafe value (but an array).
 * @returns {Array<number | string> | boolean | number | string | undefined}
 *   Safe value.
 */ function $d53ef575c839fd46$var$propertyValue(state, definition, key, value) {
    return definition ? Array.isArray(value) ? $d53ef575c839fd46$var$propertyValueMany(state, definition, key, value) : $d53ef575c839fd46$var$propertyValuePrimitive(state, definition, key, value) : undefined;
}
/**
 * Sanitize a property value which is a list.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<PropertyDefinition>} definition
 *   Definition.
 * @param {string} key
 *   Field name.
 * @param {Readonly<Array<Readonly<unknown>>>} values
 *   Unsafe value (but an array).
 * @returns {Array<number | string>}
 *   Safe value.
 */ function $d53ef575c839fd46$var$propertyValueMany(state, definition, key, values) {
    let index = -1;
    /** @type {Array<number | string>} */ const result = [];
    while(++index < values.length){
        const value = $d53ef575c839fd46$var$propertyValuePrimitive(state, definition, key, values[index]);
        if (typeof value === 'number' || typeof value === 'string') result.push(value);
    }
    return result;
}
/**
 * Sanitize a property value which is a primitive.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<PropertyDefinition>} definition
 *   Definition.
 * @param {string} key
 *   Field name.
 * @param {Readonly<unknown>} value
 *   Unsafe value (but not an array).
 * @returns {boolean | number | string | undefined}
 *   Safe value.
 */ function $d53ef575c839fd46$var$propertyValuePrimitive(state, definition, key, value) {
    if (typeof value !== 'boolean' && typeof value !== 'number' && typeof value !== 'string') return;
    if (!$d53ef575c839fd46$var$safeProtocol(state, key, value)) return;
    // Just a string, or only one item in an array, means all values are OK.
    // More than one item means an allow list.
    if (typeof definition === 'object' && definition.length > 1) {
        let ok = false;
        let index = 0 // Ignore `key`, which is the first item.
        ;
        while(++index < definition.length){
            const allowed = definition[index];
            // Expression.
            if (allowed && typeof allowed === 'object' && 'flags' in allowed) {
                if (allowed.test(String(value))) {
                    ok = true;
                    break;
                }
            } else if (allowed === value) {
                ok = true;
                break;
            }
        }
        if (!ok) return;
    }
    return state.schema.clobber && state.schema.clobberPrefix && state.schema.clobber.includes(key) ? state.schema.clobberPrefix + value : value;
}
/**
 * Check whether `value` is a safe URL.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} key
 *   Field name.
 * @param {Readonly<unknown>} value
 *   Unsafe value.
 * @returns {boolean}
 *   Whether it’s a safe value.
 */ function $d53ef575c839fd46$var$safeProtocol(state, key, value) {
    const protocols = state.schema.protocols && $d53ef575c839fd46$var$own.call(state.schema.protocols, key) ? state.schema.protocols[key] : undefined;
    // No protocols defined? Then everything is fine.
    if (!protocols || protocols.length === 0) return true;
    const url = String(value);
    const colon = url.indexOf(':');
    const questionMark = url.indexOf('?');
    const numberSign = url.indexOf('#');
    const slash = url.indexOf('/');
    if (colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign) return true;
    let index = -1;
    while(++index < protocols.length){
        const protocol = protocols[index];
        if (colon === protocol.length && url.slice(0, protocol.length) === protocol) return true;
    }
    return false;
}
/**
 * Add data and position.
 *
 * @param {Nodes} node
 *   Node to patch safe data and position on.
 * @param {Readonly<Record<string, Readonly<unknown>>>} unsafe
 *   Unsafe node-like value.
 * @returns {undefined}
 *   Nothing.
 */ function $d53ef575c839fd46$var$patch(node, unsafe) {
    const cleanPosition = (0, $9861e7b4f8df2806$export$5880b8b5730aff45)(// @ts-expect-error: looks like a node.
    unsafe);
    if (unsafe.data) node.data = (0, $e46c0242ff031819$export$2e2bcd8739ae039)(unsafe.data);
    if (cleanPosition) node.position = cleanPosition;
}
/**
 *
 * @param {Readonly<Array<PropertyDefinition>> | undefined} definitions
 * @param {string} key
 * @returns {Readonly<PropertyDefinition> | undefined}
 */ function $d53ef575c839fd46$var$findDefinition(definitions, key) {
    /** @type {PropertyDefinition | undefined} */ let dataDefault;
    let index = -1;
    if (definitions) while(++index < definitions.length){
        const entry = definitions[index];
        const name = typeof entry === 'string' ? entry : entry[0];
        if (name === key) return entry;
        if (name === 'data*') dataDefault = entry;
    }
    if (key.length > 4 && key.slice(0, 4).toLowerCase() === 'data') return dataDefault;
}


function $952077a98b509239$export$2e2bcd8739ae039(options) {
    /**
   * @param {Root} tree
   *   Tree.
   * @returns {Root}
   *   New tree.
   */ return function(tree) {
        // Assume root in -> root out.
        const result = /** @type {Root} */ (0, $d53ef575c839fd46$export$83d2e9e3e4ee39ed)(tree, options);
        return result;
    };
}



function $e5b2f0df2c7643ec$export$2e2bcd8739ae039({ markdown: markdown }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $10952db78fee7c4f$export$2def7183994512e9), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $09cf8ac2a6e57519$export$7460c8b7e4ce9582), {
            remarkPlugins: [
                (0, $78aec921ddca40c1$export$2e2bcd8739ae039)
            ],
            rehypePlugins: [
                (0, $952077a98b509239$export$2e2bcd8739ae039)
            ],
            children: markdown
        })
    });
}


function $015587f0fc8dd8b7$export$2e2bcd8739ae039() {
    const { currentOrg: currentOrg } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    if (!currentOrg) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            currentOrg.customResourcesMarkdown && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5b2f0df2c7643ec$export$2e2bcd8739ae039), {
                markdown: currentOrg.customResourcesMarkdown
            }),
            currentOrg.customResourcesMarkdown && currentOrg.managedResourcesMarkdown && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($015587f0fc8dd8b7$var$Break, {}),
            currentOrg.managedResourcesMarkdown && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5b2f0df2c7643ec$export$2e2bcd8739ae039), {
                markdown: currentOrg.managedResourcesMarkdown
            })
        ]
    });
}
const $015587f0fc8dd8b7$var$Break = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    margin: 0;
    border-radius: 10px;
    border-top: 6px solid ${({ theme: theme })=>theme.color.text};
    width: 100%;
`;




function $0870cb345d848b86$export$2e2bcd8739ae039() {
    (0, $70228be3ff15ddce$export$f08c2f745253d47b)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:resources.title'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $015587f0fc8dd8b7$export$2e2bcd8739ae039), {})
        ]
    });
}













function $5edf99d7a6a3464e$export$2e2bcd8739ae039({ open: open, onClose: onClose, orgId: orgId, canManageBilling: canManageBilling = false }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const { currentOrg: currentOrg } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const onConfirm = ()=>{
        onClose();
        if (canManageBilling) navigate(`/org/${orgId}/billing/redirect/upgrade`);
    };
    return canManageBilling == true ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        onCancel: onClose,
        title: t('common:organization.member.seats.updateLimit.title'),
        description: t('common:organization.member.seats.updateLimit.description', 'Limit reached', {
            maxSeats: currentOrg?.maxMembers
        }),
        confirmButtonText: t('common:organization.member.seats.updateLimit.action'),
        onConfirm: onConfirm
    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        title: t('common:organization.member.seats.limit.title'),
        description: t('common:organization.member.seats.limit.description', 'Limit reached', {
            maxSeats: currentOrg?.maxMembers
        }),
        confirmButtonText: t('common:close'),
        onConfirm: onConfirm
    });
}




var $7fPBF = parcelRequire("7fPBF");









var $7fPBF = parcelRequire("7fPBF");

const $7fcb1b0f8c5b974b$var$TextFieldWithValidation = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function TextFieldWithValidation({ label: label, value: value, placeholder: placeholder, hasError: hasError, helperTextMessageOnError: helperTextMessageOnError, onChange: onChange, inputProps: inputProps, helperTextSuccess: helperTextSuccess = null, onFocus: onFocus = onChange }, ref) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
        inputRef: ref,
        inputProps: inputProps,
        fullWidth: true,
        label: label,
        value: value,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        type: "text",
        error: hasError,
        FormHelperTextProps: {
            component: 'div'
        },
        helperText: hasError && helperTextMessageOnError ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7fcb1b0f8c5b974b$var$ErrorHelpText, {
            helpMessage: helperTextMessageOnError
        }) : helperTextSuccess
    });
});
const $7fcb1b0f8c5b974b$var$ErrorHelpText = ({ helpMessage: helpMessage })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fcb1b0f8c5b974b$var$StyledErrorHelpText, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                name: "warning",
                color: (0, $8951886a6b49e92a$export$35e9368ef982300f).error
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$7f714e6c560938e5), {
                children: helpMessage
            })
        ]
    });
};
const $7fcb1b0f8c5b974b$var$StyledErrorHelpText = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div')`
    display: flex;
    gap: 0.5rem;
    padding: 5px;
`;
var $7fcb1b0f8c5b974b$export$2e2bcd8739ae039 = $7fcb1b0f8c5b974b$var$TextFieldWithValidation;



const $a387e7d4ce3b8793$export$54571ac7cbe36b70 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem 0;
    border-bottom: 1px solid ${(props)=>props.theme.input.background};
    margin: 0 0 1rem 0;
`;
const $a387e7d4ce3b8793$export$78b81e628c724207 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    padding: 0 1.5rem;
    width: 100%;
`;
const $a387e7d4ce3b8793$export$7c14887e48a97962 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;









const $21f5b9af76a0c38b$export$3e3aaa3680e7023b = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $3f15ab21d190f284$export$2e2bcd8739ae039))`
    padding: 0 0 2rem 0;
`;
const $21f5b9af76a0c38b$export$b5d5cf8927ab7262 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $01917f736960ab46$export$2e2bcd8739ae039))`
    :focus-within {
        outline: 3px solid ${(0, $8951886a6b49e92a$export$35e9368ef982300f).accent};
    }
`;
const $21f5b9af76a0c38b$export$59e5bd234d7e3579 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$d9f4918700223049))`
    text-align: center;
    margin: 0 0 16px 0;
`.withComponent('p');
const $21f5b9af76a0c38b$export$f60fd70865eea589 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    width: 100%;
    padding: 1rem 0;
`;
const $21f5b9af76a0c38b$export$1f54913ccc4368b1 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    width: 100%;
    gap: 0.5rem;
    & label {
        align-self: flex-start;
    }
`;
const $21f5b9af76a0c38b$export$2d00230e1e6f7fbc = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $cd2b84e36aef1fba$export$2e2bcd8739ae039))`
    gap: 0.5rem;
`;





function $777249ad5835b0ee$var$RoleEditor({ myRole: myRole, role: role, title: title, titleDescription: titleDescription, includeDescription: includeDescription = true, onChange: onChange }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const handleChange = (event)=>{
        const { name: name, checked: checked } = event.target;
        // If toggling isAdmin, update all permissions
        if (name === 'isAdmin' && checked) {
            const updatedRole = {
                ...role
            };
            Object.keys(role).forEach((key)=>{
                updatedRole[key] = true;
            });
            onChange(updatedRole);
        } else onChange({
            ...role,
            [name]: checked
        });
    };
    const accessibleRoles = Object.keys(role).filter((key)=>{
        const typedKey = key;
        return myRole.isAdmin || myRole[typedKey];
    });
    if (!myRole.isAdmin && role.isAdmin) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $12a7318cc7b914d5$export$bdfe625add29c644), {
        $color: "default",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                name: "warning"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                children: t('common:organization.isAdmin.conflict')
            })
        ]
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $21f5b9af76a0c38b$export$2d00230e1e6f7fbc), {
        children: [
            title && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$2c65789109b698b0), {
                children: title
            }),
            titleDescription && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                children: titleDescription
            }),
            accessibleRoles.map((key)=>{
                const typedKey = key;
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
                    control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $21f5b9af76a0c38b$export$b5d5cf8927ab7262), {
                        disabled: typedKey !== 'isAdmin' && role.isAdmin,
                        checked: role[typedKey] ?? false,
                        onChange: handleChange,
                        name: typedKey
                    }),
                    label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                        children: includeDescription ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e), {
                                    as: "span",
                                    children: t(`common:organization.${typedKey}.title`)
                                }),
                                ': ',
                                t(`common:organization.${typedKey}.description`)
                            ]
                        }) : t(`common:organization.${typedKey}.title`)
                    })
                }, key);
            })
        ]
    });
}
var $777249ad5835b0ee$export$2e2bcd8739ae039 = $777249ad5835b0ee$var$RoleEditor;





var $7fPBF = parcelRequire("7fPBF");

function $ad7bfeb7fe241d67$export$2e2bcd8739ae039({ open: open, onClose: onClose, myRole: myRole, organizationId: organizationId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const alertsContainer = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const organizationContainer = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const newMemberRole = {
        isAdmin: false,
        canViewMembers: false,
        canInviteMembers: false,
        canChangeMemberPermissions: false,
        canRemoveMembers: false,
        canCreateAuthClients: false,
        canViewAuthClients: false,
        canManageBilling: false,
        canViewAnalytics: false,
        canManageChildOrganizations: false,
        canAccessOrganizationProfiles: false,
        canEditOrganizationProfiles: false
    };
    const initialInvite = {
        email: '',
        ...newMemberRole
    };
    const [invite, setInvite] = (0, $7fPBF.useState)(initialInvite);
    const [role, setRole] = (0, $7fPBF.useState)(newMemberRole);
    const [emailValidation, setEmailValidation] = (0, $7fPBF.useState)(null);
    (0, $7fPBF.useEffect)(()=>{
        if (invite?.email) setEmailValidation(null);
    }, [
        invite
    ]);
    const handleRoleChange = (updatedRole)=>{
        const newRole = {
            ...updatedRole
        };
        if (newRole.isAdmin) {
            for(const key in updatedRole)if (Object.prototype.hasOwnProperty.call(updatedRole, key)) {
                const typedKey = key;
                newRole[typedKey] = true;
            }
        }
        setRole(newRole);
        setInvite({
            ...invite,
            ...newRole
        });
    };
    const handleInviteChange = (event)=>{
        const { value: value } = event.target;
        setInvite({
            ...invite,
            email: value
        });
    };
    const handleSave = async ()=>{
        if (!invite.email) {
            setEmailValidation(t('common:organization.invite.emailRequired'));
            return;
        }
        if (invite.email && !invite.email?.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
            setEmailValidation(t('common:organization.invite.emailInvalid'));
            return;
        }
        const thisOrg = organizationContainer.invitesRef.current?.find((org)=>org.organizationId === organizationId);
        if (thisOrg && thisOrg.invites?.some((existingInvite)=>existingInvite.email === invite.email && new Date(existingInvite.expirationDate) > new Date())) {
            // invite already exists
            setEmailValidation(t('common:organization.invite.emailExists'));
            return;
        }
        const membersResult = await organizationContainer.loadOrganizationMembers(organizationId);
        if (membersResult.resultType === 'Ok' && membersResult.data) {
            const existingMember = membersResult.data.find((member)=>member.user.email === invite.email);
            if (existingMember) {
                // member already exists
                setEmailValidation(t('common:organization.member.emailExists'));
                return;
            }
        }
        const result = await organizationContainer.createOrganizationInvite(organizationId, invite);
        if (result?.resultType == 'Ok') alertsContainer.showSuccess(t('common:organization.invite.send.success', 'Success', {
            value: invite.email
        }));
        else // console.log(result);
        alertsContainer.showError(t('common:organization.invite.send.error', 'Error with invite', {
            value: invite.email
        }));
        onClose();
        setRole({
            ...newMemberRole
        });
        setInvite({
            ...initialInvite
        });
    };
    if (!organizationId || !myRole) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        fullWidth: true,
        open: open,
        onClose: onClose,
        onCancel: onClose,
        title: t('common:organization.invite.edit'),
        description: t('common:organization.invite.editDescription'),
        confirmButtonText: t('common:organization.invite.send.title'),
        onConfirm: handleSave,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a387e7d4ce3b8793$export$54571ac7cbe36b70), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fcb1b0f8c5b974b$export$2e2bcd8739ae039), {
                    required: true,
                    label: "Email",
                    value: invite?.email,
                    placeholder: 'email@email.com',
                    hasError: !!emailValidation,
                    helperTextMessageOnError: emailValidation,
                    onChange: handleInviteChange
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $777249ad5835b0ee$export$2e2bcd8739ae039), {
                title: t('common:organization.role.title'),
                myRole: myRole,
                role: role,
                onChange: handleRoleChange
            })
        ]
    });
}


function $24d7412693118a64$export$2e2bcd8739ae039({ myRole: myRole, organizationId: organizationId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [openDialog, setOpenDialog] = (0, $7fPBF.useState)(false);
    const handleOpenDialog = ()=>setOpenDialog(true);
    const handleCloseDialog = ()=>setOpenDialog(false);
    const { remainingSeats: remainingSeats } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    if (!myRole || !organizationId) return null;
    if (!myRole.canInviteMembers && !myRole.isAdmin) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                $color: "secondary",
                onClick: handleOpenDialog,
                startIcon: "plus",
                children: t('common:organization.invite.edit')
            }),
            remainingSeats > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ad7bfeb7fe241d67$export$2e2bcd8739ae039), {
                open: openDialog,
                onClose: handleCloseDialog,
                organizationId: organizationId,
                myRole: myRole
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5edf99d7a6a3464e$export$2e2bcd8739ae039), {
                open: openDialog,
                onClose: handleCloseDialog,
                orgId: organizationId,
                canManageBilling: myRole?.canManageBilling || myRole?.isAdmin
            })
        ]
    });
}








function $e7ac331879f72d98$export$2e2bcd8739ae039({ onNext: onNext, onPrevious: onPrevious, disableNext: disableNext, disablePrevious: disablePrevious, nextButtonText: nextButtonText, previousButtonText: previousButtonText }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$81ea29a9084db687), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                $color: "secondary",
                $size: "small",
                startIcon: "previous",
                onClick: onPrevious,
                disabled: disablePrevious,
                children: previousButtonText ?? t('common:previous')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e7ac331879f72d98$var$StyledNextButton, {
                $color: "secondary",
                $size: "small",
                onClick: onNext,
                endIcon: "previous",
                disabled: disableNext,
                children: nextButtonText ?? t('common:next')
            })
        ]
    });
}
const $e7ac331879f72d98$var$StyledNextButton = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039))`
    svg {
        transform: rotate(180deg);
    }
`;







const $d227fca458ea4785$export$68befc518ea2400f = (member)=>{
    const { isAdmin: isAdmin, canViewMembers: canViewMembers, canInviteMembers: canInviteMembers, canChangeMemberPermissions: canChangeMemberPermissions, canRemoveMembers: canRemoveMembers, canCreateAuthClients: canCreateAuthClients, canViewAuthClients: canViewAuthClients, canManageBilling: canManageBilling, canManageChildOrganizations: canManageChildOrganizations, canViewAnalytics: canViewAnalytics, canAccessOrganizationProfiles: canAccessOrganizationProfiles, canEditOrganizationProfiles: canEditOrganizationProfiles } = member;
    return {
        isAdmin: isAdmin,
        canViewMembers: canViewMembers,
        canInviteMembers: canInviteMembers,
        canChangeMemberPermissions: canChangeMemberPermissions,
        canRemoveMembers: canRemoveMembers,
        canCreateAuthClients: canCreateAuthClients,
        canViewAuthClients: canViewAuthClients,
        canManageBilling: canManageBilling,
        canManageChildOrganizations: canManageChildOrganizations,
        canViewAnalytics: canViewAnalytics,
        canAccessOrganizationProfiles: canAccessOrganizationProfiles,
        canEditOrganizationProfiles: canEditOrganizationProfiles
    };
};





var $7fPBF = parcelRequire("7fPBF");

function $243f463264eb1fab$export$7cca17e0b77721be() {
    const { organizationId: organizationId } = (0, $748d28edcc8cedba$export$2e2bcd8739ae039)();
    const { invites: orgInvites, invitesRef: invitesRef, loadInvites: loadInvites, loadingData: loadingData, loadingDataRef: loadingDataRef, handleLoadingDataChange: handleLoadingDataChange } = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const invites = (0, $7fPBF.useMemo)(()=>{
        if (!organizationId || loadingDataRef.current.invites == true) return null;
        return invitesRef.current.find((org)=>org.organizationId === organizationId)?.invites ?? [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        organizationId,
        orgInvites
    ]);
    (0, $7fPBF.useEffect)(()=>{
        async function fetchInvites() {
            if (!organizationId || loadingDataRef.current.invites == true) return;
            handleLoadingDataChange('invites', true);
            if (invitesRef.current.find((org)=>org.organizationId === organizationId)?.invites) {
                handleLoadingDataChange('invites', false);
                return;
            }
            try {
                const result = await loadInvites(organizationId);
                if (result?.resultType !== 'Ok') console.error('Failed to load invites for organization:', organizationId);
            } catch (error) {
                console.error('Error loading invites.');
            } finally{
                handleLoadingDataChange('invites', false);
            }
        }
        fetchInvites();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        organizationId
    ]);
    return {
        invites: invites,
        isLoading: loadingData.invites
    };
}



var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");

/**
 * Scrolls to an element with the given elementId
 * @param elementId ID of the element to scroll to
 * @param dependentParams Additional dependencies for the scroll effect
 * @param additionalConditions Optional conditions that must be met to trigger the scroll
 */ const $d856e666394c520b$var$useScrollToElement = (elementId, dependentParams = [], additionalConditions = [])=>{
    const isReducedMotion = (0, $b1f35a815c258980$export$2e2bcd8739ae039)();
    const [scrollCount, setScrollCount] = (0, $7fPBF.useState)(0);
    (0, $7fPBF.useEffect)(()=>{
        if (!elementId) return;
        const element = document.getElementById(elementId);
        const shouldScroll = additionalConditions.length === 0 || additionalConditions.some((condition)=>condition);
        if (element && shouldScroll) {
            element.focus();
            element.scrollIntoView({
                behavior: isReducedMotion ? 'instant' : 'smooth'
            });
        }
    }, [
        ...dependentParams,
        elementId,
        isReducedMotion,
        scrollCount
    ]);
    // Forces a re-scroll even when clicking the same element
    const triggerScroll = ()=>{
        setScrollCount(scrollCount + 1);
    };
    return triggerScroll;
};
var $d856e666394c520b$export$2e2bcd8739ae039 = $d856e666394c520b$var$useScrollToElement;



function $a552b14f0ac5e4a1$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { currentOrg: currentOrg } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const { showError: showError } = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const organizationContainer = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const orgInvitesSearchContentId = 'org-invites-search';
    const defaultTake = 51;
    const displayLimit = defaultTake - 1;
    const [searchQuery, setSearchQuery] = (0, $7fPBF.useState)('');
    const [debouncedQuery, setDebouncedQuery] = (0, $7fPBF.useState)({
        searchText: '',
        skip: 0,
        take: defaultTake
    });
    const invites = (0, $7fPBF.useMemo)(()=>{
        if (!currentOrg || organizationContainer.loadingDataRef.current.invites == true) return null;
        return organizationContainer.invitesRef.current.find((org)=>org.organizationId === currentOrg.id)?.invites ?? [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentOrg,
        organizationContainer.invites
    ]);
    (0, $d856e666394c520b$export$2e2bcd8739ae039)(orgInvitesSearchContentId, [
        debouncedQuery.skip
    ]);
    function handleSearchQueryChange(value) {
        setSearchQuery(value);
    }
    const showPrevious = (0, $7fPBF.useMemo)(()=>debouncedQuery.skip && debouncedQuery.skip > 0, [
        debouncedQuery.skip
    ]);
    const showNext = (0, $7fPBF.useMemo)(()=>organizationContainer.invites.length >= displayLimit, [
        organizationContainer.invites
    ]);
    const DEBOUNCE_DELAY = 500;
    (0, $7fPBF.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            const newQuery = {
                searchText: searchQuery,
                skip: 0,
                take: defaultTake
            };
            if (newQuery.searchText !== debouncedQuery.searchText) setDebouncedQuery(newQuery);
        }, DEBOUNCE_DELAY);
        return ()=>clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchQuery
    ]);
    const handleNext = ()=>{
        const count = organizationContainer.invitesRef.current.length;
        setDebouncedQuery((prev)=>({
                ...prev,
                take: defaultTake,
                skip: displayLimit + (prev.skip ?? 0)
            }));
    };
    const handlePrevious = ()=>{
        const count = organizationContainer.invitesRef.current.length;
        setDebouncedQuery((prev)=>({
                ...prev,
                take: defaultTake,
                skip: Math.max(0, (prev.skip ?? 0) - displayLimit)
            }));
    };
    (0, $7fPBF.useEffect)(()=>{
        const trySearch = async ()=>{
            if (organizationContainer.loadingDataRef.current.invites) return;
            if (!currentOrg) return;
            try {
                organizationContainer.handleLoadingDataChange('invites', true);
                await organizationContainer.loadInvites(currentOrg.id, debouncedQuery);
            } catch (e) {
                showError(t('common:organization.invite.error'));
            } finally{
                organizationContainer.handleLoadingDataChange('invites', false);
            }
        };
        trySearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        debouncedQuery
    ]);
    return {
        results: invites,
        orgInvitesSearchContentId: orgInvitesSearchContentId,
        handleSearchQueryChange: handleSearchQueryChange,
        searchQuery: searchQuery,
        showPrevious: showPrevious,
        showNext: showNext,
        handleNext: handleNext,
        handlePrevious: handlePrevious,
        isLoading: organizationContainer.loadingData.invites
    };
}







function $f8f95b189a35cb2e$export$2e2bcd8739ae039({ title: title, description: description, children: children }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
        description: description ?? t('common:organization.noAccess.description'),
        fullHeight: true,
        icon: "cancel",
        title: title ?? t('common:organization.projects.accessDenied.title'),
        children: children ? children : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
            href: "#",
            startIcon: "back",
            children: t('common:back')
        })
    });
}





const $ac3fc121a11fd783$export$c14c794fcd73bed8 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
`;
const $ac3fc121a11fd783$export$2b64bc092bad4151 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;















function $6b6dbe5e3c17f869$export$2e2bcd8739ae039({ icon: icon, title: title, active: active = true, variant: variant = 'default', chip: chip = false, iconSize: iconSize = 24 }) {
    const BodyComponent = variant === 'default' ? (0, $b091aef3a32d2bd8$export$b312780b0d72eabb) : (0, $b091aef3a32d2bd8$export$1ef657600983666a);
    if (!title) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($6b6dbe5e3c17f869$var$MemberDetail, {
        variant: variant,
        chip: chip,
        children: [
            icon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                name: icon,
                size: iconSize
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(BodyComponent, {
                children: active ? title : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6b6dbe5e3c17f869$var$StrikeThrough, {
                    "aria-hidden": true,
                    children: title
                })
            })
        ]
    });
}
const $6b6dbe5e3c17f869$var$StrikeThrough = (0, $8de346382d86c747$export$2e2bcd8739ae039).s`
    text-decoration: line-through;
    color: ${({ theme: theme })=>theme.color.neutral + '90'};
`;
const $6b6dbe5e3c17f869$var$chipStyle = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
    margin: 0 10px;
`;
const $6b6dbe5e3c17f869$var$MemberDetail = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    align-items: center;
    gap: ${({ variant: variant })=>variant === 'default' ? '0.5rem' : '0.25rem'};
    ${({ chip: chip })=>chip && $6b6dbe5e3c17f869$var$chipStyle}
`;





const $5d595f963199dd48$export$f45ccdad2e79cfb4 = {
    isAdmin: 'orgAdmin',
    canViewMembers: 'orgMembers',
    canInviteMembers: 'orgInvite',
    canChangeMemberPermissions: 'orgPermissions',
    canRemoveMembers: 'orgDeleteUser',
    canCreateAuthClients: 'orgAuthClient',
    canViewAuthClients: 'orgAuthClient',
    canManageBilling: 'orgTransaction',
    canManageChildOrganizations: 'orgAdmin',
    canViewAnalytics: 'futures',
    canAccessOrganizationProfiles: 'purchaseOrder',
    canEditOrganizationProfiles: 'purchaseOrder'
};




function $2427d6ebbf2e60fd$export$2e2bcd8739ae039({ role: role, variant: variant = 'stack' }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const randomUUID = (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)();
    const renderMemberDetailItems = (keys, activeKeys)=>keys.map((key)=>{
            const typedKey = key;
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6b6dbe5e3c17f869$export$2e2bcd8739ae039), {
                chip: true,
                active: role[typedKey],
                variant: "small",
                title: t(`common:organization.${typedKey}.title`)
            }, randomUUID + typedKey);
        });
    if (!role) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2427d6ebbf2e60fd$var$IconWrapper, {
            children: renderMemberDetailItems(Object.keys((0, $5d595f963199dd48$export$f45ccdad2e79cfb4)), Object.keys(role))
        })
    });
}
const $2427d6ebbf2e60fd$var$IconWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    gap: 0.5rem;
`;


function $6a93256354a6d378$export$2e2bcd8739ae039({ invite: invite, hideEmail: hideEmail, hideWrapper: hideWrapper }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const getRelativeTime = (0, $1e6a0781013949e7$export$2e2bcd8739ae039)();
    if (!invite) return null;
    const content = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a387e7d4ce3b8793$export$7c14887e48a97962), {
        children: [
            !hideEmail && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6b6dbe5e3c17f869$export$2e2bcd8739ae039), {
                icon: "mail",
                title: invite.email
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2427d6ebbf2e60fd$export$2e2bcd8739ae039), {
                variant: "listOnly",
                role: (0, $d227fca458ea4785$export$68befc518ea2400f)(invite)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6b6dbe5e3c17f869$export$2e2bcd8739ae039), {
                iconSize: 16,
                variant: "small",
                icon: "orgInviteExpired",
                title: t('common:organization.invite.expiration') + getRelativeTime(new Date(invite.expirationDate))
            })
        ]
    });
    return hideWrapper ? content : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a387e7d4ce3b8793$export$54571ac7cbe36b70), {
        children: content
    });
}








var $7fPBF = parcelRequire("7fPBF");


function $7ebdde8f38264897$export$2e2bcd8739ae039({ invite: invite }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const organizationContainer = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const [showRemoveDialog, setShowRemoveDialog] = (0, $7fPBF.useState)(false);
    const handleRemove = ()=>{
        setShowRemoveDialog(true);
    };
    const handleCancelRemove = ()=>{
        setShowRemoveDialog(false);
    };
    const handleConfirmDeleteInvite = async ()=>{
        if (invite.organizationId) await organizationContainer.deleteOrganizationInvite(invite.organizationId, invite.id);
        setShowRemoveDialog(false);
    };
    if (!invite) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                variant: "negative",
                startIcon: "delete",
                onClick: handleRemove,
                children: t('common:delete')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
                open: showRemoveDialog,
                onConfirm: handleConfirmDeleteInvite,
                onCancel: handleCancelRemove,
                onClose: handleCancelRemove,
                title: t('common:organization.invite.confirm'),
                confirmButtonText: t('common:organization.invite.delete'),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6a93256354a6d378$export$2e2bcd8739ae039), {
                            invite: invite
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                            children: t('common:organization.invite.confirmLong')
                        })
                    ]
                })
            })
        ]
    });
}


function $f0e163beadbbd519$export$2e2bcd8739ae039({ invite: invite, myRole: myRole }) {
    if (!myRole || !invite) return null;
    if (!myRole.canRemoveMembers && !myRole.isAdmin) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $347ffda0d89c401a$export$a27f3c48b2f1c458), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $347ffda0d89c401a$export$9de46b28c4f6c978), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ac3fc121a11fd783$export$c14c794fcd73bed8), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ac3fc121a11fd783$export$2b64bc092bad4151), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                    name: "orgInvite",
                                    size: 35
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$68b378fffb2ccca3), {
                                    children: invite.email
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ac3fc121a11fd783$export$2b64bc092bad4151), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7ebdde8f38264897$export$2e2bcd8739ae039), {
                                invite: invite
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a387e7d4ce3b8793$export$78b81e628c724207), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6a93256354a6d378$export$2e2bcd8739ae039), {
                        hideWrapper: true,
                        hideEmail: true,
                        invite: invite
                    })
                })
            ]
        })
    });
}






function $07e53c7e95507174$export$2e2bcd8739ae039({ myRole: myRole, organizationId: organizationId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
        description: t('common:organization.invite.noInvites.description'),
        fullHeight: true,
        icon: "orgCompany",
        title: t('common:organization.invite.noInvites.title'),
        children: myRole && organizationId && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $24d7412693118a64$export$2e2bcd8739ae039), {
            organizationId: organizationId,
            myRole: myRole
        })
    });
}


function $025d14e1ef64690b$export$2e2bcd8739ae039() {
    const { currentOrg: currentOrg, canInviteMembers: canInviteMembers, membership: membership, isExpiredOrg: isExpiredOrg, canManageBilling: canManageBilling, isManagedOrg: isManagedOrg } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const { isLoading: isLoading } = (0, $243f463264eb1fab$export$7cca17e0b77721be)();
    const invitesSearch = (0, $a552b14f0ac5e4a1$export$2e2bcd8739ae039)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const hasResults = (invitesSearch.results?.length ?? 0) > 0;
    if (!currentOrg) return null;
    if (isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {});
    if (!canInviteMembers || !membership) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f8f95b189a35cb2e$export$2e2bcd8739ae039), {});
    if (isExpiredOrg) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d1ebcf00b940bfdd$export$2e2bcd8739ae039), {
        organizationId: currentOrg.id,
        canManageBilling: canManageBilling,
        isManagedOrg: isManagedOrg,
        customBillingUrl: currentOrg.customBillingUrl
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $51af5a17187af6b5$export$2e2bcd8739ae039), {
                value: invitesSearch.searchQuery,
                onChange: (e)=>invitesSearch.handleSearchQueryChange(e.target.value),
                onClear: ()=>invitesSearch.handleSearchQueryChange('')
            }),
            hasResults && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:results'),
                variant: "small"
            }),
            hasResults ? invitesSearch.results?.map((invite, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f0e163beadbbd519$export$2e2bcd8739ae039), {
                    invite: invite,
                    myRole: membership
                }, index)) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $07e53c7e95507174$export$2e2bcd8739ae039), {
                myRole: (0, $d227fca458ea4785$export$68befc518ea2400f)(membership),
                organizationId: currentOrg.id
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$7df9baccf69a86b2), {
                $visuallyHide: !invitesSearch.results || invitesSearch.results.length == 0,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e7ac331879f72d98$export$2e2bcd8739ae039), {
                    onNext: invitesSearch.handleNext,
                    onPrevious: invitesSearch.handlePrevious,
                    disableNext: !invitesSearch.showNext,
                    disablePrevious: !invitesSearch.showPrevious
                })
            })
        ]
    });
}







function $baa978b131a43e54$export$2e2bcd8739ae039() {
    (0, $70228be3ff15ddce$export$f08c2f745253d47b)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { currentOrg: currentOrg, isExpiredOrg: isExpiredOrg, membership: membership, isLoading: isLoading } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    if (!currentOrg || isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e8ddd06b3da44631$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:organization.invite.orgTitle', {
                    value: currentOrg?.name
                }),
                description: t('common:organization.invite.description'),
                items: items,
                children: membership && !isExpiredOrg && currentOrg?.id && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $24d7412693118a64$export$2e2bcd8739ae039), {
                    myRole: (0, $d227fca458ea4785$export$68befc518ea2400f)(membership),
                    organizationId: currentOrg.id
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $025d14e1ef64690b$export$2e2bcd8739ae039), {})
        ]
    });
}








const $16d9b11fdb0c5246$var$Card = ({ title: title, description: description, statusText: statusChip, children: children })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $347ffda0d89c401a$export$401042fa3f49d26), {
        children: [
            statusChip && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $347ffda0d89c401a$export$fd5345d4562e9833), {
                children: statusChip
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $347ffda0d89c401a$export$9de46b28c4f6c978), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$2c65789109b698b0), {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                        children: description
                    }),
                    children
                ]
            })
        ]
    });
};
var $16d9b11fdb0c5246$export$2e2bcd8739ae039 = $16d9b11fdb0c5246$var$Card;








function $4643a3bccc023815$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { licenseType: licenseType, currentOrg: currentOrg, canViewMembers: canViewMembers, canManageBilling: canManageBilling, canViewOrgDetails: canViewOrgDetails } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const handleContinue = ()=>{
        navigate('/', {
            replace: true
        });
    };
    const guideLink = 'https://cephable.com/for-individuals/tutorials/';
    const cards = [
        {
            title: 'common:organization.titlePlural',
            description: 'common:organization.description',
            buttons: [
                {
                    text: 'common:organization.viewOrganization',
                    link: '#/org',
                    onCondition: canViewOrgDetails
                },
                {
                    text: 'common:organization.canViewMembers.title',
                    link: `#/org/${currentOrg?.id}/members`,
                    onCondition: canViewOrgDetails && canViewMembers
                },
                {
                    text: 'common:organization.canManageBilling.title',
                    link: `#/org/${currentOrg?.id}/billing/redirect/upgrade`,
                    onCondition: canManageBilling
                }
            ]
        },
        {
            title: 'common:resources.title',
            description: 'common:resources.description',
            buttons: [
                {
                    text: 'common:resources.guides',
                    link: guideLink
                }
            ]
        },
        {
            title: 'common:feedback.title',
            description: 'common:feedback.description',
            buttons: [
                {
                    text: 'common:feedback.feature',
                    link: 'https://forms.office.com/pages/responsepage.aspx?id=nXUREBN1JUCrY3YZ6NyUAMhvlErPu6pKnaJDLXYRrXdUOVc0M0c2RDBTOVoxUEdSWVUzUkFXMlNMTyQlQCN0PWcu'
                },
                {
                    text: 'common:feedback.bug',
                    link: 'https://forms.office.com/pages/responsepage.aspx?id=nXUREBN1JUCrY3YZ6NyUAMhvlErPu6pKnaJDLXYRrXdUNUIzTFpYSFBTTk5HME1MU1kyQlEyVENVUCQlQCN0PWcu'
                },
                {
                    text: 'common:feedback.contact',
                    link: 'https://cephable.com/contact-us/'
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:license.welcome.title', {
                    license: t(`common:billing.${licenseType}.titleLong`)
                }),
                description: t('common:license.welcome.description', {
                    organization: currentOrg?.name,
                    description: t(`common:billing.${licenseType}.description`)
                }),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9926e0d0274623af$export$154f0ea7dcc0c8c6), {
                onClick: ()=>handleContinue(),
                children: t('tour:onboarding.finish.continueToApp')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $348d9e775387b4da$export$85a4c3b5f32264b8), {
                children: cards.map((card, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16d9b11fdb0c5246$export$2e2bcd8739ae039), {
                        title: t(card.title),
                        description: t(card.description),
                        children: card.buttons.filter((button)=>button.onCondition === undefined || button.onCondition).map((button, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                                variant: "context",
                                href: button.link,
                                children: t(button.text)
                            }, 'button_' + index + i))
                    }, 'card_' + index))
            })
        ]
    });
}













var $7fPBF = parcelRequire("7fPBF");



function $10c08b77230bafcc$export$c24add0d20ee4d6a() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const { showError: showError } = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const { orgManagedKeysLicenseRef: orgManagedKeysLicenseRef, orgManagedLicenseKeys: orgManagedLicenseKeys, loadingDataRef: loadingDataRef, loadingData: loadingData, handleLoadingDataChange: handleLoadingDataChange, getOrgManagedLicenseKeys: getOrgManagedLicenseKeys } = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    (0, $7fPBF.useEffect)(()=>{
        async function initializeLicenseKeys() {
            if (!organizationId || loadingDataRef.current.licenseKeys == true) return;
            handleLoadingDataChange('licenseKeys', true);
            const key = orgManagedKeysLicenseRef.current.find((k)=>k.originatedByOrganizationId === organizationId);
            if (key) {
                handleLoadingDataChange('licenseKeys', false);
                return;
            }
            try {
                await getOrgManagedLicenseKeys(organizationId);
            } catch (error) {
                showError(t('common:license.key.error'));
            } finally{
                handleLoadingDataChange('licenseKeys', false);
            }
        }
        initializeLicenseKeys();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        organizationId
    ]);
    return {
        orgManagedLicenseKeys: orgManagedLicenseKeys,
        isLoading: loadingData.licenseKeys
    };
}




var $7fPBF = parcelRequire("7fPBF");






function $dff101a14f82f91d$export$2e2bcd8739ae039(defaultFilter = 'all') {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const { showError: showError } = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const organizationContainer = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const defaultTake = 51;
    const displayLimit = defaultTake - 1;
    const [searchQuery, setSearchQuery] = (0, $7fPBF.useState)('');
    const [debouncedQuery, setDebouncedQuery] = (0, $7fPBF.useState)({
        searchText: '',
        skip: 0,
        take: defaultTake
    });
    const [searchFilteredLicenseKeys, setSearchFilteredLicenseKeys, searchFilteredLicenseKeysRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(defaultFilter);
    (0, $d856e666394c520b$export$2e2bcd8739ae039)((0, $14e4f1609944ac39$export$18d6475ce2e9bfe8), [
        debouncedQuery.skip
    ]);
    function handleSearchQueryChange(value) {
        setSearchQuery(value);
    }
    function handleSearchFilteredLicenseKeysChange(value) {
        setSearchFilteredLicenseKeys(value);
    }
    const showPrevious = (0, $7fPBF.useMemo)(()=>debouncedQuery.skip && debouncedQuery.skip > 0, [
        debouncedQuery.skip
    ]);
    const showNext = (0, $7fPBF.useMemo)(()=>organizationContainer.orgManagedLicenseKeys.length >= displayLimit, [
        organizationContainer.orgManagedLicenseKeys
    ]);
    const DEBOUNCE_DELAY = 500;
    (0, $7fPBF.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            const newQuery = {
                searchText: searchQuery,
                skip: 0,
                take: defaultTake
            };
            if (newQuery.searchText !== debouncedQuery.searchText) setDebouncedQuery(newQuery);
        }, DEBOUNCE_DELAY);
        return ()=>clearTimeout(timeoutId);
    }, [
        searchQuery,
        searchFilteredLicenseKeys
    ]);
    const handleNext = ()=>{
        const count = organizationContainer.orgManagedKeysLicenseRef.current.length;
        setDebouncedQuery((prev)=>({
                ...prev,
                take: defaultTake,
                skip: displayLimit + (prev.skip ?? 0)
            }));
    };
    const handlePrevious = ()=>{
        const count = organizationContainer.orgManagedKeysLicenseRef.current.length;
        setDebouncedQuery((prev)=>({
                ...prev,
                take: defaultTake,
                skip: Math.max(0, (prev.skip ?? 0) - displayLimit)
            }));
    };
    (0, $7fPBF.useEffect)(()=>{
        const trySearch = async ()=>{
            if (organizationContainer.loadingDataRef.current.licenseKeys || !organizationId) return;
            try {
                organizationContainer.handleLoadingDataChange('licenseKeys', true);
                organizationContainer.searchOrgManageLicenseKeys(organizationId, debouncedQuery, searchFilteredLicenseKeysRef.current);
            } catch (e) {
                showError(t('common:license.key.error'));
            } finally{
                organizationContainer.handleLoadingDataChange('licenseKeys', false);
            }
        };
        trySearch();
    }, [
        debouncedQuery
    ]);
    return {
        results: organizationContainer.orgManagedLicenseKeys,
        handleSearchQueryChange: handleSearchQueryChange,
        searchQuery: searchQuery,
        searchFilteredLicenseKeys: searchFilteredLicenseKeys,
        handleSearchFilteredLicenseKeysChange: handleSearchFilteredLicenseKeysChange,
        showPrevious: showPrevious,
        showNext: showNext,
        handleNext: handleNext,
        handlePrevious: handlePrevious,
        loadingData: organizationContainer.loadingData.licenseKeys
    };
}





const $9bc694be59ba7dc7$export$94edfa5bee6a54b8 = (str, visibleCount = 4, maskChar = '*')=>{
    if (str.length <= visibleCount) return str; // If the string is shorter than visibleCount, return as is
    return str.slice(0, visibleCount) + maskChar.repeat(str.length - visibleCount); // Visible + masked part
};



var $7fPBF = parcelRequire("7fPBF");






function $e7f3fc00fe5d6c8d$export$2e2bcd8739ae039({ value: value = '', onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039), {
        fullWidth: true,
        multiline: true,
        rows: 4,
        label: t('common:description'),
        value: value,
        placeholder: '-',
        onChange: (e)=>onUpdate('description', e.target.value)
    });
}






var $7fPBF = parcelRequire("7fPBF");



function $65792f9bbfbfd034$export$2e2bcd8739ae039(licenseKey) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { showSuccess: showSuccess, showError: showError } = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const { handleLoadingDataChange: handleLoadingDataChange, loadingData: loadingData, createManagedOrg: createManagedOrg } = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const [licenseKeyAssign, setLicenseKeyAssign] = (0, $7fPBF.useState)(licenseKey);
    const [assignKey, setAssignKey] = (0, $7fPBF.useState)({
        name: '',
        description: '',
        key: licenseKey?.accessCode ?? '',
        customBillingUrl: ''
    });
    const resetAssignKey = ()=>{
        setAssignKey({
            name: '',
            description: '',
            key: licenseKey?.accessCode ?? '',
            customBillingUrl: ''
        });
    };
    const handleInputChange = (field, value)=>{
        setAssignKey((prev)=>({
                ...prev,
                [field]: value
            }));
    };
    const handleSave = async ()=>{
        if (!assignKey.name || !assignKey.description) {
            showError(t('common:requiredFields'));
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
        if (!licenseKeyAssign?.originatedByOrganizationId || !assignKey) {
            showError(t('common:saveError'));
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
        try {
            handleLoadingDataChange('managedKeys', true);
            const result = await createManagedOrg(licenseKeyAssign?.originatedByOrganizationId, assignKey);
            if (result.resultType === 'Ok' && result.data) showSuccess(t('common:saved'));
            else showError(t('common:saveError'));
            return result;
        } catch (error) {
            showError(t('common:saveError'));
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            handleLoadingDataChange('managedKeys', false);
        }
    };
    return {
        assignKey: assignKey,
        licenseKeyAssign: licenseKeyAssign,
        setLicenseKeyAssign: setLicenseKeyAssign,
        resetAssignKey: resetAssignKey,
        handleInputChange: handleInputChange,
        handleSave: handleSave,
        isLoading: loadingData.managedOrgs
    };
}







function $ae9382977fb78a94$export$2e2bcd8739ae039({ value: value = '', onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039), {
        fullWidth: true,
        label: t('common:organization.orgCustomBillingUrl.title'),
        helperText: t('common:organization.orgCustomBillingUrl.description'),
        value: value,
        placeholder: '-',
        onChange: (e)=>onUpdate('customBillingUrl', e.target.value)
    });
}





function $09e78d309b5c4bb4$export$2e2bcd8739ae039({ value: value = '', onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039), {
        fullWidth: true,
        label: t('common:organization.orgName'),
        value: value,
        placeholder: '-',
        onChange: (e)=>onUpdate('name', e.target.value)
    });
}










function $4fdc8319b8729c3b$export$2e2bcd8739ae039({ licenseKey: licenseKey }) {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: licenseKey.name,
                variant: "small"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4fdc8319b8729c3b$var$StyledLicenseTypeLogo, {
                licenseType: (0, $427978696205d868$export$5122f57547dc8eca)(licenseKey)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$a334180936c1c286), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                        children: licenseKey.accessCode
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                        children: t('common:created', 'Created', {
                            value: licenseKey.createdDate
                        })
                    }),
                    licenseKey.modifiedDate !== licenseKey.createdDate && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                        children: t('common:updated', 'Updated', {
                            value: licenseKey.modifiedDate
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                        children: t('common:expires', 'Expires', {
                            value: licenseKey.expirationDate
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                        children: t('common:organization.member.seats.maxSeatValue', 'Max', {
                            value: licenseKey.maxMembers
                        })
                    })
                ]
            })
        ]
    });
}
// TODO - this is a hack to get the icons to work correctly I have put in a ticket with the team to get better license logos
const $4fdc8319b8729c3b$var$StyledLicenseTypeLogo = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $d0f22230e48d02ba$export$2e2bcd8739ae039))`
    position: relative;
    margin-top: -80px;
    overflow: hidden;
    bottom: -50px;
`;


function $3cc9edccf5351c87$var$LicenseKeyAssignDialog({ open: open, onClose: onClose, licenseKey: licenseKey }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const { assignKey: assignKey, handleInputChange: handleInputChange, handleSave: handleSave, setLicenseKeyAssign: setLicenseKeyAssign, resetAssignKey: resetAssignKey } = (0, $65792f9bbfbfd034$export$2e2bcd8739ae039)(licenseKey);
    const handleConfirm = async ()=>{
        const result = await handleSave();
        if (result.resultType === 'Ok' && result.data) {
            handleClose();
            navigate(`/org/${result.data.originatedByOrganizationId}/managed/${result.data.id}`);
        }
    };
    const handleClose = ()=>{
        setLicenseKeyAssign(undefined);
        resetAssignKey();
        onClose();
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        fullWidth: true,
        open: open,
        onClose: handleClose,
        title: t('common:license.key.assign'),
        onCancel: handleClose,
        onConfirm: handleConfirm,
        confirmButtonText: t('common:create'),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4fdc8319b8729c3b$export$2e2bcd8739ae039), {
                licenseKey: licenseKey
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:organization.new.details'),
                variant: "small"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$a334180936c1c286), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $09e78d309b5c4bb4$export$2e2bcd8739ae039), {
                        value: assignKey.name ?? '',
                        onUpdate: (field, value)=>handleInputChange(field, value)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e7f3fc00fe5d6c8d$export$2e2bcd8739ae039), {
                        value: assignKey.description ?? '',
                        onUpdate: (field, value)=>handleInputChange(field, value)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ae9382977fb78a94$export$2e2bcd8739ae039), {
                        value: assignKey.customBillingUrl ?? '',
                        onUpdate: (field, value)=>handleInputChange(field, value)
                    })
                ]
            })
        ]
    });
}
var $3cc9edccf5351c87$export$2e2bcd8739ae039 = $3cc9edccf5351c87$var$LicenseKeyAssignDialog;







function $1e7c30ae2efd49a7$var$LicenseKeyDetailsDialog({ open: open, onClose: onClose, licenseKey: licenseKey }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const handleConfirm = ()=>{
        onClose();
        navigate(`/org/${licenseKey.originatedByOrganizationId}/managed/${licenseKey.organizationId}`);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        fullWidth: true,
        open: open,
        onClose: onClose,
        title: t('common:license.key.details'),
        onCancel: onClose,
        onConfirm: handleConfirm,
        confirmButtonText: t('common:organization.viewOrganization'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4fdc8319b8729c3b$export$2e2bcd8739ae039), {
            licenseKey: licenseKey
        })
    });
}
var $1e7c30ae2efd49a7$export$2e2bcd8739ae039 = $1e7c30ae2efd49a7$var$LicenseKeyDetailsDialog;


function $43d387c58d5b8cfc$export$2e2bcd8739ae039({ licenseKey: licenseKey }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    if (!licenseKey) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f034ea975db3d0b$export$2e2bcd8739ae039), {
                iconSize: 24,
                startIcon: licenseKey.organizationId ? 'check' : 'circle',
                endIcon: "more",
                title: licenseKey.name,
                description: licenseKey.organizationId ? t('common:used', 'Used', {
                    value: licenseKey.modifiedDate
                }) : (0, $9bc694be59ba7dc7$export$94edfa5bee6a54b8)(licenseKey.accessCode),
                onClick: ()=>setOpen(true)
            }),
            licenseKey.organizationId ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1e7c30ae2efd49a7$export$2e2bcd8739ae039), {
                open: open,
                onClose: ()=>setOpen(false),
                licenseKey: licenseKey
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3cc9edccf5351c87$export$2e2bcd8739ae039), {
                open: open,
                onClose: ()=>setOpen(false),
                licenseKey: licenseKey
            })
        ]
    });
}







function $14f7b42400a03c73$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
        description: t('common:license.key.empty.description'),
        fullHeight: true,
        title: t('common:license.key.empty.title'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
            onClick: ()=>navigate('../purchase'),
            startIcon: "plusLight",
            children: t('common:license.key.product.title')
        })
    });
}


function $331a2a11ebbf5c79$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { isLoading: isLoading } = (0, $10c08b77230bafcc$export$c24add0d20ee4d6a)(); //initialize
    const licenseKeySearch = (0, $dff101a14f82f91d$export$2e2bcd8739ae039)(); //search
    const hasResults = licenseKeySearch.results.length > 0;
    if (isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $51af5a17187af6b5$export$2e2bcd8739ae039), {
                value: licenseKeySearch.searchQuery,
                onChange: (e)=>licenseKeySearch.handleSearchQueryChange(e.target.value),
                onClear: ()=>licenseKeySearch.handleSearchQueryChange('')
            }),
            hasResults && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:results'),
                variant: "small"
            }),
            hasResults ? licenseKeySearch.results.map((licenseKey)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $43d387c58d5b8cfc$export$2e2bcd8739ae039), {
                    licenseKey: licenseKey
                }, licenseKey.id)) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $14f7b42400a03c73$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$7df9baccf69a86b2), {
                $visuallyHide: licenseKeySearch.results.length == 0,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e7ac331879f72d98$export$2e2bcd8739ae039), {
                    onNext: licenseKeySearch.handleNext,
                    onPrevious: licenseKeySearch.handlePrevious,
                    disableNext: !licenseKeySearch.showNext,
                    disablePrevious: !licenseKeySearch.showPrevious
                })
            })
        ]
    });
}




function $b9b520f8e9a5b827$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e8ddd06b3da44631$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:license.key.titlePlural'),
                description: t('common:license.key.description'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $331a2a11ebbf5c79$export$2e2bcd8739ae039), {})
        ]
    });
}













var $7fPBF = parcelRequire("7fPBF");


function $13623c5fd2a6c1d6$export$1666dd65ac1e38fd() {
    const { organizationId: organizationId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const { orgManagedOrgs: orgManagedOrgs, orgManagedOrgsRef: orgManagedOrgsRef, getOrgManagedOrgsAll: getOrgManagedOrgsAll, loadingData: loadingData, loadingDataRef: loadingDataRef, handleLoadingDataChange: handleLoadingDataChange } = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    (0, $7fPBF.useEffect)(()=>{
        async function initializeManagedOrgs() {
            if (!organizationId || loadingDataRef.current.managedOrgs == true) return;
            handleLoadingDataChange('managedOrgs', true);
            const org = orgManagedOrgsRef.current.find((mo)=>mo.originatedByOrganizationId == organizationId);
            if (org) {
                handleLoadingDataChange('managedOrgs', false);
                return;
            }
            try {
                const result = await getOrgManagedOrgsAll(organizationId);
                result?.resultType;
            } catch (error) {
                console.error('Error loading managed organizations.');
            } finally{
                handleLoadingDataChange('managedOrgs', false);
            }
        }
        initializeManagedOrgs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        organizationId
    ]);
    return {
        orgManagedOrgs: orgManagedOrgs,
        isLoading: loadingData.managedOrgs
    };
}



var $7fPBF = parcelRequire("7fPBF");





function $9b7339fe14b0b949$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const { showError: showError } = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const organizationContainer = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const managedOrgsSearchContentId = 'managed-orgs-search';
    const defaultTake = 51;
    const displayLimit = defaultTake - 1;
    const [searchQuery, setSearchQuery] = (0, $7fPBF.useState)('');
    const [debouncedQuery, setDebouncedQuery] = (0, $7fPBF.useState)({
        searchText: '',
        skip: 0,
        take: defaultTake
    });
    (0, $d856e666394c520b$export$2e2bcd8739ae039)(managedOrgsSearchContentId, [
        debouncedQuery.skip
    ]);
    function handleSearchQueryChange(value) {
        setSearchQuery(value);
    }
    const showPrevious = (0, $7fPBF.useMemo)(()=>debouncedQuery.skip && debouncedQuery.skip > 0, [
        debouncedQuery.skip
    ]);
    const showNext = (0, $7fPBF.useMemo)(()=>organizationContainer.orgManagedOrgs.length >= displayLimit, [
        organizationContainer.orgManagedOrgs
    ]);
    const DEBOUNCE_DELAY = 500;
    (0, $7fPBF.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            const newQuery = {
                searchText: searchQuery.toLowerCase(),
                skip: 0,
                take: defaultTake
            };
            if (newQuery.searchText !== debouncedQuery.searchText) setDebouncedQuery(newQuery);
        }, DEBOUNCE_DELAY);
        return ()=>clearTimeout(timeoutId);
    }, [
        searchQuery
    ]);
    const handleNext = ()=>{
        setDebouncedQuery((prev)=>({
                ...prev,
                take: defaultTake,
                skip: displayLimit + (prev.skip ?? 0)
            }));
    };
    const handlePrevious = ()=>{
        setDebouncedQuery((prev)=>({
                ...prev,
                take: defaultTake,
                skip: Math.max(0, (prev.skip ?? 0) - displayLimit)
            }));
    };
    (0, $7fPBF.useEffect)(()=>{
        const trySearch = async ()=>{
            if (organizationContainer.loadingDataRef.current.managedOrgs) return;
            if (!organizationId) return;
            try {
                organizationContainer.handleLoadingDataChange('managedOrgs', true);
                await organizationContainer.getOrgManagedOrgsAll(organizationId, debouncedQuery);
            } catch (e) {
                showError(t('common:organization.managed.error'));
            } finally{
                organizationContainer.handleLoadingDataChange('managedOrgs', false);
            }
        };
        trySearch();
    }, [
        debouncedQuery
    ]);
    return {
        results: organizationContainer.orgManagedOrgs,
        managedOrgsSearchContentId: managedOrgsSearchContentId,
        handleSearchQueryChange: handleSearchQueryChange,
        searchQuery: searchQuery,
        showPrevious: showPrevious,
        showNext: showNext,
        handleNext: handleNext,
        handlePrevious: handlePrevious,
        isLoading: organizationContainer.loadingData.managedOrgs
    };
}







var $7fPBF = parcelRequire("7fPBF");





function $2795f850cc5132b5$export$2e2bcd8739ae039({ open: open, onClose: onClose }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const handleConfirm = ()=>{
        onClose();
        navigate(`/org/${organizationId}/purchase`);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        open: open,
        onCancel: onClose,
        onClose: onClose,
        onConfirm: handleConfirm,
        confirmButtonText: t('common:license.key.product.title'),
        title: t('common:license.key.empty.title'),
        description: t('common:license.key.empty.description')
    });
}
















function $49c3dd2972df6e1a$export$2e2bcd8739ae039({ value: value, onUpdate: onUpdate, handleLicenseKeyChange: handleLicenseKeyChange, results: results = [], loadingData: loadingData }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const theme = (0, $d62c6f18f523e962$export$3b14a55fb2447963)();
    const handleUpdate = (key)=>{
        const selectedKey = results.find((k)=>k.accessCode === key);
        if (selectedKey) {
            onUpdate('key', key);
            handleLicenseKeyChange(selectedKey);
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $26a8e925f0aa9998$export$2e2bcd8739ae039), {
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcd80672e9993aad$export$2e2bcd8739ae039), {
                style: {
                    backgroundColor: theme.color.background
                },
                id: "license-key-label",
                children: "Choose a License Key"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                labelId: "license-key-label",
                value: value ?? '',
                onChange: (e)=>handleUpdate(e.target.value),
                disabled: loadingData || results.length === 0,
                displayEmpty: true,
                children: loadingData ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                    disabled: true,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d513166e63c42433$export$2e2bcd8739ae039), {
                            size: 24
                        }),
                        t('common:loading')
                    ]
                }) : results.length > 0 ? results.map((key)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        value: key.accessCode,
                        children: [
                            key.name,
                            " ",
                            ' | ',
                            t('common:organization.member.seats.maxSeatValue', 'Max', {
                                value: key.maxMembers
                            })
                        ]
                    }, key.id)) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                    disabled: true,
                    children: t('common:license.key.product.title')
                })
            })
        ]
    });
}



function $4e925a1bb1238fb4$var$LicenseKeySelectDialog({ open: open, onClose: onClose, availableKeys: availableKeys, loadingData: loadingData, ...restProps }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const { assignKey: assignKey, licenseKeyAssign: licenseKeyAssign, handleInputChange: handleInputChange, handleSave: handleSave, setLicenseKeyAssign: setLicenseKeyAssign, resetAssignKey: resetAssignKey } = (0, $65792f9bbfbfd034$export$2e2bcd8739ae039)();
    const handleClose = ()=>{
        onClose();
        setLicenseKeyAssign(undefined);
        resetAssignKey();
    };
    const handleConfirm = async ()=>{
        const result = await handleSave();
        if (result.resultType === 'Ok' && result.data) {
            handleClose();
            navigate(`/org/${result.data.originatedByOrganizationId}/managed/${result.data.id}`);
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        fullWidth: true,
        open: open,
        onClose: handleClose,
        title: t('common:license.key.assign'),
        onCancel: handleClose,
        onConfirm: handleConfirm,
        confirmButtonText: t('common:create'),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $aa23c6db410f15d5$export$a334180936c1c286), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $49c3dd2972df6e1a$export$2e2bcd8739ae039), {
                    value: assignKey.key,
                    onUpdate: handleInputChange,
                    handleLicenseKeyChange: setLicenseKeyAssign,
                    results: availableKeys,
                    loadingData: loadingData
                })
            }),
            licenseKeyAssign && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4fdc8319b8729c3b$export$2e2bcd8739ae039), {
                licenseKey: licenseKeyAssign
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:organization.new.details'),
                variant: "small"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$a334180936c1c286), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $09e78d309b5c4bb4$export$2e2bcd8739ae039), {
                        value: assignKey.name ?? '',
                        onUpdate: (field, value)=>handleInputChange(field, value)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e7f3fc00fe5d6c8d$export$2e2bcd8739ae039), {
                        value: assignKey.description ?? '',
                        onUpdate: (field, value)=>handleInputChange(field, value)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ae9382977fb78a94$export$2e2bcd8739ae039), {
                        value: assignKey.customBillingUrl ?? '',
                        onUpdate: (field, value)=>handleInputChange(field, value)
                    })
                ]
            })
        ]
    });
}
var $4e925a1bb1238fb4$export$2e2bcd8739ae039 = $4e925a1bb1238fb4$var$LicenseKeySelectDialog;


function $1e4b589f04a4e1a2$var$LicenseKeySelectAccess({ $color: $color = 'accent', $size: $size = 'small', startIcon: startIcon = 'plusLight', ...restProps }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    const { results: results, loadingData: loadingData } = (0, $dff101a14f82f91d$export$2e2bcd8739ae039)('available');
    const onClose = ()=>{
        setOpen(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                $color: $color,
                $size: $size,
                onClick: ()=>setOpen(true),
                startIcon: startIcon,
                ...restProps,
                children: t('common:organization.create')
            }),
            results.length < 1 && !loadingData ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2795f850cc5132b5$export$2e2bcd8739ae039), {
                open: open,
                onClose: onClose
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4e925a1bb1238fb4$export$2e2bcd8739ae039), {
                availableKeys: results,
                loadingData: loadingData,
                open: open,
                onClose: onClose
            })
        ]
    });
}
var $1e4b589f04a4e1a2$export$2e2bcd8739ae039 = $1e4b589f04a4e1a2$var$LicenseKeySelectAccess;






var $7fPBF = parcelRequire("7fPBF");











var $7fPBF = parcelRequire("7fPBF");




function $2d24843f3708c077$export$15de29966ec5486a(initialModel) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { updateOrganization: updateOrganization } = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const { showSuccess: showSuccess, showError: showError } = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const [editOrganization, setEditOrganization, editOrganizationRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(initialModel);
    const [hasChanges, setHasChanges] = (0, $7fPBF.useState)(false);
    const resetEditOrganization = ()=>{
        setEditOrganization(initialModel);
        setHasChanges(false);
    };
    const handleFieldChange = (fieldName, value)=>{
        setEditOrganization((prevModel)=>prevModel ? {
                ...prevModel,
                [fieldName]: value
            } : null);
        if (!hasChanges) setHasChanges(true);
    };
    const handleInputChange = (fieldName, value)=>{
        handleFieldChange(fieldName, value);
    };
    const handleUpdate = async ()=>{
        try {
            if (!initialModel?.id || !editOrganizationRef.current) throw new Error('Missing data');
            const result = await updateOrganization(initialModel.id, editOrganizationRef.current);
            if (result.resultType === 'Ok' && result.data) {
                setEditOrganization(result.data);
                setHasChanges(false);
            }
            return result;
        } catch (error) {
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const handleAlerts = (result)=>{
        if (result.resultType === 'Ok') showSuccess(t('common:saved'));
        else showError(t('common:saveError'));
    };
    const handleUpdateWithAlerts = async ()=>{
        const result = await handleUpdate();
        handleAlerts(result);
        return result;
    };
    return {
        hasChanges: hasChanges,
        editOrganization: editOrganization,
        setEditOrganization: setEditOrganization,
        handleFieldChange: handleFieldChange,
        handleInputChange: handleInputChange,
        handleUpdate: handleUpdate,
        resetEditOrganization: resetEditOrganization,
        handleUpdateWithAlerts: handleUpdateWithAlerts
    };
}





function $e11b18a0b779fb3d$var$ManagedOrgDetailsDialog({ open: open, onClose: onClose, org: org }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { handleInputChange: handleInputChange, handleUpdateWithAlerts: handleUpdateWithAlerts, editOrganization: editOrganization, hasChanges: hasChanges, resetEditOrganization: resetEditOrganization } = (0, $2d24843f3708c077$export$15de29966ec5486a)(org ?? null);
    const handleConfirm = async ()=>{
        if (hasChanges) {
            const response = await handleUpdateWithAlerts();
            if (response.resultType === 'Ok') handleClose();
        }
    };
    const handleClose = ()=>{
        onClose();
        resetEditOrganization();
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        fullWidth: true,
        dialogTag: t(`common:billing.${(0, $427978696205d868$export$5122f57547dc8eca)(org)}.title`),
        open: open,
        onClose: handleClose,
        title: org.name,
        description: org.description,
        onCancel: handleClose,
        onConfirm: handleConfirm,
        confirmButtonText: t('common:unsaved.confirm'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                    title: t('common:billing.title'),
                    variant: "small",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        $size: "small",
                        endIcon: "externalLink",
                        to: `/org/${org.originatedByOrganizationId}/managed/${org.id}/billing/redirect/upgrade`,
                        children: t('common:billing.view')
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$a334180936c1c286), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                            children: t('common:created', 'Created', {
                                value: org.createdDate
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                            children: t('common:expires', 'Expires', {
                                value: org.licenseExpirationDate
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                            children: t('common:organization.member.seats.maxSeatValue', 'Max', {
                                value: org.maxMembers ?? 0
                            })
                        })
                    ]
                }),
                editOrganization && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                            title: t('common:organization.new.details'),
                            variant: "small",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                $size: "small",
                                to: `/org/${org.originatedByOrganizationId}/managed/${org.id}`,
                                children: t('common:organization.viewOrganization')
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $09e78d309b5c4bb4$export$2e2bcd8739ae039), {
                                    value: editOrganization.name ?? '',
                                    onUpdate: (field, value)=>handleInputChange(field, value)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e7f3fc00fe5d6c8d$export$2e2bcd8739ae039), {
                                    value: editOrganization.description ?? '',
                                    onUpdate: (field, value)=>handleInputChange(field, value)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ae9382977fb78a94$export$2e2bcd8739ae039), {
                                    value: editOrganization.customBillingUrl ?? '',
                                    onUpdate: (field, value)=>handleInputChange(field, value)
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var $e11b18a0b779fb3d$export$2e2bcd8739ae039 = $e11b18a0b779fb3d$var$ManagedOrgDetailsDialog;


function $e334800c0f0fce5a$export$2e2bcd8739ae039({ organization: organization }) {
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    const handleNavigate = ()=>{
        navigate(`/org/${organization.originatedByOrganizationId}/managed/${organization.id}`);
    };
    if (!organization || !organization.originatedByOrganizationId) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f034ea975db3d0b$export$2e2bcd8739ae039), {
                iconSize: 24,
                startIcon: (0, $d0493a8b121d95e9$export$3aa18b5a5694efe6)(organization),
                endIcon: "more",
                title: organization.name,
                description: organization.description,
                onClick: ()=>setOpen(true)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e11b18a0b779fb3d$export$2e2bcd8739ae039), {
                open: open,
                onClose: ()=>setOpen(false),
                org: organization
            })
        ]
    });
}






function $ef94978f68775b91$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
        description: t('common:organization.managed.empty.description'),
        fullHeight: true,
        title: t('common:organization.managed.empty.title'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1e4b589f04a4e1a2$export$2e2bcd8739ae039), {})
    });
}


function $b468ed531a071225$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { isLoading: isLoading } = (0, $13623c5fd2a6c1d6$export$1666dd65ac1e38fd)(); //initialize
    const managedOrgSearch = (0, $9b7339fe14b0b949$export$2e2bcd8739ae039)(); //search
    const hasResults = managedOrgSearch.results.length > 0;
    if (isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $51af5a17187af6b5$export$2e2bcd8739ae039), {
                value: managedOrgSearch.searchQuery,
                onChange: (e)=>managedOrgSearch.handleSearchQueryChange(e.target.value),
                onClear: ()=>managedOrgSearch.handleSearchQueryChange('')
            }),
            hasResults && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:results'),
                variant: "small"
            }),
            hasResults ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    managedOrgSearch.results.map((managedOrg)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e334800c0f0fce5a$export$2e2bcd8739ae039), {
                            organization: managedOrg
                        }, managedOrg.id)),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $347ffda0d89c401a$export$56d6cb3330e62b54), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1e4b589f04a4e1a2$export$2e2bcd8739ae039), {})
                    })
                ]
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ef94978f68775b91$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$7df9baccf69a86b2), {
                $visuallyHide: managedOrgSearch.results.length == 0,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e7ac331879f72d98$export$2e2bcd8739ae039), {
                    onNext: managedOrgSearch.handleNext,
                    onPrevious: managedOrgSearch.handlePrevious,
                    disableNext: !managedOrgSearch.showNext,
                    disablePrevious: !managedOrgSearch.showPrevious
                })
            })
        ]
    });
}



function $776f18f1a04f38af$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:organization.managed.titlePlural'),
                description: t('common:organization.managed.description'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b468ed531a071225$export$2e2bcd8739ae039), {})
        ]
    });
}


















var $7fPBF = parcelRequire("7fPBF");

function $6a0a6661c03aa7cb$export$94554b1f485b23fb() {
    const { organizationId: organizationId } = (0, $748d28edcc8cedba$export$2e2bcd8739ae039)();
    const { organizationMembers: organizationMembers, organizationMembersRef: organizationMembersRef, loadOrganizationMembers: loadOrganizationMembers, loadingDataRef: loadingDataRef, loadingData: loadingData, handleLoadingDataChange: handleLoadingDataChange } = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const members = (0, $7fPBF.useMemo)(()=>{
        if (!organizationId) return null;
        return organizationMembersRef.current.find((org)=>org.organizationId === organizationId)?.members ?? [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        organizationId,
        organizationMembers
    ]);
    (0, $7fPBF.useEffect)(()=>{
        async function fetchMembers() {
            if (!organizationId || loadingDataRef.current.organizationMembers == true) return;
            handleLoadingDataChange('organizationMembers', true);
            const org = organizationMembersRef.current.find((org)=>org.organizationId === organizationId);
            if (org?.members && org.members.length > 0) {
                handleLoadingDataChange('organizationMembers', false);
                return;
            }
            try {
                const result = await loadOrganizationMembers(organizationId);
                if (result?.resultType !== 'Ok') console.error('Failed to load members for organization:', organizationId);
            } catch (error) {
                console.error('Error loading members.');
            } finally{
                handleLoadingDataChange('organizationMembers', false);
            }
        }
        fetchMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        organizationId
    ]);
    return {
        members: members,
        isLoading: loadingData.organizationMembers
    };
}



var $7fPBF = parcelRequire("7fPBF");





function $25a74ed7bce48d01$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { currentOrg: currentOrg } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const { showError: showError } = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const organizationContainer = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const orgMembersSearchContentId = 'org-members-search';
    const defaultTake = 51;
    const displayLimit = defaultTake - 1;
    const [searchQuery, setSearchQuery] = (0, $7fPBF.useState)('');
    const [debouncedQuery, setDebouncedQuery] = (0, $7fPBF.useState)({
        searchText: '',
        skip: 0,
        take: defaultTake
    });
    const members = (0, $7fPBF.useMemo)(()=>{
        if (!currentOrg) return null;
        return organizationContainer.organizationMembersRef.current.find((org)=>org.organizationId === currentOrg.id)?.members ?? [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentOrg,
        organizationContainer.organizationMembers
    ]);
    (0, $d856e666394c520b$export$2e2bcd8739ae039)(orgMembersSearchContentId, [
        debouncedQuery.skip
    ]);
    function handleSearchQueryChange(value) {
        setSearchQuery(value);
    }
    const showPrevious = (0, $7fPBF.useMemo)(()=>debouncedQuery.skip && debouncedQuery.skip > 0, [
        debouncedQuery.skip
    ]);
    const showNext = (0, $7fPBF.useMemo)(()=>organizationContainer.organizationMembers.length >= displayLimit, [
        organizationContainer.organizationMembers
    ]);
    const DEBOUNCE_DELAY = 500;
    (0, $7fPBF.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            const newQuery = {
                searchText: searchQuery,
                skip: 0,
                take: defaultTake
            };
            if (newQuery.searchText !== debouncedQuery.searchText) setDebouncedQuery(newQuery);
        }, DEBOUNCE_DELAY);
        return ()=>clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchQuery
    ]);
    const handleNext = ()=>{
        const count = organizationContainer.organizationMembersRef.current.length;
        setDebouncedQuery((prev)=>({
                ...prev,
                take: defaultTake,
                skip: displayLimit + (prev.skip ?? 0)
            }));
    };
    const handlePrevious = ()=>{
        const count = organizationContainer.organizationMembersRef.current.length;
        setDebouncedQuery((prev)=>({
                ...prev,
                take: defaultTake,
                skip: Math.max(0, (prev.skip ?? 0) - displayLimit)
            }));
    };
    (0, $7fPBF.useEffect)(()=>{
        const trySearch = async ()=>{
            if (organizationContainer.loadingDataRef.current.organizationMembers) return;
            if (!currentOrg) return;
            try {
                organizationContainer.handleLoadingDataChange('organizationMembers', true);
                await organizationContainer.loadOrganizationMembers(currentOrg.id, debouncedQuery);
            } catch (e) {
                showError(t('common:organization.member.loadError'));
            } finally{
                organizationContainer.handleLoadingDataChange('organizationMembers', false);
            }
        };
        trySearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        debouncedQuery
    ]);
    return {
        results: members,
        orgMembersSearchContentId: orgMembersSearchContentId,
        handleSearchQueryChange: handleSearchQueryChange,
        searchQuery: searchQuery,
        showPrevious: showPrevious,
        showNext: showNext,
        handleNext: handleNext,
        handlePrevious: handlePrevious,
        isLoading: organizationContainer.loadingData.organizationMembers
    };
}

















var $7fPBF = parcelRequire("7fPBF");







function $82c7f1922904df08$export$2e2bcd8739ae039({ member: member, hideWrapper: hideWrapper }) {
    if (!member) return null;
    const content = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a387e7d4ce3b8793$export$7c14887e48a97962), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $aa23c6db410f15d5$export$b59bdbef9ce70de2), {
                children: member.user?.firstName && member.user?.lastName ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6b6dbe5e3c17f869$export$2e2bcd8739ae039), {
                            icon: "user",
                            title: member.user?.firstName + ' ' + member.user?.lastName
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6b6dbe5e3c17f869$export$2e2bcd8739ae039), {
                            title: member.user?.email
                        })
                    ]
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6b6dbe5e3c17f869$export$2e2bcd8739ae039), {
                    icon: "user",
                    title: member.user?.email
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2427d6ebbf2e60fd$export$2e2bcd8739ae039), {
                role: (0, $d227fca458ea4785$export$68befc518ea2400f)(member)
            })
        ]
    });
    return hideWrapper ? content : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a387e7d4ce3b8793$export$54571ac7cbe36b70), {
        children: content
    });
}









var $7fPBF = parcelRequire("7fPBF");


function $ac753ef9bc704b1f$var$MemberEditDialog({ open: open, onClose: onClose, member: member, myRole: myRole }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const alertsContainer = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const organizationContainer = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const [editMember, setEditMember] = (0, $7fPBF.useState)(member);
    const [role, setRole] = (0, $7fPBF.useState)((0, $d227fca458ea4785$export$68befc518ea2400f)(member));
    (0, $7fPBF.useEffect)(()=>{
        setEditMember(member);
        setRole((0, $d227fca458ea4785$export$68befc518ea2400f)(member));
    }, [
        member
    ]);
    const handleRoleChange = (updatedRole)=>{
        setRole(updatedRole);
        setEditMember({
            ...editMember,
            ...updatedRole
        });
    };
    const handleSave = async ()=>{
        const result = await organizationContainer.updateMemberRole(editMember.organizationId, editMember.id, role);
        if (result?.resultType == 'Ok') alertsContainer.showSuccess(t('common:organization.member.updated', 'Member updated successfully', {
            value: editMember.user?.email
        }));
        else alertsContainer.showError(t('common:organization.member.error', 'Error updating member', {
            value: editMember.user?.email
        }));
        onClose();
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        fullWidth: true,
        open: open,
        onClose: onClose,
        onCancel: onClose,
        title: t('common:organization.member.edit'),
        onConfirm: handleSave,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $82c7f1922904df08$export$2e2bcd8739ae039), {
                member: editMember
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $777249ad5835b0ee$export$2e2bcd8739ae039), {
                myRole: myRole,
                role: role,
                onChange: handleRoleChange
            })
        ]
    });
}
var $ac753ef9bc704b1f$export$2e2bcd8739ae039 = $ac753ef9bc704b1f$var$MemberEditDialog;


function $db35b665e17b7e03$export$2e2bcd8739ae039({ myRole: myRole, member: member, organizationId: organizationId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const alertsContainer = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const organizationContainer = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const [showEditDialog, setShowEditDialog] = (0, $7fPBF.useState)(false);
    const [showRemoveDialog, setShowRemoveDialog] = (0, $7fPBF.useState)(false);
    const handleEdit = ()=>{
        setShowEditDialog(true);
    };
    const handleCancelEdit = ()=>{
        setShowEditDialog(false);
    };
    const handleRemove = ()=>{
        setShowRemoveDialog(true);
    };
    const handleCancelRemove = ()=>{
        setShowRemoveDialog(false);
    };
    const handleConfirmRemoveMember = async ()=>{
        if (organizationId && (myRole.canRemoveMembers || myRole.isAdmin) && member.id) {
            const result = await organizationContainer.removeMember(organizationId, member.id);
            if (result?.resultType == 'Ok') alertsContainer.showSuccess(t('common:organization.member.delete', 'Member removed successfully', {
                value: member.user?.email
            }));
            else alertsContainer.showError(t('common:organization.member.deleteError', 'Error deleting member', {
                value: member.user?.email
            }));
        }
        setShowRemoveDialog(false);
    };
    if (!member || !myRole) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            (myRole.canChangeMemberPermissions || myRole.isAdmin) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                        startIcon: "orgPermissions",
                        onClick: ()=>handleEdit(),
                        children: t('common:edit')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ac753ef9bc704b1f$export$2e2bcd8739ae039), {
                        myRole: myRole,
                        open: showEditDialog,
                        member: member,
                        onClose: handleCancelEdit
                    })
                ]
            }),
            (myRole.canRemoveMembers || myRole.isAdmin) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                        variant: "negative",
                        startIcon: "cancel2",
                        onClick: handleRemove,
                        children: t('common:organization.canRemoveMembers.action')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
                        open: showRemoveDialog,
                        onConfirm: handleConfirmRemoveMember,
                        onCancel: handleCancelRemove,
                        onClose: handleCancelRemove,
                        title: t('common:organization.canRemoveMembers.confirm'),
                        confirmButtonText: t('common:organization.canRemoveMembers.titleSingle'),
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $82c7f1922904df08$export$2e2bcd8739ae039), {
                                member: member
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                                children: t('common:organization.canRemoveMembers.confirmLong')
                            })
                        ]
                    })
                ]
            })
        ]
    });
}






function $87483011d84430aa$export$2e2bcd8739ae039({ myRole: myRole, member: member, organizationId: organizationId }) {
    if (!member || !myRole.canViewMembers) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $347ffda0d89c401a$export$a27f3c48b2f1c458), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $347ffda0d89c401a$export$9de46b28c4f6c978), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ac3fc121a11fd783$export$c14c794fcd73bed8), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ac3fc121a11fd783$export$2b64bc092bad4151), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                    name: member.isAdmin ? (0, $5d595f963199dd48$export$f45ccdad2e79cfb4).isAdmin : 'user',
                                    size: 35
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$68b378fffb2ccca3), {
                                    children: member.user.email
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ac3fc121a11fd783$export$2b64bc092bad4151), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db35b665e17b7e03$export$2e2bcd8739ae039), {
                                myRole: myRole,
                                member: member,
                                organizationId: organizationId
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a387e7d4ce3b8793$export$78b81e628c724207), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2427d6ebbf2e60fd$export$2e2bcd8739ae039), {
                        variant: "listOnly",
                        role: (0, $d227fca458ea4785$export$68befc518ea2400f)(member)
                    })
                })
            ]
        })
    });
}


function $1a021e4109b31685$export$2e2bcd8739ae039() {
    const { currentOrg: currentOrg, hasSomeMemberEditPermissions: hasSomeMemberEditPermissions, isExpiredOrg: isExpiredOrg, canManageBilling: canManageBilling, canViewMembers: canViewMembers, membership: membership, isManagedOrg: isManagedOrg } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const { isLoading: isLoading } = (0, $6a0a6661c03aa7cb$export$94554b1f485b23fb)();
    const membersSearch = (0, $25a74ed7bce48d01$export$2e2bcd8739ae039)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const hasResults = (membersSearch.results?.length ?? 0) > 0;
    if (isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {});
    if (!currentOrg || !membership) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f8f95b189a35cb2e$export$2e2bcd8739ae039), {});
    if (isExpiredOrg) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d1ebcf00b940bfdd$export$2e2bcd8739ae039), {
        organizationId: currentOrg.id,
        canManageBilling: canManageBilling,
        isManagedOrg: isManagedOrg,
        customBillingUrl: currentOrg.customBillingUrl
    });
    if (!(hasSomeMemberEditPermissions || canViewMembers)) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f8f95b189a35cb2e$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $51af5a17187af6b5$export$2e2bcd8739ae039), {
                value: membersSearch.searchQuery,
                onChange: (e)=>membersSearch.handleSearchQueryChange(e.target.value),
                onClear: ()=>membersSearch.handleSearchQueryChange('')
            }),
            hasResults && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:results'),
                variant: "small"
            }),
            hasResults ? membersSearch.results?.map((member)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $87483011d84430aa$export$2e2bcd8739ae039), {
                    member: member,
                    myRole: (0, $d227fca458ea4785$export$68befc518ea2400f)(membership),
                    organizationId: currentOrg.id
                }, member.id)) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $07e53c7e95507174$export$2e2bcd8739ae039), {
                myRole: (0, $d227fca458ea4785$export$68befc518ea2400f)(membership),
                organizationId: currentOrg.id
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$7df9baccf69a86b2), {
                $visuallyHide: !membersSearch.results || membersSearch.results.length == 0,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e7ac331879f72d98$export$2e2bcd8739ae039), {
                    onNext: membersSearch.handleNext,
                    onPrevious: membersSearch.handlePrevious,
                    disableNext: !membersSearch.showNext,
                    disablePrevious: !membersSearch.showPrevious
                })
            })
        ]
    });
}






function $e25675874c945d68$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { currentOrg: currentOrg, isExpiredOrg: isExpiredOrg, membership: membership, isLoading: isLoading } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    if (!currentOrg || isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e8ddd06b3da44631$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:organization.member.orgTitle', {
                    value: currentOrg?.name
                }),
                description: t('common:organization.member.description'),
                items: items,
                children: currentOrg && !isExpiredOrg && currentOrg.id && membership && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $24d7412693118a64$export$2e2bcd8739ae039), {
                    myRole: (0, $d227fca458ea4785$export$68befc518ea2400f)(membership),
                    organizationId: currentOrg.id
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a021e4109b31685$export$2e2bcd8739ae039), {})
        ]
    });
}













var $7fPBF = parcelRequire("7fPBF");



function $b0d3bd00e0c0516d$export$f2439d77aeb75ed4() {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const { showError: showError } = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const { orgProductsRef: orgProductsRef, orgProducts: orgProducts, loadingDataRef: loadingDataRef, loadingData: loadingData, handleLoadingDataChange: handleLoadingDataChange, getOrganizationProducts: getOrganizationProducts } = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    (0, $7fPBF.useEffect)(()=>{
        async function initializeOrgProducts() {
            if (!organizationId || loadingDataRef.current.products == true) return;
            handleLoadingDataChange('products', true);
            const product = orgProductsRef.current.find((p)=>p.organizationId === organizationId);
            if (product) {
                handleLoadingDataChange('products', false);
                return;
            }
            try {
                await getOrganizationProducts(organizationId, i18n.language);
            } catch (error) {
                showError(t('common:license.key.product.error.title'));
            } finally{
                handleLoadingDataChange('products', false);
            }
        }
        initializeOrgProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        organizationId
    ]);
    return {
        orgProducts: orgProducts,
        isLoading: loadingData.products
    };
}




var $7fPBF = parcelRequire("7fPBF");





function $64ed74c65dc8427b$export$2e2bcd8739ae039() {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const { showError: showError } = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const organizationContainer = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const defaultTake = 51;
    const displayLimit = defaultTake - 1;
    const [searchQuery, setSearchQuery] = (0, $7fPBF.useState)('');
    const [debouncedQuery, setDebouncedQuery] = (0, $7fPBF.useState)({
        searchText: '',
        skip: 0,
        take: defaultTake
    });
    (0, $d856e666394c520b$export$2e2bcd8739ae039)((0, $14e4f1609944ac39$export$18d6475ce2e9bfe8), [
        debouncedQuery.skip
    ]);
    function handleSearchQueryChange(value) {
        setSearchQuery(value);
    }
    const showPrevious = (0, $7fPBF.useMemo)(()=>debouncedQuery.skip && debouncedQuery.skip > 0, [
        debouncedQuery.skip
    ]);
    const showNext = (0, $7fPBF.useMemo)(()=>organizationContainer.orgProducts.length >= displayLimit, [
        organizationContainer.orgProducts
    ]);
    const DEBOUNCE_DELAY = 500;
    (0, $7fPBF.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            const newQuery = {
                searchText: searchQuery,
                skip: 0,
                take: defaultTake
            };
            if (newQuery.searchText !== debouncedQuery.searchText) setDebouncedQuery(newQuery);
        }, DEBOUNCE_DELAY);
        return ()=>clearTimeout(timeoutId);
    }, [
        searchQuery
    ]);
    const handleNext = ()=>{
        const count = organizationContainer.orgManagedKeysLicenseRef.current.length;
        setDebouncedQuery((prev)=>({
                ...prev,
                take: defaultTake,
                skip: displayLimit + (prev.skip ?? 0)
            }));
    };
    const handlePrevious = ()=>{
        const count = organizationContainer.orgProductsRef.current.length;
        setDebouncedQuery((prev)=>({
                ...prev,
                take: defaultTake,
                skip: Math.max(0, (prev.skip ?? 0) - displayLimit)
            }));
    };
    (0, $7fPBF.useEffect)(()=>{
        const trySearch = async ()=>{
            if (organizationContainer.loadingDataRef.current.products || !organizationId) return;
            try {
                organizationContainer.handleLoadingDataChange('products', true);
                organizationContainer.getOrganizationProducts(organizationId, i18n.language, debouncedQuery);
            } catch (e) {
                showError(t('common:license.key.product.error.title'));
            } finally{
                organizationContainer.handleLoadingDataChange('products', false);
            }
        };
        trySearch();
    }, [
        debouncedQuery
    ]);
    return {
        results: organizationContainer.orgProducts,
        handleSearchQueryChange: handleSearchQueryChange,
        searchQuery: searchQuery,
        showPrevious: showPrevious,
        showNext: showNext,
        handleNext: handleNext,
        handlePrevious: handlePrevious,
        loadingData: organizationContainer.loadingData.licenseKeys,
        displayLimit: displayLimit
    };
}











function $93eaee6431a08e4f$export$2e2bcd8739ae039({ orgProduct: orgProduct }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const match = orgProduct.product.billingCycle && orgProduct.product.billingCycle.match(/(\d+)\.\d{2}:\d{2}:\d{2}/);
    const days = match ? parseInt(match[1]) : null;
    const years = days ? Math.floor(days / 365) : null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($93eaee6431a08e4f$var$StyledCardMedium, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($93eaee6431a08e4f$var$StyledIconWrap, {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d0f22230e48d02ba$export$2e2bcd8739ae039), {
                    licenseType: (0, $427978696205d868$export$5122f57547dc8eca)(orgProduct.product),
                    size: 200
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$2c65789109b698b0), {
                children: orgProduct.product.name
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                children: t(`common:license.key.product.${orgProduct.product.billingType}.title`)
            }),
            years && years == 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                children: t('common:license.key.product.yearly')
            }),
            years && years > 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                children: t('common:license.key.product.years', {
                    value: years
                })
            }),
            days && !years && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                children: t('common:license.key.product.days', {
                    value: days
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                children: orgProduct.product.description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                to: `/org/${orgProduct.organizationId}/product/${orgProduct.productId}`,
                variant: "subsection",
                endIcon: "externalLink",
                children: t('common:license.key.product.titleLong')
            })
        ]
    });
}
const $93eaee6431a08e4f$var$StyledIconWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $347ffda0d89c401a$export$f2e4196c0d2b5bb8))`
    padding: 0 0;
    min-height: auto;
    align-items: flex-start;
`;
const $93eaee6431a08e4f$var$StyledCardMedium = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $347ffda0d89c401a$export$1056953590c5547a))`
    align-items: flex-start;
    max-height: fit-content;
`;





function $0895a725638fbacf$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
        description: t('common:license.key.product.empty.description'),
        fullHeight: true,
        title: t('common:license.key.product.empty.title')
    });
}


function $32a219db9065feb1$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { isLoading: isLoading } = (0, $b0d3bd00e0c0516d$export$f2439d77aeb75ed4)(); //initialize
    const orgProductSearch = (0, $64ed74c65dc8427b$export$2e2bcd8739ae039)(); //search
    const hasResults = orgProductSearch?.results.length > 0;
    if (isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $51af5a17187af6b5$export$2e2bcd8739ae039), {
                value: orgProductSearch.searchQuery,
                onChange: (e)=>orgProductSearch.handleSearchQueryChange(e.target.value),
                onClear: ()=>orgProductSearch.handleSearchQueryChange('')
            }),
            hasResults ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $347ffda0d89c401a$export$8ffb7ce587ade322), {
                children: orgProductSearch.results.map((orgProduct)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $93eaee6431a08e4f$export$2e2bcd8739ae039), {
                        orgProduct: orgProduct
                    }, orgProduct.id))
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0895a725638fbacf$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$7df9baccf69a86b2), {
                $visuallyHide: orgProductSearch.results.length == 0 || orgProductSearch.results.length < orgProductSearch.displayLimit,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e7ac331879f72d98$export$2e2bcd8739ae039), {
                    onNext: orgProductSearch.handleNext,
                    onPrevious: orgProductSearch.handlePrevious,
                    disableNext: !orgProductSearch.showNext,
                    disablePrevious: !orgProductSearch.showPrevious
                })
            })
        ]
    });
}




function $d391d99bd393b0cc$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e8ddd06b3da44631$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:license.key.product.titleLong'),
                description: t('common:license.key.product.description'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $32a219db9065feb1$export$2e2bcd8739ae039), {})
        ]
    });
}










// StaggeredReveal.tsx




var $7fPBF = parcelRequire("7fPBF");
const $6b389fa467c067a6$var$fadeInUp = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)`
  from { opacity: 0; transform: translateY(24px); }
  to   { opacity: 1; transform: translateY(0); }
`;
const $6b389fa467c067a6$var$animations = {
    fadeInUp: $6b389fa467c067a6$var$fadeInUp
};
const $6b389fa467c067a6$var$Container = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    /* So grid layout from parent (Group) still applies to children */
    display: contents;
`;
const $6b389fa467c067a6$var$AnimatedItem = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: ${(p)=>p.$fullWidth ? 'flex-grow' : 'flex'};
    height: 100%;
    opacity: 0;
    will-change: opacity, transform;

    @media (prefers-reduced-motion: no-preference) {
        ${(p)=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)`
            animation-name: ${$6b389fa467c067a6$var$animations[p.$animation]};
            animation-duration: ${p.$duration}ms;
            animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
            animation-fill-mode: both;
            animation-delay: var(--delay, 0ms);
            animation-play-state: ${p.$running ? 'running' : 'paused'};
        `}
    }

    @media (prefers-reduced-motion: reduce) {
        opacity: 1;
    }
`;
function $6b389fa467c067a6$export$2e2bcd8739ae039({ children: children, trigger: trigger = true, staggerDelay: staggerDelay = 120, baseDuration: baseDuration = 420, animation: animation = 'fadeInUp', startDelay: startDelay = 0, onComplete: onComplete, fullWidth: fullWidth = false }) {
    const items = (0, $7fPBF.useMemo)(()=>(0, $7fPBF.Children).toArray(children).filter(Boolean), [
        children
    ]);
    const [running, setRunning] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        setRunning(false);
        if (!trigger) return;
        const t = window.setTimeout(()=>{
            // double RAF ensures styles are committed before we flip running
            const r1 = requestAnimationFrame(()=>{
                const r2 = requestAnimationFrame(()=>setRunning(true));
                return ()=>cancelAnimationFrame(r2);
            });
            return ()=>cancelAnimationFrame(r1);
        }, startDelay);
        return ()=>clearTimeout(t);
    }, [
        trigger,
        startDelay,
        items.length
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!running || items.length === 0) return;
        const total = (items.length - 1) * staggerDelay + baseDuration;
        const t = window.setTimeout(()=>onComplete?.(), total);
        return ()=>clearTimeout(t);
    }, [
        running,
        items.length,
        staggerDelay,
        baseDuration,
        onComplete
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6b389fa467c067a6$var$Container, {
        $running: running,
        children: items.map((child, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6b389fa467c067a6$var$AnimatedItem, {
                $duration: baseDuration,
                $animation: animation,
                $running: running,
                $fullWidth: fullWidth,
                style: {
                    ['--delay']: `${i * staggerDelay}ms`
                },
                children: /*#__PURE__*/ (0, $7fPBF.isValidElement)(child) ? child : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    children: child
                })
            }, i))
    });
}











var $7fPBF = parcelRequire("7fPBF");


function $30ba1e267b5a3af7$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const { currentOrg: currentOrg, isExpiredOrg: isExpiredOrg, membership: membership, isLoading: isLoading, canEditOrganizationProfiles: canEditOrganizationProfiles, isManagedOrg: isManagedOrg, canManageBilling: canManageBilling } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const [orgProfiles, setOrgProfiles] = (0, $7fPBF.useState)([]);
    const [loadingProfiles, setLoadingProfiles] = (0, $7fPBF.useState)(true);
    const [filter, setFilter] = (0, $7fPBF.useState)('');
    const myRole = membership ? (0, $d227fca458ea4785$export$68befc518ea2400f)(membership) : undefined;
    const canManage = myRole?.canEditOrganizationProfiles || myRole?.isAdmin;
    (0, $7fPBF.useEffect)(()=>{
        const loadProfiles = async ()=>{
            if (!currentOrg?.id) return;
            setLoadingProfiles(true);
            try {
                const result = await $1a4c36336f303477$export$244d7766d2df1442(currentOrg.id);
                if (result?.resultType === 'Ok' && result.data) setOrgProfiles(result.data);
            } catch (error) {
                console.error('Error loading organization profiles:', error);
            } finally{
                setLoadingProfiles(false);
            }
        };
        if (currentOrg?.id) loadProfiles();
    }, [
        currentOrg?.id
    ]);
    const filteredProfiles = (0, $7fPBF.useMemo)(()=>{
        if (!filter) return orgProfiles;
        const lowerFilter = filter.toLowerCase();
        return orgProfiles.filter((profile)=>profile.name.toLowerCase().includes(lowerFilter) || profile.description?.toLowerCase().includes(lowerFilter));
    }, [
        orgProfiles,
        filter
    ]);
    const handleSearchChange = (e)=>{
        setFilter(e.target.value);
    };
    const handleClearSearch = ()=>{
        setFilter('');
    };
    const handleNavigateToProfile = (profileId, preview)=>{
        const destination = preview ? `./preview/${profileId}` : `./edit/${profileId}`;
        navigate(destination);
    };
    const handleCreateProfile = ()=>{
        navigate('./new');
    };
    if (!currentOrg || isLoading || loadingProfiles) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e8ddd06b3da44631$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:organization.profiles.title', {
                    value: currentOrg?.name
                }),
                description: t('common:organization.profiles.description'),
                items: items
            }),
            isExpiredOrg ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d1ebcf00b940bfdd$export$2e2bcd8739ae039), {
                organizationId: currentOrg.id,
                canManageBilling: canManageBilling,
                isManagedOrg: isManagedOrg,
                customBillingUrl: currentOrg.customBillingUrl
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    canManage && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        $color: "dashedAccent",
                        startIcon: "plus",
                        onClick: handleCreateProfile,
                        children: t('common:profile.create')
                    }),
                    orgProfiles.length > 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $51af5a17187af6b5$export$2e2bcd8739ae039), {
                        label: t('common:profile.search'),
                        value: filter,
                        onChange: handleSearchChange,
                        onClear: handleClearSearch
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $9926e0d0274623af$export$ce6636bfa4e9f0e8), {
                        children: [
                            filteredProfiles.length === 0 && filter && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: t('common:search.noResults')
                            }),
                            filteredProfiles.length === 0 && !filter && canManage && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
                                fullHeight: true,
                                description: t('common:organization.profiles.empty'),
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                    $color: "primary",
                                    startIcon: "plus",
                                    onClick: handleCreateProfile,
                                    children: t('common:profile.create')
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6b389fa467c067a6$export$2e2bcd8739ae039), {
                                fullWidth: true,
                                children: filteredProfiles.map((profile)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f034ea975db3d0b$export$2e2bcd8739ae039), {
                                        startComponent: profile.defaultLocale && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($30ba1e267b5a3af7$var$IconSpan, {
                                            children: (0, $3ecd3f7dea3d56de$export$a1451363a805f944)[profile.defaultLocale]
                                        }),
                                        title: profile.name,
                                        description: profile.description,
                                        onClick: ()=>handleNavigateToProfile(profile.id, !canEditOrganizationProfiles),
                                        iconSize: 24
                                    }, profile.id))
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $30ba1e267b5a3af7$var$IconSpan = (0, $8de346382d86c747$export$2e2bcd8739ae039).span`
    font-size: 24px;
    line-height: 0;
    display: flex;
    align-items: center;
`;


























var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");

/**
 * @import {Nodes, Parents} from 'hast'
 */ /**
 * Get the plain-text value of a hast node.
 *
 * @param {Nodes} node
 *   Node to serialize.
 * @returns {string}
 *   Serialized node.
 */ function $58714581718e6349$export$f84e8e69fd4488a5(node) {
    // “The concatenation of data of all the Text node descendants of the context
    // object, in tree order.”
    if ('children' in node) return $58714581718e6349$var$all(node);
    // “Context object’s data.”
    return 'value' in node ? node.value : '';
}
/**
 * @param {Nodes} node
 *   Node.
 * @returns {string}
 *   Serialized node.
 */ function $58714581718e6349$var$one(node) {
    if (node.type === 'text') return node.value;
    return 'children' in node ? $58714581718e6349$var$all(node) : '';
}
/**
 * @param {Parents} node
 *   Node.
 * @returns {string}
 *   Serialized node.
 */ function $58714581718e6349$var$all(node) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    while(++index < node.children.length)result[index] = $58714581718e6349$var$one(node.children[index]);
    return result.join('');
}


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 *
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ /**
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [cascade=true]
 *   Whether to drop parent nodes if they had children, but all their children
 *   were filtered out (default: `true`).
 */ 
const $31e44c919774b7ea$var$own = {}.hasOwnProperty;
function $31e44c919774b7ea$export$3dea766d36a8935f(tree, options, test) {
    const is = (0, $312c10cea7b70433$export$9c68d69a4c5bbcf9)(test || options);
    const cascadeRaw = options && typeof options === 'object' && 'cascade' in options ? /** @type {boolean | null | undefined} */ options.cascade : undefined;
    const cascade = cascadeRaw === undefined || cascadeRaw === null ? true : cascadeRaw;
    return preorder(tree);
    /**
   * @param {Node} node
   *   Current node.
   * @param {number | undefined} [index]
   *   Index of `node` in `parent`.
   * @param {Parent | undefined} [parentNode]
   *   Parent node.
   * @returns {Node | undefined}
   *   Shallow copy of `node`.
   */ function preorder(node, index, parentNode) {
        /** @type {Array<Node>} */ const children = [];
        if (!is(node, index, parentNode)) return undefined;
        if ($31e44c919774b7ea$var$parent(node)) {
            let childIndex = -1;
            while(++childIndex < node.children.length){
                const result = preorder(node.children[childIndex], childIndex, node);
                if (result) children.push(result);
            }
            if (cascade && node.children.length > 0 && children.length === 0) return undefined;
        }
        // Create a shallow clone, using the new children.
        /** @type {typeof node} */ // @ts-expect-error all the fields will be copied over.
        const next = {};
        /** @type {string} */ let key;
        for(key in node)if ($31e44c919774b7ea$var$own.call(node, key)) // @ts-expect-error: Looks like a record.
        next[key] = key === 'children' ? children : node[key];
        return next;
    }
}
/**
 * @param {Node} node
 * @returns {node is Parent}
 */ function $31e44c919774b7ea$var$parent(node) {
    return 'children' in node && node.children !== undefined;
}


var $97f2cf7466aff99c$exports = {};
/**
 * @param {string} string    The string to parse
 * @returns {Array<number>}  Returns an energetic array.
 */ function $97f2cf7466aff99c$var$parsePart(string) {
    let res = [];
    let m;
    for (let str of string.split(",").map((str)=>str.trim())){
        // just a number
        if (/^-?\d+$/.test(str)) res.push(parseInt(str, 10));
        else if (m = str.match(/^(-?\d+)(-|\.\.\.?|\u2025|\u2026|\u22EF)(-?\d+)$/)) {
            // 1-5 or 1..5 (equivalent) or 1...5 (doesn't include 5)
            let [_, lhs, sep, rhs] = m;
            if (lhs && rhs) {
                lhs = parseInt(lhs);
                rhs = parseInt(rhs);
                const incr = lhs < rhs ? 1 : -1;
                // Make it inclusive by moving the right 'stop-point' away by one.
                if (sep === "-" || sep === ".." || sep === "\u2025") rhs += incr;
                for(let i = lhs; i !== rhs; i += incr)res.push(i);
            }
        }
    }
    return res;
}
$97f2cf7466aff99c$exports.default = $97f2cf7466aff99c$var$parsePart;
$97f2cf7466aff99c$exports = $97f2cf7466aff99c$var$parsePart;


/**
 * @import {
 *   Grammar,
 *   RefractorElement,
 *   RefractorRoot,
 *   Syntax,
 *   Text
 * } from './core.js'
 */ // @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $4ad80295cf222241$export$2e2bcd8739ae039.displayName = 'clike';
$4ad80295cf222241$export$2e2bcd8739ae039.aliases = [];
function $4ad80295cf222241$export$2e2bcd8739ae039(Prism) {
    Prism.languages.clike = {
        comment: [
            {
                pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
            lookbehind: true,
            inside: {
                punctuation: /[.\\]/
            }
        },
        keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
        boolean: /\b(?:false|true)\b/,
        function: /\b\w+(?=\()/,
        number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
        operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
        punctuation: /[{}[\];(),.:]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$e064275ae5958777$export$2e2bcd8739ae039.displayName = 'c';
$e064275ae5958777$export$2e2bcd8739ae039.aliases = [];
function $e064275ae5958777$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    Prism.languages.c = Prism.languages.extend('clike', {
        comment: {
            pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
            greedy: true
        },
        string: {
            // https://en.cppreference.com/w/c/language/string_literal
            pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
            lookbehind: true
        },
        keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
        operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
    });
    Prism.languages.insertBefore('c', 'string', {
        char: {
            // https://en.cppreference.com/w/c/language/character_constant
            pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
            greedy: true
        }
    });
    Prism.languages.insertBefore('c', 'string', {
        macro: {
            // allow for multiline macro definitions
            // spaces after the # character compile fine with gcc
            pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
            lookbehind: true,
            greedy: true,
            alias: 'property',
            inside: {
                string: [
                    {
                        // highlight the path of the include statement as a string
                        pattern: /^(#\s*include\s*)<[^>]+>/,
                        lookbehind: true
                    },
                    Prism.languages.c['string']
                ],
                char: Prism.languages.c['char'],
                comment: Prism.languages.c['comment'],
                'macro-name': [
                    {
                        pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
                        lookbehind: true
                    },
                    {
                        pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
                        lookbehind: true,
                        alias: 'function'
                    }
                ],
                // highlight macro directives as keywords
                directive: {
                    pattern: /^(#\s*)[a-z]+/,
                    lookbehind: true,
                    alias: 'keyword'
                },
                'directive-hash': /^#/,
                punctuation: /##|\\(?=[\r\n])/,
                expression: {
                    pattern: /\S[\s\S]*/,
                    inside: Prism.languages.c
                }
            }
        }
    });
    Prism.languages.insertBefore('c', 'function', {
        // highlight predefined macros as constants
        constant: /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
    });
    delete Prism.languages.c['boolean'];
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$48c36581818e331d$export$2e2bcd8739ae039.displayName = 'cpp';
$48c36581818e331d$export$2e2bcd8739ae039.aliases = [];
function $48c36581818e331d$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $e064275ae5958777$export$2e2bcd8739ae039));
    (function(Prism) {
        var keyword = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/;
        var modName = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function() {
            return keyword.source;
        });
        Prism.languages.cpp = Prism.languages.extend('c', {
            'class-name': [
                {
                    pattern: RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g, function() {
                        return keyword.source;
                    })),
                    lookbehind: true
                },
                // This is intended to capture the class name of method implementations like:
                //   void foo::bar() const {}
                // However! The `foo` in the above example could also be a namespace, so we only capture the class name if
                // it starts with an uppercase letter. This approximation should give decent results.
                /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,
                // This will capture the class name before destructors like:
                //   Foo::~Foo() {}
                /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,
                // This also intends to capture the class name of method implementations but here the class has template
                // parameters, so it can't be a namespace (until C++ adds generic namespaces).
                /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/
            ],
            keyword: keyword,
            number: {
                pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
                greedy: true
            },
            operator: />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
            boolean: /\b(?:false|true)\b/
        });
        Prism.languages.insertBefore('cpp', 'string', {
            module: {
                // https://en.cppreference.com/w/cpp/language/modules
                pattern: RegExp(/(\b(?:import|module)\s+)/.source + '(?:' + // header-name
                /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + '|' + // module name or partition or both
                /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function() {
                    return modName;
                }) + ')'),
                lookbehind: true,
                greedy: true,
                inside: {
                    string: /^[<"][\s\S]+/,
                    operator: /:/,
                    punctuation: /\./
                }
            },
            'raw-string': {
                pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
                alias: 'string',
                greedy: true
            }
        });
        Prism.languages.insertBefore('cpp', 'keyword', {
            'generic-function': {
                pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
                inside: {
                    function: /^\w+/,
                    generic: {
                        pattern: /<[\s\S]+/,
                        alias: 'class-name',
                        inside: Prism.languages.cpp
                    }
                }
            }
        });
        Prism.languages.insertBefore('cpp', 'operator', {
            'double-colon': {
                pattern: /::/,
                alias: 'punctuation'
            }
        });
        Prism.languages.insertBefore('cpp', 'class-name', {
            // the base clause is an optional list of parent classes
            // https://en.cppreference.com/w/cpp/language/class
            'base-clause': {
                pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
                lookbehind: true,
                greedy: true,
                inside: Prism.languages.extend('cpp', {})
            }
        });
        Prism.languages.insertBefore('inside', 'double-colon', {
            // All untokenized words that are not namespaces should be class names
            'class-name': /\b[a-z_]\w*\b(?!\s*::)/i
        }, Prism.languages.cpp['base-clause']);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$b8123b708c3d0c30$export$2e2bcd8739ae039.displayName = 'arduino';
$b8123b708c3d0c30$export$2e2bcd8739ae039.aliases = [
    'ino'
];
function $b8123b708c3d0c30$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $48c36581818e331d$export$2e2bcd8739ae039));
    Prism.languages.arduino = Prism.languages.extend('cpp', {
        keyword: /\b(?:String|array|bool|boolean|break|byte|case|catch|continue|default|do|double|else|finally|for|function|goto|if|in|instanceof|int|integer|long|loop|new|null|return|setup|string|switch|throw|try|void|while|word)\b/,
        constant: /\b(?:ANALOG_MESSAGE|DEFAULT|DIGITAL_MESSAGE|EXTERNAL|FIRMATA_STRING|HIGH|INPUT|INPUT_PULLUP|INTERNAL|INTERNAL1V1|INTERNAL2V56|LED_BUILTIN|LOW|OUTPUT|REPORT_ANALOG|REPORT_DIGITAL|SET_PIN_MODE|SYSEX_START|SYSTEM_RESET)\b/,
        builtin: /\b(?:Audio|BSSID|Bridge|Client|Console|EEPROM|Esplora|EsploraTFT|Ethernet|EthernetClient|EthernetServer|EthernetUDP|File|FileIO|FileSystem|Firmata|GPRS|GSM|GSMBand|GSMClient|GSMModem|GSMPIN|GSMScanner|GSMServer|GSMVoiceCall|GSM_SMS|HttpClient|IPAddress|IRread|Keyboard|KeyboardController|LiquidCrystal|LiquidCrystal_I2C|Mailbox|Mouse|MouseController|PImage|Process|RSSI|RobotControl|RobotMotor|SD|SPI|SSID|Scheduler|Serial|Server|Servo|SoftwareSerial|Stepper|Stream|TFT|Task|USBHost|WiFi|WiFiClient|WiFiServer|WiFiUDP|Wire|YunClient|YunServer|abs|addParameter|analogRead|analogReadResolution|analogReference|analogWrite|analogWriteResolution|answerCall|attach|attachGPRS|attachInterrupt|attached|autoscroll|available|background|beep|begin|beginPacket|beginSD|beginSMS|beginSpeaker|beginTFT|beginTransmission|beginWrite|bit|bitClear|bitRead|bitSet|bitWrite|blink|blinkVersion|buffer|changePIN|checkPIN|checkPUK|checkReg|circle|cityNameRead|cityNameWrite|clear|clearScreen|click|close|compassRead|config|connect|connected|constrain|cos|countryNameRead|countryNameWrite|createChar|cursor|debugPrint|delay|delayMicroseconds|detach|detachInterrupt|digitalRead|digitalWrite|disconnect|display|displayLogos|drawBMP|drawCompass|encryptionType|end|endPacket|endSMS|endTransmission|endWrite|exists|exitValue|fill|find|findUntil|flush|gatewayIP|get|getAsynchronously|getBand|getButton|getCurrentCarrier|getIMEI|getKey|getModifiers|getOemKey|getPINUsed|getResult|getSignalStrength|getSocket|getVoiceCallStatus|getXChange|getYChange|hangCall|height|highByte|home|image|interrupts|isActionDone|isDirectory|isListening|isPIN|isPressed|isValid|keyPressed|keyReleased|keyboardRead|knobRead|leftToRight|line|lineFollowConfig|listen|listenOnLocalhost|loadImage|localIP|lowByte|macAddress|maintain|map|max|messageAvailable|micros|millis|min|mkdir|motorsStop|motorsWrite|mouseDragged|mouseMoved|mousePressed|mouseReleased|move|noAutoscroll|noBlink|noBuffer|noCursor|noDisplay|noFill|noInterrupts|noListenOnLocalhost|noStroke|noTone|onReceive|onRequest|open|openNextFile|overflow|parseCommand|parseFloat|parseInt|parsePacket|pauseMode|peek|pinMode|playFile|playMelody|point|pointTo|position|pow|prepare|press|print|printFirmwareVersion|printVersion|println|process|processInput|pulseIn|put|random|randomSeed|read|readAccelerometer|readBlue|readButton|readBytes|readBytesUntil|readGreen|readJoystickButton|readJoystickSwitch|readJoystickX|readJoystickY|readLightSensor|readMessage|readMicrophone|readNetworks|readRed|readSlider|readString|readStringUntil|readTemperature|ready|rect|release|releaseAll|remoteIP|remoteNumber|remotePort|remove|requestFrom|retrieveCallingNumber|rewindDirectory|rightToLeft|rmdir|robotNameRead|robotNameWrite|run|runAsynchronously|runShellCommand|runShellCommandAsynchronously|running|scanNetworks|scrollDisplayLeft|scrollDisplayRight|seek|sendAnalog|sendDigitalPortPair|sendDigitalPorts|sendString|sendSysex|serialEvent|setBand|setBitOrder|setClockDivider|setCursor|setDNS|setDataMode|setFirmwareVersion|setMode|setPINUsed|setSpeed|setTextSize|setTimeout|shiftIn|shiftOut|shutdown|sin|size|sqrt|startLoop|step|stop|stroke|subnetMask|switchPIN|tan|tempoWrite|text|tone|transfer|tuneWrite|turn|updateIR|userNameRead|userNameWrite|voiceCall|waitContinue|width|write|writeBlue|writeGreen|writeJSON|writeMessage|writeMicroseconds|writeRGB|writeRed|yield)\b/
    });
    Prism.languages.ino = Prism.languages.arduino;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $34bd8604ec75c450$export$2e2bcd8739ae039.displayName = 'bash';
$34bd8604ec75c450$export$2e2bcd8739ae039.aliases = [
    'sh',
    'shell'
];
function $34bd8604ec75c450$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // $ set | grep '^[A-Z][^[:space:]]*=' | cut -d= -f1 | tr '\n' '|'
        // + LC_ALL, RANDOM, REPLY, SECONDS.
        // + make sure PS1..4 are here as they are not always set,
        // - some useless things.
        var envVars = '\\b(?:BASH|BASHOPTS|BASH_ALIASES|BASH_ARGC|BASH_ARGV|BASH_CMDS|BASH_COMPLETION_COMPAT_DIR|BASH_LINENO|BASH_REMATCH|BASH_SOURCE|BASH_VERSINFO|BASH_VERSION|COLORTERM|COLUMNS|COMP_WORDBREAKS|DBUS_SESSION_BUS_ADDRESS|DEFAULTS_PATH|DESKTOP_SESSION|DIRSTACK|DISPLAY|EUID|GDMSESSION|GDM_LANG|GNOME_KEYRING_CONTROL|GNOME_KEYRING_PID|GPG_AGENT_INFO|GROUPS|HISTCONTROL|HISTFILE|HISTFILESIZE|HISTSIZE|HOME|HOSTNAME|HOSTTYPE|IFS|INSTANCE|JOB|LANG|LANGUAGE|LC_ADDRESS|LC_ALL|LC_IDENTIFICATION|LC_MEASUREMENT|LC_MONETARY|LC_NAME|LC_NUMERIC|LC_PAPER|LC_TELEPHONE|LC_TIME|LESSCLOSE|LESSOPEN|LINES|LOGNAME|LS_COLORS|MACHTYPE|MAILCHECK|MANDATORY_PATH|NO_AT_BRIDGE|OLDPWD|OPTERR|OPTIND|ORBIT_SOCKETDIR|OSTYPE|PAPERSIZE|PATH|PIPESTATUS|PPID|PS1|PS2|PS3|PS4|PWD|RANDOM|REPLY|SECONDS|SELINUX_INIT|SESSION|SESSIONTYPE|SESSION_MANAGER|SHELL|SHELLOPTS|SHLVL|SSH_AUTH_SOCK|TERM|UID|UPSTART_EVENTS|UPSTART_INSTANCE|UPSTART_JOB|UPSTART_SESSION|USER|WINDOWID|XAUTHORITY|XDG_CONFIG_DIRS|XDG_CURRENT_DESKTOP|XDG_DATA_DIRS|XDG_GREETER_DATA_DIR|XDG_MENU_PREFIX|XDG_RUNTIME_DIR|XDG_SEAT|XDG_SEAT_PATH|XDG_SESSION_DESKTOP|XDG_SESSION_ID|XDG_SESSION_PATH|XDG_SESSION_TYPE|XDG_VTNR|XMODIFIERS)\\b';
        var commandAfterHeredoc = {
            pattern: /(^(["']?)\w+\2)[ \t]+\S.*/,
            lookbehind: true,
            alias: 'punctuation',
            // this looks reasonably well in all themes
            inside: null // see below
        };
        var insideString = {
            bash: commandAfterHeredoc,
            environment: {
                pattern: RegExp('\\$' + envVars),
                alias: 'constant'
            },
            variable: [
                // [0]: Arithmetic Environment
                {
                    pattern: /\$?\(\([\s\S]+?\)\)/,
                    greedy: true,
                    inside: {
                        // If there is a $ sign at the beginning highlight $(( and )) as variable
                        variable: [
                            {
                                pattern: /(^\$\(\([\s\S]+)\)\)/,
                                lookbehind: true
                            },
                            /^\$\(\(/
                        ],
                        number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
                        // Operators according to https://www.gnu.org/software/bash/manual/bashref.html#Shell-Arithmetic
                        operator: /--|\+\+|\*\*=?|<<=?|>>=?|&&|\|\||[=!+\-*/%<>^&|]=?|[?~:]/,
                        // If there is no $ sign at the beginning highlight (( and )) as punctuation
                        punctuation: /\(\(?|\)\)?|,|;/
                    }
                },
                // [1]: Command Substitution
                {
                    pattern: /\$\((?:\([^)]+\)|[^()])+\)|`[^`]+`/,
                    greedy: true,
                    inside: {
                        variable: /^\$\(|^`|\)$|`$/
                    }
                },
                // [2]: Brace expansion
                {
                    pattern: /\$\{[^}]+\}/,
                    greedy: true,
                    inside: {
                        operator: /:[-=?+]?|[!\/]|##?|%%?|\^\^?|,,?/,
                        punctuation: /[\[\]]/,
                        environment: {
                            pattern: RegExp('(\\{)' + envVars),
                            lookbehind: true,
                            alias: 'constant'
                        }
                    }
                },
                /\$(?:\w+|[#?*!@$])/
            ],
            // Escape sequences from echo and printf's manuals, and escaped quotes.
            entity: /\\(?:[abceEfnrtv\\"]|O?[0-7]{1,3}|U[0-9a-fA-F]{8}|u[0-9a-fA-F]{4}|x[0-9a-fA-F]{1,2})/
        };
        Prism.languages.bash = {
            shebang: {
                pattern: /^#!\s*\/.*/,
                alias: 'important'
            },
            comment: {
                pattern: /(^|[^"{\\$])#.*/,
                lookbehind: true
            },
            'function-name': [
                // a) function foo {
                // b) foo() {
                // c) function foo() {
                // but not “foo {”
                {
                    // a) and c)
                    pattern: /(\bfunction\s+)[\w-]+(?=(?:\s*\(?:\s*\))?\s*\{)/,
                    lookbehind: true,
                    alias: 'function'
                },
                {
                    // b)
                    pattern: /\b[\w-]+(?=\s*\(\s*\)\s*\{)/,
                    alias: 'function'
                }
            ],
            // Highlight variable names as variables in for and select beginnings.
            'for-or-select': {
                pattern: /(\b(?:for|select)\s+)\w+(?=\s+in\s)/,
                alias: 'variable',
                lookbehind: true
            },
            // Highlight variable names as variables in the left-hand part
            // of assignments (“=” and “+=”).
            'assign-left': {
                pattern: /(^|[\s;|&]|[<>]\()\w+(?:\.\w+)*(?=\+?=)/,
                inside: {
                    environment: {
                        pattern: RegExp('(^|[\\s;|&]|[<>]\\()' + envVars),
                        lookbehind: true,
                        alias: 'constant'
                    }
                },
                alias: 'variable',
                lookbehind: true
            },
            // Highlight parameter names as variables
            parameter: {
                pattern: /(^|\s)-{1,2}(?:\w+:[+-]?)?\w+(?:\.\w+)*(?=[=\s]|$)/,
                alias: 'variable',
                lookbehind: true
            },
            string: [
                // Support for Here-documents https://en.wikipedia.org/wiki/Here_document
                {
                    pattern: /((?:^|[^<])<<-?\s*)(\w+)\s[\s\S]*?(?:\r?\n|\r)\2/,
                    lookbehind: true,
                    greedy: true,
                    inside: insideString
                },
                // Here-document with quotes around the tag
                // → No expansion (so no “inside”).
                {
                    pattern: /((?:^|[^<])<<-?\s*)(["'])(\w+)\2\s[\s\S]*?(?:\r?\n|\r)\3/,
                    lookbehind: true,
                    greedy: true,
                    inside: {
                        bash: commandAfterHeredoc
                    }
                },
                // “Normal” string
                {
                    // https://www.gnu.org/software/bash/manual/html_node/Double-Quotes.html
                    pattern: /(^|[^\\](?:\\\\)*)"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/,
                    lookbehind: true,
                    greedy: true,
                    inside: insideString
                },
                {
                    // https://www.gnu.org/software/bash/manual/html_node/Single-Quotes.html
                    pattern: /(^|[^$\\])'[^']*'/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    // https://www.gnu.org/software/bash/manual/html_node/ANSI_002dC-Quoting.html
                    pattern: /\$'(?:[^'\\]|\\[\s\S])*'/,
                    greedy: true,
                    inside: {
                        entity: insideString.entity
                    }
                }
            ],
            environment: {
                pattern: RegExp('\\$?' + envVars),
                alias: 'constant'
            },
            variable: insideString.variable,
            function: {
                pattern: /(^|[\s;|&]|[<>]\()(?:add|apropos|apt|apt-cache|apt-get|aptitude|aspell|automysqlbackup|awk|basename|bash|bc|bconsole|bg|bzip2|cal|cargo|cat|cfdisk|chgrp|chkconfig|chmod|chown|chroot|cksum|clear|cmp|column|comm|composer|cp|cron|crontab|csplit|curl|cut|date|dc|dd|ddrescue|debootstrap|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|docker|docker-compose|du|egrep|eject|env|ethtool|expand|expect|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|git|gparted|grep|groupadd|groupdel|groupmod|groups|grub-mkconfig|gzip|halt|head|hg|history|host|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|ip|java|jobs|join|kill|killall|less|link|ln|locate|logname|logrotate|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|lynx|make|man|mc|mdadm|mkconfig|mkdir|mke2fs|mkfifo|mkfs|mkisofs|mknod|mkswap|mmv|more|most|mount|mtools|mtr|mutt|mv|nano|nc|netstat|nice|nl|node|nohup|notify-send|npm|nslookup|op|open|parted|passwd|paste|pathchk|ping|pkill|pnpm|podman|podman-compose|popd|pr|printcap|printenv|ps|pushd|pv|quota|quotacheck|quotactl|ram|rar|rcp|reboot|remsync|rename|renice|rev|rm|rmdir|rpm|rsync|scp|screen|sdiff|sed|sendmail|seq|service|sftp|sh|shellcheck|shuf|shutdown|sleep|slocate|sort|split|ssh|stat|strace|su|sudo|sum|suspend|swapon|sync|sysctl|tac|tail|tar|tee|time|timeout|top|touch|tr|traceroute|tsort|tty|umount|uname|unexpand|uniq|units|unrar|unshar|unzip|update-grub|uptime|useradd|userdel|usermod|users|uudecode|uuencode|v|vcpkg|vdir|vi|vim|virsh|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yarn|yes|zenity|zip|zsh|zypper)(?=$|[)\s;|&])/,
                lookbehind: true
            },
            keyword: {
                pattern: /(^|[\s;|&]|[<>]\()(?:case|do|done|elif|else|esac|fi|for|function|if|in|select|then|until|while)(?=$|[)\s;|&])/,
                lookbehind: true
            },
            // https://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
            builtin: {
                pattern: /(^|[\s;|&]|[<>]\()(?:\.|:|alias|bind|break|builtin|caller|cd|command|continue|declare|echo|enable|eval|exec|exit|export|getopts|hash|help|let|local|logout|mapfile|printf|pwd|read|readarray|readonly|return|set|shift|shopt|source|test|times|trap|type|typeset|ulimit|umask|unalias|unset)(?=$|[)\s;|&])/,
                lookbehind: true,
                // Alias added to make those easier to distinguish from strings.
                alias: 'class-name'
            },
            boolean: {
                pattern: /(^|[\s;|&]|[<>]\()(?:false|true)(?=$|[)\s;|&])/,
                lookbehind: true
            },
            'file-descriptor': {
                pattern: /\B&\d\b/,
                alias: 'important'
            },
            operator: {
                // Lots of redirections here, but not just that.
                pattern: /\d?<>|>\||\+=|=[=~]?|!=?|<<[<-]?|[&\d]?>>|\d[<>]&?|[<>][&=]?|&[>&]?|\|[&|]?/,
                inside: {
                    'file-descriptor': {
                        pattern: /^\d/,
                        alias: 'important'
                    }
                }
            },
            punctuation: /\$?\(\(?|\)\)?|\.\.|[{}[\];\\]/,
            number: {
                pattern: /(^|\s)(?:[1-9]\d*|0)(?:[.,]\d+)?\b/,
                lookbehind: true
            }
        };
        commandAfterHeredoc.inside = Prism.languages.bash;
        /* Patterns in command substitution. */ var toBeCopied = [
            'comment',
            'function-name',
            'for-or-select',
            'assign-left',
            'parameter',
            'string',
            'environment',
            'function',
            'keyword',
            'builtin',
            'boolean',
            'file-descriptor',
            'operator',
            'punctuation',
            'number'
        ];
        var inside = insideString.variable[1].inside;
        for(var i = 0; i < toBeCopied.length; i++)inside[toBeCopied[i]] = Prism.languages.bash[toBeCopied[i]];
        Prism.languages.sh = Prism.languages.bash;
        Prism.languages.shell = Prism.languages.bash;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$e1ab06973c0a6c0a$export$2e2bcd8739ae039.displayName = 'csharp';
$e1ab06973c0a6c0a$export$2e2bcd8739ae039.aliases = [
    'cs',
    'dotnet'
];
function $e1ab06973c0a6c0a$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    (function(Prism) {
        /**
     * Replaces all placeholders "<<n>>" of given pattern with the n-th replacement (zero based).
     *
     * Note: This is a simple text based replacement. Be careful when using backreferences!
     *
     * @param {string} pattern the given pattern.
     * @param {string[]} replacements a list of replacement which can be inserted into the given pattern.
     * @returns {string} the pattern with all placeholders replaced with their corresponding replacements.
     * @example replace(/a<<0>>a/.source, [/b+/.source]) === /a(?:b+)a/.source
     */ function replace(pattern, replacements) {
            return pattern.replace(/<<(\d+)>>/g, function(m, index) {
                return '(?:' + replacements[+index] + ')';
            });
        }
        /**
     * @param {string} pattern
     * @param {string[]} replacements
     * @param {string} [flags]
     * @returns {RegExp}
     */ function re(pattern, replacements, flags) {
            return RegExp(replace(pattern, replacements), flags || '');
        }
        /**
     * Creates a nested pattern where all occurrences of the string `<<self>>` are replaced with the pattern itself.
     *
     * @param {string} pattern
     * @param {number} depthLog2
     * @returns {string}
     */ function nested(pattern, depthLog2) {
            for(var i = 0; i < depthLog2; i++)pattern = pattern.replace(/<<self>>/g, function() {
                return '(?:' + pattern + ')';
            });
            return pattern.replace(/<<self>>/g, '[^\\s\\S]');
        }
        // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/keywords/
        var keywordKinds = {
            // keywords which represent a return or variable type
            type: 'bool byte char decimal double dynamic float int long object sbyte short string uint ulong ushort var void',
            // keywords which are used to declare a type
            typeDeclaration: 'class enum interface record struct',
            // contextual keywords
            // ("var" and "dynamic" are missing because they are used like types)
            contextual: 'add alias and ascending async await by descending from(?=\\s*(?:\\w|$)) get global group into init(?=\\s*;) join let nameof not notnull on or orderby partial remove select set unmanaged value when where with(?=\\s*{)',
            // all other keywords
            other: 'abstract as base break case catch checked const continue default delegate do else event explicit extern finally fixed for foreach goto if implicit in internal is lock namespace new null operator out override params private protected public readonly ref return sealed sizeof stackalloc static switch this throw try typeof unchecked unsafe using virtual volatile while yield'
        };
        // keywords
        function keywordsToPattern(words) {
            return '\\b(?:' + words.trim().replace(/ /g, '|') + ')\\b';
        }
        var typeDeclarationKeywords = keywordsToPattern(keywordKinds.typeDeclaration);
        var keywords = RegExp(keywordsToPattern(keywordKinds.type + ' ' + keywordKinds.typeDeclaration + ' ' + keywordKinds.contextual + ' ' + keywordKinds.other));
        var nonTypeKeywords = keywordsToPattern(keywordKinds.typeDeclaration + ' ' + keywordKinds.contextual + ' ' + keywordKinds.other);
        var nonContextualKeywords = keywordsToPattern(keywordKinds.type + ' ' + keywordKinds.typeDeclaration + ' ' + keywordKinds.other);
        // types
        var generic = nested(/<(?:[^<>;=+\-*/%&|^]|<<self>>)*>/.source, 2) // the idea behind the other forbidden characters is to prevent false positives. Same for tupleElement.
        ;
        var nestedRound = nested(/\((?:[^()]|<<self>>)*\)/.source, 2);
        var name = /@?\b[A-Za-z_]\w*\b/.source;
        var genericName = replace(/<<0>>(?:\s*<<1>>)?/.source, [
            name,
            generic
        ]);
        var identifier = replace(/(?!<<0>>)<<1>>(?:\s*\.\s*<<1>>)*/.source, [
            nonTypeKeywords,
            genericName
        ]);
        var array = /\[\s*(?:,\s*)*\]/.source;
        var typeExpressionWithoutTuple = replace(/<<0>>(?:\s*(?:\?\s*)?<<1>>)*(?:\s*\?)?/.source, [
            identifier,
            array
        ]);
        var tupleElement = replace(/[^,()<>[\];=+\-*/%&|^]|<<0>>|<<1>>|<<2>>/.source, [
            generic,
            nestedRound,
            array
        ]);
        var tuple = replace(/\(<<0>>+(?:,<<0>>+)+\)/.source, [
            tupleElement
        ]);
        var typeExpression = replace(/(?:<<0>>|<<1>>)(?:\s*(?:\?\s*)?<<2>>)*(?:\s*\?)?/.source, [
            tuple,
            identifier,
            array
        ]);
        var typeInside = {
            keyword: keywords,
            punctuation: /[<>()?,.:[\]]/
        };
        // strings & characters
        // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/language-specification/lexical-structure#character-literals
        // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/language-specification/lexical-structure#string-literals
        var character = /'(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'/.source // simplified pattern
        ;
        var regularString = /"(?:\\.|[^\\"\r\n])*"/.source;
        var verbatimString = /@"(?:""|\\[\s\S]|[^\\"])*"(?!")/.source;
        Prism.languages.csharp = Prism.languages.extend('clike', {
            string: [
                {
                    pattern: re(/(^|[^$\\])<<0>>/.source, [
                        verbatimString
                    ]),
                    lookbehind: true,
                    greedy: true
                },
                {
                    pattern: re(/(^|[^@$\\])<<0>>/.source, [
                        regularString
                    ]),
                    lookbehind: true,
                    greedy: true
                }
            ],
            'class-name': [
                {
                    // Using static
                    // using static System.Math;
                    pattern: re(/(\busing\s+static\s+)<<0>>(?=\s*;)/.source, [
                        identifier
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // Using alias (type)
                    // using Project = PC.MyCompany.Project;
                    pattern: re(/(\busing\s+<<0>>\s*=\s*)<<1>>(?=\s*;)/.source, [
                        name,
                        typeExpression
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // Using alias (alias)
                    // using Project = PC.MyCompany.Project;
                    pattern: re(/(\busing\s+)<<0>>(?=\s*=)/.source, [
                        name
                    ]),
                    lookbehind: true
                },
                {
                    // Type declarations
                    // class Foo<A, B>
                    // interface Foo<out A, B>
                    pattern: re(/(\b<<0>>\s+)<<1>>/.source, [
                        typeDeclarationKeywords,
                        genericName
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // Single catch exception declaration
                    // catch(Foo)
                    // (things like catch(Foo e) is covered by variable declaration)
                    pattern: re(/(\bcatch\s*\(\s*)<<0>>/.source, [
                        identifier
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // Name of the type parameter of generic constraints
                    // where Foo : class
                    pattern: re(/(\bwhere\s+)<<0>>/.source, [
                        name
                    ]),
                    lookbehind: true
                },
                {
                    // Casts and checks via as and is.
                    // as Foo<A>, is Bar<B>
                    // (things like if(a is Foo b) is covered by variable declaration)
                    pattern: re(/(\b(?:is(?:\s+not)?|as)\s+)<<0>>/.source, [
                        typeExpressionWithoutTuple
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // Variable, field and parameter declaration
                    // (Foo bar, Bar baz, Foo[,,] bay, Foo<Bar, FooBar<Bar>> bax)
                    pattern: re(/\b<<0>>(?=\s+(?!<<1>>|with\s*\{)<<2>>(?:\s*[=,;:{)\]]|\s+(?:in|when)\b))/.source, [
                        typeExpression,
                        nonContextualKeywords,
                        name
                    ]),
                    inside: typeInside
                }
            ],
            keyword: keywords,
            // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/language-specification/lexical-structure#literals
            number: /(?:\b0(?:x[\da-f_]*[\da-f]|b[01_]*[01])|(?:\B\.\d+(?:_+\d+)*|\b\d+(?:_+\d+)*(?:\.\d+(?:_+\d+)*)?)(?:e[-+]?\d+(?:_+\d+)*)?)(?:[dflmu]|lu|ul)?\b/i,
            operator: />>=?|<<=?|[-=]>|([-+&|])\1|~|\?\?=?|[-+*/%&|^!=<>]=?/,
            punctuation: /\?\.?|::|[{}[\];(),.:]/
        });
        Prism.languages.insertBefore('csharp', 'number', {
            range: {
                pattern: /\.\./,
                alias: 'operator'
            }
        });
        Prism.languages.insertBefore('csharp', 'punctuation', {
            'named-parameter': {
                pattern: re(/([(,]\s*)<<0>>(?=\s*:)/.source, [
                    name
                ]),
                lookbehind: true,
                alias: 'punctuation'
            }
        });
        Prism.languages.insertBefore('csharp', 'class-name', {
            namespace: {
                // namespace Foo.Bar {}
                // using Foo.Bar;
                pattern: re(/(\b(?:namespace|using)\s+)<<0>>(?:\s*\.\s*<<0>>)*(?=\s*[;{])/.source, [
                    name
                ]),
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            },
            'type-expression': {
                // default(Foo), typeof(Foo<Bar>), sizeof(int)
                pattern: re(/(\b(?:default|sizeof|typeof)\s*\(\s*(?!\s))(?:[^()\s]|\s(?!\s)|<<0>>)*(?=\s*\))/.source, [
                    nestedRound
                ]),
                lookbehind: true,
                alias: 'class-name',
                inside: typeInside
            },
            'return-type': {
                // Foo<Bar> ForBar(); Foo IFoo.Bar() => 0
                // int this[int index] => 0; T IReadOnlyList<T>.this[int index] => this[index];
                // int Foo => 0; int Foo { get; set } = 0;
                pattern: re(/<<0>>(?=\s+(?:<<1>>\s*(?:=>|[({]|\.\s*this\s*\[)|this\s*\[))/.source, [
                    typeExpression,
                    identifier
                ]),
                inside: typeInside,
                alias: 'class-name'
            },
            'constructor-invocation': {
                // new List<Foo<Bar[]>> { }
                pattern: re(/(\bnew\s+)<<0>>(?=\s*[[({])/.source, [
                    typeExpression
                ]),
                lookbehind: true,
                inside: typeInside,
                alias: 'class-name'
            },
            /*'explicit-implementation': {
// int IFoo<Foo>.Bar => 0; void IFoo<Foo<Foo>>.Foo<T>();
pattern: replace(/\b<<0>>(?=\.<<1>>)/, className, methodOrPropertyDeclaration),
inside: classNameInside,
alias: 'class-name'
},*/ 'generic-method': {
                // foo<Bar>()
                pattern: re(/<<0>>\s*<<1>>(?=\s*\()/.source, [
                    name,
                    generic
                ]),
                inside: {
                    function: re(/^<<0>>/.source, [
                        name
                    ]),
                    generic: {
                        pattern: RegExp(generic),
                        alias: 'class-name',
                        inside: typeInside
                    }
                }
            },
            'type-list': {
                // The list of types inherited or of generic constraints
                // class Foo<F> : Bar, IList<FooBar>
                // where F : Bar, IList<int>
                pattern: re(/\b((?:<<0>>\s+<<1>>|record\s+<<1>>\s*<<5>>|where\s+<<2>>)\s*:\s*)(?:<<3>>|<<4>>|<<1>>\s*<<5>>|<<6>>)(?:\s*,\s*(?:<<3>>|<<4>>|<<6>>))*(?=\s*(?:where|[{;]|=>|$))/.source, [
                    typeDeclarationKeywords,
                    genericName,
                    name,
                    typeExpression,
                    keywords.source,
                    nestedRound,
                    /\bnew\s*\(\s*\)/.source
                ]),
                lookbehind: true,
                inside: {
                    'record-arguments': {
                        pattern: re(/(^(?!new\s*\()<<0>>\s*)<<1>>/.source, [
                            genericName,
                            nestedRound
                        ]),
                        lookbehind: true,
                        greedy: true,
                        inside: Prism.languages.csharp
                    },
                    keyword: keywords,
                    'class-name': {
                        pattern: RegExp(typeExpression),
                        greedy: true,
                        inside: typeInside
                    },
                    punctuation: /[,()]/
                }
            },
            preprocessor: {
                pattern: /(^[\t ]*)#.*/m,
                lookbehind: true,
                alias: 'property',
                inside: {
                    // highlight preprocessor directives as keywords
                    directive: {
                        pattern: /(#)\b(?:define|elif|else|endif|endregion|error|if|line|nullable|pragma|region|undef|warning)\b/,
                        lookbehind: true,
                        alias: 'keyword'
                    }
                }
            }
        });
        // attributes
        var regularStringOrCharacter = regularString + '|' + character;
        var regularStringCharacterOrComment = replace(/\/(?![*/])|\/\/[^\r\n]*[\r\n]|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>/.source, [
            regularStringOrCharacter
        ]);
        var roundExpression = nested(replace(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [
            regularStringCharacterOrComment
        ]), 2);
        // https://docs.microsoft.com/en-us/dotnet/csharp/programming-guide/concepts/attributes/#attribute-targets
        var attrTarget = /\b(?:assembly|event|field|method|module|param|property|return|type)\b/.source;
        var attr = replace(/<<0>>(?:\s*\(<<1>>*\))?/.source, [
            identifier,
            roundExpression
        ]);
        Prism.languages.insertBefore('csharp', 'class-name', {
            attribute: {
                // Attributes
                // [Foo], [Foo(1), Bar(2, Prop = "foo")], [return: Foo(1), Bar(2)], [assembly: Foo(Bar)]
                pattern: re(/((?:^|[^\s\w>)?])\s*\[\s*)(?:<<0>>\s*:\s*)?<<1>>(?:\s*,\s*<<1>>)*(?=\s*\])/.source, [
                    attrTarget,
                    attr
                ]),
                lookbehind: true,
                greedy: true,
                inside: {
                    target: {
                        pattern: re(/^<<0>>(?=\s*:)/.source, [
                            attrTarget
                        ]),
                        alias: 'keyword'
                    },
                    'attribute-arguments': {
                        pattern: re(/\(<<0>>*\)/.source, [
                            roundExpression
                        ]),
                        inside: Prism.languages.csharp
                    },
                    'class-name': {
                        pattern: RegExp(identifier),
                        inside: {
                            punctuation: /\./
                        }
                    },
                    punctuation: /[:,]/
                }
            }
        });
        // string interpolation
        var formatString = /:[^}\r\n]+/.source;
        // multi line
        var mInterpolationRound = nested(replace(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [
            regularStringCharacterOrComment
        ]), 2);
        var mInterpolation = replace(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [
            mInterpolationRound,
            formatString
        ]);
        // single line
        var sInterpolationRound = nested(replace(/[^"'/()]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>|\(<<self>>*\)/.source, [
            regularStringOrCharacter
        ]), 2);
        var sInterpolation = replace(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [
            sInterpolationRound,
            formatString
        ]);
        function createInterpolationInside(interpolation, interpolationRound) {
            return {
                interpolation: {
                    pattern: re(/((?:^|[^{])(?:\{\{)*)<<0>>/.source, [
                        interpolation
                    ]),
                    lookbehind: true,
                    inside: {
                        'format-string': {
                            pattern: re(/(^\{(?:(?![}:])<<0>>)*)<<1>>(?=\}$)/.source, [
                                interpolationRound,
                                formatString
                            ]),
                            lookbehind: true,
                            inside: {
                                punctuation: /^:/
                            }
                        },
                        punctuation: /^\{|\}$/,
                        expression: {
                            pattern: /[\s\S]+/,
                            alias: 'language-csharp',
                            inside: Prism.languages.csharp
                        }
                    }
                },
                string: /[\s\S]+/
            };
        }
        Prism.languages.insertBefore('csharp', 'string', {
            'interpolation-string': [
                {
                    pattern: re(/(^|[^\\])(?:\$@|@\$)"(?:""|\\[\s\S]|\{\{|<<0>>|[^\\{"])*"/.source, [
                        mInterpolation
                    ]),
                    lookbehind: true,
                    greedy: true,
                    inside: createInterpolationInside(mInterpolation, mInterpolationRound)
                },
                {
                    pattern: re(/(^|[^@\\])\$"(?:\\.|\{\{|<<0>>|[^\\"{])*"/.source, [
                        sInterpolation
                    ]),
                    lookbehind: true,
                    greedy: true,
                    inside: createInterpolationInside(sInterpolation, sInterpolationRound)
                }
            ],
            char: {
                pattern: RegExp(character),
                greedy: true
            }
        });
        Prism.languages.dotnet = Prism.languages.cs = Prism.languages.csharp;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $8fbeea7c20d72e06$export$2e2bcd8739ae039.displayName = 'markup';
$8fbeea7c20d72e06$export$2e2bcd8739ae039.aliases = [
    'atom',
    'html',
    'mathml',
    'rss',
    'ssml',
    'svg',
    'xml'
];
function $8fbeea7c20d72e06$export$2e2bcd8739ae039(Prism) {
    Prism.languages.markup = {
        comment: {
            pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
            greedy: true
        },
        prolog: {
            pattern: /<\?[\s\S]+?\?>/,
            greedy: true
        },
        doctype: {
            // https://www.w3.org/TR/xml/#NT-doctypedecl
            pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
            greedy: true,
            inside: {
                'internal-subset': {
                    pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                    lookbehind: true,
                    greedy: true,
                    inside: null // see below
                },
                string: {
                    pattern: /"[^"]*"|'[^']*'/,
                    greedy: true
                },
                punctuation: /^<!|>$|[[\]]/,
                'doctype-tag': /^DOCTYPE/i,
                name: /[^\s<>'"]+/
            }
        },
        cdata: {
            pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
            greedy: true
        },
        tag: {
            pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
            greedy: true,
            inside: {
                tag: {
                    pattern: /^<\/?[^\s>\/]+/,
                    inside: {
                        punctuation: /^<\/?/,
                        namespace: /^[^\s>\/:]+:/
                    }
                },
                'special-attr': [],
                'attr-value': {
                    pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                    inside: {
                        punctuation: [
                            {
                                pattern: /^=/,
                                alias: 'attr-equals'
                            },
                            {
                                pattern: /^(\s*)["']|["']$/,
                                lookbehind: true
                            }
                        ]
                    }
                },
                punctuation: /\/?>/,
                'attr-name': {
                    pattern: /[^\s>\/]+/,
                    inside: {
                        namespace: /^[^\s>\/:]+:/
                    }
                }
            }
        },
        entity: [
            {
                pattern: /&[\da-z]{1,8};/i,
                alias: 'named-entity'
            },
            /&#x?[\da-f]{1,8};/i
        ]
    };
    Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] = Prism.languages.markup['entity'];
    Prism.languages.markup['doctype'].inside['internal-subset'].inside = Prism.languages.markup;
    // Plugin to make entity title show the real entity, idea by Roman Komarov
    Prism.hooks.add('wrap', function(env) {
        if (env.type === 'entity') env.attributes['title'] = env.content.value.replace(/&amp;/, '&');
    });
    Object.defineProperty(Prism.languages.markup.tag, 'addInlined', {
        /**
     * Adds an inlined language to markup.
     *
     * An example of an inlined language is CSS with `<style>` tags.
     *
     * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addInlined('style', 'css');
     */ value: function addInlined(tagName, lang) {
            var includedCdataInside = {};
            includedCdataInside['language-' + lang] = {
                pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
                lookbehind: true,
                inside: Prism.languages[lang]
            };
            includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;
            var inside = {
                'included-cdata': {
                    pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                    inside: includedCdataInside
                }
            };
            inside['language-' + lang] = {
                pattern: /[\s\S]+/,
                inside: Prism.languages[lang]
            };
            var def = {};
            def[tagName] = {
                pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                    return tagName;
                }), 'i'),
                lookbehind: true,
                greedy: true,
                inside: inside
            };
            Prism.languages.insertBefore('markup', 'cdata', def);
        }
    });
    Object.defineProperty(Prism.languages.markup.tag, 'addAttribute', {
        /**
     * Adds an pattern to highlight languages embedded in HTML attributes.
     *
     * An example of an inlined language is CSS with `style` attributes.
     *
     * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addAttribute('style', 'css');
     */ value: function(attrName, lang) {
            Prism.languages.markup.tag.inside['special-attr'].push({
                pattern: RegExp(/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, 'i'),
                lookbehind: true,
                inside: {
                    'attr-name': /^[^\s=]+/,
                    'attr-value': {
                        pattern: /=[\s\S]+/,
                        inside: {
                            value: {
                                pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                                lookbehind: true,
                                alias: [
                                    lang,
                                    'language-' + lang
                                ],
                                inside: Prism.languages[lang]
                            },
                            punctuation: [
                                {
                                    pattern: /^=/,
                                    alias: 'attr-equals'
                                },
                                /"|'/
                            ]
                        }
                    }
                }
            });
        }
    });
    Prism.languages.html = Prism.languages.markup;
    Prism.languages.mathml = Prism.languages.markup;
    Prism.languages.svg = Prism.languages.markup;
    Prism.languages.xml = Prism.languages.extend('markup', {});
    Prism.languages.ssml = Prism.languages.xml;
    Prism.languages.atom = Prism.languages.xml;
    Prism.languages.rss = Prism.languages.xml;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $c8ae87468323f6e6$export$2e2bcd8739ae039.displayName = 'css';
$c8ae87468323f6e6$export$2e2bcd8739ae039.aliases = [];
function $c8ae87468323f6e6$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
        Prism.languages.css = {
            comment: /\/\*[\s\S]*?\*\//,
            atrule: {
                pattern: RegExp('@[\\w-](?:' + /[^;{\s"']|\s+(?!\s)/.source + '|' + string.source + ')*?' + /(?:;|(?=\s*\{))/.source),
                inside: {
                    rule: /^@[\w-]+/,
                    'selector-function-argument': {
                        pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                        lookbehind: true,
                        alias: 'selector'
                    },
                    keyword: {
                        pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                        lookbehind: true
                    }
                }
            },
            url: {
                // https://drafts.csswg.org/css-values-3/#urls
                pattern: RegExp('\\burl\\((?:' + string.source + '|' + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ')\\)', 'i'),
                greedy: true,
                inside: {
                    function: /^url/i,
                    punctuation: /^\(|\)$/,
                    string: {
                        pattern: RegExp('^' + string.source + '$'),
                        alias: 'url'
                    }
                }
            },
            selector: {
                pattern: RegExp('(^|[{}\\s])[^{}\\s](?:[^{};"\'\\s]|\\s+(?![\\s{])|' + string.source + ')*(?=\\s*\\{)'),
                lookbehind: true
            },
            string: {
                pattern: string,
                greedy: true
            },
            property: {
                pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
                lookbehind: true
            },
            important: /!important\b/i,
            function: {
                pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
                lookbehind: true
            },
            punctuation: /[(){};:,]/
        };
        Prism.languages.css['atrule'].inside.rest = Prism.languages.css;
        var markup = Prism.languages.markup;
        if (markup) {
            markup.tag.addInlined('style', 'css');
            markup.tag.addAttribute('style', 'css');
        }
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $5f6e332fbf45b5ef$export$2e2bcd8739ae039.displayName = 'diff';
$5f6e332fbf45b5ef$export$2e2bcd8739ae039.aliases = [];
function $5f6e332fbf45b5ef$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.diff = {
            coord: [
                // Match all kinds of coord lines (prefixed by "+++", "---" or "***").
                /^(?:\*{3}|-{3}|\+{3}).*$/m,
                // Match "@@ ... @@" coord lines in unified diff.
                /^@@.*@@$/m,
                // Match coord lines in normal diff (starts with a number).
                /^\d.*$/m
            ]
        };
        /**
     * A map from the name of a block to its line prefix.
     *
     * @type {Object<string, string>}
     */ var PREFIXES = {
            'deleted-sign': '-',
            'deleted-arrow': '<',
            'inserted-sign': '+',
            'inserted-arrow': '>',
            unchanged: ' ',
            diff: '!'
        };
        // add a token for each prefix
        Object.keys(PREFIXES).forEach(function(name) {
            var prefix = PREFIXES[name];
            var alias = [];
            if (!/^\w+$/.test(name)) // "deleted-sign" -> "deleted"
            alias.push(/\w+/.exec(name)[0]);
            if (name === 'diff') alias.push('bold');
            Prism.languages.diff[name] = {
                pattern: RegExp('^(?:[' + prefix + '].*(?:\r\n?|\n|(?![\\s\\S])))+', 'm'),
                alias: alias,
                inside: {
                    line: {
                        pattern: /(.)(?=[\s\S]).*(?:\r\n?|\n)?/,
                        lookbehind: true
                    },
                    prefix: {
                        pattern: /[\s\S]/,
                        alias: /\w+/.exec(name)[0]
                    }
                }
            };
        });
        // make prefixes available to Diff plugin
        Object.defineProperty(Prism.languages.diff, 'PREFIXES', {
            value: PREFIXES
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$baa978ee70a8092e$export$2e2bcd8739ae039.displayName = 'go';
$baa978ee70a8092e$export$2e2bcd8739ae039.aliases = [];
function $baa978ee70a8092e$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    Prism.languages.go = Prism.languages.extend('clike', {
        string: {
            pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/,
            lookbehind: true,
            greedy: true
        },
        keyword: /\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/,
        boolean: /\b(?:_|false|iota|nil|true)\b/,
        number: [
            // binary and octal integers
            /\b0(?:b[01_]+|o[0-7_]+)i?\b/i,
            // hexadecimal integers and floats
            /\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
            // decimal integers and floats
            /(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i
        ],
        operator: /[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./,
        builtin: /\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/
    });
    Prism.languages.insertBefore('go', 'string', {
        char: {
            pattern: /'(?:\\.|[^'\\\r\n]){0,10}'/,
            greedy: true
        }
    });
    delete Prism.languages.go['class-name'];
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $12ff858fac87095b$export$2e2bcd8739ae039.displayName = 'ini';
$12ff858fac87095b$export$2e2bcd8739ae039.aliases = [];
function $12ff858fac87095b$export$2e2bcd8739ae039(Prism) {
    Prism.languages.ini = {
        /**
     * The component mimics the behavior of the Win32 API parser.
     *
     * @see {@link https://github.com/PrismJS/prism/issues/2775#issuecomment-787477723}
     */ comment: {
            pattern: /(^[ \f\t\v]*)[#;][^\n\r]*/m,
            lookbehind: true
        },
        section: {
            pattern: /(^[ \f\t\v]*)\[[^\n\r\]]*\]?/m,
            lookbehind: true,
            inside: {
                'section-name': {
                    pattern: /(^\[[ \f\t\v]*)[^ \f\t\v\]]+(?:[ \f\t\v]+[^ \f\t\v\]]+)*/,
                    lookbehind: true,
                    alias: 'selector'
                },
                punctuation: /\[|\]/
            }
        },
        key: {
            pattern: /(^[ \f\t\v]*)[^ \f\n\r\t\v=]+(?:[ \f\t\v]+[^ \f\n\r\t\v=]+)*(?=[ \f\t\v]*=)/m,
            lookbehind: true,
            alias: 'attr-name'
        },
        value: {
            pattern: /(=[ \f\t\v]*)[^ \f\n\r\t\v]+(?:[ \f\t\v]+[^ \f\n\r\t\v]+)*/,
            lookbehind: true,
            alias: 'attr-value',
            inside: {
                'inner-value': {
                    pattern: /^("|').+(?=\1$)/,
                    lookbehind: true
                }
            }
        },
        punctuation: /=/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$68ea9a70b77f88ea$export$2e2bcd8739ae039.displayName = 'java';
$68ea9a70b77f88ea$export$2e2bcd8739ae039.aliases = [];
function $68ea9a70b77f88ea$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    (function(Prism) {
        var keywords = /\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record(?!\s*[(){}[\]<>=%~.:,;?+\-*/&|^])|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/;
        // full package (optional) + parent classes (optional)
        var classNamePrefix = /(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source;
        // based on the java naming conventions
        var className = {
            pattern: RegExp(/(^|[^\w.])/.source + classNamePrefix + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
            lookbehind: true,
            inside: {
                namespace: {
                    pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
                    inside: {
                        punctuation: /\./
                    }
                },
                punctuation: /\./
            }
        };
        Prism.languages.java = Prism.languages.extend('clike', {
            string: {
                pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"/,
                lookbehind: true,
                greedy: true
            },
            'class-name': [
                className,
                {
                    // variables, parameters, and constructor references
                    // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
                    pattern: RegExp(/(^|[^\w.])/.source + classNamePrefix + /[A-Z]\w*(?=\s+\w+\s*[;,=()]|\s*(?:\[[\s,]*\]\s*)?::\s*new\b)/.source),
                    lookbehind: true,
                    inside: className.inside
                },
                {
                    // class names based on keyword
                    // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
                    pattern: RegExp(/(\b(?:class|enum|extends|implements|instanceof|interface|new|record|throws)\s+)/.source + classNamePrefix + /[A-Z]\w*\b/.source),
                    lookbehind: true,
                    inside: className.inside
                }
            ],
            keyword: keywords,
            function: [
                Prism.languages.clike.function,
                {
                    pattern: /(::\s*)[a-z_]\w*/,
                    lookbehind: true
                }
            ],
            number: /\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,
            operator: {
                pattern: /(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m,
                lookbehind: true
            },
            constant: /\b[A-Z][A-Z_\d]+\b/
        });
        Prism.languages.insertBefore('java', 'string', {
            'triple-quoted-string': {
                // http://openjdk.java.net/jeps/355#Description
                pattern: /"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/,
                greedy: true,
                alias: 'string'
            },
            char: {
                pattern: /'(?:\\.|[^'\\\r\n]){1,6}'/,
                greedy: true
            }
        });
        Prism.languages.insertBefore('java', 'class-name', {
            annotation: {
                pattern: /(^|[^.])@\w+(?:\s*\.\s*\w+)*/,
                lookbehind: true,
                alias: 'punctuation'
            },
            generics: {
                pattern: /<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/,
                inside: {
                    'class-name': className,
                    keyword: keywords,
                    punctuation: /[<>(),.:]/,
                    operator: /[?&|]/
                }
            },
            import: [
                {
                    pattern: RegExp(/(\bimport\s+)/.source + classNamePrefix + /(?:[A-Z]\w*|\*)(?=\s*;)/.source),
                    lookbehind: true,
                    inside: {
                        namespace: className.inside.namespace,
                        punctuation: /\./,
                        operator: /\*/,
                        'class-name': /\w+/
                    }
                },
                {
                    pattern: RegExp(/(\bimport\s+static\s+)/.source + classNamePrefix + /(?:\w+|\*)(?=\s*;)/.source),
                    lookbehind: true,
                    alias: 'static',
                    inside: {
                        namespace: className.inside.namespace,
                        static: /\b\w+$/,
                        punctuation: /\./,
                        operator: /\*/,
                        'class-name': /\w+/
                    }
                }
            ],
            namespace: {
                pattern: RegExp(/(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)(?!<keyword>)[a-z]\w*(?:\.[a-z]\w*)*\.?/.source.replace(/<keyword>/g, function() {
                    return keywords.source;
                })),
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            }
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $f19e6959a3616e08$export$2e2bcd8739ae039.displayName = 'regex';
$f19e6959a3616e08$export$2e2bcd8739ae039.aliases = [];
function $f19e6959a3616e08$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var specialEscape = {
            pattern: /\\[\\(){}[\]^$+*?|.]/,
            alias: 'escape'
        };
        var escape = /\\(?:x[\da-fA-F]{2}|u[\da-fA-F]{4}|u\{[\da-fA-F]+\}|0[0-7]{0,2}|[123][0-7]{2}|c[a-zA-Z]|.)/;
        var charSet = {
            pattern: /\.|\\[wsd]|\\p\{[^{}]+\}/i,
            alias: 'class-name'
        };
        var charSetWithoutDot = {
            pattern: /\\[wsd]|\\p\{[^{}]+\}/i,
            alias: 'class-name'
        };
        var rangeChar = '(?:[^\\\\-]|' + escape.source + ')';
        var range = RegExp(rangeChar + '-' + rangeChar);
        // the name of a capturing group
        var groupName = {
            pattern: /(<|')[^<>']+(?=[>']$)/,
            lookbehind: true,
            alias: 'variable'
        };
        Prism.languages.regex = {
            'char-class': {
                pattern: /((?:^|[^\\])(?:\\\\)*)\[(?:[^\\\]]|\\[\s\S])*\]/,
                lookbehind: true,
                inside: {
                    'char-class-negation': {
                        pattern: /(^\[)\^/,
                        lookbehind: true,
                        alias: 'operator'
                    },
                    'char-class-punctuation': {
                        pattern: /^\[|\]$/,
                        alias: 'punctuation'
                    },
                    range: {
                        pattern: range,
                        inside: {
                            escape: escape,
                            'range-punctuation': {
                                pattern: /-/,
                                alias: 'operator'
                            }
                        }
                    },
                    'special-escape': specialEscape,
                    'char-set': charSetWithoutDot,
                    escape: escape
                }
            },
            'special-escape': specialEscape,
            'char-set': charSet,
            backreference: [
                {
                    // a backreference which is not an octal escape
                    pattern: /\\(?![123][0-7]{2})[1-9]/,
                    alias: 'keyword'
                },
                {
                    pattern: /\\k<[^<>']+>/,
                    alias: 'keyword',
                    inside: {
                        'group-name': groupName
                    }
                }
            ],
            anchor: {
                pattern: /[$^]|\\[ABbGZz]/,
                alias: 'function'
            },
            escape: escape,
            group: [
                {
                    // https://docs.oracle.com/javase/10/docs/api/java/util/regex/Pattern.html
                    // https://docs.microsoft.com/en-us/dotnet/standard/base-types/regular-expression-language-quick-reference?view=netframework-4.7.2#grouping-constructs
                    // (), (?<name>), (?'name'), (?>), (?:), (?=), (?!), (?<=), (?<!), (?is-m), (?i-m:)
                    pattern: /\((?:\?(?:<[^<>']+>|'[^<>']+'|[>:]|<?[=!]|[idmnsuxU]+(?:-[idmnsuxU]+)?:?))?/,
                    alias: 'punctuation',
                    inside: {
                        'group-name': groupName
                    }
                },
                {
                    pattern: /\)/,
                    alias: 'punctuation'
                }
            ],
            quantifier: {
                pattern: /(?:[+*?]|\{\d+(?:,\d*)?\})[?+]?/,
                alias: 'number'
            },
            alternation: {
                pattern: /\|/,
                alias: 'keyword'
            }
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$9f5c72e4d4e505c4$export$2e2bcd8739ae039.displayName = 'javascript';
$9f5c72e4d4e505c4$export$2e2bcd8739ae039.aliases = [
    'js'
];
function $9f5c72e4d4e505c4$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    Prism.languages.javascript = Prism.languages.extend('clike', {
        'class-name': [
            Prism.languages.clike['class-name'],
            {
                pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
                lookbehind: true
            }
        ],
        keyword: [
            {
                pattern: /((?:^|\})\s*)catch\b/,
                lookbehind: true
            },
            {
                pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
                lookbehind: true
            }
        ],
        // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
        function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
        number: {
            pattern: RegExp(/(^|[^\w$])/.source + '(?:' + // constant
            (/NaN|Infinity/.source + '|' + // binary integer
            /0[bB][01]+(?:_[01]+)*n?/.source + '|' + // octal integer
            /0[oO][0-7]+(?:_[0-7]+)*n?/.source + '|' + // hexadecimal integer
            /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + '|' + // decimal bigint
            /\d+(?:_\d+)*n/.source + '|' + // decimal number (integer or float) but no bigint
            /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ')' + /(?![\w$])/.source),
            lookbehind: true
        },
        operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
    });
    Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
    Prism.languages.insertBefore('javascript', 'keyword', {
        regex: {
            pattern: RegExp(// lookbehind
            // eslint-disable-next-line regexp/no-dupe-characters-character-class
            /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
            // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
            // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
            // with the only syntax, so we have to define 2 different regex patterns.
            /\//.source + '(?:' + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + '|' + // `v` flag syntax. This supports 3 levels of nested character classes.
            /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ')' + // lookahead
            /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                'regex-source': {
                    pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                    lookbehind: true,
                    alias: 'language-regex',
                    inside: Prism.languages.regex
                },
                'regex-delimiter': /^\/|\/$/,
                'regex-flags': /^[a-z]+$/
            }
        },
        // This must be declared before keyword because we use "function" inside the look-forward
        'function-variable': {
            pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
            alias: 'function'
        },
        parameter: [
            {
                pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            {
                pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            {
                pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            {
                pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
                lookbehind: true,
                inside: Prism.languages.javascript
            }
        ],
        constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
    });
    Prism.languages.insertBefore('javascript', 'string', {
        hashbang: {
            pattern: /^#!.*/,
            greedy: true,
            alias: 'comment'
        },
        'template-string': {
            pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
            greedy: true,
            inside: {
                'template-punctuation': {
                    pattern: /^`|`$/,
                    alias: 'string'
                },
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                    lookbehind: true,
                    inside: {
                        'interpolation-punctuation': {
                            pattern: /^\$\{|\}$/,
                            alias: 'punctuation'
                        },
                        rest: Prism.languages.javascript
                    }
                },
                string: /[\s\S]+/
            }
        },
        'string-property': {
            pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
            lookbehind: true,
            greedy: true,
            alias: 'property'
        }
    });
    Prism.languages.insertBefore('javascript', 'operator', {
        'literal-property': {
            pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
            lookbehind: true,
            alias: 'property'
        }
    });
    if (Prism.languages.markup) {
        Prism.languages.markup.tag.addInlined('script', 'javascript');
        // add attribute support for all DOM events.
        // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
        Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, 'javascript');
    }
    Prism.languages.js = Prism.languages.javascript;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $15d2f325237e0784$export$2e2bcd8739ae039.displayName = 'json';
$15d2f325237e0784$export$2e2bcd8739ae039.aliases = [
    'webmanifest'
];
function $15d2f325237e0784$export$2e2bcd8739ae039(Prism) {
    // https://www.json.org/json-en.html
    Prism.languages.json = {
        property: {
            pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
            lookbehind: true,
            greedy: true
        },
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
            greedy: true
        },
        number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
        punctuation: /[{}[\],]/,
        operator: /:/,
        boolean: /\b(?:false|true)\b/,
        null: {
            pattern: /\bnull\b/,
            alias: 'keyword'
        }
    };
    Prism.languages.webmanifest = Prism.languages.json;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$354a467a21a053bd$export$2e2bcd8739ae039.displayName = 'kotlin';
$354a467a21a053bd$export$2e2bcd8739ae039.aliases = [
    'kt',
    'kts'
];
function $354a467a21a053bd$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.kotlin = Prism.languages.extend('clike', {
            keyword: {
                // The lookbehind prevents wrong highlighting of e.g. kotlin.properties.get
                pattern: /(^|[^.])\b(?:abstract|actual|annotation|as|break|by|catch|class|companion|const|constructor|continue|crossinline|data|do|dynamic|else|enum|expect|external|final|finally|for|fun|get|if|import|in|infix|init|inline|inner|interface|internal|is|lateinit|noinline|null|object|open|operator|out|override|package|private|protected|public|reified|return|sealed|set|super|suspend|tailrec|this|throw|to|try|typealias|val|var|vararg|when|where|while)\b/,
                lookbehind: true
            },
            function: [
                {
                    pattern: /(?:`[^\r\n`]+`|\b\w+)(?=\s*\()/,
                    greedy: true
                },
                {
                    pattern: /(\.)(?:`[^\r\n`]+`|\w+)(?=\s*\{)/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            number: /\b(?:0[xX][\da-fA-F]+(?:_[\da-fA-F]+)*|0[bB][01]+(?:_[01]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?[fFL]?)\b/,
            operator: /\+[+=]?|-[-=>]?|==?=?|!(?:!|==?)?|[\/*%<>]=?|[?:]:?|\.\.|&&|\|\||\b(?:and|inv|or|shl|shr|ushr|xor)\b/
        });
        delete Prism.languages.kotlin['class-name'];
        var interpolationInside = {
            'interpolation-punctuation': {
                pattern: /^\$\{?|\}$/,
                alias: 'punctuation'
            },
            expression: {
                pattern: /[\s\S]+/,
                inside: Prism.languages.kotlin
            }
        };
        Prism.languages.insertBefore('kotlin', 'string', {
            // https://kotlinlang.org/spec/expressions.html#string-interpolation-expressions
            'string-literal': [
                {
                    pattern: /"""(?:[^$]|\$(?:(?!\{)|\{[^{}]*\}))*?"""/,
                    alias: 'multiline',
                    inside: {
                        interpolation: {
                            pattern: /\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                            inside: interpolationInside
                        },
                        string: /[\s\S]+/
                    }
                },
                {
                    pattern: /"(?:[^"\\\r\n$]|\\.|\$(?:(?!\{)|\{[^{}]*\}))*"/,
                    alias: 'singleline',
                    inside: {
                        interpolation: {
                            pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                            lookbehind: true,
                            inside: interpolationInside
                        },
                        string: /[\s\S]+/
                    }
                }
            ],
            char: {
                // https://kotlinlang.org/spec/expressions.html#character-literals
                pattern: /'(?:[^'\\\r\n]|\\(?:.|u[a-fA-F0-9]{0,4}))'/,
                greedy: true
            }
        });
        delete Prism.languages.kotlin['string'];
        Prism.languages.insertBefore('kotlin', 'keyword', {
            annotation: {
                pattern: /\B@(?:\w+:)?(?:[A-Z]\w*|\[[^\]]+\])/,
                alias: 'builtin'
            }
        });
        Prism.languages.insertBefore('kotlin', 'function', {
            label: {
                pattern: /\b\w+@|@\w+\b/,
                alias: 'symbol'
            }
        });
        Prism.languages.kt = Prism.languages.kotlin;
        Prism.languages.kts = Prism.languages.kotlin;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$5b589dc50921a1c0$export$2e2bcd8739ae039.displayName = 'less';
$5b589dc50921a1c0$export$2e2bcd8739ae039.aliases = [];
function $5b589dc50921a1c0$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $c8ae87468323f6e6$export$2e2bcd8739ae039));
    /* FIXME :
:extend() is not handled specifically : its highlighting is buggy.
Mixin usage must be inside a ruleset to be highlighted.
At-rules (e.g. import) containing interpolations are buggy.
Detached rulesets are highlighted as at-rules.
A comment before a mixin usage prevents the latter to be properly highlighted.
*/ Prism.languages.less = Prism.languages.extend('css', {
        comment: [
            /\/\*[\s\S]*?\*\//,
            {
                pattern: /(^|[^\\])\/\/.*/,
                lookbehind: true
            }
        ],
        atrule: {
            pattern: /@[\w-](?:\((?:[^(){}]|\([^(){}]*\))*\)|[^(){};\s]|\s+(?!\s))*?(?=\s*\{)/,
            inside: {
                punctuation: /[:()]/
            }
        },
        // selectors and mixins are considered the same
        selector: {
            pattern: /(?:@\{[\w-]+\}|[^{};\s@])(?:@\{[\w-]+\}|\((?:[^(){}]|\([^(){}]*\))*\)|[^(){};@\s]|\s+(?!\s))*?(?=\s*\{)/,
            inside: {
                // mixin parameters
                variable: /@+[\w-]+/
            }
        },
        property: /(?:@\{[\w-]+\}|[\w-])+(?:\+_?)?(?=\s*:)/,
        operator: /[+\-*\/]/
    });
    Prism.languages.insertBefore('less', 'property', {
        variable: [
            // Variable declaration (the colon must be consumed!)
            {
                pattern: /@[\w-]+\s*:/,
                inside: {
                    punctuation: /:/
                }
            },
            // Variable usage
            /@@?[\w-]+/
        ],
        'mixin-usage': {
            pattern: /([{;]\s*)[.#](?!\d)[\w-].*?(?=[(;])/,
            lookbehind: true,
            alias: 'function'
        }
    });
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $3350a7c50307d503$export$2e2bcd8739ae039.displayName = 'lua';
$3350a7c50307d503$export$2e2bcd8739ae039.aliases = [];
function $3350a7c50307d503$export$2e2bcd8739ae039(Prism) {
    Prism.languages.lua = {
        comment: /^#!.+|--(?:\[(=*)\[[\s\S]*?\]\1\]|.*)/m,
        // \z may be used to skip the following space
        string: {
            pattern: /(["'])(?:(?!\1)[^\\\r\n]|\\z(?:\r\n|\s)|\\(?:\r\n|[^z]))*\1|\[(=*)\[[\s\S]*?\]\2\]/,
            greedy: true
        },
        number: /\b0x[a-f\d]+(?:\.[a-f\d]*)?(?:p[+-]?\d+)?\b|\b\d+(?:\.\B|(?:\.\d*)?(?:e[+-]?\d+)?\b)|\B\.\d+(?:e[+-]?\d+)?\b/i,
        keyword: /\b(?:and|break|do|else|elseif|end|false|for|function|goto|if|in|local|nil|not|or|repeat|return|then|true|until|while)\b/,
        function: /(?!\d)\w+(?=\s*(?:[({]))/,
        operator: [
            /[-+*%^&|#]|\/\/?|<[<=]?|>[>=]?|[=~]=?/,
            {
                // Match ".." but don't break "..."
                pattern: /(^|[^.])\.\.(?!\.)/,
                lookbehind: true
            }
        ],
        punctuation: /[\[\](){},;]|\.+|:+/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $d5e8803a0ecb1a4c$export$2e2bcd8739ae039.displayName = 'makefile';
$d5e8803a0ecb1a4c$export$2e2bcd8739ae039.aliases = [];
function $d5e8803a0ecb1a4c$export$2e2bcd8739ae039(Prism) {
    Prism.languages.makefile = {
        comment: {
            pattern: /(^|[^\\])#(?:\\(?:\r\n|[\s\S])|[^\\\r\n])*/,
            lookbehind: true
        },
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        'builtin-target': {
            pattern: /\.[A-Z][^:#=\s]+(?=\s*:(?!=))/,
            alias: 'builtin'
        },
        target: {
            pattern: /^(?:[^:=\s]|[ \t]+(?![\s:]))+(?=\s*:(?!=))/m,
            alias: 'symbol',
            inside: {
                variable: /\$+(?:(?!\$)[^(){}:#=\s]+|(?=[({]))/
            }
        },
        variable: /\$+(?:(?!\$)[^(){}:#=\s]+|\([@*%<^+?][DF]\)|(?=[({]))/,
        // Directives
        keyword: /-include\b|\b(?:define|else|endef|endif|export|ifn?def|ifn?eq|include|override|private|sinclude|undefine|unexport|vpath)\b/,
        function: {
            pattern: /(\()(?:abspath|addsuffix|and|basename|call|dir|error|eval|file|filter(?:-out)?|findstring|firstword|flavor|foreach|guile|if|info|join|lastword|load|notdir|or|origin|patsubst|realpath|shell|sort|strip|subst|suffix|value|warning|wildcard|word(?:list|s)?)(?=[ \t])/,
            lookbehind: true
        },
        operator: /(?:::|[?:+!])?=|[|@]/,
        punctuation: /[:;(){}]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $d56cfd3d329eea2c$export$2e2bcd8739ae039.displayName = 'yaml';
$d56cfd3d329eea2c$export$2e2bcd8739ae039.aliases = [
    'yml'
];
function $d56cfd3d329eea2c$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // https://yaml.org/spec/1.2/spec.html#c-ns-anchor-property
        // https://yaml.org/spec/1.2/spec.html#c-ns-alias-node
        var anchorOrAlias = /[*&][^\s[\]{},]+/;
        // https://yaml.org/spec/1.2/spec.html#c-ns-tag-property
        var tag = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/;
        // https://yaml.org/spec/1.2/spec.html#c-ns-properties(n,c)
        var properties = '(?:' + tag.source + '(?:[ \t]+' + anchorOrAlias.source + ')?|' + anchorOrAlias.source + '(?:[ \t]+' + tag.source + ')?)';
        // https://yaml.org/spec/1.2/spec.html#ns-plain(n,c)
        // This is a simplified version that doesn't support "#" and multiline keys
        // All these long scarry character classes are simplified versions of YAML's characters
        var plainKey = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.source.replace(/<PLAIN>/g, function() {
            return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
        });
        var string = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;
        /**
     *
     * @param {string} value
     * @param {string} [flags]
     * @returns {RegExp}
     */ function createValuePattern(value, flags) {
            flags = (flags || '').replace(/m/g, '') + 'm' // add m flag
            ;
            var pattern = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function() {
                return properties;
            }).replace(/<<value>>/g, function() {
                return value;
            });
            return RegExp(pattern, flags);
        }
        Prism.languages.yaml = {
            scalar: {
                pattern: RegExp(/([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(/<<prop>>/g, function() {
                    return properties;
                })),
                lookbehind: true,
                alias: 'string'
            },
            comment: /#.*/,
            key: {
                pattern: RegExp(/((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function() {
                    return properties;
                }).replace(/<<key>>/g, function() {
                    return '(?:' + plainKey + '|' + string + ')';
                })),
                lookbehind: true,
                greedy: true,
                alias: 'atrule'
            },
            directive: {
                pattern: /(^[ \t]*)%.+/m,
                lookbehind: true,
                alias: 'important'
            },
            datetime: {
                pattern: createValuePattern(/\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.source),
                lookbehind: true,
                alias: 'number'
            },
            boolean: {
                pattern: createValuePattern(/false|true/.source, 'i'),
                lookbehind: true,
                alias: 'important'
            },
            null: {
                pattern: createValuePattern(/null|~/.source, 'i'),
                lookbehind: true,
                alias: 'important'
            },
            string: {
                pattern: createValuePattern(string),
                lookbehind: true,
                greedy: true
            },
            number: {
                pattern: createValuePattern(/[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source, 'i'),
                lookbehind: true
            },
            tag: tag,
            important: anchorOrAlias,
            punctuation: /---|[:[\]{}\-,|>?]|\.\.\./
        };
        Prism.languages.yml = Prism.languages.yaml;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$99679268fa665931$export$2e2bcd8739ae039.displayName = 'markdown';
$99679268fa665931$export$2e2bcd8739ae039.aliases = [
    'md'
];
function $99679268fa665931$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $8fbeea7c20d72e06$export$2e2bcd8739ae039));
    (function(Prism) {
        // Allow only one line break
        var inner = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
        /**
     * This function is intended for the creation of the bold or italic pattern.
     *
     * This also adds a lookbehind group to the given pattern to ensure that the pattern is not backslash-escaped.
     *
     * _Note:_ Keep in mind that this adds a capturing group.
     *
     * @param {string} pattern
     * @returns {RegExp}
     */ function createInline(pattern) {
            pattern = pattern.replace(/<inner>/g, function() {
                return inner;
            });
            return RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + '(?:' + pattern + ')');
        }
        var tableCell = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source;
        var tableRow = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function() {
            return tableCell;
        });
        var tableLine = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;
        Prism.languages.markdown = Prism.languages.extend('markup', {});
        Prism.languages.insertBefore('markdown', 'prolog', {
            'front-matter-block': {
                pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
                lookbehind: true,
                greedy: true,
                inside: {
                    punctuation: /^---|---$/,
                    'front-matter': {
                        pattern: /\S+(?:\s+\S+)*/,
                        alias: [
                            'yaml',
                            'language-yaml'
                        ],
                        inside: Prism.languages.yaml
                    }
                }
            },
            blockquote: {
                // > ...
                pattern: /^>(?:[\t ]*>)*/m,
                alias: 'punctuation'
            },
            table: {
                pattern: RegExp('^' + tableRow + tableLine + '(?:' + tableRow + ')*', 'm'),
                inside: {
                    'table-data-rows': {
                        pattern: RegExp('^(' + tableRow + tableLine + ')(?:' + tableRow + ')*$'),
                        lookbehind: true,
                        inside: {
                            'table-data': {
                                pattern: RegExp(tableCell),
                                inside: Prism.languages.markdown
                            },
                            punctuation: /\|/
                        }
                    },
                    'table-line': {
                        pattern: RegExp('^(' + tableRow + ')' + tableLine + '$'),
                        lookbehind: true,
                        inside: {
                            punctuation: /\||:?-{3,}:?/
                        }
                    },
                    'table-header-row': {
                        pattern: RegExp('^' + tableRow + '$'),
                        inside: {
                            'table-header': {
                                pattern: RegExp(tableCell),
                                alias: 'important',
                                inside: Prism.languages.markdown
                            },
                            punctuation: /\|/
                        }
                    }
                }
            },
            code: [
                {
                    // Prefixed by 4 spaces or 1 tab and preceded by an empty line
                    pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
                    lookbehind: true,
                    alias: 'keyword'
                },
                {
                    // ```optional language
                    // code block
                    // ```
                    pattern: /^```[\s\S]*?^```$/m,
                    greedy: true,
                    inside: {
                        'code-block': {
                            pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
                            lookbehind: true
                        },
                        'code-language': {
                            pattern: /^(```).+/,
                            lookbehind: true
                        },
                        punctuation: /```/
                    }
                }
            ],
            title: [
                {
                    // title 1
                    // =======
                    // title 2
                    // -------
                    pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
                    alias: 'important',
                    inside: {
                        punctuation: /==+$|--+$/
                    }
                },
                {
                    // # title 1
                    // ###### title 6
                    pattern: /(^\s*)#.+/m,
                    lookbehind: true,
                    alias: 'important',
                    inside: {
                        punctuation: /^#+|#+$/
                    }
                }
            ],
            hr: {
                // ***
                // ---
                // * * *
                // -----------
                pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
                lookbehind: true,
                alias: 'punctuation'
            },
            list: {
                // * item
                // + item
                // - item
                // 1. item
                pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
                lookbehind: true,
                alias: 'punctuation'
            },
            'url-reference': {
                // [id]: http://example.com "Optional title"
                // [id]: http://example.com 'Optional title'
                // [id]: http://example.com (Optional title)
                // [id]: <http://example.com> "Optional title"
                pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
                inside: {
                    variable: {
                        pattern: /^(!?\[)[^\]]+/,
                        lookbehind: true
                    },
                    string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
                    punctuation: /^[\[\]!:]|[<>]/
                },
                alias: 'url'
            },
            bold: {
                // **strong**
                // __strong__
                // allow one nested instance of italic text using the same delimiter
                pattern: createInline(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    content: {
                        pattern: /(^..)[\s\S]+(?=..$)/,
                        lookbehind: true,
                        inside: {} // see below
                    },
                    punctuation: /\*\*|__/
                }
            },
            italic: {
                // *em*
                // _em_
                // allow one nested instance of bold text using the same delimiter
                pattern: createInline(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    content: {
                        pattern: /(^.)[\s\S]+(?=.$)/,
                        lookbehind: true,
                        inside: {} // see below
                    },
                    punctuation: /[*_]/
                }
            },
            strike: {
                // ~~strike through~~
                // ~strike~
                // eslint-disable-next-line regexp/strict
                pattern: createInline(/(~~?)(?:(?!~)<inner>)+\2/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    content: {
                        pattern: /(^~~?)[\s\S]+(?=\1$)/,
                        lookbehind: true,
                        inside: {} // see below
                    },
                    punctuation: /~~?/
                }
            },
            'code-snippet': {
                // `code`
                // ``code``
                pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
                lookbehind: true,
                greedy: true,
                alias: [
                    'code',
                    'keyword'
                ]
            },
            url: {
                // [example](http://example.com "Optional title")
                // [example][id]
                // [example] [id]
                pattern: createInline(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    operator: /^!/,
                    content: {
                        pattern: /(^\[)[^\]]+(?=\])/,
                        lookbehind: true,
                        inside: {} // see below
                    },
                    variable: {
                        pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
                        lookbehind: true
                    },
                    url: {
                        pattern: /(^\]\()[^\s)]+/,
                        lookbehind: true
                    },
                    string: {
                        pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
                        lookbehind: true
                    }
                }
            }
        });
        [
            'url',
            'bold',
            'italic',
            'strike'
        ].forEach(function(token) {
            [
                'url',
                'bold',
                'italic',
                'strike',
                'code-snippet'
            ].forEach(function(inside) {
                if (token !== inside) Prism.languages.markdown[token].inside.content.inside[inside] = Prism.languages.markdown[inside];
            });
        });
        Prism.hooks.add('after-tokenize', function(env) {
            if (env.language !== 'markdown' && env.language !== 'md') return;
            function walkTokens(tokens) {
                if (!tokens || typeof tokens === 'string') return;
                for(var i = 0, l = tokens.length; i < l; i++){
                    var token = tokens[i];
                    if (token.type !== 'code') {
                        walkTokens(token.content);
                        continue;
                    }
                    /*
           * Add the correct `language-xxxx` class to this code block. Keep in mind that the `code-language` token
           * is optional. But the grammar is defined so that there is only one case we have to handle:
           *
           * token.content = [
           *     <span class="punctuation">```</span>,
           *     <span class="code-language">xxxx</span>,
           *     '\n', // exactly one new lines (\r or \n or \r\n)
           *     <span class="code-block">...</span>,
           *     '\n', // exactly one new lines again
           *     <span class="punctuation">```</span>
           * ];
           */ var codeLang = token.content[1];
                    var codeBlock = token.content[3];
                    if (codeLang && codeBlock && codeLang.type === 'code-language' && codeBlock.type === 'code-block' && typeof codeLang.content === 'string') {
                        // this might be a language that Prism does not support
                        // do some replacements to support C++, C#, and F#
                        var lang = codeLang.content.replace(/\b#/g, 'sharp').replace(/\b\+\+/g, 'pp');
                        // only use the first word
                        lang = (/[a-z][\w-]*/i.exec(lang) || [
                            ''
                        ])[0].toLowerCase();
                        var alias = 'language-' + lang;
                        // add alias
                        if (!codeBlock.alias) codeBlock.alias = [
                            alias
                        ];
                        else if (typeof codeBlock.alias === 'string') codeBlock.alias = [
                            codeBlock.alias,
                            alias
                        ];
                        else codeBlock.alias.push(alias);
                    }
                }
            }
            walkTokens(env.tokens);
        });
        Prism.hooks.add('wrap', function(env) {
            if (env.type !== 'code-block') return;
            var codeLang = '';
            for(var i = 0, l = env.classes.length; i < l; i++){
                var cls = env.classes[i];
                var match = /language-(.+)/.exec(cls);
                if (match) {
                    codeLang = match[1];
                    break;
                }
            }
            var grammar = Prism.languages[codeLang];
            if (!grammar) {
                if (codeLang && codeLang !== 'none' && Prism.plugins.autoloader) {
                    var id = 'md-' + new Date().valueOf() + '-' + Math.floor(Math.random() * 1e16);
                    env.attributes['id'] = id;
                    Prism.plugins.autoloader.loadLanguages(codeLang, function() {
                        var ele = document.getElementById(id);
                        if (ele) ele.innerHTML = Prism.highlight(ele.textContent, Prism.languages[codeLang], codeLang);
                    });
                }
            } else env.content = Prism.highlight(env.content.value, grammar, codeLang);
        });
        var tagPattern = RegExp(Prism.languages.markup.tag.pattern.source, 'gi');
        /**
     * A list of known entity names.
     *
     * This will always be incomplete to save space. The current list is the one used by lowdash's unescape function.
     *
     * @see {@link https://github.com/lodash/lodash/blob/2da024c3b4f9947a48517639de7560457cd4ec6c/unescape.js#L2}
     */ var KNOWN_ENTITY_NAMES = {
            amp: '&',
            lt: '<',
            gt: '>',
            quot: '"'
        };
        // IE 11 doesn't support `String.fromCodePoint`
        var fromCodePoint = String.fromCodePoint || String.fromCharCode;
        /**
     * Returns the text content of a given HTML source code string.
     *
     * @param {string} html
     * @returns {string}
     */ function textContent(html) {
            // remove all tags
            var text = html.replace(tagPattern, '');
            // decode known entities
            text = text.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(m, code) {
                code = code.toLowerCase();
                if (code[0] === '#') {
                    var value;
                    if (code[1] === 'x') value = parseInt(code.slice(2), 16);
                    else value = Number(code.slice(1));
                    return fromCodePoint(value);
                } else {
                    var known = KNOWN_ENTITY_NAMES[code];
                    if (known) return known;
                    // unable to decode
                    return m;
                }
            });
            return text;
        }
        Prism.languages.md = Prism.languages.markdown;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$659db1e49ba3c889$export$2e2bcd8739ae039.displayName = 'objectivec';
$659db1e49ba3c889$export$2e2bcd8739ae039.aliases = [
    'objc'
];
function $659db1e49ba3c889$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $e064275ae5958777$export$2e2bcd8739ae039));
    Prism.languages.objectivec = Prism.languages.extend('c', {
        string: {
            pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
            greedy: true
        },
        keyword: /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
        operator: /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
    });
    delete Prism.languages.objectivec['class-name'];
    Prism.languages.objc = Prism.languages.objectivec;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $f6aa5d7625509f98$export$2e2bcd8739ae039.displayName = 'perl';
$f6aa5d7625509f98$export$2e2bcd8739ae039.aliases = [];
function $f6aa5d7625509f98$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var brackets = /(?:\((?:[^()\\]|\\[\s\S])*\)|\{(?:[^{}\\]|\\[\s\S])*\}|\[(?:[^[\]\\]|\\[\s\S])*\]|<(?:[^<>\\]|\\[\s\S])*>)/.source;
        Prism.languages.perl = {
            comment: [
                {
                    // POD
                    pattern: /(^\s*)=\w[\s\S]*?=cut.*/m,
                    lookbehind: true,
                    greedy: true
                },
                {
                    pattern: /(^|[^\\$])#.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            // TODO Could be nice to handle Heredoc too.
            string: [
                {
                    pattern: RegExp(/\b(?:q|qq|qw|qx)(?![a-zA-Z0-9])\s*/.source + '(?:' + [
                        // q/.../
                        /([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
                        // q a...a
                        // eslint-disable-next-line regexp/strict
                        /([a-zA-Z0-9])(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                        // q(...)
                        // q{...}
                        // q[...]
                        // q<...>
                        brackets
                    ].join('|') + ')'),
                    greedy: true
                },
                // "...", `...`
                {
                    pattern: /("|`)(?:(?!\1)[^\\]|\\[\s\S])*\1/,
                    greedy: true
                },
                // '...'
                // FIXME Multi-line single-quoted strings are not supported as they would break variables containing '
                {
                    pattern: /'(?:[^'\\\r\n]|\\.)*'/,
                    greedy: true
                }
            ],
            regex: [
                {
                    pattern: RegExp(/\b(?:m|qr)(?![a-zA-Z0-9])\s*/.source + '(?:' + [
                        // m/.../
                        /([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
                        // m a...a
                        // eslint-disable-next-line regexp/strict
                        /([a-zA-Z0-9])(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                        // m(...)
                        // m{...}
                        // m[...]
                        // m<...>
                        brackets
                    ].join('|') + ')' + /[msixpodualngc]*/.source),
                    greedy: true
                },
                // The lookbehinds prevent -s from breaking
                {
                    pattern: RegExp(/(^|[^-])\b(?:s|tr|y)(?![a-zA-Z0-9])\s*/.source + '(?:' + [
                        // s/.../.../
                        // eslint-disable-next-line regexp/strict
                        /([^a-zA-Z0-9\s{(\[<])(?:(?!\2)[^\\]|\\[\s\S])*\2(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                        // s a...a...a
                        // eslint-disable-next-line regexp/strict
                        /([a-zA-Z0-9])(?:(?!\3)[^\\]|\\[\s\S])*\3(?:(?!\3)[^\\]|\\[\s\S])*\3/.source,
                        // s(...)(...)
                        // s{...}{...}
                        // s[...][...]
                        // s<...><...>
                        // s(...)[...]
                        brackets + /\s*/.source + brackets
                    ].join('|') + ')' + /[msixpodualngcer]*/.source),
                    lookbehind: true,
                    greedy: true
                },
                // /.../
                // The look-ahead tries to prevent two divisions on
                // the same line from being highlighted as regex.
                // This does not support multi-line regex.
                {
                    pattern: /\/(?:[^\/\\\r\n]|\\.)*\/[msixpodualngc]*(?=\s*(?:$|[\r\n,.;})&|\-+*~<>!?^]|(?:and|cmp|eq|ge|gt|le|lt|ne|not|or|x|xor)\b))/,
                    greedy: true
                }
            ],
            // FIXME Not sure about the handling of ::, ', and #
            variable: [
                // ${^POSTMATCH}
                /[&*$@%]\{\^[A-Z]+\}/,
                // $^V
                /[&*$@%]\^[A-Z_]/,
                // ${...}
                /[&*$@%]#?(?=\{)/,
                // $foo
                /[&*$@%]#?(?:(?:::)*'?(?!\d)[\w$]+(?![\w$]))+(?:::)*/,
                // $1
                /[&*$@%]\d+/,
                // $_, @_, %!
                // The negative lookahead prevents from breaking the %= operator
                /(?!%=)[$@%][!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~]/
            ],
            filehandle: {
                // <>, <FOO>, _
                pattern: /<(?![<=])\S*?>|\b_\b/,
                alias: 'symbol'
            },
            'v-string': {
                // v1.2, 1.2.3
                pattern: /v\d+(?:\.\d+)*|\d+(?:\.\d+){2,}/,
                alias: 'string'
            },
            function: {
                pattern: /(\bsub[ \t]+)\w+/,
                lookbehind: true
            },
            keyword: /\b(?:any|break|continue|default|delete|die|do|else|elsif|eval|for|foreach|given|goto|if|last|local|my|next|our|package|print|redo|require|return|say|state|sub|switch|undef|unless|until|use|when|while)\b/,
            number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)\b/,
            operator: /-[rwxoRWXOezsfdlpSbctugkTBMAC]\b|\+[+=]?|-[-=>]?|\*\*?=?|\/\/?=?|=[=~>]?|~[~=]?|\|\|?=?|&&?=?|<(?:=>?|<=?)?|>>?=?|![~=]?|[%^]=?|\.(?:=|\.\.?)?|[\\?]|\bx(?:=|\b)|\b(?:and|cmp|eq|ge|gt|le|lt|ne|not|or|xor)\b/,
            punctuation: /[{}[\];(),:]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$a400735491c1aa4e$export$2e2bcd8739ae039.displayName = 'markup-templating';
$a400735491c1aa4e$export$2e2bcd8739ae039.aliases = [];
function $a400735491c1aa4e$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $8fbeea7c20d72e06$export$2e2bcd8739ae039));
    (function(Prism) {
        /**
     * Returns the placeholder for the given language id and index.
     *
     * @param {string} language
     * @param {string|number} index
     * @returns {string}
     */ function getPlaceholder(language, index) {
            return '___' + language.toUpperCase() + index + '___';
        }
        Object.defineProperties(Prism.languages['markup-templating'] = {}, {
            buildPlaceholders: {
                /**
         * Tokenize all inline templating expressions matching `placeholderPattern`.
         *
         * If `replaceFilter` is provided, only matches of `placeholderPattern` for which `replaceFilter` returns
         * `true` will be replaced.
         *
         * @param {object} env The environment of the `before-tokenize` hook.
         * @param {string} language The language id.
         * @param {RegExp} placeholderPattern The matches of this pattern will be replaced by placeholders.
         * @param {(match: string) => boolean} [replaceFilter]
         */ value: function(env, language, placeholderPattern, replaceFilter) {
                    if (env.language !== language) return;
                    var tokenStack = env.tokenStack = [];
                    env.code = env.code.replace(placeholderPattern, function(match) {
                        if (typeof replaceFilter === 'function' && !replaceFilter(match)) return match;
                        var i = tokenStack.length;
                        var placeholder;
                        // Check for existing strings
                        while(env.code.indexOf(placeholder = getPlaceholder(language, i)) !== -1)++i;
                        // Create a sparse array
                        tokenStack[i] = match;
                        return placeholder;
                    });
                    // Switch the grammar to markup
                    env.grammar = Prism.languages.markup;
                }
            },
            tokenizePlaceholders: {
                /**
         * Replace placeholders with proper tokens after tokenizing.
         *
         * @param {object} env The environment of the `after-tokenize` hook.
         * @param {string} language The language id.
         */ value: function(env, language) {
                    if (env.language !== language || !env.tokenStack) return;
                    // Switch the grammar back
                    env.grammar = Prism.languages[language];
                    var j = 0;
                    var keys = Object.keys(env.tokenStack);
                    function walkTokens(tokens) {
                        for(var i = 0; i < tokens.length; i++){
                            // all placeholders are replaced already
                            if (j >= keys.length) break;
                            var token = tokens[i];
                            if (typeof token === 'string' || token.content && typeof token.content === 'string') {
                                var k = keys[j];
                                var t = env.tokenStack[k];
                                var s = typeof token === 'string' ? token : token.content;
                                var placeholder = getPlaceholder(language, k);
                                var index = s.indexOf(placeholder);
                                if (index > -1) {
                                    ++j;
                                    var before = s.substring(0, index);
                                    var middle = new Prism.Token(language, Prism.tokenize(t, env.grammar), 'language-' + language, t);
                                    var after = s.substring(index + placeholder.length);
                                    var replacement = [];
                                    if (before) replacement.push.apply(replacement, walkTokens([
                                        before
                                    ]));
                                    replacement.push(middle);
                                    if (after) replacement.push.apply(replacement, walkTokens([
                                        after
                                    ]));
                                    if (typeof token === 'string') tokens.splice.apply(tokens, [
                                        i,
                                        1
                                    ].concat(replacement));
                                    else token.content = replacement;
                                }
                            } else if (token.content /* && typeof token.content !== 'string' */ ) walkTokens(token.content);
                        }
                        return tokens;
                    }
                    walkTokens(env.tokens);
                }
            }
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$158311e91e281aed$export$2e2bcd8739ae039.displayName = 'php';
$158311e91e281aed$export$2e2bcd8739ae039.aliases = [];
function $158311e91e281aed$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $a400735491c1aa4e$export$2e2bcd8739ae039));
    (function(Prism) {
        var comment = /\/\*[\s\S]*?\*\/|\/\/.*|#(?!\[).*/;
        var constant = [
            {
                pattern: /\b(?:false|true)\b/i,
                alias: 'boolean'
            },
            {
                pattern: /(::\s*)\b[a-z_]\w*\b(?!\s*\()/i,
                greedy: true,
                lookbehind: true
            },
            {
                pattern: /(\b(?:case|const)\s+)\b[a-z_]\w*(?=\s*[;=])/i,
                greedy: true,
                lookbehind: true
            },
            /\b(?:null)\b/i,
            /\b[A-Z_][A-Z0-9_]*\b(?!\s*\()/
        ];
        var number = /\b0b[01]+(?:_[01]+)*\b|\b0o[0-7]+(?:_[0-7]+)*\b|\b0x[\da-f]+(?:_[\da-f]+)*\b|(?:\b\d+(?:_\d+)*\.?(?:\d+(?:_\d+)*)?|\B\.\d+)(?:e[+-]?\d+)?/i;
        var operator = /<?=>|\?\?=?|\.{3}|\??->|[!=]=?=?|::|\*\*=?|--|\+\+|&&|\|\||<<|>>|[?~]|[/^|%*&<>.+-]=?/;
        var punctuation = /[{}\[\](),:;]/;
        Prism.languages.php = {
            delimiter: {
                pattern: /\?>$|^<\?(?:php(?=\s)|=)?/i,
                alias: 'important'
            },
            comment: comment,
            variable: /\$+(?:\w+\b|(?=\{))/,
            package: {
                pattern: /(namespace\s+|use\s+(?:function\s+)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
                lookbehind: true,
                inside: {
                    punctuation: /\\/
                }
            },
            'class-name-definition': {
                pattern: /(\b(?:class|enum|interface|trait)\s+)\b[a-z_]\w*(?!\\)\b/i,
                lookbehind: true,
                alias: 'class-name'
            },
            'function-definition': {
                pattern: /(\bfunction\s+)[a-z_]\w*(?=\s*\()/i,
                lookbehind: true,
                alias: 'function'
            },
            keyword: [
                {
                    pattern: /(\(\s*)\b(?:array|bool|boolean|float|int|integer|object|string)\b(?=\s*\))/i,
                    alias: 'type-casting',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /([(,?]\s*)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|object|self|static|string)\b(?=\s*\$)/i,
                    alias: 'type-hint',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /(\)\s*:\s*(?:\?\s*)?)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|never|object|self|static|string|void)\b/i,
                    alias: 'return-type',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /\b(?:array(?!\s*\()|bool|float|int|iterable|mixed|object|string|void)\b/i,
                    alias: 'type-declaration',
                    greedy: true
                },
                {
                    pattern: /(\|\s*)(?:false|null)\b|\b(?:false|null)(?=\s*\|)/i,
                    alias: 'type-declaration',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /\b(?:parent|self|static)(?=\s*::)/i,
                    alias: 'static-context',
                    greedy: true
                },
                {
                    // yield from
                    pattern: /(\byield\s+)from\b/i,
                    lookbehind: true
                },
                // `class` is always a keyword unlike other keywords
                /\bclass\b/i,
                {
                    // https://www.php.net/manual/en/reserved.keywords.php
                    //
                    // keywords cannot be preceded by "->"
                    // the complex lookbehind means `(?<!(?:->|::)\s*)`
                    pattern: /((?:^|[^\s>:]|(?:^|[^-])>|(?:^|[^:]):)\s*)\b(?:abstract|and|array|as|break|callable|case|catch|clone|const|continue|declare|default|die|do|echo|else|elseif|empty|enddeclare|endfor|endforeach|endif|endswitch|endwhile|enum|eval|exit|extends|final|finally|fn|for|foreach|function|global|goto|if|implements|include|include_once|instanceof|insteadof|interface|isset|list|match|namespace|never|new|or|parent|print|private|protected|public|readonly|require|require_once|return|self|static|switch|throw|trait|try|unset|use|var|while|xor|yield|__halt_compiler)\b/i,
                    lookbehind: true
                }
            ],
            'argument-name': {
                pattern: /([(,]\s*)\b[a-z_]\w*(?=\s*:(?!:))/i,
                lookbehind: true
            },
            'class-name': [
                {
                    pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self|\s+static))\s+|\bcatch\s*\()\b[a-z_]\w*(?!\\)\b/i,
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /(\|\s*)\b[a-z_]\w*(?!\\)\b/i,
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /\b[a-z_]\w*(?!\\)\b(?=\s*\|)/i,
                    greedy: true
                },
                {
                    pattern: /(\|\s*)(?:\\?\b[a-z_]\w*)+\b/i,
                    alias: 'class-name-fully-qualified',
                    greedy: true,
                    lookbehind: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /(?:\\?\b[a-z_]\w*)+\b(?=\s*\|)/i,
                    alias: 'class-name-fully-qualified',
                    greedy: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self\b|\s+static\b))\s+|\bcatch\s*\()(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
                    alias: 'class-name-fully-qualified',
                    greedy: true,
                    lookbehind: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /\b[a-z_]\w*(?=\s*\$)/i,
                    alias: 'type-declaration',
                    greedy: true
                },
                {
                    pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,
                    alias: [
                        'class-name-fully-qualified',
                        'type-declaration'
                    ],
                    greedy: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /\b[a-z_]\w*(?=\s*::)/i,
                    alias: 'static-context',
                    greedy: true
                },
                {
                    pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*::)/i,
                    alias: [
                        'class-name-fully-qualified',
                        'static-context'
                    ],
                    greedy: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /([(,?]\s*)[a-z_]\w*(?=\s*\$)/i,
                    alias: 'type-hint',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /([(,?]\s*)(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,
                    alias: [
                        'class-name-fully-qualified',
                        'type-hint'
                    ],
                    greedy: true,
                    lookbehind: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /(\)\s*:\s*(?:\?\s*)?)\b[a-z_]\w*(?!\\)\b/i,
                    alias: 'return-type',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /(\)\s*:\s*(?:\?\s*)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
                    alias: [
                        'class-name-fully-qualified',
                        'return-type'
                    ],
                    greedy: true,
                    lookbehind: true,
                    inside: {
                        punctuation: /\\/
                    }
                }
            ],
            constant: constant,
            function: {
                pattern: /(^|[^\\\w])\\?[a-z_](?:[\w\\]*\w)?(?=\s*\()/i,
                lookbehind: true,
                inside: {
                    punctuation: /\\/
                }
            },
            property: {
                pattern: /(->\s*)\w+/,
                lookbehind: true
            },
            number: number,
            operator: operator,
            punctuation: punctuation
        };
        var string_interpolation = {
            pattern: /\{\$(?:\{(?:\{[^{}]+\}|[^{}]+)\}|[^{}])+\}|(^|[^\\{])\$+(?:\w+(?:\[[^\r\n\[\]]+\]|->\w+)?)/,
            lookbehind: true,
            inside: Prism.languages.php
        };
        var string = [
            {
                pattern: /<<<'([^']+)'[\r\n](?:.*[\r\n])*?\1;/,
                alias: 'nowdoc-string',
                greedy: true,
                inside: {
                    delimiter: {
                        pattern: /^<<<'[^']+'|[a-z_]\w*;$/i,
                        alias: 'symbol',
                        inside: {
                            punctuation: /^<<<'?|[';]$/
                        }
                    }
                }
            },
            {
                pattern: /<<<(?:"([^"]+)"[\r\n](?:.*[\r\n])*?\1;|([a-z_]\w*)[\r\n](?:.*[\r\n])*?\2;)/i,
                alias: 'heredoc-string',
                greedy: true,
                inside: {
                    delimiter: {
                        pattern: /^<<<(?:"[^"]+"|[a-z_]\w*)|[a-z_]\w*;$/i,
                        alias: 'symbol',
                        inside: {
                            punctuation: /^<<<"?|[";]$/
                        }
                    },
                    interpolation: string_interpolation
                }
            },
            {
                pattern: /`(?:\\[\s\S]|[^\\`])*`/,
                alias: 'backtick-quoted-string',
                greedy: true
            },
            {
                pattern: /'(?:\\[\s\S]|[^\\'])*'/,
                alias: 'single-quoted-string',
                greedy: true
            },
            {
                pattern: /"(?:\\[\s\S]|[^\\"])*"/,
                alias: 'double-quoted-string',
                greedy: true,
                inside: {
                    interpolation: string_interpolation
                }
            }
        ];
        Prism.languages.insertBefore('php', 'variable', {
            string: string,
            attribute: {
                pattern: /#\[(?:[^"'\/#]|\/(?![*/])|\/\/.*$|#(?!\[).*$|\/\*(?:[^*]|\*(?!\/))*\*\/|"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*')+\](?=\s*[a-z$#])/im,
                greedy: true,
                inside: {
                    'attribute-content': {
                        pattern: /^(#\[)[\s\S]+(?=\]$)/,
                        lookbehind: true,
                        // inside can appear subset of php
                        inside: {
                            comment: comment,
                            string: string,
                            'attribute-class-name': [
                                {
                                    pattern: /([^:]|^)\b[a-z_]\w*(?!\\)\b/i,
                                    alias: 'class-name',
                                    greedy: true,
                                    lookbehind: true
                                },
                                {
                                    pattern: /([^:]|^)(?:\\?\b[a-z_]\w*)+/i,
                                    alias: [
                                        'class-name',
                                        'class-name-fully-qualified'
                                    ],
                                    greedy: true,
                                    lookbehind: true,
                                    inside: {
                                        punctuation: /\\/
                                    }
                                }
                            ],
                            constant: constant,
                            number: number,
                            operator: operator,
                            punctuation: punctuation
                        }
                    },
                    delimiter: {
                        pattern: /^#\[|\]$/,
                        alias: 'punctuation'
                    }
                }
            }
        });
        Prism.hooks.add('before-tokenize', function(env) {
            if (!/<\?/.test(env.code)) return;
            var phpPattern = /<\?(?:[^"'/#]|\/(?![*/])|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|(?:\/\/|#(?!\[))(?:[^?\n\r]|\?(?!>))*(?=$|\?>|[\r\n])|#\[|\/\*(?:[^*]|\*(?!\/))*(?:\*\/|$))*?(?:\?>|$)/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'php', phpPattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'php');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $166c94860a240118$export$2e2bcd8739ae039.displayName = 'python';
$166c94860a240118$export$2e2bcd8739ae039.aliases = [
    'py'
];
function $166c94860a240118$export$2e2bcd8739ae039(Prism) {
    Prism.languages.python = {
        comment: {
            pattern: /(^|[^\\])#.*/,
            lookbehind: true,
            greedy: true
        },
        'string-interpolation': {
            pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
            greedy: true,
            inside: {
                interpolation: {
                    // "{" <expression> <optional "!s", "!r", or "!a"> <optional ":" format specifier> "}"
                    pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
                    lookbehind: true,
                    inside: {
                        'format-spec': {
                            pattern: /(:)[^:(){}]+(?=\}$)/,
                            lookbehind: true
                        },
                        'conversion-option': {
                            pattern: /![sra](?=[:}]$)/,
                            alias: 'punctuation'
                        },
                        rest: null
                    }
                },
                string: /[\s\S]+/
            }
        },
        'triple-quoted-string': {
            pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
            greedy: true,
            alias: 'string'
        },
        string: {
            pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
            greedy: true
        },
        function: {
            pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
            lookbehind: true
        },
        'class-name': {
            pattern: /(\bclass\s+)\w+/i,
            lookbehind: true
        },
        decorator: {
            pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
            lookbehind: true,
            alias: [
                'annotation',
                'punctuation'
            ],
            inside: {
                punctuation: /\./
            }
        },
        keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
        builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
        boolean: /\b(?:False|None|True)\b/,
        number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
        operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
        punctuation: /[{}[\];(),.:]/
    };
    Prism.languages.python['string-interpolation'].inside['interpolation'].inside.rest = Prism.languages.python;
    Prism.languages.py = Prism.languages.python;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $df89008fdd9898a1$export$2e2bcd8739ae039.displayName = 'r';
$df89008fdd9898a1$export$2e2bcd8739ae039.aliases = [];
function $df89008fdd9898a1$export$2e2bcd8739ae039(Prism) {
    Prism.languages.r = {
        comment: /#.*/,
        string: {
            pattern: /(['"])(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        'percent-operator': {
            // Includes user-defined operators
            // and %%, %*%, %/%, %in%, %o%, %x%
            pattern: /%[^%\s]*%/,
            alias: 'operator'
        },
        boolean: /\b(?:FALSE|TRUE)\b/,
        ellipsis: /\.\.(?:\.|\d+)/,
        number: [
            /\b(?:Inf|NaN)\b/,
            /(?:\b0x[\dA-Fa-f]+(?:\.\d*)?|\b\d+(?:\.\d*)?|\B\.\d+)(?:[EePp][+-]?\d+)?[iL]?/
        ],
        keyword: /\b(?:NA|NA_character_|NA_complex_|NA_integer_|NA_real_|NULL|break|else|for|function|if|in|next|repeat|while)\b/,
        operator: /->?>?|<(?:=|<?-)?|[>=!]=?|::?|&&?|\|\|?|[+*\/^$@~]/,
        punctuation: /[(){}\[\],;]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$1024f633e11e96f5$export$2e2bcd8739ae039.displayName = 'ruby';
$1024f633e11e96f5$export$2e2bcd8739ae039.aliases = [
    'rb'
];
function $1024f633e11e96f5$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.ruby = Prism.languages.extend('clike', {
            comment: {
                pattern: /#.*|^=begin\s[\s\S]*?^=end/m,
                greedy: true
            },
            'class-name': {
                pattern: /(\b(?:class|module)\s+|\bcatch\s+\()[\w.\\]+|\b[A-Z_]\w*(?=\s*\.\s*new\b)/,
                lookbehind: true,
                inside: {
                    punctuation: /[.\\]/
                }
            },
            keyword: /\b(?:BEGIN|END|alias|and|begin|break|case|class|def|define_method|defined|do|each|else|elsif|end|ensure|extend|for|if|in|include|module|new|next|nil|not|or|prepend|private|protected|public|raise|redo|require|rescue|retry|return|self|super|then|throw|undef|unless|until|when|while|yield)\b/,
            operator: /\.{2,3}|&\.|===|<?=>|[!=]?~|(?:&&|\|\||<<|>>|\*\*|[+\-*/%<>!^&|=])=?|[?:]/,
            punctuation: /[(){}[\].,;]/
        });
        Prism.languages.insertBefore('ruby', 'operator', {
            'double-colon': {
                pattern: /::/,
                alias: 'punctuation'
            }
        });
        var interpolation = {
            pattern: /((?:^|[^\\])(?:\\{2})*)#\{(?:[^{}]|\{[^{}]*\})*\}/,
            lookbehind: true,
            inside: {
                content: {
                    pattern: /^(#\{)[\s\S]+(?=\}$)/,
                    lookbehind: true,
                    inside: Prism.languages.ruby
                },
                delimiter: {
                    pattern: /^#\{|\}$/,
                    alias: 'punctuation'
                }
            }
        };
        delete Prism.languages.ruby.function;
        var percentExpression = '(?:' + [
            /([^a-zA-Z0-9\s{(\[<=])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
            /\((?:[^()\\]|\\[\s\S]|\((?:[^()\\]|\\[\s\S])*\))*\)/.source,
            /\{(?:[^{}\\]|\\[\s\S]|\{(?:[^{}\\]|\\[\s\S])*\})*\}/.source,
            /\[(?:[^\[\]\\]|\\[\s\S]|\[(?:[^\[\]\\]|\\[\s\S])*\])*\]/.source,
            /<(?:[^<>\\]|\\[\s\S]|<(?:[^<>\\]|\\[\s\S])*>)*>/.source
        ].join('|') + ')';
        var symbolName = /(?:"(?:\\.|[^"\\\r\n])*"|(?:\b[a-zA-Z_]\w*|[^\s\0-\x7F]+)[?!]?|\$.)/.source;
        Prism.languages.insertBefore('ruby', 'keyword', {
            'regex-literal': [
                {
                    pattern: RegExp(/%r/.source + percentExpression + /[egimnosux]{0,6}/.source),
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        regex: /[\s\S]+/
                    }
                },
                {
                    pattern: /(^|[^/])\/(?!\/)(?:\[[^\r\n\]]+\]|\\.|[^[/\\\r\n])+\/[egimnosux]{0,6}(?=\s*(?:$|[\r\n,.;})#]))/,
                    lookbehind: true,
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        regex: /[\s\S]+/
                    }
                }
            ],
            variable: /[@$]+[a-zA-Z_]\w*(?:[?!]|\b)/,
            symbol: [
                {
                    pattern: RegExp(/(^|[^:]):/.source + symbolName),
                    lookbehind: true,
                    greedy: true
                },
                {
                    pattern: RegExp(/([\r\n{(,][ \t]*)/.source + symbolName + /(?=:(?!:))/.source),
                    lookbehind: true,
                    greedy: true
                }
            ],
            'method-definition': {
                pattern: /(\bdef\s+)\w+(?:\s*\.\s*\w+)?/,
                lookbehind: true,
                inside: {
                    function: /\b\w+$/,
                    keyword: /^self\b/,
                    'class-name': /^\w+/,
                    punctuation: /\./
                }
            }
        });
        Prism.languages.insertBefore('ruby', 'string', {
            'string-literal': [
                {
                    pattern: RegExp(/%[qQiIwWs]?/.source + percentExpression),
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        string: /[\s\S]+/
                    }
                },
                {
                    pattern: /("|')(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|(?!\1)[^\\#\r\n])*\1/,
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        string: /[\s\S]+/
                    }
                },
                {
                    pattern: /<<[-~]?([a-z_]\w*)[\r\n](?:.*[\r\n])*?[\t ]*\1/i,
                    alias: 'heredoc-string',
                    greedy: true,
                    inside: {
                        delimiter: {
                            pattern: /^<<[-~]?[a-z_]\w*|\b[a-z_]\w*$/i,
                            inside: {
                                symbol: /\b\w+/,
                                punctuation: /^<<[-~]?/
                            }
                        },
                        interpolation: interpolation,
                        string: /[\s\S]+/
                    }
                },
                {
                    pattern: /<<[-~]?'([a-z_]\w*)'[\r\n](?:.*[\r\n])*?[\t ]*\1/i,
                    alias: 'heredoc-string',
                    greedy: true,
                    inside: {
                        delimiter: {
                            pattern: /^<<[-~]?'[a-z_]\w*'|\b[a-z_]\w*$/i,
                            inside: {
                                symbol: /\b\w+/,
                                punctuation: /^<<[-~]?'|'$/
                            }
                        },
                        string: /[\s\S]+/
                    }
                }
            ],
            'command-literal': [
                {
                    pattern: RegExp(/%x/.source + percentExpression),
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        command: {
                            pattern: /[\s\S]+/,
                            alias: 'string'
                        }
                    }
                },
                {
                    pattern: /`(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|[^\\`#\r\n])*`/,
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        command: {
                            pattern: /[\s\S]+/,
                            alias: 'string'
                        }
                    }
                }
            ]
        });
        delete Prism.languages.ruby.string;
        Prism.languages.insertBefore('ruby', 'number', {
            builtin: /\b(?:Array|Bignum|Binding|Class|Continuation|Dir|Exception|FalseClass|File|Fixnum|Float|Hash|IO|Integer|MatchData|Method|Module|NilClass|Numeric|Object|Proc|Range|Regexp|Stat|String|Struct|Symbol|TMS|Thread|ThreadGroup|Time|TrueClass)\b/,
            constant: /\b[A-Z][A-Z0-9_]*(?:[?!]|\b)/
        });
        Prism.languages.rb = Prism.languages.ruby;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $57faf12dcc554420$export$2e2bcd8739ae039.displayName = 'rust';
$57faf12dcc554420$export$2e2bcd8739ae039.aliases = [];
function $57faf12dcc554420$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var multilineComment = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source;
        for(var i = 0; i < 2; i++)// support 4 levels of nested comments
        multilineComment = multilineComment.replace(/<self>/g, function() {
            return multilineComment;
        });
        multilineComment = multilineComment.replace(/<self>/g, function() {
            return /[^\s\S]/.source;
        });
        Prism.languages.rust = {
            comment: [
                {
                    pattern: RegExp(/(^|[^\\])/.source + multilineComment),
                    lookbehind: true,
                    greedy: true
                },
                {
                    pattern: /(^|[^\\:])\/\/.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            string: {
                pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
                greedy: true
            },
            char: {
                pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
                greedy: true
            },
            attribute: {
                pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
                greedy: true,
                alias: 'attr-name',
                inside: {
                    string: null // see below
                }
            },
            // Closure params should not be confused with bitwise OR |
            'closure-params': {
                pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
                lookbehind: true,
                greedy: true,
                inside: {
                    'closure-punctuation': {
                        pattern: /^\||\|$/,
                        alias: 'punctuation'
                    },
                    rest: null // see below
                }
            },
            'lifetime-annotation': {
                pattern: /'\w+/,
                alias: 'symbol'
            },
            'fragment-specifier': {
                pattern: /(\$\w+:)[a-z]+/,
                lookbehind: true,
                alias: 'punctuation'
            },
            variable: /\$\w+/,
            'function-definition': {
                pattern: /(\bfn\s+)\w+/,
                lookbehind: true,
                alias: 'function'
            },
            'type-definition': {
                pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
                lookbehind: true,
                alias: 'class-name'
            },
            'module-declaration': [
                {
                    pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
                    lookbehind: true,
                    alias: 'namespace'
                },
                {
                    pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
                    lookbehind: true,
                    alias: 'namespace',
                    inside: {
                        punctuation: /::/
                    }
                }
            ],
            keyword: [
                // https://github.com/rust-lang/reference/blob/master/src/keywords.md
                /\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
                // primitives and str
                // https://doc.rust-lang.org/stable/rust-by-example/primitives.html
                /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/
            ],
            // functions can technically start with an upper-case letter, but this will introduce a lot of false positives
            // and Rust's naming conventions recommend snake_case anyway.
            // https://doc.rust-lang.org/1.0.0/style/style/naming/README.html
            function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
            macro: {
                pattern: /\b\w+!/,
                alias: 'property'
            },
            constant: /\b[A-Z_][A-Z_\d]+\b/,
            'class-name': /\b[A-Z]\w*\b/,
            namespace: {
                pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
                inside: {
                    punctuation: /::/
                }
            },
            // Hex, oct, bin, dec numbers with visual separators and type suffix
            number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
            boolean: /\b(?:false|true)\b/,
            punctuation: /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
            operator: /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
        };
        Prism.languages.rust['closure-params'].inside.rest = Prism.languages.rust;
        Prism.languages.rust['attribute'].inside['string'] = Prism.languages.rust['string'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$fd46c9753d6b17f5$export$2e2bcd8739ae039.displayName = 'sass';
$fd46c9753d6b17f5$export$2e2bcd8739ae039.aliases = [];
function $fd46c9753d6b17f5$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $c8ae87468323f6e6$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.sass = Prism.languages.extend('css', {
            // Sass comments don't need to be closed, only indented
            comment: {
                pattern: /^([ \t]*)\/[\/*].*(?:(?:\r?\n|\r)\1[ \t].+)*/m,
                lookbehind: true,
                greedy: true
            }
        });
        Prism.languages.insertBefore('sass', 'atrule', {
            // We want to consume the whole line
            'atrule-line': {
                // Includes support for = and + shortcuts
                pattern: /^(?:[ \t]*)[@+=].+/m,
                greedy: true,
                inside: {
                    atrule: /(?:@[\w-]+|[+=])/
                }
            }
        });
        delete Prism.languages.sass.atrule;
        var variable = /\$[-\w]+|#\{\$[-\w]+\}/;
        var operator = [
            /[+*\/%]|[=!]=|<=?|>=?|\b(?:and|not|or)\b/,
            {
                pattern: /(\s)-(?=\s)/,
                lookbehind: true
            }
        ];
        Prism.languages.insertBefore('sass', 'property', {
            // We want to consume the whole line
            'variable-line': {
                pattern: /^[ \t]*\$.+/m,
                greedy: true,
                inside: {
                    punctuation: /:/,
                    variable: variable,
                    operator: operator
                }
            },
            // We want to consume the whole line
            'property-line': {
                pattern: /^[ \t]*(?:[^:\s]+ *:.*|:[^:\s].*)/m,
                greedy: true,
                inside: {
                    property: [
                        /[^:\s]+(?=\s*:)/,
                        {
                            pattern: /(:)[^:\s]+/,
                            lookbehind: true
                        }
                    ],
                    punctuation: /:/,
                    variable: variable,
                    operator: operator,
                    important: Prism.languages.sass.important
                }
            }
        });
        delete Prism.languages.sass.property;
        delete Prism.languages.sass.important;
        // Now that whole lines for other patterns are consumed,
        // what's left should be selectors
        Prism.languages.insertBefore('sass', 'punctuation', {
            selector: {
                pattern: /^([ \t]*)\S(?:,[^,\r\n]+|[^,\r\n]*)(?:,[^,\r\n]+)*(?:,(?:\r?\n|\r)\1[ \t]+\S(?:,[^,\r\n]+|[^,\r\n]*)(?:,[^,\r\n]+)*)*/m,
                lookbehind: true,
                greedy: true
            }
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$50318a28f67a9ccf$export$2e2bcd8739ae039.displayName = 'scss';
$50318a28f67a9ccf$export$2e2bcd8739ae039.aliases = [];
function $50318a28f67a9ccf$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $c8ae87468323f6e6$export$2e2bcd8739ae039));
    Prism.languages.scss = Prism.languages.extend('css', {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
            lookbehind: true
        },
        atrule: {
            pattern: /@[\w-](?:\([^()]+\)|[^()\s]|\s+(?!\s))*?(?=\s+[{;])/,
            inside: {
                rule: /@[\w-]+/
            }
        },
        // url, compassified
        url: /(?:[-a-z]+-)?url(?=\()/i,
        // CSS selector regex is not appropriate for Sass
        // since there can be lot more things (var, @ directive, nesting..)
        // a selector must start at the end of a property or after a brace (end of other rules or nesting)
        // it can contain some characters that aren't used for defining rules or end of selector, & (parent selector), or interpolated variable
        // the end of a selector is found when there is no rules in it ( {} or {\s}) or if there is a property (because an interpolated var
        // can "pass" as a selector- e.g: proper#{$erty})
        // this one was hard to do, so please be careful if you edit this one :)
        selector: {
            // Initial look-ahead is used to prevent matching of blank selectors
            pattern: /(?=\S)[^@;{}()]?(?:[^@;{}()\s]|\s+(?!\s)|#\{\$[-\w]+\})+(?=\s*\{(?:\}|\s|[^}][^:{}]*[:{][^}]))/,
            inside: {
                parent: {
                    pattern: /&/,
                    alias: 'important'
                },
                placeholder: /%[-\w]+/,
                variable: /\$[-\w]+|#\{\$[-\w]+\}/
            }
        },
        property: {
            pattern: /(?:[-\w]|\$[-\w]|#\{\$[-\w]+\})+(?=\s*:)/,
            inside: {
                variable: /\$[-\w]+|#\{\$[-\w]+\}/
            }
        }
    });
    Prism.languages.insertBefore('scss', 'atrule', {
        keyword: [
            /@(?:content|debug|each|else(?: if)?|extend|for|forward|function|if|import|include|mixin|return|use|warn|while)\b/i,
            {
                pattern: /( )(?:from|through)(?= )/,
                lookbehind: true
            }
        ]
    });
    Prism.languages.insertBefore('scss', 'important', {
        // var and interpolated vars
        variable: /\$[-\w]+|#\{\$[-\w]+\}/
    });
    Prism.languages.insertBefore('scss', 'function', {
        'module-modifier': {
            pattern: /\b(?:as|hide|show|with)\b/i,
            alias: 'keyword'
        },
        placeholder: {
            pattern: /%[-\w]+/,
            alias: 'selector'
        },
        statement: {
            pattern: /\B!(?:default|optional)\b/i,
            alias: 'keyword'
        },
        boolean: /\b(?:false|true)\b/,
        null: {
            pattern: /\bnull\b/,
            alias: 'keyword'
        },
        operator: {
            pattern: /(\s)(?:[-+*\/%]|[=!]=|<=?|>=?|and|not|or)(?=\s)/,
            lookbehind: true
        }
    });
    Prism.languages.scss['atrule'].inside.rest = Prism.languages.scss;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $d138d4e60ec637d4$export$2e2bcd8739ae039.displayName = 'sql';
$d138d4e60ec637d4$export$2e2bcd8739ae039.aliases = [];
function $d138d4e60ec637d4$export$2e2bcd8739ae039(Prism) {
    Prism.languages.sql = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
            lookbehind: true
        },
        variable: [
            {
                pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
                greedy: true
            },
            /@[\w.$]+/
        ],
        string: {
            pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
            greedy: true,
            lookbehind: true
        },
        identifier: {
            pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
            greedy: true,
            lookbehind: true,
            inside: {
                punctuation: /^`|`$/
            }
        },
        function: /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,
        // Should we highlight user defined functions too?
        keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
        boolean: /\b(?:FALSE|NULL|TRUE)\b/i,
        number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
        operator: /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
        punctuation: /[;[\]()`,.]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $07912fa463f18ff4$export$2e2bcd8739ae039.displayName = 'swift';
$07912fa463f18ff4$export$2e2bcd8739ae039.aliases = [];
function $07912fa463f18ff4$export$2e2bcd8739ae039(Prism) {
    Prism.languages.swift = {
        comment: {
            // Nested comments are supported up to 2 levels
            pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,
            lookbehind: true,
            greedy: true
        },
        'string-literal': [
            // https://docs.swift.org/swift-book/LanguageGuide/StringsAndCharacters.html
            {
                pattern: RegExp(/(^|[^"#])/.source + '(?:' + // single-line string
                /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + '|' + // multi-line string
                /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ')' + /(?!["#])/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/,
                        lookbehind: true,
                        inside: null // see below
                    },
                    'interpolation-punctuation': {
                        pattern: /^\)|\\\($/,
                        alias: 'punctuation'
                    },
                    punctuation: /\\(?=[\r\n])/,
                    string: /[\s\S]+/
                }
            },
            {
                pattern: RegExp(/(^|[^"#])(#+)/.source + '(?:' + // single-line string
                /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + '|' + // multi-line string
                /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ')' + '\\2'),
                lookbehind: true,
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,
                        lookbehind: true,
                        inside: null // see below
                    },
                    'interpolation-punctuation': {
                        pattern: /^\)|\\#+\($/,
                        alias: 'punctuation'
                    },
                    string: /[\s\S]+/
                }
            }
        ],
        directive: {
            // directives with conditions
            pattern: RegExp(/#/.source + '(?:' + (/(?:elseif|if)\b/.source + '(?:[ \t]*' + // This regex is a little complex. It's equivalent to this:
            //   (?:![ \t]*)?(?:\b\w+\b(?:[ \t]*<round>)?|<round>)(?:[ \t]*(?:&&|\|\|))?
            // where <round> is a general parentheses expression.
            /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ')+') + '|' + /(?:else|endif)\b/.source + ')'),
            alias: 'property',
            inside: {
                'directive-name': /^#\w+/,
                boolean: /\b(?:false|true)\b/,
                number: /\b\d+(?:\.\d+)*\b/,
                operator: /!|&&|\|\||[<>]=?/,
                punctuation: /[(),]/
            }
        },
        literal: {
            pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,
            alias: 'constant'
        },
        'other-directive': {
            pattern: /#\w+\b/,
            alias: 'property'
        },
        attribute: {
            pattern: /@\w+/,
            alias: 'atrule'
        },
        'function-definition': {
            pattern: /(\bfunc\s+)\w+/,
            lookbehind: true,
            alias: 'function'
        },
        label: {
            // https://docs.swift.org/swift-book/LanguageGuide/ControlFlow.html#ID141
            pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,
            lookbehind: true,
            alias: 'important'
        },
        keyword: /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,
        boolean: /\b(?:false|true)\b/,
        nil: {
            pattern: /\bnil\b/,
            alias: 'constant'
        },
        'short-argument': /\$\d+\b/,
        omit: {
            pattern: /\b_\b/,
            alias: 'keyword'
        },
        number: /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,
        // A class name must start with an upper-case letter and be either 1 letter long or contain a lower-case letter.
        'class-name': /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        constant: /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,
        // Operators are generic in Swift. Developers can even create new operators (e.g. +++).
        // https://docs.swift.org/swift-book/ReferenceManual/zzSummaryOfTheGrammar.html#ID481
        // This regex only supports ASCII operators.
        operator: /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,
        punctuation: /[{}[\]();,.:\\]/
    };
    Prism.languages.swift['string-literal'].forEach(function(rule) {
        rule.inside['interpolation'].inside = Prism.languages.swift;
    });
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$971aaf7f210ab43d$export$2e2bcd8739ae039.displayName = 'typescript';
$971aaf7f210ab43d$export$2e2bcd8739ae039.aliases = [
    'ts'
];
function $971aaf7f210ab43d$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $9f5c72e4d4e505c4$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.typescript = Prism.languages.extend('javascript', {
            'class-name': {
                pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
                lookbehind: true,
                greedy: true,
                inside: null // see below
            },
            builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
        });
        // The keywords TypeScript adds to JavaScript
        Prism.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, // keywords that have to be followed by an identifier
        /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, // This is for `import type *, {}`
        /\btype\b(?=\s*(?:[\{*]|$))/);
        // doesn't work with TS because TS is too complex
        delete Prism.languages.typescript['parameter'];
        delete Prism.languages.typescript['literal-property'];
        // a version of typescript specifically for highlighting types
        var typeInside = Prism.languages.extend('typescript', {});
        delete typeInside['class-name'];
        Prism.languages.typescript['class-name'].inside = typeInside;
        Prism.languages.insertBefore('typescript', 'function', {
            decorator: {
                pattern: /@[$\w\xA0-\uFFFF]+/,
                inside: {
                    at: {
                        pattern: /^@/,
                        alias: 'operator'
                    },
                    function: /^[\s\S]+/
                }
            },
            'generic-function': {
                // e.g. foo<T extends "bar" | "baz">( ...
                pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
                greedy: true,
                inside: {
                    function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
                    generic: {
                        pattern: /<[\s\S]+/,
                        // everything after the first <
                        alias: 'class-name',
                        inside: typeInside
                    }
                }
            }
        });
        Prism.languages.ts = Prism.languages.typescript;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $11df1c7abcd7aa92$export$2e2bcd8739ae039.displayName = 'basic';
$11df1c7abcd7aa92$export$2e2bcd8739ae039.aliases = [];
function $11df1c7abcd7aa92$export$2e2bcd8739ae039(Prism) {
    Prism.languages.basic = {
        comment: {
            pattern: /(?:!|REM\b).+/i,
            inside: {
                keyword: /^REM/i
            }
        },
        string: {
            pattern: /"(?:""|[!#$%&'()*,\/:;<=>?^\w +\-.])*"/,
            greedy: true
        },
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
        keyword: /\b(?:AS|BEEP|BLOAD|BSAVE|CALL(?: ABSOLUTE)?|CASE|CHAIN|CHDIR|CLEAR|CLOSE|CLS|COM|COMMON|CONST|DATA|DECLARE|DEF(?: FN| SEG|DBL|INT|LNG|SNG|STR)|DIM|DO|DOUBLE|ELSE|ELSEIF|END|ENVIRON|ERASE|ERROR|EXIT|FIELD|FILES|FOR|FUNCTION|GET|GOSUB|GOTO|IF|INPUT|INTEGER|IOCTL|KEY|KILL|LINE INPUT|LOCATE|LOCK|LONG|LOOP|LSET|MKDIR|NAME|NEXT|OFF|ON(?: COM| ERROR| KEY| TIMER)?|OPEN|OPTION BASE|OUT|POKE|PUT|READ|REDIM|REM|RESTORE|RESUME|RETURN|RMDIR|RSET|RUN|SELECT CASE|SHARED|SHELL|SINGLE|SLEEP|STATIC|STEP|STOP|STRING|SUB|SWAP|SYSTEM|THEN|TIMER|TO|TROFF|TRON|TYPE|UNLOCK|UNTIL|USING|VIEW PRINT|WAIT|WEND|WHILE|WRITE)(?:\$|\b)/i,
        function: /\b(?:ABS|ACCESS|ACOS|ANGLE|AREA|ARITHMETIC|ARRAY|ASIN|ASK|AT|ATN|BASE|BEGIN|BREAK|CAUSE|CEIL|CHR|CLIP|COLLATE|COLOR|CON|COS|COSH|COT|CSC|DATE|DATUM|DEBUG|DECIMAL|DEF|DEG|DEGREES|DELETE|DET|DEVICE|DISPLAY|DOT|ELAPSED|EPS|ERASABLE|EXLINE|EXP|EXTERNAL|EXTYPE|FILETYPE|FIXED|FP|GO|GRAPH|HANDLER|IDN|IMAGE|IN|INT|INTERNAL|IP|IS|KEYED|LBOUND|LCASE|LEFT|LEN|LENGTH|LET|LINE|LINES|LOG|LOG10|LOG2|LTRIM|MARGIN|MAT|MAX|MAXNUM|MID|MIN|MISSING|MOD|NATIVE|NUL|NUMERIC|OF|OPTION|ORD|ORGANIZATION|OUTIN|OUTPUT|PI|POINT|POINTER|POINTS|POS|PRINT|PROGRAM|PROMPT|RAD|RADIANS|RANDOMIZE|RECORD|RECSIZE|RECTYPE|RELATIVE|REMAINDER|REPEAT|REST|RETRY|REWRITE|RIGHT|RND|ROUND|RTRIM|SAME|SEC|SELECT|SEQUENTIAL|SET|SETTER|SGN|SIN|SINH|SIZE|SKIP|SQR|STANDARD|STATUS|STR|STREAM|STYLE|TAB|TAN|TANH|TEMPLATE|TEXT|THERE|TIME|TIMEOUT|TRACE|TRANSFORM|TRUNCATE|UBOUND|UCASE|USE|VAL|VARIABLE|VIEWPORT|WHEN|WINDOW|WITH|ZER|ZONEWIDTH)(?:\$|\b)/i,
        operator: /<[=>]?|>=?|[+\-*\/^=&]|\b(?:AND|EQV|IMP|NOT|OR|XOR)\b/i,
        punctuation: /[,;:()]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$398c5bff0b970a81$export$2e2bcd8739ae039.displayName = 'vbnet';
$398c5bff0b970a81$export$2e2bcd8739ae039.aliases = [];
function $398c5bff0b970a81$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $11df1c7abcd7aa92$export$2e2bcd8739ae039));
    Prism.languages.vbnet = Prism.languages.extend('basic', {
        comment: [
            {
                pattern: /(?:!|REM\b).+/i,
                inside: {
                    keyword: /^REM/i
                }
            },
            {
                pattern: /(^|[^\\:])'.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(^|[^"])"(?:""|[^"])*"(?!")/,
            lookbehind: true,
            greedy: true
        },
        keyword: /(?:\b(?:ADDHANDLER|ADDRESSOF|ALIAS|AND|ANDALSO|AS|BEEP|BLOAD|BOOLEAN|BSAVE|BYREF|BYTE|BYVAL|CALL(?: ABSOLUTE)?|CASE|CATCH|CBOOL|CBYTE|CCHAR|CDATE|CDBL|CDEC|CHAIN|CHAR|CHDIR|CINT|CLASS|CLEAR|CLNG|CLOSE|CLS|COBJ|COM|COMMON|CONST|CONTINUE|CSBYTE|CSHORT|CSNG|CSTR|CTYPE|CUINT|CULNG|CUSHORT|DATA|DATE|DECIMAL|DECLARE|DEF(?: FN| SEG|DBL|INT|LNG|SNG|STR)|DEFAULT|DELEGATE|DIM|DIRECTCAST|DO|DOUBLE|ELSE|ELSEIF|END|ENUM|ENVIRON|ERASE|ERROR|EVENT|EXIT|FALSE|FIELD|FILES|FINALLY|FOR(?: EACH)?|FRIEND|FUNCTION|GET|GETTYPE|GETXMLNAMESPACE|GLOBAL|GOSUB|GOTO|HANDLES|IF|IMPLEMENTS|IMPORTS|IN|INHERITS|INPUT|INTEGER|INTERFACE|IOCTL|IS|ISNOT|KEY|KILL|LET|LIB|LIKE|LINE INPUT|LOCATE|LOCK|LONG|LOOP|LSET|ME|MKDIR|MOD|MODULE|MUSTINHERIT|MUSTOVERRIDE|MYBASE|MYCLASS|NAME|NAMESPACE|NARROWING|NEW|NEXT|NOT|NOTHING|NOTINHERITABLE|NOTOVERRIDABLE|OBJECT|OF|OFF|ON(?: COM| ERROR| KEY| TIMER)?|OPEN|OPERATOR|OPTION(?: BASE)?|OPTIONAL|OR|ORELSE|OUT|OVERLOADS|OVERRIDABLE|OVERRIDES|PARAMARRAY|PARTIAL|POKE|PRIVATE|PROPERTY|PROTECTED|PUBLIC|PUT|RAISEEVENT|READ|READONLY|REDIM|REM|REMOVEHANDLER|RESTORE|RESUME|RETURN|RMDIR|RSET|RUN|SBYTE|SELECT(?: CASE)?|SET|SHADOWS|SHARED|SHELL|SHORT|SINGLE|SLEEP|STATIC|STEP|STOP|STRING|STRUCTURE|SUB|SWAP|SYNCLOCK|SYSTEM|THEN|THROW|TIMER|TO|TROFF|TRON|TRUE|TRY|TRYCAST|TYPE|TYPEOF|UINTEGER|ULONG|UNLOCK|UNTIL|USHORT|USING|VIEW PRINT|WAIT|WEND|WHEN|WHILE|WIDENING|WITH|WITHEVENTS|WRITE|WRITEONLY|XOR)|\B(?:#CONST|#ELSE|#ELSEIF|#END|#IF))(?:\$|\b)/i,
        punctuation: /[,;:(){}]/
    });
}


/**
 * @import {Element, Root, Text} from 'hast'
 * @import {Grammar, Languages} from 'prismjs'
 */ /**
 * @typedef _Token
 *   Hidden Prism token.
 * @property {string} alias
 *   Alias.
 * @property {string} content
 *   Content.
 * @property {number} length
 *   Length.
 * @property {string} type
 *   Type.
 */ /**
 * @typedef _Env
 *   Hidden Prism environment.
 * @property {Record<string, string>} attributes
 *   Attributes.
 * @property {Array<string>} classes
 *   Classes.
 * @property {Array<RefractorElement | Text> | RefractorElement | Text} content
 *   Content.
 * @property {string} language
 *   Language.
 * @property {string} tag
 *   Tag.
 * @property {string} type
 *   Type.
 */ /**
 * @typedef {Omit<Element, 'children'> & {children: Array<RefractorElement | Text>}} RefractorElement
 *   Element; narrowed down to what’s used here.
 */ /**
 * @typedef {Omit<Root, 'children'> & {children: Array<RefractorElement | Text>}} RefractorRoot
 *   Root; narrowed down to what’s used here.
 */ /**
 * @typedef {((prism: Refractor) => undefined | void) & {aliases?: Array<string> | undefined, displayName: string}} Syntax
 *   Refractor syntax function.
 */ /**
 * @typedef Refractor
 *   Virtual syntax highlighting
 * @property {typeof alias} alias
 * @property {Languages} languages
 * @property {typeof listLanguages} listLanguages
 * @property {typeof highlight} highlight
 * @property {typeof registered} registered
 * @property {typeof register} register
 */ // Load all stuff in `prism.js` itself, except for `prism-file-highlight.js`.
// The wrapped non-leaky grammars are loaded instead of Prism’s originals.
/**
 * @typedef {import('./core.js').HChild} Child
 *   Acceptable child value.
 * @typedef {import('./core.js').HProperties} Properties
 *   Acceptable value for element properties.
 * @typedef {import('./core.js').HResult} Result
 *   Result from a `h` (or `s`) call.
 *
 * @typedef {import('./jsx-classic.js').Element} h.JSX.Element
 * @typedef {import('./jsx-classic.js').IntrinsicAttributes} h.JSX.IntrinsicAttributes
 * @typedef {import('./jsx-classic.js').IntrinsicElements} h.JSX.IntrinsicElements
 * @typedef {import('./jsx-classic.js').ElementChildrenAttribute} h.JSX.ElementChildrenAttribute
 */ /**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */ /**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */ /**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */ class $a31514946fcac663$export$19342e026b58ebb7 {
    /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */ constructor(property, normal, space){
        this.property = property;
        this.normal = normal;
        if (space) this.space = space;
    }
}
/** @type {Properties} */ $a31514946fcac663$export$19342e026b58ebb7.prototype.property = {};
/** @type {Normal} */ $a31514946fcac663$export$19342e026b58ebb7.prototype.normal = {};
/** @type {string|null} */ $a31514946fcac663$export$19342e026b58ebb7.prototype.space = null;


function $0007f1b04b92e296$export$4950aa0f605343fb(definitions, space) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    let index = -1;
    while(++index < definitions.length){
        Object.assign(property, definitions[index].property);
        Object.assign(normal, definitions[index].normal);
    }
    return new (0, $a31514946fcac663$export$19342e026b58ebb7)(property, normal, space);
}


/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */ /**
 * @param {string} value
 * @returns {string}
 */ function $14d0b9aa894028a1$export$a3295358bff77e(value) {
    return value.toLowerCase();
}



class $528803c1a3e38a4a$export$c4868e4a24d48fad {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */ constructor(property, attribute){
        /** @type {string} */ this.property = property;
        /** @type {string} */ this.attribute = attribute;
    }
}
/** @type {string|null} */ $528803c1a3e38a4a$export$c4868e4a24d48fad.prototype.space = null;
$528803c1a3e38a4a$export$c4868e4a24d48fad.prototype.boolean = false;
$528803c1a3e38a4a$export$c4868e4a24d48fad.prototype.booleanish = false;
$528803c1a3e38a4a$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$528803c1a3e38a4a$export$c4868e4a24d48fad.prototype.number = false;
$528803c1a3e38a4a$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$528803c1a3e38a4a$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$528803c1a3e38a4a$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$528803c1a3e38a4a$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$528803c1a3e38a4a$export$c4868e4a24d48fad.prototype.defined = false;


var $bc3b95fa1e4a6dee$exports = {};

$parcel$export($bc3b95fa1e4a6dee$exports, "boolean", function () { return $bc3b95fa1e4a6dee$export$4a21f16c33752377; });
$parcel$export($bc3b95fa1e4a6dee$exports, "booleanish", function () { return $bc3b95fa1e4a6dee$export$55e9e1fbc638dc8f; });
$parcel$export($bc3b95fa1e4a6dee$exports, "overloadedBoolean", function () { return $bc3b95fa1e4a6dee$export$242ac3d3042558aa; });
$parcel$export($bc3b95fa1e4a6dee$exports, "number", function () { return $bc3b95fa1e4a6dee$export$98e628dec113755e; });
$parcel$export($bc3b95fa1e4a6dee$exports, "spaceSeparated", function () { return $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e; });
$parcel$export($bc3b95fa1e4a6dee$exports, "commaSeparated", function () { return $bc3b95fa1e4a6dee$export$9c8d678629b3d3; });
$parcel$export($bc3b95fa1e4a6dee$exports, "commaOrSpaceSeparated", function () { return $bc3b95fa1e4a6dee$export$2ad25cfebf36cacd; });
let $bc3b95fa1e4a6dee$var$powers = 0;
const $bc3b95fa1e4a6dee$export$4a21f16c33752377 = $bc3b95fa1e4a6dee$var$increment();
const $bc3b95fa1e4a6dee$export$55e9e1fbc638dc8f = $bc3b95fa1e4a6dee$var$increment();
const $bc3b95fa1e4a6dee$export$242ac3d3042558aa = $bc3b95fa1e4a6dee$var$increment();
const $bc3b95fa1e4a6dee$export$98e628dec113755e = $bc3b95fa1e4a6dee$var$increment();
const $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e = $bc3b95fa1e4a6dee$var$increment();
const $bc3b95fa1e4a6dee$export$9c8d678629b3d3 = $bc3b95fa1e4a6dee$var$increment();
const $bc3b95fa1e4a6dee$export$2ad25cfebf36cacd = $bc3b95fa1e4a6dee$var$increment();
function $bc3b95fa1e4a6dee$var$increment() {
    return 2 ** ++$bc3b95fa1e4a6dee$var$powers;
}


/** @type {Array<keyof types>} */ // @ts-expect-error: hush.
const $0cf5934637829c32$var$checks = Object.keys($bc3b95fa1e4a6dee$exports);
class $0cf5934637829c32$export$ea6b9f0064e88c9b extends (0, $528803c1a3e38a4a$export$c4868e4a24d48fad) {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $0cf5934637829c32$var$mark(this, 'space', space);
        if (typeof mask === 'number') while(++index < $0cf5934637829c32$var$checks.length){
            const check = $0cf5934637829c32$var$checks[index];
            $0cf5934637829c32$var$mark(this, $0cf5934637829c32$var$checks[index], (mask & $bc3b95fa1e4a6dee$exports[check]) === $bc3b95fa1e4a6dee$exports[check]);
        }
    }
}
$0cf5934637829c32$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */ function $0cf5934637829c32$var$mark(values, key, value) {
    if (value) // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value;
}


const $486575ff30a45b78$var$own = {}.hasOwnProperty;
function $486575ff30a45b78$export$185802fd694ee1f5(definition) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    /** @type {string} */ let prop;
    for(prop in definition.properties)if ($486575ff30a45b78$var$own.call(definition.properties, prop)) {
        const value = definition.properties[prop];
        const info = new (0, $0cf5934637829c32$export$ea6b9f0064e88c9b)(prop, definition.transform(definition.attributes || {}, prop), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(prop)) info.mustUseProperty = true;
        property[prop] = info;
        normal[(0, $14d0b9aa894028a1$export$a3295358bff77e)(prop)] = prop;
        normal[(0, $14d0b9aa894028a1$export$a3295358bff77e)(info.attribute)] = prop;
    }
    return new (0, $a31514946fcac663$export$19342e026b58ebb7)(property, normal, definition.space);
}


const $648837b050af91fa$export$2bd1230ec7600845 = (0, $486575ff30a45b78$export$185802fd694ee1f5)({
    space: 'xlink',
    transform (_, prop) {
        return 'xlink:' + prop.slice(5).toLowerCase();
    },
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});



const $a5c40d8585d265ea$export$f2913fe8983302e = (0, $486575ff30a45b78$export$185802fd694ee1f5)({
    space: 'xml',
    transform (_, prop) {
        return 'xml:' + prop.slice(3).toLowerCase();
    },
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});



/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */ function $26a27b5723abe188$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


function $206037540ec46805$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $26a27b5723abe188$export$5b10b3bc32d7efbc)(attributes, property.toLowerCase());
}


const $19bba8142f0a17fa$export$e20c24a128671213 = (0, $486575ff30a45b78$export$185802fd694ee1f5)({
    space: 'xmlns',
    attributes: {
        xmlnsxlink: 'xmlns:xlink'
    },
    transform: (0, $206037540ec46805$export$32b9e4cec9c208e1),
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});




const $26be82b42d10fb3d$export$4d2d26490572750a = (0, $486575ff30a45b78$export$185802fd694ee1f5)({
    transform (_, prop) {
        return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase();
    },
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $bc3b95fa1e4a6dee$export$55e9e1fbc638dc8f),
        ariaAutoComplete: null,
        ariaBusy: (0, $bc3b95fa1e4a6dee$export$55e9e1fbc638dc8f),
        ariaChecked: (0, $bc3b95fa1e4a6dee$export$55e9e1fbc638dc8f),
        ariaColCount: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        ariaColIndex: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        ariaColSpan: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        ariaControls: (0, $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e),
        ariaCurrent: null,
        ariaDescribedBy: (0, $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e),
        ariaDetails: null,
        ariaDisabled: (0, $bc3b95fa1e4a6dee$export$55e9e1fbc638dc8f),
        ariaDropEffect: (0, $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e),
        ariaErrorMessage: null,
        ariaExpanded: (0, $bc3b95fa1e4a6dee$export$55e9e1fbc638dc8f),
        ariaFlowTo: (0, $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e),
        ariaGrabbed: (0, $bc3b95fa1e4a6dee$export$55e9e1fbc638dc8f),
        ariaHasPopup: null,
        ariaHidden: (0, $bc3b95fa1e4a6dee$export$55e9e1fbc638dc8f),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e),
        ariaLevel: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        ariaLive: null,
        ariaModal: (0, $bc3b95fa1e4a6dee$export$55e9e1fbc638dc8f),
        ariaMultiLine: (0, $bc3b95fa1e4a6dee$export$55e9e1fbc638dc8f),
        ariaMultiSelectable: (0, $bc3b95fa1e4a6dee$export$55e9e1fbc638dc8f),
        ariaOrientation: null,
        ariaOwns: (0, $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        ariaPressed: (0, $bc3b95fa1e4a6dee$export$55e9e1fbc638dc8f),
        ariaReadOnly: (0, $bc3b95fa1e4a6dee$export$55e9e1fbc638dc8f),
        ariaRelevant: null,
        ariaRequired: (0, $bc3b95fa1e4a6dee$export$55e9e1fbc638dc8f),
        ariaRoleDescription: (0, $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e),
        ariaRowCount: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        ariaRowIndex: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        ariaRowSpan: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        ariaSelected: (0, $bc3b95fa1e4a6dee$export$55e9e1fbc638dc8f),
        ariaSetSize: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        ariaSort: null,
        ariaValueMax: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        ariaValueMin: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        ariaValueNow: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        ariaValueText: null,
        role: null
    }
});





const $fa685b810208dd5f$export$c0bb0b647f701bb5 = (0, $486575ff30a45b78$export$185802fd694ee1f5)({
    space: 'html',
    attributes: {
        acceptcharset: 'accept-charset',
        classname: 'class',
        htmlfor: 'for',
        httpequiv: 'http-equiv'
    },
    transform: (0, $206037540ec46805$export$32b9e4cec9c208e1),
    mustUseProperty: [
        'checked',
        'multiple',
        'muted',
        'selected'
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $bc3b95fa1e4a6dee$export$9c8d678629b3d3),
        acceptCharset: (0, $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e),
        accessKey: (0, $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e),
        action: null,
        allow: null,
        allowFullScreen: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        allowPaymentRequest: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        allowUserMedia: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        alt: null,
        as: null,
        async: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        autoCapitalize: null,
        autoComplete: (0, $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e),
        autoFocus: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        autoPlay: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        blocking: (0, $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e),
        capture: null,
        charSet: null,
        checked: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        cite: null,
        className: (0, $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e),
        cols: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        colSpan: null,
        content: null,
        contentEditable: (0, $bc3b95fa1e4a6dee$export$55e9e1fbc638dc8f),
        controls: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        controlsList: (0, $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e),
        coords: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e) | (0, $bc3b95fa1e4a6dee$export$9c8d678629b3d3),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        defer: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        dir: null,
        dirName: null,
        disabled: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        download: (0, $bc3b95fa1e4a6dee$export$242ac3d3042558aa),
        draggable: (0, $bc3b95fa1e4a6dee$export$55e9e1fbc638dc8f),
        encType: null,
        enterKeyHint: null,
        fetchPriority: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        formTarget: null,
        headers: (0, $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e),
        height: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        hidden: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        high: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        href: null,
        hrefLang: null,
        htmlFor: (0, $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e),
        httpEquiv: (0, $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inert: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        itemId: null,
        itemProp: (0, $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e),
        itemRef: (0, $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e),
        itemScope: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        itemType: (0, $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        low: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        manifest: null,
        max: null,
        maxLength: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        media: null,
        method: null,
        min: null,
        minLength: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        multiple: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        muted: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        name: null,
        nonce: null,
        noModule: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        noValidate: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeToggle: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        optimum: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        pattern: null,
        ping: (0, $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e),
        placeholder: null,
        playsInline: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        popover: null,
        popoverTarget: null,
        popoverTargetAction: null,
        poster: null,
        preload: null,
        readOnly: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        referrerPolicy: null,
        rel: (0, $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e),
        required: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        reversed: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        rows: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        rowSpan: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        sandbox: (0, $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e),
        scope: null,
        scoped: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        seamless: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        selected: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        shadowRootClonable: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        shadowRootDelegatesFocus: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        shadowRootMode: null,
        shape: null,
        size: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        sizes: null,
        slot: null,
        span: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        spellCheck: (0, $bc3b95fa1e4a6dee$export$55e9e1fbc638dc8f),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        step: null,
        style: null,
        tabIndex: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        useMap: null,
        value: (0, $bc3b95fa1e4a6dee$export$55e9e1fbc638dc8f),
        width: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        wrap: null,
        writingSuggestions: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        borderColor: null,
        bottomMargin: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        declare: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        leftMargin: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        marginWidth: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        noResize: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        noHref: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        noShade: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        noWrap: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        rules: null,
        scheme: null,
        scrolling: (0, $bc3b95fa1e4a6dee$export$55e9e1fbc638dc8f),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        disableRemotePlayback: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        prefix: null,
        property: null,
        results: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        security: null,
        unselectable: null
    }
});





const $bc582816bd96d8f1$export$7ed1367e7fa1ad68 = (0, $486575ff30a45b78$export$185802fd694ee1f5)({
    space: 'svg',
    attributes: {
        accentHeight: 'accent-height',
        alignmentBaseline: 'alignment-baseline',
        arabicForm: 'arabic-form',
        baselineShift: 'baseline-shift',
        capHeight: 'cap-height',
        className: 'class',
        clipPath: 'clip-path',
        clipRule: 'clip-rule',
        colorInterpolation: 'color-interpolation',
        colorInterpolationFilters: 'color-interpolation-filters',
        colorProfile: 'color-profile',
        colorRendering: 'color-rendering',
        crossOrigin: 'crossorigin',
        dataType: 'datatype',
        dominantBaseline: 'dominant-baseline',
        enableBackground: 'enable-background',
        fillOpacity: 'fill-opacity',
        fillRule: 'fill-rule',
        floodColor: 'flood-color',
        floodOpacity: 'flood-opacity',
        fontFamily: 'font-family',
        fontSize: 'font-size',
        fontSizeAdjust: 'font-size-adjust',
        fontStretch: 'font-stretch',
        fontStyle: 'font-style',
        fontVariant: 'font-variant',
        fontWeight: 'font-weight',
        glyphName: 'glyph-name',
        glyphOrientationHorizontal: 'glyph-orientation-horizontal',
        glyphOrientationVertical: 'glyph-orientation-vertical',
        hrefLang: 'hreflang',
        horizAdvX: 'horiz-adv-x',
        horizOriginX: 'horiz-origin-x',
        horizOriginY: 'horiz-origin-y',
        imageRendering: 'image-rendering',
        letterSpacing: 'letter-spacing',
        lightingColor: 'lighting-color',
        markerEnd: 'marker-end',
        markerMid: 'marker-mid',
        markerStart: 'marker-start',
        navDown: 'nav-down',
        navDownLeft: 'nav-down-left',
        navDownRight: 'nav-down-right',
        navLeft: 'nav-left',
        navNext: 'nav-next',
        navPrev: 'nav-prev',
        navRight: 'nav-right',
        navUp: 'nav-up',
        navUpLeft: 'nav-up-left',
        navUpRight: 'nav-up-right',
        onAbort: 'onabort',
        onActivate: 'onactivate',
        onAfterPrint: 'onafterprint',
        onBeforePrint: 'onbeforeprint',
        onBegin: 'onbegin',
        onCancel: 'oncancel',
        onCanPlay: 'oncanplay',
        onCanPlayThrough: 'oncanplaythrough',
        onChange: 'onchange',
        onClick: 'onclick',
        onClose: 'onclose',
        onCopy: 'oncopy',
        onCueChange: 'oncuechange',
        onCut: 'oncut',
        onDblClick: 'ondblclick',
        onDrag: 'ondrag',
        onDragEnd: 'ondragend',
        onDragEnter: 'ondragenter',
        onDragExit: 'ondragexit',
        onDragLeave: 'ondragleave',
        onDragOver: 'ondragover',
        onDragStart: 'ondragstart',
        onDrop: 'ondrop',
        onDurationChange: 'ondurationchange',
        onEmptied: 'onemptied',
        onEnd: 'onend',
        onEnded: 'onended',
        onError: 'onerror',
        onFocus: 'onfocus',
        onFocusIn: 'onfocusin',
        onFocusOut: 'onfocusout',
        onHashChange: 'onhashchange',
        onInput: 'oninput',
        onInvalid: 'oninvalid',
        onKeyDown: 'onkeydown',
        onKeyPress: 'onkeypress',
        onKeyUp: 'onkeyup',
        onLoad: 'onload',
        onLoadedData: 'onloadeddata',
        onLoadedMetadata: 'onloadedmetadata',
        onLoadStart: 'onloadstart',
        onMessage: 'onmessage',
        onMouseDown: 'onmousedown',
        onMouseEnter: 'onmouseenter',
        onMouseLeave: 'onmouseleave',
        onMouseMove: 'onmousemove',
        onMouseOut: 'onmouseout',
        onMouseOver: 'onmouseover',
        onMouseUp: 'onmouseup',
        onMouseWheel: 'onmousewheel',
        onOffline: 'onoffline',
        onOnline: 'ononline',
        onPageHide: 'onpagehide',
        onPageShow: 'onpageshow',
        onPaste: 'onpaste',
        onPause: 'onpause',
        onPlay: 'onplay',
        onPlaying: 'onplaying',
        onPopState: 'onpopstate',
        onProgress: 'onprogress',
        onRateChange: 'onratechange',
        onRepeat: 'onrepeat',
        onReset: 'onreset',
        onResize: 'onresize',
        onScroll: 'onscroll',
        onSeeked: 'onseeked',
        onSeeking: 'onseeking',
        onSelect: 'onselect',
        onShow: 'onshow',
        onStalled: 'onstalled',
        onStorage: 'onstorage',
        onSubmit: 'onsubmit',
        onSuspend: 'onsuspend',
        onTimeUpdate: 'ontimeupdate',
        onToggle: 'ontoggle',
        onUnload: 'onunload',
        onVolumeChange: 'onvolumechange',
        onWaiting: 'onwaiting',
        onZoom: 'onzoom',
        overlinePosition: 'overline-position',
        overlineThickness: 'overline-thickness',
        paintOrder: 'paint-order',
        panose1: 'panose-1',
        pointerEvents: 'pointer-events',
        referrerPolicy: 'referrerpolicy',
        renderingIntent: 'rendering-intent',
        shapeRendering: 'shape-rendering',
        stopColor: 'stop-color',
        stopOpacity: 'stop-opacity',
        strikethroughPosition: 'strikethrough-position',
        strikethroughThickness: 'strikethrough-thickness',
        strokeDashArray: 'stroke-dasharray',
        strokeDashOffset: 'stroke-dashoffset',
        strokeLineCap: 'stroke-linecap',
        strokeLineJoin: 'stroke-linejoin',
        strokeMiterLimit: 'stroke-miterlimit',
        strokeOpacity: 'stroke-opacity',
        strokeWidth: 'stroke-width',
        tabIndex: 'tabindex',
        textAnchor: 'text-anchor',
        textDecoration: 'text-decoration',
        textRendering: 'text-rendering',
        transformOrigin: 'transform-origin',
        typeOf: 'typeof',
        underlinePosition: 'underline-position',
        underlineThickness: 'underline-thickness',
        unicodeBidi: 'unicode-bidi',
        unicodeRange: 'unicode-range',
        unitsPerEm: 'units-per-em',
        vAlphabetic: 'v-alphabetic',
        vHanging: 'v-hanging',
        vIdeographic: 'v-ideographic',
        vMathematical: 'v-mathematical',
        vectorEffect: 'vector-effect',
        vertAdvY: 'vert-adv-y',
        vertOriginX: 'vert-origin-x',
        vertOriginY: 'vert-origin-y',
        wordSpacing: 'word-spacing',
        writingMode: 'writing-mode',
        xHeight: 'x-height',
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: 'playbackorder',
        timelineBegin: 'timelinebegin'
    },
    transform: (0, $26a27b5723abe188$export$5b10b3bc32d7efbc),
    properties: {
        about: (0, $bc3b95fa1e4a6dee$export$2ad25cfebf36cacd),
        accentHeight: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        amplitude: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        arabicForm: null,
        ascent: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        by: null,
        calcMode: null,
        capHeight: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        className: (0, $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        diffuseConstant: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        dominantBaseline: null,
        download: (0, $bc3b95fa1e4a6dee$export$4a21f16c33752377),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $bc3b95fa1e4a6dee$export$9c8d678629b3d3),
        g2: (0, $bc3b95fa1e4a6dee$export$9c8d678629b3d3),
        glyphName: (0, $bc3b95fa1e4a6dee$export$9c8d678629b3d3),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        horizOriginX: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        horizOriginY: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        id: null,
        ideographic: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        k: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        k1: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        k2: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        k3: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        k4: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        kernelMatrix: (0, $bc3b95fa1e4a6dee$export$2ad25cfebf36cacd),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        overlineThickness: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $bc3b95fa1e4a6dee$export$ab8645c862eb5a3e),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        pointsAtY: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        pointsAtZ: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $bc3b95fa1e4a6dee$export$2ad25cfebf36cacd),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $bc3b95fa1e4a6dee$export$2ad25cfebf36cacd),
        rev: (0, $bc3b95fa1e4a6dee$export$2ad25cfebf36cacd),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $bc3b95fa1e4a6dee$export$2ad25cfebf36cacd),
        requiredFeatures: (0, $bc3b95fa1e4a6dee$export$2ad25cfebf36cacd),
        requiredFonts: (0, $bc3b95fa1e4a6dee$export$2ad25cfebf36cacd),
        requiredFormats: (0, $bc3b95fa1e4a6dee$export$2ad25cfebf36cacd),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        specularExponent: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        strikethroughThickness: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        string: null,
        stroke: null,
        strokeDashArray: (0, $bc3b95fa1e4a6dee$export$2ad25cfebf36cacd),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        strokeOpacity: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $bc3b95fa1e4a6dee$export$2ad25cfebf36cacd),
        tabIndex: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        tableValues: null,
        target: null,
        targetX: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        targetY: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $bc3b95fa1e4a6dee$export$2ad25cfebf36cacd),
        to: null,
        transform: null,
        transformOrigin: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        underlineThickness: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        values: null,
        vAlphabetic: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        vMathematical: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        vectorEffect: null,
        vHanging: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        vIdeographic: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        version: null,
        vertAdvY: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        vertOriginX: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        vertOriginY: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $bc3b95fa1e4a6dee$export$98e628dec113755e),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    }
});


/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */ 


const $f368bade99c57d16$var$valid = /^data[-\w.:]+$/i;
const $f368bade99c57d16$var$dash = /-[a-z]/g;
const $f368bade99c57d16$var$cap = /[A-Z]/g;
function $f368bade99c57d16$export$71aa6c912b956294(schema, value) {
    const normal = (0, $14d0b9aa894028a1$export$a3295358bff77e)(value);
    let prop = value;
    let Type = (0, $528803c1a3e38a4a$export$c4868e4a24d48fad);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === 'data' && $f368bade99c57d16$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === '-') {
            // Turn it into a property.
            const rest = value.slice(5).replace($f368bade99c57d16$var$dash, $f368bade99c57d16$var$camelcase);
            prop = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$f368bade99c57d16$var$dash.test(rest)) {
                let dashes = rest.replace($f368bade99c57d16$var$cap, $f368bade99c57d16$var$kebab);
                if (dashes.charAt(0) !== '-') dashes = '-' + dashes;
                value = 'data' + dashes;
            }
        }
        Type = (0, $0cf5934637829c32$export$ea6b9f0064e88c9b);
    }
    return new Type(prop, value);
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $f368bade99c57d16$var$kebab($0) {
    return '-' + $0.toLowerCase();
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $f368bade99c57d16$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}




const $94e20929a3cc0a72$export$c0bb0b647f701bb5 = (0, $0007f1b04b92e296$export$4950aa0f605343fb)([
    (0, $a5c40d8585d265ea$export$f2913fe8983302e),
    (0, $648837b050af91fa$export$2bd1230ec7600845),
    (0, $19bba8142f0a17fa$export$e20c24a128671213),
    (0, $26be82b42d10fb3d$export$4d2d26490572750a),
    (0, $fa685b810208dd5f$export$c0bb0b647f701bb5)
], 'html');
const $94e20929a3cc0a72$export$7ed1367e7fa1ad68 = (0, $0007f1b04b92e296$export$4950aa0f605343fb)([
    (0, $a5c40d8585d265ea$export$f2913fe8983302e),
    (0, $648837b050af91fa$export$2bd1230ec7600845),
    (0, $19bba8142f0a17fa$export$e20c24a128671213),
    (0, $26be82b42d10fb3d$export$4d2d26490572750a),
    (0, $bc582816bd96d8f1$export$7ed1367e7fa1ad68)
], 'svg');


/**
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Content} Content
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('property-information').Info} Info
 * @typedef {import('property-information').Schema} Schema
 */ /**
 * @typedef {Content | Root} Node
 *   Any concrete `hast` node.
 * @typedef {Root | Element} HResult
 *   Result from a `h` (or `s`) call.
 *
 * @typedef {string | number} HStyleValue
 *   Value for a CSS style field.
 * @typedef {Record<string, HStyleValue>} HStyle
 *   Supported value of a `style` prop.
 * @typedef {string | number | boolean | null | undefined} HPrimitiveValue
 *   Primitive property value.
 * @typedef {Array<string | number>} HArrayValue
 *   List of property values for space- or comma separated values (such as `className`).
 * @typedef {HPrimitiveValue | HArrayValue} HPropertyValue
 *   Primitive value or list value.
 * @typedef {{[property: string]: HPropertyValue | HStyle}} HProperties
 *   Acceptable value for element properties.
 *
 * @typedef {string | number | null | undefined} HPrimitiveChild
 *   Primitive children, either ignored (nullish), or turned into text nodes.
 * @typedef {Array<Node | HPrimitiveChild>} HArrayChild
 *   List of children.
 * @typedef {Node | HPrimitiveChild | HArrayChild} HChild
 *   Acceptable child value.
 */ 
/**
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Element} Element
 */ const $550e9d8ffcc7f985$var$search = /[#.]/g;
function $550e9d8ffcc7f985$export$529769e360e2fa1b(selector, defaultTagName) {
    const value = selector || '';
    /** @type {Properties} */ const props = {};
    let start = 0;
    /** @type {string | undefined} */ let previous;
    /** @type {string | undefined} */ let tagName;
    while(start < value.length){
        $550e9d8ffcc7f985$var$search.lastIndex = start;
        const match = $550e9d8ffcc7f985$var$search.exec(value);
        const subvalue = value.slice(start, match ? match.index : value.length);
        if (subvalue) {
            if (!previous) tagName = subvalue;
            else if (previous === '#') props.id = subvalue;
            else if (Array.isArray(props.className)) props.className.push(subvalue);
            else props.className = [
                subvalue
            ];
            start += subvalue.length;
        }
        if (match) {
            previous = match[0];
            start++;
        }
    }
    return {
        type: 'element',
        // @ts-expect-error: fine.
        tagName: tagName || defaultTagName || 'div',
        properties: props,
        children: []
    };
}




const $e582407e51b063c1$var$buttonTypes = new Set([
    'menu',
    'submit',
    'reset',
    'button'
]);
const $e582407e51b063c1$var$own = {}.hasOwnProperty;
function $e582407e51b063c1$export$b75f8c4f8f3fbd14(schema, defaultTagName, caseSensitive) {
    const adjust = caseSensitive && $e582407e51b063c1$var$createAdjustMap(caseSensitive);
    const h = /**
     * @type {{
     *   (): Root
     *   (selector: null | undefined, ...children: Array<HChild>): Root
     *   (selector: string, properties?: HProperties, ...children: Array<HChild>): Element
     *   (selector: string, ...children: Array<HChild>): Element
     * }}
     */ /**
       * Hyperscript compatible DSL for creating virtual hast trees.
       *
       * @param {string | null} [selector]
       * @param {HProperties | HChild} [properties]
       * @param {Array<HChild>} children
       * @returns {HResult}
       */ function(selector, properties, ...children) {
        let index = -1;
        /** @type {HResult} */ let node;
        if (selector === undefined || selector === null) {
            node = {
                type: 'root',
                children: []
            };
            // @ts-expect-error Properties are not supported for roots.
            children.unshift(properties);
        } else {
            node = (0, $550e9d8ffcc7f985$export$529769e360e2fa1b)(selector, defaultTagName);
            // Normalize the name.
            node.tagName = node.tagName.toLowerCase();
            if (adjust && $e582407e51b063c1$var$own.call(adjust, node.tagName)) node.tagName = adjust[node.tagName];
            // Handle props.
            if ($e582407e51b063c1$var$isProperties(properties, node.tagName)) {
                /** @type {string} */ let key;
                for(key in properties)if ($e582407e51b063c1$var$own.call(properties, key)) // @ts-expect-error `node.properties` is set.
                $e582407e51b063c1$var$addProperty(schema, node.properties, key, properties[key]);
            } else children.unshift(properties);
        }
        // Handle children.
        while(++index < children.length)$e582407e51b063c1$var$addChild(node.children, children[index]);
        if (node.type === 'element' && node.tagName === 'template') {
            node.content = {
                type: 'root',
                children: node.children
            };
            node.children = [];
        }
        return node;
    };
    return h;
}
/**
 * @param {HProperties | HChild} value
 * @param {string} name
 * @returns {value is HProperties}
 */ function $e582407e51b063c1$var$isProperties(value, name) {
    if (value === null || value === undefined || typeof value !== 'object' || Array.isArray(value)) return false;
    if (name === 'input' || !value.type || typeof value.type !== 'string') return true;
    if ('children' in value && Array.isArray(value.children)) return false;
    if (name === 'button') return $e582407e51b063c1$var$buttonTypes.has(value.type.toLowerCase());
    return !('value' in value);
}
/**
 * @param {Schema} schema
 * @param {Properties} properties
 * @param {string} key
 * @param {HStyle | HPropertyValue} value
 * @returns {void}
 */ function $e582407e51b063c1$var$addProperty(schema, properties, key, value) {
    const info = (0, $f368bade99c57d16$export$71aa6c912b956294)(schema, key);
    let index = -1;
    /** @type {HPropertyValue} */ let result;
    // Ignore nullish and NaN values.
    if (value === undefined || value === null) return;
    if (typeof value === 'number') {
        // Ignore NaN.
        if (Number.isNaN(value)) return;
        result = value;
    } else if (typeof value === 'boolean') result = value;
    else if (typeof value === 'string') {
        if (info.spaceSeparated) result = (0, $0d98344a9bfa0653$export$98e6a39c04603d36)(value);
        else if (info.commaSeparated) result = (0, $9323934601145f2e$export$98e6a39c04603d36)(value);
        else if (info.commaOrSpaceSeparated) result = (0, $0d98344a9bfa0653$export$98e6a39c04603d36)((0, $9323934601145f2e$export$98e6a39c04603d36)(value).join(' '));
        else result = $e582407e51b063c1$var$parsePrimitive(info, info.property, value);
    } else if (Array.isArray(value)) result = value.concat();
    else result = info.property === 'style' ? $e582407e51b063c1$var$style(value) : String(value);
    if (Array.isArray(result)) {
        /** @type {Array<string | number>} */ const finalResult = [];
        while(++index < result.length)// @ts-expect-error Assume no booleans in array.
        finalResult[index] = $e582407e51b063c1$var$parsePrimitive(info, info.property, result[index]);
        result = finalResult;
    }
    // Class names (which can be added both on the `selector` and here).
    if (info.property === 'className' && Array.isArray(properties.className)) // @ts-expect-error Assume no booleans in `className`.
    result = properties.className.concat(result);
    properties[info.property] = result;
}
/**
 * @param {Array<Content>} nodes
 * @param {HChild} value
 * @returns {void}
 */ function $e582407e51b063c1$var$addChild(nodes, value) {
    let index = -1;
    if (value === undefined || value === null) ;
    else if (typeof value === 'string' || typeof value === 'number') nodes.push({
        type: 'text',
        value: String(value)
    });
    else if (Array.isArray(value)) while(++index < value.length)$e582407e51b063c1$var$addChild(nodes, value[index]);
    else if (typeof value === 'object' && 'type' in value) {
        if (value.type === 'root') $e582407e51b063c1$var$addChild(nodes, value.children);
        else nodes.push(value);
    } else throw new Error('Expected node, nodes, or string, got `' + value + '`');
}
/**
 * Parse a single primitives.
 *
 * @param {Info} info
 * @param {string} name
 * @param {HPrimitiveValue} value
 * @returns {HPrimitiveValue}
 */ function $e582407e51b063c1$var$parsePrimitive(info, name, value) {
    if (typeof value === 'string') {
        if (info.number && value && !Number.isNaN(Number(value))) return Number(value);
        if ((info.boolean || info.overloadedBoolean) && (value === '' || (0, $14d0b9aa894028a1$export$a3295358bff77e)(value) === (0, $14d0b9aa894028a1$export$a3295358bff77e)(name))) return true;
    }
    return value;
}
/**
 * Serialize a `style` object as a string.
 *
 * @param {HStyle} value
 *   Style object.
 * @returns {string}
 *   CSS string.
 */ function $e582407e51b063c1$var$style(value) {
    /** @type {Array<string>} */ const result = [];
    /** @type {string} */ let key;
    for(key in value)if ($e582407e51b063c1$var$own.call(value, key)) result.push([
        key,
        value[key]
    ].join(': '));
    return result.join('; ');
}
/**
 * Create a map to adjust casing.
 *
 * @param {Array<string>} values
 *   List of properly cased keys.
 * @returns {Record<string, string>}
 *   Map of lowercase keys to uppercase keys.
 */ function $e582407e51b063c1$var$createAdjustMap(values) {
    /** @type {Record<string, string>} */ const result = {};
    let index = -1;
    while(++index < values.length)result[values[index].toLowerCase()] = values[index];
    return result;
}


const $a48d0632a475a570$export$dda1d9f60106f0e9 = (0, $e582407e51b063c1$export$b75f8c4f8f3fbd14)((0, $94e20929a3cc0a72$export$c0bb0b647f701bb5), 'div');


/**
 * @import {Point} from 'unist'
 * @import {Options} from '../index.js'
 */ /**
 * List of legacy HTML named character references that don’t need a trailing semicolon.
 *
 * @type {Array<string>}
 */ const $9d441a8e4486a83e$export$9545335bdecb4b8c = [
    'AElig',
    'AMP',
    'Aacute',
    'Acirc',
    'Agrave',
    'Aring',
    'Atilde',
    'Auml',
    'COPY',
    'Ccedil',
    'ETH',
    'Eacute',
    'Ecirc',
    'Egrave',
    'Euml',
    'GT',
    'Iacute',
    'Icirc',
    'Igrave',
    'Iuml',
    'LT',
    'Ntilde',
    'Oacute',
    'Ocirc',
    'Ograve',
    'Oslash',
    'Otilde',
    'Ouml',
    'QUOT',
    'REG',
    'THORN',
    'Uacute',
    'Ucirc',
    'Ugrave',
    'Uuml',
    'Yacute',
    'aacute',
    'acirc',
    'acute',
    'aelig',
    'agrave',
    'amp',
    'aring',
    'atilde',
    'auml',
    'brvbar',
    'ccedil',
    'cedil',
    'cent',
    'copy',
    'curren',
    'deg',
    'divide',
    'eacute',
    'ecirc',
    'egrave',
    'eth',
    'euml',
    'frac12',
    'frac14',
    'frac34',
    'gt',
    'iacute',
    'icirc',
    'iexcl',
    'igrave',
    'iquest',
    'iuml',
    'laquo',
    'lt',
    'macr',
    'micro',
    'middot',
    'nbsp',
    'not',
    'ntilde',
    'oacute',
    'ocirc',
    'ograve',
    'ordf',
    'ordm',
    'oslash',
    'otilde',
    'ouml',
    'para',
    'plusmn',
    'pound',
    'quot',
    'raquo',
    'reg',
    'sect',
    'shy',
    'sup1',
    'sup2',
    'sup3',
    'szlig',
    'thorn',
    'times',
    'uacute',
    'ucirc',
    'ugrave',
    'uml',
    'uuml',
    'yacute',
    'yen',
    'yuml'
];


/**
 * Map of invalid numeric character references to their replacements, according to HTML.
 *
 * @type {Record<number, string>}
 */ const $922953b77e46a921$export$18e663c9b25e3b2 = {
    0: "\uFFFD",
    128: "\u20AC",
    130: "\u201A",
    131: "\u0192",
    132: "\u201E",
    133: "\u2026",
    134: "\u2020",
    135: "\u2021",
    136: "\u02C6",
    137: "\u2030",
    138: "\u0160",
    139: "\u2039",
    140: "\u0152",
    142: "\u017D",
    145: "\u2018",
    146: "\u2019",
    147: "\u201C",
    148: "\u201D",
    149: "\u2022",
    150: "\u2013",
    151: "\u2014",
    152: "\u02DC",
    153: "\u2122",
    154: "\u0161",
    155: "\u203A",
    156: "\u0153",
    158: "\u017E",
    159: "\u0178"
};


/**
 * Check if the given character code, or the character code at the first
 * character, is decimal.
 *
 * @param {string|number} character
 * @returns {boolean} Whether `character` is a decimal
 */ function $be23405d8147b49a$export$2ad0182371401ea4(character) {
    const code = typeof character === 'string' ? character.charCodeAt(0) : character;
    return code >= 48 && code <= 57 /* 0-9 */ ;
}


/**
 * Check if the given character code, or the character code at the first
 * character, is hexadecimal.
 *
 * @param {string|number} character
 * @returns {boolean} Whether `character` is hexadecimal
 */ function $4ccc8a5f535bff43$export$8ec2d91f756e9f4(character) {
    const code = typeof character === 'string' ? character.charCodeAt(0) : character;
    return code >= 97 /* a */  && code <= 102 || code >= 65 /* A */  && code <= 70 || code >= 48 /* A */  && code <= 57;
}


/**
 * Check if the given character code, or the character code at the first
 * character, is alphabetical.
 *
 * @param {string|number} character
 * @returns {boolean} Whether `character` is alphabetical.
 */ function $cae77ff8c527c2d9$export$1e381e1de5ace8e(character) {
    const code = typeof character === 'string' ? character.charCodeAt(0) : character;
    return code >= 97 && code <= 122 || code >= 65 && code <= 90;
}



function $7b67d5966946bfd3$export$176ed353558777b8(character) {
    return (0, $cae77ff8c527c2d9$export$1e381e1de5ace8e)(character) || (0, $be23405d8147b49a$export$2ad0182371401ea4)(character);
}



// Warning messages.
const $fe979033c71e7672$var$messages = [
    '',
    /* 1: Non terminated (named) */ 'Named character references must be terminated by a semicolon',
    /* 2: Non terminated (numeric) */ 'Numeric character references must be terminated by a semicolon',
    /* 3: Empty (named) */ 'Named character references cannot be empty',
    /* 4: Empty (numeric) */ 'Numeric character references cannot be empty',
    /* 5: Unknown (named) */ 'Named character references must be known',
    /* 6: Disallowed (numeric) */ 'Numeric character references cannot be disallowed',
    /* 7: Prohibited (numeric) */ 'Numeric character references cannot be outside the permissible Unicode range'
];
function $fe979033c71e7672$export$6c6c782be925911c(value, options) {
    const settings = options || {};
    const additional = typeof settings.additional === 'string' ? settings.additional.charCodeAt(0) : settings.additional;
    /** @type {Array<string>} */ const result = [];
    let index = 0;
    let lines = -1;
    let queue = '';
    /** @type {Point | undefined} */ let point;
    /** @type {Array<number>|undefined} */ let indent;
    if (settings.position) {
        if ('start' in settings.position || 'indent' in settings.position) {
            // @ts-expect-error: points don’t have indent.
            indent = settings.position.indent;
            // @ts-expect-error: points don’t have indent.
            point = settings.position.start;
        } else point = settings.position;
    }
    let line = (point ? point.line : 0) || 1;
    let column = (point ? point.column : 0) || 1;
    // Cache the current point.
    let previous = now();
    /** @type {number|undefined} */ let character;
    // Ensure the algorithm walks over the first character (inclusive).
    index--;
    while(++index <= value.length){
        // If the previous character was a newline.
        if (character === 10 /* `\n` */ ) column = (indent ? indent[lines] : 0) || 1;
        character = value.charCodeAt(index);
        if (character === 38 /* `&` */ ) {
            const following = value.charCodeAt(index + 1);
            // The behavior depends on the identity of the next character.
            if (following === 9 /* `\t` */  || following === 10 /* `\n` */  || following === 12 /* `\f` */  || following === 32 /* ` ` */  || following === 38 /* `&` */  || following === 60 /* `<` */  || Number.isNaN(following) || additional && following === additional) {
                // Not a character reference.
                // No characters are consumed, and nothing is returned.
                // This is not an error, either.
                queue += String.fromCharCode(character);
                column++;
                continue;
            }
            const start = index + 1;
            let begin = start;
            let end = start;
            /** @type {string} */ let type;
            if (following === 35 /* `#` */ ) {
                // Numerical reference.
                end = ++begin;
                // The behavior further depends on the next character.
                const following = value.charCodeAt(end);
                if (following === 88 /* `X` */  || following === 120 /* `x` */ ) {
                    // ASCII hexadecimal digits.
                    type = 'hexadecimal';
                    end = ++begin;
                } else // ASCII decimal digits.
                type = 'decimal';
            } else // Named reference.
            type = 'named';
            let characterReferenceCharacters = '';
            let characterReference = '';
            let characters = '';
            // Each type of character reference accepts different characters.
            // This test is used to detect whether a reference has ended (as the semicolon
            // is not strictly needed).
            const test = type === 'named' ? (0, $7b67d5966946bfd3$export$176ed353558777b8) : type === 'decimal' ? (0, $be23405d8147b49a$export$2ad0182371401ea4) : (0, $4ccc8a5f535bff43$export$8ec2d91f756e9f4);
            end--;
            while(++end <= value.length){
                const following = value.charCodeAt(end);
                if (!test(following)) break;
                characters += String.fromCharCode(following);
                // Check if we can match a legacy named reference.
                // If so, we cache that as the last viable named reference.
                // This ensures we do not need to walk backwards later.
                if (type === 'named' && (0, $9d441a8e4486a83e$export$9545335bdecb4b8c).includes(characters)) {
                    characterReferenceCharacters = characters;
                    // @ts-expect-error: always able to decode.
                    characterReference = (0, $b2bf0a6c22a4700b$export$289b6a6320f709b4)(characters);
                }
            }
            let terminated = value.charCodeAt(end) === 59 /* `;` */ ;
            if (terminated) {
                end++;
                const namedReference = type === 'named' ? (0, $b2bf0a6c22a4700b$export$289b6a6320f709b4)(characters) : false;
                if (namedReference) {
                    characterReferenceCharacters = characters;
                    characterReference = namedReference;
                }
            }
            let diff = 1 + end - start;
            let reference = '';
            if (!terminated && settings.nonTerminated === false) ;
            else if (!characters) // An empty (possible) reference is valid, unless it’s numeric (thus an
            // ampersand followed by an octothorp).
            {
                if (type !== 'named') warning(4 /* Empty (numeric) */ , diff);
            } else if (type === 'named') {
                // An ampersand followed by anything unknown, and not terminated, is
                // invalid.
                if (terminated && !characterReference) warning(5 /* Unknown (named) */ , 1);
                else {
                    // If there’s something after an named reference which is not known,
                    // cap the reference.
                    if (characterReferenceCharacters !== characters) {
                        end = begin + characterReferenceCharacters.length;
                        diff = 1 + end - begin;
                        terminated = false;
                    }
                    // If the reference is not terminated, warn.
                    if (!terminated) {
                        const reason = characterReferenceCharacters ? 1 /* Non terminated (named) */  : 3 /* Empty (named) */ ;
                        if (settings.attribute) {
                            const following = value.charCodeAt(end);
                            if (following === 61 /* `=` */ ) {
                                warning(reason, diff);
                                characterReference = '';
                            } else if ((0, $7b67d5966946bfd3$export$176ed353558777b8)(following)) characterReference = '';
                            else warning(reason, diff);
                        } else warning(reason, diff);
                    }
                }
                reference = characterReference;
            } else {
                if (!terminated) // All nonterminated numeric references are not rendered, and emit a
                // warning.
                warning(2 /* Non terminated (numeric) */ , diff);
                // When terminated and numerical, parse as either hexadecimal or
                // decimal.
                let referenceCode = Number.parseInt(characters, type === 'hexadecimal' ? 16 : 10);
                // Emit a warning when the parsed number is prohibited, and replace with
                // replacement character.
                if ($fe979033c71e7672$var$prohibited(referenceCode)) {
                    warning(7 /* Prohibited (numeric) */ , diff);
                    reference = String.fromCharCode(65533 /* `�` */ );
                } else if (referenceCode in (0, $922953b77e46a921$export$18e663c9b25e3b2)) {
                    // Emit a warning when the parsed number is disallowed, and replace by
                    // an alternative.
                    warning(6 /* Disallowed (numeric) */ , diff);
                    reference = (0, $922953b77e46a921$export$18e663c9b25e3b2)[referenceCode];
                } else {
                    // Parse the number.
                    let output = '';
                    // Emit a warning when the parsed number should not be used.
                    if ($fe979033c71e7672$var$disallowed(referenceCode)) warning(6 /* Disallowed (numeric) */ , diff);
                    // Serialize the number.
                    if (referenceCode > 0xffff) {
                        referenceCode -= 0x10000;
                        output += String.fromCharCode(referenceCode >>> 10 | 0xd800);
                        referenceCode = 0xdc00 | referenceCode & 0x3ff;
                    }
                    reference = output + String.fromCharCode(referenceCode);
                }
            }
            // Found it!
            // First eat the queued characters as normal text, then eat a reference.
            if (reference) {
                flush();
                previous = now();
                index = end - 1;
                column += end - start + 1;
                result.push(reference);
                const next = now();
                next.offset++;
                if (settings.reference) settings.reference.call(settings.referenceContext || undefined, reference, {
                    start: previous,
                    end: next
                }, value.slice(start - 1, end));
                previous = next;
            } else {
                // If we could not find a reference, queue the checked characters (as
                // normal characters), and move the pointer to their end.
                // This is possible because we can be certain neither newlines nor
                // ampersands are included.
                characters = value.slice(start - 1, end);
                queue += characters;
                column += characters.length;
                index = end - 1;
            }
        } else {
            // Handle anything other than an ampersand, including newlines and EOF.
            if (character === 10 /* `\n` */ ) {
                line++;
                lines++;
                column = 0;
            }
            if (Number.isNaN(character)) flush();
            else {
                queue += String.fromCharCode(character);
                column++;
            }
        }
    }
    // Return the reduced nodes.
    return result.join('');
    // Get current position.
    function now() {
        return {
            line: line,
            column: column,
            offset: index + ((point ? point.offset : 0) || 0)
        };
    }
    /**
   * Handle the warning.
   *
   * @param {1|2|3|4|5|6|7} code
   * @param {number} offset
   */ function warning(code, offset) {
        /** @type {ReturnType<now>} */ let position;
        if (settings.warning) {
            position = now();
            position.column += offset;
            position.offset += offset;
            settings.warning.call(settings.warningContext || undefined, $fe979033c71e7672$var$messages[code], position, code);
        }
    }
    /**
   * Flush `queue` (normal text).
   * Macro invoked before each reference and at the end of `value`.
   * Does nothing when `queue` is empty.
   */ function flush() {
        if (queue) {
            result.push(queue);
            if (settings.text) settings.text.call(settings.textContext || undefined, queue, {
                start: previous,
                end: now()
            });
            queue = '';
        }
    }
}
/**
 * Check if `character` is outside the permissible unicode range.
 *
 * @param {number} code
 * @returns {boolean}
 */ function $fe979033c71e7672$var$prohibited(code) {
    return code >= 0xd800 && code <= 0xdfff || code > 0x10ffff;
}
/**
 * Check if `character` is disallowed.
 *
 * @param {number} code
 * @returns {boolean}
 */ function $fe979033c71e7672$var$disallowed(code) {
    return code >= 0x0001 && code <= 0x0008 || code === 0x000b || code >= 0x000d && code <= 0x001f || code >= 0x007f && code <= 0x009f || code >= 0xfdd0 && code <= 0xfdef || (code & 0xffff) === 0xffff || (code & 0xffff) === 0xfffe;
}


// @ts-nocheck
// This is a slimmed down version of `prism-core.js`, to remove globals,
// document, workers, `util.encode`, `Token.stringify`
// Private helper vars
var $e096ca6154599ee9$var$lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
var $e096ca6154599ee9$var$uniqueId = 0;
// The grammar object for plaintext
var $e096ca6154599ee9$var$plainTextGrammar = {};
var $e096ca6154599ee9$var$_ = {
    /**
   * A namespace for utility methods.
   *
   * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
   * change or disappear at any time.
   *
   * @namespace
   * @memberof Prism
   */ util: {
        /**
     * Returns the name of the type of the given value.
     *
     * @param {any} o
     * @returns {string}
     * @example
     * type(null)      === 'Null'
     * type(undefined) === 'Undefined'
     * type(123)       === 'Number'
     * type('foo')     === 'String'
     * type(true)      === 'Boolean'
     * type([1, 2])    === 'Array'
     * type({})        === 'Object'
     * type(String)    === 'Function'
     * type(/abc+/)    === 'RegExp'
     */ type: function(o) {
            return Object.prototype.toString.call(o).slice(8, -1);
        },
        /**
     * Returns a unique number for the given object. Later calls will still return the same number.
     *
     * @param {Object} obj
     * @returns {number}
     */ objId: function(obj) {
            if (!obj['__id']) Object.defineProperty(obj, '__id', {
                value: ++$e096ca6154599ee9$var$uniqueId
            });
            return obj['__id'];
        },
        /**
     * Creates a deep clone of the given object.
     *
     * The main intended use of this function is to clone language definitions.
     *
     * @param {T} o
     * @param {Record<number, any>} [visited]
     * @returns {T}
     * @template T
     */ clone: function deepClone(o, visited) {
            visited = visited || {};
            var clone;
            var id;
            switch($e096ca6154599ee9$var$_.util.type(o)){
                case 'Object':
                    id = $e096ca6154599ee9$var$_.util.objId(o);
                    if (visited[id]) return visited[id];
                    clone = /** @type {Record<string, any>} */ {};
                    visited[id] = clone;
                    for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                    return /** @type {any} */ clone;
                case 'Array':
                    id = $e096ca6154599ee9$var$_.util.objId(o);
                    if (visited[id]) return visited[id];
                    clone = [];
                    visited[id] = clone; /** @type {Array} */ 
                    /** @type {any} */ o.forEach(function(v, i) {
                        clone[i] = deepClone(v, visited);
                    });
                    return /** @type {any} */ clone;
                default:
                    return o;
            }
        }
    },
    /**
   * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
   *
   * @namespace
   * @memberof Prism
   * @public
   */ languages: {
        /**
     * The grammar for plain, unformatted text.
     */ plain: $e096ca6154599ee9$var$plainTextGrammar,
        plaintext: $e096ca6154599ee9$var$plainTextGrammar,
        text: $e096ca6154599ee9$var$plainTextGrammar,
        txt: $e096ca6154599ee9$var$plainTextGrammar,
        /**
     * Creates a deep copy of the language with the given id and appends the given tokens.
     *
     * If a token in `redef` also appears in the copied language, then the existing token in the copied language
     * will be overwritten at its original position.
     *
     * ## Best practices
     *
     * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
     * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
     * understand the language definition because, normally, the order of tokens matters in Prism grammars.
     *
     * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
     * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
     *
     * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
     * @param {Grammar} redef The new tokens to append.
     * @returns {Grammar} The new language created.
     * @public
     * @example
     * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
     *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
     *     // at its original position
     *     'comment': { ... },
     *     // CSS doesn't have a 'color' token, so this token will be appended
     *     'color': /\b(?:red|green|blue)\b/
     * });
     */ extend: function(id, redef) {
            var lang = $e096ca6154599ee9$var$_.util.clone($e096ca6154599ee9$var$_.languages[id]);
            for(var key in redef)lang[key] = redef[key];
            return lang;
        },
        /**
     * Inserts tokens _before_ another token in a language definition or any other grammar.
     *
     * ## Usage
     *
     * This helper method makes it easy to modify existing languages. For example, the CSS language definition
     * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
     * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
     * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
     * this:
     *
     * ```js
     * Prism.languages.markup.style = {
     *     // token
     * };
     * ```
     *
     * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
     * before existing tokens. For the CSS example above, you would use it like this:
     *
     * ```js
     * Prism.languages.insertBefore('markup', 'cdata', {
     *     'style': {
     *         // token
     *     }
     * });
     * ```
     *
     * ## Special cases
     *
     * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
     * will be ignored.
     *
     * This behavior can be used to insert tokens after `before`:
     *
     * ```js
     * Prism.languages.insertBefore('markup', 'comment', {
     *     'comment': Prism.languages.markup.comment,
     *     // tokens after 'comment'
     * });
     * ```
     *
     * ## Limitations
     *
     * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
     * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
     * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
     * deleting properties which is necessary to insert at arbitrary positions.
     *
     * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
     * Instead, it will create a new object and replace all references to the target object with the new one. This
     * can be done without temporarily deleting properties, so the iteration order is well-defined.
     *
     * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
     * you hold the target object in a variable, then the value of the variable will not change.
     *
     * ```js
     * var oldMarkup = Prism.languages.markup;
     * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
     *
     * assert(oldMarkup !== Prism.languages.markup);
     * assert(newMarkup === Prism.languages.markup);
     * ```
     *
     * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
     * object to be modified.
     * @param {string} before The key to insert before.
     * @param {Grammar} insert An object containing the key-value pairs to be inserted.
     * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
     * object to be modified.
     *
     * Defaults to `Prism.languages`.
     * @returns {Grammar} The new grammar object.
     * @public
     */ insertBefore: function(inside, before, insert, root) {
            root = root || /** @type {any} */ $e096ca6154599ee9$var$_.languages;
            var grammar = root[inside];
            /** @type {Grammar} */ var ret = {};
            for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                if (token == before) {
                    for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                }
                // Do not insert token which also occur in insert. See #1525
                if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
            }
            var old = root[inside];
            root[inside] = ret;
            // Update references in other language definitions
            $e096ca6154599ee9$var$_.languages.DFS($e096ca6154599ee9$var$_.languages, function(key, value) {
                if (value === old && key != inside) this[key] = ret;
            });
            return ret;
        },
        // Traverse a language definition with Depth First Search
        DFS: function DFS(o, callback, type, visited) {
            visited = visited || {};
            var objId = $e096ca6154599ee9$var$_.util.objId;
            for(var i in o)if (o.hasOwnProperty(i)) {
                callback.call(o, i, o[i], type || i);
                var property = o[i];
                var propertyType = $e096ca6154599ee9$var$_.util.type(property);
                if (propertyType === 'Object' && !visited[objId(property)]) {
                    visited[objId(property)] = true;
                    DFS(property, callback, null, visited);
                } else if (propertyType === 'Array' && !visited[objId(property)]) {
                    visited[objId(property)] = true;
                    DFS(property, callback, i, visited);
                }
            }
        }
    },
    plugins: {},
    /**
   * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
   * and the language definitions to use, and returns a string with the HTML produced.
   *
   * The following hooks will be run:
   * 1. `before-tokenize`
   * 2. `after-tokenize`
   * 3. `wrap`: On each {@link Token}.
   *
   * @param {string} text A string with the code to be highlighted.
   * @param {Grammar} grammar An object containing the tokens to use.
   *
   * Usually a language definition like `Prism.languages.markup`.
   * @param {string} language The name of the language definition passed to `grammar`.
   * @returns {string} The highlighted HTML.
   * @memberof Prism
   * @public
   * @example
   * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
   */ highlight: function(text, grammar, language) {
        var env = {
            code: text,
            grammar: grammar,
            language: language
        };
        $e096ca6154599ee9$var$_.hooks.run('before-tokenize', env);
        if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
        env.tokens = $e096ca6154599ee9$var$_.tokenize(env.code, env.grammar);
        $e096ca6154599ee9$var$_.hooks.run('after-tokenize', env);
        return $e096ca6154599ee9$var$Token.stringify($e096ca6154599ee9$var$_.util.encode(env.tokens), env.language);
    },
    /**
   * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
   * and the language definitions to use, and returns an array with the tokenized code.
   *
   * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
   *
   * This method could be useful in other contexts as well, as a very crude parser.
   *
   * @param {string} text A string with the code to be highlighted.
   * @param {Grammar} grammar An object containing the tokens to use.
   *
   * Usually a language definition like `Prism.languages.markup`.
   * @returns {TokenStream} An array of strings and tokens, a token stream.
   * @memberof Prism
   * @public
   * @example
   * let code = `var foo = 0;`;
   * let tokens = Prism.tokenize(code, Prism.languages.javascript);
   * tokens.forEach(token => {
   *     if (token instanceof Prism.Token && token.type === 'number') {
   *         console.log(`Found numeric literal: ${token.content}`);
   *     }
   * });
   */ tokenize: function(text, grammar) {
        var rest = grammar.rest;
        if (rest) {
            for(var token in rest)grammar[token] = rest[token];
            delete grammar.rest;
        }
        var tokenList = new $e096ca6154599ee9$var$LinkedList();
        $e096ca6154599ee9$var$addAfter(tokenList, tokenList.head, text);
        $e096ca6154599ee9$var$matchGrammar(text, tokenList, grammar, tokenList.head, 0);
        return $e096ca6154599ee9$var$toArray(tokenList);
    },
    /**
   * @namespace
   * @memberof Prism
   * @public
   */ hooks: {
        all: {},
        /**
     * Adds the given callback to the list of callbacks for the given hook.
     *
     * The callback will be invoked when the hook it is registered for is run.
     * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
     *
     * One callback function can be registered to multiple hooks and the same hook multiple times.
     *
     * @param {string} name The name of the hook.
     * @param {HookCallback} callback The callback function which is given environment variables.
     * @public
     */ add: function(name, callback) {
            var hooks = $e096ca6154599ee9$var$_.hooks.all;
            hooks[name] = hooks[name] || [];
            hooks[name].push(callback);
        },
        /**
     * Runs a hook invoking all registered callbacks with the given environment variables.
     *
     * Callbacks will be invoked synchronously and in the order in which they were registered.
     *
     * @param {string} name The name of the hook.
     * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
     * @public
     */ run: function(name, env) {
            var callbacks = $e096ca6154599ee9$var$_.hooks.all[name];
            if (!callbacks || !callbacks.length) return;
            for(var i = 0, callback; callback = callbacks[i++];)callback(env);
        }
    },
    Token: $e096ca6154599ee9$var$Token
};
// Typescript note:
// The following can be used to import the Token type in JSDoc:
//
//   @typedef {InstanceType<import("./prism-core")["Token"]>} Token
/**
 * Creates a new token.
 *
 * @param {string} type See {@link Token#type type}
 * @param {string | TokenStream} content See {@link Token#content content}
 * @param {string|string[]} [alias] The alias(es) of the token.
 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
 * @class
 * @global
 * @public
 */ function $e096ca6154599ee9$var$Token(type, content, alias, matchedStr) {
    /**
   * The type of the token.
   *
   * This is usually the key of a pattern in a {@link Grammar}.
   *
   * @type {string}
   * @see GrammarToken
   * @public
   */ this.type = type;
    /**
   * The strings or tokens contained by this token.
   *
   * This will be a token stream if the pattern matched also defined an `inside` grammar.
   *
   * @type {string | TokenStream}
   * @public
   */ this.content = content;
    /**
   * The alias(es) of the token.
   *
   * @type {string|string[]}
   * @see GrammarToken
   * @public
   */ this.alias = alias;
    // Copy of the full string this token was created from
    this.length = (matchedStr || '').length | 0;
}
/**
 * A token stream is an array of strings and {@link Token Token} objects.
 *
 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
 * them.
 *
 * 1. No adjacent strings.
 * 2. No empty strings.
 *
 *    The only exception here is the token stream that only contains the empty string and nothing else.
 *
 * @typedef {Array<string | Token>} TokenStream
 * @global
 * @public
 */ /**
 * @param {RegExp} pattern
 * @param {number} pos
 * @param {string} text
 * @param {boolean} lookbehind
 * @returns {RegExpExecArray | null}
 */ function $e096ca6154599ee9$var$matchPattern(pattern, pos, text, lookbehind) {
    pattern.lastIndex = pos;
    var match = pattern.exec(text);
    if (match && lookbehind && match[1]) {
        // change the match to remove the text matched by the Prism lookbehind group
        var lookbehindLength = match[1].length;
        match.index += lookbehindLength;
        match[0] = match[0].slice(lookbehindLength);
    }
    return match;
}
/**
 * @param {string} text
 * @param {LinkedList<string | Token>} tokenList
 * @param {any} grammar
 * @param {LinkedListNode<string | Token>} startNode
 * @param {number} startPos
 * @param {RematchOptions} [rematch]
 * @returns {void}
 * @private
 *
 * @typedef RematchOptions
 * @property {string} cause
 * @property {number} reach
 */ function $e096ca6154599ee9$var$matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
    for(var token in grammar){
        if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
        var patterns = grammar[token];
        patterns = Array.isArray(patterns) ? patterns : [
            patterns
        ];
        for(var j = 0; j < patterns.length; ++j){
            if (rematch && rematch.cause == token + ',' + j) return;
            var patternObj = patterns[j];
            var inside = patternObj.inside;
            var lookbehind = !!patternObj.lookbehind;
            var greedy = !!patternObj.greedy;
            var alias = patternObj.alias;
            if (greedy && !patternObj.pattern.global) {
                // Without the global flag, lastIndex won't work
                var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
            }
            /** @type {RegExp} */ var pattern = patternObj.pattern || patternObj;
            for(// iterate the token list and keep track of the current token/string position
            var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                if (rematch && pos >= rematch.reach) break;
                var str = currentNode.value;
                if (tokenList.length > text.length) // Something went terribly wrong, ABORT, ABORT!
                return;
                if (str instanceof $e096ca6154599ee9$var$Token) continue;
                var removeCount = 1 // this is the to parameter of removeBetween
                ;
                var match;
                if (greedy) {
                    match = $e096ca6154599ee9$var$matchPattern(pattern, pos, text, lookbehind);
                    if (!match || match.index >= text.length) break;
                    var from = match.index;
                    var to = match.index + match[0].length;
                    var p = pos;
                    // find the node that contains the match
                    p += currentNode.value.length;
                    while(from >= p){
                        currentNode = currentNode.next;
                        p += currentNode.value.length;
                    }
                    // adjust pos (and p)
                    p -= currentNode.value.length;
                    pos = p;
                    // the current node is a Token, then the match starts inside another Token, which is invalid
                    if (currentNode.value instanceof $e096ca6154599ee9$var$Token) continue;
                    // find the last node which is affected by this match
                    for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === 'string'); k = k.next){
                        removeCount++;
                        p += k.value.length;
                    }
                    removeCount--;
                    // replace with the new match
                    str = text.slice(pos, p);
                    match.index -= pos;
                } else {
                    match = $e096ca6154599ee9$var$matchPattern(pattern, 0, str, lookbehind);
                    if (!match) continue;
                }
                // eslint-disable-next-line no-redeclare
                var from = match.index;
                var matchStr = match[0];
                var before = str.slice(0, from);
                var after = str.slice(from + matchStr.length);
                var reach = pos + str.length;
                if (rematch && reach > rematch.reach) rematch.reach = reach;
                var removeFrom = currentNode.prev;
                if (before) {
                    removeFrom = $e096ca6154599ee9$var$addAfter(tokenList, removeFrom, before);
                    pos += before.length;
                }
                $e096ca6154599ee9$var$removeRange(tokenList, removeFrom, removeCount);
                var wrapped = new $e096ca6154599ee9$var$Token(token, inside ? $e096ca6154599ee9$var$_.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                currentNode = $e096ca6154599ee9$var$addAfter(tokenList, removeFrom, wrapped);
                if (after) $e096ca6154599ee9$var$addAfter(tokenList, currentNode, after);
                if (removeCount > 1) {
                    // at least one Token object was removed, so we have to do some rematching
                    // this can only happen if the current pattern is greedy
                    /** @type {RematchOptions} */ var nestedRematch = {
                        cause: token + ',' + j,
                        reach: reach
                    };
                    $e096ca6154599ee9$var$matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                    // the reach might have been extended because of the rematching
                    if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                }
            }
        }
    }
}
/**
 * @typedef LinkedListNode
 * @property {T} value
 * @property {LinkedListNode<T> | null} prev The previous node.
 * @property {LinkedListNode<T> | null} next The next node.
 * @template T
 * @private
 */ /**
 * @template T
 * @private
 */ function $e096ca6154599ee9$var$LinkedList() {
    /** @type {LinkedListNode<T>} */ var head = {
        value: null,
        prev: null,
        next: null
    };
    /** @type {LinkedListNode<T>} */ var tail = {
        value: null,
        prev: head,
        next: null
    };
    head.next = tail;
    /** @type {LinkedListNode<T>} */ this.head = head;
    /** @type {LinkedListNode<T>} */ this.tail = tail;
    this.length = 0;
}
/**
 * Adds a new node with the given value to the list.
 *
 * @param {LinkedList<T>} list
 * @param {LinkedListNode<T>} node
 * @param {T} value
 * @returns {LinkedListNode<T>} The added node.
 * @template T
 */ function $e096ca6154599ee9$var$addAfter(list, node, value) {
    // assumes that node != list.tail && values.length >= 0
    var next = node.next;
    var newNode = {
        value: value,
        prev: node,
        next: next
    };
    node.next = newNode;
    next.prev = newNode;
    list.length++;
    return newNode;
}
/**
 * Removes `count` nodes after the given node. The given node will not be removed.
 *
 * @param {LinkedList<T>} list
 * @param {LinkedListNode<T>} node
 * @param {number} count
 * @template T
 */ function $e096ca6154599ee9$var$removeRange(list, node, count) {
    var next = node.next;
    for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
    node.next = next;
    next.prev = node;
    list.length -= i;
}
/**
 * @param {LinkedList<T>} list
 * @returns {T[]}
 * @template T
 */ function $e096ca6154599ee9$var$toArray(list) {
    var array = [];
    var node = list.head.next;
    while(node !== list.tail){
        array.push(node.value);
        node = node.next;
    }
    return array;
}
const $e096ca6154599ee9$export$dc7257ffb0972f87 = $e096ca6154599ee9$var$_;


// To do: next major, use `Object.hasOwn`.
const $2a7ecb442ccfd5e3$var$own = {}.hasOwnProperty;
// Inherit.
function $2a7ecb442ccfd5e3$var$Refractor() {}
$2a7ecb442ccfd5e3$var$Refractor.prototype = (0, $e096ca6154599ee9$export$dc7257ffb0972f87);
const $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390 = new $2a7ecb442ccfd5e3$var$Refractor();
// Create.
$2a7ecb442ccfd5e3$export$1c6435d0b8e9f390.highlight = $2a7ecb442ccfd5e3$var$highlight;
$2a7ecb442ccfd5e3$export$1c6435d0b8e9f390.register = $2a7ecb442ccfd5e3$var$register;
$2a7ecb442ccfd5e3$export$1c6435d0b8e9f390.alias = $2a7ecb442ccfd5e3$var$alias;
$2a7ecb442ccfd5e3$export$1c6435d0b8e9f390.registered = $2a7ecb442ccfd5e3$var$registered;
$2a7ecb442ccfd5e3$export$1c6435d0b8e9f390.listLanguages = $2a7ecb442ccfd5e3$var$listLanguages;
// @ts-expect-error Overwrite Prism.
$2a7ecb442ccfd5e3$export$1c6435d0b8e9f390.util.encode = $2a7ecb442ccfd5e3$var$encode;
// @ts-expect-error Overwrite Prism.
$2a7ecb442ccfd5e3$export$1c6435d0b8e9f390.Token.stringify = $2a7ecb442ccfd5e3$var$stringify;
/**
 * Highlight `value` (code) as `language` (programming language).
 *
 * @param {string} value
 *   Code to highlight.
 * @param {Grammar | string} language
 *   Programming language name, alias, or grammar.
 * @returns {RefractorRoot}
 *   Node representing highlighted code.
 */ function $2a7ecb442ccfd5e3$var$highlight(value, language) {
    if (typeof value !== 'string') throw new TypeError('Expected `string` for `value`, got `' + value + '`');
    /** @type {Grammar} */ let grammar;
    /** @type {string | undefined} */ let name;
    // `name` is a grammar object.
    // This was called internally by Prism.js before 1.28.0.
    /* c8 ignore next 2 */ if (language && typeof language === 'object') grammar = language;
    else {
        name = language;
        if (typeof name !== 'string') throw new TypeError('Expected `string` for `name`, got `' + name + '`');
        if ($2a7ecb442ccfd5e3$var$own.call($2a7ecb442ccfd5e3$export$1c6435d0b8e9f390.languages, name)) grammar = $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390.languages[name];
        else throw new Error('Unknown language: `' + name + '` is not registered');
    }
    return {
        type: 'root',
        // @ts-expect-error: we hacked Prism to accept and return the things we want.
        children: (0, $e096ca6154599ee9$export$dc7257ffb0972f87).highlight.call($2a7ecb442ccfd5e3$export$1c6435d0b8e9f390, value, grammar, name)
    };
}
/**
 * Register a syntax.
 *
 * @param {Syntax} syntax
 *   Language function made for refractor, as in, the files in
 *   `refractor/lang/*.js`.
 * @returns {undefined}
 *   Nothing.
 */ function $2a7ecb442ccfd5e3$var$register(syntax) {
    if (typeof syntax !== 'function' || !syntax.displayName) throw new Error('Expected `function` for `syntax`, got `' + syntax + '`');
    // Do not duplicate registrations.
    if (!$2a7ecb442ccfd5e3$var$own.call($2a7ecb442ccfd5e3$export$1c6435d0b8e9f390.languages, syntax.displayName)) syntax($2a7ecb442ccfd5e3$export$1c6435d0b8e9f390);
}
/**
 * Register aliases for already registered languages.
 *
 * @param {Record<string, ReadonlyArray<string> | string> | string} language
 *   Language to alias.
 * @param {ReadonlyArray<string> | string | null | undefined} [alias]
 *   Aliases.
 * @returns {undefined}
 *   Nothing.
 */ function $2a7ecb442ccfd5e3$var$alias(language, alias) {
    const languages = $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390.languages;
    /** @type {Record<string, ReadonlyArray<string> | string>} */ let map = {};
    if (typeof language === 'string') {
        if (alias) map[language] = alias;
    } else map = language;
    /** @type {string} */ let key;
    for(key in map)if ($2a7ecb442ccfd5e3$var$own.call(map, key)) {
        const value = map[key];
        const list = typeof value === 'string' ? [
            value
        ] : value;
        let index = -1;
        while(++index < list.length)languages[list[index]] = languages[key];
    }
}
/**
 * Check whether an `alias` or `language` is registered.
 *
 * @param {string} aliasOrLanguage
 *   Language or alias to check.
 * @returns {boolean}
 *   Whether the language is registered.
 */ function $2a7ecb442ccfd5e3$var$registered(aliasOrLanguage) {
    if (typeof aliasOrLanguage !== 'string') throw new TypeError('Expected `string` for `aliasOrLanguage`, got `' + aliasOrLanguage + '`');
    return $2a7ecb442ccfd5e3$var$own.call($2a7ecb442ccfd5e3$export$1c6435d0b8e9f390.languages, aliasOrLanguage);
}
/**
 * List all registered languages (names and aliases).
 *
 * @returns {Array<string>}
 *   List of language names.
 */ function $2a7ecb442ccfd5e3$var$listLanguages() {
    const languages = $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390.languages;
    /** @type {Array<string>} */ const list = [];
    /** @type {string} */ let language;
    for(language in languages)if ($2a7ecb442ccfd5e3$var$own.call(languages, language) && typeof languages[language] === 'object') list.push(language);
    return list;
}
/**
 * @param {Array<_Token | string> | _Token | string} value
 *   Token to stringify.
 * @param {string} language
 *   Language of the token.
 * @returns {Array<RefractorElement | Text> | RefractorElement | Text}
 *   Node representing the token.
 */ function $2a7ecb442ccfd5e3$var$stringify(value, language) {
    if (typeof value === 'string') return {
        type: 'text',
        value: value
    };
    if (Array.isArray(value)) {
        /** @type {Array<RefractorElement | Text>} */ const result = [];
        let index = -1;
        while(++index < value.length)if (value[index] !== null && value[index] !== undefined && value[index] !== '') // @ts-expect-error Assume no sub-arrays.
        result.push($2a7ecb442ccfd5e3$var$stringify(value[index], language));
        return result;
    }
    /** @type {_Env} */ const env = {
        attributes: {},
        classes: [
            'token',
            value.type
        ],
        content: $2a7ecb442ccfd5e3$var$stringify(value.content, language),
        language: language,
        tag: 'span',
        type: value.type
    };
    if (value.alias) env.classes.push(...typeof value.alias === 'string' ? [
        value.alias
    ] : value.alias);
    // @ts-expect-error Prism.
    $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390.hooks.run('wrap', env);
    // @ts-expect-error Hush, it’s fine.
    return (0, $a48d0632a475a570$export$dda1d9f60106f0e9)(env.tag + '.' + env.classes.join('.'), $2a7ecb442ccfd5e3$var$attributes(env.attributes), env.content);
}
/**
 * @template {unknown} T
 *   Tokens.
 * @param {T} tokens
 *   Input.
 * @returns {T}
 *   Output, same as input.
 */ function $2a7ecb442ccfd5e3$var$encode(tokens) {
    return tokens;
}
/**
 * @param {Record<string, string>} record
 *   Attributes.
 * @returns {Record<string, string>}
 *   Attributes.
 */ function $2a7ecb442ccfd5e3$var$attributes(record) {
    /** @type {string} */ let key;
    for(key in record)if ($2a7ecb442ccfd5e3$var$own.call(record, key)) record[key] = (0, $fe979033c71e7672$export$6c6c782be925911c)(record[key]);
    return record;
}


(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $e064275ae5958777$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $48c36581818e331d$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $b8123b708c3d0c30$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $34bd8604ec75c450$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $e1ab06973c0a6c0a$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $8fbeea7c20d72e06$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $c8ae87468323f6e6$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $5f6e332fbf45b5ef$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $baa978ee70a8092e$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $12ff858fac87095b$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $68ea9a70b77f88ea$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $f19e6959a3616e08$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $9f5c72e4d4e505c4$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $15d2f325237e0784$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $354a467a21a053bd$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $5b589dc50921a1c0$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $3350a7c50307d503$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $d5e8803a0ecb1a4c$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $d56cfd3d329eea2c$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $99679268fa665931$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $659db1e49ba3c889$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $f6aa5d7625509f98$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $a400735491c1aa4e$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $158311e91e281aed$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $166c94860a240118$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $df89008fdd9898a1$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $1024f633e11e96f5$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $57faf12dcc554420$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $fd46c9753d6b17f5$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $50318a28f67a9ccf$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $d138d4e60ec637d4$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $07912fa463f18ff4$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $971aaf7f210ab43d$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $11df1c7abcd7aa92$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $398c5bff0b970a81$export$2e2bcd8739ae039));


/**
 * @import {
 *   Grammar,
 *   RefractorElement,
 *   RefractorRoot,
 *   Syntax,
 *   Text
 * } from './core.js'
 */ 




// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $f7f469a09d2923f1$export$2e2bcd8739ae039.displayName = 'abap';
$f7f469a09d2923f1$export$2e2bcd8739ae039.aliases = [];
function $f7f469a09d2923f1$export$2e2bcd8739ae039(Prism) {
    Prism.languages.abap = {
        comment: /^\*.*/m,
        string: /(`|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        'string-template': {
            pattern: /([|}])(?:\\.|[^\\|{\r\n])*(?=[|{])/,
            lookbehind: true,
            alias: 'string'
        },
        /* End Of Line comments should not interfere with strings when the
quote character occurs within them. We assume a string being highlighted
inside an EOL comment is more acceptable than the opposite.
*/ 'eol-comment': {
            pattern: /(^|\s)".*/m,
            lookbehind: true,
            alias: 'comment'
        },
        keyword: {
            pattern: /(\s|\.|^)(?:\*-INPUT|\?TO|ABAP-SOURCE|ABBREVIATED|ABS|ABSTRACT|ACCEPT|ACCEPTING|ACCESSPOLICY|ACCORDING|ACOS|ACTIVATION|ACTUAL|ADD|ADD-CORRESPONDING|ADJACENT|AFTER|ALIAS|ALIASES|ALIGN|ALL|ALLOCATE|ALPHA|ANALYSIS|ANALYZER|AND|ANY|APPEND|APPENDAGE|APPENDING|APPLICATION|ARCHIVE|AREA|ARITHMETIC|AS|ASCENDING|ASIN|ASPECT|ASSERT|ASSIGN|ASSIGNED|ASSIGNING|ASSOCIATION|ASYNCHRONOUS|AT|ATAN|ATTRIBUTES|AUTHORITY|AUTHORITY-CHECK|AVG|BACK|BACKGROUND|BACKUP|BACKWARD|BADI|BASE|BEFORE|BEGIN|BETWEEN|BIG|BINARY|BINDING|BIT|BIT-AND|BIT-NOT|BIT-OR|BIT-XOR|BLACK|BLANK|BLANKS|BLOB|BLOCK|BLOCKS|BLUE|BOUND|BOUNDARIES|BOUNDS|BOXED|BREAK-POINT|BT|BUFFER|BY|BYPASSING|BYTE|BYTE-CA|BYTE-CN|BYTE-CO|BYTE-CS|BYTE-NA|BYTE-NS|BYTE-ORDER|C|CA|CALL|CALLING|CASE|CAST|CASTING|CATCH|CEIL|CENTER|CENTERED|CHAIN|CHAIN-INPUT|CHAIN-REQUEST|CHANGE|CHANGING|CHANNELS|CHAR-TO-HEX|CHARACTER|CHARLEN|CHECK|CHECKBOX|CIRCULAR|CI_|CLASS|CLASS-CODING|CLASS-DATA|CLASS-EVENTS|CLASS-METHODS|CLASS-POOL|CLEANUP|CLEAR|CLIENT|CLOB|CLOCK|CLOSE|CN|CNT|CO|COALESCE|CODE|CODING|COLLECT|COLOR|COLUMN|COLUMNS|COL_BACKGROUND|COL_GROUP|COL_HEADING|COL_KEY|COL_NEGATIVE|COL_NORMAL|COL_POSITIVE|COL_TOTAL|COMMENT|COMMENTS|COMMIT|COMMON|COMMUNICATION|COMPARING|COMPONENT|COMPONENTS|COMPRESSION|COMPUTE|CONCAT|CONCATENATE|COND|CONDENSE|CONDITION|CONNECT|CONNECTION|CONSTANTS|CONTEXT|CONTEXTS|CONTINUE|CONTROL|CONTROLS|CONV|CONVERSION|CONVERT|COPIES|COPY|CORRESPONDING|COS|COSH|COUNT|COUNTRY|COVER|CP|CPI|CREATE|CREATING|CRITICAL|CS|CURRENCY|CURRENCY_CONVERSION|CURRENT|CURSOR|CURSOR-SELECTION|CUSTOMER|CUSTOMER-FUNCTION|DANGEROUS|DATA|DATABASE|DATAINFO|DATASET|DATE|DAYLIGHT|DBMAXLEN|DD\/MM\/YY|DD\/MM\/YYYY|DDMMYY|DEALLOCATE|DECIMALS|DECIMAL_SHIFT|DECLARATIONS|DEEP|DEFAULT|DEFERRED|DEFINE|DEFINING|DEFINITION|DELETE|DELETING|DEMAND|DEPARTMENT|DESCENDING|DESCRIBE|DESTINATION|DETAIL|DIALOG|DIRECTORY|DISCONNECT|DISPLAY|DISPLAY-MODE|DISTANCE|DISTINCT|DIV|DIVIDE|DIVIDE-CORRESPONDING|DIVISION|DO|DUMMY|DUPLICATE|DUPLICATES|DURATION|DURING|DYNAMIC|DYNPRO|E|EACH|EDIT|EDITOR-CALL|ELSE|ELSEIF|EMPTY|ENABLED|ENABLING|ENCODING|END|END-ENHANCEMENT-SECTION|END-LINES|END-OF-DEFINITION|END-OF-FILE|END-OF-PAGE|END-OF-SELECTION|ENDAT|ENDCASE|ENDCATCH|ENDCHAIN|ENDCLASS|ENDDO|ENDENHANCEMENT|ENDEXEC|ENDFOR|ENDFORM|ENDFUNCTION|ENDIAN|ENDIF|ENDING|ENDINTERFACE|ENDLOOP|ENDMETHOD|ENDMODULE|ENDON|ENDPROVIDE|ENDSELECT|ENDTRY|ENDWHILE|ENGINEERING|ENHANCEMENT|ENHANCEMENT-POINT|ENHANCEMENT-SECTION|ENHANCEMENTS|ENTRIES|ENTRY|ENVIRONMENT|EQ|EQUAL|EQUIV|ERRORMESSAGE|ERRORS|ESCAPE|ESCAPING|EVENT|EVENTS|EXACT|EXCEPT|EXCEPTION|EXCEPTION-TABLE|EXCEPTIONS|EXCLUDE|EXCLUDING|EXEC|EXECUTE|EXISTS|EXIT|EXIT-COMMAND|EXP|EXPAND|EXPANDING|EXPIRATION|EXPLICIT|EXPONENT|EXPORT|EXPORTING|EXTEND|EXTENDED|EXTENSION|EXTRACT|FAIL|FETCH|FIELD|FIELD-GROUPS|FIELD-SYMBOL|FIELD-SYMBOLS|FIELDS|FILE|FILTER|FILTER-TABLE|FILTERS|FINAL|FIND|FIRST|FIRST-LINE|FIXED-POINT|FKEQ|FKGE|FLOOR|FLUSH|FONT|FOR|FORM|FORMAT|FORWARD|FOUND|FRAC|FRAME|FRAMES|FREE|FRIENDS|FROM|FUNCTION|FUNCTION-POOL|FUNCTIONALITY|FURTHER|GAPS|GE|GENERATE|GET|GIVING|GKEQ|GKGE|GLOBAL|GRANT|GREATER|GREEN|GROUP|GROUPS|GT|HANDLE|HANDLER|HARMLESS|HASHED|HAVING|HDB|HEAD-LINES|HEADER|HEADERS|HEADING|HELP-ID|HELP-REQUEST|HIDE|HIGH|HINT|HOLD|HOTSPOT|I|ICON|ID|IDENTIFICATION|IDENTIFIER|IDS|IF|IGNORE|IGNORING|IMMEDIATELY|IMPLEMENTATION|IMPLEMENTATIONS|IMPLEMENTED|IMPLICIT|IMPORT|IMPORTING|IN|INACTIVE|INCL|INCLUDE|INCLUDES|INCLUDING|INCREMENT|INDEX|INDEX-LINE|INFOTYPES|INHERITING|INIT|INITIAL|INITIALIZATION|INNER|INOUT|INPUT|INSERT|INSTANCES|INTENSIFIED|INTERFACE|INTERFACE-POOL|INTERFACES|INTERNAL|INTERVALS|INTO|INVERSE|INVERTED-DATE|IS|ISO|ITERATOR|ITNO|JOB|JOIN|KEEP|KEEPING|KERNEL|KEY|KEYS|KEYWORDS|KIND|LANGUAGE|LAST|LATE|LAYOUT|LE|LEADING|LEAVE|LEFT|LEFT-JUSTIFIED|LEFTPLUS|LEFTSPACE|LEGACY|LENGTH|LESS|LET|LEVEL|LEVELS|LIKE|LINE|LINE-COUNT|LINE-SELECTION|LINE-SIZE|LINEFEED|LINES|LIST|LIST-PROCESSING|LISTBOX|LITTLE|LLANG|LOAD|LOAD-OF-PROGRAM|LOB|LOCAL|LOCALE|LOCATOR|LOG|LOG-POINT|LOG10|LOGFILE|LOGICAL|LONG|LOOP|LOW|LOWER|LPAD|LPI|LT|M|MAIL|MAIN|MAJOR-ID|MAPPING|MARGIN|MARK|MASK|MATCH|MATCHCODE|MAX|MAXIMUM|MEDIUM|MEMBERS|MEMORY|MESH|MESSAGE|MESSAGE-ID|MESSAGES|MESSAGING|METHOD|METHODS|MIN|MINIMUM|MINOR-ID|MM\/DD\/YY|MM\/DD\/YYYY|MMDDYY|MOD|MODE|MODIF|MODIFIER|MODIFY|MODULE|MOVE|MOVE-CORRESPONDING|MULTIPLY|MULTIPLY-CORRESPONDING|NA|NAME|NAMETAB|NATIVE|NB|NE|NESTED|NESTING|NEW|NEW-LINE|NEW-PAGE|NEW-SECTION|NEXT|NO|NO-DISPLAY|NO-EXTENSION|NO-GAP|NO-GAPS|NO-GROUPING|NO-HEADING|NO-SCROLLING|NO-SIGN|NO-TITLE|NO-TOPOFPAGE|NO-ZERO|NODE|NODES|NON-UNICODE|NON-UNIQUE|NOT|NP|NS|NULL|NUMBER|NUMOFCHAR|O|OBJECT|OBJECTS|OBLIGATORY|OCCURRENCE|OCCURRENCES|OCCURS|OF|OFF|OFFSET|OLE|ON|ONLY|OPEN|OPTION|OPTIONAL|OPTIONS|OR|ORDER|OTHER|OTHERS|OUT|OUTER|OUTPUT|OUTPUT-LENGTH|OVERFLOW|OVERLAY|PACK|PACKAGE|PAD|PADDING|PAGE|PAGES|PARAMETER|PARAMETER-TABLE|PARAMETERS|PART|PARTIALLY|PATTERN|PERCENTAGE|PERFORM|PERFORMING|PERSON|PF|PF-STATUS|PINK|PLACES|POOL|POSITION|POS_HIGH|POS_LOW|PRAGMAS|PRECOMPILED|PREFERRED|PRESERVING|PRIMARY|PRINT|PRINT-CONTROL|PRIORITY|PRIVATE|PROCEDURE|PROCESS|PROGRAM|PROPERTY|PROTECTED|PROVIDE|PUBLIC|PUSHBUTTON|PUT|QUEUE-ONLY|QUICKINFO|RADIOBUTTON|RAISE|RAISING|RANGE|RANGES|RAW|READ|READ-ONLY|READER|RECEIVE|RECEIVED|RECEIVER|RECEIVING|RED|REDEFINITION|REDUCE|REDUCED|REF|REFERENCE|REFRESH|REGEX|REJECT|REMOTE|RENAMING|REPLACE|REPLACEMENT|REPLACING|REPORT|REQUEST|REQUESTED|RESERVE|RESET|RESOLUTION|RESPECTING|RESPONSIBLE|RESULT|RESULTS|RESUMABLE|RESUME|RETRY|RETURN|RETURNCODE|RETURNING|RIGHT|RIGHT-JUSTIFIED|RIGHTPLUS|RIGHTSPACE|RISK|RMC_COMMUNICATION_FAILURE|RMC_INVALID_STATUS|RMC_SYSTEM_FAILURE|ROLE|ROLLBACK|ROUND|ROWS|RTTI|RUN|SAP|SAP-SPOOL|SAVING|SCALE_PRESERVING|SCALE_PRESERVING_SCIENTIFIC|SCAN|SCIENTIFIC|SCIENTIFIC_WITH_LEADING_ZERO|SCREEN|SCROLL|SCROLL-BOUNDARY|SCROLLING|SEARCH|SECONDARY|SECONDS|SECTION|SELECT|SELECT-OPTIONS|SELECTION|SELECTION-SCREEN|SELECTION-SET|SELECTION-SETS|SELECTION-TABLE|SELECTIONS|SELECTOR|SEND|SEPARATE|SEPARATED|SET|SHARED|SHIFT|SHORT|SHORTDUMP-ID|SIGN|SIGN_AS_POSTFIX|SIMPLE|SIN|SINGLE|SINH|SIZE|SKIP|SKIPPING|SMART|SOME|SORT|SORTABLE|SORTED|SOURCE|SPACE|SPECIFIED|SPLIT|SPOOL|SPOTS|SQL|SQLSCRIPT|SQRT|STABLE|STAMP|STANDARD|START-OF-SELECTION|STARTING|STATE|STATEMENT|STATEMENTS|STATIC|STATICS|STATUSINFO|STEP-LOOP|STOP|STRLEN|STRUCTURE|STRUCTURES|STYLE|SUBKEY|SUBMATCHES|SUBMIT|SUBROUTINE|SUBSCREEN|SUBSTRING|SUBTRACT|SUBTRACT-CORRESPONDING|SUFFIX|SUM|SUMMARY|SUMMING|SUPPLIED|SUPPLY|SUPPRESS|SWITCH|SWITCHSTATES|SYMBOL|SYNCPOINTS|SYNTAX|SYNTAX-CHECK|SYNTAX-TRACE|SYSTEM-CALL|SYSTEM-EXCEPTIONS|SYSTEM-EXIT|TAB|TABBED|TABLE|TABLES|TABLEVIEW|TABSTRIP|TAN|TANH|TARGET|TASK|TASKS|TEST|TESTING|TEXT|TEXTPOOL|THEN|THROW|TIME|TIMES|TIMESTAMP|TIMEZONE|TITLE|TITLE-LINES|TITLEBAR|TO|TOKENIZATION|TOKENS|TOP-LINES|TOP-OF-PAGE|TRACE-FILE|TRACE-TABLE|TRAILING|TRANSACTION|TRANSFER|TRANSFORMATION|TRANSLATE|TRANSPORTING|TRMAC|TRUNC|TRUNCATE|TRUNCATION|TRY|TYPE|TYPE-POOL|TYPE-POOLS|TYPES|ULINE|UNASSIGN|UNDER|UNICODE|UNION|UNIQUE|UNIT|UNIT_CONVERSION|UNIX|UNPACK|UNTIL|UNWIND|UP|UPDATE|UPPER|USER|USER-COMMAND|USING|UTF-8|VALID|VALUE|VALUE-REQUEST|VALUES|VARY|VARYING|VERIFICATION-MESSAGE|VERSION|VIA|VIEW|VISIBLE|WAIT|WARNING|WHEN|WHENEVER|WHERE|WHILE|WIDTH|WINDOW|WINDOWS|WITH|WITH-HEADING|WITH-TITLE|WITHOUT|WORD|WORK|WRITE|WRITER|X|XML|XOR|XSD|XSTRLEN|YELLOW|YES|YYMMDD|Z|ZERO|ZONE)(?![\w-])/i,
            lookbehind: true
        },
        /* Numbers can be only integers. Decimal or Hex appear only as strings */ number: /\b\d+\b/,
        /* Operators must always be surrounded by whitespace, they cannot be put
adjacent to operands.
*/ operator: {
            pattern: /(\s)(?:\*\*?|<[=>]?|>=?|\?=|[-+\/=])(?=\s)/,
            lookbehind: true
        },
        'string-operator': {
            pattern: /(\s)&&?(?=\s)/,
            lookbehind: true,
            /* The official editor highlights */ alias: 'keyword'
        },
        'token-operator': [
            {
                /* Special operators used to access structure components, class methods/attributes, etc. */ pattern: /(\w)(?:->?|=>|[~|{}])(?=\w)/,
                lookbehind: true,
                alias: 'punctuation'
            },
            {
                /* Special tokens used do delimit string templates */ pattern: /[|{}]/,
                alias: 'punctuation'
            }
        ],
        punctuation: /[,.:()]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $f2c34d5b5036ea21$export$2e2bcd8739ae039.displayName = 'abnf';
$f2c34d5b5036ea21$export$2e2bcd8739ae039.aliases = [];
function $f2c34d5b5036ea21$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var coreRules = '(?:ALPHA|BIT|CHAR|CR|CRLF|CTL|DIGIT|DQUOTE|HEXDIG|HTAB|LF|LWSP|OCTET|SP|VCHAR|WSP)';
        Prism.languages.abnf = {
            comment: /;.*/,
            string: {
                pattern: /(?:%[is])?"[^"\n\r]*"/,
                greedy: true,
                inside: {
                    punctuation: /^%[is]/
                }
            },
            range: {
                pattern: /%(?:b[01]+-[01]+|d\d+-\d+|x[A-F\d]+-[A-F\d]+)/i,
                alias: 'number'
            },
            terminal: {
                pattern: /%(?:b[01]+(?:\.[01]+)*|d\d+(?:\.\d+)*|x[A-F\d]+(?:\.[A-F\d]+)*)/i,
                alias: 'number'
            },
            repetition: {
                pattern: /(^|[^\w-])(?:\d*\*\d*|\d+)/,
                lookbehind: true,
                alias: 'operator'
            },
            definition: {
                pattern: /(^[ \t]*)(?:[a-z][\w-]*|<[^<>\r\n]*>)(?=\s*=)/m,
                lookbehind: true,
                alias: 'keyword',
                inside: {
                    punctuation: /<|>/
                }
            },
            'core-rule': {
                pattern: RegExp('(?:(^|[^<\\w-])' + coreRules + '|<' + coreRules + '>)(?![\\w-])', 'i'),
                lookbehind: true,
                alias: [
                    'rule',
                    'constant'
                ],
                inside: {
                    punctuation: /<|>/
                }
            },
            rule: {
                pattern: /(^|[^<\w-])[a-z][\w-]*|<[^<>\r\n]*>/i,
                lookbehind: true,
                inside: {
                    punctuation: /<|>/
                }
            },
            operator: /=\/?|\//,
            punctuation: /[()\[\]]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$9c5777c951754348$export$2e2bcd8739ae039.displayName = 'actionscript';
$9c5777c951754348$export$2e2bcd8739ae039.aliases = [];
function $9c5777c951754348$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $9f5c72e4d4e505c4$export$2e2bcd8739ae039));
    Prism.languages.actionscript = Prism.languages.extend('javascript', {
        keyword: /\b(?:as|break|case|catch|class|const|default|delete|do|dynamic|each|else|extends|final|finally|for|function|get|if|implements|import|in|include|instanceof|interface|internal|is|namespace|native|new|null|override|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|use|var|void|while|with)\b/,
        operator: /\+\+|--|(?:[+\-*\/%^]|&&?|\|\|?|<<?|>>?>?|[!=]=?)=?|[~?@]/
    });
    Prism.languages.actionscript['class-name'].alias = 'function';
    // doesn't work with AS because AS is too complex
    delete Prism.languages.actionscript['parameter'];
    delete Prism.languages.actionscript['literal-property'];
    if (Prism.languages.markup) Prism.languages.insertBefore('actionscript', 'string', {
        xml: {
            pattern: /(^|[^.])<\/?\w+(?:\s+[^\s>\/=]+=("|')(?:\\[\s\S]|(?!\2)[^\\])*\2)*\s*\/?>/,
            lookbehind: true,
            inside: Prism.languages.markup
        }
    });
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $3fbcaee7f13cf525$export$2e2bcd8739ae039.displayName = 'ada';
$3fbcaee7f13cf525$export$2e2bcd8739ae039.aliases = [];
function $3fbcaee7f13cf525$export$2e2bcd8739ae039(Prism) {
    Prism.languages.ada = {
        comment: /--.*/,
        string: /"(?:""|[^"\r\f\n])*"/,
        number: [
            {
                pattern: /\b\d(?:_?\d)*#[\dA-F](?:_?[\dA-F])*(?:\.[\dA-F](?:_?[\dA-F])*)?#(?:E[+-]?\d(?:_?\d)*)?/i
            },
            {
                pattern: /\b\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:E[+-]?\d(?:_?\d)*)?\b/i
            }
        ],
        attribute: {
            pattern: /\b'\w+/,
            alias: 'attr-name'
        },
        keyword: /\b(?:abort|abs|abstract|accept|access|aliased|all|and|array|at|begin|body|case|constant|declare|delay|delta|digits|do|else|elsif|end|entry|exception|exit|for|function|generic|goto|if|in|interface|is|limited|loop|mod|new|not|null|of|or|others|out|overriding|package|pragma|private|procedure|protected|raise|range|record|rem|renames|requeue|return|reverse|select|separate|some|subtype|synchronized|tagged|task|terminate|then|type|until|use|when|while|with|xor)\b/i,
        boolean: /\b(?:false|true)\b/i,
        operator: /<[=>]?|>=?|=>?|:=|\/=?|\*\*?|[&+-]/,
        punctuation: /\.\.?|[,;():]/,
        char: /'.'/,
        variable: /\b[a-z](?:\w)*\b/i
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $1e3beec4fc9f23f6$export$2e2bcd8739ae039.displayName = 'agda';
$1e3beec4fc9f23f6$export$2e2bcd8739ae039.aliases = [];
function $1e3beec4fc9f23f6$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.agda = {
            comment: /\{-[\s\S]*?(?:-\}|$)|--.*/,
            string: {
                pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
                greedy: true
            },
            punctuation: /[(){}⦃⦄.;@]/,
            'class-name': {
                pattern: /((?:data|record) +)\S+/,
                lookbehind: true
            },
            function: {
                pattern: /(^[ \t]*)(?!\s)[^:\r\n]+(?=:)/m,
                lookbehind: true
            },
            operator: {
                pattern: /(^\s*|\s)(?:[=|:∀→λ\\?_]|->)(?=\s)/,
                lookbehind: true
            },
            keyword: /\b(?:Set|abstract|constructor|data|eta-equality|field|forall|hiding|import|in|inductive|infix|infixl|infixr|instance|let|macro|module|mutual|no-eta-equality|open|overlap|pattern|postulate|primitive|private|public|quote|quoteContext|quoteGoal|quoteTerm|record|renaming|rewrite|syntax|tactic|unquote|unquoteDecl|unquoteDef|using|variable|where|with)\b/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $11e7abe0f8ae59d5$export$2e2bcd8739ae039.displayName = 'al';
$11e7abe0f8ae59d5$export$2e2bcd8739ae039.aliases = [];
function $11e7abe0f8ae59d5$export$2e2bcd8739ae039(Prism) {
    // based on https://github.com/microsoft/AL/blob/master/grammar/alsyntax.tmlanguage
    Prism.languages.al = {
        comment: /\/\/.*|\/\*[\s\S]*?\*\//,
        string: {
            pattern: /'(?:''|[^'\r\n])*'(?!')|"(?:""|[^"\r\n])*"(?!")/,
            greedy: true
        },
        function: {
            pattern: /(\b(?:event|procedure|trigger)\s+|(?:^|[^.])\.\s*)[a-z_]\w*(?=\s*\()/i,
            lookbehind: true
        },
        keyword: [
            // keywords
            /\b(?:array|asserterror|begin|break|case|do|downto|else|end|event|exit|for|foreach|function|if|implements|in|indataset|interface|internal|local|of|procedure|program|protected|repeat|runonclient|securityfiltering|suppressdispose|temporary|then|to|trigger|until|var|while|with|withevents)\b/i,
            // objects and metadata that are used like keywords
            /\b(?:action|actions|addafter|addbefore|addfirst|addlast|area|assembly|chartpart|codeunit|column|controladdin|cuegroup|customizes|dataitem|dataset|dotnet|elements|enum|enumextension|extends|field|fieldattribute|fieldelement|fieldgroup|fieldgroups|fields|filter|fixed|grid|group|key|keys|label|labels|layout|modify|moveafter|movebefore|movefirst|movelast|page|pagecustomization|pageextension|part|profile|query|repeater|report|requestpage|schema|separator|systempart|table|tableelement|tableextension|textattribute|textelement|type|usercontrol|value|xmlport)\b/i
        ],
        number: /\b(?:0x[\da-f]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?)(?:F|LL?|U(?:LL?)?)?\b/i,
        boolean: /\b(?:false|true)\b/i,
        variable: /\b(?:Curr(?:FieldNo|Page|Report)|x?Rec|RequestOptionsPage)\b/,
        'class-name': /\b(?:automation|biginteger|bigtext|blob|boolean|byte|char|clienttype|code|completiontriggererrorlevel|connectiontype|database|dataclassification|datascope|date|dateformula|datetime|decimal|defaultlayout|dialog|dictionary|dotnetassembly|dotnettypedeclaration|duration|errorinfo|errortype|executioncontext|executionmode|fieldclass|fieldref|fieldtype|file|filterpagebuilder|guid|httpclient|httpcontent|httpheaders|httprequestmessage|httpresponsemessage|instream|integer|joker|jsonarray|jsonobject|jsontoken|jsonvalue|keyref|list|moduledependencyinfo|moduleinfo|none|notification|notificationscope|objecttype|option|outstream|pageresult|record|recordid|recordref|reportformat|securityfilter|sessionsettings|tableconnectiontype|tablefilter|testaction|testfield|testfilterfield|testpage|testpermissions|testrequestpage|text|textbuilder|textconst|textencoding|time|transactionmodel|transactiontype|variant|verbosity|version|view|views|webserviceactioncontext|webserviceactionresultcode|xmlattribute|xmlattributecollection|xmlcdata|xmlcomment|xmldeclaration|xmldocument|xmldocumenttype|xmlelement|xmlnamespacemanager|xmlnametable|xmlnode|xmlnodelist|xmlprocessinginstruction|xmlreadoptions|xmltext|xmlwriteoptions)\b/i,
        operator: /\.\.|:[=:]|[-+*/]=?|<>|[<>]=?|=|\b(?:and|div|mod|not|or|xor)\b/i,
        punctuation: /[()\[\]{}:.;,]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $25cd74edc1a4e282$export$2e2bcd8739ae039.displayName = 'antlr4';
$25cd74edc1a4e282$export$2e2bcd8739ae039.aliases = [
    'g4'
];
function $25cd74edc1a4e282$export$2e2bcd8739ae039(Prism) {
    Prism.languages.antlr4 = {
        comment: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
        string: {
            pattern: /'(?:\\.|[^\\'\r\n])*'/,
            greedy: true
        },
        'character-class': {
            pattern: /\[(?:\\.|[^\\\]\r\n])*\]/,
            greedy: true,
            alias: 'regex',
            inside: {
                range: {
                    pattern: /([^[]|(?:^|[^\\])(?:\\\\)*\\\[)-(?!\])/,
                    lookbehind: true,
                    alias: 'punctuation'
                },
                escape: /\\(?:u(?:[a-fA-F\d]{4}|\{[a-fA-F\d]+\})|[pP]\{[=\w-]+\}|[^\r\nupP])/,
                punctuation: /[\[\]]/
            }
        },
        action: {
            pattern: /\{(?:[^{}]|\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*\}/,
            greedy: true,
            inside: {
                content: {
                    // this might be C, C++, Python, Java, C#, or any other language ANTLR4 compiles to
                    pattern: /(\{)[\s\S]+(?=\})/,
                    lookbehind: true
                },
                punctuation: /[{}]/
            }
        },
        command: {
            pattern: /(->\s*(?!\s))(?:\s*(?:,\s*)?\b[a-z]\w*(?:\s*\([^()\r\n]*\))?)+(?=\s*;)/i,
            lookbehind: true,
            inside: {
                function: /\b\w+(?=\s*(?:[,(]|$))/,
                punctuation: /[,()]/
            }
        },
        annotation: {
            pattern: /@\w+(?:::\w+)*/,
            alias: 'keyword'
        },
        label: {
            pattern: /#[ \t]*\w+/,
            alias: 'punctuation'
        },
        keyword: /\b(?:catch|channels|finally|fragment|grammar|import|lexer|locals|mode|options|parser|returns|throws|tokens)\b/,
        definition: [
            {
                pattern: /\b[a-z]\w*(?=\s*:)/,
                alias: [
                    'rule',
                    'class-name'
                ]
            },
            {
                pattern: /\b[A-Z]\w*(?=\s*:)/,
                alias: [
                    'token',
                    'constant'
                ]
            }
        ],
        constant: /\b[A-Z][A-Z_]*\b/,
        operator: /\.\.|->|[|~]|[*+?]\??/,
        punctuation: /[;:()=]/
    };
    Prism.languages.g4 = Prism.languages.antlr4;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $e56b6d9acce907cb$export$2e2bcd8739ae039.displayName = 'apacheconf';
$e56b6d9acce907cb$export$2e2bcd8739ae039.aliases = [];
function $e56b6d9acce907cb$export$2e2bcd8739ae039(Prism) {
    Prism.languages.apacheconf = {
        comment: /#.*/,
        'directive-inline': {
            pattern: /(^[\t ]*)\b(?:AcceptFilter|AcceptPathInfo|AccessFileName|Action|Add(?:Alt|AltByEncoding|AltByType|Charset|DefaultCharset|Description|Encoding|Handler|Icon|IconByEncoding|IconByType|InputFilter|Language|ModuleInfo|OutputFilter|OutputFilterByType|Type)|Alias|AliasMatch|Allow(?:CONNECT|EncodedSlashes|Methods|Override|OverrideList)?|Anonymous(?:_LogEmail|_MustGiveEmail|_NoUserID|_VerifyEmail)?|AsyncRequestWorkerFactor|Auth(?:BasicAuthoritative|BasicFake|BasicProvider|BasicUseDigestAlgorithm|DBDUserPWQuery|DBDUserRealmQuery|DBMGroupFile|DBMType|DBMUserFile|Digest(?:Algorithm|Domain|NonceLifetime|Provider|Qop|ShmemSize)|Form(?:Authoritative|Body|DisableNoStore|FakeBasicAuth|Location|LoginRequiredLocation|LoginSuccessLocation|LogoutLocation|Method|Mimetype|Password|Provider|SitePassphrase|Size|Username)|GroupFile|LDAP(?:AuthorizePrefix|BindAuthoritative|BindDN|BindPassword|CharsetConfig|CompareAsUser|CompareDNOnServer|DereferenceAliases|GroupAttribute|GroupAttributeIsDN|InitialBindAsUser|InitialBindPattern|MaxSubGroupDepth|RemoteUserAttribute|RemoteUserIsDN|SearchAsUser|SubGroupAttribute|SubGroupClass|Url)|Merging|Name|nCache(?:Context|Enable|ProvideFor|SOCache|Timeout)|nzFcgiCheckAuthnProvider|nzFcgiDefineProvider|Type|UserFile|zDBDLoginToReferer|zDBDQuery|zDBDRedirectQuery|zDBMType|zSendForbiddenOnFailure)|BalancerGrowth|BalancerInherit|BalancerMember|BalancerPersist|BrowserMatch|BrowserMatchNoCase|BufferedLogs|BufferSize|Cache(?:DefaultExpire|DetailHeader|DirLength|DirLevels|Disable|Enable|File|Header|IgnoreCacheControl|IgnoreHeaders|IgnoreNoLastMod|IgnoreQueryString|IgnoreURLSessionIdentifiers|KeyBaseURL|LastModifiedFactor|Lock|LockMaxAge|LockPath|MaxExpire|MaxFileSize|MinExpire|MinFileSize|NegotiatedDocs|QuickHandler|ReadSize|ReadTime|Root|Socache(?:MaxSize|MaxTime|MinTime|ReadSize|ReadTime)?|StaleOnError|StoreExpired|StoreNoStore|StorePrivate)|CGIDScriptTimeout|CGIMapExtension|CharsetDefault|CharsetOptions|CharsetSourceEnc|CheckCaseOnly|CheckSpelling|ChrootDir|ContentDigest|CookieDomain|CookieExpires|CookieName|CookieStyle|CookieTracking|CoreDumpDirectory|CustomLog|Dav|DavDepthInfinity|DavGenericLockDB|DavLockDB|DavMinTimeout|DBDExptime|DBDInitSQL|DBDKeep|DBDMax|DBDMin|DBDParams|DBDPersist|DBDPrepareSQL|DBDriver|DefaultIcon|DefaultLanguage|DefaultRuntimeDir|DefaultType|Define|Deflate(?:BufferSize|CompressionLevel|FilterNote|InflateLimitRequestBody|InflateRatio(?:Burst|Limit)|MemLevel|WindowSize)|Deny|DirectoryCheckHandler|DirectoryIndex|DirectoryIndexRedirect|DirectorySlash|DocumentRoot|DTracePrivileges|DumpIOInput|DumpIOOutput|EnableExceptionHook|EnableMMAP|EnableSendfile|Error|ErrorDocument|ErrorLog|ErrorLogFormat|Example|ExpiresActive|ExpiresByType|ExpiresDefault|ExtendedStatus|ExtFilterDefine|ExtFilterOptions|FallbackResource|FileETag|FilterChain|FilterDeclare|FilterProtocol|FilterProvider|FilterTrace|ForceLanguagePriority|ForceType|ForensicLog|GprofDir|GracefulShutdownTimeout|Group|Header|HeaderName|Heartbeat(?:Address|Listen|MaxServers|Storage)|HostnameLookups|IdentityCheck|IdentityCheckTimeout|ImapBase|ImapDefault|ImapMenu|Include|IncludeOptional|Index(?:HeadInsert|Ignore|IgnoreReset|Options|OrderDefault|StyleSheet)|InputSed|ISAPI(?:AppendLogToErrors|AppendLogToQuery|CacheFile|FakeAsync|LogNotSupported|ReadAheadBuffer)|KeepAlive|KeepAliveTimeout|KeptBodySize|LanguagePriority|LDAP(?:CacheEntries|CacheTTL|ConnectionPoolTTL|ConnectionTimeout|LibraryDebug|OpCacheEntries|OpCacheTTL|ReferralHopLimit|Referrals|Retries|RetryDelay|SharedCacheFile|SharedCacheSize|Timeout|TrustedClientCert|TrustedGlobalCert|TrustedMode|VerifyServerCert)|Limit(?:InternalRecursion|Request(?:Body|Fields|FieldSize|Line)|XMLRequestBody)|Listen|ListenBackLog|LoadFile|LoadModule|LogFormat|LogLevel|LogMessage|LuaAuthzProvider|LuaCodeCache|Lua(?:Hook(?:AccessChecker|AuthChecker|CheckUserID|Fixups|InsertFilter|Log|MapToStorage|TranslateName|TypeChecker)|Inherit|InputFilter|MapHandler|OutputFilter|PackageCPath|PackagePath|QuickHandler|Root|Scope)|Max(?:ConnectionsPerChild|KeepAliveRequests|MemFree|RangeOverlaps|RangeReversals|Ranges|RequestWorkers|SpareServers|SpareThreads|Threads)|MergeTrailers|MetaDir|MetaFiles|MetaSuffix|MimeMagicFile|MinSpareServers|MinSpareThreads|MMapFile|ModemStandard|ModMimeUsePathInfo|MultiviewsMatch|Mutex|NameVirtualHost|NoProxy|NWSSLTrustedCerts|NWSSLUpgradeable|Options|Order|OutputSed|PassEnv|PidFile|PrivilegesMode|Protocol|ProtocolEcho|Proxy(?:AddHeaders|BadHeader|Block|Domain|ErrorOverride|ExpressDBMFile|ExpressDBMType|ExpressEnable|FtpDirCharset|FtpEscapeWildcards|FtpListOnWildcard|HTML(?:BufSize|CharsetOut|DocType|Enable|Events|Extended|Fixups|Interp|Links|Meta|StripComments|URLMap)|IOBufferSize|MaxForwards|Pass(?:Inherit|InterpolateEnv|Match|Reverse|ReverseCookieDomain|ReverseCookiePath)?|PreserveHost|ReceiveBufferSize|Remote|RemoteMatch|Requests|SCGIInternalRedirect|SCGISendfile|Set|SourceAddress|Status|Timeout|Via)|ReadmeName|ReceiveBufferSize|Redirect|RedirectMatch|RedirectPermanent|RedirectTemp|ReflectorHeader|RemoteIP(?:Header|InternalProxy|InternalProxyList|ProxiesHeader|TrustedProxy|TrustedProxyList)|RemoveCharset|RemoveEncoding|RemoveHandler|RemoveInputFilter|RemoveLanguage|RemoveOutputFilter|RemoveType|RequestHeader|RequestReadTimeout|Require|Rewrite(?:Base|Cond|Engine|Map|Options|Rule)|RLimitCPU|RLimitMEM|RLimitNPROC|Satisfy|ScoreBoardFile|Script(?:Alias|AliasMatch|InterpreterSource|Log|LogBuffer|LogLength|Sock)?|SecureListen|SeeRequestTail|SendBufferSize|Server(?:Admin|Alias|Limit|Name|Path|Root|Signature|Tokens)|Session(?:Cookie(?:Name|Name2|Remove)|Crypto(?:Cipher|Driver|Passphrase|PassphraseFile)|DBD(?:CookieName|CookieName2|CookieRemove|DeleteLabel|InsertLabel|PerUser|SelectLabel|UpdateLabel)|Env|Exclude|Header|Include|MaxAge)?|SetEnv|SetEnvIf|SetEnvIfExpr|SetEnvIfNoCase|SetHandler|SetInputFilter|SetOutputFilter|SSIEndTag|SSIErrorMsg|SSIETag|SSILastModified|SSILegacyExprParser|SSIStartTag|SSITimeFormat|SSIUndefinedEcho|SSL(?:CACertificateFile|CACertificatePath|CADNRequestFile|CADNRequestPath|CARevocationCheck|CARevocationFile|CARevocationPath|CertificateChainFile|CertificateFile|CertificateKeyFile|CipherSuite|Compression|CryptoDevice|Engine|FIPS|HonorCipherOrder|InsecureRenegotiation|OCSP(?:DefaultResponder|Enable|OverrideResponder|ResponderTimeout|ResponseMaxAge|ResponseTimeSkew|UseRequestNonce)|OpenSSLConfCmd|Options|PassPhraseDialog|Protocol|Proxy(?:CACertificateFile|CACertificatePath|CARevocation(?:Check|File|Path)|CheckPeer(?:CN|Expire|Name)|CipherSuite|Engine|MachineCertificate(?:ChainFile|File|Path)|Protocol|Verify|VerifyDepth)|RandomSeed|RenegBufferSize|Require|RequireSSL|Session(?:Cache|CacheTimeout|TicketKeyFile|Tickets)|SRPUnknownUserSeed|SRPVerifierFile|Stapling(?:Cache|ErrorCacheTimeout|FakeTryLater|ForceURL|ResponderTimeout|ResponseMaxAge|ResponseTimeSkew|ReturnResponderErrors|StandardCacheTimeout)|StrictSNIVHostCheck|UserName|UseStapling|VerifyClient|VerifyDepth)|StartServers|StartThreads|Substitute|Suexec|SuexecUserGroup|ThreadLimit|ThreadsPerChild|ThreadStackSize|TimeOut|TraceEnable|TransferLog|TypesConfig|UnDefine|UndefMacro|UnsetEnv|Use|UseCanonicalName|UseCanonicalPhysicalPort|User|UserDir|VHostCGIMode|VHostCGIPrivs|VHostGroup|VHostPrivs|VHostSecure|VHostUser|Virtual(?:DocumentRoot|ScriptAlias)(?:IP)?|WatchdogInterval|XBitHack|xml2EncAlias|xml2EncDefault|xml2StartParse)\b/im,
            lookbehind: true,
            alias: 'property'
        },
        'directive-block': {
            pattern: /<\/?\b(?:Auth[nz]ProviderAlias|Directory|DirectoryMatch|Else|ElseIf|Files|FilesMatch|If|IfDefine|IfModule|IfVersion|Limit|LimitExcept|Location|LocationMatch|Macro|Proxy|Require(?:All|Any|None)|VirtualHost)\b.*>/i,
            inside: {
                'directive-block': {
                    pattern: /^<\/?\w+/,
                    inside: {
                        punctuation: /^<\/?/
                    },
                    alias: 'tag'
                },
                'directive-block-parameter': {
                    pattern: /.*[^>]/,
                    inside: {
                        punctuation: /:/,
                        string: {
                            pattern: /("|').*\1/,
                            inside: {
                                variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/
                            }
                        }
                    },
                    alias: 'attr-value'
                },
                punctuation: />/
            },
            alias: 'tag'
        },
        'directive-flags': {
            pattern: /\[(?:[\w=],?)+\]/,
            alias: 'keyword'
        },
        string: {
            pattern: /("|').*\1/,
            inside: {
                variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/
            }
        },
        variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/,
        regex: /\^?.*\$|\^.*\$?/
    };
}



// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 

$f6a7ab632d408f5f$export$2e2bcd8739ae039.displayName = 'apex';
$f6a7ab632d408f5f$export$2e2bcd8739ae039.aliases = [];
function $f6a7ab632d408f5f$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    Prism.register((0, $d138d4e60ec637d4$export$2e2bcd8739ae039));
    (function(Prism) {
        var keywords = /\b(?:(?:after|before)(?=\s+[a-z])|abstract|activate|and|any|array|as|asc|autonomous|begin|bigdecimal|blob|boolean|break|bulk|by|byte|case|cast|catch|char|class|collect|commit|const|continue|currency|date|datetime|decimal|default|delete|desc|do|double|else|end|enum|exception|exit|export|extends|final|finally|float|for|from|get(?=\s*[{};])|global|goto|group|having|hint|if|implements|import|in|inner|insert|instanceof|int|integer|interface|into|join|like|limit|list|long|loop|map|merge|new|not|null|nulls|number|object|of|on|or|outer|override|package|parallel|pragma|private|protected|public|retrieve|return|rollback|select|set|short|sObject|sort|static|string|super|switch|synchronized|system|testmethod|then|this|throw|time|transaction|transient|trigger|try|undelete|update|upsert|using|virtual|void|webservice|when|where|while|(?:inherited|with|without)\s+sharing)\b/i;
        var className = /\b(?:(?=[a-z_]\w*\s*[<\[])|(?!<keyword>))[A-Z_]\w*(?:\s*\.\s*[A-Z_]\w*)*\b(?:\s*(?:\[\s*\]|<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>))*/.source.replace(/<keyword>/g, function() {
            return keywords.source;
        });
        /** @param {string} pattern */ function insertClassName(pattern) {
            return RegExp(pattern.replace(/<CLASS-NAME>/g, function() {
                return className;
            }), 'i');
        }
        var classNameInside = {
            keyword: keywords,
            punctuation: /[()\[\]{};,:.<>]/
        };
        Prism.languages.apex = {
            comment: Prism.languages.clike.comment,
            string: Prism.languages.clike.string,
            sql: {
                pattern: /((?:[=,({:]|\breturn)\s*)\[[^\[\]]*\]/i,
                lookbehind: true,
                greedy: true,
                alias: 'language-sql',
                inside: Prism.languages.sql
            },
            annotation: {
                pattern: /@\w+\b/,
                alias: 'punctuation'
            },
            'class-name': [
                {
                    pattern: insertClassName(/(\b(?:class|enum|extends|implements|instanceof|interface|new|trigger\s+\w+\s+on)\s+)<CLASS-NAME>/.source),
                    lookbehind: true,
                    inside: classNameInside
                },
                {
                    // cast
                    pattern: insertClassName(/(\(\s*)<CLASS-NAME>(?=\s*\)\s*[\w(])/.source),
                    lookbehind: true,
                    inside: classNameInside
                },
                {
                    // variable/parameter declaration and return types
                    pattern: insertClassName(/<CLASS-NAME>(?=\s*\w+\s*[;=,(){:])/.source),
                    inside: classNameInside
                }
            ],
            trigger: {
                pattern: /(\btrigger\s+)\w+\b/i,
                lookbehind: true,
                alias: 'class-name'
            },
            keyword: keywords,
            function: /\b[a-z_]\w*(?=\s*\()/i,
            boolean: /\b(?:false|true)\b/i,
            number: /(?:\B\.\d+|\b\d+(?:\.\d+|L)?)\b/i,
            operator: /[!=](?:==?)?|\?\.?|&&|\|\||--|\+\+|[-+*/^&|]=?|:|<<?=?|>{1,3}=?/,
            punctuation: /[()\[\]{};,.]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $b46a22bd2beca28f$export$2e2bcd8739ae039.displayName = 'apl';
$b46a22bd2beca28f$export$2e2bcd8739ae039.aliases = [];
function $b46a22bd2beca28f$export$2e2bcd8739ae039(Prism) {
    Prism.languages.apl = {
        comment: /(?:⍝|#[! ]).*$/m,
        string: {
            pattern: /'(?:[^'\r\n]|'')*'/,
            greedy: true
        },
        number: /¯?(?:\d*\.?\b\d+(?:e[+¯]?\d+)?|¯|∞)(?:j¯?(?:(?:\d+(?:\.\d+)?|\.\d+)(?:e[+¯]?\d+)?|¯|∞))?/i,
        statement: /:[A-Z][a-z][A-Za-z]*\b/,
        'system-function': {
            pattern: /⎕[A-Z]+/i,
            alias: 'function'
        },
        constant: /[⍬⌾#⎕⍞]/,
        function: /[-+×÷⌈⌊∣|⍳⍸?*⍟○!⌹<≤=>≥≠≡≢∊⍷∪∩~∨∧⍱⍲⍴,⍪⌽⊖⍉↑↓⊂⊃⊆⊇⌷⍋⍒⊤⊥⍕⍎⊣⊢⍁⍂≈⍯↗¤→]/,
        'monadic-operator': {
            pattern: /[\\\/⌿⍀¨⍨⌶&∥]/,
            alias: 'operator'
        },
        'dyadic-operator': {
            pattern: /[.⍣⍠⍤∘⌸@⌺⍥]/,
            alias: 'operator'
        },
        assignment: {
            pattern: /←/,
            alias: 'keyword'
        },
        punctuation: /[\[;\]()◇⋄]/,
        dfn: {
            pattern: /[{}⍺⍵⍶⍹∇⍫:]/,
            alias: 'builtin'
        }
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $b984cf4709600aa3$export$2e2bcd8739ae039.displayName = 'applescript';
$b984cf4709600aa3$export$2e2bcd8739ae039.aliases = [];
function $b984cf4709600aa3$export$2e2bcd8739ae039(Prism) {
    Prism.languages.applescript = {
        comment: [
            // Allow one level of nesting
            /\(\*(?:\(\*(?:[^*]|\*(?!\)))*\*\)|(?!\(\*)[\s\S])*?\*\)/,
            /--.+/,
            /#.+/
        ],
        string: /"(?:\\.|[^"\\\r\n])*"/,
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e-?\d+)?\b/i,
        operator: [
            /[&=≠≤≥*+\-\/÷^]|[<>]=?/,
            /\b(?:(?:begin|end|start)s? with|(?:contains?|(?:does not|doesn't) contain)|(?:is|isn't|is not) (?:contained by|in)|(?:(?:is|isn't|is not) )?(?:greater|less) than(?: or equal)?(?: to)?|(?:comes|(?:does not|doesn't) come) (?:after|before)|(?:is|isn't|is not) equal(?: to)?|(?:(?:does not|doesn't) equal|equal to|equals|is not|isn't)|(?:a )?(?:ref(?: to)?|reference to)|(?:and|as|div|mod|not|or))\b/
        ],
        keyword: /\b(?:about|above|after|against|apart from|around|aside from|at|back|before|beginning|behind|below|beneath|beside|between|but|by|considering|continue|copy|does|eighth|else|end|equal|error|every|exit|false|fifth|first|for|fourth|from|front|get|given|global|if|ignoring|in|instead of|into|is|it|its|last|local|me|middle|my|ninth|of|on|onto|out of|over|prop|property|put|repeat|return|returning|second|set|seventh|since|sixth|some|tell|tenth|that|the|then|third|through|thru|timeout|times|to|transaction|true|try|until|where|while|whose|with|without)\b/,
        'class-name': /\b(?:POSIX file|RGB color|alias|application|boolean|centimeters|centimetres|class|constant|cubic centimeters|cubic centimetres|cubic feet|cubic inches|cubic meters|cubic metres|cubic yards|date|degrees Celsius|degrees Fahrenheit|degrees Kelvin|feet|file|gallons|grams|inches|integer|kilograms|kilometers|kilometres|list|liters|litres|meters|metres|miles|number|ounces|pounds|quarts|real|record|reference|script|square feet|square kilometers|square kilometres|square meters|square metres|square miles|square yards|text|yards)\b/,
        punctuation: /[{}():,¬«»《》]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $ccd0ef58eb523678$export$2e2bcd8739ae039.displayName = 'aql';
$ccd0ef58eb523678$export$2e2bcd8739ae039.aliases = [];
function $ccd0ef58eb523678$export$2e2bcd8739ae039(Prism) {
    Prism.languages.aql = {
        comment: /\/\/.*|\/\*[\s\S]*?\*\//,
        property: {
            pattern: /([{,]\s*)(?:(?!\d)\w+|(["'´`])(?:(?!\2)[^\\\r\n]|\\.)*\2)(?=\s*:)/,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /(["'])(?:(?!\1)[^\\\r\n]|\\.)*\1/,
            greedy: true
        },
        identifier: {
            pattern: /([´`])(?:(?!\1)[^\\\r\n]|\\.)*\1/,
            greedy: true
        },
        variable: /@@?\w+/,
        keyword: [
            {
                pattern: /(\bWITH\s+)COUNT(?=\s+INTO\b)/i,
                lookbehind: true
            },
            /\b(?:AGGREGATE|ALL|AND|ANY|ASC|COLLECT|DESC|DISTINCT|FILTER|FOR|GRAPH|IN|INBOUND|INSERT|INTO|K_PATHS|K_SHORTEST_PATHS|LET|LIKE|LIMIT|NONE|NOT|NULL|OR|OUTBOUND|REMOVE|REPLACE|RETURN|SHORTEST_PATH|SORT|UPDATE|UPSERT|WINDOW|WITH)\b/i,
            // pseudo keywords get a lookbehind to avoid false positives
            {
                pattern: /(^|[^\w.[])(?:KEEP|PRUNE|SEARCH|TO)\b/i,
                lookbehind: true
            },
            {
                pattern: /(^|[^\w.[])(?:CURRENT|NEW|OLD)\b/,
                lookbehind: true
            },
            {
                pattern: /\bOPTIONS(?=\s*\{)/i
            }
        ],
        function: /\b(?!\d)\w+(?=\s*\()/,
        boolean: /\b(?:false|true)\b/i,
        range: {
            pattern: /\.\./,
            alias: 'operator'
        },
        number: [
            /\b0b[01]+/i,
            /\b0x[0-9a-f]+/i,
            /(?:\B\.\d+|\b(?:0|[1-9]\d*)(?:\.\d+)?)(?:e[+-]?\d+)?/i
        ],
        operator: /\*{2,}|[=!]~|[!=<>]=?|&&|\|\||[-+*/%]/,
        punctuation: /::|[?.:,;()[\]{}]/
    };
}





// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $efa7ad86ceca52d0$export$2e2bcd8739ae039.displayName = 'arff';
$efa7ad86ceca52d0$export$2e2bcd8739ae039.aliases = [];
function $efa7ad86ceca52d0$export$2e2bcd8739ae039(Prism) {
    Prism.languages.arff = {
        comment: /%.*/,
        string: {
            pattern: /(["'])(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        keyword: /@(?:attribute|data|end|relation)\b/i,
        number: /\b\d+(?:\.\d+)?\b/,
        punctuation: /[{},]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $67cc3be7e12a4376$export$2e2bcd8739ae039.displayName = 'armasm';
$67cc3be7e12a4376$export$2e2bcd8739ae039.aliases = [
    'arm-asm'
];
function $67cc3be7e12a4376$export$2e2bcd8739ae039(Prism) {
    Prism.languages.armasm = {
        comment: {
            pattern: /;.*/,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"\r\n]|"")*"/,
            greedy: true,
            inside: {
                variable: {
                    pattern: /((?:^|[^$])(?:\${2})*)\$\w+/,
                    lookbehind: true
                }
            }
        },
        char: {
            pattern: /'(?:[^'\r\n]{0,4}|'')'/,
            greedy: true
        },
        'version-symbol': {
            pattern: /\|[\w@]+\|/,
            greedy: true,
            alias: 'property'
        },
        boolean: /\b(?:FALSE|TRUE)\b/,
        directive: {
            pattern: /\b(?:ALIAS|ALIGN|AREA|ARM|ASSERT|ATTR|CN|CODE|CODE16|CODE32|COMMON|CP|DATA|DCB|DCD|DCDO|DCDU|DCFD|DCFDU|DCI|DCQ|DCQU|DCW|DCWU|DN|ELIF|ELSE|END|ENDFUNC|ENDIF|ENDP|ENTRY|EQU|EXPORT|EXPORTAS|EXTERN|FIELD|FILL|FN|FUNCTION|GBLA|GBLL|GBLS|GET|GLOBAL|IF|IMPORT|INCBIN|INCLUDE|INFO|KEEP|LCLA|LCLL|LCLS|LTORG|MACRO|MAP|MEND|MEXIT|NOFP|OPT|PRESERVE8|PROC|QN|READONLY|RELOC|REQUIRE|REQUIRE8|RLIST|ROUT|SETA|SETL|SETS|SN|SPACE|SUBT|THUMB|THUMBX|TTL|WEND|WHILE)\b/,
            alias: 'property'
        },
        instruction: {
            pattern: /((?:^|(?:^|[^\\])(?:\r\n?|\n))[ \t]*(?:(?:[A-Z][A-Z0-9_]*[a-z]\w*|[a-z]\w*|\d+)[ \t]+)?)\b[A-Z.]+\b/,
            lookbehind: true,
            alias: 'keyword'
        },
        variable: /\$\w+/,
        number: /(?:\b[2-9]_\d+|(?:\b\d+(?:\.\d+)?|\B\.\d+)(?:e-?\d+)?|\b0(?:[fd]_|x)[0-9a-f]+|&[0-9a-f]+)\b/i,
        register: {
            pattern: /\b(?:r\d|lr)\b/,
            alias: 'symbol'
        },
        operator: /<>|<<|>>|&&|\|\||[=!<>/]=?|[+\-*%#?&|^]|:[A-Z]+:/,
        punctuation: /[()[\],]/
    };
    Prism.languages['arm-asm'] = Prism.languages.armasm;
}





// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $4ebb7b212204c818$export$2e2bcd8739ae039.displayName = 'arturo';
$4ebb7b212204c818$export$2e2bcd8739ae039.aliases = [
    'art'
];
function $4ebb7b212204c818$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        /**
     * @param {string} lang
     * @param {string} pattern
     */ var createLanguageString = function(lang, pattern) {
            return {
                pattern: RegExp(/\{!/.source + '(?:' + (pattern || lang) + ')' + /$[\s\S]*\}/.source, 'm'),
                greedy: true,
                inside: {
                    embedded: {
                        pattern: /(^\{!\w+\b)[\s\S]+(?=\}$)/,
                        lookbehind: true,
                        alias: 'language-' + lang,
                        inside: Prism.languages[lang]
                    },
                    string: /[\s\S]+/
                }
            };
        };
        Prism.languages.arturo = {
            comment: {
                pattern: /;.*/,
                greedy: true
            },
            character: {
                pattern: /`.`/,
                alias: 'char',
                greedy: true
            },
            number: {
                pattern: /\b\d+(?:\.\d+(?:\.\d+(?:-[\w+-]+)?)?)?\b/
            },
            string: {
                pattern: /"(?:[^"\\\r\n]|\\.)*"/,
                greedy: true
            },
            regex: {
                pattern: /\{\/.*?\/\}/,
                greedy: true
            },
            'html-string': createLanguageString('html'),
            'css-string': createLanguageString('css'),
            'js-string': createLanguageString('js'),
            'md-string': createLanguageString('md'),
            'sql-string': createLanguageString('sql'),
            'sh-string': createLanguageString('shell', 'sh'),
            multistring: {
                pattern: /».*|\{:[\s\S]*?:\}|\{[\s\S]*?\}|^-{6}$[\s\S]*/m,
                alias: 'string',
                greedy: true
            },
            label: {
                pattern: /\w+\b\??:/,
                alias: 'property'
            },
            literal: {
                pattern: /'(?:\w+\b\??:?)/,
                alias: 'constant'
            },
            type: {
                pattern: /:(?:\w+\b\??:?)/,
                alias: 'class-name'
            },
            color: /#\w+/,
            predicate: {
                pattern: /\b(?:all|and|any|ascii|attr|attribute|attributeLabel|binary|block|char|contains|database|date|dictionary|empty|equal|even|every|exists|false|floating|function|greater|greaterOrEqual|if|in|inline|integer|is|key|label|leap|less|lessOrEqual|literal|logical|lower|nand|negative|nor|not|notEqual|null|numeric|odd|or|path|pathLabel|positive|prefix|prime|regex|same|set|some|sorted|standalone|string|subset|suffix|superset|symbol|symbolLiteral|true|try|type|unless|upper|when|whitespace|word|xnor|xor|zero)\?/,
                alias: 'keyword'
            },
            'builtin-function': {
                pattern: /\b(?:abs|acos|acosh|acsec|acsech|actan|actanh|add|after|alert|alias|and|angle|append|arg|args|arity|array|as|asec|asech|asin|asinh|atan|atan2|atanh|attr|attrs|average|before|benchmark|blend|break|call|capitalize|case|ceil|chop|clear|clip|close|color|combine|conj|continue|copy|cos|cosh|crc|csec|csech|ctan|ctanh|cursor|darken|dec|decode|define|delete|desaturate|deviation|dialog|dictionary|difference|digest|digits|div|do|download|drop|dup|e|else|empty|encode|ensure|env|escape|execute|exit|exp|extend|extract|factors|fdiv|filter|first|flatten|floor|fold|from|function|gamma|gcd|get|goto|hash|hypot|if|inc|indent|index|infinity|info|input|insert|inspect|intersection|invert|jaro|join|keys|kurtosis|last|let|levenshtein|lighten|list|ln|log|loop|lower|mail|map|match|max|median|min|mod|module|mul|nand|neg|new|nor|normalize|not|now|null|open|or|outdent|pad|palette|panic|path|pause|permissions|permutate|pi|pop|popup|pow|powerset|powmod|prefix|print|prints|process|product|query|random|range|read|relative|remove|rename|render|repeat|replace|request|return|reverse|round|sample|saturate|script|sec|sech|select|serve|set|shl|shr|shuffle|sin|sinh|size|skewness|slice|sort|spin|split|sqrt|squeeze|stack|strip|sub|suffix|sum|switch|symbols|symlink|sys|take|tan|tanh|terminal|terminate|to|truncate|try|type|unclip|union|unique|unless|until|unzip|upper|values|var|variance|volume|webview|while|with|wordwrap|write|xnor|xor|zip)\b/,
                alias: 'keyword'
            },
            sugar: {
                pattern: /->|=>|\||::/,
                alias: 'operator'
            },
            punctuation: /[()[\],]/,
            symbol: {
                pattern: /<:|-:|ø|@|#|\+|\||\*|\$|---|-|%|\/|\.\.|\^|~|=|<|>|\\/
            },
            boolean: {
                pattern: /\b(?:false|maybe|true)\b/
            }
        };
        Prism.languages.art = Prism.languages['arturo'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $0ad35299f0183166$export$2e2bcd8739ae039.displayName = 'asciidoc';
$0ad35299f0183166$export$2e2bcd8739ae039.aliases = [
    'adoc'
];
function $0ad35299f0183166$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var attributes = {
            pattern: /(^[ \t]*)\[(?!\[)(?:(["'$`])(?:(?!\2)[^\\]|\\.)*\2|\[(?:[^\[\]\\]|\\.)*\]|[^\[\]\\"'$`]|\\.)*\]/m,
            lookbehind: true,
            inside: {
                quoted: {
                    pattern: /([$`])(?:(?!\1)[^\\]|\\.)*\1/,
                    inside: {
                        punctuation: /^[$`]|[$`]$/
                    }
                },
                interpreted: {
                    pattern: /'(?:[^'\\]|\\.)*'/,
                    inside: {
                        punctuation: /^'|'$/
                    }
                },
                string: /"(?:[^"\\]|\\.)*"/,
                variable: /\w+(?==)/,
                punctuation: /^\[|\]$|,/,
                operator: /=/,
                // The negative look-ahead prevents blank matches
                'attr-value': /(?!^\s+$).+/
            }
        };
        var asciidoc = Prism.languages.asciidoc = {
            'comment-block': {
                pattern: /^(\/{4,})$[\s\S]*?^\1/m,
                alias: 'comment'
            },
            table: {
                pattern: /^\|={3,}(?:(?:\r?\n|\r(?!\n)).*)*?(?:\r?\n|\r)\|={3,}$/m,
                inside: {
                    specifiers: {
                        pattern: /(?:(?:(?:\d+(?:\.\d+)?|\.\d+)[+*](?:[<^>](?:\.[<^>])?|\.[<^>])?|[<^>](?:\.[<^>])?|\.[<^>])[a-z]*|[a-z]+)(?=\|)/,
                        alias: 'attr-value'
                    },
                    punctuation: {
                        pattern: /(^|[^\\])[|!]=*/,
                        lookbehind: true
                    }
                }
            },
            'passthrough-block': {
                pattern: /^(\+{4,})$[\s\S]*?^\1$/m,
                inside: {
                    punctuation: /^\++|\++$/
                }
            },
            // Literal blocks and listing blocks
            'literal-block': {
                pattern: /^(-{4,}|\.{4,})$[\s\S]*?^\1$/m,
                inside: {
                    punctuation: /^(?:-+|\.+)|(?:-+|\.+)$/
                }
            },
            // Sidebar blocks, quote blocks, example blocks and open blocks
            'other-block': {
                pattern: /^(--|\*{4,}|_{4,}|={4,})$[\s\S]*?^\1$/m,
                inside: {
                    punctuation: /^(?:-+|\*+|_+|=+)|(?:-+|\*+|_+|=+)$/
                }
            },
            // list-punctuation and list-label must appear before indented-block
            'list-punctuation': {
                pattern: /(^[ \t]*)(?:-|\*{1,5}|\.{1,5}|(?:[a-z]|\d+)\.|[xvi]+\))(?= )/im,
                lookbehind: true,
                alias: 'punctuation'
            },
            'list-label': {
                pattern: /(^[ \t]*)[a-z\d].+(?::{2,4}|;;)(?=\s)/im,
                lookbehind: true,
                alias: 'symbol'
            },
            'indented-block': {
                pattern: /((\r?\n|\r)\2)([ \t]+)\S.*(?:(?:\r?\n|\r)\3.+)*(?=\2{2}|$)/,
                lookbehind: true
            },
            comment: /^\/\/.*/m,
            title: {
                pattern: /^.+(?:\r?\n|\r)(?:={3,}|-{3,}|~{3,}|\^{3,}|\+{3,})$|^={1,5} .+|^\.(?![\s.]).*/m,
                alias: 'important',
                inside: {
                    punctuation: /^(?:\.|=+)|(?:=+|-+|~+|\^+|\++)$/
                }
            },
            'attribute-entry': {
                pattern: /^:[^:\r\n]+:(?: .*?(?: \+(?:\r?\n|\r).*?)*)?$/m,
                alias: 'tag'
            },
            attributes: attributes,
            hr: {
                pattern: /^'{3,}$/m,
                alias: 'punctuation'
            },
            'page-break': {
                pattern: /^<{3,}$/m,
                alias: 'punctuation'
            },
            admonition: {
                pattern: /^(?:CAUTION|IMPORTANT|NOTE|TIP|WARNING):/m,
                alias: 'keyword'
            },
            callout: [
                {
                    pattern: /(^[ \t]*)<?\d*>/m,
                    lookbehind: true,
                    alias: 'symbol'
                },
                {
                    pattern: /<\d+>/,
                    alias: 'symbol'
                }
            ],
            macro: {
                pattern: /\b[a-z\d][a-z\d-]*::?(?:[^\s\[\]]*\[(?:[^\]\\"']|(["'])(?:(?!\1)[^\\]|\\.)*\1|\\.)*\])/,
                inside: {
                    function: /^[a-z\d-]+(?=:)/,
                    punctuation: /^::?/,
                    attributes: {
                        pattern: /(?:\[(?:[^\]\\"']|(["'])(?:(?!\1)[^\\]|\\.)*\1|\\.)*\])/,
                        inside: attributes.inside
                    }
                }
            },
            inline: {
                /*
The initial look-behind prevents the highlighting of escaped quoted text.
Quoted text can be multi-line but cannot span an empty line.
All quoted text can have attributes before [foobar, 'foobar', baz="bar"].
First, we handle the constrained quotes.
Those must be bounded by non-word chars and cannot have spaces between the delimiter and the first char.
They are, in order: _emphasis_, ``double quotes'', `single quotes', `monospace`, 'emphasis', *strong*, +monospace+ and #unquoted#
Then we handle the unconstrained quotes.
Those do not have the restrictions of the constrained quotes.
They are, in order: __emphasis__, **strong**, ++monospace++, +++passthrough+++, ##unquoted##, $$passthrough$$, ~subscript~, ^superscript^, {attribute-reference}, [[anchor]], [[[bibliography anchor]]], <<xref>>, (((indexes))) and ((indexes))
*/ pattern: /(^|[^\\])(?:(?:\B\[(?:[^\]\\"']|(["'])(?:(?!\2)[^\\]|\\.)*\2|\\.)*\])?(?:\b_(?!\s)(?: _|[^_\\\r\n]|\\.)+(?:(?:\r?\n|\r)(?: _|[^_\\\r\n]|\\.)+)*_\b|\B``(?!\s).+?(?:(?:\r?\n|\r).+?)*''\B|\B`(?!\s)(?:[^`'\s]|\s+\S)+['`]\B|\B(['*+#])(?!\s)(?: \3|(?!\3)[^\\\r\n]|\\.)+(?:(?:\r?\n|\r)(?: \3|(?!\3)[^\\\r\n]|\\.)+)*\3\B)|(?:\[(?:[^\]\\"']|(["'])(?:(?!\4)[^\\]|\\.)*\4|\\.)*\])?(?:(__|\*\*|\+\+\+?|##|\$\$|[~^]).+?(?:(?:\r?\n|\r).+?)*\5|\{[^}\r\n]+\}|\[\[\[?.+?(?:(?:\r?\n|\r).+?)*\]?\]\]|<<.+?(?:(?:\r?\n|\r).+?)*>>|\(\(\(?.+?(?:(?:\r?\n|\r).+?)*\)?\)\)))/m,
                lookbehind: true,
                inside: {
                    attributes: attributes,
                    url: {
                        pattern: /^(?:\[\[\[?.+?\]?\]\]|<<.+?>>)$/,
                        inside: {
                            punctuation: /^(?:\[\[\[?|<<)|(?:\]\]\]?|>>)$/
                        }
                    },
                    'attribute-ref': {
                        pattern: /^\{.+\}$/,
                        inside: {
                            variable: {
                                pattern: /(^\{)[a-z\d,+_-]+/,
                                lookbehind: true
                            },
                            operator: /^[=?!#%@$]|!(?=[:}])/,
                            punctuation: /^\{|\}$|::?/
                        }
                    },
                    italic: {
                        pattern: /^(['_])[\s\S]+\1$/,
                        inside: {
                            punctuation: /^(?:''?|__?)|(?:''?|__?)$/
                        }
                    },
                    bold: {
                        pattern: /^\*[\s\S]+\*$/,
                        inside: {
                            punctuation: /^\*\*?|\*\*?$/
                        }
                    },
                    punctuation: /^(?:``?|\+{1,3}|##?|\$\$|[~^]|\(\(\(?)|(?:''?|\+{1,3}|##?|\$\$|[~^`]|\)?\)\))$/
                }
            },
            replacement: {
                pattern: /\((?:C|R|TM)\)/,
                alias: 'builtin'
            },
            entity: /&#?[\da-z]{1,8};/i,
            'line-continuation': {
                pattern: /(^| )\+$/m,
                lookbehind: true,
                alias: 'punctuation'
            }
        };
        // Allow some nesting. There is no recursion though, so cloning should not be needed.
        function copyFromAsciiDoc(keys) {
            keys = keys.split(' ');
            var o = {};
            for(var i = 0, l = keys.length; i < l; i++)o[keys[i]] = asciidoc[keys[i]];
            return o;
        }
        attributes.inside['interpreted'].inside.rest = copyFromAsciiDoc('macro inline replacement entity');
        asciidoc['passthrough-block'].inside.rest = copyFromAsciiDoc('macro');
        asciidoc['literal-block'].inside.rest = copyFromAsciiDoc('callout');
        asciidoc['table'].inside.rest = copyFromAsciiDoc('comment-block passthrough-block literal-block other-block list-punctuation indented-block comment title attribute-entry attributes hr page-break admonition list-label callout macro inline replacement entity line-continuation');
        asciidoc['other-block'].inside.rest = copyFromAsciiDoc('table list-punctuation indented-block comment attribute-entry attributes hr page-break admonition list-label macro inline replacement entity line-continuation');
        asciidoc['title'].inside.rest = copyFromAsciiDoc('macro inline replacement entity');
        // Plugin to make entity title show the real entity, idea by Roman Komarov
        Prism.hooks.add('wrap', function(env) {
            if (env.type === 'entity') env.attributes['title'] = env.content.value.replace(/&amp;/, '&');
        });
        Prism.languages.adoc = Prism.languages.asciidoc;
    })(Prism);
}



// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 

$2444ca6586008229$export$2e2bcd8739ae039.displayName = 'aspnet';
$2444ca6586008229$export$2e2bcd8739ae039.aliases = [];
function $2444ca6586008229$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $e1ab06973c0a6c0a$export$2e2bcd8739ae039));
    Prism.register((0, $8fbeea7c20d72e06$export$2e2bcd8739ae039));
    Prism.languages.aspnet = Prism.languages.extend('markup', {
        'page-directive': {
            pattern: /<%\s*@.*%>/,
            alias: 'tag',
            inside: {
                'page-directive': {
                    pattern: /<%\s*@\s*(?:Assembly|Control|Implements|Import|Master(?:Type)?|OutputCache|Page|PreviousPageType|Reference|Register)?|%>/i,
                    alias: 'tag'
                },
                rest: Prism.languages.markup.tag.inside
            }
        },
        directive: {
            pattern: /<%.*%>/,
            alias: 'tag',
            inside: {
                directive: {
                    pattern: /<%\s*?[$=%#:]{0,2}|%>/,
                    alias: 'tag'
                },
                rest: Prism.languages.csharp
            }
        }
    });
    // Regexp copied from prism-markup, with a negative look-ahead added
    Prism.languages.aspnet.tag.pattern = /<(?!%)\/?[^\s>\/]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/;
    // match directives of attribute value foo="<% Bar %>"
    Prism.languages.insertBefore('inside', 'punctuation', {
        directive: Prism.languages.aspnet['directive']
    }, Prism.languages.aspnet.tag.inside['attr-value']);
    Prism.languages.insertBefore('aspnet', 'comment', {
        'asp-comment': {
            pattern: /<%--[\s\S]*?--%>/,
            alias: [
                'asp',
                'comment'
            ]
        }
    });
    // script runat="server" contains csharp, not javascript
    Prism.languages.insertBefore('aspnet', Prism.languages.javascript ? 'script' : 'tag', {
        'asp-script': {
            pattern: /(<script(?=.*runat=['"]?server\b)[^>]*>)[\s\S]*?(?=<\/script>)/i,
            lookbehind: true,
            alias: [
                'asp',
                'script'
            ],
            inside: Prism.languages.csharp || {}
        }
    });
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $b537db6f9f7bc622$export$2e2bcd8739ae039.displayName = 'asm6502';
$b537db6f9f7bc622$export$2e2bcd8739ae039.aliases = [];
function $b537db6f9f7bc622$export$2e2bcd8739ae039(Prism) {
    Prism.languages.asm6502 = {
        comment: /;.*/,
        directive: {
            pattern: /\.\w+(?= )/,
            alias: 'property'
        },
        string: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
        'op-code': {
            pattern: /\b(?:ADC|AND|ASL|BCC|BCS|BEQ|BIT|BMI|BNE|BPL|BRK|BVC|BVS|CLC|CLD|CLI|CLV|CMP|CPX|CPY|DEC|DEX|DEY|EOR|INC|INX|INY|JMP|JSR|LDA|LDX|LDY|LSR|NOP|ORA|PHA|PHP|PLA|PLP|ROL|ROR|RTI|RTS|SBC|SEC|SED|SEI|STA|STX|STY|TAX|TAY|TSX|TXA|TXS|TYA|adc|and|asl|bcc|bcs|beq|bit|bmi|bne|bpl|brk|bvc|bvs|clc|cld|cli|clv|cmp|cpx|cpy|dec|dex|dey|eor|inc|inx|iny|jmp|jsr|lda|ldx|ldy|lsr|nop|ora|pha|php|pla|plp|rol|ror|rti|rts|sbc|sec|sed|sei|sta|stx|sty|tax|tay|tsx|txa|txs|tya)\b/,
            alias: 'keyword'
        },
        'hex-number': {
            pattern: /#?\$[\da-f]{1,4}\b/i,
            alias: 'number'
        },
        'binary-number': {
            pattern: /#?%[01]+\b/,
            alias: 'number'
        },
        'decimal-number': {
            pattern: /#?\b\d+\b/,
            alias: 'number'
        },
        register: {
            pattern: /\b[xya]\b/i,
            alias: 'variable'
        },
        punctuation: /[(),:]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $d40a6e41fa1845ea$export$2e2bcd8739ae039.displayName = 'asmatmel';
$d40a6e41fa1845ea$export$2e2bcd8739ae039.aliases = [];
function $d40a6e41fa1845ea$export$2e2bcd8739ae039(Prism) {
    Prism.languages.asmatmel = {
        comment: {
            pattern: /;.*/,
            greedy: true
        },
        string: {
            pattern: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        constant: /\b(?:PORT[A-Z]|DDR[A-Z]|(?:DD|P)[A-Z](?:\d|[0-2]\d|3[01]))\b/,
        directive: {
            pattern: /\.\w+(?= )/,
            alias: 'property'
        },
        'r-register': {
            pattern: /\br(?:\d|[12]\d|3[01])\b/,
            alias: 'variable'
        },
        'op-code': {
            pattern: /\b(?:ADC|ADD|ADIW|AND|ANDI|ASR|BCLR|BLD|BRBC|BRBS|BRCC|BRCS|BREAK|BREQ|BRGE|BRHC|BRHS|BRID|BRIE|BRLO|BRLT|BRMI|BRNE|BRPL|BRSH|BRTC|BRTS|BRVC|BRVS|BSET|BST|CALL|CBI|CBR|CLC|CLH|CLI|CLN|CLR|CLS|CLT|CLV|CLZ|COM|CP|CPC|CPI|CPSE|DEC|DES|EICALL|EIJMP|ELPM|EOR|FMUL|FMULS|FMULSU|ICALL|IJMP|IN|INC|JMP|LAC|LAS|LAT|LD|LD[A-Za-z0-9]|LPM|LSL|LSR|MOV|MOVW|MUL|MULS|MULSU|NEG|NOP|OR|ORI|OUT|POP|PUSH|RCALL|RET|RETI|RJMP|ROL|ROR|SBC|SBCI|SBI|SBIC|SBIS|SBIW|SBR|SBRC|SBRS|SEC|SEH|SEI|SEN|SER|SES|SET|SEV|SEZ|SLEEP|SPM|ST|ST[A-Z0-9]|SUB|SUBI|SWAP|TST|WDR|XCH|adc|add|adiw|and|andi|asr|bclr|bld|brbc|brbs|brcc|brcs|break|breq|brge|brhc|brhs|brid|brie|brlo|brlt|brmi|brne|brpl|brsh|brtc|brts|brvc|brvs|bset|bst|call|cbi|cbr|clc|clh|cli|cln|clr|cls|clt|clv|clz|com|cp|cpc|cpi|cpse|dec|des|eicall|eijmp|elpm|eor|fmul|fmuls|fmulsu|icall|ijmp|in|inc|jmp|lac|las|lat|ld|ld[a-z0-9]|lpm|lsl|lsr|mov|movw|mul|muls|mulsu|neg|nop|or|ori|out|pop|push|rcall|ret|reti|rjmp|rol|ror|sbc|sbci|sbi|sbic|sbis|sbiw|sbr|sbrc|sbrs|sec|seh|sei|sen|ser|ses|set|sev|sez|sleep|spm|st|st[a-zA-Z0-9]|sub|subi|swap|tst|wdr|xch)\b/,
            alias: 'keyword'
        },
        'hex-number': {
            pattern: /#?\$[\da-f]{2,4}\b/i,
            alias: 'number'
        },
        'binary-number': {
            pattern: /#?%[01]+\b/,
            alias: 'number'
        },
        'decimal-number': {
            pattern: /#?\b\d+\b/,
            alias: 'number'
        },
        register: {
            pattern: /\b[acznvshtixy]\b/i,
            alias: 'variable'
        },
        operator: />>=?|<<=?|&[&=]?|\|[\|=]?|[-+*/%^!=<>?]=?/,
        punctuation: /[(),:]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $b19cc59852e2480c$export$2e2bcd8739ae039.displayName = 'autohotkey';
$b19cc59852e2480c$export$2e2bcd8739ae039.aliases = [];
function $b19cc59852e2480c$export$2e2bcd8739ae039(Prism) {
    // NOTES - follows first-first highlight method, block is locked after highlight, different from SyntaxHl
    Prism.languages.autohotkey = {
        comment: [
            {
                pattern: /(^|\s);.*/,
                lookbehind: true
            },
            {
                pattern: /(^[\t ]*)\/\*(?:[\r\n](?![ \t]*\*\/)|[^\r\n])*(?:[\r\n][ \t]*\*\/)?/m,
                lookbehind: true,
                greedy: true
            }
        ],
        tag: {
            // labels
            pattern: /^([ \t]*)[^\s,`":]+(?=:[ \t]*$)/m,
            lookbehind: true
        },
        string: /"(?:[^"\n\r]|"")*"/,
        variable: /%\w+%/,
        number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
        operator: /\?|\/\/?=?|:=|\|[=|]?|&[=&]?|\+[=+]?|-[=-]?|\*[=*]?|<(?:<=?|>|=)?|>>?=?|[.^!=~]=?|\b(?:AND|NOT|OR)\b/,
        boolean: /\b(?:false|true)\b/,
        command: {
            pattern: /\b(?:AutoTrim|BlockInput|Break|Click|ClipWait|Continue|Control|ControlClick|ControlFocus|ControlGet|ControlGetFocus|ControlGetPos|ControlGetText|ControlMove|ControlSend|ControlSendRaw|ControlSetText|CoordMode|Critical|DetectHiddenText|DetectHiddenWindows|Drive|DriveGet|DriveSpaceFree|EnvAdd|EnvDiv|EnvGet|EnvMult|EnvSet|EnvSub|EnvUpdate|Exit|ExitApp|FileAppend|FileCopy|FileCopyDir|FileCreateDir|FileCreateShortcut|FileDelete|FileEncoding|FileGetAttrib|FileGetShortcut|FileGetSize|FileGetTime|FileGetVersion|FileInstall|FileMove|FileMoveDir|FileRead|FileReadLine|FileRecycle|FileRecycleEmpty|FileRemoveDir|FileSelectFile|FileSelectFolder|FileSetAttrib|FileSetTime|FormatTime|GetKeyState|Gosub|Goto|GroupActivate|GroupAdd|GroupClose|GroupDeactivate|Gui|GuiControl|GuiControlGet|Hotkey|ImageSearch|IniDelete|IniRead|IniWrite|Input|InputBox|KeyWait|ListHotkeys|ListLines|ListVars|Loop|Menu|MouseClick|MouseClickDrag|MouseGetPos|MouseMove|MsgBox|OnExit|OutputDebug|Pause|PixelGetColor|PixelSearch|PostMessage|Process|Progress|Random|RegDelete|RegRead|RegWrite|Reload|Repeat|Return|Run|RunAs|RunWait|Send|SendEvent|SendInput|SendMessage|SendMode|SendPlay|SendRaw|SetBatchLines|SetCapslockState|SetControlDelay|SetDefaultMouseSpeed|SetEnv|SetFormat|SetKeyDelay|SetMouseDelay|SetNumlockState|SetRegView|SetScrollLockState|SetStoreCapslockMode|SetTimer|SetTitleMatchMode|SetWinDelay|SetWorkingDir|Shutdown|Sleep|Sort|SoundBeep|SoundGet|SoundGetWaveVolume|SoundPlay|SoundSet|SoundSetWaveVolume|SplashImage|SplashTextOff|SplashTextOn|SplitPath|StatusBarGetText|StatusBarWait|StringCaseSense|StringGetPos|StringLeft|StringLen|StringLower|StringMid|StringReplace|StringRight|StringSplit|StringTrimLeft|StringTrimRight|StringUpper|Suspend|SysGet|Thread|ToolTip|Transform|TrayTip|URLDownloadToFile|WinActivate|WinActivateBottom|WinClose|WinGet|WinGetActiveStats|WinGetActiveTitle|WinGetClass|WinGetPos|WinGetText|WinGetTitle|WinHide|WinKill|WinMaximize|WinMenuSelectItem|WinMinimize|WinMinimizeAll|WinMinimizeAllUndo|WinMove|WinRestore|WinSet|WinSetTitle|WinShow|WinWait|WinWaitActive|WinWaitClose|WinWaitNotActive)\b/i,
            alias: 'selector'
        },
        constant: /\b(?:a_ahkpath|a_ahkversion|a_appdata|a_appdatacommon|a_autotrim|a_batchlines|a_caretx|a_carety|a_computername|a_controldelay|a_cursor|a_dd|a_ddd|a_dddd|a_defaultmousespeed|a_desktop|a_desktopcommon|a_detecthiddentext|a_detecthiddenwindows|a_endchar|a_eventinfo|a_exitreason|a_fileencoding|a_formatfloat|a_formatinteger|a_gui|a_guicontrol|a_guicontrolevent|a_guievent|a_guiheight|a_guiwidth|a_guix|a_guiy|a_hour|a_iconfile|a_iconhidden|a_iconnumber|a_icontip|a_index|a_ipaddress1|a_ipaddress2|a_ipaddress3|a_ipaddress4|a_is64bitos|a_isadmin|a_iscompiled|a_iscritical|a_ispaused|a_issuspended|a_isunicode|a_keydelay|a_language|a_lasterror|a_linefile|a_linenumber|a_loopfield|a_loopfileattrib|a_loopfiledir|a_loopfileext|a_loopfilefullpath|a_loopfilelongpath|a_loopfilename|a_loopfileshortname|a_loopfileshortpath|a_loopfilesize|a_loopfilesizekb|a_loopfilesizemb|a_loopfiletimeaccessed|a_loopfiletimecreated|a_loopfiletimemodified|a_loopreadline|a_loopregkey|a_loopregname|a_loopregsubkey|a_loopregtimemodified|a_loopregtype|a_mday|a_min|a_mm|a_mmm|a_mmmm|a_mon|a_mousedelay|a_msec|a_mydocuments|a_now|a_nowutc|a_numbatchlines|a_ostype|a_osversion|a_priorhotkey|a_priorkey|a_programfiles|a_programs|a_programscommon|a_ptrsize|a_regview|a_screendpi|a_screenheight|a_screenwidth|a_scriptdir|a_scriptfullpath|a_scripthwnd|a_scriptname|a_sec|a_space|a_startmenu|a_startmenucommon|a_startup|a_startupcommon|a_stringcasesense|a_tab|a_temp|a_thisfunc|a_thishotkey|a_thislabel|a_thismenu|a_thismenuitem|a_thismenuitempos|a_tickcount|a_timeidle|a_timeidlephysical|a_timesincepriorhotkey|a_timesincethishotkey|a_titlematchmode|a_titlematchmodespeed|a_username|a_wday|a_windelay|a_windir|a_workingdir|a_yday|a_year|a_yweek|a_yyyy|clipboard|clipboardall|comspec|errorlevel|programfiles)\b/i,
        builtin: /\b(?:abs|acos|asc|asin|atan|ceil|chr|class|comobjactive|comobjarray|comobjconnect|comobjcreate|comobjerror|comobjflags|comobjget|comobjquery|comobjtype|comobjvalue|cos|dllcall|exp|fileexist|Fileopen|floor|format|il_add|il_create|il_destroy|instr|isfunc|islabel|IsObject|ln|log|ltrim|lv_add|lv_delete|lv_deletecol|lv_getcount|lv_getnext|lv_gettext|lv_insert|lv_insertcol|lv_modify|lv_modifycol|lv_setimagelist|mod|numget|numput|onmessage|regexmatch|regexreplace|registercallback|round|rtrim|sb_seticon|sb_setparts|sb_settext|sin|sqrt|strlen|strreplace|strsplit|substr|tan|tv_add|tv_delete|tv_get|tv_getchild|tv_getcount|tv_getnext|tv_getparent|tv_getprev|tv_getselection|tv_gettext|tv_modify|varsetcapacity|winactive|winexist|__Call|__Get|__New|__Set)\b/i,
        symbol: /\b(?:alt|altdown|altup|appskey|backspace|browser_back|browser_favorites|browser_forward|browser_home|browser_refresh|browser_search|browser_stop|bs|capslock|ctrl|ctrlbreak|ctrldown|ctrlup|del|delete|down|end|enter|esc|escape|f1|f10|f11|f12|f13|f14|f15|f16|f17|f18|f19|f2|f20|f21|f22|f23|f24|f3|f4|f5|f6|f7|f8|f9|home|ins|insert|joy1|joy10|joy11|joy12|joy13|joy14|joy15|joy16|joy17|joy18|joy19|joy2|joy20|joy21|joy22|joy23|joy24|joy25|joy26|joy27|joy28|joy29|joy3|joy30|joy31|joy32|joy4|joy5|joy6|joy7|joy8|joy9|joyaxes|joybuttons|joyinfo|joyname|joypov|joyr|joyu|joyv|joyx|joyy|joyz|lalt|launch_app1|launch_app2|launch_mail|launch_media|lbutton|lcontrol|lctrl|left|lshift|lwin|lwindown|lwinup|mbutton|media_next|media_play_pause|media_prev|media_stop|numlock|numpad0|numpad1|numpad2|numpad3|numpad4|numpad5|numpad6|numpad7|numpad8|numpad9|numpadadd|numpadclear|numpaddel|numpaddiv|numpaddot|numpaddown|numpadend|numpadenter|numpadhome|numpadins|numpadleft|numpadmult|numpadpgdn|numpadpgup|numpadright|numpadsub|numpadup|pgdn|pgup|printscreen|ralt|rbutton|rcontrol|rctrl|right|rshift|rwin|rwindown|rwinup|scrolllock|shift|shiftdown|shiftup|space|tab|up|volume_down|volume_mute|volume_up|wheeldown|wheelleft|wheelright|wheelup|xbutton1|xbutton2)\b/i,
        directive: {
            pattern: /#[a-z]+\b/i,
            alias: 'important'
        },
        keyword: /\b(?:Abort|AboveNormal|Add|ahk_class|ahk_exe|ahk_group|ahk_id|ahk_pid|All|Alnum|Alpha|AltSubmit|AltTab|AltTabAndMenu|AltTabMenu|AltTabMenuDismiss|AlwaysOnTop|AutoSize|Background|BackgroundTrans|BelowNormal|between|BitAnd|BitNot|BitOr|BitShiftLeft|BitShiftRight|BitXOr|Bold|Border|Button|ByRef|Catch|Checkbox|Checked|CheckedGray|Choose|ChooseString|Close|Color|ComboBox|Contains|ControlList|Count|Date|DateTime|Days|DDL|Default|DeleteAll|Delimiter|Deref|Destroy|Digit|Disable|Disabled|DropDownList|Edit|Eject|Else|Enable|Enabled|Error|Exist|Expand|ExStyle|FileSystem|Finally|First|Flash|Float|FloatFast|Focus|Font|for|global|Grid|Group|GroupBox|GuiClose|GuiContextMenu|GuiDropFiles|GuiEscape|GuiSize|Hdr|Hidden|Hide|High|HKCC|HKCR|HKCU|HKEY_CLASSES_ROOT|HKEY_CURRENT_CONFIG|HKEY_CURRENT_USER|HKEY_LOCAL_MACHINE|HKEY_USERS|HKLM|HKU|Hours|HScroll|Icon|IconSmall|ID|IDLast|If|IfEqual|IfExist|IfGreater|IfGreaterOrEqual|IfInString|IfLess|IfLessOrEqual|IfMsgBox|IfNotEqual|IfNotExist|IfNotInString|IfWinActive|IfWinExist|IfWinNotActive|IfWinNotExist|Ignore|ImageList|in|Integer|IntegerFast|Interrupt|is|italic|Join|Label|LastFound|LastFoundExist|Limit|Lines|List|ListBox|ListView|local|Lock|Logoff|Low|Lower|Lowercase|MainWindow|Margin|Maximize|MaximizeBox|MaxSize|Minimize|MinimizeBox|MinMax|MinSize|Minutes|MonthCal|Mouse|Move|Multi|NA|No|NoActivate|NoDefault|NoHide|NoIcon|NoMainWindow|norm|Normal|NoSort|NoSortHdr|NoStandard|Not|NoTab|NoTimers|Number|Off|Ok|On|OwnDialogs|Owner|Parse|Password|Picture|Pixel|Pos|Pow|Priority|ProcessName|Radio|Range|Read|ReadOnly|Realtime|Redraw|Region|REG_BINARY|REG_DWORD|REG_EXPAND_SZ|REG_MULTI_SZ|REG_SZ|Relative|Rename|Report|Resize|Restore|Retry|RGB|Screen|Seconds|Section|Serial|SetLabel|ShiftAltTab|Show|Single|Slider|SortDesc|Standard|static|Status|StatusBar|StatusCD|strike|Style|Submit|SysMenu|Tab2|TabStop|Text|Theme|Throw|Tile|ToggleCheck|ToggleEnable|ToolWindow|Top|Topmost|TransColor|Transparent|Tray|TreeView|Try|TryAgain|Type|UnCheck|underline|Unicode|Unlock|Until|UpDown|Upper|Uppercase|UseErrorLevel|Vis|VisFirst|Visible|VScroll|Wait|WaitClose|WantCtrlA|WantF2|WantReturn|While|Wrap|Xdigit|xm|xp|xs|Yes|ym|yp|ys)\b/i,
        function: /[^(); \t,\n+*\-=?>:\\\/<&%\[\]]+(?=\()/,
        punctuation: /[{}[\]():,]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $17b2b51b5d1fc4c1$export$2e2bcd8739ae039.displayName = 'autoit';
$17b2b51b5d1fc4c1$export$2e2bcd8739ae039.aliases = [];
function $17b2b51b5d1fc4c1$export$2e2bcd8739ae039(Prism) {
    Prism.languages.autoit = {
        comment: [
            /;.*/,
            {
                // The multi-line comments delimiters can actually be commented out with ";"
                pattern: /(^[\t ]*)#(?:comments-start|cs)[\s\S]*?^[ \t]*#(?:ce|comments-end)/m,
                lookbehind: true
            }
        ],
        url: {
            pattern: /(^[\t ]*#include\s+)(?:<[^\r\n>]+>|"[^\r\n"]+")/m,
            lookbehind: true
        },
        string: {
            pattern: /(["'])(?:\1\1|(?!\1)[^\r\n])*\1/,
            greedy: true,
            inside: {
                variable: /([%$@])\w+\1/
            }
        },
        directive: {
            pattern: /(^[\t ]*)#[\w-]+/m,
            lookbehind: true,
            alias: 'keyword'
        },
        function: /\b\w+(?=\()/,
        // Variables and macros
        variable: /[$@]\w+/,
        keyword: /\b(?:Case|Const|Continue(?:Case|Loop)|Default|Dim|Do|Else(?:If)?|End(?:Func|If|Select|Switch|With)|Enum|Exit(?:Loop)?|For|Func|Global|If|In|Local|Next|Null|ReDim|Select|Static|Step|Switch|Then|To|Until|Volatile|WEnd|While|With)\b/i,
        number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i,
        boolean: /\b(?:False|True)\b/i,
        operator: /<[=>]?|[-+*\/=&>]=?|[?^]|\b(?:And|Not|Or)\b/i,
        punctuation: /[\[\]().,:]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $f4a134fc3ae6bf3d$export$2e2bcd8739ae039.displayName = 'avisynth';
$f4a134fc3ae6bf3d$export$2e2bcd8739ae039.aliases = [
    'avs'
];
function $f4a134fc3ae6bf3d$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        function replace(pattern, replacements) {
            return pattern.replace(/<<(\d+)>>/g, function(m, index) {
                return replacements[+index];
            });
        }
        function re(pattern, replacements, flags) {
            return RegExp(replace(pattern, replacements), flags || '');
        }
        var types = /bool|clip|float|int|string|val/.source;
        var internals = [
            // bools
            /is(?:bool|clip|float|int|string)|defined|(?:(?:internal)?function|var)?exists?/.source,
            // control
            /apply|assert|default|eval|import|nop|select|undefined/.source,
            // global
            /opt_(?:allowfloataudio|avipadscanlines|dwchannelmask|enable_(?:b64a|planartopackedrgb|v210|y3_10_10|y3_10_16)|usewaveextensible|vdubplanarhack)|set(?:cachemode|maxcpu|memorymax|planarlegacyalignment|workingdir)/.source,
            // conv
            /hex(?:value)?|value/.source,
            // numeric
            /abs|ceil|continued(?:denominator|numerator)?|exp|floor|fmod|frac|log(?:10)?|max|min|muldiv|pi|pow|rand|round|sign|spline|sqrt/.source,
            // trig
            /a?sinh?|a?cosh?|a?tan[2h]?/.source,
            // bit
            /(?:bit(?:and|not|x?or|[lr]?shift[aslu]?|sh[lr]|sa[lr]|[lr]rotatel?|ro[rl]|te?st|set(?:count)?|cl(?:ea)?r|ch(?:an)?ge?))/.source,
            // runtime
            /average(?:[bgr]|chroma[uv]|luma)|(?:[rgb]|chroma[uv]|luma|rgb|[yuv](?=difference(?:fromprevious|tonext)))difference(?:fromprevious|tonext)?|[yuvrgb]plane(?:median|min|max|minmaxdifference)/.source,
            // script
            /getprocessinfo|logmsg|script(?:dir(?:utf8)?|file(?:utf8)?|name(?:utf8)?)|setlogparams/.source,
            // string
            /chr|(?:fill|find|left|mid|replace|rev|right)str|format|[lu]case|ord|str(?:cmpi?|fromutf8|len|toutf8)|time|trim(?:all|left|right)/.source,
            // version
            /isversionorgreater|version(?:number|string)/.source,
            // helper
            /buildpixeltype|colorspacenametopixeltype/.source,
            // avsplus
            /addautoloaddir|on(?:cpu|cuda)|prefetch|setfiltermtmode/.source
        ].join('|');
        var properties = [
            // content
            /has(?:audio|video)/.source,
            // resolution
            /height|width/.source,
            // framerate
            /frame(?:count|rate)|framerate(?:denominator|numerator)/.source,
            // interlacing
            /getparity|is(?:field|frame)based/.source,
            // color format
            /bitspercomponent|componentsize|hasalpha|is(?:planar(?:rgba?)?|interleaved|rgb(?:24|32|48|64)?|y(?:8|u(?:va?|y2))?|yv(?:12|16|24|411)|420|422|444|packedrgb)|numcomponents|pixeltype/.source,
            // audio
            /audio(?:bits|channels|duration|length(?:[fs]|hi|lo)?|rate)|isaudio(?:float|int)/.source
        ].join('|');
        var filters = [
            // source
            /avi(?:file)?source|directshowsource|image(?:reader|source|sourceanim)|opendmlsource|segmented(?:avisource|directshowsource)|wavsource/.source,
            // color
            /coloryuv|convertbacktoyuy2|convertto(?:RGB(?:24|32|48|64)|(?:planar)?RGBA?|Y8?|YV(?:12|16|24|411)|YUVA?(?:411|420|422|444)|YUY2)|fixluminance|gr[ae]yscale|invert|levels|limiter|mergea?rgb|merge(?:chroma|luma)|rgbadjust|show(?:alpha|blue|green|red)|swapuv|tweak|[uv]toy8?|ytouv/.source,
            // overlay
            /(?:colorkey|reset)mask|layer|mask(?:hs)?|merge|overlay|subtract/.source,
            // geometry
            /addborders|(?:bicubic|bilinear|blackman|gauss|lanczos4|lanczos|point|sinc|spline(?:16|36|64))resize|crop(?:bottom)?|flip(?:horizontal|vertical)|(?:horizontal|vertical)?reduceby2|letterbox|skewrows|turn(?:180|left|right)/.source,
            // pixel
            /blur|fixbrokenchromaupsampling|generalconvolution|(?:spatial|temporal)soften|sharpen/.source,
            // timeline
            /trim|(?:un)?alignedsplice|(?:assume|assumescaled|change|convert)FPS|(?:delete|duplicate)frame|dissolve|fade(?:in|io|out)[02]?|freezeframe|interleave|loop|reverse|select(?:even|odd|(?:range)?every)/.source,
            // interlace
            /assume[bt]ff|assume(?:field|frame)based|bob|complementparity|doubleweave|peculiarblend|pulldown|separate(?:columns|fields|rows)|swapfields|weave(?:columns|rows)?/.source,
            // audio
            /amplify(?:db)?|assumesamplerate|audiodub(?:ex)?|audiotrim|convertaudioto(?:(?:8|16|24|32)bit|float)|converttomono|delayaudio|ensurevbrmp3sync|get(?:left|right)?channel|kill(?:audio|video)|mergechannels|mixaudio|monotostereo|normalize|resampleaudio|ssrc|supereq|timestretch/.source,
            // conditional
            /animate|applyrange|conditional(?:filter|reader|select)|frameevaluate|scriptclip|tcp(?:server|source)|writefile(?:end|if|start)?/.source,
            // export
            /imagewriter/.source,
            // debug
            /blackness|blankclip|colorbars(?:hd)?|compare|dumpfiltergraph|echo|histogram|info|messageclip|preroll|setgraphanalysis|show(?:framenumber|smpte|time)|showfiveversions|stack(?:horizontal|vertical)|subtitle|tone|version/.source
        ].join('|');
        var allinternals = [
            internals,
            properties,
            filters
        ].join('|');
        Prism.languages.avisynth = {
            comment: [
                {
                    // Matches [* *] nestable block comments, but only supports 1 level of nested comments
                    // /\[\*(?:[^\[*]|\[(?!\*)|\*(?!\])|<self>)*\*\]/
                    pattern: /(^|[^\\])\[\*(?:[^\[*]|\[(?!\*)|\*(?!\])|\[\*(?:[^\[*]|\[(?!\*)|\*(?!\]))*\*\])*\*\]/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    // Matches /* */ block comments
                    pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    // Matches # comments
                    pattern: /(^|[^\\$])#.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            // Handle before strings because optional arguments are surrounded by double quotes
            argument: {
                pattern: re(/\b(?:<<0>>)\s+("?)\w+\1/.source, [
                    types
                ], 'i'),
                inside: {
                    keyword: /^\w+/
                }
            },
            // Optional argument assignment
            'argument-label': {
                pattern: /([,(][\s\\]*)\w+\s*=(?!=)/,
                lookbehind: true,
                inside: {
                    'argument-name': {
                        pattern: /^\w+/,
                        alias: 'punctuation'
                    },
                    punctuation: /=$/
                }
            },
            string: [
                {
                    // triple double-quoted
                    pattern: /"""[\s\S]*?"""/,
                    greedy: true
                },
                {
                    // single double-quoted
                    pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
                    greedy: true,
                    inside: {
                        constant: {
                            // These *are* case-sensitive!
                            pattern: /\b(?:DEFAULT_MT_MODE|(?:MAINSCRIPT|PROGRAM|SCRIPT)DIR|(?:MACHINE|USER)_(?:CLASSIC|PLUS)_PLUGINS)\b/
                        }
                    }
                }
            ],
            // The special "last" variable that takes the value of the last implicitly returned clip
            variable: /\b(?:last)\b/i,
            boolean: /\b(?:false|no|true|yes)\b/i,
            keyword: /\b(?:catch|else|for|function|global|if|return|try|while|__END__)\b/i,
            constant: /\bMT_(?:MULTI_INSTANCE|NICE_FILTER|SERIALIZED|SPECIAL_MT)\b/,
            // AviSynth's internal functions, filters, and properties
            'builtin-function': {
                pattern: re(/\b(?:<<0>>)\b/.source, [
                    allinternals
                ], 'i'),
                alias: 'function'
            },
            'type-cast': {
                pattern: re(/\b(?:<<0>>)(?=\s*\()/.source, [
                    types
                ], 'i'),
                alias: 'keyword'
            },
            // External/user-defined filters
            function: {
                pattern: /\b[a-z_]\w*(?=\s*\()|(\.)[a-z_]\w*\b/i,
                lookbehind: true
            },
            // Matches a \ as the first or last character on a line
            'line-continuation': {
                pattern: /(^[ \t]*)\\|\\(?=[ \t]*$)/m,
                lookbehind: true,
                alias: 'punctuation'
            },
            number: /\B\$(?:[\da-f]{6}|[\da-f]{8})\b|(?:(?:\b|\B-)\d+(?:\.\d*)?\b|\B\.\d+\b)/i,
            operator: /\+\+?|[!=<>]=?|&&|\|\||[?:*/%-]/,
            punctuation: /[{}\[\]();,.]/
        };
        Prism.languages.avs = Prism.languages.avisynth;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $cbb6560f9029869a$export$2e2bcd8739ae039.displayName = 'avro-idl';
$cbb6560f9029869a$export$2e2bcd8739ae039.aliases = [
    'avdl'
];
function $cbb6560f9029869a$export$2e2bcd8739ae039(Prism) {
    // GitHub: https://github.com/apache/avro
    // Docs: https://avro.apache.org/docs/current/idl.html
    Prism.languages['avro-idl'] = {
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])"(?:[^\r\n"\\]|\\.)*"/,
            lookbehind: true,
            greedy: true
        },
        annotation: {
            pattern: /@(?:[$\w.-]|`[^\r\n`]+`)+/,
            greedy: true,
            alias: 'function'
        },
        'function-identifier': {
            pattern: /`[^\r\n`]+`(?=\s*\()/,
            greedy: true,
            alias: 'function'
        },
        identifier: {
            pattern: /`[^\r\n`]+`/,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:enum|error|protocol|record|throws)\b\s+)[$\w]+/,
            lookbehind: true,
            greedy: true
        },
        keyword: /\b(?:array|boolean|bytes|date|decimal|double|enum|error|false|fixed|float|idl|import|int|local_timestamp_ms|long|map|null|oneway|protocol|record|schema|string|throws|time_ms|timestamp_ms|true|union|uuid|void)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: [
            {
                pattern: /(^|[^\w.])-?(?:(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|0x(?:[a-f0-9]+(?:\.[a-f0-9]*)?|\.[a-f0-9]+)(?:p[+-]?\d+)?)[dfl]?(?![\w.])/i,
                lookbehind: true
            },
            /-?\b(?:Infinity|NaN)\b/
        ],
        operator: /=/,
        punctuation: /[()\[\]{}<>.:,;-]/
    };
    Prism.languages.avdl = Prism.languages['avro-idl'];
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $967d57fc0e7de922$export$2e2bcd8739ae039.displayName = 'awk';
$967d57fc0e7de922$export$2e2bcd8739ae039.aliases = [
    'gawk'
];
function $967d57fc0e7de922$export$2e2bcd8739ae039(Prism) {
    Prism.languages.awk = {
        hashbang: {
            pattern: /^#!.*/,
            greedy: true,
            alias: 'comment'
        },
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])"(?:[^\\"\r\n]|\\.)*"/,
            lookbehind: true,
            greedy: true
        },
        regex: {
            pattern: /((?:^|[^\w\s)])\s*)\/(?:[^\/\\\r\n]|\\.)*\//,
            lookbehind: true,
            greedy: true
        },
        variable: /\$\w+/,
        keyword: /\b(?:BEGIN|BEGINFILE|END|ENDFILE|break|case|continue|default|delete|do|else|exit|for|function|getline|if|in|next|nextfile|printf?|return|switch|while)\b|@(?:include|load)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0x[a-fA-F0-9]+)\b/,
        operator: /--|\+\+|!?~|>&|>>|<<|(?:\*\*|[<>!=+\-*/%^])=?|&&|\|[|&]|[?:]/,
        punctuation: /[()[\]{},;]/
    };
    Prism.languages.gawk = Prism.languages.awk;
}



// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $8b0b331041684e32$export$2e2bcd8739ae039.displayName = 'batch';
$8b0b331041684e32$export$2e2bcd8739ae039.aliases = [];
function $8b0b331041684e32$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var variable = /%%?[~:\w]+%?|!\S+!/;
        var parameter = {
            pattern: /\/[a-z?]+(?=[ :]|$):?|-[a-z]\b|--[a-z-]+\b/im,
            alias: 'attr-name',
            inside: {
                punctuation: /:/
            }
        };
        var string = /"(?:[\\"]"|[^"])*"(?!")/;
        var number = /(?:\b|-)\d+\b/;
        Prism.languages.batch = {
            comment: [
                /^::.*/m,
                {
                    pattern: /((?:^|[&(])[ \t]*)rem\b(?:[^^&)\r\n]|\^(?:\r\n|[\s\S]))*/im,
                    lookbehind: true
                }
            ],
            label: {
                pattern: /^:.*/m,
                alias: 'property'
            },
            command: [
                {
                    // FOR command
                    pattern: /((?:^|[&(])[ \t]*)for(?: \/[a-z?](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* \S+ in \([^)]+\) do/im,
                    lookbehind: true,
                    inside: {
                        keyword: /\b(?:do|in)\b|^for\b/i,
                        string: string,
                        parameter: parameter,
                        variable: variable,
                        number: number,
                        punctuation: /[()',]/
                    }
                },
                {
                    // IF command
                    pattern: /((?:^|[&(])[ \t]*)if(?: \/[a-z?](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* (?:not )?(?:cmdextversion \d+|defined \w+|errorlevel \d+|exist \S+|(?:"[^"]*"|(?!")(?:(?!==)\S)+)?(?:==| (?:equ|geq|gtr|leq|lss|neq) )(?:"[^"]*"|[^\s"]\S*))/im,
                    lookbehind: true,
                    inside: {
                        keyword: /\b(?:cmdextversion|defined|errorlevel|exist|not)\b|^if\b/i,
                        string: string,
                        parameter: parameter,
                        variable: variable,
                        number: number,
                        operator: /\^|==|\b(?:equ|geq|gtr|leq|lss|neq)\b/i
                    }
                },
                {
                    // ELSE command
                    pattern: /((?:^|[&()])[ \t]*)else\b/im,
                    lookbehind: true,
                    inside: {
                        keyword: /^else\b/i
                    }
                },
                {
                    // SET command
                    pattern: /((?:^|[&(])[ \t]*)set(?: \/[a-z](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* (?:[^^&)\r\n]|\^(?:\r\n|[\s\S]))*/im,
                    lookbehind: true,
                    inside: {
                        keyword: /^set\b/i,
                        string: string,
                        parameter: parameter,
                        variable: [
                            variable,
                            /\w+(?=(?:[*\/%+\-&^|]|<<|>>)?=)/
                        ],
                        number: number,
                        operator: /[*\/%+\-&^|]=?|<<=?|>>=?|[!~_=]/,
                        punctuation: /[()',]/
                    }
                },
                {
                    // Other commands
                    pattern: /((?:^|[&(])[ \t]*@?)\w+\b(?:"(?:[\\"]"|[^"])*"(?!")|[^"^&)\r\n]|\^(?:\r\n|[\s\S]))*/m,
                    lookbehind: true,
                    inside: {
                        keyword: /^\w+\b/,
                        string: string,
                        parameter: parameter,
                        label: {
                            pattern: /(^\s*):\S+/m,
                            lookbehind: true,
                            alias: 'property'
                        },
                        variable: variable,
                        number: number,
                        operator: /\^/
                    }
                }
            ],
            operator: /[&@]/,
            punctuation: /[()']/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $20a170561b9d92de$export$2e2bcd8739ae039.displayName = 'bbcode';
$20a170561b9d92de$export$2e2bcd8739ae039.aliases = [
    'shortcode'
];
function $20a170561b9d92de$export$2e2bcd8739ae039(Prism) {
    Prism.languages.bbcode = {
        tag: {
            pattern: /\[\/?[^\s=\]]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+))?(?:\s+[^\s=\]]+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+))*\s*\]/,
            inside: {
                tag: {
                    pattern: /^\[\/?[^\s=\]]+/,
                    inside: {
                        punctuation: /^\[\/?/
                    }
                },
                'attr-value': {
                    pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+)/,
                    inside: {
                        punctuation: [
                            /^=/,
                            {
                                pattern: /^(\s*)["']|["']$/,
                                lookbehind: true
                            }
                        ]
                    }
                },
                punctuation: /\]/,
                'attr-name': /[^\s=\]]+/
            }
        }
    };
    Prism.languages.shortcode = Prism.languages.bbcode;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $5808f16c368df70d$export$2e2bcd8739ae039.displayName = 'bbj';
$5808f16c368df70d$export$2e2bcd8739ae039.aliases = [];
function $5808f16c368df70d$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.bbj = {
            comment: {
                pattern: /(^|[^\\:])rem\s+.*/i,
                lookbehind: true,
                greedy: true
            },
            string: {
                pattern: /(['"])(?:(?!\1|\\).|\\.)*\1/,
                greedy: true
            },
            number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
            keyword: /\b(?:abstract|all|argc|begin|bye|callback|case|chn|class|classend|ctl|day|declare|delete|dim|dom|dread|dsz|else|end|endif|err|exitto|extends|fi|field|for|from|gosub|goto|if|implements|interface|interfaceend|iol|iolist|let|list|load|method|methodend|methodret|on|opts|pfx|print|private|process_events|protected|psz|public|read|read_resource|release|remove_callback|repeat|restore|return|rev|seterr|setesc|sqlchn|sqlunt|ssn|start|static|swend|switch|sys|then|tim|unt|until|use|void|wend|where|while)\b/i,
            function: /\b\w+(?=\()/,
            boolean: /\b(?:BBjAPI\.TRUE|BBjAPI\.FALSE)\b/i,
            operator: /<[=>]?|>=?|[+\-*\/^=&]|\b(?:and|not|or|xor)\b/i,
            punctuation: /[.,;:()]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $ca8b23f8f4c3551e$export$2e2bcd8739ae039.displayName = 'bicep';
$ca8b23f8f4c3551e$export$2e2bcd8739ae039.aliases = [];
function $ca8b23f8f4c3551e$export$2e2bcd8739ae039(Prism) {
    // based loosely upon: https://github.com/Azure/bicep/blob/main/src/textmate/bicep.tmlanguage
    Prism.languages.bicep = {
        comment: [
            {
                // multiline comments eg /* ASDF */
                pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                lookbehind: true,
                greedy: true
            },
            {
                // singleline comments eg // ASDF
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        property: [
            {
                pattern: /([\r\n][ \t]*)[a-z_]\w*(?=[ \t]*:)/i,
                lookbehind: true
            },
            {
                pattern: /([\r\n][ \t]*)'(?:\\.|\$(?!\{)|[^'\\\r\n$])*'(?=[ \t]*:)/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: [
            {
                pattern: /'''[^'][\s\S]*?'''/,
                greedy: true
            },
            {
                pattern: /(^|[^\\'])'(?:\\.|\$(?!\{)|[^'\\\r\n$])*'/,
                lookbehind: true,
                greedy: true
            }
        ],
        'interpolated-string': {
            pattern: /(^|[^\\'])'(?:\\.|\$(?:(?!\{)|\{[^{}\r\n]*\})|[^'\\\r\n$])*'/,
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /\$\{[^{}\r\n]*\}/,
                    inside: {
                        expression: {
                            pattern: /(^\$\{)[\s\S]+(?=\}$)/,
                            lookbehind: true
                        },
                        punctuation: /^\$\{|\}$/
                    }
                },
                string: /[\s\S]+/
            }
        },
        datatype: {
            pattern: /(\b(?:output|param)\b[ \t]+\w+[ \t]+)\w+\b/,
            lookbehind: true,
            alias: 'class-name'
        },
        boolean: /\b(?:false|true)\b/,
        // https://github.com/Azure/bicep/blob/114a3251b4e6e30082a58729f19a8cc4e374ffa6/src/textmate/bicep.tmlanguage#L184
        keyword: /\b(?:existing|for|if|in|module|null|output|param|resource|targetScope|var)\b/,
        decorator: /@\w+\b/,
        function: /\b[a-z_]\w*(?=[ \t]*\()/i,
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
        operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/,
        punctuation: /[{}[\];(),.:]/
    };
    Prism.languages.bicep['interpolated-string'].inside['interpolation'].inside['expression'].inside = Prism.languages.bicep;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$06c073f7d52d479c$export$2e2bcd8739ae039.displayName = 'birb';
$06c073f7d52d479c$export$2e2bcd8739ae039.aliases = [];
function $06c073f7d52d479c$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    Prism.languages.birb = Prism.languages.extend('clike', {
        string: {
            pattern: /r?("|')(?:\\.|(?!\1)[^\\])*\1/,
            greedy: true
        },
        'class-name': [
            /\b[A-Z](?:[\d_]*[a-zA-Z]\w*)?\b/,
            // matches variable and function return types (parameters as well).
            /\b(?:[A-Z]\w*|(?!(?:var|void)\b)[a-z]\w*)(?=\s+\w+\s*[;,=()])/
        ],
        keyword: /\b(?:assert|break|case|class|const|default|else|enum|final|follows|for|grab|if|nest|new|next|noSeeb|return|static|switch|throw|var|void|while)\b/,
        operator: /\+\+|--|&&|\|\||<<=?|>>=?|~(?:\/=?)?|[+\-*\/%&^|=!<>]=?|\?|:/,
        variable: /\b[a-z_]\w*\b/
    });
    Prism.languages.insertBefore('birb', 'function', {
        metadata: {
            pattern: /<\w+>/,
            greedy: true,
            alias: 'symbol'
        }
    });
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$5e72be8fe18bd064$export$2e2bcd8739ae039.displayName = 'bison';
$5e72be8fe18bd064$export$2e2bcd8739ae039.aliases = [];
function $5e72be8fe18bd064$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $e064275ae5958777$export$2e2bcd8739ae039));
    Prism.languages.bison = Prism.languages.extend('c', {});
    Prism.languages.insertBefore('bison', 'comment', {
        bison: {
            // This should match all the beginning of the file
            // including the prologue(s), the bison declarations and
            // the grammar rules.
            pattern: /^(?:[^%]|%(?!%))*%%[\s\S]*?%%/,
            inside: {
                c: {
                    // Allow for one level of nested braces
                    pattern: /%\{[\s\S]*?%\}|\{(?:\{[^}]*\}|[^{}])*\}/,
                    inside: {
                        delimiter: {
                            pattern: /^%?\{|%?\}$/,
                            alias: 'punctuation'
                        },
                        'bison-variable': {
                            pattern: /[$@](?:<[^\s>]+>)?[\w$]+/,
                            alias: 'variable',
                            inside: {
                                punctuation: /<|>/
                            }
                        },
                        rest: Prism.languages.c
                    }
                },
                comment: Prism.languages.c.comment,
                string: Prism.languages.c.string,
                property: /\S+(?=:)/,
                keyword: /%\w+/,
                number: {
                    pattern: /(^|[^@])\b(?:0x[\da-f]+|\d+)/i,
                    lookbehind: true
                },
                punctuation: /%[%?]|[|:;\[\]<>]/
            }
        }
    });
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $c71f9922480b0744$export$2e2bcd8739ae039.displayName = 'bnf';
$c71f9922480b0744$export$2e2bcd8739ae039.aliases = [
    'rbnf'
];
function $c71f9922480b0744$export$2e2bcd8739ae039(Prism) {
    Prism.languages.bnf = {
        string: {
            pattern: /"[^\r\n"]*"|'[^\r\n']*'/
        },
        definition: {
            pattern: /<[^<>\r\n\t]+>(?=\s*::=)/,
            alias: [
                'rule',
                'keyword'
            ],
            inside: {
                punctuation: /^<|>$/
            }
        },
        rule: {
            pattern: /<[^<>\r\n\t]+>/,
            inside: {
                punctuation: /^<|>$/
            }
        },
        operator: /::=|[|()[\]{}*+?]|\.{3}/
    };
    Prism.languages.rbnf = Prism.languages.bnf;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $a3d00393544ce230$export$2e2bcd8739ae039.displayName = 'bqn';
$a3d00393544ce230$export$2e2bcd8739ae039.aliases = [];
function $a3d00393544ce230$export$2e2bcd8739ae039(Prism) {
    Prism.languages.bqn = {
        shebang: {
            pattern: /^#![ \t]*\/.*/,
            alias: 'important',
            greedy: true
        },
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        'string-literal': {
            pattern: /"(?:[^"]|"")*"/,
            greedy: true,
            alias: 'string'
        },
        'character-literal': {
            pattern: /'(?:[\s\S]|[\uD800-\uDBFF][\uDC00-\uDFFF])'/,
            greedy: true,
            alias: 'char'
        },
        function: /•[\w¯.∞π]+[\w¯.∞π]*/,
        'dot-notation-on-brackets': {
            pattern: /\{(?=.*\}\.)|\}\./,
            alias: 'namespace'
        },
        'special-name': {
            pattern: /(?:𝕨|𝕩|𝕗|𝕘|𝕤|𝕣|𝕎|𝕏|𝔽|𝔾|𝕊|_𝕣_|_𝕣)/,
            alias: 'keyword'
        },
        'dot-notation-on-name': {
            pattern: /[A-Za-z_][\w¯∞π]*\./,
            alias: 'namespace'
        },
        'word-number-scientific': {
            pattern: /\d+(?:\.\d+)?[eE]¯?\d+/,
            alias: 'number'
        },
        'word-name': {
            pattern: /[A-Za-z_][\w¯∞π]*/,
            alias: 'symbol'
        },
        'word-number': {
            pattern: /[¯∞π]?(?:\d*\.?\b\d+(?:e[+¯]?\d+|E[+¯]?\d+)?|¯|∞|π)(?:j¯?(?:(?:\d+(?:\.\d+)?|\.\d+)(?:e[+¯]?\d+|E[+¯]?\d+)?|¯|∞|π))?/,
            alias: 'number'
        },
        'null-literal': {
            pattern: /@/,
            alias: 'char'
        },
        'primitive-functions': {
            pattern: /[-+×÷⋆√⌊⌈|¬∧∨<>≠=≤≥≡≢⊣⊢⥊∾≍⋈↑↓↕«»⌽⍉/⍋⍒⊏⊑⊐⊒∊⍷⊔!]/,
            alias: 'operator'
        },
        'primitive-1-operators': {
            pattern: /[`˜˘¨⁼⌜´˝˙]/,
            alias: 'operator'
        },
        'primitive-2-operators': {
            pattern: /[∘⊸⟜○⌾⎉⚇⍟⊘◶⎊]/,
            alias: 'operator'
        },
        punctuation: /[←⇐↩(){}⟨⟩[\]‿·⋄,.;:?]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $cf785f3588045cda$export$2e2bcd8739ae039.displayName = 'brainfuck';
$cf785f3588045cda$export$2e2bcd8739ae039.aliases = [];
function $cf785f3588045cda$export$2e2bcd8739ae039(Prism) {
    Prism.languages.brainfuck = {
        pointer: {
            pattern: /<|>/,
            alias: 'keyword'
        },
        increment: {
            pattern: /\+/,
            alias: 'inserted'
        },
        decrement: {
            pattern: /-/,
            alias: 'deleted'
        },
        branching: {
            pattern: /\[|\]/,
            alias: 'important'
        },
        operator: /[.,]/,
        comment: /\S+/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $59fc0f93be148eaa$export$2e2bcd8739ae039.displayName = 'brightscript';
$59fc0f93be148eaa$export$2e2bcd8739ae039.aliases = [];
function $59fc0f93be148eaa$export$2e2bcd8739ae039(Prism) {
    Prism.languages.brightscript = {
        comment: /(?:\brem|').*/i,
        'directive-statement': {
            pattern: /(^[\t ]*)#(?:const|else(?:[\t ]+if)?|end[\t ]+if|error|if).*/im,
            lookbehind: true,
            alias: 'property',
            inside: {
                'error-message': {
                    pattern: /(^#error).+/,
                    lookbehind: true
                },
                directive: {
                    pattern: /^#(?:const|else(?:[\t ]+if)?|end[\t ]+if|error|if)/,
                    alias: 'keyword'
                },
                expression: {
                    pattern: /[\s\S]+/,
                    inside: null // see below
                }
            }
        },
        property: {
            pattern: /([\r\n{,][\t ]*)(?:(?!\d)\w+|"(?:[^"\r\n]|"")*"(?!"))(?=[ \t]*:)/,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"\r\n]|"")*"(?!")/,
            greedy: true
        },
        'class-name': {
            pattern: /(\bAs[\t ]+)\w+/i,
            lookbehind: true
        },
        keyword: /\b(?:As|Dim|Each|Else|Elseif|End|Exit|For|Function|Goto|If|In|Print|Return|Step|Stop|Sub|Then|To|While)\b/i,
        boolean: /\b(?:false|true)\b/i,
        function: /\b(?!\d)\w+(?=[\t ]*\()/,
        number: /(?:\b\d+(?:\.\d+)?(?:[ed][+-]\d+)?|&h[a-f\d]+)\b[%&!#]?/i,
        operator: /--|\+\+|>>=?|<<=?|<>|[-+*/\\<>]=?|[:^=?]|\b(?:and|mod|not|or)\b/i,
        punctuation: /[.,;()[\]{}]/,
        constant: /\b(?:LINE_NUM)\b/i
    };
    Prism.languages.brightscript['directive-statement'].inside.expression.inside = Prism.languages.brightscript;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $76e312b5f9c1dafd$export$2e2bcd8739ae039.displayName = 'bro';
$76e312b5f9c1dafd$export$2e2bcd8739ae039.aliases = [];
function $76e312b5f9c1dafd$export$2e2bcd8739ae039(Prism) {
    Prism.languages.bro = {
        comment: {
            pattern: /(^|[^\\$])#.*/,
            lookbehind: true,
            inside: {
                italic: /\b(?:FIXME|TODO|XXX)\b/
            }
        },
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        boolean: /\b[TF]\b/,
        function: {
            pattern: /(\b(?:event|function|hook)[ \t]+)\w+(?:::\w+)?/,
            lookbehind: true
        },
        builtin: /(?:@(?:load(?:-(?:plugin|sigs))?|unload|prefixes|ifn?def|else|(?:end)?if|DIR|FILENAME))|(?:&?(?:add_func|create_expire|default|delete_func|encrypt|error_handler|expire_func|group|log|mergeable|optional|persistent|priority|raw_output|read_expire|redef|rotate_interval|rotate_size|synchronized|type_column|write_expire))/,
        constant: {
            pattern: /(\bconst[ \t]+)\w+/i,
            lookbehind: true
        },
        keyword: /\b(?:add|addr|alarm|any|bool|break|const|continue|count|delete|double|else|enum|event|export|file|for|function|global|hook|if|in|int|interval|local|module|next|of|opaque|pattern|port|print|record|return|schedule|set|string|subnet|table|time|timeout|using|vector|when)\b/,
        operator: /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&|\|\|?|\?|\*|\/|~|\^|%/,
        number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
        punctuation: /[{}[\];(),.:]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $2959da9e8e9aaa6e$export$2e2bcd8739ae039.displayName = 'bsl';
$2959da9e8e9aaa6e$export$2e2bcd8739ae039.aliases = [
    'oscript'
];
function $2959da9e8e9aaa6e$export$2e2bcd8739ae039(Prism) {
    /* eslint-disable no-misleading-character-class */ // 1C:Enterprise
    // https://github.com/Diversus23/
    //
    Prism.languages.bsl = {
        comment: /\/\/.*/,
        string: [
            // Строки
            // Strings
            {
                pattern: /"(?:[^"]|"")*"(?!")/,
                greedy: true
            },
            // Дата и время
            // Date & time
            {
                pattern: /'(?:[^'\r\n\\]|\\.)*'/
            }
        ],
        keyword: [
            {
                // RU
                pattern: /(^|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:пока|для|новый|прервать|попытка|исключение|вызватьисключение|иначе|конецпопытки|неопределено|функция|перем|возврат|конецфункции|если|иначеесли|процедура|конецпроцедуры|тогда|знач|экспорт|конецесли|из|каждого|истина|ложь|по|цикл|конеццикла|выполнить)(?![\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])/i,
                lookbehind: true
            },
            {
                // EN
                pattern: /\b(?:break|do|each|else|elseif|enddo|endfunction|endif|endprocedure|endtry|except|execute|export|false|for|function|if|in|new|null|procedure|raise|return|then|to|true|try|undefined|val|var|while)\b/i
            }
        ],
        number: {
            pattern: /(^(?=\d)|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:\d+(?:\.\d*)?|\.\d+)(?:E[+-]?\d+)?/i,
            lookbehind: true
        },
        operator: [
            /[<>+\-*/]=?|[%=]/,
            // RU
            {
                pattern: /(^|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:и|или|не)(?![\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])/i,
                lookbehind: true
            },
            // EN
            {
                pattern: /\b(?:and|not|or)\b/i
            }
        ],
        punctuation: /\(\.|\.\)|[()\[\]:;,.]/,
        directive: [
            // Теги препроцессора вида &Клиент, &Сервер, ...
            // Preprocessor tags of the type &Client, &Server, ...
            {
                pattern: /^([ \t]*)&.*/m,
                lookbehind: true,
                greedy: true,
                alias: 'important'
            },
            // Инструкции препроцессора вида:
            // #Если Сервер Тогда
            // ...
            // #КонецЕсли
            // Preprocessor instructions of the form:
            // #If Server Then
            // ...
            // #EndIf
            {
                pattern: /^([ \t]*)#.*/gm,
                lookbehind: true,
                greedy: true,
                alias: 'important'
            }
        ]
    };
    Prism.languages.oscript = Prism.languages['bsl'];
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$f2f07591da692ef4$export$2e2bcd8739ae039.displayName = 'cfscript';
$f2f07591da692ef4$export$2e2bcd8739ae039.aliases = [
    'cfc'
];
function $f2f07591da692ef4$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    // https://cfdocs.org/script
    Prism.languages.cfscript = Prism.languages.extend('clike', {
        comment: [
            {
                pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                lookbehind: true,
                inside: {
                    annotation: {
                        pattern: /(?:^|[^.])@[\w\.]+/,
                        alias: 'punctuation'
                    }
                }
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        keyword: /\b(?:abstract|break|catch|component|continue|default|do|else|extends|final|finally|for|function|if|in|include|package|private|property|public|remote|required|rethrow|return|static|switch|throw|try|var|while|xml)\b(?!\s*=)/,
        operator: [
            /\+\+|--|&&|\|\||::|=>|[!=]==|[-+*/%&|^!=<>]=?|\?(?:\.|:)?|:/,
            /\b(?:and|contains|eq|equal|eqv|gt|gte|imp|is|lt|lte|mod|not|or|xor)\b/
        ],
        scope: {
            pattern: /\b(?:application|arguments|cgi|client|cookie|local|session|super|this|variables)\b/,
            alias: 'global'
        },
        type: {
            pattern: /\b(?:any|array|binary|boolean|date|guid|numeric|query|string|struct|uuid|void|xml)\b/,
            alias: 'builtin'
        }
    });
    Prism.languages.insertBefore('cfscript', 'keyword', {
        // This must be declared before keyword because we use "function" inside the lookahead
        'function-variable': {
            pattern: /[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
            alias: 'function'
        }
    });
    delete Prism.languages.cfscript['class-name'];
    Prism.languages.cfc = Prism.languages['cfscript'];
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 

$d89c7404fbd627bd$export$2e2bcd8739ae039.displayName = 'chaiscript';
$d89c7404fbd627bd$export$2e2bcd8739ae039.aliases = [];
function $d89c7404fbd627bd$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    Prism.register((0, $48c36581818e331d$export$2e2bcd8739ae039));
    Prism.languages.chaiscript = Prism.languages.extend('clike', {
        string: {
            pattern: /(^|[^\\])'(?:[^'\\]|\\[\s\S])*'/,
            lookbehind: true,
            greedy: true
        },
        'class-name': [
            {
                // e.g. class Rectangle { ... }
                pattern: /(\bclass\s+)\w+/,
                lookbehind: true
            },
            {
                // e.g. attr Rectangle::height, def Rectangle::area() { ... }
                pattern: /(\b(?:attr|def)\s+)\w+(?=\s*::)/,
                lookbehind: true
            }
        ],
        keyword: /\b(?:attr|auto|break|case|catch|class|continue|def|default|else|finally|for|fun|global|if|return|switch|this|try|var|while)\b/,
        number: [
            Prism.languages.cpp.number,
            /\b(?:Infinity|NaN)\b/
        ],
        operator: />>=?|<<=?|\|\||&&|:[:=]?|--|\+\+|[=!<>+\-*/%|&^]=?|[?~]|`[^`\r\n]{1,4}`/
    });
    Prism.languages.insertBefore('chaiscript', 'operator', {
        'parameter-type': {
            // e.g. def foo(int x, Vector y) {...}
            pattern: /([,(]\s*)\w+(?=\s+\w)/,
            lookbehind: true,
            alias: 'class-name'
        }
    });
    Prism.languages.insertBefore('chaiscript', 'string', {
        'string-interpolation': {
            pattern: /(^|[^\\])"(?:[^"$\\]|\\[\s\S]|\$(?!\{)|\$\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*"/,
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\}/,
                    lookbehind: true,
                    inside: {
                        'interpolation-expression': {
                            pattern: /(^\$\{)[\s\S]+(?=\}$)/,
                            lookbehind: true,
                            inside: Prism.languages.chaiscript
                        },
                        'interpolation-punctuation': {
                            pattern: /^\$\{|\}$/,
                            alias: 'punctuation'
                        }
                    }
                },
                string: /[\s\S]+/
            }
        }
    });
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $798968c11c0bc12d$export$2e2bcd8739ae039.displayName = 'cil';
$798968c11c0bc12d$export$2e2bcd8739ae039.aliases = [];
function $798968c11c0bc12d$export$2e2bcd8739ae039(Prism) {
    Prism.languages.cil = {
        comment: /\/\/.*/,
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        directive: {
            pattern: /(^|\W)\.[a-z]+(?=\s)/,
            lookbehind: true,
            alias: 'class-name'
        },
        // Actually an assembly reference
        variable: /\[[\w\.]+\]/,
        keyword: /\b(?:abstract|ansi|assembly|auto|autochar|beforefieldinit|bool|bstr|byvalstr|catch|char|cil|class|currency|date|decimal|default|enum|error|explicit|extends|extern|famandassem|family|famorassem|final(?:ly)?|float32|float64|hidebysig|u?int(?:8|16|32|64)?|iant|idispatch|implements|import|initonly|instance|interface|iunknown|literal|lpstr|lpstruct|lptstr|lpwstr|managed|method|native(?:Type)?|nested|newslot|object(?:ref)?|pinvokeimpl|private|privatescope|public|reqsecobj|rtspecialname|runtime|sealed|sequential|serializable|specialname|static|string|struct|syschar|tbstr|unicode|unmanagedexp|unsigned|value(?:type)?|variant|virtual|void)\b/,
        function: /\b(?:(?:constrained|no|readonly|tail|unaligned|volatile)\.)?(?:conv\.(?:[iu][1248]?|ovf\.[iu][1248]?(?:\.un)?|r\.un|r4|r8)|ldc\.(?:i4(?:\.\d+|\.[mM]1|\.s)?|i8|r4|r8)|ldelem(?:\.[iu][1248]?|\.r[48]|\.ref|a)?|ldind\.(?:[iu][1248]?|r[48]|ref)|stelem\.?(?:i[1248]?|r[48]|ref)?|stind\.(?:i[1248]?|r[48]|ref)?|end(?:fault|filter|finally)|ldarg(?:\.[0-3s]|a(?:\.s)?)?|ldloc(?:\.\d+|\.s)?|sub(?:\.ovf(?:\.un)?)?|mul(?:\.ovf(?:\.un)?)?|add(?:\.ovf(?:\.un)?)?|stloc(?:\.[0-3s])?|refany(?:type|val)|blt(?:\.un)?(?:\.s)?|ble(?:\.un)?(?:\.s)?|bgt(?:\.un)?(?:\.s)?|bge(?:\.un)?(?:\.s)?|unbox(?:\.any)?|init(?:blk|obj)|call(?:i|virt)?|brfalse(?:\.s)?|bne\.un(?:\.s)?|ldloca(?:\.s)?|brzero(?:\.s)?|brtrue(?:\.s)?|brnull(?:\.s)?|brinst(?:\.s)?|starg(?:\.s)?|leave(?:\.s)?|shr(?:\.un)?|rem(?:\.un)?|div(?:\.un)?|clt(?:\.un)?|alignment|castclass|ldvirtftn|beq(?:\.s)?|ckfinite|ldsflda|ldtoken|localloc|mkrefany|rethrow|cgt\.un|arglist|switch|stsfld|sizeof|newobj|newarr|ldsfld|ldnull|ldflda|isinst|throw|stobj|stfld|ldstr|ldobj|ldlen|ldftn|ldfld|cpobj|cpblk|break|br\.s|xor|shl|ret|pop|not|nop|neg|jmp|dup|cgt|ceq|box|and|or|br)\b/,
        boolean: /\b(?:false|true)\b/,
        number: /\b-?(?:0x[0-9a-f]+|\d+)(?:\.[0-9a-f]+)?\b/i,
        punctuation: /[{}[\];(),:=]|IL_[0-9A-Za-z]+/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$5aff22135ddd5819$export$2e2bcd8739ae039.displayName = 'cilkc';
$5aff22135ddd5819$export$2e2bcd8739ae039.aliases = [
    'cilk-c'
];
function $5aff22135ddd5819$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $e064275ae5958777$export$2e2bcd8739ae039));
    Prism.languages.cilkc = Prism.languages.insertBefore('c', 'function', {
        'parallel-keyword': {
            pattern: /\bcilk_(?:for|reducer|s(?:cope|pawn|ync))\b/,
            alias: 'keyword'
        }
    });
    Prism.languages['cilk-c'] = Prism.languages['cilkc'];
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$6d8a360147f50c03$export$2e2bcd8739ae039.displayName = 'cilkcpp';
$6d8a360147f50c03$export$2e2bcd8739ae039.aliases = [
    'cilk',
    'cilk-cpp'
];
function $6d8a360147f50c03$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $48c36581818e331d$export$2e2bcd8739ae039));
    Prism.languages.cilkcpp = Prism.languages.insertBefore('cpp', 'function', {
        'parallel-keyword': {
            pattern: /\bcilk_(?:for|reducer|s(?:cope|pawn|ync))\b/,
            alias: 'keyword'
        }
    });
    Prism.languages['cilk-cpp'] = Prism.languages['cilkcpp'];
    Prism.languages['cilk'] = Prism.languages['cilkcpp'];
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $078c1acafabfb52e$export$2e2bcd8739ae039.displayName = 'clojure';
$078c1acafabfb52e$export$2e2bcd8739ae039.aliases = [];
function $078c1acafabfb52e$export$2e2bcd8739ae039(Prism) {
    // Copied from https://github.com/jeluard/prism-clojure
    Prism.languages.clojure = {
        comment: {
            pattern: /;.*/,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"\\]|\\.)*"/,
            greedy: true
        },
        char: /\\\w+/,
        symbol: {
            pattern: /(^|[\s()\[\]{},])::?[\w*+!?'<>=/.-]+/,
            lookbehind: true
        },
        keyword: {
            pattern: /(\()(?:-|->|->>|\.|\.\.|\*|\/|\+|<|<=|=|==|>|>=|accessor|agent|agent-errors|aget|alength|all-ns|alter|and|append-child|apply|array-map|aset|aset-boolean|aset-byte|aset-char|aset-double|aset-float|aset-int|aset-long|aset-short|assert|assoc|await|await-for|bean|binding|bit-and|bit-not|bit-or|bit-shift-left|bit-shift-right|bit-xor|boolean|branch\?|butlast|byte|cast|char|children|class|clear-agent-errors|comment|commute|comp|comparator|complement|concat|cond|conj|cons|constantly|construct-proxy|contains\?|count|create-ns|create-struct|cycle|dec|declare|def|def-|definline|definterface|defmacro|defmethod|defmulti|defn|defn-|defonce|defproject|defprotocol|defrecord|defstruct|deftype|deref|difference|disj|dissoc|distinct|do|doall|doc|dorun|doseq|dosync|dotimes|doto|double|down|drop|drop-while|edit|end\?|ensure|eval|every\?|false\?|ffirst|file-seq|filter|find|find-doc|find-ns|find-var|first|float|flush|fn|fnseq|for|frest|gensym|get|get-proxy-class|hash-map|hash-set|identical\?|identity|if|if-let|if-not|import|in-ns|inc|index|insert-child|insert-left|insert-right|inspect-table|inspect-tree|instance\?|int|interleave|intersection|into|into-array|iterate|join|key|keys|keyword|keyword\?|last|lazy-cat|lazy-cons|left|lefts|let|line-seq|list|list\*|load|load-file|locking|long|loop|macroexpand|macroexpand-1|make-array|make-node|map|map-invert|map\?|mapcat|max|max-key|memfn|merge|merge-with|meta|min|min-key|monitor-enter|name|namespace|neg\?|new|newline|next|nil\?|node|not|not-any\?|not-every\?|not=|ns|ns-imports|ns-interns|ns-map|ns-name|ns-publics|ns-refers|ns-resolve|ns-unmap|nth|nthrest|or|parse|partial|path|peek|pop|pos\?|pr|pr-str|print|print-str|println|println-str|prn|prn-str|project|proxy|proxy-mappings|quot|quote|rand|rand-int|range|re-find|re-groups|re-matcher|re-matches|re-pattern|re-seq|read|read-line|recur|reduce|ref|ref-set|refer|rem|remove|remove-method|remove-ns|rename|rename-keys|repeat|replace|replicate|resolve|rest|resultset-seq|reverse|rfirst|right|rights|root|rrest|rseq|second|select|select-keys|send|send-off|seq|seq-zip|seq\?|set|set!|short|slurp|some|sort|sort-by|sorted-map|sorted-map-by|sorted-set|special-symbol\?|split-at|split-with|str|string\?|struct|struct-map|subs|subvec|symbol|symbol\?|sync|take|take-nth|take-while|test|throw|time|to-array|to-array-2d|tree-seq|true\?|try|union|up|update-proxy|val|vals|var|var-get|var-set|var\?|vector|vector-zip|vector\?|when|when-first|when-let|when-not|with-local-vars|with-meta|with-open|with-out-str|xml-seq|xml-zip|zero\?|zipmap|zipper)(?=[\s)]|$)/,
            lookbehind: true
        },
        boolean: /\b(?:false|nil|true)\b/,
        number: {
            pattern: /(^|[^\w$@])(?:\d+(?:[/.]\d+)?(?:e[+-]?\d+)?|0x[a-f0-9]+|[1-9]\d?r[a-z0-9]+)[lmn]?(?![\w$@])/i,
            lookbehind: true
        },
        function: {
            pattern: /((?:^|[^'])\()[\w*+!?'<>=/.-]+(?=[\s)]|$)/,
            lookbehind: true
        },
        operator: /[#@^`~]/,
        punctuation: /[{}\[\](),]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $cee2ea6304aada5e$export$2e2bcd8739ae039.displayName = 'cmake';
$cee2ea6304aada5e$export$2e2bcd8739ae039.aliases = [];
function $cee2ea6304aada5e$export$2e2bcd8739ae039(Prism) {
    Prism.languages.cmake = {
        comment: /#.*/,
        string: {
            pattern: /"(?:[^\\"]|\\.)*"/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /\$\{(?:[^{}$]|\$\{[^{}$]*\})*\}/,
                    inside: {
                        punctuation: /\$\{|\}/,
                        variable: /\w+/
                    }
                }
            }
        },
        variable: /\b(?:CMAKE_\w+|\w+_(?:(?:BINARY|SOURCE)_DIR|DESCRIPTION|HOMEPAGE_URL|ROOT|VERSION(?:_MAJOR|_MINOR|_PATCH|_TWEAK)?)|(?:ANDROID|APPLE|BORLAND|BUILD_SHARED_LIBS|CACHE|CPACK_(?:ABSOLUTE_DESTINATION_FILES|COMPONENT_INCLUDE_TOPLEVEL_DIRECTORY|ERROR_ON_ABSOLUTE_INSTALL_DESTINATION|INCLUDE_TOPLEVEL_DIRECTORY|INSTALL_DEFAULT_DIRECTORY_PERMISSIONS|INSTALL_SCRIPT|PACKAGING_INSTALL_PREFIX|SET_DESTDIR|WARN_ON_ABSOLUTE_INSTALL_DESTINATION)|CTEST_(?:BINARY_DIRECTORY|BUILD_COMMAND|BUILD_NAME|BZR_COMMAND|BZR_UPDATE_OPTIONS|CHANGE_ID|CHECKOUT_COMMAND|CONFIGURATION_TYPE|CONFIGURE_COMMAND|COVERAGE_COMMAND|COVERAGE_EXTRA_FLAGS|CURL_OPTIONS|CUSTOM_(?:COVERAGE_EXCLUDE|ERROR_EXCEPTION|ERROR_MATCH|ERROR_POST_CONTEXT|ERROR_PRE_CONTEXT|MAXIMUM_FAILED_TEST_OUTPUT_SIZE|MAXIMUM_NUMBER_OF_(?:ERRORS|WARNINGS)|MAXIMUM_PASSED_TEST_OUTPUT_SIZE|MEMCHECK_IGNORE|POST_MEMCHECK|POST_TEST|PRE_MEMCHECK|PRE_TEST|TESTS_IGNORE|WARNING_EXCEPTION|WARNING_MATCH)|CVS_CHECKOUT|CVS_COMMAND|CVS_UPDATE_OPTIONS|DROP_LOCATION|DROP_METHOD|DROP_SITE|DROP_SITE_CDASH|DROP_SITE_PASSWORD|DROP_SITE_USER|EXTRA_COVERAGE_GLOB|GIT_COMMAND|GIT_INIT_SUBMODULES|GIT_UPDATE_CUSTOM|GIT_UPDATE_OPTIONS|HG_COMMAND|HG_UPDATE_OPTIONS|LABELS_FOR_SUBPROJECTS|MEMORYCHECK_(?:COMMAND|COMMAND_OPTIONS|SANITIZER_OPTIONS|SUPPRESSIONS_FILE|TYPE)|NIGHTLY_START_TIME|P4_CLIENT|P4_COMMAND|P4_OPTIONS|P4_UPDATE_OPTIONS|RUN_CURRENT_SCRIPT|SCP_COMMAND|SITE|SOURCE_DIRECTORY|SUBMIT_URL|SVN_COMMAND|SVN_OPTIONS|SVN_UPDATE_OPTIONS|TEST_LOAD|TEST_TIMEOUT|TRIGGER_SITE|UPDATE_COMMAND|UPDATE_OPTIONS|UPDATE_VERSION_ONLY|USE_LAUNCHERS)|CYGWIN|ENV|EXECUTABLE_OUTPUT_PATH|GHS-MULTI|IOS|LIBRARY_OUTPUT_PATH|MINGW|MSVC(?:10|11|12|14|60|70|71|80|90|_IDE|_TOOLSET_VERSION|_VERSION)?|MSYS|PROJECT_NAME|UNIX|WIN32|WINCE|WINDOWS_PHONE|WINDOWS_STORE|XCODE))\b/,
        property: /\b(?:cxx_\w+|(?:ARCHIVE_OUTPUT_(?:DIRECTORY|NAME)|COMPILE_DEFINITIONS|COMPILE_PDB_NAME|COMPILE_PDB_OUTPUT_DIRECTORY|EXCLUDE_FROM_DEFAULT_BUILD|IMPORTED_(?:IMPLIB|LIBNAME|LINK_DEPENDENT_LIBRARIES|LINK_INTERFACE_LANGUAGES|LINK_INTERFACE_LIBRARIES|LINK_INTERFACE_MULTIPLICITY|LOCATION|NO_SONAME|OBJECTS|SONAME)|INTERPROCEDURAL_OPTIMIZATION|LIBRARY_OUTPUT_DIRECTORY|LIBRARY_OUTPUT_NAME|LINK_FLAGS|LINK_INTERFACE_LIBRARIES|LINK_INTERFACE_MULTIPLICITY|LOCATION|MAP_IMPORTED_CONFIG|OSX_ARCHITECTURES|OUTPUT_NAME|PDB_NAME|PDB_OUTPUT_DIRECTORY|RUNTIME_OUTPUT_DIRECTORY|RUNTIME_OUTPUT_NAME|STATIC_LIBRARY_FLAGS|VS_CSHARP|VS_DOTNET_REFERENCEPROP|VS_DOTNET_REFERENCE|VS_GLOBAL_SECTION_POST|VS_GLOBAL_SECTION_PRE|VS_GLOBAL|XCODE_ATTRIBUTE)_\w+|\w+_(?:CLANG_TIDY|COMPILER_LAUNCHER|CPPCHECK|CPPLINT|INCLUDE_WHAT_YOU_USE|OUTPUT_NAME|POSTFIX|VISIBILITY_PRESET)|ABSTRACT|ADDITIONAL_MAKE_CLEAN_FILES|ADVANCED|ALIASED_TARGET|ALLOW_DUPLICATE_CUSTOM_TARGETS|ANDROID_(?:ANT_ADDITIONAL_OPTIONS|API|API_MIN|ARCH|ASSETS_DIRECTORIES|GUI|JAR_DEPENDENCIES|NATIVE_LIB_DEPENDENCIES|NATIVE_LIB_DIRECTORIES|PROCESS_MAX|PROGUARD|PROGUARD_CONFIG_PATH|SECURE_PROPS_PATH|SKIP_ANT_STEP|STL_TYPE)|ARCHIVE_OUTPUT_DIRECTORY|ATTACHED_FILES|ATTACHED_FILES_ON_FAIL|AUTOGEN_(?:BUILD_DIR|ORIGIN_DEPENDS|PARALLEL|SOURCE_GROUP|TARGETS_FOLDER|TARGET_DEPENDS)|AUTOMOC|AUTOMOC_(?:COMPILER_PREDEFINES|DEPEND_FILTERS|EXECUTABLE|MACRO_NAMES|MOC_OPTIONS|SOURCE_GROUP|TARGETS_FOLDER)|AUTORCC|AUTORCC_EXECUTABLE|AUTORCC_OPTIONS|AUTORCC_SOURCE_GROUP|AUTOUIC|AUTOUIC_EXECUTABLE|AUTOUIC_OPTIONS|AUTOUIC_SEARCH_PATHS|BINARY_DIR|BUILDSYSTEM_TARGETS|BUILD_RPATH|BUILD_RPATH_USE_ORIGIN|BUILD_WITH_INSTALL_NAME_DIR|BUILD_WITH_INSTALL_RPATH|BUNDLE|BUNDLE_EXTENSION|CACHE_VARIABLES|CLEAN_NO_CUSTOM|COMMON_LANGUAGE_RUNTIME|COMPATIBLE_INTERFACE_(?:BOOL|NUMBER_MAX|NUMBER_MIN|STRING)|COMPILE_(?:DEFINITIONS|FEATURES|FLAGS|OPTIONS|PDB_NAME|PDB_OUTPUT_DIRECTORY)|COST|CPACK_DESKTOP_SHORTCUTS|CPACK_NEVER_OVERWRITE|CPACK_PERMANENT|CPACK_STARTUP_SHORTCUTS|CPACK_START_MENU_SHORTCUTS|CPACK_WIX_ACL|CROSSCOMPILING_EMULATOR|CUDA_EXTENSIONS|CUDA_PTX_COMPILATION|CUDA_RESOLVE_DEVICE_SYMBOLS|CUDA_SEPARABLE_COMPILATION|CUDA_STANDARD|CUDA_STANDARD_REQUIRED|CXX_EXTENSIONS|CXX_STANDARD|CXX_STANDARD_REQUIRED|C_EXTENSIONS|C_STANDARD|C_STANDARD_REQUIRED|DEBUG_CONFIGURATIONS|DEFINE_SYMBOL|DEFINITIONS|DEPENDS|DEPLOYMENT_ADDITIONAL_FILES|DEPLOYMENT_REMOTE_DIRECTORY|DISABLED|DISABLED_FEATURES|ECLIPSE_EXTRA_CPROJECT_CONTENTS|ECLIPSE_EXTRA_NATURES|ENABLED_FEATURES|ENABLED_LANGUAGES|ENABLE_EXPORTS|ENVIRONMENT|EXCLUDE_FROM_ALL|EXCLUDE_FROM_DEFAULT_BUILD|EXPORT_NAME|EXPORT_PROPERTIES|EXTERNAL_OBJECT|EchoString|FAIL_REGULAR_EXPRESSION|FIND_LIBRARY_USE_LIB32_PATHS|FIND_LIBRARY_USE_LIB64_PATHS|FIND_LIBRARY_USE_LIBX32_PATHS|FIND_LIBRARY_USE_OPENBSD_VERSIONING|FIXTURES_CLEANUP|FIXTURES_REQUIRED|FIXTURES_SETUP|FOLDER|FRAMEWORK|Fortran_FORMAT|Fortran_MODULE_DIRECTORY|GENERATED|GENERATOR_FILE_NAME|GENERATOR_IS_MULTI_CONFIG|GHS_INTEGRITY_APP|GHS_NO_SOURCE_GROUP_FILE|GLOBAL_DEPENDS_DEBUG_MODE|GLOBAL_DEPENDS_NO_CYCLES|GNUtoMS|HAS_CXX|HEADER_FILE_ONLY|HELPSTRING|IMPLICIT_DEPENDS_INCLUDE_TRANSFORM|IMPORTED|IMPORTED_(?:COMMON_LANGUAGE_RUNTIME|CONFIGURATIONS|GLOBAL|IMPLIB|LIBNAME|LINK_DEPENDENT_LIBRARIES|LINK_INTERFACE_(?:LANGUAGES|LIBRARIES|MULTIPLICITY)|LOCATION|NO_SONAME|OBJECTS|SONAME)|IMPORT_PREFIX|IMPORT_SUFFIX|INCLUDE_DIRECTORIES|INCLUDE_REGULAR_EXPRESSION|INSTALL_NAME_DIR|INSTALL_RPATH|INSTALL_RPATH_USE_LINK_PATH|INTERFACE_(?:AUTOUIC_OPTIONS|COMPILE_DEFINITIONS|COMPILE_FEATURES|COMPILE_OPTIONS|INCLUDE_DIRECTORIES|LINK_DEPENDS|LINK_DIRECTORIES|LINK_LIBRARIES|LINK_OPTIONS|POSITION_INDEPENDENT_CODE|SOURCES|SYSTEM_INCLUDE_DIRECTORIES)|INTERPROCEDURAL_OPTIMIZATION|IN_TRY_COMPILE|IOS_INSTALL_COMBINED|JOB_POOLS|JOB_POOL_COMPILE|JOB_POOL_LINK|KEEP_EXTENSION|LABELS|LANGUAGE|LIBRARY_OUTPUT_DIRECTORY|LINKER_LANGUAGE|LINK_(?:DEPENDS|DEPENDS_NO_SHARED|DIRECTORIES|FLAGS|INTERFACE_LIBRARIES|INTERFACE_MULTIPLICITY|LIBRARIES|OPTIONS|SEARCH_END_STATIC|SEARCH_START_STATIC|WHAT_YOU_USE)|LISTFILE_STACK|LOCATION|MACOSX_BUNDLE|MACOSX_BUNDLE_INFO_PLIST|MACOSX_FRAMEWORK_INFO_PLIST|MACOSX_PACKAGE_LOCATION|MACOSX_RPATH|MACROS|MANUALLY_ADDED_DEPENDENCIES|MEASUREMENT|MODIFIED|NAME|NO_SONAME|NO_SYSTEM_FROM_IMPORTED|OBJECT_DEPENDS|OBJECT_OUTPUTS|OSX_ARCHITECTURES|OUTPUT_NAME|PACKAGES_FOUND|PACKAGES_NOT_FOUND|PARENT_DIRECTORY|PASS_REGULAR_EXPRESSION|PDB_NAME|PDB_OUTPUT_DIRECTORY|POSITION_INDEPENDENT_CODE|POST_INSTALL_SCRIPT|PREDEFINED_TARGETS_FOLDER|PREFIX|PRE_INSTALL_SCRIPT|PRIVATE_HEADER|PROCESSORS|PROCESSOR_AFFINITY|PROJECT_LABEL|PUBLIC_HEADER|REPORT_UNDEFINED_PROPERTIES|REQUIRED_FILES|RESOURCE|RESOURCE_LOCK|RULE_LAUNCH_COMPILE|RULE_LAUNCH_CUSTOM|RULE_LAUNCH_LINK|RULE_MESSAGES|RUNTIME_OUTPUT_DIRECTORY|RUN_SERIAL|SKIP_AUTOGEN|SKIP_AUTOMOC|SKIP_AUTORCC|SKIP_AUTOUIC|SKIP_BUILD_RPATH|SKIP_RETURN_CODE|SOURCES|SOURCE_DIR|SOVERSION|STATIC_LIBRARY_FLAGS|STATIC_LIBRARY_OPTIONS|STRINGS|SUBDIRECTORIES|SUFFIX|SYMBOLIC|TARGET_ARCHIVES_MAY_BE_SHARED_LIBS|TARGET_MESSAGES|TARGET_SUPPORTS_SHARED_LIBS|TESTS|TEST_INCLUDE_FILE|TEST_INCLUDE_FILES|TIMEOUT|TIMEOUT_AFTER_MATCH|TYPE|USE_FOLDERS|VALUE|VARIABLES|VERSION|VISIBILITY_INLINES_HIDDEN|VS_(?:CONFIGURATION_TYPE|COPY_TO_OUT_DIR|DEBUGGER_(?:COMMAND|COMMAND_ARGUMENTS|ENVIRONMENT|WORKING_DIRECTORY)|DEPLOYMENT_CONTENT|DEPLOYMENT_LOCATION|DOTNET_REFERENCES|DOTNET_REFERENCES_COPY_LOCAL|INCLUDE_IN_VSIX|IOT_STARTUP_TASK|KEYWORD|RESOURCE_GENERATOR|SCC_AUXPATH|SCC_LOCALPATH|SCC_PROJECTNAME|SCC_PROVIDER|SDK_REFERENCES|SHADER_(?:DISABLE_OPTIMIZATIONS|ENABLE_DEBUG|ENTRYPOINT|FLAGS|MODEL|OBJECT_FILE_NAME|OUTPUT_HEADER_FILE|TYPE|VARIABLE_NAME)|STARTUP_PROJECT|TOOL_OVERRIDE|USER_PROPS|WINRT_COMPONENT|WINRT_EXTENSIONS|WINRT_REFERENCES|XAML_TYPE)|WILL_FAIL|WIN32_EXECUTABLE|WINDOWS_EXPORT_ALL_SYMBOLS|WORKING_DIRECTORY|WRAP_EXCLUDE|XCODE_(?:EMIT_EFFECTIVE_PLATFORM_NAME|EXPLICIT_FILE_TYPE|FILE_ATTRIBUTES|LAST_KNOWN_FILE_TYPE|PRODUCT_TYPE|SCHEME_(?:ADDRESS_SANITIZER|ADDRESS_SANITIZER_USE_AFTER_RETURN|ARGUMENTS|DISABLE_MAIN_THREAD_CHECKER|DYNAMIC_LIBRARY_LOADS|DYNAMIC_LINKER_API_USAGE|ENVIRONMENT|EXECUTABLE|GUARD_MALLOC|MAIN_THREAD_CHECKER_STOP|MALLOC_GUARD_EDGES|MALLOC_SCRIBBLE|MALLOC_STACK|THREAD_SANITIZER(?:_STOP)?|UNDEFINED_BEHAVIOUR_SANITIZER(?:_STOP)?|ZOMBIE_OBJECTS))|XCTEST)\b/,
        keyword: /\b(?:add_compile_definitions|add_compile_options|add_custom_command|add_custom_target|add_definitions|add_dependencies|add_executable|add_library|add_link_options|add_subdirectory|add_test|aux_source_directory|break|build_command|build_name|cmake_host_system_information|cmake_minimum_required|cmake_parse_arguments|cmake_policy|configure_file|continue|create_test_sourcelist|ctest_build|ctest_configure|ctest_coverage|ctest_empty_binary_directory|ctest_memcheck|ctest_read_custom_files|ctest_run_script|ctest_sleep|ctest_start|ctest_submit|ctest_test|ctest_update|ctest_upload|define_property|else|elseif|enable_language|enable_testing|endforeach|endfunction|endif|endmacro|endwhile|exec_program|execute_process|export|export_library_dependencies|file|find_file|find_library|find_package|find_path|find_program|fltk_wrap_ui|foreach|function|get_cmake_property|get_directory_property|get_filename_component|get_property|get_source_file_property|get_target_property|get_test_property|if|include|include_directories|include_external_msproject|include_guard|include_regular_expression|install|install_files|install_programs|install_targets|link_directories|link_libraries|list|load_cache|load_command|macro|make_directory|mark_as_advanced|math|message|option|output_required_files|project|qt_wrap_cpp|qt_wrap_ui|remove|remove_definitions|return|separate_arguments|set|set_directory_properties|set_property|set_source_files_properties|set_target_properties|set_tests_properties|site_name|source_group|string|subdir_depends|subdirs|target_compile_definitions|target_compile_features|target_compile_options|target_include_directories|target_link_directories|target_link_libraries|target_link_options|target_sources|try_compile|try_run|unset|use_mangled_mesa|utility_source|variable_requires|variable_watch|while|write_file)(?=\s*\()\b/,
        boolean: /\b(?:FALSE|OFF|ON|TRUE)\b/,
        namespace: /\b(?:INTERFACE|PRIVATE|PROPERTIES|PUBLIC|SHARED|STATIC|TARGET_OBJECTS)\b/,
        operator: /\b(?:AND|DEFINED|EQUAL|GREATER|LESS|MATCHES|NOT|OR|STREQUAL|STRGREATER|STRLESS|VERSION_EQUAL|VERSION_GREATER|VERSION_LESS)\b/,
        inserted: {
            pattern: /\b\w+::\w+\b/,
            alias: 'class-name'
        },
        number: /\b\d+(?:\.\d+)*\b/,
        function: /\b[a-z_]\w*(?=\s*\()\b/i,
        punctuation: /[()>}]|\$[<{]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $691efb0e9b94d4ac$export$2e2bcd8739ae039.displayName = 'cobol';
$691efb0e9b94d4ac$export$2e2bcd8739ae039.aliases = [];
function $691efb0e9b94d4ac$export$2e2bcd8739ae039(Prism) {
    Prism.languages.cobol = {
        comment: {
            pattern: /\*>.*|(^[ \t]*)\*.*/m,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /[xzgn]?(?:"(?:[^\r\n"]|"")*"(?!")|'(?:[^\r\n']|'')*'(?!'))/i,
            greedy: true
        },
        level: {
            pattern: /(^[ \t]*)\d+\b/m,
            lookbehind: true,
            greedy: true,
            alias: 'number'
        },
        'class-name': {
            // https://github.com/antlr/grammars-v4/blob/42edd5b687d183b5fa679e858a82297bd27141e7/cobol85/Cobol85.g4#L1015
            pattern: /(\bpic(?:ture)?\s+)(?:(?:[-\w$/,:*+<>]|\.(?!\s|$))(?:\(\d+\))?)+/i,
            lookbehind: true,
            inside: {
                number: {
                    pattern: /(\()\d+/,
                    lookbehind: true
                },
                punctuation: /[()]/
            }
        },
        keyword: {
            pattern: /(^|[^\w-])(?:ABORT|ACCEPT|ACCESS|ADD|ADDRESS|ADVANCING|AFTER|ALIGNED|ALL|ALPHABET|ALPHABETIC|ALPHABETIC-LOWER|ALPHABETIC-UPPER|ALPHANUMERIC|ALPHANUMERIC-EDITED|ALSO|ALTER|ALTERNATE|ANY|ARE|AREA|AREAS|AS|ASCENDING|ASCII|ASSIGN|ASSOCIATED-DATA|ASSOCIATED-DATA-LENGTH|AT|ATTRIBUTE|AUTHOR|AUTO|AUTO-SKIP|BACKGROUND-COLOR|BACKGROUND-COLOUR|BASIS|BEEP|BEFORE|BEGINNING|BELL|BINARY|BIT|BLANK|BLINK|BLOCK|BOTTOM|BOUNDS|BY|BYFUNCTION|BYTITLE|CALL|CANCEL|CAPABLE|CCSVERSION|CD|CF|CH|CHAINING|CHANGED|CHANNEL|CHARACTER|CHARACTERS|CLASS|CLASS-ID|CLOCK-UNITS|CLOSE|CLOSE-DISPOSITION|COBOL|CODE|CODE-SET|COL|COLLATING|COLUMN|COM-REG|COMMA|COMMITMENT|COMMON|COMMUNICATION|COMP|COMP-1|COMP-2|COMP-3|COMP-4|COMP-5|COMPUTATIONAL|COMPUTATIONAL-1|COMPUTATIONAL-2|COMPUTATIONAL-3|COMPUTATIONAL-4|COMPUTATIONAL-5|COMPUTE|CONFIGURATION|CONTAINS|CONTENT|CONTINUE|CONTROL|CONTROL-POINT|CONTROLS|CONVENTION|CONVERTING|COPY|CORR|CORRESPONDING|COUNT|CRUNCH|CURRENCY|CURSOR|DATA|DATA-BASE|DATE|DATE-COMPILED|DATE-WRITTEN|DAY|DAY-OF-WEEK|DBCS|DE|DEBUG-CONTENTS|DEBUG-ITEM|DEBUG-LINE|DEBUG-NAME|DEBUG-SUB-1|DEBUG-SUB-2|DEBUG-SUB-3|DEBUGGING|DECIMAL-POINT|DECLARATIVES|DEFAULT|DEFAULT-DISPLAY|DEFINITION|DELETE|DELIMITED|DELIMITER|DEPENDING|DESCENDING|DESTINATION|DETAIL|DFHRESP|DFHVALUE|DISABLE|DISK|DISPLAY|DISPLAY-1|DIVIDE|DIVISION|DONTCARE|DOUBLE|DOWN|DUPLICATES|DYNAMIC|EBCDIC|EGCS|EGI|ELSE|EMI|EMPTY-CHECK|ENABLE|END|END-ACCEPT|END-ADD|END-CALL|END-COMPUTE|END-DELETE|END-DIVIDE|END-EVALUATE|END-IF|END-MULTIPLY|END-OF-PAGE|END-PERFORM|END-READ|END-RECEIVE|END-RETURN|END-REWRITE|END-SEARCH|END-START|END-STRING|END-SUBTRACT|END-UNSTRING|END-WRITE|ENDING|ENTER|ENTRY|ENTRY-PROCEDURE|ENVIRONMENT|EOL|EOP|EOS|ERASE|ERROR|ESCAPE|ESI|EVALUATE|EVENT|EVERY|EXCEPTION|EXCLUSIVE|EXHIBIT|EXIT|EXPORT|EXTEND|EXTENDED|EXTERNAL|FD|FILE|FILE-CONTROL|FILLER|FINAL|FIRST|FOOTING|FOR|FOREGROUND-COLOR|FOREGROUND-COLOUR|FROM|FULL|FUNCTION|FUNCTION-POINTER|FUNCTIONNAME|GENERATE|GIVING|GLOBAL|GO|GOBACK|GRID|GROUP|HEADING|HIGH-VALUE|HIGH-VALUES|HIGHLIGHT|I-O|I-O-CONTROL|ID|IDENTIFICATION|IF|IMPLICIT|IMPORT|IN|INDEX|INDEXED|INDICATE|INITIAL|INITIALIZE|INITIATE|INPUT|INPUT-OUTPUT|INSPECT|INSTALLATION|INTEGER|INTO|INVALID|INVOKE|IS|JUST|JUSTIFIED|KANJI|KEPT|KEY|KEYBOARD|LABEL|LANGUAGE|LAST|LB|LD|LEADING|LEFT|LEFTLINE|LENGTH|LENGTH-CHECK|LIBACCESS|LIBPARAMETER|LIBRARY|LIMIT|LIMITS|LINAGE|LINAGE-COUNTER|LINE|LINE-COUNTER|LINES|LINKAGE|LIST|LOCAL|LOCAL-STORAGE|LOCK|LONG-DATE|LONG-TIME|LOW-VALUE|LOW-VALUES|LOWER|LOWLIGHT|MEMORY|MERGE|MESSAGE|MMDDYYYY|MODE|MODULES|MORE-LABELS|MOVE|MULTIPLE|MULTIPLY|NAMED|NATIONAL|NATIONAL-EDITED|NATIVE|NEGATIVE|NETWORK|NEXT|NO|NO-ECHO|NULL|NULLS|NUMBER|NUMERIC|NUMERIC-DATE|NUMERIC-EDITED|NUMERIC-TIME|OBJECT-COMPUTER|OCCURS|ODT|OF|OFF|OMITTED|ON|OPEN|OPTIONAL|ORDER|ORDERLY|ORGANIZATION|OTHER|OUTPUT|OVERFLOW|OVERLINE|OWN|PACKED-DECIMAL|PADDING|PAGE|PAGE-COUNTER|PASSWORD|PERFORM|PF|PH|PIC|PICTURE|PLUS|POINTER|PORT|POSITION|POSITIVE|PRINTER|PRINTING|PRIVATE|PROCEDURE|PROCEDURE-POINTER|PROCEDURES|PROCEED|PROCESS|PROGRAM|PROGRAM-ID|PROGRAM-LIBRARY|PROMPT|PURGE|QUEUE|QUOTE|QUOTES|RANDOM|RD|READ|READER|REAL|RECEIVE|RECEIVED|RECORD|RECORDING|RECORDS|RECURSIVE|REDEFINES|REEL|REF|REFERENCE|REFERENCES|RELATIVE|RELEASE|REMAINDER|REMARKS|REMOTE|REMOVAL|REMOVE|RENAMES|REPLACE|REPLACING|REPORT|REPORTING|REPORTS|REQUIRED|RERUN|RESERVE|RESET|RETURN|RETURN-CODE|RETURNING|REVERSE-VIDEO|REVERSED|REWIND|REWRITE|RF|RH|RIGHT|ROUNDED|RUN|SAME|SAVE|SCREEN|SD|SEARCH|SECTION|SECURE|SECURITY|SEGMENT|SEGMENT-LIMIT|SELECT|SEND|SENTENCE|SEPARATE|SEQUENCE|SEQUENTIAL|SET|SHARED|SHAREDBYALL|SHAREDBYRUNUNIT|SHARING|SHIFT-IN|SHIFT-OUT|SHORT-DATE|SIGN|SIZE|SORT|SORT-CONTROL|SORT-CORE-SIZE|SORT-FILE-SIZE|SORT-MERGE|SORT-MESSAGE|SORT-MODE-SIZE|SORT-RETURN|SOURCE|SOURCE-COMPUTER|SPACE|SPACES|SPECIAL-NAMES|STANDARD|STANDARD-1|STANDARD-2|START|STATUS|STOP|STRING|SUB-QUEUE-1|SUB-QUEUE-2|SUB-QUEUE-3|SUBTRACT|SUM|SUPPRESS|SYMBOL|SYMBOLIC|SYNC|SYNCHRONIZED|TABLE|TALLY|TALLYING|TAPE|TASK|TERMINAL|TERMINATE|TEST|TEXT|THEN|THREAD|THREAD-LOCAL|THROUGH|THRU|TIME|TIMER|TIMES|TITLE|TO|TODAYS-DATE|TODAYS-NAME|TOP|TRAILING|TRUNCATED|TYPE|TYPEDEF|UNDERLINE|UNIT|UNSTRING|UNTIL|UP|UPON|USAGE|USE|USING|VALUE|VALUES|VARYING|VIRTUAL|WAIT|WHEN|WHEN-COMPILED|WITH|WORDS|WORKING-STORAGE|WRITE|YEAR|YYYYDDD|YYYYMMDD|ZERO-FILL|ZEROES|ZEROS)(?![\w-])/i,
            lookbehind: true
        },
        boolean: {
            pattern: /(^|[^\w-])(?:false|true)(?![\w-])/i,
            lookbehind: true
        },
        number: {
            pattern: /(^|[^\w-])(?:[+-]?(?:(?:\d+(?:[.,]\d+)?|[.,]\d+)(?:e[+-]?\d+)?|zero))(?![\w-])/i,
            lookbehind: true
        },
        operator: [
            /<>|[<>]=?|[=+*/&]/,
            {
                pattern: /(^|[^\w-])(?:-|and|equal|greater|less|not|or|than)(?![\w-])/i,
                lookbehind: true
            }
        ],
        punctuation: /[.:,()]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$d990e59e4070f253$export$2e2bcd8739ae039.displayName = 'coffeescript';
$d990e59e4070f253$export$2e2bcd8739ae039.aliases = [
    'coffee'
];
function $d990e59e4070f253$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $9f5c72e4d4e505c4$export$2e2bcd8739ae039));
    (function(Prism) {
        // Ignore comments starting with { to privilege string interpolation highlighting
        var comment = /#(?!\{).+/;
        var interpolation = {
            pattern: /#\{[^}]+\}/,
            alias: 'variable'
        };
        Prism.languages.coffeescript = Prism.languages.extend('javascript', {
            comment: comment,
            string: [
                // Strings are multiline
                {
                    pattern: /'(?:\\[\s\S]|[^\\'])*'/,
                    greedy: true
                },
                {
                    // Strings are multiline
                    pattern: /"(?:\\[\s\S]|[^\\"])*"/,
                    greedy: true,
                    inside: {
                        interpolation: interpolation
                    }
                }
            ],
            keyword: /\b(?:and|break|by|catch|class|continue|debugger|delete|do|each|else|extend|extends|false|finally|for|if|in|instanceof|is|isnt|let|loop|namespace|new|no|not|null|of|off|on|or|own|return|super|switch|then|this|throw|true|try|typeof|undefined|unless|until|when|while|window|with|yes|yield)\b/,
            'class-member': {
                pattern: /@(?!\d)\w+/,
                alias: 'variable'
            }
        });
        Prism.languages.insertBefore('coffeescript', 'comment', {
            'multiline-comment': {
                pattern: /###[\s\S]+?###/,
                alias: 'comment'
            },
            // Block regexp can contain comments and interpolation
            'block-regex': {
                pattern: /\/{3}[\s\S]*?\/{3}/,
                alias: 'regex',
                inside: {
                    comment: comment,
                    interpolation: interpolation
                }
            }
        });
        Prism.languages.insertBefore('coffeescript', 'string', {
            'inline-javascript': {
                pattern: /`(?:\\[\s\S]|[^\\`])*`/,
                inside: {
                    delimiter: {
                        pattern: /^`|`$/,
                        alias: 'punctuation'
                    },
                    script: {
                        pattern: /[\s\S]+/,
                        alias: 'language-javascript',
                        inside: Prism.languages.javascript
                    }
                }
            },
            // Block strings
            'multiline-string': [
                {
                    pattern: /'''[\s\S]*?'''/,
                    greedy: true,
                    alias: 'string'
                },
                {
                    pattern: /"""[\s\S]*?"""/,
                    greedy: true,
                    alias: 'string',
                    inside: {
                        interpolation: interpolation
                    }
                }
            ]
        });
        Prism.languages.insertBefore('coffeescript', 'keyword', {
            // Object property
            property: /(?!\d)\w+(?=\s*:(?!:))/
        });
        delete Prism.languages.coffeescript['template-string'];
        Prism.languages.coffee = Prism.languages.coffeescript;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $a3d3743a5475e600$export$2e2bcd8739ae039.displayName = 'concurnas';
$a3d3743a5475e600$export$2e2bcd8739ae039.aliases = [
    'conc'
];
function $a3d3743a5475e600$export$2e2bcd8739ae039(Prism) {
    Prism.languages.concurnas = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\/\/.*)/,
            lookbehind: true,
            greedy: true
        },
        langext: {
            pattern: /\b\w+\s*\|\|[\s\S]+?\|\|/,
            greedy: true,
            inside: {
                'class-name': /^\w+/,
                string: {
                    pattern: /(^\s*\|\|)[\s\S]+(?=\|\|$)/,
                    lookbehind: true
                },
                punctuation: /\|\|/
            }
        },
        function: {
            pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/,
            lookbehind: true
        },
        keyword: /\b(?:abstract|actor|also|annotation|assert|async|await|bool|boolean|break|byte|case|catch|changed|char|class|closed|constant|continue|def|default|del|double|elif|else|enum|every|extends|false|finally|float|for|from|global|gpudef|gpukernel|if|import|in|init|inject|int|lambda|local|long|loop|match|new|nodefault|null|of|onchange|open|out|override|package|parfor|parforsync|post|pre|private|protected|provide|provider|public|return|shared|short|single|size_t|sizeof|super|sync|this|throw|trait|trans|transient|true|try|typedef|unchecked|using|val|var|void|while|with)\b/,
        boolean: /\b(?:false|true)\b/,
        number: /\b0b[01][01_]*L?\b|\b0x(?:[\da-f_]*\.)?[\da-f_p+-]+\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfls]?/i,
        punctuation: /[{}[\];(),.:]/,
        operator: /<==|>==|=>|->|<-|<>|&==|&<>|\?:?|\.\?|\+\+|--|[-+*/=<>]=?|[!^~]|\b(?:and|as|band|bor|bxor|comp|is|isnot|mod|or)\b=?/,
        annotation: {
            pattern: /@(?:\w+:)?(?:\w+|\[[^\]]+\])?/,
            alias: 'builtin'
        }
    };
    Prism.languages.insertBefore('concurnas', 'langext', {
        'regex-literal': {
            pattern: /\br("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                    lookbehind: true,
                    inside: Prism.languages.concurnas
                },
                regex: /[\s\S]+/
            }
        },
        'string-literal': {
            pattern: /(?:\B|\bs)("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                    lookbehind: true,
                    inside: Prism.languages.concurnas
                },
                string: /[\s\S]+/
            }
        }
    });
    Prism.languages.conc = Prism.languages.concurnas;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $d243e507e31dca19$export$2e2bcd8739ae039.displayName = 'csp';
$d243e507e31dca19$export$2e2bcd8739ae039.aliases = [];
function $d243e507e31dca19$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        /**
     * @param {string} source
     * @returns {RegExp}
     */ function value(source) {
            return RegExp(/([ \t])/.source + '(?:' + source + ')' + /(?=[\s;]|$)/.source, 'i');
        }
        Prism.languages.csp = {
            directive: {
                pattern: /(^|[\s;])(?:base-uri|block-all-mixed-content|(?:child|connect|default|font|frame|img|manifest|media|object|prefetch|script|style|worker)-src|disown-opener|form-action|frame-(?:ancestors|options)|input-protection(?:-(?:clip|selectors))?|navigate-to|plugin-types|policy-uri|referrer|reflected-xss|report-(?:to|uri)|require-sri-for|sandbox|(?:script|style)-src-(?:attr|elem)|upgrade-insecure-requests)(?=[\s;]|$)/i,
                lookbehind: true,
                alias: 'property'
            },
            scheme: {
                pattern: value(/[a-z][a-z0-9.+-]*:/.source),
                lookbehind: true
            },
            none: {
                pattern: value(/'none'/.source),
                lookbehind: true,
                alias: 'keyword'
            },
            nonce: {
                pattern: value(/'nonce-[-+/\w=]+'/.source),
                lookbehind: true,
                alias: 'number'
            },
            hash: {
                pattern: value(/'sha(?:256|384|512)-[-+/\w=]+'/.source),
                lookbehind: true,
                alias: 'number'
            },
            host: {
                pattern: value(/[a-z][a-z0-9.+-]*:\/\/[^\s;,']*/.source + '|' + /\*[^\s;,']*/.source + '|' + /[a-z0-9-]+(?:\.[a-z0-9-]+)+(?::[\d*]+)?(?:\/[^\s;,']*)?/.source),
                lookbehind: true,
                alias: 'url',
                inside: {
                    important: /\*/
                }
            },
            keyword: [
                {
                    pattern: value(/'unsafe-[a-z-]+'/.source),
                    lookbehind: true,
                    alias: 'unsafe'
                },
                {
                    pattern: value(/'[a-z-]+'/.source),
                    lookbehind: true,
                    alias: 'safe'
                }
            ],
            punctuation: /;/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $a1e229080488625c$export$2e2bcd8739ae039.displayName = 'cooklang';
$a1e229080488625c$export$2e2bcd8739ae039.aliases = [];
function $a1e229080488625c$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // see https://github.com/cooklang/spec/blob/main/EBNF.md
        var single_token_suffix = /(?:(?!\s)[\d$+<=a-zA-Z\x80-\uFFFF])+/.source;
        var multi_token_infix = /[^{}@#]+/.source;
        var multi_token_suffix = /\{[^}#@]*\}/.source;
        var multi_token = multi_token_infix + multi_token_suffix;
        var timer_units = /(?:h|hours|hrs|m|min|minutes)/.source;
        var amount_group_impl = {
            pattern: /\{[^{}]*\}/,
            inside: {
                amount: {
                    pattern: /([\{|])[^{}|*%]+/,
                    lookbehind: true,
                    alias: 'number'
                },
                unit: {
                    pattern: /(%)[^}]+/,
                    lookbehind: true,
                    alias: 'symbol'
                },
                'servings-scaler': {
                    pattern: /\*/,
                    alias: 'operator'
                },
                'servings-alternative-separator': {
                    pattern: /\|/,
                    alias: 'operator'
                },
                'unit-separator': {
                    pattern: /(?:%|(\*)%)/,
                    lookbehind: true,
                    alias: 'operator'
                },
                punctuation: /[{}]/
            }
        };
        Prism.languages.cooklang = {
            comment: {
                // [- comment -]
                // -- comment
                pattern: /\[-[\s\S]*?-\]|--.*/,
                greedy: true
            },
            meta: {
                // >> key: value
                pattern: />>.*:.*/,
                inside: {
                    property: {
                        // key:
                        pattern: /(>>\s*)[^\s:](?:[^:]*[^\s:])?/,
                        lookbehind: true
                    }
                }
            },
            'cookware-group': {
                // #...{...}, #...
                pattern: new RegExp('#(?:' + multi_token + '|' + single_token_suffix + ')'),
                inside: {
                    cookware: {
                        pattern: new RegExp('(^#)(?:' + multi_token_infix + ')'),
                        lookbehind: true,
                        alias: 'variable'
                    },
                    'cookware-keyword': {
                        pattern: /^#/,
                        alias: 'keyword'
                    },
                    'quantity-group': {
                        pattern: new RegExp(/\{[^{}@#]*\}/),
                        inside: {
                            quantity: {
                                pattern: new RegExp(/(^\{)/.source + multi_token_infix),
                                lookbehind: true,
                                alias: 'number'
                            },
                            punctuation: /[{}]/
                        }
                    }
                }
            },
            'ingredient-group': {
                // @...{...}, @...
                pattern: new RegExp('@(?:' + multi_token + '|' + single_token_suffix + ')'),
                inside: {
                    ingredient: {
                        pattern: new RegExp('(^@)(?:' + multi_token_infix + ')'),
                        lookbehind: true,
                        alias: 'variable'
                    },
                    'ingredient-keyword': {
                        pattern: /^@/,
                        alias: 'keyword'
                    },
                    'amount-group': amount_group_impl
                }
            },
            'timer-group': {
                // ~timer{...}
                // eslint-disable-next-line regexp/sort-alternatives
                pattern: /~(?!\s)[^@#~{}]*\{[^{}]*\}/,
                inside: {
                    timer: {
                        pattern: /(^~)[^{]+/,
                        lookbehind: true,
                        alias: 'variable'
                    },
                    'duration-group': {
                        // {...}
                        pattern: /\{[^{}]*\}/,
                        inside: {
                            punctuation: /[{}]/,
                            unit: {
                                pattern: new RegExp(/(%\s*)/.source + timer_units + /\b/.source),
                                lookbehind: true,
                                alias: 'symbol'
                            },
                            operator: /%/,
                            duration: {
                                pattern: /\d+/,
                                alias: 'number'
                            }
                        }
                    },
                    'timer-keyword': {
                        pattern: /^~/,
                        alias: 'keyword'
                    }
                }
            }
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $f215d4aafad64c17$export$2e2bcd8739ae039.displayName = 'coq';
$f215d4aafad64c17$export$2e2bcd8739ae039.aliases = [];
function $f215d4aafad64c17$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // https://github.com/coq/coq
        var commentSource = /\(\*(?:[^(*]|\((?!\*)|\*(?!\))|<self>)*\*\)/.source;
        for(var i = 0; i < 2; i++)commentSource = commentSource.replace(/<self>/g, function() {
            return commentSource;
        });
        commentSource = commentSource.replace(/<self>/g, '[]');
        Prism.languages.coq = {
            comment: RegExp(commentSource),
            string: {
                pattern: /"(?:[^"]|"")*"(?!")/,
                greedy: true
            },
            attribute: [
                {
                    pattern: RegExp(/#\[(?:[^\[\]("]|"(?:[^"]|"")*"(?!")|\((?!\*)|<comment>)*\]/.source.replace(/<comment>/g, function() {
                        return commentSource;
                    })),
                    greedy: true,
                    alias: 'attr-name',
                    inside: {
                        comment: RegExp(commentSource),
                        string: {
                            pattern: /"(?:[^"]|"")*"(?!")/,
                            greedy: true
                        },
                        operator: /=/,
                        punctuation: /^#\[|\]$|[,()]/
                    }
                },
                {
                    pattern: /\b(?:Cumulative|Global|Local|Monomorphic|NonCumulative|Polymorphic|Private|Program)\b/,
                    alias: 'attr-name'
                }
            ],
            keyword: /\b(?:Abort|About|Add|Admit|Admitted|All|Arguments|As|Assumptions|Axiom|Axioms|Back|BackTo|Backtrace|BinOp|BinOpSpec|BinRel|Bind|Blacklist|Canonical|Case|Cd|Check|Class|Classes|Close|CoFixpoint|CoInductive|Coercion|Coercions|Collection|Combined|Compute|Conjecture|Conjectures|Constant|Constants|Constraint|Constructors|Context|Corollary|Create|CstOp|Custom|Cut|Debug|Declare|Defined|Definition|Delimit|Dependencies|Dependent|Derive|Diffs|Drop|Elimination|End|Entry|Equality|Eval|Example|Existential|Existentials|Existing|Export|Extern|Extraction|Fact|Fail|Field|File|Firstorder|Fixpoint|Flags|Focus|From|Funclass|Function|Functional|GC|Generalizable|Goal|Grab|Grammar|Graph|Guarded|Haskell|Heap|Hide|Hint|HintDb|Hints|Hypotheses|Hypothesis|IF|Identity|Immediate|Implicit|Implicits|Import|Include|Induction|Inductive|Infix|Info|Initial|InjTyp|Inline|Inspect|Instance|Instances|Intro|Intros|Inversion|Inversion_clear|JSON|Language|Left|Lemma|Let|Lia|Libraries|Library|Load|LoadPath|Locate|Ltac|Ltac2|ML|Match|Method|Minimality|Module|Modules|Morphism|Next|NoInline|Notation|Number|OCaml|Obligation|Obligations|Opaque|Open|Optimize|Parameter|Parameters|Parametric|Path|Paths|Prenex|Preterm|Primitive|Print|Profile|Projections|Proof|Prop|PropBinOp|PropOp|PropUOp|Property|Proposition|Pwd|Qed|Quit|Rec|Record|Recursive|Redirect|Reduction|Register|Relation|Remark|Remove|Require|Reserved|Reset|Resolve|Restart|Rewrite|Right|Ring|Rings|SProp|Saturate|Save|Scheme|Scope|Scopes|Search|SearchHead|SearchPattern|SearchRewrite|Section|Separate|Set|Setoid|Show|Signatures|Solve|Solver|Sort|Sortclass|Sorted|Spec|Step|Strategies|Strategy|String|Structure|SubClass|Subgraph|SuchThat|Tactic|Term|TestCompile|Theorem|Time|Timeout|To|Transparent|Type|Typeclasses|Types|Typing|UnOp|UnOpSpec|Undelimit|Undo|Unfocus|Unfocused|Unfold|Universe|Universes|Unshelve|Variable|Variables|Variant|Verbose|View|Visibility|Zify|_|apply|as|at|by|cofix|else|end|exists|exists2|fix|for|forall|fun|if|in|let|match|measure|move|removed|return|struct|then|using|wf|where|with)\b/,
            number: /\b(?:0x[a-f0-9][a-f0-9_]*(?:\.[a-f0-9_]+)?(?:p[+-]?\d[\d_]*)?|\d[\d_]*(?:\.[\d_]+)?(?:e[+-]?\d[\d_]*)?)\b/i,
            punct: {
                pattern: /@\{|\{\||\[=|:>/,
                alias: 'punctuation'
            },
            operator: /\/\\|\\\/|\.{2,3}|:{1,2}=|\*\*|[-=]>|<(?:->?|[+:=>]|<:)|>(?:=|->)|\|[-|]?|[-!%&*+/<=>?@^~']/,
            punctuation: /\.\(|`\(|@\{|`\{|\{\||\[=|:>|[:.,;(){}\[\]]/
        };
    })(Prism);
}



// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$81ed84b8749657d1$export$2e2bcd8739ae039.displayName = 'crystal';
$81ed84b8749657d1$export$2e2bcd8739ae039.aliases = [];
function $81ed84b8749657d1$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $1024f633e11e96f5$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.crystal = Prism.languages.extend('ruby', {
            keyword: [
                /\b(?:__DIR__|__END_LINE__|__FILE__|__LINE__|abstract|alias|annotation|as|asm|begin|break|case|class|def|do|else|elsif|end|ensure|enum|extend|for|fun|if|ifdef|include|instance_sizeof|lib|macro|module|next|of|out|pointerof|private|protected|ptr|require|rescue|return|select|self|sizeof|struct|super|then|type|typeof|undef|uninitialized|union|unless|until|when|while|with|yield)\b/,
                {
                    pattern: /(\.\s*)(?:is_a|responds_to)\?/,
                    lookbehind: true
                }
            ],
            number: /\b(?:0b[01_]*[01]|0o[0-7_]*[0-7]|0x[\da-fA-F_]*[\da-fA-F]|(?:\d(?:[\d_]*\d)?)(?:\.[\d_]*\d)?(?:[eE][+-]?[\d_]*\d)?)(?:_(?:[uif](?:8|16|32|64))?)?\b/,
            operator: [
                /->/,
                Prism.languages.ruby.operator
            ],
            punctuation: /[(){}[\].,;\\]/
        });
        Prism.languages.insertBefore('crystal', 'string-literal', {
            attribute: {
                pattern: /@\[.*?\]/,
                inside: {
                    delimiter: {
                        pattern: /^@\[|\]$/,
                        alias: 'punctuation'
                    },
                    attribute: {
                        pattern: /^(\s*)\w+/,
                        lookbehind: true,
                        alias: 'class-name'
                    },
                    args: {
                        pattern: /\S(?:[\s\S]*\S)?/,
                        inside: Prism.languages.crystal
                    }
                }
            },
            expansion: {
                pattern: /\{(?:\{.*?\}|%.*?%)\}/,
                inside: {
                    content: {
                        pattern: /^(\{.)[\s\S]+(?=.\}$)/,
                        lookbehind: true,
                        inside: Prism.languages.crystal
                    },
                    delimiter: {
                        pattern: /^\{[\{%]|[\}%]\}$/,
                        alias: 'operator'
                    }
                }
            },
            char: {
                pattern: /'(?:[^\\\r\n]{1,2}|\\(?:.|u(?:[A-Fa-f0-9]{1,4}|\{[A-Fa-f0-9]{1,6}\})))'/,
                greedy: true
            }
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$6a669cbb1cd34ac4$export$2e2bcd8739ae039.displayName = 'css-extras';
$6a669cbb1cd34ac4$export$2e2bcd8739ae039.aliases = [];
function $6a669cbb1cd34ac4$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $c8ae87468323f6e6$export$2e2bcd8739ae039));
    (function(Prism) {
        var string = /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/;
        var selectorInside;
        Prism.languages.css.selector = {
            pattern: Prism.languages.css.selector.pattern,
            lookbehind: true,
            inside: selectorInside = {
                'pseudo-element': /:(?:after|before|first-letter|first-line|selection)|::[-\w]+/,
                'pseudo-class': /:[-\w]+/,
                class: /\.[-\w]+/,
                id: /#[-\w]+/,
                attribute: {
                    pattern: RegExp('\\[(?:[^[\\]"\']|' + string.source + ')*\\]'),
                    greedy: true,
                    inside: {
                        punctuation: /^\[|\]$/,
                        'case-sensitivity': {
                            pattern: /(\s)[si]$/i,
                            lookbehind: true,
                            alias: 'keyword'
                        },
                        namespace: {
                            pattern: /^(\s*)(?:(?!\s)[-*\w\xA0-\uFFFF])*\|(?!=)/,
                            lookbehind: true,
                            inside: {
                                punctuation: /\|$/
                            }
                        },
                        'attr-name': {
                            pattern: /^(\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+/,
                            lookbehind: true
                        },
                        'attr-value': [
                            string,
                            {
                                pattern: /(=\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+(?=\s*$)/,
                                lookbehind: true
                            }
                        ],
                        operator: /[|~*^$]?=/
                    }
                },
                'n-th': [
                    {
                        pattern: /(\(\s*)[+-]?\d*[\dn](?:\s*[+-]\s*\d+)?(?=\s*\))/,
                        lookbehind: true,
                        inside: {
                            number: /[\dn]+/,
                            operator: /[+-]/
                        }
                    },
                    {
                        pattern: /(\(\s*)(?:even|odd)(?=\s*\))/i,
                        lookbehind: true
                    }
                ],
                combinator: />|\+|~|\|\|/,
                // the `tag` token has been existed and removed.
                // because we can't find a perfect tokenize to match it.
                // if you want to add it, please read https://github.com/PrismJS/prism/pull/2373 first.
                punctuation: /[(),]/
            }
        };
        Prism.languages.css['atrule'].inside['selector-function-argument'].inside = selectorInside;
        Prism.languages.insertBefore('css', 'property', {
            variable: {
                pattern: /(^|[^-\w\xA0-\uFFFF])--(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*/i,
                lookbehind: true
            }
        });
        var unit = {
            pattern: /(\b\d+)(?:%|[a-z]+(?![\w-]))/,
            lookbehind: true
        };
        // 123 -123 .123 -.123 12.3 -12.3
        var number = {
            pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
            lookbehind: true
        };
        Prism.languages.insertBefore('css', 'function', {
            operator: {
                pattern: /(\s)[+\-*\/](?=\s)/,
                lookbehind: true
            },
            // CAREFUL!
            // Previewers and Inline color use hexcode and color.
            hexcode: {
                pattern: /\B#[\da-f]{3,8}\b/i,
                alias: 'color'
            },
            color: [
                {
                    pattern: /(^|[^\w-])(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|RebeccaPurple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)(?![\w-])/i,
                    lookbehind: true
                },
                {
                    pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
                    inside: {
                        unit: unit,
                        number: number,
                        function: /[\w-]+(?=\()/,
                        punctuation: /[(),]/
                    }
                }
            ],
            // it's important that there is no boundary assertion after the hex digits
            entity: /\\[\da-f]{1,8}/i,
            unit: unit,
            number: number
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $e44e89ab2dc97a78$export$2e2bcd8739ae039.displayName = 'csv';
$e44e89ab2dc97a78$export$2e2bcd8739ae039.aliases = [];
function $e44e89ab2dc97a78$export$2e2bcd8739ae039(Prism) {
    // https://tools.ietf.org/html/rfc4180
    Prism.languages.csv = {
        value: /[^\r\n,"]+|"(?:[^"]|"")*"(?!")/,
        punctuation: /,/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $03bb8bfbcc096edb$export$2e2bcd8739ae039.displayName = 'cue';
$03bb8bfbcc096edb$export$2e2bcd8739ae039.aliases = [];
function $03bb8bfbcc096edb$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // https://cuelang.org/docs/references/spec/
        // eslint-disable-next-line regexp/strict
        var stringEscape = /\\(?:(?!\2)|\2(?:[^()\r\n]|\([^()]*\)))/.source;
        // eslint-disable-next-line regexp/strict
        var stringTypes = /"""(?:[^\\"]|"(?!""\2)|<esc>)*"""/.source + // eslint-disable-next-line regexp/strict
        '|' + /'''(?:[^\\']|'(?!''\2)|<esc>)*'''/.source + // eslint-disable-next-line regexp/strict
        '|' + /"(?:[^\\\r\n"]|"(?!\2)|<esc>)*"/.source + // eslint-disable-next-line regexp/strict
        '|' + /'(?:[^\\\r\n']|'(?!\2)|<esc>)*'/.source;
        var stringLiteral = '(?:' + stringTypes.replace(/<esc>/g, stringEscape) + ')';
        Prism.languages.cue = {
            comment: {
                pattern: /\/\/.*/,
                greedy: true
            },
            'string-literal': {
                // eslint-disable-next-line regexp/strict
                pattern: RegExp(/(^|[^#"'\\])(#*)/.source + stringLiteral + /(?!["'])\2/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    // I'm using dirty hack here. We have to know the number hashes at the start of the string somehow,
                    // but we can't look back. So instead, we will use a lookahead, go to the end of the string, and
                    // capture the hashes at the end of the string.
                    escape: {
                        pattern: /(?=[\s\S]*["'](#*)$)\\\1(?:U[a-fA-F0-9]{1,8}|u[a-fA-F0-9]{1,4}|x[a-fA-F0-9]{1,2}|\d{2,3}|[^(])/,
                        greedy: true,
                        alias: 'string'
                    },
                    interpolation: {
                        pattern: /(?=[\s\S]*["'](#*)$)\\\1\([^()]*\)/,
                        greedy: true,
                        inside: {
                            punctuation: /^\\#*\(|\)$/,
                            expression: {
                                pattern: /[\s\S]+/,
                                inside: null
                            }
                        }
                    },
                    string: /[\s\S]+/
                }
            },
            keyword: {
                pattern: /(^|[^\w$])(?:for|if|import|in|let|null|package)(?![\w$])/,
                lookbehind: true
            },
            boolean: {
                pattern: /(^|[^\w$])(?:false|true)(?![\w$])/,
                lookbehind: true
            },
            builtin: {
                pattern: /(^|[^\w$])(?:bool|bytes|float|float(?:32|64)|u?int(?:8|16|32|64|128)?|number|rune|string)(?![\w$])/,
                lookbehind: true
            },
            attribute: {
                pattern: /@[\w$]+(?=\s*\()/,
                alias: 'function'
            },
            function: {
                pattern: /(^|[^\w$])[a-z_$][\w$]*(?=\s*\()/i,
                lookbehind: true
            },
            number: {
                pattern: /(^|[^\w$.])(?:0b[01]+(?:_[01]+)*|0o[0-7]+(?:_[0-7]+)*|0[xX][0-9A-Fa-f]+(?:_[0-9A-Fa-f]+)*|(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[eE][+-]?\d+(?:_\d+)*)?(?:[KMGTP]i?)?)(?![\w$])/,
                lookbehind: true
            },
            operator: /\.{3}|_\|_|&&?|\|\|?|[=!]~|[<>=!]=?|[+\-*/?]/,
            punctuation: /[()[\]{},.:]/
        };
        Prism.languages.cue['string-literal'].inside.interpolation.inside.expression.inside = Prism.languages.cue;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $538c836732b1c8a0$export$2e2bcd8739ae039.displayName = 'cypher';
$538c836732b1c8a0$export$2e2bcd8739ae039.aliases = [];
function $538c836732b1c8a0$export$2e2bcd8739ae039(Prism) {
    Prism.languages.cypher = {
        // https://neo4j.com/docs/cypher-manual/current/syntax/comments/
        comment: /\/\/.*/,
        string: {
            pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/,
            greedy: true
        },
        'class-name': {
            pattern: /(:\s*)(?:\w+|`(?:[^`\\\r\n])*`)(?=\s*[{):])/,
            lookbehind: true,
            greedy: true
        },
        relationship: {
            pattern: /(-\[\s*(?:\w+\s*|`(?:[^`\\\r\n])*`\s*)?:\s*|\|\s*:\s*)(?:\w+|`(?:[^`\\\r\n])*`)/,
            lookbehind: true,
            greedy: true,
            alias: 'property'
        },
        identifier: {
            pattern: /`(?:[^`\\\r\n])*`/,
            greedy: true
        },
        variable: /\$\w+/,
        // https://neo4j.com/docs/cypher-manual/current/syntax/reserved/
        keyword: /\b(?:ADD|ALL|AND|AS|ASC|ASCENDING|ASSERT|BY|CALL|CASE|COMMIT|CONSTRAINT|CONTAINS|CREATE|CSV|DELETE|DESC|DESCENDING|DETACH|DISTINCT|DO|DROP|ELSE|END|ENDS|EXISTS|FOR|FOREACH|IN|INDEX|IS|JOIN|KEY|LIMIT|LOAD|MANDATORY|MATCH|MERGE|NODE|NOT|OF|ON|OPTIONAL|OR|ORDER(?=\s+BY)|PERIODIC|REMOVE|REQUIRE|RETURN|SCALAR|SCAN|SET|SKIP|START|STARTS|THEN|UNION|UNIQUE|UNWIND|USING|WHEN|WHERE|WITH|XOR|YIELD)\b/i,
        function: /\b\w+\b(?=\s*\()/,
        boolean: /\b(?:false|null|true)\b/i,
        number: /\b(?:0x[\da-fA-F]+|\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)\b/,
        // https://neo4j.com/docs/cypher-manual/current/syntax/operators/
        operator: /:|<--?|--?>?|<>|=~?|[<>]=?|[+*/%^|]|\.\.\.?/,
        punctuation: /[()[\]{},;.]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$313c3e47a28a32fd$export$2e2bcd8739ae039.displayName = 'd';
$313c3e47a28a32fd$export$2e2bcd8739ae039.aliases = [];
function $313c3e47a28a32fd$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    Prism.languages.d = Prism.languages.extend('clike', {
        comment: [
            {
                // Shebang
                pattern: /^\s*#!.+/,
                greedy: true
            },
            {
                pattern: RegExp(/(^|[^\\])/.source + '(?:' + [
                    // /+ comment +/
                    // Allow one level of nesting
                    /\/\+(?:\/\+(?:[^+]|\+(?!\/))*\+\/|(?!\/\+)[\s\S])*?\+\//.source,
                    // // comment
                    /\/\/.*/.source,
                    // /* comment */
                    /\/\*[\s\S]*?\*\//.source
                ].join('|') + ')'),
                lookbehind: true,
                greedy: true
            }
        ],
        string: [
            {
                pattern: RegExp([
                    // r"", x""
                    /\b[rx]"(?:\\[\s\S]|[^\\"])*"[cwd]?/.source,
                    // q"[]", q"()", q"<>", q"{}"
                    /\bq"(?:\[[\s\S]*?\]|\([\s\S]*?\)|<[\s\S]*?>|\{[\s\S]*?\})"/.source,
                    // q"IDENT
                    // ...
                    // IDENT"
                    /\bq"((?!\d)\w+)$[\s\S]*?^\1"/.source,
                    // q"//", q"||", etc.
                    // eslint-disable-next-line regexp/strict
                    /\bq"(.)[\s\S]*?\2"/.source,
                    // eslint-disable-next-line regexp/strict
                    /(["`])(?:\\[\s\S]|(?!\3)[^\\])*\3[cwd]?/.source
                ].join('|'), 'm'),
                greedy: true
            },
            {
                pattern: /\bq\{(?:\{[^{}]*\}|[^{}])*\}/,
                greedy: true,
                alias: 'token-string'
            }
        ],
        // In order: $, keywords and special tokens, globally defined symbols
        keyword: /\$|\b(?:__(?:(?:DATE|EOF|FILE|FUNCTION|LINE|MODULE|PRETTY_FUNCTION|TIMESTAMP|TIME|VENDOR|VERSION)__|gshared|parameters|traits|vector)|abstract|alias|align|asm|assert|auto|body|bool|break|byte|case|cast|catch|cdouble|cent|cfloat|char|class|const|continue|creal|dchar|debug|default|delegate|delete|deprecated|do|double|dstring|else|enum|export|extern|false|final|finally|float|for|foreach|foreach_reverse|function|goto|idouble|if|ifloat|immutable|import|inout|int|interface|invariant|ireal|lazy|long|macro|mixin|module|new|nothrow|null|out|override|package|pragma|private|protected|ptrdiff_t|public|pure|real|ref|return|scope|shared|short|size_t|static|string|struct|super|switch|synchronized|template|this|throw|true|try|typedef|typeid|typeof|ubyte|ucent|uint|ulong|union|unittest|ushort|version|void|volatile|wchar|while|with|wstring)\b/,
        number: [
            // The lookbehind and the negative look-ahead try to prevent bad highlighting of the .. operator
            // Hexadecimal numbers must be handled separately to avoid problems with exponent "e"
            /\b0x\.?[a-f\d_]+(?:(?!\.\.)\.[a-f\d_]*)?(?:p[+-]?[a-f\d_]+)?[ulfi]{0,4}/i,
            {
                pattern: /((?:\.\.)?)(?:\b0b\.?|\b|\.)\d[\d_]*(?:(?!\.\.)\.[\d_]*)?(?:e[+-]?\d[\d_]*)?[ulfi]{0,4}/i,
                lookbehind: true
            }
        ],
        operator: /\|[|=]?|&[&=]?|\+[+=]?|-[-=]?|\.?\.\.|=[>=]?|!(?:i[ns]\b|<>?=?|>=?|=)?|\bi[ns]\b|(?:<[<>]?|>>?>?|\^\^|[*\/%^~])=?/
    });
    Prism.languages.insertBefore('d', 'string', {
        // Characters
        // 'a', '\\', '\n', '\xFF', '\377', '\uFFFF', '\U0010FFFF', '\quot'
        char: /'(?:\\(?:\W|\w+)|[^\\])'/
    });
    Prism.languages.insertBefore('d', 'keyword', {
        property: /\B@\w*/
    });
    Prism.languages.insertBefore('d', 'function', {
        register: {
            // Iasm registers
            pattern: /\b(?:[ABCD][LHX]|E?(?:BP|DI|SI|SP)|[BS]PL|[ECSDGF]S|CR[0234]|[DS]IL|DR[012367]|E[ABCD]X|X?MM[0-7]|R(?:1[0-5]|[89])[BWD]?|R[ABCD]X|R[BS]P|R[DS]I|TR[3-7]|XMM(?:1[0-5]|[89])|YMM(?:1[0-5]|\d))\b|\bST(?:\([0-7]\)|\b)/,
            alias: 'variable'
        }
    });
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$6a0fa37bec677708$export$2e2bcd8739ae039.displayName = 'dart';
$6a0fa37bec677708$export$2e2bcd8739ae039.aliases = [];
function $6a0fa37bec677708$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    (function(Prism) {
        var keywords = [
            /\b(?:async|sync|yield)\*/,
            /\b(?:abstract|assert|async|await|break|case|catch|class|const|continue|covariant|default|deferred|do|dynamic|else|enum|export|extends|extension|external|factory|final|finally|for|get|hide|if|implements|import|in|interface|library|mixin|new|null|on|operator|part|rethrow|return|set|show|static|super|switch|sync|this|throw|try|typedef|var|void|while|with|yield)\b/
        ];
        // Handles named imports, such as http.Client
        var packagePrefix = /(^|[^\w.])(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source;
        // based on the dart naming conventions
        var className = {
            pattern: RegExp(packagePrefix + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
            lookbehind: true,
            inside: {
                namespace: {
                    pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
                    inside: {
                        punctuation: /\./
                    }
                }
            }
        };
        Prism.languages.dart = Prism.languages.extend('clike', {
            'class-name': [
                className,
                {
                    // variables and parameters
                    // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
                    pattern: RegExp(packagePrefix + /[A-Z]\w*(?=\s+\w+\s*[;,=()])/.source),
                    lookbehind: true,
                    inside: className.inside
                }
            ],
            keyword: keywords,
            operator: /\bis!|\b(?:as|is)\b|\+\+|--|&&|\|\||<<=?|>>=?|~(?:\/=?)?|[+\-*\/%&^|=!<>]=?|\?/
        });
        Prism.languages.insertBefore('dart', 'string', {
            'string-literal': {
                pattern: /r?(?:("""|''')[\s\S]*?\1|(["'])(?:\\.|(?!\2)[^\\\r\n])*\2(?!\2))/,
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\w+|\{(?:[^{}]|\{[^{}]*\})*\})/,
                        lookbehind: true,
                        inside: {
                            punctuation: /^\$\{?|\}$/,
                            expression: {
                                pattern: /[\s\S]+/,
                                inside: Prism.languages.dart
                            }
                        }
                    },
                    string: /[\s\S]+/
                }
            },
            string: undefined
        });
        Prism.languages.insertBefore('dart', 'class-name', {
            metadata: {
                pattern: /@\w+/,
                alias: 'function'
            }
        });
        Prism.languages.insertBefore('dart', 'class-name', {
            generics: {
                pattern: /<(?:[\w\s,.&?]|<(?:[\w\s,.&?]|<(?:[\w\s,.&?]|<[\w\s,.&?]*>)*>)*>)*>/,
                inside: {
                    'class-name': className,
                    keyword: keywords,
                    punctuation: /[<>(),.:]/,
                    operator: /[?&|]/
                }
            }
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $ec2377a3ba62255c$export$2e2bcd8739ae039.displayName = 'dataweave';
$ec2377a3ba62255c$export$2e2bcd8739ae039.aliases = [];
function $ec2377a3ba62255c$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.dataweave = {
            url: /\b[A-Za-z]+:\/\/[\w/:.?=&-]+|\burn:[\w:.?=&-]+/,
            property: {
                pattern: /(?:\b\w+#)?(?:"(?:\\.|[^\\"\r\n])*"|\b\w+)(?=\s*[:@])/,
                greedy: true
            },
            string: {
                pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
                greedy: true
            },
            'mime-type': /\b(?:application|audio|image|multipart|text|video)\/[\w+-]+/,
            date: {
                pattern: /\|[\w:+-]+\|/,
                greedy: true
            },
            comment: [
                {
                    pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    pattern: /(^|[^\\:])\/\/.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            regex: {
                pattern: /\/(?:[^\\\/\r\n]|\\[^\r\n])+\//,
                greedy: true
            },
            keyword: /\b(?:and|as|at|case|do|else|fun|if|input|is|match|not|ns|null|or|output|type|unless|update|using|var)\b/,
            function: /\b[A-Z_]\w*(?=\s*\()/i,
            number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
            punctuation: /[{}[\];(),.:@]/,
            operator: /<<|>>|->|[<>~=]=?|!=|--?-?|\+\+?|!|\?/,
            boolean: /\b(?:false|true)\b/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $4e5f3564e17eab03$export$2e2bcd8739ae039.displayName = 'dax';
$4e5f3564e17eab03$export$2e2bcd8739ae039.aliases = [];
function $4e5f3564e17eab03$export$2e2bcd8739ae039(Prism) {
    Prism.languages.dax = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/).*)/,
            lookbehind: true
        },
        'data-field': {
            pattern: /'(?:[^']|'')*'(?!')(?:\[[ \w\xA0-\uFFFF]+\])?|\w+\[[ \w\xA0-\uFFFF]+\]/,
            alias: 'symbol'
        },
        measure: {
            pattern: /\[[ \w\xA0-\uFFFF]+\]/,
            alias: 'constant'
        },
        string: {
            pattern: /"(?:[^"]|"")*"(?!")/,
            greedy: true
        },
        function: /\b(?:ABS|ACOS|ACOSH|ACOT|ACOTH|ADDCOLUMNS|ADDMISSINGITEMS|ALL|ALLCROSSFILTERED|ALLEXCEPT|ALLNOBLANKROW|ALLSELECTED|AND|APPROXIMATEDISTINCTCOUNT|ASIN|ASINH|ATAN|ATANH|AVERAGE|AVERAGEA|AVERAGEX|BETA\.DIST|BETA\.INV|BLANK|CALCULATE|CALCULATETABLE|CALENDAR|CALENDARAUTO|CEILING|CHISQ\.DIST|CHISQ\.DIST\.RT|CHISQ\.INV|CHISQ\.INV\.RT|CLOSINGBALANCEMONTH|CLOSINGBALANCEQUARTER|CLOSINGBALANCEYEAR|COALESCE|COMBIN|COMBINA|COMBINEVALUES|CONCATENATE|CONCATENATEX|CONFIDENCE\.NORM|CONFIDENCE\.T|CONTAINS|CONTAINSROW|CONTAINSSTRING|CONTAINSSTRINGEXACT|CONVERT|COS|COSH|COT|COTH|COUNT|COUNTA|COUNTAX|COUNTBLANK|COUNTROWS|COUNTX|CROSSFILTER|CROSSJOIN|CURRENCY|CURRENTGROUP|CUSTOMDATA|DATATABLE|DATE|DATEADD|DATEDIFF|DATESBETWEEN|DATESINPERIOD|DATESMTD|DATESQTD|DATESYTD|DATEVALUE|DAY|DEGREES|DETAILROWS|DISTINCT|DISTINCTCOUNT|DISTINCTCOUNTNOBLANK|DIVIDE|EARLIER|EARLIEST|EDATE|ENDOFMONTH|ENDOFQUARTER|ENDOFYEAR|EOMONTH|ERROR|EVEN|EXACT|EXCEPT|EXP|EXPON\.DIST|FACT|FALSE|FILTER|FILTERS|FIND|FIRSTDATE|FIRSTNONBLANK|FIRSTNONBLANKVALUE|FIXED|FLOOR|FORMAT|GCD|GENERATE|GENERATEALL|GENERATESERIES|GEOMEAN|GEOMEANX|GROUPBY|HASONEFILTER|HASONEVALUE|HOUR|IF|IF\.EAGER|IFERROR|IGNORE|INT|INTERSECT|ISBLANK|ISCROSSFILTERED|ISEMPTY|ISERROR|ISEVEN|ISFILTERED|ISINSCOPE|ISLOGICAL|ISNONTEXT|ISNUMBER|ISO\.CEILING|ISODD|ISONORAFTER|ISSELECTEDMEASURE|ISSUBTOTAL|ISTEXT|KEEPFILTERS|KEYWORDMATCH|LASTDATE|LASTNONBLANK|LASTNONBLANKVALUE|LCM|LEFT|LEN|LN|LOG|LOG10|LOOKUPVALUE|LOWER|MAX|MAXA|MAXX|MEDIAN|MEDIANX|MID|MIN|MINA|MINUTE|MINX|MOD|MONTH|MROUND|NATURALINNERJOIN|NATURALLEFTOUTERJOIN|NEXTDAY|NEXTMONTH|NEXTQUARTER|NEXTYEAR|NONVISUAL|NORM\.DIST|NORM\.INV|NORM\.S\.DIST|NORM\.S\.INV|NOT|NOW|ODD|OPENINGBALANCEMONTH|OPENINGBALANCEQUARTER|OPENINGBALANCEYEAR|OR|PARALLELPERIOD|PATH|PATHCONTAINS|PATHITEM|PATHITEMREVERSE|PATHLENGTH|PERCENTILE\.EXC|PERCENTILE\.INC|PERCENTILEX\.EXC|PERCENTILEX\.INC|PERMUT|PI|POISSON\.DIST|POWER|PREVIOUSDAY|PREVIOUSMONTH|PREVIOUSQUARTER|PREVIOUSYEAR|PRODUCT|PRODUCTX|QUARTER|QUOTIENT|RADIANS|RAND|RANDBETWEEN|RANK\.EQ|RANKX|RELATED|RELATEDTABLE|REMOVEFILTERS|REPLACE|REPT|RIGHT|ROLLUP|ROLLUPADDISSUBTOTAL|ROLLUPGROUP|ROLLUPISSUBTOTAL|ROUND|ROUNDDOWN|ROUNDUP|ROW|SAMEPERIODLASTYEAR|SAMPLE|SEARCH|SECOND|SELECTCOLUMNS|SELECTEDMEASURE|SELECTEDMEASUREFORMATSTRING|SELECTEDMEASURENAME|SELECTEDVALUE|SIGN|SIN|SINH|SQRT|SQRTPI|STARTOFMONTH|STARTOFQUARTER|STARTOFYEAR|STDEV\.P|STDEV\.S|STDEVX\.P|STDEVX\.S|SUBSTITUTE|SUBSTITUTEWITHINDEX|SUM|SUMMARIZE|SUMMARIZECOLUMNS|SUMX|SWITCH|T\.DIST|T\.DIST\.2T|T\.DIST\.RT|T\.INV|T\.INV\.2T|TAN|TANH|TIME|TIMEVALUE|TODAY|TOPN|TOPNPERLEVEL|TOPNSKIP|TOTALMTD|TOTALQTD|TOTALYTD|TREATAS|TRIM|TRUE|TRUNC|UNICHAR|UNICODE|UNION|UPPER|USERELATIONSHIP|USERNAME|USEROBJECTID|USERPRINCIPALNAME|UTCNOW|UTCTODAY|VALUE|VALUES|VAR\.P|VAR\.S|VARX\.P|VARX\.S|WEEKDAY|WEEKNUM|XIRR|XNPV|YEAR|YEARFRAC)(?=\s*\()/i,
        keyword: /\b(?:DEFINE|EVALUATE|MEASURE|ORDER\s+BY|RETURN|VAR|START\s+AT|ASC|DESC)\b/i,
        boolean: {
            pattern: /\b(?:FALSE|NULL|TRUE)\b/i,
            alias: 'constant'
        },
        number: /\b\d+(?:\.\d*)?|\B\.\d+\b/,
        operator: /:=|[-+*\/=^]|&&?|\|\||<(?:=>?|<|>)?|>[>=]?|\b(?:IN|NOT)\b/i,
        punctuation: /[;\[\](){}`,.]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $c79f4752b8ecb9f9$export$2e2bcd8739ae039.displayName = 'dhall';
$c79f4752b8ecb9f9$export$2e2bcd8739ae039.aliases = [];
function $c79f4752b8ecb9f9$export$2e2bcd8739ae039(Prism) {
    // ABNF grammar:
    // https://github.com/dhall-lang/dhall-lang/blob/master/standard/dhall.abnf
    Prism.languages.dhall = {
        // Multi-line comments can be nested. E.g. {- foo {- bar -} -}
        // The multi-line pattern is essentially this:
        //   \{-(?:[^-{]|-(?!\})|\{(?!-)|<SELF>)*-\}
        comment: /--.*|\{-(?:[^-{]|-(?!\})|\{(?!-)|\{-(?:[^-{]|-(?!\})|\{(?!-))*-\})*-\}/,
        string: {
            pattern: /"(?:[^"\\]|\\.)*"|''(?:[^']|'(?!')|'''|''\$\{)*''(?!'|\$)/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /\$\{[^{}]*\}/,
                    inside: {
                        expression: {
                            pattern: /(^\$\{)[\s\S]+(?=\}$)/,
                            lookbehind: true,
                            alias: 'language-dhall',
                            inside: null // see blow
                        },
                        punctuation: /\$\{|\}/
                    }
                }
            }
        },
        label: {
            pattern: /`[^`]*`/,
            greedy: true
        },
        url: {
            // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L596
            pattern: /\bhttps?:\/\/[\w.:%!$&'*+;=@~-]+(?:\/[\w.:%!$&'*+;=@~-]*)*(?:\?[/?\w.:%!$&'*+;=@~-]*)?/,
            greedy: true
        },
        env: {
            // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L661
            pattern: /\benv:(?:(?!\d)\w+|"(?:[^"\\=]|\\.)*")/,
            greedy: true,
            inside: {
                function: /^env/,
                operator: /^:/,
                variable: /[\s\S]+/
            }
        },
        hash: {
            // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L725
            pattern: /\bsha256:[\da-fA-F]{64}\b/,
            inside: {
                function: /sha256/,
                operator: /:/,
                number: /[\da-fA-F]{64}/
            }
        },
        // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L359
        keyword: /\b(?:as|assert|else|forall|if|in|let|merge|missing|then|toMap|using|with)\b|\u2200/,
        builtin: /\b(?:None|Some)\b/,
        boolean: /\b(?:False|True)\b/,
        number: /\bNaN\b|-?\bInfinity\b|[+-]?\b(?:0x[\da-fA-F]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/,
        operator: /\/\\|\/\/\\\\|&&|\|\||===|[!=]=|\/\/|->|\+\+|::|[+*#@=:?<>|\\\u2227\u2a53\u2261\u2afd\u03bb\u2192]/,
        punctuation: /\.\.|[{}\[\](),./]/,
        // we'll just assume that every capital word left is a type name
        'class-name': /\b[A-Z]\w*\b/
    };
    Prism.languages.dhall.string.inside.interpolation.inside.expression.inside = Prism.languages.dhall;
}




// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$e041944f5d00c63c$export$2e2bcd8739ae039.displayName = 'django';
$e041944f5d00c63c$export$2e2bcd8739ae039.aliases = [
    'jinja2'
];
function $e041944f5d00c63c$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $a400735491c1aa4e$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.django = {
            comment: /^\{#[\s\S]*?#\}$/,
            tag: {
                pattern: /(^\{%[+-]?\s*)\w+/,
                lookbehind: true,
                alias: 'keyword'
            },
            delimiter: {
                pattern: /^\{[{%][+-]?|[+-]?[}%]\}$/,
                alias: 'punctuation'
            },
            string: {
                pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
                greedy: true
            },
            filter: {
                pattern: /(\|)\w+/,
                lookbehind: true,
                alias: 'function'
            },
            test: {
                pattern: /(\bis\s+(?:not\s+)?)(?!not\b)\w+/,
                lookbehind: true,
                alias: 'function'
            },
            function: /\b[a-z_]\w+(?=\s*\()/i,
            keyword: /\b(?:and|as|by|else|for|if|import|in|is|loop|not|or|recursive|with|without)\b/,
            operator: /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
            number: /\b\d+(?:\.\d+)?\b/,
            boolean: /[Ff]alse|[Nn]one|[Tt]rue/,
            variable: /\b\w+\b/,
            punctuation: /[{}[\](),.:;]/
        };
        var pattern = /\{\{[\s\S]*?\}\}|\{%[\s\S]*?%\}|\{#[\s\S]*?#\}/g;
        var markupTemplating = Prism.languages['markup-templating'];
        Prism.hooks.add('before-tokenize', function(env) {
            markupTemplating.buildPlaceholders(env, 'django', pattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            markupTemplating.tokenizePlaceholders(env, 'django');
        });
        // Add an Jinja2 alias
        Prism.languages.jinja2 = Prism.languages.django;
        Prism.hooks.add('before-tokenize', function(env) {
            markupTemplating.buildPlaceholders(env, 'jinja2', pattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            markupTemplating.tokenizePlaceholders(env, 'jinja2');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $73ad660dd1c97629$export$2e2bcd8739ae039.displayName = 'dns-zone-file';
$73ad660dd1c97629$export$2e2bcd8739ae039.aliases = [
    'dns-zone'
];
function $73ad660dd1c97629$export$2e2bcd8739ae039(Prism) {
    Prism.languages['dns-zone-file'] = {
        comment: /;.*/,
        string: {
            pattern: /"(?:\\.|[^"\\\r\n])*"/,
            greedy: true
        },
        variable: [
            {
                pattern: /(^\$ORIGIN[ \t]+)\S+/m,
                lookbehind: true
            },
            {
                pattern: /(^|\s)@(?=\s|$)/,
                lookbehind: true
            }
        ],
        keyword: /^\$(?:INCLUDE|ORIGIN|TTL)(?=\s|$)/m,
        class: {
            // https://tools.ietf.org/html/rfc1035#page-13
            pattern: /(^|\s)(?:CH|CS|HS|IN)(?=\s|$)/,
            lookbehind: true,
            alias: 'keyword'
        },
        type: {
            // https://en.wikipedia.org/wiki/List_of_DNS_record_types
            pattern: /(^|\s)(?:A|A6|AAAA|AFSDB|APL|ATMA|CAA|CDNSKEY|CDS|CERT|CNAME|DHCID|DLV|DNAME|DNSKEY|DS|EID|GID|GPOS|HINFO|HIP|IPSECKEY|ISDN|KEY|KX|LOC|MAILA|MAILB|MB|MD|MF|MG|MINFO|MR|MX|NAPTR|NB|NBSTAT|NIMLOC|NINFO|NS|NSAP|NSAP-PTR|NSEC|NSEC3|NSEC3PARAM|NULL|NXT|OPENPGPKEY|PTR|PX|RKEY|RP|RRSIG|RT|SIG|SINK|SMIMEA|SOA|SPF|SRV|SSHFP|TA|TKEY|TLSA|TSIG|TXT|UID|UINFO|UNSPEC|URI|WKS|X25)(?=\s|$)/,
            lookbehind: true,
            alias: 'keyword'
        },
        punctuation: /[()]/
    };
    Prism.languages['dns-zone'] = Prism.languages['dns-zone-file'];
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $9f0d5922b028f25a$export$2e2bcd8739ae039.displayName = 'docker';
$9f0d5922b028f25a$export$2e2bcd8739ae039.aliases = [
    'dockerfile'
];
function $9f0d5922b028f25a$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // Many of the following regexes will contain negated lookaheads like `[ \t]+(?![ \t])`. This is a trick to ensure
        // that quantifiers behave *atomically*. Atomic quantifiers are necessary to prevent exponential backtracking.
        var spaceAfterBackSlash = /\\[\r\n](?:\s|\\[\r\n]|#.*(?!.))*(?![\s#]|\\[\r\n])/.source;
        // At least one space, comment, or line break
        var space = /(?:[ \t]+(?![ \t])(?:<SP_BS>)?|<SP_BS>)/.source.replace(/<SP_BS>/g, function() {
            return spaceAfterBackSlash;
        });
        var string = /"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*"|'(?:[^'\\\r\n]|\\(?:\r\n|[\s\S]))*'/.source;
        var option = /--[\w-]+=(?:<STR>|(?!["'])(?:[^\s\\]|\\.)+)/.source.replace(/<STR>/g, function() {
            return string;
        });
        var stringRule = {
            pattern: RegExp(string),
            greedy: true
        };
        var commentRule = {
            pattern: /(^[ \t]*)#.*/m,
            lookbehind: true,
            greedy: true
        };
        /**
     * @param {string} source
     * @param {string} flags
     * @returns {RegExp}
     */ function re(source, flags) {
            source = source.replace(/<OPT>/g, function() {
                return option;
            }).replace(/<SP>/g, function() {
                return space;
            });
            return RegExp(source, flags);
        }
        Prism.languages.docker = {
            instruction: {
                pattern: /(^[ \t]*)(?:ADD|ARG|CMD|COPY|ENTRYPOINT|ENV|EXPOSE|FROM|HEALTHCHECK|LABEL|MAINTAINER|ONBUILD|RUN|SHELL|STOPSIGNAL|USER|VOLUME|WORKDIR)(?=\s)(?:\\.|[^\r\n\\])*(?:\\$(?:\s|#.*$)*(?![\s#])(?:\\.|[^\r\n\\])*)*/im,
                lookbehind: true,
                greedy: true,
                inside: {
                    options: {
                        pattern: re(/(^(?:ONBUILD<SP>)?\w+<SP>)<OPT>(?:<SP><OPT>)*/.source, 'i'),
                        lookbehind: true,
                        greedy: true,
                        inside: {
                            property: {
                                pattern: /(^|\s)--[\w-]+/,
                                lookbehind: true
                            },
                            string: [
                                stringRule,
                                {
                                    pattern: /(=)(?!["'])(?:[^\s\\]|\\.)+/,
                                    lookbehind: true
                                }
                            ],
                            operator: /\\$/m,
                            punctuation: /=/
                        }
                    },
                    keyword: [
                        {
                            // https://docs.docker.com/engine/reference/builder/#healthcheck
                            pattern: re(/(^(?:ONBUILD<SP>)?HEALTHCHECK<SP>(?:<OPT><SP>)*)(?:CMD|NONE)\b/.source, 'i'),
                            lookbehind: true,
                            greedy: true
                        },
                        {
                            // https://docs.docker.com/engine/reference/builder/#from
                            pattern: re(/(^(?:ONBUILD<SP>)?FROM<SP>(?:<OPT><SP>)*(?!--)[^ \t\\]+<SP>)AS/.source, 'i'),
                            lookbehind: true,
                            greedy: true
                        },
                        {
                            // https://docs.docker.com/engine/reference/builder/#onbuild
                            pattern: re(/(^ONBUILD<SP>)\w+/.source, 'i'),
                            lookbehind: true,
                            greedy: true
                        },
                        {
                            pattern: /^\w+/,
                            greedy: true
                        }
                    ],
                    comment: commentRule,
                    string: stringRule,
                    variable: /\$(?:\w+|\{[^{}"'\\]*\})/,
                    operator: /\\$/m
                }
            },
            comment: commentRule
        };
        Prism.languages.dockerfile = Prism.languages.docker;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $2a574647ed928968$export$2e2bcd8739ae039.displayName = 'dot';
$2a574647ed928968$export$2e2bcd8739ae039.aliases = [
    'gv'
];
function $2a574647ed928968$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var ID = '(?:' + [
            // an identifier
            /[a-zA-Z_\x80-\uFFFF][\w\x80-\uFFFF]*/.source,
            // a number
            /-?(?:\.\d+|\d+(?:\.\d*)?)/.source,
            // a double-quoted string
            /"[^"\\]*(?:\\[\s\S][^"\\]*)*"/.source,
            // HTML-like string
            /<(?:[^<>]|(?!<!--)<(?:[^<>"']|"[^"]*"|'[^']*')+>|<!--(?:[^-]|-(?!->))*-->)*>/.source
        ].join('|') + ')';
        var IDInside = {
            markup: {
                pattern: /(^<)[\s\S]+(?=>$)/,
                lookbehind: true,
                alias: [
                    'language-markup',
                    'language-html',
                    'language-xml'
                ],
                inside: Prism.languages.markup
            }
        };
        /**
     * @param {string} source
     * @param {string} flags
     * @returns {RegExp}
     */ function withID(source, flags) {
            return RegExp(source.replace(/<ID>/g, function() {
                return ID;
            }), flags);
        }
        Prism.languages.dot = {
            comment: {
                pattern: /\/\/.*|\/\*[\s\S]*?\*\/|^#.*/m,
                greedy: true
            },
            'graph-name': {
                pattern: withID(/(\b(?:digraph|graph|subgraph)[ \t\r\n]+)<ID>/.source, 'i'),
                lookbehind: true,
                greedy: true,
                alias: 'class-name',
                inside: IDInside
            },
            'attr-value': {
                pattern: withID(/(=[ \t\r\n]*)<ID>/.source),
                lookbehind: true,
                greedy: true,
                inside: IDInside
            },
            'attr-name': {
                pattern: withID(/([\[;, \t\r\n])<ID>(?=[ \t\r\n]*=)/.source),
                lookbehind: true,
                greedy: true,
                inside: IDInside
            },
            keyword: /\b(?:digraph|edge|graph|node|strict|subgraph)\b/i,
            'compass-point': {
                pattern: /(:[ \t\r\n]*)(?:[ewc_]|[ns][ew]?)(?![\w\x80-\uFFFF])/,
                lookbehind: true,
                alias: 'builtin'
            },
            node: {
                pattern: withID(/(^|[^-.\w\x80-\uFFFF\\])<ID>/.source),
                lookbehind: true,
                greedy: true,
                inside: IDInside
            },
            operator: /[=:]|-[->]/,
            punctuation: /[\[\]{};,]/
        };
        Prism.languages.gv = Prism.languages.dot;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $39e923bc942f1557$export$2e2bcd8739ae039.displayName = 'ebnf';
$39e923bc942f1557$export$2e2bcd8739ae039.aliases = [];
function $39e923bc942f1557$export$2e2bcd8739ae039(Prism) {
    Prism.languages.ebnf = {
        comment: /\(\*[\s\S]*?\*\)/,
        string: {
            pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
            greedy: true
        },
        special: {
            pattern: /\?[^?\r\n]*\?/,
            greedy: true,
            alias: 'class-name'
        },
        definition: {
            pattern: /^([\t ]*)[a-z]\w*(?:[ \t]+[a-z]\w*)*(?=\s*=)/im,
            lookbehind: true,
            alias: [
                'rule',
                'keyword'
            ]
        },
        rule: /\b[a-z]\w*(?:[ \t]+[a-z]\w*)*\b/i,
        punctuation: /\([:/]|[:/]\)|[.,;()[\]{}]/,
        operator: /[-=|*/!]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $b4ba574bb0c7b7ad$export$2e2bcd8739ae039.displayName = 'editorconfig';
$b4ba574bb0c7b7ad$export$2e2bcd8739ae039.aliases = [];
function $b4ba574bb0c7b7ad$export$2e2bcd8739ae039(Prism) {
    Prism.languages.editorconfig = {
        // https://editorconfig-specification.readthedocs.io
        comment: /[;#].*/,
        section: {
            pattern: /(^[ \t]*)\[.+\]/m,
            lookbehind: true,
            alias: 'selector',
            inside: {
                regex: /\\\\[\[\]{},!?.*]/,
                // Escape special characters with '\\'
                operator: /[!?]|\.\.|\*{1,2}/,
                punctuation: /[\[\]{},]/
            }
        },
        key: {
            pattern: /(^[ \t]*)[^\s=]+(?=[ \t]*=)/m,
            lookbehind: true,
            alias: 'attr-name'
        },
        value: {
            pattern: /=.*/,
            alias: 'attr-value',
            inside: {
                punctuation: /^=/
            }
        }
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $1b81107a7b5ce4f8$export$2e2bcd8739ae039.displayName = 'eiffel';
$1b81107a7b5ce4f8$export$2e2bcd8739ae039.aliases = [];
function $1b81107a7b5ce4f8$export$2e2bcd8739ae039(Prism) {
    Prism.languages.eiffel = {
        comment: /--.*/,
        string: [
            // Aligned-verbatim-strings
            {
                pattern: /"([^[]*)\[[\s\S]*?\]\1"/,
                greedy: true
            },
            // Non-aligned-verbatim-strings
            {
                pattern: /"([^{]*)\{[\s\S]*?\}\1"/,
                greedy: true
            },
            // Single-line string
            {
                pattern: /"(?:%(?:(?!\n)\s)*\n\s*%|%\S|[^%"\r\n])*"/,
                greedy: true
            }
        ],
        // normal char | special char | char code
        char: /'(?:%.|[^%'\r\n])+'/,
        keyword: /\b(?:across|agent|alias|all|and|as|assign|attached|attribute|check|class|convert|create|Current|debug|deferred|detachable|do|else|elseif|end|ensure|expanded|export|external|feature|from|frozen|if|implies|inherit|inspect|invariant|like|local|loop|not|note|obsolete|old|once|or|Precursor|redefine|rename|require|rescue|Result|retry|select|separate|some|then|undefine|until|variant|Void|when|xor)\b/i,
        boolean: /\b(?:False|True)\b/i,
        // Convention: class-names are always all upper-case characters
        'class-name': /\b[A-Z][\dA-Z_]*\b/,
        number: [
            // hexa | octal | bin
            /\b0[xcb][\da-f](?:_*[\da-f])*\b/i,
            // Decimal
            /(?:\b\d(?:_*\d)*)?\.(?:(?:\d(?:_*\d)*)?e[+-]?)?\d(?:_*\d)*\b|\b\d(?:_*\d)*\b\.?/i
        ],
        punctuation: /:=|<<|>>|\(\||\|\)|->|\.(?=\w)|[{}[\];(),:?]/,
        operator: /\\\\|\|\.\.\||\.\.|\/[~\/=]?|[><]=?|[-+*^=~]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 

$167758c4a2bcd476$export$2e2bcd8739ae039.displayName = 'ejs';
$167758c4a2bcd476$export$2e2bcd8739ae039.aliases = [
    'eta'
];
function $167758c4a2bcd476$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $9f5c72e4d4e505c4$export$2e2bcd8739ae039));
    Prism.register((0, $a400735491c1aa4e$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.ejs = {
            delimiter: {
                pattern: /^<%[-_=]?|[-_]?%>$/,
                alias: 'punctuation'
            },
            comment: /^#[\s\S]*/,
            'language-javascript': {
                pattern: /[\s\S]+/,
                inside: Prism.languages.javascript
            }
        };
        Prism.hooks.add('before-tokenize', function(env) {
            var ejsPattern = /<%(?!%)[\s\S]+?%>/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'ejs', ejsPattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'ejs');
        });
        Prism.languages.eta = Prism.languages.ejs;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $eec348ce27e7d8ad$export$2e2bcd8739ae039.displayName = 'elixir';
$eec348ce27e7d8ad$export$2e2bcd8739ae039.aliases = [];
function $eec348ce27e7d8ad$export$2e2bcd8739ae039(Prism) {
    Prism.languages.elixir = {
        doc: {
            pattern: /@(?:doc|moduledoc)\s+(?:("""|''')[\s\S]*?\1|("|')(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2)/,
            inside: {
                attribute: /^@\w+/,
                string: /['"][\s\S]+/
            }
        },
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        // ~r"""foo""" (multi-line), ~r'''foo''' (multi-line), ~r/foo/, ~r|foo|, ~r"foo", ~r'foo', ~r(foo), ~r[foo], ~r{foo}, ~r<foo>
        regex: {
            pattern: /~[rR](?:("""|''')(?:\\[\s\S]|(?!\1)[^\\])+\1|([\/|"'])(?:\\.|(?!\2)[^\\\r\n])+\2|\((?:\\.|[^\\)\r\n])+\)|\[(?:\\.|[^\\\]\r\n])+\]|\{(?:\\.|[^\\}\r\n])+\}|<(?:\\.|[^\\>\r\n])+>)[uismxfr]*/,
            greedy: true
        },
        string: [
            {
                // ~s"""foo""" (multi-line), ~s'''foo''' (multi-line), ~s/foo/, ~s|foo|, ~s"foo", ~s'foo', ~s(foo), ~s[foo], ~s{foo} (with interpolation care), ~s<foo>
                pattern: /~[cCsSwW](?:("""|''')(?:\\[\s\S]|(?!\1)[^\\])+\1|([\/|"'])(?:\\.|(?!\2)[^\\\r\n])+\2|\((?:\\.|[^\\)\r\n])+\)|\[(?:\\.|[^\\\]\r\n])+\]|\{(?:\\.|#\{[^}]+\}|#(?!\{)|[^#\\}\r\n])+\}|<(?:\\.|[^\\>\r\n])+>)[csa]?/,
                greedy: true,
                inside: {
                }
            },
            {
                pattern: /("""|''')[\s\S]*?\1/,
                greedy: true,
                inside: {
                }
            },
            {
                // Multi-line strings are allowed
                pattern: /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
                greedy: true,
                inside: {
                }
            }
        ],
        atom: {
            // Look-behind prevents bad highlighting of the :: operator
            pattern: /(^|[^:]):\w+/,
            lookbehind: true,
            alias: 'symbol'
        },
        module: {
            pattern: /\b[A-Z]\w*\b/,
            alias: 'class-name'
        },
        // Look-ahead prevents bad highlighting of the :: operator
        'attr-name': /\b\w+\??:(?!:)/,
        argument: {
            // Look-behind prevents bad highlighting of the && operator
            pattern: /(^|[^&])&\d+/,
            lookbehind: true,
            alias: 'variable'
        },
        attribute: {
            pattern: /@\w+/,
            alias: 'variable'
        },
        function: /\b[_a-zA-Z]\w*[?!]?(?:(?=\s*(?:\.\s*)?\()|(?=\/\d))/,
        number: /\b(?:0[box][a-f\d_]+|\d[\d_]*)(?:\.[\d_]+)?(?:e[+-]?[\d_]+)?\b/i,
        keyword: /\b(?:after|alias|and|case|catch|cond|def(?:callback|delegate|exception|impl|macro|module|n|np|p|protocol|struct)?|do|else|end|fn|for|if|import|not|or|quote|raise|require|rescue|try|unless|unquote|use|when)\b/,
        boolean: /\b(?:false|nil|true)\b/,
        operator: [
            /\bin\b|&&?|\|[|>]?|\\\\|::|\.\.\.?|\+\+?|-[->]?|<[-=>]|>=|!==?|\B!|=(?:==?|[>~])?|[*\/^]/,
            {
                // We don't want to match <<
                pattern: /([^<])<(?!<)/,
                lookbehind: true
            },
            {
                // We don't want to match >>
                pattern: /([^>])>(?!>)/,
                lookbehind: true
            }
        ],
        punctuation: /<<|>>|[.,%\[\]{}()]/
    };
    Prism.languages.elixir.string.forEach(function(o) {
        o.inside = {
            interpolation: {
                pattern: /#\{[^}]+\}/,
                inside: {
                    delimiter: {
                        pattern: /^#\{|\}$/,
                        alias: 'punctuation'
                    },
                    rest: Prism.languages.elixir
                }
            }
        };
    });
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $f4c7bf5b97ed8197$export$2e2bcd8739ae039.displayName = 'elm';
$f4c7bf5b97ed8197$export$2e2bcd8739ae039.aliases = [];
function $f4c7bf5b97ed8197$export$2e2bcd8739ae039(Prism) {
    Prism.languages.elm = {
        comment: /--.*|\{-[\s\S]*?-\}/,
        char: {
            pattern: /'(?:[^\\'\r\n]|\\(?:[abfnrtv\\']|\d+|x[0-9a-fA-F]+|u\{[0-9a-fA-F]+\}))'/,
            greedy: true
        },
        string: [
            {
                // Multiline strings are wrapped in triple ". Quotes may appear unescaped.
                pattern: /"""[\s\S]*?"""/,
                greedy: true
            },
            {
                pattern: /"(?:[^\\"\r\n]|\\.)*"/,
                greedy: true
            }
        ],
        'import-statement': {
            // The imported or hidden names are not included in this import
            // statement. This is because we want to highlight those exactly like
            // we do for the names in the program.
            pattern: /(^[\t ]*)import\s+[A-Z]\w*(?:\.[A-Z]\w*)*(?:\s+as\s+(?:[A-Z]\w*)(?:\.[A-Z]\w*)*)?(?:\s+exposing\s+)?/m,
            lookbehind: true,
            inside: {
                keyword: /\b(?:as|exposing|import)\b/
            }
        },
        keyword: /\b(?:alias|as|case|else|exposing|if|in|infixl|infixr|let|module|of|then|type)\b/,
        // These are builtin variables only. Constructors are highlighted later as a constant.
        builtin: /\b(?:abs|acos|always|asin|atan|atan2|ceiling|clamp|compare|cos|curry|degrees|e|flip|floor|fromPolar|identity|isInfinite|isNaN|logBase|max|min|negate|never|not|pi|radians|rem|round|sin|sqrt|tan|toFloat|toPolar|toString|truncate|turns|uncurry|xor)\b/,
        // decimal integers and floating point numbers | hexadecimal integers
        number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0x[0-9a-f]+)\b/i,
        // Most of this is needed because of the meaning of a single '.'.
        // If it stands alone freely, it is the function composition.
        // It may also be a separator between a module name and an identifier => no
        // operator. If it comes together with other special characters it is an
        // operator too.
        // Valid operator characters in 0.18: +-/*=.$<>:&|^?%#@~!
        // Ref: https://groups.google.com/forum/#!msg/elm-dev/0AHSnDdkSkQ/E0SVU70JEQAJ
        operator: /\s\.\s|[+\-/*=.$<>:&|^?%#@~!]{2,}|[+\-/*=$<>:&|^?%#@~!]/,
        // In Elm, nearly everything is a variable, do not highlight these.
        hvariable: /\b(?:[A-Z]\w*\.)*[a-z]\w*\b/,
        constant: /\b(?:[A-Z]\w*\.)*[A-Z]\w*\b/,
        punctuation: /[{}[\]|(),.:]/
    };
}



// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 

$e103275a4fe1cf8e$export$2e2bcd8739ae039.displayName = 'etlua';
$e103275a4fe1cf8e$export$2e2bcd8739ae039.aliases = [];
function $e103275a4fe1cf8e$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $3350a7c50307d503$export$2e2bcd8739ae039));
    Prism.register((0, $a400735491c1aa4e$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.etlua = {
            delimiter: {
                pattern: /^<%[-=]?|-?%>$/,
                alias: 'punctuation'
            },
            'language-lua': {
                pattern: /[\s\S]+/,
                inside: Prism.languages.lua
            }
        };
        Prism.hooks.add('before-tokenize', function(env) {
            var pattern = /<%[\s\S]+?%>/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'etlua', pattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'etlua');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 

$c96ec64ee90c7f15$export$2e2bcd8739ae039.displayName = 'erb';
$c96ec64ee90c7f15$export$2e2bcd8739ae039.aliases = [];
function $c96ec64ee90c7f15$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $a400735491c1aa4e$export$2e2bcd8739ae039));
    Prism.register((0, $1024f633e11e96f5$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.erb = {
            delimiter: {
                pattern: /^(\s*)<%=?|%>(?=\s*$)/,
                lookbehind: true,
                alias: 'punctuation'
            },
            ruby: {
                pattern: /\s*\S[\s\S]*/,
                alias: 'language-ruby',
                inside: Prism.languages.ruby
            }
        };
        Prism.hooks.add('before-tokenize', function(env) {
            var erbPattern = /<%=?(?:[^\r\n]|[\r\n](?!=begin)|[\r\n]=begin\s(?:[^\r\n]|[\r\n](?!=end))*[\r\n]=end)+?%>/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'erb', erbPattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'erb');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $62620c15354b1402$export$2e2bcd8739ae039.displayName = 'erlang';
$62620c15354b1402$export$2e2bcd8739ae039.aliases = [];
function $62620c15354b1402$export$2e2bcd8739ae039(Prism) {
    Prism.languages.erlang = {
        comment: /%.+/,
        string: {
            pattern: /"(?:\\.|[^\\"\r\n])*"/,
            greedy: true
        },
        'quoted-function': {
            pattern: /'(?:\\.|[^\\'\r\n])+'(?=\()/,
            alias: 'function'
        },
        'quoted-atom': {
            pattern: /'(?:\\.|[^\\'\r\n])+'/,
            alias: 'atom'
        },
        boolean: /\b(?:false|true)\b/,
        keyword: /\b(?:after|begin|case|catch|end|fun|if|of|receive|try|when)\b/,
        number: [
            /\$\\?./,
            /\b\d+#[a-z0-9]+/i,
            /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i
        ],
        function: /\b[a-z][\w@]*(?=\()/,
        variable: {
            // Look-behind is used to prevent wrong highlighting of atoms containing "@"
            pattern: /(^|[^@])(?:\b|\?)[A-Z_][\w@]*/,
            lookbehind: true
        },
        operator: [
            /[=\/<>:]=|=[:\/]=|\+\+?|--?|[=*\/!]|\b(?:and|andalso|band|bnot|bor|bsl|bsr|bxor|div|not|or|orelse|rem|xor)\b/,
            {
                // We don't want to match <<
                pattern: /(^|[^<])<(?!<)/,
                lookbehind: true
            },
            {
                // We don't want to match >>
                pattern: /(^|[^>])>(?!>)/,
                lookbehind: true
            }
        ],
        atom: /\b[a-z][\w@]*/,
        punctuation: /[()[\]{}:;,.#|]|<<|>>/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $456b4755eb59d7fa$export$2e2bcd8739ae039.displayName = 'excel-formula';
$456b4755eb59d7fa$export$2e2bcd8739ae039.aliases = [
    'xls',
    'xlsx'
];
function $456b4755eb59d7fa$export$2e2bcd8739ae039(Prism) {
    Prism.languages['excel-formula'] = {
        comment: {
            pattern: /(\bN\(\s*)"(?:[^"]|"")*"(?=\s*\))/i,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"]|"")*"(?!")/,
            greedy: true
        },
        reference: {
            // https://www.ablebits.com/office-addins-blog/2015/12/08/excel-reference-another-sheet-workbook/
            // Sales!B2
            // 'Winter sales'!B2
            // [Sales.xlsx]Jan!B2:B5
            // D:\Reports\[Sales.xlsx]Jan!B2:B5
            // '[Sales.xlsx]Jan sales'!B2:B5
            // 'D:\Reports\[Sales.xlsx]Jan sales'!B2:B5
            pattern: /(?:'[^']*'|(?:[^\s()[\]{}<>*?"';,$&]*\[[^^\s()[\]{}<>*?"']+\])?\w+)!/,
            greedy: true,
            alias: 'string',
            inside: {
                operator: /!$/,
                punctuation: /'/,
                sheet: {
                    pattern: /[^[\]]+$/,
                    alias: 'function'
                },
                file: {
                    pattern: /\[[^[\]]+\]$/,
                    inside: {
                        punctuation: /[[\]]/
                    }
                },
                path: /[\s\S]+/
            }
        },
        'function-name': {
            pattern: /\b[A-Z]\w*(?=\()/i,
            alias: 'builtin'
        },
        range: {
            pattern: /\$?\b(?:[A-Z]+\$?\d+:\$?[A-Z]+\$?\d+|[A-Z]+:\$?[A-Z]+|\d+:\$?\d+)\b/i,
            alias: 'selector',
            inside: {
                operator: /:/,
                cell: /\$?[A-Z]+\$?\d+/i,
                column: /\$?[A-Z]+/i,
                row: /\$?\d+/
            }
        },
        cell: {
            // Excel is case insensitive, so the string "foo1" could be either a variable or a cell.
            // To combat this, we match cells case insensitive, if the contain at least one "$", and case sensitive otherwise.
            pattern: /\b[A-Z]+\d+\b|\$[A-Za-z]+\$?\d+\b|\b[A-Za-z]+\$\d+\b/,
            alias: 'selector'
        },
        number: /(?:\b\d+(?:\.\d+)?|\B\.\d+)(?:e[+-]?\d+)?\b/i,
        boolean: /\b(?:FALSE|TRUE)\b/i,
        operator: /[-+*/^%=&,]|<[=>]?|>=?/,
        punctuation: /[[\]();{}|]/
    };
    Prism.languages['xlsx'] = Prism.languages['xls'] = Prism.languages['excel-formula'];
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$d0a70735eb9f5348$export$2e2bcd8739ae039.displayName = 'fsharp';
$d0a70735eb9f5348$export$2e2bcd8739ae039.aliases = [];
function $d0a70735eb9f5348$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    Prism.languages.fsharp = Prism.languages.extend('clike', {
        comment: [
            {
                pattern: /(^|[^\\])\(\*(?!\))[\s\S]*?\*\)/,
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(?:"""[\s\S]*?"""|@"(?:""|[^"])*"|"(?:\\[\s\S]|[^\\"])*")B?/,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:exception|inherit|interface|new|of|type)\s+|\w\s*:\s*|\s:\??>\s*)[.\w]+\b(?:\s*(?:->|\*)\s*[.\w]+\b)*(?!\s*[:.])/,
            lookbehind: true,
            inside: {
                operator: /->|\*/,
                punctuation: /\./
            }
        },
        keyword: /\b(?:let|return|use|yield)(?:!\B|\b)|\b(?:abstract|and|as|asr|assert|atomic|base|begin|break|checked|class|component|const|constraint|constructor|continue|default|delegate|do|done|downcast|downto|eager|elif|else|end|event|exception|extern|external|false|finally|fixed|for|fun|function|functor|global|if|in|include|inherit|inline|interface|internal|land|lazy|lor|lsl|lsr|lxor|match|member|method|mixin|mod|module|mutable|namespace|new|not|null|object|of|open|or|override|parallel|private|process|protected|public|pure|rec|sealed|select|sig|static|struct|tailcall|then|to|trait|true|try|type|upcast|val|virtual|void|volatile|when|while|with)\b/,
        number: [
            /\b0x[\da-fA-F]+(?:LF|lf|un)?\b/,
            /\b0b[01]+(?:uy|y)?\b/,
            /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[fm]|e[+-]?\d+)?\b/i,
            /\b\d+(?:[IlLsy]|UL|u[lsy]?)?\b/
        ],
        operator: /([<>~&^])\1\1|([*.:<>&])\2|<-|->|[!=:]=|<?\|{1,3}>?|\??(?:<=|>=|<>|[-+*/%=<>])\??|[!?^&]|~[+~-]|:>|:\?>?/
    });
    Prism.languages.insertBefore('fsharp', 'keyword', {
        preprocessor: {
            pattern: /(^[\t ]*)#.*/m,
            lookbehind: true,
            alias: 'property',
            inside: {
                directive: {
                    pattern: /(^#)\b(?:else|endif|if|light|line|nowarn)\b/,
                    lookbehind: true,
                    alias: 'keyword'
                }
            }
        }
    });
    Prism.languages.insertBefore('fsharp', 'punctuation', {
        'computation-expression': {
            pattern: /\b[_a-z]\w*(?=\s*\{)/i,
            alias: 'keyword'
        }
    });
    Prism.languages.insertBefore('fsharp', 'string', {
        annotation: {
            pattern: /\[<.+?>\]/,
            greedy: true,
            inside: {
                punctuation: /^\[<|>\]$/,
                'class-name': {
                    pattern: /^\w+$|(^|;\s*)[A-Z]\w*(?=\()/,
                    lookbehind: true
                },
                'annotation-content': {
                    pattern: /[\s\S]+/,
                    inside: Prism.languages.fsharp
                }
            }
        },
        char: {
            pattern: /'(?:[^\\']|\\(?:.|\d{3}|x[a-fA-F\d]{2}|u[a-fA-F\d]{4}|U[a-fA-F\d]{8}))'B?/,
            greedy: true
        }
    });
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $1d7ed5492e362bb6$export$2e2bcd8739ae039.displayName = 'factor';
$1d7ed5492e362bb6$export$2e2bcd8739ae039.aliases = [];
function $1d7ed5492e362bb6$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var comment_inside = {
            function: /\b(?:BUGS?|FIX(?:MES?)?|NOTES?|TODOS?|XX+|HACKS?|WARN(?:ING)?|\?{2,}|!{2,})\b/
        };
        var string_inside = {
            number: /\\[^\s']|%\w/
        };
        var factor = {
            comment: [
                {
                    // ! single-line exclamation point comments with whitespace after/around the !
                    pattern: /(^|\s)(?:! .*|!$)/,
                    lookbehind: true,
                    inside: comment_inside
                } /* from basis/multiline: */ ,
                {
                    // /* comment */, /* comment*/
                    pattern: /(^|\s)\/\*\s[\s\S]*?\*\/(?=\s|$)/,
                    lookbehind: true,
                    greedy: true,
                    inside: comment_inside
                },
                {
                    // ![[ comment ]] , ![===[ comment]===]
                    pattern: /(^|\s)!\[(={0,6})\[\s[\s\S]*?\]\2\](?=\s|$)/,
                    lookbehind: true,
                    greedy: true,
                    inside: comment_inside
                }
            ],
            number: [
                {
                    // basic base 10 integers 9, -9
                    pattern: /(^|\s)[+-]?\d+(?=\s|$)/,
                    lookbehind: true
                },
                {
                    // base prefix integers 0b010 0o70 0xad 0d10 0XAD -0xa9
                    pattern: /(^|\s)[+-]?0(?:b[01]+|o[0-7]+|d\d+|x[\dA-F]+)(?=\s|$)/i,
                    lookbehind: true
                },
                {
                    // fractional ratios 1/5 -1/5 and the literal float approximations 1/5. -1/5.
                    pattern: /(^|\s)[+-]?\d+\/\d+\.?(?=\s|$)/,
                    lookbehind: true
                },
                {
                    // positive mixed numbers 23+1/5 +23+1/5
                    pattern: /(^|\s)\+?\d+\+\d+\/\d+(?=\s|$)/,
                    lookbehind: true
                },
                {
                    // negative mixed numbers -23-1/5
                    pattern: /(^|\s)-\d+-\d+\/\d+(?=\s|$)/,
                    lookbehind: true
                },
                {
                    // basic decimal floats -0.01 0. .0 .1 -.1 -1. -12.13 +12.13
                    // and scientific notation with base 10 exponents 3e4 3e-4 .3e-4
                    pattern: /(^|\s)[+-]?(?:\d*\.\d+|\d+\.\d*|\d+)(?:e[+-]?\d+)?(?=\s|$)/i,
                    lookbehind: true
                },
                {
                    // NAN literal syntax NAN: 80000deadbeef, NAN: a
                    pattern: /(^|\s)NAN:\s+[\da-fA-F]+(?=\s|$)/,
                    lookbehind: true
                },
                {
                    /*
base prefix floats 0x1.0p3 (8.0) 0b1.010p2 (5.0) 0x1.p1 0b1.11111111p11111...
"The normalized hex form ±0x1.MMMMMMMMMMMMM[pP]±EEEE allows any floating-point number to be specified precisely.
The values of MMMMMMMMMMMMM and EEEE map directly to the mantissa and exponent fields of the binary IEEE 754 representation."
<https://docs.factorcode.org/content/article-syntax-floats.html>
*/ pattern: /(^|\s)[+-]?0(?:b1\.[01]*|o1\.[0-7]*|d1\.\d*|x1\.[\dA-F]*)p\d+(?=\s|$)/i,
                    lookbehind: true
                }
            ],
            // R/ regexp?\/\\/
            regexp: {
                pattern: /(^|\s)R\/\s(?:\\\S|[^\\/])*\/(?:[idmsr]*|[idmsr]+-[idmsr]+)(?=\s|$)/,
                lookbehind: true,
                alias: 'number',
                inside: {
                    variable: /\\\S/,
                    keyword: /[+?*\[\]^$(){}.|]/,
                    operator: {
                        pattern: /(\/)[idmsr]+(?:-[idmsr]+)?/,
                        lookbehind: true
                    }
                }
            },
            boolean: {
                pattern: /(^|\s)[tf](?=\s|$)/,
                lookbehind: true
            },
            // SBUF" asd", URL" ://...", P" /etc/"
            'custom-string': {
                pattern: /(^|\s)[A-Z0-9\-]+"\s(?:\\\S|[^"\\])*"/,
                lookbehind: true,
                greedy: true,
                alias: 'string',
                inside: {
                    number: /\\\S|%\w|\//
                }
            },
            'multiline-string': [
                {
                    // STRING: name \n content \n ; -> CONSTANT: name "content" (symbol)
                    pattern: /(^|\s)STRING:\s+\S+(?:\n|\r\n).*(?:\n|\r\n)\s*;(?=\s|$)/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'string',
                    inside: {
                        number: string_inside.number,
                        // trailing semicolon on its own line
                        'semicolon-or-setlocal': {
                            pattern: /([\r\n][ \t]*);(?=\s|$)/,
                            lookbehind: true,
                            alias: 'function'
                        }
                    }
                },
                {
                    // HEREDOC: marker \n content \n marker ; -> "content" (immediate)
                    pattern: /(^|\s)HEREDOC:\s+\S+(?:\n|\r\n).*(?:\n|\r\n)\s*\S+(?=\s|$)/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'string',
                    inside: string_inside
                },
                {
                    // [[ string ]], [==[ string]==]
                    pattern: /(^|\s)\[(={0,6})\[\s[\s\S]*?\]\2\](?=\s|$)/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'string',
                    inside: string_inside
                }
            ],
            'special-using': {
                pattern: /(^|\s)USING:(?:\s\S+)*(?=\s+;(?:\s|$))/,
                lookbehind: true,
                alias: 'function',
                inside: {
                    // this is essentially a regex for vocab names, which i don't want to specify
                    // but the USING: gets picked up as a vocab name
                    string: {
                        pattern: /(\s)[^:\s]+/,
                        lookbehind: true
                    }
                }
            },
            /* this description of stack effect literal syntax is not complete and not as specific as theoretically possible
trying to do better is more work and regex-computation-time than it's worth though.
- we'd like to have the "delimiter" parts of the stack effect [ (, --, and ) ] be a different (less-important or comment-like) colour to the stack effect contents
- we'd like if nested stack effects were treated as such rather than just appearing flat (with `inside`)
- we'd like if the following variable name conventions were recognised specifically:
special row variables = ..a b..
type and stack effect annotations end with a colon = ( quot: ( a: ( -- ) -- b ) -- x ), ( x: number -- )
word throws unconditional error = *
any other word-like variable name = a ? q' etc
https://docs.factorcode.org/content/article-effects.html
these are pretty complicated to highlight properly without a real parser, and therefore out of scope
the old pattern, which may be later useful, was: (^|\s)(?:call|execute|eval)?\((?:\s+[^"\r\n\t ]\S*)*?\s+--(?:\s+[^"\n\t ]\S*)*?\s+\)(?=\s|$)
*/ // current solution is not great
            'stack-effect-delimiter': [
                {
                    // opening parenthesis
                    pattern: /(^|\s)(?:call|eval|execute)?\((?=\s)/,
                    lookbehind: true,
                    alias: 'operator'
                },
                {
                    // middle --
                    pattern: /(\s)--(?=\s)/,
                    lookbehind: true,
                    alias: 'operator'
                },
                {
                    // closing parenthesis
                    pattern: /(\s)\)(?=\s|$)/,
                    lookbehind: true,
                    alias: 'operator'
                }
            ],
            combinators: {
                pattern: null,
                lookbehind: true,
                alias: 'keyword'
            },
            'kernel-builtin': {
                pattern: null,
                lookbehind: true,
                alias: 'variable'
            },
            'sequences-builtin': {
                pattern: null,
                lookbehind: true,
                alias: 'variable'
            },
            'math-builtin': {
                pattern: null,
                lookbehind: true,
                alias: 'variable'
            },
            'constructor-word': {
                // <array> but not <=>
                pattern: /(^|\s)<(?!=+>|-+>)\S+>(?=\s|$)/,
                lookbehind: true,
                alias: 'keyword'
            },
            'other-builtin-syntax': {
                pattern: null,
                lookbehind: true,
                alias: 'operator'
            },
            /*
full list of supported word naming conventions: (the convention appears outside of the [brackets])
set-[x]
change-[x]
with-[x]
new-[x]
>[string]
[base]>
[string]>[number]
+[symbol]+
[boolean-word]?
?[of]
[slot-reader]>>
>>[slot-setter]
[slot-writer]<<
([implementation-detail])
[mutater]!
[variant]*
[prettyprint].
$[help-markup]
<constructors>, SYNTAX:, etc are supported by their own patterns.
`with` and `new` from `kernel` are their own builtins.
see <https://docs.factorcode.org/content/article-conventions.html>
*/ 'conventionally-named-word': {
                pattern: /(^|\s)(?!")(?:(?:change|new|set|with)-\S+|\$\S+|>[^>\s]+|[^:>\s]+>|[^>\s]+>[^>\s]+|\+[^+\s]+\+|[^?\s]+\?|\?[^?\s]+|[^>\s]+>>|>>[^>\s]+|[^<\s]+<<|\([^()\s]+\)|[^!\s]+!|[^*\s]\S*\*|[^.\s]\S*\.)(?=\s|$)/,
                lookbehind: true,
                alias: 'keyword'
            },
            'colon-syntax': {
                pattern: /(^|\s)(?:[A-Z0-9\-]+#?)?:{1,2}\s+(?:;\S+|(?!;)\S+)(?=\s|$)/,
                lookbehind: true,
                greedy: true,
                alias: 'function'
            },
            'semicolon-or-setlocal': {
                pattern: /(\s)(?:;|:>)(?=\s|$)/,
                lookbehind: true,
                alias: 'function'
            },
            // do not highlight leading } or trailing X{ at the begin/end of the file as it's invalid syntax
            'curly-brace-literal-delimiter': [
                {
                    // opening
                    pattern: /(^|\s)[a-z]*\{(?=\s)/i,
                    lookbehind: true,
                    alias: 'operator'
                },
                {
                    // closing
                    pattern: /(\s)\}(?=\s|$)/,
                    lookbehind: true,
                    alias: 'operator'
                }
            ],
            // do not highlight leading ] or trailing [ at the begin/end of the file as it's invalid syntax
            'quotation-delimiter': [
                {
                    // opening
                    pattern: /(^|\s)\[(?=\s)/,
                    lookbehind: true,
                    alias: 'operator'
                },
                {
                    // closing
                    pattern: /(\s)\](?=\s|$)/,
                    lookbehind: true,
                    alias: 'operator'
                }
            ],
            'normal-word': {
                pattern: /(^|\s)[^"\s]\S*(?=\s|$)/,
                lookbehind: true
            },
            /*
basic first-class string "a"
with escaped double-quote "a\""
escaped backslash "\\"
and general escapes since Factor has so many "\N"
syntax that works in the reference implementation that isn't fully
supported because it's an implementation detail:
"string 1""string 2" -> 2 strings (works anyway)
"string"5 -> string, 5
"string"[ ] -> string, quotation
{ "a"} -> array<string>
the rest of those examples all properly recognise the string, but not
the other object (number, quotation, etc)
this is fine for a regex-only implementation.
*/ string: {
                pattern: /"(?:\\\S|[^"\\])*"/,
                greedy: true,
                inside: string_inside
            }
        };
        var escape = function(str) {
            return (str + '').replace(/([.?*+\^$\[\]\\(){}|\-])/g, '\\$1');
        };
        var arrToWordsRegExp = function(arr) {
            return new RegExp('(^|\\s)(?:' + arr.map(escape).join('|') + ')(?=\\s|$)');
        };
        var builtins = {
            'kernel-builtin': [
                'or',
                '2nipd',
                '4drop',
                'tuck',
                'wrapper',
                'nip',
                'wrapper?',
                'callstack>array',
                'die',
                'dupd',
                'callstack',
                'callstack?',
                '3dup',
                'hashcode',
                'pick',
                '4nip',
                'build',
                '>boolean',
                'nipd',
                'clone',
                '5nip',
                'eq?',
                '?',
                '=',
                'swapd',
                '2over',
                'clear',
                '2dup',
                'get-retainstack',
                'not',
                'tuple?',
                'dup',
                '3nipd',
                'call',
                '-rotd',
                'object',
                'drop',
                'assert=',
                'assert?',
                '-rot',
                'execute',
                'boa',
                'get-callstack',
                'curried?',
                '3drop',
                'pickd',
                'overd',
                'over',
                'roll',
                '3nip',
                'swap',
                'and',
                '2nip',
                'rotd',
                'throw',
                '(clone)',
                'hashcode*',
                'spin',
                'reach',
                '4dup',
                'equal?',
                'get-datastack',
                'assert',
                '2drop',
                '<wrapper>',
                'boolean?',
                'identity-hashcode',
                'identity-tuple?',
                'null',
                'composed?',
                'new',
                '5drop',
                'rot',
                '-roll',
                'xor',
                'identity-tuple',
                'boolean'
            ],
            'other-builtin-syntax': [
                // syntax
                '=======',
                'recursive',
                'flushable',
                '>>',
                '<<<<<<',
                'M\\',
                'B',
                'PRIVATE>',
                '\\',
                '======',
                'final',
                'inline',
                'delimiter',
                'deprecated',
                '<PRIVATE',
                '>>>>>>',
                '<<<<<<<',
                'parse-complex',
                'malformed-complex',
                'read-only',
                '>>>>>>>',
                'call-next-method',
                '<<',
                'foldable',
                // literals
                '$',
                '$[',
                '${'
            ],
            'sequences-builtin': [
                'member-eq?',
                'mismatch',
                'append',
                'assert-sequence=',
                'longer',
                'repetition',
                'clone-like',
                '3sequence',
                'assert-sequence?',
                'last-index-from',
                'reversed',
                'index-from',
                'cut*',
                'pad-tail',
                'join-as',
                'remove-eq!',
                'concat-as',
                'but-last',
                'snip',
                'nths',
                'nth',
                'sequence',
                'longest',
                'slice?',
                '<slice>',
                'remove-nth',
                'tail-slice',
                'empty?',
                'tail*',
                'member?',
                'virtual-sequence?',
                'set-length',
                'drop-prefix',
                'iota',
                'unclip',
                'bounds-error?',
                'unclip-last-slice',
                'non-negative-integer-expected',
                'non-negative-integer-expected?',
                'midpoint@',
                'longer?',
                '?set-nth',
                '?first',
                'rest-slice',
                'prepend-as',
                'prepend',
                'fourth',
                'sift',
                'subseq-start',
                'new-sequence',
                '?last',
                'like',
                'first4',
                '1sequence',
                'reverse',
                'slice',
                'virtual@',
                'repetition?',
                'set-last',
                'index',
                '4sequence',
                'max-length',
                'set-second',
                'immutable-sequence',
                'first2',
                'first3',
                'supremum',
                'unclip-slice',
                'suffix!',
                'insert-nth',
                'tail',
                '3append',
                'short',
                'suffix',
                'concat',
                'flip',
                'immutable?',
                'reverse!',
                '2sequence',
                'sum',
                'delete-all',
                'indices',
                'snip-slice',
                '<iota>',
                'check-slice',
                'sequence?',
                'head',
                'append-as',
                'halves',
                'sequence=',
                'collapse-slice',
                '?second',
                'slice-error?',
                'product',
                'bounds-check?',
                'bounds-check',
                'immutable',
                'virtual-exemplar',
                'harvest',
                'remove',
                'pad-head',
                'last',
                'set-fourth',
                'cartesian-product',
                'remove-eq',
                'shorten',
                'shorter',
                'reversed?',
                'shorter?',
                'shortest',
                'head-slice',
                'pop*',
                'tail-slice*',
                'but-last-slice',
                'iota?',
                'append!',
                'cut-slice',
                'new-resizable',
                'head-slice*',
                'sequence-hashcode',
                'pop',
                'set-nth',
                '?nth',
                'second',
                'join',
                'immutable-sequence?',
                '<reversed>',
                '3append-as',
                'virtual-sequence',
                'subseq?',
                'remove-nth!',
                'length',
                'last-index',
                'lengthen',
                'assert-sequence',
                'copy',
                'move',
                'third',
                'first',
                'tail?',
                'set-first',
                'prefix',
                'bounds-error',
                '<repetition>',
                'exchange',
                'surround',
                'cut',
                'min-length',
                'set-third',
                'push-all',
                'head?',
                'subseq-start-from',
                'delete-slice',
                'rest',
                'sum-lengths',
                'head*',
                'infimum',
                'remove!',
                'glue',
                'slice-error',
                'subseq',
                'push',
                'replace-slice',
                'subseq-as',
                'unclip-last'
            ],
            'math-builtin': [
                'number=',
                'next-power-of-2',
                '?1+',
                'fp-special?',
                'imaginary-part',
                'float>bits',
                'number?',
                'fp-infinity?',
                'bignum?',
                'fp-snan?',
                'denominator',
                'gcd',
                '*',
                '+',
                'fp-bitwise=',
                '-',
                'u>=',
                '/',
                '>=',
                'bitand',
                'power-of-2?',
                'log2-expects-positive',
                'neg?',
                '<',
                'log2',
                '>',
                'integer?',
                'number',
                'bits>double',
                '2/',
                'zero?',
                'bits>float',
                'float?',
                'shift',
                'ratio?',
                'rect>',
                'even?',
                'ratio',
                'fp-sign',
                'bitnot',
                '>fixnum',
                'complex?',
                '/i',
                'integer>fixnum',
                '/f',
                'sgn',
                '>bignum',
                'next-float',
                'u<',
                'u>',
                'mod',
                'recip',
                'rational',
                '>float',
                '2^',
                'integer',
                'fixnum?',
                'neg',
                'fixnum',
                'sq',
                'bignum',
                '>rect',
                'bit?',
                'fp-qnan?',
                'simple-gcd',
                'complex',
                '<fp-nan>',
                'real',
                '>fraction',
                'double>bits',
                'bitor',
                'rem',
                'fp-nan-payload',
                'real-part',
                'log2-expects-positive?',
                'prev-float',
                'align',
                'unordered?',
                'float',
                'fp-nan?',
                'abs',
                'bitxor',
                'integer>fixnum-strict',
                'u<=',
                'odd?',
                '<=',
                '/mod',
                '>integer',
                'real?',
                'rational?',
                'numerator'
            ]
        };
        Object.keys(builtins).forEach(function(k) {
            factor[k].pattern = arrToWordsRegExp(builtins[k]);
        });
        var combinators = [
            // kernel
            '2bi',
            'while',
            '2tri',
            'bi*',
            '4dip',
            'both?',
            'same?',
            'tri@',
            'curry',
            'prepose',
            '3bi',
            '?if',
            'tri*',
            '2keep',
            '3keep',
            'curried',
            '2keepd',
            'when',
            '2bi*',
            '2tri*',
            '4keep',
            'bi@',
            'keepdd',
            'do',
            'unless*',
            'tri-curry',
            'if*',
            'loop',
            'bi-curry*',
            'when*',
            '2bi@',
            '2tri@',
            'with',
            '2with',
            'either?',
            'bi',
            'until',
            '3dip',
            '3curry',
            'tri-curry*',
            'tri-curry@',
            'bi-curry',
            'keepd',
            'compose',
            '2dip',
            'if',
            '3tri',
            'unless',
            'tuple',
            'keep',
            '2curry',
            'tri',
            'most',
            'while*',
            'dip',
            'composed',
            'bi-curry@',
            // sequences
            'find-last-from',
            'trim-head-slice',
            'map-as',
            'each-from',
            'none?',
            'trim-tail',
            'partition',
            'if-empty',
            'accumulate*',
            'reject!',
            'find-from',
            'accumulate-as',
            'collector-for-as',
            'reject',
            'map',
            'map-sum',
            'accumulate!',
            '2each-from',
            'follow',
            'supremum-by',
            'map!',
            'unless-empty',
            'collector',
            'padding',
            'reduce-index',
            'replicate-as',
            'infimum-by',
            'trim-tail-slice',
            'count',
            'find-index',
            'filter',
            'accumulate*!',
            'reject-as',
            'map-integers',
            'map-find',
            'reduce',
            'selector',
            'interleave',
            '2map',
            'filter-as',
            'binary-reduce',
            'map-index-as',
            'find',
            'produce',
            'filter!',
            'replicate',
            'cartesian-map',
            'cartesian-each',
            'find-index-from',
            'map-find-last',
            '3map-as',
            '3map',
            'find-last',
            'selector-as',
            '2map-as',
            '2map-reduce',
            'accumulate',
            'each',
            'each-index',
            'accumulate*-as',
            'when-empty',
            'all?',
            'collector-as',
            'push-either',
            'new-like',
            'collector-for',
            '2selector',
            'push-if',
            '2all?',
            'map-reduce',
            '3each',
            'any?',
            'trim-slice',
            '2reduce',
            'change-nth',
            'produce-as',
            '2each',
            'trim',
            'trim-head',
            'cartesian-find',
            'map-index',
            // math
            'if-zero',
            'each-integer',
            'unless-zero',
            '(find-integer)',
            'when-zero',
            'find-last-integer',
            '(all-integers?)',
            'times',
            '(each-integer)',
            'find-integer',
            'all-integers?',
            // math.combinators
            'unless-negative',
            'if-positive',
            'when-positive',
            'when-negative',
            'unless-positive',
            'if-negative',
            // combinators
            'case',
            '2cleave',
            'cond>quot',
            'case>quot',
            '3cleave',
            'wrong-values',
            'to-fixed-point',
            'alist>quot',
            'cond',
            'cleave',
            'call-effect',
            'recursive-hashcode',
            'spread',
            'deep-spread>quot',
            // combinators.short-circuit
            '2||',
            '0||',
            'n||',
            '0&&',
            '2&&',
            '3||',
            '1||',
            '1&&',
            'n&&',
            '3&&',
            // combinators.smart
            'smart-unless*',
            'keep-inputs',
            'reduce-outputs',
            'smart-when*',
            'cleave>array',
            'smart-with',
            'smart-apply',
            'smart-if',
            'inputs/outputs',
            'output>sequence-n',
            'map-outputs',
            'map-reduce-outputs',
            'dropping',
            'output>array',
            'smart-map-reduce',
            'smart-2map-reduce',
            'output>array-n',
            'nullary',
            'input<sequence',
            'append-outputs',
            'drop-inputs',
            'inputs',
            'smart-2reduce',
            'drop-outputs',
            'smart-reduce',
            'preserving',
            'smart-when',
            'outputs',
            'append-outputs-as',
            'smart-unless',
            'smart-if*',
            'sum-outputs',
            'input<sequence-unsafe',
            'output>sequence'
        ];
        factor.combinators.pattern = arrToWordsRegExp(combinators);
        Prism.languages.factor = factor;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $53271749677b9f40$export$2e2bcd8739ae039.displayName = 'false';
$53271749677b9f40$export$2e2bcd8739ae039.aliases = [];
function $53271749677b9f40$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        /**
     * Based on the manual by Wouter van Oortmerssen.
     *
     * @see {@link https://github.com/PrismJS/prism/issues/2801#issue-829717504}
     */ Prism.languages['false'] = {
            comment: {
                pattern: /\{[^}]*\}/
            },
            string: {
                pattern: /"[^"]*"/,
                greedy: true
            },
            'character-code': {
                pattern: /'(?:[^\r]|\r\n?)/,
                alias: 'number'
            },
            'assembler-code': {
                pattern: /\d+`/,
                alias: 'important'
            },
            number: /\d+/,
            operator: /[-!#$%&'*+,./:;=>?@\\^_`|~ßø]/,
            punctuation: /\[|\]/,
            variable: /[a-z]/,
            'non-standard': {
                pattern: /[()<BDO®]/,
                alias: 'bold'
            }
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$5540e33516f385a9$export$2e2bcd8739ae039.displayName = 'firestore-security-rules';
$5540e33516f385a9$export$2e2bcd8739ae039.aliases = [];
function $5540e33516f385a9$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    Prism.languages['firestore-security-rules'] = Prism.languages.extend('clike', {
        comment: /\/\/.*/,
        keyword: /\b(?:allow|function|if|match|null|return|rules_version|service)\b/,
        operator: /&&|\|\||[<>!=]=?|[-+*/%]|\b(?:in|is)\b/
    });
    delete Prism.languages['firestore-security-rules']['class-name'];
    Prism.languages.insertBefore('firestore-security-rules', 'keyword', {
        path: {
            pattern: /(^|[\s(),])(?:\/(?:[\w\xA0-\uFFFF]+|\{[\w\xA0-\uFFFF]+(?:=\*\*)?\}|\$\([\w\xA0-\uFFFF.]+\)))+/,
            lookbehind: true,
            greedy: true,
            inside: {
                variable: {
                    pattern: /\{[\w\xA0-\uFFFF]+(?:=\*\*)?\}|\$\([\w\xA0-\uFFFF.]+\)/,
                    inside: {
                        operator: /=/,
                        keyword: /\*\*/,
                        punctuation: /[.$(){}]/
                    }
                },
                punctuation: /\//
            }
        },
        method: {
            // to make the pattern shorter, the actual method names are omitted
            pattern: /(\ballow\s+)[a-z]+(?:\s*,\s*[a-z]+)*(?=\s*[:;])/,
            lookbehind: true,
            alias: 'builtin',
            inside: {
                punctuation: /,/
            }
        }
    });
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$0d2da194b5281e11$export$2e2bcd8739ae039.displayName = 'flow';
$0d2da194b5281e11$export$2e2bcd8739ae039.aliases = [];
function $0d2da194b5281e11$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $9f5c72e4d4e505c4$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.flow = Prism.languages.extend('javascript', {});
        Prism.languages.insertBefore('flow', 'keyword', {
            type: [
                {
                    pattern: /\b(?:[Bb]oolean|Function|[Nn]umber|[Ss]tring|[Ss]ymbol|any|mixed|null|void)\b/,
                    alias: 'class-name'
                }
            ]
        });
        Prism.languages.flow['function-variable'].pattern = /(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=\s*(?:function\b|(?:\([^()]*\)(?:\s*:\s*\w+)?|(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/i;
        delete Prism.languages.flow['parameter'];
        Prism.languages.insertBefore('flow', 'operator', {
            'flow-punctuation': {
                pattern: /\{\||\|\}/,
                alias: 'punctuation'
            }
        });
        if (!Array.isArray(Prism.languages.flow.keyword)) Prism.languages.flow.keyword = [
            Prism.languages.flow.keyword
        ];
        Prism.languages.flow.keyword.unshift({
            pattern: /(^|[^$]\b)(?:Class|declare|opaque|type)\b(?!\$)/,
            lookbehind: true
        }, {
            pattern: /(^|[^$]\B)\$(?:Diff|Enum|Exact|Keys|ObjMap|PropertyType|Record|Shape|Subtype|Supertype|await)\b(?!\$)/,
            lookbehind: true
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $16a86fc228919017$export$2e2bcd8739ae039.displayName = 'fortran';
$16a86fc228919017$export$2e2bcd8739ae039.aliases = [];
function $16a86fc228919017$export$2e2bcd8739ae039(Prism) {
    Prism.languages.fortran = {
        'quoted-number': {
            pattern: /[BOZ](['"])[A-F0-9]+\1/i,
            alias: 'number'
        },
        string: {
            pattern: /(?:\b\w+_)?(['"])(?:\1\1|&(?:\r\n?|\n)(?:[ \t]*!.*(?:\r\n?|\n)|(?![ \t]*!))|(?!\1).)*(?:\1|&)/,
            inside: {
                comment: {
                    pattern: /(&(?:\r\n?|\n)\s*)!.*/,
                    lookbehind: true
                }
            }
        },
        comment: {
            pattern: /!.*/,
            greedy: true
        },
        boolean: /\.(?:FALSE|TRUE)\.(?:_\w+)?/i,
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[ED][+-]?\d+)?(?:_\w+)?/i,
        keyword: [
            // Types
            /\b(?:CHARACTER|COMPLEX|DOUBLE ?PRECISION|INTEGER|LOGICAL|REAL)\b/i,
            // END statements
            /\b(?:END ?)?(?:BLOCK ?DATA|DO|FILE|FORALL|FUNCTION|IF|INTERFACE|MODULE(?! PROCEDURE)|PROGRAM|SELECT|SUBROUTINE|TYPE|WHERE)\b/i,
            // Statements
            /\b(?:ALLOCATABLE|ALLOCATE|BACKSPACE|CALL|CASE|CLOSE|COMMON|CONTAINS|CONTINUE|CYCLE|DATA|DEALLOCATE|DIMENSION|DO|END|EQUIVALENCE|EXIT|EXTERNAL|FORMAT|GO ?TO|IMPLICIT(?: NONE)?|INQUIRE|INTENT|INTRINSIC|MODULE PROCEDURE|NAMELIST|NULLIFY|OPEN|OPTIONAL|PARAMETER|POINTER|PRINT|PRIVATE|PUBLIC|READ|RETURN|REWIND|SAVE|SELECT|STOP|TARGET|WHILE|WRITE)\b/i,
            // Others
            /\b(?:ASSIGNMENT|DEFAULT|ELEMENTAL|ELSE|ELSEIF|ELSEWHERE|ENTRY|IN|INCLUDE|INOUT|KIND|NULL|ONLY|OPERATOR|OUT|PURE|RECURSIVE|RESULT|SEQUENCE|STAT|THEN|USE)\b/i
        ],
        operator: [
            /\*\*|\/\/|=>|[=\/]=|[<>]=?|::|[+\-*=%]|\.[A-Z]+\./i,
            {
                // Use lookbehind to prevent confusion with (/ /)
                pattern: /(^|(?!\().)\/(?!\))/,
                lookbehind: true
            }
        ],
        punctuation: /\(\/|\/\)|[(),;:&]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$1b6187306027f2b6$export$2e2bcd8739ae039.displayName = 'ftl';
$1b6187306027f2b6$export$2e2bcd8739ae039.aliases = [];
function $1b6187306027f2b6$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $a400735491c1aa4e$export$2e2bcd8739ae039));
    (function(Prism) {
        // https://freemarker.apache.org/docs/dgui_template_exp.html
        // FTL expression with 4 levels of nesting supported
        var FTL_EXPR = /[^<()"']|\((?:<expr>)*\)|<(?!#--)|<#--(?:[^-]|-(?!->))*-->|"(?:[^\\"]|\\.)*"|'(?:[^\\']|\\.)*'/.source;
        for(var i = 0; i < 2; i++)FTL_EXPR = FTL_EXPR.replace(/<expr>/g, function() {
            return FTL_EXPR;
        });
        FTL_EXPR = FTL_EXPR.replace(/<expr>/g, /[^\s\S]/.source);
        var ftl = {
            comment: /<#--[\s\S]*?-->/,
            string: [
                {
                    // raw string
                    pattern: /\br("|')(?:(?!\1)[^\\]|\\.)*\1/,
                    greedy: true
                },
                {
                    pattern: RegExp(/("|')(?:(?!\1|\$\{)[^\\]|\\.|\$\{(?:(?!\})(?:<expr>))*\})*\1/.source.replace(/<expr>/g, function() {
                        return FTL_EXPR;
                    })),
                    greedy: true,
                    inside: {
                        interpolation: {
                            pattern: RegExp(/((?:^|[^\\])(?:\\\\)*)\$\{(?:(?!\})(?:<expr>))*\}/.source.replace(/<expr>/g, function() {
                                return FTL_EXPR;
                            })),
                            lookbehind: true,
                            inside: {
                                'interpolation-punctuation': {
                                    pattern: /^\$\{|\}$/,
                                    alias: 'punctuation'
                                },
                                rest: null
                            }
                        }
                    }
                }
            ],
            keyword: /\b(?:as)\b/,
            boolean: /\b(?:false|true)\b/,
            'builtin-function': {
                pattern: /((?:^|[^?])\?\s*)\w+/,
                lookbehind: true,
                alias: 'function'
            },
            function: /\b\w+(?=\s*\()/,
            number: /\b\d+(?:\.\d+)?\b/,
            operator: /\.\.[<*!]?|->|--|\+\+|&&|\|\||\?{1,2}|[-+*/%!=<>]=?|\b(?:gt|gte|lt|lte)\b/,
            punctuation: /[,;.:()[\]{}]/
        };
        ftl.string[1].inside.interpolation.inside.rest = ftl;
        Prism.languages.ftl = {
            'ftl-comment': {
                // the pattern is shortened to be more efficient
                pattern: /^<#--[\s\S]*/,
                alias: 'comment'
            },
            'ftl-directive': {
                pattern: /^<[\s\S]+>$/,
                inside: {
                    directive: {
                        pattern: /(^<\/?)[#@][a-z]\w*/i,
                        lookbehind: true,
                        alias: 'keyword'
                    },
                    punctuation: /^<\/?|\/?>$/,
                    content: {
                        pattern: /\s*\S[\s\S]*/,
                        alias: 'ftl',
                        inside: ftl
                    }
                }
            },
            'ftl-interpolation': {
                pattern: /^\$\{[\s\S]*\}$/,
                inside: {
                    punctuation: /^\$\{|\}$/,
                    content: {
                        pattern: /\s*\S[\s\S]*/,
                        alias: 'ftl',
                        inside: ftl
                    }
                }
            }
        };
        Prism.hooks.add('before-tokenize', function(env) {
            // eslint-disable-next-line regexp/no-useless-lazy
            var pattern = RegExp(/<#--[\s\S]*?-->|<\/?[#@][a-zA-Z](?:<expr>)*?>|\$\{(?:<expr>)*?\}/.source.replace(/<expr>/g, function() {
                return FTL_EXPR;
            }), 'gi');
            Prism.languages['markup-templating'].buildPlaceholders(env, 'ftl', pattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'ftl');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$c0df2d899927fa32$export$2e2bcd8739ae039.displayName = 'gml';
$c0df2d899927fa32$export$2e2bcd8739ae039.aliases = [
    'gamemakerlanguage'
];
function $c0df2d899927fa32$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    Prism.languages.gamemakerlanguage = Prism.languages.gml = Prism.languages.extend('clike', {
        keyword: /\b(?:break|case|continue|default|do|else|enum|exit|for|globalvar|if|repeat|return|switch|until|var|while)\b/,
        number: /(?:\b0x[\da-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ulf]{0,4}/i,
        operator: /--|\+\+|[-+%/=]=?|!=|\*\*?=?|<[<=>]?|>[=>]?|&&?|\^\^?|\|\|?|~|\b(?:and|at|not|or|with|xor)\b/,
        constant: /\b(?:GM_build_date|GM_version|action_(?:continue|restart|reverse|stop)|all|gamespeed_(?:fps|microseconds)|global|local|noone|other|pi|pointer_(?:invalid|null)|self|timezone_(?:local|utc)|undefined|ev_(?:create|destroy|step|alarm|keyboard|mouse|collision|other|draw|draw_(?:begin|end|post|pre)|keypress|keyrelease|trigger|(?:left|middle|no|right)_button|(?:left|middle|right)_press|(?:left|middle|right)_release|mouse_(?:enter|leave|wheel_down|wheel_up)|global_(?:left|middle|right)_button|global_(?:left|middle|right)_press|global_(?:left|middle|right)_release|joystick(?:1|2)_(?:button1|button2|button3|button4|button5|button6|button7|button8|down|left|right|up)|outside|boundary|game_start|game_end|room_start|room_end|no_more_lives|animation_end|end_of_path|no_more_health|user\d|gui|gui_begin|gui_end|step_(?:begin|end|normal))|vk_(?:alt|anykey|backspace|control|delete|down|end|enter|escape|home|insert|left|nokey|pagedown|pageup|pause|printscreen|return|right|shift|space|tab|up|f\d|numpad\d|add|decimal|divide|lalt|lcontrol|lshift|multiply|ralt|rcontrol|rshift|subtract)|achievement_(?:filter_(?:all_players|favorites_only|friends_only)|friends_info|info|leaderboard_info|our_info|pic_loaded|show_(?:achievement|bank|friend_picker|leaderboard|profile|purchase_prompt|ui)|type_challenge|type_score_challenge)|asset_(?:font|object|path|room|script|shader|sound|sprite|tiles|timeline|unknown)|audio_(?:3d|falloff_(?:exponent_distance|exponent_distance_clamped|inverse_distance|inverse_distance_clamped|linear_distance|linear_distance_clamped|none)|mono|new_system|old_system|stereo)|bm_(?:add|complex|dest_alpha|dest_color|dest_colour|inv_dest_alpha|inv_dest_color|inv_dest_colour|inv_src_alpha|inv_src_color|inv_src_colour|max|normal|one|src_alpha|src_alpha_sat|src_color|src_colour|subtract|zero)|browser_(?:chrome|firefox|ie|ie_mobile|not_a_browser|opera|safari|safari_mobile|tizen|unknown|windows_store)|buffer_(?:bool|f16|f32|f64|fast|fixed|generalerror|grow|invalidtype|network|outofbounds|outofspace|s16|s32|s8|seek_end|seek_relative|seek_start|string|text|u16|u32|u64|u8|vbuffer|wrap)|c_(?:aqua|black|blue|dkgray|fuchsia|gray|green|lime|ltgray|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow)|cmpfunc_(?:always|equal|greater|greaterequal|less|lessequal|never|notequal)|cr_(?:appstart|arrow|beam|cross|default|drag|handpoint|hourglass|none|size_all|size_nesw|size_ns|size_nwse|size_we|uparrow)|cull_(?:clockwise|counterclockwise|noculling)|device_(?:emulator|tablet)|device_ios_(?:ipad|ipad_retina|iphone|iphone5|iphone6|iphone6plus|iphone_retina|unknown)|display_(?:landscape|landscape_flipped|portrait|portrait_flipped)|dll_(?:cdecl|cdel|stdcall)|ds_type_(?:grid|list|map|priority|queue|stack)|ef_(?:cloud|ellipse|explosion|firework|flare|rain|ring|smoke|smokeup|snow|spark|star)|fa_(?:archive|bottom|center|directory|hidden|left|middle|readonly|right|sysfile|top|volumeid)|fb_login_(?:default|fallback_to_webview|forcing_safari|forcing_webview|no_fallback_to_webview|use_system_account)|iap_(?:available|canceled|ev_consume|ev_product|ev_purchase|ev_restore|ev_storeload|failed|purchased|refunded|status_available|status_loading|status_processing|status_restoring|status_unavailable|status_uninitialised|storeload_failed|storeload_ok|unavailable)|leaderboard_type_(?:number|time_mins_secs)|lighttype_(?:dir|point)|matrix_(?:projection|view|world)|mb_(?:any|left|middle|none|right)|network_(?:config_(?:connect_timeout|disable_reliable_udp|enable_reliable_udp|use_non_blocking_socket)|socket_(?:bluetooth|tcp|udp)|type_(?:connect|data|disconnect|non_blocking_connect))|of_challenge_(?:lose|tie|win)|os_(?:android|ios|linux|macosx|ps3|ps4|psvita|unknown|uwp|win32|win8native|windows|winphone|xboxone)|phy_debug_render_(?:aabb|collision_pairs|coms|core_shapes|joints|obb|shapes)|phy_joint_(?:anchor_1_x|anchor_1_y|anchor_2_x|anchor_2_y|angle|angle_limits|damping_ratio|frequency|length_1|length_2|lower_angle_limit|max_force|max_length|max_motor_force|max_motor_torque|max_torque|motor_force|motor_speed|motor_torque|reaction_force_x|reaction_force_y|reaction_torque|speed|translation|upper_angle_limit)|phy_particle_data_flag_(?:category|color|colour|position|typeflags|velocity)|phy_particle_flag_(?:colormixing|colourmixing|elastic|powder|spring|tensile|viscous|wall|water|zombie)|phy_particle_group_flag_(?:rigid|solid)|pr_(?:linelist|linestrip|pointlist|trianglefan|trianglelist|trianglestrip)|ps_(?:distr|shape)_(?:diamond|ellipse|gaussian|invgaussian|line|linear|rectangle)|pt_shape_(?:circle|cloud|disk|explosion|flare|line|pixel|ring|smoke|snow|spark|sphere|square|star)|ty_(?:real|string)|gp_(?:face\d|axislh|axislv|axisrh|axisrv|padd|padl|padr|padu|select|shoulderl|shoulderlb|shoulderr|shoulderrb|start|stickl|stickr)|lb_disp_(?:none|numeric|time_ms|time_sec)|lb_sort_(?:ascending|descending|none)|ov_(?:achievements|community|friends|gamegroup|players|settings)|ugc_(?:filetype_(?:community|microtrans)|list_(?:Favorited|Followed|Published|Subscribed|UsedOrPlayed|VotedDown|VotedOn|VotedUp|WillVoteLater)|match_(?:AllGuides|Artwork|Collections|ControllerBindings|IntegratedGuides|Items|Items_Mtx|Items_ReadyToUse|Screenshots|UsableInGame|Videos|WebGuides)|query_(?:AcceptedForGameRankedByAcceptanceDate|CreatedByFriendsRankedByPublicationDate|FavoritedByFriendsRankedByPublicationDate|NotYetRated)|query_RankedBy(?:NumTimesReported|PublicationDate|TextSearch|TotalVotesAsc|Trend|Vote|VotesUp)|result_success|sortorder_CreationOrder(?:Asc|Desc)|sortorder_(?:ForModeration|LastUpdatedDesc|SubscriptionDateDesc|TitleAsc|VoteScoreDesc)|visibility_(?:friends_only|private|public))|vertex_usage_(?:binormal|blendindices|blendweight|color|colour|depth|fog|normal|position|psize|sample|tangent|texcoord|textcoord)|vertex_type_(?:float\d|color|colour|ubyte4)|input_type|layerelementtype_(?:background|instance|oldtilemap|particlesystem|sprite|tile|tilemap|undefined)|se_(?:chorus|compressor|echo|equalizer|flanger|gargle|none|reverb)|text_type|tile_(?:flip|index_mask|mirror|rotate)|(?:obj|rm|scr|spr)\w+)\b/,
        variable: /\b(?:alarm|application_surface|async_load|background_(?:alpha|blend|color|colour|foreground|height|hspeed|htiled|index|showcolor|showcolour|visible|vspeed|vtiled|width|x|xscale|y|yscale)|bbox_(?:bottom|left|right|top)|browser_(?:height|width)|caption_(?:health|lives|score)|current_(?:day|hour|minute|month|second|time|weekday|year)|cursor_sprite|debug_mode|delta_time|direction|display_aa|error_(?:last|occurred)|event_(?:action|number|object|type)|fps|fps_real|friction|game_(?:display|project|save)_(?:id|name)|gamemaker_(?:pro|registered|version)|gravity|gravity_direction|(?:h|v)speed|health|iap_data|id|image_(?:alpha|angle|blend|depth|index|number|speed|xscale|yscale)|instance_(?:count|id)|keyboard_(?:key|lastchar|lastkey|string)|layer|lives|mask_index|mouse_(?:button|lastbutton|x|y)|object_index|os_(?:browser|device|type|version)|path_(?:endaction|index|orientation|position|positionprevious|scale|speed)|persistent|phy_(?:rotation|(?:col_normal|collision|com|linear_velocity|position|speed)_(?:x|y)|angular_(?:damping|velocity)|position_(?:x|y)previous|speed|linear_damping|bullet|fixed_rotation|active|mass|inertia|dynamic|kinematic|sleeping|collision_points)|pointer_(?:invalid|null)|room|room_(?:caption|first|height|last|persistent|speed|width)|score|secure_mode|show_(?:health|lives|score)|solid|speed|sprite_(?:height|index|width|xoffset|yoffset)|temp_directory|timeline_(?:index|loop|position|running|speed)|transition_(?:color|kind|steps)|undefined|view_(?:angle|current|enabled|(?:h|v)(?:border|speed)|(?:h|w|x|y)port|(?:h|w|x|y)view|object|surface_id|visible)|visible|webgl_enabled|working_directory|(?:x|y)(?:previous|start)|x|y|argument(?:_relitive|_count|\d)|argument|global|local|other|self)\b/
    });
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $9da0023f8b18122c$export$2e2bcd8739ae039.displayName = 'gap';
$9da0023f8b18122c$export$2e2bcd8739ae039.aliases = [];
function $9da0023f8b18122c$export$2e2bcd8739ae039(Prism) {
    // https://www.gap-system.org/Manuals/doc/ref/chap4.html
    // https://www.gap-system.org/Manuals/doc/ref/chap27.html
    Prism.languages.gap = {
        shell: {
            pattern: /^gap>[\s\S]*?(?=^gap>|$(?![\s\S]))/m,
            greedy: true,
            inside: {
                gap: {
                    pattern: /^(gap>).+(?:(?:\r(?:\n|(?!\n))|\n)>.*)*/,
                    lookbehind: true,
                    inside: null // see below
                },
                punctuation: /^gap>/
            }
        },
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\'"])(?:'(?:[^\r\n\\']|\\.){1,10}'|"(?:[^\r\n\\"]|\\.)*"(?!")|"""[\s\S]*?""")/,
            lookbehind: true,
            greedy: true,
            inside: {
                continuation: {
                    pattern: /([\r\n])>/,
                    lookbehind: true,
                    alias: 'punctuation'
                }
            }
        },
        keyword: /\b(?:Assert|Info|IsBound|QUIT|TryNextMethod|Unbind|and|atomic|break|continue|do|elif|else|end|fi|for|function|if|in|local|mod|not|od|or|quit|readonly|readwrite|rec|repeat|return|then|until|while)\b/,
        boolean: /\b(?:false|true)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: {
            pattern: /(^|[^\w.]|\.\.)(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?(?:_[a-z]?)?(?=$|[^\w.]|\.\.)/,
            lookbehind: true
        },
        continuation: {
            pattern: /([\r\n])>/,
            lookbehind: true,
            alias: 'punctuation'
        },
        operator: /->|[-+*/^~=!]|<>|[<>]=?|:=|\.\./,
        punctuation: /[()[\]{},;.:]/
    };
    Prism.languages.gap.shell.inside.gap.inside = Prism.languages.gap;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $1180e16820c68a4b$export$2e2bcd8739ae039.displayName = 'gcode';
$1180e16820c68a4b$export$2e2bcd8739ae039.aliases = [];
function $1180e16820c68a4b$export$2e2bcd8739ae039(Prism) {
    Prism.languages.gcode = {
        comment: /;.*|\B\(.*?\)\B/,
        string: {
            pattern: /"(?:""|[^"])*"/,
            greedy: true
        },
        keyword: /\b[GM]\d+(?:\.\d+)?\b/,
        property: /\b[A-Z]/,
        checksum: {
            pattern: /(\*)\d+/,
            lookbehind: true,
            alias: 'number'
        },
        // T0:0:0
        punctuation: /[:*]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $d9207b1e3b2f4a30$export$2e2bcd8739ae039.displayName = 'gdscript';
$d9207b1e3b2f4a30$export$2e2bcd8739ae039.aliases = [];
function $d9207b1e3b2f4a30$export$2e2bcd8739ae039(Prism) {
    Prism.languages.gdscript = {
        comment: /#.*/,
        string: {
            pattern: /@?(?:("|')(?:(?!\1)[^\n\\]|\\[\s\S])*\1(?!"|')|"""(?:[^\\]|\\[\s\S])*?""")/,
            greedy: true
        },
        'class-name': {
            // class_name Foo, extends Bar, class InnerClass
            // export(int) var baz, export(int, 0) var i
            // as Node
            // const FOO: int = 9, var bar: bool = true
            // func add(reference: Item, amount: int) -> Item:
            pattern: /(^(?:class|class_name|extends)[ \t]+|^export\([ \t]*|\bas[ \t]+|(?:\b(?:const|var)[ \t]|[,(])[ \t]*\w+[ \t]*:[ \t]*|->[ \t]*)[a-zA-Z_]\w*/m,
            lookbehind: true
        },
        keyword: /\b(?:and|as|assert|break|breakpoint|class|class_name|const|continue|elif|else|enum|export|extends|for|func|if|in|is|master|mastersync|match|not|null|onready|or|pass|preload|puppet|puppetsync|remote|remotesync|return|self|setget|signal|static|tool|var|while|yield)\b/,
        function: /\b[a-z_]\w*(?=[ \t]*\()/i,
        variable: /\$\w+/,
        number: [
            /\b0b[01_]+\b|\b0x[\da-fA-F_]+\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.[\d_]+)(?:e[+-]?[\d_]+)?\b/,
            /\b(?:INF|NAN|PI|TAU)\b/
        ],
        constant: /\b[A-Z][A-Z_\d]*\b/,
        boolean: /\b(?:false|true)\b/,
        operator: /->|:=|&&|\|\||<<|>>|[-+*/%&|!<>=]=?|[~^]/,
        punctuation: /[.:,;()[\]{}]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $6e91e40129219b4e$export$2e2bcd8739ae039.displayName = 'gedcom';
$6e91e40129219b4e$export$2e2bcd8739ae039.aliases = [];
function $6e91e40129219b4e$export$2e2bcd8739ae039(Prism) {
    Prism.languages.gedcom = {
        'line-value': {
            // Preceded by level, optional pointer, and tag
            pattern: /(^[\t ]*\d+ +(?:@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@ +)?\w+ ).+/m,
            lookbehind: true,
            inside: {
                pointer: {
                    pattern: /^@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@$/,
                    alias: 'variable'
                }
            }
        },
        record: {
            // Preceded by level and optional pointer
            pattern: /(^[\t ]*\d+ +(?:@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@ +)?)\w+/m,
            lookbehind: true,
            alias: 'tag'
        },
        level: {
            pattern: /(^[\t ]*)\d+/m,
            lookbehind: true,
            alias: 'number'
        },
        pointer: {
            pattern: /@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@/,
            alias: 'variable'
        }
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $6b2780e9071d1692$export$2e2bcd8739ae039.displayName = 'gettext';
$6b2780e9071d1692$export$2e2bcd8739ae039.aliases = [
    'po'
];
function $6b2780e9071d1692$export$2e2bcd8739ae039(Prism) {
    Prism.languages.gettext = {
        comment: [
            {
                pattern: /# .*/,
                greedy: true,
                alias: 'translator-comment'
            },
            {
                pattern: /#\..*/,
                greedy: true,
                alias: 'extracted-comment'
            },
            {
                pattern: /#:.*/,
                greedy: true,
                alias: 'reference-comment'
            },
            {
                pattern: /#,.*/,
                greedy: true,
                alias: 'flag-comment'
            },
            {
                pattern: /#\|.*/,
                greedy: true,
                alias: 'previously-untranslated-comment'
            },
            {
                pattern: /#.*/,
                greedy: true
            }
        ],
        string: {
            pattern: /(^|[^\\])"(?:[^"\\]|\\.)*"/,
            lookbehind: true,
            greedy: true
        },
        keyword: /^msg(?:ctxt|id|id_plural|str)\b/m,
        number: /\b\d+\b/,
        punctuation: /[\[\]]/
    };
    Prism.languages.po = Prism.languages.gettext;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $ae0c3767cd329fa7$export$2e2bcd8739ae039.displayName = 'gherkin';
$ae0c3767cd329fa7$export$2e2bcd8739ae039.aliases = [];
function $ae0c3767cd329fa7$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var tableRow = /(?:\r?\n|\r)[ \t]*\|.+\|(?:(?!\|).)*/.source;
        Prism.languages.gherkin = {
            pystring: {
                pattern: /("""|''')[\s\S]+?\1/,
                alias: 'string'
            },
            comment: {
                pattern: /(^[ \t]*)#.*/m,
                lookbehind: true
            },
            tag: {
                pattern: /(^[ \t]*)@\S*/m,
                lookbehind: true
            },
            feature: {
                pattern: /((?:^|\r?\n|\r)[ \t]*)(?:Ability|Ahoy matey!|Arwedd|Aspekt|Besigheid Behoefte|Business Need|Caracteristica|Característica|Egenskab|Egenskap|Eiginleiki|Feature|Fīča|Fitur|Fonctionnalité|Fonksyonalite|Funcionalidade|Funcionalitat|Functionalitate|Funcţionalitate|Funcționalitate|Functionaliteit|Fungsi|Funkcia|Funkcija|Funkcionalitāte|Funkcionalnost|Funkcja|Funksie|Funktionalität|Funktionalitéit|Funzionalità|Hwaet|Hwæt|Jellemző|Karakteristik|Lastnost|Mak|Mogucnost|laH|Mogućnost|Moznosti|Možnosti|OH HAI|Omadus|Ominaisuus|Osobina|Özellik|Potrzeba biznesowa|perbogh|poQbogh malja'|Požadavek|Požiadavka|Pretty much|Qap|Qu'meH 'ut|Savybė|Tính năng|Trajto|Vermoë|Vlastnosť|Właściwość|Značilnost|Δυνατότητα|Λειτουργία|Могућност|Мөмкинлек|Особина|Свойство|Үзенчәлеклелек|Функционал|Функционалност|Функция|Функціонал|תכונה|خاصية|خصوصیت|صلاحیت|کاروبار کی ضرورت|وِیژگی|रूप लेख|ਖਾਸੀਅਤ|ਨਕਸ਼ ਨੁਹਾਰ|ਮੁਹਾਂਦਰਾ|గుణము|ಹೆಚ್ಚಳ|ความต้องการทางธุรกิจ|ความสามารถ|โครงหลัก|기능|フィーチャ|功能|機能):(?:[^:\r\n]+(?:\r?\n|\r|$))*/,
                lookbehind: true,
                inside: {
                    important: {
                        pattern: /(:)[^\r\n]+/,
                        lookbehind: true
                    },
                    keyword: /[^:\r\n]+:/
                }
            },
            scenario: {
                pattern: /(^[ \t]*)(?:Abstract Scenario|Abstrakt Scenario|Achtergrond|Aer|Ær|Agtergrond|All y'all|Antecedentes|Antecedents|Atburðarás|Atburðarásir|Awww, look mate|B4|Background|Baggrund|Bakgrund|Bakgrunn|Bakgrunnur|Beispiele|Beispiller|Bối cảnh|Cefndir|Cenario|Cenário|Cenario de Fundo|Cenário de Fundo|Cenarios|Cenários|Contesto|Context|Contexte|Contexto|Conto|Contoh|Contone|Dæmi|Dasar|Dead men tell no tales|Delineacao do Cenario|Delineação do Cenário|Dis is what went down|Dữ liệu|Dyagram Senaryo|Dyagram senaryo|Egzanp|Ejemplos|Eksempler|Ekzemploj|Enghreifftiau|Esbozo do escenario|Escenari|Escenario|Esempi|Esquema de l'escenari|Esquema del escenario|Esquema do Cenario|Esquema do Cenário|EXAMPLZ|Examples|Exempel|Exemple|Exemples|Exemplos|First off|Fono|Forgatókönyv|Forgatókönyv vázlat|Fundo|Geçmiş|Grundlage|Hannergrond|ghantoH|Háttér|Heave to|Istorik|Juhtumid|Keadaan|Khung kịch bản|Khung tình huống|Kịch bản|Koncept|Konsep skenario|Kontèks|Kontekst|Kontekstas|Konteksts|Kontext|Konturo de la scenaro|Latar Belakang|lut chovnatlh|lut|lutmey|Lýsing Atburðarásar|Lýsing Dæma|MISHUN SRSLY|MISHUN|Menggariskan Senario|mo'|Náčrt Scenára|Náčrt Scénáře|Náčrt Scenáru|Oris scenarija|Örnekler|Osnova|Osnova Scenára|Osnova scénáře|Osnutek|Ozadje|Paraugs|Pavyzdžiai|Példák|Piemēri|Plan du scénario|Plan du Scénario|Plan Senaryo|Plan senaryo|Plang vum Szenario|Pozadí|Pozadie|Pozadina|Príklady|Příklady|Primer|Primeri|Primjeri|Przykłady|Raamstsenaarium|Reckon it's like|Rerefons|Scenár|Scénář|Scenarie|Scenarij|Scenarijai|Scenarijaus šablonas|Scenariji|Scenārijs|Scenārijs pēc parauga|Scenarijus|Scenario|Scénario|Scenario Amlinellol|Scenario Outline|Scenario Template|Scenariomal|Scenariomall|Scenarios|Scenariu|Scenariusz|Scenaro|Schema dello scenario|Se ðe|Se the|Se þe|Senario|Senaryo Deskripsyon|Senaryo deskripsyon|Senaryo|Senaryo taslağı|Shiver me timbers|Situācija|Situai|Situasie Uiteensetting|Situasie|Skenario konsep|Skenario|Skica|Structura scenariu|Structură scenariu|Struktura scenarija|Stsenaarium|Swa hwaer swa|Swa|Swa hwær swa|Szablon scenariusza|Szenario|Szenariogrundriss|Tapaukset|Tapaus|Tapausaihio|Taust|Tausta|Template Keadaan|Template Senario|Template Situai|The thing of it is|Tình huống|Variantai|Voorbeelde|Voorbeelden|Wharrimean is|Yo-ho-ho|You'll wanna|Założenia|Παραδείγματα|Περιγραφή Σεναρίου|Σενάρια|Σενάριο|Υπόβαθρο|Кереш|Контекст|Концепт|Мисаллар|Мисоллар|Основа|Передумова|Позадина|Предистория|Предыстория|Приклади|Пример|Примери|Примеры|Рамка на сценарий|Скица|Структура сценарија|Структура сценария|Структура сценарію|Сценарий|Сценарий структураси|Сценарийның төзелеше|Сценарији|Сценарио|Сценарій|Тарих|Үрнәкләр|דוגמאות|רקע|תבנית תרחיש|תרחיש|الخلفية|الگوی سناریو|امثلة|پس منظر|زمینه|سناریو|سيناريو|سيناريو مخطط|مثالیں|منظر نامے کا خاکہ|منظرنامہ|نمونه ها|उदाहरण|परिदृश्य|परिदृश्य रूपरेखा|पृष्ठभूमि|ਉਦਾਹਰਨਾਂ|ਪਟਕਥਾ|ਪਟਕਥਾ ਢਾਂਚਾ|ਪਟਕਥਾ ਰੂਪ ਰੇਖਾ|ਪਿਛੋਕੜ|ఉదాహరణలు|కథనం|నేపథ్యం|సన్నివేశం|ಉದಾಹರಣೆಗಳು|ಕಥಾಸಾರಾಂಶ|ವಿವರಣೆ|ಹಿನ್ನೆಲೆ|โครงสร้างของเหตุการณ์|ชุดของตัวอย่าง|ชุดของเหตุการณ์|แนวคิด|สรุปเหตุการณ์|เหตุการณ์|배경|시나리오|시나리오 개요|예|サンプル|シナリオ|シナリオアウトライン|シナリオテンプレ|シナリオテンプレート|テンプレ|例|例子|剧本|剧本大纲|劇本|劇本大綱|场景|场景大纲|場景|場景大綱|背景):[^:\r\n]*/m,
                lookbehind: true,
                inside: {
                    important: {
                        pattern: /(:)[^\r\n]*/,
                        lookbehind: true
                    },
                    keyword: /[^:\r\n]+:/
                }
            },
            'table-body': {
                // Look-behind is used to skip the table head, which has the same format as any table row
                pattern: RegExp('(' + tableRow + ')(?:' + tableRow + ')+'),
                lookbehind: true,
                inside: {
                    outline: {
                        pattern: /<[^>]+>/,
                        alias: 'variable'
                    },
                    td: {
                        pattern: /\s*[^\s|][^|]*/,
                        alias: 'string'
                    },
                    punctuation: /\|/
                }
            },
            'table-head': {
                pattern: RegExp(tableRow),
                inside: {
                    th: {
                        pattern: /\s*[^\s|][^|]*/,
                        alias: 'variable'
                    },
                    punctuation: /\|/
                }
            },
            atrule: {
                pattern: /(^[ \t]+)(?:'a|'ach|'ej|7|a|A také|A taktiež|A tiež|A zároveň|Aber|Ac|Adott|Akkor|Ak|Aleshores|Ale|Ali|Allora|Alors|Als|Ama|Amennyiben|Amikor|Ampak|an|AN|Ananging|And y'all|And|Angenommen|Anrhegedig a|An|Apabila|Atès|Atesa|Atunci|Avast!|Aye|A|awer|Bagi|Banjur|Bet|Biết|Blimey!|Buh|But at the end of the day I reckon|But y'all|But|BUT|Cal|Când|Cand|Cando|Ce|Cuando|Če|Ða ðe|Ða|Dadas|Dada|Dados|Dado|DaH ghu' bejlu'|dann|Dann|Dano|Dan|Dar|Dat fiind|Data|Date fiind|Date|Dati fiind|Dati|Daţi fiind|Dați fiind|DEN|Dato|De|Den youse gotta|Dengan|Diberi|Diyelim ki|Donada|Donat|Donitaĵo|Do|Dun|Duota|Ðurh|Eeldades|Ef|Eğer ki|Entao|Então|Entón|E|En|Entonces|Epi|És|Etant donnée|Etant donné|Et|Étant données|Étant donnée|Étant donné|Etant données|Etant donnés|Étant donnés|Fakat|Gangway!|Gdy|Gegeben seien|Gegeben sei|Gegeven|Gegewe|ghu' noblu'|Gitt|Given y'all|Given|Givet|Givun|Ha|Cho|I CAN HAZ|In|Ir|It's just unbelievable|I|Ja|Jeśli|Jeżeli|Kad|Kada|Kadar|Kai|Kaj|Když|Keď|Kemudian|Ketika|Khi|Kiedy|Ko|Kuid|Kui|Kun|Lan|latlh|Le sa a|Let go and haul|Le|Lè sa a|Lè|Logo|Lorsqu'<|Lorsque|mä|Maar|Mais|Mając|Ma|Majd|Maka|Manawa|Mas|Men|Menawa|Mutta|Nalika|Nalikaning|Nanging|Når|När|Nato|Nhưng|Niin|Njuk|O zaman|Och|Og|Oletetaan|Ond|Onda|Oraz|Pak|Pero|Però|Podano|Pokiaľ|Pokud|Potem|Potom|Privzeto|Pryd|Quan|Quand|Quando|qaSDI'|Så|Sed|Se|Siis|Sipoze ke|Sipoze Ke|Sipoze|Si|Şi|Și|Soit|Stel|Tada|Tad|Takrat|Tak|Tapi|Ter|Tetapi|Tha the|Tha|Then y'all|Then|Thì|Thurh|Toda|Too right|Un|Und|ugeholl|Và|vaj|Vendar|Ve|wann|Wanneer|WEN|Wenn|When y'all|When|Wtedy|Wun|Y'know|Yeah nah|Yna|Youse know like when|Youse know when youse got|Y|Za predpokladu|Za předpokladu|Zadan|Zadani|Zadano|Zadate|Zadato|Zakładając|Zaradi|Zatati|Þa þe|Þa|Þá|Þegar|Þurh|Αλλά|Δεδομένου|Και|Όταν|Τότε|А також|Агар|Але|Али|Аммо|А|Әгәр|Әйтик|Әмма|Бирок|Ва|Вә|Дадено|Дано|Допустим|Если|Задате|Задати|Задато|И|І|К тому же|Када|Кад|Когато|Когда|Коли|Ләкин|Лекин|Нәтиҗәдә|Нехай|Но|Онда|Припустимо, що|Припустимо|Пусть|Также|Та|Тогда|Тоді|То|Унда|Һәм|Якщо|אבל|אזי|אז|בהינתן|וגם|כאשר|آنگاه|اذاً|اگر|اما|اور|با فرض|بالفرض|بفرض|پھر|تب|ثم|جب|عندما|فرض کیا|لكن|لیکن|متى|هنگامی|و|अगर|और|कदा|किन्तु|चूंकि|जब|तथा|तदा|तब|परन्तु|पर|यदि|ਅਤੇ|ਜਦੋਂ|ਜਿਵੇਂ ਕਿ|ਜੇਕਰ|ਤਦ|ਪਰ|అప్పుడు|ఈ పరిస్థితిలో|కాని|చెప్పబడినది|మరియు|ಆದರೆ|ನಂತರ|ನೀಡಿದ|ಮತ್ತು|ಸ್ಥಿತಿಯನ್ನು|กำหนดให้|ดังนั้น|แต่|เมื่อ|และ|그러면<|그리고<|단<|만약<|만일<|먼저<|조건<|하지만<|かつ<|しかし<|ただし<|ならば<|もし<|並且<|但し<|但是<|假如<|假定<|假設<|假设<|前提<|同时<|同時<|并且<|当<|當<|而且<|那么<|那麼<)(?=[ \t])/m,
                lookbehind: true
            },
            string: {
                pattern: /"(?:\\.|[^"\\\r\n])*"|'(?:\\.|[^'\\\r\n])*'/,
                inside: {
                    outline: {
                        pattern: /<[^>]+>/,
                        alias: 'variable'
                    }
                }
            },
            outline: {
                pattern: /<[^>]+>/,
                alias: 'variable'
            }
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $1d9d3eed717d4843$export$2e2bcd8739ae039.displayName = 'git';
$1d9d3eed717d4843$export$2e2bcd8739ae039.aliases = [];
function $1d9d3eed717d4843$export$2e2bcd8739ae039(Prism) {
    Prism.languages.git = {
        /*
     * A simple one line comment like in a git status command
     * For instance:
     * $ git status
     * # On branch infinite-scroll
     * # Your branch and 'origin/sharedBranches/frontendTeam/infinite-scroll' have diverged,
     * # and have 1 and 2 different commits each, respectively.
     * nothing to commit (working directory clean)
     */ comment: /^#.*/m,
        /*
     * Regexp to match the changed lines in a git diff output. Check the example below.
     */ deleted: /^[-–].*/m,
        inserted: /^\+.*/m,
        /*
     * a string (double and simple quote)
     */ string: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        /*
     * a git command. It starts with a random prompt finishing by a $, then "git" then some other parameters
     * For instance:
     * $ git add file.txt
     */ command: {
            pattern: /^.*\$ git .*$/m,
            inside: {
                /*
         * A git command can contain a parameter starting by a single or a double dash followed by a string
         * For instance:
         * $ git diff --cached
         * $ git log -p
         */ parameter: /\s--?\w+/
            }
        },
        /*
     * Coordinates displayed in a git diff command
     * For instance:
     * $ git diff
     * diff --git file.txt file.txt
     * index 6214953..1d54a52 100644
     * --- file.txt
     * +++ file.txt
     * @@ -1 +1,2 @@
     * -Here's my tetx file
     * +Here's my text file
     * +And this is the second line
     */ coord: /^@@.*@@$/m,
        /*
     * Match a "commit [SHA1]" line in a git log output.
     * For instance:
     * $ git log
     * commit a11a14ef7e26f2ca62d4b35eac455ce636d0dc09
     * Author: lgiraudel
     * Date:   Mon Feb 17 11:18:34 2014 +0100
     *
     *     Add of a new line
     */ 'commit-sha1': /^commit \w{40}$/m
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$fd4037dcd4da1450$export$2e2bcd8739ae039.displayName = 'glsl';
$fd4037dcd4da1450$export$2e2bcd8739ae039.aliases = [];
function $fd4037dcd4da1450$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $e064275ae5958777$export$2e2bcd8739ae039));
    Prism.languages.glsl = Prism.languages.extend('c', {
        keyword: /\b(?:active|asm|atomic_uint|attribute|[ibdu]?vec[234]|bool|break|buffer|case|cast|centroid|class|coherent|common|const|continue|d?mat[234](?:x[234])?|default|discard|do|double|else|enum|extern|external|false|filter|fixed|flat|float|for|fvec[234]|goto|half|highp|hvec[234]|[iu]?sampler2DMS(?:Array)?|[iu]?sampler2DRect|[iu]?samplerBuffer|[iu]?samplerCube|[iu]?samplerCubeArray|[iu]?sampler[123]D|[iu]?sampler[12]DArray|[iu]?image2DMS(?:Array)?|[iu]?image2DRect|[iu]?imageBuffer|[iu]?imageCube|[iu]?imageCubeArray|[iu]?image[123]D|[iu]?image[12]DArray|if|in|inline|inout|input|int|interface|invariant|layout|long|lowp|mediump|namespace|noinline|noperspective|out|output|partition|patch|precise|precision|public|readonly|resource|restrict|return|sample|sampler[12]DArrayShadow|sampler[12]DShadow|sampler2DRectShadow|sampler3DRect|samplerCubeArrayShadow|samplerCubeShadow|shared|short|sizeof|smooth|static|struct|subroutine|superp|switch|template|this|true|typedef|uint|uniform|union|unsigned|using|varying|void|volatile|while|writeonly)\b/
    });
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $b9e8ba6248f02e58$export$2e2bcd8739ae039.displayName = 'gn';
$b9e8ba6248f02e58$export$2e2bcd8739ae039.aliases = [
    'gni'
];
function $b9e8ba6248f02e58$export$2e2bcd8739ae039(Prism) {
    // https://gn.googlesource.com/gn/+/refs/heads/main/docs/reference.md#grammar
    Prism.languages.gn = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        'string-literal': {
            pattern: /(^|[^\\"])"(?:[^\r\n"\\]|\\.)*"/,
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\{[\s\S]*?\}|[a-zA-Z_]\w*|0x[a-fA-F0-9]{2})/,
                    lookbehind: true,
                    inside: {
                        number: /^\$0x[\s\S]{2}$/,
                        variable: /^\$\w+$/,
                        'interpolation-punctuation': {
                            pattern: /^\$\{|\}$/,
                            alias: 'punctuation'
                        },
                        expression: {
                            pattern: /[\s\S]+/,
                            inside: null // see below
                        }
                    }
                },
                string: /[\s\S]+/
            }
        },
        keyword: /\b(?:else|if)\b/,
        boolean: /\b(?:false|true)\b/,
        'builtin-function': {
            // a few functions get special highlighting to improve readability
            pattern: /\b(?:assert|defined|foreach|import|pool|print|template|tool|toolchain)(?=\s*\()/i,
            alias: 'keyword'
        },
        function: /\b[a-z_]\w*(?=\s*\()/i,
        constant: /\b(?:current_cpu|current_os|current_toolchain|default_toolchain|host_cpu|host_os|root_build_dir|root_gen_dir|root_out_dir|target_cpu|target_gen_dir|target_os|target_out_dir)\b/,
        number: /-?\b\d+\b/,
        operator: /[-+!=<>]=?|&&|\|\|/,
        punctuation: /[(){}[\],.]/
    };
    Prism.languages.gn['string-literal'].inside['interpolation'].inside['expression'].inside = Prism.languages.gn;
    Prism.languages.gni = Prism.languages.gn;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $f1312a50584a5846$export$2e2bcd8739ae039.displayName = 'linker-script';
$f1312a50584a5846$export$2e2bcd8739ae039.aliases = [
    'ld'
];
function $f1312a50584a5846$export$2e2bcd8739ae039(Prism) {
    Prism.languages['linker-script'] = {
        comment: {
            pattern: /(^|\s)\/\*[\s\S]*?(?:$|\*\/)/,
            lookbehind: true,
            greedy: true
        },
        identifier: {
            pattern: /"[^"\r\n]*"/,
            greedy: true
        },
        'location-counter': {
            pattern: /\B\.\B/,
            alias: 'important'
        },
        section: {
            pattern: /(^|[^\w*])\.\w+\b/,
            lookbehind: true,
            alias: 'keyword'
        },
        function: /\b[A-Z][A-Z_]*(?=\s*\()/,
        number: /\b(?:0[xX][a-fA-F0-9]+|\d+)[KM]?\b/,
        operator: />>=?|<<=?|->|\+\+|--|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?/,
        punctuation: /[(){},;]/
    };
    Prism.languages['ld'] = Prism.languages['linker-script'];
}



// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $44f129dcd2f3d3cd$export$2e2bcd8739ae039.displayName = 'go-module';
$44f129dcd2f3d3cd$export$2e2bcd8739ae039.aliases = [
    'go-mod'
];
function $44f129dcd2f3d3cd$export$2e2bcd8739ae039(Prism) {
    // https://go.dev/ref/mod#go-mod-file-module
    Prism.languages['go-mod'] = Prism.languages['go-module'] = {
        comment: {
            pattern: /\/\/.*/,
            greedy: true
        },
        version: {
            pattern: /(^|[\s()[\],])v\d+\.\d+\.\d+(?:[+-][-+.\w]*)?(?![^\s()[\],])/,
            lookbehind: true,
            alias: 'number'
        },
        'go-version': {
            pattern: /((?:^|\s)go\s+)\d+(?:\.\d+){1,2}/,
            lookbehind: true,
            alias: 'number'
        },
        keyword: {
            pattern: /^([ \t]*)(?:exclude|go|module|replace|require|retract)\b/m,
            lookbehind: true
        },
        operator: /=>/,
        punctuation: /[()[\],]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$266db073fe988064$export$2e2bcd8739ae039.displayName = 'gradle';
$266db073fe988064$export$2e2bcd8739ae039.aliases = [];
function $266db073fe988064$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    (function(Prism) {
        var interpolation = {
            pattern: /((?:^|[^\\$])(?:\\{2})*)\$(?:\w+|\{[^{}]*\})/,
            lookbehind: true,
            inside: {
                'interpolation-punctuation': {
                    pattern: /^\$\{?|\}$/,
                    alias: 'punctuation'
                },
                expression: {
                    pattern: /[\s\S]+/,
                    inside: null
                }
            }
        };
        Prism.languages.gradle = Prism.languages.extend('clike', {
            string: {
                pattern: /'''(?:[^\\]|\\[\s\S])*?'''|'(?:\\.|[^\\'\r\n])*'/,
                greedy: true
            },
            keyword: /\b(?:apply|def|dependencies|else|if|implementation|import|plugin|plugins|project|repositories|repository|sourceSets|tasks|val)\b/,
            number: /\b(?:0b[01_]+|0x[\da-f_]+(?:\.[\da-f_p\-]+)?|[\d_]+(?:\.[\d_]+)?(?:e[+-]?\d+)?)[glidf]?\b/i,
            operator: {
                pattern: /(^|[^.])(?:~|==?~?|\?[.:]?|\*(?:[.=]|\*=?)?|\.[@&]|\.\.<|\.\.(?!\.)|-[-=>]?|\+[+=]?|!=?|<(?:<=?|=>?)?|>(?:>>?=?|=)?|&[&=]?|\|[|=]?|\/=?|\^=?|%=?)/,
                lookbehind: true
            },
            punctuation: /\.+|[{}[\];(),:$]/
        });
        Prism.languages.insertBefore('gradle', 'string', {
            shebang: {
                pattern: /#!.+/,
                alias: 'comment',
                greedy: true
            },
            'interpolation-string': {
                pattern: /"""(?:[^\\]|\\[\s\S])*?"""|(["/])(?:\\.|(?!\1)[^\\\r\n])*\1|\$\/(?:[^/$]|\$(?:[/$]|(?![/$]))|\/(?!\$))*\/\$/,
                greedy: true,
                inside: {
                    interpolation: interpolation,
                    string: /[\s\S]+/
                }
            }
        });
        Prism.languages.insertBefore('gradle', 'punctuation', {
            'spock-block': /\b(?:and|cleanup|expect|given|setup|then|when|where):/
        });
        Prism.languages.insertBefore('gradle', 'function', {
            annotation: {
                pattern: /(^|[^.])@\w+/,
                lookbehind: true,
                alias: 'punctuation'
            }
        });
        interpolation.inside.expression.inside = Prism.languages.gradle;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $d9761534803b6b12$export$2e2bcd8739ae039.displayName = 'graphql';
$d9761534803b6b12$export$2e2bcd8739ae039.aliases = [];
function $d9761534803b6b12$export$2e2bcd8739ae039(Prism) {
    Prism.languages.graphql = {
        comment: /#.*/,
        description: {
            pattern: /(?:"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*")(?=\s*[a-z_])/i,
            greedy: true,
            alias: 'string',
            inside: {
                'language-markdown': {
                    pattern: /(^"(?:"")?)(?!\1)[\s\S]+(?=\1$)/,
                    lookbehind: true,
                    inside: Prism.languages.markdown
                }
            }
        },
        string: {
            pattern: /"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*"/,
            greedy: true
        },
        number: /(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
        boolean: /\b(?:false|true)\b/,
        variable: /\$[a-z_]\w*/i,
        directive: {
            pattern: /@[a-z_]\w*/i,
            alias: 'function'
        },
        'attr-name': {
            pattern: /\b[a-z_]\w*(?=\s*(?:\((?:[^()"]|"(?:\\.|[^\\"\r\n])*")*\))?:)/i,
            greedy: true
        },
        'atom-input': {
            pattern: /\b[A-Z]\w*Input\b/,
            alias: 'class-name'
        },
        scalar: /\b(?:Boolean|Float|ID|Int|String)\b/,
        constant: /\b[A-Z][A-Z_\d]*\b/,
        'class-name': {
            pattern: /(\b(?:enum|implements|interface|on|scalar|type|union)\s+|&\s*|:\s*|\[)[A-Z_]\w*/,
            lookbehind: true
        },
        fragment: {
            pattern: /(\bfragment\s+|\.{3}\s*(?!on\b))[a-zA-Z_]\w*/,
            lookbehind: true,
            alias: 'function'
        },
        'definition-mutation': {
            pattern: /(\bmutation\s+)[a-zA-Z_]\w*/,
            lookbehind: true,
            alias: 'function'
        },
        'definition-query': {
            pattern: /(\bquery\s+)[a-zA-Z_]\w*/,
            lookbehind: true,
            alias: 'function'
        },
        keyword: /\b(?:directive|enum|extend|fragment|implements|input|interface|mutation|on|query|repeatable|scalar|schema|subscription|type|union)\b/,
        operator: /[!=|&]|\.{3}/,
        'property-query': /\w+(?=\s*\()/,
        object: /\w+(?=\s*\{)/,
        punctuation: /[!(){}\[\]:=,]/,
        property: /\w+/
    };
    Prism.hooks.add('after-tokenize', function afterTokenizeGraphql(env) {
        if (env.language !== 'graphql') return;
        /**
     * get the graphql token stream that we want to customize
     *
     * @typedef {InstanceType<import("./prism-core")["Token"]>} Token
     * @type {Token[]}
     */ var validTokens = env.tokens.filter(function(token) {
            return typeof token !== 'string' && token.type !== 'comment' && token.type !== 'scalar';
        });
        var currentIndex = 0;
        /**
     * Returns whether the token relative to the current index has the given type.
     *
     * @param {number} offset
     * @returns {Token | undefined}
     */ function getToken(offset) {
            return validTokens[currentIndex + offset];
        }
        /**
     * Returns whether the token relative to the current index has the given type.
     *
     * @param {readonly string[]} types
     * @param {number} [offset=0]
     * @returns {boolean}
     */ function isTokenType(types, offset) {
            offset = offset || 0;
            for(var i = 0; i < types.length; i++){
                var token = getToken(i + offset);
                if (!token || token.type !== types[i]) return false;
            }
            return true;
        }
        /**
     * Returns the index of the closing bracket to an opening bracket.
     *
     * It is assumed that `token[currentIndex - 1]` is an opening bracket.
     *
     * If no closing bracket could be found, `-1` will be returned.
     *
     * @param {RegExp} open
     * @param {RegExp} close
     * @returns {number}
     */ function findClosingBracket(open, close) {
            var stackHeight = 1;
            for(var i = currentIndex; i < validTokens.length; i++){
                var token = validTokens[i];
                var content = token.content;
                if (token.type === 'punctuation' && typeof content === 'string') {
                    if (open.test(content)) stackHeight++;
                    else if (close.test(content)) {
                        stackHeight--;
                        if (stackHeight === 0) return i;
                    }
                }
            }
            return -1;
        }
        /**
     * Adds an alias to the given token.
     *
     * @param {Token} token
     * @param {string} alias
     * @returns {void}
     */ function addAlias(token, alias) {
            var aliases = token.alias;
            if (!aliases) token.alias = aliases = [];
            else if (!Array.isArray(aliases)) token.alias = aliases = [
                aliases
            ];
            aliases.push(alias);
        }
        for(; currentIndex < validTokens.length;){
            var startToken = validTokens[currentIndex++];
            // add special aliases for mutation tokens
            if (startToken.type === 'keyword' && startToken.content === 'mutation') {
                // any array of the names of all input variables (if any)
                var inputVariables = [];
                if (isTokenType([
                    'definition-mutation',
                    'punctuation'
                ]) && getToken(1).content === '(') {
                    // definition
                    currentIndex += 2 // skip 'definition-mutation' and 'punctuation'
                    ;
                    var definitionEnd = findClosingBracket(/^\($/, /^\)$/);
                    if (definitionEnd === -1) continue;
                    // find all input variables
                    for(; currentIndex < definitionEnd; currentIndex++){
                        var t = getToken(0);
                        if (t.type === 'variable') {
                            addAlias(t, 'variable-input');
                            inputVariables.push(t.content);
                        }
                    }
                    currentIndex = definitionEnd + 1;
                }
                if (isTokenType([
                    'punctuation',
                    'property-query'
                ]) && getToken(0).content === '{') {
                    currentIndex++ // skip opening bracket
                    ;
                    addAlias(getToken(0), 'property-mutation');
                    if (inputVariables.length > 0) {
                        var mutationEnd = findClosingBracket(/^\{$/, /^\}$/);
                        if (mutationEnd === -1) continue;
                        // give references to input variables a special alias
                        for(var i = currentIndex; i < mutationEnd; i++){
                            var varToken = validTokens[i];
                            if (varToken.type === 'variable' && inputVariables.indexOf(varToken.content) >= 0) addAlias(varToken, 'variable-input');
                        }
                    }
                }
            }
        }
    });
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$47c726b1edca75eb$export$2e2bcd8739ae039.displayName = 'groovy';
$47c726b1edca75eb$export$2e2bcd8739ae039.aliases = [];
function $47c726b1edca75eb$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    (function(Prism) {
        var interpolation = {
            pattern: /((?:^|[^\\$])(?:\\{2})*)\$(?:\w+|\{[^{}]*\})/,
            lookbehind: true,
            inside: {
                'interpolation-punctuation': {
                    pattern: /^\$\{?|\}$/,
                    alias: 'punctuation'
                },
                expression: {
                    pattern: /[\s\S]+/,
                    inside: null // see below
                }
            }
        };
        Prism.languages.groovy = Prism.languages.extend('clike', {
            string: {
                // https://groovy-lang.org/syntax.html#_dollar_slashy_string
                pattern: /'''(?:[^\\]|\\[\s\S])*?'''|'(?:\\.|[^\\'\r\n])*'/,
                greedy: true
            },
            keyword: /\b(?:abstract|as|assert|boolean|break|byte|case|catch|char|class|const|continue|def|default|do|double|else|enum|extends|final|finally|float|for|goto|if|implements|import|in|instanceof|int|interface|long|native|new|package|private|protected|public|return|short|static|strictfp|super|switch|synchronized|this|throw|throws|trait|transient|try|void|volatile|while)\b/,
            number: /\b(?:0b[01_]+|0x[\da-f_]+(?:\.[\da-f_p\-]+)?|[\d_]+(?:\.[\d_]+)?(?:e[+-]?\d+)?)[glidf]?\b/i,
            operator: {
                pattern: /(^|[^.])(?:~|==?~?|\?[.:]?|\*(?:[.=]|\*=?)?|\.[@&]|\.\.<|\.\.(?!\.)|-[-=>]?|\+[+=]?|!=?|<(?:<=?|=>?)?|>(?:>>?=?|=)?|&[&=]?|\|[|=]?|\/=?|\^=?|%=?)/,
                lookbehind: true
            },
            punctuation: /\.+|[{}[\];(),:$]/
        });
        Prism.languages.insertBefore('groovy', 'string', {
            shebang: {
                pattern: /#!.+/,
                alias: 'comment',
                greedy: true
            },
            'interpolation-string': {
                // TODO: Slash strings (e.g. /foo/) can contain line breaks but this will cause a lot of trouble with
                // simple division (see JS regex), so find a fix maybe?
                pattern: /"""(?:[^\\]|\\[\s\S])*?"""|(["/])(?:\\.|(?!\1)[^\\\r\n])*\1|\$\/(?:[^/$]|\$(?:[/$]|(?![/$]))|\/(?!\$))*\/\$/,
                greedy: true,
                inside: {
                    interpolation: interpolation,
                    string: /[\s\S]+/
                }
            }
        });
        Prism.languages.insertBefore('groovy', 'punctuation', {
            'spock-block': /\b(?:and|cleanup|expect|given|setup|then|when|where):/
        });
        Prism.languages.insertBefore('groovy', 'function', {
            annotation: {
                pattern: /(^|[^.])@\w+/,
                lookbehind: true,
                alias: 'punctuation'
            }
        });
        interpolation.inside.expression.inside = Prism.languages.groovy;
    })(Prism);
}




// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$69a27b40c3c43adf$export$2e2bcd8739ae039.displayName = 'textile';
$69a27b40c3c43adf$export$2e2bcd8739ae039.aliases = [];
function $69a27b40c3c43adf$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $8fbeea7c20d72e06$export$2e2bcd8739ae039));
    (function(Prism) {
        // We don't allow for pipes inside parentheses
        // to not break table pattern |(. foo |). bar |
        var modifierRegex = /\([^|()\n]+\)|\[[^\]\n]+\]|\{[^}\n]+\}/.source;
        // Opening and closing parentheses which are not a modifier
        // This pattern is necessary to prevent exponential backtracking
        var parenthesesRegex = /\)|\((?![^|()\n]+\))/.source;
        /**
     * @param {string} source
     * @param {string} [flags]
     */ function withModifier(source, flags) {
            return RegExp(source.replace(/<MOD>/g, function() {
                return '(?:' + modifierRegex + ')';
            }).replace(/<PAR>/g, function() {
                return '(?:' + parenthesesRegex + ')';
            }), flags || '');
        }
        var modifierTokens = {
            css: {
                pattern: /\{[^{}]+\}/,
                inside: {
                    rest: Prism.languages.css
                }
            },
            'class-id': {
                pattern: /(\()[^()]+(?=\))/,
                lookbehind: true,
                alias: 'attr-value'
            },
            lang: {
                pattern: /(\[)[^\[\]]+(?=\])/,
                lookbehind: true,
                alias: 'attr-value'
            },
            // Anything else is punctuation (the first pattern is for row/col spans inside tables)
            punctuation: /[\\\/]\d+|\S/
        };
        var textile = Prism.languages.textile = Prism.languages.extend('markup', {
            phrase: {
                pattern: /(^|\r|\n)\S[\s\S]*?(?=$|\r?\n\r?\n|\r\r)/,
                lookbehind: true,
                inside: {
                    // h1. Header 1
                    'block-tag': {
                        pattern: withModifier(/^[a-z]\w*(?:<MOD>|<PAR>|[<>=])*\./.source),
                        inside: {
                            modifier: {
                                pattern: withModifier(/(^[a-z]\w*)(?:<MOD>|<PAR>|[<>=])+(?=\.)/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            tag: /^[a-z]\w*/,
                            punctuation: /\.$/
                        }
                    },
                    // # List item
                    // * List item
                    list: {
                        pattern: withModifier(/^[*#]+<MOD>*\s+\S.*/.source, 'm'),
                        inside: {
                            modifier: {
                                pattern: withModifier(/(^[*#]+)<MOD>+/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            punctuation: /^[*#]+/
                        }
                    },
                    // | cell | cell | cell |
                    table: {
                        // Modifiers can be applied to the row: {color:red}.|1|2|3|
                        // or the cell: |{color:red}.1|2|3|
                        pattern: withModifier(/^(?:(?:<MOD>|<PAR>|[<>=^~])+\.\s*)?(?:\|(?:(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+\.|(?!(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+\.))[^|]*)+\|/.source, 'm'),
                        inside: {
                            modifier: {
                                // Modifiers for rows after the first one are
                                // preceded by a pipe and a line feed
                                pattern: withModifier(/(^|\|(?:\r?\n|\r)?)(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+(?=\.)/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            punctuation: /\||^\./
                        }
                    },
                    inline: {
                        // eslint-disable-next-line regexp/no-super-linear-backtracking
                        pattern: withModifier(/(^|[^a-zA-Z\d])(\*\*|__|\?\?|[*_%@+\-^~])<MOD>*.+?\2(?![a-zA-Z\d])/.source),
                        lookbehind: true,
                        inside: {
                            // Note: superscripts and subscripts are not handled specifically
                            // *bold*, **bold**
                            bold: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^(\*\*?)<MOD>*).+?(?=\2)/.source),
                                lookbehind: true
                            },
                            // _italic_, __italic__
                            italic: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^(__?)<MOD>*).+?(?=\2)/.source),
                                lookbehind: true
                            },
                            // ??cite??
                            cite: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^\?\?<MOD>*).+?(?=\?\?)/.source),
                                lookbehind: true,
                                alias: 'string'
                            },
                            // @code@
                            code: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^@<MOD>*).+?(?=@)/.source),
                                lookbehind: true,
                                alias: 'keyword'
                            },
                            // +inserted+
                            inserted: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^\+<MOD>*).+?(?=\+)/.source),
                                lookbehind: true
                            },
                            // -deleted-
                            deleted: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^-<MOD>*).+?(?=-)/.source),
                                lookbehind: true
                            },
                            // %span%
                            span: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^%<MOD>*).+?(?=%)/.source),
                                lookbehind: true
                            },
                            modifier: {
                                pattern: withModifier(/(^\*\*|__|\?\?|[*_%@+\-^~])<MOD>+/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            punctuation: /[*_%?@+\-^~]+/
                        }
                    },
                    // [alias]http://example.com
                    'link-ref': {
                        pattern: /^\[[^\]]+\]\S+$/m,
                        inside: {
                            string: {
                                pattern: /(^\[)[^\]]+(?=\])/,
                                lookbehind: true
                            },
                            url: {
                                pattern: /(^\])\S+$/,
                                lookbehind: true
                            },
                            punctuation: /[\[\]]/
                        }
                    },
                    // "text":http://example.com
                    // "text":link-ref
                    link: {
                        // eslint-disable-next-line regexp/no-super-linear-backtracking
                        pattern: withModifier(/"<MOD>*[^"]+":.+?(?=[^\w/]?(?:\s|$))/.source),
                        inside: {
                            text: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^"<MOD>*)[^"]+(?=")/.source),
                                lookbehind: true
                            },
                            modifier: {
                                pattern: withModifier(/(^")<MOD>+/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            url: {
                                pattern: /(:).+/,
                                lookbehind: true
                            },
                            punctuation: /[":]/
                        }
                    },
                    // !image.jpg!
                    // !image.jpg(Title)!:http://example.com
                    image: {
                        pattern: withModifier(/!(?:<MOD>|<PAR>|[<>=])*(?![<>=])[^!\s()]+(?:\([^)]+\))?!(?::.+?(?=[^\w/]?(?:\s|$)))?/.source),
                        inside: {
                            source: {
                                pattern: withModifier(/(^!(?:<MOD>|<PAR>|[<>=])*)(?![<>=])[^!\s()]+(?:\([^)]+\))?(?=!)/.source),
                                lookbehind: true,
                                alias: 'url'
                            },
                            modifier: {
                                pattern: withModifier(/(^!)(?:<MOD>|<PAR>|[<>=])+/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            url: {
                                pattern: /(:).+/,
                                lookbehind: true
                            },
                            punctuation: /[!:]/
                        }
                    },
                    // Footnote[1]
                    footnote: {
                        pattern: /\b\[\d+\]/,
                        alias: 'comment',
                        inside: {
                            punctuation: /\[|\]/
                        }
                    },
                    // CSS(Cascading Style Sheet)
                    acronym: {
                        pattern: /\b[A-Z\d]+\([^)]+\)/,
                        inside: {
                            comment: {
                                pattern: /(\()[^()]+(?=\))/,
                                lookbehind: true
                            },
                            punctuation: /[()]/
                        }
                    },
                    // Prism(C)
                    mark: {
                        pattern: /\b\((?:C|R|TM)\)/,
                        alias: 'comment',
                        inside: {
                            punctuation: /[()]/
                        }
                    }
                }
            }
        });
        var phraseInside = textile['phrase'].inside;
        var nestedPatterns = {
            inline: phraseInside['inline'],
            link: phraseInside['link'],
            image: phraseInside['image'],
            footnote: phraseInside['footnote'],
            acronym: phraseInside['acronym'],
            mark: phraseInside['mark']
        };
        // Only allow alpha-numeric HTML tags, not XML tags
        textile.tag.pattern = /<\/?(?!\d)[a-z0-9]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/i;
        // Allow some nesting
        var phraseInlineInside = phraseInside['inline'].inside;
        phraseInlineInside['bold'].inside = nestedPatterns;
        phraseInlineInside['italic'].inside = nestedPatterns;
        phraseInlineInside['inserted'].inside = nestedPatterns;
        phraseInlineInside['deleted'].inside = nestedPatterns;
        phraseInlineInside['span'].inside = nestedPatterns;
        // Allow some styles inside table cells
        var phraseTableInside = phraseInside['table'].inside;
        phraseTableInside['inline'] = nestedPatterns['inline'];
        phraseTableInside['link'] = nestedPatterns['link'];
        phraseTableInside['image'] = nestedPatterns['image'];
        phraseTableInside['footnote'] = nestedPatterns['footnote'];
        phraseTableInside['acronym'] = nestedPatterns['acronym'];
        phraseTableInside['mark'] = nestedPatterns['mark'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$e08e083f92fc8aa0$export$2e2bcd8739ae039.displayName = 'haml';
$e08e083f92fc8aa0$export$2e2bcd8739ae039.aliases = [];
function $e08e083f92fc8aa0$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $1024f633e11e96f5$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.haml = {
            // Multiline stuff should appear before the rest
            'multiline-comment': {
                pattern: /((?:^|\r?\n|\r)([\t ]*))(?:\/|-#).*(?:(?:\r?\n|\r)\2[\t ].+)*/,
                lookbehind: true,
                alias: 'comment'
            },
            'multiline-code': [
                {
                    pattern: /((?:^|\r?\n|\r)([\t ]*)(?:[~-]|[&!]?=)).*,[\t ]*(?:(?:\r?\n|\r)\2[\t ].*,[\t ]*)*(?:(?:\r?\n|\r)\2[\t ].+)/,
                    lookbehind: true,
                    inside: Prism.languages.ruby
                },
                {
                    pattern: /((?:^|\r?\n|\r)([\t ]*)(?:[~-]|[&!]?=)).*\|[\t ]*(?:(?:\r?\n|\r)\2[\t ].*\|[\t ]*)*/,
                    lookbehind: true,
                    inside: Prism.languages.ruby
                }
            ],
            // See at the end of the file for known filters
            filter: {
                pattern: /((?:^|\r?\n|\r)([\t ]*)):[\w-]+(?:(?:\r?\n|\r)(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/,
                lookbehind: true,
                inside: {
                    'filter-name': {
                        pattern: /^:[\w-]+/,
                        alias: 'symbol'
                    }
                }
            },
            markup: {
                pattern: /((?:^|\r?\n|\r)[\t ]*)<.+/,
                lookbehind: true,
                inside: Prism.languages.markup
            },
            doctype: {
                pattern: /((?:^|\r?\n|\r)[\t ]*)!!!(?: .+)?/,
                lookbehind: true
            },
            tag: {
                // Allows for one nested group of braces
                pattern: /((?:^|\r?\n|\r)[\t ]*)[%.#][\w\-#.]*[\w\-](?:\([^)]+\)|\{(?:\{[^}]+\}|[^{}])+\}|\[[^\]]+\])*[\/<>]*/,
                lookbehind: true,
                inside: {
                    attributes: [
                        {
                            // Lookbehind tries to prevent interpolations from breaking it all
                            // Allows for one nested group of braces
                            pattern: /(^|[^#])\{(?:\{[^}]+\}|[^{}])+\}/,
                            lookbehind: true,
                            inside: Prism.languages.ruby
                        },
                        {
                            pattern: /\([^)]+\)/,
                            inside: {
                                'attr-value': {
                                    pattern: /(=\s*)(?:"(?:\\.|[^\\"\r\n])*"|[^)\s]+)/,
                                    lookbehind: true
                                },
                                'attr-name': /[\w:-]+(?=\s*!?=|\s*[,)])/,
                                punctuation: /[=(),]/
                            }
                        },
                        {
                            pattern: /\[[^\]]+\]/,
                            inside: Prism.languages.ruby
                        }
                    ],
                    punctuation: /[<>]/
                }
            },
            code: {
                pattern: /((?:^|\r?\n|\r)[\t ]*(?:[~-]|[&!]?=)).+/,
                lookbehind: true,
                inside: Prism.languages.ruby
            },
            // Interpolations in plain text
            interpolation: {
                pattern: /#\{[^}]+\}/,
                inside: {
                    delimiter: {
                        pattern: /^#\{|\}$/,
                        alias: 'punctuation'
                    },
                    ruby: {
                        pattern: /[\s\S]+/,
                        inside: Prism.languages.ruby
                    }
                }
            },
            punctuation: {
                pattern: /((?:^|\r?\n|\r)[\t ]*)[~=\-&!]+/,
                lookbehind: true
            }
        };
        var filter_pattern = '((?:^|\\r?\\n|\\r)([\\t ]*)):{{filter_name}}(?:(?:\\r?\\n|\\r)(?:\\2[\\t ].+|\\s*?(?=\\r?\\n|\\r)))+';
        // Non exhaustive list of available filters and associated languages
        var filters = [
            'css',
            {
                filter: 'coffee',
                language: 'coffeescript'
            },
            'erb',
            'javascript',
            'less',
            'markdown',
            'ruby',
            'scss',
            'textile'
        ];
        var all_filters = {};
        for(var i = 0, l = filters.length; i < l; i++){
            var filter = filters[i];
            filter = typeof filter === 'string' ? {
                filter: filter,
                language: filter
            } : filter;
            if (Prism.languages[filter.language]) all_filters['filter-' + filter.filter] = {
                pattern: RegExp(filter_pattern.replace('{{filter_name}}', function() {
                    return filter.filter;
                })),
                lookbehind: true,
                inside: {
                    'filter-name': {
                        pattern: /^:[\w-]+/,
                        alias: 'symbol'
                    },
                    text: {
                        pattern: /[\s\S]+/,
                        alias: [
                            filter.language,
                            'language-' + filter.language
                        ],
                        inside: Prism.languages[filter.language]
                    }
                }
            };
        }
        Prism.languages.insertBefore('haml', 'filter', all_filters);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$764f1e53d8d49149$export$2e2bcd8739ae039.displayName = 'handlebars';
$764f1e53d8d49149$export$2e2bcd8739ae039.aliases = [
    'hbs',
    'mustache'
];
function $764f1e53d8d49149$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $a400735491c1aa4e$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.handlebars = {
            comment: /\{\{![\s\S]*?\}\}/,
            delimiter: {
                pattern: /^\{\{\{?|\}\}\}?$/,
                alias: 'punctuation'
            },
            string: /(["'])(?:\\.|(?!\1)[^\\\r\n])*\1/,
            number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][+-]?\d+)?/,
            boolean: /\b(?:false|true)\b/,
            block: {
                pattern: /^(\s*(?:~\s*)?)[#\/]\S+?(?=\s*(?:~\s*)?$|\s)/,
                lookbehind: true,
                alias: 'keyword'
            },
            brackets: {
                pattern: /\[[^\]]+\]/,
                inside: {
                    punctuation: /\[|\]/,
                    variable: /[\s\S]+/
                }
            },
            punctuation: /[!"#%&':()*+,.\/;<=>@\[\\\]^`{|}~]/,
            variable: /[^!"#%&'()*+,\/;<=>@\[\\\]^`{|}~\s]+/
        };
        Prism.hooks.add('before-tokenize', function(env) {
            var handlebarsPattern = /\{\{\{[\s\S]+?\}\}\}|\{\{[\s\S]+?\}\}/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'handlebars', handlebarsPattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'handlebars');
        });
        Prism.languages.hbs = Prism.languages.handlebars;
        Prism.languages.mustache = Prism.languages.handlebars;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $0a2709da981e5d8c$export$2e2bcd8739ae039.displayName = 'haskell';
$0a2709da981e5d8c$export$2e2bcd8739ae039.aliases = [
    'hs'
];
function $0a2709da981e5d8c$export$2e2bcd8739ae039(Prism) {
    Prism.languages.haskell = {
        comment: {
            pattern: /(^|[^-!#$%*+=?&@|~.:<>^\\\/])(?:--(?:(?=.)[^-!#$%*+=?&@|~.:<>^\\\/].*|$)|\{-[\s\S]*?-\})/m,
            lookbehind: true
        },
        char: {
            pattern: /'(?:[^\\']|\\(?:[abfnrtv\\"'&]|\^[A-Z@[\]^_]|ACK|BEL|BS|CAN|CR|DC1|DC2|DC3|DC4|DEL|DLE|EM|ENQ|EOT|ESC|ETB|ETX|FF|FS|GS|HT|LF|NAK|NUL|RS|SI|SO|SOH|SP|STX|SUB|SYN|US|VT|\d+|o[0-7]+|x[0-9a-fA-F]+))'/,
            alias: 'string'
        },
        string: {
            pattern: /"(?:[^\\"]|\\(?:\S|\s+\\))*"/,
            greedy: true
        },
        keyword: /\b(?:case|class|data|deriving|do|else|if|in|infixl|infixr|instance|let|module|newtype|of|primitive|then|type|where)\b/,
        'import-statement': {
            // The imported or hidden names are not included in this import
            // statement. This is because we want to highlight those exactly like
            // we do for the names in the program.
            pattern: /(^[\t ]*)import\s+(?:qualified\s+)?(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*(?:\s+as\s+(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*)?(?:\s+hiding\b)?/m,
            lookbehind: true,
            inside: {
                keyword: /\b(?:as|hiding|import|qualified)\b/,
                punctuation: /\./
            }
        },
        // These are builtin variables only. Constructors are highlighted later as a constant.
        builtin: /\b(?:abs|acos|acosh|all|and|any|appendFile|approxRational|asTypeOf|asin|asinh|atan|atan2|atanh|basicIORun|break|catch|ceiling|chr|compare|concat|concatMap|const|cos|cosh|curry|cycle|decodeFloat|denominator|digitToInt|div|divMod|drop|dropWhile|either|elem|encodeFloat|enumFrom|enumFromThen|enumFromThenTo|enumFromTo|error|even|exp|exponent|fail|filter|flip|floatDigits|floatRadix|floatRange|floor|fmap|foldl|foldl1|foldr|foldr1|fromDouble|fromEnum|fromInt|fromInteger|fromIntegral|fromRational|fst|gcd|getChar|getContents|getLine|group|head|id|inRange|index|init|intToDigit|interact|ioError|isAlpha|isAlphaNum|isAscii|isControl|isDenormalized|isDigit|isHexDigit|isIEEE|isInfinite|isLower|isNaN|isNegativeZero|isOctDigit|isPrint|isSpace|isUpper|iterate|last|lcm|length|lex|lexDigits|lexLitChar|lines|log|logBase|lookup|map|mapM|mapM_|max|maxBound|maximum|maybe|min|minBound|minimum|mod|negate|not|notElem|null|numerator|odd|or|ord|otherwise|pack|pi|pred|primExitWith|print|product|properFraction|putChar|putStr|putStrLn|quot|quotRem|range|rangeSize|read|readDec|readFile|readFloat|readHex|readIO|readInt|readList|readLitChar|readLn|readOct|readParen|readSigned|reads|readsPrec|realToFrac|recip|rem|repeat|replicate|return|reverse|round|scaleFloat|scanl|scanl1|scanr|scanr1|seq|sequence|sequence_|show|showChar|showInt|showList|showLitChar|showParen|showSigned|showString|shows|showsPrec|significand|signum|sin|sinh|snd|sort|span|splitAt|sqrt|subtract|succ|sum|tail|take|takeWhile|tan|tanh|threadToIOResult|toEnum|toInt|toInteger|toLower|toRational|toUpper|truncate|uncurry|undefined|unlines|until|unwords|unzip|unzip3|userError|words|writeFile|zip|zip3|zipWith|zipWith3)\b/,
        // decimal integers and floating point numbers | octal integers | hexadecimal integers
        number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0o[0-7]+|0x[0-9a-f]+)\b/i,
        operator: [
            {
                // infix operator
                pattern: /`(?:[A-Z][\w']*\.)*[_a-z][\w']*`/,
                greedy: true
            },
            {
                // function composition
                pattern: /(\s)\.(?=\s)/,
                lookbehind: true
            },
            // Most of this is needed because of the meaning of a single '.'.
            // If it stands alone freely, it is the function composition.
            // It may also be a separator between a module name and an identifier => no
            // operator. If it comes together with other special characters it is an
            // operator too.
            //
            // This regex means: /[-!#$%*+=?&@|~.:<>^\\\/]+/ without /\./.
            /[-!#$%*+=?&@|~:<>^\\\/][-!#$%*+=?&@|~.:<>^\\\/]*|\.[-!#$%*+=?&@|~.:<>^\\\/]+/
        ],
        // In Haskell, nearly everything is a variable, do not highlight these.
        hvariable: {
            pattern: /\b(?:[A-Z][\w']*\.)*[_a-z][\w']*/,
            inside: {
                punctuation: /\./
            }
        },
        constant: {
            pattern: /\b(?:[A-Z][\w']*\.)*[A-Z][\w']*/,
            inside: {
                punctuation: /\./
            }
        },
        punctuation: /[{}[\];(),.:]/
    };
    Prism.languages.hs = Prism.languages.haskell;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$26270207db713fa6$export$2e2bcd8739ae039.displayName = 'haxe';
$26270207db713fa6$export$2e2bcd8739ae039.aliases = [];
function $26270207db713fa6$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    Prism.languages.haxe = Prism.languages.extend('clike', {
        string: {
            // Strings can be multi-line
            pattern: /"(?:[^"\\]|\\[\s\S])*"/,
            greedy: true
        },
        'class-name': [
            {
                pattern: /(\b(?:abstract|class|enum|extends|implements|interface|new|typedef)\s+)[A-Z_]\w*/,
                lookbehind: true
            },
            // based on naming convention
            /\b[A-Z]\w*/
        ],
        // The final look-ahead prevents highlighting of keywords if expressions such as "haxe.macro.Expr"
        keyword: /\bthis\b|\b(?:abstract|as|break|case|cast|catch|class|continue|default|do|dynamic|else|enum|extends|extern|final|for|from|function|if|implements|import|in|inline|interface|macro|new|null|operator|overload|override|package|private|public|return|static|super|switch|throw|to|try|typedef|untyped|using|var|while)(?!\.)\b/,
        function: {
            pattern: /\b[a-z_]\w*(?=\s*(?:<[^<>]*>\s*)?\()/i,
            greedy: true
        },
        operator: /\.{3}|\+\+|--|&&|\|\||->|=>|(?:<<?|>{1,3}|[-+*/%!=&|^])=?|[?:~]/
    });
    Prism.languages.insertBefore('haxe', 'string', {
        'string-interpolation': {
            pattern: /'(?:[^'\\]|\\[\s\S])*'/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /(^|[^\\])\$(?:\w+|\{[^{}]+\})/,
                    lookbehind: true,
                    inside: {
                        'interpolation-punctuation': {
                            pattern: /^\$\{?|\}$/,
                            alias: 'punctuation'
                        },
                        expression: {
                            pattern: /[\s\S]+/,
                            inside: Prism.languages.haxe
                        }
                    }
                },
                string: /[\s\S]+/
            }
        }
    });
    Prism.languages.insertBefore('haxe', 'class-name', {
        regex: {
            pattern: /~\/(?:[^\/\\\r\n]|\\.)+\/[a-z]*/,
            greedy: true,
            inside: {
                'regex-flags': /\b[a-z]+$/,
                'regex-source': {
                    pattern: /^(~\/)[\s\S]+(?=\/$)/,
                    lookbehind: true,
                    alias: 'language-regex',
                    inside: Prism.languages.regex
                },
                'regex-delimiter': /^~\/|\/$/
            }
        }
    });
    Prism.languages.insertBefore('haxe', 'keyword', {
        preprocessor: {
            pattern: /#(?:else|elseif|end|if)\b.*/,
            alias: 'property'
        },
        metadata: {
            pattern: /@:?[\w.]+/,
            alias: 'symbol'
        },
        reification: {
            pattern: /\$(?:\w+|(?=\{))/,
            alias: 'important'
        }
    });
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $1cfef378e309df5d$export$2e2bcd8739ae039.displayName = 'hcl';
$1cfef378e309df5d$export$2e2bcd8739ae039.aliases = [];
function $1cfef378e309df5d$export$2e2bcd8739ae039(Prism) {
    Prism.languages.hcl = {
        comment: /(?:\/\/|#).*|\/\*[\s\S]*?(?:\*\/|$)/,
        heredoc: {
            pattern: /<<-?(\w+\b)[\s\S]*?^[ \t]*\1/m,
            greedy: true,
            alias: 'string'
        },
        keyword: [
            {
                pattern: /(?:data|resource)\s+(?:"(?:\\[\s\S]|[^\\"])*")(?=\s+"[\w-]+"\s+\{)/i,
                inside: {
                    type: {
                        pattern: /(resource|data|\s+)(?:"(?:\\[\s\S]|[^\\"])*")/i,
                        lookbehind: true,
                        alias: 'variable'
                    }
                }
            },
            {
                pattern: /(?:backend|module|output|provider|provisioner|variable)\s+(?:[\w-]+|"(?:\\[\s\S]|[^\\"])*")\s+(?=\{)/i,
                inside: {
                    type: {
                        pattern: /(backend|module|output|provider|provisioner|variable)\s+(?:[\w-]+|"(?:\\[\s\S]|[^\\"])*")\s+/i,
                        lookbehind: true,
                        alias: 'variable'
                    }
                }
            },
            /[\w-]+(?=\s+\{)/
        ],
        property: [
            /[-\w\.]+(?=\s*=(?!=))/,
            /"(?:\\[\s\S]|[^\\"])+"(?=\s*[:=])/
        ],
        string: {
            pattern: /"(?:[^\\$"]|\\[\s\S]|\$(?:(?=")|\$+(?!\$)|[^"${])|\$\{(?:[^{}"]|"(?:[^\\"]|\\[\s\S])*")*\})*"/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /(^|[^$])\$\{(?:[^{}"]|"(?:[^\\"]|\\[\s\S])*")*\}/,
                    lookbehind: true,
                    inside: {
                        type: {
                            pattern: /(\b(?:count|data|local|module|path|self|terraform|var)\b\.)[\w\*]+/i,
                            lookbehind: true,
                            alias: 'variable'
                        },
                        keyword: /\b(?:count|data|local|module|path|self|terraform|var)\b/i,
                        function: /\w+(?=\()/,
                        string: {
                            pattern: /"(?:\\[\s\S]|[^\\"])*"/,
                            greedy: true
                        },
                        number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
                        punctuation: /[!\$#%&'()*+,.\/;<=>@\[\\\]^`{|}~?:]/
                    }
                }
            }
        },
        number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
        boolean: /\b(?:false|true)\b/i,
        punctuation: /[=\[\]{}]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$7e7fbe9aa72823ed$export$2e2bcd8739ae039.displayName = 'hlsl';
$7e7fbe9aa72823ed$export$2e2bcd8739ae039.aliases = [];
function $7e7fbe9aa72823ed$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $e064275ae5958777$export$2e2bcd8739ae039));
    Prism.languages.hlsl = Prism.languages.extend('c', {
        // Regarding keywords and class names:
        // The list of all keywords was split into 'keyword' and 'class-name' tokens based on whether they are capitalized.
        // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-keywords
        // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-reserved-words
        'class-name': [
            Prism.languages.c['class-name'],
            /\b(?:AppendStructuredBuffer|BlendState|Buffer|ByteAddressBuffer|CompileShader|ComputeShader|ConsumeStructuredBuffer|DepthStencilState|DepthStencilView|DomainShader|GeometryShader|Hullshader|InputPatch|LineStream|OutputPatch|PixelShader|PointStream|RWBuffer|RWByteAddressBuffer|RWStructuredBuffer|RWTexture(?:1D|1DArray|2D|2DArray|3D)|RasterizerState|RenderTargetView|SamplerComparisonState|SamplerState|StructuredBuffer|Texture(?:1D|1DArray|2D|2DArray|2DMS|2DMSArray|3D|Cube|CubeArray)|TriangleStream|VertexShader)\b/
        ],
        keyword: [
            // HLSL keyword
            /\b(?:asm|asm_fragment|auto|break|case|catch|cbuffer|centroid|char|class|column_major|compile|compile_fragment|const|const_cast|continue|default|delete|discard|do|dynamic_cast|else|enum|explicit|export|extern|for|friend|fxgroup|goto|groupshared|if|in|inline|inout|interface|line|lineadj|linear|long|matrix|mutable|namespace|new|nointerpolation|noperspective|operator|out|packoffset|pass|pixelfragment|point|precise|private|protected|public|register|reinterpret_cast|return|row_major|sample|sampler|shared|short|signed|sizeof|snorm|stateblock|stateblock_state|static|static_cast|string|struct|switch|tbuffer|technique|technique10|technique11|template|texture|this|throw|triangle|triangleadj|try|typedef|typename|uniform|union|unorm|unsigned|using|vector|vertexfragment|virtual|void|volatile|while)\b/,
            // scalar, vector, and matrix types
            /\b(?:bool|double|dword|float|half|int|min(?:10float|12int|16(?:float|int|uint))|uint)(?:[1-4](?:x[1-4])?)?\b/
        ],
        // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-grammar#floating-point-numbers
        number: /(?:(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+)?|\b0x[\da-fA-F]+)[fFhHlLuU]?\b/,
        boolean: /\b(?:false|true)\b/
    });
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $336784a38a667aef$export$2e2bcd8739ae039.displayName = 'hoon';
$336784a38a667aef$export$2e2bcd8739ae039.aliases = [];
function $336784a38a667aef$export$2e2bcd8739ae039(Prism) {
    Prism.languages.hoon = {
        comment: {
            pattern: /::.*/,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*'/,
            greedy: true
        },
        constant: /%(?:\.[ny]|[\w-]+)/,
        'class-name': /@(?:[a-z0-9-]*[a-z0-9])?|\*/i,
        function: /(?:\+[-+] {2})?(?:[a-z](?:[a-z0-9-]*[a-z0-9])?)/,
        keyword: /\.[\^\+\*=\?]|![><:\.=\?!]|=[>|:,\.\-\^<+;/~\*\?]|\?[>|:\.\-\^<\+&~=@!]|\|[\$_%:\.\-\^~\*=@\?]|\+[|\$\+\*]|:[_\-\^\+~\*]|%[_:\.\-\^\+~\*=]|\^[|:\.\-\+&~\*=\?]|\$[|_%:<>\-\^&~@=\?]|;[:<\+;\/~\*=]|~[>|\$_%<\+\/&=\?!]|--|==/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $ff1650a614471816$export$2e2bcd8739ae039.displayName = 'hpkp';
$ff1650a614471816$export$2e2bcd8739ae039.aliases = [];
function $ff1650a614471816$export$2e2bcd8739ae039(Prism) {
    /**
   * Original by Scott Helme.
   *
   * Reference: https://scotthelme.co.uk/hpkp-cheat-sheet/
   */ Prism.languages.hpkp = {
        directive: {
            pattern: /\b(?:includeSubDomains|max-age|pin-sha256|preload|report-to|report-uri|strict)(?=[\s;=]|$)/i,
            alias: 'property'
        },
        operator: /=/,
        punctuation: /;/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $0e2de5a532079e2e$export$2e2bcd8739ae039.displayName = 'hsts';
$0e2de5a532079e2e$export$2e2bcd8739ae039.aliases = [];
function $0e2de5a532079e2e$export$2e2bcd8739ae039(Prism) {
    /**
   * Original by Scott Helme.
   *
   * Reference: https://scotthelme.co.uk/hsts-cheat-sheet/
   */ Prism.languages.hsts = {
        directive: {
            pattern: /\b(?:includeSubDomains|max-age|preload)(?=[\s;=]|$)/i,
            alias: 'property'
        },
        operator: /=/,
        punctuation: /;/
    };
}



// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $06e94734974cdb6c$export$2e2bcd8739ae039.displayName = 'uri';
$06e94734974cdb6c$export$2e2bcd8739ae039.aliases = [
    'url'
];
function $06e94734974cdb6c$export$2e2bcd8739ae039(Prism) {
    // https://tools.ietf.org/html/rfc3986#appendix-A
    Prism.languages.uri = {
        scheme: {
            pattern: /^[a-z][a-z0-9+.-]*:/im,
            greedy: true,
            inside: {
                'scheme-delimiter': /:$/
            }
        },
        fragment: {
            pattern: /#[\w\-.~!$&'()*+,;=%:@/?]*/,
            inside: {
                'fragment-delimiter': /^#/
            }
        },
        query: {
            pattern: /\?[\w\-.~!$&'()*+,;=%:@/?]*/,
            inside: {
                'query-delimiter': {
                    pattern: /^\?/,
                    greedy: true
                },
                'pair-delimiter': /[&;]/,
                pair: {
                    pattern: /^[^=][\s\S]*/,
                    inside: {
                        key: /^[^=]+/,
                        value: {
                            pattern: /(^=)[\s\S]+/,
                            lookbehind: true
                        }
                    }
                }
            }
        },
        authority: {
            pattern: RegExp(/^\/\//.source + // [ userinfo "@" ]
            /(?:[\w\-.~!$&'()*+,;=%:]*@)?/.source + // host
            ('(?:' + // IP-literal
            /\[(?:[0-9a-fA-F:.]{2,48}|v[0-9a-fA-F]+\.[\w\-.~!$&'()*+,;=]+)\]/.source + '|' + // IPv4address or registered name
            /[\w\-.~!$&'()*+,;=%]*/.source + ')') + // [ ":" port ]
            /(?::\d*)?/.source, 'm'),
            inside: {
                'authority-delimiter': /^\/\//,
                'user-info-segment': {
                    pattern: /^[\w\-.~!$&'()*+,;=%:]*@/,
                    inside: {
                        'user-info-delimiter': /@$/,
                        'user-info': /^[\w\-.~!$&'()*+,;=%:]+/
                    }
                },
                'port-segment': {
                    pattern: /:\d*$/,
                    inside: {
                        'port-delimiter': /^:/,
                        port: /^\d+/
                    }
                },
                host: {
                    pattern: /[\s\S]+/,
                    inside: {
                        'ip-literal': {
                            pattern: /^\[[\s\S]+\]$/,
                            inside: {
                                'ip-literal-delimiter': /^\[|\]$/,
                                'ipv-future': /^v[\s\S]+/,
                                'ipv6-address': /^[\s\S]+/
                            }
                        },
                        'ipv4-address': /^(?:(?:[03-9]\d?|[12]\d{0,2})\.){3}(?:[03-9]\d?|[12]\d{0,2})$/
                    }
                }
            }
        },
        path: {
            pattern: /^[\w\-.~!$&'()*+,;=%:@/]+/m,
            inside: {
                'path-separator': /\//
            }
        }
    };
    Prism.languages.url = Prism.languages.uri;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $dd4e0ac0e264206b$export$2e2bcd8739ae039.displayName = 'http';
$dd4e0ac0e264206b$export$2e2bcd8739ae039.aliases = [];
function $dd4e0ac0e264206b$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        /**
     * @param {string} name
     * @returns {RegExp}
     */ function headerValueOf(name) {
            return RegExp('(^(?:' + name + '):[ \t]*(?![ \t]))[^]+', 'i');
        }
        Prism.languages.http = {
            'request-line': {
                pattern: /^(?:CONNECT|DELETE|GET|HEAD|OPTIONS|PATCH|POST|PRI|PUT|SEARCH|TRACE)\s(?:https?:\/\/|\/)\S*\sHTTP\/[\d.]+/m,
                inside: {
                    // HTTP Method
                    method: {
                        pattern: /^[A-Z]+\b/,
                        alias: 'property'
                    },
                    // Request Target e.g. http://example.com, /path/to/file
                    'request-target': {
                        pattern: /^(\s)(?:https?:\/\/|\/)\S*(?=\s)/,
                        lookbehind: true,
                        alias: 'url',
                        inside: Prism.languages.uri
                    },
                    // HTTP Version
                    'http-version': {
                        pattern: /^(\s)HTTP\/[\d.]+/,
                        lookbehind: true,
                        alias: 'property'
                    }
                }
            },
            'response-status': {
                pattern: /^HTTP\/[\d.]+ \d+ .+/m,
                inside: {
                    // HTTP Version
                    'http-version': {
                        pattern: /^HTTP\/[\d.]+/,
                        alias: 'property'
                    },
                    // Status Code
                    'status-code': {
                        pattern: /^(\s)\d+(?=\s)/,
                        lookbehind: true,
                        alias: 'number'
                    },
                    // Reason Phrase
                    'reason-phrase': {
                        pattern: /^(\s).+/,
                        lookbehind: true,
                        alias: 'string'
                    }
                }
            },
            header: {
                pattern: /^[\w-]+:.+(?:(?:\r\n?|\n)[ \t].+)*/m,
                inside: {
                    'header-value': [
                        {
                            pattern: headerValueOf(/Content-Security-Policy/.source),
                            lookbehind: true,
                            alias: [
                                'csp',
                                'languages-csp'
                            ],
                            inside: Prism.languages.csp
                        },
                        {
                            pattern: headerValueOf(/Public-Key-Pins(?:-Report-Only)?/.source),
                            lookbehind: true,
                            alias: [
                                'hpkp',
                                'languages-hpkp'
                            ],
                            inside: Prism.languages.hpkp
                        },
                        {
                            pattern: headerValueOf(/Strict-Transport-Security/.source),
                            lookbehind: true,
                            alias: [
                                'hsts',
                                'languages-hsts'
                            ],
                            inside: Prism.languages.hsts
                        },
                        {
                            pattern: headerValueOf(/[^:]+/.source),
                            lookbehind: true
                        }
                    ],
                    'header-name': {
                        pattern: /^[^:]+/,
                        alias: 'keyword'
                    },
                    punctuation: /^:/
                }
            }
        };
        // Create a mapping of Content-Type headers to language definitions
        var langs = Prism.languages;
        var httpLanguages = {
            'application/javascript': langs.javascript,
            'application/json': langs.json || langs.javascript,
            'application/xml': langs.xml,
            'text/xml': langs.xml,
            'text/html': langs.html,
            'text/css': langs.css,
            'text/plain': langs.plain
        };
        // Declare which types can also be suffixes
        var suffixTypes = {
            'application/json': true,
            'application/xml': true
        };
        /**
     * Returns a pattern for the given content type which matches it and any type which has it as a suffix.
     *
     * @param {string} contentType
     * @returns {string}
     */ function getSuffixPattern(contentType) {
            var suffix = contentType.replace(/^[a-z]+\//, '');
            var suffixPattern = '\\w+/(?:[\\w.-]+\\+)+' + suffix + '(?![+\\w.-])';
            return '(?:' + contentType + '|' + suffixPattern + ')';
        }
        // Insert each content type parser that has its associated language
        // currently loaded.
        var options;
        for(var contentType in httpLanguages)if (httpLanguages[contentType]) {
            options = options || {};
            var pattern = suffixTypes[contentType] ? getSuffixPattern(contentType) : contentType;
            options[contentType.replace(/\//g, '-')] = {
                pattern: RegExp('(' + /content-type:\s*/.source + pattern + /(?:(?:\r\n?|\n)[\w-].*)*(?:\r(?:\n|(?!\n))|\n)/.source + ')' + // This is a little interesting:
                // The HTTP format spec required 1 empty line before the body to make everything unambiguous.
                // However, when writing code by hand (e.g. to display on a website) people can forget about this,
                // so we want to be liberal here. We will allow the empty line to be omitted if the first line of
                // the body does not start with a [\w-] character (as headers do).
                /[^ \t\w-][\s\S]*/.source, 'i'),
                lookbehind: true,
                inside: httpLanguages[contentType]
            };
        }
        if (options) Prism.languages.insertBefore('http', 'header', options);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $68defdc6cd38bdb4$export$2e2bcd8739ae039.displayName = 'ichigojam';
$68defdc6cd38bdb4$export$2e2bcd8739ae039.aliases = [];
function $68defdc6cd38bdb4$export$2e2bcd8739ae039(Prism) {
    // according to the offical reference (EN)
    // https://ichigojam.net/IchigoJam-en.html
    Prism.languages.ichigojam = {
        comment: /(?:\B'|REM)(?:[^\n\r]*)/i,
        string: {
            pattern: /"(?:""|[!#$%&'()*,\/:;<=>?^\w +\-.])*"/,
            greedy: true
        },
        number: /\B#[0-9A-F]+|\B`[01]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
        keyword: /\b(?:BEEP|BPS|CASE|CLEAR|CLK|CLO|CLP|CLS|CLT|CLV|CONT|COPY|ELSE|END|FILE|FILES|FOR|GOSUB|GOTO|GSB|IF|INPUT|KBD|LED|LET|LIST|LOAD|LOCATE|LRUN|NEW|NEXT|OUT|PLAY|POKE|PRINT|PWM|REM|RENUM|RESET|RETURN|RIGHT|RTN|RUN|SAVE|SCROLL|SLEEP|SRND|STEP|STOP|SUB|TEMPO|THEN|TO|UART|VIDEO|WAIT)(?:\$|\b)/i,
        function: /\b(?:ABS|ANA|ASC|BIN|BTN|DEC|END|FREE|HELP|HEX|I2CR|I2CW|IN|INKEY|LEN|LINE|PEEK|RND|SCR|SOUND|STR|TICK|USR|VER|VPEEK|ZER)(?:\$|\b)/i,
        label: /(?:\B@\S+)/,
        operator: /<[=>]?|>=?|\|\||&&|[+\-*\/=|&^~!]|\b(?:AND|NOT|OR)\b/i,
        punctuation: /[\[,;:()\]]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $6b343a6bc0ab8052$export$2e2bcd8739ae039.displayName = 'icon';
$6b343a6bc0ab8052$export$2e2bcd8739ae039.aliases = [];
function $6b343a6bc0ab8052$export$2e2bcd8739ae039(Prism) {
    Prism.languages.icon = {
        comment: /#.*/,
        string: {
            pattern: /(["'])(?:(?!\1)[^\\\r\n_]|\\.|_(?!\1)(?:\r\n|[\s\S]))*\1/,
            greedy: true
        },
        number: /\b(?:\d+r[a-z\d]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b|\.\d+\b/i,
        'builtin-keyword': {
            pattern: /&(?:allocated|ascii|clock|collections|cset|current|date|dateline|digits|dump|e|error(?:number|text|value)?|errout|fail|features|file|host|input|lcase|letters|level|line|main|null|output|phi|pi|pos|progname|random|regions|source|storage|subject|time|trace|ucase|version)\b/,
            alias: 'variable'
        },
        directive: {
            pattern: /\$\w+/,
            alias: 'builtin'
        },
        keyword: /\b(?:break|by|case|create|default|do|else|end|every|fail|global|if|initial|invocable|link|local|next|not|of|procedure|record|repeat|return|static|suspend|then|to|until|while)\b/,
        function: /\b(?!\d)\w+(?=\s*[({]|\s*!\s*\[)/,
        operator: /[+-]:(?!=)|(?:[\/?@^%&]|\+\+?|--?|==?=?|~==?=?|\*\*?|\|\|\|?|<(?:->?|<?=?)|>>?=?)(?::=)?|:(?:=:?)?|[!.\\|~]/,
        punctuation: /[\[\](){},;]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $4cb476895e94c36f$export$2e2bcd8739ae039.displayName = 'icu-message-format';
$4cb476895e94c36f$export$2e2bcd8739ae039.aliases = [];
function $4cb476895e94c36f$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        /**
     * @param {string} source
     * @param {number} level
     * @returns {string}
     */ function nested(source, level) {
            if (level <= 0) return /[]/.source;
            else return source.replace(/<SELF>/g, function() {
                return nested(source, level - 1);
            });
        }
        var stringPattern = /'[{}:=,](?:[^']|'')*'(?!')/;
        var escape = {
            pattern: /''/,
            greedy: true,
            alias: 'operator'
        };
        var string = {
            pattern: stringPattern,
            greedy: true,
            inside: {
                escape: escape
            }
        };
        var argumentSource = nested(/\{(?:[^{}']|'(?![{},'])|''|<STR>|<SELF>)*\}/.source.replace(/<STR>/g, function() {
            return stringPattern.source;
        }), 8);
        var nestedMessage = {
            pattern: RegExp(argumentSource),
            inside: {
                message: {
                    pattern: /^(\{)[\s\S]+(?=\}$)/,
                    lookbehind: true,
                    inside: null // see below
                },
                'message-delimiter': {
                    pattern: /./,
                    alias: 'punctuation'
                }
            }
        };
        Prism.languages['icu-message-format'] = {
            argument: {
                pattern: RegExp(argumentSource),
                greedy: true,
                inside: {
                    content: {
                        pattern: /^(\{)[\s\S]+(?=\}$)/,
                        lookbehind: true,
                        inside: {
                            'argument-name': {
                                pattern: /^(\s*)[^{}:=,\s]+/,
                                lookbehind: true
                            },
                            'choice-style': {
                                // https://unicode-org.github.io/icu-docs/apidoc/released/icu4c/classicu_1_1ChoiceFormat.html#details
                                pattern: /^(\s*,\s*choice\s*,\s*)\S(?:[\s\S]*\S)?/,
                                lookbehind: true,
                                inside: {
                                    punctuation: /\|/,
                                    range: {
                                        pattern: /^(\s*)[+-]?(?:\d+(?:\.\d*)?|\u221e)\s*[<#\u2264]/,
                                        lookbehind: true,
                                        inside: {
                                            operator: /[<#\u2264]/,
                                            number: /\S+/
                                        }
                                    },
                                    rest: null // see below
                                }
                            },
                            'plural-style': {
                                // https://unicode-org.github.io/icu-docs/apidoc/released/icu4j/com/ibm/icu/text/PluralFormat.html#:~:text=Patterns%20and%20Their%20Interpretation
                                pattern: /^(\s*,\s*(?:plural|selectordinal)\s*,\s*)\S(?:[\s\S]*\S)?/,
                                lookbehind: true,
                                inside: {
                                    offset: /^offset:\s*\d+/,
                                    'nested-message': nestedMessage,
                                    selector: {
                                        pattern: /=\d+|[^{}:=,\s]+/,
                                        inside: {
                                            keyword: /^(?:few|many|one|other|two|zero)$/
                                        }
                                    }
                                }
                            },
                            'select-style': {
                                // https://unicode-org.github.io/icu-docs/apidoc/released/icu4j/com/ibm/icu/text/SelectFormat.html#:~:text=Patterns%20and%20Their%20Interpretation
                                pattern: /^(\s*,\s*select\s*,\s*)\S(?:[\s\S]*\S)?/,
                                lookbehind: true,
                                inside: {
                                    'nested-message': nestedMessage,
                                    selector: {
                                        pattern: /[^{}:=,\s]+/,
                                        inside: {
                                            keyword: /^other$/
                                        }
                                    }
                                }
                            },
                            keyword: /\b(?:choice|plural|select|selectordinal)\b/,
                            'arg-type': {
                                pattern: /\b(?:date|duration|number|ordinal|spellout|time)\b/,
                                alias: 'keyword'
                            },
                            'arg-skeleton': {
                                pattern: /(,\s*)::[^{}:=,\s]+/,
                                lookbehind: true
                            },
                            'arg-style': {
                                pattern: /(,\s*)(?:currency|full|integer|long|medium|percent|short)(?=\s*$)/,
                                lookbehind: true
                            },
                            'arg-style-text': {
                                pattern: RegExp(/(^\s*,\s*(?=\S))/.source + nested(/(?:[^{}']|'[^']*'|\{(?:<SELF>)?\})+/.source, 8) + '$'),
                                lookbehind: true,
                                alias: 'string'
                            },
                            punctuation: /,/
                        }
                    },
                    'argument-delimiter': {
                        pattern: /./,
                        alias: 'operator'
                    }
                }
            },
            escape: escape,
            string: string
        };
        nestedMessage.inside.message.inside = Prism.languages['icu-message-format'];
        Prism.languages['icu-message-format'].argument.inside.content.inside['choice-style'].inside.rest = Prism.languages['icu-message-format'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$7486a97757b46985$export$2e2bcd8739ae039.displayName = 'idris';
$7486a97757b46985$export$2e2bcd8739ae039.aliases = [
    'idr'
];
function $7486a97757b46985$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $0a2709da981e5d8c$export$2e2bcd8739ae039));
    Prism.languages.idris = Prism.languages.extend('haskell', {
        comment: {
            pattern: /(?:(?:--|\|\|\|).*$|\{-[\s\S]*?-\})/m
        },
        keyword: /\b(?:Type|case|class|codata|constructor|corecord|data|do|dsl|else|export|if|implementation|implicit|import|impossible|in|infix|infixl|infixr|instance|interface|let|module|mutual|namespace|of|parameters|partial|postulate|private|proof|public|quoteGoal|record|rewrite|syntax|then|total|using|where|with)\b/,
        builtin: undefined
    });
    Prism.languages.insertBefore('idris', 'keyword', {
        'import-statement': {
            pattern: /(^\s*import\s+)(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*/m,
            lookbehind: true,
            inside: {
                punctuation: /\./
            }
        }
    });
    Prism.languages.idr = Prism.languages.idris;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $765305b27b262a69$export$2e2bcd8739ae039.displayName = 'ignore';
$765305b27b262a69$export$2e2bcd8739ae039.aliases = [
    'gitignore',
    'hgignore',
    'npmignore'
];
function $765305b27b262a69$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.ignore = {
            // https://git-scm.com/docs/gitignore
            comment: /^#.*/m,
            entry: {
                pattern: /\S(?:.*(?:(?:\\ )|\S))?/,
                alias: 'string',
                inside: {
                    operator: /^!|\*\*?|\?/,
                    regex: {
                        pattern: /(^|[^\\])\[[^\[\]]*\]/,
                        lookbehind: true
                    },
                    punctuation: /\//
                }
            }
        };
        Prism.languages.gitignore = Prism.languages.ignore;
        Prism.languages.hgignore = Prism.languages.ignore;
        Prism.languages.npmignore = Prism.languages.ignore;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $9f4b875c06247633$export$2e2bcd8739ae039.displayName = 'inform7';
$9f4b875c06247633$export$2e2bcd8739ae039.aliases = [];
function $9f4b875c06247633$export$2e2bcd8739ae039(Prism) {
    Prism.languages.inform7 = {
        string: {
            pattern: /"[^"]*"/,
            inside: {
                substitution: {
                    pattern: /\[[^\[\]]+\]/,
                    inside: {
                        delimiter: {
                            pattern: /\[|\]/,
                            alias: 'punctuation'
                        }
                    }
                }
            }
        },
        comment: {
            pattern: /\[[^\[\]]+\]/,
            greedy: true
        },
        title: {
            pattern: /^[ \t]*(?:book|chapter|part(?! of)|section|table|volume)\b.+/im,
            alias: 'important'
        },
        number: {
            pattern: /(^|[^-])(?:\b\d+(?:\.\d+)?(?:\^\d+)?(?:(?!\d)\w+)?|\b(?:eight|eleven|five|four|nine|one|seven|six|ten|three|twelve|two))\b(?!-)/i,
            lookbehind: true
        },
        verb: {
            pattern: /(^|[^-])\b(?:answering|applying to|are|asking|attacking|be(?:ing)?|burning|buying|called|carries|carry(?! out)|carrying|climbing|closing|conceal(?:ing|s)?|consulting|contain(?:ing|s)?|cutting|drinking|dropping|eating|enclos(?:es?|ing)|entering|examining|exiting|getting|giving|going|ha(?:s|ve|ving)|hold(?:ing|s)?|impl(?:ies|y)|incorporat(?:es?|ing)|inserting|is|jumping|kissing|listening|locking|looking|mean(?:ing|s)?|opening|provid(?:es?|ing)|pulling|pushing|putting|relat(?:es?|ing)|removing|searching|see(?:ing|s)?|setting|showing|singing|sleeping|smelling|squeezing|support(?:ing|s)?|swearing|switching|taking|tasting|telling|thinking|throwing|touching|turning|tying|unlock(?:ing|s)?|var(?:ies|y|ying)|waiting|waking|waving|wear(?:ing|s)?)\b(?!-)/i,
            lookbehind: true,
            alias: 'operator'
        },
        keyword: {
            pattern: /(^|[^-])\b(?:after|before|carry out|check|continue the action|definition(?= *:)|do nothing|else|end (?:if|the story|unless)|every turn|if|include|instead(?: of)?|let|move|no|now|otherwise|repeat|report|resume the story|rule for|running through|say(?:ing)?|stop the action|test|try(?:ing)?|understand|unless|use|when|while|yes)\b(?!-)/i,
            lookbehind: true
        },
        property: {
            pattern: /(^|[^-])\b(?:adjacent(?! to)|carried|closed|concealed|contained|dark|described|edible|empty|enclosed|enterable|even|female|fixed in place|full|handled|held|improper-named|incorporated|inedible|invisible|lighted|lit|lock(?:able|ed)|male|marked for listing|mentioned|negative|neuter|non-(?:empty|full|recurring)|odd|opaque|open(?:able)?|plural-named|portable|positive|privately-named|proper-named|provided|publically-named|pushable between rooms|recurring|related|rubbing|scenery|seen|singular-named|supported|swinging|switch(?:able|ed(?: off| on)?)|touch(?:able|ed)|transparent|unconcealed|undescribed|unlit|unlocked|unmarked for listing|unmentioned|unopenable|untouchable|unvisited|variable|visible|visited|wearable|worn)\b(?!-)/i,
            lookbehind: true,
            alias: 'symbol'
        },
        position: {
            pattern: /(^|[^-])\b(?:above|adjacent to|back side of|below|between|down|east|everywhere|front side|here|in|inside(?: from)?|north(?:east|west)?|nowhere|on(?: top of)?|other side|outside(?: from)?|parts? of|regionally in|south(?:east|west)?|through|up|west|within)\b(?!-)/i,
            lookbehind: true,
            alias: 'keyword'
        },
        type: {
            pattern: /(^|[^-])\b(?:actions?|activit(?:ies|y)|actors?|animals?|backdrops?|containers?|devices?|directions?|doors?|holders?|kinds?|lists?|m[ae]n|nobody|nothing|nouns?|numbers?|objects?|people|persons?|player(?:'s holdall)?|regions?|relations?|rooms?|rule(?:book)?s?|scenes?|someone|something|supporters?|tables?|texts?|things?|time|vehicles?|wom[ae]n)\b(?!-)/i,
            lookbehind: true,
            alias: 'variable'
        },
        punctuation: /[.,:;(){}]/
    };
    Prism.languages.inform7['string'].inside['substitution'].inside.rest = Prism.languages.inform7;
    // We don't want the remaining text in the substitution to be highlighted as the string.
    Prism.languages.inform7['string'].inside['substitution'].inside.rest.text = {
        pattern: /\S(?:\s*\S)*/,
        alias: 'comment'
    };
}



// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $7beef303dd5ba8d6$export$2e2bcd8739ae039.displayName = 'io';
$7beef303dd5ba8d6$export$2e2bcd8739ae039.aliases = [];
function $7beef303dd5ba8d6$export$2e2bcd8739ae039(Prism) {
    Prism.languages.io = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\/\/.*|#.*)/,
            lookbehind: true,
            greedy: true
        },
        'triple-quoted-string': {
            pattern: /"""(?:\\[\s\S]|(?!""")[^\\])*"""/,
            greedy: true,
            alias: 'string'
        },
        string: {
            pattern: /"(?:\\.|[^\\\r\n"])*"/,
            greedy: true
        },
        keyword: /\b(?:activate|activeCoroCount|asString|block|break|call|catch|clone|collectGarbage|compileString|continue|do|doFile|doMessage|doString|else|elseif|exit|for|foreach|forward|getEnvironmentVariable|getSlot|hasSlot|if|ifFalse|ifNil|ifNilEval|ifTrue|isActive|isNil|isResumable|list|message|method|parent|pass|pause|perform|performWithArgList|print|println|proto|raise|raiseResumable|removeSlot|resend|resume|schedulerSleepSeconds|self|sender|setSchedulerSleepSeconds|setSlot|shallowCopy|slotNames|super|system|then|thisBlock|thisContext|try|type|uniqueId|updateSlot|wait|while|write|yield)\b/,
        builtin: /\b(?:Array|AudioDevice|AudioMixer|BigNum|Block|Box|Buffer|CFunction|CGI|Color|Curses|DBM|DNSResolver|DOConnection|DOProxy|DOServer|Date|Directory|Duration|DynLib|Error|Exception|FFT|File|Fnmatch|Font|Future|GL|GLE|GLScissor|GLU|GLUCylinder|GLUQuadric|GLUSphere|GLUT|Host|Image|Importer|LinkList|List|Lobby|Locals|MD5|MP3Decoder|MP3Encoder|Map|Message|Movie|Notification|Number|Object|OpenGL|Point|Protos|Random|Regex|SGML|SGMLElement|SGMLParser|SQLite|Sequence|Server|ShowMessage|SleepyCat|SleepyCatCursor|Socket|SocketManager|Sound|Soup|Store|String|Tree|UDPSender|UPDReceiver|URL|User|Warning|WeakLink)\b/,
        boolean: /\b(?:false|nil|true)\b/,
        number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e-?\d+)?/i,
        operator: /[=!*/%+\-^&|]=|>>?=?|<<?=?|:?:?=|\+\+?|--?|\*\*?|\/\/?|%|\|\|?|&&?|\b(?:and|not|or|return)\b|@@?|\?\??|\.\./,
        punctuation: /[{}[\];(),.:]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $9daff9909ad10959$export$2e2bcd8739ae039.displayName = 'j';
$9daff9909ad10959$export$2e2bcd8739ae039.aliases = [];
function $9daff9909ad10959$export$2e2bcd8739ae039(Prism) {
    Prism.languages.j = {
        comment: {
            pattern: /\bNB\..*/,
            greedy: true
        },
        string: {
            pattern: /'(?:''|[^'\r\n])*'/,
            greedy: true
        },
        keyword: /\b(?:(?:CR|LF|adverb|conjunction|def|define|dyad|monad|noun|verb)\b|(?:assert|break|case|catch[dt]?|continue|do|else|elseif|end|fcase|for|for_\w+|goto_\w+|if|label_\w+|return|select|throw|try|while|whilst)\.)/,
        verb: {
            // Negative look-ahead prevents bad highlighting
            // of ^: ;. =. =: !. !:
            pattern: /(?!\^:|;\.|[=!][.:])(?:\{(?:\.|::?)?|p(?:\.\.?|:)|[=!\]]|[<>+*\-%$|,#][.:]?|[?^]\.?|[;\[]:?|[~}"i][.:]|[ACeEIjLor]\.|(?:[_\/\\qsux]|_?\d):)/,
            alias: 'keyword'
        },
        number: /\b_?(?:(?!\d:)\d+(?:\.\d+)?(?:(?:ad|ar|[ejpx])_?\d+(?:\.\d+)?)*(?:b_?[\da-z]+(?:\.[\da-z]+)?)?|_\b(?!\.))/,
        adverb: {
            pattern: /[~}]|[\/\\]\.?|[bfM]\.|t[.:]/,
            alias: 'builtin'
        },
        operator: /[=a][.:]|_\./,
        conjunction: {
            pattern: /&(?:\.:?|:)?|[.:@][.:]?|[!D][.:]|[;dHT]\.|`:?|[\^LS]:|"/,
            alias: 'variable'
        },
        punctuation: /[()]/
    };
}




// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $3fdb7058e3046f24$export$2e2bcd8739ae039.displayName = 'javadoclike';
$3fdb7058e3046f24$export$2e2bcd8739ae039.aliases = [];
function $3fdb7058e3046f24$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var javaDocLike = Prism.languages.javadoclike = {
            parameter: {
                pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*@(?:arg|arguments|param)\s+)\w+/m,
                lookbehind: true
            },
            keyword: {
                // keywords are the first word in a line preceded be an `@` or surrounded by curly braces.
                // @word, {@word}
                pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*|\{)@[a-z][a-zA-Z-]+\b/m,
                lookbehind: true
            },
            punctuation: /[{}]/
        };
        /**
     * Adds doc comment support to the given language and calls a given callback on each doc comment pattern.
     *
     * @param {string} lang the language add doc comment support to.
     * @param {(pattern: {inside: {rest: undefined}}) => void} callback the function called with each doc comment pattern as argument.
     */ function docCommentSupport(lang, callback) {
            var tokenName = 'doc-comment';
            var grammar = Prism.languages[lang];
            if (!grammar) return;
            var token = grammar[tokenName];
            if (!token) {
                // add doc comment: /** */
                var definition = {};
                definition[tokenName] = {
                    pattern: /(^|[^\\])\/\*\*[^/][\s\S]*?(?:\*\/|$)/,
                    lookbehind: true,
                    alias: 'comment'
                };
                grammar = Prism.languages.insertBefore(lang, 'comment', definition);
                token = grammar[tokenName];
            }
            if (token instanceof RegExp) // convert regex to object
            token = grammar[tokenName] = {
                pattern: token
            };
            if (Array.isArray(token)) for(var i = 0, l = token.length; i < l; i++){
                if (token[i] instanceof RegExp) token[i] = {
                    pattern: token[i]
                };
                callback(token[i]);
            }
            else callback(token);
        }
        /**
     * Adds doc-comment support to the given languages for the given documentation language.
     *
     * @param {string[]|string} languages
     * @param {Object} docLanguage
     */ function addSupport(languages, docLanguage) {
            if (typeof languages === 'string') languages = [
                languages
            ];
            languages.forEach(function(lang) {
                docCommentSupport(lang, function(pattern) {
                    if (!pattern.inside) pattern.inside = {};
                    pattern.inside.rest = docLanguage;
                });
            });
        }
        Object.defineProperty(javaDocLike, 'addSupport', {
            value: addSupport
        });
        javaDocLike.addSupport([
            'java',
            'javascript',
            'php'
        ], javaDocLike);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$500308337cc8fd8d$export$2e2bcd8739ae039.displayName = 'scala';
$500308337cc8fd8d$export$2e2bcd8739ae039.aliases = [];
function $500308337cc8fd8d$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $68ea9a70b77f88ea$export$2e2bcd8739ae039));
    Prism.languages.scala = Prism.languages.extend('java', {
        'triple-quoted-string': {
            pattern: /"""[\s\S]*?"""/,
            greedy: true,
            alias: 'string'
        },
        string: {
            pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        keyword: /<-|=>|\b(?:abstract|case|catch|class|def|derives|do|else|enum|extends|extension|final|finally|for|forSome|given|if|implicit|import|infix|inline|lazy|match|new|null|object|opaque|open|override|package|private|protected|return|sealed|self|super|this|throw|trait|transparent|try|type|using|val|var|while|with|yield)\b/,
        number: /\b0x(?:[\da-f]*\.)?[\da-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e\d+)?[dfl]?/i,
        builtin: /\b(?:Any|AnyRef|AnyVal|Boolean|Byte|Char|Double|Float|Int|Long|Nothing|Short|String|Unit)\b/,
        symbol: /'[^\d\s\\]\w*/
    });
    Prism.languages.insertBefore('scala', 'triple-quoted-string', {
        'string-interpolation': {
            pattern: /\b[a-z]\w*(?:"""(?:[^$]|\$(?:[^{]|\{(?:[^{}]|\{[^{}]*\})*\}))*?"""|"(?:[^$"\r\n]|\$(?:[^{]|\{(?:[^{}]|\{[^{}]*\})*\}))*")/i,
            greedy: true,
            inside: {
                id: {
                    pattern: /^\w+/,
                    greedy: true,
                    alias: 'function'
                },
                escape: {
                    pattern: /\\\$"|\$[$"]/,
                    greedy: true,
                    alias: 'symbol'
                },
                interpolation: {
                    pattern: /\$(?:\w+|\{(?:[^{}]|\{[^{}]*\})*\})/,
                    greedy: true,
                    inside: {
                        punctuation: /^\$\{?|\}$/,
                        expression: {
                            pattern: /[\s\S]+/,
                            inside: Prism.languages.scala
                        }
                    }
                },
                string: /[\s\S]+/
            }
        }
    });
    delete Prism.languages.scala['class-name'];
    delete Prism.languages.scala['function'];
    delete Prism.languages.scala['constant'];
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 


$a16ebd91e2b74520$export$2e2bcd8739ae039.displayName = 'javadoc';
$a16ebd91e2b74520$export$2e2bcd8739ae039.aliases = [];
function $a16ebd91e2b74520$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $68ea9a70b77f88ea$export$2e2bcd8739ae039));
    Prism.register((0, $3fdb7058e3046f24$export$2e2bcd8739ae039));
    Prism.register((0, $8fbeea7c20d72e06$export$2e2bcd8739ae039));
    (function(Prism) {
        var codeLinePattern = /(^(?:[\t ]*(?:\*\s*)*))[^*\s].*$/m;
        var memberReference = /#\s*\w+(?:\s*\([^()]*\))?/.source;
        var reference = /(?:\b[a-zA-Z]\w+\s*\.\s*)*\b[A-Z]\w*(?:\s*<mem>)?|<mem>/.source.replace(/<mem>/g, function() {
            return memberReference;
        });
        Prism.languages.javadoc = Prism.languages.extend('javadoclike', {});
        Prism.languages.insertBefore('javadoc', 'keyword', {
            reference: {
                pattern: RegExp(/(@(?:exception|link|linkplain|see|throws|value)\s+(?:\*\s*)?)/.source + '(?:' + reference + ')'),
                lookbehind: true,
                inside: {
                    function: {
                        pattern: /(#\s*)\w+(?=\s*\()/,
                        lookbehind: true
                    },
                    field: {
                        pattern: /(#\s*)\w+/,
                        lookbehind: true
                    },
                    namespace: {
                        pattern: /\b(?:[a-z]\w*\s*\.\s*)+/,
                        inside: {
                            punctuation: /\./
                        }
                    },
                    'class-name': /\b[A-Z]\w*/,
                    keyword: Prism.languages.java.keyword,
                    punctuation: /[#()[\],.]/
                }
            },
            'class-name': {
                // @param <T> the first generic type parameter
                pattern: /(@param\s+)<[A-Z]\w*>/,
                lookbehind: true,
                inside: {
                    punctuation: /[.<>]/
                }
            },
            'code-section': [
                {
                    pattern: /(\{@code\s+(?!\s))(?:[^\s{}]|\s+(?![\s}])|\{(?:[^{}]|\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*\})+(?=\s*\})/,
                    lookbehind: true,
                    inside: {
                        code: {
                            // there can't be any HTML inside of {@code} tags
                            pattern: codeLinePattern,
                            lookbehind: true,
                            inside: Prism.languages.java,
                            alias: 'language-java'
                        }
                    }
                },
                {
                    pattern: /(<(code|pre|tt)>(?!<code>)\s*)\S(?:\S|\s+\S)*?(?=\s*<\/\2>)/,
                    lookbehind: true,
                    inside: {
                        line: {
                            pattern: codeLinePattern,
                            lookbehind: true,
                            inside: {
                                // highlight HTML tags and entities
                                tag: Prism.languages.markup.tag,
                                entity: Prism.languages.markup.entity,
                                code: {
                                    // everything else is Java code
                                    pattern: /.+/,
                                    inside: Prism.languages.java,
                                    alias: 'language-java'
                                }
                            }
                        }
                    }
                }
            ],
            tag: Prism.languages.markup.tag,
            entity: Prism.languages.markup.entity
        });
        Prism.languages.javadoclike.addSupport('java', Prism.languages.javadoc);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $759ff8712e89417d$export$2e2bcd8739ae039.displayName = 'javastacktrace';
$759ff8712e89417d$export$2e2bcd8739ae039.aliases = [];
function $759ff8712e89417d$export$2e2bcd8739ae039(Prism) {
    // Specification:
    // https://docs.oracle.com/en/java/javase/13/docs/api/java.base/java/lang/Throwable.html#printStackTrace()
    Prism.languages.javastacktrace = {
        // java.sql.SQLException: Violation of unique constraint MY_ENTITY_UK_1: duplicate value(s) for column(s) MY_COLUMN in statement [...]
        // Caused by: java.sql.SQLException: Violation of unique constraint MY_ENTITY_UK_1: duplicate value(s) for column(s) MY_COLUMN in statement [...]
        // Caused by: com.example.myproject.MyProjectServletException
        // Caused by: MidLevelException: LowLevelException
        // Suppressed: Resource$CloseFailException: Resource ID = 0
        summary: {
            pattern: /^([\t ]*)(?:(?:Caused by:|Suppressed:|Exception in thread "[^"]*")[\t ]+)?[\w$.]+(?::.*)?$/m,
            lookbehind: true,
            inside: {
                keyword: {
                    pattern: /^([\t ]*)(?:(?:Caused by|Suppressed)(?=:)|Exception in thread)/m,
                    lookbehind: true
                },
                // the current thread if the summary starts with 'Exception in thread'
                string: {
                    pattern: /^(\s*)"[^"]*"/,
                    lookbehind: true
                },
                exceptions: {
                    pattern: /^(:?\s*)[\w$.]+(?=:|$)/,
                    lookbehind: true,
                    inside: {
                        'class-name': /[\w$]+$/,
                        namespace: /\b[a-z]\w*\b/,
                        punctuation: /\./
                    }
                },
                message: {
                    pattern: /(:\s*)\S.*/,
                    lookbehind: true,
                    alias: 'string'
                },
                punctuation: /:/
            }
        },
        // at org.mortbay.jetty.servlet.ServletHandler$CachedChain.doFilter(ServletHandler.java:1166)
        // at org.hsqldb.jdbc.Util.throwError(Unknown Source) here could be some notes
        // at java.base/java.lang.Class.forName0(Native Method)
        // at Util.<init>(Unknown Source)
        // at com.foo.loader/foo@9.0/com.foo.Main.run(Main.java:101)
        // at com.foo.loader//com.foo.bar.App.run(App.java:12)
        // at acme@2.1/org.acme.Lib.test(Lib.java:80)
        // at MyClass.mash(MyClass.java:9)
        //
        // More information:
        // https://docs.oracle.com/en/java/javase/13/docs/api/java.base/java/lang/StackTraceElement.html#toString()
        //
        // A valid Java module name is defined as:
        //   "A module name consists of one or more Java identifiers (§3.8) separated by "." tokens."
        // https://docs.oracle.com/javase/specs/jls/se9/html/jls-6.html#jls-ModuleName
        //
        // A Java module version is defined by this class:
        // https://docs.oracle.com/javase/9/docs/api/java/lang/module/ModuleDescriptor.Version.html
        // This is the implementation of the `parse` method in JDK13:
        // https://github.com/matcdac/jdk/blob/2305df71d1b7710266ae0956d73927a225132c0f/src/java.base/share/classes/java/lang/module/ModuleDescriptor.java#L1108
        // However, to keep this simple, a version will be matched by the pattern /@[\w$.+-]*/.
        'stack-frame': {
            pattern: /^([\t ]*)at (?:[\w$./]|@[\w$.+-]*\/)+(?:<init>)?\([^()]*\)/m,
            lookbehind: true,
            inside: {
                keyword: {
                    pattern: /^(\s*)at(?= )/,
                    lookbehind: true
                },
                source: [
                    // (Main.java:15)
                    // (Main.scala:15)
                    {
                        pattern: /(\()\w+\.\w+:\d+(?=\))/,
                        lookbehind: true,
                        inside: {
                            file: /^\w+\.\w+/,
                            punctuation: /:/,
                            'line-number': {
                                pattern: /\b\d+\b/,
                                alias: 'number'
                            }
                        }
                    },
                    // (Unknown Source)
                    // (Native Method)
                    // (...something...)
                    {
                        pattern: /(\()[^()]*(?=\))/,
                        lookbehind: true,
                        inside: {
                            keyword: /^(?:Native Method|Unknown Source)$/
                        }
                    }
                ],
                'class-name': /[\w$]+(?=\.(?:<init>|[\w$]+)\()/,
                function: /(?:<init>|[\w$]+)(?=\()/,
                'class-loader': {
                    pattern: /(\s)[a-z]\w*(?:\.[a-z]\w*)*(?=\/[\w@$.]*\/)/,
                    lookbehind: true,
                    alias: 'namespace',
                    inside: {
                        punctuation: /\./
                    }
                },
                module: {
                    pattern: /([\s/])[a-z]\w*(?:\.[a-z]\w*)*(?:@[\w$.+-]*)?(?=\/)/,
                    lookbehind: true,
                    inside: {
                        version: {
                            pattern: /(@)[\s\S]+/,
                            lookbehind: true,
                            alias: 'number'
                        },
                        punctuation: /[@.]/
                    }
                },
                namespace: {
                    pattern: /(?:\b[a-z]\w*\.)+/,
                    inside: {
                        punctuation: /\./
                    }
                },
                punctuation: /[()/.]/
            }
        },
        // ... 32 more
        // ... 32 common frames omitted
        more: {
            pattern: /^([\t ]*)\.{3} \d+ [a-z]+(?: [a-z]+)*/m,
            lookbehind: true,
            inside: {
                punctuation: /\.{3}/,
                number: /\d+/,
                keyword: /\b[a-z]+(?: [a-z]+)*\b/
            }
        }
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $ec82644279b505a3$export$2e2bcd8739ae039.displayName = 'jexl';
$ec82644279b505a3$export$2e2bcd8739ae039.aliases = [];
function $ec82644279b505a3$export$2e2bcd8739ae039(Prism) {
    Prism.languages.jexl = {
        string: /(["'])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
        transform: {
            pattern: /(\|\s*)[a-zA-Zа-яА-Я_\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$][\wа-яА-Я\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$]*/,
            alias: 'function',
            lookbehind: true
        },
        function: /[a-zA-Zа-яА-Я_\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$][\wа-яА-Я\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$]*\s*(?=\()/,
        number: /\b\d+(?:\.\d+)?\b|\B\.\d+\b/,
        operator: /[<>!]=?|-|\+|&&|==|\|\|?|\/\/?|[?:*^%]/,
        boolean: /\b(?:false|true)\b/,
        keyword: /\bin\b/,
        punctuation: /[{}[\](),.]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$156df7f34267ef47$export$2e2bcd8739ae039.displayName = 'jolie';
$156df7f34267ef47$export$2e2bcd8739ae039.aliases = [];
function $156df7f34267ef47$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    Prism.languages.jolie = Prism.languages.extend('clike', {
        string: {
            pattern: /(^|[^\\])"(?:\\[\s\S]|[^"\\])*"/,
            lookbehind: true,
            greedy: true
        },
        'class-name': {
            pattern: /((?:\b(?:as|courier|embed|in|inputPort|outputPort|service)\b|@)[ \t]*)\w+/,
            lookbehind: true
        },
        keyword: /\b(?:as|cH|comp|concurrent|constants|courier|cset|csets|default|define|else|embed|embedded|execution|exit|extender|for|foreach|forward|from|global|if|import|in|include|init|inputPort|install|instanceof|interface|is_defined|linkIn|linkOut|main|new|nullProcess|outputPort|over|private|provide|public|scope|sequential|service|single|spawn|synchronized|this|throw|throws|type|undef|until|while|with)\b/,
        function: /\b[a-z_]\w*(?=[ \t]*[@(])/i,
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?l?/i,
        operator: /-[-=>]?|\+[+=]?|<[<=]?|[>=*!]=?|&&|\|\||[?\/%^@|]/,
        punctuation: /[()[\]{},;.:]/,
        builtin: /\b(?:Byte|any|bool|char|double|enum|float|int|length|long|ranges|regex|string|undefined|void)\b/
    });
    Prism.languages.insertBefore('jolie', 'keyword', {
        aggregates: {
            pattern: /(\bAggregates\s*:\s*)(?:\w+(?:\s+with\s+\w+)?\s*,\s*)*\w+(?:\s+with\s+\w+)?/,
            lookbehind: true,
            inside: {
                keyword: /\bwith\b/,
                'class-name': /\w+/,
                punctuation: /,/
            }
        },
        redirects: {
            pattern: /(\bRedirects\s*:\s*)(?:\w+\s*=>\s*\w+\s*,\s*)*(?:\w+\s*=>\s*\w+)/,
            lookbehind: true,
            inside: {
                punctuation: /,/,
                'class-name': /\w+/,
                operator: /=>/
            }
        },
        property: {
            pattern: /\b(?:Aggregates|[Ii]nterfaces|Java|Javascript|Jolie|[Ll]ocation|OneWay|[Pp]rotocol|Redirects|RequestResponse)\b(?=[ \t]*:)/
        }
    });
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $b479671e17d8160f$export$2e2bcd8739ae039.displayName = 'jq';
$b479671e17d8160f$export$2e2bcd8739ae039.aliases = [];
function $b479671e17d8160f$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var interpolation = /\\\((?:[^()]|\([^()]*\))*\)/.source;
        var string = RegExp(/(^|[^\\])"(?:[^"\r\n\\]|\\[^\r\n(]|__)*"/.source.replace(/__/g, function() {
            return interpolation;
        }));
        var stringInterpolation = {
            interpolation: {
                pattern: RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + interpolation),
                lookbehind: true,
                inside: {
                    content: {
                        pattern: /^(\\\()[\s\S]+(?=\)$)/,
                        lookbehind: true,
                        inside: null // see below
                    },
                    punctuation: /^\\\(|\)$/
                }
            }
        };
        var jq = Prism.languages.jq = {
            comment: /#.*/,
            property: {
                pattern: RegExp(string.source + /(?=\s*:(?!:))/.source),
                lookbehind: true,
                greedy: true,
                inside: stringInterpolation
            },
            string: {
                pattern: string,
                lookbehind: true,
                greedy: true,
                inside: stringInterpolation
            },
            function: {
                pattern: /(\bdef\s+)[a-z_]\w+/i,
                lookbehind: true
            },
            variable: /\B\$\w+/,
            'property-literal': {
                pattern: /\b[a-z_]\w*(?=\s*:(?!:))/i,
                alias: 'property'
            },
            keyword: /\b(?:as|break|catch|def|elif|else|end|foreach|if|import|include|label|module|modulemeta|null|reduce|then|try|while)\b/,
            boolean: /\b(?:false|true)\b/,
            number: /(?:\b\d+\.|\B\.)?\b\d+(?:[eE][+-]?\d+)?\b/,
            operator: [
                {
                    pattern: /\|=?/,
                    alias: 'pipe'
                },
                /\.\.|[!=<>]?=|\?\/\/|\/\/=?|[-+*/%]=?|[<>?]|\b(?:and|not|or)\b/
            ],
            'c-style-function': {
                pattern: /\b[a-z_]\w*(?=\s*\()/i,
                alias: 'function'
            },
            punctuation: /::|[()\[\]{},:;]|\.(?=\s*[\[\w$])/,
            dot: {
                pattern: /\./,
                alias: 'important'
            }
        };
        stringInterpolation.interpolation.inside.content.inside = jq;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$4d6acca9e6f19adf$export$2e2bcd8739ae039.displayName = 'js-templates';
$4d6acca9e6f19adf$export$2e2bcd8739ae039.aliases = [];
function $4d6acca9e6f19adf$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $9f5c72e4d4e505c4$export$2e2bcd8739ae039));
    (function(Prism) {
        var templateString = Prism.languages.javascript['template-string'];
        // see the pattern in prism-javascript.js
        var templateLiteralPattern = templateString.pattern.source;
        var interpolationObject = templateString.inside['interpolation'];
        var interpolationPunctuationObject = interpolationObject.inside['interpolation-punctuation'];
        var interpolationPattern = interpolationObject.pattern.source;
        /**
     * Creates a new pattern to match a template string with a special tag.
     *
     * This will return `undefined` if there is no grammar with the given language id.
     *
     * @param {string} language The language id of the embedded language. E.g. `markdown`.
     * @param {string} tag The regex pattern to match the tag.
     * @returns {object | undefined}
     * @example
     * createTemplate('css', /\bcss/.source);
     */ function createTemplate(language, tag) {
            if (!Prism.languages[language]) return undefined;
            return {
                pattern: RegExp('((?:' + tag + ')\\s*)' + templateLiteralPattern),
                lookbehind: true,
                greedy: true,
                inside: {
                    'template-punctuation': {
                        pattern: /^`|`$/,
                        alias: 'string'
                    },
                    'embedded-code': {
                        pattern: /[\s\S]+/,
                        alias: language
                    }
                }
            };
        }
        Prism.languages.javascript['template-string'] = [
            // styled-jsx:
            //   css`a { color: #25F; }`
            // styled-components:
            //   styled.h1`color: red;`
            createTemplate('css', /\b(?:styled(?:\([^)]*\))?(?:\s*\.\s*\w+(?:\([^)]*\))*)*|css(?:\s*\.\s*(?:global|resolve))?|createGlobalStyle|keyframes)/.source),
            // html`<p></p>`
            // div.innerHTML = `<p></p>`
            createTemplate('html', /\bhtml|\.\s*(?:inner|outer)HTML\s*\+?=/.source),
            // svg`<path fill="#fff" d="M55.37 ..."/>`
            createTemplate('svg', /\bsvg/.source),
            // md`# h1`, markdown`## h2`
            createTemplate('markdown', /\b(?:markdown|md)/.source),
            // gql`...`, graphql`...`, graphql.experimental`...`
            createTemplate('graphql', /\b(?:gql|graphql(?:\s*\.\s*experimental)?)/.source),
            // sql`...`
            createTemplate('sql', /\bsql/.source),
            // vanilla template string
            templateString
        ].filter(Boolean);
        /**
     * Returns a specific placeholder literal for the given language.
     *
     * @param {number} counter
     * @param {string} language
     * @returns {string}
     */ function getPlaceholder(counter, language) {
            return '___' + language.toUpperCase() + '_' + counter + '___';
        }
        /**
     * Returns the tokens of `Prism.tokenize` but also runs the `before-tokenize` and `after-tokenize` hooks.
     *
     * @param {string} code
     * @param {any} grammar
     * @param {string} language
     * @returns {(string|Token)[]}
     */ function tokenizeWithHooks(code, grammar, language) {
            var env = {
                code: code,
                grammar: grammar,
                language: language
            };
            Prism.hooks.run('before-tokenize', env);
            env.tokens = Prism.tokenize(env.code, env.grammar);
            Prism.hooks.run('after-tokenize', env);
            return env.tokens;
        }
        /**
     * Returns the token of the given JavaScript interpolation expression.
     *
     * @param {string} expression The code of the expression. E.g. `"${42}"`
     * @returns {Token}
     */ function tokenizeInterpolationExpression(expression) {
            var tempGrammar = {};
            tempGrammar['interpolation-punctuation'] = interpolationPunctuationObject;
            /** @type {Array} */ var tokens = Prism.tokenize(expression, tempGrammar);
            if (tokens.length === 3) {
                /**
         * The token array will look like this
         * [
         *     ["interpolation-punctuation", "${"]
         *     "..." // JavaScript expression of the interpolation
         *     ["interpolation-punctuation", "}"]
         * ]
         */ var args = [
                    1,
                    1
                ];
                args.push.apply(args, tokenizeWithHooks(tokens[1], Prism.languages.javascript, 'javascript'));
                tokens.splice.apply(tokens, args);
            }
            return new Prism.Token('interpolation', tokens, interpolationObject.alias, expression);
        }
        /**
     * Tokenizes the given code with support for JavaScript interpolation expressions mixed in.
     *
     * This function has 3 phases:
     *
     * 1. Replace all JavaScript interpolation expression with a placeholder.
     *    The placeholder will have the syntax of a identify of the target language.
     * 2. Tokenize the code with placeholders.
     * 3. Tokenize the interpolation expressions and re-insert them into the tokenize code.
     *    The insertion only works if a placeholder hasn't been "ripped apart" meaning that the placeholder has been
     *    tokenized as two tokens by the grammar of the embedded language.
     *
     * @param {string} code
     * @param {object} grammar
     * @param {string} language
     * @returns {Token}
     */ function tokenizeEmbedded(code, grammar, language) {
            // 1. First filter out all interpolations
            // because they might be escaped, we need a lookbehind, so we use Prism
            /** @type {(Token|string)[]} */ var _tokens = Prism.tokenize(code, {
                interpolation: {
                    pattern: RegExp(interpolationPattern),
                    lookbehind: true
                }
            });
            // replace all interpolations with a placeholder which is not in the code already
            var placeholderCounter = 0;
            /** @type {Object<string, string>} */ var placeholderMap = {};
            var embeddedCode = _tokens.map(function(token) {
                if (typeof token === 'string') return token;
                else {
                    var interpolationExpression = token.content;
                    var placeholder;
                    while(code.indexOf(placeholder = getPlaceholder(placeholderCounter++, language)) !== -1);
                    placeholderMap[placeholder] = interpolationExpression;
                    return placeholder;
                }
            }).join('');
            // 2. Tokenize the embedded code
            var embeddedTokens = tokenizeWithHooks(embeddedCode, grammar, language);
            // 3. Re-insert the interpolation
            var placeholders = Object.keys(placeholderMap);
            placeholderCounter = 0;
            /**
       *
       * @param {(Token|string)[]} tokens
       * @returns {void}
       */ function walkTokens(tokens) {
                for(var i = 0; i < tokens.length; i++){
                    if (placeholderCounter >= placeholders.length) return;
                    var token = tokens[i];
                    if (typeof token === 'string' || typeof token.content === 'string') {
                        var placeholder = placeholders[placeholderCounter];
                        var s = typeof token === 'string' ? token : /** @type {string} */ token.content;
                        var index = s.indexOf(placeholder);
                        if (index !== -1) {
                            ++placeholderCounter;
                            var before = s.substring(0, index);
                            var middle = tokenizeInterpolationExpression(placeholderMap[placeholder]);
                            var after = s.substring(index + placeholder.length);
                            var replacement = [];
                            if (before) replacement.push(before);
                            replacement.push(middle);
                            if (after) {
                                var afterTokens = [
                                    after
                                ];
                                walkTokens(afterTokens);
                                replacement.push.apply(replacement, afterTokens);
                            }
                            if (typeof token === 'string') {
                                tokens.splice.apply(tokens, [
                                    i,
                                    1
                                ].concat(replacement));
                                i += replacement.length - 1;
                            } else token.content = replacement;
                        }
                    } else {
                        var content = token.content;
                        if (Array.isArray(content)) walkTokens(content);
                        else walkTokens([
                            content
                        ]);
                    }
                }
            }
            walkTokens(embeddedTokens);
            return new Prism.Token(language, embeddedTokens, 'language-' + language, code);
        }
        /**
     * The languages for which JS templating will handle tagged template literals.
     *
     * JS templating isn't active for only JavaScript but also related languages like TypeScript, JSX, and TSX.
     */ var supportedLanguages = {
            javascript: true,
            js: true,
            typescript: true,
            ts: true,
            jsx: true,
            tsx: true
        };
        Prism.hooks.add('after-tokenize', function(env) {
            if (!(env.language in supportedLanguages)) return;
            /**
       * Finds and tokenizes all template strings with an embedded languages.
       *
       * @param {(Token | string)[]} tokens
       * @returns {void}
       */ function findTemplateStrings(tokens) {
                for(var i = 0, l = tokens.length; i < l; i++){
                    var token = tokens[i];
                    if (typeof token === 'string') continue;
                    var content = token.content;
                    if (!Array.isArray(content)) {
                        if (typeof content !== 'string') findTemplateStrings([
                            content
                        ]);
                        continue;
                    }
                    if (token.type === 'template-string') {
                        /**
             * A JavaScript template-string token will look like this:
             *
             * ["template-string", [
             *     ["template-punctuation", "`"],
             *     (
             *         An array of "string" and "interpolation" tokens. This is the simple string case.
             *         or
             *         ["embedded-code", "..."] This is the token containing the embedded code.
             *                                  It also has an alias which is the language of the embedded code.
             *     ),
             *     ["template-punctuation", "`"]
             * ]]
             */ var embedded = content[1];
                        if (content.length === 3 && typeof embedded !== 'string' && embedded.type === 'embedded-code') {
                            // get string content
                            var code = stringContent(embedded);
                            var alias = embedded.alias;
                            var language = Array.isArray(alias) ? alias[0] : alias;
                            var grammar = Prism.languages[language];
                            if (!grammar) continue;
                            content[1] = tokenizeEmbedded(code, grammar, language);
                        }
                    } else findTemplateStrings(content);
                }
            }
            findTemplateStrings(env.tokens);
        });
        /**
     * Returns the string content of a token or token stream.
     *
     * @param {string | Token | (string | Token)[]} value
     * @returns {string}
     */ function stringContent(value) {
            if (typeof value === 'string') return value;
            else if (Array.isArray(value)) return value.map(stringContent).join('');
            else return stringContent(value.content);
        }
    })(Prism);
}



// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 


$1ffd3d64aa89c36a$export$2e2bcd8739ae039.displayName = 'jsdoc';
$1ffd3d64aa89c36a$export$2e2bcd8739ae039.aliases = [];
function $1ffd3d64aa89c36a$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $3fdb7058e3046f24$export$2e2bcd8739ae039));
    Prism.register((0, $9f5c72e4d4e505c4$export$2e2bcd8739ae039));
    Prism.register((0, $971aaf7f210ab43d$export$2e2bcd8739ae039));
    (function(Prism) {
        var javascript = Prism.languages.javascript;
        var type = /\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})+\}/.source;
        var parameterPrefix = '(@(?:arg|argument|param|property)\\s+(?:' + type + '\\s+)?)';
        Prism.languages.jsdoc = Prism.languages.extend('javadoclike', {
            parameter: {
                // @param {string} foo - foo bar
                pattern: RegExp(parameterPrefix + /(?:(?!\s)[$\w\xA0-\uFFFF.])+(?=\s|$)/.source),
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            }
        });
        Prism.languages.insertBefore('jsdoc', 'keyword', {
            'optional-parameter': {
                // @param {string} [baz.foo="bar"] foo bar
                pattern: RegExp(parameterPrefix + /\[(?:(?!\s)[$\w\xA0-\uFFFF.])+(?:=[^[\]]+)?\](?=\s|$)/.source),
                lookbehind: true,
                inside: {
                    parameter: {
                        pattern: /(^\[)[$\w\xA0-\uFFFF\.]+/,
                        lookbehind: true,
                        inside: {
                            punctuation: /\./
                        }
                    },
                    code: {
                        pattern: /(=)[\s\S]*(?=\]$)/,
                        lookbehind: true,
                        inside: javascript,
                        alias: 'language-javascript'
                    },
                    punctuation: /[=[\]]/
                }
            },
            'class-name': [
                {
                    pattern: RegExp(/(@(?:augments|class|extends|interface|memberof!?|template|this|typedef)\s+(?:<TYPE>\s+)?)[A-Z]\w*(?:\.[A-Z]\w*)*/.source.replace(/<TYPE>/g, function() {
                        return type;
                    })),
                    lookbehind: true,
                    inside: {
                        punctuation: /\./
                    }
                },
                {
                    pattern: RegExp('(@[a-z]+\\s+)' + type),
                    lookbehind: true,
                    inside: {
                        string: javascript.string,
                        number: javascript.number,
                        boolean: javascript.boolean,
                        keyword: Prism.languages.typescript.keyword,
                        operator: /=>|\.\.\.|[&|?:*]/,
                        punctuation: /[.,;=<>{}()[\]]/
                    }
                }
            ],
            example: {
                pattern: /(@example\s+(?!\s))(?:[^@\s]|\s+(?!\s))+?(?=\s*(?:\*\s*)?(?:@\w|\*\/))/,
                lookbehind: true,
                inside: {
                    code: {
                        pattern: /^([\t ]*(?:\*\s*)?)\S.*$/m,
                        lookbehind: true,
                        inside: javascript,
                        alias: 'language-javascript'
                    }
                }
            }
        });
        Prism.languages.javadoclike.addSupport('javascript', Prism.languages.jsdoc);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$bb03f40051b66d6c$export$2e2bcd8739ae039.displayName = 'n4js';
$bb03f40051b66d6c$export$2e2bcd8739ae039.aliases = [
    'n4jsd'
];
function $bb03f40051b66d6c$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $9f5c72e4d4e505c4$export$2e2bcd8739ae039));
    Prism.languages.n4js = Prism.languages.extend('javascript', {
        // Keywords from N4JS language spec: https://numberfour.github.io/n4js/spec/N4JSSpec.html
        keyword: /\b(?:Array|any|boolean|break|case|catch|class|const|constructor|continue|debugger|declare|default|delete|do|else|enum|export|extends|false|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|module|new|null|number|package|private|protected|public|return|set|static|string|super|switch|this|throw|true|try|typeof|var|void|while|with|yield)\b/
    });
    Prism.languages.insertBefore('n4js', 'constant', {
        // Annotations in N4JS spec: https://numberfour.github.io/n4js/spec/N4JSSpec.html#_annotations
        annotation: {
            pattern: /@+\w+/,
            alias: 'operator'
        }
    });
    Prism.languages.n4jsd = Prism.languages.n4js;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$eb9ff5d3299d2f78$export$2e2bcd8739ae039.displayName = 'js-extras';
$eb9ff5d3299d2f78$export$2e2bcd8739ae039.aliases = [];
function $eb9ff5d3299d2f78$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $9f5c72e4d4e505c4$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.insertBefore('javascript', 'function-variable', {
            'method-variable': {
                pattern: RegExp('(\\.\\s*)' + Prism.languages.javascript['function-variable'].pattern.source),
                lookbehind: true,
                alias: [
                    'function-variable',
                    'method',
                    'function',
                    'property-access'
                ]
            }
        });
        Prism.languages.insertBefore('javascript', 'function', {
            method: {
                pattern: RegExp('(\\.\\s*)' + Prism.languages.javascript['function'].source),
                lookbehind: true,
                alias: [
                    'function',
                    'property-access'
                ]
            }
        });
        Prism.languages.insertBefore('javascript', 'constant', {
            'known-class-name': [
                {
                    // standard built-ins
                    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects
                    pattern: /\b(?:(?:Float(?:32|64)|(?:Int|Uint)(?:8|16|32)|Uint8Clamped)?Array|ArrayBuffer|BigInt|Boolean|DataView|Date|Error|Function|Intl|JSON|(?:Weak)?(?:Map|Set)|Math|Number|Object|Promise|Proxy|Reflect|RegExp|String|Symbol|WebAssembly)\b/,
                    alias: 'class-name'
                },
                {
                    // errors
                    pattern: /\b(?:[A-Z]\w*)Error\b/,
                    alias: 'class-name'
                }
            ]
        });
        /**
     * Replaces the `<ID>` placeholder in the given pattern with a pattern for general JS identifiers.
     *
     * @param {string} source
     * @param {string} [flags]
     * @returns {RegExp}
     */ function withId(source, flags) {
            return RegExp(source.replace(/<ID>/g, function() {
                return /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/.source;
            }), flags);
        }
        Prism.languages.insertBefore('javascript', 'keyword', {
            imports: {
                // https://tc39.es/ecma262/#sec-imports
                pattern: withId(/(\bimport\b\s*)(?:<ID>(?:\s*,\s*(?:\*\s*as\s+<ID>|\{[^{}]*\}))?|\*\s*as\s+<ID>|\{[^{}]*\})(?=\s*\bfrom\b)/.source),
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            exports: {
                // https://tc39.es/ecma262/#sec-exports
                pattern: withId(/(\bexport\b\s*)(?:\*(?:\s*as\s+<ID>)?(?=\s*\bfrom\b)|\{[^{}]*\})/.source),
                lookbehind: true,
                inside: Prism.languages.javascript
            }
        });
        Prism.languages.javascript['keyword'].unshift({
            pattern: /\b(?:as|default|export|from|import)\b/,
            alias: 'module'
        }, {
            pattern: /\b(?:await|break|catch|continue|do|else|finally|for|if|return|switch|throw|try|while|yield)\b/,
            alias: 'control-flow'
        }, {
            pattern: /\bnull\b/,
            alias: [
                'null',
                'nil'
            ]
        }, {
            pattern: /\bundefined\b/,
            alias: 'nil'
        });
        Prism.languages.insertBefore('javascript', 'operator', {
            spread: {
                pattern: /\.{3}/,
                alias: 'operator'
            },
            arrow: {
                pattern: /=>/,
                alias: 'operator'
            }
        });
        Prism.languages.insertBefore('javascript', 'punctuation', {
            'property-access': {
                pattern: withId(/(\.\s*)#?<ID>/.source),
                lookbehind: true
            },
            'maybe-class-name': {
                pattern: /(^|[^$\w\xA0-\uFFFF])[A-Z][$\w\xA0-\uFFFF]+/,
                lookbehind: true
            },
            dom: {
                // this contains only a few commonly used DOM variables
                pattern: /\b(?:document|(?:local|session)Storage|location|navigator|performance|window)\b/,
                alias: 'variable'
            },
            console: {
                pattern: /\bconsole(?=\s*\.)/,
                alias: 'class-name'
            }
        });
        // add 'maybe-class-name' to tokens which might be a class name
        var maybeClassNameTokens = [
            'function',
            'function-variable',
            'method',
            'method-variable',
            'property-access'
        ];
        for(var i = 0; i < maybeClassNameTokens.length; i++){
            var token = maybeClassNameTokens[i];
            var value = Prism.languages.javascript[token];
            // convert regex to object
            if (Prism.util.type(value) === 'RegExp') value = Prism.languages.javascript[token] = {
                pattern: value
            };
            // keep in mind that we don't support arrays
            var inside = value.inside || {};
            value.inside = inside;
            inside['maybe-class-name'] = /^[A-Z][\s\S]*/;
        }
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$ab6ad1272fe5d0de$export$2e2bcd8739ae039.displayName = 'json5';
$ab6ad1272fe5d0de$export$2e2bcd8739ae039.aliases = [];
function $ab6ad1272fe5d0de$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $15d2f325237e0784$export$2e2bcd8739ae039));
    (function(Prism) {
        var string = /("|')(?:\\(?:\r\n?|\n|.)|(?!\1)[^\\\r\n])*\1/;
        Prism.languages.json5 = Prism.languages.extend('json', {
            property: [
                {
                    pattern: RegExp(string.source + '(?=\\s*:)'),
                    greedy: true
                },
                {
                    pattern: /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/,
                    alias: 'unquoted'
                }
            ],
            string: {
                pattern: string,
                greedy: true
            },
            number: /[+-]?\b(?:NaN|Infinity|0x[a-fA-F\d]+)\b|[+-]?(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+\b)?/
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$7aed4cc800fa5add$export$2e2bcd8739ae039.displayName = 'jsonp';
$7aed4cc800fa5add$export$2e2bcd8739ae039.aliases = [];
function $7aed4cc800fa5add$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $15d2f325237e0784$export$2e2bcd8739ae039));
    Prism.languages.jsonp = Prism.languages.extend('json', {
        punctuation: /[{}[\]();,.]/
    });
    Prism.languages.insertBefore('jsonp', 'punctuation', {
        function: /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*\()/
    });
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $d044b3e9acc7ccc1$export$2e2bcd8739ae039.displayName = 'jsstacktrace';
$d044b3e9acc7ccc1$export$2e2bcd8739ae039.aliases = [];
function $d044b3e9acc7ccc1$export$2e2bcd8739ae039(Prism) {
    Prism.languages.jsstacktrace = {
        'error-message': {
            pattern: /^\S.*/m,
            alias: 'string'
        },
        'stack-frame': {
            pattern: /(^[ \t]+)at[ \t].*/m,
            lookbehind: true,
            inside: {
                'not-my-code': {
                    pattern: /^at[ \t]+(?!\s)(?:node\.js|<unknown>|.*(?:node_modules|\(<anonymous>\)|\(<unknown>|<anonymous>$|\(internal\/|\(node\.js)).*/m,
                    alias: 'comment'
                },
                filename: {
                    pattern: /(\bat\s+(?!\s)|\()(?:[a-zA-Z]:)?[^():]+(?=:)/,
                    lookbehind: true,
                    alias: 'url'
                },
                function: {
                    pattern: /(\bat\s+(?:new\s+)?)(?!\s)[_$a-zA-Z\xA0-\uFFFF<][.$\w\xA0-\uFFFF<>]*/,
                    lookbehind: true,
                    inside: {
                        punctuation: /\./
                    }
                },
                punctuation: /[()]/,
                keyword: /\b(?:at|new)\b/,
                alias: {
                    pattern: /\[(?:as\s+)?(?!\s)[_$a-zA-Z\xA0-\uFFFF][$\w\xA0-\uFFFF]*\]/,
                    alias: 'variable'
                },
                'line-number': {
                    pattern: /:\d+(?::\d+)?\b/,
                    alias: 'number',
                    inside: {
                        punctuation: /:/
                    }
                }
            }
        }
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $b96993469faeeb1c$export$2e2bcd8739ae039.displayName = 'julia';
$b96993469faeeb1c$export$2e2bcd8739ae039.aliases = [];
function $b96993469faeeb1c$export$2e2bcd8739ae039(Prism) {
    Prism.languages.julia = {
        comment: {
            // support one level of nested comments
            // https://github.com/JuliaLang/julia/pull/6128
            pattern: /(^|[^\\])(?:#=(?:[^#=]|=(?!#)|#(?!=)|#=(?:[^#=]|=(?!#)|#(?!=))*=#)*=#|#.*)/,
            lookbehind: true
        },
        regex: {
            // https://docs.julialang.org/en/v1/manual/strings/#Regular-Expressions-1
            pattern: /r"(?:\\.|[^"\\\r\n])*"[imsx]{0,4}/,
            greedy: true
        },
        string: {
            // https://docs.julialang.org/en/v1/manual/strings/#String-Basics-1
            // https://docs.julialang.org/en/v1/manual/strings/#non-standard-string-literals-1
            // https://docs.julialang.org/en/v1/manual/running-external-programs/#Running-External-Programs-1
            pattern: /"""[\s\S]+?"""|(?:\b\w+)?"(?:\\.|[^"\\\r\n])*"|`(?:[^\\`\r\n]|\\.)*`/,
            greedy: true
        },
        char: {
            // https://docs.julialang.org/en/v1/manual/strings/#man-characters-1
            pattern: /(^|[^\w'])'(?:\\[^\r\n][^'\r\n]*|[^\\\r\n])'/,
            lookbehind: true,
            greedy: true
        },
        keyword: /\b(?:abstract|baremodule|begin|bitstype|break|catch|ccall|const|continue|do|else|elseif|end|export|finally|for|function|global|if|immutable|import|importall|in|let|local|macro|module|print|println|quote|return|struct|try|type|typealias|using|while)\b/,
        boolean: /\b(?:false|true)\b/,
        number: /(?:\b(?=\d)|\B(?=\.))(?:0[box])?(?:[\da-f]+(?:_[\da-f]+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[efp][+-]?\d+(?:_\d+)*)?j?/i,
        // https://docs.julialang.org/en/v1/manual/mathematical-operations/
        // https://docs.julialang.org/en/v1/manual/mathematical-operations/#Operator-Precedence-and-Associativity-1
        operator: /&&|\|\||[-+*^%÷⊻&$\\]=?|\/[\/=]?|!=?=?|\|[=>]?|<(?:<=?|[=:|])?|>(?:=|>>?=?)?|==?=?|[~≠≤≥'√∛]/,
        punctuation: /::?|[{}[\]();,.?]/,
        // https://docs.julialang.org/en/v1/base/numbers/#Base.im
        constant: /\b(?:(?:Inf|NaN)(?:16|32|64)?|im|pi)\b|[πℯ]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $7c30d02132551dfa$export$2e2bcd8739ae039.displayName = 'keepalived';
$7c30d02132551dfa$export$2e2bcd8739ae039.aliases = [];
function $7c30d02132551dfa$export$2e2bcd8739ae039(Prism) {
    Prism.languages.keepalived = {
        comment: {
            pattern: /[#!].*/,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/,
            lookbehind: true,
            greedy: true
        },
        // support IPv4, IPv6, subnet mask
        ip: {
            pattern: RegExp(/\b(?:(?:(?:[\da-f]{1,4}:){7}[\da-f]{1,4}|(?:[\da-f]{1,4}:){6}:[\da-f]{1,4}|(?:[\da-f]{1,4}:){5}:(?:[\da-f]{1,4}:)?[\da-f]{1,4}|(?:[\da-f]{1,4}:){4}:(?:[\da-f]{1,4}:){0,2}[\da-f]{1,4}|(?:[\da-f]{1,4}:){3}:(?:[\da-f]{1,4}:){0,3}[\da-f]{1,4}|(?:[\da-f]{1,4}:){2}:(?:[\da-f]{1,4}:){0,4}[\da-f]{1,4}|(?:[\da-f]{1,4}:){6}<ipv4>|(?:[\da-f]{1,4}:){0,5}:<ipv4>|::(?:[\da-f]{1,4}:){0,5}<ipv4>|[\da-f]{1,4}::(?:[\da-f]{1,4}:){0,5}[\da-f]{1,4}|::(?:[\da-f]{1,4}:){0,6}[\da-f]{1,4}|(?:[\da-f]{1,4}:){1,7}:)(?:\/\d{1,3})?|<ipv4>(?:\/\d{1,2})?)\b/.source.replace(/<ipv4>/g, function() {
                return /(?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d))/.source;
            }), 'i'),
            alias: 'number'
        },
        // support *nix / Windows, directory / file
        path: {
            pattern: /(\s)\/(?:[^\/\s]+\/)*[^\/\s]*|\b[a-zA-Z]:\\(?:[^\\\s]+\\)*[^\\\s]*/,
            lookbehind: true,
            alias: 'string'
        },
        variable: /\$\{?\w+\}?/,
        email: {
            pattern: /[\w-]+@[\w-]+(?:\.[\w-]{2,3}){1,2}/,
            alias: 'string'
        },
        'conditional-configuration': {
            pattern: /@\^?[\w-]+/,
            alias: 'variable'
        },
        operator: /=/,
        property: /\b(?:BFD_CHECK|DNS_CHECK|FILE_CHECK|HTTP_GET|MISC_CHECK|NAME|PING_CHECK|SCRIPTS|SMTP_CHECK|SSL|SSL_GET|TCP_CHECK|UDP_CHECK|accept|advert_int|alpha|auth_pass|auth_type|authentication|bfd_cpu_affinity|bfd_instance|bfd_no_swap|bfd_priority|bfd_process_name|bfd_rlimit_rttime|bfd_rt_priority|bind_if|bind_port|bindto|ca|certificate|check_unicast_src|checker|checker_cpu_affinity|checker_log_all_failures|checker_no_swap|checker_priority|checker_rlimit_rttime|checker_rt_priority|child_wait_time|connect_ip|connect_port|connect_timeout|dbus_service_name|debug|default_interface|delay|delay_before_retry|delay_loop|digest|dont_track_primary|dynamic|dynamic_interfaces|enable_(?:dbus|script_security|sni|snmp_checker|snmp_rfc|snmp_rfcv2|snmp_rfcv3|snmp_vrrp|traps)|end|fall|fast_recovery|file|flag-[123]|fork_delay|full_command|fwmark|garp_group|garp_interval|garp_lower_prio_delay|garp_lower_prio_repeat|garp_master_delay|garp_master_refresh|garp_master_refresh_repeat|garp_master_repeat|global_defs|global_tracking|gna_interval|group|ha_suspend|hashed|helo_name|higher_prio_send_advert|hoplimit|http_protocol|hysteresis|idle_tx|include|inhibit_on_failure|init_fail|init_file|instance|interface|interfaces|interval|ip_family|ipvs_process_name|keepalived.conf|kernel_rx_buf_size|key|linkbeat_interfaces|linkbeat_use_polling|log_all_failures|log_unknown_vrids|lower_prio_no_advert|lthreshold|lvs_flush|lvs_flush_onstop|lvs_method|lvs_netlink_cmd_rcv_bufs|lvs_netlink_cmd_rcv_bufs_force|lvs_netlink_monitor_rcv_bufs|lvs_netlink_monitor_rcv_bufs_force|lvs_notify_fifo|lvs_notify_fifo_script|lvs_sched|lvs_sync_daemon|max_auto_priority|max_hops|mcast_src_ip|mh-fallback|mh-port|min_auto_priority_delay|min_rx|min_tx|misc_dynamic|misc_path|misc_timeout|multiplier|name|namespace_with_ipsets|native_ipv6|neighbor_ip|net_namespace|net_namespace_ipvs|nftables|nftables_counters|nftables_ifindex|nftables_priority|no_accept|no_checker_emails|no_email_faults|nopreempt|notification_email|notification_email_from|notify|notify_backup|notify_deleted|notify_down|notify_fault|notify_fifo|notify_fifo_script|notify_master|notify_master_rx_lower_pri|notify_priority_changes|notify_stop|notify_up|old_unicast_checksum|omega|ops|param_match|passive|password|path|persistence_engine|persistence_granularity|persistence_timeout|preempt|preempt_delay|priority|process|process_monitor_rcv_bufs|process_monitor_rcv_bufs_force|process_name|process_names|promote_secondaries|protocol|proxy_arp|proxy_arp_pvlan|quorum|quorum_down|quorum_max|quorum_up|random_seed|real_server|regex|regex_max_offset|regex_min_offset|regex_no_match|regex_options|regex_stack|reload_repeat|reload_time_file|require_reply|retry|rise|router_id|rs_init_notifies|script|script_user|sh-fallback|sh-port|shutdown_script|shutdown_script_timeout|skip_check_adv_addr|smtp_alert|smtp_alert_checker|smtp_alert_vrrp|smtp_connect_timeout|smtp_helo_name|smtp_server|snmp_socket|sorry_server|sorry_server_inhibit|sorry_server_lvs_method|source_ip|start|startup_script|startup_script_timeout|state|static_ipaddress|static_routes|static_rules|status_code|step|strict_mode|sync_group_tracking_weight|terminate_delay|timeout|track_bfd|track_file|track_group|track_interface|track_process|track_script|track_src_ip|ttl|type|umask|unicast_peer|unicast_src_ip|unicast_ttl|url|use_ipvlan|use_pid_dir|use_vmac|user|uthreshold|val[123]|version|virtual_ipaddress|virtual_ipaddress_excluded|virtual_router_id|virtual_routes|virtual_rules|virtual_server|virtual_server_group|virtualhost|vmac_xmit_base|vrrp|vrrp_(?:check_unicast_src|cpu_affinity|garp_interval|garp_lower_prio_delay|garp_lower_prio_repeat|garp_master_delay|garp_master_refresh|garp_master_refresh_repeat|garp_master_repeat|gna_interval|higher_prio_send_advert|instance|ipsets|iptables|lower_prio_no_advert|mcast_group4|mcast_group6|min_garp|netlink_cmd_rcv_bufs|netlink_cmd_rcv_bufs_force|netlink_monitor_rcv_bufs|netlink_monitor_rcv_bufs_force|no_swap|notify_fifo|notify_fifo_script|notify_priority_changes|priority|process_name|rlimit_rttime|rt_priority|rx_bufs_multiplier|rx_bufs_policy|script|skip_check_adv_addr|startup_delay|strict|sync_group|track_process|version)|warmup|weight)\b/,
        constant: /\b(?:A|AAAA|AH|BACKUP|CNAME|DR|MASTER|MX|NAT|NS|PASS|SCTP|SOA|TCP|TUN|TXT|UDP|dh|fo|lblc|lblcr|lc|mh|nq|ovf|rr|sed|sh|wlc|wrr)\b/,
        number: {
            pattern: /(^|[^\w.-])-?\d+(?:\.\d+)?/,
            lookbehind: true
        },
        boolean: /\b(?:false|no|off|on|true|yes)\b/,
        punctuation: /[\{\}]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $1ee6f3ef2718464c$export$2e2bcd8739ae039.displayName = 'keyman';
$1ee6f3ef2718464c$export$2e2bcd8739ae039.aliases = [];
function $1ee6f3ef2718464c$export$2e2bcd8739ae039(Prism) {
    Prism.languages.keyman = {
        comment: {
            pattern: /\bc .*/i,
            greedy: true
        },
        string: {
            pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
            greedy: true
        },
        'virtual-key': {
            pattern: /\[\s*(?:(?:ALT|CAPS|CTRL|LALT|LCTRL|NCAPS|RALT|RCTRL|SHIFT)\s+)*(?:[TKU]_[\w?]+|[A-E]\d\d?|"[^"\r\n]*"|'[^'\r\n]*')\s*\]/i,
            greedy: true,
            alias: 'function' // alias for styles
        },
        // https://help.keyman.com/developer/language/guide/headers
        'header-keyword': {
            pattern: /&\w+/,
            alias: 'bold' // alias for styles
        },
        'header-statement': {
            pattern: /\b(?:bitmap|bitmaps|caps always off|caps on only|copyright|hotkey|language|layout|message|name|shift frees caps|version)\b/i,
            alias: 'bold' // alias for styles
        },
        'rule-keyword': {
            pattern: /\b(?:any|baselayout|beep|call|context|deadkey|dk|if|index|layer|notany|nul|outs|platform|reset|return|save|set|store|use)\b/i,
            alias: 'keyword'
        },
        'structural-keyword': {
            pattern: /\b(?:ansi|begin|group|match|newcontext|nomatch|postkeystroke|readonly|unicode|using keys)\b/i,
            alias: 'keyword'
        },
        'compile-target': {
            pattern: /\$(?:keyman|keymanonly|keymanweb|kmfl|weaver):/i,
            alias: 'property'
        },
        // U+####, x###, d### characters and numbers
        number: /\b(?:U\+[\dA-F]+|d\d+|x[\da-f]+|\d+)\b/i,
        operator: /[+>\\$]|\.\./,
        punctuation: /[()=,]/
    };
}



// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $4cdbc21cd3056574$export$2e2bcd8739ae039.displayName = 'kumir';
$4cdbc21cd3056574$export$2e2bcd8739ae039.aliases = [
    'kum'
];
function $4cdbc21cd3056574$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        /**
     * Regular expression for characters that are not allowed in identifiers.
     *
     * @type {string}
     */ var nonId = /\s\x00-\x1f\x22-\x2f\x3a-\x3f\x5b-\x5e\x60\x7b-\x7e/.source;
        /**
     * Surround a regular expression for IDs with patterns for non-ID sequences.
     *
     * @param {string} pattern A regular expression for identifiers.
     * @param {string} [flags] The regular expression flags.
     * @returns {RegExp} A wrapped regular expression for identifiers.
     */ function wrapId(pattern, flags) {
            return RegExp(pattern.replace(/<nonId>/g, nonId), flags);
        }
        Prism.languages.kumir = {
            comment: {
                pattern: /\|.*/
            },
            prolog: {
                pattern: /#.*/,
                greedy: true
            },
            string: {
                pattern: /"[^\n\r"]*"|'[^\n\r']*'/,
                greedy: true
            },
            boolean: {
                pattern: wrapId(/(^|[<nonId>])(?:да|нет)(?=[<nonId>]|$)/.source),
                lookbehind: true
            },
            'operator-word': {
                pattern: wrapId(/(^|[<nonId>])(?:и|или|не)(?=[<nonId>]|$)/.source),
                lookbehind: true,
                alias: 'keyword'
            },
            'system-variable': {
                pattern: wrapId(/(^|[<nonId>])знач(?=[<nonId>]|$)/.source),
                lookbehind: true,
                alias: 'keyword'
            },
            type: [
                {
                    pattern: wrapId(/(^|[<nonId>])(?:вещ|лит|лог|сим|цел)(?:\x20*таб)?(?=[<nonId>]|$)/.source),
                    lookbehind: true,
                    alias: 'builtin'
                },
                {
                    pattern: wrapId(/(^|[<nonId>])(?:компл|сканкод|файл|цвет)(?=[<nonId>]|$)/.source),
                    lookbehind: true,
                    alias: 'important'
                }
            ],
            /**
       * Should be performed after searching for type names because of "таб".
       * "таб" is a reserved word, but never used without a preceding type name.
       * "НАЗНАЧИТЬ", "Фввод", and "Фвывод" are not reserved words.
       */ keyword: {
                pattern: wrapId(/(^|[<nonId>])(?:алг|арг(?:\x20*рез)?|ввод|ВКЛЮЧИТЬ|вс[её]|выбор|вывод|выход|дано|для|до|дс|если|иначе|исп|использовать|кон(?:(?:\x20+|_)исп)?|кц(?:(?:\x20+|_)при)?|надо|нач|нс|нц|от|пауза|пока|при|раза?|рез|стоп|таб|то|утв|шаг)(?=[<nonId>]|$)/.source),
                lookbehind: true
            },
            /** Should be performed after searching for reserved words. */ name: {
                // eslint-disable-next-line regexp/no-super-linear-backtracking
                pattern: wrapId(/(^|[<nonId>])[^\d<nonId>][^<nonId>]*(?:\x20+[^<nonId>]+)*(?=[<nonId>]|$)/.source),
                lookbehind: true
            },
            /** Should be performed after searching for names. */ number: {
                pattern: wrapId(/(^|[<nonId>])(?:\B\$[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)(?=[<nonId>]|$)/.source, 'i'),
                lookbehind: true
            },
            /** Should be performed after searching for words. */ punctuation: /:=|[(),:;\[\]]/,
            /**
       * Should be performed after searching for
       * - numeric constants (because of "+" and "-");
       * - punctuation marks (because of ":=" and "=").
       */ 'operator-char': {
                pattern: /\*\*?|<[=>]?|>=?|[-+/=]/,
                alias: 'operator'
            }
        };
        Prism.languages.kum = Prism.languages.kumir;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $d3fcd032b357bb2d$export$2e2bcd8739ae039.displayName = 'kusto';
$d3fcd032b357bb2d$export$2e2bcd8739ae039.aliases = [];
function $d3fcd032b357bb2d$export$2e2bcd8739ae039(Prism) {
    Prism.languages.kusto = {
        comment: {
            pattern: /\/\/.*/,
            greedy: true
        },
        string: {
            pattern: /```[\s\S]*?```|[hH]?(?:"(?:[^\r\n\\"]|\\.)*"|'(?:[^\r\n\\']|\\.)*'|@(?:"[^\r\n"]*"|'[^\r\n']*'))/,
            greedy: true
        },
        verb: {
            pattern: /(\|\s*)[a-z][\w-]*/i,
            lookbehind: true,
            alias: 'keyword'
        },
        command: {
            pattern: /\.[a-z][a-z\d-]*\b/,
            alias: 'keyword'
        },
        'class-name': /\b(?:bool|datetime|decimal|dynamic|guid|int|long|real|string|timespan)\b/,
        keyword: /\b(?:access|alias|and|anti|as|asc|auto|between|by|(?:contains|(?:ends|starts)with|has(?:perfix|suffix)?)(?:_cs)?|database|declare|desc|external|from|fullouter|has_all|in|ingestion|inline|inner|innerunique|into|(?:left|right)(?:anti(?:semi)?|inner|outer|semi)?|let|like|local|not|of|on|or|pattern|print|query_parameters|range|restrict|schema|set|step|table|tables|to|view|where|with|matches\s+regex|nulls\s+(?:first|last))(?![\w-])/,
        boolean: /\b(?:false|null|true)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/,
        datetime: [
            {
                // RFC 822 + RFC 850
                pattern: /\b(?:(?:Fri|Friday|Mon|Monday|Sat|Saturday|Sun|Sunday|Thu|Thursday|Tue|Tuesday|Wed|Wednesday)\s*,\s*)?\d{1,2}(?:\s+|-)(?:Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)(?:\s+|-)\d{2}\s+\d{2}:\d{2}(?::\d{2})?(?:\s*(?:\b(?:[A-Z]|(?:[ECMT][DS]|GM|U)T)|[+-]\d{4}))?\b/,
                alias: 'number'
            },
            {
                // ISO 8601
                pattern: /[+-]?\b(?:\d{4}-\d{2}-\d{2}(?:[ T]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)?|\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)Z?/,
                alias: 'number'
            }
        ],
        number: /\b(?:0x[0-9A-Fa-f]+|\d+(?:\.\d+)?(?:[Ee][+-]?\d+)?)(?:(?:min|sec|[mnµ]s|[dhms]|microsecond|tick)\b)?|[+-]?\binf\b/,
        operator: /=>|[!=]~|[!=<>]=?|[-+*/%|]|\.\./,
        punctuation: /[()\[\]{},;.:]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $450490f6a0da68bd$export$2e2bcd8739ae039.displayName = 'latex';
$450490f6a0da68bd$export$2e2bcd8739ae039.aliases = [
    'context',
    'tex'
];
function $450490f6a0da68bd$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var funcPattern = /\\(?:[^a-z()[\]]|[a-z*]+)/i;
        var insideEqu = {
            'equation-command': {
                pattern: funcPattern,
                alias: 'regex'
            }
        };
        Prism.languages.latex = {
            comment: /%.*/,
            // the verbatim environment prints whitespace to the document
            cdata: {
                pattern: /(\\begin\{((?:lstlisting|verbatim)\*?)\})[\s\S]*?(?=\\end\{\2\})/,
                lookbehind: true
            },
            /*
       * equations can be between $$ $$ or $ $ or \( \) or \[ \]
       * (all are multiline)
       */ equation: [
                {
                    pattern: /\$\$(?:\\[\s\S]|[^\\$])+\$\$|\$(?:\\[\s\S]|[^\\$])+\$|\\\([\s\S]*?\\\)|\\\[[\s\S]*?\\\]/,
                    inside: insideEqu,
                    alias: 'string'
                },
                {
                    pattern: /(\\begin\{((?:align|eqnarray|equation|gather|math|multline)\*?)\})[\s\S]*?(?=\\end\{\2\})/,
                    lookbehind: true,
                    inside: insideEqu,
                    alias: 'string'
                }
            ],
            /*
       * arguments which are keywords or references are highlighted
       * as keywords
       */ keyword: {
                pattern: /(\\(?:begin|cite|documentclass|end|label|ref|usepackage)(?:\[[^\]]+\])?\{)[^}]+(?=\})/,
                lookbehind: true
            },
            url: {
                pattern: /(\\url\{)[^}]+(?=\})/,
                lookbehind: true
            },
            /*
       * section or chapter headlines are highlighted as bold so that
       * they stand out more
       */ headline: {
                pattern: /(\\(?:chapter|frametitle|paragraph|part|section|subparagraph|subsection|subsubparagraph|subsubsection|subsubsubparagraph)\*?(?:\[[^\]]+\])?\{)[^}]+(?=\})/,
                lookbehind: true,
                alias: 'class-name'
            },
            function: {
                pattern: funcPattern,
                alias: 'selector'
            },
            punctuation: /[[\]{}&]/
        };
        Prism.languages.tex = Prism.languages.latex;
        Prism.languages.context = Prism.languages.latex;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 


$28745139b7e39184$export$2e2bcd8739ae039.displayName = 'latte';
$28745139b7e39184$export$2e2bcd8739ae039.aliases = [];
function $28745139b7e39184$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    Prism.register((0, $a400735491c1aa4e$export$2e2bcd8739ae039));
    Prism.register((0, $158311e91e281aed$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.latte = {
            comment: /^\{\*[\s\S]*/,
            'latte-tag': {
                // https://latte.nette.org/en/tags
                pattern: /(^\{(?:\/(?=[a-z]))?)(?:[=_]|[a-z]\w*\b(?!\())/i,
                lookbehind: true,
                alias: 'important'
            },
            delimiter: {
                pattern: /^\{\/?|\}$/,
                alias: 'punctuation'
            },
            php: {
                pattern: /\S(?:[\s\S]*\S)?/,
                alias: 'language-php',
                inside: Prism.languages.php
            }
        };
        var markupLatte = Prism.languages.extend('markup', {});
        Prism.languages.insertBefore('inside', 'attr-value', {
            'n-attr': {
                pattern: /n:[\w-]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+))?/,
                inside: {
                    'attr-name': {
                        pattern: /^[^\s=]+/,
                        alias: 'important'
                    },
                    'attr-value': {
                        pattern: /=[\s\S]+/,
                        inside: {
                            punctuation: [
                                /^=/,
                                {
                                    pattern: /^(\s*)["']|["']$/,
                                    lookbehind: true
                                }
                            ],
                            php: {
                                pattern: /\S(?:[\s\S]*\S)?/,
                                inside: Prism.languages.php
                            }
                        }
                    }
                }
            }
        }, markupLatte.tag);
        Prism.hooks.add('before-tokenize', function(env) {
            if (env.language !== 'latte') return;
            var lattePattern = /\{\*[\s\S]*?\*\}|\{[^'"\s{}*](?:[^"'/{}]|\/(?![*/])|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|\/\*(?:[^*]|\*(?!\/))*\*\/)*\}/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'latte', lattePattern);
            env.grammar = markupLatte;
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'latte');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $c6a13ead09099e31$export$2e2bcd8739ae039.displayName = 'scheme';
$c6a13ead09099e31$export$2e2bcd8739ae039.aliases = [];
function $c6a13ead09099e31$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.scheme = {
            // this supports "normal" single-line comments:
            //   ; comment
            // and (potentially nested) multiline comments:
            //   #| comment #| nested |# still comment |#
            // (only 1 level of nesting is supported)
            comment: /;.*|#;\s*(?:\((?:[^()]|\([^()]*\))*\)|\[(?:[^\[\]]|\[[^\[\]]*\])*\])|#\|(?:[^#|]|#(?!\|)|\|(?!#)|#\|(?:[^#|]|#(?!\|)|\|(?!#))*\|#)*\|#/,
            string: {
                pattern: /"(?:[^"\\]|\\.)*"/,
                greedy: true
            },
            symbol: {
                pattern: /'[^()\[\]#'\s]+/,
                greedy: true
            },
            char: {
                pattern: /#\\(?:[ux][a-fA-F\d]+\b|[-a-zA-Z]+\b|[\uD800-\uDBFF][\uDC00-\uDFFF]|\S)/,
                greedy: true
            },
            'lambda-parameter': [
                // https://www.cs.cmu.edu/Groups/AI/html/r4rs/r4rs_6.html#SEC30
                {
                    pattern: /((?:^|[^'`#])[(\[]lambda\s+)(?:[^|()\[\]'\s]+|\|(?:[^\\|]|\\.)*\|)/,
                    lookbehind: true
                },
                {
                    pattern: /((?:^|[^'`#])[(\[]lambda\s+[(\[])[^()\[\]']+/,
                    lookbehind: true
                }
            ],
            keyword: {
                pattern: /((?:^|[^'`#])[(\[])(?:begin|case(?:-lambda)?|cond(?:-expand)?|define(?:-library|-macro|-record-type|-syntax|-values)?|defmacro|delay(?:-force)?|do|else|except|export|guard|if|import|include(?:-ci|-library-declarations)?|lambda|let(?:rec)?(?:-syntax|-values|\*)?|let\*-values|only|parameterize|prefix|(?:quasi-?)?quote|rename|set!|syntax-(?:case|rules)|unless|unquote(?:-splicing)?|when)(?=[()\[\]\s]|$)/,
                lookbehind: true
            },
            builtin: {
                // all functions of the base library of R7RS plus some of built-ins of R5Rs
                pattern: /((?:^|[^'`#])[(\[])(?:abs|and|append|apply|assoc|ass[qv]|binary-port\?|boolean=?\?|bytevector(?:-append|-copy|-copy!|-length|-u8-ref|-u8-set!|\?)?|caar|cadr|call-with-(?:current-continuation|port|values)|call\/cc|car|cdar|cddr|cdr|ceiling|char(?:->integer|-ready\?|\?|<\?|<=\?|=\?|>\?|>=\?)|close-(?:input-port|output-port|port)|complex\?|cons|current-(?:error|input|output)-port|denominator|dynamic-wind|eof-object\??|eq\?|equal\?|eqv\?|error|error-object(?:-irritants|-message|\?)|eval|even\?|exact(?:-integer-sqrt|-integer\?|\?)?|expt|features|file-error\?|floor(?:-quotient|-remainder|\/)?|flush-output-port|for-each|gcd|get-output-(?:bytevector|string)|inexact\??|input-port(?:-open\?|\?)|integer(?:->char|\?)|lcm|length|list(?:->string|->vector|-copy|-ref|-set!|-tail|\?)?|make-(?:bytevector|list|parameter|string|vector)|map|max|member|memq|memv|min|modulo|negative\?|newline|not|null\?|number(?:->string|\?)|numerator|odd\?|open-(?:input|output)-(?:bytevector|string)|or|output-port(?:-open\?|\?)|pair\?|peek-char|peek-u8|port\?|positive\?|procedure\?|quotient|raise|raise-continuable|rational\?|rationalize|read-(?:bytevector|bytevector!|char|error\?|line|string|u8)|real\?|remainder|reverse|round|set-c[ad]r!|square|string(?:->list|->number|->symbol|->utf8|->vector|-append|-copy|-copy!|-fill!|-for-each|-length|-map|-ref|-set!|\?|<\?|<=\?|=\?|>\?|>=\?)?|substring|symbol(?:->string|\?|=\?)|syntax-error|textual-port\?|truncate(?:-quotient|-remainder|\/)?|u8-ready\?|utf8->string|values|vector(?:->list|->string|-append|-copy|-copy!|-fill!|-for-each|-length|-map|-ref|-set!|\?)?|with-exception-handler|write-(?:bytevector|char|string|u8)|zero\?)(?=[()\[\]\s]|$)/,
                lookbehind: true
            },
            operator: {
                pattern: /((?:^|[^'`#])[(\[])(?:[-+*%/]|[<>]=?|=>?)(?=[()\[\]\s]|$)/,
                lookbehind: true
            },
            number: {
                // The number pattern from [the R7RS spec](https://small.r7rs.org/attachment/r7rs.pdf).
                //
                // <number>      := <num 2>|<num 8>|<num 10>|<num 16>
                // <num R>       := <prefix R><complex R>
                // <complex R>   := <real R>(?:@<real R>|<imaginary R>)?|<imaginary R>
                // <imaginary R> := [+-](?:<ureal R>|(?:inf|nan)\.0)?i
                // <real R>      := [+-]?<ureal R>|[+-](?:inf|nan)\.0
                // <ureal R>     := <uint R>(?:\/<uint R>)?
                //                | <decimal R>
                //
                // <decimal 10>  := (?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?
                // <uint R>      := <digit R>+
                // <prefix R>    := <radix R>(?:#[ei])?|(?:#[ei])?<radix R>
                // <radix 2>     := #b
                // <radix 8>     := #o
                // <radix 10>    := (?:#d)?
                // <radix 16>    := #x
                // <digit 2>     := [01]
                // <digit 8>     := [0-7]
                // <digit 10>    := \d
                // <digit 16>    := [0-9a-f]
                //
                // The problem with this grammar is that the resulting regex is way to complex, so we simplify by grouping all
                // non-decimal bases together. This results in a decimal (dec) and combined binary, octal, and hexadecimal (box)
                // pattern:
                pattern: RegExp(SortedBNF({
                    '<ureal dec>': /\d+(?:\/\d+)|(?:\d+(?:\.\d*)?|\.\d+)(?:[esfdl][+-]?\d+)?/.source,
                    '<real dec>': /[+-]?<ureal dec>|[+-](?:inf|nan)\.0/.source,
                    '<imaginary dec>': /[+-](?:<ureal dec>|(?:inf|nan)\.0)?i/.source,
                    '<complex dec>': /<real dec>(?:@<real dec>|<imaginary dec>)?|<imaginary dec>/.source,
                    '<num dec>': /(?:#d(?:#[ei])?|#[ei](?:#d)?)?<complex dec>/.source,
                    '<ureal box>': /[0-9a-f]+(?:\/[0-9a-f]+)?/.source,
                    '<real box>': /[+-]?<ureal box>|[+-](?:inf|nan)\.0/.source,
                    '<imaginary box>': /[+-](?:<ureal box>|(?:inf|nan)\.0)?i/.source,
                    '<complex box>': /<real box>(?:@<real box>|<imaginary box>)?|<imaginary box>/.source,
                    '<num box>': /#[box](?:#[ei])?|(?:#[ei])?#[box]<complex box>/.source,
                    '<number>': /(^|[()\[\]\s])(?:<num dec>|<num box>)(?=[()\[\]\s]|$)/.source
                }), 'i'),
                lookbehind: true
            },
            boolean: {
                pattern: /(^|[()\[\]\s])#(?:[ft]|false|true)(?=[()\[\]\s]|$)/,
                lookbehind: true
            },
            function: {
                pattern: /((?:^|[^'`#])[(\[])(?:[^|()\[\]'\s]+|\|(?:[^\\|]|\\.)*\|)(?=[()\[\]\s]|$)/,
                lookbehind: true
            },
            identifier: {
                pattern: /(^|[()\[\]\s])\|(?:[^\\|]|\\.)*\|(?=[()\[\]\s]|$)/,
                lookbehind: true,
                greedy: true
            },
            punctuation: /[()\[\]']/
        };
        /**
     * Given a topologically sorted BNF grammar, this will return the RegExp source of last rule of the grammar.
     *
     * @param {Record<string, string>} grammar
     * @returns {string}
     */ function SortedBNF(grammar) {
            for(var key in grammar)grammar[key] = grammar[key].replace(/<[\w\s]+>/g, function(key) {
                return '(?:' + grammar[key].trim() + ')';
            });
            // return the last item
            return grammar[key];
        }
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$5474249eecc23269$export$2e2bcd8739ae039.displayName = 'lilypond';
$5474249eecc23269$export$2e2bcd8739ae039.aliases = [
    'ly'
];
function $5474249eecc23269$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $c6a13ead09099e31$export$2e2bcd8739ae039));
    (function(Prism) {
        var schemeExpression = /\((?:[^();"#\\]|\\[\s\S]|;.*(?!.)|"(?:[^"\\]|\\.)*"|#(?:\{(?:(?!#\})[\s\S])*#\}|[^{])|<expr>)*\)/.source;
        // allow for up to pow(2, recursivenessLog2) many levels of recursive brace expressions
        // For some reason, this can't be 4
        var recursivenessLog2 = 5;
        for(var i = 0; i < recursivenessLog2; i++)schemeExpression = schemeExpression.replace(/<expr>/g, function() {
            return schemeExpression;
        });
        schemeExpression = schemeExpression.replace(/<expr>/g, /[^\s\S]/.source);
        var lilypond = Prism.languages.lilypond = {
            comment: /%(?:(?!\{).*|\{[\s\S]*?%\})/,
            'embedded-scheme': {
                pattern: RegExp(/(^|[=\s])#(?:"(?:[^"\\]|\\.)*"|[^\s()"]*(?:[^\s()]|<expr>))/.source.replace(/<expr>/g, function() {
                    return schemeExpression;
                }), 'm'),
                lookbehind: true,
                greedy: true,
                inside: {
                    scheme: {
                        pattern: /^(#)[\s\S]+$/,
                        lookbehind: true,
                        alias: 'language-scheme',
                        inside: {
                            'embedded-lilypond': {
                                pattern: /#\{[\s\S]*?#\}/,
                                greedy: true,
                                inside: {
                                    punctuation: /^#\{|#\}$/,
                                    lilypond: {
                                        pattern: /[\s\S]+/,
                                        alias: 'language-lilypond',
                                        inside: null // see below
                                    }
                                }
                            },
                            rest: Prism.languages.scheme
                        }
                    },
                    punctuation: /#/
                }
            },
            string: {
                pattern: /"(?:[^"\\]|\\.)*"/,
                greedy: true
            },
            'class-name': {
                pattern: /(\\new\s+)[\w-]+/,
                lookbehind: true
            },
            keyword: {
                pattern: /\\[a-z][-\w]*/i,
                inside: {
                    punctuation: /^\\/
                }
            },
            operator: /[=|]|<<|>>/,
            punctuation: {
                pattern: /(^|[a-z\d])(?:'+|,+|[_^]?-[_^]?(?:[-+^!>._]|(?=\d))|[_^]\.?|[.!])|[{}()[\]<>^~]|\\[()[\]<>\\!]|--|__/,
                lookbehind: true
            },
            number: /\b\d+(?:\/\d+)?\b/
        };
        lilypond['embedded-scheme'].inside['scheme'].inside['embedded-lilypond'].inside['lilypond'].inside = lilypond;
        Prism.languages.ly = lilypond;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$635a44d6d212f42f$export$2e2bcd8739ae039.displayName = 'liquid';
$635a44d6d212f42f$export$2e2bcd8739ae039.aliases = [];
function $635a44d6d212f42f$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $a400735491c1aa4e$export$2e2bcd8739ae039));
    Prism.languages.liquid = {
        comment: {
            pattern: /(^\{%\s*comment\s*%\})[\s\S]+(?=\{%\s*endcomment\s*%\}$)/,
            lookbehind: true
        },
        delimiter: {
            pattern: /^\{(?:\{\{|[%\{])-?|-?(?:\}\}|[%\}])\}$/,
            alias: 'punctuation'
        },
        string: {
            pattern: /"[^"]*"|'[^']*'/,
            greedy: true
        },
        keyword: /\b(?:as|assign|break|(?:end)?(?:capture|case|comment|for|form|if|paginate|raw|style|tablerow|unless)|continue|cycle|decrement|echo|else|elsif|in|include|increment|limit|liquid|offset|range|render|reversed|section|when|with)\b/,
        object: /\b(?:address|all_country_option_tags|article|block|blog|cart|checkout|collection|color|country|country_option_tags|currency|current_page|current_tags|customer|customer_address|date|discount_allocation|discount_application|external_video|filter|filter_value|font|forloop|fulfillment|generic_file|gift_card|group|handle|image|line_item|link|linklist|localization|location|measurement|media|metafield|model|model_source|order|page|page_description|page_image|page_title|part|policy|product|product_option|recommendations|request|robots|routes|rule|script|search|selling_plan|selling_plan_allocation|selling_plan_group|shipping_method|shop|shop_locale|sitemap|store_availability|tax_line|template|theme|transaction|unit_price_measurement|user_agent|variant|video|video_source)\b/,
        function: [
            {
                pattern: /(\|\s*)\w+/,
                lookbehind: true,
                alias: 'filter'
            },
            {
                // array functions
                pattern: /(\.\s*)(?:first|last|size)/,
                lookbehind: true
            }
        ],
        boolean: /\b(?:false|nil|true)\b/,
        range: {
            pattern: /\.\./,
            alias: 'operator'
        },
        // https://github.com/Shopify/liquid/blob/698f5e0d967423e013f6169d9111bd969bd78337/lib/liquid/lexer.rb#L21
        number: /\b\d+(?:\.\d+)?\b/,
        operator: /[!=]=|<>|[<>]=?|[|?:=-]|\b(?:and|contains(?=\s)|or)\b/,
        punctuation: /[.,\[\]()]/,
        empty: {
            pattern: /\bempty\b/,
            alias: 'keyword'
        }
    };
    Prism.hooks.add('before-tokenize', function(env) {
        var liquidPattern = /\{%\s*comment\s*%\}[\s\S]*?\{%\s*endcomment\s*%\}|\{(?:%[\s\S]*?%|\{\{[\s\S]*?\}\}|\{[\s\S]*?\})\}/g;
        var insideRaw = false;
        Prism.languages['markup-templating'].buildPlaceholders(env, 'liquid', liquidPattern, function(match) {
            var tagMatch = /^\{%-?\s*(\w+)/.exec(match);
            if (tagMatch) {
                var tag = tagMatch[1];
                if (tag === 'raw' && !insideRaw) {
                    insideRaw = true;
                    return true;
                } else if (tag === 'endraw') {
                    insideRaw = false;
                    return true;
                }
            }
            return !insideRaw;
        });
    });
    Prism.hooks.add('after-tokenize', function(env) {
        Prism.languages['markup-templating'].tokenizePlaceholders(env, 'liquid');
    });
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $289de95df67c09ba$export$2e2bcd8739ae039.displayName = 'lisp';
$289de95df67c09ba$export$2e2bcd8739ae039.aliases = [
    'elisp',
    'emacs',
    'emacs-lisp'
];
function $289de95df67c09ba$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        /**
     * Functions to construct regular expressions
     * e.g. (interactive ... or (interactive)
     *
     * @param {string} name
     * @returns {RegExp}
     */ function simple_form(name) {
            return RegExp(/(\()/.source + '(?:' + name + ')' + /(?=[\s\)])/.source);
        }
        /**
     * booleans and numbers
     *
     * @param {string} pattern
     * @returns {RegExp}
     */ function primitive(pattern) {
            return RegExp(/([\s([])/.source + '(?:' + pattern + ')' + /(?=[\s)])/.source);
        }
        // Patterns in regular expressions
        // Symbol name. See https://www.gnu.org/software/emacs/manual/html_node/elisp/Symbol-Type.html
        // & and : are excluded as they are usually used for special purposes
        var symbol = /(?!\d)[-+*/~!@$%^=<>{}\w]+/.source;
        // symbol starting with & used in function arguments
        var marker = '&' + symbol;
        // Open parenthesis for look-behind
        var par = '(\\()';
        var endpar = '(?=\\))';
        // End the pattern with look-ahead space
        var space = '(?=\\s)';
        var nestedPar = /(?:[^()]|\((?:[^()]|\((?:[^()]|\((?:[^()]|\((?:[^()]|\([^()]*\))*\))*\))*\))*\))*/.source;
        var language = {
            // Three or four semicolons are considered a heading.
            // See https://www.gnu.org/software/emacs/manual/html_node/elisp/Comment-Tips.html
            heading: {
                pattern: /;;;.*/,
                alias: [
                    'comment',
                    'title'
                ]
            },
            comment: /;.*/,
            string: {
                pattern: /"(?:[^"\\]|\\.)*"/,
                greedy: true,
                inside: {
                    argument: /[-A-Z]+(?=[.,\s])/,
                    symbol: RegExp('`' + symbol + "'")
                }
            },
            'quoted-symbol': {
                pattern: RegExp("#?'" + symbol),
                alias: [
                    'variable',
                    'symbol'
                ]
            },
            'lisp-property': {
                pattern: RegExp(':' + symbol),
                alias: 'property'
            },
            splice: {
                pattern: RegExp(',@?' + symbol),
                alias: [
                    'symbol',
                    'variable'
                ]
            },
            keyword: [
                {
                    pattern: RegExp(par + '(?:and|(?:cl-)?letf|cl-loop|cond|cons|error|if|(?:lexical-)?let\\*?|message|not|null|or|provide|require|setq|unless|use-package|when|while)' + space),
                    lookbehind: true
                },
                {
                    pattern: RegExp(par + '(?:append|by|collect|concat|do|finally|for|in|return)' + space),
                    lookbehind: true
                }
            ],
            declare: {
                pattern: simple_form(/declare/.source),
                lookbehind: true,
                alias: 'keyword'
            },
            interactive: {
                pattern: simple_form(/interactive/.source),
                lookbehind: true,
                alias: 'keyword'
            },
            boolean: {
                pattern: primitive(/nil|t/.source),
                lookbehind: true
            },
            number: {
                pattern: primitive(/[-+]?\d+(?:\.\d*)?/.source),
                lookbehind: true
            },
            defvar: {
                pattern: RegExp(par + 'def(?:const|custom|group|var)\\s+' + symbol),
                lookbehind: true,
                inside: {
                    keyword: /^def[a-z]+/,
                    variable: RegExp(symbol)
                }
            },
            defun: {
                pattern: RegExp(par + /(?:cl-)?(?:defmacro|defun\*?)\s+/.source + symbol + /\s+\(/.source + nestedPar + /\)/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    keyword: /^(?:cl-)?def\S+/,
                    // See below, this property needs to be defined later so that it can
                    // reference the language object.
                    arguments: null,
                    function: {
                        pattern: RegExp('(^\\s)' + symbol),
                        lookbehind: true
                    },
                    punctuation: /[()]/
                }
            },
            lambda: {
                pattern: RegExp(par + 'lambda\\s+\\(\\s*(?:&?' + symbol + '(?:\\s+&?' + symbol + ')*\\s*)?\\)'),
                lookbehind: true,
                greedy: true,
                inside: {
                    keyword: /^lambda/,
                    // See below, this property needs to be defined later so that it can
                    // reference the language object.
                    arguments: null,
                    punctuation: /[()]/
                }
            },
            car: {
                pattern: RegExp(par + symbol),
                lookbehind: true
            },
            punctuation: [
                // open paren, brackets, and close paren
                /(?:['`,]?\(|[)\[\]])/,
                // cons
                {
                    pattern: /(\s)\.(?=\s)/,
                    lookbehind: true
                }
            ]
        };
        var arg = {
            'lisp-marker': RegExp(marker),
            varform: {
                pattern: RegExp(/\(/.source + symbol + /\s+(?=\S)/.source + nestedPar + /\)/.source),
                inside: language
            },
            argument: {
                pattern: RegExp(/(^|[\s(])/.source + symbol),
                lookbehind: true,
                alias: 'variable'
            },
            rest: language
        };
        var forms = '\\S+(?:\\s+\\S+)*';
        var arglist = {
            pattern: RegExp(par + nestedPar + endpar),
            lookbehind: true,
            inside: {
                'rest-vars': {
                    pattern: RegExp('&(?:body|rest)\\s+' + forms),
                    inside: arg
                },
                'other-marker-vars': {
                    pattern: RegExp('&(?:aux|optional)\\s+' + forms),
                    inside: arg
                },
                keys: {
                    pattern: RegExp('&key\\s+' + forms + '(?:\\s+&allow-other-keys)?'),
                    inside: arg
                },
                argument: {
                    pattern: RegExp(symbol),
                    alias: 'variable'
                },
                punctuation: /[()]/
            }
        };
        language['lambda'].inside.arguments = arglist;
        language['defun'].inside.arguments = Prism.util.clone(arglist);
        language['defun'].inside.arguments.inside.sublist = arglist;
        Prism.languages.lisp = language;
        Prism.languages.elisp = language;
        Prism.languages.emacs = language;
        Prism.languages['emacs-lisp'] = language;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $07724378ac8681ca$export$2e2bcd8739ae039.displayName = 'livescript';
$07724378ac8681ca$export$2e2bcd8739ae039.aliases = [];
function $07724378ac8681ca$export$2e2bcd8739ae039(Prism) {
    Prism.languages.livescript = {
        comment: [
            {
                pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
                lookbehind: true
            },
            {
                pattern: /(^|[^\\])#.*/,
                lookbehind: true
            }
        ],
        'interpolated-string': {
            /* Look-behind and look-ahead prevents wrong behavior of the greedy pattern
       * forcing it to match """-quoted string when it would otherwise match "-quoted first. */ pattern: /(^|[^"])("""|")(?:\\[\s\S]|(?!\2)[^\\])*\2(?!")/,
            lookbehind: true,
            greedy: true,
            inside: {
                variable: {
                    pattern: /(^|[^\\])#[a-z_](?:-?[a-z]|[\d_])*/m,
                    lookbehind: true
                },
                interpolation: {
                    pattern: /(^|[^\\])#\{[^}]+\}/m,
                    lookbehind: true,
                    inside: {
                        'interpolation-punctuation': {
                            pattern: /^#\{|\}$/,
                            alias: 'variable'
                        }
                    }
                },
                string: /[\s\S]+/
            }
        },
        string: [
            {
                pattern: /('''|')(?:\\[\s\S]|(?!\1)[^\\])*\1/,
                greedy: true
            },
            {
                pattern: /<\[[\s\S]*?\]>/,
                greedy: true
            },
            /\\[^\s,;\])}]+/
        ],
        regex: [
            {
                pattern: /\/\/(?:\[[^\r\n\]]*\]|\\.|(?!\/\/)[^\\\[])+\/\/[gimyu]{0,5}/,
                greedy: true,
                inside: {
                    comment: {
                        pattern: /(^|[^\\])#.*/,
                        lookbehind: true
                    }
                }
            },
            {
                pattern: /\/(?:\[[^\r\n\]]*\]|\\.|[^/\\\r\n\[])+\/[gimyu]{0,5}/,
                greedy: true
            }
        ],
        keyword: {
            pattern: /(^|(?!-).)\b(?:break|case|catch|class|const|continue|default|do|else|extends|fallthrough|finally|for(?: ever)?|function|if|implements|it|let|loop|new|null|otherwise|own|return|super|switch|that|then|this|throw|try|unless|until|var|void|when|while|yield)(?!-)\b/m,
            lookbehind: true
        },
        'keyword-operator': {
            pattern: /(^|[^-])\b(?:(?:delete|require|typeof)!|(?:and|by|delete|export|from|import(?: all)?|in|instanceof|is(?: not|nt)?|not|of|or|til|to|typeof|with|xor)(?!-)\b)/m,
            lookbehind: true,
            alias: 'operator'
        },
        boolean: {
            pattern: /(^|[^-])\b(?:false|no|off|on|true|yes)(?!-)\b/m,
            lookbehind: true
        },
        argument: {
            // Don't match .&. nor &&
            pattern: /(^|(?!\.&\.)[^&])&(?!&)\d*/m,
            lookbehind: true,
            alias: 'variable'
        },
        number: /\b(?:\d+~[\da-z]+|\d[\d_]*(?:\.\d[\d_]*)?(?:[a-z]\w*)?)/i,
        identifier: /[a-z_](?:-?[a-z]|[\d_])*/i,
        operator: [
            // Spaced .
            {
                pattern: /( )\.(?= )/,
                lookbehind: true
            },
            // Full list, in order:
            // .= .~ .. ...
            // .&. .^. .<<. .>>. .>>>.
            // := :: ::=
            // &&
            // || |>
            // < << <<< <<<<
            // <- <-- <-! <--!
            // <~ <~~ <~! <~~!
            // <| <= <?
            // > >> >= >?
            // - -- -> -->
            // + ++
            // @ @@
            // % %%
            // * **
            // ! != !~=
            // !~> !~~>
            // !-> !-->
            // ~ ~> ~~> ~=
            // = ==
            // ^ ^^
            // / ?
            /\.(?:[=~]|\.\.?)|\.(?:[&|^]|<<|>>>?)\.|:(?:=|:=?)|&&|\|[|>]|<(?:<<?<?|--?!?|~~?!?|[|=?])?|>[>=?]?|-(?:->?|>)?|\+\+?|@@?|%%?|\*\*?|!(?:~?=|--?>|~?~>)?|~(?:~?>|=)?|==?|\^\^?|[\/?]/
        ],
        punctuation: /[(){}\[\]|.,:;`]/
    };
    Prism.languages.livescript['interpolated-string'].inside['interpolation'].inside.rest = Prism.languages.livescript;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $129c4ebc87b64902$export$2e2bcd8739ae039.displayName = 'llvm';
$129c4ebc87b64902$export$2e2bcd8739ae039.aliases = [];
function $129c4ebc87b64902$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.llvm = {
            comment: /;.*/,
            string: {
                pattern: /"[^"]*"/,
                greedy: true
            },
            boolean: /\b(?:false|true)\b/,
            variable: /[%@!#](?:(?!\d)(?:[-$.\w]|\\[a-f\d]{2})+|\d+)/i,
            label: /(?!\d)(?:[-$.\w]|\\[a-f\d]{2})+:/i,
            type: {
                pattern: /\b(?:double|float|fp128|half|i[1-9]\d*|label|metadata|ppc_fp128|token|void|x86_fp80|x86_mmx)\b/,
                alias: 'class-name'
            },
            keyword: /\b[a-z_][a-z_0-9]*\b/,
            number: /[+-]?\b\d+(?:\.\d+)?(?:[eE][+-]?\d+)?\b|\b0x[\dA-Fa-f]+\b|\b0xK[\dA-Fa-f]{20}\b|\b0x[ML][\dA-Fa-f]{32}\b|\b0xH[\dA-Fa-f]{4}\b/,
            punctuation: /[{}[\];(),.!*=<>]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $96cdba00d04057e5$export$2e2bcd8739ae039.displayName = 'log';
$96cdba00d04057e5$export$2e2bcd8739ae039.aliases = [];
function $96cdba00d04057e5$export$2e2bcd8739ae039(Prism) {
    // This is a language definition for generic log files.
    // Since there is no one log format, this language definition has to support all formats to some degree.
    //
    // Based on https://github.com/MTDL9/vim-log-highlighting
    Prism.languages.log = {
        string: {
            // Single-quoted strings must not be confused with plain text. E.g. Can't isn't Susan's Chris' toy
            pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?![st] | \w)(?:[^'\\\r\n]|\\.)*'/,
            greedy: true
        },
        exception: {
            pattern: /(^|[^\w.])[a-z][\w.]*(?:Error|Exception):.*(?:(?:\r\n?|\n)[ \t]*(?:at[ \t].+|\.{3}.*|Caused by:.*))+(?:(?:\r\n?|\n)[ \t]*\.\.\. .*)?/,
            lookbehind: true,
            greedy: true,
            alias: [
                'javastacktrace',
                'language-javastacktrace'
            ],
            inside: Prism.languages['javastacktrace'] || {
                keyword: /\bat\b/,
                function: /[a-z_][\w$]*(?=\()/,
                punctuation: /[.:()]/
            }
        },
        level: [
            {
                pattern: /\b(?:ALERT|CRIT|CRITICAL|EMERG|EMERGENCY|ERR|ERROR|FAILURE|FATAL|SEVERE)\b/,
                alias: [
                    'error',
                    'important'
                ]
            },
            {
                pattern: /\b(?:WARN|WARNING|WRN)\b/,
                alias: [
                    'warning',
                    'important'
                ]
            },
            {
                pattern: /\b(?:DISPLAY|INF|INFO|NOTICE|STATUS)\b/,
                alias: [
                    'info',
                    'keyword'
                ]
            },
            {
                pattern: /\b(?:DBG|DEBUG|FINE)\b/,
                alias: [
                    'debug',
                    'keyword'
                ]
            },
            {
                pattern: /\b(?:FINER|FINEST|TRACE|TRC|VERBOSE|VRB)\b/,
                alias: [
                    'trace',
                    'comment'
                ]
            }
        ],
        property: {
            pattern: /((?:^|[\]|])[ \t]*)[a-z_](?:[\w-]|\b\/\b)*(?:[. ]\(?\w(?:[\w-]|\b\/\b)*\)?)*:(?=\s)/im,
            lookbehind: true
        },
        separator: {
            pattern: /(^|[^-+])-{3,}|={3,}|\*{3,}|- - /m,
            lookbehind: true,
            alias: 'comment'
        },
        url: /\b(?:file|ftp|https?):\/\/[^\s|,;'"]*[^\s|,;'">.]/,
        email: {
            pattern: /(^|\s)[-\w+.]+@[a-z][a-z0-9-]*(?:\.[a-z][a-z0-9-]*)+(?=\s)/,
            lookbehind: true,
            alias: 'url'
        },
        'ip-address': {
            pattern: /\b(?:\d{1,3}(?:\.\d{1,3}){3})\b/,
            alias: 'constant'
        },
        'mac-address': {
            pattern: /\b[a-f0-9]{2}(?::[a-f0-9]{2}){5}\b/i,
            alias: 'constant'
        },
        domain: {
            pattern: /(^|\s)[a-z][a-z0-9-]*(?:\.[a-z][a-z0-9-]*)*\.[a-z][a-z0-9-]+(?=\s)/,
            lookbehind: true,
            alias: 'constant'
        },
        uuid: {
            pattern: /\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b/i,
            alias: 'constant'
        },
        hash: {
            pattern: /\b(?:[a-f0-9]{32}){1,2}\b/i,
            alias: 'constant'
        },
        'file-path': {
            pattern: /\b[a-z]:[\\/][^\s|,;:(){}\[\]"']+|(^|[\s:\[\](>|])\.{0,2}\/\w[^\s|,;:(){}\[\]"']*/i,
            lookbehind: true,
            greedy: true,
            alias: 'string'
        },
        date: {
            pattern: RegExp(/\b\d{4}[-/]\d{2}[-/]\d{2}(?:T(?=\d{1,2}:)|(?=\s\d{1,2}:))/.source + '|' + /\b\d{1,4}[-/ ](?:\d{1,2}|Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)[-/ ]\d{2,4}T?\b/.source + '|' + /\b(?:(?:Fri|Mon|Sat|Sun|Thu|Tue|Wed)(?:\s{1,2}(?:Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep))?|Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)\s{1,2}\d{1,2}\b/.source, 'i'),
            alias: 'number'
        },
        time: {
            pattern: /\b\d{1,2}:\d{1,2}:\d{1,2}(?:[.,:]\d+)?(?:\s?[+-]\d{2}:?\d{2}|Z)?\b/,
            alias: 'number'
        },
        boolean: /\b(?:false|null|true)\b/i,
        number: {
            pattern: /(^|[^.\w])(?:0x[a-f0-9]+|0o[0-7]+|0b[01]+|v?\d[\da-f]*(?:\.\d+)*(?:e[+-]?\d+)?[a-z]{0,3}\b)\b(?!\.\w)/i,
            lookbehind: true
        },
        operator: /[;:?<=>~/@!$%&+\-|^(){}*#]/,
        punctuation: /[\[\].,]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $6ab3d3339ebbb87d$export$2e2bcd8739ae039.displayName = 'lolcode';
$6ab3d3339ebbb87d$export$2e2bcd8739ae039.aliases = [];
function $6ab3d3339ebbb87d$export$2e2bcd8739ae039(Prism) {
    Prism.languages.lolcode = {
        comment: [
            /\bOBTW\s[\s\S]*?\sTLDR\b/,
            /\bBTW.+/
        ],
        string: {
            pattern: /"(?::.|[^":])*"/,
            inside: {
                variable: /:\{[^}]+\}/,
                symbol: [
                    /:\([a-f\d]+\)/i,
                    /:\[[^\]]+\]/,
                    /:[)>o":]/
                ]
            },
            greedy: true
        },
        number: /(?:\B-)?(?:\b\d+(?:\.\d*)?|\B\.\d+)/,
        symbol: {
            pattern: /(^|\s)(?:A )?(?:BUKKIT|NOOB|NUMBAR|NUMBR|TROOF|YARN)(?=\s|,|$)/,
            lookbehind: true,
            inside: {
                keyword: /A(?=\s)/
            }
        },
        label: {
            pattern: /((?:^|\s)(?:IM IN YR|IM OUTTA YR) )[a-zA-Z]\w*/,
            lookbehind: true,
            alias: 'string'
        },
        function: {
            pattern: /((?:^|\s)(?:HOW IZ I|I IZ|IZ) )[a-zA-Z]\w*/,
            lookbehind: true
        },
        keyword: [
            {
                pattern: /(^|\s)(?:AN|FOUND YR|GIMMEH|GTFO|HAI|HAS A|HOW IZ I|I HAS A|I IZ|IF U SAY SO|IM IN YR|IM OUTTA YR|IS NOW(?: A)?|ITZ(?: A)?|IZ|KTHX|KTHXBYE|LIEK(?: A)?|MAEK|MEBBE|MKAY|NERFIN|NO WAI|O HAI IM|O RLY\?|OIC|OMG|OMGWTF|R|SMOOSH|SRS|TIL|UPPIN|VISIBLE|WILE|WTF\?|YA RLY|YR)(?=\s|,|$)/,
                lookbehind: true
            },
            /'Z(?=\s|,|$)/
        ],
        boolean: {
            pattern: /(^|\s)(?:FAIL|WIN)(?=\s|,|$)/,
            lookbehind: true
        },
        variable: {
            pattern: /(^|\s)IT(?=\s|,|$)/,
            lookbehind: true
        },
        operator: {
            pattern: /(^|\s)(?:NOT|BOTH SAEM|DIFFRINT|(?:ALL|ANY|BIGGR|BOTH|DIFF|EITHER|MOD|PRODUKT|QUOSHUNT|SMALLR|SUM|WON) OF)(?=\s|,|$)/,
            lookbehind: true
        },
        punctuation: /\.{3}|…|,|!/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $6f023dee4f5684a2$export$2e2bcd8739ae039.displayName = 'magma';
$6f023dee4f5684a2$export$2e2bcd8739ae039.aliases = [];
function $6f023dee4f5684a2$export$2e2bcd8739ae039(Prism) {
    Prism.languages.magma = {
        output: {
            pattern: /^(>.*(?:\r(?:\n|(?!\n))|\n))(?!>)(?:.+|(?:\r(?:\n|(?!\n))|\n)(?!>).*)(?:(?:\r(?:\n|(?!\n))|\n)(?!>).*)*/m,
            lookbehind: true,
            greedy: true
        },
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\"])"(?:[^\r\n\\"]|\\.)*"/,
            lookbehind: true,
            greedy: true
        },
        // http://magma.maths.usyd.edu.au/magma/handbook/text/82
        keyword: /\b(?:_|adj|and|assert|assert2|assert3|assigned|break|by|case|cat|catch|clear|cmpeq|cmpne|continue|declare|default|delete|diff|div|do|elif|else|end|eq|error|eval|exists|exit|for|forall|forward|fprintf|freeze|function|ge|gt|if|iload|import|in|intrinsic|is|join|le|load|local|lt|meet|mod|ne|not|notadj|notin|notsubset|or|print|printf|procedure|quit|random|read|readi|repeat|require|requirege|requirerange|restore|return|save|sdiff|select|subset|then|time|to|try|until|vprint|vprintf|vtime|when|where|while|xor)\b/,
        boolean: /\b(?:false|true)\b/,
        generator: {
            pattern: /\b[a-z_]\w*(?=\s*<)/i,
            alias: 'class-name'
        },
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: {
            pattern: /(^|[^\w.]|\.\.)(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?(?:_[a-z]?)?(?=$|[^\w.]|\.\.)/,
            lookbehind: true
        },
        operator: /->|[-+*/^~!|#=]|:=|\.\./,
        punctuation: /[()[\]{}<>,;.:]/
    };
}



// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $896766ac97cf30fc$export$2e2bcd8739ae039.displayName = 'mata';
$896766ac97cf30fc$export$2e2bcd8739ae039.aliases = [];
function $896766ac97cf30fc$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var orgType = /\b(?:(?:col|row)?vector|matrix|scalar)\b/.source;
        var type = /\bvoid\b|<org>|\b(?:complex|numeric|pointer(?:\s*\([^()]*\))?|real|string|(?:class|struct)\s+\w+|transmorphic)(?:\s*<org>)?/.source.replace(/<org>/g, orgType);
        Prism.languages.mata = {
            comment: {
                pattern: /\/\/.*|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\//,
                greedy: true
            },
            string: {
                pattern: /"[^"\r\n]*"|[‘`']".*?"[’`']/,
                greedy: true
            },
            'class-name': {
                pattern: /(\b(?:class|extends|struct)\s+)\w+(?=\s*(?:\{|\bextends\b))/,
                lookbehind: true
            },
            type: {
                pattern: RegExp(type),
                alias: 'class-name',
                inside: {
                    punctuation: /[()]/,
                    keyword: /\b(?:class|function|struct|void)\b/
                }
            },
            keyword: /\b(?:break|class|continue|do|else|end|extends|external|final|for|function|goto|if|pragma|private|protected|public|return|static|struct|unset|unused|version|virtual|while)\b/,
            constant: /\bNULL\b/,
            number: {
                pattern: /(^|[^\w.])(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|\d[a-f0-9]*(?:\.[a-f0-9]+)?x[+-]?\d+)i?(?![\w.])/i,
                lookbehind: true
            },
            missing: {
                pattern: /(^|[^\w.])(?:\.[a-z]?)(?![\w.])/,
                lookbehind: true,
                alias: 'symbol'
            },
            function: /\b[a-z_]\w*(?=\s*\()/i,
            operator: /\.\.|\+\+|--|&&|\|\||:?(?:[!=<>]=|[+\-*/^<>&|:])|[!?=\\#’`']/,
            punctuation: /[()[\]{},;.]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $de9f82a08ba821dd$export$2e2bcd8739ae039.displayName = 'matlab';
$de9f82a08ba821dd$export$2e2bcd8739ae039.aliases = [];
function $de9f82a08ba821dd$export$2e2bcd8739ae039(Prism) {
    Prism.languages.matlab = {
        comment: [
            /%\{[\s\S]*?\}%/,
            /%.+/
        ],
        string: {
            pattern: /\B'(?:''|[^'\r\n])*'/,
            greedy: true
        },
        // FIXME We could handle imaginary numbers as a whole
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+)?(?:[ij])?|\b[ij]\b/,
        keyword: /\b(?:NaN|break|case|catch|continue|else|elseif|end|for|function|if|inf|otherwise|parfor|pause|pi|return|switch|try|while)\b/,
        function: /\b(?!\d)\w+(?=\s*\()/,
        operator: /\.?[*^\/\\']|[+\-:@]|[<>=~]=?|&&?|\|\|?/,
        punctuation: /\.{3}|[.,;\[\](){}!]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $2a76ed9e2036f609$export$2e2bcd8739ae039.displayName = 'maxscript';
$2a76ed9e2036f609$export$2e2bcd8739ae039.aliases = [];
function $2a76ed9e2036f609$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var keywords = /\b(?:about|and|animate|as|at|attributes|by|case|catch|collect|continue|coordsys|do|else|exit|fn|for|from|function|global|if|in|local|macroscript|mapped|max|not|of|off|on|or|parameters|persistent|plugin|rcmenu|return|rollout|set|struct|then|throw|to|tool|try|undo|utility|when|where|while|with)\b/i;
        Prism.languages.maxscript = {
            comment: {
                pattern: /\/\*[\s\S]*?(?:\*\/|$)|--.*/,
                greedy: true
            },
            string: {
                pattern: /(^|[^"\\@])(?:"(?:[^"\\]|\\[\s\S])*"|@"[^"]*")/,
                lookbehind: true,
                greedy: true
            },
            path: {
                pattern: /\$(?:[\w/\\.*?]|'[^']*')*/,
                greedy: true,
                alias: 'string'
            },
            'function-call': {
                pattern: RegExp('((?:' + // start of line
                (/^/.source + '|' + // operators and other language constructs
                /[;=<>+\-*/^({\[]/.source + '|' + // keywords as part of statements
                /\b(?:and|by|case|catch|collect|do|else|if|in|not|or|return|then|to|try|where|while|with)\b/.source) + ')[ \t]*)' + '(?!' + keywords.source + ')' + /[a-z_]\w*\b/.source + '(?=[ \t]*(?:' + // variable
                ('(?!' + keywords.source + ')' + /[a-z_]/.source + '|' + // number
                /\d|-\.?\d/.source + '|' + // other expressions or literals
                /[({'"$@#?]/.source) + '))', 'im'),
                lookbehind: true,
                greedy: true,
                alias: 'function'
            },
            'function-definition': {
                pattern: /(\b(?:fn|function)\s+)\w+\b/i,
                lookbehind: true,
                alias: 'function'
            },
            argument: {
                pattern: /\b[a-z_]\w*(?=:)/i,
                alias: 'attr-name'
            },
            keyword: keywords,
            boolean: /\b(?:false|true)\b/,
            time: {
                pattern: /(^|[^\w.])(?:(?:(?:\d+(?:\.\d*)?|\.\d+)(?:[eEdD][+-]\d+|[LP])?[msft])+|\d+:\d+(?:\.\d*)?)(?![\w.:])/,
                lookbehind: true,
                alias: 'number'
            },
            number: [
                {
                    pattern: /(^|[^\w.])(?:(?:\d+(?:\.\d*)?|\.\d+)(?:[eEdD][+-]\d+|[LP])?|0x[a-fA-F0-9]+)(?![\w.:])/,
                    lookbehind: true
                },
                /\b(?:e|pi)\b/
            ],
            constant: /\b(?:dontcollect|ok|silentValue|undefined|unsupplied)\b/,
            color: {
                pattern: /\b(?:black|blue|brown|gray|green|orange|red|white|yellow)\b/i,
                alias: 'constant'
            },
            operator: /[-+*/<>=!]=?|[&^?]|#(?!\()/,
            punctuation: /[()\[\]{}.:,;]|#(?=\()|\\$/m
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $aabfe52eb8bf425f$export$2e2bcd8739ae039.displayName = 'mel';
$aabfe52eb8bf425f$export$2e2bcd8739ae039.aliases = [];
function $aabfe52eb8bf425f$export$2e2bcd8739ae039(Prism) {
    Prism.languages.mel = {
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
            greedy: true
        },
        code: {
            pattern: /`(?:\\.|[^\\`])*`/,
            greedy: true,
            alias: 'italic',
            inside: {
                delimiter: {
                    pattern: /^`|`$/,
                    alias: 'punctuation'
                },
                statement: {
                    pattern: /[\s\S]+/,
                    inside: null // see below
                }
            }
        },
        string: {
            pattern: /"(?:\\.|[^\\"\r\n])*"/,
            greedy: true
        },
        variable: /\$\w+/,
        number: /\b0x[\da-fA-F]+\b|\b\d+(?:\.\d*)?|\B\.\d+/,
        flag: {
            pattern: /-[^\d\W]\w*/,
            alias: 'operator'
        },
        keyword: /\b(?:break|case|continue|default|do|else|float|for|global|if|in|int|matrix|proc|return|string|switch|vector|while)\b/,
        function: {
            pattern: /((?:^|[{;])[ \t]*)[a-z_]\w*\b(?!\s*(?:\.(?!\.)|[[{=]))|\b[a-z_]\w*(?=[ \t]*\()/im,
            lookbehind: true,
            greedy: true
        },
        'tensor-punctuation': {
            pattern: /<<|>>/,
            alias: 'punctuation'
        },
        operator: /\+[+=]?|-[-=]?|&&|\|\||[<>]=?|[*\/!=]=?|[%^]/,
        punctuation: /[.,:;?\[\](){}]/
    };
    Prism.languages.mel['code'].inside['statement'].inside = Prism.languages.mel;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $04f7e8ee922eafab$export$2e2bcd8739ae039.displayName = 'mermaid';
$04f7e8ee922eafab$export$2e2bcd8739ae039.aliases = [];
function $04f7e8ee922eafab$export$2e2bcd8739ae039(Prism) {
    Prism.languages.mermaid = {
        comment: {
            pattern: /%%.*/,
            greedy: true
        },
        style: {
            pattern: /^([ \t]*(?:classDef|linkStyle|style)[ \t]+[\w$-]+[ \t]+)\w.*[^\s;]/m,
            lookbehind: true,
            inside: {
                property: /\b\w[\w-]*(?=[ \t]*:)/,
                operator: /:/,
                punctuation: /,/
            }
        },
        'inter-arrow-label': {
            pattern: /([^<>ox.=-])(?:-[-.]|==)(?![<>ox.=-])[ \t]*(?:"[^"\r\n]*"|[^\s".=-](?:[^\r\n.=-]*[^\s.=-])?)[ \t]*(?:\.+->?|--+[->]|==+[=>])(?![<>ox.=-])/,
            lookbehind: true,
            greedy: true,
            inside: {
                arrow: {
                    pattern: /(?:\.+->?|--+[->]|==+[=>])$/,
                    alias: 'operator'
                },
                label: {
                    pattern: /^([\s\S]{2}[ \t]*)\S(?:[\s\S]*\S)?/,
                    lookbehind: true,
                    alias: 'property'
                },
                'arrow-head': {
                    pattern: /^\S+/,
                    alias: [
                        'arrow',
                        'operator'
                    ]
                }
            }
        },
        arrow: [
            // This might look complex but it really isn't.
            // There are many possible arrows (see tests) and it's impossible to fit all of them into one pattern. The
            // problem is that we only have one lookbehind per pattern. However, we cannot disallow too many arrow
            // characters in the one lookbehind because that would create too many false negatives. So we have to split the
            // arrows into different patterns.
            {
                // ER diagram
                pattern: /(^|[^{}|o.-])[|}][|o](?:--|\.\.)[|o][|{](?![{}|o.-])/,
                lookbehind: true,
                alias: 'operator'
            },
            {
                // flow chart
                // (?:==+|--+|-\.*-)
                pattern: /(^|[^<>ox.=-])(?:[<ox](?:==+|--+|-\.*-)[>ox]?|(?:==+|--+|-\.*-)[>ox]|===+|---+|-\.+-)(?![<>ox.=-])/,
                lookbehind: true,
                alias: 'operator'
            },
            {
                // sequence diagram
                pattern: /(^|[^<>()x-])(?:--?(?:>>|[x>)])(?![<>()x])|(?:<<|[x<(])--?(?!-))/,
                lookbehind: true,
                alias: 'operator'
            },
            {
                // class diagram
                pattern: /(^|[^<>|*o.-])(?:[*o]--|--[*o]|<\|?(?:--|\.\.)|(?:--|\.\.)\|?>|--|\.\.)(?![<>|*o.-])/,
                lookbehind: true,
                alias: 'operator'
            }
        ],
        label: {
            pattern: /(^|[^|<])\|(?:[^\r\n"|]|"[^"\r\n]*")+\|/,
            lookbehind: true,
            greedy: true,
            alias: 'property'
        },
        text: {
            pattern: /(?:[(\[{]+|\b>)(?:[^\r\n"()\[\]{}]|"[^"\r\n]*")+(?:[)\]}]+|>)/,
            alias: 'string'
        },
        string: {
            pattern: /"[^"\r\n]*"/,
            greedy: true
        },
        annotation: {
            pattern: /<<(?:abstract|choice|enumeration|fork|interface|join|service)>>|\[\[(?:choice|fork|join)\]\]/i,
            alias: 'important'
        },
        keyword: [
            // This language has both case-sensitive and case-insensitive keywords
            {
                pattern: /(^[ \t]*)(?:action|callback|class|classDef|classDiagram|click|direction|erDiagram|flowchart|gantt|gitGraph|graph|journey|link|linkStyle|pie|requirementDiagram|sequenceDiagram|stateDiagram|stateDiagram-v2|style|subgraph)(?![\w$-])/m,
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^[ \t]*)(?:activate|alt|and|as|autonumber|deactivate|else|end(?:[ \t]+note)?|loop|opt|par|participant|rect|state|note[ \t]+(?:over|(?:left|right)[ \t]+of))(?![\w$-])/im,
                lookbehind: true,
                greedy: true
            }
        ],
        entity: /#[a-z0-9]+;/,
        operator: {
            pattern: /(\w[ \t]*)&(?=[ \t]*\w)|:::|:/,
            lookbehind: true
        },
        punctuation: /[(){};]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $bd38c279ea049f97$export$2e2bcd8739ae039.displayName = 'metafont';
$bd38c279ea049f97$export$2e2bcd8739ae039.aliases = [];
function $bd38c279ea049f97$export$2e2bcd8739ae039(Prism) {
    Prism.languages.metafont = {
        // Syntax of METAFONT with the added (public) elements of PlainMETAFONT. Except for internal quantities they are expected to be rarely redefined. Freely inspired by the syntax of Christophe Grandsire for the Crimson Editor.
        comment: {
            pattern: /%.*/,
            greedy: true
        },
        string: {
            pattern: /"[^\r\n"]*"/,
            greedy: true
        },
        number: /\d*\.?\d+/,
        boolean: /\b(?:false|true)\b/,
        punctuation: [
            /[,;()]/,
            {
                pattern: /(^|[^{}])(?:\{|\})(?![{}])/,
                lookbehind: true
            },
            {
                pattern: /(^|[^[])\[(?!\[)/,
                lookbehind: true
            },
            {
                pattern: /(^|[^\]])\](?!\])/,
                lookbehind: true
            }
        ],
        constant: [
            {
                pattern: /(^|[^!?])\?\?\?(?![!?])/,
                lookbehind: true
            },
            {
                pattern: /(^|[^/*\\])(?:\\|\\\\)(?![/*\\])/,
                lookbehind: true
            },
            /\b(?:_|blankpicture|bp|cc|cm|dd|ditto|down|eps|epsilon|fullcircle|halfcircle|identity|in|infinity|left|mm|nullpen|nullpicture|origin|pc|penrazor|penspeck|pensquare|penstroke|proof|pt|quartercircle|relax|right|smoke|unitpixel|unitsquare|up)\b/
        ],
        quantity: {
            pattern: /\b(?:autorounding|blacker|boundarychar|charcode|chardp|chardx|chardy|charext|charht|charic|charwd|currentwindow|day|designsize|displaying|fillin|fontmaking|granularity|hppp|join_radius|month|o_correction|pausing|pen_(?:bot|lft|rt|top)|pixels_per_inch|proofing|showstopping|smoothing|time|tolerance|tracingcapsules|tracingchoices|tracingcommands|tracingedges|tracingequations|tracingmacros|tracingonline|tracingoutput|tracingpens|tracingrestores|tracingspecs|tracingstats|tracingtitles|turningcheck|vppp|warningcheck|xoffset|year|yoffset)\b/,
            alias: 'keyword'
        },
        command: {
            pattern: /\b(?:addto|batchmode|charlist|cull|display|errhelp|errmessage|errorstopmode|everyjob|extensible|fontdimen|headerbyte|inner|interim|let|ligtable|message|newinternal|nonstopmode|numspecial|openwindow|outer|randomseed|save|scrollmode|shipout|show|showdependencies|showstats|showtoken|showvariable|special)\b/,
            alias: 'builtin'
        },
        operator: [
            {
                pattern: /(^|[^>=<:|])(?:<|<=|=|=:|\|=:|\|=:>|=:\|>|=:\||\|=:\||\|=:\|>|\|=:\|>>|>|>=|:|:=|<>|::|\|\|:)(?![>=<:|])/,
                lookbehind: true
            },
            {
                pattern: /(^|[^+-])(?:\+|\+\+|-{1,3}|\+-\+)(?![+-])/,
                lookbehind: true
            },
            {
                pattern: /(^|[^/*\\])(?:\*|\*\*|\/)(?![/*\\])/,
                lookbehind: true
            },
            {
                pattern: /(^|[^.])(?:\.{2,3})(?!\.)/,
                lookbehind: true
            },
            {
                pattern: /(^|[^@#&$])&(?![@#&$])/,
                lookbehind: true
            },
            /\b(?:and|not|or)\b/
        ],
        macro: {
            pattern: /\b(?:abs|beginchar|bot|byte|capsule_def|ceiling|change_width|clear_pen_memory|clearit|clearpen|clearxy|counterclockwise|cullit|cutdraw|cutoff|decr|define_blacker_pixels|define_corrected_pixels|define_good_x_pixels|define_good_y_pixels|define_horizontal_corrected_pixels|define_pixels|define_whole_blacker_pixels|define_whole_pixels|define_whole_vertical_blacker_pixels|define_whole_vertical_pixels|dir|direction|directionpoint|div|dotprod|downto|draw|drawdot|endchar|erase|fill|filldraw|fix_units|flex|font_coding_scheme|font_extra_space|font_identifier|font_normal_shrink|font_normal_space|font_normal_stretch|font_quad|font_size|font_slant|font_x_height|gfcorners|gobble|gobbled|good\.(?:bot|lft|rt|top|x|y)|grayfont|hide|hround|imagerules|incr|interact|interpath|intersectionpoint|inverse|italcorr|killtext|labelfont|labels|lft|loggingall|lowres_fix|makegrid|makelabel(?:\.(?:bot|lft|rt|top)(?:\.nodot)?)?|max|min|mod|mode_def|mode_setup|nodisplays|notransforms|numtok|openit|penlabels|penpos|pickup|proofoffset|proofrule|proofrulethickness|range|reflectedabout|rotatedabout|rotatedaround|round|rt|savepen|screenchars|screenrule|screenstrokes|shipit|showit|slantfont|softjoin|solve|stop|superellipse|tensepath|thru|titlefont|top|tracingall|tracingnone|undraw|undrawdot|unfill|unfilldraw|upto|vround)\b/,
            alias: 'function'
        },
        builtin: /\b(?:ASCII|angle|char|cosd|decimal|directiontime|floor|hex|intersectiontimes|jobname|known|length|makepath|makepen|mexp|mlog|normaldeviate|oct|odd|pencircle|penoffset|point|postcontrol|precontrol|reverse|rotated|sind|sqrt|str|subpath|substring|totalweight|turningnumber|uniformdeviate|unknown|xpart|xxpart|xypart|ypart|yxpart|yypart)\b/,
        keyword: /\b(?:also|at|atleast|begingroup|charexists|contour|controls|curl|cycle|def|delimiters|doublepath|dropping|dump|else|elseif|end|enddef|endfor|endgroup|endinput|exitif|exitunless|expandafter|fi|for|forever|forsuffixes|from|if|input|inwindow|keeping|kern|of|primarydef|quote|readstring|scaled|scantokens|secondarydef|shifted|skipto|slanted|step|tension|tertiarydef|to|transformed|until|vardef|withpen|withweight|xscaled|yscaled|zscaled)\b/,
        type: {
            pattern: /\b(?:boolean|expr|numeric|pair|path|pen|picture|primary|secondary|string|suffix|tertiary|text|transform)\b/,
            alias: 'property'
        },
        variable: {
            pattern: /(^|[^@#&$])(?:@#|#@|#|@)(?![@#&$])|\b(?:aspect_ratio|currentpen|currentpicture|currenttransform|d|extra_beginchar|extra_endchar|extra_setup|h|localfont|mag|mode|screen_cols|screen_rows|w|whatever|x|y|z)\b/,
            lookbehind: true
        }
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $ac6fd29ed90881aa$export$2e2bcd8739ae039.displayName = 'mizar';
$ac6fd29ed90881aa$export$2e2bcd8739ae039.aliases = [];
function $ac6fd29ed90881aa$export$2e2bcd8739ae039(Prism) {
    Prism.languages.mizar = {
        comment: /::.+/,
        keyword: /@proof\b|\b(?:according|aggregate|all|and|antonym|are|as|associativity|assume|asymmetry|attr|be|begin|being|by|canceled|case|cases|clusters?|coherence|commutativity|compatibility|connectedness|consider|consistency|constructors|contradiction|correctness|def|deffunc|define|definitions?|defpred|do|does|end|environ|equals|ex|exactly|existence|for|from|func|given|hence|hereby|holds|idempotence|identity|iff?|implies|involutiveness|irreflexivity|is|it|let|means|mode|non|not|notations?|now|of|or|otherwise|over|per|pred|prefix|projectivity|proof|provided|qua|reconsider|redefine|reduce|reducibility|reflexivity|registrations?|requirements|reserve|sch|schemes?|section|selector|set|sethood|st|struct|such|suppose|symmetry|synonym|take|that|the|then|theorems?|thesis|thus|to|transitivity|uniqueness|vocabular(?:ies|y)|when|where|with|wrt)\b/,
        parameter: {
            pattern: /\$(?:10|\d)/,
            alias: 'variable'
        },
        variable: /\b\w+(?=:)/,
        number: /(?:\b|-)\d+\b/,
        operator: /\.\.\.|->|&|\.?=/,
        punctuation: /\(#|#\)|[,:;\[\](){}]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$56ed3f40b114f9da$export$2e2bcd8739ae039.displayName = 'mongodb';
$56ed3f40b114f9da$export$2e2bcd8739ae039.aliases = [];
function $56ed3f40b114f9da$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $9f5c72e4d4e505c4$export$2e2bcd8739ae039));
    (function(Prism) {
        var operators = [
            // query and projection
            '$eq',
            '$gt',
            '$gte',
            '$in',
            '$lt',
            '$lte',
            '$ne',
            '$nin',
            '$and',
            '$not',
            '$nor',
            '$or',
            '$exists',
            '$type',
            '$expr',
            '$jsonSchema',
            '$mod',
            '$regex',
            '$text',
            '$where',
            '$geoIntersects',
            '$geoWithin',
            '$near',
            '$nearSphere',
            '$all',
            '$elemMatch',
            '$size',
            '$bitsAllClear',
            '$bitsAllSet',
            '$bitsAnyClear',
            '$bitsAnySet',
            '$comment',
            '$elemMatch',
            '$meta',
            '$slice',
            // update
            '$currentDate',
            '$inc',
            '$min',
            '$max',
            '$mul',
            '$rename',
            '$set',
            '$setOnInsert',
            '$unset',
            '$addToSet',
            '$pop',
            '$pull',
            '$push',
            '$pullAll',
            '$each',
            '$position',
            '$slice',
            '$sort',
            '$bit',
            // aggregation pipeline stages
            '$addFields',
            '$bucket',
            '$bucketAuto',
            '$collStats',
            '$count',
            '$currentOp',
            '$facet',
            '$geoNear',
            '$graphLookup',
            '$group',
            '$indexStats',
            '$limit',
            '$listLocalSessions',
            '$listSessions',
            '$lookup',
            '$match',
            '$merge',
            '$out',
            '$planCacheStats',
            '$project',
            '$redact',
            '$replaceRoot',
            '$replaceWith',
            '$sample',
            '$set',
            '$skip',
            '$sort',
            '$sortByCount',
            '$unionWith',
            '$unset',
            '$unwind',
            '$setWindowFields',
            // aggregation pipeline operators
            '$abs',
            '$accumulator',
            '$acos',
            '$acosh',
            '$add',
            '$addToSet',
            '$allElementsTrue',
            '$and',
            '$anyElementTrue',
            '$arrayElemAt',
            '$arrayToObject',
            '$asin',
            '$asinh',
            '$atan',
            '$atan2',
            '$atanh',
            '$avg',
            '$binarySize',
            '$bsonSize',
            '$ceil',
            '$cmp',
            '$concat',
            '$concatArrays',
            '$cond',
            '$convert',
            '$cos',
            '$dateFromParts',
            '$dateToParts',
            '$dateFromString',
            '$dateToString',
            '$dayOfMonth',
            '$dayOfWeek',
            '$dayOfYear',
            '$degreesToRadians',
            '$divide',
            '$eq',
            '$exp',
            '$filter',
            '$first',
            '$floor',
            '$function',
            '$gt',
            '$gte',
            '$hour',
            '$ifNull',
            '$in',
            '$indexOfArray',
            '$indexOfBytes',
            '$indexOfCP',
            '$isArray',
            '$isNumber',
            '$isoDayOfWeek',
            '$isoWeek',
            '$isoWeekYear',
            '$last',
            '$last',
            '$let',
            '$literal',
            '$ln',
            '$log',
            '$log10',
            '$lt',
            '$lte',
            '$ltrim',
            '$map',
            '$max',
            '$mergeObjects',
            '$meta',
            '$min',
            '$millisecond',
            '$minute',
            '$mod',
            '$month',
            '$multiply',
            '$ne',
            '$not',
            '$objectToArray',
            '$or',
            '$pow',
            '$push',
            '$radiansToDegrees',
            '$range',
            '$reduce',
            '$regexFind',
            '$regexFindAll',
            '$regexMatch',
            '$replaceOne',
            '$replaceAll',
            '$reverseArray',
            '$round',
            '$rtrim',
            '$second',
            '$setDifference',
            '$setEquals',
            '$setIntersection',
            '$setIsSubset',
            '$setUnion',
            '$size',
            '$sin',
            '$slice',
            '$split',
            '$sqrt',
            '$stdDevPop',
            '$stdDevSamp',
            '$strcasecmp',
            '$strLenBytes',
            '$strLenCP',
            '$substr',
            '$substrBytes',
            '$substrCP',
            '$subtract',
            '$sum',
            '$switch',
            '$tan',
            '$toBool',
            '$toDate',
            '$toDecimal',
            '$toDouble',
            '$toInt',
            '$toLong',
            '$toObjectId',
            '$toString',
            '$toLower',
            '$toUpper',
            '$trim',
            '$trunc',
            '$type',
            '$week',
            '$year',
            '$zip',
            '$count',
            '$dateAdd',
            '$dateDiff',
            '$dateSubtract',
            '$dateTrunc',
            '$getField',
            '$rand',
            '$sampleRate',
            '$setField',
            '$unsetField',
            // aggregation pipeline query modifiers
            '$comment',
            '$explain',
            '$hint',
            '$max',
            '$maxTimeMS',
            '$min',
            '$orderby',
            '$query',
            '$returnKey',
            '$showDiskLoc',
            '$natural'
        ];
        var builtinFunctions = [
            'ObjectId',
            'Code',
            'BinData',
            'DBRef',
            'Timestamp',
            'NumberLong',
            'NumberDecimal',
            'MaxKey',
            'MinKey',
            'RegExp',
            'ISODate',
            'UUID'
        ];
        operators = operators.map(function(operator) {
            return operator.replace('$', '\\$');
        });
        var operatorsSource = '(?:' + operators.join('|') + ')\\b';
        Prism.languages.mongodb = Prism.languages.extend('javascript', {});
        Prism.languages.insertBefore('mongodb', 'string', {
            property: {
                pattern: /(?:(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)(?=\s*:)/,
                greedy: true,
                inside: {
                    keyword: RegExp('^([\'"])?' + operatorsSource + '(?:\\1)?$')
                }
            }
        });
        Prism.languages.mongodb.string.inside = {
            url: {
                // url pattern
                pattern: /https?:\/\/[-\w@:%.+~#=]{1,256}\.[a-z0-9()]{1,6}\b[-\w()@:%+.~#?&/=]*/i,
                greedy: true
            },
            entity: {
                // ipv4
                pattern: /\b(?:(?:[01]?\d\d?|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d\d?|2[0-4]\d|25[0-5])\b/,
                greedy: true
            }
        };
        Prism.languages.insertBefore('mongodb', 'constant', {
            builtin: {
                pattern: RegExp('\\b(?:' + builtinFunctions.join('|') + ')\\b'),
                alias: 'keyword'
            }
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $211dce0e13dad2bb$export$2e2bcd8739ae039.displayName = 'monkey';
$211dce0e13dad2bb$export$2e2bcd8739ae039.aliases = [];
function $211dce0e13dad2bb$export$2e2bcd8739ae039(Prism) {
    Prism.languages.monkey = {
        comment: {
            pattern: /^#Rem\s[\s\S]*?^#End|'.+/im,
            greedy: true
        },
        string: {
            pattern: /"[^"\r\n]*"/,
            greedy: true
        },
        preprocessor: {
            pattern: /(^[ \t]*)#.+/m,
            lookbehind: true,
            greedy: true,
            alias: 'property'
        },
        function: /\b\w+(?=\()/,
        'type-char': {
            pattern: /\b[?%#$]/,
            alias: 'class-name'
        },
        number: {
            pattern: /((?:\.\.)?)(?:(?:\b|\B-\.?|\B\.)\d+(?:(?!\.\.)\.\d*)?|\$[\da-f]+)/i,
            lookbehind: true
        },
        keyword: /\b(?:Abstract|Array|Bool|Case|Catch|Class|Const|Continue|Default|Eachin|Else|ElseIf|End|EndIf|Exit|Extends|Extern|False|Field|Final|Float|For|Forever|Function|Global|If|Implements|Import|Inline|Int|Interface|Local|Method|Module|New|Next|Null|Object|Private|Property|Public|Repeat|Return|Select|Self|Step|Strict|String|Super|Then|Throw|To|True|Try|Until|Void|Wend|While)\b/i,
        operator: /\.\.|<[=>]?|>=?|:?=|(?:[+\-*\/&~|]|\b(?:Mod|Shl|Shr)\b)=?|\b(?:And|Not|Or)\b/i,
        punctuation: /[.,:;()\[\]]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $2bee048455602adf$export$2e2bcd8739ae039.displayName = 'moonscript';
$2bee048455602adf$export$2e2bcd8739ae039.aliases = [
    'moon'
];
function $2bee048455602adf$export$2e2bcd8739ae039(Prism) {
    Prism.languages.moonscript = {
        comment: /--.*/,
        string: [
            {
                pattern: /'[^']*'|\[(=*)\[[\s\S]*?\]\1\]/,
                greedy: true
            },
            {
                pattern: /"[^"]*"/,
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: /#\{[^{}]*\}/,
                        inside: {
                            moonscript: {
                                pattern: /(^#\{)[\s\S]+(?=\})/,
                                lookbehind: true,
                                inside: null // see beow
                            },
                            'interpolation-punctuation': {
                                pattern: /#\{|\}/,
                                alias: 'punctuation'
                            }
                        }
                    }
                }
            }
        ],
        'class-name': [
            {
                pattern: /(\b(?:class|extends)[ \t]+)\w+/,
                lookbehind: true
            },
            // class-like names start with a capital letter
            /\b[A-Z]\w*/
        ],
        keyword: /\b(?:class|continue|do|else|elseif|export|extends|for|from|if|import|in|local|nil|return|self|super|switch|then|unless|using|when|while|with)\b/,
        variable: /@@?\w*/,
        property: {
            pattern: /\b(?!\d)\w+(?=:)|(:)(?!\d)\w+/,
            lookbehind: true
        },
        function: {
            pattern: /\b(?:_G|_VERSION|assert|collectgarbage|coroutine\.(?:create|resume|running|status|wrap|yield)|debug\.(?:debug|getfenv|gethook|getinfo|getlocal|getmetatable|getregistry|getupvalue|setfenv|sethook|setlocal|setmetatable|setupvalue|traceback)|dofile|error|getfenv|getmetatable|io\.(?:close|flush|input|lines|open|output|popen|read|stderr|stdin|stdout|tmpfile|type|write)|ipairs|load|loadfile|loadstring|math\.(?:abs|acos|asin|atan|atan2|ceil|cos|cosh|deg|exp|floor|fmod|frexp|ldexp|log|log10|max|min|modf|pi|pow|rad|random|randomseed|sin|sinh|sqrt|tan|tanh)|module|next|os\.(?:clock|date|difftime|execute|exit|getenv|remove|rename|setlocale|time|tmpname)|package\.(?:cpath|loaded|loadlib|path|preload|seeall)|pairs|pcall|print|rawequal|rawget|rawset|require|select|setfenv|setmetatable|string\.(?:byte|char|dump|find|format|gmatch|gsub|len|lower|match|rep|reverse|sub|upper)|table\.(?:concat|insert|maxn|remove|sort)|tonumber|tostring|type|unpack|xpcall)\b/,
            inside: {
                punctuation: /\./
            }
        },
        boolean: /\b(?:false|true)\b/,
        number: /(?:\B\.\d+|\b\d+\.\d+|\b\d+(?=[eE]))(?:[eE][-+]?\d+)?\b|\b(?:0x[a-fA-F\d]+|\d+)(?:U?LL)?\b/,
        operator: /\.{3}|[-=]>|~=|(?:[-+*/%<>!=]|\.\.)=?|[:#^]|\b(?:and|or)\b=?|\b(?:not)\b/,
        punctuation: /[.,()[\]{}\\]/
    };
    Prism.languages.moonscript.string[1].inside.interpolation.inside.moonscript.inside = Prism.languages.moonscript;
    Prism.languages.moon = Prism.languages.moonscript;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $b35e937e9517d15f$export$2e2bcd8739ae039.displayName = 'n1ql';
$b35e937e9517d15f$export$2e2bcd8739ae039.aliases = [];
function $b35e937e9517d15f$export$2e2bcd8739ae039(Prism) {
    // https://docs.couchbase.com/server/current/n1ql/n1ql-language-reference/index.html
    Prism.languages.n1ql = {
        comment: {
            pattern: /\/\*[\s\S]*?(?:$|\*\/)|--.*/,
            greedy: true
        },
        string: {
            pattern: /(["'])(?:\\[\s\S]|(?!\1)[^\\]|\1\1)*\1/,
            greedy: true
        },
        identifier: {
            pattern: /`(?:\\[\s\S]|[^\\`]|``)*`/,
            greedy: true
        },
        parameter: /\$[\w.]+/,
        // https://docs.couchbase.com/server/current/n1ql/n1ql-language-reference/reservedwords.html#n1ql-reserved-words
        keyword: /\b(?:ADVISE|ALL|ALTER|ANALYZE|AS|ASC|AT|BEGIN|BINARY|BOOLEAN|BREAK|BUCKET|BUILD|BY|CALL|CAST|CLUSTER|COLLATE|COLLECTION|COMMIT|COMMITTED|CONNECT|CONTINUE|CORRELATE|CORRELATED|COVER|CREATE|CURRENT|DATABASE|DATASET|DATASTORE|DECLARE|DECREMENT|DELETE|DERIVED|DESC|DESCRIBE|DISTINCT|DO|DROP|EACH|ELEMENT|EXCEPT|EXCLUDE|EXECUTE|EXPLAIN|FETCH|FILTER|FLATTEN|FLUSH|FOLLOWING|FOR|FORCE|FROM|FTS|FUNCTION|GOLANG|GRANT|GROUP|GROUPS|GSI|HASH|HAVING|IF|IGNORE|ILIKE|INCLUDE|INCREMENT|INDEX|INFER|INLINE|INNER|INSERT|INTERSECT|INTO|IS|ISOLATION|JAVASCRIPT|JOIN|KEY|KEYS|KEYSPACE|KNOWN|LANGUAGE|LAST|LEFT|LET|LETTING|LEVEL|LIMIT|LSM|MAP|MAPPING|MATCHED|MATERIALIZED|MERGE|MINUS|MISSING|NAMESPACE|NEST|NL|NO|NTH_VALUE|NULL|NULLS|NUMBER|OBJECT|OFFSET|ON|OPTION|OPTIONS|ORDER|OTHERS|OUTER|OVER|PARSE|PARTITION|PASSWORD|PATH|POOL|PRECEDING|PREPARE|PRIMARY|PRIVATE|PRIVILEGE|PROBE|PROCEDURE|PUBLIC|RANGE|RAW|REALM|REDUCE|RENAME|RESPECT|RETURN|RETURNING|REVOKE|RIGHT|ROLE|ROLLBACK|ROW|ROWS|SATISFIES|SAVEPOINT|SCHEMA|SCOPE|SELECT|SELF|SEMI|SET|SHOW|SOME|START|STATISTICS|STRING|SYSTEM|TIES|TO|TRAN|TRANSACTION|TRIGGER|TRUNCATE|UNBOUNDED|UNDER|UNION|UNIQUE|UNKNOWN|UNNEST|UNSET|UPDATE|UPSERT|USE|USER|USING|VALIDATE|VALUE|VALUES|VIA|VIEW|WHERE|WHILE|WINDOW|WITH|WORK|XOR)\b/i,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        boolean: /\b(?:FALSE|TRUE)\b/i,
        number: /(?:\b\d+\.|\B\.)\d+e[+\-]?\d+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
        operator: /[-+*\/%]|!=|==?|\|\||<[>=]?|>=?|\b(?:AND|ANY|ARRAY|BETWEEN|CASE|ELSE|END|EVERY|EXISTS|FIRST|IN|LIKE|NOT|OR|THEN|VALUED|WHEN|WITHIN)\b/i,
        punctuation: /[;[\](),.{}:]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $a13fb2bc0247ad39$export$2e2bcd8739ae039.displayName = 'nand2tetris-hdl';
$a13fb2bc0247ad39$export$2e2bcd8739ae039.aliases = [];
function $a13fb2bc0247ad39$export$2e2bcd8739ae039(Prism) {
    Prism.languages['nand2tetris-hdl'] = {
        comment: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
        keyword: /\b(?:BUILTIN|CHIP|CLOCKED|IN|OUT|PARTS)\b/,
        boolean: /\b(?:false|true)\b/,
        function: /\b[A-Za-z][A-Za-z0-9]*(?=\()/,
        number: /\b\d+\b/,
        operator: /=|\.\./,
        punctuation: /[{}[\];(),:]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $67ac6d7ef8b75c7a$export$2e2bcd8739ae039.displayName = 'naniscript';
$67ac6d7ef8b75c7a$export$2e2bcd8739ae039.aliases = [
    'nani'
];
function $67ac6d7ef8b75c7a$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var expressionDef = /\{[^\r\n\[\]{}]*\}/;
        var params = {
            'quoted-string': {
                pattern: /"(?:[^"\\]|\\.)*"/,
                alias: 'operator'
            },
            'command-param-id': {
                pattern: /(\s)\w+:/,
                lookbehind: true,
                alias: 'property'
            },
            'command-param-value': [
                {
                    pattern: expressionDef,
                    alias: 'selector'
                },
                {
                    pattern: /([\t ])\S+/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'operator'
                },
                {
                    pattern: /\S(?:.*\S)?/,
                    alias: 'operator'
                }
            ]
        };
        Prism.languages.naniscript = {
            // ; ...
            comment: {
                pattern: /^([\t ]*);.*/m,
                lookbehind: true
            },
            // > ...
            // Define is a control line starting with '>' followed by a word, a space and a text.
            define: {
                pattern: /^>.+/m,
                alias: 'tag',
                inside: {
                    value: {
                        pattern: /(^>\w+[\t ]+)(?!\s)[^{}\r\n]+/,
                        lookbehind: true,
                        alias: 'operator'
                    },
                    key: {
                        pattern: /(^>)\w+/,
                        lookbehind: true
                    }
                }
            },
            // # ...
            label: {
                pattern: /^([\t ]*)#[\t ]*\w+[\t ]*$/m,
                lookbehind: true,
                alias: 'regex'
            },
            command: {
                pattern: /^([\t ]*)@\w+(?=[\t ]|$).*/m,
                lookbehind: true,
                alias: 'function',
                inside: {
                    'command-name': /^@\w+/,
                    expression: {
                        pattern: expressionDef,
                        greedy: true,
                        alias: 'selector'
                    },
                    'command-params': {
                        pattern: /\s*\S[\s\S]*/,
                        inside: params
                    }
                }
            },
            // Generic is any line that doesn't start with operators: ;>#@
            'generic-text': {
                pattern: /(^[ \t]*)[^#@>;\s].*/m,
                lookbehind: true,
                alias: 'punctuation',
                inside: {
                    // \{ ... \} ... \[ ... \] ... \"
                    'escaped-char': /\\[{}\[\]"]/,
                    expression: {
                        pattern: expressionDef,
                        greedy: true,
                        alias: 'selector'
                    },
                    'inline-command': {
                        pattern: /\[[\t ]*\w[^\r\n\[\]]*\]/,
                        greedy: true,
                        alias: 'function',
                        inside: {
                            'command-params': {
                                pattern: /(^\[[\t ]*\w+\b)[\s\S]+(?=\]$)/,
                                lookbehind: true,
                                inside: params
                            },
                            'command-param-name': {
                                pattern: /^(\[[\t ]*)\w+/,
                                lookbehind: true,
                                alias: 'name'
                            },
                            'start-stop-char': /[\[\]]/
                        }
                    }
                }
            }
        };
        Prism.languages.nani = Prism.languages['naniscript'];
        /** @typedef {InstanceType<import("./prism-core")["Token"]>} Token */ /**
     * This hook is used to validate generic-text tokens for balanced brackets.
     * Mark token as bad-line when contains not balanced brackets: {},[]
     */ Prism.hooks.add('after-tokenize', function(env) {
            /** @type {(Token | string)[]} */ var tokens = env.tokens;
            tokens.forEach(function(token) {
                if (typeof token !== 'string' && token.type === 'generic-text') {
                    var content = getTextContent(token);
                    if (!isBracketsBalanced(content)) {
                        token.type = 'bad-line';
                        token.content = content;
                    }
                }
            });
        });
        /**
     * @param {string} input
     * @returns {boolean}
     */ function isBracketsBalanced(input) {
            var brackets = '[]{}';
            var stack = [];
            for(var i = 0; i < input.length; i++){
                var bracket = input[i];
                var bracketsIndex = brackets.indexOf(bracket);
                if (bracketsIndex !== -1) {
                    if (bracketsIndex % 2 === 0) stack.push(bracketsIndex + 1);
                    else if (stack.pop() !== bracketsIndex) return false;
                }
            }
            return stack.length === 0;
        }
        /**
     * @param {string | Token | (string | Token)[]} token
     * @returns {string}
     */ function getTextContent(token) {
            if (typeof token === 'string') return token;
            else if (Array.isArray(token)) return token.map(getTextContent).join('');
            else return getTextContent(token.content);
        }
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $40cfb9ef16e11da4$export$2e2bcd8739ae039.displayName = 'nasm';
$40cfb9ef16e11da4$export$2e2bcd8739ae039.aliases = [];
function $40cfb9ef16e11da4$export$2e2bcd8739ae039(Prism) {
    Prism.languages.nasm = {
        comment: /;.*$/m,
        string: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
        label: {
            pattern: /(^\s*)[A-Za-z._?$][\w.?$@~#]*:/m,
            lookbehind: true,
            alias: 'function'
        },
        keyword: [
            /\[?BITS (?:16|32|64)\]?/,
            {
                pattern: /(^\s*)section\s*[a-z.]+:?/im,
                lookbehind: true
            },
            /(?:extern|global)[^;\r\n]*/i,
            /(?:CPU|DEFAULT|FLOAT).*$/m
        ],
        register: {
            pattern: /\b(?:st\d|[xyz]mm\d\d?|[cdt]r\d|r\d\d?[bwd]?|[er]?[abcd]x|[abcd][hl]|[er]?(?:bp|di|si|sp)|[cdefgs]s)\b/i,
            alias: 'variable'
        },
        number: /(?:\b|(?=\$))(?:0[hx](?:\.[\da-f]+|[\da-f]+(?:\.[\da-f]+)?)(?:p[+-]?\d+)?|\d[\da-f]+[hx]|\$\d[\da-f]*|0[oq][0-7]+|[0-7]+[oq]|0[by][01]+|[01]+[by]|0[dt]\d+|(?:\d+(?:\.\d+)?|\.\d+)(?:\.?e[+-]?\d+)?[dt]?)\b/i,
        operator: /[\[\]*+\-\/%<>=&|$!]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $35e43dc81d081cb9$export$2e2bcd8739ae039.displayName = 'neon';
$35e43dc81d081cb9$export$2e2bcd8739ae039.aliases = [];
function $35e43dc81d081cb9$export$2e2bcd8739ae039(Prism) {
    Prism.languages.neon = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        datetime: {
            pattern: /(^|[[{(=:,\s])\d\d\d\d-\d\d?-\d\d?(?:(?:[Tt]| +)\d\d?:\d\d:\d\d(?:\.\d*)? *(?:Z|[-+]\d\d?(?::?\d\d)?)?)?(?=$|[\]}),\s])/,
            lookbehind: true,
            alias: 'number'
        },
        key: {
            pattern: /(^|[[{(,\s])[^,:=[\]{}()'"\s]+(?=\s*:(?:$|[\]}),\s])|\s*=)/,
            lookbehind: true,
            alias: 'property'
        },
        number: {
            pattern: /(^|[[{(=:,\s])[+-]?(?:0x[\da-fA-F]+|0o[0-7]+|0b[01]+|(?:\d+(?:\.\d*)?|\.?\d+)(?:[eE][+-]?\d+)?)(?=$|[\]}),:=\s])/,
            lookbehind: true
        },
        boolean: {
            pattern: /(^|[[{(=:,\s])(?:false|no|true|yes)(?=$|[\]}),:=\s])/i,
            lookbehind: true
        },
        null: {
            pattern: /(^|[[{(=:,\s])(?:null)(?=$|[\]}),:=\s])/i,
            lookbehind: true,
            alias: 'keyword'
        },
        string: {
            pattern: /(^|[[{(=:,\s])(?:('''|""")\r?\n(?:(?:[^\r\n]|\r?\n(?![\t ]*\2))*\r?\n)?[\t ]*\2|'[^'\r\n]*'|"(?:\\.|[^\\"\r\n])*")/,
            lookbehind: true,
            greedy: true
        },
        literal: {
            pattern: /(^|[[{(=:,\s])(?:[^#"',:=[\]{}()\s`-]|[:-][^"',=[\]{}()\s])(?:[^,:=\]})(\s]|:(?![\s,\]})]|$)|[ \t]+[^#,:=\]})(\s])*/,
            lookbehind: true,
            alias: 'string'
        },
        punctuation: /[,:=[\]{}()-]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $125d6a9ccb15ad01$export$2e2bcd8739ae039.displayName = 'nevod';
$125d6a9ccb15ad01$export$2e2bcd8739ae039.aliases = [];
function $125d6a9ccb15ad01$export$2e2bcd8739ae039(Prism) {
    Prism.languages.nevod = {
        comment: /\/\/.*|(?:\/\*[\s\S]*?(?:\*\/|$))/,
        string: {
            pattern: /(?:"(?:""|[^"])*"(?!")|'(?:''|[^'])*'(?!'))!?\*?/,
            greedy: true,
            inside: {
                'string-attrs': /!$|!\*$|\*$/
            }
        },
        namespace: {
            pattern: /(@namespace\s+)[a-zA-Z0-9\-.]+(?=\s*\{)/,
            lookbehind: true
        },
        pattern: {
            pattern: /(@pattern\s+)?#?[a-zA-Z0-9\-.]+(?:\s*\(\s*(?:~\s*)?[a-zA-Z0-9\-.]+\s*(?:,\s*(?:~\s*)?[a-zA-Z0-9\-.]*)*\))?(?=\s*=)/,
            lookbehind: true,
            inside: {
                'pattern-name': {
                    pattern: /^#?[a-zA-Z0-9\-.]+/,
                    alias: 'class-name'
                },
                fields: {
                    pattern: /\(.*\)/,
                    inside: {
                        'field-name': {
                            pattern: /[a-zA-Z0-9\-.]+/,
                            alias: 'variable'
                        },
                        punctuation: /[,()]/,
                        operator: {
                            pattern: /~/,
                            alias: 'field-hidden-mark'
                        }
                    }
                }
            }
        },
        search: {
            pattern: /(@search\s+|#)[a-zA-Z0-9\-.]+(?:\.\*)?(?=\s*;)/,
            alias: 'function',
            lookbehind: true
        },
        keyword: /@(?:having|inside|namespace|outside|pattern|require|search|where)\b/,
        'standard-pattern': {
            pattern: /\b(?:Alpha|AlphaNum|Any|Blank|End|LineBreak|Num|NumAlpha|Punct|Space|Start|Symbol|Word|WordBreak)\b(?:\([a-zA-Z0-9\-.,\s+]*\))?/,
            inside: {
                'standard-pattern-name': {
                    pattern: /^[a-zA-Z0-9\-.]+/,
                    alias: 'builtin'
                },
                quantifier: {
                    pattern: /\b\d+(?:\s*\+|\s*-\s*\d+)?(?!\w)/,
                    alias: 'number'
                },
                'standard-pattern-attr': {
                    pattern: /[a-zA-Z0-9\-.]+/,
                    alias: 'builtin'
                },
                punctuation: /[,()]/
            }
        },
        quantifier: {
            pattern: /\b\d+(?:\s*\+|\s*-\s*\d+)?(?!\w)/,
            alias: 'number'
        },
        operator: [
            {
                pattern: /=/,
                alias: 'pattern-def'
            },
            {
                pattern: /&/,
                alias: 'conjunction'
            },
            {
                pattern: /~/,
                alias: 'exception'
            },
            {
                pattern: /\?/,
                alias: 'optionality'
            },
            {
                pattern: /[[\]]/,
                alias: 'repetition'
            },
            {
                pattern: /[{}]/,
                alias: 'variation'
            },
            {
                pattern: /[+_]/,
                alias: 'sequence'
            },
            {
                pattern: /\.{2,3}/,
                alias: 'span'
            }
        ],
        'field-capture': [
            {
                pattern: /([a-zA-Z0-9\-.]+\s*\()\s*[a-zA-Z0-9\-.]+\s*:\s*[a-zA-Z0-9\-.]+(?:\s*,\s*[a-zA-Z0-9\-.]+\s*:\s*[a-zA-Z0-9\-.]+)*(?=\s*\))/,
                lookbehind: true,
                inside: {
                    'field-name': {
                        pattern: /[a-zA-Z0-9\-.]+/,
                        alias: 'variable'
                    },
                    colon: /:/
                }
            },
            {
                pattern: /[a-zA-Z0-9\-.]+\s*:/,
                inside: {
                    'field-name': {
                        pattern: /[a-zA-Z0-9\-.]+/,
                        alias: 'variable'
                    },
                    colon: /:/
                }
            }
        ],
        punctuation: /[:;,()]/,
        name: /[a-zA-Z0-9\-.]+/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $f42e340bf35f0931$export$2e2bcd8739ae039.displayName = 'nginx';
$f42e340bf35f0931$export$2e2bcd8739ae039.aliases = [];
function $f42e340bf35f0931$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var variable = /\$(?:\w[a-z\d]*(?:_[^\x00-\x1F\s"'\\()$]*)?|\{[^}\s"'\\]+\})/i;
        Prism.languages.nginx = {
            comment: {
                pattern: /(^|[\s{};])#.*/,
                lookbehind: true,
                greedy: true
            },
            directive: {
                pattern: /(^|\s)\w(?:[^;{}"'\\\s]|\\.|"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*'|\s+(?:#.*(?!.)|(?![#\s])))*?(?=\s*[;{])/,
                lookbehind: true,
                greedy: true,
                inside: {
                    string: {
                        pattern: /((?:^|[^\\])(?:\\\\)*)(?:"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*')/,
                        lookbehind: true,
                        greedy: true,
                        inside: {
                            escape: {
                                pattern: /\\["'\\nrt]/,
                                alias: 'entity'
                            },
                            variable: variable
                        }
                    },
                    comment: {
                        pattern: /(\s)#.*/,
                        lookbehind: true,
                        greedy: true
                    },
                    keyword: {
                        pattern: /^\S+/,
                        greedy: true
                    },
                    // other patterns
                    boolean: {
                        pattern: /(\s)(?:off|on)(?!\S)/,
                        lookbehind: true
                    },
                    number: {
                        pattern: /(\s)\d+[a-z]*(?!\S)/i,
                        lookbehind: true
                    },
                    variable: variable
                }
            },
            punctuation: /[{};]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $75633cf46d2c1f4a$export$2e2bcd8739ae039.displayName = 'nim';
$75633cf46d2c1f4a$export$2e2bcd8739ae039.aliases = [];
function $75633cf46d2c1f4a$export$2e2bcd8739ae039(Prism) {
    Prism.languages.nim = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        string: {
            // Double-quoted strings can be prefixed by an identifier (Generalized raw string literals)
            pattern: /(?:\b(?!\d)(?:\w|\\x[89a-fA-F][0-9a-fA-F])+)?(?:"""[\s\S]*?"""(?!")|"(?:\\[\s\S]|""|[^"\\])*")/,
            greedy: true
        },
        char: {
            // Character literals are handled specifically to prevent issues with numeric type suffixes
            pattern: /'(?:\\(?:\d+|x[\da-fA-F]{0,2}|.)|[^'])'/,
            greedy: true
        },
        function: {
            pattern: /(?:(?!\d)(?:\w|\\x[89a-fA-F][0-9a-fA-F])+|`[^`\r\n]+`)\*?(?:\[[^\]]+\])?(?=\s*\()/,
            greedy: true,
            inside: {
                operator: /\*$/
            }
        },
        // We don't want to highlight operators (and anything really) inside backticks
        identifier: {
            pattern: /`[^`\r\n]+`/,
            greedy: true,
            inside: {
                punctuation: /`/
            }
        },
        // The negative look ahead prevents wrong highlighting of the .. operator
        number: /\b(?:0[xXoObB][\da-fA-F_]+|\d[\d_]*(?:(?!\.\.)\.[\d_]*)?(?:[eE][+-]?\d[\d_]*)?)(?:'?[iuf]\d*)?/,
        keyword: /\b(?:addr|as|asm|atomic|bind|block|break|case|cast|concept|const|continue|converter|defer|discard|distinct|do|elif|else|end|enum|except|export|finally|for|from|func|generic|if|import|include|interface|iterator|let|macro|method|mixin|nil|object|out|proc|ptr|raise|ref|return|static|template|try|tuple|type|using|var|when|while|with|without|yield)\b/,
        operator: {
            // Look behind and look ahead prevent wrong highlighting of punctuations [. .] {. .} (. .)
            // but allow the slice operator .. to take precedence over them
            // One can define his own operators in Nim so all combination of operators might be an operator.
            pattern: /(^|[({\[](?=\.\.)|(?![({\[]\.).)(?:(?:[=+\-*\/<>@$~&%|!?^:\\]|\.\.|\.(?![)}\]]))+|\b(?:and|div|in|is|isnot|mod|not|notin|of|or|shl|shr|xor)\b)/m,
            lookbehind: true
        },
        punctuation: /[({\[]\.|\.[)}\]]|[`(){}\[\],:]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $1bff446789010f5a$export$2e2bcd8739ae039.displayName = 'nix';
$1bff446789010f5a$export$2e2bcd8739ae039.aliases = [];
function $1bff446789010f5a$export$2e2bcd8739ae039(Prism) {
    Prism.languages.nix = {
        comment: {
            pattern: /\/\*[\s\S]*?\*\/|#.*/,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"\\]|\\[\s\S])*"|''(?:(?!'')[\s\S]|''(?:'|\\|\$\{))*''/,
            greedy: true,
            inside: {
                interpolation: {
                    // The lookbehind ensures the ${} is not preceded by \ or ''
                    pattern: /(^|(?:^|(?!'').)[^\\])\$\{(?:[^{}]|\{[^}]*\})*\}/,
                    lookbehind: true,
                    inside: null // see below
                }
            }
        },
        url: [
            /\b(?:[a-z]{3,7}:\/\/)[\w\-+%~\/.:#=?&]+/,
            {
                pattern: /([^\/])(?:[\w\-+%~.:#=?&]*(?!\/\/)[\w\-+%~\/.:#=?&])?(?!\/\/)\/[\w\-+%~\/.:#=?&]*/,
                lookbehind: true
            }
        ],
        antiquotation: {
            pattern: /\$(?=\{)/,
            alias: 'important'
        },
        number: /\b\d+\b/,
        keyword: /\b(?:assert|builtins|else|if|in|inherit|let|null|or|then|with)\b/,
        function: /\b(?:abort|add|all|any|attrNames|attrValues|baseNameOf|compareVersions|concatLists|currentSystem|deepSeq|derivation|dirOf|div|elem(?:At)?|fetch(?:Tarball|url)|filter(?:Source)?|fromJSON|genList|getAttr|getEnv|hasAttr|hashString|head|import|intersectAttrs|is(?:Attrs|Bool|Function|Int|List|Null|String)|length|lessThan|listToAttrs|map|mul|parseDrvName|pathExists|read(?:Dir|File)|removeAttrs|replaceStrings|seq|sort|stringLength|sub(?:string)?|tail|throw|to(?:File|JSON|Path|String|XML)|trace|typeOf)\b|\bfoldl'\B/,
        boolean: /\b(?:false|true)\b/,
        operator: /[=!<>]=?|\+\+?|\|\||&&|\/\/|->?|[?@]/,
        punctuation: /[{}()[\].,:;]/
    };
    Prism.languages.nix.string.inside.interpolation.inside = Prism.languages.nix;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $97c725d8f828cda7$export$2e2bcd8739ae039.displayName = 'nsis';
$97c725d8f828cda7$export$2e2bcd8739ae039.aliases = [];
function $97c725d8f828cda7$export$2e2bcd8739ae039(Prism) {
    /**
   * Original by Jan T. Sott (http://github.com/idleberg)
   *
   * Includes all commands and plug-ins shipped with NSIS 3.08
   */ Prism.languages.nsis = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|[#;].*)/,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        keyword: {
            pattern: /(^[\t ]*)(?:Abort|Add(?:BrandingImage|Size)|AdvSplash|Allow(?:RootDirInstall|SkipFiles)|AutoCloseWindow|BG(?:Font|Gradient|Image)|Banner|BrandingText|BringToFront|CRCCheck|Call(?:InstDLL)?|Caption|ChangeUI|CheckBitmap|ClearErrors|CompletedText|ComponentText|CopyFiles|Create(?:Directory|Font|ShortCut)|Delete(?:INISec|INIStr|RegKey|RegValue)?|Detail(?:Print|sButtonText)|Dialer|Dir(?:Text|Var|Verify)|EnableWindow|Enum(?:RegKey|RegValue)|Exch|Exec(?:Shell(?:Wait)?|Wait)?|ExpandEnvStrings|File(?:BufSize|Close|ErrorText|Open|Read|ReadByte|ReadUTF16LE|ReadWord|Seek|Write|WriteByte|WriteUTF16LE|WriteWord)?|Find(?:Close|First|Next|Window)|FlushINI|Get(?:CurInstType|CurrentAddress|DLLVersion(?:Local)?|DlgItem|ErrorLevel|FileTime(?:Local)?|FullPathName|Function(?:Address|End)?|InstDirError|KnownFolderPath|LabelAddress|TempFileName|WinVer)|Goto|HideWindow|Icon|If(?:Abort|Errors|FileExists|RebootFlag|RtlLanguage|ShellVarContextAll|Silent)|InitPluginsDir|InstProgressFlags|Inst(?:Type(?:GetText|SetText)?)|Install(?:ButtonText|Colors|Dir(?:RegKey)?)|Int(?:64|Ptr)?CmpU?|Int(?:64)?Fmt|Int(?:Ptr)?Op|IsWindow|Lang(?:DLL|String)|License(?:BkColor|Data|ForceSelection|LangString|Text)|LoadLanguageFile|LockWindow|Log(?:Set|Text)|Manifest(?:DPIAware|SupportedOS)|Math|MessageBox|MiscButtonText|NSISdl|Name|Nop|OutFile|PE(?:DllCharacteristics|SubsysVer)|Page(?:Callbacks)?|Pop|Push|Quit|RMDir|Read(?:EnvStr|INIStr|RegDWORD|RegStr)|Reboot|RegDLL|Rename|RequestExecutionLevel|ReserveFile|Return|SearchPath|Section(?:End|GetFlags|GetInstTypes|GetSize|GetText|Group|In|SetFlags|SetInstTypes|SetSize|SetText)?|SendMessage|Set(?:AutoClose|BrandingImage|Compress|Compressor(?:DictSize)?|CtlColors|CurInstType|DatablockOptimize|DateSave|Details(?:Print|View)|ErrorLevel|Errors|FileAttributes|Font|OutPath|Overwrite|PluginUnload|RebootFlag|RegView|ShellVarContext|Silent)|Show(?:InstDetails|UninstDetails|Window)|Silent(?:Install|UnInstall)|Sleep|SpaceTexts|Splash|StartMenu|Str(?:CmpS?|Cpy|Len)|SubCaption|System|Target|UnRegDLL|Unicode|UninstPage|Uninstall(?:ButtonText|Caption|Icon|SubCaption|Text)|UserInfo|VI(?:AddVersionKey|FileVersion|ProductVersion)|VPatch|Var|WindowIcon|Write(?:INIStr|Reg(?:Bin|DWORD|ExpandStr|MultiStr|None|Str)|Uninstaller)|XPStyle|ns(?:Dialogs|Exec))\b/m,
            lookbehind: true
        },
        property: /\b(?:ARCHIVE|FILE_(?:ATTRIBUTE_ARCHIVE|ATTRIBUTE_NORMAL|ATTRIBUTE_OFFLINE|ATTRIBUTE_READONLY|ATTRIBUTE_SYSTEM|ATTRIBUTE_TEMPORARY)|HK(?:(?:CR|CU|LM)(?:32|64)?|DD|PD|U)|HKEY_(?:CLASSES_ROOT|CURRENT_CONFIG|CURRENT_USER|DYN_DATA|LOCAL_MACHINE|PERFORMANCE_DATA|USERS)|ID(?:ABORT|CANCEL|IGNORE|NO|OK|RETRY|YES)|MB_(?:ABORTRETRYIGNORE|DEFBUTTON1|DEFBUTTON2|DEFBUTTON3|DEFBUTTON4|ICONEXCLAMATION|ICONINFORMATION|ICONQUESTION|ICONSTOP|OK|OKCANCEL|RETRYCANCEL|RIGHT|RTLREADING|SETFOREGROUND|TOPMOST|USERICON|YESNO)|NORMAL|OFFLINE|READONLY|SHCTX|SHELL_CONTEXT|SYSTEM|TEMPORARY|admin|all|auto|both|colored|false|force|hide|highest|lastused|leave|listonly|none|normal|notset|off|on|open|print|show|silent|silentlog|smooth|textonly|true|user)\b/,
        constant: /\$\{[!\w\.:\^-]+\}|\$\([!\w\.:\^-]+\)/,
        variable: /\$\w[\w\.]*/,
        number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
        operator: /--?|\+\+?|<=?|>=?|==?=?|&&?|\|\|?|[?*\/~^%]/,
        punctuation: /[{}[\];(),.:]/,
        important: {
            pattern: /(^[\t ]*)!(?:addincludedir|addplugindir|appendfile|cd|define|delfile|echo|else|endif|error|execute|finalize|getdllversion|gettlbversion|if|ifdef|ifmacrodef|ifmacrondef|ifndef|include|insertmacro|macro|macroend|makensis|packhdr|pragma|searchparse|searchreplace|system|tempfile|undef|verbose|warning)\b/im,
            lookbehind: true
        }
    };
}



// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $cd9a564d21652aa1$export$2e2bcd8739ae039.displayName = 'ocaml';
$cd9a564d21652aa1$export$2e2bcd8739ae039.aliases = [];
function $cd9a564d21652aa1$export$2e2bcd8739ae039(Prism) {
    // https://ocaml.org/manual/lex.html
    Prism.languages.ocaml = {
        comment: {
            pattern: /\(\*[\s\S]*?\*\)/,
            greedy: true
        },
        char: {
            pattern: /'(?:[^\\\r\n']|\\(?:.|[ox]?[0-9a-f]{1,3}))'/i,
            greedy: true
        },
        string: [
            {
                pattern: /"(?:\\(?:[\s\S]|\r\n)|[^\\\r\n"])*"/,
                greedy: true
            },
            {
                pattern: /\{([a-z_]*)\|[\s\S]*?\|\1\}/,
                greedy: true
            }
        ],
        number: [
            // binary and octal
            /\b(?:0b[01][01_]*|0o[0-7][0-7_]*)\b/i,
            // hexadecimal
            /\b0x[a-f0-9][a-f0-9_]*(?:\.[a-f0-9_]*)?(?:p[+-]?\d[\d_]*)?(?!\w)/i,
            // decimal
            /\b\d[\d_]*(?:\.[\d_]*)?(?:e[+-]?\d[\d_]*)?(?!\w)/i
        ],
        directive: {
            pattern: /\B#\w+/,
            alias: 'property'
        },
        label: {
            pattern: /\B~\w+/,
            alias: 'property'
        },
        'type-variable': {
            pattern: /\B'\w+/,
            alias: 'function'
        },
        variant: {
            pattern: /`\w+/,
            alias: 'symbol'
        },
        // For the list of keywords and operators,
        // see: http://caml.inria.fr/pub/docs/manual-ocaml/lex.html#sec84
        keyword: /\b(?:as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|match|method|module|mutable|new|nonrec|object|of|open|private|rec|sig|struct|then|to|try|type|val|value|virtual|when|where|while|with)\b/,
        boolean: /\b(?:false|true)\b/,
        'operator-like-punctuation': {
            pattern: /\[[<>|]|[>|]\]|\{<|>\}/,
            alias: 'punctuation'
        },
        // Custom operators are allowed
        operator: /\.[.~]|:[=>]|[=<>@^|&+\-*\/$%!?~][!$%&*+\-.\/:<=>?@^|~]*|\b(?:and|asr|land|lor|lsl|lsr|lxor|mod|or)\b/,
        punctuation: /;;|::|[(){}\[\].,:;#]|\b_\b/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $e05990136349c4df$export$2e2bcd8739ae039.displayName = 'odin';
$e05990136349c4df$export$2e2bcd8739ae039.aliases = [];
function $e05990136349c4df$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var escapes = /\\(?:["'\\abefnrtv]|0[0-7]{2}|U[\dA-Fa-f]{6}|u[\dA-Fa-f]{4}|x[\dA-Fa-f]{2})/;
        Prism.languages.odin = {
            /**
       * The current implementation supports only 1 level of nesting.
       *
       * @author Michael Schmidt
       * @author edukisto
       */ comment: [
                {
                    pattern: /\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:\*(?!\/)|[^*])*(?:\*\/|$))*(?:\*\/|$)/,
                    greedy: true
                },
                {
                    pattern: /#![^\n\r]*/,
                    greedy: true
                },
                {
                    pattern: /\/\/[^\n\r]*/,
                    greedy: true
                }
            ],
            /**
       * Should be found before strings because of '"'"- and '`'`-like sequences.
       */ char: {
                pattern: /'(?:\\(?:.|[0Uux][0-9A-Fa-f]{1,6})|[^\n\r'\\])'/,
                greedy: true,
                inside: {
                    symbol: escapes
                }
            },
            string: [
                {
                    pattern: /`[^`]*`/,
                    greedy: true
                },
                {
                    pattern: /"(?:\\.|[^\n\r"\\])*"/,
                    greedy: true,
                    inside: {
                        symbol: escapes
                    }
                }
            ],
            directive: {
                pattern: /#\w+/,
                alias: 'property'
            },
            number: /\b0(?:b[01_]+|d[\d_]+|h_*(?:(?:(?:[\dA-Fa-f]_*){8}){1,2}|(?:[\dA-Fa-f]_*){4})|o[0-7_]+|x[\dA-F_a-f]+|z[\dAB_ab]+)\b|(?:\b\d+(?:\.(?!\.)\d*)?|\B\.\d+)(?:[Ee][+-]?\d*)?[ijk]?(?!\w)/,
            discard: {
                pattern: /\b_\b/,
                alias: 'keyword'
            },
            'procedure-definition': {
                pattern: /\b\w+(?=[ \t]*(?::\s*){2}proc\b)/,
                alias: 'function'
            },
            keyword: /\b(?:asm|auto_cast|bit_set|break|case|cast|context|continue|defer|distinct|do|dynamic|else|enum|fallthrough|for|foreign|if|import|in|map|matrix|not_in|or_else|or_return|package|proc|return|struct|switch|transmute|typeid|union|using|when|where)\b/,
            /**
       * false, nil, true can be used as procedure names. "_" and keywords can't.
       */ 'procedure-name': {
                pattern: /\b\w+(?=[ \t]*\()/,
                alias: 'function'
            },
            boolean: /\b(?:false|nil|true)\b/,
            'constant-parameter-sign': {
                pattern: /\$/,
                alias: 'important'
            },
            undefined: {
                pattern: /---/,
                alias: 'operator'
            },
            arrow: {
                pattern: /->/,
                alias: 'punctuation'
            },
            operator: /\+\+|--|\.\.[<=]?|(?:&~|[-!*+/=~]|[%&<>|]{1,2})=?|[?^]/,
            punctuation: /[(),.:;@\[\]{}]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$b7975b7b5bfae0d4$export$2e2bcd8739ae039.displayName = 'opencl';
$b7975b7b5bfae0d4$export$2e2bcd8739ae039.aliases = [];
function $b7975b7b5bfae0d4$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $e064275ae5958777$export$2e2bcd8739ae039));
    (function(Prism) {
        /* OpenCL kernel language */ Prism.languages.opencl = Prism.languages.extend('c', {
            // Extracted from the official specs (2.0) and http://streamcomputing.eu/downloads/?opencl.lang (opencl-keywords, opencl-types) and http://sourceforge.net/tracker/?func=detail&aid=2957794&group_id=95717&atid=612384 (Words2, partly Words3)
            keyword: /\b(?:(?:__)?(?:constant|global|kernel|local|private|read_only|read_write|write_only)|__attribute__|auto|(?:bool|u?(?:char|int|long|short)|half|quad)(?:2|3|4|8|16)?|break|case|complex|const|continue|(?:double|float)(?:16(?:x(?:1|2|4|8|16))?|1x(?:1|2|4|8|16)|2(?:x(?:1|2|4|8|16))?|3|4(?:x(?:1|2|4|8|16))?|8(?:x(?:1|2|4|8|16))?)?|default|do|else|enum|extern|for|goto|if|imaginary|inline|packed|pipe|register|restrict|return|signed|sizeof|static|struct|switch|typedef|uniform|union|unsigned|void|volatile|while)\b/,
            // Extracted from http://streamcomputing.eu/downloads/?opencl.lang (opencl-const)
            // Math Constants: https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/mathConstants.html
            // Macros and Limits: https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/macroLimits.html
            number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[fuhl]{0,4}/i,
            boolean: /\b(?:false|true)\b/,
            'constant-opencl-kernel': {
                pattern: /\b(?:CHAR_(?:BIT|MAX|MIN)|CLK_(?:ADDRESS_(?:CLAMP(?:_TO_EDGE)?|NONE|REPEAT)|FILTER_(?:LINEAR|NEAREST)|(?:GLOBAL|LOCAL)_MEM_FENCE|NORMALIZED_COORDS_(?:FALSE|TRUE))|CL_(?:BGRA|(?:HALF_)?FLOAT|INTENSITY|LUMINANCE|A?R?G?B?[Ax]?|(?:(?:UN)?SIGNED|[US]NORM)_(?:INT(?:8|16|32))|UNORM_(?:INT_101010|SHORT_(?:555|565)))|(?:DBL|FLT|HALF)_(?:DIG|EPSILON|(?:MAX|MIN)(?:(?:_10)?_EXP)?|MANT_DIG)|FLT_RADIX|HUGE_VALF?|(?:INT|LONG|SCHAR|SHRT)_(?:MAX|MIN)|INFINITY|MAXFLOAT|M_(?:[12]_PI|2_SQRTPI|E|LN(?:2|10)|LOG(?:2|10)E?|PI(?:_[24])?|SQRT(?:1_2|2))(?:_F|_H)?|NAN|(?:UCHAR|UINT|ULONG|USHRT)_MAX)\b/,
                alias: 'constant'
            }
        });
        Prism.languages.insertBefore('opencl', 'class-name', {
            // https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/scalarDataTypes.html
            // https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/otherDataTypes.html
            'builtin-type': {
                pattern: /\b(?:_cl_(?:command_queue|context|device_id|event|kernel|mem|platform_id|program|sampler)|cl_(?:image_format|mem_fence_flags)|clk_event_t|event_t|image(?:1d_(?:array_|buffer_)?t|2d_(?:array_(?:depth_|msaa_depth_|msaa_)?|depth_|msaa_depth_|msaa_)?t|3d_t)|intptr_t|ndrange_t|ptrdiff_t|queue_t|reserve_id_t|sampler_t|size_t|uintptr_t)\b/,
                alias: 'keyword'
            }
        });
        var attributes = {
            // Extracted from http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-types and opencl-host)
            'type-opencl-host': {
                pattern: /\b(?:cl_(?:GLenum|GLint|GLuin|addressing_mode|bitfield|bool|buffer_create_type|build_status|channel_(?:order|type)|(?:u?(?:char|int|long|short)|double|float)(?:2|3|4|8|16)?|command_(?:queue(?:_info|_properties)?|type)|context(?:_info|_properties)?|device_(?:exec_capabilities|fp_config|id|info|local_mem_type|mem_cache_type|type)|(?:event|sampler)(?:_info)?|filter_mode|half|image_info|kernel(?:_info|_work_group_info)?|map_flags|mem(?:_flags|_info|_object_type)?|platform_(?:id|info)|profiling_info|program(?:_build_info|_info)?))\b/,
                alias: 'keyword'
            },
            'boolean-opencl-host': {
                pattern: /\bCL_(?:FALSE|TRUE)\b/,
                alias: 'boolean'
            },
            // Extracted from cl.h (2.0) and http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-const)
            'constant-opencl-host': {
                pattern: /\bCL_(?:A|ABGR|ADDRESS_(?:CLAMP(?:_TO_EDGE)?|MIRRORED_REPEAT|NONE|REPEAT)|ARGB|BGRA|BLOCKING|BUFFER_CREATE_TYPE_REGION|BUILD_(?:ERROR|IN_PROGRESS|NONE|PROGRAM_FAILURE|SUCCESS)|COMMAND_(?:ACQUIRE_GL_OBJECTS|BARRIER|COPY_(?:BUFFER(?:_RECT|_TO_IMAGE)?|IMAGE(?:_TO_BUFFER)?)|FILL_(?:BUFFER|IMAGE)|MAP(?:_BUFFER|_IMAGE)|MARKER|MIGRATE(?:_SVM)?_MEM_OBJECTS|NATIVE_KERNEL|NDRANGE_KERNEL|READ_(?:BUFFER(?:_RECT)?|IMAGE)|RELEASE_GL_OBJECTS|SVM_(?:FREE|MAP|MEMCPY|MEMFILL|UNMAP)|TASK|UNMAP_MEM_OBJECT|USER|WRITE_(?:BUFFER(?:_RECT)?|IMAGE))|COMPILER_NOT_AVAILABLE|COMPILE_PROGRAM_FAILURE|COMPLETE|CONTEXT_(?:DEVICES|INTEROP_USER_SYNC|NUM_DEVICES|PLATFORM|PROPERTIES|REFERENCE_COUNT)|DEPTH(?:_STENCIL)?|DEVICE_(?:ADDRESS_BITS|AFFINITY_DOMAIN_(?:L[1-4]_CACHE|NEXT_PARTITIONABLE|NUMA)|AVAILABLE|BUILT_IN_KERNELS|COMPILER_AVAILABLE|DOUBLE_FP_CONFIG|ENDIAN_LITTLE|ERROR_CORRECTION_SUPPORT|EXECUTION_CAPABILITIES|EXTENSIONS|GLOBAL_(?:MEM_(?:CACHELINE_SIZE|CACHE_SIZE|CACHE_TYPE|SIZE)|VARIABLE_PREFERRED_TOTAL_SIZE)|HOST_UNIFIED_MEMORY|IL_VERSION|IMAGE(?:2D_MAX_(?:HEIGHT|WIDTH)|3D_MAX_(?:DEPTH|HEIGHT|WIDTH)|_BASE_ADDRESS_ALIGNMENT|_MAX_ARRAY_SIZE|_MAX_BUFFER_SIZE|_PITCH_ALIGNMENT|_SUPPORT)|LINKER_AVAILABLE|LOCAL_MEM_SIZE|LOCAL_MEM_TYPE|MAX_(?:CLOCK_FREQUENCY|COMPUTE_UNITS|CONSTANT_ARGS|CONSTANT_BUFFER_SIZE|GLOBAL_VARIABLE_SIZE|MEM_ALLOC_SIZE|NUM_SUB_GROUPS|ON_DEVICE_(?:EVENTS|QUEUES)|PARAMETER_SIZE|PIPE_ARGS|READ_IMAGE_ARGS|READ_WRITE_IMAGE_ARGS|SAMPLERS|WORK_GROUP_SIZE|WORK_ITEM_DIMENSIONS|WORK_ITEM_SIZES|WRITE_IMAGE_ARGS)|MEM_BASE_ADDR_ALIGN|MIN_DATA_TYPE_ALIGN_SIZE|NAME|NATIVE_VECTOR_WIDTH_(?:CHAR|DOUBLE|FLOAT|HALF|INT|LONG|SHORT)|NOT_(?:AVAILABLE|FOUND)|OPENCL_C_VERSION|PARENT_DEVICE|PARTITION_(?:AFFINITY_DOMAIN|BY_AFFINITY_DOMAIN|BY_COUNTS|BY_COUNTS_LIST_END|EQUALLY|FAILED|MAX_SUB_DEVICES|PROPERTIES|TYPE)|PIPE_MAX_(?:ACTIVE_RESERVATIONS|PACKET_SIZE)|PLATFORM|PREFERRED_(?:GLOBAL_ATOMIC_ALIGNMENT|INTEROP_USER_SYNC|LOCAL_ATOMIC_ALIGNMENT|PLATFORM_ATOMIC_ALIGNMENT|VECTOR_WIDTH_(?:CHAR|DOUBLE|FLOAT|HALF|INT|LONG|SHORT))|PRINTF_BUFFER_SIZE|PROFILE|PROFILING_TIMER_RESOLUTION|QUEUE_(?:ON_(?:DEVICE_(?:MAX_SIZE|PREFERRED_SIZE|PROPERTIES)|HOST_PROPERTIES)|PROPERTIES)|REFERENCE_COUNT|SINGLE_FP_CONFIG|SUB_GROUP_INDEPENDENT_FORWARD_PROGRESS|SVM_(?:ATOMICS|CAPABILITIES|COARSE_GRAIN_BUFFER|FINE_GRAIN_BUFFER|FINE_GRAIN_SYSTEM)|TYPE(?:_ACCELERATOR|_ALL|_CPU|_CUSTOM|_DEFAULT|_GPU)?|VENDOR(?:_ID)?|VERSION)|DRIVER_VERSION|EVENT_(?:COMMAND_(?:EXECUTION_STATUS|QUEUE|TYPE)|CONTEXT|REFERENCE_COUNT)|EXEC_(?:KERNEL|NATIVE_KERNEL|STATUS_ERROR_FOR_EVENTS_IN_WAIT_LIST)|FILTER_(?:LINEAR|NEAREST)|FLOAT|FP_(?:CORRECTLY_ROUNDED_DIVIDE_SQRT|DENORM|FMA|INF_NAN|ROUND_TO_INF|ROUND_TO_NEAREST|ROUND_TO_ZERO|SOFT_FLOAT)|GLOBAL|HALF_FLOAT|IMAGE_(?:ARRAY_SIZE|BUFFER|DEPTH|ELEMENT_SIZE|FORMAT|FORMAT_MISMATCH|FORMAT_NOT_SUPPORTED|HEIGHT|NUM_MIP_LEVELS|NUM_SAMPLES|ROW_PITCH|SLICE_PITCH|WIDTH)|INTENSITY|INVALID_(?:ARG_INDEX|ARG_SIZE|ARG_VALUE|BINARY|BUFFER_SIZE|BUILD_OPTIONS|COMMAND_QUEUE|COMPILER_OPTIONS|CONTEXT|DEVICE|DEVICE_PARTITION_COUNT|DEVICE_QUEUE|DEVICE_TYPE|EVENT|EVENT_WAIT_LIST|GLOBAL_OFFSET|GLOBAL_WORK_SIZE|GL_OBJECT|HOST_PTR|IMAGE_DESCRIPTOR|IMAGE_FORMAT_DESCRIPTOR|IMAGE_SIZE|KERNEL|KERNEL_ARGS|KERNEL_DEFINITION|KERNEL_NAME|LINKER_OPTIONS|MEM_OBJECT|MIP_LEVEL|OPERATION|PIPE_SIZE|PLATFORM|PROGRAM|PROGRAM_EXECUTABLE|PROPERTY|QUEUE_PROPERTIES|SAMPLER|VALUE|WORK_DIMENSION|WORK_GROUP_SIZE|WORK_ITEM_SIZE)|KERNEL_(?:ARG_(?:ACCESS_(?:NONE|QUALIFIER|READ_ONLY|READ_WRITE|WRITE_ONLY)|ADDRESS_(?:CONSTANT|GLOBAL|LOCAL|PRIVATE|QUALIFIER)|INFO_NOT_AVAILABLE|NAME|TYPE_(?:CONST|NAME|NONE|PIPE|QUALIFIER|RESTRICT|VOLATILE))|ATTRIBUTES|COMPILE_NUM_SUB_GROUPS|COMPILE_WORK_GROUP_SIZE|CONTEXT|EXEC_INFO_SVM_FINE_GRAIN_SYSTEM|EXEC_INFO_SVM_PTRS|FUNCTION_NAME|GLOBAL_WORK_SIZE|LOCAL_MEM_SIZE|LOCAL_SIZE_FOR_SUB_GROUP_COUNT|MAX_NUM_SUB_GROUPS|MAX_SUB_GROUP_SIZE_FOR_NDRANGE|NUM_ARGS|PREFERRED_WORK_GROUP_SIZE_MULTIPLE|PRIVATE_MEM_SIZE|PROGRAM|REFERENCE_COUNT|SUB_GROUP_COUNT_FOR_NDRANGE|WORK_GROUP_SIZE)|LINKER_NOT_AVAILABLE|LINK_PROGRAM_FAILURE|LOCAL|LUMINANCE|MAP_(?:FAILURE|READ|WRITE|WRITE_INVALIDATE_REGION)|MEM_(?:ALLOC_HOST_PTR|ASSOCIATED_MEMOBJECT|CONTEXT|COPY_HOST_PTR|COPY_OVERLAP|FLAGS|HOST_NO_ACCESS|HOST_PTR|HOST_READ_ONLY|HOST_WRITE_ONLY|KERNEL_READ_AND_WRITE|MAP_COUNT|OBJECT_(?:ALLOCATION_FAILURE|BUFFER|IMAGE1D|IMAGE1D_ARRAY|IMAGE1D_BUFFER|IMAGE2D|IMAGE2D_ARRAY|IMAGE3D|PIPE)|OFFSET|READ_ONLY|READ_WRITE|REFERENCE_COUNT|SIZE|SVM_ATOMICS|SVM_FINE_GRAIN_BUFFER|TYPE|USES_SVM_POINTER|USE_HOST_PTR|WRITE_ONLY)|MIGRATE_MEM_OBJECT_(?:CONTENT_UNDEFINED|HOST)|MISALIGNED_SUB_BUFFER_OFFSET|NONE|NON_BLOCKING|OUT_OF_(?:HOST_MEMORY|RESOURCES)|PIPE_(?:MAX_PACKETS|PACKET_SIZE)|PLATFORM_(?:EXTENSIONS|HOST_TIMER_RESOLUTION|NAME|PROFILE|VENDOR|VERSION)|PROFILING_(?:COMMAND_(?:COMPLETE|END|QUEUED|START|SUBMIT)|INFO_NOT_AVAILABLE)|PROGRAM_(?:BINARIES|BINARY_SIZES|BINARY_TYPE(?:_COMPILED_OBJECT|_EXECUTABLE|_LIBRARY|_NONE)?|BUILD_(?:GLOBAL_VARIABLE_TOTAL_SIZE|LOG|OPTIONS|STATUS)|CONTEXT|DEVICES|IL|KERNEL_NAMES|NUM_DEVICES|NUM_KERNELS|REFERENCE_COUNT|SOURCE)|QUEUED|QUEUE_(?:CONTEXT|DEVICE|DEVICE_DEFAULT|ON_DEVICE|ON_DEVICE_DEFAULT|OUT_OF_ORDER_EXEC_MODE_ENABLE|PROFILING_ENABLE|PROPERTIES|REFERENCE_COUNT|SIZE)|R|RA|READ_(?:ONLY|WRITE)_CACHE|RG|RGB|RGBA|RGBx|RGx|RUNNING|Rx|SAMPLER_(?:ADDRESSING_MODE|CONTEXT|FILTER_MODE|LOD_MAX|LOD_MIN|MIP_FILTER_MODE|NORMALIZED_COORDS|REFERENCE_COUNT)|(?:UN)?SIGNED_INT(?:8|16|32)|SNORM_INT(?:8|16)|SUBMITTED|SUCCESS|UNORM_INT(?:8|16|24|_101010|_101010_2)|UNORM_SHORT_(?:555|565)|VERSION_(?:1_0|1_1|1_2|2_0|2_1)|sBGRA|sRGB|sRGBA|sRGBx)\b/,
                alias: 'constant'
            },
            // Extracted from cl.h (2.0) and http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-host)
            'function-opencl-host': {
                pattern: /\bcl(?:BuildProgram|CloneKernel|CompileProgram|Create(?:Buffer|CommandQueue(?:WithProperties)?|Context|ContextFromType|Image|Image2D|Image3D|Kernel|KernelsInProgram|Pipe|ProgramWith(?:Binary|BuiltInKernels|IL|Source)|Sampler|SamplerWithProperties|SubBuffer|SubDevices|UserEvent)|Enqueue(?:(?:Barrier|Marker)(?:WithWaitList)?|Copy(?:Buffer(?:Rect|ToImage)?|Image(?:ToBuffer)?)|(?:Fill|Map)(?:Buffer|Image)|MigrateMemObjects|NDRangeKernel|NativeKernel|(?:Read|Write)(?:Buffer(?:Rect)?|Image)|SVM(?:Free|Map|MemFill|Memcpy|MigrateMem|Unmap)|Task|UnmapMemObject|WaitForEvents)|Finish|Flush|Get(?:CommandQueueInfo|ContextInfo|Device(?:AndHostTimer|IDs|Info)|Event(?:Profiling)?Info|ExtensionFunctionAddress(?:ForPlatform)?|HostTimer|ImageInfo|Kernel(?:ArgInfo|Info|SubGroupInfo|WorkGroupInfo)|MemObjectInfo|PipeInfo|Platform(?:IDs|Info)|Program(?:Build)?Info|SamplerInfo|SupportedImageFormats)|LinkProgram|(?:Release|Retain)(?:CommandQueue|Context|Device|Event|Kernel|MemObject|Program|Sampler)|SVM(?:Alloc|Free)|Set(?:CommandQueueProperty|DefaultDeviceCommandQueue|EventCallback|Kernel|Kernel(?:Arg(?:SVMPointer)?|ExecInfo)|MemObjectDestructorCallback|UserEventStatus)|Unload(?:Platform)?Compiler|WaitForEvents)\b/,
                alias: 'function'
            }
        };
        /* OpenCL host API */ Prism.languages.insertBefore('c', 'keyword', attributes);
        // C++ includes everything from the OpenCL C host API plus the classes defined in cl2.h
        if (Prism.languages.cpp) {
            // Extracted from doxygen class list http://github.khronos.org/OpenCL-CLHPP/annotated.html
            attributes['type-opencl-host-cpp'] = {
                pattern: /\b(?:Buffer|BufferGL|BufferRenderGL|CommandQueue|Context|Device|DeviceCommandQueue|EnqueueArgs|Event|Image|Image1D|Image1DArray|Image1DBuffer|Image2D|Image2DArray|Image2DGL|Image3D|Image3DGL|ImageFormat|ImageGL|Kernel|KernelFunctor|LocalSpaceArg|Memory|NDRange|Pipe|Platform|Program|SVMAllocator|SVMTraitAtomic|SVMTraitCoarse|SVMTraitFine|SVMTraitReadOnly|SVMTraitReadWrite|SVMTraitWriteOnly|Sampler|UserEvent)\b/,
                alias: 'keyword'
            };
            Prism.languages.insertBefore('cpp', 'keyword', attributes);
        }
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $2f2929915e467e10$export$2e2bcd8739ae039.displayName = 'openqasm';
$2f2929915e467e10$export$2e2bcd8739ae039.aliases = [
    'qasm'
];
function $2f2929915e467e10$export$2e2bcd8739ae039(Prism) {
    // https://qiskit.github.io/openqasm/grammar/index.html
    Prism.languages.openqasm = {
        comment: /\/\*[\s\S]*?\*\/|\/\/.*/,
        string: {
            pattern: /"[^"\r\n\t]*"|'[^'\r\n\t]*'/,
            greedy: true
        },
        keyword: /\b(?:CX|OPENQASM|U|barrier|boxas|boxto|break|const|continue|ctrl|def|defcal|defcalgrammar|delay|else|end|for|gate|gphase|if|in|include|inv|kernel|lengthof|let|measure|pow|reset|return|rotary|stretchinf|while)\b|#pragma\b/,
        'class-name': /\b(?:angle|bit|bool|creg|fixed|float|int|length|qreg|qubit|stretch|uint)\b/,
        function: /\b(?:cos|exp|ln|popcount|rotl|rotr|sin|sqrt|tan)\b(?=\s*\()/,
        constant: /\b(?:euler|pi|tau)\b|π|𝜏|ℇ/,
        number: {
            pattern: /(^|[^.\w$])(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?(?:dt|ns|us|µs|ms|s)?/i,
            lookbehind: true
        },
        operator: /->|>>=?|<<=?|&&|\|\||\+\+|--|[!=<>&|~^+\-*/%]=?|@/,
        punctuation: /[(){}\[\];,:.]/
    };
    Prism.languages.qasm = Prism.languages.openqasm;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $54b2f524a651ec09$export$2e2bcd8739ae039.displayName = 'oz';
$54b2f524a651ec09$export$2e2bcd8739ae039.aliases = [];
function $54b2f524a651ec09$export$2e2bcd8739ae039(Prism) {
    Prism.languages.oz = {
        comment: {
            pattern: /\/\*[\s\S]*?\*\/|%.*/,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"\\]|\\[\s\S])*"/,
            greedy: true
        },
        atom: {
            pattern: /'(?:[^'\\]|\\[\s\S])*'/,
            greedy: true,
            alias: 'builtin'
        },
        keyword: /\$|\[\]|\b(?:_|at|attr|case|catch|choice|class|cond|declare|define|dis|else(?:case|if)?|end|export|fail|false|feat|finally|from|fun|functor|if|import|in|local|lock|meth|nil|not|of|or|prepare|proc|prop|raise|require|self|skip|then|thread|true|try|unit)\b/,
        function: [
            /\b[a-z][A-Za-z\d]*(?=\()/,
            {
                pattern: /(\{)[A-Z][A-Za-z\d]*\b/,
                lookbehind: true
            }
        ],
        number: /\b(?:0[bx][\da-f]+|\d+(?:\.\d*)?(?:e~?\d+)?)\b|&(?:[^\\]|\\(?:\d{3}|.))/i,
        variable: /`(?:[^`\\]|\\.)+`/,
        'attr-name': /\b\w+(?=[ \t]*:(?![:=]))/,
        operator: /:(?:=|::?)|<[-:=]?|=(?:=|<?:?)|>=?:?|\\=:?|!!?|[|#+\-*\/,~^@]|\b(?:andthen|div|mod|orelse)\b/,
        punctuation: /[\[\](){}.:;?]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $cdc3b5076c1ba432$export$2e2bcd8739ae039.displayName = 'parigp';
$cdc3b5076c1ba432$export$2e2bcd8739ae039.aliases = [];
function $cdc3b5076c1ba432$export$2e2bcd8739ae039(Prism) {
    Prism.languages.parigp = {
        comment: /\/\*[\s\S]*?\*\/|\\\\.*/,
        string: {
            pattern: /"(?:[^"\\\r\n]|\\.)*"/,
            greedy: true
        },
        // PARI/GP does not care about white spaces at all
        // so let's process the keywords to build an appropriate regexp
        // (e.g. "b *r *e *a *k", etc.)
        keyword: function() {
            var keywords = [
                'breakpoint',
                'break',
                'dbg_down',
                'dbg_err',
                'dbg_up',
                'dbg_x',
                'forcomposite',
                'fordiv',
                'forell',
                'forpart',
                'forprime',
                'forstep',
                'forsubgroup',
                'forvec',
                'for',
                'iferr',
                'if',
                'local',
                'my',
                'next',
                'return',
                'until',
                'while'
            ];
            keywords = keywords.map(function(keyword) {
                return keyword.split('').join(' *');
            }).join('|');
            return RegExp('\\b(?:' + keywords + ')\\b');
        }(),
        function: /\b\w(?:[\w ]*\w)?(?= *\()/,
        number: {
            // The lookbehind and the negative lookahead prevent from breaking the .. operator
            pattern: /((?:\. *\. *)?)(?:\b\d(?: *\d)*(?: *(?!\. *\.)\.(?: *\d)*)?|\. *\d(?: *\d)*)(?: *e *(?:[+-] *)?\d(?: *\d)*)?/i,
            lookbehind: true
        },
        operator: /\. *\.|[*\/!](?: *=)?|%(?: *=|(?: *#)?(?: *')*)?|\+(?: *[+=])?|-(?: *[-=>])?|<(?: *>|(?: *<)?(?: *=)?)?|>(?: *>)?(?: *=)?|=(?: *=){0,2}|\\(?: *\/)?(?: *=)?|&(?: *&)?|\| *\||['#~^]/,
        punctuation: /[\[\]{}().,:;|]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$93a3c4102cd2d290$export$2e2bcd8739ae039.displayName = 'parser';
$93a3c4102cd2d290$export$2e2bcd8739ae039.aliases = [];
function $93a3c4102cd2d290$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $8fbeea7c20d72e06$export$2e2bcd8739ae039));
    (function(Prism) {
        var parser = Prism.languages.parser = Prism.languages.extend('markup', {
            keyword: {
                pattern: /(^|[^^])(?:\^(?:case|eval|for|if|switch|throw)\b|@(?:BASE|CLASS|GET(?:_DEFAULT)?|OPTIONS|SET_DEFAULT|USE)\b)/,
                lookbehind: true
            },
            variable: {
                pattern: /(^|[^^])\B\$(?:\w+|(?=[.{]))(?:(?:\.|::?)\w+)*(?:\.|::?)?/,
                lookbehind: true,
                inside: {
                    punctuation: /\.|:+/
                }
            },
            function: {
                pattern: /(^|[^^])\B[@^]\w+(?:(?:\.|::?)\w+)*(?:\.|::?)?/,
                lookbehind: true,
                inside: {
                    keyword: {
                        pattern: /(^@)(?:GET_|SET_)/,
                        lookbehind: true
                    },
                    punctuation: /\.|:+/
                }
            },
            escape: {
                pattern: /\^(?:[$^;@()\[\]{}"':]|#[a-f\d]*)/i,
                alias: 'builtin'
            },
            punctuation: /[\[\](){};]/
        });
        parser = Prism.languages.insertBefore('parser', 'keyword', {
            'parser-comment': {
                pattern: /(\s)#.*/,
                lookbehind: true,
                alias: 'comment'
            },
            expression: {
                // Allow for 3 levels of depth
                pattern: /(^|[^^])\((?:[^()]|\((?:[^()]|\((?:[^()])*\))*\))*\)/,
                greedy: true,
                lookbehind: true,
                inside: {
                    string: {
                        pattern: /(^|[^^])(["'])(?:(?!\2)[^^]|\^[\s\S])*\2/,
                        lookbehind: true
                    },
                    keyword: parser.keyword,
                    variable: parser.variable,
                    function: parser.function,
                    boolean: /\b(?:false|true)\b/,
                    number: /\b(?:0x[a-f\d]+|\d+(?:\.\d*)?(?:e[+-]?\d+)?)\b/i,
                    escape: parser.escape,
                    operator: /[~+*\/\\%]|!(?:\|\|?|=)?|&&?|\|\|?|==|<[<=]?|>[>=]?|-[fd]?|\b(?:def|eq|ge|gt|in|is|le|lt|ne)\b/,
                    punctuation: parser.punctuation
                }
            }
        });
        Prism.languages.insertBefore('inside', 'punctuation', {
            expression: parser.expression,
            keyword: parser.keyword,
            variable: parser.variable,
            function: parser.function,
            escape: parser.escape,
            'parser-punctuation': {
                pattern: parser.punctuation,
                alias: 'punctuation'
            }
        }, parser['tag'].inside['attr-value']);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $1b15ceff9a8a0e6b$export$2e2bcd8739ae039.displayName = 'pascal';
$1b15ceff9a8a0e6b$export$2e2bcd8739ae039.aliases = [
    'objectpascal'
];
function $1b15ceff9a8a0e6b$export$2e2bcd8739ae039(Prism) {
    // Based on Free Pascal
    /* TODO
Support inline asm ?
*/ Prism.languages.pascal = {
        directive: {
            pattern: /\{\$[\s\S]*?\}/,
            greedy: true,
            alias: [
                'marco',
                'property'
            ]
        },
        comment: {
            pattern: /\(\*[\s\S]*?\*\)|\{[\s\S]*?\}|\/\/.*/,
            greedy: true
        },
        string: {
            pattern: /(?:'(?:''|[^'\r\n])*'(?!')|#[&$%]?[a-f\d]+)+|\^[a-z]/i,
            greedy: true
        },
        asm: {
            pattern: /(\basm\b)[\s\S]+?(?=\bend\s*[;[])/i,
            lookbehind: true,
            greedy: true,
            inside: null // see below
        },
        keyword: [
            {
                // Turbo Pascal
                pattern: /(^|[^&])\b(?:absolute|array|asm|begin|case|const|constructor|destructor|do|downto|else|end|file|for|function|goto|if|implementation|inherited|inline|interface|label|nil|object|of|operator|packed|procedure|program|record|reintroduce|repeat|self|set|string|then|to|type|unit|until|uses|var|while|with)\b/i,
                lookbehind: true
            },
            {
                // Free Pascal
                pattern: /(^|[^&])\b(?:dispose|exit|false|new|true)\b/i,
                lookbehind: true
            },
            {
                // Object Pascal
                pattern: /(^|[^&])\b(?:class|dispinterface|except|exports|finalization|finally|initialization|inline|library|on|out|packed|property|raise|resourcestring|threadvar|try)\b/i,
                lookbehind: true
            },
            {
                // Modifiers
                pattern: /(^|[^&])\b(?:absolute|abstract|alias|assembler|bitpacked|break|cdecl|continue|cppdecl|cvar|default|deprecated|dynamic|enumerator|experimental|export|external|far|far16|forward|generic|helper|implements|index|interrupt|iochecks|local|message|name|near|nodefault|noreturn|nostackframe|oldfpccall|otherwise|overload|override|pascal|platform|private|protected|public|published|read|register|reintroduce|result|safecall|saveregisters|softfloat|specialize|static|stdcall|stored|strict|unaligned|unimplemented|varargs|virtual|write)\b/i,
                lookbehind: true
            }
        ],
        number: [
            // Hexadecimal, octal and binary
            /(?:[&%]\d+|\$[a-f\d]+)/i,
            // Decimal
            /\b\d+(?:\.\d+)?(?:e[+-]?\d+)?/i
        ],
        operator: [
            /\.\.|\*\*|:=|<[<=>]?|>[>=]?|[+\-*\/]=?|[@^=]/,
            {
                pattern: /(^|[^&])\b(?:and|as|div|exclude|in|include|is|mod|not|or|shl|shr|xor)\b/,
                lookbehind: true
            }
        ],
        punctuation: /\(\.|\.\)|[()\[\]:;,.]/
    };
    Prism.languages.pascal.asm.inside = Prism.languages.extend('pascal', {
        asm: undefined,
        keyword: undefined,
        operator: undefined
    });
    Prism.languages.objectpascal = Prism.languages.pascal;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $c030b773dec3817a$export$2e2bcd8739ae039.displayName = 'pascaligo';
$c030b773dec3817a$export$2e2bcd8739ae039.aliases = [];
function $c030b773dec3817a$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // Pascaligo is a layer 2 smart contract language for the tezos blockchain
        var braces = /\((?:[^()]|\((?:[^()]|\([^()]*\))*\))*\)/.source;
        var type = /(?:\b\w+(?:<braces>)?|<braces>)/.source.replace(/<braces>/g, function() {
            return braces;
        });
        var pascaligo = Prism.languages.pascaligo = {
            comment: /\(\*[\s\S]+?\*\)|\/\/.*/,
            string: {
                pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1|\^[a-z]/i,
                greedy: true
            },
            'class-name': [
                {
                    pattern: RegExp(/(\btype\s+\w+\s+is\s+)<type>/.source.replace(/<type>/g, function() {
                        return type;
                    }), 'i'),
                    lookbehind: true,
                    inside: null // see below
                },
                {
                    pattern: RegExp(/<type>(?=\s+is\b)/.source.replace(/<type>/g, function() {
                        return type;
                    }), 'i'),
                    inside: null // see below
                },
                {
                    pattern: RegExp(/(:\s*)<type>/.source.replace(/<type>/g, function() {
                        return type;
                    })),
                    lookbehind: true,
                    inside: null // see below
                }
            ],
            keyword: {
                pattern: /(^|[^&])\b(?:begin|block|case|const|else|end|fail|for|from|function|if|is|nil|of|remove|return|skip|then|type|var|while|with)\b/i,
                lookbehind: true
            },
            boolean: {
                pattern: /(^|[^&])\b(?:False|True)\b/i,
                lookbehind: true
            },
            builtin: {
                pattern: /(^|[^&])\b(?:bool|int|list|map|nat|record|string|unit)\b/i,
                lookbehind: true
            },
            function: /\b\w+(?=\s*\()/,
            number: [
                // Hexadecimal, octal and binary
                /%[01]+|&[0-7]+|\$[a-f\d]+/i,
                // Decimal
                /\b\d+(?:\.\d+)?(?:e[+-]?\d+)?(?:mtz|n)?/i
            ],
            operator: /->|=\/=|\.\.|\*\*|:=|<[<=>]?|>[>=]?|[+\-*\/]=?|[@^=|]|\b(?:and|mod|or)\b/,
            punctuation: /\(\.|\.\)|[()\[\]:;,.{}]/
        };
        var classNameInside = [
            'comment',
            'keyword',
            'builtin',
            'operator',
            'punctuation'
        ].reduce(function(accum, key) {
            accum[key] = pascaligo[key];
            return accum;
        }, {});
        pascaligo['class-name'].forEach(function(p) {
            p.inside = classNameInside;
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $e41f426c5f9f53ed$export$2e2bcd8739ae039.displayName = 'psl';
$e41f426c5f9f53ed$export$2e2bcd8739ae039.aliases = [];
function $e41f426c5f9f53ed$export$2e2bcd8739ae039(Prism) {
    Prism.languages.psl = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        string: {
            pattern: /"(?:\\.|[^\\"])*"/,
            greedy: true,
            inside: {
                symbol: /\\[ntrbA-Z"\\]/
            }
        },
        'heredoc-string': {
            pattern: /<<<([a-zA-Z_]\w*)[\r\n](?:.*[\r\n])*?\1\b/,
            alias: 'string',
            greedy: true
        },
        keyword: /\b(?:__multi|__single|case|default|do|else|elsif|exit|export|for|foreach|function|if|last|line|local|next|requires|return|switch|until|while|word)\b/,
        constant: /\b(?:ALARM|CHART_ADD_GRAPH|CHART_DELETE_GRAPH|CHART_DESTROY|CHART_LOAD|CHART_PRINT|EOF|OFFLINE|OK|PSL_PROF_LOG|R_CHECK_HORIZ|R_CHECK_VERT|R_CLICKER|R_COLUMN|R_FRAME|R_ICON|R_LABEL|R_LABEL_CENTER|R_LIST_MULTIPLE|R_LIST_MULTIPLE_ND|R_LIST_SINGLE|R_LIST_SINGLE_ND|R_MENU|R_POPUP|R_POPUP_SCROLLED|R_RADIO_HORIZ|R_RADIO_VERT|R_ROW|R_SCALE_HORIZ|R_SCALE_VERT|R_SEP_HORIZ|R_SEP_VERT|R_SPINNER|R_TEXT_FIELD|R_TEXT_FIELD_LABEL|R_TOGGLE|TRIM_LEADING|TRIM_LEADING_AND_TRAILING|TRIM_REDUNDANT|TRIM_TRAILING|VOID|WARN)\b/,
        boolean: /\b(?:FALSE|False|NO|No|TRUE|True|YES|Yes|false|no|true|yes)\b/,
        variable: /\b(?:PslDebug|errno|exit_status)\b/,
        builtin: {
            pattern: /\b(?:PslExecute|PslFunctionCall|PslFunctionExists|PslSetOptions|_snmp_debug|acos|add_diary|annotate|annotate_get|ascii_to_ebcdic|asctime|asin|atan|atexit|batch_set|blackout|cat|ceil|chan_exists|change_state|close|code_cvt|cond_signal|cond_wait|console_type|convert_base|convert_date|convert_locale_date|cos|cosh|create|date|dcget_text|destroy|destroy_lock|dget_text|difference|dump_hist|ebcdic_to_ascii|encrypt|event_archive|event_catalog_get|event_check|event_query|event_range_manage|event_range_query|event_report|event_schedule|event_trigger|event_trigger2|execute|exists|exp|fabs|file|floor|fmod|fopen|fseek|ftell|full_discovery|get|get_chan_info|get_ranges|get_text|get_vars|getenv|gethostinfo|getpid|getpname|grep|history|history_get_retention|in_transition|index|int|internal|intersection|is_var|isnumber|join|kill|length|lines|lock|lock_info|log|log10|loge|matchline|msg_check|msg_get_format|msg_get_severity|msg_printf|msg_sprintf|ntharg|nthargf|nthline|nthlinef|num_bytes|num_consoles|pconfig|popen|poplines|pow|print|printf|proc_exists|process|random|read|readln|refresh_parameters|remote_check|remote_close|remote_event_query|remote_event_trigger|remote_file_send|remote_open|remove|replace|rindex|sec_check_priv|sec_store_get|sec_store_set|set|set_alarm_ranges|set_locale|share|sin|sinh|sleep|snmp_agent_config|snmp_agent_start|snmp_agent_stop|snmp_close|snmp_config|snmp_get|snmp_get_next|snmp_h_get|snmp_h_get_next|snmp_h_set|snmp_open|snmp_set|snmp_trap_ignore|snmp_trap_listen|snmp_trap_raise_std_trap|snmp_trap_receive|snmp_trap_register_im|snmp_trap_send|snmp_walk|sopen|sort|splitline|sprintf|sqrt|srandom|str_repeat|strcasecmp|subset|substr|system|tail|tan|tanh|text_domain|time|tmpnam|tolower|toupper|trace_psl_process|trim|union|unique|unlock|unset|va_arg|va_start|write)\b/,
            alias: 'builtin-function'
        },
        'foreach-variable': {
            pattern: /(\bforeach\s+(?:(?:\w+\b|"(?:\\.|[^\\"])*")\s+){0,2})[_a-zA-Z]\w*(?=\s*\()/,
            lookbehind: true,
            greedy: true
        },
        function: /\b[_a-z]\w*\b(?=\s*\()/i,
        number: /\b(?:0x[0-9a-f]+|\d+(?:\.\d+)?)\b/i,
        operator: /--|\+\+|&&=?|\|\|=?|<<=?|>>=?|[=!]~|[-+*/%&|^!=<>]=?|\.|[:?]/,
        punctuation: /[(){}\[\];,]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $b6257d9e504bba06$export$2e2bcd8739ae039.displayName = 'pcaxis';
$b6257d9e504bba06$export$2e2bcd8739ae039.aliases = [
    'px'
];
function $b6257d9e504bba06$export$2e2bcd8739ae039(Prism) {
    Prism.languages.pcaxis = {
        string: /"[^"]*"/,
        keyword: {
            pattern: /((?:^|;)\s*)[-A-Z\d]+(?:\s*\[[-\w]+\])?(?:\s*\("[^"]*"(?:,\s*"[^"]*")*\))?(?=\s*=)/,
            lookbehind: true,
            greedy: true,
            inside: {
                keyword: /^[-A-Z\d]+/,
                language: {
                    pattern: /^(\s*)\[[-\w]+\]/,
                    lookbehind: true,
                    inside: {
                        punctuation: /^\[|\]$/,
                        property: /[-\w]+/
                    }
                },
                'sub-key': {
                    pattern: /^(\s*)\S[\s\S]*/,
                    lookbehind: true,
                    inside: {
                        parameter: {
                            pattern: /"[^"]*"/,
                            alias: 'property'
                        },
                        punctuation: /^\(|\)$|,/
                    }
                }
            }
        },
        operator: /=/,
        tlist: {
            pattern: /TLIST\s*\(\s*\w+(?:(?:\s*,\s*"[^"]*")+|\s*,\s*"[^"]*"-"[^"]*")?\s*\)/,
            greedy: true,
            inside: {
                function: /^TLIST/,
                property: {
                    pattern: /^(\s*\(\s*)\w+/,
                    lookbehind: true
                },
                string: /"[^"]*"/,
                punctuation: /[(),]/,
                operator: /-/
            }
        },
        punctuation: /[;,]/,
        number: {
            pattern: /(^|\s)\d+(?:\.\d+)?(?!\S)/,
            lookbehind: true
        },
        boolean: /NO|YES/
    };
    Prism.languages.px = Prism.languages.pcaxis;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $2051cf815a16bf4c$export$2e2bcd8739ae039.displayName = 'peoplecode';
$2051cf815a16bf4c$export$2e2bcd8739ae039.aliases = [
    'pcode'
];
function $2051cf815a16bf4c$export$2e2bcd8739ae039(Prism) {
    Prism.languages.peoplecode = {
        comment: RegExp([
            // C-style multiline comments
            /\/\*[\s\S]*?\*\//.source,
            // REM comments
            /\bREM[^;]*;/.source,
            // Nested <* *> comments
            /<\*(?:[^<*]|\*(?!>)|<(?!\*)|<\*(?:(?!\*>)[\s\S])*\*>)*\*>/.source,
            // /+ +/ comments
            /\/\+[\s\S]*?\+\//.source
        ].join('|')),
        string: {
            pattern: /'(?:''|[^'\r\n])*'(?!')|"(?:""|[^"\r\n])*"(?!")/,
            greedy: true
        },
        variable: /%\w+/,
        'function-definition': {
            pattern: /((?:^|[^\w-])(?:function|method)\s+)\w+/i,
            lookbehind: true,
            alias: 'function'
        },
        'class-name': {
            pattern: /((?:^|[^-\w])(?:as|catch|class|component|create|extends|global|implements|instance|local|of|property|returns)\s+)\w+(?::\w+)*/i,
            lookbehind: true,
            inside: {
                punctuation: /:/
            }
        },
        keyword: /\b(?:abstract|alias|as|catch|class|component|constant|create|declare|else|end-(?:class|evaluate|for|function|get|if|method|set|try|while)|evaluate|extends|for|function|get|global|if|implements|import|instance|library|local|method|null|of|out|peopleCode|private|program|property|protected|readonly|ref|repeat|returns?|set|step|then|throw|to|try|until|value|when(?:-other)?|while)\b/i,
        'operator-keyword': {
            pattern: /\b(?:and|not|or)\b/i,
            alias: 'operator'
        },
        function: /[_a-z]\w*(?=\s*\()/i,
        boolean: /\b(?:false|true)\b/i,
        number: /\b\d+(?:\.\d+)?\b/,
        operator: /<>|[<>]=?|!=|\*\*|[-+*/|=@]/,
        punctuation: /[:.;,()[\]]/
    };
    Prism.languages.pcode = Prism.languages.peoplecode;
}



// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 

$10a061d2d8575bf9$export$2e2bcd8739ae039.displayName = 'phpdoc';
$10a061d2d8575bf9$export$2e2bcd8739ae039.aliases = [];
function $10a061d2d8575bf9$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $3fdb7058e3046f24$export$2e2bcd8739ae039));
    Prism.register((0, $158311e91e281aed$export$2e2bcd8739ae039));
    (function(Prism) {
        var typeExpression = /(?:\b[a-zA-Z]\w*|[|\\[\]])+/.source;
        Prism.languages.phpdoc = Prism.languages.extend('javadoclike', {
            parameter: {
                pattern: RegExp('(@(?:global|param|property(?:-read|-write)?|var)\\s+(?:' + typeExpression + '\\s+)?)\\$\\w+'),
                lookbehind: true
            }
        });
        Prism.languages.insertBefore('phpdoc', 'keyword', {
            'class-name': [
                {
                    pattern: RegExp('(@(?:global|package|param|property(?:-read|-write)?|return|subpackage|throws|var)\\s+)' + typeExpression),
                    lookbehind: true,
                    inside: {
                        keyword: /\b(?:array|bool|boolean|callback|double|false|float|int|integer|mixed|null|object|resource|self|string|true|void)\b/,
                        punctuation: /[|\\[\]()]/
                    }
                }
            ]
        });
        Prism.languages.javadoclike.addSupport('php', Prism.languages.phpdoc);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$d29e8f3c68872260$export$2e2bcd8739ae039.displayName = 'php-extras';
$d29e8f3c68872260$export$2e2bcd8739ae039.aliases = [];
function $d29e8f3c68872260$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $158311e91e281aed$export$2e2bcd8739ae039));
    Prism.languages.insertBefore('php', 'variable', {
        this: {
            pattern: /\$this\b/,
            alias: 'keyword'
        },
        global: /\$(?:GLOBALS|HTTP_RAW_POST_DATA|_(?:COOKIE|ENV|FILES|GET|POST|REQUEST|SERVER|SESSION)|argc|argv|http_response_header|php_errormsg)\b/,
        scope: {
            pattern: /\b[\w\\]+::/,
            inside: {
                keyword: /\b(?:parent|self|static)\b/,
                punctuation: /::|\\/
            }
        }
    });
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $45fbb76bf789e0a2$export$2e2bcd8739ae039.displayName = 'plant-uml';
$45fbb76bf789e0a2$export$2e2bcd8739ae039.aliases = [
    'plantuml'
];
function $45fbb76bf789e0a2$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var variable = /\$\w+|%[a-z]+%/;
        var arrowAttr = /\[[^[\]]*\]/.source;
        var arrowDirection = /(?:[drlu]|do|down|le|left|ri|right|up)/.source;
        var arrowBody = '(?:-+' + arrowDirection + '-+|\\.+' + arrowDirection + '\\.+|-+(?:' + arrowAttr + '-*)?|' + arrowAttr + '-+|\\.+(?:' + arrowAttr + '\\.*)?|' + arrowAttr + '\\.+)';
        var arrowLeft = /(?:<{1,2}|\/{1,2}|\\{1,2}|<\||[#*^+}xo])/.source;
        var arrowRight = /(?:>{1,2}|\/{1,2}|\\{1,2}|\|>|[#*^+{xo])/.source;
        var arrowPrefix = /[[?]?[ox]?/.source;
        var arrowSuffix = /[ox]?[\]?]?/.source;
        var arrow = arrowPrefix + '(?:' + arrowBody + arrowRight + '|' + arrowLeft + arrowBody + '(?:' + arrowRight + ')?' + ')' + arrowSuffix;
        Prism.languages['plant-uml'] = {
            comment: {
                pattern: /(^[ \t]*)(?:'.*|\/'[\s\S]*?'\/)/m,
                lookbehind: true,
                greedy: true
            },
            preprocessor: {
                pattern: /(^[ \t]*)!.*/m,
                lookbehind: true,
                greedy: true,
                alias: 'property',
                inside: {
                    variable: variable
                }
            },
            delimiter: {
                pattern: /(^[ \t]*)@(?:end|start)uml\b/m,
                lookbehind: true,
                greedy: true,
                alias: 'punctuation'
            },
            arrow: {
                pattern: RegExp(/(^|[^-.<>?|\\[\]ox])/.source + arrow + /(?![-.<>?|\\\]ox])/.source),
                lookbehind: true,
                greedy: true,
                alias: 'operator',
                inside: {
                    expression: {
                        pattern: /(\[)[^[\]]+(?=\])/,
                        lookbehind: true,
                        inside: null // see below
                    },
                    punctuation: /\[(?=$|\])|^\]/
                }
            },
            string: {
                pattern: /"[^"]*"/,
                greedy: true
            },
            text: {
                pattern: /(\[[ \t]*[\r\n]+(?![\r\n]))[^\]]*(?=\])/,
                lookbehind: true,
                greedy: true,
                alias: 'string'
            },
            keyword: [
                {
                    pattern: /^([ \t]*)(?:abstract\s+class|end\s+(?:box|fork|group|merge|note|ref|split|title)|(?:fork|split)(?:\s+again)?|activate|actor|agent|alt|annotation|artifact|autoactivate|autonumber|backward|binary|boundary|box|break|caption|card|case|circle|class|clock|cloud|collections|component|concise|control|create|critical|database|deactivate|destroy|detach|diamond|else|elseif|end|end[hr]note|endif|endswitch|endwhile|entity|enum|file|folder|footer|frame|group|[hr]?note|header|hexagon|hide|if|interface|label|legend|loop|map|namespace|network|newpage|node|nwdiag|object|opt|package|page|par|participant|person|queue|rectangle|ref|remove|repeat|restore|return|robust|scale|set|show|skinparam|stack|start|state|stop|storage|switch|title|together|usecase|usecase\/|while)(?=\s|$)/m,
                    lookbehind: true,
                    greedy: true
                },
                /\b(?:elseif|equals|not|while)(?=\s*\()/,
                /\b(?:as|is|then)\b/
            ],
            divider: {
                pattern: /^==.+==$/m,
                greedy: true,
                alias: 'important'
            },
            time: {
                pattern: /@(?:\d+(?:[:/]\d+){2}|[+-]?\d+|:[a-z]\w*(?:[+-]\d+)?)\b/i,
                greedy: true,
                alias: 'number'
            },
            color: {
                pattern: /#(?:[a-z_]+|[a-fA-F0-9]+)\b/,
                alias: 'symbol'
            },
            variable: variable,
            punctuation: /[:,;()[\]{}]|\.{3}/
        };
        Prism.languages['plant-uml'].arrow.inside.expression.inside = Prism.languages['plant-uml'];
        Prism.languages['plantuml'] = Prism.languages['plant-uml'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$e226b64ac0fbc6f8$export$2e2bcd8739ae039.displayName = 'plsql';
$e226b64ac0fbc6f8$export$2e2bcd8739ae039.aliases = [];
function $e226b64ac0fbc6f8$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $d138d4e60ec637d4$export$2e2bcd8739ae039));
    Prism.languages.plsql = Prism.languages.extend('sql', {
        comment: {
            pattern: /\/\*[\s\S]*?\*\/|--.*/,
            greedy: true
        },
        // https://docs.oracle.com/en/database/oracle/oracle-database/21/lnpls/plsql-reserved-words-keywords.html
        keyword: /\b(?:A|ACCESSIBLE|ADD|AGENT|AGGREGATE|ALL|ALTER|AND|ANY|ARRAY|AS|ASC|AT|ATTRIBUTE|AUTHID|AVG|BEGIN|BETWEEN|BFILE_BASE|BINARY|BLOB_BASE|BLOCK|BODY|BOTH|BOUND|BULK|BY|BYTE|C|CALL|CALLING|CASCADE|CASE|CHAR|CHARACTER|CHARSET|CHARSETFORM|CHARSETID|CHAR_BASE|CHECK|CLOB_BASE|CLONE|CLOSE|CLUSTER|CLUSTERS|COLAUTH|COLLECT|COLUMNS|COMMENT|COMMIT|COMMITTED|COMPILED|COMPRESS|CONNECT|CONSTANT|CONSTRUCTOR|CONTEXT|CONTINUE|CONVERT|COUNT|CRASH|CREATE|CREDENTIAL|CURRENT|CURSOR|CUSTOMDATUM|DANGLING|DATA|DATE|DATE_BASE|DAY|DECLARE|DEFAULT|DEFINE|DELETE|DESC|DETERMINISTIC|DIRECTORY|DISTINCT|DOUBLE|DROP|DURATION|ELEMENT|ELSE|ELSIF|EMPTY|END|ESCAPE|EXCEPT|EXCEPTION|EXCEPTIONS|EXCLUSIVE|EXECUTE|EXISTS|EXIT|EXTERNAL|FETCH|FINAL|FIRST|FIXED|FLOAT|FOR|FORALL|FORCE|FROM|FUNCTION|GENERAL|GOTO|GRANT|GROUP|HASH|HAVING|HEAP|HIDDEN|HOUR|IDENTIFIED|IF|IMMEDIATE|IMMUTABLE|IN|INCLUDING|INDEX|INDEXES|INDICATOR|INDICES|INFINITE|INSERT|INSTANTIABLE|INT|INTERFACE|INTERSECT|INTERVAL|INTO|INVALIDATE|IS|ISOLATION|JAVA|LANGUAGE|LARGE|LEADING|LENGTH|LEVEL|LIBRARY|LIKE|LIKE2|LIKE4|LIKEC|LIMIT|LIMITED|LOCAL|LOCK|LONG|LOOP|MAP|MAX|MAXLEN|MEMBER|MERGE|MIN|MINUS|MINUTE|MOD|MODE|MODIFY|MONTH|MULTISET|MUTABLE|NAME|NAN|NATIONAL|NATIVE|NCHAR|NEW|NOCOMPRESS|NOCOPY|NOT|NOWAIT|NULL|NUMBER_BASE|OBJECT|OCICOLL|OCIDATE|OCIDATETIME|OCIDURATION|OCIINTERVAL|OCILOBLOCATOR|OCINUMBER|OCIRAW|OCIREF|OCIREFCURSOR|OCIROWID|OCISTRING|OCITYPE|OF|OLD|ON|ONLY|OPAQUE|OPEN|OPERATOR|OPTION|OR|ORACLE|ORADATA|ORDER|ORGANIZATION|ORLANY|ORLVARY|OTHERS|OUT|OVERLAPS|OVERRIDING|PACKAGE|PARALLEL_ENABLE|PARAMETER|PARAMETERS|PARENT|PARTITION|PASCAL|PERSISTABLE|PIPE|PIPELINED|PLUGGABLE|POLYMORPHIC|PRAGMA|PRECISION|PRIOR|PRIVATE|PROCEDURE|PUBLIC|RAISE|RANGE|RAW|READ|RECORD|REF|REFERENCE|RELIES_ON|REM|REMAINDER|RENAME|RESOURCE|RESULT|RESULT_CACHE|RETURN|RETURNING|REVERSE|REVOKE|ROLLBACK|ROW|SAMPLE|SAVE|SAVEPOINT|SB1|SB2|SB4|SECOND|SEGMENT|SELECT|SELF|SEPARATE|SEQUENCE|SERIALIZABLE|SET|SHARE|SHORT|SIZE|SIZE_T|SOME|SPARSE|SQL|SQLCODE|SQLDATA|SQLNAME|SQLSTATE|STANDARD|START|STATIC|STDDEV|STORED|STRING|STRUCT|STYLE|SUBMULTISET|SUBPARTITION|SUBSTITUTABLE|SUBTYPE|SUM|SYNONYM|TABAUTH|TABLE|TDO|THE|THEN|TIME|TIMESTAMP|TIMEZONE_ABBR|TIMEZONE_HOUR|TIMEZONE_MINUTE|TIMEZONE_REGION|TO|TRAILING|TRANSACTION|TRANSACTIONAL|TRUSTED|TYPE|UB1|UB2|UB4|UNDER|UNION|UNIQUE|UNPLUG|UNSIGNED|UNTRUSTED|UPDATE|USE|USING|VALIST|VALUE|VALUES|VARIABLE|VARIANCE|VARRAY|VARYING|VIEW|VIEWS|VOID|WHEN|WHERE|WHILE|WITH|WORK|WRAPPED|WRITE|YEAR|ZONE)\b/i,
        // https://docs.oracle.com/en/database/oracle/oracle-database/21/lnpls/plsql-language-fundamentals.html#GUID-96A42F7C-7A71-4B90-8255-CA9C8BD9722E
        operator: /:=?|=>|[<>^~!]=|\.\.|\|\||\*\*|[-+*/%<>=@]/
    });
    Prism.languages.insertBefore('plsql', 'operator', {
        label: {
            pattern: /<<\s*\w+\s*>>/,
            alias: 'symbol'
        }
    });
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $62afefd0906ae624$export$2e2bcd8739ae039.displayName = 'powerquery';
$62afefd0906ae624$export$2e2bcd8739ae039.aliases = [
    'mscript',
    'pq'
];
function $62afefd0906ae624$export$2e2bcd8739ae039(Prism) {
    // https://docs.microsoft.com/en-us/powerquery-m/power-query-m-language-specification
    Prism.languages.powerquery = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
            lookbehind: true,
            greedy: true
        },
        'quoted-identifier': {
            pattern: /#"(?:[^"\r\n]|"")*"(?!")/,
            greedy: true
        },
        string: {
            pattern: /(?:#!)?"(?:[^"\r\n]|"")*"(?!")/,
            greedy: true
        },
        constant: [
            /\bDay\.(?:Friday|Monday|Saturday|Sunday|Thursday|Tuesday|Wednesday)\b/,
            /\bTraceLevel\.(?:Critical|Error|Information|Verbose|Warning)\b/,
            /\bOccurrence\.(?:All|First|Last)\b/,
            /\bOrder\.(?:Ascending|Descending)\b/,
            /\bRoundingMode\.(?:AwayFromZero|Down|ToEven|TowardZero|Up)\b/,
            /\bMissingField\.(?:Error|Ignore|UseNull)\b/,
            /\bQuoteStyle\.(?:Csv|None)\b/,
            /\bJoinKind\.(?:FullOuter|Inner|LeftAnti|LeftOuter|RightAnti|RightOuter)\b/,
            /\bGroupKind\.(?:Global|Local)\b/,
            /\bExtraValues\.(?:Error|Ignore|List)\b/,
            /\bJoinAlgorithm\.(?:Dynamic|LeftHash|LeftIndex|PairwiseHash|RightHash|RightIndex|SortMerge)\b/,
            /\bJoinSide\.(?:Left|Right)\b/,
            /\bPrecision\.(?:Decimal|Double)\b/,
            /\bRelativePosition\.From(?:End|Start)\b/,
            /\bTextEncoding\.(?:Ascii|BigEndianUnicode|Unicode|Utf16|Utf8|Windows)\b/,
            /\b(?:Any|Binary|Date|DateTime|DateTimeZone|Duration|Function|Int16|Int32|Int64|Int8|List|Logical|None|Number|Record|Table|Text|Time)\.Type\b/,
            /\bnull\b/
        ],
        boolean: /\b(?:false|true)\b/,
        keyword: /\b(?:and|as|each|else|error|if|in|is|let|meta|not|nullable|optional|or|otherwise|section|shared|then|try|type)\b|#(?:binary|date|datetime|datetimezone|duration|infinity|nan|sections|shared|table|time)\b/,
        function: {
            pattern: /(^|[^#\w.])[a-z_][\w.]*(?=\s*\()/i,
            lookbehind: true
        },
        'data-type': {
            pattern: /\b(?:any|anynonnull|binary|date|datetime|datetimezone|duration|function|list|logical|none|number|record|table|text|time)\b/,
            alias: 'class-name'
        },
        number: {
            pattern: /\b0x[\da-f]+\b|(?:[+-]?(?:\b\d+\.)?\b\d+|[+-]\.\d+|(^|[^.])\B\.\d+)(?:e[+-]?\d+)?\b/i,
            lookbehind: true
        },
        operator: /[-+*\/&?@^]|<(?:=>?|>)?|>=?|=>?|\.\.\.?/,
        punctuation: /[,;\[\](){}]/
    };
    Prism.languages.pq = Prism.languages['powerquery'];
    Prism.languages.mscript = Prism.languages['powerquery'];
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $c0a064543930cbfc$export$2e2bcd8739ae039.displayName = 'powershell';
$c0a064543930cbfc$export$2e2bcd8739ae039.aliases = [];
function $c0a064543930cbfc$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var powershell = Prism.languages.powershell = {
            comment: [
                {
                    pattern: /(^|[^`])<#[\s\S]*?#>/,
                    lookbehind: true
                },
                {
                    pattern: /(^|[^`])#.*/,
                    lookbehind: true
                }
            ],
            string: [
                {
                    pattern: /"(?:`[\s\S]|[^`"])*"/,
                    greedy: true,
                    inside: null // see below
                },
                {
                    pattern: /'(?:[^']|'')*'/,
                    greedy: true
                }
            ],
            // Matches name spaces as well as casts, attribute decorators. Force starting with letter to avoid matching array indices
            // Supports two levels of nested brackets (e.g. `[OutputType([System.Collections.Generic.List[int]])]`)
            namespace: /\[[a-z](?:\[(?:\[[^\]]*\]|[^\[\]])*\]|[^\[\]])*\]/i,
            boolean: /\$(?:false|true)\b/i,
            variable: /\$\w+\b/,
            // Cmdlets and aliases. Aliases should come last, otherwise "write" gets preferred over "write-host" for example
            // Get-Command | ?{ $_.ModuleName -match "Microsoft.PowerShell.(Util|Core|Management)" }
            // Get-Alias | ?{ $_.ReferencedCommand.Module.Name -match "Microsoft.PowerShell.(Util|Core|Management)" }
            function: [
                /\b(?:Add|Approve|Assert|Backup|Block|Checkpoint|Clear|Close|Compare|Complete|Compress|Confirm|Connect|Convert|ConvertFrom|ConvertTo|Copy|Debug|Deny|Disable|Disconnect|Dismount|Edit|Enable|Enter|Exit|Expand|Export|Find|ForEach|Format|Get|Grant|Group|Hide|Import|Initialize|Install|Invoke|Join|Limit|Lock|Measure|Merge|Move|New|Open|Optimize|Out|Ping|Pop|Protect|Publish|Push|Read|Receive|Redo|Register|Remove|Rename|Repair|Request|Reset|Resize|Resolve|Restart|Restore|Resume|Revoke|Save|Search|Select|Send|Set|Show|Skip|Sort|Split|Start|Step|Stop|Submit|Suspend|Switch|Sync|Tee|Test|Trace|Unblock|Undo|Uninstall|Unlock|Unprotect|Unpublish|Unregister|Update|Use|Wait|Watch|Where|Write)-[a-z]+\b/i,
                /\b(?:ac|cat|chdir|clc|cli|clp|clv|compare|copy|cp|cpi|cpp|cvpa|dbp|del|diff|dir|ebp|echo|epal|epcsv|epsn|erase|fc|fl|ft|fw|gal|gbp|gc|gci|gcs|gdr|gi|gl|gm|gp|gps|group|gsv|gu|gv|gwmi|iex|ii|ipal|ipcsv|ipsn|irm|iwmi|iwr|kill|lp|ls|measure|mi|mount|move|mp|mv|nal|ndr|ni|nv|ogv|popd|ps|pushd|pwd|rbp|rd|rdr|ren|ri|rm|rmdir|rni|rnp|rp|rv|rvpa|rwmi|sal|saps|sasv|sbp|sc|select|set|shcm|si|sl|sleep|sls|sort|sp|spps|spsv|start|sv|swmi|tee|trcm|type|write)\b/i
            ],
            // per http://technet.microsoft.com/en-us/library/hh847744.aspx
            keyword: /\b(?:Begin|Break|Catch|Class|Continue|Data|Define|Do|DynamicParam|Else|ElseIf|End|Exit|Filter|Finally|For|ForEach|From|Function|If|InlineScript|Parallel|Param|Process|Return|Sequence|Switch|Throw|Trap|Try|Until|Using|Var|While|Workflow)\b/i,
            operator: {
                pattern: /(^|\W)(?:!|-(?:b?(?:and|x?or)|as|(?:Not)?(?:Contains|In|Like|Match)|eq|ge|gt|is(?:Not)?|Join|le|lt|ne|not|Replace|sh[lr])\b|-[-=]?|\+[+=]?|[*\/%]=?)/i,
                lookbehind: true
            },
            punctuation: /[|{}[\];(),.]/
        };
        // Variable interpolation inside strings, and nested expressions
        powershell.string[0].inside = {
            function: {
                // Allow for one level of nesting
                pattern: /(^|[^`])\$\((?:\$\([^\r\n()]*\)|(?!\$\()[^\r\n)])*\)/,
                lookbehind: true,
                inside: powershell
            },
            boolean: powershell.boolean,
            variable: powershell.variable
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$28775ad983a33289$export$2e2bcd8739ae039.displayName = 'processing';
$28775ad983a33289$export$2e2bcd8739ae039.aliases = [];
function $28775ad983a33289$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    Prism.languages.processing = Prism.languages.extend('clike', {
        keyword: /\b(?:break|case|catch|class|continue|default|else|extends|final|for|if|implements|import|new|null|private|public|return|static|super|switch|this|try|void|while)\b/,
        // Spaces are allowed between function name and parenthesis
        function: /\b\w+(?=\s*\()/,
        operator: /<[<=]?|>[>=]?|&&?|\|\|?|[%?]|[!=+\-*\/]=?/
    });
    Prism.languages.insertBefore('processing', 'number', {
        // Special case: XML is a type
        constant: /\b(?!XML\b)[A-Z][A-Z\d_]+\b/,
        type: {
            pattern: /\b(?:boolean|byte|char|color|double|float|int|[A-Z]\w*)\b/,
            alias: 'class-name'
        }
    });
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $99e8dd8f6b35dcc4$export$2e2bcd8739ae039.displayName = 'prolog';
$99e8dd8f6b35dcc4$export$2e2bcd8739ae039.aliases = [];
function $99e8dd8f6b35dcc4$export$2e2bcd8739ae039(Prism) {
    Prism.languages.prolog = {
        // Syntax depends on the implementation
        comment: {
            pattern: /\/\*[\s\S]*?\*\/|%.*/,
            greedy: true
        },
        // Depending on the implementation, strings may allow escaped newlines and quote-escape
        string: {
            pattern: /(["'])(?:\1\1|\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1(?!\1)/,
            greedy: true
        },
        builtin: /\b(?:fx|fy|xf[xy]?|yfx?)\b/,
        // FIXME: Should we list all null-ary predicates (not followed by a parenthesis) like halt, trace, etc.?
        function: /\b[a-z]\w*(?:(?=\()|\/\d+)/,
        number: /\b\d+(?:\.\d*)?/,
        // Custom operators are allowed
        operator: /[:\\=><\-?*@\/;+^|!$.]+|\b(?:is|mod|not|xor)\b/,
        punctuation: /[(){}\[\],]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $b6c4f78e62cb8bfe$export$2e2bcd8739ae039.displayName = 'promql';
$b6c4f78e62cb8bfe$export$2e2bcd8739ae039.aliases = [];
function $b6c4f78e62cb8bfe$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // PromQL Aggregation Operators
        // (https://prometheus.io/docs/prometheus/latest/querying/operators/#aggregation-operators)
        var aggregations = [
            'sum',
            'min',
            'max',
            'avg',
            'group',
            'stddev',
            'stdvar',
            'count',
            'count_values',
            'bottomk',
            'topk',
            'quantile'
        ];
        // PromQL vector matching + the by and without clauses
        // (https://prometheus.io/docs/prometheus/latest/querying/operators/#vector-matching)
        var vectorMatching = [
            'on',
            'ignoring',
            'group_right',
            'group_left',
            'by',
            'without'
        ];
        // PromQL offset modifier
        // (https://prometheus.io/docs/prometheus/latest/querying/basics/#offset-modifier)
        var offsetModifier = [
            'offset'
        ];
        var keywords = aggregations.concat(vectorMatching, offsetModifier);
        Prism.languages.promql = {
            comment: {
                pattern: /(^[ \t]*)#.*/m,
                lookbehind: true
            },
            'vector-match': {
                // Match the comma-separated label lists inside vector matching:
                pattern: new RegExp('((?:' + vectorMatching.join('|') + ')\\s*)\\([^)]*\\)'),
                lookbehind: true,
                inside: {
                    'label-key': {
                        pattern: /\b[^,]+\b/,
                        alias: 'attr-name'
                    },
                    punctuation: /[(),]/
                }
            },
            'context-labels': {
                pattern: /\{[^{}]*\}/,
                inside: {
                    'label-key': {
                        pattern: /\b[a-z_]\w*(?=\s*(?:=|![=~]))/,
                        alias: 'attr-name'
                    },
                    'label-value': {
                        pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
                        greedy: true,
                        alias: 'attr-value'
                    },
                    punctuation: /\{|\}|=~?|![=~]|,/
                }
            },
            'context-range': [
                {
                    pattern: /\[[\w\s:]+\]/,
                    // [1m]
                    inside: {
                        punctuation: /\[|\]|:/,
                        'range-duration': {
                            pattern: /\b(?:\d+(?:[smhdwy]|ms))+\b/i,
                            alias: 'number'
                        }
                    }
                },
                {
                    pattern: /(\boffset\s+)\w+/,
                    // offset 1m
                    lookbehind: true,
                    inside: {
                        'range-duration': {
                            pattern: /\b(?:\d+(?:[smhdwy]|ms))+\b/i,
                            alias: 'number'
                        }
                    }
                }
            ],
            keyword: new RegExp('\\b(?:' + keywords.join('|') + ')\\b', 'i'),
            function: /\b[a-z_]\w*(?=\s*\()/i,
            number: /[-+]?(?:(?:\b\d+(?:\.\d+)?|\B\.\d+)(?:e[-+]?\d+)?\b|\b(?:0x[0-9a-f]+|nan|inf)\b)/i,
            operator: /[\^*/%+-]|==|!=|<=|<|>=|>|\b(?:and|or|unless)\b/i,
            punctuation: /[{};()`,.[\]]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $685367727897b6e2$export$2e2bcd8739ae039.displayName = 'properties';
$685367727897b6e2$export$2e2bcd8739ae039.aliases = [];
function $685367727897b6e2$export$2e2bcd8739ae039(Prism) {
    Prism.languages.properties = {
        comment: /^[ \t]*[#!].*$/m,
        value: {
            pattern: /(^[ \t]*(?:\\(?:\r\n|[\s\S])|[^\\\s:=])+(?: *[=:] *(?! )| ))(?:\\(?:\r\n|[\s\S])|[^\\\r\n])+/m,
            lookbehind: true,
            alias: 'attr-value'
        },
        key: {
            pattern: /^[ \t]*(?:\\(?:\r\n|[\s\S])|[^\\\s:=])+(?= *[=:]| )/m,
            alias: 'attr-name'
        },
        punctuation: /[=:]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$3a8d0988a68f18f1$export$2e2bcd8739ae039.displayName = 'protobuf';
$3a8d0988a68f18f1$export$2e2bcd8739ae039.aliases = [];
function $3a8d0988a68f18f1$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    (function(Prism) {
        var builtinTypes = /\b(?:bool|bytes|double|s?fixed(?:32|64)|float|[su]?int(?:32|64)|string)\b/;
        Prism.languages.protobuf = Prism.languages.extend('clike', {
            'class-name': [
                {
                    pattern: /(\b(?:enum|extend|message|service)\s+)[A-Za-z_]\w*(?=\s*\{)/,
                    lookbehind: true
                },
                {
                    pattern: /(\b(?:rpc\s+\w+|returns)\s*\(\s*(?:stream\s+)?)\.?[A-Za-z_]\w*(?:\.[A-Za-z_]\w*)*(?=\s*\))/,
                    lookbehind: true
                }
            ],
            keyword: /\b(?:enum|extend|extensions|import|message|oneof|option|optional|package|public|repeated|required|reserved|returns|rpc(?=\s+\w)|service|stream|syntax|to)\b(?!\s*=\s*\d)/,
            function: /\b[a-z_]\w*(?=\s*\()/i
        });
        Prism.languages.insertBefore('protobuf', 'operator', {
            map: {
                pattern: /\bmap<\s*[\w.]+\s*,\s*[\w.]+\s*>(?=\s+[a-z_]\w*\s*[=;])/i,
                alias: 'class-name',
                inside: {
                    punctuation: /[<>.,]/,
                    builtin: builtinTypes
                }
            },
            builtin: builtinTypes,
            'positional-class-name': {
                pattern: /(?:\b|\B\.)[a-z_]\w*(?:\.[a-z_]\w*)*(?=\s+[a-z_]\w*\s*[=;])/i,
                alias: 'class-name',
                inside: {
                    punctuation: /\./
                }
            },
            annotation: {
                pattern: /(\[\s*)[a-z_]\w*(?=\s*=)/i,
                lookbehind: true
            }
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $fdca6bde44738939$export$2e2bcd8739ae039.displayName = 'stylus';
$fdca6bde44738939$export$2e2bcd8739ae039.aliases = [];
function $fdca6bde44738939$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var unit = {
            pattern: /(\b\d+)(?:%|[a-z]+)/,
            lookbehind: true
        };
        // 123 -123 .123 -.123 12.3 -12.3
        var number = {
            pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
            lookbehind: true
        };
        var inside = {
            comment: {
                pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
                lookbehind: true
            },
            url: {
                pattern: /\burl\((["']?).*?\1\)/i,
                greedy: true
            },
            string: {
                pattern: /("|')(?:(?!\1)[^\\\r\n]|\\(?:\r\n|[\s\S]))*\1/,
                greedy: true
            },
            interpolation: null,
            // See below
            func: null,
            // See below
            important: /\B!(?:important|optional)\b/i,
            keyword: {
                pattern: /(^|\s+)(?:(?:else|for|if|return|unless)(?=\s|$)|@[\w-]+)/,
                lookbehind: true
            },
            hexcode: /#[\da-f]{3,6}/i,
            color: [
                /\b(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)\b/i,
                {
                    pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
                    inside: {
                        unit: unit,
                        number: number,
                        function: /[\w-]+(?=\()/,
                        punctuation: /[(),]/
                    }
                }
            ],
            entity: /\\[\da-f]{1,8}/i,
            unit: unit,
            boolean: /\b(?:false|true)\b/,
            operator: [
                // We want non-word chars around "-" because it is
                // accepted in property names.
                /~|[+!\/%<>?=]=?|[-:]=|\*[*=]?|\.{2,3}|&&|\|\||\B-\B|\b(?:and|in|is(?: a| defined| not|nt)?|not|or)\b/
            ],
            number: number,
            punctuation: /[{}()\[\];:,]/
        };
        inside['interpolation'] = {
            pattern: /\{[^\r\n}:]+\}/,
            alias: 'variable',
            inside: {
                delimiter: {
                    pattern: /^\{|\}$/,
                    alias: 'punctuation'
                },
                rest: inside
            }
        };
        inside['func'] = {
            pattern: /[\w-]+\([^)]*\).*/,
            inside: {
                function: /^[^(]+/,
                rest: inside
            }
        };
        Prism.languages.stylus = {
            'atrule-declaration': {
                pattern: /(^[ \t]*)@.+/m,
                lookbehind: true,
                inside: {
                    atrule: /^@[\w-]+/,
                    rest: inside
                }
            },
            'variable-declaration': {
                pattern: /(^[ \t]*)[\w$-]+\s*.?=[ \t]*(?:\{[^{}]*\}|\S.*|$)/m,
                lookbehind: true,
                inside: {
                    variable: /^\S+/,
                    rest: inside
                }
            },
            statement: {
                pattern: /(^[ \t]*)(?:else|for|if|return|unless)[ \t].+/m,
                lookbehind: true,
                inside: {
                    keyword: /^\S+/,
                    rest: inside
                }
            },
            // A property/value pair cannot end with a comma or a brace
            // It cannot have indented content unless it ended with a semicolon
            'property-declaration': {
                pattern: /((?:^|\{)([ \t]*))(?:[\w-]|\{[^}\r\n]+\})+(?:\s*:\s*|[ \t]+)(?!\s)[^{\r\n]*(?:;|[^{\r\n,]$(?!(?:\r?\n|\r)(?:\{|\2[ \t])))/m,
                lookbehind: true,
                inside: {
                    property: {
                        pattern: /^[^\s:]+/,
                        inside: {
                            interpolation: inside.interpolation
                        }
                    },
                    rest: inside
                }
            },
            // A selector can contain parentheses only as part of a pseudo-element
            // It can span multiple lines.
            // It must end with a comma or an accolade or have indented content.
            selector: {
                pattern: /(^[ \t]*)(?:(?=\S)(?:[^{}\r\n:()]|::?[\w-]+(?:\([^)\r\n]*\)|(?![\w-]))|\{[^}\r\n]+\})+)(?:(?:\r?\n|\r)(?:\1(?:(?=\S)(?:[^{}\r\n:()]|::?[\w-]+(?:\([^)\r\n]*\)|(?![\w-]))|\{[^}\r\n]+\})+)))*(?:,$|\{|(?=(?:\r?\n|\r)(?:\{|\1[ \t])))/m,
                lookbehind: true,
                inside: {
                    interpolation: inside.interpolation,
                    comment: inside.comment,
                    punctuation: /[{},]/
                }
            },
            func: inside.func,
            string: inside.string,
            comment: {
                pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
                lookbehind: true,
                greedy: true
            },
            interpolation: inside.interpolation,
            punctuation: /[{}()\[\];:.]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$6e4ccd37e0cb374b$export$2e2bcd8739ae039.displayName = 'twig';
$6e4ccd37e0cb374b$export$2e2bcd8739ae039.aliases = [];
function $6e4ccd37e0cb374b$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $a400735491c1aa4e$export$2e2bcd8739ae039));
    Prism.languages.twig = {
        comment: /^\{#[\s\S]*?#\}$/,
        'tag-name': {
            pattern: /(^\{%-?\s*)\w+/,
            lookbehind: true,
            alias: 'keyword'
        },
        delimiter: {
            pattern: /^\{[{%]-?|-?[%}]\}$/,
            alias: 'punctuation'
        },
        string: {
            pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            inside: {
                punctuation: /^['"]|['"]$/
            }
        },
        keyword: /\b(?:even|if|odd)\b/,
        boolean: /\b(?:false|null|true)\b/,
        number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
        operator: [
            {
                pattern: /(\s)(?:and|b-and|b-or|b-xor|ends with|in|is|matches|not|or|same as|starts with)(?=\s)/,
                lookbehind: true
            },
            /[=<>]=?|!=|\*\*?|\/\/?|\?:?|[-+~%|]/
        ],
        punctuation: /[()\[\]{}:.,]/
    };
    Prism.hooks.add('before-tokenize', function(env) {
        if (env.language !== 'twig') return;
        var pattern = /\{(?:#[\s\S]*?#|%[\s\S]*?%|\{[\s\S]*?\})\}/g;
        Prism.languages['markup-templating'].buildPlaceholders(env, 'twig', pattern);
    });
    Prism.hooks.add('after-tokenize', function(env) {
        Prism.languages['markup-templating'].tokenizePlaceholders(env, 'twig');
    });
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 

$86460e0d73a40885$export$2e2bcd8739ae039.displayName = 'pug';
$86460e0d73a40885$export$2e2bcd8739ae039.aliases = [];
function $86460e0d73a40885$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $9f5c72e4d4e505c4$export$2e2bcd8739ae039));
    Prism.register((0, $8fbeea7c20d72e06$export$2e2bcd8739ae039));
    (function(Prism) {
        // TODO:
        // - Add CSS highlighting inside <style> tags
        // - Add support for multi-line code blocks
        // - Add support for interpolation #{} and !{}
        // - Add support for tag interpolation #[]
        // - Add explicit support for plain text using |
        // - Add support for markup embedded in plain text
        Prism.languages.pug = {
            // Multiline stuff should appear before the rest
            // This handles both single-line and multi-line comments
            comment: {
                pattern: /(^([\t ]*))\/\/.*(?:(?:\r?\n|\r)\2[\t ].+)*/m,
                lookbehind: true
            },
            // All the tag-related part is in lookbehind
            // so that it can be highlighted by the "tag" pattern
            'multiline-script': {
                pattern: /(^([\t ]*)script\b.*\.[\t ]*)(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            // See at the end of the file for known filters
            filter: {
                pattern: /(^([\t ]*)):.+(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
                lookbehind: true,
                inside: {
                    'filter-name': {
                        pattern: /^:[\w-]+/,
                        alias: 'variable'
                    },
                    text: /\S[\s\S]*/
                }
            },
            'multiline-plain-text': {
                pattern: /(^([\t ]*)[\w\-#.]+\.[\t ]*)(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
                lookbehind: true
            },
            markup: {
                pattern: /(^[\t ]*)<.+/m,
                lookbehind: true,
                inside: Prism.languages.markup
            },
            doctype: {
                pattern: /((?:^|\n)[\t ]*)doctype(?: .+)?/,
                lookbehind: true
            },
            // This handle all conditional and loop keywords
            'flow-control': {
                pattern: /(^[\t ]*)(?:case|default|each|else|if|unless|when|while)\b(?: .+)?/m,
                lookbehind: true,
                inside: {
                    each: {
                        pattern: /^each .+? in\b/,
                        inside: {
                            keyword: /\b(?:each|in)\b/,
                            punctuation: /,/
                        }
                    },
                    branch: {
                        pattern: /^(?:case|default|else|if|unless|when|while)\b/,
                        alias: 'keyword'
                    },
                    rest: Prism.languages.javascript
                }
            },
            keyword: {
                pattern: /(^[\t ]*)(?:append|block|extends|include|prepend)\b.+/m,
                lookbehind: true
            },
            mixin: [
                // Declaration
                {
                    pattern: /(^[\t ]*)mixin .+/m,
                    lookbehind: true,
                    inside: {
                        keyword: /^mixin/,
                        function: /\w+(?=\s*\(|\s*$)/,
                        punctuation: /[(),.]/
                    }
                },
                // Usage
                {
                    pattern: /(^[\t ]*)\+.+/m,
                    lookbehind: true,
                    inside: {
                        name: {
                            pattern: /^\+\w+/,
                            alias: 'function'
                        },
                        rest: Prism.languages.javascript
                    }
                }
            ],
            script: {
                pattern: /(^[\t ]*script(?:(?:&[^(]+)?\([^)]+\))*[\t ]).+/m,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            'plain-text': {
                pattern: /(^[\t ]*(?!-)[\w\-#.]*[\w\-](?:(?:&[^(]+)?\([^)]+\))*\/?[\t ]).+/m,
                lookbehind: true
            },
            tag: {
                pattern: /(^[\t ]*)(?!-)[\w\-#.]*[\w\-](?:(?:&[^(]+)?\([^)]+\))*\/?:?/m,
                lookbehind: true,
                inside: {
                    attributes: [
                        {
                            pattern: /&[^(]+\([^)]+\)/,
                            inside: Prism.languages.javascript
                        },
                        {
                            pattern: /\([^)]+\)/,
                            inside: {
                                'attr-value': {
                                    pattern: /(=\s*(?!\s))(?:\{[^}]*\}|[^,)\r\n]+)/,
                                    lookbehind: true,
                                    inside: Prism.languages.javascript
                                },
                                'attr-name': /[\w-]+(?=\s*!?=|\s*[,)])/,
                                punctuation: /[!=(),]+/
                            }
                        }
                    ],
                    punctuation: /:/,
                    'attr-id': /#[\w\-]+/,
                    'attr-class': /\.[\w\-]+/
                }
            },
            code: [
                {
                    pattern: /(^[\t ]*(?:-|!?=)).+/m,
                    lookbehind: true,
                    inside: Prism.languages.javascript
                }
            ],
            punctuation: /[.\-!=|]+/
        };
        var filter_pattern = /(^([\t ]*)):<filter_name>(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/.source;
        // Non exhaustive list of available filters and associated languages
        var filters = [
            {
                filter: 'atpl',
                language: 'twig'
            },
            {
                filter: 'coffee',
                language: 'coffeescript'
            },
            'ejs',
            'handlebars',
            'less',
            'livescript',
            'markdown',
            {
                filter: 'sass',
                language: 'scss'
            },
            'stylus'
        ];
        var all_filters = {};
        for(var i = 0, l = filters.length; i < l; i++){
            var filter = filters[i];
            filter = typeof filter === 'string' ? {
                filter: filter,
                language: filter
            } : filter;
            if (Prism.languages[filter.language]) all_filters['filter-' + filter.filter] = {
                pattern: RegExp(filter_pattern.replace('<filter_name>', function() {
                    return filter.filter;
                }), 'm'),
                lookbehind: true,
                inside: {
                    'filter-name': {
                        pattern: /^:[\w-]+/,
                        alias: 'variable'
                    },
                    text: {
                        pattern: /\S[\s\S]*/,
                        alias: [
                            filter.language,
                            'language-' + filter.language
                        ],
                        inside: Prism.languages[filter.language]
                    }
                }
            };
        }
        Prism.languages.insertBefore('pug', 'filter', all_filters);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $ee80061b022a92ec$export$2e2bcd8739ae039.displayName = 'puppet';
$ee80061b022a92ec$export$2e2bcd8739ae039.aliases = [];
function $ee80061b022a92ec$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.puppet = {
            heredoc: [
                // Matches the content of a quoted heredoc string (subject to interpolation)
                {
                    pattern: /(@\("([^"\r\n\/):]+)"(?:\/[nrts$uL]*)?\).*(?:\r?\n|\r))(?:.*(?:\r?\n|\r(?!\n)))*?[ \t]*(?:\|[ \t]*)?(?:-[ \t]*)?\2/,
                    lookbehind: true,
                    alias: 'string',
                    inside: {
                        // Matches the end tag
                        punctuation: /(?=\S).*\S(?= *$)/
                    }
                },
                // Matches the content of an unquoted heredoc string (no interpolation)
                {
                    pattern: /(@\(([^"\r\n\/):]+)(?:\/[nrts$uL]*)?\).*(?:\r?\n|\r))(?:.*(?:\r?\n|\r(?!\n)))*?[ \t]*(?:\|[ \t]*)?(?:-[ \t]*)?\2/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'string',
                    inside: {
                        // Matches the end tag
                        punctuation: /(?=\S).*\S(?= *$)/
                    }
                },
                // Matches the start tag of heredoc strings
                {
                    pattern: /@\("?(?:[^"\r\n\/):]+)"?(?:\/[nrts$uL]*)?\)/,
                    alias: 'string',
                    inside: {
                        punctuation: {
                            pattern: /(\().+?(?=\))/,
                            lookbehind: true
                        }
                    }
                }
            ],
            'multiline-comment': {
                pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
                lookbehind: true,
                greedy: true,
                alias: 'comment'
            },
            regex: {
                // Must be prefixed with the keyword "node" or a non-word char
                pattern: /((?:\bnode\s+|[~=\(\[\{,]\s*|[=+]>\s*|^\s*))\/(?:[^\/\\]|\\[\s\S])+\/(?:[imx]+\b|\B)/,
                lookbehind: true,
                greedy: true,
                inside: {
                    // Extended regexes must have the x flag. They can contain single-line comments.
                    'extended-regex': {
                        pattern: /^\/(?:[^\/\\]|\\[\s\S])+\/[im]*x[im]*$/,
                        inside: {
                            comment: /#.*/
                        }
                    }
                }
            },
            comment: {
                pattern: /(^|[^\\])#.*/,
                lookbehind: true,
                greedy: true
            },
            string: {
                // Allow for one nested level of double quotes inside interpolation
                pattern: /(["'])(?:\$\{(?:[^'"}]|(["'])(?:(?!\2)[^\\]|\\[\s\S])*\2)+\}|\$(?!\{)|(?!\1)[^\\$]|\\[\s\S])*\1/,
                greedy: true,
                inside: {
                    'double-quoted': {
                        pattern: /^"[\s\S]*"$/,
                        inside: {
                        }
                    }
                }
            },
            variable: {
                pattern: /\$(?:::)?\w+(?:::\w+)*/,
                inside: {
                    punctuation: /::/
                }
            },
            'attr-name': /(?:\b\w+|\*)(?=\s*=>)/,
            function: [
                {
                    pattern: /(\.)(?!\d)\w+/,
                    lookbehind: true
                },
                /\b(?:contain|debug|err|fail|include|info|notice|realize|require|tag|warning)\b|\b(?!\d)\w+(?=\()/
            ],
            number: /\b(?:0x[a-f\d]+|\d+(?:\.\d+)?(?:e-?\d+)?)\b/i,
            boolean: /\b(?:false|true)\b/,
            // Includes words reserved for future use
            keyword: /\b(?:application|attr|case|class|consumes|default|define|else|elsif|function|if|import|inherits|node|private|produces|type|undef|unless)\b/,
            datatype: {
                pattern: /\b(?:Any|Array|Boolean|Callable|Catalogentry|Class|Collection|Data|Default|Enum|Float|Hash|Integer|NotUndef|Numeric|Optional|Pattern|Regexp|Resource|Runtime|Scalar|String|Struct|Tuple|Type|Undef|Variant)\b/,
                alias: 'symbol'
            },
            operator: /=[=~>]?|![=~]?|<(?:<\|?|[=~|-])?|>[>=]?|->?|~>|\|>?>?|[*\/%+?]|\b(?:and|in|or)\b/,
            punctuation: /[\[\]{}().,;]|:+/
        };
        var interpolation = [
            {
                // Allow for one nested level of braces inside interpolation
                pattern: /(^|[^\\])\$\{(?:[^'"{}]|\{[^}]*\}|(["'])(?:(?!\2)[^\\]|\\[\s\S])*\2)+\}/,
                lookbehind: true,
                inside: {
                    'short-variable': {
                        // Negative look-ahead prevent wrong highlighting of functions
                        pattern: /(^\$\{)(?!\w+\()(?:::)?\w+(?:::\w+)*/,
                        lookbehind: true,
                        alias: 'variable',
                        inside: {
                            punctuation: /::/
                        }
                    },
                    delimiter: {
                        pattern: /^\$/,
                        alias: 'variable'
                    },
                    rest: Prism.languages.puppet
                }
            },
            {
                pattern: /(^|[^\\])\$(?:::)?\w+(?:::\w+)*/,
                lookbehind: true,
                alias: 'variable',
                inside: {
                    punctuation: /::/
                }
            }
        ];
        Prism.languages.puppet['heredoc'][0].inside.interpolation = interpolation;
        Prism.languages.puppet['string'].inside['double-quoted'].inside.interpolation = interpolation;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $0061c6e41b3a4570$export$2e2bcd8739ae039.displayName = 'pure';
$0061c6e41b3a4570$export$2e2bcd8739ae039.aliases = [];
function $0061c6e41b3a4570$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // https://agraef.github.io/pure-docs/pure.html#lexical-matters
        Prism.languages.pure = {
            comment: [
                {
                    pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
                    lookbehind: true
                },
                {
                    pattern: /(^|[^\\:])\/\/.*/,
                    lookbehind: true
                },
                /#!.+/
            ],
            'inline-lang': {
                pattern: /%<[\s\S]+?%>/,
                greedy: true,
                inside: {
                    lang: {
                        pattern: /(^%< *)-\*-.+?-\*-/,
                        lookbehind: true,
                        alias: 'comment'
                    },
                    delimiter: {
                        pattern: /^%<.*|%>$/,
                        alias: 'punctuation'
                    }
                }
            },
            string: {
                pattern: /"(?:\\.|[^"\\\r\n])*"/,
                greedy: true
            },
            number: {
                // The look-behind prevents wrong highlighting of the .. operator
                pattern: /((?:\.\.)?)(?:\b(?:inf|nan)\b|\b0x[\da-f]+|(?:\b(?:0b)?\d+(?:\.\d+)?|\B\.\d+)(?:e[+-]?\d+)?L?)/i,
                lookbehind: true
            },
            keyword: /\b(?:NULL|ans|break|bt|case|catch|cd|clear|const|def|del|dump|else|end|exit|extern|false|force|help|if|infix[lr]?|interface|let|ls|mem|namespace|nonfix|of|otherwise|outfix|override|postfix|prefix|private|public|pwd|quit|run|save|show|stats|then|throw|trace|true|type|underride|using|when|with)\b/,
            function: /\b(?:abs|add_(?:addr|constdef|(?:fundef|interface|macdef|typedef)(?:_at)?|vardef)|all|any|applp?|arity|bigintp?|blob(?:_crc|_size|p)?|boolp?|byte_c?string(?:_pointer)?|byte_(?:matrix|pointer)|calloc|cat|catmap|ceil|char[ps]?|check_ptrtag|chr|clear_sentry|clearsym|closurep?|cmatrixp?|cols?|colcat(?:map)?|colmap|colrev|colvector(?:p|seq)?|complex(?:_float_(?:matrix|pointer)|_matrix(?:_view)?|_pointer|p)?|conj|cookedp?|cst|cstring(?:_(?:dup|list|vector))?|curry3?|cyclen?|del_(?:constdef|fundef|interface|macdef|typedef|vardef)|delete|diag(?:mat)?|dim|dmatrixp?|do|double(?:_matrix(?:_view)?|_pointer|p)?|dowith3?|drop|dropwhile|eval(?:cmd)?|exactp|filter|fix|fixity|flip|float(?:_matrix|_pointer)|floor|fold[lr]1?|frac|free|funp?|functionp?|gcd|get(?:_(?:byte|constdef|double|float|fundef|int(?:64)?|interface(?:_typedef)?|long|macdef|pointer|ptrtag|sentry|short|string|typedef|vardef))?|globsym|hash|head|id|im|imatrixp?|index|inexactp|infp|init|insert|int(?:_matrix(?:_view)?|_pointer|p)?|int64_(?:matrix|pointer)|integerp?|iteraten?|iterwhile|join|keys?|lambdap?|last(?:err(?:pos)?)?|lcd|list[2p]?|listmap|make_ptrtag|malloc|map|matcat|matrixp?|max|member|min|nanp|nargs|nmatrixp?|null|numberp?|ord|pack(?:ed)?|pointer(?:_cast|_tag|_type|p)?|pow|pred|ptrtag|put(?:_(?:byte|double|float|int(?:64)?|long|pointer|short|string))?|rationalp?|re|realp?|realloc|recordp?|redim|reduce(?:_with)?|refp?|repeatn?|reverse|rlistp?|round|rows?|rowcat(?:map)?|rowmap|rowrev|rowvector(?:p|seq)?|same|scan[lr]1?|sentry|sgn|short_(?:matrix|pointer)|slice|smatrixp?|sort|split|str|strcat|stream|stride|string(?:_(?:dup|list|vector)|p)?|subdiag(?:mat)?|submat|subseq2?|substr|succ|supdiag(?:mat)?|symbolp?|tail|take|takewhile|thunkp?|transpose|trunc|tuplep?|typep|ubyte|uint(?:64)?|ulong|uncurry3?|unref|unzip3?|update|ushort|vals?|varp?|vector(?:p|seq)?|void|zip3?|zipwith3?)\b/,
            special: {
                pattern: /\b__[a-z]+__\b/i,
                alias: 'builtin'
            },
            // Any combination of operator chars can be an operator
            // eslint-disable-next-line no-misleading-character-class
            operator: /(?:[!"#$%&'*+,\-.\/:<=>?@\\^`|~\u00a1-\u00bf\u00d7-\u00f7\u20d0-\u2bff]|\b_+\b)+|\b(?:and|div|mod|not|or)\b/,
            // FIXME: How can we prevent | and , to be highlighted as operator when they are used alone?
            punctuation: /[(){}\[\];,|]/
        };
        var inlineLanguages = [
            'c',
            {
                lang: 'c++',
                alias: 'cpp'
            },
            'fortran'
        ];
        var inlineLanguageRe = /%< *-\*- *<lang>\d* *-\*-[\s\S]+?%>/.source;
        inlineLanguages.forEach(function(lang) {
            var alias = lang;
            if (typeof lang !== 'string') {
                alias = lang.alias;
                lang = lang.lang;
            }
            if (Prism.languages[alias]) {
                var o = {};
                o['inline-lang-' + alias] = {
                    pattern: RegExp(inlineLanguageRe.replace('<lang>', lang.replace(/([.+*?\/\\(){}\[\]])/g, '\\$1')), 'i'),
                    inside: Prism.util.clone(Prism.languages.pure['inline-lang'].inside)
                };
                o['inline-lang-' + alias].inside.rest = Prism.util.clone(Prism.languages[alias]);
                Prism.languages.insertBefore('pure', 'inline-lang', o);
            }
        });
        // C is the default inline language
        if (Prism.languages.c) Prism.languages.pure['inline-lang'].inside.rest = Prism.util.clone(Prism.languages.c);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$4bd4f4ed7632711a$export$2e2bcd8739ae039.displayName = 'purebasic';
$4bd4f4ed7632711a$export$2e2bcd8739ae039.aliases = [
    'pbfasm'
];
function $4bd4f4ed7632711a$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    /*
Original Code by Bas Groothedde
!!MANY THANKS!! I never would have made this, regex and me will never be best friends ;)
==> https://codepen.io/ImagineProgramming/details/JYydBy/
slightly changed to pass all tests
*/ // PureBasic support, steal stuff from ansi-c
    Prism.languages.purebasic = Prism.languages.extend('clike', {
        comment: /;.*/,
        keyword: /\b(?:align|and|as|break|calldebugger|case|compilercase|compilerdefault|compilerelse|compilerelseif|compilerendif|compilerendselect|compilererror|compilerif|compilerselect|continue|data|datasection|debug|debuglevel|declare|declarec|declarecdll|declaredll|declaremodule|default|define|dim|disableasm|disabledebugger|disableexplicit|else|elseif|enableasm|enabledebugger|enableexplicit|end|enddatasection|enddeclaremodule|endenumeration|endif|endimport|endinterface|endmacro|endmodule|endprocedure|endselect|endstructure|endstructureunion|endwith|enumeration|extends|fakereturn|for|foreach|forever|global|gosub|goto|if|import|importc|includebinary|includefile|includepath|interface|macro|module|newlist|newmap|next|not|or|procedure|procedurec|procedurecdll|proceduredll|procedurereturn|protected|prototype|prototypec|read|redim|repeat|restore|return|runtime|select|shared|static|step|structure|structureunion|swap|threaded|to|until|wend|while|with|xincludefile|xor)\b/i,
        function: /\b\w+(?:\.\w+)?\s*(?=\()/,
        number: /(?:\$[\da-f]+|\b-?(?:\d+(?:\.\d+)?|\.\d+)(?:e[+-]?\d+)?)\b/i,
        operator: /(?:@\*?|\?|\*)\w+\$?|-[>-]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|?\||[~^%?*/@]/
    });
    Prism.languages.insertBefore('purebasic', 'keyword', {
        tag: /#\w+\$?/,
        asm: {
            pattern: /(^[\t ]*)!.*/m,
            lookbehind: true,
            alias: 'tag',
            inside: {
                comment: /;.*/,
                string: {
                    pattern: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
                    greedy: true
                },
                // Anonymous label references, i.e.: jmp @b
                'label-reference-anonymous': {
                    pattern: /(!\s*j[a-z]+\s+)@[fb]/i,
                    lookbehind: true,
                    alias: 'fasm-label'
                },
                // Named label reference, i.e.: jne label1
                'label-reference-addressed': {
                    pattern: /(!\s*j[a-z]+\s+)[A-Z._?$@][\w.?$@~#]*/i,
                    lookbehind: true,
                    alias: 'fasm-label'
                },
                keyword: [
                    /\b(?:extern|global)\b[^;\r\n]*/i,
                    /\b(?:CPU|DEFAULT|FLOAT)\b.*/
                ],
                function: {
                    pattern: /^([\t ]*!\s*)[\da-z]+(?=\s|$)/im,
                    lookbehind: true
                },
                'function-inline': {
                    pattern: /(:\s*)[\da-z]+(?=\s)/i,
                    lookbehind: true,
                    alias: 'function'
                },
                label: {
                    pattern: /^([\t ]*!\s*)[A-Za-z._?$@][\w.?$@~#]*(?=:)/m,
                    lookbehind: true,
                    alias: 'fasm-label'
                },
                register: /\b(?:st\d|[xyz]mm\d\d?|[cdt]r\d|r\d\d?[bwd]?|[er]?[abcd]x|[abcd][hl]|[er]?(?:bp|di|si|sp)|[cdefgs]s|mm\d+)\b/i,
                number: /(?:\b|-|(?=\$))(?:0[hx](?:[\da-f]*\.)?[\da-f]+(?:p[+-]?\d+)?|\d[\da-f]+[hx]|\$\d[\da-f]*|0[oq][0-7]+|[0-7]+[oq]|0[by][01]+|[01]+[by]|0[dt]\d+|(?:\d+(?:\.\d+)?|\.\d+)(?:\.?e[+-]?\d+)?[dt]?)\b/i,
                operator: /[\[\]*+\-/%<>=&|$!,.:]/
            }
        }
    });
    delete Prism.languages.purebasic['class-name'];
    delete Prism.languages.purebasic['boolean'];
    Prism.languages.pbfasm = Prism.languages['purebasic'];
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$d5b21f8d3d5d8ce1$export$2e2bcd8739ae039.displayName = 'purescript';
$d5b21f8d3d5d8ce1$export$2e2bcd8739ae039.aliases = [
    'purs'
];
function $d5b21f8d3d5d8ce1$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $0a2709da981e5d8c$export$2e2bcd8739ae039));
    Prism.languages.purescript = Prism.languages.extend('haskell', {
        keyword: /\b(?:ado|case|class|data|derive|do|else|forall|if|in|infixl|infixr|instance|let|module|newtype|of|primitive|then|type|where)\b|∀/,
        'import-statement': {
            // The imported or hidden names are not included in this import
            // statement. This is because we want to highlight those exactly like
            // we do for the names in the program.
            pattern: /(^[\t ]*)import\s+[A-Z][\w']*(?:\.[A-Z][\w']*)*(?:\s+as\s+[A-Z][\w']*(?:\.[A-Z][\w']*)*)?(?:\s+hiding\b)?/m,
            lookbehind: true,
            inside: {
                keyword: /\b(?:as|hiding|import)\b/,
                punctuation: /\./
            }
        },
        // These are builtin functions only. Constructors are highlighted later as a constant.
        builtin: /\b(?:absurd|add|ap|append|apply|between|bind|bottom|clamp|compare|comparing|compose|conj|const|degree|discard|disj|div|eq|flap|flip|gcd|identity|ifM|join|lcm|liftA1|liftM1|map|max|mempty|min|mod|mul|negate|not|notEq|one|otherwise|recip|show|sub|top|unit|unless|unlessM|void|when|whenM|zero)\b/,
        operator: [
            // Infix operators
            Prism.languages.haskell.operator[0],
            // ASCII operators
            Prism.languages.haskell.operator[2],
            // All UTF16 Unicode operator symbols
            // This regex is equivalent to /(?=[\x80-\uFFFF])[\p{gc=Math_Symbol}\p{gc=Currency_Symbol}\p{Modifier_Symbol}\p{Other_Symbol}]/u
            // See https://github.com/PrismJS/prism/issues/3006 for more details.
            /[\xa2-\xa6\xa8\xa9\xac\xae-\xb1\xb4\xb8\xd7\xf7\u02c2-\u02c5\u02d2-\u02df\u02e5-\u02eb\u02ed\u02ef-\u02ff\u0375\u0384\u0385\u03f6\u0482\u058d-\u058f\u0606-\u0608\u060b\u060e\u060f\u06de\u06e9\u06fd\u06fe\u07f6\u07fe\u07ff\u09f2\u09f3\u09fa\u09fb\u0af1\u0b70\u0bf3-\u0bfa\u0c7f\u0d4f\u0d79\u0e3f\u0f01-\u0f03\u0f13\u0f15-\u0f17\u0f1a-\u0f1f\u0f34\u0f36\u0f38\u0fbe-\u0fc5\u0fc7-\u0fcc\u0fce\u0fcf\u0fd5-\u0fd8\u109e\u109f\u1390-\u1399\u166d\u17db\u1940\u19de-\u19ff\u1b61-\u1b6a\u1b74-\u1b7c\u1fbd\u1fbf-\u1fc1\u1fcd-\u1fcf\u1fdd-\u1fdf\u1fed-\u1fef\u1ffd\u1ffe\u2044\u2052\u207a-\u207c\u208a-\u208c\u20a0-\u20bf\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211e-\u2123\u2125\u2127\u2129\u212e\u213a\u213b\u2140-\u2144\u214a-\u214d\u214f\u218a\u218b\u2190-\u2307\u230c-\u2328\u232b-\u2426\u2440-\u244a\u249c-\u24e9\u2500-\u2767\u2794-\u27c4\u27c7-\u27e5\u27f0-\u2982\u2999-\u29d7\u29dc-\u29fb\u29fe-\u2b73\u2b76-\u2b95\u2b97-\u2bff\u2ce5-\u2cea\u2e50\u2e51\u2e80-\u2e99\u2e9b-\u2ef3\u2f00-\u2fd5\u2ff0-\u2ffb\u3004\u3012\u3013\u3020\u3036\u3037\u303e\u303f\u309b\u309c\u3190\u3191\u3196-\u319f\u31c0-\u31e3\u3200-\u321e\u322a-\u3247\u3250\u3260-\u327f\u328a-\u32b0\u32c0-\u33ff\u4dc0-\u4dff\ua490-\ua4c6\ua700-\ua716\ua720\ua721\ua789\ua78a\ua828-\ua82b\ua836-\ua839\uaa77-\uaa79\uab5b\uab6a\uab6b\ufb29\ufbb2-\ufbc1\ufdfc\ufdfd\ufe62\ufe64-\ufe66\ufe69\uff04\uff0b\uff1c-\uff1e\uff3e\uff40\uff5c\uff5e\uffe0-\uffe6\uffe8-\uffee\ufffc\ufffd]/
        ]
    });
    Prism.languages.purs = Prism.languages.purescript;
}



// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$89a20c95494c3404$export$2e2bcd8739ae039.displayName = 'qsharp';
$89a20c95494c3404$export$2e2bcd8739ae039.aliases = [
    'qs'
];
function $89a20c95494c3404$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    (function(Prism) {
        /**
     * Replaces all placeholders "<<n>>" of given pattern with the n-th replacement (zero based).
     *
     * Note: This is a simple text based replacement. Be careful when using backreferences!
     *
     * @param {string} pattern the given pattern.
     * @param {string[]} replacements a list of replacement which can be inserted into the given pattern.
     * @returns {string} the pattern with all placeholders replaced with their corresponding replacements.
     * @example replace(/a<<0>>a/.source, [/b+/.source]) === /a(?:b+)a/.source
     */ function replace(pattern, replacements) {
            return pattern.replace(/<<(\d+)>>/g, function(m, index) {
                return '(?:' + replacements[+index] + ')';
            });
        }
        /**
     * @param {string} pattern
     * @param {string[]} replacements
     * @param {string} [flags]
     * @returns {RegExp}
     */ function re(pattern, replacements, flags) {
            return RegExp(replace(pattern, replacements), flags || '');
        }
        /**
     * Creates a nested pattern where all occurrences of the string `<<self>>` are replaced with the pattern itself.
     *
     * @param {string} pattern
     * @param {number} depthLog2
     * @returns {string}
     */ function nested(pattern, depthLog2) {
            for(var i = 0; i < depthLog2; i++)pattern = pattern.replace(/<<self>>/g, function() {
                return '(?:' + pattern + ')';
            });
            return pattern.replace(/<<self>>/g, '[^\\s\\S]');
        }
        // https://docs.microsoft.com/en-us/azure/quantum/user-guide/language/typesystem/
        // https://github.com/microsoft/qsharp-language/tree/main/Specifications/Language/5_Grammar
        var keywordKinds = {
            // keywords which represent a return or variable type
            type: 'Adj BigInt Bool Ctl Double false Int One Pauli PauliI PauliX PauliY PauliZ Qubit Range Result String true Unit Zero',
            // all other keywords
            other: 'Adjoint adjoint apply as auto body borrow borrowing Controlled controlled distribute elif else fail fixup for function if in internal intrinsic invert is let mutable namespace new newtype open operation repeat return self set until use using while within'
        };
        // keywords
        function keywordsToPattern(words) {
            return '\\b(?:' + words.trim().replace(/ /g, '|') + ')\\b';
        }
        var keywords = RegExp(keywordsToPattern(keywordKinds.type + ' ' + keywordKinds.other));
        // types
        var identifier = /\b[A-Za-z_]\w*\b/.source;
        var qualifiedName = replace(/<<0>>(?:\s*\.\s*<<0>>)*/.source, [
            identifier
        ]);
        var typeInside = {
            keyword: keywords,
            punctuation: /[<>()?,.:[\]]/
        };
        // strings
        var regularString = /"(?:\\.|[^\\"])*"/.source;
        Prism.languages.qsharp = Prism.languages.extend('clike', {
            comment: /\/\/.*/,
            string: [
                {
                    pattern: re(/(^|[^$\\])<<0>>/.source, [
                        regularString
                    ]),
                    lookbehind: true,
                    greedy: true
                }
            ],
            'class-name': [
                {
                    // open Microsoft.Quantum.Canon;
                    // open Microsoft.Quantum.Canon as CN;
                    pattern: re(/(\b(?:as|open)\s+)<<0>>(?=\s*(?:;|as\b))/.source, [
                        qualifiedName
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // namespace Quantum.App1;
                    pattern: re(/(\bnamespace\s+)<<0>>(?=\s*\{)/.source, [
                        qualifiedName
                    ]),
                    lookbehind: true,
                    inside: typeInside
                }
            ],
            keyword: keywords,
            number: /(?:\b0(?:x[\da-f]+|b[01]+|o[0-7]+)|(?:\B\.\d+|\b\d+(?:\.\d*)?)(?:e[-+]?\d+)?)l?\b/i,
            operator: /\band=|\bor=|\band\b|\bnot\b|\bor\b|<[-=]|[-=]>|>>>=?|<<<=?|\^\^\^=?|\|\|\|=?|&&&=?|w\/=?|~~~|[*\/+\-^=!%]=?/,
            punctuation: /::|[{}[\];(),.:]/
        });
        Prism.languages.insertBefore('qsharp', 'number', {
            range: {
                pattern: /\.\./,
                alias: 'operator'
            }
        });
        // single line
        var interpolationExpr = nested(replace(/\{(?:[^"{}]|<<0>>|<<self>>)*\}/.source, [
            regularString
        ]), 2);
        Prism.languages.insertBefore('qsharp', 'string', {
            'interpolation-string': {
                pattern: re(/\$"(?:\\.|<<0>>|[^\\"{])*"/.source, [
                    interpolationExpr
                ]),
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: re(/((?:^|[^\\])(?:\\\\)*)<<0>>/.source, [
                            interpolationExpr
                        ]),
                        lookbehind: true,
                        inside: {
                            punctuation: /^\{|\}$/,
                            expression: {
                                pattern: /[\s\S]+/,
                                alias: 'language-qsharp',
                                inside: Prism.languages.qsharp
                            }
                        }
                    },
                    string: /[\s\S]+/
                }
            }
        });
    })(Prism);
    Prism.languages.qs = Prism.languages.qsharp;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $d7dbc2fe5eb92f6c$export$2e2bcd8739ae039.displayName = 'q';
$d7dbc2fe5eb92f6c$export$2e2bcd8739ae039.aliases = [];
function $d7dbc2fe5eb92f6c$export$2e2bcd8739ae039(Prism) {
    Prism.languages.q = {
        string: /"(?:\\.|[^"\\\r\n])*"/,
        comment: [
            // From http://code.kx.com/wiki/Reference/Slash:
            // When / is following a space (or a right parenthesis, bracket, or brace), it is ignored with the rest of the line.
            {
                pattern: /([\t )\]}])\/.*/,
                lookbehind: true,
                greedy: true
            },
            // From http://code.kx.com/wiki/Reference/Slash:
            // A line which has / as its first character and contains at least one other non-whitespace character is a whole-line comment and is ignored entirely.
            // A / on a line by itself begins a multiline comment which is terminated by the next \ on a line by itself.
            // If a / is not matched by a \, the multiline comment is unterminated and continues to end of file.
            // The / and \ must be the first char on the line, but may be followed by any amount of whitespace.
            {
                pattern: /(^|\r?\n|\r)\/[\t ]*(?:(?:\r?\n|\r)(?:.*(?:\r?\n|\r(?!\n)))*?(?:\\(?=[\t ]*(?:\r?\n|\r))|$)|\S.*)/,
                lookbehind: true,
                greedy: true
            },
            // From http://code.kx.com/wiki/Reference/Slash:
            // A \ on a line by itself with no preceding matching / will comment to end of file.
            {
                pattern: /^\\[\t ]*(?:\r?\n|\r)[\s\S]+/m,
                greedy: true
            },
            {
                pattern: /^#!.+/m,
                greedy: true
            }
        ],
        symbol: /`(?::\S+|[\w.]*)/,
        datetime: {
            pattern: /0N[mdzuvt]|0W[dtz]|\d{4}\.\d\d(?:m|\.\d\d(?:T(?:\d\d(?::\d\d(?::\d\d(?:[.:]\d\d\d)?)?)?)?)?[dz]?)|\d\d:\d\d(?::\d\d(?:[.:]\d\d\d)?)?[uvt]?/,
            alias: 'number'
        },
        // The negative look-ahead prevents bad highlighting
        // of verbs 0: and 1:
        number: /\b(?![01]:)(?:0N[hje]?|0W[hj]?|0[wn]|0x[\da-fA-F]+|\d+(?:\.\d*)?(?:e[+-]?\d+)?[hjfeb]?)/,
        keyword: /\\\w+\b|\b(?:abs|acos|aj0?|all|and|any|asc|asin|asof|atan|attr|avgs?|binr?|by|ceiling|cols|cor|cos|count|cov|cross|csv|cut|delete|deltas|desc|dev|differ|distinct|div|do|dsave|ej|enlist|eval|except|exec|exit|exp|fby|fills|first|fkeys|flip|floor|from|get|getenv|group|gtime|hclose|hcount|hdel|hopen|hsym|iasc|identity|idesc|if|ij|in|insert|inter|inv|keys?|last|like|list|ljf?|load|log|lower|lsq|ltime|ltrim|mavg|maxs?|mcount|md5|mdev|med|meta|mins?|mmax|mmin|mmu|mod|msum|neg|next|not|null|or|over|parse|peach|pj|plist|prds?|prev|prior|rand|rank|ratios|raze|read0|read1|reciprocal|reval|reverse|rload|rotate|rsave|rtrim|save|scan|scov|sdev|select|set|setenv|show|signum|sin|sqrt|ssr?|string|sublist|sums?|sv|svar|system|tables|tan|til|trim|txf|type|uj|ungroup|union|update|upper|upsert|value|var|views?|vs|wavg|where|while|within|wj1?|wsum|ww|xasc|xbar|xcols?|xdesc|xexp|xgroup|xkey|xlog|xprev|xrank)\b/,
        adverb: {
            pattern: /['\/\\]:?|\beach\b/,
            alias: 'function'
        },
        verb: {
            pattern: /(?:\B\.\B|\b[01]:|<[=>]?|>=?|[:+\-*%,!?~=|$&#@^]):?|\b_\b:?/,
            alias: 'operator'
        },
        punctuation: /[(){}\[\];.]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$be31e43f53721fa6$export$2e2bcd8739ae039.displayName = 'qml';
$be31e43f53721fa6$export$2e2bcd8739ae039.aliases = [];
function $be31e43f53721fa6$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $9f5c72e4d4e505c4$export$2e2bcd8739ae039));
    (function(Prism) {
        var jsString = /"(?:\\.|[^\\"\r\n])*"|'(?:\\.|[^\\'\r\n])*'/.source;
        var jsComment = /\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))*\*\//.source;
        var jsExpr = /(?:[^\\()[\]{}"'/]|<string>|\/(?![*/])|<comment>|\(<expr>*\)|\[<expr>*\]|\{<expr>*\}|\\[\s\S])/.source.replace(/<string>/g, function() {
            return jsString;
        }).replace(/<comment>/g, function() {
            return jsComment;
        });
        // the pattern will blow up, so only a few iterations
        for(var i = 0; i < 2; i++)jsExpr = jsExpr.replace(/<expr>/g, function() {
            return jsExpr;
        });
        jsExpr = jsExpr.replace(/<expr>/g, '[^\\s\\S]');
        Prism.languages.qml = {
            comment: {
                pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
                greedy: true
            },
            'javascript-function': {
                pattern: RegExp(/((?:^|;)[ \t]*)function\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*\(<js>*\)\s*\{<js>*\}/.source.replace(/<js>/g, function() {
                    return jsExpr;
                }), 'm'),
                lookbehind: true,
                greedy: true,
                alias: 'language-javascript',
                inside: Prism.languages.javascript
            },
            'class-name': {
                pattern: /((?:^|[:;])[ \t]*)(?!\d)\w+(?=[ \t]*\{|[ \t]+on\b)/m,
                lookbehind: true
            },
            property: [
                {
                    pattern: /((?:^|[;{])[ \t]*)(?!\d)\w+(?:\.\w+)*(?=[ \t]*:)/m,
                    lookbehind: true
                },
                {
                    pattern: /((?:^|[;{])[ \t]*)property[ \t]+(?!\d)\w+(?:\.\w+)*[ \t]+(?!\d)\w+(?:\.\w+)*(?=[ \t]*:)/m,
                    lookbehind: true,
                    inside: {
                        keyword: /^property/,
                        property: /\w+(?:\.\w+)*/
                    }
                }
            ],
            'javascript-expression': {
                pattern: RegExp(/(:[ \t]*)(?![\s;}[])(?:(?!$|[;}])<js>)+/.source.replace(/<js>/g, function() {
                    return jsExpr;
                }), 'm'),
                lookbehind: true,
                greedy: true,
                alias: 'language-javascript',
                inside: Prism.languages.javascript
            },
            string: {
                pattern: /"(?:\\.|[^\\"\r\n])*"/,
                greedy: true
            },
            keyword: /\b(?:as|import|on)\b/,
            punctuation: /[{}[\]:;,]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$d93e8cacda7cdd1f$export$2e2bcd8739ae039.displayName = 'qore';
$d93e8cacda7cdd1f$export$2e2bcd8739ae039.aliases = [];
function $d93e8cacda7cdd1f$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    Prism.languages.qore = Prism.languages.extend('clike', {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:\/\/|#).*)/,
            lookbehind: true
        },
        // Overridden to allow unescaped multi-line strings
        string: {
            pattern: /("|')(?:\\[\s\S]|(?!\1)[^\\])*\1/,
            greedy: true
        },
        keyword: /\b(?:abstract|any|assert|binary|bool|boolean|break|byte|case|catch|char|class|code|const|continue|data|default|do|double|else|enum|extends|final|finally|float|for|goto|hash|if|implements|import|inherits|instanceof|int|interface|long|my|native|new|nothing|null|object|our|own|private|reference|rethrow|return|short|soft(?:bool|date|float|int|list|number|string)|static|strictfp|string|sub|super|switch|synchronized|this|throw|throws|transient|try|void|volatile|while)\b/,
        boolean: /\b(?:false|true)\b/i,
        function: /\$?\b(?!\d)\w+(?=\()/,
        number: /\b(?:0b[01]+|0x(?:[\da-f]*\.)?[\da-fp\-]+|(?:\d+(?:\.\d+)?|\.\d+)(?:e\d+)?[df]|(?:\d+(?:\.\d+)?|\.\d+))\b/i,
        operator: {
            pattern: /(^|[^.])(?:\+[+=]?|-[-=]?|[!=](?:==?|~)?|>>?=?|<(?:=>?|<=?)?|&[&=]?|\|[|=]?|[*\/%^]=?|[~?])/,
            lookbehind: true
        },
        variable: /\$(?!\d)\w+\b/
    });
}



// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$8f8e297012e12c77$export$2e2bcd8739ae039.displayName = 'racket';
$8f8e297012e12c77$export$2e2bcd8739ae039.aliases = [
    'rkt'
];
function $8f8e297012e12c77$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $c6a13ead09099e31$export$2e2bcd8739ae039));
    Prism.languages.racket = Prism.languages.extend('scheme', {
        'lambda-parameter': {
            // the racket lambda syntax is a lot more complex, so we won't even attempt to capture it.
            // this will just prevent false positives of the `function` pattern
            pattern: /([(\[]lambda\s+[(\[])[^()\[\]'\s]+/,
            lookbehind: true
        }
    });
    Prism.languages.insertBefore('racket', 'string', {
        lang: {
            pattern: /^#lang.+/m,
            greedy: true,
            alias: 'keyword'
        }
    });
    Prism.languages.rkt = Prism.languages.racket;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 

$18e4422100889798$export$2e2bcd8739ae039.displayName = 'cshtml';
$18e4422100889798$export$2e2bcd8739ae039.aliases = [
    'razor'
];
function $18e4422100889798$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $e1ab06973c0a6c0a$export$2e2bcd8739ae039));
    Prism.register((0, $8fbeea7c20d72e06$export$2e2bcd8739ae039));
    (function(Prism) {
        var commentLike = /\/(?![/*])|\/\/.*[\r\n]|\/\*[^*]*(?:\*(?!\/)[^*]*)*\*\//.source;
        var stringLike = /@(?!")|"(?:[^\r\n\\"]|\\.)*"|@"(?:[^\\"]|""|\\[\s\S])*"(?!")/.source + '|' + /'(?:(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'|(?=[^\\](?!')))/.source;
        /**
     * Creates a nested pattern where all occurrences of the string `<<self>>` are replaced with the pattern itself.
     *
     * @param {string} pattern
     * @param {number} depthLog2
     * @returns {string}
     */ function nested(pattern, depthLog2) {
            for(var i = 0; i < depthLog2; i++)pattern = pattern.replace(/<self>/g, function() {
                return '(?:' + pattern + ')';
            });
            return pattern.replace(/<self>/g, '[^\\s\\S]').replace(/<str>/g, '(?:' + stringLike + ')').replace(/<comment>/g, '(?:' + commentLike + ')');
        }
        var round = nested(/\((?:[^()'"@/]|<str>|<comment>|<self>)*\)/.source, 2);
        var square = nested(/\[(?:[^\[\]'"@/]|<str>|<comment>|<self>)*\]/.source, 1);
        var curly = nested(/\{(?:[^{}'"@/]|<str>|<comment>|<self>)*\}/.source, 2);
        var angle = nested(/<(?:[^<>'"@/]|<comment>|<self>)*>/.source, 1);
        var inlineCs = /@/.source + /(?:await\b\s*)?/.source + '(?:' + /(?!await\b)\w+\b/.source + '|' + round + ')' + '(?:' + /[?!]?\.\w+\b/.source + '|' + '(?:' + angle + ')?' + round + '|' + square + ')*' + /(?![?!\.(\[]|<(?!\/))/.source;
        // Note about the above bracket patterns:
        // They all ignore HTML expressions that might be in the C# code. This is a problem because HTML (like strings and
        // comments) is parsed differently. This is a huge problem because HTML might contain brackets and quotes which
        // messes up the bracket and string counting implemented by the above patterns.
        //
        // This problem is not fixable because 1) HTML expression are highly context sensitive and very difficult to detect
        // and 2) they require one capturing group at every nested level. See the `tagRegion` pattern to admire the
        // complexity of an HTML expression.
        //
        // To somewhat alleviate the problem a bit, the patterns for characters (e.g. 'a') is very permissive, it also
        // allows invalid characters to support HTML expressions like this: <p>That's it!</p>.
        var tagAttrInlineCs = /@(?![\w()])/.source + '|' + inlineCs;
        var tagAttrValue = '(?:' + /"[^"@]*"|'[^'@]*'|[^\s'"@>=]+(?=[\s>])/.source + '|' + '["\'][^"\'@]*(?:(?:' + tagAttrInlineCs + ')[^"\'@]*)+["\']' + ')';
        var tagAttrs = /(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*<tagAttrValue>|(?=[\s/>])))+)?/.source.replace(/<tagAttrValue>/, tagAttrValue);
        var tagContent = /(?!\d)[^\s>\/=$<%]+/.source + tagAttrs + /\s*\/?>/.source;
        var tagRegion = /\B@?/.source + '(?:' + /<([a-zA-Z][\w:]*)/.source + tagAttrs + /\s*>/.source + '(?:' + (/[^<]/.source + '|' + // all tags that are not the start tag
        // eslint-disable-next-line regexp/strict
        /<\/?(?!\1\b)/.source + tagContent + '|' + // nested start tag
        nested(// eslint-disable-next-line regexp/strict
        /<\1/.source + tagAttrs + /\s*>/.source + '(?:' + (/[^<]/.source + '|' + // all tags that are not the start tag
        // eslint-disable-next-line regexp/strict
        /<\/?(?!\1\b)/.source + tagContent + '|' + '<self>') + ')*' + // eslint-disable-next-line regexp/strict
        /<\/\1\s*>/.source, 2)) + ')*' + // eslint-disable-next-line regexp/strict
        /<\/\1\s*>/.source + '|' + /</.source + tagContent + ')';
        // Now for the actual language definition(s):
        //
        // Razor as a language has 2 parts:
        //  1) CSHTML: A markup-like language that has been extended with inline C# code expressions and blocks.
        //  2) C#+HTML: A variant of C# that can contain CSHTML tags as expressions.
        //
        // In the below code, both CSHTML and C#+HTML will be create as separate language definitions that reference each
        // other. However, only CSHTML will be exported via `Prism.languages`.
        Prism.languages.cshtml = Prism.languages.extend('markup', {});
        var csharpWithHtml = Prism.languages.insertBefore('csharp', 'string', {
            html: {
                pattern: RegExp(tagRegion),
                greedy: true,
                inside: Prism.languages.cshtml
            }
        }, {
            csharp: Prism.languages.extend('csharp', {})
        });
        var cs = {
            pattern: /\S[\s\S]*/,
            alias: 'language-csharp',
            inside: csharpWithHtml
        };
        var inlineValue = {
            pattern: RegExp(/(^|[^@])/.source + inlineCs),
            lookbehind: true,
            greedy: true,
            alias: 'variable',
            inside: {
                keyword: /^@/,
                csharp: cs
            }
        };
        Prism.languages.cshtml.tag.pattern = RegExp(/<\/?/.source + tagContent);
        Prism.languages.cshtml.tag.inside['attr-value'].pattern = RegExp(/=\s*/.source + tagAttrValue);
        Prism.languages.insertBefore('inside', 'punctuation', {
            value: inlineValue
        }, Prism.languages.cshtml.tag.inside['attr-value']);
        Prism.languages.insertBefore('cshtml', 'prolog', {
            'razor-comment': {
                pattern: /@\*[\s\S]*?\*@/,
                greedy: true,
                alias: 'comment'
            },
            block: {
                pattern: RegExp(/(^|[^@])@/.source + '(?:' + [
                    // @{ ... }
                    curly,
                    // @code{ ... }
                    /(?:code|functions)\s*/.source + curly,
                    // @for (...) { ... }
                    /(?:for|foreach|lock|switch|using|while)\s*/.source + round + /\s*/.source + curly,
                    // @do { ... } while (...);
                    /do\s*/.source + curly + /\s*while\s*/.source + round + /(?:\s*;)?/.source,
                    // @try { ... } catch (...) { ... } finally { ... }
                    /try\s*/.source + curly + /\s*catch\s*/.source + round + /\s*/.source + curly + /\s*finally\s*/.source + curly,
                    // @if (...) {...} else if (...) {...} else {...}
                    /if\s*/.source + round + /\s*/.source + curly + '(?:' + /\s*else/.source + '(?:' + /\s+if\s*/.source + round + ')?' + /\s*/.source + curly + ')*',
                    // @helper Ident(params) { ... }
                    /helper\s+\w+\s*/.source + round + /\s*/.source + curly
                ].join('|') + ')'),
                lookbehind: true,
                greedy: true,
                inside: {
                    keyword: /^@\w*/,
                    csharp: cs
                }
            },
            directive: {
                pattern: /^([ \t]*)@(?:addTagHelper|attribute|implements|inherits|inject|layout|model|namespace|page|preservewhitespace|removeTagHelper|section|tagHelperPrefix|using)(?=\s).*/m,
                lookbehind: true,
                greedy: true,
                inside: {
                    keyword: /^@\w+/,
                    csharp: cs
                }
            },
            value: inlineValue,
            'delegate-operator': {
                pattern: /(^|[^@])@(?=<)/,
                lookbehind: true,
                alias: 'operator'
            }
        });
        Prism.languages.razor = Prism.languages.cshtml;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 

$5a7f23f7c27bdf2d$export$2e2bcd8739ae039.displayName = 'jsx';
$5a7f23f7c27bdf2d$export$2e2bcd8739ae039.aliases = [];
function $5a7f23f7c27bdf2d$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $9f5c72e4d4e505c4$export$2e2bcd8739ae039));
    Prism.register((0, $8fbeea7c20d72e06$export$2e2bcd8739ae039));
    (function(Prism) {
        var javascript = Prism.util.clone(Prism.languages.javascript);
        var space = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source;
        var braces = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source;
        var spread = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
        /**
     * @param {string} source
     * @param {string} [flags]
     */ function re(source, flags) {
            source = source.replace(/<S>/g, function() {
                return space;
            }).replace(/<BRACES>/g, function() {
                return braces;
            }).replace(/<SPREAD>/g, function() {
                return spread;
            });
            return RegExp(source, flags);
        }
        spread = re(spread).source;
        Prism.languages.jsx = Prism.languages.extend('markup', javascript);
        Prism.languages.jsx.tag.pattern = re(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source);
        Prism.languages.jsx.tag.inside['tag'].pattern = /^<\/?[^\s>\/]*/;
        Prism.languages.jsx.tag.inside['attr-value'].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/;
        Prism.languages.jsx.tag.inside['tag'].inside['class-name'] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/;
        Prism.languages.jsx.tag.inside['comment'] = javascript['comment'];
        Prism.languages.insertBefore('inside', 'attr-name', {
            spread: {
                pattern: re(/<SPREAD>/.source),
                inside: Prism.languages.jsx
            }
        }, Prism.languages.jsx.tag);
        Prism.languages.insertBefore('inside', 'special-attr', {
            script: {
                // Allow for two levels of nesting
                pattern: re(/=<BRACES>/.source),
                alias: 'language-javascript',
                inside: {
                    'script-punctuation': {
                        pattern: /^=(?=\{)/,
                        alias: 'punctuation'
                    },
                    rest: Prism.languages.jsx
                }
            }
        }, Prism.languages.jsx.tag);
        // The following will handle plain text inside tags
        var stringifyToken = function(token) {
            if (!token) return '';
            if (typeof token === 'string') return token;
            if (typeof token.content === 'string') return token.content;
            return token.content.map(stringifyToken).join('');
        };
        var walkTokens = function(tokens) {
            var openedTags = [];
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                var notTagNorBrace = false;
                if (typeof token !== 'string') {
                    if (token.type === 'tag' && token.content[0] && token.content[0].type === 'tag') {
                        // We found a tag, now find its kind
                        if (token.content[0].content[0].content === '</') // Closing tag
                        {
                            if (openedTags.length > 0 && openedTags[openedTags.length - 1].tagName === stringifyToken(token.content[0].content[1])) // Pop matching opening tag
                            openedTags.pop();
                        } else {
                            if (token.content[token.content.length - 1].content === '/>') ;
                            else // Opening tag
                            openedTags.push({
                                tagName: stringifyToken(token.content[0].content[1]),
                                openedBraces: 0
                            });
                        }
                    } else if (openedTags.length > 0 && token.type === 'punctuation' && token.content === '{') // Here we might have entered a JSX context inside a tag
                    openedTags[openedTags.length - 1].openedBraces++;
                    else if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces > 0 && token.type === 'punctuation' && token.content === '}') // Here we might have left a JSX context inside a tag
                    openedTags[openedTags.length - 1].openedBraces--;
                    else notTagNorBrace = true;
                }
                if (notTagNorBrace || typeof token === 'string') {
                    if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces === 0) {
                        // Here we are inside a tag, and not inside a JSX context.
                        // That's plain text: drop any tokens matched.
                        var plainText = stringifyToken(token);
                        // And merge text with adjacent text
                        if (i < tokens.length - 1 && (typeof tokens[i + 1] === 'string' || tokens[i + 1].type === 'plain-text')) {
                            plainText += stringifyToken(tokens[i + 1]);
                            tokens.splice(i + 1, 1);
                        }
                        if (i > 0 && (typeof tokens[i - 1] === 'string' || tokens[i - 1].type === 'plain-text')) {
                            plainText = stringifyToken(tokens[i - 1]) + plainText;
                            tokens.splice(i - 1, 1);
                            i--;
                        }
                        tokens[i] = new Prism.Token('plain-text', plainText, null, plainText);
                    }
                }
                if (token.content && typeof token.content !== 'string') walkTokens(token.content);
            }
        };
        Prism.hooks.add('after-tokenize', function(env) {
            if (env.language !== 'jsx' && env.language !== 'tsx') return;
            walkTokens(env.tokens);
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 

$ddc9cfbdf3ae03e6$export$2e2bcd8739ae039.displayName = 'tsx';
$ddc9cfbdf3ae03e6$export$2e2bcd8739ae039.aliases = [];
function $ddc9cfbdf3ae03e6$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $5a7f23f7c27bdf2d$export$2e2bcd8739ae039));
    Prism.register((0, $971aaf7f210ab43d$export$2e2bcd8739ae039));
    (function(Prism) {
        var typescript = Prism.util.clone(Prism.languages.typescript);
        Prism.languages.tsx = Prism.languages.extend('jsx', typescript);
        // doesn't work with TS because TS is too complex
        delete Prism.languages.tsx['parameter'];
        delete Prism.languages.tsx['literal-property'];
        // This will prevent collisions between TSX tags and TS generic types.
        // Idea by https://github.com/karlhorky
        // Discussion: https://github.com/PrismJS/prism/issues/2594#issuecomment-710666928
        var tag = Prism.languages.tsx.tag;
        tag.pattern = RegExp(/(^|[^\w$]|(?=<\/))/.source + '(?:' + tag.pattern.source + ')', tag.pattern.flags);
        tag.lookbehind = true;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$d2abd9c8c48957cf$export$2e2bcd8739ae039.displayName = 'reason';
$d2abd9c8c48957cf$export$2e2bcd8739ae039.aliases = [];
function $d2abd9c8c48957cf$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    Prism.languages.reason = Prism.languages.extend('clike', {
        string: {
            pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
            greedy: true
        },
        // 'class-name' must be matched *after* 'constructor' defined below
        'class-name': /\b[A-Z]\w*/,
        keyword: /\b(?:and|as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|method|module|mutable|new|nonrec|object|of|open|or|private|rec|sig|struct|switch|then|to|try|type|val|virtual|when|while|with)\b/,
        operator: /\.{3}|:[:=]|\|>|->|=(?:==?|>)?|<=?|>=?|[|^?'#!~`]|[+\-*\/]\.?|\b(?:asr|land|lor|lsl|lsr|lxor|mod)\b/
    });
    Prism.languages.insertBefore('reason', 'class-name', {
        char: {
            pattern: /'(?:\\x[\da-f]{2}|\\o[0-3][0-7][0-7]|\\\d{3}|\\.|[^'\\\r\n])'/,
            greedy: true
        },
        // Negative look-ahead prevents from matching things like String.capitalize
        constructor: /\b[A-Z]\w*\b(?!\s*\.)/,
        label: {
            pattern: /\b[a-z]\w*(?=::)/,
            alias: 'symbol'
        }
    });
    // We can't match functions property, so let's not even try.
    delete Prism.languages.reason.function;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $e6d237a9cb4c3d5f$export$2e2bcd8739ae039.displayName = 'rego';
$e6d237a9cb4c3d5f$export$2e2bcd8739ae039.aliases = [];
function $e6d237a9cb4c3d5f$export$2e2bcd8739ae039(Prism) {
    // https://www.openpolicyagent.org/docs/latest/policy-reference/
    Prism.languages.rego = {
        comment: /#.*/,
        property: {
            pattern: /(^|[^\\.])(?:"(?:\\.|[^\\"\r\n])*"|`[^`]*`|\b[a-z_]\w*\b)(?=\s*:(?!=))/i,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"|`[^`]*`/,
            lookbehind: true,
            greedy: true
        },
        keyword: /\b(?:as|default|else|import|not|null|package|set(?=\s*\()|some|with)\b/,
        boolean: /\b(?:false|true)\b/,
        function: {
            pattern: /\b[a-z_]\w*\b(?:\s*\.\s*\b[a-z_]\w*\b)*(?=\s*\()/i,
            inside: {
                namespace: /\b\w+\b(?=\s*\.)/,
                punctuation: /\./
            }
        },
        number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
        operator: /[-+*/%|&]|[<>:=]=?|!=|\b_\b/,
        punctuation: /[,;.\[\]{}()]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $e688140d88bbf085$export$2e2bcd8739ae039.displayName = 'renpy';
$e688140d88bbf085$export$2e2bcd8739ae039.aliases = [
    'rpy'
];
function $e688140d88bbf085$export$2e2bcd8739ae039(Prism) {
    Prism.languages.renpy = {
        comment: {
            pattern: /(^|[^\\])#.+/,
            lookbehind: true
        },
        string: {
            pattern: /("""|''')[\s\S]+?\1|("|')(?:\\.|(?!\2)[^\\])*\2|(?:^#?(?:(?:[0-9a-fA-F]){3}|[0-9a-fA-F]{6})$)/m,
            greedy: true
        },
        function: /\b[a-z_]\w*(?=\()/i,
        property: /\b(?:Update|UpdateVersion|action|activate_sound|adv_nvl_transition|after_load_transition|align|alpha|alt|anchor|antialias|area|auto|background|bar_invert|bar_resizing|bar_vertical|black_color|bold|bottom_bar|bottom_gutter|bottom_margin|bottom_padding|box_reverse|box_wrap|can_update|caret|child|color|crop|default_afm_enable|default_afm_time|default_fullscreen|default_text_cps|developer|directory_name|drag_handle|drag_joined|drag_name|drag_raise|draggable|dragged|drop_shadow|drop_shadow_color|droppable|dropped|easein|easeout|edgescroll|end_game_transition|end_splash_transition|enter_replay_transition|enter_sound|enter_transition|enter_yesno_transition|executable_name|exit_replay_transition|exit_sound|exit_transition|exit_yesno_transition|fadein|fadeout|first_indent|first_spacing|fit_first|focus|focus_mask|font|foreground|game_main_transition|get_installed_packages|google_play_key|google_play_salt|ground|has_music|has_sound|has_voice|height|help|hinting|hover|hover_background|hover_color|hover_sound|hovered|hyperlink_functions|idle|idle_color|image_style|include_update|insensitive|insensitive_background|insensitive_color|inside|intra_transition|italic|justify|kerning|keyboard_focus|language|layer_clipping|layers|layout|left_bar|left_gutter|left_margin|left_padding|length|line_leading|line_overlap_split|line_spacing|linear|main_game_transition|main_menu_music|maximum|min_width|minimum|minwidth|modal|mouse|mousewheel|name|narrator_menu|newline_indent|nvl_adv_transition|offset|order_reverse|outlines|overlay_functions|pos|position|prefix|radius|range|rest_indent|right_bar|right_gutter|right_margin|right_padding|rotate|rotate_pad|ruby_style|sample_sound|save_directory|say_attribute_transition|screen_height|screen_width|scrollbars|selected_hover|selected_hover_color|selected_idle|selected_idle_color|selected_insensitive|show_side_image|show_two_window|side_spacing|side_xpos|side_ypos|size|size_group|slow_cps|slow_cps_multiplier|spacing|strikethrough|subpixel|text_align|text_style|text_xpos|text_y_fudge|text_ypos|thumb|thumb_offset|thumb_shadow|thumbnail_height|thumbnail_width|time|top_bar|top_gutter|top_margin|top_padding|translations|underline|unscrollable|update|value|version|version_name|version_tuple|vertical|width|window_hide_transition|window_icon|window_left_padding|window_show_transition|window_title|windows_icon|xadjustment|xalign|xanchor|xanchoraround|xaround|xcenter|xfill|xinitial|xmargin|xmaximum|xminimum|xoffset|xofsset|xpadding|xpos|xsize|xzoom|yadjustment|yalign|yanchor|yanchoraround|yaround|ycenter|yfill|yinitial|ymargin|ymaximum|yminimum|yoffset|ypadding|ypos|ysize|ysizexysize|yzoom|zoom|zorder)\b/,
        tag: /\b(?:bar|block|button|buttoscreenn|drag|draggroup|fixed|frame|grid|[hv]box|hotbar|hotspot|image|imagebutton|imagemap|input|key|label|menu|mm_menu_frame|mousearea|nvl|parallel|screen|self|side|tag|text|textbutton|timer|vbar|viewport|window)\b|\$/,
        keyword: /\b(?:None|add|adjustment|alignaround|allow|angle|animation|around|as|assert|behind|box_layout|break|build|cache|call|center|changed|child_size|choice|circles|class|clear|clicked|clipping|clockwise|config|contains|continue|corner1|corner2|counterclockwise|def|default|define|del|delay|disabled|disabled_text|dissolve|elif|else|event|except|exclude|exec|expression|fade|finally|for|from|function|global|gm_root|has|hide|id|if|import|in|init|is|jump|knot|lambda|left|less_rounded|mm_root|movie|music|null|on|onlayer|pass|pause|persistent|play|print|python|queue|raise|random|renpy|repeat|return|right|rounded_window|scene|scope|set|show|slow|slow_abortable|slow_done|sound|stop|store|style|style_group|substitute|suffix|theme|transform|transform_anchor|transpose|try|ui|unhovered|updater|use|voice|while|widget|widget_hover|widget_selected|widget_text|yield)\b/,
        boolean: /\b(?:[Ff]alse|[Tt]rue)\b/,
        number: /(?:\b(?:0[bo])?(?:(?:\d|0x[\da-f])[\da-f]*(?:\.\d*)?)|\B\.\d+)(?:e[+-]?\d+)?j?/i,
        operator: /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]|\b(?:and|at|not|or|with)\b/,
        punctuation: /[{}[\];(),.:]/
    };
    Prism.languages.rpy = Prism.languages.renpy;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $6ad9cfd191d928bf$export$2e2bcd8739ae039.displayName = 'rescript';
$6ad9cfd191d928bf$export$2e2bcd8739ae039.aliases = [
    'res'
];
function $6ad9cfd191d928bf$export$2e2bcd8739ae039(Prism) {
    Prism.languages.rescript = {
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
            greedy: true
        },
        char: {
            pattern: /'(?:[^\r\n\\]|\\(?:.|\w+))'/,
            greedy: true
        },
        string: {
            pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
            greedy: true
        },
        'class-name': /\b[A-Z]\w*|@[a-z.]*|#[A-Za-z]\w*|#\d/,
        function: {
            pattern: /[a-zA-Z]\w*(?=\()|(\.)[a-z]\w*/,
            lookbehind: true
        },
        number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
        boolean: /\b(?:false|true)\b/,
        'attr-value': /[A-Za-z]\w*(?==)/,
        constant: {
            pattern: /(\btype\s+)[a-z]\w*/,
            lookbehind: true
        },
        tag: {
            pattern: /(<)[a-z]\w*|(?:<\/)[a-z]\w*/,
            lookbehind: true,
            inside: {
                operator: /<|>|\//
            }
        },
        keyword: /\b(?:and|as|assert|begin|bool|class|constraint|do|done|downto|else|end|exception|external|float|for|fun|function|if|in|include|inherit|initializer|int|lazy|let|method|module|mutable|new|nonrec|object|of|open|or|private|rec|string|switch|then|to|try|type|when|while|with)\b/,
        operator: /\.{3}|:[:=]?|\|>|->|=(?:==?|>)?|<=?|>=?|[|^?'#!~`]|[+\-*\/]\.?|\b(?:asr|land|lor|lsl|lsr|lxor|mod)\b/,
        punctuation: /[(){}[\],;.]/
    };
    Prism.languages.insertBefore('rescript', 'string', {
        'template-string': {
            pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
            greedy: true,
            inside: {
                'template-punctuation': {
                    pattern: /^`|`$/,
                    alias: 'string'
                },
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                    lookbehind: true,
                    inside: {
                        'interpolation-punctuation': {
                            pattern: /^\$\{|\}$/,
                            alias: 'tag'
                        },
                        rest: Prism.languages.rescript
                    }
                },
                string: /[\s\S]+/
            }
        }
    });
    Prism.languages.res = Prism.languages.rescript;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $0382dbd2a40e4691$export$2e2bcd8739ae039.displayName = 'rest';
$0382dbd2a40e4691$export$2e2bcd8739ae039.aliases = [];
function $0382dbd2a40e4691$export$2e2bcd8739ae039(Prism) {
    Prism.languages.rest = {
        table: [
            {
                pattern: /(^[\t ]*)(?:\+[=-]+)+\+(?:\r?\n|\r)(?:\1[+|].+[+|](?:\r?\n|\r))+\1(?:\+[=-]+)+\+/m,
                lookbehind: true,
                inside: {
                    punctuation: /\||(?:\+[=-]+)+\+/
                }
            },
            {
                pattern: /(^[\t ]*)=+ [ =]*=(?:(?:\r?\n|\r)\1.+)+(?:\r?\n|\r)\1=+ [ =]*=(?=(?:\r?\n|\r){2}|\s*$)/m,
                lookbehind: true,
                inside: {
                    punctuation: /[=-]+/
                }
            }
        ],
        // Directive-like patterns
        'substitution-def': {
            pattern: /(^[\t ]*\.\. )\|(?:[^|\s](?:[^|]*[^|\s])?)\| [^:]+::/m,
            lookbehind: true,
            inside: {
                substitution: {
                    pattern: /^\|(?:[^|\s]|[^|\s][^|]*[^|\s])\|/,
                    alias: 'attr-value',
                    inside: {
                        punctuation: /^\||\|$/
                    }
                },
                directive: {
                    pattern: /( )(?! )[^:]+::/,
                    lookbehind: true,
                    alias: 'function',
                    inside: {
                        punctuation: /::$/
                    }
                }
            }
        },
        'link-target': [
            {
                pattern: /(^[\t ]*\.\. )\[[^\]]+\]/m,
                lookbehind: true,
                alias: 'string',
                inside: {
                    punctuation: /^\[|\]$/
                }
            },
            {
                pattern: /(^[\t ]*\.\. )_(?:`[^`]+`|(?:[^:\\]|\\.)+):/m,
                lookbehind: true,
                alias: 'string',
                inside: {
                    punctuation: /^_|:$/
                }
            }
        ],
        directive: {
            pattern: /(^[\t ]*\.\. )[^:]+::/m,
            lookbehind: true,
            alias: 'function',
            inside: {
                punctuation: /::$/
            }
        },
        comment: {
            // The two alternatives try to prevent highlighting of blank comments
            pattern: /(^[\t ]*\.\.)(?:(?: .+)?(?:(?:\r?\n|\r).+)+| .+)(?=(?:\r?\n|\r){2}|$)/m,
            lookbehind: true
        },
        title: [
            // Overlined and underlined
            {
                pattern: /^(([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2+)(?:\r?\n|\r).+(?:\r?\n|\r)\1$/m,
                inside: {
                    punctuation: /^[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+|[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+$/,
                    important: /.+/
                }
            },
            // Underlined only
            {
                pattern: /(^|(?:\r?\n|\r){2}).+(?:\r?\n|\r)([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2+(?=\r?\n|\r|$)/,
                lookbehind: true,
                inside: {
                    punctuation: /[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+$/,
                    important: /.+/
                }
            }
        ],
        hr: {
            pattern: /((?:\r?\n|\r){2})([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2{3,}(?=(?:\r?\n|\r){2})/,
            lookbehind: true,
            alias: 'punctuation'
        },
        field: {
            pattern: /(^[\t ]*):[^:\r\n]+:(?= )/m,
            lookbehind: true,
            alias: 'attr-name'
        },
        'command-line-option': {
            pattern: /(^[\t ]*)(?:[+-][a-z\d]|(?:--|\/)[a-z\d-]+)(?:[ =](?:[a-z][\w-]*|<[^<>]+>))?(?:, (?:[+-][a-z\d]|(?:--|\/)[a-z\d-]+)(?:[ =](?:[a-z][\w-]*|<[^<>]+>))?)*(?=(?:\r?\n|\r)? {2,}\S)/im,
            lookbehind: true,
            alias: 'symbol'
        },
        'literal-block': {
            pattern: /::(?:\r?\n|\r){2}([ \t]+)(?![ \t]).+(?:(?:\r?\n|\r)\1.+)*/,
            inside: {
                'literal-block-punctuation': {
                    pattern: /^::/,
                    alias: 'punctuation'
                }
            }
        },
        'quoted-literal-block': {
            pattern: /::(?:\r?\n|\r){2}([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]).*(?:(?:\r?\n|\r)\1.*)*/,
            inside: {
                'literal-block-punctuation': {
                    pattern: /^(?:::|([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\1*)/m,
                    alias: 'punctuation'
                }
            }
        },
        'list-bullet': {
            pattern: /(^[\t ]*)(?:[*+\-•‣⁃]|\(?(?:\d+|[a-z]|[ivxdclm]+)\)|(?:\d+|[a-z]|[ivxdclm]+)\.)(?= )/im,
            lookbehind: true,
            alias: 'punctuation'
        },
        'doctest-block': {
            pattern: /(^[\t ]*)>>> .+(?:(?:\r?\n|\r).+)*/m,
            lookbehind: true,
            inside: {
                punctuation: /^>>>/
            }
        },
        inline: [
            {
                pattern: /(^|[\s\-:\/'"<(\[{])(?::[^:]+:`.*?`|`.*?`:[^:]+:|(\*\*?|``?|\|)(?!\s)(?:(?!\2).)*\S\2(?=[\s\-.,:;!?\\\/'")\]}]|$))/m,
                lookbehind: true,
                inside: {
                    bold: {
                        pattern: /(^\*\*).+(?=\*\*$)/,
                        lookbehind: true
                    },
                    italic: {
                        pattern: /(^\*).+(?=\*$)/,
                        lookbehind: true
                    },
                    'inline-literal': {
                        pattern: /(^``).+(?=``$)/,
                        lookbehind: true,
                        alias: 'symbol'
                    },
                    role: {
                        pattern: /^:[^:]+:|:[^:]+:$/,
                        alias: 'function',
                        inside: {
                            punctuation: /^:|:$/
                        }
                    },
                    'interpreted-text': {
                        pattern: /(^`).+(?=`$)/,
                        lookbehind: true,
                        alias: 'attr-value'
                    },
                    substitution: {
                        pattern: /(^\|).+(?=\|$)/,
                        lookbehind: true,
                        alias: 'attr-value'
                    },
                    punctuation: /\*\*?|``?|\|/
                }
            }
        ],
        link: [
            {
                pattern: /\[[^\[\]]+\]_(?=[\s\-.,:;!?\\\/'")\]}]|$)/,
                alias: 'string',
                inside: {
                    punctuation: /^\[|\]_$/
                }
            },
            {
                pattern: /(?:\b[a-z\d]+(?:[_.:+][a-z\d]+)*_?_|`[^`]+`_?_|_`[^`]+`)(?=[\s\-.,:;!?\\\/'")\]}]|$)/i,
                alias: 'string',
                inside: {
                    punctuation: /^_?`|`$|`?_?_$/
                }
            }
        ],
        // Line block start,
        // quote attribution,
        // explicit markup start,
        // and anonymous hyperlink target shortcut (__)
        punctuation: {
            pattern: /(^[\t ]*)(?:\|(?= |$)|(?:---?|—|\.\.|__)(?= )|\.\.$)/m,
            lookbehind: true
        }
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $d57abbe2a1fb24f1$export$2e2bcd8739ae039.displayName = 'rip';
$d57abbe2a1fb24f1$export$2e2bcd8739ae039.aliases = [];
function $d57abbe2a1fb24f1$export$2e2bcd8739ae039(Prism) {
    Prism.languages.rip = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        char: {
            pattern: /\B`[^\s`'",.:;#\/\\()<>\[\]{}]\b/,
            greedy: true
        },
        string: {
            pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        regex: {
            pattern: /(^|[^/])\/(?!\/)(?:\[[^\n\r\]]*\]|\\.|[^/\\\r\n\[])+\/(?=\s*(?:$|[\r\n,.;})]))/,
            lookbehind: true,
            greedy: true
        },
        keyword: /(?:=>|->)|\b(?:case|catch|class|else|exit|finally|if|raise|return|switch|try)\b/,
        builtin: /@|\bSystem\b/,
        boolean: /\b(?:false|true)\b/,
        date: /\b\d{4}-\d{2}-\d{2}\b/,
        time: /\b\d{2}:\d{2}:\d{2}\b/,
        datetime: /\b\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\b/,
        symbol: /:[^\d\s`'",.:;#\/\\()<>\[\]{}][^\s`'",.:;#\/\\()<>\[\]{}]*/,
        number: /[+-]?\b(?:\d+\.\d+|\d+)\b/,
        punctuation: /(?:\.{2,3})|[`,.:;=\/\\()<>\[\]{}]/,
        reference: /[^\d\s`'",.:;#\/\\()<>\[\]{}][^\s`'",.:;#\/\\()<>\[\]{}]*/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $9916e53b415a0d4b$export$2e2bcd8739ae039.displayName = 'roboconf';
$9916e53b415a0d4b$export$2e2bcd8739ae039.aliases = [];
function $9916e53b415a0d4b$export$2e2bcd8739ae039(Prism) {
    Prism.languages.roboconf = {
        comment: /#.*/,
        keyword: {
            pattern: /(^|\s)(?:(?:external|import)\b|(?:facet|instance of)(?=[ \t]+[\w-]+[ \t]*\{))/,
            lookbehind: true
        },
        component: {
            pattern: /[\w-]+(?=[ \t]*\{)/,
            alias: 'variable'
        },
        property: /[\w.-]+(?=[ \t]*:)/,
        value: {
            pattern: /(=[ \t]*(?![ \t]))[^,;]+/,
            lookbehind: true,
            alias: 'attr-value'
        },
        optional: {
            pattern: /\(optional\)/,
            alias: 'builtin'
        },
        wildcard: {
            pattern: /(\.)\*/,
            lookbehind: true,
            alias: 'operator'
        },
        punctuation: /[{},.;:=]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $51c5d77fbea0c80e$export$2e2bcd8739ae039.displayName = 'robotframework';
$51c5d77fbea0c80e$export$2e2bcd8739ae039.aliases = [
    'robot'
];
function $51c5d77fbea0c80e$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var comment = {
            pattern: /(^[ \t]*| {2}|\t)#.*/m,
            lookbehind: true,
            greedy: true
        };
        var variable = {
            pattern: /((?:^|[^\\])(?:\\{2})*)[$@&%]\{(?:[^{}\r\n]|\{[^{}\r\n]*\})*\}/,
            lookbehind: true,
            inside: {
                punctuation: /^[$@&%]\{|\}$/
            }
        };
        function createSection(name, inside) {
            var extendecInside = {};
            extendecInside['section-header'] = {
                pattern: /^ ?\*{3}.+?\*{3}/,
                alias: 'keyword'
            };
            // copy inside tokens
            for(var token in inside)extendecInside[token] = inside[token];
            extendecInside['tag'] = {
                pattern: /([\r\n](?: {2}|\t)[ \t]*)\[[-\w]+\]/,
                lookbehind: true,
                inside: {
                    punctuation: /\[|\]/
                }
            };
            extendecInside['variable'] = variable;
            extendecInside['comment'] = comment;
            return {
                pattern: RegExp(/^ ?\*{3}[ \t]*<name>[ \t]*\*{3}(?:.|[\r\n](?!\*{3}))*/.source.replace(/<name>/g, function() {
                    return name;
                }), 'im'),
                alias: 'section',
                inside: extendecInside
            };
        }
        var docTag = {
            pattern: /(\[Documentation\](?: {2}|\t)[ \t]*)(?![ \t]|#)(?:.|(?:\r\n?|\n)[ \t]*\.{3})+/,
            lookbehind: true,
            alias: 'string'
        };
        var testNameLike = {
            pattern: /([\r\n] ?)(?!#)(?:\S(?:[ \t]\S)*)+/,
            lookbehind: true,
            alias: 'function',
            inside: {
                variable: variable
            }
        };
        var testPropertyLike = {
            pattern: /([\r\n](?: {2}|\t)[ \t]*)(?!\[|\.{3}|#)(?:\S(?:[ \t]\S)*)+/,
            lookbehind: true,
            inside: {
                variable: variable
            }
        };
        Prism.languages['robotframework'] = {
            settings: createSection('Settings', {
                documentation: {
                    pattern: /([\r\n] ?Documentation(?: {2}|\t)[ \t]*)(?![ \t]|#)(?:.|(?:\r\n?|\n)[ \t]*\.{3})+/,
                    lookbehind: true,
                    alias: 'string'
                },
                property: {
                    pattern: /([\r\n] ?)(?!\.{3}|#)(?:\S(?:[ \t]\S)*)+/,
                    lookbehind: true
                }
            }),
            variables: createSection('Variables'),
            'test-cases': createSection('Test Cases', {
                'test-name': testNameLike,
                documentation: docTag,
                property: testPropertyLike
            }),
            keywords: createSection('Keywords', {
                'keyword-name': testNameLike,
                documentation: docTag,
                property: testPropertyLike
            }),
            tasks: createSection('Tasks', {
                'task-name': testNameLike,
                documentation: docTag,
                property: testPropertyLike
            }),
            comment: comment
        };
        Prism.languages.robot = Prism.languages['robotframework'];
    })(Prism);
}



// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $f68bbd0409e49719$export$2e2bcd8739ae039.displayName = 'sas';
$f68bbd0409e49719$export$2e2bcd8739ae039.aliases = [];
function $f68bbd0409e49719$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var stringPattern = /(?:"(?:""|[^"])*"(?!")|'(?:''|[^'])*'(?!'))/.source;
        var number = /\b(?:\d[\da-f]*x|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i;
        var numericConstant = {
            pattern: RegExp(stringPattern + '[bx]'),
            alias: 'number'
        };
        var macroVariable = {
            pattern: /&[a-z_]\w*/i
        };
        var macroKeyword = {
            pattern: /((?:^|\s|=|\())%(?:ABORT|BY|CMS|COPY|DISPLAY|DO|ELSE|END|EVAL|GLOBAL|GO|GOTO|IF|INC|INCLUDE|INDEX|INPUT|KTRIM|LENGTH|LET|LIST|LOCAL|PUT|QKTRIM|QSCAN|QSUBSTR|QSYSFUNC|QUPCASE|RETURN|RUN|SCAN|SUBSTR|SUPERQ|SYMDEL|SYMEXIST|SYMGLOBL|SYMLOCAL|SYSCALL|SYSEVALF|SYSEXEC|SYSFUNC|SYSGET|SYSRPUT|THEN|TO|TSO|UNQUOTE|UNTIL|UPCASE|WHILE|WINDOW)\b/i,
            lookbehind: true,
            alias: 'keyword'
        };
        var step = {
            pattern: /(^|\s)(?:proc\s+\w+|data(?!=)|quit|run)\b/i,
            alias: 'keyword',
            lookbehind: true
        };
        var comment = [
            /\/\*[\s\S]*?\*\//,
            {
                pattern: /(^[ \t]*|;\s*)\*[^;]*;/m,
                lookbehind: true
            }
        ];
        var string = {
            pattern: RegExp(stringPattern),
            greedy: true
        };
        var punctuation = /[$%@.(){}\[\];,\\]/;
        var func = {
            pattern: /%?\b\w+(?=\()/,
            alias: 'keyword'
        };
        var args = {
            function: func,
            'arg-value': {
                pattern: /(=\s*)[A-Z\.]+/i,
                lookbehind: true
            },
            operator: /=/,
            'macro-variable': macroVariable,
            arg: {
                pattern: /[A-Z]+/i,
                alias: 'keyword'
            },
            number: number,
            'numeric-constant': numericConstant,
            punctuation: punctuation,
            string: string
        };
        var format = {
            pattern: /\b(?:format|put)\b=?[\w'$.]+/i,
            inside: {
                keyword: /^(?:format|put)(?==)/i,
                equals: /=/,
                format: {
                    pattern: /(?:\w|\$\d)+\.\d?/,
                    alias: 'number'
                }
            }
        };
        var altformat = {
            pattern: /\b(?:format|put)\s+[\w']+(?:\s+[$.\w]+)+(?=;)/i,
            inside: {
                keyword: /^(?:format|put)/i,
                format: {
                    pattern: /[\w$]+\.\d?/,
                    alias: 'number'
                }
            }
        };
        var globalStatements = {
            pattern: /((?:^|\s)=?)(?:catname|checkpoint execute_always|dm|endsas|filename|footnote|%include|libname|%list|lock|missing|options|page|resetline|%run|sasfile|skip|sysecho|title\d?)\b/i,
            lookbehind: true,
            alias: 'keyword'
        };
        var submitStatement = {
            pattern: /(^|\s)(?:submit(?:\s+(?:load|norun|parseonly))?|endsubmit)\b/i,
            lookbehind: true,
            alias: 'keyword'
        };
        var actionSets = /aStore|accessControl|aggregation|audio|autotune|bayesianNetClassifier|bioMedImage|boolRule|builtins|cardinality|cdm|clustering|conditionalRandomFields|configuration|copula|countreg|dataDiscovery|dataPreprocess|dataSciencePilot|dataStep|decisionTree|deduplication|deepLearn|deepNeural|deepRnn|ds2|ecm|entityRes|espCluster|explainModel|factmac|fastKnn|fcmpact|fedSql|freqTab|gVarCluster|gam|gleam|graphSemiSupLearn|hiddenMarkovModel|hyperGroup|ica|image|iml|kernalPca|langModel|ldaTopic|loadStreams|mbc|mixed|mlTools|modelPublishing|network|neuralNet|nmf|nonParametricBayes|nonlinear|optNetwork|optimization|panel|pca|percentile|phreg|pls|qkb|qlim|quantreg|recommend|regression|reinforcementLearn|robustPca|ruleMining|sampling|sandwich|sccasl|search(?:Analytics)?|sentimentAnalysis|sequence|session(?:Prop)?|severity|simSystem|simple|smartData|sparkEmbeddedProcess|sparseML|spatialreg|spc|stabilityMonitoring|svDataDescription|svm|table|text(?:Filters|Frequency|Mining|Parse|Rule(?:Develop|Score)|Topic|Util)|timeData|transpose|tsInfo|tsReconcile|uniTimeSeries|varReduce/.source;
        var casActions = {
            pattern: RegExp(/(^|\s)(?:action\s+)?(?:<act>)\.[a-z]+\b[^;]+/.source.replace(/<act>/g, function() {
                return actionSets;
            }), 'i'),
            lookbehind: true,
            inside: {
                keyword: RegExp(/(?:<act>)\.[a-z]+\b/.source.replace(/<act>/g, function() {
                    return actionSets;
                }), 'i'),
                action: {
                    pattern: /(?:action)/i,
                    alias: 'keyword'
                },
                comment: comment,
                function: func,
                'arg-value': args['arg-value'],
                operator: args.operator,
                argument: args.arg,
                number: number,
                'numeric-constant': numericConstant,
                punctuation: punctuation,
                string: string
            }
        };
        var keywords = {
            pattern: /((?:^|\s)=?)(?:after|analysis|and|array|barchart|barwidth|begingraph|by|call|cas|cbarline|cfill|class(?:lev)?|close|column|computed?|contains|continue|data(?==)|define|delete|describe|document|do\s+over|do|dol|drop|dul|else|end(?:comp|source)?|entryTitle|eval(?:uate)?|exec(?:ute)?|exit|file(?:name)?|fill(?:attrs)?|flist|fnc|function(?:list)?|global|goto|group(?:by)?|headline|headskip|histogram|if|infile|keep|keylabel|keyword|label|layout|leave|legendlabel|length|libname|loadactionset|merge|midpoints|_?null_|name|noobs|nowd|ods|options|or|otherwise|out(?:put)?|over(?:lay)?|plot|print|put|raise|ranexp|rannor|rbreak|retain|return|select|session|sessref|set|source|statgraph|sum|summarize|table|temp|terminate|then\s+do|then|title\d?|to|var|when|where|xaxisopts|y2axisopts|yaxisopts)\b/i,
            lookbehind: true
        };
        Prism.languages.sas = {
            datalines: {
                pattern: /^([ \t]*)(?:cards|(?:data)?lines);[\s\S]+?^[ \t]*;/im,
                lookbehind: true,
                alias: 'string',
                inside: {
                    keyword: {
                        pattern: /^(?:cards|(?:data)?lines)/i
                    },
                    punctuation: /;/
                }
            },
            'proc-sql': {
                pattern: /(^proc\s+(?:fed)?sql(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
                lookbehind: true,
                inside: {
                    sql: {
                        pattern: RegExp(/^[ \t]*(?:select|alter\s+table|(?:create|describe|drop)\s+(?:index|table(?:\s+constraints)?|view)|create\s+unique\s+index|insert\s+into|update)(?:<str>|[^;"'])+;/.source.replace(/<str>/g, function() {
                            return stringPattern;
                        }), 'im'),
                        alias: 'language-sql',
                        inside: Prism.languages.sql
                    },
                    'global-statements': globalStatements,
                    'sql-statements': {
                        pattern: /(^|\s)(?:disconnect\s+from|begin|commit|exec(?:ute)?|reset|rollback|validate)\b/i,
                        lookbehind: true,
                        alias: 'keyword'
                    },
                    number: number,
                    'numeric-constant': numericConstant,
                    punctuation: punctuation,
                    string: string
                }
            },
            'proc-groovy': {
                pattern: /(^proc\s+groovy(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
                lookbehind: true,
                inside: {
                    comment: comment,
                    groovy: {
                        pattern: RegExp(/(^[ \t]*submit(?:\s+(?:load|norun|parseonly))?)(?:<str>|[^"'])+?(?=endsubmit;)/.source.replace(/<str>/g, function() {
                            return stringPattern;
                        }), 'im'),
                        lookbehind: true,
                        alias: 'language-groovy',
                        inside: Prism.languages.groovy
                    },
                    keyword: keywords,
                    'submit-statement': submitStatement,
                    'global-statements': globalStatements,
                    number: number,
                    'numeric-constant': numericConstant,
                    punctuation: punctuation,
                    string: string
                }
            },
            'proc-lua': {
                pattern: /(^proc\s+lua(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
                lookbehind: true,
                inside: {
                    comment: comment,
                    lua: {
                        pattern: RegExp(/(^[ \t]*submit(?:\s+(?:load|norun|parseonly))?)(?:<str>|[^"'])+?(?=endsubmit;)/.source.replace(/<str>/g, function() {
                            return stringPattern;
                        }), 'im'),
                        lookbehind: true,
                        alias: 'language-lua',
                        inside: Prism.languages.lua
                    },
                    keyword: keywords,
                    'submit-statement': submitStatement,
                    'global-statements': globalStatements,
                    number: number,
                    'numeric-constant': numericConstant,
                    punctuation: punctuation,
                    string: string
                }
            },
            'proc-cas': {
                pattern: /(^proc\s+cas(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|quit|data);|(?![\s\S]))/im,
                lookbehind: true,
                inside: {
                    comment: comment,
                    'statement-var': {
                        pattern: /((?:^|\s)=?)saveresult\s[^;]+/im,
                        lookbehind: true,
                        inside: {
                            statement: {
                                pattern: /^saveresult\s+\S+/i,
                                inside: {
                                    keyword: /^(?:saveresult)/i
                                }
                            },
                            rest: args
                        }
                    },
                    'cas-actions': casActions,
                    statement: {
                        pattern: /((?:^|\s)=?)(?:default|(?:un)?set|on|output|upload)[^;]+/im,
                        lookbehind: true,
                        inside: args
                    },
                    step: step,
                    keyword: keywords,
                    function: func,
                    format: format,
                    altformat: altformat,
                    'global-statements': globalStatements,
                    number: number,
                    'numeric-constant': numericConstant,
                    punctuation: punctuation,
                    string: string
                }
            },
            'proc-args': {
                pattern: RegExp(/(^proc\s+\w+\s+)(?!\s)(?:[^;"']|<str>)+;/.source.replace(/<str>/g, function() {
                    return stringPattern;
                }), 'im'),
                lookbehind: true,
                inside: args
            },
            /*Special keywords within macros*/ 'macro-keyword': macroKeyword,
            'macro-variable': macroVariable,
            'macro-string-functions': {
                pattern: /((?:^|\s|=))%(?:BQUOTE|NRBQUOTE|NRQUOTE|NRSTR|QUOTE|STR)\(.*?(?:[^%]\))/i,
                lookbehind: true,
                inside: {
                    function: {
                        pattern: /%(?:BQUOTE|NRBQUOTE|NRQUOTE|NRSTR|QUOTE|STR)/i,
                        alias: 'keyword'
                    },
                    'macro-keyword': macroKeyword,
                    'macro-variable': macroVariable,
                    'escaped-char': {
                        pattern: /%['"()<>=¬^~;,#]/
                    },
                    punctuation: punctuation
                }
            },
            'macro-declaration': {
                pattern: /^%macro[^;]+(?=;)/im,
                inside: {
                    keyword: /%macro/i
                }
            },
            'macro-end': {
                pattern: /^%mend[^;]+(?=;)/im,
                inside: {
                    keyword: /%mend/i
                }
            },
            /*%_zscore(headcir, _lhc, _mhc, _shc, headcz, headcpct, _Fheadcz); */ macro: {
                pattern: /%_\w+(?=\()/,
                alias: 'keyword'
            },
            input: {
                pattern: /\binput\s[-\w\s/*.$&]+;/i,
                inside: {
                    input: {
                        alias: 'keyword',
                        pattern: /^input/i
                    },
                    comment: comment,
                    number: number,
                    'numeric-constant': numericConstant
                }
            },
            'options-args': {
                pattern: /(^options)[-'"|/\\<>*+=:()\w\s]*(?=;)/im,
                lookbehind: true,
                inside: args
            },
            'cas-actions': casActions,
            comment: comment,
            function: func,
            format: format,
            altformat: altformat,
            'numeric-constant': numericConstant,
            datetime: {
                // '1jan2013'd, '9:25:19pm't, '18jan2003:9:27:05am'dt
                pattern: RegExp(stringPattern + '(?:dt?|t)'),
                alias: 'number'
            },
            string: string,
            step: step,
            keyword: keywords,
            // In SAS Studio syntax highlighting, these operators are styled like keywords
            'operator-keyword': {
                pattern: /\b(?:eq|ge|gt|in|le|lt|ne|not)\b/i,
                alias: 'operator'
            },
            // Decimal (1.2e23), hexadecimal (0c1x)
            number: number,
            operator: /\*\*?|\|\|?|!!?|¦¦?|<[>=]?|>[<=]?|[-+\/=&]|[~¬^]=?/,
            punctuation: punctuation
        };
    })(Prism);
}



// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$c02a8ca6bc5c05f7$export$2e2bcd8739ae039.displayName = 'shell-session';
$c02a8ca6bc5c05f7$export$2e2bcd8739ae039.aliases = [
    'sh-session',
    'shellsession'
];
function $c02a8ca6bc5c05f7$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $34bd8604ec75c450$export$2e2bcd8739ae039));
    (function(Prism) {
        // CAREFUL!
        // The following patterns are concatenated, so the group referenced by a back reference is non-obvious!
        var strings = [
            // normal string
            /"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/.source,
            /'[^']*'/.source,
            /\$'(?:[^'\\]|\\[\s\S])*'/.source,
            // here doc
            // 2 capturing groups
            /<<-?\s*(["']?)(\w+)\1\s[\s\S]*?[\r\n]\2/.source
        ].join('|');
        Prism.languages['shell-session'] = {
            command: {
                pattern: RegExp(// user info
                /^/.source + '(?:' + // <user> ":" ( <path> )?
                (/[^\s@:$#%*!/\\]+@[^\r\n@:$#%*!/\\]+(?::[^\0-\x1F$#%*?"<>:;|]+)?/.source + '|' + // <path>
                // Since the path pattern is quite general, we will require it to start with a special character to
                // prevent false positives.
                /[/~.][^\0-\x1F$#%*?"<>@:;|]*/.source) + ')?' + // shell symbol
                /[$#%](?=\s)/.source + // bash command
                /(?:[^\\\r\n \t'"<$]|[ \t](?:(?!#)|#.*$)|\\(?:[^\r]|\r\n?)|\$(?!')|<(?!<)|<<str>>)+/.source.replace(/<<str>>/g, function() {
                    return strings;
                }), 'm'),
                greedy: true,
                inside: {
                    info: {
                        // foo@bar:~/files$ exit
                        // foo@bar$ exit
                        // ~/files$ exit
                        pattern: /^[^#$%]+/,
                        alias: 'punctuation',
                        inside: {
                            user: /^[^\s@:$#%*!/\\]+@[^\r\n@:$#%*!/\\]+/,
                            punctuation: /:/,
                            path: /[\s\S]+/
                        }
                    },
                    bash: {
                        pattern: /(^[$#%]\s*)\S[\s\S]*/,
                        lookbehind: true,
                        alias: 'language-bash',
                        inside: Prism.languages.bash
                    },
                    'shell-symbol': {
                        pattern: /^[$#%]/,
                        alias: 'important'
                    }
                }
            },
            output: /.(?:.*(?:[\r\n]|.$))*/
        };
        Prism.languages['sh-session'] = Prism.languages['shellsession'] = Prism.languages['shell-session'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $c1218d553691b555$export$2e2bcd8739ae039.displayName = 'smali';
$c1218d553691b555$export$2e2bcd8739ae039.aliases = [];
function $c1218d553691b555$export$2e2bcd8739ae039(Prism) {
    // Test files for the parser itself:
    // https://github.com/JesusFreke/smali/tree/master/smali/src/test/resources/LexerTest
    Prism.languages.smali = {
        comment: /#.*/,
        string: {
            pattern: /"(?:[^\r\n\\"]|\\.)*"|'(?:[^\r\n\\']|\\(?:.|u[\da-fA-F]{4}))'/,
            greedy: true
        },
        'class-name': {
            pattern: /(^|[^L])L(?:(?:\w+|`[^`\r\n]*`)\/)*(?:[\w$]+|`[^`\r\n]*`)(?=\s*;)/,
            lookbehind: true,
            inside: {
                'class-name': {
                    pattern: /(^L|\/)(?:[\w$]+|`[^`\r\n]*`)$/,
                    lookbehind: true
                },
                namespace: {
                    pattern: /^(L)(?:(?:\w+|`[^`\r\n]*`)\/)+/,
                    lookbehind: true,
                    inside: {
                        punctuation: /\//
                    }
                },
                builtin: /^L/
            }
        },
        builtin: [
            {
                // Reference: https://github.com/JesusFreke/smali/wiki/TypesMethodsAndFields#types
                pattern: /([();\[])[BCDFIJSVZ]+/,
                lookbehind: true
            },
            {
                // e.g. .field mWifiOnUid:I
                pattern: /([\w$>]:)[BCDFIJSVZ]/,
                lookbehind: true
            }
        ],
        keyword: [
            {
                pattern: /(\.end\s+)[\w-]+/,
                lookbehind: true
            },
            {
                pattern: /(^|[^\w.-])\.(?!\d)[\w-]+/,
                lookbehind: true
            },
            {
                pattern: /(^|[^\w.-])(?:abstract|annotation|bridge|constructor|enum|final|interface|private|protected|public|runtime|static|synthetic|system|transient)(?![\w.-])/,
                lookbehind: true
            }
        ],
        function: {
            pattern: /(^|[^\w.-])(?:\w+|<[\w$-]+>)(?=\()/,
            lookbehind: true
        },
        field: {
            pattern: /[\w$]+(?=:)/,
            alias: 'variable'
        },
        register: {
            pattern: /(^|[^\w.-])[vp]\d(?![\w.-])/,
            lookbehind: true,
            alias: 'variable'
        },
        boolean: {
            pattern: /(^|[^\w.-])(?:false|true)(?![\w.-])/,
            lookbehind: true
        },
        number: {
            pattern: /(^|[^/\w.-])-?(?:NAN|INFINITY|0x(?:[\dA-F]+(?:\.[\dA-F]*)?|\.[\dA-F]+)(?:p[+-]?[\dA-F]+)?|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?)[dflst]?(?![\w.-])/i,
            lookbehind: true
        },
        label: {
            pattern: /(:)\w+/,
            lookbehind: true,
            alias: 'property'
        },
        operator: /->|\.\.|[\[=]/,
        punctuation: /[{}(),;:]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $a403180e6d9b6e5a$export$2e2bcd8739ae039.displayName = 'smalltalk';
$a403180e6d9b6e5a$export$2e2bcd8739ae039.aliases = [];
function $a403180e6d9b6e5a$export$2e2bcd8739ae039(Prism) {
    Prism.languages.smalltalk = {
        comment: {
            pattern: /"(?:""|[^"])*"/,
            greedy: true
        },
        char: {
            pattern: /\$./,
            greedy: true
        },
        string: {
            pattern: /'(?:''|[^'])*'/,
            greedy: true
        },
        symbol: /#[\da-z]+|#(?:-|([+\/\\*~<>=@%|&?!])\1?)|#(?=\()/i,
        'block-arguments': {
            pattern: /(\[\s*):[^\[|]*\|/,
            lookbehind: true,
            inside: {
                variable: /:[\da-z]+/i,
                punctuation: /\|/
            }
        },
        'temporary-variables': {
            pattern: /\|[^|]+\|/,
            inside: {
                variable: /[\da-z]+/i,
                punctuation: /\|/
            }
        },
        keyword: /\b(?:new|nil|self|super)\b/,
        boolean: /\b(?:false|true)\b/,
        number: [
            /\d+r-?[\dA-Z]+(?:\.[\dA-Z]+)?(?:e-?\d+)?/,
            /\b\d+(?:\.\d+)?(?:e-?\d+)?/
        ],
        operator: /[<=]=?|:=|~[~=]|\/\/?|\\\\|>[>=]?|[!^+\-*&|,@]/,
        punctuation: /[.;:?\[\](){}]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$06c969704178cca0$export$2e2bcd8739ae039.displayName = 'smarty';
$06c969704178cca0$export$2e2bcd8739ae039.aliases = [];
function $06c969704178cca0$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $a400735491c1aa4e$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.smarty = {
            comment: {
                pattern: /^\{\*[\s\S]*?\*\}/,
                greedy: true
            },
            'embedded-php': {
                pattern: /^\{php\}[\s\S]*?\{\/php\}/,
                greedy: true,
                inside: {
                    smarty: {
                        pattern: /^\{php\}|\{\/php\}$/,
                        inside: null // see below
                    },
                    php: {
                        pattern: /[\s\S]+/,
                        alias: 'language-php',
                        inside: Prism.languages.php
                    }
                }
            },
            string: [
                {
                    pattern: /"(?:\\.|[^"\\\r\n])*"/,
                    greedy: true,
                    inside: {
                        interpolation: {
                            pattern: /\{[^{}]*\}|`[^`]*`/,
                            inside: {
                                'interpolation-punctuation': {
                                    pattern: /^[{`]|[`}]$/,
                                    alias: 'punctuation'
                                },
                                expression: {
                                    pattern: /[\s\S]+/,
                                    inside: null // see below
                                }
                            }
                        },
                        variable: /\$\w+/
                    }
                },
                {
                    pattern: /'(?:\\.|[^'\\\r\n])*'/,
                    greedy: true
                }
            ],
            keyword: {
                pattern: /(^\{\/?)[a-z_]\w*\b(?!\()/i,
                lookbehind: true,
                greedy: true
            },
            delimiter: {
                pattern: /^\{\/?|\}$/,
                greedy: true,
                alias: 'punctuation'
            },
            number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
            variable: [
                /\$(?!\d)\w+/,
                /#(?!\d)\w+#/,
                {
                    pattern: /(\.|->|\w\s*=)(?!\d)\w+\b(?!\()/,
                    lookbehind: true
                },
                {
                    pattern: /(\[)(?!\d)\w+(?=\])/,
                    lookbehind: true
                }
            ],
            function: {
                pattern: /(\|\s*)@?[a-z_]\w*|\b[a-z_]\w*(?=\()/i,
                lookbehind: true
            },
            'attr-name': /\b[a-z_]\w*(?=\s*=)/i,
            boolean: /\b(?:false|no|off|on|true|yes)\b/,
            punctuation: /[\[\](){}.,:`]|->/,
            operator: [
                /[+\-*\/%]|==?=?|[!<>]=?|&&|\|\|?/,
                /\bis\s+(?:not\s+)?(?:div|even|odd)(?:\s+by)?\b/,
                /\b(?:and|eq|gt?e|gt|lt?e|lt|mod|neq?|not|or)\b/
            ]
        };
        Prism.languages.smarty['embedded-php'].inside.smarty.inside = Prism.languages.smarty;
        Prism.languages.smarty.string[0].inside.interpolation.inside.expression.inside = Prism.languages.smarty;
        var string = /"(?:\\.|[^"\\\r\n])*"|'(?:\\.|[^'\\\r\n])*'/;
        var smartyPattern = RegExp(// comments
        /\{\*[\s\S]*?\*\}/.source + '|' + // php tags
        /\{php\}[\s\S]*?\{\/php\}/.source + '|' + // smarty blocks
        /\{(?:[^{}"']|<str>|\{(?:[^{}"']|<str>|\{(?:[^{}"']|<str>)*\})*\})*\}/.source.replace(/<str>/g, function() {
            return string.source;
        }), 'g');
        // Tokenize all inline Smarty expressions
        Prism.hooks.add('before-tokenize', function(env) {
            var smartyLiteralStart = '{literal}';
            var smartyLiteralEnd = '{/literal}';
            var smartyLiteralMode = false;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'smarty', smartyPattern, function(match) {
                // Smarty tags inside {literal} block are ignored
                if (match === smartyLiteralEnd) smartyLiteralMode = false;
                if (!smartyLiteralMode) {
                    if (match === smartyLiteralStart) smartyLiteralMode = true;
                    return true;
                }
                return false;
            });
        });
        // Re-insert the tokens after tokenizing
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'smarty');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $c964236cd184e11d$export$2e2bcd8739ae039.displayName = 'sml';
$c964236cd184e11d$export$2e2bcd8739ae039.aliases = [
    'smlnj'
];
function $c964236cd184e11d$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var keywords = /\b(?:abstype|and|andalso|as|case|datatype|do|else|end|eqtype|exception|fn|fun|functor|handle|if|in|include|infix|infixr|let|local|nonfix|of|op|open|orelse|raise|rec|sharing|sig|signature|struct|structure|then|type|val|where|while|with|withtype)\b/i;
        Prism.languages.sml = {
            // allow one level of nesting
            comment: /\(\*(?:[^*(]|\*(?!\))|\((?!\*)|\(\*(?:[^*(]|\*(?!\))|\((?!\*))*\*\))*\*\)/,
            string: {
                pattern: /#?"(?:[^"\\]|\\.)*"/,
                greedy: true
            },
            'class-name': [
                {
                    // This is only an approximation since the real grammar is context-free
                    //
                    // Why the main loop so complex?
                    // The main loop is approximately the same as /(?:\s*(?:[*,]|->)\s*<TERMINAL>)*/ which is, obviously, a lot
                    // simpler. The difference is that if a comma is the last iteration of the loop, then the terminal must be
                    // followed by a long identifier.
                    pattern: RegExp(/((?:^|[^:]):\s*)<TERMINAL>(?:\s*(?:(?:\*|->)\s*<TERMINAL>|,\s*<TERMINAL>(?:(?=<NOT-LAST>)|(?!<NOT-LAST>)\s+<LONG-ID>)))*/.source.replace(/<NOT-LAST>/g, function() {
                        return /\s*(?:[*,]|->)/.source;
                    }).replace(/<TERMINAL>/g, function() {
                        return /(?:'[\w']*|<LONG-ID>|\((?:[^()]|\([^()]*\))*\)|\{(?:[^{}]|\{[^{}]*\})*\})(?:\s+<LONG-ID>)*/.source;
                    }).replace(/<LONG-ID>/g, function() {
                        return /(?!<KEYWORD>)[a-z\d_][\w'.]*/.source;
                    }).replace(/<KEYWORD>/g, function() {
                        return keywords.source;
                    }), 'i'),
                    lookbehind: true,
                    greedy: true,
                    inside: null // see below
                },
                {
                    pattern: /((?:^|[^\w'])(?:datatype|exception|functor|signature|structure|type)\s+)[a-z_][\w'.]*/i,
                    lookbehind: true
                }
            ],
            function: {
                pattern: /((?:^|[^\w'])fun\s+)[a-z_][\w'.]*/i,
                lookbehind: true
            },
            keyword: keywords,
            variable: {
                pattern: /(^|[^\w'])'[\w']*/,
                lookbehind: true
            },
            number: /~?\b(?:\d+(?:\.\d+)?(?:e~?\d+)?|0x[\da-f]+)\b/i,
            word: {
                pattern: /\b0w(?:\d+|x[\da-f]+)\b/i,
                alias: 'constant'
            },
            boolean: /\b(?:false|true)\b/i,
            operator: /\.\.\.|:[>=:]|=>?|->|[<>]=?|[!+\-*/^#|@~]/,
            punctuation: /[(){}\[\].:,;]/
        };
        Prism.languages.sml['class-name'][0].inside = Prism.languages.sml;
        Prism.languages.smlnj = Prism.languages.sml;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$7a0bad4c5f491fc6$export$2e2bcd8739ae039.displayName = 'solidity';
$7a0bad4c5f491fc6$export$2e2bcd8739ae039.aliases = [
    'sol'
];
function $7a0bad4c5f491fc6$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    Prism.languages.solidity = Prism.languages.extend('clike', {
        'class-name': {
            pattern: /(\b(?:contract|enum|interface|library|new|struct|using)\s+)(?!\d)[\w$]+/,
            lookbehind: true
        },
        keyword: /\b(?:_|anonymous|as|assembly|assert|break|calldata|case|constant|constructor|continue|contract|default|delete|do|else|emit|enum|event|external|for|from|function|if|import|indexed|inherited|interface|internal|is|let|library|mapping|memory|modifier|new|payable|pragma|private|public|pure|require|returns?|revert|selfdestruct|solidity|storage|struct|suicide|switch|this|throw|using|var|view|while)\b/,
        operator: /=>|->|:=|=:|\*\*|\+\+|--|\|\||&&|<<=?|>>=?|[-+*/%^&|<>!=]=?|[~?]/
    });
    Prism.languages.insertBefore('solidity', 'keyword', {
        builtin: /\b(?:address|bool|byte|u?int(?:8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?|string|bytes(?:[1-9]|[12]\d|3[0-2])?)\b/
    });
    Prism.languages.insertBefore('solidity', 'number', {
        version: {
            pattern: /([<>]=?|\^)\d+\.\d+\.\d+\b/,
            lookbehind: true,
            alias: 'number'
        }
    });
    Prism.languages.sol = Prism.languages.solidity;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $294be4aa5b92251c$export$2e2bcd8739ae039.displayName = 'solution-file';
$294be4aa5b92251c$export$2e2bcd8739ae039.aliases = [
    'sln'
];
function $294be4aa5b92251c$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var guid = {
            // https://en.wikipedia.org/wiki/Universally_unique_identifier#Format
            pattern: /\{[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}\}/i,
            alias: 'constant',
            inside: {
                punctuation: /[{}]/
            }
        };
        Prism.languages['solution-file'] = {
            comment: {
                pattern: /#.*/,
                greedy: true
            },
            string: {
                pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
                greedy: true,
                inside: {
                    guid: guid
                }
            },
            object: {
                // Foo
                //   Bar("abs") = 9
                //   EndBar
                //   Prop = TRUE
                // EndFoo
                pattern: /^([ \t]*)(?:([A-Z]\w*)\b(?=.*(?:\r\n?|\n)(?:\1[ \t].*(?:\r\n?|\n))*\1End\2(?=[ \t]*$))|End[A-Z]\w*(?=[ \t]*$))/m,
                lookbehind: true,
                greedy: true,
                alias: 'keyword'
            },
            property: {
                pattern: /^([ \t]*)(?!\s)[^\r\n"#=()]*[^\s"#=()](?=\s*=)/m,
                lookbehind: true,
                inside: {
                    guid: guid
                }
            },
            guid: guid,
            number: /\b\d+(?:\.\d+)*\b/,
            boolean: /\b(?:FALSE|TRUE)\b/,
            operator: /=/,
            punctuation: /[(),]/
        };
        Prism.languages['sln'] = Prism.languages['solution-file'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$a2bb05d986dace6b$export$2e2bcd8739ae039.displayName = 'soy';
$a2bb05d986dace6b$export$2e2bcd8739ae039.aliases = [];
function $a2bb05d986dace6b$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $a400735491c1aa4e$export$2e2bcd8739ae039));
    (function(Prism) {
        var stringPattern = /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/;
        var numberPattern = /\b\d+(?:\.\d+)?(?:[eE][+-]?\d+)?\b|\b0x[\dA-F]+\b/;
        Prism.languages.soy = {
            comment: [
                /\/\*[\s\S]*?\*\//,
                {
                    pattern: /(\s)\/\/.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            'command-arg': {
                pattern: /(\{+\/?\s*(?:alias|call|delcall|delpackage|deltemplate|namespace|template)\s+)\.?[\w.]+/,
                lookbehind: true,
                alias: 'string',
                inside: {
                    punctuation: /\./
                }
            },
            parameter: {
                pattern: /(\{+\/?\s*@?param\??\s+)\.?[\w.]+/,
                lookbehind: true,
                alias: 'variable'
            },
            keyword: [
                {
                    pattern: /(\{+\/?[^\S\r\n]*)(?:\\[nrt]|alias|call|case|css|default|delcall|delpackage|deltemplate|else(?:if)?|fallbackmsg|for(?:each)?|if(?:empty)?|lb|let|literal|msg|namespace|nil|@?param\??|rb|sp|switch|template|xid)/,
                    lookbehind: true
                },
                /\b(?:any|as|attributes|bool|css|float|html|in|int|js|list|map|null|number|string|uri)\b/
            ],
            delimiter: {
                pattern: /^\{+\/?|\/?\}+$/,
                alias: 'punctuation'
            },
            property: /\w+(?==)/,
            variable: {
                pattern: /\$[^\W\d]\w*(?:\??(?:\.\w+|\[[^\]]+\]))*/,
                inside: {
                    string: {
                        pattern: stringPattern,
                        greedy: true
                    },
                    number: numberPattern,
                    punctuation: /[\[\].?]/
                }
            },
            string: {
                pattern: stringPattern,
                greedy: true
            },
            function: [
                /\w+(?=\()/,
                {
                    pattern: /(\|[^\S\r\n]*)\w+/,
                    lookbehind: true
                }
            ],
            boolean: /\b(?:false|true)\b/,
            number: numberPattern,
            operator: /\?:?|<=?|>=?|==?|!=|[+*/%-]|\b(?:and|not|or)\b/,
            punctuation: /[{}()\[\]|.,:]/
        };
        // Tokenize all inline Soy expressions
        Prism.hooks.add('before-tokenize', function(env) {
            var soyPattern = /\{\{.+?\}\}|\{.+?\}|\s\/\/.*|\/\*[\s\S]*?\*\//g;
            var soyLitteralStart = '{literal}';
            var soyLitteralEnd = '{/literal}';
            var soyLitteralMode = false;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'soy', soyPattern, function(match) {
                // Soy tags inside {literal} block are ignored
                if (match === soyLitteralEnd) soyLitteralMode = false;
                if (!soyLitteralMode) {
                    if (match === soyLitteralStart) soyLitteralMode = true;
                    return true;
                }
                return false;
            });
        });
        // Re-insert the tokens after tokenizing
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'soy');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $1848b7039ce8121b$export$2e2bcd8739ae039.displayName = 'turtle';
$1848b7039ce8121b$export$2e2bcd8739ae039.aliases = [
    'trig'
];
function $1848b7039ce8121b$export$2e2bcd8739ae039(Prism) {
    Prism.languages.turtle = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        'multiline-string': {
            pattern: /"""(?:(?:""?)?(?:[^"\\]|\\.))*"""|'''(?:(?:''?)?(?:[^'\\]|\\.))*'''/,
            greedy: true,
            alias: 'string',
            inside: {
                comment: /#.*/
            }
        },
        string: {
            pattern: /"(?:[^\\"\r\n]|\\.)*"|'(?:[^\\'\r\n]|\\.)*'/,
            greedy: true
        },
        url: {
            pattern: /<(?:[^\x00-\x20<>"{}|^`\\]|\\(?:u[\da-fA-F]{4}|U[\da-fA-F]{8}))*>/,
            greedy: true,
            inside: {
                punctuation: /[<>]/
            }
        },
        function: {
            pattern: /(?:(?![-.\d\xB7])[-.\w\xB7\xC0-\uFFFD]+)?:(?:(?![-.])(?:[-.:\w\xC0-\uFFFD]|%[\da-f]{2}|\\.)+)?/i,
            inside: {
                'local-name': {
                    pattern: /([^:]*:)[\s\S]+/,
                    lookbehind: true
                },
                prefix: {
                    pattern: /[\s\S]+/,
                    inside: {
                        punctuation: /:/
                    }
                }
            }
        },
        number: /[+-]?\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
        punctuation: /[{}.,;()[\]]|\^\^/,
        boolean: /\b(?:false|true)\b/,
        keyword: [
            /(?:\ba|@prefix|@base)\b|=/,
            /\b(?:base|graph|prefix)\b/i
        ],
        tag: {
            pattern: /@[a-z]+(?:-[a-z\d]+)*/i,
            inside: {
                punctuation: /@/
            }
        }
    };
    Prism.languages.trig = Prism.languages['turtle'];
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$9d31fc816d6fcc6c$export$2e2bcd8739ae039.displayName = 'sparql';
$9d31fc816d6fcc6c$export$2e2bcd8739ae039.aliases = [
    'rq'
];
function $9d31fc816d6fcc6c$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $1848b7039ce8121b$export$2e2bcd8739ae039));
    Prism.languages.sparql = Prism.languages.extend('turtle', {
        boolean: /\b(?:false|true)\b/i,
        variable: {
            pattern: /[?$]\w+/,
            greedy: true
        }
    });
    Prism.languages.insertBefore('sparql', 'punctuation', {
        keyword: [
            /\b(?:A|ADD|ALL|AS|ASC|ASK|BNODE|BY|CLEAR|CONSTRUCT|COPY|CREATE|DATA|DEFAULT|DELETE|DESC|DESCRIBE|DISTINCT|DROP|EXISTS|FILTER|FROM|GROUP|HAVING|INSERT|INTO|LIMIT|LOAD|MINUS|MOVE|NAMED|NOT|NOW|OFFSET|OPTIONAL|ORDER|RAND|REDUCED|SELECT|SEPARATOR|SERVICE|SILENT|STRUUID|UNION|USING|UUID|VALUES|WHERE)\b/i,
            /\b(?:ABS|AVG|BIND|BOUND|CEIL|COALESCE|CONCAT|CONTAINS|COUNT|DATATYPE|DAY|ENCODE_FOR_URI|FLOOR|GROUP_CONCAT|HOURS|IF|IRI|isBLANK|isIRI|isLITERAL|isNUMERIC|isURI|LANG|LANGMATCHES|LCASE|MAX|MD5|MIN|MINUTES|MONTH|REGEX|REPLACE|ROUND|sameTerm|SAMPLE|SECONDS|SHA1|SHA256|SHA384|SHA512|STR|STRAFTER|STRBEFORE|STRDT|STRENDS|STRLANG|STRLEN|STRSTARTS|SUBSTR|SUM|TIMEZONE|TZ|UCASE|URI|YEAR)\b(?=\s*\()/i,
            /\b(?:BASE|GRAPH|PREFIX)\b/i
        ]
    });
    Prism.languages.rq = Prism.languages.sparql;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $b378706f71f4008e$export$2e2bcd8739ae039.displayName = 'splunk-spl';
$b378706f71f4008e$export$2e2bcd8739ae039.aliases = [];
function $b378706f71f4008e$export$2e2bcd8739ae039(Prism) {
    Prism.languages['splunk-spl'] = {
        comment: /`comment\("(?:\\.|[^\\"])*"\)`/,
        string: {
            pattern: /"(?:\\.|[^\\"])*"/,
            greedy: true
        },
        // https://docs.splunk.com/Documentation/Splunk/7.3.0/SearchReference/ListOfSearchCommands
        keyword: /\b(?:abstract|accum|addcoltotals|addinfo|addtotals|analyzefields|anomalies|anomalousvalue|anomalydetection|append|appendcols|appendcsv|appendlookup|appendpipe|arules|associate|audit|autoregress|bin|bucket|bucketdir|chart|cluster|cofilter|collect|concurrency|contingency|convert|correlate|datamodel|dbinspect|dedup|delete|delta|diff|erex|eval|eventcount|eventstats|extract|fieldformat|fields|fieldsummary|filldown|fillnull|findtypes|folderize|foreach|format|from|gauge|gentimes|geom|geomfilter|geostats|head|highlight|history|iconify|input|inputcsv|inputlookup|iplocation|join|kmeans|kv|kvform|loadjob|localize|localop|lookup|makecontinuous|makemv|makeresults|map|mcollect|metadata|metasearch|meventcollect|mstats|multikv|multisearch|mvcombine|mvexpand|nomv|outlier|outputcsv|outputlookup|outputtext|overlap|pivot|predict|rangemap|rare|regex|relevancy|reltime|rename|replace|rest|return|reverse|rex|rtorder|run|savedsearch|script|scrub|search|searchtxn|selfjoin|sendemail|set|setfields|sichart|sirare|sistats|sitimechart|sitop|sort|spath|stats|strcat|streamstats|table|tags|tail|timechart|timewrap|top|transaction|transpose|trendline|tscollect|tstats|typeahead|typelearner|typer|union|uniq|untable|where|x11|xmlkv|xmlunescape|xpath|xyseries)\b/i,
        'operator-word': {
            pattern: /\b(?:and|as|by|not|or|xor)\b/i,
            alias: 'operator'
        },
        function: /\b\w+(?=\s*\()/,
        property: /\b\w+(?=\s*=(?!=))/,
        date: {
            // MM/DD/YYYY(:HH:MM:SS)?
            pattern: /\b\d{1,2}\/\d{1,2}\/\d{1,4}(?:(?::\d{1,2}){3})?\b/,
            alias: 'number'
        },
        number: /\b\d+(?:\.\d+)?\b/,
        boolean: /\b(?:f|false|t|true)\b/i,
        operator: /[<>=]=?|[-+*/%|]/,
        punctuation: /[()[\],]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$f2508382838b5b34$export$2e2bcd8739ae039.displayName = 'sqf';
$f2508382838b5b34$export$2e2bcd8739ae039.aliases = [];
function $f2508382838b5b34$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    Prism.languages.sqf = Prism.languages.extend('clike', {
        string: {
            pattern: /"(?:(?:"")?[^"])*"(?!")|'(?:[^'])*'/,
            greedy: true
        },
        keyword: /\b(?:breakOut|breakTo|call|case|catch|default|do|echo|else|execFSM|execVM|exitWith|for|forEach|forEachMember|forEachMemberAgent|forEachMemberTeam|from|goto|if|nil|preprocessFile|preprocessFileLineNumbers|private|scopeName|spawn|step|switch|then|throw|to|try|while|with)\b/i,
        boolean: /\b(?:false|true)\b/i,
        function: /\b(?:abs|accTime|acos|action|actionIDs|actionKeys|actionKeysImages|actionKeysNames|actionKeysNamesArray|actionName|actionParams|activateAddons|activatedAddons|activateKey|add3DENConnection|add3DENEventHandler|add3DENLayer|addAction|addBackpack|addBackpackCargo|addBackpackCargoGlobal|addBackpackGlobal|addCamShake|addCuratorAddons|addCuratorCameraArea|addCuratorEditableObjects|addCuratorEditingArea|addCuratorPoints|addEditorObject|addEventHandler|addForce|addForceGeneratorRTD|addGoggles|addGroupIcon|addHandgunItem|addHeadgear|addItem|addItemCargo|addItemCargoGlobal|addItemPool|addItemToBackpack|addItemToUniform|addItemToVest|addLiveStats|addMagazine|addMagazineAmmoCargo|addMagazineCargo|addMagazineCargoGlobal|addMagazineGlobal|addMagazinePool|addMagazines|addMagazineTurret|addMenu|addMenuItem|addMissionEventHandler|addMPEventHandler|addMusicEventHandler|addOwnedMine|addPlayerScores|addPrimaryWeaponItem|addPublicVariableEventHandler|addRating|addResources|addScore|addScoreSide|addSecondaryWeaponItem|addSwitchableUnit|addTeamMember|addToRemainsCollector|addTorque|addUniform|addVehicle|addVest|addWaypoint|addWeapon|addWeaponCargo|addWeaponCargoGlobal|addWeaponGlobal|addWeaponItem|addWeaponPool|addWeaponTurret|admin|agent|agents|AGLToASL|aimedAtTarget|aimPos|airDensityCurveRTD|airDensityRTD|airplaneThrottle|airportSide|AISFinishHeal|alive|all3DENEntities|allAirports|allControls|allCurators|allCutLayers|allDead|allDeadMen|allDisplays|allGroups|allMapMarkers|allMines|allMissionObjects|allow3DMode|allowCrewInImmobile|allowCuratorLogicIgnoreAreas|allowDamage|allowDammage|allowFileOperations|allowFleeing|allowGetIn|allowSprint|allPlayers|allSimpleObjects|allSites|allTurrets|allUnits|allUnitsUAV|allVariables|ammo|ammoOnPylon|animate|animateBay|animateDoor|animatePylon|animateSource|animationNames|animationPhase|animationSourcePhase|animationState|append|apply|armoryPoints|arrayIntersect|asin|ASLToAGL|ASLToATL|assert|assignAsCargo|assignAsCargoIndex|assignAsCommander|assignAsDriver|assignAsGunner|assignAsTurret|assignCurator|assignedCargo|assignedCommander|assignedDriver|assignedGunner|assignedItems|assignedTarget|assignedTeam|assignedVehicle|assignedVehicleRole|assignItem|assignTeam|assignToAirport|atan|atan2|atg|ATLToASL|attachedObject|attachedObjects|attachedTo|attachObject|attachTo|attackEnabled|backpack|backpackCargo|backpackContainer|backpackItems|backpackMagazines|backpackSpaceFor|behaviour|benchmark|binocular|blufor|boundingBox|boundingBoxReal|boundingCenter|briefingName|buildingExit|buildingPos|buldozer_EnableRoadDiag|buldozer_IsEnabledRoadDiag|buldozer_LoadNewRoads|buldozer_reloadOperMap|buttonAction|buttonSetAction|cadetMode|callExtension|camCommand|camCommit|camCommitPrepared|camCommitted|camConstuctionSetParams|camCreate|camDestroy|cameraEffect|cameraEffectEnableHUD|cameraInterest|cameraOn|cameraView|campaignConfigFile|camPreload|camPreloaded|camPrepareBank|camPrepareDir|camPrepareDive|camPrepareFocus|camPrepareFov|camPrepareFovRange|camPreparePos|camPrepareRelPos|camPrepareTarget|camSetBank|camSetDir|camSetDive|camSetFocus|camSetFov|camSetFovRange|camSetPos|camSetRelPos|camSetTarget|camTarget|camUseNVG|canAdd|canAddItemToBackpack|canAddItemToUniform|canAddItemToVest|cancelSimpleTaskDestination|canFire|canMove|canSlingLoad|canStand|canSuspend|canTriggerDynamicSimulation|canUnloadInCombat|canVehicleCargo|captive|captiveNum|cbChecked|cbSetChecked|ceil|channelEnabled|cheatsEnabled|checkAIFeature|checkVisibility|civilian|className|clear3DENAttribute|clear3DENInventory|clearAllItemsFromBackpack|clearBackpackCargo|clearBackpackCargoGlobal|clearForcesRTD|clearGroupIcons|clearItemCargo|clearItemCargoGlobal|clearItemPool|clearMagazineCargo|clearMagazineCargoGlobal|clearMagazinePool|clearOverlay|clearRadio|clearVehicleInit|clearWeaponCargo|clearWeaponCargoGlobal|clearWeaponPool|clientOwner|closeDialog|closeDisplay|closeOverlay|collapseObjectTree|collect3DENHistory|collectiveRTD|combatMode|commandArtilleryFire|commandChat|commander|commandFire|commandFollow|commandFSM|commandGetOut|commandingMenu|commandMove|commandRadio|commandStop|commandSuppressiveFire|commandTarget|commandWatch|comment|commitOverlay|compile|compileFinal|completedFSM|composeText|configClasses|configFile|configHierarchy|configName|configNull|configProperties|configSourceAddonList|configSourceMod|configSourceModList|confirmSensorTarget|connectTerminalToUAV|controlNull|controlsGroupCtrl|copyFromClipboard|copyToClipboard|copyWaypoints|cos|count|countEnemy|countFriendly|countSide|countType|countUnknown|create3DENComposition|create3DENEntity|createAgent|createCenter|createDialog|createDiaryLink|createDiaryRecord|createDiarySubject|createDisplay|createGearDialog|createGroup|createGuardedPoint|createLocation|createMarker|createMarkerLocal|createMenu|createMine|createMissionDisplay|createMPCampaignDisplay|createSimpleObject|createSimpleTask|createSite|createSoundSource|createTask|createTeam|createTrigger|createUnit|createVehicle|createVehicleCrew|createVehicleLocal|crew|ctAddHeader|ctAddRow|ctClear|ctCurSel|ctData|ctFindHeaderRows|ctFindRowHeader|ctHeaderControls|ctHeaderCount|ctRemoveHeaders|ctRemoveRows|ctrlActivate|ctrlAddEventHandler|ctrlAngle|ctrlAutoScrollDelay|ctrlAutoScrollRewind|ctrlAutoScrollSpeed|ctrlChecked|ctrlClassName|ctrlCommit|ctrlCommitted|ctrlCreate|ctrlDelete|ctrlEnable|ctrlEnabled|ctrlFade|ctrlHTMLLoaded|ctrlIDC|ctrlIDD|ctrlMapAnimAdd|ctrlMapAnimClear|ctrlMapAnimCommit|ctrlMapAnimDone|ctrlMapCursor|ctrlMapMouseOver|ctrlMapScale|ctrlMapScreenToWorld|ctrlMapWorldToScreen|ctrlModel|ctrlModelDirAndUp|ctrlModelScale|ctrlParent|ctrlParentControlsGroup|ctrlPosition|ctrlRemoveAllEventHandlers|ctrlRemoveEventHandler|ctrlScale|ctrlSetActiveColor|ctrlSetAngle|ctrlSetAutoScrollDelay|ctrlSetAutoScrollRewind|ctrlSetAutoScrollSpeed|ctrlSetBackgroundColor|ctrlSetChecked|ctrlSetDisabledColor|ctrlSetEventHandler|ctrlSetFade|ctrlSetFocus|ctrlSetFont|ctrlSetFontH1|ctrlSetFontH1B|ctrlSetFontH2|ctrlSetFontH2B|ctrlSetFontH3|ctrlSetFontH3B|ctrlSetFontH4|ctrlSetFontH4B|ctrlSetFontH5|ctrlSetFontH5B|ctrlSetFontH6|ctrlSetFontH6B|ctrlSetFontHeight|ctrlSetFontHeightH1|ctrlSetFontHeightH2|ctrlSetFontHeightH3|ctrlSetFontHeightH4|ctrlSetFontHeightH5|ctrlSetFontHeightH6|ctrlSetFontHeightSecondary|ctrlSetFontP|ctrlSetFontPB|ctrlSetFontSecondary|ctrlSetForegroundColor|ctrlSetModel|ctrlSetModelDirAndUp|ctrlSetModelScale|ctrlSetPixelPrecision|ctrlSetPosition|ctrlSetScale|ctrlSetStructuredText|ctrlSetText|ctrlSetTextColor|ctrlSetTextColorSecondary|ctrlSetTextSecondary|ctrlSetTooltip|ctrlSetTooltipColorBox|ctrlSetTooltipColorShade|ctrlSetTooltipColorText|ctrlShow|ctrlShown|ctrlText|ctrlTextHeight|ctrlTextSecondary|ctrlTextWidth|ctrlType|ctrlVisible|ctRowControls|ctRowCount|ctSetCurSel|ctSetData|ctSetHeaderTemplate|ctSetRowTemplate|ctSetValue|ctValue|curatorAddons|curatorCamera|curatorCameraArea|curatorCameraAreaCeiling|curatorCoef|curatorEditableObjects|curatorEditingArea|curatorEditingAreaType|curatorMouseOver|curatorPoints|curatorRegisteredObjects|curatorSelected|curatorWaypointCost|current3DENOperation|currentChannel|currentCommand|currentMagazine|currentMagazineDetail|currentMagazineDetailTurret|currentMagazineTurret|currentMuzzle|currentNamespace|currentTask|currentTasks|currentThrowable|currentVisionMode|currentWaypoint|currentWeapon|currentWeaponMode|currentWeaponTurret|currentZeroing|cursorObject|cursorTarget|customChat|customRadio|cutFadeOut|cutObj|cutRsc|cutText|damage|date|dateToNumber|daytime|deActivateKey|debriefingText|debugFSM|debugLog|deg|delete3DENEntities|deleteAt|deleteCenter|deleteCollection|deleteEditorObject|deleteGroup|deleteGroupWhenEmpty|deleteIdentity|deleteLocation|deleteMarker|deleteMarkerLocal|deleteRange|deleteResources|deleteSite|deleteStatus|deleteTeam|deleteVehicle|deleteVehicleCrew|deleteWaypoint|detach|detectedMines|diag_activeMissionFSMs|diag_activeScripts|diag_activeSQFScripts|diag_activeSQSScripts|diag_captureFrame|diag_captureFrameToFile|diag_captureSlowFrame|diag_codePerformance|diag_drawMode|diag_dynamicSimulationEnd|diag_enable|diag_enabled|diag_fps|diag_fpsMin|diag_frameNo|diag_lightNewLoad|diag_list|diag_log|diag_logSlowFrame|diag_mergeConfigFile|diag_recordTurretLimits|diag_setLightNew|diag_tickTime|diag_toggle|dialog|diarySubjectExists|didJIP|didJIPOwner|difficulty|difficultyEnabled|difficultyEnabledRTD|difficultyOption|direction|directSay|disableAI|disableCollisionWith|disableConversation|disableDebriefingStats|disableMapIndicators|disableNVGEquipment|disableRemoteSensors|disableSerialization|disableTIEquipment|disableUAVConnectability|disableUserInput|displayAddEventHandler|displayCtrl|displayNull|displayParent|displayRemoveAllEventHandlers|displayRemoveEventHandler|displaySetEventHandler|dissolveTeam|distance|distance2D|distanceSqr|distributionRegion|do3DENAction|doArtilleryFire|doFire|doFollow|doFSM|doGetOut|doMove|doorPhase|doStop|doSuppressiveFire|doTarget|doWatch|drawArrow|drawEllipse|drawIcon|drawIcon3D|drawLine|drawLine3D|drawLink|drawLocation|drawPolygon|drawRectangle|drawTriangle|driver|drop|dynamicSimulationDistance|dynamicSimulationDistanceCoef|dynamicSimulationEnabled|dynamicSimulationSystemEnabled|east|edit3DENMissionAttributes|editObject|editorSetEventHandler|effectiveCommander|emptyPositions|enableAI|enableAIFeature|enableAimPrecision|enableAttack|enableAudioFeature|enableAutoStartUpRTD|enableAutoTrimRTD|enableCamShake|enableCaustics|enableChannel|enableCollisionWith|enableCopilot|enableDebriefingStats|enableDiagLegend|enableDynamicSimulation|enableDynamicSimulationSystem|enableEndDialog|enableEngineArtillery|enableEnvironment|enableFatigue|enableGunLights|enableInfoPanelComponent|enableIRLasers|enableMimics|enablePersonTurret|enableRadio|enableReload|enableRopeAttach|enableSatNormalOnDetail|enableSaving|enableSentences|enableSimulation|enableSimulationGlobal|enableStamina|enableStressDamage|enableTeamSwitch|enableTraffic|enableUAVConnectability|enableUAVWaypoints|enableVehicleCargo|enableVehicleSensor|enableWeaponDisassembly|endl|endLoadingScreen|endMission|engineOn|enginesIsOnRTD|enginesPowerRTD|enginesRpmRTD|enginesTorqueRTD|entities|environmentEnabled|estimatedEndServerTime|estimatedTimeLeft|evalObjectArgument|everyBackpack|everyContainer|exec|execEditorScript|exp|expectedDestination|exportJIPMessages|eyeDirection|eyePos|face|faction|fadeMusic|fadeRadio|fadeSound|fadeSpeech|failMission|fillWeaponsFromPool|find|findCover|findDisplay|findEditorObject|findEmptyPosition|findEmptyPositionReady|findIf|findNearestEnemy|finishMissionInit|finite|fire|fireAtTarget|firstBackpack|flag|flagAnimationPhase|flagOwner|flagSide|flagTexture|fleeing|floor|flyInHeight|flyInHeightASL|fog|fogForecast|fogParams|forceAddUniform|forceAtPositionRTD|forcedMap|forceEnd|forceFlagTexture|forceFollowRoad|forceGeneratorRTD|forceMap|forceRespawn|forceSpeed|forceWalk|forceWeaponFire|forceWeatherChange|forgetTarget|format|formation|formationDirection|formationLeader|formationMembers|formationPosition|formationTask|formatText|formLeader|freeLook|fromEditor|fuel|fullCrew|gearIDCAmmoCount|gearSlotAmmoCount|gearSlotData|get3DENActionState|get3DENAttribute|get3DENCamera|get3DENConnections|get3DENEntity|get3DENEntityID|get3DENGrid|get3DENIconsVisible|get3DENLayerEntities|get3DENLinesVisible|get3DENMissionAttribute|get3DENMouseOver|get3DENSelected|getAimingCoef|getAllEnvSoundControllers|getAllHitPointsDamage|getAllOwnedMines|getAllSoundControllers|getAmmoCargo|getAnimAimPrecision|getAnimSpeedCoef|getArray|getArtilleryAmmo|getArtilleryComputerSettings|getArtilleryETA|getAssignedCuratorLogic|getAssignedCuratorUnit|getBackpackCargo|getBleedingRemaining|getBurningValue|getCameraViewDirection|getCargoIndex|getCenterOfMass|getClientState|getClientStateNumber|getCompatiblePylonMagazines|getConnectedUAV|getContainerMaxLoad|getCursorObjectParams|getCustomAimCoef|getDammage|getDescription|getDir|getDirVisual|getDLCAssetsUsage|getDLCAssetsUsageByName|getDLCs|getDLCUsageTime|getEditorCamera|getEditorMode|getEditorObjectScope|getElevationOffset|getEngineTargetRpmRTD|getEnvSoundController|getFatigue|getFieldManualStartPage|getForcedFlagTexture|getFriend|getFSMVariable|getFuelCargo|getGroupIcon|getGroupIconParams|getGroupIcons|getHideFrom|getHit|getHitIndex|getHitPointDamage|getItemCargo|getMagazineCargo|getMarkerColor|getMarkerPos|getMarkerSize|getMarkerType|getMass|getMissionConfig|getMissionConfigValue|getMissionDLCs|getMissionLayerEntities|getMissionLayers|getModelInfo|getMousePosition|getMusicPlayedTime|getNumber|getObjectArgument|getObjectChildren|getObjectDLC|getObjectMaterials|getObjectProxy|getObjectTextures|getObjectType|getObjectViewDistance|getOxygenRemaining|getPersonUsedDLCs|getPilotCameraDirection|getPilotCameraPosition|getPilotCameraRotation|getPilotCameraTarget|getPlateNumber|getPlayerChannel|getPlayerScores|getPlayerUID|getPlayerUIDOld|getPos|getPosASL|getPosASLVisual|getPosASLW|getPosATL|getPosATLVisual|getPosVisual|getPosWorld|getPylonMagazines|getRelDir|getRelPos|getRemoteSensorsDisabled|getRepairCargo|getResolution|getRotorBrakeRTD|getShadowDistance|getShotParents|getSlingLoad|getSoundController|getSoundControllerResult|getSpeed|getStamina|getStatValue|getSuppression|getTerrainGrid|getTerrainHeightASL|getText|getTotalDLCUsageTime|getTrimOffsetRTD|getUnitLoadout|getUnitTrait|getUserMFDText|getUserMFDValue|getVariable|getVehicleCargo|getWeaponCargo|getWeaponSway|getWingsOrientationRTD|getWingsPositionRTD|getWPPos|glanceAt|globalChat|globalRadio|goggles|group|groupChat|groupFromNetId|groupIconSelectable|groupIconsVisible|groupId|groupOwner|groupRadio|groupSelectedUnits|groupSelectUnit|grpNull|gunner|gusts|halt|handgunItems|handgunMagazine|handgunWeapon|handsHit|hasInterface|hasPilotCamera|hasWeapon|hcAllGroups|hcGroupParams|hcLeader|hcRemoveAllGroups|hcRemoveGroup|hcSelected|hcSelectGroup|hcSetGroup|hcShowBar|hcShownBar|headgear|hideBody|hideObject|hideObjectGlobal|hideSelection|hint|hintC|hintCadet|hintSilent|hmd|hostMission|htmlLoad|HUDMovementLevels|humidity|image|importAllGroups|importance|in|inArea|inAreaArray|incapacitatedState|independent|inflame|inflamed|infoPanel|infoPanelComponentEnabled|infoPanelComponents|infoPanels|inGameUISetEventHandler|inheritsFrom|initAmbientLife|inPolygon|inputAction|inRangeOfArtillery|insertEditorObject|intersect|is3DEN|is3DENMultiplayer|isAbleToBreathe|isAgent|isAimPrecisionEnabled|isArray|isAutoHoverOn|isAutonomous|isAutoStartUpEnabledRTD|isAutotest|isAutoTrimOnRTD|isBleeding|isBurning|isClass|isCollisionLightOn|isCopilotEnabled|isDamageAllowed|isDedicated|isDLCAvailable|isEngineOn|isEqualTo|isEqualType|isEqualTypeAll|isEqualTypeAny|isEqualTypeArray|isEqualTypeParams|isFilePatchingEnabled|isFlashlightOn|isFlatEmpty|isForcedWalk|isFormationLeader|isGroupDeletedWhenEmpty|isHidden|isInRemainsCollector|isInstructorFigureEnabled|isIRLaserOn|isKeyActive|isKindOf|isLaserOn|isLightOn|isLocalized|isManualFire|isMarkedForCollection|isMultiplayer|isMultiplayerSolo|isNil|isNull|isNumber|isObjectHidden|isObjectRTD|isOnRoad|isPipEnabled|isPlayer|isRealTime|isRemoteExecuted|isRemoteExecutedJIP|isServer|isShowing3DIcons|isSimpleObject|isSprintAllowed|isStaminaEnabled|isSteamMission|isStreamFriendlyUIEnabled|isStressDamageEnabled|isText|isTouchingGround|isTurnedOut|isTutHintsEnabled|isUAVConnectable|isUAVConnected|isUIContext|isUniformAllowed|isVehicleCargo|isVehicleRadarOn|isVehicleSensorEnabled|isWalking|isWeaponDeployed|isWeaponRested|itemCargo|items|itemsWithMagazines|join|joinAs|joinAsSilent|joinSilent|joinString|kbAddDatabase|kbAddDatabaseTargets|kbAddTopic|kbHasTopic|kbReact|kbRemoveTopic|kbTell|kbWasSaid|keyImage|keyName|knowsAbout|land|landAt|landResult|language|laserTarget|lbAdd|lbClear|lbColor|lbColorRight|lbCurSel|lbData|lbDelete|lbIsSelected|lbPicture|lbPictureRight|lbSelection|lbSetColor|lbSetColorRight|lbSetCurSel|lbSetData|lbSetPicture|lbSetPictureColor|lbSetPictureColorDisabled|lbSetPictureColorSelected|lbSetPictureRight|lbSetPictureRightColor|lbSetPictureRightColorDisabled|lbSetPictureRightColorSelected|lbSetSelectColor|lbSetSelectColorRight|lbSetSelected|lbSetText|lbSetTextRight|lbSetTooltip|lbSetValue|lbSize|lbSort|lbSortByValue|lbText|lbTextRight|lbValue|leader|leaderboardDeInit|leaderboardGetRows|leaderboardInit|leaderboardRequestRowsFriends|leaderboardRequestRowsGlobal|leaderboardRequestRowsGlobalAroundUser|leaderboardsRequestUploadScore|leaderboardsRequestUploadScoreKeepBest|leaderboardState|leaveVehicle|libraryCredits|libraryDisclaimers|lifeState|lightAttachObject|lightDetachObject|lightIsOn|lightnings|limitSpeed|linearConversion|lineBreak|lineIntersects|lineIntersectsObjs|lineIntersectsSurfaces|lineIntersectsWith|linkItem|list|listObjects|listRemoteTargets|listVehicleSensors|ln|lnbAddArray|lnbAddColumn|lnbAddRow|lnbClear|lnbColor|lnbColorRight|lnbCurSelRow|lnbData|lnbDeleteColumn|lnbDeleteRow|lnbGetColumnsPosition|lnbPicture|lnbPictureRight|lnbSetColor|lnbSetColorRight|lnbSetColumnsPos|lnbSetCurSelRow|lnbSetData|lnbSetPicture|lnbSetPictureColor|lnbSetPictureColorRight|lnbSetPictureColorSelected|lnbSetPictureColorSelectedRight|lnbSetPictureRight|lnbSetText|lnbSetTextRight|lnbSetValue|lnbSize|lnbSort|lnbSortByValue|lnbText|lnbTextRight|lnbValue|load|loadAbs|loadBackpack|loadFile|loadGame|loadIdentity|loadMagazine|loadOverlay|loadStatus|loadUniform|loadVest|local|localize|locationNull|locationPosition|lock|lockCameraTo|lockCargo|lockDriver|locked|lockedCargo|lockedDriver|lockedTurret|lockIdentity|lockTurret|lockWP|log|logEntities|logNetwork|logNetworkTerminate|lookAt|lookAtPos|magazineCargo|magazines|magazinesAllTurrets|magazinesAmmo|magazinesAmmoCargo|magazinesAmmoFull|magazinesDetail|magazinesDetailBackpack|magazinesDetailUniform|magazinesDetailVest|magazinesTurret|magazineTurretAmmo|mapAnimAdd|mapAnimClear|mapAnimCommit|mapAnimDone|mapCenterOnCamera|mapGridPosition|markAsFinishedOnSteam|markerAlpha|markerBrush|markerColor|markerDir|markerPos|markerShape|markerSize|markerText|markerType|max|members|menuAction|menuAdd|menuChecked|menuClear|menuCollapse|menuData|menuDelete|menuEnable|menuEnabled|menuExpand|menuHover|menuPicture|menuSetAction|menuSetCheck|menuSetData|menuSetPicture|menuSetValue|menuShortcut|menuShortcutText|menuSize|menuSort|menuText|menuURL|menuValue|min|mineActive|mineDetectedBy|missionConfigFile|missionDifficulty|missionName|missionNamespace|missionStart|missionVersion|modelToWorld|modelToWorldVisual|modelToWorldVisualWorld|modelToWorldWorld|modParams|moonIntensity|moonPhase|morale|move|move3DENCamera|moveInAny|moveInCargo|moveInCommander|moveInDriver|moveInGunner|moveInTurret|moveObjectToEnd|moveOut|moveTime|moveTo|moveToCompleted|moveToFailed|musicVolume|name|nameSound|nearEntities|nearestBuilding|nearestLocation|nearestLocations|nearestLocationWithDubbing|nearestObject|nearestObjects|nearestTerrainObjects|nearObjects|nearObjectsReady|nearRoads|nearSupplies|nearTargets|needReload|netId|netObjNull|newOverlay|nextMenuItemIndex|nextWeatherChange|nMenuItems|numberOfEnginesRTD|numberToDate|objectCurators|objectFromNetId|objectParent|objNull|objStatus|onBriefingGear|onBriefingGroup|onBriefingNotes|onBriefingPlan|onBriefingTeamSwitch|onCommandModeChanged|onDoubleClick|onEachFrame|onGroupIconClick|onGroupIconOverEnter|onGroupIconOverLeave|onHCGroupSelectionChanged|onMapSingleClick|onPlayerConnected|onPlayerDisconnected|onPreloadFinished|onPreloadStarted|onShowNewObject|onTeamSwitch|openCuratorInterface|openDLCPage|openDSInterface|openMap|openSteamApp|openYoutubeVideo|opfor|orderGetIn|overcast|overcastForecast|owner|param|params|parseNumber|parseSimpleArray|parseText|parsingNamespace|particlesQuality|pi|pickWeaponPool|pitch|pixelGrid|pixelGridBase|pixelGridNoUIScale|pixelH|pixelW|playableSlotsNumber|playableUnits|playAction|playActionNow|player|playerRespawnTime|playerSide|playersNumber|playGesture|playMission|playMove|playMoveNow|playMusic|playScriptedMission|playSound|playSound3D|position|positionCameraToWorld|posScreenToWorld|posWorldToScreen|ppEffectAdjust|ppEffectCommit|ppEffectCommitted|ppEffectCreate|ppEffectDestroy|ppEffectEnable|ppEffectEnabled|ppEffectForceInNVG|precision|preloadCamera|preloadObject|preloadSound|preloadTitleObj|preloadTitleRsc|primaryWeapon|primaryWeaponItems|primaryWeaponMagazine|priority|processDiaryLink|processInitCommands|productVersion|profileName|profileNamespace|profileNameSteam|progressLoadingScreen|progressPosition|progressSetPosition|publicVariable|publicVariableClient|publicVariableServer|pushBack|pushBackUnique|putWeaponPool|queryItemsPool|queryMagazinePool|queryWeaponPool|rad|radioChannelAdd|radioChannelCreate|radioChannelRemove|radioChannelSetCallSign|radioChannelSetLabel|radioVolume|rain|rainbow|random|rank|rankId|rating|rectangular|registeredTasks|registerTask|reload|reloadEnabled|remoteControl|remoteExec|remoteExecCall|remoteExecutedOwner|remove3DENConnection|remove3DENEventHandler|remove3DENLayer|removeAction|removeAll3DENEventHandlers|removeAllActions|removeAllAssignedItems|removeAllContainers|removeAllCuratorAddons|removeAllCuratorCameraAreas|removeAllCuratorEditingAreas|removeAllEventHandlers|removeAllHandgunItems|removeAllItems|removeAllItemsWithMagazines|removeAllMissionEventHandlers|removeAllMPEventHandlers|removeAllMusicEventHandlers|removeAllOwnedMines|removeAllPrimaryWeaponItems|removeAllWeapons|removeBackpack|removeBackpackGlobal|removeCuratorAddons|removeCuratorCameraArea|removeCuratorEditableObjects|removeCuratorEditingArea|removeDrawIcon|removeDrawLinks|removeEventHandler|removeFromRemainsCollector|removeGoggles|removeGroupIcon|removeHandgunItem|removeHeadgear|removeItem|removeItemFromBackpack|removeItemFromUniform|removeItemFromVest|removeItems|removeMagazine|removeMagazineGlobal|removeMagazines|removeMagazinesTurret|removeMagazineTurret|removeMenuItem|removeMissionEventHandler|removeMPEventHandler|removeMusicEventHandler|removeOwnedMine|removePrimaryWeaponItem|removeSecondaryWeaponItem|removeSimpleTask|removeSwitchableUnit|removeTeamMember|removeUniform|removeVest|removeWeapon|removeWeaponAttachmentCargo|removeWeaponCargo|removeWeaponGlobal|removeWeaponTurret|reportRemoteTarget|requiredVersion|resetCamShake|resetSubgroupDirection|resistance|resize|resources|respawnVehicle|restartEditorCamera|reveal|revealMine|reverse|reversedMouseY|roadAt|roadsConnectedTo|roleDescription|ropeAttachedObjects|ropeAttachedTo|ropeAttachEnabled|ropeAttachTo|ropeCreate|ropeCut|ropeDestroy|ropeDetach|ropeEndPosition|ropeLength|ropes|ropeUnwind|ropeUnwound|rotorsForcesRTD|rotorsRpmRTD|round|runInitScript|safeZoneH|safeZoneW|safeZoneWAbs|safeZoneX|safeZoneXAbs|safeZoneY|save3DENInventory|saveGame|saveIdentity|saveJoysticks|saveOverlay|saveProfileNamespace|saveStatus|saveVar|savingEnabled|say|say2D|say3D|score|scoreSide|screenshot|screenToWorld|scriptDone|scriptName|scriptNull|scudState|secondaryWeapon|secondaryWeaponItems|secondaryWeaponMagazine|select|selectBestPlaces|selectDiarySubject|selectedEditorObjects|selectEditorObject|selectionNames|selectionPosition|selectLeader|selectMax|selectMin|selectNoPlayer|selectPlayer|selectRandom|selectRandomWeighted|selectWeapon|selectWeaponTurret|sendAUMessage|sendSimpleCommand|sendTask|sendTaskResult|sendUDPMessage|serverCommand|serverCommandAvailable|serverCommandExecutable|serverName|serverTime|set|set3DENAttribute|set3DENAttributes|set3DENGrid|set3DENIconsVisible|set3DENLayer|set3DENLinesVisible|set3DENLogicType|set3DENMissionAttribute|set3DENMissionAttributes|set3DENModelsVisible|set3DENObjectType|set3DENSelected|setAccTime|setActualCollectiveRTD|setAirplaneThrottle|setAirportSide|setAmmo|setAmmoCargo|setAmmoOnPylon|setAnimSpeedCoef|setAperture|setApertureNew|setArmoryPoints|setAttributes|setAutonomous|setBehaviour|setBleedingRemaining|setBrakesRTD|setCameraInterest|setCamShakeDefParams|setCamShakeParams|setCamUseTI|setCaptive|setCenterOfMass|setCollisionLight|setCombatMode|setCompassOscillation|setConvoySeparation|setCuratorCameraAreaCeiling|setCuratorCoef|setCuratorEditingAreaType|setCuratorWaypointCost|setCurrentChannel|setCurrentTask|setCurrentWaypoint|setCustomAimCoef|setCustomWeightRTD|setDamage|setDammage|setDate|setDebriefingText|setDefaultCamera|setDestination|setDetailMapBlendPars|setDir|setDirection|setDrawIcon|setDriveOnPath|setDropInterval|setDynamicSimulationDistance|setDynamicSimulationDistanceCoef|setEditorMode|setEditorObjectScope|setEffectCondition|setEngineRpmRTD|setFace|setFaceAnimation|setFatigue|setFeatureType|setFlagAnimationPhase|setFlagOwner|setFlagSide|setFlagTexture|setFog|setForceGeneratorRTD|setFormation|setFormationTask|setFormDir|setFriend|setFromEditor|setFSMVariable|setFuel|setFuelCargo|setGroupIcon|setGroupIconParams|setGroupIconsSelectable|setGroupIconsVisible|setGroupId|setGroupIdGlobal|setGroupOwner|setGusts|setHideBehind|setHit|setHitIndex|setHitPointDamage|setHorizonParallaxCoef|setHUDMovementLevels|setIdentity|setImportance|setInfoPanel|setLeader|setLightAmbient|setLightAttenuation|setLightBrightness|setLightColor|setLightDayLight|setLightFlareMaxDistance|setLightFlareSize|setLightIntensity|setLightnings|setLightUseFlare|setLocalWindParams|setMagazineTurretAmmo|setMarkerAlpha|setMarkerAlphaLocal|setMarkerBrush|setMarkerBrushLocal|setMarkerColor|setMarkerColorLocal|setMarkerDir|setMarkerDirLocal|setMarkerPos|setMarkerPosLocal|setMarkerShape|setMarkerShapeLocal|setMarkerSize|setMarkerSizeLocal|setMarkerText|setMarkerTextLocal|setMarkerType|setMarkerTypeLocal|setMass|setMimic|setMousePosition|setMusicEffect|setMusicEventHandler|setName|setNameSound|setObjectArguments|setObjectMaterial|setObjectMaterialGlobal|setObjectProxy|setObjectTexture|setObjectTextureGlobal|setObjectViewDistance|setOvercast|setOwner|setOxygenRemaining|setParticleCircle|setParticleClass|setParticleFire|setParticleParams|setParticleRandom|setPilotCameraDirection|setPilotCameraRotation|setPilotCameraTarget|setPilotLight|setPiPEffect|setPitch|setPlateNumber|setPlayable|setPlayerRespawnTime|setPos|setPosASL|setPosASL2|setPosASLW|setPosATL|setPosition|setPosWorld|setPylonLoadOut|setPylonsPriority|setRadioMsg|setRain|setRainbow|setRandomLip|setRank|setRectangular|setRepairCargo|setRotorBrakeRTD|setShadowDistance|setShotParents|setSide|setSimpleTaskAlwaysVisible|setSimpleTaskCustomData|setSimpleTaskDescription|setSimpleTaskDestination|setSimpleTaskTarget|setSimpleTaskType|setSimulWeatherLayers|setSize|setSkill|setSlingLoad|setSoundEffect|setSpeaker|setSpeech|setSpeedMode|setStamina|setStaminaScheme|setStatValue|setSuppression|setSystemOfUnits|setTargetAge|setTaskMarkerOffset|setTaskResult|setTaskState|setTerrainGrid|setText|setTimeMultiplier|setTitleEffect|setToneMapping|setToneMappingParams|setTrafficDensity|setTrafficDistance|setTrafficGap|setTrafficSpeed|setTriggerActivation|setTriggerArea|setTriggerStatements|setTriggerText|setTriggerTimeout|setTriggerType|setType|setUnconscious|setUnitAbility|setUnitLoadout|setUnitPos|setUnitPosWeak|setUnitRank|setUnitRecoilCoefficient|setUnitTrait|setUnloadInCombat|setUserActionText|setUserMFDText|setUserMFDValue|setVariable|setVectorDir|setVectorDirAndUp|setVectorUp|setVehicleAmmo|setVehicleAmmoDef|setVehicleArmor|setVehicleCargo|setVehicleId|setVehicleInit|setVehicleLock|setVehiclePosition|setVehicleRadar|setVehicleReceiveRemoteTargets|setVehicleReportOwnPosition|setVehicleReportRemoteTargets|setVehicleTIPars|setVehicleVarName|setVelocity|setVelocityModelSpace|setVelocityTransformation|setViewDistance|setVisibleIfTreeCollapsed|setWantedRpmRTD|setWaves|setWaypointBehaviour|setWaypointCombatMode|setWaypointCompletionRadius|setWaypointDescription|setWaypointForceBehaviour|setWaypointFormation|setWaypointHousePosition|setWaypointLoiterRadius|setWaypointLoiterType|setWaypointName|setWaypointPosition|setWaypointScript|setWaypointSpeed|setWaypointStatements|setWaypointTimeout|setWaypointType|setWaypointVisible|setWeaponReloadingTime|setWind|setWindDir|setWindForce|setWindStr|setWingForceScaleRTD|setWPPos|show3DIcons|showChat|showCinemaBorder|showCommandingMenu|showCompass|showCuratorCompass|showGPS|showHUD|showLegend|showMap|shownArtilleryComputer|shownChat|shownCompass|shownCuratorCompass|showNewEditorObject|shownGPS|shownHUD|shownMap|shownPad|shownRadio|shownScoretable|shownUAVFeed|shownWarrant|shownWatch|showPad|showRadio|showScoretable|showSubtitles|showUAVFeed|showWarrant|showWatch|showWaypoint|showWaypoints|side|sideAmbientLife|sideChat|sideEmpty|sideEnemy|sideFriendly|sideLogic|sideRadio|sideUnknown|simpleTasks|simulationEnabled|simulCloudDensity|simulCloudOcclusion|simulInClouds|simulWeatherSync|sin|size|sizeOf|skill|skillFinal|skipTime|sleep|sliderPosition|sliderRange|sliderSetPosition|sliderSetRange|sliderSetSpeed|sliderSpeed|slingLoadAssistantShown|soldierMagazines|someAmmo|sort|soundVolume|speaker|speed|speedMode|splitString|sqrt|squadParams|stance|startLoadingScreen|stop|stopEngineRTD|stopped|str|sunOrMoon|supportInfo|suppressFor|surfaceIsWater|surfaceNormal|surfaceType|swimInDepth|switchableUnits|switchAction|switchCamera|switchGesture|switchLight|switchMove|synchronizedObjects|synchronizedTriggers|synchronizedWaypoints|synchronizeObjectsAdd|synchronizeObjectsRemove|synchronizeTrigger|synchronizeWaypoint|systemChat|systemOfUnits|tan|targetKnowledge|targets|targetsAggregate|targetsQuery|taskAlwaysVisible|taskChildren|taskCompleted|taskCustomData|taskDescription|taskDestination|taskHint|taskMarkerOffset|taskNull|taskParent|taskResult|taskState|taskType|teamMember|teamMemberNull|teamName|teams|teamSwitch|teamSwitchEnabled|teamType|terminate|terrainIntersect|terrainIntersectASL|terrainIntersectAtASL|text|textLog|textLogFormat|tg|time|timeMultiplier|titleCut|titleFadeOut|titleObj|titleRsc|titleText|toArray|toFixed|toLower|toString|toUpper|triggerActivated|triggerActivation|triggerArea|triggerAttachedVehicle|triggerAttachObject|triggerAttachVehicle|triggerDynamicSimulation|triggerStatements|triggerText|triggerTimeout|triggerTimeoutCurrent|triggerType|turretLocal|turretOwner|turretUnit|tvAdd|tvClear|tvCollapse|tvCollapseAll|tvCount|tvCurSel|tvData|tvDelete|tvExpand|tvExpandAll|tvPicture|tvPictureRight|tvSetColor|tvSetCurSel|tvSetData|tvSetPicture|tvSetPictureColor|tvSetPictureColorDisabled|tvSetPictureColorSelected|tvSetPictureRight|tvSetPictureRightColor|tvSetPictureRightColorDisabled|tvSetPictureRightColorSelected|tvSetSelectColor|tvSetText|tvSetTooltip|tvSetValue|tvSort|tvSortByValue|tvText|tvTooltip|tvValue|type|typeName|typeOf|UAVControl|uiNamespace|uiSleep|unassignCurator|unassignItem|unassignTeam|unassignVehicle|underwater|uniform|uniformContainer|uniformItems|uniformMagazines|unitAddons|unitAimPosition|unitAimPositionVisual|unitBackpack|unitIsUAV|unitPos|unitReady|unitRecoilCoefficient|units|unitsBelowHeight|unlinkItem|unlockAchievement|unregisterTask|updateDrawIcon|updateMenuItem|updateObjectTree|useAIOperMapObstructionTest|useAISteeringComponent|useAudioTimeForMoves|userInputDisabled|vectorAdd|vectorCos|vectorCrossProduct|vectorDiff|vectorDir|vectorDirVisual|vectorDistance|vectorDistanceSqr|vectorDotProduct|vectorFromTo|vectorMagnitude|vectorMagnitudeSqr|vectorModelToWorld|vectorModelToWorldVisual|vectorMultiply|vectorNormalized|vectorUp|vectorUpVisual|vectorWorldToModel|vectorWorldToModelVisual|vehicle|vehicleCargoEnabled|vehicleChat|vehicleRadio|vehicleReceiveRemoteTargets|vehicleReportOwnPosition|vehicleReportRemoteTargets|vehicles|vehicleVarName|velocity|velocityModelSpace|verifySignature|vest|vestContainer|vestItems|vestMagazines|viewDistance|visibleCompass|visibleGPS|visibleMap|visiblePosition|visiblePositionASL|visibleScoretable|visibleWatch|waitUntil|waves|waypointAttachedObject|waypointAttachedVehicle|waypointAttachObject|waypointAttachVehicle|waypointBehaviour|waypointCombatMode|waypointCompletionRadius|waypointDescription|waypointForceBehaviour|waypointFormation|waypointHousePosition|waypointLoiterRadius|waypointLoiterType|waypointName|waypointPosition|waypoints|waypointScript|waypointsEnabledUAV|waypointShow|waypointSpeed|waypointStatements|waypointTimeout|waypointTimeoutCurrent|waypointType|waypointVisible|weaponAccessories|weaponAccessoriesCargo|weaponCargo|weaponDirection|weaponInertia|weaponLowered|weapons|weaponsItems|weaponsItemsCargo|weaponState|weaponsTurret|weightRTD|west|WFSideText|wind|windDir|windRTD|windStr|wingsForcesRTD|worldName|worldSize|worldToModel|worldToModelVisual|worldToScreen)\b/i,
        number: /(?:\$|\b0x)[\da-f]+\b|(?:\B\.\d+|\b\d+(?:\.\d+)?)(?:e[+-]?\d+)?\b/i,
        operator: /##|>>|&&|\|\||[!=<>]=?|[-+*/%#^]|\b(?:and|mod|not|or)\b/i,
        'magic-variable': {
            pattern: /\b(?:this|thisList|thisTrigger|_exception|_fnc_scriptName|_fnc_scriptNameParent|_forEachIndex|_this|_thisEventHandler|_thisFSM|_thisScript|_x)\b/i,
            alias: 'keyword'
        },
        constant: /\bDIK(?:_[a-z\d]+)+\b/i
    });
    Prism.languages.insertBefore('sqf', 'string', {
        macro: {
            pattern: /(^[ \t]*)#[a-z](?:[^\r\n\\]|\\(?:\r\n|[\s\S]))*/im,
            lookbehind: true,
            greedy: true,
            alias: 'property',
            inside: {
                directive: {
                    pattern: /#[a-z]+\b/i,
                    alias: 'keyword'
                },
                comment: Prism.languages.sqf.comment
            }
        }
    });
    delete Prism.languages.sqf['class-name'];
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$ef926d412abc34a9$export$2e2bcd8739ae039.displayName = 'squirrel';
$ef926d412abc34a9$export$2e2bcd8739ae039.aliases = [];
function $ef926d412abc34a9$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    Prism.languages.squirrel = Prism.languages.extend('clike', {
        comment: [
            Prism.languages.clike['comment'][0],
            {
                pattern: /(^|[^\\:])(?:\/\/|#).*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(^|[^\\"'@])(?:@"(?:[^"]|"")*"(?!")|"(?:[^\\\r\n"]|\\.)*")/,
            lookbehind: true,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:class|enum|extends|instanceof)\s+)\w+(?:\.\w+)*/,
            lookbehind: true,
            inside: {
                punctuation: /\./
            }
        },
        keyword: /\b(?:__FILE__|__LINE__|base|break|case|catch|class|clone|const|constructor|continue|default|delete|else|enum|extends|for|foreach|function|if|in|instanceof|local|null|resume|return|static|switch|this|throw|try|typeof|while|yield)\b/,
        number: /\b(?:0x[0-9a-fA-F]+|\d+(?:\.(?:\d+|[eE][+-]?\d+))?)\b/,
        operator: /\+\+|--|<=>|<[-<]|>>>?|&&?|\|\|?|[-+*/%!=<>]=?|[~^]|::?/,
        punctuation: /[(){}\[\],;.]/
    });
    Prism.languages.insertBefore('squirrel', 'string', {
        char: {
            pattern: /(^|[^\\"'])'(?:[^\\']|\\(?:[xuU][0-9a-fA-F]{0,8}|[\s\S]))'/,
            lookbehind: true,
            greedy: true
        }
    });
    Prism.languages.insertBefore('squirrel', 'operator', {
        'attribute-punctuation': {
            pattern: /<\/|\/>/,
            alias: 'important'
        },
        lambda: {
            pattern: /@(?=\()/,
            alias: 'operator'
        }
    });
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $e656c717edb0fe18$export$2e2bcd8739ae039.displayName = 'stan';
$e656c717edb0fe18$export$2e2bcd8739ae039.aliases = [];
function $e656c717edb0fe18$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // https://mc-stan.org/docs/2_28/reference-manual/bnf-grammars.html
        var higherOrderFunctions = /\b(?:algebra_solver|algebra_solver_newton|integrate_1d|integrate_ode|integrate_ode_bdf|integrate_ode_rk45|map_rect|ode_(?:adams|bdf|ckrk|rk45)(?:_tol)?|ode_adjoint_tol_ctl|reduce_sum|reduce_sum_static)\b/;
        Prism.languages.stan = {
            comment: /\/\/.*|\/\*[\s\S]*?\*\/|#(?!include).*/,
            string: {
                // String literals can contain spaces and any printable ASCII characters except for " and \
                // https://mc-stan.org/docs/2_24/reference-manual/print-statements-section.html#string-literals
                pattern: /"[\x20\x21\x23-\x5B\x5D-\x7E]*"/,
                greedy: true
            },
            directive: {
                pattern: /^([ \t]*)#include\b.*/m,
                lookbehind: true,
                alias: 'property'
            },
            'function-arg': {
                pattern: RegExp('(' + higherOrderFunctions.source + /\s*\(\s*/.source + ')' + /[a-zA-Z]\w*/.source),
                lookbehind: true,
                alias: 'function'
            },
            constraint: {
                pattern: /(\b(?:int|matrix|real|row_vector|vector)\s*)<[^<>]*>/,
                lookbehind: true,
                inside: {
                    expression: {
                        pattern: /(=\s*)\S(?:\S|\s+(?!\s))*?(?=\s*(?:>$|,\s*\w+\s*=))/,
                        lookbehind: true,
                        inside: null // see below
                    },
                    property: /\b[a-z]\w*(?=\s*=)/i,
                    operator: /=/,
                    punctuation: /^<|>$|,/
                }
            },
            keyword: [
                {
                    pattern: /\bdata(?=\s*\{)|\b(?:functions|generated|model|parameters|quantities|transformed)\b/,
                    alias: 'program-block'
                },
                /\b(?:array|break|cholesky_factor_corr|cholesky_factor_cov|complex|continue|corr_matrix|cov_matrix|data|else|for|if|in|increment_log_prob|int|matrix|ordered|positive_ordered|print|real|reject|return|row_vector|simplex|target|unit_vector|vector|void|while)\b/,
                // these are functions that are known to take another function as their first argument.
                higherOrderFunctions
            ],
            function: /\b[a-z]\w*(?=\s*\()/i,
            number: /(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:E[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
            boolean: /\b(?:false|true)\b/,
            operator: /<-|\.[*/]=?|\|\|?|&&|[!=<>+\-*/]=?|['^%~?:]/,
            punctuation: /[()\[\]{},;]/
        };
        Prism.languages.stan.constraint.inside.expression.inside = Prism.languages.stan;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 


$95debfda020aeb85$export$2e2bcd8739ae039.displayName = 'stata';
$95debfda020aeb85$export$2e2bcd8739ae039.aliases = [];
function $95debfda020aeb85$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $68ea9a70b77f88ea$export$2e2bcd8739ae039));
    Prism.register((0, $896766ac97cf30fc$export$2e2bcd8739ae039));
    Prism.register((0, $166c94860a240118$export$2e2bcd8739ae039));
    // https://www.stata.com/manuals/u.pdf
    // https://www.stata.com/manuals/p.pdf
    Prism.languages.stata = {
        comment: [
            {
                pattern: /(^[ \t]*)\*.*/m,
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|\s)\/\/.*|\/\*[\s\S]*?\*\//,
                lookbehind: true,
                greedy: true
            }
        ],
        'string-literal': {
            pattern: /"[^"\r\n]*"|[‘`']".*?"[’`']/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /\$\{[^{}]*\}|[‘`']\w[^’`'\r\n]*[’`']/,
                    inside: {
                        punctuation: /^\$\{|\}$/,
                        expression: {
                            pattern: /[\s\S]+/,
                            inside: null // see below
                        }
                    }
                },
                string: /[\s\S]+/
            }
        },
        mata: {
            pattern: /(^[ \t]*mata[ \t]*:)[\s\S]+?(?=^end\b)/m,
            lookbehind: true,
            greedy: true,
            alias: 'language-mata',
            inside: Prism.languages.mata
        },
        java: {
            pattern: /(^[ \t]*java[ \t]*:)[\s\S]+?(?=^end\b)/m,
            lookbehind: true,
            greedy: true,
            alias: 'language-java',
            inside: Prism.languages.java
        },
        python: {
            pattern: /(^[ \t]*python[ \t]*:)[\s\S]+?(?=^end\b)/m,
            lookbehind: true,
            greedy: true,
            alias: 'language-python',
            inside: Prism.languages.python
        },
        command: {
            pattern: /(^[ \t]*(?:\.[ \t]+)?(?:(?:bayes|bootstrap|by|bysort|capture|collect|fmm|fp|frame|jackknife|mfp|mi|nestreg|noisily|permute|quietly|rolling|simulate|statsby|stepwise|svy|version|xi)\b[^:\r\n]*:[ \t]*|(?:capture|noisily|quietly|version)[ \t]+)?)[a-zA-Z]\w*/m,
            lookbehind: true,
            greedy: true,
            alias: 'keyword'
        },
        variable: /\$\w+|[‘`']\w[^’`'\r\n]*[’`']/,
        keyword: /\b(?:bayes|bootstrap|by|bysort|capture|clear|collect|fmm|fp|frame|if|in|jackknife|mi[ \t]+estimate|mfp|nestreg|noisily|of|permute|quietly|rolling|simulate|sort|statsby|stepwise|svy|varlist|version|xi)\b/,
        boolean: /\b(?:off|on)\b/,
        number: /\b\d+(?:\.\d+)?\b|\B\.\d+/,
        function: /\b[a-z_]\w*(?=\()/i,
        operator: /\+\+|--|##?|[<>!=~]=?|[+\-*^&|/]/,
        punctuation: /[(){}[\],:]/
    };
    Prism.languages.stata['string-literal'].inside.interpolation.inside.expression.inside = Prism.languages.stata;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $4d275be294286983$export$2e2bcd8739ae039.displayName = 'iecst';
$4d275be294286983$export$2e2bcd8739ae039.aliases = [];
function $4d275be294286983$export$2e2bcd8739ae039(Prism) {
    Prism.languages.iecst = {
        comment: [
            {
                pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\(\*[\s\S]*?(?:\*\)|$)|\{[\s\S]*?(?:\}|$))/,
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        keyword: [
            /\b(?:END_)?(?:PROGRAM|CONFIGURATION|INTERFACE|FUNCTION_BLOCK|FUNCTION|ACTION|TRANSITION|TYPE|STRUCT|(?:INITIAL_)?STEP|NAMESPACE|LIBRARY|CHANNEL|FOLDER|RESOURCE|VAR_(?:ACCESS|CONFIG|EXTERNAL|GLOBAL|INPUT|IN_OUT|OUTPUT|TEMP)|VAR|METHOD|PROPERTY)\b/i,
            /\b(?:AT|BY|(?:END_)?(?:CASE|FOR|IF|REPEAT|WHILE)|CONSTANT|CONTINUE|DO|ELSE|ELSIF|EXIT|EXTENDS|FROM|GET|GOTO|IMPLEMENTS|JMP|NON_RETAIN|OF|PRIVATE|PROTECTED|PUBLIC|RETAIN|RETURN|SET|TASK|THEN|TO|UNTIL|USING|WITH|__CATCH|__ENDTRY|__FINALLY|__TRY)\b/
        ],
        'class-name': /\b(?:ANY|ARRAY|BOOL|BYTE|U?(?:D|L|S)?INT|(?:D|L)?WORD|DATE(?:_AND_TIME)?|DT|L?REAL|POINTER|STRING|TIME(?:_OF_DAY)?|TOD)\b/,
        address: {
            pattern: /%[IQM][XBWDL][\d.]*|%[IQ][\d.]*/,
            alias: 'symbol'
        },
        number: /\b(?:16#[\da-f]+|2#[01_]+|0x[\da-f]+)\b|\b(?:D|DT|T|TOD)#[\d_shmd:]*|\b[A-Z]*#[\d.,_]*|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
        boolean: /\b(?:FALSE|NULL|TRUE)\b/,
        operator: /S?R?:?=>?|&&?|\*\*?|<[=>]?|>=?|[-:^/+#]|\b(?:AND|EQ|EXPT|GE|GT|LE|LT|MOD|NE|NOT|OR|XOR)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        punctuation: /[()[\].,;]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $81adf7b0e724d48d$export$2e2bcd8739ae039.displayName = 'supercollider';
$81adf7b0e724d48d$export$2e2bcd8739ae039.aliases = [
    'sclang'
];
function $81adf7b0e724d48d$export$2e2bcd8739ae039(Prism) {
    Prism.languages.supercollider = {
        comment: {
            pattern: /\/\/.*|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\//,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])"(?:[^"\\]|\\[\s\S])*"/,
            lookbehind: true,
            greedy: true
        },
        char: {
            pattern: /\$(?:[^\\\r\n]|\\.)/,
            greedy: true
        },
        symbol: {
            pattern: /(^|[^\\])'(?:[^'\\]|\\[\s\S])*'|\\\w+/,
            lookbehind: true,
            greedy: true
        },
        keyword: /\b(?:_|arg|classvar|const|nil|var|while)\b/,
        boolean: /\b(?:false|true)\b/,
        label: {
            pattern: /\b[a-z_]\w*(?=\s*:)/,
            alias: 'property'
        },
        number: /\b(?:inf|pi|0x[0-9a-fA-F]+|\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(?:pi)?|\d+r[0-9a-zA-Z]+(?:\.[0-9a-zA-Z]+)?|\d+[sb]{1,4}\d*)\b/,
        'class-name': /\b[A-Z]\w*\b/,
        operator: /\.{2,3}|#(?![[{])|&&|[!=]==?|\+>>|\+{1,3}|-[->]|=>|>>|\?\?|@\|?@|\|(?:@|[!=]=)?\||!\?|<[!=>]|\*{1,2}|<{2,3}\*?|[-!%&/<>?@|=`]/,
        punctuation: /[{}()[\].:,;]|#[[{]/
    };
    Prism.languages.sclang = Prism.languages.supercollider;
}



// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $cfa4e33b24acc9a0$export$2e2bcd8739ae039.displayName = 'systemd';
$cfa4e33b24acc9a0$export$2e2bcd8739ae039.aliases = [];
function $cfa4e33b24acc9a0$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var comment = {
            pattern: /^[;#].*/m,
            greedy: true
        };
        var quotesSource = /"(?:[^\r\n"\\]|\\(?:[^\r]|\r\n?))*"(?!\S)/.source;
        Prism.languages.systemd = {
            comment: comment,
            section: {
                pattern: /^\[[^\n\r\[\]]*\](?=[ \t]*$)/m,
                greedy: true,
                inside: {
                    punctuation: /^\[|\]$/,
                    'section-name': {
                        pattern: /[\s\S]+/,
                        alias: 'selector'
                    }
                }
            },
            key: {
                pattern: /^[^\s=]+(?=[ \t]*=)/m,
                greedy: true,
                alias: 'attr-name'
            },
            value: {
                // This pattern is quite complex because of two properties:
                //  1) Quotes (strings) must be preceded by a space. Since we can't use lookbehinds, we have to "resolve"
                //     the lookbehind. You will see this in the main loop where spaces are handled separately.
                //  2) Line continuations.
                //     After line continuations, empty lines and comments are ignored so we have to consume them.
                pattern: RegExp(/(=[ \t]*(?!\s))/.source + // the value either starts with quotes or not
                '(?:' + quotesSource + '|(?=[^"\r\n]))' + // main loop
                '(?:' + (/[^\s\\]/.source + // handle spaces separately because of quotes
                '|' + '[ \t]+(?:(?![ \t"])|' + quotesSource + ')' + // line continuation
                '|' + /\\[\r\n]+(?:[#;].*[\r\n]+)*(?![#;])/.source) + ')*'),
                lookbehind: true,
                greedy: true,
                alias: 'attr-value',
                inside: {
                    comment: comment,
                    quoted: {
                        pattern: RegExp(/(^|\s)/.source + quotesSource),
                        lookbehind: true,
                        greedy: true
                    },
                    punctuation: /\\$/m,
                    boolean: {
                        pattern: /^(?:false|no|off|on|true|yes)$/,
                        greedy: true
                    }
                }
            },
            punctuation: /=/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $51899036da79c505$export$2e2bcd8739ae039.displayName = 't4-templating';
$51899036da79c505$export$2e2bcd8739ae039.aliases = [];
function $51899036da79c505$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        function createBlock(prefix, inside, contentAlias) {
            return {
                pattern: RegExp('<#' + prefix + '[\\s\\S]*?#>'),
                alias: 'block',
                inside: {
                    delimiter: {
                        pattern: RegExp('^<#' + prefix + '|#>$'),
                        alias: 'important'
                    },
                    content: {
                        pattern: /[\s\S]+/,
                        inside: inside,
                        alias: contentAlias
                    }
                }
            };
        }
        function createT4(insideLang) {
            var grammar = Prism.languages[insideLang];
            var className = 'language-' + insideLang;
            return {
                block: {
                    pattern: /<#[\s\S]+?#>/,
                    inside: {
                        directive: createBlock('@', {
                            'attr-value': {
                                pattern: /=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+)/,
                                inside: {
                                    punctuation: /^=|^["']|["']$/
                                }
                            },
                            keyword: /\b\w+(?=\s)/,
                            'attr-name': /\b\w+/
                        }),
                        expression: createBlock('=', grammar, className),
                        'class-feature': createBlock('\\+', grammar, className),
                        standard: createBlock('', grammar, className)
                    }
                }
            };
        }
        Prism.languages['t4-templating'] = Object.defineProperty({}, 'createT4', {
            value: createT4
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 

$f6729417cfa54226$export$2e2bcd8739ae039.displayName = 't4-cs';
$f6729417cfa54226$export$2e2bcd8739ae039.aliases = [
    't4'
];
function $f6729417cfa54226$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $e1ab06973c0a6c0a$export$2e2bcd8739ae039));
    Prism.register((0, $51899036da79c505$export$2e2bcd8739ae039));
    Prism.languages.t4 = Prism.languages['t4-cs'] = Prism.languages['t4-templating'].createT4('csharp');
}



// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 

$20f4ee0703b4f693$export$2e2bcd8739ae039.displayName = 't4-vb';
$20f4ee0703b4f693$export$2e2bcd8739ae039.aliases = [];
function $20f4ee0703b4f693$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $51899036da79c505$export$2e2bcd8739ae039));
    Prism.register((0, $398c5bff0b970a81$export$2e2bcd8739ae039));
    Prism.languages['t4-vb'] = Prism.languages['t4-templating'].createT4('vbnet');
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$df26257a89ddaec0$export$2e2bcd8739ae039.displayName = 'tap';
$df26257a89ddaec0$export$2e2bcd8739ae039.aliases = [];
function $df26257a89ddaec0$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $d56cfd3d329eea2c$export$2e2bcd8739ae039));
    // https://en.wikipedia.org/wiki/Test_Anything_Protocol
    Prism.languages.tap = {
        fail: /not ok[^#{\n\r]*/,
        pass: /ok[^#{\n\r]*/,
        pragma: /pragma [+-][a-z]+/,
        bailout: /bail out!.*/i,
        version: /TAP version \d+/i,
        plan: /\b\d+\.\.\d+(?: +#.*)?/,
        subtest: {
            pattern: /# Subtest(?:: .*)?/,
            greedy: true
        },
        punctuation: /[{}]/,
        directive: /#.*/,
        yamlish: {
            pattern: /(^[ \t]*)---[\s\S]*?[\r\n][ \t]*\.\.\.$/m,
            lookbehind: true,
            inside: Prism.languages.yaml,
            alias: 'language-yaml'
        }
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $d7ef411c4285b1f9$export$2e2bcd8739ae039.displayName = 'tcl';
$d7ef411c4285b1f9$export$2e2bcd8739ae039.aliases = [];
function $d7ef411c4285b1f9$export$2e2bcd8739ae039(Prism) {
    Prism.languages.tcl = {
        comment: {
            pattern: /(^|[^\\])#.*/,
            lookbehind: true
        },
        string: {
            pattern: /"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*"/,
            greedy: true
        },
        variable: [
            {
                pattern: /(\$)(?:::)?(?:[a-zA-Z0-9]+::)*\w+/,
                lookbehind: true
            },
            {
                pattern: /(\$)\{[^}]+\}/,
                lookbehind: true
            },
            {
                pattern: /(^[\t ]*set[ \t]+)(?:::)?(?:[a-zA-Z0-9]+::)*\w+/m,
                lookbehind: true
            }
        ],
        function: {
            pattern: /(^[\t ]*proc[ \t]+)\S+/m,
            lookbehind: true
        },
        builtin: [
            {
                pattern: /(^[\t ]*)(?:break|class|continue|error|eval|exit|for|foreach|if|proc|return|switch|while)\b/m,
                lookbehind: true
            },
            /\b(?:else|elseif)\b/
        ],
        scope: {
            pattern: /(^[\t ]*)(?:global|upvar|variable)\b/m,
            lookbehind: true,
            alias: 'constant'
        },
        keyword: {
            pattern: /(^[\t ]*|\[)(?:Safe_Base|Tcl|after|append|apply|array|auto_(?:execok|import|load|mkindex|qualify|reset)|automkindex_old|bgerror|binary|catch|cd|chan|clock|close|concat|dde|dict|encoding|eof|exec|expr|fblocked|fconfigure|fcopy|file(?:event|name)?|flush|gets|glob|history|http|incr|info|interp|join|lappend|lassign|lindex|linsert|list|llength|load|lrange|lrepeat|lreplace|lreverse|lsearch|lset|lsort|math(?:func|op)|memory|msgcat|namespace|open|package|parray|pid|pkg_mkIndex|platform|puts|pwd|re_syntax|read|refchan|regexp|registry|regsub|rename|scan|seek|set|socket|source|split|string|subst|tcl(?:_endOfWord|_findLibrary|startOf(?:Next|Previous)Word|test|vars|wordBreak(?:After|Before))|tell|time|tm|trace|unknown|unload|unset|update|uplevel|vwait)\b/m,
            lookbehind: true
        },
        operator: /!=?|\*\*?|==|&&?|\|\|?|<[=<]?|>[=>]?|[-+~\/%?^]|\b(?:eq|in|ne|ni)\b/,
        punctuation: /[{}()\[\]]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 

$011c2c67b24b2834$export$2e2bcd8739ae039.displayName = 'tt2';
$011c2c67b24b2834$export$2e2bcd8739ae039.aliases = [];
function $011c2c67b24b2834$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    Prism.register((0, $a400735491c1aa4e$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.tt2 = Prism.languages.extend('clike', {
            comment: /#.*|\[%#[\s\S]*?%\]/,
            keyword: /\b(?:BLOCK|CALL|CASE|CATCH|CLEAR|DEBUG|DEFAULT|ELSE|ELSIF|END|FILTER|FINAL|FOREACH|GET|IF|IN|INCLUDE|INSERT|LAST|MACRO|META|NEXT|PERL|PROCESS|RAWPERL|RETURN|SET|STOP|SWITCH|TAGS|THROW|TRY|UNLESS|USE|WHILE|WRAPPER)\b/,
            punctuation: /[[\]{},()]/
        });
        Prism.languages.insertBefore('tt2', 'number', {
            operator: /=[>=]?|!=?|<=?|>=?|&&|\|\|?|\b(?:and|not|or)\b/,
            variable: {
                pattern: /\b[a-z]\w*(?:\s*\.\s*(?:\d+|\$?[a-z]\w*))*\b/i
            }
        });
        Prism.languages.insertBefore('tt2', 'keyword', {
            delimiter: {
                pattern: /^(?:\[%|%%)-?|-?%\]$/,
                alias: 'punctuation'
            }
        });
        Prism.languages.insertBefore('tt2', 'string', {
            'single-quoted-string': {
                pattern: /'[^\\']*(?:\\[\s\S][^\\']*)*'/,
                greedy: true,
                alias: 'string'
            },
            'double-quoted-string': {
                pattern: /"[^\\"]*(?:\\[\s\S][^\\"]*)*"/,
                greedy: true,
                alias: 'string',
                inside: {
                    variable: {
                        pattern: /\$(?:[a-z]\w*(?:\.(?:\d+|\$?[a-z]\w*))*)/i
                    }
                }
            }
        });
        // The different types of TT2 strings "replace" the C-like standard string
        delete Prism.languages.tt2.string;
        Prism.hooks.add('before-tokenize', function(env) {
            var tt2Pattern = /\[%[\s\S]+?%\]/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'tt2', tt2Pattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'tt2');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $e5a2f3fd754dcba1$export$2e2bcd8739ae039.displayName = 'toml';
$e5a2f3fd754dcba1$export$2e2bcd8739ae039.aliases = [];
function $e5a2f3fd754dcba1$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var key = /(?:[\w-]+|'[^'\n\r]*'|"(?:\\.|[^\\"\r\n])*")/.source;
        /**
     * @param {string} pattern
     */ function insertKey(pattern) {
            return pattern.replace(/__/g, function() {
                return key;
            });
        }
        Prism.languages.toml = {
            comment: {
                pattern: /#.*/,
                greedy: true
            },
            table: {
                pattern: RegExp(insertKey(/(^[\t ]*\[\s*(?:\[\s*)?)__(?:\s*\.\s*__)*(?=\s*\])/.source), 'm'),
                lookbehind: true,
                greedy: true,
                alias: 'class-name'
            },
            key: {
                pattern: RegExp(insertKey(/(^[\t ]*|[{,]\s*)__(?:\s*\.\s*__)*(?=\s*=)/.source), 'm'),
                lookbehind: true,
                greedy: true,
                alias: 'property'
            },
            string: {
                pattern: /"""(?:\\[\s\S]|[^\\])*?"""|'''[\s\S]*?'''|'[^'\n\r]*'|"(?:\\.|[^\\"\r\n])*"/,
                greedy: true
            },
            date: [
                {
                    // Offset Date-Time, Local Date-Time, Local Date
                    pattern: /\b\d{4}-\d{2}-\d{2}(?:[T\s]\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?)?\b/i,
                    alias: 'number'
                },
                {
                    // Local Time
                    pattern: /\b\d{2}:\d{2}:\d{2}(?:\.\d+)?\b/,
                    alias: 'number'
                }
            ],
            number: /(?:\b0(?:x[\da-zA-Z]+(?:_[\da-zA-Z]+)*|o[0-7]+(?:_[0-7]+)*|b[10]+(?:_[10]+)*))\b|[-+]?\b\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?\b|[-+]?\b(?:inf|nan)\b/,
            boolean: /\b(?:false|true)\b/,
            punctuation: /[.,=[\]{}]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $a36665b93fb978c8$export$2e2bcd8739ae039.displayName = 'tremor';
$a36665b93fb978c8$export$2e2bcd8739ae039.aliases = [
    'trickle',
    'troy'
];
function $a36665b93fb978c8$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.tremor = {
            comment: {
                pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
                lookbehind: true
            },
            'interpolated-string': null,
            // see below
            extractor: {
                pattern: /\b[a-z_]\w*\|(?:[^\r\n\\|]|\\(?:\r\n|[\s\S]))*\|/i,
                greedy: true,
                inside: {
                    regex: {
                        pattern: /(^re)\|[\s\S]+/,
                        lookbehind: true
                    },
                    function: /^\w+/,
                    value: /\|[\s\S]+/
                }
            },
            identifier: {
                pattern: /`[^`]*`/,
                greedy: true
            },
            function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())\b/,
            keyword: /\b(?:args|as|by|case|config|connect|connector|const|copy|create|default|define|deploy|drop|each|emit|end|erase|event|flow|fn|for|from|group|having|insert|into|intrinsic|let|links|match|merge|mod|move|of|operator|patch|pipeline|recur|script|select|set|sliding|state|stream|to|tumbling|update|use|when|where|window|with)\b/,
            boolean: /\b(?:false|null|true)\b/i,
            number: /\b(?:0b[01_]*|0x[0-9a-fA-F_]*|\d[\d_]*(?:\.\d[\d_]*)?(?:[Ee][+-]?[\d_]+)?)\b/,
            'pattern-punctuation': {
                pattern: /%(?=[({[])/,
                alias: 'punctuation'
            },
            operator: /[-+*\/%~!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?>?=?|(?:absent|and|not|or|present|xor)\b/,
            punctuation: /::|[;\[\]()\{\},.:]/
        };
        var interpolationPattern = /#\{(?:[^"{}]|\{[^{}]*\}|"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*")*\}/.source;
        Prism.languages.tremor['interpolated-string'] = {
            pattern: RegExp(/(^|[^\\])/.source + '(?:' + '"""(?:' + /[^"\\#]|\\[\s\S]|"(?!"")|#(?!\{)/.source + '|' + interpolationPattern + ')*"""' + '|' + '"(?:' + /[^"\\\r\n#]|\\(?:\r\n|[\s\S])|#(?!\{)/.source + '|' + interpolationPattern + ')*"' + ')'),
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: RegExp(interpolationPattern),
                    inside: {
                        punctuation: /^#\{|\}$/,
                        expression: {
                            pattern: /[\s\S]+/,
                            inside: Prism.languages.tremor
                        }
                    }
                },
                string: /[\s\S]+/
            }
        };
        Prism.languages.troy = Prism.languages['tremor'];
        Prism.languages.trickle = Prism.languages['tremor'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $42c1d84a70d4c560$export$2e2bcd8739ae039.displayName = 'typoscript';
$42c1d84a70d4c560$export$2e2bcd8739ae039.aliases = [
    'tsconfig'
];
function $42c1d84a70d4c560$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var keywords = /\b(?:ACT|ACTIFSUB|CARRAY|CASE|CLEARGIF|COA|COA_INT|CONSTANTS|CONTENT|CUR|EDITPANEL|EFFECT|EXT|FILE|FLUIDTEMPLATE|FORM|FRAME|FRAMESET|GIFBUILDER|GMENU|GMENU_FOLDOUT|GMENU_LAYERS|GP|HMENU|HRULER|HTML|IENV|IFSUB|IMAGE|IMGMENU|IMGMENUITEM|IMGTEXT|IMG_RESOURCE|INCLUDE_TYPOSCRIPT|JSMENU|JSMENUITEM|LLL|LOAD_REGISTER|NO|PAGE|RECORDS|RESTORE_REGISTER|TEMPLATE|TEXT|TMENU|TMENUITEM|TMENU_LAYERS|USER|USER_INT|_GIFBUILDER|global|globalString|globalVar)\b/;
        Prism.languages.typoscript = {
            comment: [
                {
                    // multiline comments /* */
                    pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                    lookbehind: true
                },
                {
                    // double-slash comments - ignored when backslashes or colon is found in front
                    // also ignored whenever directly after an equal-sign, because it would probably be an url without protocol
                    pattern: /(^|[^\\:= \t]|(?:^|[^= \t])[ \t]+)\/\/.*/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    // hash comments - ignored when leading quote is found for hex colors in strings
                    pattern: /(^|[^"'])#.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            function: [
                {
                    // old include style
                    pattern: /<INCLUDE_TYPOSCRIPT:\s*source\s*=\s*(?:"[^"\r\n]*"|'[^'\r\n]*')\s*>/,
                    inside: {
                        string: {
                            pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
                            inside: {
                                keyword: keywords
                            }
                        },
                        keyword: {
                            pattern: /INCLUDE_TYPOSCRIPT/
                        }
                    }
                },
                {
                    // new include style
                    pattern: /@import\s*(?:"[^"\r\n]*"|'[^'\r\n]*')/,
                    inside: {
                        string: /"[^"\r\n]*"|'[^'\r\n]*'/
                    }
                }
            ],
            string: {
                pattern: /^([^=]*=[< ]?)(?:(?!\]\n).)*/,
                lookbehind: true,
                inside: {
                    function: /\{\$.*\}/,
                    // constants include
                    keyword: keywords,
                    number: /^\d+$/,
                    punctuation: /[,|:]/
                }
            },
            keyword: keywords,
            number: {
                // special highlighting for indexes of arrays in tags
                pattern: /\b\d+\s*[.{=]/,
                inside: {
                    operator: /[.{=]/
                }
            },
            tag: {
                pattern: /\.?[-\w\\]+\.?/,
                inside: {
                    punctuation: /\./
                }
            },
            punctuation: /[{}[\];(),.:|]/,
            operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/
        };
        Prism.languages.tsconfig = Prism.languages.typoscript;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $e3eeeb1b10048f63$export$2e2bcd8739ae039.displayName = 'unrealscript';
$e3eeeb1b10048f63$export$2e2bcd8739ae039.aliases = [
    'uc',
    'uscript'
];
function $e3eeeb1b10048f63$export$2e2bcd8739ae039(Prism) {
    Prism.languages.unrealscript = {
        comment: /\/\/.*|\/\*[\s\S]*?\*\//,
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        category: {
            pattern: /(\b(?:(?:autoexpand|hide|show)categories|var)\s*\()[^()]+(?=\))/,
            lookbehind: true,
            greedy: true,
            alias: 'property'
        },
        metadata: {
            pattern: /(\w\s*)<\s*\w+\s*=[^<>|=\r\n]+(?:\|\s*\w+\s*=[^<>|=\r\n]+)*>/,
            lookbehind: true,
            greedy: true,
            inside: {
                property: /\b\w+(?=\s*=)/,
                operator: /=/,
                punctuation: /[<>|]/
            }
        },
        macro: {
            pattern: /`\w+/,
            alias: 'property'
        },
        'class-name': {
            pattern: /(\b(?:class|enum|extends|interface|state(?:\(\))?|struct|within)\s+)\w+/,
            lookbehind: true
        },
        keyword: /\b(?:abstract|actor|array|auto|autoexpandcategories|bool|break|byte|case|class|classgroup|client|coerce|collapsecategories|config|const|continue|default|defaultproperties|delegate|dependson|deprecated|do|dontcollapsecategories|editconst|editinlinenew|else|enum|event|exec|export|extends|final|float|for|forcescriptorder|foreach|function|goto|guid|hidecategories|hidedropdown|if|ignores|implements|inherits|input|int|interface|iterator|latent|local|material|name|native|nativereplication|noexport|nontransient|noteditinlinenew|notplaceable|operator|optional|out|pawn|perobjectconfig|perobjectlocalized|placeable|postoperator|preoperator|private|protected|reliable|replication|return|server|showcategories|simulated|singular|state|static|string|struct|structdefault|structdefaultproperties|switch|texture|transient|travel|unreliable|until|var|vector|while|within)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        boolean: /\b(?:false|true)\b/,
        number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
        // https://docs.unrealengine.com/udk/Three/UnrealScriptExpressions.html
        operator: />>|<<|--|\+\+|\*\*|[-+*/~!=<>$@]=?|&&?|\|\|?|\^\^?|[?:%]|\b(?:ClockwiseFrom|Cross|Dot)\b/,
        punctuation: /[()[\]{};,.]/
    };
    Prism.languages.uc = Prism.languages.uscript = Prism.languages.unrealscript;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $767b96663a8577d6$export$2e2bcd8739ae039.displayName = 'uorazor';
$767b96663a8577d6$export$2e2bcd8739ae039.aliases = [];
function $767b96663a8577d6$export$2e2bcd8739ae039(Prism) {
    Prism.languages.uorazor = {
        'comment-hash': {
            pattern: /#.*/,
            alias: 'comment',
            greedy: true
        },
        'comment-slash': {
            pattern: /\/\/.*/,
            alias: 'comment',
            greedy: true
        },
        string: {
            pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            inside: {
                punctuation: /^['"]|['"]$/
            },
            greedy: true
        },
        'source-layers': {
            pattern: /\b(?:arms|backpack|blue|bracelet|cancel|clear|cloak|criminal|earrings|enemy|facialhair|friend|friendly|gloves|gray|grey|ground|hair|head|innerlegs|innertorso|innocent|lefthand|middletorso|murderer|neck|nonfriendly|onehandedsecondary|outerlegs|outertorso|pants|red|righthand|ring|self|shirt|shoes|talisman|waist)\b/i,
            alias: 'function'
        },
        'source-commands': {
            pattern: /\b(?:alliance|attack|cast|clearall|clearignore|clearjournal|clearlist|clearsysmsg|createlist|createtimer|dclick|dclicktype|dclickvar|dress|dressconfig|drop|droprelloc|emote|getlabel|guild|gumpclose|gumpresponse|hotkey|ignore|lasttarget|lift|lifttype|menu|menuresponse|msg|org|organize|organizer|overhead|pause|poplist|potion|promptresponse|pushlist|removelist|removetimer|rename|restock|say|scav|scavenger|script|setability|setlasttarget|setskill|settimer|setvar|sysmsg|target|targetloc|targetrelloc|targettype|undress|unignore|unsetvar|useobject|useonce|useskill|usetype|virtue|wait|waitforgump|waitformenu|waitforprompt|waitforstat|waitforsysmsg|waitfortarget|walk|wfsysmsg|wft|whisper|yell)\b/,
            alias: 'function'
        },
        'tag-name': {
            pattern: /(^\{%-?\s*)\w+/,
            lookbehind: true,
            alias: 'keyword'
        },
        delimiter: {
            pattern: /^\{[{%]-?|-?[%}]\}$/,
            alias: 'punctuation'
        },
        function: /\b(?:atlist|close|closest|count|counter|counttype|dead|dex|diffhits|diffmana|diffstam|diffweight|find|findbuff|finddebuff|findlayer|findtype|findtypelist|followers|gumpexists|hidden|hits|hp|hue|human|humanoid|ingump|inlist|insysmessage|insysmsg|int|invul|lhandempty|list|listexists|mana|maxhits|maxhp|maxmana|maxstam|maxweight|monster|mounted|name|next|noto|paralyzed|poisoned|position|prev|previous|queued|rand|random|rhandempty|skill|stam|str|targetexists|timer|timerexists|varexist|warmode|weight)\b/,
        keyword: /\b(?:and|as|break|continue|else|elseif|endfor|endif|endwhile|for|if|loop|not|or|replay|stop|while)\b/,
        boolean: /\b(?:false|null|true)\b/,
        number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
        operator: [
            {
                pattern: /(\s)(?:and|b-and|b-or|b-xor|ends with|in|is|matches|not|or|same as|starts with)(?=\s)/,
                lookbehind: true
            },
            /[=<>]=?|!=|\*\*?|\/\/?|\?:?|[-+~%|]/
        ],
        punctuation: /[()\[\]{}:.,]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$2e5ae03d6489eb63$export$2e2bcd8739ae039.displayName = 'v';
$2e5ae03d6489eb63$export$2e2bcd8739ae039.aliases = [];
function $2e5ae03d6489eb63$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    (function(Prism) {
        var interpolationExpr = {
            pattern: /[\s\S]+/,
            inside: null
        };
        Prism.languages.v = Prism.languages.extend('clike', {
            string: {
                pattern: /r?(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
                alias: 'quoted-string',
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\{[^{}]*\}|\w+(?:\.\w+(?:\([^\(\)]*\))?|\[[^\[\]]+\])*)/,
                        lookbehind: true,
                        inside: {
                            'interpolation-variable': {
                                pattern: /^\$\w[\s\S]*$/,
                                alias: 'variable'
                            },
                            'interpolation-punctuation': {
                                pattern: /^\$\{|\}$/,
                                alias: 'punctuation'
                            },
                            'interpolation-expression': interpolationExpr
                        }
                    }
                }
            },
            'class-name': {
                pattern: /(\b(?:enum|interface|struct|type)\s+)(?:C\.)?\w+/,
                lookbehind: true
            },
            keyword: /(?:\b(?:__global|as|asm|assert|atomic|break|chan|const|continue|defer|else|embed|enum|fn|for|go(?:to)?|if|import|in|interface|is|lock|match|module|mut|none|or|pub|return|rlock|select|shared|sizeof|static|struct|type(?:of)?|union|unsafe)|\$(?:else|for|if)|#(?:flag|include))\b/,
            number: /\b(?:0x[a-f\d]+(?:_[a-f\d]+)*|0b[01]+(?:_[01]+)*|0o[0-7]+(?:_[0-7]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?)\b/i,
            operator: /~|\?|[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\.?/,
            builtin: /\b(?:any(?:_float|_int)?|bool|byte(?:ptr)?|charptr|f(?:32|64)|i(?:8|16|64|128|nt)|rune|size_t|string|u(?:16|32|64|128)|voidptr)\b/
        });
        interpolationExpr.inside = Prism.languages.v;
        Prism.languages.insertBefore('v', 'string', {
            char: {
                pattern: /`(?:\\`|\\?[^`]{1,2})`/,
                // using {1,2} instead of `u` flag for compatibility
                alias: 'rune'
            }
        });
        Prism.languages.insertBefore('v', 'operator', {
            attribute: {
                pattern: /(^[\t ]*)\[(?:deprecated|direct_array_access|flag|inline|live|ref_only|typedef|unsafe_fn|windows_stdcall)\]/m,
                lookbehind: true,
                alias: 'annotation',
                inside: {
                    punctuation: /[\[\]]/,
                    keyword: /\w+/
                }
            },
            generic: {
                pattern: /<\w+>(?=\s*[\)\{])/,
                inside: {
                    punctuation: /[<>]/,
                    'class-name': /\w+/
                }
            }
        });
        Prism.languages.insertBefore('v', 'function', {
            'generic-function': {
                // e.g. foo<T>( ...
                pattern: /\b\w+\s*<\w+>(?=\()/,
                inside: {
                    function: /^\w+/,
                    generic: {
                        pattern: /<\w+>/,
                        inside: Prism.languages.v.generic.inside
                    }
                }
            }
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$0fb6d91d2cc339cb$export$2e2bcd8739ae039.displayName = 'vala';
$0fb6d91d2cc339cb$export$2e2bcd8739ae039.aliases = [];
function $0fb6d91d2cc339cb$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
    Prism.languages.vala = Prism.languages.extend('clike', {
        // Classes copied from prism-csharp
        'class-name': [
            {
                // (Foo bar, Bar baz)
                pattern: /\b[A-Z]\w*(?:\.\w+)*\b(?=(?:\?\s+|\*?\s+\*?)\w)/,
                inside: {
                    punctuation: /\./
                }
            },
            {
                // [Foo]
                pattern: /(\[)[A-Z]\w*(?:\.\w+)*\b/,
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            },
            {
                // class Foo : Bar
                pattern: /(\b(?:class|interface)\s+[A-Z]\w*(?:\.\w+)*\s*:\s*)[A-Z]\w*(?:\.\w+)*\b/,
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            },
            {
                // class Foo
                pattern: /((?:\b(?:class|enum|interface|new|struct)\s+)|(?:catch\s+\())[A-Z]\w*(?:\.\w+)*\b/,
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            }
        ],
        keyword: /\b(?:abstract|as|assert|async|base|bool|break|case|catch|char|class|const|construct|continue|default|delegate|delete|do|double|dynamic|else|ensures|enum|errordomain|extern|finally|float|for|foreach|get|if|in|inline|int|int16|int32|int64|int8|interface|internal|is|lock|long|namespace|new|null|out|override|owned|params|private|protected|public|ref|requires|return|set|short|signal|sizeof|size_t|ssize_t|static|string|struct|switch|this|throw|throws|try|typeof|uchar|uint|uint16|uint32|uint64|uint8|ulong|unichar|unowned|ushort|using|value|var|virtual|void|volatile|weak|while|yield)\b/i,
        function: /\b\w+(?=\s*\()/,
        number: /(?:\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)(?:f|u?l?)?/i,
        operator: /\+\+|--|&&|\|\||<<=?|>>=?|=>|->|~|[+\-*\/%&^|=!<>]=?|\?\??|\.\.\./,
        punctuation: /[{}[\];(),.:]/,
        constant: /\b[A-Z0-9_]+\b/
    });
    Prism.languages.insertBefore('vala', 'string', {
        'raw-string': {
            pattern: /"""[\s\S]*?"""/,
            greedy: true,
            alias: 'string'
        },
        'template-string': {
            pattern: /@"[\s\S]*?"/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /\$(?:\([^)]*\)|[a-zA-Z]\w*)/,
                    inside: {
                        delimiter: {
                            pattern: /^\$\(?|\)$/,
                            alias: 'punctuation'
                        },
                        rest: Prism.languages.vala
                    }
                },
                string: /[\s\S]+/
            }
        }
    });
    Prism.languages.insertBefore('vala', 'keyword', {
        regex: {
            pattern: /\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[imsx]{0,4}(?=\s*(?:$|[\r\n,.;})\]]))/,
            greedy: true,
            inside: {
                'regex-source': {
                    pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                    lookbehind: true,
                    alias: 'language-regex',
                    inside: Prism.languages.regex
                },
                'regex-delimiter': /^\//,
                'regex-flags': /^[a-z]+$/
            }
        }
    });
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$a354882a5ae49c2a$export$2e2bcd8739ae039.displayName = 'velocity';
$a354882a5ae49c2a$export$2e2bcd8739ae039.aliases = [];
function $a354882a5ae49c2a$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $8fbeea7c20d72e06$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.velocity = Prism.languages.extend('markup', {});
        var velocity = {
            variable: {
                pattern: /(^|[^\\](?:\\\\)*)\$!?(?:[a-z][\w-]*(?:\([^)]*\))?(?:\.[a-z][\w-]*(?:\([^)]*\))?|\[[^\]]+\])*|\{[^}]+\})/i,
                lookbehind: true,
                inside: {} // See below
            },
            string: {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            number: /\b\d+\b/,
            boolean: /\b(?:false|true)\b/,
            operator: /[=!<>]=?|[+*/%-]|&&|\|\||\.\.|\b(?:eq|g[et]|l[et]|n(?:e|ot))\b/,
            punctuation: /[(){}[\]:,.]/
        };
        velocity.variable.inside = {
            string: velocity['string'],
            function: {
                pattern: /([^\w-])[a-z][\w-]*(?=\()/,
                lookbehind: true
            },
            number: velocity['number'],
            boolean: velocity['boolean'],
            punctuation: velocity['punctuation']
        };
        Prism.languages.insertBefore('velocity', 'comment', {
            unparsed: {
                pattern: /(^|[^\\])#\[\[[\s\S]*?\]\]#/,
                lookbehind: true,
                greedy: true,
                inside: {
                    punctuation: /^#\[\[|\]\]#$/
                }
            },
            'velocity-comment': [
                {
                    pattern: /(^|[^\\])#\*[\s\S]*?\*#/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'comment'
                },
                {
                    pattern: /(^|[^\\])##.*/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'comment'
                }
            ],
            directive: {
                pattern: /(^|[^\\](?:\\\\)*)#@?(?:[a-z][\w-]*|\{[a-z][\w-]*\})(?:\s*\((?:[^()]|\([^()]*\))*\))?/i,
                lookbehind: true,
                inside: {
                    keyword: {
                        pattern: /^#@?(?:[a-z][\w-]*|\{[a-z][\w-]*\})|\bin\b/,
                        inside: {
                            punctuation: /[{}]/
                        }
                    },
                    rest: velocity
                }
            },
            variable: velocity['variable']
        });
        Prism.languages.velocity['tag'].inside['attr-value'].inside.rest = Prism.languages.velocity;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $0089cfef22bc1b0d$export$2e2bcd8739ae039.displayName = 'verilog';
$0089cfef22bc1b0d$export$2e2bcd8739ae039.aliases = [];
function $0089cfef22bc1b0d$export$2e2bcd8739ae039(Prism) {
    Prism.languages.verilog = {
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
            greedy: true
        },
        string: {
            pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
            greedy: true
        },
        'kernel-function': {
            // support for any kernel function (ex: $display())
            pattern: /\B\$\w+\b/,
            alias: 'property'
        },
        // support for user defined constants (ex: `define)
        constant: /\B`\w+\b/,
        function: /\b\w+(?=\()/,
        // support for verilog and system verilog keywords
        keyword: /\b(?:alias|and|assert|assign|assume|automatic|before|begin|bind|bins|binsof|bit|break|buf|bufif0|bufif1|byte|case|casex|casez|cell|chandle|class|clocking|cmos|config|const|constraint|context|continue|cover|covergroup|coverpoint|cross|deassign|default|defparam|design|disable|dist|do|edge|else|end|endcase|endclass|endclocking|endconfig|endfunction|endgenerate|endgroup|endinterface|endmodule|endpackage|endprimitive|endprogram|endproperty|endsequence|endspecify|endtable|endtask|enum|event|expect|export|extends|extern|final|first_match|for|force|foreach|forever|fork|forkjoin|function|generate|genvar|highz0|highz1|if|iff|ifnone|ignore_bins|illegal_bins|import|incdir|include|initial|inout|input|inside|instance|int|integer|interface|intersect|join|join_any|join_none|large|liblist|library|local|localparam|logic|longint|macromodule|matches|medium|modport|module|nand|negedge|new|nmos|nor|noshowcancelled|not|notif0|notif1|null|or|output|package|packed|parameter|pmos|posedge|primitive|priority|program|property|protected|pull0|pull1|pulldown|pullup|pulsestyle_ondetect|pulsestyle_onevent|pure|rand|randc|randcase|randsequence|rcmos|real|realtime|ref|reg|release|repeat|return|rnmos|rpmos|rtran|rtranif0|rtranif1|scalared|sequence|shortint|shortreal|showcancelled|signed|small|solve|specify|specparam|static|string|strong0|strong1|struct|super|supply0|supply1|table|tagged|task|this|throughout|time|timeprecision|timeunit|tran|tranif0|tranif1|tri|tri0|tri1|triand|trior|trireg|type|typedef|union|unique|unsigned|use|uwire|var|vectored|virtual|void|wait|wait_order|wand|weak0|weak1|while|wildcard|wire|with|within|wor|xnor|xor)\b/,
        // bold highlighting for all verilog and system verilog logic blocks
        important: /\b(?:always|always_comb|always_ff|always_latch)\b(?: *@)?/,
        // support for time ticks, vectors, and real numbers
        number: /\B##?\d+|(?:\b\d+)?'[odbh] ?[\da-fzx_?]+|\b(?:\d*[._])?\d+(?:e[-+]?\d+)?/i,
        operator: /[-+{}^~%*\/?=!<>&|]+/,
        punctuation: /[[\];(),.:]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $0b8dc39b7929d21d$export$2e2bcd8739ae039.displayName = 'vhdl';
$0b8dc39b7929d21d$export$2e2bcd8739ae039.aliases = [];
function $0b8dc39b7929d21d$export$2e2bcd8739ae039(Prism) {
    Prism.languages.vhdl = {
        comment: /--.+/,
        // support for all logic vectors
        'vhdl-vectors': {
            pattern: /\b[oxb]"[\da-f_]+"|"[01uxzwlh-]+"/i,
            alias: 'number'
        },
        // support for operator overloading included
        'quoted-function': {
            pattern: /"\S+?"(?=\()/,
            alias: 'function'
        },
        string: /"(?:[^\\"\r\n]|\\(?:\r\n|[\s\S]))*"/,
        attribute: {
            pattern: /\b'\w+/,
            alias: 'attr-name'
        },
        // support for predefined attributes included
        keyword: /\b(?:access|after|alias|all|architecture|array|assert|attribute|begin|block|body|buffer|bus|case|component|configuration|constant|disconnect|downto|else|elsif|end|entity|exit|file|for|function|generate|generic|group|guarded|if|impure|in|inertial|inout|is|label|library|linkage|literal|loop|map|new|next|null|of|on|open|others|out|package|port|postponed|private|procedure|process|pure|range|record|register|reject|report|return|select|severity|shared|signal|subtype|then|to|transport|type|unaffected|units|until|use|variable|view|wait|when|while|with)\b/i,
        boolean: /\b(?:false|true)\b/i,
        function: /\w+(?=\()/,
        // decimal, based, physical, and exponential numbers supported
        number: /'[01uxzwlh-]'|\b(?:\d+#[\da-f_.]+#|\d[\d_.]*)(?:e[-+]?\d+)?/i,
        operator: /[<>]=?|:=|[-+*/&=]|\b(?:abs|and|mod|nand|nor|not|or|rem|rol|ror|sla|sll|sra|srl|xnor|xor)\b/i,
        punctuation: /[{}[\];(),.:]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $e73f907dadddc458$export$2e2bcd8739ae039.displayName = 'vim';
$e73f907dadddc458$export$2e2bcd8739ae039.aliases = [];
function $e73f907dadddc458$export$2e2bcd8739ae039(Prism) {
    Prism.languages.vim = {
        string: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\r\n]|'')*'/,
        comment: /".*/,
        function: /\b\w+(?=\()/,
        keyword: /\b(?:N|Next|P|Print|X|XMLent|XMLns|ab|abbreviate|abc|abclear|abo|aboveleft|al|all|ar|arga|argadd|argd|argdelete|argdo|arge|argedit|argg|argglobal|argl|arglocal|args|argu|argument|as|ascii|b|bN|bNext|ba|bad|badd|ball|bd|bdelete|be|bel|belowright|bf|bfirst|bl|blast|bm|bmodified|bn|bnext|bo|botright|bp|bprevious|br|brea|break|breaka|breakadd|breakd|breakdel|breakl|breaklist|brewind|bro|browse|bufdo|buffer|buffers|bun|bunload|bw|bwipeout|c|cN|cNext|cNfcNfile|ca|cabbrev|cabc|cabclear|cad|caddb|caddbuffer|caddexpr|caddf|caddfile|cal|call|cat|catch|cb|cbuffer|cc|ccl|cclose|cd|ce|center|cex|cexpr|cf|cfile|cfir|cfirst|cg|cgetb|cgetbuffer|cgete|cgetexpr|cgetfile|change|changes|chd|chdir|che|checkpath|checkt|checktime|cl|cla|clast|clist|clo|close|cmapc|cmapclear|cn|cnew|cnewer|cnext|cnf|cnfile|cnorea|cnoreabbrev|co|col|colder|colo|colorscheme|comc|comclear|comp|compiler|con|conf|confirm|continue|cope|copen|copy|cp|cpf|cpfile|cprevious|cq|cquit|cr|crewind|cu|cuna|cunabbrev|cunmap|cw|cwindow|d|debugg|debuggreedy|delc|delcommand|delete|delf|delfunction|delm|delmarks|di|diffg|diffget|diffoff|diffpatch|diffpu|diffput|diffsplit|diffthis|diffu|diffupdate|dig|digraphs|display|dj|djump|dl|dlist|dr|drop|ds|dsearch|dsp|dsplit|e|earlier|echoe|echoerr|echom|echomsg|echon|edit|el|else|elsei|elseif|em|emenu|en|endf|endfo|endfor|endfun|endfunction|endif|endt|endtry|endw|endwhile|ene|enew|ex|exi|exit|exu|exusage|f|file|files|filetype|fin|fina|finally|find|fini|finish|fir|first|fix|fixdel|fo|fold|foldc|foldclose|foldd|folddoc|folddoclosed|folddoopen|foldo|foldopen|for|fu|fun|function|go|goto|gr|grep|grepa|grepadd|h|ha|hardcopy|help|helpf|helpfind|helpg|helpgrep|helpt|helptags|hid|hide|his|history|ia|iabbrev|iabc|iabclear|if|ij|ijump|il|ilist|imapc|imapclear|in|inorea|inoreabbrev|isearch|isp|isplit|iu|iuna|iunabbrev|iunmap|j|join|ju|jumps|k|kee|keepalt|keepj|keepjumps|keepmarks|l|lN|lNext|lNf|lNfile|la|lad|laddb|laddbuffer|laddexpr|laddf|laddfile|lan|language|last|later|lb|lbuffer|lc|lcd|lch|lchdir|lcl|lclose|left|lefta|leftabove|let|lex|lexpr|lf|lfile|lfir|lfirst|lg|lgetb|lgetbuffer|lgete|lgetexpr|lgetfile|lgr|lgrep|lgrepa|lgrepadd|lh|lhelpgrep|list|ll|lla|llast|lli|llist|lm|lmak|lmake|lmap|lmapc|lmapclear|ln|lne|lnew|lnewer|lnext|lnf|lnfile|lnoremap|lo|loadview|loc|lockmarks|lockv|lockvar|lol|lolder|lop|lopen|lp|lpf|lpfile|lprevious|lr|lrewind|ls|lt|ltag|lu|lunmap|lv|lvimgrep|lvimgrepa|lvimgrepadd|lw|lwindow|m|ma|mak|make|mark|marks|mat|match|menut|menutranslate|mk|mkexrc|mks|mksession|mksp|mkspell|mkv|mkvie|mkview|mkvimrc|mod|mode|move|mz|mzf|mzfile|mzscheme|n|nbkey|new|next|nmapc|nmapclear|noh|nohlsearch|norea|noreabbrev|nu|number|nun|nunmap|o|omapc|omapclear|on|only|open|opt|options|ou|ounmap|p|pc|pclose|pe|ped|pedit|perl|perld|perldo|po|pop|popu|popup|pp|ppop|pre|preserve|prev|previous|print|prof|profd|profdel|profile|promptf|promptfind|promptr|promptrepl|ps|psearch|ptN|ptNext|pta|ptag|ptf|ptfirst|ptj|ptjump|ptl|ptlast|ptn|ptnext|ptp|ptprevious|ptr|ptrewind|pts|ptselect|pu|put|pw|pwd|py|pyf|pyfile|python|q|qa|qall|quit|quita|quitall|r|read|rec|recover|red|redi|redir|redo|redr|redraw|redraws|redrawstatus|reg|registers|res|resize|ret|retab|retu|return|rew|rewind|ri|right|rightb|rightbelow|ru|rub|ruby|rubyd|rubydo|rubyf|rubyfile|runtime|rv|rviminfo|sN|sNext|sa|sal|sall|san|sandbox|sargument|sav|saveas|sb|sbN|sbNext|sba|sball|sbf|sbfirst|sbl|sblast|sbm|sbmodified|sbn|sbnext|sbp|sbprevious|sbr|sbrewind|sbuffer|scrip|scripte|scriptencoding|scriptnames|se|set|setf|setfiletype|setg|setglobal|setl|setlocal|sf|sfind|sfir|sfirst|sh|shell|sign|sil|silent|sim|simalt|sl|sla|slast|sleep|sm|smagic|smap|smapc|smapclear|sme|smenu|sn|snext|sni|sniff|sno|snomagic|snor|snoremap|snoreme|snoremenu|so|sor|sort|source|sp|spe|spelld|spelldump|spellgood|spelli|spellinfo|spellr|spellrepall|spellu|spellundo|spellw|spellwrong|split|spr|sprevious|sre|srewind|st|sta|stag|star|startg|startgreplace|startinsert|startr|startreplace|stj|stjump|stop|stopi|stopinsert|sts|stselect|sun|sunhide|sunm|sunmap|sus|suspend|sv|sview|syncbind|t|tN|tNext|ta|tab|tabN|tabNext|tabc|tabclose|tabd|tabdo|tabe|tabedit|tabf|tabfind|tabfir|tabfirst|tabl|tablast|tabm|tabmove|tabn|tabnew|tabnext|tabo|tabonly|tabp|tabprevious|tabr|tabrewind|tabs|tag|tags|tc|tcl|tcld|tcldo|tclf|tclfile|te|tearoff|tf|tfirst|th|throw|tj|tjump|tl|tlast|tm|tmenu|tn|tnext|to|topleft|tp|tprevious|tr|trewind|try|ts|tselect|tu|tunmenu|u|una|unabbreviate|undo|undoj|undojoin|undol|undolist|unh|unhide|unlet|unlo|unlockvar|unm|unmap|up|update|ve|verb|verbose|version|vert|vertical|vi|vie|view|vim|vimgrep|vimgrepa|vimgrepadd|visual|viu|viusage|vmapc|vmapclear|vne|vnew|vs|vsplit|vu|vunmap|w|wN|wNext|wa|wall|wh|while|win|winc|wincmd|windo|winp|winpos|winsize|wn|wnext|wp|wprevious|wq|wqa|wqall|write|ws|wsverb|wv|wviminfo|x|xa|xall|xit|xm|xmap|xmapc|xmapclear|xme|xmenu|xn|xnoremap|xnoreme|xnoremenu|xu|xunmap|y|yank)\b/,
        builtin: /\b(?:acd|ai|akm|aleph|allowrevins|altkeymap|ambiwidth|ambw|anti|antialias|arab|arabic|arabicshape|ari|arshape|autochdir|autocmd|autoindent|autoread|autowrite|autowriteall|aw|awa|background|backspace|backup|backupcopy|backupdir|backupext|backupskip|balloondelay|ballooneval|balloonexpr|bdir|bdlay|beval|bex|bexpr|bg|bh|bin|binary|biosk|bioskey|bk|bkc|bomb|breakat|brk|browsedir|bs|bsdir|bsk|bt|bufhidden|buflisted|buftype|casemap|ccv|cdpath|cedit|cfu|ch|charconvert|ci|cin|cindent|cink|cinkeys|cino|cinoptions|cinw|cinwords|clipboard|cmdheight|cmdwinheight|cmp|cms|columns|com|comments|commentstring|compatible|complete|completefunc|completeopt|consk|conskey|copyindent|cot|cpo|cpoptions|cpt|cscopepathcomp|cscopeprg|cscopequickfix|cscopetag|cscopetagorder|cscopeverbose|cspc|csprg|csqf|cst|csto|csverb|cuc|cul|cursorcolumn|cursorline|cwh|debug|deco|def|define|delcombine|dex|dg|dict|dictionary|diff|diffexpr|diffopt|digraph|dip|dir|directory|dy|ea|ead|eadirection|eb|ed|edcompatible|ef|efm|ei|ek|enc|encoding|endofline|eol|ep|equalalways|equalprg|errorbells|errorfile|errorformat|esckeys|et|eventignore|expandtab|exrc|fcl|fcs|fdc|fde|fdi|fdl|fdls|fdm|fdn|fdo|fdt|fen|fenc|fencs|fex|ff|ffs|fileencoding|fileencodings|fileformat|fileformats|fillchars|fk|fkmap|flp|fml|fmr|foldcolumn|foldenable|foldexpr|foldignore|foldlevel|foldlevelstart|foldmarker|foldmethod|foldminlines|foldnestmax|foldtext|formatexpr|formatlistpat|formatoptions|formatprg|fp|fs|fsync|ft|gcr|gd|gdefault|gfm|gfn|gfs|gfw|ghr|gp|grepformat|grepprg|gtl|gtt|guicursor|guifont|guifontset|guifontwide|guiheadroom|guioptions|guipty|guitablabel|guitabtooltip|helpfile|helpheight|helplang|hf|hh|hi|hidden|highlight|hk|hkmap|hkmapp|hkp|hl|hlg|hls|hlsearch|ic|icon|iconstring|ignorecase|im|imactivatekey|imak|imc|imcmdline|imd|imdisable|imi|iminsert|ims|imsearch|inc|include|includeexpr|incsearch|inde|indentexpr|indentkeys|indk|inex|inf|infercase|insertmode|invacd|invai|invakm|invallowrevins|invaltkeymap|invanti|invantialias|invar|invarab|invarabic|invarabicshape|invari|invarshape|invautochdir|invautoindent|invautoread|invautowrite|invautowriteall|invaw|invawa|invbackup|invballooneval|invbeval|invbin|invbinary|invbiosk|invbioskey|invbk|invbl|invbomb|invbuflisted|invcf|invci|invcin|invcindent|invcompatible|invconfirm|invconsk|invconskey|invcopyindent|invcp|invcscopetag|invcscopeverbose|invcst|invcsverb|invcuc|invcul|invcursorcolumn|invcursorline|invdeco|invdelcombine|invdg|invdiff|invdigraph|invdisable|invea|inveb|inved|invedcompatible|invek|invendofline|inveol|invequalalways|inverrorbells|invesckeys|invet|invex|invexpandtab|invexrc|invfen|invfk|invfkmap|invfoldenable|invgd|invgdefault|invguipty|invhid|invhidden|invhk|invhkmap|invhkmapp|invhkp|invhls|invhlsearch|invic|invicon|invignorecase|invim|invimc|invimcmdline|invimd|invincsearch|invinf|invinfercase|invinsertmode|invis|invjoinspaces|invjs|invlazyredraw|invlbr|invlinebreak|invlisp|invlist|invloadplugins|invlpl|invlz|invma|invmacatsui|invmagic|invmh|invml|invmod|invmodeline|invmodifiable|invmodified|invmore|invmousef|invmousefocus|invmousehide|invnu|invnumber|invodev|invopendevice|invpaste|invpi|invpreserveindent|invpreviewwindow|invprompt|invpvw|invreadonly|invremap|invrestorescreen|invrevins|invri|invrightleft|invrightleftcmd|invrl|invrlc|invro|invrs|invru|invruler|invsb|invsc|invscb|invscrollbind|invscs|invsecure|invsft|invshellslash|invshelltemp|invshiftround|invshortname|invshowcmd|invshowfulltag|invshowmatch|invshowmode|invsi|invsm|invsmartcase|invsmartindent|invsmarttab|invsmd|invsn|invsol|invspell|invsplitbelow|invsplitright|invspr|invsr|invssl|invsta|invstartofline|invstmp|invswapfile|invswf|invta|invtagbsearch|invtagrelative|invtagstack|invtbi|invtbidi|invtbs|invtermbidi|invterse|invtextauto|invtextmode|invtf|invtgst|invtildeop|invtimeout|invtitle|invto|invtop|invtr|invttimeout|invttybuiltin|invttyfast|invtx|invvb|invvisualbell|invwa|invwarn|invwb|invweirdinvert|invwfh|invwfw|invwildmenu|invwinfixheight|invwinfixwidth|invwiv|invwmnu|invwrap|invwrapscan|invwrite|invwriteany|invwritebackup|invws|isf|isfname|isi|isident|isk|iskeyword|isprint|joinspaces|js|key|keymap|keymodel|keywordprg|km|kmp|kp|langmap|langmenu|laststatus|lazyredraw|lbr|lcs|linebreak|lines|linespace|lisp|lispwords|listchars|loadplugins|lpl|lsp|lz|macatsui|magic|makeef|makeprg|matchpairs|matchtime|maxcombine|maxfuncdepth|maxmapdepth|maxmem|maxmempattern|maxmemtot|mco|mef|menuitems|mfd|mh|mis|mkspellmem|ml|mls|mm|mmd|mmp|mmt|modeline|modelines|modifiable|modified|more|mouse|mousef|mousefocus|mousehide|mousem|mousemodel|mouses|mouseshape|mouset|mousetime|mp|mps|msm|mzq|mzquantum|nf|noacd|noai|noakm|noallowrevins|noaltkeymap|noanti|noantialias|noar|noarab|noarabic|noarabicshape|noari|noarshape|noautochdir|noautoindent|noautoread|noautowrite|noautowriteall|noaw|noawa|nobackup|noballooneval|nobeval|nobin|nobinary|nobiosk|nobioskey|nobk|nobl|nobomb|nobuflisted|nocf|noci|nocin|nocindent|nocompatible|noconfirm|noconsk|noconskey|nocopyindent|nocp|nocscopetag|nocscopeverbose|nocst|nocsverb|nocuc|nocul|nocursorcolumn|nocursorline|nodeco|nodelcombine|nodg|nodiff|nodigraph|nodisable|noea|noeb|noed|noedcompatible|noek|noendofline|noeol|noequalalways|noerrorbells|noesckeys|noet|noex|noexpandtab|noexrc|nofen|nofk|nofkmap|nofoldenable|nogd|nogdefault|noguipty|nohid|nohidden|nohk|nohkmap|nohkmapp|nohkp|nohls|noic|noicon|noignorecase|noim|noimc|noimcmdline|noimd|noincsearch|noinf|noinfercase|noinsertmode|nois|nojoinspaces|nojs|nolazyredraw|nolbr|nolinebreak|nolisp|nolist|noloadplugins|nolpl|nolz|noma|nomacatsui|nomagic|nomh|noml|nomod|nomodeline|nomodifiable|nomodified|nomore|nomousef|nomousefocus|nomousehide|nonu|nonumber|noodev|noopendevice|nopaste|nopi|nopreserveindent|nopreviewwindow|noprompt|nopvw|noreadonly|noremap|norestorescreen|norevins|nori|norightleft|norightleftcmd|norl|norlc|noro|nors|noru|noruler|nosb|nosc|noscb|noscrollbind|noscs|nosecure|nosft|noshellslash|noshelltemp|noshiftround|noshortname|noshowcmd|noshowfulltag|noshowmatch|noshowmode|nosi|nosm|nosmartcase|nosmartindent|nosmarttab|nosmd|nosn|nosol|nospell|nosplitbelow|nosplitright|nospr|nosr|nossl|nosta|nostartofline|nostmp|noswapfile|noswf|nota|notagbsearch|notagrelative|notagstack|notbi|notbidi|notbs|notermbidi|noterse|notextauto|notextmode|notf|notgst|notildeop|notimeout|notitle|noto|notop|notr|nottimeout|nottybuiltin|nottyfast|notx|novb|novisualbell|nowa|nowarn|nowb|noweirdinvert|nowfh|nowfw|nowildmenu|nowinfixheight|nowinfixwidth|nowiv|nowmnu|nowrap|nowrapscan|nowrite|nowriteany|nowritebackup|nows|nrformats|numberwidth|nuw|odev|oft|ofu|omnifunc|opendevice|operatorfunc|opfunc|osfiletype|pa|para|paragraphs|paste|pastetoggle|patchexpr|patchmode|path|pdev|penc|pex|pexpr|pfn|ph|pheader|pi|pm|pmbcs|pmbfn|popt|preserveindent|previewheight|previewwindow|printdevice|printencoding|printexpr|printfont|printheader|printmbcharset|printmbfont|printoptions|prompt|pt|pumheight|pvh|pvw|qe|quoteescape|readonly|remap|report|restorescreen|revins|rightleft|rightleftcmd|rl|rlc|ro|rs|rtp|ruf|ruler|rulerformat|runtimepath|sbo|sc|scb|scr|scroll|scrollbind|scrolljump|scrolloff|scrollopt|scs|sect|sections|secure|sel|selection|selectmode|sessionoptions|sft|shcf|shellcmdflag|shellpipe|shellquote|shellredir|shellslash|shelltemp|shelltype|shellxquote|shiftround|shiftwidth|shm|shortmess|shortname|showbreak|showcmd|showfulltag|showmatch|showmode|showtabline|shq|si|sidescroll|sidescrolloff|siso|sj|slm|smartcase|smartindent|smarttab|smc|smd|softtabstop|sol|spc|spell|spellcapcheck|spellfile|spelllang|spellsuggest|spf|spl|splitbelow|splitright|sps|sr|srr|ss|ssl|ssop|stal|startofline|statusline|stl|stmp|su|sua|suffixes|suffixesadd|sw|swapfile|swapsync|swb|swf|switchbuf|sws|sxq|syn|synmaxcol|syntax|t_AB|t_AF|t_AL|t_CS|t_CV|t_Ce|t_Co|t_Cs|t_DL|t_EI|t_F1|t_F2|t_F3|t_F4|t_F5|t_F6|t_F7|t_F8|t_F9|t_IE|t_IS|t_K1|t_K3|t_K4|t_K5|t_K6|t_K7|t_K8|t_K9|t_KA|t_KB|t_KC|t_KD|t_KE|t_KF|t_KG|t_KH|t_KI|t_KJ|t_KK|t_KL|t_RI|t_RV|t_SI|t_Sb|t_Sf|t_WP|t_WS|t_ZH|t_ZR|t_al|t_bc|t_cd|t_ce|t_cl|t_cm|t_cs|t_da|t_db|t_dl|t_fs|t_k1|t_k2|t_k3|t_k4|t_k5|t_k6|t_k7|t_k8|t_k9|t_kB|t_kD|t_kI|t_kN|t_kP|t_kb|t_kd|t_ke|t_kh|t_kl|t_kr|t_ks|t_ku|t_le|t_mb|t_md|t_me|t_mr|t_ms|t_nd|t_op|t_se|t_so|t_sr|t_te|t_ti|t_ts|t_ue|t_us|t_ut|t_vb|t_ve|t_vi|t_vs|t_xs|tabline|tabpagemax|tabstop|tagbsearch|taglength|tagrelative|tagstack|tal|tb|tbi|tbidi|tbis|tbs|tenc|term|termbidi|termencoding|terse|textauto|textmode|textwidth|tgst|thesaurus|tildeop|timeout|timeoutlen|title|titlelen|titleold|titlestring|toolbar|toolbariconsize|top|tpm|tsl|tsr|ttimeout|ttimeoutlen|ttm|tty|ttybuiltin|ttyfast|ttym|ttymouse|ttyscroll|ttytype|tw|tx|uc|ul|undolevels|updatecount|updatetime|ut|vb|vbs|vdir|verbosefile|vfile|viewdir|viewoptions|viminfo|virtualedit|visualbell|vop|wak|warn|wb|wc|wcm|wd|weirdinvert|wfh|wfw|whichwrap|wi|wig|wildchar|wildcharm|wildignore|wildmenu|wildmode|wildoptions|wim|winaltkeys|window|winfixheight|winfixwidth|winheight|winminheight|winminwidth|winwidth|wiv|wiw|wm|wmh|wmnu|wmw|wop|wrap|wrapmargin|wrapscan|writeany|writebackup|writedelay|ww)\b/,
        number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?)\b/i,
        operator: /\|\||&&|[-+.]=?|[=!](?:[=~][#?]?)?|[<>]=?[#?]?|[*\/%?]|\b(?:is(?:not)?)\b/,
        punctuation: /[{}[\](),;:]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $faf2e69849cc2214$export$2e2bcd8739ae039.displayName = 'visual-basic';
$faf2e69849cc2214$export$2e2bcd8739ae039.aliases = [
    'vb',
    'vba'
];
function $faf2e69849cc2214$export$2e2bcd8739ae039(Prism) {
    Prism.languages['visual-basic'] = {
        comment: {
            pattern: /(?:['‘’]|REM\b)(?:[^\r\n_]|_(?:\r\n?|\n)?)*/i,
            inside: {
                keyword: /^REM/i
            }
        },
        directive: {
            pattern: /#(?:Const|Else|ElseIf|End|ExternalChecksum|ExternalSource|If|Region)(?:\b_[ \t]*(?:\r\n?|\n)|.)+/i,
            alias: 'property',
            greedy: true
        },
        string: {
            pattern: /\$?["“”](?:["“”]{2}|[^"“”])*["“”]C?/i,
            greedy: true
        },
        date: {
            pattern: /#[ \t]*(?:\d+([/-])\d+\1\d+(?:[ \t]+(?:\d+[ \t]*(?:AM|PM)|\d+:\d+(?::\d+)?(?:[ \t]*(?:AM|PM))?))?|\d+[ \t]*(?:AM|PM)|\d+:\d+(?::\d+)?(?:[ \t]*(?:AM|PM))?)[ \t]*#/i,
            alias: 'number'
        },
        number: /(?:(?:\b\d+(?:\.\d+)?|\.\d+)(?:E[+-]?\d+)?|&[HO][\dA-F]+)(?:[FRD]|U?[ILS])?/i,
        boolean: /\b(?:False|Nothing|True)\b/i,
        keyword: /\b(?:AddHandler|AddressOf|Alias|And(?:Also)?|As|Boolean|ByRef|Byte|ByVal|Call|Case|Catch|C(?:Bool|Byte|Char|Date|Dbl|Dec|Int|Lng|Obj|SByte|Short|Sng|Str|Type|UInt|ULng|UShort)|Char|Class|Const|Continue|Currency|Date|Decimal|Declare|Default|Delegate|Dim|DirectCast|Do|Double|Each|Else(?:If)?|End(?:If)?|Enum|Erase|Error|Event|Exit|Finally|For|Friend|Function|Get(?:Type|XMLNamespace)?|Global|GoSub|GoTo|Handles|If|Implements|Imports|In|Inherits|Integer|Interface|Is|IsNot|Let|Lib|Like|Long|Loop|Me|Mod|Module|Must(?:Inherit|Override)|My(?:Base|Class)|Namespace|Narrowing|New|Next|Not(?:Inheritable|Overridable)?|Object|Of|On|Operator|Option(?:al)?|Or(?:Else)?|Out|Overloads|Overridable|Overrides|ParamArray|Partial|Private|Property|Protected|Public|RaiseEvent|ReadOnly|ReDim|RemoveHandler|Resume|Return|SByte|Select|Set|Shadows|Shared|short|Single|Static|Step|Stop|String|Structure|Sub|SyncLock|Then|Throw|To|Try|TryCast|Type|TypeOf|U(?:Integer|Long|Short)|Until|Using|Variant|Wend|When|While|Widening|With(?:Events)?|WriteOnly|Xor)\b/i,
        operator: /[+\-*/\\^<=>&#@$%!]|\b_(?=[ \t]*[\r\n])/,
        punctuation: /[{}().,:?]/
    };
    Prism.languages.vb = Prism.languages['visual-basic'];
    Prism.languages.vba = Prism.languages['visual-basic'];
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $765e7f252f771396$export$2e2bcd8739ae039.displayName = 'warpscript';
$765e7f252f771396$export$2e2bcd8739ae039.aliases = [];
function $765e7f252f771396$export$2e2bcd8739ae039(Prism) {
    Prism.languages.warpscript = {
        comment: /#.*|\/\/.*|\/\*[\s\S]*?\*\//,
        string: {
            pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'|<'(?:[^\\']|'(?!>)|\\.)*'>/,
            greedy: true
        },
        variable: /\$\S+/,
        macro: {
            pattern: /@\S+/,
            alias: 'property'
        },
        // WarpScript doesn't have any keywords, these are all functions under the control category
        // https://www.warp10.io/tags/control
        keyword: /\b(?:BREAK|CHECKMACRO|CONTINUE|CUDF|DEFINED|DEFINEDMACRO|EVAL|FAIL|FOR|FOREACH|FORSTEP|IFT|IFTE|MSGFAIL|NRETURN|RETHROW|RETURN|SWITCH|TRY|UDF|UNTIL|WHILE)\b/,
        number: /[+-]?\b(?:NaN|Infinity|\d+(?:\.\d*)?(?:[Ee][+-]?\d+)?|0x[\da-fA-F]+|0b[01]+)\b/,
        boolean: /\b(?:F|T|false|true)\b/,
        punctuation: /<%|%>|[{}[\]()]/,
        // Some operators from the "operators" category
        // https://www.warp10.io/tags/operators
        operator: /==|&&?|\|\|?|\*\*?|>>>?|<<|[<>!~]=?|[-/%^]|\+!?|\b(?:AND|NOT|OR)\b/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $44804e313ed480d5$export$2e2bcd8739ae039.displayName = 'wasm';
$44804e313ed480d5$export$2e2bcd8739ae039.aliases = [];
function $44804e313ed480d5$export$2e2bcd8739ae039(Prism) {
    Prism.languages.wasm = {
        comment: [
            /\(;[\s\S]*?;\)/,
            {
                pattern: /;;.*/,
                greedy: true
            }
        ],
        string: {
            pattern: /"(?:\\[\s\S]|[^"\\])*"/,
            greedy: true
        },
        keyword: [
            {
                pattern: /\b(?:align|offset)=/,
                inside: {
                    operator: /=/
                }
            },
            {
                pattern: /\b(?:(?:f32|f64|i32|i64)(?:\.(?:abs|add|and|ceil|clz|const|convert_[su]\/i(?:32|64)|copysign|ctz|demote\/f64|div(?:_[su])?|eqz?|extend_[su]\/i32|floor|ge(?:_[su])?|gt(?:_[su])?|le(?:_[su])?|load(?:(?:8|16|32)_[su])?|lt(?:_[su])?|max|min|mul|neg?|nearest|or|popcnt|promote\/f32|reinterpret\/[fi](?:32|64)|rem_[su]|rot[lr]|shl|shr_[su]|sqrt|store(?:8|16|32)?|sub|trunc(?:_[su]\/f(?:32|64))?|wrap\/i64|xor))?|memory\.(?:grow|size))\b/,
                inside: {
                    punctuation: /\./
                }
            },
            /\b(?:anyfunc|block|br(?:_if|_table)?|call(?:_indirect)?|data|drop|elem|else|end|export|func|get_(?:global|local)|global|if|import|local|loop|memory|module|mut|nop|offset|param|result|return|select|set_(?:global|local)|start|table|tee_local|then|type|unreachable)\b/
        ],
        variable: /\$[\w!#$%&'*+\-./:<=>?@\\^`|~]+/,
        number: /[+-]?\b(?:\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:[eE][+-]?\d(?:_?\d)*)?|0x[\da-fA-F](?:_?[\da-fA-F])*(?:\.[\da-fA-F](?:_?[\da-fA-D])*)?(?:[pP][+-]?\d(?:_?\d)*)?)\b|\binf\b|\bnan(?::0x[\da-fA-F](?:_?[\da-fA-D])*)?\b/,
        punctuation: /[()]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $7233d4a8ed8a1afe$export$2e2bcd8739ae039.displayName = 'web-idl';
$7233d4a8ed8a1afe$export$2e2bcd8739ae039.aliases = [
    'webidl'
];
function $7233d4a8ed8a1afe$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var id = /(?:\B-|\b_|\b)[A-Za-z][\w-]*(?![\w-])/.source;
        var type = '(?:' + /\b(?:unsigned\s+)?long\s+long(?![\w-])/.source + '|' + /\b(?:unrestricted|unsigned)\s+[a-z]+(?![\w-])/.source + '|' + /(?!(?:unrestricted|unsigned)\b)/.source + id + /(?:\s*<(?:[^<>]|<[^<>]*>)*>)?/.source + ')' + /(?:\s*\?)?/.source;
        var typeInside = {};
        Prism.languages['web-idl'] = {
            comment: {
                pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
                greedy: true
            },
            string: {
                pattern: /"[^"]*"/,
                greedy: true
            },
            namespace: {
                pattern: RegExp(/(\bnamespace\s+)/.source + id),
                lookbehind: true
            },
            'class-name': [
                {
                    pattern: /(^|[^\w-])(?:iterable|maplike|setlike)\s*<(?:[^<>]|<[^<>]*>)*>/,
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    pattern: RegExp(/(\b(?:attribute|const|deleter|getter|optional|setter)\s+)/.source + type),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // callback return type
                    pattern: RegExp('(' + /\bcallback\s+/.source + id + /\s*=\s*/.source + ')' + type),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // typedef
                    pattern: RegExp(/(\btypedef\b\s*)/.source + type),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    pattern: RegExp(/(\b(?:callback|dictionary|enum|interface(?:\s+mixin)?)\s+)(?!(?:interface|mixin)\b)/.source + id),
                    lookbehind: true
                },
                {
                    // inheritance
                    pattern: RegExp(/(:\s*)/.source + id),
                    lookbehind: true
                },
                // includes and implements
                RegExp(id + /(?=\s+(?:implements|includes)\b)/.source),
                {
                    pattern: RegExp(/(\b(?:implements|includes)\s+)/.source + id),
                    lookbehind: true
                },
                {
                    // function return type, parameter types, and dictionary members
                    pattern: RegExp(type + '(?=' + /\s*(?:\.{3}\s*)?/.source + id + /\s*[(),;=]/.source + ')'),
                    inside: typeInside
                }
            ],
            builtin: /\b(?:ArrayBuffer|BigInt64Array|BigUint64Array|ByteString|DOMString|DataView|Float32Array|Float64Array|FrozenArray|Int16Array|Int32Array|Int8Array|ObservableArray|Promise|USVString|Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray)\b/,
            keyword: [
                /\b(?:async|attribute|callback|const|constructor|deleter|dictionary|enum|getter|implements|includes|inherit|interface|mixin|namespace|null|optional|or|partial|readonly|required|setter|static|stringifier|typedef|unrestricted)\b/,
                // type keywords
                /\b(?:any|bigint|boolean|byte|double|float|iterable|long|maplike|object|octet|record|sequence|setlike|short|symbol|undefined|unsigned|void)\b/
            ],
            boolean: /\b(?:false|true)\b/,
            number: {
                pattern: /(^|[^\w-])-?(?:0x[0-9a-f]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|NaN|Infinity)(?![\w-])/i,
                lookbehind: true
            },
            operator: /\.{3}|[=:?<>-]/,
            punctuation: /[(){}[\].,;]/
        };
        for(var key in Prism.languages['web-idl'])if (key !== 'class-name') typeInside[key] = Prism.languages['web-idl'][key];
        Prism.languages['webidl'] = Prism.languages['web-idl'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $0c8f23efcfcfc76d$export$2e2bcd8739ae039.displayName = 'wgsl';
$0c8f23efcfcfc76d$export$2e2bcd8739ae039.aliases = [];
function $0c8f23efcfcfc76d$export$2e2bcd8739ae039(Prism) {
    Prism.languages.wgsl = {
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
            greedy: true
        },
        'builtin-attribute': {
            pattern: /(@)builtin\(.*?\)/,
            lookbehind: true,
            inside: {
                attribute: {
                    pattern: /^builtin/,
                    alias: 'attr-name'
                },
                punctuation: /[(),]/,
                'built-in-values': {
                    pattern: /\b(?:frag_depth|front_facing|global_invocation_id|instance_index|local_invocation_id|local_invocation_index|num_workgroups|position|sample_index|sample_mask|vertex_index|workgroup_id)\b/,
                    alias: 'attr-value'
                }
            }
        },
        attributes: {
            pattern: /(@)(?:align|binding|compute|const|fragment|group|id|interpolate|invariant|location|size|vertex|workgroup_size)/i,
            lookbehind: true,
            alias: 'attr-name'
        },
        functions: {
            pattern: /\b(fn\s+)[_a-zA-Z]\w*(?=[(<])/,
            lookbehind: true,
            alias: 'function'
        },
        keyword: /\b(?:bitcast|break|case|const|continue|continuing|default|discard|else|enable|fallthrough|fn|for|function|if|let|loop|private|return|storage|struct|switch|type|uniform|var|while|workgroup)\b/,
        builtin: /\b(?:abs|acos|acosh|all|any|array|asin|asinh|atan|atan2|atanh|atomic|atomicAdd|atomicAnd|atomicCompareExchangeWeak|atomicExchange|atomicLoad|atomicMax|atomicMin|atomicOr|atomicStore|atomicSub|atomicXor|bool|ceil|clamp|cos|cosh|countLeadingZeros|countOneBits|countTrailingZeros|cross|degrees|determinant|distance|dot|dpdx|dpdxCoarse|dpdxFine|dpdy|dpdyCoarse|dpdyFine|exp|exp2|extractBits|f32|f64|faceForward|firstLeadingBit|floor|fma|fract|frexp|fwidth|fwidthCoarse|fwidthFine|i32|i64|insertBits|inverseSqrt|ldexp|length|log|log2|mat[2-4]x[2-4]|max|min|mix|modf|normalize|override|pack2x16float|pack2x16snorm|pack2x16unorm|pack4x8snorm|pack4x8unorm|pow|ptr|quantizeToF16|radians|reflect|refract|reverseBits|round|sampler|sampler_comparison|select|shiftLeft|shiftRight|sign|sin|sinh|smoothstep|sqrt|staticAssert|step|storageBarrier|tan|tanh|textureDimensions|textureGather|textureGatherCompare|textureLoad|textureNumLayers|textureNumLevels|textureNumSamples|textureSample|textureSampleBias|textureSampleCompare|textureSampleCompareLevel|textureSampleGrad|textureSampleLevel|textureStore|texture_1d|texture_2d|texture_2d_array|texture_3d|texture_cube|texture_cube_array|texture_depth_2d|texture_depth_2d_array|texture_depth_cube|texture_depth_cube_array|texture_depth_multisampled_2d|texture_multisampled_2d|texture_storage_1d|texture_storage_2d|texture_storage_2d_array|texture_storage_3d|transpose|trunc|u32|u64|unpack2x16float|unpack2x16snorm|unpack2x16unorm|unpack4x8snorm|unpack4x8unorm|vec[2-4]|workgroupBarrier)\b/,
        'function-calls': {
            pattern: /\b[_a-z]\w*(?=\()/i,
            alias: 'function'
        },
        'class-name': /\b(?:[A-Z][A-Za-z0-9]*)\b/,
        'bool-literal': {
            pattern: /\b(?:false|true)\b/,
            alias: 'boolean'
        },
        'hex-int-literal': {
            pattern: /\b0[xX][0-9a-fA-F]+[iu]?\b(?![.pP])/,
            alias: 'number'
        },
        'hex-float-literal': {
            pattern: /\b0[xX][0-9a-fA-F]*(?:\.[0-9a-fA-F]*)?(?:[pP][+-]?\d+[fh]?)?/,
            alias: 'number'
        },
        'decimal-float-literal': [
            {
                pattern: /\d*\.\d+(?:[eE](?:\+|-)?\d+)?[fh]?/,
                alias: 'number'
            },
            {
                pattern: /\d+\.\d*(?:[eE](?:\+|-)?\d+)?[fh]?/,
                alias: 'number'
            },
            {
                pattern: /\d+[eE](?:\+|-)?\d+[fh]?/,
                alias: 'number'
            },
            {
                pattern: /\b\d+[fh]\b/,
                alias: 'number'
            }
        ],
        'int-literal': {
            pattern: /\b\d+[iu]?\b/,
            alias: 'number'
        },
        operator: [
            {
                pattern: /(?:\^|~|\|(?!\|)|\|\||&&|<<|>>|!)(?!=)/
            },
            {
                pattern: /&(?![&=])/
            },
            {
                pattern: /(?:\+=|-=|\*=|\/=|%=|\^=|&=|\|=|<<=|>>=)/
            },
            {
                pattern: /(^|[^<>=!])=(?![=>])/,
                lookbehind: true
            },
            {
                pattern: /(?:==|!=|<=|\+\+|--|(^|[^=])>=)/,
                lookbehind: true
            },
            {
                pattern: /(?:(?:[+%]|(?:\*(?!\w)))(?!=))|(?:-(?!>))|(?:\/(?!\/))/
            },
            {
                pattern: /->/
            }
        ],
        punctuation: /[@(){}[\],;<>:.]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$d595a484a1962a9e$export$2e2bcd8739ae039.displayName = 'wiki';
$d595a484a1962a9e$export$2e2bcd8739ae039.aliases = [];
function $d595a484a1962a9e$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $8fbeea7c20d72e06$export$2e2bcd8739ae039));
    Prism.languages.wiki = Prism.languages.extend('markup', {
        'block-comment': {
            pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
            lookbehind: true,
            alias: 'comment'
        },
        heading: {
            pattern: /^(=+)[^=\r\n].*?\1/m,
            inside: {
                punctuation: /^=+|=+$/,
                important: /.+/
            }
        },
        emphasis: {
            // TODO Multi-line
            pattern: /('{2,5}).+?\1/,
            inside: {
                'bold-italic': {
                    pattern: /(''''').+?(?=\1)/,
                    lookbehind: true,
                    alias: [
                        'bold',
                        'italic'
                    ]
                },
                bold: {
                    pattern: /(''')[^'](?:.*?[^'])?(?=\1)/,
                    lookbehind: true
                },
                italic: {
                    pattern: /('')[^'](?:.*?[^'])?(?=\1)/,
                    lookbehind: true
                },
                punctuation: /^''+|''+$/
            }
        },
        hr: {
            pattern: /^-{4,}/m,
            alias: 'punctuation'
        },
        url: [
            /ISBN +(?:97[89][ -]?)?(?:\d[ -]?){9}[\dx]\b|(?:PMID|RFC) +\d+/i,
            /\[\[.+?\]\]|\[.+?\]/
        ],
        variable: [
            /__[A-Z]+__/,
            // FIXME Nested structures should be handled
            // {{formatnum:{{#expr:{{{3}}}}}}}
            /\{{3}.+?\}{3}/,
            /\{\{.+?\}\}/
        ],
        symbol: [
            /^#redirect/im,
            /~{3,5}/
        ],
        // Handle table attrs:
        // {|
        // ! style="text-align:left;"| Item
        // |}
        'table-tag': {
            pattern: /((?:^|[|!])[|!])[^|\r\n]+\|(?!\|)/m,
            lookbehind: true,
            inside: {
                'table-bar': {
                    pattern: /\|$/,
                    alias: 'punctuation'
                },
                rest: Prism.languages.markup['tag'].inside
            }
        },
        punctuation: /^(?:\{\||\|\}|\|-|[*#:;!|])|\|\||!!/m
    });
    Prism.languages.insertBefore('wiki', 'tag', {
        // Prevent highlighting inside <nowiki>, <source> and <pre> tags
        nowiki: {
            pattern: /<(nowiki|pre|source)\b[^>]*>[\s\S]*?<\/\1>/i,
            inside: {
                tag: {
                    pattern: /<(?:nowiki|pre|source)\b[^>]*>|<\/(?:nowiki|pre|source)>/i,
                    inside: Prism.languages.markup['tag'].inside
                }
            }
        }
    });
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $68aeea185b71a2d0$export$2e2bcd8739ae039.displayName = 'wolfram';
$68aeea185b71a2d0$export$2e2bcd8739ae039.aliases = [
    'mathematica',
    'nb',
    'wl'
];
function $68aeea185b71a2d0$export$2e2bcd8739ae039(Prism) {
    Prism.languages.wolfram = {
        comment: // Allow one level of nesting - note: regex taken from applescipt
        /\(\*(?:\(\*(?:[^*]|\*(?!\)))*\*\)|(?!\(\*)[\s\S])*?\*\)/,
        string: {
            pattern: /"(?:\\.|[^"\\\r\n])*"/,
            greedy: true
        },
        keyword: /\b(?:Abs|AbsArg|Accuracy|Block|Do|For|Function|If|Manipulate|Module|Nest|NestList|None|Return|Switch|Table|Which|While)\b/,
        context: {
            pattern: /\b\w+`+\w*/,
            alias: 'class-name'
        },
        blank: {
            pattern: /\b\w+_\b/,
            alias: 'regex'
        },
        'global-variable': {
            pattern: /\$\w+/,
            alias: 'variable'
        },
        boolean: /\b(?:False|True)\b/,
        number: /(?:\b(?=\d)|\B(?=\.))(?:0[bo])?(?:(?:\d|0x[\da-f])[\da-f]*(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?j?\b/i,
        operator: /\/\.|;|=\.|\^=|\^:=|:=|<<|>>|<\||\|>|:>|\|->|->|<-|@@@|@@|@|\/@|=!=|===|==|=|\+|-|\[\/-+%=\]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
        punctuation: /[{}[\];(),.:]/
    };
    Prism.languages.mathematica = Prism.languages.wolfram;
    Prism.languages.wl = Prism.languages.wolfram;
    Prism.languages.nb = Prism.languages.wolfram;
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $70de300ff39a1f3b$export$2e2bcd8739ae039.displayName = 'wren';
$70de300ff39a1f3b$export$2e2bcd8739ae039.aliases = [];
function $70de300ff39a1f3b$export$2e2bcd8739ae039(Prism) {
    // https://wren.io/
    Prism.languages.wren = {
        // Multiline comments in Wren can have nested multiline comments
        // Comments: // and /* */
        comment: [
            {
                // support 3 levels of nesting
                // regex: \/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\/
                pattern: /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*))*\*\/)*\*\/)*\*\//,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        // Triple quoted strings are multiline but cannot have interpolation (raw strings)
        // Based on prism-python.js
        'triple-quoted-string': {
            pattern: /"""[\s\S]*?"""/,
            greedy: true,
            alias: 'string'
        },
        // see below
        'string-literal': null,
        // #!/usr/bin/env wren on the first line
        hashbang: {
            pattern: /^#!\/.+/,
            greedy: true,
            alias: 'comment'
        },
        // Attributes are special keywords to add meta data to classes
        attribute: {
            // #! attributes are stored in class properties
            // #!myvar = true
            // #attributes are not stored and dismissed at compilation
            pattern: /#!?[ \t\u3000]*\w+/,
            alias: 'keyword'
        },
        'class-name': [
            {
                // class definition
                // class Meta {}
                pattern: /(\bclass\s+)\w+/,
                lookbehind: true
            },
            // A class must always start with an uppercase.
            // File.read
            /\b[A-Z][a-z\d_]*\b/
        ],
        // A constant can be a variable, class, property or method. Just named in all uppercase letters
        constant: /\b[A-Z][A-Z\d_]*\b/,
        null: {
            pattern: /\bnull\b/,
            alias: 'keyword'
        },
        keyword: /\b(?:as|break|class|construct|continue|else|for|foreign|if|import|in|is|return|static|super|this|var|while)\b/,
        boolean: /\b(?:false|true)\b/,
        number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i,
        // Functions can be Class.method()
        function: /\b[a-z_]\w*(?=\s*[({])/i,
        operator: /<<|>>|[=!<>]=?|&&|\|\||[-+*/%~^&|?:]|\.{2,3}/,
        punctuation: /[\[\](){}.,;]/
    };
    Prism.languages.wren['string-literal'] = {
        // A single quote string is multiline and can have interpolation (similar to JS backticks ``)
        pattern: /(^|[^\\"])"(?:[^\\"%]|\\[\s\S]|%(?!\()|%\((?:[^()]|\((?:[^()]|\([^)]*\))*\))*\))*"/,
        lookbehind: true,
        greedy: true,
        inside: {
            interpolation: {
                // "%(interpolation)"
                pattern: /((?:^|[^\\])(?:\\{2})*)%\((?:[^()]|\((?:[^()]|\([^)]*\))*\))*\)/,
                lookbehind: true,
                inside: {
                    expression: {
                        pattern: /^(%\()[\s\S]+(?=\)$)/,
                        lookbehind: true,
                        inside: Prism.languages.wren
                    },
                    'interpolation-punctuation': {
                        pattern: /^%\(|\)$/,
                        alias: 'punctuation'
                    }
                }
            },
            string: /[\s\S]+/
        }
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$fdeb598fcd5b1665$export$2e2bcd8739ae039.displayName = 'xeora';
$fdeb598fcd5b1665$export$2e2bcd8739ae039.aliases = [
    'xeoracube'
];
function $fdeb598fcd5b1665$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $8fbeea7c20d72e06$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.xeora = Prism.languages.extend('markup', {
            constant: {
                pattern: /\$(?:DomainContents|PageRenderDuration)\$/,
                inside: {
                    punctuation: {
                        pattern: /\$/
                    }
                }
            },
            variable: {
                pattern: /\$@?(?:#+|[-+*~=^])?[\w.]+\$/,
                inside: {
                    punctuation: {
                        pattern: /[$.]/
                    },
                    operator: {
                        pattern: /#+|[-+*~=^@]/
                    }
                }
            },
            'function-inline': {
                pattern: /\$F:[-\w.]+\?[-\w.]+(?:,(?:(?:@[-#]*\w+\.[\w+.]\.*)*\|)*(?:(?:[\w+]|[-#*.~^]+[\w+]|=\S)(?:[^$=]|=+[^=])*=*|(?:@[-#]*\w+\.[\w+.]\.*)+(?:(?:[\w+]|[-#*~^][-#*.~^]*[\w+]|=\S)(?:[^$=]|=+[^=])*=*)?)?)?\$/,
                inside: {
                    variable: {
                        pattern: /(?:[,|])@?(?:#+|[-+*~=^])?[\w.]+/,
                        inside: {
                            punctuation: {
                                pattern: /[,.|]/
                            },
                            operator: {
                                pattern: /#+|[-+*~=^@]/
                            }
                        }
                    },
                    punctuation: {
                        pattern: /\$\w:|[$:?.,|]/
                    }
                },
                alias: 'function'
            },
            'function-block': {
                pattern: /\$XF:\{[-\w.]+\?[-\w.]+(?:,(?:(?:@[-#]*\w+\.[\w+.]\.*)*\|)*(?:(?:[\w+]|[-#*.~^]+[\w+]|=\S)(?:[^$=]|=+[^=])*=*|(?:@[-#]*\w+\.[\w+.]\.*)+(?:(?:[\w+]|[-#*~^][-#*.~^]*[\w+]|=\S)(?:[^$=]|=+[^=])*=*)?)?)?\}:XF\$/,
                inside: {
                    punctuation: {
                        pattern: /[$:{}?.,|]/
                    }
                },
                alias: 'function'
            },
            'directive-inline': {
                pattern: /\$\w(?:#\d+\+?)?(?:\[[-\w.]+\])?:[-\/\w.]+\$/,
                inside: {
                    punctuation: {
                        pattern: /\$(?:\w:|C(?:\[|#\d))?|[:{[\]]/,
                        inside: {
                            tag: {
                                pattern: /#\d/
                            }
                        }
                    }
                },
                alias: 'function'
            },
            'directive-block-open': {
                pattern: /\$\w+:\{|\$\w(?:#\d+\+?)?(?:\[[-\w.]+\])?:[-\w.]+:\{(?:![A-Z]+)?/,
                inside: {
                    punctuation: {
                        pattern: /\$(?:\w:|C(?:\[|#\d))?|[:{[\]]/,
                        inside: {
                            tag: {
                                pattern: /#\d/
                            }
                        }
                    },
                    attribute: {
                        pattern: /![A-Z]+$/,
                        inside: {
                            punctuation: {
                                pattern: /!/
                            }
                        },
                        alias: 'keyword'
                    }
                },
                alias: 'function'
            },
            'directive-block-separator': {
                pattern: /\}:[-\w.]+:\{/,
                inside: {
                    punctuation: {
                        pattern: /[:{}]/
                    }
                },
                alias: 'function'
            },
            'directive-block-close': {
                pattern: /\}:[-\w.]+\$/,
                inside: {
                    punctuation: {
                        pattern: /[:{}$]/
                    }
                },
                alias: 'function'
            }
        });
        Prism.languages.insertBefore('inside', 'punctuation', {
            variable: Prism.languages.xeora['function-inline'].inside['variable']
        }, Prism.languages.xeora['function-block']);
        Prism.languages.xeoracube = Prism.languages.xeora;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$7112d806a0282692$export$2e2bcd8739ae039.displayName = 'xml-doc';
$7112d806a0282692$export$2e2bcd8739ae039.aliases = [];
function $7112d806a0282692$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $8fbeea7c20d72e06$export$2e2bcd8739ae039));
    (function(Prism) {
        /**
     * If the given language is present, it will insert the given doc comment grammar token into it.
     *
     * @param {string} lang
     * @param {any} docComment
     */ function insertDocComment(lang, docComment) {
            if (Prism.languages[lang]) Prism.languages.insertBefore(lang, 'comment', {
                'doc-comment': docComment
            });
        }
        var tag = Prism.languages.markup.tag;
        var slashDocComment = {
            pattern: /\/\/\/.*/,
            greedy: true,
            alias: 'comment',
            inside: {
                tag: tag
            }
        };
        var tickDocComment = {
            pattern: /'''.*/,
            greedy: true,
            alias: 'comment',
            inside: {
                tag: tag
            }
        };
        insertDocComment('csharp', slashDocComment);
        insertDocComment('fsharp', slashDocComment);
        insertDocComment('vbnet', tickDocComment);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $033659d7b3c389e9$export$2e2bcd8739ae039.displayName = 'xojo';
$033659d7b3c389e9$export$2e2bcd8739ae039.aliases = [];
function $033659d7b3c389e9$export$2e2bcd8739ae039(Prism) {
    Prism.languages.xojo = {
        comment: {
            pattern: /(?:'|\/\/|Rem\b).+/i,
            greedy: true
        },
        string: {
            pattern: /"(?:""|[^"])*"/,
            greedy: true
        },
        number: [
            /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
            /&[bchou][a-z\d]+/i
        ],
        directive: {
            pattern: /#(?:Else|ElseIf|Endif|If|Pragma)\b/i,
            alias: 'property'
        },
        keyword: /\b(?:AddHandler|App|Array|As(?:signs)?|Auto|Boolean|Break|By(?:Ref|Val)|Byte|Call|Case|Catch|CFStringRef|CGFloat|Class|Color|Const|Continue|CString|Currency|CurrentMethodName|Declare|Delegate|Dim|Do(?:uble|wnTo)?|Each|Else(?:If)?|End|Enumeration|Event|Exception|Exit|Extends|False|Finally|For|Function|Get|GetTypeInfo|Global|GOTO|If|Implements|In|Inherits|Int(?:8|16|32|64|eger|erface)?|Lib|Loop|Me|Module|Next|Nil|Object|Optional|OSType|ParamArray|Private|Property|Protected|PString|Ptr|Raise(?:Event)?|ReDim|RemoveHandler|Return|Select(?:or)?|Self|Set|Shared|Short|Single|Soft|Static|Step|String|Sub|Super|Text|Then|To|True|Try|Ubound|UInt(?:8|16|32|64|eger)?|Until|Using|Var(?:iant)?|Wend|While|WindowPtr|WString)\b/i,
        operator: /<[=>]?|>=?|[+\-*\/\\^=]|\b(?:AddressOf|And|Ctype|IsA?|Mod|New|Not|Or|WeakAddressOf|Xor)\b/i,
        punctuation: /[.,;:()]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ 
$dd4d22383240ce4c$export$2e2bcd8739ae039.displayName = 'xquery';
$dd4d22383240ce4c$export$2e2bcd8739ae039.aliases = [];
function $dd4d22383240ce4c$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $8fbeea7c20d72e06$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.xquery = Prism.languages.extend('markup', {
            'xquery-comment': {
                pattern: /\(:[\s\S]*?:\)/,
                greedy: true,
                alias: 'comment'
            },
            string: {
                pattern: /(["'])(?:\1\1|(?!\1)[\s\S])*\1/,
                greedy: true
            },
            extension: {
                pattern: /\(#.+?#\)/,
                alias: 'symbol'
            },
            variable: /\$[-\w:]+/,
            axis: {
                pattern: /(^|[^-])(?:ancestor(?:-or-self)?|attribute|child|descendant(?:-or-self)?|following(?:-sibling)?|parent|preceding(?:-sibling)?|self)(?=::)/,
                lookbehind: true,
                alias: 'operator'
            },
            'keyword-operator': {
                pattern: /(^|[^:-])\b(?:and|castable as|div|eq|except|ge|gt|idiv|instance of|intersect|is|le|lt|mod|ne|or|union)\b(?=$|[^:-])/,
                lookbehind: true,
                alias: 'operator'
            },
            keyword: {
                pattern: /(^|[^:-])\b(?:as|ascending|at|base-uri|boundary-space|case|cast as|collation|construction|copy-namespaces|declare|default|descending|else|empty (?:greatest|least)|encoding|every|external|for|function|if|import|in|inherit|lax|let|map|module|namespace|no-inherit|no-preserve|option|order(?: by|ed|ing)?|preserve|return|satisfies|schema|some|stable|strict|strip|then|to|treat as|typeswitch|unordered|validate|variable|version|where|xquery)\b(?=$|[^:-])/,
                lookbehind: true
            },
            function: /[\w-]+(?::[\w-]+)*(?=\s*\()/,
            'xquery-element': {
                pattern: /(element\s+)[\w-]+(?::[\w-]+)*/,
                lookbehind: true,
                alias: 'tag'
            },
            'xquery-attribute': {
                pattern: /(attribute\s+)[\w-]+(?::[\w-]+)*/,
                lookbehind: true,
                alias: 'attr-name'
            },
            builtin: {
                pattern: /(^|[^:-])\b(?:attribute|comment|document|element|processing-instruction|text|xs:(?:ENTITIES|ENTITY|ID|IDREFS?|NCName|NMTOKENS?|NOTATION|Name|QName|anyAtomicType|anyType|anyURI|base64Binary|boolean|byte|date|dateTime|dayTimeDuration|decimal|double|duration|float|gDay|gMonth|gMonthDay|gYear|gYearMonth|hexBinary|int|integer|language|long|negativeInteger|nonNegativeInteger|nonPositiveInteger|normalizedString|positiveInteger|short|string|time|token|unsigned(?:Byte|Int|Long|Short)|untyped(?:Atomic)?|yearMonthDuration))\b(?=$|[^:-])/,
                lookbehind: true
            },
            number: /\b\d+(?:\.\d+)?(?:E[+-]?\d+)?/,
            operator: [
                /[+*=?|@]|\.\.?|:=|!=|<[=<]?|>[=>]?/,
                {
                    pattern: /(\s)-(?=\s)/,
                    lookbehind: true
                }
            ],
            punctuation: /[[\](){},;:/]/
        });
        Prism.languages.xquery.tag.pattern = /<\/?(?!\d)[^\s>\/=$<%]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/;
        Prism.languages.xquery['tag'].inside['attr-value'].pattern = /=(?:("|')(?:\\[\s\S]|\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}|(?!\1)[^\\])*\1|[^\s'">=]+)/;
        Prism.languages.xquery['tag'].inside['attr-value'].inside['punctuation'] = /^="|"$/;
        Prism.languages.xquery['tag'].inside['attr-value'].inside['expression'] = {
            // Allow for two levels of nesting
            pattern: /\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}/,
            inside: Prism.languages.xquery,
            alias: 'language-xquery'
        };
        // The following will handle plain text inside tags
        var stringifyToken = function(token) {
            if (typeof token === 'string') return token;
            if (typeof token.content === 'string') return token.content;
            return token.content.map(stringifyToken).join('');
        };
        var walkTokens = function(tokens) {
            var openedTags = [];
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                var notTagNorBrace = false;
                if (typeof token !== 'string') {
                    if (token.type === 'tag' && token.content[0] && token.content[0].type === 'tag') {
                        // We found a tag, now find its kind
                        if (token.content[0].content[0].content === '</') // Closing tag
                        {
                            if (openedTags.length > 0 && openedTags[openedTags.length - 1].tagName === stringifyToken(token.content[0].content[1])) // Pop matching opening tag
                            openedTags.pop();
                        } else {
                            if (token.content[token.content.length - 1].content === '/>') ;
                            else // Opening tag
                            openedTags.push({
                                tagName: stringifyToken(token.content[0].content[1]),
                                openedBraces: 0
                            });
                        }
                    } else if (openedTags.length > 0 && token.type === 'punctuation' && token.content === '{' && // Ignore `{{`
                    (!tokens[i + 1] || tokens[i + 1].type !== 'punctuation' || tokens[i + 1].content !== '{') && (!tokens[i - 1] || tokens[i - 1].type !== 'plain-text' || tokens[i - 1].content !== '{')) // Here we might have entered an XQuery expression inside a tag
                    openedTags[openedTags.length - 1].openedBraces++;
                    else if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces > 0 && token.type === 'punctuation' && token.content === '}') // Here we might have left an XQuery expression inside a tag
                    openedTags[openedTags.length - 1].openedBraces--;
                    else if (token.type !== 'comment') notTagNorBrace = true;
                }
                if (notTagNorBrace || typeof token === 'string') {
                    if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces === 0) {
                        // Here we are inside a tag, and not inside an XQuery expression.
                        // That's plain text: drop any tokens matched.
                        var plainText = stringifyToken(token);
                        // And merge text with adjacent text
                        if (i < tokens.length - 1 && (typeof tokens[i + 1] === 'string' || tokens[i + 1].type === 'plain-text')) {
                            plainText += stringifyToken(tokens[i + 1]);
                            tokens.splice(i + 1, 1);
                        }
                        if (i > 0 && (typeof tokens[i - 1] === 'string' || tokens[i - 1].type === 'plain-text')) {
                            plainText = stringifyToken(tokens[i - 1]) + plainText;
                            tokens.splice(i - 1, 1);
                            i--;
                        }
                        if (/^\s+$/.test(plainText)) tokens[i] = plainText;
                        else tokens[i] = new Prism.Token('plain-text', plainText, null, plainText);
                    }
                }
                if (token.content && typeof token.content !== 'string') walkTokens(token.content);
            }
        };
        Prism.hooks.add('after-tokenize', function(env) {
            if (env.language !== 'xquery') return;
            walkTokens(env.tokens);
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $975f0076412f8fa5$export$2e2bcd8739ae039.displayName = 'yang';
$975f0076412f8fa5$export$2e2bcd8739ae039.aliases = [];
function $975f0076412f8fa5$export$2e2bcd8739ae039(Prism) {
    Prism.languages.yang = {
        // https://tools.ietf.org/html/rfc6020#page-34
        // http://www.yang-central.org/twiki/bin/view/Main/YangExamples
        comment: /\/\*[\s\S]*?\*\/|\/\/.*/,
        string: {
            pattern: /"(?:[^\\"]|\\.)*"|'[^']*'/,
            greedy: true
        },
        keyword: {
            pattern: /(^|[{};\r\n][ \t]*)[a-z_][\w.-]*/i,
            lookbehind: true
        },
        namespace: {
            pattern: /(\s)[a-z_][\w.-]*(?=:)/i,
            lookbehind: true
        },
        boolean: /\b(?:false|true)\b/,
        operator: /\+/,
        punctuation: /[{};:]/
    };
}


// @ts-nocheck
/**
 * @import {Syntax} from '../core.js'
 */ $e411bd09bcaa3c3a$export$2e2bcd8739ae039.displayName = 'zig';
$e411bd09bcaa3c3a$export$2e2bcd8739ae039.aliases = [];
function $e411bd09bcaa3c3a$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        function literal(str) {
            return function() {
                return str;
            };
        }
        var keyword = /\b(?:align|allowzero|and|anyframe|anytype|asm|async|await|break|cancel|catch|comptime|const|continue|defer|else|enum|errdefer|error|export|extern|fn|for|if|inline|linksection|nakedcc|noalias|nosuspend|null|or|orelse|packed|promise|pub|resume|return|stdcallcc|struct|suspend|switch|test|threadlocal|try|undefined|union|unreachable|usingnamespace|var|volatile|while)\b/;
        var IDENTIFIER = '\\b(?!' + keyword.source + ')(?!\\d)\\w+\\b';
        var ALIGN = /align\s*\((?:[^()]|\([^()]*\))*\)/.source;
        var PREFIX_TYPE_OP = /(?:\?|\bpromise->|(?:\[[^[\]]*\]|\*(?!\*)|\*\*)(?:\s*<ALIGN>|\s*const\b|\s*volatile\b|\s*allowzero\b)*)/.source.replace(/<ALIGN>/g, literal(ALIGN));
        var SUFFIX_EXPR = /(?:\bpromise\b|(?:\berror\.)?<ID>(?:\.<ID>)*(?!\s+<ID>))/.source.replace(/<ID>/g, literal(IDENTIFIER));
        var TYPE = '(?!\\s)(?:!?\\s*(?:' + PREFIX_TYPE_OP + '\\s*)*' + SUFFIX_EXPR + ')+';
        /*
     * A simplified grammar for Zig compile time type literals:
     *
     * TypeExpr = ( "!"? PREFIX_TYPE_OP* SUFFIX_EXPR )+
     *
     * SUFFIX_EXPR = ( \b "promise" \b | ( \b "error" "." )? IDENTIFIER ( "." IDENTIFIER )* (?! \s+ IDENTIFIER ) )
     *
     * PREFIX_TYPE_OP = "?"
     *                | \b "promise" "->"
     *                | ( "[" [^\[\]]* "]" | "*" | "**" ) ( ALIGN | "const" \b | "volatile" \b | "allowzero" \b )*
     *
     * ALIGN = "align" "(" ( [^()] | "(" [^()]* ")" )* ")"
     *
     * IDENTIFIER = \b (?! KEYWORD ) [a-zA-Z_] \w* \b
     *
     */ Prism.languages.zig = {
            comment: [
                {
                    pattern: /\/\/[/!].*/,
                    alias: 'doc-comment'
                },
                /\/{2}.*/
            ],
            string: [
                {
                    // "string" and c"string"
                    pattern: /(^|[^\\@])c?"(?:[^"\\\r\n]|\\.)*"/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    // multiline strings and c-strings
                    pattern: /([\r\n])([ \t]+c?\\{2}).*(?:(?:\r\n?|\n)\2.*)*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            char: {
                // characters 'a', '\n', '\xFF', '\u{10FFFF}'
                pattern: /(^|[^\\])'(?:[^'\\\r\n]|[\uD800-\uDFFF]{2}|\\(?:.|x[a-fA-F\d]{2}|u\{[a-fA-F\d]{1,6}\}))'/,
                lookbehind: true,
                greedy: true
            },
            builtin: /\B@(?!\d)\w+(?=\s*\()/,
            label: {
                pattern: /(\b(?:break|continue)\s*:\s*)\w+\b|\b(?!\d)\w+\b(?=\s*:\s*(?:\{|while\b))/,
                lookbehind: true
            },
            'class-name': [
                // const Foo = struct {};
                /\b(?!\d)\w+(?=\s*=\s*(?:(?:extern|packed)\s+)?(?:enum|struct|union)\s*[({])/,
                {
                    // const x: i32 = 9;
                    // var x: Bar;
                    // fn foo(x: bool, y: f32) void {}
                    pattern: RegExp(/(:\s*)<TYPE>(?=\s*(?:<ALIGN>\s*)?[=;,)])|<TYPE>(?=\s*(?:<ALIGN>\s*)?\{)/.source.replace(/<TYPE>/g, literal(TYPE)).replace(/<ALIGN>/g, literal(ALIGN))),
                    lookbehind: true,
                    inside: null // see below
                },
                {
                    // extern fn foo(x: f64) f64; (optional alignment)
                    pattern: RegExp(/(\)\s*)<TYPE>(?=\s*(?:<ALIGN>\s*)?;)/.source.replace(/<TYPE>/g, literal(TYPE)).replace(/<ALIGN>/g, literal(ALIGN))),
                    lookbehind: true,
                    inside: null // see below
                }
            ],
            'builtin-type': {
                pattern: /\b(?:anyerror|bool|c_u?(?:int|long|longlong|short)|c_longdouble|c_void|comptime_(?:float|int)|f(?:16|32|64|128)|[iu](?:8|16|32|64|128|size)|noreturn|type|void)\b/,
                alias: 'keyword'
            },
            keyword: keyword,
            function: /\b(?!\d)\w+(?=\s*\()/,
            number: /\b(?:0b[01]+|0o[0-7]+|0x[a-fA-F\d]+(?:\.[a-fA-F\d]*)?(?:[pP][+-]?[a-fA-F\d]+)?|\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)\b/,
            boolean: /\b(?:false|true)\b/,
            operator: /\.[*?]|\.{2,3}|[-=]>|\*\*|\+\+|\|\||(?:<<|>>|[-+*]%|[-+*/%^&|<>!=])=?|[?~]/,
            punctuation: /[.:,;(){}[\]]/
        };
        Prism.languages.zig['class-name'].forEach(function(obj) {
            if (obj.inside === null) obj.inside = Prism.languages.zig;
        });
    })(Prism);
}



(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $8fbeea7c20d72e06$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $c8ae87468323f6e6$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $4ad80295cf222241$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $f19e6959a3616e08$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $9f5c72e4d4e505c4$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $f7f469a09d2923f1$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $f2c34d5b5036ea21$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $9c5777c951754348$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $3fbcaee7f13cf525$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $1e3beec4fc9f23f6$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $11e7abe0f8ae59d5$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $25cd74edc1a4e282$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $e56b6d9acce907cb$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $d138d4e60ec637d4$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $f6a7ab632d408f5f$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $b46a22bd2beca28f$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $b984cf4709600aa3$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $ccd0ef58eb523678$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $e064275ae5958777$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $48c36581818e331d$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $b8123b708c3d0c30$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $efa7ad86ceca52d0$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $67cc3be7e12a4376$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $34bd8604ec75c450$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $d56cfd3d329eea2c$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $99679268fa665931$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $4ebb7b212204c818$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $0ad35299f0183166$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $e1ab06973c0a6c0a$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $2444ca6586008229$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $b537db6f9f7bc622$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $d40a6e41fa1845ea$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $b19cc59852e2480c$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $17b2b51b5d1fc4c1$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $f4a134fc3ae6bf3d$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $cbb6560f9029869a$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $967d57fc0e7de922$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $11df1c7abcd7aa92$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $8b0b331041684e32$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $20a170561b9d92de$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $5808f16c368df70d$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $ca8b23f8f4c3551e$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $06c073f7d52d479c$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $5e72be8fe18bd064$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $c71f9922480b0744$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $a3d00393544ce230$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $cf785f3588045cda$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $59fc0f93be148eaa$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $76e312b5f9c1dafd$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $2959da9e8e9aaa6e$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $f2f07591da692ef4$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $d89c7404fbd627bd$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $798968c11c0bc12d$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $5aff22135ddd5819$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $6d8a360147f50c03$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $078c1acafabfb52e$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $cee2ea6304aada5e$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $691efb0e9b94d4ac$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $d990e59e4070f253$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $a3d3743a5475e600$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $d243e507e31dca19$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $a1e229080488625c$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $f215d4aafad64c17$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $1024f633e11e96f5$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $81ed84b8749657d1$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $6a669cbb1cd34ac4$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $e44e89ab2dc97a78$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $03bb8bfbcc096edb$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $538c836732b1c8a0$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $313c3e47a28a32fd$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $6a0fa37bec677708$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $ec2377a3ba62255c$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $4e5f3564e17eab03$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $c79f4752b8ecb9f9$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $5f6e332fbf45b5ef$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $a400735491c1aa4e$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $e041944f5d00c63c$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $73ad660dd1c97629$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $9f0d5922b028f25a$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $2a574647ed928968$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $39e923bc942f1557$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $b4ba574bb0c7b7ad$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $1b81107a7b5ce4f8$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $167758c4a2bcd476$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $eec348ce27e7d8ad$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $f4c7bf5b97ed8197$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $3350a7c50307d503$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $e103275a4fe1cf8e$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $c96ec64ee90c7f15$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $62620c15354b1402$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $456b4755eb59d7fa$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $d0a70735eb9f5348$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $1d7ed5492e362bb6$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $53271749677b9f40$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $5540e33516f385a9$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $0d2da194b5281e11$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $16a86fc228919017$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $1b6187306027f2b6$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $c0df2d899927fa32$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $9da0023f8b18122c$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $1180e16820c68a4b$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $d9207b1e3b2f4a30$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $6e91e40129219b4e$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $6b2780e9071d1692$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $ae0c3767cd329fa7$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $1d9d3eed717d4843$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $fd4037dcd4da1450$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $b9e8ba6248f02e58$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $f1312a50584a5846$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $baa978ee70a8092e$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $44f129dcd2f3d3cd$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $266db073fe988064$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $d9761534803b6b12$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $47c726b1edca75eb$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $5b589dc50921a1c0$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $50318a28f67a9ccf$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $69a27b40c3c43adf$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $e08e083f92fc8aa0$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $764f1e53d8d49149$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $0a2709da981e5d8c$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $26270207db713fa6$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $1cfef378e309df5d$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $7e7fbe9aa72823ed$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $336784a38a667aef$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $ff1650a614471816$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $0e2de5a532079e2e$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $15d2f325237e0784$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $06e94734974cdb6c$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $dd4e0ac0e264206b$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $68defdc6cd38bdb4$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $6b343a6bc0ab8052$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $4cb476895e94c36f$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $7486a97757b46985$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $765305b27b262a69$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $9f4b875c06247633$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $12ff858fac87095b$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $7beef303dd5ba8d6$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $9daff9909ad10959$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $68ea9a70b77f88ea$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $158311e91e281aed$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $3fdb7058e3046f24$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $500308337cc8fd8d$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $a16ebd91e2b74520$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $759ff8712e89417d$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $ec82644279b505a3$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $156df7f34267ef47$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $b479671e17d8160f$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $4d6acca9e6f19adf$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $971aaf7f210ab43d$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $1ffd3d64aa89c36a$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $bb03f40051b66d6c$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $eb9ff5d3299d2f78$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $ab6ad1272fe5d0de$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $7aed4cc800fa5add$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $d044b3e9acc7ccc1$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $b96993469faeeb1c$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $7c30d02132551dfa$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $1ee6f3ef2718464c$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $354a467a21a053bd$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $4cdbc21cd3056574$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $d3fcd032b357bb2d$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $450490f6a0da68bd$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $28745139b7e39184$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $c6a13ead09099e31$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $5474249eecc23269$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $635a44d6d212f42f$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $289de95df67c09ba$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $07724378ac8681ca$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $129c4ebc87b64902$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $96cdba00d04057e5$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $6ab3d3339ebbb87d$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $6f023dee4f5684a2$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $d5e8803a0ecb1a4c$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $896766ac97cf30fc$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $de9f82a08ba821dd$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $2a76ed9e2036f609$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $aabfe52eb8bf425f$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $04f7e8ee922eafab$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $bd38c279ea049f97$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $ac6fd29ed90881aa$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $56ed3f40b114f9da$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $211dce0e13dad2bb$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $2bee048455602adf$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $b35e937e9517d15f$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $a13fb2bc0247ad39$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $67ac6d7ef8b75c7a$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $40cfb9ef16e11da4$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $35e43dc81d081cb9$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $125d6a9ccb15ad01$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $f42e340bf35f0931$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $75633cf46d2c1f4a$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $1bff446789010f5a$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $97c725d8f828cda7$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $659db1e49ba3c889$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $cd9a564d21652aa1$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $e05990136349c4df$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $b7975b7b5bfae0d4$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $2f2929915e467e10$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $54b2f524a651ec09$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $cdc3b5076c1ba432$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $93a3c4102cd2d290$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $1b15ceff9a8a0e6b$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $c030b773dec3817a$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $e41f426c5f9f53ed$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $b6257d9e504bba06$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $2051cf815a16bf4c$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $f6aa5d7625509f98$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $10a061d2d8575bf9$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $d29e8f3c68872260$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $45fbb76bf789e0a2$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $e226b64ac0fbc6f8$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $62afefd0906ae624$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $c0a064543930cbfc$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $28775ad983a33289$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $99e8dd8f6b35dcc4$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $b6c4f78e62cb8bfe$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $685367727897b6e2$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $3a8d0988a68f18f1$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $fdca6bde44738939$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $6e4ccd37e0cb374b$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $86460e0d73a40885$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $ee80061b022a92ec$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $0061c6e41b3a4570$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $4bd4f4ed7632711a$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $d5b21f8d3d5d8ce1$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $166c94860a240118$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $89a20c95494c3404$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $d7dbc2fe5eb92f6c$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $be31e43f53721fa6$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $d93e8cacda7cdd1f$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $df89008fdd9898a1$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $8f8e297012e12c77$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $18e4422100889798$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $5a7f23f7c27bdf2d$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $ddc9cfbdf3ae03e6$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $d2abd9c8c48957cf$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $e6d237a9cb4c3d5f$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $e688140d88bbf085$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $6ad9cfd191d928bf$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $0382dbd2a40e4691$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $d57abbe2a1fb24f1$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $9916e53b415a0d4b$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $51c5d77fbea0c80e$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $57faf12dcc554420$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $f68bbd0409e49719$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $fd46c9753d6b17f5$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $c02a8ca6bc5c05f7$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $c1218d553691b555$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $a403180e6d9b6e5a$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $06c969704178cca0$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $c964236cd184e11d$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $7a0bad4c5f491fc6$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $294be4aa5b92251c$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $a2bb05d986dace6b$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $1848b7039ce8121b$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $9d31fc816d6fcc6c$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $b378706f71f4008e$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $f2508382838b5b34$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $ef926d412abc34a9$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $e656c717edb0fe18$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $95debfda020aeb85$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $4d275be294286983$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $81adf7b0e724d48d$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $07912fa463f18ff4$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $cfa4e33b24acc9a0$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $51899036da79c505$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $f6729417cfa54226$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $398c5bff0b970a81$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $20f4ee0703b4f693$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $df26257a89ddaec0$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $d7ef411c4285b1f9$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $011c2c67b24b2834$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $e5a2f3fd754dcba1$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $a36665b93fb978c8$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $42c1d84a70d4c560$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $e3eeeb1b10048f63$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $767b96663a8577d6$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $2e5ae03d6489eb63$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $0fb6d91d2cc339cb$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $a354882a5ae49c2a$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $0089cfef22bc1b0d$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $0b8dc39b7929d21d$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $e73f907dadddc458$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $faf2e69849cc2214$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $765e7f252f771396$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $44804e313ed480d5$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $7233d4a8ed8a1afe$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $0c8f23efcfcfc76d$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $d595a484a1962a9e$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $68aeea185b71a2d0$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $70de300ff39a1f3b$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $fdeb598fcd5b1665$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $7112d806a0282692$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $033659d7b3c389e9$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $dd4d22383240ce4c$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $975f0076412f8fa5$export$2e2bcd8739ae039));
(0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390).register((0, $e411bd09bcaa3c3a$export$2e2bcd8739ae039));


function $e62a4495d284aec6$var$a() {
    $e62a4495d284aec6$var$a = function(e, r) {
        return new t(e, void 0, r);
    };
    var e = RegExp.prototype, r = new WeakMap;
    function t(e, n, i) {
        var o = new RegExp(e, n);
        return r.set(o, i || r.get(e)), $e62a4495d284aec6$var$l(o, t.prototype);
    }
    function n(e, t) {
        var n = r.get(t);
        return Object.keys(n).reduce(function(r, t) {
            var i = n[t];
            if ("number" == typeof i) r[t] = e[i];
            else {
                for(var o = 0; void 0 === e[i[o]] && o + 1 < i.length;)o++;
                r[t] = e[i[o]];
            }
            return r;
        }, Object.create(null));
    }
    return function(e, r) {
        if ("function" != typeof r && null !== r) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(r && r.prototype, {
            constructor: {
                value: e,
                writable: !0,
                configurable: !0
            }
        }), Object.defineProperty(e, "prototype", {
            writable: !1
        }), r && $e62a4495d284aec6$var$l(e, r);
    }(t, RegExp), t.prototype.exec = function(r) {
        var t = e.exec.call(this, r);
        if (t) {
            t.groups = n(t, this);
            var i = t.indices;
            i && (i.groups = n(i, this));
        }
        return t;
    }, t.prototype[Symbol.replace] = function(t, i) {
        if ("string" == typeof i) {
            var o = r.get(this);
            return e[Symbol.replace].call(this, t, i.replace(/\$<([^>]+)>/g, function(e, r) {
                var t = o[r];
                return "$" + (Array.isArray(t) ? t.join("$") : t);
            }));
        }
        if ("function" == typeof i) {
            var a = this;
            return e[Symbol.replace].call(this, t, function() {
                var e = arguments;
                return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(n(e, a)), i.apply(this, e);
            });
        }
        return e[Symbol.replace].call(this, t, i);
    }, $e62a4495d284aec6$var$a.apply(this, arguments);
}
function $e62a4495d284aec6$var$l(e, r) {
    return $e62a4495d284aec6$var$l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, r) {
        return e.__proto__ = r, e;
    }, $e62a4495d284aec6$var$l(e, r);
}
function $e62a4495d284aec6$var$s(e, r) {
    (null == r || r > e.length) && (r = e.length);
    for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
    return n;
}
function $e62a4495d284aec6$var$u(e, r) {
    var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (t) return (t = t.call(e)).next.bind(t);
    if (Array.isArray(e) || (t = function(e, r) {
        if (e) {
            if ("string" == typeof e) return $e62a4495d284aec6$var$s(e, r);
            var t = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e62a4495d284aec6$var$s(e, r) : void 0;
        }
    }(e)) || r && e && "number" == typeof e.length) {
        t && (e = t);
        var n = 0;
        return function() {
            return n >= e.length ? {
                done: !0
            } : {
                done: !1,
                value: e[n++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $e62a4495d284aec6$export$f80b9a7578ac06a = function(i) {
    return function(o) {
        return void 0 === o && (o = {}), function(e, r) {
            if (r && !e.registered(r)) throw new Error('The default language "' + r + '" is not registered with refractor.');
        }(i, o.defaultLanguage), function(r) {
            (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(r, "element", l);
        };
        function l(e, l, s) {
            var c, p;
            if (s && "pre" === s.tagName && "code" === e.tagName) {
                var f = (null == e || null == (c = e.data) ? void 0 : c.meta) || (null == e || null == (p = e.properties) ? void 0 : p.metastring) || "";
                e.properties.className ? "boolean" == typeof e.properties.className ? e.properties.className = [] : Array.isArray(e.properties.className) || (e.properties.className = [
                    e.properties.className
                ]) : e.properties.className = [];
                var m, h, d = function(e) {
                    for(var r, t = $e62a4495d284aec6$var$u(e.properties.className); !(r = t()).done;){
                        var n = r.value;
                        if ("language-" === n.slice(0, 9)) return n.slice(9).toLowerCase();
                    }
                    return null;
                }(e);
                if (!d && o.defaultLanguage && e.properties.className.push("language-" + (d = o.defaultLanguage)), e.properties.className.push("code-highlight"), d) try {
                    var g, v;
                    v = null != (g = d) && g.includes("diff-") ? d.split("-")[1] : d, m = i.highlight((0, $58714581718e6349$export$f84e8e69fd4488a5)(e), v), s.properties.className = (s.properties.className || []).concat("language-" + v);
                } catch (r) {
                    if (!o.ignoreMissing || !/Unknown language/.test(r.message)) throw r;
                    m = e;
                }
                else m = e;
                m.children = (h = 1, function e(r) {
                    return r.reduce(function(r, t) {
                        if ("text" === t.type) {
                            var n = t.value, i = (n.match(/\n/g) || "").length;
                            if (0 === i) t.position = {
                                start: {
                                    line: h,
                                    column: 1
                                },
                                end: {
                                    line: h,
                                    column: 1
                                }
                            }, r.push(t);
                            else for(var o, a = n.split("\n"), l = $e62a4495d284aec6$var$u(a.entries()); !(o = l()).done;){
                                var s = o.value, c = s[0], p = s[1];
                                r.push({
                                    type: "text",
                                    value: c === a.length - 1 ? p : p + "\n",
                                    position: {
                                        start: {
                                            line: h + c,
                                            column: 1
                                        },
                                        end: {
                                            line: h + c,
                                            column: 1
                                        }
                                    }
                                });
                            }
                            return h += i, r;
                        }
                        if (Object.prototype.hasOwnProperty.call(t, "children")) {
                            var f = h;
                            return t.children = e(t.children), r.push(t), t.position = {
                                start: {
                                    line: f,
                                    column: 1
                                },
                                end: {
                                    line: h,
                                    column: 1
                                }
                            }, r;
                        }
                        return r.push(t), r;
                    }, []);
                })(m.children), m.position = m.children.length > 0 ? {
                    start: {
                        line: m.children[0].position.start.line,
                        column: 0
                    },
                    end: {
                        line: m.children[m.children.length - 1].position.end.line,
                        column: 0
                    }
                } : {
                    start: {
                        line: 0,
                        column: 0
                    },
                    end: {
                        line: 0,
                        column: 0
                    }
                };
                for(var y, b = function(e) {
                    var r = /{([\d,-]+)}/, t = e.split(",").map(function(e) {
                        return e.trim();
                    }).join();
                    if (r.test(t)) {
                        var i = r.exec(t)[1], o = (0, (/*@__PURE__*/$parcel$interopDefault($97f2cf7466aff99c$exports)))(i);
                        return function(e) {
                            return o.includes(e + 1);
                        };
                    }
                    return function() {
                        return !1;
                    };
                }(f), w = function(e) {
                    var r = /*#__PURE__*/ $e62a4495d284aec6$var$a(/showLineNumbers=(\d+)/i, {
                        lines: 1
                    });
                    if (r.test(e)) {
                        var t = r.exec(e);
                        return Number(t.groups.lines);
                    }
                    return 1;
                }(f), N = function(e) {
                    for(var r = new Array(e), t = 0; t < e; t++)r[t] = {
                        type: "element",
                        tagName: "span",
                        properties: {
                            className: []
                        },
                        children: []
                    };
                    return r;
                }(m.position.end.line), j = [
                    "showlinenumbers=false",
                    'showlinenumbers="false"',
                    "showlinenumbers={false}"
                ], x = function() {
                    var e, n, i = y.value, a = i[0], l = i[1];
                    l.properties.className = [
                        "code-line"
                    ];
                    var s = (0, $31e44c919774b7ea$export$3dea766d36a8935f)(m, function(e) {
                        return e.position.start.line <= a + 1 && e.position.end.line >= a + 1;
                    });
                    l.children = s.children, !f.toLowerCase().includes("showLineNumbers".toLowerCase()) && !o.showLineNumbers || j.some(function(e) {
                        return f.toLowerCase().includes(e);
                    }) || (l.properties.line = [
                        (a + w).toString()
                    ], l.properties.className.push("line-number")), b(a) && l.properties.className.push("highlight-line"), ("diff" === d || null != (e = d) && e.includes("diff-")) && "-" === (0, $58714581718e6349$export$f84e8e69fd4488a5)(l).substring(0, 1) ? l.properties.className.push("deleted") : ("diff" === d || null != (n = d) && n.includes("diff-")) && "+" === (0, $58714581718e6349$export$f84e8e69fd4488a5)(l).substring(0, 1) && l.properties.className.push("inserted");
                }, O = $e62a4495d284aec6$var$u(N.entries()); !(y = O()).done;)x();
                N.length > 0 && "" === (0, $58714581718e6349$export$f84e8e69fd4488a5)(N[N.length - 1]).trim() && N.pop(), e.children = N;
            }
        }
    };
}, $e62a4495d284aec6$export$d63bd6a97105214e = $e62a4495d284aec6$export$f80b9a7578ac06a((0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390)), $e62a4495d284aec6$export$2e2bcd8739ae039 = $e62a4495d284aec6$export$f80b9a7578ac06a((0, $2a7ecb442ccfd5e3$export$1c6435d0b8e9f390));



/**
 * @import {AstSelector} from 'css-selector-parser'
 * @import {Element, Nodes, RootContent} from 'hast'
 * @import {Schema} from 'property-information'
 */ /**
 * @typedef {'html' | 'svg'} Space
 *   Name of namespace.
 *
 * @typedef {'auto' | 'ltr' | 'rtl'} Direction
 *   Direction.
 *
 * @typedef State
 *   Current state.
 * @property {Direction} direction
 *   Current direction.
 * @property {boolean} editableOrEditingHost
 *   Whether we’re in `contentEditable`.
 * @property {number | undefined} elementCount
 *   Track siblings: there are `n` siblings.
 * @property {number | undefined} elementIndex
 *   Track siblings: this current element has `n` elements before it.
 * @property {boolean} found
 *   Whether we found at least one match.
 * @property {string | undefined} language
 *   Current language.
 * @property {boolean} one
 *   Whether we can stop looking after we found one element.
 * @property {Array<Element>} results
 *   Matches.
 * @property {AstSelector} rootQuery
 *   Original root selectors.
 * @property {Schema} schema
 *   Current schema.
 * @property {Array<RootContent>} scopeElements
 *   Elements in scope.
 * @property {boolean} shallow
 *   Whether we only allow selectors without nesting.
 * @property {number | undefined} typeCount
 *   Track siblings: there are `n` siblings with this element’s tag name.
 * @property {number | undefined} typeIndex
 *   Track siblings: this current element has `n` elements with its tag name
 *   before it.
 */ 
/**
 * @import {AstSelector} from 'css-selector-parser'
 */ var $dde9b3bc5b1e1c4d$export$fd2ef7d56085a14e = {};
var $dde9b3bc5b1e1c4d$export$e5ec415068eb8990 = {};
function $dde9b3bc5b1e1c4d$var$extendIndex(item, index) {
    var currentIndex = index;
    for(var pos = 0; pos < item.length; pos++){
        var isLast = pos === item.length - 1;
        var char = item.charAt(pos);
        var charIndex = currentIndex[char] || (currentIndex[char] = {
            chars: {}
        });
        if (isLast) charIndex.self = item;
        currentIndex = charIndex.chars;
    }
}
function $dde9b3bc5b1e1c4d$export$fd845abd87c3ff7(items) {
    if (items.length === 0) return $dde9b3bc5b1e1c4d$export$fd2ef7d56085a14e;
    var index = {};
    for(var _i = 0, items_1 = items; _i < items_1.length; _i++){
        var item = items_1[_i];
        $dde9b3bc5b1e1c4d$var$extendIndex(item, index);
    }
    return index;
}
function $dde9b3bc5b1e1c4d$export$90ad197f4c3d269d(items) {
    if (items.length === 0) return $dde9b3bc5b1e1c4d$export$e5ec415068eb8990;
    var result = {};
    for(var _i = 0, items_2 = items; _i < items_2.length; _i++){
        var item = items_2[_i];
        result[item] = true;
    }
    return result;
}


var $e589bf2e4bc2ee64$export$f2d6fbb4761a05b2 = {};
var $e589bf2e4bc2ee64$export$2860e7ac7b9acf6d = {
    type: 'String',
    optional: true
};
function $e589bf2e4bc2ee64$var$calculatePseudoSignature(types) {
    var result = {
        type: 'NoArgument',
        optional: false
    };
    function setResultType(type) {
        if (result.type && result.type !== type && result.type !== 'NoArgument') throw new Error("Conflicting pseudo-class argument type: \"".concat(result.type, "\" vs \"").concat(type, "\"."));
        result.type = type;
    }
    for(var _i = 0, types_1 = types; _i < types_1.length; _i++){
        var type = types_1[_i];
        if (type === 'NoArgument') result.optional = true;
        if (type === 'Formula') setResultType('Formula');
        if (type === 'FormulaOfSelector') {
            setResultType('Formula');
            result.ofSelector = true;
        }
        if (type === 'String') setResultType('String');
        if (type === 'Selector') setResultType('Selector');
    }
    return result;
}
function $e589bf2e4bc2ee64$export$c8d0a76456c41dc2(obj) {
    var result = {};
    for(var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++){
        var category = _a[_i];
        var items = obj[category];
        if (items) for(var _b = 0, _c = items; _b < _c.length; _b++){
            var item = _c[_b];
            (result[item] || (result[item] = [])).push(category);
        }
    }
    return result;
}
function $e589bf2e4bc2ee64$export$3e512c88fa08ef5(definitions) {
    var pseudoClassesToArgumentTypes = $e589bf2e4bc2ee64$export$c8d0a76456c41dc2(definitions);
    var result = {};
    for(var _i = 0, _a = Object.keys(pseudoClassesToArgumentTypes); _i < _a.length; _i++){
        var pseudoClass = _a[_i];
        var argumentTypes = pseudoClassesToArgumentTypes[pseudoClass];
        if (argumentTypes) result[pseudoClass] = $e589bf2e4bc2ee64$var$calculatePseudoSignature(argumentTypes);
    }
    return result;
}


var $f67c0075e21dfa5b$var$__assign = undefined && undefined.__assign || function() {
    $f67c0075e21dfa5b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f67c0075e21dfa5b$var$__assign.apply(this, arguments);
};
var $f67c0075e21dfa5b$var$emptyXmlOptions = {};
var $f67c0075e21dfa5b$var$defaultXmlOptions = {
    wildcard: true
};
function $f67c0075e21dfa5b$export$21f18aac0f802d79(param) {
    if (param) {
        if (typeof param === 'boolean') return $f67c0075e21dfa5b$var$defaultXmlOptions;
        else return param;
    } else return $f67c0075e21dfa5b$var$emptyXmlOptions;
}
function $f67c0075e21dfa5b$var$withMigration(migration, merge) {
    return function(base, extension) {
        return merge(migration(base), migration(extension));
    };
}
function $f67c0075e21dfa5b$var$withNoNegative(merge) {
    return function(base, extension) {
        var result = merge(base, extension);
        if (!result) throw new Error("Syntax definition cannot be null or undefined.");
        return result;
    };
}
function $f67c0075e21dfa5b$var$withPositive(positive, merge) {
    return function(base, extension) {
        if (extension === true) return positive;
        return merge(base === true ? positive : base, extension);
    };
}
function $f67c0075e21dfa5b$var$mergeSection(values) {
    return function(base, extension) {
        if (!extension || !base) return extension;
        if (typeof extension !== 'object' || extension === null) throw new Error("Unexpected syntax definition extension type: ".concat(extension, "."));
        var result = $f67c0075e21dfa5b$var$__assign({}, base);
        for(var _i = 0, _a = Object.entries(extension); _i < _a.length; _i++){
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (key === 'latest') continue;
            var mergeSchema = values[key];
            result[key] = mergeSchema(base[key], value);
        }
        return result;
    };
}
function $f67c0075e21dfa5b$var$replaceValueIfSpecified(base, extension) {
    if (extension !== undefined) return extension;
    return base;
}
function $f67c0075e21dfa5b$var$concatArray(base, extension) {
    if (!extension) return base;
    if (!base) return extension;
    return base.concat(extension);
}
function $f67c0075e21dfa5b$var$mergeDefinitions(base, extension) {
    if (!extension) return base;
    if (!base) return extension;
    var result = $f67c0075e21dfa5b$var$__assign({}, base);
    for(var _i = 0, _a = Object.entries(extension); _i < _a.length; _i++){
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (!value) {
            delete result[key];
            continue;
        }
        var baseValue = base[key];
        if (!baseValue) {
            result[key] = value;
            continue;
        }
        result[key] = baseValue.concat(value);
    }
    return result;
}
var $f67c0075e21dfa5b$export$e482e55c173ab6 = $f67c0075e21dfa5b$var$withNoNegative($f67c0075e21dfa5b$var$mergeSection({
    baseSyntax: $f67c0075e21dfa5b$var$replaceValueIfSpecified,
    modules: $f67c0075e21dfa5b$var$concatArray,
    tag: $f67c0075e21dfa5b$var$withPositive($f67c0075e21dfa5b$var$defaultXmlOptions, $f67c0075e21dfa5b$var$mergeSection({
        wildcard: $f67c0075e21dfa5b$var$replaceValueIfSpecified
    })),
    ids: $f67c0075e21dfa5b$var$replaceValueIfSpecified,
    classNames: $f67c0075e21dfa5b$var$replaceValueIfSpecified,
    nestingSelector: $f67c0075e21dfa5b$var$replaceValueIfSpecified,
    namespace: $f67c0075e21dfa5b$var$withPositive($f67c0075e21dfa5b$var$defaultXmlOptions, $f67c0075e21dfa5b$var$mergeSection({
        wildcard: $f67c0075e21dfa5b$var$replaceValueIfSpecified
    })),
    combinators: $f67c0075e21dfa5b$var$concatArray,
    attributes: $f67c0075e21dfa5b$var$mergeSection({
        operators: $f67c0075e21dfa5b$var$concatArray,
        caseSensitivityModifiers: $f67c0075e21dfa5b$var$concatArray,
        unknownCaseSensitivityModifiers: $f67c0075e21dfa5b$var$replaceValueIfSpecified
    }),
    pseudoClasses: $f67c0075e21dfa5b$var$mergeSection({
        unknown: $f67c0075e21dfa5b$var$replaceValueIfSpecified,
        definitions: $f67c0075e21dfa5b$var$mergeDefinitions
    }),
    pseudoElements: $f67c0075e21dfa5b$var$mergeSection({
        unknown: $f67c0075e21dfa5b$var$replaceValueIfSpecified,
        notation: $f67c0075e21dfa5b$var$replaceValueIfSpecified,
        definitions: $f67c0075e21dfa5b$var$withMigration(function(definitions) {
            return Array.isArray(definitions) ? {
                NoArgument: definitions
            } : definitions;
        }, $f67c0075e21dfa5b$var$mergeDefinitions)
    })
}));
var $f67c0075e21dfa5b$var$css1SyntaxDefinition = {
    tag: {},
    ids: true,
    classNames: true,
    combinators: [],
    pseudoElements: {
        unknown: 'reject',
        notation: 'singleColon',
        definitions: [
            'first-letter',
            'first-line'
        ]
    },
    pseudoClasses: {
        unknown: 'reject',
        definitions: {
            NoArgument: [
                'link',
                'visited',
                'active'
            ]
        }
    }
};
var $f67c0075e21dfa5b$var$css2SyntaxDefinition = $f67c0075e21dfa5b$export$e482e55c173ab6($f67c0075e21dfa5b$var$css1SyntaxDefinition, {
    tag: {
        wildcard: true
    },
    combinators: [
        '>',
        '+'
    ],
    attributes: {
        unknownCaseSensitivityModifiers: 'reject',
        operators: [
            '=',
            '~=',
            '|='
        ]
    },
    pseudoElements: {
        definitions: [
            'before',
            'after'
        ]
    },
    pseudoClasses: {
        unknown: 'reject',
        definitions: {
            NoArgument: [
                'hover',
                'focus',
                'first-child'
            ],
            String: [
                'lang'
            ]
        }
    }
});
var $f67c0075e21dfa5b$var$selectors3SyntaxDefinition = $f67c0075e21dfa5b$export$e482e55c173ab6($f67c0075e21dfa5b$var$css2SyntaxDefinition, {
    namespace: {
        wildcard: true
    },
    combinators: [
        '~'
    ],
    attributes: {
        operators: [
            '^=',
            '$=',
            '*='
        ]
    },
    pseudoElements: {
        notation: 'both'
    },
    pseudoClasses: {
        definitions: {
            NoArgument: [
                'root',
                'last-child',
                'first-of-type',
                'last-of-type',
                'only-child',
                'only-of-type',
                'empty',
                'target',
                'enabled',
                'disabled',
                'checked',
                'indeterminate'
            ],
            Formula: [
                'nth-child',
                'nth-last-child',
                'nth-of-type',
                'nth-last-of-type'
            ],
            Selector: [
                'not'
            ]
        }
    }
});
var $f67c0075e21dfa5b$var$selectors4SyntaxDefinition = $f67c0075e21dfa5b$export$e482e55c173ab6($f67c0075e21dfa5b$var$selectors3SyntaxDefinition, {
    combinators: [
        '||'
    ],
    attributes: {
        caseSensitivityModifiers: [
            'i',
            'I',
            's',
            'S'
        ]
    },
    pseudoClasses: {
        definitions: {
            NoArgument: [
                'any-link',
                'local-link',
                'target-within',
                'scope',
                'current',
                'past',
                'future',
                'focus-within',
                'focus-visible',
                'read-write',
                'read-only',
                'placeholder-shown',
                'default',
                'valid',
                'invalid',
                'in-range',
                'out-of-range',
                'required',
                'optional',
                'blank',
                'user-invalid',
                'playing',
                'paused',
                'autofill',
                'modal',
                'fullscreen',
                'picture-in-picture',
                'defined',
                'loading',
                'popover-open'
            ],
            Formula: [
                'nth-col',
                'nth-last-col'
            ],
            String: [
                'dir'
            ],
            FormulaOfSelector: [
                'nth-child',
                'nth-last-child'
            ],
            Selector: [
                'current',
                'is',
                'where',
                'has',
                'state'
            ]
        }
    },
    pseudoElements: {
        definitions: {
            NoArgument: [
                'marker'
            ]
        }
    }
});
var $f67c0075e21dfa5b$export$f2154c9edd9fd6d5 = {
    'css-position-1': {
        latest: false,
        pseudoClasses: {
            definitions: {
                NoArgument: [
                    'static',
                    'relative',
                    'absolute'
                ]
            }
        }
    },
    'css-position-2': {
        latest: false,
        pseudoClasses: {
            definitions: {
                NoArgument: [
                    'static',
                    'relative',
                    'absolute',
                    'fixed'
                ]
            }
        }
    },
    'css-position-3': {
        latest: false,
        pseudoClasses: {
            definitions: {
                NoArgument: [
                    'sticky',
                    'fixed',
                    'absolute',
                    'relative',
                    'static'
                ]
            }
        }
    },
    'css-position-4': {
        latest: true,
        pseudoClasses: {
            definitions: {
                NoArgument: [
                    'sticky',
                    'fixed',
                    'absolute',
                    'relative',
                    'static',
                    'initial'
                ]
            }
        }
    },
    'css-scoping-1': {
        latest: true,
        pseudoClasses: {
            definitions: {
                NoArgument: [
                    'host',
                    'host-context'
                ],
                Selector: [
                    'host',
                    'host-context'
                ]
            }
        },
        pseudoElements: {
            definitions: {
                Selector: [
                    'slotted'
                ]
            }
        }
    },
    'css-pseudo-4': {
        latest: true,
        pseudoElements: {
            definitions: {
                NoArgument: [
                    'marker',
                    'selection',
                    'target-text',
                    'search-text',
                    'spelling-error',
                    'grammar-error',
                    'backdrop',
                    'file-selector-button',
                    'prefix',
                    'postfix',
                    'placeholder',
                    'details-content'
                ],
                String: [
                    'highlight'
                ]
            }
        }
    },
    'css-shadow-parts-1': {
        latest: true,
        pseudoElements: {
            definitions: {
                String: [
                    'part'
                ]
            }
        }
    },
    'css-nesting-1': {
        latest: true,
        nestingSelector: true
    }
};
var $f67c0075e21dfa5b$var$latestSyntaxDefinition = $f67c0075e21dfa5b$var$__assign($f67c0075e21dfa5b$var$__assign({}, $f67c0075e21dfa5b$var$selectors4SyntaxDefinition), {
    modules: Object.entries($f67c0075e21dfa5b$export$f2154c9edd9fd6d5).filter(function(_a) {
        var latest = _a[1].latest;
        return latest;
    }).map(function(_a) {
        var name = _a[0];
        return name;
    })
});
var $f67c0075e21dfa5b$var$progressiveSyntaxDefinition = $f67c0075e21dfa5b$export$e482e55c173ab6($f67c0075e21dfa5b$var$latestSyntaxDefinition, {
    pseudoElements: {
        unknown: 'accept'
    },
    pseudoClasses: {
        unknown: 'accept'
    },
    attributes: {
        unknownCaseSensitivityModifiers: 'accept'
    }
});
var $f67c0075e21dfa5b$export$a62db26b89cc3840 = {
    css1: $f67c0075e21dfa5b$var$css1SyntaxDefinition,
    css2: $f67c0075e21dfa5b$var$css2SyntaxDefinition,
    css3: $f67c0075e21dfa5b$var$selectors3SyntaxDefinition,
    'selectors-3': $f67c0075e21dfa5b$var$selectors3SyntaxDefinition,
    'selectors-4': $f67c0075e21dfa5b$var$selectors4SyntaxDefinition,
    latest: $f67c0075e21dfa5b$var$latestSyntaxDefinition,
    progressive: $f67c0075e21dfa5b$var$progressiveSyntaxDefinition
};
function $f67c0075e21dfa5b$export$936d38df95fb257() {
    var index = {
        pseudoClasses: {},
        pseudoElements: {}
    };
    // Add CSS Levels (excluding 'latest' and 'progressive')
    var cssLevels = [
        'css1',
        'css2',
        'css3',
        'selectors-3',
        'selectors-4'
    ];
    for(var _i = 0, cssLevels_1 = cssLevels; _i < cssLevels_1.length; _i++){
        var level = cssLevels_1[_i];
        var syntax = $f67c0075e21dfa5b$export$a62db26b89cc3840[level];
        // Process pseudo-classes
        if (syntax.pseudoClasses && typeof syntax.pseudoClasses === 'object') {
            var definitions = syntax.pseudoClasses.definitions;
            if (definitions) for(var _a = 0, _b = Object.entries(definitions); _a < _b.length; _a++){
                var _c = _b[_a], names = _c[1];
                for(var _d = 0, names_1 = names; _d < names_1.length; _d++){
                    var name_1 = names_1[_d];
                    if (!index.pseudoClasses[name_1]) index.pseudoClasses[name_1] = [];
                    if (!index.pseudoClasses[name_1].includes(level)) index.pseudoClasses[name_1].push(level);
                }
            }
        }
        // Process pseudo-elements
        if (syntax.pseudoElements && typeof syntax.pseudoElements === 'object') {
            var definitions = syntax.pseudoElements.definitions;
            if (definitions) {
                if (Array.isArray(definitions)) for(var _e = 0, definitions_1 = definitions; _e < definitions_1.length; _e++){
                    var name_2 = definitions_1[_e];
                    if (!index.pseudoElements[name_2]) index.pseudoElements[name_2] = [];
                    if (!index.pseudoElements[name_2].includes(level)) index.pseudoElements[name_2].push(level);
                }
                else for(var _f = 0, _g = Object.values(definitions); _f < _g.length; _f++){
                    var names = _g[_f];
                    for(var _h = 0, names_2 = names; _h < names_2.length; _h++){
                        var name_3 = names_2[_h];
                        if (!index.pseudoElements[name_3]) index.pseudoElements[name_3] = [];
                        if (!index.pseudoElements[name_3].includes(level)) index.pseudoElements[name_3].push(level);
                    }
                }
            }
        }
    }
    // Add CSS Modules
    for(var _j = 0, _k = Object.entries($f67c0075e21dfa5b$export$f2154c9edd9fd6d5); _j < _k.length; _j++){
        var _l = _k[_j], moduleName = _l[0], moduleSyntax = _l[1];
        // Process pseudo-classes
        if (moduleSyntax.pseudoClasses && typeof moduleSyntax.pseudoClasses === 'object') {
            var definitions = moduleSyntax.pseudoClasses.definitions;
            if (definitions) for(var _m = 0, _o = Object.values(definitions); _m < _o.length; _m++){
                var names = _o[_m];
                for(var _p = 0, names_3 = names; _p < names_3.length; _p++){
                    var name_4 = names_3[_p];
                    if (!index.pseudoClasses[name_4]) index.pseudoClasses[name_4] = [];
                    if (!index.pseudoClasses[name_4].includes(moduleName)) index.pseudoClasses[name_4].push(moduleName);
                }
            }
        }
        // Process pseudo-elements
        if (moduleSyntax.pseudoElements && typeof moduleSyntax.pseudoElements === 'object') {
            var definitions = moduleSyntax.pseudoElements.definitions;
            if (definitions) {
                if (Array.isArray(definitions)) for(var _q = 0, definitions_2 = definitions; _q < definitions_2.length; _q++){
                    var name_5 = definitions_2[_q];
                    if (!index.pseudoElements[name_5]) index.pseudoElements[name_5] = [];
                    if (!index.pseudoElements[name_5].includes(moduleName)) index.pseudoElements[name_5].push(moduleName);
                }
                else for(var _r = 0, _s = Object.values(definitions); _r < _s.length; _r++){
                    var names = _s[_r];
                    for(var _t = 0, names_4 = names; _t < names_4.length; _t++){
                        var name_6 = names_4[_t];
                        if (!index.pseudoElements[name_6]) index.pseudoElements[name_6] = [];
                        if (!index.pseudoElements[name_6].includes(moduleName)) index.pseudoElements[name_6].push(moduleName);
                    }
                }
            }
        }
    }
    return index;
}
var $f67c0075e21dfa5b$export$dd1b971945cbb3c7 = $f67c0075e21dfa5b$export$936d38df95fb257();


function $ddae313f2cb96861$export$25af8346f6239c5b(c) {
    return c >= 'a' && c <= 'z' || c >= 'A' && c <= 'Z' || c === '-' || c === '_' || c === '\\' || c >= '\u00a0';
}
function $ddae313f2cb96861$export$63c9ecd03a955e6b(c) {
    return c >= 'a' && c <= 'z' || c >= 'A' && c <= 'Z' || c >= '0' && c <= '9' || c === '-' || c === '_' || c >= '\u00a0';
}
function $ddae313f2cb96861$export$8a9b6341a7c96bc(c) {
    return c >= 'a' && c <= 'f' || c >= 'A' && c <= 'F' || c >= '0' && c <= '9';
}
var $ddae313f2cb96861$export$3c7f85fa1719c0df = {
    '!': true,
    '"': true,
    '#': true,
    $: true,
    '%': true,
    '&': true,
    "'": true,
    '(': true,
    ')': true,
    '*': true,
    '+': true,
    ',': true,
    '.': true,
    '/': true,
    ';': true,
    '<': true,
    '=': true,
    '>': true,
    '?': true,
    '@': true,
    '[': true,
    '\\': true,
    ']': true,
    '^': true,
    '`': true,
    '{': true,
    '|': true,
    '}': true,
    '~': true
};
var $ddae313f2cb96861$export$85b7ce609d55feb0 = {
    '\n': true,
    '\r': true,
    '\t': true,
    '\f': true,
    '\v': true
};
var $ddae313f2cb96861$export$f451d7af9c363592 = {
    ' ': true,
    '\t': true,
    '\n': true,
    '\r': true,
    '\f': true
};
var $ddae313f2cb96861$export$4a6f40ec9a9f93d = {
    '"': true,
    "'": true
};
var $ddae313f2cb96861$export$4772887ab32e45a3 = {
    0: true,
    1: true,
    2: true,
    3: true,
    4: true,
    5: true,
    6: true,
    7: true,
    8: true,
    9: true
};
var $ddae313f2cb96861$export$1fccc43cb8f7bfd2 = 6;
function $ddae313f2cb96861$export$56fe274825607f4a(s) {
    var len = s.length;
    var result = '';
    var i = 0;
    while(i < len){
        var chr = s.charAt(i);
        if ($ddae313f2cb96861$export$3c7f85fa1719c0df[chr] || chr === '-' && i === 1 && s.charAt(0) === '-') result += '\\' + chr;
        else if (chr === '-' || chr === '_' || chr >= 'A' && chr <= 'Z' || chr >= 'a' && chr <= 'z' || chr >= '0' && chr <= '9' && i !== 0 && !(i === 1 && s.charAt(0) === '-')) result += chr;
        else {
            var charCode = chr.charCodeAt(0);
            if ((charCode & 0xf800) === 0xd800) {
                var extraCharCode = s.charCodeAt(i++);
                if ((charCode & 0xfc00) !== 0xd800 || (extraCharCode & 0xfc00) !== 0xdc00) throw Error('UCS-2(decode): illegal sequence');
                charCode = ((charCode & 0x3ff) << 10) + (extraCharCode & 0x3ff) + 0x10000;
            }
            result += '\\' + charCode.toString(16) + ' ';
        }
        i++;
    }
    return result.trim();
}
function $ddae313f2cb96861$export$4148cf4a40af9f34(s) {
    var len = s.length;
    var result = '';
    var i = 0;
    while(i < len){
        var chr = s.charAt(i);
        if (chr === '"') chr = '\\"';
        else if (chr === '\\') chr = '\\\\';
        else if ($ddae313f2cb96861$export$85b7ce609d55feb0[chr]) chr = '\\' + chr.charCodeAt(0).toString(16) + (i === len - 1 ? '' : ' ');
        result += chr;
        i++;
    }
    return "\"".concat(result, "\"");
}


var $7b881788824fe7ce$var$errorPrefix = "css-selector-parser parse error: ";
function $7b881788824fe7ce$export$88a1156fad04455f(options) {
    if (options === void 0) options = {};
    var _a = options.syntax, syntax = _a === void 0 ? 'latest' : _a, substitutes = options.substitutes, _b = options.strict, strict = _b === void 0 ? true : _b, modules = options.modules;
    var syntaxDefinition = typeof syntax === 'object' ? syntax : (0, $f67c0075e21dfa5b$export$a62db26b89cc3840)[syntax];
    if (syntaxDefinition.baseSyntax) syntaxDefinition = (0, $f67c0075e21dfa5b$export$e482e55c173ab6)((0, $f67c0075e21dfa5b$export$a62db26b89cc3840)[syntaxDefinition.baseSyntax], syntaxDefinition);
    // Apply modules from syntax definition
    if (syntaxDefinition.modules && syntaxDefinition.modules.length > 0) for(var _i = 0, _c = syntaxDefinition.modules; _i < _c.length; _i++){
        var module_1 = _c[_i];
        var moduleSyntax = (0, $f67c0075e21dfa5b$export$f2154c9edd9fd6d5)[module_1];
        if (moduleSyntax) syntaxDefinition = (0, $f67c0075e21dfa5b$export$e482e55c173ab6)(moduleSyntax, syntaxDefinition);
    }
    // Apply additional modules if specified from options
    if (modules && modules.length > 0) for(var _d = 0, modules_1 = modules; _d < modules_1.length; _d++){
        var module_2 = modules_1[_d];
        var moduleSyntax = (0, $f67c0075e21dfa5b$export$f2154c9edd9fd6d5)[module_2];
        if (moduleSyntax) syntaxDefinition = (0, $f67c0075e21dfa5b$export$e482e55c173ab6)(moduleSyntax, syntaxDefinition);
    }
    var _e = syntaxDefinition.tag ? [
        true,
        Boolean((0, $f67c0075e21dfa5b$export$21f18aac0f802d79)(syntaxDefinition.tag).wildcard)
    ] : [
        false,
        false
    ], tagNameEnabled = _e[0], tagNameWildcardEnabled = _e[1];
    var idEnabled = Boolean(syntaxDefinition.ids);
    var classNamesEnabled = Boolean(syntaxDefinition.classNames);
    var nestingSelectorEnabled = Boolean(syntaxDefinition.nestingSelector);
    var namespaceEnabled = Boolean(syntaxDefinition.namespace);
    var namespaceWildcardEnabled = syntaxDefinition.namespace && (syntaxDefinition.namespace === true || syntaxDefinition.namespace.wildcard === true);
    if (namespaceEnabled && !tagNameEnabled) throw new Error("".concat($7b881788824fe7ce$var$errorPrefix, "Namespaces cannot be enabled while tags are disabled."));
    var substitutesEnabled = Boolean(substitutes);
    var combinatorsIndex = syntaxDefinition.combinators ? (0, $dde9b3bc5b1e1c4d$export$fd845abd87c3ff7)(syntaxDefinition.combinators) : (0, $dde9b3bc5b1e1c4d$export$fd2ef7d56085a14e);
    var _f = syntaxDefinition.attributes ? [
        true,
        syntaxDefinition.attributes.operators ? (0, $dde9b3bc5b1e1c4d$export$fd845abd87c3ff7)(syntaxDefinition.attributes.operators) : (0, $dde9b3bc5b1e1c4d$export$fd2ef7d56085a14e),
        syntaxDefinition.attributes.caseSensitivityModifiers ? (0, $dde9b3bc5b1e1c4d$export$90ad197f4c3d269d)(syntaxDefinition.attributes.caseSensitivityModifiers) : (0, $dde9b3bc5b1e1c4d$export$e5ec415068eb8990),
        syntaxDefinition.attributes.unknownCaseSensitivityModifiers === 'accept'
    ] : [
        false,
        (0, $dde9b3bc5b1e1c4d$export$fd2ef7d56085a14e),
        (0, $dde9b3bc5b1e1c4d$export$e5ec415068eb8990),
        false
    ], attributesEnabled = _f[0], attributesOperatorsIndex = _f[1], attributesCaseSensitivityModifiers = _f[2], attributesAcceptUnknownCaseSensitivityModifiers = _f[3];
    var attributesCaseSensitivityModifiersEnabled = attributesAcceptUnknownCaseSensitivityModifiers || Object.keys(attributesCaseSensitivityModifiers).length > 0;
    var _g = syntaxDefinition.pseudoClasses ? [
        true,
        syntaxDefinition.pseudoClasses.definitions ? (0, $e589bf2e4bc2ee64$export$3e512c88fa08ef5)(syntaxDefinition.pseudoClasses.definitions) : (0, $e589bf2e4bc2ee64$export$f2d6fbb4761a05b2),
        syntaxDefinition.pseudoClasses.unknown === 'accept'
    ] : [
        false,
        (0, $e589bf2e4bc2ee64$export$f2d6fbb4761a05b2),
        false
    ], pseudoClassesEnabled = _g[0], pseudoClassesDefinitions = _g[1], pseudoClassesAcceptUnknown = _g[2];
    var _h = syntaxDefinition.pseudoElements ? [
        true,
        syntaxDefinition.pseudoElements.notation === 'singleColon' || syntaxDefinition.pseudoElements.notation === 'both',
        !syntaxDefinition.pseudoElements.notation || syntaxDefinition.pseudoElements.notation === 'doubleColon' || syntaxDefinition.pseudoElements.notation === 'both',
        syntaxDefinition.pseudoElements.definitions ? (0, $e589bf2e4bc2ee64$export$3e512c88fa08ef5)(Array.isArray(syntaxDefinition.pseudoElements.definitions) ? {
            NoArgument: syntaxDefinition.pseudoElements.definitions
        } : syntaxDefinition.pseudoElements.definitions) : (0, $e589bf2e4bc2ee64$export$f2d6fbb4761a05b2),
        syntaxDefinition.pseudoElements.unknown === 'accept'
    ] : [
        false,
        false,
        false,
        (0, $e589bf2e4bc2ee64$export$f2d6fbb4761a05b2),
        false
    ], pseudoElementsEnabled = _h[0], pseudoElementsSingleColonNotationEnabled = _h[1], pseudoElementsDoubleColonNotationEnabled = _h[2], pseudoElementsDefinitions = _h[3], pseudoElementsAcceptUnknown = _h[4];
    var str = '';
    var l = str.length;
    var pos = 0;
    var chr = '';
    var is = function(comparison) {
        return chr === comparison;
    };
    var isTagStart = function() {
        return is('*') || (0, $ddae313f2cb96861$export$25af8346f6239c5b)(chr);
    };
    var rewind = function(newPos) {
        pos = newPos;
        chr = str.charAt(pos);
    };
    var next = function() {
        pos++;
        chr = str.charAt(pos);
    };
    var readAndNext = function() {
        var current = chr;
        pos++;
        chr = str.charAt(pos);
        return current;
    };
    /** @throws ParserError */ function fail(errorMessage) {
        var position = Math.min(l - 1, pos);
        var error = new Error("".concat($7b881788824fe7ce$var$errorPrefix).concat(errorMessage, " Pos: ").concat(position, "."));
        error.position = position;
        error.name = 'ParserError';
        throw error;
    }
    function assert(condition, errorMessage) {
        if (!condition) return fail(errorMessage);
    }
    var assertNonEof = function() {
        assert(pos < l, 'Unexpected end of input.');
    };
    var isEof = function() {
        return pos >= l;
    };
    var pass = function(character) {
        assert(pos < l, "Expected \"".concat(character, "\" but end of input reached."));
        assert(chr === character, "Expected \"".concat(character, "\" but \"").concat(chr, "\" found."));
        pos++;
        chr = str.charAt(pos);
    };
    function matchMulticharIndex(index) {
        var match = matchMulticharIndexPos(index, pos);
        if (match) {
            pos += match.length;
            chr = str.charAt(pos);
            return match;
        }
    }
    function matchMulticharIndexPos(index, subPos) {
        var char = str.charAt(subPos);
        var charIndex = index[char];
        if (charIndex) {
            var subMatch = matchMulticharIndexPos(charIndex.chars, subPos + 1);
            if (subMatch) return subMatch;
            if (charIndex.self) return charIndex.self;
        }
    }
    /**
     * @see https://www.w3.org/TR/css-syntax/#hex-digit-diagram
     */ function parseHex() {
        var hex = readAndNext();
        var count = 1;
        while((0, $ddae313f2cb96861$export$8a9b6341a7c96bc)(chr) && count < (0, $ddae313f2cb96861$export$1fccc43cb8f7bfd2)){
            hex += readAndNext();
            count++;
        }
        skipSingleWhitespace();
        return String.fromCharCode(parseInt(hex, 16));
    }
    /**
     * @see https://www.w3.org/TR/css-syntax/#string-token-diagram
     */ function parseString(quote) {
        var result = '';
        pass(quote);
        while(pos < l){
            if (is(quote)) {
                next();
                return result;
            } else if (is('\\')) {
                next();
                if (is(quote)) {
                    result += quote;
                    next();
                } else if (chr === '\n' || chr === '\f') next();
                else if (chr === '\r') {
                    next();
                    if (is('\n')) next();
                } else if ((0, $ddae313f2cb96861$export$8a9b6341a7c96bc)(chr)) result += parseHex();
                else {
                    result += chr;
                    next();
                }
            } else {
                result += chr;
                next();
            }
        }
        return result;
    }
    /**
     * @see https://www.w3.org/TR/css-syntax/#ident-token-diagram
     */ function parseIdentifier() {
        if (!(0, $ddae313f2cb96861$export$25af8346f6239c5b)(chr)) return null;
        var result = '';
        while(is('-')){
            result += chr;
            next();
        }
        if (result === '-' && !(0, $ddae313f2cb96861$export$63c9ecd03a955e6b)(chr) && !is('\\')) fail('Identifiers cannot consist of a single hyphen.');
        if (strict && result.length >= 2) // Checking this only for strict mode since browsers work fine with these identifiers.
        fail('Identifiers cannot start with two hyphens with strict mode on.');
        if ((0, $ddae313f2cb96861$export$4772887ab32e45a3)[chr]) fail('Identifiers cannot start with hyphens followed by digits.');
        while(pos < l){
            if ((0, $ddae313f2cb96861$export$63c9ecd03a955e6b)(chr)) result += readAndNext();
            else if (is('\\')) {
                next();
                assertNonEof();
                if ((0, $ddae313f2cb96861$export$8a9b6341a7c96bc)(chr)) result += parseHex();
                else result += readAndNext();
            } else break;
        }
        return result;
    }
    function parsePseudoClassString() {
        var result = '';
        while(pos < l){
            if (is(')')) break;
            else if (is('\\')) {
                next();
                if (isEof() && !strict) return (result + '\\').trim();
                assertNonEof();
                if ((0, $ddae313f2cb96861$export$8a9b6341a7c96bc)(chr)) result += parseHex();
                else result += readAndNext();
            } else result += readAndNext();
        }
        return result.trim();
    }
    function skipSingleWhitespace() {
        if (chr === ' ' || chr === '\t' || chr === '\f' || chr === '\n') {
            next();
            return;
        }
        if (chr === '\r') next();
        if (chr === '\n') next();
    }
    function skipWhitespace() {
        while((0, $ddae313f2cb96861$export$f451d7af9c363592)[chr])next();
    }
    function parseSelector(relative) {
        if (relative === void 0) relative = false;
        skipWhitespace();
        var rules = [
            parseRule(relative)
        ];
        while(is(',')){
            next();
            skipWhitespace();
            rules.push(parseRule(relative));
        }
        return {
            type: 'Selector',
            rules: rules
        };
    }
    function parseAttribute() {
        pass('[');
        skipWhitespace();
        var attr;
        if (is('|')) {
            assert(namespaceEnabled, 'Namespaces are not enabled.');
            next();
            var name_1 = parseIdentifier();
            assert(name_1, 'Expected attribute name.');
            attr = {
                type: 'Attribute',
                name: name_1,
                namespace: {
                    type: 'NoNamespace'
                }
            };
        } else if (is('*')) {
            assert(namespaceEnabled, 'Namespaces are not enabled.');
            assert(namespaceWildcardEnabled, 'Wildcard namespace is not enabled.');
            next();
            pass('|');
            var name_2 = parseIdentifier();
            assert(name_2, 'Expected attribute name.');
            attr = {
                type: 'Attribute',
                name: name_2,
                namespace: {
                    type: 'WildcardNamespace'
                }
            };
        } else {
            var identifier = parseIdentifier();
            assert(identifier, 'Expected attribute name.');
            attr = {
                type: 'Attribute',
                name: identifier
            };
            if (is('|')) {
                var savedPos = pos;
                next();
                if ((0, $ddae313f2cb96861$export$25af8346f6239c5b)(chr)) {
                    assert(namespaceEnabled, 'Namespaces are not enabled.');
                    var name_3 = parseIdentifier();
                    assert(name_3, 'Expected attribute name.');
                    attr = {
                        type: 'Attribute',
                        name: name_3,
                        namespace: {
                            type: 'NamespaceName',
                            name: identifier
                        }
                    };
                } else rewind(savedPos);
            }
        }
        assert(attr.name, 'Expected attribute name.');
        skipWhitespace();
        if (isEof() && !strict) return attr;
        if (is(']')) next();
        else {
            attr.operator = matchMulticharIndex(attributesOperatorsIndex);
            assert(attr.operator, 'Expected a valid attribute selector operator.');
            skipWhitespace();
            assertNonEof();
            if ((0, $ddae313f2cb96861$export$4a6f40ec9a9f93d)[chr]) attr.value = {
                type: 'String',
                value: parseString(chr)
            };
            else if (substitutesEnabled && is('$')) {
                next();
                var name_4 = parseIdentifier();
                assert(name_4, 'Expected substitute name.');
                attr.value = {
                    type: 'Substitution',
                    name: name_4
                };
            } else {
                var value = parseIdentifier();
                assert(value, 'Expected attribute value.');
                attr.value = {
                    type: 'String',
                    value: value
                };
            }
            skipWhitespace();
            if (isEof() && !strict) return attr;
            if (!is(']')) {
                var caseSensitivityModifier = parseIdentifier();
                assert(caseSensitivityModifier, 'Expected end of attribute selector.');
                attr.caseSensitivityModifier = caseSensitivityModifier;
                assert(attributesCaseSensitivityModifiersEnabled, 'Attribute case sensitivity modifiers are not enabled.');
                assert(attributesAcceptUnknownCaseSensitivityModifiers || attributesCaseSensitivityModifiers[attr.caseSensitivityModifier], 'Unknown attribute case sensitivity modifier.');
                skipWhitespace();
                if (isEof() && !strict) return attr;
            }
            pass(']');
        }
        return attr;
    }
    function parseNumber() {
        var result = '';
        while((0, $ddae313f2cb96861$export$4772887ab32e45a3)[chr])result += readAndNext();
        assert(result !== '', 'Formula parse error.');
        return parseInt(result);
    }
    var isNumberStart = function() {
        return is('-') || is('+') || (0, $ddae313f2cb96861$export$4772887ab32e45a3)[chr];
    };
    function parseFormula() {
        if (is('e') || is('o')) {
            var ident = parseIdentifier();
            if (ident === 'even') {
                skipWhitespace();
                return [
                    2,
                    0
                ];
            }
            if (ident === 'odd') {
                skipWhitespace();
                return [
                    2,
                    1
                ];
            }
        }
        var firstNumber = null;
        var firstNumberMultiplier = 1;
        if (is('-')) {
            next();
            firstNumberMultiplier = -1;
        }
        if (isNumberStart()) {
            if (is('+')) next();
            firstNumber = parseNumber();
            if (!is('\\') && !is('n')) return [
                0,
                firstNumber * firstNumberMultiplier
            ];
        }
        if (firstNumber === null) firstNumber = 1;
        firstNumber *= firstNumberMultiplier;
        var identifier;
        if (is('\\')) {
            next();
            if ((0, $ddae313f2cb96861$export$8a9b6341a7c96bc)(chr)) identifier = parseHex();
            else identifier = readAndNext();
        } else identifier = readAndNext();
        assert(identifier === 'n', 'Formula parse error: expected "n".');
        skipWhitespace();
        if (is('+') || is('-')) {
            var sign = is('+') ? 1 : -1;
            next();
            skipWhitespace();
            return [
                firstNumber,
                sign * parseNumber()
            ];
        } else return [
            firstNumber,
            0
        ];
    }
    function parsePseudoArgument(pseudoName, type, signature) {
        var argument;
        if (is('(')) {
            next();
            skipWhitespace();
            if (substitutesEnabled && is('$')) {
                next();
                var name_5 = parseIdentifier();
                assert(name_5, 'Expected substitute name.');
                argument = {
                    type: 'Substitution',
                    name: name_5
                };
            } else if (signature.type === 'String') {
                argument = {
                    type: 'String',
                    value: parsePseudoClassString()
                };
                assert(argument.value, "Expected ".concat(type, " argument value."));
            } else if (signature.type === 'Selector') argument = parseSelector(true);
            else if (signature.type === 'Formula') {
                var _a = parseFormula(), a = _a[0], b = _a[1];
                argument = {
                    type: 'Formula',
                    a: a,
                    b: b
                };
                if (signature.ofSelector) {
                    skipWhitespace();
                    if (is('o') || is('\\')) {
                        var ident = parseIdentifier();
                        assert(ident === 'of', 'Formula of selector parse error.');
                        skipWhitespace();
                        argument = {
                            type: 'FormulaOfSelector',
                            a: a,
                            b: b,
                            selector: parseRule()
                        };
                    }
                }
            } else return fail("Invalid ".concat(type, " signature."));
            skipWhitespace();
            if (isEof() && !strict) return argument;
            pass(')');
        } else assert(signature.optional, "Argument is required for ".concat(type, " \"").concat(pseudoName, "\"."));
        return argument;
    }
    function parseTagName() {
        if (is('*')) {
            assert(tagNameWildcardEnabled, 'Wildcard tag name is not enabled.');
            next();
            return {
                type: 'WildcardTag'
            };
        } else if ((0, $ddae313f2cb96861$export$25af8346f6239c5b)(chr)) {
            assert(tagNameEnabled, 'Tag names are not enabled.');
            var name_6 = parseIdentifier();
            assert(name_6, 'Expected tag name.');
            return {
                type: 'TagName',
                name: name_6
            };
        } else return fail('Expected tag name.');
    }
    function parseTagNameWithNamespace() {
        if (is('*')) {
            var savedPos = pos;
            next();
            if (!is('|')) {
                rewind(savedPos);
                return parseTagName();
            }
            next();
            if (!isTagStart()) {
                rewind(savedPos);
                return parseTagName();
            }
            assert(namespaceEnabled, 'Namespaces are not enabled.');
            assert(namespaceWildcardEnabled, 'Wildcard namespace is not enabled.');
            var tagName = parseTagName();
            tagName.namespace = {
                type: 'WildcardNamespace'
            };
            return tagName;
        } else if (is('|')) {
            assert(namespaceEnabled, 'Namespaces are not enabled.');
            next();
            var tagName = parseTagName();
            tagName.namespace = {
                type: 'NoNamespace'
            };
            return tagName;
        } else if ((0, $ddae313f2cb96861$export$25af8346f6239c5b)(chr)) {
            var identifier = parseIdentifier();
            assert(identifier, 'Expected tag name.');
            if (!is('|')) {
                assert(tagNameEnabled, 'Tag names are not enabled.');
                return {
                    type: 'TagName',
                    name: identifier
                };
            }
            var savedPos = pos;
            next();
            if (!isTagStart()) {
                rewind(savedPos);
                return {
                    type: 'TagName',
                    name: identifier
                };
            }
            assert(namespaceEnabled, 'Namespaces are not enabled.');
            var tagName = parseTagName();
            tagName.namespace = {
                type: 'NamespaceName',
                name: identifier
            };
            return tagName;
        } else return fail('Expected tag name.');
    }
    function parseRule(relative) {
        var _a, _b;
        if (relative === void 0) relative = false;
        var rule = {
            type: 'Rule',
            items: []
        };
        if (relative) {
            var combinator = matchMulticharIndex(combinatorsIndex);
            if (combinator) {
                rule.combinator = combinator;
                skipWhitespace();
            }
        }
        while(pos < l){
            if (isTagStart()) {
                assert(rule.items.length === 0, 'Unexpected tag/namespace start.');
                rule.items.push(parseTagNameWithNamespace());
            } else if (is('|')) {
                var savedPos = pos;
                next();
                if (isTagStart()) {
                    assert(rule.items.length === 0, 'Unexpected tag/namespace start.');
                    rewind(savedPos);
                    rule.items.push(parseTagNameWithNamespace());
                } else {
                    rewind(savedPos);
                    break;
                }
            } else if (is('.')) {
                assert(classNamesEnabled, 'Class names are not enabled.');
                next();
                var className = parseIdentifier();
                assert(className, 'Expected class name.');
                rule.items.push({
                    type: 'ClassName',
                    name: className
                });
            } else if (is('#')) {
                assert(idEnabled, 'IDs are not enabled.');
                next();
                var idName = parseIdentifier();
                assert(idName, 'Expected ID name.');
                rule.items.push({
                    type: 'Id',
                    name: idName
                });
            } else if (is('&')) {
                assert(nestingSelectorEnabled, 'Nesting selector is not enabled.');
                next();
                rule.items.push({
                    type: 'NestingSelector'
                });
            } else if (is('[')) {
                assert(attributesEnabled, 'Attributes are not enabled.');
                rule.items.push(parseAttribute());
            } else if (is(':')) {
                var isDoubleColon = false;
                var isPseudoElement = false;
                next();
                if (is(':')) {
                    assert(pseudoElementsEnabled, 'Pseudo elements are not enabled.');
                    assert(pseudoElementsDoubleColonNotationEnabled, 'Pseudo elements double colon notation is not enabled.');
                    isDoubleColon = true;
                    next();
                }
                var pseudoName = parseIdentifier();
                assert(isDoubleColon || pseudoName, 'Expected pseudo-class name.');
                assert(!isDoubleColon || pseudoName, 'Expected pseudo-element name.');
                assert(pseudoName, 'Expected pseudo-class name.');
                if (!isDoubleColon || pseudoElementsAcceptUnknown || Object.prototype.hasOwnProperty.call(pseudoElementsDefinitions, pseudoName)) ;
                else {
                    // Generate a helpful error message with location information
                    var locations = (0, $f67c0075e21dfa5b$export$dd1b971945cbb3c7).pseudoElements[pseudoName];
                    var errorMessage = "Unknown pseudo-element \"".concat(pseudoName, "\"");
                    if (locations && locations.length > 0) errorMessage += ". It is defined in: ".concat(locations.join(', '));
                    fail(errorMessage + '.');
                }
                isPseudoElement = pseudoElementsEnabled && (isDoubleColon || !isDoubleColon && pseudoElementsSingleColonNotationEnabled && Object.prototype.hasOwnProperty.call(pseudoElementsDefinitions, pseudoName));
                if (isPseudoElement) {
                    var signature = (_a = pseudoElementsDefinitions[pseudoName]) !== null && _a !== void 0 ? _a : pseudoElementsAcceptUnknown && (0, $e589bf2e4bc2ee64$export$2860e7ac7b9acf6d);
                    var pseudoElement = {
                        type: 'PseudoElement',
                        name: pseudoName
                    };
                    var argument = parsePseudoArgument(pseudoName, 'pseudo-element', signature);
                    if (argument) {
                        assert(argument.type !== 'Formula' && argument.type !== 'FormulaOfSelector', 'Pseudo-elements cannot have formula argument.');
                        pseudoElement.argument = argument;
                    }
                    rule.items.push(pseudoElement);
                } else {
                    assert(pseudoClassesEnabled, 'Pseudo-classes are not enabled.');
                    var signature = (_b = pseudoClassesDefinitions[pseudoName]) !== null && _b !== void 0 ? _b : pseudoClassesAcceptUnknown && (0, $e589bf2e4bc2ee64$export$2860e7ac7b9acf6d);
                    if (signature) ;
                    else {
                        // Generate a helpful error message with location information
                        var locations = (0, $f67c0075e21dfa5b$export$dd1b971945cbb3c7).pseudoClasses[pseudoName];
                        var errorMessage = "Unknown pseudo-class: \"".concat(pseudoName, "\"");
                        if (locations && locations.length > 0) errorMessage += ". It is defined in: ".concat(locations.join(', '));
                        fail(errorMessage + '.');
                    }
                    var argument = parsePseudoArgument(pseudoName, 'pseudo-class', signature);
                    var pseudoClass = {
                        type: 'PseudoClass',
                        name: pseudoName
                    };
                    if (argument) pseudoClass.argument = argument;
                    rule.items.push(pseudoClass);
                }
            } else break;
        }
        if (rule.items.length === 0) {
            if (isEof()) return fail('Expected rule but end of input reached.');
            else return fail("Expected rule but \"".concat(chr, "\" found."));
        }
        skipWhitespace();
        if (!isEof() && !is(',') && !is(')')) {
            var combinator = matchMulticharIndex(combinatorsIndex);
            skipWhitespace();
            rule.nestedRule = parseRule();
            rule.nestedRule.combinator = combinator;
        }
        return rule;
    }
    return function(input) {
        // noinspection SuspiciousTypeOfGuard
        if (typeof input !== 'string') throw new Error("".concat($7b881788824fe7ce$var$errorPrefix, "Expected string input."));
        str = input;
        l = str.length;
        pos = 0;
        chr = str.charAt(0);
        return parseSelector();
    };
}



var $b244e34656e25320$var$errorPrefix = "css-selector-parser render error: ";
function $b244e34656e25320$var$renderNamespace(namespace) {
    if (namespace.type === 'WildcardNamespace') return '*|';
    else if (namespace.type === 'NamespaceName') return "".concat((0, $ddae313f2cb96861$export$56fe274825607f4a)(namespace.name), "|");
    else if (namespace.type === 'NoNamespace') return '|';
    throw new Error("".concat($b244e34656e25320$var$errorPrefix, "Unknown namespace type: ").concat(namespace.type, "."));
}
function $b244e34656e25320$var$renderSubstitution(sub) {
    return "$".concat((0, $ddae313f2cb96861$export$56fe274825607f4a)(sub.name));
}
function $b244e34656e25320$var$renderFormula(a, b) {
    if (a) {
        var result = "".concat(a === 1 ? '' : a === -1 ? '-' : a, "n");
        if (b) result += "".concat(b > 0 ? '+' : '').concat(b);
        return result;
    } else return String(b);
}
function $b244e34656e25320$export$b3890eb0ae9dca99(entity) {
    if (entity.type === 'Selector') return entity.rules.map($b244e34656e25320$export$b3890eb0ae9dca99).join(', ');
    if (entity.type === 'Rule') {
        var result = '';
        var items = entity.items, combinator = entity.combinator, nestedRule = entity.nestedRule;
        if (combinator) result += "".concat(combinator, " ");
        for(var _i = 0, items_1 = items; _i < items_1.length; _i++){
            var item = items_1[_i];
            result += $b244e34656e25320$export$b3890eb0ae9dca99(item);
        }
        if (nestedRule) result += " ".concat($b244e34656e25320$export$b3890eb0ae9dca99(nestedRule));
        return result;
    } else if (entity.type === 'TagName' || entity.type === 'WildcardTag') {
        var result = '';
        var namespace = entity.namespace;
        if (namespace) result += $b244e34656e25320$var$renderNamespace(namespace);
        if (entity.type === 'TagName') result += (0, $ddae313f2cb96861$export$56fe274825607f4a)(entity.name);
        else if (entity.type === 'WildcardTag') result += '*';
        return result;
    } else if (entity.type === 'Id') return "#".concat((0, $ddae313f2cb96861$export$56fe274825607f4a)(entity.name));
    else if (entity.type === 'ClassName') return ".".concat((0, $ddae313f2cb96861$export$56fe274825607f4a)(entity.name));
    else if (entity.type === 'NestingSelector') return '&';
    else if (entity.type === 'Attribute') {
        var name_1 = entity.name, namespace = entity.namespace, operator = entity.operator, value = entity.value, caseSensitivityModifier = entity.caseSensitivityModifier;
        var result = '[';
        if (namespace) result += $b244e34656e25320$var$renderNamespace(namespace);
        result += (0, $ddae313f2cb96861$export$56fe274825607f4a)(name_1);
        if (operator && value) {
            result += operator;
            if (value.type === 'String') result += (0, $ddae313f2cb96861$export$4148cf4a40af9f34)(value.value);
            else if (value.type === 'Substitution') result += $b244e34656e25320$var$renderSubstitution(value);
            else throw new Error("Unknown attribute value type: ".concat(value.type, "."));
            if (caseSensitivityModifier) result += " ".concat((0, $ddae313f2cb96861$export$56fe274825607f4a)(caseSensitivityModifier));
        }
        result += ']';
        return result;
    } else if (entity.type === 'PseudoClass') {
        var name_2 = entity.name, argument = entity.argument;
        var result = ":".concat((0, $ddae313f2cb96861$export$56fe274825607f4a)(name_2));
        if (argument) result += "(".concat(argument.type === 'String' ? (0, $ddae313f2cb96861$export$56fe274825607f4a)(argument.value) : $b244e34656e25320$export$b3890eb0ae9dca99(argument), ")");
        return result;
    } else if (entity.type === 'PseudoElement') {
        var name_3 = entity.name, argument = entity.argument;
        var result = "::".concat((0, $ddae313f2cb96861$export$56fe274825607f4a)(name_3));
        if (argument) result += "(".concat(argument.type === 'String' ? (0, $ddae313f2cb96861$export$56fe274825607f4a)(argument.value) : $b244e34656e25320$export$b3890eb0ae9dca99(argument), ")");
        return result;
    } else if (entity.type === 'String') throw new Error("".concat($b244e34656e25320$var$errorPrefix, "String cannot be rendered outside of context."));
    else if (entity.type === 'Formula') return $b244e34656e25320$var$renderFormula(entity.a, entity.b);
    else if (entity.type === 'FormulaOfSelector') return $b244e34656e25320$var$renderFormula(entity.a, entity.b) + ' of ' + $b244e34656e25320$export$b3890eb0ae9dca99(entity.selector);
    else if (entity.type === 'Substitution') return "$".concat((0, $ddae313f2cb96861$export$56fe274825607f4a)(entity.name));
    throw new Error("Unknown type specified to render method: ".concat(entity.type, "."));
}


var $42408b66c0c1394b$var$__assign = undefined && undefined.__assign || function() {
    $42408b66c0c1394b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $42408b66c0c1394b$var$__assign.apply(this, arguments);
};
function $42408b66c0c1394b$var$astMethods(type) {
    return function(generatorName, checkerName) {
        var _a;
        return _a = {}, _a[generatorName] = function(props) {
            return $42408b66c0c1394b$var$__assign({
                type: type
            }, props);
        }, _a[checkerName] = function(entity) {
            return typeof entity === 'object' && entity !== null && entity.type === type;
        }, _a;
    };
}
var $42408b66c0c1394b$export$240a2ee49d1b21d = $42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign({}, $42408b66c0c1394b$var$astMethods('Selector')('selector', 'isSelector')), $42408b66c0c1394b$var$astMethods('Rule')('rule', 'isRule')), $42408b66c0c1394b$var$astMethods('TagName')('tagName', 'isTagName')), $42408b66c0c1394b$var$astMethods('Id')('id', 'isId')), $42408b66c0c1394b$var$astMethods('ClassName')('className', 'isClassName')), $42408b66c0c1394b$var$astMethods('WildcardTag')('wildcardTag', 'isWildcardTag')), $42408b66c0c1394b$var$astMethods('NamespaceName')('namespaceName', 'isNamespaceName')), $42408b66c0c1394b$var$astMethods('WildcardNamespace')('wildcardNamespace', 'isWildcardNamespace')), $42408b66c0c1394b$var$astMethods('NoNamespace')('noNamespace', 'isNoNamespace')), $42408b66c0c1394b$var$astMethods('NestingSelector')('nestingSelector', 'isNestingSelector')), $42408b66c0c1394b$var$astMethods('Attribute')('attribute', 'isAttribute')), $42408b66c0c1394b$var$astMethods('PseudoClass')('pseudoClass', 'isPseudoClass')), $42408b66c0c1394b$var$astMethods('PseudoElement')('pseudoElement', 'isPseudoElement')), $42408b66c0c1394b$var$astMethods('String')('string', 'isString')), $42408b66c0c1394b$var$astMethods('Formula')('formula', 'isFormula')), $42408b66c0c1394b$var$astMethods('FormulaOfSelector')('formulaOfSelector', 'isFormulaOfSelector')), $42408b66c0c1394b$var$astMethods('Substitution')('substitution', 'isSubstitution'));


var $a150759246302970$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function $a150759246302970$export$df3f009e3d155b20(node, visitor) {
    var visitorObj = typeof visitor === 'function' ? {
        enter: visitor
    } : visitor;
    var state = {
        visitor: visitorObj,
        parents: []
    };
    $a150759246302970$var$visitNode(node, state, undefined, undefined, undefined);
}
/**
 * Visits a single node and its children.
 */ function $a150759246302970$var$visitNode(node, state, parent, key, index) {
    var context = {
        node: node,
        parent: parent,
        parents: $a150759246302970$var$__spreadArray([], state.parents, true),
        key: key,
        index: index
    };
    // Call enter hook
    var skipChildren = false;
    if (state.visitor.enter) {
        var result = state.visitor.enter(node, context);
        if (result === false) skipChildren = true;
    }
    // Visit children unless skipped
    if (!skipChildren) {
        state.parents.push(node);
        $a150759246302970$var$visitChildren(node, state);
        state.parents.pop();
    }
    // Call exit hook
    if (state.visitor.exit) state.visitor.exit(node, context);
}
/**
 * Visits all children of a node based on its type.
 */ function $a150759246302970$var$visitChildren(node, state) {
    switch(node.type){
        case 'Selector':
            $a150759246302970$var$visitSelector(node, state);
            break;
        case 'Rule':
            $a150759246302970$var$visitRule(node, state);
            break;
        case 'TagName':
            $a150759246302970$var$visitTagName(node, state);
            break;
        case 'WildcardTag':
            $a150759246302970$var$visitWildcardTag(node, state);
            break;
        case 'Attribute':
            $a150759246302970$var$visitAttribute(node, state);
            break;
        case 'PseudoClass':
            $a150759246302970$var$visitPseudoClass(node, state);
            break;
        case 'PseudoElement':
            $a150759246302970$var$visitPseudoElement(node, state);
            break;
        case 'FormulaOfSelector':
            $a150759246302970$var$visitFormulaOfSelector(node, state);
            break;
        // Leaf nodes with no children
        case 'Id':
        case 'ClassName':
        case 'NamespaceName':
        case 'WildcardNamespace':
        case 'NoNamespace':
        case 'NestingSelector':
        case 'String':
        case 'Formula':
        case 'Substitution':
            break;
    }
}
function $a150759246302970$var$visitSelector(node, state) {
    node.rules.forEach(function(rule, index) {
        $a150759246302970$var$visitNode(rule, state, node, 'rules', index);
    });
}
function $a150759246302970$var$visitRule(node, state) {
    node.items.forEach(function(item, index) {
        $a150759246302970$var$visitNode(item, state, node, 'items', index);
    });
    if (node.nestedRule) $a150759246302970$var$visitNode(node.nestedRule, state, node, 'nestedRule', undefined);
}
function $a150759246302970$var$visitTagName(node, state) {
    if (node.namespace) $a150759246302970$var$visitNode(node.namespace, state, node, 'namespace', undefined);
}
function $a150759246302970$var$visitWildcardTag(node, state) {
    if (node.namespace) $a150759246302970$var$visitNode(node.namespace, state, node, 'namespace', undefined);
}
function $a150759246302970$var$visitAttribute(node, state) {
    if (node.namespace) $a150759246302970$var$visitNode(node.namespace, state, node, 'namespace', undefined);
    if (node.value) $a150759246302970$var$visitNode(node.value, state, node, 'value', undefined);
}
function $a150759246302970$var$visitPseudoClass(node, state) {
    if (node.argument) $a150759246302970$var$visitNode(node.argument, state, node, 'argument', undefined);
}
function $a150759246302970$var$visitPseudoElement(node, state) {
    if (node.argument) $a150759246302970$var$visitNode(node.argument, state, node, 'argument', undefined);
}
function $a150759246302970$var$visitFormulaOfSelector(node, state) {
    $a150759246302970$var$visitNode(node.selector, state, node, 'selector', undefined);
}




const $4124eb6fe7464b38$var$cssSelectorParse = (0, $7b881788824fe7ce$export$88a1156fad04455f)({
    syntax: 'selectors-4'
});
function $4124eb6fe7464b38$export$98e6a39c04603d36(selector) {
    if (typeof selector !== 'string') throw new TypeError('Expected `string` as selector, not `' + selector + '`');
    return $4124eb6fe7464b38$var$cssSelectorParse(selector);
}


/**
 * @import {AstRule} from 'css-selector-parser'
 * @import {Element, Nodes, Parents} from 'hast'
 * @import {State} from './index.js'
 */ /**
 * @typedef Counts
 *   Info on elements in a parent.
 * @property {number} count
 *   Number of elements.
 * @property {Map<string, number>} types
 *   Number of elements by tag name.
 *
 * @typedef Nest
 *   Rule sets by nesting.
 * @property {Array<AstRule> | undefined} adjacentSibling
 *   `a + b`
 * @property {Array<AstRule> | undefined} descendant
 *   `a b`
 * @property {Array<AstRule> | undefined} directChild
 *   `a > b`
 * @property {Array<AstRule> | undefined} generalSibling
 *   `a ~ b`
 */ /**
 * @import {Visitor} from 'unist-util-visit'
 * @import {ElementContent, Nodes} from 'hast'
 * @import {Direction, State} from './index.js'
 */ const $0db0f7d85151f24d$var$rtlRange = '\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC';
const $0db0f7d85151f24d$var$ltrRange = "A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u02B8\u0300-\u0590\u0800-\u1FFF\u200E\u2C00-\uFB1C\uFE00-\uFE6F\uFEFD-\uFFFF";
/* eslint-disable no-misleading-character-class */ const $0db0f7d85151f24d$var$rtl = new RegExp('^[^' + $0db0f7d85151f24d$var$ltrRange + ']*[' + $0db0f7d85151f24d$var$rtlRange + ']');
const $0db0f7d85151f24d$var$ltr = new RegExp('^[^' + $0db0f7d85151f24d$var$rtlRange + ']*[' + $0db0f7d85151f24d$var$ltrRange + ']');
function $0db0f7d85151f24d$export$9fddb9d0dd7d8a54(value) {
    const source = String(value || '');
    return $0db0f7d85151f24d$var$rtl.test(source) ? 'rtl' : $0db0f7d85151f24d$var$ltr.test(source) ? 'ltr' : 'neutral';
}





function $b8abdcb0edb929ec$export$b6a91203b6b36f(state, node) {
    const schema = state.schema;
    const language = state.language;
    const currentDirection = state.direction;
    const editableOrEditingHost = state.editableOrEditingHost;
    /** @type {Direction | undefined} */ let directionInferred;
    if (node.type === 'element') {
        const lang = node.properties.xmlLang || node.properties.lang;
        const type = node.properties.type || 'text';
        const direction = $b8abdcb0edb929ec$var$directionProperty(node);
        if (lang !== null && lang !== undefined) state.language = String(lang);
        if (schema && schema.space === 'html') {
            if (node.properties.contentEditable === 'true') state.editableOrEditingHost = true;
            if (node.tagName === 'svg') state.schema = (0, $cad208d20be39d74$export$7ed1367e7fa1ad68);
            // See: <https://html.spec.whatwg.org/#the-directionality>.
            // Explicit `[dir=rtl]`.
            if (direction === 'rtl') directionInferred = direction;
            else if (// Explicit `[dir=ltr]`.
            direction === 'ltr' || // HTML with an invalid or no `[dir]`.
            direction !== 'auto' && node.tagName === 'html' || // `input[type=tel]` with an invalid or no `[dir]`.
            direction !== 'auto' && node.tagName === 'input' && type === 'tel') directionInferred = 'ltr';
            else if (direction === 'auto' || node.tagName === 'bdi') {
                if (node.tagName === 'textarea') // Check contents of `<textarea>`.
                directionInferred = $b8abdcb0edb929ec$var$directionBidi((0, $58714581718e6349$export$f84e8e69fd4488a5)(node));
                else if (node.tagName === 'input' && (type === 'email' || type === 'search' || type === 'tel' || type === 'text')) // Check value of `<input>`.
                directionInferred = node.properties.value ? $b8abdcb0edb929ec$var$directionBidi(String(node.properties.value)) : 'ltr';
                else // Check text nodes in `node`.
                (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(node, inferDirectionality);
            }
            if (directionInferred) state.direction = directionInferred;
        } else if (state.editableOrEditingHost) state.editableOrEditingHost = false;
    }
    return reset;
    /**
   * @returns {undefined}
   *   Nothing.
   */ function reset() {
        state.schema = schema;
        state.language = language;
        state.direction = currentDirection;
        state.editableOrEditingHost = editableOrEditingHost;
    }
    /** @type {Visitor<ElementContent>} */ function inferDirectionality(child) {
        if (child.type === 'text') {
            directionInferred = $b8abdcb0edb929ec$var$directionBidi(child.value);
            return directionInferred ? (0, $9ef2eaca0b34953c$export$7f100f842f565dc9) : undefined;
        }
        if (child !== node && child.type === 'element' && (child.tagName === 'bdi' || child.tagName === 'script' || child.tagName === 'style' || child.tagName === 'textare' || $b8abdcb0edb929ec$var$directionProperty(child))) return 0, $9ef2eaca0b34953c$export$8773f85c2fb2c116;
    }
}
/**
 * See `wooorm/direction`.
 *
 * @param {string} value
 *   Value to check.
 * @returns {Exclude<Direction, 'auto'> | undefined}
 *   Directionality.
 */ function $b8abdcb0edb929ec$var$directionBidi(value) {
    const result = (0, $0db0f7d85151f24d$export$9fddb9d0dd7d8a54)(value);
    return result === 'neutral' ? undefined : result;
}
/**
 * @param {ElementContent} node
 *   Node to check.
 * @returns {Direction | undefined}
 *   Directionality.
 */ function $b8abdcb0edb929ec$var$directionProperty(node) {
    const value = node.type === 'element' && typeof node.properties.dir === 'string' ? node.properties.dir.toLowerCase() : undefined;
    return value === 'auto' || value === 'ltr' || value === 'rtl' ? value : undefined;
}


/**
 * @import {AstRule} from 'css-selector-parser'
 * @import {Element, Parents} from 'hast'
 * @import {State} from './index.js'
 */ /**
 * @import {AstAttribute} from 'css-selector-parser'
 * @import {Element, Properties} from 'hast'
 * @import {Info, Schema} from 'property-information'
 */ 



function $1e9a7b5843ff9cc5$export$af4b9a83f4b00434(query, element, schema) {
    const info = (0, $84669bfd2b988556$export$71aa6c912b956294)(schema, query.name);
    const propertyValue = element.properties[info.property];
    let value = $1e9a7b5843ff9cc5$var$normalizeValue(propertyValue, info);
    // Exists.
    if (!query.value) return value !== undefined;
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(query.value.type === 'String', 'expected plain string');
    let key = query.value.value;
    // Case-sensitivity.
    if (query.caseSensitivityModifier === 'i') {
        key = key.toLowerCase();
        if (value) value = value.toLowerCase();
    }
    if (value !== undefined) switch(query.operator){
        // Exact.
        case '=':
            return key === value;
        // Ends.
        case '$=':
            return key === value.slice(-key.length);
        // Contains.
        case '*=':
            return value.includes(key);
        // Begins.
        case '^=':
            return key === value.slice(0, key.length);
        // Exact or prefix.
        case '|=':
            return key === value || key === value.slice(0, key.length) && value.charAt(key.length) === '-';
        // Space-separated list.
        case '~=':
            return(// For all other values (including comma-separated lists), return whether this
            // is an exact match.
            key === value || // If this is a space-separated list, and the query is contained in it, return
            // true.
            $0d98344a9bfa0653$export$98e6a39c04603d36(value).includes(key));
    }
    return false;
}
/**
 *
 * @param {Properties[keyof Properties]} value
 * @param {Info} info
 * @returns {string | undefined}
 */ function $1e9a7b5843ff9cc5$var$normalizeValue(value, info) {
    if (value === null || value === undefined) ;
    else if (typeof value === 'boolean') {
        if (value) return info.attribute;
    } else if (Array.isArray(value)) {
        if (value.length > 0) return (info.commaSeparated ? (0, $9323934601145f2e$export$fac44ee5b035f737) : $0d98344a9bfa0653$export$fac44ee5b035f737)(value);
    } else return String(value);
}


/**
 * @import {AstClassName} from 'css-selector-parser'
 * @import {Element} from 'hast'
 */ /** @type {Array<never>} */ const $693ce8a7cf643383$var$emptyClassNames = [];
function $693ce8a7cf643383$export$2913c0c0b5623090(query, element) {
    // Assume array.
    const value = /** @type {Readonly<Array<string>>} */ element.properties.className || $693ce8a7cf643383$var$emptyClassNames;
    return value.includes(query.name);
}


/**
 * @import {AstId} from 'css-selector-parser'
 * @import {Element} from 'hast'
 */ /**
 * Check whether an element has an ID.
 *
 * @param {AstId} query
 *   AST rule (with `ids`).
 * @param {Element} element
 *   Element.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $0d66214d99d2cbfa$export$d560c7e4a29451c2(query, element) {
    return element.properties.id === query.name;
}


/**
 * @import {AstTagName} from 'css-selector-parser'
 * @import {Element} from 'hast'
 */ /**
 * Check whether an element has a tag name.
 *
 * @param {AstTagName} query
 *   AST rule (with `tag`).
 * @param {Element} element
 *   Element.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $22aadedf983dfddd$export$a8ff84c12d48cfa6(query, element) {
    return query.name === element.tagName;
}


/**
 * @import {AstPseudoClass} from 'css-selector-parser'
 * @import {default as NthCheck} from 'nth-check'
 * @import {ElementContent, Element, Parents} from 'hast'
 * @import {State} from './index.js'
 */ /**
 * See <https://tools.ietf.org/html/rfc4647#section-3.1>
 * for more info on the algorithms.
 */ /**
 * @typedef {string} Tag
 *   BCP-47 tag.
 * @typedef {Array<Tag>} Tags
 *   List of BCP-47 tags.
 * @typedef {string} Range
 *   RFC 4647 range.
 * @typedef {Array<Range>} Ranges
 *   List of RFC 4647 range.
 *
 * @callback Check
 *   An internal check.
 * @param {Tag} tag
 *   BCP-47 tag.
 * @param {Range} range
 *   RFC 4647 range.
 * @returns {boolean}
 *   Whether the range matches the tag.
 *
 * @typedef {FilterOrLookup<true>} Filter
 *   Filter: yields all tags that match a range.
 * @typedef {FilterOrLookup<false>} Lookup
 *   Lookup: yields the best tag that matches a range.
 */ /**
 * @template {boolean} IsFilter
 *   Whether to filter or perform a lookup.
 * @callback FilterOrLookup
 *   A check.
 * @param {Tag|Tags} tags
 *   One or more BCP-47 tags.
 * @param {Range|Ranges|undefined} [ranges='*']
 *   One or more RFC 4647 ranges.
 * @returns {IsFilter extends true ? Tags : Tag|undefined}
 *   Result.
 */ /**
 * Factory to perform a filter or a lookup.
 *
 * This factory creates a function that accepts a list of tags and a list of
 * ranges, and contains logic to exit early for lookups.
 * `check` just has to deal with one tag and one range.
 * This match function iterates over ranges, and for each range,
 * iterates over tags.
 * That way, earlier ranges matching any tag have precedence over later ranges.
 *
 * @template {boolean} IsFilter
 * @param {Check} check
 *   A check.
 * @param {IsFilter} filter
 *   Whether to filter or perform a lookup.
 * @returns {FilterOrLookup<IsFilter>}
 *   Filter or lookup.
 */ function $b87ec220e0070103$var$factory(check, filter) {
    /**
   * @param {Tag|Tags} tags
   *   One or more BCP-47 tags.
   * @param {Range|Ranges|undefined} [ranges='*']
   *   One or more RFC 4647 ranges.
   * @returns {IsFilter extends true ? Tags : Tag|undefined}
   *   Result.
   */ return function(tags, ranges) {
        let left = $b87ec220e0070103$var$cast(tags, 'tag');
        const right = $b87ec220e0070103$var$cast(ranges === null || ranges === undefined ? '*' : ranges, 'range');
        /** @type {Tags} */ const matches = [];
        let rightIndex = -1;
        while(++rightIndex < right.length){
            const range = right[rightIndex].toLowerCase();
            // Ignore wildcards in lookup mode.
            if (!filter && range === '*') continue;
            let leftIndex = -1;
            /** @type {Tags} */ const next = [];
            while(++leftIndex < left.length)if (check(left[leftIndex].toLowerCase(), range)) {
                // Exit if this is a lookup and we have a match.
                if (!filter) return /** @type {IsFilter extends true ? Tags : Tag|undefined} */ left[leftIndex];
                matches.push(left[leftIndex]);
            } else next.push(left[leftIndex]);
            left = next;
        }
        // If this is a filter, return the list.  If it’s a lookup, we didn’t find
        // a match, so return `undefined`.
        return /** @type {IsFilter extends true ? Tags : Tag|undefined} */ filter ? matches : undefined;
    };
}
const $b87ec220e0070103$export$454d02d943c45292 = $b87ec220e0070103$var$factory(function(tag, range) {
    return range === '*' || tag === range || tag.includes(range + '-');
}, true);
const $b87ec220e0070103$export$d216e65da1a9aa7e = $b87ec220e0070103$var$factory(function(tag, range) {
    // 3.3.2.1
    const left = tag.split('-');
    const right = range.split('-');
    let leftIndex = 0;
    let rightIndex = 0;
    // 3.3.2.2
    if (right[rightIndex] !== '*' && left[leftIndex] !== right[rightIndex]) return false;
    leftIndex++;
    rightIndex++;
    // 3.3.2.3
    while(rightIndex < right.length){
        // 3.3.2.3.A
        if (right[rightIndex] === '*') {
            rightIndex++;
            continue;
        }
        // 3.3.2.3.B
        if (!left[leftIndex]) return false;
        // 3.3.2.3.C
        if (left[leftIndex] === right[rightIndex]) {
            leftIndex++;
            rightIndex++;
            continue;
        }
        // 3.3.2.3.D
        if (left[leftIndex].length === 1) return false;
        // 3.3.2.3.E
        leftIndex++;
    }
    // 3.3.2.4
    return true;
}, true);
const $b87ec220e0070103$export$dfc7155ac0343b8 = $b87ec220e0070103$var$factory(function(tag, range) {
    let right = range;
    /* eslint-disable-next-line no-constant-condition */ while(true){
        if (right === '*' || tag === right) return true;
        let index = right.lastIndexOf('-');
        if (index < 0) return false;
        if (right.charAt(index - 2) === '-') index -= 2;
        right = right.slice(0, index);
    }
}, false);
/**
 * Validate tags or ranges, and cast them to arrays.
 *
 * @param {string|Array<string>} values
 * @param {string} name
 * @returns {Array<string>}
 */ function $b87ec220e0070103$var$cast(values, name) {
    const value = values && typeof values === 'string' ? [
        values
    ] : values;
    if (!value || typeof value !== 'object' || !('length' in value)) throw new Error('Invalid ' + name + ' `' + value + '`, expected non-empty string');
    return value;
}




/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Nodes} Nodes
 */ const $faf93996c771049f$var$own = {}.hasOwnProperty;
function $faf93996c771049f$export$bf9617eaf5d2451(node, name) {
    const value = node.type === 'element' && $faf93996c771049f$var$own.call(node.properties, name) && node.properties[name];
    return value !== null && value !== undefined && value !== false;
}



// Following http://www.w3.org/TR/css3-selectors/#nth-child-pseudo
// Whitespace as per https://www.w3.org/TR/selectors-3/#lex is " \t\r\n\f"
const $0cd817c59cf7d5e8$var$whitespace = new Set([
    9,
    10,
    12,
    13,
    32
]);
const $0cd817c59cf7d5e8$var$ZERO = "0".charCodeAt(0);
const $0cd817c59cf7d5e8$var$NINE = "9".charCodeAt(0);
function $0cd817c59cf7d5e8$export$98e6a39c04603d36(formula) {
    formula = formula.trim().toLowerCase();
    if (formula === "even") return [
        2,
        0
    ];
    else if (formula === "odd") return [
        2,
        1
    ];
    // Parse [ ['-'|'+']? INTEGER? {N} [ S* ['-'|'+'] S* INTEGER ]?
    let idx = 0;
    let a = 0;
    let sign = readSign();
    let number = readNumber();
    if (idx < formula.length && formula.charAt(idx) === "n") {
        idx++;
        a = sign * (number !== null && number !== void 0 ? number : 1);
        skipWhitespace();
        if (idx < formula.length) {
            sign = readSign();
            skipWhitespace();
            number = readNumber();
        } else sign = number = 0;
    }
    // Throw if there is anything else
    if (number === null || idx < formula.length) throw new Error(`n-th rule couldn't be parsed ('${formula}')`);
    return [
        a,
        sign * number
    ];
    function readSign() {
        if (formula.charAt(idx) === "-") {
            idx++;
            return -1;
        }
        if (formula.charAt(idx) === "+") idx++;
        return 1;
    }
    function readNumber() {
        const start = idx;
        let value = 0;
        while(idx < formula.length && formula.charCodeAt(idx) >= $0cd817c59cf7d5e8$var$ZERO && formula.charCodeAt(idx) <= $0cd817c59cf7d5e8$var$NINE){
            value = value * 10 + (formula.charCodeAt(idx) - $0cd817c59cf7d5e8$var$ZERO);
            idx++;
        }
        // Return `null` if we didn't read anything.
        return idx === start ? null : value;
    }
    function skipWhitespace() {
        while(idx < formula.length && $0cd817c59cf7d5e8$var$whitespace.has(formula.charCodeAt(idx)))idx++;
    }
}


var $b9a70fb689ad7ba3$exports = {};
$b9a70fb689ad7ba3$exports = {
    trueFunc: function trueFunc() {
        return true;
    },
    falseFunc: function falseFunc() {
        return false;
    }
};


function $0a99a8565361a0f1$export$ef7acd7185315e22(parsed) {
    const a = parsed[0];
    // Subtract 1 from `b`, to convert from one- to zero-indexed.
    const b = parsed[1] - 1;
    /*
     * When `b <= 0`, `a * n` won't be lead to any matches for `a < 0`.
     * Besides, the specification states that no elements are
     * matched when `a` and `b` are 0.
     *
     * `b < 0` here as we subtracted 1 from `b` above.
     */ if (b < 0 && a <= 0) return (0, (/*@__PURE__*/$parcel$interopDefault($b9a70fb689ad7ba3$exports))).falseFunc;
    // When `a` is in the range -1..1, it matches any element (so only `b` is checked).
    if (a === -1) return (index)=>index <= b;
    if (a === 0) return (index)=>index === b;
    // When `b <= 0` and `a === 1`, they match any element.
    if (a === 1) return b < 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($b9a70fb689ad7ba3$exports))).trueFunc : (index)=>index >= b;
    /*
     * Otherwise, modulo can be used to check if there is a match.
     *
     * Modulo doesn't care about the sign, so let's use `a`s absolute value.
     */ const absA = Math.abs(a);
    // Get `b mod a`, + a if this is negative.
    const bMod = (b % absA + absA) % absA;
    return a > 1 ? (index)=>index >= b && index % absA === bMod : (index)=>index <= b && index % absA === bMod;
}
function $0a99a8565361a0f1$export$80d376111cc09ad7(parsed) {
    const a = parsed[0];
    // Subtract 1 from `b`, to convert from one- to zero-indexed.
    let b = parsed[1] - 1;
    let n = 0;
    // Make sure to always return an increasing sequence
    if (a < 0) {
        const aPos = -a;
        // Get `b mod a`
        const minValue = (b % aPos + aPos) % aPos;
        return ()=>{
            const val = minValue + aPos * n++;
            return val > b ? null : val;
        };
    }
    if (a === 0) return b < 0 ? ()=>null : ()=>n++ === 0 ? b : null;
    if (b < 0) b += a * Math.ceil(-b / a);
    return ()=>a * n++ + b;
}


function $afef59663c7fe1ad$export$2e2bcd8739ae039(formula) {
    return (0, $0a99a8565361a0f1$export$ef7acd7185315e22)((0, $0cd817c59cf7d5e8$export$98e6a39c04603d36)(formula));
}
function $afef59663c7fe1ad$export$49bb65c2ea163039(formula) {
    return (0, $0a99a8565361a0f1$export$80d376111cc09ad7)((0, $0cd817c59cf7d5e8$export$98e6a39c04603d36)(formula));
}


/**
 * @callback Handler
 *   Handle a value, with a certain ID field set to a certain value.
 *   The ID field is passed to `zwitch`, and it’s value is this function’s
 *   place on the `handlers` record.
 * @param {...any} parameters
 *   Arbitrary parameters passed to the zwitch.
 *   The first will be an object with a certain ID field set to a certain value.
 * @returns {any}
 *   Anything!
 */ /**
 * @callback UnknownHandler
 *   Handle values that do have a certain ID field, but it’s set to a value
 *   that is not listed in the `handlers` record.
 * @param {unknown} value
 *   An object with a certain ID field set to an unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {any}
 *   Anything!
 */ /**
 * @callback InvalidHandler
 *   Handle values that do not have a certain ID field.
 * @param {unknown} value
 *   Any unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {void|null|undefined|never}
 *   This should crash or return nothing.
 */ /**
 * @template {InvalidHandler} [Invalid=InvalidHandler]
 * @template {UnknownHandler} [Unknown=UnknownHandler]
 * @template {Record<string, Handler>} [Handlers=Record<string, Handler>]
 * @typedef Options
 *   Configuration (required).
 * @property {Invalid} [invalid]
 *   Handler to use for invalid values.
 * @property {Unknown} [unknown]
 *   Handler to use for unknown values.
 * @property {Handlers} [handlers]
 *   Handlers to use.
 */ const $17810db8694da3f3$var$own = {}.hasOwnProperty;
function $17810db8694da3f3$export$d6a12bfbbedf6185(key, options) {
    const settings = options || {};
    /**
   * Handle one value.
   *
   * Based on the bound `key`, a respective handler will be called.
   * If `value` is not an object, or doesn’t have a `key` property, the special
   * “invalid” handler will be called.
   * If `value` has an unknown `key`, the special “unknown” handler will be
   * called.
   *
   * All arguments, and the context object, are passed through to the handler,
   * and it’s result is returned.
   *
   * @this {unknown}
   *   Any context object.
   * @param {unknown} [value]
   *   Any value.
   * @param {...unknown} parameters
   *   Arbitrary parameters passed to the zwitch.
   * @property {Handler} invalid
   *   Handle for values that do not have a certain ID field.
   * @property {Handler} unknown
   *   Handle values that do have a certain ID field, but it’s set to a value
   *   that is not listed in the `handlers` record.
   * @property {Handlers} handlers
   *   Record of handlers.
   * @returns {unknown}
   *   Anything.
   */ function one(value, ...parameters) {
        /** @type {Handler|undefined} */ let fn = one.invalid;
        const handlers = one.handlers;
        if (value && $17810db8694da3f3$var$own.call(value, key)) {
            // @ts-expect-error Indexable.
            const id = String(value[key]);
            // @ts-expect-error Indexable.
            fn = $17810db8694da3f3$var$own.call(handlers, id) ? handlers[id] : one.unknown;
        }
        if (fn) return fn.call(this, value, ...parameters);
    }
    one.handlers = settings.handlers || {};
    one.invalid = settings.invalid;
    one.unknown = settings.unknown;
    // @ts-expect-error: matches!
    return one;
}



/** @type {NthCheck} */ // @ts-expect-error: types are broken.
const $a5b05a26e79bd4e7$var$nthCheck = (0, $afef59663c7fe1ad$export$2e2bcd8739ae039).default || (0, $afef59663c7fe1ad$export$2e2bcd8739ae039);
const $a5b05a26e79bd4e7$export$4a40d01fa098dd92 = (0, $17810db8694da3f3$export$d6a12bfbbedf6185)('name', {
    handlers: {
        'any-link': $a5b05a26e79bd4e7$var$anyLink,
        blank: $a5b05a26e79bd4e7$var$blank,
        checked: $a5b05a26e79bd4e7$var$checked,
        dir: $a5b05a26e79bd4e7$var$dir,
        disabled: $a5b05a26e79bd4e7$var$disabled,
        empty: $a5b05a26e79bd4e7$var$empty,
        enabled: $a5b05a26e79bd4e7$var$enabled,
        'first-child': $a5b05a26e79bd4e7$var$firstChild,
        'first-of-type': $a5b05a26e79bd4e7$var$firstOfType,
        has: $a5b05a26e79bd4e7$var$has,
        is: $a5b05a26e79bd4e7$var$is,
        lang: $a5b05a26e79bd4e7$var$lang,
        'last-child': $a5b05a26e79bd4e7$var$lastChild,
        'last-of-type': $a5b05a26e79bd4e7$var$lastOfType,
        not: $a5b05a26e79bd4e7$var$not,
        'nth-child': $a5b05a26e79bd4e7$var$nthChild,
        'nth-last-child': $a5b05a26e79bd4e7$var$nthLastChild,
        'nth-last-of-type': $a5b05a26e79bd4e7$var$nthLastOfType,
        'nth-of-type': $a5b05a26e79bd4e7$var$nthOfType,
        'only-child': $a5b05a26e79bd4e7$var$onlyChild,
        'only-of-type': $a5b05a26e79bd4e7$var$onlyOfType,
        optional: $a5b05a26e79bd4e7$var$optional,
        'read-only': $a5b05a26e79bd4e7$var$readOnly,
        'read-write': $a5b05a26e79bd4e7$var$readWrite,
        required: $a5b05a26e79bd4e7$var$required,
        root: $a5b05a26e79bd4e7$var$root,
        scope: $a5b05a26e79bd4e7$var$scope
    },
    invalid: $a5b05a26e79bd4e7$var$invalidPseudo,
    unknown: $a5b05a26e79bd4e7$var$unknownPseudo
});
/**
 * Check whether an element matches an `:any-link` pseudo.
 *
 * @param {AstPseudoClass} _
 *   Query.
 * @param {Element} element
 *   Element.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$anyLink(_, element) {
    return (element.tagName === 'a' || element.tagName === 'area' || element.tagName === 'link') && (0, $faf93996c771049f$export$bf9617eaf5d2451)(element, 'href');
}
/**
 * @param {State} state
 *   State.
 * @param {AstPseudoClass} query
 *   Query.
 */ function $a5b05a26e79bd4e7$var$assertDeep(state, query) {
    if (state.shallow) throw new Error('Cannot use `:' + query.name + '` without parent');
}
/**
 * Check whether an element matches a `:blank` pseudo.
 *
 * @param {AstPseudoClass} _
 *   Query.
 * @param {Element} element
 *   Element.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$blank(_, element) {
    return !$a5b05a26e79bd4e7$var$someChildren(element, check);
    /**
   * @param {ElementContent} child
   * @returns {boolean}
   */ function check(child) {
        return child.type === 'element' || child.type === 'text' && !(0, $99728b3b7e804493$export$7af1228ff777d175)(child);
    }
}
/**
 * Check whether an element matches a `:checked` pseudo.
 *
 * @param {AstPseudoClass} _
 *   Query.
 * @param {Element} element
 *   Element.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$checked(_, element) {
    if (element.tagName === 'input' || element.tagName === 'menuitem') return Boolean((element.properties.type === 'checkbox' || element.properties.type === 'radio') && (0, $faf93996c771049f$export$bf9617eaf5d2451)(element, 'checked'));
    if (element.tagName === 'option') return (0, $faf93996c771049f$export$bf9617eaf5d2451)(element, 'selected');
    return false;
}
/**
 * Check whether an element matches a `:dir()` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} _1
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _3
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ // eslint-disable-next-line unicorn/prevent-abbreviations
function $a5b05a26e79bd4e7$var$dir(query, _1, _2, _3, state) {
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(query.argument, 'expected `argument`');
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(query.argument.type === 'String', 'expected plain text');
    return state.direction === query.argument.value;
}
/**
 * Check whether an element matches a `:disabled` pseudo.
 *
 * @param {AstPseudoClass} _
 *   Query.
 * @param {Element} element
 *   Element.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$disabled(_, element) {
    return (element.tagName === 'button' || element.tagName === 'input' || element.tagName === 'select' || element.tagName === 'textarea' || element.tagName === 'optgroup' || element.tagName === 'option' || element.tagName === 'menuitem' || element.tagName === 'fieldset') && (0, $faf93996c771049f$export$bf9617eaf5d2451)(element, 'disabled');
}
/**
 * Check whether an element matches an `:empty` pseudo.
 *
 * @param {AstPseudoClass} _
 *   Query.
 * @param {Element} element
 *   Element.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$empty(_, element) {
    return !$a5b05a26e79bd4e7$var$someChildren(element, check);
    /**
   * @param {ElementContent} child
   * @returns {boolean}
   */ function check(child) {
        return child.type === 'element' || child.type === 'text';
    }
}
/**
 * Check whether an element matches an `:enabled` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} element
 *   Element.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$enabled(query, element) {
    return !$a5b05a26e79bd4e7$var$disabled(query, element);
}
/**
 * Check whether an element matches a `:first-child` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} _1
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _3
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$firstChild(query, _1, _2, _3, state) {
    $a5b05a26e79bd4e7$var$assertDeep(state, query);
    return state.elementIndex === 0;
}
/**
 * Check whether an element matches a `:first-of-type` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} _1
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _3
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$firstOfType(query, _1, _2, _3, state) {
    $a5b05a26e79bd4e7$var$assertDeep(state, query);
    return state.typeIndex === 0;
}
/**
 * @param {AstPseudoClass} query
 *   Query.
 * @returns {(value: number) => boolean}
 *   N.
 */ function $a5b05a26e79bd4e7$var$getCachedNthCheck(query) {
    /** @type {(value: number) => boolean} */ // @ts-expect-error: cache.
    let cachedFunction = query._cachedFn;
    if (!cachedFunction) {
        const value = query.argument;
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(value, 'expected `argument`');
        if (value.type !== 'Formula') throw new Error('Expected `nth` formula, such as `even` or `2n+1` (`of` is not yet supported)');
        cachedFunction = $a5b05a26e79bd4e7$var$nthCheck(value.a + 'n+' + value.b);
        // @ts-expect-error: cache.
        query._cachedFn = cachedFunction;
    }
    return cachedFunction;
}
/**
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} element
 *   Element.
 * @param {number | undefined} _1
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _2
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$has(query, element, _1, _2, state) {
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(query.argument, 'expected `argument`');
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(query.argument.type === 'Selector', 'expected selector');
    /** @type {State} */ const childState = {
        ...state,
        // Not found yet.
        found: false,
        // One result is enough.
        one: true,
        results: [],
        rootQuery: query.argument,
        scopeElements: [
            element
        ],
        // Do walk deep.
        shallow: false
    };
    (0, $fe3036b5ffa0fe7d$export$588732934346abbf)(childState, {
        type: 'root',
        children: element.children
    });
    return childState.results.length > 0;
}
// Shouldn’t be called, parser gives correct data.
/* c8 ignore next 3 */ function $a5b05a26e79bd4e7$var$invalidPseudo() {
    (0, $5f7e7f29fdd0c06b$export$565e9d9bd6b6e0d4)('Invalid pseudo-selector');
}
/**
 * Check whether an element `:is` further selectors.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} element
 *   Element.
 * @param {number | undefined} _1
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _2
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$is(query, element, _1, _2, state) {
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(query.argument, 'expected `argument`');
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(query.argument.type === 'Selector', 'expected selector');
    /** @type {State} */ const childState = {
        ...state,
        // Not found yet.
        found: false,
        // One result is enough.
        one: true,
        results: [],
        rootQuery: query.argument,
        scopeElements: [
            element
        ],
        // Do walk deep.
        shallow: false
    };
    (0, $fe3036b5ffa0fe7d$export$588732934346abbf)(childState, element);
    return childState.results[0] === element;
}
/**
 * Check whether an element matches a `:lang()` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} _1
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _3
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$lang(query, _1, _2, _3, state) {
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(query.argument, 'expected `argument`');
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(query.argument.type === 'String', 'expected string');
    return state.language !== '' && state.language !== undefined && (0, $b87ec220e0070103$export$d216e65da1a9aa7e)(state.language, (0, $9323934601145f2e$export$98e6a39c04603d36)(query.argument.value)).length > 0;
}
/**
 * Check whether an element matches a `:last-child` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} _1
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _3
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$lastChild(query, _1, _2, _3, state) {
    $a5b05a26e79bd4e7$var$assertDeep(state, query);
    return Boolean(state.elementCount && state.elementIndex === state.elementCount - 1);
}
/**
 * Check whether an element matches a `:last-of-type` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} _1
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _3
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$lastOfType(query, _1, _2, _3, state) {
    $a5b05a26e79bd4e7$var$assertDeep(state, query);
    return typeof state.typeIndex === 'number' && typeof state.typeCount === 'number' && state.typeIndex === state.typeCount - 1;
}
/**
 * Check whether an element does `:not` match further selectors.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} element
 *   Element.
 * @param {number | undefined} index
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} parent
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$not(query, element, index, parent, state) {
    return !$a5b05a26e79bd4e7$var$is(query, element, index, parent, state);
}
/**
 * Check whether an element matches an `:nth-child` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} _1
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _3
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$nthChild(query, _1, _2, _3, state) {
    const cachedFunction = $a5b05a26e79bd4e7$var$getCachedNthCheck(query);
    $a5b05a26e79bd4e7$var$assertDeep(state, query);
    return typeof state.elementIndex === 'number' && cachedFunction(state.elementIndex);
}
/**
 * Check whether an element matches an `:nth-last-child` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} _1
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _3
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$nthLastChild(query, _1, _2, _3, state) {
    const cachedFunction = $a5b05a26e79bd4e7$var$getCachedNthCheck(query);
    $a5b05a26e79bd4e7$var$assertDeep(state, query);
    return Boolean(typeof state.elementCount === 'number' && typeof state.elementIndex === 'number' && cachedFunction(state.elementCount - state.elementIndex - 1));
}
/**
 * Check whether an element matches a `:nth-last-of-type` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} _1
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _3
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$nthLastOfType(query, _1, _2, _3, state) {
    const cachedFunction = $a5b05a26e79bd4e7$var$getCachedNthCheck(query);
    $a5b05a26e79bd4e7$var$assertDeep(state, query);
    return typeof state.typeCount === 'number' && typeof state.typeIndex === 'number' && cachedFunction(state.typeCount - 1 - state.typeIndex);
}
/**
 * Check whether an element matches an `:nth-of-type` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} _1
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _3
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$nthOfType(query, _1, _2, _3, state) {
    const cachedFunction = $a5b05a26e79bd4e7$var$getCachedNthCheck(query);
    $a5b05a26e79bd4e7$var$assertDeep(state, query);
    return typeof state.typeIndex === 'number' && cachedFunction(state.typeIndex);
}
/**
 * Check whether an element matches an `:only-child` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} _1
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _3
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$onlyChild(query, _1, _2, _3, state) {
    $a5b05a26e79bd4e7$var$assertDeep(state, query);
    return state.elementCount === 1;
}
/**
 * Check whether an element matches an `:only-of-type` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} _1
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _3
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$onlyOfType(query, _1, _2, _3, state) {
    $a5b05a26e79bd4e7$var$assertDeep(state, query);
    return state.typeCount === 1;
}
/**
 * Check whether an element matches an `:optional` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} element
 *   Element.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$optional(query, element) {
    return !$a5b05a26e79bd4e7$var$required(query, element);
}
/**
 * Check whether an element matches a `:read-only` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} element
 *   Element.
 * @param {number | undefined} index
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} parent
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$readOnly(query, element, index, parent, state) {
    return !$a5b05a26e79bd4e7$var$readWrite(query, element, index, parent, state);
}
/**
 * Check whether an element matches a `:read-write` pseudo.
 *
 * @param {AstPseudoClass} _
 *   Query.
 * @param {Element} element
 *   Element.
 * @param {number | undefined} _1
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _2
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$readWrite(_, element, _1, _2, state) {
    return element.tagName === 'input' || element.tagName === 'textarea' ? !(0, $faf93996c771049f$export$bf9617eaf5d2451)(element, 'readOnly') && !(0, $faf93996c771049f$export$bf9617eaf5d2451)(element, 'disabled') : Boolean(state.editableOrEditingHost);
}
/**
 * Check whether an element matches a `:required` pseudo.
 *
 * @param {AstPseudoClass} _
 *   Query.
 * @param {Element} element
 *   Element.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$required(_, element) {
    return (element.tagName === 'input' || element.tagName === 'textarea' || element.tagName === 'select') && (0, $faf93996c771049f$export$bf9617eaf5d2451)(element, 'required');
}
/**
 * Check whether an element matches a `:root` pseudo.
 *
 * @param {AstPseudoClass} _1
 *   Query.
 * @param {Element} element
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} parent
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$root(_1, element, _2, parent, state) {
    return Boolean((!parent || parent.type === 'root') && state.schema && (state.schema.space === 'html' || state.schema.space === 'svg') && (element.tagName === 'html' || element.tagName === 'svg'));
}
/**
 * Check whether an element matches a `:scope` pseudo.
 *
 * @param {AstPseudoClass} _1
 *   Query.
 * @param {Element} element
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _3
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$scope(_1, element, _2, _3, state) {
    return state.scopeElements.includes(element);
}
/**
 * Check children.
 *
 * @param {Element} element
 *   Element.
 * @param {(child: ElementContent) => boolean} check
 *   Check.
 * @returns {boolean}
 *   Whether a child of `element` matches `check`.
 */ function $a5b05a26e79bd4e7$var$someChildren(element, check) {
    const children = element.children;
    let index = -1;
    while(++index < children.length){
        if (check(children[index])) return true;
    }
    return false;
}
/**
 * @param {unknown} query_
 *   Query-like value.
 * @returns {never}
 *   Nothing.
 * @throws
 *   Exception.
 */ function $a5b05a26e79bd4e7$var$unknownPseudo(query_) {
    // Runtime JS guarantees it has a `name`.
    const query = /** @type {AstPseudoClass} */ query_;
    throw new Error('Unknown pseudo-selector `' + query.name + '`');
}


function $54886b55b3c045c7$export$e0969da9b8fb378d(query, element, index, parent, state) {
    for (const item of query.items){
        // eslint-disable-next-line unicorn/prefer-switch
        if (item.type === 'Attribute') {
            if (!(0, $1e9a7b5843ff9cc5$export$af4b9a83f4b00434)(item, element, state.schema)) return false;
        } else if (item.type === 'Id') {
            if (!(0, $0d66214d99d2cbfa$export$d560c7e4a29451c2)(item, element)) return false;
        } else if (item.type === 'ClassName') {
            if (!(0, $693ce8a7cf643383$export$2913c0c0b5623090)(item, element)) return false;
        } else if (item.type === 'PseudoClass') {
            if (!(0, $a5b05a26e79bd4e7$export$4a40d01fa098dd92)(item, element, index, parent, state)) return false;
        } else if (item.type === 'PseudoElement') throw new Error('Invalid selector: `::' + item.name + '`');
        else if (item.type === 'TagName') {
            if (!(0, $22aadedf983dfddd$export$a8ff84c12d48cfa6)(item, element)) return false;
        }
    }
    return true;
}


/** @type {Array<never>} */ const $fe3036b5ffa0fe7d$var$empty = [];
function $fe3036b5ffa0fe7d$export$588732934346abbf(state, tree) {
    if (tree) $fe3036b5ffa0fe7d$var$one(state, [], tree, undefined, undefined, tree);
}
/**
 * Add a rule to a nesting map.
 *
 * @param {Nest} nest
 *   Nesting.
 * @param {keyof Nest} field
 *   Field.
 * @param {AstRule} rule
 *   Rule.
 */ function $fe3036b5ffa0fe7d$var$add(nest, field, rule) {
    const list = nest[field];
    if (list) list.push(rule);
    else nest[field] = [
        rule
    ];
}
/**
 * Check in a parent.
 *
 * @param {State} state
 *   State.
 * @param {Nest} nest
 *   Nesting.
 * @param {Parents} node
 *   Parent.
 * @param {Nodes} tree
 *   Tree.
 * @returns {undefined}
 *   Nothing.
 */ function $fe3036b5ffa0fe7d$var$all(state, nest, node, tree) {
    const fromParent = $fe3036b5ffa0fe7d$var$combine(nest.descendant, nest.directChild);
    /** @type {Array<AstRule> | undefined} */ let fromSibling;
    let index = -1;
    /**
   * Total counts.
   * @type {Counts}
   */ const total = {
        count: 0,
        types: new Map()
    };
    /**
   * Counts of previous siblings.
   * @type {Counts}
   */ const before = {
        count: 0,
        types: new Map()
    };
    while(++index < node.children.length)$fe3036b5ffa0fe7d$var$count(total, node.children[index]);
    index = -1;
    while(++index < node.children.length){
        const child = node.children[index];
        // Uppercase to prevent prototype polution, injecting `constructor` or so.
        // Normalize because HTML is insensitive.
        const name = child.type === 'element' ? child.tagName.toUpperCase() : undefined;
        // Before counting further elements:
        state.elementIndex = before.count;
        state.typeIndex = name ? before.types.get(name) || 0 : 0;
        // After counting all elements.
        state.elementCount = total.count;
        state.typeCount = name ? total.types.get(name) : 0;
        // Only apply if this is a parent, this should be an element, but we check
        // for parents so that we delve into custom nodes too.
        if ('children' in child) {
            const forSibling = $fe3036b5ffa0fe7d$var$combine(fromParent, fromSibling);
            const nest = $fe3036b5ffa0fe7d$var$one(state, forSibling, node.children[index], index, node, tree);
            fromSibling = $fe3036b5ffa0fe7d$var$combine(nest.generalSibling, nest.adjacentSibling);
        }
        // We found one thing, and one is enough.
        if (state.one && state.found) break;
        $fe3036b5ffa0fe7d$var$count(before, node.children[index]);
    }
}
/**
 * Apply selectors to an element.
 *
 * @param {State} state
 *   Current state.
 * @param {Array<AstRule>} rules
 *   Rules to apply.
 * @param {Element} node
 *   Element to apply rules to.
 * @param {number | undefined} index
 *   Index of `node` in `parent`.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @returns {Nest}
 *   Further rules.
 */ function $fe3036b5ffa0fe7d$var$applySelectors(state, rules, node, index, parent) {
    /** @type {Nest} */ const nestResult = {
        adjacentSibling: undefined,
        descendant: undefined,
        directChild: undefined,
        generalSibling: undefined
    };
    let selectorIndex = -1;
    while(++selectorIndex < rules.length){
        const rule = rules[selectorIndex];
        // We found one thing, and one is enough.
        if (state.one && state.found) break;
        // When shallow, we don’t allow nested rules.
        // Idea: we could allow a stack of parents?
        // Might get quite complex though.
        if (state.shallow && rule.nestedRule) throw new Error('Expected selector without nesting');
        // If this rule matches:
        if ((0, $54886b55b3c045c7$export$e0969da9b8fb378d)(rule, node, index, parent, state)) {
            const nest = rule.nestedRule;
            // Are there more?
            if (nest) {
                /** @type {keyof Nest} */ const label = nest.combinator === '+' ? 'adjacentSibling' : nest.combinator === '~' ? 'generalSibling' : nest.combinator === '>' ? 'directChild' : 'descendant';
                $fe3036b5ffa0fe7d$var$add(nestResult, label, nest);
            } else {
                // We have a match!
                state.found = true;
                if (!state.results.includes(node)) state.results.push(node);
            }
        }
        // Descendant.
        if (rule.combinator === undefined) $fe3036b5ffa0fe7d$var$add(nestResult, 'descendant', rule);
        else if (rule.combinator === '~') $fe3036b5ffa0fe7d$var$add(nestResult, 'generalSibling', rule);
    // Drop direct child (`>`), adjacent sibling (`+`).
    }
    return nestResult;
}
/**
 * Combine two lists, if needed.
 *
 * This is optimized to create as few lists as possible.
 *
 * @param {Array<AstRule> | undefined} left
 *   Rules.
 * @param {Array<AstRule> | undefined} right
 *   Rules.
 * @returns {Array<AstRule>}
 *   Rules.
 */ function $fe3036b5ffa0fe7d$var$combine(left, right) {
    return left && right && left.length > 0 && right.length > 0 ? [
        ...left,
        ...right
    ] : left && left.length > 0 ? left : right && right.length > 0 ? right : $fe3036b5ffa0fe7d$var$empty;
}
/**
 * Count a node.
 *
 * @param {Counts} counts
 *   Counts.
 * @param {Nodes} node
 *   Node (we’re looking for elements).
 * @returns {undefined}
 *   Nothing.
 */ function $fe3036b5ffa0fe7d$var$count(counts, node) {
    if (node.type === 'element') {
        // Uppercase to prevent prototype polution, injecting `constructor` or so.
        // Normalize because HTML is insensitive.
        const name = node.tagName.toUpperCase();
        const count = (counts.types.get(name) || 0) + 1;
        counts.count++;
        counts.types.set(name, count);
    }
}
/**
 * Check a node.
 *
 * @param {State} state
 *   State.
 * @param {Array<AstRule>} currentRules
 *   Rules.
 * @param {Nodes} node
 *   Node.
 * @param {number | undefined} index
 *   Index of `node` in `parent`.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @param {Nodes} tree
 *   Tree.
 * @returns {Nest}
 *   Nesting.
 */ function $fe3036b5ffa0fe7d$var$one(state, currentRules, node, index, parent, tree) {
    /** @type {Nest} */ let nestResult = {
        adjacentSibling: undefined,
        descendant: undefined,
        directChild: undefined,
        generalSibling: undefined
    };
    const exit = (0, $b8abdcb0edb929ec$export$b6a91203b6b36f)(state, node);
    if (node.type === 'element') {
        let rootRules = state.rootQuery.rules;
        // Remove direct child rules if this is the root.
        // This only happens for a `:has()` rule, which can be like
        // `a:has(> b)`.
        if (parent && parent !== tree) rootRules = state.rootQuery.rules.filter((d)=>d.combinator === undefined || d.combinator === '>' && parent === tree);
        nestResult = $fe3036b5ffa0fe7d$var$applySelectors(state, // Try the root rules for this element too.
        $fe3036b5ffa0fe7d$var$combine(currentRules, rootRules), node, index, parent);
    }
    // If this is a parent, and we want to delve into them, and we haven’t found
    // our single result yet.
    if ('children' in node && !state.shallow && !(state.one && state.found)) $fe3036b5ffa0fe7d$var$all(state, nestResult, node, tree);
    exit();
    return nestResult;
}


function $ec180a0534485ddf$export$de994efd351b291c(selector, node, space) {
    const state = $ec180a0534485ddf$var$createState(selector, node, space);
    state.one = true;
    state.shallow = true;
    (0, $fe3036b5ffa0fe7d$export$588732934346abbf)(state, node || undefined);
    return state.results.length > 0;
}
function $ec180a0534485ddf$export$2e6c959c16ff56b8(selector, tree, space) {
    const state = $ec180a0534485ddf$var$createState(selector, tree, space);
    state.one = true;
    (0, $fe3036b5ffa0fe7d$export$588732934346abbf)(state, tree || undefined);
    return state.results[0];
}
function $ec180a0534485ddf$export$90aca4adda6ff0f5(selector, tree, space) {
    const state = $ec180a0534485ddf$var$createState(selector, tree, space);
    (0, $fe3036b5ffa0fe7d$export$588732934346abbf)(state, tree || undefined);
    return state.results;
}
/**
 * @param {string} selector
 *   CSS selector, such as (`h1`, `a, b`).
 * @param {Nodes | null | undefined} [tree]
 *   Tree to search (optional).
 * @param {Space | null | undefined} [space='html']
 *   Name of namespace (default: `'html'`).
 * @returns {State} State
 *   State.
 */ function $ec180a0534485ddf$var$createState(selector, tree, space) {
    return {
        direction: 'ltr',
        editableOrEditingHost: false,
        elementCount: undefined,
        elementIndex: undefined,
        found: false,
        language: undefined,
        one: false,
        // State of the query.
        results: [],
        rootQuery: (0, $4124eb6fe7464b38$export$98e6a39c04603d36)(selector),
        schema: space === 'svg' ? (0, $cad208d20be39d74$export$7ed1367e7fa1ad68) : (0, $cad208d20be39d74$export$c0bb0b647f701bb5),
        scopeElements: tree ? tree.type === 'root' ? tree.children : [
            tree
        ] : [],
        shallow: false,
        typeIndex: undefined,
        typeCount: undefined
    };
}


const $bcddeefdf0cb0501$export$fdc2b83d227adb1a = (data = [], code = '')=>{
    data.forEach((node)=>{
        if (node.type === 'text') code += node.value;
        else if (node.type === 'element' && node.children && Array.isArray(node.children)) code += $bcddeefdf0cb0501$export$fdc2b83d227adb1a(node.children);
    });
    return code;
};
const $bcddeefdf0cb0501$var$remarkRewrite = (options)=>{
    const { selector: selector, rewrite: rewrite } = options || {};
    return (tree)=>{
        if (!rewrite || typeof rewrite !== 'function') return;
        if (selector && typeof selector === 'string') {
            const selected = (0, $ec180a0534485ddf$export$90aca4adda6ff0f5)(selector, tree);
            if (selected && selected.length > 0) (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(tree, selected, (node, index, parent)=>{
                rewrite(node, index, parent);
            });
            return;
        }
        (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(tree, (node, index, parent)=>{
            rewrite(node, index, parent);
        });
    };
};
var $bcddeefdf0cb0501$export$2e2bcd8739ae039 = $bcddeefdf0cb0501$var$remarkRewrite;


/**
 * @typedef {import('unist').Node} UnistNode
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ // To do: use types from `unist-util-visit-parents` when it’s released.
/**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends Array<any>
 *   ? MatchesOne<Value, Check[keyof Check]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends UnistNode ? number | undefined : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends UnistParent ? Ancestor | undefined : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [Ancestor=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Visited, Parent<Ancestor, Visited>>} BuildVisitorFromMatch
 *   Build a typed `Visitor` function from a node and all possible parents.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Visited
 *   Node type.
 * @template {UnistParent} Ancestor
 *   Parent type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     Matches<Descendant, Check>,
 *     Extract<Descendant, UnistParent>
 *   >
 * )} BuildVisitorFromDescendants
 *   Build a typed `Visitor` function from a list of descendants and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Node type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ 
function $6975da2fd2d5971c$export$bf638b60ea8b89b7(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
    /** @type {boolean | null | undefined} */ let reverse;
    /** @type {Test} */ let test;
    /** @type {Visitor} */ let visitor;
    if (typeof testOrVisitor === 'function' && typeof visitorOrReverse !== 'function') {
        test = undefined;
        visitor = testOrVisitor;
        reverse = visitorOrReverse;
    } else {
        // @ts-expect-error: assume the overload with test was given.
        test = testOrVisitor;
        // @ts-expect-error: assume the overload with test was given.
        visitor = visitorOrReverse;
        reverse = maybeReverse;
    }
    (0, $9ef2eaca0b34953c$export$70008a21eb6de899)(tree, test, overload, reverse);
    /**
   * @param {UnistNode} node
   * @param {Array<UnistParent>} parents
   */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        const index = parent ? parent.children.indexOf(node) : undefined;
        return visitor(node, index, parent);
    }
}


const $b0cad0253fcc653e$export$23a35a76cb919b24 = (url = '')=>(url.match(/([^?=&]+)(=([^&]*))/g) || []).reduce((a, v)=>(a[v.slice(0, v.indexOf('='))] = v.slice(v.indexOf('=') + 1), a), {});
const $b0cad0253fcc653e$export$7a7e2ad9b538cb5a = (data = [], index)=>{
    let i = index;
    while(i > -1){
        i--;
        if (!data[i]) return;
        if (data[i] && data[i].value && data[i].value.replace(/(\n|\s)/g, '') !== '' || data[i].type !== 'text') {
            if (!/^rehype:/.test(data[i].value) || data[i].type !== 'comment') return;
            return data[i];
        }
    }
    return;
};
const $b0cad0253fcc653e$export$dc55241c2417fab = (data = [], index, tagName, codeBlockParames)=>{
    let i = index;
    while(i < data.length){
        i++;
        if (tagName) {
            const element = data[i];
            if (element && element.value && element.value.replace(/(\n|\s)/g, '') !== '' || data[i] && data[i].type === 'element') return element.tagName === tagName ? element : undefined;
        } else {
            const element = data[i];
            if (!element || element.type === 'element') return;
            if (element.type === 'text' && element.value.replace(/(\n|\s)/g, '') !== '') return;
            if (element.type && /^(comment|raw)$/ig.test(element.type)) {
                if (element.value && !/^rehype:/.test(element.value.replace(/^(\s+)?<!--(.*?)-->/, '$2') || '')) return;
                if (codeBlockParames) {
                    const nextNode = $b0cad0253fcc653e$export$dc55241c2417fab(data, i, 'pre', codeBlockParames);
                    if (nextNode) return;
                    element.value = (element.value || '').replace(/^(\n|\s)+/, '');
                    return element;
                } else {
                    element.value = (element.value || '').replace(/^(\n|\s)+/, '');
                    return element;
                }
            }
        }
    }
    return;
};
const $b0cad0253fcc653e$export$4c884b6086c3192e = ({ value: value = '' })=>{
    const param = $b0cad0253fcc653e$export$23a35a76cb919b24(value.replace(/^<!--(.*?)-->/, '$1').replace(/^rehype:/, ''));
    Object.keys(param).forEach((keyName)=>{
        if (param[keyName] === 'true') param[keyName] = true;
        if (param[keyName] === 'false') param[keyName] = false;
        if (typeof param[keyName] === 'string' && !/^0/.test(param[keyName]) && !isNaN(+param[keyName])) param[keyName] = +param[keyName];
    });
    return param;
};
const $b0cad0253fcc653e$export$2238984c2c06f712 = (defaultAttrs, attrs, type)=>{
    if (type === 'string') return {
        ...defaultAttrs,
        'data-config': JSON.stringify({
            ...attrs,
            rehyp: true
        })
    };
    else if (type === 'attr') return {
        ...defaultAttrs,
        ...attrs
    };
    return {
        ...defaultAttrs,
        'data-config': {
            ...attrs,
            rehyp: true
        }
    };
};


const $d80b7298c6dd9c3b$var$rehypeAttrs = (options = {})=>{
    const { properties: properties = 'data', codeBlockParames: codeBlockParames = true } = options;
    return (tree)=>{
        (0, $6975da2fd2d5971c$export$bf638b60ea8b89b7)(tree, 'element', (node, index, parent)=>{
            if (codeBlockParames && node.tagName === 'pre' && node && Array.isArray(node.children) && parent && Array.isArray(parent.children) && parent.children.length > 1) {
                const firstChild = node.children[0];
                if (firstChild && firstChild.tagName === 'code' && typeof index === 'number') {
                    const child = (0, $b0cad0253fcc653e$export$7a7e2ad9b538cb5a)(parent.children, index);
                    if (child) {
                        const attr = (0, $b0cad0253fcc653e$export$4c884b6086c3192e)(child);
                        if (Object.keys(attr).length > 0) {
                            node.properties = {
                                ...node.properties,
                                'data-type': 'rehyp'
                            };
                            firstChild.properties = (0, $b0cad0253fcc653e$export$2238984c2c06f712)(firstChild.properties, attr, properties);
                        }
                    }
                }
            }
            if (/^(em|strong|b|a|i|p|pre|kbd|blockquote|h(1|2|3|4|5|6)|code|table|img|del|ul|ol)$/.test(node.tagName) && parent && Array.isArray(parent.children) && typeof index === 'number') {
                const child = (0, $b0cad0253fcc653e$export$dc55241c2417fab)(parent.children, index, '', codeBlockParames);
                if (child) {
                    const attr = (0, $b0cad0253fcc653e$export$4c884b6086c3192e)(child);
                    if (Object.keys(attr).length > 0) node.properties = (0, $b0cad0253fcc653e$export$2238984c2c06f712)(node.properties, attr, properties);
                }
            }
        });
    };
};
var $d80b7298c6dd9c3b$export$2e2bcd8739ae039 = $d80b7298c6dd9c3b$var$rehypeAttrs;


/**
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast-util-raw').Options} RawOptions
 * @typedef {import('vfile').VFile} VFile
 */ /**
 * @typedef {Omit<RawOptions, 'file'>} Options
 *   Configuration.
 */ /**
 * @import {Options} from 'hast-util-raw'
 * @import {Comment, Doctype, Element, Nodes, RootContent, Root, Text} from 'hast'
 * @import {Raw} from 'mdast-util-to-hast'
 * @import {DefaultTreeAdapterMap, ParserOptions} from 'parse5'
 * @import {Point} from 'unist'
 */ /**
 * @typedef State
 *   Info passed around about the current state.
 * @property {(node: Nodes) => undefined} handle
 *   Add a hast node to the parser.
 * @property {Options} options
 *   User configuration.
 * @property {Parser<DefaultTreeAdapterMap>} parser
 *   Current parser.
 * @property {boolean} stitches
 *   Whether there are stitches.
 */ /**
 * @typedef Stitch
 *   Custom comment-like value we pass through parse5, which contains a
 *   replacement node that we’ll swap back in afterwards.
 * @property {'comment'} type
 *   Node type.
 * @property {{stitch: Nodes}} value
 *   Replacement value.
 */ 
/**
 * @import {ElementData, Element, Nodes, RootContent, Root} from 'hast'
 * @import {DefaultTreeAdapterMap, Token} from 'parse5'
 * @import {Schema} from 'property-information'
 * @import {Point, Position} from 'unist'
 * @import {VFile} from 'vfile'
 * @import {Options} from 'hast-util-from-parse5'
 */ /**
 * @typedef State
 *   Info passed around about the current state.
 * @property {VFile | undefined} file
 *   Corresponding file.
 * @property {boolean} location
 *   Whether location info was found.
 * @property {Schema} schema
 *   Current schema.
 * @property {boolean | undefined} verbose
 *   Add extra positional info.
 */ 
// Register the JSX namespace on `h`.
/**
 * @typedef {import('./jsx-classic.js').Element} h.JSX.Element
 * @typedef {import('./jsx-classic.js').ElementChildrenAttribute} h.JSX.ElementChildrenAttribute
 * @typedef {import('./jsx-classic.js').IntrinsicAttributes} h.JSX.IntrinsicAttributes
 * @typedef {import('./jsx-classic.js').IntrinsicElements} h.JSX.IntrinsicElements
 */ // Register the JSX namespace on `s`.
/**
 * @typedef {import('./jsx-classic.js').Element} s.JSX.Element
 * @typedef {import('./jsx-classic.js').ElementChildrenAttribute} s.JSX.ElementChildrenAttribute
 * @typedef {import('./jsx-classic.js').IntrinsicAttributes} s.JSX.IntrinsicAttributes
 * @typedef {import('./jsx-classic.js').IntrinsicElements} s.JSX.IntrinsicElements
 */ 
/**
 * @import {Element, Nodes, RootContent, Root} from 'hast'
 * @import {Info, Schema} from 'property-information'
 */ /**
 * @typedef {Array<Nodes | PrimitiveChild>} ArrayChildNested
 *   List of children (deep).
 */ /**
 * @typedef {Array<ArrayChildNested | Nodes | PrimitiveChild>} ArrayChild
 *   List of children.
 */ /**
 * @typedef {Array<number | string>} ArrayValue
 *   List of property values for space- or comma separated values (such as `className`).
 */ /**
 * @typedef {ArrayChild | Nodes | PrimitiveChild} Child
 *   Acceptable child value.
 */ /**
 * @typedef {number | string | null | undefined} PrimitiveChild
 *   Primitive children, either ignored (nullish), or turned into text nodes.
 */ /**
 * @typedef {boolean | number | string | null | undefined} PrimitiveValue
 *   Primitive property value.
 */ /**
 * @typedef {Record<string, PropertyValue | Style>} Properties
 *   Acceptable value for element properties.
 */ /**
 * @typedef {ArrayValue | PrimitiveValue} PropertyValue
 *   Primitive value or list value.
 */ /**
 * @typedef {Element | Root} Result
 *   Result from a `h` (or `s`) call.
 */ /**
 * @typedef {number | string} StyleValue
 *   Value for a CSS style field.
 */ /**
 * @typedef {Record<string, StyleValue>} Style
 *   Supported value of a `style` prop.
 */ 
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 */ /**
 * @template {string} SimpleSelector
 *   Selector type.
 * @template {string} DefaultTagName
 *   Default tag name.
 * @typedef {(
 *   SimpleSelector extends ''
 *     ? DefaultTagName
 *     : SimpleSelector extends `${infer TagName}.${infer Rest}`
 *     ? ExtractTagName<TagName, DefaultTagName>
 *     : SimpleSelector extends `${infer TagName}#${infer Rest}`
 *     ? ExtractTagName<TagName, DefaultTagName>
 *     : SimpleSelector extends string
 *     ? SimpleSelector
 *     : DefaultTagName
 * )} ExtractTagName
 *   Extract tag name from a simple selector.
 */ const $3fdccad7db8388a7$var$search = /[#.]/g;
function $3fdccad7db8388a7$export$529769e360e2fa1b(selector, defaultTagName) {
    const value = selector || '';
    /** @type {Properties} */ const props = {};
    let start = 0;
    /** @type {string | undefined} */ let previous;
    /** @type {string | undefined} */ let tagName;
    while(start < value.length){
        $3fdccad7db8388a7$var$search.lastIndex = start;
        const match = $3fdccad7db8388a7$var$search.exec(value);
        const subvalue = value.slice(start, match ? match.index : value.length);
        if (subvalue) {
            if (!previous) tagName = subvalue;
            else if (previous === '#') props.id = subvalue;
            else if (Array.isArray(props.className)) props.className.push(subvalue);
            else props.className = [
                subvalue
            ];
            start += subvalue.length;
        }
        if (match) {
            previous = match[0];
            start++;
        }
    }
    return {
        type: 'element',
        // @ts-expect-error: tag name is parsed.
        tagName: tagName || defaultTagName || 'div',
        properties: props,
        children: []
    };
}




function $d415320c58bb27af$export$92ec6bcf7c3ee08c(schema, defaultTagName, caseSensitive) {
    const adjust = caseSensitive ? $d415320c58bb27af$var$createAdjustMap(caseSensitive) : undefined;
    /**
   * Hyperscript compatible DSL for creating virtual hast trees.
   *
   * @overload
   * @param {null | undefined} [selector]
   * @param {...Child} children
   * @returns {Root}
   *
   * @overload
   * @param {string} selector
   * @param {Properties} properties
   * @param {...Child} children
   * @returns {Element}
   *
   * @overload
   * @param {string} selector
   * @param {...Child} children
   * @returns {Element}
   *
   * @param {string | null | undefined} [selector]
   *   Selector.
   * @param {Child | Properties | null | undefined} [properties]
   *   Properties (or first child) (default: `undefined`).
   * @param {...Child} children
   *   Children.
   * @returns {Result}
   *   Result.
   */ function h(selector, properties, ...children) {
        /** @type {Result} */ let node;
        if (selector === null || selector === undefined) {
            node = {
                type: 'root',
                children: []
            };
            // Properties are not supported for roots.
            const child = /** @type {Child} */ properties;
            children.unshift(child);
        } else {
            node = (0, $3fdccad7db8388a7$export$529769e360e2fa1b)(selector, defaultTagName);
            // Normalize the name.
            const lower = node.tagName.toLowerCase();
            const adjusted = adjust ? adjust.get(lower) : undefined;
            node.tagName = adjusted || lower;
            // Handle properties.
            if ($d415320c58bb27af$var$isChild(properties)) children.unshift(properties);
            else for (const [key, value] of Object.entries(properties))$d415320c58bb27af$var$addProperty(schema, node.properties, key, value);
        }
        // Handle children.
        for (const child of children)$d415320c58bb27af$var$addChild(node.children, child);
        if (node.type === 'element' && node.tagName === 'template') {
            node.content = {
                type: 'root',
                children: node.children
            };
            node.children = [];
        }
        return node;
    }
    return h;
}
/**
 * Check if something is properties or a child.
 *
 * @param {Child | Properties} value
 *   Value to check.
 * @returns {value is Child}
 *   Whether `value` is definitely a child.
 */ function $d415320c58bb27af$var$isChild(value) {
    // Never properties if not an object.
    if (value === null || typeof value !== 'object' || Array.isArray(value)) return true;
    // Never node without `type`; that’s the main discriminator.
    if (typeof value.type !== 'string') return false;
    // Slower check: never property value if object or array with
    // non-number/strings.
    const record = /** @type {Record<string, unknown>} */ value;
    const keys = Object.keys(value);
    for (const key of keys){
        const value = record[key];
        if (value && typeof value === 'object') {
            if (!Array.isArray(value)) return true;
            const list = /** @type {ReadonlyArray<unknown>} */ value;
            for (const item of list){
                if (typeof item !== 'number' && typeof item !== 'string') return true;
            }
        }
    }
    // Also see empty `children` as a node.
    if ('children' in value && Array.isArray(value.children)) return true;
    // Default to properties, someone can always pass an empty object,
    // put `data: {}` in a node,
    // or wrap it in an array.
    return false;
}
/**
 * @param {Schema} schema
 *   Schema.
 * @param {Properties} properties
 *   Properties object.
 * @param {string} key
 *   Property name.
 * @param {PropertyValue | Style} value
 *   Property value.
 * @returns {undefined}
 *   Nothing.
 */ function $d415320c58bb27af$var$addProperty(schema, properties, key, value) {
    const info = (0, $84669bfd2b988556$export$71aa6c912b956294)(schema, key);
    /** @type {PropertyValue} */ let result;
    // Ignore nullish and NaN values.
    if (value === null || value === undefined) return;
    if (typeof value === 'number') {
        // Ignore NaN.
        if (Number.isNaN(value)) return;
        result = value;
    } else if (typeof value === 'boolean') result = value;
    else if (typeof value === 'string') {
        if (info.spaceSeparated) result = (0, $0d98344a9bfa0653$export$98e6a39c04603d36)(value);
        else if (info.commaSeparated) result = (0, $9323934601145f2e$export$98e6a39c04603d36)(value);
        else if (info.commaOrSpaceSeparated) result = (0, $0d98344a9bfa0653$export$98e6a39c04603d36)((0, $9323934601145f2e$export$98e6a39c04603d36)(value).join(' '));
        else result = $d415320c58bb27af$var$parsePrimitive(info, info.property, value);
    } else if (Array.isArray(value)) result = [
        ...value
    ];
    else result = info.property === 'style' ? $d415320c58bb27af$var$style(value) : String(value);
    if (Array.isArray(result)) {
        /** @type {Array<number | string>} */ const finalResult = [];
        for (const item of result)// Assume no booleans in array.
        finalResult.push(/** @type {number | string} */ $d415320c58bb27af$var$parsePrimitive(info, info.property, item));
        result = finalResult;
    }
    // Class names (which can be added both on the `selector` and here).
    if (info.property === 'className' && Array.isArray(properties.className)) // Assume no booleans in `className`.
    result = properties.className.concat(/** @type {Array<number | string> | number | string} */ result);
    properties[info.property] = result;
}
/**
 * @param {Array<RootContent>} nodes
 *   Children.
 * @param {Child} value
 *   Child.
 * @returns {undefined}
 *   Nothing.
 */ function $d415320c58bb27af$var$addChild(nodes, value) {
    if (value === null || value === undefined) ;
    else if (typeof value === 'number' || typeof value === 'string') nodes.push({
        type: 'text',
        value: String(value)
    });
    else if (Array.isArray(value)) for (const child of value)$d415320c58bb27af$var$addChild(nodes, child);
    else if (typeof value === 'object' && 'type' in value) {
        if (value.type === 'root') $d415320c58bb27af$var$addChild(nodes, value.children);
        else nodes.push(value);
    } else throw new Error('Expected node, nodes, or string, got `' + value + '`');
}
/**
 * Parse a single primitives.
 *
 * @param {Info} info
 *   Property information.
 * @param {string} name
 *   Property name.
 * @param {PrimitiveValue} value
 *   Property value.
 * @returns {PrimitiveValue}
 *   Property value.
 */ function $d415320c58bb27af$var$parsePrimitive(info, name, value) {
    if (typeof value === 'string') {
        if (info.number && value && !Number.isNaN(Number(value))) return Number(value);
        if ((info.boolean || info.overloadedBoolean) && (value === '' || (0, $e193cc6bfb75f539$export$a3295358bff77e)(value) === (0, $e193cc6bfb75f539$export$a3295358bff77e)(name))) return true;
    }
    return value;
}
/**
 * Serialize a `style` object as a string.
 *
 * @param {Style} styles
 *   Style object.
 * @returns {string}
 *   CSS string.
 */ function $d415320c58bb27af$var$style(styles) {
    /** @type {Array<string>} */ const result = [];
    for (const [key, value] of Object.entries(styles))result.push([
        key,
        value
    ].join(': '));
    return result.join('; ');
}
/**
 * Create a map to adjust casing.
 *
 * @param {ReadonlyArray<string>} values
 *   List of properly cased keys.
 * @returns {Map<string, string>}
 *   Map of lowercase keys to uppercase keys.
 */ function $d415320c58bb27af$var$createAdjustMap(values) {
    /** @type {Map<string, string>} */ const result = new Map();
    for (const value of values)result.set(value.toLowerCase(), value);
    return result;
}


/**
 * List of case-sensitive SVG tag names.
 *
 * @type {ReadonlyArray<string>}
 */ const $7f0a7850c17f5683$export$5ec6e4ea2f9364a1 = [
    'altGlyph',
    'altGlyphDef',
    'altGlyphItem',
    'animateColor',
    'animateMotion',
    'animateTransform',
    'clipPath',
    'feBlend',
    'feColorMatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feDropShadow',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'foreignObject',
    'glyphRef',
    'linearGradient',
    'radialGradient',
    'solidColor',
    'textArea',
    'textPath'
];


const $ef6b1b82ffb3458e$export$dda1d9f60106f0e9 = (0, $d415320c58bb27af$export$92ec6bcf7c3ee08c)((0, $cad208d20be39d74$export$c0bb0b647f701bb5), 'div');
const $ef6b1b82ffb3458e$export$2408f22a0fab9ae5 = (0, $d415320c58bb27af$export$92ec6bcf7c3ee08c)((0, $cad208d20be39d74$export$7ed1367e7fa1ad68), 'g', (0, $7f0a7850c17f5683$export$5ec6e4ea2f9364a1));



/**
 * @import {VFile, Value} from 'vfile'
 * @import {Location} from 'vfile-location'
 */ /**
 * Create an index of the given document to translate between line/column and
 * offset based positional info.
 *
 * Also implemented in Rust in [`wooorm/markdown-rs`][markdown-rs].
 *
 * [markdown-rs]: https://github.com/wooorm/markdown-rs/blob/main/src/util/location.rs
 *
 * @param {VFile | Value} file
 *   File to index.
 * @returns {Location}
 *   Accessors for index.
 */ function $cca897a9465fcc26$export$17b07c660794dc13(file) {
    const value = String(file);
    /**
   * List, where each index is a line number (0-based), and each value is the
   * byte index *after* where the line ends.
   *
   * @type {Array<number>}
   */ const indices = [];
    return {
        toOffset: toOffset,
        toPoint: toPoint
    };
    /** @type {Location['toPoint']} */ function toPoint(offset) {
        if (typeof offset === 'number' && offset > -1 && offset <= value.length) {
            let index = 0;
            while(true){
                let end = indices[index];
                if (end === undefined) {
                    const eol = $cca897a9465fcc26$var$next(value, indices[index - 1]);
                    end = eol === -1 ? value.length + 1 : eol + 1;
                    indices[index] = end;
                }
                if (end > offset) return {
                    line: index + 1,
                    column: offset - (index > 0 ? indices[index - 1] : 0) + 1,
                    offset: offset
                };
                index++;
            }
        }
    }
    /** @type {Location['toOffset']} */ function toOffset(point) {
        if (point && typeof point.line === 'number' && typeof point.column === 'number' && !Number.isNaN(point.line) && !Number.isNaN(point.column)) {
            while(indices.length < point.line){
                const from = indices[indices.length - 1];
                const eol = $cca897a9465fcc26$var$next(value, from);
                const end = eol === -1 ? value.length + 1 : eol + 1;
                if (from === end) break;
                indices.push(end);
            }
            const offset = (point.line > 1 ? indices[point.line - 2] : 0) + point.column - 1;
            // The given `column` could not exist on this line.
            if (offset < indices[point.line - 1]) return offset;
        }
    }
}
/**
 * @param {string} value
 * @param {number} from
 */ function $cca897a9465fcc26$var$next(value, from) {
    const cr = value.indexOf('\r', from);
    const lf = value.indexOf('\n', from);
    if (lf === -1) return cr;
    if (cr === -1 || cr + 1 === lf) return lf;
    return cr < lf ? cr : lf;
}


/**
 * Map of web namespaces.
 *
 * @type {Record<string, string>}
 */ const $1ef3bf91500f5903$export$f9bfcc6efbcb9478 = {
    html: 'http://www.w3.org/1999/xhtml',
    mathml: 'http://www.w3.org/1998/Math/MathML',
    svg: 'http://www.w3.org/2000/svg',
    xlink: 'http://www.w3.org/1999/xlink',
    xml: 'http://www.w3.org/XML/1998/namespace',
    xmlns: 'http://www.w3.org/2000/xmlns/'
};


const $73bde87d01cc5621$var$own = {}.hasOwnProperty;
/** @type {unknown} */ // type-coverage:ignore-next-line
const $73bde87d01cc5621$var$proto = Object.prototype;
function $73bde87d01cc5621$export$371ddbe92c872127(tree, options) {
    const settings = options || {};
    return $73bde87d01cc5621$var$one({
        file: settings.file || undefined,
        location: false,
        schema: settings.space === 'svg' ? (0, $cad208d20be39d74$export$7ed1367e7fa1ad68) : (0, $cad208d20be39d74$export$c0bb0b647f701bb5),
        verbose: settings.verbose || false
    }, tree);
}
/**
 * Transform a node.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {DefaultTreeAdapterMap['node']} node
 *   p5 node.
 * @returns {Nodes}
 *   hast node.
 */ function $73bde87d01cc5621$var$one(state, node) {
    /** @type {Nodes} */ let result;
    switch(node.nodeName){
        case '#comment':
            {
                const reference = /** @type {DefaultTreeAdapterMap['commentNode']} */ node;
                result = {
                    type: 'comment',
                    value: reference.data
                };
                $73bde87d01cc5621$var$patch(state, reference, result);
                return result;
            }
        case '#document':
        case '#document-fragment':
            {
                const reference = /** @type {DefaultTreeAdapterMap['document'] | DefaultTreeAdapterMap['documentFragment']} */ node;
                const quirksMode = 'mode' in reference ? reference.mode === 'quirks' || reference.mode === 'limited-quirks' : false;
                result = {
                    type: 'root',
                    children: $73bde87d01cc5621$var$all(state, node.childNodes),
                    data: {
                        quirksMode: quirksMode
                    }
                };
                if (state.file && state.location) {
                    const document = String(state.file);
                    const loc = (0, $cca897a9465fcc26$export$17b07c660794dc13)(document);
                    const start = loc.toPoint(0);
                    const end = loc.toPoint(document.length);
                    // Always defined as we give valid input.
                    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(start, 'expected `start`');
                    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(end, 'expected `end`');
                    result.position = {
                        start: start,
                        end: end
                    };
                }
                return result;
            }
        case '#documentType':
            {
                const reference = /** @type {DefaultTreeAdapterMap['documentType']} */ node;
                result = {
                    type: 'doctype'
                };
                $73bde87d01cc5621$var$patch(state, reference, result);
                return result;
            }
        case '#text':
            {
                const reference = /** @type {DefaultTreeAdapterMap['textNode']} */ node;
                result = {
                    type: 'text',
                    value: reference.value
                };
                $73bde87d01cc5621$var$patch(state, reference, result);
                return result;
            }
        // Element.
        default:
            {
                const reference = /** @type {DefaultTreeAdapterMap['element']} */ node;
                result = $73bde87d01cc5621$var$element(state, reference);
                return result;
            }
    }
}
/**
 * Transform children.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Array<DefaultTreeAdapterMap['node']>} nodes
 *   Nodes.
 * @returns {Array<RootContent>}
 *   hast nodes.
 */ function $73bde87d01cc5621$var$all(state, nodes) {
    let index = -1;
    /** @type {Array<RootContent>} */ const results = [];
    while(++index < nodes.length){
        // Assume no roots in `nodes`.
        const result = /** @type {RootContent} */ $73bde87d01cc5621$var$one(state, nodes[index]);
        results.push(result);
    }
    return results;
}
/**
 * Transform an element.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {DefaultTreeAdapterMap['element']} node
 *   `parse5` node to transform.
 * @returns {Element}
 *   hast node.
 */ function $73bde87d01cc5621$var$element(state, node) {
    const schema = state.schema;
    state.schema = node.namespaceURI === (0, $1ef3bf91500f5903$export$f9bfcc6efbcb9478).svg ? (0, $cad208d20be39d74$export$7ed1367e7fa1ad68) : (0, $cad208d20be39d74$export$c0bb0b647f701bb5);
    // Props.
    let index = -1;
    /** @type {Record<string, string>} */ const properties = {};
    while(++index < node.attrs.length){
        const attribute = node.attrs[index];
        const name = (attribute.prefix ? attribute.prefix + ':' : '') + attribute.name;
        if (!$73bde87d01cc5621$var$own.call($73bde87d01cc5621$var$proto, name)) properties[name] = attribute.value;
    }
    // Build.
    const x = state.schema.space === 'svg' ? (0, $ef6b1b82ffb3458e$export$2408f22a0fab9ae5) : (0, $ef6b1b82ffb3458e$export$dda1d9f60106f0e9);
    const result = x(node.tagName, properties, $73bde87d01cc5621$var$all(state, node.childNodes));
    $73bde87d01cc5621$var$patch(state, node, result);
    // Switch content.
    if (result.tagName === 'template') {
        const reference = /** @type {DefaultTreeAdapterMap['template']} */ node;
        const pos = reference.sourceCodeLocation;
        const startTag = pos && pos.startTag && $73bde87d01cc5621$var$position(pos.startTag);
        const endTag = pos && pos.endTag && $73bde87d01cc5621$var$position(pos.endTag);
        // Root in, root out.
        const content = /** @type {Root} */ $73bde87d01cc5621$var$one(state, reference.content);
        if (startTag && endTag && state.file) content.position = {
            start: startTag.end,
            end: endTag.start
        };
        result.content = content;
    }
    state.schema = schema;
    return result;
}
/**
 * Patch positional info from `from` onto `to`.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {DefaultTreeAdapterMap['node']} from
 *   p5 node.
 * @param {Nodes} to
 *   hast node.
 * @returns {undefined}
 *   Nothing.
 */ function $73bde87d01cc5621$var$patch(state, from, to) {
    if ('sourceCodeLocation' in from && from.sourceCodeLocation && state.file) {
        const position = $73bde87d01cc5621$var$createLocation(state, to, from.sourceCodeLocation);
        if (position) {
            state.location = true;
            to.position = position;
        }
    }
}
/**
 * Create clean positional information.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Nodes} node
 *   hast node.
 * @param {Token.ElementLocation} location
 *   p5 location info.
 * @returns {Position | undefined}
 *   Position, or nothing.
 */ function $73bde87d01cc5621$var$createLocation(state, node, location) {
    const result = $73bde87d01cc5621$var$position(location);
    if (node.type === 'element') {
        const tail = node.children[node.children.length - 1];
        // Bug for unclosed with children.
        // See: <https://github.com/inikulin/parse5/issues/109>.
        if (result && !location.endTag && tail && tail.position && tail.position.end) result.end = Object.assign({}, tail.position.end);
        if (state.verbose) {
            /** @type {Record<string, Position | undefined>} */ const properties = {};
            /** @type {string} */ let key;
            if (location.attrs) {
                for(key in location.attrs)if ($73bde87d01cc5621$var$own.call(location.attrs, key)) properties[(0, $84669bfd2b988556$export$71aa6c912b956294)(state.schema, key).property] = $73bde87d01cc5621$var$position(location.attrs[key]);
            }
            (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(location.startTag, 'a start tag should exist');
            const opening = $73bde87d01cc5621$var$position(location.startTag);
            const closing = location.endTag ? $73bde87d01cc5621$var$position(location.endTag) : undefined;
            /** @type {ElementData['position']} */ const data = {
                opening: opening
            };
            if (closing) data.closing = closing;
            data.properties = properties;
            node.data = {
                position: data
            };
        }
    }
    return result;
}
/**
 * Turn a p5 location into a position.
 *
 * @param {Token.Location} loc
 *   Location.
 * @returns {Position | undefined}
 *   Position or nothing.
 */ function $73bde87d01cc5621$var$position(loc) {
    const start = $73bde87d01cc5621$var$point({
        line: loc.startLine,
        column: loc.startCol,
        offset: loc.startOffset
    });
    const end = $73bde87d01cc5621$var$point({
        line: loc.endLine,
        column: loc.endCol,
        offset: loc.endOffset
    });
    // @ts-expect-error: we do use `undefined` for points if one or the other
    // exists.
    return start || end ? {
        start: start,
        end: end
    } : undefined;
}
/**
 * Filter out invalid points.
 *
 * @param {Point} point
 *   Point with potentially `undefined` values.
 * @returns {Point | undefined}
 *   Point or nothing.
 */ function $73bde87d01cc5621$var$point(point) {
    return point.line && point.column ? point : undefined;
}


/**
 * @import {Comment, Doctype, Element, Nodes, RootContent, Root, Text} from 'hast'
 * @import {DefaultTreeAdapterMap, Token} from 'parse5'
 * @import {Schema} from 'property-information'
 */ /**
 * @typedef {DefaultTreeAdapterMap['document']} Parse5Document
 * @typedef {DefaultTreeAdapterMap['documentFragment']} Parse5Fragment
 * @typedef {DefaultTreeAdapterMap['element']} Parse5Element
 * @typedef {DefaultTreeAdapterMap['node']} Parse5Nodes
 * @typedef {DefaultTreeAdapterMap['documentType']} Parse5Doctype
 * @typedef {DefaultTreeAdapterMap['commentNode']} Parse5Comment
 * @typedef {DefaultTreeAdapterMap['textNode']} Parse5Text
 * @typedef {DefaultTreeAdapterMap['parentNode']} Parse5Parent
 * @typedef {Token.Attribute} Parse5Attribute
 *
 * @typedef Options
 *   Configuration.
 * @property {Space | null | undefined} [space='html']
 *   Which space the document is in (default: `'html'`).
 *
 *   When an `<svg>` element is found in the HTML space, this package already
 *   automatically switches to and from the SVG space when entering and exiting
 *   it.
 *
 * @typedef {Exclude<Parse5Nodes, Parse5Document | Parse5Fragment>} Parse5Content
 *
 * @typedef {'html' | 'svg'} Space
 */ 





/** @type {Options} */ const $2e94052ec8d06cd1$var$emptyOptions = {};
const $2e94052ec8d06cd1$var$own = {}.hasOwnProperty;
const $2e94052ec8d06cd1$var$one = (0, $17810db8694da3f3$export$d6a12bfbbedf6185)('type', {
    handlers: {
        root: $2e94052ec8d06cd1$var$root,
        element: $2e94052ec8d06cd1$var$element,
        text: $2e94052ec8d06cd1$var$text,
        comment: $2e94052ec8d06cd1$var$comment,
        doctype: $2e94052ec8d06cd1$var$doctype
    }
});
function $2e94052ec8d06cd1$export$b4cf803c867502fc(tree, options) {
    const settings = options || $2e94052ec8d06cd1$var$emptyOptions;
    const space = settings.space;
    return $2e94052ec8d06cd1$var$one(tree, space === 'svg' ? (0, $cad208d20be39d74$export$7ed1367e7fa1ad68) : (0, $cad208d20be39d74$export$c0bb0b647f701bb5));
}
/**
 * @param {Root} node
 *   Node (hast) to transform.
 * @param {Schema} schema
 *   Current schema.
 * @returns {Parse5Document}
 *   Parse5 node.
 */ function $2e94052ec8d06cd1$var$root(node, schema) {
    /** @type {Parse5Document} */ const result = {
        nodeName: '#document',
        // @ts-expect-error: `parse5` uses enums, which are actually strings.
        mode: (node.data || {}).quirksMode ? 'quirks' : 'no-quirks',
        childNodes: []
    };
    result.childNodes = $2e94052ec8d06cd1$var$all(node.children, result, schema);
    $2e94052ec8d06cd1$var$patch(node, result);
    return result;
}
/**
 * @param {Root} node
 *   Node (hast) to transform.
 * @param {Schema} schema
 *   Current schema.
 * @returns {Parse5Fragment}
 *   Parse5 node.
 */ function $2e94052ec8d06cd1$var$fragment(node, schema) {
    /** @type {Parse5Fragment} */ const result = {
        nodeName: '#document-fragment',
        childNodes: []
    };
    result.childNodes = $2e94052ec8d06cd1$var$all(node.children, result, schema);
    $2e94052ec8d06cd1$var$patch(node, result);
    return result;
}
/**
 * @param {Doctype} node
 *   Node (hast) to transform.
 * @returns {Parse5Doctype}
 *   Parse5 node.
 */ function $2e94052ec8d06cd1$var$doctype(node) {
    /** @type {Parse5Doctype} */ const result = {
        nodeName: '#documentType',
        name: 'html',
        publicId: '',
        systemId: '',
        parentNode: null
    };
    $2e94052ec8d06cd1$var$patch(node, result);
    return result;
}
/**
 * @param {Text} node
 *   Node (hast) to transform.
 * @returns {Parse5Text}
 *   Parse5 node.
 */ function $2e94052ec8d06cd1$var$text(node) {
    /** @type {Parse5Text} */ const result = {
        nodeName: '#text',
        value: node.value,
        parentNode: null
    };
    $2e94052ec8d06cd1$var$patch(node, result);
    return result;
}
/**
 * @param {Comment} node
 *   Node (hast) to transform.
 * @returns {Parse5Comment}
 *   Parse5 node.
 */ function $2e94052ec8d06cd1$var$comment(node) {
    /** @type {Parse5Comment} */ const result = {
        nodeName: '#comment',
        data: node.value,
        parentNode: null
    };
    $2e94052ec8d06cd1$var$patch(node, result);
    return result;
}
/**
 * @param {Element} node
 *   Node (hast) to transform.
 * @param {Schema} schema
 *   Current schema.
 * @returns {Parse5Element}
 *   Parse5 node.
 */ function $2e94052ec8d06cd1$var$element(node, schema) {
    const parentSchema = schema;
    let currentSchema = parentSchema;
    if (node.type === 'element' && node.tagName.toLowerCase() === 'svg' && parentSchema.space === 'html') currentSchema = (0, $cad208d20be39d74$export$7ed1367e7fa1ad68);
    /** @type {Array<Parse5Attribute>} */ const attrs = [];
    /** @type {string} */ let prop;
    if (node.properties) {
        for(prop in node.properties)if (prop !== 'children' && $2e94052ec8d06cd1$var$own.call(node.properties, prop)) {
            const result = $2e94052ec8d06cd1$var$createProperty(currentSchema, prop, node.properties[prop]);
            if (result) attrs.push(result);
        }
    }
    const space = currentSchema.space;
    // `html` and `svg` both have a space.
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(space);
    /** @type {Parse5Element} */ const result = {
        nodeName: node.tagName,
        tagName: node.tagName,
        attrs: attrs,
        // @ts-expect-error: `parse5` types are wrong.
        namespaceURI: (0, $1ef3bf91500f5903$export$f9bfcc6efbcb9478)[space],
        childNodes: [],
        parentNode: null
    };
    result.childNodes = $2e94052ec8d06cd1$var$all(node.children, result, currentSchema);
    $2e94052ec8d06cd1$var$patch(node, result);
    if (node.tagName === 'template' && node.content) // @ts-expect-error: `parse5` types are wrong.
    result.content = $2e94052ec8d06cd1$var$fragment(node.content, currentSchema);
    return result;
}
/**
 * Handle a property.
 *
 * @param {Schema} schema
 *   Current schema.
 * @param {string} prop
 *   Key.
 * @param {Array<number | string> | boolean | number | string | null | undefined} value
 *   hast property value.
 * @returns {Parse5Attribute | undefined}
 *   Field for runtime, optional.
 */ function $2e94052ec8d06cd1$var$createProperty(schema, prop, value) {
    const info = (0, $84669bfd2b988556$export$71aa6c912b956294)(schema, prop);
    // Ignore nullish and `NaN` values.
    if (value === false || value === null || value === undefined || typeof value === 'number' && Number.isNaN(value) || !value && info.boolean) return;
    if (Array.isArray(value)) // Accept `array`.
    // Most props are space-separated.
    value = info.commaSeparated ? (0, $9323934601145f2e$export$fac44ee5b035f737)(value) : (0, $0d98344a9bfa0653$export$fac44ee5b035f737)(value);
    /** @type {Parse5Attribute} */ const attribute = {
        name: info.attribute,
        value: value === true ? '' : String(value)
    };
    if (info.space && info.space !== 'html' && info.space !== 'svg') {
        const index = attribute.name.indexOf(':');
        if (index < 0) attribute.prefix = '';
        else {
            attribute.name = attribute.name.slice(index + 1);
            attribute.prefix = info.attribute.slice(0, index);
        }
        attribute.namespace = (0, $1ef3bf91500f5903$export$f9bfcc6efbcb9478)[info.space];
    }
    return attribute;
}
/**
 * Transform all hast nodes.
 *
 * @param {Array<RootContent>} children
 *   List of children.
 * @param {Parse5Parent} parentNode
 *   `parse5` parent node.
 * @param {Schema} schema
 *   Current schema.
 * @returns {Array<Parse5Content>}
 *   Transformed children.
 */ function $2e94052ec8d06cd1$var$all(children, parentNode, schema) {
    let index = -1;
    /** @type {Array<Parse5Content>} */ const results = [];
    if (children) while(++index < children.length){
        /** @type {Parse5Content} */ const child = $2e94052ec8d06cd1$var$one(children[index], schema);
        child.parentNode = parentNode;
        results.push(child);
    }
    return results;
}
/**
 * Add position info from `from` to `to`.
 *
 * @param {Nodes} from
 *   hast node.
 * @param {Parse5Nodes} to
 *   `parse5` node.
 * @returns {undefined}
 *   Nothing.
 */ function $2e94052ec8d06cd1$var$patch(from, to) {
    const position = from.position;
    if (position && position.start && position.end) {
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(typeof position.start.offset === 'number');
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(typeof position.end.offset === 'number');
        to.sourceCodeLocation = {
            startLine: position.start.line,
            startCol: position.start.column,
            startOffset: position.start.offset,
            endLine: position.end.line,
            endCol: position.end.column,
            endOffset: position.end.offset
        };
    }
}


/**
 * List of HTML void tag names.
 *
 * @type {Array<string>}
 */ const $fe4fce3fd1fee116$export$762508062d068de = [
    'area',
    'base',
    'basefont',
    'bgsound',
    'br',
    'col',
    'command',
    'embed',
    'frame',
    'hr',
    'image',
    'img',
    'input',
    'keygen',
    'link',
    'meta',
    'param',
    'source',
    'track',
    'wbr'
];


const $bb1347fda1174ed8$var$UNDEFINED_CODE_POINTS = new Set([
    65534,
    65535,
    131070,
    131071,
    196606,
    196607,
    262142,
    262143,
    327678,
    327679,
    393214,
    393215,
    458750,
    458751,
    524286,
    524287,
    589822,
    589823,
    655358,
    655359,
    720894,
    720895,
    786430,
    786431,
    851966,
    851967,
    917502,
    917503,
    983038,
    983039,
    1048574,
    1048575,
    1114110,
    1114111
]);
const $bb1347fda1174ed8$export$e8d20e7a50e6c279 = '\uFFFD';
var $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0;
(function(CODE_POINTS) {
    CODE_POINTS[CODE_POINTS["EOF"] = -1] = "EOF";
    CODE_POINTS[CODE_POINTS["NULL"] = 0] = "NULL";
    CODE_POINTS[CODE_POINTS["TABULATION"] = 9] = "TABULATION";
    CODE_POINTS[CODE_POINTS["CARRIAGE_RETURN"] = 13] = "CARRIAGE_RETURN";
    CODE_POINTS[CODE_POINTS["LINE_FEED"] = 10] = "LINE_FEED";
    CODE_POINTS[CODE_POINTS["FORM_FEED"] = 12] = "FORM_FEED";
    CODE_POINTS[CODE_POINTS["SPACE"] = 32] = "SPACE";
    CODE_POINTS[CODE_POINTS["EXCLAMATION_MARK"] = 33] = "EXCLAMATION_MARK";
    CODE_POINTS[CODE_POINTS["QUOTATION_MARK"] = 34] = "QUOTATION_MARK";
    CODE_POINTS[CODE_POINTS["AMPERSAND"] = 38] = "AMPERSAND";
    CODE_POINTS[CODE_POINTS["APOSTROPHE"] = 39] = "APOSTROPHE";
    CODE_POINTS[CODE_POINTS["HYPHEN_MINUS"] = 45] = "HYPHEN_MINUS";
    CODE_POINTS[CODE_POINTS["SOLIDUS"] = 47] = "SOLIDUS";
    CODE_POINTS[CODE_POINTS["DIGIT_0"] = 48] = "DIGIT_0";
    CODE_POINTS[CODE_POINTS["DIGIT_9"] = 57] = "DIGIT_9";
    CODE_POINTS[CODE_POINTS["SEMICOLON"] = 59] = "SEMICOLON";
    CODE_POINTS[CODE_POINTS["LESS_THAN_SIGN"] = 60] = "LESS_THAN_SIGN";
    CODE_POINTS[CODE_POINTS["EQUALS_SIGN"] = 61] = "EQUALS_SIGN";
    CODE_POINTS[CODE_POINTS["GREATER_THAN_SIGN"] = 62] = "GREATER_THAN_SIGN";
    CODE_POINTS[CODE_POINTS["QUESTION_MARK"] = 63] = "QUESTION_MARK";
    CODE_POINTS[CODE_POINTS["LATIN_CAPITAL_A"] = 65] = "LATIN_CAPITAL_A";
    CODE_POINTS[CODE_POINTS["LATIN_CAPITAL_Z"] = 90] = "LATIN_CAPITAL_Z";
    CODE_POINTS[CODE_POINTS["RIGHT_SQUARE_BRACKET"] = 93] = "RIGHT_SQUARE_BRACKET";
    CODE_POINTS[CODE_POINTS["GRAVE_ACCENT"] = 96] = "GRAVE_ACCENT";
    CODE_POINTS[CODE_POINTS["LATIN_SMALL_A"] = 97] = "LATIN_SMALL_A";
    CODE_POINTS[CODE_POINTS["LATIN_SMALL_Z"] = 122] = "LATIN_SMALL_Z";
})($bb1347fda1174ed8$export$e3f6c2feb5c0ecc0 || ($bb1347fda1174ed8$export$e3f6c2feb5c0ecc0 = {}));
const $bb1347fda1174ed8$export$5abac700f947e2 = {
    DASH_DASH: '--',
    CDATA_START: '[CDATA[',
    DOCTYPE: 'doctype',
    SCRIPT: 'script',
    PUBLIC: 'public',
    SYSTEM: 'system'
};
function $bb1347fda1174ed8$export$7e678b42035e707f(cp) {
    return cp >= 55296 && cp <= 57343;
}
function $bb1347fda1174ed8$export$e7f1d94bb17e4055(cp) {
    return cp >= 56320 && cp <= 57343;
}
function $bb1347fda1174ed8$export$91e83256751ec906(cp1, cp2) {
    return (cp1 - 55296) * 1024 + 9216 + cp2;
}
function $bb1347fda1174ed8$export$d6953a6077926e(cp) {
    return cp !== 0x20 && cp !== 0x0a && cp !== 0x0d && cp !== 0x09 && cp !== 0x0c && cp >= 0x01 && cp <= 0x1f || cp >= 0x7f && cp <= 0x9f;
}
function $bb1347fda1174ed8$export$b3484aaf321bda02(cp) {
    return cp >= 64976 && cp <= 65007 || $bb1347fda1174ed8$var$UNDEFINED_CODE_POINTS.has(cp);
}


var $36aeaab04c5a6aea$export$9e0efcb140234d2;
(function(ERR) {
    ERR["controlCharacterInInputStream"] = "control-character-in-input-stream";
    ERR["noncharacterInInputStream"] = "noncharacter-in-input-stream";
    ERR["surrogateInInputStream"] = "surrogate-in-input-stream";
    ERR["nonVoidHtmlElementStartTagWithTrailingSolidus"] = "non-void-html-element-start-tag-with-trailing-solidus";
    ERR["endTagWithAttributes"] = "end-tag-with-attributes";
    ERR["endTagWithTrailingSolidus"] = "end-tag-with-trailing-solidus";
    ERR["unexpectedSolidusInTag"] = "unexpected-solidus-in-tag";
    ERR["unexpectedNullCharacter"] = "unexpected-null-character";
    ERR["unexpectedQuestionMarkInsteadOfTagName"] = "unexpected-question-mark-instead-of-tag-name";
    ERR["invalidFirstCharacterOfTagName"] = "invalid-first-character-of-tag-name";
    ERR["unexpectedEqualsSignBeforeAttributeName"] = "unexpected-equals-sign-before-attribute-name";
    ERR["missingEndTagName"] = "missing-end-tag-name";
    ERR["unexpectedCharacterInAttributeName"] = "unexpected-character-in-attribute-name";
    ERR["unknownNamedCharacterReference"] = "unknown-named-character-reference";
    ERR["missingSemicolonAfterCharacterReference"] = "missing-semicolon-after-character-reference";
    ERR["unexpectedCharacterAfterDoctypeSystemIdentifier"] = "unexpected-character-after-doctype-system-identifier";
    ERR["unexpectedCharacterInUnquotedAttributeValue"] = "unexpected-character-in-unquoted-attribute-value";
    ERR["eofBeforeTagName"] = "eof-before-tag-name";
    ERR["eofInTag"] = "eof-in-tag";
    ERR["missingAttributeValue"] = "missing-attribute-value";
    ERR["missingWhitespaceBetweenAttributes"] = "missing-whitespace-between-attributes";
    ERR["missingWhitespaceAfterDoctypePublicKeyword"] = "missing-whitespace-after-doctype-public-keyword";
    ERR["missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers"] = "missing-whitespace-between-doctype-public-and-system-identifiers";
    ERR["missingWhitespaceAfterDoctypeSystemKeyword"] = "missing-whitespace-after-doctype-system-keyword";
    ERR["missingQuoteBeforeDoctypePublicIdentifier"] = "missing-quote-before-doctype-public-identifier";
    ERR["missingQuoteBeforeDoctypeSystemIdentifier"] = "missing-quote-before-doctype-system-identifier";
    ERR["missingDoctypePublicIdentifier"] = "missing-doctype-public-identifier";
    ERR["missingDoctypeSystemIdentifier"] = "missing-doctype-system-identifier";
    ERR["abruptDoctypePublicIdentifier"] = "abrupt-doctype-public-identifier";
    ERR["abruptDoctypeSystemIdentifier"] = "abrupt-doctype-system-identifier";
    ERR["cdataInHtmlContent"] = "cdata-in-html-content";
    ERR["incorrectlyOpenedComment"] = "incorrectly-opened-comment";
    ERR["eofInScriptHtmlCommentLikeText"] = "eof-in-script-html-comment-like-text";
    ERR["eofInDoctype"] = "eof-in-doctype";
    ERR["nestedComment"] = "nested-comment";
    ERR["abruptClosingOfEmptyComment"] = "abrupt-closing-of-empty-comment";
    ERR["eofInComment"] = "eof-in-comment";
    ERR["incorrectlyClosedComment"] = "incorrectly-closed-comment";
    ERR["eofInCdata"] = "eof-in-cdata";
    ERR["absenceOfDigitsInNumericCharacterReference"] = "absence-of-digits-in-numeric-character-reference";
    ERR["nullCharacterReference"] = "null-character-reference";
    ERR["surrogateCharacterReference"] = "surrogate-character-reference";
    ERR["characterReferenceOutsideUnicodeRange"] = "character-reference-outside-unicode-range";
    ERR["controlCharacterReference"] = "control-character-reference";
    ERR["noncharacterCharacterReference"] = "noncharacter-character-reference";
    ERR["missingWhitespaceBeforeDoctypeName"] = "missing-whitespace-before-doctype-name";
    ERR["missingDoctypeName"] = "missing-doctype-name";
    ERR["invalidCharacterSequenceAfterDoctypeName"] = "invalid-character-sequence-after-doctype-name";
    ERR["duplicateAttribute"] = "duplicate-attribute";
    ERR["nonConformingDoctype"] = "non-conforming-doctype";
    ERR["missingDoctype"] = "missing-doctype";
    ERR["misplacedDoctype"] = "misplaced-doctype";
    ERR["endTagWithoutMatchingOpenElement"] = "end-tag-without-matching-open-element";
    ERR["closingOfElementWithOpenChildElements"] = "closing-of-element-with-open-child-elements";
    ERR["disallowedContentInNoscriptInHead"] = "disallowed-content-in-noscript-in-head";
    ERR["openElementsLeftAfterEof"] = "open-elements-left-after-eof";
    ERR["abandonedHeadElementChild"] = "abandoned-head-element-child";
    ERR["misplacedStartTagForHeadElement"] = "misplaced-start-tag-for-head-element";
    ERR["nestedNoscriptInHead"] = "nested-noscript-in-head";
    ERR["eofInElementThatCanContainOnlyText"] = "eof-in-element-that-can-contain-only-text";
})($36aeaab04c5a6aea$export$9e0efcb140234d2 || ($36aeaab04c5a6aea$export$9e0efcb140234d2 = {}));


//Const
const $5940cf2ccae8becf$var$DEFAULT_BUFFER_WATERLINE = 65536;
class $5940cf2ccae8becf$export$35db5c8036a15ad1 {
    constructor(handler){
        this.handler = handler;
        this.html = '';
        this.pos = -1;
        // NOTE: Initial `lastGapPos` is -2, to ensure `col` on initialisation is 0
        this.lastGapPos = -2;
        this.gapStack = [];
        this.skipNextNewLine = false;
        this.lastChunkWritten = false;
        this.endOfChunkHit = false;
        this.bufferWaterline = $5940cf2ccae8becf$var$DEFAULT_BUFFER_WATERLINE;
        this.isEol = false;
        this.lineStartPos = 0;
        this.droppedBufferSize = 0;
        this.line = 1;
        //NOTE: avoid reporting errors twice on advance/retreat
        this.lastErrOffset = -1;
    }
    /** The column on the current line. If we just saw a gap (eg. a surrogate pair), return the index before. */ get col() {
        return this.pos - this.lineStartPos + Number(this.lastGapPos !== this.pos);
    }
    get offset() {
        return this.droppedBufferSize + this.pos;
    }
    getError(code, cpOffset) {
        const { line: line, col: col, offset: offset } = this;
        const startCol = col + cpOffset;
        const startOffset = offset + cpOffset;
        return {
            code: code,
            startLine: line,
            endLine: line,
            startCol: startCol,
            endCol: startCol,
            startOffset: startOffset,
            endOffset: startOffset
        };
    }
    _err(code) {
        if (this.handler.onParseError && this.lastErrOffset !== this.offset) {
            this.lastErrOffset = this.offset;
            this.handler.onParseError(this.getError(code, 0));
        }
    }
    _addGap() {
        this.gapStack.push(this.lastGapPos);
        this.lastGapPos = this.pos;
    }
    _processSurrogate(cp) {
        //NOTE: try to peek a surrogate pair
        if (this.pos !== this.html.length - 1) {
            const nextCp = this.html.charCodeAt(this.pos + 1);
            if ((0, $bb1347fda1174ed8$export$e7f1d94bb17e4055)(nextCp)) {
                //NOTE: we have a surrogate pair. Peek pair character and recalculate code point.
                this.pos++;
                //NOTE: add a gap that should be avoided during retreat
                this._addGap();
                return (0, $bb1347fda1174ed8$export$91e83256751ec906)(cp, nextCp);
            }
        } else if (!this.lastChunkWritten) {
            this.endOfChunkHit = true;
            return (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF;
        }
        //NOTE: isolated surrogate
        this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).surrogateInInputStream);
        return cp;
    }
    willDropParsedChunk() {
        return this.pos > this.bufferWaterline;
    }
    dropParsedChunk() {
        if (this.willDropParsedChunk()) {
            this.html = this.html.substring(this.pos);
            this.lineStartPos -= this.pos;
            this.droppedBufferSize += this.pos;
            this.pos = 0;
            this.lastGapPos = -2;
            this.gapStack.length = 0;
        }
    }
    write(chunk, isLastChunk) {
        if (this.html.length > 0) this.html += chunk;
        else this.html = chunk;
        this.endOfChunkHit = false;
        this.lastChunkWritten = isLastChunk;
    }
    insertHtmlAtCurrentPos(chunk) {
        this.html = this.html.substring(0, this.pos + 1) + chunk + this.html.substring(this.pos + 1);
        this.endOfChunkHit = false;
    }
    startsWith(pattern, caseSensitive) {
        // Check if our buffer has enough characters
        if (this.pos + pattern.length > this.html.length) {
            this.endOfChunkHit = !this.lastChunkWritten;
            return false;
        }
        if (caseSensitive) return this.html.startsWith(pattern, this.pos);
        for(let i = 0; i < pattern.length; i++){
            const cp = this.html.charCodeAt(this.pos + i) | 0x20;
            if (cp !== pattern.charCodeAt(i)) return false;
        }
        return true;
    }
    peek(offset) {
        const pos = this.pos + offset;
        if (pos >= this.html.length) {
            this.endOfChunkHit = !this.lastChunkWritten;
            return (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF;
        }
        const code = this.html.charCodeAt(pos);
        return code === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).CARRIAGE_RETURN ? (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED : code;
    }
    advance() {
        this.pos++;
        //NOTE: LF should be in the last column of the line
        if (this.isEol) {
            this.isEol = false;
            this.line++;
            this.lineStartPos = this.pos;
        }
        if (this.pos >= this.html.length) {
            this.endOfChunkHit = !this.lastChunkWritten;
            return (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF;
        }
        let cp = this.html.charCodeAt(this.pos);
        //NOTE: all U+000D CARRIAGE RETURN (CR) characters must be converted to U+000A LINE FEED (LF) characters
        if (cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).CARRIAGE_RETURN) {
            this.isEol = true;
            this.skipNextNewLine = true;
            return (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED;
        }
        //NOTE: any U+000A LINE FEED (LF) characters that immediately follow a U+000D CARRIAGE RETURN (CR) character
        //must be ignored.
        if (cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED) {
            this.isEol = true;
            if (this.skipNextNewLine) {
                // `line` will be bumped again in the recursive call.
                this.line--;
                this.skipNextNewLine = false;
                this._addGap();
                return this.advance();
            }
        }
        this.skipNextNewLine = false;
        if ((0, $bb1347fda1174ed8$export$7e678b42035e707f)(cp)) cp = this._processSurrogate(cp);
        //OPTIMIZATION: first check if code point is in the common allowed
        //range (ASCII alphanumeric, whitespaces, big chunk of BMP)
        //before going into detailed performance cost validation.
        const isCommonValidRange = this.handler.onParseError === null || cp > 0x1f && cp < 0x7f || cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED || cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).CARRIAGE_RETURN || cp > 0x9f && cp < 64976;
        if (!isCommonValidRange) this._checkForProblematicCharacters(cp);
        return cp;
    }
    _checkForProblematicCharacters(cp) {
        if ((0, $bb1347fda1174ed8$export$d6953a6077926e)(cp)) this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).controlCharacterInInputStream);
        else if ((0, $bb1347fda1174ed8$export$b3484aaf321bda02)(cp)) this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).noncharacterInInputStream);
    }
    retreat(count) {
        this.pos -= count;
        while(this.pos < this.lastGapPos){
            this.lastGapPos = this.gapStack.pop();
            this.pos--;
        }
        this.isEol = false;
    }
}



var $be390ad8d330a451$exports = {};

$parcel$export($be390ad8d330a451$exports, "TokenType", function () { return $be390ad8d330a451$export$f435f793048e7a0f; });
$parcel$export($be390ad8d330a451$exports, "getTokenAttr", function () { return $be390ad8d330a451$export$df33bba014b5841e; });
var $be390ad8d330a451$export$f435f793048e7a0f;
(function(TokenType) {
    TokenType[TokenType["CHARACTER"] = 0] = "CHARACTER";
    TokenType[TokenType["NULL_CHARACTER"] = 1] = "NULL_CHARACTER";
    TokenType[TokenType["WHITESPACE_CHARACTER"] = 2] = "WHITESPACE_CHARACTER";
    TokenType[TokenType["START_TAG"] = 3] = "START_TAG";
    TokenType[TokenType["END_TAG"] = 4] = "END_TAG";
    TokenType[TokenType["COMMENT"] = 5] = "COMMENT";
    TokenType[TokenType["DOCTYPE"] = 6] = "DOCTYPE";
    TokenType[TokenType["EOF"] = 7] = "EOF";
    TokenType[TokenType["HIBERNATION"] = 8] = "HIBERNATION";
})($be390ad8d330a451$export$f435f793048e7a0f || ($be390ad8d330a451$export$f435f793048e7a0f = {}));
function $be390ad8d330a451$export$df33bba014b5841e(token, attrName) {
    for(let i = token.attrs.length - 1; i >= 0; i--){
        if (token.attrs[i].name === attrName) return token.attrs[i].value;
    }
    return null;
}


// Generated using scripts/write-decode-map.ts
const $8bb06a4e9c5f6236$export$b6a4accd5ee85f69 = /* #__PURE__ */ new Uint16Array(// prettier-ignore
/* #__PURE__ */ "\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c".split("").map((c)=>c.charCodeAt(0)));


// Generated using scripts/write-decode-map.ts
const $0de03497dce2af08$export$298b118b5a906d9f = /* #__PURE__ */ new Uint16Array(// prettier-ignore
/* #__PURE__ */ "\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022".split("").map((c)=>c.charCodeAt(0)));


// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $ac732ca4fea94b4a$var$_a;
const $ac732ca4fea94b4a$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
const $ac732ca4fea94b4a$export$73bfc63873071f74 = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, n/no-unsupported-features/es-builtins
($ac732ca4fea94b4a$var$_a = String.fromCodePoint) !== null && $ac732ca4fea94b4a$var$_a !== void 0 ? $ac732ca4fea94b4a$var$_a : function(codePoint) {
    let output = "";
    if (codePoint > 65535) {
        codePoint -= 65536;
        output += String.fromCharCode(codePoint >>> 10 & 1023 | 55296);
        codePoint = 56320 | codePoint & 1023;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
function $ac732ca4fea94b4a$export$b978ab756102108a(codePoint) {
    var _a;
    if (codePoint >= 55296 && codePoint <= 57343 || codePoint > 1114111) return 65533;
    return (_a = $ac732ca4fea94b4a$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
function $ac732ca4fea94b4a$export$1f5a05ca6191a69a(codePoint) {
    return $ac732ca4fea94b4a$export$73bfc63873071f74($ac732ca4fea94b4a$export$b978ab756102108a(codePoint));
}


var $b715bb39f665675e$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($b715bb39f665675e$var$CharCodes || ($b715bb39f665675e$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ const $b715bb39f665675e$var$TO_LOWER_BIT = 32;
var $b715bb39f665675e$export$6a4325c613e0faec;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($b715bb39f665675e$export$6a4325c613e0faec || ($b715bb39f665675e$export$6a4325c613e0faec = {}));
function $b715bb39f665675e$var$isNumber(code) {
    return code >= $b715bb39f665675e$var$CharCodes.ZERO && code <= $b715bb39f665675e$var$CharCodes.NINE;
}
function $b715bb39f665675e$var$isHexadecimalCharacter(code) {
    return code >= $b715bb39f665675e$var$CharCodes.UPPER_A && code <= $b715bb39f665675e$var$CharCodes.UPPER_F || code >= $b715bb39f665675e$var$CharCodes.LOWER_A && code <= $b715bb39f665675e$var$CharCodes.LOWER_F;
}
function $b715bb39f665675e$var$isAsciiAlphaNumeric(code) {
    return code >= $b715bb39f665675e$var$CharCodes.UPPER_A && code <= $b715bb39f665675e$var$CharCodes.UPPER_Z || code >= $b715bb39f665675e$var$CharCodes.LOWER_A && code <= $b715bb39f665675e$var$CharCodes.LOWER_Z || $b715bb39f665675e$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $b715bb39f665675e$var$isEntityInAttributeInvalidEnd(code) {
    return code === $b715bb39f665675e$var$CharCodes.EQUALS || $b715bb39f665675e$var$isAsciiAlphaNumeric(code);
}
var $b715bb39f665675e$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($b715bb39f665675e$var$EntityDecoderState || ($b715bb39f665675e$var$EntityDecoderState = {}));
var $b715bb39f665675e$export$8c8f129ce60f53c;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($b715bb39f665675e$export$8c8f129ce60f53c || ($b715bb39f665675e$export$8c8f129ce60f53c = {}));
class $b715bb39f665675e$export$15263a93ff7ec8ba {
    constructor(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors){
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $b715bb39f665675e$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $b715bb39f665675e$export$8c8f129ce60f53c.Strict;
    }
    /** Resets the instance to make it reusable. */ startEntity(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $b715bb39f665675e$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ write(input, offset) {
        switch(this.state){
            case $b715bb39f665675e$var$EntityDecoderState.EntityStart:
                if (input.charCodeAt(offset) === $b715bb39f665675e$var$CharCodes.NUM) {
                    this.state = $b715bb39f665675e$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(input, offset + 1);
                }
                this.state = $b715bb39f665675e$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(input, offset);
            case $b715bb39f665675e$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(input, offset);
            case $b715bb39f665675e$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(input, offset);
            case $b715bb39f665675e$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(input, offset);
            case $b715bb39f665675e$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(input, offset);
        }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericStart(input, offset) {
        if (offset >= input.length) return -1;
        if ((input.charCodeAt(offset) | $b715bb39f665675e$var$TO_LOWER_BIT) === $b715bb39f665675e$var$CharCodes.LOWER_X) {
            this.state = $b715bb39f665675e$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(input, offset + 1);
        }
        this.state = $b715bb39f665675e$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(input, offset);
    }
    addToNumericResult(input, start, end, base) {
        if (start !== end) {
            const digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + Number.parseInt(input.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericHex(input, offset) {
        const startIndex = offset;
        while(offset < input.length){
            const char = input.charCodeAt(offset);
            if ($b715bb39f665675e$var$isNumber(char) || $b715bb39f665675e$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(input, startIndex, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(input, startIndex, offset, 16);
        return -1;
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericDecimal(input, offset) {
        const startIndex = offset;
        while(offset < input.length){
            const char = input.charCodeAt(offset);
            if ($b715bb39f665675e$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(input, startIndex, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(input, startIndex, offset, 10);
        return -1;
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ emitNumericEntity(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $b715bb39f665675e$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $b715bb39f665675e$export$8c8f129ce60f53c.Strict) return 0;
        this.emitCodePoint((0, $ac732ca4fea94b4a$export$b978ab756102108a)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $b715bb39f665675e$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNamedEntity(input, offset) {
        const { decodeTree: decodeTree } = this;
        let current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        let valueLength = (current & $b715bb39f665675e$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        for(; offset < input.length; offset++, this.excess++){
            const char = input.charCodeAt(offset);
            this.treeIndex = $b715bb39f665675e$export$44c08d99945e6276(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $b715bb39f665675e$export$8c8f129ce60f53c.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $b715bb39f665675e$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $b715bb39f665675e$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $b715bb39f665675e$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $b715bb39f665675e$export$8c8f129ce60f53c.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ emitNotTerminatedNamedEntity() {
        var _a;
        const { result: result, decodeTree: decodeTree } = this;
        const valueLength = (decodeTree[result] & $b715bb39f665675e$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    }
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ emitNamedEntityData(result, valueLength, consumed) {
        const { decodeTree: decodeTree } = this;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$b715bb39f665675e$export$6a4325c613e0faec.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ end() {
        var _a;
        switch(this.state){
            case $b715bb39f665675e$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $b715bb39f665675e$export$8c8f129ce60f53c.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $b715bb39f665675e$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $b715bb39f665675e$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $b715bb39f665675e$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $b715bb39f665675e$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    }
}
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $b715bb39f665675e$var$getDecoder(decodeTree) {
    let returnValue = "";
    const decoder = new $b715bb39f665675e$export$15263a93ff7ec8ba(decodeTree, (data)=>returnValue += (0, $ac732ca4fea94b4a$export$73bfc63873071f74)(data));
    return function decodeWithTrie(input, decodeMode) {
        let lastIndex = 0;
        let offset = 0;
        while((offset = input.indexOf("&", offset)) >= 0){
            returnValue += input.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            const length = decoder.write(input, // Skip the "&"
            offset + 1);
            if (length < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + length;
            // If `length` is 0, skip the current `&` and continue.
            offset = length === 0 ? lastIndex + 1 : lastIndex;
        }
        const result = returnValue + input.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        returnValue = "";
        return result;
    };
}
function $b715bb39f665675e$export$44c08d99945e6276(decodeTree, current, nodeIndex, char) {
    const branchCount = (current & $b715bb39f665675e$export$6a4325c613e0faec.BRANCH_LENGTH) >> 7;
    const jumpOffset = current & $b715bb39f665675e$export$6a4325c613e0faec.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIndex : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        const value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIndex + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    let lo = nodeIndex;
    let hi = lo + branchCount - 1;
    while(lo <= hi){
        const mid = lo + hi >>> 1;
        const midValue = decodeTree[mid];
        if (midValue < char) lo = mid + 1;
        else if (midValue > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
const $b715bb39f665675e$var$htmlDecoder = /* #__PURE__ */ $b715bb39f665675e$var$getDecoder((0, $8bb06a4e9c5f6236$export$b6a4accd5ee85f69));
const $b715bb39f665675e$var$xmlDecoder = /* #__PURE__ */ $b715bb39f665675e$var$getDecoder((0, $0de03497dce2af08$export$298b118b5a906d9f));
function $b715bb39f665675e$export$f045cb747ce77a19(htmlString, mode = $b715bb39f665675e$export$8c8f129ce60f53c.Legacy) {
    return $b715bb39f665675e$var$htmlDecoder(htmlString, mode);
}
function $b715bb39f665675e$export$49f5e8089adb006a(htmlAttribute) {
    return $b715bb39f665675e$var$htmlDecoder(htmlAttribute, $b715bb39f665675e$export$8c8f129ce60f53c.Attribute);
}
function $b715bb39f665675e$export$da52f4371b3f37de(htmlString) {
    return $b715bb39f665675e$var$htmlDecoder(htmlString, $b715bb39f665675e$export$8c8f129ce60f53c.Strict);
}
function $b715bb39f665675e$export$88e3b9643a8bd06e(xmlString) {
    return $b715bb39f665675e$var$xmlDecoder(xmlString, $b715bb39f665675e$export$8c8f129ce60f53c.Strict);
}



var $c2855a9ccb69df69$exports = {};

$parcel$export($c2855a9ccb69df69$exports, "NS", function () { return $c2855a9ccb69df69$export$fb4028874a74450; });
$parcel$export($c2855a9ccb69df69$exports, "ATTRS", function () { return $c2855a9ccb69df69$export$380b7bc9e6cb1918; });
$parcel$export($c2855a9ccb69df69$exports, "DOCUMENT_MODE", function () { return $c2855a9ccb69df69$export$a74d46c85337d29a; });
$parcel$export($c2855a9ccb69df69$exports, "TAG_NAMES", function () { return $c2855a9ccb69df69$export$7e674a85a2656dce; });
$parcel$export($c2855a9ccb69df69$exports, "TAG_ID", function () { return $c2855a9ccb69df69$export$cb0999a53e0acaed; });
$parcel$export($c2855a9ccb69df69$exports, "getTagID", function () { return $c2855a9ccb69df69$export$39db8a1315f68282; });
$parcel$export($c2855a9ccb69df69$exports, "SPECIAL_ELEMENTS", function () { return $c2855a9ccb69df69$export$7e5172336f7d2bbb; });
$parcel$export($c2855a9ccb69df69$exports, "NUMBERED_HEADERS", function () { return $c2855a9ccb69df69$export$1ecc20fa0754c045; });
$parcel$export($c2855a9ccb69df69$exports, "hasUnescapedText", function () { return $c2855a9ccb69df69$export$4ce4f8c09f921aed; });
/** All valid namespaces in HTML. */ var $c2855a9ccb69df69$export$fb4028874a74450;
(function(NS) {
    NS["HTML"] = "http://www.w3.org/1999/xhtml";
    NS["MATHML"] = "http://www.w3.org/1998/Math/MathML";
    NS["SVG"] = "http://www.w3.org/2000/svg";
    NS["XLINK"] = "http://www.w3.org/1999/xlink";
    NS["XML"] = "http://www.w3.org/XML/1998/namespace";
    NS["XMLNS"] = "http://www.w3.org/2000/xmlns/";
})($c2855a9ccb69df69$export$fb4028874a74450 || ($c2855a9ccb69df69$export$fb4028874a74450 = {}));
var $c2855a9ccb69df69$export$380b7bc9e6cb1918;
(function(ATTRS) {
    ATTRS["TYPE"] = "type";
    ATTRS["ACTION"] = "action";
    ATTRS["ENCODING"] = "encoding";
    ATTRS["PROMPT"] = "prompt";
    ATTRS["NAME"] = "name";
    ATTRS["COLOR"] = "color";
    ATTRS["FACE"] = "face";
    ATTRS["SIZE"] = "size";
})($c2855a9ccb69df69$export$380b7bc9e6cb1918 || ($c2855a9ccb69df69$export$380b7bc9e6cb1918 = {}));
var $c2855a9ccb69df69$export$a74d46c85337d29a;
(function(DOCUMENT_MODE) {
    DOCUMENT_MODE["NO_QUIRKS"] = "no-quirks";
    DOCUMENT_MODE["QUIRKS"] = "quirks";
    DOCUMENT_MODE["LIMITED_QUIRKS"] = "limited-quirks";
})($c2855a9ccb69df69$export$a74d46c85337d29a || ($c2855a9ccb69df69$export$a74d46c85337d29a = {}));
var $c2855a9ccb69df69$export$7e674a85a2656dce;
(function(TAG_NAMES) {
    TAG_NAMES["A"] = "a";
    TAG_NAMES["ADDRESS"] = "address";
    TAG_NAMES["ANNOTATION_XML"] = "annotation-xml";
    TAG_NAMES["APPLET"] = "applet";
    TAG_NAMES["AREA"] = "area";
    TAG_NAMES["ARTICLE"] = "article";
    TAG_NAMES["ASIDE"] = "aside";
    TAG_NAMES["B"] = "b";
    TAG_NAMES["BASE"] = "base";
    TAG_NAMES["BASEFONT"] = "basefont";
    TAG_NAMES["BGSOUND"] = "bgsound";
    TAG_NAMES["BIG"] = "big";
    TAG_NAMES["BLOCKQUOTE"] = "blockquote";
    TAG_NAMES["BODY"] = "body";
    TAG_NAMES["BR"] = "br";
    TAG_NAMES["BUTTON"] = "button";
    TAG_NAMES["CAPTION"] = "caption";
    TAG_NAMES["CENTER"] = "center";
    TAG_NAMES["CODE"] = "code";
    TAG_NAMES["COL"] = "col";
    TAG_NAMES["COLGROUP"] = "colgroup";
    TAG_NAMES["DD"] = "dd";
    TAG_NAMES["DESC"] = "desc";
    TAG_NAMES["DETAILS"] = "details";
    TAG_NAMES["DIALOG"] = "dialog";
    TAG_NAMES["DIR"] = "dir";
    TAG_NAMES["DIV"] = "div";
    TAG_NAMES["DL"] = "dl";
    TAG_NAMES["DT"] = "dt";
    TAG_NAMES["EM"] = "em";
    TAG_NAMES["EMBED"] = "embed";
    TAG_NAMES["FIELDSET"] = "fieldset";
    TAG_NAMES["FIGCAPTION"] = "figcaption";
    TAG_NAMES["FIGURE"] = "figure";
    TAG_NAMES["FONT"] = "font";
    TAG_NAMES["FOOTER"] = "footer";
    TAG_NAMES["FOREIGN_OBJECT"] = "foreignObject";
    TAG_NAMES["FORM"] = "form";
    TAG_NAMES["FRAME"] = "frame";
    TAG_NAMES["FRAMESET"] = "frameset";
    TAG_NAMES["H1"] = "h1";
    TAG_NAMES["H2"] = "h2";
    TAG_NAMES["H3"] = "h3";
    TAG_NAMES["H4"] = "h4";
    TAG_NAMES["H5"] = "h5";
    TAG_NAMES["H6"] = "h6";
    TAG_NAMES["HEAD"] = "head";
    TAG_NAMES["HEADER"] = "header";
    TAG_NAMES["HGROUP"] = "hgroup";
    TAG_NAMES["HR"] = "hr";
    TAG_NAMES["HTML"] = "html";
    TAG_NAMES["I"] = "i";
    TAG_NAMES["IMG"] = "img";
    TAG_NAMES["IMAGE"] = "image";
    TAG_NAMES["INPUT"] = "input";
    TAG_NAMES["IFRAME"] = "iframe";
    TAG_NAMES["KEYGEN"] = "keygen";
    TAG_NAMES["LABEL"] = "label";
    TAG_NAMES["LI"] = "li";
    TAG_NAMES["LINK"] = "link";
    TAG_NAMES["LISTING"] = "listing";
    TAG_NAMES["MAIN"] = "main";
    TAG_NAMES["MALIGNMARK"] = "malignmark";
    TAG_NAMES["MARQUEE"] = "marquee";
    TAG_NAMES["MATH"] = "math";
    TAG_NAMES["MENU"] = "menu";
    TAG_NAMES["META"] = "meta";
    TAG_NAMES["MGLYPH"] = "mglyph";
    TAG_NAMES["MI"] = "mi";
    TAG_NAMES["MO"] = "mo";
    TAG_NAMES["MN"] = "mn";
    TAG_NAMES["MS"] = "ms";
    TAG_NAMES["MTEXT"] = "mtext";
    TAG_NAMES["NAV"] = "nav";
    TAG_NAMES["NOBR"] = "nobr";
    TAG_NAMES["NOFRAMES"] = "noframes";
    TAG_NAMES["NOEMBED"] = "noembed";
    TAG_NAMES["NOSCRIPT"] = "noscript";
    TAG_NAMES["OBJECT"] = "object";
    TAG_NAMES["OL"] = "ol";
    TAG_NAMES["OPTGROUP"] = "optgroup";
    TAG_NAMES["OPTION"] = "option";
    TAG_NAMES["P"] = "p";
    TAG_NAMES["PARAM"] = "param";
    TAG_NAMES["PLAINTEXT"] = "plaintext";
    TAG_NAMES["PRE"] = "pre";
    TAG_NAMES["RB"] = "rb";
    TAG_NAMES["RP"] = "rp";
    TAG_NAMES["RT"] = "rt";
    TAG_NAMES["RTC"] = "rtc";
    TAG_NAMES["RUBY"] = "ruby";
    TAG_NAMES["S"] = "s";
    TAG_NAMES["SCRIPT"] = "script";
    TAG_NAMES["SEARCH"] = "search";
    TAG_NAMES["SECTION"] = "section";
    TAG_NAMES["SELECT"] = "select";
    TAG_NAMES["SOURCE"] = "source";
    TAG_NAMES["SMALL"] = "small";
    TAG_NAMES["SPAN"] = "span";
    TAG_NAMES["STRIKE"] = "strike";
    TAG_NAMES["STRONG"] = "strong";
    TAG_NAMES["STYLE"] = "style";
    TAG_NAMES["SUB"] = "sub";
    TAG_NAMES["SUMMARY"] = "summary";
    TAG_NAMES["SUP"] = "sup";
    TAG_NAMES["TABLE"] = "table";
    TAG_NAMES["TBODY"] = "tbody";
    TAG_NAMES["TEMPLATE"] = "template";
    TAG_NAMES["TEXTAREA"] = "textarea";
    TAG_NAMES["TFOOT"] = "tfoot";
    TAG_NAMES["TD"] = "td";
    TAG_NAMES["TH"] = "th";
    TAG_NAMES["THEAD"] = "thead";
    TAG_NAMES["TITLE"] = "title";
    TAG_NAMES["TR"] = "tr";
    TAG_NAMES["TRACK"] = "track";
    TAG_NAMES["TT"] = "tt";
    TAG_NAMES["U"] = "u";
    TAG_NAMES["UL"] = "ul";
    TAG_NAMES["SVG"] = "svg";
    TAG_NAMES["VAR"] = "var";
    TAG_NAMES["WBR"] = "wbr";
    TAG_NAMES["XMP"] = "xmp";
})($c2855a9ccb69df69$export$7e674a85a2656dce || ($c2855a9ccb69df69$export$7e674a85a2656dce = {}));
var $c2855a9ccb69df69$export$cb0999a53e0acaed;
(function(TAG_ID) {
    TAG_ID[TAG_ID["UNKNOWN"] = 0] = "UNKNOWN";
    TAG_ID[TAG_ID["A"] = 1] = "A";
    TAG_ID[TAG_ID["ADDRESS"] = 2] = "ADDRESS";
    TAG_ID[TAG_ID["ANNOTATION_XML"] = 3] = "ANNOTATION_XML";
    TAG_ID[TAG_ID["APPLET"] = 4] = "APPLET";
    TAG_ID[TAG_ID["AREA"] = 5] = "AREA";
    TAG_ID[TAG_ID["ARTICLE"] = 6] = "ARTICLE";
    TAG_ID[TAG_ID["ASIDE"] = 7] = "ASIDE";
    TAG_ID[TAG_ID["B"] = 8] = "B";
    TAG_ID[TAG_ID["BASE"] = 9] = "BASE";
    TAG_ID[TAG_ID["BASEFONT"] = 10] = "BASEFONT";
    TAG_ID[TAG_ID["BGSOUND"] = 11] = "BGSOUND";
    TAG_ID[TAG_ID["BIG"] = 12] = "BIG";
    TAG_ID[TAG_ID["BLOCKQUOTE"] = 13] = "BLOCKQUOTE";
    TAG_ID[TAG_ID["BODY"] = 14] = "BODY";
    TAG_ID[TAG_ID["BR"] = 15] = "BR";
    TAG_ID[TAG_ID["BUTTON"] = 16] = "BUTTON";
    TAG_ID[TAG_ID["CAPTION"] = 17] = "CAPTION";
    TAG_ID[TAG_ID["CENTER"] = 18] = "CENTER";
    TAG_ID[TAG_ID["CODE"] = 19] = "CODE";
    TAG_ID[TAG_ID["COL"] = 20] = "COL";
    TAG_ID[TAG_ID["COLGROUP"] = 21] = "COLGROUP";
    TAG_ID[TAG_ID["DD"] = 22] = "DD";
    TAG_ID[TAG_ID["DESC"] = 23] = "DESC";
    TAG_ID[TAG_ID["DETAILS"] = 24] = "DETAILS";
    TAG_ID[TAG_ID["DIALOG"] = 25] = "DIALOG";
    TAG_ID[TAG_ID["DIR"] = 26] = "DIR";
    TAG_ID[TAG_ID["DIV"] = 27] = "DIV";
    TAG_ID[TAG_ID["DL"] = 28] = "DL";
    TAG_ID[TAG_ID["DT"] = 29] = "DT";
    TAG_ID[TAG_ID["EM"] = 30] = "EM";
    TAG_ID[TAG_ID["EMBED"] = 31] = "EMBED";
    TAG_ID[TAG_ID["FIELDSET"] = 32] = "FIELDSET";
    TAG_ID[TAG_ID["FIGCAPTION"] = 33] = "FIGCAPTION";
    TAG_ID[TAG_ID["FIGURE"] = 34] = "FIGURE";
    TAG_ID[TAG_ID["FONT"] = 35] = "FONT";
    TAG_ID[TAG_ID["FOOTER"] = 36] = "FOOTER";
    TAG_ID[TAG_ID["FOREIGN_OBJECT"] = 37] = "FOREIGN_OBJECT";
    TAG_ID[TAG_ID["FORM"] = 38] = "FORM";
    TAG_ID[TAG_ID["FRAME"] = 39] = "FRAME";
    TAG_ID[TAG_ID["FRAMESET"] = 40] = "FRAMESET";
    TAG_ID[TAG_ID["H1"] = 41] = "H1";
    TAG_ID[TAG_ID["H2"] = 42] = "H2";
    TAG_ID[TAG_ID["H3"] = 43] = "H3";
    TAG_ID[TAG_ID["H4"] = 44] = "H4";
    TAG_ID[TAG_ID["H5"] = 45] = "H5";
    TAG_ID[TAG_ID["H6"] = 46] = "H6";
    TAG_ID[TAG_ID["HEAD"] = 47] = "HEAD";
    TAG_ID[TAG_ID["HEADER"] = 48] = "HEADER";
    TAG_ID[TAG_ID["HGROUP"] = 49] = "HGROUP";
    TAG_ID[TAG_ID["HR"] = 50] = "HR";
    TAG_ID[TAG_ID["HTML"] = 51] = "HTML";
    TAG_ID[TAG_ID["I"] = 52] = "I";
    TAG_ID[TAG_ID["IMG"] = 53] = "IMG";
    TAG_ID[TAG_ID["IMAGE"] = 54] = "IMAGE";
    TAG_ID[TAG_ID["INPUT"] = 55] = "INPUT";
    TAG_ID[TAG_ID["IFRAME"] = 56] = "IFRAME";
    TAG_ID[TAG_ID["KEYGEN"] = 57] = "KEYGEN";
    TAG_ID[TAG_ID["LABEL"] = 58] = "LABEL";
    TAG_ID[TAG_ID["LI"] = 59] = "LI";
    TAG_ID[TAG_ID["LINK"] = 60] = "LINK";
    TAG_ID[TAG_ID["LISTING"] = 61] = "LISTING";
    TAG_ID[TAG_ID["MAIN"] = 62] = "MAIN";
    TAG_ID[TAG_ID["MALIGNMARK"] = 63] = "MALIGNMARK";
    TAG_ID[TAG_ID["MARQUEE"] = 64] = "MARQUEE";
    TAG_ID[TAG_ID["MATH"] = 65] = "MATH";
    TAG_ID[TAG_ID["MENU"] = 66] = "MENU";
    TAG_ID[TAG_ID["META"] = 67] = "META";
    TAG_ID[TAG_ID["MGLYPH"] = 68] = "MGLYPH";
    TAG_ID[TAG_ID["MI"] = 69] = "MI";
    TAG_ID[TAG_ID["MO"] = 70] = "MO";
    TAG_ID[TAG_ID["MN"] = 71] = "MN";
    TAG_ID[TAG_ID["MS"] = 72] = "MS";
    TAG_ID[TAG_ID["MTEXT"] = 73] = "MTEXT";
    TAG_ID[TAG_ID["NAV"] = 74] = "NAV";
    TAG_ID[TAG_ID["NOBR"] = 75] = "NOBR";
    TAG_ID[TAG_ID["NOFRAMES"] = 76] = "NOFRAMES";
    TAG_ID[TAG_ID["NOEMBED"] = 77] = "NOEMBED";
    TAG_ID[TAG_ID["NOSCRIPT"] = 78] = "NOSCRIPT";
    TAG_ID[TAG_ID["OBJECT"] = 79] = "OBJECT";
    TAG_ID[TAG_ID["OL"] = 80] = "OL";
    TAG_ID[TAG_ID["OPTGROUP"] = 81] = "OPTGROUP";
    TAG_ID[TAG_ID["OPTION"] = 82] = "OPTION";
    TAG_ID[TAG_ID["P"] = 83] = "P";
    TAG_ID[TAG_ID["PARAM"] = 84] = "PARAM";
    TAG_ID[TAG_ID["PLAINTEXT"] = 85] = "PLAINTEXT";
    TAG_ID[TAG_ID["PRE"] = 86] = "PRE";
    TAG_ID[TAG_ID["RB"] = 87] = "RB";
    TAG_ID[TAG_ID["RP"] = 88] = "RP";
    TAG_ID[TAG_ID["RT"] = 89] = "RT";
    TAG_ID[TAG_ID["RTC"] = 90] = "RTC";
    TAG_ID[TAG_ID["RUBY"] = 91] = "RUBY";
    TAG_ID[TAG_ID["S"] = 92] = "S";
    TAG_ID[TAG_ID["SCRIPT"] = 93] = "SCRIPT";
    TAG_ID[TAG_ID["SEARCH"] = 94] = "SEARCH";
    TAG_ID[TAG_ID["SECTION"] = 95] = "SECTION";
    TAG_ID[TAG_ID["SELECT"] = 96] = "SELECT";
    TAG_ID[TAG_ID["SOURCE"] = 97] = "SOURCE";
    TAG_ID[TAG_ID["SMALL"] = 98] = "SMALL";
    TAG_ID[TAG_ID["SPAN"] = 99] = "SPAN";
    TAG_ID[TAG_ID["STRIKE"] = 100] = "STRIKE";
    TAG_ID[TAG_ID["STRONG"] = 101] = "STRONG";
    TAG_ID[TAG_ID["STYLE"] = 102] = "STYLE";
    TAG_ID[TAG_ID["SUB"] = 103] = "SUB";
    TAG_ID[TAG_ID["SUMMARY"] = 104] = "SUMMARY";
    TAG_ID[TAG_ID["SUP"] = 105] = "SUP";
    TAG_ID[TAG_ID["TABLE"] = 106] = "TABLE";
    TAG_ID[TAG_ID["TBODY"] = 107] = "TBODY";
    TAG_ID[TAG_ID["TEMPLATE"] = 108] = "TEMPLATE";
    TAG_ID[TAG_ID["TEXTAREA"] = 109] = "TEXTAREA";
    TAG_ID[TAG_ID["TFOOT"] = 110] = "TFOOT";
    TAG_ID[TAG_ID["TD"] = 111] = "TD";
    TAG_ID[TAG_ID["TH"] = 112] = "TH";
    TAG_ID[TAG_ID["THEAD"] = 113] = "THEAD";
    TAG_ID[TAG_ID["TITLE"] = 114] = "TITLE";
    TAG_ID[TAG_ID["TR"] = 115] = "TR";
    TAG_ID[TAG_ID["TRACK"] = 116] = "TRACK";
    TAG_ID[TAG_ID["TT"] = 117] = "TT";
    TAG_ID[TAG_ID["U"] = 118] = "U";
    TAG_ID[TAG_ID["UL"] = 119] = "UL";
    TAG_ID[TAG_ID["SVG"] = 120] = "SVG";
    TAG_ID[TAG_ID["VAR"] = 121] = "VAR";
    TAG_ID[TAG_ID["WBR"] = 122] = "WBR";
    TAG_ID[TAG_ID["XMP"] = 123] = "XMP";
})($c2855a9ccb69df69$export$cb0999a53e0acaed || ($c2855a9ccb69df69$export$cb0999a53e0acaed = {}));
const $c2855a9ccb69df69$var$TAG_NAME_TO_ID = new Map([
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.A,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.A
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.ADDRESS,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.ADDRESS
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.ANNOTATION_XML,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.ANNOTATION_XML
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.APPLET,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.APPLET
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.AREA,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.AREA
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.ARTICLE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.ARTICLE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.ASIDE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.ASIDE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.B,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.B
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.BASE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.BASE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.BASEFONT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.BASEFONT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.BGSOUND,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.BGSOUND
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.BIG,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.BIG
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.BLOCKQUOTE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.BLOCKQUOTE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.BODY,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.BODY
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.BR,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.BR
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.BUTTON,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.BUTTON
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.CAPTION,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.CAPTION
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.CENTER,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.CENTER
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.CODE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.CODE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.COL,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.COL
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.COLGROUP,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.COLGROUP
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.DD,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.DD
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.DESC,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.DESC
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.DETAILS,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.DETAILS
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.DIALOG,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.DIALOG
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.DIR,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.DIR
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.DIV,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.DIV
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.DL,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.DL
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.DT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.DT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.EM,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.EM
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.EMBED,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.EMBED
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.FIELDSET,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.FIELDSET
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.FIGCAPTION,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.FIGCAPTION
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.FIGURE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.FIGURE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.FONT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.FONT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.FOOTER,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.FOOTER
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.FOREIGN_OBJECT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.FOREIGN_OBJECT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.FORM,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.FORM
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.FRAME,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.FRAME
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.FRAMESET,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.FRAMESET
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.H1,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.H1
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.H2,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.H2
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.H3,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.H3
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.H4,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.H4
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.H5,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.H5
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.H6,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.H6
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.HEAD,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.HEAD
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.HEADER,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.HEADER
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.HGROUP,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.HGROUP
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.HR,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.HR
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.HTML,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.HTML
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.I,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.I
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.IMG,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.IMG
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.IMAGE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.IMAGE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.INPUT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.INPUT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.IFRAME,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.IFRAME
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.KEYGEN,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.KEYGEN
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.LABEL,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.LABEL
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.LI,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.LI
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.LINK,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.LINK
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.LISTING,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.LISTING
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.MAIN,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.MAIN
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.MALIGNMARK,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.MALIGNMARK
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.MARQUEE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.MARQUEE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.MATH,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.MATH
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.MENU,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.MENU
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.META,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.META
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.MGLYPH,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.MGLYPH
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.MI,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.MI
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.MO,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.MO
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.MN,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.MN
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.MS,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.MS
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.MTEXT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.MTEXT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.NAV,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.NAV
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.NOBR,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.NOBR
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.NOFRAMES,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.NOFRAMES
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.NOEMBED,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.NOEMBED
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.NOSCRIPT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.NOSCRIPT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.OBJECT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.OBJECT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.OL,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.OL
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.OPTGROUP,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.OPTGROUP
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.OPTION,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.OPTION
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.P,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.P
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.PARAM,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.PARAM
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.PLAINTEXT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.PLAINTEXT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.PRE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.PRE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.RB,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.RB
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.RP,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.RP
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.RT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.RT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.RTC,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.RTC
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.RUBY,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.RUBY
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.S,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.S
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.SCRIPT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.SCRIPT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.SEARCH,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.SEARCH
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.SECTION,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.SECTION
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.SELECT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.SELECT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.SOURCE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.SOURCE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.SMALL,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.SMALL
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.SPAN,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.SPAN
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.STRIKE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.STRIKE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.STRONG,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.STRONG
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.STYLE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.STYLE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.SUB,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.SUB
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.SUMMARY,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.SUMMARY
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.SUP,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.SUP
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.TABLE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.TABLE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.TBODY,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.TBODY
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.TEMPLATE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.TEMPLATE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.TEXTAREA,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.TEXTAREA
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.TFOOT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.TFOOT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.TD,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.TD
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.TH,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.TH
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.THEAD,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.THEAD
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.TITLE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.TITLE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.TR,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.TR
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.TRACK,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.TRACK
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.TT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.TT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.U,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.U
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.UL,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.UL
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.SVG,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.SVG
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.VAR,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.VAR
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.WBR,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.WBR
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.XMP,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.XMP
    ]
]);
function $c2855a9ccb69df69$export$39db8a1315f68282(tagName) {
    var _a;
    return (_a = $c2855a9ccb69df69$var$TAG_NAME_TO_ID.get(tagName)) !== null && _a !== void 0 ? _a : $c2855a9ccb69df69$export$cb0999a53e0acaed.UNKNOWN;
}
const $c2855a9ccb69df69$var$$ = $c2855a9ccb69df69$export$cb0999a53e0acaed;
const $c2855a9ccb69df69$export$7e5172336f7d2bbb = {
    [$c2855a9ccb69df69$export$fb4028874a74450.HTML]: new Set([
        $c2855a9ccb69df69$var$$.ADDRESS,
        $c2855a9ccb69df69$var$$.APPLET,
        $c2855a9ccb69df69$var$$.AREA,
        $c2855a9ccb69df69$var$$.ARTICLE,
        $c2855a9ccb69df69$var$$.ASIDE,
        $c2855a9ccb69df69$var$$.BASE,
        $c2855a9ccb69df69$var$$.BASEFONT,
        $c2855a9ccb69df69$var$$.BGSOUND,
        $c2855a9ccb69df69$var$$.BLOCKQUOTE,
        $c2855a9ccb69df69$var$$.BODY,
        $c2855a9ccb69df69$var$$.BR,
        $c2855a9ccb69df69$var$$.BUTTON,
        $c2855a9ccb69df69$var$$.CAPTION,
        $c2855a9ccb69df69$var$$.CENTER,
        $c2855a9ccb69df69$var$$.COL,
        $c2855a9ccb69df69$var$$.COLGROUP,
        $c2855a9ccb69df69$var$$.DD,
        $c2855a9ccb69df69$var$$.DETAILS,
        $c2855a9ccb69df69$var$$.DIR,
        $c2855a9ccb69df69$var$$.DIV,
        $c2855a9ccb69df69$var$$.DL,
        $c2855a9ccb69df69$var$$.DT,
        $c2855a9ccb69df69$var$$.EMBED,
        $c2855a9ccb69df69$var$$.FIELDSET,
        $c2855a9ccb69df69$var$$.FIGCAPTION,
        $c2855a9ccb69df69$var$$.FIGURE,
        $c2855a9ccb69df69$var$$.FOOTER,
        $c2855a9ccb69df69$var$$.FORM,
        $c2855a9ccb69df69$var$$.FRAME,
        $c2855a9ccb69df69$var$$.FRAMESET,
        $c2855a9ccb69df69$var$$.H1,
        $c2855a9ccb69df69$var$$.H2,
        $c2855a9ccb69df69$var$$.H3,
        $c2855a9ccb69df69$var$$.H4,
        $c2855a9ccb69df69$var$$.H5,
        $c2855a9ccb69df69$var$$.H6,
        $c2855a9ccb69df69$var$$.HEAD,
        $c2855a9ccb69df69$var$$.HEADER,
        $c2855a9ccb69df69$var$$.HGROUP,
        $c2855a9ccb69df69$var$$.HR,
        $c2855a9ccb69df69$var$$.HTML,
        $c2855a9ccb69df69$var$$.IFRAME,
        $c2855a9ccb69df69$var$$.IMG,
        $c2855a9ccb69df69$var$$.INPUT,
        $c2855a9ccb69df69$var$$.LI,
        $c2855a9ccb69df69$var$$.LINK,
        $c2855a9ccb69df69$var$$.LISTING,
        $c2855a9ccb69df69$var$$.MAIN,
        $c2855a9ccb69df69$var$$.MARQUEE,
        $c2855a9ccb69df69$var$$.MENU,
        $c2855a9ccb69df69$var$$.META,
        $c2855a9ccb69df69$var$$.NAV,
        $c2855a9ccb69df69$var$$.NOEMBED,
        $c2855a9ccb69df69$var$$.NOFRAMES,
        $c2855a9ccb69df69$var$$.NOSCRIPT,
        $c2855a9ccb69df69$var$$.OBJECT,
        $c2855a9ccb69df69$var$$.OL,
        $c2855a9ccb69df69$var$$.P,
        $c2855a9ccb69df69$var$$.PARAM,
        $c2855a9ccb69df69$var$$.PLAINTEXT,
        $c2855a9ccb69df69$var$$.PRE,
        $c2855a9ccb69df69$var$$.SCRIPT,
        $c2855a9ccb69df69$var$$.SECTION,
        $c2855a9ccb69df69$var$$.SELECT,
        $c2855a9ccb69df69$var$$.SOURCE,
        $c2855a9ccb69df69$var$$.STYLE,
        $c2855a9ccb69df69$var$$.SUMMARY,
        $c2855a9ccb69df69$var$$.TABLE,
        $c2855a9ccb69df69$var$$.TBODY,
        $c2855a9ccb69df69$var$$.TD,
        $c2855a9ccb69df69$var$$.TEMPLATE,
        $c2855a9ccb69df69$var$$.TEXTAREA,
        $c2855a9ccb69df69$var$$.TFOOT,
        $c2855a9ccb69df69$var$$.TH,
        $c2855a9ccb69df69$var$$.THEAD,
        $c2855a9ccb69df69$var$$.TITLE,
        $c2855a9ccb69df69$var$$.TR,
        $c2855a9ccb69df69$var$$.TRACK,
        $c2855a9ccb69df69$var$$.UL,
        $c2855a9ccb69df69$var$$.WBR,
        $c2855a9ccb69df69$var$$.XMP
    ]),
    [$c2855a9ccb69df69$export$fb4028874a74450.MATHML]: new Set([
        $c2855a9ccb69df69$var$$.MI,
        $c2855a9ccb69df69$var$$.MO,
        $c2855a9ccb69df69$var$$.MN,
        $c2855a9ccb69df69$var$$.MS,
        $c2855a9ccb69df69$var$$.MTEXT,
        $c2855a9ccb69df69$var$$.ANNOTATION_XML
    ]),
    [$c2855a9ccb69df69$export$fb4028874a74450.SVG]: new Set([
        $c2855a9ccb69df69$var$$.TITLE,
        $c2855a9ccb69df69$var$$.FOREIGN_OBJECT,
        $c2855a9ccb69df69$var$$.DESC
    ]),
    [$c2855a9ccb69df69$export$fb4028874a74450.XLINK]: new Set(),
    [$c2855a9ccb69df69$export$fb4028874a74450.XML]: new Set(),
    [$c2855a9ccb69df69$export$fb4028874a74450.XMLNS]: new Set()
};
const $c2855a9ccb69df69$export$1ecc20fa0754c045 = new Set([
    $c2855a9ccb69df69$var$$.H1,
    $c2855a9ccb69df69$var$$.H2,
    $c2855a9ccb69df69$var$$.H3,
    $c2855a9ccb69df69$var$$.H4,
    $c2855a9ccb69df69$var$$.H5,
    $c2855a9ccb69df69$var$$.H6
]);
const $c2855a9ccb69df69$var$UNESCAPED_TEXT = new Set([
    $c2855a9ccb69df69$export$7e674a85a2656dce.STYLE,
    $c2855a9ccb69df69$export$7e674a85a2656dce.SCRIPT,
    $c2855a9ccb69df69$export$7e674a85a2656dce.XMP,
    $c2855a9ccb69df69$export$7e674a85a2656dce.IFRAME,
    $c2855a9ccb69df69$export$7e674a85a2656dce.NOEMBED,
    $c2855a9ccb69df69$export$7e674a85a2656dce.NOFRAMES,
    $c2855a9ccb69df69$export$7e674a85a2656dce.PLAINTEXT
]);
function $c2855a9ccb69df69$export$4ce4f8c09f921aed(tn, scriptingEnabled) {
    return $c2855a9ccb69df69$var$UNESCAPED_TEXT.has(tn) || scriptingEnabled && tn === $c2855a9ccb69df69$export$7e674a85a2656dce.NOSCRIPT;
}


//States
var $c44790542489a2a8$var$State;
(function(State) {
    State[State["DATA"] = 0] = "DATA";
    State[State["RCDATA"] = 1] = "RCDATA";
    State[State["RAWTEXT"] = 2] = "RAWTEXT";
    State[State["SCRIPT_DATA"] = 3] = "SCRIPT_DATA";
    State[State["PLAINTEXT"] = 4] = "PLAINTEXT";
    State[State["TAG_OPEN"] = 5] = "TAG_OPEN";
    State[State["END_TAG_OPEN"] = 6] = "END_TAG_OPEN";
    State[State["TAG_NAME"] = 7] = "TAG_NAME";
    State[State["RCDATA_LESS_THAN_SIGN"] = 8] = "RCDATA_LESS_THAN_SIGN";
    State[State["RCDATA_END_TAG_OPEN"] = 9] = "RCDATA_END_TAG_OPEN";
    State[State["RCDATA_END_TAG_NAME"] = 10] = "RCDATA_END_TAG_NAME";
    State[State["RAWTEXT_LESS_THAN_SIGN"] = 11] = "RAWTEXT_LESS_THAN_SIGN";
    State[State["RAWTEXT_END_TAG_OPEN"] = 12] = "RAWTEXT_END_TAG_OPEN";
    State[State["RAWTEXT_END_TAG_NAME"] = 13] = "RAWTEXT_END_TAG_NAME";
    State[State["SCRIPT_DATA_LESS_THAN_SIGN"] = 14] = "SCRIPT_DATA_LESS_THAN_SIGN";
    State[State["SCRIPT_DATA_END_TAG_OPEN"] = 15] = "SCRIPT_DATA_END_TAG_OPEN";
    State[State["SCRIPT_DATA_END_TAG_NAME"] = 16] = "SCRIPT_DATA_END_TAG_NAME";
    State[State["SCRIPT_DATA_ESCAPE_START"] = 17] = "SCRIPT_DATA_ESCAPE_START";
    State[State["SCRIPT_DATA_ESCAPE_START_DASH"] = 18] = "SCRIPT_DATA_ESCAPE_START_DASH";
    State[State["SCRIPT_DATA_ESCAPED"] = 19] = "SCRIPT_DATA_ESCAPED";
    State[State["SCRIPT_DATA_ESCAPED_DASH"] = 20] = "SCRIPT_DATA_ESCAPED_DASH";
    State[State["SCRIPT_DATA_ESCAPED_DASH_DASH"] = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH";
    State[State["SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN"] = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN";
    State[State["SCRIPT_DATA_ESCAPED_END_TAG_OPEN"] = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN";
    State[State["SCRIPT_DATA_ESCAPED_END_TAG_NAME"] = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPE_START"] = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPED"] = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPED_DASH"] = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH"] = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN"] = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPE_END"] = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END";
    State[State["BEFORE_ATTRIBUTE_NAME"] = 31] = "BEFORE_ATTRIBUTE_NAME";
    State[State["ATTRIBUTE_NAME"] = 32] = "ATTRIBUTE_NAME";
    State[State["AFTER_ATTRIBUTE_NAME"] = 33] = "AFTER_ATTRIBUTE_NAME";
    State[State["BEFORE_ATTRIBUTE_VALUE"] = 34] = "BEFORE_ATTRIBUTE_VALUE";
    State[State["ATTRIBUTE_VALUE_DOUBLE_QUOTED"] = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED";
    State[State["ATTRIBUTE_VALUE_SINGLE_QUOTED"] = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED";
    State[State["ATTRIBUTE_VALUE_UNQUOTED"] = 37] = "ATTRIBUTE_VALUE_UNQUOTED";
    State[State["AFTER_ATTRIBUTE_VALUE_QUOTED"] = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED";
    State[State["SELF_CLOSING_START_TAG"] = 39] = "SELF_CLOSING_START_TAG";
    State[State["BOGUS_COMMENT"] = 40] = "BOGUS_COMMENT";
    State[State["MARKUP_DECLARATION_OPEN"] = 41] = "MARKUP_DECLARATION_OPEN";
    State[State["COMMENT_START"] = 42] = "COMMENT_START";
    State[State["COMMENT_START_DASH"] = 43] = "COMMENT_START_DASH";
    State[State["COMMENT"] = 44] = "COMMENT";
    State[State["COMMENT_LESS_THAN_SIGN"] = 45] = "COMMENT_LESS_THAN_SIGN";
    State[State["COMMENT_LESS_THAN_SIGN_BANG"] = 46] = "COMMENT_LESS_THAN_SIGN_BANG";
    State[State["COMMENT_LESS_THAN_SIGN_BANG_DASH"] = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH";
    State[State["COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH"] = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH";
    State[State["COMMENT_END_DASH"] = 49] = "COMMENT_END_DASH";
    State[State["COMMENT_END"] = 50] = "COMMENT_END";
    State[State["COMMENT_END_BANG"] = 51] = "COMMENT_END_BANG";
    State[State["DOCTYPE"] = 52] = "DOCTYPE";
    State[State["BEFORE_DOCTYPE_NAME"] = 53] = "BEFORE_DOCTYPE_NAME";
    State[State["DOCTYPE_NAME"] = 54] = "DOCTYPE_NAME";
    State[State["AFTER_DOCTYPE_NAME"] = 55] = "AFTER_DOCTYPE_NAME";
    State[State["AFTER_DOCTYPE_PUBLIC_KEYWORD"] = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD";
    State[State["BEFORE_DOCTYPE_PUBLIC_IDENTIFIER"] = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER";
    State[State["DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED"] = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED";
    State[State["DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED"] = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED";
    State[State["AFTER_DOCTYPE_PUBLIC_IDENTIFIER"] = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER";
    State[State["BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS"] = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS";
    State[State["AFTER_DOCTYPE_SYSTEM_KEYWORD"] = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD";
    State[State["BEFORE_DOCTYPE_SYSTEM_IDENTIFIER"] = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER";
    State[State["DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED"] = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED";
    State[State["DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED"] = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED";
    State[State["AFTER_DOCTYPE_SYSTEM_IDENTIFIER"] = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER";
    State[State["BOGUS_DOCTYPE"] = 67] = "BOGUS_DOCTYPE";
    State[State["CDATA_SECTION"] = 68] = "CDATA_SECTION";
    State[State["CDATA_SECTION_BRACKET"] = 69] = "CDATA_SECTION_BRACKET";
    State[State["CDATA_SECTION_END"] = 70] = "CDATA_SECTION_END";
    State[State["CHARACTER_REFERENCE"] = 71] = "CHARACTER_REFERENCE";
    State[State["AMBIGUOUS_AMPERSAND"] = 72] = "AMBIGUOUS_AMPERSAND";
})($c44790542489a2a8$var$State || ($c44790542489a2a8$var$State = {}));
const $c44790542489a2a8$export$d0c9fb8d2ebe5159 = {
    DATA: $c44790542489a2a8$var$State.DATA,
    RCDATA: $c44790542489a2a8$var$State.RCDATA,
    RAWTEXT: $c44790542489a2a8$var$State.RAWTEXT,
    SCRIPT_DATA: $c44790542489a2a8$var$State.SCRIPT_DATA,
    PLAINTEXT: $c44790542489a2a8$var$State.PLAINTEXT,
    CDATA_SECTION: $c44790542489a2a8$var$State.CDATA_SECTION
};
//Utils
//OPTIMIZATION: these utility functions should not be moved out of this module. V8 Crankshaft will not inline
//this functions if they will be situated in another module due to context switch.
//Always perform inlining check before modifying this functions ('node --trace-inlining').
function $c44790542489a2a8$var$isAsciiDigit(cp) {
    return cp >= (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).DIGIT_0 && cp <= (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).DIGIT_9;
}
function $c44790542489a2a8$var$isAsciiUpper(cp) {
    return cp >= (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LATIN_CAPITAL_A && cp <= (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LATIN_CAPITAL_Z;
}
function $c44790542489a2a8$var$isAsciiLower(cp) {
    return cp >= (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LATIN_SMALL_A && cp <= (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LATIN_SMALL_Z;
}
function $c44790542489a2a8$var$isAsciiLetter(cp) {
    return $c44790542489a2a8$var$isAsciiLower(cp) || $c44790542489a2a8$var$isAsciiUpper(cp);
}
function $c44790542489a2a8$var$isAsciiAlphaNumeric(cp) {
    return $c44790542489a2a8$var$isAsciiLetter(cp) || $c44790542489a2a8$var$isAsciiDigit(cp);
}
function $c44790542489a2a8$var$toAsciiLower(cp) {
    return cp + 32;
}
function $c44790542489a2a8$var$isWhitespace(cp) {
    return cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE || cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED || cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION || cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED;
}
function $c44790542489a2a8$var$isScriptDataDoubleEscapeSequenceEnd(cp) {
    return $c44790542489a2a8$var$isWhitespace(cp) || cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SOLIDUS || cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN;
}
function $c44790542489a2a8$var$getErrorForNumericCharacterReference(code) {
    if (code === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL) return (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).nullCharacterReference;
    else if (code > 1114111) return (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).characterReferenceOutsideUnicodeRange;
    else if ((0, $bb1347fda1174ed8$export$7e678b42035e707f)(code)) return (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).surrogateCharacterReference;
    else if ((0, $bb1347fda1174ed8$export$b3484aaf321bda02)(code)) return (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).noncharacterCharacterReference;
    else if ((0, $bb1347fda1174ed8$export$d6953a6077926e)(code) || code === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).CARRIAGE_RETURN) return (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).controlCharacterReference;
    return null;
}
class $c44790542489a2a8$export$55e8b082af4aa63e {
    constructor(options, handler){
        this.options = options;
        this.handler = handler;
        this.paused = false;
        /** Ensures that the parsing loop isn't run multiple times at once. */ this.inLoop = false;
        /**
         * Indicates that the current adjusted node exists, is not an element in the HTML namespace,
         * and that it is not an integration point for either MathML or HTML.
         *
         * @see {@link https://html.spec.whatwg.org/multipage/parsing.html#tree-construction}
         */ this.inForeignNode = false;
        this.lastStartTagName = '';
        this.active = false;
        this.state = $c44790542489a2a8$var$State.DATA;
        this.returnState = $c44790542489a2a8$var$State.DATA;
        this.entityStartPos = 0;
        this.consumedAfterSnapshot = -1;
        this.currentCharacterToken = null;
        this.currentToken = null;
        this.currentAttr = {
            name: '',
            value: ''
        };
        this.preprocessor = new (0, $5940cf2ccae8becf$export$35db5c8036a15ad1)(handler);
        this.currentLocation = this.getCurrentLocation(-1);
        this.entityDecoder = new (0, $b715bb39f665675e$export$15263a93ff7ec8ba)((0, $8bb06a4e9c5f6236$export$b6a4accd5ee85f69), (cp, consumed)=>{
            // Note: Set `pos` _before_ flushing, as flushing might drop
            // the current chunk and invalidate `entityStartPos`.
            this.preprocessor.pos = this.entityStartPos + consumed - 1;
            this._flushCodePointConsumedAsCharacterReference(cp);
        }, handler.onParseError ? {
            missingSemicolonAfterCharacterReference: ()=>{
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingSemicolonAfterCharacterReference, 1);
            },
            absenceOfDigitsInNumericCharacterReference: (consumed)=>{
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).absenceOfDigitsInNumericCharacterReference, this.entityStartPos - this.preprocessor.pos + consumed);
            },
            validateNumericCharacterReference: (code)=>{
                const error = $c44790542489a2a8$var$getErrorForNumericCharacterReference(code);
                if (error) this._err(error, 1);
            }
        } : undefined);
    }
    //Errors
    _err(code, cpOffset = 0) {
        var _a, _b;
        (_b = (_a = this.handler).onParseError) === null || _b === void 0 || _b.call(_a, this.preprocessor.getError(code, cpOffset));
    }
    // NOTE: `offset` may never run across line boundaries.
    getCurrentLocation(offset) {
        if (!this.options.sourceCodeLocationInfo) return null;
        return {
            startLine: this.preprocessor.line,
            startCol: this.preprocessor.col - offset,
            startOffset: this.preprocessor.offset - offset,
            endLine: -1,
            endCol: -1,
            endOffset: -1
        };
    }
    _runParsingLoop() {
        if (this.inLoop) return;
        this.inLoop = true;
        while(this.active && !this.paused){
            this.consumedAfterSnapshot = 0;
            const cp = this._consume();
            if (!this._ensureHibernation()) this._callState(cp);
        }
        this.inLoop = false;
    }
    //API
    pause() {
        this.paused = true;
    }
    resume(writeCallback) {
        if (!this.paused) throw new Error('Parser was already resumed');
        this.paused = false;
        // Necessary for synchronous resume.
        if (this.inLoop) return;
        this._runParsingLoop();
        if (!this.paused) writeCallback === null || writeCallback === void 0 || writeCallback();
    }
    write(chunk, isLastChunk, writeCallback) {
        this.active = true;
        this.preprocessor.write(chunk, isLastChunk);
        this._runParsingLoop();
        if (!this.paused) writeCallback === null || writeCallback === void 0 || writeCallback();
    }
    insertHtmlAtCurrentPos(chunk) {
        this.active = true;
        this.preprocessor.insertHtmlAtCurrentPos(chunk);
        this._runParsingLoop();
    }
    //Hibernation
    _ensureHibernation() {
        if (this.preprocessor.endOfChunkHit) {
            this.preprocessor.retreat(this.consumedAfterSnapshot);
            this.consumedAfterSnapshot = 0;
            this.active = false;
            return true;
        }
        return false;
    }
    //Consumption
    _consume() {
        this.consumedAfterSnapshot++;
        return this.preprocessor.advance();
    }
    _advanceBy(count) {
        this.consumedAfterSnapshot += count;
        for(let i = 0; i < count; i++)this.preprocessor.advance();
    }
    _consumeSequenceIfMatch(pattern, caseSensitive) {
        if (this.preprocessor.startsWith(pattern, caseSensitive)) {
            // We will already have consumed one character before calling this method.
            this._advanceBy(pattern.length - 1);
            return true;
        }
        return false;
    }
    //Token creation
    _createStartTagToken() {
        this.currentToken = {
            type: (0, $be390ad8d330a451$export$f435f793048e7a0f).START_TAG,
            tagName: '',
            tagID: (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).UNKNOWN,
            selfClosing: false,
            ackSelfClosing: false,
            attrs: [],
            location: this.getCurrentLocation(1)
        };
    }
    _createEndTagToken() {
        this.currentToken = {
            type: (0, $be390ad8d330a451$export$f435f793048e7a0f).END_TAG,
            tagName: '',
            tagID: (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).UNKNOWN,
            selfClosing: false,
            ackSelfClosing: false,
            attrs: [],
            location: this.getCurrentLocation(2)
        };
    }
    _createCommentToken(offset) {
        this.currentToken = {
            type: (0, $be390ad8d330a451$export$f435f793048e7a0f).COMMENT,
            data: '',
            location: this.getCurrentLocation(offset)
        };
    }
    _createDoctypeToken(initialName) {
        this.currentToken = {
            type: (0, $be390ad8d330a451$export$f435f793048e7a0f).DOCTYPE,
            name: initialName,
            forceQuirks: false,
            publicId: null,
            systemId: null,
            location: this.currentLocation
        };
    }
    _createCharacterToken(type, chars) {
        this.currentCharacterToken = {
            type: type,
            chars: chars,
            location: this.currentLocation
        };
    }
    //Tag attributes
    _createAttr(attrNameFirstCh) {
        this.currentAttr = {
            name: attrNameFirstCh,
            value: ''
        };
        this.currentLocation = this.getCurrentLocation(0);
    }
    _leaveAttrName() {
        var _a;
        var _b;
        const token = this.currentToken;
        if ((0, $be390ad8d330a451$export$df33bba014b5841e)(token, this.currentAttr.name) === null) {
            token.attrs.push(this.currentAttr);
            if (token.location && this.currentLocation) {
                const attrLocations = (_a = (_b = token.location).attrs) !== null && _a !== void 0 ? _a : _b.attrs = Object.create(null);
                attrLocations[this.currentAttr.name] = this.currentLocation;
                // Set end location
                this._leaveAttrValue();
            }
        } else this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).duplicateAttribute);
    }
    _leaveAttrValue() {
        if (this.currentLocation) {
            this.currentLocation.endLine = this.preprocessor.line;
            this.currentLocation.endCol = this.preprocessor.col;
            this.currentLocation.endOffset = this.preprocessor.offset;
        }
    }
    //Token emission
    prepareToken(ct) {
        this._emitCurrentCharacterToken(ct.location);
        this.currentToken = null;
        if (ct.location) {
            ct.location.endLine = this.preprocessor.line;
            ct.location.endCol = this.preprocessor.col + 1;
            ct.location.endOffset = this.preprocessor.offset + 1;
        }
        this.currentLocation = this.getCurrentLocation(-1);
    }
    emitCurrentTagToken() {
        const ct = this.currentToken;
        this.prepareToken(ct);
        ct.tagID = (0, $c2855a9ccb69df69$export$39db8a1315f68282)(ct.tagName);
        if (ct.type === (0, $be390ad8d330a451$export$f435f793048e7a0f).START_TAG) {
            this.lastStartTagName = ct.tagName;
            this.handler.onStartTag(ct);
        } else {
            if (ct.attrs.length > 0) this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).endTagWithAttributes);
            if (ct.selfClosing) this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).endTagWithTrailingSolidus);
            this.handler.onEndTag(ct);
        }
        this.preprocessor.dropParsedChunk();
    }
    emitCurrentComment(ct) {
        this.prepareToken(ct);
        this.handler.onComment(ct);
        this.preprocessor.dropParsedChunk();
    }
    emitCurrentDoctype(ct) {
        this.prepareToken(ct);
        this.handler.onDoctype(ct);
        this.preprocessor.dropParsedChunk();
    }
    _emitCurrentCharacterToken(nextLocation) {
        if (this.currentCharacterToken) {
            //NOTE: if we have a pending character token, make it's end location equal to the
            //current token's start location.
            if (nextLocation && this.currentCharacterToken.location) {
                this.currentCharacterToken.location.endLine = nextLocation.startLine;
                this.currentCharacterToken.location.endCol = nextLocation.startCol;
                this.currentCharacterToken.location.endOffset = nextLocation.startOffset;
            }
            switch(this.currentCharacterToken.type){
                case (0, $be390ad8d330a451$export$f435f793048e7a0f).CHARACTER:
                    this.handler.onCharacter(this.currentCharacterToken);
                    break;
                case (0, $be390ad8d330a451$export$f435f793048e7a0f).NULL_CHARACTER:
                    this.handler.onNullCharacter(this.currentCharacterToken);
                    break;
                case (0, $be390ad8d330a451$export$f435f793048e7a0f).WHITESPACE_CHARACTER:
                    this.handler.onWhitespaceCharacter(this.currentCharacterToken);
                    break;
            }
            this.currentCharacterToken = null;
        }
    }
    _emitEOFToken() {
        const location = this.getCurrentLocation(0);
        if (location) {
            location.endLine = location.startLine;
            location.endCol = location.startCol;
            location.endOffset = location.startOffset;
        }
        this._emitCurrentCharacterToken(location);
        this.handler.onEof({
            type: (0, $be390ad8d330a451$export$f435f793048e7a0f).EOF,
            location: location
        });
        this.active = false;
    }
    //Characters emission
    //OPTIMIZATION: The specification uses only one type of character token (one token per character).
    //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
    //If we have a sequence of characters that belong to the same group, the parser can process it
    //as a single solid character token.
    //So, there are 3 types of character tokens in parse5:
    //1)TokenType.NULL_CHARACTER - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
    //2)TokenType.WHITESPACE_CHARACTER - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
    //3)TokenType.CHARACTER - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
    _appendCharToCurrentCharacterToken(type, ch) {
        if (this.currentCharacterToken) {
            if (this.currentCharacterToken.type === type) {
                this.currentCharacterToken.chars += ch;
                return;
            } else {
                this.currentLocation = this.getCurrentLocation(0);
                this._emitCurrentCharacterToken(this.currentLocation);
                this.preprocessor.dropParsedChunk();
            }
        }
        this._createCharacterToken(type, ch);
    }
    _emitCodePoint(cp) {
        const type = $c44790542489a2a8$var$isWhitespace(cp) ? (0, $be390ad8d330a451$export$f435f793048e7a0f).WHITESPACE_CHARACTER : cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL ? (0, $be390ad8d330a451$export$f435f793048e7a0f).NULL_CHARACTER : (0, $be390ad8d330a451$export$f435f793048e7a0f).CHARACTER;
        this._appendCharToCurrentCharacterToken(type, String.fromCodePoint(cp));
    }
    //NOTE: used when we emit characters explicitly.
    //This is always for non-whitespace and non-null characters, which allows us to avoid additional checks.
    _emitChars(ch) {
        this._appendCharToCurrentCharacterToken((0, $be390ad8d330a451$export$f435f793048e7a0f).CHARACTER, ch);
    }
    // Character reference helpers
    _startCharacterReference() {
        this.returnState = this.state;
        this.state = $c44790542489a2a8$var$State.CHARACTER_REFERENCE;
        this.entityStartPos = this.preprocessor.pos;
        this.entityDecoder.startEntity(this._isCharacterReferenceInAttribute() ? (0, $b715bb39f665675e$export$8c8f129ce60f53c).Attribute : (0, $b715bb39f665675e$export$8c8f129ce60f53c).Legacy);
    }
    _isCharacterReferenceInAttribute() {
        return this.returnState === $c44790542489a2a8$var$State.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === $c44790542489a2a8$var$State.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === $c44790542489a2a8$var$State.ATTRIBUTE_VALUE_UNQUOTED;
    }
    _flushCodePointConsumedAsCharacterReference(cp) {
        if (this._isCharacterReferenceInAttribute()) this.currentAttr.value += String.fromCodePoint(cp);
        else this._emitCodePoint(cp);
    }
    // Calling states this way turns out to be much faster than any other approach.
    _callState(cp) {
        switch(this.state){
            case $c44790542489a2a8$var$State.DATA:
                this._stateData(cp);
                break;
            case $c44790542489a2a8$var$State.RCDATA:
                this._stateRcdata(cp);
                break;
            case $c44790542489a2a8$var$State.RAWTEXT:
                this._stateRawtext(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA:
                this._stateScriptData(cp);
                break;
            case $c44790542489a2a8$var$State.PLAINTEXT:
                this._statePlaintext(cp);
                break;
            case $c44790542489a2a8$var$State.TAG_OPEN:
                this._stateTagOpen(cp);
                break;
            case $c44790542489a2a8$var$State.END_TAG_OPEN:
                this._stateEndTagOpen(cp);
                break;
            case $c44790542489a2a8$var$State.TAG_NAME:
                this._stateTagName(cp);
                break;
            case $c44790542489a2a8$var$State.RCDATA_LESS_THAN_SIGN:
                this._stateRcdataLessThanSign(cp);
                break;
            case $c44790542489a2a8$var$State.RCDATA_END_TAG_OPEN:
                this._stateRcdataEndTagOpen(cp);
                break;
            case $c44790542489a2a8$var$State.RCDATA_END_TAG_NAME:
                this._stateRcdataEndTagName(cp);
                break;
            case $c44790542489a2a8$var$State.RAWTEXT_LESS_THAN_SIGN:
                this._stateRawtextLessThanSign(cp);
                break;
            case $c44790542489a2a8$var$State.RAWTEXT_END_TAG_OPEN:
                this._stateRawtextEndTagOpen(cp);
                break;
            case $c44790542489a2a8$var$State.RAWTEXT_END_TAG_NAME:
                this._stateRawtextEndTagName(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_LESS_THAN_SIGN:
                this._stateScriptDataLessThanSign(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_END_TAG_OPEN:
                this._stateScriptDataEndTagOpen(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_END_TAG_NAME:
                this._stateScriptDataEndTagName(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPE_START:
                this._stateScriptDataEscapeStart(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPE_START_DASH:
                this._stateScriptDataEscapeStartDash(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED:
                this._stateScriptDataEscaped(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED_DASH:
                this._stateScriptDataEscapedDash(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED_DASH_DASH:
                this._stateScriptDataEscapedDashDash(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN:
                this._stateScriptDataEscapedLessThanSign(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED_END_TAG_OPEN:
                this._stateScriptDataEscapedEndTagOpen(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED_END_TAG_NAME:
                this._stateScriptDataEscapedEndTagName(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPE_START:
                this._stateScriptDataDoubleEscapeStart(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED:
                this._stateScriptDataDoubleEscaped(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH:
                this._stateScriptDataDoubleEscapedDash(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH:
                this._stateScriptDataDoubleEscapedDashDash(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN:
                this._stateScriptDataDoubleEscapedLessThanSign(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPE_END:
                this._stateScriptDataDoubleEscapeEnd(cp);
                break;
            case $c44790542489a2a8$var$State.BEFORE_ATTRIBUTE_NAME:
                this._stateBeforeAttributeName(cp);
                break;
            case $c44790542489a2a8$var$State.ATTRIBUTE_NAME:
                this._stateAttributeName(cp);
                break;
            case $c44790542489a2a8$var$State.AFTER_ATTRIBUTE_NAME:
                this._stateAfterAttributeName(cp);
                break;
            case $c44790542489a2a8$var$State.BEFORE_ATTRIBUTE_VALUE:
                this._stateBeforeAttributeValue(cp);
                break;
            case $c44790542489a2a8$var$State.ATTRIBUTE_VALUE_DOUBLE_QUOTED:
                this._stateAttributeValueDoubleQuoted(cp);
                break;
            case $c44790542489a2a8$var$State.ATTRIBUTE_VALUE_SINGLE_QUOTED:
                this._stateAttributeValueSingleQuoted(cp);
                break;
            case $c44790542489a2a8$var$State.ATTRIBUTE_VALUE_UNQUOTED:
                this._stateAttributeValueUnquoted(cp);
                break;
            case $c44790542489a2a8$var$State.AFTER_ATTRIBUTE_VALUE_QUOTED:
                this._stateAfterAttributeValueQuoted(cp);
                break;
            case $c44790542489a2a8$var$State.SELF_CLOSING_START_TAG:
                this._stateSelfClosingStartTag(cp);
                break;
            case $c44790542489a2a8$var$State.BOGUS_COMMENT:
                this._stateBogusComment(cp);
                break;
            case $c44790542489a2a8$var$State.MARKUP_DECLARATION_OPEN:
                this._stateMarkupDeclarationOpen(cp);
                break;
            case $c44790542489a2a8$var$State.COMMENT_START:
                this._stateCommentStart(cp);
                break;
            case $c44790542489a2a8$var$State.COMMENT_START_DASH:
                this._stateCommentStartDash(cp);
                break;
            case $c44790542489a2a8$var$State.COMMENT:
                this._stateComment(cp);
                break;
            case $c44790542489a2a8$var$State.COMMENT_LESS_THAN_SIGN:
                this._stateCommentLessThanSign(cp);
                break;
            case $c44790542489a2a8$var$State.COMMENT_LESS_THAN_SIGN_BANG:
                this._stateCommentLessThanSignBang(cp);
                break;
            case $c44790542489a2a8$var$State.COMMENT_LESS_THAN_SIGN_BANG_DASH:
                this._stateCommentLessThanSignBangDash(cp);
                break;
            case $c44790542489a2a8$var$State.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH:
                this._stateCommentLessThanSignBangDashDash(cp);
                break;
            case $c44790542489a2a8$var$State.COMMENT_END_DASH:
                this._stateCommentEndDash(cp);
                break;
            case $c44790542489a2a8$var$State.COMMENT_END:
                this._stateCommentEnd(cp);
                break;
            case $c44790542489a2a8$var$State.COMMENT_END_BANG:
                this._stateCommentEndBang(cp);
                break;
            case $c44790542489a2a8$var$State.DOCTYPE:
                this._stateDoctype(cp);
                break;
            case $c44790542489a2a8$var$State.BEFORE_DOCTYPE_NAME:
                this._stateBeforeDoctypeName(cp);
                break;
            case $c44790542489a2a8$var$State.DOCTYPE_NAME:
                this._stateDoctypeName(cp);
                break;
            case $c44790542489a2a8$var$State.AFTER_DOCTYPE_NAME:
                this._stateAfterDoctypeName(cp);
                break;
            case $c44790542489a2a8$var$State.AFTER_DOCTYPE_PUBLIC_KEYWORD:
                this._stateAfterDoctypePublicKeyword(cp);
                break;
            case $c44790542489a2a8$var$State.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER:
                this._stateBeforeDoctypePublicIdentifier(cp);
                break;
            case $c44790542489a2a8$var$State.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED:
                this._stateDoctypePublicIdentifierDoubleQuoted(cp);
                break;
            case $c44790542489a2a8$var$State.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED:
                this._stateDoctypePublicIdentifierSingleQuoted(cp);
                break;
            case $c44790542489a2a8$var$State.AFTER_DOCTYPE_PUBLIC_IDENTIFIER:
                this._stateAfterDoctypePublicIdentifier(cp);
                break;
            case $c44790542489a2a8$var$State.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS:
                this._stateBetweenDoctypePublicAndSystemIdentifiers(cp);
                break;
            case $c44790542489a2a8$var$State.AFTER_DOCTYPE_SYSTEM_KEYWORD:
                this._stateAfterDoctypeSystemKeyword(cp);
                break;
            case $c44790542489a2a8$var$State.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER:
                this._stateBeforeDoctypeSystemIdentifier(cp);
                break;
            case $c44790542489a2a8$var$State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED:
                this._stateDoctypeSystemIdentifierDoubleQuoted(cp);
                break;
            case $c44790542489a2a8$var$State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED:
                this._stateDoctypeSystemIdentifierSingleQuoted(cp);
                break;
            case $c44790542489a2a8$var$State.AFTER_DOCTYPE_SYSTEM_IDENTIFIER:
                this._stateAfterDoctypeSystemIdentifier(cp);
                break;
            case $c44790542489a2a8$var$State.BOGUS_DOCTYPE:
                this._stateBogusDoctype(cp);
                break;
            case $c44790542489a2a8$var$State.CDATA_SECTION:
                this._stateCdataSection(cp);
                break;
            case $c44790542489a2a8$var$State.CDATA_SECTION_BRACKET:
                this._stateCdataSectionBracket(cp);
                break;
            case $c44790542489a2a8$var$State.CDATA_SECTION_END:
                this._stateCdataSectionEnd(cp);
                break;
            case $c44790542489a2a8$var$State.CHARACTER_REFERENCE:
                this._stateCharacterReference();
                break;
            case $c44790542489a2a8$var$State.AMBIGUOUS_AMPERSAND:
                this._stateAmbiguousAmpersand(cp);
                break;
            default:
                throw new Error('Unknown state');
        }
    }
    // State machine
    // Data state
    //------------------------------------------------------------------
    _stateData(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.TAG_OPEN;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).AMPERSAND:
                this._startCharacterReference();
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitCodePoint(cp);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    //  RCDATA state
    //------------------------------------------------------------------
    _stateRcdata(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).AMPERSAND:
                this._startCharacterReference();
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.RCDATA_LESS_THAN_SIGN;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitChars((0, $bb1347fda1174ed8$export$e8d20e7a50e6c279));
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // RAWTEXT state
    //------------------------------------------------------------------
    _stateRawtext(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.RAWTEXT_LESS_THAN_SIGN;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitChars((0, $bb1347fda1174ed8$export$e8d20e7a50e6c279));
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // Script data state
    //------------------------------------------------------------------
    _stateScriptData(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_LESS_THAN_SIGN;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitChars((0, $bb1347fda1174ed8$export$e8d20e7a50e6c279));
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // PLAINTEXT state
    //------------------------------------------------------------------
    _statePlaintext(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitChars((0, $bb1347fda1174ed8$export$e8d20e7a50e6c279));
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // Tag open state
    //------------------------------------------------------------------
    _stateTagOpen(cp) {
        if ($c44790542489a2a8$var$isAsciiLetter(cp)) {
            this._createStartTagToken();
            this.state = $c44790542489a2a8$var$State.TAG_NAME;
            this._stateTagName(cp);
        } else switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EXCLAMATION_MARK:
                this.state = $c44790542489a2a8$var$State.MARKUP_DECLARATION_OPEN;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SOLIDUS:
                this.state = $c44790542489a2a8$var$State.END_TAG_OPEN;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).QUESTION_MARK:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedQuestionMarkInsteadOfTagName);
                this._createCommentToken(1);
                this.state = $c44790542489a2a8$var$State.BOGUS_COMMENT;
                this._stateBogusComment(cp);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofBeforeTagName);
                this._emitChars('<');
                this._emitEOFToken();
                break;
            default:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).invalidFirstCharacterOfTagName);
                this._emitChars('<');
                this.state = $c44790542489a2a8$var$State.DATA;
                this._stateData(cp);
        }
    }
    // End tag open state
    //------------------------------------------------------------------
    _stateEndTagOpen(cp) {
        if ($c44790542489a2a8$var$isAsciiLetter(cp)) {
            this._createEndTagToken();
            this.state = $c44790542489a2a8$var$State.TAG_NAME;
            this._stateTagName(cp);
        } else switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingEndTagName);
                this.state = $c44790542489a2a8$var$State.DATA;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofBeforeTagName);
                this._emitChars('</');
                this._emitEOFToken();
                break;
            default:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).invalidFirstCharacterOfTagName);
                this._createCommentToken(2);
                this.state = $c44790542489a2a8$var$State.BOGUS_COMMENT;
                this._stateBogusComment(cp);
        }
    }
    // Tag name state
    //------------------------------------------------------------------
    _stateTagName(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this.state = $c44790542489a2a8$var$State.BEFORE_ATTRIBUTE_NAME;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SOLIDUS:
                this.state = $c44790542489a2a8$var$State.SELF_CLOSING_START_TAG;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentTagToken();
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.tagName += (0, $bb1347fda1174ed8$export$e8d20e7a50e6c279);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                token.tagName += String.fromCodePoint($c44790542489a2a8$var$isAsciiUpper(cp) ? $c44790542489a2a8$var$toAsciiLower(cp) : cp);
        }
    }
    // RCDATA less-than sign state
    //------------------------------------------------------------------
    _stateRcdataLessThanSign(cp) {
        if (cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SOLIDUS) this.state = $c44790542489a2a8$var$State.RCDATA_END_TAG_OPEN;
        else {
            this._emitChars('<');
            this.state = $c44790542489a2a8$var$State.RCDATA;
            this._stateRcdata(cp);
        }
    }
    // RCDATA end tag open state
    //------------------------------------------------------------------
    _stateRcdataEndTagOpen(cp) {
        if ($c44790542489a2a8$var$isAsciiLetter(cp)) {
            this.state = $c44790542489a2a8$var$State.RCDATA_END_TAG_NAME;
            this._stateRcdataEndTagName(cp);
        } else {
            this._emitChars('</');
            this.state = $c44790542489a2a8$var$State.RCDATA;
            this._stateRcdata(cp);
        }
    }
    handleSpecialEndTag(_cp) {
        if (!this.preprocessor.startsWith(this.lastStartTagName, false)) return !this._ensureHibernation();
        this._createEndTagToken();
        const token = this.currentToken;
        token.tagName = this.lastStartTagName;
        const cp = this.preprocessor.peek(this.lastStartTagName.length);
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this._advanceBy(this.lastStartTagName.length);
                this.state = $c44790542489a2a8$var$State.BEFORE_ATTRIBUTE_NAME;
                return false;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SOLIDUS:
                this._advanceBy(this.lastStartTagName.length);
                this.state = $c44790542489a2a8$var$State.SELF_CLOSING_START_TAG;
                return false;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._advanceBy(this.lastStartTagName.length);
                this.emitCurrentTagToken();
                this.state = $c44790542489a2a8$var$State.DATA;
                return false;
            default:
                return !this._ensureHibernation();
        }
    }
    // RCDATA end tag name state
    //------------------------------------------------------------------
    _stateRcdataEndTagName(cp) {
        if (this.handleSpecialEndTag(cp)) {
            this._emitChars('</');
            this.state = $c44790542489a2a8$var$State.RCDATA;
            this._stateRcdata(cp);
        }
    }
    // RAWTEXT less-than sign state
    //------------------------------------------------------------------
    _stateRawtextLessThanSign(cp) {
        if (cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SOLIDUS) this.state = $c44790542489a2a8$var$State.RAWTEXT_END_TAG_OPEN;
        else {
            this._emitChars('<');
            this.state = $c44790542489a2a8$var$State.RAWTEXT;
            this._stateRawtext(cp);
        }
    }
    // RAWTEXT end tag open state
    //------------------------------------------------------------------
    _stateRawtextEndTagOpen(cp) {
        if ($c44790542489a2a8$var$isAsciiLetter(cp)) {
            this.state = $c44790542489a2a8$var$State.RAWTEXT_END_TAG_NAME;
            this._stateRawtextEndTagName(cp);
        } else {
            this._emitChars('</');
            this.state = $c44790542489a2a8$var$State.RAWTEXT;
            this._stateRawtext(cp);
        }
    }
    // RAWTEXT end tag name state
    //------------------------------------------------------------------
    _stateRawtextEndTagName(cp) {
        if (this.handleSpecialEndTag(cp)) {
            this._emitChars('</');
            this.state = $c44790542489a2a8$var$State.RAWTEXT;
            this._stateRawtext(cp);
        }
    }
    // Script data less-than sign state
    //------------------------------------------------------------------
    _stateScriptDataLessThanSign(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SOLIDUS:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_END_TAG_OPEN;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EXCLAMATION_MARK:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPE_START;
                this._emitChars('<!');
                break;
            default:
                this._emitChars('<');
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA;
                this._stateScriptData(cp);
        }
    }
    // Script data end tag open state
    //------------------------------------------------------------------
    _stateScriptDataEndTagOpen(cp) {
        if ($c44790542489a2a8$var$isAsciiLetter(cp)) {
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_END_TAG_NAME;
            this._stateScriptDataEndTagName(cp);
        } else {
            this._emitChars('</');
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA;
            this._stateScriptData(cp);
        }
    }
    // Script data end tag name state
    //------------------------------------------------------------------
    _stateScriptDataEndTagName(cp) {
        if (this.handleSpecialEndTag(cp)) {
            this._emitChars('</');
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA;
            this._stateScriptData(cp);
        }
    }
    // Script data escape start state
    //------------------------------------------------------------------
    _stateScriptDataEscapeStart(cp) {
        if (cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS) {
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPE_START_DASH;
            this._emitChars('-');
        } else {
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA;
            this._stateScriptData(cp);
        }
    }
    // Script data escape start dash state
    //------------------------------------------------------------------
    _stateScriptDataEscapeStartDash(cp) {
        if (cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS) {
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED_DASH_DASH;
            this._emitChars('-');
        } else {
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA;
            this._stateScriptData(cp);
        }
    }
    // Script data escaped state
    //------------------------------------------------------------------
    _stateScriptDataEscaped(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED_DASH;
                this._emitChars('-');
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitChars((0, $bb1347fda1174ed8$export$e8d20e7a50e6c279));
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // Script data escaped dash state
    //------------------------------------------------------------------
    _stateScriptDataEscapedDash(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED_DASH_DASH;
                this._emitChars('-');
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED;
                this._emitChars((0, $bb1347fda1174ed8$export$e8d20e7a50e6c279));
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            default:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED;
                this._emitCodePoint(cp);
        }
    }
    // Script data escaped dash dash state
    //------------------------------------------------------------------
    _stateScriptDataEscapedDashDash(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this._emitChars('-');
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA;
                this._emitChars('>');
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED;
                this._emitChars((0, $bb1347fda1174ed8$export$e8d20e7a50e6c279));
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            default:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED;
                this._emitCodePoint(cp);
        }
    }
    // Script data escaped less-than sign state
    //------------------------------------------------------------------
    _stateScriptDataEscapedLessThanSign(cp) {
        if (cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SOLIDUS) this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED_END_TAG_OPEN;
        else if ($c44790542489a2a8$var$isAsciiLetter(cp)) {
            this._emitChars('<');
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPE_START;
            this._stateScriptDataDoubleEscapeStart(cp);
        } else {
            this._emitChars('<');
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED;
            this._stateScriptDataEscaped(cp);
        }
    }
    // Script data escaped end tag open state
    //------------------------------------------------------------------
    _stateScriptDataEscapedEndTagOpen(cp) {
        if ($c44790542489a2a8$var$isAsciiLetter(cp)) {
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED_END_TAG_NAME;
            this._stateScriptDataEscapedEndTagName(cp);
        } else {
            this._emitChars('</');
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED;
            this._stateScriptDataEscaped(cp);
        }
    }
    // Script data escaped end tag name state
    //------------------------------------------------------------------
    _stateScriptDataEscapedEndTagName(cp) {
        if (this.handleSpecialEndTag(cp)) {
            this._emitChars('</');
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED;
            this._stateScriptDataEscaped(cp);
        }
    }
    // Script data double escape start state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscapeStart(cp) {
        if (this.preprocessor.startsWith((0, $bb1347fda1174ed8$export$5abac700f947e2).SCRIPT, false) && $c44790542489a2a8$var$isScriptDataDoubleEscapeSequenceEnd(this.preprocessor.peek((0, $bb1347fda1174ed8$export$5abac700f947e2).SCRIPT.length))) {
            this._emitCodePoint(cp);
            for(let i = 0; i < (0, $bb1347fda1174ed8$export$5abac700f947e2).SCRIPT.length; i++)this._emitCodePoint(this._consume());
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
        } else if (!this._ensureHibernation()) {
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED;
            this._stateScriptDataEscaped(cp);
        }
    }
    // Script data double escaped state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscaped(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH;
                this._emitChars('-');
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN;
                this._emitChars('<');
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitChars((0, $bb1347fda1174ed8$export$e8d20e7a50e6c279));
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // Script data double escaped dash state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscapedDash(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH;
                this._emitChars('-');
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN;
                this._emitChars('<');
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
                this._emitChars((0, $bb1347fda1174ed8$export$e8d20e7a50e6c279));
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            default:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
                this._emitCodePoint(cp);
        }
    }
    // Script data double escaped dash dash state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscapedDashDash(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this._emitChars('-');
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN;
                this._emitChars('<');
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA;
                this._emitChars('>');
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
                this._emitChars((0, $bb1347fda1174ed8$export$e8d20e7a50e6c279));
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            default:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
                this._emitCodePoint(cp);
        }
    }
    // Script data double escaped less-than sign state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscapedLessThanSign(cp) {
        if (cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SOLIDUS) {
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPE_END;
            this._emitChars('/');
        } else {
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
            this._stateScriptDataDoubleEscaped(cp);
        }
    }
    // Script data double escape end state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscapeEnd(cp) {
        if (this.preprocessor.startsWith((0, $bb1347fda1174ed8$export$5abac700f947e2).SCRIPT, false) && $c44790542489a2a8$var$isScriptDataDoubleEscapeSequenceEnd(this.preprocessor.peek((0, $bb1347fda1174ed8$export$5abac700f947e2).SCRIPT.length))) {
            this._emitCodePoint(cp);
            for(let i = 0; i < (0, $bb1347fda1174ed8$export$5abac700f947e2).SCRIPT.length; i++)this._emitCodePoint(this._consume());
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED;
        } else if (!this._ensureHibernation()) {
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
            this._stateScriptDataDoubleEscaped(cp);
        }
    }
    // Before attribute name state
    //------------------------------------------------------------------
    _stateBeforeAttributeName(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SOLIDUS:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this.state = $c44790542489a2a8$var$State.AFTER_ATTRIBUTE_NAME;
                this._stateAfterAttributeName(cp);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EQUALS_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedEqualsSignBeforeAttributeName);
                this._createAttr('=');
                this.state = $c44790542489a2a8$var$State.ATTRIBUTE_NAME;
                break;
            default:
                this._createAttr('');
                this.state = $c44790542489a2a8$var$State.ATTRIBUTE_NAME;
                this._stateAttributeName(cp);
        }
    }
    // Attribute name state
    //------------------------------------------------------------------
    _stateAttributeName(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SOLIDUS:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._leaveAttrName();
                this.state = $c44790542489a2a8$var$State.AFTER_ATTRIBUTE_NAME;
                this._stateAfterAttributeName(cp);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EQUALS_SIGN:
                this._leaveAttrName();
                this.state = $c44790542489a2a8$var$State.BEFORE_ATTRIBUTE_VALUE;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).APOSTROPHE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedCharacterInAttributeName);
                this.currentAttr.name += String.fromCodePoint(cp);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.currentAttr.name += (0, $bb1347fda1174ed8$export$e8d20e7a50e6c279);
                break;
            default:
                this.currentAttr.name += String.fromCodePoint($c44790542489a2a8$var$isAsciiUpper(cp) ? $c44790542489a2a8$var$toAsciiLower(cp) : cp);
        }
    }
    // After attribute name state
    //------------------------------------------------------------------
    _stateAfterAttributeName(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SOLIDUS:
                this.state = $c44790542489a2a8$var$State.SELF_CLOSING_START_TAG;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EQUALS_SIGN:
                this.state = $c44790542489a2a8$var$State.BEFORE_ATTRIBUTE_VALUE;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentTagToken();
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                this._createAttr('');
                this.state = $c44790542489a2a8$var$State.ATTRIBUTE_NAME;
                this._stateAttributeName(cp);
        }
    }
    // Before attribute value state
    //------------------------------------------------------------------
    _stateBeforeAttributeValue(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this.state = $c44790542489a2a8$var$State.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this.state = $c44790542489a2a8$var$State.ATTRIBUTE_VALUE_SINGLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingAttributeValue);
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentTagToken();
                break;
            default:
                this.state = $c44790542489a2a8$var$State.ATTRIBUTE_VALUE_UNQUOTED;
                this._stateAttributeValueUnquoted(cp);
        }
    }
    // Attribute value (double-quoted) state
    //------------------------------------------------------------------
    _stateAttributeValueDoubleQuoted(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this.state = $c44790542489a2a8$var$State.AFTER_ATTRIBUTE_VALUE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).AMPERSAND:
                this._startCharacterReference();
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.currentAttr.value += (0, $bb1347fda1174ed8$export$e8d20e7a50e6c279);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                this.currentAttr.value += String.fromCodePoint(cp);
        }
    }
    // Attribute value (single-quoted) state
    //------------------------------------------------------------------
    _stateAttributeValueSingleQuoted(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this.state = $c44790542489a2a8$var$State.AFTER_ATTRIBUTE_VALUE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).AMPERSAND:
                this._startCharacterReference();
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.currentAttr.value += (0, $bb1347fda1174ed8$export$e8d20e7a50e6c279);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                this.currentAttr.value += String.fromCodePoint(cp);
        }
    }
    // Attribute value (unquoted) state
    //------------------------------------------------------------------
    _stateAttributeValueUnquoted(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this._leaveAttrValue();
                this.state = $c44790542489a2a8$var$State.BEFORE_ATTRIBUTE_NAME;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).AMPERSAND:
                this._startCharacterReference();
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._leaveAttrValue();
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentTagToken();
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.currentAttr.value += (0, $bb1347fda1174ed8$export$e8d20e7a50e6c279);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).APOSTROPHE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EQUALS_SIGN:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GRAVE_ACCENT:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedCharacterInUnquotedAttributeValue);
                this.currentAttr.value += String.fromCodePoint(cp);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                this.currentAttr.value += String.fromCodePoint(cp);
        }
    }
    // After attribute value (quoted) state
    //------------------------------------------------------------------
    _stateAfterAttributeValueQuoted(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this._leaveAttrValue();
                this.state = $c44790542489a2a8$var$State.BEFORE_ATTRIBUTE_NAME;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SOLIDUS:
                this._leaveAttrValue();
                this.state = $c44790542489a2a8$var$State.SELF_CLOSING_START_TAG;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._leaveAttrValue();
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentTagToken();
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingWhitespaceBetweenAttributes);
                this.state = $c44790542489a2a8$var$State.BEFORE_ATTRIBUTE_NAME;
                this._stateBeforeAttributeName(cp);
        }
    }
    // Self-closing start tag state
    //------------------------------------------------------------------
    _stateSelfClosingStartTag(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                {
                    const token = this.currentToken;
                    token.selfClosing = true;
                    this.state = $c44790542489a2a8$var$State.DATA;
                    this.emitCurrentTagToken();
                    break;
                }
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedSolidusInTag);
                this.state = $c44790542489a2a8$var$State.BEFORE_ATTRIBUTE_NAME;
                this._stateBeforeAttributeName(cp);
        }
    }
    // Bogus comment state
    //------------------------------------------------------------------
    _stateBogusComment(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentComment(token);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.data += (0, $bb1347fda1174ed8$export$e8d20e7a50e6c279);
                break;
            default:
                token.data += String.fromCodePoint(cp);
        }
    }
    // Markup declaration open state
    //------------------------------------------------------------------
    _stateMarkupDeclarationOpen(cp) {
        if (this._consumeSequenceIfMatch((0, $bb1347fda1174ed8$export$5abac700f947e2).DASH_DASH, true)) {
            this._createCommentToken((0, $bb1347fda1174ed8$export$5abac700f947e2).DASH_DASH.length + 1);
            this.state = $c44790542489a2a8$var$State.COMMENT_START;
        } else if (this._consumeSequenceIfMatch((0, $bb1347fda1174ed8$export$5abac700f947e2).DOCTYPE, false)) {
            // NOTE: Doctypes tokens are created without fixed offsets. We keep track of the moment a doctype *might* start here.
            this.currentLocation = this.getCurrentLocation((0, $bb1347fda1174ed8$export$5abac700f947e2).DOCTYPE.length + 1);
            this.state = $c44790542489a2a8$var$State.DOCTYPE;
        } else if (this._consumeSequenceIfMatch((0, $bb1347fda1174ed8$export$5abac700f947e2).CDATA_START, true)) {
            if (this.inForeignNode) this.state = $c44790542489a2a8$var$State.CDATA_SECTION;
            else {
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).cdataInHtmlContent);
                this._createCommentToken((0, $bb1347fda1174ed8$export$5abac700f947e2).CDATA_START.length + 1);
                this.currentToken.data = '[CDATA[';
                this.state = $c44790542489a2a8$var$State.BOGUS_COMMENT;
            }
        } else if (!this._ensureHibernation()) {
            this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).incorrectlyOpenedComment);
            this._createCommentToken(2);
            this.state = $c44790542489a2a8$var$State.BOGUS_COMMENT;
            this._stateBogusComment(cp);
        }
    }
    // Comment start state
    //------------------------------------------------------------------
    _stateCommentStart(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $c44790542489a2a8$var$State.COMMENT_START_DASH;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                {
                    this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).abruptClosingOfEmptyComment);
                    this.state = $c44790542489a2a8$var$State.DATA;
                    const token = this.currentToken;
                    this.emitCurrentComment(token);
                    break;
                }
            default:
                this.state = $c44790542489a2a8$var$State.COMMENT;
                this._stateComment(cp);
        }
    }
    // Comment start dash state
    //------------------------------------------------------------------
    _stateCommentStartDash(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $c44790542489a2a8$var$State.COMMENT_END;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).abruptClosingOfEmptyComment);
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentComment(token);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInComment);
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            default:
                token.data += '-';
                this.state = $c44790542489a2a8$var$State.COMMENT;
                this._stateComment(cp);
        }
    }
    // Comment state
    //------------------------------------------------------------------
    _stateComment(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $c44790542489a2a8$var$State.COMMENT_END_DASH;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                token.data += '<';
                this.state = $c44790542489a2a8$var$State.COMMENT_LESS_THAN_SIGN;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.data += (0, $bb1347fda1174ed8$export$e8d20e7a50e6c279);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInComment);
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            default:
                token.data += String.fromCodePoint(cp);
        }
    }
    // Comment less-than sign state
    //------------------------------------------------------------------
    _stateCommentLessThanSign(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EXCLAMATION_MARK:
                token.data += '!';
                this.state = $c44790542489a2a8$var$State.COMMENT_LESS_THAN_SIGN_BANG;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                token.data += '<';
                break;
            default:
                this.state = $c44790542489a2a8$var$State.COMMENT;
                this._stateComment(cp);
        }
    }
    // Comment less-than sign bang state
    //------------------------------------------------------------------
    _stateCommentLessThanSignBang(cp) {
        if (cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS) this.state = $c44790542489a2a8$var$State.COMMENT_LESS_THAN_SIGN_BANG_DASH;
        else {
            this.state = $c44790542489a2a8$var$State.COMMENT;
            this._stateComment(cp);
        }
    }
    // Comment less-than sign bang dash state
    //------------------------------------------------------------------
    _stateCommentLessThanSignBangDash(cp) {
        if (cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS) this.state = $c44790542489a2a8$var$State.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH;
        else {
            this.state = $c44790542489a2a8$var$State.COMMENT_END_DASH;
            this._stateCommentEndDash(cp);
        }
    }
    // Comment less-than sign bang dash dash state
    //------------------------------------------------------------------
    _stateCommentLessThanSignBangDashDash(cp) {
        if (cp !== (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN && cp !== (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF) this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).nestedComment);
        this.state = $c44790542489a2a8$var$State.COMMENT_END;
        this._stateCommentEnd(cp);
    }
    // Comment end dash state
    //------------------------------------------------------------------
    _stateCommentEndDash(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $c44790542489a2a8$var$State.COMMENT_END;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInComment);
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            default:
                token.data += '-';
                this.state = $c44790542489a2a8$var$State.COMMENT;
                this._stateComment(cp);
        }
    }
    // Comment end state
    //------------------------------------------------------------------
    _stateCommentEnd(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentComment(token);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EXCLAMATION_MARK:
                this.state = $c44790542489a2a8$var$State.COMMENT_END_BANG;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                token.data += '-';
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInComment);
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            default:
                token.data += '--';
                this.state = $c44790542489a2a8$var$State.COMMENT;
                this._stateComment(cp);
        }
    }
    // Comment end bang state
    //------------------------------------------------------------------
    _stateCommentEndBang(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                token.data += '--!';
                this.state = $c44790542489a2a8$var$State.COMMENT_END_DASH;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).incorrectlyClosedComment);
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentComment(token);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInComment);
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            default:
                token.data += '--!';
                this.state = $c44790542489a2a8$var$State.COMMENT;
                this._stateComment(cp);
        }
    }
    // DOCTYPE state
    //------------------------------------------------------------------
    _stateDoctype(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this.state = $c44790542489a2a8$var$State.BEFORE_DOCTYPE_NAME;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.BEFORE_DOCTYPE_NAME;
                this._stateBeforeDoctypeName(cp);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                {
                    this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                    this._createDoctypeToken(null);
                    const token = this.currentToken;
                    token.forceQuirks = true;
                    this.emitCurrentDoctype(token);
                    this._emitEOFToken();
                    break;
                }
            default:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingWhitespaceBeforeDoctypeName);
                this.state = $c44790542489a2a8$var$State.BEFORE_DOCTYPE_NAME;
                this._stateBeforeDoctypeName(cp);
        }
    }
    // Before DOCTYPE name state
    //------------------------------------------------------------------
    _stateBeforeDoctypeName(cp) {
        if ($c44790542489a2a8$var$isAsciiUpper(cp)) {
            this._createDoctypeToken(String.fromCharCode($c44790542489a2a8$var$toAsciiLower(cp)));
            this.state = $c44790542489a2a8$var$State.DOCTYPE_NAME;
        } else switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._createDoctypeToken((0, $bb1347fda1174ed8$export$e8d20e7a50e6c279));
                this.state = $c44790542489a2a8$var$State.DOCTYPE_NAME;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                {
                    this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingDoctypeName);
                    this._createDoctypeToken(null);
                    const token = this.currentToken;
                    token.forceQuirks = true;
                    this.emitCurrentDoctype(token);
                    this.state = $c44790542489a2a8$var$State.DATA;
                    break;
                }
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                {
                    this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                    this._createDoctypeToken(null);
                    const token = this.currentToken;
                    token.forceQuirks = true;
                    this.emitCurrentDoctype(token);
                    this._emitEOFToken();
                    break;
                }
            default:
                this._createDoctypeToken(String.fromCodePoint(cp));
                this.state = $c44790542489a2a8$var$State.DOCTYPE_NAME;
        }
    }
    // DOCTYPE name state
    //------------------------------------------------------------------
    _stateDoctypeName(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this.state = $c44790542489a2a8$var$State.AFTER_DOCTYPE_NAME;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.name += (0, $bb1347fda1174ed8$export$e8d20e7a50e6c279);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                token.name += String.fromCodePoint($c44790542489a2a8$var$isAsciiUpper(cp) ? $c44790542489a2a8$var$toAsciiLower(cp) : cp);
        }
    }
    // After DOCTYPE name state
    //------------------------------------------------------------------
    _stateAfterDoctypeName(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                if (this._consumeSequenceIfMatch((0, $bb1347fda1174ed8$export$5abac700f947e2).PUBLIC, false)) this.state = $c44790542489a2a8$var$State.AFTER_DOCTYPE_PUBLIC_KEYWORD;
                else if (this._consumeSequenceIfMatch((0, $bb1347fda1174ed8$export$5abac700f947e2).SYSTEM, false)) this.state = $c44790542489a2a8$var$State.AFTER_DOCTYPE_SYSTEM_KEYWORD;
                else if (!this._ensureHibernation()) {
                    this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).invalidCharacterSequenceAfterDoctypeName);
                    token.forceQuirks = true;
                    this.state = $c44790542489a2a8$var$State.BOGUS_DOCTYPE;
                    this._stateBogusDoctype(cp);
                }
        }
    }
    // After DOCTYPE public keyword state
    //------------------------------------------------------------------
    _stateAfterDoctypePublicKeyword(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this.state = $c44790542489a2a8$var$State.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingWhitespaceAfterDoctypePublicKeyword);
                token.publicId = '';
                this.state = $c44790542489a2a8$var$State.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingWhitespaceAfterDoctypePublicKeyword);
                token.publicId = '';
                this.state = $c44790542489a2a8$var$State.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingQuoteBeforeDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.state = $c44790542489a2a8$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // Before DOCTYPE public identifier state
    //------------------------------------------------------------------
    _stateBeforeDoctypePublicIdentifier(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                token.publicId = '';
                this.state = $c44790542489a2a8$var$State.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                token.publicId = '';
                this.state = $c44790542489a2a8$var$State.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingQuoteBeforeDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.state = $c44790542489a2a8$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // DOCTYPE public identifier (double-quoted) state
    //------------------------------------------------------------------
    _stateDoctypePublicIdentifierDoubleQuoted(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this.state = $c44790542489a2a8$var$State.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.publicId += (0, $bb1347fda1174ed8$export$e8d20e7a50e6c279);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).abruptDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this.state = $c44790542489a2a8$var$State.DATA;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                token.publicId += String.fromCodePoint(cp);
        }
    }
    // DOCTYPE public identifier (single-quoted) state
    //------------------------------------------------------------------
    _stateDoctypePublicIdentifierSingleQuoted(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this.state = $c44790542489a2a8$var$State.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.publicId += (0, $bb1347fda1174ed8$export$e8d20e7a50e6c279);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).abruptDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this.state = $c44790542489a2a8$var$State.DATA;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                token.publicId += String.fromCodePoint(cp);
        }
    }
    // After DOCTYPE public identifier state
    //------------------------------------------------------------------
    _stateAfterDoctypePublicIdentifier(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this.state = $c44790542489a2a8$var$State.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers);
                token.systemId = '';
                this.state = $c44790542489a2a8$var$State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers);
                token.systemId = '';
                this.state = $c44790542489a2a8$var$State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingQuoteBeforeDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = $c44790542489a2a8$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // Between DOCTYPE public and system identifiers state
    //------------------------------------------------------------------
    _stateBetweenDoctypePublicAndSystemIdentifiers(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.emitCurrentDoctype(token);
                this.state = $c44790542489a2a8$var$State.DATA;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                token.systemId = '';
                this.state = $c44790542489a2a8$var$State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                token.systemId = '';
                this.state = $c44790542489a2a8$var$State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingQuoteBeforeDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = $c44790542489a2a8$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // After DOCTYPE system keyword state
    //------------------------------------------------------------------
    _stateAfterDoctypeSystemKeyword(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this.state = $c44790542489a2a8$var$State.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingWhitespaceAfterDoctypeSystemKeyword);
                token.systemId = '';
                this.state = $c44790542489a2a8$var$State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingWhitespaceAfterDoctypeSystemKeyword);
                token.systemId = '';
                this.state = $c44790542489a2a8$var$State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingQuoteBeforeDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = $c44790542489a2a8$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // Before DOCTYPE system identifier state
    //------------------------------------------------------------------
    _stateBeforeDoctypeSystemIdentifier(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                token.systemId = '';
                this.state = $c44790542489a2a8$var$State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                token.systemId = '';
                this.state = $c44790542489a2a8$var$State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingQuoteBeforeDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = $c44790542489a2a8$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // DOCTYPE system identifier (double-quoted) state
    //------------------------------------------------------------------
    _stateDoctypeSystemIdentifierDoubleQuoted(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this.state = $c44790542489a2a8$var$State.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.systemId += (0, $bb1347fda1174ed8$export$e8d20e7a50e6c279);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).abruptDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this.state = $c44790542489a2a8$var$State.DATA;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                token.systemId += String.fromCodePoint(cp);
        }
    }
    // DOCTYPE system identifier (single-quoted) state
    //------------------------------------------------------------------
    _stateDoctypeSystemIdentifierSingleQuoted(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this.state = $c44790542489a2a8$var$State.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.systemId += (0, $bb1347fda1174ed8$export$e8d20e7a50e6c279);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).abruptDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this.state = $c44790542489a2a8$var$State.DATA;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                token.systemId += String.fromCodePoint(cp);
        }
    }
    // After DOCTYPE system identifier state
    //------------------------------------------------------------------
    _stateAfterDoctypeSystemIdentifier(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.emitCurrentDoctype(token);
                this.state = $c44790542489a2a8$var$State.DATA;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedCharacterAfterDoctypeSystemIdentifier);
                this.state = $c44790542489a2a8$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // Bogus DOCTYPE state
    //------------------------------------------------------------------
    _stateBogusDoctype(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.emitCurrentDoctype(token);
                this.state = $c44790542489a2a8$var$State.DATA;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
        }
    }
    // CDATA section state
    //------------------------------------------------------------------
    _stateCdataSection(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).RIGHT_SQUARE_BRACKET:
                this.state = $c44790542489a2a8$var$State.CDATA_SECTION_BRACKET;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInCdata);
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // CDATA section bracket state
    //------------------------------------------------------------------
    _stateCdataSectionBracket(cp) {
        if (cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).RIGHT_SQUARE_BRACKET) this.state = $c44790542489a2a8$var$State.CDATA_SECTION_END;
        else {
            this._emitChars(']');
            this.state = $c44790542489a2a8$var$State.CDATA_SECTION;
            this._stateCdataSection(cp);
        }
    }
    // CDATA section end state
    //------------------------------------------------------------------
    _stateCdataSectionEnd(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.DATA;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).RIGHT_SQUARE_BRACKET:
                this._emitChars(']');
                break;
            default:
                this._emitChars(']]');
                this.state = $c44790542489a2a8$var$State.CDATA_SECTION;
                this._stateCdataSection(cp);
        }
    }
    // Character reference state
    //------------------------------------------------------------------
    _stateCharacterReference() {
        let length = this.entityDecoder.write(this.preprocessor.html, this.preprocessor.pos);
        if (length < 0) {
            if (this.preprocessor.lastChunkWritten) length = this.entityDecoder.end();
            else {
                // Wait for the rest of the entity.
                this.active = false;
                // Mark the entire buffer as read.
                this.preprocessor.pos = this.preprocessor.html.length - 1;
                this.consumedAfterSnapshot = 0;
                this.preprocessor.endOfChunkHit = true;
                return;
            }
        }
        if (length === 0) {
            // This was not a valid entity. Go back to the beginning, and
            // figure out what to do.
            this.preprocessor.pos = this.entityStartPos;
            this._flushCodePointConsumedAsCharacterReference((0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).AMPERSAND);
            this.state = !this._isCharacterReferenceInAttribute() && $c44790542489a2a8$var$isAsciiAlphaNumeric(this.preprocessor.peek(1)) ? $c44790542489a2a8$var$State.AMBIGUOUS_AMPERSAND : this.returnState;
        } else // We successfully parsed an entity. Switch to the return state.
        this.state = this.returnState;
    }
    // Ambiguos ampersand state
    //------------------------------------------------------------------
    _stateAmbiguousAmpersand(cp) {
        if ($c44790542489a2a8$var$isAsciiAlphaNumeric(cp)) this._flushCodePointConsumedAsCharacterReference(cp);
        else {
            if (cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SEMICOLON) this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unknownNamedCharacterReference);
            this.state = this.returnState;
            this._callState(cp);
        }
    }
}



//Element utils
const $ebf2c18607f34e1d$var$IMPLICIT_END_TAG_REQUIRED = new Set([
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DD,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DT,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LI,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTGROUP,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTION,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).RB,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).RP,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).RT,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).RTC
]);
const $ebf2c18607f34e1d$var$IMPLICIT_END_TAG_REQUIRED_THOROUGHLY = new Set([
    ...$ebf2c18607f34e1d$var$IMPLICIT_END_TAG_REQUIRED,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR
]);
const $ebf2c18607f34e1d$var$SCOPING_ELEMENTS_HTML = new Set([
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).APPLET,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MARQUEE,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OBJECT,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH
]);
const $ebf2c18607f34e1d$var$SCOPING_ELEMENTS_HTML_LIST = new Set([
    ...$ebf2c18607f34e1d$var$SCOPING_ELEMENTS_HTML,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OL,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).UL
]);
const $ebf2c18607f34e1d$var$SCOPING_ELEMENTS_HTML_BUTTON = new Set([
    ...$ebf2c18607f34e1d$var$SCOPING_ELEMENTS_HTML,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BUTTON
]);
const $ebf2c18607f34e1d$var$SCOPING_ELEMENTS_MATHML = new Set([
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).ANNOTATION_XML,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MI,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MN,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MO,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MS,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MTEXT
]);
const $ebf2c18607f34e1d$var$SCOPING_ELEMENTS_SVG = new Set([
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DESC,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FOREIGN_OBJECT,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TITLE
]);
const $ebf2c18607f34e1d$var$TABLE_ROW_CONTEXT = new Set([
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML
]);
const $ebf2c18607f34e1d$var$TABLE_BODY_CONTEXT = new Set([
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML
]);
const $ebf2c18607f34e1d$var$TABLE_CONTEXT = new Set([
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML
]);
const $ebf2c18607f34e1d$var$TABLE_CELLS = new Set([
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH
]);
class $ebf2c18607f34e1d$export$56decf886ed987d6 {
    get currentTmplContentOrNode() {
        return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
    }
    constructor(document, treeAdapter, handler){
        this.treeAdapter = treeAdapter;
        this.handler = handler;
        this.items = [];
        this.tagIDs = [];
        this.stackTop = -1;
        this.tmplCount = 0;
        this.currentTagId = (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).UNKNOWN;
        this.current = document;
    }
    //Index of element
    _indexOf(element) {
        return this.items.lastIndexOf(element, this.stackTop);
    }
    //Update current element
    _isInTemplate() {
        return this.currentTagId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML;
    }
    _updateCurrentElement() {
        this.current = this.items[this.stackTop];
        this.currentTagId = this.tagIDs[this.stackTop];
    }
    //Mutations
    push(element, tagID) {
        this.stackTop++;
        this.items[this.stackTop] = element;
        this.current = element;
        this.tagIDs[this.stackTop] = tagID;
        this.currentTagId = tagID;
        if (this._isInTemplate()) this.tmplCount++;
        this.handler.onItemPush(element, tagID, true);
    }
    pop() {
        const popped = this.current;
        if (this.tmplCount > 0 && this._isInTemplate()) this.tmplCount--;
        this.stackTop--;
        this._updateCurrentElement();
        this.handler.onItemPop(popped, true);
    }
    replace(oldElement, newElement) {
        const idx = this._indexOf(oldElement);
        this.items[idx] = newElement;
        if (idx === this.stackTop) this.current = newElement;
    }
    insertAfter(referenceElement, newElement, newElementID) {
        const insertionIdx = this._indexOf(referenceElement) + 1;
        this.items.splice(insertionIdx, 0, newElement);
        this.tagIDs.splice(insertionIdx, 0, newElementID);
        this.stackTop++;
        if (insertionIdx === this.stackTop) this._updateCurrentElement();
        if (this.current && this.currentTagId !== undefined) this.handler.onItemPush(this.current, this.currentTagId, insertionIdx === this.stackTop);
    }
    popUntilTagNamePopped(tagName) {
        let targetIdx = this.stackTop + 1;
        do targetIdx = this.tagIDs.lastIndexOf(tagName, targetIdx - 1);
        while (targetIdx > 0 && this.treeAdapter.getNamespaceURI(this.items[targetIdx]) !== (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
        this.shortenToLength(Math.max(targetIdx, 0));
    }
    shortenToLength(idx) {
        while(this.stackTop >= idx){
            const popped = this.current;
            if (this.tmplCount > 0 && this._isInTemplate()) this.tmplCount -= 1;
            this.stackTop--;
            this._updateCurrentElement();
            this.handler.onItemPop(popped, this.stackTop < idx);
        }
    }
    popUntilElementPopped(element) {
        const idx = this._indexOf(element);
        this.shortenToLength(Math.max(idx, 0));
    }
    popUntilPopped(tagNames, targetNS) {
        const idx = this._indexOfTagNames(tagNames, targetNS);
        this.shortenToLength(Math.max(idx, 0));
    }
    popUntilNumberedHeaderPopped() {
        this.popUntilPopped((0, $c2855a9ccb69df69$export$1ecc20fa0754c045), (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    }
    popUntilTableCellPopped() {
        this.popUntilPopped($ebf2c18607f34e1d$var$TABLE_CELLS, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    }
    popAllUpToHtmlElement() {
        //NOTE: here we assume that the root <html> element is always first in the open element stack, so
        //we perform this fast stack clean up.
        this.tmplCount = 0;
        this.shortenToLength(1);
    }
    _indexOfTagNames(tagNames, namespace) {
        for(let i = this.stackTop; i >= 0; i--){
            if (tagNames.has(this.tagIDs[i]) && this.treeAdapter.getNamespaceURI(this.items[i]) === namespace) return i;
        }
        return -1;
    }
    clearBackTo(tagNames, targetNS) {
        const idx = this._indexOfTagNames(tagNames, targetNS);
        this.shortenToLength(idx + 1);
    }
    clearBackToTableContext() {
        this.clearBackTo($ebf2c18607f34e1d$var$TABLE_CONTEXT, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    }
    clearBackToTableBodyContext() {
        this.clearBackTo($ebf2c18607f34e1d$var$TABLE_BODY_CONTEXT, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    }
    clearBackToTableRowContext() {
        this.clearBackTo($ebf2c18607f34e1d$var$TABLE_ROW_CONTEXT, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    }
    remove(element) {
        const idx = this._indexOf(element);
        if (idx >= 0) {
            if (idx === this.stackTop) this.pop();
            else {
                this.items.splice(idx, 1);
                this.tagIDs.splice(idx, 1);
                this.stackTop--;
                this._updateCurrentElement();
                this.handler.onItemPop(element, false);
            }
        }
    }
    //Search
    tryPeekProperlyNestedBodyElement() {
        //Properly nested <body> element (should be second element in stack).
        return this.stackTop >= 1 && this.tagIDs[1] === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY ? this.items[1] : null;
    }
    contains(element) {
        return this._indexOf(element) > -1;
    }
    getCommonAncestor(element) {
        const elementIdx = this._indexOf(element) - 1;
        return elementIdx >= 0 ? this.items[elementIdx] : null;
    }
    isRootHtmlElementCurrent() {
        return this.stackTop === 0 && this.tagIDs[0] === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML;
    }
    //Element in scope
    hasInDynamicScope(tagName, htmlScope) {
        for(let i = this.stackTop; i >= 0; i--){
            const tn = this.tagIDs[i];
            switch(this.treeAdapter.getNamespaceURI(this.items[i])){
                case (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML:
                    if (tn === tagName) return true;
                    if (htmlScope.has(tn)) return false;
                    break;
                case (0, $c2855a9ccb69df69$export$fb4028874a74450).SVG:
                    if ($ebf2c18607f34e1d$var$SCOPING_ELEMENTS_SVG.has(tn)) return false;
                    break;
                case (0, $c2855a9ccb69df69$export$fb4028874a74450).MATHML:
                    if ($ebf2c18607f34e1d$var$SCOPING_ELEMENTS_MATHML.has(tn)) return false;
                    break;
            }
        }
        return true;
    }
    hasInScope(tagName) {
        return this.hasInDynamicScope(tagName, $ebf2c18607f34e1d$var$SCOPING_ELEMENTS_HTML);
    }
    hasInListItemScope(tagName) {
        return this.hasInDynamicScope(tagName, $ebf2c18607f34e1d$var$SCOPING_ELEMENTS_HTML_LIST);
    }
    hasInButtonScope(tagName) {
        return this.hasInDynamicScope(tagName, $ebf2c18607f34e1d$var$SCOPING_ELEMENTS_HTML_BUTTON);
    }
    hasNumberedHeaderInScope() {
        for(let i = this.stackTop; i >= 0; i--){
            const tn = this.tagIDs[i];
            switch(this.treeAdapter.getNamespaceURI(this.items[i])){
                case (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML:
                    if ((0, $c2855a9ccb69df69$export$1ecc20fa0754c045).has(tn)) return true;
                    if ($ebf2c18607f34e1d$var$SCOPING_ELEMENTS_HTML.has(tn)) return false;
                    break;
                case (0, $c2855a9ccb69df69$export$fb4028874a74450).SVG:
                    if ($ebf2c18607f34e1d$var$SCOPING_ELEMENTS_SVG.has(tn)) return false;
                    break;
                case (0, $c2855a9ccb69df69$export$fb4028874a74450).MATHML:
                    if ($ebf2c18607f34e1d$var$SCOPING_ELEMENTS_MATHML.has(tn)) return false;
                    break;
            }
        }
        return true;
    }
    hasInTableScope(tagName) {
        for(let i = this.stackTop; i >= 0; i--){
            if (this.treeAdapter.getNamespaceURI(this.items[i]) !== (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML) continue;
            switch(this.tagIDs[i]){
                case tagName:
                    return true;
                case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE:
                case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
                    return false;
            }
        }
        return true;
    }
    hasTableBodyContextInTableScope() {
        for(let i = this.stackTop; i >= 0; i--){
            if (this.treeAdapter.getNamespaceURI(this.items[i]) !== (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML) continue;
            switch(this.tagIDs[i]){
                case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY:
                case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD:
                case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT:
                    return true;
                case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE:
                case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
                    return false;
            }
        }
        return true;
    }
    hasInSelectScope(tagName) {
        for(let i = this.stackTop; i >= 0; i--){
            if (this.treeAdapter.getNamespaceURI(this.items[i]) !== (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML) continue;
            switch(this.tagIDs[i]){
                case tagName:
                    return true;
                case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTION:
                case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTGROUP:
                    break;
                default:
                    return false;
            }
        }
        return true;
    }
    //Implied end tags
    generateImpliedEndTags() {
        while(this.currentTagId !== undefined && $ebf2c18607f34e1d$var$IMPLICIT_END_TAG_REQUIRED.has(this.currentTagId))this.pop();
    }
    generateImpliedEndTagsThoroughly() {
        while(this.currentTagId !== undefined && $ebf2c18607f34e1d$var$IMPLICIT_END_TAG_REQUIRED_THOROUGHLY.has(this.currentTagId))this.pop();
    }
    generateImpliedEndTagsWithExclusion(exclusionId) {
        while(this.currentTagId !== undefined && this.currentTagId !== exclusionId && $ebf2c18607f34e1d$var$IMPLICIT_END_TAG_REQUIRED_THOROUGHLY.has(this.currentTagId))this.pop();
    }
}


//Const
const $e595487314683422$var$NOAH_ARK_CAPACITY = 3;
var $e595487314683422$export$e41c32906b33062a;
(function(EntryType) {
    EntryType[EntryType["Marker"] = 0] = "Marker";
    EntryType[EntryType["Element"] = 1] = "Element";
})($e595487314683422$export$e41c32906b33062a || ($e595487314683422$export$e41c32906b33062a = {}));
const $e595487314683422$var$MARKER = {
    type: $e595487314683422$export$e41c32906b33062a.Marker
};
class $e595487314683422$export$20023318d9d5bbce {
    constructor(treeAdapter){
        this.treeAdapter = treeAdapter;
        this.entries = [];
        this.bookmark = null;
    }
    //Noah Ark's condition
    //OPTIMIZATION: at first we try to find possible candidates for exclusion using
    //lightweight heuristics without thorough attributes check.
    _getNoahArkConditionCandidates(newElement, neAttrs) {
        const candidates = [];
        const neAttrsLength = neAttrs.length;
        const neTagName = this.treeAdapter.getTagName(newElement);
        const neNamespaceURI = this.treeAdapter.getNamespaceURI(newElement);
        for(let i = 0; i < this.entries.length; i++){
            const entry = this.entries[i];
            if (entry.type === $e595487314683422$export$e41c32906b33062a.Marker) break;
            const { element: element } = entry;
            if (this.treeAdapter.getTagName(element) === neTagName && this.treeAdapter.getNamespaceURI(element) === neNamespaceURI) {
                const elementAttrs = this.treeAdapter.getAttrList(element);
                if (elementAttrs.length === neAttrsLength) candidates.push({
                    idx: i,
                    attrs: elementAttrs
                });
            }
        }
        return candidates;
    }
    _ensureNoahArkCondition(newElement) {
        if (this.entries.length < $e595487314683422$var$NOAH_ARK_CAPACITY) return;
        const neAttrs = this.treeAdapter.getAttrList(newElement);
        const candidates = this._getNoahArkConditionCandidates(newElement, neAttrs);
        if (candidates.length < $e595487314683422$var$NOAH_ARK_CAPACITY) return;
        //NOTE: build attrs map for the new element, so we can perform fast lookups
        const neAttrsMap = new Map(neAttrs.map((neAttr)=>[
                neAttr.name,
                neAttr.value
            ]));
        let validCandidates = 0;
        //NOTE: remove bottommost candidates, until Noah's Ark condition will not be met
        for(let i = 0; i < candidates.length; i++){
            const candidate = candidates[i];
            // We know that `candidate.attrs.length === neAttrs.length`
            if (candidate.attrs.every((cAttr)=>neAttrsMap.get(cAttr.name) === cAttr.value)) {
                validCandidates += 1;
                if (validCandidates >= $e595487314683422$var$NOAH_ARK_CAPACITY) this.entries.splice(candidate.idx, 1);
            }
        }
    }
    //Mutations
    insertMarker() {
        this.entries.unshift($e595487314683422$var$MARKER);
    }
    pushElement(element, token) {
        this._ensureNoahArkCondition(element);
        this.entries.unshift({
            type: $e595487314683422$export$e41c32906b33062a.Element,
            element: element,
            token: token
        });
    }
    insertElementAfterBookmark(element, token) {
        const bookmarkIdx = this.entries.indexOf(this.bookmark);
        this.entries.splice(bookmarkIdx, 0, {
            type: $e595487314683422$export$e41c32906b33062a.Element,
            element: element,
            token: token
        });
    }
    removeEntry(entry) {
        const entryIndex = this.entries.indexOf(entry);
        if (entryIndex !== -1) this.entries.splice(entryIndex, 1);
    }
    /**
     * Clears the list of formatting elements up to the last marker.
     *
     * @see https://html.spec.whatwg.org/multipage/parsing.html#clear-the-list-of-active-formatting-elements-up-to-the-last-marker
     */ clearToLastMarker() {
        const markerIdx = this.entries.indexOf($e595487314683422$var$MARKER);
        if (markerIdx === -1) this.entries.length = 0;
        else this.entries.splice(0, markerIdx + 1);
    }
    //Search
    getElementEntryInScopeWithTagName(tagName) {
        const entry = this.entries.find((entry)=>entry.type === $e595487314683422$export$e41c32906b33062a.Marker || this.treeAdapter.getTagName(entry.element) === tagName);
        return entry && entry.type === $e595487314683422$export$e41c32906b33062a.Element ? entry : null;
    }
    getElementEntry(element) {
        return this.entries.find((entry)=>entry.type === $e595487314683422$export$e41c32906b33062a.Element && entry.element === element);
    }
}



const $01acbc1e35b87488$export$7ddbba828dfa4796 = {
    //Node construction
    createDocument () {
        return {
            nodeName: '#document',
            mode: (0, $c2855a9ccb69df69$export$a74d46c85337d29a).NO_QUIRKS,
            childNodes: []
        };
    },
    createDocumentFragment () {
        return {
            nodeName: '#document-fragment',
            childNodes: []
        };
    },
    createElement (tagName, namespaceURI, attrs) {
        return {
            nodeName: tagName,
            tagName: tagName,
            attrs: attrs,
            namespaceURI: namespaceURI,
            childNodes: [],
            parentNode: null
        };
    },
    createCommentNode (data) {
        return {
            nodeName: '#comment',
            data: data,
            parentNode: null
        };
    },
    createTextNode (value) {
        return {
            nodeName: '#text',
            value: value,
            parentNode: null
        };
    },
    //Tree mutation
    appendChild (parentNode, newNode) {
        parentNode.childNodes.push(newNode);
        newNode.parentNode = parentNode;
    },
    insertBefore (parentNode, newNode, referenceNode) {
        const insertionIdx = parentNode.childNodes.indexOf(referenceNode);
        parentNode.childNodes.splice(insertionIdx, 0, newNode);
        newNode.parentNode = parentNode;
    },
    setTemplateContent (templateElement, contentElement) {
        templateElement.content = contentElement;
    },
    getTemplateContent (templateElement) {
        return templateElement.content;
    },
    setDocumentType (document, name, publicId, systemId) {
        const doctypeNode = document.childNodes.find((node)=>node.nodeName === '#documentType');
        if (doctypeNode) {
            doctypeNode.name = name;
            doctypeNode.publicId = publicId;
            doctypeNode.systemId = systemId;
        } else {
            const node = {
                nodeName: '#documentType',
                name: name,
                publicId: publicId,
                systemId: systemId,
                parentNode: null
            };
            $01acbc1e35b87488$export$7ddbba828dfa4796.appendChild(document, node);
        }
    },
    setDocumentMode (document, mode) {
        document.mode = mode;
    },
    getDocumentMode (document) {
        return document.mode;
    },
    detachNode (node) {
        if (node.parentNode) {
            const idx = node.parentNode.childNodes.indexOf(node);
            node.parentNode.childNodes.splice(idx, 1);
            node.parentNode = null;
        }
    },
    insertText (parentNode, text) {
        if (parentNode.childNodes.length > 0) {
            const prevNode = parentNode.childNodes[parentNode.childNodes.length - 1];
            if ($01acbc1e35b87488$export$7ddbba828dfa4796.isTextNode(prevNode)) {
                prevNode.value += text;
                return;
            }
        }
        $01acbc1e35b87488$export$7ddbba828dfa4796.appendChild(parentNode, $01acbc1e35b87488$export$7ddbba828dfa4796.createTextNode(text));
    },
    insertTextBefore (parentNode, text, referenceNode) {
        const prevNode = parentNode.childNodes[parentNode.childNodes.indexOf(referenceNode) - 1];
        if (prevNode && $01acbc1e35b87488$export$7ddbba828dfa4796.isTextNode(prevNode)) prevNode.value += text;
        else $01acbc1e35b87488$export$7ddbba828dfa4796.insertBefore(parentNode, $01acbc1e35b87488$export$7ddbba828dfa4796.createTextNode(text), referenceNode);
    },
    adoptAttributes (recipient, attrs) {
        const recipientAttrsMap = new Set(recipient.attrs.map((attr)=>attr.name));
        for(let j = 0; j < attrs.length; j++)if (!recipientAttrsMap.has(attrs[j].name)) recipient.attrs.push(attrs[j]);
    },
    //Tree traversing
    getFirstChild (node) {
        return node.childNodes[0];
    },
    getChildNodes (node) {
        return node.childNodes;
    },
    getParentNode (node) {
        return node.parentNode;
    },
    getAttrList (element) {
        return element.attrs;
    },
    //Node data
    getTagName (element) {
        return element.tagName;
    },
    getNamespaceURI (element) {
        return element.namespaceURI;
    },
    getTextNodeContent (textNode) {
        return textNode.value;
    },
    getCommentNodeContent (commentNode) {
        return commentNode.data;
    },
    getDocumentTypeNodeName (doctypeNode) {
        return doctypeNode.name;
    },
    getDocumentTypeNodePublicId (doctypeNode) {
        return doctypeNode.publicId;
    },
    getDocumentTypeNodeSystemId (doctypeNode) {
        return doctypeNode.systemId;
    },
    //Node types
    isTextNode (node) {
        return node.nodeName === '#text';
    },
    isCommentNode (node) {
        return node.nodeName === '#comment';
    },
    isDocumentTypeNode (node) {
        return node.nodeName === '#documentType';
    },
    isElementNode (node) {
        return Object.prototype.hasOwnProperty.call(node, 'tagName');
    },
    // Source code location
    setNodeSourceCodeLocation (node, location) {
        node.sourceCodeLocation = location;
    },
    getNodeSourceCodeLocation (node) {
        return node.sourceCodeLocation;
    },
    updateNodeSourceCodeLocation (node, endLocation) {
        node.sourceCodeLocation = {
            ...node.sourceCodeLocation,
            ...endLocation
        };
    }
};



//Const
const $32b34f4d04b90291$var$VALID_DOCTYPE_NAME = 'html';
const $32b34f4d04b90291$var$VALID_SYSTEM_ID = 'about:legacy-compat';
const $32b34f4d04b90291$var$QUIRKS_MODE_SYSTEM_ID = 'http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd';
const $32b34f4d04b90291$var$QUIRKS_MODE_PUBLIC_ID_PREFIXES = [
    '+//silmaril//dtd html pro v0r11 19970101//',
    '-//as//dtd html 3.0 aswedit + extensions//',
    '-//advasoft ltd//dtd html 3.0 aswedit + extensions//',
    '-//ietf//dtd html 2.0 level 1//',
    '-//ietf//dtd html 2.0 level 2//',
    '-//ietf//dtd html 2.0 strict level 1//',
    '-//ietf//dtd html 2.0 strict level 2//',
    '-//ietf//dtd html 2.0 strict//',
    '-//ietf//dtd html 2.0//',
    '-//ietf//dtd html 2.1e//',
    '-//ietf//dtd html 3.0//',
    '-//ietf//dtd html 3.2 final//',
    '-//ietf//dtd html 3.2//',
    '-//ietf//dtd html 3//',
    '-//ietf//dtd html level 0//',
    '-//ietf//dtd html level 1//',
    '-//ietf//dtd html level 2//',
    '-//ietf//dtd html level 3//',
    '-//ietf//dtd html strict level 0//',
    '-//ietf//dtd html strict level 1//',
    '-//ietf//dtd html strict level 2//',
    '-//ietf//dtd html strict level 3//',
    '-//ietf//dtd html strict//',
    '-//ietf//dtd html//',
    '-//metrius//dtd metrius presentational//',
    '-//microsoft//dtd internet explorer 2.0 html strict//',
    '-//microsoft//dtd internet explorer 2.0 html//',
    '-//microsoft//dtd internet explorer 2.0 tables//',
    '-//microsoft//dtd internet explorer 3.0 html strict//',
    '-//microsoft//dtd internet explorer 3.0 html//',
    '-//microsoft//dtd internet explorer 3.0 tables//',
    '-//netscape comm. corp.//dtd html//',
    '-//netscape comm. corp.//dtd strict html//',
    "-//o'reilly and associates//dtd html 2.0//",
    "-//o'reilly and associates//dtd html extended 1.0//",
    "-//o'reilly and associates//dtd html extended relaxed 1.0//",
    '-//sq//dtd html 2.0 hotmetal + extensions//',
    '-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//',
    '-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//',
    '-//spyglass//dtd html 2.0 extended//',
    '-//sun microsystems corp.//dtd hotjava html//',
    '-//sun microsystems corp.//dtd hotjava strict html//',
    '-//w3c//dtd html 3 1995-03-24//',
    '-//w3c//dtd html 3.2 draft//',
    '-//w3c//dtd html 3.2 final//',
    '-//w3c//dtd html 3.2//',
    '-//w3c//dtd html 3.2s draft//',
    '-//w3c//dtd html 4.0 frameset//',
    '-//w3c//dtd html 4.0 transitional//',
    '-//w3c//dtd html experimental 19960712//',
    '-//w3c//dtd html experimental 970421//',
    '-//w3c//dtd w3 html//',
    '-//w3o//dtd w3 html 3.0//',
    '-//webtechs//dtd mozilla html 2.0//',
    '-//webtechs//dtd mozilla html//'
];
const $32b34f4d04b90291$var$QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES = [
    ...$32b34f4d04b90291$var$QUIRKS_MODE_PUBLIC_ID_PREFIXES,
    '-//w3c//dtd html 4.01 frameset//',
    '-//w3c//dtd html 4.01 transitional//'
];
const $32b34f4d04b90291$var$QUIRKS_MODE_PUBLIC_IDS = new Set([
    '-//w3o//dtd w3 html strict 3.0//en//',
    '-/w3c/dtd html 4.0 transitional/en',
    'html'
]);
const $32b34f4d04b90291$var$LIMITED_QUIRKS_PUBLIC_ID_PREFIXES = [
    '-//w3c//dtd xhtml 1.0 frameset//',
    '-//w3c//dtd xhtml 1.0 transitional//'
];
const $32b34f4d04b90291$var$LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES = [
    ...$32b34f4d04b90291$var$LIMITED_QUIRKS_PUBLIC_ID_PREFIXES,
    '-//w3c//dtd html 4.01 frameset//',
    '-//w3c//dtd html 4.01 transitional//'
];
//Utils
function $32b34f4d04b90291$var$hasPrefix(publicId, prefixes) {
    return prefixes.some((prefix)=>publicId.startsWith(prefix));
}
function $32b34f4d04b90291$export$ee48152ecc0e3f40(token) {
    return token.name === $32b34f4d04b90291$var$VALID_DOCTYPE_NAME && token.publicId === null && (token.systemId === null || token.systemId === $32b34f4d04b90291$var$VALID_SYSTEM_ID);
}
function $32b34f4d04b90291$export$64782beacef87b30(token) {
    if (token.name !== $32b34f4d04b90291$var$VALID_DOCTYPE_NAME) return (0, $c2855a9ccb69df69$export$a74d46c85337d29a).QUIRKS;
    const { systemId: systemId } = token;
    if (systemId && systemId.toLowerCase() === $32b34f4d04b90291$var$QUIRKS_MODE_SYSTEM_ID) return (0, $c2855a9ccb69df69$export$a74d46c85337d29a).QUIRKS;
    let { publicId: publicId } = token;
    if (publicId !== null) {
        publicId = publicId.toLowerCase();
        if ($32b34f4d04b90291$var$QUIRKS_MODE_PUBLIC_IDS.has(publicId)) return (0, $c2855a9ccb69df69$export$a74d46c85337d29a).QUIRKS;
        let prefixes = systemId === null ? $32b34f4d04b90291$var$QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES : $32b34f4d04b90291$var$QUIRKS_MODE_PUBLIC_ID_PREFIXES;
        if ($32b34f4d04b90291$var$hasPrefix(publicId, prefixes)) return (0, $c2855a9ccb69df69$export$a74d46c85337d29a).QUIRKS;
        prefixes = systemId === null ? $32b34f4d04b90291$var$LIMITED_QUIRKS_PUBLIC_ID_PREFIXES : $32b34f4d04b90291$var$LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES;
        if ($32b34f4d04b90291$var$hasPrefix(publicId, prefixes)) return (0, $c2855a9ccb69df69$export$a74d46c85337d29a).LIMITED_QUIRKS;
    }
    return (0, $c2855a9ccb69df69$export$a74d46c85337d29a).NO_QUIRKS;
}



//MIME types
const $488c212c7b5d6f42$var$MIME_TYPES = {
    TEXT_HTML: 'text/html',
    APPLICATION_XML: 'application/xhtml+xml'
};
//Attributes
const $488c212c7b5d6f42$var$DEFINITION_URL_ATTR = 'definitionurl';
const $488c212c7b5d6f42$var$ADJUSTED_DEFINITION_URL_ATTR = 'definitionURL';
const $488c212c7b5d6f42$var$SVG_ATTRS_ADJUSTMENT_MAP = new Map([
    'attributeName',
    'attributeType',
    'baseFrequency',
    'baseProfile',
    'calcMode',
    'clipPathUnits',
    'diffuseConstant',
    'edgeMode',
    'filterUnits',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'kernelMatrix',
    'kernelUnitLength',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'limitingConeAngle',
    'markerHeight',
    'markerUnits',
    'markerWidth',
    'maskContentUnits',
    'maskUnits',
    'numOctaves',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'refX',
    'refY',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'specularConstant',
    'specularExponent',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stitchTiles',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textLength',
    'viewBox',
    'viewTarget',
    'xChannelSelector',
    'yChannelSelector',
    'zoomAndPan'
].map((attr)=>[
        attr.toLowerCase(),
        attr
    ]));
const $488c212c7b5d6f42$var$XML_ATTRS_ADJUSTMENT_MAP = new Map([
    [
        'xlink:actuate',
        {
            prefix: 'xlink',
            name: 'actuate',
            namespace: (0, $c2855a9ccb69df69$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xlink:arcrole',
        {
            prefix: 'xlink',
            name: 'arcrole',
            namespace: (0, $c2855a9ccb69df69$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xlink:href',
        {
            prefix: 'xlink',
            name: 'href',
            namespace: (0, $c2855a9ccb69df69$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xlink:role',
        {
            prefix: 'xlink',
            name: 'role',
            namespace: (0, $c2855a9ccb69df69$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xlink:show',
        {
            prefix: 'xlink',
            name: 'show',
            namespace: (0, $c2855a9ccb69df69$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xlink:title',
        {
            prefix: 'xlink',
            name: 'title',
            namespace: (0, $c2855a9ccb69df69$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xlink:type',
        {
            prefix: 'xlink',
            name: 'type',
            namespace: (0, $c2855a9ccb69df69$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xml:lang',
        {
            prefix: 'xml',
            name: 'lang',
            namespace: (0, $c2855a9ccb69df69$export$fb4028874a74450).XML
        }
    ],
    [
        'xml:space',
        {
            prefix: 'xml',
            name: 'space',
            namespace: (0, $c2855a9ccb69df69$export$fb4028874a74450).XML
        }
    ],
    [
        'xmlns',
        {
            prefix: '',
            name: 'xmlns',
            namespace: (0, $c2855a9ccb69df69$export$fb4028874a74450).XMLNS
        }
    ],
    [
        'xmlns:xlink',
        {
            prefix: 'xmlns',
            name: 'xlink',
            namespace: (0, $c2855a9ccb69df69$export$fb4028874a74450).XMLNS
        }
    ]
]);
const $488c212c7b5d6f42$export$86512877756eb1b1 = new Map([
    'altGlyph',
    'altGlyphDef',
    'altGlyphItem',
    'animateColor',
    'animateMotion',
    'animateTransform',
    'clipPath',
    'feBlend',
    'feColorMatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'foreignObject',
    'glyphRef',
    'linearGradient',
    'radialGradient',
    'textPath'
].map((tn)=>[
        tn.toLowerCase(),
        tn
    ]));
//Tags that causes exit from foreign content
const $488c212c7b5d6f42$var$EXITS_FOREIGN_CONTENT = new Set([
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).B,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BIG,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BLOCKQUOTE,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BR,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CENTER,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CODE,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DD,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DIV,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DL,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DT,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).EM,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).EMBED,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H1,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H2,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H3,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H4,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H5,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H6,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEAD,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HR,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).I,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).IMG,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LI,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LISTING,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MENU,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).META,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOBR,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OL,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).PRE,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).RUBY,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).S,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SMALL,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SPAN,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).STRONG,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).STRIKE,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SUB,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SUP,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TT,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).U,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).UL,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).VAR
]);
function $488c212c7b5d6f42$export$3435eb4ab4d2ed2d(startTagToken) {
    const tn = startTagToken.tagID;
    const isFontWithAttrs = tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FONT && startTagToken.attrs.some(({ name: name })=>name === (0, $c2855a9ccb69df69$export$380b7bc9e6cb1918).COLOR || name === (0, $c2855a9ccb69df69$export$380b7bc9e6cb1918).SIZE || name === (0, $c2855a9ccb69df69$export$380b7bc9e6cb1918).FACE);
    return isFontWithAttrs || $488c212c7b5d6f42$var$EXITS_FOREIGN_CONTENT.has(tn);
}
function $488c212c7b5d6f42$export$c583cc5a9d633feb(token) {
    for(let i = 0; i < token.attrs.length; i++)if (token.attrs[i].name === $488c212c7b5d6f42$var$DEFINITION_URL_ATTR) {
        token.attrs[i].name = $488c212c7b5d6f42$var$ADJUSTED_DEFINITION_URL_ATTR;
        break;
    }
}
function $488c212c7b5d6f42$export$74ce06f755fb8f68(token) {
    for(let i = 0; i < token.attrs.length; i++){
        const adjustedAttrName = $488c212c7b5d6f42$var$SVG_ATTRS_ADJUSTMENT_MAP.get(token.attrs[i].name);
        if (adjustedAttrName != null) token.attrs[i].name = adjustedAttrName;
    }
}
function $488c212c7b5d6f42$export$a5192af02995cbdc(token) {
    for(let i = 0; i < token.attrs.length; i++){
        const adjustedAttrEntry = $488c212c7b5d6f42$var$XML_ATTRS_ADJUSTMENT_MAP.get(token.attrs[i].name);
        if (adjustedAttrEntry) {
            token.attrs[i].prefix = adjustedAttrEntry.prefix;
            token.attrs[i].name = adjustedAttrEntry.name;
            token.attrs[i].namespace = adjustedAttrEntry.namespace;
        }
    }
}
function $488c212c7b5d6f42$export$95df78fe2e7f33e3(token) {
    const adjustedTagName = $488c212c7b5d6f42$export$86512877756eb1b1.get(token.tagName);
    if (adjustedTagName != null) {
        token.tagName = adjustedTagName;
        token.tagID = (0, $c2855a9ccb69df69$export$39db8a1315f68282)(token.tagName);
    }
}
//Integration points
function $488c212c7b5d6f42$var$isMathMLTextIntegrationPoint(tn, ns) {
    return ns === (0, $c2855a9ccb69df69$export$fb4028874a74450).MATHML && (tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MI || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MO || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MN || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MS || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MTEXT);
}
function $488c212c7b5d6f42$var$isHtmlIntegrationPoint(tn, ns, attrs) {
    if (ns === (0, $c2855a9ccb69df69$export$fb4028874a74450).MATHML && tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).ANNOTATION_XML) {
        for(let i = 0; i < attrs.length; i++)if (attrs[i].name === (0, $c2855a9ccb69df69$export$380b7bc9e6cb1918).ENCODING) {
            const value = attrs[i].value.toLowerCase();
            return value === $488c212c7b5d6f42$var$MIME_TYPES.TEXT_HTML || value === $488c212c7b5d6f42$var$MIME_TYPES.APPLICATION_XML;
        }
    }
    return ns === (0, $c2855a9ccb69df69$export$fb4028874a74450).SVG && (tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FOREIGN_OBJECT || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DESC || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TITLE);
}
function $488c212c7b5d6f42$export$6baf3ebfdd620e1(tn, ns, attrs, foreignNS) {
    return (!foreignNS || foreignNS === (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML) && $488c212c7b5d6f42$var$isHtmlIntegrationPoint(tn, ns, attrs) || (!foreignNS || foreignNS === (0, $c2855a9ccb69df69$export$fb4028874a74450).MATHML) && $488c212c7b5d6f42$var$isMathMLTextIntegrationPoint(tn, ns);
}






//Misc constants
const $2f5582982d8cf3f4$var$HIDDEN_INPUT_TYPE = 'hidden';
//Adoption agency loops iteration count
const $2f5582982d8cf3f4$var$AA_OUTER_LOOP_ITER = 8;
const $2f5582982d8cf3f4$var$AA_INNER_LOOP_ITER = 3;
//Insertion modes
var $2f5582982d8cf3f4$var$InsertionMode;
(function(InsertionMode) {
    InsertionMode[InsertionMode["INITIAL"] = 0] = "INITIAL";
    InsertionMode[InsertionMode["BEFORE_HTML"] = 1] = "BEFORE_HTML";
    InsertionMode[InsertionMode["BEFORE_HEAD"] = 2] = "BEFORE_HEAD";
    InsertionMode[InsertionMode["IN_HEAD"] = 3] = "IN_HEAD";
    InsertionMode[InsertionMode["IN_HEAD_NO_SCRIPT"] = 4] = "IN_HEAD_NO_SCRIPT";
    InsertionMode[InsertionMode["AFTER_HEAD"] = 5] = "AFTER_HEAD";
    InsertionMode[InsertionMode["IN_BODY"] = 6] = "IN_BODY";
    InsertionMode[InsertionMode["TEXT"] = 7] = "TEXT";
    InsertionMode[InsertionMode["IN_TABLE"] = 8] = "IN_TABLE";
    InsertionMode[InsertionMode["IN_TABLE_TEXT"] = 9] = "IN_TABLE_TEXT";
    InsertionMode[InsertionMode["IN_CAPTION"] = 10] = "IN_CAPTION";
    InsertionMode[InsertionMode["IN_COLUMN_GROUP"] = 11] = "IN_COLUMN_GROUP";
    InsertionMode[InsertionMode["IN_TABLE_BODY"] = 12] = "IN_TABLE_BODY";
    InsertionMode[InsertionMode["IN_ROW"] = 13] = "IN_ROW";
    InsertionMode[InsertionMode["IN_CELL"] = 14] = "IN_CELL";
    InsertionMode[InsertionMode["IN_SELECT"] = 15] = "IN_SELECT";
    InsertionMode[InsertionMode["IN_SELECT_IN_TABLE"] = 16] = "IN_SELECT_IN_TABLE";
    InsertionMode[InsertionMode["IN_TEMPLATE"] = 17] = "IN_TEMPLATE";
    InsertionMode[InsertionMode["AFTER_BODY"] = 18] = "AFTER_BODY";
    InsertionMode[InsertionMode["IN_FRAMESET"] = 19] = "IN_FRAMESET";
    InsertionMode[InsertionMode["AFTER_FRAMESET"] = 20] = "AFTER_FRAMESET";
    InsertionMode[InsertionMode["AFTER_AFTER_BODY"] = 21] = "AFTER_AFTER_BODY";
    InsertionMode[InsertionMode["AFTER_AFTER_FRAMESET"] = 22] = "AFTER_AFTER_FRAMESET";
})($2f5582982d8cf3f4$var$InsertionMode || ($2f5582982d8cf3f4$var$InsertionMode = {}));
const $2f5582982d8cf3f4$var$BASE_LOC = {
    startLine: -1,
    startCol: -1,
    startOffset: -1,
    endLine: -1,
    endCol: -1,
    endOffset: -1
};
const $2f5582982d8cf3f4$var$TABLE_STRUCTURE_TAGS = new Set([
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR
]);
const $2f5582982d8cf3f4$var$defaultParserOptions = {
    scriptingEnabled: true,
    sourceCodeLocationInfo: false,
    treeAdapter: (0, $01acbc1e35b87488$export$7ddbba828dfa4796),
    onParseError: null
};
class $2f5582982d8cf3f4$export$7acfa6ed01010e37 {
    constructor(options, document, /** @internal */ fragmentContext = null, /** @internal */ scriptHandler = null){
        this.fragmentContext = fragmentContext;
        this.scriptHandler = scriptHandler;
        this.currentToken = null;
        this.stopped = false;
        /** @internal */ this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.INITIAL;
        /** @internal */ this.originalInsertionMode = $2f5582982d8cf3f4$var$InsertionMode.INITIAL;
        /** @internal */ this.headElement = null;
        /** @internal */ this.formElement = null;
        /** Indicates that the current node is not an element in the HTML namespace */ this.currentNotInHTML = false;
        /**
         * The template insertion mode stack is maintained from the left.
         * Ie. the topmost element will always have index 0.
         *
         * @internal
         */ this.tmplInsertionModeStack = [];
        /** @internal */ this.pendingCharacterTokens = [];
        /** @internal */ this.hasNonWhitespacePendingCharacterToken = false;
        /** @internal */ this.framesetOk = true;
        /** @internal */ this.skipNextNewLine = false;
        /** @internal */ this.fosterParentingEnabled = false;
        this.options = {
            ...$2f5582982d8cf3f4$var$defaultParserOptions,
            ...options
        };
        this.treeAdapter = this.options.treeAdapter;
        this.onParseError = this.options.onParseError;
        // Always enable location info if we report parse errors.
        if (this.onParseError) this.options.sourceCodeLocationInfo = true;
        this.document = document !== null && document !== void 0 ? document : this.treeAdapter.createDocument();
        this.tokenizer = new (0, $c44790542489a2a8$export$55e8b082af4aa63e)(this.options, this);
        this.activeFormattingElements = new (0, $e595487314683422$export$20023318d9d5bbce)(this.treeAdapter);
        this.fragmentContextID = fragmentContext ? (0, $c2855a9ccb69df69$export$39db8a1315f68282)(this.treeAdapter.getTagName(fragmentContext)) : (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).UNKNOWN;
        this._setContextModes(fragmentContext !== null && fragmentContext !== void 0 ? fragmentContext : this.document, this.fragmentContextID);
        this.openElements = new (0, $ebf2c18607f34e1d$export$56decf886ed987d6)(this.document, this.treeAdapter, this);
    }
    // API
    static parse(html, options) {
        const parser = new this(options);
        parser.tokenizer.write(html, true);
        return parser.document;
    }
    static getFragmentParser(fragmentContext, options) {
        const opts = {
            ...$2f5582982d8cf3f4$var$defaultParserOptions,
            ...options
        };
        //NOTE: use a <template> element as the fragment context if no context element was provided,
        //so we will parse in a "forgiving" manner
        fragmentContext !== null && fragmentContext !== void 0 ? fragmentContext : fragmentContext = opts.treeAdapter.createElement((0, $c2855a9ccb69df69$export$7e674a85a2656dce).TEMPLATE, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML, []);
        //NOTE: create a fake element which will be used as the `document` for fragment parsing.
        //This is important for jsdom, where a new `document` cannot be created. This led to
        //fragment parsing messing with the main `document`.
        const documentMock = opts.treeAdapter.createElement('documentmock', (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML, []);
        const parser = new this(opts, documentMock, fragmentContext);
        if (parser.fragmentContextID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE) parser.tmplInsertionModeStack.unshift($2f5582982d8cf3f4$var$InsertionMode.IN_TEMPLATE);
        parser._initTokenizerForFragmentParsing();
        parser._insertFakeRootElement();
        parser._resetInsertionMode();
        parser._findFormInFragmentContext();
        return parser;
    }
    getFragment() {
        const rootElement = this.treeAdapter.getFirstChild(this.document);
        const fragment = this.treeAdapter.createDocumentFragment();
        this._adoptNodes(rootElement, fragment);
        return fragment;
    }
    //Errors
    /** @internal */ _err(token, code, beforeToken) {
        var _a;
        if (!this.onParseError) return;
        const loc = (_a = token.location) !== null && _a !== void 0 ? _a : $2f5582982d8cf3f4$var$BASE_LOC;
        const err = {
            code: code,
            startLine: loc.startLine,
            startCol: loc.startCol,
            startOffset: loc.startOffset,
            endLine: beforeToken ? loc.startLine : loc.endLine,
            endCol: beforeToken ? loc.startCol : loc.endCol,
            endOffset: beforeToken ? loc.startOffset : loc.endOffset
        };
        this.onParseError(err);
    }
    //Stack events
    /** @internal */ onItemPush(node, tid, isTop) {
        var _a, _b;
        (_b = (_a = this.treeAdapter).onItemPush) === null || _b === void 0 || _b.call(_a, node);
        if (isTop && this.openElements.stackTop > 0) this._setContextModes(node, tid);
    }
    /** @internal */ onItemPop(node, isTop) {
        var _a, _b;
        if (this.options.sourceCodeLocationInfo) this._setEndLocation(node, this.currentToken);
        (_b = (_a = this.treeAdapter).onItemPop) === null || _b === void 0 || _b.call(_a, node, this.openElements.current);
        if (isTop) {
            let current;
            let currentTagId;
            if (this.openElements.stackTop === 0 && this.fragmentContext) {
                current = this.fragmentContext;
                currentTagId = this.fragmentContextID;
            } else ({ current: current, currentTagId: currentTagId } = this.openElements);
            this._setContextModes(current, currentTagId);
        }
    }
    _setContextModes(current, tid) {
        const isHTML = current === this.document || current && this.treeAdapter.getNamespaceURI(current) === (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML;
        this.currentNotInHTML = !isHTML;
        this.tokenizer.inForeignNode = !isHTML && current !== undefined && tid !== undefined && !this._isIntegrationPoint(tid, current);
    }
    /** @protected */ _switchToTextParsing(currentToken, nextTokenizerState) {
        this._insertElement(currentToken, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
        this.tokenizer.state = nextTokenizerState;
        this.originalInsertionMode = this.insertionMode;
        this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.TEXT;
    }
    switchToPlaintextParsing() {
        this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.TEXT;
        this.originalInsertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_BODY;
        this.tokenizer.state = (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).PLAINTEXT;
    }
    //Fragment parsing
    /** @protected */ _getAdjustedCurrentElement() {
        return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
    }
    /** @protected */ _findFormInFragmentContext() {
        let node = this.fragmentContext;
        while(node){
            if (this.treeAdapter.getTagName(node) === (0, $c2855a9ccb69df69$export$7e674a85a2656dce).FORM) {
                this.formElement = node;
                break;
            }
            node = this.treeAdapter.getParentNode(node);
        }
    }
    _initTokenizerForFragmentParsing() {
        if (!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML) return;
        switch(this.fragmentContextID){
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TITLE:
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEXTAREA:
                this.tokenizer.state = (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).RCDATA;
                break;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).STYLE:
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).XMP:
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).IFRAME:
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOEMBED:
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOFRAMES:
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOSCRIPT:
                this.tokenizer.state = (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).RAWTEXT;
                break;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SCRIPT:
                this.tokenizer.state = (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).SCRIPT_DATA;
                break;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).PLAINTEXT:
                this.tokenizer.state = (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).PLAINTEXT;
                break;
            default:
        }
    }
    //Tree mutation
    /** @protected */ _setDocumentType(token) {
        const name = token.name || '';
        const publicId = token.publicId || '';
        const systemId = token.systemId || '';
        this.treeAdapter.setDocumentType(this.document, name, publicId, systemId);
        if (token.location) {
            const documentChildren = this.treeAdapter.getChildNodes(this.document);
            const docTypeNode = documentChildren.find((node)=>this.treeAdapter.isDocumentTypeNode(node));
            if (docTypeNode) this.treeAdapter.setNodeSourceCodeLocation(docTypeNode, token.location);
        }
    }
    /** @protected */ _attachElementToTree(element, location) {
        if (this.options.sourceCodeLocationInfo) {
            const loc = location && {
                ...location,
                startTag: location
            };
            this.treeAdapter.setNodeSourceCodeLocation(element, loc);
        }
        if (this._shouldFosterParentOnInsertion()) this._fosterParentElement(element);
        else {
            const parent = this.openElements.currentTmplContentOrNode;
            this.treeAdapter.appendChild(parent !== null && parent !== void 0 ? parent : this.document, element);
        }
    }
    /**
     * For self-closing tags. Add an element to the tree, but skip adding it
     * to the stack.
     */ /** @protected */ _appendElement(token, namespaceURI) {
        const element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);
        this._attachElementToTree(element, token.location);
    }
    /** @protected */ _insertElement(token, namespaceURI) {
        const element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);
        this._attachElementToTree(element, token.location);
        this.openElements.push(element, token.tagID);
    }
    /** @protected */ _insertFakeElement(tagName, tagID) {
        const element = this.treeAdapter.createElement(tagName, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML, []);
        this._attachElementToTree(element, null);
        this.openElements.push(element, tagID);
    }
    /** @protected */ _insertTemplate(token) {
        const tmpl = this.treeAdapter.createElement(token.tagName, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML, token.attrs);
        const content = this.treeAdapter.createDocumentFragment();
        this.treeAdapter.setTemplateContent(tmpl, content);
        this._attachElementToTree(tmpl, token.location);
        this.openElements.push(tmpl, token.tagID);
        if (this.options.sourceCodeLocationInfo) this.treeAdapter.setNodeSourceCodeLocation(content, null);
    }
    /** @protected */ _insertFakeRootElement() {
        const element = this.treeAdapter.createElement((0, $c2855a9ccb69df69$export$7e674a85a2656dce).HTML, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML, []);
        if (this.options.sourceCodeLocationInfo) this.treeAdapter.setNodeSourceCodeLocation(element, null);
        this.treeAdapter.appendChild(this.openElements.current, element);
        this.openElements.push(element, (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML);
    }
    /** @protected */ _appendCommentNode(token, parent) {
        const commentNode = this.treeAdapter.createCommentNode(token.data);
        this.treeAdapter.appendChild(parent, commentNode);
        if (this.options.sourceCodeLocationInfo) this.treeAdapter.setNodeSourceCodeLocation(commentNode, token.location);
    }
    /** @protected */ _insertCharacters(token) {
        let parent;
        let beforeElement;
        if (this._shouldFosterParentOnInsertion()) {
            ({ parent: parent, beforeElement: beforeElement } = this._findFosterParentingLocation());
            if (beforeElement) this.treeAdapter.insertTextBefore(parent, token.chars, beforeElement);
            else this.treeAdapter.insertText(parent, token.chars);
        } else {
            parent = this.openElements.currentTmplContentOrNode;
            this.treeAdapter.insertText(parent, token.chars);
        }
        if (!token.location) return;
        const siblings = this.treeAdapter.getChildNodes(parent);
        const textNodeIdx = beforeElement ? siblings.lastIndexOf(beforeElement) : siblings.length;
        const textNode = siblings[textNodeIdx - 1];
        //NOTE: if we have a location assigned by another token, then just update the end position
        const tnLoc = this.treeAdapter.getNodeSourceCodeLocation(textNode);
        if (tnLoc) {
            const { endLine: endLine, endCol: endCol, endOffset: endOffset } = token.location;
            this.treeAdapter.updateNodeSourceCodeLocation(textNode, {
                endLine: endLine,
                endCol: endCol,
                endOffset: endOffset
            });
        } else if (this.options.sourceCodeLocationInfo) this.treeAdapter.setNodeSourceCodeLocation(textNode, token.location);
    }
    /** @protected */ _adoptNodes(donor, recipient) {
        for(let child = this.treeAdapter.getFirstChild(donor); child; child = this.treeAdapter.getFirstChild(donor)){
            this.treeAdapter.detachNode(child);
            this.treeAdapter.appendChild(recipient, child);
        }
    }
    /** @protected */ _setEndLocation(element, closingToken) {
        if (this.treeAdapter.getNodeSourceCodeLocation(element) && closingToken.location) {
            const ctLoc = closingToken.location;
            const tn = this.treeAdapter.getTagName(element);
            const endLoc = // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
            // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
            closingToken.type === (0, $be390ad8d330a451$export$f435f793048e7a0f).END_TAG && tn === closingToken.tagName ? {
                endTag: {
                    ...ctLoc
                },
                endLine: ctLoc.endLine,
                endCol: ctLoc.endCol,
                endOffset: ctLoc.endOffset
            } : {
                endLine: ctLoc.startLine,
                endCol: ctLoc.startCol,
                endOffset: ctLoc.startOffset
            };
            this.treeAdapter.updateNodeSourceCodeLocation(element, endLoc);
        }
    }
    //Token processing
    shouldProcessStartTagTokenInForeignContent(token) {
        // Check that neither current === document, or ns === NS.HTML
        if (!this.currentNotInHTML) return false;
        let current;
        let currentTagId;
        if (this.openElements.stackTop === 0 && this.fragmentContext) {
            current = this.fragmentContext;
            currentTagId = this.fragmentContextID;
        } else ({ current: current, currentTagId: currentTagId } = this.openElements);
        if (token.tagID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SVG && this.treeAdapter.getTagName(current) === (0, $c2855a9ccb69df69$export$7e674a85a2656dce).ANNOTATION_XML && this.treeAdapter.getNamespaceURI(current) === (0, $c2855a9ccb69df69$export$fb4028874a74450).MATHML) return false;
        return(// Check that `current` is not an integration point for HTML or MathML elements.
        this.tokenizer.inForeignNode || // If it _is_ an integration point, then we might have to check that it is not an HTML
        // integration point.
        (token.tagID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MGLYPH || token.tagID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MALIGNMARK) && currentTagId !== undefined && !this._isIntegrationPoint(currentTagId, current, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML));
    }
    /** @protected */ _processToken(token) {
        switch(token.type){
            case (0, $be390ad8d330a451$export$f435f793048e7a0f).CHARACTER:
                this.onCharacter(token);
                break;
            case (0, $be390ad8d330a451$export$f435f793048e7a0f).NULL_CHARACTER:
                this.onNullCharacter(token);
                break;
            case (0, $be390ad8d330a451$export$f435f793048e7a0f).COMMENT:
                this.onComment(token);
                break;
            case (0, $be390ad8d330a451$export$f435f793048e7a0f).DOCTYPE:
                this.onDoctype(token);
                break;
            case (0, $be390ad8d330a451$export$f435f793048e7a0f).START_TAG:
                this._processStartTag(token);
                break;
            case (0, $be390ad8d330a451$export$f435f793048e7a0f).END_TAG:
                this.onEndTag(token);
                break;
            case (0, $be390ad8d330a451$export$f435f793048e7a0f).EOF:
                this.onEof(token);
                break;
            case (0, $be390ad8d330a451$export$f435f793048e7a0f).WHITESPACE_CHARACTER:
                this.onWhitespaceCharacter(token);
                break;
        }
    }
    //Integration points
    /** @protected */ _isIntegrationPoint(tid, element, foreignNS) {
        const ns = this.treeAdapter.getNamespaceURI(element);
        const attrs = this.treeAdapter.getAttrList(element);
        return $488c212c7b5d6f42$export$6baf3ebfdd620e1(tid, ns, attrs, foreignNS);
    }
    //Active formatting elements reconstruction
    /** @protected */ _reconstructActiveFormattingElements() {
        const listLength = this.activeFormattingElements.entries.length;
        if (listLength) {
            const endIndex = this.activeFormattingElements.entries.findIndex((entry)=>entry.type === (0, $e595487314683422$export$e41c32906b33062a).Marker || this.openElements.contains(entry.element));
            const unopenIdx = endIndex === -1 ? listLength - 1 : endIndex - 1;
            for(let i = unopenIdx; i >= 0; i--){
                const entry = this.activeFormattingElements.entries[i];
                this._insertElement(entry.token, this.treeAdapter.getNamespaceURI(entry.element));
                entry.element = this.openElements.current;
            }
        }
    }
    //Close elements
    /** @protected */ _closeTableCell() {
        this.openElements.generateImpliedEndTags();
        this.openElements.popUntilTableCellPopped();
        this.activeFormattingElements.clearToLastMarker();
        this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_ROW;
    }
    /** @protected */ _closePElement() {
        this.openElements.generateImpliedEndTagsWithExclusion((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P);
        this.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P);
    }
    //Insertion modes
    /** @protected */ _resetInsertionMode() {
        for(let i = this.openElements.stackTop; i >= 0; i--)//Insertion mode reset map
        switch(i === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[i]){
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR:
                this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_ROW;
                return;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY:
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD:
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT:
                this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY;
                return;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION:
                this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_CAPTION;
                return;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP:
                this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_COLUMN_GROUP;
                return;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE:
                this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE;
                return;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY:
                this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_BODY;
                return;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FRAMESET:
                this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_FRAMESET;
                return;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SELECT:
                this._resetInsertionModeForSelect(i);
                return;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
                this.insertionMode = this.tmplInsertionModeStack[0];
                return;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
                this.insertionMode = this.headElement ? $2f5582982d8cf3f4$var$InsertionMode.AFTER_HEAD : $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HEAD;
                return;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD:
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH:
                if (i > 0) {
                    this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_CELL;
                    return;
                }
                break;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEAD:
                if (i > 0) {
                    this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD;
                    return;
                }
                break;
        }
        this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_BODY;
    }
    /** @protected */ _resetInsertionModeForSelect(selectIdx) {
        if (selectIdx > 0) for(let i = selectIdx - 1; i > 0; i--){
            const tn = this.openElements.tagIDs[i];
            if (tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE) break;
            else if (tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE) {
                this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT_IN_TABLE;
                return;
            }
        }
        this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT;
    }
    //Foster parenting
    /** @protected */ _isElementCausesFosterParenting(tn) {
        return $2f5582982d8cf3f4$var$TABLE_STRUCTURE_TAGS.has(tn);
    }
    /** @protected */ _shouldFosterParentOnInsertion() {
        return this.fosterParentingEnabled && this.openElements.currentTagId !== undefined && this._isElementCausesFosterParenting(this.openElements.currentTagId);
    }
    /** @protected */ _findFosterParentingLocation() {
        for(let i = this.openElements.stackTop; i >= 0; i--){
            const openElement = this.openElements.items[i];
            switch(this.openElements.tagIDs[i]){
                case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
                    if (this.treeAdapter.getNamespaceURI(openElement) === (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML) return {
                        parent: this.treeAdapter.getTemplateContent(openElement),
                        beforeElement: null
                    };
                    break;
                case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE:
                    {
                        const parent = this.treeAdapter.getParentNode(openElement);
                        if (parent) return {
                            parent: parent,
                            beforeElement: openElement
                        };
                        return {
                            parent: this.openElements.items[i - 1],
                            beforeElement: null
                        };
                    }
                default:
            }
        }
        return {
            parent: this.openElements.items[0],
            beforeElement: null
        };
    }
    /** @protected */ _fosterParentElement(element) {
        const location = this._findFosterParentingLocation();
        if (location.beforeElement) this.treeAdapter.insertBefore(location.parent, element, location.beforeElement);
        else this.treeAdapter.appendChild(location.parent, element);
    }
    //Special elements
    /** @protected */ _isSpecialElement(element, id) {
        const ns = this.treeAdapter.getNamespaceURI(element);
        return (0, $c2855a9ccb69df69$export$7e5172336f7d2bbb)[ns].has(id);
    }
    /** @internal */ onCharacter(token) {
        this.skipNextNewLine = false;
        if (this.tokenizer.inForeignNode) {
            $2f5582982d8cf3f4$var$characterInForeignContent(this, token);
            return;
        }
        switch(this.insertionMode){
            case $2f5582982d8cf3f4$var$InsertionMode.INITIAL:
                $2f5582982d8cf3f4$var$tokenInInitialMode(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HTML:
                $2f5582982d8cf3f4$var$tokenBeforeHtml(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HEAD:
                $2f5582982d8cf3f4$var$tokenBeforeHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD:
                $2f5582982d8cf3f4$var$tokenInHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD_NO_SCRIPT:
                $2f5582982d8cf3f4$var$tokenInHeadNoScript(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_HEAD:
                $2f5582982d8cf3f4$var$tokenAfterHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_CAPTION:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_CELL:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TEMPLATE:
                $2f5582982d8cf3f4$var$characterInBody(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.TEXT:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT_IN_TABLE:
                this._insertCharacters(token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_ROW:
                $2f5582982d8cf3f4$var$characterInTable(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_TEXT:
                $2f5582982d8cf3f4$var$characterInTableText(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_COLUMN_GROUP:
                $2f5582982d8cf3f4$var$tokenInColumnGroup(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_BODY:
                $2f5582982d8cf3f4$var$tokenAfterBody(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_AFTER_BODY:
                $2f5582982d8cf3f4$var$tokenAfterAfterBody(this, token);
                break;
            default:
        }
    }
    /** @internal */ onNullCharacter(token) {
        this.skipNextNewLine = false;
        if (this.tokenizer.inForeignNode) {
            $2f5582982d8cf3f4$var$nullCharacterInForeignContent(this, token);
            return;
        }
        switch(this.insertionMode){
            case $2f5582982d8cf3f4$var$InsertionMode.INITIAL:
                $2f5582982d8cf3f4$var$tokenInInitialMode(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HTML:
                $2f5582982d8cf3f4$var$tokenBeforeHtml(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HEAD:
                $2f5582982d8cf3f4$var$tokenBeforeHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD:
                $2f5582982d8cf3f4$var$tokenInHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD_NO_SCRIPT:
                $2f5582982d8cf3f4$var$tokenInHeadNoScript(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_HEAD:
                $2f5582982d8cf3f4$var$tokenAfterHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.TEXT:
                this._insertCharacters(token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_ROW:
                $2f5582982d8cf3f4$var$characterInTable(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_COLUMN_GROUP:
                $2f5582982d8cf3f4$var$tokenInColumnGroup(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_BODY:
                $2f5582982d8cf3f4$var$tokenAfterBody(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_AFTER_BODY:
                $2f5582982d8cf3f4$var$tokenAfterAfterBody(this, token);
                break;
            default:
        }
    }
    /** @internal */ onComment(token) {
        this.skipNextNewLine = false;
        if (this.currentNotInHTML) {
            $2f5582982d8cf3f4$var$appendComment(this, token);
            return;
        }
        switch(this.insertionMode){
            case $2f5582982d8cf3f4$var$InsertionMode.INITIAL:
            case $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HTML:
            case $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HEAD:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD_NO_SCRIPT:
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_HEAD:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_CAPTION:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_COLUMN_GROUP:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_ROW:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_CELL:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT_IN_TABLE:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TEMPLATE:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_FRAMESET:
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_FRAMESET:
                $2f5582982d8cf3f4$var$appendComment(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_TEXT:
                $2f5582982d8cf3f4$var$tokenInTableText(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_BODY:
                $2f5582982d8cf3f4$var$appendCommentToRootHtmlElement(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_AFTER_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_AFTER_FRAMESET:
                $2f5582982d8cf3f4$var$appendCommentToDocument(this, token);
                break;
            default:
        }
    }
    /** @internal */ onDoctype(token) {
        this.skipNextNewLine = false;
        switch(this.insertionMode){
            case $2f5582982d8cf3f4$var$InsertionMode.INITIAL:
                $2f5582982d8cf3f4$var$doctypeInInitialMode(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HEAD:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD_NO_SCRIPT:
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_HEAD:
                this._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).misplacedDoctype);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_TEXT:
                $2f5582982d8cf3f4$var$tokenInTableText(this, token);
                break;
            default:
        }
    }
    /** @internal */ onStartTag(token) {
        this.skipNextNewLine = false;
        this.currentToken = token;
        this._processStartTag(token);
        if (token.selfClosing && !token.ackSelfClosing) this._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).nonVoidHtmlElementStartTagWithTrailingSolidus);
    }
    /**
     * Processes a given start tag.
     *
     * `onStartTag` checks if a self-closing tag was recognized. When a token
     * is moved inbetween multiple insertion modes, this check for self-closing
     * could lead to false positives. To avoid this, `_processStartTag` is used
     * for nested calls.
     *
     * @param token The token to process.
     * @protected
     */ _processStartTag(token) {
        if (this.shouldProcessStartTagTokenInForeignContent(token)) $2f5582982d8cf3f4$var$startTagInForeignContent(this, token);
        else this._startTagOutsideForeignContent(token);
    }
    /** @protected */ _startTagOutsideForeignContent(token) {
        switch(this.insertionMode){
            case $2f5582982d8cf3f4$var$InsertionMode.INITIAL:
                $2f5582982d8cf3f4$var$tokenInInitialMode(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HTML:
                $2f5582982d8cf3f4$var$startTagBeforeHtml(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HEAD:
                $2f5582982d8cf3f4$var$startTagBeforeHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD:
                $2f5582982d8cf3f4$var$startTagInHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD_NO_SCRIPT:
                $2f5582982d8cf3f4$var$startTagInHeadNoScript(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_HEAD:
                $2f5582982d8cf3f4$var$startTagAfterHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_BODY:
                $2f5582982d8cf3f4$var$startTagInBody(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE:
                $2f5582982d8cf3f4$var$startTagInTable(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_TEXT:
                $2f5582982d8cf3f4$var$tokenInTableText(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_CAPTION:
                $2f5582982d8cf3f4$var$startTagInCaption(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_COLUMN_GROUP:
                $2f5582982d8cf3f4$var$startTagInColumnGroup(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY:
                $2f5582982d8cf3f4$var$startTagInTableBody(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_ROW:
                $2f5582982d8cf3f4$var$startTagInRow(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_CELL:
                $2f5582982d8cf3f4$var$startTagInCell(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT:
                $2f5582982d8cf3f4$var$startTagInSelect(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT_IN_TABLE:
                $2f5582982d8cf3f4$var$startTagInSelectInTable(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TEMPLATE:
                $2f5582982d8cf3f4$var$startTagInTemplate(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_BODY:
                $2f5582982d8cf3f4$var$startTagAfterBody(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_FRAMESET:
                $2f5582982d8cf3f4$var$startTagInFrameset(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_FRAMESET:
                $2f5582982d8cf3f4$var$startTagAfterFrameset(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_AFTER_BODY:
                $2f5582982d8cf3f4$var$startTagAfterAfterBody(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_AFTER_FRAMESET:
                $2f5582982d8cf3f4$var$startTagAfterAfterFrameset(this, token);
                break;
            default:
        }
    }
    /** @internal */ onEndTag(token) {
        this.skipNextNewLine = false;
        this.currentToken = token;
        if (this.currentNotInHTML) $2f5582982d8cf3f4$var$endTagInForeignContent(this, token);
        else this._endTagOutsideForeignContent(token);
    }
    /** @protected */ _endTagOutsideForeignContent(token) {
        switch(this.insertionMode){
            case $2f5582982d8cf3f4$var$InsertionMode.INITIAL:
                $2f5582982d8cf3f4$var$tokenInInitialMode(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HTML:
                $2f5582982d8cf3f4$var$endTagBeforeHtml(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HEAD:
                $2f5582982d8cf3f4$var$endTagBeforeHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD:
                $2f5582982d8cf3f4$var$endTagInHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD_NO_SCRIPT:
                $2f5582982d8cf3f4$var$endTagInHeadNoScript(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_HEAD:
                $2f5582982d8cf3f4$var$endTagAfterHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_BODY:
                $2f5582982d8cf3f4$var$endTagInBody(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.TEXT:
                $2f5582982d8cf3f4$var$endTagInText(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE:
                $2f5582982d8cf3f4$var$endTagInTable(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_TEXT:
                $2f5582982d8cf3f4$var$tokenInTableText(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_CAPTION:
                $2f5582982d8cf3f4$var$endTagInCaption(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_COLUMN_GROUP:
                $2f5582982d8cf3f4$var$endTagInColumnGroup(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY:
                $2f5582982d8cf3f4$var$endTagInTableBody(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_ROW:
                $2f5582982d8cf3f4$var$endTagInRow(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_CELL:
                $2f5582982d8cf3f4$var$endTagInCell(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT:
                $2f5582982d8cf3f4$var$endTagInSelect(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT_IN_TABLE:
                $2f5582982d8cf3f4$var$endTagInSelectInTable(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TEMPLATE:
                $2f5582982d8cf3f4$var$endTagInTemplate(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_BODY:
                $2f5582982d8cf3f4$var$endTagAfterBody(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_FRAMESET:
                $2f5582982d8cf3f4$var$endTagInFrameset(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_FRAMESET:
                $2f5582982d8cf3f4$var$endTagAfterFrameset(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_AFTER_BODY:
                $2f5582982d8cf3f4$var$tokenAfterAfterBody(this, token);
                break;
            default:
        }
    }
    /** @internal */ onEof(token) {
        switch(this.insertionMode){
            case $2f5582982d8cf3f4$var$InsertionMode.INITIAL:
                $2f5582982d8cf3f4$var$tokenInInitialMode(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HTML:
                $2f5582982d8cf3f4$var$tokenBeforeHtml(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HEAD:
                $2f5582982d8cf3f4$var$tokenBeforeHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD:
                $2f5582982d8cf3f4$var$tokenInHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD_NO_SCRIPT:
                $2f5582982d8cf3f4$var$tokenInHeadNoScript(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_HEAD:
                $2f5582982d8cf3f4$var$tokenAfterHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_CAPTION:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_COLUMN_GROUP:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_ROW:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_CELL:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT_IN_TABLE:
                $2f5582982d8cf3f4$var$eofInBody(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.TEXT:
                $2f5582982d8cf3f4$var$eofInText(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_TEXT:
                $2f5582982d8cf3f4$var$tokenInTableText(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TEMPLATE:
                $2f5582982d8cf3f4$var$eofInTemplate(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_FRAMESET:
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_FRAMESET:
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_AFTER_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_AFTER_FRAMESET:
                $2f5582982d8cf3f4$var$stopParsing(this, token);
                break;
            default:
        }
    }
    /** @internal */ onWhitespaceCharacter(token) {
        if (this.skipNextNewLine) {
            this.skipNextNewLine = false;
            if (token.chars.charCodeAt(0) === $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0.LINE_FEED) {
                if (token.chars.length === 1) return;
                token.chars = token.chars.substr(1);
            }
        }
        if (this.tokenizer.inForeignNode) {
            this._insertCharacters(token);
            return;
        }
        switch(this.insertionMode){
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD_NO_SCRIPT:
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_HEAD:
            case $2f5582982d8cf3f4$var$InsertionMode.TEXT:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_COLUMN_GROUP:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT_IN_TABLE:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_FRAMESET:
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_FRAMESET:
                this._insertCharacters(token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_CAPTION:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_CELL:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TEMPLATE:
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_AFTER_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_AFTER_FRAMESET:
                $2f5582982d8cf3f4$var$whitespaceCharacterInBody(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_ROW:
                $2f5582982d8cf3f4$var$characterInTable(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_TEXT:
                $2f5582982d8cf3f4$var$whitespaceCharacterInTableText(this, token);
                break;
            default:
        }
    }
}
//Adoption agency algorithm
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/tree-construction.html#adoptionAgency)
//------------------------------------------------------------------
//Steps 5-8 of the algorithm
function $2f5582982d8cf3f4$var$aaObtainFormattingElementEntry(p, token) {
    let formattingElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName(token.tagName);
    if (formattingElementEntry) {
        if (!p.openElements.contains(formattingElementEntry.element)) {
            p.activeFormattingElements.removeEntry(formattingElementEntry);
            formattingElementEntry = null;
        } else if (!p.openElements.hasInScope(token.tagID)) formattingElementEntry = null;
    } else $2f5582982d8cf3f4$var$genericEndTagInBody(p, token);
    return formattingElementEntry;
}
//Steps 9 and 10 of the algorithm
function $2f5582982d8cf3f4$var$aaObtainFurthestBlock(p, formattingElementEntry) {
    let furthestBlock = null;
    let idx = p.openElements.stackTop;
    for(; idx >= 0; idx--){
        const element = p.openElements.items[idx];
        if (element === formattingElementEntry.element) break;
        if (p._isSpecialElement(element, p.openElements.tagIDs[idx])) furthestBlock = element;
    }
    if (!furthestBlock) {
        p.openElements.shortenToLength(Math.max(idx, 0));
        p.activeFormattingElements.removeEntry(formattingElementEntry);
    }
    return furthestBlock;
}
//Step 13 of the algorithm
function $2f5582982d8cf3f4$var$aaInnerLoop(p, furthestBlock, formattingElement) {
    let lastElement = furthestBlock;
    let nextElement = p.openElements.getCommonAncestor(furthestBlock);
    for(let i = 0, element = nextElement; element !== formattingElement; i++, element = nextElement){
        //NOTE: store the next element for the next loop iteration (it may be deleted from the stack by step 9.5)
        nextElement = p.openElements.getCommonAncestor(element);
        const elementEntry = p.activeFormattingElements.getElementEntry(element);
        const counterOverflow = elementEntry && i >= $2f5582982d8cf3f4$var$AA_INNER_LOOP_ITER;
        const shouldRemoveFromOpenElements = !elementEntry || counterOverflow;
        if (shouldRemoveFromOpenElements) {
            if (counterOverflow) p.activeFormattingElements.removeEntry(elementEntry);
            p.openElements.remove(element);
        } else {
            element = $2f5582982d8cf3f4$var$aaRecreateElementFromEntry(p, elementEntry);
            if (lastElement === furthestBlock) p.activeFormattingElements.bookmark = elementEntry;
            p.treeAdapter.detachNode(lastElement);
            p.treeAdapter.appendChild(element, lastElement);
            lastElement = element;
        }
    }
    return lastElement;
}
//Step 13.7 of the algorithm
function $2f5582982d8cf3f4$var$aaRecreateElementFromEntry(p, elementEntry) {
    const ns = p.treeAdapter.getNamespaceURI(elementEntry.element);
    const newElement = p.treeAdapter.createElement(elementEntry.token.tagName, ns, elementEntry.token.attrs);
    p.openElements.replace(elementEntry.element, newElement);
    elementEntry.element = newElement;
    return newElement;
}
//Step 14 of the algorithm
function $2f5582982d8cf3f4$var$aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement) {
    const tn = p.treeAdapter.getTagName(commonAncestor);
    const tid = (0, $c2855a9ccb69df69$export$39db8a1315f68282)(tn);
    if (p._isElementCausesFosterParenting(tid)) p._fosterParentElement(lastElement);
    else {
        const ns = p.treeAdapter.getNamespaceURI(commonAncestor);
        if (tid === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE && ns === (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML) commonAncestor = p.treeAdapter.getTemplateContent(commonAncestor);
        p.treeAdapter.appendChild(commonAncestor, lastElement);
    }
}
//Steps 15-19 of the algorithm
function $2f5582982d8cf3f4$var$aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry) {
    const ns = p.treeAdapter.getNamespaceURI(formattingElementEntry.element);
    const { token: token } = formattingElementEntry;
    const newElement = p.treeAdapter.createElement(token.tagName, ns, token.attrs);
    p._adoptNodes(furthestBlock, newElement);
    p.treeAdapter.appendChild(furthestBlock, newElement);
    p.activeFormattingElements.insertElementAfterBookmark(newElement, token);
    p.activeFormattingElements.removeEntry(formattingElementEntry);
    p.openElements.remove(formattingElementEntry.element);
    p.openElements.insertAfter(furthestBlock, newElement, token.tagID);
}
//Algorithm entry point
function $2f5582982d8cf3f4$var$callAdoptionAgency(p, token) {
    for(let i = 0; i < $2f5582982d8cf3f4$var$AA_OUTER_LOOP_ITER; i++){
        const formattingElementEntry = $2f5582982d8cf3f4$var$aaObtainFormattingElementEntry(p, token);
        if (!formattingElementEntry) break;
        const furthestBlock = $2f5582982d8cf3f4$var$aaObtainFurthestBlock(p, formattingElementEntry);
        if (!furthestBlock) break;
        p.activeFormattingElements.bookmark = formattingElementEntry;
        const lastElement = $2f5582982d8cf3f4$var$aaInnerLoop(p, furthestBlock, formattingElementEntry.element);
        const commonAncestor = p.openElements.getCommonAncestor(formattingElementEntry.element);
        p.treeAdapter.detachNode(lastElement);
        if (commonAncestor) $2f5582982d8cf3f4$var$aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement);
        $2f5582982d8cf3f4$var$aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry);
    }
}
//Generic token handlers
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$appendComment(p, token) {
    p._appendCommentNode(token, p.openElements.currentTmplContentOrNode);
}
function $2f5582982d8cf3f4$var$appendCommentToRootHtmlElement(p, token) {
    p._appendCommentNode(token, p.openElements.items[0]);
}
function $2f5582982d8cf3f4$var$appendCommentToDocument(p, token) {
    p._appendCommentNode(token, p.document);
}
function $2f5582982d8cf3f4$var$stopParsing(p, token) {
    p.stopped = true;
    // NOTE: Set end locations for elements that remain on the open element stack.
    if (token.location) {
        // NOTE: If we are not in a fragment, `html` and `body` will stay on the stack.
        // This is a problem, as we might overwrite their end position here.
        const target = p.fragmentContext ? 0 : 2;
        for(let i = p.openElements.stackTop; i >= target; i--)p._setEndLocation(p.openElements.items[i], token);
        // Handle `html` and `body`
        if (!p.fragmentContext && p.openElements.stackTop >= 0) {
            const htmlElement = p.openElements.items[0];
            const htmlLocation = p.treeAdapter.getNodeSourceCodeLocation(htmlElement);
            if (htmlLocation && !htmlLocation.endTag) {
                p._setEndLocation(htmlElement, token);
                if (p.openElements.stackTop >= 1) {
                    const bodyElement = p.openElements.items[1];
                    const bodyLocation = p.treeAdapter.getNodeSourceCodeLocation(bodyElement);
                    if (bodyLocation && !bodyLocation.endTag) p._setEndLocation(bodyElement, token);
                }
            }
        }
    }
}
// The "initial" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$doctypeInInitialMode(p, token) {
    p._setDocumentType(token);
    const mode = token.forceQuirks ? (0, $c2855a9ccb69df69$export$a74d46c85337d29a).QUIRKS : $32b34f4d04b90291$export$64782beacef87b30(token);
    if (!$32b34f4d04b90291$export$ee48152ecc0e3f40(token)) p._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).nonConformingDoctype);
    p.treeAdapter.setDocumentMode(p.document, mode);
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HTML;
}
function $2f5582982d8cf3f4$var$tokenInInitialMode(p, token) {
    p._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingDoctype, true);
    p.treeAdapter.setDocumentMode(p.document, (0, $c2855a9ccb69df69$export$a74d46c85337d29a).QUIRKS);
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HTML;
    p._processToken(token);
}
// The "before html" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagBeforeHtml(p, token) {
    if (token.tagID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML) {
        p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
        p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HEAD;
    } else $2f5582982d8cf3f4$var$tokenBeforeHtml(p, token);
}
function $2f5582982d8cf3f4$var$endTagBeforeHtml(p, token) {
    const tn = token.tagID;
    if (tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEAD || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BR) $2f5582982d8cf3f4$var$tokenBeforeHtml(p, token);
}
function $2f5582982d8cf3f4$var$tokenBeforeHtml(p, token) {
    p._insertFakeRootElement();
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HEAD;
    p._processToken(token);
}
// The "before head" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagBeforeHead(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
            $2f5582982d8cf3f4$var$startTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEAD:
            p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
            p.headElement = p.openElements.current;
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD;
            break;
        default:
            $2f5582982d8cf3f4$var$tokenBeforeHead(p, token);
    }
}
function $2f5582982d8cf3f4$var$endTagBeforeHead(p, token) {
    const tn = token.tagID;
    if (tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEAD || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BR) $2f5582982d8cf3f4$var$tokenBeforeHead(p, token);
    else p._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).endTagWithoutMatchingOpenElement);
}
function $2f5582982d8cf3f4$var$tokenBeforeHead(p, token) {
    p._insertFakeElement((0, $c2855a9ccb69df69$export$7e674a85a2656dce).HEAD, (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEAD);
    p.headElement = p.openElements.current;
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD;
    p._processToken(token);
}
// The "in head" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagInHead(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
            $2f5582982d8cf3f4$var$startTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BASE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BASEFONT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BGSOUND:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LINK:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).META:
            p._appendElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
            token.ackSelfClosing = true;
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TITLE:
            p._switchToTextParsing(token, (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).RCDATA);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOSCRIPT:
            if (p.options.scriptingEnabled) p._switchToTextParsing(token, (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).RAWTEXT);
            else {
                p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
                p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD_NO_SCRIPT;
            }
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOFRAMES:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).STYLE:
            p._switchToTextParsing(token, (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).RAWTEXT);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SCRIPT:
            p._switchToTextParsing(token, (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).SCRIPT_DATA);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
            p._insertTemplate(token);
            p.activeFormattingElements.insertMarker();
            p.framesetOk = false;
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TEMPLATE;
            p.tmplInsertionModeStack.unshift($2f5582982d8cf3f4$var$InsertionMode.IN_TEMPLATE);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEAD:
            p._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).misplacedStartTagForHeadElement);
            break;
        default:
            $2f5582982d8cf3f4$var$tokenInHead(p, token);
    }
}
function $2f5582982d8cf3f4$var$endTagInHead(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEAD:
            p.openElements.pop();
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.AFTER_HEAD;
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BR:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
            $2f5582982d8cf3f4$var$tokenInHead(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
            $2f5582982d8cf3f4$var$templateEndTagInHead(p, token);
            break;
        default:
            p._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).endTagWithoutMatchingOpenElement);
    }
}
function $2f5582982d8cf3f4$var$templateEndTagInHead(p, token) {
    if (p.openElements.tmplCount > 0) {
        p.openElements.generateImpliedEndTagsThoroughly();
        if (p.openElements.currentTagId !== (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE) p._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).closingOfElementWithOpenChildElements);
        p.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE);
        p.activeFormattingElements.clearToLastMarker();
        p.tmplInsertionModeStack.shift();
        p._resetInsertionMode();
    } else p._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).endTagWithoutMatchingOpenElement);
}
function $2f5582982d8cf3f4$var$tokenInHead(p, token) {
    p.openElements.pop();
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.AFTER_HEAD;
    p._processToken(token);
}
// The "in head no script" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagInHeadNoScript(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
            $2f5582982d8cf3f4$var$startTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BASEFONT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BGSOUND:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEAD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LINK:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).META:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOFRAMES:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).STYLE:
            $2f5582982d8cf3f4$var$startTagInHead(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOSCRIPT:
            p._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).nestedNoscriptInHead);
            break;
        default:
            $2f5582982d8cf3f4$var$tokenInHeadNoScript(p, token);
    }
}
function $2f5582982d8cf3f4$var$endTagInHeadNoScript(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOSCRIPT:
            p.openElements.pop();
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD;
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BR:
            $2f5582982d8cf3f4$var$tokenInHeadNoScript(p, token);
            break;
        default:
            p._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).endTagWithoutMatchingOpenElement);
    }
}
function $2f5582982d8cf3f4$var$tokenInHeadNoScript(p, token) {
    const errCode = token.type === (0, $be390ad8d330a451$export$f435f793048e7a0f).EOF ? (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).openElementsLeftAfterEof : (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).disallowedContentInNoscriptInHead;
    p._err(token, errCode);
    p.openElements.pop();
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD;
    p._processToken(token);
}
// The "after head" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagAfterHead(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
            $2f5582982d8cf3f4$var$startTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY:
            p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
            p.framesetOk = false;
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_BODY;
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FRAMESET:
            p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_FRAMESET;
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BASE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BASEFONT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BGSOUND:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LINK:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).META:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOFRAMES:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SCRIPT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).STYLE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TITLE:
            p._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).abandonedHeadElementChild);
            p.openElements.push(p.headElement, (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEAD);
            $2f5582982d8cf3f4$var$startTagInHead(p, token);
            p.openElements.remove(p.headElement);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEAD:
            p._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).misplacedStartTagForHeadElement);
            break;
        default:
            $2f5582982d8cf3f4$var$tokenAfterHead(p, token);
    }
}
function $2f5582982d8cf3f4$var$endTagAfterHead(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BR:
            $2f5582982d8cf3f4$var$tokenAfterHead(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
            $2f5582982d8cf3f4$var$templateEndTagInHead(p, token);
            break;
        default:
            p._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).endTagWithoutMatchingOpenElement);
    }
}
function $2f5582982d8cf3f4$var$tokenAfterHead(p, token) {
    p._insertFakeElement((0, $c2855a9ccb69df69$export$7e674a85a2656dce).BODY, (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY);
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_BODY;
    $2f5582982d8cf3f4$var$modeInBody(p, token);
}
// The "in body" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$modeInBody(p, token) {
    switch(token.type){
        case (0, $be390ad8d330a451$export$f435f793048e7a0f).CHARACTER:
            $2f5582982d8cf3f4$var$characterInBody(p, token);
            break;
        case (0, $be390ad8d330a451$export$f435f793048e7a0f).WHITESPACE_CHARACTER:
            $2f5582982d8cf3f4$var$whitespaceCharacterInBody(p, token);
            break;
        case (0, $be390ad8d330a451$export$f435f793048e7a0f).COMMENT:
            $2f5582982d8cf3f4$var$appendComment(p, token);
            break;
        case (0, $be390ad8d330a451$export$f435f793048e7a0f).START_TAG:
            $2f5582982d8cf3f4$var$startTagInBody(p, token);
            break;
        case (0, $be390ad8d330a451$export$f435f793048e7a0f).END_TAG:
            $2f5582982d8cf3f4$var$endTagInBody(p, token);
            break;
        case (0, $be390ad8d330a451$export$f435f793048e7a0f).EOF:
            $2f5582982d8cf3f4$var$eofInBody(p, token);
            break;
        default:
    }
}
function $2f5582982d8cf3f4$var$whitespaceCharacterInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertCharacters(token);
}
function $2f5582982d8cf3f4$var$characterInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertCharacters(token);
    p.framesetOk = false;
}
function $2f5582982d8cf3f4$var$htmlStartTagInBody(p, token) {
    if (p.openElements.tmplCount === 0) p.treeAdapter.adoptAttributes(p.openElements.items[0], token.attrs);
}
function $2f5582982d8cf3f4$var$bodyStartTagInBody(p, token) {
    const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
    if (bodyElement && p.openElements.tmplCount === 0) {
        p.framesetOk = false;
        p.treeAdapter.adoptAttributes(bodyElement, token.attrs);
    }
}
function $2f5582982d8cf3f4$var$framesetStartTagInBody(p, token) {
    const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
    if (p.framesetOk && bodyElement) {
        p.treeAdapter.detachNode(bodyElement);
        p.openElements.popAllUpToHtmlElement();
        p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
        p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_FRAMESET;
    }
}
function $2f5582982d8cf3f4$var$addressStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P)) p._closePElement();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
}
function $2f5582982d8cf3f4$var$numberedHeaderStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P)) p._closePElement();
    if (p.openElements.currentTagId !== undefined && (0, $c2855a9ccb69df69$export$1ecc20fa0754c045).has(p.openElements.currentTagId)) p.openElements.pop();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
}
function $2f5582982d8cf3f4$var$preStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P)) p._closePElement();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
    //on to the next one. (Newlines at the start of pre blocks are ignored as an authoring convenience.)
    p.skipNextNewLine = true;
    p.framesetOk = false;
}
function $2f5582982d8cf3f4$var$formStartTagInBody(p, token) {
    const inTemplate = p.openElements.tmplCount > 0;
    if (!p.formElement || inTemplate) {
        if (p.openElements.hasInButtonScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P)) p._closePElement();
        p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
        if (!inTemplate) p.formElement = p.openElements.current;
    }
}
function $2f5582982d8cf3f4$var$listItemStartTagInBody(p, token) {
    p.framesetOk = false;
    const tn = token.tagID;
    for(let i = p.openElements.stackTop; i >= 0; i--){
        const elementId = p.openElements.tagIDs[i];
        if (tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LI && elementId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LI || (tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DD || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DT) && (elementId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DD || elementId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DT)) {
            p.openElements.generateImpliedEndTagsWithExclusion(elementId);
            p.openElements.popUntilTagNamePopped(elementId);
            break;
        }
        if (elementId !== (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).ADDRESS && elementId !== (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DIV && elementId !== (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P && p._isSpecialElement(p.openElements.items[i], elementId)) break;
    }
    if (p.openElements.hasInButtonScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P)) p._closePElement();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
}
function $2f5582982d8cf3f4$var$plaintextStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P)) p._closePElement();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    p.tokenizer.state = (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).PLAINTEXT;
}
function $2f5582982d8cf3f4$var$buttonStartTagInBody(p, token) {
    if (p.openElements.hasInScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BUTTON)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BUTTON);
    }
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    p.framesetOk = false;
}
function $2f5582982d8cf3f4$var$aStartTagInBody(p, token) {
    const activeElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName((0, $c2855a9ccb69df69$export$7e674a85a2656dce).A);
    if (activeElementEntry) {
        $2f5582982d8cf3f4$var$callAdoptionAgency(p, token);
        p.openElements.remove(activeElementEntry.element);
        p.activeFormattingElements.removeEntry(activeElementEntry);
    }
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}
function $2f5582982d8cf3f4$var$bStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}
function $2f5582982d8cf3f4$var$nobrStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    if (p.openElements.hasInScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOBR)) {
        $2f5582982d8cf3f4$var$callAdoptionAgency(p, token);
        p._reconstructActiveFormattingElements();
    }
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}
function $2f5582982d8cf3f4$var$appletStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    p.activeFormattingElements.insertMarker();
    p.framesetOk = false;
}
function $2f5582982d8cf3f4$var$tableStartTagInBody(p, token) {
    if (p.treeAdapter.getDocumentMode(p.document) !== (0, $c2855a9ccb69df69$export$a74d46c85337d29a).QUIRKS && p.openElements.hasInButtonScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P)) p._closePElement();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    p.framesetOk = false;
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE;
}
function $2f5582982d8cf3f4$var$areaStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._appendElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    p.framesetOk = false;
    token.ackSelfClosing = true;
}
function $2f5582982d8cf3f4$var$isHiddenInput(token) {
    const inputType = (0, $be390ad8d330a451$export$df33bba014b5841e)(token, (0, $c2855a9ccb69df69$export$380b7bc9e6cb1918).TYPE);
    return inputType != null && inputType.toLowerCase() === $2f5582982d8cf3f4$var$HIDDEN_INPUT_TYPE;
}
function $2f5582982d8cf3f4$var$inputStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._appendElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    if (!$2f5582982d8cf3f4$var$isHiddenInput(token)) p.framesetOk = false;
    token.ackSelfClosing = true;
}
function $2f5582982d8cf3f4$var$paramStartTagInBody(p, token) {
    p._appendElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    token.ackSelfClosing = true;
}
function $2f5582982d8cf3f4$var$hrStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P)) p._closePElement();
    p._appendElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    p.framesetOk = false;
    token.ackSelfClosing = true;
}
function $2f5582982d8cf3f4$var$imageStartTagInBody(p, token) {
    token.tagName = (0, $c2855a9ccb69df69$export$7e674a85a2656dce).IMG;
    token.tagID = (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).IMG;
    $2f5582982d8cf3f4$var$areaStartTagInBody(p, token);
}
function $2f5582982d8cf3f4$var$textareaStartTagInBody(p, token) {
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
    //on to the next one. (Newlines at the start of textarea elements are ignored as an authoring convenience.)
    p.skipNextNewLine = true;
    p.tokenizer.state = (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).RCDATA;
    p.originalInsertionMode = p.insertionMode;
    p.framesetOk = false;
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.TEXT;
}
function $2f5582982d8cf3f4$var$xmpStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P)) p._closePElement();
    p._reconstructActiveFormattingElements();
    p.framesetOk = false;
    p._switchToTextParsing(token, (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).RAWTEXT);
}
function $2f5582982d8cf3f4$var$iframeStartTagInBody(p, token) {
    p.framesetOk = false;
    p._switchToTextParsing(token, (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).RAWTEXT);
}
//NOTE: here we assume that we always act as a user agent with enabled plugins/frames, so we parse
//<noembed>/<noframes> as rawtext.
function $2f5582982d8cf3f4$var$rawTextStartTagInBody(p, token) {
    p._switchToTextParsing(token, (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).RAWTEXT);
}
function $2f5582982d8cf3f4$var$selectStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    p.framesetOk = false;
    p.insertionMode = p.insertionMode === $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE || p.insertionMode === $2f5582982d8cf3f4$var$InsertionMode.IN_CAPTION || p.insertionMode === $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY || p.insertionMode === $2f5582982d8cf3f4$var$InsertionMode.IN_ROW || p.insertionMode === $2f5582982d8cf3f4$var$InsertionMode.IN_CELL ? $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT_IN_TABLE : $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT;
}
function $2f5582982d8cf3f4$var$optgroupStartTagInBody(p, token) {
    if (p.openElements.currentTagId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTION) p.openElements.pop();
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
}
function $2f5582982d8cf3f4$var$rbStartTagInBody(p, token) {
    if (p.openElements.hasInScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).RUBY)) p.openElements.generateImpliedEndTags();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
}
function $2f5582982d8cf3f4$var$rtStartTagInBody(p, token) {
    if (p.openElements.hasInScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).RUBY)) p.openElements.generateImpliedEndTagsWithExclusion((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).RTC);
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
}
function $2f5582982d8cf3f4$var$mathStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    $488c212c7b5d6f42$export$c583cc5a9d633feb(token);
    $488c212c7b5d6f42$export$a5192af02995cbdc(token);
    if (token.selfClosing) p._appendElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).MATHML);
    else p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).MATHML);
    token.ackSelfClosing = true;
}
function $2f5582982d8cf3f4$var$svgStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    $488c212c7b5d6f42$export$74ce06f755fb8f68(token);
    $488c212c7b5d6f42$export$a5192af02995cbdc(token);
    if (token.selfClosing) p._appendElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).SVG);
    else p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).SVG);
    token.ackSelfClosing = true;
}
function $2f5582982d8cf3f4$var$genericStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
}
function $2f5582982d8cf3f4$var$startTagInBody(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).I:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).S:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).B:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).U:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).EM:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BIG:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CODE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FONT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SMALL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).STRIKE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).STRONG:
            $2f5582982d8cf3f4$var$bStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).A:
            $2f5582982d8cf3f4$var$aStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H1:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H2:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H3:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H4:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H5:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H6:
            $2f5582982d8cf3f4$var$numberedHeaderStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).UL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DIV:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DIR:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NAV:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MAIN:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MENU:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).ASIDE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CENTER:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FIGURE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FOOTER:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEADER:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HGROUP:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DIALOG:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DETAILS:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).ADDRESS:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).ARTICLE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SEARCH:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SECTION:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SUMMARY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FIELDSET:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BLOCKQUOTE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FIGCAPTION:
            $2f5582982d8cf3f4$var$addressStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LI:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DT:
            $2f5582982d8cf3f4$var$listItemStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BR:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).IMG:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).WBR:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).AREA:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).EMBED:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).KEYGEN:
            $2f5582982d8cf3f4$var$areaStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HR:
            $2f5582982d8cf3f4$var$hrStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).RB:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).RTC:
            $2f5582982d8cf3f4$var$rbStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).RT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).RP:
            $2f5582982d8cf3f4$var$rtStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).PRE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LISTING:
            $2f5582982d8cf3f4$var$preStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).XMP:
            $2f5582982d8cf3f4$var$xmpStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SVG:
            $2f5582982d8cf3f4$var$svgStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
            $2f5582982d8cf3f4$var$htmlStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BASE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LINK:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).META:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).STYLE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TITLE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SCRIPT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BGSOUND:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BASEFONT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
            $2f5582982d8cf3f4$var$startTagInHead(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY:
            $2f5582982d8cf3f4$var$bodyStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FORM:
            $2f5582982d8cf3f4$var$formStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOBR:
            $2f5582982d8cf3f4$var$nobrStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MATH:
            $2f5582982d8cf3f4$var$mathStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE:
            $2f5582982d8cf3f4$var$tableStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).INPUT:
            $2f5582982d8cf3f4$var$inputStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).PARAM:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TRACK:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SOURCE:
            $2f5582982d8cf3f4$var$paramStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).IMAGE:
            $2f5582982d8cf3f4$var$imageStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BUTTON:
            $2f5582982d8cf3f4$var$buttonStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).APPLET:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OBJECT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MARQUEE:
            $2f5582982d8cf3f4$var$appletStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).IFRAME:
            $2f5582982d8cf3f4$var$iframeStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SELECT:
            $2f5582982d8cf3f4$var$selectStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTION:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTGROUP:
            $2f5582982d8cf3f4$var$optgroupStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOEMBED:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOFRAMES:
            $2f5582982d8cf3f4$var$rawTextStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FRAMESET:
            $2f5582982d8cf3f4$var$framesetStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEXTAREA:
            $2f5582982d8cf3f4$var$textareaStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOSCRIPT:
            if (p.options.scriptingEnabled) $2f5582982d8cf3f4$var$rawTextStartTagInBody(p, token);
            else $2f5582982d8cf3f4$var$genericStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).PLAINTEXT:
            $2f5582982d8cf3f4$var$plaintextStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEAD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FRAME:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP:
            break;
        default:
            $2f5582982d8cf3f4$var$genericStartTagInBody(p, token);
    }
}
function $2f5582982d8cf3f4$var$bodyEndTagInBody(p, token) {
    if (p.openElements.hasInScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY)) {
        p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.AFTER_BODY;
        //NOTE: <body> is never popped from the stack, so we need to updated
        //the end location explicitly.
        if (p.options.sourceCodeLocationInfo) {
            const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
            if (bodyElement) p._setEndLocation(bodyElement, token);
        }
    }
}
function $2f5582982d8cf3f4$var$htmlEndTagInBody(p, token) {
    if (p.openElements.hasInScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY)) {
        p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.AFTER_BODY;
        $2f5582982d8cf3f4$var$endTagAfterBody(p, token);
    }
}
function $2f5582982d8cf3f4$var$addressEndTagInBody(p, token) {
    const tn = token.tagID;
    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
    }
}
function $2f5582982d8cf3f4$var$formEndTagInBody(p) {
    const inTemplate = p.openElements.tmplCount > 0;
    const { formElement: formElement } = p;
    if (!inTemplate) p.formElement = null;
    if ((formElement || inTemplate) && p.openElements.hasInScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FORM)) {
        p.openElements.generateImpliedEndTags();
        if (inTemplate) p.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FORM);
        else if (formElement) p.openElements.remove(formElement);
    }
}
function $2f5582982d8cf3f4$var$pEndTagInBody(p) {
    if (!p.openElements.hasInButtonScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P)) p._insertFakeElement((0, $c2855a9ccb69df69$export$7e674a85a2656dce).P, (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P);
    p._closePElement();
}
function $2f5582982d8cf3f4$var$liEndTagInBody(p) {
    if (p.openElements.hasInListItemScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LI)) {
        p.openElements.generateImpliedEndTagsWithExclusion((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LI);
        p.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LI);
    }
}
function $2f5582982d8cf3f4$var$ddEndTagInBody(p, token) {
    const tn = token.tagID;
    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTagsWithExclusion(tn);
        p.openElements.popUntilTagNamePopped(tn);
    }
}
function $2f5582982d8cf3f4$var$numberedHeaderEndTagInBody(p) {
    if (p.openElements.hasNumberedHeaderInScope()) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilNumberedHeaderPopped();
    }
}
function $2f5582982d8cf3f4$var$appletEndTagInBody(p, token) {
    const tn = token.tagID;
    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
        p.activeFormattingElements.clearToLastMarker();
    }
}
function $2f5582982d8cf3f4$var$brEndTagInBody(p) {
    p._reconstructActiveFormattingElements();
    p._insertFakeElement((0, $c2855a9ccb69df69$export$7e674a85a2656dce).BR, (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BR);
    p.openElements.pop();
    p.framesetOk = false;
}
function $2f5582982d8cf3f4$var$genericEndTagInBody(p, token) {
    const tn = token.tagName;
    const tid = token.tagID;
    for(let i = p.openElements.stackTop; i > 0; i--){
        const element = p.openElements.items[i];
        const elementId = p.openElements.tagIDs[i];
        // Compare the tag name here, as the tag might not be a known tag with an ID.
        if (tid === elementId && (tid !== (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).UNKNOWN || p.treeAdapter.getTagName(element) === tn)) {
            p.openElements.generateImpliedEndTagsWithExclusion(tid);
            if (p.openElements.stackTop >= i) p.openElements.shortenToLength(i);
            break;
        }
        if (p._isSpecialElement(element, elementId)) break;
    }
}
function $2f5582982d8cf3f4$var$endTagInBody(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).A:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).B:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).I:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).S:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).U:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).EM:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BIG:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CODE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FONT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOBR:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SMALL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).STRIKE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).STRONG:
            $2f5582982d8cf3f4$var$callAdoptionAgency(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P:
            $2f5582982d8cf3f4$var$pEndTagInBody(p);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).UL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DIR:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DIV:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NAV:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).PRE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MAIN:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MENU:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).ASIDE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BUTTON:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CENTER:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FIGURE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FOOTER:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEADER:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HGROUP:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DIALOG:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).ADDRESS:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).ARTICLE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DETAILS:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SEARCH:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SECTION:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SUMMARY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LISTING:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FIELDSET:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BLOCKQUOTE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FIGCAPTION:
            $2f5582982d8cf3f4$var$addressEndTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LI:
            $2f5582982d8cf3f4$var$liEndTagInBody(p);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DT:
            $2f5582982d8cf3f4$var$ddEndTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H1:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H2:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H3:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H4:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H5:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H6:
            $2f5582982d8cf3f4$var$numberedHeaderEndTagInBody(p);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BR:
            $2f5582982d8cf3f4$var$brEndTagInBody(p);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY:
            $2f5582982d8cf3f4$var$bodyEndTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
            $2f5582982d8cf3f4$var$htmlEndTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FORM:
            $2f5582982d8cf3f4$var$formEndTagInBody(p);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).APPLET:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OBJECT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MARQUEE:
            $2f5582982d8cf3f4$var$appletEndTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
            $2f5582982d8cf3f4$var$templateEndTagInHead(p, token);
            break;
        default:
            $2f5582982d8cf3f4$var$genericEndTagInBody(p, token);
    }
}
function $2f5582982d8cf3f4$var$eofInBody(p, token) {
    if (p.tmplInsertionModeStack.length > 0) $2f5582982d8cf3f4$var$eofInTemplate(p, token);
    else $2f5582982d8cf3f4$var$stopParsing(p, token);
}
// The "text" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$endTagInText(p, token) {
    var _a;
    if (token.tagID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SCRIPT) (_a = p.scriptHandler) === null || _a === void 0 || _a.call(p, p.openElements.current);
    p.openElements.pop();
    p.insertionMode = p.originalInsertionMode;
}
function $2f5582982d8cf3f4$var$eofInText(p, token) {
    p._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInElementThatCanContainOnlyText);
    p.openElements.pop();
    p.insertionMode = p.originalInsertionMode;
    p.onEof(token);
}
// The "in table" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$characterInTable(p, token) {
    if (p.openElements.currentTagId !== undefined && $2f5582982d8cf3f4$var$TABLE_STRUCTURE_TAGS.has(p.openElements.currentTagId)) {
        p.pendingCharacterTokens.length = 0;
        p.hasNonWhitespacePendingCharacterToken = false;
        p.originalInsertionMode = p.insertionMode;
        p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_TEXT;
        switch(token.type){
            case (0, $be390ad8d330a451$export$f435f793048e7a0f).CHARACTER:
                $2f5582982d8cf3f4$var$characterInTableText(p, token);
                break;
            case (0, $be390ad8d330a451$export$f435f793048e7a0f).WHITESPACE_CHARACTER:
                $2f5582982d8cf3f4$var$whitespaceCharacterInTableText(p, token);
                break;
        }
    } else $2f5582982d8cf3f4$var$tokenInTable(p, token);
}
function $2f5582982d8cf3f4$var$captionStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p.activeFormattingElements.insertMarker();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_CAPTION;
}
function $2f5582982d8cf3f4$var$colgroupStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_COLUMN_GROUP;
}
function $2f5582982d8cf3f4$var$colStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertFakeElement((0, $c2855a9ccb69df69$export$7e674a85a2656dce).COLGROUP, (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP);
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_COLUMN_GROUP;
    $2f5582982d8cf3f4$var$startTagInColumnGroup(p, token);
}
function $2f5582982d8cf3f4$var$tbodyStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY;
}
function $2f5582982d8cf3f4$var$tdStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertFakeElement((0, $c2855a9ccb69df69$export$7e674a85a2656dce).TBODY, (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY);
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY;
    $2f5582982d8cf3f4$var$startTagInTableBody(p, token);
}
function $2f5582982d8cf3f4$var$tableStartTagInTable(p, token) {
    if (p.openElements.hasInTableScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE)) {
        p.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE);
        p._resetInsertionMode();
        p._processStartTag(token);
    }
}
function $2f5582982d8cf3f4$var$inputStartTagInTable(p, token) {
    if ($2f5582982d8cf3f4$var$isHiddenInput(token)) p._appendElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    else $2f5582982d8cf3f4$var$tokenInTable(p, token);
    token.ackSelfClosing = true;
}
function $2f5582982d8cf3f4$var$formStartTagInTable(p, token) {
    if (!p.formElement && p.openElements.tmplCount === 0) {
        p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
        p.formElement = p.openElements.current;
        p.openElements.pop();
    }
}
function $2f5582982d8cf3f4$var$startTagInTable(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR:
            $2f5582982d8cf3f4$var$tdStartTagInTable(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).STYLE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SCRIPT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
            $2f5582982d8cf3f4$var$startTagInHead(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COL:
            $2f5582982d8cf3f4$var$colStartTagInTable(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FORM:
            $2f5582982d8cf3f4$var$formStartTagInTable(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE:
            $2f5582982d8cf3f4$var$tableStartTagInTable(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD:
            $2f5582982d8cf3f4$var$tbodyStartTagInTable(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).INPUT:
            $2f5582982d8cf3f4$var$inputStartTagInTable(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION:
            $2f5582982d8cf3f4$var$captionStartTagInTable(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP:
            $2f5582982d8cf3f4$var$colgroupStartTagInTable(p, token);
            break;
        default:
            $2f5582982d8cf3f4$var$tokenInTable(p, token);
    }
}
function $2f5582982d8cf3f4$var$endTagInTable(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE:
            if (p.openElements.hasInTableScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE)) {
                p.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE);
                p._resetInsertionMode();
            }
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
            $2f5582982d8cf3f4$var$templateEndTagInHead(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR:
            break;
        default:
            $2f5582982d8cf3f4$var$tokenInTable(p, token);
    }
}
function $2f5582982d8cf3f4$var$tokenInTable(p, token) {
    const savedFosterParentingState = p.fosterParentingEnabled;
    p.fosterParentingEnabled = true;
    // Process token in `In Body` mode
    $2f5582982d8cf3f4$var$modeInBody(p, token);
    p.fosterParentingEnabled = savedFosterParentingState;
}
// The "in table text" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$whitespaceCharacterInTableText(p, token) {
    p.pendingCharacterTokens.push(token);
}
function $2f5582982d8cf3f4$var$characterInTableText(p, token) {
    p.pendingCharacterTokens.push(token);
    p.hasNonWhitespacePendingCharacterToken = true;
}
function $2f5582982d8cf3f4$var$tokenInTableText(p, token) {
    let i = 0;
    if (p.hasNonWhitespacePendingCharacterToken) for(; i < p.pendingCharacterTokens.length; i++)$2f5582982d8cf3f4$var$tokenInTable(p, p.pendingCharacterTokens[i]);
    else for(; i < p.pendingCharacterTokens.length; i++)p._insertCharacters(p.pendingCharacterTokens[i]);
    p.insertionMode = p.originalInsertionMode;
    p._processToken(token);
}
// The "in caption" insertion mode
//------------------------------------------------------------------
const $2f5582982d8cf3f4$var$TABLE_VOID_ELEMENTS = new Set([
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COL,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR
]);
function $2f5582982d8cf3f4$var$startTagInCaption(p, token) {
    const tn = token.tagID;
    if ($2f5582982d8cf3f4$var$TABLE_VOID_ELEMENTS.has(tn)) {
        if (p.openElements.hasInTableScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION)) {
            p.openElements.generateImpliedEndTags();
            p.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION);
            p.activeFormattingElements.clearToLastMarker();
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE;
            $2f5582982d8cf3f4$var$startTagInTable(p, token);
        }
    } else $2f5582982d8cf3f4$var$startTagInBody(p, token);
}
function $2f5582982d8cf3f4$var$endTagInCaption(p, token) {
    const tn = token.tagID;
    switch(tn){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE:
            if (p.openElements.hasInTableScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION)) {
                p.openElements.generateImpliedEndTags();
                p.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION);
                p.activeFormattingElements.clearToLastMarker();
                p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE;
                if (tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE) $2f5582982d8cf3f4$var$endTagInTable(p, token);
            }
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR:
            break;
        default:
            $2f5582982d8cf3f4$var$endTagInBody(p, token);
    }
}
// The "in column group" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagInColumnGroup(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
            $2f5582982d8cf3f4$var$startTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COL:
            p._appendElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
            token.ackSelfClosing = true;
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
            $2f5582982d8cf3f4$var$startTagInHead(p, token);
            break;
        default:
            $2f5582982d8cf3f4$var$tokenInColumnGroup(p, token);
    }
}
function $2f5582982d8cf3f4$var$endTagInColumnGroup(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP:
            if (p.openElements.currentTagId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP) {
                p.openElements.pop();
                p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE;
            }
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
            $2f5582982d8cf3f4$var$templateEndTagInHead(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COL:
            break;
        default:
            $2f5582982d8cf3f4$var$tokenInColumnGroup(p, token);
    }
}
function $2f5582982d8cf3f4$var$tokenInColumnGroup(p, token) {
    if (p.openElements.currentTagId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP) {
        p.openElements.pop();
        p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE;
        p._processToken(token);
    }
}
// The "in table body" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagInTableBody(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR:
            p.openElements.clearBackToTableBodyContext();
            p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_ROW;
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD:
            p.openElements.clearBackToTableBodyContext();
            p._insertFakeElement((0, $c2855a9ccb69df69$export$7e674a85a2656dce).TR, (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR);
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_ROW;
            $2f5582982d8cf3f4$var$startTagInRow(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD:
            if (p.openElements.hasTableBodyContextInTableScope()) {
                p.openElements.clearBackToTableBodyContext();
                p.openElements.pop();
                p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE;
                $2f5582982d8cf3f4$var$startTagInTable(p, token);
            }
            break;
        default:
            $2f5582982d8cf3f4$var$startTagInTable(p, token);
    }
}
function $2f5582982d8cf3f4$var$endTagInTableBody(p, token) {
    const tn = token.tagID;
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD:
            if (p.openElements.hasInTableScope(tn)) {
                p.openElements.clearBackToTableBodyContext();
                p.openElements.pop();
                p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE;
            }
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE:
            if (p.openElements.hasTableBodyContextInTableScope()) {
                p.openElements.clearBackToTableBodyContext();
                p.openElements.pop();
                p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE;
                $2f5582982d8cf3f4$var$endTagInTable(p, token);
            }
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR:
            break;
        default:
            $2f5582982d8cf3f4$var$endTagInTable(p, token);
    }
}
// The "in row" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagInRow(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD:
            p.openElements.clearBackToTableRowContext();
            p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_CELL;
            p.activeFormattingElements.insertMarker();
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR:
            if (p.openElements.hasInTableScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR)) {
                p.openElements.clearBackToTableRowContext();
                p.openElements.pop();
                p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY;
                $2f5582982d8cf3f4$var$startTagInTableBody(p, token);
            }
            break;
        default:
            $2f5582982d8cf3f4$var$startTagInTable(p, token);
    }
}
function $2f5582982d8cf3f4$var$endTagInRow(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR:
            if (p.openElements.hasInTableScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR)) {
                p.openElements.clearBackToTableRowContext();
                p.openElements.pop();
                p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY;
            }
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE:
            if (p.openElements.hasInTableScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR)) {
                p.openElements.clearBackToTableRowContext();
                p.openElements.pop();
                p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY;
                $2f5582982d8cf3f4$var$endTagInTableBody(p, token);
            }
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD:
            if (p.openElements.hasInTableScope(token.tagID) || p.openElements.hasInTableScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR)) {
                p.openElements.clearBackToTableRowContext();
                p.openElements.pop();
                p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY;
                $2f5582982d8cf3f4$var$endTagInTableBody(p, token);
            }
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH:
            break;
        default:
            $2f5582982d8cf3f4$var$endTagInTable(p, token);
    }
}
// The "in cell" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagInCell(p, token) {
    const tn = token.tagID;
    if ($2f5582982d8cf3f4$var$TABLE_VOID_ELEMENTS.has(tn)) {
        if (p.openElements.hasInTableScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD) || p.openElements.hasInTableScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH)) {
            p._closeTableCell();
            $2f5582982d8cf3f4$var$startTagInRow(p, token);
        }
    } else $2f5582982d8cf3f4$var$startTagInBody(p, token);
}
function $2f5582982d8cf3f4$var$endTagInCell(p, token) {
    const tn = token.tagID;
    switch(tn){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH:
            if (p.openElements.hasInTableScope(tn)) {
                p.openElements.generateImpliedEndTags();
                p.openElements.popUntilTagNamePopped(tn);
                p.activeFormattingElements.clearToLastMarker();
                p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_ROW;
            }
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR:
            if (p.openElements.hasInTableScope(tn)) {
                p._closeTableCell();
                $2f5582982d8cf3f4$var$endTagInRow(p, token);
            }
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
            break;
        default:
            $2f5582982d8cf3f4$var$endTagInBody(p, token);
    }
}
// The "in select" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagInSelect(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
            $2f5582982d8cf3f4$var$startTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTION:
            if (p.openElements.currentTagId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTION) p.openElements.pop();
            p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTGROUP:
            if (p.openElements.currentTagId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTION) p.openElements.pop();
            if (p.openElements.currentTagId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTGROUP) p.openElements.pop();
            p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HR:
            if (p.openElements.currentTagId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTION) p.openElements.pop();
            if (p.openElements.currentTagId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTGROUP) p.openElements.pop();
            p._appendElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
            token.ackSelfClosing = true;
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).INPUT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).KEYGEN:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEXTAREA:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SELECT:
            if (p.openElements.hasInSelectScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SELECT)) {
                p.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SELECT);
                p._resetInsertionMode();
                if (token.tagID !== (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SELECT) p._processStartTag(token);
            }
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SCRIPT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
            $2f5582982d8cf3f4$var$startTagInHead(p, token);
            break;
        default:
    }
}
function $2f5582982d8cf3f4$var$endTagInSelect(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTGROUP:
            if (p.openElements.stackTop > 0 && p.openElements.currentTagId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTION && p.openElements.tagIDs[p.openElements.stackTop - 1] === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTGROUP) p.openElements.pop();
            if (p.openElements.currentTagId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTGROUP) p.openElements.pop();
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTION:
            if (p.openElements.currentTagId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTION) p.openElements.pop();
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SELECT:
            if (p.openElements.hasInSelectScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SELECT)) {
                p.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SELECT);
                p._resetInsertionMode();
            }
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
            $2f5582982d8cf3f4$var$templateEndTagInHead(p, token);
            break;
        default:
    }
}
// The "in select in table" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagInSelectInTable(p, token) {
    const tn = token.tagID;
    if (tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH) {
        p.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SELECT);
        p._resetInsertionMode();
        p._processStartTag(token);
    } else $2f5582982d8cf3f4$var$startTagInSelect(p, token);
}
function $2f5582982d8cf3f4$var$endTagInSelectInTable(p, token) {
    const tn = token.tagID;
    if (tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH) {
        if (p.openElements.hasInTableScope(tn)) {
            p.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SELECT);
            p._resetInsertionMode();
            p.onEndTag(token);
        }
    } else $2f5582982d8cf3f4$var$endTagInSelect(p, token);
}
// The "in template" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagInTemplate(p, token) {
    switch(token.tagID){
        // First, handle tags that can start without a mode change
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BASE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BASEFONT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BGSOUND:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LINK:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).META:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOFRAMES:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SCRIPT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).STYLE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TITLE:
            $2f5582982d8cf3f4$var$startTagInHead(p, token);
            break;
        // Re-process the token in the appropriate mode
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD:
            p.tmplInsertionModeStack[0] = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE;
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE;
            $2f5582982d8cf3f4$var$startTagInTable(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COL:
            p.tmplInsertionModeStack[0] = $2f5582982d8cf3f4$var$InsertionMode.IN_COLUMN_GROUP;
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_COLUMN_GROUP;
            $2f5582982d8cf3f4$var$startTagInColumnGroup(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR:
            p.tmplInsertionModeStack[0] = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY;
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY;
            $2f5582982d8cf3f4$var$startTagInTableBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH:
            p.tmplInsertionModeStack[0] = $2f5582982d8cf3f4$var$InsertionMode.IN_ROW;
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_ROW;
            $2f5582982d8cf3f4$var$startTagInRow(p, token);
            break;
        default:
            p.tmplInsertionModeStack[0] = $2f5582982d8cf3f4$var$InsertionMode.IN_BODY;
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_BODY;
            $2f5582982d8cf3f4$var$startTagInBody(p, token);
    }
}
function $2f5582982d8cf3f4$var$endTagInTemplate(p, token) {
    if (token.tagID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE) $2f5582982d8cf3f4$var$templateEndTagInHead(p, token);
}
function $2f5582982d8cf3f4$var$eofInTemplate(p, token) {
    if (p.openElements.tmplCount > 0) {
        p.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE);
        p.activeFormattingElements.clearToLastMarker();
        p.tmplInsertionModeStack.shift();
        p._resetInsertionMode();
        p.onEof(token);
    } else $2f5582982d8cf3f4$var$stopParsing(p, token);
}
// The "after body" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagAfterBody(p, token) {
    if (token.tagID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML) $2f5582982d8cf3f4$var$startTagInBody(p, token);
    else $2f5582982d8cf3f4$var$tokenAfterBody(p, token);
}
function $2f5582982d8cf3f4$var$endTagAfterBody(p, token) {
    var _a;
    if (token.tagID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML) {
        if (!p.fragmentContext) p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.AFTER_AFTER_BODY;
        //NOTE: <html> is never popped from the stack, so we need to updated
        //the end location explicitly.
        if (p.options.sourceCodeLocationInfo && p.openElements.tagIDs[0] === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML) {
            p._setEndLocation(p.openElements.items[0], token);
            // Update the body element, if it doesn't have an end tag
            const bodyElement = p.openElements.items[1];
            if (bodyElement && !((_a = p.treeAdapter.getNodeSourceCodeLocation(bodyElement)) === null || _a === void 0 ? void 0 : _a.endTag)) p._setEndLocation(bodyElement, token);
        }
    } else $2f5582982d8cf3f4$var$tokenAfterBody(p, token);
}
function $2f5582982d8cf3f4$var$tokenAfterBody(p, token) {
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_BODY;
    $2f5582982d8cf3f4$var$modeInBody(p, token);
}
// The "in frameset" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagInFrameset(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
            $2f5582982d8cf3f4$var$startTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FRAMESET:
            p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FRAME:
            p._appendElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
            token.ackSelfClosing = true;
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOFRAMES:
            $2f5582982d8cf3f4$var$startTagInHead(p, token);
            break;
        default:
    }
}
function $2f5582982d8cf3f4$var$endTagInFrameset(p, token) {
    if (token.tagID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FRAMESET && !p.openElements.isRootHtmlElementCurrent()) {
        p.openElements.pop();
        if (!p.fragmentContext && p.openElements.currentTagId !== (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FRAMESET) p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.AFTER_FRAMESET;
    }
}
// The "after frameset" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagAfterFrameset(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
            $2f5582982d8cf3f4$var$startTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOFRAMES:
            $2f5582982d8cf3f4$var$startTagInHead(p, token);
            break;
        default:
    }
}
function $2f5582982d8cf3f4$var$endTagAfterFrameset(p, token) {
    if (token.tagID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML) p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.AFTER_AFTER_FRAMESET;
}
// The "after after body" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagAfterAfterBody(p, token) {
    if (token.tagID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML) $2f5582982d8cf3f4$var$startTagInBody(p, token);
    else $2f5582982d8cf3f4$var$tokenAfterAfterBody(p, token);
}
function $2f5582982d8cf3f4$var$tokenAfterAfterBody(p, token) {
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_BODY;
    $2f5582982d8cf3f4$var$modeInBody(p, token);
}
// The "after after frameset" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagAfterAfterFrameset(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
            $2f5582982d8cf3f4$var$startTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOFRAMES:
            $2f5582982d8cf3f4$var$startTagInHead(p, token);
            break;
        default:
    }
}
// The rules for parsing tokens in foreign content
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$nullCharacterInForeignContent(p, token) {
    token.chars = $bb1347fda1174ed8$export$e8d20e7a50e6c279;
    p._insertCharacters(token);
}
function $2f5582982d8cf3f4$var$characterInForeignContent(p, token) {
    p._insertCharacters(token);
    p.framesetOk = false;
}
function $2f5582982d8cf3f4$var$popUntilHtmlOrIntegrationPoint(p) {
    while(p.treeAdapter.getNamespaceURI(p.openElements.current) !== (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML && p.openElements.currentTagId !== undefined && !p._isIntegrationPoint(p.openElements.currentTagId, p.openElements.current))p.openElements.pop();
}
function $2f5582982d8cf3f4$var$startTagInForeignContent(p, token) {
    if ($488c212c7b5d6f42$export$3435eb4ab4d2ed2d(token)) {
        $2f5582982d8cf3f4$var$popUntilHtmlOrIntegrationPoint(p);
        p._startTagOutsideForeignContent(token);
    } else {
        const current = p._getAdjustedCurrentElement();
        const currentNs = p.treeAdapter.getNamespaceURI(current);
        if (currentNs === (0, $c2855a9ccb69df69$export$fb4028874a74450).MATHML) $488c212c7b5d6f42$export$c583cc5a9d633feb(token);
        else if (currentNs === (0, $c2855a9ccb69df69$export$fb4028874a74450).SVG) {
            $488c212c7b5d6f42$export$95df78fe2e7f33e3(token);
            $488c212c7b5d6f42$export$74ce06f755fb8f68(token);
        }
        $488c212c7b5d6f42$export$a5192af02995cbdc(token);
        if (token.selfClosing) p._appendElement(token, currentNs);
        else p._insertElement(token, currentNs);
        token.ackSelfClosing = true;
    }
}
function $2f5582982d8cf3f4$var$endTagInForeignContent(p, token) {
    if (token.tagID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P || token.tagID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BR) {
        $2f5582982d8cf3f4$var$popUntilHtmlOrIntegrationPoint(p);
        p._endTagOutsideForeignContent(token);
        return;
    }
    for(let i = p.openElements.stackTop; i > 0; i--){
        const element = p.openElements.items[i];
        if (p.treeAdapter.getNamespaceURI(element) === (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML) {
            p._endTagOutsideForeignContent(token);
            break;
        }
        const tagName = p.treeAdapter.getTagName(element);
        if (tagName.toLowerCase() === token.tagName) {
            //NOTE: update the token tag name for `_setEndLocation`.
            token.tagName = tagName;
            p.openElements.shortenToLength(i);
            break;
        }
    }
}




const $76b9307c73063a75$export$5699810ce3244ab8 = /["$&'<>\u0080-\uFFFF]/g;
const $76b9307c73063a75$var$xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
const $76b9307c73063a75$export$e02688b8085d016b = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt == null ? (c, index)=>(c.charCodeAt(index) & 64512) === 55296 ? (c.charCodeAt(index) - 55296) * 1024 + c.charCodeAt(index + 1) - 56320 + 65536 : c.charCodeAt(index) : (input, index)=>input.codePointAt(index);
function $76b9307c73063a75$export$18855ec5be97da16(input) {
    let returnValue = "";
    let lastIndex = 0;
    let match;
    while((match = $76b9307c73063a75$export$5699810ce3244ab8.exec(input)) !== null){
        const { index: index } = match;
        const char = input.charCodeAt(index);
        const next = $76b9307c73063a75$var$xmlCodeMap.get(char);
        if (next === undefined) {
            returnValue += `${input.substring(lastIndex, index)}&#x${$76b9307c73063a75$export$e02688b8085d016b(input, index).toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIndex = $76b9307c73063a75$export$5699810ce3244ab8.lastIndex += Number((char & 64512) === 55296);
        } else {
            returnValue += input.substring(lastIndex, index) + next;
            lastIndex = index + 1;
        }
    }
    return returnValue + input.substr(lastIndex);
}
const $76b9307c73063a75$export$4e7f196112fea3c5 = $76b9307c73063a75$export$18855ec5be97da16;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function $76b9307c73063a75$var$getEscaper(regex, map) {
    return function escape(data) {
        let match;
        let lastIndex = 0;
        let result = "";
        while(match = regex.exec(data)){
            if (lastIndex !== match.index) result += data.substring(lastIndex, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIndex = match.index + 1;
        }
        return result + data.substring(lastIndex);
    };
}
const $76b9307c73063a75$export$9e081872deefdcb0 = /* #__PURE__ */ $76b9307c73063a75$var$getEscaper(/["&'<>]/g, $76b9307c73063a75$var$xmlCodeMap);
const $76b9307c73063a75$export$30330f3d5eb70e11 = /* #__PURE__ */ $76b9307c73063a75$var$getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
const $76b9307c73063a75$export$96e6fc3a139b2555 = /* #__PURE__ */ $76b9307c73063a75$var$getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));



// Sets
const $762ab6a391ef02ce$var$VOID_ELEMENTS = new Set([
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).AREA,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).BASE,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).BASEFONT,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).BGSOUND,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).BR,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).COL,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).EMBED,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).FRAME,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).HR,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).IMG,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).INPUT,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).KEYGEN,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).LINK,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).META,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).PARAM,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).SOURCE,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).TRACK,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).WBR
]);
function $762ab6a391ef02ce$var$isVoidElement(node, options) {
    return options.treeAdapter.isElementNode(node) && options.treeAdapter.getNamespaceURI(node) === (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML && $762ab6a391ef02ce$var$VOID_ELEMENTS.has(options.treeAdapter.getTagName(node));
}
const $762ab6a391ef02ce$var$defaultOpts = {
    treeAdapter: (0, $01acbc1e35b87488$export$7ddbba828dfa4796),
    scriptingEnabled: true
};
function $762ab6a391ef02ce$export$dfdc1655ccc5b9cb(node, options) {
    const opts = {
        ...$762ab6a391ef02ce$var$defaultOpts,
        ...options
    };
    if ($762ab6a391ef02ce$var$isVoidElement(node, opts)) return '';
    return $762ab6a391ef02ce$var$serializeChildNodes(node, opts);
}
function $762ab6a391ef02ce$export$71e9c1f1ceb5a856(node, options) {
    const opts = {
        ...$762ab6a391ef02ce$var$defaultOpts,
        ...options
    };
    return $762ab6a391ef02ce$var$serializeNode(node, opts);
}
function $762ab6a391ef02ce$var$serializeChildNodes(parentNode, options) {
    let html = '';
    // Get container of the child nodes
    const container = options.treeAdapter.isElementNode(parentNode) && options.treeAdapter.getTagName(parentNode) === (0, $c2855a9ccb69df69$export$7e674a85a2656dce).TEMPLATE && options.treeAdapter.getNamespaceURI(parentNode) === (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML ? options.treeAdapter.getTemplateContent(parentNode) : parentNode;
    const childNodes = options.treeAdapter.getChildNodes(container);
    if (childNodes) for (const currentNode of childNodes)html += $762ab6a391ef02ce$var$serializeNode(currentNode, options);
    return html;
}
function $762ab6a391ef02ce$var$serializeNode(node, options) {
    if (options.treeAdapter.isElementNode(node)) return $762ab6a391ef02ce$var$serializeElement(node, options);
    if (options.treeAdapter.isTextNode(node)) return $762ab6a391ef02ce$var$serializeTextNode(node, options);
    if (options.treeAdapter.isCommentNode(node)) return $762ab6a391ef02ce$var$serializeCommentNode(node, options);
    if (options.treeAdapter.isDocumentTypeNode(node)) return $762ab6a391ef02ce$var$serializeDocumentTypeNode(node, options);
    // Return an empty string for unknown nodes
    return '';
}
function $762ab6a391ef02ce$var$serializeElement(node, options) {
    const tn = options.treeAdapter.getTagName(node);
    return `<${tn}${$762ab6a391ef02ce$var$serializeAttributes(node, options)}>${$762ab6a391ef02ce$var$isVoidElement(node, options) ? '' : `${$762ab6a391ef02ce$var$serializeChildNodes(node, options)}</${tn}>`}`;
}
function $762ab6a391ef02ce$var$serializeAttributes(node, { treeAdapter: treeAdapter }) {
    let html = '';
    for (const attr of treeAdapter.getAttrList(node)){
        html += ' ';
        if (attr.namespace) switch(attr.namespace){
            case (0, $c2855a9ccb69df69$export$fb4028874a74450).XML:
                html += `xml:${attr.name}`;
                break;
            case (0, $c2855a9ccb69df69$export$fb4028874a74450).XMLNS:
                if (attr.name !== 'xmlns') html += 'xmlns:';
                html += attr.name;
                break;
            case (0, $c2855a9ccb69df69$export$fb4028874a74450).XLINK:
                html += `xlink:${attr.name}`;
                break;
            default:
                html += `${attr.prefix}:${attr.name}`;
        }
        else html += attr.name;
        html += `="${(0, $76b9307c73063a75$export$30330f3d5eb70e11)(attr.value)}"`;
    }
    return html;
}
function $762ab6a391ef02ce$var$serializeTextNode(node, options) {
    const { treeAdapter: treeAdapter } = options;
    const content = treeAdapter.getTextNodeContent(node);
    const parent = treeAdapter.getParentNode(node);
    const parentTn = parent && treeAdapter.isElementNode(parent) && treeAdapter.getTagName(parent);
    return parentTn && treeAdapter.getNamespaceURI(parent) === (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML && (0, $c2855a9ccb69df69$export$4ce4f8c09f921aed)(parentTn, options.scriptingEnabled) ? content : (0, $76b9307c73063a75$export$96e6fc3a139b2555)(content);
}
function $762ab6a391ef02ce$var$serializeCommentNode(node, { treeAdapter: treeAdapter }) {
    return `<!--${treeAdapter.getCommentNodeContent(node)}-->`;
}
function $762ab6a391ef02ce$var$serializeDocumentTypeNode(node, { treeAdapter: treeAdapter }) {
    return `<!DOCTYPE ${treeAdapter.getDocumentTypeNodeName(node)}>`;
}







function $7822c393005c8687$export$98e6a39c04603d36(html, options) {
    return (0, $2f5582982d8cf3f4$export$7acfa6ed01010e37).parse(html, options);
}
function $7822c393005c8687$export$e1152f5efcc82ad(fragmentContext, html, options) {
    if (typeof fragmentContext === 'string') {
        options = html;
        html = fragmentContext;
        fragmentContext = null;
    }
    const parser = (0, $2f5582982d8cf3f4$export$7acfa6ed01010e37).getFragmentParser(fragmentContext, options);
    parser.tokenizer.write(html, true);
    return parser.getFragment();
}






const $c58a141a6871fca8$var$gfmTagfilterExpression = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|textarea|title|xmp)(?=[\t\n\f\r />])/gi;
// Node types associated with MDX.
// <https://github.com/mdx-js/mdx/blob/8a56312/packages/mdx/lib/node-types.js>
const $c58a141a6871fca8$var$knownMdxNames = new Set([
    'mdxFlowExpression',
    'mdxJsxFlowElement',
    'mdxJsxTextElement',
    'mdxTextExpression',
    'mdxjsEsm'
]);
/** @type {ParserOptions<DefaultTreeAdapterMap>} */ const $c58a141a6871fca8$var$parseOptions = {
    sourceCodeLocationInfo: true,
    scriptingEnabled: false
};
function $c58a141a6871fca8$export$1776c186c69df29e(tree, options) {
    const document = $c58a141a6871fca8$var$documentMode(tree);
    /** @type {(node: Nodes, state: State) => undefined} */ const one = (0, $17810db8694da3f3$export$d6a12bfbbedf6185)('type', {
        handlers: {
            root: $c58a141a6871fca8$var$root,
            element: $c58a141a6871fca8$var$element,
            text: $c58a141a6871fca8$var$text,
            comment: $c58a141a6871fca8$var$comment,
            doctype: $c58a141a6871fca8$var$doctype,
            raw: $c58a141a6871fca8$var$handleRaw
        },
        unknown: $c58a141a6871fca8$var$unknown
    });
    /** @type {State} */ const state = {
        parser: document ? new (0, $2f5582982d8cf3f4$export$7acfa6ed01010e37)($c58a141a6871fca8$var$parseOptions) : (0, $2f5582982d8cf3f4$export$7acfa6ed01010e37).getFragmentParser(undefined, $c58a141a6871fca8$var$parseOptions),
        handle (node) {
            one(node, state);
        },
        stitches: false,
        options: options || {}
    };
    one(tree, state);
    $c58a141a6871fca8$var$resetTokenizer(state, (0, $9861e7b4f8df2806$export$771bf3e4949bfbee)());
    const p5 = document ? state.parser.document : state.parser.getFragment();
    const result = (0, $73bde87d01cc5621$export$371ddbe92c872127)(p5, {
        // To do: support `space`?
        file: state.options.file
    });
    if (state.stitches) (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(result, 'comment', function(node, index, parent) {
        const stitch = /** @type {unknown} */ node;
        if (stitch.value.stitch && parent && index !== undefined) {
            /** @type {Array<RootContent>} */ const siblings = parent.children;
            // @ts-expect-error: assume the stitch is allowed.
            siblings[index] = stitch.value.stitch;
            return index;
        }
    });
    // Unpack if possible and when not given a `root`.
    if (result.type === 'root' && result.children.length === 1 && result.children[0].type === tree.type) return result.children[0];
    return result;
}
/**
 * Transform all nodes
 *
 * @param {Array<RootContent>} nodes
 *   hast content.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */ function $c58a141a6871fca8$var$all(nodes, state) {
    let index = -1;
    /* istanbul ignore else - invalid nodes, see rehypejs/rehype-raw#7. */ if (nodes) while(++index < nodes.length)state.handle(nodes[index]);
}
/**
 * Transform a root.
 *
 * @param {Root} node
 *   hast root node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */ function $c58a141a6871fca8$var$root(node, state) {
    $c58a141a6871fca8$var$all(node.children, state);
}
/**
 * Transform an element.
 *
 * @param {Element} node
 *   hast element node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */ function $c58a141a6871fca8$var$element(node, state) {
    $c58a141a6871fca8$var$startTag(node, state);
    $c58a141a6871fca8$var$all(node.children, state);
    $c58a141a6871fca8$var$endTag(node, state);
}
/**
 * Transform a text.
 *
 * @param {Text} node
 *   hast text node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */ function $c58a141a6871fca8$var$text(node, state) {
    // Allow `DATA` through `PLAINTEXT`,
    // but when hanging in a tag for example,
    // switch back to `DATA`.
    // Note: `State` is not exposed by `parse5`, so these numbers are fragile.
    // See: <https://github.com/inikulin/parse5/blob/46cba43/packages/parse5/lib/tokenizer/index.ts#L58>
    if (state.parser.tokenizer.state > 4) state.parser.tokenizer.state = 0;
    /** @type {Token.CharacterToken} */ const token = {
        type: (0, $be390ad8d330a451$exports).TokenType.CHARACTER,
        chars: node.value,
        location: $c58a141a6871fca8$var$createParse5Location(node)
    };
    $c58a141a6871fca8$var$resetTokenizer(state, (0, $9861e7b4f8df2806$export$771bf3e4949bfbee)(node));
    // @ts-expect-error: private.
    state.parser.currentToken = token;
    // @ts-expect-error: private.
    state.parser._processToken(state.parser.currentToken);
}
/**
 * Transform a doctype.
 *
 * @param {Doctype} node
 *   hast doctype node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */ function $c58a141a6871fca8$var$doctype(node, state) {
    /** @type {Token.DoctypeToken} */ const token = {
        type: (0, $be390ad8d330a451$exports).TokenType.DOCTYPE,
        name: 'html',
        forceQuirks: false,
        publicId: '',
        systemId: '',
        location: $c58a141a6871fca8$var$createParse5Location(node)
    };
    $c58a141a6871fca8$var$resetTokenizer(state, (0, $9861e7b4f8df2806$export$771bf3e4949bfbee)(node));
    // @ts-expect-error: private.
    state.parser.currentToken = token;
    // @ts-expect-error: private.
    state.parser._processToken(state.parser.currentToken);
}
/**
 * Transform a stitch.
 *
 * @param {Nodes} node
 *   unknown node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */ function $c58a141a6871fca8$var$stitch(node, state) {
    // Mark that there are stitches, so we need to walk the tree and revert them.
    state.stitches = true;
    /** @type {Nodes} */ const clone = $c58a141a6871fca8$var$cloneWithoutChildren(node);
    // Recurse, because to somewhat handle `[<x>]</x>` (where `[]` denotes the
    // passed through node).
    if ('children' in node && 'children' in clone) {
        // Root in root out.
        const fakeRoot = /** @type {Root} */ $c58a141a6871fca8$export$1776c186c69df29e({
            type: 'root',
            children: node.children
        }, state.options);
        clone.children = fakeRoot.children;
    }
    // Hack: `value` is supposed to be a string, but as none of the tools
    // (`parse5` or `hast-util-from-parse5`) looks at it, we can pass nodes
    // through.
    $c58a141a6871fca8$var$comment({
        type: 'comment',
        value: {
            stitch: clone
        }
    }, state);
}
/**
 * Transform a comment (or stitch).
 *
 * @param {Comment | Stitch} node
 *   hast comment node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */ function $c58a141a6871fca8$var$comment(node, state) {
    /** @type {string} */ // @ts-expect-error: we pass stitches through.
    const data = node.value;
    /** @type {Token.CommentToken} */ const token = {
        type: (0, $be390ad8d330a451$exports).TokenType.COMMENT,
        data: data,
        location: $c58a141a6871fca8$var$createParse5Location(node)
    };
    $c58a141a6871fca8$var$resetTokenizer(state, (0, $9861e7b4f8df2806$export$771bf3e4949bfbee)(node));
    // @ts-expect-error: private.
    state.parser.currentToken = token;
    // @ts-expect-error: private.
    state.parser._processToken(state.parser.currentToken);
}
/**
 * Transform a raw node.
 *
 * @param {Raw} node
 *   hast raw node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */ function $c58a141a6871fca8$var$handleRaw(node, state) {
    // Reset preprocessor:
    // See: <https://github.com/inikulin/parse5/blob/6f7ca60/packages/parse5/lib/tokenizer/preprocessor.ts#L18-L31>.
    state.parser.tokenizer.preprocessor.html = '';
    state.parser.tokenizer.preprocessor.pos = -1;
    // @ts-expect-error: private.
    // type-coverage:ignore-next-line
    state.parser.tokenizer.preprocessor.lastGapPos = -2;
    // @ts-expect-error: private.
    // type-coverage:ignore-next-line
    state.parser.tokenizer.preprocessor.gapStack = [];
    // @ts-expect-error: private.
    // type-coverage:ignore-next-line
    state.parser.tokenizer.preprocessor.skipNextNewLine = false;
    state.parser.tokenizer.preprocessor.lastChunkWritten = false;
    state.parser.tokenizer.preprocessor.endOfChunkHit = false;
    // @ts-expect-error: private.
    // type-coverage:ignore-next-line
    state.parser.tokenizer.preprocessor.isEol = false;
    // Now pass `node.value`.
    $c58a141a6871fca8$var$setPoint(state, (0, $9861e7b4f8df2806$export$771bf3e4949bfbee)(node));
    state.parser.tokenizer.write(state.options.tagfilter ? node.value.replace($c58a141a6871fca8$var$gfmTagfilterExpression, '&lt;$1$2') : node.value, false);
    // @ts-expect-error: private.
    state.parser.tokenizer._runParsingLoop();
    // Character references hang, so if we ended there, we need to flush
    // those too.
    // We reset the preprocessor as if the document ends here.
    // Then one single call to the relevant state does the trick, parse5
    // consumes the whole token.
    // Note: `State` is not exposed by `parse5`, so these numbers are fragile.
    // See: <https://github.com/inikulin/parse5/blob/46cba43/packages/parse5/lib/tokenizer/index.ts#L58>
    // Note: a change to `parse5`, which breaks this, was merged but not released.
    // Investigate when it is.
    // To do: remove next major.
    /* c8 ignore next 12 -- removed in <https://github.com/inikulin/parse5/pull/897> */ if (state.parser.tokenizer.state === 72 /* NAMED_CHARACTER_REFERENCE */  || // @ts-expect-error: removed.
    state.parser.tokenizer.state === 78 /* NUMERIC_CHARACTER_REFERENCE_END */ ) {
        state.parser.tokenizer.preprocessor.lastChunkWritten = true;
        /** @type {number} */ // @ts-expect-error: private.
        const cp = state.parser.tokenizer._consume();
        // @ts-expect-error: private.
        state.parser.tokenizer._callState(cp);
    }
}
/**
 * Crash on an unknown node.
 *
 * @param {unknown} node_
 *   unknown node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Never.
 */ function $c58a141a6871fca8$var$unknown(node_, state) {
    const node = /** @type {Nodes} */ node_;
    if (state.options.passThrough && state.options.passThrough.includes(node.type)) $c58a141a6871fca8$var$stitch(node, state);
    else {
        let extra = '';
        if ($c58a141a6871fca8$var$knownMdxNames.has(node.type)) extra = ". It looks like you are using MDX nodes with `hast-util-raw` (or `rehype-raw`). If you use this because you are using remark or rehype plugins that inject `'html'` nodes, then please raise an issue with that plugin, as its a bad and slow idea. If you use this because you are using markdown syntax, then you have to configure this utility (or plugin) to pass through these nodes (see `passThrough` in docs), but you can also migrate to use the MDX syntax";
        throw new Error('Cannot compile `' + node.type + '` node' + extra);
    }
}
/**
 * Reset the tokenizer of a parser.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Point | undefined} point
 *   Point.
 * @returns {undefined}
 *   Nothing.
 */ function $c58a141a6871fca8$var$resetTokenizer(state, point) {
    $c58a141a6871fca8$var$setPoint(state, point);
    // Process final characters if they’re still there after hibernating.
    /** @type {Token.CharacterToken} */ // @ts-expect-error: private.
    const token = state.parser.tokenizer.currentCharacterToken;
    if (token && token.location) {
        token.location.endLine = state.parser.tokenizer.preprocessor.line;
        token.location.endCol = state.parser.tokenizer.preprocessor.col + 1;
        token.location.endOffset = state.parser.tokenizer.preprocessor.offset + 1;
        // @ts-expect-error: private.
        state.parser.currentToken = token;
        // @ts-expect-error: private.
        state.parser._processToken(state.parser.currentToken);
    }
    // Reset tokenizer:
    // See: <https://github.com/inikulin/parse5/blob/6f7ca60/packages/parse5/lib/tokenizer/index.ts#L187-L223>.
    // Especially putting it back in the `data` state is useful: some elements,
    // like textareas and iframes, change the state.
    // See GH-7.
    // But also if broken HTML is in `raw`, and then a correct element is given.
    // See GH-11.
    // @ts-expect-error: private.
    state.parser.tokenizer.paused = false;
    // @ts-expect-error: private.
    state.parser.tokenizer.inLoop = false;
    // Note: don’t reset `state`, `inForeignNode`, or `lastStartTagName`, we
    // manually update those when needed.
    state.parser.tokenizer.active = false;
    // @ts-expect-error: private.
    state.parser.tokenizer.returnState = (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).DATA;
    // @ts-expect-error: private.
    state.parser.tokenizer.charRefCode = -1;
    // @ts-expect-error: private.
    state.parser.tokenizer.consumedAfterSnapshot = -1;
    // @ts-expect-error: private.
    state.parser.tokenizer.currentLocation = null;
    // @ts-expect-error: private.
    state.parser.tokenizer.currentCharacterToken = null;
    // @ts-expect-error: private.
    state.parser.tokenizer.currentToken = null;
    // @ts-expect-error: private.
    state.parser.tokenizer.currentAttr = {
        name: '',
        value: ''
    };
}
/**
 * Set current location.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Point | undefined} point
 *   Point.
 * @returns {undefined}
 *   Nothing.
 */ function $c58a141a6871fca8$var$setPoint(state, point) {
    if (point && point.offset !== undefined) {
        /** @type {Token.Location} */ const location = {
            startLine: point.line,
            startCol: point.column,
            startOffset: point.offset,
            endLine: -1,
            endCol: -1,
            endOffset: -1
        };
        // @ts-expect-error: private.
        // type-coverage:ignore-next-line
        state.parser.tokenizer.preprocessor.lineStartPos = -point.column + 1 // Looks weird, but ensures we get correct positional info.
        ;
        state.parser.tokenizer.preprocessor.droppedBufferSize = point.offset;
        state.parser.tokenizer.preprocessor.line = point.line;
        // @ts-expect-error: private.
        state.parser.tokenizer.currentLocation = location;
    }
}
/**
 * Emit a start tag.
 *
 * @param {Element} node
 *   Element.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */ function $c58a141a6871fca8$var$startTag(node, state) {
    const tagName = node.tagName.toLowerCase();
    // Ignore tags if we’re in plain text.
    if (state.parser.tokenizer.state === (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).PLAINTEXT) return;
    $c58a141a6871fca8$var$resetTokenizer(state, (0, $9861e7b4f8df2806$export$771bf3e4949bfbee)(node));
    const current = state.parser.openElements.current;
    let ns = 'namespaceURI' in current ? current.namespaceURI : (0, $1ef3bf91500f5903$export$f9bfcc6efbcb9478).html;
    if (ns === (0, $1ef3bf91500f5903$export$f9bfcc6efbcb9478).html && tagName === 'svg') ns = (0, $1ef3bf91500f5903$export$f9bfcc6efbcb9478).svg;
    const result = (0, $2e94052ec8d06cd1$export$b4cf803c867502fc)(// Shallow clone to not delve into `children`: we only need the attributes.
    {
        ...node,
        children: []
    }, {
        space: ns === (0, $1ef3bf91500f5903$export$f9bfcc6efbcb9478).svg ? 'svg' : 'html'
    });
    /** @type {Token.TagToken} */ const tag = {
        type: (0, $be390ad8d330a451$exports).TokenType.START_TAG,
        tagName: tagName,
        tagID: (0, $c2855a9ccb69df69$exports).getTagID(tagName),
        // We always send start and end tags.
        selfClosing: false,
        ackSelfClosing: false,
        // Always element.
        /* c8 ignore next */ attrs: 'attrs' in result ? result.attrs : [],
        location: $c58a141a6871fca8$var$createParse5Location(node)
    };
    // The HTML parsing algorithm works by doing half of the state management in
    // the tokenizer and half in the parser.
    // We can’t use the tokenizer here, as we don’t have strings.
    // So we act *as if* the tokenizer emits tokens:
    // @ts-expect-error: private.
    state.parser.currentToken = tag;
    // @ts-expect-error: private.
    state.parser._processToken(state.parser.currentToken);
    // …but then we still need a bunch of work that the tokenizer would normally
    // do, such as:
    // Set a tag name, similar to how the tokenizer would do it.
    state.parser.tokenizer.lastStartTagName = tagName;
// `inForeignNode` is correctly set by the parser.
}
/**
 * Emit an end tag.
 *
 * @param {Element} node
 *   Element.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */ function $c58a141a6871fca8$var$endTag(node, state) {
    const tagName = node.tagName.toLowerCase();
    // Do not emit closing tags for HTML void elements.
    if (!state.parser.tokenizer.inForeignNode && (0, $fe4fce3fd1fee116$export$762508062d068de).includes(tagName)) return;
    // Ignore tags if we’re in plain text.
    if (state.parser.tokenizer.state === (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).PLAINTEXT) return;
    $c58a141a6871fca8$var$resetTokenizer(state, (0, $9861e7b4f8df2806$export$da309cdce9dc2a25)(node));
    /** @type {Token.TagToken} */ const tag = {
        type: (0, $be390ad8d330a451$exports).TokenType.END_TAG,
        tagName: tagName,
        tagID: (0, $c2855a9ccb69df69$exports).getTagID(tagName),
        selfClosing: false,
        ackSelfClosing: false,
        attrs: [],
        location: $c58a141a6871fca8$var$createParse5Location(node)
    };
    // The HTML parsing algorithm works by doing half of the state management in
    // the tokenizer and half in the parser.
    // We can’t use the tokenizer here, as we don’t have strings.
    // So we act *as if* the tokenizer emits tokens:
    // @ts-expect-error: private.
    state.parser.currentToken = tag;
    // @ts-expect-error: private.
    state.parser._processToken(state.parser.currentToken);
    // …but then we still need a bunch of work that the tokenizer would normally
    // do, such as:
    // Switch back to the data state after alternative states that don’t accept
    // tags:
    if (// Current element is closed.
    tagName === state.parser.tokenizer.lastStartTagName && // `<textarea>` and `<title>`
    (state.parser.tokenizer.state === (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).RCDATA || // `<iframe>`, `<noembed>`, `<noframes>`, `<style>`, `<xmp>`
    state.parser.tokenizer.state === (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).RAWTEXT || // `<script>`
    state.parser.tokenizer.state === (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).SCRIPT_DATA)) state.parser.tokenizer.state = (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).DATA;
}
/**
 * Check if `node` represents a whole document or a fragment.
 *
 * @param {Nodes} node
 *   hast node.
 * @returns {boolean}
 *   Whether this represents a whole document or a fragment.
 */ function $c58a141a6871fca8$var$documentMode(node) {
    const head = node.type === 'root' ? node.children[0] : node;
    return Boolean(head && (head.type === 'doctype' || head.type === 'element' && head.tagName.toLowerCase() === 'html'));
}
/**
 * Get a `parse5` location from a node.
 *
 * @param {Nodes | Stitch} node
 *   hast node.
 * @returns {Token.Location}
 *   `parse5` location.
 */ function $c58a141a6871fca8$var$createParse5Location(node) {
    const start = (0, $9861e7b4f8df2806$export$771bf3e4949bfbee)(node) || {
        line: undefined,
        column: undefined,
        offset: undefined
    };
    const end = (0, $9861e7b4f8df2806$export$da309cdce9dc2a25)(node) || {
        line: undefined,
        column: undefined,
        offset: undefined
    };
    /** @type {Record<keyof Token.Location, number | undefined>} */ const location = {
        startLine: start.line,
        startCol: start.column,
        startOffset: start.offset,
        endLine: end.line,
        endCol: end.column,
        endOffset: end.offset
    };
    // @ts-expect-error: unist point values can be `undefined` in hast, which
    // `parse5` types don’t want.
    return location;
}
/**
 * @template {Nodes} NodeType
 *   Node type.
 * @param {NodeType} node
 *   Node to clone.
 * @returns {NodeType}
 *   Cloned node, without children.
 */ function $c58a141a6871fca8$var$cloneWithoutChildren(node) {
    return 'children' in node ? (0, $e46c0242ff031819$export$2e2bcd8739ae039)({
        ...node,
        children: []
    }) : (0, $e46c0242ff031819$export$2e2bcd8739ae039)(node);
}


function $f9f41141c2cb11d3$export$2e2bcd8739ae039(options) {
    /**
   * @param {Root} tree
   *   Tree.
   * @param {VFile} file
   *   File.
   * @returns {Root}
   *   New tree.
   */ return function(tree, file) {
        // Assume root in -> root out.
        const result = /** @type {Root} */ (0, $c58a141a6871fca8$export$1776c186c69df29e)(tree, {
            ...options,
            file: file
        });
        return result;
    };
}





var $7fPBF = parcelRequire("7fPBF");
/**
 * @import {Element, ElementContent, Nodes, Parents, Root} from 'hast'
 * @import {ComponentProps, ElementType, ReactElement} from 'react'
 * @import {Options as RemarkRehypeOptions} from 'remark-rehype'
 * @import {BuildVisitor} from 'unist-util-visit'
 * @import {PluggableList} from 'unified'
 */ /**
 * @callback AllowElement
 *   Filter elements.
 * @param {Readonly<Element>} element
 *   Element to check.
 * @param {number} index
 *   Index of `element` in `parent`.
 * @param {Readonly<Parents> | undefined} parent
 *   Parent of `element`.
 * @returns {boolean | null | undefined}
 *   Whether to allow `element` (default: `false`).
 */ /**
 * @typedef ExtraProps
 *   Extra fields we pass.
 * @property {Element | undefined} [node]
 *   passed when `passNode` is on.
 */ /**
 * @typedef {{
 *   [Key in Extract<ElementType, string>]?: ElementType<ComponentProps<Key> & ExtraProps>
 * }} Components
 *   Map tag names to components.
 */ /**
 * @typedef Deprecation
 *   Deprecation.
 * @property {string} from
 *   Old field.
 * @property {string} id
 *   ID in readme.
 * @property {keyof Options} [to]
 *   New field.
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {AllowElement | null | undefined} [allowElement]
 *   Filter elements (optional);
 *   `allowedElements` / `disallowedElements` is used first.
 * @property {ReadonlyArray<string> | null | undefined} [allowedElements]
 *   Tag names to allow (default: all tag names);
 *   cannot combine w/ `disallowedElements`.
 * @property {string | null | undefined} [children]
 *   Markdown.
 * @property {string | null | undefined} [className]
 *   Wrap in a `div` with this class name.
 * @property {Components | null | undefined} [components]
 *   Map tag names to components.
 * @property {ReadonlyArray<string> | null | undefined} [disallowedElements]
 *   Tag names to disallow (default: `[]`);
 *   cannot combine w/ `allowedElements`.
 * @property {PluggableList | null | undefined} [rehypePlugins]
 *   List of rehype plugins to use.
 * @property {PluggableList | null | undefined} [remarkPlugins]
 *   List of remark plugins to use.
 * @property {Readonly<RemarkRehypeOptions> | null | undefined} [remarkRehypeOptions]
 *   Options to pass through to `remark-rehype`.
 * @property {boolean | null | undefined} [skipHtml=false]
 *   Ignore HTML in markdown completely (default: `false`).
 * @property {boolean | null | undefined} [unwrapDisallowed=false]
 *   Extract (unwrap) what’s in disallowed elements (default: `false`);
 *   normally when say `strong` is not allowed, it and it’s children are dropped,
 *   with `unwrapDisallowed` the element itself is replaced by its children.
 * @property {UrlTransform | null | undefined} [urlTransform]
 *   Change URLs (default: `defaultUrlTransform`)
 */ /**
 * @callback UrlTransform
 *   Transform all URLs.
 * @param {string} url
 *   URL.
 * @param {string} key
 *   Property name (example: `'href'`).
 * @param {Readonly<Element>} node
 *   Node.
 * @returns {string | null | undefined}
 *   Transformed URL (optional).
 */ 








const $82a842773b01cef7$var$changelog = 'https://github.com/remarkjs/react-markdown/blob/main/changelog.md';
/** @type {PluggableList} */ const $82a842773b01cef7$var$emptyPlugins = [];
/** @type {Readonly<RemarkRehypeOptions>} */ const $82a842773b01cef7$var$emptyRemarkRehypeOptions = {
    allowDangerousHtml: true
};
const $82a842773b01cef7$var$safeProtocol = /^(https?|ircs?|mailto|xmpp)$/i;
// Mutable because we `delete` any time it’s used and a message is sent.
/** @type {ReadonlyArray<Readonly<Deprecation>>} */ const $82a842773b01cef7$var$deprecations = [
    {
        from: 'astPlugins',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'allowDangerousHtml',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'allowNode',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'allowElement'
    },
    {
        from: 'allowedTypes',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'allowedElements'
    },
    {
        from: 'disallowedTypes',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'disallowedElements'
    },
    {
        from: 'escapeHtml',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'includeElementIndex',
        id: '#remove-includeelementindex'
    },
    {
        from: 'includeNodeIndex',
        id: 'change-includenodeindex-to-includeelementindex'
    },
    {
        from: 'linkTarget',
        id: 'remove-linktarget'
    },
    {
        from: 'plugins',
        id: 'change-plugins-to-remarkplugins',
        to: 'remarkPlugins'
    },
    {
        from: 'rawSourcePos',
        id: '#remove-rawsourcepos'
    },
    {
        from: 'renderers',
        id: 'change-renderers-to-components',
        to: 'components'
    },
    {
        from: 'source',
        id: 'change-source-to-children',
        to: 'children'
    },
    {
        from: 'sourcePos',
        id: '#remove-sourcepos'
    },
    {
        from: 'transformImageUri',
        id: '#add-urltransform',
        to: 'urlTransform'
    },
    {
        from: 'transformLinkUri',
        id: '#add-urltransform',
        to: 'urlTransform'
    }
];
function $82a842773b01cef7$export$7460c8b7e4ce9582(options) {
    const allowedElements = options.allowedElements;
    const allowElement = options.allowElement;
    const children = options.children || '';
    const className = options.className;
    const components = options.components;
    const disallowedElements = options.disallowedElements;
    const rehypePlugins = options.rehypePlugins || $82a842773b01cef7$var$emptyPlugins;
    const remarkPlugins = options.remarkPlugins || $82a842773b01cef7$var$emptyPlugins;
    const remarkRehypeOptions = options.remarkRehypeOptions ? {
        ...options.remarkRehypeOptions,
        ...$82a842773b01cef7$var$emptyRemarkRehypeOptions
    } : $82a842773b01cef7$var$emptyRemarkRehypeOptions;
    const skipHtml = options.skipHtml;
    const unwrapDisallowed = options.unwrapDisallowed;
    const urlTransform = options.urlTransform || $82a842773b01cef7$export$ca5e94754123e2f3;
    const processor = (0, $82354957eb1a51f9$export$7cc1b2fe10c52bb)().use((0, $4f339a22525673d0$export$2e2bcd8739ae039)).use(remarkPlugins).use((0, $74ce0141155f6a3a$export$2e2bcd8739ae039), remarkRehypeOptions).use(rehypePlugins);
    const file = new (0, $365ad175729fa366$export$93dff69eb10dc7ce)();
    if (typeof children === 'string') file.value = children;
    else (0, $5f7e7f29fdd0c06b$export$565e9d9bd6b6e0d4)('Unexpected value `' + children + '` for `children` prop, expected `string`');
    if (allowedElements && disallowedElements) (0, $5f7e7f29fdd0c06b$export$565e9d9bd6b6e0d4)('Unexpected combined `allowedElements` and `disallowedElements`, expected one or the other');
    for (const deprecation of $82a842773b01cef7$var$deprecations)if (Object.hasOwn(options, deprecation.from)) (0, $5f7e7f29fdd0c06b$export$565e9d9bd6b6e0d4)('Unexpected `' + deprecation.from + '` prop, ' + (deprecation.to ? 'use `' + deprecation.to + '` instead' : 'remove it') + ' (see <' + $82a842773b01cef7$var$changelog + '#' + deprecation.id + '> for more info)');
    const mdastTree = processor.parse(file);
    /** @type {Nodes} */ let hastTree = processor.runSync(mdastTree, file);
    // Wrap in `div` if there’s a class name.
    if (className) hastTree = {
        type: 'element',
        tagName: 'div',
        properties: {
            className: className
        },
        // Assume no doctypes.
        children: /** @type {Array<ElementContent>} */ hastTree.type === 'root' ? hastTree.children : [
            hastTree
        ]
    };
    (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(hastTree, transform);
    return (0, $bcaef7e086af7de5$export$59c10052b2dee561)(hastTree, {
        Fragment: $824c049f32d4395d$exports.Fragment,
        components: // @ts-expect-error
        // React components are allowed to return numbers,
        // but not according to the types in hast-util-to-jsx-runtime
        components,
        ignoreInvalidStyle: true,
        jsx: $824c049f32d4395d$exports.jsx,
        jsxs: $824c049f32d4395d$exports.jsxs,
        passKeys: true,
        passNode: true
    });
    /** @type {BuildVisitor<Root>} */ function transform(node, index, parent) {
        if (node.type === 'raw' && parent && typeof index === 'number') {
            if (skipHtml) parent.children.splice(index, 1);
            else parent.children[index] = {
                type: 'text',
                value: node.value
            };
            return index;
        }
        if (node.type === 'element') {
            /** @type {string} */ let key;
            for(key in 0, $1389ec48924c67a6$export$de3e062aedff083a)if (Object.hasOwn((0, $1389ec48924c67a6$export$de3e062aedff083a), key) && Object.hasOwn(node.properties, key)) {
                const value = node.properties[key];
                const test = (0, $1389ec48924c67a6$export$de3e062aedff083a)[key];
                if (test === null || test.includes(node.tagName)) node.properties[key] = urlTransform(String(value || ''), key, node);
            }
        }
        if (node.type === 'element') {
            let remove = allowedElements ? !allowedElements.includes(node.tagName) : disallowedElements ? disallowedElements.includes(node.tagName) : false;
            if (!remove && allowElement && typeof index === 'number') remove = !allowElement(node, index, parent);
            if (remove && parent && typeof index === 'number') {
                if (unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
                else parent.children.splice(index, 1);
                return index;
            }
        }
    }
}
function $82a842773b01cef7$export$ca5e94754123e2f3(value) {
    // Same as:
    // <https://github.com/micromark/micromark/blob/929275e/packages/micromark-util-sanitize-uri/dev/index.js#L34>
    // But without the `encode` part.
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash !== -1 && colon > slash || questionMark !== -1 && colon > questionMark || numberSign !== -1 && colon > numberSign || // It is a protocol, it should be allowed.
    $82a842773b01cef7$var$safeProtocol.test(value.slice(0, colon))) return value;
    return '';
}





const $e23aa99c2e71581e$var$alertRegex = /^\[!(NOTE|TIP|IMPORTANT|WARNING|CAUTION)\]/i;
const $e23aa99c2e71581e$var$alertLegacyRegex = /^\[!(NOTE|TIP|IMPORTANT|WARNING|CAUTION)(\/.*)?\]/i;
const $e23aa99c2e71581e$export$a7abfbfd1870441d = ({ legacyTitle: legacyTitle = false, tagName: tagName = "div" } = {})=>{
    return (tree)=>{
        (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(tree, "blockquote", (node, index, parent)=>{
            let alertType = '';
            let title = '';
            let isNext = true;
            let child = node.children.map((item)=>{
                if (isNext && item.type === "paragraph") {
                    const firstNode = item.children[0];
                    const text = firstNode.type === 'text' ? firstNode.value : '';
                    const reg = legacyTitle ? $e23aa99c2e71581e$var$alertLegacyRegex : $e23aa99c2e71581e$var$alertRegex;
                    const match = text.match(reg);
                    if (match) {
                        isNext = false;
                        alertType = match[1].toLocaleLowerCase();
                        title = legacyTitle ? match[2] || alertType.toLocaleUpperCase() : alertType.toLocaleUpperCase();
                        if (text.includes('\n')) item.children[0] = {
                            type: 'text',
                            value: text.replace(reg, '').replace(/^\n+/, '')
                        };
                        if (!text.includes('\n')) {
                            const itemChild = [];
                            item.children.forEach((item, idx)=>{
                                if (idx == 0) return;
                                if (idx == 1 && item.type === 'break') return;
                                itemChild.push(item);
                            });
                            item.children = [
                                ...itemChild
                            ];
                        }
                    }
                }
                return item;
            });
            if (!!alertType) {
                node.data = {
                    hName: tagName,
                    hProperties: {
                        class: `markdown-alert markdown-alert-${alertType}`,
                        dir: 'auto'
                    }
                };
                child.unshift({
                    type: "paragraph",
                    children: [
                        $e23aa99c2e71581e$export$48ba2a4751b6e66d(alertType),
                        {
                            type: "text",
                            value: title.replace(/^\//, '')
                        }
                    ],
                    data: {
                        hProperties: {
                            class: "markdown-alert-title",
                            dir: "auto"
                        }
                    }
                });
            }
            node.children = [
                ...child
            ];
        });
    };
};
var $e23aa99c2e71581e$export$2e2bcd8739ae039 = $e23aa99c2e71581e$export$a7abfbfd1870441d;
function $e23aa99c2e71581e$export$48ba2a4751b6e66d(type) {
    let pathD = $e23aa99c2e71581e$var$pathData[type] ?? '';
    return {
        type: "emphasis",
        data: {
            hName: "svg",
            hProperties: {
                class: "octicon",
                viewBox: '0 0 16 16',
                width: '16',
                height: '16',
                ariaHidden: 'true'
            }
        },
        children: [
            {
                type: "emphasis",
                data: {
                    hName: "path",
                    hProperties: {
                        d: pathD
                    }
                },
                children: []
            }
        ]
    };
}
const $e23aa99c2e71581e$var$pathData = {
    note: 'M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM6.5 7.75A.75.75 0 0 1 7.25 7h1a.75.75 0 0 1 .75.75v2.75h.25a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1 0-1.5h.25v-2h-.25a.75.75 0 0 1-.75-.75ZM8 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z',
    tip: 'M8 1.5c-2.363 0-4 1.69-4 3.75 0 .984.424 1.625.984 2.304l.214.253c.223.264.47.556.673.848.284.411.537.896.621 1.49a.75.75 0 0 1-1.484.211c-.04-.282-.163-.547-.37-.847a8.456 8.456 0 0 0-.542-.68c-.084-.1-.173-.205-.268-.32C3.201 7.75 2.5 6.766 2.5 5.25 2.5 2.31 4.863 0 8 0s5.5 2.31 5.5 5.25c0 1.516-.701 2.5-1.328 3.259-.095.115-.184.22-.268.319-.207.245-.383.453-.541.681-.208.3-.33.565-.37.847a.751.751 0 0 1-1.485-.212c.084-.593.337-1.078.621-1.489.203-.292.45-.584.673-.848.075-.088.147-.173.213-.253.561-.679.985-1.32.985-2.304 0-2.06-1.637-3.75-4-3.75ZM5.75 12h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5ZM6 15.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z',
    important: 'M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v9.5A1.75 1.75 0 0 1 14.25 13H8.06l-2.573 2.573A1.458 1.458 0 0 1 3 14.543V13H1.75A1.75 1.75 0 0 1 0 11.25Zm1.75-.25a.25.25 0 0 0-.25.25v9.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25Zm7 2.25v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 1.5 0ZM9 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
    warning: 'M6.457 1.047c.659-1.234 2.427-1.234 3.086 0l6.082 11.378A1.75 1.75 0 0 1 14.082 15H1.918a1.75 1.75 0 0 1-1.543-2.575Zm1.763.707a.25.25 0 0 0-.44 0L1.698 13.132a.25.25 0 0 0 .22.368h12.164a.25.25 0 0 0 .22-.368Zm.53 3.996v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 1.5 0ZM9 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
    caution: 'M4.47.22A.749.749 0 0 1 5 0h6c.199 0 .389.079.53.22l4.25 4.25c.141.14.22.331.22.53v6a.749.749 0 0 1-.22.53l-4.25 4.25A.749.749 0 0 1 11 16H5a.749.749 0 0 1-.53-.22L.22 11.53A.749.749 0 0 1 0 11V5c0-.199.079-.389.22-.53Zm.84 1.28L1.5 5.31v5.38l3.81 3.81h5.38l3.81-3.81V5.31L10.69 1.5ZM8 4a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 8 4Zm0 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z'
};


var $598ebbeaa9d76cf6$exports = {};
/**! 
 * @uiw/copy-to-clipboard v1.0.20 
 * Copy to clipboard. 
 * 
 * Copyright (c) 2026 Kenny Wang 
 * https://github.com/uiwjs/copy-to-clipboard.git 
 * 
 * @website: https://uiwjs.github.io/copy-to-clipboard
 
 * Licensed under the MIT license 
 */ (function(global, factory) {
    $598ebbeaa9d76cf6$exports = factory();
})($598ebbeaa9d76cf6$exports, function() {
    'use strict';
    /**
   * *** This styling is an extra step which is likely not required. ***
   * https://github.com/w3c/clipboard-apis/blob/master/explainer.adoc#writing-to-the-clipboard
   * 
   * Why is it here? To ensure:
   * 
   * 1. the element is able to have focus and selection.
   * 2. if element was to flash render it has minimal visual impact.
   * 3. less flakyness with selection and copying which **might** occur if
   *     the textarea element is not visible.
   *
   *   The likelihood is the element won't even render, not even a flash,
   *   so some of these are just precautions. However in IE the element
   *   is visible whilst the popup box asking the user for permission for
   *   the web page to copy to the clipboard.
   *  
   *   Place in top-left corner of screen regardless of scroll position.
   *
   * @typedef CopyTextToClipboard
   * @property {(text: string, method?: (isCopy: boolean) => void) => void} void
   * @returns {void}
   * 
   * @param {string} text 
   * @param {CopyTextToClipboard} cb 
   */ function copyTextToClipboard(text, cb) {
        if (typeof document === "undefined") return;
        const el = document.createElement('textarea');
        el.value = text;
        el.setAttribute('readonly', '');
        el.style = {
            position: 'absolute',
            left: '-9999px'
        };
        document.body.appendChild(el);
        const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
        el.select();
        let isCopy = false;
        try {
            const successful = document.execCommand('copy');
            isCopy = !!successful;
        } catch (err) {
            isCopy = false;
        }
        document.body.removeChild(el);
        if (selected && document.getSelection) {
            document.getSelection().removeAllRanges();
            document.getSelection().addRange(selected);
        }
        cb && cb(isCopy);
    }
    return copyTextToClipboard;
});



var $7fPBF = parcelRequire("7fPBF");
function $dc74e42b6f513323$var$getParentElement(target) {
    if (!target) return null;
    var dom = target;
    if (dom.dataset.code && dom.classList.contains('copied')) return dom;
    if (dom.parentElement) return $dc74e42b6f513323$var$getParentElement(dom.parentElement);
    return null;
}
function $dc74e42b6f513323$export$89911e2cdbb3cf4e(container) {
    var handle = (event)=>{
        var target = $dc74e42b6f513323$var$getParentElement(event.target);
        if (!target) return;
        target.classList.add('active');
        (0, (/*@__PURE__*/$parcel$interopDefault($598ebbeaa9d76cf6$exports)))(target.dataset.code, function() {
            setTimeout(()=>{
                target.classList.remove('active');
            }, 2000);
        });
    };
    (0, $7fPBF.useEffect)(()=>{
        var _container$current, _container$current2;
        (_container$current = container.current) == null || _container$current.removeEventListener('click', handle, false);
        (_container$current2 = container.current) == null || _container$current2.addEventListener('click', handle, false);
        return ()=>{
            var _container$current3;
            (_container$current3 = container.current) == null || _container$current3.removeEventListener('click', handle, false);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        container
    ]);
}




var $efac3f5f92b18b5b$var$_excluded = [
    "prefixCls",
    "className",
    "source",
    "style",
    "disableCopy",
    "skipHtml",
    "onScroll",
    "onMouseOver",
    "pluginsFilter",
    "rehypeRewrite",
    "wrapperElement",
    "warpperElement",
    "urlTransform"
];
var $efac3f5f92b18b5b$var$defaultUrlTransform = (url)=>url;
var $efac3f5f92b18b5b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef((props, ref)=>{
    var { prefixCls: prefixCls = 'wmde-markdown wmde-markdown-color', className: className, source: source, style: style, disableCopy: disableCopy = false, skipHtml: skipHtml = true, onScroll: onScroll, onMouseOver: onMouseOver, pluginsFilter: pluginsFilter, wrapperElement: wrapperElement = {}, warpperElement: warpperElement = {}, urlTransform: urlTransform } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $efac3f5f92b18b5b$var$_excluded);
    var mdp = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
    (0, $7fPBF.useImperativeHandle)(ref, ()=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
            mdp: mdp
        }), [
        mdp,
        props
    ]);
    var cls = (prefixCls || '') + " " + (className || '');
    (0, $dc74e42b6f513323$export$89911e2cdbb3cf4e)(mdp);
    var rehypePlugins = [
        ...other.rehypePlugins || []
    ];
    var customProps = {
        allowElement: (element, index, parent)=>{
            if (other.allowElement) return other.allowElement(element, index, parent);
            return /^[A-Za-z0-9]+$/.test(element.tagName);
        }
    };
    if (!skipHtml) rehypePlugins.push((0, $f9f41141c2cb11d3$export$2e2bcd8739ae039));
    var remarkPlugins = [
        (0, $e23aa99c2e71581e$export$a7abfbfd1870441d),
        ...other.remarkPlugins || [],
        (0, $78aec921ddca40c1$export$2e2bcd8739ae039)
    ];
    var wrapperProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, warpperElement, wrapperElement);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: mdp,
        onScroll: onScroll,
        onMouseOver: onMouseOver
    }, wrapperProps, {
        className: cls,
        style: style,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $82a842773b01cef7$export$7460c8b7e4ce9582), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, customProps, other, {
            skipHtml: !skipHtml,
            urlTransform: urlTransform || $efac3f5f92b18b5b$var$defaultUrlTransform,
            rehypePlugins: pluginsFilter ? pluginsFilter('rehype', rehypePlugins) : rehypePlugins,
            remarkPlugins: pluginsFilter ? pluginsFilter('remark', remarkPlugins) : remarkPlugins,
            children: source || ''
        }))
    }));
});




var $616f52481ce12753$export$bcd9bd23ec5009d2 = function reservedMeta(options) {
    if (options === void 0) options = {};
    return (tree)=>{
        (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(tree, (node)=>{
            if (node.type === 'element' && node.tagName === 'code' && node.data && node.data.meta) node.properties = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, node.properties, {
                'data-meta': String(node.data.meta)
            });
        });
    };
};



var $a9c851889f79086b$export$ff6de02db552a63 = function retrieveMeta(options) {
    if (options === void 0) options = {};
    return (tree)=>{
        (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(tree, (node)=>{
            if (node.type === 'element' && node.tagName === 'code' && node.properties && node.properties['dataMeta']) {
                if (!node.data) node.data = {};
                var metaString = node.properties['dataMeta'];
                if (typeof metaString === 'string') node.data.meta = metaString;
                delete node.properties['dataMeta'];
            }
        });
    };
};



/**
 * @typedef {import('hast').Root} Root
 */ /**
 * @typedef Options
 *   Configuration (optional).
 * @property {string} [prefix='']
 *   Prefix to add in front of `id`s (default: `''`).
 */ // This module is generated by `script/`.
/* eslint-disable no-control-regex, no-misleading-character-class, no-useless-escape */ const $ae487c3cb68e5dd7$export$17b0f4d84dbfeedf = /[\0-\x1F!-,\.\/:-@\[-\^`\{-\xA9\xAB-\xB4\xB6-\xB9\xBB-\xBF\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0378\u0379\u037E\u0380-\u0385\u0387\u038B\u038D\u03A2\u03F6\u0482\u0530\u0557\u0558\u055A-\u055F\u0589-\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u05CF\u05EB-\u05EE\u05F3-\u060F\u061B-\u061F\u066A-\u066D\u06D4\u06DD\u06DE\u06E9\u06FD\u06FE\u0700-\u070F\u074B\u074C\u07B2-\u07BF\u07F6-\u07F9\u07FB\u07FC\u07FE\u07FF\u082E-\u083F\u085C-\u085F\u086B-\u089F\u08B5\u08C8-\u08D2\u08E2\u0964\u0965\u0970\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09F2-\u09FB\u09FD\u09FF\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF0-\u0AF8\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B54\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B70\u0B72-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BF0-\u0BFF\u0C0D\u0C11\u0C29\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5B-\u0C5F\u0C64\u0C65\u0C70-\u0C7F\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0CFF\u0D0D\u0D11\u0D45\u0D49\u0D4F-\u0D53\u0D58-\u0D5E\u0D64\u0D65\u0D70-\u0D79\u0D80\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DE5\u0DF0\u0DF1\u0DF4-\u0E00\u0E3B-\u0E3F\u0E4F\u0E5A-\u0E80\u0E83\u0E85\u0E8B\u0EA4\u0EA6\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F01-\u0F17\u0F1A-\u0F1F\u0F2A-\u0F34\u0F36\u0F38\u0F3A-\u0F3D\u0F48\u0F6D-\u0F70\u0F85\u0F98\u0FBD-\u0FC5\u0FC7-\u0FFF\u104A-\u104F\u109E\u109F\u10C6\u10C8-\u10CC\u10CE\u10CF\u10FB\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u1360-\u137F\u1390-\u139F\u13F6\u13F7\u13FE-\u1400\u166D\u166E\u1680\u169B-\u169F\u16EB-\u16ED\u16F9-\u16FF\u170D\u1715-\u171F\u1735-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17D4-\u17D6\u17D8-\u17DB\u17DE\u17DF\u17EA-\u180A\u180E\u180F\u181A-\u181F\u1879-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191F\u192C-\u192F\u193C-\u1945\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DA-\u19FF\u1A1C-\u1A1F\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1AA6\u1AA8-\u1AAF\u1AC1-\u1AFF\u1B4C-\u1B4F\u1B5A-\u1B6A\u1B74-\u1B7F\u1BF4-\u1BFF\u1C38-\u1C3F\u1C4A-\u1C4C\u1C7E\u1C7F\u1C89-\u1C8F\u1CBB\u1CBC\u1CC0-\u1CCF\u1CD3\u1CFB-\u1CFF\u1DFA\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FBD\u1FBF-\u1FC1\u1FC5\u1FCD-\u1FCF\u1FD4\u1FD5\u1FDC-\u1FDF\u1FED-\u1FF1\u1FF5\u1FFD-\u203E\u2041-\u2053\u2055-\u2070\u2072-\u207E\u2080-\u208F\u209D-\u20CF\u20F1-\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F-\u215F\u2189-\u24B5\u24EA-\u2BFF\u2C2F\u2C5F\u2CE5-\u2CEA\u2CF4-\u2CFF\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D70-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E00-\u2E2E\u2E30-\u3004\u3008-\u3020\u3030\u3036\u3037\u303D-\u3040\u3097\u3098\u309B\u309C\u30A0\u30FB\u3100-\u3104\u3130\u318F-\u319F\u31C0-\u31EF\u3200-\u33FF\u4DC0-\u4DFF\u9FFD-\u9FFF\uA48D-\uA4CF\uA4FE\uA4FF\uA60D-\uA60F\uA62C-\uA63F\uA673\uA67E\uA6F2-\uA716\uA720\uA721\uA789\uA78A\uA7C0\uA7C1\uA7CB-\uA7F4\uA828-\uA82B\uA82D-\uA83F\uA874-\uA87F\uA8C6-\uA8CF\uA8DA-\uA8DF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA954-\uA95F\uA97D-\uA97F\uA9C1-\uA9CE\uA9DA-\uA9DF\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A-\uAA5F\uAA77-\uAA79\uAAC3-\uAADA\uAADE\uAADF\uAAF0\uAAF1\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F\uAB5B\uAB6A-\uAB6F\uABEB\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uD7FF\uE000-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB29\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBB2-\uFBD2\uFD3E-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFC-\uFDFF\uFE10-\uFE1F\uFE30-\uFE32\uFE35-\uFE4C\uFE50-\uFE6F\uFE75\uFEFD-\uFF0F\uFF1A-\uFF20\uFF3B-\uFF3E\uFF40\uFF5B-\uFF65\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFFF]|\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDD3F\uDD75-\uDDFC\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEE1-\uDEFF\uDF20-\uDF2C\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDF9F\uDFC4-\uDFC7\uDFD0\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56-\uDC5F\uDC77-\uDC7F\uDC9F-\uDCDF\uDCF3\uDCF6-\uDCFF\uDD16-\uDD1F\uDD3A-\uDD7F\uDDB8-\uDDBD\uDDC0-\uDDFF\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE36\uDE37\uDE3B-\uDE3E\uDE40-\uDE5F\uDE7D-\uDE7F\uDE9D-\uDEBF\uDEC8\uDEE7-\uDEFF\uDF36-\uDF3F\uDF56-\uDF5F\uDF73-\uDF7F\uDF92-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCFF\uDD28-\uDD2F\uDD3A-\uDE7F\uDEAA\uDEAD-\uDEAF\uDEB2-\uDEFF\uDF1D-\uDF26\uDF28-\uDF2F\uDF51-\uDFAF\uDFC5-\uDFDF\uDFF7-\uDFFF]|\uD804[\uDC47-\uDC65\uDC70-\uDC7E\uDCBB-\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD40-\uDD43\uDD48-\uDD4F\uDD74\uDD75\uDD77-\uDD7F\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDFF\uDE12\uDE38-\uDE3D\uDE3F-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEA9-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC4B-\uDC4F\uDC5A-\uDC5D\uDC62-\uDC7F\uDCC6\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDC1-\uDDD7\uDDDE-\uDDFF\uDE41-\uDE43\uDE45-\uDE4F\uDE5A-\uDE7F\uDEB9-\uDEBF\uDECA-\uDEFF\uDF1B\uDF1C\uDF2C-\uDF2F\uDF3A-\uDFFF]|\uD806[\uDC3B-\uDC9F\uDCEA-\uDCFE\uDD07\uDD08\uDD0A\uDD0B\uDD14\uDD17\uDD36\uDD39\uDD3A\uDD44-\uDD4F\uDD5A-\uDD9F\uDDA8\uDDA9\uDDD8\uDDD9\uDDE2\uDDE5-\uDDFF\uDE3F-\uDE46\uDE48-\uDE4F\uDE9A-\uDE9C\uDE9E-\uDEBF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC37\uDC41-\uDC4F\uDC5A-\uDC71\uDC90\uDC91\uDCA8\uDCB7-\uDCFF\uDD07\uDD0A\uDD37-\uDD39\uDD3B\uDD3E\uDD48-\uDD4F\uDD5A-\uDD5F\uDD66\uDD69\uDD8F\uDD92\uDD99-\uDD9F\uDDAA-\uDEDF\uDEF7-\uDFAF\uDFB1-\uDFFF]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80B\uD80E-\uD810\uD812-\uD819\uD824-\uD82B\uD82D\uD82E\uD830-\uD833\uD837\uD839\uD83D\uD83F\uD87B-\uD87D\uD87F\uD885-\uDB3F\uDB41-\uDBFF][\uDC00-\uDFFF]|\uD80D[\uDC2F-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDECF\uDEEE\uDEEF\uDEF5-\uDEFF\uDF37-\uDF3F\uDF44-\uDF4F\uDF5A-\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDE3F\uDE80-\uDEFF\uDF4B-\uDF4E\uDF88-\uDF8E\uDFA0-\uDFDF\uDFE2\uDFE5-\uDFEF\uDFF2-\uDFFF]|\uD821[\uDFF8-\uDFFF]|\uD823[\uDCD6-\uDCFF\uDD09-\uDFFF]|\uD82C[\uDD1F-\uDD4F\uDD53-\uDD63\uDD68-\uDD6F\uDEFC-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A-\uDC9C\uDC9F-\uDFFF]|\uD834[\uDC00-\uDD64\uDD6A-\uDD6C\uDD73-\uDD7A\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDE41\uDE45-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3\uDFCC\uDFCD]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDCFF\uDD2D-\uDD2F\uDD3E\uDD3F\uDD4A-\uDD4D\uDD4F-\uDEBF\uDEFA-\uDFFF]|\uD83A[\uDCC5-\uDCCF\uDCD7-\uDCFF\uDD4C-\uDD4F\uDD5A-\uDFFF]|\uD83B[\uDC00-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDFFF]|\uD83C[\uDC00-\uDD2F\uDD4A-\uDD4F\uDD6A-\uDD6F\uDD8A-\uDFFF]|\uD83E[\uDC00-\uDFEF\uDFFA-\uDFFF]|\uD869[\uDEDE-\uDEFF]|\uD86D[\uDF35-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDEAF]|\uD87A[\uDFE1-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uD884[\uDF4B-\uDFFF]|\uDB40[\uDC00-\uDCFF\uDDF0-\uDFFF]/g;


const $4d58ce33fc36f101$var$own = Object.hasOwnProperty;
class $4d58ce33fc36f101$export$2e2bcd8739ae039 {
    /**
   * Create a new slug class.
   */ constructor(){
        /** @type {Record<string, number>} */ // eslint-disable-next-line no-unused-expressions
        this.occurrences;
        this.reset();
    }
    /**
   * Generate a unique slug.
  *
  * Tracks previously generated slugs: repeated calls with the same value
  * will result in different slugs.
  * Use the `slug` function to get same slugs.
   *
   * @param  {string} value
   *   String of text to slugify
   * @param  {boolean} [maintainCase=false]
   *   Keep the current case, otherwise make all lowercase
   * @return {string}
   *   A unique slug string
   */ slug(value, maintainCase) {
        const self = this;
        let result = $4d58ce33fc36f101$export$74643d1fe038be1a(value, maintainCase === true);
        const originalSlug = result;
        while($4d58ce33fc36f101$var$own.call(self.occurrences, result)){
            self.occurrences[originalSlug]++;
            result = originalSlug + '-' + self.occurrences[originalSlug];
        }
        self.occurrences[result] = 0;
        return result;
    }
    /**
   * Reset - Forget all previous slugs
   *
   * @return void
   */ reset() {
        this.occurrences = Object.create(null);
    }
}
function $4d58ce33fc36f101$export$74643d1fe038be1a(value, maintainCase) {
    if (typeof value !== 'string') return '';
    if (!maintainCase) value = value.toLowerCase();
    return value.replace((0, $ae487c3cb68e5dd7$export$17b0f4d84dbfeedf), '').replace(/ /g, '-');
}


/**
 * @typedef {import('hast').Nodes} Nodes
 */ /**
 * Get the rank (`1` to `6`) of headings (`h1` to `h6`).
 *
 * @param {Nodes} node
 *   Node to check.
 * @returns {number | undefined}
 *   Rank of the heading or `undefined` if not a heading.
 */ function $bcc3ef519e284ce4$export$82ce812bc3d95a0b(node) {
    const name = node.type === 'element' ? node.tagName.toLowerCase() : '';
    const code = name.length === 2 && name.charCodeAt(0) === 104 /* `h` */  ? name.charCodeAt(1) : 0;
    return code > 48 /* `0` */  && code < 55 /* `7` */  ? code - 48 /* `0` */  : undefined;
}




/** @type {Options} */ const $14d18d8874a9c57e$var$emptyOptions = {};
const $14d18d8874a9c57e$var$slugs = new (0, $4d58ce33fc36f101$export$2e2bcd8739ae039)();
function $14d18d8874a9c57e$export$2e2bcd8739ae039(options) {
    const settings = options || $14d18d8874a9c57e$var$emptyOptions;
    const prefix = settings.prefix || '';
    /**
   * @param {Root} tree
   *   Tree.
   * @returns {undefined}
   *   Nothing.
   */ return function(tree) {
        $14d18d8874a9c57e$var$slugs.reset();
        (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(tree, 'element', function(node) {
            if ((0, $bcc3ef519e284ce4$export$82ce812bc3d95a0b)(node) && !node.properties.id) node.properties.id = prefix + $14d18d8874a9c57e$var$slugs.slug((0, $58714581718e6349$export$f84e8e69fd4488a5)(node));
        });
    };
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Root} Root
 *
 * @typedef {import('hast-util-is-element').Test} Test
 */ /**
 * @typedef {'after' | 'append' | 'before' | 'prepend' | 'wrap'} Behavior
 *   Behavior.
 *
 * @callback Build
 *   Generate content.
 * @param {Readonly<Element>} element
 *   Current heading.
 * @returns {Array<ElementContent> | ElementContent}
 *   Content.
 *
 * @callback BuildProperties
 *   Generate properties.
 * @param {Readonly<Element>} element
 *   Current heading.
 * @returns {Properties}
 *   Properties.
 *
 * @typedef Options
 *   Configuration.
 * @property {Behavior | null | undefined} [behavior='prepend']
 *   How to create links (default: `'prepend'`).
 * @property {Readonly<ElementContent> | ReadonlyArray<ElementContent> | Build | null | undefined} [content]
 *   Content to insert in the link (default: if `'wrap'` then `undefined`,
 *   otherwise `<span class="icon icon-link"></span>`);
 *   if `behavior` is `'wrap'` and `Build` is passed, its result replaces the
 *   existing content, otherwise the content is added after existing content.
 * @property {Readonly<ElementContent> | ReadonlyArray<ElementContent> | Build | null | undefined} [group]
 *   Content to wrap the heading and link with, if `behavior` is `'after'` or
 *   `'before'` (optional).
 * @property {Readonly<Properties> | BuildProperties | null | undefined} [headingProperties]
 *   Extra properties to set on the heading (optional).
 * @property {Readonly<Properties> | BuildProperties | null | undefined} [properties]
 *   Extra properties to set on the link when injecting (default:
 *   `{ariaHidden: true, tabIndex: -1}` if `'append'` or `'prepend'`, otherwise
 *   `undefined`).
 * @property {Test | null | undefined} [test]
 *   Extra test for which headings are linked (optional).
 */ /**
 * @template T
 *   Kind.
 * @typedef {(
 *   T extends Record<any, any>
 *     ? {-readonly [k in keyof T]: Cloneable<T[k]>}
 *     : T
 * )} Cloneable
 *   Deep clone.
 *
 *   See: <https://github.com/microsoft/TypeScript-DOM-lib-generator/issues/1237#issuecomment-1345515448>
 */ 

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Parents} Parents
 */ /**
 * @template Fn
 * @template Fallback
 * @typedef {Fn extends (value: any) => value is infer Thing ? Thing : Fallback} Predicate
 */ /**
 * @callback Check
 *   Check that an arbitrary value is an element.
 * @param {unknown} this
 *   Context object (`this`) to call `test` with
 * @param {unknown} [element]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   Position of `element` in its parent.
 * @param {Parents | null | undefined} [parent]
 *   Parent of `element`.
 * @returns {boolean}
 *   Whether this is an element and passes a test.
 *
 * @typedef {Array<TestFunction | string> | TestFunction | string | null | undefined} Test
 *   Check for an arbitrary element.
 *
 *   * when `string`, checks that the element has that tag name
 *   * when `function`, see `TestFunction`
 *   * when `Array`, checks if one of the subtests pass
 *
 * @callback TestFunction
 *   Check if an element passes a test.
 * @param {unknown} this
 *   The given context.
 * @param {Element} element
 *   An element.
 * @param {number | undefined} [index]
 *   Position of `element` in its parent.
 * @param {Parents | undefined} [parent]
 *   Parent of `element`.
 * @returns {boolean | undefined | void}
 *   Whether this element passes the test.
 *
 *   Note: `void` is included until TS sees no return as `undefined`.
 */ /**
 * Check if `element` is an `Element` and whether it passes the given test.
 *
 * @param element
 *   Thing to check, typically `element`.
 * @param test
 *   Check for a specific element.
 * @param index
 *   Position of `element` in its parent.
 * @param parent
 *   Parent of `element`.
 * @param context
 *   Context object (`this`) to call `test` with.
 * @returns
 *   Whether `element` is an `Element` and passes a test.
 * @throws
 *   When an incorrect `test`, `index`, or `parent` is given; there is no error
 *   thrown when `element` is not a node or not an element.
 */ const $209fa5866cc095a5$export$45a5e7f76e0caa8d = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends TestFunction>(element: unknown, test: Condition, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element & Predicate<Condition, Element>) &
   *   (<Condition extends string>(element: unknown, test: Condition, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element & {tagName: Condition}) &
   *   ((element?: null | undefined) => false) &
   *   ((element: unknown, test?: null | undefined, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element) &
   *   ((element: unknown, test?: Test, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [element]
     * @param {Test | undefined} [test]
     * @param {number | null | undefined} [index]
     * @param {Parents | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function(element, test, index, parent, context) {
    const check = $209fa5866cc095a5$export$26aad476166fd89e(test);
    if (index !== null && index !== undefined && (typeof index !== 'number' || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error('Expected positive finite `index`');
    if (parent !== null && parent !== undefined && (!parent.type || !parent.children)) throw new Error('Expected valid `parent`');
    if ((index === null || index === undefined) !== (parent === null || parent === undefined)) throw new Error('Expected both `index` and `parent`');
    return $209fa5866cc095a5$var$looksLikeAnElement(element) ? check.call(context, element, index, parent) : false;
};
const $209fa5866cc095a5$export$26aad476166fd89e = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends TestFunction>(test: Condition) => (element: unknown, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element & Predicate<Condition, Element>) &
   *   (<Condition extends string>(test: Condition) => (element: unknown, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element & {tagName: Condition}) &
   *   ((test?: null | undefined) => (element?: unknown, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element) &
   *   ((test?: Test) => Check)
   * )}
   */ /**
     * @param {Test | null | undefined} [test]
     * @returns {Check}
     */ function(test) {
    if (test === null || test === undefined) return $209fa5866cc095a5$var$element;
    if (typeof test === 'string') return $209fa5866cc095a5$var$tagNameFactory(test);
    // Assume array.
    if (typeof test === 'object') return $209fa5866cc095a5$var$anyFactory(test);
    if (typeof test === 'function') return $209fa5866cc095a5$var$castFactory(test);
    throw new Error('Expected function, string, or array as `test`');
};
/**
 * Handle multiple tests.
 *
 * @param {Array<TestFunction | string>} tests
 * @returns {Check}
 */ function $209fa5866cc095a5$var$anyFactory(tests) {
    /** @type {Array<Check>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $209fa5866cc095a5$export$26aad476166fd89e(tests[index]);
    return $209fa5866cc095a5$var$castFactory(any);
    /**
   * @this {unknown}
   * @type {TestFunction}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn a string into a test for an element with a certain type.
 *
 * @param {string} check
 * @returns {Check}
 */ function $209fa5866cc095a5$var$tagNameFactory(check) {
    return $209fa5866cc095a5$var$castFactory(tagName);
    /**
   * @param {Element} element
   * @returns {boolean}
   */ function tagName(element) {
        return element.tagName === check;
    }
}
/**
 * Turn a custom test into a test for an element that passes that test.
 *
 * @param {TestFunction} testFunction
 * @returns {Check}
 */ function $209fa5866cc095a5$var$castFactory(testFunction) {
    return check;
    /**
   * @this {unknown}
   * @type {Check}
   */ function check(value, index, parent) {
        return Boolean($209fa5866cc095a5$var$looksLikeAnElement(value) && testFunction.call(this, value, typeof index === 'number' ? index : undefined, parent || undefined));
    }
}
/**
 * Make sure something is an element.
 *
 * @param {unknown} element
 * @returns {element is Element}
 */ function $209fa5866cc095a5$var$element(element) {
    return Boolean(element && typeof element === 'object' && 'type' in element && element.type === 'element' && 'tagName' in element && typeof element.tagName === 'string');
}
/**
 * @param {unknown} value
 * @returns {value is Element}
 */ function $209fa5866cc095a5$var$looksLikeAnElement(value) {
    return value !== null && typeof value === 'object' && 'type' in value && 'tagName' in value;
}



/** @type {Element} */ const $8241da65474efe8a$var$contentDefaults = {
    type: 'element',
    tagName: 'span',
    properties: {
        className: [
            'icon',
            'icon-link'
        ]
    },
    children: []
};
/** @type {Options} */ const $8241da65474efe8a$var$emptyOptions = {};
function $8241da65474efe8a$export$2e2bcd8739ae039(options) {
    const settings = options || $8241da65474efe8a$var$emptyOptions;
    let properties = settings.properties;
    const headingOroperties = settings.headingProperties;
    const behavior = settings.behavior || 'prepend';
    const content = settings.content;
    const group = settings.group;
    const is = (0, $209fa5866cc095a5$export$26aad476166fd89e)(settings.test);
    /** @type {import('unist-util-visit').Visitor<Element>} */ let method;
    if (behavior === 'after' || behavior === 'before') method = around;
    else if (behavior === 'wrap') method = wrap;
    else {
        method = inject;
        if (!properties) properties = {
            ariaHidden: 'true',
            tabIndex: -1
        };
    }
    /**
   * Transform.
   *
   * @param {Root} tree
   *   Tree.
   * @returns {undefined}
   *   Nothing.
   */ return function(tree) {
        (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(tree, 'element', function(node, index, parent) {
            if ((0, $bcc3ef519e284ce4$export$82ce812bc3d95a0b)(node) && node.properties.id && is(node, index, parent)) {
                Object.assign(node.properties, $8241da65474efe8a$var$toProperties(headingOroperties, node));
                return method(node, index, parent);
            }
        });
    };
    /** @type {import('unist-util-visit').Visitor<Element>} */ function inject(node) {
        const children = $8241da65474efe8a$var$toChildren(content || $8241da65474efe8a$var$contentDefaults, node);
        node.children[behavior === 'prepend' ? 'unshift' : 'push']($8241da65474efe8a$var$create(node, $8241da65474efe8a$var$toProperties(properties, node), children));
        return [
            (0, $9ef2eaca0b34953c$export$8773f85c2fb2c116)
        ];
    }
    /** @type {import('unist-util-visit').Visitor<Element>} */ function around(node, index, parent) {
        /* c8 ignore next -- uncommon */ if (typeof index !== 'number' || !parent) return;
        const children = $8241da65474efe8a$var$toChildren(content || $8241da65474efe8a$var$contentDefaults, node);
        const link = $8241da65474efe8a$var$create(node, $8241da65474efe8a$var$toProperties(properties, node), children);
        let nodes = behavior === 'before' ? [
            link,
            node
        ] : [
            node,
            link
        ];
        if (group) {
            const grouping = $8241da65474efe8a$var$toNode(group, node);
            if (grouping && !Array.isArray(grouping) && grouping.type === 'element') {
                grouping.children = nodes;
                nodes = [
                    grouping
                ];
            }
        }
        parent.children.splice(index, 1, ...nodes);
        return [
            (0, $9ef2eaca0b34953c$export$8773f85c2fb2c116),
            index + nodes.length
        ];
    }
    /** @type {import('unist-util-visit').Visitor<Element>} */ function wrap(node) {
        /** @type {Array<ElementContent>} */ let before = node.children;
        /** @type {Array<ElementContent> | ElementContent} */ let after = [];
        if (typeof content === 'function') {
            before = [];
            after = content(node);
        } else if (content) after = $8241da65474efe8a$var$clone(content);
        node.children = [
            $8241da65474efe8a$var$create(node, $8241da65474efe8a$var$toProperties(properties, node), Array.isArray(after) ? [
                ...before,
                ...after
            ] : [
                ...before,
                after
            ])
        ];
        return [
            (0, $9ef2eaca0b34953c$export$8773f85c2fb2c116)
        ];
    }
}
/**
 * Deep clone.
 *
 * @template T
 *   Kind.
 * @param {T} thing
 *   Thing to clone.
 * @returns {Cloneable<T>}
 *   Cloned thing.
 */ function $8241da65474efe8a$var$clone(thing) {
    // Cast because it’s mutable now.
    return /** @type {Cloneable<T>} */ (0, $e46c0242ff031819$export$2e2bcd8739ae039)(thing);
}
/**
 * Create an `a`.
 *
 * @param {Readonly<Element>} node
 *   Related heading.
 * @param {Properties | undefined} properties
 *   Properties to set on the link.
 * @param {Array<ElementContent>} children
 *   Content.
 * @returns {Element}
 *   Link.
 */ function $8241da65474efe8a$var$create(node, properties, children) {
    return {
        type: 'element',
        tagName: 'a',
        properties: {
            ...properties,
            href: '#' + node.properties.id
        },
        children: children
    };
}
/**
 * Turn into children.
 *
 * @param {Readonly<ElementContent> | ReadonlyArray<ElementContent> | Build} value
 *   Content.
 * @param {Readonly<Element>} node
 *   Related heading.
 * @returns {Array<ElementContent>}
 *   Children.
 */ function $8241da65474efe8a$var$toChildren(value, node) {
    const result = $8241da65474efe8a$var$toNode(value, node);
    return Array.isArray(result) ? result : [
        result
    ];
}
/**
 * Turn into a node.
 *
 * @param {Readonly<ElementContent> | ReadonlyArray<ElementContent> | Build} value
 *   Content.
 * @param {Readonly<Element>} node
 *   Related heading.
 * @returns {Array<ElementContent> | ElementContent}
 *   Node.
 */ function $8241da65474efe8a$var$toNode(value, node) {
    if (typeof value === 'function') return value(node);
    return $8241da65474efe8a$var$clone(value);
}
/**
 * Turn into properties.
 *
 * @param {Readonly<Properties> | BuildProperties | null | undefined} value
 *   Properties.
 * @param {Readonly<Element>} node
 *   Related heading.
 * @returns {Properties}
 *   Properties.
 */ function $8241da65474efe8a$var$toProperties(value, node) {
    if (typeof value === 'function') return value(node);
    return value ? $8241da65474efe8a$var$clone(value) : {};
}



const $d3f2ca39d437ddf0$var$rehypeIgnore = (options = {})=>{
    const { openDelimiter: openDelimiter = 'rehype:ignore:start', closeDelimiter: closeDelimiter = 'rehype:ignore:end' } = options;
    return (tree)=>{
        (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(tree, (node, index, parent)=>{
            if (node.type === 'element' || node.type === 'root') {
                // const start = node.children.findIndex((item) => item.type === 'comment' && item.value === openDelimiter);
                // const end = node.children.findIndex((item) => item.type === 'comment' && item.value === closeDelimiter);
                // if (start > -1 && end > -1) {
                //   node.children = node.children.filter((_, idx) => idx < start || idx > end);
                // }
                let start = false;
                node.children = node.children.filter((item)=>{
                    if (item.type === 'raw' || item.type === 'comment') {
                        let str = (item.value || '').trim();
                        str = str.replace(/^<!--(.*?)-->/, '$1');
                        if (str === openDelimiter) {
                            start = true;
                            return false;
                        }
                        if (str === closeDelimiter) {
                            start = false;
                            return false;
                        }
                    }
                    return !start;
                });
            }
        });
    };
};
var $d3f2ca39d437ddf0$export$2e2bcd8739ae039 = $d3f2ca39d437ddf0$var$rehypeIgnore;



var $38e354e0e68a1b87$export$923a4a02e333a06 = {
    type: 'element',
    tagName: 'svg',
    properties: {
        className: 'octicon octicon-link',
        viewBox: '0 0 16 16',
        version: '1.1',
        width: '16',
        height: '16',
        ariaHidden: 'true'
    },
    children: [
        {
            type: 'element',
            tagName: 'path',
            children: [],
            properties: {
                fillRule: 'evenodd',
                d: 'M7.775 3.275a.75.75 0 001.06 1.06l1.25-1.25a2 2 0 112.83 2.83l-2.5 2.5a2 2 0 01-2.83 0 .75.75 0 00-1.06 1.06 3.5 3.5 0 004.95 0l2.5-2.5a3.5 3.5 0 00-4.95-4.95l-1.25 1.25zm-4.69 9.64a2 2 0 010-2.83l2.5-2.5a2 2 0 012.83 0 .75.75 0 001.06-1.06 3.5 3.5 0 00-4.95 0l-2.5 2.5a3.5 3.5 0 004.95 4.95l1.25-1.25a.75.75 0 00-1.06-1.06l-1.25 1.25a2 2 0 01-2.83 0z'
            }
        }
    ]
};


function $8249f70436a6365a$export$9ffdecd63ef0d23f(str) {
    if (str === void 0) str = '';
    return {
        type: 'element',
        tagName: 'div',
        properties: {
            class: 'copied',
            'data-code': str
        },
        children: [
            {
                type: 'element',
                tagName: 'svg',
                properties: {
                    className: 'octicon-copy',
                    ariaHidden: 'true',
                    viewBox: '0 0 16 16',
                    fill: 'currentColor',
                    height: 12,
                    width: 12
                },
                children: [
                    {
                        type: 'element',
                        tagName: 'path',
                        properties: {
                            fillRule: 'evenodd',
                            d: 'M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 010 1.5h-1.5a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-1.5a.75.75 0 011.5 0v1.5A1.75 1.75 0 019.25 16h-7.5A1.75 1.75 0 010 14.25v-7.5z'
                        },
                        children: []
                    },
                    {
                        type: 'element',
                        tagName: 'path',
                        properties: {
                            fillRule: 'evenodd',
                            d: 'M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0114.25 11h-7.5A1.75 1.75 0 015 9.25v-7.5zm1.75-.25a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-7.5a.25.25 0 00-.25-.25h-7.5z'
                        },
                        children: []
                    }
                ]
            },
            {
                type: 'element',
                tagName: 'svg',
                properties: {
                    className: 'octicon-check',
                    ariaHidden: 'true',
                    viewBox: '0 0 16 16',
                    fill: 'currentColor',
                    height: 12,
                    width: 12
                },
                children: [
                    {
                        type: 'element',
                        tagName: 'path',
                        properties: {
                            fillRule: 'evenodd',
                            d: 'M13.78 4.22a.75.75 0 010 1.06l-7.25 7.25a.75.75 0 01-1.06 0L2.22 9.28a.75.75 0 011.06-1.06L6 10.94l6.72-6.72a.75.75 0 011.06 0z'
                        },
                        children: []
                    }
                ]
            }
        ]
    };
}


var $1d3fc30d025817e1$export$44ff98c3c5f3f29e = (disableCopy, rewrite)=>(node, index, parent)=>{
        if (node.type === 'element' && parent && parent.type === 'root' && /h(1|2|3|4|5|6)/.test(node.tagName)) {
            var child = node.children && node.children[0];
            if (child && child.properties && child.properties.ariaHidden === 'true') {
                child.properties = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    class: 'anchor'
                }, child.properties);
                child.children = [
                    (0, $38e354e0e68a1b87$export$923a4a02e333a06)
                ];
            }
        }
        if (node.type === 'element' && node.tagName === 'pre' && !disableCopy) {
            var code = (0, $bcddeefdf0cb0501$export$fdc2b83d227adb1a)(node.children);
            node.children.push((0, $8249f70436a6365a$export$9ffdecd63ef0d23f)(code));
        }
        rewrite && rewrite(node, index === null ? undefined : index, parent === null ? undefined : parent);
    };
var $1d3fc30d025817e1$export$bf2258f12d8e13f4 = [
    (0, $14d18d8874a9c57e$export$2e2bcd8739ae039),
    (0, $8241da65474efe8a$export$2e2bcd8739ae039),
    (0, $d3f2ca39d437ddf0$export$2e2bcd8739ae039)
];





var $7b0fa6cba31fe01a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef((props, ref)=>{
    var _props$disableCopy;
    var rehypePlugins = [
        (0, $616f52481ce12753$export$bcd9bd23ec5009d2),
        (0, $f9f41141c2cb11d3$export$2e2bcd8739ae039),
        (0, $a9c851889f79086b$export$ff6de02db552a63),
        ...(0, $1d3fc30d025817e1$export$bf2258f12d8e13f4),
        [
            (0, $bcddeefdf0cb0501$export$2e2bcd8739ae039),
            {
                rewrite: (0, $1d3fc30d025817e1$export$44ff98c3c5f3f29e)((_props$disableCopy = props.disableCopy) != null ? _props$disableCopy : false, props.rehypeRewrite)
            }
        ],
        [
            (0, $d80b7298c6dd9c3b$export$2e2bcd8739ae039),
            {
                properties: 'attr'
            }
        ],
        ...props.rehypePlugins || [],
        [
            (0, $e62a4495d284aec6$export$2e2bcd8739ae039),
            {
                ignoreMissing: true
            }
        ]
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $efac3f5f92b18b5b$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        rehypePlugins: rehypePlugins,
        ref: ref
    }));
});




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
function $7c2cb0ce17642c75$export$1650419e431d3ba3(state, action) {
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state, action);
}
var $7c2cb0ce17642c75$export$27b8dd149e32f6c7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext({
    markdown: ''
});




var $7fPBF = parcelRequire("7fPBF");




function $da6420f2709698c0$export$2e2bcd8739ae039(props) {
    var { prefixCls: prefixCls, groupName: groupName, commands: commands, children: children } = props || {};
    var { barPopup: barPopup = {} } = (0, $7fPBF.useContext)((0, $7c2cb0ce17642c75$export$27b8dd149e32f6c7));
    return (0, $7fPBF.useMemo)(()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: prefixCls + "-toolbar-child " + (groupName && barPopup[groupName] ? 'active' : ''),
            onClick: (e)=>e.stopPropagation(),
            children: Array.isArray(commands) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f179cc69962c631d$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                commands: commands
            }, props, {
                isChild: true
            })) : children
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        commands,
        barPopup,
        groupName,
        prefixCls
    ]);
}




function $f179cc69962c631d$export$935e16d2d88a04e6(props) {
    var { prefixCls: prefixCls, overflow: overflow } = props;
    var { fullscreen: fullscreen, preview: preview, barPopup: barPopup = {}, components: components, commandOrchestrator: commandOrchestrator, dispatch: dispatch } = (0, $7fPBF.useContext)((0, $7c2cb0ce17642c75$export$27b8dd149e32f6c7));
    var originalOverflow = (0, $7fPBF.useRef)('');
    function handleClick(command, name) {
        if (!dispatch) return;
        var state = {
            barPopup: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, barPopup)
        };
        if (command.keyCommand === 'preview') state.preview = command.value;
        if (command.keyCommand === 'fullscreen') state.fullscreen = !fullscreen;
        if (props.commands && command.keyCommand === 'group') props.commands.forEach((item)=>{
            if (name === item.groupName) state.barPopup[name] = true;
            else if (item.keyCommand) state.barPopup[item.groupName] = false;
        });
        else if (name || command.parent) Object.keys(state.barPopup || {}).forEach((keyName)=>{
            state.barPopup[keyName] = false;
        });
        if (Object.keys(state).length) dispatch((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state));
        commandOrchestrator && commandOrchestrator.executeCommand(command);
    }
    (0, $7fPBF.useEffect)(()=>{
        if (document && overflow) {
            if (fullscreen) // prevent scroll on fullscreen
            document.body.style.overflow = 'hidden';
            else {
                // get the original overflow only the first time
                if (!originalOverflow.current) originalOverflow.current = window.getComputedStyle(document.body, null).overflow;
                // reset to the original overflow
                document.body.style.overflow = originalOverflow.current;
            }
        }
    }, [
        fullscreen,
        originalOverflow,
        overflow
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
        children: (props.commands || []).map((item, idx)=>{
            if (item.keyCommand === 'divider') return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, item.liProps, {
                className: prefixCls + "-toolbar-divider"
            }), idx);
            if (!item.keyCommand) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fPBF.Fragment), {}, idx);
            var activeBtn = fullscreen && item.keyCommand === 'fullscreen' || item.keyCommand === 'preview' && preview === item.value;
            var childNode = item.children && typeof item.children === 'function' ? item.children({
                getState: ()=>commandOrchestrator.getState(),
                textApi: commandOrchestrator ? commandOrchestrator.textApi : undefined,
                close: ()=>handleClick({}, item.groupName),
                execute: ()=>handleClick({
                        execute: item.execute
                    }),
                dispatch: dispatch
            }) : undefined;
            var disabled = barPopup && preview && preview === 'preview' && !/(preview|fullscreen)/.test(item.keyCommand);
            var render = (components == null ? void 0 : components.toolbar) || item.render;
            var com = render && typeof render === 'function' ? render(item, !!disabled, handleClick, idx) : null;
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("li", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, item.liProps, {
                className: activeBtn ? "active" : '',
                children: [
                    com && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(com) && com,
                    !com && !item.buttonProps && item.icon,
                    !com && item.buttonProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement('button', (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                        type: 'button',
                        key: idx,
                        disabled: disabled,
                        'data-name': item.name
                    }, item.buttonProps, {
                        onClick: (evn)=>{
                            evn.stopPropagation();
                            handleClick(item, item.groupName);
                        }
                    }), item.icon),
                    item.children && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $da6420f2709698c0$export$2e2bcd8739ae039), {
                        overflow: overflow,
                        groupName: item.groupName,
                        prefixCls: prefixCls,
                        children: childNode,
                        commands: Array.isArray(item.children) ? item.children : undefined
                    })
                ]
            }), idx);
        })
    });
}
function $f179cc69962c631d$export$2e2bcd8739ae039(props) {
    if (props === void 0) props = {};
    var { prefixCls: prefixCls, isChild: isChild, className: className } = props;
    var { commands: commands, extraCommands: extraCommands } = (0, $7fPBF.useContext)((0, $7c2cb0ce17642c75$export$27b8dd149e32f6c7));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: prefixCls + "-toolbar " + className,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($f179cc69962c631d$export$935e16d2d88a04e6, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
                commands: props.commands || commands || []
            })),
            !isChild && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($f179cc69962c631d$export$935e16d2d88a04e6, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
                commands: extraCommands || []
            }))
        ]
    });
}
function $f179cc69962c631d$export$f8f240f0d25ce088(props) {
    var { hideToolbar: hideToolbar, toolbarBottom: toolbarBottom, placement: placement, overflow: overflow, prefixCls: prefixCls } = props;
    if (hideToolbar || placement === 'bottom' && !toolbarBottom || placement === 'top' && toolbarBottom) return null;
    var cls = toolbarBottom ? 'bottom' : '';
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($f179cc69962c631d$export$2e2bcd8739ae039, {
        prefixCls: prefixCls,
        overflow: overflow,
        className: cls
    });
}





var $7fPBF = parcelRequire("7fPBF");


function $291b77f2b248d49a$var$getCommands(data, resulte) {
    if (data === void 0) data = [];
    if (resulte === void 0) resulte = {};
    data.forEach((item)=>{
        if (item.children && Array.isArray(item.children)) resulte = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, resulte, $291b77f2b248d49a$var$getCommands(item.children || []));
        else if (item.keyCommand && item.shortcuts && item.execute) resulte[item.shortcuts.toLocaleLowerCase()] = item;
    });
    return resulte;
}
function $291b77f2b248d49a$export$2e2bcd8739ae039(e, commands, commandOrchestrator, dispatch, state) {
    if (commands === void 0) commands = [];
    var data = $291b77f2b248d49a$var$getCommands(commands || []);
    var shortcuts = [];
    if (e.altKey) shortcuts.push('alt');
    if (e.shiftKey) shortcuts.push('shift');
    if (e.metaKey) shortcuts.push('cmd');
    if (e.ctrlKey) shortcuts.push('ctrl');
    if (shortcuts.length > 0 && !/(control|alt|meta|shift)/.test(e.key.toLocaleLowerCase())) shortcuts.push(e.key.toLocaleLowerCase());
    if (/escape/.test(e.key.toLocaleLowerCase())) shortcuts.push('escape');
    if (shortcuts.length < 1) return;
    var equal = !!data[shortcuts.join('+')];
    var command = equal ? data[shortcuts.join('+')] : undefined;
    Object.keys(data).forEach((item)=>{
        var isequal = item.split('+').every((v)=>{
            if (/ctrlcmd/.test(v)) return shortcuts.includes('ctrl') || shortcuts.includes('cmd');
            return shortcuts.includes(v);
        });
        if (isequal) command = data[item];
    });
    if (command && commandOrchestrator) {
        e.stopPropagation();
        e.preventDefault();
        commandOrchestrator.executeCommand(command, dispatch, state, shortcuts);
        return;
    }
}


function $53471605b9d4580f$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), e.raw = t, e;
}



var $7fPBF = parcelRequire("7fPBF");
// Note: types exposed from `index.d.ts`
/**
 * @import {Root} from 'hast'
 * @import {Options as FromHtmlOptions} from 'hast-util-from-html'
 * @import {Parser, Processor} from 'unified'
 */ /**
 * @typedef {Omit<FromHtmlOptions, 'onerror'> & RehypeParseFields} Options
 *   Configuration.
 *
 * @typedef RehypeParseFields
 *   Extra fields.
 * @property {boolean | null | undefined} [emitParseErrors=false]
 *   Whether to emit parse errors while parsing (default: `false`).
 *
 *   > 👉 **Note**: parse errors are currently being added to HTML.
 *   > Not all errors emitted by parse5 (or us) are specced yet.
 *   > Some documentation may still be missing.
 */ /**
 * @import {Root} from 'hast'
 * @import {ParserError} from 'parse5'
 * @import {Value} from 'vfile'
 * @import {ErrorCode, Options} from './types.js'
 */ 




/**
 * @typedef ErrorInfo
 *   Info on a `parse5` error.
 * @property {string} reason
 *   Reason of error.
 * @property {string} description
 *   More info on error.
 * @property {false} [url]
 *   Turn off if this is not documented in the html5 spec (optional).
 */ const $ccbec9718b6e8588$export$30f3b02011db23c0 = {
    /** @type {ErrorInfo} */ abandonedHeadElementChild: {
        reason: 'Unexpected metadata element after head',
        description: 'Unexpected element after head. Expected the element before `</head>`',
        url: false
    },
    /** @type {ErrorInfo} */ abruptClosingOfEmptyComment: {
        reason: 'Unexpected abruptly closed empty comment',
        description: 'Unexpected `>` or `->`. Expected `-->` to close comments'
    },
    /** @type {ErrorInfo} */ abruptDoctypePublicIdentifier: {
        reason: 'Unexpected abruptly closed public identifier',
        description: 'Unexpected `>`. Expected a closing `"` or `\'` after the public identifier'
    },
    /** @type {ErrorInfo} */ abruptDoctypeSystemIdentifier: {
        reason: 'Unexpected abruptly closed system identifier',
        description: 'Unexpected `>`. Expected a closing `"` or `\'` after the identifier identifier'
    },
    /** @type {ErrorInfo} */ absenceOfDigitsInNumericCharacterReference: {
        reason: 'Unexpected non-digit at start of numeric character reference',
        description: 'Unexpected `%c`. Expected `[0-9]` for decimal references or `[0-9a-fA-F]` for hexadecimal references'
    },
    /** @type {ErrorInfo} */ cdataInHtmlContent: {
        reason: 'Unexpected CDATA section in HTML',
        description: 'Unexpected `<![CDATA[` in HTML. Remove it, use a comment, or encode special characters instead'
    },
    /** @type {ErrorInfo} */ characterReferenceOutsideUnicodeRange: {
        reason: 'Unexpected too big numeric character reference',
        description: 'Unexpectedly high character reference. Expected character references to be at most hexadecimal 10ffff (or decimal 1114111)'
    },
    /** @type {ErrorInfo} */ closingOfElementWithOpenChildElements: {
        reason: 'Unexpected closing tag with open child elements',
        description: 'Unexpectedly closing tag. Expected other tags to be closed first',
        url: false
    },
    /** @type {ErrorInfo} */ controlCharacterInInputStream: {
        reason: 'Unexpected control character',
        description: 'Unexpected control character `%x`. Expected a non-control code point, 0x00, or ASCII whitespace'
    },
    /** @type {ErrorInfo} */ controlCharacterReference: {
        reason: 'Unexpected control character reference',
        description: 'Unexpectedly control character in reference. Expected a non-control code point, 0x00, or ASCII whitespace'
    },
    /** @type {ErrorInfo} */ disallowedContentInNoscriptInHead: {
        reason: 'Disallowed content inside `<noscript>` in `<head>`',
        description: 'Unexpected text character `%c`. Only use text in `<noscript>`s in `<body>`',
        url: false
    },
    /** @type {ErrorInfo} */ duplicateAttribute: {
        reason: 'Unexpected duplicate attribute',
        description: 'Unexpectedly double attribute. Expected attributes to occur only once'
    },
    /** @type {ErrorInfo} */ endTagWithAttributes: {
        reason: 'Unexpected attribute on closing tag',
        description: 'Unexpected attribute. Expected `>` instead'
    },
    /** @type {ErrorInfo} */ endTagWithTrailingSolidus: {
        reason: 'Unexpected slash at end of closing tag',
        description: 'Unexpected `%c-1`. Expected `>` instead'
    },
    /** @type {ErrorInfo} */ endTagWithoutMatchingOpenElement: {
        reason: 'Unexpected unopened end tag',
        description: 'Unexpected end tag. Expected no end tag or another end tag',
        url: false
    },
    /** @type {ErrorInfo} */ eofBeforeTagName: {
        reason: 'Unexpected end of file',
        description: 'Unexpected end of file. Expected tag name instead'
    },
    /** @type {ErrorInfo} */ eofInCdata: {
        reason: 'Unexpected end of file in CDATA',
        description: 'Unexpected end of file. Expected `]]>` to close the CDATA'
    },
    /** @type {ErrorInfo} */ eofInComment: {
        reason: 'Unexpected end of file in comment',
        description: 'Unexpected end of file. Expected `-->` to close the comment'
    },
    /** @type {ErrorInfo} */ eofInDoctype: {
        reason: 'Unexpected end of file in doctype',
        description: 'Unexpected end of file. Expected a valid doctype (such as `<!doctype html>`)'
    },
    /** @type {ErrorInfo} */ eofInElementThatCanContainOnlyText: {
        reason: 'Unexpected end of file in element that can only contain text',
        description: 'Unexpected end of file. Expected text or a closing tag',
        url: false
    },
    /** @type {ErrorInfo} */ eofInScriptHtmlCommentLikeText: {
        reason: 'Unexpected end of file in comment inside script',
        description: 'Unexpected end of file. Expected `-->` to close the comment'
    },
    /** @type {ErrorInfo} */ eofInTag: {
        reason: 'Unexpected end of file in tag',
        description: 'Unexpected end of file. Expected `>` to close the tag'
    },
    /** @type {ErrorInfo} */ incorrectlyClosedComment: {
        reason: 'Incorrectly closed comment',
        description: 'Unexpected `%c-1`. Expected `-->` to close the comment'
    },
    /** @type {ErrorInfo} */ incorrectlyOpenedComment: {
        reason: 'Incorrectly opened comment',
        description: 'Unexpected `%c`. Expected `<!--` to open the comment'
    },
    /** @type {ErrorInfo} */ invalidCharacterSequenceAfterDoctypeName: {
        reason: 'Invalid sequence after doctype name',
        description: 'Unexpected sequence at `%c`. Expected `public` or `system`'
    },
    /** @type {ErrorInfo} */ invalidFirstCharacterOfTagName: {
        reason: 'Invalid first character in tag name',
        description: 'Unexpected `%c`. Expected an ASCII letter instead'
    },
    /** @type {ErrorInfo} */ misplacedDoctype: {
        reason: 'Misplaced doctype',
        description: 'Unexpected doctype. Expected doctype before head',
        url: false
    },
    /** @type {ErrorInfo} */ misplacedStartTagForHeadElement: {
        reason: 'Misplaced `<head>` start tag',
        description: 'Unexpected start tag `<head>`. Expected `<head>` directly after doctype',
        url: false
    },
    /** @type {ErrorInfo} */ missingAttributeValue: {
        reason: 'Missing attribute value',
        description: 'Unexpected `%c-1`. Expected an attribute value or no `%c-1` instead'
    },
    /** @type {ErrorInfo} */ missingDoctype: {
        reason: 'Missing doctype before other content',
        description: 'Expected a `<!doctype html>` before anything else',
        url: false
    },
    /** @type {ErrorInfo} */ missingDoctypeName: {
        reason: 'Missing doctype name',
        description: 'Unexpected doctype end at `%c`. Expected `html` instead'
    },
    /** @type {ErrorInfo} */ missingDoctypePublicIdentifier: {
        reason: 'Missing public identifier in doctype',
        description: 'Unexpected `%c`. Expected identifier for `public` instead'
    },
    /** @type {ErrorInfo} */ missingDoctypeSystemIdentifier: {
        reason: 'Missing system identifier in doctype',
        description: 'Unexpected `%c`. Expected identifier for `system` instead (suggested: `"about:legacy-compat"`)'
    },
    /** @type {ErrorInfo} */ missingEndTagName: {
        reason: 'Missing name in end tag',
        description: 'Unexpected `%c`. Expected an ASCII letter instead'
    },
    /** @type {ErrorInfo} */ missingQuoteBeforeDoctypePublicIdentifier: {
        reason: 'Missing quote before public identifier in doctype',
        description: 'Unexpected `%c`. Expected `"` or `\'` instead'
    },
    /** @type {ErrorInfo} */ missingQuoteBeforeDoctypeSystemIdentifier: {
        reason: 'Missing quote before system identifier in doctype',
        description: 'Unexpected `%c`. Expected `"` or `\'` instead'
    },
    /** @type {ErrorInfo} */ missingSemicolonAfterCharacterReference: {
        reason: 'Missing semicolon after character reference',
        description: 'Unexpected `%c`. Expected `;` instead'
    },
    /** @type {ErrorInfo} */ missingWhitespaceAfterDoctypePublicKeyword: {
        reason: 'Missing whitespace after public identifier in doctype',
        description: 'Unexpected `%c`. Expected ASCII whitespace instead'
    },
    /** @type {ErrorInfo} */ missingWhitespaceAfterDoctypeSystemKeyword: {
        reason: 'Missing whitespace after system identifier in doctype',
        description: 'Unexpected `%c`. Expected ASCII whitespace instead'
    },
    /** @type {ErrorInfo} */ missingWhitespaceBeforeDoctypeName: {
        reason: 'Missing whitespace before doctype name',
        description: 'Unexpected `%c`. Expected ASCII whitespace instead'
    },
    /** @type {ErrorInfo} */ missingWhitespaceBetweenAttributes: {
        reason: 'Missing whitespace between attributes',
        description: 'Unexpected `%c`. Expected ASCII whitespace instead'
    },
    /** @type {ErrorInfo} */ missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers: {
        reason: 'Missing whitespace between public and system identifiers in doctype',
        description: 'Unexpected `%c`. Expected ASCII whitespace instead'
    },
    /** @type {ErrorInfo} */ nestedComment: {
        reason: 'Unexpected nested comment',
        description: 'Unexpected `<!--`. Expected `-->`'
    },
    /** @type {ErrorInfo} */ nestedNoscriptInHead: {
        reason: 'Unexpected nested `<noscript>` in `<head>`',
        description: 'Unexpected `<noscript>`. Expected a closing tag or a meta element',
        url: false
    },
    /** @type {ErrorInfo} */ nonConformingDoctype: {
        reason: 'Unexpected non-conforming doctype declaration',
        description: 'Expected `<!doctype html>` or `<!doctype html system "about:legacy-compat">`',
        url: false
    },
    /** @type {ErrorInfo} */ nonVoidHtmlElementStartTagWithTrailingSolidus: {
        reason: 'Unexpected trailing slash on start tag of non-void element',
        description: 'Unexpected `/`. Expected `>` instead'
    },
    /** @type {ErrorInfo} */ noncharacterCharacterReference: {
        reason: 'Unexpected noncharacter code point referenced by character reference',
        description: 'Unexpected code point. Do not use noncharacters in HTML'
    },
    /** @type {ErrorInfo} */ noncharacterInInputStream: {
        reason: 'Unexpected noncharacter character',
        description: 'Unexpected code point `%x`. Do not use noncharacters in HTML'
    },
    /** @type {ErrorInfo} */ nullCharacterReference: {
        reason: 'Unexpected NULL character referenced by character reference',
        description: 'Unexpected code point. Do not use NULL characters in HTML'
    },
    /** @type {ErrorInfo} */ openElementsLeftAfterEof: {
        reason: 'Unexpected end of file',
        description: 'Unexpected end of file. Expected closing tag instead',
        url: false
    },
    /** @type {ErrorInfo} */ surrogateCharacterReference: {
        reason: 'Unexpected surrogate character referenced by character reference',
        description: 'Unexpected code point. Do not use lone surrogate characters in HTML'
    },
    /** @type {ErrorInfo} */ surrogateInInputStream: {
        reason: 'Unexpected surrogate character',
        description: 'Unexpected code point `%x`. Do not use lone surrogate characters in HTML'
    },
    /** @type {ErrorInfo} */ unexpectedCharacterAfterDoctypeSystemIdentifier: {
        reason: 'Invalid character after system identifier in doctype',
        description: 'Unexpected character at `%c`. Expected `>`'
    },
    /** @type {ErrorInfo} */ unexpectedCharacterInAttributeName: {
        reason: 'Unexpected character in attribute name',
        description: 'Unexpected `%c`. Expected whitespace, `/`, `>`, `=`, or probably an ASCII letter'
    },
    /** @type {ErrorInfo} */ unexpectedCharacterInUnquotedAttributeValue: {
        reason: 'Unexpected character in unquoted attribute value',
        description: 'Unexpected `%c`. Quote the attribute value to include it'
    },
    /** @type {ErrorInfo} */ unexpectedEqualsSignBeforeAttributeName: {
        reason: 'Unexpected equals sign before attribute name',
        description: 'Unexpected `%c`. Add an attribute name before it'
    },
    /** @type {ErrorInfo} */ unexpectedNullCharacter: {
        reason: 'Unexpected NULL character',
        description: 'Unexpected code point `%x`. Do not use NULL characters in HTML'
    },
    /** @type {ErrorInfo} */ unexpectedQuestionMarkInsteadOfTagName: {
        reason: 'Unexpected question mark instead of tag name',
        description: 'Unexpected `%c`. Expected an ASCII letter instead'
    },
    /** @type {ErrorInfo} */ unexpectedSolidusInTag: {
        reason: 'Unexpected slash in tag',
        description: 'Unexpected `%c-1`. Expected it followed by `>` or in a quoted attribute value'
    },
    /** @type {ErrorInfo} */ unknownNamedCharacterReference: {
        reason: 'Unexpected unknown named character reference',
        description: 'Unexpected character reference. Expected known named character references'
    }
};


const $171d02596f0a6171$var$base = 'https://html.spec.whatwg.org/multipage/parsing.html#parse-error-';
const $171d02596f0a6171$var$dashToCamelRe = /-[a-z]/g;
const $171d02596f0a6171$var$formatCRe = /%c(?:([-+])(\d+))?/g;
const $171d02596f0a6171$var$formatXRe = /%x/g;
const $171d02596f0a6171$var$fatalities = {
    2: true,
    1: false,
    0: null
};
/** @type {Readonly<Options>} */ const $171d02596f0a6171$var$emptyOptions = {};
function $171d02596f0a6171$export$657711bc6c3b0a5b(value, options) {
    const settings = options || $171d02596f0a6171$var$emptyOptions;
    const onerror = settings.onerror;
    const file = value instanceof (0, $365ad175729fa366$export$93dff69eb10dc7ce) ? value : new (0, $365ad175729fa366$export$93dff69eb10dc7ce)(value);
    const parseFunction = settings.fragment ? (0, $7822c393005c8687$export$e1152f5efcc82ad) : (0, $7822c393005c8687$export$98e6a39c04603d36);
    const document = String(file);
    const p5Document = parseFunction(document, {
        sourceCodeLocationInfo: true,
        // Note `parse5` types currently do not allow `undefined`.
        onParseError: settings.onerror ? internalOnerror : null,
        scriptingEnabled: false
    });
    // `parse5` returns document which are always mapped to roots.
    return /** @type {Root} */ (0, $73bde87d01cc5621$export$371ddbe92c872127)(p5Document, {
        file: file,
        space: settings.space,
        verbose: settings.verbose
    });
    /**
   * Handle a parse error.
   *
   * @param {ParserError} error
   *   Parse5 error.
   * @returns {undefined}
   *   Nothing.
   */ function internalOnerror(error) {
        const code = error.code;
        const name = $171d02596f0a6171$var$camelcase(code);
        const setting = settings[name];
        const config = setting === null || setting === undefined ? true : setting;
        const level = typeof config === 'number' ? config : config ? 1 : 0;
        if (level) {
            const info = (0, $ccbec9718b6e8588$export$30f3b02011db23c0)[name];
            (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(info, 'expected known error from `parse5`');
            const message = new (0, $0aa9ed7423c10921$export$752e5c445fe834ef)(format(info.reason), {
                place: {
                    start: {
                        line: error.startLine,
                        column: error.startCol,
                        offset: error.startOffset
                    },
                    end: {
                        line: error.endLine,
                        column: error.endCol,
                        offset: error.endOffset
                    }
                },
                ruleId: code,
                source: 'hast-util-from-html'
            });
            if (file.path) {
                message.file = file.path;
                message.name = file.path + ':' + message.name;
            }
            message.fatal = $171d02596f0a6171$var$fatalities[level];
            message.note = format(info.description);
            message.url = info.url === false ? undefined : $171d02596f0a6171$var$base + code;
            (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(onerror, '`internalOnerror` is not passed if `onerror` is not set');
            onerror(message);
        }
        /**
     * Format a human readable string about an error.
     *
     * @param {string} value
     *   Value to format.
     * @returns {string}
     *   Formatted.
     */ function format(value) {
            return value.replace($171d02596f0a6171$var$formatCRe, formatC).replace($171d02596f0a6171$var$formatXRe, formatX);
            /**
       * Format the character.
       *
       * @param {string} _
       *   Match.
       * @param {string} $1
       *   Sign (`-` or `+`, optional).
       * @param {string} $2
       *   Offset.
       * @returns {string}
       *   Formatted.
       */ function formatC(_, $1, $2) {
                const offset = ($2 ? Number.parseInt($2, 10) : 0) * ($1 === '-' ? -1 : 1);
                const char = document.charAt(error.startOffset + offset);
                return $171d02596f0a6171$var$visualizeCharacter(char);
            }
            /**
       * Format the character code.
       *
       * @returns {string}
       *   Formatted.
       */ function formatX() {
                return $171d02596f0a6171$var$visualizeCharacterCode(document.charCodeAt(error.startOffset));
            }
        }
    }
}
/**
 * @param {string} value
 *   Error code in dash case.
 * @returns {ErrorCode}
 *   Error code in camelcase.
 */ function $171d02596f0a6171$var$camelcase(value) {
    // This should match an error code.
    return /** @type {ErrorCode} */ value.replace($171d02596f0a6171$var$dashToCamelRe, $171d02596f0a6171$var$dashToCamel);
}
/**
 * @param {string} $0
 *   Match.
 * @returns {string}
 *   Camelcased.
 */ function $171d02596f0a6171$var$dashToCamel($0) {
    return $0.charAt(1).toUpperCase();
}
/**
 * @param {string} char
 *   Character.
 * @returns {string}
 *   Formatted.
 */ function $171d02596f0a6171$var$visualizeCharacter(char) {
    return char === '`' ? '` ` `' : char;
}
/**
 * @param {number} charCode
 *   Character code.
 * @returns {string}
 *   Formatted.
 */ function $171d02596f0a6171$var$visualizeCharacterCode(charCode) {
    return '0x' + charCode.toString(16).toUpperCase();
}


function $8d8ab2772df59c2a$export$2e2bcd8739ae039(options) {
    /** @type {Processor<Root>} */ // @ts-expect-error: TS in JSDoc generates wrong types if `this` is typed regularly.
    const self = this;
    const { emitParseErrors: emitParseErrors, ...settings } = {
        ...self.data('settings'),
        ...options
    };
    self.parser = parser;
    /**
   * @type {Parser<Root>}
   */ function parser(document, file) {
        return (0, $171d02596f0a6171$export$657711bc6c3b0a5b)(document, {
            ...settings,
            onerror: emitParseErrors ? function(message) {
                if (file.path) {
                    message.name = file.path + ':' + message.name;
                    message.file = file.path;
                }
                file.messages.push(message);
            } : undefined
        });
    }
}


/**
 * @import {Root} from 'hast'
 * @import {Options} from 'hast-util-to-html'
 * @import {Compiler, Processor} from 'unified'
 */ /**
 * @import {Nodes, Parents, RootContent} from 'hast'
 * @import {Schema} from 'property-information'
 * @import {Options as StringifyEntitiesOptions} from 'stringify-entities'
 */ /**
 * @typedef {Omit<StringifyEntitiesOptions, 'attribute' | 'escapeOnly' | 'subset'>} CharacterReferences
 *
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [allowDangerousCharacters=false]
 *   Do not encode some characters which cause XSS vulnerabilities in older
 *   browsers (default: `false`).
 *
 *   > ⚠️ **Danger**: only set this if you completely trust the content.
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Allow `raw` nodes and insert them as raw HTML (default: `false`).
 *
 *   When `false`, `Raw` nodes are encoded.
 *
 *   > ⚠️ **Danger**: only set this if you completely trust the content.
 * @property {boolean | null | undefined} [allowParseErrors=false]
 *   Do not encode characters which cause parse errors (even though they work),
 *   to save bytes (default: `false`).
 *
 *   Not used in the SVG space.
 *
 *   > 👉 **Note**: intentionally creates parse errors in markup (how parse
 *   > errors are handled is well defined, so this works but isn’t pretty).
 * @property {boolean | null | undefined} [bogusComments=false]
 *   Use “bogus comments” instead of comments to save byes: `<?charlie>`
 *   instead of `<!--charlie-->` (default: `false`).
 *
 *   > 👉 **Note**: intentionally creates parse errors in markup (how parse
 *   > errors are handled is well defined, so this works but isn’t pretty).
 * @property {CharacterReferences | null | undefined} [characterReferences]
 *   Configure how to serialize character references (optional).
 * @property {boolean | null | undefined} [closeEmptyElements=false]
 *   Close SVG elements without any content with slash (`/`) on the opening tag
 *   instead of an end tag: `<circle />` instead of `<circle></circle>`
 *   (default: `false`).
 *
 *   See `tightSelfClosing` to control whether a space is used before the
 *   slash.
 *
 *   Not used in the HTML space.
 * @property {boolean | null | undefined} [closeSelfClosing=false]
 *   Close self-closing nodes with an extra slash (`/`): `<img />` instead of
 *   `<img>` (default: `false`).
 *
 *   See `tightSelfClosing` to control whether a space is used before the
 *   slash.
 *
 *   Not used in the SVG space.
 * @property {boolean | null | undefined} [collapseEmptyAttributes=false]
 *   Collapse empty attributes: get `class` instead of `class=""` (default:
 *   `false`).
 *
 *   Not used in the SVG space.
 *
 *   > 👉 **Note**: boolean attributes (such as `hidden`) are always collapsed.
 * @property {boolean | null | undefined} [omitOptionalTags=false]
 *   Omit optional opening and closing tags (default: `false`).
 *
 *   For example, in `<ol><li>one</li><li>two</li></ol>`, both `</li>` closing
 *   tags can be omitted.
 *   The first because it’s followed by another `li`, the last because it’s
 *   followed by nothing.
 *
 *   Not used in the SVG space.
 * @property {boolean | null | undefined} [preferUnquoted=false]
 *   Leave attributes unquoted if that results in less bytes (default: `false`).
 *
 *   Not used in the SVG space.
 * @property {boolean | null | undefined} [quoteSmart=false]
 *   Use the other quote if that results in less bytes (default: `false`).
 * @property {Quote | null | undefined} [quote='"']
 *   Preferred quote to use (default: `'"'`).
 * @property {Space | null | undefined} [space='html']
 *   When an `<svg>` element is found in the HTML space, this package already
 *   automatically switches to and from the SVG space when entering and exiting
 *   it (default: `'html'`).
 *
 *   > 👉 **Note**: hast is not XML.
 *   > It supports SVG as embedded in HTML.
 *   > It does not support the features available in XML.
 *   > Passing SVG might break but fragments of modern SVG should be fine.
 *   > Use [`xast`][xast] if you need to support SVG as XML.
 * @property {boolean | null | undefined} [tightAttributes=false]
 *   Join attributes together, without whitespace, if possible: get
 *   `class="a b"title="c d"` instead of `class="a b" title="c d"` to save
 *   bytes (default: `false`).
 *
 *   Not used in the SVG space.
 *
 *   > 👉 **Note**: intentionally creates parse errors in markup (how parse
 *   > errors are handled is well defined, so this works but isn’t pretty).
 * @property {boolean | null | undefined} [tightCommaSeparatedLists=false]
 *   Join known comma-separated attribute values with just a comma (`,`),
 *   instead of padding them on the right as well (`,␠`, where `␠` represents a
 *   space) (default: `false`).
 * @property {boolean | null | undefined} [tightDoctype=false]
 *   Drop unneeded spaces in doctypes: `<!doctypehtml>` instead of
 *   `<!doctype html>` to save bytes (default: `false`).
 *
 *   > 👉 **Note**: intentionally creates parse errors in markup (how parse
 *   > errors are handled is well defined, so this works but isn’t pretty).
 * @property {boolean | null | undefined} [tightSelfClosing=false]
 *   Do not use an extra space when closing self-closing elements: `<img/>`
 *   instead of `<img />` (default: `false`).
 *
 *   > 👉 **Note**: only used if `closeSelfClosing: true` or
 *   > `closeEmptyElements: true`.
 * @property {boolean | null | undefined} [upperDoctype=false]
 *   Use a `<!DOCTYPE…` instead of `<!doctype…` (default: `false`).
 *
 *   Useless except for XHTML.
 * @property {ReadonlyArray<string> | null | undefined} [voids]
 *   Tag names of elements to serialize without closing tag (default: `html-void-elements`).
 *
 *   Not used in the SVG space.
 *
 *   > 👉 **Note**: It’s highly unlikely that you want to pass this, because
 *   > hast is not for XML, and HTML will not add more void elements.
 *
 * @typedef {'"' | "'"} Quote
 *   HTML quotes for attribute values.
 *
 * @typedef {Omit<Required<{[key in keyof Options]: Exclude<Options[key], null | undefined>}>, 'space' | 'quote'>} Settings
 *
 * @typedef {'html' | 'svg'} Space
 *   Namespace.
 *
 * @typedef State
 *   Info passed around about the current state.
 * @property {(node: Parents | undefined) => string} all
 *   Serialize the children of a parent node.
 * @property {Quote} alternative
 *   Alternative quote.
 * @property {(node: Nodes, index: number | undefined, parent: Parents | undefined) => string} one
 *   Serialize one node.
 * @property {Quote} quote
 *   Preferred quote.
 * @property {Schema} schema
 *   Current schema.
 * @property {Settings} settings
 *   User configuration.
 */ 

/**
 * @import {Nodes, Parents} from 'hast'
 * @import {State} from '../index.js'
 */ 
/**
 * @import {Comment, Parents} from 'hast'
 * @import {State} from '../index.js'
 */ /**
 * @typedef {import('./core.js').CoreOptions & import('./util/format-smart.js').FormatSmartOptions} Options
 * @typedef {import('./core.js').CoreOptions} LightOptions
 */ /**
 * @typedef CoreOptions
 * @property {ReadonlyArray<string>} [subset=[]]
 *   Whether to only escape the given subset of characters.
 * @property {boolean} [escapeOnly=false]
 *   Whether to only escape possibly dangerous characters.
 *   Those characters are `"`, `&`, `'`, `<`, `>`, and `` ` ``.
 *
 * @typedef FormatOptions
 * @property {(code: number, next: number, options: CoreWithFormatOptions) => string} format
 *   Format strategy.
 *
 * @typedef {CoreOptions & FormatOptions & import('./util/format-smart.js').FormatSmartOptions} CoreWithFormatOptions
 */ const $410b843dad1a1135$var$defaultSubsetRegex = /["&'<>`]/g;
const $410b843dad1a1135$var$surrogatePairsRegex = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
const $410b843dad1a1135$var$controlCharactersRegex = // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
/[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;
const $410b843dad1a1135$var$regexEscapeRegex = /[|\\{}()[\]^$+*?.]/g;
/** @type {WeakMap<ReadonlyArray<string>, RegExp>} */ const $410b843dad1a1135$var$subsetToRegexCache = new WeakMap();
function $410b843dad1a1135$export$b75f8c4f8f3fbd14(value, options) {
    value = value.replace(options.subset ? $410b843dad1a1135$var$charactersToExpressionCached(options.subset) : $410b843dad1a1135$var$defaultSubsetRegex, basic);
    if (options.subset || options.escapeOnly) return value;
    return value// Surrogate pairs.
    .replace($410b843dad1a1135$var$surrogatePairsRegex, surrogate)// BMP control characters (C0 except for LF, CR, SP; DEL; and some more
    // non-ASCII ones).
    .replace($410b843dad1a1135$var$controlCharactersRegex, basic);
    /**
   * @param {string} pair
   * @param {number} index
   * @param {string} all
   */ function surrogate(pair, index, all) {
        return options.format((pair.charCodeAt(0) - 0xd800) * 0x400 + pair.charCodeAt(1) - 0xdc00 + 0x10000, all.charCodeAt(index + 2), options);
    }
    /**
   * @param {string} character
   * @param {number} index
   * @param {string} all
   */ function basic(character, index, all) {
        return options.format(character.charCodeAt(0), all.charCodeAt(index + 1), options);
    }
}
/**
 * A wrapper function that caches the result of `charactersToExpression` with a WeakMap.
 * This can improve performance when tooling calls `charactersToExpression` repeatedly
 * with the same subset.
 *
 * @param {ReadonlyArray<string>} subset
 * @returns {RegExp}
 */ function $410b843dad1a1135$var$charactersToExpressionCached(subset) {
    let cached = $410b843dad1a1135$var$subsetToRegexCache.get(subset);
    if (!cached) {
        cached = $410b843dad1a1135$var$charactersToExpression(subset);
        $410b843dad1a1135$var$subsetToRegexCache.set(subset, cached);
    }
    return cached;
}
/**
 * @param {ReadonlyArray<string>} subset
 * @returns {RegExp}
 */ function $410b843dad1a1135$var$charactersToExpression(subset) {
    /** @type {Array<string>} */ const groups = [];
    let index = -1;
    while(++index < subset.length)groups.push(subset[index].replace($410b843dad1a1135$var$regexEscapeRegex, '\\$&'));
    return new RegExp('(?:' + groups.join('|') + ')', 'g');
}


/**
 * @typedef FormatSmartOptions
 * @property {boolean} [useNamedReferences=false]
 *   Prefer named character references (`&amp;`) where possible.
 * @property {boolean} [useShortestReferences=false]
 *   Prefer the shortest possible reference, if that results in less bytes.
 *   **Note**: `useNamedReferences` can be omitted when using `useShortestReferences`.
 * @property {boolean} [omitOptionalSemicolons=false]
 *   Whether to omit semicolons when possible.
 *   **Note**: This creates what HTML calls “parse errors” but is otherwise still valid HTML — don’t use this except when building a minifier.
 *   Omitting semicolons is possible for certain named and numeric references in some cases.
 * @property {boolean} [attribute=false]
 *   Create character references which don’t fail in attributes.
 *   **Note**: `attribute` only applies when operating dangerously with
 *   `omitOptionalSemicolons: true`.
 */ const $cf86d5c85b816fed$var$hexadecimalRegex = /[\dA-Fa-f]/;
function $cf86d5c85b816fed$export$ef12b12fd64fa3cc(code, next, omit) {
    const value = '&#x' + code.toString(16).toUpperCase();
    return omit && next && !$cf86d5c85b816fed$var$hexadecimalRegex.test(String.fromCharCode(next)) ? value : value + ';';
}


const $65294a4e137377e3$var$decimalRegex = /\d/;
function $65294a4e137377e3$export$63ad841d70774900(code, next, omit) {
    const value = '&#' + String(code);
    return omit && next && !$65294a4e137377e3$var$decimalRegex.test(String.fromCharCode(next)) ? value : value + ';';
}



/**
 * Map of named character references from HTML 4.
 *
 * @type {Record<string, string>}
 */ const $eddcd7cb7275dd15$export$40952e41c47e8e55 = {
    nbsp: "\xa0",
    iexcl: "\xa1",
    cent: "\xa2",
    pound: "\xa3",
    curren: "\xa4",
    yen: "\xa5",
    brvbar: "\xa6",
    sect: "\xa7",
    uml: "\xa8",
    copy: "\xa9",
    ordf: "\xaa",
    laquo: "\xab",
    not: "\xac",
    shy: "\xad",
    reg: "\xae",
    macr: "\xaf",
    deg: "\xb0",
    plusmn: "\xb1",
    sup2: "\xb2",
    sup3: "\xb3",
    acute: "\xb4",
    micro: "\xb5",
    para: "\xb6",
    middot: "\xb7",
    cedil: "\xb8",
    sup1: "\xb9",
    ordm: "\xba",
    raquo: "\xbb",
    frac14: "\xbc",
    frac12: "\xbd",
    frac34: "\xbe",
    iquest: "\xbf",
    Agrave: "\xc0",
    Aacute: "\xc1",
    Acirc: "\xc2",
    Atilde: "\xc3",
    Auml: "\xc4",
    Aring: "\xc5",
    AElig: "\xc6",
    Ccedil: "\xc7",
    Egrave: "\xc8",
    Eacute: "\xc9",
    Ecirc: "\xca",
    Euml: "\xcb",
    Igrave: "\xcc",
    Iacute: "\xcd",
    Icirc: "\xce",
    Iuml: "\xcf",
    ETH: "\xd0",
    Ntilde: "\xd1",
    Ograve: "\xd2",
    Oacute: "\xd3",
    Ocirc: "\xd4",
    Otilde: "\xd5",
    Ouml: "\xd6",
    times: "\xd7",
    Oslash: "\xd8",
    Ugrave: "\xd9",
    Uacute: "\xda",
    Ucirc: "\xdb",
    Uuml: "\xdc",
    Yacute: "\xdd",
    THORN: "\xde",
    szlig: "\xdf",
    agrave: "\xe0",
    aacute: "\xe1",
    acirc: "\xe2",
    atilde: "\xe3",
    auml: "\xe4",
    aring: "\xe5",
    aelig: "\xe6",
    ccedil: "\xe7",
    egrave: "\xe8",
    eacute: "\xe9",
    ecirc: "\xea",
    euml: "\xeb",
    igrave: "\xec",
    iacute: "\xed",
    icirc: "\xee",
    iuml: "\xef",
    eth: "\xf0",
    ntilde: "\xf1",
    ograve: "\xf2",
    oacute: "\xf3",
    ocirc: "\xf4",
    otilde: "\xf5",
    ouml: "\xf6",
    divide: "\xf7",
    oslash: "\xf8",
    ugrave: "\xf9",
    uacute: "\xfa",
    ucirc: "\xfb",
    uuml: "\xfc",
    yacute: "\xfd",
    thorn: "\xfe",
    yuml: "\xff",
    fnof: "\u0192",
    Alpha: "\u0391",
    Beta: "\u0392",
    Gamma: "\u0393",
    Delta: "\u0394",
    Epsilon: "\u0395",
    Zeta: "\u0396",
    Eta: "\u0397",
    Theta: "\u0398",
    Iota: "\u0399",
    Kappa: "\u039A",
    Lambda: "\u039B",
    Mu: "\u039C",
    Nu: "\u039D",
    Xi: "\u039E",
    Omicron: "\u039F",
    Pi: "\u03A0",
    Rho: "\u03A1",
    Sigma: "\u03A3",
    Tau: "\u03A4",
    Upsilon: "\u03A5",
    Phi: "\u03A6",
    Chi: "\u03A7",
    Psi: "\u03A8",
    Omega: "\u03A9",
    alpha: "\u03B1",
    beta: "\u03B2",
    gamma: "\u03B3",
    delta: "\u03B4",
    epsilon: "\u03B5",
    zeta: "\u03B6",
    eta: "\u03B7",
    theta: "\u03B8",
    iota: "\u03B9",
    kappa: "\u03BA",
    lambda: "\u03BB",
    mu: "\u03BC",
    nu: "\u03BD",
    xi: "\u03BE",
    omicron: "\u03BF",
    pi: "\u03C0",
    rho: "\u03C1",
    sigmaf: "\u03C2",
    sigma: "\u03C3",
    tau: "\u03C4",
    upsilon: "\u03C5",
    phi: "\u03C6",
    chi: "\u03C7",
    psi: "\u03C8",
    omega: "\u03C9",
    thetasym: "\u03D1",
    upsih: "\u03D2",
    piv: "\u03D6",
    bull: "\u2022",
    hellip: "\u2026",
    prime: "\u2032",
    Prime: "\u2033",
    oline: "\u203E",
    frasl: "\u2044",
    weierp: "\u2118",
    image: "\u2111",
    real: "\u211C",
    trade: "\u2122",
    alefsym: "\u2135",
    larr: "\u2190",
    uarr: "\u2191",
    rarr: "\u2192",
    darr: "\u2193",
    harr: "\u2194",
    crarr: "\u21B5",
    lArr: "\u21D0",
    uArr: "\u21D1",
    rArr: "\u21D2",
    dArr: "\u21D3",
    hArr: "\u21D4",
    forall: "\u2200",
    part: "\u2202",
    exist: "\u2203",
    empty: "\u2205",
    nabla: "\u2207",
    isin: "\u2208",
    notin: "\u2209",
    ni: "\u220B",
    prod: "\u220F",
    sum: "\u2211",
    minus: "\u2212",
    lowast: "\u2217",
    radic: "\u221A",
    prop: "\u221D",
    infin: "\u221E",
    ang: "\u2220",
    and: "\u2227",
    or: "\u2228",
    cap: "\u2229",
    cup: "\u222A",
    int: "\u222B",
    there4: "\u2234",
    sim: "\u223C",
    cong: "\u2245",
    asymp: "\u2248",
    ne: "\u2260",
    equiv: "\u2261",
    le: "\u2264",
    ge: "\u2265",
    sub: "\u2282",
    sup: "\u2283",
    nsub: "\u2284",
    sube: "\u2286",
    supe: "\u2287",
    oplus: "\u2295",
    otimes: "\u2297",
    perp: "\u22A5",
    sdot: "\u22C5",
    lceil: "\u2308",
    rceil: "\u2309",
    lfloor: "\u230A",
    rfloor: "\u230B",
    lang: "\u2329",
    rang: "\u232A",
    loz: "\u25CA",
    spades: "\u2660",
    clubs: "\u2663",
    hearts: "\u2665",
    diams: "\u2666",
    quot: '"',
    amp: '&',
    lt: '<',
    gt: '>',
    OElig: "\u0152",
    oelig: "\u0153",
    Scaron: "\u0160",
    scaron: "\u0161",
    Yuml: "\u0178",
    circ: "\u02C6",
    tilde: "\u02DC",
    ensp: "\u2002",
    emsp: "\u2003",
    thinsp: "\u2009",
    zwnj: "\u200C",
    zwj: "\u200D",
    lrm: "\u200E",
    rlm: "\u200F",
    ndash: "\u2013",
    mdash: "\u2014",
    lsquo: "\u2018",
    rsquo: "\u2019",
    sbquo: "\u201A",
    ldquo: "\u201C",
    rdquo: "\u201D",
    bdquo: "\u201E",
    dagger: "\u2020",
    Dagger: "\u2021",
    permil: "\u2030",
    lsaquo: "\u2039",
    rsaquo: "\u203A",
    euro: "\u20AC"
};


/**
 * List of legacy (that don’t need a trailing `;`) named references which could,
 * depending on what follows them, turn into a different meaning
 *
 * @type {Array<string>}
 */ const $4ed18c9e25dcc553$export$39b76096d2f1d598 = [
    'cent',
    'copy',
    'divide',
    'gt',
    'lt',
    'not',
    'para',
    'times'
];


const $6e20758df27af6be$var$own = {}.hasOwnProperty;
/**
 * `characterEntitiesHtml4` but inverted.
 *
 * @type {Record<string, string>}
 */ const $6e20758df27af6be$var$characters = {};
/** @type {string} */ let $6e20758df27af6be$var$key;
for($6e20758df27af6be$var$key in 0, $eddcd7cb7275dd15$export$40952e41c47e8e55)if ($6e20758df27af6be$var$own.call((0, $eddcd7cb7275dd15$export$40952e41c47e8e55), $6e20758df27af6be$var$key)) $6e20758df27af6be$var$characters[(0, $eddcd7cb7275dd15$export$40952e41c47e8e55)[$6e20758df27af6be$var$key]] = $6e20758df27af6be$var$key;
const $6e20758df27af6be$var$notAlphanumericRegex = /[^\dA-Za-z]/;
function $6e20758df27af6be$export$b1e14dcd42472e57(code, next, omit, attribute) {
    const character = String.fromCharCode(code);
    if ($6e20758df27af6be$var$own.call($6e20758df27af6be$var$characters, character)) {
        const name = $6e20758df27af6be$var$characters[character];
        const value = '&' + name;
        if (omit && (0, $9d441a8e4486a83e$export$9545335bdecb4b8c).includes(name) && !(0, $4ed18c9e25dcc553$export$39b76096d2f1d598).includes(name) && (!attribute || next && next !== 61 /* `=` */  && $6e20758df27af6be$var$notAlphanumericRegex.test(String.fromCharCode(next)))) return value;
        return value + ';';
    }
    return '';
}


function $270a3d583edee730$export$f53904683bee23d7(code, next, options) {
    let numeric = (0, $cf86d5c85b816fed$export$ef12b12fd64fa3cc)(code, next, options.omitOptionalSemicolons);
    /** @type {string|undefined} */ let named;
    if (options.useNamedReferences || options.useShortestReferences) named = (0, $6e20758df27af6be$export$b1e14dcd42472e57)(code, next, options.omitOptionalSemicolons, options.attribute);
    // Use the shortest numeric reference when requested.
    // A simple algorithm would use decimal for all code points under 100, as
    // those are shorter than hexadecimal:
    //
    // * `&#99;` vs `&#x63;` (decimal shorter)
    // * `&#100;` vs `&#x64;` (equal)
    //
    // However, because we take `next` into consideration when `omit` is used,
    // And it would be possible that decimals are shorter on bigger values as
    // well if `next` is hexadecimal but not decimal, we instead compare both.
    if ((options.useShortestReferences || !named) && options.useShortestReferences) {
        const decimal = (0, $65294a4e137377e3$export$63ad841d70774900)(code, next, options.omitOptionalSemicolons);
        if (decimal.length < numeric.length) numeric = decimal;
    }
    return named && (!options.useShortestReferences || named.length < numeric.length) ? named : numeric;
}


/**
 * The smallest way to encode a character.
 *
 * @param {number} code
 * @returns {string}
 */ function $3bd3ec3028ea85fe$export$83cfa611e0071208(code) {
    return '&#x' + code.toString(16).toUpperCase() + ';';
}


function $4306eeea4ecd9ecc$export$aca9de459d63ca2e(value, options) {
    return (0, $410b843dad1a1135$export$b75f8c4f8f3fbd14)(value, Object.assign({
        format: (0, $270a3d583edee730$export$f53904683bee23d7)
    }, options));
}
function $4306eeea4ecd9ecc$export$a2577b9dadf100a3(value, options) {
    return (0, $410b843dad1a1135$export$b75f8c4f8f3fbd14)(value, Object.assign({
        format: (0, $3bd3ec3028ea85fe$export$83cfa611e0071208)
    }, options));
}


const $b4ee3be9337e6748$var$htmlCommentRegex = /^>|^->|<!--|-->|--!>|<!-$/g;
// Declare arrays as variables so it can be cached by `stringifyEntities`
const $b4ee3be9337e6748$var$bogusCommentEntitySubset = [
    '>'
];
const $b4ee3be9337e6748$var$commentEntitySubset = [
    '<',
    '>'
];
function $b4ee3be9337e6748$export$4a34f930e789283c(node, _1, _2, state) {
    // See: <https://html.spec.whatwg.org/multipage/syntax.html#comments>
    return state.settings.bogusComments ? '<?' + (0, $4306eeea4ecd9ecc$export$aca9de459d63ca2e)(node.value, Object.assign({}, state.settings.characterReferences, {
        subset: $b4ee3be9337e6748$var$bogusCommentEntitySubset
    })) + '>' : '<!--' + node.value.replace($b4ee3be9337e6748$var$htmlCommentRegex, encode) + '-->';
    /**
   * @param {string} $0
   */ function encode($0) {
        return (0, $4306eeea4ecd9ecc$export$aca9de459d63ca2e)($0, Object.assign({}, state.settings.characterReferences, {
            subset: $b4ee3be9337e6748$var$commentEntitySubset
        }));
    }
}


/**
 * @import {Doctype, Parents} from 'hast'
 * @import {State} from '../index.js'
 */ /**
 * Serialize a doctype.
 *
 * @param {Doctype} _1
 *   Node to handle.
 * @param {number | undefined} _2
 *   Index of `node` in `parent.
 * @param {Parents | undefined} _3
 *   Parent of `node`.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {string}
 *   Serialized node.
 */ function $3cb60d8884f767f1$export$3c172dfa1c27da99(_1, _2, _3, state) {
    return '<!' + (state.settings.upperDoctype ? 'DOCTYPE' : 'doctype') + (state.settings.tightDoctype ? '' : ' ') + 'html>';
}


/**
 * @import {Element, Parents, Properties} from 'hast'
 * @import {State} from '../index.js'
 */ 




/**
 * @import {Element, Parents} from 'hast'
 */ 
/**
 * @import {Parents, RootContent} from 'hast'
 */ 
const $3eeeab5c3692c755$export$a0f7cf204d8f22ba = $3eeeab5c3692c755$var$siblings(1);
const $3eeeab5c3692c755$export$b103c35f55382246 = $3eeeab5c3692c755$var$siblings(-1);
/** @type {Array<RootContent>} */ const $3eeeab5c3692c755$var$emptyChildren = [];
/**
 * Factory to check siblings in a direction.
 *
 * @param {number} increment
 */ function $3eeeab5c3692c755$var$siblings(increment) {
    return sibling;
    /**
   * Find applicable siblings in a direction.
   *
   * @template {Parents} Parent
   *   Parent type.
   * @param {Parent | undefined} parent
   *   Parent.
   * @param {number | undefined} index
   *   Index of child in `parent`.
   * @param {boolean | undefined} [includeWhitespace=false]
   *   Whether to include whitespace (default: `false`).
   * @returns {Parent extends {children: Array<infer Child>} ? Child | undefined : never}
   *   Child of parent.
   */ function sibling(parent, index, includeWhitespace) {
        const siblings = parent ? parent.children : $3eeeab5c3692c755$var$emptyChildren;
        let offset = (index || 0) + increment;
        let next = siblings[offset];
        if (!includeWhitespace) while(next && (0, $99728b3b7e804493$export$7af1228ff777d175)(next)){
            offset += increment;
            next = siblings[offset];
        }
        // @ts-expect-error: it’s a correct child.
        return next;
    }
}


/**
 * @import {Element, Parents} from 'hast'
 */ /**
 * @callback OmitHandle
 *   Check if a tag can be omitted.
 * @param {Element} element
 *   Element to check.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether to omit a tag.
 *
 */ const $f3ca3f1fb2337dc6$var$own = {}.hasOwnProperty;
function $f3ca3f1fb2337dc6$export$67d072dabf9c1c63(handlers) {
    return omit;
    /**
   * Check if a given node can have a tag omitted.
   *
   * @type {OmitHandle}
   */ function omit(node, index, parent) {
        return $f3ca3f1fb2337dc6$var$own.call(handlers, node.tagName) && handlers[node.tagName](node, index, parent);
    }
}


const $cf67feaaa0a6d0be$export$4e69df80cd44263b = (0, $f3ca3f1fb2337dc6$export$67d072dabf9c1c63)({
    body: $cf67feaaa0a6d0be$var$body,
    caption: $cf67feaaa0a6d0be$var$headOrColgroupOrCaption,
    colgroup: $cf67feaaa0a6d0be$var$headOrColgroupOrCaption,
    dd: $cf67feaaa0a6d0be$var$dd,
    dt: $cf67feaaa0a6d0be$var$dt,
    head: $cf67feaaa0a6d0be$var$headOrColgroupOrCaption,
    html: $cf67feaaa0a6d0be$var$html,
    li: $cf67feaaa0a6d0be$var$li,
    optgroup: $cf67feaaa0a6d0be$var$optgroup,
    option: $cf67feaaa0a6d0be$var$option,
    p: $cf67feaaa0a6d0be$var$p,
    rp: $cf67feaaa0a6d0be$var$rubyElement,
    rt: $cf67feaaa0a6d0be$var$rubyElement,
    tbody: $cf67feaaa0a6d0be$var$tbody,
    td: $cf67feaaa0a6d0be$var$cells,
    tfoot: $cf67feaaa0a6d0be$var$tfoot,
    th: $cf67feaaa0a6d0be$var$cells,
    thead: $cf67feaaa0a6d0be$var$thead,
    tr: $cf67feaaa0a6d0be$var$tr
});
/**
 * Macro for `</head>`, `</colgroup>`, and `</caption>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$headOrColgroupOrCaption(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index, true);
    return !next || next.type !== 'comment' && !(next.type === 'text' && (0, $99728b3b7e804493$export$7af1228ff777d175)(next.value.charAt(0)));
}
/**
 * Whether to omit `</html>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$html(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type !== 'comment';
}
/**
 * Whether to omit `</body>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$body(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type !== 'comment';
}
/**
 * Whether to omit `</p>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$p(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
    return next ? next.type === 'element' && (next.tagName === 'address' || next.tagName === 'article' || next.tagName === 'aside' || next.tagName === 'blockquote' || next.tagName === 'details' || next.tagName === 'div' || next.tagName === 'dl' || next.tagName === 'fieldset' || next.tagName === 'figcaption' || next.tagName === 'figure' || next.tagName === 'footer' || next.tagName === 'form' || next.tagName === 'h1' || next.tagName === 'h2' || next.tagName === 'h3' || next.tagName === 'h4' || next.tagName === 'h5' || next.tagName === 'h6' || next.tagName === 'header' || next.tagName === 'hgroup' || next.tagName === 'hr' || next.tagName === 'main' || next.tagName === 'menu' || next.tagName === 'nav' || next.tagName === 'ol' || next.tagName === 'p' || next.tagName === 'pre' || next.tagName === 'section' || next.tagName === 'table' || next.tagName === 'ul') : !parent || // Confusing parent.
    !(parent.type === 'element' && (parent.tagName === 'a' || parent.tagName === 'audio' || parent.tagName === 'del' || parent.tagName === 'ins' || parent.tagName === 'map' || parent.tagName === 'noscript' || parent.tagName === 'video'));
}
/**
 * Whether to omit `</li>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$li(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && next.tagName === 'li';
}
/**
 * Whether to omit `</dt>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$dt(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
    return Boolean(next && next.type === 'element' && (next.tagName === 'dt' || next.tagName === 'dd'));
}
/**
 * Whether to omit `</dd>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$dd(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && (next.tagName === 'dt' || next.tagName === 'dd');
}
/**
 * Whether to omit `</rt>` or `</rp>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$rubyElement(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && (next.tagName === 'rp' || next.tagName === 'rt');
}
/**
 * Whether to omit `</optgroup>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$optgroup(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && next.tagName === 'optgroup';
}
/**
 * Whether to omit `</option>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$option(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && (next.tagName === 'option' || next.tagName === 'optgroup');
}
/**
 * Whether to omit `</thead>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$thead(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
    return Boolean(next && next.type === 'element' && (next.tagName === 'tbody' || next.tagName === 'tfoot'));
}
/**
 * Whether to omit `</tbody>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$tbody(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && (next.tagName === 'tbody' || next.tagName === 'tfoot');
}
/**
 * Whether to omit `</tfoot>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$tfoot(_, index, parent) {
    return !(0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
}
/**
 * Whether to omit `</tr>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$tr(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && next.tagName === 'tr';
}
/**
 * Whether to omit `</td>` or `</th>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$cells(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && (next.tagName === 'td' || next.tagName === 'th');
}


/**
 * @import {Element, Parents} from 'hast'
 */ 



const $be39f1a58e7b8fed$export$47fa9d71658d4a69 = (0, $f3ca3f1fb2337dc6$export$67d072dabf9c1c63)({
    body: $be39f1a58e7b8fed$var$body,
    colgroup: $be39f1a58e7b8fed$var$colgroup,
    head: $be39f1a58e7b8fed$var$head,
    html: $be39f1a58e7b8fed$var$html,
    tbody: $be39f1a58e7b8fed$var$tbody
});
/**
 * Whether to omit `<html>`.
 *
 * @param {Element} node
 *   Element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $be39f1a58e7b8fed$var$html(node) {
    const head = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(node, -1);
    return !head || head.type !== 'comment';
}
/**
 * Whether to omit `<head>`.
 *
 * @param {Element} node
 *   Element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $be39f1a58e7b8fed$var$head(node) {
    /** @type {Set<string>} */ const seen = new Set();
    // Whether `srcdoc` or not,
    // make sure the content model at least doesn’t have too many `base`s/`title`s.
    for (const child of node.children)if (child.type === 'element' && (child.tagName === 'base' || child.tagName === 'title')) {
        if (seen.has(child.tagName)) return false;
        seen.add(child.tagName);
    }
    // “May be omitted if the element is empty,
    // or if the first thing inside the head element is an element.”
    const child = node.children[0];
    return !child || child.type === 'element';
}
/**
 * Whether to omit `<body>`.
 *
 * @param {Element} node
 *   Element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $be39f1a58e7b8fed$var$body(node) {
    const head = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(node, -1, true);
    return !head || head.type !== 'comment' && !(head.type === 'text' && (0, $99728b3b7e804493$export$7af1228ff777d175)(head.value.charAt(0))) && !(head.type === 'element' && (head.tagName === 'meta' || head.tagName === 'link' || head.tagName === 'script' || head.tagName === 'style' || head.tagName === 'template'));
}
/**
 * Whether to omit `<colgroup>`.
 * The spec describes some logic for the opening tag, but it’s easier to
 * implement in the closing tag, to the same effect, so we handle it there
 * instead.
 *
 * @param {Element} node
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $be39f1a58e7b8fed$var$colgroup(node, index, parent) {
    const previous = (0, $3eeeab5c3692c755$export$b103c35f55382246)(parent, index);
    const head = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(node, -1, true);
    // Previous colgroup was already omitted.
    if (parent && previous && previous.type === 'element' && previous.tagName === 'colgroup' && (0, $cf67feaaa0a6d0be$export$4e69df80cd44263b)(previous, parent.children.indexOf(previous), parent)) return false;
    return Boolean(head && head.type === 'element' && head.tagName === 'col');
}
/**
 * Whether to omit `<tbody>`.
 *
 * @param {Element} node
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $be39f1a58e7b8fed$var$tbody(node, index, parent) {
    const previous = (0, $3eeeab5c3692c755$export$b103c35f55382246)(parent, index);
    const head = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(node, -1);
    // Previous table section was already omitted.
    if (parent && previous && previous.type === 'element' && (previous.tagName === 'thead' || previous.tagName === 'tbody') && (0, $cf67feaaa0a6d0be$export$4e69df80cd44263b)(previous, parent.children.indexOf(previous), parent)) return false;
    return Boolean(head && head.type === 'element' && head.tagName === 'tr');
}


/**
 * Maps of subsets.
 *
 * Each value is a matrix of tuples.
 * The value at `0` causes parse errors, the value at `1` is valid.
 * Of both, the value at `0` is unsafe, and the value at `1` is safe.
 *
 * @type {Record<'double' | 'name' | 'single' | 'unquoted', Array<[Array<string>, Array<string>]>>}
 */ const $241c439d722cfb1b$var$constants = {
    // See: <https://html.spec.whatwg.org/#attribute-name-state>.
    name: [
        [
            '\t\n\f\r &/=>'.split(''),
            '\t\n\f\r "&\'/=>`'.split('')
        ],
        [
            '\0\t\n\f\r "&\'/<=>'.split(''),
            '\0\t\n\f\r "&\'/<=>`'.split('')
        ]
    ],
    // See: <https://html.spec.whatwg.org/#attribute-value-(unquoted)-state>.
    unquoted: [
        [
            '\t\n\f\r &>'.split(''),
            '\0\t\n\f\r "&\'<=>`'.split('')
        ],
        [
            '\0\t\n\f\r "&\'<=>`'.split(''),
            '\0\t\n\f\r "&\'<=>`'.split('')
        ]
    ],
    // See: <https://html.spec.whatwg.org/#attribute-value-(single-quoted)-state>.
    single: [
        [
            "&'".split(''),
            '"&\'`'.split('')
        ],
        [
            "\0&'".split(''),
            '\0"&\'`'.split('')
        ]
    ],
    // See: <https://html.spec.whatwg.org/#attribute-value-(double-quoted)-state>.
    double: [
        [
            '"&'.split(''),
            '"&\'`'.split('')
        ],
        [
            '\0"&'.split(''),
            '\0"&\'`'.split('')
        ]
    ]
};
function $241c439d722cfb1b$export$8454457683f90105(node, index, parent, state) {
    const schema = state.schema;
    const omit = schema.space === 'svg' ? false : state.settings.omitOptionalTags;
    let selfClosing = schema.space === 'svg' ? state.settings.closeEmptyElements : state.settings.voids.includes(node.tagName.toLowerCase());
    /** @type {Array<string>} */ const parts = [];
    /** @type {string} */ let last;
    if (schema.space === 'html' && node.tagName === 'svg') state.schema = (0, $cad208d20be39d74$export$7ed1367e7fa1ad68);
    const attributes = $241c439d722cfb1b$var$serializeAttributes(state, node.properties);
    const content = state.all(schema.space === 'html' && node.tagName === 'template' ? node.content : node);
    state.schema = schema;
    // If the node is categorised as void, but it has children, remove the
    // categorisation.
    // This enables for example `menuitem`s, which are void in W3C HTML but not
    // void in WHATWG HTML, to be stringified properly.
    // Note: `menuitem` has since been removed from the HTML spec, and so is no
    // longer void.
    if (content) selfClosing = false;
    if (attributes || !omit || !(0, $be39f1a58e7b8fed$export$47fa9d71658d4a69)(node, index, parent)) {
        parts.push('<', node.tagName, attributes ? ' ' + attributes : '');
        if (selfClosing && (schema.space === 'svg' || state.settings.closeSelfClosing)) {
            last = attributes.charAt(attributes.length - 1);
            if (!state.settings.tightSelfClosing || last === '/' || last && last !== '"' && last !== "'") parts.push(' ');
            parts.push('/');
        }
        parts.push('>');
    }
    parts.push(content);
    if (!selfClosing && (!omit || !(0, $cf67feaaa0a6d0be$export$4e69df80cd44263b)(node, index, parent))) parts.push('</' + node.tagName + '>');
    return parts.join('');
}
/**
 * @param {State} state
 * @param {Properties | null | undefined} properties
 * @returns {string}
 */ function $241c439d722cfb1b$var$serializeAttributes(state, properties) {
    /** @type {Array<string>} */ const values = [];
    let index = -1;
    /** @type {string} */ let key;
    if (properties) {
        for(key in properties)if (properties[key] !== null && properties[key] !== undefined) {
            const value = $241c439d722cfb1b$var$serializeAttribute(state, key, properties[key]);
            if (value) values.push(value);
        }
    }
    while(++index < values.length){
        const last = state.settings.tightAttributes ? values[index].charAt(values[index].length - 1) : undefined;
        // In tight mode, don’t add a space after quoted attributes.
        if (index !== values.length - 1 && last !== '"' && last !== "'") values[index] += ' ';
    }
    return values.join('');
}
/**
 * @param {State} state
 * @param {string} key
 * @param {Properties[keyof Properties]} value
 * @returns {string}
 */ function $241c439d722cfb1b$var$serializeAttribute(state, key, value) {
    const info = (0, $84669bfd2b988556$export$71aa6c912b956294)(state.schema, key);
    const x = state.settings.allowParseErrors && state.schema.space === 'html' ? 0 : 1;
    const y = state.settings.allowDangerousCharacters ? 0 : 1;
    let quote = state.quote;
    /** @type {string | undefined} */ let result;
    if (info.overloadedBoolean && (value === info.attribute || value === '')) value = true;
    else if ((info.boolean || info.overloadedBoolean) && (typeof value !== 'string' || value === info.attribute || value === '')) value = Boolean(value);
    if (value === null || value === undefined || value === false || typeof value === 'number' && Number.isNaN(value)) return '';
    const name = (0, $4306eeea4ecd9ecc$export$aca9de459d63ca2e)(info.attribute, Object.assign({}, state.settings.characterReferences, {
        // Always encode without parse errors in non-HTML.
        subset: $241c439d722cfb1b$var$constants.name[x][y]
    }));
    // No value.
    // There is currently only one boolean property in SVG: `[download]` on
    // `<a>`.
    // This property does not seem to work in browsers (Firefox, Safari, Chrome),
    // so I can’t test if dropping the value works.
    // But I assume that it should:
    //
    // ```html
    // <!doctype html>
    // <svg viewBox="0 0 100 100">
    //   <a href=https://example.com download>
    //     <circle cx=50 cy=40 r=35 />
    //   </a>
    // </svg>
    // ```
    //
    // See: <https://github.com/wooorm/property-information/blob/main/lib/svg.js>
    if (value === true) return name;
    // `spaces` doesn’t accept a second argument, but it’s given here just to
    // keep the code cleaner.
    value = Array.isArray(value) ? (info.commaSeparated ? (0, $9323934601145f2e$export$fac44ee5b035f737) : (0, $0d98344a9bfa0653$export$fac44ee5b035f737))(value, {
        padLeft: !state.settings.tightCommaSeparatedLists
    }) : String(value);
    if (state.settings.collapseEmptyAttributes && !value) return name;
    // Check unquoted value.
    if (state.settings.preferUnquoted) result = (0, $4306eeea4ecd9ecc$export$aca9de459d63ca2e)(value, Object.assign({}, state.settings.characterReferences, {
        attribute: true,
        subset: $241c439d722cfb1b$var$constants.unquoted[x][y]
    }));
    // If we don’t want unquoted, or if `value` contains character references when
    // unquoted…
    if (result !== value) {
        // If the alternative is less common than `quote`, switch.
        if (state.settings.quoteSmart && (0, $b227513681bd728a$export$fa42eaa97a352e23)(value, quote) > (0, $b227513681bd728a$export$fa42eaa97a352e23)(value, state.alternative)) quote = state.alternative;
        result = quote + (0, $4306eeea4ecd9ecc$export$aca9de459d63ca2e)(value, Object.assign({}, state.settings.characterReferences, {
            // Always encode without parse errors in non-HTML.
            subset: (quote === "'" ? $241c439d722cfb1b$var$constants.single : $241c439d722cfb1b$var$constants.double)[x][y],
            attribute: true
        })) + quote;
    }
    // Don’t add a `=` for unquoted empties.
    return name + (result ? '=' + result : result);
}


/**
 * @import {Parents} from 'hast'
 * @import {Raw} from 'mdast-util-to-hast'
 * @import {State} from '../index.js'
 */ /**
 * @import {Parents, Text} from 'hast'
 * @import {Raw} from 'mdast-util-to-hast'
 * @import {State} from '../index.js'
 */ 
// Declare array as variable so it can be cached by `stringifyEntities`
const $3d3056a7327d61ed$var$textEntitySubset = [
    '<',
    '&'
];
function $3d3056a7327d61ed$export$6f093cfa640b7166(node, _, parent, state) {
    // Check if content of `node` should be escaped.
    return parent && parent.type === 'element' && (parent.tagName === 'script' || parent.tagName === 'style') ? node.value : (0, $4306eeea4ecd9ecc$export$aca9de459d63ca2e)(node.value, Object.assign({}, state.settings.characterReferences, {
        subset: $3d3056a7327d61ed$var$textEntitySubset
    }));
}


function $6d731af9aee87b6d$export$1776c186c69df29e(node, index, parent, state) {
    return state.settings.allowDangerousHtml ? node.value : (0, $3d3056a7327d61ed$export$6f093cfa640b7166)(node, index, parent, state);
}


/**
 * @import {Parents, Root} from 'hast'
 * @import {State} from '../index.js'
 */ /**
 * Serialize a root.
 *
 * @param {Root} node
 *   Node to handle.
 * @param {number | undefined} _1
 *   Index of `node` in `parent.
 * @param {Parents | undefined} _2
 *   Parent of `node`.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {string}
 *   Serialized node.
 */ function $32787891ae5202c8$export$e8e78c978b129247(node, _1, _2, state) {
    return state.all(node);
}



const $63d36365cefda5e3$export$8f34ce051745d39e = (0, $17810db8694da3f3$export$d6a12bfbbedf6185)('type', {
    invalid: $63d36365cefda5e3$var$invalid,
    unknown: $63d36365cefda5e3$var$unknown,
    handlers: {
        comment: $b4ee3be9337e6748$export$4a34f930e789283c,
        doctype: $3cb60d8884f767f1$export$3c172dfa1c27da99,
        element: $241c439d722cfb1b$export$8454457683f90105,
        raw: $6d731af9aee87b6d$export$1776c186c69df29e,
        root: $32787891ae5202c8$export$e8e78c978b129247,
        text: $3d3056a7327d61ed$export$6f093cfa640b7166
    }
});
/**
 * Fail when a non-node is found in the tree.
 *
 * @param {unknown} node
 *   Unknown value.
 * @returns {never}
 *   Never.
 */ function $63d36365cefda5e3$var$invalid(node) {
    throw new Error('Expected node, not `' + node + '`');
}
/**
 * Fail when a node with an unknown type is found in the tree.
 *
 * @param {unknown} node_
 *  Unknown node.
 * @returns {never}
 *   Never.
 */ function $63d36365cefda5e3$var$unknown(node_) {
    // `type` is guaranteed by runtime JS.
    const node = /** @type {Nodes} */ node_;
    throw new Error('Cannot compile unknown node `' + node.type + '`');
}


/** @type {Options} */ const $b6819b5b1a8bddcd$var$emptyOptions = {};
/** @type {CharacterReferences} */ const $b6819b5b1a8bddcd$var$emptyCharacterReferences = {};
/** @type {Array<never>} */ const $b6819b5b1a8bddcd$var$emptyChildren = [];
function $b6819b5b1a8bddcd$export$a10125c086a4df16(tree, options) {
    const options_ = options || $b6819b5b1a8bddcd$var$emptyOptions;
    const quote = options_.quote || '"';
    const alternative = quote === '"' ? "'" : '"';
    if (quote !== '"' && quote !== "'") throw new Error('Invalid quote `' + quote + '`, expected `\'` or `"`');
    /** @type {State} */ const state = {
        one: $b6819b5b1a8bddcd$var$one,
        all: $b6819b5b1a8bddcd$export$84bf76cd7afc7469,
        settings: {
            omitOptionalTags: options_.omitOptionalTags || false,
            allowParseErrors: options_.allowParseErrors || false,
            allowDangerousCharacters: options_.allowDangerousCharacters || false,
            quoteSmart: options_.quoteSmart || false,
            preferUnquoted: options_.preferUnquoted || false,
            tightAttributes: options_.tightAttributes || false,
            upperDoctype: options_.upperDoctype || false,
            tightDoctype: options_.tightDoctype || false,
            bogusComments: options_.bogusComments || false,
            tightCommaSeparatedLists: options_.tightCommaSeparatedLists || false,
            tightSelfClosing: options_.tightSelfClosing || false,
            collapseEmptyAttributes: options_.collapseEmptyAttributes || false,
            allowDangerousHtml: options_.allowDangerousHtml || false,
            voids: options_.voids || (0, $fe4fce3fd1fee116$export$762508062d068de),
            characterReferences: options_.characterReferences || $b6819b5b1a8bddcd$var$emptyCharacterReferences,
            closeSelfClosing: options_.closeSelfClosing || false,
            closeEmptyElements: options_.closeEmptyElements || false
        },
        schema: options_.space === 'svg' ? (0, $cad208d20be39d74$export$7ed1367e7fa1ad68) : (0, $cad208d20be39d74$export$c0bb0b647f701bb5),
        quote: quote,
        alternative: alternative
    };
    return state.one(Array.isArray(tree) ? {
        type: 'root',
        children: tree
    } : tree, undefined, undefined);
}
/**
 * Serialize a node.
 *
 * @this {State}
 *   Info passed around about the current state.
 * @param {Nodes} node
 *   Node to handle.
 * @param {number | undefined} index
 *   Index of `node` in `parent.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @returns {string}
 *   Serialized node.
 */ function $b6819b5b1a8bddcd$var$one(node, index, parent) {
    return (0, $63d36365cefda5e3$export$8f34ce051745d39e)(node, index, parent, this);
}
function $b6819b5b1a8bddcd$export$84bf76cd7afc7469(parent) {
    /** @type {Array<string>} */ const results = [];
    const children = parent && parent.children || $b6819b5b1a8bddcd$var$emptyChildren;
    let index = -1;
    while(++index < children.length)results[index] = this.one(children[index], index, parent);
    return results.join('');
}


function $bbf894dfad4e2855$export$2e2bcd8739ae039(options) {
    /** @type {Processor<undefined, undefined, undefined, Root, string>} */ // @ts-expect-error: TS in JSDoc generates wrong types if `this` is typed regularly.
    const self = this;
    const settings = {
        ...self.data('settings'),
        ...options
    };
    self.compiler = compiler;
    /**
   * @type {Compiler<Root, string>}
   */ function compiler(tree) {
        return (0, $b6819b5b1a8bddcd$export$a10125c086a4df16)(tree, settings);
    }
}



const $896ab3348b7fb05e$export$3c91a9a75d9d4e1f = (0, $82354957eb1a51f9$export$7cc1b2fe10c52bb)().use((0, $8d8ab2772df59c2a$export$2e2bcd8739ae039)).use((0, $bbf894dfad4e2855$export$2e2bcd8739ae039)).freeze();






/**
 * @typedef {import('./core.js').Syntax} Syntax
 */ // @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $eba707d89e6509b5$export$2e2bcd8739ae039.displayName = 'clike';
$eba707d89e6509b5$export$2e2bcd8739ae039.aliases = [];
function $eba707d89e6509b5$export$2e2bcd8739ae039(Prism) {
    Prism.languages.clike = {
        comment: [
            {
                pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
            lookbehind: true,
            inside: {
                punctuation: /[.\\]/
            }
        },
        keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
        boolean: /\b(?:false|true)\b/,
        function: /\b\w+(?=\()/,
        number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
        operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
        punctuation: /[{}[\];(),.:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$f4e156ae6ed8d0a0$export$2e2bcd8739ae039.displayName = 'c';
$f4e156ae6ed8d0a0$export$2e2bcd8739ae039.aliases = [];
function $f4e156ae6ed8d0a0$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.c = Prism.languages.extend('clike', {
        comment: {
            pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
            greedy: true
        },
        string: {
            // https://en.cppreference.com/w/c/language/string_literal
            pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
            lookbehind: true
        },
        keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
        operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
    });
    Prism.languages.insertBefore('c', 'string', {
        char: {
            // https://en.cppreference.com/w/c/language/character_constant
            pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
            greedy: true
        }
    });
    Prism.languages.insertBefore('c', 'string', {
        macro: {
            // allow for multiline macro definitions
            // spaces after the # character compile fine with gcc
            pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
            lookbehind: true,
            greedy: true,
            alias: 'property',
            inside: {
                string: [
                    {
                        // highlight the path of the include statement as a string
                        pattern: /^(#\s*include\s*)<[^>]+>/,
                        lookbehind: true
                    },
                    Prism.languages.c['string']
                ],
                char: Prism.languages.c['char'],
                comment: Prism.languages.c['comment'],
                'macro-name': [
                    {
                        pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
                        lookbehind: true
                    },
                    {
                        pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
                        lookbehind: true,
                        alias: 'function'
                    }
                ],
                // highlight macro directives as keywords
                directive: {
                    pattern: /^(#\s*)[a-z]+/,
                    lookbehind: true,
                    alias: 'keyword'
                },
                'directive-hash': /^#/,
                punctuation: /##|\\(?=[\r\n])/,
                expression: {
                    pattern: /\S[\s\S]*/,
                    inside: Prism.languages.c
                }
            }
        }
    });
    Prism.languages.insertBefore('c', 'function', {
        // highlight predefined macros as constants
        constant: /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
    });
    delete Prism.languages.c['boolean'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$b373cdd06f88d58c$export$2e2bcd8739ae039.displayName = 'cpp';
$b373cdd06f88d58c$export$2e2bcd8739ae039.aliases = [];
function $b373cdd06f88d58c$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f4e156ae6ed8d0a0$export$2e2bcd8739ae039));
    (function(Prism) {
        var keyword = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/;
        var modName = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function() {
            return keyword.source;
        });
        Prism.languages.cpp = Prism.languages.extend('c', {
            'class-name': [
                {
                    pattern: RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g, function() {
                        return keyword.source;
                    })),
                    lookbehind: true
                },
                // This is intended to capture the class name of method implementations like:
                //   void foo::bar() const {}
                // However! The `foo` in the above example could also be a namespace, so we only capture the class name if
                // it starts with an uppercase letter. This approximation should give decent results.
                /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,
                // This will capture the class name before destructors like:
                //   Foo::~Foo() {}
                /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,
                // This also intends to capture the class name of method implementations but here the class has template
                // parameters, so it can't be a namespace (until C++ adds generic namespaces).
                /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/
            ],
            keyword: keyword,
            number: {
                pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
                greedy: true
            },
            operator: />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
            boolean: /\b(?:false|true)\b/
        });
        Prism.languages.insertBefore('cpp', 'string', {
            module: {
                // https://en.cppreference.com/w/cpp/language/modules
                pattern: RegExp(/(\b(?:import|module)\s+)/.source + '(?:' + // header-name
                /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + '|' + // module name or partition or both
                /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function() {
                    return modName;
                }) + ')'),
                lookbehind: true,
                greedy: true,
                inside: {
                    string: /^[<"][\s\S]+/,
                    operator: /:/,
                    punctuation: /\./
                }
            },
            'raw-string': {
                pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
                alias: 'string',
                greedy: true
            }
        });
        Prism.languages.insertBefore('cpp', 'keyword', {
            'generic-function': {
                pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
                inside: {
                    function: /^\w+/,
                    generic: {
                        pattern: /<[\s\S]+/,
                        alias: 'class-name',
                        inside: Prism.languages.cpp
                    }
                }
            }
        });
        Prism.languages.insertBefore('cpp', 'operator', {
            'double-colon': {
                pattern: /::/,
                alias: 'punctuation'
            }
        });
        Prism.languages.insertBefore('cpp', 'class-name', {
            // the base clause is an optional list of parent classes
            // https://en.cppreference.com/w/cpp/language/class
            'base-clause': {
                pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
                lookbehind: true,
                greedy: true,
                inside: Prism.languages.extend('cpp', {})
            }
        });
        Prism.languages.insertBefore('inside', 'double-colon', {
            // All untokenized words that are not namespaces should be class names
            'class-name': /\b[a-z_]\w*\b(?!\s*::)/i
        }, Prism.languages.cpp['base-clause']);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$4fe2e947cede365f$export$2e2bcd8739ae039.displayName = 'arduino';
$4fe2e947cede365f$export$2e2bcd8739ae039.aliases = [
    'ino'
];
function $4fe2e947cede365f$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $b373cdd06f88d58c$export$2e2bcd8739ae039));
    Prism.languages.arduino = Prism.languages.extend('cpp', {
        keyword: /\b(?:String|array|bool|boolean|break|byte|case|catch|continue|default|do|double|else|finally|for|function|goto|if|in|instanceof|int|integer|long|loop|new|null|return|setup|string|switch|throw|try|void|while|word)\b/,
        constant: /\b(?:ANALOG_MESSAGE|DEFAULT|DIGITAL_MESSAGE|EXTERNAL|FIRMATA_STRING|HIGH|INPUT|INPUT_PULLUP|INTERNAL|INTERNAL1V1|INTERNAL2V56|LED_BUILTIN|LOW|OUTPUT|REPORT_ANALOG|REPORT_DIGITAL|SET_PIN_MODE|SYSEX_START|SYSTEM_RESET)\b/,
        builtin: /\b(?:Audio|BSSID|Bridge|Client|Console|EEPROM|Esplora|EsploraTFT|Ethernet|EthernetClient|EthernetServer|EthernetUDP|File|FileIO|FileSystem|Firmata|GPRS|GSM|GSMBand|GSMClient|GSMModem|GSMPIN|GSMScanner|GSMServer|GSMVoiceCall|GSM_SMS|HttpClient|IPAddress|IRread|Keyboard|KeyboardController|LiquidCrystal|LiquidCrystal_I2C|Mailbox|Mouse|MouseController|PImage|Process|RSSI|RobotControl|RobotMotor|SD|SPI|SSID|Scheduler|Serial|Server|Servo|SoftwareSerial|Stepper|Stream|TFT|Task|USBHost|WiFi|WiFiClient|WiFiServer|WiFiUDP|Wire|YunClient|YunServer|abs|addParameter|analogRead|analogReadResolution|analogReference|analogWrite|analogWriteResolution|answerCall|attach|attachGPRS|attachInterrupt|attached|autoscroll|available|background|beep|begin|beginPacket|beginSD|beginSMS|beginSpeaker|beginTFT|beginTransmission|beginWrite|bit|bitClear|bitRead|bitSet|bitWrite|blink|blinkVersion|buffer|changePIN|checkPIN|checkPUK|checkReg|circle|cityNameRead|cityNameWrite|clear|clearScreen|click|close|compassRead|config|connect|connected|constrain|cos|countryNameRead|countryNameWrite|createChar|cursor|debugPrint|delay|delayMicroseconds|detach|detachInterrupt|digitalRead|digitalWrite|disconnect|display|displayLogos|drawBMP|drawCompass|encryptionType|end|endPacket|endSMS|endTransmission|endWrite|exists|exitValue|fill|find|findUntil|flush|gatewayIP|get|getAsynchronously|getBand|getButton|getCurrentCarrier|getIMEI|getKey|getModifiers|getOemKey|getPINUsed|getResult|getSignalStrength|getSocket|getVoiceCallStatus|getXChange|getYChange|hangCall|height|highByte|home|image|interrupts|isActionDone|isDirectory|isListening|isPIN|isPressed|isValid|keyPressed|keyReleased|keyboardRead|knobRead|leftToRight|line|lineFollowConfig|listen|listenOnLocalhost|loadImage|localIP|lowByte|macAddress|maintain|map|max|messageAvailable|micros|millis|min|mkdir|motorsStop|motorsWrite|mouseDragged|mouseMoved|mousePressed|mouseReleased|move|noAutoscroll|noBlink|noBuffer|noCursor|noDisplay|noFill|noInterrupts|noListenOnLocalhost|noStroke|noTone|onReceive|onRequest|open|openNextFile|overflow|parseCommand|parseFloat|parseInt|parsePacket|pauseMode|peek|pinMode|playFile|playMelody|point|pointTo|position|pow|prepare|press|print|printFirmwareVersion|printVersion|println|process|processInput|pulseIn|put|random|randomSeed|read|readAccelerometer|readBlue|readButton|readBytes|readBytesUntil|readGreen|readJoystickButton|readJoystickSwitch|readJoystickX|readJoystickY|readLightSensor|readMessage|readMicrophone|readNetworks|readRed|readSlider|readString|readStringUntil|readTemperature|ready|rect|release|releaseAll|remoteIP|remoteNumber|remotePort|remove|requestFrom|retrieveCallingNumber|rewindDirectory|rightToLeft|rmdir|robotNameRead|robotNameWrite|run|runAsynchronously|runShellCommand|runShellCommandAsynchronously|running|scanNetworks|scrollDisplayLeft|scrollDisplayRight|seek|sendAnalog|sendDigitalPortPair|sendDigitalPorts|sendString|sendSysex|serialEvent|setBand|setBitOrder|setClockDivider|setCursor|setDNS|setDataMode|setFirmwareVersion|setMode|setPINUsed|setSpeed|setTextSize|setTimeout|shiftIn|shiftOut|shutdown|sin|size|sqrt|startLoop|step|stop|stroke|subnetMask|switchPIN|tan|tempoWrite|text|tone|transfer|tuneWrite|turn|updateIR|userNameRead|userNameWrite|voiceCall|waitContinue|width|write|writeBlue|writeGreen|writeJSON|writeMessage|writeMicroseconds|writeRGB|writeRed|yield)\b/
    });
    Prism.languages.ino = Prism.languages.arduino;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $8bc35bfd2be6822a$export$2e2bcd8739ae039.displayName = 'bash';
$8bc35bfd2be6822a$export$2e2bcd8739ae039.aliases = [
    'sh',
    'shell'
];
function $8bc35bfd2be6822a$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // $ set | grep '^[A-Z][^[:space:]]*=' | cut -d= -f1 | tr '\n' '|'
        // + LC_ALL, RANDOM, REPLY, SECONDS.
        // + make sure PS1..4 are here as they are not always set,
        // - some useless things.
        var envVars = '\\b(?:BASH|BASHOPTS|BASH_ALIASES|BASH_ARGC|BASH_ARGV|BASH_CMDS|BASH_COMPLETION_COMPAT_DIR|BASH_LINENO|BASH_REMATCH|BASH_SOURCE|BASH_VERSINFO|BASH_VERSION|COLORTERM|COLUMNS|COMP_WORDBREAKS|DBUS_SESSION_BUS_ADDRESS|DEFAULTS_PATH|DESKTOP_SESSION|DIRSTACK|DISPLAY|EUID|GDMSESSION|GDM_LANG|GNOME_KEYRING_CONTROL|GNOME_KEYRING_PID|GPG_AGENT_INFO|GROUPS|HISTCONTROL|HISTFILE|HISTFILESIZE|HISTSIZE|HOME|HOSTNAME|HOSTTYPE|IFS|INSTANCE|JOB|LANG|LANGUAGE|LC_ADDRESS|LC_ALL|LC_IDENTIFICATION|LC_MEASUREMENT|LC_MONETARY|LC_NAME|LC_NUMERIC|LC_PAPER|LC_TELEPHONE|LC_TIME|LESSCLOSE|LESSOPEN|LINES|LOGNAME|LS_COLORS|MACHTYPE|MAILCHECK|MANDATORY_PATH|NO_AT_BRIDGE|OLDPWD|OPTERR|OPTIND|ORBIT_SOCKETDIR|OSTYPE|PAPERSIZE|PATH|PIPESTATUS|PPID|PS1|PS2|PS3|PS4|PWD|RANDOM|REPLY|SECONDS|SELINUX_INIT|SESSION|SESSIONTYPE|SESSION_MANAGER|SHELL|SHELLOPTS|SHLVL|SSH_AUTH_SOCK|TERM|UID|UPSTART_EVENTS|UPSTART_INSTANCE|UPSTART_JOB|UPSTART_SESSION|USER|WINDOWID|XAUTHORITY|XDG_CONFIG_DIRS|XDG_CURRENT_DESKTOP|XDG_DATA_DIRS|XDG_GREETER_DATA_DIR|XDG_MENU_PREFIX|XDG_RUNTIME_DIR|XDG_SEAT|XDG_SEAT_PATH|XDG_SESSION_DESKTOP|XDG_SESSION_ID|XDG_SESSION_PATH|XDG_SESSION_TYPE|XDG_VTNR|XMODIFIERS)\\b';
        var commandAfterHeredoc = {
            pattern: /(^(["']?)\w+\2)[ \t]+\S.*/,
            lookbehind: true,
            alias: 'punctuation',
            // this looks reasonably well in all themes
            inside: null // see below
        };
        var insideString = {
            bash: commandAfterHeredoc,
            environment: {
                pattern: RegExp('\\$' + envVars),
                alias: 'constant'
            },
            variable: [
                // [0]: Arithmetic Environment
                {
                    pattern: /\$?\(\([\s\S]+?\)\)/,
                    greedy: true,
                    inside: {
                        // If there is a $ sign at the beginning highlight $(( and )) as variable
                        variable: [
                            {
                                pattern: /(^\$\(\([\s\S]+)\)\)/,
                                lookbehind: true
                            },
                            /^\$\(\(/
                        ],
                        number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
                        // Operators according to https://www.gnu.org/software/bash/manual/bashref.html#Shell-Arithmetic
                        operator: /--|\+\+|\*\*=?|<<=?|>>=?|&&|\|\||[=!+\-*/%<>^&|]=?|[?~:]/,
                        // If there is no $ sign at the beginning highlight (( and )) as punctuation
                        punctuation: /\(\(?|\)\)?|,|;/
                    }
                },
                // [1]: Command Substitution
                {
                    pattern: /\$\((?:\([^)]+\)|[^()])+\)|`[^`]+`/,
                    greedy: true,
                    inside: {
                        variable: /^\$\(|^`|\)$|`$/
                    }
                },
                // [2]: Brace expansion
                {
                    pattern: /\$\{[^}]+\}/,
                    greedy: true,
                    inside: {
                        operator: /:[-=?+]?|[!\/]|##?|%%?|\^\^?|,,?/,
                        punctuation: /[\[\]]/,
                        environment: {
                            pattern: RegExp('(\\{)' + envVars),
                            lookbehind: true,
                            alias: 'constant'
                        }
                    }
                },
                /\$(?:\w+|[#?*!@$])/
            ],
            // Escape sequences from echo and printf's manuals, and escaped quotes.
            entity: /\\(?:[abceEfnrtv\\"]|O?[0-7]{1,3}|U[0-9a-fA-F]{8}|u[0-9a-fA-F]{4}|x[0-9a-fA-F]{1,2})/
        };
        Prism.languages.bash = {
            shebang: {
                pattern: /^#!\s*\/.*/,
                alias: 'important'
            },
            comment: {
                pattern: /(^|[^"{\\$])#.*/,
                lookbehind: true
            },
            'function-name': [
                // a) function foo {
                // b) foo() {
                // c) function foo() {
                // but not “foo {”
                {
                    // a) and c)
                    pattern: /(\bfunction\s+)[\w-]+(?=(?:\s*\(?:\s*\))?\s*\{)/,
                    lookbehind: true,
                    alias: 'function'
                },
                {
                    // b)
                    pattern: /\b[\w-]+(?=\s*\(\s*\)\s*\{)/,
                    alias: 'function'
                }
            ],
            // Highlight variable names as variables in for and select beginnings.
            'for-or-select': {
                pattern: /(\b(?:for|select)\s+)\w+(?=\s+in\s)/,
                alias: 'variable',
                lookbehind: true
            },
            // Highlight variable names as variables in the left-hand part
            // of assignments (“=” and “+=”).
            'assign-left': {
                pattern: /(^|[\s;|&]|[<>]\()\w+(?:\.\w+)*(?=\+?=)/,
                inside: {
                    environment: {
                        pattern: RegExp('(^|[\\s;|&]|[<>]\\()' + envVars),
                        lookbehind: true,
                        alias: 'constant'
                    }
                },
                alias: 'variable',
                lookbehind: true
            },
            // Highlight parameter names as variables
            parameter: {
                pattern: /(^|\s)-{1,2}(?:\w+:[+-]?)?\w+(?:\.\w+)*(?=[=\s]|$)/,
                alias: 'variable',
                lookbehind: true
            },
            string: [
                // Support for Here-documents https://en.wikipedia.org/wiki/Here_document
                {
                    pattern: /((?:^|[^<])<<-?\s*)(\w+)\s[\s\S]*?(?:\r?\n|\r)\2/,
                    lookbehind: true,
                    greedy: true,
                    inside: insideString
                },
                // Here-document with quotes around the tag
                // → No expansion (so no “inside”).
                {
                    pattern: /((?:^|[^<])<<-?\s*)(["'])(\w+)\2\s[\s\S]*?(?:\r?\n|\r)\3/,
                    lookbehind: true,
                    greedy: true,
                    inside: {
                        bash: commandAfterHeredoc
                    }
                },
                // “Normal” string
                {
                    // https://www.gnu.org/software/bash/manual/html_node/Double-Quotes.html
                    pattern: /(^|[^\\](?:\\\\)*)"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/,
                    lookbehind: true,
                    greedy: true,
                    inside: insideString
                },
                {
                    // https://www.gnu.org/software/bash/manual/html_node/Single-Quotes.html
                    pattern: /(^|[^$\\])'[^']*'/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    // https://www.gnu.org/software/bash/manual/html_node/ANSI_002dC-Quoting.html
                    pattern: /\$'(?:[^'\\]|\\[\s\S])*'/,
                    greedy: true,
                    inside: {
                        entity: insideString.entity
                    }
                }
            ],
            environment: {
                pattern: RegExp('\\$?' + envVars),
                alias: 'constant'
            },
            variable: insideString.variable,
            function: {
                pattern: /(^|[\s;|&]|[<>]\()(?:add|apropos|apt|apt-cache|apt-get|aptitude|aspell|automysqlbackup|awk|basename|bash|bc|bconsole|bg|bzip2|cal|cargo|cat|cfdisk|chgrp|chkconfig|chmod|chown|chroot|cksum|clear|cmp|column|comm|composer|cp|cron|crontab|csplit|curl|cut|date|dc|dd|ddrescue|debootstrap|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|docker|docker-compose|du|egrep|eject|env|ethtool|expand|expect|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|git|gparted|grep|groupadd|groupdel|groupmod|groups|grub-mkconfig|gzip|halt|head|hg|history|host|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|ip|java|jobs|join|kill|killall|less|link|ln|locate|logname|logrotate|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|lynx|make|man|mc|mdadm|mkconfig|mkdir|mke2fs|mkfifo|mkfs|mkisofs|mknod|mkswap|mmv|more|most|mount|mtools|mtr|mutt|mv|nano|nc|netstat|nice|nl|node|nohup|notify-send|npm|nslookup|op|open|parted|passwd|paste|pathchk|ping|pkill|pnpm|podman|podman-compose|popd|pr|printcap|printenv|ps|pushd|pv|quota|quotacheck|quotactl|ram|rar|rcp|reboot|remsync|rename|renice|rev|rm|rmdir|rpm|rsync|scp|screen|sdiff|sed|sendmail|seq|service|sftp|sh|shellcheck|shuf|shutdown|sleep|slocate|sort|split|ssh|stat|strace|su|sudo|sum|suspend|swapon|sync|sysctl|tac|tail|tar|tee|time|timeout|top|touch|tr|traceroute|tsort|tty|umount|uname|unexpand|uniq|units|unrar|unshar|unzip|update-grub|uptime|useradd|userdel|usermod|users|uudecode|uuencode|v|vcpkg|vdir|vi|vim|virsh|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yarn|yes|zenity|zip|zsh|zypper)(?=$|[)\s;|&])/,
                lookbehind: true
            },
            keyword: {
                pattern: /(^|[\s;|&]|[<>]\()(?:case|do|done|elif|else|esac|fi|for|function|if|in|select|then|until|while)(?=$|[)\s;|&])/,
                lookbehind: true
            },
            // https://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
            builtin: {
                pattern: /(^|[\s;|&]|[<>]\()(?:\.|:|alias|bind|break|builtin|caller|cd|command|continue|declare|echo|enable|eval|exec|exit|export|getopts|hash|help|let|local|logout|mapfile|printf|pwd|read|readarray|readonly|return|set|shift|shopt|source|test|times|trap|type|typeset|ulimit|umask|unalias|unset)(?=$|[)\s;|&])/,
                lookbehind: true,
                // Alias added to make those easier to distinguish from strings.
                alias: 'class-name'
            },
            boolean: {
                pattern: /(^|[\s;|&]|[<>]\()(?:false|true)(?=$|[)\s;|&])/,
                lookbehind: true
            },
            'file-descriptor': {
                pattern: /\B&\d\b/,
                alias: 'important'
            },
            operator: {
                // Lots of redirections here, but not just that.
                pattern: /\d?<>|>\||\+=|=[=~]?|!=?|<<[<-]?|[&\d]?>>|\d[<>]&?|[<>][&=]?|&[>&]?|\|[&|]?/,
                inside: {
                    'file-descriptor': {
                        pattern: /^\d/,
                        alias: 'important'
                    }
                }
            },
            punctuation: /\$?\(\(?|\)\)?|\.\.|[{}[\];\\]/,
            number: {
                pattern: /(^|\s)(?:[1-9]\d*|0)(?:[.,]\d+)?\b/,
                lookbehind: true
            }
        };
        commandAfterHeredoc.inside = Prism.languages.bash;
        /* Patterns in command substitution. */ var toBeCopied = [
            'comment',
            'function-name',
            'for-or-select',
            'assign-left',
            'parameter',
            'string',
            'environment',
            'function',
            'keyword',
            'builtin',
            'boolean',
            'file-descriptor',
            'operator',
            'punctuation',
            'number'
        ];
        var inside = insideString.variable[1].inside;
        for(var i = 0; i < toBeCopied.length; i++)inside[toBeCopied[i]] = Prism.languages.bash[toBeCopied[i]];
        Prism.languages.sh = Prism.languages.bash;
        Prism.languages.shell = Prism.languages.bash;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$803928922a6961a4$export$2e2bcd8739ae039.displayName = 'csharp';
$803928922a6961a4$export$2e2bcd8739ae039.aliases = [
    'cs',
    'dotnet'
];
function $803928922a6961a4$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    (function(Prism) {
        /**
     * Replaces all placeholders "<<n>>" of given pattern with the n-th replacement (zero based).
     *
     * Note: This is a simple text based replacement. Be careful when using backreferences!
     *
     * @param {string} pattern the given pattern.
     * @param {string[]} replacements a list of replacement which can be inserted into the given pattern.
     * @returns {string} the pattern with all placeholders replaced with their corresponding replacements.
     * @example replace(/a<<0>>a/.source, [/b+/.source]) === /a(?:b+)a/.source
     */ function replace(pattern, replacements) {
            return pattern.replace(/<<(\d+)>>/g, function(m, index) {
                return '(?:' + replacements[+index] + ')';
            });
        }
        /**
     * @param {string} pattern
     * @param {string[]} replacements
     * @param {string} [flags]
     * @returns {RegExp}
     */ function re(pattern, replacements, flags) {
            return RegExp(replace(pattern, replacements), flags || '');
        }
        /**
     * Creates a nested pattern where all occurrences of the string `<<self>>` are replaced with the pattern itself.
     *
     * @param {string} pattern
     * @param {number} depthLog2
     * @returns {string}
     */ function nested(pattern, depthLog2) {
            for(var i = 0; i < depthLog2; i++)pattern = pattern.replace(/<<self>>/g, function() {
                return '(?:' + pattern + ')';
            });
            return pattern.replace(/<<self>>/g, '[^\\s\\S]');
        }
        // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/keywords/
        var keywordKinds = {
            // keywords which represent a return or variable type
            type: 'bool byte char decimal double dynamic float int long object sbyte short string uint ulong ushort var void',
            // keywords which are used to declare a type
            typeDeclaration: 'class enum interface record struct',
            // contextual keywords
            // ("var" and "dynamic" are missing because they are used like types)
            contextual: 'add alias and ascending async await by descending from(?=\\s*(?:\\w|$)) get global group into init(?=\\s*;) join let nameof not notnull on or orderby partial remove select set unmanaged value when where with(?=\\s*{)',
            // all other keywords
            other: 'abstract as base break case catch checked const continue default delegate do else event explicit extern finally fixed for foreach goto if implicit in internal is lock namespace new null operator out override params private protected public readonly ref return sealed sizeof stackalloc static switch this throw try typeof unchecked unsafe using virtual volatile while yield'
        };
        // keywords
        function keywordsToPattern(words) {
            return '\\b(?:' + words.trim().replace(/ /g, '|') + ')\\b';
        }
        var typeDeclarationKeywords = keywordsToPattern(keywordKinds.typeDeclaration);
        var keywords = RegExp(keywordsToPattern(keywordKinds.type + ' ' + keywordKinds.typeDeclaration + ' ' + keywordKinds.contextual + ' ' + keywordKinds.other));
        var nonTypeKeywords = keywordsToPattern(keywordKinds.typeDeclaration + ' ' + keywordKinds.contextual + ' ' + keywordKinds.other);
        var nonContextualKeywords = keywordsToPattern(keywordKinds.type + ' ' + keywordKinds.typeDeclaration + ' ' + keywordKinds.other);
        // types
        var generic = nested(/<(?:[^<>;=+\-*/%&|^]|<<self>>)*>/.source, 2) // the idea behind the other forbidden characters is to prevent false positives. Same for tupleElement.
        ;
        var nestedRound = nested(/\((?:[^()]|<<self>>)*\)/.source, 2);
        var name = /@?\b[A-Za-z_]\w*\b/.source;
        var genericName = replace(/<<0>>(?:\s*<<1>>)?/.source, [
            name,
            generic
        ]);
        var identifier = replace(/(?!<<0>>)<<1>>(?:\s*\.\s*<<1>>)*/.source, [
            nonTypeKeywords,
            genericName
        ]);
        var array = /\[\s*(?:,\s*)*\]/.source;
        var typeExpressionWithoutTuple = replace(/<<0>>(?:\s*(?:\?\s*)?<<1>>)*(?:\s*\?)?/.source, [
            identifier,
            array
        ]);
        var tupleElement = replace(/[^,()<>[\];=+\-*/%&|^]|<<0>>|<<1>>|<<2>>/.source, [
            generic,
            nestedRound,
            array
        ]);
        var tuple = replace(/\(<<0>>+(?:,<<0>>+)+\)/.source, [
            tupleElement
        ]);
        var typeExpression = replace(/(?:<<0>>|<<1>>)(?:\s*(?:\?\s*)?<<2>>)*(?:\s*\?)?/.source, [
            tuple,
            identifier,
            array
        ]);
        var typeInside = {
            keyword: keywords,
            punctuation: /[<>()?,.:[\]]/
        };
        // strings & characters
        // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/language-specification/lexical-structure#character-literals
        // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/language-specification/lexical-structure#string-literals
        var character = /'(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'/.source // simplified pattern
        ;
        var regularString = /"(?:\\.|[^\\"\r\n])*"/.source;
        var verbatimString = /@"(?:""|\\[\s\S]|[^\\"])*"(?!")/.source;
        Prism.languages.csharp = Prism.languages.extend('clike', {
            string: [
                {
                    pattern: re(/(^|[^$\\])<<0>>/.source, [
                        verbatimString
                    ]),
                    lookbehind: true,
                    greedy: true
                },
                {
                    pattern: re(/(^|[^@$\\])<<0>>/.source, [
                        regularString
                    ]),
                    lookbehind: true,
                    greedy: true
                }
            ],
            'class-name': [
                {
                    // Using static
                    // using static System.Math;
                    pattern: re(/(\busing\s+static\s+)<<0>>(?=\s*;)/.source, [
                        identifier
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // Using alias (type)
                    // using Project = PC.MyCompany.Project;
                    pattern: re(/(\busing\s+<<0>>\s*=\s*)<<1>>(?=\s*;)/.source, [
                        name,
                        typeExpression
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // Using alias (alias)
                    // using Project = PC.MyCompany.Project;
                    pattern: re(/(\busing\s+)<<0>>(?=\s*=)/.source, [
                        name
                    ]),
                    lookbehind: true
                },
                {
                    // Type declarations
                    // class Foo<A, B>
                    // interface Foo<out A, B>
                    pattern: re(/(\b<<0>>\s+)<<1>>/.source, [
                        typeDeclarationKeywords,
                        genericName
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // Single catch exception declaration
                    // catch(Foo)
                    // (things like catch(Foo e) is covered by variable declaration)
                    pattern: re(/(\bcatch\s*\(\s*)<<0>>/.source, [
                        identifier
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // Name of the type parameter of generic constraints
                    // where Foo : class
                    pattern: re(/(\bwhere\s+)<<0>>/.source, [
                        name
                    ]),
                    lookbehind: true
                },
                {
                    // Casts and checks via as and is.
                    // as Foo<A>, is Bar<B>
                    // (things like if(a is Foo b) is covered by variable declaration)
                    pattern: re(/(\b(?:is(?:\s+not)?|as)\s+)<<0>>/.source, [
                        typeExpressionWithoutTuple
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // Variable, field and parameter declaration
                    // (Foo bar, Bar baz, Foo[,,] bay, Foo<Bar, FooBar<Bar>> bax)
                    pattern: re(/\b<<0>>(?=\s+(?!<<1>>|with\s*\{)<<2>>(?:\s*[=,;:{)\]]|\s+(?:in|when)\b))/.source, [
                        typeExpression,
                        nonContextualKeywords,
                        name
                    ]),
                    inside: typeInside
                }
            ],
            keyword: keywords,
            // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/language-specification/lexical-structure#literals
            number: /(?:\b0(?:x[\da-f_]*[\da-f]|b[01_]*[01])|(?:\B\.\d+(?:_+\d+)*|\b\d+(?:_+\d+)*(?:\.\d+(?:_+\d+)*)?)(?:e[-+]?\d+(?:_+\d+)*)?)(?:[dflmu]|lu|ul)?\b/i,
            operator: />>=?|<<=?|[-=]>|([-+&|])\1|~|\?\?=?|[-+*/%&|^!=<>]=?/,
            punctuation: /\?\.?|::|[{}[\];(),.:]/
        });
        Prism.languages.insertBefore('csharp', 'number', {
            range: {
                pattern: /\.\./,
                alias: 'operator'
            }
        });
        Prism.languages.insertBefore('csharp', 'punctuation', {
            'named-parameter': {
                pattern: re(/([(,]\s*)<<0>>(?=\s*:)/.source, [
                    name
                ]),
                lookbehind: true,
                alias: 'punctuation'
            }
        });
        Prism.languages.insertBefore('csharp', 'class-name', {
            namespace: {
                // namespace Foo.Bar {}
                // using Foo.Bar;
                pattern: re(/(\b(?:namespace|using)\s+)<<0>>(?:\s*\.\s*<<0>>)*(?=\s*[;{])/.source, [
                    name
                ]),
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            },
            'type-expression': {
                // default(Foo), typeof(Foo<Bar>), sizeof(int)
                pattern: re(/(\b(?:default|sizeof|typeof)\s*\(\s*(?!\s))(?:[^()\s]|\s(?!\s)|<<0>>)*(?=\s*\))/.source, [
                    nestedRound
                ]),
                lookbehind: true,
                alias: 'class-name',
                inside: typeInside
            },
            'return-type': {
                // Foo<Bar> ForBar(); Foo IFoo.Bar() => 0
                // int this[int index] => 0; T IReadOnlyList<T>.this[int index] => this[index];
                // int Foo => 0; int Foo { get; set } = 0;
                pattern: re(/<<0>>(?=\s+(?:<<1>>\s*(?:=>|[({]|\.\s*this\s*\[)|this\s*\[))/.source, [
                    typeExpression,
                    identifier
                ]),
                inside: typeInside,
                alias: 'class-name'
            },
            'constructor-invocation': {
                // new List<Foo<Bar[]>> { }
                pattern: re(/(\bnew\s+)<<0>>(?=\s*[[({])/.source, [
                    typeExpression
                ]),
                lookbehind: true,
                inside: typeInside,
                alias: 'class-name'
            },
            /*'explicit-implementation': {
// int IFoo<Foo>.Bar => 0; void IFoo<Foo<Foo>>.Foo<T>();
pattern: replace(/\b<<0>>(?=\.<<1>>)/, className, methodOrPropertyDeclaration),
inside: classNameInside,
alias: 'class-name'
},*/ 'generic-method': {
                // foo<Bar>()
                pattern: re(/<<0>>\s*<<1>>(?=\s*\()/.source, [
                    name,
                    generic
                ]),
                inside: {
                    function: re(/^<<0>>/.source, [
                        name
                    ]),
                    generic: {
                        pattern: RegExp(generic),
                        alias: 'class-name',
                        inside: typeInside
                    }
                }
            },
            'type-list': {
                // The list of types inherited or of generic constraints
                // class Foo<F> : Bar, IList<FooBar>
                // where F : Bar, IList<int>
                pattern: re(/\b((?:<<0>>\s+<<1>>|record\s+<<1>>\s*<<5>>|where\s+<<2>>)\s*:\s*)(?:<<3>>|<<4>>|<<1>>\s*<<5>>|<<6>>)(?:\s*,\s*(?:<<3>>|<<4>>|<<6>>))*(?=\s*(?:where|[{;]|=>|$))/.source, [
                    typeDeclarationKeywords,
                    genericName,
                    name,
                    typeExpression,
                    keywords.source,
                    nestedRound,
                    /\bnew\s*\(\s*\)/.source
                ]),
                lookbehind: true,
                inside: {
                    'record-arguments': {
                        pattern: re(/(^(?!new\s*\()<<0>>\s*)<<1>>/.source, [
                            genericName,
                            nestedRound
                        ]),
                        lookbehind: true,
                        greedy: true,
                        inside: Prism.languages.csharp
                    },
                    keyword: keywords,
                    'class-name': {
                        pattern: RegExp(typeExpression),
                        greedy: true,
                        inside: typeInside
                    },
                    punctuation: /[,()]/
                }
            },
            preprocessor: {
                pattern: /(^[\t ]*)#.*/m,
                lookbehind: true,
                alias: 'property',
                inside: {
                    // highlight preprocessor directives as keywords
                    directive: {
                        pattern: /(#)\b(?:define|elif|else|endif|endregion|error|if|line|nullable|pragma|region|undef|warning)\b/,
                        lookbehind: true,
                        alias: 'keyword'
                    }
                }
            }
        });
        // attributes
        var regularStringOrCharacter = regularString + '|' + character;
        var regularStringCharacterOrComment = replace(/\/(?![*/])|\/\/[^\r\n]*[\r\n]|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>/.source, [
            regularStringOrCharacter
        ]);
        var roundExpression = nested(replace(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [
            regularStringCharacterOrComment
        ]), 2);
        // https://docs.microsoft.com/en-us/dotnet/csharp/programming-guide/concepts/attributes/#attribute-targets
        var attrTarget = /\b(?:assembly|event|field|method|module|param|property|return|type)\b/.source;
        var attr = replace(/<<0>>(?:\s*\(<<1>>*\))?/.source, [
            identifier,
            roundExpression
        ]);
        Prism.languages.insertBefore('csharp', 'class-name', {
            attribute: {
                // Attributes
                // [Foo], [Foo(1), Bar(2, Prop = "foo")], [return: Foo(1), Bar(2)], [assembly: Foo(Bar)]
                pattern: re(/((?:^|[^\s\w>)?])\s*\[\s*)(?:<<0>>\s*:\s*)?<<1>>(?:\s*,\s*<<1>>)*(?=\s*\])/.source, [
                    attrTarget,
                    attr
                ]),
                lookbehind: true,
                greedy: true,
                inside: {
                    target: {
                        pattern: re(/^<<0>>(?=\s*:)/.source, [
                            attrTarget
                        ]),
                        alias: 'keyword'
                    },
                    'attribute-arguments': {
                        pattern: re(/\(<<0>>*\)/.source, [
                            roundExpression
                        ]),
                        inside: Prism.languages.csharp
                    },
                    'class-name': {
                        pattern: RegExp(identifier),
                        inside: {
                            punctuation: /\./
                        }
                    },
                    punctuation: /[:,]/
                }
            }
        });
        // string interpolation
        var formatString = /:[^}\r\n]+/.source;
        // multi line
        var mInterpolationRound = nested(replace(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [
            regularStringCharacterOrComment
        ]), 2);
        var mInterpolation = replace(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [
            mInterpolationRound,
            formatString
        ]);
        // single line
        var sInterpolationRound = nested(replace(/[^"'/()]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>|\(<<self>>*\)/.source, [
            regularStringOrCharacter
        ]), 2);
        var sInterpolation = replace(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [
            sInterpolationRound,
            formatString
        ]);
        function createInterpolationInside(interpolation, interpolationRound) {
            return {
                interpolation: {
                    pattern: re(/((?:^|[^{])(?:\{\{)*)<<0>>/.source, [
                        interpolation
                    ]),
                    lookbehind: true,
                    inside: {
                        'format-string': {
                            pattern: re(/(^\{(?:(?![}:])<<0>>)*)<<1>>(?=\}$)/.source, [
                                interpolationRound,
                                formatString
                            ]),
                            lookbehind: true,
                            inside: {
                                punctuation: /^:/
                            }
                        },
                        punctuation: /^\{|\}$/,
                        expression: {
                            pattern: /[\s\S]+/,
                            alias: 'language-csharp',
                            inside: Prism.languages.csharp
                        }
                    }
                },
                string: /[\s\S]+/
            };
        }
        Prism.languages.insertBefore('csharp', 'string', {
            'interpolation-string': [
                {
                    pattern: re(/(^|[^\\])(?:\$@|@\$)"(?:""|\\[\s\S]|\{\{|<<0>>|[^\\{"])*"/.source, [
                        mInterpolation
                    ]),
                    lookbehind: true,
                    greedy: true,
                    inside: createInterpolationInside(mInterpolation, mInterpolationRound)
                },
                {
                    pattern: re(/(^|[^@\\])\$"(?:\\.|\{\{|<<0>>|[^\\"{])*"/.source, [
                        sInterpolation
                    ]),
                    lookbehind: true,
                    greedy: true,
                    inside: createInterpolationInside(sInterpolation, sInterpolationRound)
                }
            ],
            char: {
                pattern: RegExp(character),
                greedy: true
            }
        });
        Prism.languages.dotnet = Prism.languages.cs = Prism.languages.csharp;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $f47682e33a093951$export$2e2bcd8739ae039.displayName = 'markup';
$f47682e33a093951$export$2e2bcd8739ae039.aliases = [
    'atom',
    'html',
    'mathml',
    'rss',
    'ssml',
    'svg',
    'xml'
];
function $f47682e33a093951$export$2e2bcd8739ae039(Prism) {
    Prism.languages.markup = {
        comment: {
            pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
            greedy: true
        },
        prolog: {
            pattern: /<\?[\s\S]+?\?>/,
            greedy: true
        },
        doctype: {
            // https://www.w3.org/TR/xml/#NT-doctypedecl
            pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
            greedy: true,
            inside: {
                'internal-subset': {
                    pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                    lookbehind: true,
                    greedy: true,
                    inside: null // see below
                },
                string: {
                    pattern: /"[^"]*"|'[^']*'/,
                    greedy: true
                },
                punctuation: /^<!|>$|[[\]]/,
                'doctype-tag': /^DOCTYPE/i,
                name: /[^\s<>'"]+/
            }
        },
        cdata: {
            pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
            greedy: true
        },
        tag: {
            pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
            greedy: true,
            inside: {
                tag: {
                    pattern: /^<\/?[^\s>\/]+/,
                    inside: {
                        punctuation: /^<\/?/,
                        namespace: /^[^\s>\/:]+:/
                    }
                },
                'special-attr': [],
                'attr-value': {
                    pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                    inside: {
                        punctuation: [
                            {
                                pattern: /^=/,
                                alias: 'attr-equals'
                            },
                            {
                                pattern: /^(\s*)["']|["']$/,
                                lookbehind: true
                            }
                        ]
                    }
                },
                punctuation: /\/?>/,
                'attr-name': {
                    pattern: /[^\s>\/]+/,
                    inside: {
                        namespace: /^[^\s>\/:]+:/
                    }
                }
            }
        },
        entity: [
            {
                pattern: /&[\da-z]{1,8};/i,
                alias: 'named-entity'
            },
            /&#x?[\da-f]{1,8};/i
        ]
    };
    Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] = Prism.languages.markup['entity'];
    Prism.languages.markup['doctype'].inside['internal-subset'].inside = Prism.languages.markup;
    // Plugin to make entity title show the real entity, idea by Roman Komarov
    Prism.hooks.add('wrap', function(env) {
        if (env.type === 'entity') env.attributes['title'] = env.content.value.replace(/&amp;/, '&');
    });
    Object.defineProperty(Prism.languages.markup.tag, 'addInlined', {
        /**
     * Adds an inlined language to markup.
     *
     * An example of an inlined language is CSS with `<style>` tags.
     *
     * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addInlined('style', 'css');
     */ value: function addInlined(tagName, lang) {
            var includedCdataInside = {};
            includedCdataInside['language-' + lang] = {
                pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
                lookbehind: true,
                inside: Prism.languages[lang]
            };
            includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;
            var inside = {
                'included-cdata': {
                    pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                    inside: includedCdataInside
                }
            };
            inside['language-' + lang] = {
                pattern: /[\s\S]+/,
                inside: Prism.languages[lang]
            };
            var def = {};
            def[tagName] = {
                pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                    return tagName;
                }), 'i'),
                lookbehind: true,
                greedy: true,
                inside: inside
            };
            Prism.languages.insertBefore('markup', 'cdata', def);
        }
    });
    Object.defineProperty(Prism.languages.markup.tag, 'addAttribute', {
        /**
     * Adds an pattern to highlight languages embedded in HTML attributes.
     *
     * An example of an inlined language is CSS with `style` attributes.
     *
     * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addAttribute('style', 'css');
     */ value: function(attrName, lang) {
            Prism.languages.markup.tag.inside['special-attr'].push({
                pattern: RegExp(/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, 'i'),
                lookbehind: true,
                inside: {
                    'attr-name': /^[^\s=]+/,
                    'attr-value': {
                        pattern: /=[\s\S]+/,
                        inside: {
                            value: {
                                pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                                lookbehind: true,
                                alias: [
                                    lang,
                                    'language-' + lang
                                ],
                                inside: Prism.languages[lang]
                            },
                            punctuation: [
                                {
                                    pattern: /^=/,
                                    alias: 'attr-equals'
                                },
                                /"|'/
                            ]
                        }
                    }
                }
            });
        }
    });
    Prism.languages.html = Prism.languages.markup;
    Prism.languages.mathml = Prism.languages.markup;
    Prism.languages.svg = Prism.languages.markup;
    Prism.languages.xml = Prism.languages.extend('markup', {});
    Prism.languages.ssml = Prism.languages.xml;
    Prism.languages.atom = Prism.languages.xml;
    Prism.languages.rss = Prism.languages.xml;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $8467c3aacdff56ee$export$2e2bcd8739ae039.displayName = 'css';
$8467c3aacdff56ee$export$2e2bcd8739ae039.aliases = [];
function $8467c3aacdff56ee$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
        Prism.languages.css = {
            comment: /\/\*[\s\S]*?\*\//,
            atrule: {
                pattern: RegExp('@[\\w-](?:' + /[^;{\s"']|\s+(?!\s)/.source + '|' + string.source + ')*?' + /(?:;|(?=\s*\{))/.source),
                inside: {
                    rule: /^@[\w-]+/,
                    'selector-function-argument': {
                        pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                        lookbehind: true,
                        alias: 'selector'
                    },
                    keyword: {
                        pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                        lookbehind: true
                    }
                }
            },
            url: {
                // https://drafts.csswg.org/css-values-3/#urls
                pattern: RegExp('\\burl\\((?:' + string.source + '|' + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ')\\)', 'i'),
                greedy: true,
                inside: {
                    function: /^url/i,
                    punctuation: /^\(|\)$/,
                    string: {
                        pattern: RegExp('^' + string.source + '$'),
                        alias: 'url'
                    }
                }
            },
            selector: {
                pattern: RegExp('(^|[{}\\s])[^{}\\s](?:[^{};"\'\\s]|\\s+(?![\\s{])|' + string.source + ')*(?=\\s*\\{)'),
                lookbehind: true
            },
            string: {
                pattern: string,
                greedy: true
            },
            property: {
                pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
                lookbehind: true
            },
            important: /!important\b/i,
            function: {
                pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
                lookbehind: true
            },
            punctuation: /[(){};:,]/
        };
        Prism.languages.css['atrule'].inside.rest = Prism.languages.css;
        var markup = Prism.languages.markup;
        if (markup) {
            markup.tag.addInlined('style', 'css');
            markup.tag.addAttribute('style', 'css');
        }
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $dab2950de0f638d9$export$2e2bcd8739ae039.displayName = 'diff';
$dab2950de0f638d9$export$2e2bcd8739ae039.aliases = [];
function $dab2950de0f638d9$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.diff = {
            coord: [
                // Match all kinds of coord lines (prefixed by "+++", "---" or "***").
                /^(?:\*{3}|-{3}|\+{3}).*$/m,
                // Match "@@ ... @@" coord lines in unified diff.
                /^@@.*@@$/m,
                // Match coord lines in normal diff (starts with a number).
                /^\d.*$/m
            ]
        };
        /**
     * A map from the name of a block to its line prefix.
     *
     * @type {Object<string, string>}
     */ var PREFIXES = {
            'deleted-sign': '-',
            'deleted-arrow': '<',
            'inserted-sign': '+',
            'inserted-arrow': '>',
            unchanged: ' ',
            diff: '!'
        };
        // add a token for each prefix
        Object.keys(PREFIXES).forEach(function(name) {
            var prefix = PREFIXES[name];
            var alias = [];
            if (!/^\w+$/.test(name)) // "deleted-sign" -> "deleted"
            alias.push(/\w+/.exec(name)[0]);
            if (name === 'diff') alias.push('bold');
            Prism.languages.diff[name] = {
                pattern: RegExp('^(?:[' + prefix + '].*(?:\r\n?|\n|(?![\\s\\S])))+', 'm'),
                alias: alias,
                inside: {
                    line: {
                        pattern: /(.)(?=[\s\S]).*(?:\r\n?|\n)?/,
                        lookbehind: true
                    },
                    prefix: {
                        pattern: /[\s\S]/,
                        alias: /\w+/.exec(name)[0]
                    }
                }
            };
        });
        // make prefixes available to Diff plugin
        Object.defineProperty(Prism.languages.diff, 'PREFIXES', {
            value: PREFIXES
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$1c0f2e453947e61a$export$2e2bcd8739ae039.displayName = 'go';
$1c0f2e453947e61a$export$2e2bcd8739ae039.aliases = [];
function $1c0f2e453947e61a$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.go = Prism.languages.extend('clike', {
        string: {
            pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/,
            lookbehind: true,
            greedy: true
        },
        keyword: /\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/,
        boolean: /\b(?:_|false|iota|nil|true)\b/,
        number: [
            // binary and octal integers
            /\b0(?:b[01_]+|o[0-7_]+)i?\b/i,
            // hexadecimal integers and floats
            /\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
            // decimal integers and floats
            /(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i
        ],
        operator: /[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./,
        builtin: /\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/
    });
    Prism.languages.insertBefore('go', 'string', {
        char: {
            pattern: /'(?:\\.|[^'\\\r\n]){0,10}'/,
            greedy: true
        }
    });
    delete Prism.languages.go['class-name'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $197381b2d5f39c0b$export$2e2bcd8739ae039.displayName = 'ini';
$197381b2d5f39c0b$export$2e2bcd8739ae039.aliases = [];
function $197381b2d5f39c0b$export$2e2bcd8739ae039(Prism) {
    Prism.languages.ini = {
        /**
     * The component mimics the behavior of the Win32 API parser.
     *
     * @see {@link https://github.com/PrismJS/prism/issues/2775#issuecomment-787477723}
     */ comment: {
            pattern: /(^[ \f\t\v]*)[#;][^\n\r]*/m,
            lookbehind: true
        },
        section: {
            pattern: /(^[ \f\t\v]*)\[[^\n\r\]]*\]?/m,
            lookbehind: true,
            inside: {
                'section-name': {
                    pattern: /(^\[[ \f\t\v]*)[^ \f\t\v\]]+(?:[ \f\t\v]+[^ \f\t\v\]]+)*/,
                    lookbehind: true,
                    alias: 'selector'
                },
                punctuation: /\[|\]/
            }
        },
        key: {
            pattern: /(^[ \f\t\v]*)[^ \f\n\r\t\v=]+(?:[ \f\t\v]+[^ \f\n\r\t\v=]+)*(?=[ \f\t\v]*=)/m,
            lookbehind: true,
            alias: 'attr-name'
        },
        value: {
            pattern: /(=[ \f\t\v]*)[^ \f\n\r\t\v]+(?:[ \f\t\v]+[^ \f\n\r\t\v]+)*/,
            lookbehind: true,
            alias: 'attr-value',
            inside: {
                'inner-value': {
                    pattern: /^("|').+(?=\1$)/,
                    lookbehind: true
                }
            }
        },
        punctuation: /=/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$49817f5fa65142f2$export$2e2bcd8739ae039.displayName = 'java';
$49817f5fa65142f2$export$2e2bcd8739ae039.aliases = [];
function $49817f5fa65142f2$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    (function(Prism) {
        var keywords = /\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record(?!\s*[(){}[\]<>=%~.:,;?+\-*/&|^])|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/;
        // full package (optional) + parent classes (optional)
        var classNamePrefix = /(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source;
        // based on the java naming conventions
        var className = {
            pattern: RegExp(/(^|[^\w.])/.source + classNamePrefix + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
            lookbehind: true,
            inside: {
                namespace: {
                    pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
                    inside: {
                        punctuation: /\./
                    }
                },
                punctuation: /\./
            }
        };
        Prism.languages.java = Prism.languages.extend('clike', {
            string: {
                pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"/,
                lookbehind: true,
                greedy: true
            },
            'class-name': [
                className,
                {
                    // variables, parameters, and constructor references
                    // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
                    pattern: RegExp(/(^|[^\w.])/.source + classNamePrefix + /[A-Z]\w*(?=\s+\w+\s*[;,=()]|\s*(?:\[[\s,]*\]\s*)?::\s*new\b)/.source),
                    lookbehind: true,
                    inside: className.inside
                },
                {
                    // class names based on keyword
                    // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
                    pattern: RegExp(/(\b(?:class|enum|extends|implements|instanceof|interface|new|record|throws)\s+)/.source + classNamePrefix + /[A-Z]\w*\b/.source),
                    lookbehind: true,
                    inside: className.inside
                }
            ],
            keyword: keywords,
            function: [
                Prism.languages.clike.function,
                {
                    pattern: /(::\s*)[a-z_]\w*/,
                    lookbehind: true
                }
            ],
            number: /\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,
            operator: {
                pattern: /(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m,
                lookbehind: true
            },
            constant: /\b[A-Z][A-Z_\d]+\b/
        });
        Prism.languages.insertBefore('java', 'string', {
            'triple-quoted-string': {
                // http://openjdk.java.net/jeps/355#Description
                pattern: /"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/,
                greedy: true,
                alias: 'string'
            },
            char: {
                pattern: /'(?:\\.|[^'\\\r\n]){1,6}'/,
                greedy: true
            }
        });
        Prism.languages.insertBefore('java', 'class-name', {
            annotation: {
                pattern: /(^|[^.])@\w+(?:\s*\.\s*\w+)*/,
                lookbehind: true,
                alias: 'punctuation'
            },
            generics: {
                pattern: /<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/,
                inside: {
                    'class-name': className,
                    keyword: keywords,
                    punctuation: /[<>(),.:]/,
                    operator: /[?&|]/
                }
            },
            import: [
                {
                    pattern: RegExp(/(\bimport\s+)/.source + classNamePrefix + /(?:[A-Z]\w*|\*)(?=\s*;)/.source),
                    lookbehind: true,
                    inside: {
                        namespace: className.inside.namespace,
                        punctuation: /\./,
                        operator: /\*/,
                        'class-name': /\w+/
                    }
                },
                {
                    pattern: RegExp(/(\bimport\s+static\s+)/.source + classNamePrefix + /(?:\w+|\*)(?=\s*;)/.source),
                    lookbehind: true,
                    alias: 'static',
                    inside: {
                        namespace: className.inside.namespace,
                        static: /\b\w+$/,
                        punctuation: /\./,
                        operator: /\*/,
                        'class-name': /\w+/
                    }
                }
            ],
            namespace: {
                pattern: RegExp(/(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)(?!<keyword>)[a-z]\w*(?:\.[a-z]\w*)*\.?/.source.replace(/<keyword>/g, function() {
                    return keywords.source;
                })),
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            }
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $c029552e57eb42d4$export$2e2bcd8739ae039.displayName = 'regex';
$c029552e57eb42d4$export$2e2bcd8739ae039.aliases = [];
function $c029552e57eb42d4$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var specialEscape = {
            pattern: /\\[\\(){}[\]^$+*?|.]/,
            alias: 'escape'
        };
        var escape = /\\(?:x[\da-fA-F]{2}|u[\da-fA-F]{4}|u\{[\da-fA-F]+\}|0[0-7]{0,2}|[123][0-7]{2}|c[a-zA-Z]|.)/;
        var charSet = {
            pattern: /\.|\\[wsd]|\\p\{[^{}]+\}/i,
            alias: 'class-name'
        };
        var charSetWithoutDot = {
            pattern: /\\[wsd]|\\p\{[^{}]+\}/i,
            alias: 'class-name'
        };
        var rangeChar = '(?:[^\\\\-]|' + escape.source + ')';
        var range = RegExp(rangeChar + '-' + rangeChar);
        // the name of a capturing group
        var groupName = {
            pattern: /(<|')[^<>']+(?=[>']$)/,
            lookbehind: true,
            alias: 'variable'
        };
        Prism.languages.regex = {
            'char-class': {
                pattern: /((?:^|[^\\])(?:\\\\)*)\[(?:[^\\\]]|\\[\s\S])*\]/,
                lookbehind: true,
                inside: {
                    'char-class-negation': {
                        pattern: /(^\[)\^/,
                        lookbehind: true,
                        alias: 'operator'
                    },
                    'char-class-punctuation': {
                        pattern: /^\[|\]$/,
                        alias: 'punctuation'
                    },
                    range: {
                        pattern: range,
                        inside: {
                            escape: escape,
                            'range-punctuation': {
                                pattern: /-/,
                                alias: 'operator'
                            }
                        }
                    },
                    'special-escape': specialEscape,
                    'char-set': charSetWithoutDot,
                    escape: escape
                }
            },
            'special-escape': specialEscape,
            'char-set': charSet,
            backreference: [
                {
                    // a backreference which is not an octal escape
                    pattern: /\\(?![123][0-7]{2})[1-9]/,
                    alias: 'keyword'
                },
                {
                    pattern: /\\k<[^<>']+>/,
                    alias: 'keyword',
                    inside: {
                        'group-name': groupName
                    }
                }
            ],
            anchor: {
                pattern: /[$^]|\\[ABbGZz]/,
                alias: 'function'
            },
            escape: escape,
            group: [
                {
                    // https://docs.oracle.com/javase/10/docs/api/java/util/regex/Pattern.html
                    // https://docs.microsoft.com/en-us/dotnet/standard/base-types/regular-expression-language-quick-reference?view=netframework-4.7.2#grouping-constructs
                    // (), (?<name>), (?'name'), (?>), (?:), (?=), (?!), (?<=), (?<!), (?is-m), (?i-m:)
                    pattern: /\((?:\?(?:<[^<>']+>|'[^<>']+'|[>:]|<?[=!]|[idmnsuxU]+(?:-[idmnsuxU]+)?:?))?/,
                    alias: 'punctuation',
                    inside: {
                        'group-name': groupName
                    }
                },
                {
                    pattern: /\)/,
                    alias: 'punctuation'
                }
            ],
            quantifier: {
                pattern: /(?:[+*?]|\{\d+(?:,\d*)?\})[?+]?/,
                alias: 'number'
            },
            alternation: {
                pattern: /\|/,
                alias: 'keyword'
            }
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$7a8c3997a83eed46$export$2e2bcd8739ae039.displayName = 'javascript';
$7a8c3997a83eed46$export$2e2bcd8739ae039.aliases = [
    'js'
];
function $7a8c3997a83eed46$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.javascript = Prism.languages.extend('clike', {
        'class-name': [
            Prism.languages.clike['class-name'],
            {
                pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
                lookbehind: true
            }
        ],
        keyword: [
            {
                pattern: /((?:^|\})\s*)catch\b/,
                lookbehind: true
            },
            {
                pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
                lookbehind: true
            }
        ],
        // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
        function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
        number: {
            pattern: RegExp(/(^|[^\w$])/.source + '(?:' + // constant
            (/NaN|Infinity/.source + '|' + // binary integer
            /0[bB][01]+(?:_[01]+)*n?/.source + '|' + // octal integer
            /0[oO][0-7]+(?:_[0-7]+)*n?/.source + '|' + // hexadecimal integer
            /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + '|' + // decimal bigint
            /\d+(?:_\d+)*n/.source + '|' + // decimal number (integer or float) but no bigint
            /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ')' + /(?![\w$])/.source),
            lookbehind: true
        },
        operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
    });
    Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
    Prism.languages.insertBefore('javascript', 'keyword', {
        regex: {
            pattern: RegExp(// lookbehind
            // eslint-disable-next-line regexp/no-dupe-characters-character-class
            /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
            // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
            // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
            // with the only syntax, so we have to define 2 different regex patterns.
            /\//.source + '(?:' + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + '|' + // `v` flag syntax. This supports 3 levels of nested character classes.
            /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ')' + // lookahead
            /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                'regex-source': {
                    pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                    lookbehind: true,
                    alias: 'language-regex',
                    inside: Prism.languages.regex
                },
                'regex-delimiter': /^\/|\/$/,
                'regex-flags': /^[a-z]+$/
            }
        },
        // This must be declared before keyword because we use "function" inside the look-forward
        'function-variable': {
            pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
            alias: 'function'
        },
        parameter: [
            {
                pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            {
                pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            {
                pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            {
                pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
                lookbehind: true,
                inside: Prism.languages.javascript
            }
        ],
        constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
    });
    Prism.languages.insertBefore('javascript', 'string', {
        hashbang: {
            pattern: /^#!.*/,
            greedy: true,
            alias: 'comment'
        },
        'template-string': {
            pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
            greedy: true,
            inside: {
                'template-punctuation': {
                    pattern: /^`|`$/,
                    alias: 'string'
                },
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                    lookbehind: true,
                    inside: {
                        'interpolation-punctuation': {
                            pattern: /^\$\{|\}$/,
                            alias: 'punctuation'
                        },
                        rest: Prism.languages.javascript
                    }
                },
                string: /[\s\S]+/
            }
        },
        'string-property': {
            pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
            lookbehind: true,
            greedy: true,
            alias: 'property'
        }
    });
    Prism.languages.insertBefore('javascript', 'operator', {
        'literal-property': {
            pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
            lookbehind: true,
            alias: 'property'
        }
    });
    if (Prism.languages.markup) {
        Prism.languages.markup.tag.addInlined('script', 'javascript');
        // add attribute support for all DOM events.
        // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
        Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, 'javascript');
    }
    Prism.languages.js = Prism.languages.javascript;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $7ca1ade36c00114f$export$2e2bcd8739ae039.displayName = 'json';
$7ca1ade36c00114f$export$2e2bcd8739ae039.aliases = [
    'webmanifest'
];
function $7ca1ade36c00114f$export$2e2bcd8739ae039(Prism) {
    // https://www.json.org/json-en.html
    Prism.languages.json = {
        property: {
            pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
            lookbehind: true,
            greedy: true
        },
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
            greedy: true
        },
        number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
        punctuation: /[{}[\],]/,
        operator: /:/,
        boolean: /\b(?:false|true)\b/,
        null: {
            pattern: /\bnull\b/,
            alias: 'keyword'
        }
    };
    Prism.languages.webmanifest = Prism.languages.json;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$edb8a8bbc6c61935$export$2e2bcd8739ae039.displayName = 'kotlin';
$edb8a8bbc6c61935$export$2e2bcd8739ae039.aliases = [
    'kt',
    'kts'
];
function $edb8a8bbc6c61935$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.kotlin = Prism.languages.extend('clike', {
            keyword: {
                // The lookbehind prevents wrong highlighting of e.g. kotlin.properties.get
                pattern: /(^|[^.])\b(?:abstract|actual|annotation|as|break|by|catch|class|companion|const|constructor|continue|crossinline|data|do|dynamic|else|enum|expect|external|final|finally|for|fun|get|if|import|in|infix|init|inline|inner|interface|internal|is|lateinit|noinline|null|object|open|operator|out|override|package|private|protected|public|reified|return|sealed|set|super|suspend|tailrec|this|throw|to|try|typealias|val|var|vararg|when|where|while)\b/,
                lookbehind: true
            },
            function: [
                {
                    pattern: /(?:`[^\r\n`]+`|\b\w+)(?=\s*\()/,
                    greedy: true
                },
                {
                    pattern: /(\.)(?:`[^\r\n`]+`|\w+)(?=\s*\{)/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            number: /\b(?:0[xX][\da-fA-F]+(?:_[\da-fA-F]+)*|0[bB][01]+(?:_[01]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?[fFL]?)\b/,
            operator: /\+[+=]?|-[-=>]?|==?=?|!(?:!|==?)?|[\/*%<>]=?|[?:]:?|\.\.|&&|\|\||\b(?:and|inv|or|shl|shr|ushr|xor)\b/
        });
        delete Prism.languages.kotlin['class-name'];
        var interpolationInside = {
            'interpolation-punctuation': {
                pattern: /^\$\{?|\}$/,
                alias: 'punctuation'
            },
            expression: {
                pattern: /[\s\S]+/,
                inside: Prism.languages.kotlin
            }
        };
        Prism.languages.insertBefore('kotlin', 'string', {
            // https://kotlinlang.org/spec/expressions.html#string-interpolation-expressions
            'string-literal': [
                {
                    pattern: /"""(?:[^$]|\$(?:(?!\{)|\{[^{}]*\}))*?"""/,
                    alias: 'multiline',
                    inside: {
                        interpolation: {
                            pattern: /\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                            inside: interpolationInside
                        },
                        string: /[\s\S]+/
                    }
                },
                {
                    pattern: /"(?:[^"\\\r\n$]|\\.|\$(?:(?!\{)|\{[^{}]*\}))*"/,
                    alias: 'singleline',
                    inside: {
                        interpolation: {
                            pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                            lookbehind: true,
                            inside: interpolationInside
                        },
                        string: /[\s\S]+/
                    }
                }
            ],
            char: {
                // https://kotlinlang.org/spec/expressions.html#character-literals
                pattern: /'(?:[^'\\\r\n]|\\(?:.|u[a-fA-F0-9]{0,4}))'/,
                greedy: true
            }
        });
        delete Prism.languages.kotlin['string'];
        Prism.languages.insertBefore('kotlin', 'keyword', {
            annotation: {
                pattern: /\B@(?:\w+:)?(?:[A-Z]\w*|\[[^\]]+\])/,
                alias: 'builtin'
            }
        });
        Prism.languages.insertBefore('kotlin', 'function', {
            label: {
                pattern: /\b\w+@|@\w+\b/,
                alias: 'symbol'
            }
        });
        Prism.languages.kt = Prism.languages.kotlin;
        Prism.languages.kts = Prism.languages.kotlin;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$f3a5ce20fdab9e50$export$2e2bcd8739ae039.displayName = 'less';
$f3a5ce20fdab9e50$export$2e2bcd8739ae039.aliases = [];
function $f3a5ce20fdab9e50$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $8467c3aacdff56ee$export$2e2bcd8739ae039));
    /* FIXME :
:extend() is not handled specifically : its highlighting is buggy.
Mixin usage must be inside a ruleset to be highlighted.
At-rules (e.g. import) containing interpolations are buggy.
Detached rulesets are highlighted as at-rules.
A comment before a mixin usage prevents the latter to be properly highlighted.
*/ Prism.languages.less = Prism.languages.extend('css', {
        comment: [
            /\/\*[\s\S]*?\*\//,
            {
                pattern: /(^|[^\\])\/\/.*/,
                lookbehind: true
            }
        ],
        atrule: {
            pattern: /@[\w-](?:\((?:[^(){}]|\([^(){}]*\))*\)|[^(){};\s]|\s+(?!\s))*?(?=\s*\{)/,
            inside: {
                punctuation: /[:()]/
            }
        },
        // selectors and mixins are considered the same
        selector: {
            pattern: /(?:@\{[\w-]+\}|[^{};\s@])(?:@\{[\w-]+\}|\((?:[^(){}]|\([^(){}]*\))*\)|[^(){};@\s]|\s+(?!\s))*?(?=\s*\{)/,
            inside: {
                // mixin parameters
                variable: /@+[\w-]+/
            }
        },
        property: /(?:@\{[\w-]+\}|[\w-])+(?:\+_?)?(?=\s*:)/,
        operator: /[+\-*\/]/
    });
    Prism.languages.insertBefore('less', 'property', {
        variable: [
            // Variable declaration (the colon must be consumed!)
            {
                pattern: /@[\w-]+\s*:/,
                inside: {
                    punctuation: /:/
                }
            },
            // Variable usage
            /@@?[\w-]+/
        ],
        'mixin-usage': {
            pattern: /([{;]\s*)[.#](?!\d)[\w-].*?(?=[(;])/,
            lookbehind: true,
            alias: 'function'
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $20b8caf8b024dc15$export$2e2bcd8739ae039.displayName = 'lua';
$20b8caf8b024dc15$export$2e2bcd8739ae039.aliases = [];
function $20b8caf8b024dc15$export$2e2bcd8739ae039(Prism) {
    Prism.languages.lua = {
        comment: /^#!.+|--(?:\[(=*)\[[\s\S]*?\]\1\]|.*)/m,
        // \z may be used to skip the following space
        string: {
            pattern: /(["'])(?:(?!\1)[^\\\r\n]|\\z(?:\r\n|\s)|\\(?:\r\n|[^z]))*\1|\[(=*)\[[\s\S]*?\]\2\]/,
            greedy: true
        },
        number: /\b0x[a-f\d]+(?:\.[a-f\d]*)?(?:p[+-]?\d+)?\b|\b\d+(?:\.\B|(?:\.\d*)?(?:e[+-]?\d+)?\b)|\B\.\d+(?:e[+-]?\d+)?\b/i,
        keyword: /\b(?:and|break|do|else|elseif|end|false|for|function|goto|if|in|local|nil|not|or|repeat|return|then|true|until|while)\b/,
        function: /(?!\d)\w+(?=\s*(?:[({]))/,
        operator: [
            /[-+*%^&|#]|\/\/?|<[<=]?|>[>=]?|[=~]=?/,
            {
                // Match ".." but don't break "..."
                pattern: /(^|[^.])\.\.(?!\.)/,
                lookbehind: true
            }
        ],
        punctuation: /[\[\](){},;]|\.+|:+/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $23da19d9f15297a4$export$2e2bcd8739ae039.displayName = 'makefile';
$23da19d9f15297a4$export$2e2bcd8739ae039.aliases = [];
function $23da19d9f15297a4$export$2e2bcd8739ae039(Prism) {
    Prism.languages.makefile = {
        comment: {
            pattern: /(^|[^\\])#(?:\\(?:\r\n|[\s\S])|[^\\\r\n])*/,
            lookbehind: true
        },
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        'builtin-target': {
            pattern: /\.[A-Z][^:#=\s]+(?=\s*:(?!=))/,
            alias: 'builtin'
        },
        target: {
            pattern: /^(?:[^:=\s]|[ \t]+(?![\s:]))+(?=\s*:(?!=))/m,
            alias: 'symbol',
            inside: {
                variable: /\$+(?:(?!\$)[^(){}:#=\s]+|(?=[({]))/
            }
        },
        variable: /\$+(?:(?!\$)[^(){}:#=\s]+|\([@*%<^+?][DF]\)|(?=[({]))/,
        // Directives
        keyword: /-include\b|\b(?:define|else|endef|endif|export|ifn?def|ifn?eq|include|override|private|sinclude|undefine|unexport|vpath)\b/,
        function: {
            pattern: /(\()(?:abspath|addsuffix|and|basename|call|dir|error|eval|file|filter(?:-out)?|findstring|firstword|flavor|foreach|guile|if|info|join|lastword|load|notdir|or|origin|patsubst|realpath|shell|sort|strip|subst|suffix|value|warning|wildcard|word(?:list|s)?)(?=[ \t])/,
            lookbehind: true
        },
        operator: /(?:::|[?:+!])?=|[|@]/,
        punctuation: /[:;(){}]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $1da2260b608e55ec$export$2e2bcd8739ae039.displayName = 'yaml';
$1da2260b608e55ec$export$2e2bcd8739ae039.aliases = [
    'yml'
];
function $1da2260b608e55ec$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // https://yaml.org/spec/1.2/spec.html#c-ns-anchor-property
        // https://yaml.org/spec/1.2/spec.html#c-ns-alias-node
        var anchorOrAlias = /[*&][^\s[\]{},]+/;
        // https://yaml.org/spec/1.2/spec.html#c-ns-tag-property
        var tag = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/;
        // https://yaml.org/spec/1.2/spec.html#c-ns-properties(n,c)
        var properties = '(?:' + tag.source + '(?:[ \t]+' + anchorOrAlias.source + ')?|' + anchorOrAlias.source + '(?:[ \t]+' + tag.source + ')?)';
        // https://yaml.org/spec/1.2/spec.html#ns-plain(n,c)
        // This is a simplified version that doesn't support "#" and multiline keys
        // All these long scarry character classes are simplified versions of YAML's characters
        var plainKey = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.source.replace(/<PLAIN>/g, function() {
            return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
        });
        var string = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;
        /**
     *
     * @param {string} value
     * @param {string} [flags]
     * @returns {RegExp}
     */ function createValuePattern(value, flags) {
            flags = (flags || '').replace(/m/g, '') + 'm' // add m flag
            ;
            var pattern = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function() {
                return properties;
            }).replace(/<<value>>/g, function() {
                return value;
            });
            return RegExp(pattern, flags);
        }
        Prism.languages.yaml = {
            scalar: {
                pattern: RegExp(/([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(/<<prop>>/g, function() {
                    return properties;
                })),
                lookbehind: true,
                alias: 'string'
            },
            comment: /#.*/,
            key: {
                pattern: RegExp(/((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function() {
                    return properties;
                }).replace(/<<key>>/g, function() {
                    return '(?:' + plainKey + '|' + string + ')';
                })),
                lookbehind: true,
                greedy: true,
                alias: 'atrule'
            },
            directive: {
                pattern: /(^[ \t]*)%.+/m,
                lookbehind: true,
                alias: 'important'
            },
            datetime: {
                pattern: createValuePattern(/\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.source),
                lookbehind: true,
                alias: 'number'
            },
            boolean: {
                pattern: createValuePattern(/false|true/.source, 'i'),
                lookbehind: true,
                alias: 'important'
            },
            null: {
                pattern: createValuePattern(/null|~/.source, 'i'),
                lookbehind: true,
                alias: 'important'
            },
            string: {
                pattern: createValuePattern(string),
                lookbehind: true,
                greedy: true
            },
            number: {
                pattern: createValuePattern(/[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source, 'i'),
                lookbehind: true
            },
            tag: tag,
            important: anchorOrAlias,
            punctuation: /---|[:[\]{}\-,|>?]|\.\.\./
        };
        Prism.languages.yml = Prism.languages.yaml;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$ee5893254ac9a415$export$2e2bcd8739ae039.displayName = 'markdown';
$ee5893254ac9a415$export$2e2bcd8739ae039.aliases = [
    'md'
];
function $ee5893254ac9a415$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    (function(Prism) {
        // Allow only one line break
        var inner = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
        /**
     * This function is intended for the creation of the bold or italic pattern.
     *
     * This also adds a lookbehind group to the given pattern to ensure that the pattern is not backslash-escaped.
     *
     * _Note:_ Keep in mind that this adds a capturing group.
     *
     * @param {string} pattern
     * @returns {RegExp}
     */ function createInline(pattern) {
            pattern = pattern.replace(/<inner>/g, function() {
                return inner;
            });
            return RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + '(?:' + pattern + ')');
        }
        var tableCell = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source;
        var tableRow = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function() {
            return tableCell;
        });
        var tableLine = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;
        Prism.languages.markdown = Prism.languages.extend('markup', {});
        Prism.languages.insertBefore('markdown', 'prolog', {
            'front-matter-block': {
                pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
                lookbehind: true,
                greedy: true,
                inside: {
                    punctuation: /^---|---$/,
                    'front-matter': {
                        pattern: /\S+(?:\s+\S+)*/,
                        alias: [
                            'yaml',
                            'language-yaml'
                        ],
                        inside: Prism.languages.yaml
                    }
                }
            },
            blockquote: {
                // > ...
                pattern: /^>(?:[\t ]*>)*/m,
                alias: 'punctuation'
            },
            table: {
                pattern: RegExp('^' + tableRow + tableLine + '(?:' + tableRow + ')*', 'm'),
                inside: {
                    'table-data-rows': {
                        pattern: RegExp('^(' + tableRow + tableLine + ')(?:' + tableRow + ')*$'),
                        lookbehind: true,
                        inside: {
                            'table-data': {
                                pattern: RegExp(tableCell),
                                inside: Prism.languages.markdown
                            },
                            punctuation: /\|/
                        }
                    },
                    'table-line': {
                        pattern: RegExp('^(' + tableRow + ')' + tableLine + '$'),
                        lookbehind: true,
                        inside: {
                            punctuation: /\||:?-{3,}:?/
                        }
                    },
                    'table-header-row': {
                        pattern: RegExp('^' + tableRow + '$'),
                        inside: {
                            'table-header': {
                                pattern: RegExp(tableCell),
                                alias: 'important',
                                inside: Prism.languages.markdown
                            },
                            punctuation: /\|/
                        }
                    }
                }
            },
            code: [
                {
                    // Prefixed by 4 spaces or 1 tab and preceded by an empty line
                    pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
                    lookbehind: true,
                    alias: 'keyword'
                },
                {
                    // ```optional language
                    // code block
                    // ```
                    pattern: /^```[\s\S]*?^```$/m,
                    greedy: true,
                    inside: {
                        'code-block': {
                            pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
                            lookbehind: true
                        },
                        'code-language': {
                            pattern: /^(```).+/,
                            lookbehind: true
                        },
                        punctuation: /```/
                    }
                }
            ],
            title: [
                {
                    // title 1
                    // =======
                    // title 2
                    // -------
                    pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
                    alias: 'important',
                    inside: {
                        punctuation: /==+$|--+$/
                    }
                },
                {
                    // # title 1
                    // ###### title 6
                    pattern: /(^\s*)#.+/m,
                    lookbehind: true,
                    alias: 'important',
                    inside: {
                        punctuation: /^#+|#+$/
                    }
                }
            ],
            hr: {
                // ***
                // ---
                // * * *
                // -----------
                pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
                lookbehind: true,
                alias: 'punctuation'
            },
            list: {
                // * item
                // + item
                // - item
                // 1. item
                pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
                lookbehind: true,
                alias: 'punctuation'
            },
            'url-reference': {
                // [id]: http://example.com "Optional title"
                // [id]: http://example.com 'Optional title'
                // [id]: http://example.com (Optional title)
                // [id]: <http://example.com> "Optional title"
                pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
                inside: {
                    variable: {
                        pattern: /^(!?\[)[^\]]+/,
                        lookbehind: true
                    },
                    string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
                    punctuation: /^[\[\]!:]|[<>]/
                },
                alias: 'url'
            },
            bold: {
                // **strong**
                // __strong__
                // allow one nested instance of italic text using the same delimiter
                pattern: createInline(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    content: {
                        pattern: /(^..)[\s\S]+(?=..$)/,
                        lookbehind: true,
                        inside: {} // see below
                    },
                    punctuation: /\*\*|__/
                }
            },
            italic: {
                // *em*
                // _em_
                // allow one nested instance of bold text using the same delimiter
                pattern: createInline(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    content: {
                        pattern: /(^.)[\s\S]+(?=.$)/,
                        lookbehind: true,
                        inside: {} // see below
                    },
                    punctuation: /[*_]/
                }
            },
            strike: {
                // ~~strike through~~
                // ~strike~
                // eslint-disable-next-line regexp/strict
                pattern: createInline(/(~~?)(?:(?!~)<inner>)+\2/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    content: {
                        pattern: /(^~~?)[\s\S]+(?=\1$)/,
                        lookbehind: true,
                        inside: {} // see below
                    },
                    punctuation: /~~?/
                }
            },
            'code-snippet': {
                // `code`
                // ``code``
                pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
                lookbehind: true,
                greedy: true,
                alias: [
                    'code',
                    'keyword'
                ]
            },
            url: {
                // [example](http://example.com "Optional title")
                // [example][id]
                // [example] [id]
                pattern: createInline(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    operator: /^!/,
                    content: {
                        pattern: /(^\[)[^\]]+(?=\])/,
                        lookbehind: true,
                        inside: {} // see below
                    },
                    variable: {
                        pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
                        lookbehind: true
                    },
                    url: {
                        pattern: /(^\]\()[^\s)]+/,
                        lookbehind: true
                    },
                    string: {
                        pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
                        lookbehind: true
                    }
                }
            }
        });
        [
            'url',
            'bold',
            'italic',
            'strike'
        ].forEach(function(token) {
            [
                'url',
                'bold',
                'italic',
                'strike',
                'code-snippet'
            ].forEach(function(inside) {
                if (token !== inside) Prism.languages.markdown[token].inside.content.inside[inside] = Prism.languages.markdown[inside];
            });
        });
        Prism.hooks.add('after-tokenize', function(env) {
            if (env.language !== 'markdown' && env.language !== 'md') return;
            function walkTokens(tokens) {
                if (!tokens || typeof tokens === 'string') return;
                for(var i = 0, l = tokens.length; i < l; i++){
                    var token = tokens[i];
                    if (token.type !== 'code') {
                        walkTokens(token.content);
                        continue;
                    }
                    /*
           * Add the correct `language-xxxx` class to this code block. Keep in mind that the `code-language` token
           * is optional. But the grammar is defined so that there is only one case we have to handle:
           *
           * token.content = [
           *     <span class="punctuation">```</span>,
           *     <span class="code-language">xxxx</span>,
           *     '\n', // exactly one new lines (\r or \n or \r\n)
           *     <span class="code-block">...</span>,
           *     '\n', // exactly one new lines again
           *     <span class="punctuation">```</span>
           * ];
           */ var codeLang = token.content[1];
                    var codeBlock = token.content[3];
                    if (codeLang && codeBlock && codeLang.type === 'code-language' && codeBlock.type === 'code-block' && typeof codeLang.content === 'string') {
                        // this might be a language that Prism does not support
                        // do some replacements to support C++, C#, and F#
                        var lang = codeLang.content.replace(/\b#/g, 'sharp').replace(/\b\+\+/g, 'pp');
                        // only use the first word
                        lang = (/[a-z][\w-]*/i.exec(lang) || [
                            ''
                        ])[0].toLowerCase();
                        var alias = 'language-' + lang;
                        // add alias
                        if (!codeBlock.alias) codeBlock.alias = [
                            alias
                        ];
                        else if (typeof codeBlock.alias === 'string') codeBlock.alias = [
                            codeBlock.alias,
                            alias
                        ];
                        else codeBlock.alias.push(alias);
                    }
                }
            }
            walkTokens(env.tokens);
        });
        Prism.hooks.add('wrap', function(env) {
            if (env.type !== 'code-block') return;
            var codeLang = '';
            for(var i = 0, l = env.classes.length; i < l; i++){
                var cls = env.classes[i];
                var match = /language-(.+)/.exec(cls);
                if (match) {
                    codeLang = match[1];
                    break;
                }
            }
            var grammar = Prism.languages[codeLang];
            if (!grammar) {
                if (codeLang && codeLang !== 'none' && Prism.plugins.autoloader) {
                    var id = 'md-' + new Date().valueOf() + '-' + Math.floor(Math.random() * 1e16);
                    env.attributes['id'] = id;
                    Prism.plugins.autoloader.loadLanguages(codeLang, function() {
                        var ele = document.getElementById(id);
                        if (ele) ele.innerHTML = Prism.highlight(ele.textContent, Prism.languages[codeLang], codeLang);
                    });
                }
            } else env.content = Prism.highlight(env.content.value, grammar, codeLang);
        });
        var tagPattern = RegExp(Prism.languages.markup.tag.pattern.source, 'gi');
        /**
     * A list of known entity names.
     *
     * This will always be incomplete to save space. The current list is the one used by lowdash's unescape function.
     *
     * @see {@link https://github.com/lodash/lodash/blob/2da024c3b4f9947a48517639de7560457cd4ec6c/unescape.js#L2}
     */ var KNOWN_ENTITY_NAMES = {
            amp: '&',
            lt: '<',
            gt: '>',
            quot: '"'
        };
        // IE 11 doesn't support `String.fromCodePoint`
        var fromCodePoint = String.fromCodePoint || String.fromCharCode;
        /**
     * Returns the text content of a given HTML source code string.
     *
     * @param {string} html
     * @returns {string}
     */ function textContent(html) {
            // remove all tags
            var text = html.replace(tagPattern, '');
            // decode known entities
            text = text.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(m, code) {
                code = code.toLowerCase();
                if (code[0] === '#') {
                    var value;
                    if (code[1] === 'x') value = parseInt(code.slice(2), 16);
                    else value = Number(code.slice(1));
                    return fromCodePoint(value);
                } else {
                    var known = KNOWN_ENTITY_NAMES[code];
                    if (known) return known;
                    // unable to decode
                    return m;
                }
            });
            return text;
        }
        Prism.languages.md = Prism.languages.markdown;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$846ab470db2ff869$export$2e2bcd8739ae039.displayName = 'objectivec';
$846ab470db2ff869$export$2e2bcd8739ae039.aliases = [
    'objc'
];
function $846ab470db2ff869$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f4e156ae6ed8d0a0$export$2e2bcd8739ae039));
    Prism.languages.objectivec = Prism.languages.extend('c', {
        string: {
            pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
            greedy: true
        },
        keyword: /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
        operator: /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
    });
    delete Prism.languages.objectivec['class-name'];
    Prism.languages.objc = Prism.languages.objectivec;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $380e029e8a782237$export$2e2bcd8739ae039.displayName = 'perl';
$380e029e8a782237$export$2e2bcd8739ae039.aliases = [];
function $380e029e8a782237$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var brackets = /(?:\((?:[^()\\]|\\[\s\S])*\)|\{(?:[^{}\\]|\\[\s\S])*\}|\[(?:[^[\]\\]|\\[\s\S])*\]|<(?:[^<>\\]|\\[\s\S])*>)/.source;
        Prism.languages.perl = {
            comment: [
                {
                    // POD
                    pattern: /(^\s*)=\w[\s\S]*?=cut.*/m,
                    lookbehind: true,
                    greedy: true
                },
                {
                    pattern: /(^|[^\\$])#.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            // TODO Could be nice to handle Heredoc too.
            string: [
                {
                    pattern: RegExp(/\b(?:q|qq|qw|qx)(?![a-zA-Z0-9])\s*/.source + '(?:' + [
                        // q/.../
                        /([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
                        // q a...a
                        // eslint-disable-next-line regexp/strict
                        /([a-zA-Z0-9])(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                        // q(...)
                        // q{...}
                        // q[...]
                        // q<...>
                        brackets
                    ].join('|') + ')'),
                    greedy: true
                },
                // "...", `...`
                {
                    pattern: /("|`)(?:(?!\1)[^\\]|\\[\s\S])*\1/,
                    greedy: true
                },
                // '...'
                // FIXME Multi-line single-quoted strings are not supported as they would break variables containing '
                {
                    pattern: /'(?:[^'\\\r\n]|\\.)*'/,
                    greedy: true
                }
            ],
            regex: [
                {
                    pattern: RegExp(/\b(?:m|qr)(?![a-zA-Z0-9])\s*/.source + '(?:' + [
                        // m/.../
                        /([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
                        // m a...a
                        // eslint-disable-next-line regexp/strict
                        /([a-zA-Z0-9])(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                        // m(...)
                        // m{...}
                        // m[...]
                        // m<...>
                        brackets
                    ].join('|') + ')' + /[msixpodualngc]*/.source),
                    greedy: true
                },
                // The lookbehinds prevent -s from breaking
                {
                    pattern: RegExp(/(^|[^-])\b(?:s|tr|y)(?![a-zA-Z0-9])\s*/.source + '(?:' + [
                        // s/.../.../
                        // eslint-disable-next-line regexp/strict
                        /([^a-zA-Z0-9\s{(\[<])(?:(?!\2)[^\\]|\\[\s\S])*\2(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                        // s a...a...a
                        // eslint-disable-next-line regexp/strict
                        /([a-zA-Z0-9])(?:(?!\3)[^\\]|\\[\s\S])*\3(?:(?!\3)[^\\]|\\[\s\S])*\3/.source,
                        // s(...)(...)
                        // s{...}{...}
                        // s[...][...]
                        // s<...><...>
                        // s(...)[...]
                        brackets + /\s*/.source + brackets
                    ].join('|') + ')' + /[msixpodualngcer]*/.source),
                    lookbehind: true,
                    greedy: true
                },
                // /.../
                // The look-ahead tries to prevent two divisions on
                // the same line from being highlighted as regex.
                // This does not support multi-line regex.
                {
                    pattern: /\/(?:[^\/\\\r\n]|\\.)*\/[msixpodualngc]*(?=\s*(?:$|[\r\n,.;})&|\-+*~<>!?^]|(?:and|cmp|eq|ge|gt|le|lt|ne|not|or|x|xor)\b))/,
                    greedy: true
                }
            ],
            // FIXME Not sure about the handling of ::, ', and #
            variable: [
                // ${^POSTMATCH}
                /[&*$@%]\{\^[A-Z]+\}/,
                // $^V
                /[&*$@%]\^[A-Z_]/,
                // ${...}
                /[&*$@%]#?(?=\{)/,
                // $foo
                /[&*$@%]#?(?:(?:::)*'?(?!\d)[\w$]+(?![\w$]))+(?:::)*/,
                // $1
                /[&*$@%]\d+/,
                // $_, @_, %!
                // The negative lookahead prevents from breaking the %= operator
                /(?!%=)[$@%][!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~]/
            ],
            filehandle: {
                // <>, <FOO>, _
                pattern: /<(?![<=])\S*?>|\b_\b/,
                alias: 'symbol'
            },
            'v-string': {
                // v1.2, 1.2.3
                pattern: /v\d+(?:\.\d+)*|\d+(?:\.\d+){2,}/,
                alias: 'string'
            },
            function: {
                pattern: /(\bsub[ \t]+)\w+/,
                lookbehind: true
            },
            keyword: /\b(?:any|break|continue|default|delete|die|do|else|elsif|eval|for|foreach|given|goto|if|last|local|my|next|our|package|print|redo|require|return|say|state|sub|switch|undef|unless|until|use|when|while)\b/,
            number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)\b/,
            operator: /-[rwxoRWXOezsfdlpSbctugkTBMAC]\b|\+[+=]?|-[-=>]?|\*\*?=?|\/\/?=?|=[=~>]?|~[~=]?|\|\|?=?|&&?=?|<(?:=>?|<=?)?|>>?=?|![~=]?|[%^]=?|\.(?:=|\.\.?)?|[\\?]|\bx(?:=|\b)|\b(?:and|cmp|eq|ge|gt|le|lt|ne|not|or|xor)\b/,
            punctuation: /[{}[\];(),:]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$11b4f9d2b497fd4f$export$2e2bcd8739ae039.displayName = 'markup-templating';
$11b4f9d2b497fd4f$export$2e2bcd8739ae039.aliases = [];
function $11b4f9d2b497fd4f$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    (function(Prism) {
        /**
     * Returns the placeholder for the given language id and index.
     *
     * @param {string} language
     * @param {string|number} index
     * @returns {string}
     */ function getPlaceholder(language, index) {
            return '___' + language.toUpperCase() + index + '___';
        }
        Object.defineProperties(Prism.languages['markup-templating'] = {}, {
            buildPlaceholders: {
                /**
         * Tokenize all inline templating expressions matching `placeholderPattern`.
         *
         * If `replaceFilter` is provided, only matches of `placeholderPattern` for which `replaceFilter` returns
         * `true` will be replaced.
         *
         * @param {object} env The environment of the `before-tokenize` hook.
         * @param {string} language The language id.
         * @param {RegExp} placeholderPattern The matches of this pattern will be replaced by placeholders.
         * @param {(match: string) => boolean} [replaceFilter]
         */ value: function(env, language, placeholderPattern, replaceFilter) {
                    if (env.language !== language) return;
                    var tokenStack = env.tokenStack = [];
                    env.code = env.code.replace(placeholderPattern, function(match) {
                        if (typeof replaceFilter === 'function' && !replaceFilter(match)) return match;
                        var i = tokenStack.length;
                        var placeholder;
                        // Check for existing strings
                        while(env.code.indexOf(placeholder = getPlaceholder(language, i)) !== -1)++i;
                        // Create a sparse array
                        tokenStack[i] = match;
                        return placeholder;
                    });
                    // Switch the grammar to markup
                    env.grammar = Prism.languages.markup;
                }
            },
            tokenizePlaceholders: {
                /**
         * Replace placeholders with proper tokens after tokenizing.
         *
         * @param {object} env The environment of the `after-tokenize` hook.
         * @param {string} language The language id.
         */ value: function(env, language) {
                    if (env.language !== language || !env.tokenStack) return;
                    // Switch the grammar back
                    env.grammar = Prism.languages[language];
                    var j = 0;
                    var keys = Object.keys(env.tokenStack);
                    function walkTokens(tokens) {
                        for(var i = 0; i < tokens.length; i++){
                            // all placeholders are replaced already
                            if (j >= keys.length) break;
                            var token = tokens[i];
                            if (typeof token === 'string' || token.content && typeof token.content === 'string') {
                                var k = keys[j];
                                var t = env.tokenStack[k];
                                var s = typeof token === 'string' ? token : token.content;
                                var placeholder = getPlaceholder(language, k);
                                var index = s.indexOf(placeholder);
                                if (index > -1) {
                                    ++j;
                                    var before = s.substring(0, index);
                                    var middle = new Prism.Token(language, Prism.tokenize(t, env.grammar), 'language-' + language, t);
                                    var after = s.substring(index + placeholder.length);
                                    var replacement = [];
                                    if (before) replacement.push.apply(replacement, walkTokens([
                                        before
                                    ]));
                                    replacement.push(middle);
                                    if (after) replacement.push.apply(replacement, walkTokens([
                                        after
                                    ]));
                                    if (typeof token === 'string') tokens.splice.apply(tokens, [
                                        i,
                                        1
                                    ].concat(replacement));
                                    else token.content = replacement;
                                }
                            } else if (token.content /* && typeof token.content !== 'string' */ ) walkTokens(token.content);
                        }
                        return tokens;
                    }
                    walkTokens(env.tokens);
                }
            }
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$8a2c8b738cd1f636$export$2e2bcd8739ae039.displayName = 'php';
$8a2c8b738cd1f636$export$2e2bcd8739ae039.aliases = [];
function $8a2c8b738cd1f636$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
    (function(Prism) {
        var comment = /\/\*[\s\S]*?\*\/|\/\/.*|#(?!\[).*/;
        var constant = [
            {
                pattern: /\b(?:false|true)\b/i,
                alias: 'boolean'
            },
            {
                pattern: /(::\s*)\b[a-z_]\w*\b(?!\s*\()/i,
                greedy: true,
                lookbehind: true
            },
            {
                pattern: /(\b(?:case|const)\s+)\b[a-z_]\w*(?=\s*[;=])/i,
                greedy: true,
                lookbehind: true
            },
            /\b(?:null)\b/i,
            /\b[A-Z_][A-Z0-9_]*\b(?!\s*\()/
        ];
        var number = /\b0b[01]+(?:_[01]+)*\b|\b0o[0-7]+(?:_[0-7]+)*\b|\b0x[\da-f]+(?:_[\da-f]+)*\b|(?:\b\d+(?:_\d+)*\.?(?:\d+(?:_\d+)*)?|\B\.\d+)(?:e[+-]?\d+)?/i;
        var operator = /<?=>|\?\?=?|\.{3}|\??->|[!=]=?=?|::|\*\*=?|--|\+\+|&&|\|\||<<|>>|[?~]|[/^|%*&<>.+-]=?/;
        var punctuation = /[{}\[\](),:;]/;
        Prism.languages.php = {
            delimiter: {
                pattern: /\?>$|^<\?(?:php(?=\s)|=)?/i,
                alias: 'important'
            },
            comment: comment,
            variable: /\$+(?:\w+\b|(?=\{))/,
            package: {
                pattern: /(namespace\s+|use\s+(?:function\s+)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
                lookbehind: true,
                inside: {
                    punctuation: /\\/
                }
            },
            'class-name-definition': {
                pattern: /(\b(?:class|enum|interface|trait)\s+)\b[a-z_]\w*(?!\\)\b/i,
                lookbehind: true,
                alias: 'class-name'
            },
            'function-definition': {
                pattern: /(\bfunction\s+)[a-z_]\w*(?=\s*\()/i,
                lookbehind: true,
                alias: 'function'
            },
            keyword: [
                {
                    pattern: /(\(\s*)\b(?:array|bool|boolean|float|int|integer|object|string)\b(?=\s*\))/i,
                    alias: 'type-casting',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /([(,?]\s*)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|object|self|static|string)\b(?=\s*\$)/i,
                    alias: 'type-hint',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /(\)\s*:\s*(?:\?\s*)?)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|never|object|self|static|string|void)\b/i,
                    alias: 'return-type',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /\b(?:array(?!\s*\()|bool|float|int|iterable|mixed|object|string|void)\b/i,
                    alias: 'type-declaration',
                    greedy: true
                },
                {
                    pattern: /(\|\s*)(?:false|null)\b|\b(?:false|null)(?=\s*\|)/i,
                    alias: 'type-declaration',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /\b(?:parent|self|static)(?=\s*::)/i,
                    alias: 'static-context',
                    greedy: true
                },
                {
                    // yield from
                    pattern: /(\byield\s+)from\b/i,
                    lookbehind: true
                },
                // `class` is always a keyword unlike other keywords
                /\bclass\b/i,
                {
                    // https://www.php.net/manual/en/reserved.keywords.php
                    //
                    // keywords cannot be preceded by "->"
                    // the complex lookbehind means `(?<!(?:->|::)\s*)`
                    pattern: /((?:^|[^\s>:]|(?:^|[^-])>|(?:^|[^:]):)\s*)\b(?:abstract|and|array|as|break|callable|case|catch|clone|const|continue|declare|default|die|do|echo|else|elseif|empty|enddeclare|endfor|endforeach|endif|endswitch|endwhile|enum|eval|exit|extends|final|finally|fn|for|foreach|function|global|goto|if|implements|include|include_once|instanceof|insteadof|interface|isset|list|match|namespace|never|new|or|parent|print|private|protected|public|readonly|require|require_once|return|self|static|switch|throw|trait|try|unset|use|var|while|xor|yield|__halt_compiler)\b/i,
                    lookbehind: true
                }
            ],
            'argument-name': {
                pattern: /([(,]\s*)\b[a-z_]\w*(?=\s*:(?!:))/i,
                lookbehind: true
            },
            'class-name': [
                {
                    pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self|\s+static))\s+|\bcatch\s*\()\b[a-z_]\w*(?!\\)\b/i,
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /(\|\s*)\b[a-z_]\w*(?!\\)\b/i,
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /\b[a-z_]\w*(?!\\)\b(?=\s*\|)/i,
                    greedy: true
                },
                {
                    pattern: /(\|\s*)(?:\\?\b[a-z_]\w*)+\b/i,
                    alias: 'class-name-fully-qualified',
                    greedy: true,
                    lookbehind: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /(?:\\?\b[a-z_]\w*)+\b(?=\s*\|)/i,
                    alias: 'class-name-fully-qualified',
                    greedy: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self\b|\s+static\b))\s+|\bcatch\s*\()(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
                    alias: 'class-name-fully-qualified',
                    greedy: true,
                    lookbehind: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /\b[a-z_]\w*(?=\s*\$)/i,
                    alias: 'type-declaration',
                    greedy: true
                },
                {
                    pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,
                    alias: [
                        'class-name-fully-qualified',
                        'type-declaration'
                    ],
                    greedy: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /\b[a-z_]\w*(?=\s*::)/i,
                    alias: 'static-context',
                    greedy: true
                },
                {
                    pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*::)/i,
                    alias: [
                        'class-name-fully-qualified',
                        'static-context'
                    ],
                    greedy: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /([(,?]\s*)[a-z_]\w*(?=\s*\$)/i,
                    alias: 'type-hint',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /([(,?]\s*)(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,
                    alias: [
                        'class-name-fully-qualified',
                        'type-hint'
                    ],
                    greedy: true,
                    lookbehind: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /(\)\s*:\s*(?:\?\s*)?)\b[a-z_]\w*(?!\\)\b/i,
                    alias: 'return-type',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /(\)\s*:\s*(?:\?\s*)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
                    alias: [
                        'class-name-fully-qualified',
                        'return-type'
                    ],
                    greedy: true,
                    lookbehind: true,
                    inside: {
                        punctuation: /\\/
                    }
                }
            ],
            constant: constant,
            function: {
                pattern: /(^|[^\\\w])\\?[a-z_](?:[\w\\]*\w)?(?=\s*\()/i,
                lookbehind: true,
                inside: {
                    punctuation: /\\/
                }
            },
            property: {
                pattern: /(->\s*)\w+/,
                lookbehind: true
            },
            number: number,
            operator: operator,
            punctuation: punctuation
        };
        var string_interpolation = {
            pattern: /\{\$(?:\{(?:\{[^{}]+\}|[^{}]+)\}|[^{}])+\}|(^|[^\\{])\$+(?:\w+(?:\[[^\r\n\[\]]+\]|->\w+)?)/,
            lookbehind: true,
            inside: Prism.languages.php
        };
        var string = [
            {
                pattern: /<<<'([^']+)'[\r\n](?:.*[\r\n])*?\1;/,
                alias: 'nowdoc-string',
                greedy: true,
                inside: {
                    delimiter: {
                        pattern: /^<<<'[^']+'|[a-z_]\w*;$/i,
                        alias: 'symbol',
                        inside: {
                            punctuation: /^<<<'?|[';]$/
                        }
                    }
                }
            },
            {
                pattern: /<<<(?:"([^"]+)"[\r\n](?:.*[\r\n])*?\1;|([a-z_]\w*)[\r\n](?:.*[\r\n])*?\2;)/i,
                alias: 'heredoc-string',
                greedy: true,
                inside: {
                    delimiter: {
                        pattern: /^<<<(?:"[^"]+"|[a-z_]\w*)|[a-z_]\w*;$/i,
                        alias: 'symbol',
                        inside: {
                            punctuation: /^<<<"?|[";]$/
                        }
                    },
                    interpolation: string_interpolation
                }
            },
            {
                pattern: /`(?:\\[\s\S]|[^\\`])*`/,
                alias: 'backtick-quoted-string',
                greedy: true
            },
            {
                pattern: /'(?:\\[\s\S]|[^\\'])*'/,
                alias: 'single-quoted-string',
                greedy: true
            },
            {
                pattern: /"(?:\\[\s\S]|[^\\"])*"/,
                alias: 'double-quoted-string',
                greedy: true,
                inside: {
                    interpolation: string_interpolation
                }
            }
        ];
        Prism.languages.insertBefore('php', 'variable', {
            string: string,
            attribute: {
                pattern: /#\[(?:[^"'\/#]|\/(?![*/])|\/\/.*$|#(?!\[).*$|\/\*(?:[^*]|\*(?!\/))*\*\/|"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*')+\](?=\s*[a-z$#])/im,
                greedy: true,
                inside: {
                    'attribute-content': {
                        pattern: /^(#\[)[\s\S]+(?=\]$)/,
                        lookbehind: true,
                        // inside can appear subset of php
                        inside: {
                            comment: comment,
                            string: string,
                            'attribute-class-name': [
                                {
                                    pattern: /([^:]|^)\b[a-z_]\w*(?!\\)\b/i,
                                    alias: 'class-name',
                                    greedy: true,
                                    lookbehind: true
                                },
                                {
                                    pattern: /([^:]|^)(?:\\?\b[a-z_]\w*)+/i,
                                    alias: [
                                        'class-name',
                                        'class-name-fully-qualified'
                                    ],
                                    greedy: true,
                                    lookbehind: true,
                                    inside: {
                                        punctuation: /\\/
                                    }
                                }
                            ],
                            constant: constant,
                            number: number,
                            operator: operator,
                            punctuation: punctuation
                        }
                    },
                    delimiter: {
                        pattern: /^#\[|\]$/,
                        alias: 'punctuation'
                    }
                }
            }
        });
        Prism.hooks.add('before-tokenize', function(env) {
            if (!/<\?/.test(env.code)) return;
            var phpPattern = /<\?(?:[^"'/#]|\/(?![*/])|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|(?:\/\/|#(?!\[))(?:[^?\n\r]|\?(?!>))*(?=$|\?>|[\r\n])|#\[|\/\*(?:[^*]|\*(?!\/))*(?:\*\/|$))*?(?:\?>|$)/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'php', phpPattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'php');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $4c79b618a588b28d$export$2e2bcd8739ae039.displayName = 'python';
$4c79b618a588b28d$export$2e2bcd8739ae039.aliases = [
    'py'
];
function $4c79b618a588b28d$export$2e2bcd8739ae039(Prism) {
    Prism.languages.python = {
        comment: {
            pattern: /(^|[^\\])#.*/,
            lookbehind: true,
            greedy: true
        },
        'string-interpolation': {
            pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
            greedy: true,
            inside: {
                interpolation: {
                    // "{" <expression> <optional "!s", "!r", or "!a"> <optional ":" format specifier> "}"
                    pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
                    lookbehind: true,
                    inside: {
                        'format-spec': {
                            pattern: /(:)[^:(){}]+(?=\}$)/,
                            lookbehind: true
                        },
                        'conversion-option': {
                            pattern: /![sra](?=[:}]$)/,
                            alias: 'punctuation'
                        },
                        rest: null
                    }
                },
                string: /[\s\S]+/
            }
        },
        'triple-quoted-string': {
            pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
            greedy: true,
            alias: 'string'
        },
        string: {
            pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
            greedy: true
        },
        function: {
            pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
            lookbehind: true
        },
        'class-name': {
            pattern: /(\bclass\s+)\w+/i,
            lookbehind: true
        },
        decorator: {
            pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
            lookbehind: true,
            alias: [
                'annotation',
                'punctuation'
            ],
            inside: {
                punctuation: /\./
            }
        },
        keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
        builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
        boolean: /\b(?:False|None|True)\b/,
        number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
        operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
        punctuation: /[{}[\];(),.:]/
    };
    Prism.languages.python['string-interpolation'].inside['interpolation'].inside.rest = Prism.languages.python;
    Prism.languages.py = Prism.languages.python;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $781e96ef45d1066d$export$2e2bcd8739ae039.displayName = 'r';
$781e96ef45d1066d$export$2e2bcd8739ae039.aliases = [];
function $781e96ef45d1066d$export$2e2bcd8739ae039(Prism) {
    Prism.languages.r = {
        comment: /#.*/,
        string: {
            pattern: /(['"])(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        'percent-operator': {
            // Includes user-defined operators
            // and %%, %*%, %/%, %in%, %o%, %x%
            pattern: /%[^%\s]*%/,
            alias: 'operator'
        },
        boolean: /\b(?:FALSE|TRUE)\b/,
        ellipsis: /\.\.(?:\.|\d+)/,
        number: [
            /\b(?:Inf|NaN)\b/,
            /(?:\b0x[\dA-Fa-f]+(?:\.\d*)?|\b\d+(?:\.\d*)?|\B\.\d+)(?:[EePp][+-]?\d+)?[iL]?/
        ],
        keyword: /\b(?:NA|NA_character_|NA_complex_|NA_integer_|NA_real_|NULL|break|else|for|function|if|in|next|repeat|while)\b/,
        operator: /->?>?|<(?:=|<?-)?|[>=!]=?|::?|&&?|\|\|?|[+*\/^$@~]/,
        punctuation: /[(){}\[\],;]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$0814f5761e025965$export$2e2bcd8739ae039.displayName = 'ruby';
$0814f5761e025965$export$2e2bcd8739ae039.aliases = [
    'rb'
];
function $0814f5761e025965$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.ruby = Prism.languages.extend('clike', {
            comment: {
                pattern: /#.*|^=begin\s[\s\S]*?^=end/m,
                greedy: true
            },
            'class-name': {
                pattern: /(\b(?:class|module)\s+|\bcatch\s+\()[\w.\\]+|\b[A-Z_]\w*(?=\s*\.\s*new\b)/,
                lookbehind: true,
                inside: {
                    punctuation: /[.\\]/
                }
            },
            keyword: /\b(?:BEGIN|END|alias|and|begin|break|case|class|def|define_method|defined|do|each|else|elsif|end|ensure|extend|for|if|in|include|module|new|next|nil|not|or|prepend|private|protected|public|raise|redo|require|rescue|retry|return|self|super|then|throw|undef|unless|until|when|while|yield)\b/,
            operator: /\.{2,3}|&\.|===|<?=>|[!=]?~|(?:&&|\|\||<<|>>|\*\*|[+\-*/%<>!^&|=])=?|[?:]/,
            punctuation: /[(){}[\].,;]/
        });
        Prism.languages.insertBefore('ruby', 'operator', {
            'double-colon': {
                pattern: /::/,
                alias: 'punctuation'
            }
        });
        var interpolation = {
            pattern: /((?:^|[^\\])(?:\\{2})*)#\{(?:[^{}]|\{[^{}]*\})*\}/,
            lookbehind: true,
            inside: {
                content: {
                    pattern: /^(#\{)[\s\S]+(?=\}$)/,
                    lookbehind: true,
                    inside: Prism.languages.ruby
                },
                delimiter: {
                    pattern: /^#\{|\}$/,
                    alias: 'punctuation'
                }
            }
        };
        delete Prism.languages.ruby.function;
        var percentExpression = '(?:' + [
            /([^a-zA-Z0-9\s{(\[<=])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
            /\((?:[^()\\]|\\[\s\S]|\((?:[^()\\]|\\[\s\S])*\))*\)/.source,
            /\{(?:[^{}\\]|\\[\s\S]|\{(?:[^{}\\]|\\[\s\S])*\})*\}/.source,
            /\[(?:[^\[\]\\]|\\[\s\S]|\[(?:[^\[\]\\]|\\[\s\S])*\])*\]/.source,
            /<(?:[^<>\\]|\\[\s\S]|<(?:[^<>\\]|\\[\s\S])*>)*>/.source
        ].join('|') + ')';
        var symbolName = /(?:"(?:\\.|[^"\\\r\n])*"|(?:\b[a-zA-Z_]\w*|[^\s\0-\x7F]+)[?!]?|\$.)/.source;
        Prism.languages.insertBefore('ruby', 'keyword', {
            'regex-literal': [
                {
                    pattern: RegExp(/%r/.source + percentExpression + /[egimnosux]{0,6}/.source),
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        regex: /[\s\S]+/
                    }
                },
                {
                    pattern: /(^|[^/])\/(?!\/)(?:\[[^\r\n\]]+\]|\\.|[^[/\\\r\n])+\/[egimnosux]{0,6}(?=\s*(?:$|[\r\n,.;})#]))/,
                    lookbehind: true,
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        regex: /[\s\S]+/
                    }
                }
            ],
            variable: /[@$]+[a-zA-Z_]\w*(?:[?!]|\b)/,
            symbol: [
                {
                    pattern: RegExp(/(^|[^:]):/.source + symbolName),
                    lookbehind: true,
                    greedy: true
                },
                {
                    pattern: RegExp(/([\r\n{(,][ \t]*)/.source + symbolName + /(?=:(?!:))/.source),
                    lookbehind: true,
                    greedy: true
                }
            ],
            'method-definition': {
                pattern: /(\bdef\s+)\w+(?:\s*\.\s*\w+)?/,
                lookbehind: true,
                inside: {
                    function: /\b\w+$/,
                    keyword: /^self\b/,
                    'class-name': /^\w+/,
                    punctuation: /\./
                }
            }
        });
        Prism.languages.insertBefore('ruby', 'string', {
            'string-literal': [
                {
                    pattern: RegExp(/%[qQiIwWs]?/.source + percentExpression),
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        string: /[\s\S]+/
                    }
                },
                {
                    pattern: /("|')(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|(?!\1)[^\\#\r\n])*\1/,
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        string: /[\s\S]+/
                    }
                },
                {
                    pattern: /<<[-~]?([a-z_]\w*)[\r\n](?:.*[\r\n])*?[\t ]*\1/i,
                    alias: 'heredoc-string',
                    greedy: true,
                    inside: {
                        delimiter: {
                            pattern: /^<<[-~]?[a-z_]\w*|\b[a-z_]\w*$/i,
                            inside: {
                                symbol: /\b\w+/,
                                punctuation: /^<<[-~]?/
                            }
                        },
                        interpolation: interpolation,
                        string: /[\s\S]+/
                    }
                },
                {
                    pattern: /<<[-~]?'([a-z_]\w*)'[\r\n](?:.*[\r\n])*?[\t ]*\1/i,
                    alias: 'heredoc-string',
                    greedy: true,
                    inside: {
                        delimiter: {
                            pattern: /^<<[-~]?'[a-z_]\w*'|\b[a-z_]\w*$/i,
                            inside: {
                                symbol: /\b\w+/,
                                punctuation: /^<<[-~]?'|'$/
                            }
                        },
                        string: /[\s\S]+/
                    }
                }
            ],
            'command-literal': [
                {
                    pattern: RegExp(/%x/.source + percentExpression),
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        command: {
                            pattern: /[\s\S]+/,
                            alias: 'string'
                        }
                    }
                },
                {
                    pattern: /`(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|[^\\`#\r\n])*`/,
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        command: {
                            pattern: /[\s\S]+/,
                            alias: 'string'
                        }
                    }
                }
            ]
        });
        delete Prism.languages.ruby.string;
        Prism.languages.insertBefore('ruby', 'number', {
            builtin: /\b(?:Array|Bignum|Binding|Class|Continuation|Dir|Exception|FalseClass|File|Fixnum|Float|Hash|IO|Integer|MatchData|Method|Module|NilClass|Numeric|Object|Proc|Range|Regexp|Stat|String|Struct|Symbol|TMS|Thread|ThreadGroup|Time|TrueClass)\b/,
            constant: /\b[A-Z][A-Z0-9_]*(?:[?!]|\b)/
        });
        Prism.languages.rb = Prism.languages.ruby;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $27d87a17c8c1aaf3$export$2e2bcd8739ae039.displayName = 'rust';
$27d87a17c8c1aaf3$export$2e2bcd8739ae039.aliases = [];
function $27d87a17c8c1aaf3$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var multilineComment = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source;
        for(var i = 0; i < 2; i++)// support 4 levels of nested comments
        multilineComment = multilineComment.replace(/<self>/g, function() {
            return multilineComment;
        });
        multilineComment = multilineComment.replace(/<self>/g, function() {
            return /[^\s\S]/.source;
        });
        Prism.languages.rust = {
            comment: [
                {
                    pattern: RegExp(/(^|[^\\])/.source + multilineComment),
                    lookbehind: true,
                    greedy: true
                },
                {
                    pattern: /(^|[^\\:])\/\/.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            string: {
                pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
                greedy: true
            },
            char: {
                pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
                greedy: true
            },
            attribute: {
                pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
                greedy: true,
                alias: 'attr-name',
                inside: {
                    string: null // see below
                }
            },
            // Closure params should not be confused with bitwise OR |
            'closure-params': {
                pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
                lookbehind: true,
                greedy: true,
                inside: {
                    'closure-punctuation': {
                        pattern: /^\||\|$/,
                        alias: 'punctuation'
                    },
                    rest: null // see below
                }
            },
            'lifetime-annotation': {
                pattern: /'\w+/,
                alias: 'symbol'
            },
            'fragment-specifier': {
                pattern: /(\$\w+:)[a-z]+/,
                lookbehind: true,
                alias: 'punctuation'
            },
            variable: /\$\w+/,
            'function-definition': {
                pattern: /(\bfn\s+)\w+/,
                lookbehind: true,
                alias: 'function'
            },
            'type-definition': {
                pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
                lookbehind: true,
                alias: 'class-name'
            },
            'module-declaration': [
                {
                    pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
                    lookbehind: true,
                    alias: 'namespace'
                },
                {
                    pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
                    lookbehind: true,
                    alias: 'namespace',
                    inside: {
                        punctuation: /::/
                    }
                }
            ],
            keyword: [
                // https://github.com/rust-lang/reference/blob/master/src/keywords.md
                /\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
                // primitives and str
                // https://doc.rust-lang.org/stable/rust-by-example/primitives.html
                /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/
            ],
            // functions can technically start with an upper-case letter, but this will introduce a lot of false positives
            // and Rust's naming conventions recommend snake_case anyway.
            // https://doc.rust-lang.org/1.0.0/style/style/naming/README.html
            function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
            macro: {
                pattern: /\b\w+!/,
                alias: 'property'
            },
            constant: /\b[A-Z_][A-Z_\d]+\b/,
            'class-name': /\b[A-Z]\w*\b/,
            namespace: {
                pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
                inside: {
                    punctuation: /::/
                }
            },
            // Hex, oct, bin, dec numbers with visual separators and type suffix
            number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
            boolean: /\b(?:false|true)\b/,
            punctuation: /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
            operator: /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
        };
        Prism.languages.rust['closure-params'].inside.rest = Prism.languages.rust;
        Prism.languages.rust['attribute'].inside['string'] = Prism.languages.rust['string'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$d4804f7e613d614f$export$2e2bcd8739ae039.displayName = 'sass';
$d4804f7e613d614f$export$2e2bcd8739ae039.aliases = [];
function $d4804f7e613d614f$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $8467c3aacdff56ee$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.sass = Prism.languages.extend('css', {
            // Sass comments don't need to be closed, only indented
            comment: {
                pattern: /^([ \t]*)\/[\/*].*(?:(?:\r?\n|\r)\1[ \t].+)*/m,
                lookbehind: true,
                greedy: true
            }
        });
        Prism.languages.insertBefore('sass', 'atrule', {
            // We want to consume the whole line
            'atrule-line': {
                // Includes support for = and + shortcuts
                pattern: /^(?:[ \t]*)[@+=].+/m,
                greedy: true,
                inside: {
                    atrule: /(?:@[\w-]+|[+=])/
                }
            }
        });
        delete Prism.languages.sass.atrule;
        var variable = /\$[-\w]+|#\{\$[-\w]+\}/;
        var operator = [
            /[+*\/%]|[=!]=|<=?|>=?|\b(?:and|not|or)\b/,
            {
                pattern: /(\s)-(?=\s)/,
                lookbehind: true
            }
        ];
        Prism.languages.insertBefore('sass', 'property', {
            // We want to consume the whole line
            'variable-line': {
                pattern: /^[ \t]*\$.+/m,
                greedy: true,
                inside: {
                    punctuation: /:/,
                    variable: variable,
                    operator: operator
                }
            },
            // We want to consume the whole line
            'property-line': {
                pattern: /^[ \t]*(?:[^:\s]+ *:.*|:[^:\s].*)/m,
                greedy: true,
                inside: {
                    property: [
                        /[^:\s]+(?=\s*:)/,
                        {
                            pattern: /(:)[^:\s]+/,
                            lookbehind: true
                        }
                    ],
                    punctuation: /:/,
                    variable: variable,
                    operator: operator,
                    important: Prism.languages.sass.important
                }
            }
        });
        delete Prism.languages.sass.property;
        delete Prism.languages.sass.important;
        // Now that whole lines for other patterns are consumed,
        // what's left should be selectors
        Prism.languages.insertBefore('sass', 'punctuation', {
            selector: {
                pattern: /^([ \t]*)\S(?:,[^,\r\n]+|[^,\r\n]*)(?:,[^,\r\n]+)*(?:,(?:\r?\n|\r)\1[ \t]+\S(?:,[^,\r\n]+|[^,\r\n]*)(?:,[^,\r\n]+)*)*/m,
                lookbehind: true,
                greedy: true
            }
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$621160e6c15c3eff$export$2e2bcd8739ae039.displayName = 'scss';
$621160e6c15c3eff$export$2e2bcd8739ae039.aliases = [];
function $621160e6c15c3eff$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $8467c3aacdff56ee$export$2e2bcd8739ae039));
    Prism.languages.scss = Prism.languages.extend('css', {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
            lookbehind: true
        },
        atrule: {
            pattern: /@[\w-](?:\([^()]+\)|[^()\s]|\s+(?!\s))*?(?=\s+[{;])/,
            inside: {
                rule: /@[\w-]+/
            }
        },
        // url, compassified
        url: /(?:[-a-z]+-)?url(?=\()/i,
        // CSS selector regex is not appropriate for Sass
        // since there can be lot more things (var, @ directive, nesting..)
        // a selector must start at the end of a property or after a brace (end of other rules or nesting)
        // it can contain some characters that aren't used for defining rules or end of selector, & (parent selector), or interpolated variable
        // the end of a selector is found when there is no rules in it ( {} or {\s}) or if there is a property (because an interpolated var
        // can "pass" as a selector- e.g: proper#{$erty})
        // this one was hard to do, so please be careful if you edit this one :)
        selector: {
            // Initial look-ahead is used to prevent matching of blank selectors
            pattern: /(?=\S)[^@;{}()]?(?:[^@;{}()\s]|\s+(?!\s)|#\{\$[-\w]+\})+(?=\s*\{(?:\}|\s|[^}][^:{}]*[:{][^}]))/,
            inside: {
                parent: {
                    pattern: /&/,
                    alias: 'important'
                },
                placeholder: /%[-\w]+/,
                variable: /\$[-\w]+|#\{\$[-\w]+\}/
            }
        },
        property: {
            pattern: /(?:[-\w]|\$[-\w]|#\{\$[-\w]+\})+(?=\s*:)/,
            inside: {
                variable: /\$[-\w]+|#\{\$[-\w]+\}/
            }
        }
    });
    Prism.languages.insertBefore('scss', 'atrule', {
        keyword: [
            /@(?:content|debug|each|else(?: if)?|extend|for|forward|function|if|import|include|mixin|return|use|warn|while)\b/i,
            {
                pattern: /( )(?:from|through)(?= )/,
                lookbehind: true
            }
        ]
    });
    Prism.languages.insertBefore('scss', 'important', {
        // var and interpolated vars
        variable: /\$[-\w]+|#\{\$[-\w]+\}/
    });
    Prism.languages.insertBefore('scss', 'function', {
        'module-modifier': {
            pattern: /\b(?:as|hide|show|with)\b/i,
            alias: 'keyword'
        },
        placeholder: {
            pattern: /%[-\w]+/,
            alias: 'selector'
        },
        statement: {
            pattern: /\B!(?:default|optional)\b/i,
            alias: 'keyword'
        },
        boolean: /\b(?:false|true)\b/,
        null: {
            pattern: /\bnull\b/,
            alias: 'keyword'
        },
        operator: {
            pattern: /(\s)(?:[-+*\/%]|[=!]=|<=?|>=?|and|not|or)(?=\s)/,
            lookbehind: true
        }
    });
    Prism.languages.scss['atrule'].inside.rest = Prism.languages.scss;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $eb5bcdfed284c0e2$export$2e2bcd8739ae039.displayName = 'sql';
$eb5bcdfed284c0e2$export$2e2bcd8739ae039.aliases = [];
function $eb5bcdfed284c0e2$export$2e2bcd8739ae039(Prism) {
    Prism.languages.sql = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
            lookbehind: true
        },
        variable: [
            {
                pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
                greedy: true
            },
            /@[\w.$]+/
        ],
        string: {
            pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
            greedy: true,
            lookbehind: true
        },
        identifier: {
            pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
            greedy: true,
            lookbehind: true,
            inside: {
                punctuation: /^`|`$/
            }
        },
        function: /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,
        // Should we highlight user defined functions too?
        keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
        boolean: /\b(?:FALSE|NULL|TRUE)\b/i,
        number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
        operator: /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
        punctuation: /[;[\]()`,.]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $10278687c497f16d$export$2e2bcd8739ae039.displayName = 'swift';
$10278687c497f16d$export$2e2bcd8739ae039.aliases = [];
function $10278687c497f16d$export$2e2bcd8739ae039(Prism) {
    Prism.languages.swift = {
        comment: {
            // Nested comments are supported up to 2 levels
            pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,
            lookbehind: true,
            greedy: true
        },
        'string-literal': [
            // https://docs.swift.org/swift-book/LanguageGuide/StringsAndCharacters.html
            {
                pattern: RegExp(/(^|[^"#])/.source + '(?:' + // single-line string
                /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + '|' + // multi-line string
                /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ')' + /(?!["#])/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/,
                        lookbehind: true,
                        inside: null // see below
                    },
                    'interpolation-punctuation': {
                        pattern: /^\)|\\\($/,
                        alias: 'punctuation'
                    },
                    punctuation: /\\(?=[\r\n])/,
                    string: /[\s\S]+/
                }
            },
            {
                pattern: RegExp(/(^|[^"#])(#+)/.source + '(?:' + // single-line string
                /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + '|' + // multi-line string
                /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ')' + '\\2'),
                lookbehind: true,
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,
                        lookbehind: true,
                        inside: null // see below
                    },
                    'interpolation-punctuation': {
                        pattern: /^\)|\\#+\($/,
                        alias: 'punctuation'
                    },
                    string: /[\s\S]+/
                }
            }
        ],
        directive: {
            // directives with conditions
            pattern: RegExp(/#/.source + '(?:' + (/(?:elseif|if)\b/.source + '(?:[ \t]*' + // This regex is a little complex. It's equivalent to this:
            //   (?:![ \t]*)?(?:\b\w+\b(?:[ \t]*<round>)?|<round>)(?:[ \t]*(?:&&|\|\|))?
            // where <round> is a general parentheses expression.
            /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ')+') + '|' + /(?:else|endif)\b/.source + ')'),
            alias: 'property',
            inside: {
                'directive-name': /^#\w+/,
                boolean: /\b(?:false|true)\b/,
                number: /\b\d+(?:\.\d+)*\b/,
                operator: /!|&&|\|\||[<>]=?/,
                punctuation: /[(),]/
            }
        },
        literal: {
            pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,
            alias: 'constant'
        },
        'other-directive': {
            pattern: /#\w+\b/,
            alias: 'property'
        },
        attribute: {
            pattern: /@\w+/,
            alias: 'atrule'
        },
        'function-definition': {
            pattern: /(\bfunc\s+)\w+/,
            lookbehind: true,
            alias: 'function'
        },
        label: {
            // https://docs.swift.org/swift-book/LanguageGuide/ControlFlow.html#ID141
            pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,
            lookbehind: true,
            alias: 'important'
        },
        keyword: /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,
        boolean: /\b(?:false|true)\b/,
        nil: {
            pattern: /\bnil\b/,
            alias: 'constant'
        },
        'short-argument': /\$\d+\b/,
        omit: {
            pattern: /\b_\b/,
            alias: 'keyword'
        },
        number: /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,
        // A class name must start with an upper-case letter and be either 1 letter long or contain a lower-case letter.
        'class-name': /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        constant: /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,
        // Operators are generic in Swift. Developers can even create new operators (e.g. +++).
        // https://docs.swift.org/swift-book/ReferenceManual/zzSummaryOfTheGrammar.html#ID481
        // This regex only supports ASCII operators.
        operator: /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,
        punctuation: /[{}[\]();,.:\\]/
    };
    Prism.languages.swift['string-literal'].forEach(function(rule) {
        rule.inside['interpolation'].inside = Prism.languages.swift;
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$010d7940936c67fb$export$2e2bcd8739ae039.displayName = 'typescript';
$010d7940936c67fb$export$2e2bcd8739ae039.aliases = [
    'ts'
];
function $010d7940936c67fb$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.typescript = Prism.languages.extend('javascript', {
            'class-name': {
                pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
                lookbehind: true,
                greedy: true,
                inside: null // see below
            },
            builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
        });
        // The keywords TypeScript adds to JavaScript
        Prism.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, // keywords that have to be followed by an identifier
        /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, // This is for `import type *, {}`
        /\btype\b(?=\s*(?:[\{*]|$))/);
        // doesn't work with TS because TS is too complex
        delete Prism.languages.typescript['parameter'];
        delete Prism.languages.typescript['literal-property'];
        // a version of typescript specifically for highlighting types
        var typeInside = Prism.languages.extend('typescript', {});
        delete typeInside['class-name'];
        Prism.languages.typescript['class-name'].inside = typeInside;
        Prism.languages.insertBefore('typescript', 'function', {
            decorator: {
                pattern: /@[$\w\xA0-\uFFFF]+/,
                inside: {
                    at: {
                        pattern: /^@/,
                        alias: 'operator'
                    },
                    function: /^[\s\S]+/
                }
            },
            'generic-function': {
                // e.g. foo<T extends "bar" | "baz">( ...
                pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
                greedy: true,
                inside: {
                    function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
                    generic: {
                        pattern: /<[\s\S]+/,
                        // everything after the first <
                        alias: 'class-name',
                        inside: typeInside
                    }
                }
            }
        });
        Prism.languages.ts = Prism.languages.typescript;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $b245c95193e08d8c$export$2e2bcd8739ae039.displayName = 'basic';
$b245c95193e08d8c$export$2e2bcd8739ae039.aliases = [];
function $b245c95193e08d8c$export$2e2bcd8739ae039(Prism) {
    Prism.languages.basic = {
        comment: {
            pattern: /(?:!|REM\b).+/i,
            inside: {
                keyword: /^REM/i
            }
        },
        string: {
            pattern: /"(?:""|[!#$%&'()*,\/:;<=>?^\w +\-.])*"/,
            greedy: true
        },
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
        keyword: /\b(?:AS|BEEP|BLOAD|BSAVE|CALL(?: ABSOLUTE)?|CASE|CHAIN|CHDIR|CLEAR|CLOSE|CLS|COM|COMMON|CONST|DATA|DECLARE|DEF(?: FN| SEG|DBL|INT|LNG|SNG|STR)|DIM|DO|DOUBLE|ELSE|ELSEIF|END|ENVIRON|ERASE|ERROR|EXIT|FIELD|FILES|FOR|FUNCTION|GET|GOSUB|GOTO|IF|INPUT|INTEGER|IOCTL|KEY|KILL|LINE INPUT|LOCATE|LOCK|LONG|LOOP|LSET|MKDIR|NAME|NEXT|OFF|ON(?: COM| ERROR| KEY| TIMER)?|OPEN|OPTION BASE|OUT|POKE|PUT|READ|REDIM|REM|RESTORE|RESUME|RETURN|RMDIR|RSET|RUN|SELECT CASE|SHARED|SHELL|SINGLE|SLEEP|STATIC|STEP|STOP|STRING|SUB|SWAP|SYSTEM|THEN|TIMER|TO|TROFF|TRON|TYPE|UNLOCK|UNTIL|USING|VIEW PRINT|WAIT|WEND|WHILE|WRITE)(?:\$|\b)/i,
        function: /\b(?:ABS|ACCESS|ACOS|ANGLE|AREA|ARITHMETIC|ARRAY|ASIN|ASK|AT|ATN|BASE|BEGIN|BREAK|CAUSE|CEIL|CHR|CLIP|COLLATE|COLOR|CON|COS|COSH|COT|CSC|DATE|DATUM|DEBUG|DECIMAL|DEF|DEG|DEGREES|DELETE|DET|DEVICE|DISPLAY|DOT|ELAPSED|EPS|ERASABLE|EXLINE|EXP|EXTERNAL|EXTYPE|FILETYPE|FIXED|FP|GO|GRAPH|HANDLER|IDN|IMAGE|IN|INT|INTERNAL|IP|IS|KEYED|LBOUND|LCASE|LEFT|LEN|LENGTH|LET|LINE|LINES|LOG|LOG10|LOG2|LTRIM|MARGIN|MAT|MAX|MAXNUM|MID|MIN|MISSING|MOD|NATIVE|NUL|NUMERIC|OF|OPTION|ORD|ORGANIZATION|OUTIN|OUTPUT|PI|POINT|POINTER|POINTS|POS|PRINT|PROGRAM|PROMPT|RAD|RADIANS|RANDOMIZE|RECORD|RECSIZE|RECTYPE|RELATIVE|REMAINDER|REPEAT|REST|RETRY|REWRITE|RIGHT|RND|ROUND|RTRIM|SAME|SEC|SELECT|SEQUENTIAL|SET|SETTER|SGN|SIN|SINH|SIZE|SKIP|SQR|STANDARD|STATUS|STR|STREAM|STYLE|TAB|TAN|TANH|TEMPLATE|TEXT|THERE|TIME|TIMEOUT|TRACE|TRANSFORM|TRUNCATE|UBOUND|UCASE|USE|VAL|VARIABLE|VIEWPORT|WHEN|WINDOW|WITH|ZER|ZONEWIDTH)(?:\$|\b)/i,
        operator: /<[=>]?|>=?|[+\-*\/^=&]|\b(?:AND|EQV|IMP|NOT|OR|XOR)\b/i,
        punctuation: /[,;:()]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$74f53190c8211cce$export$2e2bcd8739ae039.displayName = 'vbnet';
$74f53190c8211cce$export$2e2bcd8739ae039.aliases = [];
function $74f53190c8211cce$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $b245c95193e08d8c$export$2e2bcd8739ae039));
    Prism.languages.vbnet = Prism.languages.extend('basic', {
        comment: [
            {
                pattern: /(?:!|REM\b).+/i,
                inside: {
                    keyword: /^REM/i
                }
            },
            {
                pattern: /(^|[^\\:])'.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(^|[^"])"(?:""|[^"])*"(?!")/,
            lookbehind: true,
            greedy: true
        },
        keyword: /(?:\b(?:ADDHANDLER|ADDRESSOF|ALIAS|AND|ANDALSO|AS|BEEP|BLOAD|BOOLEAN|BSAVE|BYREF|BYTE|BYVAL|CALL(?: ABSOLUTE)?|CASE|CATCH|CBOOL|CBYTE|CCHAR|CDATE|CDBL|CDEC|CHAIN|CHAR|CHDIR|CINT|CLASS|CLEAR|CLNG|CLOSE|CLS|COBJ|COM|COMMON|CONST|CONTINUE|CSBYTE|CSHORT|CSNG|CSTR|CTYPE|CUINT|CULNG|CUSHORT|DATA|DATE|DECIMAL|DECLARE|DEF(?: FN| SEG|DBL|INT|LNG|SNG|STR)|DEFAULT|DELEGATE|DIM|DIRECTCAST|DO|DOUBLE|ELSE|ELSEIF|END|ENUM|ENVIRON|ERASE|ERROR|EVENT|EXIT|FALSE|FIELD|FILES|FINALLY|FOR(?: EACH)?|FRIEND|FUNCTION|GET|GETTYPE|GETXMLNAMESPACE|GLOBAL|GOSUB|GOTO|HANDLES|IF|IMPLEMENTS|IMPORTS|IN|INHERITS|INPUT|INTEGER|INTERFACE|IOCTL|IS|ISNOT|KEY|KILL|LET|LIB|LIKE|LINE INPUT|LOCATE|LOCK|LONG|LOOP|LSET|ME|MKDIR|MOD|MODULE|MUSTINHERIT|MUSTOVERRIDE|MYBASE|MYCLASS|NAME|NAMESPACE|NARROWING|NEW|NEXT|NOT|NOTHING|NOTINHERITABLE|NOTOVERRIDABLE|OBJECT|OF|OFF|ON(?: COM| ERROR| KEY| TIMER)?|OPEN|OPERATOR|OPTION(?: BASE)?|OPTIONAL|OR|ORELSE|OUT|OVERLOADS|OVERRIDABLE|OVERRIDES|PARAMARRAY|PARTIAL|POKE|PRIVATE|PROPERTY|PROTECTED|PUBLIC|PUT|RAISEEVENT|READ|READONLY|REDIM|REM|REMOVEHANDLER|RESTORE|RESUME|RETURN|RMDIR|RSET|RUN|SBYTE|SELECT(?: CASE)?|SET|SHADOWS|SHARED|SHELL|SHORT|SINGLE|SLEEP|STATIC|STEP|STOP|STRING|STRUCTURE|SUB|SWAP|SYNCLOCK|SYSTEM|THEN|THROW|TIMER|TO|TROFF|TRON|TRUE|TRY|TRYCAST|TYPE|TYPEOF|UINTEGER|ULONG|UNLOCK|UNTIL|USHORT|USING|VIEW PRINT|WAIT|WEND|WHEN|WHILE|WIDENING|WITH|WITHEVENTS|WRITE|WRITEONLY|XOR)|\B(?:#CONST|#ELSE|#ELSEIF|#END|#IF))(?:\$|\b)/i,
        punctuation: /[,;:(){}]/
    });
}


/**
 * @import {Element, Root, Text} from 'hast'
 * @import {Grammar, Languages} from 'prismjs'
 */ /**
 * @typedef _Token
 *   Hidden Prism token.
 * @property {string} alias
 *   Alias.
 * @property {string} content
 *   Content.
 * @property {number} length
 *   Length.
 * @property {string} type
 *   Type.
 */ /**
 * @typedef _Env
 *   Hidden Prism environment.
 * @property {Record<string, string>} attributes
 *   Attributes.
 * @property {Array<string>} classes
 *   Classes.
 * @property {Array<Element | Text> | Element | Text} content
 *   Content.
 * @property {string} language
 *   Language.
 * @property {string} tag
 *   Tag.
 * @property {string} type
 *   Type.
 */ /**
 * @typedef {((prism: Refractor) => undefined | void) & {aliases?: Array<string> | undefined, displayName: string}} Syntax
 *   Refractor syntax function.
 */ /**
 * @typedef Refractor
 *   Virtual syntax highlighting
 * @property {typeof alias} alias
 * @property {Languages} languages
 * @property {typeof listLanguages} listLanguages
 * @property {typeof highlight} highlight
 * @property {typeof registered} registered
 * @property {typeof register} register
 */ // Load all stuff in `prism.js` itself, except for `prism-file-highlight.js`.
// The wrapped non-leaky grammars are loaded instead of Prism’s originals.


// @ts-nocheck
// This is a slimmed down version of `prism-core.js`, to remove globals,
// document, workers, `util.encode`, `Token.stringify`
// Private helper vars
var $7272cd95bfd5bc93$var$lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
var $7272cd95bfd5bc93$var$uniqueId = 0;
// The grammar object for plaintext
var $7272cd95bfd5bc93$var$plainTextGrammar = {};
var $7272cd95bfd5bc93$var$_ = {
    /**
   * A namespace for utility methods.
   *
   * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
   * change or disappear at any time.
   *
   * @namespace
   * @memberof Prism
   */ util: {
        /**
     * Returns the name of the type of the given value.
     *
     * @param {any} o
     * @returns {string}
     * @example
     * type(null)      === 'Null'
     * type(undefined) === 'Undefined'
     * type(123)       === 'Number'
     * type('foo')     === 'String'
     * type(true)      === 'Boolean'
     * type([1, 2])    === 'Array'
     * type({})        === 'Object'
     * type(String)    === 'Function'
     * type(/abc+/)    === 'RegExp'
     */ type: function(o) {
            return Object.prototype.toString.call(o).slice(8, -1);
        },
        /**
     * Returns a unique number for the given object. Later calls will still return the same number.
     *
     * @param {Object} obj
     * @returns {number}
     */ objId: function(obj) {
            if (!obj['__id']) Object.defineProperty(obj, '__id', {
                value: ++$7272cd95bfd5bc93$var$uniqueId
            });
            return obj['__id'];
        },
        /**
     * Creates a deep clone of the given object.
     *
     * The main intended use of this function is to clone language definitions.
     *
     * @param {T} o
     * @param {Record<number, any>} [visited]
     * @returns {T}
     * @template T
     */ clone: function deepClone(o, visited) {
            visited = visited || {};
            var clone;
            var id;
            switch($7272cd95bfd5bc93$var$_.util.type(o)){
                case 'Object':
                    id = $7272cd95bfd5bc93$var$_.util.objId(o);
                    if (visited[id]) return visited[id];
                    clone = /** @type {Record<string, any>} */ {};
                    visited[id] = clone;
                    for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                    return /** @type {any} */ clone;
                case 'Array':
                    id = $7272cd95bfd5bc93$var$_.util.objId(o);
                    if (visited[id]) return visited[id];
                    clone = [];
                    visited[id] = clone; /** @type {Array} */ 
                    /** @type {any} */ o.forEach(function(v, i) {
                        clone[i] = deepClone(v, visited);
                    });
                    return /** @type {any} */ clone;
                default:
                    return o;
            }
        }
    },
    /**
   * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
   *
   * @namespace
   * @memberof Prism
   * @public
   */ languages: {
        /**
     * The grammar for plain, unformatted text.
     */ plain: $7272cd95bfd5bc93$var$plainTextGrammar,
        plaintext: $7272cd95bfd5bc93$var$plainTextGrammar,
        text: $7272cd95bfd5bc93$var$plainTextGrammar,
        txt: $7272cd95bfd5bc93$var$plainTextGrammar,
        /**
     * Creates a deep copy of the language with the given id and appends the given tokens.
     *
     * If a token in `redef` also appears in the copied language, then the existing token in the copied language
     * will be overwritten at its original position.
     *
     * ## Best practices
     *
     * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
     * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
     * understand the language definition because, normally, the order of tokens matters in Prism grammars.
     *
     * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
     * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
     *
     * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
     * @param {Grammar} redef The new tokens to append.
     * @returns {Grammar} The new language created.
     * @public
     * @example
     * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
     *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
     *     // at its original position
     *     'comment': { ... },
     *     // CSS doesn't have a 'color' token, so this token will be appended
     *     'color': /\b(?:red|green|blue)\b/
     * });
     */ extend: function(id, redef) {
            var lang = $7272cd95bfd5bc93$var$_.util.clone($7272cd95bfd5bc93$var$_.languages[id]);
            for(var key in redef)lang[key] = redef[key];
            return lang;
        },
        /**
     * Inserts tokens _before_ another token in a language definition or any other grammar.
     *
     * ## Usage
     *
     * This helper method makes it easy to modify existing languages. For example, the CSS language definition
     * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
     * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
     * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
     * this:
     *
     * ```js
     * Prism.languages.markup.style = {
     *     // token
     * };
     * ```
     *
     * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
     * before existing tokens. For the CSS example above, you would use it like this:
     *
     * ```js
     * Prism.languages.insertBefore('markup', 'cdata', {
     *     'style': {
     *         // token
     *     }
     * });
     * ```
     *
     * ## Special cases
     *
     * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
     * will be ignored.
     *
     * This behavior can be used to insert tokens after `before`:
     *
     * ```js
     * Prism.languages.insertBefore('markup', 'comment', {
     *     'comment': Prism.languages.markup.comment,
     *     // tokens after 'comment'
     * });
     * ```
     *
     * ## Limitations
     *
     * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
     * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
     * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
     * deleting properties which is necessary to insert at arbitrary positions.
     *
     * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
     * Instead, it will create a new object and replace all references to the target object with the new one. This
     * can be done without temporarily deleting properties, so the iteration order is well-defined.
     *
     * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
     * you hold the target object in a variable, then the value of the variable will not change.
     *
     * ```js
     * var oldMarkup = Prism.languages.markup;
     * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
     *
     * assert(oldMarkup !== Prism.languages.markup);
     * assert(newMarkup === Prism.languages.markup);
     * ```
     *
     * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
     * object to be modified.
     * @param {string} before The key to insert before.
     * @param {Grammar} insert An object containing the key-value pairs to be inserted.
     * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
     * object to be modified.
     *
     * Defaults to `Prism.languages`.
     * @returns {Grammar} The new grammar object.
     * @public
     */ insertBefore: function(inside, before, insert, root) {
            root = root || /** @type {any} */ $7272cd95bfd5bc93$var$_.languages;
            var grammar = root[inside];
            /** @type {Grammar} */ var ret = {};
            for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                if (token == before) {
                    for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                }
                // Do not insert token which also occur in insert. See #1525
                if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
            }
            var old = root[inside];
            root[inside] = ret;
            // Update references in other language definitions
            $7272cd95bfd5bc93$var$_.languages.DFS($7272cd95bfd5bc93$var$_.languages, function(key, value) {
                if (value === old && key != inside) this[key] = ret;
            });
            return ret;
        },
        // Traverse a language definition with Depth First Search
        DFS: function DFS(o, callback, type, visited) {
            visited = visited || {};
            var objId = $7272cd95bfd5bc93$var$_.util.objId;
            for(var i in o)if (o.hasOwnProperty(i)) {
                callback.call(o, i, o[i], type || i);
                var property = o[i];
                var propertyType = $7272cd95bfd5bc93$var$_.util.type(property);
                if (propertyType === 'Object' && !visited[objId(property)]) {
                    visited[objId(property)] = true;
                    DFS(property, callback, null, visited);
                } else if (propertyType === 'Array' && !visited[objId(property)]) {
                    visited[objId(property)] = true;
                    DFS(property, callback, i, visited);
                }
            }
        }
    },
    plugins: {},
    /**
   * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
   * and the language definitions to use, and returns a string with the HTML produced.
   *
   * The following hooks will be run:
   * 1. `before-tokenize`
   * 2. `after-tokenize`
   * 3. `wrap`: On each {@link Token}.
   *
   * @param {string} text A string with the code to be highlighted.
   * @param {Grammar} grammar An object containing the tokens to use.
   *
   * Usually a language definition like `Prism.languages.markup`.
   * @param {string} language The name of the language definition passed to `grammar`.
   * @returns {string} The highlighted HTML.
   * @memberof Prism
   * @public
   * @example
   * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
   */ highlight: function(text, grammar, language) {
        var env = {
            code: text,
            grammar: grammar,
            language: language
        };
        $7272cd95bfd5bc93$var$_.hooks.run('before-tokenize', env);
        if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
        env.tokens = $7272cd95bfd5bc93$var$_.tokenize(env.code, env.grammar);
        $7272cd95bfd5bc93$var$_.hooks.run('after-tokenize', env);
        return $7272cd95bfd5bc93$var$Token.stringify($7272cd95bfd5bc93$var$_.util.encode(env.tokens), env.language);
    },
    /**
   * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
   * and the language definitions to use, and returns an array with the tokenized code.
   *
   * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
   *
   * This method could be useful in other contexts as well, as a very crude parser.
   *
   * @param {string} text A string with the code to be highlighted.
   * @param {Grammar} grammar An object containing the tokens to use.
   *
   * Usually a language definition like `Prism.languages.markup`.
   * @returns {TokenStream} An array of strings and tokens, a token stream.
   * @memberof Prism
   * @public
   * @example
   * let code = `var foo = 0;`;
   * let tokens = Prism.tokenize(code, Prism.languages.javascript);
   * tokens.forEach(token => {
   *     if (token instanceof Prism.Token && token.type === 'number') {
   *         console.log(`Found numeric literal: ${token.content}`);
   *     }
   * });
   */ tokenize: function(text, grammar) {
        var rest = grammar.rest;
        if (rest) {
            for(var token in rest)grammar[token] = rest[token];
            delete grammar.rest;
        }
        var tokenList = new $7272cd95bfd5bc93$var$LinkedList();
        $7272cd95bfd5bc93$var$addAfter(tokenList, tokenList.head, text);
        $7272cd95bfd5bc93$var$matchGrammar(text, tokenList, grammar, tokenList.head, 0);
        return $7272cd95bfd5bc93$var$toArray(tokenList);
    },
    /**
   * @namespace
   * @memberof Prism
   * @public
   */ hooks: {
        all: {},
        /**
     * Adds the given callback to the list of callbacks for the given hook.
     *
     * The callback will be invoked when the hook it is registered for is run.
     * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
     *
     * One callback function can be registered to multiple hooks and the same hook multiple times.
     *
     * @param {string} name The name of the hook.
     * @param {HookCallback} callback The callback function which is given environment variables.
     * @public
     */ add: function(name, callback) {
            var hooks = $7272cd95bfd5bc93$var$_.hooks.all;
            hooks[name] = hooks[name] || [];
            hooks[name].push(callback);
        },
        /**
     * Runs a hook invoking all registered callbacks with the given environment variables.
     *
     * Callbacks will be invoked synchronously and in the order in which they were registered.
     *
     * @param {string} name The name of the hook.
     * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
     * @public
     */ run: function(name, env) {
            var callbacks = $7272cd95bfd5bc93$var$_.hooks.all[name];
            if (!callbacks || !callbacks.length) return;
            for(var i = 0, callback; callback = callbacks[i++];)callback(env);
        }
    },
    Token: $7272cd95bfd5bc93$var$Token
};
// Typescript note:
// The following can be used to import the Token type in JSDoc:
//
//   @typedef {InstanceType<import("./prism-core")["Token"]>} Token
/**
 * Creates a new token.
 *
 * @param {string} type See {@link Token#type type}
 * @param {string | TokenStream} content See {@link Token#content content}
 * @param {string|string[]} [alias] The alias(es) of the token.
 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
 * @class
 * @global
 * @public
 */ function $7272cd95bfd5bc93$var$Token(type, content, alias, matchedStr) {
    /**
   * The type of the token.
   *
   * This is usually the key of a pattern in a {@link Grammar}.
   *
   * @type {string}
   * @see GrammarToken
   * @public
   */ this.type = type;
    /**
   * The strings or tokens contained by this token.
   *
   * This will be a token stream if the pattern matched also defined an `inside` grammar.
   *
   * @type {string | TokenStream}
   * @public
   */ this.content = content;
    /**
   * The alias(es) of the token.
   *
   * @type {string|string[]}
   * @see GrammarToken
   * @public
   */ this.alias = alias;
    // Copy of the full string this token was created from
    this.length = (matchedStr || '').length | 0;
}
/**
 * A token stream is an array of strings and {@link Token Token} objects.
 *
 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
 * them.
 *
 * 1. No adjacent strings.
 * 2. No empty strings.
 *
 *    The only exception here is the token stream that only contains the empty string and nothing else.
 *
 * @typedef {Array<string | Token>} TokenStream
 * @global
 * @public
 */ /**
 * @param {RegExp} pattern
 * @param {number} pos
 * @param {string} text
 * @param {boolean} lookbehind
 * @returns {RegExpExecArray | null}
 */ function $7272cd95bfd5bc93$var$matchPattern(pattern, pos, text, lookbehind) {
    pattern.lastIndex = pos;
    var match = pattern.exec(text);
    if (match && lookbehind && match[1]) {
        // change the match to remove the text matched by the Prism lookbehind group
        var lookbehindLength = match[1].length;
        match.index += lookbehindLength;
        match[0] = match[0].slice(lookbehindLength);
    }
    return match;
}
/**
 * @param {string} text
 * @param {LinkedList<string | Token>} tokenList
 * @param {any} grammar
 * @param {LinkedListNode<string | Token>} startNode
 * @param {number} startPos
 * @param {RematchOptions} [rematch]
 * @returns {void}
 * @private
 *
 * @typedef RematchOptions
 * @property {string} cause
 * @property {number} reach
 */ function $7272cd95bfd5bc93$var$matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
    for(var token in grammar){
        if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
        var patterns = grammar[token];
        patterns = Array.isArray(patterns) ? patterns : [
            patterns
        ];
        for(var j = 0; j < patterns.length; ++j){
            if (rematch && rematch.cause == token + ',' + j) return;
            var patternObj = patterns[j];
            var inside = patternObj.inside;
            var lookbehind = !!patternObj.lookbehind;
            var greedy = !!patternObj.greedy;
            var alias = patternObj.alias;
            if (greedy && !patternObj.pattern.global) {
                // Without the global flag, lastIndex won't work
                var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
            }
            /** @type {RegExp} */ var pattern = patternObj.pattern || patternObj;
            for(// iterate the token list and keep track of the current token/string position
            var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                if (rematch && pos >= rematch.reach) break;
                var str = currentNode.value;
                if (tokenList.length > text.length) // Something went terribly wrong, ABORT, ABORT!
                return;
                if (str instanceof $7272cd95bfd5bc93$var$Token) continue;
                var removeCount = 1 // this is the to parameter of removeBetween
                ;
                var match;
                if (greedy) {
                    match = $7272cd95bfd5bc93$var$matchPattern(pattern, pos, text, lookbehind);
                    if (!match || match.index >= text.length) break;
                    var from = match.index;
                    var to = match.index + match[0].length;
                    var p = pos;
                    // find the node that contains the match
                    p += currentNode.value.length;
                    while(from >= p){
                        currentNode = currentNode.next;
                        p += currentNode.value.length;
                    }
                    // adjust pos (and p)
                    p -= currentNode.value.length;
                    pos = p;
                    // the current node is a Token, then the match starts inside another Token, which is invalid
                    if (currentNode.value instanceof $7272cd95bfd5bc93$var$Token) continue;
                    // find the last node which is affected by this match
                    for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === 'string'); k = k.next){
                        removeCount++;
                        p += k.value.length;
                    }
                    removeCount--;
                    // replace with the new match
                    str = text.slice(pos, p);
                    match.index -= pos;
                } else {
                    match = $7272cd95bfd5bc93$var$matchPattern(pattern, 0, str, lookbehind);
                    if (!match) continue;
                }
                // eslint-disable-next-line no-redeclare
                var from = match.index;
                var matchStr = match[0];
                var before = str.slice(0, from);
                var after = str.slice(from + matchStr.length);
                var reach = pos + str.length;
                if (rematch && reach > rematch.reach) rematch.reach = reach;
                var removeFrom = currentNode.prev;
                if (before) {
                    removeFrom = $7272cd95bfd5bc93$var$addAfter(tokenList, removeFrom, before);
                    pos += before.length;
                }
                $7272cd95bfd5bc93$var$removeRange(tokenList, removeFrom, removeCount);
                var wrapped = new $7272cd95bfd5bc93$var$Token(token, inside ? $7272cd95bfd5bc93$var$_.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                currentNode = $7272cd95bfd5bc93$var$addAfter(tokenList, removeFrom, wrapped);
                if (after) $7272cd95bfd5bc93$var$addAfter(tokenList, currentNode, after);
                if (removeCount > 1) {
                    // at least one Token object was removed, so we have to do some rematching
                    // this can only happen if the current pattern is greedy
                    /** @type {RematchOptions} */ var nestedRematch = {
                        cause: token + ',' + j,
                        reach: reach
                    };
                    $7272cd95bfd5bc93$var$matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                    // the reach might have been extended because of the rematching
                    if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                }
            }
        }
    }
}
/**
 * @typedef LinkedListNode
 * @property {T} value
 * @property {LinkedListNode<T> | null} prev The previous node.
 * @property {LinkedListNode<T> | null} next The next node.
 * @template T
 * @private
 */ /**
 * @template T
 * @private
 */ function $7272cd95bfd5bc93$var$LinkedList() {
    /** @type {LinkedListNode<T>} */ var head = {
        value: null,
        prev: null,
        next: null
    };
    /** @type {LinkedListNode<T>} */ var tail = {
        value: null,
        prev: head,
        next: null
    };
    head.next = tail;
    /** @type {LinkedListNode<T>} */ this.head = head;
    /** @type {LinkedListNode<T>} */ this.tail = tail;
    this.length = 0;
}
/**
 * Adds a new node with the given value to the list.
 *
 * @param {LinkedList<T>} list
 * @param {LinkedListNode<T>} node
 * @param {T} value
 * @returns {LinkedListNode<T>} The added node.
 * @template T
 */ function $7272cd95bfd5bc93$var$addAfter(list, node, value) {
    // assumes that node != list.tail && values.length >= 0
    var next = node.next;
    var newNode = {
        value: value,
        prev: node,
        next: next
    };
    node.next = newNode;
    next.prev = newNode;
    list.length++;
    return newNode;
}
/**
 * Removes `count` nodes after the given node. The given node will not be removed.
 *
 * @param {LinkedList<T>} list
 * @param {LinkedListNode<T>} node
 * @param {number} count
 * @template T
 */ function $7272cd95bfd5bc93$var$removeRange(list, node, count) {
    var next = node.next;
    for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
    node.next = next;
    next.prev = node;
    list.length -= i;
}
/**
 * @param {LinkedList<T>} list
 * @returns {T[]}
 * @template T
 */ function $7272cd95bfd5bc93$var$toArray(list) {
    var array = [];
    var node = list.head.next;
    while(node !== list.tail){
        array.push(node.value);
        node = node.next;
    }
    return array;
}
const $7272cd95bfd5bc93$export$dc7257ffb0972f87 = $7272cd95bfd5bc93$var$_;


// Inherit.
function $2c82f7cbfe622eb8$var$Refractor() {}
$2c82f7cbfe622eb8$var$Refractor.prototype = (0, $7272cd95bfd5bc93$export$dc7257ffb0972f87);
const $2c82f7cbfe622eb8$export$1c6435d0b8e9f390 = new $2c82f7cbfe622eb8$var$Refractor();
// Create.
$2c82f7cbfe622eb8$export$1c6435d0b8e9f390.highlight = $2c82f7cbfe622eb8$var$highlight;
$2c82f7cbfe622eb8$export$1c6435d0b8e9f390.register = $2c82f7cbfe622eb8$var$register;
$2c82f7cbfe622eb8$export$1c6435d0b8e9f390.alias = $2c82f7cbfe622eb8$var$alias;
$2c82f7cbfe622eb8$export$1c6435d0b8e9f390.registered = $2c82f7cbfe622eb8$var$registered;
$2c82f7cbfe622eb8$export$1c6435d0b8e9f390.listLanguages = $2c82f7cbfe622eb8$var$listLanguages;
// @ts-expect-error Overwrite Prism.
$2c82f7cbfe622eb8$export$1c6435d0b8e9f390.util.encode = $2c82f7cbfe622eb8$var$encode;
// @ts-expect-error Overwrite Prism.
$2c82f7cbfe622eb8$export$1c6435d0b8e9f390.Token.stringify = $2c82f7cbfe622eb8$var$stringify;
/**
 * Highlight `value` (code) as `language` (programming language).
 *
 * @param {string} value
 *   Code to highlight.
 * @param {Grammar | string} language
 *   Programming language name, alias, or grammar.
 * @returns {Root}
 *   Node representing highlighted code.
 */ function $2c82f7cbfe622eb8$var$highlight(value, language) {
    if (typeof value !== 'string') throw new TypeError('Expected `string` for `value`, got `' + value + '`');
    /** @type {Grammar} */ let grammar;
    /** @type {string | undefined} */ let name;
    // `name` is a grammar object.
    // This was called internally by Prism.js before 1.28.0.
    /* c8 ignore next 2 */ if (language && typeof language === 'object') grammar = language;
    else {
        name = language;
        if (typeof name !== 'string') throw new TypeError('Expected `string` for `name`, got `' + name + '`');
        if (Object.hasOwn($2c82f7cbfe622eb8$export$1c6435d0b8e9f390.languages, name)) grammar = $2c82f7cbfe622eb8$export$1c6435d0b8e9f390.languages[name];
        else throw new Error('Unknown language: `' + name + '` is not registered');
    }
    return {
        type: 'root',
        // @ts-expect-error: we hacked Prism to accept and return the things we want.
        children: (0, $7272cd95bfd5bc93$export$dc7257ffb0972f87).highlight.call($2c82f7cbfe622eb8$export$1c6435d0b8e9f390, value, grammar, name)
    };
}
/**
 * Register a syntax.
 *
 * @param {Syntax} syntax
 *   Language function made for refractor, as in, the files in
 *   `refractor/lang/*.js`.
 * @returns {undefined}
 *   Nothing.
 */ function $2c82f7cbfe622eb8$var$register(syntax) {
    if (typeof syntax !== 'function' || !syntax.displayName) throw new Error('Expected `function` for `syntax`, got `' + syntax + '`');
    // Do not duplicate registrations.
    if (!Object.hasOwn($2c82f7cbfe622eb8$export$1c6435d0b8e9f390.languages, syntax.displayName)) syntax($2c82f7cbfe622eb8$export$1c6435d0b8e9f390);
}
/**
 * Register aliases for already registered languages.
 *
 * @param {Record<string, ReadonlyArray<string> | string> | string} language
 *   Language to alias.
 * @param {ReadonlyArray<string> | string | null | undefined} [alias]
 *   Aliases.
 * @returns {undefined}
 *   Nothing.
 */ function $2c82f7cbfe622eb8$var$alias(language, alias) {
    const languages = $2c82f7cbfe622eb8$export$1c6435d0b8e9f390.languages;
    /** @type {Record<string, ReadonlyArray<string> | string>} */ let map = {};
    if (typeof language === 'string') {
        if (alias) map[language] = alias;
    } else map = language;
    /** @type {string} */ let key;
    for(key in map)if (Object.hasOwn(map, key)) {
        const value = map[key];
        const list = typeof value === 'string' ? [
            value
        ] : value;
        let index = -1;
        while(++index < list.length)languages[list[index]] = languages[key];
    }
}
/**
 * Check whether an `alias` or `language` is registered.
 *
 * @param {string} aliasOrLanguage
 *   Language or alias to check.
 * @returns {boolean}
 *   Whether the language is registered.
 */ function $2c82f7cbfe622eb8$var$registered(aliasOrLanguage) {
    if (typeof aliasOrLanguage !== 'string') throw new TypeError('Expected `string` for `aliasOrLanguage`, got `' + aliasOrLanguage + '`');
    return Object.hasOwn($2c82f7cbfe622eb8$export$1c6435d0b8e9f390.languages, aliasOrLanguage);
}
/**
 * List all registered languages (names and aliases).
 *
 * @returns {Array<string>}
 *   List of language names.
 */ function $2c82f7cbfe622eb8$var$listLanguages() {
    const languages = $2c82f7cbfe622eb8$export$1c6435d0b8e9f390.languages;
    /** @type {Array<string>} */ const list = [];
    /** @type {string} */ let language;
    for(language in languages)if (Object.hasOwn(languages, language) && typeof languages[language] === 'object') list.push(language);
    return list;
}
/**
 * @param {Array<_Token | string> | _Token | string} value
 *   Token to stringify.
 * @param {string} language
 *   Language of the token.
 * @returns {Array<Element | Text> | Element | Text}
 *   Node representing the token.
 */ function $2c82f7cbfe622eb8$var$stringify(value, language) {
    if (typeof value === 'string') return {
        type: 'text',
        value: value
    };
    if (Array.isArray(value)) {
        /** @type {Array<Element | Text>} */ const result = [];
        let index = -1;
        while(++index < value.length)if (value[index] !== null && value[index] !== undefined && value[index] !== '') // Cast because we assume no sub-arrays.
        result.push(/** @type {Element | Text} */ $2c82f7cbfe622eb8$var$stringify(value[index], language));
        return result;
    }
    /** @type {_Env} */ const env = {
        attributes: {},
        classes: [
            'token',
            value.type
        ],
        content: $2c82f7cbfe622eb8$var$stringify(value.content, language),
        language: language,
        tag: 'span',
        type: value.type
    };
    if (value.alias) env.classes.push(...typeof value.alias === 'string' ? [
        value.alias
    ] : value.alias);
    // @ts-expect-error Prism.
    $2c82f7cbfe622eb8$export$1c6435d0b8e9f390.hooks.run('wrap', env);
    return (0, $ef6b1b82ffb3458e$export$dda1d9f60106f0e9)(env.tag + '.' + env.classes.join('.'), $2c82f7cbfe622eb8$var$attributes(env.attributes), env.content);
}
/**
 * @template {unknown} T
 *   Tokens.
 * @param {T} tokens
 *   Input.
 * @returns {T}
 *   Output, same as input.
 */ function $2c82f7cbfe622eb8$var$encode(tokens) {
    return tokens;
}
/**
 * @param {Record<string, string>} record
 *   Attributes.
 * @returns {Record<string, string>}
 *   Attributes.
 */ function $2c82f7cbfe622eb8$var$attributes(record) {
    /** @type {string} */ let key;
    for(key in record)if (Object.hasOwn(record, key)) record[key] = (0, $fe979033c71e7672$export$6c6c782be925911c)(record[key]);
    return record;
}


(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f4e156ae6ed8d0a0$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b373cdd06f88d58c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4fe2e947cede365f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $8bc35bfd2be6822a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $803928922a6961a4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f47682e33a093951$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $8467c3aacdff56ee$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $dab2950de0f638d9$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1c0f2e453947e61a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $197381b2d5f39c0b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $49817f5fa65142f2$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $c029552e57eb42d4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $7ca1ade36c00114f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $edb8a8bbc6c61935$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f3a5ce20fdab9e50$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $20b8caf8b024dc15$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $23da19d9f15297a4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1da2260b608e55ec$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $ee5893254ac9a415$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $846ab470db2ff869$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $380e029e8a782237$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $8a2c8b738cd1f636$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4c79b618a588b28d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $781e96ef45d1066d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0814f5761e025965$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $27d87a17c8c1aaf3$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $d4804f7e613d614f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $621160e6c15c3eff$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $eb5bcdfed284c0e2$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $10278687c497f16d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $010d7940936c67fb$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b245c95193e08d8c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $74f53190c8211cce$export$2e2bcd8739ae039));


/**
 * @typedef {import('./core.js').Syntax} Syntax
 */ 




// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $95ea2c9bcdd7f611$export$2e2bcd8739ae039.displayName = 'abap';
$95ea2c9bcdd7f611$export$2e2bcd8739ae039.aliases = [];
function $95ea2c9bcdd7f611$export$2e2bcd8739ae039(Prism) {
    Prism.languages.abap = {
        comment: /^\*.*/m,
        string: /(`|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        'string-template': {
            pattern: /([|}])(?:\\.|[^\\|{\r\n])*(?=[|{])/,
            lookbehind: true,
            alias: 'string'
        },
        /* End Of Line comments should not interfere with strings when the
quote character occurs within them. We assume a string being highlighted
inside an EOL comment is more acceptable than the opposite.
*/ 'eol-comment': {
            pattern: /(^|\s)".*/m,
            lookbehind: true,
            alias: 'comment'
        },
        keyword: {
            pattern: /(\s|\.|^)(?:\*-INPUT|\?TO|ABAP-SOURCE|ABBREVIATED|ABS|ABSTRACT|ACCEPT|ACCEPTING|ACCESSPOLICY|ACCORDING|ACOS|ACTIVATION|ACTUAL|ADD|ADD-CORRESPONDING|ADJACENT|AFTER|ALIAS|ALIASES|ALIGN|ALL|ALLOCATE|ALPHA|ANALYSIS|ANALYZER|AND|ANY|APPEND|APPENDAGE|APPENDING|APPLICATION|ARCHIVE|AREA|ARITHMETIC|AS|ASCENDING|ASIN|ASPECT|ASSERT|ASSIGN|ASSIGNED|ASSIGNING|ASSOCIATION|ASYNCHRONOUS|AT|ATAN|ATTRIBUTES|AUTHORITY|AUTHORITY-CHECK|AVG|BACK|BACKGROUND|BACKUP|BACKWARD|BADI|BASE|BEFORE|BEGIN|BETWEEN|BIG|BINARY|BINDING|BIT|BIT-AND|BIT-NOT|BIT-OR|BIT-XOR|BLACK|BLANK|BLANKS|BLOB|BLOCK|BLOCKS|BLUE|BOUND|BOUNDARIES|BOUNDS|BOXED|BREAK-POINT|BT|BUFFER|BY|BYPASSING|BYTE|BYTE-CA|BYTE-CN|BYTE-CO|BYTE-CS|BYTE-NA|BYTE-NS|BYTE-ORDER|C|CA|CALL|CALLING|CASE|CAST|CASTING|CATCH|CEIL|CENTER|CENTERED|CHAIN|CHAIN-INPUT|CHAIN-REQUEST|CHANGE|CHANGING|CHANNELS|CHAR-TO-HEX|CHARACTER|CHARLEN|CHECK|CHECKBOX|CIRCULAR|CI_|CLASS|CLASS-CODING|CLASS-DATA|CLASS-EVENTS|CLASS-METHODS|CLASS-POOL|CLEANUP|CLEAR|CLIENT|CLOB|CLOCK|CLOSE|CN|CNT|CO|COALESCE|CODE|CODING|COLLECT|COLOR|COLUMN|COLUMNS|COL_BACKGROUND|COL_GROUP|COL_HEADING|COL_KEY|COL_NEGATIVE|COL_NORMAL|COL_POSITIVE|COL_TOTAL|COMMENT|COMMENTS|COMMIT|COMMON|COMMUNICATION|COMPARING|COMPONENT|COMPONENTS|COMPRESSION|COMPUTE|CONCAT|CONCATENATE|COND|CONDENSE|CONDITION|CONNECT|CONNECTION|CONSTANTS|CONTEXT|CONTEXTS|CONTINUE|CONTROL|CONTROLS|CONV|CONVERSION|CONVERT|COPIES|COPY|CORRESPONDING|COS|COSH|COUNT|COUNTRY|COVER|CP|CPI|CREATE|CREATING|CRITICAL|CS|CURRENCY|CURRENCY_CONVERSION|CURRENT|CURSOR|CURSOR-SELECTION|CUSTOMER|CUSTOMER-FUNCTION|DANGEROUS|DATA|DATABASE|DATAINFO|DATASET|DATE|DAYLIGHT|DBMAXLEN|DD\/MM\/YY|DD\/MM\/YYYY|DDMMYY|DEALLOCATE|DECIMALS|DECIMAL_SHIFT|DECLARATIONS|DEEP|DEFAULT|DEFERRED|DEFINE|DEFINING|DEFINITION|DELETE|DELETING|DEMAND|DEPARTMENT|DESCENDING|DESCRIBE|DESTINATION|DETAIL|DIALOG|DIRECTORY|DISCONNECT|DISPLAY|DISPLAY-MODE|DISTANCE|DISTINCT|DIV|DIVIDE|DIVIDE-CORRESPONDING|DIVISION|DO|DUMMY|DUPLICATE|DUPLICATES|DURATION|DURING|DYNAMIC|DYNPRO|E|EACH|EDIT|EDITOR-CALL|ELSE|ELSEIF|EMPTY|ENABLED|ENABLING|ENCODING|END|END-ENHANCEMENT-SECTION|END-LINES|END-OF-DEFINITION|END-OF-FILE|END-OF-PAGE|END-OF-SELECTION|ENDAT|ENDCASE|ENDCATCH|ENDCHAIN|ENDCLASS|ENDDO|ENDENHANCEMENT|ENDEXEC|ENDFOR|ENDFORM|ENDFUNCTION|ENDIAN|ENDIF|ENDING|ENDINTERFACE|ENDLOOP|ENDMETHOD|ENDMODULE|ENDON|ENDPROVIDE|ENDSELECT|ENDTRY|ENDWHILE|ENGINEERING|ENHANCEMENT|ENHANCEMENT-POINT|ENHANCEMENT-SECTION|ENHANCEMENTS|ENTRIES|ENTRY|ENVIRONMENT|EQ|EQUAL|EQUIV|ERRORMESSAGE|ERRORS|ESCAPE|ESCAPING|EVENT|EVENTS|EXACT|EXCEPT|EXCEPTION|EXCEPTION-TABLE|EXCEPTIONS|EXCLUDE|EXCLUDING|EXEC|EXECUTE|EXISTS|EXIT|EXIT-COMMAND|EXP|EXPAND|EXPANDING|EXPIRATION|EXPLICIT|EXPONENT|EXPORT|EXPORTING|EXTEND|EXTENDED|EXTENSION|EXTRACT|FAIL|FETCH|FIELD|FIELD-GROUPS|FIELD-SYMBOL|FIELD-SYMBOLS|FIELDS|FILE|FILTER|FILTER-TABLE|FILTERS|FINAL|FIND|FIRST|FIRST-LINE|FIXED-POINT|FKEQ|FKGE|FLOOR|FLUSH|FONT|FOR|FORM|FORMAT|FORWARD|FOUND|FRAC|FRAME|FRAMES|FREE|FRIENDS|FROM|FUNCTION|FUNCTION-POOL|FUNCTIONALITY|FURTHER|GAPS|GE|GENERATE|GET|GIVING|GKEQ|GKGE|GLOBAL|GRANT|GREATER|GREEN|GROUP|GROUPS|GT|HANDLE|HANDLER|HARMLESS|HASHED|HAVING|HDB|HEAD-LINES|HEADER|HEADERS|HEADING|HELP-ID|HELP-REQUEST|HIDE|HIGH|HINT|HOLD|HOTSPOT|I|ICON|ID|IDENTIFICATION|IDENTIFIER|IDS|IF|IGNORE|IGNORING|IMMEDIATELY|IMPLEMENTATION|IMPLEMENTATIONS|IMPLEMENTED|IMPLICIT|IMPORT|IMPORTING|IN|INACTIVE|INCL|INCLUDE|INCLUDES|INCLUDING|INCREMENT|INDEX|INDEX-LINE|INFOTYPES|INHERITING|INIT|INITIAL|INITIALIZATION|INNER|INOUT|INPUT|INSERT|INSTANCES|INTENSIFIED|INTERFACE|INTERFACE-POOL|INTERFACES|INTERNAL|INTERVALS|INTO|INVERSE|INVERTED-DATE|IS|ISO|ITERATOR|ITNO|JOB|JOIN|KEEP|KEEPING|KERNEL|KEY|KEYS|KEYWORDS|KIND|LANGUAGE|LAST|LATE|LAYOUT|LE|LEADING|LEAVE|LEFT|LEFT-JUSTIFIED|LEFTPLUS|LEFTSPACE|LEGACY|LENGTH|LESS|LET|LEVEL|LEVELS|LIKE|LINE|LINE-COUNT|LINE-SELECTION|LINE-SIZE|LINEFEED|LINES|LIST|LIST-PROCESSING|LISTBOX|LITTLE|LLANG|LOAD|LOAD-OF-PROGRAM|LOB|LOCAL|LOCALE|LOCATOR|LOG|LOG-POINT|LOG10|LOGFILE|LOGICAL|LONG|LOOP|LOW|LOWER|LPAD|LPI|LT|M|MAIL|MAIN|MAJOR-ID|MAPPING|MARGIN|MARK|MASK|MATCH|MATCHCODE|MAX|MAXIMUM|MEDIUM|MEMBERS|MEMORY|MESH|MESSAGE|MESSAGE-ID|MESSAGES|MESSAGING|METHOD|METHODS|MIN|MINIMUM|MINOR-ID|MM\/DD\/YY|MM\/DD\/YYYY|MMDDYY|MOD|MODE|MODIF|MODIFIER|MODIFY|MODULE|MOVE|MOVE-CORRESPONDING|MULTIPLY|MULTIPLY-CORRESPONDING|NA|NAME|NAMETAB|NATIVE|NB|NE|NESTED|NESTING|NEW|NEW-LINE|NEW-PAGE|NEW-SECTION|NEXT|NO|NO-DISPLAY|NO-EXTENSION|NO-GAP|NO-GAPS|NO-GROUPING|NO-HEADING|NO-SCROLLING|NO-SIGN|NO-TITLE|NO-TOPOFPAGE|NO-ZERO|NODE|NODES|NON-UNICODE|NON-UNIQUE|NOT|NP|NS|NULL|NUMBER|NUMOFCHAR|O|OBJECT|OBJECTS|OBLIGATORY|OCCURRENCE|OCCURRENCES|OCCURS|OF|OFF|OFFSET|OLE|ON|ONLY|OPEN|OPTION|OPTIONAL|OPTIONS|OR|ORDER|OTHER|OTHERS|OUT|OUTER|OUTPUT|OUTPUT-LENGTH|OVERFLOW|OVERLAY|PACK|PACKAGE|PAD|PADDING|PAGE|PAGES|PARAMETER|PARAMETER-TABLE|PARAMETERS|PART|PARTIALLY|PATTERN|PERCENTAGE|PERFORM|PERFORMING|PERSON|PF|PF-STATUS|PINK|PLACES|POOL|POSITION|POS_HIGH|POS_LOW|PRAGMAS|PRECOMPILED|PREFERRED|PRESERVING|PRIMARY|PRINT|PRINT-CONTROL|PRIORITY|PRIVATE|PROCEDURE|PROCESS|PROGRAM|PROPERTY|PROTECTED|PROVIDE|PUBLIC|PUSHBUTTON|PUT|QUEUE-ONLY|QUICKINFO|RADIOBUTTON|RAISE|RAISING|RANGE|RANGES|RAW|READ|READ-ONLY|READER|RECEIVE|RECEIVED|RECEIVER|RECEIVING|RED|REDEFINITION|REDUCE|REDUCED|REF|REFERENCE|REFRESH|REGEX|REJECT|REMOTE|RENAMING|REPLACE|REPLACEMENT|REPLACING|REPORT|REQUEST|REQUESTED|RESERVE|RESET|RESOLUTION|RESPECTING|RESPONSIBLE|RESULT|RESULTS|RESUMABLE|RESUME|RETRY|RETURN|RETURNCODE|RETURNING|RIGHT|RIGHT-JUSTIFIED|RIGHTPLUS|RIGHTSPACE|RISK|RMC_COMMUNICATION_FAILURE|RMC_INVALID_STATUS|RMC_SYSTEM_FAILURE|ROLE|ROLLBACK|ROUND|ROWS|RTTI|RUN|SAP|SAP-SPOOL|SAVING|SCALE_PRESERVING|SCALE_PRESERVING_SCIENTIFIC|SCAN|SCIENTIFIC|SCIENTIFIC_WITH_LEADING_ZERO|SCREEN|SCROLL|SCROLL-BOUNDARY|SCROLLING|SEARCH|SECONDARY|SECONDS|SECTION|SELECT|SELECT-OPTIONS|SELECTION|SELECTION-SCREEN|SELECTION-SET|SELECTION-SETS|SELECTION-TABLE|SELECTIONS|SELECTOR|SEND|SEPARATE|SEPARATED|SET|SHARED|SHIFT|SHORT|SHORTDUMP-ID|SIGN|SIGN_AS_POSTFIX|SIMPLE|SIN|SINGLE|SINH|SIZE|SKIP|SKIPPING|SMART|SOME|SORT|SORTABLE|SORTED|SOURCE|SPACE|SPECIFIED|SPLIT|SPOOL|SPOTS|SQL|SQLSCRIPT|SQRT|STABLE|STAMP|STANDARD|START-OF-SELECTION|STARTING|STATE|STATEMENT|STATEMENTS|STATIC|STATICS|STATUSINFO|STEP-LOOP|STOP|STRLEN|STRUCTURE|STRUCTURES|STYLE|SUBKEY|SUBMATCHES|SUBMIT|SUBROUTINE|SUBSCREEN|SUBSTRING|SUBTRACT|SUBTRACT-CORRESPONDING|SUFFIX|SUM|SUMMARY|SUMMING|SUPPLIED|SUPPLY|SUPPRESS|SWITCH|SWITCHSTATES|SYMBOL|SYNCPOINTS|SYNTAX|SYNTAX-CHECK|SYNTAX-TRACE|SYSTEM-CALL|SYSTEM-EXCEPTIONS|SYSTEM-EXIT|TAB|TABBED|TABLE|TABLES|TABLEVIEW|TABSTRIP|TAN|TANH|TARGET|TASK|TASKS|TEST|TESTING|TEXT|TEXTPOOL|THEN|THROW|TIME|TIMES|TIMESTAMP|TIMEZONE|TITLE|TITLE-LINES|TITLEBAR|TO|TOKENIZATION|TOKENS|TOP-LINES|TOP-OF-PAGE|TRACE-FILE|TRACE-TABLE|TRAILING|TRANSACTION|TRANSFER|TRANSFORMATION|TRANSLATE|TRANSPORTING|TRMAC|TRUNC|TRUNCATE|TRUNCATION|TRY|TYPE|TYPE-POOL|TYPE-POOLS|TYPES|ULINE|UNASSIGN|UNDER|UNICODE|UNION|UNIQUE|UNIT|UNIT_CONVERSION|UNIX|UNPACK|UNTIL|UNWIND|UP|UPDATE|UPPER|USER|USER-COMMAND|USING|UTF-8|VALID|VALUE|VALUE-REQUEST|VALUES|VARY|VARYING|VERIFICATION-MESSAGE|VERSION|VIA|VIEW|VISIBLE|WAIT|WARNING|WHEN|WHENEVER|WHERE|WHILE|WIDTH|WINDOW|WINDOWS|WITH|WITH-HEADING|WITH-TITLE|WITHOUT|WORD|WORK|WRITE|WRITER|X|XML|XOR|XSD|XSTRLEN|YELLOW|YES|YYMMDD|Z|ZERO|ZONE)(?![\w-])/i,
            lookbehind: true
        },
        /* Numbers can be only integers. Decimal or Hex appear only as strings */ number: /\b\d+\b/,
        /* Operators must always be surrounded by whitespace, they cannot be put
adjacent to operands.
*/ operator: {
            pattern: /(\s)(?:\*\*?|<[=>]?|>=?|\?=|[-+\/=])(?=\s)/,
            lookbehind: true
        },
        'string-operator': {
            pattern: /(\s)&&?(?=\s)/,
            lookbehind: true,
            /* The official editor highlights */ alias: 'keyword'
        },
        'token-operator': [
            {
                /* Special operators used to access structure components, class methods/attributes, etc. */ pattern: /(\w)(?:->?|=>|[~|{}])(?=\w)/,
                lookbehind: true,
                alias: 'punctuation'
            },
            {
                /* Special tokens used do delimit string templates */ pattern: /[|{}]/,
                alias: 'punctuation'
            }
        ],
        punctuation: /[,.:()]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $c4d1e2daa7d84c8b$export$2e2bcd8739ae039.displayName = 'abnf';
$c4d1e2daa7d84c8b$export$2e2bcd8739ae039.aliases = [];
function $c4d1e2daa7d84c8b$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var coreRules = '(?:ALPHA|BIT|CHAR|CR|CRLF|CTL|DIGIT|DQUOTE|HEXDIG|HTAB|LF|LWSP|OCTET|SP|VCHAR|WSP)';
        Prism.languages.abnf = {
            comment: /;.*/,
            string: {
                pattern: /(?:%[is])?"[^"\n\r]*"/,
                greedy: true,
                inside: {
                    punctuation: /^%[is]/
                }
            },
            range: {
                pattern: /%(?:b[01]+-[01]+|d\d+-\d+|x[A-F\d]+-[A-F\d]+)/i,
                alias: 'number'
            },
            terminal: {
                pattern: /%(?:b[01]+(?:\.[01]+)*|d\d+(?:\.\d+)*|x[A-F\d]+(?:\.[A-F\d]+)*)/i,
                alias: 'number'
            },
            repetition: {
                pattern: /(^|[^\w-])(?:\d*\*\d*|\d+)/,
                lookbehind: true,
                alias: 'operator'
            },
            definition: {
                pattern: /(^[ \t]*)(?:[a-z][\w-]*|<[^<>\r\n]*>)(?=\s*=)/m,
                lookbehind: true,
                alias: 'keyword',
                inside: {
                    punctuation: /<|>/
                }
            },
            'core-rule': {
                pattern: RegExp('(?:(^|[^<\\w-])' + coreRules + '|<' + coreRules + '>)(?![\\w-])', 'i'),
                lookbehind: true,
                alias: [
                    'rule',
                    'constant'
                ],
                inside: {
                    punctuation: /<|>/
                }
            },
            rule: {
                pattern: /(^|[^<\w-])[a-z][\w-]*|<[^<>\r\n]*>/i,
                lookbehind: true,
                inside: {
                    punctuation: /<|>/
                }
            },
            operator: /=\/?|\//,
            punctuation: /[()\[\]]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$0a13ac6a7fcf6722$export$2e2bcd8739ae039.displayName = 'actionscript';
$0a13ac6a7fcf6722$export$2e2bcd8739ae039.aliases = [];
function $0a13ac6a7fcf6722$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
    Prism.languages.actionscript = Prism.languages.extend('javascript', {
        keyword: /\b(?:as|break|case|catch|class|const|default|delete|do|dynamic|each|else|extends|final|finally|for|function|get|if|implements|import|in|include|instanceof|interface|internal|is|namespace|native|new|null|override|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|use|var|void|while|with)\b/,
        operator: /\+\+|--|(?:[+\-*\/%^]|&&?|\|\|?|<<?|>>?>?|[!=]=?)=?|[~?@]/
    });
    Prism.languages.actionscript['class-name'].alias = 'function';
    // doesn't work with AS because AS is too complex
    delete Prism.languages.actionscript['parameter'];
    delete Prism.languages.actionscript['literal-property'];
    if (Prism.languages.markup) Prism.languages.insertBefore('actionscript', 'string', {
        xml: {
            pattern: /(^|[^.])<\/?\w+(?:\s+[^\s>\/=]+=("|')(?:\\[\s\S]|(?!\2)[^\\])*\2)*\s*\/?>/,
            lookbehind: true,
            inside: Prism.languages.markup
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $f7f5127772c5c04e$export$2e2bcd8739ae039.displayName = 'ada';
$f7f5127772c5c04e$export$2e2bcd8739ae039.aliases = [];
function $f7f5127772c5c04e$export$2e2bcd8739ae039(Prism) {
    Prism.languages.ada = {
        comment: /--.*/,
        string: /"(?:""|[^"\r\f\n])*"/,
        number: [
            {
                pattern: /\b\d(?:_?\d)*#[\dA-F](?:_?[\dA-F])*(?:\.[\dA-F](?:_?[\dA-F])*)?#(?:E[+-]?\d(?:_?\d)*)?/i
            },
            {
                pattern: /\b\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:E[+-]?\d(?:_?\d)*)?\b/i
            }
        ],
        attribute: {
            pattern: /\b'\w+/,
            alias: 'attr-name'
        },
        keyword: /\b(?:abort|abs|abstract|accept|access|aliased|all|and|array|at|begin|body|case|constant|declare|delay|delta|digits|do|else|elsif|end|entry|exception|exit|for|function|generic|goto|if|in|interface|is|limited|loop|mod|new|not|null|of|or|others|out|overriding|package|pragma|private|procedure|protected|raise|range|record|rem|renames|requeue|return|reverse|select|separate|some|subtype|synchronized|tagged|task|terminate|then|type|until|use|when|while|with|xor)\b/i,
        boolean: /\b(?:false|true)\b/i,
        operator: /<[=>]?|>=?|=>?|:=|\/=?|\*\*?|[&+-]/,
        punctuation: /\.\.?|[,;():]/,
        char: /'.'/,
        variable: /\b[a-z](?:\w)*\b/i
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $64a4add7c0be4a61$export$2e2bcd8739ae039.displayName = 'agda';
$64a4add7c0be4a61$export$2e2bcd8739ae039.aliases = [];
function $64a4add7c0be4a61$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.agda = {
            comment: /\{-[\s\S]*?(?:-\}|$)|--.*/,
            string: {
                pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
                greedy: true
            },
            punctuation: /[(){}⦃⦄.;@]/,
            'class-name': {
                pattern: /((?:data|record) +)\S+/,
                lookbehind: true
            },
            function: {
                pattern: /(^[ \t]*)(?!\s)[^:\r\n]+(?=:)/m,
                lookbehind: true
            },
            operator: {
                pattern: /(^\s*|\s)(?:[=|:∀→λ\\?_]|->)(?=\s)/,
                lookbehind: true
            },
            keyword: /\b(?:Set|abstract|constructor|data|eta-equality|field|forall|hiding|import|in|inductive|infix|infixl|infixr|instance|let|macro|module|mutual|no-eta-equality|open|overlap|pattern|postulate|primitive|private|public|quote|quoteContext|quoteGoal|quoteTerm|record|renaming|rewrite|syntax|tactic|unquote|unquoteDecl|unquoteDef|using|variable|where|with)\b/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $99775d8f376cb002$export$2e2bcd8739ae039.displayName = 'al';
$99775d8f376cb002$export$2e2bcd8739ae039.aliases = [];
function $99775d8f376cb002$export$2e2bcd8739ae039(Prism) {
    // based on https://github.com/microsoft/AL/blob/master/grammar/alsyntax.tmlanguage
    Prism.languages.al = {
        comment: /\/\/.*|\/\*[\s\S]*?\*\//,
        string: {
            pattern: /'(?:''|[^'\r\n])*'(?!')|"(?:""|[^"\r\n])*"(?!")/,
            greedy: true
        },
        function: {
            pattern: /(\b(?:event|procedure|trigger)\s+|(?:^|[^.])\.\s*)[a-z_]\w*(?=\s*\()/i,
            lookbehind: true
        },
        keyword: [
            // keywords
            /\b(?:array|asserterror|begin|break|case|do|downto|else|end|event|exit|for|foreach|function|if|implements|in|indataset|interface|internal|local|of|procedure|program|protected|repeat|runonclient|securityfiltering|suppressdispose|temporary|then|to|trigger|until|var|while|with|withevents)\b/i,
            // objects and metadata that are used like keywords
            /\b(?:action|actions|addafter|addbefore|addfirst|addlast|area|assembly|chartpart|codeunit|column|controladdin|cuegroup|customizes|dataitem|dataset|dotnet|elements|enum|enumextension|extends|field|fieldattribute|fieldelement|fieldgroup|fieldgroups|fields|filter|fixed|grid|group|key|keys|label|labels|layout|modify|moveafter|movebefore|movefirst|movelast|page|pagecustomization|pageextension|part|profile|query|repeater|report|requestpage|schema|separator|systempart|table|tableelement|tableextension|textattribute|textelement|type|usercontrol|value|xmlport)\b/i
        ],
        number: /\b(?:0x[\da-f]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?)(?:F|LL?|U(?:LL?)?)?\b/i,
        boolean: /\b(?:false|true)\b/i,
        variable: /\b(?:Curr(?:FieldNo|Page|Report)|x?Rec|RequestOptionsPage)\b/,
        'class-name': /\b(?:automation|biginteger|bigtext|blob|boolean|byte|char|clienttype|code|completiontriggererrorlevel|connectiontype|database|dataclassification|datascope|date|dateformula|datetime|decimal|defaultlayout|dialog|dictionary|dotnetassembly|dotnettypedeclaration|duration|errorinfo|errortype|executioncontext|executionmode|fieldclass|fieldref|fieldtype|file|filterpagebuilder|guid|httpclient|httpcontent|httpheaders|httprequestmessage|httpresponsemessage|instream|integer|joker|jsonarray|jsonobject|jsontoken|jsonvalue|keyref|list|moduledependencyinfo|moduleinfo|none|notification|notificationscope|objecttype|option|outstream|pageresult|record|recordid|recordref|reportformat|securityfilter|sessionsettings|tableconnectiontype|tablefilter|testaction|testfield|testfilterfield|testpage|testpermissions|testrequestpage|text|textbuilder|textconst|textencoding|time|transactionmodel|transactiontype|variant|verbosity|version|view|views|webserviceactioncontext|webserviceactionresultcode|xmlattribute|xmlattributecollection|xmlcdata|xmlcomment|xmldeclaration|xmldocument|xmldocumenttype|xmlelement|xmlnamespacemanager|xmlnametable|xmlnode|xmlnodelist|xmlprocessinginstruction|xmlreadoptions|xmltext|xmlwriteoptions)\b/i,
        operator: /\.\.|:[=:]|[-+*/]=?|<>|[<>]=?|=|\b(?:and|div|mod|not|or|xor)\b/i,
        punctuation: /[()\[\]{}:.;,]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $f2801efe566f5e02$export$2e2bcd8739ae039.displayName = 'antlr4';
$f2801efe566f5e02$export$2e2bcd8739ae039.aliases = [
    'g4'
];
function $f2801efe566f5e02$export$2e2bcd8739ae039(Prism) {
    Prism.languages.antlr4 = {
        comment: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
        string: {
            pattern: /'(?:\\.|[^\\'\r\n])*'/,
            greedy: true
        },
        'character-class': {
            pattern: /\[(?:\\.|[^\\\]\r\n])*\]/,
            greedy: true,
            alias: 'regex',
            inside: {
                range: {
                    pattern: /([^[]|(?:^|[^\\])(?:\\\\)*\\\[)-(?!\])/,
                    lookbehind: true,
                    alias: 'punctuation'
                },
                escape: /\\(?:u(?:[a-fA-F\d]{4}|\{[a-fA-F\d]+\})|[pP]\{[=\w-]+\}|[^\r\nupP])/,
                punctuation: /[\[\]]/
            }
        },
        action: {
            pattern: /\{(?:[^{}]|\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*\}/,
            greedy: true,
            inside: {
                content: {
                    // this might be C, C++, Python, Java, C#, or any other language ANTLR4 compiles to
                    pattern: /(\{)[\s\S]+(?=\})/,
                    lookbehind: true
                },
                punctuation: /[{}]/
            }
        },
        command: {
            pattern: /(->\s*(?!\s))(?:\s*(?:,\s*)?\b[a-z]\w*(?:\s*\([^()\r\n]*\))?)+(?=\s*;)/i,
            lookbehind: true,
            inside: {
                function: /\b\w+(?=\s*(?:[,(]|$))/,
                punctuation: /[,()]/
            }
        },
        annotation: {
            pattern: /@\w+(?:::\w+)*/,
            alias: 'keyword'
        },
        label: {
            pattern: /#[ \t]*\w+/,
            alias: 'punctuation'
        },
        keyword: /\b(?:catch|channels|finally|fragment|grammar|import|lexer|locals|mode|options|parser|returns|throws|tokens)\b/,
        definition: [
            {
                pattern: /\b[a-z]\w*(?=\s*:)/,
                alias: [
                    'rule',
                    'class-name'
                ]
            },
            {
                pattern: /\b[A-Z]\w*(?=\s*:)/,
                alias: [
                    'token',
                    'constant'
                ]
            }
        ],
        constant: /\b[A-Z][A-Z_]*\b/,
        operator: /\.\.|->|[|~]|[*+?]\??/,
        punctuation: /[;:()=]/
    };
    Prism.languages.g4 = Prism.languages.antlr4;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $5f9b78712ea78e48$export$2e2bcd8739ae039.displayName = 'apacheconf';
$5f9b78712ea78e48$export$2e2bcd8739ae039.aliases = [];
function $5f9b78712ea78e48$export$2e2bcd8739ae039(Prism) {
    Prism.languages.apacheconf = {
        comment: /#.*/,
        'directive-inline': {
            pattern: /(^[\t ]*)\b(?:AcceptFilter|AcceptPathInfo|AccessFileName|Action|Add(?:Alt|AltByEncoding|AltByType|Charset|DefaultCharset|Description|Encoding|Handler|Icon|IconByEncoding|IconByType|InputFilter|Language|ModuleInfo|OutputFilter|OutputFilterByType|Type)|Alias|AliasMatch|Allow(?:CONNECT|EncodedSlashes|Methods|Override|OverrideList)?|Anonymous(?:_LogEmail|_MustGiveEmail|_NoUserID|_VerifyEmail)?|AsyncRequestWorkerFactor|Auth(?:BasicAuthoritative|BasicFake|BasicProvider|BasicUseDigestAlgorithm|DBDUserPWQuery|DBDUserRealmQuery|DBMGroupFile|DBMType|DBMUserFile|Digest(?:Algorithm|Domain|NonceLifetime|Provider|Qop|ShmemSize)|Form(?:Authoritative|Body|DisableNoStore|FakeBasicAuth|Location|LoginRequiredLocation|LoginSuccessLocation|LogoutLocation|Method|Mimetype|Password|Provider|SitePassphrase|Size|Username)|GroupFile|LDAP(?:AuthorizePrefix|BindAuthoritative|BindDN|BindPassword|CharsetConfig|CompareAsUser|CompareDNOnServer|DereferenceAliases|GroupAttribute|GroupAttributeIsDN|InitialBindAsUser|InitialBindPattern|MaxSubGroupDepth|RemoteUserAttribute|RemoteUserIsDN|SearchAsUser|SubGroupAttribute|SubGroupClass|Url)|Merging|Name|nCache(?:Context|Enable|ProvideFor|SOCache|Timeout)|nzFcgiCheckAuthnProvider|nzFcgiDefineProvider|Type|UserFile|zDBDLoginToReferer|zDBDQuery|zDBDRedirectQuery|zDBMType|zSendForbiddenOnFailure)|BalancerGrowth|BalancerInherit|BalancerMember|BalancerPersist|BrowserMatch|BrowserMatchNoCase|BufferedLogs|BufferSize|Cache(?:DefaultExpire|DetailHeader|DirLength|DirLevels|Disable|Enable|File|Header|IgnoreCacheControl|IgnoreHeaders|IgnoreNoLastMod|IgnoreQueryString|IgnoreURLSessionIdentifiers|KeyBaseURL|LastModifiedFactor|Lock|LockMaxAge|LockPath|MaxExpire|MaxFileSize|MinExpire|MinFileSize|NegotiatedDocs|QuickHandler|ReadSize|ReadTime|Root|Socache(?:MaxSize|MaxTime|MinTime|ReadSize|ReadTime)?|StaleOnError|StoreExpired|StoreNoStore|StorePrivate)|CGIDScriptTimeout|CGIMapExtension|CharsetDefault|CharsetOptions|CharsetSourceEnc|CheckCaseOnly|CheckSpelling|ChrootDir|ContentDigest|CookieDomain|CookieExpires|CookieName|CookieStyle|CookieTracking|CoreDumpDirectory|CustomLog|Dav|DavDepthInfinity|DavGenericLockDB|DavLockDB|DavMinTimeout|DBDExptime|DBDInitSQL|DBDKeep|DBDMax|DBDMin|DBDParams|DBDPersist|DBDPrepareSQL|DBDriver|DefaultIcon|DefaultLanguage|DefaultRuntimeDir|DefaultType|Define|Deflate(?:BufferSize|CompressionLevel|FilterNote|InflateLimitRequestBody|InflateRatio(?:Burst|Limit)|MemLevel|WindowSize)|Deny|DirectoryCheckHandler|DirectoryIndex|DirectoryIndexRedirect|DirectorySlash|DocumentRoot|DTracePrivileges|DumpIOInput|DumpIOOutput|EnableExceptionHook|EnableMMAP|EnableSendfile|Error|ErrorDocument|ErrorLog|ErrorLogFormat|Example|ExpiresActive|ExpiresByType|ExpiresDefault|ExtendedStatus|ExtFilterDefine|ExtFilterOptions|FallbackResource|FileETag|FilterChain|FilterDeclare|FilterProtocol|FilterProvider|FilterTrace|ForceLanguagePriority|ForceType|ForensicLog|GprofDir|GracefulShutdownTimeout|Group|Header|HeaderName|Heartbeat(?:Address|Listen|MaxServers|Storage)|HostnameLookups|IdentityCheck|IdentityCheckTimeout|ImapBase|ImapDefault|ImapMenu|Include|IncludeOptional|Index(?:HeadInsert|Ignore|IgnoreReset|Options|OrderDefault|StyleSheet)|InputSed|ISAPI(?:AppendLogToErrors|AppendLogToQuery|CacheFile|FakeAsync|LogNotSupported|ReadAheadBuffer)|KeepAlive|KeepAliveTimeout|KeptBodySize|LanguagePriority|LDAP(?:CacheEntries|CacheTTL|ConnectionPoolTTL|ConnectionTimeout|LibraryDebug|OpCacheEntries|OpCacheTTL|ReferralHopLimit|Referrals|Retries|RetryDelay|SharedCacheFile|SharedCacheSize|Timeout|TrustedClientCert|TrustedGlobalCert|TrustedMode|VerifyServerCert)|Limit(?:InternalRecursion|Request(?:Body|Fields|FieldSize|Line)|XMLRequestBody)|Listen|ListenBackLog|LoadFile|LoadModule|LogFormat|LogLevel|LogMessage|LuaAuthzProvider|LuaCodeCache|Lua(?:Hook(?:AccessChecker|AuthChecker|CheckUserID|Fixups|InsertFilter|Log|MapToStorage|TranslateName|TypeChecker)|Inherit|InputFilter|MapHandler|OutputFilter|PackageCPath|PackagePath|QuickHandler|Root|Scope)|Max(?:ConnectionsPerChild|KeepAliveRequests|MemFree|RangeOverlaps|RangeReversals|Ranges|RequestWorkers|SpareServers|SpareThreads|Threads)|MergeTrailers|MetaDir|MetaFiles|MetaSuffix|MimeMagicFile|MinSpareServers|MinSpareThreads|MMapFile|ModemStandard|ModMimeUsePathInfo|MultiviewsMatch|Mutex|NameVirtualHost|NoProxy|NWSSLTrustedCerts|NWSSLUpgradeable|Options|Order|OutputSed|PassEnv|PidFile|PrivilegesMode|Protocol|ProtocolEcho|Proxy(?:AddHeaders|BadHeader|Block|Domain|ErrorOverride|ExpressDBMFile|ExpressDBMType|ExpressEnable|FtpDirCharset|FtpEscapeWildcards|FtpListOnWildcard|HTML(?:BufSize|CharsetOut|DocType|Enable|Events|Extended|Fixups|Interp|Links|Meta|StripComments|URLMap)|IOBufferSize|MaxForwards|Pass(?:Inherit|InterpolateEnv|Match|Reverse|ReverseCookieDomain|ReverseCookiePath)?|PreserveHost|ReceiveBufferSize|Remote|RemoteMatch|Requests|SCGIInternalRedirect|SCGISendfile|Set|SourceAddress|Status|Timeout|Via)|ReadmeName|ReceiveBufferSize|Redirect|RedirectMatch|RedirectPermanent|RedirectTemp|ReflectorHeader|RemoteIP(?:Header|InternalProxy|InternalProxyList|ProxiesHeader|TrustedProxy|TrustedProxyList)|RemoveCharset|RemoveEncoding|RemoveHandler|RemoveInputFilter|RemoveLanguage|RemoveOutputFilter|RemoveType|RequestHeader|RequestReadTimeout|Require|Rewrite(?:Base|Cond|Engine|Map|Options|Rule)|RLimitCPU|RLimitMEM|RLimitNPROC|Satisfy|ScoreBoardFile|Script(?:Alias|AliasMatch|InterpreterSource|Log|LogBuffer|LogLength|Sock)?|SecureListen|SeeRequestTail|SendBufferSize|Server(?:Admin|Alias|Limit|Name|Path|Root|Signature|Tokens)|Session(?:Cookie(?:Name|Name2|Remove)|Crypto(?:Cipher|Driver|Passphrase|PassphraseFile)|DBD(?:CookieName|CookieName2|CookieRemove|DeleteLabel|InsertLabel|PerUser|SelectLabel|UpdateLabel)|Env|Exclude|Header|Include|MaxAge)?|SetEnv|SetEnvIf|SetEnvIfExpr|SetEnvIfNoCase|SetHandler|SetInputFilter|SetOutputFilter|SSIEndTag|SSIErrorMsg|SSIETag|SSILastModified|SSILegacyExprParser|SSIStartTag|SSITimeFormat|SSIUndefinedEcho|SSL(?:CACertificateFile|CACertificatePath|CADNRequestFile|CADNRequestPath|CARevocationCheck|CARevocationFile|CARevocationPath|CertificateChainFile|CertificateFile|CertificateKeyFile|CipherSuite|Compression|CryptoDevice|Engine|FIPS|HonorCipherOrder|InsecureRenegotiation|OCSP(?:DefaultResponder|Enable|OverrideResponder|ResponderTimeout|ResponseMaxAge|ResponseTimeSkew|UseRequestNonce)|OpenSSLConfCmd|Options|PassPhraseDialog|Protocol|Proxy(?:CACertificateFile|CACertificatePath|CARevocation(?:Check|File|Path)|CheckPeer(?:CN|Expire|Name)|CipherSuite|Engine|MachineCertificate(?:ChainFile|File|Path)|Protocol|Verify|VerifyDepth)|RandomSeed|RenegBufferSize|Require|RequireSSL|Session(?:Cache|CacheTimeout|TicketKeyFile|Tickets)|SRPUnknownUserSeed|SRPVerifierFile|Stapling(?:Cache|ErrorCacheTimeout|FakeTryLater|ForceURL|ResponderTimeout|ResponseMaxAge|ResponseTimeSkew|ReturnResponderErrors|StandardCacheTimeout)|StrictSNIVHostCheck|UserName|UseStapling|VerifyClient|VerifyDepth)|StartServers|StartThreads|Substitute|Suexec|SuexecUserGroup|ThreadLimit|ThreadsPerChild|ThreadStackSize|TimeOut|TraceEnable|TransferLog|TypesConfig|UnDefine|UndefMacro|UnsetEnv|Use|UseCanonicalName|UseCanonicalPhysicalPort|User|UserDir|VHostCGIMode|VHostCGIPrivs|VHostGroup|VHostPrivs|VHostSecure|VHostUser|Virtual(?:DocumentRoot|ScriptAlias)(?:IP)?|WatchdogInterval|XBitHack|xml2EncAlias|xml2EncDefault|xml2StartParse)\b/im,
            lookbehind: true,
            alias: 'property'
        },
        'directive-block': {
            pattern: /<\/?\b(?:Auth[nz]ProviderAlias|Directory|DirectoryMatch|Else|ElseIf|Files|FilesMatch|If|IfDefine|IfModule|IfVersion|Limit|LimitExcept|Location|LocationMatch|Macro|Proxy|Require(?:All|Any|None)|VirtualHost)\b.*>/i,
            inside: {
                'directive-block': {
                    pattern: /^<\/?\w+/,
                    inside: {
                        punctuation: /^<\/?/
                    },
                    alias: 'tag'
                },
                'directive-block-parameter': {
                    pattern: /.*[^>]/,
                    inside: {
                        punctuation: /:/,
                        string: {
                            pattern: /("|').*\1/,
                            inside: {
                                variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/
                            }
                        }
                    },
                    alias: 'attr-value'
                },
                punctuation: />/
            },
            alias: 'tag'
        },
        'directive-flags': {
            pattern: /\[(?:[\w=],?)+\]/,
            alias: 'keyword'
        },
        string: {
            pattern: /("|').*\1/,
            inside: {
                variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/
            }
        },
        variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/,
        regex: /\^?.*\$|\^.*\$?/
    };
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$c25959ac29c21b23$export$2e2bcd8739ae039.displayName = 'apex';
$c25959ac29c21b23$export$2e2bcd8739ae039.aliases = [];
function $c25959ac29c21b23$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.register((0, $eb5bcdfed284c0e2$export$2e2bcd8739ae039));
    (function(Prism) {
        var keywords = /\b(?:(?:after|before)(?=\s+[a-z])|abstract|activate|and|any|array|as|asc|autonomous|begin|bigdecimal|blob|boolean|break|bulk|by|byte|case|cast|catch|char|class|collect|commit|const|continue|currency|date|datetime|decimal|default|delete|desc|do|double|else|end|enum|exception|exit|export|extends|final|finally|float|for|from|get(?=\s*[{};])|global|goto|group|having|hint|if|implements|import|in|inner|insert|instanceof|int|integer|interface|into|join|like|limit|list|long|loop|map|merge|new|not|null|nulls|number|object|of|on|or|outer|override|package|parallel|pragma|private|protected|public|retrieve|return|rollback|select|set|short|sObject|sort|static|string|super|switch|synchronized|system|testmethod|then|this|throw|time|transaction|transient|trigger|try|undelete|update|upsert|using|virtual|void|webservice|when|where|while|(?:inherited|with|without)\s+sharing)\b/i;
        var className = /\b(?:(?=[a-z_]\w*\s*[<\[])|(?!<keyword>))[A-Z_]\w*(?:\s*\.\s*[A-Z_]\w*)*\b(?:\s*(?:\[\s*\]|<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>))*/.source.replace(/<keyword>/g, function() {
            return keywords.source;
        });
        /** @param {string} pattern */ function insertClassName(pattern) {
            return RegExp(pattern.replace(/<CLASS-NAME>/g, function() {
                return className;
            }), 'i');
        }
        var classNameInside = {
            keyword: keywords,
            punctuation: /[()\[\]{};,:.<>]/
        };
        Prism.languages.apex = {
            comment: Prism.languages.clike.comment,
            string: Prism.languages.clike.string,
            sql: {
                pattern: /((?:[=,({:]|\breturn)\s*)\[[^\[\]]*\]/i,
                lookbehind: true,
                greedy: true,
                alias: 'language-sql',
                inside: Prism.languages.sql
            },
            annotation: {
                pattern: /@\w+\b/,
                alias: 'punctuation'
            },
            'class-name': [
                {
                    pattern: insertClassName(/(\b(?:class|enum|extends|implements|instanceof|interface|new|trigger\s+\w+\s+on)\s+)<CLASS-NAME>/.source),
                    lookbehind: true,
                    inside: classNameInside
                },
                {
                    // cast
                    pattern: insertClassName(/(\(\s*)<CLASS-NAME>(?=\s*\)\s*[\w(])/.source),
                    lookbehind: true,
                    inside: classNameInside
                },
                {
                    // variable/parameter declaration and return types
                    pattern: insertClassName(/<CLASS-NAME>(?=\s*\w+\s*[;=,(){:])/.source),
                    inside: classNameInside
                }
            ],
            trigger: {
                pattern: /(\btrigger\s+)\w+\b/i,
                lookbehind: true,
                alias: 'class-name'
            },
            keyword: keywords,
            function: /\b[a-z_]\w*(?=\s*\()/i,
            boolean: /\b(?:false|true)\b/i,
            number: /(?:\B\.\d+|\b\d+(?:\.\d+|L)?)\b/i,
            operator: /[!=](?:==?)?|\?\.?|&&|\|\||--|\+\+|[-+*/^&|]=?|:|<<?=?|>{1,3}=?/,
            punctuation: /[()\[\]{};,.]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $34c2ee9c440ac9ed$export$2e2bcd8739ae039.displayName = 'apl';
$34c2ee9c440ac9ed$export$2e2bcd8739ae039.aliases = [];
function $34c2ee9c440ac9ed$export$2e2bcd8739ae039(Prism) {
    Prism.languages.apl = {
        comment: /(?:⍝|#[! ]).*$/m,
        string: {
            pattern: /'(?:[^'\r\n]|'')*'/,
            greedy: true
        },
        number: /¯?(?:\d*\.?\b\d+(?:e[+¯]?\d+)?|¯|∞)(?:j¯?(?:(?:\d+(?:\.\d+)?|\.\d+)(?:e[+¯]?\d+)?|¯|∞))?/i,
        statement: /:[A-Z][a-z][A-Za-z]*\b/,
        'system-function': {
            pattern: /⎕[A-Z]+/i,
            alias: 'function'
        },
        constant: /[⍬⌾#⎕⍞]/,
        function: /[-+×÷⌈⌊∣|⍳⍸?*⍟○!⌹<≤=>≥≠≡≢∊⍷∪∩~∨∧⍱⍲⍴,⍪⌽⊖⍉↑↓⊂⊃⊆⊇⌷⍋⍒⊤⊥⍕⍎⊣⊢⍁⍂≈⍯↗¤→]/,
        'monadic-operator': {
            pattern: /[\\\/⌿⍀¨⍨⌶&∥]/,
            alias: 'operator'
        },
        'dyadic-operator': {
            pattern: /[.⍣⍠⍤∘⌸@⌺⍥]/,
            alias: 'operator'
        },
        assignment: {
            pattern: /←/,
            alias: 'keyword'
        },
        punctuation: /[\[;\]()◇⋄]/,
        dfn: {
            pattern: /[{}⍺⍵⍶⍹∇⍫:]/,
            alias: 'builtin'
        }
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $16c57dd521f1a867$export$2e2bcd8739ae039.displayName = 'applescript';
$16c57dd521f1a867$export$2e2bcd8739ae039.aliases = [];
function $16c57dd521f1a867$export$2e2bcd8739ae039(Prism) {
    Prism.languages.applescript = {
        comment: [
            // Allow one level of nesting
            /\(\*(?:\(\*(?:[^*]|\*(?!\)))*\*\)|(?!\(\*)[\s\S])*?\*\)/,
            /--.+/,
            /#.+/
        ],
        string: /"(?:\\.|[^"\\\r\n])*"/,
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e-?\d+)?\b/i,
        operator: [
            /[&=≠≤≥*+\-\/÷^]|[<>]=?/,
            /\b(?:(?:begin|end|start)s? with|(?:contains?|(?:does not|doesn't) contain)|(?:is|isn't|is not) (?:contained by|in)|(?:(?:is|isn't|is not) )?(?:greater|less) than(?: or equal)?(?: to)?|(?:comes|(?:does not|doesn't) come) (?:after|before)|(?:is|isn't|is not) equal(?: to)?|(?:(?:does not|doesn't) equal|equal to|equals|is not|isn't)|(?:a )?(?:ref(?: to)?|reference to)|(?:and|as|div|mod|not|or))\b/
        ],
        keyword: /\b(?:about|above|after|against|apart from|around|aside from|at|back|before|beginning|behind|below|beneath|beside|between|but|by|considering|continue|copy|does|eighth|else|end|equal|error|every|exit|false|fifth|first|for|fourth|from|front|get|given|global|if|ignoring|in|instead of|into|is|it|its|last|local|me|middle|my|ninth|of|on|onto|out of|over|prop|property|put|repeat|return|returning|second|set|seventh|since|sixth|some|tell|tenth|that|the|then|third|through|thru|timeout|times|to|transaction|true|try|until|where|while|whose|with|without)\b/,
        'class-name': /\b(?:POSIX file|RGB color|alias|application|boolean|centimeters|centimetres|class|constant|cubic centimeters|cubic centimetres|cubic feet|cubic inches|cubic meters|cubic metres|cubic yards|date|degrees Celsius|degrees Fahrenheit|degrees Kelvin|feet|file|gallons|grams|inches|integer|kilograms|kilometers|kilometres|list|liters|litres|meters|metres|miles|number|ounces|pounds|quarts|real|record|reference|script|square feet|square kilometers|square kilometres|square meters|square metres|square miles|square yards|text|yards)\b/,
        punctuation: /[{}():,¬«»《》]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $d761452eb924cd1c$export$2e2bcd8739ae039.displayName = 'aql';
$d761452eb924cd1c$export$2e2bcd8739ae039.aliases = [];
function $d761452eb924cd1c$export$2e2bcd8739ae039(Prism) {
    Prism.languages.aql = {
        comment: /\/\/.*|\/\*[\s\S]*?\*\//,
        property: {
            pattern: /([{,]\s*)(?:(?!\d)\w+|(["'´`])(?:(?!\2)[^\\\r\n]|\\.)*\2)(?=\s*:)/,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /(["'])(?:(?!\1)[^\\\r\n]|\\.)*\1/,
            greedy: true
        },
        identifier: {
            pattern: /([´`])(?:(?!\1)[^\\\r\n]|\\.)*\1/,
            greedy: true
        },
        variable: /@@?\w+/,
        keyword: [
            {
                pattern: /(\bWITH\s+)COUNT(?=\s+INTO\b)/i,
                lookbehind: true
            },
            /\b(?:AGGREGATE|ALL|AND|ANY|ASC|COLLECT|DESC|DISTINCT|FILTER|FOR|GRAPH|IN|INBOUND|INSERT|INTO|K_PATHS|K_SHORTEST_PATHS|LET|LIKE|LIMIT|NONE|NOT|NULL|OR|OUTBOUND|REMOVE|REPLACE|RETURN|SHORTEST_PATH|SORT|UPDATE|UPSERT|WINDOW|WITH)\b/i,
            // pseudo keywords get a lookbehind to avoid false positives
            {
                pattern: /(^|[^\w.[])(?:KEEP|PRUNE|SEARCH|TO)\b/i,
                lookbehind: true
            },
            {
                pattern: /(^|[^\w.[])(?:CURRENT|NEW|OLD)\b/,
                lookbehind: true
            },
            {
                pattern: /\bOPTIONS(?=\s*\{)/i
            }
        ],
        function: /\b(?!\d)\w+(?=\s*\()/,
        boolean: /\b(?:false|true)\b/i,
        range: {
            pattern: /\.\./,
            alias: 'operator'
        },
        number: [
            /\b0b[01]+/i,
            /\b0x[0-9a-f]+/i,
            /(?:\B\.\d+|\b(?:0|[1-9]\d*)(?:\.\d+)?)(?:e[+-]?\d+)?/i
        ],
        operator: /\*{2,}|[=!]~|[!=<>]=?|&&|\|\||[-+*/%]/,
        punctuation: /::|[?.:,;()[\]{}]/
    };
}





// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $46893c7fe39cde19$export$2e2bcd8739ae039.displayName = 'arff';
$46893c7fe39cde19$export$2e2bcd8739ae039.aliases = [];
function $46893c7fe39cde19$export$2e2bcd8739ae039(Prism) {
    Prism.languages.arff = {
        comment: /%.*/,
        string: {
            pattern: /(["'])(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        keyword: /@(?:attribute|data|end|relation)\b/i,
        number: /\b\d+(?:\.\d+)?\b/,
        punctuation: /[{},]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $13f495791853dbf3$export$2e2bcd8739ae039.displayName = 'armasm';
$13f495791853dbf3$export$2e2bcd8739ae039.aliases = [
    'arm-asm'
];
function $13f495791853dbf3$export$2e2bcd8739ae039(Prism) {
    Prism.languages.armasm = {
        comment: {
            pattern: /;.*/,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"\r\n]|"")*"/,
            greedy: true,
            inside: {
                variable: {
                    pattern: /((?:^|[^$])(?:\${2})*)\$\w+/,
                    lookbehind: true
                }
            }
        },
        char: {
            pattern: /'(?:[^'\r\n]{0,4}|'')'/,
            greedy: true
        },
        'version-symbol': {
            pattern: /\|[\w@]+\|/,
            greedy: true,
            alias: 'property'
        },
        boolean: /\b(?:FALSE|TRUE)\b/,
        directive: {
            pattern: /\b(?:ALIAS|ALIGN|AREA|ARM|ASSERT|ATTR|CN|CODE|CODE16|CODE32|COMMON|CP|DATA|DCB|DCD|DCDO|DCDU|DCFD|DCFDU|DCI|DCQ|DCQU|DCW|DCWU|DN|ELIF|ELSE|END|ENDFUNC|ENDIF|ENDP|ENTRY|EQU|EXPORT|EXPORTAS|EXTERN|FIELD|FILL|FN|FUNCTION|GBLA|GBLL|GBLS|GET|GLOBAL|IF|IMPORT|INCBIN|INCLUDE|INFO|KEEP|LCLA|LCLL|LCLS|LTORG|MACRO|MAP|MEND|MEXIT|NOFP|OPT|PRESERVE8|PROC|QN|READONLY|RELOC|REQUIRE|REQUIRE8|RLIST|ROUT|SETA|SETL|SETS|SN|SPACE|SUBT|THUMB|THUMBX|TTL|WEND|WHILE)\b/,
            alias: 'property'
        },
        instruction: {
            pattern: /((?:^|(?:^|[^\\])(?:\r\n?|\n))[ \t]*(?:(?:[A-Z][A-Z0-9_]*[a-z]\w*|[a-z]\w*|\d+)[ \t]+)?)\b[A-Z.]+\b/,
            lookbehind: true,
            alias: 'keyword'
        },
        variable: /\$\w+/,
        number: /(?:\b[2-9]_\d+|(?:\b\d+(?:\.\d+)?|\B\.\d+)(?:e-?\d+)?|\b0(?:[fd]_|x)[0-9a-f]+|&[0-9a-f]+)\b/i,
        register: {
            pattern: /\b(?:r\d|lr)\b/,
            alias: 'symbol'
        },
        operator: /<>|<<|>>|&&|\|\||[=!<>/]=?|[+\-*%#?&|^]|:[A-Z]+:/,
        punctuation: /[()[\],]/
    };
    Prism.languages['arm-asm'] = Prism.languages.armasm;
}





// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $93cf65ee58a98ba9$export$2e2bcd8739ae039.displayName = 'arturo';
$93cf65ee58a98ba9$export$2e2bcd8739ae039.aliases = [
    'art'
];
function $93cf65ee58a98ba9$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        /**
     * @param {string} lang
     * @param {string} pattern
     */ var createLanguageString = function(lang, pattern) {
            return {
                pattern: RegExp(/\{!/.source + '(?:' + (pattern || lang) + ')' + /$[\s\S]*\}/.source, 'm'),
                greedy: true,
                inside: {
                    embedded: {
                        pattern: /(^\{!\w+\b)[\s\S]+(?=\}$)/,
                        lookbehind: true,
                        alias: 'language-' + lang,
                        inside: Prism.languages[lang]
                    },
                    string: /[\s\S]+/
                }
            };
        };
        Prism.languages.arturo = {
            comment: {
                pattern: /;.*/,
                greedy: true
            },
            character: {
                pattern: /`.`/,
                alias: 'char',
                greedy: true
            },
            number: {
                pattern: /\b\d+(?:\.\d+(?:\.\d+(?:-[\w+-]+)?)?)?\b/
            },
            string: {
                pattern: /"(?:[^"\\\r\n]|\\.)*"/,
                greedy: true
            },
            regex: {
                pattern: /\{\/.*?\/\}/,
                greedy: true
            },
            'html-string': createLanguageString('html'),
            'css-string': createLanguageString('css'),
            'js-string': createLanguageString('js'),
            'md-string': createLanguageString('md'),
            'sql-string': createLanguageString('sql'),
            'sh-string': createLanguageString('shell', 'sh'),
            multistring: {
                pattern: /».*|\{:[\s\S]*?:\}|\{[\s\S]*?\}|^-{6}$[\s\S]*/m,
                alias: 'string',
                greedy: true
            },
            label: {
                pattern: /\w+\b\??:/,
                alias: 'property'
            },
            literal: {
                pattern: /'(?:\w+\b\??:?)/,
                alias: 'constant'
            },
            type: {
                pattern: /:(?:\w+\b\??:?)/,
                alias: 'class-name'
            },
            color: /#\w+/,
            predicate: {
                pattern: /\b(?:all|and|any|ascii|attr|attribute|attributeLabel|binary|block|char|contains|database|date|dictionary|empty|equal|even|every|exists|false|floating|function|greater|greaterOrEqual|if|in|inline|integer|is|key|label|leap|less|lessOrEqual|literal|logical|lower|nand|negative|nor|not|notEqual|null|numeric|odd|or|path|pathLabel|positive|prefix|prime|regex|same|set|some|sorted|standalone|string|subset|suffix|superset|symbol|symbolLiteral|true|try|type|unless|upper|when|whitespace|word|xnor|xor|zero)\?/,
                alias: 'keyword'
            },
            'builtin-function': {
                pattern: /\b(?:abs|acos|acosh|acsec|acsech|actan|actanh|add|after|alert|alias|and|angle|append|arg|args|arity|array|as|asec|asech|asin|asinh|atan|atan2|atanh|attr|attrs|average|before|benchmark|blend|break|call|capitalize|case|ceil|chop|clear|clip|close|color|combine|conj|continue|copy|cos|cosh|crc|csec|csech|ctan|ctanh|cursor|darken|dec|decode|define|delete|desaturate|deviation|dialog|dictionary|difference|digest|digits|div|do|download|drop|dup|e|else|empty|encode|ensure|env|escape|execute|exit|exp|extend|extract|factors|fdiv|filter|first|flatten|floor|fold|from|function|gamma|gcd|get|goto|hash|hypot|if|inc|indent|index|infinity|info|input|insert|inspect|intersection|invert|jaro|join|keys|kurtosis|last|let|levenshtein|lighten|list|ln|log|loop|lower|mail|map|match|max|median|min|mod|module|mul|nand|neg|new|nor|normalize|not|now|null|open|or|outdent|pad|palette|panic|path|pause|permissions|permutate|pi|pop|popup|pow|powerset|powmod|prefix|print|prints|process|product|query|random|range|read|relative|remove|rename|render|repeat|replace|request|return|reverse|round|sample|saturate|script|sec|sech|select|serve|set|shl|shr|shuffle|sin|sinh|size|skewness|slice|sort|spin|split|sqrt|squeeze|stack|strip|sub|suffix|sum|switch|symbols|symlink|sys|take|tan|tanh|terminal|terminate|to|truncate|try|type|unclip|union|unique|unless|until|unzip|upper|values|var|variance|volume|webview|while|with|wordwrap|write|xnor|xor|zip)\b/,
                alias: 'keyword'
            },
            sugar: {
                pattern: /->|=>|\||::/,
                alias: 'operator'
            },
            punctuation: /[()[\],]/,
            symbol: {
                pattern: /<:|-:|ø|@|#|\+|\||\*|\$|---|-|%|\/|\.\.|\^|~|=|<|>|\\/
            },
            boolean: {
                pattern: /\b(?:false|maybe|true)\b/
            }
        };
        Prism.languages.art = Prism.languages['arturo'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $825a50f0352eefcc$export$2e2bcd8739ae039.displayName = 'asciidoc';
$825a50f0352eefcc$export$2e2bcd8739ae039.aliases = [
    'adoc'
];
function $825a50f0352eefcc$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var attributes = {
            pattern: /(^[ \t]*)\[(?!\[)(?:(["'$`])(?:(?!\2)[^\\]|\\.)*\2|\[(?:[^\[\]\\]|\\.)*\]|[^\[\]\\"'$`]|\\.)*\]/m,
            lookbehind: true,
            inside: {
                quoted: {
                    pattern: /([$`])(?:(?!\1)[^\\]|\\.)*\1/,
                    inside: {
                        punctuation: /^[$`]|[$`]$/
                    }
                },
                interpreted: {
                    pattern: /'(?:[^'\\]|\\.)*'/,
                    inside: {
                        punctuation: /^'|'$/
                    }
                },
                string: /"(?:[^"\\]|\\.)*"/,
                variable: /\w+(?==)/,
                punctuation: /^\[|\]$|,/,
                operator: /=/,
                // The negative look-ahead prevents blank matches
                'attr-value': /(?!^\s+$).+/
            }
        };
        var asciidoc = Prism.languages.asciidoc = {
            'comment-block': {
                pattern: /^(\/{4,})$[\s\S]*?^\1/m,
                alias: 'comment'
            },
            table: {
                pattern: /^\|={3,}(?:(?:\r?\n|\r(?!\n)).*)*?(?:\r?\n|\r)\|={3,}$/m,
                inside: {
                    specifiers: {
                        pattern: /(?:(?:(?:\d+(?:\.\d+)?|\.\d+)[+*](?:[<^>](?:\.[<^>])?|\.[<^>])?|[<^>](?:\.[<^>])?|\.[<^>])[a-z]*|[a-z]+)(?=\|)/,
                        alias: 'attr-value'
                    },
                    punctuation: {
                        pattern: /(^|[^\\])[|!]=*/,
                        lookbehind: true
                    }
                }
            },
            'passthrough-block': {
                pattern: /^(\+{4,})$[\s\S]*?^\1$/m,
                inside: {
                    punctuation: /^\++|\++$/
                }
            },
            // Literal blocks and listing blocks
            'literal-block': {
                pattern: /^(-{4,}|\.{4,})$[\s\S]*?^\1$/m,
                inside: {
                    punctuation: /^(?:-+|\.+)|(?:-+|\.+)$/
                }
            },
            // Sidebar blocks, quote blocks, example blocks and open blocks
            'other-block': {
                pattern: /^(--|\*{4,}|_{4,}|={4,})$[\s\S]*?^\1$/m,
                inside: {
                    punctuation: /^(?:-+|\*+|_+|=+)|(?:-+|\*+|_+|=+)$/
                }
            },
            // list-punctuation and list-label must appear before indented-block
            'list-punctuation': {
                pattern: /(^[ \t]*)(?:-|\*{1,5}|\.{1,5}|(?:[a-z]|\d+)\.|[xvi]+\))(?= )/im,
                lookbehind: true,
                alias: 'punctuation'
            },
            'list-label': {
                pattern: /(^[ \t]*)[a-z\d].+(?::{2,4}|;;)(?=\s)/im,
                lookbehind: true,
                alias: 'symbol'
            },
            'indented-block': {
                pattern: /((\r?\n|\r)\2)([ \t]+)\S.*(?:(?:\r?\n|\r)\3.+)*(?=\2{2}|$)/,
                lookbehind: true
            },
            comment: /^\/\/.*/m,
            title: {
                pattern: /^.+(?:\r?\n|\r)(?:={3,}|-{3,}|~{3,}|\^{3,}|\+{3,})$|^={1,5} .+|^\.(?![\s.]).*/m,
                alias: 'important',
                inside: {
                    punctuation: /^(?:\.|=+)|(?:=+|-+|~+|\^+|\++)$/
                }
            },
            'attribute-entry': {
                pattern: /^:[^:\r\n]+:(?: .*?(?: \+(?:\r?\n|\r).*?)*)?$/m,
                alias: 'tag'
            },
            attributes: attributes,
            hr: {
                pattern: /^'{3,}$/m,
                alias: 'punctuation'
            },
            'page-break': {
                pattern: /^<{3,}$/m,
                alias: 'punctuation'
            },
            admonition: {
                pattern: /^(?:CAUTION|IMPORTANT|NOTE|TIP|WARNING):/m,
                alias: 'keyword'
            },
            callout: [
                {
                    pattern: /(^[ \t]*)<?\d*>/m,
                    lookbehind: true,
                    alias: 'symbol'
                },
                {
                    pattern: /<\d+>/,
                    alias: 'symbol'
                }
            ],
            macro: {
                pattern: /\b[a-z\d][a-z\d-]*::?(?:[^\s\[\]]*\[(?:[^\]\\"']|(["'])(?:(?!\1)[^\\]|\\.)*\1|\\.)*\])/,
                inside: {
                    function: /^[a-z\d-]+(?=:)/,
                    punctuation: /^::?/,
                    attributes: {
                        pattern: /(?:\[(?:[^\]\\"']|(["'])(?:(?!\1)[^\\]|\\.)*\1|\\.)*\])/,
                        inside: attributes.inside
                    }
                }
            },
            inline: {
                /*
The initial look-behind prevents the highlighting of escaped quoted text.
Quoted text can be multi-line but cannot span an empty line.
All quoted text can have attributes before [foobar, 'foobar', baz="bar"].
First, we handle the constrained quotes.
Those must be bounded by non-word chars and cannot have spaces between the delimiter and the first char.
They are, in order: _emphasis_, ``double quotes'', `single quotes', `monospace`, 'emphasis', *strong*, +monospace+ and #unquoted#
Then we handle the unconstrained quotes.
Those do not have the restrictions of the constrained quotes.
They are, in order: __emphasis__, **strong**, ++monospace++, +++passthrough+++, ##unquoted##, $$passthrough$$, ~subscript~, ^superscript^, {attribute-reference}, [[anchor]], [[[bibliography anchor]]], <<xref>>, (((indexes))) and ((indexes))
*/ pattern: /(^|[^\\])(?:(?:\B\[(?:[^\]\\"']|(["'])(?:(?!\2)[^\\]|\\.)*\2|\\.)*\])?(?:\b_(?!\s)(?: _|[^_\\\r\n]|\\.)+(?:(?:\r?\n|\r)(?: _|[^_\\\r\n]|\\.)+)*_\b|\B``(?!\s).+?(?:(?:\r?\n|\r).+?)*''\B|\B`(?!\s)(?:[^`'\s]|\s+\S)+['`]\B|\B(['*+#])(?!\s)(?: \3|(?!\3)[^\\\r\n]|\\.)+(?:(?:\r?\n|\r)(?: \3|(?!\3)[^\\\r\n]|\\.)+)*\3\B)|(?:\[(?:[^\]\\"']|(["'])(?:(?!\4)[^\\]|\\.)*\4|\\.)*\])?(?:(__|\*\*|\+\+\+?|##|\$\$|[~^]).+?(?:(?:\r?\n|\r).+?)*\5|\{[^}\r\n]+\}|\[\[\[?.+?(?:(?:\r?\n|\r).+?)*\]?\]\]|<<.+?(?:(?:\r?\n|\r).+?)*>>|\(\(\(?.+?(?:(?:\r?\n|\r).+?)*\)?\)\)))/m,
                lookbehind: true,
                inside: {
                    attributes: attributes,
                    url: {
                        pattern: /^(?:\[\[\[?.+?\]?\]\]|<<.+?>>)$/,
                        inside: {
                            punctuation: /^(?:\[\[\[?|<<)|(?:\]\]\]?|>>)$/
                        }
                    },
                    'attribute-ref': {
                        pattern: /^\{.+\}$/,
                        inside: {
                            variable: {
                                pattern: /(^\{)[a-z\d,+_-]+/,
                                lookbehind: true
                            },
                            operator: /^[=?!#%@$]|!(?=[:}])/,
                            punctuation: /^\{|\}$|::?/
                        }
                    },
                    italic: {
                        pattern: /^(['_])[\s\S]+\1$/,
                        inside: {
                            punctuation: /^(?:''?|__?)|(?:''?|__?)$/
                        }
                    },
                    bold: {
                        pattern: /^\*[\s\S]+\*$/,
                        inside: {
                            punctuation: /^\*\*?|\*\*?$/
                        }
                    },
                    punctuation: /^(?:``?|\+{1,3}|##?|\$\$|[~^]|\(\(\(?)|(?:''?|\+{1,3}|##?|\$\$|[~^`]|\)?\)\))$/
                }
            },
            replacement: {
                pattern: /\((?:C|R|TM)\)/,
                alias: 'builtin'
            },
            entity: /&#?[\da-z]{1,8};/i,
            'line-continuation': {
                pattern: /(^| )\+$/m,
                lookbehind: true,
                alias: 'punctuation'
            }
        };
        // Allow some nesting. There is no recursion though, so cloning should not be needed.
        function copyFromAsciiDoc(keys) {
            keys = keys.split(' ');
            var o = {};
            for(var i = 0, l = keys.length; i < l; i++)o[keys[i]] = asciidoc[keys[i]];
            return o;
        }
        attributes.inside['interpreted'].inside.rest = copyFromAsciiDoc('macro inline replacement entity');
        asciidoc['passthrough-block'].inside.rest = copyFromAsciiDoc('macro');
        asciidoc['literal-block'].inside.rest = copyFromAsciiDoc('callout');
        asciidoc['table'].inside.rest = copyFromAsciiDoc('comment-block passthrough-block literal-block other-block list-punctuation indented-block comment title attribute-entry attributes hr page-break admonition list-label callout macro inline replacement entity line-continuation');
        asciidoc['other-block'].inside.rest = copyFromAsciiDoc('table list-punctuation indented-block comment attribute-entry attributes hr page-break admonition list-label macro inline replacement entity line-continuation');
        asciidoc['title'].inside.rest = copyFromAsciiDoc('macro inline replacement entity');
        // Plugin to make entity title show the real entity, idea by Roman Komarov
        Prism.hooks.add('wrap', function(env) {
            if (env.type === 'entity') env.attributes['title'] = env.content.value.replace(/&amp;/, '&');
        });
        Prism.languages.adoc = Prism.languages.asciidoc;
    })(Prism);
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$ae7a5bea34c537e5$export$2e2bcd8739ae039.displayName = 'aspnet';
$ae7a5bea34c537e5$export$2e2bcd8739ae039.aliases = [];
function $ae7a5bea34c537e5$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $803928922a6961a4$export$2e2bcd8739ae039));
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    Prism.languages.aspnet = Prism.languages.extend('markup', {
        'page-directive': {
            pattern: /<%\s*@.*%>/,
            alias: 'tag',
            inside: {
                'page-directive': {
                    pattern: /<%\s*@\s*(?:Assembly|Control|Implements|Import|Master(?:Type)?|OutputCache|Page|PreviousPageType|Reference|Register)?|%>/i,
                    alias: 'tag'
                },
                rest: Prism.languages.markup.tag.inside
            }
        },
        directive: {
            pattern: /<%.*%>/,
            alias: 'tag',
            inside: {
                directive: {
                    pattern: /<%\s*?[$=%#:]{0,2}|%>/,
                    alias: 'tag'
                },
                rest: Prism.languages.csharp
            }
        }
    });
    // Regexp copied from prism-markup, with a negative look-ahead added
    Prism.languages.aspnet.tag.pattern = /<(?!%)\/?[^\s>\/]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/;
    // match directives of attribute value foo="<% Bar %>"
    Prism.languages.insertBefore('inside', 'punctuation', {
        directive: Prism.languages.aspnet['directive']
    }, Prism.languages.aspnet.tag.inside['attr-value']);
    Prism.languages.insertBefore('aspnet', 'comment', {
        'asp-comment': {
            pattern: /<%--[\s\S]*?--%>/,
            alias: [
                'asp',
                'comment'
            ]
        }
    });
    // script runat="server" contains csharp, not javascript
    Prism.languages.insertBefore('aspnet', Prism.languages.javascript ? 'script' : 'tag', {
        'asp-script': {
            pattern: /(<script(?=.*runat=['"]?server\b)[^>]*>)[\s\S]*?(?=<\/script>)/i,
            lookbehind: true,
            alias: [
                'asp',
                'script'
            ],
            inside: Prism.languages.csharp || {}
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $bd73346734ce1e3f$export$2e2bcd8739ae039.displayName = 'asm6502';
$bd73346734ce1e3f$export$2e2bcd8739ae039.aliases = [];
function $bd73346734ce1e3f$export$2e2bcd8739ae039(Prism) {
    Prism.languages.asm6502 = {
        comment: /;.*/,
        directive: {
            pattern: /\.\w+(?= )/,
            alias: 'property'
        },
        string: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
        'op-code': {
            pattern: /\b(?:ADC|AND|ASL|BCC|BCS|BEQ|BIT|BMI|BNE|BPL|BRK|BVC|BVS|CLC|CLD|CLI|CLV|CMP|CPX|CPY|DEC|DEX|DEY|EOR|INC|INX|INY|JMP|JSR|LDA|LDX|LDY|LSR|NOP|ORA|PHA|PHP|PLA|PLP|ROL|ROR|RTI|RTS|SBC|SEC|SED|SEI|STA|STX|STY|TAX|TAY|TSX|TXA|TXS|TYA|adc|and|asl|bcc|bcs|beq|bit|bmi|bne|bpl|brk|bvc|bvs|clc|cld|cli|clv|cmp|cpx|cpy|dec|dex|dey|eor|inc|inx|iny|jmp|jsr|lda|ldx|ldy|lsr|nop|ora|pha|php|pla|plp|rol|ror|rti|rts|sbc|sec|sed|sei|sta|stx|sty|tax|tay|tsx|txa|txs|tya)\b/,
            alias: 'keyword'
        },
        'hex-number': {
            pattern: /#?\$[\da-f]{1,4}\b/i,
            alias: 'number'
        },
        'binary-number': {
            pattern: /#?%[01]+\b/,
            alias: 'number'
        },
        'decimal-number': {
            pattern: /#?\b\d+\b/,
            alias: 'number'
        },
        register: {
            pattern: /\b[xya]\b/i,
            alias: 'variable'
        },
        punctuation: /[(),:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $75d197dead828344$export$2e2bcd8739ae039.displayName = 'asmatmel';
$75d197dead828344$export$2e2bcd8739ae039.aliases = [];
function $75d197dead828344$export$2e2bcd8739ae039(Prism) {
    Prism.languages.asmatmel = {
        comment: {
            pattern: /;.*/,
            greedy: true
        },
        string: {
            pattern: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        constant: /\b(?:PORT[A-Z]|DDR[A-Z]|(?:DD|P)[A-Z](?:\d|[0-2]\d|3[01]))\b/,
        directive: {
            pattern: /\.\w+(?= )/,
            alias: 'property'
        },
        'r-register': {
            pattern: /\br(?:\d|[12]\d|3[01])\b/,
            alias: 'variable'
        },
        'op-code': {
            pattern: /\b(?:ADC|ADD|ADIW|AND|ANDI|ASR|BCLR|BLD|BRBC|BRBS|BRCC|BRCS|BREAK|BREQ|BRGE|BRHC|BRHS|BRID|BRIE|BRLO|BRLT|BRMI|BRNE|BRPL|BRSH|BRTC|BRTS|BRVC|BRVS|BSET|BST|CALL|CBI|CBR|CLC|CLH|CLI|CLN|CLR|CLS|CLT|CLV|CLZ|COM|CP|CPC|CPI|CPSE|DEC|DES|EICALL|EIJMP|ELPM|EOR|FMUL|FMULS|FMULSU|ICALL|IJMP|IN|INC|JMP|LAC|LAS|LAT|LD|LD[A-Za-z0-9]|LPM|LSL|LSR|MOV|MOVW|MUL|MULS|MULSU|NEG|NOP|OR|ORI|OUT|POP|PUSH|RCALL|RET|RETI|RJMP|ROL|ROR|SBC|SBCI|SBI|SBIC|SBIS|SBIW|SBR|SBRC|SBRS|SEC|SEH|SEI|SEN|SER|SES|SET|SEV|SEZ|SLEEP|SPM|ST|ST[A-Z0-9]|SUB|SUBI|SWAP|TST|WDR|XCH|adc|add|adiw|and|andi|asr|bclr|bld|brbc|brbs|brcc|brcs|break|breq|brge|brhc|brhs|brid|brie|brlo|brlt|brmi|brne|brpl|brsh|brtc|brts|brvc|brvs|bset|bst|call|cbi|cbr|clc|clh|cli|cln|clr|cls|clt|clv|clz|com|cp|cpc|cpi|cpse|dec|des|eicall|eijmp|elpm|eor|fmul|fmuls|fmulsu|icall|ijmp|in|inc|jmp|lac|las|lat|ld|ld[a-z0-9]|lpm|lsl|lsr|mov|movw|mul|muls|mulsu|neg|nop|or|ori|out|pop|push|rcall|ret|reti|rjmp|rol|ror|sbc|sbci|sbi|sbic|sbis|sbiw|sbr|sbrc|sbrs|sec|seh|sei|sen|ser|ses|set|sev|sez|sleep|spm|st|st[a-zA-Z0-9]|sub|subi|swap|tst|wdr|xch)\b/,
            alias: 'keyword'
        },
        'hex-number': {
            pattern: /#?\$[\da-f]{2,4}\b/i,
            alias: 'number'
        },
        'binary-number': {
            pattern: /#?%[01]+\b/,
            alias: 'number'
        },
        'decimal-number': {
            pattern: /#?\b\d+\b/,
            alias: 'number'
        },
        register: {
            pattern: /\b[acznvshtixy]\b/i,
            alias: 'variable'
        },
        operator: />>=?|<<=?|&[&=]?|\|[\|=]?|[-+*/%^!=<>?]=?/,
        punctuation: /[(),:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $6fdeaba363e1867b$export$2e2bcd8739ae039.displayName = 'autohotkey';
$6fdeaba363e1867b$export$2e2bcd8739ae039.aliases = [];
function $6fdeaba363e1867b$export$2e2bcd8739ae039(Prism) {
    // NOTES - follows first-first highlight method, block is locked after highlight, different from SyntaxHl
    Prism.languages.autohotkey = {
        comment: [
            {
                pattern: /(^|\s);.*/,
                lookbehind: true
            },
            {
                pattern: /(^[\t ]*)\/\*(?:[\r\n](?![ \t]*\*\/)|[^\r\n])*(?:[\r\n][ \t]*\*\/)?/m,
                lookbehind: true,
                greedy: true
            }
        ],
        tag: {
            // labels
            pattern: /^([ \t]*)[^\s,`":]+(?=:[ \t]*$)/m,
            lookbehind: true
        },
        string: /"(?:[^"\n\r]|"")*"/,
        variable: /%\w+%/,
        number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
        operator: /\?|\/\/?=?|:=|\|[=|]?|&[=&]?|\+[=+]?|-[=-]?|\*[=*]?|<(?:<=?|>|=)?|>>?=?|[.^!=~]=?|\b(?:AND|NOT|OR)\b/,
        boolean: /\b(?:false|true)\b/,
        command: {
            pattern: /\b(?:AutoTrim|BlockInput|Break|Click|ClipWait|Continue|Control|ControlClick|ControlFocus|ControlGet|ControlGetFocus|ControlGetPos|ControlGetText|ControlMove|ControlSend|ControlSendRaw|ControlSetText|CoordMode|Critical|DetectHiddenText|DetectHiddenWindows|Drive|DriveGet|DriveSpaceFree|EnvAdd|EnvDiv|EnvGet|EnvMult|EnvSet|EnvSub|EnvUpdate|Exit|ExitApp|FileAppend|FileCopy|FileCopyDir|FileCreateDir|FileCreateShortcut|FileDelete|FileEncoding|FileGetAttrib|FileGetShortcut|FileGetSize|FileGetTime|FileGetVersion|FileInstall|FileMove|FileMoveDir|FileRead|FileReadLine|FileRecycle|FileRecycleEmpty|FileRemoveDir|FileSelectFile|FileSelectFolder|FileSetAttrib|FileSetTime|FormatTime|GetKeyState|Gosub|Goto|GroupActivate|GroupAdd|GroupClose|GroupDeactivate|Gui|GuiControl|GuiControlGet|Hotkey|ImageSearch|IniDelete|IniRead|IniWrite|Input|InputBox|KeyWait|ListHotkeys|ListLines|ListVars|Loop|Menu|MouseClick|MouseClickDrag|MouseGetPos|MouseMove|MsgBox|OnExit|OutputDebug|Pause|PixelGetColor|PixelSearch|PostMessage|Process|Progress|Random|RegDelete|RegRead|RegWrite|Reload|Repeat|Return|Run|RunAs|RunWait|Send|SendEvent|SendInput|SendMessage|SendMode|SendPlay|SendRaw|SetBatchLines|SetCapslockState|SetControlDelay|SetDefaultMouseSpeed|SetEnv|SetFormat|SetKeyDelay|SetMouseDelay|SetNumlockState|SetRegView|SetScrollLockState|SetStoreCapslockMode|SetTimer|SetTitleMatchMode|SetWinDelay|SetWorkingDir|Shutdown|Sleep|Sort|SoundBeep|SoundGet|SoundGetWaveVolume|SoundPlay|SoundSet|SoundSetWaveVolume|SplashImage|SplashTextOff|SplashTextOn|SplitPath|StatusBarGetText|StatusBarWait|StringCaseSense|StringGetPos|StringLeft|StringLen|StringLower|StringMid|StringReplace|StringRight|StringSplit|StringTrimLeft|StringTrimRight|StringUpper|Suspend|SysGet|Thread|ToolTip|Transform|TrayTip|URLDownloadToFile|WinActivate|WinActivateBottom|WinClose|WinGet|WinGetActiveStats|WinGetActiveTitle|WinGetClass|WinGetPos|WinGetText|WinGetTitle|WinHide|WinKill|WinMaximize|WinMenuSelectItem|WinMinimize|WinMinimizeAll|WinMinimizeAllUndo|WinMove|WinRestore|WinSet|WinSetTitle|WinShow|WinWait|WinWaitActive|WinWaitClose|WinWaitNotActive)\b/i,
            alias: 'selector'
        },
        constant: /\b(?:a_ahkpath|a_ahkversion|a_appdata|a_appdatacommon|a_autotrim|a_batchlines|a_caretx|a_carety|a_computername|a_controldelay|a_cursor|a_dd|a_ddd|a_dddd|a_defaultmousespeed|a_desktop|a_desktopcommon|a_detecthiddentext|a_detecthiddenwindows|a_endchar|a_eventinfo|a_exitreason|a_fileencoding|a_formatfloat|a_formatinteger|a_gui|a_guicontrol|a_guicontrolevent|a_guievent|a_guiheight|a_guiwidth|a_guix|a_guiy|a_hour|a_iconfile|a_iconhidden|a_iconnumber|a_icontip|a_index|a_ipaddress1|a_ipaddress2|a_ipaddress3|a_ipaddress4|a_is64bitos|a_isadmin|a_iscompiled|a_iscritical|a_ispaused|a_issuspended|a_isunicode|a_keydelay|a_language|a_lasterror|a_linefile|a_linenumber|a_loopfield|a_loopfileattrib|a_loopfiledir|a_loopfileext|a_loopfilefullpath|a_loopfilelongpath|a_loopfilename|a_loopfileshortname|a_loopfileshortpath|a_loopfilesize|a_loopfilesizekb|a_loopfilesizemb|a_loopfiletimeaccessed|a_loopfiletimecreated|a_loopfiletimemodified|a_loopreadline|a_loopregkey|a_loopregname|a_loopregsubkey|a_loopregtimemodified|a_loopregtype|a_mday|a_min|a_mm|a_mmm|a_mmmm|a_mon|a_mousedelay|a_msec|a_mydocuments|a_now|a_nowutc|a_numbatchlines|a_ostype|a_osversion|a_priorhotkey|a_priorkey|a_programfiles|a_programs|a_programscommon|a_ptrsize|a_regview|a_screendpi|a_screenheight|a_screenwidth|a_scriptdir|a_scriptfullpath|a_scripthwnd|a_scriptname|a_sec|a_space|a_startmenu|a_startmenucommon|a_startup|a_startupcommon|a_stringcasesense|a_tab|a_temp|a_thisfunc|a_thishotkey|a_thislabel|a_thismenu|a_thismenuitem|a_thismenuitempos|a_tickcount|a_timeidle|a_timeidlephysical|a_timesincepriorhotkey|a_timesincethishotkey|a_titlematchmode|a_titlematchmodespeed|a_username|a_wday|a_windelay|a_windir|a_workingdir|a_yday|a_year|a_yweek|a_yyyy|clipboard|clipboardall|comspec|errorlevel|programfiles)\b/i,
        builtin: /\b(?:abs|acos|asc|asin|atan|ceil|chr|class|comobjactive|comobjarray|comobjconnect|comobjcreate|comobjerror|comobjflags|comobjget|comobjquery|comobjtype|comobjvalue|cos|dllcall|exp|fileexist|Fileopen|floor|format|il_add|il_create|il_destroy|instr|isfunc|islabel|IsObject|ln|log|ltrim|lv_add|lv_delete|lv_deletecol|lv_getcount|lv_getnext|lv_gettext|lv_insert|lv_insertcol|lv_modify|lv_modifycol|lv_setimagelist|mod|numget|numput|onmessage|regexmatch|regexreplace|registercallback|round|rtrim|sb_seticon|sb_setparts|sb_settext|sin|sqrt|strlen|strreplace|strsplit|substr|tan|tv_add|tv_delete|tv_get|tv_getchild|tv_getcount|tv_getnext|tv_getparent|tv_getprev|tv_getselection|tv_gettext|tv_modify|varsetcapacity|winactive|winexist|__Call|__Get|__New|__Set)\b/i,
        symbol: /\b(?:alt|altdown|altup|appskey|backspace|browser_back|browser_favorites|browser_forward|browser_home|browser_refresh|browser_search|browser_stop|bs|capslock|ctrl|ctrlbreak|ctrldown|ctrlup|del|delete|down|end|enter|esc|escape|f1|f10|f11|f12|f13|f14|f15|f16|f17|f18|f19|f2|f20|f21|f22|f23|f24|f3|f4|f5|f6|f7|f8|f9|home|ins|insert|joy1|joy10|joy11|joy12|joy13|joy14|joy15|joy16|joy17|joy18|joy19|joy2|joy20|joy21|joy22|joy23|joy24|joy25|joy26|joy27|joy28|joy29|joy3|joy30|joy31|joy32|joy4|joy5|joy6|joy7|joy8|joy9|joyaxes|joybuttons|joyinfo|joyname|joypov|joyr|joyu|joyv|joyx|joyy|joyz|lalt|launch_app1|launch_app2|launch_mail|launch_media|lbutton|lcontrol|lctrl|left|lshift|lwin|lwindown|lwinup|mbutton|media_next|media_play_pause|media_prev|media_stop|numlock|numpad0|numpad1|numpad2|numpad3|numpad4|numpad5|numpad6|numpad7|numpad8|numpad9|numpadadd|numpadclear|numpaddel|numpaddiv|numpaddot|numpaddown|numpadend|numpadenter|numpadhome|numpadins|numpadleft|numpadmult|numpadpgdn|numpadpgup|numpadright|numpadsub|numpadup|pgdn|pgup|printscreen|ralt|rbutton|rcontrol|rctrl|right|rshift|rwin|rwindown|rwinup|scrolllock|shift|shiftdown|shiftup|space|tab|up|volume_down|volume_mute|volume_up|wheeldown|wheelleft|wheelright|wheelup|xbutton1|xbutton2)\b/i,
        directive: {
            pattern: /#[a-z]+\b/i,
            alias: 'important'
        },
        keyword: /\b(?:Abort|AboveNormal|Add|ahk_class|ahk_exe|ahk_group|ahk_id|ahk_pid|All|Alnum|Alpha|AltSubmit|AltTab|AltTabAndMenu|AltTabMenu|AltTabMenuDismiss|AlwaysOnTop|AutoSize|Background|BackgroundTrans|BelowNormal|between|BitAnd|BitNot|BitOr|BitShiftLeft|BitShiftRight|BitXOr|Bold|Border|Button|ByRef|Catch|Checkbox|Checked|CheckedGray|Choose|ChooseString|Close|Color|ComboBox|Contains|ControlList|Count|Date|DateTime|Days|DDL|Default|DeleteAll|Delimiter|Deref|Destroy|Digit|Disable|Disabled|DropDownList|Edit|Eject|Else|Enable|Enabled|Error|Exist|Expand|ExStyle|FileSystem|Finally|First|Flash|Float|FloatFast|Focus|Font|for|global|Grid|Group|GroupBox|GuiClose|GuiContextMenu|GuiDropFiles|GuiEscape|GuiSize|Hdr|Hidden|Hide|High|HKCC|HKCR|HKCU|HKEY_CLASSES_ROOT|HKEY_CURRENT_CONFIG|HKEY_CURRENT_USER|HKEY_LOCAL_MACHINE|HKEY_USERS|HKLM|HKU|Hours|HScroll|Icon|IconSmall|ID|IDLast|If|IfEqual|IfExist|IfGreater|IfGreaterOrEqual|IfInString|IfLess|IfLessOrEqual|IfMsgBox|IfNotEqual|IfNotExist|IfNotInString|IfWinActive|IfWinExist|IfWinNotActive|IfWinNotExist|Ignore|ImageList|in|Integer|IntegerFast|Interrupt|is|italic|Join|Label|LastFound|LastFoundExist|Limit|Lines|List|ListBox|ListView|local|Lock|Logoff|Low|Lower|Lowercase|MainWindow|Margin|Maximize|MaximizeBox|MaxSize|Minimize|MinimizeBox|MinMax|MinSize|Minutes|MonthCal|Mouse|Move|Multi|NA|No|NoActivate|NoDefault|NoHide|NoIcon|NoMainWindow|norm|Normal|NoSort|NoSortHdr|NoStandard|Not|NoTab|NoTimers|Number|Off|Ok|On|OwnDialogs|Owner|Parse|Password|Picture|Pixel|Pos|Pow|Priority|ProcessName|Radio|Range|Read|ReadOnly|Realtime|Redraw|Region|REG_BINARY|REG_DWORD|REG_EXPAND_SZ|REG_MULTI_SZ|REG_SZ|Relative|Rename|Report|Resize|Restore|Retry|RGB|Screen|Seconds|Section|Serial|SetLabel|ShiftAltTab|Show|Single|Slider|SortDesc|Standard|static|Status|StatusBar|StatusCD|strike|Style|Submit|SysMenu|Tab2|TabStop|Text|Theme|Throw|Tile|ToggleCheck|ToggleEnable|ToolWindow|Top|Topmost|TransColor|Transparent|Tray|TreeView|Try|TryAgain|Type|UnCheck|underline|Unicode|Unlock|Until|UpDown|Upper|Uppercase|UseErrorLevel|Vis|VisFirst|Visible|VScroll|Wait|WaitClose|WantCtrlA|WantF2|WantReturn|While|Wrap|Xdigit|xm|xp|xs|Yes|ym|yp|ys)\b/i,
        function: /[^(); \t,\n+*\-=?>:\\\/<&%\[\]]+(?=\()/,
        punctuation: /[{}[\]():,]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $b9409e2dd4b1f152$export$2e2bcd8739ae039.displayName = 'autoit';
$b9409e2dd4b1f152$export$2e2bcd8739ae039.aliases = [];
function $b9409e2dd4b1f152$export$2e2bcd8739ae039(Prism) {
    Prism.languages.autoit = {
        comment: [
            /;.*/,
            {
                // The multi-line comments delimiters can actually be commented out with ";"
                pattern: /(^[\t ]*)#(?:comments-start|cs)[\s\S]*?^[ \t]*#(?:ce|comments-end)/m,
                lookbehind: true
            }
        ],
        url: {
            pattern: /(^[\t ]*#include\s+)(?:<[^\r\n>]+>|"[^\r\n"]+")/m,
            lookbehind: true
        },
        string: {
            pattern: /(["'])(?:\1\1|(?!\1)[^\r\n])*\1/,
            greedy: true,
            inside: {
                variable: /([%$@])\w+\1/
            }
        },
        directive: {
            pattern: /(^[\t ]*)#[\w-]+/m,
            lookbehind: true,
            alias: 'keyword'
        },
        function: /\b\w+(?=\()/,
        // Variables and macros
        variable: /[$@]\w+/,
        keyword: /\b(?:Case|Const|Continue(?:Case|Loop)|Default|Dim|Do|Else(?:If)?|End(?:Func|If|Select|Switch|With)|Enum|Exit(?:Loop)?|For|Func|Global|If|In|Local|Next|Null|ReDim|Select|Static|Step|Switch|Then|To|Until|Volatile|WEnd|While|With)\b/i,
        number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i,
        boolean: /\b(?:False|True)\b/i,
        operator: /<[=>]?|[-+*\/=&>]=?|[?^]|\b(?:And|Not|Or)\b/i,
        punctuation: /[\[\]().,:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $5a70a1b33a6cef7a$export$2e2bcd8739ae039.displayName = 'avisynth';
$5a70a1b33a6cef7a$export$2e2bcd8739ae039.aliases = [
    'avs'
];
function $5a70a1b33a6cef7a$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        function replace(pattern, replacements) {
            return pattern.replace(/<<(\d+)>>/g, function(m, index) {
                return replacements[+index];
            });
        }
        function re(pattern, replacements, flags) {
            return RegExp(replace(pattern, replacements), flags || '');
        }
        var types = /bool|clip|float|int|string|val/.source;
        var internals = [
            // bools
            /is(?:bool|clip|float|int|string)|defined|(?:(?:internal)?function|var)?exists?/.source,
            // control
            /apply|assert|default|eval|import|nop|select|undefined/.source,
            // global
            /opt_(?:allowfloataudio|avipadscanlines|dwchannelmask|enable_(?:b64a|planartopackedrgb|v210|y3_10_10|y3_10_16)|usewaveextensible|vdubplanarhack)|set(?:cachemode|maxcpu|memorymax|planarlegacyalignment|workingdir)/.source,
            // conv
            /hex(?:value)?|value/.source,
            // numeric
            /abs|ceil|continued(?:denominator|numerator)?|exp|floor|fmod|frac|log(?:10)?|max|min|muldiv|pi|pow|rand|round|sign|spline|sqrt/.source,
            // trig
            /a?sinh?|a?cosh?|a?tan[2h]?/.source,
            // bit
            /(?:bit(?:and|not|x?or|[lr]?shift[aslu]?|sh[lr]|sa[lr]|[lr]rotatel?|ro[rl]|te?st|set(?:count)?|cl(?:ea)?r|ch(?:an)?ge?))/.source,
            // runtime
            /average(?:[bgr]|chroma[uv]|luma)|(?:[rgb]|chroma[uv]|luma|rgb|[yuv](?=difference(?:fromprevious|tonext)))difference(?:fromprevious|tonext)?|[yuvrgb]plane(?:median|min|max|minmaxdifference)/.source,
            // script
            /getprocessinfo|logmsg|script(?:dir(?:utf8)?|file(?:utf8)?|name(?:utf8)?)|setlogparams/.source,
            // string
            /chr|(?:fill|find|left|mid|replace|rev|right)str|format|[lu]case|ord|str(?:cmpi?|fromutf8|len|toutf8)|time|trim(?:all|left|right)/.source,
            // version
            /isversionorgreater|version(?:number|string)/.source,
            // helper
            /buildpixeltype|colorspacenametopixeltype/.source,
            // avsplus
            /addautoloaddir|on(?:cpu|cuda)|prefetch|setfiltermtmode/.source
        ].join('|');
        var properties = [
            // content
            /has(?:audio|video)/.source,
            // resolution
            /height|width/.source,
            // framerate
            /frame(?:count|rate)|framerate(?:denominator|numerator)/.source,
            // interlacing
            /getparity|is(?:field|frame)based/.source,
            // color format
            /bitspercomponent|componentsize|hasalpha|is(?:planar(?:rgba?)?|interleaved|rgb(?:24|32|48|64)?|y(?:8|u(?:va?|y2))?|yv(?:12|16|24|411)|420|422|444|packedrgb)|numcomponents|pixeltype/.source,
            // audio
            /audio(?:bits|channels|duration|length(?:[fs]|hi|lo)?|rate)|isaudio(?:float|int)/.source
        ].join('|');
        var filters = [
            // source
            /avi(?:file)?source|directshowsource|image(?:reader|source|sourceanim)|opendmlsource|segmented(?:avisource|directshowsource)|wavsource/.source,
            // color
            /coloryuv|convertbacktoyuy2|convertto(?:RGB(?:24|32|48|64)|(?:planar)?RGBA?|Y8?|YV(?:12|16|24|411)|YUVA?(?:411|420|422|444)|YUY2)|fixluminance|gr[ae]yscale|invert|levels|limiter|mergea?rgb|merge(?:chroma|luma)|rgbadjust|show(?:alpha|blue|green|red)|swapuv|tweak|[uv]toy8?|ytouv/.source,
            // overlay
            /(?:colorkey|reset)mask|layer|mask(?:hs)?|merge|overlay|subtract/.source,
            // geometry
            /addborders|(?:bicubic|bilinear|blackman|gauss|lanczos4|lanczos|point|sinc|spline(?:16|36|64))resize|crop(?:bottom)?|flip(?:horizontal|vertical)|(?:horizontal|vertical)?reduceby2|letterbox|skewrows|turn(?:180|left|right)/.source,
            // pixel
            /blur|fixbrokenchromaupsampling|generalconvolution|(?:spatial|temporal)soften|sharpen/.source,
            // timeline
            /trim|(?:un)?alignedsplice|(?:assume|assumescaled|change|convert)FPS|(?:delete|duplicate)frame|dissolve|fade(?:in|io|out)[02]?|freezeframe|interleave|loop|reverse|select(?:even|odd|(?:range)?every)/.source,
            // interlace
            /assume[bt]ff|assume(?:field|frame)based|bob|complementparity|doubleweave|peculiarblend|pulldown|separate(?:columns|fields|rows)|swapfields|weave(?:columns|rows)?/.source,
            // audio
            /amplify(?:db)?|assumesamplerate|audiodub(?:ex)?|audiotrim|convertaudioto(?:(?:8|16|24|32)bit|float)|converttomono|delayaudio|ensurevbrmp3sync|get(?:left|right)?channel|kill(?:audio|video)|mergechannels|mixaudio|monotostereo|normalize|resampleaudio|ssrc|supereq|timestretch/.source,
            // conditional
            /animate|applyrange|conditional(?:filter|reader|select)|frameevaluate|scriptclip|tcp(?:server|source)|writefile(?:end|if|start)?/.source,
            // export
            /imagewriter/.source,
            // debug
            /blackness|blankclip|colorbars(?:hd)?|compare|dumpfiltergraph|echo|histogram|info|messageclip|preroll|setgraphanalysis|show(?:framenumber|smpte|time)|showfiveversions|stack(?:horizontal|vertical)|subtitle|tone|version/.source
        ].join('|');
        var allinternals = [
            internals,
            properties,
            filters
        ].join('|');
        Prism.languages.avisynth = {
            comment: [
                {
                    // Matches [* *] nestable block comments, but only supports 1 level of nested comments
                    // /\[\*(?:[^\[*]|\[(?!\*)|\*(?!\])|<self>)*\*\]/
                    pattern: /(^|[^\\])\[\*(?:[^\[*]|\[(?!\*)|\*(?!\])|\[\*(?:[^\[*]|\[(?!\*)|\*(?!\]))*\*\])*\*\]/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    // Matches /* */ block comments
                    pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    // Matches # comments
                    pattern: /(^|[^\\$])#.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            // Handle before strings because optional arguments are surrounded by double quotes
            argument: {
                pattern: re(/\b(?:<<0>>)\s+("?)\w+\1/.source, [
                    types
                ], 'i'),
                inside: {
                    keyword: /^\w+/
                }
            },
            // Optional argument assignment
            'argument-label': {
                pattern: /([,(][\s\\]*)\w+\s*=(?!=)/,
                lookbehind: true,
                inside: {
                    'argument-name': {
                        pattern: /^\w+/,
                        alias: 'punctuation'
                    },
                    punctuation: /=$/
                }
            },
            string: [
                {
                    // triple double-quoted
                    pattern: /"""[\s\S]*?"""/,
                    greedy: true
                },
                {
                    // single double-quoted
                    pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
                    greedy: true,
                    inside: {
                        constant: {
                            // These *are* case-sensitive!
                            pattern: /\b(?:DEFAULT_MT_MODE|(?:MAINSCRIPT|PROGRAM|SCRIPT)DIR|(?:MACHINE|USER)_(?:CLASSIC|PLUS)_PLUGINS)\b/
                        }
                    }
                }
            ],
            // The special "last" variable that takes the value of the last implicitly returned clip
            variable: /\b(?:last)\b/i,
            boolean: /\b(?:false|no|true|yes)\b/i,
            keyword: /\b(?:catch|else|for|function|global|if|return|try|while|__END__)\b/i,
            constant: /\bMT_(?:MULTI_INSTANCE|NICE_FILTER|SERIALIZED|SPECIAL_MT)\b/,
            // AviSynth's internal functions, filters, and properties
            'builtin-function': {
                pattern: re(/\b(?:<<0>>)\b/.source, [
                    allinternals
                ], 'i'),
                alias: 'function'
            },
            'type-cast': {
                pattern: re(/\b(?:<<0>>)(?=\s*\()/.source, [
                    types
                ], 'i'),
                alias: 'keyword'
            },
            // External/user-defined filters
            function: {
                pattern: /\b[a-z_]\w*(?=\s*\()|(\.)[a-z_]\w*\b/i,
                lookbehind: true
            },
            // Matches a \ as the first or last character on a line
            'line-continuation': {
                pattern: /(^[ \t]*)\\|\\(?=[ \t]*$)/m,
                lookbehind: true,
                alias: 'punctuation'
            },
            number: /\B\$(?:[\da-f]{6}|[\da-f]{8})\b|(?:(?:\b|\B-)\d+(?:\.\d*)?\b|\B\.\d+\b)/i,
            operator: /\+\+?|[!=<>]=?|&&|\|\||[?:*/%-]/,
            punctuation: /[{}\[\]();,.]/
        };
        Prism.languages.avs = Prism.languages.avisynth;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $fde5bd5d73cb6997$export$2e2bcd8739ae039.displayName = 'avro-idl';
$fde5bd5d73cb6997$export$2e2bcd8739ae039.aliases = [
    'avdl'
];
function $fde5bd5d73cb6997$export$2e2bcd8739ae039(Prism) {
    // GitHub: https://github.com/apache/avro
    // Docs: https://avro.apache.org/docs/current/idl.html
    Prism.languages['avro-idl'] = {
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])"(?:[^\r\n"\\]|\\.)*"/,
            lookbehind: true,
            greedy: true
        },
        annotation: {
            pattern: /@(?:[$\w.-]|`[^\r\n`]+`)+/,
            greedy: true,
            alias: 'function'
        },
        'function-identifier': {
            pattern: /`[^\r\n`]+`(?=\s*\()/,
            greedy: true,
            alias: 'function'
        },
        identifier: {
            pattern: /`[^\r\n`]+`/,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:enum|error|protocol|record|throws)\b\s+)[$\w]+/,
            lookbehind: true,
            greedy: true
        },
        keyword: /\b(?:array|boolean|bytes|date|decimal|double|enum|error|false|fixed|float|idl|import|int|local_timestamp_ms|long|map|null|oneway|protocol|record|schema|string|throws|time_ms|timestamp_ms|true|union|uuid|void)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: [
            {
                pattern: /(^|[^\w.])-?(?:(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|0x(?:[a-f0-9]+(?:\.[a-f0-9]*)?|\.[a-f0-9]+)(?:p[+-]?\d+)?)[dfl]?(?![\w.])/i,
                lookbehind: true
            },
            /-?\b(?:Infinity|NaN)\b/
        ],
        operator: /=/,
        punctuation: /[()\[\]{}<>.:,;-]/
    };
    Prism.languages.avdl = Prism.languages['avro-idl'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $c23e2e2dfd81122c$export$2e2bcd8739ae039.displayName = 'awk';
$c23e2e2dfd81122c$export$2e2bcd8739ae039.aliases = [
    'gawk'
];
function $c23e2e2dfd81122c$export$2e2bcd8739ae039(Prism) {
    Prism.languages.awk = {
        hashbang: {
            pattern: /^#!.*/,
            greedy: true,
            alias: 'comment'
        },
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])"(?:[^\\"\r\n]|\\.)*"/,
            lookbehind: true,
            greedy: true
        },
        regex: {
            pattern: /((?:^|[^\w\s)])\s*)\/(?:[^\/\\\r\n]|\\.)*\//,
            lookbehind: true,
            greedy: true
        },
        variable: /\$\w+/,
        keyword: /\b(?:BEGIN|BEGINFILE|END|ENDFILE|break|case|continue|default|delete|do|else|exit|for|function|getline|if|in|next|nextfile|printf?|return|switch|while)\b|@(?:include|load)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0x[a-fA-F0-9]+)\b/,
        operator: /--|\+\+|!?~|>&|>>|<<|(?:\*\*|[<>!=+\-*/%^])=?|&&|\|[|&]|[?:]/,
        punctuation: /[()[\]{},;]/
    };
    Prism.languages.gawk = Prism.languages.awk;
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $f1ff25d1ebcd6cac$export$2e2bcd8739ae039.displayName = 'batch';
$f1ff25d1ebcd6cac$export$2e2bcd8739ae039.aliases = [];
function $f1ff25d1ebcd6cac$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var variable = /%%?[~:\w]+%?|!\S+!/;
        var parameter = {
            pattern: /\/[a-z?]+(?=[ :]|$):?|-[a-z]\b|--[a-z-]+\b/im,
            alias: 'attr-name',
            inside: {
                punctuation: /:/
            }
        };
        var string = /"(?:[\\"]"|[^"])*"(?!")/;
        var number = /(?:\b|-)\d+\b/;
        Prism.languages.batch = {
            comment: [
                /^::.*/m,
                {
                    pattern: /((?:^|[&(])[ \t]*)rem\b(?:[^^&)\r\n]|\^(?:\r\n|[\s\S]))*/im,
                    lookbehind: true
                }
            ],
            label: {
                pattern: /^:.*/m,
                alias: 'property'
            },
            command: [
                {
                    // FOR command
                    pattern: /((?:^|[&(])[ \t]*)for(?: \/[a-z?](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* \S+ in \([^)]+\) do/im,
                    lookbehind: true,
                    inside: {
                        keyword: /\b(?:do|in)\b|^for\b/i,
                        string: string,
                        parameter: parameter,
                        variable: variable,
                        number: number,
                        punctuation: /[()',]/
                    }
                },
                {
                    // IF command
                    pattern: /((?:^|[&(])[ \t]*)if(?: \/[a-z?](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* (?:not )?(?:cmdextversion \d+|defined \w+|errorlevel \d+|exist \S+|(?:"[^"]*"|(?!")(?:(?!==)\S)+)?(?:==| (?:equ|geq|gtr|leq|lss|neq) )(?:"[^"]*"|[^\s"]\S*))/im,
                    lookbehind: true,
                    inside: {
                        keyword: /\b(?:cmdextversion|defined|errorlevel|exist|not)\b|^if\b/i,
                        string: string,
                        parameter: parameter,
                        variable: variable,
                        number: number,
                        operator: /\^|==|\b(?:equ|geq|gtr|leq|lss|neq)\b/i
                    }
                },
                {
                    // ELSE command
                    pattern: /((?:^|[&()])[ \t]*)else\b/im,
                    lookbehind: true,
                    inside: {
                        keyword: /^else\b/i
                    }
                },
                {
                    // SET command
                    pattern: /((?:^|[&(])[ \t]*)set(?: \/[a-z](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* (?:[^^&)\r\n]|\^(?:\r\n|[\s\S]))*/im,
                    lookbehind: true,
                    inside: {
                        keyword: /^set\b/i,
                        string: string,
                        parameter: parameter,
                        variable: [
                            variable,
                            /\w+(?=(?:[*\/%+\-&^|]|<<|>>)?=)/
                        ],
                        number: number,
                        operator: /[*\/%+\-&^|]=?|<<=?|>>=?|[!~_=]/,
                        punctuation: /[()',]/
                    }
                },
                {
                    // Other commands
                    pattern: /((?:^|[&(])[ \t]*@?)\w+\b(?:"(?:[\\"]"|[^"])*"(?!")|[^"^&)\r\n]|\^(?:\r\n|[\s\S]))*/m,
                    lookbehind: true,
                    inside: {
                        keyword: /^\w+\b/,
                        string: string,
                        parameter: parameter,
                        label: {
                            pattern: /(^\s*):\S+/m,
                            lookbehind: true,
                            alias: 'property'
                        },
                        variable: variable,
                        number: number,
                        operator: /\^/
                    }
                }
            ],
            operator: /[&@]/,
            punctuation: /[()']/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $92013590b857bd88$export$2e2bcd8739ae039.displayName = 'bbcode';
$92013590b857bd88$export$2e2bcd8739ae039.aliases = [
    'shortcode'
];
function $92013590b857bd88$export$2e2bcd8739ae039(Prism) {
    Prism.languages.bbcode = {
        tag: {
            pattern: /\[\/?[^\s=\]]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+))?(?:\s+[^\s=\]]+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+))*\s*\]/,
            inside: {
                tag: {
                    pattern: /^\[\/?[^\s=\]]+/,
                    inside: {
                        punctuation: /^\[\/?/
                    }
                },
                'attr-value': {
                    pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+)/,
                    inside: {
                        punctuation: [
                            /^=/,
                            {
                                pattern: /^(\s*)["']|["']$/,
                                lookbehind: true
                            }
                        ]
                    }
                },
                punctuation: /\]/,
                'attr-name': /[^\s=\]]+/
            }
        }
    };
    Prism.languages.shortcode = Prism.languages.bbcode;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $d4e3d605b49454d4$export$2e2bcd8739ae039.displayName = 'bbj';
$d4e3d605b49454d4$export$2e2bcd8739ae039.aliases = [];
function $d4e3d605b49454d4$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.bbj = {
            comment: {
                pattern: /(^|[^\\:])rem\s+.*/i,
                lookbehind: true,
                greedy: true
            },
            string: {
                pattern: /(['"])(?:(?!\1|\\).|\\.)*\1/,
                greedy: true
            },
            number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
            keyword: /\b(?:abstract|all|argc|begin|bye|callback|case|chn|class|classend|ctl|day|declare|delete|dim|dom|dread|dsz|else|end|endif|err|exitto|extends|fi|field|for|from|gosub|goto|if|implements|interface|interfaceend|iol|iolist|let|list|load|method|methodend|methodret|on|opts|pfx|print|private|process_events|protected|psz|public|read|read_resource|release|remove_callback|repeat|restore|return|rev|seterr|setesc|sqlchn|sqlunt|ssn|start|static|swend|switch|sys|then|tim|unt|until|use|void|wend|where|while)\b/i,
            function: /\b\w+(?=\()/,
            boolean: /\b(?:BBjAPI\.TRUE|BBjAPI\.FALSE)\b/i,
            operator: /<[=>]?|>=?|[+\-*\/^=&]|\b(?:and|not|or|xor)\b/i,
            punctuation: /[.,;:()]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $26acd6c806290335$export$2e2bcd8739ae039.displayName = 'bicep';
$26acd6c806290335$export$2e2bcd8739ae039.aliases = [];
function $26acd6c806290335$export$2e2bcd8739ae039(Prism) {
    // based loosely upon: https://github.com/Azure/bicep/blob/main/src/textmate/bicep.tmlanguage
    Prism.languages.bicep = {
        comment: [
            {
                // multiline comments eg /* ASDF */
                pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                lookbehind: true,
                greedy: true
            },
            {
                // singleline comments eg // ASDF
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        property: [
            {
                pattern: /([\r\n][ \t]*)[a-z_]\w*(?=[ \t]*:)/i,
                lookbehind: true
            },
            {
                pattern: /([\r\n][ \t]*)'(?:\\.|\$(?!\{)|[^'\\\r\n$])*'(?=[ \t]*:)/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: [
            {
                pattern: /'''[^'][\s\S]*?'''/,
                greedy: true
            },
            {
                pattern: /(^|[^\\'])'(?:\\.|\$(?!\{)|[^'\\\r\n$])*'/,
                lookbehind: true,
                greedy: true
            }
        ],
        'interpolated-string': {
            pattern: /(^|[^\\'])'(?:\\.|\$(?:(?!\{)|\{[^{}\r\n]*\})|[^'\\\r\n$])*'/,
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /\$\{[^{}\r\n]*\}/,
                    inside: {
                        expression: {
                            pattern: /(^\$\{)[\s\S]+(?=\}$)/,
                            lookbehind: true
                        },
                        punctuation: /^\$\{|\}$/
                    }
                },
                string: /[\s\S]+/
            }
        },
        datatype: {
            pattern: /(\b(?:output|param)\b[ \t]+\w+[ \t]+)\w+\b/,
            lookbehind: true,
            alias: 'class-name'
        },
        boolean: /\b(?:false|true)\b/,
        // https://github.com/Azure/bicep/blob/114a3251b4e6e30082a58729f19a8cc4e374ffa6/src/textmate/bicep.tmlanguage#L184
        keyword: /\b(?:existing|for|if|in|module|null|output|param|resource|targetScope|var)\b/,
        decorator: /@\w+\b/,
        function: /\b[a-z_]\w*(?=[ \t]*\()/i,
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
        operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/,
        punctuation: /[{}[\];(),.:]/
    };
    Prism.languages.bicep['interpolated-string'].inside['interpolation'].inside['expression'].inside = Prism.languages.bicep;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$e9431566d3fac7dd$export$2e2bcd8739ae039.displayName = 'birb';
$e9431566d3fac7dd$export$2e2bcd8739ae039.aliases = [];
function $e9431566d3fac7dd$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.birb = Prism.languages.extend('clike', {
        string: {
            pattern: /r?("|')(?:\\.|(?!\1)[^\\])*\1/,
            greedy: true
        },
        'class-name': [
            /\b[A-Z](?:[\d_]*[a-zA-Z]\w*)?\b/,
            // matches variable and function return types (parameters as well).
            /\b(?:[A-Z]\w*|(?!(?:var|void)\b)[a-z]\w*)(?=\s+\w+\s*[;,=()])/
        ],
        keyword: /\b(?:assert|break|case|class|const|default|else|enum|final|follows|for|grab|if|nest|new|next|noSeeb|return|static|switch|throw|var|void|while)\b/,
        operator: /\+\+|--|&&|\|\||<<=?|>>=?|~(?:\/=?)?|[+\-*\/%&^|=!<>]=?|\?|:/,
        variable: /\b[a-z_]\w*\b/
    });
    Prism.languages.insertBefore('birb', 'function', {
        metadata: {
            pattern: /<\w+>/,
            greedy: true,
            alias: 'symbol'
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$c084f125db8708f6$export$2e2bcd8739ae039.displayName = 'bison';
$c084f125db8708f6$export$2e2bcd8739ae039.aliases = [];
function $c084f125db8708f6$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f4e156ae6ed8d0a0$export$2e2bcd8739ae039));
    Prism.languages.bison = Prism.languages.extend('c', {});
    Prism.languages.insertBefore('bison', 'comment', {
        bison: {
            // This should match all the beginning of the file
            // including the prologue(s), the bison declarations and
            // the grammar rules.
            pattern: /^(?:[^%]|%(?!%))*%%[\s\S]*?%%/,
            inside: {
                c: {
                    // Allow for one level of nested braces
                    pattern: /%\{[\s\S]*?%\}|\{(?:\{[^}]*\}|[^{}])*\}/,
                    inside: {
                        delimiter: {
                            pattern: /^%?\{|%?\}$/,
                            alias: 'punctuation'
                        },
                        'bison-variable': {
                            pattern: /[$@](?:<[^\s>]+>)?[\w$]+/,
                            alias: 'variable',
                            inside: {
                                punctuation: /<|>/
                            }
                        },
                        rest: Prism.languages.c
                    }
                },
                comment: Prism.languages.c.comment,
                string: Prism.languages.c.string,
                property: /\S+(?=:)/,
                keyword: /%\w+/,
                number: {
                    pattern: /(^|[^@])\b(?:0x[\da-f]+|\d+)/i,
                    lookbehind: true
                },
                punctuation: /%[%?]|[|:;\[\]<>]/
            }
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $8798e67056712316$export$2e2bcd8739ae039.displayName = 'bnf';
$8798e67056712316$export$2e2bcd8739ae039.aliases = [
    'rbnf'
];
function $8798e67056712316$export$2e2bcd8739ae039(Prism) {
    Prism.languages.bnf = {
        string: {
            pattern: /"[^\r\n"]*"|'[^\r\n']*'/
        },
        definition: {
            pattern: /<[^<>\r\n\t]+>(?=\s*::=)/,
            alias: [
                'rule',
                'keyword'
            ],
            inside: {
                punctuation: /^<|>$/
            }
        },
        rule: {
            pattern: /<[^<>\r\n\t]+>/,
            inside: {
                punctuation: /^<|>$/
            }
        },
        operator: /::=|[|()[\]{}*+?]|\.{3}/
    };
    Prism.languages.rbnf = Prism.languages.bnf;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $604e26785f89d2b2$export$2e2bcd8739ae039.displayName = 'bqn';
$604e26785f89d2b2$export$2e2bcd8739ae039.aliases = [];
function $604e26785f89d2b2$export$2e2bcd8739ae039(Prism) {
    Prism.languages.bqn = {
        shebang: {
            pattern: /^#![ \t]*\/.*/,
            alias: 'important',
            greedy: true
        },
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        'string-literal': {
            pattern: /"(?:[^"]|"")*"/,
            greedy: true,
            alias: 'string'
        },
        'character-literal': {
            pattern: /'(?:[\s\S]|[\uD800-\uDBFF][\uDC00-\uDFFF])'/,
            greedy: true,
            alias: 'char'
        },
        function: /•[\w¯.∞π]+[\w¯.∞π]*/,
        'dot-notation-on-brackets': {
            pattern: /\{(?=.*\}\.)|\}\./,
            alias: 'namespace'
        },
        'special-name': {
            pattern: /(?:𝕨|𝕩|𝕗|𝕘|𝕤|𝕣|𝕎|𝕏|𝔽|𝔾|𝕊|_𝕣_|_𝕣)/,
            alias: 'keyword'
        },
        'dot-notation-on-name': {
            pattern: /[A-Za-z_][\w¯∞π]*\./,
            alias: 'namespace'
        },
        'word-number-scientific': {
            pattern: /\d+(?:\.\d+)?[eE]¯?\d+/,
            alias: 'number'
        },
        'word-name': {
            pattern: /[A-Za-z_][\w¯∞π]*/,
            alias: 'symbol'
        },
        'word-number': {
            pattern: /[¯∞π]?(?:\d*\.?\b\d+(?:e[+¯]?\d+|E[+¯]?\d+)?|¯|∞|π)(?:j¯?(?:(?:\d+(?:\.\d+)?|\.\d+)(?:e[+¯]?\d+|E[+¯]?\d+)?|¯|∞|π))?/,
            alias: 'number'
        },
        'null-literal': {
            pattern: /@/,
            alias: 'char'
        },
        'primitive-functions': {
            pattern: /[-+×÷⋆√⌊⌈|¬∧∨<>≠=≤≥≡≢⊣⊢⥊∾≍⋈↑↓↕«»⌽⍉/⍋⍒⊏⊑⊐⊒∊⍷⊔!]/,
            alias: 'operator'
        },
        'primitive-1-operators': {
            pattern: /[`˜˘¨⁼⌜´˝˙]/,
            alias: 'operator'
        },
        'primitive-2-operators': {
            pattern: /[∘⊸⟜○⌾⎉⚇⍟⊘◶⎊]/,
            alias: 'operator'
        },
        punctuation: /[←⇐↩(){}⟨⟩[\]‿·⋄,.;:?]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $69bb850a8bbe91f4$export$2e2bcd8739ae039.displayName = 'brainfuck';
$69bb850a8bbe91f4$export$2e2bcd8739ae039.aliases = [];
function $69bb850a8bbe91f4$export$2e2bcd8739ae039(Prism) {
    Prism.languages.brainfuck = {
        pointer: {
            pattern: /<|>/,
            alias: 'keyword'
        },
        increment: {
            pattern: /\+/,
            alias: 'inserted'
        },
        decrement: {
            pattern: /-/,
            alias: 'deleted'
        },
        branching: {
            pattern: /\[|\]/,
            alias: 'important'
        },
        operator: /[.,]/,
        comment: /\S+/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $0d5ca126f659299e$export$2e2bcd8739ae039.displayName = 'brightscript';
$0d5ca126f659299e$export$2e2bcd8739ae039.aliases = [];
function $0d5ca126f659299e$export$2e2bcd8739ae039(Prism) {
    Prism.languages.brightscript = {
        comment: /(?:\brem|').*/i,
        'directive-statement': {
            pattern: /(^[\t ]*)#(?:const|else(?:[\t ]+if)?|end[\t ]+if|error|if).*/im,
            lookbehind: true,
            alias: 'property',
            inside: {
                'error-message': {
                    pattern: /(^#error).+/,
                    lookbehind: true
                },
                directive: {
                    pattern: /^#(?:const|else(?:[\t ]+if)?|end[\t ]+if|error|if)/,
                    alias: 'keyword'
                },
                expression: {
                    pattern: /[\s\S]+/,
                    inside: null // see below
                }
            }
        },
        property: {
            pattern: /([\r\n{,][\t ]*)(?:(?!\d)\w+|"(?:[^"\r\n]|"")*"(?!"))(?=[ \t]*:)/,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"\r\n]|"")*"(?!")/,
            greedy: true
        },
        'class-name': {
            pattern: /(\bAs[\t ]+)\w+/i,
            lookbehind: true
        },
        keyword: /\b(?:As|Dim|Each|Else|Elseif|End|Exit|For|Function|Goto|If|In|Print|Return|Step|Stop|Sub|Then|To|While)\b/i,
        boolean: /\b(?:false|true)\b/i,
        function: /\b(?!\d)\w+(?=[\t ]*\()/,
        number: /(?:\b\d+(?:\.\d+)?(?:[ed][+-]\d+)?|&h[a-f\d]+)\b[%&!#]?/i,
        operator: /--|\+\+|>>=?|<<=?|<>|[-+*/\\<>]=?|[:^=?]|\b(?:and|mod|not|or)\b/i,
        punctuation: /[.,;()[\]{}]/,
        constant: /\b(?:LINE_NUM)\b/i
    };
    Prism.languages.brightscript['directive-statement'].inside.expression.inside = Prism.languages.brightscript;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $beb46e0ab65e7d5b$export$2e2bcd8739ae039.displayName = 'bro';
$beb46e0ab65e7d5b$export$2e2bcd8739ae039.aliases = [];
function $beb46e0ab65e7d5b$export$2e2bcd8739ae039(Prism) {
    Prism.languages.bro = {
        comment: {
            pattern: /(^|[^\\$])#.*/,
            lookbehind: true,
            inside: {
                italic: /\b(?:FIXME|TODO|XXX)\b/
            }
        },
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        boolean: /\b[TF]\b/,
        function: {
            pattern: /(\b(?:event|function|hook)[ \t]+)\w+(?:::\w+)?/,
            lookbehind: true
        },
        builtin: /(?:@(?:load(?:-(?:plugin|sigs))?|unload|prefixes|ifn?def|else|(?:end)?if|DIR|FILENAME))|(?:&?(?:add_func|create_expire|default|delete_func|encrypt|error_handler|expire_func|group|log|mergeable|optional|persistent|priority|raw_output|read_expire|redef|rotate_interval|rotate_size|synchronized|type_column|write_expire))/,
        constant: {
            pattern: /(\bconst[ \t]+)\w+/i,
            lookbehind: true
        },
        keyword: /\b(?:add|addr|alarm|any|bool|break|const|continue|count|delete|double|else|enum|event|export|file|for|function|global|hook|if|in|int|interval|local|module|next|of|opaque|pattern|port|print|record|return|schedule|set|string|subnet|table|time|timeout|using|vector|when)\b/,
        operator: /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&|\|\|?|\?|\*|\/|~|\^|%/,
        number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
        punctuation: /[{}[\];(),.:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $daeaab3980ca96e4$export$2e2bcd8739ae039.displayName = 'bsl';
$daeaab3980ca96e4$export$2e2bcd8739ae039.aliases = [
    'oscript'
];
function $daeaab3980ca96e4$export$2e2bcd8739ae039(Prism) {
    /* eslint-disable no-misleading-character-class */ // 1C:Enterprise
    // https://github.com/Diversus23/
    //
    Prism.languages.bsl = {
        comment: /\/\/.*/,
        string: [
            // Строки
            // Strings
            {
                pattern: /"(?:[^"]|"")*"(?!")/,
                greedy: true
            },
            // Дата и время
            // Date & time
            {
                pattern: /'(?:[^'\r\n\\]|\\.)*'/
            }
        ],
        keyword: [
            {
                // RU
                pattern: /(^|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:пока|для|новый|прервать|попытка|исключение|вызватьисключение|иначе|конецпопытки|неопределено|функция|перем|возврат|конецфункции|если|иначеесли|процедура|конецпроцедуры|тогда|знач|экспорт|конецесли|из|каждого|истина|ложь|по|цикл|конеццикла|выполнить)(?![\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])/i,
                lookbehind: true
            },
            {
                // EN
                pattern: /\b(?:break|do|each|else|elseif|enddo|endfunction|endif|endprocedure|endtry|except|execute|export|false|for|function|if|in|new|null|procedure|raise|return|then|to|true|try|undefined|val|var|while)\b/i
            }
        ],
        number: {
            pattern: /(^(?=\d)|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:\d+(?:\.\d*)?|\.\d+)(?:E[+-]?\d+)?/i,
            lookbehind: true
        },
        operator: [
            /[<>+\-*/]=?|[%=]/,
            // RU
            {
                pattern: /(^|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:и|или|не)(?![\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])/i,
                lookbehind: true
            },
            // EN
            {
                pattern: /\b(?:and|not|or)\b/i
            }
        ],
        punctuation: /\(\.|\.\)|[()\[\]:;,.]/,
        directive: [
            // Теги препроцессора вида &Клиент, &Сервер, ...
            // Preprocessor tags of the type &Client, &Server, ...
            {
                pattern: /^([ \t]*)&.*/m,
                lookbehind: true,
                greedy: true,
                alias: 'important'
            },
            // Инструкции препроцессора вида:
            // #Если Сервер Тогда
            // ...
            // #КонецЕсли
            // Preprocessor instructions of the form:
            // #If Server Then
            // ...
            // #EndIf
            {
                pattern: /^([ \t]*)#.*/gm,
                lookbehind: true,
                greedy: true,
                alias: 'important'
            }
        ]
    };
    Prism.languages.oscript = Prism.languages['bsl'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$84399bc3f59b1c8b$export$2e2bcd8739ae039.displayName = 'cfscript';
$84399bc3f59b1c8b$export$2e2bcd8739ae039.aliases = [
    'cfc'
];
function $84399bc3f59b1c8b$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    // https://cfdocs.org/script
    Prism.languages.cfscript = Prism.languages.extend('clike', {
        comment: [
            {
                pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                lookbehind: true,
                inside: {
                    annotation: {
                        pattern: /(?:^|[^.])@[\w\.]+/,
                        alias: 'punctuation'
                    }
                }
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        keyword: /\b(?:abstract|break|catch|component|continue|default|do|else|extends|final|finally|for|function|if|in|include|package|private|property|public|remote|required|rethrow|return|static|switch|throw|try|var|while|xml)\b(?!\s*=)/,
        operator: [
            /\+\+|--|&&|\|\||::|=>|[!=]==|[-+*/%&|^!=<>]=?|\?(?:\.|:)?|:/,
            /\b(?:and|contains|eq|equal|eqv|gt|gte|imp|is|lt|lte|mod|not|or|xor)\b/
        ],
        scope: {
            pattern: /\b(?:application|arguments|cgi|client|cookie|local|session|super|this|variables)\b/,
            alias: 'global'
        },
        type: {
            pattern: /\b(?:any|array|binary|boolean|date|guid|numeric|query|string|struct|uuid|void|xml)\b/,
            alias: 'builtin'
        }
    });
    Prism.languages.insertBefore('cfscript', 'keyword', {
        // This must be declared before keyword because we use "function" inside the lookahead
        'function-variable': {
            pattern: /[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
            alias: 'function'
        }
    });
    delete Prism.languages.cfscript['class-name'];
    Prism.languages.cfc = Prism.languages['cfscript'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$56a51c0494ec22f0$export$2e2bcd8739ae039.displayName = 'chaiscript';
$56a51c0494ec22f0$export$2e2bcd8739ae039.aliases = [];
function $56a51c0494ec22f0$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.register((0, $b373cdd06f88d58c$export$2e2bcd8739ae039));
    Prism.languages.chaiscript = Prism.languages.extend('clike', {
        string: {
            pattern: /(^|[^\\])'(?:[^'\\]|\\[\s\S])*'/,
            lookbehind: true,
            greedy: true
        },
        'class-name': [
            {
                // e.g. class Rectangle { ... }
                pattern: /(\bclass\s+)\w+/,
                lookbehind: true
            },
            {
                // e.g. attr Rectangle::height, def Rectangle::area() { ... }
                pattern: /(\b(?:attr|def)\s+)\w+(?=\s*::)/,
                lookbehind: true
            }
        ],
        keyword: /\b(?:attr|auto|break|case|catch|class|continue|def|default|else|finally|for|fun|global|if|return|switch|this|try|var|while)\b/,
        number: [
            Prism.languages.cpp.number,
            /\b(?:Infinity|NaN)\b/
        ],
        operator: />>=?|<<=?|\|\||&&|:[:=]?|--|\+\+|[=!<>+\-*/%|&^]=?|[?~]|`[^`\r\n]{1,4}`/
    });
    Prism.languages.insertBefore('chaiscript', 'operator', {
        'parameter-type': {
            // e.g. def foo(int x, Vector y) {...}
            pattern: /([,(]\s*)\w+(?=\s+\w)/,
            lookbehind: true,
            alias: 'class-name'
        }
    });
    Prism.languages.insertBefore('chaiscript', 'string', {
        'string-interpolation': {
            pattern: /(^|[^\\])"(?:[^"$\\]|\\[\s\S]|\$(?!\{)|\$\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*"/,
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\}/,
                    lookbehind: true,
                    inside: {
                        'interpolation-expression': {
                            pattern: /(^\$\{)[\s\S]+(?=\}$)/,
                            lookbehind: true,
                            inside: Prism.languages.chaiscript
                        },
                        'interpolation-punctuation': {
                            pattern: /^\$\{|\}$/,
                            alias: 'punctuation'
                        }
                    }
                },
                string: /[\s\S]+/
            }
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $8ec1bae033ed476d$export$2e2bcd8739ae039.displayName = 'cil';
$8ec1bae033ed476d$export$2e2bcd8739ae039.aliases = [];
function $8ec1bae033ed476d$export$2e2bcd8739ae039(Prism) {
    Prism.languages.cil = {
        comment: /\/\/.*/,
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        directive: {
            pattern: /(^|\W)\.[a-z]+(?=\s)/,
            lookbehind: true,
            alias: 'class-name'
        },
        // Actually an assembly reference
        variable: /\[[\w\.]+\]/,
        keyword: /\b(?:abstract|ansi|assembly|auto|autochar|beforefieldinit|bool|bstr|byvalstr|catch|char|cil|class|currency|date|decimal|default|enum|error|explicit|extends|extern|famandassem|family|famorassem|final(?:ly)?|float32|float64|hidebysig|u?int(?:8|16|32|64)?|iant|idispatch|implements|import|initonly|instance|interface|iunknown|literal|lpstr|lpstruct|lptstr|lpwstr|managed|method|native(?:Type)?|nested|newslot|object(?:ref)?|pinvokeimpl|private|privatescope|public|reqsecobj|rtspecialname|runtime|sealed|sequential|serializable|specialname|static|string|struct|syschar|tbstr|unicode|unmanagedexp|unsigned|value(?:type)?|variant|virtual|void)\b/,
        function: /\b(?:(?:constrained|no|readonly|tail|unaligned|volatile)\.)?(?:conv\.(?:[iu][1248]?|ovf\.[iu][1248]?(?:\.un)?|r\.un|r4|r8)|ldc\.(?:i4(?:\.\d+|\.[mM]1|\.s)?|i8|r4|r8)|ldelem(?:\.[iu][1248]?|\.r[48]|\.ref|a)?|ldind\.(?:[iu][1248]?|r[48]|ref)|stelem\.?(?:i[1248]?|r[48]|ref)?|stind\.(?:i[1248]?|r[48]|ref)?|end(?:fault|filter|finally)|ldarg(?:\.[0-3s]|a(?:\.s)?)?|ldloc(?:\.\d+|\.s)?|sub(?:\.ovf(?:\.un)?)?|mul(?:\.ovf(?:\.un)?)?|add(?:\.ovf(?:\.un)?)?|stloc(?:\.[0-3s])?|refany(?:type|val)|blt(?:\.un)?(?:\.s)?|ble(?:\.un)?(?:\.s)?|bgt(?:\.un)?(?:\.s)?|bge(?:\.un)?(?:\.s)?|unbox(?:\.any)?|init(?:blk|obj)|call(?:i|virt)?|brfalse(?:\.s)?|bne\.un(?:\.s)?|ldloca(?:\.s)?|brzero(?:\.s)?|brtrue(?:\.s)?|brnull(?:\.s)?|brinst(?:\.s)?|starg(?:\.s)?|leave(?:\.s)?|shr(?:\.un)?|rem(?:\.un)?|div(?:\.un)?|clt(?:\.un)?|alignment|castclass|ldvirtftn|beq(?:\.s)?|ckfinite|ldsflda|ldtoken|localloc|mkrefany|rethrow|cgt\.un|arglist|switch|stsfld|sizeof|newobj|newarr|ldsfld|ldnull|ldflda|isinst|throw|stobj|stfld|ldstr|ldobj|ldlen|ldftn|ldfld|cpobj|cpblk|break|br\.s|xor|shl|ret|pop|not|nop|neg|jmp|dup|cgt|ceq|box|and|or|br)\b/,
        boolean: /\b(?:false|true)\b/,
        number: /\b-?(?:0x[0-9a-f]+|\d+)(?:\.[0-9a-f]+)?\b/i,
        punctuation: /[{}[\];(),:=]|IL_[0-9A-Za-z]+/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$fa97cf30362824f8$export$2e2bcd8739ae039.displayName = 'cilkc';
$fa97cf30362824f8$export$2e2bcd8739ae039.aliases = [
    'cilk-c'
];
function $fa97cf30362824f8$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f4e156ae6ed8d0a0$export$2e2bcd8739ae039));
    Prism.languages.cilkc = Prism.languages.insertBefore('c', 'function', {
        'parallel-keyword': {
            pattern: /\bcilk_(?:for|reducer|s(?:cope|pawn|ync))\b/,
            alias: 'keyword'
        }
    });
    Prism.languages['cilk-c'] = Prism.languages['cilkc'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$aad082cba5464279$export$2e2bcd8739ae039.displayName = 'cilkcpp';
$aad082cba5464279$export$2e2bcd8739ae039.aliases = [
    'cilk',
    'cilk-cpp'
];
function $aad082cba5464279$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $b373cdd06f88d58c$export$2e2bcd8739ae039));
    Prism.languages.cilkcpp = Prism.languages.insertBefore('cpp', 'function', {
        'parallel-keyword': {
            pattern: /\bcilk_(?:for|reducer|s(?:cope|pawn|ync))\b/,
            alias: 'keyword'
        }
    });
    Prism.languages['cilk-cpp'] = Prism.languages['cilkcpp'];
    Prism.languages['cilk'] = Prism.languages['cilkcpp'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $77fe7b80ef861b40$export$2e2bcd8739ae039.displayName = 'clojure';
$77fe7b80ef861b40$export$2e2bcd8739ae039.aliases = [];
function $77fe7b80ef861b40$export$2e2bcd8739ae039(Prism) {
    // Copied from https://github.com/jeluard/prism-clojure
    Prism.languages.clojure = {
        comment: {
            pattern: /;.*/,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"\\]|\\.)*"/,
            greedy: true
        },
        char: /\\\w+/,
        symbol: {
            pattern: /(^|[\s()\[\]{},])::?[\w*+!?'<>=/.-]+/,
            lookbehind: true
        },
        keyword: {
            pattern: /(\()(?:-|->|->>|\.|\.\.|\*|\/|\+|<|<=|=|==|>|>=|accessor|agent|agent-errors|aget|alength|all-ns|alter|and|append-child|apply|array-map|aset|aset-boolean|aset-byte|aset-char|aset-double|aset-float|aset-int|aset-long|aset-short|assert|assoc|await|await-for|bean|binding|bit-and|bit-not|bit-or|bit-shift-left|bit-shift-right|bit-xor|boolean|branch\?|butlast|byte|cast|char|children|class|clear-agent-errors|comment|commute|comp|comparator|complement|concat|cond|conj|cons|constantly|construct-proxy|contains\?|count|create-ns|create-struct|cycle|dec|declare|def|def-|definline|definterface|defmacro|defmethod|defmulti|defn|defn-|defonce|defproject|defprotocol|defrecord|defstruct|deftype|deref|difference|disj|dissoc|distinct|do|doall|doc|dorun|doseq|dosync|dotimes|doto|double|down|drop|drop-while|edit|end\?|ensure|eval|every\?|false\?|ffirst|file-seq|filter|find|find-doc|find-ns|find-var|first|float|flush|fn|fnseq|for|frest|gensym|get|get-proxy-class|hash-map|hash-set|identical\?|identity|if|if-let|if-not|import|in-ns|inc|index|insert-child|insert-left|insert-right|inspect-table|inspect-tree|instance\?|int|interleave|intersection|into|into-array|iterate|join|key|keys|keyword|keyword\?|last|lazy-cat|lazy-cons|left|lefts|let|line-seq|list|list\*|load|load-file|locking|long|loop|macroexpand|macroexpand-1|make-array|make-node|map|map-invert|map\?|mapcat|max|max-key|memfn|merge|merge-with|meta|min|min-key|monitor-enter|name|namespace|neg\?|new|newline|next|nil\?|node|not|not-any\?|not-every\?|not=|ns|ns-imports|ns-interns|ns-map|ns-name|ns-publics|ns-refers|ns-resolve|ns-unmap|nth|nthrest|or|parse|partial|path|peek|pop|pos\?|pr|pr-str|print|print-str|println|println-str|prn|prn-str|project|proxy|proxy-mappings|quot|quote|rand|rand-int|range|re-find|re-groups|re-matcher|re-matches|re-pattern|re-seq|read|read-line|recur|reduce|ref|ref-set|refer|rem|remove|remove-method|remove-ns|rename|rename-keys|repeat|replace|replicate|resolve|rest|resultset-seq|reverse|rfirst|right|rights|root|rrest|rseq|second|select|select-keys|send|send-off|seq|seq-zip|seq\?|set|set!|short|slurp|some|sort|sort-by|sorted-map|sorted-map-by|sorted-set|special-symbol\?|split-at|split-with|str|string\?|struct|struct-map|subs|subvec|symbol|symbol\?|sync|take|take-nth|take-while|test|throw|time|to-array|to-array-2d|tree-seq|true\?|try|union|up|update-proxy|val|vals|var|var-get|var-set|var\?|vector|vector-zip|vector\?|when|when-first|when-let|when-not|with-local-vars|with-meta|with-open|with-out-str|xml-seq|xml-zip|zero\?|zipmap|zipper)(?=[\s)]|$)/,
            lookbehind: true
        },
        boolean: /\b(?:false|nil|true)\b/,
        number: {
            pattern: /(^|[^\w$@])(?:\d+(?:[/.]\d+)?(?:e[+-]?\d+)?|0x[a-f0-9]+|[1-9]\d?r[a-z0-9]+)[lmn]?(?![\w$@])/i,
            lookbehind: true
        },
        function: {
            pattern: /((?:^|[^'])\()[\w*+!?'<>=/.-]+(?=[\s)]|$)/,
            lookbehind: true
        },
        operator: /[#@^`~]/,
        punctuation: /[{}\[\](),]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $53052fb9d74303db$export$2e2bcd8739ae039.displayName = 'cmake';
$53052fb9d74303db$export$2e2bcd8739ae039.aliases = [];
function $53052fb9d74303db$export$2e2bcd8739ae039(Prism) {
    Prism.languages.cmake = {
        comment: /#.*/,
        string: {
            pattern: /"(?:[^\\"]|\\.)*"/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /\$\{(?:[^{}$]|\$\{[^{}$]*\})*\}/,
                    inside: {
                        punctuation: /\$\{|\}/,
                        variable: /\w+/
                    }
                }
            }
        },
        variable: /\b(?:CMAKE_\w+|\w+_(?:(?:BINARY|SOURCE)_DIR|DESCRIPTION|HOMEPAGE_URL|ROOT|VERSION(?:_MAJOR|_MINOR|_PATCH|_TWEAK)?)|(?:ANDROID|APPLE|BORLAND|BUILD_SHARED_LIBS|CACHE|CPACK_(?:ABSOLUTE_DESTINATION_FILES|COMPONENT_INCLUDE_TOPLEVEL_DIRECTORY|ERROR_ON_ABSOLUTE_INSTALL_DESTINATION|INCLUDE_TOPLEVEL_DIRECTORY|INSTALL_DEFAULT_DIRECTORY_PERMISSIONS|INSTALL_SCRIPT|PACKAGING_INSTALL_PREFIX|SET_DESTDIR|WARN_ON_ABSOLUTE_INSTALL_DESTINATION)|CTEST_(?:BINARY_DIRECTORY|BUILD_COMMAND|BUILD_NAME|BZR_COMMAND|BZR_UPDATE_OPTIONS|CHANGE_ID|CHECKOUT_COMMAND|CONFIGURATION_TYPE|CONFIGURE_COMMAND|COVERAGE_COMMAND|COVERAGE_EXTRA_FLAGS|CURL_OPTIONS|CUSTOM_(?:COVERAGE_EXCLUDE|ERROR_EXCEPTION|ERROR_MATCH|ERROR_POST_CONTEXT|ERROR_PRE_CONTEXT|MAXIMUM_FAILED_TEST_OUTPUT_SIZE|MAXIMUM_NUMBER_OF_(?:ERRORS|WARNINGS)|MAXIMUM_PASSED_TEST_OUTPUT_SIZE|MEMCHECK_IGNORE|POST_MEMCHECK|POST_TEST|PRE_MEMCHECK|PRE_TEST|TESTS_IGNORE|WARNING_EXCEPTION|WARNING_MATCH)|CVS_CHECKOUT|CVS_COMMAND|CVS_UPDATE_OPTIONS|DROP_LOCATION|DROP_METHOD|DROP_SITE|DROP_SITE_CDASH|DROP_SITE_PASSWORD|DROP_SITE_USER|EXTRA_COVERAGE_GLOB|GIT_COMMAND|GIT_INIT_SUBMODULES|GIT_UPDATE_CUSTOM|GIT_UPDATE_OPTIONS|HG_COMMAND|HG_UPDATE_OPTIONS|LABELS_FOR_SUBPROJECTS|MEMORYCHECK_(?:COMMAND|COMMAND_OPTIONS|SANITIZER_OPTIONS|SUPPRESSIONS_FILE|TYPE)|NIGHTLY_START_TIME|P4_CLIENT|P4_COMMAND|P4_OPTIONS|P4_UPDATE_OPTIONS|RUN_CURRENT_SCRIPT|SCP_COMMAND|SITE|SOURCE_DIRECTORY|SUBMIT_URL|SVN_COMMAND|SVN_OPTIONS|SVN_UPDATE_OPTIONS|TEST_LOAD|TEST_TIMEOUT|TRIGGER_SITE|UPDATE_COMMAND|UPDATE_OPTIONS|UPDATE_VERSION_ONLY|USE_LAUNCHERS)|CYGWIN|ENV|EXECUTABLE_OUTPUT_PATH|GHS-MULTI|IOS|LIBRARY_OUTPUT_PATH|MINGW|MSVC(?:10|11|12|14|60|70|71|80|90|_IDE|_TOOLSET_VERSION|_VERSION)?|MSYS|PROJECT_NAME|UNIX|WIN32|WINCE|WINDOWS_PHONE|WINDOWS_STORE|XCODE))\b/,
        property: /\b(?:cxx_\w+|(?:ARCHIVE_OUTPUT_(?:DIRECTORY|NAME)|COMPILE_DEFINITIONS|COMPILE_PDB_NAME|COMPILE_PDB_OUTPUT_DIRECTORY|EXCLUDE_FROM_DEFAULT_BUILD|IMPORTED_(?:IMPLIB|LIBNAME|LINK_DEPENDENT_LIBRARIES|LINK_INTERFACE_LANGUAGES|LINK_INTERFACE_LIBRARIES|LINK_INTERFACE_MULTIPLICITY|LOCATION|NO_SONAME|OBJECTS|SONAME)|INTERPROCEDURAL_OPTIMIZATION|LIBRARY_OUTPUT_DIRECTORY|LIBRARY_OUTPUT_NAME|LINK_FLAGS|LINK_INTERFACE_LIBRARIES|LINK_INTERFACE_MULTIPLICITY|LOCATION|MAP_IMPORTED_CONFIG|OSX_ARCHITECTURES|OUTPUT_NAME|PDB_NAME|PDB_OUTPUT_DIRECTORY|RUNTIME_OUTPUT_DIRECTORY|RUNTIME_OUTPUT_NAME|STATIC_LIBRARY_FLAGS|VS_CSHARP|VS_DOTNET_REFERENCEPROP|VS_DOTNET_REFERENCE|VS_GLOBAL_SECTION_POST|VS_GLOBAL_SECTION_PRE|VS_GLOBAL|XCODE_ATTRIBUTE)_\w+|\w+_(?:CLANG_TIDY|COMPILER_LAUNCHER|CPPCHECK|CPPLINT|INCLUDE_WHAT_YOU_USE|OUTPUT_NAME|POSTFIX|VISIBILITY_PRESET)|ABSTRACT|ADDITIONAL_MAKE_CLEAN_FILES|ADVANCED|ALIASED_TARGET|ALLOW_DUPLICATE_CUSTOM_TARGETS|ANDROID_(?:ANT_ADDITIONAL_OPTIONS|API|API_MIN|ARCH|ASSETS_DIRECTORIES|GUI|JAR_DEPENDENCIES|NATIVE_LIB_DEPENDENCIES|NATIVE_LIB_DIRECTORIES|PROCESS_MAX|PROGUARD|PROGUARD_CONFIG_PATH|SECURE_PROPS_PATH|SKIP_ANT_STEP|STL_TYPE)|ARCHIVE_OUTPUT_DIRECTORY|ATTACHED_FILES|ATTACHED_FILES_ON_FAIL|AUTOGEN_(?:BUILD_DIR|ORIGIN_DEPENDS|PARALLEL|SOURCE_GROUP|TARGETS_FOLDER|TARGET_DEPENDS)|AUTOMOC|AUTOMOC_(?:COMPILER_PREDEFINES|DEPEND_FILTERS|EXECUTABLE|MACRO_NAMES|MOC_OPTIONS|SOURCE_GROUP|TARGETS_FOLDER)|AUTORCC|AUTORCC_EXECUTABLE|AUTORCC_OPTIONS|AUTORCC_SOURCE_GROUP|AUTOUIC|AUTOUIC_EXECUTABLE|AUTOUIC_OPTIONS|AUTOUIC_SEARCH_PATHS|BINARY_DIR|BUILDSYSTEM_TARGETS|BUILD_RPATH|BUILD_RPATH_USE_ORIGIN|BUILD_WITH_INSTALL_NAME_DIR|BUILD_WITH_INSTALL_RPATH|BUNDLE|BUNDLE_EXTENSION|CACHE_VARIABLES|CLEAN_NO_CUSTOM|COMMON_LANGUAGE_RUNTIME|COMPATIBLE_INTERFACE_(?:BOOL|NUMBER_MAX|NUMBER_MIN|STRING)|COMPILE_(?:DEFINITIONS|FEATURES|FLAGS|OPTIONS|PDB_NAME|PDB_OUTPUT_DIRECTORY)|COST|CPACK_DESKTOP_SHORTCUTS|CPACK_NEVER_OVERWRITE|CPACK_PERMANENT|CPACK_STARTUP_SHORTCUTS|CPACK_START_MENU_SHORTCUTS|CPACK_WIX_ACL|CROSSCOMPILING_EMULATOR|CUDA_EXTENSIONS|CUDA_PTX_COMPILATION|CUDA_RESOLVE_DEVICE_SYMBOLS|CUDA_SEPARABLE_COMPILATION|CUDA_STANDARD|CUDA_STANDARD_REQUIRED|CXX_EXTENSIONS|CXX_STANDARD|CXX_STANDARD_REQUIRED|C_EXTENSIONS|C_STANDARD|C_STANDARD_REQUIRED|DEBUG_CONFIGURATIONS|DEFINE_SYMBOL|DEFINITIONS|DEPENDS|DEPLOYMENT_ADDITIONAL_FILES|DEPLOYMENT_REMOTE_DIRECTORY|DISABLED|DISABLED_FEATURES|ECLIPSE_EXTRA_CPROJECT_CONTENTS|ECLIPSE_EXTRA_NATURES|ENABLED_FEATURES|ENABLED_LANGUAGES|ENABLE_EXPORTS|ENVIRONMENT|EXCLUDE_FROM_ALL|EXCLUDE_FROM_DEFAULT_BUILD|EXPORT_NAME|EXPORT_PROPERTIES|EXTERNAL_OBJECT|EchoString|FAIL_REGULAR_EXPRESSION|FIND_LIBRARY_USE_LIB32_PATHS|FIND_LIBRARY_USE_LIB64_PATHS|FIND_LIBRARY_USE_LIBX32_PATHS|FIND_LIBRARY_USE_OPENBSD_VERSIONING|FIXTURES_CLEANUP|FIXTURES_REQUIRED|FIXTURES_SETUP|FOLDER|FRAMEWORK|Fortran_FORMAT|Fortran_MODULE_DIRECTORY|GENERATED|GENERATOR_FILE_NAME|GENERATOR_IS_MULTI_CONFIG|GHS_INTEGRITY_APP|GHS_NO_SOURCE_GROUP_FILE|GLOBAL_DEPENDS_DEBUG_MODE|GLOBAL_DEPENDS_NO_CYCLES|GNUtoMS|HAS_CXX|HEADER_FILE_ONLY|HELPSTRING|IMPLICIT_DEPENDS_INCLUDE_TRANSFORM|IMPORTED|IMPORTED_(?:COMMON_LANGUAGE_RUNTIME|CONFIGURATIONS|GLOBAL|IMPLIB|LIBNAME|LINK_DEPENDENT_LIBRARIES|LINK_INTERFACE_(?:LANGUAGES|LIBRARIES|MULTIPLICITY)|LOCATION|NO_SONAME|OBJECTS|SONAME)|IMPORT_PREFIX|IMPORT_SUFFIX|INCLUDE_DIRECTORIES|INCLUDE_REGULAR_EXPRESSION|INSTALL_NAME_DIR|INSTALL_RPATH|INSTALL_RPATH_USE_LINK_PATH|INTERFACE_(?:AUTOUIC_OPTIONS|COMPILE_DEFINITIONS|COMPILE_FEATURES|COMPILE_OPTIONS|INCLUDE_DIRECTORIES|LINK_DEPENDS|LINK_DIRECTORIES|LINK_LIBRARIES|LINK_OPTIONS|POSITION_INDEPENDENT_CODE|SOURCES|SYSTEM_INCLUDE_DIRECTORIES)|INTERPROCEDURAL_OPTIMIZATION|IN_TRY_COMPILE|IOS_INSTALL_COMBINED|JOB_POOLS|JOB_POOL_COMPILE|JOB_POOL_LINK|KEEP_EXTENSION|LABELS|LANGUAGE|LIBRARY_OUTPUT_DIRECTORY|LINKER_LANGUAGE|LINK_(?:DEPENDS|DEPENDS_NO_SHARED|DIRECTORIES|FLAGS|INTERFACE_LIBRARIES|INTERFACE_MULTIPLICITY|LIBRARIES|OPTIONS|SEARCH_END_STATIC|SEARCH_START_STATIC|WHAT_YOU_USE)|LISTFILE_STACK|LOCATION|MACOSX_BUNDLE|MACOSX_BUNDLE_INFO_PLIST|MACOSX_FRAMEWORK_INFO_PLIST|MACOSX_PACKAGE_LOCATION|MACOSX_RPATH|MACROS|MANUALLY_ADDED_DEPENDENCIES|MEASUREMENT|MODIFIED|NAME|NO_SONAME|NO_SYSTEM_FROM_IMPORTED|OBJECT_DEPENDS|OBJECT_OUTPUTS|OSX_ARCHITECTURES|OUTPUT_NAME|PACKAGES_FOUND|PACKAGES_NOT_FOUND|PARENT_DIRECTORY|PASS_REGULAR_EXPRESSION|PDB_NAME|PDB_OUTPUT_DIRECTORY|POSITION_INDEPENDENT_CODE|POST_INSTALL_SCRIPT|PREDEFINED_TARGETS_FOLDER|PREFIX|PRE_INSTALL_SCRIPT|PRIVATE_HEADER|PROCESSORS|PROCESSOR_AFFINITY|PROJECT_LABEL|PUBLIC_HEADER|REPORT_UNDEFINED_PROPERTIES|REQUIRED_FILES|RESOURCE|RESOURCE_LOCK|RULE_LAUNCH_COMPILE|RULE_LAUNCH_CUSTOM|RULE_LAUNCH_LINK|RULE_MESSAGES|RUNTIME_OUTPUT_DIRECTORY|RUN_SERIAL|SKIP_AUTOGEN|SKIP_AUTOMOC|SKIP_AUTORCC|SKIP_AUTOUIC|SKIP_BUILD_RPATH|SKIP_RETURN_CODE|SOURCES|SOURCE_DIR|SOVERSION|STATIC_LIBRARY_FLAGS|STATIC_LIBRARY_OPTIONS|STRINGS|SUBDIRECTORIES|SUFFIX|SYMBOLIC|TARGET_ARCHIVES_MAY_BE_SHARED_LIBS|TARGET_MESSAGES|TARGET_SUPPORTS_SHARED_LIBS|TESTS|TEST_INCLUDE_FILE|TEST_INCLUDE_FILES|TIMEOUT|TIMEOUT_AFTER_MATCH|TYPE|USE_FOLDERS|VALUE|VARIABLES|VERSION|VISIBILITY_INLINES_HIDDEN|VS_(?:CONFIGURATION_TYPE|COPY_TO_OUT_DIR|DEBUGGER_(?:COMMAND|COMMAND_ARGUMENTS|ENVIRONMENT|WORKING_DIRECTORY)|DEPLOYMENT_CONTENT|DEPLOYMENT_LOCATION|DOTNET_REFERENCES|DOTNET_REFERENCES_COPY_LOCAL|INCLUDE_IN_VSIX|IOT_STARTUP_TASK|KEYWORD|RESOURCE_GENERATOR|SCC_AUXPATH|SCC_LOCALPATH|SCC_PROJECTNAME|SCC_PROVIDER|SDK_REFERENCES|SHADER_(?:DISABLE_OPTIMIZATIONS|ENABLE_DEBUG|ENTRYPOINT|FLAGS|MODEL|OBJECT_FILE_NAME|OUTPUT_HEADER_FILE|TYPE|VARIABLE_NAME)|STARTUP_PROJECT|TOOL_OVERRIDE|USER_PROPS|WINRT_COMPONENT|WINRT_EXTENSIONS|WINRT_REFERENCES|XAML_TYPE)|WILL_FAIL|WIN32_EXECUTABLE|WINDOWS_EXPORT_ALL_SYMBOLS|WORKING_DIRECTORY|WRAP_EXCLUDE|XCODE_(?:EMIT_EFFECTIVE_PLATFORM_NAME|EXPLICIT_FILE_TYPE|FILE_ATTRIBUTES|LAST_KNOWN_FILE_TYPE|PRODUCT_TYPE|SCHEME_(?:ADDRESS_SANITIZER|ADDRESS_SANITIZER_USE_AFTER_RETURN|ARGUMENTS|DISABLE_MAIN_THREAD_CHECKER|DYNAMIC_LIBRARY_LOADS|DYNAMIC_LINKER_API_USAGE|ENVIRONMENT|EXECUTABLE|GUARD_MALLOC|MAIN_THREAD_CHECKER_STOP|MALLOC_GUARD_EDGES|MALLOC_SCRIBBLE|MALLOC_STACK|THREAD_SANITIZER(?:_STOP)?|UNDEFINED_BEHAVIOUR_SANITIZER(?:_STOP)?|ZOMBIE_OBJECTS))|XCTEST)\b/,
        keyword: /\b(?:add_compile_definitions|add_compile_options|add_custom_command|add_custom_target|add_definitions|add_dependencies|add_executable|add_library|add_link_options|add_subdirectory|add_test|aux_source_directory|break|build_command|build_name|cmake_host_system_information|cmake_minimum_required|cmake_parse_arguments|cmake_policy|configure_file|continue|create_test_sourcelist|ctest_build|ctest_configure|ctest_coverage|ctest_empty_binary_directory|ctest_memcheck|ctest_read_custom_files|ctest_run_script|ctest_sleep|ctest_start|ctest_submit|ctest_test|ctest_update|ctest_upload|define_property|else|elseif|enable_language|enable_testing|endforeach|endfunction|endif|endmacro|endwhile|exec_program|execute_process|export|export_library_dependencies|file|find_file|find_library|find_package|find_path|find_program|fltk_wrap_ui|foreach|function|get_cmake_property|get_directory_property|get_filename_component|get_property|get_source_file_property|get_target_property|get_test_property|if|include|include_directories|include_external_msproject|include_guard|include_regular_expression|install|install_files|install_programs|install_targets|link_directories|link_libraries|list|load_cache|load_command|macro|make_directory|mark_as_advanced|math|message|option|output_required_files|project|qt_wrap_cpp|qt_wrap_ui|remove|remove_definitions|return|separate_arguments|set|set_directory_properties|set_property|set_source_files_properties|set_target_properties|set_tests_properties|site_name|source_group|string|subdir_depends|subdirs|target_compile_definitions|target_compile_features|target_compile_options|target_include_directories|target_link_directories|target_link_libraries|target_link_options|target_sources|try_compile|try_run|unset|use_mangled_mesa|utility_source|variable_requires|variable_watch|while|write_file)(?=\s*\()\b/,
        boolean: /\b(?:FALSE|OFF|ON|TRUE)\b/,
        namespace: /\b(?:INTERFACE|PRIVATE|PROPERTIES|PUBLIC|SHARED|STATIC|TARGET_OBJECTS)\b/,
        operator: /\b(?:AND|DEFINED|EQUAL|GREATER|LESS|MATCHES|NOT|OR|STREQUAL|STRGREATER|STRLESS|VERSION_EQUAL|VERSION_GREATER|VERSION_LESS)\b/,
        inserted: {
            pattern: /\b\w+::\w+\b/,
            alias: 'class-name'
        },
        number: /\b\d+(?:\.\d+)*\b/,
        function: /\b[a-z_]\w*(?=\s*\()\b/i,
        punctuation: /[()>}]|\$[<{]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $f86df18bcfea9f70$export$2e2bcd8739ae039.displayName = 'cobol';
$f86df18bcfea9f70$export$2e2bcd8739ae039.aliases = [];
function $f86df18bcfea9f70$export$2e2bcd8739ae039(Prism) {
    Prism.languages.cobol = {
        comment: {
            pattern: /\*>.*|(^[ \t]*)\*.*/m,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /[xzgn]?(?:"(?:[^\r\n"]|"")*"(?!")|'(?:[^\r\n']|'')*'(?!'))/i,
            greedy: true
        },
        level: {
            pattern: /(^[ \t]*)\d+\b/m,
            lookbehind: true,
            greedy: true,
            alias: 'number'
        },
        'class-name': {
            // https://github.com/antlr/grammars-v4/blob/42edd5b687d183b5fa679e858a82297bd27141e7/cobol85/Cobol85.g4#L1015
            pattern: /(\bpic(?:ture)?\s+)(?:(?:[-\w$/,:*+<>]|\.(?!\s|$))(?:\(\d+\))?)+/i,
            lookbehind: true,
            inside: {
                number: {
                    pattern: /(\()\d+/,
                    lookbehind: true
                },
                punctuation: /[()]/
            }
        },
        keyword: {
            pattern: /(^|[^\w-])(?:ABORT|ACCEPT|ACCESS|ADD|ADDRESS|ADVANCING|AFTER|ALIGNED|ALL|ALPHABET|ALPHABETIC|ALPHABETIC-LOWER|ALPHABETIC-UPPER|ALPHANUMERIC|ALPHANUMERIC-EDITED|ALSO|ALTER|ALTERNATE|ANY|ARE|AREA|AREAS|AS|ASCENDING|ASCII|ASSIGN|ASSOCIATED-DATA|ASSOCIATED-DATA-LENGTH|AT|ATTRIBUTE|AUTHOR|AUTO|AUTO-SKIP|BACKGROUND-COLOR|BACKGROUND-COLOUR|BASIS|BEEP|BEFORE|BEGINNING|BELL|BINARY|BIT|BLANK|BLINK|BLOCK|BOTTOM|BOUNDS|BY|BYFUNCTION|BYTITLE|CALL|CANCEL|CAPABLE|CCSVERSION|CD|CF|CH|CHAINING|CHANGED|CHANNEL|CHARACTER|CHARACTERS|CLASS|CLASS-ID|CLOCK-UNITS|CLOSE|CLOSE-DISPOSITION|COBOL|CODE|CODE-SET|COL|COLLATING|COLUMN|COM-REG|COMMA|COMMITMENT|COMMON|COMMUNICATION|COMP|COMP-1|COMP-2|COMP-3|COMP-4|COMP-5|COMPUTATIONAL|COMPUTATIONAL-1|COMPUTATIONAL-2|COMPUTATIONAL-3|COMPUTATIONAL-4|COMPUTATIONAL-5|COMPUTE|CONFIGURATION|CONTAINS|CONTENT|CONTINUE|CONTROL|CONTROL-POINT|CONTROLS|CONVENTION|CONVERTING|COPY|CORR|CORRESPONDING|COUNT|CRUNCH|CURRENCY|CURSOR|DATA|DATA-BASE|DATE|DATE-COMPILED|DATE-WRITTEN|DAY|DAY-OF-WEEK|DBCS|DE|DEBUG-CONTENTS|DEBUG-ITEM|DEBUG-LINE|DEBUG-NAME|DEBUG-SUB-1|DEBUG-SUB-2|DEBUG-SUB-3|DEBUGGING|DECIMAL-POINT|DECLARATIVES|DEFAULT|DEFAULT-DISPLAY|DEFINITION|DELETE|DELIMITED|DELIMITER|DEPENDING|DESCENDING|DESTINATION|DETAIL|DFHRESP|DFHVALUE|DISABLE|DISK|DISPLAY|DISPLAY-1|DIVIDE|DIVISION|DONTCARE|DOUBLE|DOWN|DUPLICATES|DYNAMIC|EBCDIC|EGCS|EGI|ELSE|EMI|EMPTY-CHECK|ENABLE|END|END-ACCEPT|END-ADD|END-CALL|END-COMPUTE|END-DELETE|END-DIVIDE|END-EVALUATE|END-IF|END-MULTIPLY|END-OF-PAGE|END-PERFORM|END-READ|END-RECEIVE|END-RETURN|END-REWRITE|END-SEARCH|END-START|END-STRING|END-SUBTRACT|END-UNSTRING|END-WRITE|ENDING|ENTER|ENTRY|ENTRY-PROCEDURE|ENVIRONMENT|EOL|EOP|EOS|ERASE|ERROR|ESCAPE|ESI|EVALUATE|EVENT|EVERY|EXCEPTION|EXCLUSIVE|EXHIBIT|EXIT|EXPORT|EXTEND|EXTENDED|EXTERNAL|FD|FILE|FILE-CONTROL|FILLER|FINAL|FIRST|FOOTING|FOR|FOREGROUND-COLOR|FOREGROUND-COLOUR|FROM|FULL|FUNCTION|FUNCTION-POINTER|FUNCTIONNAME|GENERATE|GIVING|GLOBAL|GO|GOBACK|GRID|GROUP|HEADING|HIGH-VALUE|HIGH-VALUES|HIGHLIGHT|I-O|I-O-CONTROL|ID|IDENTIFICATION|IF|IMPLICIT|IMPORT|IN|INDEX|INDEXED|INDICATE|INITIAL|INITIALIZE|INITIATE|INPUT|INPUT-OUTPUT|INSPECT|INSTALLATION|INTEGER|INTO|INVALID|INVOKE|IS|JUST|JUSTIFIED|KANJI|KEPT|KEY|KEYBOARD|LABEL|LANGUAGE|LAST|LB|LD|LEADING|LEFT|LEFTLINE|LENGTH|LENGTH-CHECK|LIBACCESS|LIBPARAMETER|LIBRARY|LIMIT|LIMITS|LINAGE|LINAGE-COUNTER|LINE|LINE-COUNTER|LINES|LINKAGE|LIST|LOCAL|LOCAL-STORAGE|LOCK|LONG-DATE|LONG-TIME|LOW-VALUE|LOW-VALUES|LOWER|LOWLIGHT|MEMORY|MERGE|MESSAGE|MMDDYYYY|MODE|MODULES|MORE-LABELS|MOVE|MULTIPLE|MULTIPLY|NAMED|NATIONAL|NATIONAL-EDITED|NATIVE|NEGATIVE|NETWORK|NEXT|NO|NO-ECHO|NULL|NULLS|NUMBER|NUMERIC|NUMERIC-DATE|NUMERIC-EDITED|NUMERIC-TIME|OBJECT-COMPUTER|OCCURS|ODT|OF|OFF|OMITTED|ON|OPEN|OPTIONAL|ORDER|ORDERLY|ORGANIZATION|OTHER|OUTPUT|OVERFLOW|OVERLINE|OWN|PACKED-DECIMAL|PADDING|PAGE|PAGE-COUNTER|PASSWORD|PERFORM|PF|PH|PIC|PICTURE|PLUS|POINTER|PORT|POSITION|POSITIVE|PRINTER|PRINTING|PRIVATE|PROCEDURE|PROCEDURE-POINTER|PROCEDURES|PROCEED|PROCESS|PROGRAM|PROGRAM-ID|PROGRAM-LIBRARY|PROMPT|PURGE|QUEUE|QUOTE|QUOTES|RANDOM|RD|READ|READER|REAL|RECEIVE|RECEIVED|RECORD|RECORDING|RECORDS|RECURSIVE|REDEFINES|REEL|REF|REFERENCE|REFERENCES|RELATIVE|RELEASE|REMAINDER|REMARKS|REMOTE|REMOVAL|REMOVE|RENAMES|REPLACE|REPLACING|REPORT|REPORTING|REPORTS|REQUIRED|RERUN|RESERVE|RESET|RETURN|RETURN-CODE|RETURNING|REVERSE-VIDEO|REVERSED|REWIND|REWRITE|RF|RH|RIGHT|ROUNDED|RUN|SAME|SAVE|SCREEN|SD|SEARCH|SECTION|SECURE|SECURITY|SEGMENT|SEGMENT-LIMIT|SELECT|SEND|SENTENCE|SEPARATE|SEQUENCE|SEQUENTIAL|SET|SHARED|SHAREDBYALL|SHAREDBYRUNUNIT|SHARING|SHIFT-IN|SHIFT-OUT|SHORT-DATE|SIGN|SIZE|SORT|SORT-CONTROL|SORT-CORE-SIZE|SORT-FILE-SIZE|SORT-MERGE|SORT-MESSAGE|SORT-MODE-SIZE|SORT-RETURN|SOURCE|SOURCE-COMPUTER|SPACE|SPACES|SPECIAL-NAMES|STANDARD|STANDARD-1|STANDARD-2|START|STATUS|STOP|STRING|SUB-QUEUE-1|SUB-QUEUE-2|SUB-QUEUE-3|SUBTRACT|SUM|SUPPRESS|SYMBOL|SYMBOLIC|SYNC|SYNCHRONIZED|TABLE|TALLY|TALLYING|TAPE|TASK|TERMINAL|TERMINATE|TEST|TEXT|THEN|THREAD|THREAD-LOCAL|THROUGH|THRU|TIME|TIMER|TIMES|TITLE|TO|TODAYS-DATE|TODAYS-NAME|TOP|TRAILING|TRUNCATED|TYPE|TYPEDEF|UNDERLINE|UNIT|UNSTRING|UNTIL|UP|UPON|USAGE|USE|USING|VALUE|VALUES|VARYING|VIRTUAL|WAIT|WHEN|WHEN-COMPILED|WITH|WORDS|WORKING-STORAGE|WRITE|YEAR|YYYYDDD|YYYYMMDD|ZERO-FILL|ZEROES|ZEROS)(?![\w-])/i,
            lookbehind: true
        },
        boolean: {
            pattern: /(^|[^\w-])(?:false|true)(?![\w-])/i,
            lookbehind: true
        },
        number: {
            pattern: /(^|[^\w-])(?:[+-]?(?:(?:\d+(?:[.,]\d+)?|[.,]\d+)(?:e[+-]?\d+)?|zero))(?![\w-])/i,
            lookbehind: true
        },
        operator: [
            /<>|[<>]=?|[=+*/&]/,
            {
                pattern: /(^|[^\w-])(?:-|and|equal|greater|less|not|or|than)(?![\w-])/i,
                lookbehind: true
            }
        ],
        punctuation: /[.:,()]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$f4e95d0947d511df$export$2e2bcd8739ae039.displayName = 'coffeescript';
$f4e95d0947d511df$export$2e2bcd8739ae039.aliases = [
    'coffee'
];
function $f4e95d0947d511df$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
    (function(Prism) {
        // Ignore comments starting with { to privilege string interpolation highlighting
        var comment = /#(?!\{).+/;
        var interpolation = {
            pattern: /#\{[^}]+\}/,
            alias: 'variable'
        };
        Prism.languages.coffeescript = Prism.languages.extend('javascript', {
            comment: comment,
            string: [
                // Strings are multiline
                {
                    pattern: /'(?:\\[\s\S]|[^\\'])*'/,
                    greedy: true
                },
                {
                    // Strings are multiline
                    pattern: /"(?:\\[\s\S]|[^\\"])*"/,
                    greedy: true,
                    inside: {
                        interpolation: interpolation
                    }
                }
            ],
            keyword: /\b(?:and|break|by|catch|class|continue|debugger|delete|do|each|else|extend|extends|false|finally|for|if|in|instanceof|is|isnt|let|loop|namespace|new|no|not|null|of|off|on|or|own|return|super|switch|then|this|throw|true|try|typeof|undefined|unless|until|when|while|window|with|yes|yield)\b/,
            'class-member': {
                pattern: /@(?!\d)\w+/,
                alias: 'variable'
            }
        });
        Prism.languages.insertBefore('coffeescript', 'comment', {
            'multiline-comment': {
                pattern: /###[\s\S]+?###/,
                alias: 'comment'
            },
            // Block regexp can contain comments and interpolation
            'block-regex': {
                pattern: /\/{3}[\s\S]*?\/{3}/,
                alias: 'regex',
                inside: {
                    comment: comment,
                    interpolation: interpolation
                }
            }
        });
        Prism.languages.insertBefore('coffeescript', 'string', {
            'inline-javascript': {
                pattern: /`(?:\\[\s\S]|[^\\`])*`/,
                inside: {
                    delimiter: {
                        pattern: /^`|`$/,
                        alias: 'punctuation'
                    },
                    script: {
                        pattern: /[\s\S]+/,
                        alias: 'language-javascript',
                        inside: Prism.languages.javascript
                    }
                }
            },
            // Block strings
            'multiline-string': [
                {
                    pattern: /'''[\s\S]*?'''/,
                    greedy: true,
                    alias: 'string'
                },
                {
                    pattern: /"""[\s\S]*?"""/,
                    greedy: true,
                    alias: 'string',
                    inside: {
                        interpolation: interpolation
                    }
                }
            ]
        });
        Prism.languages.insertBefore('coffeescript', 'keyword', {
            // Object property
            property: /(?!\d)\w+(?=\s*:(?!:))/
        });
        delete Prism.languages.coffeescript['template-string'];
        Prism.languages.coffee = Prism.languages.coffeescript;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $1f6beaffa93c6e28$export$2e2bcd8739ae039.displayName = 'concurnas';
$1f6beaffa93c6e28$export$2e2bcd8739ae039.aliases = [
    'conc'
];
function $1f6beaffa93c6e28$export$2e2bcd8739ae039(Prism) {
    Prism.languages.concurnas = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\/\/.*)/,
            lookbehind: true,
            greedy: true
        },
        langext: {
            pattern: /\b\w+\s*\|\|[\s\S]+?\|\|/,
            greedy: true,
            inside: {
                'class-name': /^\w+/,
                string: {
                    pattern: /(^\s*\|\|)[\s\S]+(?=\|\|$)/,
                    lookbehind: true
                },
                punctuation: /\|\|/
            }
        },
        function: {
            pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/,
            lookbehind: true
        },
        keyword: /\b(?:abstract|actor|also|annotation|assert|async|await|bool|boolean|break|byte|case|catch|changed|char|class|closed|constant|continue|def|default|del|double|elif|else|enum|every|extends|false|finally|float|for|from|global|gpudef|gpukernel|if|import|in|init|inject|int|lambda|local|long|loop|match|new|nodefault|null|of|onchange|open|out|override|package|parfor|parforsync|post|pre|private|protected|provide|provider|public|return|shared|short|single|size_t|sizeof|super|sync|this|throw|trait|trans|transient|true|try|typedef|unchecked|using|val|var|void|while|with)\b/,
        boolean: /\b(?:false|true)\b/,
        number: /\b0b[01][01_]*L?\b|\b0x(?:[\da-f_]*\.)?[\da-f_p+-]+\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfls]?/i,
        punctuation: /[{}[\];(),.:]/,
        operator: /<==|>==|=>|->|<-|<>|&==|&<>|\?:?|\.\?|\+\+|--|[-+*/=<>]=?|[!^~]|\b(?:and|as|band|bor|bxor|comp|is|isnot|mod|or)\b=?/,
        annotation: {
            pattern: /@(?:\w+:)?(?:\w+|\[[^\]]+\])?/,
            alias: 'builtin'
        }
    };
    Prism.languages.insertBefore('concurnas', 'langext', {
        'regex-literal': {
            pattern: /\br("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                    lookbehind: true,
                    inside: Prism.languages.concurnas
                },
                regex: /[\s\S]+/
            }
        },
        'string-literal': {
            pattern: /(?:\B|\bs)("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                    lookbehind: true,
                    inside: Prism.languages.concurnas
                },
                string: /[\s\S]+/
            }
        }
    });
    Prism.languages.conc = Prism.languages.concurnas;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $1fe20ac82cecf3eb$export$2e2bcd8739ae039.displayName = 'csp';
$1fe20ac82cecf3eb$export$2e2bcd8739ae039.aliases = [];
function $1fe20ac82cecf3eb$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        /**
     * @param {string} source
     * @returns {RegExp}
     */ function value(source) {
            return RegExp(/([ \t])/.source + '(?:' + source + ')' + /(?=[\s;]|$)/.source, 'i');
        }
        Prism.languages.csp = {
            directive: {
                pattern: /(^|[\s;])(?:base-uri|block-all-mixed-content|(?:child|connect|default|font|frame|img|manifest|media|object|prefetch|script|style|worker)-src|disown-opener|form-action|frame-(?:ancestors|options)|input-protection(?:-(?:clip|selectors))?|navigate-to|plugin-types|policy-uri|referrer|reflected-xss|report-(?:to|uri)|require-sri-for|sandbox|(?:script|style)-src-(?:attr|elem)|upgrade-insecure-requests)(?=[\s;]|$)/i,
                lookbehind: true,
                alias: 'property'
            },
            scheme: {
                pattern: value(/[a-z][a-z0-9.+-]*:/.source),
                lookbehind: true
            },
            none: {
                pattern: value(/'none'/.source),
                lookbehind: true,
                alias: 'keyword'
            },
            nonce: {
                pattern: value(/'nonce-[-+/\w=]+'/.source),
                lookbehind: true,
                alias: 'number'
            },
            hash: {
                pattern: value(/'sha(?:256|384|512)-[-+/\w=]+'/.source),
                lookbehind: true,
                alias: 'number'
            },
            host: {
                pattern: value(/[a-z][a-z0-9.+-]*:\/\/[^\s;,']*/.source + '|' + /\*[^\s;,']*/.source + '|' + /[a-z0-9-]+(?:\.[a-z0-9-]+)+(?::[\d*]+)?(?:\/[^\s;,']*)?/.source),
                lookbehind: true,
                alias: 'url',
                inside: {
                    important: /\*/
                }
            },
            keyword: [
                {
                    pattern: value(/'unsafe-[a-z-]+'/.source),
                    lookbehind: true,
                    alias: 'unsafe'
                },
                {
                    pattern: value(/'[a-z-]+'/.source),
                    lookbehind: true,
                    alias: 'safe'
                }
            ],
            punctuation: /;/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $debd1f6308a90423$export$2e2bcd8739ae039.displayName = 'cooklang';
$debd1f6308a90423$export$2e2bcd8739ae039.aliases = [];
function $debd1f6308a90423$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // see https://github.com/cooklang/spec/blob/main/EBNF.md
        var single_token_suffix = /(?:(?!\s)[\d$+<=a-zA-Z\x80-\uFFFF])+/.source;
        var multi_token_infix = /[^{}@#]+/.source;
        var multi_token_suffix = /\{[^}#@]*\}/.source;
        var multi_token = multi_token_infix + multi_token_suffix;
        var timer_units = /(?:h|hours|hrs|m|min|minutes)/.source;
        var amount_group_impl = {
            pattern: /\{[^{}]*\}/,
            inside: {
                amount: {
                    pattern: /([\{|])[^{}|*%]+/,
                    lookbehind: true,
                    alias: 'number'
                },
                unit: {
                    pattern: /(%)[^}]+/,
                    lookbehind: true,
                    alias: 'symbol'
                },
                'servings-scaler': {
                    pattern: /\*/,
                    alias: 'operator'
                },
                'servings-alternative-separator': {
                    pattern: /\|/,
                    alias: 'operator'
                },
                'unit-separator': {
                    pattern: /(?:%|(\*)%)/,
                    lookbehind: true,
                    alias: 'operator'
                },
                punctuation: /[{}]/
            }
        };
        Prism.languages.cooklang = {
            comment: {
                // [- comment -]
                // -- comment
                pattern: /\[-[\s\S]*?-\]|--.*/,
                greedy: true
            },
            meta: {
                // >> key: value
                pattern: />>.*:.*/,
                inside: {
                    property: {
                        // key:
                        pattern: /(>>\s*)[^\s:](?:[^:]*[^\s:])?/,
                        lookbehind: true
                    }
                }
            },
            'cookware-group': {
                // #...{...}, #...
                pattern: new RegExp('#(?:' + multi_token + '|' + single_token_suffix + ')'),
                inside: {
                    cookware: {
                        pattern: new RegExp('(^#)(?:' + multi_token_infix + ')'),
                        lookbehind: true,
                        alias: 'variable'
                    },
                    'cookware-keyword': {
                        pattern: /^#/,
                        alias: 'keyword'
                    },
                    'quantity-group': {
                        pattern: new RegExp(/\{[^{}@#]*\}/),
                        inside: {
                            quantity: {
                                pattern: new RegExp(/(^\{)/.source + multi_token_infix),
                                lookbehind: true,
                                alias: 'number'
                            },
                            punctuation: /[{}]/
                        }
                    }
                }
            },
            'ingredient-group': {
                // @...{...}, @...
                pattern: new RegExp('@(?:' + multi_token + '|' + single_token_suffix + ')'),
                inside: {
                    ingredient: {
                        pattern: new RegExp('(^@)(?:' + multi_token_infix + ')'),
                        lookbehind: true,
                        alias: 'variable'
                    },
                    'ingredient-keyword': {
                        pattern: /^@/,
                        alias: 'keyword'
                    },
                    'amount-group': amount_group_impl
                }
            },
            'timer-group': {
                // ~timer{...}
                // eslint-disable-next-line regexp/sort-alternatives
                pattern: /~(?!\s)[^@#~{}]*\{[^{}]*\}/,
                inside: {
                    timer: {
                        pattern: /(^~)[^{]+/,
                        lookbehind: true,
                        alias: 'variable'
                    },
                    'duration-group': {
                        // {...}
                        pattern: /\{[^{}]*\}/,
                        inside: {
                            punctuation: /[{}]/,
                            unit: {
                                pattern: new RegExp(/(%\s*)/.source + timer_units + /\b/.source),
                                lookbehind: true,
                                alias: 'symbol'
                            },
                            operator: /%/,
                            duration: {
                                pattern: /\d+/,
                                alias: 'number'
                            }
                        }
                    },
                    'timer-keyword': {
                        pattern: /^~/,
                        alias: 'keyword'
                    }
                }
            }
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $e8643cf3d5f78f91$export$2e2bcd8739ae039.displayName = 'coq';
$e8643cf3d5f78f91$export$2e2bcd8739ae039.aliases = [];
function $e8643cf3d5f78f91$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // https://github.com/coq/coq
        var commentSource = /\(\*(?:[^(*]|\((?!\*)|\*(?!\))|<self>)*\*\)/.source;
        for(var i = 0; i < 2; i++)commentSource = commentSource.replace(/<self>/g, function() {
            return commentSource;
        });
        commentSource = commentSource.replace(/<self>/g, '[]');
        Prism.languages.coq = {
            comment: RegExp(commentSource),
            string: {
                pattern: /"(?:[^"]|"")*"(?!")/,
                greedy: true
            },
            attribute: [
                {
                    pattern: RegExp(/#\[(?:[^\[\]("]|"(?:[^"]|"")*"(?!")|\((?!\*)|<comment>)*\]/.source.replace(/<comment>/g, function() {
                        return commentSource;
                    })),
                    greedy: true,
                    alias: 'attr-name',
                    inside: {
                        comment: RegExp(commentSource),
                        string: {
                            pattern: /"(?:[^"]|"")*"(?!")/,
                            greedy: true
                        },
                        operator: /=/,
                        punctuation: /^#\[|\]$|[,()]/
                    }
                },
                {
                    pattern: /\b(?:Cumulative|Global|Local|Monomorphic|NonCumulative|Polymorphic|Private|Program)\b/,
                    alias: 'attr-name'
                }
            ],
            keyword: /\b(?:Abort|About|Add|Admit|Admitted|All|Arguments|As|Assumptions|Axiom|Axioms|Back|BackTo|Backtrace|BinOp|BinOpSpec|BinRel|Bind|Blacklist|Canonical|Case|Cd|Check|Class|Classes|Close|CoFixpoint|CoInductive|Coercion|Coercions|Collection|Combined|Compute|Conjecture|Conjectures|Constant|Constants|Constraint|Constructors|Context|Corollary|Create|CstOp|Custom|Cut|Debug|Declare|Defined|Definition|Delimit|Dependencies|Dependent|Derive|Diffs|Drop|Elimination|End|Entry|Equality|Eval|Example|Existential|Existentials|Existing|Export|Extern|Extraction|Fact|Fail|Field|File|Firstorder|Fixpoint|Flags|Focus|From|Funclass|Function|Functional|GC|Generalizable|Goal|Grab|Grammar|Graph|Guarded|Haskell|Heap|Hide|Hint|HintDb|Hints|Hypotheses|Hypothesis|IF|Identity|Immediate|Implicit|Implicits|Import|Include|Induction|Inductive|Infix|Info|Initial|InjTyp|Inline|Inspect|Instance|Instances|Intro|Intros|Inversion|Inversion_clear|JSON|Language|Left|Lemma|Let|Lia|Libraries|Library|Load|LoadPath|Locate|Ltac|Ltac2|ML|Match|Method|Minimality|Module|Modules|Morphism|Next|NoInline|Notation|Number|OCaml|Obligation|Obligations|Opaque|Open|Optimize|Parameter|Parameters|Parametric|Path|Paths|Prenex|Preterm|Primitive|Print|Profile|Projections|Proof|Prop|PropBinOp|PropOp|PropUOp|Property|Proposition|Pwd|Qed|Quit|Rec|Record|Recursive|Redirect|Reduction|Register|Relation|Remark|Remove|Require|Reserved|Reset|Resolve|Restart|Rewrite|Right|Ring|Rings|SProp|Saturate|Save|Scheme|Scope|Scopes|Search|SearchHead|SearchPattern|SearchRewrite|Section|Separate|Set|Setoid|Show|Signatures|Solve|Solver|Sort|Sortclass|Sorted|Spec|Step|Strategies|Strategy|String|Structure|SubClass|Subgraph|SuchThat|Tactic|Term|TestCompile|Theorem|Time|Timeout|To|Transparent|Type|Typeclasses|Types|Typing|UnOp|UnOpSpec|Undelimit|Undo|Unfocus|Unfocused|Unfold|Universe|Universes|Unshelve|Variable|Variables|Variant|Verbose|View|Visibility|Zify|_|apply|as|at|by|cofix|else|end|exists|exists2|fix|for|forall|fun|if|in|let|match|measure|move|removed|return|struct|then|using|wf|where|with)\b/,
            number: /\b(?:0x[a-f0-9][a-f0-9_]*(?:\.[a-f0-9_]+)?(?:p[+-]?\d[\d_]*)?|\d[\d_]*(?:\.[\d_]+)?(?:e[+-]?\d[\d_]*)?)\b/i,
            punct: {
                pattern: /@\{|\{\||\[=|:>/,
                alias: 'punctuation'
            },
            operator: /\/\\|\\\/|\.{2,3}|:{1,2}=|\*\*|[-=]>|<(?:->?|[+:=>]|<:)|>(?:=|->)|\|[-|]?|[-!%&*+/<=>?@^~']/,
            punctuation: /\.\(|`\(|@\{|`\{|\{\||\[=|:>|[:.,;(){}\[\]]/
        };
    })(Prism);
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$4f8b5c37b37db49e$export$2e2bcd8739ae039.displayName = 'crystal';
$4f8b5c37b37db49e$export$2e2bcd8739ae039.aliases = [];
function $4f8b5c37b37db49e$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $0814f5761e025965$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.crystal = Prism.languages.extend('ruby', {
            keyword: [
                /\b(?:__DIR__|__END_LINE__|__FILE__|__LINE__|abstract|alias|annotation|as|asm|begin|break|case|class|def|do|else|elsif|end|ensure|enum|extend|for|fun|if|ifdef|include|instance_sizeof|lib|macro|module|next|of|out|pointerof|private|protected|ptr|require|rescue|return|select|self|sizeof|struct|super|then|type|typeof|undef|uninitialized|union|unless|until|when|while|with|yield)\b/,
                {
                    pattern: /(\.\s*)(?:is_a|responds_to)\?/,
                    lookbehind: true
                }
            ],
            number: /\b(?:0b[01_]*[01]|0o[0-7_]*[0-7]|0x[\da-fA-F_]*[\da-fA-F]|(?:\d(?:[\d_]*\d)?)(?:\.[\d_]*\d)?(?:[eE][+-]?[\d_]*\d)?)(?:_(?:[uif](?:8|16|32|64))?)?\b/,
            operator: [
                /->/,
                Prism.languages.ruby.operator
            ],
            punctuation: /[(){}[\].,;\\]/
        });
        Prism.languages.insertBefore('crystal', 'string-literal', {
            attribute: {
                pattern: /@\[.*?\]/,
                inside: {
                    delimiter: {
                        pattern: /^@\[|\]$/,
                        alias: 'punctuation'
                    },
                    attribute: {
                        pattern: /^(\s*)\w+/,
                        lookbehind: true,
                        alias: 'class-name'
                    },
                    args: {
                        pattern: /\S(?:[\s\S]*\S)?/,
                        inside: Prism.languages.crystal
                    }
                }
            },
            expansion: {
                pattern: /\{(?:\{.*?\}|%.*?%)\}/,
                inside: {
                    content: {
                        pattern: /^(\{.)[\s\S]+(?=.\}$)/,
                        lookbehind: true,
                        inside: Prism.languages.crystal
                    },
                    delimiter: {
                        pattern: /^\{[\{%]|[\}%]\}$/,
                        alias: 'operator'
                    }
                }
            },
            char: {
                pattern: /'(?:[^\\\r\n]{1,2}|\\(?:.|u(?:[A-Fa-f0-9]{1,4}|\{[A-Fa-f0-9]{1,6}\})))'/,
                greedy: true
            }
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$a0274c81b19638e1$export$2e2bcd8739ae039.displayName = 'css-extras';
$a0274c81b19638e1$export$2e2bcd8739ae039.aliases = [];
function $a0274c81b19638e1$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $8467c3aacdff56ee$export$2e2bcd8739ae039));
    (function(Prism) {
        var string = /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/;
        var selectorInside;
        Prism.languages.css.selector = {
            pattern: Prism.languages.css.selector.pattern,
            lookbehind: true,
            inside: selectorInside = {
                'pseudo-element': /:(?:after|before|first-letter|first-line|selection)|::[-\w]+/,
                'pseudo-class': /:[-\w]+/,
                class: /\.[-\w]+/,
                id: /#[-\w]+/,
                attribute: {
                    pattern: RegExp('\\[(?:[^[\\]"\']|' + string.source + ')*\\]'),
                    greedy: true,
                    inside: {
                        punctuation: /^\[|\]$/,
                        'case-sensitivity': {
                            pattern: /(\s)[si]$/i,
                            lookbehind: true,
                            alias: 'keyword'
                        },
                        namespace: {
                            pattern: /^(\s*)(?:(?!\s)[-*\w\xA0-\uFFFF])*\|(?!=)/,
                            lookbehind: true,
                            inside: {
                                punctuation: /\|$/
                            }
                        },
                        'attr-name': {
                            pattern: /^(\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+/,
                            lookbehind: true
                        },
                        'attr-value': [
                            string,
                            {
                                pattern: /(=\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+(?=\s*$)/,
                                lookbehind: true
                            }
                        ],
                        operator: /[|~*^$]?=/
                    }
                },
                'n-th': [
                    {
                        pattern: /(\(\s*)[+-]?\d*[\dn](?:\s*[+-]\s*\d+)?(?=\s*\))/,
                        lookbehind: true,
                        inside: {
                            number: /[\dn]+/,
                            operator: /[+-]/
                        }
                    },
                    {
                        pattern: /(\(\s*)(?:even|odd)(?=\s*\))/i,
                        lookbehind: true
                    }
                ],
                combinator: />|\+|~|\|\|/,
                // the `tag` token has been existed and removed.
                // because we can't find a perfect tokenize to match it.
                // if you want to add it, please read https://github.com/PrismJS/prism/pull/2373 first.
                punctuation: /[(),]/
            }
        };
        Prism.languages.css['atrule'].inside['selector-function-argument'].inside = selectorInside;
        Prism.languages.insertBefore('css', 'property', {
            variable: {
                pattern: /(^|[^-\w\xA0-\uFFFF])--(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*/i,
                lookbehind: true
            }
        });
        var unit = {
            pattern: /(\b\d+)(?:%|[a-z]+(?![\w-]))/,
            lookbehind: true
        };
        // 123 -123 .123 -.123 12.3 -12.3
        var number = {
            pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
            lookbehind: true
        };
        Prism.languages.insertBefore('css', 'function', {
            operator: {
                pattern: /(\s)[+\-*\/](?=\s)/,
                lookbehind: true
            },
            // CAREFUL!
            // Previewers and Inline color use hexcode and color.
            hexcode: {
                pattern: /\B#[\da-f]{3,8}\b/i,
                alias: 'color'
            },
            color: [
                {
                    pattern: /(^|[^\w-])(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|RebeccaPurple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)(?![\w-])/i,
                    lookbehind: true
                },
                {
                    pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
                    inside: {
                        unit: unit,
                        number: number,
                        function: /[\w-]+(?=\()/,
                        punctuation: /[(),]/
                    }
                }
            ],
            // it's important that there is no boundary assertion after the hex digits
            entity: /\\[\da-f]{1,8}/i,
            unit: unit,
            number: number
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $732efa98354ef152$export$2e2bcd8739ae039.displayName = 'csv';
$732efa98354ef152$export$2e2bcd8739ae039.aliases = [];
function $732efa98354ef152$export$2e2bcd8739ae039(Prism) {
    // https://tools.ietf.org/html/rfc4180
    Prism.languages.csv = {
        value: /[^\r\n,"]+|"(?:[^"]|"")*"(?!")/,
        punctuation: /,/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $4c72dd9423c79b65$export$2e2bcd8739ae039.displayName = 'cue';
$4c72dd9423c79b65$export$2e2bcd8739ae039.aliases = [];
function $4c72dd9423c79b65$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // https://cuelang.org/docs/references/spec/
        // eslint-disable-next-line regexp/strict
        var stringEscape = /\\(?:(?!\2)|\2(?:[^()\r\n]|\([^()]*\)))/.source;
        // eslint-disable-next-line regexp/strict
        var stringTypes = /"""(?:[^\\"]|"(?!""\2)|<esc>)*"""/.source + // eslint-disable-next-line regexp/strict
        '|' + /'''(?:[^\\']|'(?!''\2)|<esc>)*'''/.source + // eslint-disable-next-line regexp/strict
        '|' + /"(?:[^\\\r\n"]|"(?!\2)|<esc>)*"/.source + // eslint-disable-next-line regexp/strict
        '|' + /'(?:[^\\\r\n']|'(?!\2)|<esc>)*'/.source;
        var stringLiteral = '(?:' + stringTypes.replace(/<esc>/g, stringEscape) + ')';
        Prism.languages.cue = {
            comment: {
                pattern: /\/\/.*/,
                greedy: true
            },
            'string-literal': {
                // eslint-disable-next-line regexp/strict
                pattern: RegExp(/(^|[^#"'\\])(#*)/.source + stringLiteral + /(?!["'])\2/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    // I'm using dirty hack here. We have to know the number hashes at the start of the string somehow,
                    // but we can't look back. So instead, we will use a lookahead, go to the end of the string, and
                    // capture the hashes at the end of the string.
                    escape: {
                        pattern: /(?=[\s\S]*["'](#*)$)\\\1(?:U[a-fA-F0-9]{1,8}|u[a-fA-F0-9]{1,4}|x[a-fA-F0-9]{1,2}|\d{2,3}|[^(])/,
                        greedy: true,
                        alias: 'string'
                    },
                    interpolation: {
                        pattern: /(?=[\s\S]*["'](#*)$)\\\1\([^()]*\)/,
                        greedy: true,
                        inside: {
                            punctuation: /^\\#*\(|\)$/,
                            expression: {
                                pattern: /[\s\S]+/,
                                inside: null
                            }
                        }
                    },
                    string: /[\s\S]+/
                }
            },
            keyword: {
                pattern: /(^|[^\w$])(?:for|if|import|in|let|null|package)(?![\w$])/,
                lookbehind: true
            },
            boolean: {
                pattern: /(^|[^\w$])(?:false|true)(?![\w$])/,
                lookbehind: true
            },
            builtin: {
                pattern: /(^|[^\w$])(?:bool|bytes|float|float(?:32|64)|u?int(?:8|16|32|64|128)?|number|rune|string)(?![\w$])/,
                lookbehind: true
            },
            attribute: {
                pattern: /@[\w$]+(?=\s*\()/,
                alias: 'function'
            },
            function: {
                pattern: /(^|[^\w$])[a-z_$][\w$]*(?=\s*\()/i,
                lookbehind: true
            },
            number: {
                pattern: /(^|[^\w$.])(?:0b[01]+(?:_[01]+)*|0o[0-7]+(?:_[0-7]+)*|0[xX][0-9A-Fa-f]+(?:_[0-9A-Fa-f]+)*|(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[eE][+-]?\d+(?:_\d+)*)?(?:[KMGTP]i?)?)(?![\w$])/,
                lookbehind: true
            },
            operator: /\.{3}|_\|_|&&?|\|\|?|[=!]~|[<>=!]=?|[+\-*/?]/,
            punctuation: /[()[\]{},.:]/
        };
        Prism.languages.cue['string-literal'].inside.interpolation.inside.expression.inside = Prism.languages.cue;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $4849b6a31c9f2c50$export$2e2bcd8739ae039.displayName = 'cypher';
$4849b6a31c9f2c50$export$2e2bcd8739ae039.aliases = [];
function $4849b6a31c9f2c50$export$2e2bcd8739ae039(Prism) {
    Prism.languages.cypher = {
        // https://neo4j.com/docs/cypher-manual/current/syntax/comments/
        comment: /\/\/.*/,
        string: {
            pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/,
            greedy: true
        },
        'class-name': {
            pattern: /(:\s*)(?:\w+|`(?:[^`\\\r\n])*`)(?=\s*[{):])/,
            lookbehind: true,
            greedy: true
        },
        relationship: {
            pattern: /(-\[\s*(?:\w+\s*|`(?:[^`\\\r\n])*`\s*)?:\s*|\|\s*:\s*)(?:\w+|`(?:[^`\\\r\n])*`)/,
            lookbehind: true,
            greedy: true,
            alias: 'property'
        },
        identifier: {
            pattern: /`(?:[^`\\\r\n])*`/,
            greedy: true
        },
        variable: /\$\w+/,
        // https://neo4j.com/docs/cypher-manual/current/syntax/reserved/
        keyword: /\b(?:ADD|ALL|AND|AS|ASC|ASCENDING|ASSERT|BY|CALL|CASE|COMMIT|CONSTRAINT|CONTAINS|CREATE|CSV|DELETE|DESC|DESCENDING|DETACH|DISTINCT|DO|DROP|ELSE|END|ENDS|EXISTS|FOR|FOREACH|IN|INDEX|IS|JOIN|KEY|LIMIT|LOAD|MANDATORY|MATCH|MERGE|NODE|NOT|OF|ON|OPTIONAL|OR|ORDER(?=\s+BY)|PERIODIC|REMOVE|REQUIRE|RETURN|SCALAR|SCAN|SET|SKIP|START|STARTS|THEN|UNION|UNIQUE|UNWIND|USING|WHEN|WHERE|WITH|XOR|YIELD)\b/i,
        function: /\b\w+\b(?=\s*\()/,
        boolean: /\b(?:false|null|true)\b/i,
        number: /\b(?:0x[\da-fA-F]+|\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)\b/,
        // https://neo4j.com/docs/cypher-manual/current/syntax/operators/
        operator: /:|<--?|--?>?|<>|=~?|[<>]=?|[+*/%^|]|\.\.\.?/,
        punctuation: /[()[\]{},;.]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$d96e6553b79e688e$export$2e2bcd8739ae039.displayName = 'd';
$d96e6553b79e688e$export$2e2bcd8739ae039.aliases = [];
function $d96e6553b79e688e$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.d = Prism.languages.extend('clike', {
        comment: [
            {
                // Shebang
                pattern: /^\s*#!.+/,
                greedy: true
            },
            {
                pattern: RegExp(/(^|[^\\])/.source + '(?:' + [
                    // /+ comment +/
                    // Allow one level of nesting
                    /\/\+(?:\/\+(?:[^+]|\+(?!\/))*\+\/|(?!\/\+)[\s\S])*?\+\//.source,
                    // // comment
                    /\/\/.*/.source,
                    // /* comment */
                    /\/\*[\s\S]*?\*\//.source
                ].join('|') + ')'),
                lookbehind: true,
                greedy: true
            }
        ],
        string: [
            {
                pattern: RegExp([
                    // r"", x""
                    /\b[rx]"(?:\\[\s\S]|[^\\"])*"[cwd]?/.source,
                    // q"[]", q"()", q"<>", q"{}"
                    /\bq"(?:\[[\s\S]*?\]|\([\s\S]*?\)|<[\s\S]*?>|\{[\s\S]*?\})"/.source,
                    // q"IDENT
                    // ...
                    // IDENT"
                    /\bq"((?!\d)\w+)$[\s\S]*?^\1"/.source,
                    // q"//", q"||", etc.
                    // eslint-disable-next-line regexp/strict
                    /\bq"(.)[\s\S]*?\2"/.source,
                    // eslint-disable-next-line regexp/strict
                    /(["`])(?:\\[\s\S]|(?!\3)[^\\])*\3[cwd]?/.source
                ].join('|'), 'm'),
                greedy: true
            },
            {
                pattern: /\bq\{(?:\{[^{}]*\}|[^{}])*\}/,
                greedy: true,
                alias: 'token-string'
            }
        ],
        // In order: $, keywords and special tokens, globally defined symbols
        keyword: /\$|\b(?:__(?:(?:DATE|EOF|FILE|FUNCTION|LINE|MODULE|PRETTY_FUNCTION|TIMESTAMP|TIME|VENDOR|VERSION)__|gshared|parameters|traits|vector)|abstract|alias|align|asm|assert|auto|body|bool|break|byte|case|cast|catch|cdouble|cent|cfloat|char|class|const|continue|creal|dchar|debug|default|delegate|delete|deprecated|do|double|dstring|else|enum|export|extern|false|final|finally|float|for|foreach|foreach_reverse|function|goto|idouble|if|ifloat|immutable|import|inout|int|interface|invariant|ireal|lazy|long|macro|mixin|module|new|nothrow|null|out|override|package|pragma|private|protected|ptrdiff_t|public|pure|real|ref|return|scope|shared|short|size_t|static|string|struct|super|switch|synchronized|template|this|throw|true|try|typedef|typeid|typeof|ubyte|ucent|uint|ulong|union|unittest|ushort|version|void|volatile|wchar|while|with|wstring)\b/,
        number: [
            // The lookbehind and the negative look-ahead try to prevent bad highlighting of the .. operator
            // Hexadecimal numbers must be handled separately to avoid problems with exponent "e"
            /\b0x\.?[a-f\d_]+(?:(?!\.\.)\.[a-f\d_]*)?(?:p[+-]?[a-f\d_]+)?[ulfi]{0,4}/i,
            {
                pattern: /((?:\.\.)?)(?:\b0b\.?|\b|\.)\d[\d_]*(?:(?!\.\.)\.[\d_]*)?(?:e[+-]?\d[\d_]*)?[ulfi]{0,4}/i,
                lookbehind: true
            }
        ],
        operator: /\|[|=]?|&[&=]?|\+[+=]?|-[-=]?|\.?\.\.|=[>=]?|!(?:i[ns]\b|<>?=?|>=?|=)?|\bi[ns]\b|(?:<[<>]?|>>?>?|\^\^|[*\/%^~])=?/
    });
    Prism.languages.insertBefore('d', 'string', {
        // Characters
        // 'a', '\\', '\n', '\xFF', '\377', '\uFFFF', '\U0010FFFF', '\quot'
        char: /'(?:\\(?:\W|\w+)|[^\\])'/
    });
    Prism.languages.insertBefore('d', 'keyword', {
        property: /\B@\w*/
    });
    Prism.languages.insertBefore('d', 'function', {
        register: {
            // Iasm registers
            pattern: /\b(?:[ABCD][LHX]|E?(?:BP|DI|SI|SP)|[BS]PL|[ECSDGF]S|CR[0234]|[DS]IL|DR[012367]|E[ABCD]X|X?MM[0-7]|R(?:1[0-5]|[89])[BWD]?|R[ABCD]X|R[BS]P|R[DS]I|TR[3-7]|XMM(?:1[0-5]|[89])|YMM(?:1[0-5]|\d))\b|\bST(?:\([0-7]\)|\b)/,
            alias: 'variable'
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$74043824b764ef3e$export$2e2bcd8739ae039.displayName = 'dart';
$74043824b764ef3e$export$2e2bcd8739ae039.aliases = [];
function $74043824b764ef3e$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    (function(Prism) {
        var keywords = [
            /\b(?:async|sync|yield)\*/,
            /\b(?:abstract|assert|async|await|break|case|catch|class|const|continue|covariant|default|deferred|do|dynamic|else|enum|export|extends|extension|external|factory|final|finally|for|get|hide|if|implements|import|in|interface|library|mixin|new|null|on|operator|part|rethrow|return|set|show|static|super|switch|sync|this|throw|try|typedef|var|void|while|with|yield)\b/
        ];
        // Handles named imports, such as http.Client
        var packagePrefix = /(^|[^\w.])(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source;
        // based on the dart naming conventions
        var className = {
            pattern: RegExp(packagePrefix + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
            lookbehind: true,
            inside: {
                namespace: {
                    pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
                    inside: {
                        punctuation: /\./
                    }
                }
            }
        };
        Prism.languages.dart = Prism.languages.extend('clike', {
            'class-name': [
                className,
                {
                    // variables and parameters
                    // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
                    pattern: RegExp(packagePrefix + /[A-Z]\w*(?=\s+\w+\s*[;,=()])/.source),
                    lookbehind: true,
                    inside: className.inside
                }
            ],
            keyword: keywords,
            operator: /\bis!|\b(?:as|is)\b|\+\+|--|&&|\|\||<<=?|>>=?|~(?:\/=?)?|[+\-*\/%&^|=!<>]=?|\?/
        });
        Prism.languages.insertBefore('dart', 'string', {
            'string-literal': {
                pattern: /r?(?:("""|''')[\s\S]*?\1|(["'])(?:\\.|(?!\2)[^\\\r\n])*\2(?!\2))/,
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\w+|\{(?:[^{}]|\{[^{}]*\})*\})/,
                        lookbehind: true,
                        inside: {
                            punctuation: /^\$\{?|\}$/,
                            expression: {
                                pattern: /[\s\S]+/,
                                inside: Prism.languages.dart
                            }
                        }
                    },
                    string: /[\s\S]+/
                }
            },
            string: undefined
        });
        Prism.languages.insertBefore('dart', 'class-name', {
            metadata: {
                pattern: /@\w+/,
                alias: 'function'
            }
        });
        Prism.languages.insertBefore('dart', 'class-name', {
            generics: {
                pattern: /<(?:[\w\s,.&?]|<(?:[\w\s,.&?]|<(?:[\w\s,.&?]|<[\w\s,.&?]*>)*>)*>)*>/,
                inside: {
                    'class-name': className,
                    keyword: keywords,
                    punctuation: /[<>(),.:]/,
                    operator: /[?&|]/
                }
            }
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $a2a3ecd8671a9cb9$export$2e2bcd8739ae039.displayName = 'dataweave';
$a2a3ecd8671a9cb9$export$2e2bcd8739ae039.aliases = [];
function $a2a3ecd8671a9cb9$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.dataweave = {
            url: /\b[A-Za-z]+:\/\/[\w/:.?=&-]+|\burn:[\w:.?=&-]+/,
            property: {
                pattern: /(?:\b\w+#)?(?:"(?:\\.|[^\\"\r\n])*"|\b\w+)(?=\s*[:@])/,
                greedy: true
            },
            string: {
                pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
                greedy: true
            },
            'mime-type': /\b(?:application|audio|image|multipart|text|video)\/[\w+-]+/,
            date: {
                pattern: /\|[\w:+-]+\|/,
                greedy: true
            },
            comment: [
                {
                    pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    pattern: /(^|[^\\:])\/\/.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            regex: {
                pattern: /\/(?:[^\\\/\r\n]|\\[^\r\n])+\//,
                greedy: true
            },
            keyword: /\b(?:and|as|at|case|do|else|fun|if|input|is|match|not|ns|null|or|output|type|unless|update|using|var)\b/,
            function: /\b[A-Z_]\w*(?=\s*\()/i,
            number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
            punctuation: /[{}[\];(),.:@]/,
            operator: /<<|>>|->|[<>~=]=?|!=|--?-?|\+\+?|!|\?/,
            boolean: /\b(?:false|true)\b/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $456d34d6a0e808d3$export$2e2bcd8739ae039.displayName = 'dax';
$456d34d6a0e808d3$export$2e2bcd8739ae039.aliases = [];
function $456d34d6a0e808d3$export$2e2bcd8739ae039(Prism) {
    Prism.languages.dax = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/).*)/,
            lookbehind: true
        },
        'data-field': {
            pattern: /'(?:[^']|'')*'(?!')(?:\[[ \w\xA0-\uFFFF]+\])?|\w+\[[ \w\xA0-\uFFFF]+\]/,
            alias: 'symbol'
        },
        measure: {
            pattern: /\[[ \w\xA0-\uFFFF]+\]/,
            alias: 'constant'
        },
        string: {
            pattern: /"(?:[^"]|"")*"(?!")/,
            greedy: true
        },
        function: /\b(?:ABS|ACOS|ACOSH|ACOT|ACOTH|ADDCOLUMNS|ADDMISSINGITEMS|ALL|ALLCROSSFILTERED|ALLEXCEPT|ALLNOBLANKROW|ALLSELECTED|AND|APPROXIMATEDISTINCTCOUNT|ASIN|ASINH|ATAN|ATANH|AVERAGE|AVERAGEA|AVERAGEX|BETA\.DIST|BETA\.INV|BLANK|CALCULATE|CALCULATETABLE|CALENDAR|CALENDARAUTO|CEILING|CHISQ\.DIST|CHISQ\.DIST\.RT|CHISQ\.INV|CHISQ\.INV\.RT|CLOSINGBALANCEMONTH|CLOSINGBALANCEQUARTER|CLOSINGBALANCEYEAR|COALESCE|COMBIN|COMBINA|COMBINEVALUES|CONCATENATE|CONCATENATEX|CONFIDENCE\.NORM|CONFIDENCE\.T|CONTAINS|CONTAINSROW|CONTAINSSTRING|CONTAINSSTRINGEXACT|CONVERT|COS|COSH|COT|COTH|COUNT|COUNTA|COUNTAX|COUNTBLANK|COUNTROWS|COUNTX|CROSSFILTER|CROSSJOIN|CURRENCY|CURRENTGROUP|CUSTOMDATA|DATATABLE|DATE|DATEADD|DATEDIFF|DATESBETWEEN|DATESINPERIOD|DATESMTD|DATESQTD|DATESYTD|DATEVALUE|DAY|DEGREES|DETAILROWS|DISTINCT|DISTINCTCOUNT|DISTINCTCOUNTNOBLANK|DIVIDE|EARLIER|EARLIEST|EDATE|ENDOFMONTH|ENDOFQUARTER|ENDOFYEAR|EOMONTH|ERROR|EVEN|EXACT|EXCEPT|EXP|EXPON\.DIST|FACT|FALSE|FILTER|FILTERS|FIND|FIRSTDATE|FIRSTNONBLANK|FIRSTNONBLANKVALUE|FIXED|FLOOR|FORMAT|GCD|GENERATE|GENERATEALL|GENERATESERIES|GEOMEAN|GEOMEANX|GROUPBY|HASONEFILTER|HASONEVALUE|HOUR|IF|IF\.EAGER|IFERROR|IGNORE|INT|INTERSECT|ISBLANK|ISCROSSFILTERED|ISEMPTY|ISERROR|ISEVEN|ISFILTERED|ISINSCOPE|ISLOGICAL|ISNONTEXT|ISNUMBER|ISO\.CEILING|ISODD|ISONORAFTER|ISSELECTEDMEASURE|ISSUBTOTAL|ISTEXT|KEEPFILTERS|KEYWORDMATCH|LASTDATE|LASTNONBLANK|LASTNONBLANKVALUE|LCM|LEFT|LEN|LN|LOG|LOG10|LOOKUPVALUE|LOWER|MAX|MAXA|MAXX|MEDIAN|MEDIANX|MID|MIN|MINA|MINUTE|MINX|MOD|MONTH|MROUND|NATURALINNERJOIN|NATURALLEFTOUTERJOIN|NEXTDAY|NEXTMONTH|NEXTQUARTER|NEXTYEAR|NONVISUAL|NORM\.DIST|NORM\.INV|NORM\.S\.DIST|NORM\.S\.INV|NOT|NOW|ODD|OPENINGBALANCEMONTH|OPENINGBALANCEQUARTER|OPENINGBALANCEYEAR|OR|PARALLELPERIOD|PATH|PATHCONTAINS|PATHITEM|PATHITEMREVERSE|PATHLENGTH|PERCENTILE\.EXC|PERCENTILE\.INC|PERCENTILEX\.EXC|PERCENTILEX\.INC|PERMUT|PI|POISSON\.DIST|POWER|PREVIOUSDAY|PREVIOUSMONTH|PREVIOUSQUARTER|PREVIOUSYEAR|PRODUCT|PRODUCTX|QUARTER|QUOTIENT|RADIANS|RAND|RANDBETWEEN|RANK\.EQ|RANKX|RELATED|RELATEDTABLE|REMOVEFILTERS|REPLACE|REPT|RIGHT|ROLLUP|ROLLUPADDISSUBTOTAL|ROLLUPGROUP|ROLLUPISSUBTOTAL|ROUND|ROUNDDOWN|ROUNDUP|ROW|SAMEPERIODLASTYEAR|SAMPLE|SEARCH|SECOND|SELECTCOLUMNS|SELECTEDMEASURE|SELECTEDMEASUREFORMATSTRING|SELECTEDMEASURENAME|SELECTEDVALUE|SIGN|SIN|SINH|SQRT|SQRTPI|STARTOFMONTH|STARTOFQUARTER|STARTOFYEAR|STDEV\.P|STDEV\.S|STDEVX\.P|STDEVX\.S|SUBSTITUTE|SUBSTITUTEWITHINDEX|SUM|SUMMARIZE|SUMMARIZECOLUMNS|SUMX|SWITCH|T\.DIST|T\.DIST\.2T|T\.DIST\.RT|T\.INV|T\.INV\.2T|TAN|TANH|TIME|TIMEVALUE|TODAY|TOPN|TOPNPERLEVEL|TOPNSKIP|TOTALMTD|TOTALQTD|TOTALYTD|TREATAS|TRIM|TRUE|TRUNC|UNICHAR|UNICODE|UNION|UPPER|USERELATIONSHIP|USERNAME|USEROBJECTID|USERPRINCIPALNAME|UTCNOW|UTCTODAY|VALUE|VALUES|VAR\.P|VAR\.S|VARX\.P|VARX\.S|WEEKDAY|WEEKNUM|XIRR|XNPV|YEAR|YEARFRAC)(?=\s*\()/i,
        keyword: /\b(?:DEFINE|EVALUATE|MEASURE|ORDER\s+BY|RETURN|VAR|START\s+AT|ASC|DESC)\b/i,
        boolean: {
            pattern: /\b(?:FALSE|NULL|TRUE)\b/i,
            alias: 'constant'
        },
        number: /\b\d+(?:\.\d*)?|\B\.\d+\b/,
        operator: /:=|[-+*\/=^]|&&?|\|\||<(?:=>?|<|>)?|>[>=]?|\b(?:IN|NOT)\b/i,
        punctuation: /[;\[\](){}`,.]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $09fb00aefac0036e$export$2e2bcd8739ae039.displayName = 'dhall';
$09fb00aefac0036e$export$2e2bcd8739ae039.aliases = [];
function $09fb00aefac0036e$export$2e2bcd8739ae039(Prism) {
    // ABNF grammar:
    // https://github.com/dhall-lang/dhall-lang/blob/master/standard/dhall.abnf
    Prism.languages.dhall = {
        // Multi-line comments can be nested. E.g. {- foo {- bar -} -}
        // The multi-line pattern is essentially this:
        //   \{-(?:[^-{]|-(?!\})|\{(?!-)|<SELF>)*-\}
        comment: /--.*|\{-(?:[^-{]|-(?!\})|\{(?!-)|\{-(?:[^-{]|-(?!\})|\{(?!-))*-\})*-\}/,
        string: {
            pattern: /"(?:[^"\\]|\\.)*"|''(?:[^']|'(?!')|'''|''\$\{)*''(?!'|\$)/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /\$\{[^{}]*\}/,
                    inside: {
                        expression: {
                            pattern: /(^\$\{)[\s\S]+(?=\}$)/,
                            lookbehind: true,
                            alias: 'language-dhall',
                            inside: null // see blow
                        },
                        punctuation: /\$\{|\}/
                    }
                }
            }
        },
        label: {
            pattern: /`[^`]*`/,
            greedy: true
        },
        url: {
            // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L596
            pattern: /\bhttps?:\/\/[\w.:%!$&'*+;=@~-]+(?:\/[\w.:%!$&'*+;=@~-]*)*(?:\?[/?\w.:%!$&'*+;=@~-]*)?/,
            greedy: true
        },
        env: {
            // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L661
            pattern: /\benv:(?:(?!\d)\w+|"(?:[^"\\=]|\\.)*")/,
            greedy: true,
            inside: {
                function: /^env/,
                operator: /^:/,
                variable: /[\s\S]+/
            }
        },
        hash: {
            // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L725
            pattern: /\bsha256:[\da-fA-F]{64}\b/,
            inside: {
                function: /sha256/,
                operator: /:/,
                number: /[\da-fA-F]{64}/
            }
        },
        // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L359
        keyword: /\b(?:as|assert|else|forall|if|in|let|merge|missing|then|toMap|using|with)\b|\u2200/,
        builtin: /\b(?:None|Some)\b/,
        boolean: /\b(?:False|True)\b/,
        number: /\bNaN\b|-?\bInfinity\b|[+-]?\b(?:0x[\da-fA-F]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/,
        operator: /\/\\|\/\/\\\\|&&|\|\||===|[!=]=|\/\/|->|\+\+|::|[+*#@=:?<>|\\\u2227\u2a53\u2261\u2afd\u03bb\u2192]/,
        punctuation: /\.\.|[{}\[\](),./]/,
        // we'll just assume that every capital word left is a type name
        'class-name': /\b[A-Z]\w*\b/
    };
    Prism.languages.dhall.string.inside.interpolation.inside.expression.inside = Prism.languages.dhall;
}




// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$713fb0d437182828$export$2e2bcd8739ae039.displayName = 'django';
$713fb0d437182828$export$2e2bcd8739ae039.aliases = [
    'jinja2'
];
function $713fb0d437182828$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.django = {
            comment: /^\{#[\s\S]*?#\}$/,
            tag: {
                pattern: /(^\{%[+-]?\s*)\w+/,
                lookbehind: true,
                alias: 'keyword'
            },
            delimiter: {
                pattern: /^\{[{%][+-]?|[+-]?[}%]\}$/,
                alias: 'punctuation'
            },
            string: {
                pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
                greedy: true
            },
            filter: {
                pattern: /(\|)\w+/,
                lookbehind: true,
                alias: 'function'
            },
            test: {
                pattern: /(\bis\s+(?:not\s+)?)(?!not\b)\w+/,
                lookbehind: true,
                alias: 'function'
            },
            function: /\b[a-z_]\w+(?=\s*\()/i,
            keyword: /\b(?:and|as|by|else|for|if|import|in|is|loop|not|or|recursive|with|without)\b/,
            operator: /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
            number: /\b\d+(?:\.\d+)?\b/,
            boolean: /[Ff]alse|[Nn]one|[Tt]rue/,
            variable: /\b\w+\b/,
            punctuation: /[{}[\](),.:;]/
        };
        var pattern = /\{\{[\s\S]*?\}\}|\{%[\s\S]*?%\}|\{#[\s\S]*?#\}/g;
        var markupTemplating = Prism.languages['markup-templating'];
        Prism.hooks.add('before-tokenize', function(env) {
            markupTemplating.buildPlaceholders(env, 'django', pattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            markupTemplating.tokenizePlaceholders(env, 'django');
        });
        // Add an Jinja2 alias
        Prism.languages.jinja2 = Prism.languages.django;
        Prism.hooks.add('before-tokenize', function(env) {
            markupTemplating.buildPlaceholders(env, 'jinja2', pattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            markupTemplating.tokenizePlaceholders(env, 'jinja2');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $9df90d7c45567ff9$export$2e2bcd8739ae039.displayName = 'dns-zone-file';
$9df90d7c45567ff9$export$2e2bcd8739ae039.aliases = [
    'dns-zone'
];
function $9df90d7c45567ff9$export$2e2bcd8739ae039(Prism) {
    Prism.languages['dns-zone-file'] = {
        comment: /;.*/,
        string: {
            pattern: /"(?:\\.|[^"\\\r\n])*"/,
            greedy: true
        },
        variable: [
            {
                pattern: /(^\$ORIGIN[ \t]+)\S+/m,
                lookbehind: true
            },
            {
                pattern: /(^|\s)@(?=\s|$)/,
                lookbehind: true
            }
        ],
        keyword: /^\$(?:INCLUDE|ORIGIN|TTL)(?=\s|$)/m,
        class: {
            // https://tools.ietf.org/html/rfc1035#page-13
            pattern: /(^|\s)(?:CH|CS|HS|IN)(?=\s|$)/,
            lookbehind: true,
            alias: 'keyword'
        },
        type: {
            // https://en.wikipedia.org/wiki/List_of_DNS_record_types
            pattern: /(^|\s)(?:A|A6|AAAA|AFSDB|APL|ATMA|CAA|CDNSKEY|CDS|CERT|CNAME|DHCID|DLV|DNAME|DNSKEY|DS|EID|GID|GPOS|HINFO|HIP|IPSECKEY|ISDN|KEY|KX|LOC|MAILA|MAILB|MB|MD|MF|MG|MINFO|MR|MX|NAPTR|NB|NBSTAT|NIMLOC|NINFO|NS|NSAP|NSAP-PTR|NSEC|NSEC3|NSEC3PARAM|NULL|NXT|OPENPGPKEY|PTR|PX|RKEY|RP|RRSIG|RT|SIG|SINK|SMIMEA|SOA|SPF|SRV|SSHFP|TA|TKEY|TLSA|TSIG|TXT|UID|UINFO|UNSPEC|URI|WKS|X25)(?=\s|$)/,
            lookbehind: true,
            alias: 'keyword'
        },
        punctuation: /[()]/
    };
    Prism.languages['dns-zone'] = Prism.languages['dns-zone-file'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $6bf0eb89a36e65a0$export$2e2bcd8739ae039.displayName = 'docker';
$6bf0eb89a36e65a0$export$2e2bcd8739ae039.aliases = [
    'dockerfile'
];
function $6bf0eb89a36e65a0$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // Many of the following regexes will contain negated lookaheads like `[ \t]+(?![ \t])`. This is a trick to ensure
        // that quantifiers behave *atomically*. Atomic quantifiers are necessary to prevent exponential backtracking.
        var spaceAfterBackSlash = /\\[\r\n](?:\s|\\[\r\n]|#.*(?!.))*(?![\s#]|\\[\r\n])/.source;
        // At least one space, comment, or line break
        var space = /(?:[ \t]+(?![ \t])(?:<SP_BS>)?|<SP_BS>)/.source.replace(/<SP_BS>/g, function() {
            return spaceAfterBackSlash;
        });
        var string = /"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*"|'(?:[^'\\\r\n]|\\(?:\r\n|[\s\S]))*'/.source;
        var option = /--[\w-]+=(?:<STR>|(?!["'])(?:[^\s\\]|\\.)+)/.source.replace(/<STR>/g, function() {
            return string;
        });
        var stringRule = {
            pattern: RegExp(string),
            greedy: true
        };
        var commentRule = {
            pattern: /(^[ \t]*)#.*/m,
            lookbehind: true,
            greedy: true
        };
        /**
     * @param {string} source
     * @param {string} flags
     * @returns {RegExp}
     */ function re(source, flags) {
            source = source.replace(/<OPT>/g, function() {
                return option;
            }).replace(/<SP>/g, function() {
                return space;
            });
            return RegExp(source, flags);
        }
        Prism.languages.docker = {
            instruction: {
                pattern: /(^[ \t]*)(?:ADD|ARG|CMD|COPY|ENTRYPOINT|ENV|EXPOSE|FROM|HEALTHCHECK|LABEL|MAINTAINER|ONBUILD|RUN|SHELL|STOPSIGNAL|USER|VOLUME|WORKDIR)(?=\s)(?:\\.|[^\r\n\\])*(?:\\$(?:\s|#.*$)*(?![\s#])(?:\\.|[^\r\n\\])*)*/im,
                lookbehind: true,
                greedy: true,
                inside: {
                    options: {
                        pattern: re(/(^(?:ONBUILD<SP>)?\w+<SP>)<OPT>(?:<SP><OPT>)*/.source, 'i'),
                        lookbehind: true,
                        greedy: true,
                        inside: {
                            property: {
                                pattern: /(^|\s)--[\w-]+/,
                                lookbehind: true
                            },
                            string: [
                                stringRule,
                                {
                                    pattern: /(=)(?!["'])(?:[^\s\\]|\\.)+/,
                                    lookbehind: true
                                }
                            ],
                            operator: /\\$/m,
                            punctuation: /=/
                        }
                    },
                    keyword: [
                        {
                            // https://docs.docker.com/engine/reference/builder/#healthcheck
                            pattern: re(/(^(?:ONBUILD<SP>)?HEALTHCHECK<SP>(?:<OPT><SP>)*)(?:CMD|NONE)\b/.source, 'i'),
                            lookbehind: true,
                            greedy: true
                        },
                        {
                            // https://docs.docker.com/engine/reference/builder/#from
                            pattern: re(/(^(?:ONBUILD<SP>)?FROM<SP>(?:<OPT><SP>)*(?!--)[^ \t\\]+<SP>)AS/.source, 'i'),
                            lookbehind: true,
                            greedy: true
                        },
                        {
                            // https://docs.docker.com/engine/reference/builder/#onbuild
                            pattern: re(/(^ONBUILD<SP>)\w+/.source, 'i'),
                            lookbehind: true,
                            greedy: true
                        },
                        {
                            pattern: /^\w+/,
                            greedy: true
                        }
                    ],
                    comment: commentRule,
                    string: stringRule,
                    variable: /\$(?:\w+|\{[^{}"'\\]*\})/,
                    operator: /\\$/m
                }
            },
            comment: commentRule
        };
        Prism.languages.dockerfile = Prism.languages.docker;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $9be5e6824314caae$export$2e2bcd8739ae039.displayName = 'dot';
$9be5e6824314caae$export$2e2bcd8739ae039.aliases = [
    'gv'
];
function $9be5e6824314caae$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var ID = '(?:' + [
            // an identifier
            /[a-zA-Z_\x80-\uFFFF][\w\x80-\uFFFF]*/.source,
            // a number
            /-?(?:\.\d+|\d+(?:\.\d*)?)/.source,
            // a double-quoted string
            /"[^"\\]*(?:\\[\s\S][^"\\]*)*"/.source,
            // HTML-like string
            /<(?:[^<>]|(?!<!--)<(?:[^<>"']|"[^"]*"|'[^']*')+>|<!--(?:[^-]|-(?!->))*-->)*>/.source
        ].join('|') + ')';
        var IDInside = {
            markup: {
                pattern: /(^<)[\s\S]+(?=>$)/,
                lookbehind: true,
                alias: [
                    'language-markup',
                    'language-html',
                    'language-xml'
                ],
                inside: Prism.languages.markup
            }
        };
        /**
     * @param {string} source
     * @param {string} flags
     * @returns {RegExp}
     */ function withID(source, flags) {
            return RegExp(source.replace(/<ID>/g, function() {
                return ID;
            }), flags);
        }
        Prism.languages.dot = {
            comment: {
                pattern: /\/\/.*|\/\*[\s\S]*?\*\/|^#.*/m,
                greedy: true
            },
            'graph-name': {
                pattern: withID(/(\b(?:digraph|graph|subgraph)[ \t\r\n]+)<ID>/.source, 'i'),
                lookbehind: true,
                greedy: true,
                alias: 'class-name',
                inside: IDInside
            },
            'attr-value': {
                pattern: withID(/(=[ \t\r\n]*)<ID>/.source),
                lookbehind: true,
                greedy: true,
                inside: IDInside
            },
            'attr-name': {
                pattern: withID(/([\[;, \t\r\n])<ID>(?=[ \t\r\n]*=)/.source),
                lookbehind: true,
                greedy: true,
                inside: IDInside
            },
            keyword: /\b(?:digraph|edge|graph|node|strict|subgraph)\b/i,
            'compass-point': {
                pattern: /(:[ \t\r\n]*)(?:[ewc_]|[ns][ew]?)(?![\w\x80-\uFFFF])/,
                lookbehind: true,
                alias: 'builtin'
            },
            node: {
                pattern: withID(/(^|[^-.\w\x80-\uFFFF\\])<ID>/.source),
                lookbehind: true,
                greedy: true,
                inside: IDInside
            },
            operator: /[=:]|-[->]/,
            punctuation: /[\[\]{};,]/
        };
        Prism.languages.gv = Prism.languages.dot;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $582d3cacea24a910$export$2e2bcd8739ae039.displayName = 'ebnf';
$582d3cacea24a910$export$2e2bcd8739ae039.aliases = [];
function $582d3cacea24a910$export$2e2bcd8739ae039(Prism) {
    Prism.languages.ebnf = {
        comment: /\(\*[\s\S]*?\*\)/,
        string: {
            pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
            greedy: true
        },
        special: {
            pattern: /\?[^?\r\n]*\?/,
            greedy: true,
            alias: 'class-name'
        },
        definition: {
            pattern: /^([\t ]*)[a-z]\w*(?:[ \t]+[a-z]\w*)*(?=\s*=)/im,
            lookbehind: true,
            alias: [
                'rule',
                'keyword'
            ]
        },
        rule: /\b[a-z]\w*(?:[ \t]+[a-z]\w*)*\b/i,
        punctuation: /\([:/]|[:/]\)|[.,;()[\]{}]/,
        operator: /[-=|*/!]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $5b71468010bc72da$export$2e2bcd8739ae039.displayName = 'editorconfig';
$5b71468010bc72da$export$2e2bcd8739ae039.aliases = [];
function $5b71468010bc72da$export$2e2bcd8739ae039(Prism) {
    Prism.languages.editorconfig = {
        // https://editorconfig-specification.readthedocs.io
        comment: /[;#].*/,
        section: {
            pattern: /(^[ \t]*)\[.+\]/m,
            lookbehind: true,
            alias: 'selector',
            inside: {
                regex: /\\\\[\[\]{},!?.*]/,
                // Escape special characters with '\\'
                operator: /[!?]|\.\.|\*{1,2}/,
                punctuation: /[\[\]{},]/
            }
        },
        key: {
            pattern: /(^[ \t]*)[^\s=]+(?=[ \t]*=)/m,
            lookbehind: true,
            alias: 'attr-name'
        },
        value: {
            pattern: /=.*/,
            alias: 'attr-value',
            inside: {
                punctuation: /^=/
            }
        }
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $05008d3ff07b1f36$export$2e2bcd8739ae039.displayName = 'eiffel';
$05008d3ff07b1f36$export$2e2bcd8739ae039.aliases = [];
function $05008d3ff07b1f36$export$2e2bcd8739ae039(Prism) {
    Prism.languages.eiffel = {
        comment: /--.*/,
        string: [
            // Aligned-verbatim-strings
            {
                pattern: /"([^[]*)\[[\s\S]*?\]\1"/,
                greedy: true
            },
            // Non-aligned-verbatim-strings
            {
                pattern: /"([^{]*)\{[\s\S]*?\}\1"/,
                greedy: true
            },
            // Single-line string
            {
                pattern: /"(?:%(?:(?!\n)\s)*\n\s*%|%\S|[^%"\r\n])*"/,
                greedy: true
            }
        ],
        // normal char | special char | char code
        char: /'(?:%.|[^%'\r\n])+'/,
        keyword: /\b(?:across|agent|alias|all|and|as|assign|attached|attribute|check|class|convert|create|Current|debug|deferred|detachable|do|else|elseif|end|ensure|expanded|export|external|feature|from|frozen|if|implies|inherit|inspect|invariant|like|local|loop|not|note|obsolete|old|once|or|Precursor|redefine|rename|require|rescue|Result|retry|select|separate|some|then|undefine|until|variant|Void|when|xor)\b/i,
        boolean: /\b(?:False|True)\b/i,
        // Convention: class-names are always all upper-case characters
        'class-name': /\b[A-Z][\dA-Z_]*\b/,
        number: [
            // hexa | octal | bin
            /\b0[xcb][\da-f](?:_*[\da-f])*\b/i,
            // Decimal
            /(?:\b\d(?:_*\d)*)?\.(?:(?:\d(?:_*\d)*)?e[+-]?)?\d(?:_*\d)*\b|\b\d(?:_*\d)*\b\.?/i
        ],
        punctuation: /:=|<<|>>|\(\||\|\)|->|\.(?=\w)|[{}[\];(),:?]/,
        operator: /\\\\|\|\.\.\||\.\.|\/[~\/=]?|[><]=?|[-+*^=~]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$1f738c70877931fd$export$2e2bcd8739ae039.displayName = 'ejs';
$1f738c70877931fd$export$2e2bcd8739ae039.aliases = [
    'eta'
];
function $1f738c70877931fd$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
    Prism.register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.ejs = {
            delimiter: {
                pattern: /^<%[-_=]?|[-_]?%>$/,
                alias: 'punctuation'
            },
            comment: /^#[\s\S]*/,
            'language-javascript': {
                pattern: /[\s\S]+/,
                inside: Prism.languages.javascript
            }
        };
        Prism.hooks.add('before-tokenize', function(env) {
            var ejsPattern = /<%(?!%)[\s\S]+?%>/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'ejs', ejsPattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'ejs');
        });
        Prism.languages.eta = Prism.languages.ejs;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $7290ce53648b43d9$export$2e2bcd8739ae039.displayName = 'elixir';
$7290ce53648b43d9$export$2e2bcd8739ae039.aliases = [];
function $7290ce53648b43d9$export$2e2bcd8739ae039(Prism) {
    Prism.languages.elixir = {
        doc: {
            pattern: /@(?:doc|moduledoc)\s+(?:("""|''')[\s\S]*?\1|("|')(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2)/,
            inside: {
                attribute: /^@\w+/,
                string: /['"][\s\S]+/
            }
        },
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        // ~r"""foo""" (multi-line), ~r'''foo''' (multi-line), ~r/foo/, ~r|foo|, ~r"foo", ~r'foo', ~r(foo), ~r[foo], ~r{foo}, ~r<foo>
        regex: {
            pattern: /~[rR](?:("""|''')(?:\\[\s\S]|(?!\1)[^\\])+\1|([\/|"'])(?:\\.|(?!\2)[^\\\r\n])+\2|\((?:\\.|[^\\)\r\n])+\)|\[(?:\\.|[^\\\]\r\n])+\]|\{(?:\\.|[^\\}\r\n])+\}|<(?:\\.|[^\\>\r\n])+>)[uismxfr]*/,
            greedy: true
        },
        string: [
            {
                // ~s"""foo""" (multi-line), ~s'''foo''' (multi-line), ~s/foo/, ~s|foo|, ~s"foo", ~s'foo', ~s(foo), ~s[foo], ~s{foo} (with interpolation care), ~s<foo>
                pattern: /~[cCsSwW](?:("""|''')(?:\\[\s\S]|(?!\1)[^\\])+\1|([\/|"'])(?:\\.|(?!\2)[^\\\r\n])+\2|\((?:\\.|[^\\)\r\n])+\)|\[(?:\\.|[^\\\]\r\n])+\]|\{(?:\\.|#\{[^}]+\}|#(?!\{)|[^#\\}\r\n])+\}|<(?:\\.|[^\\>\r\n])+>)[csa]?/,
                greedy: true,
                inside: {
                }
            },
            {
                pattern: /("""|''')[\s\S]*?\1/,
                greedy: true,
                inside: {
                }
            },
            {
                // Multi-line strings are allowed
                pattern: /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
                greedy: true,
                inside: {
                }
            }
        ],
        atom: {
            // Look-behind prevents bad highlighting of the :: operator
            pattern: /(^|[^:]):\w+/,
            lookbehind: true,
            alias: 'symbol'
        },
        module: {
            pattern: /\b[A-Z]\w*\b/,
            alias: 'class-name'
        },
        // Look-ahead prevents bad highlighting of the :: operator
        'attr-name': /\b\w+\??:(?!:)/,
        argument: {
            // Look-behind prevents bad highlighting of the && operator
            pattern: /(^|[^&])&\d+/,
            lookbehind: true,
            alias: 'variable'
        },
        attribute: {
            pattern: /@\w+/,
            alias: 'variable'
        },
        function: /\b[_a-zA-Z]\w*[?!]?(?:(?=\s*(?:\.\s*)?\()|(?=\/\d))/,
        number: /\b(?:0[box][a-f\d_]+|\d[\d_]*)(?:\.[\d_]+)?(?:e[+-]?[\d_]+)?\b/i,
        keyword: /\b(?:after|alias|and|case|catch|cond|def(?:callback|delegate|exception|impl|macro|module|n|np|p|protocol|struct)?|do|else|end|fn|for|if|import|not|or|quote|raise|require|rescue|try|unless|unquote|use|when)\b/,
        boolean: /\b(?:false|nil|true)\b/,
        operator: [
            /\bin\b|&&?|\|[|>]?|\\\\|::|\.\.\.?|\+\+?|-[->]?|<[-=>]|>=|!==?|\B!|=(?:==?|[>~])?|[*\/^]/,
            {
                // We don't want to match <<
                pattern: /([^<])<(?!<)/,
                lookbehind: true
            },
            {
                // We don't want to match >>
                pattern: /([^>])>(?!>)/,
                lookbehind: true
            }
        ],
        punctuation: /<<|>>|[.,%\[\]{}()]/
    };
    Prism.languages.elixir.string.forEach(function(o) {
        o.inside = {
            interpolation: {
                pattern: /#\{[^}]+\}/,
                inside: {
                    delimiter: {
                        pattern: /^#\{|\}$/,
                        alias: 'punctuation'
                    },
                    rest: Prism.languages.elixir
                }
            }
        };
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $4e7615bc2bd38bf5$export$2e2bcd8739ae039.displayName = 'elm';
$4e7615bc2bd38bf5$export$2e2bcd8739ae039.aliases = [];
function $4e7615bc2bd38bf5$export$2e2bcd8739ae039(Prism) {
    Prism.languages.elm = {
        comment: /--.*|\{-[\s\S]*?-\}/,
        char: {
            pattern: /'(?:[^\\'\r\n]|\\(?:[abfnrtv\\']|\d+|x[0-9a-fA-F]+|u\{[0-9a-fA-F]+\}))'/,
            greedy: true
        },
        string: [
            {
                // Multiline strings are wrapped in triple ". Quotes may appear unescaped.
                pattern: /"""[\s\S]*?"""/,
                greedy: true
            },
            {
                pattern: /"(?:[^\\"\r\n]|\\.)*"/,
                greedy: true
            }
        ],
        'import-statement': {
            // The imported or hidden names are not included in this import
            // statement. This is because we want to highlight those exactly like
            // we do for the names in the program.
            pattern: /(^[\t ]*)import\s+[A-Z]\w*(?:\.[A-Z]\w*)*(?:\s+as\s+(?:[A-Z]\w*)(?:\.[A-Z]\w*)*)?(?:\s+exposing\s+)?/m,
            lookbehind: true,
            inside: {
                keyword: /\b(?:as|exposing|import)\b/
            }
        },
        keyword: /\b(?:alias|as|case|else|exposing|if|in|infixl|infixr|let|module|of|then|type)\b/,
        // These are builtin variables only. Constructors are highlighted later as a constant.
        builtin: /\b(?:abs|acos|always|asin|atan|atan2|ceiling|clamp|compare|cos|curry|degrees|e|flip|floor|fromPolar|identity|isInfinite|isNaN|logBase|max|min|negate|never|not|pi|radians|rem|round|sin|sqrt|tan|toFloat|toPolar|toString|truncate|turns|uncurry|xor)\b/,
        // decimal integers and floating point numbers | hexadecimal integers
        number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0x[0-9a-f]+)\b/i,
        // Most of this is needed because of the meaning of a single '.'.
        // If it stands alone freely, it is the function composition.
        // It may also be a separator between a module name and an identifier => no
        // operator. If it comes together with other special characters it is an
        // operator too.
        // Valid operator characters in 0.18: +-/*=.$<>:&|^?%#@~!
        // Ref: https://groups.google.com/forum/#!msg/elm-dev/0AHSnDdkSkQ/E0SVU70JEQAJ
        operator: /\s\.\s|[+\-/*=.$<>:&|^?%#@~!]{2,}|[+\-/*=$<>:&|^?%#@~!]/,
        // In Elm, nearly everything is a variable, do not highlight these.
        hvariable: /\b(?:[A-Z]\w*\.)*[a-z]\w*\b/,
        constant: /\b(?:[A-Z]\w*\.)*[A-Z]\w*\b/,
        punctuation: /[{}[\]|(),.:]/
    };
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$24261424b318a546$export$2e2bcd8739ae039.displayName = 'etlua';
$24261424b318a546$export$2e2bcd8739ae039.aliases = [];
function $24261424b318a546$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $20b8caf8b024dc15$export$2e2bcd8739ae039));
    Prism.register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.etlua = {
            delimiter: {
                pattern: /^<%[-=]?|-?%>$/,
                alias: 'punctuation'
            },
            'language-lua': {
                pattern: /[\s\S]+/,
                inside: Prism.languages.lua
            }
        };
        Prism.hooks.add('before-tokenize', function(env) {
            var pattern = /<%[\s\S]+?%>/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'etlua', pattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'etlua');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$81a7c5742f763317$export$2e2bcd8739ae039.displayName = 'erb';
$81a7c5742f763317$export$2e2bcd8739ae039.aliases = [];
function $81a7c5742f763317$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
    Prism.register((0, $0814f5761e025965$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.erb = {
            delimiter: {
                pattern: /^(\s*)<%=?|%>(?=\s*$)/,
                lookbehind: true,
                alias: 'punctuation'
            },
            ruby: {
                pattern: /\s*\S[\s\S]*/,
                alias: 'language-ruby',
                inside: Prism.languages.ruby
            }
        };
        Prism.hooks.add('before-tokenize', function(env) {
            var erbPattern = /<%=?(?:[^\r\n]|[\r\n](?!=begin)|[\r\n]=begin\s(?:[^\r\n]|[\r\n](?!=end))*[\r\n]=end)+?%>/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'erb', erbPattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'erb');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $645d653be7f1e246$export$2e2bcd8739ae039.displayName = 'erlang';
$645d653be7f1e246$export$2e2bcd8739ae039.aliases = [];
function $645d653be7f1e246$export$2e2bcd8739ae039(Prism) {
    Prism.languages.erlang = {
        comment: /%.+/,
        string: {
            pattern: /"(?:\\.|[^\\"\r\n])*"/,
            greedy: true
        },
        'quoted-function': {
            pattern: /'(?:\\.|[^\\'\r\n])+'(?=\()/,
            alias: 'function'
        },
        'quoted-atom': {
            pattern: /'(?:\\.|[^\\'\r\n])+'/,
            alias: 'atom'
        },
        boolean: /\b(?:false|true)\b/,
        keyword: /\b(?:after|begin|case|catch|end|fun|if|of|receive|try|when)\b/,
        number: [
            /\$\\?./,
            /\b\d+#[a-z0-9]+/i,
            /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i
        ],
        function: /\b[a-z][\w@]*(?=\()/,
        variable: {
            // Look-behind is used to prevent wrong highlighting of atoms containing "@"
            pattern: /(^|[^@])(?:\b|\?)[A-Z_][\w@]*/,
            lookbehind: true
        },
        operator: [
            /[=\/<>:]=|=[:\/]=|\+\+?|--?|[=*\/!]|\b(?:and|andalso|band|bnot|bor|bsl|bsr|bxor|div|not|or|orelse|rem|xor)\b/,
            {
                // We don't want to match <<
                pattern: /(^|[^<])<(?!<)/,
                lookbehind: true
            },
            {
                // We don't want to match >>
                pattern: /(^|[^>])>(?!>)/,
                lookbehind: true
            }
        ],
        atom: /\b[a-z][\w@]*/,
        punctuation: /[()[\]{}:;,.#|]|<<|>>/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $23b4532be12400bd$export$2e2bcd8739ae039.displayName = 'excel-formula';
$23b4532be12400bd$export$2e2bcd8739ae039.aliases = [
    'xls',
    'xlsx'
];
function $23b4532be12400bd$export$2e2bcd8739ae039(Prism) {
    Prism.languages['excel-formula'] = {
        comment: {
            pattern: /(\bN\(\s*)"(?:[^"]|"")*"(?=\s*\))/i,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"]|"")*"(?!")/,
            greedy: true
        },
        reference: {
            // https://www.ablebits.com/office-addins-blog/2015/12/08/excel-reference-another-sheet-workbook/
            // Sales!B2
            // 'Winter sales'!B2
            // [Sales.xlsx]Jan!B2:B5
            // D:\Reports\[Sales.xlsx]Jan!B2:B5
            // '[Sales.xlsx]Jan sales'!B2:B5
            // 'D:\Reports\[Sales.xlsx]Jan sales'!B2:B5
            pattern: /(?:'[^']*'|(?:[^\s()[\]{}<>*?"';,$&]*\[[^^\s()[\]{}<>*?"']+\])?\w+)!/,
            greedy: true,
            alias: 'string',
            inside: {
                operator: /!$/,
                punctuation: /'/,
                sheet: {
                    pattern: /[^[\]]+$/,
                    alias: 'function'
                },
                file: {
                    pattern: /\[[^[\]]+\]$/,
                    inside: {
                        punctuation: /[[\]]/
                    }
                },
                path: /[\s\S]+/
            }
        },
        'function-name': {
            pattern: /\b[A-Z]\w*(?=\()/i,
            alias: 'builtin'
        },
        range: {
            pattern: /\$?\b(?:[A-Z]+\$?\d+:\$?[A-Z]+\$?\d+|[A-Z]+:\$?[A-Z]+|\d+:\$?\d+)\b/i,
            alias: 'selector',
            inside: {
                operator: /:/,
                cell: /\$?[A-Z]+\$?\d+/i,
                column: /\$?[A-Z]+/i,
                row: /\$?\d+/
            }
        },
        cell: {
            // Excel is case insensitive, so the string "foo1" could be either a variable or a cell.
            // To combat this, we match cells case insensitive, if the contain at least one "$", and case sensitive otherwise.
            pattern: /\b[A-Z]+\d+\b|\$[A-Za-z]+\$?\d+\b|\b[A-Za-z]+\$\d+\b/,
            alias: 'selector'
        },
        number: /(?:\b\d+(?:\.\d+)?|\B\.\d+)(?:e[+-]?\d+)?\b/i,
        boolean: /\b(?:FALSE|TRUE)\b/i,
        operator: /[-+*/^%=&,]|<[=>]?|>=?/,
        punctuation: /[[\]();{}|]/
    };
    Prism.languages['xlsx'] = Prism.languages['xls'] = Prism.languages['excel-formula'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$03636fbb6bcf9de6$export$2e2bcd8739ae039.displayName = 'fsharp';
$03636fbb6bcf9de6$export$2e2bcd8739ae039.aliases = [];
function $03636fbb6bcf9de6$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.fsharp = Prism.languages.extend('clike', {
        comment: [
            {
                pattern: /(^|[^\\])\(\*(?!\))[\s\S]*?\*\)/,
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(?:"""[\s\S]*?"""|@"(?:""|[^"])*"|"(?:\\[\s\S]|[^\\"])*")B?/,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:exception|inherit|interface|new|of|type)\s+|\w\s*:\s*|\s:\??>\s*)[.\w]+\b(?:\s*(?:->|\*)\s*[.\w]+\b)*(?!\s*[:.])/,
            lookbehind: true,
            inside: {
                operator: /->|\*/,
                punctuation: /\./
            }
        },
        keyword: /\b(?:let|return|use|yield)(?:!\B|\b)|\b(?:abstract|and|as|asr|assert|atomic|base|begin|break|checked|class|component|const|constraint|constructor|continue|default|delegate|do|done|downcast|downto|eager|elif|else|end|event|exception|extern|external|false|finally|fixed|for|fun|function|functor|global|if|in|include|inherit|inline|interface|internal|land|lazy|lor|lsl|lsr|lxor|match|member|method|mixin|mod|module|mutable|namespace|new|not|null|object|of|open|or|override|parallel|private|process|protected|public|pure|rec|sealed|select|sig|static|struct|tailcall|then|to|trait|true|try|type|upcast|val|virtual|void|volatile|when|while|with)\b/,
        number: [
            /\b0x[\da-fA-F]+(?:LF|lf|un)?\b/,
            /\b0b[01]+(?:uy|y)?\b/,
            /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[fm]|e[+-]?\d+)?\b/i,
            /\b\d+(?:[IlLsy]|UL|u[lsy]?)?\b/
        ],
        operator: /([<>~&^])\1\1|([*.:<>&])\2|<-|->|[!=:]=|<?\|{1,3}>?|\??(?:<=|>=|<>|[-+*/%=<>])\??|[!?^&]|~[+~-]|:>|:\?>?/
    });
    Prism.languages.insertBefore('fsharp', 'keyword', {
        preprocessor: {
            pattern: /(^[\t ]*)#.*/m,
            lookbehind: true,
            alias: 'property',
            inside: {
                directive: {
                    pattern: /(^#)\b(?:else|endif|if|light|line|nowarn)\b/,
                    lookbehind: true,
                    alias: 'keyword'
                }
            }
        }
    });
    Prism.languages.insertBefore('fsharp', 'punctuation', {
        'computation-expression': {
            pattern: /\b[_a-z]\w*(?=\s*\{)/i,
            alias: 'keyword'
        }
    });
    Prism.languages.insertBefore('fsharp', 'string', {
        annotation: {
            pattern: /\[<.+?>\]/,
            greedy: true,
            inside: {
                punctuation: /^\[<|>\]$/,
                'class-name': {
                    pattern: /^\w+$|(^|;\s*)[A-Z]\w*(?=\()/,
                    lookbehind: true
                },
                'annotation-content': {
                    pattern: /[\s\S]+/,
                    inside: Prism.languages.fsharp
                }
            }
        },
        char: {
            pattern: /'(?:[^\\']|\\(?:.|\d{3}|x[a-fA-F\d]{2}|u[a-fA-F\d]{4}|U[a-fA-F\d]{8}))'B?/,
            greedy: true
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $d1ff02eb2618944d$export$2e2bcd8739ae039.displayName = 'factor';
$d1ff02eb2618944d$export$2e2bcd8739ae039.aliases = [];
function $d1ff02eb2618944d$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var comment_inside = {
            function: /\b(?:BUGS?|FIX(?:MES?)?|NOTES?|TODOS?|XX+|HACKS?|WARN(?:ING)?|\?{2,}|!{2,})\b/
        };
        var string_inside = {
            number: /\\[^\s']|%\w/
        };
        var factor = {
            comment: [
                {
                    // ! single-line exclamation point comments with whitespace after/around the !
                    pattern: /(^|\s)(?:! .*|!$)/,
                    lookbehind: true,
                    inside: comment_inside
                } /* from basis/multiline: */ ,
                {
                    // /* comment */, /* comment*/
                    pattern: /(^|\s)\/\*\s[\s\S]*?\*\/(?=\s|$)/,
                    lookbehind: true,
                    greedy: true,
                    inside: comment_inside
                },
                {
                    // ![[ comment ]] , ![===[ comment]===]
                    pattern: /(^|\s)!\[(={0,6})\[\s[\s\S]*?\]\2\](?=\s|$)/,
                    lookbehind: true,
                    greedy: true,
                    inside: comment_inside
                }
            ],
            number: [
                {
                    // basic base 10 integers 9, -9
                    pattern: /(^|\s)[+-]?\d+(?=\s|$)/,
                    lookbehind: true
                },
                {
                    // base prefix integers 0b010 0o70 0xad 0d10 0XAD -0xa9
                    pattern: /(^|\s)[+-]?0(?:b[01]+|o[0-7]+|d\d+|x[\dA-F]+)(?=\s|$)/i,
                    lookbehind: true
                },
                {
                    // fractional ratios 1/5 -1/5 and the literal float approximations 1/5. -1/5.
                    pattern: /(^|\s)[+-]?\d+\/\d+\.?(?=\s|$)/,
                    lookbehind: true
                },
                {
                    // positive mixed numbers 23+1/5 +23+1/5
                    pattern: /(^|\s)\+?\d+\+\d+\/\d+(?=\s|$)/,
                    lookbehind: true
                },
                {
                    // negative mixed numbers -23-1/5
                    pattern: /(^|\s)-\d+-\d+\/\d+(?=\s|$)/,
                    lookbehind: true
                },
                {
                    // basic decimal floats -0.01 0. .0 .1 -.1 -1. -12.13 +12.13
                    // and scientific notation with base 10 exponents 3e4 3e-4 .3e-4
                    pattern: /(^|\s)[+-]?(?:\d*\.\d+|\d+\.\d*|\d+)(?:e[+-]?\d+)?(?=\s|$)/i,
                    lookbehind: true
                },
                {
                    // NAN literal syntax NAN: 80000deadbeef, NAN: a
                    pattern: /(^|\s)NAN:\s+[\da-fA-F]+(?=\s|$)/,
                    lookbehind: true
                },
                {
                    /*
base prefix floats 0x1.0p3 (8.0) 0b1.010p2 (5.0) 0x1.p1 0b1.11111111p11111...
"The normalized hex form ±0x1.MMMMMMMMMMMMM[pP]±EEEE allows any floating-point number to be specified precisely.
The values of MMMMMMMMMMMMM and EEEE map directly to the mantissa and exponent fields of the binary IEEE 754 representation."
<https://docs.factorcode.org/content/article-syntax-floats.html>
*/ pattern: /(^|\s)[+-]?0(?:b1\.[01]*|o1\.[0-7]*|d1\.\d*|x1\.[\dA-F]*)p\d+(?=\s|$)/i,
                    lookbehind: true
                }
            ],
            // R/ regexp?\/\\/
            regexp: {
                pattern: /(^|\s)R\/\s(?:\\\S|[^\\/])*\/(?:[idmsr]*|[idmsr]+-[idmsr]+)(?=\s|$)/,
                lookbehind: true,
                alias: 'number',
                inside: {
                    variable: /\\\S/,
                    keyword: /[+?*\[\]^$(){}.|]/,
                    operator: {
                        pattern: /(\/)[idmsr]+(?:-[idmsr]+)?/,
                        lookbehind: true
                    }
                }
            },
            boolean: {
                pattern: /(^|\s)[tf](?=\s|$)/,
                lookbehind: true
            },
            // SBUF" asd", URL" ://...", P" /etc/"
            'custom-string': {
                pattern: /(^|\s)[A-Z0-9\-]+"\s(?:\\\S|[^"\\])*"/,
                lookbehind: true,
                greedy: true,
                alias: 'string',
                inside: {
                    number: /\\\S|%\w|\//
                }
            },
            'multiline-string': [
                {
                    // STRING: name \n content \n ; -> CONSTANT: name "content" (symbol)
                    pattern: /(^|\s)STRING:\s+\S+(?:\n|\r\n).*(?:\n|\r\n)\s*;(?=\s|$)/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'string',
                    inside: {
                        number: string_inside.number,
                        // trailing semicolon on its own line
                        'semicolon-or-setlocal': {
                            pattern: /([\r\n][ \t]*);(?=\s|$)/,
                            lookbehind: true,
                            alias: 'function'
                        }
                    }
                },
                {
                    // HEREDOC: marker \n content \n marker ; -> "content" (immediate)
                    pattern: /(^|\s)HEREDOC:\s+\S+(?:\n|\r\n).*(?:\n|\r\n)\s*\S+(?=\s|$)/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'string',
                    inside: string_inside
                },
                {
                    // [[ string ]], [==[ string]==]
                    pattern: /(^|\s)\[(={0,6})\[\s[\s\S]*?\]\2\](?=\s|$)/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'string',
                    inside: string_inside
                }
            ],
            'special-using': {
                pattern: /(^|\s)USING:(?:\s\S+)*(?=\s+;(?:\s|$))/,
                lookbehind: true,
                alias: 'function',
                inside: {
                    // this is essentially a regex for vocab names, which i don't want to specify
                    // but the USING: gets picked up as a vocab name
                    string: {
                        pattern: /(\s)[^:\s]+/,
                        lookbehind: true
                    }
                }
            },
            /* this description of stack effect literal syntax is not complete and not as specific as theoretically possible
trying to do better is more work and regex-computation-time than it's worth though.
- we'd like to have the "delimiter" parts of the stack effect [ (, --, and ) ] be a different (less-important or comment-like) colour to the stack effect contents
- we'd like if nested stack effects were treated as such rather than just appearing flat (with `inside`)
- we'd like if the following variable name conventions were recognised specifically:
special row variables = ..a b..
type and stack effect annotations end with a colon = ( quot: ( a: ( -- ) -- b ) -- x ), ( x: number -- )
word throws unconditional error = *
any other word-like variable name = a ? q' etc
https://docs.factorcode.org/content/article-effects.html
these are pretty complicated to highlight properly without a real parser, and therefore out of scope
the old pattern, which may be later useful, was: (^|\s)(?:call|execute|eval)?\((?:\s+[^"\r\n\t ]\S*)*?\s+--(?:\s+[^"\n\t ]\S*)*?\s+\)(?=\s|$)
*/ // current solution is not great
            'stack-effect-delimiter': [
                {
                    // opening parenthesis
                    pattern: /(^|\s)(?:call|eval|execute)?\((?=\s)/,
                    lookbehind: true,
                    alias: 'operator'
                },
                {
                    // middle --
                    pattern: /(\s)--(?=\s)/,
                    lookbehind: true,
                    alias: 'operator'
                },
                {
                    // closing parenthesis
                    pattern: /(\s)\)(?=\s|$)/,
                    lookbehind: true,
                    alias: 'operator'
                }
            ],
            combinators: {
                pattern: null,
                lookbehind: true,
                alias: 'keyword'
            },
            'kernel-builtin': {
                pattern: null,
                lookbehind: true,
                alias: 'variable'
            },
            'sequences-builtin': {
                pattern: null,
                lookbehind: true,
                alias: 'variable'
            },
            'math-builtin': {
                pattern: null,
                lookbehind: true,
                alias: 'variable'
            },
            'constructor-word': {
                // <array> but not <=>
                pattern: /(^|\s)<(?!=+>|-+>)\S+>(?=\s|$)/,
                lookbehind: true,
                alias: 'keyword'
            },
            'other-builtin-syntax': {
                pattern: null,
                lookbehind: true,
                alias: 'operator'
            },
            /*
full list of supported word naming conventions: (the convention appears outside of the [brackets])
set-[x]
change-[x]
with-[x]
new-[x]
>[string]
[base]>
[string]>[number]
+[symbol]+
[boolean-word]?
?[of]
[slot-reader]>>
>>[slot-setter]
[slot-writer]<<
([implementation-detail])
[mutater]!
[variant]*
[prettyprint].
$[help-markup]
<constructors>, SYNTAX:, etc are supported by their own patterns.
`with` and `new` from `kernel` are their own builtins.
see <https://docs.factorcode.org/content/article-conventions.html>
*/ 'conventionally-named-word': {
                pattern: /(^|\s)(?!")(?:(?:change|new|set|with)-\S+|\$\S+|>[^>\s]+|[^:>\s]+>|[^>\s]+>[^>\s]+|\+[^+\s]+\+|[^?\s]+\?|\?[^?\s]+|[^>\s]+>>|>>[^>\s]+|[^<\s]+<<|\([^()\s]+\)|[^!\s]+!|[^*\s]\S*\*|[^.\s]\S*\.)(?=\s|$)/,
                lookbehind: true,
                alias: 'keyword'
            },
            'colon-syntax': {
                pattern: /(^|\s)(?:[A-Z0-9\-]+#?)?:{1,2}\s+(?:;\S+|(?!;)\S+)(?=\s|$)/,
                lookbehind: true,
                greedy: true,
                alias: 'function'
            },
            'semicolon-or-setlocal': {
                pattern: /(\s)(?:;|:>)(?=\s|$)/,
                lookbehind: true,
                alias: 'function'
            },
            // do not highlight leading } or trailing X{ at the begin/end of the file as it's invalid syntax
            'curly-brace-literal-delimiter': [
                {
                    // opening
                    pattern: /(^|\s)[a-z]*\{(?=\s)/i,
                    lookbehind: true,
                    alias: 'operator'
                },
                {
                    // closing
                    pattern: /(\s)\}(?=\s|$)/,
                    lookbehind: true,
                    alias: 'operator'
                }
            ],
            // do not highlight leading ] or trailing [ at the begin/end of the file as it's invalid syntax
            'quotation-delimiter': [
                {
                    // opening
                    pattern: /(^|\s)\[(?=\s)/,
                    lookbehind: true,
                    alias: 'operator'
                },
                {
                    // closing
                    pattern: /(\s)\](?=\s|$)/,
                    lookbehind: true,
                    alias: 'operator'
                }
            ],
            'normal-word': {
                pattern: /(^|\s)[^"\s]\S*(?=\s|$)/,
                lookbehind: true
            },
            /*
basic first-class string "a"
with escaped double-quote "a\""
escaped backslash "\\"
and general escapes since Factor has so many "\N"
syntax that works in the reference implementation that isn't fully
supported because it's an implementation detail:
"string 1""string 2" -> 2 strings (works anyway)
"string"5 -> string, 5
"string"[ ] -> string, quotation
{ "a"} -> array<string>
the rest of those examples all properly recognise the string, but not
the other object (number, quotation, etc)
this is fine for a regex-only implementation.
*/ string: {
                pattern: /"(?:\\\S|[^"\\])*"/,
                greedy: true,
                inside: string_inside
            }
        };
        var escape = function(str) {
            return (str + '').replace(/([.?*+\^$\[\]\\(){}|\-])/g, '\\$1');
        };
        var arrToWordsRegExp = function(arr) {
            return new RegExp('(^|\\s)(?:' + arr.map(escape).join('|') + ')(?=\\s|$)');
        };
        var builtins = {
            'kernel-builtin': [
                'or',
                '2nipd',
                '4drop',
                'tuck',
                'wrapper',
                'nip',
                'wrapper?',
                'callstack>array',
                'die',
                'dupd',
                'callstack',
                'callstack?',
                '3dup',
                'hashcode',
                'pick',
                '4nip',
                'build',
                '>boolean',
                'nipd',
                'clone',
                '5nip',
                'eq?',
                '?',
                '=',
                'swapd',
                '2over',
                'clear',
                '2dup',
                'get-retainstack',
                'not',
                'tuple?',
                'dup',
                '3nipd',
                'call',
                '-rotd',
                'object',
                'drop',
                'assert=',
                'assert?',
                '-rot',
                'execute',
                'boa',
                'get-callstack',
                'curried?',
                '3drop',
                'pickd',
                'overd',
                'over',
                'roll',
                '3nip',
                'swap',
                'and',
                '2nip',
                'rotd',
                'throw',
                '(clone)',
                'hashcode*',
                'spin',
                'reach',
                '4dup',
                'equal?',
                'get-datastack',
                'assert',
                '2drop',
                '<wrapper>',
                'boolean?',
                'identity-hashcode',
                'identity-tuple?',
                'null',
                'composed?',
                'new',
                '5drop',
                'rot',
                '-roll',
                'xor',
                'identity-tuple',
                'boolean'
            ],
            'other-builtin-syntax': [
                // syntax
                '=======',
                'recursive',
                'flushable',
                '>>',
                '<<<<<<',
                'M\\',
                'B',
                'PRIVATE>',
                '\\',
                '======',
                'final',
                'inline',
                'delimiter',
                'deprecated',
                '<PRIVATE',
                '>>>>>>',
                '<<<<<<<',
                'parse-complex',
                'malformed-complex',
                'read-only',
                '>>>>>>>',
                'call-next-method',
                '<<',
                'foldable',
                // literals
                '$',
                '$[',
                '${'
            ],
            'sequences-builtin': [
                'member-eq?',
                'mismatch',
                'append',
                'assert-sequence=',
                'longer',
                'repetition',
                'clone-like',
                '3sequence',
                'assert-sequence?',
                'last-index-from',
                'reversed',
                'index-from',
                'cut*',
                'pad-tail',
                'join-as',
                'remove-eq!',
                'concat-as',
                'but-last',
                'snip',
                'nths',
                'nth',
                'sequence',
                'longest',
                'slice?',
                '<slice>',
                'remove-nth',
                'tail-slice',
                'empty?',
                'tail*',
                'member?',
                'virtual-sequence?',
                'set-length',
                'drop-prefix',
                'iota',
                'unclip',
                'bounds-error?',
                'unclip-last-slice',
                'non-negative-integer-expected',
                'non-negative-integer-expected?',
                'midpoint@',
                'longer?',
                '?set-nth',
                '?first',
                'rest-slice',
                'prepend-as',
                'prepend',
                'fourth',
                'sift',
                'subseq-start',
                'new-sequence',
                '?last',
                'like',
                'first4',
                '1sequence',
                'reverse',
                'slice',
                'virtual@',
                'repetition?',
                'set-last',
                'index',
                '4sequence',
                'max-length',
                'set-second',
                'immutable-sequence',
                'first2',
                'first3',
                'supremum',
                'unclip-slice',
                'suffix!',
                'insert-nth',
                'tail',
                '3append',
                'short',
                'suffix',
                'concat',
                'flip',
                'immutable?',
                'reverse!',
                '2sequence',
                'sum',
                'delete-all',
                'indices',
                'snip-slice',
                '<iota>',
                'check-slice',
                'sequence?',
                'head',
                'append-as',
                'halves',
                'sequence=',
                'collapse-slice',
                '?second',
                'slice-error?',
                'product',
                'bounds-check?',
                'bounds-check',
                'immutable',
                'virtual-exemplar',
                'harvest',
                'remove',
                'pad-head',
                'last',
                'set-fourth',
                'cartesian-product',
                'remove-eq',
                'shorten',
                'shorter',
                'reversed?',
                'shorter?',
                'shortest',
                'head-slice',
                'pop*',
                'tail-slice*',
                'but-last-slice',
                'iota?',
                'append!',
                'cut-slice',
                'new-resizable',
                'head-slice*',
                'sequence-hashcode',
                'pop',
                'set-nth',
                '?nth',
                'second',
                'join',
                'immutable-sequence?',
                '<reversed>',
                '3append-as',
                'virtual-sequence',
                'subseq?',
                'remove-nth!',
                'length',
                'last-index',
                'lengthen',
                'assert-sequence',
                'copy',
                'move',
                'third',
                'first',
                'tail?',
                'set-first',
                'prefix',
                'bounds-error',
                '<repetition>',
                'exchange',
                'surround',
                'cut',
                'min-length',
                'set-third',
                'push-all',
                'head?',
                'subseq-start-from',
                'delete-slice',
                'rest',
                'sum-lengths',
                'head*',
                'infimum',
                'remove!',
                'glue',
                'slice-error',
                'subseq',
                'push',
                'replace-slice',
                'subseq-as',
                'unclip-last'
            ],
            'math-builtin': [
                'number=',
                'next-power-of-2',
                '?1+',
                'fp-special?',
                'imaginary-part',
                'float>bits',
                'number?',
                'fp-infinity?',
                'bignum?',
                'fp-snan?',
                'denominator',
                'gcd',
                '*',
                '+',
                'fp-bitwise=',
                '-',
                'u>=',
                '/',
                '>=',
                'bitand',
                'power-of-2?',
                'log2-expects-positive',
                'neg?',
                '<',
                'log2',
                '>',
                'integer?',
                'number',
                'bits>double',
                '2/',
                'zero?',
                'bits>float',
                'float?',
                'shift',
                'ratio?',
                'rect>',
                'even?',
                'ratio',
                'fp-sign',
                'bitnot',
                '>fixnum',
                'complex?',
                '/i',
                'integer>fixnum',
                '/f',
                'sgn',
                '>bignum',
                'next-float',
                'u<',
                'u>',
                'mod',
                'recip',
                'rational',
                '>float',
                '2^',
                'integer',
                'fixnum?',
                'neg',
                'fixnum',
                'sq',
                'bignum',
                '>rect',
                'bit?',
                'fp-qnan?',
                'simple-gcd',
                'complex',
                '<fp-nan>',
                'real',
                '>fraction',
                'double>bits',
                'bitor',
                'rem',
                'fp-nan-payload',
                'real-part',
                'log2-expects-positive?',
                'prev-float',
                'align',
                'unordered?',
                'float',
                'fp-nan?',
                'abs',
                'bitxor',
                'integer>fixnum-strict',
                'u<=',
                'odd?',
                '<=',
                '/mod',
                '>integer',
                'real?',
                'rational?',
                'numerator'
            ]
        };
        Object.keys(builtins).forEach(function(k) {
            factor[k].pattern = arrToWordsRegExp(builtins[k]);
        });
        var combinators = [
            // kernel
            '2bi',
            'while',
            '2tri',
            'bi*',
            '4dip',
            'both?',
            'same?',
            'tri@',
            'curry',
            'prepose',
            '3bi',
            '?if',
            'tri*',
            '2keep',
            '3keep',
            'curried',
            '2keepd',
            'when',
            '2bi*',
            '2tri*',
            '4keep',
            'bi@',
            'keepdd',
            'do',
            'unless*',
            'tri-curry',
            'if*',
            'loop',
            'bi-curry*',
            'when*',
            '2bi@',
            '2tri@',
            'with',
            '2with',
            'either?',
            'bi',
            'until',
            '3dip',
            '3curry',
            'tri-curry*',
            'tri-curry@',
            'bi-curry',
            'keepd',
            'compose',
            '2dip',
            'if',
            '3tri',
            'unless',
            'tuple',
            'keep',
            '2curry',
            'tri',
            'most',
            'while*',
            'dip',
            'composed',
            'bi-curry@',
            // sequences
            'find-last-from',
            'trim-head-slice',
            'map-as',
            'each-from',
            'none?',
            'trim-tail',
            'partition',
            'if-empty',
            'accumulate*',
            'reject!',
            'find-from',
            'accumulate-as',
            'collector-for-as',
            'reject',
            'map',
            'map-sum',
            'accumulate!',
            '2each-from',
            'follow',
            'supremum-by',
            'map!',
            'unless-empty',
            'collector',
            'padding',
            'reduce-index',
            'replicate-as',
            'infimum-by',
            'trim-tail-slice',
            'count',
            'find-index',
            'filter',
            'accumulate*!',
            'reject-as',
            'map-integers',
            'map-find',
            'reduce',
            'selector',
            'interleave',
            '2map',
            'filter-as',
            'binary-reduce',
            'map-index-as',
            'find',
            'produce',
            'filter!',
            'replicate',
            'cartesian-map',
            'cartesian-each',
            'find-index-from',
            'map-find-last',
            '3map-as',
            '3map',
            'find-last',
            'selector-as',
            '2map-as',
            '2map-reduce',
            'accumulate',
            'each',
            'each-index',
            'accumulate*-as',
            'when-empty',
            'all?',
            'collector-as',
            'push-either',
            'new-like',
            'collector-for',
            '2selector',
            'push-if',
            '2all?',
            'map-reduce',
            '3each',
            'any?',
            'trim-slice',
            '2reduce',
            'change-nth',
            'produce-as',
            '2each',
            'trim',
            'trim-head',
            'cartesian-find',
            'map-index',
            // math
            'if-zero',
            'each-integer',
            'unless-zero',
            '(find-integer)',
            'when-zero',
            'find-last-integer',
            '(all-integers?)',
            'times',
            '(each-integer)',
            'find-integer',
            'all-integers?',
            // math.combinators
            'unless-negative',
            'if-positive',
            'when-positive',
            'when-negative',
            'unless-positive',
            'if-negative',
            // combinators
            'case',
            '2cleave',
            'cond>quot',
            'case>quot',
            '3cleave',
            'wrong-values',
            'to-fixed-point',
            'alist>quot',
            'cond',
            'cleave',
            'call-effect',
            'recursive-hashcode',
            'spread',
            'deep-spread>quot',
            // combinators.short-circuit
            '2||',
            '0||',
            'n||',
            '0&&',
            '2&&',
            '3||',
            '1||',
            '1&&',
            'n&&',
            '3&&',
            // combinators.smart
            'smart-unless*',
            'keep-inputs',
            'reduce-outputs',
            'smart-when*',
            'cleave>array',
            'smart-with',
            'smart-apply',
            'smart-if',
            'inputs/outputs',
            'output>sequence-n',
            'map-outputs',
            'map-reduce-outputs',
            'dropping',
            'output>array',
            'smart-map-reduce',
            'smart-2map-reduce',
            'output>array-n',
            'nullary',
            'input<sequence',
            'append-outputs',
            'drop-inputs',
            'inputs',
            'smart-2reduce',
            'drop-outputs',
            'smart-reduce',
            'preserving',
            'smart-when',
            'outputs',
            'append-outputs-as',
            'smart-unless',
            'smart-if*',
            'sum-outputs',
            'input<sequence-unsafe',
            'output>sequence'
        ];
        factor.combinators.pattern = arrToWordsRegExp(combinators);
        Prism.languages.factor = factor;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $0690cd6d0a840968$export$2e2bcd8739ae039.displayName = 'false';
$0690cd6d0a840968$export$2e2bcd8739ae039.aliases = [];
function $0690cd6d0a840968$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        /**
     * Based on the manual by Wouter van Oortmerssen.
     *
     * @see {@link https://github.com/PrismJS/prism/issues/2801#issue-829717504}
     */ Prism.languages['false'] = {
            comment: {
                pattern: /\{[^}]*\}/
            },
            string: {
                pattern: /"[^"]*"/,
                greedy: true
            },
            'character-code': {
                pattern: /'(?:[^\r]|\r\n?)/,
                alias: 'number'
            },
            'assembler-code': {
                pattern: /\d+`/,
                alias: 'important'
            },
            number: /\d+/,
            operator: /[-!#$%&'*+,./:;=>?@\\^_`|~ßø]/,
            punctuation: /\[|\]/,
            variable: /[a-z]/,
            'non-standard': {
                pattern: /[()<BDO®]/,
                alias: 'bold'
            }
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$b30f7170c1780bbb$export$2e2bcd8739ae039.displayName = 'firestore-security-rules';
$b30f7170c1780bbb$export$2e2bcd8739ae039.aliases = [];
function $b30f7170c1780bbb$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages['firestore-security-rules'] = Prism.languages.extend('clike', {
        comment: /\/\/.*/,
        keyword: /\b(?:allow|function|if|match|null|return|rules_version|service)\b/,
        operator: /&&|\|\||[<>!=]=?|[-+*/%]|\b(?:in|is)\b/
    });
    delete Prism.languages['firestore-security-rules']['class-name'];
    Prism.languages.insertBefore('firestore-security-rules', 'keyword', {
        path: {
            pattern: /(^|[\s(),])(?:\/(?:[\w\xA0-\uFFFF]+|\{[\w\xA0-\uFFFF]+(?:=\*\*)?\}|\$\([\w\xA0-\uFFFF.]+\)))+/,
            lookbehind: true,
            greedy: true,
            inside: {
                variable: {
                    pattern: /\{[\w\xA0-\uFFFF]+(?:=\*\*)?\}|\$\([\w\xA0-\uFFFF.]+\)/,
                    inside: {
                        operator: /=/,
                        keyword: /\*\*/,
                        punctuation: /[.$(){}]/
                    }
                },
                punctuation: /\//
            }
        },
        method: {
            // to make the pattern shorter, the actual method names are omitted
            pattern: /(\ballow\s+)[a-z]+(?:\s*,\s*[a-z]+)*(?=\s*[:;])/,
            lookbehind: true,
            alias: 'builtin',
            inside: {
                punctuation: /,/
            }
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$589c0bdcaa161eef$export$2e2bcd8739ae039.displayName = 'flow';
$589c0bdcaa161eef$export$2e2bcd8739ae039.aliases = [];
function $589c0bdcaa161eef$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.flow = Prism.languages.extend('javascript', {});
        Prism.languages.insertBefore('flow', 'keyword', {
            type: [
                {
                    pattern: /\b(?:[Bb]oolean|Function|[Nn]umber|[Ss]tring|[Ss]ymbol|any|mixed|null|void)\b/,
                    alias: 'class-name'
                }
            ]
        });
        Prism.languages.flow['function-variable'].pattern = /(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=\s*(?:function\b|(?:\([^()]*\)(?:\s*:\s*\w+)?|(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/i;
        delete Prism.languages.flow['parameter'];
        Prism.languages.insertBefore('flow', 'operator', {
            'flow-punctuation': {
                pattern: /\{\||\|\}/,
                alias: 'punctuation'
            }
        });
        if (!Array.isArray(Prism.languages.flow.keyword)) Prism.languages.flow.keyword = [
            Prism.languages.flow.keyword
        ];
        Prism.languages.flow.keyword.unshift({
            pattern: /(^|[^$]\b)(?:Class|declare|opaque|type)\b(?!\$)/,
            lookbehind: true
        }, {
            pattern: /(^|[^$]\B)\$(?:Diff|Enum|Exact|Keys|ObjMap|PropertyType|Record|Shape|Subtype|Supertype|await)\b(?!\$)/,
            lookbehind: true
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $1f14745690836bca$export$2e2bcd8739ae039.displayName = 'fortran';
$1f14745690836bca$export$2e2bcd8739ae039.aliases = [];
function $1f14745690836bca$export$2e2bcd8739ae039(Prism) {
    Prism.languages.fortran = {
        'quoted-number': {
            pattern: /[BOZ](['"])[A-F0-9]+\1/i,
            alias: 'number'
        },
        string: {
            pattern: /(?:\b\w+_)?(['"])(?:\1\1|&(?:\r\n?|\n)(?:[ \t]*!.*(?:\r\n?|\n)|(?![ \t]*!))|(?!\1).)*(?:\1|&)/,
            inside: {
                comment: {
                    pattern: /(&(?:\r\n?|\n)\s*)!.*/,
                    lookbehind: true
                }
            }
        },
        comment: {
            pattern: /!.*/,
            greedy: true
        },
        boolean: /\.(?:FALSE|TRUE)\.(?:_\w+)?/i,
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[ED][+-]?\d+)?(?:_\w+)?/i,
        keyword: [
            // Types
            /\b(?:CHARACTER|COMPLEX|DOUBLE ?PRECISION|INTEGER|LOGICAL|REAL)\b/i,
            // END statements
            /\b(?:END ?)?(?:BLOCK ?DATA|DO|FILE|FORALL|FUNCTION|IF|INTERFACE|MODULE(?! PROCEDURE)|PROGRAM|SELECT|SUBROUTINE|TYPE|WHERE)\b/i,
            // Statements
            /\b(?:ALLOCATABLE|ALLOCATE|BACKSPACE|CALL|CASE|CLOSE|COMMON|CONTAINS|CONTINUE|CYCLE|DATA|DEALLOCATE|DIMENSION|DO|END|EQUIVALENCE|EXIT|EXTERNAL|FORMAT|GO ?TO|IMPLICIT(?: NONE)?|INQUIRE|INTENT|INTRINSIC|MODULE PROCEDURE|NAMELIST|NULLIFY|OPEN|OPTIONAL|PARAMETER|POINTER|PRINT|PRIVATE|PUBLIC|READ|RETURN|REWIND|SAVE|SELECT|STOP|TARGET|WHILE|WRITE)\b/i,
            // Others
            /\b(?:ASSIGNMENT|DEFAULT|ELEMENTAL|ELSE|ELSEIF|ELSEWHERE|ENTRY|IN|INCLUDE|INOUT|KIND|NULL|ONLY|OPERATOR|OUT|PURE|RECURSIVE|RESULT|SEQUENCE|STAT|THEN|USE)\b/i
        ],
        operator: [
            /\*\*|\/\/|=>|[=\/]=|[<>]=?|::|[+\-*=%]|\.[A-Z]+\./i,
            {
                // Use lookbehind to prevent confusion with (/ /)
                pattern: /(^|(?!\().)\/(?!\))/,
                lookbehind: true
            }
        ],
        punctuation: /\(\/|\/\)|[(),;:&]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$c4bd90163a636571$export$2e2bcd8739ae039.displayName = 'ftl';
$c4bd90163a636571$export$2e2bcd8739ae039.aliases = [];
function $c4bd90163a636571$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
    (function(Prism) {
        // https://freemarker.apache.org/docs/dgui_template_exp.html
        // FTL expression with 4 levels of nesting supported
        var FTL_EXPR = /[^<()"']|\((?:<expr>)*\)|<(?!#--)|<#--(?:[^-]|-(?!->))*-->|"(?:[^\\"]|\\.)*"|'(?:[^\\']|\\.)*'/.source;
        for(var i = 0; i < 2; i++)FTL_EXPR = FTL_EXPR.replace(/<expr>/g, function() {
            return FTL_EXPR;
        });
        FTL_EXPR = FTL_EXPR.replace(/<expr>/g, /[^\s\S]/.source);
        var ftl = {
            comment: /<#--[\s\S]*?-->/,
            string: [
                {
                    // raw string
                    pattern: /\br("|')(?:(?!\1)[^\\]|\\.)*\1/,
                    greedy: true
                },
                {
                    pattern: RegExp(/("|')(?:(?!\1|\$\{)[^\\]|\\.|\$\{(?:(?!\})(?:<expr>))*\})*\1/.source.replace(/<expr>/g, function() {
                        return FTL_EXPR;
                    })),
                    greedy: true,
                    inside: {
                        interpolation: {
                            pattern: RegExp(/((?:^|[^\\])(?:\\\\)*)\$\{(?:(?!\})(?:<expr>))*\}/.source.replace(/<expr>/g, function() {
                                return FTL_EXPR;
                            })),
                            lookbehind: true,
                            inside: {
                                'interpolation-punctuation': {
                                    pattern: /^\$\{|\}$/,
                                    alias: 'punctuation'
                                },
                                rest: null
                            }
                        }
                    }
                }
            ],
            keyword: /\b(?:as)\b/,
            boolean: /\b(?:false|true)\b/,
            'builtin-function': {
                pattern: /((?:^|[^?])\?\s*)\w+/,
                lookbehind: true,
                alias: 'function'
            },
            function: /\b\w+(?=\s*\()/,
            number: /\b\d+(?:\.\d+)?\b/,
            operator: /\.\.[<*!]?|->|--|\+\+|&&|\|\||\?{1,2}|[-+*/%!=<>]=?|\b(?:gt|gte|lt|lte)\b/,
            punctuation: /[,;.:()[\]{}]/
        };
        ftl.string[1].inside.interpolation.inside.rest = ftl;
        Prism.languages.ftl = {
            'ftl-comment': {
                // the pattern is shortened to be more efficient
                pattern: /^<#--[\s\S]*/,
                alias: 'comment'
            },
            'ftl-directive': {
                pattern: /^<[\s\S]+>$/,
                inside: {
                    directive: {
                        pattern: /(^<\/?)[#@][a-z]\w*/i,
                        lookbehind: true,
                        alias: 'keyword'
                    },
                    punctuation: /^<\/?|\/?>$/,
                    content: {
                        pattern: /\s*\S[\s\S]*/,
                        alias: 'ftl',
                        inside: ftl
                    }
                }
            },
            'ftl-interpolation': {
                pattern: /^\$\{[\s\S]*\}$/,
                inside: {
                    punctuation: /^\$\{|\}$/,
                    content: {
                        pattern: /\s*\S[\s\S]*/,
                        alias: 'ftl',
                        inside: ftl
                    }
                }
            }
        };
        Prism.hooks.add('before-tokenize', function(env) {
            // eslint-disable-next-line regexp/no-useless-lazy
            var pattern = RegExp(/<#--[\s\S]*?-->|<\/?[#@][a-zA-Z](?:<expr>)*?>|\$\{(?:<expr>)*?\}/.source.replace(/<expr>/g, function() {
                return FTL_EXPR;
            }), 'gi');
            Prism.languages['markup-templating'].buildPlaceholders(env, 'ftl', pattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'ftl');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$d04717890a46cf2e$export$2e2bcd8739ae039.displayName = 'gml';
$d04717890a46cf2e$export$2e2bcd8739ae039.aliases = [
    'gamemakerlanguage'
];
function $d04717890a46cf2e$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.gamemakerlanguage = Prism.languages.gml = Prism.languages.extend('clike', {
        keyword: /\b(?:break|case|continue|default|do|else|enum|exit|for|globalvar|if|repeat|return|switch|until|var|while)\b/,
        number: /(?:\b0x[\da-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ulf]{0,4}/i,
        operator: /--|\+\+|[-+%/=]=?|!=|\*\*?=?|<[<=>]?|>[=>]?|&&?|\^\^?|\|\|?|~|\b(?:and|at|not|or|with|xor)\b/,
        constant: /\b(?:GM_build_date|GM_version|action_(?:continue|restart|reverse|stop)|all|gamespeed_(?:fps|microseconds)|global|local|noone|other|pi|pointer_(?:invalid|null)|self|timezone_(?:local|utc)|undefined|ev_(?:create|destroy|step|alarm|keyboard|mouse|collision|other|draw|draw_(?:begin|end|post|pre)|keypress|keyrelease|trigger|(?:left|middle|no|right)_button|(?:left|middle|right)_press|(?:left|middle|right)_release|mouse_(?:enter|leave|wheel_down|wheel_up)|global_(?:left|middle|right)_button|global_(?:left|middle|right)_press|global_(?:left|middle|right)_release|joystick(?:1|2)_(?:button1|button2|button3|button4|button5|button6|button7|button8|down|left|right|up)|outside|boundary|game_start|game_end|room_start|room_end|no_more_lives|animation_end|end_of_path|no_more_health|user\d|gui|gui_begin|gui_end|step_(?:begin|end|normal))|vk_(?:alt|anykey|backspace|control|delete|down|end|enter|escape|home|insert|left|nokey|pagedown|pageup|pause|printscreen|return|right|shift|space|tab|up|f\d|numpad\d|add|decimal|divide|lalt|lcontrol|lshift|multiply|ralt|rcontrol|rshift|subtract)|achievement_(?:filter_(?:all_players|favorites_only|friends_only)|friends_info|info|leaderboard_info|our_info|pic_loaded|show_(?:achievement|bank|friend_picker|leaderboard|profile|purchase_prompt|ui)|type_challenge|type_score_challenge)|asset_(?:font|object|path|room|script|shader|sound|sprite|tiles|timeline|unknown)|audio_(?:3d|falloff_(?:exponent_distance|exponent_distance_clamped|inverse_distance|inverse_distance_clamped|linear_distance|linear_distance_clamped|none)|mono|new_system|old_system|stereo)|bm_(?:add|complex|dest_alpha|dest_color|dest_colour|inv_dest_alpha|inv_dest_color|inv_dest_colour|inv_src_alpha|inv_src_color|inv_src_colour|max|normal|one|src_alpha|src_alpha_sat|src_color|src_colour|subtract|zero)|browser_(?:chrome|firefox|ie|ie_mobile|not_a_browser|opera|safari|safari_mobile|tizen|unknown|windows_store)|buffer_(?:bool|f16|f32|f64|fast|fixed|generalerror|grow|invalidtype|network|outofbounds|outofspace|s16|s32|s8|seek_end|seek_relative|seek_start|string|text|u16|u32|u64|u8|vbuffer|wrap)|c_(?:aqua|black|blue|dkgray|fuchsia|gray|green|lime|ltgray|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow)|cmpfunc_(?:always|equal|greater|greaterequal|less|lessequal|never|notequal)|cr_(?:appstart|arrow|beam|cross|default|drag|handpoint|hourglass|none|size_all|size_nesw|size_ns|size_nwse|size_we|uparrow)|cull_(?:clockwise|counterclockwise|noculling)|device_(?:emulator|tablet)|device_ios_(?:ipad|ipad_retina|iphone|iphone5|iphone6|iphone6plus|iphone_retina|unknown)|display_(?:landscape|landscape_flipped|portrait|portrait_flipped)|dll_(?:cdecl|cdel|stdcall)|ds_type_(?:grid|list|map|priority|queue|stack)|ef_(?:cloud|ellipse|explosion|firework|flare|rain|ring|smoke|smokeup|snow|spark|star)|fa_(?:archive|bottom|center|directory|hidden|left|middle|readonly|right|sysfile|top|volumeid)|fb_login_(?:default|fallback_to_webview|forcing_safari|forcing_webview|no_fallback_to_webview|use_system_account)|iap_(?:available|canceled|ev_consume|ev_product|ev_purchase|ev_restore|ev_storeload|failed|purchased|refunded|status_available|status_loading|status_processing|status_restoring|status_unavailable|status_uninitialised|storeload_failed|storeload_ok|unavailable)|leaderboard_type_(?:number|time_mins_secs)|lighttype_(?:dir|point)|matrix_(?:projection|view|world)|mb_(?:any|left|middle|none|right)|network_(?:config_(?:connect_timeout|disable_reliable_udp|enable_reliable_udp|use_non_blocking_socket)|socket_(?:bluetooth|tcp|udp)|type_(?:connect|data|disconnect|non_blocking_connect))|of_challenge_(?:lose|tie|win)|os_(?:android|ios|linux|macosx|ps3|ps4|psvita|unknown|uwp|win32|win8native|windows|winphone|xboxone)|phy_debug_render_(?:aabb|collision_pairs|coms|core_shapes|joints|obb|shapes)|phy_joint_(?:anchor_1_x|anchor_1_y|anchor_2_x|anchor_2_y|angle|angle_limits|damping_ratio|frequency|length_1|length_2|lower_angle_limit|max_force|max_length|max_motor_force|max_motor_torque|max_torque|motor_force|motor_speed|motor_torque|reaction_force_x|reaction_force_y|reaction_torque|speed|translation|upper_angle_limit)|phy_particle_data_flag_(?:category|color|colour|position|typeflags|velocity)|phy_particle_flag_(?:colormixing|colourmixing|elastic|powder|spring|tensile|viscous|wall|water|zombie)|phy_particle_group_flag_(?:rigid|solid)|pr_(?:linelist|linestrip|pointlist|trianglefan|trianglelist|trianglestrip)|ps_(?:distr|shape)_(?:diamond|ellipse|gaussian|invgaussian|line|linear|rectangle)|pt_shape_(?:circle|cloud|disk|explosion|flare|line|pixel|ring|smoke|snow|spark|sphere|square|star)|ty_(?:real|string)|gp_(?:face\d|axislh|axislv|axisrh|axisrv|padd|padl|padr|padu|select|shoulderl|shoulderlb|shoulderr|shoulderrb|start|stickl|stickr)|lb_disp_(?:none|numeric|time_ms|time_sec)|lb_sort_(?:ascending|descending|none)|ov_(?:achievements|community|friends|gamegroup|players|settings)|ugc_(?:filetype_(?:community|microtrans)|list_(?:Favorited|Followed|Published|Subscribed|UsedOrPlayed|VotedDown|VotedOn|VotedUp|WillVoteLater)|match_(?:AllGuides|Artwork|Collections|ControllerBindings|IntegratedGuides|Items|Items_Mtx|Items_ReadyToUse|Screenshots|UsableInGame|Videos|WebGuides)|query_(?:AcceptedForGameRankedByAcceptanceDate|CreatedByFriendsRankedByPublicationDate|FavoritedByFriendsRankedByPublicationDate|NotYetRated)|query_RankedBy(?:NumTimesReported|PublicationDate|TextSearch|TotalVotesAsc|Trend|Vote|VotesUp)|result_success|sortorder_CreationOrder(?:Asc|Desc)|sortorder_(?:ForModeration|LastUpdatedDesc|SubscriptionDateDesc|TitleAsc|VoteScoreDesc)|visibility_(?:friends_only|private|public))|vertex_usage_(?:binormal|blendindices|blendweight|color|colour|depth|fog|normal|position|psize|sample|tangent|texcoord|textcoord)|vertex_type_(?:float\d|color|colour|ubyte4)|input_type|layerelementtype_(?:background|instance|oldtilemap|particlesystem|sprite|tile|tilemap|undefined)|se_(?:chorus|compressor|echo|equalizer|flanger|gargle|none|reverb)|text_type|tile_(?:flip|index_mask|mirror|rotate)|(?:obj|rm|scr|spr)\w+)\b/,
        variable: /\b(?:alarm|application_surface|async_load|background_(?:alpha|blend|color|colour|foreground|height|hspeed|htiled|index|showcolor|showcolour|visible|vspeed|vtiled|width|x|xscale|y|yscale)|bbox_(?:bottom|left|right|top)|browser_(?:height|width)|caption_(?:health|lives|score)|current_(?:day|hour|minute|month|second|time|weekday|year)|cursor_sprite|debug_mode|delta_time|direction|display_aa|error_(?:last|occurred)|event_(?:action|number|object|type)|fps|fps_real|friction|game_(?:display|project|save)_(?:id|name)|gamemaker_(?:pro|registered|version)|gravity|gravity_direction|(?:h|v)speed|health|iap_data|id|image_(?:alpha|angle|blend|depth|index|number|speed|xscale|yscale)|instance_(?:count|id)|keyboard_(?:key|lastchar|lastkey|string)|layer|lives|mask_index|mouse_(?:button|lastbutton|x|y)|object_index|os_(?:browser|device|type|version)|path_(?:endaction|index|orientation|position|positionprevious|scale|speed)|persistent|phy_(?:rotation|(?:col_normal|collision|com|linear_velocity|position|speed)_(?:x|y)|angular_(?:damping|velocity)|position_(?:x|y)previous|speed|linear_damping|bullet|fixed_rotation|active|mass|inertia|dynamic|kinematic|sleeping|collision_points)|pointer_(?:invalid|null)|room|room_(?:caption|first|height|last|persistent|speed|width)|score|secure_mode|show_(?:health|lives|score)|solid|speed|sprite_(?:height|index|width|xoffset|yoffset)|temp_directory|timeline_(?:index|loop|position|running|speed)|transition_(?:color|kind|steps)|undefined|view_(?:angle|current|enabled|(?:h|v)(?:border|speed)|(?:h|w|x|y)port|(?:h|w|x|y)view|object|surface_id|visible)|visible|webgl_enabled|working_directory|(?:x|y)(?:previous|start)|x|y|argument(?:_relitive|_count|\d)|argument|global|local|other|self)\b/
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $79b0be010e76d7ca$export$2e2bcd8739ae039.displayName = 'gap';
$79b0be010e76d7ca$export$2e2bcd8739ae039.aliases = [];
function $79b0be010e76d7ca$export$2e2bcd8739ae039(Prism) {
    // https://www.gap-system.org/Manuals/doc/ref/chap4.html
    // https://www.gap-system.org/Manuals/doc/ref/chap27.html
    Prism.languages.gap = {
        shell: {
            pattern: /^gap>[\s\S]*?(?=^gap>|$(?![\s\S]))/m,
            greedy: true,
            inside: {
                gap: {
                    pattern: /^(gap>).+(?:(?:\r(?:\n|(?!\n))|\n)>.*)*/,
                    lookbehind: true,
                    inside: null // see below
                },
                punctuation: /^gap>/
            }
        },
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\'"])(?:'(?:[^\r\n\\']|\\.){1,10}'|"(?:[^\r\n\\"]|\\.)*"(?!")|"""[\s\S]*?""")/,
            lookbehind: true,
            greedy: true,
            inside: {
                continuation: {
                    pattern: /([\r\n])>/,
                    lookbehind: true,
                    alias: 'punctuation'
                }
            }
        },
        keyword: /\b(?:Assert|Info|IsBound|QUIT|TryNextMethod|Unbind|and|atomic|break|continue|do|elif|else|end|fi|for|function|if|in|local|mod|not|od|or|quit|readonly|readwrite|rec|repeat|return|then|until|while)\b/,
        boolean: /\b(?:false|true)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: {
            pattern: /(^|[^\w.]|\.\.)(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?(?:_[a-z]?)?(?=$|[^\w.]|\.\.)/,
            lookbehind: true
        },
        continuation: {
            pattern: /([\r\n])>/,
            lookbehind: true,
            alias: 'punctuation'
        },
        operator: /->|[-+*/^~=!]|<>|[<>]=?|:=|\.\./,
        punctuation: /[()[\]{},;.:]/
    };
    Prism.languages.gap.shell.inside.gap.inside = Prism.languages.gap;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $3ad1242016c38065$export$2e2bcd8739ae039.displayName = 'gcode';
$3ad1242016c38065$export$2e2bcd8739ae039.aliases = [];
function $3ad1242016c38065$export$2e2bcd8739ae039(Prism) {
    Prism.languages.gcode = {
        comment: /;.*|\B\(.*?\)\B/,
        string: {
            pattern: /"(?:""|[^"])*"/,
            greedy: true
        },
        keyword: /\b[GM]\d+(?:\.\d+)?\b/,
        property: /\b[A-Z]/,
        checksum: {
            pattern: /(\*)\d+/,
            lookbehind: true,
            alias: 'number'
        },
        // T0:0:0
        punctuation: /[:*]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $675c24a063f84cbd$export$2e2bcd8739ae039.displayName = 'gdscript';
$675c24a063f84cbd$export$2e2bcd8739ae039.aliases = [];
function $675c24a063f84cbd$export$2e2bcd8739ae039(Prism) {
    Prism.languages.gdscript = {
        comment: /#.*/,
        string: {
            pattern: /@?(?:("|')(?:(?!\1)[^\n\\]|\\[\s\S])*\1(?!"|')|"""(?:[^\\]|\\[\s\S])*?""")/,
            greedy: true
        },
        'class-name': {
            // class_name Foo, extends Bar, class InnerClass
            // export(int) var baz, export(int, 0) var i
            // as Node
            // const FOO: int = 9, var bar: bool = true
            // func add(reference: Item, amount: int) -> Item:
            pattern: /(^(?:class|class_name|extends)[ \t]+|^export\([ \t]*|\bas[ \t]+|(?:\b(?:const|var)[ \t]|[,(])[ \t]*\w+[ \t]*:[ \t]*|->[ \t]*)[a-zA-Z_]\w*/m,
            lookbehind: true
        },
        keyword: /\b(?:and|as|assert|break|breakpoint|class|class_name|const|continue|elif|else|enum|export|extends|for|func|if|in|is|master|mastersync|match|not|null|onready|or|pass|preload|puppet|puppetsync|remote|remotesync|return|self|setget|signal|static|tool|var|while|yield)\b/,
        function: /\b[a-z_]\w*(?=[ \t]*\()/i,
        variable: /\$\w+/,
        number: [
            /\b0b[01_]+\b|\b0x[\da-fA-F_]+\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.[\d_]+)(?:e[+-]?[\d_]+)?\b/,
            /\b(?:INF|NAN|PI|TAU)\b/
        ],
        constant: /\b[A-Z][A-Z_\d]*\b/,
        boolean: /\b(?:false|true)\b/,
        operator: /->|:=|&&|\|\||<<|>>|[-+*/%&|!<>=]=?|[~^]/,
        punctuation: /[.:,;()[\]{}]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $b7509ddd058c90d0$export$2e2bcd8739ae039.displayName = 'gedcom';
$b7509ddd058c90d0$export$2e2bcd8739ae039.aliases = [];
function $b7509ddd058c90d0$export$2e2bcd8739ae039(Prism) {
    Prism.languages.gedcom = {
        'line-value': {
            // Preceded by level, optional pointer, and tag
            pattern: /(^[\t ]*\d+ +(?:@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@ +)?\w+ ).+/m,
            lookbehind: true,
            inside: {
                pointer: {
                    pattern: /^@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@$/,
                    alias: 'variable'
                }
            }
        },
        record: {
            // Preceded by level and optional pointer
            pattern: /(^[\t ]*\d+ +(?:@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@ +)?)\w+/m,
            lookbehind: true,
            alias: 'tag'
        },
        level: {
            pattern: /(^[\t ]*)\d+/m,
            lookbehind: true,
            alias: 'number'
        },
        pointer: {
            pattern: /@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@/,
            alias: 'variable'
        }
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $ec3042630860b388$export$2e2bcd8739ae039.displayName = 'gettext';
$ec3042630860b388$export$2e2bcd8739ae039.aliases = [
    'po'
];
function $ec3042630860b388$export$2e2bcd8739ae039(Prism) {
    Prism.languages.gettext = {
        comment: [
            {
                pattern: /# .*/,
                greedy: true,
                alias: 'translator-comment'
            },
            {
                pattern: /#\..*/,
                greedy: true,
                alias: 'extracted-comment'
            },
            {
                pattern: /#:.*/,
                greedy: true,
                alias: 'reference-comment'
            },
            {
                pattern: /#,.*/,
                greedy: true,
                alias: 'flag-comment'
            },
            {
                pattern: /#\|.*/,
                greedy: true,
                alias: 'previously-untranslated-comment'
            },
            {
                pattern: /#.*/,
                greedy: true
            }
        ],
        string: {
            pattern: /(^|[^\\])"(?:[^"\\]|\\.)*"/,
            lookbehind: true,
            greedy: true
        },
        keyword: /^msg(?:ctxt|id|id_plural|str)\b/m,
        number: /\b\d+\b/,
        punctuation: /[\[\]]/
    };
    Prism.languages.po = Prism.languages.gettext;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $e41ae20b134c7e19$export$2e2bcd8739ae039.displayName = 'gherkin';
$e41ae20b134c7e19$export$2e2bcd8739ae039.aliases = [];
function $e41ae20b134c7e19$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var tableRow = /(?:\r?\n|\r)[ \t]*\|.+\|(?:(?!\|).)*/.source;
        Prism.languages.gherkin = {
            pystring: {
                pattern: /("""|''')[\s\S]+?\1/,
                alias: 'string'
            },
            comment: {
                pattern: /(^[ \t]*)#.*/m,
                lookbehind: true
            },
            tag: {
                pattern: /(^[ \t]*)@\S*/m,
                lookbehind: true
            },
            feature: {
                pattern: /((?:^|\r?\n|\r)[ \t]*)(?:Ability|Ahoy matey!|Arwedd|Aspekt|Besigheid Behoefte|Business Need|Caracteristica|Característica|Egenskab|Egenskap|Eiginleiki|Feature|Fīča|Fitur|Fonctionnalité|Fonksyonalite|Funcionalidade|Funcionalitat|Functionalitate|Funcţionalitate|Funcționalitate|Functionaliteit|Fungsi|Funkcia|Funkcija|Funkcionalitāte|Funkcionalnost|Funkcja|Funksie|Funktionalität|Funktionalitéit|Funzionalità|Hwaet|Hwæt|Jellemző|Karakteristik|Lastnost|Mak|Mogucnost|laH|Mogućnost|Moznosti|Možnosti|OH HAI|Omadus|Ominaisuus|Osobina|Özellik|Potrzeba biznesowa|perbogh|poQbogh malja'|Požadavek|Požiadavka|Pretty much|Qap|Qu'meH 'ut|Savybė|Tính năng|Trajto|Vermoë|Vlastnosť|Właściwość|Značilnost|Δυνατότητα|Λειτουργία|Могућност|Мөмкинлек|Особина|Свойство|Үзенчәлеклелек|Функционал|Функционалност|Функция|Функціонал|תכונה|خاصية|خصوصیت|صلاحیت|کاروبار کی ضرورت|وِیژگی|रूप लेख|ਖਾਸੀਅਤ|ਨਕਸ਼ ਨੁਹਾਰ|ਮੁਹਾਂਦਰਾ|గుణము|ಹೆಚ್ಚಳ|ความต้องการทางธุรกิจ|ความสามารถ|โครงหลัก|기능|フィーチャ|功能|機能):(?:[^:\r\n]+(?:\r?\n|\r|$))*/,
                lookbehind: true,
                inside: {
                    important: {
                        pattern: /(:)[^\r\n]+/,
                        lookbehind: true
                    },
                    keyword: /[^:\r\n]+:/
                }
            },
            scenario: {
                pattern: /(^[ \t]*)(?:Abstract Scenario|Abstrakt Scenario|Achtergrond|Aer|Ær|Agtergrond|All y'all|Antecedentes|Antecedents|Atburðarás|Atburðarásir|Awww, look mate|B4|Background|Baggrund|Bakgrund|Bakgrunn|Bakgrunnur|Beispiele|Beispiller|Bối cảnh|Cefndir|Cenario|Cenário|Cenario de Fundo|Cenário de Fundo|Cenarios|Cenários|Contesto|Context|Contexte|Contexto|Conto|Contoh|Contone|Dæmi|Dasar|Dead men tell no tales|Delineacao do Cenario|Delineação do Cenário|Dis is what went down|Dữ liệu|Dyagram Senaryo|Dyagram senaryo|Egzanp|Ejemplos|Eksempler|Ekzemploj|Enghreifftiau|Esbozo do escenario|Escenari|Escenario|Esempi|Esquema de l'escenari|Esquema del escenario|Esquema do Cenario|Esquema do Cenário|EXAMPLZ|Examples|Exempel|Exemple|Exemples|Exemplos|First off|Fono|Forgatókönyv|Forgatókönyv vázlat|Fundo|Geçmiş|Grundlage|Hannergrond|ghantoH|Háttér|Heave to|Istorik|Juhtumid|Keadaan|Khung kịch bản|Khung tình huống|Kịch bản|Koncept|Konsep skenario|Kontèks|Kontekst|Kontekstas|Konteksts|Kontext|Konturo de la scenaro|Latar Belakang|lut chovnatlh|lut|lutmey|Lýsing Atburðarásar|Lýsing Dæma|MISHUN SRSLY|MISHUN|Menggariskan Senario|mo'|Náčrt Scenára|Náčrt Scénáře|Náčrt Scenáru|Oris scenarija|Örnekler|Osnova|Osnova Scenára|Osnova scénáře|Osnutek|Ozadje|Paraugs|Pavyzdžiai|Példák|Piemēri|Plan du scénario|Plan du Scénario|Plan Senaryo|Plan senaryo|Plang vum Szenario|Pozadí|Pozadie|Pozadina|Príklady|Příklady|Primer|Primeri|Primjeri|Przykłady|Raamstsenaarium|Reckon it's like|Rerefons|Scenár|Scénář|Scenarie|Scenarij|Scenarijai|Scenarijaus šablonas|Scenariji|Scenārijs|Scenārijs pēc parauga|Scenarijus|Scenario|Scénario|Scenario Amlinellol|Scenario Outline|Scenario Template|Scenariomal|Scenariomall|Scenarios|Scenariu|Scenariusz|Scenaro|Schema dello scenario|Se ðe|Se the|Se þe|Senario|Senaryo Deskripsyon|Senaryo deskripsyon|Senaryo|Senaryo taslağı|Shiver me timbers|Situācija|Situai|Situasie Uiteensetting|Situasie|Skenario konsep|Skenario|Skica|Structura scenariu|Structură scenariu|Struktura scenarija|Stsenaarium|Swa hwaer swa|Swa|Swa hwær swa|Szablon scenariusza|Szenario|Szenariogrundriss|Tapaukset|Tapaus|Tapausaihio|Taust|Tausta|Template Keadaan|Template Senario|Template Situai|The thing of it is|Tình huống|Variantai|Voorbeelde|Voorbeelden|Wharrimean is|Yo-ho-ho|You'll wanna|Założenia|Παραδείγματα|Περιγραφή Σεναρίου|Σενάρια|Σενάριο|Υπόβαθρο|Кереш|Контекст|Концепт|Мисаллар|Мисоллар|Основа|Передумова|Позадина|Предистория|Предыстория|Приклади|Пример|Примери|Примеры|Рамка на сценарий|Скица|Структура сценарија|Структура сценария|Структура сценарію|Сценарий|Сценарий структураси|Сценарийның төзелеше|Сценарији|Сценарио|Сценарій|Тарих|Үрнәкләр|דוגמאות|רקע|תבנית תרחיש|תרחיש|الخلفية|الگوی سناریو|امثلة|پس منظر|زمینه|سناریو|سيناريو|سيناريو مخطط|مثالیں|منظر نامے کا خاکہ|منظرنامہ|نمونه ها|उदाहरण|परिदृश्य|परिदृश्य रूपरेखा|पृष्ठभूमि|ਉਦਾਹਰਨਾਂ|ਪਟਕਥਾ|ਪਟਕਥਾ ਢਾਂਚਾ|ਪਟਕਥਾ ਰੂਪ ਰੇਖਾ|ਪਿਛੋਕੜ|ఉదాహరణలు|కథనం|నేపథ్యం|సన్నివేశం|ಉದಾಹರಣೆಗಳು|ಕಥಾಸಾರಾಂಶ|ವಿವರಣೆ|ಹಿನ್ನೆಲೆ|โครงสร้างของเหตุการณ์|ชุดของตัวอย่าง|ชุดของเหตุการณ์|แนวคิด|สรุปเหตุการณ์|เหตุการณ์|배경|시나리오|시나리오 개요|예|サンプル|シナリオ|シナリオアウトライン|シナリオテンプレ|シナリオテンプレート|テンプレ|例|例子|剧本|剧本大纲|劇本|劇本大綱|场景|场景大纲|場景|場景大綱|背景):[^:\r\n]*/m,
                lookbehind: true,
                inside: {
                    important: {
                        pattern: /(:)[^\r\n]*/,
                        lookbehind: true
                    },
                    keyword: /[^:\r\n]+:/
                }
            },
            'table-body': {
                // Look-behind is used to skip the table head, which has the same format as any table row
                pattern: RegExp('(' + tableRow + ')(?:' + tableRow + ')+'),
                lookbehind: true,
                inside: {
                    outline: {
                        pattern: /<[^>]+>/,
                        alias: 'variable'
                    },
                    td: {
                        pattern: /\s*[^\s|][^|]*/,
                        alias: 'string'
                    },
                    punctuation: /\|/
                }
            },
            'table-head': {
                pattern: RegExp(tableRow),
                inside: {
                    th: {
                        pattern: /\s*[^\s|][^|]*/,
                        alias: 'variable'
                    },
                    punctuation: /\|/
                }
            },
            atrule: {
                pattern: /(^[ \t]+)(?:'a|'ach|'ej|7|a|A také|A taktiež|A tiež|A zároveň|Aber|Ac|Adott|Akkor|Ak|Aleshores|Ale|Ali|Allora|Alors|Als|Ama|Amennyiben|Amikor|Ampak|an|AN|Ananging|And y'all|And|Angenommen|Anrhegedig a|An|Apabila|Atès|Atesa|Atunci|Avast!|Aye|A|awer|Bagi|Banjur|Bet|Biết|Blimey!|Buh|But at the end of the day I reckon|But y'all|But|BUT|Cal|Când|Cand|Cando|Ce|Cuando|Če|Ða ðe|Ða|Dadas|Dada|Dados|Dado|DaH ghu' bejlu'|dann|Dann|Dano|Dan|Dar|Dat fiind|Data|Date fiind|Date|Dati fiind|Dati|Daţi fiind|Dați fiind|DEN|Dato|De|Den youse gotta|Dengan|Diberi|Diyelim ki|Donada|Donat|Donitaĵo|Do|Dun|Duota|Ðurh|Eeldades|Ef|Eğer ki|Entao|Então|Entón|E|En|Entonces|Epi|És|Etant donnée|Etant donné|Et|Étant données|Étant donnée|Étant donné|Etant données|Etant donnés|Étant donnés|Fakat|Gangway!|Gdy|Gegeben seien|Gegeben sei|Gegeven|Gegewe|ghu' noblu'|Gitt|Given y'all|Given|Givet|Givun|Ha|Cho|I CAN HAZ|In|Ir|It's just unbelievable|I|Ja|Jeśli|Jeżeli|Kad|Kada|Kadar|Kai|Kaj|Když|Keď|Kemudian|Ketika|Khi|Kiedy|Ko|Kuid|Kui|Kun|Lan|latlh|Le sa a|Let go and haul|Le|Lè sa a|Lè|Logo|Lorsqu'<|Lorsque|mä|Maar|Mais|Mając|Ma|Majd|Maka|Manawa|Mas|Men|Menawa|Mutta|Nalika|Nalikaning|Nanging|Når|När|Nato|Nhưng|Niin|Njuk|O zaman|Och|Og|Oletetaan|Ond|Onda|Oraz|Pak|Pero|Però|Podano|Pokiaľ|Pokud|Potem|Potom|Privzeto|Pryd|Quan|Quand|Quando|qaSDI'|Så|Sed|Se|Siis|Sipoze ke|Sipoze Ke|Sipoze|Si|Şi|Și|Soit|Stel|Tada|Tad|Takrat|Tak|Tapi|Ter|Tetapi|Tha the|Tha|Then y'all|Then|Thì|Thurh|Toda|Too right|Un|Und|ugeholl|Và|vaj|Vendar|Ve|wann|Wanneer|WEN|Wenn|When y'all|When|Wtedy|Wun|Y'know|Yeah nah|Yna|Youse know like when|Youse know when youse got|Y|Za predpokladu|Za předpokladu|Zadan|Zadani|Zadano|Zadate|Zadato|Zakładając|Zaradi|Zatati|Þa þe|Þa|Þá|Þegar|Þurh|Αλλά|Δεδομένου|Και|Όταν|Τότε|А також|Агар|Але|Али|Аммо|А|Әгәр|Әйтик|Әмма|Бирок|Ва|Вә|Дадено|Дано|Допустим|Если|Задате|Задати|Задато|И|І|К тому же|Када|Кад|Когато|Когда|Коли|Ләкин|Лекин|Нәтиҗәдә|Нехай|Но|Онда|Припустимо, що|Припустимо|Пусть|Также|Та|Тогда|Тоді|То|Унда|Һәм|Якщо|אבל|אזי|אז|בהינתן|וגם|כאשר|آنگاه|اذاً|اگر|اما|اور|با فرض|بالفرض|بفرض|پھر|تب|ثم|جب|عندما|فرض کیا|لكن|لیکن|متى|هنگامی|و|अगर|और|कदा|किन्तु|चूंकि|जब|तथा|तदा|तब|परन्तु|पर|यदि|ਅਤੇ|ਜਦੋਂ|ਜਿਵੇਂ ਕਿ|ਜੇਕਰ|ਤਦ|ਪਰ|అప్పుడు|ఈ పరిస్థితిలో|కాని|చెప్పబడినది|మరియు|ಆದರೆ|ನಂತರ|ನೀಡಿದ|ಮತ್ತು|ಸ್ಥಿತಿಯನ್ನು|กำหนดให้|ดังนั้น|แต่|เมื่อ|และ|그러면<|그리고<|단<|만약<|만일<|먼저<|조건<|하지만<|かつ<|しかし<|ただし<|ならば<|もし<|並且<|但し<|但是<|假如<|假定<|假設<|假设<|前提<|同时<|同時<|并且<|当<|當<|而且<|那么<|那麼<)(?=[ \t])/m,
                lookbehind: true
            },
            string: {
                pattern: /"(?:\\.|[^"\\\r\n])*"|'(?:\\.|[^'\\\r\n])*'/,
                inside: {
                    outline: {
                        pattern: /<[^>]+>/,
                        alias: 'variable'
                    }
                }
            },
            outline: {
                pattern: /<[^>]+>/,
                alias: 'variable'
            }
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $b8a98b0ff64a5cd4$export$2e2bcd8739ae039.displayName = 'git';
$b8a98b0ff64a5cd4$export$2e2bcd8739ae039.aliases = [];
function $b8a98b0ff64a5cd4$export$2e2bcd8739ae039(Prism) {
    Prism.languages.git = {
        /*
     * A simple one line comment like in a git status command
     * For instance:
     * $ git status
     * # On branch infinite-scroll
     * # Your branch and 'origin/sharedBranches/frontendTeam/infinite-scroll' have diverged,
     * # and have 1 and 2 different commits each, respectively.
     * nothing to commit (working directory clean)
     */ comment: /^#.*/m,
        /*
     * Regexp to match the changed lines in a git diff output. Check the example below.
     */ deleted: /^[-–].*/m,
        inserted: /^\+.*/m,
        /*
     * a string (double and simple quote)
     */ string: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        /*
     * a git command. It starts with a random prompt finishing by a $, then "git" then some other parameters
     * For instance:
     * $ git add file.txt
     */ command: {
            pattern: /^.*\$ git .*$/m,
            inside: {
                /*
         * A git command can contain a parameter starting by a single or a double dash followed by a string
         * For instance:
         * $ git diff --cached
         * $ git log -p
         */ parameter: /\s--?\w+/
            }
        },
        /*
     * Coordinates displayed in a git diff command
     * For instance:
     * $ git diff
     * diff --git file.txt file.txt
     * index 6214953..1d54a52 100644
     * --- file.txt
     * +++ file.txt
     * @@ -1 +1,2 @@
     * -Here's my tetx file
     * +Here's my text file
     * +And this is the second line
     */ coord: /^@@.*@@$/m,
        /*
     * Match a "commit [SHA1]" line in a git log output.
     * For instance:
     * $ git log
     * commit a11a14ef7e26f2ca62d4b35eac455ce636d0dc09
     * Author: lgiraudel
     * Date:   Mon Feb 17 11:18:34 2014 +0100
     *
     *     Add of a new line
     */ 'commit-sha1': /^commit \w{40}$/m
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$a9f5bac9ba5085d8$export$2e2bcd8739ae039.displayName = 'glsl';
$a9f5bac9ba5085d8$export$2e2bcd8739ae039.aliases = [];
function $a9f5bac9ba5085d8$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f4e156ae6ed8d0a0$export$2e2bcd8739ae039));
    Prism.languages.glsl = Prism.languages.extend('c', {
        keyword: /\b(?:active|asm|atomic_uint|attribute|[ibdu]?vec[234]|bool|break|buffer|case|cast|centroid|class|coherent|common|const|continue|d?mat[234](?:x[234])?|default|discard|do|double|else|enum|extern|external|false|filter|fixed|flat|float|for|fvec[234]|goto|half|highp|hvec[234]|[iu]?sampler2DMS(?:Array)?|[iu]?sampler2DRect|[iu]?samplerBuffer|[iu]?samplerCube|[iu]?samplerCubeArray|[iu]?sampler[123]D|[iu]?sampler[12]DArray|[iu]?image2DMS(?:Array)?|[iu]?image2DRect|[iu]?imageBuffer|[iu]?imageCube|[iu]?imageCubeArray|[iu]?image[123]D|[iu]?image[12]DArray|if|in|inline|inout|input|int|interface|invariant|layout|long|lowp|mediump|namespace|noinline|noperspective|out|output|partition|patch|precise|precision|public|readonly|resource|restrict|return|sample|sampler[12]DArrayShadow|sampler[12]DShadow|sampler2DRectShadow|sampler3DRect|samplerCubeArrayShadow|samplerCubeShadow|shared|short|sizeof|smooth|static|struct|subroutine|superp|switch|template|this|true|typedef|uint|uniform|union|unsigned|using|varying|void|volatile|while|writeonly)\b/
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $5bfce00dfe9edf4d$export$2e2bcd8739ae039.displayName = 'gn';
$5bfce00dfe9edf4d$export$2e2bcd8739ae039.aliases = [
    'gni'
];
function $5bfce00dfe9edf4d$export$2e2bcd8739ae039(Prism) {
    // https://gn.googlesource.com/gn/+/refs/heads/main/docs/reference.md#grammar
    Prism.languages.gn = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        'string-literal': {
            pattern: /(^|[^\\"])"(?:[^\r\n"\\]|\\.)*"/,
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\{[\s\S]*?\}|[a-zA-Z_]\w*|0x[a-fA-F0-9]{2})/,
                    lookbehind: true,
                    inside: {
                        number: /^\$0x[\s\S]{2}$/,
                        variable: /^\$\w+$/,
                        'interpolation-punctuation': {
                            pattern: /^\$\{|\}$/,
                            alias: 'punctuation'
                        },
                        expression: {
                            pattern: /[\s\S]+/,
                            inside: null // see below
                        }
                    }
                },
                string: /[\s\S]+/
            }
        },
        keyword: /\b(?:else|if)\b/,
        boolean: /\b(?:false|true)\b/,
        'builtin-function': {
            // a few functions get special highlighting to improve readability
            pattern: /\b(?:assert|defined|foreach|import|pool|print|template|tool|toolchain)(?=\s*\()/i,
            alias: 'keyword'
        },
        function: /\b[a-z_]\w*(?=\s*\()/i,
        constant: /\b(?:current_cpu|current_os|current_toolchain|default_toolchain|host_cpu|host_os|root_build_dir|root_gen_dir|root_out_dir|target_cpu|target_gen_dir|target_os|target_out_dir)\b/,
        number: /-?\b\d+\b/,
        operator: /[-+!=<>]=?|&&|\|\|/,
        punctuation: /[(){}[\],.]/
    };
    Prism.languages.gn['string-literal'].inside['interpolation'].inside['expression'].inside = Prism.languages.gn;
    Prism.languages.gni = Prism.languages.gn;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $47dfe45f952c98c2$export$2e2bcd8739ae039.displayName = 'linker-script';
$47dfe45f952c98c2$export$2e2bcd8739ae039.aliases = [
    'ld'
];
function $47dfe45f952c98c2$export$2e2bcd8739ae039(Prism) {
    Prism.languages['linker-script'] = {
        comment: {
            pattern: /(^|\s)\/\*[\s\S]*?(?:$|\*\/)/,
            lookbehind: true,
            greedy: true
        },
        identifier: {
            pattern: /"[^"\r\n]*"/,
            greedy: true
        },
        'location-counter': {
            pattern: /\B\.\B/,
            alias: 'important'
        },
        section: {
            pattern: /(^|[^\w*])\.\w+\b/,
            lookbehind: true,
            alias: 'keyword'
        },
        function: /\b[A-Z][A-Z_]*(?=\s*\()/,
        number: /\b(?:0[xX][a-fA-F0-9]+|\d+)[KM]?\b/,
        operator: />>=?|<<=?|->|\+\+|--|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?/,
        punctuation: /[(){},;]/
    };
    Prism.languages['ld'] = Prism.languages['linker-script'];
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $9f945d890adcf850$export$2e2bcd8739ae039.displayName = 'go-module';
$9f945d890adcf850$export$2e2bcd8739ae039.aliases = [
    'go-mod'
];
function $9f945d890adcf850$export$2e2bcd8739ae039(Prism) {
    // https://go.dev/ref/mod#go-mod-file-module
    Prism.languages['go-mod'] = Prism.languages['go-module'] = {
        comment: {
            pattern: /\/\/.*/,
            greedy: true
        },
        version: {
            pattern: /(^|[\s()[\],])v\d+\.\d+\.\d+(?:[+-][-+.\w]*)?(?![^\s()[\],])/,
            lookbehind: true,
            alias: 'number'
        },
        'go-version': {
            pattern: /((?:^|\s)go\s+)\d+(?:\.\d+){1,2}/,
            lookbehind: true,
            alias: 'number'
        },
        keyword: {
            pattern: /^([ \t]*)(?:exclude|go|module|replace|require|retract)\b/m,
            lookbehind: true
        },
        operator: /=>/,
        punctuation: /[()[\],]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$cd8c18afbde31359$export$2e2bcd8739ae039.displayName = 'gradle';
$cd8c18afbde31359$export$2e2bcd8739ae039.aliases = [];
function $cd8c18afbde31359$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    (function(Prism) {
        var interpolation = {
            pattern: /((?:^|[^\\$])(?:\\{2})*)\$(?:\w+|\{[^{}]*\})/,
            lookbehind: true,
            inside: {
                'interpolation-punctuation': {
                    pattern: /^\$\{?|\}$/,
                    alias: 'punctuation'
                },
                expression: {
                    pattern: /[\s\S]+/,
                    inside: null
                }
            }
        };
        Prism.languages.gradle = Prism.languages.extend('clike', {
            string: {
                pattern: /'''(?:[^\\]|\\[\s\S])*?'''|'(?:\\.|[^\\'\r\n])*'/,
                greedy: true
            },
            keyword: /\b(?:apply|def|dependencies|else|if|implementation|import|plugin|plugins|project|repositories|repository|sourceSets|tasks|val)\b/,
            number: /\b(?:0b[01_]+|0x[\da-f_]+(?:\.[\da-f_p\-]+)?|[\d_]+(?:\.[\d_]+)?(?:e[+-]?\d+)?)[glidf]?\b/i,
            operator: {
                pattern: /(^|[^.])(?:~|==?~?|\?[.:]?|\*(?:[.=]|\*=?)?|\.[@&]|\.\.<|\.\.(?!\.)|-[-=>]?|\+[+=]?|!=?|<(?:<=?|=>?)?|>(?:>>?=?|=)?|&[&=]?|\|[|=]?|\/=?|\^=?|%=?)/,
                lookbehind: true
            },
            punctuation: /\.+|[{}[\];(),:$]/
        });
        Prism.languages.insertBefore('gradle', 'string', {
            shebang: {
                pattern: /#!.+/,
                alias: 'comment',
                greedy: true
            },
            'interpolation-string': {
                pattern: /"""(?:[^\\]|\\[\s\S])*?"""|(["/])(?:\\.|(?!\1)[^\\\r\n])*\1|\$\/(?:[^/$]|\$(?:[/$]|(?![/$]))|\/(?!\$))*\/\$/,
                greedy: true,
                inside: {
                    interpolation: interpolation,
                    string: /[\s\S]+/
                }
            }
        });
        Prism.languages.insertBefore('gradle', 'punctuation', {
            'spock-block': /\b(?:and|cleanup|expect|given|setup|then|when|where):/
        });
        Prism.languages.insertBefore('gradle', 'function', {
            annotation: {
                pattern: /(^|[^.])@\w+/,
                lookbehind: true,
                alias: 'punctuation'
            }
        });
        interpolation.inside.expression.inside = Prism.languages.gradle;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $c77c0e4272178579$export$2e2bcd8739ae039.displayName = 'graphql';
$c77c0e4272178579$export$2e2bcd8739ae039.aliases = [];
function $c77c0e4272178579$export$2e2bcd8739ae039(Prism) {
    Prism.languages.graphql = {
        comment: /#.*/,
        description: {
            pattern: /(?:"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*")(?=\s*[a-z_])/i,
            greedy: true,
            alias: 'string',
            inside: {
                'language-markdown': {
                    pattern: /(^"(?:"")?)(?!\1)[\s\S]+(?=\1$)/,
                    lookbehind: true,
                    inside: Prism.languages.markdown
                }
            }
        },
        string: {
            pattern: /"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*"/,
            greedy: true
        },
        number: /(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
        boolean: /\b(?:false|true)\b/,
        variable: /\$[a-z_]\w*/i,
        directive: {
            pattern: /@[a-z_]\w*/i,
            alias: 'function'
        },
        'attr-name': {
            pattern: /\b[a-z_]\w*(?=\s*(?:\((?:[^()"]|"(?:\\.|[^\\"\r\n])*")*\))?:)/i,
            greedy: true
        },
        'atom-input': {
            pattern: /\b[A-Z]\w*Input\b/,
            alias: 'class-name'
        },
        scalar: /\b(?:Boolean|Float|ID|Int|String)\b/,
        constant: /\b[A-Z][A-Z_\d]*\b/,
        'class-name': {
            pattern: /(\b(?:enum|implements|interface|on|scalar|type|union)\s+|&\s*|:\s*|\[)[A-Z_]\w*/,
            lookbehind: true
        },
        fragment: {
            pattern: /(\bfragment\s+|\.{3}\s*(?!on\b))[a-zA-Z_]\w*/,
            lookbehind: true,
            alias: 'function'
        },
        'definition-mutation': {
            pattern: /(\bmutation\s+)[a-zA-Z_]\w*/,
            lookbehind: true,
            alias: 'function'
        },
        'definition-query': {
            pattern: /(\bquery\s+)[a-zA-Z_]\w*/,
            lookbehind: true,
            alias: 'function'
        },
        keyword: /\b(?:directive|enum|extend|fragment|implements|input|interface|mutation|on|query|repeatable|scalar|schema|subscription|type|union)\b/,
        operator: /[!=|&]|\.{3}/,
        'property-query': /\w+(?=\s*\()/,
        object: /\w+(?=\s*\{)/,
        punctuation: /[!(){}\[\]:=,]/,
        property: /\w+/
    };
    Prism.hooks.add('after-tokenize', function afterTokenizeGraphql(env) {
        if (env.language !== 'graphql') return;
        /**
     * get the graphql token stream that we want to customize
     *
     * @typedef {InstanceType<import("./prism-core")["Token"]>} Token
     * @type {Token[]}
     */ var validTokens = env.tokens.filter(function(token) {
            return typeof token !== 'string' && token.type !== 'comment' && token.type !== 'scalar';
        });
        var currentIndex = 0;
        /**
     * Returns whether the token relative to the current index has the given type.
     *
     * @param {number} offset
     * @returns {Token | undefined}
     */ function getToken(offset) {
            return validTokens[currentIndex + offset];
        }
        /**
     * Returns whether the token relative to the current index has the given type.
     *
     * @param {readonly string[]} types
     * @param {number} [offset=0]
     * @returns {boolean}
     */ function isTokenType(types, offset) {
            offset = offset || 0;
            for(var i = 0; i < types.length; i++){
                var token = getToken(i + offset);
                if (!token || token.type !== types[i]) return false;
            }
            return true;
        }
        /**
     * Returns the index of the closing bracket to an opening bracket.
     *
     * It is assumed that `token[currentIndex - 1]` is an opening bracket.
     *
     * If no closing bracket could be found, `-1` will be returned.
     *
     * @param {RegExp} open
     * @param {RegExp} close
     * @returns {number}
     */ function findClosingBracket(open, close) {
            var stackHeight = 1;
            for(var i = currentIndex; i < validTokens.length; i++){
                var token = validTokens[i];
                var content = token.content;
                if (token.type === 'punctuation' && typeof content === 'string') {
                    if (open.test(content)) stackHeight++;
                    else if (close.test(content)) {
                        stackHeight--;
                        if (stackHeight === 0) return i;
                    }
                }
            }
            return -1;
        }
        /**
     * Adds an alias to the given token.
     *
     * @param {Token} token
     * @param {string} alias
     * @returns {void}
     */ function addAlias(token, alias) {
            var aliases = token.alias;
            if (!aliases) token.alias = aliases = [];
            else if (!Array.isArray(aliases)) token.alias = aliases = [
                aliases
            ];
            aliases.push(alias);
        }
        for(; currentIndex < validTokens.length;){
            var startToken = validTokens[currentIndex++];
            // add special aliases for mutation tokens
            if (startToken.type === 'keyword' && startToken.content === 'mutation') {
                // any array of the names of all input variables (if any)
                var inputVariables = [];
                if (isTokenType([
                    'definition-mutation',
                    'punctuation'
                ]) && getToken(1).content === '(') {
                    // definition
                    currentIndex += 2 // skip 'definition-mutation' and 'punctuation'
                    ;
                    var definitionEnd = findClosingBracket(/^\($/, /^\)$/);
                    if (definitionEnd === -1) continue;
                    // find all input variables
                    for(; currentIndex < definitionEnd; currentIndex++){
                        var t = getToken(0);
                        if (t.type === 'variable') {
                            addAlias(t, 'variable-input');
                            inputVariables.push(t.content);
                        }
                    }
                    currentIndex = definitionEnd + 1;
                }
                if (isTokenType([
                    'punctuation',
                    'property-query'
                ]) && getToken(0).content === '{') {
                    currentIndex++ // skip opening bracket
                    ;
                    addAlias(getToken(0), 'property-mutation');
                    if (inputVariables.length > 0) {
                        var mutationEnd = findClosingBracket(/^\{$/, /^\}$/);
                        if (mutationEnd === -1) continue;
                        // give references to input variables a special alias
                        for(var i = currentIndex; i < mutationEnd; i++){
                            var varToken = validTokens[i];
                            if (varToken.type === 'variable' && inputVariables.indexOf(varToken.content) >= 0) addAlias(varToken, 'variable-input');
                        }
                    }
                }
            }
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$bb09ab25dfcbb114$export$2e2bcd8739ae039.displayName = 'groovy';
$bb09ab25dfcbb114$export$2e2bcd8739ae039.aliases = [];
function $bb09ab25dfcbb114$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    (function(Prism) {
        var interpolation = {
            pattern: /((?:^|[^\\$])(?:\\{2})*)\$(?:\w+|\{[^{}]*\})/,
            lookbehind: true,
            inside: {
                'interpolation-punctuation': {
                    pattern: /^\$\{?|\}$/,
                    alias: 'punctuation'
                },
                expression: {
                    pattern: /[\s\S]+/,
                    inside: null // see below
                }
            }
        };
        Prism.languages.groovy = Prism.languages.extend('clike', {
            string: {
                // https://groovy-lang.org/syntax.html#_dollar_slashy_string
                pattern: /'''(?:[^\\]|\\[\s\S])*?'''|'(?:\\.|[^\\'\r\n])*'/,
                greedy: true
            },
            keyword: /\b(?:abstract|as|assert|boolean|break|byte|case|catch|char|class|const|continue|def|default|do|double|else|enum|extends|final|finally|float|for|goto|if|implements|import|in|instanceof|int|interface|long|native|new|package|private|protected|public|return|short|static|strictfp|super|switch|synchronized|this|throw|throws|trait|transient|try|void|volatile|while)\b/,
            number: /\b(?:0b[01_]+|0x[\da-f_]+(?:\.[\da-f_p\-]+)?|[\d_]+(?:\.[\d_]+)?(?:e[+-]?\d+)?)[glidf]?\b/i,
            operator: {
                pattern: /(^|[^.])(?:~|==?~?|\?[.:]?|\*(?:[.=]|\*=?)?|\.[@&]|\.\.<|\.\.(?!\.)|-[-=>]?|\+[+=]?|!=?|<(?:<=?|=>?)?|>(?:>>?=?|=)?|&[&=]?|\|[|=]?|\/=?|\^=?|%=?)/,
                lookbehind: true
            },
            punctuation: /\.+|[{}[\];(),:$]/
        });
        Prism.languages.insertBefore('groovy', 'string', {
            shebang: {
                pattern: /#!.+/,
                alias: 'comment',
                greedy: true
            },
            'interpolation-string': {
                // TODO: Slash strings (e.g. /foo/) can contain line breaks but this will cause a lot of trouble with
                // simple division (see JS regex), so find a fix maybe?
                pattern: /"""(?:[^\\]|\\[\s\S])*?"""|(["/])(?:\\.|(?!\1)[^\\\r\n])*\1|\$\/(?:[^/$]|\$(?:[/$]|(?![/$]))|\/(?!\$))*\/\$/,
                greedy: true,
                inside: {
                    interpolation: interpolation,
                    string: /[\s\S]+/
                }
            }
        });
        Prism.languages.insertBefore('groovy', 'punctuation', {
            'spock-block': /\b(?:and|cleanup|expect|given|setup|then|when|where):/
        });
        Prism.languages.insertBefore('groovy', 'function', {
            annotation: {
                pattern: /(^|[^.])@\w+/,
                lookbehind: true,
                alias: 'punctuation'
            }
        });
        interpolation.inside.expression.inside = Prism.languages.groovy;
    })(Prism);
}




// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$9c25dab359558e3e$export$2e2bcd8739ae039.displayName = 'textile';
$9c25dab359558e3e$export$2e2bcd8739ae039.aliases = [];
function $9c25dab359558e3e$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    (function(Prism) {
        // We don't allow for pipes inside parentheses
        // to not break table pattern |(. foo |). bar |
        var modifierRegex = /\([^|()\n]+\)|\[[^\]\n]+\]|\{[^}\n]+\}/.source;
        // Opening and closing parentheses which are not a modifier
        // This pattern is necessary to prevent exponential backtracking
        var parenthesesRegex = /\)|\((?![^|()\n]+\))/.source;
        /**
     * @param {string} source
     * @param {string} [flags]
     */ function withModifier(source, flags) {
            return RegExp(source.replace(/<MOD>/g, function() {
                return '(?:' + modifierRegex + ')';
            }).replace(/<PAR>/g, function() {
                return '(?:' + parenthesesRegex + ')';
            }), flags || '');
        }
        var modifierTokens = {
            css: {
                pattern: /\{[^{}]+\}/,
                inside: {
                    rest: Prism.languages.css
                }
            },
            'class-id': {
                pattern: /(\()[^()]+(?=\))/,
                lookbehind: true,
                alias: 'attr-value'
            },
            lang: {
                pattern: /(\[)[^\[\]]+(?=\])/,
                lookbehind: true,
                alias: 'attr-value'
            },
            // Anything else is punctuation (the first pattern is for row/col spans inside tables)
            punctuation: /[\\\/]\d+|\S/
        };
        var textile = Prism.languages.textile = Prism.languages.extend('markup', {
            phrase: {
                pattern: /(^|\r|\n)\S[\s\S]*?(?=$|\r?\n\r?\n|\r\r)/,
                lookbehind: true,
                inside: {
                    // h1. Header 1
                    'block-tag': {
                        pattern: withModifier(/^[a-z]\w*(?:<MOD>|<PAR>|[<>=])*\./.source),
                        inside: {
                            modifier: {
                                pattern: withModifier(/(^[a-z]\w*)(?:<MOD>|<PAR>|[<>=])+(?=\.)/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            tag: /^[a-z]\w*/,
                            punctuation: /\.$/
                        }
                    },
                    // # List item
                    // * List item
                    list: {
                        pattern: withModifier(/^[*#]+<MOD>*\s+\S.*/.source, 'm'),
                        inside: {
                            modifier: {
                                pattern: withModifier(/(^[*#]+)<MOD>+/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            punctuation: /^[*#]+/
                        }
                    },
                    // | cell | cell | cell |
                    table: {
                        // Modifiers can be applied to the row: {color:red}.|1|2|3|
                        // or the cell: |{color:red}.1|2|3|
                        pattern: withModifier(/^(?:(?:<MOD>|<PAR>|[<>=^~])+\.\s*)?(?:\|(?:(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+\.|(?!(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+\.))[^|]*)+\|/.source, 'm'),
                        inside: {
                            modifier: {
                                // Modifiers for rows after the first one are
                                // preceded by a pipe and a line feed
                                pattern: withModifier(/(^|\|(?:\r?\n|\r)?)(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+(?=\.)/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            punctuation: /\||^\./
                        }
                    },
                    inline: {
                        // eslint-disable-next-line regexp/no-super-linear-backtracking
                        pattern: withModifier(/(^|[^a-zA-Z\d])(\*\*|__|\?\?|[*_%@+\-^~])<MOD>*.+?\2(?![a-zA-Z\d])/.source),
                        lookbehind: true,
                        inside: {
                            // Note: superscripts and subscripts are not handled specifically
                            // *bold*, **bold**
                            bold: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^(\*\*?)<MOD>*).+?(?=\2)/.source),
                                lookbehind: true
                            },
                            // _italic_, __italic__
                            italic: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^(__?)<MOD>*).+?(?=\2)/.source),
                                lookbehind: true
                            },
                            // ??cite??
                            cite: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^\?\?<MOD>*).+?(?=\?\?)/.source),
                                lookbehind: true,
                                alias: 'string'
                            },
                            // @code@
                            code: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^@<MOD>*).+?(?=@)/.source),
                                lookbehind: true,
                                alias: 'keyword'
                            },
                            // +inserted+
                            inserted: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^\+<MOD>*).+?(?=\+)/.source),
                                lookbehind: true
                            },
                            // -deleted-
                            deleted: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^-<MOD>*).+?(?=-)/.source),
                                lookbehind: true
                            },
                            // %span%
                            span: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^%<MOD>*).+?(?=%)/.source),
                                lookbehind: true
                            },
                            modifier: {
                                pattern: withModifier(/(^\*\*|__|\?\?|[*_%@+\-^~])<MOD>+/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            punctuation: /[*_%?@+\-^~]+/
                        }
                    },
                    // [alias]http://example.com
                    'link-ref': {
                        pattern: /^\[[^\]]+\]\S+$/m,
                        inside: {
                            string: {
                                pattern: /(^\[)[^\]]+(?=\])/,
                                lookbehind: true
                            },
                            url: {
                                pattern: /(^\])\S+$/,
                                lookbehind: true
                            },
                            punctuation: /[\[\]]/
                        }
                    },
                    // "text":http://example.com
                    // "text":link-ref
                    link: {
                        // eslint-disable-next-line regexp/no-super-linear-backtracking
                        pattern: withModifier(/"<MOD>*[^"]+":.+?(?=[^\w/]?(?:\s|$))/.source),
                        inside: {
                            text: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^"<MOD>*)[^"]+(?=")/.source),
                                lookbehind: true
                            },
                            modifier: {
                                pattern: withModifier(/(^")<MOD>+/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            url: {
                                pattern: /(:).+/,
                                lookbehind: true
                            },
                            punctuation: /[":]/
                        }
                    },
                    // !image.jpg!
                    // !image.jpg(Title)!:http://example.com
                    image: {
                        pattern: withModifier(/!(?:<MOD>|<PAR>|[<>=])*(?![<>=])[^!\s()]+(?:\([^)]+\))?!(?::.+?(?=[^\w/]?(?:\s|$)))?/.source),
                        inside: {
                            source: {
                                pattern: withModifier(/(^!(?:<MOD>|<PAR>|[<>=])*)(?![<>=])[^!\s()]+(?:\([^)]+\))?(?=!)/.source),
                                lookbehind: true,
                                alias: 'url'
                            },
                            modifier: {
                                pattern: withModifier(/(^!)(?:<MOD>|<PAR>|[<>=])+/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            url: {
                                pattern: /(:).+/,
                                lookbehind: true
                            },
                            punctuation: /[!:]/
                        }
                    },
                    // Footnote[1]
                    footnote: {
                        pattern: /\b\[\d+\]/,
                        alias: 'comment',
                        inside: {
                            punctuation: /\[|\]/
                        }
                    },
                    // CSS(Cascading Style Sheet)
                    acronym: {
                        pattern: /\b[A-Z\d]+\([^)]+\)/,
                        inside: {
                            comment: {
                                pattern: /(\()[^()]+(?=\))/,
                                lookbehind: true
                            },
                            punctuation: /[()]/
                        }
                    },
                    // Prism(C)
                    mark: {
                        pattern: /\b\((?:C|R|TM)\)/,
                        alias: 'comment',
                        inside: {
                            punctuation: /[()]/
                        }
                    }
                }
            }
        });
        var phraseInside = textile['phrase'].inside;
        var nestedPatterns = {
            inline: phraseInside['inline'],
            link: phraseInside['link'],
            image: phraseInside['image'],
            footnote: phraseInside['footnote'],
            acronym: phraseInside['acronym'],
            mark: phraseInside['mark']
        };
        // Only allow alpha-numeric HTML tags, not XML tags
        textile.tag.pattern = /<\/?(?!\d)[a-z0-9]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/i;
        // Allow some nesting
        var phraseInlineInside = phraseInside['inline'].inside;
        phraseInlineInside['bold'].inside = nestedPatterns;
        phraseInlineInside['italic'].inside = nestedPatterns;
        phraseInlineInside['inserted'].inside = nestedPatterns;
        phraseInlineInside['deleted'].inside = nestedPatterns;
        phraseInlineInside['span'].inside = nestedPatterns;
        // Allow some styles inside table cells
        var phraseTableInside = phraseInside['table'].inside;
        phraseTableInside['inline'] = nestedPatterns['inline'];
        phraseTableInside['link'] = nestedPatterns['link'];
        phraseTableInside['image'] = nestedPatterns['image'];
        phraseTableInside['footnote'] = nestedPatterns['footnote'];
        phraseTableInside['acronym'] = nestedPatterns['acronym'];
        phraseTableInside['mark'] = nestedPatterns['mark'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$2590b32a10d9ecc8$export$2e2bcd8739ae039.displayName = 'haml';
$2590b32a10d9ecc8$export$2e2bcd8739ae039.aliases = [];
function $2590b32a10d9ecc8$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $0814f5761e025965$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.haml = {
            // Multiline stuff should appear before the rest
            'multiline-comment': {
                pattern: /((?:^|\r?\n|\r)([\t ]*))(?:\/|-#).*(?:(?:\r?\n|\r)\2[\t ].+)*/,
                lookbehind: true,
                alias: 'comment'
            },
            'multiline-code': [
                {
                    pattern: /((?:^|\r?\n|\r)([\t ]*)(?:[~-]|[&!]?=)).*,[\t ]*(?:(?:\r?\n|\r)\2[\t ].*,[\t ]*)*(?:(?:\r?\n|\r)\2[\t ].+)/,
                    lookbehind: true,
                    inside: Prism.languages.ruby
                },
                {
                    pattern: /((?:^|\r?\n|\r)([\t ]*)(?:[~-]|[&!]?=)).*\|[\t ]*(?:(?:\r?\n|\r)\2[\t ].*\|[\t ]*)*/,
                    lookbehind: true,
                    inside: Prism.languages.ruby
                }
            ],
            // See at the end of the file for known filters
            filter: {
                pattern: /((?:^|\r?\n|\r)([\t ]*)):[\w-]+(?:(?:\r?\n|\r)(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/,
                lookbehind: true,
                inside: {
                    'filter-name': {
                        pattern: /^:[\w-]+/,
                        alias: 'symbol'
                    }
                }
            },
            markup: {
                pattern: /((?:^|\r?\n|\r)[\t ]*)<.+/,
                lookbehind: true,
                inside: Prism.languages.markup
            },
            doctype: {
                pattern: /((?:^|\r?\n|\r)[\t ]*)!!!(?: .+)?/,
                lookbehind: true
            },
            tag: {
                // Allows for one nested group of braces
                pattern: /((?:^|\r?\n|\r)[\t ]*)[%.#][\w\-#.]*[\w\-](?:\([^)]+\)|\{(?:\{[^}]+\}|[^{}])+\}|\[[^\]]+\])*[\/<>]*/,
                lookbehind: true,
                inside: {
                    attributes: [
                        {
                            // Lookbehind tries to prevent interpolations from breaking it all
                            // Allows for one nested group of braces
                            pattern: /(^|[^#])\{(?:\{[^}]+\}|[^{}])+\}/,
                            lookbehind: true,
                            inside: Prism.languages.ruby
                        },
                        {
                            pattern: /\([^)]+\)/,
                            inside: {
                                'attr-value': {
                                    pattern: /(=\s*)(?:"(?:\\.|[^\\"\r\n])*"|[^)\s]+)/,
                                    lookbehind: true
                                },
                                'attr-name': /[\w:-]+(?=\s*!?=|\s*[,)])/,
                                punctuation: /[=(),]/
                            }
                        },
                        {
                            pattern: /\[[^\]]+\]/,
                            inside: Prism.languages.ruby
                        }
                    ],
                    punctuation: /[<>]/
                }
            },
            code: {
                pattern: /((?:^|\r?\n|\r)[\t ]*(?:[~-]|[&!]?=)).+/,
                lookbehind: true,
                inside: Prism.languages.ruby
            },
            // Interpolations in plain text
            interpolation: {
                pattern: /#\{[^}]+\}/,
                inside: {
                    delimiter: {
                        pattern: /^#\{|\}$/,
                        alias: 'punctuation'
                    },
                    ruby: {
                        pattern: /[\s\S]+/,
                        inside: Prism.languages.ruby
                    }
                }
            },
            punctuation: {
                pattern: /((?:^|\r?\n|\r)[\t ]*)[~=\-&!]+/,
                lookbehind: true
            }
        };
        var filter_pattern = '((?:^|\\r?\\n|\\r)([\\t ]*)):{{filter_name}}(?:(?:\\r?\\n|\\r)(?:\\2[\\t ].+|\\s*?(?=\\r?\\n|\\r)))+';
        // Non exhaustive list of available filters and associated languages
        var filters = [
            'css',
            {
                filter: 'coffee',
                language: 'coffeescript'
            },
            'erb',
            'javascript',
            'less',
            'markdown',
            'ruby',
            'scss',
            'textile'
        ];
        var all_filters = {};
        for(var i = 0, l = filters.length; i < l; i++){
            var filter = filters[i];
            filter = typeof filter === 'string' ? {
                filter: filter,
                language: filter
            } : filter;
            if (Prism.languages[filter.language]) all_filters['filter-' + filter.filter] = {
                pattern: RegExp(filter_pattern.replace('{{filter_name}}', function() {
                    return filter.filter;
                })),
                lookbehind: true,
                inside: {
                    'filter-name': {
                        pattern: /^:[\w-]+/,
                        alias: 'symbol'
                    },
                    text: {
                        pattern: /[\s\S]+/,
                        alias: [
                            filter.language,
                            'language-' + filter.language
                        ],
                        inside: Prism.languages[filter.language]
                    }
                }
            };
        }
        Prism.languages.insertBefore('haml', 'filter', all_filters);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$abb136260c600497$export$2e2bcd8739ae039.displayName = 'handlebars';
$abb136260c600497$export$2e2bcd8739ae039.aliases = [
    'hbs',
    'mustache'
];
function $abb136260c600497$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.handlebars = {
            comment: /\{\{![\s\S]*?\}\}/,
            delimiter: {
                pattern: /^\{\{\{?|\}\}\}?$/,
                alias: 'punctuation'
            },
            string: /(["'])(?:\\.|(?!\1)[^\\\r\n])*\1/,
            number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][+-]?\d+)?/,
            boolean: /\b(?:false|true)\b/,
            block: {
                pattern: /^(\s*(?:~\s*)?)[#\/]\S+?(?=\s*(?:~\s*)?$|\s)/,
                lookbehind: true,
                alias: 'keyword'
            },
            brackets: {
                pattern: /\[[^\]]+\]/,
                inside: {
                    punctuation: /\[|\]/,
                    variable: /[\s\S]+/
                }
            },
            punctuation: /[!"#%&':()*+,.\/;<=>@\[\\\]^`{|}~]/,
            variable: /[^!"#%&'()*+,\/;<=>@\[\\\]^`{|}~\s]+/
        };
        Prism.hooks.add('before-tokenize', function(env) {
            var handlebarsPattern = /\{\{\{[\s\S]+?\}\}\}|\{\{[\s\S]+?\}\}/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'handlebars', handlebarsPattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'handlebars');
        });
        Prism.languages.hbs = Prism.languages.handlebars;
        Prism.languages.mustache = Prism.languages.handlebars;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $2ae70ee16ca48837$export$2e2bcd8739ae039.displayName = 'haskell';
$2ae70ee16ca48837$export$2e2bcd8739ae039.aliases = [
    'hs'
];
function $2ae70ee16ca48837$export$2e2bcd8739ae039(Prism) {
    Prism.languages.haskell = {
        comment: {
            pattern: /(^|[^-!#$%*+=?&@|~.:<>^\\\/])(?:--(?:(?=.)[^-!#$%*+=?&@|~.:<>^\\\/].*|$)|\{-[\s\S]*?-\})/m,
            lookbehind: true
        },
        char: {
            pattern: /'(?:[^\\']|\\(?:[abfnrtv\\"'&]|\^[A-Z@[\]^_]|ACK|BEL|BS|CAN|CR|DC1|DC2|DC3|DC4|DEL|DLE|EM|ENQ|EOT|ESC|ETB|ETX|FF|FS|GS|HT|LF|NAK|NUL|RS|SI|SO|SOH|SP|STX|SUB|SYN|US|VT|\d+|o[0-7]+|x[0-9a-fA-F]+))'/,
            alias: 'string'
        },
        string: {
            pattern: /"(?:[^\\"]|\\(?:\S|\s+\\))*"/,
            greedy: true
        },
        keyword: /\b(?:case|class|data|deriving|do|else|if|in|infixl|infixr|instance|let|module|newtype|of|primitive|then|type|where)\b/,
        'import-statement': {
            // The imported or hidden names are not included in this import
            // statement. This is because we want to highlight those exactly like
            // we do for the names in the program.
            pattern: /(^[\t ]*)import\s+(?:qualified\s+)?(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*(?:\s+as\s+(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*)?(?:\s+hiding\b)?/m,
            lookbehind: true,
            inside: {
                keyword: /\b(?:as|hiding|import|qualified)\b/,
                punctuation: /\./
            }
        },
        // These are builtin variables only. Constructors are highlighted later as a constant.
        builtin: /\b(?:abs|acos|acosh|all|and|any|appendFile|approxRational|asTypeOf|asin|asinh|atan|atan2|atanh|basicIORun|break|catch|ceiling|chr|compare|concat|concatMap|const|cos|cosh|curry|cycle|decodeFloat|denominator|digitToInt|div|divMod|drop|dropWhile|either|elem|encodeFloat|enumFrom|enumFromThen|enumFromThenTo|enumFromTo|error|even|exp|exponent|fail|filter|flip|floatDigits|floatRadix|floatRange|floor|fmap|foldl|foldl1|foldr|foldr1|fromDouble|fromEnum|fromInt|fromInteger|fromIntegral|fromRational|fst|gcd|getChar|getContents|getLine|group|head|id|inRange|index|init|intToDigit|interact|ioError|isAlpha|isAlphaNum|isAscii|isControl|isDenormalized|isDigit|isHexDigit|isIEEE|isInfinite|isLower|isNaN|isNegativeZero|isOctDigit|isPrint|isSpace|isUpper|iterate|last|lcm|length|lex|lexDigits|lexLitChar|lines|log|logBase|lookup|map|mapM|mapM_|max|maxBound|maximum|maybe|min|minBound|minimum|mod|negate|not|notElem|null|numerator|odd|or|ord|otherwise|pack|pi|pred|primExitWith|print|product|properFraction|putChar|putStr|putStrLn|quot|quotRem|range|rangeSize|read|readDec|readFile|readFloat|readHex|readIO|readInt|readList|readLitChar|readLn|readOct|readParen|readSigned|reads|readsPrec|realToFrac|recip|rem|repeat|replicate|return|reverse|round|scaleFloat|scanl|scanl1|scanr|scanr1|seq|sequence|sequence_|show|showChar|showInt|showList|showLitChar|showParen|showSigned|showString|shows|showsPrec|significand|signum|sin|sinh|snd|sort|span|splitAt|sqrt|subtract|succ|sum|tail|take|takeWhile|tan|tanh|threadToIOResult|toEnum|toInt|toInteger|toLower|toRational|toUpper|truncate|uncurry|undefined|unlines|until|unwords|unzip|unzip3|userError|words|writeFile|zip|zip3|zipWith|zipWith3)\b/,
        // decimal integers and floating point numbers | octal integers | hexadecimal integers
        number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0o[0-7]+|0x[0-9a-f]+)\b/i,
        operator: [
            {
                // infix operator
                pattern: /`(?:[A-Z][\w']*\.)*[_a-z][\w']*`/,
                greedy: true
            },
            {
                // function composition
                pattern: /(\s)\.(?=\s)/,
                lookbehind: true
            },
            // Most of this is needed because of the meaning of a single '.'.
            // If it stands alone freely, it is the function composition.
            // It may also be a separator between a module name and an identifier => no
            // operator. If it comes together with other special characters it is an
            // operator too.
            //
            // This regex means: /[-!#$%*+=?&@|~.:<>^\\\/]+/ without /\./.
            /[-!#$%*+=?&@|~:<>^\\\/][-!#$%*+=?&@|~.:<>^\\\/]*|\.[-!#$%*+=?&@|~.:<>^\\\/]+/
        ],
        // In Haskell, nearly everything is a variable, do not highlight these.
        hvariable: {
            pattern: /\b(?:[A-Z][\w']*\.)*[_a-z][\w']*/,
            inside: {
                punctuation: /\./
            }
        },
        constant: {
            pattern: /\b(?:[A-Z][\w']*\.)*[A-Z][\w']*/,
            inside: {
                punctuation: /\./
            }
        },
        punctuation: /[{}[\];(),.:]/
    };
    Prism.languages.hs = Prism.languages.haskell;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$1ba73c5509e75af1$export$2e2bcd8739ae039.displayName = 'haxe';
$1ba73c5509e75af1$export$2e2bcd8739ae039.aliases = [];
function $1ba73c5509e75af1$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.haxe = Prism.languages.extend('clike', {
        string: {
            // Strings can be multi-line
            pattern: /"(?:[^"\\]|\\[\s\S])*"/,
            greedy: true
        },
        'class-name': [
            {
                pattern: /(\b(?:abstract|class|enum|extends|implements|interface|new|typedef)\s+)[A-Z_]\w*/,
                lookbehind: true
            },
            // based on naming convention
            /\b[A-Z]\w*/
        ],
        // The final look-ahead prevents highlighting of keywords if expressions such as "haxe.macro.Expr"
        keyword: /\bthis\b|\b(?:abstract|as|break|case|cast|catch|class|continue|default|do|dynamic|else|enum|extends|extern|final|for|from|function|if|implements|import|in|inline|interface|macro|new|null|operator|overload|override|package|private|public|return|static|super|switch|throw|to|try|typedef|untyped|using|var|while)(?!\.)\b/,
        function: {
            pattern: /\b[a-z_]\w*(?=\s*(?:<[^<>]*>\s*)?\()/i,
            greedy: true
        },
        operator: /\.{3}|\+\+|--|&&|\|\||->|=>|(?:<<?|>{1,3}|[-+*/%!=&|^])=?|[?:~]/
    });
    Prism.languages.insertBefore('haxe', 'string', {
        'string-interpolation': {
            pattern: /'(?:[^'\\]|\\[\s\S])*'/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /(^|[^\\])\$(?:\w+|\{[^{}]+\})/,
                    lookbehind: true,
                    inside: {
                        'interpolation-punctuation': {
                            pattern: /^\$\{?|\}$/,
                            alias: 'punctuation'
                        },
                        expression: {
                            pattern: /[\s\S]+/,
                            inside: Prism.languages.haxe
                        }
                    }
                },
                string: /[\s\S]+/
            }
        }
    });
    Prism.languages.insertBefore('haxe', 'class-name', {
        regex: {
            pattern: /~\/(?:[^\/\\\r\n]|\\.)+\/[a-z]*/,
            greedy: true,
            inside: {
                'regex-flags': /\b[a-z]+$/,
                'regex-source': {
                    pattern: /^(~\/)[\s\S]+(?=\/$)/,
                    lookbehind: true,
                    alias: 'language-regex',
                    inside: Prism.languages.regex
                },
                'regex-delimiter': /^~\/|\/$/
            }
        }
    });
    Prism.languages.insertBefore('haxe', 'keyword', {
        preprocessor: {
            pattern: /#(?:else|elseif|end|if)\b.*/,
            alias: 'property'
        },
        metadata: {
            pattern: /@:?[\w.]+/,
            alias: 'symbol'
        },
        reification: {
            pattern: /\$(?:\w+|(?=\{))/,
            alias: 'important'
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $50cc4f59c8b2da7b$export$2e2bcd8739ae039.displayName = 'hcl';
$50cc4f59c8b2da7b$export$2e2bcd8739ae039.aliases = [];
function $50cc4f59c8b2da7b$export$2e2bcd8739ae039(Prism) {
    Prism.languages.hcl = {
        comment: /(?:\/\/|#).*|\/\*[\s\S]*?(?:\*\/|$)/,
        heredoc: {
            pattern: /<<-?(\w+\b)[\s\S]*?^[ \t]*\1/m,
            greedy: true,
            alias: 'string'
        },
        keyword: [
            {
                pattern: /(?:data|resource)\s+(?:"(?:\\[\s\S]|[^\\"])*")(?=\s+"[\w-]+"\s+\{)/i,
                inside: {
                    type: {
                        pattern: /(resource|data|\s+)(?:"(?:\\[\s\S]|[^\\"])*")/i,
                        lookbehind: true,
                        alias: 'variable'
                    }
                }
            },
            {
                pattern: /(?:backend|module|output|provider|provisioner|variable)\s+(?:[\w-]+|"(?:\\[\s\S]|[^\\"])*")\s+(?=\{)/i,
                inside: {
                    type: {
                        pattern: /(backend|module|output|provider|provisioner|variable)\s+(?:[\w-]+|"(?:\\[\s\S]|[^\\"])*")\s+/i,
                        lookbehind: true,
                        alias: 'variable'
                    }
                }
            },
            /[\w-]+(?=\s+\{)/
        ],
        property: [
            /[-\w\.]+(?=\s*=(?!=))/,
            /"(?:\\[\s\S]|[^\\"])+"(?=\s*[:=])/
        ],
        string: {
            pattern: /"(?:[^\\$"]|\\[\s\S]|\$(?:(?=")|\$+(?!\$)|[^"${])|\$\{(?:[^{}"]|"(?:[^\\"]|\\[\s\S])*")*\})*"/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /(^|[^$])\$\{(?:[^{}"]|"(?:[^\\"]|\\[\s\S])*")*\}/,
                    lookbehind: true,
                    inside: {
                        type: {
                            pattern: /(\b(?:count|data|local|module|path|self|terraform|var)\b\.)[\w\*]+/i,
                            lookbehind: true,
                            alias: 'variable'
                        },
                        keyword: /\b(?:count|data|local|module|path|self|terraform|var)\b/i,
                        function: /\w+(?=\()/,
                        string: {
                            pattern: /"(?:\\[\s\S]|[^\\"])*"/,
                            greedy: true
                        },
                        number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
                        punctuation: /[!\$#%&'()*+,.\/;<=>@\[\\\]^`{|}~?:]/
                    }
                }
            }
        },
        number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
        boolean: /\b(?:false|true)\b/i,
        punctuation: /[=\[\]{}]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$e2e7d35f13665654$export$2e2bcd8739ae039.displayName = 'hlsl';
$e2e7d35f13665654$export$2e2bcd8739ae039.aliases = [];
function $e2e7d35f13665654$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f4e156ae6ed8d0a0$export$2e2bcd8739ae039));
    Prism.languages.hlsl = Prism.languages.extend('c', {
        // Regarding keywords and class names:
        // The list of all keywords was split into 'keyword' and 'class-name' tokens based on whether they are capitalized.
        // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-keywords
        // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-reserved-words
        'class-name': [
            Prism.languages.c['class-name'],
            /\b(?:AppendStructuredBuffer|BlendState|Buffer|ByteAddressBuffer|CompileShader|ComputeShader|ConsumeStructuredBuffer|DepthStencilState|DepthStencilView|DomainShader|GeometryShader|Hullshader|InputPatch|LineStream|OutputPatch|PixelShader|PointStream|RWBuffer|RWByteAddressBuffer|RWStructuredBuffer|RWTexture(?:1D|1DArray|2D|2DArray|3D)|RasterizerState|RenderTargetView|SamplerComparisonState|SamplerState|StructuredBuffer|Texture(?:1D|1DArray|2D|2DArray|2DMS|2DMSArray|3D|Cube|CubeArray)|TriangleStream|VertexShader)\b/
        ],
        keyword: [
            // HLSL keyword
            /\b(?:asm|asm_fragment|auto|break|case|catch|cbuffer|centroid|char|class|column_major|compile|compile_fragment|const|const_cast|continue|default|delete|discard|do|dynamic_cast|else|enum|explicit|export|extern|for|friend|fxgroup|goto|groupshared|if|in|inline|inout|interface|line|lineadj|linear|long|matrix|mutable|namespace|new|nointerpolation|noperspective|operator|out|packoffset|pass|pixelfragment|point|precise|private|protected|public|register|reinterpret_cast|return|row_major|sample|sampler|shared|short|signed|sizeof|snorm|stateblock|stateblock_state|static|static_cast|string|struct|switch|tbuffer|technique|technique10|technique11|template|texture|this|throw|triangle|triangleadj|try|typedef|typename|uniform|union|unorm|unsigned|using|vector|vertexfragment|virtual|void|volatile|while)\b/,
            // scalar, vector, and matrix types
            /\b(?:bool|double|dword|float|half|int|min(?:10float|12int|16(?:float|int|uint))|uint)(?:[1-4](?:x[1-4])?)?\b/
        ],
        // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-grammar#floating-point-numbers
        number: /(?:(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+)?|\b0x[\da-fA-F]+)[fFhHlLuU]?\b/,
        boolean: /\b(?:false|true)\b/
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $e34b34b543223ef4$export$2e2bcd8739ae039.displayName = 'hoon';
$e34b34b543223ef4$export$2e2bcd8739ae039.aliases = [];
function $e34b34b543223ef4$export$2e2bcd8739ae039(Prism) {
    Prism.languages.hoon = {
        comment: {
            pattern: /::.*/,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*'/,
            greedy: true
        },
        constant: /%(?:\.[ny]|[\w-]+)/,
        'class-name': /@(?:[a-z0-9-]*[a-z0-9])?|\*/i,
        function: /(?:\+[-+] {2})?(?:[a-z](?:[a-z0-9-]*[a-z0-9])?)/,
        keyword: /\.[\^\+\*=\?]|![><:\.=\?!]|=[>|:,\.\-\^<+;/~\*\?]|\?[>|:\.\-\^<\+&~=@!]|\|[\$_%:\.\-\^~\*=@\?]|\+[|\$\+\*]|:[_\-\^\+~\*]|%[_:\.\-\^\+~\*=]|\^[|:\.\-\+&~\*=\?]|\$[|_%:<>\-\^&~@=\?]|;[:<\+;\/~\*=]|~[>|\$_%<\+\/&=\?!]|--|==/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $669817df648224fc$export$2e2bcd8739ae039.displayName = 'hpkp';
$669817df648224fc$export$2e2bcd8739ae039.aliases = [];
function $669817df648224fc$export$2e2bcd8739ae039(Prism) {
    /**
   * Original by Scott Helme.
   *
   * Reference: https://scotthelme.co.uk/hpkp-cheat-sheet/
   */ Prism.languages.hpkp = {
        directive: {
            pattern: /\b(?:includeSubDomains|max-age|pin-sha256|preload|report-to|report-uri|strict)(?=[\s;=]|$)/i,
            alias: 'property'
        },
        operator: /=/,
        punctuation: /;/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $6c6957e69ba93803$export$2e2bcd8739ae039.displayName = 'hsts';
$6c6957e69ba93803$export$2e2bcd8739ae039.aliases = [];
function $6c6957e69ba93803$export$2e2bcd8739ae039(Prism) {
    /**
   * Original by Scott Helme.
   *
   * Reference: https://scotthelme.co.uk/hsts-cheat-sheet/
   */ Prism.languages.hsts = {
        directive: {
            pattern: /\b(?:includeSubDomains|max-age|preload)(?=[\s;=]|$)/i,
            alias: 'property'
        },
        operator: /=/,
        punctuation: /;/
    };
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $6583f09ac504dc32$export$2e2bcd8739ae039.displayName = 'uri';
$6583f09ac504dc32$export$2e2bcd8739ae039.aliases = [
    'url'
];
function $6583f09ac504dc32$export$2e2bcd8739ae039(Prism) {
    // https://tools.ietf.org/html/rfc3986#appendix-A
    Prism.languages.uri = {
        scheme: {
            pattern: /^[a-z][a-z0-9+.-]*:/im,
            greedy: true,
            inside: {
                'scheme-delimiter': /:$/
            }
        },
        fragment: {
            pattern: /#[\w\-.~!$&'()*+,;=%:@/?]*/,
            inside: {
                'fragment-delimiter': /^#/
            }
        },
        query: {
            pattern: /\?[\w\-.~!$&'()*+,;=%:@/?]*/,
            inside: {
                'query-delimiter': {
                    pattern: /^\?/,
                    greedy: true
                },
                'pair-delimiter': /[&;]/,
                pair: {
                    pattern: /^[^=][\s\S]*/,
                    inside: {
                        key: /^[^=]+/,
                        value: {
                            pattern: /(^=)[\s\S]+/,
                            lookbehind: true
                        }
                    }
                }
            }
        },
        authority: {
            pattern: RegExp(/^\/\//.source + // [ userinfo "@" ]
            /(?:[\w\-.~!$&'()*+,;=%:]*@)?/.source + // host
            ('(?:' + // IP-literal
            /\[(?:[0-9a-fA-F:.]{2,48}|v[0-9a-fA-F]+\.[\w\-.~!$&'()*+,;=]+)\]/.source + '|' + // IPv4address or registered name
            /[\w\-.~!$&'()*+,;=%]*/.source + ')') + // [ ":" port ]
            /(?::\d*)?/.source, 'm'),
            inside: {
                'authority-delimiter': /^\/\//,
                'user-info-segment': {
                    pattern: /^[\w\-.~!$&'()*+,;=%:]*@/,
                    inside: {
                        'user-info-delimiter': /@$/,
                        'user-info': /^[\w\-.~!$&'()*+,;=%:]+/
                    }
                },
                'port-segment': {
                    pattern: /:\d*$/,
                    inside: {
                        'port-delimiter': /^:/,
                        port: /^\d+/
                    }
                },
                host: {
                    pattern: /[\s\S]+/,
                    inside: {
                        'ip-literal': {
                            pattern: /^\[[\s\S]+\]$/,
                            inside: {
                                'ip-literal-delimiter': /^\[|\]$/,
                                'ipv-future': /^v[\s\S]+/,
                                'ipv6-address': /^[\s\S]+/
                            }
                        },
                        'ipv4-address': /^(?:(?:[03-9]\d?|[12]\d{0,2})\.){3}(?:[03-9]\d?|[12]\d{0,2})$/
                    }
                }
            }
        },
        path: {
            pattern: /^[\w\-.~!$&'()*+,;=%:@/]+/m,
            inside: {
                'path-separator': /\//
            }
        }
    };
    Prism.languages.url = Prism.languages.uri;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $df4a8f4049b5c047$export$2e2bcd8739ae039.displayName = 'http';
$df4a8f4049b5c047$export$2e2bcd8739ae039.aliases = [];
function $df4a8f4049b5c047$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        /**
     * @param {string} name
     * @returns {RegExp}
     */ function headerValueOf(name) {
            return RegExp('(^(?:' + name + '):[ \t]*(?![ \t]))[^]+', 'i');
        }
        Prism.languages.http = {
            'request-line': {
                pattern: /^(?:CONNECT|DELETE|GET|HEAD|OPTIONS|PATCH|POST|PRI|PUT|SEARCH|TRACE)\s(?:https?:\/\/|\/)\S*\sHTTP\/[\d.]+/m,
                inside: {
                    // HTTP Method
                    method: {
                        pattern: /^[A-Z]+\b/,
                        alias: 'property'
                    },
                    // Request Target e.g. http://example.com, /path/to/file
                    'request-target': {
                        pattern: /^(\s)(?:https?:\/\/|\/)\S*(?=\s)/,
                        lookbehind: true,
                        alias: 'url',
                        inside: Prism.languages.uri
                    },
                    // HTTP Version
                    'http-version': {
                        pattern: /^(\s)HTTP\/[\d.]+/,
                        lookbehind: true,
                        alias: 'property'
                    }
                }
            },
            'response-status': {
                pattern: /^HTTP\/[\d.]+ \d+ .+/m,
                inside: {
                    // HTTP Version
                    'http-version': {
                        pattern: /^HTTP\/[\d.]+/,
                        alias: 'property'
                    },
                    // Status Code
                    'status-code': {
                        pattern: /^(\s)\d+(?=\s)/,
                        lookbehind: true,
                        alias: 'number'
                    },
                    // Reason Phrase
                    'reason-phrase': {
                        pattern: /^(\s).+/,
                        lookbehind: true,
                        alias: 'string'
                    }
                }
            },
            header: {
                pattern: /^[\w-]+:.+(?:(?:\r\n?|\n)[ \t].+)*/m,
                inside: {
                    'header-value': [
                        {
                            pattern: headerValueOf(/Content-Security-Policy/.source),
                            lookbehind: true,
                            alias: [
                                'csp',
                                'languages-csp'
                            ],
                            inside: Prism.languages.csp
                        },
                        {
                            pattern: headerValueOf(/Public-Key-Pins(?:-Report-Only)?/.source),
                            lookbehind: true,
                            alias: [
                                'hpkp',
                                'languages-hpkp'
                            ],
                            inside: Prism.languages.hpkp
                        },
                        {
                            pattern: headerValueOf(/Strict-Transport-Security/.source),
                            lookbehind: true,
                            alias: [
                                'hsts',
                                'languages-hsts'
                            ],
                            inside: Prism.languages.hsts
                        },
                        {
                            pattern: headerValueOf(/[^:]+/.source),
                            lookbehind: true
                        }
                    ],
                    'header-name': {
                        pattern: /^[^:]+/,
                        alias: 'keyword'
                    },
                    punctuation: /^:/
                }
            }
        };
        // Create a mapping of Content-Type headers to language definitions
        var langs = Prism.languages;
        var httpLanguages = {
            'application/javascript': langs.javascript,
            'application/json': langs.json || langs.javascript,
            'application/xml': langs.xml,
            'text/xml': langs.xml,
            'text/html': langs.html,
            'text/css': langs.css,
            'text/plain': langs.plain
        };
        // Declare which types can also be suffixes
        var suffixTypes = {
            'application/json': true,
            'application/xml': true
        };
        /**
     * Returns a pattern for the given content type which matches it and any type which has it as a suffix.
     *
     * @param {string} contentType
     * @returns {string}
     */ function getSuffixPattern(contentType) {
            var suffix = contentType.replace(/^[a-z]+\//, '');
            var suffixPattern = '\\w+/(?:[\\w.-]+\\+)+' + suffix + '(?![+\\w.-])';
            return '(?:' + contentType + '|' + suffixPattern + ')';
        }
        // Insert each content type parser that has its associated language
        // currently loaded.
        var options;
        for(var contentType in httpLanguages)if (httpLanguages[contentType]) {
            options = options || {};
            var pattern = suffixTypes[contentType] ? getSuffixPattern(contentType) : contentType;
            options[contentType.replace(/\//g, '-')] = {
                pattern: RegExp('(' + /content-type:\s*/.source + pattern + /(?:(?:\r\n?|\n)[\w-].*)*(?:\r(?:\n|(?!\n))|\n)/.source + ')' + // This is a little interesting:
                // The HTTP format spec required 1 empty line before the body to make everything unambiguous.
                // However, when writing code by hand (e.g. to display on a website) people can forget about this,
                // so we want to be liberal here. We will allow the empty line to be omitted if the first line of
                // the body does not start with a [\w-] character (as headers do).
                /[^ \t\w-][\s\S]*/.source, 'i'),
                lookbehind: true,
                inside: httpLanguages[contentType]
            };
        }
        if (options) Prism.languages.insertBefore('http', 'header', options);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $dae26b846c274399$export$2e2bcd8739ae039.displayName = 'ichigojam';
$dae26b846c274399$export$2e2bcd8739ae039.aliases = [];
function $dae26b846c274399$export$2e2bcd8739ae039(Prism) {
    // according to the offical reference (EN)
    // https://ichigojam.net/IchigoJam-en.html
    Prism.languages.ichigojam = {
        comment: /(?:\B'|REM)(?:[^\n\r]*)/i,
        string: {
            pattern: /"(?:""|[!#$%&'()*,\/:;<=>?^\w +\-.])*"/,
            greedy: true
        },
        number: /\B#[0-9A-F]+|\B`[01]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
        keyword: /\b(?:BEEP|BPS|CASE|CLEAR|CLK|CLO|CLP|CLS|CLT|CLV|CONT|COPY|ELSE|END|FILE|FILES|FOR|GOSUB|GOTO|GSB|IF|INPUT|KBD|LED|LET|LIST|LOAD|LOCATE|LRUN|NEW|NEXT|OUT|PLAY|POKE|PRINT|PWM|REM|RENUM|RESET|RETURN|RIGHT|RTN|RUN|SAVE|SCROLL|SLEEP|SRND|STEP|STOP|SUB|TEMPO|THEN|TO|UART|VIDEO|WAIT)(?:\$|\b)/i,
        function: /\b(?:ABS|ANA|ASC|BIN|BTN|DEC|END|FREE|HELP|HEX|I2CR|I2CW|IN|INKEY|LEN|LINE|PEEK|RND|SCR|SOUND|STR|TICK|USR|VER|VPEEK|ZER)(?:\$|\b)/i,
        label: /(?:\B@\S+)/,
        operator: /<[=>]?|>=?|\|\||&&|[+\-*\/=|&^~!]|\b(?:AND|NOT|OR)\b/i,
        punctuation: /[\[,;:()\]]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $7f7ed36c71460d27$export$2e2bcd8739ae039.displayName = 'icon';
$7f7ed36c71460d27$export$2e2bcd8739ae039.aliases = [];
function $7f7ed36c71460d27$export$2e2bcd8739ae039(Prism) {
    Prism.languages.icon = {
        comment: /#.*/,
        string: {
            pattern: /(["'])(?:(?!\1)[^\\\r\n_]|\\.|_(?!\1)(?:\r\n|[\s\S]))*\1/,
            greedy: true
        },
        number: /\b(?:\d+r[a-z\d]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b|\.\d+\b/i,
        'builtin-keyword': {
            pattern: /&(?:allocated|ascii|clock|collections|cset|current|date|dateline|digits|dump|e|error(?:number|text|value)?|errout|fail|features|file|host|input|lcase|letters|level|line|main|null|output|phi|pi|pos|progname|random|regions|source|storage|subject|time|trace|ucase|version)\b/,
            alias: 'variable'
        },
        directive: {
            pattern: /\$\w+/,
            alias: 'builtin'
        },
        keyword: /\b(?:break|by|case|create|default|do|else|end|every|fail|global|if|initial|invocable|link|local|next|not|of|procedure|record|repeat|return|static|suspend|then|to|until|while)\b/,
        function: /\b(?!\d)\w+(?=\s*[({]|\s*!\s*\[)/,
        operator: /[+-]:(?!=)|(?:[\/?@^%&]|\+\+?|--?|==?=?|~==?=?|\*\*?|\|\|\|?|<(?:->?|<?=?)|>>?=?)(?::=)?|:(?:=:?)?|[!.\\|~]/,
        punctuation: /[\[\](){},;]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $01d5a9ee0f18d738$export$2e2bcd8739ae039.displayName = 'icu-message-format';
$01d5a9ee0f18d738$export$2e2bcd8739ae039.aliases = [];
function $01d5a9ee0f18d738$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        /**
     * @param {string} source
     * @param {number} level
     * @returns {string}
     */ function nested(source, level) {
            if (level <= 0) return /[]/.source;
            else return source.replace(/<SELF>/g, function() {
                return nested(source, level - 1);
            });
        }
        var stringPattern = /'[{}:=,](?:[^']|'')*'(?!')/;
        var escape = {
            pattern: /''/,
            greedy: true,
            alias: 'operator'
        };
        var string = {
            pattern: stringPattern,
            greedy: true,
            inside: {
                escape: escape
            }
        };
        var argumentSource = nested(/\{(?:[^{}']|'(?![{},'])|''|<STR>|<SELF>)*\}/.source.replace(/<STR>/g, function() {
            return stringPattern.source;
        }), 8);
        var nestedMessage = {
            pattern: RegExp(argumentSource),
            inside: {
                message: {
                    pattern: /^(\{)[\s\S]+(?=\}$)/,
                    lookbehind: true,
                    inside: null // see below
                },
                'message-delimiter': {
                    pattern: /./,
                    alias: 'punctuation'
                }
            }
        };
        Prism.languages['icu-message-format'] = {
            argument: {
                pattern: RegExp(argumentSource),
                greedy: true,
                inside: {
                    content: {
                        pattern: /^(\{)[\s\S]+(?=\}$)/,
                        lookbehind: true,
                        inside: {
                            'argument-name': {
                                pattern: /^(\s*)[^{}:=,\s]+/,
                                lookbehind: true
                            },
                            'choice-style': {
                                // https://unicode-org.github.io/icu-docs/apidoc/released/icu4c/classicu_1_1ChoiceFormat.html#details
                                pattern: /^(\s*,\s*choice\s*,\s*)\S(?:[\s\S]*\S)?/,
                                lookbehind: true,
                                inside: {
                                    punctuation: /\|/,
                                    range: {
                                        pattern: /^(\s*)[+-]?(?:\d+(?:\.\d*)?|\u221e)\s*[<#\u2264]/,
                                        lookbehind: true,
                                        inside: {
                                            operator: /[<#\u2264]/,
                                            number: /\S+/
                                        }
                                    },
                                    rest: null // see below
                                }
                            },
                            'plural-style': {
                                // https://unicode-org.github.io/icu-docs/apidoc/released/icu4j/com/ibm/icu/text/PluralFormat.html#:~:text=Patterns%20and%20Their%20Interpretation
                                pattern: /^(\s*,\s*(?:plural|selectordinal)\s*,\s*)\S(?:[\s\S]*\S)?/,
                                lookbehind: true,
                                inside: {
                                    offset: /^offset:\s*\d+/,
                                    'nested-message': nestedMessage,
                                    selector: {
                                        pattern: /=\d+|[^{}:=,\s]+/,
                                        inside: {
                                            keyword: /^(?:few|many|one|other|two|zero)$/
                                        }
                                    }
                                }
                            },
                            'select-style': {
                                // https://unicode-org.github.io/icu-docs/apidoc/released/icu4j/com/ibm/icu/text/SelectFormat.html#:~:text=Patterns%20and%20Their%20Interpretation
                                pattern: /^(\s*,\s*select\s*,\s*)\S(?:[\s\S]*\S)?/,
                                lookbehind: true,
                                inside: {
                                    'nested-message': nestedMessage,
                                    selector: {
                                        pattern: /[^{}:=,\s]+/,
                                        inside: {
                                            keyword: /^other$/
                                        }
                                    }
                                }
                            },
                            keyword: /\b(?:choice|plural|select|selectordinal)\b/,
                            'arg-type': {
                                pattern: /\b(?:date|duration|number|ordinal|spellout|time)\b/,
                                alias: 'keyword'
                            },
                            'arg-skeleton': {
                                pattern: /(,\s*)::[^{}:=,\s]+/,
                                lookbehind: true
                            },
                            'arg-style': {
                                pattern: /(,\s*)(?:currency|full|integer|long|medium|percent|short)(?=\s*$)/,
                                lookbehind: true
                            },
                            'arg-style-text': {
                                pattern: RegExp(/(^\s*,\s*(?=\S))/.source + nested(/(?:[^{}']|'[^']*'|\{(?:<SELF>)?\})+/.source, 8) + '$'),
                                lookbehind: true,
                                alias: 'string'
                            },
                            punctuation: /,/
                        }
                    },
                    'argument-delimiter': {
                        pattern: /./,
                        alias: 'operator'
                    }
                }
            },
            escape: escape,
            string: string
        };
        nestedMessage.inside.message.inside = Prism.languages['icu-message-format'];
        Prism.languages['icu-message-format'].argument.inside.content.inside['choice-style'].inside.rest = Prism.languages['icu-message-format'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$3c79c65302ac0671$export$2e2bcd8739ae039.displayName = 'idris';
$3c79c65302ac0671$export$2e2bcd8739ae039.aliases = [
    'idr'
];
function $3c79c65302ac0671$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $2ae70ee16ca48837$export$2e2bcd8739ae039));
    Prism.languages.idris = Prism.languages.extend('haskell', {
        comment: {
            pattern: /(?:(?:--|\|\|\|).*$|\{-[\s\S]*?-\})/m
        },
        keyword: /\b(?:Type|case|class|codata|constructor|corecord|data|do|dsl|else|export|if|implementation|implicit|import|impossible|in|infix|infixl|infixr|instance|interface|let|module|mutual|namespace|of|parameters|partial|postulate|private|proof|public|quoteGoal|record|rewrite|syntax|then|total|using|where|with)\b/,
        builtin: undefined
    });
    Prism.languages.insertBefore('idris', 'keyword', {
        'import-statement': {
            pattern: /(^\s*import\s+)(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*/m,
            lookbehind: true,
            inside: {
                punctuation: /\./
            }
        }
    });
    Prism.languages.idr = Prism.languages.idris;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $de2f160c2fe3453a$export$2e2bcd8739ae039.displayName = 'ignore';
$de2f160c2fe3453a$export$2e2bcd8739ae039.aliases = [
    'gitignore',
    'hgignore',
    'npmignore'
];
function $de2f160c2fe3453a$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.ignore = {
            // https://git-scm.com/docs/gitignore
            comment: /^#.*/m,
            entry: {
                pattern: /\S(?:.*(?:(?:\\ )|\S))?/,
                alias: 'string',
                inside: {
                    operator: /^!|\*\*?|\?/,
                    regex: {
                        pattern: /(^|[^\\])\[[^\[\]]*\]/,
                        lookbehind: true
                    },
                    punctuation: /\//
                }
            }
        };
        Prism.languages.gitignore = Prism.languages.ignore;
        Prism.languages.hgignore = Prism.languages.ignore;
        Prism.languages.npmignore = Prism.languages.ignore;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $2575e451a3a1df7f$export$2e2bcd8739ae039.displayName = 'inform7';
$2575e451a3a1df7f$export$2e2bcd8739ae039.aliases = [];
function $2575e451a3a1df7f$export$2e2bcd8739ae039(Prism) {
    Prism.languages.inform7 = {
        string: {
            pattern: /"[^"]*"/,
            inside: {
                substitution: {
                    pattern: /\[[^\[\]]+\]/,
                    inside: {
                        delimiter: {
                            pattern: /\[|\]/,
                            alias: 'punctuation'
                        }
                    }
                }
            }
        },
        comment: {
            pattern: /\[[^\[\]]+\]/,
            greedy: true
        },
        title: {
            pattern: /^[ \t]*(?:book|chapter|part(?! of)|section|table|volume)\b.+/im,
            alias: 'important'
        },
        number: {
            pattern: /(^|[^-])(?:\b\d+(?:\.\d+)?(?:\^\d+)?(?:(?!\d)\w+)?|\b(?:eight|eleven|five|four|nine|one|seven|six|ten|three|twelve|two))\b(?!-)/i,
            lookbehind: true
        },
        verb: {
            pattern: /(^|[^-])\b(?:answering|applying to|are|asking|attacking|be(?:ing)?|burning|buying|called|carries|carry(?! out)|carrying|climbing|closing|conceal(?:ing|s)?|consulting|contain(?:ing|s)?|cutting|drinking|dropping|eating|enclos(?:es?|ing)|entering|examining|exiting|getting|giving|going|ha(?:s|ve|ving)|hold(?:ing|s)?|impl(?:ies|y)|incorporat(?:es?|ing)|inserting|is|jumping|kissing|listening|locking|looking|mean(?:ing|s)?|opening|provid(?:es?|ing)|pulling|pushing|putting|relat(?:es?|ing)|removing|searching|see(?:ing|s)?|setting|showing|singing|sleeping|smelling|squeezing|support(?:ing|s)?|swearing|switching|taking|tasting|telling|thinking|throwing|touching|turning|tying|unlock(?:ing|s)?|var(?:ies|y|ying)|waiting|waking|waving|wear(?:ing|s)?)\b(?!-)/i,
            lookbehind: true,
            alias: 'operator'
        },
        keyword: {
            pattern: /(^|[^-])\b(?:after|before|carry out|check|continue the action|definition(?= *:)|do nothing|else|end (?:if|the story|unless)|every turn|if|include|instead(?: of)?|let|move|no|now|otherwise|repeat|report|resume the story|rule for|running through|say(?:ing)?|stop the action|test|try(?:ing)?|understand|unless|use|when|while|yes)\b(?!-)/i,
            lookbehind: true
        },
        property: {
            pattern: /(^|[^-])\b(?:adjacent(?! to)|carried|closed|concealed|contained|dark|described|edible|empty|enclosed|enterable|even|female|fixed in place|full|handled|held|improper-named|incorporated|inedible|invisible|lighted|lit|lock(?:able|ed)|male|marked for listing|mentioned|negative|neuter|non-(?:empty|full|recurring)|odd|opaque|open(?:able)?|plural-named|portable|positive|privately-named|proper-named|provided|publically-named|pushable between rooms|recurring|related|rubbing|scenery|seen|singular-named|supported|swinging|switch(?:able|ed(?: off| on)?)|touch(?:able|ed)|transparent|unconcealed|undescribed|unlit|unlocked|unmarked for listing|unmentioned|unopenable|untouchable|unvisited|variable|visible|visited|wearable|worn)\b(?!-)/i,
            lookbehind: true,
            alias: 'symbol'
        },
        position: {
            pattern: /(^|[^-])\b(?:above|adjacent to|back side of|below|between|down|east|everywhere|front side|here|in|inside(?: from)?|north(?:east|west)?|nowhere|on(?: top of)?|other side|outside(?: from)?|parts? of|regionally in|south(?:east|west)?|through|up|west|within)\b(?!-)/i,
            lookbehind: true,
            alias: 'keyword'
        },
        type: {
            pattern: /(^|[^-])\b(?:actions?|activit(?:ies|y)|actors?|animals?|backdrops?|containers?|devices?|directions?|doors?|holders?|kinds?|lists?|m[ae]n|nobody|nothing|nouns?|numbers?|objects?|people|persons?|player(?:'s holdall)?|regions?|relations?|rooms?|rule(?:book)?s?|scenes?|someone|something|supporters?|tables?|texts?|things?|time|vehicles?|wom[ae]n)\b(?!-)/i,
            lookbehind: true,
            alias: 'variable'
        },
        punctuation: /[.,:;(){}]/
    };
    Prism.languages.inform7['string'].inside['substitution'].inside.rest = Prism.languages.inform7;
    // We don't want the remaining text in the substitution to be highlighted as the string.
    Prism.languages.inform7['string'].inside['substitution'].inside.rest.text = {
        pattern: /\S(?:\s*\S)*/,
        alias: 'comment'
    };
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $0b6b8e959651c37f$export$2e2bcd8739ae039.displayName = 'io';
$0b6b8e959651c37f$export$2e2bcd8739ae039.aliases = [];
function $0b6b8e959651c37f$export$2e2bcd8739ae039(Prism) {
    Prism.languages.io = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\/\/.*|#.*)/,
            lookbehind: true,
            greedy: true
        },
        'triple-quoted-string': {
            pattern: /"""(?:\\[\s\S]|(?!""")[^\\])*"""/,
            greedy: true,
            alias: 'string'
        },
        string: {
            pattern: /"(?:\\.|[^\\\r\n"])*"/,
            greedy: true
        },
        keyword: /\b(?:activate|activeCoroCount|asString|block|break|call|catch|clone|collectGarbage|compileString|continue|do|doFile|doMessage|doString|else|elseif|exit|for|foreach|forward|getEnvironmentVariable|getSlot|hasSlot|if|ifFalse|ifNil|ifNilEval|ifTrue|isActive|isNil|isResumable|list|message|method|parent|pass|pause|perform|performWithArgList|print|println|proto|raise|raiseResumable|removeSlot|resend|resume|schedulerSleepSeconds|self|sender|setSchedulerSleepSeconds|setSlot|shallowCopy|slotNames|super|system|then|thisBlock|thisContext|try|type|uniqueId|updateSlot|wait|while|write|yield)\b/,
        builtin: /\b(?:Array|AudioDevice|AudioMixer|BigNum|Block|Box|Buffer|CFunction|CGI|Color|Curses|DBM|DNSResolver|DOConnection|DOProxy|DOServer|Date|Directory|Duration|DynLib|Error|Exception|FFT|File|Fnmatch|Font|Future|GL|GLE|GLScissor|GLU|GLUCylinder|GLUQuadric|GLUSphere|GLUT|Host|Image|Importer|LinkList|List|Lobby|Locals|MD5|MP3Decoder|MP3Encoder|Map|Message|Movie|Notification|Number|Object|OpenGL|Point|Protos|Random|Regex|SGML|SGMLElement|SGMLParser|SQLite|Sequence|Server|ShowMessage|SleepyCat|SleepyCatCursor|Socket|SocketManager|Sound|Soup|Store|String|Tree|UDPSender|UPDReceiver|URL|User|Warning|WeakLink)\b/,
        boolean: /\b(?:false|nil|true)\b/,
        number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e-?\d+)?/i,
        operator: /[=!*/%+\-^&|]=|>>?=?|<<?=?|:?:?=|\+\+?|--?|\*\*?|\/\/?|%|\|\|?|&&?|\b(?:and|not|or|return)\b|@@?|\?\??|\.\./,
        punctuation: /[{}[\];(),.:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $cd93a27b452b7c48$export$2e2bcd8739ae039.displayName = 'j';
$cd93a27b452b7c48$export$2e2bcd8739ae039.aliases = [];
function $cd93a27b452b7c48$export$2e2bcd8739ae039(Prism) {
    Prism.languages.j = {
        comment: {
            pattern: /\bNB\..*/,
            greedy: true
        },
        string: {
            pattern: /'(?:''|[^'\r\n])*'/,
            greedy: true
        },
        keyword: /\b(?:(?:CR|LF|adverb|conjunction|def|define|dyad|monad|noun|verb)\b|(?:assert|break|case|catch[dt]?|continue|do|else|elseif|end|fcase|for|for_\w+|goto_\w+|if|label_\w+|return|select|throw|try|while|whilst)\.)/,
        verb: {
            // Negative look-ahead prevents bad highlighting
            // of ^: ;. =. =: !. !:
            pattern: /(?!\^:|;\.|[=!][.:])(?:\{(?:\.|::?)?|p(?:\.\.?|:)|[=!\]]|[<>+*\-%$|,#][.:]?|[?^]\.?|[;\[]:?|[~}"i][.:]|[ACeEIjLor]\.|(?:[_\/\\qsux]|_?\d):)/,
            alias: 'keyword'
        },
        number: /\b_?(?:(?!\d:)\d+(?:\.\d+)?(?:(?:ad|ar|[ejpx])_?\d+(?:\.\d+)?)*(?:b_?[\da-z]+(?:\.[\da-z]+)?)?|_\b(?!\.))/,
        adverb: {
            pattern: /[~}]|[\/\\]\.?|[bfM]\.|t[.:]/,
            alias: 'builtin'
        },
        operator: /[=a][.:]|_\./,
        conjunction: {
            pattern: /&(?:\.:?|:)?|[.:@][.:]?|[!D][.:]|[;dHT]\.|`:?|[\^LS]:|"/,
            alias: 'variable'
        },
        punctuation: /[()]/
    };
}




// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $27318f6b523d68d5$export$2e2bcd8739ae039.displayName = 'javadoclike';
$27318f6b523d68d5$export$2e2bcd8739ae039.aliases = [];
function $27318f6b523d68d5$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var javaDocLike = Prism.languages.javadoclike = {
            parameter: {
                pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*@(?:arg|arguments|param)\s+)\w+/m,
                lookbehind: true
            },
            keyword: {
                // keywords are the first word in a line preceded be an `@` or surrounded by curly braces.
                // @word, {@word}
                pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*|\{)@[a-z][a-zA-Z-]+\b/m,
                lookbehind: true
            },
            punctuation: /[{}]/
        };
        /**
     * Adds doc comment support to the given language and calls a given callback on each doc comment pattern.
     *
     * @param {string} lang the language add doc comment support to.
     * @param {(pattern: {inside: {rest: undefined}}) => void} callback the function called with each doc comment pattern as argument.
     */ function docCommentSupport(lang, callback) {
            var tokenName = 'doc-comment';
            var grammar = Prism.languages[lang];
            if (!grammar) return;
            var token = grammar[tokenName];
            if (!token) {
                // add doc comment: /** */
                var definition = {};
                definition[tokenName] = {
                    pattern: /(^|[^\\])\/\*\*[^/][\s\S]*?(?:\*\/|$)/,
                    lookbehind: true,
                    alias: 'comment'
                };
                grammar = Prism.languages.insertBefore(lang, 'comment', definition);
                token = grammar[tokenName];
            }
            if (token instanceof RegExp) // convert regex to object
            token = grammar[tokenName] = {
                pattern: token
            };
            if (Array.isArray(token)) for(var i = 0, l = token.length; i < l; i++){
                if (token[i] instanceof RegExp) token[i] = {
                    pattern: token[i]
                };
                callback(token[i]);
            }
            else callback(token);
        }
        /**
     * Adds doc-comment support to the given languages for the given documentation language.
     *
     * @param {string[]|string} languages
     * @param {Object} docLanguage
     */ function addSupport(languages, docLanguage) {
            if (typeof languages === 'string') languages = [
                languages
            ];
            languages.forEach(function(lang) {
                docCommentSupport(lang, function(pattern) {
                    if (!pattern.inside) pattern.inside = {};
                    pattern.inside.rest = docLanguage;
                });
            });
        }
        Object.defineProperty(javaDocLike, 'addSupport', {
            value: addSupport
        });
        javaDocLike.addSupport([
            'java',
            'javascript',
            'php'
        ], javaDocLike);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$46a0b7b965a829bf$export$2e2bcd8739ae039.displayName = 'scala';
$46a0b7b965a829bf$export$2e2bcd8739ae039.aliases = [];
function $46a0b7b965a829bf$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $49817f5fa65142f2$export$2e2bcd8739ae039));
    Prism.languages.scala = Prism.languages.extend('java', {
        'triple-quoted-string': {
            pattern: /"""[\s\S]*?"""/,
            greedy: true,
            alias: 'string'
        },
        string: {
            pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        keyword: /<-|=>|\b(?:abstract|case|catch|class|def|derives|do|else|enum|extends|extension|final|finally|for|forSome|given|if|implicit|import|infix|inline|lazy|match|new|null|object|opaque|open|override|package|private|protected|return|sealed|self|super|this|throw|trait|transparent|try|type|using|val|var|while|with|yield)\b/,
        number: /\b0x(?:[\da-f]*\.)?[\da-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e\d+)?[dfl]?/i,
        builtin: /\b(?:Any|AnyRef|AnyVal|Boolean|Byte|Char|Double|Float|Int|Long|Nothing|Short|String|Unit)\b/,
        symbol: /'[^\d\s\\]\w*/
    });
    Prism.languages.insertBefore('scala', 'triple-quoted-string', {
        'string-interpolation': {
            pattern: /\b[a-z]\w*(?:"""(?:[^$]|\$(?:[^{]|\{(?:[^{}]|\{[^{}]*\})*\}))*?"""|"(?:[^$"\r\n]|\$(?:[^{]|\{(?:[^{}]|\{[^{}]*\})*\}))*")/i,
            greedy: true,
            inside: {
                id: {
                    pattern: /^\w+/,
                    greedy: true,
                    alias: 'function'
                },
                escape: {
                    pattern: /\\\$"|\$[$"]/,
                    greedy: true,
                    alias: 'symbol'
                },
                interpolation: {
                    pattern: /\$(?:\w+|\{(?:[^{}]|\{[^{}]*\})*\})/,
                    greedy: true,
                    inside: {
                        punctuation: /^\$\{?|\}$/,
                        expression: {
                            pattern: /[\s\S]+/,
                            inside: Prism.languages.scala
                        }
                    }
                },
                string: /[\s\S]+/
            }
        }
    });
    delete Prism.languages.scala['class-name'];
    delete Prism.languages.scala['function'];
    delete Prism.languages.scala['constant'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 


$988c0ef2629271f3$export$2e2bcd8739ae039.displayName = 'javadoc';
$988c0ef2629271f3$export$2e2bcd8739ae039.aliases = [];
function $988c0ef2629271f3$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $49817f5fa65142f2$export$2e2bcd8739ae039));
    Prism.register((0, $27318f6b523d68d5$export$2e2bcd8739ae039));
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    (function(Prism) {
        var codeLinePattern = /(^(?:[\t ]*(?:\*\s*)*))[^*\s].*$/m;
        var memberReference = /#\s*\w+(?:\s*\([^()]*\))?/.source;
        var reference = /(?:\b[a-zA-Z]\w+\s*\.\s*)*\b[A-Z]\w*(?:\s*<mem>)?|<mem>/.source.replace(/<mem>/g, function() {
            return memberReference;
        });
        Prism.languages.javadoc = Prism.languages.extend('javadoclike', {});
        Prism.languages.insertBefore('javadoc', 'keyword', {
            reference: {
                pattern: RegExp(/(@(?:exception|link|linkplain|see|throws|value)\s+(?:\*\s*)?)/.source + '(?:' + reference + ')'),
                lookbehind: true,
                inside: {
                    function: {
                        pattern: /(#\s*)\w+(?=\s*\()/,
                        lookbehind: true
                    },
                    field: {
                        pattern: /(#\s*)\w+/,
                        lookbehind: true
                    },
                    namespace: {
                        pattern: /\b(?:[a-z]\w*\s*\.\s*)+/,
                        inside: {
                            punctuation: /\./
                        }
                    },
                    'class-name': /\b[A-Z]\w*/,
                    keyword: Prism.languages.java.keyword,
                    punctuation: /[#()[\],.]/
                }
            },
            'class-name': {
                // @param <T> the first generic type parameter
                pattern: /(@param\s+)<[A-Z]\w*>/,
                lookbehind: true,
                inside: {
                    punctuation: /[.<>]/
                }
            },
            'code-section': [
                {
                    pattern: /(\{@code\s+(?!\s))(?:[^\s{}]|\s+(?![\s}])|\{(?:[^{}]|\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*\})+(?=\s*\})/,
                    lookbehind: true,
                    inside: {
                        code: {
                            // there can't be any HTML inside of {@code} tags
                            pattern: codeLinePattern,
                            lookbehind: true,
                            inside: Prism.languages.java,
                            alias: 'language-java'
                        }
                    }
                },
                {
                    pattern: /(<(code|pre|tt)>(?!<code>)\s*)\S(?:\S|\s+\S)*?(?=\s*<\/\2>)/,
                    lookbehind: true,
                    inside: {
                        line: {
                            pattern: codeLinePattern,
                            lookbehind: true,
                            inside: {
                                // highlight HTML tags and entities
                                tag: Prism.languages.markup.tag,
                                entity: Prism.languages.markup.entity,
                                code: {
                                    // everything else is Java code
                                    pattern: /.+/,
                                    inside: Prism.languages.java,
                                    alias: 'language-java'
                                }
                            }
                        }
                    }
                }
            ],
            tag: Prism.languages.markup.tag,
            entity: Prism.languages.markup.entity
        });
        Prism.languages.javadoclike.addSupport('java', Prism.languages.javadoc);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $cb363a9e19005aae$export$2e2bcd8739ae039.displayName = 'javastacktrace';
$cb363a9e19005aae$export$2e2bcd8739ae039.aliases = [];
function $cb363a9e19005aae$export$2e2bcd8739ae039(Prism) {
    // Specification:
    // https://docs.oracle.com/en/java/javase/13/docs/api/java.base/java/lang/Throwable.html#printStackTrace()
    Prism.languages.javastacktrace = {
        // java.sql.SQLException: Violation of unique constraint MY_ENTITY_UK_1: duplicate value(s) for column(s) MY_COLUMN in statement [...]
        // Caused by: java.sql.SQLException: Violation of unique constraint MY_ENTITY_UK_1: duplicate value(s) for column(s) MY_COLUMN in statement [...]
        // Caused by: com.example.myproject.MyProjectServletException
        // Caused by: MidLevelException: LowLevelException
        // Suppressed: Resource$CloseFailException: Resource ID = 0
        summary: {
            pattern: /^([\t ]*)(?:(?:Caused by:|Suppressed:|Exception in thread "[^"]*")[\t ]+)?[\w$.]+(?::.*)?$/m,
            lookbehind: true,
            inside: {
                keyword: {
                    pattern: /^([\t ]*)(?:(?:Caused by|Suppressed)(?=:)|Exception in thread)/m,
                    lookbehind: true
                },
                // the current thread if the summary starts with 'Exception in thread'
                string: {
                    pattern: /^(\s*)"[^"]*"/,
                    lookbehind: true
                },
                exceptions: {
                    pattern: /^(:?\s*)[\w$.]+(?=:|$)/,
                    lookbehind: true,
                    inside: {
                        'class-name': /[\w$]+$/,
                        namespace: /\b[a-z]\w*\b/,
                        punctuation: /\./
                    }
                },
                message: {
                    pattern: /(:\s*)\S.*/,
                    lookbehind: true,
                    alias: 'string'
                },
                punctuation: /:/
            }
        },
        // at org.mortbay.jetty.servlet.ServletHandler$CachedChain.doFilter(ServletHandler.java:1166)
        // at org.hsqldb.jdbc.Util.throwError(Unknown Source) here could be some notes
        // at java.base/java.lang.Class.forName0(Native Method)
        // at Util.<init>(Unknown Source)
        // at com.foo.loader/foo@9.0/com.foo.Main.run(Main.java:101)
        // at com.foo.loader//com.foo.bar.App.run(App.java:12)
        // at acme@2.1/org.acme.Lib.test(Lib.java:80)
        // at MyClass.mash(MyClass.java:9)
        //
        // More information:
        // https://docs.oracle.com/en/java/javase/13/docs/api/java.base/java/lang/StackTraceElement.html#toString()
        //
        // A valid Java module name is defined as:
        //   "A module name consists of one or more Java identifiers (§3.8) separated by "." tokens."
        // https://docs.oracle.com/javase/specs/jls/se9/html/jls-6.html#jls-ModuleName
        //
        // A Java module version is defined by this class:
        // https://docs.oracle.com/javase/9/docs/api/java/lang/module/ModuleDescriptor.Version.html
        // This is the implementation of the `parse` method in JDK13:
        // https://github.com/matcdac/jdk/blob/2305df71d1b7710266ae0956d73927a225132c0f/src/java.base/share/classes/java/lang/module/ModuleDescriptor.java#L1108
        // However, to keep this simple, a version will be matched by the pattern /@[\w$.+-]*/.
        'stack-frame': {
            pattern: /^([\t ]*)at (?:[\w$./]|@[\w$.+-]*\/)+(?:<init>)?\([^()]*\)/m,
            lookbehind: true,
            inside: {
                keyword: {
                    pattern: /^(\s*)at(?= )/,
                    lookbehind: true
                },
                source: [
                    // (Main.java:15)
                    // (Main.scala:15)
                    {
                        pattern: /(\()\w+\.\w+:\d+(?=\))/,
                        lookbehind: true,
                        inside: {
                            file: /^\w+\.\w+/,
                            punctuation: /:/,
                            'line-number': {
                                pattern: /\b\d+\b/,
                                alias: 'number'
                            }
                        }
                    },
                    // (Unknown Source)
                    // (Native Method)
                    // (...something...)
                    {
                        pattern: /(\()[^()]*(?=\))/,
                        lookbehind: true,
                        inside: {
                            keyword: /^(?:Native Method|Unknown Source)$/
                        }
                    }
                ],
                'class-name': /[\w$]+(?=\.(?:<init>|[\w$]+)\()/,
                function: /(?:<init>|[\w$]+)(?=\()/,
                'class-loader': {
                    pattern: /(\s)[a-z]\w*(?:\.[a-z]\w*)*(?=\/[\w@$.]*\/)/,
                    lookbehind: true,
                    alias: 'namespace',
                    inside: {
                        punctuation: /\./
                    }
                },
                module: {
                    pattern: /([\s/])[a-z]\w*(?:\.[a-z]\w*)*(?:@[\w$.+-]*)?(?=\/)/,
                    lookbehind: true,
                    inside: {
                        version: {
                            pattern: /(@)[\s\S]+/,
                            lookbehind: true,
                            alias: 'number'
                        },
                        punctuation: /[@.]/
                    }
                },
                namespace: {
                    pattern: /(?:\b[a-z]\w*\.)+/,
                    inside: {
                        punctuation: /\./
                    }
                },
                punctuation: /[()/.]/
            }
        },
        // ... 32 more
        // ... 32 common frames omitted
        more: {
            pattern: /^([\t ]*)\.{3} \d+ [a-z]+(?: [a-z]+)*/m,
            lookbehind: true,
            inside: {
                punctuation: /\.{3}/,
                number: /\d+/,
                keyword: /\b[a-z]+(?: [a-z]+)*\b/
            }
        }
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $49ed9aeb5a3777c3$export$2e2bcd8739ae039.displayName = 'jexl';
$49ed9aeb5a3777c3$export$2e2bcd8739ae039.aliases = [];
function $49ed9aeb5a3777c3$export$2e2bcd8739ae039(Prism) {
    Prism.languages.jexl = {
        string: /(["'])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
        transform: {
            pattern: /(\|\s*)[a-zA-Zа-яА-Я_\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$][\wа-яА-Я\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$]*/,
            alias: 'function',
            lookbehind: true
        },
        function: /[a-zA-Zа-яА-Я_\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$][\wа-яА-Я\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$]*\s*(?=\()/,
        number: /\b\d+(?:\.\d+)?\b|\B\.\d+\b/,
        operator: /[<>!]=?|-|\+|&&|==|\|\|?|\/\/?|[?:*^%]/,
        boolean: /\b(?:false|true)\b/,
        keyword: /\bin\b/,
        punctuation: /[{}[\](),.]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$23ae979d55503543$export$2e2bcd8739ae039.displayName = 'jolie';
$23ae979d55503543$export$2e2bcd8739ae039.aliases = [];
function $23ae979d55503543$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.jolie = Prism.languages.extend('clike', {
        string: {
            pattern: /(^|[^\\])"(?:\\[\s\S]|[^"\\])*"/,
            lookbehind: true,
            greedy: true
        },
        'class-name': {
            pattern: /((?:\b(?:as|courier|embed|in|inputPort|outputPort|service)\b|@)[ \t]*)\w+/,
            lookbehind: true
        },
        keyword: /\b(?:as|cH|comp|concurrent|constants|courier|cset|csets|default|define|else|embed|embedded|execution|exit|extender|for|foreach|forward|from|global|if|import|in|include|init|inputPort|install|instanceof|interface|is_defined|linkIn|linkOut|main|new|nullProcess|outputPort|over|private|provide|public|scope|sequential|service|single|spawn|synchronized|this|throw|throws|type|undef|until|while|with)\b/,
        function: /\b[a-z_]\w*(?=[ \t]*[@(])/i,
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?l?/i,
        operator: /-[-=>]?|\+[+=]?|<[<=]?|[>=*!]=?|&&|\|\||[?\/%^@|]/,
        punctuation: /[()[\]{},;.:]/,
        builtin: /\b(?:Byte|any|bool|char|double|enum|float|int|length|long|ranges|regex|string|undefined|void)\b/
    });
    Prism.languages.insertBefore('jolie', 'keyword', {
        aggregates: {
            pattern: /(\bAggregates\s*:\s*)(?:\w+(?:\s+with\s+\w+)?\s*,\s*)*\w+(?:\s+with\s+\w+)?/,
            lookbehind: true,
            inside: {
                keyword: /\bwith\b/,
                'class-name': /\w+/,
                punctuation: /,/
            }
        },
        redirects: {
            pattern: /(\bRedirects\s*:\s*)(?:\w+\s*=>\s*\w+\s*,\s*)*(?:\w+\s*=>\s*\w+)/,
            lookbehind: true,
            inside: {
                punctuation: /,/,
                'class-name': /\w+/,
                operator: /=>/
            }
        },
        property: {
            pattern: /\b(?:Aggregates|[Ii]nterfaces|Java|Javascript|Jolie|[Ll]ocation|OneWay|[Pp]rotocol|Redirects|RequestResponse)\b(?=[ \t]*:)/
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $8f95bc848ace76c7$export$2e2bcd8739ae039.displayName = 'jq';
$8f95bc848ace76c7$export$2e2bcd8739ae039.aliases = [];
function $8f95bc848ace76c7$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var interpolation = /\\\((?:[^()]|\([^()]*\))*\)/.source;
        var string = RegExp(/(^|[^\\])"(?:[^"\r\n\\]|\\[^\r\n(]|__)*"/.source.replace(/__/g, function() {
            return interpolation;
        }));
        var stringInterpolation = {
            interpolation: {
                pattern: RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + interpolation),
                lookbehind: true,
                inside: {
                    content: {
                        pattern: /^(\\\()[\s\S]+(?=\)$)/,
                        lookbehind: true,
                        inside: null // see below
                    },
                    punctuation: /^\\\(|\)$/
                }
            }
        };
        var jq = Prism.languages.jq = {
            comment: /#.*/,
            property: {
                pattern: RegExp(string.source + /(?=\s*:(?!:))/.source),
                lookbehind: true,
                greedy: true,
                inside: stringInterpolation
            },
            string: {
                pattern: string,
                lookbehind: true,
                greedy: true,
                inside: stringInterpolation
            },
            function: {
                pattern: /(\bdef\s+)[a-z_]\w+/i,
                lookbehind: true
            },
            variable: /\B\$\w+/,
            'property-literal': {
                pattern: /\b[a-z_]\w*(?=\s*:(?!:))/i,
                alias: 'property'
            },
            keyword: /\b(?:as|break|catch|def|elif|else|end|foreach|if|import|include|label|module|modulemeta|null|reduce|then|try|while)\b/,
            boolean: /\b(?:false|true)\b/,
            number: /(?:\b\d+\.|\B\.)?\b\d+(?:[eE][+-]?\d+)?\b/,
            operator: [
                {
                    pattern: /\|=?/,
                    alias: 'pipe'
                },
                /\.\.|[!=<>]?=|\?\/\/|\/\/=?|[-+*/%]=?|[<>?]|\b(?:and|not|or)\b/
            ],
            'c-style-function': {
                pattern: /\b[a-z_]\w*(?=\s*\()/i,
                alias: 'function'
            },
            punctuation: /::|[()\[\]{},:;]|\.(?=\s*[\[\w$])/,
            dot: {
                pattern: /\./,
                alias: 'important'
            }
        };
        stringInterpolation.interpolation.inside.content.inside = jq;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$b338b4b197bcd1b4$export$2e2bcd8739ae039.displayName = 'js-templates';
$b338b4b197bcd1b4$export$2e2bcd8739ae039.aliases = [];
function $b338b4b197bcd1b4$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
    (function(Prism) {
        var templateString = Prism.languages.javascript['template-string'];
        // see the pattern in prism-javascript.js
        var templateLiteralPattern = templateString.pattern.source;
        var interpolationObject = templateString.inside['interpolation'];
        var interpolationPunctuationObject = interpolationObject.inside['interpolation-punctuation'];
        var interpolationPattern = interpolationObject.pattern.source;
        /**
     * Creates a new pattern to match a template string with a special tag.
     *
     * This will return `undefined` if there is no grammar with the given language id.
     *
     * @param {string} language The language id of the embedded language. E.g. `markdown`.
     * @param {string} tag The regex pattern to match the tag.
     * @returns {object | undefined}
     * @example
     * createTemplate('css', /\bcss/.source);
     */ function createTemplate(language, tag) {
            if (!Prism.languages[language]) return undefined;
            return {
                pattern: RegExp('((?:' + tag + ')\\s*)' + templateLiteralPattern),
                lookbehind: true,
                greedy: true,
                inside: {
                    'template-punctuation': {
                        pattern: /^`|`$/,
                        alias: 'string'
                    },
                    'embedded-code': {
                        pattern: /[\s\S]+/,
                        alias: language
                    }
                }
            };
        }
        Prism.languages.javascript['template-string'] = [
            // styled-jsx:
            //   css`a { color: #25F; }`
            // styled-components:
            //   styled.h1`color: red;`
            createTemplate('css', /\b(?:styled(?:\([^)]*\))?(?:\s*\.\s*\w+(?:\([^)]*\))*)*|css(?:\s*\.\s*(?:global|resolve))?|createGlobalStyle|keyframes)/.source),
            // html`<p></p>`
            // div.innerHTML = `<p></p>`
            createTemplate('html', /\bhtml|\.\s*(?:inner|outer)HTML\s*\+?=/.source),
            // svg`<path fill="#fff" d="M55.37 ..."/>`
            createTemplate('svg', /\bsvg/.source),
            // md`# h1`, markdown`## h2`
            createTemplate('markdown', /\b(?:markdown|md)/.source),
            // gql`...`, graphql`...`, graphql.experimental`...`
            createTemplate('graphql', /\b(?:gql|graphql(?:\s*\.\s*experimental)?)/.source),
            // sql`...`
            createTemplate('sql', /\bsql/.source),
            // vanilla template string
            templateString
        ].filter(Boolean);
        /**
     * Returns a specific placeholder literal for the given language.
     *
     * @param {number} counter
     * @param {string} language
     * @returns {string}
     */ function getPlaceholder(counter, language) {
            return '___' + language.toUpperCase() + '_' + counter + '___';
        }
        /**
     * Returns the tokens of `Prism.tokenize` but also runs the `before-tokenize` and `after-tokenize` hooks.
     *
     * @param {string} code
     * @param {any} grammar
     * @param {string} language
     * @returns {(string|Token)[]}
     */ function tokenizeWithHooks(code, grammar, language) {
            var env = {
                code: code,
                grammar: grammar,
                language: language
            };
            Prism.hooks.run('before-tokenize', env);
            env.tokens = Prism.tokenize(env.code, env.grammar);
            Prism.hooks.run('after-tokenize', env);
            return env.tokens;
        }
        /**
     * Returns the token of the given JavaScript interpolation expression.
     *
     * @param {string} expression The code of the expression. E.g. `"${42}"`
     * @returns {Token}
     */ function tokenizeInterpolationExpression(expression) {
            var tempGrammar = {};
            tempGrammar['interpolation-punctuation'] = interpolationPunctuationObject;
            /** @type {Array} */ var tokens = Prism.tokenize(expression, tempGrammar);
            if (tokens.length === 3) {
                /**
         * The token array will look like this
         * [
         *     ["interpolation-punctuation", "${"]
         *     "..." // JavaScript expression of the interpolation
         *     ["interpolation-punctuation", "}"]
         * ]
         */ var args = [
                    1,
                    1
                ];
                args.push.apply(args, tokenizeWithHooks(tokens[1], Prism.languages.javascript, 'javascript'));
                tokens.splice.apply(tokens, args);
            }
            return new Prism.Token('interpolation', tokens, interpolationObject.alias, expression);
        }
        /**
     * Tokenizes the given code with support for JavaScript interpolation expressions mixed in.
     *
     * This function has 3 phases:
     *
     * 1. Replace all JavaScript interpolation expression with a placeholder.
     *    The placeholder will have the syntax of a identify of the target language.
     * 2. Tokenize the code with placeholders.
     * 3. Tokenize the interpolation expressions and re-insert them into the tokenize code.
     *    The insertion only works if a placeholder hasn't been "ripped apart" meaning that the placeholder has been
     *    tokenized as two tokens by the grammar of the embedded language.
     *
     * @param {string} code
     * @param {object} grammar
     * @param {string} language
     * @returns {Token}
     */ function tokenizeEmbedded(code, grammar, language) {
            // 1. First filter out all interpolations
            // because they might be escaped, we need a lookbehind, so we use Prism
            /** @type {(Token|string)[]} */ var _tokens = Prism.tokenize(code, {
                interpolation: {
                    pattern: RegExp(interpolationPattern),
                    lookbehind: true
                }
            });
            // replace all interpolations with a placeholder which is not in the code already
            var placeholderCounter = 0;
            /** @type {Object<string, string>} */ var placeholderMap = {};
            var embeddedCode = _tokens.map(function(token) {
                if (typeof token === 'string') return token;
                else {
                    var interpolationExpression = token.content;
                    var placeholder;
                    while(code.indexOf(placeholder = getPlaceholder(placeholderCounter++, language)) !== -1);
                    placeholderMap[placeholder] = interpolationExpression;
                    return placeholder;
                }
            }).join('');
            // 2. Tokenize the embedded code
            var embeddedTokens = tokenizeWithHooks(embeddedCode, grammar, language);
            // 3. Re-insert the interpolation
            var placeholders = Object.keys(placeholderMap);
            placeholderCounter = 0;
            /**
       *
       * @param {(Token|string)[]} tokens
       * @returns {void}
       */ function walkTokens(tokens) {
                for(var i = 0; i < tokens.length; i++){
                    if (placeholderCounter >= placeholders.length) return;
                    var token = tokens[i];
                    if (typeof token === 'string' || typeof token.content === 'string') {
                        var placeholder = placeholders[placeholderCounter];
                        var s = typeof token === 'string' ? token : /** @type {string} */ token.content;
                        var index = s.indexOf(placeholder);
                        if (index !== -1) {
                            ++placeholderCounter;
                            var before = s.substring(0, index);
                            var middle = tokenizeInterpolationExpression(placeholderMap[placeholder]);
                            var after = s.substring(index + placeholder.length);
                            var replacement = [];
                            if (before) replacement.push(before);
                            replacement.push(middle);
                            if (after) {
                                var afterTokens = [
                                    after
                                ];
                                walkTokens(afterTokens);
                                replacement.push.apply(replacement, afterTokens);
                            }
                            if (typeof token === 'string') {
                                tokens.splice.apply(tokens, [
                                    i,
                                    1
                                ].concat(replacement));
                                i += replacement.length - 1;
                            } else token.content = replacement;
                        }
                    } else {
                        var content = token.content;
                        if (Array.isArray(content)) walkTokens(content);
                        else walkTokens([
                            content
                        ]);
                    }
                }
            }
            walkTokens(embeddedTokens);
            return new Prism.Token(language, embeddedTokens, 'language-' + language, code);
        }
        /**
     * The languages for which JS templating will handle tagged template literals.
     *
     * JS templating isn't active for only JavaScript but also related languages like TypeScript, JSX, and TSX.
     */ var supportedLanguages = {
            javascript: true,
            js: true,
            typescript: true,
            ts: true,
            jsx: true,
            tsx: true
        };
        Prism.hooks.add('after-tokenize', function(env) {
            if (!(env.language in supportedLanguages)) return;
            /**
       * Finds and tokenizes all template strings with an embedded languages.
       *
       * @param {(Token | string)[]} tokens
       * @returns {void}
       */ function findTemplateStrings(tokens) {
                for(var i = 0, l = tokens.length; i < l; i++){
                    var token = tokens[i];
                    if (typeof token === 'string') continue;
                    var content = token.content;
                    if (!Array.isArray(content)) {
                        if (typeof content !== 'string') findTemplateStrings([
                            content
                        ]);
                        continue;
                    }
                    if (token.type === 'template-string') {
                        /**
             * A JavaScript template-string token will look like this:
             *
             * ["template-string", [
             *     ["template-punctuation", "`"],
             *     (
             *         An array of "string" and "interpolation" tokens. This is the simple string case.
             *         or
             *         ["embedded-code", "..."] This is the token containing the embedded code.
             *                                  It also has an alias which is the language of the embedded code.
             *     ),
             *     ["template-punctuation", "`"]
             * ]]
             */ var embedded = content[1];
                        if (content.length === 3 && typeof embedded !== 'string' && embedded.type === 'embedded-code') {
                            // get string content
                            var code = stringContent(embedded);
                            var alias = embedded.alias;
                            var language = Array.isArray(alias) ? alias[0] : alias;
                            var grammar = Prism.languages[language];
                            if (!grammar) continue;
                            content[1] = tokenizeEmbedded(code, grammar, language);
                        }
                    } else findTemplateStrings(content);
                }
            }
            findTemplateStrings(env.tokens);
        });
        /**
     * Returns the string content of a token or token stream.
     *
     * @param {string | Token | (string | Token)[]} value
     * @returns {string}
     */ function stringContent(value) {
            if (typeof value === 'string') return value;
            else if (Array.isArray(value)) return value.map(stringContent).join('');
            else return stringContent(value.content);
        }
    })(Prism);
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 


$bf3c2cf9e7b7e15b$export$2e2bcd8739ae039.displayName = 'jsdoc';
$bf3c2cf9e7b7e15b$export$2e2bcd8739ae039.aliases = [];
function $bf3c2cf9e7b7e15b$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $27318f6b523d68d5$export$2e2bcd8739ae039));
    Prism.register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
    Prism.register((0, $010d7940936c67fb$export$2e2bcd8739ae039));
    (function(Prism) {
        var javascript = Prism.languages.javascript;
        var type = /\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})+\}/.source;
        var parameterPrefix = '(@(?:arg|argument|param|property)\\s+(?:' + type + '\\s+)?)';
        Prism.languages.jsdoc = Prism.languages.extend('javadoclike', {
            parameter: {
                // @param {string} foo - foo bar
                pattern: RegExp(parameterPrefix + /(?:(?!\s)[$\w\xA0-\uFFFF.])+(?=\s|$)/.source),
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            }
        });
        Prism.languages.insertBefore('jsdoc', 'keyword', {
            'optional-parameter': {
                // @param {string} [baz.foo="bar"] foo bar
                pattern: RegExp(parameterPrefix + /\[(?:(?!\s)[$\w\xA0-\uFFFF.])+(?:=[^[\]]+)?\](?=\s|$)/.source),
                lookbehind: true,
                inside: {
                    parameter: {
                        pattern: /(^\[)[$\w\xA0-\uFFFF\.]+/,
                        lookbehind: true,
                        inside: {
                            punctuation: /\./
                        }
                    },
                    code: {
                        pattern: /(=)[\s\S]*(?=\]$)/,
                        lookbehind: true,
                        inside: javascript,
                        alias: 'language-javascript'
                    },
                    punctuation: /[=[\]]/
                }
            },
            'class-name': [
                {
                    pattern: RegExp(/(@(?:augments|class|extends|interface|memberof!?|template|this|typedef)\s+(?:<TYPE>\s+)?)[A-Z]\w*(?:\.[A-Z]\w*)*/.source.replace(/<TYPE>/g, function() {
                        return type;
                    })),
                    lookbehind: true,
                    inside: {
                        punctuation: /\./
                    }
                },
                {
                    pattern: RegExp('(@[a-z]+\\s+)' + type),
                    lookbehind: true,
                    inside: {
                        string: javascript.string,
                        number: javascript.number,
                        boolean: javascript.boolean,
                        keyword: Prism.languages.typescript.keyword,
                        operator: /=>|\.\.\.|[&|?:*]/,
                        punctuation: /[.,;=<>{}()[\]]/
                    }
                }
            ],
            example: {
                pattern: /(@example\s+(?!\s))(?:[^@\s]|\s+(?!\s))+?(?=\s*(?:\*\s*)?(?:@\w|\*\/))/,
                lookbehind: true,
                inside: {
                    code: {
                        pattern: /^([\t ]*(?:\*\s*)?)\S.*$/m,
                        lookbehind: true,
                        inside: javascript,
                        alias: 'language-javascript'
                    }
                }
            }
        });
        Prism.languages.javadoclike.addSupport('javascript', Prism.languages.jsdoc);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$a236d89746bc105c$export$2e2bcd8739ae039.displayName = 'n4js';
$a236d89746bc105c$export$2e2bcd8739ae039.aliases = [
    'n4jsd'
];
function $a236d89746bc105c$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
    Prism.languages.n4js = Prism.languages.extend('javascript', {
        // Keywords from N4JS language spec: https://numberfour.github.io/n4js/spec/N4JSSpec.html
        keyword: /\b(?:Array|any|boolean|break|case|catch|class|const|constructor|continue|debugger|declare|default|delete|do|else|enum|export|extends|false|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|module|new|null|number|package|private|protected|public|return|set|static|string|super|switch|this|throw|true|try|typeof|var|void|while|with|yield)\b/
    });
    Prism.languages.insertBefore('n4js', 'constant', {
        // Annotations in N4JS spec: https://numberfour.github.io/n4js/spec/N4JSSpec.html#_annotations
        annotation: {
            pattern: /@+\w+/,
            alias: 'operator'
        }
    });
    Prism.languages.n4jsd = Prism.languages.n4js;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$964a8a24221af55b$export$2e2bcd8739ae039.displayName = 'js-extras';
$964a8a24221af55b$export$2e2bcd8739ae039.aliases = [];
function $964a8a24221af55b$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.insertBefore('javascript', 'function-variable', {
            'method-variable': {
                pattern: RegExp('(\\.\\s*)' + Prism.languages.javascript['function-variable'].pattern.source),
                lookbehind: true,
                alias: [
                    'function-variable',
                    'method',
                    'function',
                    'property-access'
                ]
            }
        });
        Prism.languages.insertBefore('javascript', 'function', {
            method: {
                pattern: RegExp('(\\.\\s*)' + Prism.languages.javascript['function'].source),
                lookbehind: true,
                alias: [
                    'function',
                    'property-access'
                ]
            }
        });
        Prism.languages.insertBefore('javascript', 'constant', {
            'known-class-name': [
                {
                    // standard built-ins
                    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects
                    pattern: /\b(?:(?:Float(?:32|64)|(?:Int|Uint)(?:8|16|32)|Uint8Clamped)?Array|ArrayBuffer|BigInt|Boolean|DataView|Date|Error|Function|Intl|JSON|(?:Weak)?(?:Map|Set)|Math|Number|Object|Promise|Proxy|Reflect|RegExp|String|Symbol|WebAssembly)\b/,
                    alias: 'class-name'
                },
                {
                    // errors
                    pattern: /\b(?:[A-Z]\w*)Error\b/,
                    alias: 'class-name'
                }
            ]
        });
        /**
     * Replaces the `<ID>` placeholder in the given pattern with a pattern for general JS identifiers.
     *
     * @param {string} source
     * @param {string} [flags]
     * @returns {RegExp}
     */ function withId(source, flags) {
            return RegExp(source.replace(/<ID>/g, function() {
                return /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/.source;
            }), flags);
        }
        Prism.languages.insertBefore('javascript', 'keyword', {
            imports: {
                // https://tc39.es/ecma262/#sec-imports
                pattern: withId(/(\bimport\b\s*)(?:<ID>(?:\s*,\s*(?:\*\s*as\s+<ID>|\{[^{}]*\}))?|\*\s*as\s+<ID>|\{[^{}]*\})(?=\s*\bfrom\b)/.source),
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            exports: {
                // https://tc39.es/ecma262/#sec-exports
                pattern: withId(/(\bexport\b\s*)(?:\*(?:\s*as\s+<ID>)?(?=\s*\bfrom\b)|\{[^{}]*\})/.source),
                lookbehind: true,
                inside: Prism.languages.javascript
            }
        });
        Prism.languages.javascript['keyword'].unshift({
            pattern: /\b(?:as|default|export|from|import)\b/,
            alias: 'module'
        }, {
            pattern: /\b(?:await|break|catch|continue|do|else|finally|for|if|return|switch|throw|try|while|yield)\b/,
            alias: 'control-flow'
        }, {
            pattern: /\bnull\b/,
            alias: [
                'null',
                'nil'
            ]
        }, {
            pattern: /\bundefined\b/,
            alias: 'nil'
        });
        Prism.languages.insertBefore('javascript', 'operator', {
            spread: {
                pattern: /\.{3}/,
                alias: 'operator'
            },
            arrow: {
                pattern: /=>/,
                alias: 'operator'
            }
        });
        Prism.languages.insertBefore('javascript', 'punctuation', {
            'property-access': {
                pattern: withId(/(\.\s*)#?<ID>/.source),
                lookbehind: true
            },
            'maybe-class-name': {
                pattern: /(^|[^$\w\xA0-\uFFFF])[A-Z][$\w\xA0-\uFFFF]+/,
                lookbehind: true
            },
            dom: {
                // this contains only a few commonly used DOM variables
                pattern: /\b(?:document|(?:local|session)Storage|location|navigator|performance|window)\b/,
                alias: 'variable'
            },
            console: {
                pattern: /\bconsole(?=\s*\.)/,
                alias: 'class-name'
            }
        });
        // add 'maybe-class-name' to tokens which might be a class name
        var maybeClassNameTokens = [
            'function',
            'function-variable',
            'method',
            'method-variable',
            'property-access'
        ];
        for(var i = 0; i < maybeClassNameTokens.length; i++){
            var token = maybeClassNameTokens[i];
            var value = Prism.languages.javascript[token];
            // convert regex to object
            if (Prism.util.type(value) === 'RegExp') value = Prism.languages.javascript[token] = {
                pattern: value
            };
            // keep in mind that we don't support arrays
            var inside = value.inside || {};
            value.inside = inside;
            inside['maybe-class-name'] = /^[A-Z][\s\S]*/;
        }
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$1ea37e5c47d5707d$export$2e2bcd8739ae039.displayName = 'json5';
$1ea37e5c47d5707d$export$2e2bcd8739ae039.aliases = [];
function $1ea37e5c47d5707d$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7ca1ade36c00114f$export$2e2bcd8739ae039));
    (function(Prism) {
        var string = /("|')(?:\\(?:\r\n?|\n|.)|(?!\1)[^\\\r\n])*\1/;
        Prism.languages.json5 = Prism.languages.extend('json', {
            property: [
                {
                    pattern: RegExp(string.source + '(?=\\s*:)'),
                    greedy: true
                },
                {
                    pattern: /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/,
                    alias: 'unquoted'
                }
            ],
            string: {
                pattern: string,
                greedy: true
            },
            number: /[+-]?\b(?:NaN|Infinity|0x[a-fA-F\d]+)\b|[+-]?(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+\b)?/
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$94086998b35689c5$export$2e2bcd8739ae039.displayName = 'jsonp';
$94086998b35689c5$export$2e2bcd8739ae039.aliases = [];
function $94086998b35689c5$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7ca1ade36c00114f$export$2e2bcd8739ae039));
    Prism.languages.jsonp = Prism.languages.extend('json', {
        punctuation: /[{}[\]();,.]/
    });
    Prism.languages.insertBefore('jsonp', 'punctuation', {
        function: /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*\()/
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $5b076416d0eabdf4$export$2e2bcd8739ae039.displayName = 'jsstacktrace';
$5b076416d0eabdf4$export$2e2bcd8739ae039.aliases = [];
function $5b076416d0eabdf4$export$2e2bcd8739ae039(Prism) {
    Prism.languages.jsstacktrace = {
        'error-message': {
            pattern: /^\S.*/m,
            alias: 'string'
        },
        'stack-frame': {
            pattern: /(^[ \t]+)at[ \t].*/m,
            lookbehind: true,
            inside: {
                'not-my-code': {
                    pattern: /^at[ \t]+(?!\s)(?:node\.js|<unknown>|.*(?:node_modules|\(<anonymous>\)|\(<unknown>|<anonymous>$|\(internal\/|\(node\.js)).*/m,
                    alias: 'comment'
                },
                filename: {
                    pattern: /(\bat\s+(?!\s)|\()(?:[a-zA-Z]:)?[^():]+(?=:)/,
                    lookbehind: true,
                    alias: 'url'
                },
                function: {
                    pattern: /(\bat\s+(?:new\s+)?)(?!\s)[_$a-zA-Z\xA0-\uFFFF<][.$\w\xA0-\uFFFF<>]*/,
                    lookbehind: true,
                    inside: {
                        punctuation: /\./
                    }
                },
                punctuation: /[()]/,
                keyword: /\b(?:at|new)\b/,
                alias: {
                    pattern: /\[(?:as\s+)?(?!\s)[_$a-zA-Z\xA0-\uFFFF][$\w\xA0-\uFFFF]*\]/,
                    alias: 'variable'
                },
                'line-number': {
                    pattern: /:\d+(?::\d+)?\b/,
                    alias: 'number',
                    inside: {
                        punctuation: /:/
                    }
                }
            }
        }
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $cfc1afd3507a91b5$export$2e2bcd8739ae039.displayName = 'julia';
$cfc1afd3507a91b5$export$2e2bcd8739ae039.aliases = [];
function $cfc1afd3507a91b5$export$2e2bcd8739ae039(Prism) {
    Prism.languages.julia = {
        comment: {
            // support one level of nested comments
            // https://github.com/JuliaLang/julia/pull/6128
            pattern: /(^|[^\\])(?:#=(?:[^#=]|=(?!#)|#(?!=)|#=(?:[^#=]|=(?!#)|#(?!=))*=#)*=#|#.*)/,
            lookbehind: true
        },
        regex: {
            // https://docs.julialang.org/en/v1/manual/strings/#Regular-Expressions-1
            pattern: /r"(?:\\.|[^"\\\r\n])*"[imsx]{0,4}/,
            greedy: true
        },
        string: {
            // https://docs.julialang.org/en/v1/manual/strings/#String-Basics-1
            // https://docs.julialang.org/en/v1/manual/strings/#non-standard-string-literals-1
            // https://docs.julialang.org/en/v1/manual/running-external-programs/#Running-External-Programs-1
            pattern: /"""[\s\S]+?"""|(?:\b\w+)?"(?:\\.|[^"\\\r\n])*"|`(?:[^\\`\r\n]|\\.)*`/,
            greedy: true
        },
        char: {
            // https://docs.julialang.org/en/v1/manual/strings/#man-characters-1
            pattern: /(^|[^\w'])'(?:\\[^\r\n][^'\r\n]*|[^\\\r\n])'/,
            lookbehind: true,
            greedy: true
        },
        keyword: /\b(?:abstract|baremodule|begin|bitstype|break|catch|ccall|const|continue|do|else|elseif|end|export|finally|for|function|global|if|immutable|import|importall|in|let|local|macro|module|print|println|quote|return|struct|try|type|typealias|using|while)\b/,
        boolean: /\b(?:false|true)\b/,
        number: /(?:\b(?=\d)|\B(?=\.))(?:0[box])?(?:[\da-f]+(?:_[\da-f]+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[efp][+-]?\d+(?:_\d+)*)?j?/i,
        // https://docs.julialang.org/en/v1/manual/mathematical-operations/
        // https://docs.julialang.org/en/v1/manual/mathematical-operations/#Operator-Precedence-and-Associativity-1
        operator: /&&|\|\||[-+*^%÷⊻&$\\]=?|\/[\/=]?|!=?=?|\|[=>]?|<(?:<=?|[=:|])?|>(?:=|>>?=?)?|==?=?|[~≠≤≥'√∛]/,
        punctuation: /::?|[{}[\]();,.?]/,
        // https://docs.julialang.org/en/v1/base/numbers/#Base.im
        constant: /\b(?:(?:Inf|NaN)(?:16|32|64)?|im|pi)\b|[πℯ]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $350499ec8fbf9130$export$2e2bcd8739ae039.displayName = 'keepalived';
$350499ec8fbf9130$export$2e2bcd8739ae039.aliases = [];
function $350499ec8fbf9130$export$2e2bcd8739ae039(Prism) {
    Prism.languages.keepalived = {
        comment: {
            pattern: /[#!].*/,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/,
            lookbehind: true,
            greedy: true
        },
        // support IPv4, IPv6, subnet mask
        ip: {
            pattern: RegExp(/\b(?:(?:(?:[\da-f]{1,4}:){7}[\da-f]{1,4}|(?:[\da-f]{1,4}:){6}:[\da-f]{1,4}|(?:[\da-f]{1,4}:){5}:(?:[\da-f]{1,4}:)?[\da-f]{1,4}|(?:[\da-f]{1,4}:){4}:(?:[\da-f]{1,4}:){0,2}[\da-f]{1,4}|(?:[\da-f]{1,4}:){3}:(?:[\da-f]{1,4}:){0,3}[\da-f]{1,4}|(?:[\da-f]{1,4}:){2}:(?:[\da-f]{1,4}:){0,4}[\da-f]{1,4}|(?:[\da-f]{1,4}:){6}<ipv4>|(?:[\da-f]{1,4}:){0,5}:<ipv4>|::(?:[\da-f]{1,4}:){0,5}<ipv4>|[\da-f]{1,4}::(?:[\da-f]{1,4}:){0,5}[\da-f]{1,4}|::(?:[\da-f]{1,4}:){0,6}[\da-f]{1,4}|(?:[\da-f]{1,4}:){1,7}:)(?:\/\d{1,3})?|<ipv4>(?:\/\d{1,2})?)\b/.source.replace(/<ipv4>/g, function() {
                return /(?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d))/.source;
            }), 'i'),
            alias: 'number'
        },
        // support *nix / Windows, directory / file
        path: {
            pattern: /(\s)\/(?:[^\/\s]+\/)*[^\/\s]*|\b[a-zA-Z]:\\(?:[^\\\s]+\\)*[^\\\s]*/,
            lookbehind: true,
            alias: 'string'
        },
        variable: /\$\{?\w+\}?/,
        email: {
            pattern: /[\w-]+@[\w-]+(?:\.[\w-]{2,3}){1,2}/,
            alias: 'string'
        },
        'conditional-configuration': {
            pattern: /@\^?[\w-]+/,
            alias: 'variable'
        },
        operator: /=/,
        property: /\b(?:BFD_CHECK|DNS_CHECK|FILE_CHECK|HTTP_GET|MISC_CHECK|NAME|PING_CHECK|SCRIPTS|SMTP_CHECK|SSL|SSL_GET|TCP_CHECK|UDP_CHECK|accept|advert_int|alpha|auth_pass|auth_type|authentication|bfd_cpu_affinity|bfd_instance|bfd_no_swap|bfd_priority|bfd_process_name|bfd_rlimit_rttime|bfd_rt_priority|bind_if|bind_port|bindto|ca|certificate|check_unicast_src|checker|checker_cpu_affinity|checker_log_all_failures|checker_no_swap|checker_priority|checker_rlimit_rttime|checker_rt_priority|child_wait_time|connect_ip|connect_port|connect_timeout|dbus_service_name|debug|default_interface|delay|delay_before_retry|delay_loop|digest|dont_track_primary|dynamic|dynamic_interfaces|enable_(?:dbus|script_security|sni|snmp_checker|snmp_rfc|snmp_rfcv2|snmp_rfcv3|snmp_vrrp|traps)|end|fall|fast_recovery|file|flag-[123]|fork_delay|full_command|fwmark|garp_group|garp_interval|garp_lower_prio_delay|garp_lower_prio_repeat|garp_master_delay|garp_master_refresh|garp_master_refresh_repeat|garp_master_repeat|global_defs|global_tracking|gna_interval|group|ha_suspend|hashed|helo_name|higher_prio_send_advert|hoplimit|http_protocol|hysteresis|idle_tx|include|inhibit_on_failure|init_fail|init_file|instance|interface|interfaces|interval|ip_family|ipvs_process_name|keepalived.conf|kernel_rx_buf_size|key|linkbeat_interfaces|linkbeat_use_polling|log_all_failures|log_unknown_vrids|lower_prio_no_advert|lthreshold|lvs_flush|lvs_flush_onstop|lvs_method|lvs_netlink_cmd_rcv_bufs|lvs_netlink_cmd_rcv_bufs_force|lvs_netlink_monitor_rcv_bufs|lvs_netlink_monitor_rcv_bufs_force|lvs_notify_fifo|lvs_notify_fifo_script|lvs_sched|lvs_sync_daemon|max_auto_priority|max_hops|mcast_src_ip|mh-fallback|mh-port|min_auto_priority_delay|min_rx|min_tx|misc_dynamic|misc_path|misc_timeout|multiplier|name|namespace_with_ipsets|native_ipv6|neighbor_ip|net_namespace|net_namespace_ipvs|nftables|nftables_counters|nftables_ifindex|nftables_priority|no_accept|no_checker_emails|no_email_faults|nopreempt|notification_email|notification_email_from|notify|notify_backup|notify_deleted|notify_down|notify_fault|notify_fifo|notify_fifo_script|notify_master|notify_master_rx_lower_pri|notify_priority_changes|notify_stop|notify_up|old_unicast_checksum|omega|ops|param_match|passive|password|path|persistence_engine|persistence_granularity|persistence_timeout|preempt|preempt_delay|priority|process|process_monitor_rcv_bufs|process_monitor_rcv_bufs_force|process_name|process_names|promote_secondaries|protocol|proxy_arp|proxy_arp_pvlan|quorum|quorum_down|quorum_max|quorum_up|random_seed|real_server|regex|regex_max_offset|regex_min_offset|regex_no_match|regex_options|regex_stack|reload_repeat|reload_time_file|require_reply|retry|rise|router_id|rs_init_notifies|script|script_user|sh-fallback|sh-port|shutdown_script|shutdown_script_timeout|skip_check_adv_addr|smtp_alert|smtp_alert_checker|smtp_alert_vrrp|smtp_connect_timeout|smtp_helo_name|smtp_server|snmp_socket|sorry_server|sorry_server_inhibit|sorry_server_lvs_method|source_ip|start|startup_script|startup_script_timeout|state|static_ipaddress|static_routes|static_rules|status_code|step|strict_mode|sync_group_tracking_weight|terminate_delay|timeout|track_bfd|track_file|track_group|track_interface|track_process|track_script|track_src_ip|ttl|type|umask|unicast_peer|unicast_src_ip|unicast_ttl|url|use_ipvlan|use_pid_dir|use_vmac|user|uthreshold|val[123]|version|virtual_ipaddress|virtual_ipaddress_excluded|virtual_router_id|virtual_routes|virtual_rules|virtual_server|virtual_server_group|virtualhost|vmac_xmit_base|vrrp|vrrp_(?:check_unicast_src|cpu_affinity|garp_interval|garp_lower_prio_delay|garp_lower_prio_repeat|garp_master_delay|garp_master_refresh|garp_master_refresh_repeat|garp_master_repeat|gna_interval|higher_prio_send_advert|instance|ipsets|iptables|lower_prio_no_advert|mcast_group4|mcast_group6|min_garp|netlink_cmd_rcv_bufs|netlink_cmd_rcv_bufs_force|netlink_monitor_rcv_bufs|netlink_monitor_rcv_bufs_force|no_swap|notify_fifo|notify_fifo_script|notify_priority_changes|priority|process_name|rlimit_rttime|rt_priority|rx_bufs_multiplier|rx_bufs_policy|script|skip_check_adv_addr|startup_delay|strict|sync_group|track_process|version)|warmup|weight)\b/,
        constant: /\b(?:A|AAAA|AH|BACKUP|CNAME|DR|MASTER|MX|NAT|NS|PASS|SCTP|SOA|TCP|TUN|TXT|UDP|dh|fo|lblc|lblcr|lc|mh|nq|ovf|rr|sed|sh|wlc|wrr)\b/,
        number: {
            pattern: /(^|[^\w.-])-?\d+(?:\.\d+)?/,
            lookbehind: true
        },
        boolean: /\b(?:false|no|off|on|true|yes)\b/,
        punctuation: /[\{\}]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $d1947654b0468835$export$2e2bcd8739ae039.displayName = 'keyman';
$d1947654b0468835$export$2e2bcd8739ae039.aliases = [];
function $d1947654b0468835$export$2e2bcd8739ae039(Prism) {
    Prism.languages.keyman = {
        comment: {
            pattern: /\bc .*/i,
            greedy: true
        },
        string: {
            pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
            greedy: true
        },
        'virtual-key': {
            pattern: /\[\s*(?:(?:ALT|CAPS|CTRL|LALT|LCTRL|NCAPS|RALT|RCTRL|SHIFT)\s+)*(?:[TKU]_[\w?]+|[A-E]\d\d?|"[^"\r\n]*"|'[^'\r\n]*')\s*\]/i,
            greedy: true,
            alias: 'function' // alias for styles
        },
        // https://help.keyman.com/developer/language/guide/headers
        'header-keyword': {
            pattern: /&\w+/,
            alias: 'bold' // alias for styles
        },
        'header-statement': {
            pattern: /\b(?:bitmap|bitmaps|caps always off|caps on only|copyright|hotkey|language|layout|message|name|shift frees caps|version)\b/i,
            alias: 'bold' // alias for styles
        },
        'rule-keyword': {
            pattern: /\b(?:any|baselayout|beep|call|context|deadkey|dk|if|index|layer|notany|nul|outs|platform|reset|return|save|set|store|use)\b/i,
            alias: 'keyword'
        },
        'structural-keyword': {
            pattern: /\b(?:ansi|begin|group|match|newcontext|nomatch|postkeystroke|readonly|unicode|using keys)\b/i,
            alias: 'keyword'
        },
        'compile-target': {
            pattern: /\$(?:keyman|keymanonly|keymanweb|kmfl|weaver):/i,
            alias: 'property'
        },
        // U+####, x###, d### characters and numbers
        number: /\b(?:U\+[\dA-F]+|d\d+|x[\da-f]+|\d+)\b/i,
        operator: /[+>\\$]|\.\./,
        punctuation: /[()=,]/
    };
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $5796ea4f5c719733$export$2e2bcd8739ae039.displayName = 'kumir';
$5796ea4f5c719733$export$2e2bcd8739ae039.aliases = [
    'kum'
];
function $5796ea4f5c719733$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        /**
     * Regular expression for characters that are not allowed in identifiers.
     *
     * @type {string}
     */ var nonId = /\s\x00-\x1f\x22-\x2f\x3a-\x3f\x5b-\x5e\x60\x7b-\x7e/.source;
        /**
     * Surround a regular expression for IDs with patterns for non-ID sequences.
     *
     * @param {string} pattern A regular expression for identifiers.
     * @param {string} [flags] The regular expression flags.
     * @returns {RegExp} A wrapped regular expression for identifiers.
     */ function wrapId(pattern, flags) {
            return RegExp(pattern.replace(/<nonId>/g, nonId), flags);
        }
        Prism.languages.kumir = {
            comment: {
                pattern: /\|.*/
            },
            prolog: {
                pattern: /#.*/,
                greedy: true
            },
            string: {
                pattern: /"[^\n\r"]*"|'[^\n\r']*'/,
                greedy: true
            },
            boolean: {
                pattern: wrapId(/(^|[<nonId>])(?:да|нет)(?=[<nonId>]|$)/.source),
                lookbehind: true
            },
            'operator-word': {
                pattern: wrapId(/(^|[<nonId>])(?:и|или|не)(?=[<nonId>]|$)/.source),
                lookbehind: true,
                alias: 'keyword'
            },
            'system-variable': {
                pattern: wrapId(/(^|[<nonId>])знач(?=[<nonId>]|$)/.source),
                lookbehind: true,
                alias: 'keyword'
            },
            type: [
                {
                    pattern: wrapId(/(^|[<nonId>])(?:вещ|лит|лог|сим|цел)(?:\x20*таб)?(?=[<nonId>]|$)/.source),
                    lookbehind: true,
                    alias: 'builtin'
                },
                {
                    pattern: wrapId(/(^|[<nonId>])(?:компл|сканкод|файл|цвет)(?=[<nonId>]|$)/.source),
                    lookbehind: true,
                    alias: 'important'
                }
            ],
            /**
       * Should be performed after searching for type names because of "таб".
       * "таб" is a reserved word, but never used without a preceding type name.
       * "НАЗНАЧИТЬ", "Фввод", and "Фвывод" are not reserved words.
       */ keyword: {
                pattern: wrapId(/(^|[<nonId>])(?:алг|арг(?:\x20*рез)?|ввод|ВКЛЮЧИТЬ|вс[её]|выбор|вывод|выход|дано|для|до|дс|если|иначе|исп|использовать|кон(?:(?:\x20+|_)исп)?|кц(?:(?:\x20+|_)при)?|надо|нач|нс|нц|от|пауза|пока|при|раза?|рез|стоп|таб|то|утв|шаг)(?=[<nonId>]|$)/.source),
                lookbehind: true
            },
            /** Should be performed after searching for reserved words. */ name: {
                // eslint-disable-next-line regexp/no-super-linear-backtracking
                pattern: wrapId(/(^|[<nonId>])[^\d<nonId>][^<nonId>]*(?:\x20+[^<nonId>]+)*(?=[<nonId>]|$)/.source),
                lookbehind: true
            },
            /** Should be performed after searching for names. */ number: {
                pattern: wrapId(/(^|[<nonId>])(?:\B\$[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)(?=[<nonId>]|$)/.source, 'i'),
                lookbehind: true
            },
            /** Should be performed after searching for words. */ punctuation: /:=|[(),:;\[\]]/,
            /**
       * Should be performed after searching for
       * - numeric constants (because of "+" and "-");
       * - punctuation marks (because of ":=" and "=").
       */ 'operator-char': {
                pattern: /\*\*?|<[=>]?|>=?|[-+/=]/,
                alias: 'operator'
            }
        };
        Prism.languages.kum = Prism.languages.kumir;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $c3d8d532e557e2f4$export$2e2bcd8739ae039.displayName = 'kusto';
$c3d8d532e557e2f4$export$2e2bcd8739ae039.aliases = [];
function $c3d8d532e557e2f4$export$2e2bcd8739ae039(Prism) {
    Prism.languages.kusto = {
        comment: {
            pattern: /\/\/.*/,
            greedy: true
        },
        string: {
            pattern: /```[\s\S]*?```|[hH]?(?:"(?:[^\r\n\\"]|\\.)*"|'(?:[^\r\n\\']|\\.)*'|@(?:"[^\r\n"]*"|'[^\r\n']*'))/,
            greedy: true
        },
        verb: {
            pattern: /(\|\s*)[a-z][\w-]*/i,
            lookbehind: true,
            alias: 'keyword'
        },
        command: {
            pattern: /\.[a-z][a-z\d-]*\b/,
            alias: 'keyword'
        },
        'class-name': /\b(?:bool|datetime|decimal|dynamic|guid|int|long|real|string|timespan)\b/,
        keyword: /\b(?:access|alias|and|anti|as|asc|auto|between|by|(?:contains|(?:ends|starts)with|has(?:perfix|suffix)?)(?:_cs)?|database|declare|desc|external|from|fullouter|has_all|in|ingestion|inline|inner|innerunique|into|(?:left|right)(?:anti(?:semi)?|inner|outer|semi)?|let|like|local|not|of|on|or|pattern|print|query_parameters|range|restrict|schema|set|step|table|tables|to|view|where|with|matches\s+regex|nulls\s+(?:first|last))(?![\w-])/,
        boolean: /\b(?:false|null|true)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/,
        datetime: [
            {
                // RFC 822 + RFC 850
                pattern: /\b(?:(?:Fri|Friday|Mon|Monday|Sat|Saturday|Sun|Sunday|Thu|Thursday|Tue|Tuesday|Wed|Wednesday)\s*,\s*)?\d{1,2}(?:\s+|-)(?:Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)(?:\s+|-)\d{2}\s+\d{2}:\d{2}(?::\d{2})?(?:\s*(?:\b(?:[A-Z]|(?:[ECMT][DS]|GM|U)T)|[+-]\d{4}))?\b/,
                alias: 'number'
            },
            {
                // ISO 8601
                pattern: /[+-]?\b(?:\d{4}-\d{2}-\d{2}(?:[ T]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)?|\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)Z?/,
                alias: 'number'
            }
        ],
        number: /\b(?:0x[0-9A-Fa-f]+|\d+(?:\.\d+)?(?:[Ee][+-]?\d+)?)(?:(?:min|sec|[mnµ]s|[dhms]|microsecond|tick)\b)?|[+-]?\binf\b/,
        operator: /=>|[!=]~|[!=<>]=?|[-+*/%|]|\.\./,
        punctuation: /[()\[\]{},;.:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $f13c2598f5dc8663$export$2e2bcd8739ae039.displayName = 'latex';
$f13c2598f5dc8663$export$2e2bcd8739ae039.aliases = [
    'context',
    'tex'
];
function $f13c2598f5dc8663$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var funcPattern = /\\(?:[^a-z()[\]]|[a-z*]+)/i;
        var insideEqu = {
            'equation-command': {
                pattern: funcPattern,
                alias: 'regex'
            }
        };
        Prism.languages.latex = {
            comment: /%.*/,
            // the verbatim environment prints whitespace to the document
            cdata: {
                pattern: /(\\begin\{((?:lstlisting|verbatim)\*?)\})[\s\S]*?(?=\\end\{\2\})/,
                lookbehind: true
            },
            /*
       * equations can be between $$ $$ or $ $ or \( \) or \[ \]
       * (all are multiline)
       */ equation: [
                {
                    pattern: /\$\$(?:\\[\s\S]|[^\\$])+\$\$|\$(?:\\[\s\S]|[^\\$])+\$|\\\([\s\S]*?\\\)|\\\[[\s\S]*?\\\]/,
                    inside: insideEqu,
                    alias: 'string'
                },
                {
                    pattern: /(\\begin\{((?:align|eqnarray|equation|gather|math|multline)\*?)\})[\s\S]*?(?=\\end\{\2\})/,
                    lookbehind: true,
                    inside: insideEqu,
                    alias: 'string'
                }
            ],
            /*
       * arguments which are keywords or references are highlighted
       * as keywords
       */ keyword: {
                pattern: /(\\(?:begin|cite|documentclass|end|label|ref|usepackage)(?:\[[^\]]+\])?\{)[^}]+(?=\})/,
                lookbehind: true
            },
            url: {
                pattern: /(\\url\{)[^}]+(?=\})/,
                lookbehind: true
            },
            /*
       * section or chapter headlines are highlighted as bold so that
       * they stand out more
       */ headline: {
                pattern: /(\\(?:chapter|frametitle|paragraph|part|section|subparagraph|subsection|subsubparagraph|subsubsection|subsubsubparagraph)\*?(?:\[[^\]]+\])?\{)[^}]+(?=\})/,
                lookbehind: true,
                alias: 'class-name'
            },
            function: {
                pattern: funcPattern,
                alias: 'selector'
            },
            punctuation: /[[\]{}&]/
        };
        Prism.languages.tex = Prism.languages.latex;
        Prism.languages.context = Prism.languages.latex;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 


$c8196ec3df0cee5b$export$2e2bcd8739ae039.displayName = 'latte';
$c8196ec3df0cee5b$export$2e2bcd8739ae039.aliases = [];
function $c8196ec3df0cee5b$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
    Prism.register((0, $8a2c8b738cd1f636$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.latte = {
            comment: /^\{\*[\s\S]*/,
            'latte-tag': {
                // https://latte.nette.org/en/tags
                pattern: /(^\{(?:\/(?=[a-z]))?)(?:[=_]|[a-z]\w*\b(?!\())/i,
                lookbehind: true,
                alias: 'important'
            },
            delimiter: {
                pattern: /^\{\/?|\}$/,
                alias: 'punctuation'
            },
            php: {
                pattern: /\S(?:[\s\S]*\S)?/,
                alias: 'language-php',
                inside: Prism.languages.php
            }
        };
        var markupLatte = Prism.languages.extend('markup', {});
        Prism.languages.insertBefore('inside', 'attr-value', {
            'n-attr': {
                pattern: /n:[\w-]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+))?/,
                inside: {
                    'attr-name': {
                        pattern: /^[^\s=]+/,
                        alias: 'important'
                    },
                    'attr-value': {
                        pattern: /=[\s\S]+/,
                        inside: {
                            punctuation: [
                                /^=/,
                                {
                                    pattern: /^(\s*)["']|["']$/,
                                    lookbehind: true
                                }
                            ],
                            php: {
                                pattern: /\S(?:[\s\S]*\S)?/,
                                inside: Prism.languages.php
                            }
                        }
                    }
                }
            }
        }, markupLatte.tag);
        Prism.hooks.add('before-tokenize', function(env) {
            if (env.language !== 'latte') return;
            var lattePattern = /\{\*[\s\S]*?\*\}|\{[^'"\s{}*](?:[^"'/{}]|\/(?![*/])|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|\/\*(?:[^*]|\*(?!\/))*\*\/)*\}/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'latte', lattePattern);
            env.grammar = markupLatte;
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'latte');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $f15bc5f7f9ab760a$export$2e2bcd8739ae039.displayName = 'scheme';
$f15bc5f7f9ab760a$export$2e2bcd8739ae039.aliases = [];
function $f15bc5f7f9ab760a$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.scheme = {
            // this supports "normal" single-line comments:
            //   ; comment
            // and (potentially nested) multiline comments:
            //   #| comment #| nested |# still comment |#
            // (only 1 level of nesting is supported)
            comment: /;.*|#;\s*(?:\((?:[^()]|\([^()]*\))*\)|\[(?:[^\[\]]|\[[^\[\]]*\])*\])|#\|(?:[^#|]|#(?!\|)|\|(?!#)|#\|(?:[^#|]|#(?!\|)|\|(?!#))*\|#)*\|#/,
            string: {
                pattern: /"(?:[^"\\]|\\.)*"/,
                greedy: true
            },
            symbol: {
                pattern: /'[^()\[\]#'\s]+/,
                greedy: true
            },
            char: {
                pattern: /#\\(?:[ux][a-fA-F\d]+\b|[-a-zA-Z]+\b|[\uD800-\uDBFF][\uDC00-\uDFFF]|\S)/,
                greedy: true
            },
            'lambda-parameter': [
                // https://www.cs.cmu.edu/Groups/AI/html/r4rs/r4rs_6.html#SEC30
                {
                    pattern: /((?:^|[^'`#])[(\[]lambda\s+)(?:[^|()\[\]'\s]+|\|(?:[^\\|]|\\.)*\|)/,
                    lookbehind: true
                },
                {
                    pattern: /((?:^|[^'`#])[(\[]lambda\s+[(\[])[^()\[\]']+/,
                    lookbehind: true
                }
            ],
            keyword: {
                pattern: /((?:^|[^'`#])[(\[])(?:begin|case(?:-lambda)?|cond(?:-expand)?|define(?:-library|-macro|-record-type|-syntax|-values)?|defmacro|delay(?:-force)?|do|else|except|export|guard|if|import|include(?:-ci|-library-declarations)?|lambda|let(?:rec)?(?:-syntax|-values|\*)?|let\*-values|only|parameterize|prefix|(?:quasi-?)?quote|rename|set!|syntax-(?:case|rules)|unless|unquote(?:-splicing)?|when)(?=[()\[\]\s]|$)/,
                lookbehind: true
            },
            builtin: {
                // all functions of the base library of R7RS plus some of built-ins of R5Rs
                pattern: /((?:^|[^'`#])[(\[])(?:abs|and|append|apply|assoc|ass[qv]|binary-port\?|boolean=?\?|bytevector(?:-append|-copy|-copy!|-length|-u8-ref|-u8-set!|\?)?|caar|cadr|call-with-(?:current-continuation|port|values)|call\/cc|car|cdar|cddr|cdr|ceiling|char(?:->integer|-ready\?|\?|<\?|<=\?|=\?|>\?|>=\?)|close-(?:input-port|output-port|port)|complex\?|cons|current-(?:error|input|output)-port|denominator|dynamic-wind|eof-object\??|eq\?|equal\?|eqv\?|error|error-object(?:-irritants|-message|\?)|eval|even\?|exact(?:-integer-sqrt|-integer\?|\?)?|expt|features|file-error\?|floor(?:-quotient|-remainder|\/)?|flush-output-port|for-each|gcd|get-output-(?:bytevector|string)|inexact\??|input-port(?:-open\?|\?)|integer(?:->char|\?)|lcm|length|list(?:->string|->vector|-copy|-ref|-set!|-tail|\?)?|make-(?:bytevector|list|parameter|string|vector)|map|max|member|memq|memv|min|modulo|negative\?|newline|not|null\?|number(?:->string|\?)|numerator|odd\?|open-(?:input|output)-(?:bytevector|string)|or|output-port(?:-open\?|\?)|pair\?|peek-char|peek-u8|port\?|positive\?|procedure\?|quotient|raise|raise-continuable|rational\?|rationalize|read-(?:bytevector|bytevector!|char|error\?|line|string|u8)|real\?|remainder|reverse|round|set-c[ad]r!|square|string(?:->list|->number|->symbol|->utf8|->vector|-append|-copy|-copy!|-fill!|-for-each|-length|-map|-ref|-set!|\?|<\?|<=\?|=\?|>\?|>=\?)?|substring|symbol(?:->string|\?|=\?)|syntax-error|textual-port\?|truncate(?:-quotient|-remainder|\/)?|u8-ready\?|utf8->string|values|vector(?:->list|->string|-append|-copy|-copy!|-fill!|-for-each|-length|-map|-ref|-set!|\?)?|with-exception-handler|write-(?:bytevector|char|string|u8)|zero\?)(?=[()\[\]\s]|$)/,
                lookbehind: true
            },
            operator: {
                pattern: /((?:^|[^'`#])[(\[])(?:[-+*%/]|[<>]=?|=>?)(?=[()\[\]\s]|$)/,
                lookbehind: true
            },
            number: {
                // The number pattern from [the R7RS spec](https://small.r7rs.org/attachment/r7rs.pdf).
                //
                // <number>      := <num 2>|<num 8>|<num 10>|<num 16>
                // <num R>       := <prefix R><complex R>
                // <complex R>   := <real R>(?:@<real R>|<imaginary R>)?|<imaginary R>
                // <imaginary R> := [+-](?:<ureal R>|(?:inf|nan)\.0)?i
                // <real R>      := [+-]?<ureal R>|[+-](?:inf|nan)\.0
                // <ureal R>     := <uint R>(?:\/<uint R>)?
                //                | <decimal R>
                //
                // <decimal 10>  := (?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?
                // <uint R>      := <digit R>+
                // <prefix R>    := <radix R>(?:#[ei])?|(?:#[ei])?<radix R>
                // <radix 2>     := #b
                // <radix 8>     := #o
                // <radix 10>    := (?:#d)?
                // <radix 16>    := #x
                // <digit 2>     := [01]
                // <digit 8>     := [0-7]
                // <digit 10>    := \d
                // <digit 16>    := [0-9a-f]
                //
                // The problem with this grammar is that the resulting regex is way to complex, so we simplify by grouping all
                // non-decimal bases together. This results in a decimal (dec) and combined binary, octal, and hexadecimal (box)
                // pattern:
                pattern: RegExp(SortedBNF({
                    '<ureal dec>': /\d+(?:\/\d+)|(?:\d+(?:\.\d*)?|\.\d+)(?:[esfdl][+-]?\d+)?/.source,
                    '<real dec>': /[+-]?<ureal dec>|[+-](?:inf|nan)\.0/.source,
                    '<imaginary dec>': /[+-](?:<ureal dec>|(?:inf|nan)\.0)?i/.source,
                    '<complex dec>': /<real dec>(?:@<real dec>|<imaginary dec>)?|<imaginary dec>/.source,
                    '<num dec>': /(?:#d(?:#[ei])?|#[ei](?:#d)?)?<complex dec>/.source,
                    '<ureal box>': /[0-9a-f]+(?:\/[0-9a-f]+)?/.source,
                    '<real box>': /[+-]?<ureal box>|[+-](?:inf|nan)\.0/.source,
                    '<imaginary box>': /[+-](?:<ureal box>|(?:inf|nan)\.0)?i/.source,
                    '<complex box>': /<real box>(?:@<real box>|<imaginary box>)?|<imaginary box>/.source,
                    '<num box>': /#[box](?:#[ei])?|(?:#[ei])?#[box]<complex box>/.source,
                    '<number>': /(^|[()\[\]\s])(?:<num dec>|<num box>)(?=[()\[\]\s]|$)/.source
                }), 'i'),
                lookbehind: true
            },
            boolean: {
                pattern: /(^|[()\[\]\s])#(?:[ft]|false|true)(?=[()\[\]\s]|$)/,
                lookbehind: true
            },
            function: {
                pattern: /((?:^|[^'`#])[(\[])(?:[^|()\[\]'\s]+|\|(?:[^\\|]|\\.)*\|)(?=[()\[\]\s]|$)/,
                lookbehind: true
            },
            identifier: {
                pattern: /(^|[()\[\]\s])\|(?:[^\\|]|\\.)*\|(?=[()\[\]\s]|$)/,
                lookbehind: true,
                greedy: true
            },
            punctuation: /[()\[\]']/
        };
        /**
     * Given a topologically sorted BNF grammar, this will return the RegExp source of last rule of the grammar.
     *
     * @param {Record<string, string>} grammar
     * @returns {string}
     */ function SortedBNF(grammar) {
            for(var key in grammar)grammar[key] = grammar[key].replace(/<[\w\s]+>/g, function(key) {
                return '(?:' + grammar[key].trim() + ')';
            });
            // return the last item
            return grammar[key];
        }
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$dff85ed6bfabe21a$export$2e2bcd8739ae039.displayName = 'lilypond';
$dff85ed6bfabe21a$export$2e2bcd8739ae039.aliases = [
    'ly'
];
function $dff85ed6bfabe21a$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f15bc5f7f9ab760a$export$2e2bcd8739ae039));
    (function(Prism) {
        var schemeExpression = /\((?:[^();"#\\]|\\[\s\S]|;.*(?!.)|"(?:[^"\\]|\\.)*"|#(?:\{(?:(?!#\})[\s\S])*#\}|[^{])|<expr>)*\)/.source;
        // allow for up to pow(2, recursivenessLog2) many levels of recursive brace expressions
        // For some reason, this can't be 4
        var recursivenessLog2 = 5;
        for(var i = 0; i < recursivenessLog2; i++)schemeExpression = schemeExpression.replace(/<expr>/g, function() {
            return schemeExpression;
        });
        schemeExpression = schemeExpression.replace(/<expr>/g, /[^\s\S]/.source);
        var lilypond = Prism.languages.lilypond = {
            comment: /%(?:(?!\{).*|\{[\s\S]*?%\})/,
            'embedded-scheme': {
                pattern: RegExp(/(^|[=\s])#(?:"(?:[^"\\]|\\.)*"|[^\s()"]*(?:[^\s()]|<expr>))/.source.replace(/<expr>/g, function() {
                    return schemeExpression;
                }), 'm'),
                lookbehind: true,
                greedy: true,
                inside: {
                    scheme: {
                        pattern: /^(#)[\s\S]+$/,
                        lookbehind: true,
                        alias: 'language-scheme',
                        inside: {
                            'embedded-lilypond': {
                                pattern: /#\{[\s\S]*?#\}/,
                                greedy: true,
                                inside: {
                                    punctuation: /^#\{|#\}$/,
                                    lilypond: {
                                        pattern: /[\s\S]+/,
                                        alias: 'language-lilypond',
                                        inside: null // see below
                                    }
                                }
                            },
                            rest: Prism.languages.scheme
                        }
                    },
                    punctuation: /#/
                }
            },
            string: {
                pattern: /"(?:[^"\\]|\\.)*"/,
                greedy: true
            },
            'class-name': {
                pattern: /(\\new\s+)[\w-]+/,
                lookbehind: true
            },
            keyword: {
                pattern: /\\[a-z][-\w]*/i,
                inside: {
                    punctuation: /^\\/
                }
            },
            operator: /[=|]|<<|>>/,
            punctuation: {
                pattern: /(^|[a-z\d])(?:'+|,+|[_^]?-[_^]?(?:[-+^!>._]|(?=\d))|[_^]\.?|[.!])|[{}()[\]<>^~]|\\[()[\]<>\\!]|--|__/,
                lookbehind: true
            },
            number: /\b\d+(?:\/\d+)?\b/
        };
        lilypond['embedded-scheme'].inside['scheme'].inside['embedded-lilypond'].inside['lilypond'].inside = lilypond;
        Prism.languages.ly = lilypond;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$0ebb485d13184e81$export$2e2bcd8739ae039.displayName = 'liquid';
$0ebb485d13184e81$export$2e2bcd8739ae039.aliases = [];
function $0ebb485d13184e81$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
    Prism.languages.liquid = {
        comment: {
            pattern: /(^\{%\s*comment\s*%\})[\s\S]+(?=\{%\s*endcomment\s*%\}$)/,
            lookbehind: true
        },
        delimiter: {
            pattern: /^\{(?:\{\{|[%\{])-?|-?(?:\}\}|[%\}])\}$/,
            alias: 'punctuation'
        },
        string: {
            pattern: /"[^"]*"|'[^']*'/,
            greedy: true
        },
        keyword: /\b(?:as|assign|break|(?:end)?(?:capture|case|comment|for|form|if|paginate|raw|style|tablerow|unless)|continue|cycle|decrement|echo|else|elsif|in|include|increment|limit|liquid|offset|range|render|reversed|section|when|with)\b/,
        object: /\b(?:address|all_country_option_tags|article|block|blog|cart|checkout|collection|color|country|country_option_tags|currency|current_page|current_tags|customer|customer_address|date|discount_allocation|discount_application|external_video|filter|filter_value|font|forloop|fulfillment|generic_file|gift_card|group|handle|image|line_item|link|linklist|localization|location|measurement|media|metafield|model|model_source|order|page|page_description|page_image|page_title|part|policy|product|product_option|recommendations|request|robots|routes|rule|script|search|selling_plan|selling_plan_allocation|selling_plan_group|shipping_method|shop|shop_locale|sitemap|store_availability|tax_line|template|theme|transaction|unit_price_measurement|user_agent|variant|video|video_source)\b/,
        function: [
            {
                pattern: /(\|\s*)\w+/,
                lookbehind: true,
                alias: 'filter'
            },
            {
                // array functions
                pattern: /(\.\s*)(?:first|last|size)/,
                lookbehind: true
            }
        ],
        boolean: /\b(?:false|nil|true)\b/,
        range: {
            pattern: /\.\./,
            alias: 'operator'
        },
        // https://github.com/Shopify/liquid/blob/698f5e0d967423e013f6169d9111bd969bd78337/lib/liquid/lexer.rb#L21
        number: /\b\d+(?:\.\d+)?\b/,
        operator: /[!=]=|<>|[<>]=?|[|?:=-]|\b(?:and|contains(?=\s)|or)\b/,
        punctuation: /[.,\[\]()]/,
        empty: {
            pattern: /\bempty\b/,
            alias: 'keyword'
        }
    };
    Prism.hooks.add('before-tokenize', function(env) {
        var liquidPattern = /\{%\s*comment\s*%\}[\s\S]*?\{%\s*endcomment\s*%\}|\{(?:%[\s\S]*?%|\{\{[\s\S]*?\}\}|\{[\s\S]*?\})\}/g;
        var insideRaw = false;
        Prism.languages['markup-templating'].buildPlaceholders(env, 'liquid', liquidPattern, function(match) {
            var tagMatch = /^\{%-?\s*(\w+)/.exec(match);
            if (tagMatch) {
                var tag = tagMatch[1];
                if (tag === 'raw' && !insideRaw) {
                    insideRaw = true;
                    return true;
                } else if (tag === 'endraw') {
                    insideRaw = false;
                    return true;
                }
            }
            return !insideRaw;
        });
    });
    Prism.hooks.add('after-tokenize', function(env) {
        Prism.languages['markup-templating'].tokenizePlaceholders(env, 'liquid');
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $59e22f64646db583$export$2e2bcd8739ae039.displayName = 'lisp';
$59e22f64646db583$export$2e2bcd8739ae039.aliases = [
    'elisp',
    'emacs',
    'emacs-lisp'
];
function $59e22f64646db583$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        /**
     * Functions to construct regular expressions
     * e.g. (interactive ... or (interactive)
     *
     * @param {string} name
     * @returns {RegExp}
     */ function simple_form(name) {
            return RegExp(/(\()/.source + '(?:' + name + ')' + /(?=[\s\)])/.source);
        }
        /**
     * booleans and numbers
     *
     * @param {string} pattern
     * @returns {RegExp}
     */ function primitive(pattern) {
            return RegExp(/([\s([])/.source + '(?:' + pattern + ')' + /(?=[\s)])/.source);
        }
        // Patterns in regular expressions
        // Symbol name. See https://www.gnu.org/software/emacs/manual/html_node/elisp/Symbol-Type.html
        // & and : are excluded as they are usually used for special purposes
        var symbol = /(?!\d)[-+*/~!@$%^=<>{}\w]+/.source;
        // symbol starting with & used in function arguments
        var marker = '&' + symbol;
        // Open parenthesis for look-behind
        var par = '(\\()';
        var endpar = '(?=\\))';
        // End the pattern with look-ahead space
        var space = '(?=\\s)';
        var nestedPar = /(?:[^()]|\((?:[^()]|\((?:[^()]|\((?:[^()]|\((?:[^()]|\([^()]*\))*\))*\))*\))*\))*/.source;
        var language = {
            // Three or four semicolons are considered a heading.
            // See https://www.gnu.org/software/emacs/manual/html_node/elisp/Comment-Tips.html
            heading: {
                pattern: /;;;.*/,
                alias: [
                    'comment',
                    'title'
                ]
            },
            comment: /;.*/,
            string: {
                pattern: /"(?:[^"\\]|\\.)*"/,
                greedy: true,
                inside: {
                    argument: /[-A-Z]+(?=[.,\s])/,
                    symbol: RegExp('`' + symbol + "'")
                }
            },
            'quoted-symbol': {
                pattern: RegExp("#?'" + symbol),
                alias: [
                    'variable',
                    'symbol'
                ]
            },
            'lisp-property': {
                pattern: RegExp(':' + symbol),
                alias: 'property'
            },
            splice: {
                pattern: RegExp(',@?' + symbol),
                alias: [
                    'symbol',
                    'variable'
                ]
            },
            keyword: [
                {
                    pattern: RegExp(par + '(?:and|(?:cl-)?letf|cl-loop|cond|cons|error|if|(?:lexical-)?let\\*?|message|not|null|or|provide|require|setq|unless|use-package|when|while)' + space),
                    lookbehind: true
                },
                {
                    pattern: RegExp(par + '(?:append|by|collect|concat|do|finally|for|in|return)' + space),
                    lookbehind: true
                }
            ],
            declare: {
                pattern: simple_form(/declare/.source),
                lookbehind: true,
                alias: 'keyword'
            },
            interactive: {
                pattern: simple_form(/interactive/.source),
                lookbehind: true,
                alias: 'keyword'
            },
            boolean: {
                pattern: primitive(/nil|t/.source),
                lookbehind: true
            },
            number: {
                pattern: primitive(/[-+]?\d+(?:\.\d*)?/.source),
                lookbehind: true
            },
            defvar: {
                pattern: RegExp(par + 'def(?:const|custom|group|var)\\s+' + symbol),
                lookbehind: true,
                inside: {
                    keyword: /^def[a-z]+/,
                    variable: RegExp(symbol)
                }
            },
            defun: {
                pattern: RegExp(par + /(?:cl-)?(?:defmacro|defun\*?)\s+/.source + symbol + /\s+\(/.source + nestedPar + /\)/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    keyword: /^(?:cl-)?def\S+/,
                    // See below, this property needs to be defined later so that it can
                    // reference the language object.
                    arguments: null,
                    function: {
                        pattern: RegExp('(^\\s)' + symbol),
                        lookbehind: true
                    },
                    punctuation: /[()]/
                }
            },
            lambda: {
                pattern: RegExp(par + 'lambda\\s+\\(\\s*(?:&?' + symbol + '(?:\\s+&?' + symbol + ')*\\s*)?\\)'),
                lookbehind: true,
                greedy: true,
                inside: {
                    keyword: /^lambda/,
                    // See below, this property needs to be defined later so that it can
                    // reference the language object.
                    arguments: null,
                    punctuation: /[()]/
                }
            },
            car: {
                pattern: RegExp(par + symbol),
                lookbehind: true
            },
            punctuation: [
                // open paren, brackets, and close paren
                /(?:['`,]?\(|[)\[\]])/,
                // cons
                {
                    pattern: /(\s)\.(?=\s)/,
                    lookbehind: true
                }
            ]
        };
        var arg = {
            'lisp-marker': RegExp(marker),
            varform: {
                pattern: RegExp(/\(/.source + symbol + /\s+(?=\S)/.source + nestedPar + /\)/.source),
                inside: language
            },
            argument: {
                pattern: RegExp(/(^|[\s(])/.source + symbol),
                lookbehind: true,
                alias: 'variable'
            },
            rest: language
        };
        var forms = '\\S+(?:\\s+\\S+)*';
        var arglist = {
            pattern: RegExp(par + nestedPar + endpar),
            lookbehind: true,
            inside: {
                'rest-vars': {
                    pattern: RegExp('&(?:body|rest)\\s+' + forms),
                    inside: arg
                },
                'other-marker-vars': {
                    pattern: RegExp('&(?:aux|optional)\\s+' + forms),
                    inside: arg
                },
                keys: {
                    pattern: RegExp('&key\\s+' + forms + '(?:\\s+&allow-other-keys)?'),
                    inside: arg
                },
                argument: {
                    pattern: RegExp(symbol),
                    alias: 'variable'
                },
                punctuation: /[()]/
            }
        };
        language['lambda'].inside.arguments = arglist;
        language['defun'].inside.arguments = Prism.util.clone(arglist);
        language['defun'].inside.arguments.inside.sublist = arglist;
        Prism.languages.lisp = language;
        Prism.languages.elisp = language;
        Prism.languages.emacs = language;
        Prism.languages['emacs-lisp'] = language;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $fb1869ae2e02698d$export$2e2bcd8739ae039.displayName = 'livescript';
$fb1869ae2e02698d$export$2e2bcd8739ae039.aliases = [];
function $fb1869ae2e02698d$export$2e2bcd8739ae039(Prism) {
    Prism.languages.livescript = {
        comment: [
            {
                pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
                lookbehind: true
            },
            {
                pattern: /(^|[^\\])#.*/,
                lookbehind: true
            }
        ],
        'interpolated-string': {
            /* Look-behind and look-ahead prevents wrong behavior of the greedy pattern
       * forcing it to match """-quoted string when it would otherwise match "-quoted first. */ pattern: /(^|[^"])("""|")(?:\\[\s\S]|(?!\2)[^\\])*\2(?!")/,
            lookbehind: true,
            greedy: true,
            inside: {
                variable: {
                    pattern: /(^|[^\\])#[a-z_](?:-?[a-z]|[\d_])*/m,
                    lookbehind: true
                },
                interpolation: {
                    pattern: /(^|[^\\])#\{[^}]+\}/m,
                    lookbehind: true,
                    inside: {
                        'interpolation-punctuation': {
                            pattern: /^#\{|\}$/,
                            alias: 'variable'
                        }
                    }
                },
                string: /[\s\S]+/
            }
        },
        string: [
            {
                pattern: /('''|')(?:\\[\s\S]|(?!\1)[^\\])*\1/,
                greedy: true
            },
            {
                pattern: /<\[[\s\S]*?\]>/,
                greedy: true
            },
            /\\[^\s,;\])}]+/
        ],
        regex: [
            {
                pattern: /\/\/(?:\[[^\r\n\]]*\]|\\.|(?!\/\/)[^\\\[])+\/\/[gimyu]{0,5}/,
                greedy: true,
                inside: {
                    comment: {
                        pattern: /(^|[^\\])#.*/,
                        lookbehind: true
                    }
                }
            },
            {
                pattern: /\/(?:\[[^\r\n\]]*\]|\\.|[^/\\\r\n\[])+\/[gimyu]{0,5}/,
                greedy: true
            }
        ],
        keyword: {
            pattern: /(^|(?!-).)\b(?:break|case|catch|class|const|continue|default|do|else|extends|fallthrough|finally|for(?: ever)?|function|if|implements|it|let|loop|new|null|otherwise|own|return|super|switch|that|then|this|throw|try|unless|until|var|void|when|while|yield)(?!-)\b/m,
            lookbehind: true
        },
        'keyword-operator': {
            pattern: /(^|[^-])\b(?:(?:delete|require|typeof)!|(?:and|by|delete|export|from|import(?: all)?|in|instanceof|is(?: not|nt)?|not|of|or|til|to|typeof|with|xor)(?!-)\b)/m,
            lookbehind: true,
            alias: 'operator'
        },
        boolean: {
            pattern: /(^|[^-])\b(?:false|no|off|on|true|yes)(?!-)\b/m,
            lookbehind: true
        },
        argument: {
            // Don't match .&. nor &&
            pattern: /(^|(?!\.&\.)[^&])&(?!&)\d*/m,
            lookbehind: true,
            alias: 'variable'
        },
        number: /\b(?:\d+~[\da-z]+|\d[\d_]*(?:\.\d[\d_]*)?(?:[a-z]\w*)?)/i,
        identifier: /[a-z_](?:-?[a-z]|[\d_])*/i,
        operator: [
            // Spaced .
            {
                pattern: /( )\.(?= )/,
                lookbehind: true
            },
            // Full list, in order:
            // .= .~ .. ...
            // .&. .^. .<<. .>>. .>>>.
            // := :: ::=
            // &&
            // || |>
            // < << <<< <<<<
            // <- <-- <-! <--!
            // <~ <~~ <~! <~~!
            // <| <= <?
            // > >> >= >?
            // - -- -> -->
            // + ++
            // @ @@
            // % %%
            // * **
            // ! != !~=
            // !~> !~~>
            // !-> !-->
            // ~ ~> ~~> ~=
            // = ==
            // ^ ^^
            // / ?
            /\.(?:[=~]|\.\.?)|\.(?:[&|^]|<<|>>>?)\.|:(?:=|:=?)|&&|\|[|>]|<(?:<<?<?|--?!?|~~?!?|[|=?])?|>[>=?]?|-(?:->?|>)?|\+\+?|@@?|%%?|\*\*?|!(?:~?=|--?>|~?~>)?|~(?:~?>|=)?|==?|\^\^?|[\/?]/
        ],
        punctuation: /[(){}\[\]|.,:;`]/
    };
    Prism.languages.livescript['interpolated-string'].inside['interpolation'].inside.rest = Prism.languages.livescript;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $b6a0f971cc211856$export$2e2bcd8739ae039.displayName = 'llvm';
$b6a0f971cc211856$export$2e2bcd8739ae039.aliases = [];
function $b6a0f971cc211856$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.llvm = {
            comment: /;.*/,
            string: {
                pattern: /"[^"]*"/,
                greedy: true
            },
            boolean: /\b(?:false|true)\b/,
            variable: /[%@!#](?:(?!\d)(?:[-$.\w]|\\[a-f\d]{2})+|\d+)/i,
            label: /(?!\d)(?:[-$.\w]|\\[a-f\d]{2})+:/i,
            type: {
                pattern: /\b(?:double|float|fp128|half|i[1-9]\d*|label|metadata|ppc_fp128|token|void|x86_fp80|x86_mmx)\b/,
                alias: 'class-name'
            },
            keyword: /\b[a-z_][a-z_0-9]*\b/,
            number: /[+-]?\b\d+(?:\.\d+)?(?:[eE][+-]?\d+)?\b|\b0x[\dA-Fa-f]+\b|\b0xK[\dA-Fa-f]{20}\b|\b0x[ML][\dA-Fa-f]{32}\b|\b0xH[\dA-Fa-f]{4}\b/,
            punctuation: /[{}[\];(),.!*=<>]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $0ce2bbca25db411c$export$2e2bcd8739ae039.displayName = 'log';
$0ce2bbca25db411c$export$2e2bcd8739ae039.aliases = [];
function $0ce2bbca25db411c$export$2e2bcd8739ae039(Prism) {
    // This is a language definition for generic log files.
    // Since there is no one log format, this language definition has to support all formats to some degree.
    //
    // Based on https://github.com/MTDL9/vim-log-highlighting
    Prism.languages.log = {
        string: {
            // Single-quoted strings must not be confused with plain text. E.g. Can't isn't Susan's Chris' toy
            pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?![st] | \w)(?:[^'\\\r\n]|\\.)*'/,
            greedy: true
        },
        exception: {
            pattern: /(^|[^\w.])[a-z][\w.]*(?:Error|Exception):.*(?:(?:\r\n?|\n)[ \t]*(?:at[ \t].+|\.{3}.*|Caused by:.*))+(?:(?:\r\n?|\n)[ \t]*\.\.\. .*)?/,
            lookbehind: true,
            greedy: true,
            alias: [
                'javastacktrace',
                'language-javastacktrace'
            ],
            inside: Prism.languages['javastacktrace'] || {
                keyword: /\bat\b/,
                function: /[a-z_][\w$]*(?=\()/,
                punctuation: /[.:()]/
            }
        },
        level: [
            {
                pattern: /\b(?:ALERT|CRIT|CRITICAL|EMERG|EMERGENCY|ERR|ERROR|FAILURE|FATAL|SEVERE)\b/,
                alias: [
                    'error',
                    'important'
                ]
            },
            {
                pattern: /\b(?:WARN|WARNING|WRN)\b/,
                alias: [
                    'warning',
                    'important'
                ]
            },
            {
                pattern: /\b(?:DISPLAY|INF|INFO|NOTICE|STATUS)\b/,
                alias: [
                    'info',
                    'keyword'
                ]
            },
            {
                pattern: /\b(?:DBG|DEBUG|FINE)\b/,
                alias: [
                    'debug',
                    'keyword'
                ]
            },
            {
                pattern: /\b(?:FINER|FINEST|TRACE|TRC|VERBOSE|VRB)\b/,
                alias: [
                    'trace',
                    'comment'
                ]
            }
        ],
        property: {
            pattern: /((?:^|[\]|])[ \t]*)[a-z_](?:[\w-]|\b\/\b)*(?:[. ]\(?\w(?:[\w-]|\b\/\b)*\)?)*:(?=\s)/im,
            lookbehind: true
        },
        separator: {
            pattern: /(^|[^-+])-{3,}|={3,}|\*{3,}|- - /m,
            lookbehind: true,
            alias: 'comment'
        },
        url: /\b(?:file|ftp|https?):\/\/[^\s|,;'"]*[^\s|,;'">.]/,
        email: {
            pattern: /(^|\s)[-\w+.]+@[a-z][a-z0-9-]*(?:\.[a-z][a-z0-9-]*)+(?=\s)/,
            lookbehind: true,
            alias: 'url'
        },
        'ip-address': {
            pattern: /\b(?:\d{1,3}(?:\.\d{1,3}){3})\b/,
            alias: 'constant'
        },
        'mac-address': {
            pattern: /\b[a-f0-9]{2}(?::[a-f0-9]{2}){5}\b/i,
            alias: 'constant'
        },
        domain: {
            pattern: /(^|\s)[a-z][a-z0-9-]*(?:\.[a-z][a-z0-9-]*)*\.[a-z][a-z0-9-]+(?=\s)/,
            lookbehind: true,
            alias: 'constant'
        },
        uuid: {
            pattern: /\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b/i,
            alias: 'constant'
        },
        hash: {
            pattern: /\b(?:[a-f0-9]{32}){1,2}\b/i,
            alias: 'constant'
        },
        'file-path': {
            pattern: /\b[a-z]:[\\/][^\s|,;:(){}\[\]"']+|(^|[\s:\[\](>|])\.{0,2}\/\w[^\s|,;:(){}\[\]"']*/i,
            lookbehind: true,
            greedy: true,
            alias: 'string'
        },
        date: {
            pattern: RegExp(/\b\d{4}[-/]\d{2}[-/]\d{2}(?:T(?=\d{1,2}:)|(?=\s\d{1,2}:))/.source + '|' + /\b\d{1,4}[-/ ](?:\d{1,2}|Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)[-/ ]\d{2,4}T?\b/.source + '|' + /\b(?:(?:Fri|Mon|Sat|Sun|Thu|Tue|Wed)(?:\s{1,2}(?:Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep))?|Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)\s{1,2}\d{1,2}\b/.source, 'i'),
            alias: 'number'
        },
        time: {
            pattern: /\b\d{1,2}:\d{1,2}:\d{1,2}(?:[.,:]\d+)?(?:\s?[+-]\d{2}:?\d{2}|Z)?\b/,
            alias: 'number'
        },
        boolean: /\b(?:false|null|true)\b/i,
        number: {
            pattern: /(^|[^.\w])(?:0x[a-f0-9]+|0o[0-7]+|0b[01]+|v?\d[\da-f]*(?:\.\d+)*(?:e[+-]?\d+)?[a-z]{0,3}\b)\b(?!\.\w)/i,
            lookbehind: true
        },
        operator: /[;:?<=>~/@!$%&+\-|^(){}*#]/,
        punctuation: /[\[\].,]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $55c84b5f47c86788$export$2e2bcd8739ae039.displayName = 'lolcode';
$55c84b5f47c86788$export$2e2bcd8739ae039.aliases = [];
function $55c84b5f47c86788$export$2e2bcd8739ae039(Prism) {
    Prism.languages.lolcode = {
        comment: [
            /\bOBTW\s[\s\S]*?\sTLDR\b/,
            /\bBTW.+/
        ],
        string: {
            pattern: /"(?::.|[^":])*"/,
            inside: {
                variable: /:\{[^}]+\}/,
                symbol: [
                    /:\([a-f\d]+\)/i,
                    /:\[[^\]]+\]/,
                    /:[)>o":]/
                ]
            },
            greedy: true
        },
        number: /(?:\B-)?(?:\b\d+(?:\.\d*)?|\B\.\d+)/,
        symbol: {
            pattern: /(^|\s)(?:A )?(?:BUKKIT|NOOB|NUMBAR|NUMBR|TROOF|YARN)(?=\s|,|$)/,
            lookbehind: true,
            inside: {
                keyword: /A(?=\s)/
            }
        },
        label: {
            pattern: /((?:^|\s)(?:IM IN YR|IM OUTTA YR) )[a-zA-Z]\w*/,
            lookbehind: true,
            alias: 'string'
        },
        function: {
            pattern: /((?:^|\s)(?:HOW IZ I|I IZ|IZ) )[a-zA-Z]\w*/,
            lookbehind: true
        },
        keyword: [
            {
                pattern: /(^|\s)(?:AN|FOUND YR|GIMMEH|GTFO|HAI|HAS A|HOW IZ I|I HAS A|I IZ|IF U SAY SO|IM IN YR|IM OUTTA YR|IS NOW(?: A)?|ITZ(?: A)?|IZ|KTHX|KTHXBYE|LIEK(?: A)?|MAEK|MEBBE|MKAY|NERFIN|NO WAI|O HAI IM|O RLY\?|OIC|OMG|OMGWTF|R|SMOOSH|SRS|TIL|UPPIN|VISIBLE|WILE|WTF\?|YA RLY|YR)(?=\s|,|$)/,
                lookbehind: true
            },
            /'Z(?=\s|,|$)/
        ],
        boolean: {
            pattern: /(^|\s)(?:FAIL|WIN)(?=\s|,|$)/,
            lookbehind: true
        },
        variable: {
            pattern: /(^|\s)IT(?=\s|,|$)/,
            lookbehind: true
        },
        operator: {
            pattern: /(^|\s)(?:NOT|BOTH SAEM|DIFFRINT|(?:ALL|ANY|BIGGR|BOTH|DIFF|EITHER|MOD|PRODUKT|QUOSHUNT|SMALLR|SUM|WON) OF)(?=\s|,|$)/,
            lookbehind: true
        },
        punctuation: /\.{3}|…|,|!/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $9513a6857dddaa7a$export$2e2bcd8739ae039.displayName = 'magma';
$9513a6857dddaa7a$export$2e2bcd8739ae039.aliases = [];
function $9513a6857dddaa7a$export$2e2bcd8739ae039(Prism) {
    Prism.languages.magma = {
        output: {
            pattern: /^(>.*(?:\r(?:\n|(?!\n))|\n))(?!>)(?:.+|(?:\r(?:\n|(?!\n))|\n)(?!>).*)(?:(?:\r(?:\n|(?!\n))|\n)(?!>).*)*/m,
            lookbehind: true,
            greedy: true
        },
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\"])"(?:[^\r\n\\"]|\\.)*"/,
            lookbehind: true,
            greedy: true
        },
        // http://magma.maths.usyd.edu.au/magma/handbook/text/82
        keyword: /\b(?:_|adj|and|assert|assert2|assert3|assigned|break|by|case|cat|catch|clear|cmpeq|cmpne|continue|declare|default|delete|diff|div|do|elif|else|end|eq|error|eval|exists|exit|for|forall|forward|fprintf|freeze|function|ge|gt|if|iload|import|in|intrinsic|is|join|le|load|local|lt|meet|mod|ne|not|notadj|notin|notsubset|or|print|printf|procedure|quit|random|read|readi|repeat|require|requirege|requirerange|restore|return|save|sdiff|select|subset|then|time|to|try|until|vprint|vprintf|vtime|when|where|while|xor)\b/,
        boolean: /\b(?:false|true)\b/,
        generator: {
            pattern: /\b[a-z_]\w*(?=\s*<)/i,
            alias: 'class-name'
        },
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: {
            pattern: /(^|[^\w.]|\.\.)(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?(?:_[a-z]?)?(?=$|[^\w.]|\.\.)/,
            lookbehind: true
        },
        operator: /->|[-+*/^~!|#=]|:=|\.\./,
        punctuation: /[()[\]{}<>,;.:]/
    };
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $7306ed74be230ce9$export$2e2bcd8739ae039.displayName = 'mata';
$7306ed74be230ce9$export$2e2bcd8739ae039.aliases = [];
function $7306ed74be230ce9$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var orgType = /\b(?:(?:col|row)?vector|matrix|scalar)\b/.source;
        var type = /\bvoid\b|<org>|\b(?:complex|numeric|pointer(?:\s*\([^()]*\))?|real|string|(?:class|struct)\s+\w+|transmorphic)(?:\s*<org>)?/.source.replace(/<org>/g, orgType);
        Prism.languages.mata = {
            comment: {
                pattern: /\/\/.*|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\//,
                greedy: true
            },
            string: {
                pattern: /"[^"\r\n]*"|[‘`']".*?"[’`']/,
                greedy: true
            },
            'class-name': {
                pattern: /(\b(?:class|extends|struct)\s+)\w+(?=\s*(?:\{|\bextends\b))/,
                lookbehind: true
            },
            type: {
                pattern: RegExp(type),
                alias: 'class-name',
                inside: {
                    punctuation: /[()]/,
                    keyword: /\b(?:class|function|struct|void)\b/
                }
            },
            keyword: /\b(?:break|class|continue|do|else|end|extends|external|final|for|function|goto|if|pragma|private|protected|public|return|static|struct|unset|unused|version|virtual|while)\b/,
            constant: /\bNULL\b/,
            number: {
                pattern: /(^|[^\w.])(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|\d[a-f0-9]*(?:\.[a-f0-9]+)?x[+-]?\d+)i?(?![\w.])/i,
                lookbehind: true
            },
            missing: {
                pattern: /(^|[^\w.])(?:\.[a-z]?)(?![\w.])/,
                lookbehind: true,
                alias: 'symbol'
            },
            function: /\b[a-z_]\w*(?=\s*\()/i,
            operator: /\.\.|\+\+|--|&&|\|\||:?(?:[!=<>]=|[+\-*/^<>&|:])|[!?=\\#’`']/,
            punctuation: /[()[\]{},;.]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $0032d605afbc43b2$export$2e2bcd8739ae039.displayName = 'matlab';
$0032d605afbc43b2$export$2e2bcd8739ae039.aliases = [];
function $0032d605afbc43b2$export$2e2bcd8739ae039(Prism) {
    Prism.languages.matlab = {
        comment: [
            /%\{[\s\S]*?\}%/,
            /%.+/
        ],
        string: {
            pattern: /\B'(?:''|[^'\r\n])*'/,
            greedy: true
        },
        // FIXME We could handle imaginary numbers as a whole
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+)?(?:[ij])?|\b[ij]\b/,
        keyword: /\b(?:NaN|break|case|catch|continue|else|elseif|end|for|function|if|inf|otherwise|parfor|pause|pi|return|switch|try|while)\b/,
        function: /\b(?!\d)\w+(?=\s*\()/,
        operator: /\.?[*^\/\\']|[+\-:@]|[<>=~]=?|&&?|\|\|?/,
        punctuation: /\.{3}|[.,;\[\](){}!]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $ff984944cd41b96b$export$2e2bcd8739ae039.displayName = 'maxscript';
$ff984944cd41b96b$export$2e2bcd8739ae039.aliases = [];
function $ff984944cd41b96b$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var keywords = /\b(?:about|and|animate|as|at|attributes|by|case|catch|collect|continue|coordsys|do|else|exit|fn|for|from|function|global|if|in|local|macroscript|mapped|max|not|of|off|on|or|parameters|persistent|plugin|rcmenu|return|rollout|set|struct|then|throw|to|tool|try|undo|utility|when|where|while|with)\b/i;
        Prism.languages.maxscript = {
            comment: {
                pattern: /\/\*[\s\S]*?(?:\*\/|$)|--.*/,
                greedy: true
            },
            string: {
                pattern: /(^|[^"\\@])(?:"(?:[^"\\]|\\[\s\S])*"|@"[^"]*")/,
                lookbehind: true,
                greedy: true
            },
            path: {
                pattern: /\$(?:[\w/\\.*?]|'[^']*')*/,
                greedy: true,
                alias: 'string'
            },
            'function-call': {
                pattern: RegExp('((?:' + // start of line
                (/^/.source + '|' + // operators and other language constructs
                /[;=<>+\-*/^({\[]/.source + '|' + // keywords as part of statements
                /\b(?:and|by|case|catch|collect|do|else|if|in|not|or|return|then|to|try|where|while|with)\b/.source) + ')[ \t]*)' + '(?!' + keywords.source + ')' + /[a-z_]\w*\b/.source + '(?=[ \t]*(?:' + // variable
                ('(?!' + keywords.source + ')' + /[a-z_]/.source + '|' + // number
                /\d|-\.?\d/.source + '|' + // other expressions or literals
                /[({'"$@#?]/.source) + '))', 'im'),
                lookbehind: true,
                greedy: true,
                alias: 'function'
            },
            'function-definition': {
                pattern: /(\b(?:fn|function)\s+)\w+\b/i,
                lookbehind: true,
                alias: 'function'
            },
            argument: {
                pattern: /\b[a-z_]\w*(?=:)/i,
                alias: 'attr-name'
            },
            keyword: keywords,
            boolean: /\b(?:false|true)\b/,
            time: {
                pattern: /(^|[^\w.])(?:(?:(?:\d+(?:\.\d*)?|\.\d+)(?:[eEdD][+-]\d+|[LP])?[msft])+|\d+:\d+(?:\.\d*)?)(?![\w.:])/,
                lookbehind: true,
                alias: 'number'
            },
            number: [
                {
                    pattern: /(^|[^\w.])(?:(?:\d+(?:\.\d*)?|\.\d+)(?:[eEdD][+-]\d+|[LP])?|0x[a-fA-F0-9]+)(?![\w.:])/,
                    lookbehind: true
                },
                /\b(?:e|pi)\b/
            ],
            constant: /\b(?:dontcollect|ok|silentValue|undefined|unsupplied)\b/,
            color: {
                pattern: /\b(?:black|blue|brown|gray|green|orange|red|white|yellow)\b/i,
                alias: 'constant'
            },
            operator: /[-+*/<>=!]=?|[&^?]|#(?!\()/,
            punctuation: /[()\[\]{}.:,;]|#(?=\()|\\$/m
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $aee6b2f66d7ac757$export$2e2bcd8739ae039.displayName = 'mel';
$aee6b2f66d7ac757$export$2e2bcd8739ae039.aliases = [];
function $aee6b2f66d7ac757$export$2e2bcd8739ae039(Prism) {
    Prism.languages.mel = {
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
            greedy: true
        },
        code: {
            pattern: /`(?:\\.|[^\\`])*`/,
            greedy: true,
            alias: 'italic',
            inside: {
                delimiter: {
                    pattern: /^`|`$/,
                    alias: 'punctuation'
                },
                statement: {
                    pattern: /[\s\S]+/,
                    inside: null // see below
                }
            }
        },
        string: {
            pattern: /"(?:\\.|[^\\"\r\n])*"/,
            greedy: true
        },
        variable: /\$\w+/,
        number: /\b0x[\da-fA-F]+\b|\b\d+(?:\.\d*)?|\B\.\d+/,
        flag: {
            pattern: /-[^\d\W]\w*/,
            alias: 'operator'
        },
        keyword: /\b(?:break|case|continue|default|do|else|float|for|global|if|in|int|matrix|proc|return|string|switch|vector|while)\b/,
        function: {
            pattern: /((?:^|[{;])[ \t]*)[a-z_]\w*\b(?!\s*(?:\.(?!\.)|[[{=]))|\b[a-z_]\w*(?=[ \t]*\()/im,
            lookbehind: true,
            greedy: true
        },
        'tensor-punctuation': {
            pattern: /<<|>>/,
            alias: 'punctuation'
        },
        operator: /\+[+=]?|-[-=]?|&&|\|\||[<>]=?|[*\/!=]=?|[%^]/,
        punctuation: /[.,:;?\[\](){}]/
    };
    Prism.languages.mel['code'].inside['statement'].inside = Prism.languages.mel;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $a4448d0866560d14$export$2e2bcd8739ae039.displayName = 'mermaid';
$a4448d0866560d14$export$2e2bcd8739ae039.aliases = [];
function $a4448d0866560d14$export$2e2bcd8739ae039(Prism) {
    Prism.languages.mermaid = {
        comment: {
            pattern: /%%.*/,
            greedy: true
        },
        style: {
            pattern: /^([ \t]*(?:classDef|linkStyle|style)[ \t]+[\w$-]+[ \t]+)\w.*[^\s;]/m,
            lookbehind: true,
            inside: {
                property: /\b\w[\w-]*(?=[ \t]*:)/,
                operator: /:/,
                punctuation: /,/
            }
        },
        'inter-arrow-label': {
            pattern: /([^<>ox.=-])(?:-[-.]|==)(?![<>ox.=-])[ \t]*(?:"[^"\r\n]*"|[^\s".=-](?:[^\r\n.=-]*[^\s.=-])?)[ \t]*(?:\.+->?|--+[->]|==+[=>])(?![<>ox.=-])/,
            lookbehind: true,
            greedy: true,
            inside: {
                arrow: {
                    pattern: /(?:\.+->?|--+[->]|==+[=>])$/,
                    alias: 'operator'
                },
                label: {
                    pattern: /^([\s\S]{2}[ \t]*)\S(?:[\s\S]*\S)?/,
                    lookbehind: true,
                    alias: 'property'
                },
                'arrow-head': {
                    pattern: /^\S+/,
                    alias: [
                        'arrow',
                        'operator'
                    ]
                }
            }
        },
        arrow: [
            // This might look complex but it really isn't.
            // There are many possible arrows (see tests) and it's impossible to fit all of them into one pattern. The
            // problem is that we only have one lookbehind per pattern. However, we cannot disallow too many arrow
            // characters in the one lookbehind because that would create too many false negatives. So we have to split the
            // arrows into different patterns.
            {
                // ER diagram
                pattern: /(^|[^{}|o.-])[|}][|o](?:--|\.\.)[|o][|{](?![{}|o.-])/,
                lookbehind: true,
                alias: 'operator'
            },
            {
                // flow chart
                // (?:==+|--+|-\.*-)
                pattern: /(^|[^<>ox.=-])(?:[<ox](?:==+|--+|-\.*-)[>ox]?|(?:==+|--+|-\.*-)[>ox]|===+|---+|-\.+-)(?![<>ox.=-])/,
                lookbehind: true,
                alias: 'operator'
            },
            {
                // sequence diagram
                pattern: /(^|[^<>()x-])(?:--?(?:>>|[x>)])(?![<>()x])|(?:<<|[x<(])--?(?!-))/,
                lookbehind: true,
                alias: 'operator'
            },
            {
                // class diagram
                pattern: /(^|[^<>|*o.-])(?:[*o]--|--[*o]|<\|?(?:--|\.\.)|(?:--|\.\.)\|?>|--|\.\.)(?![<>|*o.-])/,
                lookbehind: true,
                alias: 'operator'
            }
        ],
        label: {
            pattern: /(^|[^|<])\|(?:[^\r\n"|]|"[^"\r\n]*")+\|/,
            lookbehind: true,
            greedy: true,
            alias: 'property'
        },
        text: {
            pattern: /(?:[(\[{]+|\b>)(?:[^\r\n"()\[\]{}]|"[^"\r\n]*")+(?:[)\]}]+|>)/,
            alias: 'string'
        },
        string: {
            pattern: /"[^"\r\n]*"/,
            greedy: true
        },
        annotation: {
            pattern: /<<(?:abstract|choice|enumeration|fork|interface|join|service)>>|\[\[(?:choice|fork|join)\]\]/i,
            alias: 'important'
        },
        keyword: [
            // This language has both case-sensitive and case-insensitive keywords
            {
                pattern: /(^[ \t]*)(?:action|callback|class|classDef|classDiagram|click|direction|erDiagram|flowchart|gantt|gitGraph|graph|journey|link|linkStyle|pie|requirementDiagram|sequenceDiagram|stateDiagram|stateDiagram-v2|style|subgraph)(?![\w$-])/m,
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^[ \t]*)(?:activate|alt|and|as|autonumber|deactivate|else|end(?:[ \t]+note)?|loop|opt|par|participant|rect|state|note[ \t]+(?:over|(?:left|right)[ \t]+of))(?![\w$-])/im,
                lookbehind: true,
                greedy: true
            }
        ],
        entity: /#[a-z0-9]+;/,
        operator: {
            pattern: /(\w[ \t]*)&(?=[ \t]*\w)|:::|:/,
            lookbehind: true
        },
        punctuation: /[(){};]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $8d3fa3f18bccf1b2$export$2e2bcd8739ae039.displayName = 'metafont';
$8d3fa3f18bccf1b2$export$2e2bcd8739ae039.aliases = [];
function $8d3fa3f18bccf1b2$export$2e2bcd8739ae039(Prism) {
    Prism.languages.metafont = {
        // Syntax of METAFONT with the added (public) elements of PlainMETAFONT. Except for internal quantities they are expected to be rarely redefined. Freely inspired by the syntax of Christophe Grandsire for the Crimson Editor.
        comment: {
            pattern: /%.*/,
            greedy: true
        },
        string: {
            pattern: /"[^\r\n"]*"/,
            greedy: true
        },
        number: /\d*\.?\d+/,
        boolean: /\b(?:false|true)\b/,
        punctuation: [
            /[,;()]/,
            {
                pattern: /(^|[^{}])(?:\{|\})(?![{}])/,
                lookbehind: true
            },
            {
                pattern: /(^|[^[])\[(?!\[)/,
                lookbehind: true
            },
            {
                pattern: /(^|[^\]])\](?!\])/,
                lookbehind: true
            }
        ],
        constant: [
            {
                pattern: /(^|[^!?])\?\?\?(?![!?])/,
                lookbehind: true
            },
            {
                pattern: /(^|[^/*\\])(?:\\|\\\\)(?![/*\\])/,
                lookbehind: true
            },
            /\b(?:_|blankpicture|bp|cc|cm|dd|ditto|down|eps|epsilon|fullcircle|halfcircle|identity|in|infinity|left|mm|nullpen|nullpicture|origin|pc|penrazor|penspeck|pensquare|penstroke|proof|pt|quartercircle|relax|right|smoke|unitpixel|unitsquare|up)\b/
        ],
        quantity: {
            pattern: /\b(?:autorounding|blacker|boundarychar|charcode|chardp|chardx|chardy|charext|charht|charic|charwd|currentwindow|day|designsize|displaying|fillin|fontmaking|granularity|hppp|join_radius|month|o_correction|pausing|pen_(?:bot|lft|rt|top)|pixels_per_inch|proofing|showstopping|smoothing|time|tolerance|tracingcapsules|tracingchoices|tracingcommands|tracingedges|tracingequations|tracingmacros|tracingonline|tracingoutput|tracingpens|tracingrestores|tracingspecs|tracingstats|tracingtitles|turningcheck|vppp|warningcheck|xoffset|year|yoffset)\b/,
            alias: 'keyword'
        },
        command: {
            pattern: /\b(?:addto|batchmode|charlist|cull|display|errhelp|errmessage|errorstopmode|everyjob|extensible|fontdimen|headerbyte|inner|interim|let|ligtable|message|newinternal|nonstopmode|numspecial|openwindow|outer|randomseed|save|scrollmode|shipout|show|showdependencies|showstats|showtoken|showvariable|special)\b/,
            alias: 'builtin'
        },
        operator: [
            {
                pattern: /(^|[^>=<:|])(?:<|<=|=|=:|\|=:|\|=:>|=:\|>|=:\||\|=:\||\|=:\|>|\|=:\|>>|>|>=|:|:=|<>|::|\|\|:)(?![>=<:|])/,
                lookbehind: true
            },
            {
                pattern: /(^|[^+-])(?:\+|\+\+|-{1,3}|\+-\+)(?![+-])/,
                lookbehind: true
            },
            {
                pattern: /(^|[^/*\\])(?:\*|\*\*|\/)(?![/*\\])/,
                lookbehind: true
            },
            {
                pattern: /(^|[^.])(?:\.{2,3})(?!\.)/,
                lookbehind: true
            },
            {
                pattern: /(^|[^@#&$])&(?![@#&$])/,
                lookbehind: true
            },
            /\b(?:and|not|or)\b/
        ],
        macro: {
            pattern: /\b(?:abs|beginchar|bot|byte|capsule_def|ceiling|change_width|clear_pen_memory|clearit|clearpen|clearxy|counterclockwise|cullit|cutdraw|cutoff|decr|define_blacker_pixels|define_corrected_pixels|define_good_x_pixels|define_good_y_pixels|define_horizontal_corrected_pixels|define_pixels|define_whole_blacker_pixels|define_whole_pixels|define_whole_vertical_blacker_pixels|define_whole_vertical_pixels|dir|direction|directionpoint|div|dotprod|downto|draw|drawdot|endchar|erase|fill|filldraw|fix_units|flex|font_coding_scheme|font_extra_space|font_identifier|font_normal_shrink|font_normal_space|font_normal_stretch|font_quad|font_size|font_slant|font_x_height|gfcorners|gobble|gobbled|good\.(?:bot|lft|rt|top|x|y)|grayfont|hide|hround|imagerules|incr|interact|interpath|intersectionpoint|inverse|italcorr|killtext|labelfont|labels|lft|loggingall|lowres_fix|makegrid|makelabel(?:\.(?:bot|lft|rt|top)(?:\.nodot)?)?|max|min|mod|mode_def|mode_setup|nodisplays|notransforms|numtok|openit|penlabels|penpos|pickup|proofoffset|proofrule|proofrulethickness|range|reflectedabout|rotatedabout|rotatedaround|round|rt|savepen|screenchars|screenrule|screenstrokes|shipit|showit|slantfont|softjoin|solve|stop|superellipse|tensepath|thru|titlefont|top|tracingall|tracingnone|undraw|undrawdot|unfill|unfilldraw|upto|vround)\b/,
            alias: 'function'
        },
        builtin: /\b(?:ASCII|angle|char|cosd|decimal|directiontime|floor|hex|intersectiontimes|jobname|known|length|makepath|makepen|mexp|mlog|normaldeviate|oct|odd|pencircle|penoffset|point|postcontrol|precontrol|reverse|rotated|sind|sqrt|str|subpath|substring|totalweight|turningnumber|uniformdeviate|unknown|xpart|xxpart|xypart|ypart|yxpart|yypart)\b/,
        keyword: /\b(?:also|at|atleast|begingroup|charexists|contour|controls|curl|cycle|def|delimiters|doublepath|dropping|dump|else|elseif|end|enddef|endfor|endgroup|endinput|exitif|exitunless|expandafter|fi|for|forever|forsuffixes|from|if|input|inwindow|keeping|kern|of|primarydef|quote|readstring|scaled|scantokens|secondarydef|shifted|skipto|slanted|step|tension|tertiarydef|to|transformed|until|vardef|withpen|withweight|xscaled|yscaled|zscaled)\b/,
        type: {
            pattern: /\b(?:boolean|expr|numeric|pair|path|pen|picture|primary|secondary|string|suffix|tertiary|text|transform)\b/,
            alias: 'property'
        },
        variable: {
            pattern: /(^|[^@#&$])(?:@#|#@|#|@)(?![@#&$])|\b(?:aspect_ratio|currentpen|currentpicture|currenttransform|d|extra_beginchar|extra_endchar|extra_setup|h|localfont|mag|mode|screen_cols|screen_rows|w|whatever|x|y|z)\b/,
            lookbehind: true
        }
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $fce09911b128bdb6$export$2e2bcd8739ae039.displayName = 'mizar';
$fce09911b128bdb6$export$2e2bcd8739ae039.aliases = [];
function $fce09911b128bdb6$export$2e2bcd8739ae039(Prism) {
    Prism.languages.mizar = {
        comment: /::.+/,
        keyword: /@proof\b|\b(?:according|aggregate|all|and|antonym|are|as|associativity|assume|asymmetry|attr|be|begin|being|by|canceled|case|cases|clusters?|coherence|commutativity|compatibility|connectedness|consider|consistency|constructors|contradiction|correctness|def|deffunc|define|definitions?|defpred|do|does|end|environ|equals|ex|exactly|existence|for|from|func|given|hence|hereby|holds|idempotence|identity|iff?|implies|involutiveness|irreflexivity|is|it|let|means|mode|non|not|notations?|now|of|or|otherwise|over|per|pred|prefix|projectivity|proof|provided|qua|reconsider|redefine|reduce|reducibility|reflexivity|registrations?|requirements|reserve|sch|schemes?|section|selector|set|sethood|st|struct|such|suppose|symmetry|synonym|take|that|the|then|theorems?|thesis|thus|to|transitivity|uniqueness|vocabular(?:ies|y)|when|where|with|wrt)\b/,
        parameter: {
            pattern: /\$(?:10|\d)/,
            alias: 'variable'
        },
        variable: /\b\w+(?=:)/,
        number: /(?:\b|-)\d+\b/,
        operator: /\.\.\.|->|&|\.?=/,
        punctuation: /\(#|#\)|[,:;\[\](){}]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$3350c1fbd5ca8b13$export$2e2bcd8739ae039.displayName = 'mongodb';
$3350c1fbd5ca8b13$export$2e2bcd8739ae039.aliases = [];
function $3350c1fbd5ca8b13$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
    (function(Prism) {
        var operators = [
            // query and projection
            '$eq',
            '$gt',
            '$gte',
            '$in',
            '$lt',
            '$lte',
            '$ne',
            '$nin',
            '$and',
            '$not',
            '$nor',
            '$or',
            '$exists',
            '$type',
            '$expr',
            '$jsonSchema',
            '$mod',
            '$regex',
            '$text',
            '$where',
            '$geoIntersects',
            '$geoWithin',
            '$near',
            '$nearSphere',
            '$all',
            '$elemMatch',
            '$size',
            '$bitsAllClear',
            '$bitsAllSet',
            '$bitsAnyClear',
            '$bitsAnySet',
            '$comment',
            '$elemMatch',
            '$meta',
            '$slice',
            // update
            '$currentDate',
            '$inc',
            '$min',
            '$max',
            '$mul',
            '$rename',
            '$set',
            '$setOnInsert',
            '$unset',
            '$addToSet',
            '$pop',
            '$pull',
            '$push',
            '$pullAll',
            '$each',
            '$position',
            '$slice',
            '$sort',
            '$bit',
            // aggregation pipeline stages
            '$addFields',
            '$bucket',
            '$bucketAuto',
            '$collStats',
            '$count',
            '$currentOp',
            '$facet',
            '$geoNear',
            '$graphLookup',
            '$group',
            '$indexStats',
            '$limit',
            '$listLocalSessions',
            '$listSessions',
            '$lookup',
            '$match',
            '$merge',
            '$out',
            '$planCacheStats',
            '$project',
            '$redact',
            '$replaceRoot',
            '$replaceWith',
            '$sample',
            '$set',
            '$skip',
            '$sort',
            '$sortByCount',
            '$unionWith',
            '$unset',
            '$unwind',
            '$setWindowFields',
            // aggregation pipeline operators
            '$abs',
            '$accumulator',
            '$acos',
            '$acosh',
            '$add',
            '$addToSet',
            '$allElementsTrue',
            '$and',
            '$anyElementTrue',
            '$arrayElemAt',
            '$arrayToObject',
            '$asin',
            '$asinh',
            '$atan',
            '$atan2',
            '$atanh',
            '$avg',
            '$binarySize',
            '$bsonSize',
            '$ceil',
            '$cmp',
            '$concat',
            '$concatArrays',
            '$cond',
            '$convert',
            '$cos',
            '$dateFromParts',
            '$dateToParts',
            '$dateFromString',
            '$dateToString',
            '$dayOfMonth',
            '$dayOfWeek',
            '$dayOfYear',
            '$degreesToRadians',
            '$divide',
            '$eq',
            '$exp',
            '$filter',
            '$first',
            '$floor',
            '$function',
            '$gt',
            '$gte',
            '$hour',
            '$ifNull',
            '$in',
            '$indexOfArray',
            '$indexOfBytes',
            '$indexOfCP',
            '$isArray',
            '$isNumber',
            '$isoDayOfWeek',
            '$isoWeek',
            '$isoWeekYear',
            '$last',
            '$last',
            '$let',
            '$literal',
            '$ln',
            '$log',
            '$log10',
            '$lt',
            '$lte',
            '$ltrim',
            '$map',
            '$max',
            '$mergeObjects',
            '$meta',
            '$min',
            '$millisecond',
            '$minute',
            '$mod',
            '$month',
            '$multiply',
            '$ne',
            '$not',
            '$objectToArray',
            '$or',
            '$pow',
            '$push',
            '$radiansToDegrees',
            '$range',
            '$reduce',
            '$regexFind',
            '$regexFindAll',
            '$regexMatch',
            '$replaceOne',
            '$replaceAll',
            '$reverseArray',
            '$round',
            '$rtrim',
            '$second',
            '$setDifference',
            '$setEquals',
            '$setIntersection',
            '$setIsSubset',
            '$setUnion',
            '$size',
            '$sin',
            '$slice',
            '$split',
            '$sqrt',
            '$stdDevPop',
            '$stdDevSamp',
            '$strcasecmp',
            '$strLenBytes',
            '$strLenCP',
            '$substr',
            '$substrBytes',
            '$substrCP',
            '$subtract',
            '$sum',
            '$switch',
            '$tan',
            '$toBool',
            '$toDate',
            '$toDecimal',
            '$toDouble',
            '$toInt',
            '$toLong',
            '$toObjectId',
            '$toString',
            '$toLower',
            '$toUpper',
            '$trim',
            '$trunc',
            '$type',
            '$week',
            '$year',
            '$zip',
            '$count',
            '$dateAdd',
            '$dateDiff',
            '$dateSubtract',
            '$dateTrunc',
            '$getField',
            '$rand',
            '$sampleRate',
            '$setField',
            '$unsetField',
            // aggregation pipeline query modifiers
            '$comment',
            '$explain',
            '$hint',
            '$max',
            '$maxTimeMS',
            '$min',
            '$orderby',
            '$query',
            '$returnKey',
            '$showDiskLoc',
            '$natural'
        ];
        var builtinFunctions = [
            'ObjectId',
            'Code',
            'BinData',
            'DBRef',
            'Timestamp',
            'NumberLong',
            'NumberDecimal',
            'MaxKey',
            'MinKey',
            'RegExp',
            'ISODate',
            'UUID'
        ];
        operators = operators.map(function(operator) {
            return operator.replace('$', '\\$');
        });
        var operatorsSource = '(?:' + operators.join('|') + ')\\b';
        Prism.languages.mongodb = Prism.languages.extend('javascript', {});
        Prism.languages.insertBefore('mongodb', 'string', {
            property: {
                pattern: /(?:(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)(?=\s*:)/,
                greedy: true,
                inside: {
                    keyword: RegExp('^([\'"])?' + operatorsSource + '(?:\\1)?$')
                }
            }
        });
        Prism.languages.mongodb.string.inside = {
            url: {
                // url pattern
                pattern: /https?:\/\/[-\w@:%.+~#=]{1,256}\.[a-z0-9()]{1,6}\b[-\w()@:%+.~#?&/=]*/i,
                greedy: true
            },
            entity: {
                // ipv4
                pattern: /\b(?:(?:[01]?\d\d?|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d\d?|2[0-4]\d|25[0-5])\b/,
                greedy: true
            }
        };
        Prism.languages.insertBefore('mongodb', 'constant', {
            builtin: {
                pattern: RegExp('\\b(?:' + builtinFunctions.join('|') + ')\\b'),
                alias: 'keyword'
            }
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $5c87aab191bc72fd$export$2e2bcd8739ae039.displayName = 'monkey';
$5c87aab191bc72fd$export$2e2bcd8739ae039.aliases = [];
function $5c87aab191bc72fd$export$2e2bcd8739ae039(Prism) {
    Prism.languages.monkey = {
        comment: {
            pattern: /^#Rem\s[\s\S]*?^#End|'.+/im,
            greedy: true
        },
        string: {
            pattern: /"[^"\r\n]*"/,
            greedy: true
        },
        preprocessor: {
            pattern: /(^[ \t]*)#.+/m,
            lookbehind: true,
            greedy: true,
            alias: 'property'
        },
        function: /\b\w+(?=\()/,
        'type-char': {
            pattern: /\b[?%#$]/,
            alias: 'class-name'
        },
        number: {
            pattern: /((?:\.\.)?)(?:(?:\b|\B-\.?|\B\.)\d+(?:(?!\.\.)\.\d*)?|\$[\da-f]+)/i,
            lookbehind: true
        },
        keyword: /\b(?:Abstract|Array|Bool|Case|Catch|Class|Const|Continue|Default|Eachin|Else|ElseIf|End|EndIf|Exit|Extends|Extern|False|Field|Final|Float|For|Forever|Function|Global|If|Implements|Import|Inline|Int|Interface|Local|Method|Module|New|Next|Null|Object|Private|Property|Public|Repeat|Return|Select|Self|Step|Strict|String|Super|Then|Throw|To|True|Try|Until|Void|Wend|While)\b/i,
        operator: /\.\.|<[=>]?|>=?|:?=|(?:[+\-*\/&~|]|\b(?:Mod|Shl|Shr)\b)=?|\b(?:And|Not|Or)\b/i,
        punctuation: /[.,:;()\[\]]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $0efdb6c99f3f7c98$export$2e2bcd8739ae039.displayName = 'moonscript';
$0efdb6c99f3f7c98$export$2e2bcd8739ae039.aliases = [
    'moon'
];
function $0efdb6c99f3f7c98$export$2e2bcd8739ae039(Prism) {
    Prism.languages.moonscript = {
        comment: /--.*/,
        string: [
            {
                pattern: /'[^']*'|\[(=*)\[[\s\S]*?\]\1\]/,
                greedy: true
            },
            {
                pattern: /"[^"]*"/,
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: /#\{[^{}]*\}/,
                        inside: {
                            moonscript: {
                                pattern: /(^#\{)[\s\S]+(?=\})/,
                                lookbehind: true,
                                inside: null // see beow
                            },
                            'interpolation-punctuation': {
                                pattern: /#\{|\}/,
                                alias: 'punctuation'
                            }
                        }
                    }
                }
            }
        ],
        'class-name': [
            {
                pattern: /(\b(?:class|extends)[ \t]+)\w+/,
                lookbehind: true
            },
            // class-like names start with a capital letter
            /\b[A-Z]\w*/
        ],
        keyword: /\b(?:class|continue|do|else|elseif|export|extends|for|from|if|import|in|local|nil|return|self|super|switch|then|unless|using|when|while|with)\b/,
        variable: /@@?\w*/,
        property: {
            pattern: /\b(?!\d)\w+(?=:)|(:)(?!\d)\w+/,
            lookbehind: true
        },
        function: {
            pattern: /\b(?:_G|_VERSION|assert|collectgarbage|coroutine\.(?:create|resume|running|status|wrap|yield)|debug\.(?:debug|getfenv|gethook|getinfo|getlocal|getmetatable|getregistry|getupvalue|setfenv|sethook|setlocal|setmetatable|setupvalue|traceback)|dofile|error|getfenv|getmetatable|io\.(?:close|flush|input|lines|open|output|popen|read|stderr|stdin|stdout|tmpfile|type|write)|ipairs|load|loadfile|loadstring|math\.(?:abs|acos|asin|atan|atan2|ceil|cos|cosh|deg|exp|floor|fmod|frexp|ldexp|log|log10|max|min|modf|pi|pow|rad|random|randomseed|sin|sinh|sqrt|tan|tanh)|module|next|os\.(?:clock|date|difftime|execute|exit|getenv|remove|rename|setlocale|time|tmpname)|package\.(?:cpath|loaded|loadlib|path|preload|seeall)|pairs|pcall|print|rawequal|rawget|rawset|require|select|setfenv|setmetatable|string\.(?:byte|char|dump|find|format|gmatch|gsub|len|lower|match|rep|reverse|sub|upper)|table\.(?:concat|insert|maxn|remove|sort)|tonumber|tostring|type|unpack|xpcall)\b/,
            inside: {
                punctuation: /\./
            }
        },
        boolean: /\b(?:false|true)\b/,
        number: /(?:\B\.\d+|\b\d+\.\d+|\b\d+(?=[eE]))(?:[eE][-+]?\d+)?\b|\b(?:0x[a-fA-F\d]+|\d+)(?:U?LL)?\b/,
        operator: /\.{3}|[-=]>|~=|(?:[-+*/%<>!=]|\.\.)=?|[:#^]|\b(?:and|or)\b=?|\b(?:not)\b/,
        punctuation: /[.,()[\]{}\\]/
    };
    Prism.languages.moonscript.string[1].inside.interpolation.inside.moonscript.inside = Prism.languages.moonscript;
    Prism.languages.moon = Prism.languages.moonscript;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $0c54d82c2339cc9c$export$2e2bcd8739ae039.displayName = 'n1ql';
$0c54d82c2339cc9c$export$2e2bcd8739ae039.aliases = [];
function $0c54d82c2339cc9c$export$2e2bcd8739ae039(Prism) {
    // https://docs.couchbase.com/server/current/n1ql/n1ql-language-reference/index.html
    Prism.languages.n1ql = {
        comment: {
            pattern: /\/\*[\s\S]*?(?:$|\*\/)|--.*/,
            greedy: true
        },
        string: {
            pattern: /(["'])(?:\\[\s\S]|(?!\1)[^\\]|\1\1)*\1/,
            greedy: true
        },
        identifier: {
            pattern: /`(?:\\[\s\S]|[^\\`]|``)*`/,
            greedy: true
        },
        parameter: /\$[\w.]+/,
        // https://docs.couchbase.com/server/current/n1ql/n1ql-language-reference/reservedwords.html#n1ql-reserved-words
        keyword: /\b(?:ADVISE|ALL|ALTER|ANALYZE|AS|ASC|AT|BEGIN|BINARY|BOOLEAN|BREAK|BUCKET|BUILD|BY|CALL|CAST|CLUSTER|COLLATE|COLLECTION|COMMIT|COMMITTED|CONNECT|CONTINUE|CORRELATE|CORRELATED|COVER|CREATE|CURRENT|DATABASE|DATASET|DATASTORE|DECLARE|DECREMENT|DELETE|DERIVED|DESC|DESCRIBE|DISTINCT|DO|DROP|EACH|ELEMENT|EXCEPT|EXCLUDE|EXECUTE|EXPLAIN|FETCH|FILTER|FLATTEN|FLUSH|FOLLOWING|FOR|FORCE|FROM|FTS|FUNCTION|GOLANG|GRANT|GROUP|GROUPS|GSI|HASH|HAVING|IF|IGNORE|ILIKE|INCLUDE|INCREMENT|INDEX|INFER|INLINE|INNER|INSERT|INTERSECT|INTO|IS|ISOLATION|JAVASCRIPT|JOIN|KEY|KEYS|KEYSPACE|KNOWN|LANGUAGE|LAST|LEFT|LET|LETTING|LEVEL|LIMIT|LSM|MAP|MAPPING|MATCHED|MATERIALIZED|MERGE|MINUS|MISSING|NAMESPACE|NEST|NL|NO|NTH_VALUE|NULL|NULLS|NUMBER|OBJECT|OFFSET|ON|OPTION|OPTIONS|ORDER|OTHERS|OUTER|OVER|PARSE|PARTITION|PASSWORD|PATH|POOL|PRECEDING|PREPARE|PRIMARY|PRIVATE|PRIVILEGE|PROBE|PROCEDURE|PUBLIC|RANGE|RAW|REALM|REDUCE|RENAME|RESPECT|RETURN|RETURNING|REVOKE|RIGHT|ROLE|ROLLBACK|ROW|ROWS|SATISFIES|SAVEPOINT|SCHEMA|SCOPE|SELECT|SELF|SEMI|SET|SHOW|SOME|START|STATISTICS|STRING|SYSTEM|TIES|TO|TRAN|TRANSACTION|TRIGGER|TRUNCATE|UNBOUNDED|UNDER|UNION|UNIQUE|UNKNOWN|UNNEST|UNSET|UPDATE|UPSERT|USE|USER|USING|VALIDATE|VALUE|VALUES|VIA|VIEW|WHERE|WHILE|WINDOW|WITH|WORK|XOR)\b/i,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        boolean: /\b(?:FALSE|TRUE)\b/i,
        number: /(?:\b\d+\.|\B\.)\d+e[+\-]?\d+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
        operator: /[-+*\/%]|!=|==?|\|\||<[>=]?|>=?|\b(?:AND|ANY|ARRAY|BETWEEN|CASE|ELSE|END|EVERY|EXISTS|FIRST|IN|LIKE|NOT|OR|THEN|VALUED|WHEN|WITHIN)\b/i,
        punctuation: /[;[\](),.{}:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $dd0a8f9cf86863f1$export$2e2bcd8739ae039.displayName = 'nand2tetris-hdl';
$dd0a8f9cf86863f1$export$2e2bcd8739ae039.aliases = [];
function $dd0a8f9cf86863f1$export$2e2bcd8739ae039(Prism) {
    Prism.languages['nand2tetris-hdl'] = {
        comment: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
        keyword: /\b(?:BUILTIN|CHIP|CLOCKED|IN|OUT|PARTS)\b/,
        boolean: /\b(?:false|true)\b/,
        function: /\b[A-Za-z][A-Za-z0-9]*(?=\()/,
        number: /\b\d+\b/,
        operator: /=|\.\./,
        punctuation: /[{}[\];(),:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $6be9a541d67ded55$export$2e2bcd8739ae039.displayName = 'naniscript';
$6be9a541d67ded55$export$2e2bcd8739ae039.aliases = [
    'nani'
];
function $6be9a541d67ded55$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var expressionDef = /\{[^\r\n\[\]{}]*\}/;
        var params = {
            'quoted-string': {
                pattern: /"(?:[^"\\]|\\.)*"/,
                alias: 'operator'
            },
            'command-param-id': {
                pattern: /(\s)\w+:/,
                lookbehind: true,
                alias: 'property'
            },
            'command-param-value': [
                {
                    pattern: expressionDef,
                    alias: 'selector'
                },
                {
                    pattern: /([\t ])\S+/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'operator'
                },
                {
                    pattern: /\S(?:.*\S)?/,
                    alias: 'operator'
                }
            ]
        };
        Prism.languages.naniscript = {
            // ; ...
            comment: {
                pattern: /^([\t ]*);.*/m,
                lookbehind: true
            },
            // > ...
            // Define is a control line starting with '>' followed by a word, a space and a text.
            define: {
                pattern: /^>.+/m,
                alias: 'tag',
                inside: {
                    value: {
                        pattern: /(^>\w+[\t ]+)(?!\s)[^{}\r\n]+/,
                        lookbehind: true,
                        alias: 'operator'
                    },
                    key: {
                        pattern: /(^>)\w+/,
                        lookbehind: true
                    }
                }
            },
            // # ...
            label: {
                pattern: /^([\t ]*)#[\t ]*\w+[\t ]*$/m,
                lookbehind: true,
                alias: 'regex'
            },
            command: {
                pattern: /^([\t ]*)@\w+(?=[\t ]|$).*/m,
                lookbehind: true,
                alias: 'function',
                inside: {
                    'command-name': /^@\w+/,
                    expression: {
                        pattern: expressionDef,
                        greedy: true,
                        alias: 'selector'
                    },
                    'command-params': {
                        pattern: /\s*\S[\s\S]*/,
                        inside: params
                    }
                }
            },
            // Generic is any line that doesn't start with operators: ;>#@
            'generic-text': {
                pattern: /(^[ \t]*)[^#@>;\s].*/m,
                lookbehind: true,
                alias: 'punctuation',
                inside: {
                    // \{ ... \} ... \[ ... \] ... \"
                    'escaped-char': /\\[{}\[\]"]/,
                    expression: {
                        pattern: expressionDef,
                        greedy: true,
                        alias: 'selector'
                    },
                    'inline-command': {
                        pattern: /\[[\t ]*\w[^\r\n\[\]]*\]/,
                        greedy: true,
                        alias: 'function',
                        inside: {
                            'command-params': {
                                pattern: /(^\[[\t ]*\w+\b)[\s\S]+(?=\]$)/,
                                lookbehind: true,
                                inside: params
                            },
                            'command-param-name': {
                                pattern: /^(\[[\t ]*)\w+/,
                                lookbehind: true,
                                alias: 'name'
                            },
                            'start-stop-char': /[\[\]]/
                        }
                    }
                }
            }
        };
        Prism.languages.nani = Prism.languages['naniscript'];
        /** @typedef {InstanceType<import("./prism-core")["Token"]>} Token */ /**
     * This hook is used to validate generic-text tokens for balanced brackets.
     * Mark token as bad-line when contains not balanced brackets: {},[]
     */ Prism.hooks.add('after-tokenize', function(env) {
            /** @type {(Token | string)[]} */ var tokens = env.tokens;
            tokens.forEach(function(token) {
                if (typeof token !== 'string' && token.type === 'generic-text') {
                    var content = getTextContent(token);
                    if (!isBracketsBalanced(content)) {
                        token.type = 'bad-line';
                        token.content = content;
                    }
                }
            });
        });
        /**
     * @param {string} input
     * @returns {boolean}
     */ function isBracketsBalanced(input) {
            var brackets = '[]{}';
            var stack = [];
            for(var i = 0; i < input.length; i++){
                var bracket = input[i];
                var bracketsIndex = brackets.indexOf(bracket);
                if (bracketsIndex !== -1) {
                    if (bracketsIndex % 2 === 0) stack.push(bracketsIndex + 1);
                    else if (stack.pop() !== bracketsIndex) return false;
                }
            }
            return stack.length === 0;
        }
        /**
     * @param {string | Token | (string | Token)[]} token
     * @returns {string}
     */ function getTextContent(token) {
            if (typeof token === 'string') return token;
            else if (Array.isArray(token)) return token.map(getTextContent).join('');
            else return getTextContent(token.content);
        }
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $436bbebbe3139e7e$export$2e2bcd8739ae039.displayName = 'nasm';
$436bbebbe3139e7e$export$2e2bcd8739ae039.aliases = [];
function $436bbebbe3139e7e$export$2e2bcd8739ae039(Prism) {
    Prism.languages.nasm = {
        comment: /;.*$/m,
        string: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
        label: {
            pattern: /(^\s*)[A-Za-z._?$][\w.?$@~#]*:/m,
            lookbehind: true,
            alias: 'function'
        },
        keyword: [
            /\[?BITS (?:16|32|64)\]?/,
            {
                pattern: /(^\s*)section\s*[a-z.]+:?/im,
                lookbehind: true
            },
            /(?:extern|global)[^;\r\n]*/i,
            /(?:CPU|DEFAULT|FLOAT).*$/m
        ],
        register: {
            pattern: /\b(?:st\d|[xyz]mm\d\d?|[cdt]r\d|r\d\d?[bwd]?|[er]?[abcd]x|[abcd][hl]|[er]?(?:bp|di|si|sp)|[cdefgs]s)\b/i,
            alias: 'variable'
        },
        number: /(?:\b|(?=\$))(?:0[hx](?:\.[\da-f]+|[\da-f]+(?:\.[\da-f]+)?)(?:p[+-]?\d+)?|\d[\da-f]+[hx]|\$\d[\da-f]*|0[oq][0-7]+|[0-7]+[oq]|0[by][01]+|[01]+[by]|0[dt]\d+|(?:\d+(?:\.\d+)?|\.\d+)(?:\.?e[+-]?\d+)?[dt]?)\b/i,
        operator: /[\[\]*+\-\/%<>=&|$!]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $4b0c7b814ccf677f$export$2e2bcd8739ae039.displayName = 'neon';
$4b0c7b814ccf677f$export$2e2bcd8739ae039.aliases = [];
function $4b0c7b814ccf677f$export$2e2bcd8739ae039(Prism) {
    Prism.languages.neon = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        datetime: {
            pattern: /(^|[[{(=:,\s])\d\d\d\d-\d\d?-\d\d?(?:(?:[Tt]| +)\d\d?:\d\d:\d\d(?:\.\d*)? *(?:Z|[-+]\d\d?(?::?\d\d)?)?)?(?=$|[\]}),\s])/,
            lookbehind: true,
            alias: 'number'
        },
        key: {
            pattern: /(^|[[{(,\s])[^,:=[\]{}()'"\s]+(?=\s*:(?:$|[\]}),\s])|\s*=)/,
            lookbehind: true,
            alias: 'property'
        },
        number: {
            pattern: /(^|[[{(=:,\s])[+-]?(?:0x[\da-fA-F]+|0o[0-7]+|0b[01]+|(?:\d+(?:\.\d*)?|\.?\d+)(?:[eE][+-]?\d+)?)(?=$|[\]}),:=\s])/,
            lookbehind: true
        },
        boolean: {
            pattern: /(^|[[{(=:,\s])(?:false|no|true|yes)(?=$|[\]}),:=\s])/i,
            lookbehind: true
        },
        null: {
            pattern: /(^|[[{(=:,\s])(?:null)(?=$|[\]}),:=\s])/i,
            lookbehind: true,
            alias: 'keyword'
        },
        string: {
            pattern: /(^|[[{(=:,\s])(?:('''|""")\r?\n(?:(?:[^\r\n]|\r?\n(?![\t ]*\2))*\r?\n)?[\t ]*\2|'[^'\r\n]*'|"(?:\\.|[^\\"\r\n])*")/,
            lookbehind: true,
            greedy: true
        },
        literal: {
            pattern: /(^|[[{(=:,\s])(?:[^#"',:=[\]{}()\s`-]|[:-][^"',=[\]{}()\s])(?:[^,:=\]})(\s]|:(?![\s,\]})]|$)|[ \t]+[^#,:=\]})(\s])*/,
            lookbehind: true,
            alias: 'string'
        },
        punctuation: /[,:=[\]{}()-]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $937b72076b7797c7$export$2e2bcd8739ae039.displayName = 'nevod';
$937b72076b7797c7$export$2e2bcd8739ae039.aliases = [];
function $937b72076b7797c7$export$2e2bcd8739ae039(Prism) {
    Prism.languages.nevod = {
        comment: /\/\/.*|(?:\/\*[\s\S]*?(?:\*\/|$))/,
        string: {
            pattern: /(?:"(?:""|[^"])*"(?!")|'(?:''|[^'])*'(?!'))!?\*?/,
            greedy: true,
            inside: {
                'string-attrs': /!$|!\*$|\*$/
            }
        },
        namespace: {
            pattern: /(@namespace\s+)[a-zA-Z0-9\-.]+(?=\s*\{)/,
            lookbehind: true
        },
        pattern: {
            pattern: /(@pattern\s+)?#?[a-zA-Z0-9\-.]+(?:\s*\(\s*(?:~\s*)?[a-zA-Z0-9\-.]+\s*(?:,\s*(?:~\s*)?[a-zA-Z0-9\-.]*)*\))?(?=\s*=)/,
            lookbehind: true,
            inside: {
                'pattern-name': {
                    pattern: /^#?[a-zA-Z0-9\-.]+/,
                    alias: 'class-name'
                },
                fields: {
                    pattern: /\(.*\)/,
                    inside: {
                        'field-name': {
                            pattern: /[a-zA-Z0-9\-.]+/,
                            alias: 'variable'
                        },
                        punctuation: /[,()]/,
                        operator: {
                            pattern: /~/,
                            alias: 'field-hidden-mark'
                        }
                    }
                }
            }
        },
        search: {
            pattern: /(@search\s+|#)[a-zA-Z0-9\-.]+(?:\.\*)?(?=\s*;)/,
            alias: 'function',
            lookbehind: true
        },
        keyword: /@(?:having|inside|namespace|outside|pattern|require|search|where)\b/,
        'standard-pattern': {
            pattern: /\b(?:Alpha|AlphaNum|Any|Blank|End|LineBreak|Num|NumAlpha|Punct|Space|Start|Symbol|Word|WordBreak)\b(?:\([a-zA-Z0-9\-.,\s+]*\))?/,
            inside: {
                'standard-pattern-name': {
                    pattern: /^[a-zA-Z0-9\-.]+/,
                    alias: 'builtin'
                },
                quantifier: {
                    pattern: /\b\d+(?:\s*\+|\s*-\s*\d+)?(?!\w)/,
                    alias: 'number'
                },
                'standard-pattern-attr': {
                    pattern: /[a-zA-Z0-9\-.]+/,
                    alias: 'builtin'
                },
                punctuation: /[,()]/
            }
        },
        quantifier: {
            pattern: /\b\d+(?:\s*\+|\s*-\s*\d+)?(?!\w)/,
            alias: 'number'
        },
        operator: [
            {
                pattern: /=/,
                alias: 'pattern-def'
            },
            {
                pattern: /&/,
                alias: 'conjunction'
            },
            {
                pattern: /~/,
                alias: 'exception'
            },
            {
                pattern: /\?/,
                alias: 'optionality'
            },
            {
                pattern: /[[\]]/,
                alias: 'repetition'
            },
            {
                pattern: /[{}]/,
                alias: 'variation'
            },
            {
                pattern: /[+_]/,
                alias: 'sequence'
            },
            {
                pattern: /\.{2,3}/,
                alias: 'span'
            }
        ],
        'field-capture': [
            {
                pattern: /([a-zA-Z0-9\-.]+\s*\()\s*[a-zA-Z0-9\-.]+\s*:\s*[a-zA-Z0-9\-.]+(?:\s*,\s*[a-zA-Z0-9\-.]+\s*:\s*[a-zA-Z0-9\-.]+)*(?=\s*\))/,
                lookbehind: true,
                inside: {
                    'field-name': {
                        pattern: /[a-zA-Z0-9\-.]+/,
                        alias: 'variable'
                    },
                    colon: /:/
                }
            },
            {
                pattern: /[a-zA-Z0-9\-.]+\s*:/,
                inside: {
                    'field-name': {
                        pattern: /[a-zA-Z0-9\-.]+/,
                        alias: 'variable'
                    },
                    colon: /:/
                }
            }
        ],
        punctuation: /[:;,()]/,
        name: /[a-zA-Z0-9\-.]+/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $93be80b0f58505d4$export$2e2bcd8739ae039.displayName = 'nginx';
$93be80b0f58505d4$export$2e2bcd8739ae039.aliases = [];
function $93be80b0f58505d4$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var variable = /\$(?:\w[a-z\d]*(?:_[^\x00-\x1F\s"'\\()$]*)?|\{[^}\s"'\\]+\})/i;
        Prism.languages.nginx = {
            comment: {
                pattern: /(^|[\s{};])#.*/,
                lookbehind: true,
                greedy: true
            },
            directive: {
                pattern: /(^|\s)\w(?:[^;{}"'\\\s]|\\.|"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*'|\s+(?:#.*(?!.)|(?![#\s])))*?(?=\s*[;{])/,
                lookbehind: true,
                greedy: true,
                inside: {
                    string: {
                        pattern: /((?:^|[^\\])(?:\\\\)*)(?:"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*')/,
                        lookbehind: true,
                        greedy: true,
                        inside: {
                            escape: {
                                pattern: /\\["'\\nrt]/,
                                alias: 'entity'
                            },
                            variable: variable
                        }
                    },
                    comment: {
                        pattern: /(\s)#.*/,
                        lookbehind: true,
                        greedy: true
                    },
                    keyword: {
                        pattern: /^\S+/,
                        greedy: true
                    },
                    // other patterns
                    boolean: {
                        pattern: /(\s)(?:off|on)(?!\S)/,
                        lookbehind: true
                    },
                    number: {
                        pattern: /(\s)\d+[a-z]*(?!\S)/i,
                        lookbehind: true
                    },
                    variable: variable
                }
            },
            punctuation: /[{};]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $833f205419d7e6ea$export$2e2bcd8739ae039.displayName = 'nim';
$833f205419d7e6ea$export$2e2bcd8739ae039.aliases = [];
function $833f205419d7e6ea$export$2e2bcd8739ae039(Prism) {
    Prism.languages.nim = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        string: {
            // Double-quoted strings can be prefixed by an identifier (Generalized raw string literals)
            pattern: /(?:\b(?!\d)(?:\w|\\x[89a-fA-F][0-9a-fA-F])+)?(?:"""[\s\S]*?"""(?!")|"(?:\\[\s\S]|""|[^"\\])*")/,
            greedy: true
        },
        char: {
            // Character literals are handled specifically to prevent issues with numeric type suffixes
            pattern: /'(?:\\(?:\d+|x[\da-fA-F]{0,2}|.)|[^'])'/,
            greedy: true
        },
        function: {
            pattern: /(?:(?!\d)(?:\w|\\x[89a-fA-F][0-9a-fA-F])+|`[^`\r\n]+`)\*?(?:\[[^\]]+\])?(?=\s*\()/,
            greedy: true,
            inside: {
                operator: /\*$/
            }
        },
        // We don't want to highlight operators (and anything really) inside backticks
        identifier: {
            pattern: /`[^`\r\n]+`/,
            greedy: true,
            inside: {
                punctuation: /`/
            }
        },
        // The negative look ahead prevents wrong highlighting of the .. operator
        number: /\b(?:0[xXoObB][\da-fA-F_]+|\d[\d_]*(?:(?!\.\.)\.[\d_]*)?(?:[eE][+-]?\d[\d_]*)?)(?:'?[iuf]\d*)?/,
        keyword: /\b(?:addr|as|asm|atomic|bind|block|break|case|cast|concept|const|continue|converter|defer|discard|distinct|do|elif|else|end|enum|except|export|finally|for|from|func|generic|if|import|include|interface|iterator|let|macro|method|mixin|nil|object|out|proc|ptr|raise|ref|return|static|template|try|tuple|type|using|var|when|while|with|without|yield)\b/,
        operator: {
            // Look behind and look ahead prevent wrong highlighting of punctuations [. .] {. .} (. .)
            // but allow the slice operator .. to take precedence over them
            // One can define his own operators in Nim so all combination of operators might be an operator.
            pattern: /(^|[({\[](?=\.\.)|(?![({\[]\.).)(?:(?:[=+\-*\/<>@$~&%|!?^:\\]|\.\.|\.(?![)}\]]))+|\b(?:and|div|in|is|isnot|mod|not|notin|of|or|shl|shr|xor)\b)/m,
            lookbehind: true
        },
        punctuation: /[({\[]\.|\.[)}\]]|[`(){}\[\],:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $f6e28ce82e52815a$export$2e2bcd8739ae039.displayName = 'nix';
$f6e28ce82e52815a$export$2e2bcd8739ae039.aliases = [];
function $f6e28ce82e52815a$export$2e2bcd8739ae039(Prism) {
    Prism.languages.nix = {
        comment: {
            pattern: /\/\*[\s\S]*?\*\/|#.*/,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"\\]|\\[\s\S])*"|''(?:(?!'')[\s\S]|''(?:'|\\|\$\{))*''/,
            greedy: true,
            inside: {
                interpolation: {
                    // The lookbehind ensures the ${} is not preceded by \ or ''
                    pattern: /(^|(?:^|(?!'').)[^\\])\$\{(?:[^{}]|\{[^}]*\})*\}/,
                    lookbehind: true,
                    inside: null // see below
                }
            }
        },
        url: [
            /\b(?:[a-z]{3,7}:\/\/)[\w\-+%~\/.:#=?&]+/,
            {
                pattern: /([^\/])(?:[\w\-+%~.:#=?&]*(?!\/\/)[\w\-+%~\/.:#=?&])?(?!\/\/)\/[\w\-+%~\/.:#=?&]*/,
                lookbehind: true
            }
        ],
        antiquotation: {
            pattern: /\$(?=\{)/,
            alias: 'important'
        },
        number: /\b\d+\b/,
        keyword: /\b(?:assert|builtins|else|if|in|inherit|let|null|or|then|with)\b/,
        function: /\b(?:abort|add|all|any|attrNames|attrValues|baseNameOf|compareVersions|concatLists|currentSystem|deepSeq|derivation|dirOf|div|elem(?:At)?|fetch(?:Tarball|url)|filter(?:Source)?|fromJSON|genList|getAttr|getEnv|hasAttr|hashString|head|import|intersectAttrs|is(?:Attrs|Bool|Function|Int|List|Null|String)|length|lessThan|listToAttrs|map|mul|parseDrvName|pathExists|read(?:Dir|File)|removeAttrs|replaceStrings|seq|sort|stringLength|sub(?:string)?|tail|throw|to(?:File|JSON|Path|String|XML)|trace|typeOf)\b|\bfoldl'\B/,
        boolean: /\b(?:false|true)\b/,
        operator: /[=!<>]=?|\+\+?|\|\||&&|\/\/|->?|[?@]/,
        punctuation: /[{}()[\].,:;]/
    };
    Prism.languages.nix.string.inside.interpolation.inside = Prism.languages.nix;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $a71447da60e1f6e1$export$2e2bcd8739ae039.displayName = 'nsis';
$a71447da60e1f6e1$export$2e2bcd8739ae039.aliases = [];
function $a71447da60e1f6e1$export$2e2bcd8739ae039(Prism) {
    /**
   * Original by Jan T. Sott (http://github.com/idleberg)
   *
   * Includes all commands and plug-ins shipped with NSIS 3.08
   */ Prism.languages.nsis = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|[#;].*)/,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        keyword: {
            pattern: /(^[\t ]*)(?:Abort|Add(?:BrandingImage|Size)|AdvSplash|Allow(?:RootDirInstall|SkipFiles)|AutoCloseWindow|BG(?:Font|Gradient|Image)|Banner|BrandingText|BringToFront|CRCCheck|Call(?:InstDLL)?|Caption|ChangeUI|CheckBitmap|ClearErrors|CompletedText|ComponentText|CopyFiles|Create(?:Directory|Font|ShortCut)|Delete(?:INISec|INIStr|RegKey|RegValue)?|Detail(?:Print|sButtonText)|Dialer|Dir(?:Text|Var|Verify)|EnableWindow|Enum(?:RegKey|RegValue)|Exch|Exec(?:Shell(?:Wait)?|Wait)?|ExpandEnvStrings|File(?:BufSize|Close|ErrorText|Open|Read|ReadByte|ReadUTF16LE|ReadWord|Seek|Write|WriteByte|WriteUTF16LE|WriteWord)?|Find(?:Close|First|Next|Window)|FlushINI|Get(?:CurInstType|CurrentAddress|DLLVersion(?:Local)?|DlgItem|ErrorLevel|FileTime(?:Local)?|FullPathName|Function(?:Address|End)?|InstDirError|KnownFolderPath|LabelAddress|TempFileName|WinVer)|Goto|HideWindow|Icon|If(?:Abort|Errors|FileExists|RebootFlag|RtlLanguage|ShellVarContextAll|Silent)|InitPluginsDir|InstProgressFlags|Inst(?:Type(?:GetText|SetText)?)|Install(?:ButtonText|Colors|Dir(?:RegKey)?)|Int(?:64|Ptr)?CmpU?|Int(?:64)?Fmt|Int(?:Ptr)?Op|IsWindow|Lang(?:DLL|String)|License(?:BkColor|Data|ForceSelection|LangString|Text)|LoadLanguageFile|LockWindow|Log(?:Set|Text)|Manifest(?:DPIAware|SupportedOS)|Math|MessageBox|MiscButtonText|NSISdl|Name|Nop|OutFile|PE(?:DllCharacteristics|SubsysVer)|Page(?:Callbacks)?|Pop|Push|Quit|RMDir|Read(?:EnvStr|INIStr|RegDWORD|RegStr)|Reboot|RegDLL|Rename|RequestExecutionLevel|ReserveFile|Return|SearchPath|Section(?:End|GetFlags|GetInstTypes|GetSize|GetText|Group|In|SetFlags|SetInstTypes|SetSize|SetText)?|SendMessage|Set(?:AutoClose|BrandingImage|Compress|Compressor(?:DictSize)?|CtlColors|CurInstType|DatablockOptimize|DateSave|Details(?:Print|View)|ErrorLevel|Errors|FileAttributes|Font|OutPath|Overwrite|PluginUnload|RebootFlag|RegView|ShellVarContext|Silent)|Show(?:InstDetails|UninstDetails|Window)|Silent(?:Install|UnInstall)|Sleep|SpaceTexts|Splash|StartMenu|Str(?:CmpS?|Cpy|Len)|SubCaption|System|Target|UnRegDLL|Unicode|UninstPage|Uninstall(?:ButtonText|Caption|Icon|SubCaption|Text)|UserInfo|VI(?:AddVersionKey|FileVersion|ProductVersion)|VPatch|Var|WindowIcon|Write(?:INIStr|Reg(?:Bin|DWORD|ExpandStr|MultiStr|None|Str)|Uninstaller)|XPStyle|ns(?:Dialogs|Exec))\b/m,
            lookbehind: true
        },
        property: /\b(?:ARCHIVE|FILE_(?:ATTRIBUTE_ARCHIVE|ATTRIBUTE_NORMAL|ATTRIBUTE_OFFLINE|ATTRIBUTE_READONLY|ATTRIBUTE_SYSTEM|ATTRIBUTE_TEMPORARY)|HK(?:(?:CR|CU|LM)(?:32|64)?|DD|PD|U)|HKEY_(?:CLASSES_ROOT|CURRENT_CONFIG|CURRENT_USER|DYN_DATA|LOCAL_MACHINE|PERFORMANCE_DATA|USERS)|ID(?:ABORT|CANCEL|IGNORE|NO|OK|RETRY|YES)|MB_(?:ABORTRETRYIGNORE|DEFBUTTON1|DEFBUTTON2|DEFBUTTON3|DEFBUTTON4|ICONEXCLAMATION|ICONINFORMATION|ICONQUESTION|ICONSTOP|OK|OKCANCEL|RETRYCANCEL|RIGHT|RTLREADING|SETFOREGROUND|TOPMOST|USERICON|YESNO)|NORMAL|OFFLINE|READONLY|SHCTX|SHELL_CONTEXT|SYSTEM|TEMPORARY|admin|all|auto|both|colored|false|force|hide|highest|lastused|leave|listonly|none|normal|notset|off|on|open|print|show|silent|silentlog|smooth|textonly|true|user)\b/,
        constant: /\$\{[!\w\.:\^-]+\}|\$\([!\w\.:\^-]+\)/,
        variable: /\$\w[\w\.]*/,
        number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
        operator: /--?|\+\+?|<=?|>=?|==?=?|&&?|\|\|?|[?*\/~^%]/,
        punctuation: /[{}[\];(),.:]/,
        important: {
            pattern: /(^[\t ]*)!(?:addincludedir|addplugindir|appendfile|cd|define|delfile|echo|else|endif|error|execute|finalize|getdllversion|gettlbversion|if|ifdef|ifmacrodef|ifmacrondef|ifndef|include|insertmacro|macro|macroend|makensis|packhdr|pragma|searchparse|searchreplace|system|tempfile|undef|verbose|warning)\b/im,
            lookbehind: true
        }
    };
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $db79ad093bda0678$export$2e2bcd8739ae039.displayName = 'ocaml';
$db79ad093bda0678$export$2e2bcd8739ae039.aliases = [];
function $db79ad093bda0678$export$2e2bcd8739ae039(Prism) {
    // https://ocaml.org/manual/lex.html
    Prism.languages.ocaml = {
        comment: {
            pattern: /\(\*[\s\S]*?\*\)/,
            greedy: true
        },
        char: {
            pattern: /'(?:[^\\\r\n']|\\(?:.|[ox]?[0-9a-f]{1,3}))'/i,
            greedy: true
        },
        string: [
            {
                pattern: /"(?:\\(?:[\s\S]|\r\n)|[^\\\r\n"])*"/,
                greedy: true
            },
            {
                pattern: /\{([a-z_]*)\|[\s\S]*?\|\1\}/,
                greedy: true
            }
        ],
        number: [
            // binary and octal
            /\b(?:0b[01][01_]*|0o[0-7][0-7_]*)\b/i,
            // hexadecimal
            /\b0x[a-f0-9][a-f0-9_]*(?:\.[a-f0-9_]*)?(?:p[+-]?\d[\d_]*)?(?!\w)/i,
            // decimal
            /\b\d[\d_]*(?:\.[\d_]*)?(?:e[+-]?\d[\d_]*)?(?!\w)/i
        ],
        directive: {
            pattern: /\B#\w+/,
            alias: 'property'
        },
        label: {
            pattern: /\B~\w+/,
            alias: 'property'
        },
        'type-variable': {
            pattern: /\B'\w+/,
            alias: 'function'
        },
        variant: {
            pattern: /`\w+/,
            alias: 'symbol'
        },
        // For the list of keywords and operators,
        // see: http://caml.inria.fr/pub/docs/manual-ocaml/lex.html#sec84
        keyword: /\b(?:as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|match|method|module|mutable|new|nonrec|object|of|open|private|rec|sig|struct|then|to|try|type|val|value|virtual|when|where|while|with)\b/,
        boolean: /\b(?:false|true)\b/,
        'operator-like-punctuation': {
            pattern: /\[[<>|]|[>|]\]|\{<|>\}/,
            alias: 'punctuation'
        },
        // Custom operators are allowed
        operator: /\.[.~]|:[=>]|[=<>@^|&+\-*\/$%!?~][!$%&*+\-.\/:<=>?@^|~]*|\b(?:and|asr|land|lor|lsl|lsr|lxor|mod|or)\b/,
        punctuation: /;;|::|[(){}\[\].,:;#]|\b_\b/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $4ed009a5750aab51$export$2e2bcd8739ae039.displayName = 'odin';
$4ed009a5750aab51$export$2e2bcd8739ae039.aliases = [];
function $4ed009a5750aab51$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var escapes = /\\(?:["'\\abefnrtv]|0[0-7]{2}|U[\dA-Fa-f]{6}|u[\dA-Fa-f]{4}|x[\dA-Fa-f]{2})/;
        Prism.languages.odin = {
            /**
       * The current implementation supports only 1 level of nesting.
       *
       * @author Michael Schmidt
       * @author edukisto
       */ comment: [
                {
                    pattern: /\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:\*(?!\/)|[^*])*(?:\*\/|$))*(?:\*\/|$)/,
                    greedy: true
                },
                {
                    pattern: /#![^\n\r]*/,
                    greedy: true
                },
                {
                    pattern: /\/\/[^\n\r]*/,
                    greedy: true
                }
            ],
            /**
       * Should be found before strings because of '"'"- and '`'`-like sequences.
       */ char: {
                pattern: /'(?:\\(?:.|[0Uux][0-9A-Fa-f]{1,6})|[^\n\r'\\])'/,
                greedy: true,
                inside: {
                    symbol: escapes
                }
            },
            string: [
                {
                    pattern: /`[^`]*`/,
                    greedy: true
                },
                {
                    pattern: /"(?:\\.|[^\n\r"\\])*"/,
                    greedy: true,
                    inside: {
                        symbol: escapes
                    }
                }
            ],
            directive: {
                pattern: /#\w+/,
                alias: 'property'
            },
            number: /\b0(?:b[01_]+|d[\d_]+|h_*(?:(?:(?:[\dA-Fa-f]_*){8}){1,2}|(?:[\dA-Fa-f]_*){4})|o[0-7_]+|x[\dA-F_a-f]+|z[\dAB_ab]+)\b|(?:\b\d+(?:\.(?!\.)\d*)?|\B\.\d+)(?:[Ee][+-]?\d*)?[ijk]?(?!\w)/,
            discard: {
                pattern: /\b_\b/,
                alias: 'keyword'
            },
            'procedure-definition': {
                pattern: /\b\w+(?=[ \t]*(?::\s*){2}proc\b)/,
                alias: 'function'
            },
            keyword: /\b(?:asm|auto_cast|bit_set|break|case|cast|context|continue|defer|distinct|do|dynamic|else|enum|fallthrough|for|foreign|if|import|in|map|matrix|not_in|or_else|or_return|package|proc|return|struct|switch|transmute|typeid|union|using|when|where)\b/,
            /**
       * false, nil, true can be used as procedure names. "_" and keywords can't.
       */ 'procedure-name': {
                pattern: /\b\w+(?=[ \t]*\()/,
                alias: 'function'
            },
            boolean: /\b(?:false|nil|true)\b/,
            'constant-parameter-sign': {
                pattern: /\$/,
                alias: 'important'
            },
            undefined: {
                pattern: /---/,
                alias: 'operator'
            },
            arrow: {
                pattern: /->/,
                alias: 'punctuation'
            },
            operator: /\+\+|--|\.\.[<=]?|(?:&~|[-!*+/=~]|[%&<>|]{1,2})=?|[?^]/,
            punctuation: /[(),.:;@\[\]{}]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$2aa93c3806b01798$export$2e2bcd8739ae039.displayName = 'opencl';
$2aa93c3806b01798$export$2e2bcd8739ae039.aliases = [];
function $2aa93c3806b01798$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f4e156ae6ed8d0a0$export$2e2bcd8739ae039));
    (function(Prism) {
        /* OpenCL kernel language */ Prism.languages.opencl = Prism.languages.extend('c', {
            // Extracted from the official specs (2.0) and http://streamcomputing.eu/downloads/?opencl.lang (opencl-keywords, opencl-types) and http://sourceforge.net/tracker/?func=detail&aid=2957794&group_id=95717&atid=612384 (Words2, partly Words3)
            keyword: /\b(?:(?:__)?(?:constant|global|kernel|local|private|read_only|read_write|write_only)|__attribute__|auto|(?:bool|u?(?:char|int|long|short)|half|quad)(?:2|3|4|8|16)?|break|case|complex|const|continue|(?:double|float)(?:16(?:x(?:1|2|4|8|16))?|1x(?:1|2|4|8|16)|2(?:x(?:1|2|4|8|16))?|3|4(?:x(?:1|2|4|8|16))?|8(?:x(?:1|2|4|8|16))?)?|default|do|else|enum|extern|for|goto|if|imaginary|inline|packed|pipe|register|restrict|return|signed|sizeof|static|struct|switch|typedef|uniform|union|unsigned|void|volatile|while)\b/,
            // Extracted from http://streamcomputing.eu/downloads/?opencl.lang (opencl-const)
            // Math Constants: https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/mathConstants.html
            // Macros and Limits: https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/macroLimits.html
            number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[fuhl]{0,4}/i,
            boolean: /\b(?:false|true)\b/,
            'constant-opencl-kernel': {
                pattern: /\b(?:CHAR_(?:BIT|MAX|MIN)|CLK_(?:ADDRESS_(?:CLAMP(?:_TO_EDGE)?|NONE|REPEAT)|FILTER_(?:LINEAR|NEAREST)|(?:GLOBAL|LOCAL)_MEM_FENCE|NORMALIZED_COORDS_(?:FALSE|TRUE))|CL_(?:BGRA|(?:HALF_)?FLOAT|INTENSITY|LUMINANCE|A?R?G?B?[Ax]?|(?:(?:UN)?SIGNED|[US]NORM)_(?:INT(?:8|16|32))|UNORM_(?:INT_101010|SHORT_(?:555|565)))|(?:DBL|FLT|HALF)_(?:DIG|EPSILON|(?:MAX|MIN)(?:(?:_10)?_EXP)?|MANT_DIG)|FLT_RADIX|HUGE_VALF?|(?:INT|LONG|SCHAR|SHRT)_(?:MAX|MIN)|INFINITY|MAXFLOAT|M_(?:[12]_PI|2_SQRTPI|E|LN(?:2|10)|LOG(?:2|10)E?|PI(?:_[24])?|SQRT(?:1_2|2))(?:_F|_H)?|NAN|(?:UCHAR|UINT|ULONG|USHRT)_MAX)\b/,
                alias: 'constant'
            }
        });
        Prism.languages.insertBefore('opencl', 'class-name', {
            // https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/scalarDataTypes.html
            // https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/otherDataTypes.html
            'builtin-type': {
                pattern: /\b(?:_cl_(?:command_queue|context|device_id|event|kernel|mem|platform_id|program|sampler)|cl_(?:image_format|mem_fence_flags)|clk_event_t|event_t|image(?:1d_(?:array_|buffer_)?t|2d_(?:array_(?:depth_|msaa_depth_|msaa_)?|depth_|msaa_depth_|msaa_)?t|3d_t)|intptr_t|ndrange_t|ptrdiff_t|queue_t|reserve_id_t|sampler_t|size_t|uintptr_t)\b/,
                alias: 'keyword'
            }
        });
        var attributes = {
            // Extracted from http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-types and opencl-host)
            'type-opencl-host': {
                pattern: /\b(?:cl_(?:GLenum|GLint|GLuin|addressing_mode|bitfield|bool|buffer_create_type|build_status|channel_(?:order|type)|(?:u?(?:char|int|long|short)|double|float)(?:2|3|4|8|16)?|command_(?:queue(?:_info|_properties)?|type)|context(?:_info|_properties)?|device_(?:exec_capabilities|fp_config|id|info|local_mem_type|mem_cache_type|type)|(?:event|sampler)(?:_info)?|filter_mode|half|image_info|kernel(?:_info|_work_group_info)?|map_flags|mem(?:_flags|_info|_object_type)?|platform_(?:id|info)|profiling_info|program(?:_build_info|_info)?))\b/,
                alias: 'keyword'
            },
            'boolean-opencl-host': {
                pattern: /\bCL_(?:FALSE|TRUE)\b/,
                alias: 'boolean'
            },
            // Extracted from cl.h (2.0) and http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-const)
            'constant-opencl-host': {
                pattern: /\bCL_(?:A|ABGR|ADDRESS_(?:CLAMP(?:_TO_EDGE)?|MIRRORED_REPEAT|NONE|REPEAT)|ARGB|BGRA|BLOCKING|BUFFER_CREATE_TYPE_REGION|BUILD_(?:ERROR|IN_PROGRESS|NONE|PROGRAM_FAILURE|SUCCESS)|COMMAND_(?:ACQUIRE_GL_OBJECTS|BARRIER|COPY_(?:BUFFER(?:_RECT|_TO_IMAGE)?|IMAGE(?:_TO_BUFFER)?)|FILL_(?:BUFFER|IMAGE)|MAP(?:_BUFFER|_IMAGE)|MARKER|MIGRATE(?:_SVM)?_MEM_OBJECTS|NATIVE_KERNEL|NDRANGE_KERNEL|READ_(?:BUFFER(?:_RECT)?|IMAGE)|RELEASE_GL_OBJECTS|SVM_(?:FREE|MAP|MEMCPY|MEMFILL|UNMAP)|TASK|UNMAP_MEM_OBJECT|USER|WRITE_(?:BUFFER(?:_RECT)?|IMAGE))|COMPILER_NOT_AVAILABLE|COMPILE_PROGRAM_FAILURE|COMPLETE|CONTEXT_(?:DEVICES|INTEROP_USER_SYNC|NUM_DEVICES|PLATFORM|PROPERTIES|REFERENCE_COUNT)|DEPTH(?:_STENCIL)?|DEVICE_(?:ADDRESS_BITS|AFFINITY_DOMAIN_(?:L[1-4]_CACHE|NEXT_PARTITIONABLE|NUMA)|AVAILABLE|BUILT_IN_KERNELS|COMPILER_AVAILABLE|DOUBLE_FP_CONFIG|ENDIAN_LITTLE|ERROR_CORRECTION_SUPPORT|EXECUTION_CAPABILITIES|EXTENSIONS|GLOBAL_(?:MEM_(?:CACHELINE_SIZE|CACHE_SIZE|CACHE_TYPE|SIZE)|VARIABLE_PREFERRED_TOTAL_SIZE)|HOST_UNIFIED_MEMORY|IL_VERSION|IMAGE(?:2D_MAX_(?:HEIGHT|WIDTH)|3D_MAX_(?:DEPTH|HEIGHT|WIDTH)|_BASE_ADDRESS_ALIGNMENT|_MAX_ARRAY_SIZE|_MAX_BUFFER_SIZE|_PITCH_ALIGNMENT|_SUPPORT)|LINKER_AVAILABLE|LOCAL_MEM_SIZE|LOCAL_MEM_TYPE|MAX_(?:CLOCK_FREQUENCY|COMPUTE_UNITS|CONSTANT_ARGS|CONSTANT_BUFFER_SIZE|GLOBAL_VARIABLE_SIZE|MEM_ALLOC_SIZE|NUM_SUB_GROUPS|ON_DEVICE_(?:EVENTS|QUEUES)|PARAMETER_SIZE|PIPE_ARGS|READ_IMAGE_ARGS|READ_WRITE_IMAGE_ARGS|SAMPLERS|WORK_GROUP_SIZE|WORK_ITEM_DIMENSIONS|WORK_ITEM_SIZES|WRITE_IMAGE_ARGS)|MEM_BASE_ADDR_ALIGN|MIN_DATA_TYPE_ALIGN_SIZE|NAME|NATIVE_VECTOR_WIDTH_(?:CHAR|DOUBLE|FLOAT|HALF|INT|LONG|SHORT)|NOT_(?:AVAILABLE|FOUND)|OPENCL_C_VERSION|PARENT_DEVICE|PARTITION_(?:AFFINITY_DOMAIN|BY_AFFINITY_DOMAIN|BY_COUNTS|BY_COUNTS_LIST_END|EQUALLY|FAILED|MAX_SUB_DEVICES|PROPERTIES|TYPE)|PIPE_MAX_(?:ACTIVE_RESERVATIONS|PACKET_SIZE)|PLATFORM|PREFERRED_(?:GLOBAL_ATOMIC_ALIGNMENT|INTEROP_USER_SYNC|LOCAL_ATOMIC_ALIGNMENT|PLATFORM_ATOMIC_ALIGNMENT|VECTOR_WIDTH_(?:CHAR|DOUBLE|FLOAT|HALF|INT|LONG|SHORT))|PRINTF_BUFFER_SIZE|PROFILE|PROFILING_TIMER_RESOLUTION|QUEUE_(?:ON_(?:DEVICE_(?:MAX_SIZE|PREFERRED_SIZE|PROPERTIES)|HOST_PROPERTIES)|PROPERTIES)|REFERENCE_COUNT|SINGLE_FP_CONFIG|SUB_GROUP_INDEPENDENT_FORWARD_PROGRESS|SVM_(?:ATOMICS|CAPABILITIES|COARSE_GRAIN_BUFFER|FINE_GRAIN_BUFFER|FINE_GRAIN_SYSTEM)|TYPE(?:_ACCELERATOR|_ALL|_CPU|_CUSTOM|_DEFAULT|_GPU)?|VENDOR(?:_ID)?|VERSION)|DRIVER_VERSION|EVENT_(?:COMMAND_(?:EXECUTION_STATUS|QUEUE|TYPE)|CONTEXT|REFERENCE_COUNT)|EXEC_(?:KERNEL|NATIVE_KERNEL|STATUS_ERROR_FOR_EVENTS_IN_WAIT_LIST)|FILTER_(?:LINEAR|NEAREST)|FLOAT|FP_(?:CORRECTLY_ROUNDED_DIVIDE_SQRT|DENORM|FMA|INF_NAN|ROUND_TO_INF|ROUND_TO_NEAREST|ROUND_TO_ZERO|SOFT_FLOAT)|GLOBAL|HALF_FLOAT|IMAGE_(?:ARRAY_SIZE|BUFFER|DEPTH|ELEMENT_SIZE|FORMAT|FORMAT_MISMATCH|FORMAT_NOT_SUPPORTED|HEIGHT|NUM_MIP_LEVELS|NUM_SAMPLES|ROW_PITCH|SLICE_PITCH|WIDTH)|INTENSITY|INVALID_(?:ARG_INDEX|ARG_SIZE|ARG_VALUE|BINARY|BUFFER_SIZE|BUILD_OPTIONS|COMMAND_QUEUE|COMPILER_OPTIONS|CONTEXT|DEVICE|DEVICE_PARTITION_COUNT|DEVICE_QUEUE|DEVICE_TYPE|EVENT|EVENT_WAIT_LIST|GLOBAL_OFFSET|GLOBAL_WORK_SIZE|GL_OBJECT|HOST_PTR|IMAGE_DESCRIPTOR|IMAGE_FORMAT_DESCRIPTOR|IMAGE_SIZE|KERNEL|KERNEL_ARGS|KERNEL_DEFINITION|KERNEL_NAME|LINKER_OPTIONS|MEM_OBJECT|MIP_LEVEL|OPERATION|PIPE_SIZE|PLATFORM|PROGRAM|PROGRAM_EXECUTABLE|PROPERTY|QUEUE_PROPERTIES|SAMPLER|VALUE|WORK_DIMENSION|WORK_GROUP_SIZE|WORK_ITEM_SIZE)|KERNEL_(?:ARG_(?:ACCESS_(?:NONE|QUALIFIER|READ_ONLY|READ_WRITE|WRITE_ONLY)|ADDRESS_(?:CONSTANT|GLOBAL|LOCAL|PRIVATE|QUALIFIER)|INFO_NOT_AVAILABLE|NAME|TYPE_(?:CONST|NAME|NONE|PIPE|QUALIFIER|RESTRICT|VOLATILE))|ATTRIBUTES|COMPILE_NUM_SUB_GROUPS|COMPILE_WORK_GROUP_SIZE|CONTEXT|EXEC_INFO_SVM_FINE_GRAIN_SYSTEM|EXEC_INFO_SVM_PTRS|FUNCTION_NAME|GLOBAL_WORK_SIZE|LOCAL_MEM_SIZE|LOCAL_SIZE_FOR_SUB_GROUP_COUNT|MAX_NUM_SUB_GROUPS|MAX_SUB_GROUP_SIZE_FOR_NDRANGE|NUM_ARGS|PREFERRED_WORK_GROUP_SIZE_MULTIPLE|PRIVATE_MEM_SIZE|PROGRAM|REFERENCE_COUNT|SUB_GROUP_COUNT_FOR_NDRANGE|WORK_GROUP_SIZE)|LINKER_NOT_AVAILABLE|LINK_PROGRAM_FAILURE|LOCAL|LUMINANCE|MAP_(?:FAILURE|READ|WRITE|WRITE_INVALIDATE_REGION)|MEM_(?:ALLOC_HOST_PTR|ASSOCIATED_MEMOBJECT|CONTEXT|COPY_HOST_PTR|COPY_OVERLAP|FLAGS|HOST_NO_ACCESS|HOST_PTR|HOST_READ_ONLY|HOST_WRITE_ONLY|KERNEL_READ_AND_WRITE|MAP_COUNT|OBJECT_(?:ALLOCATION_FAILURE|BUFFER|IMAGE1D|IMAGE1D_ARRAY|IMAGE1D_BUFFER|IMAGE2D|IMAGE2D_ARRAY|IMAGE3D|PIPE)|OFFSET|READ_ONLY|READ_WRITE|REFERENCE_COUNT|SIZE|SVM_ATOMICS|SVM_FINE_GRAIN_BUFFER|TYPE|USES_SVM_POINTER|USE_HOST_PTR|WRITE_ONLY)|MIGRATE_MEM_OBJECT_(?:CONTENT_UNDEFINED|HOST)|MISALIGNED_SUB_BUFFER_OFFSET|NONE|NON_BLOCKING|OUT_OF_(?:HOST_MEMORY|RESOURCES)|PIPE_(?:MAX_PACKETS|PACKET_SIZE)|PLATFORM_(?:EXTENSIONS|HOST_TIMER_RESOLUTION|NAME|PROFILE|VENDOR|VERSION)|PROFILING_(?:COMMAND_(?:COMPLETE|END|QUEUED|START|SUBMIT)|INFO_NOT_AVAILABLE)|PROGRAM_(?:BINARIES|BINARY_SIZES|BINARY_TYPE(?:_COMPILED_OBJECT|_EXECUTABLE|_LIBRARY|_NONE)?|BUILD_(?:GLOBAL_VARIABLE_TOTAL_SIZE|LOG|OPTIONS|STATUS)|CONTEXT|DEVICES|IL|KERNEL_NAMES|NUM_DEVICES|NUM_KERNELS|REFERENCE_COUNT|SOURCE)|QUEUED|QUEUE_(?:CONTEXT|DEVICE|DEVICE_DEFAULT|ON_DEVICE|ON_DEVICE_DEFAULT|OUT_OF_ORDER_EXEC_MODE_ENABLE|PROFILING_ENABLE|PROPERTIES|REFERENCE_COUNT|SIZE)|R|RA|READ_(?:ONLY|WRITE)_CACHE|RG|RGB|RGBA|RGBx|RGx|RUNNING|Rx|SAMPLER_(?:ADDRESSING_MODE|CONTEXT|FILTER_MODE|LOD_MAX|LOD_MIN|MIP_FILTER_MODE|NORMALIZED_COORDS|REFERENCE_COUNT)|(?:UN)?SIGNED_INT(?:8|16|32)|SNORM_INT(?:8|16)|SUBMITTED|SUCCESS|UNORM_INT(?:8|16|24|_101010|_101010_2)|UNORM_SHORT_(?:555|565)|VERSION_(?:1_0|1_1|1_2|2_0|2_1)|sBGRA|sRGB|sRGBA|sRGBx)\b/,
                alias: 'constant'
            },
            // Extracted from cl.h (2.0) and http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-host)
            'function-opencl-host': {
                pattern: /\bcl(?:BuildProgram|CloneKernel|CompileProgram|Create(?:Buffer|CommandQueue(?:WithProperties)?|Context|ContextFromType|Image|Image2D|Image3D|Kernel|KernelsInProgram|Pipe|ProgramWith(?:Binary|BuiltInKernels|IL|Source)|Sampler|SamplerWithProperties|SubBuffer|SubDevices|UserEvent)|Enqueue(?:(?:Barrier|Marker)(?:WithWaitList)?|Copy(?:Buffer(?:Rect|ToImage)?|Image(?:ToBuffer)?)|(?:Fill|Map)(?:Buffer|Image)|MigrateMemObjects|NDRangeKernel|NativeKernel|(?:Read|Write)(?:Buffer(?:Rect)?|Image)|SVM(?:Free|Map|MemFill|Memcpy|MigrateMem|Unmap)|Task|UnmapMemObject|WaitForEvents)|Finish|Flush|Get(?:CommandQueueInfo|ContextInfo|Device(?:AndHostTimer|IDs|Info)|Event(?:Profiling)?Info|ExtensionFunctionAddress(?:ForPlatform)?|HostTimer|ImageInfo|Kernel(?:ArgInfo|Info|SubGroupInfo|WorkGroupInfo)|MemObjectInfo|PipeInfo|Platform(?:IDs|Info)|Program(?:Build)?Info|SamplerInfo|SupportedImageFormats)|LinkProgram|(?:Release|Retain)(?:CommandQueue|Context|Device|Event|Kernel|MemObject|Program|Sampler)|SVM(?:Alloc|Free)|Set(?:CommandQueueProperty|DefaultDeviceCommandQueue|EventCallback|Kernel|Kernel(?:Arg(?:SVMPointer)?|ExecInfo)|MemObjectDestructorCallback|UserEventStatus)|Unload(?:Platform)?Compiler|WaitForEvents)\b/,
                alias: 'function'
            }
        };
        /* OpenCL host API */ Prism.languages.insertBefore('c', 'keyword', attributes);
        // C++ includes everything from the OpenCL C host API plus the classes defined in cl2.h
        if (Prism.languages.cpp) {
            // Extracted from doxygen class list http://github.khronos.org/OpenCL-CLHPP/annotated.html
            attributes['type-opencl-host-cpp'] = {
                pattern: /\b(?:Buffer|BufferGL|BufferRenderGL|CommandQueue|Context|Device|DeviceCommandQueue|EnqueueArgs|Event|Image|Image1D|Image1DArray|Image1DBuffer|Image2D|Image2DArray|Image2DGL|Image3D|Image3DGL|ImageFormat|ImageGL|Kernel|KernelFunctor|LocalSpaceArg|Memory|NDRange|Pipe|Platform|Program|SVMAllocator|SVMTraitAtomic|SVMTraitCoarse|SVMTraitFine|SVMTraitReadOnly|SVMTraitReadWrite|SVMTraitWriteOnly|Sampler|UserEvent)\b/,
                alias: 'keyword'
            };
            Prism.languages.insertBefore('cpp', 'keyword', attributes);
        }
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $6a65d32501c7d08f$export$2e2bcd8739ae039.displayName = 'openqasm';
$6a65d32501c7d08f$export$2e2bcd8739ae039.aliases = [
    'qasm'
];
function $6a65d32501c7d08f$export$2e2bcd8739ae039(Prism) {
    // https://qiskit.github.io/openqasm/grammar/index.html
    Prism.languages.openqasm = {
        comment: /\/\*[\s\S]*?\*\/|\/\/.*/,
        string: {
            pattern: /"[^"\r\n\t]*"|'[^'\r\n\t]*'/,
            greedy: true
        },
        keyword: /\b(?:CX|OPENQASM|U|barrier|boxas|boxto|break|const|continue|ctrl|def|defcal|defcalgrammar|delay|else|end|for|gate|gphase|if|in|include|inv|kernel|lengthof|let|measure|pow|reset|return|rotary|stretchinf|while)\b|#pragma\b/,
        'class-name': /\b(?:angle|bit|bool|creg|fixed|float|int|length|qreg|qubit|stretch|uint)\b/,
        function: /\b(?:cos|exp|ln|popcount|rotl|rotr|sin|sqrt|tan)\b(?=\s*\()/,
        constant: /\b(?:euler|pi|tau)\b|π|𝜏|ℇ/,
        number: {
            pattern: /(^|[^.\w$])(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?(?:dt|ns|us|µs|ms|s)?/i,
            lookbehind: true
        },
        operator: /->|>>=?|<<=?|&&|\|\||\+\+|--|[!=<>&|~^+\-*/%]=?|@/,
        punctuation: /[(){}\[\];,:.]/
    };
    Prism.languages.qasm = Prism.languages.openqasm;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $8ed4b18f31ffd000$export$2e2bcd8739ae039.displayName = 'oz';
$8ed4b18f31ffd000$export$2e2bcd8739ae039.aliases = [];
function $8ed4b18f31ffd000$export$2e2bcd8739ae039(Prism) {
    Prism.languages.oz = {
        comment: {
            pattern: /\/\*[\s\S]*?\*\/|%.*/,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"\\]|\\[\s\S])*"/,
            greedy: true
        },
        atom: {
            pattern: /'(?:[^'\\]|\\[\s\S])*'/,
            greedy: true,
            alias: 'builtin'
        },
        keyword: /\$|\[\]|\b(?:_|at|attr|case|catch|choice|class|cond|declare|define|dis|else(?:case|if)?|end|export|fail|false|feat|finally|from|fun|functor|if|import|in|local|lock|meth|nil|not|of|or|prepare|proc|prop|raise|require|self|skip|then|thread|true|try|unit)\b/,
        function: [
            /\b[a-z][A-Za-z\d]*(?=\()/,
            {
                pattern: /(\{)[A-Z][A-Za-z\d]*\b/,
                lookbehind: true
            }
        ],
        number: /\b(?:0[bx][\da-f]+|\d+(?:\.\d*)?(?:e~?\d+)?)\b|&(?:[^\\]|\\(?:\d{3}|.))/i,
        variable: /`(?:[^`\\]|\\.)+`/,
        'attr-name': /\b\w+(?=[ \t]*:(?![:=]))/,
        operator: /:(?:=|::?)|<[-:=]?|=(?:=|<?:?)|>=?:?|\\=:?|!!?|[|#+\-*\/,~^@]|\b(?:andthen|div|mod|orelse)\b/,
        punctuation: /[\[\](){}.:;?]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $5e75362810025a55$export$2e2bcd8739ae039.displayName = 'parigp';
$5e75362810025a55$export$2e2bcd8739ae039.aliases = [];
function $5e75362810025a55$export$2e2bcd8739ae039(Prism) {
    Prism.languages.parigp = {
        comment: /\/\*[\s\S]*?\*\/|\\\\.*/,
        string: {
            pattern: /"(?:[^"\\\r\n]|\\.)*"/,
            greedy: true
        },
        // PARI/GP does not care about white spaces at all
        // so let's process the keywords to build an appropriate regexp
        // (e.g. "b *r *e *a *k", etc.)
        keyword: function() {
            var keywords = [
                'breakpoint',
                'break',
                'dbg_down',
                'dbg_err',
                'dbg_up',
                'dbg_x',
                'forcomposite',
                'fordiv',
                'forell',
                'forpart',
                'forprime',
                'forstep',
                'forsubgroup',
                'forvec',
                'for',
                'iferr',
                'if',
                'local',
                'my',
                'next',
                'return',
                'until',
                'while'
            ];
            keywords = keywords.map(function(keyword) {
                return keyword.split('').join(' *');
            }).join('|');
            return RegExp('\\b(?:' + keywords + ')\\b');
        }(),
        function: /\b\w(?:[\w ]*\w)?(?= *\()/,
        number: {
            // The lookbehind and the negative lookahead prevent from breaking the .. operator
            pattern: /((?:\. *\. *)?)(?:\b\d(?: *\d)*(?: *(?!\. *\.)\.(?: *\d)*)?|\. *\d(?: *\d)*)(?: *e *(?:[+-] *)?\d(?: *\d)*)?/i,
            lookbehind: true
        },
        operator: /\. *\.|[*\/!](?: *=)?|%(?: *=|(?: *#)?(?: *')*)?|\+(?: *[+=])?|-(?: *[-=>])?|<(?: *>|(?: *<)?(?: *=)?)?|>(?: *>)?(?: *=)?|=(?: *=){0,2}|\\(?: *\/)?(?: *=)?|&(?: *&)?|\| *\||['#~^]/,
        punctuation: /[\[\]{}().,:;|]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$5233df02eb9ce262$export$2e2bcd8739ae039.displayName = 'parser';
$5233df02eb9ce262$export$2e2bcd8739ae039.aliases = [];
function $5233df02eb9ce262$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    (function(Prism) {
        var parser = Prism.languages.parser = Prism.languages.extend('markup', {
            keyword: {
                pattern: /(^|[^^])(?:\^(?:case|eval|for|if|switch|throw)\b|@(?:BASE|CLASS|GET(?:_DEFAULT)?|OPTIONS|SET_DEFAULT|USE)\b)/,
                lookbehind: true
            },
            variable: {
                pattern: /(^|[^^])\B\$(?:\w+|(?=[.{]))(?:(?:\.|::?)\w+)*(?:\.|::?)?/,
                lookbehind: true,
                inside: {
                    punctuation: /\.|:+/
                }
            },
            function: {
                pattern: /(^|[^^])\B[@^]\w+(?:(?:\.|::?)\w+)*(?:\.|::?)?/,
                lookbehind: true,
                inside: {
                    keyword: {
                        pattern: /(^@)(?:GET_|SET_)/,
                        lookbehind: true
                    },
                    punctuation: /\.|:+/
                }
            },
            escape: {
                pattern: /\^(?:[$^;@()\[\]{}"':]|#[a-f\d]*)/i,
                alias: 'builtin'
            },
            punctuation: /[\[\](){};]/
        });
        parser = Prism.languages.insertBefore('parser', 'keyword', {
            'parser-comment': {
                pattern: /(\s)#.*/,
                lookbehind: true,
                alias: 'comment'
            },
            expression: {
                // Allow for 3 levels of depth
                pattern: /(^|[^^])\((?:[^()]|\((?:[^()]|\((?:[^()])*\))*\))*\)/,
                greedy: true,
                lookbehind: true,
                inside: {
                    string: {
                        pattern: /(^|[^^])(["'])(?:(?!\2)[^^]|\^[\s\S])*\2/,
                        lookbehind: true
                    },
                    keyword: parser.keyword,
                    variable: parser.variable,
                    function: parser.function,
                    boolean: /\b(?:false|true)\b/,
                    number: /\b(?:0x[a-f\d]+|\d+(?:\.\d*)?(?:e[+-]?\d+)?)\b/i,
                    escape: parser.escape,
                    operator: /[~+*\/\\%]|!(?:\|\|?|=)?|&&?|\|\|?|==|<[<=]?|>[>=]?|-[fd]?|\b(?:def|eq|ge|gt|in|is|le|lt|ne)\b/,
                    punctuation: parser.punctuation
                }
            }
        });
        Prism.languages.insertBefore('inside', 'punctuation', {
            expression: parser.expression,
            keyword: parser.keyword,
            variable: parser.variable,
            function: parser.function,
            escape: parser.escape,
            'parser-punctuation': {
                pattern: parser.punctuation,
                alias: 'punctuation'
            }
        }, parser['tag'].inside['attr-value']);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $b2343da39e8ef130$export$2e2bcd8739ae039.displayName = 'pascal';
$b2343da39e8ef130$export$2e2bcd8739ae039.aliases = [
    'objectpascal'
];
function $b2343da39e8ef130$export$2e2bcd8739ae039(Prism) {
    // Based on Free Pascal
    /* TODO
Support inline asm ?
*/ Prism.languages.pascal = {
        directive: {
            pattern: /\{\$[\s\S]*?\}/,
            greedy: true,
            alias: [
                'marco',
                'property'
            ]
        },
        comment: {
            pattern: /\(\*[\s\S]*?\*\)|\{[\s\S]*?\}|\/\/.*/,
            greedy: true
        },
        string: {
            pattern: /(?:'(?:''|[^'\r\n])*'(?!')|#[&$%]?[a-f\d]+)+|\^[a-z]/i,
            greedy: true
        },
        asm: {
            pattern: /(\basm\b)[\s\S]+?(?=\bend\s*[;[])/i,
            lookbehind: true,
            greedy: true,
            inside: null // see below
        },
        keyword: [
            {
                // Turbo Pascal
                pattern: /(^|[^&])\b(?:absolute|array|asm|begin|case|const|constructor|destructor|do|downto|else|end|file|for|function|goto|if|implementation|inherited|inline|interface|label|nil|object|of|operator|packed|procedure|program|record|reintroduce|repeat|self|set|string|then|to|type|unit|until|uses|var|while|with)\b/i,
                lookbehind: true
            },
            {
                // Free Pascal
                pattern: /(^|[^&])\b(?:dispose|exit|false|new|true)\b/i,
                lookbehind: true
            },
            {
                // Object Pascal
                pattern: /(^|[^&])\b(?:class|dispinterface|except|exports|finalization|finally|initialization|inline|library|on|out|packed|property|raise|resourcestring|threadvar|try)\b/i,
                lookbehind: true
            },
            {
                // Modifiers
                pattern: /(^|[^&])\b(?:absolute|abstract|alias|assembler|bitpacked|break|cdecl|continue|cppdecl|cvar|default|deprecated|dynamic|enumerator|experimental|export|external|far|far16|forward|generic|helper|implements|index|interrupt|iochecks|local|message|name|near|nodefault|noreturn|nostackframe|oldfpccall|otherwise|overload|override|pascal|platform|private|protected|public|published|read|register|reintroduce|result|safecall|saveregisters|softfloat|specialize|static|stdcall|stored|strict|unaligned|unimplemented|varargs|virtual|write)\b/i,
                lookbehind: true
            }
        ],
        number: [
            // Hexadecimal, octal and binary
            /(?:[&%]\d+|\$[a-f\d]+)/i,
            // Decimal
            /\b\d+(?:\.\d+)?(?:e[+-]?\d+)?/i
        ],
        operator: [
            /\.\.|\*\*|:=|<[<=>]?|>[>=]?|[+\-*\/]=?|[@^=]/,
            {
                pattern: /(^|[^&])\b(?:and|as|div|exclude|in|include|is|mod|not|or|shl|shr|xor)\b/,
                lookbehind: true
            }
        ],
        punctuation: /\(\.|\.\)|[()\[\]:;,.]/
    };
    Prism.languages.pascal.asm.inside = Prism.languages.extend('pascal', {
        asm: undefined,
        keyword: undefined,
        operator: undefined
    });
    Prism.languages.objectpascal = Prism.languages.pascal;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $677549b6ac647aae$export$2e2bcd8739ae039.displayName = 'pascaligo';
$677549b6ac647aae$export$2e2bcd8739ae039.aliases = [];
function $677549b6ac647aae$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // Pascaligo is a layer 2 smart contract language for the tezos blockchain
        var braces = /\((?:[^()]|\((?:[^()]|\([^()]*\))*\))*\)/.source;
        var type = /(?:\b\w+(?:<braces>)?|<braces>)/.source.replace(/<braces>/g, function() {
            return braces;
        });
        var pascaligo = Prism.languages.pascaligo = {
            comment: /\(\*[\s\S]+?\*\)|\/\/.*/,
            string: {
                pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1|\^[a-z]/i,
                greedy: true
            },
            'class-name': [
                {
                    pattern: RegExp(/(\btype\s+\w+\s+is\s+)<type>/.source.replace(/<type>/g, function() {
                        return type;
                    }), 'i'),
                    lookbehind: true,
                    inside: null // see below
                },
                {
                    pattern: RegExp(/<type>(?=\s+is\b)/.source.replace(/<type>/g, function() {
                        return type;
                    }), 'i'),
                    inside: null // see below
                },
                {
                    pattern: RegExp(/(:\s*)<type>/.source.replace(/<type>/g, function() {
                        return type;
                    })),
                    lookbehind: true,
                    inside: null // see below
                }
            ],
            keyword: {
                pattern: /(^|[^&])\b(?:begin|block|case|const|else|end|fail|for|from|function|if|is|nil|of|remove|return|skip|then|type|var|while|with)\b/i,
                lookbehind: true
            },
            boolean: {
                pattern: /(^|[^&])\b(?:False|True)\b/i,
                lookbehind: true
            },
            builtin: {
                pattern: /(^|[^&])\b(?:bool|int|list|map|nat|record|string|unit)\b/i,
                lookbehind: true
            },
            function: /\b\w+(?=\s*\()/,
            number: [
                // Hexadecimal, octal and binary
                /%[01]+|&[0-7]+|\$[a-f\d]+/i,
                // Decimal
                /\b\d+(?:\.\d+)?(?:e[+-]?\d+)?(?:mtz|n)?/i
            ],
            operator: /->|=\/=|\.\.|\*\*|:=|<[<=>]?|>[>=]?|[+\-*\/]=?|[@^=|]|\b(?:and|mod|or)\b/,
            punctuation: /\(\.|\.\)|[()\[\]:;,.{}]/
        };
        var classNameInside = [
            'comment',
            'keyword',
            'builtin',
            'operator',
            'punctuation'
        ].reduce(function(accum, key) {
            accum[key] = pascaligo[key];
            return accum;
        }, {});
        pascaligo['class-name'].forEach(function(p) {
            p.inside = classNameInside;
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $deb4ca581bc1f27a$export$2e2bcd8739ae039.displayName = 'psl';
$deb4ca581bc1f27a$export$2e2bcd8739ae039.aliases = [];
function $deb4ca581bc1f27a$export$2e2bcd8739ae039(Prism) {
    Prism.languages.psl = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        string: {
            pattern: /"(?:\\.|[^\\"])*"/,
            greedy: true,
            inside: {
                symbol: /\\[ntrbA-Z"\\]/
            }
        },
        'heredoc-string': {
            pattern: /<<<([a-zA-Z_]\w*)[\r\n](?:.*[\r\n])*?\1\b/,
            alias: 'string',
            greedy: true
        },
        keyword: /\b(?:__multi|__single|case|default|do|else|elsif|exit|export|for|foreach|function|if|last|line|local|next|requires|return|switch|until|while|word)\b/,
        constant: /\b(?:ALARM|CHART_ADD_GRAPH|CHART_DELETE_GRAPH|CHART_DESTROY|CHART_LOAD|CHART_PRINT|EOF|OFFLINE|OK|PSL_PROF_LOG|R_CHECK_HORIZ|R_CHECK_VERT|R_CLICKER|R_COLUMN|R_FRAME|R_ICON|R_LABEL|R_LABEL_CENTER|R_LIST_MULTIPLE|R_LIST_MULTIPLE_ND|R_LIST_SINGLE|R_LIST_SINGLE_ND|R_MENU|R_POPUP|R_POPUP_SCROLLED|R_RADIO_HORIZ|R_RADIO_VERT|R_ROW|R_SCALE_HORIZ|R_SCALE_VERT|R_SEP_HORIZ|R_SEP_VERT|R_SPINNER|R_TEXT_FIELD|R_TEXT_FIELD_LABEL|R_TOGGLE|TRIM_LEADING|TRIM_LEADING_AND_TRAILING|TRIM_REDUNDANT|TRIM_TRAILING|VOID|WARN)\b/,
        boolean: /\b(?:FALSE|False|NO|No|TRUE|True|YES|Yes|false|no|true|yes)\b/,
        variable: /\b(?:PslDebug|errno|exit_status)\b/,
        builtin: {
            pattern: /\b(?:PslExecute|PslFunctionCall|PslFunctionExists|PslSetOptions|_snmp_debug|acos|add_diary|annotate|annotate_get|ascii_to_ebcdic|asctime|asin|atan|atexit|batch_set|blackout|cat|ceil|chan_exists|change_state|close|code_cvt|cond_signal|cond_wait|console_type|convert_base|convert_date|convert_locale_date|cos|cosh|create|date|dcget_text|destroy|destroy_lock|dget_text|difference|dump_hist|ebcdic_to_ascii|encrypt|event_archive|event_catalog_get|event_check|event_query|event_range_manage|event_range_query|event_report|event_schedule|event_trigger|event_trigger2|execute|exists|exp|fabs|file|floor|fmod|fopen|fseek|ftell|full_discovery|get|get_chan_info|get_ranges|get_text|get_vars|getenv|gethostinfo|getpid|getpname|grep|history|history_get_retention|in_transition|index|int|internal|intersection|is_var|isnumber|join|kill|length|lines|lock|lock_info|log|log10|loge|matchline|msg_check|msg_get_format|msg_get_severity|msg_printf|msg_sprintf|ntharg|nthargf|nthline|nthlinef|num_bytes|num_consoles|pconfig|popen|poplines|pow|print|printf|proc_exists|process|random|read|readln|refresh_parameters|remote_check|remote_close|remote_event_query|remote_event_trigger|remote_file_send|remote_open|remove|replace|rindex|sec_check_priv|sec_store_get|sec_store_set|set|set_alarm_ranges|set_locale|share|sin|sinh|sleep|snmp_agent_config|snmp_agent_start|snmp_agent_stop|snmp_close|snmp_config|snmp_get|snmp_get_next|snmp_h_get|snmp_h_get_next|snmp_h_set|snmp_open|snmp_set|snmp_trap_ignore|snmp_trap_listen|snmp_trap_raise_std_trap|snmp_trap_receive|snmp_trap_register_im|snmp_trap_send|snmp_walk|sopen|sort|splitline|sprintf|sqrt|srandom|str_repeat|strcasecmp|subset|substr|system|tail|tan|tanh|text_domain|time|tmpnam|tolower|toupper|trace_psl_process|trim|union|unique|unlock|unset|va_arg|va_start|write)\b/,
            alias: 'builtin-function'
        },
        'foreach-variable': {
            pattern: /(\bforeach\s+(?:(?:\w+\b|"(?:\\.|[^\\"])*")\s+){0,2})[_a-zA-Z]\w*(?=\s*\()/,
            lookbehind: true,
            greedy: true
        },
        function: /\b[_a-z]\w*\b(?=\s*\()/i,
        number: /\b(?:0x[0-9a-f]+|\d+(?:\.\d+)?)\b/i,
        operator: /--|\+\+|&&=?|\|\|=?|<<=?|>>=?|[=!]~|[-+*/%&|^!=<>]=?|\.|[:?]/,
        punctuation: /[(){}\[\];,]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $5d2497dd4e3ab655$export$2e2bcd8739ae039.displayName = 'pcaxis';
$5d2497dd4e3ab655$export$2e2bcd8739ae039.aliases = [
    'px'
];
function $5d2497dd4e3ab655$export$2e2bcd8739ae039(Prism) {
    Prism.languages.pcaxis = {
        string: /"[^"]*"/,
        keyword: {
            pattern: /((?:^|;)\s*)[-A-Z\d]+(?:\s*\[[-\w]+\])?(?:\s*\("[^"]*"(?:,\s*"[^"]*")*\))?(?=\s*=)/,
            lookbehind: true,
            greedy: true,
            inside: {
                keyword: /^[-A-Z\d]+/,
                language: {
                    pattern: /^(\s*)\[[-\w]+\]/,
                    lookbehind: true,
                    inside: {
                        punctuation: /^\[|\]$/,
                        property: /[-\w]+/
                    }
                },
                'sub-key': {
                    pattern: /^(\s*)\S[\s\S]*/,
                    lookbehind: true,
                    inside: {
                        parameter: {
                            pattern: /"[^"]*"/,
                            alias: 'property'
                        },
                        punctuation: /^\(|\)$|,/
                    }
                }
            }
        },
        operator: /=/,
        tlist: {
            pattern: /TLIST\s*\(\s*\w+(?:(?:\s*,\s*"[^"]*")+|\s*,\s*"[^"]*"-"[^"]*")?\s*\)/,
            greedy: true,
            inside: {
                function: /^TLIST/,
                property: {
                    pattern: /^(\s*\(\s*)\w+/,
                    lookbehind: true
                },
                string: /"[^"]*"/,
                punctuation: /[(),]/,
                operator: /-/
            }
        },
        punctuation: /[;,]/,
        number: {
            pattern: /(^|\s)\d+(?:\.\d+)?(?!\S)/,
            lookbehind: true
        },
        boolean: /NO|YES/
    };
    Prism.languages.px = Prism.languages.pcaxis;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $4b3fd195950a9be7$export$2e2bcd8739ae039.displayName = 'peoplecode';
$4b3fd195950a9be7$export$2e2bcd8739ae039.aliases = [
    'pcode'
];
function $4b3fd195950a9be7$export$2e2bcd8739ae039(Prism) {
    Prism.languages.peoplecode = {
        comment: RegExp([
            // C-style multiline comments
            /\/\*[\s\S]*?\*\//.source,
            // REM comments
            /\bREM[^;]*;/.source,
            // Nested <* *> comments
            /<\*(?:[^<*]|\*(?!>)|<(?!\*)|<\*(?:(?!\*>)[\s\S])*\*>)*\*>/.source,
            // /+ +/ comments
            /\/\+[\s\S]*?\+\//.source
        ].join('|')),
        string: {
            pattern: /'(?:''|[^'\r\n])*'(?!')|"(?:""|[^"\r\n])*"(?!")/,
            greedy: true
        },
        variable: /%\w+/,
        'function-definition': {
            pattern: /((?:^|[^\w-])(?:function|method)\s+)\w+/i,
            lookbehind: true,
            alias: 'function'
        },
        'class-name': {
            pattern: /((?:^|[^-\w])(?:as|catch|class|component|create|extends|global|implements|instance|local|of|property|returns)\s+)\w+(?::\w+)*/i,
            lookbehind: true,
            inside: {
                punctuation: /:/
            }
        },
        keyword: /\b(?:abstract|alias|as|catch|class|component|constant|create|declare|else|end-(?:class|evaluate|for|function|get|if|method|set|try|while)|evaluate|extends|for|function|get|global|if|implements|import|instance|library|local|method|null|of|out|peopleCode|private|program|property|protected|readonly|ref|repeat|returns?|set|step|then|throw|to|try|until|value|when(?:-other)?|while)\b/i,
        'operator-keyword': {
            pattern: /\b(?:and|not|or)\b/i,
            alias: 'operator'
        },
        function: /[_a-z]\w*(?=\s*\()/i,
        boolean: /\b(?:false|true)\b/i,
        number: /\b\d+(?:\.\d+)?\b/,
        operator: /<>|[<>]=?|!=|\*\*|[-+*/|=@]/,
        punctuation: /[:.;,()[\]]/
    };
    Prism.languages.pcode = Prism.languages.peoplecode;
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$1e6f9251c3a754c6$export$2e2bcd8739ae039.displayName = 'phpdoc';
$1e6f9251c3a754c6$export$2e2bcd8739ae039.aliases = [];
function $1e6f9251c3a754c6$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $27318f6b523d68d5$export$2e2bcd8739ae039));
    Prism.register((0, $8a2c8b738cd1f636$export$2e2bcd8739ae039));
    (function(Prism) {
        var typeExpression = /(?:\b[a-zA-Z]\w*|[|\\[\]])+/.source;
        Prism.languages.phpdoc = Prism.languages.extend('javadoclike', {
            parameter: {
                pattern: RegExp('(@(?:global|param|property(?:-read|-write)?|var)\\s+(?:' + typeExpression + '\\s+)?)\\$\\w+'),
                lookbehind: true
            }
        });
        Prism.languages.insertBefore('phpdoc', 'keyword', {
            'class-name': [
                {
                    pattern: RegExp('(@(?:global|package|param|property(?:-read|-write)?|return|subpackage|throws|var)\\s+)' + typeExpression),
                    lookbehind: true,
                    inside: {
                        keyword: /\b(?:array|bool|boolean|callback|double|false|float|int|integer|mixed|null|object|resource|self|string|true|void)\b/,
                        punctuation: /[|\\[\]()]/
                    }
                }
            ]
        });
        Prism.languages.javadoclike.addSupport('php', Prism.languages.phpdoc);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$83967affbf32d3d2$export$2e2bcd8739ae039.displayName = 'php-extras';
$83967affbf32d3d2$export$2e2bcd8739ae039.aliases = [];
function $83967affbf32d3d2$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $8a2c8b738cd1f636$export$2e2bcd8739ae039));
    Prism.languages.insertBefore('php', 'variable', {
        this: {
            pattern: /\$this\b/,
            alias: 'keyword'
        },
        global: /\$(?:GLOBALS|HTTP_RAW_POST_DATA|_(?:COOKIE|ENV|FILES|GET|POST|REQUEST|SERVER|SESSION)|argc|argv|http_response_header|php_errormsg)\b/,
        scope: {
            pattern: /\b[\w\\]+::/,
            inside: {
                keyword: /\b(?:parent|self|static)\b/,
                punctuation: /::|\\/
            }
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $b8eebe66b02f0b09$export$2e2bcd8739ae039.displayName = 'plant-uml';
$b8eebe66b02f0b09$export$2e2bcd8739ae039.aliases = [
    'plantuml'
];
function $b8eebe66b02f0b09$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var variable = /\$\w+|%[a-z]+%/;
        var arrowAttr = /\[[^[\]]*\]/.source;
        var arrowDirection = /(?:[drlu]|do|down|le|left|ri|right|up)/.source;
        var arrowBody = '(?:-+' + arrowDirection + '-+|\\.+' + arrowDirection + '\\.+|-+(?:' + arrowAttr + '-*)?|' + arrowAttr + '-+|\\.+(?:' + arrowAttr + '\\.*)?|' + arrowAttr + '\\.+)';
        var arrowLeft = /(?:<{1,2}|\/{1,2}|\\{1,2}|<\||[#*^+}xo])/.source;
        var arrowRight = /(?:>{1,2}|\/{1,2}|\\{1,2}|\|>|[#*^+{xo])/.source;
        var arrowPrefix = /[[?]?[ox]?/.source;
        var arrowSuffix = /[ox]?[\]?]?/.source;
        var arrow = arrowPrefix + '(?:' + arrowBody + arrowRight + '|' + arrowLeft + arrowBody + '(?:' + arrowRight + ')?' + ')' + arrowSuffix;
        Prism.languages['plant-uml'] = {
            comment: {
                pattern: /(^[ \t]*)(?:'.*|\/'[\s\S]*?'\/)/m,
                lookbehind: true,
                greedy: true
            },
            preprocessor: {
                pattern: /(^[ \t]*)!.*/m,
                lookbehind: true,
                greedy: true,
                alias: 'property',
                inside: {
                    variable: variable
                }
            },
            delimiter: {
                pattern: /(^[ \t]*)@(?:end|start)uml\b/m,
                lookbehind: true,
                greedy: true,
                alias: 'punctuation'
            },
            arrow: {
                pattern: RegExp(/(^|[^-.<>?|\\[\]ox])/.source + arrow + /(?![-.<>?|\\\]ox])/.source),
                lookbehind: true,
                greedy: true,
                alias: 'operator',
                inside: {
                    expression: {
                        pattern: /(\[)[^[\]]+(?=\])/,
                        lookbehind: true,
                        inside: null // see below
                    },
                    punctuation: /\[(?=$|\])|^\]/
                }
            },
            string: {
                pattern: /"[^"]*"/,
                greedy: true
            },
            text: {
                pattern: /(\[[ \t]*[\r\n]+(?![\r\n]))[^\]]*(?=\])/,
                lookbehind: true,
                greedy: true,
                alias: 'string'
            },
            keyword: [
                {
                    pattern: /^([ \t]*)(?:abstract\s+class|end\s+(?:box|fork|group|merge|note|ref|split|title)|(?:fork|split)(?:\s+again)?|activate|actor|agent|alt|annotation|artifact|autoactivate|autonumber|backward|binary|boundary|box|break|caption|card|case|circle|class|clock|cloud|collections|component|concise|control|create|critical|database|deactivate|destroy|detach|diamond|else|elseif|end|end[hr]note|endif|endswitch|endwhile|entity|enum|file|folder|footer|frame|group|[hr]?note|header|hexagon|hide|if|interface|label|legend|loop|map|namespace|network|newpage|node|nwdiag|object|opt|package|page|par|participant|person|queue|rectangle|ref|remove|repeat|restore|return|robust|scale|set|show|skinparam|stack|start|state|stop|storage|switch|title|together|usecase|usecase\/|while)(?=\s|$)/m,
                    lookbehind: true,
                    greedy: true
                },
                /\b(?:elseif|equals|not|while)(?=\s*\()/,
                /\b(?:as|is|then)\b/
            ],
            divider: {
                pattern: /^==.+==$/m,
                greedy: true,
                alias: 'important'
            },
            time: {
                pattern: /@(?:\d+(?:[:/]\d+){2}|[+-]?\d+|:[a-z]\w*(?:[+-]\d+)?)\b/i,
                greedy: true,
                alias: 'number'
            },
            color: {
                pattern: /#(?:[a-z_]+|[a-fA-F0-9]+)\b/,
                alias: 'symbol'
            },
            variable: variable,
            punctuation: /[:,;()[\]{}]|\.{3}/
        };
        Prism.languages['plant-uml'].arrow.inside.expression.inside = Prism.languages['plant-uml'];
        Prism.languages['plantuml'] = Prism.languages['plant-uml'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$ee0a699affb8796e$export$2e2bcd8739ae039.displayName = 'plsql';
$ee0a699affb8796e$export$2e2bcd8739ae039.aliases = [];
function $ee0a699affb8796e$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eb5bcdfed284c0e2$export$2e2bcd8739ae039));
    Prism.languages.plsql = Prism.languages.extend('sql', {
        comment: {
            pattern: /\/\*[\s\S]*?\*\/|--.*/,
            greedy: true
        },
        // https://docs.oracle.com/en/database/oracle/oracle-database/21/lnpls/plsql-reserved-words-keywords.html
        keyword: /\b(?:A|ACCESSIBLE|ADD|AGENT|AGGREGATE|ALL|ALTER|AND|ANY|ARRAY|AS|ASC|AT|ATTRIBUTE|AUTHID|AVG|BEGIN|BETWEEN|BFILE_BASE|BINARY|BLOB_BASE|BLOCK|BODY|BOTH|BOUND|BULK|BY|BYTE|C|CALL|CALLING|CASCADE|CASE|CHAR|CHARACTER|CHARSET|CHARSETFORM|CHARSETID|CHAR_BASE|CHECK|CLOB_BASE|CLONE|CLOSE|CLUSTER|CLUSTERS|COLAUTH|COLLECT|COLUMNS|COMMENT|COMMIT|COMMITTED|COMPILED|COMPRESS|CONNECT|CONSTANT|CONSTRUCTOR|CONTEXT|CONTINUE|CONVERT|COUNT|CRASH|CREATE|CREDENTIAL|CURRENT|CURSOR|CUSTOMDATUM|DANGLING|DATA|DATE|DATE_BASE|DAY|DECLARE|DEFAULT|DEFINE|DELETE|DESC|DETERMINISTIC|DIRECTORY|DISTINCT|DOUBLE|DROP|DURATION|ELEMENT|ELSE|ELSIF|EMPTY|END|ESCAPE|EXCEPT|EXCEPTION|EXCEPTIONS|EXCLUSIVE|EXECUTE|EXISTS|EXIT|EXTERNAL|FETCH|FINAL|FIRST|FIXED|FLOAT|FOR|FORALL|FORCE|FROM|FUNCTION|GENERAL|GOTO|GRANT|GROUP|HASH|HAVING|HEAP|HIDDEN|HOUR|IDENTIFIED|IF|IMMEDIATE|IMMUTABLE|IN|INCLUDING|INDEX|INDEXES|INDICATOR|INDICES|INFINITE|INSERT|INSTANTIABLE|INT|INTERFACE|INTERSECT|INTERVAL|INTO|INVALIDATE|IS|ISOLATION|JAVA|LANGUAGE|LARGE|LEADING|LENGTH|LEVEL|LIBRARY|LIKE|LIKE2|LIKE4|LIKEC|LIMIT|LIMITED|LOCAL|LOCK|LONG|LOOP|MAP|MAX|MAXLEN|MEMBER|MERGE|MIN|MINUS|MINUTE|MOD|MODE|MODIFY|MONTH|MULTISET|MUTABLE|NAME|NAN|NATIONAL|NATIVE|NCHAR|NEW|NOCOMPRESS|NOCOPY|NOT|NOWAIT|NULL|NUMBER_BASE|OBJECT|OCICOLL|OCIDATE|OCIDATETIME|OCIDURATION|OCIINTERVAL|OCILOBLOCATOR|OCINUMBER|OCIRAW|OCIREF|OCIREFCURSOR|OCIROWID|OCISTRING|OCITYPE|OF|OLD|ON|ONLY|OPAQUE|OPEN|OPERATOR|OPTION|OR|ORACLE|ORADATA|ORDER|ORGANIZATION|ORLANY|ORLVARY|OTHERS|OUT|OVERLAPS|OVERRIDING|PACKAGE|PARALLEL_ENABLE|PARAMETER|PARAMETERS|PARENT|PARTITION|PASCAL|PERSISTABLE|PIPE|PIPELINED|PLUGGABLE|POLYMORPHIC|PRAGMA|PRECISION|PRIOR|PRIVATE|PROCEDURE|PUBLIC|RAISE|RANGE|RAW|READ|RECORD|REF|REFERENCE|RELIES_ON|REM|REMAINDER|RENAME|RESOURCE|RESULT|RESULT_CACHE|RETURN|RETURNING|REVERSE|REVOKE|ROLLBACK|ROW|SAMPLE|SAVE|SAVEPOINT|SB1|SB2|SB4|SECOND|SEGMENT|SELECT|SELF|SEPARATE|SEQUENCE|SERIALIZABLE|SET|SHARE|SHORT|SIZE|SIZE_T|SOME|SPARSE|SQL|SQLCODE|SQLDATA|SQLNAME|SQLSTATE|STANDARD|START|STATIC|STDDEV|STORED|STRING|STRUCT|STYLE|SUBMULTISET|SUBPARTITION|SUBSTITUTABLE|SUBTYPE|SUM|SYNONYM|TABAUTH|TABLE|TDO|THE|THEN|TIME|TIMESTAMP|TIMEZONE_ABBR|TIMEZONE_HOUR|TIMEZONE_MINUTE|TIMEZONE_REGION|TO|TRAILING|TRANSACTION|TRANSACTIONAL|TRUSTED|TYPE|UB1|UB2|UB4|UNDER|UNION|UNIQUE|UNPLUG|UNSIGNED|UNTRUSTED|UPDATE|USE|USING|VALIST|VALUE|VALUES|VARIABLE|VARIANCE|VARRAY|VARYING|VIEW|VIEWS|VOID|WHEN|WHERE|WHILE|WITH|WORK|WRAPPED|WRITE|YEAR|ZONE)\b/i,
        // https://docs.oracle.com/en/database/oracle/oracle-database/21/lnpls/plsql-language-fundamentals.html#GUID-96A42F7C-7A71-4B90-8255-CA9C8BD9722E
        operator: /:=?|=>|[<>^~!]=|\.\.|\|\||\*\*|[-+*/%<>=@]/
    });
    Prism.languages.insertBefore('plsql', 'operator', {
        label: {
            pattern: /<<\s*\w+\s*>>/,
            alias: 'symbol'
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $bb80e878636bd8f6$export$2e2bcd8739ae039.displayName = 'powerquery';
$bb80e878636bd8f6$export$2e2bcd8739ae039.aliases = [
    'mscript',
    'pq'
];
function $bb80e878636bd8f6$export$2e2bcd8739ae039(Prism) {
    // https://docs.microsoft.com/en-us/powerquery-m/power-query-m-language-specification
    Prism.languages.powerquery = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
            lookbehind: true,
            greedy: true
        },
        'quoted-identifier': {
            pattern: /#"(?:[^"\r\n]|"")*"(?!")/,
            greedy: true
        },
        string: {
            pattern: /(?:#!)?"(?:[^"\r\n]|"")*"(?!")/,
            greedy: true
        },
        constant: [
            /\bDay\.(?:Friday|Monday|Saturday|Sunday|Thursday|Tuesday|Wednesday)\b/,
            /\bTraceLevel\.(?:Critical|Error|Information|Verbose|Warning)\b/,
            /\bOccurrence\.(?:All|First|Last)\b/,
            /\bOrder\.(?:Ascending|Descending)\b/,
            /\bRoundingMode\.(?:AwayFromZero|Down|ToEven|TowardZero|Up)\b/,
            /\bMissingField\.(?:Error|Ignore|UseNull)\b/,
            /\bQuoteStyle\.(?:Csv|None)\b/,
            /\bJoinKind\.(?:FullOuter|Inner|LeftAnti|LeftOuter|RightAnti|RightOuter)\b/,
            /\bGroupKind\.(?:Global|Local)\b/,
            /\bExtraValues\.(?:Error|Ignore|List)\b/,
            /\bJoinAlgorithm\.(?:Dynamic|LeftHash|LeftIndex|PairwiseHash|RightHash|RightIndex|SortMerge)\b/,
            /\bJoinSide\.(?:Left|Right)\b/,
            /\bPrecision\.(?:Decimal|Double)\b/,
            /\bRelativePosition\.From(?:End|Start)\b/,
            /\bTextEncoding\.(?:Ascii|BigEndianUnicode|Unicode|Utf16|Utf8|Windows)\b/,
            /\b(?:Any|Binary|Date|DateTime|DateTimeZone|Duration|Function|Int16|Int32|Int64|Int8|List|Logical|None|Number|Record|Table|Text|Time)\.Type\b/,
            /\bnull\b/
        ],
        boolean: /\b(?:false|true)\b/,
        keyword: /\b(?:and|as|each|else|error|if|in|is|let|meta|not|nullable|optional|or|otherwise|section|shared|then|try|type)\b|#(?:binary|date|datetime|datetimezone|duration|infinity|nan|sections|shared|table|time)\b/,
        function: {
            pattern: /(^|[^#\w.])[a-z_][\w.]*(?=\s*\()/i,
            lookbehind: true
        },
        'data-type': {
            pattern: /\b(?:any|anynonnull|binary|date|datetime|datetimezone|duration|function|list|logical|none|number|record|table|text|time)\b/,
            alias: 'class-name'
        },
        number: {
            pattern: /\b0x[\da-f]+\b|(?:[+-]?(?:\b\d+\.)?\b\d+|[+-]\.\d+|(^|[^.])\B\.\d+)(?:e[+-]?\d+)?\b/i,
            lookbehind: true
        },
        operator: /[-+*\/&?@^]|<(?:=>?|>)?|>=?|=>?|\.\.\.?/,
        punctuation: /[,;\[\](){}]/
    };
    Prism.languages.pq = Prism.languages['powerquery'];
    Prism.languages.mscript = Prism.languages['powerquery'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $07c52e9b9a88ab06$export$2e2bcd8739ae039.displayName = 'powershell';
$07c52e9b9a88ab06$export$2e2bcd8739ae039.aliases = [];
function $07c52e9b9a88ab06$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var powershell = Prism.languages.powershell = {
            comment: [
                {
                    pattern: /(^|[^`])<#[\s\S]*?#>/,
                    lookbehind: true
                },
                {
                    pattern: /(^|[^`])#.*/,
                    lookbehind: true
                }
            ],
            string: [
                {
                    pattern: /"(?:`[\s\S]|[^`"])*"/,
                    greedy: true,
                    inside: null // see below
                },
                {
                    pattern: /'(?:[^']|'')*'/,
                    greedy: true
                }
            ],
            // Matches name spaces as well as casts, attribute decorators. Force starting with letter to avoid matching array indices
            // Supports two levels of nested brackets (e.g. `[OutputType([System.Collections.Generic.List[int]])]`)
            namespace: /\[[a-z](?:\[(?:\[[^\]]*\]|[^\[\]])*\]|[^\[\]])*\]/i,
            boolean: /\$(?:false|true)\b/i,
            variable: /\$\w+\b/,
            // Cmdlets and aliases. Aliases should come last, otherwise "write" gets preferred over "write-host" for example
            // Get-Command | ?{ $_.ModuleName -match "Microsoft.PowerShell.(Util|Core|Management)" }
            // Get-Alias | ?{ $_.ReferencedCommand.Module.Name -match "Microsoft.PowerShell.(Util|Core|Management)" }
            function: [
                /\b(?:Add|Approve|Assert|Backup|Block|Checkpoint|Clear|Close|Compare|Complete|Compress|Confirm|Connect|Convert|ConvertFrom|ConvertTo|Copy|Debug|Deny|Disable|Disconnect|Dismount|Edit|Enable|Enter|Exit|Expand|Export|Find|ForEach|Format|Get|Grant|Group|Hide|Import|Initialize|Install|Invoke|Join|Limit|Lock|Measure|Merge|Move|New|Open|Optimize|Out|Ping|Pop|Protect|Publish|Push|Read|Receive|Redo|Register|Remove|Rename|Repair|Request|Reset|Resize|Resolve|Restart|Restore|Resume|Revoke|Save|Search|Select|Send|Set|Show|Skip|Sort|Split|Start|Step|Stop|Submit|Suspend|Switch|Sync|Tee|Test|Trace|Unblock|Undo|Uninstall|Unlock|Unprotect|Unpublish|Unregister|Update|Use|Wait|Watch|Where|Write)-[a-z]+\b/i,
                /\b(?:ac|cat|chdir|clc|cli|clp|clv|compare|copy|cp|cpi|cpp|cvpa|dbp|del|diff|dir|ebp|echo|epal|epcsv|epsn|erase|fc|fl|ft|fw|gal|gbp|gc|gci|gcs|gdr|gi|gl|gm|gp|gps|group|gsv|gu|gv|gwmi|iex|ii|ipal|ipcsv|ipsn|irm|iwmi|iwr|kill|lp|ls|measure|mi|mount|move|mp|mv|nal|ndr|ni|nv|ogv|popd|ps|pushd|pwd|rbp|rd|rdr|ren|ri|rm|rmdir|rni|rnp|rp|rv|rvpa|rwmi|sal|saps|sasv|sbp|sc|select|set|shcm|si|sl|sleep|sls|sort|sp|spps|spsv|start|sv|swmi|tee|trcm|type|write)\b/i
            ],
            // per http://technet.microsoft.com/en-us/library/hh847744.aspx
            keyword: /\b(?:Begin|Break|Catch|Class|Continue|Data|Define|Do|DynamicParam|Else|ElseIf|End|Exit|Filter|Finally|For|ForEach|From|Function|If|InlineScript|Parallel|Param|Process|Return|Sequence|Switch|Throw|Trap|Try|Until|Using|Var|While|Workflow)\b/i,
            operator: {
                pattern: /(^|\W)(?:!|-(?:b?(?:and|x?or)|as|(?:Not)?(?:Contains|In|Like|Match)|eq|ge|gt|is(?:Not)?|Join|le|lt|ne|not|Replace|sh[lr])\b|-[-=]?|\+[+=]?|[*\/%]=?)/i,
                lookbehind: true
            },
            punctuation: /[|{}[\];(),.]/
        };
        // Variable interpolation inside strings, and nested expressions
        powershell.string[0].inside = {
            function: {
                // Allow for one level of nesting
                pattern: /(^|[^`])\$\((?:\$\([^\r\n()]*\)|(?!\$\()[^\r\n)])*\)/,
                lookbehind: true,
                inside: powershell
            },
            boolean: powershell.boolean,
            variable: powershell.variable
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$b43974aae9bb9664$export$2e2bcd8739ae039.displayName = 'processing';
$b43974aae9bb9664$export$2e2bcd8739ae039.aliases = [];
function $b43974aae9bb9664$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.processing = Prism.languages.extend('clike', {
        keyword: /\b(?:break|case|catch|class|continue|default|else|extends|final|for|if|implements|import|new|null|private|public|return|static|super|switch|this|try|void|while)\b/,
        // Spaces are allowed between function name and parenthesis
        function: /\b\w+(?=\s*\()/,
        operator: /<[<=]?|>[>=]?|&&?|\|\|?|[%?]|[!=+\-*\/]=?/
    });
    Prism.languages.insertBefore('processing', 'number', {
        // Special case: XML is a type
        constant: /\b(?!XML\b)[A-Z][A-Z\d_]+\b/,
        type: {
            pattern: /\b(?:boolean|byte|char|color|double|float|int|[A-Z]\w*)\b/,
            alias: 'class-name'
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $37e5b1709464e513$export$2e2bcd8739ae039.displayName = 'prolog';
$37e5b1709464e513$export$2e2bcd8739ae039.aliases = [];
function $37e5b1709464e513$export$2e2bcd8739ae039(Prism) {
    Prism.languages.prolog = {
        // Syntax depends on the implementation
        comment: {
            pattern: /\/\*[\s\S]*?\*\/|%.*/,
            greedy: true
        },
        // Depending on the implementation, strings may allow escaped newlines and quote-escape
        string: {
            pattern: /(["'])(?:\1\1|\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1(?!\1)/,
            greedy: true
        },
        builtin: /\b(?:fx|fy|xf[xy]?|yfx?)\b/,
        // FIXME: Should we list all null-ary predicates (not followed by a parenthesis) like halt, trace, etc.?
        function: /\b[a-z]\w*(?:(?=\()|\/\d+)/,
        number: /\b\d+(?:\.\d*)?/,
        // Custom operators are allowed
        operator: /[:\\=><\-?*@\/;+^|!$.]+|\b(?:is|mod|not|xor)\b/,
        punctuation: /[(){}\[\],]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $4b50fa11ce89925a$export$2e2bcd8739ae039.displayName = 'promql';
$4b50fa11ce89925a$export$2e2bcd8739ae039.aliases = [];
function $4b50fa11ce89925a$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // PromQL Aggregation Operators
        // (https://prometheus.io/docs/prometheus/latest/querying/operators/#aggregation-operators)
        var aggregations = [
            'sum',
            'min',
            'max',
            'avg',
            'group',
            'stddev',
            'stdvar',
            'count',
            'count_values',
            'bottomk',
            'topk',
            'quantile'
        ];
        // PromQL vector matching + the by and without clauses
        // (https://prometheus.io/docs/prometheus/latest/querying/operators/#vector-matching)
        var vectorMatching = [
            'on',
            'ignoring',
            'group_right',
            'group_left',
            'by',
            'without'
        ];
        // PromQL offset modifier
        // (https://prometheus.io/docs/prometheus/latest/querying/basics/#offset-modifier)
        var offsetModifier = [
            'offset'
        ];
        var keywords = aggregations.concat(vectorMatching, offsetModifier);
        Prism.languages.promql = {
            comment: {
                pattern: /(^[ \t]*)#.*/m,
                lookbehind: true
            },
            'vector-match': {
                // Match the comma-separated label lists inside vector matching:
                pattern: new RegExp('((?:' + vectorMatching.join('|') + ')\\s*)\\([^)]*\\)'),
                lookbehind: true,
                inside: {
                    'label-key': {
                        pattern: /\b[^,]+\b/,
                        alias: 'attr-name'
                    },
                    punctuation: /[(),]/
                }
            },
            'context-labels': {
                pattern: /\{[^{}]*\}/,
                inside: {
                    'label-key': {
                        pattern: /\b[a-z_]\w*(?=\s*(?:=|![=~]))/,
                        alias: 'attr-name'
                    },
                    'label-value': {
                        pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
                        greedy: true,
                        alias: 'attr-value'
                    },
                    punctuation: /\{|\}|=~?|![=~]|,/
                }
            },
            'context-range': [
                {
                    pattern: /\[[\w\s:]+\]/,
                    // [1m]
                    inside: {
                        punctuation: /\[|\]|:/,
                        'range-duration': {
                            pattern: /\b(?:\d+(?:[smhdwy]|ms))+\b/i,
                            alias: 'number'
                        }
                    }
                },
                {
                    pattern: /(\boffset\s+)\w+/,
                    // offset 1m
                    lookbehind: true,
                    inside: {
                        'range-duration': {
                            pattern: /\b(?:\d+(?:[smhdwy]|ms))+\b/i,
                            alias: 'number'
                        }
                    }
                }
            ],
            keyword: new RegExp('\\b(?:' + keywords.join('|') + ')\\b', 'i'),
            function: /\b[a-z_]\w*(?=\s*\()/i,
            number: /[-+]?(?:(?:\b\d+(?:\.\d+)?|\B\.\d+)(?:e[-+]?\d+)?\b|\b(?:0x[0-9a-f]+|nan|inf)\b)/i,
            operator: /[\^*/%+-]|==|!=|<=|<|>=|>|\b(?:and|or|unless)\b/i,
            punctuation: /[{};()`,.[\]]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $5ac9473b450a64ab$export$2e2bcd8739ae039.displayName = 'properties';
$5ac9473b450a64ab$export$2e2bcd8739ae039.aliases = [];
function $5ac9473b450a64ab$export$2e2bcd8739ae039(Prism) {
    Prism.languages.properties = {
        comment: /^[ \t]*[#!].*$/m,
        value: {
            pattern: /(^[ \t]*(?:\\(?:\r\n|[\s\S])|[^\\\s:=])+(?: *[=:] *(?! )| ))(?:\\(?:\r\n|[\s\S])|[^\\\r\n])+/m,
            lookbehind: true,
            alias: 'attr-value'
        },
        key: {
            pattern: /^[ \t]*(?:\\(?:\r\n|[\s\S])|[^\\\s:=])+(?= *[=:]| )/m,
            alias: 'attr-name'
        },
        punctuation: /[=:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$e427246b711a2509$export$2e2bcd8739ae039.displayName = 'protobuf';
$e427246b711a2509$export$2e2bcd8739ae039.aliases = [];
function $e427246b711a2509$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    (function(Prism) {
        var builtinTypes = /\b(?:bool|bytes|double|s?fixed(?:32|64)|float|[su]?int(?:32|64)|string)\b/;
        Prism.languages.protobuf = Prism.languages.extend('clike', {
            'class-name': [
                {
                    pattern: /(\b(?:enum|extend|message|service)\s+)[A-Za-z_]\w*(?=\s*\{)/,
                    lookbehind: true
                },
                {
                    pattern: /(\b(?:rpc\s+\w+|returns)\s*\(\s*(?:stream\s+)?)\.?[A-Za-z_]\w*(?:\.[A-Za-z_]\w*)*(?=\s*\))/,
                    lookbehind: true
                }
            ],
            keyword: /\b(?:enum|extend|extensions|import|message|oneof|option|optional|package|public|repeated|required|reserved|returns|rpc(?=\s+\w)|service|stream|syntax|to)\b(?!\s*=\s*\d)/,
            function: /\b[a-z_]\w*(?=\s*\()/i
        });
        Prism.languages.insertBefore('protobuf', 'operator', {
            map: {
                pattern: /\bmap<\s*[\w.]+\s*,\s*[\w.]+\s*>(?=\s+[a-z_]\w*\s*[=;])/i,
                alias: 'class-name',
                inside: {
                    punctuation: /[<>.,]/,
                    builtin: builtinTypes
                }
            },
            builtin: builtinTypes,
            'positional-class-name': {
                pattern: /(?:\b|\B\.)[a-z_]\w*(?:\.[a-z_]\w*)*(?=\s+[a-z_]\w*\s*[=;])/i,
                alias: 'class-name',
                inside: {
                    punctuation: /\./
                }
            },
            annotation: {
                pattern: /(\[\s*)[a-z_]\w*(?=\s*=)/i,
                lookbehind: true
            }
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $295e7fe9e01d0862$export$2e2bcd8739ae039.displayName = 'stylus';
$295e7fe9e01d0862$export$2e2bcd8739ae039.aliases = [];
function $295e7fe9e01d0862$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var unit = {
            pattern: /(\b\d+)(?:%|[a-z]+)/,
            lookbehind: true
        };
        // 123 -123 .123 -.123 12.3 -12.3
        var number = {
            pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
            lookbehind: true
        };
        var inside = {
            comment: {
                pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
                lookbehind: true
            },
            url: {
                pattern: /\burl\((["']?).*?\1\)/i,
                greedy: true
            },
            string: {
                pattern: /("|')(?:(?!\1)[^\\\r\n]|\\(?:\r\n|[\s\S]))*\1/,
                greedy: true
            },
            interpolation: null,
            // See below
            func: null,
            // See below
            important: /\B!(?:important|optional)\b/i,
            keyword: {
                pattern: /(^|\s+)(?:(?:else|for|if|return|unless)(?=\s|$)|@[\w-]+)/,
                lookbehind: true
            },
            hexcode: /#[\da-f]{3,6}/i,
            color: [
                /\b(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)\b/i,
                {
                    pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
                    inside: {
                        unit: unit,
                        number: number,
                        function: /[\w-]+(?=\()/,
                        punctuation: /[(),]/
                    }
                }
            ],
            entity: /\\[\da-f]{1,8}/i,
            unit: unit,
            boolean: /\b(?:false|true)\b/,
            operator: [
                // We want non-word chars around "-" because it is
                // accepted in property names.
                /~|[+!\/%<>?=]=?|[-:]=|\*[*=]?|\.{2,3}|&&|\|\||\B-\B|\b(?:and|in|is(?: a| defined| not|nt)?|not|or)\b/
            ],
            number: number,
            punctuation: /[{}()\[\];:,]/
        };
        inside['interpolation'] = {
            pattern: /\{[^\r\n}:]+\}/,
            alias: 'variable',
            inside: {
                delimiter: {
                    pattern: /^\{|\}$/,
                    alias: 'punctuation'
                },
                rest: inside
            }
        };
        inside['func'] = {
            pattern: /[\w-]+\([^)]*\).*/,
            inside: {
                function: /^[^(]+/,
                rest: inside
            }
        };
        Prism.languages.stylus = {
            'atrule-declaration': {
                pattern: /(^[ \t]*)@.+/m,
                lookbehind: true,
                inside: {
                    atrule: /^@[\w-]+/,
                    rest: inside
                }
            },
            'variable-declaration': {
                pattern: /(^[ \t]*)[\w$-]+\s*.?=[ \t]*(?:\{[^{}]*\}|\S.*|$)/m,
                lookbehind: true,
                inside: {
                    variable: /^\S+/,
                    rest: inside
                }
            },
            statement: {
                pattern: /(^[ \t]*)(?:else|for|if|return|unless)[ \t].+/m,
                lookbehind: true,
                inside: {
                    keyword: /^\S+/,
                    rest: inside
                }
            },
            // A property/value pair cannot end with a comma or a brace
            // It cannot have indented content unless it ended with a semicolon
            'property-declaration': {
                pattern: /((?:^|\{)([ \t]*))(?:[\w-]|\{[^}\r\n]+\})+(?:\s*:\s*|[ \t]+)(?!\s)[^{\r\n]*(?:;|[^{\r\n,]$(?!(?:\r?\n|\r)(?:\{|\2[ \t])))/m,
                lookbehind: true,
                inside: {
                    property: {
                        pattern: /^[^\s:]+/,
                        inside: {
                            interpolation: inside.interpolation
                        }
                    },
                    rest: inside
                }
            },
            // A selector can contain parentheses only as part of a pseudo-element
            // It can span multiple lines.
            // It must end with a comma or an accolade or have indented content.
            selector: {
                pattern: /(^[ \t]*)(?:(?=\S)(?:[^{}\r\n:()]|::?[\w-]+(?:\([^)\r\n]*\)|(?![\w-]))|\{[^}\r\n]+\})+)(?:(?:\r?\n|\r)(?:\1(?:(?=\S)(?:[^{}\r\n:()]|::?[\w-]+(?:\([^)\r\n]*\)|(?![\w-]))|\{[^}\r\n]+\})+)))*(?:,$|\{|(?=(?:\r?\n|\r)(?:\{|\1[ \t])))/m,
                lookbehind: true,
                inside: {
                    interpolation: inside.interpolation,
                    comment: inside.comment,
                    punctuation: /[{},]/
                }
            },
            func: inside.func,
            string: inside.string,
            comment: {
                pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
                lookbehind: true,
                greedy: true
            },
            interpolation: inside.interpolation,
            punctuation: /[{}()\[\];:.]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$48a2ee38b0d45f1e$export$2e2bcd8739ae039.displayName = 'twig';
$48a2ee38b0d45f1e$export$2e2bcd8739ae039.aliases = [];
function $48a2ee38b0d45f1e$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
    Prism.languages.twig = {
        comment: /^\{#[\s\S]*?#\}$/,
        'tag-name': {
            pattern: /(^\{%-?\s*)\w+/,
            lookbehind: true,
            alias: 'keyword'
        },
        delimiter: {
            pattern: /^\{[{%]-?|-?[%}]\}$/,
            alias: 'punctuation'
        },
        string: {
            pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            inside: {
                punctuation: /^['"]|['"]$/
            }
        },
        keyword: /\b(?:even|if|odd)\b/,
        boolean: /\b(?:false|null|true)\b/,
        number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
        operator: [
            {
                pattern: /(\s)(?:and|b-and|b-or|b-xor|ends with|in|is|matches|not|or|same as|starts with)(?=\s)/,
                lookbehind: true
            },
            /[=<>]=?|!=|\*\*?|\/\/?|\?:?|[-+~%|]/
        ],
        punctuation: /[()\[\]{}:.,]/
    };
    Prism.hooks.add('before-tokenize', function(env) {
        if (env.language !== 'twig') return;
        var pattern = /\{(?:#[\s\S]*?#|%[\s\S]*?%|\{[\s\S]*?\})\}/g;
        Prism.languages['markup-templating'].buildPlaceholders(env, 'twig', pattern);
    });
    Prism.hooks.add('after-tokenize', function(env) {
        Prism.languages['markup-templating'].tokenizePlaceholders(env, 'twig');
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$9d032faa85d6103d$export$2e2bcd8739ae039.displayName = 'pug';
$9d032faa85d6103d$export$2e2bcd8739ae039.aliases = [];
function $9d032faa85d6103d$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    (function(Prism) {
        // TODO:
        // - Add CSS highlighting inside <style> tags
        // - Add support for multi-line code blocks
        // - Add support for interpolation #{} and !{}
        // - Add support for tag interpolation #[]
        // - Add explicit support for plain text using |
        // - Add support for markup embedded in plain text
        Prism.languages.pug = {
            // Multiline stuff should appear before the rest
            // This handles both single-line and multi-line comments
            comment: {
                pattern: /(^([\t ]*))\/\/.*(?:(?:\r?\n|\r)\2[\t ].+)*/m,
                lookbehind: true
            },
            // All the tag-related part is in lookbehind
            // so that it can be highlighted by the "tag" pattern
            'multiline-script': {
                pattern: /(^([\t ]*)script\b.*\.[\t ]*)(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            // See at the end of the file for known filters
            filter: {
                pattern: /(^([\t ]*)):.+(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
                lookbehind: true,
                inside: {
                    'filter-name': {
                        pattern: /^:[\w-]+/,
                        alias: 'variable'
                    },
                    text: /\S[\s\S]*/
                }
            },
            'multiline-plain-text': {
                pattern: /(^([\t ]*)[\w\-#.]+\.[\t ]*)(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
                lookbehind: true
            },
            markup: {
                pattern: /(^[\t ]*)<.+/m,
                lookbehind: true,
                inside: Prism.languages.markup
            },
            doctype: {
                pattern: /((?:^|\n)[\t ]*)doctype(?: .+)?/,
                lookbehind: true
            },
            // This handle all conditional and loop keywords
            'flow-control': {
                pattern: /(^[\t ]*)(?:case|default|each|else|if|unless|when|while)\b(?: .+)?/m,
                lookbehind: true,
                inside: {
                    each: {
                        pattern: /^each .+? in\b/,
                        inside: {
                            keyword: /\b(?:each|in)\b/,
                            punctuation: /,/
                        }
                    },
                    branch: {
                        pattern: /^(?:case|default|else|if|unless|when|while)\b/,
                        alias: 'keyword'
                    },
                    rest: Prism.languages.javascript
                }
            },
            keyword: {
                pattern: /(^[\t ]*)(?:append|block|extends|include|prepend)\b.+/m,
                lookbehind: true
            },
            mixin: [
                // Declaration
                {
                    pattern: /(^[\t ]*)mixin .+/m,
                    lookbehind: true,
                    inside: {
                        keyword: /^mixin/,
                        function: /\w+(?=\s*\(|\s*$)/,
                        punctuation: /[(),.]/
                    }
                },
                // Usage
                {
                    pattern: /(^[\t ]*)\+.+/m,
                    lookbehind: true,
                    inside: {
                        name: {
                            pattern: /^\+\w+/,
                            alias: 'function'
                        },
                        rest: Prism.languages.javascript
                    }
                }
            ],
            script: {
                pattern: /(^[\t ]*script(?:(?:&[^(]+)?\([^)]+\))*[\t ]).+/m,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            'plain-text': {
                pattern: /(^[\t ]*(?!-)[\w\-#.]*[\w\-](?:(?:&[^(]+)?\([^)]+\))*\/?[\t ]).+/m,
                lookbehind: true
            },
            tag: {
                pattern: /(^[\t ]*)(?!-)[\w\-#.]*[\w\-](?:(?:&[^(]+)?\([^)]+\))*\/?:?/m,
                lookbehind: true,
                inside: {
                    attributes: [
                        {
                            pattern: /&[^(]+\([^)]+\)/,
                            inside: Prism.languages.javascript
                        },
                        {
                            pattern: /\([^)]+\)/,
                            inside: {
                                'attr-value': {
                                    pattern: /(=\s*(?!\s))(?:\{[^}]*\}|[^,)\r\n]+)/,
                                    lookbehind: true,
                                    inside: Prism.languages.javascript
                                },
                                'attr-name': /[\w-]+(?=\s*!?=|\s*[,)])/,
                                punctuation: /[!=(),]+/
                            }
                        }
                    ],
                    punctuation: /:/,
                    'attr-id': /#[\w\-]+/,
                    'attr-class': /\.[\w\-]+/
                }
            },
            code: [
                {
                    pattern: /(^[\t ]*(?:-|!?=)).+/m,
                    lookbehind: true,
                    inside: Prism.languages.javascript
                }
            ],
            punctuation: /[.\-!=|]+/
        };
        var filter_pattern = /(^([\t ]*)):<filter_name>(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/.source;
        // Non exhaustive list of available filters and associated languages
        var filters = [
            {
                filter: 'atpl',
                language: 'twig'
            },
            {
                filter: 'coffee',
                language: 'coffeescript'
            },
            'ejs',
            'handlebars',
            'less',
            'livescript',
            'markdown',
            {
                filter: 'sass',
                language: 'scss'
            },
            'stylus'
        ];
        var all_filters = {};
        for(var i = 0, l = filters.length; i < l; i++){
            var filter = filters[i];
            filter = typeof filter === 'string' ? {
                filter: filter,
                language: filter
            } : filter;
            if (Prism.languages[filter.language]) all_filters['filter-' + filter.filter] = {
                pattern: RegExp(filter_pattern.replace('<filter_name>', function() {
                    return filter.filter;
                }), 'm'),
                lookbehind: true,
                inside: {
                    'filter-name': {
                        pattern: /^:[\w-]+/,
                        alias: 'variable'
                    },
                    text: {
                        pattern: /\S[\s\S]*/,
                        alias: [
                            filter.language,
                            'language-' + filter.language
                        ],
                        inside: Prism.languages[filter.language]
                    }
                }
            };
        }
        Prism.languages.insertBefore('pug', 'filter', all_filters);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $f0ce0a61b7257e87$export$2e2bcd8739ae039.displayName = 'puppet';
$f0ce0a61b7257e87$export$2e2bcd8739ae039.aliases = [];
function $f0ce0a61b7257e87$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.puppet = {
            heredoc: [
                // Matches the content of a quoted heredoc string (subject to interpolation)
                {
                    pattern: /(@\("([^"\r\n\/):]+)"(?:\/[nrts$uL]*)?\).*(?:\r?\n|\r))(?:.*(?:\r?\n|\r(?!\n)))*?[ \t]*(?:\|[ \t]*)?(?:-[ \t]*)?\2/,
                    lookbehind: true,
                    alias: 'string',
                    inside: {
                        // Matches the end tag
                        punctuation: /(?=\S).*\S(?= *$)/
                    }
                },
                // Matches the content of an unquoted heredoc string (no interpolation)
                {
                    pattern: /(@\(([^"\r\n\/):]+)(?:\/[nrts$uL]*)?\).*(?:\r?\n|\r))(?:.*(?:\r?\n|\r(?!\n)))*?[ \t]*(?:\|[ \t]*)?(?:-[ \t]*)?\2/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'string',
                    inside: {
                        // Matches the end tag
                        punctuation: /(?=\S).*\S(?= *$)/
                    }
                },
                // Matches the start tag of heredoc strings
                {
                    pattern: /@\("?(?:[^"\r\n\/):]+)"?(?:\/[nrts$uL]*)?\)/,
                    alias: 'string',
                    inside: {
                        punctuation: {
                            pattern: /(\().+?(?=\))/,
                            lookbehind: true
                        }
                    }
                }
            ],
            'multiline-comment': {
                pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
                lookbehind: true,
                greedy: true,
                alias: 'comment'
            },
            regex: {
                // Must be prefixed with the keyword "node" or a non-word char
                pattern: /((?:\bnode\s+|[~=\(\[\{,]\s*|[=+]>\s*|^\s*))\/(?:[^\/\\]|\\[\s\S])+\/(?:[imx]+\b|\B)/,
                lookbehind: true,
                greedy: true,
                inside: {
                    // Extended regexes must have the x flag. They can contain single-line comments.
                    'extended-regex': {
                        pattern: /^\/(?:[^\/\\]|\\[\s\S])+\/[im]*x[im]*$/,
                        inside: {
                            comment: /#.*/
                        }
                    }
                }
            },
            comment: {
                pattern: /(^|[^\\])#.*/,
                lookbehind: true,
                greedy: true
            },
            string: {
                // Allow for one nested level of double quotes inside interpolation
                pattern: /(["'])(?:\$\{(?:[^'"}]|(["'])(?:(?!\2)[^\\]|\\[\s\S])*\2)+\}|\$(?!\{)|(?!\1)[^\\$]|\\[\s\S])*\1/,
                greedy: true,
                inside: {
                    'double-quoted': {
                        pattern: /^"[\s\S]*"$/,
                        inside: {
                        }
                    }
                }
            },
            variable: {
                pattern: /\$(?:::)?\w+(?:::\w+)*/,
                inside: {
                    punctuation: /::/
                }
            },
            'attr-name': /(?:\b\w+|\*)(?=\s*=>)/,
            function: [
                {
                    pattern: /(\.)(?!\d)\w+/,
                    lookbehind: true
                },
                /\b(?:contain|debug|err|fail|include|info|notice|realize|require|tag|warning)\b|\b(?!\d)\w+(?=\()/
            ],
            number: /\b(?:0x[a-f\d]+|\d+(?:\.\d+)?(?:e-?\d+)?)\b/i,
            boolean: /\b(?:false|true)\b/,
            // Includes words reserved for future use
            keyword: /\b(?:application|attr|case|class|consumes|default|define|else|elsif|function|if|import|inherits|node|private|produces|type|undef|unless)\b/,
            datatype: {
                pattern: /\b(?:Any|Array|Boolean|Callable|Catalogentry|Class|Collection|Data|Default|Enum|Float|Hash|Integer|NotUndef|Numeric|Optional|Pattern|Regexp|Resource|Runtime|Scalar|String|Struct|Tuple|Type|Undef|Variant)\b/,
                alias: 'symbol'
            },
            operator: /=[=~>]?|![=~]?|<(?:<\|?|[=~|-])?|>[>=]?|->?|~>|\|>?>?|[*\/%+?]|\b(?:and|in|or)\b/,
            punctuation: /[\[\]{}().,;]|:+/
        };
        var interpolation = [
            {
                // Allow for one nested level of braces inside interpolation
                pattern: /(^|[^\\])\$\{(?:[^'"{}]|\{[^}]*\}|(["'])(?:(?!\2)[^\\]|\\[\s\S])*\2)+\}/,
                lookbehind: true,
                inside: {
                    'short-variable': {
                        // Negative look-ahead prevent wrong highlighting of functions
                        pattern: /(^\$\{)(?!\w+\()(?:::)?\w+(?:::\w+)*/,
                        lookbehind: true,
                        alias: 'variable',
                        inside: {
                            punctuation: /::/
                        }
                    },
                    delimiter: {
                        pattern: /^\$/,
                        alias: 'variable'
                    },
                    rest: Prism.languages.puppet
                }
            },
            {
                pattern: /(^|[^\\])\$(?:::)?\w+(?:::\w+)*/,
                lookbehind: true,
                alias: 'variable',
                inside: {
                    punctuation: /::/
                }
            }
        ];
        Prism.languages.puppet['heredoc'][0].inside.interpolation = interpolation;
        Prism.languages.puppet['string'].inside['double-quoted'].inside.interpolation = interpolation;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $d402b3c4cd63a644$export$2e2bcd8739ae039.displayName = 'pure';
$d402b3c4cd63a644$export$2e2bcd8739ae039.aliases = [];
function $d402b3c4cd63a644$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // https://agraef.github.io/pure-docs/pure.html#lexical-matters
        Prism.languages.pure = {
            comment: [
                {
                    pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
                    lookbehind: true
                },
                {
                    pattern: /(^|[^\\:])\/\/.*/,
                    lookbehind: true
                },
                /#!.+/
            ],
            'inline-lang': {
                pattern: /%<[\s\S]+?%>/,
                greedy: true,
                inside: {
                    lang: {
                        pattern: /(^%< *)-\*-.+?-\*-/,
                        lookbehind: true,
                        alias: 'comment'
                    },
                    delimiter: {
                        pattern: /^%<.*|%>$/,
                        alias: 'punctuation'
                    }
                }
            },
            string: {
                pattern: /"(?:\\.|[^"\\\r\n])*"/,
                greedy: true
            },
            number: {
                // The look-behind prevents wrong highlighting of the .. operator
                pattern: /((?:\.\.)?)(?:\b(?:inf|nan)\b|\b0x[\da-f]+|(?:\b(?:0b)?\d+(?:\.\d+)?|\B\.\d+)(?:e[+-]?\d+)?L?)/i,
                lookbehind: true
            },
            keyword: /\b(?:NULL|ans|break|bt|case|catch|cd|clear|const|def|del|dump|else|end|exit|extern|false|force|help|if|infix[lr]?|interface|let|ls|mem|namespace|nonfix|of|otherwise|outfix|override|postfix|prefix|private|public|pwd|quit|run|save|show|stats|then|throw|trace|true|type|underride|using|when|with)\b/,
            function: /\b(?:abs|add_(?:addr|constdef|(?:fundef|interface|macdef|typedef)(?:_at)?|vardef)|all|any|applp?|arity|bigintp?|blob(?:_crc|_size|p)?|boolp?|byte_c?string(?:_pointer)?|byte_(?:matrix|pointer)|calloc|cat|catmap|ceil|char[ps]?|check_ptrtag|chr|clear_sentry|clearsym|closurep?|cmatrixp?|cols?|colcat(?:map)?|colmap|colrev|colvector(?:p|seq)?|complex(?:_float_(?:matrix|pointer)|_matrix(?:_view)?|_pointer|p)?|conj|cookedp?|cst|cstring(?:_(?:dup|list|vector))?|curry3?|cyclen?|del_(?:constdef|fundef|interface|macdef|typedef|vardef)|delete|diag(?:mat)?|dim|dmatrixp?|do|double(?:_matrix(?:_view)?|_pointer|p)?|dowith3?|drop|dropwhile|eval(?:cmd)?|exactp|filter|fix|fixity|flip|float(?:_matrix|_pointer)|floor|fold[lr]1?|frac|free|funp?|functionp?|gcd|get(?:_(?:byte|constdef|double|float|fundef|int(?:64)?|interface(?:_typedef)?|long|macdef|pointer|ptrtag|sentry|short|string|typedef|vardef))?|globsym|hash|head|id|im|imatrixp?|index|inexactp|infp|init|insert|int(?:_matrix(?:_view)?|_pointer|p)?|int64_(?:matrix|pointer)|integerp?|iteraten?|iterwhile|join|keys?|lambdap?|last(?:err(?:pos)?)?|lcd|list[2p]?|listmap|make_ptrtag|malloc|map|matcat|matrixp?|max|member|min|nanp|nargs|nmatrixp?|null|numberp?|ord|pack(?:ed)?|pointer(?:_cast|_tag|_type|p)?|pow|pred|ptrtag|put(?:_(?:byte|double|float|int(?:64)?|long|pointer|short|string))?|rationalp?|re|realp?|realloc|recordp?|redim|reduce(?:_with)?|refp?|repeatn?|reverse|rlistp?|round|rows?|rowcat(?:map)?|rowmap|rowrev|rowvector(?:p|seq)?|same|scan[lr]1?|sentry|sgn|short_(?:matrix|pointer)|slice|smatrixp?|sort|split|str|strcat|stream|stride|string(?:_(?:dup|list|vector)|p)?|subdiag(?:mat)?|submat|subseq2?|substr|succ|supdiag(?:mat)?|symbolp?|tail|take|takewhile|thunkp?|transpose|trunc|tuplep?|typep|ubyte|uint(?:64)?|ulong|uncurry3?|unref|unzip3?|update|ushort|vals?|varp?|vector(?:p|seq)?|void|zip3?|zipwith3?)\b/,
            special: {
                pattern: /\b__[a-z]+__\b/i,
                alias: 'builtin'
            },
            // Any combination of operator chars can be an operator
            // eslint-disable-next-line no-misleading-character-class
            operator: /(?:[!"#$%&'*+,\-.\/:<=>?@\\^`|~\u00a1-\u00bf\u00d7-\u00f7\u20d0-\u2bff]|\b_+\b)+|\b(?:and|div|mod|not|or)\b/,
            // FIXME: How can we prevent | and , to be highlighted as operator when they are used alone?
            punctuation: /[(){}\[\];,|]/
        };
        var inlineLanguages = [
            'c',
            {
                lang: 'c++',
                alias: 'cpp'
            },
            'fortran'
        ];
        var inlineLanguageRe = /%< *-\*- *<lang>\d* *-\*-[\s\S]+?%>/.source;
        inlineLanguages.forEach(function(lang) {
            var alias = lang;
            if (typeof lang !== 'string') {
                alias = lang.alias;
                lang = lang.lang;
            }
            if (Prism.languages[alias]) {
                var o = {};
                o['inline-lang-' + alias] = {
                    pattern: RegExp(inlineLanguageRe.replace('<lang>', lang.replace(/([.+*?\/\\(){}\[\]])/g, '\\$1')), 'i'),
                    inside: Prism.util.clone(Prism.languages.pure['inline-lang'].inside)
                };
                o['inline-lang-' + alias].inside.rest = Prism.util.clone(Prism.languages[alias]);
                Prism.languages.insertBefore('pure', 'inline-lang', o);
            }
        });
        // C is the default inline language
        if (Prism.languages.c) Prism.languages.pure['inline-lang'].inside.rest = Prism.util.clone(Prism.languages.c);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$a42852126578ac8f$export$2e2bcd8739ae039.displayName = 'purebasic';
$a42852126578ac8f$export$2e2bcd8739ae039.aliases = [
    'pbfasm'
];
function $a42852126578ac8f$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    /*
Original Code by Bas Groothedde
!!MANY THANKS!! I never would have made this, regex and me will never be best friends ;)
==> https://codepen.io/ImagineProgramming/details/JYydBy/
slightly changed to pass all tests
*/ // PureBasic support, steal stuff from ansi-c
    Prism.languages.purebasic = Prism.languages.extend('clike', {
        comment: /;.*/,
        keyword: /\b(?:align|and|as|break|calldebugger|case|compilercase|compilerdefault|compilerelse|compilerelseif|compilerendif|compilerendselect|compilererror|compilerif|compilerselect|continue|data|datasection|debug|debuglevel|declare|declarec|declarecdll|declaredll|declaremodule|default|define|dim|disableasm|disabledebugger|disableexplicit|else|elseif|enableasm|enabledebugger|enableexplicit|end|enddatasection|enddeclaremodule|endenumeration|endif|endimport|endinterface|endmacro|endmodule|endprocedure|endselect|endstructure|endstructureunion|endwith|enumeration|extends|fakereturn|for|foreach|forever|global|gosub|goto|if|import|importc|includebinary|includefile|includepath|interface|macro|module|newlist|newmap|next|not|or|procedure|procedurec|procedurecdll|proceduredll|procedurereturn|protected|prototype|prototypec|read|redim|repeat|restore|return|runtime|select|shared|static|step|structure|structureunion|swap|threaded|to|until|wend|while|with|xincludefile|xor)\b/i,
        function: /\b\w+(?:\.\w+)?\s*(?=\()/,
        number: /(?:\$[\da-f]+|\b-?(?:\d+(?:\.\d+)?|\.\d+)(?:e[+-]?\d+)?)\b/i,
        operator: /(?:@\*?|\?|\*)\w+\$?|-[>-]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|?\||[~^%?*/@]/
    });
    Prism.languages.insertBefore('purebasic', 'keyword', {
        tag: /#\w+\$?/,
        asm: {
            pattern: /(^[\t ]*)!.*/m,
            lookbehind: true,
            alias: 'tag',
            inside: {
                comment: /;.*/,
                string: {
                    pattern: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
                    greedy: true
                },
                // Anonymous label references, i.e.: jmp @b
                'label-reference-anonymous': {
                    pattern: /(!\s*j[a-z]+\s+)@[fb]/i,
                    lookbehind: true,
                    alias: 'fasm-label'
                },
                // Named label reference, i.e.: jne label1
                'label-reference-addressed': {
                    pattern: /(!\s*j[a-z]+\s+)[A-Z._?$@][\w.?$@~#]*/i,
                    lookbehind: true,
                    alias: 'fasm-label'
                },
                keyword: [
                    /\b(?:extern|global)\b[^;\r\n]*/i,
                    /\b(?:CPU|DEFAULT|FLOAT)\b.*/
                ],
                function: {
                    pattern: /^([\t ]*!\s*)[\da-z]+(?=\s|$)/im,
                    lookbehind: true
                },
                'function-inline': {
                    pattern: /(:\s*)[\da-z]+(?=\s)/i,
                    lookbehind: true,
                    alias: 'function'
                },
                label: {
                    pattern: /^([\t ]*!\s*)[A-Za-z._?$@][\w.?$@~#]*(?=:)/m,
                    lookbehind: true,
                    alias: 'fasm-label'
                },
                register: /\b(?:st\d|[xyz]mm\d\d?|[cdt]r\d|r\d\d?[bwd]?|[er]?[abcd]x|[abcd][hl]|[er]?(?:bp|di|si|sp)|[cdefgs]s|mm\d+)\b/i,
                number: /(?:\b|-|(?=\$))(?:0[hx](?:[\da-f]*\.)?[\da-f]+(?:p[+-]?\d+)?|\d[\da-f]+[hx]|\$\d[\da-f]*|0[oq][0-7]+|[0-7]+[oq]|0[by][01]+|[01]+[by]|0[dt]\d+|(?:\d+(?:\.\d+)?|\.\d+)(?:\.?e[+-]?\d+)?[dt]?)\b/i,
                operator: /[\[\]*+\-/%<>=&|$!,.:]/
            }
        }
    });
    delete Prism.languages.purebasic['class-name'];
    delete Prism.languages.purebasic['boolean'];
    Prism.languages.pbfasm = Prism.languages['purebasic'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$75c09846dd2bbd2b$export$2e2bcd8739ae039.displayName = 'purescript';
$75c09846dd2bbd2b$export$2e2bcd8739ae039.aliases = [
    'purs'
];
function $75c09846dd2bbd2b$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $2ae70ee16ca48837$export$2e2bcd8739ae039));
    Prism.languages.purescript = Prism.languages.extend('haskell', {
        keyword: /\b(?:ado|case|class|data|derive|do|else|forall|if|in|infixl|infixr|instance|let|module|newtype|of|primitive|then|type|where)\b|∀/,
        'import-statement': {
            // The imported or hidden names are not included in this import
            // statement. This is because we want to highlight those exactly like
            // we do for the names in the program.
            pattern: /(^[\t ]*)import\s+[A-Z][\w']*(?:\.[A-Z][\w']*)*(?:\s+as\s+[A-Z][\w']*(?:\.[A-Z][\w']*)*)?(?:\s+hiding\b)?/m,
            lookbehind: true,
            inside: {
                keyword: /\b(?:as|hiding|import)\b/,
                punctuation: /\./
            }
        },
        // These are builtin functions only. Constructors are highlighted later as a constant.
        builtin: /\b(?:absurd|add|ap|append|apply|between|bind|bottom|clamp|compare|comparing|compose|conj|const|degree|discard|disj|div|eq|flap|flip|gcd|identity|ifM|join|lcm|liftA1|liftM1|map|max|mempty|min|mod|mul|negate|not|notEq|one|otherwise|recip|show|sub|top|unit|unless|unlessM|void|when|whenM|zero)\b/,
        operator: [
            // Infix operators
            Prism.languages.haskell.operator[0],
            // ASCII operators
            Prism.languages.haskell.operator[2],
            // All UTF16 Unicode operator symbols
            // This regex is equivalent to /(?=[\x80-\uFFFF])[\p{gc=Math_Symbol}\p{gc=Currency_Symbol}\p{Modifier_Symbol}\p{Other_Symbol}]/u
            // See https://github.com/PrismJS/prism/issues/3006 for more details.
            /[\xa2-\xa6\xa8\xa9\xac\xae-\xb1\xb4\xb8\xd7\xf7\u02c2-\u02c5\u02d2-\u02df\u02e5-\u02eb\u02ed\u02ef-\u02ff\u0375\u0384\u0385\u03f6\u0482\u058d-\u058f\u0606-\u0608\u060b\u060e\u060f\u06de\u06e9\u06fd\u06fe\u07f6\u07fe\u07ff\u09f2\u09f3\u09fa\u09fb\u0af1\u0b70\u0bf3-\u0bfa\u0c7f\u0d4f\u0d79\u0e3f\u0f01-\u0f03\u0f13\u0f15-\u0f17\u0f1a-\u0f1f\u0f34\u0f36\u0f38\u0fbe-\u0fc5\u0fc7-\u0fcc\u0fce\u0fcf\u0fd5-\u0fd8\u109e\u109f\u1390-\u1399\u166d\u17db\u1940\u19de-\u19ff\u1b61-\u1b6a\u1b74-\u1b7c\u1fbd\u1fbf-\u1fc1\u1fcd-\u1fcf\u1fdd-\u1fdf\u1fed-\u1fef\u1ffd\u1ffe\u2044\u2052\u207a-\u207c\u208a-\u208c\u20a0-\u20bf\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211e-\u2123\u2125\u2127\u2129\u212e\u213a\u213b\u2140-\u2144\u214a-\u214d\u214f\u218a\u218b\u2190-\u2307\u230c-\u2328\u232b-\u2426\u2440-\u244a\u249c-\u24e9\u2500-\u2767\u2794-\u27c4\u27c7-\u27e5\u27f0-\u2982\u2999-\u29d7\u29dc-\u29fb\u29fe-\u2b73\u2b76-\u2b95\u2b97-\u2bff\u2ce5-\u2cea\u2e50\u2e51\u2e80-\u2e99\u2e9b-\u2ef3\u2f00-\u2fd5\u2ff0-\u2ffb\u3004\u3012\u3013\u3020\u3036\u3037\u303e\u303f\u309b\u309c\u3190\u3191\u3196-\u319f\u31c0-\u31e3\u3200-\u321e\u322a-\u3247\u3250\u3260-\u327f\u328a-\u32b0\u32c0-\u33ff\u4dc0-\u4dff\ua490-\ua4c6\ua700-\ua716\ua720\ua721\ua789\ua78a\ua828-\ua82b\ua836-\ua839\uaa77-\uaa79\uab5b\uab6a\uab6b\ufb29\ufbb2-\ufbc1\ufdfc\ufdfd\ufe62\ufe64-\ufe66\ufe69\uff04\uff0b\uff1c-\uff1e\uff3e\uff40\uff5c\uff5e\uffe0-\uffe6\uffe8-\uffee\ufffc\ufffd]/
        ]
    });
    Prism.languages.purs = Prism.languages.purescript;
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$3b64cc26a0bd267e$export$2e2bcd8739ae039.displayName = 'qsharp';
$3b64cc26a0bd267e$export$2e2bcd8739ae039.aliases = [
    'qs'
];
function $3b64cc26a0bd267e$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    (function(Prism) {
        /**
     * Replaces all placeholders "<<n>>" of given pattern with the n-th replacement (zero based).
     *
     * Note: This is a simple text based replacement. Be careful when using backreferences!
     *
     * @param {string} pattern the given pattern.
     * @param {string[]} replacements a list of replacement which can be inserted into the given pattern.
     * @returns {string} the pattern with all placeholders replaced with their corresponding replacements.
     * @example replace(/a<<0>>a/.source, [/b+/.source]) === /a(?:b+)a/.source
     */ function replace(pattern, replacements) {
            return pattern.replace(/<<(\d+)>>/g, function(m, index) {
                return '(?:' + replacements[+index] + ')';
            });
        }
        /**
     * @param {string} pattern
     * @param {string[]} replacements
     * @param {string} [flags]
     * @returns {RegExp}
     */ function re(pattern, replacements, flags) {
            return RegExp(replace(pattern, replacements), flags || '');
        }
        /**
     * Creates a nested pattern where all occurrences of the string `<<self>>` are replaced with the pattern itself.
     *
     * @param {string} pattern
     * @param {number} depthLog2
     * @returns {string}
     */ function nested(pattern, depthLog2) {
            for(var i = 0; i < depthLog2; i++)pattern = pattern.replace(/<<self>>/g, function() {
                return '(?:' + pattern + ')';
            });
            return pattern.replace(/<<self>>/g, '[^\\s\\S]');
        }
        // https://docs.microsoft.com/en-us/azure/quantum/user-guide/language/typesystem/
        // https://github.com/microsoft/qsharp-language/tree/main/Specifications/Language/5_Grammar
        var keywordKinds = {
            // keywords which represent a return or variable type
            type: 'Adj BigInt Bool Ctl Double false Int One Pauli PauliI PauliX PauliY PauliZ Qubit Range Result String true Unit Zero',
            // all other keywords
            other: 'Adjoint adjoint apply as auto body borrow borrowing Controlled controlled distribute elif else fail fixup for function if in internal intrinsic invert is let mutable namespace new newtype open operation repeat return self set until use using while within'
        };
        // keywords
        function keywordsToPattern(words) {
            return '\\b(?:' + words.trim().replace(/ /g, '|') + ')\\b';
        }
        var keywords = RegExp(keywordsToPattern(keywordKinds.type + ' ' + keywordKinds.other));
        // types
        var identifier = /\b[A-Za-z_]\w*\b/.source;
        var qualifiedName = replace(/<<0>>(?:\s*\.\s*<<0>>)*/.source, [
            identifier
        ]);
        var typeInside = {
            keyword: keywords,
            punctuation: /[<>()?,.:[\]]/
        };
        // strings
        var regularString = /"(?:\\.|[^\\"])*"/.source;
        Prism.languages.qsharp = Prism.languages.extend('clike', {
            comment: /\/\/.*/,
            string: [
                {
                    pattern: re(/(^|[^$\\])<<0>>/.source, [
                        regularString
                    ]),
                    lookbehind: true,
                    greedy: true
                }
            ],
            'class-name': [
                {
                    // open Microsoft.Quantum.Canon;
                    // open Microsoft.Quantum.Canon as CN;
                    pattern: re(/(\b(?:as|open)\s+)<<0>>(?=\s*(?:;|as\b))/.source, [
                        qualifiedName
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // namespace Quantum.App1;
                    pattern: re(/(\bnamespace\s+)<<0>>(?=\s*\{)/.source, [
                        qualifiedName
                    ]),
                    lookbehind: true,
                    inside: typeInside
                }
            ],
            keyword: keywords,
            number: /(?:\b0(?:x[\da-f]+|b[01]+|o[0-7]+)|(?:\B\.\d+|\b\d+(?:\.\d*)?)(?:e[-+]?\d+)?)l?\b/i,
            operator: /\band=|\bor=|\band\b|\bnot\b|\bor\b|<[-=]|[-=]>|>>>=?|<<<=?|\^\^\^=?|\|\|\|=?|&&&=?|w\/=?|~~~|[*\/+\-^=!%]=?/,
            punctuation: /::|[{}[\];(),.:]/
        });
        Prism.languages.insertBefore('qsharp', 'number', {
            range: {
                pattern: /\.\./,
                alias: 'operator'
            }
        });
        // single line
        var interpolationExpr = nested(replace(/\{(?:[^"{}]|<<0>>|<<self>>)*\}/.source, [
            regularString
        ]), 2);
        Prism.languages.insertBefore('qsharp', 'string', {
            'interpolation-string': {
                pattern: re(/\$"(?:\\.|<<0>>|[^\\"{])*"/.source, [
                    interpolationExpr
                ]),
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: re(/((?:^|[^\\])(?:\\\\)*)<<0>>/.source, [
                            interpolationExpr
                        ]),
                        lookbehind: true,
                        inside: {
                            punctuation: /^\{|\}$/,
                            expression: {
                                pattern: /[\s\S]+/,
                                alias: 'language-qsharp',
                                inside: Prism.languages.qsharp
                            }
                        }
                    },
                    string: /[\s\S]+/
                }
            }
        });
    })(Prism);
    Prism.languages.qs = Prism.languages.qsharp;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $2651f31c4a94c2f1$export$2e2bcd8739ae039.displayName = 'q';
$2651f31c4a94c2f1$export$2e2bcd8739ae039.aliases = [];
function $2651f31c4a94c2f1$export$2e2bcd8739ae039(Prism) {
    Prism.languages.q = {
        string: /"(?:\\.|[^"\\\r\n])*"/,
        comment: [
            // From http://code.kx.com/wiki/Reference/Slash:
            // When / is following a space (or a right parenthesis, bracket, or brace), it is ignored with the rest of the line.
            {
                pattern: /([\t )\]}])\/.*/,
                lookbehind: true,
                greedy: true
            },
            // From http://code.kx.com/wiki/Reference/Slash:
            // A line which has / as its first character and contains at least one other non-whitespace character is a whole-line comment and is ignored entirely.
            // A / on a line by itself begins a multiline comment which is terminated by the next \ on a line by itself.
            // If a / is not matched by a \, the multiline comment is unterminated and continues to end of file.
            // The / and \ must be the first char on the line, but may be followed by any amount of whitespace.
            {
                pattern: /(^|\r?\n|\r)\/[\t ]*(?:(?:\r?\n|\r)(?:.*(?:\r?\n|\r(?!\n)))*?(?:\\(?=[\t ]*(?:\r?\n|\r))|$)|\S.*)/,
                lookbehind: true,
                greedy: true
            },
            // From http://code.kx.com/wiki/Reference/Slash:
            // A \ on a line by itself with no preceding matching / will comment to end of file.
            {
                pattern: /^\\[\t ]*(?:\r?\n|\r)[\s\S]+/m,
                greedy: true
            },
            {
                pattern: /^#!.+/m,
                greedy: true
            }
        ],
        symbol: /`(?::\S+|[\w.]*)/,
        datetime: {
            pattern: /0N[mdzuvt]|0W[dtz]|\d{4}\.\d\d(?:m|\.\d\d(?:T(?:\d\d(?::\d\d(?::\d\d(?:[.:]\d\d\d)?)?)?)?)?[dz]?)|\d\d:\d\d(?::\d\d(?:[.:]\d\d\d)?)?[uvt]?/,
            alias: 'number'
        },
        // The negative look-ahead prevents bad highlighting
        // of verbs 0: and 1:
        number: /\b(?![01]:)(?:0N[hje]?|0W[hj]?|0[wn]|0x[\da-fA-F]+|\d+(?:\.\d*)?(?:e[+-]?\d+)?[hjfeb]?)/,
        keyword: /\\\w+\b|\b(?:abs|acos|aj0?|all|and|any|asc|asin|asof|atan|attr|avgs?|binr?|by|ceiling|cols|cor|cos|count|cov|cross|csv|cut|delete|deltas|desc|dev|differ|distinct|div|do|dsave|ej|enlist|eval|except|exec|exit|exp|fby|fills|first|fkeys|flip|floor|from|get|getenv|group|gtime|hclose|hcount|hdel|hopen|hsym|iasc|identity|idesc|if|ij|in|insert|inter|inv|keys?|last|like|list|ljf?|load|log|lower|lsq|ltime|ltrim|mavg|maxs?|mcount|md5|mdev|med|meta|mins?|mmax|mmin|mmu|mod|msum|neg|next|not|null|or|over|parse|peach|pj|plist|prds?|prev|prior|rand|rank|ratios|raze|read0|read1|reciprocal|reval|reverse|rload|rotate|rsave|rtrim|save|scan|scov|sdev|select|set|setenv|show|signum|sin|sqrt|ssr?|string|sublist|sums?|sv|svar|system|tables|tan|til|trim|txf|type|uj|ungroup|union|update|upper|upsert|value|var|views?|vs|wavg|where|while|within|wj1?|wsum|ww|xasc|xbar|xcols?|xdesc|xexp|xgroup|xkey|xlog|xprev|xrank)\b/,
        adverb: {
            pattern: /['\/\\]:?|\beach\b/,
            alias: 'function'
        },
        verb: {
            pattern: /(?:\B\.\B|\b[01]:|<[=>]?|>=?|[:+\-*%,!?~=|$&#@^]):?|\b_\b:?/,
            alias: 'operator'
        },
        punctuation: /[(){}\[\];.]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$2ba51d01e535556e$export$2e2bcd8739ae039.displayName = 'qml';
$2ba51d01e535556e$export$2e2bcd8739ae039.aliases = [];
function $2ba51d01e535556e$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
    (function(Prism) {
        var jsString = /"(?:\\.|[^\\"\r\n])*"|'(?:\\.|[^\\'\r\n])*'/.source;
        var jsComment = /\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))*\*\//.source;
        var jsExpr = /(?:[^\\()[\]{}"'/]|<string>|\/(?![*/])|<comment>|\(<expr>*\)|\[<expr>*\]|\{<expr>*\}|\\[\s\S])/.source.replace(/<string>/g, function() {
            return jsString;
        }).replace(/<comment>/g, function() {
            return jsComment;
        });
        // the pattern will blow up, so only a few iterations
        for(var i = 0; i < 2; i++)jsExpr = jsExpr.replace(/<expr>/g, function() {
            return jsExpr;
        });
        jsExpr = jsExpr.replace(/<expr>/g, '[^\\s\\S]');
        Prism.languages.qml = {
            comment: {
                pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
                greedy: true
            },
            'javascript-function': {
                pattern: RegExp(/((?:^|;)[ \t]*)function\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*\(<js>*\)\s*\{<js>*\}/.source.replace(/<js>/g, function() {
                    return jsExpr;
                }), 'm'),
                lookbehind: true,
                greedy: true,
                alias: 'language-javascript',
                inside: Prism.languages.javascript
            },
            'class-name': {
                pattern: /((?:^|[:;])[ \t]*)(?!\d)\w+(?=[ \t]*\{|[ \t]+on\b)/m,
                lookbehind: true
            },
            property: [
                {
                    pattern: /((?:^|[;{])[ \t]*)(?!\d)\w+(?:\.\w+)*(?=[ \t]*:)/m,
                    lookbehind: true
                },
                {
                    pattern: /((?:^|[;{])[ \t]*)property[ \t]+(?!\d)\w+(?:\.\w+)*[ \t]+(?!\d)\w+(?:\.\w+)*(?=[ \t]*:)/m,
                    lookbehind: true,
                    inside: {
                        keyword: /^property/,
                        property: /\w+(?:\.\w+)*/
                    }
                }
            ],
            'javascript-expression': {
                pattern: RegExp(/(:[ \t]*)(?![\s;}[])(?:(?!$|[;}])<js>)+/.source.replace(/<js>/g, function() {
                    return jsExpr;
                }), 'm'),
                lookbehind: true,
                greedy: true,
                alias: 'language-javascript',
                inside: Prism.languages.javascript
            },
            string: {
                pattern: /"(?:\\.|[^\\"\r\n])*"/,
                greedy: true
            },
            keyword: /\b(?:as|import|on)\b/,
            punctuation: /[{}[\]:;,]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$f20909d17a339405$export$2e2bcd8739ae039.displayName = 'qore';
$f20909d17a339405$export$2e2bcd8739ae039.aliases = [];
function $f20909d17a339405$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.qore = Prism.languages.extend('clike', {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:\/\/|#).*)/,
            lookbehind: true
        },
        // Overridden to allow unescaped multi-line strings
        string: {
            pattern: /("|')(?:\\[\s\S]|(?!\1)[^\\])*\1/,
            greedy: true
        },
        keyword: /\b(?:abstract|any|assert|binary|bool|boolean|break|byte|case|catch|char|class|code|const|continue|data|default|do|double|else|enum|extends|final|finally|float|for|goto|hash|if|implements|import|inherits|instanceof|int|interface|long|my|native|new|nothing|null|object|our|own|private|reference|rethrow|return|short|soft(?:bool|date|float|int|list|number|string)|static|strictfp|string|sub|super|switch|synchronized|this|throw|throws|transient|try|void|volatile|while)\b/,
        boolean: /\b(?:false|true)\b/i,
        function: /\$?\b(?!\d)\w+(?=\()/,
        number: /\b(?:0b[01]+|0x(?:[\da-f]*\.)?[\da-fp\-]+|(?:\d+(?:\.\d+)?|\.\d+)(?:e\d+)?[df]|(?:\d+(?:\.\d+)?|\.\d+))\b/i,
        operator: {
            pattern: /(^|[^.])(?:\+[+=]?|-[-=]?|[!=](?:==?|~)?|>>?=?|<(?:=>?|<=?)?|&[&=]?|\|[|=]?|[*\/%^]=?|[~?])/,
            lookbehind: true
        },
        variable: /\$(?!\d)\w+\b/
    });
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$2def36300150cc17$export$2e2bcd8739ae039.displayName = 'racket';
$2def36300150cc17$export$2e2bcd8739ae039.aliases = [
    'rkt'
];
function $2def36300150cc17$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f15bc5f7f9ab760a$export$2e2bcd8739ae039));
    Prism.languages.racket = Prism.languages.extend('scheme', {
        'lambda-parameter': {
            // the racket lambda syntax is a lot more complex, so we won't even attempt to capture it.
            // this will just prevent false positives of the `function` pattern
            pattern: /([(\[]lambda\s+[(\[])[^()\[\]'\s]+/,
            lookbehind: true
        }
    });
    Prism.languages.insertBefore('racket', 'string', {
        lang: {
            pattern: /^#lang.+/m,
            greedy: true,
            alias: 'keyword'
        }
    });
    Prism.languages.rkt = Prism.languages.racket;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$be3f5e01c2434719$export$2e2bcd8739ae039.displayName = 'cshtml';
$be3f5e01c2434719$export$2e2bcd8739ae039.aliases = [
    'razor'
];
function $be3f5e01c2434719$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $803928922a6961a4$export$2e2bcd8739ae039));
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    (function(Prism) {
        var commentLike = /\/(?![/*])|\/\/.*[\r\n]|\/\*[^*]*(?:\*(?!\/)[^*]*)*\*\//.source;
        var stringLike = /@(?!")|"(?:[^\r\n\\"]|\\.)*"|@"(?:[^\\"]|""|\\[\s\S])*"(?!")/.source + '|' + /'(?:(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'|(?=[^\\](?!')))/.source;
        /**
     * Creates a nested pattern where all occurrences of the string `<<self>>` are replaced with the pattern itself.
     *
     * @param {string} pattern
     * @param {number} depthLog2
     * @returns {string}
     */ function nested(pattern, depthLog2) {
            for(var i = 0; i < depthLog2; i++)pattern = pattern.replace(/<self>/g, function() {
                return '(?:' + pattern + ')';
            });
            return pattern.replace(/<self>/g, '[^\\s\\S]').replace(/<str>/g, '(?:' + stringLike + ')').replace(/<comment>/g, '(?:' + commentLike + ')');
        }
        var round = nested(/\((?:[^()'"@/]|<str>|<comment>|<self>)*\)/.source, 2);
        var square = nested(/\[(?:[^\[\]'"@/]|<str>|<comment>|<self>)*\]/.source, 1);
        var curly = nested(/\{(?:[^{}'"@/]|<str>|<comment>|<self>)*\}/.source, 2);
        var angle = nested(/<(?:[^<>'"@/]|<comment>|<self>)*>/.source, 1);
        var inlineCs = /@/.source + /(?:await\b\s*)?/.source + '(?:' + /(?!await\b)\w+\b/.source + '|' + round + ')' + '(?:' + /[?!]?\.\w+\b/.source + '|' + '(?:' + angle + ')?' + round + '|' + square + ')*' + /(?![?!\.(\[]|<(?!\/))/.source;
        // Note about the above bracket patterns:
        // They all ignore HTML expressions that might be in the C# code. This is a problem because HTML (like strings and
        // comments) is parsed differently. This is a huge problem because HTML might contain brackets and quotes which
        // messes up the bracket and string counting implemented by the above patterns.
        //
        // This problem is not fixable because 1) HTML expression are highly context sensitive and very difficult to detect
        // and 2) they require one capturing group at every nested level. See the `tagRegion` pattern to admire the
        // complexity of an HTML expression.
        //
        // To somewhat alleviate the problem a bit, the patterns for characters (e.g. 'a') is very permissive, it also
        // allows invalid characters to support HTML expressions like this: <p>That's it!</p>.
        var tagAttrInlineCs = /@(?![\w()])/.source + '|' + inlineCs;
        var tagAttrValue = '(?:' + /"[^"@]*"|'[^'@]*'|[^\s'"@>=]+(?=[\s>])/.source + '|' + '["\'][^"\'@]*(?:(?:' + tagAttrInlineCs + ')[^"\'@]*)+["\']' + ')';
        var tagAttrs = /(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*<tagAttrValue>|(?=[\s/>])))+)?/.source.replace(/<tagAttrValue>/, tagAttrValue);
        var tagContent = /(?!\d)[^\s>\/=$<%]+/.source + tagAttrs + /\s*\/?>/.source;
        var tagRegion = /\B@?/.source + '(?:' + /<([a-zA-Z][\w:]*)/.source + tagAttrs + /\s*>/.source + '(?:' + (/[^<]/.source + '|' + // all tags that are not the start tag
        // eslint-disable-next-line regexp/strict
        /<\/?(?!\1\b)/.source + tagContent + '|' + // nested start tag
        nested(// eslint-disable-next-line regexp/strict
        /<\1/.source + tagAttrs + /\s*>/.source + '(?:' + (/[^<]/.source + '|' + // all tags that are not the start tag
        // eslint-disable-next-line regexp/strict
        /<\/?(?!\1\b)/.source + tagContent + '|' + '<self>') + ')*' + // eslint-disable-next-line regexp/strict
        /<\/\1\s*>/.source, 2)) + ')*' + // eslint-disable-next-line regexp/strict
        /<\/\1\s*>/.source + '|' + /</.source + tagContent + ')';
        // Now for the actual language definition(s):
        //
        // Razor as a language has 2 parts:
        //  1) CSHTML: A markup-like language that has been extended with inline C# code expressions and blocks.
        //  2) C#+HTML: A variant of C# that can contain CSHTML tags as expressions.
        //
        // In the below code, both CSHTML and C#+HTML will be create as separate language definitions that reference each
        // other. However, only CSHTML will be exported via `Prism.languages`.
        Prism.languages.cshtml = Prism.languages.extend('markup', {});
        var csharpWithHtml = Prism.languages.insertBefore('csharp', 'string', {
            html: {
                pattern: RegExp(tagRegion),
                greedy: true,
                inside: Prism.languages.cshtml
            }
        }, {
            csharp: Prism.languages.extend('csharp', {})
        });
        var cs = {
            pattern: /\S[\s\S]*/,
            alias: 'language-csharp',
            inside: csharpWithHtml
        };
        var inlineValue = {
            pattern: RegExp(/(^|[^@])/.source + inlineCs),
            lookbehind: true,
            greedy: true,
            alias: 'variable',
            inside: {
                keyword: /^@/,
                csharp: cs
            }
        };
        Prism.languages.cshtml.tag.pattern = RegExp(/<\/?/.source + tagContent);
        Prism.languages.cshtml.tag.inside['attr-value'].pattern = RegExp(/=\s*/.source + tagAttrValue);
        Prism.languages.insertBefore('inside', 'punctuation', {
            value: inlineValue
        }, Prism.languages.cshtml.tag.inside['attr-value']);
        Prism.languages.insertBefore('cshtml', 'prolog', {
            'razor-comment': {
                pattern: /@\*[\s\S]*?\*@/,
                greedy: true,
                alias: 'comment'
            },
            block: {
                pattern: RegExp(/(^|[^@])@/.source + '(?:' + [
                    // @{ ... }
                    curly,
                    // @code{ ... }
                    /(?:code|functions)\s*/.source + curly,
                    // @for (...) { ... }
                    /(?:for|foreach|lock|switch|using|while)\s*/.source + round + /\s*/.source + curly,
                    // @do { ... } while (...);
                    /do\s*/.source + curly + /\s*while\s*/.source + round + /(?:\s*;)?/.source,
                    // @try { ... } catch (...) { ... } finally { ... }
                    /try\s*/.source + curly + /\s*catch\s*/.source + round + /\s*/.source + curly + /\s*finally\s*/.source + curly,
                    // @if (...) {...} else if (...) {...} else {...}
                    /if\s*/.source + round + /\s*/.source + curly + '(?:' + /\s*else/.source + '(?:' + /\s+if\s*/.source + round + ')?' + /\s*/.source + curly + ')*',
                    // @helper Ident(params) { ... }
                    /helper\s+\w+\s*/.source + round + /\s*/.source + curly
                ].join('|') + ')'),
                lookbehind: true,
                greedy: true,
                inside: {
                    keyword: /^@\w*/,
                    csharp: cs
                }
            },
            directive: {
                pattern: /^([ \t]*)@(?:addTagHelper|attribute|implements|inherits|inject|layout|model|namespace|page|preservewhitespace|removeTagHelper|section|tagHelperPrefix|using)(?=\s).*/m,
                lookbehind: true,
                greedy: true,
                inside: {
                    keyword: /^@\w+/,
                    csharp: cs
                }
            },
            value: inlineValue,
            'delegate-operator': {
                pattern: /(^|[^@])@(?=<)/,
                lookbehind: true,
                alias: 'operator'
            }
        });
        Prism.languages.razor = Prism.languages.cshtml;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$0636642bf7a5dca9$export$2e2bcd8739ae039.displayName = 'jsx';
$0636642bf7a5dca9$export$2e2bcd8739ae039.aliases = [];
function $0636642bf7a5dca9$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    (function(Prism) {
        var javascript = Prism.util.clone(Prism.languages.javascript);
        var space = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source;
        var braces = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source;
        var spread = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
        /**
     * @param {string} source
     * @param {string} [flags]
     */ function re(source, flags) {
            source = source.replace(/<S>/g, function() {
                return space;
            }).replace(/<BRACES>/g, function() {
                return braces;
            }).replace(/<SPREAD>/g, function() {
                return spread;
            });
            return RegExp(source, flags);
        }
        spread = re(spread).source;
        Prism.languages.jsx = Prism.languages.extend('markup', javascript);
        Prism.languages.jsx.tag.pattern = re(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source);
        Prism.languages.jsx.tag.inside['tag'].pattern = /^<\/?[^\s>\/]*/;
        Prism.languages.jsx.tag.inside['attr-value'].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/;
        Prism.languages.jsx.tag.inside['tag'].inside['class-name'] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/;
        Prism.languages.jsx.tag.inside['comment'] = javascript['comment'];
        Prism.languages.insertBefore('inside', 'attr-name', {
            spread: {
                pattern: re(/<SPREAD>/.source),
                inside: Prism.languages.jsx
            }
        }, Prism.languages.jsx.tag);
        Prism.languages.insertBefore('inside', 'special-attr', {
            script: {
                // Allow for two levels of nesting
                pattern: re(/=<BRACES>/.source),
                alias: 'language-javascript',
                inside: {
                    'script-punctuation': {
                        pattern: /^=(?=\{)/,
                        alias: 'punctuation'
                    },
                    rest: Prism.languages.jsx
                }
            }
        }, Prism.languages.jsx.tag);
        // The following will handle plain text inside tags
        var stringifyToken = function(token) {
            if (!token) return '';
            if (typeof token === 'string') return token;
            if (typeof token.content === 'string') return token.content;
            return token.content.map(stringifyToken).join('');
        };
        var walkTokens = function(tokens) {
            var openedTags = [];
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                var notTagNorBrace = false;
                if (typeof token !== 'string') {
                    if (token.type === 'tag' && token.content[0] && token.content[0].type === 'tag') {
                        // We found a tag, now find its kind
                        if (token.content[0].content[0].content === '</') // Closing tag
                        {
                            if (openedTags.length > 0 && openedTags[openedTags.length - 1].tagName === stringifyToken(token.content[0].content[1])) // Pop matching opening tag
                            openedTags.pop();
                        } else {
                            if (token.content[token.content.length - 1].content === '/>') ;
                            else // Opening tag
                            openedTags.push({
                                tagName: stringifyToken(token.content[0].content[1]),
                                openedBraces: 0
                            });
                        }
                    } else if (openedTags.length > 0 && token.type === 'punctuation' && token.content === '{') // Here we might have entered a JSX context inside a tag
                    openedTags[openedTags.length - 1].openedBraces++;
                    else if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces > 0 && token.type === 'punctuation' && token.content === '}') // Here we might have left a JSX context inside a tag
                    openedTags[openedTags.length - 1].openedBraces--;
                    else notTagNorBrace = true;
                }
                if (notTagNorBrace || typeof token === 'string') {
                    if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces === 0) {
                        // Here we are inside a tag, and not inside a JSX context.
                        // That's plain text: drop any tokens matched.
                        var plainText = stringifyToken(token);
                        // And merge text with adjacent text
                        if (i < tokens.length - 1 && (typeof tokens[i + 1] === 'string' || tokens[i + 1].type === 'plain-text')) {
                            plainText += stringifyToken(tokens[i + 1]);
                            tokens.splice(i + 1, 1);
                        }
                        if (i > 0 && (typeof tokens[i - 1] === 'string' || tokens[i - 1].type === 'plain-text')) {
                            plainText = stringifyToken(tokens[i - 1]) + plainText;
                            tokens.splice(i - 1, 1);
                            i--;
                        }
                        tokens[i] = new Prism.Token('plain-text', plainText, null, plainText);
                    }
                }
                if (token.content && typeof token.content !== 'string') walkTokens(token.content);
            }
        };
        Prism.hooks.add('after-tokenize', function(env) {
            if (env.language !== 'jsx' && env.language !== 'tsx') return;
            walkTokens(env.tokens);
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$1100e9295cc7554a$export$2e2bcd8739ae039.displayName = 'tsx';
$1100e9295cc7554a$export$2e2bcd8739ae039.aliases = [];
function $1100e9295cc7554a$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $0636642bf7a5dca9$export$2e2bcd8739ae039));
    Prism.register((0, $010d7940936c67fb$export$2e2bcd8739ae039));
    (function(Prism) {
        var typescript = Prism.util.clone(Prism.languages.typescript);
        Prism.languages.tsx = Prism.languages.extend('jsx', typescript);
        // doesn't work with TS because TS is too complex
        delete Prism.languages.tsx['parameter'];
        delete Prism.languages.tsx['literal-property'];
        // This will prevent collisions between TSX tags and TS generic types.
        // Idea by https://github.com/karlhorky
        // Discussion: https://github.com/PrismJS/prism/issues/2594#issuecomment-710666928
        var tag = Prism.languages.tsx.tag;
        tag.pattern = RegExp(/(^|[^\w$]|(?=<\/))/.source + '(?:' + tag.pattern.source + ')', tag.pattern.flags);
        tag.lookbehind = true;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$ad8d5c52e7714ea6$export$2e2bcd8739ae039.displayName = 'reason';
$ad8d5c52e7714ea6$export$2e2bcd8739ae039.aliases = [];
function $ad8d5c52e7714ea6$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.reason = Prism.languages.extend('clike', {
        string: {
            pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
            greedy: true
        },
        // 'class-name' must be matched *after* 'constructor' defined below
        'class-name': /\b[A-Z]\w*/,
        keyword: /\b(?:and|as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|method|module|mutable|new|nonrec|object|of|open|or|private|rec|sig|struct|switch|then|to|try|type|val|virtual|when|while|with)\b/,
        operator: /\.{3}|:[:=]|\|>|->|=(?:==?|>)?|<=?|>=?|[|^?'#!~`]|[+\-*\/]\.?|\b(?:asr|land|lor|lsl|lsr|lxor|mod)\b/
    });
    Prism.languages.insertBefore('reason', 'class-name', {
        char: {
            pattern: /'(?:\\x[\da-f]{2}|\\o[0-3][0-7][0-7]|\\\d{3}|\\.|[^'\\\r\n])'/,
            greedy: true
        },
        // Negative look-ahead prevents from matching things like String.capitalize
        constructor: /\b[A-Z]\w*\b(?!\s*\.)/,
        label: {
            pattern: /\b[a-z]\w*(?=::)/,
            alias: 'symbol'
        }
    });
    // We can't match functions property, so let's not even try.
    delete Prism.languages.reason.function;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $c4f30d48e56845b8$export$2e2bcd8739ae039.displayName = 'rego';
$c4f30d48e56845b8$export$2e2bcd8739ae039.aliases = [];
function $c4f30d48e56845b8$export$2e2bcd8739ae039(Prism) {
    // https://www.openpolicyagent.org/docs/latest/policy-reference/
    Prism.languages.rego = {
        comment: /#.*/,
        property: {
            pattern: /(^|[^\\.])(?:"(?:\\.|[^\\"\r\n])*"|`[^`]*`|\b[a-z_]\w*\b)(?=\s*:(?!=))/i,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"|`[^`]*`/,
            lookbehind: true,
            greedy: true
        },
        keyword: /\b(?:as|default|else|import|not|null|package|set(?=\s*\()|some|with)\b/,
        boolean: /\b(?:false|true)\b/,
        function: {
            pattern: /\b[a-z_]\w*\b(?:\s*\.\s*\b[a-z_]\w*\b)*(?=\s*\()/i,
            inside: {
                namespace: /\b\w+\b(?=\s*\.)/,
                punctuation: /\./
            }
        },
        number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
        operator: /[-+*/%|&]|[<>:=]=?|!=|\b_\b/,
        punctuation: /[,;.\[\]{}()]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $32c58ead3c55b79c$export$2e2bcd8739ae039.displayName = 'renpy';
$32c58ead3c55b79c$export$2e2bcd8739ae039.aliases = [
    'rpy'
];
function $32c58ead3c55b79c$export$2e2bcd8739ae039(Prism) {
    Prism.languages.renpy = {
        comment: {
            pattern: /(^|[^\\])#.+/,
            lookbehind: true
        },
        string: {
            pattern: /("""|''')[\s\S]+?\1|("|')(?:\\.|(?!\2)[^\\])*\2|(?:^#?(?:(?:[0-9a-fA-F]){3}|[0-9a-fA-F]{6})$)/m,
            greedy: true
        },
        function: /\b[a-z_]\w*(?=\()/i,
        property: /\b(?:Update|UpdateVersion|action|activate_sound|adv_nvl_transition|after_load_transition|align|alpha|alt|anchor|antialias|area|auto|background|bar_invert|bar_resizing|bar_vertical|black_color|bold|bottom_bar|bottom_gutter|bottom_margin|bottom_padding|box_reverse|box_wrap|can_update|caret|child|color|crop|default_afm_enable|default_afm_time|default_fullscreen|default_text_cps|developer|directory_name|drag_handle|drag_joined|drag_name|drag_raise|draggable|dragged|drop_shadow|drop_shadow_color|droppable|dropped|easein|easeout|edgescroll|end_game_transition|end_splash_transition|enter_replay_transition|enter_sound|enter_transition|enter_yesno_transition|executable_name|exit_replay_transition|exit_sound|exit_transition|exit_yesno_transition|fadein|fadeout|first_indent|first_spacing|fit_first|focus|focus_mask|font|foreground|game_main_transition|get_installed_packages|google_play_key|google_play_salt|ground|has_music|has_sound|has_voice|height|help|hinting|hover|hover_background|hover_color|hover_sound|hovered|hyperlink_functions|idle|idle_color|image_style|include_update|insensitive|insensitive_background|insensitive_color|inside|intra_transition|italic|justify|kerning|keyboard_focus|language|layer_clipping|layers|layout|left_bar|left_gutter|left_margin|left_padding|length|line_leading|line_overlap_split|line_spacing|linear|main_game_transition|main_menu_music|maximum|min_width|minimum|minwidth|modal|mouse|mousewheel|name|narrator_menu|newline_indent|nvl_adv_transition|offset|order_reverse|outlines|overlay_functions|pos|position|prefix|radius|range|rest_indent|right_bar|right_gutter|right_margin|right_padding|rotate|rotate_pad|ruby_style|sample_sound|save_directory|say_attribute_transition|screen_height|screen_width|scrollbars|selected_hover|selected_hover_color|selected_idle|selected_idle_color|selected_insensitive|show_side_image|show_two_window|side_spacing|side_xpos|side_ypos|size|size_group|slow_cps|slow_cps_multiplier|spacing|strikethrough|subpixel|text_align|text_style|text_xpos|text_y_fudge|text_ypos|thumb|thumb_offset|thumb_shadow|thumbnail_height|thumbnail_width|time|top_bar|top_gutter|top_margin|top_padding|translations|underline|unscrollable|update|value|version|version_name|version_tuple|vertical|width|window_hide_transition|window_icon|window_left_padding|window_show_transition|window_title|windows_icon|xadjustment|xalign|xanchor|xanchoraround|xaround|xcenter|xfill|xinitial|xmargin|xmaximum|xminimum|xoffset|xofsset|xpadding|xpos|xsize|xzoom|yadjustment|yalign|yanchor|yanchoraround|yaround|ycenter|yfill|yinitial|ymargin|ymaximum|yminimum|yoffset|ypadding|ypos|ysize|ysizexysize|yzoom|zoom|zorder)\b/,
        tag: /\b(?:bar|block|button|buttoscreenn|drag|draggroup|fixed|frame|grid|[hv]box|hotbar|hotspot|image|imagebutton|imagemap|input|key|label|menu|mm_menu_frame|mousearea|nvl|parallel|screen|self|side|tag|text|textbutton|timer|vbar|viewport|window)\b|\$/,
        keyword: /\b(?:None|add|adjustment|alignaround|allow|angle|animation|around|as|assert|behind|box_layout|break|build|cache|call|center|changed|child_size|choice|circles|class|clear|clicked|clipping|clockwise|config|contains|continue|corner1|corner2|counterclockwise|def|default|define|del|delay|disabled|disabled_text|dissolve|elif|else|event|except|exclude|exec|expression|fade|finally|for|from|function|global|gm_root|has|hide|id|if|import|in|init|is|jump|knot|lambda|left|less_rounded|mm_root|movie|music|null|on|onlayer|pass|pause|persistent|play|print|python|queue|raise|random|renpy|repeat|return|right|rounded_window|scene|scope|set|show|slow|slow_abortable|slow_done|sound|stop|store|style|style_group|substitute|suffix|theme|transform|transform_anchor|transpose|try|ui|unhovered|updater|use|voice|while|widget|widget_hover|widget_selected|widget_text|yield)\b/,
        boolean: /\b(?:[Ff]alse|[Tt]rue)\b/,
        number: /(?:\b(?:0[bo])?(?:(?:\d|0x[\da-f])[\da-f]*(?:\.\d*)?)|\B\.\d+)(?:e[+-]?\d+)?j?/i,
        operator: /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]|\b(?:and|at|not|or|with)\b/,
        punctuation: /[{}[\];(),.:]/
    };
    Prism.languages.rpy = Prism.languages.renpy;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $50e3d013937d7b07$export$2e2bcd8739ae039.displayName = 'rescript';
$50e3d013937d7b07$export$2e2bcd8739ae039.aliases = [
    'res'
];
function $50e3d013937d7b07$export$2e2bcd8739ae039(Prism) {
    Prism.languages.rescript = {
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
            greedy: true
        },
        char: {
            pattern: /'(?:[^\r\n\\]|\\(?:.|\w+))'/,
            greedy: true
        },
        string: {
            pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
            greedy: true
        },
        'class-name': /\b[A-Z]\w*|@[a-z.]*|#[A-Za-z]\w*|#\d/,
        function: {
            pattern: /[a-zA-Z]\w*(?=\()|(\.)[a-z]\w*/,
            lookbehind: true
        },
        number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
        boolean: /\b(?:false|true)\b/,
        'attr-value': /[A-Za-z]\w*(?==)/,
        constant: {
            pattern: /(\btype\s+)[a-z]\w*/,
            lookbehind: true
        },
        tag: {
            pattern: /(<)[a-z]\w*|(?:<\/)[a-z]\w*/,
            lookbehind: true,
            inside: {
                operator: /<|>|\//
            }
        },
        keyword: /\b(?:and|as|assert|begin|bool|class|constraint|do|done|downto|else|end|exception|external|float|for|fun|function|if|in|include|inherit|initializer|int|lazy|let|method|module|mutable|new|nonrec|object|of|open|or|private|rec|string|switch|then|to|try|type|when|while|with)\b/,
        operator: /\.{3}|:[:=]?|\|>|->|=(?:==?|>)?|<=?|>=?|[|^?'#!~`]|[+\-*\/]\.?|\b(?:asr|land|lor|lsl|lsr|lxor|mod)\b/,
        punctuation: /[(){}[\],;.]/
    };
    Prism.languages.insertBefore('rescript', 'string', {
        'template-string': {
            pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
            greedy: true,
            inside: {
                'template-punctuation': {
                    pattern: /^`|`$/,
                    alias: 'string'
                },
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                    lookbehind: true,
                    inside: {
                        'interpolation-punctuation': {
                            pattern: /^\$\{|\}$/,
                            alias: 'tag'
                        },
                        rest: Prism.languages.rescript
                    }
                },
                string: /[\s\S]+/
            }
        }
    });
    Prism.languages.res = Prism.languages.rescript;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $c37f7ecb6b24967e$export$2e2bcd8739ae039.displayName = 'rest';
$c37f7ecb6b24967e$export$2e2bcd8739ae039.aliases = [];
function $c37f7ecb6b24967e$export$2e2bcd8739ae039(Prism) {
    Prism.languages.rest = {
        table: [
            {
                pattern: /(^[\t ]*)(?:\+[=-]+)+\+(?:\r?\n|\r)(?:\1[+|].+[+|](?:\r?\n|\r))+\1(?:\+[=-]+)+\+/m,
                lookbehind: true,
                inside: {
                    punctuation: /\||(?:\+[=-]+)+\+/
                }
            },
            {
                pattern: /(^[\t ]*)=+ [ =]*=(?:(?:\r?\n|\r)\1.+)+(?:\r?\n|\r)\1=+ [ =]*=(?=(?:\r?\n|\r){2}|\s*$)/m,
                lookbehind: true,
                inside: {
                    punctuation: /[=-]+/
                }
            }
        ],
        // Directive-like patterns
        'substitution-def': {
            pattern: /(^[\t ]*\.\. )\|(?:[^|\s](?:[^|]*[^|\s])?)\| [^:]+::/m,
            lookbehind: true,
            inside: {
                substitution: {
                    pattern: /^\|(?:[^|\s]|[^|\s][^|]*[^|\s])\|/,
                    alias: 'attr-value',
                    inside: {
                        punctuation: /^\||\|$/
                    }
                },
                directive: {
                    pattern: /( )(?! )[^:]+::/,
                    lookbehind: true,
                    alias: 'function',
                    inside: {
                        punctuation: /::$/
                    }
                }
            }
        },
        'link-target': [
            {
                pattern: /(^[\t ]*\.\. )\[[^\]]+\]/m,
                lookbehind: true,
                alias: 'string',
                inside: {
                    punctuation: /^\[|\]$/
                }
            },
            {
                pattern: /(^[\t ]*\.\. )_(?:`[^`]+`|(?:[^:\\]|\\.)+):/m,
                lookbehind: true,
                alias: 'string',
                inside: {
                    punctuation: /^_|:$/
                }
            }
        ],
        directive: {
            pattern: /(^[\t ]*\.\. )[^:]+::/m,
            lookbehind: true,
            alias: 'function',
            inside: {
                punctuation: /::$/
            }
        },
        comment: {
            // The two alternatives try to prevent highlighting of blank comments
            pattern: /(^[\t ]*\.\.)(?:(?: .+)?(?:(?:\r?\n|\r).+)+| .+)(?=(?:\r?\n|\r){2}|$)/m,
            lookbehind: true
        },
        title: [
            // Overlined and underlined
            {
                pattern: /^(([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2+)(?:\r?\n|\r).+(?:\r?\n|\r)\1$/m,
                inside: {
                    punctuation: /^[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+|[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+$/,
                    important: /.+/
                }
            },
            // Underlined only
            {
                pattern: /(^|(?:\r?\n|\r){2}).+(?:\r?\n|\r)([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2+(?=\r?\n|\r|$)/,
                lookbehind: true,
                inside: {
                    punctuation: /[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+$/,
                    important: /.+/
                }
            }
        ],
        hr: {
            pattern: /((?:\r?\n|\r){2})([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2{3,}(?=(?:\r?\n|\r){2})/,
            lookbehind: true,
            alias: 'punctuation'
        },
        field: {
            pattern: /(^[\t ]*):[^:\r\n]+:(?= )/m,
            lookbehind: true,
            alias: 'attr-name'
        },
        'command-line-option': {
            pattern: /(^[\t ]*)(?:[+-][a-z\d]|(?:--|\/)[a-z\d-]+)(?:[ =](?:[a-z][\w-]*|<[^<>]+>))?(?:, (?:[+-][a-z\d]|(?:--|\/)[a-z\d-]+)(?:[ =](?:[a-z][\w-]*|<[^<>]+>))?)*(?=(?:\r?\n|\r)? {2,}\S)/im,
            lookbehind: true,
            alias: 'symbol'
        },
        'literal-block': {
            pattern: /::(?:\r?\n|\r){2}([ \t]+)(?![ \t]).+(?:(?:\r?\n|\r)\1.+)*/,
            inside: {
                'literal-block-punctuation': {
                    pattern: /^::/,
                    alias: 'punctuation'
                }
            }
        },
        'quoted-literal-block': {
            pattern: /::(?:\r?\n|\r){2}([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]).*(?:(?:\r?\n|\r)\1.*)*/,
            inside: {
                'literal-block-punctuation': {
                    pattern: /^(?:::|([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\1*)/m,
                    alias: 'punctuation'
                }
            }
        },
        'list-bullet': {
            pattern: /(^[\t ]*)(?:[*+\-•‣⁃]|\(?(?:\d+|[a-z]|[ivxdclm]+)\)|(?:\d+|[a-z]|[ivxdclm]+)\.)(?= )/im,
            lookbehind: true,
            alias: 'punctuation'
        },
        'doctest-block': {
            pattern: /(^[\t ]*)>>> .+(?:(?:\r?\n|\r).+)*/m,
            lookbehind: true,
            inside: {
                punctuation: /^>>>/
            }
        },
        inline: [
            {
                pattern: /(^|[\s\-:\/'"<(\[{])(?::[^:]+:`.*?`|`.*?`:[^:]+:|(\*\*?|``?|\|)(?!\s)(?:(?!\2).)*\S\2(?=[\s\-.,:;!?\\\/'")\]}]|$))/m,
                lookbehind: true,
                inside: {
                    bold: {
                        pattern: /(^\*\*).+(?=\*\*$)/,
                        lookbehind: true
                    },
                    italic: {
                        pattern: /(^\*).+(?=\*$)/,
                        lookbehind: true
                    },
                    'inline-literal': {
                        pattern: /(^``).+(?=``$)/,
                        lookbehind: true,
                        alias: 'symbol'
                    },
                    role: {
                        pattern: /^:[^:]+:|:[^:]+:$/,
                        alias: 'function',
                        inside: {
                            punctuation: /^:|:$/
                        }
                    },
                    'interpreted-text': {
                        pattern: /(^`).+(?=`$)/,
                        lookbehind: true,
                        alias: 'attr-value'
                    },
                    substitution: {
                        pattern: /(^\|).+(?=\|$)/,
                        lookbehind: true,
                        alias: 'attr-value'
                    },
                    punctuation: /\*\*?|``?|\|/
                }
            }
        ],
        link: [
            {
                pattern: /\[[^\[\]]+\]_(?=[\s\-.,:;!?\\\/'")\]}]|$)/,
                alias: 'string',
                inside: {
                    punctuation: /^\[|\]_$/
                }
            },
            {
                pattern: /(?:\b[a-z\d]+(?:[_.:+][a-z\d]+)*_?_|`[^`]+`_?_|_`[^`]+`)(?=[\s\-.,:;!?\\\/'")\]}]|$)/i,
                alias: 'string',
                inside: {
                    punctuation: /^_?`|`$|`?_?_$/
                }
            }
        ],
        // Line block start,
        // quote attribution,
        // explicit markup start,
        // and anonymous hyperlink target shortcut (__)
        punctuation: {
            pattern: /(^[\t ]*)(?:\|(?= |$)|(?:---?|—|\.\.|__)(?= )|\.\.$)/m,
            lookbehind: true
        }
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $9e1e815b43dfcf12$export$2e2bcd8739ae039.displayName = 'rip';
$9e1e815b43dfcf12$export$2e2bcd8739ae039.aliases = [];
function $9e1e815b43dfcf12$export$2e2bcd8739ae039(Prism) {
    Prism.languages.rip = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        char: {
            pattern: /\B`[^\s`'",.:;#\/\\()<>\[\]{}]\b/,
            greedy: true
        },
        string: {
            pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        regex: {
            pattern: /(^|[^/])\/(?!\/)(?:\[[^\n\r\]]*\]|\\.|[^/\\\r\n\[])+\/(?=\s*(?:$|[\r\n,.;})]))/,
            lookbehind: true,
            greedy: true
        },
        keyword: /(?:=>|->)|\b(?:case|catch|class|else|exit|finally|if|raise|return|switch|try)\b/,
        builtin: /@|\bSystem\b/,
        boolean: /\b(?:false|true)\b/,
        date: /\b\d{4}-\d{2}-\d{2}\b/,
        time: /\b\d{2}:\d{2}:\d{2}\b/,
        datetime: /\b\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\b/,
        symbol: /:[^\d\s`'",.:;#\/\\()<>\[\]{}][^\s`'",.:;#\/\\()<>\[\]{}]*/,
        number: /[+-]?\b(?:\d+\.\d+|\d+)\b/,
        punctuation: /(?:\.{2,3})|[`,.:;=\/\\()<>\[\]{}]/,
        reference: /[^\d\s`'",.:;#\/\\()<>\[\]{}][^\s`'",.:;#\/\\()<>\[\]{}]*/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $e01299bf75eda32d$export$2e2bcd8739ae039.displayName = 'roboconf';
$e01299bf75eda32d$export$2e2bcd8739ae039.aliases = [];
function $e01299bf75eda32d$export$2e2bcd8739ae039(Prism) {
    Prism.languages.roboconf = {
        comment: /#.*/,
        keyword: {
            pattern: /(^|\s)(?:(?:external|import)\b|(?:facet|instance of)(?=[ \t]+[\w-]+[ \t]*\{))/,
            lookbehind: true
        },
        component: {
            pattern: /[\w-]+(?=[ \t]*\{)/,
            alias: 'variable'
        },
        property: /[\w.-]+(?=[ \t]*:)/,
        value: {
            pattern: /(=[ \t]*(?![ \t]))[^,;]+/,
            lookbehind: true,
            alias: 'attr-value'
        },
        optional: {
            pattern: /\(optional\)/,
            alias: 'builtin'
        },
        wildcard: {
            pattern: /(\.)\*/,
            lookbehind: true,
            alias: 'operator'
        },
        punctuation: /[{},.;:=]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $37dde9971f145ea3$export$2e2bcd8739ae039.displayName = 'robotframework';
$37dde9971f145ea3$export$2e2bcd8739ae039.aliases = [
    'robot'
];
function $37dde9971f145ea3$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var comment = {
            pattern: /(^[ \t]*| {2}|\t)#.*/m,
            lookbehind: true,
            greedy: true
        };
        var variable = {
            pattern: /((?:^|[^\\])(?:\\{2})*)[$@&%]\{(?:[^{}\r\n]|\{[^{}\r\n]*\})*\}/,
            lookbehind: true,
            inside: {
                punctuation: /^[$@&%]\{|\}$/
            }
        };
        function createSection(name, inside) {
            var extendecInside = {};
            extendecInside['section-header'] = {
                pattern: /^ ?\*{3}.+?\*{3}/,
                alias: 'keyword'
            };
            // copy inside tokens
            for(var token in inside)extendecInside[token] = inside[token];
            extendecInside['tag'] = {
                pattern: /([\r\n](?: {2}|\t)[ \t]*)\[[-\w]+\]/,
                lookbehind: true,
                inside: {
                    punctuation: /\[|\]/
                }
            };
            extendecInside['variable'] = variable;
            extendecInside['comment'] = comment;
            return {
                pattern: RegExp(/^ ?\*{3}[ \t]*<name>[ \t]*\*{3}(?:.|[\r\n](?!\*{3}))*/.source.replace(/<name>/g, function() {
                    return name;
                }), 'im'),
                alias: 'section',
                inside: extendecInside
            };
        }
        var docTag = {
            pattern: /(\[Documentation\](?: {2}|\t)[ \t]*)(?![ \t]|#)(?:.|(?:\r\n?|\n)[ \t]*\.{3})+/,
            lookbehind: true,
            alias: 'string'
        };
        var testNameLike = {
            pattern: /([\r\n] ?)(?!#)(?:\S(?:[ \t]\S)*)+/,
            lookbehind: true,
            alias: 'function',
            inside: {
                variable: variable
            }
        };
        var testPropertyLike = {
            pattern: /([\r\n](?: {2}|\t)[ \t]*)(?!\[|\.{3}|#)(?:\S(?:[ \t]\S)*)+/,
            lookbehind: true,
            inside: {
                variable: variable
            }
        };
        Prism.languages['robotframework'] = {
            settings: createSection('Settings', {
                documentation: {
                    pattern: /([\r\n] ?Documentation(?: {2}|\t)[ \t]*)(?![ \t]|#)(?:.|(?:\r\n?|\n)[ \t]*\.{3})+/,
                    lookbehind: true,
                    alias: 'string'
                },
                property: {
                    pattern: /([\r\n] ?)(?!\.{3}|#)(?:\S(?:[ \t]\S)*)+/,
                    lookbehind: true
                }
            }),
            variables: createSection('Variables'),
            'test-cases': createSection('Test Cases', {
                'test-name': testNameLike,
                documentation: docTag,
                property: testPropertyLike
            }),
            keywords: createSection('Keywords', {
                'keyword-name': testNameLike,
                documentation: docTag,
                property: testPropertyLike
            }),
            tasks: createSection('Tasks', {
                'task-name': testNameLike,
                documentation: docTag,
                property: testPropertyLike
            }),
            comment: comment
        };
        Prism.languages.robot = Prism.languages['robotframework'];
    })(Prism);
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $390e344e43dfbcde$export$2e2bcd8739ae039.displayName = 'sas';
$390e344e43dfbcde$export$2e2bcd8739ae039.aliases = [];
function $390e344e43dfbcde$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var stringPattern = /(?:"(?:""|[^"])*"(?!")|'(?:''|[^'])*'(?!'))/.source;
        var number = /\b(?:\d[\da-f]*x|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i;
        var numericConstant = {
            pattern: RegExp(stringPattern + '[bx]'),
            alias: 'number'
        };
        var macroVariable = {
            pattern: /&[a-z_]\w*/i
        };
        var macroKeyword = {
            pattern: /((?:^|\s|=|\())%(?:ABORT|BY|CMS|COPY|DISPLAY|DO|ELSE|END|EVAL|GLOBAL|GO|GOTO|IF|INC|INCLUDE|INDEX|INPUT|KTRIM|LENGTH|LET|LIST|LOCAL|PUT|QKTRIM|QSCAN|QSUBSTR|QSYSFUNC|QUPCASE|RETURN|RUN|SCAN|SUBSTR|SUPERQ|SYMDEL|SYMEXIST|SYMGLOBL|SYMLOCAL|SYSCALL|SYSEVALF|SYSEXEC|SYSFUNC|SYSGET|SYSRPUT|THEN|TO|TSO|UNQUOTE|UNTIL|UPCASE|WHILE|WINDOW)\b/i,
            lookbehind: true,
            alias: 'keyword'
        };
        var step = {
            pattern: /(^|\s)(?:proc\s+\w+|data(?!=)|quit|run)\b/i,
            alias: 'keyword',
            lookbehind: true
        };
        var comment = [
            /\/\*[\s\S]*?\*\//,
            {
                pattern: /(^[ \t]*|;\s*)\*[^;]*;/m,
                lookbehind: true
            }
        ];
        var string = {
            pattern: RegExp(stringPattern),
            greedy: true
        };
        var punctuation = /[$%@.(){}\[\];,\\]/;
        var func = {
            pattern: /%?\b\w+(?=\()/,
            alias: 'keyword'
        };
        var args = {
            function: func,
            'arg-value': {
                pattern: /(=\s*)[A-Z\.]+/i,
                lookbehind: true
            },
            operator: /=/,
            'macro-variable': macroVariable,
            arg: {
                pattern: /[A-Z]+/i,
                alias: 'keyword'
            },
            number: number,
            'numeric-constant': numericConstant,
            punctuation: punctuation,
            string: string
        };
        var format = {
            pattern: /\b(?:format|put)\b=?[\w'$.]+/i,
            inside: {
                keyword: /^(?:format|put)(?==)/i,
                equals: /=/,
                format: {
                    pattern: /(?:\w|\$\d)+\.\d?/,
                    alias: 'number'
                }
            }
        };
        var altformat = {
            pattern: /\b(?:format|put)\s+[\w']+(?:\s+[$.\w]+)+(?=;)/i,
            inside: {
                keyword: /^(?:format|put)/i,
                format: {
                    pattern: /[\w$]+\.\d?/,
                    alias: 'number'
                }
            }
        };
        var globalStatements = {
            pattern: /((?:^|\s)=?)(?:catname|checkpoint execute_always|dm|endsas|filename|footnote|%include|libname|%list|lock|missing|options|page|resetline|%run|sasfile|skip|sysecho|title\d?)\b/i,
            lookbehind: true,
            alias: 'keyword'
        };
        var submitStatement = {
            pattern: /(^|\s)(?:submit(?:\s+(?:load|norun|parseonly))?|endsubmit)\b/i,
            lookbehind: true,
            alias: 'keyword'
        };
        var actionSets = /aStore|accessControl|aggregation|audio|autotune|bayesianNetClassifier|bioMedImage|boolRule|builtins|cardinality|cdm|clustering|conditionalRandomFields|configuration|copula|countreg|dataDiscovery|dataPreprocess|dataSciencePilot|dataStep|decisionTree|deduplication|deepLearn|deepNeural|deepRnn|ds2|ecm|entityRes|espCluster|explainModel|factmac|fastKnn|fcmpact|fedSql|freqTab|gVarCluster|gam|gleam|graphSemiSupLearn|hiddenMarkovModel|hyperGroup|ica|image|iml|kernalPca|langModel|ldaTopic|loadStreams|mbc|mixed|mlTools|modelPublishing|network|neuralNet|nmf|nonParametricBayes|nonlinear|optNetwork|optimization|panel|pca|percentile|phreg|pls|qkb|qlim|quantreg|recommend|regression|reinforcementLearn|robustPca|ruleMining|sampling|sandwich|sccasl|search(?:Analytics)?|sentimentAnalysis|sequence|session(?:Prop)?|severity|simSystem|simple|smartData|sparkEmbeddedProcess|sparseML|spatialreg|spc|stabilityMonitoring|svDataDescription|svm|table|text(?:Filters|Frequency|Mining|Parse|Rule(?:Develop|Score)|Topic|Util)|timeData|transpose|tsInfo|tsReconcile|uniTimeSeries|varReduce/.source;
        var casActions = {
            pattern: RegExp(/(^|\s)(?:action\s+)?(?:<act>)\.[a-z]+\b[^;]+/.source.replace(/<act>/g, function() {
                return actionSets;
            }), 'i'),
            lookbehind: true,
            inside: {
                keyword: RegExp(/(?:<act>)\.[a-z]+\b/.source.replace(/<act>/g, function() {
                    return actionSets;
                }), 'i'),
                action: {
                    pattern: /(?:action)/i,
                    alias: 'keyword'
                },
                comment: comment,
                function: func,
                'arg-value': args['arg-value'],
                operator: args.operator,
                argument: args.arg,
                number: number,
                'numeric-constant': numericConstant,
                punctuation: punctuation,
                string: string
            }
        };
        var keywords = {
            pattern: /((?:^|\s)=?)(?:after|analysis|and|array|barchart|barwidth|begingraph|by|call|cas|cbarline|cfill|class(?:lev)?|close|column|computed?|contains|continue|data(?==)|define|delete|describe|document|do\s+over|do|dol|drop|dul|else|end(?:comp|source)?|entryTitle|eval(?:uate)?|exec(?:ute)?|exit|file(?:name)?|fill(?:attrs)?|flist|fnc|function(?:list)?|global|goto|group(?:by)?|headline|headskip|histogram|if|infile|keep|keylabel|keyword|label|layout|leave|legendlabel|length|libname|loadactionset|merge|midpoints|_?null_|name|noobs|nowd|ods|options|or|otherwise|out(?:put)?|over(?:lay)?|plot|print|put|raise|ranexp|rannor|rbreak|retain|return|select|session|sessref|set|source|statgraph|sum|summarize|table|temp|terminate|then\s+do|then|title\d?|to|var|when|where|xaxisopts|y2axisopts|yaxisopts)\b/i,
            lookbehind: true
        };
        Prism.languages.sas = {
            datalines: {
                pattern: /^([ \t]*)(?:cards|(?:data)?lines);[\s\S]+?^[ \t]*;/im,
                lookbehind: true,
                alias: 'string',
                inside: {
                    keyword: {
                        pattern: /^(?:cards|(?:data)?lines)/i
                    },
                    punctuation: /;/
                }
            },
            'proc-sql': {
                pattern: /(^proc\s+(?:fed)?sql(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
                lookbehind: true,
                inside: {
                    sql: {
                        pattern: RegExp(/^[ \t]*(?:select|alter\s+table|(?:create|describe|drop)\s+(?:index|table(?:\s+constraints)?|view)|create\s+unique\s+index|insert\s+into|update)(?:<str>|[^;"'])+;/.source.replace(/<str>/g, function() {
                            return stringPattern;
                        }), 'im'),
                        alias: 'language-sql',
                        inside: Prism.languages.sql
                    },
                    'global-statements': globalStatements,
                    'sql-statements': {
                        pattern: /(^|\s)(?:disconnect\s+from|begin|commit|exec(?:ute)?|reset|rollback|validate)\b/i,
                        lookbehind: true,
                        alias: 'keyword'
                    },
                    number: number,
                    'numeric-constant': numericConstant,
                    punctuation: punctuation,
                    string: string
                }
            },
            'proc-groovy': {
                pattern: /(^proc\s+groovy(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
                lookbehind: true,
                inside: {
                    comment: comment,
                    groovy: {
                        pattern: RegExp(/(^[ \t]*submit(?:\s+(?:load|norun|parseonly))?)(?:<str>|[^"'])+?(?=endsubmit;)/.source.replace(/<str>/g, function() {
                            return stringPattern;
                        }), 'im'),
                        lookbehind: true,
                        alias: 'language-groovy',
                        inside: Prism.languages.groovy
                    },
                    keyword: keywords,
                    'submit-statement': submitStatement,
                    'global-statements': globalStatements,
                    number: number,
                    'numeric-constant': numericConstant,
                    punctuation: punctuation,
                    string: string
                }
            },
            'proc-lua': {
                pattern: /(^proc\s+lua(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
                lookbehind: true,
                inside: {
                    comment: comment,
                    lua: {
                        pattern: RegExp(/(^[ \t]*submit(?:\s+(?:load|norun|parseonly))?)(?:<str>|[^"'])+?(?=endsubmit;)/.source.replace(/<str>/g, function() {
                            return stringPattern;
                        }), 'im'),
                        lookbehind: true,
                        alias: 'language-lua',
                        inside: Prism.languages.lua
                    },
                    keyword: keywords,
                    'submit-statement': submitStatement,
                    'global-statements': globalStatements,
                    number: number,
                    'numeric-constant': numericConstant,
                    punctuation: punctuation,
                    string: string
                }
            },
            'proc-cas': {
                pattern: /(^proc\s+cas(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|quit|data);|(?![\s\S]))/im,
                lookbehind: true,
                inside: {
                    comment: comment,
                    'statement-var': {
                        pattern: /((?:^|\s)=?)saveresult\s[^;]+/im,
                        lookbehind: true,
                        inside: {
                            statement: {
                                pattern: /^saveresult\s+\S+/i,
                                inside: {
                                    keyword: /^(?:saveresult)/i
                                }
                            },
                            rest: args
                        }
                    },
                    'cas-actions': casActions,
                    statement: {
                        pattern: /((?:^|\s)=?)(?:default|(?:un)?set|on|output|upload)[^;]+/im,
                        lookbehind: true,
                        inside: args
                    },
                    step: step,
                    keyword: keywords,
                    function: func,
                    format: format,
                    altformat: altformat,
                    'global-statements': globalStatements,
                    number: number,
                    'numeric-constant': numericConstant,
                    punctuation: punctuation,
                    string: string
                }
            },
            'proc-args': {
                pattern: RegExp(/(^proc\s+\w+\s+)(?!\s)(?:[^;"']|<str>)+;/.source.replace(/<str>/g, function() {
                    return stringPattern;
                }), 'im'),
                lookbehind: true,
                inside: args
            },
            /*Special keywords within macros*/ 'macro-keyword': macroKeyword,
            'macro-variable': macroVariable,
            'macro-string-functions': {
                pattern: /((?:^|\s|=))%(?:BQUOTE|NRBQUOTE|NRQUOTE|NRSTR|QUOTE|STR)\(.*?(?:[^%]\))/i,
                lookbehind: true,
                inside: {
                    function: {
                        pattern: /%(?:BQUOTE|NRBQUOTE|NRQUOTE|NRSTR|QUOTE|STR)/i,
                        alias: 'keyword'
                    },
                    'macro-keyword': macroKeyword,
                    'macro-variable': macroVariable,
                    'escaped-char': {
                        pattern: /%['"()<>=¬^~;,#]/
                    },
                    punctuation: punctuation
                }
            },
            'macro-declaration': {
                pattern: /^%macro[^;]+(?=;)/im,
                inside: {
                    keyword: /%macro/i
                }
            },
            'macro-end': {
                pattern: /^%mend[^;]+(?=;)/im,
                inside: {
                    keyword: /%mend/i
                }
            },
            /*%_zscore(headcir, _lhc, _mhc, _shc, headcz, headcpct, _Fheadcz); */ macro: {
                pattern: /%_\w+(?=\()/,
                alias: 'keyword'
            },
            input: {
                pattern: /\binput\s[-\w\s/*.$&]+;/i,
                inside: {
                    input: {
                        alias: 'keyword',
                        pattern: /^input/i
                    },
                    comment: comment,
                    number: number,
                    'numeric-constant': numericConstant
                }
            },
            'options-args': {
                pattern: /(^options)[-'"|/\\<>*+=:()\w\s]*(?=;)/im,
                lookbehind: true,
                inside: args
            },
            'cas-actions': casActions,
            comment: comment,
            function: func,
            format: format,
            altformat: altformat,
            'numeric-constant': numericConstant,
            datetime: {
                // '1jan2013'd, '9:25:19pm't, '18jan2003:9:27:05am'dt
                pattern: RegExp(stringPattern + '(?:dt?|t)'),
                alias: 'number'
            },
            string: string,
            step: step,
            keyword: keywords,
            // In SAS Studio syntax highlighting, these operators are styled like keywords
            'operator-keyword': {
                pattern: /\b(?:eq|ge|gt|in|le|lt|ne|not)\b/i,
                alias: 'operator'
            },
            // Decimal (1.2e23), hexadecimal (0c1x)
            number: number,
            operator: /\*\*?|\|\|?|!!?|¦¦?|<[>=]?|>[<=]?|[-+\/=&]|[~¬^]=?/,
            punctuation: punctuation
        };
    })(Prism);
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$730f9a4b12501d43$export$2e2bcd8739ae039.displayName = 'shell-session';
$730f9a4b12501d43$export$2e2bcd8739ae039.aliases = [
    'sh-session',
    'shellsession'
];
function $730f9a4b12501d43$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $8bc35bfd2be6822a$export$2e2bcd8739ae039));
    (function(Prism) {
        // CAREFUL!
        // The following patterns are concatenated, so the group referenced by a back reference is non-obvious!
        var strings = [
            // normal string
            /"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/.source,
            /'[^']*'/.source,
            /\$'(?:[^'\\]|\\[\s\S])*'/.source,
            // here doc
            // 2 capturing groups
            /<<-?\s*(["']?)(\w+)\1\s[\s\S]*?[\r\n]\2/.source
        ].join('|');
        Prism.languages['shell-session'] = {
            command: {
                pattern: RegExp(// user info
                /^/.source + '(?:' + // <user> ":" ( <path> )?
                (/[^\s@:$#%*!/\\]+@[^\r\n@:$#%*!/\\]+(?::[^\0-\x1F$#%*?"<>:;|]+)?/.source + '|' + // <path>
                // Since the path pattern is quite general, we will require it to start with a special character to
                // prevent false positives.
                /[/~.][^\0-\x1F$#%*?"<>@:;|]*/.source) + ')?' + // shell symbol
                /[$#%](?=\s)/.source + // bash command
                /(?:[^\\\r\n \t'"<$]|[ \t](?:(?!#)|#.*$)|\\(?:[^\r]|\r\n?)|\$(?!')|<(?!<)|<<str>>)+/.source.replace(/<<str>>/g, function() {
                    return strings;
                }), 'm'),
                greedy: true,
                inside: {
                    info: {
                        // foo@bar:~/files$ exit
                        // foo@bar$ exit
                        // ~/files$ exit
                        pattern: /^[^#$%]+/,
                        alias: 'punctuation',
                        inside: {
                            user: /^[^\s@:$#%*!/\\]+@[^\r\n@:$#%*!/\\]+/,
                            punctuation: /:/,
                            path: /[\s\S]+/
                        }
                    },
                    bash: {
                        pattern: /(^[$#%]\s*)\S[\s\S]*/,
                        lookbehind: true,
                        alias: 'language-bash',
                        inside: Prism.languages.bash
                    },
                    'shell-symbol': {
                        pattern: /^[$#%]/,
                        alias: 'important'
                    }
                }
            },
            output: /.(?:.*(?:[\r\n]|.$))*/
        };
        Prism.languages['sh-session'] = Prism.languages['shellsession'] = Prism.languages['shell-session'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $0ef3d1ceb8394e5c$export$2e2bcd8739ae039.displayName = 'smali';
$0ef3d1ceb8394e5c$export$2e2bcd8739ae039.aliases = [];
function $0ef3d1ceb8394e5c$export$2e2bcd8739ae039(Prism) {
    // Test files for the parser itself:
    // https://github.com/JesusFreke/smali/tree/master/smali/src/test/resources/LexerTest
    Prism.languages.smali = {
        comment: /#.*/,
        string: {
            pattern: /"(?:[^\r\n\\"]|\\.)*"|'(?:[^\r\n\\']|\\(?:.|u[\da-fA-F]{4}))'/,
            greedy: true
        },
        'class-name': {
            pattern: /(^|[^L])L(?:(?:\w+|`[^`\r\n]*`)\/)*(?:[\w$]+|`[^`\r\n]*`)(?=\s*;)/,
            lookbehind: true,
            inside: {
                'class-name': {
                    pattern: /(^L|\/)(?:[\w$]+|`[^`\r\n]*`)$/,
                    lookbehind: true
                },
                namespace: {
                    pattern: /^(L)(?:(?:\w+|`[^`\r\n]*`)\/)+/,
                    lookbehind: true,
                    inside: {
                        punctuation: /\//
                    }
                },
                builtin: /^L/
            }
        },
        builtin: [
            {
                // Reference: https://github.com/JesusFreke/smali/wiki/TypesMethodsAndFields#types
                pattern: /([();\[])[BCDFIJSVZ]+/,
                lookbehind: true
            },
            {
                // e.g. .field mWifiOnUid:I
                pattern: /([\w$>]:)[BCDFIJSVZ]/,
                lookbehind: true
            }
        ],
        keyword: [
            {
                pattern: /(\.end\s+)[\w-]+/,
                lookbehind: true
            },
            {
                pattern: /(^|[^\w.-])\.(?!\d)[\w-]+/,
                lookbehind: true
            },
            {
                pattern: /(^|[^\w.-])(?:abstract|annotation|bridge|constructor|enum|final|interface|private|protected|public|runtime|static|synthetic|system|transient)(?![\w.-])/,
                lookbehind: true
            }
        ],
        function: {
            pattern: /(^|[^\w.-])(?:\w+|<[\w$-]+>)(?=\()/,
            lookbehind: true
        },
        field: {
            pattern: /[\w$]+(?=:)/,
            alias: 'variable'
        },
        register: {
            pattern: /(^|[^\w.-])[vp]\d(?![\w.-])/,
            lookbehind: true,
            alias: 'variable'
        },
        boolean: {
            pattern: /(^|[^\w.-])(?:false|true)(?![\w.-])/,
            lookbehind: true
        },
        number: {
            pattern: /(^|[^/\w.-])-?(?:NAN|INFINITY|0x(?:[\dA-F]+(?:\.[\dA-F]*)?|\.[\dA-F]+)(?:p[+-]?[\dA-F]+)?|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?)[dflst]?(?![\w.-])/i,
            lookbehind: true
        },
        label: {
            pattern: /(:)\w+/,
            lookbehind: true,
            alias: 'property'
        },
        operator: /->|\.\.|[\[=]/,
        punctuation: /[{}(),;:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $feeef9c3da6c04de$export$2e2bcd8739ae039.displayName = 'smalltalk';
$feeef9c3da6c04de$export$2e2bcd8739ae039.aliases = [];
function $feeef9c3da6c04de$export$2e2bcd8739ae039(Prism) {
    Prism.languages.smalltalk = {
        comment: {
            pattern: /"(?:""|[^"])*"/,
            greedy: true
        },
        char: {
            pattern: /\$./,
            greedy: true
        },
        string: {
            pattern: /'(?:''|[^'])*'/,
            greedy: true
        },
        symbol: /#[\da-z]+|#(?:-|([+\/\\*~<>=@%|&?!])\1?)|#(?=\()/i,
        'block-arguments': {
            pattern: /(\[\s*):[^\[|]*\|/,
            lookbehind: true,
            inside: {
                variable: /:[\da-z]+/i,
                punctuation: /\|/
            }
        },
        'temporary-variables': {
            pattern: /\|[^|]+\|/,
            inside: {
                variable: /[\da-z]+/i,
                punctuation: /\|/
            }
        },
        keyword: /\b(?:new|nil|self|super)\b/,
        boolean: /\b(?:false|true)\b/,
        number: [
            /\d+r-?[\dA-Z]+(?:\.[\dA-Z]+)?(?:e-?\d+)?/,
            /\b\d+(?:\.\d+)?(?:e-?\d+)?/
        ],
        operator: /[<=]=?|:=|~[~=]|\/\/?|\\\\|>[>=]?|[!^+\-*&|,@]/,
        punctuation: /[.;:?\[\](){}]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$a0deafd0233b5617$export$2e2bcd8739ae039.displayName = 'smarty';
$a0deafd0233b5617$export$2e2bcd8739ae039.aliases = [];
function $a0deafd0233b5617$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.smarty = {
            comment: {
                pattern: /^\{\*[\s\S]*?\*\}/,
                greedy: true
            },
            'embedded-php': {
                pattern: /^\{php\}[\s\S]*?\{\/php\}/,
                greedy: true,
                inside: {
                    smarty: {
                        pattern: /^\{php\}|\{\/php\}$/,
                        inside: null // see below
                    },
                    php: {
                        pattern: /[\s\S]+/,
                        alias: 'language-php',
                        inside: Prism.languages.php
                    }
                }
            },
            string: [
                {
                    pattern: /"(?:\\.|[^"\\\r\n])*"/,
                    greedy: true,
                    inside: {
                        interpolation: {
                            pattern: /\{[^{}]*\}|`[^`]*`/,
                            inside: {
                                'interpolation-punctuation': {
                                    pattern: /^[{`]|[`}]$/,
                                    alias: 'punctuation'
                                },
                                expression: {
                                    pattern: /[\s\S]+/,
                                    inside: null // see below
                                }
                            }
                        },
                        variable: /\$\w+/
                    }
                },
                {
                    pattern: /'(?:\\.|[^'\\\r\n])*'/,
                    greedy: true
                }
            ],
            keyword: {
                pattern: /(^\{\/?)[a-z_]\w*\b(?!\()/i,
                lookbehind: true,
                greedy: true
            },
            delimiter: {
                pattern: /^\{\/?|\}$/,
                greedy: true,
                alias: 'punctuation'
            },
            number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
            variable: [
                /\$(?!\d)\w+/,
                /#(?!\d)\w+#/,
                {
                    pattern: /(\.|->|\w\s*=)(?!\d)\w+\b(?!\()/,
                    lookbehind: true
                },
                {
                    pattern: /(\[)(?!\d)\w+(?=\])/,
                    lookbehind: true
                }
            ],
            function: {
                pattern: /(\|\s*)@?[a-z_]\w*|\b[a-z_]\w*(?=\()/i,
                lookbehind: true
            },
            'attr-name': /\b[a-z_]\w*(?=\s*=)/i,
            boolean: /\b(?:false|no|off|on|true|yes)\b/,
            punctuation: /[\[\](){}.,:`]|->/,
            operator: [
                /[+\-*\/%]|==?=?|[!<>]=?|&&|\|\|?/,
                /\bis\s+(?:not\s+)?(?:div|even|odd)(?:\s+by)?\b/,
                /\b(?:and|eq|gt?e|gt|lt?e|lt|mod|neq?|not|or)\b/
            ]
        };
        Prism.languages.smarty['embedded-php'].inside.smarty.inside = Prism.languages.smarty;
        Prism.languages.smarty.string[0].inside.interpolation.inside.expression.inside = Prism.languages.smarty;
        var string = /"(?:\\.|[^"\\\r\n])*"|'(?:\\.|[^'\\\r\n])*'/;
        var smartyPattern = RegExp(// comments
        /\{\*[\s\S]*?\*\}/.source + '|' + // php tags
        /\{php\}[\s\S]*?\{\/php\}/.source + '|' + // smarty blocks
        /\{(?:[^{}"']|<str>|\{(?:[^{}"']|<str>|\{(?:[^{}"']|<str>)*\})*\})*\}/.source.replace(/<str>/g, function() {
            return string.source;
        }), 'g');
        // Tokenize all inline Smarty expressions
        Prism.hooks.add('before-tokenize', function(env) {
            var smartyLiteralStart = '{literal}';
            var smartyLiteralEnd = '{/literal}';
            var smartyLiteralMode = false;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'smarty', smartyPattern, function(match) {
                // Smarty tags inside {literal} block are ignored
                if (match === smartyLiteralEnd) smartyLiteralMode = false;
                if (!smartyLiteralMode) {
                    if (match === smartyLiteralStart) smartyLiteralMode = true;
                    return true;
                }
                return false;
            });
        });
        // Re-insert the tokens after tokenizing
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'smarty');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $1aa991af509c7894$export$2e2bcd8739ae039.displayName = 'sml';
$1aa991af509c7894$export$2e2bcd8739ae039.aliases = [
    'smlnj'
];
function $1aa991af509c7894$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var keywords = /\b(?:abstype|and|andalso|as|case|datatype|do|else|end|eqtype|exception|fn|fun|functor|handle|if|in|include|infix|infixr|let|local|nonfix|of|op|open|orelse|raise|rec|sharing|sig|signature|struct|structure|then|type|val|where|while|with|withtype)\b/i;
        Prism.languages.sml = {
            // allow one level of nesting
            comment: /\(\*(?:[^*(]|\*(?!\))|\((?!\*)|\(\*(?:[^*(]|\*(?!\))|\((?!\*))*\*\))*\*\)/,
            string: {
                pattern: /#?"(?:[^"\\]|\\.)*"/,
                greedy: true
            },
            'class-name': [
                {
                    // This is only an approximation since the real grammar is context-free
                    //
                    // Why the main loop so complex?
                    // The main loop is approximately the same as /(?:\s*(?:[*,]|->)\s*<TERMINAL>)*/ which is, obviously, a lot
                    // simpler. The difference is that if a comma is the last iteration of the loop, then the terminal must be
                    // followed by a long identifier.
                    pattern: RegExp(/((?:^|[^:]):\s*)<TERMINAL>(?:\s*(?:(?:\*|->)\s*<TERMINAL>|,\s*<TERMINAL>(?:(?=<NOT-LAST>)|(?!<NOT-LAST>)\s+<LONG-ID>)))*/.source.replace(/<NOT-LAST>/g, function() {
                        return /\s*(?:[*,]|->)/.source;
                    }).replace(/<TERMINAL>/g, function() {
                        return /(?:'[\w']*|<LONG-ID>|\((?:[^()]|\([^()]*\))*\)|\{(?:[^{}]|\{[^{}]*\})*\})(?:\s+<LONG-ID>)*/.source;
                    }).replace(/<LONG-ID>/g, function() {
                        return /(?!<KEYWORD>)[a-z\d_][\w'.]*/.source;
                    }).replace(/<KEYWORD>/g, function() {
                        return keywords.source;
                    }), 'i'),
                    lookbehind: true,
                    greedy: true,
                    inside: null // see below
                },
                {
                    pattern: /((?:^|[^\w'])(?:datatype|exception|functor|signature|structure|type)\s+)[a-z_][\w'.]*/i,
                    lookbehind: true
                }
            ],
            function: {
                pattern: /((?:^|[^\w'])fun\s+)[a-z_][\w'.]*/i,
                lookbehind: true
            },
            keyword: keywords,
            variable: {
                pattern: /(^|[^\w'])'[\w']*/,
                lookbehind: true
            },
            number: /~?\b(?:\d+(?:\.\d+)?(?:e~?\d+)?|0x[\da-f]+)\b/i,
            word: {
                pattern: /\b0w(?:\d+|x[\da-f]+)\b/i,
                alias: 'constant'
            },
            boolean: /\b(?:false|true)\b/i,
            operator: /\.\.\.|:[>=:]|=>?|->|[<>]=?|[!+\-*/^#|@~]/,
            punctuation: /[(){}\[\].:,;]/
        };
        Prism.languages.sml['class-name'][0].inside = Prism.languages.sml;
        Prism.languages.smlnj = Prism.languages.sml;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$3a1367f4db4eb9c1$export$2e2bcd8739ae039.displayName = 'solidity';
$3a1367f4db4eb9c1$export$2e2bcd8739ae039.aliases = [
    'sol'
];
function $3a1367f4db4eb9c1$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.solidity = Prism.languages.extend('clike', {
        'class-name': {
            pattern: /(\b(?:contract|enum|interface|library|new|struct|using)\s+)(?!\d)[\w$]+/,
            lookbehind: true
        },
        keyword: /\b(?:_|anonymous|as|assembly|assert|break|calldata|case|constant|constructor|continue|contract|default|delete|do|else|emit|enum|event|external|for|from|function|if|import|indexed|inherited|interface|internal|is|let|library|mapping|memory|modifier|new|payable|pragma|private|public|pure|require|returns?|revert|selfdestruct|solidity|storage|struct|suicide|switch|this|throw|using|var|view|while)\b/,
        operator: /=>|->|:=|=:|\*\*|\+\+|--|\|\||&&|<<=?|>>=?|[-+*/%^&|<>!=]=?|[~?]/
    });
    Prism.languages.insertBefore('solidity', 'keyword', {
        builtin: /\b(?:address|bool|byte|u?int(?:8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?|string|bytes(?:[1-9]|[12]\d|3[0-2])?)\b/
    });
    Prism.languages.insertBefore('solidity', 'number', {
        version: {
            pattern: /([<>]=?|\^)\d+\.\d+\.\d+\b/,
            lookbehind: true,
            alias: 'number'
        }
    });
    Prism.languages.sol = Prism.languages.solidity;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $3f3dc76a1a6f0313$export$2e2bcd8739ae039.displayName = 'solution-file';
$3f3dc76a1a6f0313$export$2e2bcd8739ae039.aliases = [
    'sln'
];
function $3f3dc76a1a6f0313$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var guid = {
            // https://en.wikipedia.org/wiki/Universally_unique_identifier#Format
            pattern: /\{[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}\}/i,
            alias: 'constant',
            inside: {
                punctuation: /[{}]/
            }
        };
        Prism.languages['solution-file'] = {
            comment: {
                pattern: /#.*/,
                greedy: true
            },
            string: {
                pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
                greedy: true,
                inside: {
                    guid: guid
                }
            },
            object: {
                // Foo
                //   Bar("abs") = 9
                //   EndBar
                //   Prop = TRUE
                // EndFoo
                pattern: /^([ \t]*)(?:([A-Z]\w*)\b(?=.*(?:\r\n?|\n)(?:\1[ \t].*(?:\r\n?|\n))*\1End\2(?=[ \t]*$))|End[A-Z]\w*(?=[ \t]*$))/m,
                lookbehind: true,
                greedy: true,
                alias: 'keyword'
            },
            property: {
                pattern: /^([ \t]*)(?!\s)[^\r\n"#=()]*[^\s"#=()](?=\s*=)/m,
                lookbehind: true,
                inside: {
                    guid: guid
                }
            },
            guid: guid,
            number: /\b\d+(?:\.\d+)*\b/,
            boolean: /\b(?:FALSE|TRUE)\b/,
            operator: /=/,
            punctuation: /[(),]/
        };
        Prism.languages['sln'] = Prism.languages['solution-file'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$4b8f98fbb364b5fe$export$2e2bcd8739ae039.displayName = 'soy';
$4b8f98fbb364b5fe$export$2e2bcd8739ae039.aliases = [];
function $4b8f98fbb364b5fe$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
    (function(Prism) {
        var stringPattern = /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/;
        var numberPattern = /\b\d+(?:\.\d+)?(?:[eE][+-]?\d+)?\b|\b0x[\dA-F]+\b/;
        Prism.languages.soy = {
            comment: [
                /\/\*[\s\S]*?\*\//,
                {
                    pattern: /(\s)\/\/.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            'command-arg': {
                pattern: /(\{+\/?\s*(?:alias|call|delcall|delpackage|deltemplate|namespace|template)\s+)\.?[\w.]+/,
                lookbehind: true,
                alias: 'string',
                inside: {
                    punctuation: /\./
                }
            },
            parameter: {
                pattern: /(\{+\/?\s*@?param\??\s+)\.?[\w.]+/,
                lookbehind: true,
                alias: 'variable'
            },
            keyword: [
                {
                    pattern: /(\{+\/?[^\S\r\n]*)(?:\\[nrt]|alias|call|case|css|default|delcall|delpackage|deltemplate|else(?:if)?|fallbackmsg|for(?:each)?|if(?:empty)?|lb|let|literal|msg|namespace|nil|@?param\??|rb|sp|switch|template|xid)/,
                    lookbehind: true
                },
                /\b(?:any|as|attributes|bool|css|float|html|in|int|js|list|map|null|number|string|uri)\b/
            ],
            delimiter: {
                pattern: /^\{+\/?|\/?\}+$/,
                alias: 'punctuation'
            },
            property: /\w+(?==)/,
            variable: {
                pattern: /\$[^\W\d]\w*(?:\??(?:\.\w+|\[[^\]]+\]))*/,
                inside: {
                    string: {
                        pattern: stringPattern,
                        greedy: true
                    },
                    number: numberPattern,
                    punctuation: /[\[\].?]/
                }
            },
            string: {
                pattern: stringPattern,
                greedy: true
            },
            function: [
                /\w+(?=\()/,
                {
                    pattern: /(\|[^\S\r\n]*)\w+/,
                    lookbehind: true
                }
            ],
            boolean: /\b(?:false|true)\b/,
            number: numberPattern,
            operator: /\?:?|<=?|>=?|==?|!=|[+*/%-]|\b(?:and|not|or)\b/,
            punctuation: /[{}()\[\]|.,:]/
        };
        // Tokenize all inline Soy expressions
        Prism.hooks.add('before-tokenize', function(env) {
            var soyPattern = /\{\{.+?\}\}|\{.+?\}|\s\/\/.*|\/\*[\s\S]*?\*\//g;
            var soyLitteralStart = '{literal}';
            var soyLitteralEnd = '{/literal}';
            var soyLitteralMode = false;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'soy', soyPattern, function(match) {
                // Soy tags inside {literal} block are ignored
                if (match === soyLitteralEnd) soyLitteralMode = false;
                if (!soyLitteralMode) {
                    if (match === soyLitteralStart) soyLitteralMode = true;
                    return true;
                }
                return false;
            });
        });
        // Re-insert the tokens after tokenizing
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'soy');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $013d5fc882b5f308$export$2e2bcd8739ae039.displayName = 'turtle';
$013d5fc882b5f308$export$2e2bcd8739ae039.aliases = [
    'trig'
];
function $013d5fc882b5f308$export$2e2bcd8739ae039(Prism) {
    Prism.languages.turtle = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        'multiline-string': {
            pattern: /"""(?:(?:""?)?(?:[^"\\]|\\.))*"""|'''(?:(?:''?)?(?:[^'\\]|\\.))*'''/,
            greedy: true,
            alias: 'string',
            inside: {
                comment: /#.*/
            }
        },
        string: {
            pattern: /"(?:[^\\"\r\n]|\\.)*"|'(?:[^\\'\r\n]|\\.)*'/,
            greedy: true
        },
        url: {
            pattern: /<(?:[^\x00-\x20<>"{}|^`\\]|\\(?:u[\da-fA-F]{4}|U[\da-fA-F]{8}))*>/,
            greedy: true,
            inside: {
                punctuation: /[<>]/
            }
        },
        function: {
            pattern: /(?:(?![-.\d\xB7])[-.\w\xB7\xC0-\uFFFD]+)?:(?:(?![-.])(?:[-.:\w\xC0-\uFFFD]|%[\da-f]{2}|\\.)+)?/i,
            inside: {
                'local-name': {
                    pattern: /([^:]*:)[\s\S]+/,
                    lookbehind: true
                },
                prefix: {
                    pattern: /[\s\S]+/,
                    inside: {
                        punctuation: /:/
                    }
                }
            }
        },
        number: /[+-]?\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
        punctuation: /[{}.,;()[\]]|\^\^/,
        boolean: /\b(?:false|true)\b/,
        keyword: [
            /(?:\ba|@prefix|@base)\b|=/,
            /\b(?:base|graph|prefix)\b/i
        ],
        tag: {
            pattern: /@[a-z]+(?:-[a-z\d]+)*/i,
            inside: {
                punctuation: /@/
            }
        }
    };
    Prism.languages.trig = Prism.languages['turtle'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$803656f9da2f54a6$export$2e2bcd8739ae039.displayName = 'sparql';
$803656f9da2f54a6$export$2e2bcd8739ae039.aliases = [
    'rq'
];
function $803656f9da2f54a6$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $013d5fc882b5f308$export$2e2bcd8739ae039));
    Prism.languages.sparql = Prism.languages.extend('turtle', {
        boolean: /\b(?:false|true)\b/i,
        variable: {
            pattern: /[?$]\w+/,
            greedy: true
        }
    });
    Prism.languages.insertBefore('sparql', 'punctuation', {
        keyword: [
            /\b(?:A|ADD|ALL|AS|ASC|ASK|BNODE|BY|CLEAR|CONSTRUCT|COPY|CREATE|DATA|DEFAULT|DELETE|DESC|DESCRIBE|DISTINCT|DROP|EXISTS|FILTER|FROM|GROUP|HAVING|INSERT|INTO|LIMIT|LOAD|MINUS|MOVE|NAMED|NOT|NOW|OFFSET|OPTIONAL|ORDER|RAND|REDUCED|SELECT|SEPARATOR|SERVICE|SILENT|STRUUID|UNION|USING|UUID|VALUES|WHERE)\b/i,
            /\b(?:ABS|AVG|BIND|BOUND|CEIL|COALESCE|CONCAT|CONTAINS|COUNT|DATATYPE|DAY|ENCODE_FOR_URI|FLOOR|GROUP_CONCAT|HOURS|IF|IRI|isBLANK|isIRI|isLITERAL|isNUMERIC|isURI|LANG|LANGMATCHES|LCASE|MAX|MD5|MIN|MINUTES|MONTH|REGEX|REPLACE|ROUND|sameTerm|SAMPLE|SECONDS|SHA1|SHA256|SHA384|SHA512|STR|STRAFTER|STRBEFORE|STRDT|STRENDS|STRLANG|STRLEN|STRSTARTS|SUBSTR|SUM|TIMEZONE|TZ|UCASE|URI|YEAR)\b(?=\s*\()/i,
            /\b(?:BASE|GRAPH|PREFIX)\b/i
        ]
    });
    Prism.languages.rq = Prism.languages.sparql;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $fbdec31c6df2c19f$export$2e2bcd8739ae039.displayName = 'splunk-spl';
$fbdec31c6df2c19f$export$2e2bcd8739ae039.aliases = [];
function $fbdec31c6df2c19f$export$2e2bcd8739ae039(Prism) {
    Prism.languages['splunk-spl'] = {
        comment: /`comment\("(?:\\.|[^\\"])*"\)`/,
        string: {
            pattern: /"(?:\\.|[^\\"])*"/,
            greedy: true
        },
        // https://docs.splunk.com/Documentation/Splunk/7.3.0/SearchReference/ListOfSearchCommands
        keyword: /\b(?:abstract|accum|addcoltotals|addinfo|addtotals|analyzefields|anomalies|anomalousvalue|anomalydetection|append|appendcols|appendcsv|appendlookup|appendpipe|arules|associate|audit|autoregress|bin|bucket|bucketdir|chart|cluster|cofilter|collect|concurrency|contingency|convert|correlate|datamodel|dbinspect|dedup|delete|delta|diff|erex|eval|eventcount|eventstats|extract|fieldformat|fields|fieldsummary|filldown|fillnull|findtypes|folderize|foreach|format|from|gauge|gentimes|geom|geomfilter|geostats|head|highlight|history|iconify|input|inputcsv|inputlookup|iplocation|join|kmeans|kv|kvform|loadjob|localize|localop|lookup|makecontinuous|makemv|makeresults|map|mcollect|metadata|metasearch|meventcollect|mstats|multikv|multisearch|mvcombine|mvexpand|nomv|outlier|outputcsv|outputlookup|outputtext|overlap|pivot|predict|rangemap|rare|regex|relevancy|reltime|rename|replace|rest|return|reverse|rex|rtorder|run|savedsearch|script|scrub|search|searchtxn|selfjoin|sendemail|set|setfields|sichart|sirare|sistats|sitimechart|sitop|sort|spath|stats|strcat|streamstats|table|tags|tail|timechart|timewrap|top|transaction|transpose|trendline|tscollect|tstats|typeahead|typelearner|typer|union|uniq|untable|where|x11|xmlkv|xmlunescape|xpath|xyseries)\b/i,
        'operator-word': {
            pattern: /\b(?:and|as|by|not|or|xor)\b/i,
            alias: 'operator'
        },
        function: /\b\w+(?=\s*\()/,
        property: /\b\w+(?=\s*=(?!=))/,
        date: {
            // MM/DD/YYYY(:HH:MM:SS)?
            pattern: /\b\d{1,2}\/\d{1,2}\/\d{1,4}(?:(?::\d{1,2}){3})?\b/,
            alias: 'number'
        },
        number: /\b\d+(?:\.\d+)?\b/,
        boolean: /\b(?:f|false|t|true)\b/i,
        operator: /[<>=]=?|[-+*/%|]/,
        punctuation: /[()[\],]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$12d6f3ddfd59c8f8$export$2e2bcd8739ae039.displayName = 'sqf';
$12d6f3ddfd59c8f8$export$2e2bcd8739ae039.aliases = [];
function $12d6f3ddfd59c8f8$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.sqf = Prism.languages.extend('clike', {
        string: {
            pattern: /"(?:(?:"")?[^"])*"(?!")|'(?:[^'])*'/,
            greedy: true
        },
        keyword: /\b(?:breakOut|breakTo|call|case|catch|default|do|echo|else|execFSM|execVM|exitWith|for|forEach|forEachMember|forEachMemberAgent|forEachMemberTeam|from|goto|if|nil|preprocessFile|preprocessFileLineNumbers|private|scopeName|spawn|step|switch|then|throw|to|try|while|with)\b/i,
        boolean: /\b(?:false|true)\b/i,
        function: /\b(?:abs|accTime|acos|action|actionIDs|actionKeys|actionKeysImages|actionKeysNames|actionKeysNamesArray|actionName|actionParams|activateAddons|activatedAddons|activateKey|add3DENConnection|add3DENEventHandler|add3DENLayer|addAction|addBackpack|addBackpackCargo|addBackpackCargoGlobal|addBackpackGlobal|addCamShake|addCuratorAddons|addCuratorCameraArea|addCuratorEditableObjects|addCuratorEditingArea|addCuratorPoints|addEditorObject|addEventHandler|addForce|addForceGeneratorRTD|addGoggles|addGroupIcon|addHandgunItem|addHeadgear|addItem|addItemCargo|addItemCargoGlobal|addItemPool|addItemToBackpack|addItemToUniform|addItemToVest|addLiveStats|addMagazine|addMagazineAmmoCargo|addMagazineCargo|addMagazineCargoGlobal|addMagazineGlobal|addMagazinePool|addMagazines|addMagazineTurret|addMenu|addMenuItem|addMissionEventHandler|addMPEventHandler|addMusicEventHandler|addOwnedMine|addPlayerScores|addPrimaryWeaponItem|addPublicVariableEventHandler|addRating|addResources|addScore|addScoreSide|addSecondaryWeaponItem|addSwitchableUnit|addTeamMember|addToRemainsCollector|addTorque|addUniform|addVehicle|addVest|addWaypoint|addWeapon|addWeaponCargo|addWeaponCargoGlobal|addWeaponGlobal|addWeaponItem|addWeaponPool|addWeaponTurret|admin|agent|agents|AGLToASL|aimedAtTarget|aimPos|airDensityCurveRTD|airDensityRTD|airplaneThrottle|airportSide|AISFinishHeal|alive|all3DENEntities|allAirports|allControls|allCurators|allCutLayers|allDead|allDeadMen|allDisplays|allGroups|allMapMarkers|allMines|allMissionObjects|allow3DMode|allowCrewInImmobile|allowCuratorLogicIgnoreAreas|allowDamage|allowDammage|allowFileOperations|allowFleeing|allowGetIn|allowSprint|allPlayers|allSimpleObjects|allSites|allTurrets|allUnits|allUnitsUAV|allVariables|ammo|ammoOnPylon|animate|animateBay|animateDoor|animatePylon|animateSource|animationNames|animationPhase|animationSourcePhase|animationState|append|apply|armoryPoints|arrayIntersect|asin|ASLToAGL|ASLToATL|assert|assignAsCargo|assignAsCargoIndex|assignAsCommander|assignAsDriver|assignAsGunner|assignAsTurret|assignCurator|assignedCargo|assignedCommander|assignedDriver|assignedGunner|assignedItems|assignedTarget|assignedTeam|assignedVehicle|assignedVehicleRole|assignItem|assignTeam|assignToAirport|atan|atan2|atg|ATLToASL|attachedObject|attachedObjects|attachedTo|attachObject|attachTo|attackEnabled|backpack|backpackCargo|backpackContainer|backpackItems|backpackMagazines|backpackSpaceFor|behaviour|benchmark|binocular|blufor|boundingBox|boundingBoxReal|boundingCenter|briefingName|buildingExit|buildingPos|buldozer_EnableRoadDiag|buldozer_IsEnabledRoadDiag|buldozer_LoadNewRoads|buldozer_reloadOperMap|buttonAction|buttonSetAction|cadetMode|callExtension|camCommand|camCommit|camCommitPrepared|camCommitted|camConstuctionSetParams|camCreate|camDestroy|cameraEffect|cameraEffectEnableHUD|cameraInterest|cameraOn|cameraView|campaignConfigFile|camPreload|camPreloaded|camPrepareBank|camPrepareDir|camPrepareDive|camPrepareFocus|camPrepareFov|camPrepareFovRange|camPreparePos|camPrepareRelPos|camPrepareTarget|camSetBank|camSetDir|camSetDive|camSetFocus|camSetFov|camSetFovRange|camSetPos|camSetRelPos|camSetTarget|camTarget|camUseNVG|canAdd|canAddItemToBackpack|canAddItemToUniform|canAddItemToVest|cancelSimpleTaskDestination|canFire|canMove|canSlingLoad|canStand|canSuspend|canTriggerDynamicSimulation|canUnloadInCombat|canVehicleCargo|captive|captiveNum|cbChecked|cbSetChecked|ceil|channelEnabled|cheatsEnabled|checkAIFeature|checkVisibility|civilian|className|clear3DENAttribute|clear3DENInventory|clearAllItemsFromBackpack|clearBackpackCargo|clearBackpackCargoGlobal|clearForcesRTD|clearGroupIcons|clearItemCargo|clearItemCargoGlobal|clearItemPool|clearMagazineCargo|clearMagazineCargoGlobal|clearMagazinePool|clearOverlay|clearRadio|clearVehicleInit|clearWeaponCargo|clearWeaponCargoGlobal|clearWeaponPool|clientOwner|closeDialog|closeDisplay|closeOverlay|collapseObjectTree|collect3DENHistory|collectiveRTD|combatMode|commandArtilleryFire|commandChat|commander|commandFire|commandFollow|commandFSM|commandGetOut|commandingMenu|commandMove|commandRadio|commandStop|commandSuppressiveFire|commandTarget|commandWatch|comment|commitOverlay|compile|compileFinal|completedFSM|composeText|configClasses|configFile|configHierarchy|configName|configNull|configProperties|configSourceAddonList|configSourceMod|configSourceModList|confirmSensorTarget|connectTerminalToUAV|controlNull|controlsGroupCtrl|copyFromClipboard|copyToClipboard|copyWaypoints|cos|count|countEnemy|countFriendly|countSide|countType|countUnknown|create3DENComposition|create3DENEntity|createAgent|createCenter|createDialog|createDiaryLink|createDiaryRecord|createDiarySubject|createDisplay|createGearDialog|createGroup|createGuardedPoint|createLocation|createMarker|createMarkerLocal|createMenu|createMine|createMissionDisplay|createMPCampaignDisplay|createSimpleObject|createSimpleTask|createSite|createSoundSource|createTask|createTeam|createTrigger|createUnit|createVehicle|createVehicleCrew|createVehicleLocal|crew|ctAddHeader|ctAddRow|ctClear|ctCurSel|ctData|ctFindHeaderRows|ctFindRowHeader|ctHeaderControls|ctHeaderCount|ctRemoveHeaders|ctRemoveRows|ctrlActivate|ctrlAddEventHandler|ctrlAngle|ctrlAutoScrollDelay|ctrlAutoScrollRewind|ctrlAutoScrollSpeed|ctrlChecked|ctrlClassName|ctrlCommit|ctrlCommitted|ctrlCreate|ctrlDelete|ctrlEnable|ctrlEnabled|ctrlFade|ctrlHTMLLoaded|ctrlIDC|ctrlIDD|ctrlMapAnimAdd|ctrlMapAnimClear|ctrlMapAnimCommit|ctrlMapAnimDone|ctrlMapCursor|ctrlMapMouseOver|ctrlMapScale|ctrlMapScreenToWorld|ctrlMapWorldToScreen|ctrlModel|ctrlModelDirAndUp|ctrlModelScale|ctrlParent|ctrlParentControlsGroup|ctrlPosition|ctrlRemoveAllEventHandlers|ctrlRemoveEventHandler|ctrlScale|ctrlSetActiveColor|ctrlSetAngle|ctrlSetAutoScrollDelay|ctrlSetAutoScrollRewind|ctrlSetAutoScrollSpeed|ctrlSetBackgroundColor|ctrlSetChecked|ctrlSetDisabledColor|ctrlSetEventHandler|ctrlSetFade|ctrlSetFocus|ctrlSetFont|ctrlSetFontH1|ctrlSetFontH1B|ctrlSetFontH2|ctrlSetFontH2B|ctrlSetFontH3|ctrlSetFontH3B|ctrlSetFontH4|ctrlSetFontH4B|ctrlSetFontH5|ctrlSetFontH5B|ctrlSetFontH6|ctrlSetFontH6B|ctrlSetFontHeight|ctrlSetFontHeightH1|ctrlSetFontHeightH2|ctrlSetFontHeightH3|ctrlSetFontHeightH4|ctrlSetFontHeightH5|ctrlSetFontHeightH6|ctrlSetFontHeightSecondary|ctrlSetFontP|ctrlSetFontPB|ctrlSetFontSecondary|ctrlSetForegroundColor|ctrlSetModel|ctrlSetModelDirAndUp|ctrlSetModelScale|ctrlSetPixelPrecision|ctrlSetPosition|ctrlSetScale|ctrlSetStructuredText|ctrlSetText|ctrlSetTextColor|ctrlSetTextColorSecondary|ctrlSetTextSecondary|ctrlSetTooltip|ctrlSetTooltipColorBox|ctrlSetTooltipColorShade|ctrlSetTooltipColorText|ctrlShow|ctrlShown|ctrlText|ctrlTextHeight|ctrlTextSecondary|ctrlTextWidth|ctrlType|ctrlVisible|ctRowControls|ctRowCount|ctSetCurSel|ctSetData|ctSetHeaderTemplate|ctSetRowTemplate|ctSetValue|ctValue|curatorAddons|curatorCamera|curatorCameraArea|curatorCameraAreaCeiling|curatorCoef|curatorEditableObjects|curatorEditingArea|curatorEditingAreaType|curatorMouseOver|curatorPoints|curatorRegisteredObjects|curatorSelected|curatorWaypointCost|current3DENOperation|currentChannel|currentCommand|currentMagazine|currentMagazineDetail|currentMagazineDetailTurret|currentMagazineTurret|currentMuzzle|currentNamespace|currentTask|currentTasks|currentThrowable|currentVisionMode|currentWaypoint|currentWeapon|currentWeaponMode|currentWeaponTurret|currentZeroing|cursorObject|cursorTarget|customChat|customRadio|cutFadeOut|cutObj|cutRsc|cutText|damage|date|dateToNumber|daytime|deActivateKey|debriefingText|debugFSM|debugLog|deg|delete3DENEntities|deleteAt|deleteCenter|deleteCollection|deleteEditorObject|deleteGroup|deleteGroupWhenEmpty|deleteIdentity|deleteLocation|deleteMarker|deleteMarkerLocal|deleteRange|deleteResources|deleteSite|deleteStatus|deleteTeam|deleteVehicle|deleteVehicleCrew|deleteWaypoint|detach|detectedMines|diag_activeMissionFSMs|diag_activeScripts|diag_activeSQFScripts|diag_activeSQSScripts|diag_captureFrame|diag_captureFrameToFile|diag_captureSlowFrame|diag_codePerformance|diag_drawMode|diag_dynamicSimulationEnd|diag_enable|diag_enabled|diag_fps|diag_fpsMin|diag_frameNo|diag_lightNewLoad|diag_list|diag_log|diag_logSlowFrame|diag_mergeConfigFile|diag_recordTurretLimits|diag_setLightNew|diag_tickTime|diag_toggle|dialog|diarySubjectExists|didJIP|didJIPOwner|difficulty|difficultyEnabled|difficultyEnabledRTD|difficultyOption|direction|directSay|disableAI|disableCollisionWith|disableConversation|disableDebriefingStats|disableMapIndicators|disableNVGEquipment|disableRemoteSensors|disableSerialization|disableTIEquipment|disableUAVConnectability|disableUserInput|displayAddEventHandler|displayCtrl|displayNull|displayParent|displayRemoveAllEventHandlers|displayRemoveEventHandler|displaySetEventHandler|dissolveTeam|distance|distance2D|distanceSqr|distributionRegion|do3DENAction|doArtilleryFire|doFire|doFollow|doFSM|doGetOut|doMove|doorPhase|doStop|doSuppressiveFire|doTarget|doWatch|drawArrow|drawEllipse|drawIcon|drawIcon3D|drawLine|drawLine3D|drawLink|drawLocation|drawPolygon|drawRectangle|drawTriangle|driver|drop|dynamicSimulationDistance|dynamicSimulationDistanceCoef|dynamicSimulationEnabled|dynamicSimulationSystemEnabled|east|edit3DENMissionAttributes|editObject|editorSetEventHandler|effectiveCommander|emptyPositions|enableAI|enableAIFeature|enableAimPrecision|enableAttack|enableAudioFeature|enableAutoStartUpRTD|enableAutoTrimRTD|enableCamShake|enableCaustics|enableChannel|enableCollisionWith|enableCopilot|enableDebriefingStats|enableDiagLegend|enableDynamicSimulation|enableDynamicSimulationSystem|enableEndDialog|enableEngineArtillery|enableEnvironment|enableFatigue|enableGunLights|enableInfoPanelComponent|enableIRLasers|enableMimics|enablePersonTurret|enableRadio|enableReload|enableRopeAttach|enableSatNormalOnDetail|enableSaving|enableSentences|enableSimulation|enableSimulationGlobal|enableStamina|enableStressDamage|enableTeamSwitch|enableTraffic|enableUAVConnectability|enableUAVWaypoints|enableVehicleCargo|enableVehicleSensor|enableWeaponDisassembly|endl|endLoadingScreen|endMission|engineOn|enginesIsOnRTD|enginesPowerRTD|enginesRpmRTD|enginesTorqueRTD|entities|environmentEnabled|estimatedEndServerTime|estimatedTimeLeft|evalObjectArgument|everyBackpack|everyContainer|exec|execEditorScript|exp|expectedDestination|exportJIPMessages|eyeDirection|eyePos|face|faction|fadeMusic|fadeRadio|fadeSound|fadeSpeech|failMission|fillWeaponsFromPool|find|findCover|findDisplay|findEditorObject|findEmptyPosition|findEmptyPositionReady|findIf|findNearestEnemy|finishMissionInit|finite|fire|fireAtTarget|firstBackpack|flag|flagAnimationPhase|flagOwner|flagSide|flagTexture|fleeing|floor|flyInHeight|flyInHeightASL|fog|fogForecast|fogParams|forceAddUniform|forceAtPositionRTD|forcedMap|forceEnd|forceFlagTexture|forceFollowRoad|forceGeneratorRTD|forceMap|forceRespawn|forceSpeed|forceWalk|forceWeaponFire|forceWeatherChange|forgetTarget|format|formation|formationDirection|formationLeader|formationMembers|formationPosition|formationTask|formatText|formLeader|freeLook|fromEditor|fuel|fullCrew|gearIDCAmmoCount|gearSlotAmmoCount|gearSlotData|get3DENActionState|get3DENAttribute|get3DENCamera|get3DENConnections|get3DENEntity|get3DENEntityID|get3DENGrid|get3DENIconsVisible|get3DENLayerEntities|get3DENLinesVisible|get3DENMissionAttribute|get3DENMouseOver|get3DENSelected|getAimingCoef|getAllEnvSoundControllers|getAllHitPointsDamage|getAllOwnedMines|getAllSoundControllers|getAmmoCargo|getAnimAimPrecision|getAnimSpeedCoef|getArray|getArtilleryAmmo|getArtilleryComputerSettings|getArtilleryETA|getAssignedCuratorLogic|getAssignedCuratorUnit|getBackpackCargo|getBleedingRemaining|getBurningValue|getCameraViewDirection|getCargoIndex|getCenterOfMass|getClientState|getClientStateNumber|getCompatiblePylonMagazines|getConnectedUAV|getContainerMaxLoad|getCursorObjectParams|getCustomAimCoef|getDammage|getDescription|getDir|getDirVisual|getDLCAssetsUsage|getDLCAssetsUsageByName|getDLCs|getDLCUsageTime|getEditorCamera|getEditorMode|getEditorObjectScope|getElevationOffset|getEngineTargetRpmRTD|getEnvSoundController|getFatigue|getFieldManualStartPage|getForcedFlagTexture|getFriend|getFSMVariable|getFuelCargo|getGroupIcon|getGroupIconParams|getGroupIcons|getHideFrom|getHit|getHitIndex|getHitPointDamage|getItemCargo|getMagazineCargo|getMarkerColor|getMarkerPos|getMarkerSize|getMarkerType|getMass|getMissionConfig|getMissionConfigValue|getMissionDLCs|getMissionLayerEntities|getMissionLayers|getModelInfo|getMousePosition|getMusicPlayedTime|getNumber|getObjectArgument|getObjectChildren|getObjectDLC|getObjectMaterials|getObjectProxy|getObjectTextures|getObjectType|getObjectViewDistance|getOxygenRemaining|getPersonUsedDLCs|getPilotCameraDirection|getPilotCameraPosition|getPilotCameraRotation|getPilotCameraTarget|getPlateNumber|getPlayerChannel|getPlayerScores|getPlayerUID|getPlayerUIDOld|getPos|getPosASL|getPosASLVisual|getPosASLW|getPosATL|getPosATLVisual|getPosVisual|getPosWorld|getPylonMagazines|getRelDir|getRelPos|getRemoteSensorsDisabled|getRepairCargo|getResolution|getRotorBrakeRTD|getShadowDistance|getShotParents|getSlingLoad|getSoundController|getSoundControllerResult|getSpeed|getStamina|getStatValue|getSuppression|getTerrainGrid|getTerrainHeightASL|getText|getTotalDLCUsageTime|getTrimOffsetRTD|getUnitLoadout|getUnitTrait|getUserMFDText|getUserMFDValue|getVariable|getVehicleCargo|getWeaponCargo|getWeaponSway|getWingsOrientationRTD|getWingsPositionRTD|getWPPos|glanceAt|globalChat|globalRadio|goggles|group|groupChat|groupFromNetId|groupIconSelectable|groupIconsVisible|groupId|groupOwner|groupRadio|groupSelectedUnits|groupSelectUnit|grpNull|gunner|gusts|halt|handgunItems|handgunMagazine|handgunWeapon|handsHit|hasInterface|hasPilotCamera|hasWeapon|hcAllGroups|hcGroupParams|hcLeader|hcRemoveAllGroups|hcRemoveGroup|hcSelected|hcSelectGroup|hcSetGroup|hcShowBar|hcShownBar|headgear|hideBody|hideObject|hideObjectGlobal|hideSelection|hint|hintC|hintCadet|hintSilent|hmd|hostMission|htmlLoad|HUDMovementLevels|humidity|image|importAllGroups|importance|in|inArea|inAreaArray|incapacitatedState|independent|inflame|inflamed|infoPanel|infoPanelComponentEnabled|infoPanelComponents|infoPanels|inGameUISetEventHandler|inheritsFrom|initAmbientLife|inPolygon|inputAction|inRangeOfArtillery|insertEditorObject|intersect|is3DEN|is3DENMultiplayer|isAbleToBreathe|isAgent|isAimPrecisionEnabled|isArray|isAutoHoverOn|isAutonomous|isAutoStartUpEnabledRTD|isAutotest|isAutoTrimOnRTD|isBleeding|isBurning|isClass|isCollisionLightOn|isCopilotEnabled|isDamageAllowed|isDedicated|isDLCAvailable|isEngineOn|isEqualTo|isEqualType|isEqualTypeAll|isEqualTypeAny|isEqualTypeArray|isEqualTypeParams|isFilePatchingEnabled|isFlashlightOn|isFlatEmpty|isForcedWalk|isFormationLeader|isGroupDeletedWhenEmpty|isHidden|isInRemainsCollector|isInstructorFigureEnabled|isIRLaserOn|isKeyActive|isKindOf|isLaserOn|isLightOn|isLocalized|isManualFire|isMarkedForCollection|isMultiplayer|isMultiplayerSolo|isNil|isNull|isNumber|isObjectHidden|isObjectRTD|isOnRoad|isPipEnabled|isPlayer|isRealTime|isRemoteExecuted|isRemoteExecutedJIP|isServer|isShowing3DIcons|isSimpleObject|isSprintAllowed|isStaminaEnabled|isSteamMission|isStreamFriendlyUIEnabled|isStressDamageEnabled|isText|isTouchingGround|isTurnedOut|isTutHintsEnabled|isUAVConnectable|isUAVConnected|isUIContext|isUniformAllowed|isVehicleCargo|isVehicleRadarOn|isVehicleSensorEnabled|isWalking|isWeaponDeployed|isWeaponRested|itemCargo|items|itemsWithMagazines|join|joinAs|joinAsSilent|joinSilent|joinString|kbAddDatabase|kbAddDatabaseTargets|kbAddTopic|kbHasTopic|kbReact|kbRemoveTopic|kbTell|kbWasSaid|keyImage|keyName|knowsAbout|land|landAt|landResult|language|laserTarget|lbAdd|lbClear|lbColor|lbColorRight|lbCurSel|lbData|lbDelete|lbIsSelected|lbPicture|lbPictureRight|lbSelection|lbSetColor|lbSetColorRight|lbSetCurSel|lbSetData|lbSetPicture|lbSetPictureColor|lbSetPictureColorDisabled|lbSetPictureColorSelected|lbSetPictureRight|lbSetPictureRightColor|lbSetPictureRightColorDisabled|lbSetPictureRightColorSelected|lbSetSelectColor|lbSetSelectColorRight|lbSetSelected|lbSetText|lbSetTextRight|lbSetTooltip|lbSetValue|lbSize|lbSort|lbSortByValue|lbText|lbTextRight|lbValue|leader|leaderboardDeInit|leaderboardGetRows|leaderboardInit|leaderboardRequestRowsFriends|leaderboardRequestRowsGlobal|leaderboardRequestRowsGlobalAroundUser|leaderboardsRequestUploadScore|leaderboardsRequestUploadScoreKeepBest|leaderboardState|leaveVehicle|libraryCredits|libraryDisclaimers|lifeState|lightAttachObject|lightDetachObject|lightIsOn|lightnings|limitSpeed|linearConversion|lineBreak|lineIntersects|lineIntersectsObjs|lineIntersectsSurfaces|lineIntersectsWith|linkItem|list|listObjects|listRemoteTargets|listVehicleSensors|ln|lnbAddArray|lnbAddColumn|lnbAddRow|lnbClear|lnbColor|lnbColorRight|lnbCurSelRow|lnbData|lnbDeleteColumn|lnbDeleteRow|lnbGetColumnsPosition|lnbPicture|lnbPictureRight|lnbSetColor|lnbSetColorRight|lnbSetColumnsPos|lnbSetCurSelRow|lnbSetData|lnbSetPicture|lnbSetPictureColor|lnbSetPictureColorRight|lnbSetPictureColorSelected|lnbSetPictureColorSelectedRight|lnbSetPictureRight|lnbSetText|lnbSetTextRight|lnbSetValue|lnbSize|lnbSort|lnbSortByValue|lnbText|lnbTextRight|lnbValue|load|loadAbs|loadBackpack|loadFile|loadGame|loadIdentity|loadMagazine|loadOverlay|loadStatus|loadUniform|loadVest|local|localize|locationNull|locationPosition|lock|lockCameraTo|lockCargo|lockDriver|locked|lockedCargo|lockedDriver|lockedTurret|lockIdentity|lockTurret|lockWP|log|logEntities|logNetwork|logNetworkTerminate|lookAt|lookAtPos|magazineCargo|magazines|magazinesAllTurrets|magazinesAmmo|magazinesAmmoCargo|magazinesAmmoFull|magazinesDetail|magazinesDetailBackpack|magazinesDetailUniform|magazinesDetailVest|magazinesTurret|magazineTurretAmmo|mapAnimAdd|mapAnimClear|mapAnimCommit|mapAnimDone|mapCenterOnCamera|mapGridPosition|markAsFinishedOnSteam|markerAlpha|markerBrush|markerColor|markerDir|markerPos|markerShape|markerSize|markerText|markerType|max|members|menuAction|menuAdd|menuChecked|menuClear|menuCollapse|menuData|menuDelete|menuEnable|menuEnabled|menuExpand|menuHover|menuPicture|menuSetAction|menuSetCheck|menuSetData|menuSetPicture|menuSetValue|menuShortcut|menuShortcutText|menuSize|menuSort|menuText|menuURL|menuValue|min|mineActive|mineDetectedBy|missionConfigFile|missionDifficulty|missionName|missionNamespace|missionStart|missionVersion|modelToWorld|modelToWorldVisual|modelToWorldVisualWorld|modelToWorldWorld|modParams|moonIntensity|moonPhase|morale|move|move3DENCamera|moveInAny|moveInCargo|moveInCommander|moveInDriver|moveInGunner|moveInTurret|moveObjectToEnd|moveOut|moveTime|moveTo|moveToCompleted|moveToFailed|musicVolume|name|nameSound|nearEntities|nearestBuilding|nearestLocation|nearestLocations|nearestLocationWithDubbing|nearestObject|nearestObjects|nearestTerrainObjects|nearObjects|nearObjectsReady|nearRoads|nearSupplies|nearTargets|needReload|netId|netObjNull|newOverlay|nextMenuItemIndex|nextWeatherChange|nMenuItems|numberOfEnginesRTD|numberToDate|objectCurators|objectFromNetId|objectParent|objNull|objStatus|onBriefingGear|onBriefingGroup|onBriefingNotes|onBriefingPlan|onBriefingTeamSwitch|onCommandModeChanged|onDoubleClick|onEachFrame|onGroupIconClick|onGroupIconOverEnter|onGroupIconOverLeave|onHCGroupSelectionChanged|onMapSingleClick|onPlayerConnected|onPlayerDisconnected|onPreloadFinished|onPreloadStarted|onShowNewObject|onTeamSwitch|openCuratorInterface|openDLCPage|openDSInterface|openMap|openSteamApp|openYoutubeVideo|opfor|orderGetIn|overcast|overcastForecast|owner|param|params|parseNumber|parseSimpleArray|parseText|parsingNamespace|particlesQuality|pi|pickWeaponPool|pitch|pixelGrid|pixelGridBase|pixelGridNoUIScale|pixelH|pixelW|playableSlotsNumber|playableUnits|playAction|playActionNow|player|playerRespawnTime|playerSide|playersNumber|playGesture|playMission|playMove|playMoveNow|playMusic|playScriptedMission|playSound|playSound3D|position|positionCameraToWorld|posScreenToWorld|posWorldToScreen|ppEffectAdjust|ppEffectCommit|ppEffectCommitted|ppEffectCreate|ppEffectDestroy|ppEffectEnable|ppEffectEnabled|ppEffectForceInNVG|precision|preloadCamera|preloadObject|preloadSound|preloadTitleObj|preloadTitleRsc|primaryWeapon|primaryWeaponItems|primaryWeaponMagazine|priority|processDiaryLink|processInitCommands|productVersion|profileName|profileNamespace|profileNameSteam|progressLoadingScreen|progressPosition|progressSetPosition|publicVariable|publicVariableClient|publicVariableServer|pushBack|pushBackUnique|putWeaponPool|queryItemsPool|queryMagazinePool|queryWeaponPool|rad|radioChannelAdd|radioChannelCreate|radioChannelRemove|radioChannelSetCallSign|radioChannelSetLabel|radioVolume|rain|rainbow|random|rank|rankId|rating|rectangular|registeredTasks|registerTask|reload|reloadEnabled|remoteControl|remoteExec|remoteExecCall|remoteExecutedOwner|remove3DENConnection|remove3DENEventHandler|remove3DENLayer|removeAction|removeAll3DENEventHandlers|removeAllActions|removeAllAssignedItems|removeAllContainers|removeAllCuratorAddons|removeAllCuratorCameraAreas|removeAllCuratorEditingAreas|removeAllEventHandlers|removeAllHandgunItems|removeAllItems|removeAllItemsWithMagazines|removeAllMissionEventHandlers|removeAllMPEventHandlers|removeAllMusicEventHandlers|removeAllOwnedMines|removeAllPrimaryWeaponItems|removeAllWeapons|removeBackpack|removeBackpackGlobal|removeCuratorAddons|removeCuratorCameraArea|removeCuratorEditableObjects|removeCuratorEditingArea|removeDrawIcon|removeDrawLinks|removeEventHandler|removeFromRemainsCollector|removeGoggles|removeGroupIcon|removeHandgunItem|removeHeadgear|removeItem|removeItemFromBackpack|removeItemFromUniform|removeItemFromVest|removeItems|removeMagazine|removeMagazineGlobal|removeMagazines|removeMagazinesTurret|removeMagazineTurret|removeMenuItem|removeMissionEventHandler|removeMPEventHandler|removeMusicEventHandler|removeOwnedMine|removePrimaryWeaponItem|removeSecondaryWeaponItem|removeSimpleTask|removeSwitchableUnit|removeTeamMember|removeUniform|removeVest|removeWeapon|removeWeaponAttachmentCargo|removeWeaponCargo|removeWeaponGlobal|removeWeaponTurret|reportRemoteTarget|requiredVersion|resetCamShake|resetSubgroupDirection|resistance|resize|resources|respawnVehicle|restartEditorCamera|reveal|revealMine|reverse|reversedMouseY|roadAt|roadsConnectedTo|roleDescription|ropeAttachedObjects|ropeAttachedTo|ropeAttachEnabled|ropeAttachTo|ropeCreate|ropeCut|ropeDestroy|ropeDetach|ropeEndPosition|ropeLength|ropes|ropeUnwind|ropeUnwound|rotorsForcesRTD|rotorsRpmRTD|round|runInitScript|safeZoneH|safeZoneW|safeZoneWAbs|safeZoneX|safeZoneXAbs|safeZoneY|save3DENInventory|saveGame|saveIdentity|saveJoysticks|saveOverlay|saveProfileNamespace|saveStatus|saveVar|savingEnabled|say|say2D|say3D|score|scoreSide|screenshot|screenToWorld|scriptDone|scriptName|scriptNull|scudState|secondaryWeapon|secondaryWeaponItems|secondaryWeaponMagazine|select|selectBestPlaces|selectDiarySubject|selectedEditorObjects|selectEditorObject|selectionNames|selectionPosition|selectLeader|selectMax|selectMin|selectNoPlayer|selectPlayer|selectRandom|selectRandomWeighted|selectWeapon|selectWeaponTurret|sendAUMessage|sendSimpleCommand|sendTask|sendTaskResult|sendUDPMessage|serverCommand|serverCommandAvailable|serverCommandExecutable|serverName|serverTime|set|set3DENAttribute|set3DENAttributes|set3DENGrid|set3DENIconsVisible|set3DENLayer|set3DENLinesVisible|set3DENLogicType|set3DENMissionAttribute|set3DENMissionAttributes|set3DENModelsVisible|set3DENObjectType|set3DENSelected|setAccTime|setActualCollectiveRTD|setAirplaneThrottle|setAirportSide|setAmmo|setAmmoCargo|setAmmoOnPylon|setAnimSpeedCoef|setAperture|setApertureNew|setArmoryPoints|setAttributes|setAutonomous|setBehaviour|setBleedingRemaining|setBrakesRTD|setCameraInterest|setCamShakeDefParams|setCamShakeParams|setCamUseTI|setCaptive|setCenterOfMass|setCollisionLight|setCombatMode|setCompassOscillation|setConvoySeparation|setCuratorCameraAreaCeiling|setCuratorCoef|setCuratorEditingAreaType|setCuratorWaypointCost|setCurrentChannel|setCurrentTask|setCurrentWaypoint|setCustomAimCoef|setCustomWeightRTD|setDamage|setDammage|setDate|setDebriefingText|setDefaultCamera|setDestination|setDetailMapBlendPars|setDir|setDirection|setDrawIcon|setDriveOnPath|setDropInterval|setDynamicSimulationDistance|setDynamicSimulationDistanceCoef|setEditorMode|setEditorObjectScope|setEffectCondition|setEngineRpmRTD|setFace|setFaceAnimation|setFatigue|setFeatureType|setFlagAnimationPhase|setFlagOwner|setFlagSide|setFlagTexture|setFog|setForceGeneratorRTD|setFormation|setFormationTask|setFormDir|setFriend|setFromEditor|setFSMVariable|setFuel|setFuelCargo|setGroupIcon|setGroupIconParams|setGroupIconsSelectable|setGroupIconsVisible|setGroupId|setGroupIdGlobal|setGroupOwner|setGusts|setHideBehind|setHit|setHitIndex|setHitPointDamage|setHorizonParallaxCoef|setHUDMovementLevels|setIdentity|setImportance|setInfoPanel|setLeader|setLightAmbient|setLightAttenuation|setLightBrightness|setLightColor|setLightDayLight|setLightFlareMaxDistance|setLightFlareSize|setLightIntensity|setLightnings|setLightUseFlare|setLocalWindParams|setMagazineTurretAmmo|setMarkerAlpha|setMarkerAlphaLocal|setMarkerBrush|setMarkerBrushLocal|setMarkerColor|setMarkerColorLocal|setMarkerDir|setMarkerDirLocal|setMarkerPos|setMarkerPosLocal|setMarkerShape|setMarkerShapeLocal|setMarkerSize|setMarkerSizeLocal|setMarkerText|setMarkerTextLocal|setMarkerType|setMarkerTypeLocal|setMass|setMimic|setMousePosition|setMusicEffect|setMusicEventHandler|setName|setNameSound|setObjectArguments|setObjectMaterial|setObjectMaterialGlobal|setObjectProxy|setObjectTexture|setObjectTextureGlobal|setObjectViewDistance|setOvercast|setOwner|setOxygenRemaining|setParticleCircle|setParticleClass|setParticleFire|setParticleParams|setParticleRandom|setPilotCameraDirection|setPilotCameraRotation|setPilotCameraTarget|setPilotLight|setPiPEffect|setPitch|setPlateNumber|setPlayable|setPlayerRespawnTime|setPos|setPosASL|setPosASL2|setPosASLW|setPosATL|setPosition|setPosWorld|setPylonLoadOut|setPylonsPriority|setRadioMsg|setRain|setRainbow|setRandomLip|setRank|setRectangular|setRepairCargo|setRotorBrakeRTD|setShadowDistance|setShotParents|setSide|setSimpleTaskAlwaysVisible|setSimpleTaskCustomData|setSimpleTaskDescription|setSimpleTaskDestination|setSimpleTaskTarget|setSimpleTaskType|setSimulWeatherLayers|setSize|setSkill|setSlingLoad|setSoundEffect|setSpeaker|setSpeech|setSpeedMode|setStamina|setStaminaScheme|setStatValue|setSuppression|setSystemOfUnits|setTargetAge|setTaskMarkerOffset|setTaskResult|setTaskState|setTerrainGrid|setText|setTimeMultiplier|setTitleEffect|setToneMapping|setToneMappingParams|setTrafficDensity|setTrafficDistance|setTrafficGap|setTrafficSpeed|setTriggerActivation|setTriggerArea|setTriggerStatements|setTriggerText|setTriggerTimeout|setTriggerType|setType|setUnconscious|setUnitAbility|setUnitLoadout|setUnitPos|setUnitPosWeak|setUnitRank|setUnitRecoilCoefficient|setUnitTrait|setUnloadInCombat|setUserActionText|setUserMFDText|setUserMFDValue|setVariable|setVectorDir|setVectorDirAndUp|setVectorUp|setVehicleAmmo|setVehicleAmmoDef|setVehicleArmor|setVehicleCargo|setVehicleId|setVehicleInit|setVehicleLock|setVehiclePosition|setVehicleRadar|setVehicleReceiveRemoteTargets|setVehicleReportOwnPosition|setVehicleReportRemoteTargets|setVehicleTIPars|setVehicleVarName|setVelocity|setVelocityModelSpace|setVelocityTransformation|setViewDistance|setVisibleIfTreeCollapsed|setWantedRpmRTD|setWaves|setWaypointBehaviour|setWaypointCombatMode|setWaypointCompletionRadius|setWaypointDescription|setWaypointForceBehaviour|setWaypointFormation|setWaypointHousePosition|setWaypointLoiterRadius|setWaypointLoiterType|setWaypointName|setWaypointPosition|setWaypointScript|setWaypointSpeed|setWaypointStatements|setWaypointTimeout|setWaypointType|setWaypointVisible|setWeaponReloadingTime|setWind|setWindDir|setWindForce|setWindStr|setWingForceScaleRTD|setWPPos|show3DIcons|showChat|showCinemaBorder|showCommandingMenu|showCompass|showCuratorCompass|showGPS|showHUD|showLegend|showMap|shownArtilleryComputer|shownChat|shownCompass|shownCuratorCompass|showNewEditorObject|shownGPS|shownHUD|shownMap|shownPad|shownRadio|shownScoretable|shownUAVFeed|shownWarrant|shownWatch|showPad|showRadio|showScoretable|showSubtitles|showUAVFeed|showWarrant|showWatch|showWaypoint|showWaypoints|side|sideAmbientLife|sideChat|sideEmpty|sideEnemy|sideFriendly|sideLogic|sideRadio|sideUnknown|simpleTasks|simulationEnabled|simulCloudDensity|simulCloudOcclusion|simulInClouds|simulWeatherSync|sin|size|sizeOf|skill|skillFinal|skipTime|sleep|sliderPosition|sliderRange|sliderSetPosition|sliderSetRange|sliderSetSpeed|sliderSpeed|slingLoadAssistantShown|soldierMagazines|someAmmo|sort|soundVolume|speaker|speed|speedMode|splitString|sqrt|squadParams|stance|startLoadingScreen|stop|stopEngineRTD|stopped|str|sunOrMoon|supportInfo|suppressFor|surfaceIsWater|surfaceNormal|surfaceType|swimInDepth|switchableUnits|switchAction|switchCamera|switchGesture|switchLight|switchMove|synchronizedObjects|synchronizedTriggers|synchronizedWaypoints|synchronizeObjectsAdd|synchronizeObjectsRemove|synchronizeTrigger|synchronizeWaypoint|systemChat|systemOfUnits|tan|targetKnowledge|targets|targetsAggregate|targetsQuery|taskAlwaysVisible|taskChildren|taskCompleted|taskCustomData|taskDescription|taskDestination|taskHint|taskMarkerOffset|taskNull|taskParent|taskResult|taskState|taskType|teamMember|teamMemberNull|teamName|teams|teamSwitch|teamSwitchEnabled|teamType|terminate|terrainIntersect|terrainIntersectASL|terrainIntersectAtASL|text|textLog|textLogFormat|tg|time|timeMultiplier|titleCut|titleFadeOut|titleObj|titleRsc|titleText|toArray|toFixed|toLower|toString|toUpper|triggerActivated|triggerActivation|triggerArea|triggerAttachedVehicle|triggerAttachObject|triggerAttachVehicle|triggerDynamicSimulation|triggerStatements|triggerText|triggerTimeout|triggerTimeoutCurrent|triggerType|turretLocal|turretOwner|turretUnit|tvAdd|tvClear|tvCollapse|tvCollapseAll|tvCount|tvCurSel|tvData|tvDelete|tvExpand|tvExpandAll|tvPicture|tvPictureRight|tvSetColor|tvSetCurSel|tvSetData|tvSetPicture|tvSetPictureColor|tvSetPictureColorDisabled|tvSetPictureColorSelected|tvSetPictureRight|tvSetPictureRightColor|tvSetPictureRightColorDisabled|tvSetPictureRightColorSelected|tvSetSelectColor|tvSetText|tvSetTooltip|tvSetValue|tvSort|tvSortByValue|tvText|tvTooltip|tvValue|type|typeName|typeOf|UAVControl|uiNamespace|uiSleep|unassignCurator|unassignItem|unassignTeam|unassignVehicle|underwater|uniform|uniformContainer|uniformItems|uniformMagazines|unitAddons|unitAimPosition|unitAimPositionVisual|unitBackpack|unitIsUAV|unitPos|unitReady|unitRecoilCoefficient|units|unitsBelowHeight|unlinkItem|unlockAchievement|unregisterTask|updateDrawIcon|updateMenuItem|updateObjectTree|useAIOperMapObstructionTest|useAISteeringComponent|useAudioTimeForMoves|userInputDisabled|vectorAdd|vectorCos|vectorCrossProduct|vectorDiff|vectorDir|vectorDirVisual|vectorDistance|vectorDistanceSqr|vectorDotProduct|vectorFromTo|vectorMagnitude|vectorMagnitudeSqr|vectorModelToWorld|vectorModelToWorldVisual|vectorMultiply|vectorNormalized|vectorUp|vectorUpVisual|vectorWorldToModel|vectorWorldToModelVisual|vehicle|vehicleCargoEnabled|vehicleChat|vehicleRadio|vehicleReceiveRemoteTargets|vehicleReportOwnPosition|vehicleReportRemoteTargets|vehicles|vehicleVarName|velocity|velocityModelSpace|verifySignature|vest|vestContainer|vestItems|vestMagazines|viewDistance|visibleCompass|visibleGPS|visibleMap|visiblePosition|visiblePositionASL|visibleScoretable|visibleWatch|waitUntil|waves|waypointAttachedObject|waypointAttachedVehicle|waypointAttachObject|waypointAttachVehicle|waypointBehaviour|waypointCombatMode|waypointCompletionRadius|waypointDescription|waypointForceBehaviour|waypointFormation|waypointHousePosition|waypointLoiterRadius|waypointLoiterType|waypointName|waypointPosition|waypoints|waypointScript|waypointsEnabledUAV|waypointShow|waypointSpeed|waypointStatements|waypointTimeout|waypointTimeoutCurrent|waypointType|waypointVisible|weaponAccessories|weaponAccessoriesCargo|weaponCargo|weaponDirection|weaponInertia|weaponLowered|weapons|weaponsItems|weaponsItemsCargo|weaponState|weaponsTurret|weightRTD|west|WFSideText|wind|windDir|windRTD|windStr|wingsForcesRTD|worldName|worldSize|worldToModel|worldToModelVisual|worldToScreen)\b/i,
        number: /(?:\$|\b0x)[\da-f]+\b|(?:\B\.\d+|\b\d+(?:\.\d+)?)(?:e[+-]?\d+)?\b/i,
        operator: /##|>>|&&|\|\||[!=<>]=?|[-+*/%#^]|\b(?:and|mod|not|or)\b/i,
        'magic-variable': {
            pattern: /\b(?:this|thisList|thisTrigger|_exception|_fnc_scriptName|_fnc_scriptNameParent|_forEachIndex|_this|_thisEventHandler|_thisFSM|_thisScript|_x)\b/i,
            alias: 'keyword'
        },
        constant: /\bDIK(?:_[a-z\d]+)+\b/i
    });
    Prism.languages.insertBefore('sqf', 'string', {
        macro: {
            pattern: /(^[ \t]*)#[a-z](?:[^\r\n\\]|\\(?:\r\n|[\s\S]))*/im,
            lookbehind: true,
            greedy: true,
            alias: 'property',
            inside: {
                directive: {
                    pattern: /#[a-z]+\b/i,
                    alias: 'keyword'
                },
                comment: Prism.languages.sqf.comment
            }
        }
    });
    delete Prism.languages.sqf['class-name'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$d0722eb1de37ae4c$export$2e2bcd8739ae039.displayName = 'squirrel';
$d0722eb1de37ae4c$export$2e2bcd8739ae039.aliases = [];
function $d0722eb1de37ae4c$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.squirrel = Prism.languages.extend('clike', {
        comment: [
            Prism.languages.clike['comment'][0],
            {
                pattern: /(^|[^\\:])(?:\/\/|#).*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(^|[^\\"'@])(?:@"(?:[^"]|"")*"(?!")|"(?:[^\\\r\n"]|\\.)*")/,
            lookbehind: true,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:class|enum|extends|instanceof)\s+)\w+(?:\.\w+)*/,
            lookbehind: true,
            inside: {
                punctuation: /\./
            }
        },
        keyword: /\b(?:__FILE__|__LINE__|base|break|case|catch|class|clone|const|constructor|continue|default|delete|else|enum|extends|for|foreach|function|if|in|instanceof|local|null|resume|return|static|switch|this|throw|try|typeof|while|yield)\b/,
        number: /\b(?:0x[0-9a-fA-F]+|\d+(?:\.(?:\d+|[eE][+-]?\d+))?)\b/,
        operator: /\+\+|--|<=>|<[-<]|>>>?|&&?|\|\|?|[-+*/%!=<>]=?|[~^]|::?/,
        punctuation: /[(){}\[\],;.]/
    });
    Prism.languages.insertBefore('squirrel', 'string', {
        char: {
            pattern: /(^|[^\\"'])'(?:[^\\']|\\(?:[xuU][0-9a-fA-F]{0,8}|[\s\S]))'/,
            lookbehind: true,
            greedy: true
        }
    });
    Prism.languages.insertBefore('squirrel', 'operator', {
        'attribute-punctuation': {
            pattern: /<\/|\/>/,
            alias: 'important'
        },
        lambda: {
            pattern: /@(?=\()/,
            alias: 'operator'
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $d11fe3812b565e9e$export$2e2bcd8739ae039.displayName = 'stan';
$d11fe3812b565e9e$export$2e2bcd8739ae039.aliases = [];
function $d11fe3812b565e9e$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // https://mc-stan.org/docs/2_28/reference-manual/bnf-grammars.html
        var higherOrderFunctions = /\b(?:algebra_solver|algebra_solver_newton|integrate_1d|integrate_ode|integrate_ode_bdf|integrate_ode_rk45|map_rect|ode_(?:adams|bdf|ckrk|rk45)(?:_tol)?|ode_adjoint_tol_ctl|reduce_sum|reduce_sum_static)\b/;
        Prism.languages.stan = {
            comment: /\/\/.*|\/\*[\s\S]*?\*\/|#(?!include).*/,
            string: {
                // String literals can contain spaces and any printable ASCII characters except for " and \
                // https://mc-stan.org/docs/2_24/reference-manual/print-statements-section.html#string-literals
                pattern: /"[\x20\x21\x23-\x5B\x5D-\x7E]*"/,
                greedy: true
            },
            directive: {
                pattern: /^([ \t]*)#include\b.*/m,
                lookbehind: true,
                alias: 'property'
            },
            'function-arg': {
                pattern: RegExp('(' + higherOrderFunctions.source + /\s*\(\s*/.source + ')' + /[a-zA-Z]\w*/.source),
                lookbehind: true,
                alias: 'function'
            },
            constraint: {
                pattern: /(\b(?:int|matrix|real|row_vector|vector)\s*)<[^<>]*>/,
                lookbehind: true,
                inside: {
                    expression: {
                        pattern: /(=\s*)\S(?:\S|\s+(?!\s))*?(?=\s*(?:>$|,\s*\w+\s*=))/,
                        lookbehind: true,
                        inside: null // see below
                    },
                    property: /\b[a-z]\w*(?=\s*=)/i,
                    operator: /=/,
                    punctuation: /^<|>$|,/
                }
            },
            keyword: [
                {
                    pattern: /\bdata(?=\s*\{)|\b(?:functions|generated|model|parameters|quantities|transformed)\b/,
                    alias: 'program-block'
                },
                /\b(?:array|break|cholesky_factor_corr|cholesky_factor_cov|complex|continue|corr_matrix|cov_matrix|data|else|for|if|in|increment_log_prob|int|matrix|ordered|positive_ordered|print|real|reject|return|row_vector|simplex|target|unit_vector|vector|void|while)\b/,
                // these are functions that are known to take another function as their first argument.
                higherOrderFunctions
            ],
            function: /\b[a-z]\w*(?=\s*\()/i,
            number: /(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:E[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
            boolean: /\b(?:false|true)\b/,
            operator: /<-|\.[*/]=?|\|\|?|&&|[!=<>+\-*/]=?|['^%~?:]/,
            punctuation: /[()\[\]{},;]/
        };
        Prism.languages.stan.constraint.inside.expression.inside = Prism.languages.stan;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 


$b9bd6ce061e8b23b$export$2e2bcd8739ae039.displayName = 'stata';
$b9bd6ce061e8b23b$export$2e2bcd8739ae039.aliases = [];
function $b9bd6ce061e8b23b$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $49817f5fa65142f2$export$2e2bcd8739ae039));
    Prism.register((0, $7306ed74be230ce9$export$2e2bcd8739ae039));
    Prism.register((0, $4c79b618a588b28d$export$2e2bcd8739ae039));
    // https://www.stata.com/manuals/u.pdf
    // https://www.stata.com/manuals/p.pdf
    Prism.languages.stata = {
        comment: [
            {
                pattern: /(^[ \t]*)\*.*/m,
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|\s)\/\/.*|\/\*[\s\S]*?\*\//,
                lookbehind: true,
                greedy: true
            }
        ],
        'string-literal': {
            pattern: /"[^"\r\n]*"|[‘`']".*?"[’`']/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /\$\{[^{}]*\}|[‘`']\w[^’`'\r\n]*[’`']/,
                    inside: {
                        punctuation: /^\$\{|\}$/,
                        expression: {
                            pattern: /[\s\S]+/,
                            inside: null // see below
                        }
                    }
                },
                string: /[\s\S]+/
            }
        },
        mata: {
            pattern: /(^[ \t]*mata[ \t]*:)[\s\S]+?(?=^end\b)/m,
            lookbehind: true,
            greedy: true,
            alias: 'language-mata',
            inside: Prism.languages.mata
        },
        java: {
            pattern: /(^[ \t]*java[ \t]*:)[\s\S]+?(?=^end\b)/m,
            lookbehind: true,
            greedy: true,
            alias: 'language-java',
            inside: Prism.languages.java
        },
        python: {
            pattern: /(^[ \t]*python[ \t]*:)[\s\S]+?(?=^end\b)/m,
            lookbehind: true,
            greedy: true,
            alias: 'language-python',
            inside: Prism.languages.python
        },
        command: {
            pattern: /(^[ \t]*(?:\.[ \t]+)?(?:(?:bayes|bootstrap|by|bysort|capture|collect|fmm|fp|frame|jackknife|mfp|mi|nestreg|noisily|permute|quietly|rolling|simulate|statsby|stepwise|svy|version|xi)\b[^:\r\n]*:[ \t]*|(?:capture|noisily|quietly|version)[ \t]+)?)[a-zA-Z]\w*/m,
            lookbehind: true,
            greedy: true,
            alias: 'keyword'
        },
        variable: /\$\w+|[‘`']\w[^’`'\r\n]*[’`']/,
        keyword: /\b(?:bayes|bootstrap|by|bysort|capture|clear|collect|fmm|fp|frame|if|in|jackknife|mi[ \t]+estimate|mfp|nestreg|noisily|of|permute|quietly|rolling|simulate|sort|statsby|stepwise|svy|varlist|version|xi)\b/,
        boolean: /\b(?:off|on)\b/,
        number: /\b\d+(?:\.\d+)?\b|\B\.\d+/,
        function: /\b[a-z_]\w*(?=\()/i,
        operator: /\+\+|--|##?|[<>!=~]=?|[+\-*^&|/]/,
        punctuation: /[(){}[\],:]/
    };
    Prism.languages.stata['string-literal'].inside.interpolation.inside.expression.inside = Prism.languages.stata;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $9f8d1abaebbe1e7b$export$2e2bcd8739ae039.displayName = 'iecst';
$9f8d1abaebbe1e7b$export$2e2bcd8739ae039.aliases = [];
function $9f8d1abaebbe1e7b$export$2e2bcd8739ae039(Prism) {
    Prism.languages.iecst = {
        comment: [
            {
                pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\(\*[\s\S]*?(?:\*\)|$)|\{[\s\S]*?(?:\}|$))/,
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        keyword: [
            /\b(?:END_)?(?:PROGRAM|CONFIGURATION|INTERFACE|FUNCTION_BLOCK|FUNCTION|ACTION|TRANSITION|TYPE|STRUCT|(?:INITIAL_)?STEP|NAMESPACE|LIBRARY|CHANNEL|FOLDER|RESOURCE|VAR_(?:ACCESS|CONFIG|EXTERNAL|GLOBAL|INPUT|IN_OUT|OUTPUT|TEMP)|VAR|METHOD|PROPERTY)\b/i,
            /\b(?:AT|BY|(?:END_)?(?:CASE|FOR|IF|REPEAT|WHILE)|CONSTANT|CONTINUE|DO|ELSE|ELSIF|EXIT|EXTENDS|FROM|GET|GOTO|IMPLEMENTS|JMP|NON_RETAIN|OF|PRIVATE|PROTECTED|PUBLIC|RETAIN|RETURN|SET|TASK|THEN|TO|UNTIL|USING|WITH|__CATCH|__ENDTRY|__FINALLY|__TRY)\b/
        ],
        'class-name': /\b(?:ANY|ARRAY|BOOL|BYTE|U?(?:D|L|S)?INT|(?:D|L)?WORD|DATE(?:_AND_TIME)?|DT|L?REAL|POINTER|STRING|TIME(?:_OF_DAY)?|TOD)\b/,
        address: {
            pattern: /%[IQM][XBWDL][\d.]*|%[IQ][\d.]*/,
            alias: 'symbol'
        },
        number: /\b(?:16#[\da-f]+|2#[01_]+|0x[\da-f]+)\b|\b(?:D|DT|T|TOD)#[\d_shmd:]*|\b[A-Z]*#[\d.,_]*|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
        boolean: /\b(?:FALSE|NULL|TRUE)\b/,
        operator: /S?R?:?=>?|&&?|\*\*?|<[=>]?|>=?|[-:^/+#]|\b(?:AND|EQ|EXPT|GE|GT|LE|LT|MOD|NE|NOT|OR|XOR)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        punctuation: /[()[\].,;]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $352108f0900288bc$export$2e2bcd8739ae039.displayName = 'supercollider';
$352108f0900288bc$export$2e2bcd8739ae039.aliases = [
    'sclang'
];
function $352108f0900288bc$export$2e2bcd8739ae039(Prism) {
    Prism.languages.supercollider = {
        comment: {
            pattern: /\/\/.*|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\//,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])"(?:[^"\\]|\\[\s\S])*"/,
            lookbehind: true,
            greedy: true
        },
        char: {
            pattern: /\$(?:[^\\\r\n]|\\.)/,
            greedy: true
        },
        symbol: {
            pattern: /(^|[^\\])'(?:[^'\\]|\\[\s\S])*'|\\\w+/,
            lookbehind: true,
            greedy: true
        },
        keyword: /\b(?:_|arg|classvar|const|nil|var|while)\b/,
        boolean: /\b(?:false|true)\b/,
        label: {
            pattern: /\b[a-z_]\w*(?=\s*:)/,
            alias: 'property'
        },
        number: /\b(?:inf|pi|0x[0-9a-fA-F]+|\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(?:pi)?|\d+r[0-9a-zA-Z]+(?:\.[0-9a-zA-Z]+)?|\d+[sb]{1,4}\d*)\b/,
        'class-name': /\b[A-Z]\w*\b/,
        operator: /\.{2,3}|#(?![[{])|&&|[!=]==?|\+>>|\+{1,3}|-[->]|=>|>>|\?\?|@\|?@|\|(?:@|[!=]=)?\||!\?|<[!=>]|\*{1,2}|<{2,3}\*?|[-!%&/<>?@|=`]/,
        punctuation: /[{}()[\].:,;]|#[[{]/
    };
    Prism.languages.sclang = Prism.languages.supercollider;
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $f6357e1d35f66b04$export$2e2bcd8739ae039.displayName = 'systemd';
$f6357e1d35f66b04$export$2e2bcd8739ae039.aliases = [];
function $f6357e1d35f66b04$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var comment = {
            pattern: /^[;#].*/m,
            greedy: true
        };
        var quotesSource = /"(?:[^\r\n"\\]|\\(?:[^\r]|\r\n?))*"(?!\S)/.source;
        Prism.languages.systemd = {
            comment: comment,
            section: {
                pattern: /^\[[^\n\r\[\]]*\](?=[ \t]*$)/m,
                greedy: true,
                inside: {
                    punctuation: /^\[|\]$/,
                    'section-name': {
                        pattern: /[\s\S]+/,
                        alias: 'selector'
                    }
                }
            },
            key: {
                pattern: /^[^\s=]+(?=[ \t]*=)/m,
                greedy: true,
                alias: 'attr-name'
            },
            value: {
                // This pattern is quite complex because of two properties:
                //  1) Quotes (strings) must be preceded by a space. Since we can't use lookbehinds, we have to "resolve"
                //     the lookbehind. You will see this in the main loop where spaces are handled separately.
                //  2) Line continuations.
                //     After line continuations, empty lines and comments are ignored so we have to consume them.
                pattern: RegExp(/(=[ \t]*(?!\s))/.source + // the value either starts with quotes or not
                '(?:' + quotesSource + '|(?=[^"\r\n]))' + // main loop
                '(?:' + (/[^\s\\]/.source + // handle spaces separately because of quotes
                '|' + '[ \t]+(?:(?![ \t"])|' + quotesSource + ')' + // line continuation
                '|' + /\\[\r\n]+(?:[#;].*[\r\n]+)*(?![#;])/.source) + ')*'),
                lookbehind: true,
                greedy: true,
                alias: 'attr-value',
                inside: {
                    comment: comment,
                    quoted: {
                        pattern: RegExp(/(^|\s)/.source + quotesSource),
                        lookbehind: true,
                        greedy: true
                    },
                    punctuation: /\\$/m,
                    boolean: {
                        pattern: /^(?:false|no|off|on|true|yes)$/,
                        greedy: true
                    }
                }
            },
            punctuation: /=/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $cf1be131e0fce4fa$export$2e2bcd8739ae039.displayName = 't4-templating';
$cf1be131e0fce4fa$export$2e2bcd8739ae039.aliases = [];
function $cf1be131e0fce4fa$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        function createBlock(prefix, inside, contentAlias) {
            return {
                pattern: RegExp('<#' + prefix + '[\\s\\S]*?#>'),
                alias: 'block',
                inside: {
                    delimiter: {
                        pattern: RegExp('^<#' + prefix + '|#>$'),
                        alias: 'important'
                    },
                    content: {
                        pattern: /[\s\S]+/,
                        inside: inside,
                        alias: contentAlias
                    }
                }
            };
        }
        function createT4(insideLang) {
            var grammar = Prism.languages[insideLang];
            var className = 'language-' + insideLang;
            return {
                block: {
                    pattern: /<#[\s\S]+?#>/,
                    inside: {
                        directive: createBlock('@', {
                            'attr-value': {
                                pattern: /=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+)/,
                                inside: {
                                    punctuation: /^=|^["']|["']$/
                                }
                            },
                            keyword: /\b\w+(?=\s)/,
                            'attr-name': /\b\w+/
                        }),
                        expression: createBlock('=', grammar, className),
                        'class-feature': createBlock('\\+', grammar, className),
                        standard: createBlock('', grammar, className)
                    }
                }
            };
        }
        Prism.languages['t4-templating'] = Object.defineProperty({}, 'createT4', {
            value: createT4
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$059ad53228ded3c9$export$2e2bcd8739ae039.displayName = 't4-cs';
$059ad53228ded3c9$export$2e2bcd8739ae039.aliases = [
    't4'
];
function $059ad53228ded3c9$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $803928922a6961a4$export$2e2bcd8739ae039));
    Prism.register((0, $cf1be131e0fce4fa$export$2e2bcd8739ae039));
    Prism.languages.t4 = Prism.languages['t4-cs'] = Prism.languages['t4-templating'].createT4('csharp');
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$0acbc38df3a79135$export$2e2bcd8739ae039.displayName = 't4-vb';
$0acbc38df3a79135$export$2e2bcd8739ae039.aliases = [];
function $0acbc38df3a79135$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $cf1be131e0fce4fa$export$2e2bcd8739ae039));
    Prism.register((0, $74f53190c8211cce$export$2e2bcd8739ae039));
    Prism.languages['t4-vb'] = Prism.languages['t4-templating'].createT4('vbnet');
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$3b31713a87a8de6a$export$2e2bcd8739ae039.displayName = 'tap';
$3b31713a87a8de6a$export$2e2bcd8739ae039.aliases = [];
function $3b31713a87a8de6a$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $1da2260b608e55ec$export$2e2bcd8739ae039));
    // https://en.wikipedia.org/wiki/Test_Anything_Protocol
    Prism.languages.tap = {
        fail: /not ok[^#{\n\r]*/,
        pass: /ok[^#{\n\r]*/,
        pragma: /pragma [+-][a-z]+/,
        bailout: /bail out!.*/i,
        version: /TAP version \d+/i,
        plan: /\b\d+\.\.\d+(?: +#.*)?/,
        subtest: {
            pattern: /# Subtest(?:: .*)?/,
            greedy: true
        },
        punctuation: /[{}]/,
        directive: /#.*/,
        yamlish: {
            pattern: /(^[ \t]*)---[\s\S]*?[\r\n][ \t]*\.\.\.$/m,
            lookbehind: true,
            inside: Prism.languages.yaml,
            alias: 'language-yaml'
        }
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $735a787ca1f7aae4$export$2e2bcd8739ae039.displayName = 'tcl';
$735a787ca1f7aae4$export$2e2bcd8739ae039.aliases = [];
function $735a787ca1f7aae4$export$2e2bcd8739ae039(Prism) {
    Prism.languages.tcl = {
        comment: {
            pattern: /(^|[^\\])#.*/,
            lookbehind: true
        },
        string: {
            pattern: /"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*"/,
            greedy: true
        },
        variable: [
            {
                pattern: /(\$)(?:::)?(?:[a-zA-Z0-9]+::)*\w+/,
                lookbehind: true
            },
            {
                pattern: /(\$)\{[^}]+\}/,
                lookbehind: true
            },
            {
                pattern: /(^[\t ]*set[ \t]+)(?:::)?(?:[a-zA-Z0-9]+::)*\w+/m,
                lookbehind: true
            }
        ],
        function: {
            pattern: /(^[\t ]*proc[ \t]+)\S+/m,
            lookbehind: true
        },
        builtin: [
            {
                pattern: /(^[\t ]*)(?:break|class|continue|error|eval|exit|for|foreach|if|proc|return|switch|while)\b/m,
                lookbehind: true
            },
            /\b(?:else|elseif)\b/
        ],
        scope: {
            pattern: /(^[\t ]*)(?:global|upvar|variable)\b/m,
            lookbehind: true,
            alias: 'constant'
        },
        keyword: {
            pattern: /(^[\t ]*|\[)(?:Safe_Base|Tcl|after|append|apply|array|auto_(?:execok|import|load|mkindex|qualify|reset)|automkindex_old|bgerror|binary|catch|cd|chan|clock|close|concat|dde|dict|encoding|eof|exec|expr|fblocked|fconfigure|fcopy|file(?:event|name)?|flush|gets|glob|history|http|incr|info|interp|join|lappend|lassign|lindex|linsert|list|llength|load|lrange|lrepeat|lreplace|lreverse|lsearch|lset|lsort|math(?:func|op)|memory|msgcat|namespace|open|package|parray|pid|pkg_mkIndex|platform|puts|pwd|re_syntax|read|refchan|regexp|registry|regsub|rename|scan|seek|set|socket|source|split|string|subst|tcl(?:_endOfWord|_findLibrary|startOf(?:Next|Previous)Word|test|vars|wordBreak(?:After|Before))|tell|time|tm|trace|unknown|unload|unset|update|uplevel|vwait)\b/m,
            lookbehind: true
        },
        operator: /!=?|\*\*?|==|&&?|\|\|?|<[=<]?|>[=>]?|[-+~\/%?^]|\b(?:eq|in|ne|ni)\b/,
        punctuation: /[{}()\[\]]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$38e9da697ee0f6f7$export$2e2bcd8739ae039.displayName = 'tt2';
$38e9da697ee0f6f7$export$2e2bcd8739ae039.aliases = [];
function $38e9da697ee0f6f7$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.tt2 = Prism.languages.extend('clike', {
            comment: /#.*|\[%#[\s\S]*?%\]/,
            keyword: /\b(?:BLOCK|CALL|CASE|CATCH|CLEAR|DEBUG|DEFAULT|ELSE|ELSIF|END|FILTER|FINAL|FOREACH|GET|IF|IN|INCLUDE|INSERT|LAST|MACRO|META|NEXT|PERL|PROCESS|RAWPERL|RETURN|SET|STOP|SWITCH|TAGS|THROW|TRY|UNLESS|USE|WHILE|WRAPPER)\b/,
            punctuation: /[[\]{},()]/
        });
        Prism.languages.insertBefore('tt2', 'number', {
            operator: /=[>=]?|!=?|<=?|>=?|&&|\|\|?|\b(?:and|not|or)\b/,
            variable: {
                pattern: /\b[a-z]\w*(?:\s*\.\s*(?:\d+|\$?[a-z]\w*))*\b/i
            }
        });
        Prism.languages.insertBefore('tt2', 'keyword', {
            delimiter: {
                pattern: /^(?:\[%|%%)-?|-?%\]$/,
                alias: 'punctuation'
            }
        });
        Prism.languages.insertBefore('tt2', 'string', {
            'single-quoted-string': {
                pattern: /'[^\\']*(?:\\[\s\S][^\\']*)*'/,
                greedy: true,
                alias: 'string'
            },
            'double-quoted-string': {
                pattern: /"[^\\"]*(?:\\[\s\S][^\\"]*)*"/,
                greedy: true,
                alias: 'string',
                inside: {
                    variable: {
                        pattern: /\$(?:[a-z]\w*(?:\.(?:\d+|\$?[a-z]\w*))*)/i
                    }
                }
            }
        });
        // The different types of TT2 strings "replace" the C-like standard string
        delete Prism.languages.tt2.string;
        Prism.hooks.add('before-tokenize', function(env) {
            var tt2Pattern = /\[%[\s\S]+?%\]/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'tt2', tt2Pattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'tt2');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $00d1fd220eb25cf1$export$2e2bcd8739ae039.displayName = 'toml';
$00d1fd220eb25cf1$export$2e2bcd8739ae039.aliases = [];
function $00d1fd220eb25cf1$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var key = /(?:[\w-]+|'[^'\n\r]*'|"(?:\\.|[^\\"\r\n])*")/.source;
        /**
     * @param {string} pattern
     */ function insertKey(pattern) {
            return pattern.replace(/__/g, function() {
                return key;
            });
        }
        Prism.languages.toml = {
            comment: {
                pattern: /#.*/,
                greedy: true
            },
            table: {
                pattern: RegExp(insertKey(/(^[\t ]*\[\s*(?:\[\s*)?)__(?:\s*\.\s*__)*(?=\s*\])/.source), 'm'),
                lookbehind: true,
                greedy: true,
                alias: 'class-name'
            },
            key: {
                pattern: RegExp(insertKey(/(^[\t ]*|[{,]\s*)__(?:\s*\.\s*__)*(?=\s*=)/.source), 'm'),
                lookbehind: true,
                greedy: true,
                alias: 'property'
            },
            string: {
                pattern: /"""(?:\\[\s\S]|[^\\])*?"""|'''[\s\S]*?'''|'[^'\n\r]*'|"(?:\\.|[^\\"\r\n])*"/,
                greedy: true
            },
            date: [
                {
                    // Offset Date-Time, Local Date-Time, Local Date
                    pattern: /\b\d{4}-\d{2}-\d{2}(?:[T\s]\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?)?\b/i,
                    alias: 'number'
                },
                {
                    // Local Time
                    pattern: /\b\d{2}:\d{2}:\d{2}(?:\.\d+)?\b/,
                    alias: 'number'
                }
            ],
            number: /(?:\b0(?:x[\da-zA-Z]+(?:_[\da-zA-Z]+)*|o[0-7]+(?:_[0-7]+)*|b[10]+(?:_[10]+)*))\b|[-+]?\b\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?\b|[-+]?\b(?:inf|nan)\b/,
            boolean: /\b(?:false|true)\b/,
            punctuation: /[.,=[\]{}]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $9f2f0d409f6bf608$export$2e2bcd8739ae039.displayName = 'tremor';
$9f2f0d409f6bf608$export$2e2bcd8739ae039.aliases = [
    'trickle',
    'troy'
];
function $9f2f0d409f6bf608$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.tremor = {
            comment: {
                pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
                lookbehind: true
            },
            'interpolated-string': null,
            // see below
            extractor: {
                pattern: /\b[a-z_]\w*\|(?:[^\r\n\\|]|\\(?:\r\n|[\s\S]))*\|/i,
                greedy: true,
                inside: {
                    regex: {
                        pattern: /(^re)\|[\s\S]+/,
                        lookbehind: true
                    },
                    function: /^\w+/,
                    value: /\|[\s\S]+/
                }
            },
            identifier: {
                pattern: /`[^`]*`/,
                greedy: true
            },
            function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())\b/,
            keyword: /\b(?:args|as|by|case|config|connect|connector|const|copy|create|default|define|deploy|drop|each|emit|end|erase|event|flow|fn|for|from|group|having|insert|into|intrinsic|let|links|match|merge|mod|move|of|operator|patch|pipeline|recur|script|select|set|sliding|state|stream|to|tumbling|update|use|when|where|window|with)\b/,
            boolean: /\b(?:false|null|true)\b/i,
            number: /\b(?:0b[01_]*|0x[0-9a-fA-F_]*|\d[\d_]*(?:\.\d[\d_]*)?(?:[Ee][+-]?[\d_]+)?)\b/,
            'pattern-punctuation': {
                pattern: /%(?=[({[])/,
                alias: 'punctuation'
            },
            operator: /[-+*\/%~!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?>?=?|(?:absent|and|not|or|present|xor)\b/,
            punctuation: /::|[;\[\]()\{\},.:]/
        };
        var interpolationPattern = /#\{(?:[^"{}]|\{[^{}]*\}|"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*")*\}/.source;
        Prism.languages.tremor['interpolated-string'] = {
            pattern: RegExp(/(^|[^\\])/.source + '(?:' + '"""(?:' + /[^"\\#]|\\[\s\S]|"(?!"")|#(?!\{)/.source + '|' + interpolationPattern + ')*"""' + '|' + '"(?:' + /[^"\\\r\n#]|\\(?:\r\n|[\s\S])|#(?!\{)/.source + '|' + interpolationPattern + ')*"' + ')'),
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: RegExp(interpolationPattern),
                    inside: {
                        punctuation: /^#\{|\}$/,
                        expression: {
                            pattern: /[\s\S]+/,
                            inside: Prism.languages.tremor
                        }
                    }
                },
                string: /[\s\S]+/
            }
        };
        Prism.languages.troy = Prism.languages['tremor'];
        Prism.languages.trickle = Prism.languages['tremor'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $91f9e56f191bfd66$export$2e2bcd8739ae039.displayName = 'typoscript';
$91f9e56f191bfd66$export$2e2bcd8739ae039.aliases = [
    'tsconfig'
];
function $91f9e56f191bfd66$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var keywords = /\b(?:ACT|ACTIFSUB|CARRAY|CASE|CLEARGIF|COA|COA_INT|CONSTANTS|CONTENT|CUR|EDITPANEL|EFFECT|EXT|FILE|FLUIDTEMPLATE|FORM|FRAME|FRAMESET|GIFBUILDER|GMENU|GMENU_FOLDOUT|GMENU_LAYERS|GP|HMENU|HRULER|HTML|IENV|IFSUB|IMAGE|IMGMENU|IMGMENUITEM|IMGTEXT|IMG_RESOURCE|INCLUDE_TYPOSCRIPT|JSMENU|JSMENUITEM|LLL|LOAD_REGISTER|NO|PAGE|RECORDS|RESTORE_REGISTER|TEMPLATE|TEXT|TMENU|TMENUITEM|TMENU_LAYERS|USER|USER_INT|_GIFBUILDER|global|globalString|globalVar)\b/;
        Prism.languages.typoscript = {
            comment: [
                {
                    // multiline comments /* */
                    pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                    lookbehind: true
                },
                {
                    // double-slash comments - ignored when backslashes or colon is found in front
                    // also ignored whenever directly after an equal-sign, because it would probably be an url without protocol
                    pattern: /(^|[^\\:= \t]|(?:^|[^= \t])[ \t]+)\/\/.*/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    // hash comments - ignored when leading quote is found for hex colors in strings
                    pattern: /(^|[^"'])#.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            function: [
                {
                    // old include style
                    pattern: /<INCLUDE_TYPOSCRIPT:\s*source\s*=\s*(?:"[^"\r\n]*"|'[^'\r\n]*')\s*>/,
                    inside: {
                        string: {
                            pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
                            inside: {
                                keyword: keywords
                            }
                        },
                        keyword: {
                            pattern: /INCLUDE_TYPOSCRIPT/
                        }
                    }
                },
                {
                    // new include style
                    pattern: /@import\s*(?:"[^"\r\n]*"|'[^'\r\n]*')/,
                    inside: {
                        string: /"[^"\r\n]*"|'[^'\r\n]*'/
                    }
                }
            ],
            string: {
                pattern: /^([^=]*=[< ]?)(?:(?!\]\n).)*/,
                lookbehind: true,
                inside: {
                    function: /\{\$.*\}/,
                    // constants include
                    keyword: keywords,
                    number: /^\d+$/,
                    punctuation: /[,|:]/
                }
            },
            keyword: keywords,
            number: {
                // special highlighting for indexes of arrays in tags
                pattern: /\b\d+\s*[.{=]/,
                inside: {
                    operator: /[.{=]/
                }
            },
            tag: {
                pattern: /\.?[-\w\\]+\.?/,
                inside: {
                    punctuation: /\./
                }
            },
            punctuation: /[{}[\];(),.:|]/,
            operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/
        };
        Prism.languages.tsconfig = Prism.languages.typoscript;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $d826ce7b7a227512$export$2e2bcd8739ae039.displayName = 'unrealscript';
$d826ce7b7a227512$export$2e2bcd8739ae039.aliases = [
    'uc',
    'uscript'
];
function $d826ce7b7a227512$export$2e2bcd8739ae039(Prism) {
    Prism.languages.unrealscript = {
        comment: /\/\/.*|\/\*[\s\S]*?\*\//,
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        category: {
            pattern: /(\b(?:(?:autoexpand|hide|show)categories|var)\s*\()[^()]+(?=\))/,
            lookbehind: true,
            greedy: true,
            alias: 'property'
        },
        metadata: {
            pattern: /(\w\s*)<\s*\w+\s*=[^<>|=\r\n]+(?:\|\s*\w+\s*=[^<>|=\r\n]+)*>/,
            lookbehind: true,
            greedy: true,
            inside: {
                property: /\b\w+(?=\s*=)/,
                operator: /=/,
                punctuation: /[<>|]/
            }
        },
        macro: {
            pattern: /`\w+/,
            alias: 'property'
        },
        'class-name': {
            pattern: /(\b(?:class|enum|extends|interface|state(?:\(\))?|struct|within)\s+)\w+/,
            lookbehind: true
        },
        keyword: /\b(?:abstract|actor|array|auto|autoexpandcategories|bool|break|byte|case|class|classgroup|client|coerce|collapsecategories|config|const|continue|default|defaultproperties|delegate|dependson|deprecated|do|dontcollapsecategories|editconst|editinlinenew|else|enum|event|exec|export|extends|final|float|for|forcescriptorder|foreach|function|goto|guid|hidecategories|hidedropdown|if|ignores|implements|inherits|input|int|interface|iterator|latent|local|material|name|native|nativereplication|noexport|nontransient|noteditinlinenew|notplaceable|operator|optional|out|pawn|perobjectconfig|perobjectlocalized|placeable|postoperator|preoperator|private|protected|reliable|replication|return|server|showcategories|simulated|singular|state|static|string|struct|structdefault|structdefaultproperties|switch|texture|transient|travel|unreliable|until|var|vector|while|within)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        boolean: /\b(?:false|true)\b/,
        number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
        // https://docs.unrealengine.com/udk/Three/UnrealScriptExpressions.html
        operator: />>|<<|--|\+\+|\*\*|[-+*/~!=<>$@]=?|&&?|\|\|?|\^\^?|[?:%]|\b(?:ClockwiseFrom|Cross|Dot)\b/,
        punctuation: /[()[\]{};,.]/
    };
    Prism.languages.uc = Prism.languages.uscript = Prism.languages.unrealscript;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $e2afbfabfe840b99$export$2e2bcd8739ae039.displayName = 'uorazor';
$e2afbfabfe840b99$export$2e2bcd8739ae039.aliases = [];
function $e2afbfabfe840b99$export$2e2bcd8739ae039(Prism) {
    Prism.languages.uorazor = {
        'comment-hash': {
            pattern: /#.*/,
            alias: 'comment',
            greedy: true
        },
        'comment-slash': {
            pattern: /\/\/.*/,
            alias: 'comment',
            greedy: true
        },
        string: {
            pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            inside: {
                punctuation: /^['"]|['"]$/
            },
            greedy: true
        },
        'source-layers': {
            pattern: /\b(?:arms|backpack|blue|bracelet|cancel|clear|cloak|criminal|earrings|enemy|facialhair|friend|friendly|gloves|gray|grey|ground|hair|head|innerlegs|innertorso|innocent|lefthand|middletorso|murderer|neck|nonfriendly|onehandedsecondary|outerlegs|outertorso|pants|red|righthand|ring|self|shirt|shoes|talisman|waist)\b/i,
            alias: 'function'
        },
        'source-commands': {
            pattern: /\b(?:alliance|attack|cast|clearall|clearignore|clearjournal|clearlist|clearsysmsg|createlist|createtimer|dclick|dclicktype|dclickvar|dress|dressconfig|drop|droprelloc|emote|getlabel|guild|gumpclose|gumpresponse|hotkey|ignore|lasttarget|lift|lifttype|menu|menuresponse|msg|org|organize|organizer|overhead|pause|poplist|potion|promptresponse|pushlist|removelist|removetimer|rename|restock|say|scav|scavenger|script|setability|setlasttarget|setskill|settimer|setvar|sysmsg|target|targetloc|targetrelloc|targettype|undress|unignore|unsetvar|useobject|useonce|useskill|usetype|virtue|wait|waitforgump|waitformenu|waitforprompt|waitforstat|waitforsysmsg|waitfortarget|walk|wfsysmsg|wft|whisper|yell)\b/,
            alias: 'function'
        },
        'tag-name': {
            pattern: /(^\{%-?\s*)\w+/,
            lookbehind: true,
            alias: 'keyword'
        },
        delimiter: {
            pattern: /^\{[{%]-?|-?[%}]\}$/,
            alias: 'punctuation'
        },
        function: /\b(?:atlist|close|closest|count|counter|counttype|dead|dex|diffhits|diffmana|diffstam|diffweight|find|findbuff|finddebuff|findlayer|findtype|findtypelist|followers|gumpexists|hidden|hits|hp|hue|human|humanoid|ingump|inlist|insysmessage|insysmsg|int|invul|lhandempty|list|listexists|mana|maxhits|maxhp|maxmana|maxstam|maxweight|monster|mounted|name|next|noto|paralyzed|poisoned|position|prev|previous|queued|rand|random|rhandempty|skill|stam|str|targetexists|timer|timerexists|varexist|warmode|weight)\b/,
        keyword: /\b(?:and|as|break|continue|else|elseif|endfor|endif|endwhile|for|if|loop|not|or|replay|stop|while)\b/,
        boolean: /\b(?:false|null|true)\b/,
        number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
        operator: [
            {
                pattern: /(\s)(?:and|b-and|b-or|b-xor|ends with|in|is|matches|not|or|same as|starts with)(?=\s)/,
                lookbehind: true
            },
            /[=<>]=?|!=|\*\*?|\/\/?|\?:?|[-+~%|]/
        ],
        punctuation: /[()\[\]{}:.,]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$8548b6b81abd0793$export$2e2bcd8739ae039.displayName = 'v';
$8548b6b81abd0793$export$2e2bcd8739ae039.aliases = [];
function $8548b6b81abd0793$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    (function(Prism) {
        var interpolationExpr = {
            pattern: /[\s\S]+/,
            inside: null
        };
        Prism.languages.v = Prism.languages.extend('clike', {
            string: {
                pattern: /r?(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
                alias: 'quoted-string',
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\{[^{}]*\}|\w+(?:\.\w+(?:\([^\(\)]*\))?|\[[^\[\]]+\])*)/,
                        lookbehind: true,
                        inside: {
                            'interpolation-variable': {
                                pattern: /^\$\w[\s\S]*$/,
                                alias: 'variable'
                            },
                            'interpolation-punctuation': {
                                pattern: /^\$\{|\}$/,
                                alias: 'punctuation'
                            },
                            'interpolation-expression': interpolationExpr
                        }
                    }
                }
            },
            'class-name': {
                pattern: /(\b(?:enum|interface|struct|type)\s+)(?:C\.)?\w+/,
                lookbehind: true
            },
            keyword: /(?:\b(?:__global|as|asm|assert|atomic|break|chan|const|continue|defer|else|embed|enum|fn|for|go(?:to)?|if|import|in|interface|is|lock|match|module|mut|none|or|pub|return|rlock|select|shared|sizeof|static|struct|type(?:of)?|union|unsafe)|\$(?:else|for|if)|#(?:flag|include))\b/,
            number: /\b(?:0x[a-f\d]+(?:_[a-f\d]+)*|0b[01]+(?:_[01]+)*|0o[0-7]+(?:_[0-7]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?)\b/i,
            operator: /~|\?|[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\.?/,
            builtin: /\b(?:any(?:_float|_int)?|bool|byte(?:ptr)?|charptr|f(?:32|64)|i(?:8|16|64|128|nt)|rune|size_t|string|u(?:16|32|64|128)|voidptr)\b/
        });
        interpolationExpr.inside = Prism.languages.v;
        Prism.languages.insertBefore('v', 'string', {
            char: {
                pattern: /`(?:\\`|\\?[^`]{1,2})`/,
                // using {1,2} instead of `u` flag for compatibility
                alias: 'rune'
            }
        });
        Prism.languages.insertBefore('v', 'operator', {
            attribute: {
                pattern: /(^[\t ]*)\[(?:deprecated|direct_array_access|flag|inline|live|ref_only|typedef|unsafe_fn|windows_stdcall)\]/m,
                lookbehind: true,
                alias: 'annotation',
                inside: {
                    punctuation: /[\[\]]/,
                    keyword: /\w+/
                }
            },
            generic: {
                pattern: /<\w+>(?=\s*[\)\{])/,
                inside: {
                    punctuation: /[<>]/,
                    'class-name': /\w+/
                }
            }
        });
        Prism.languages.insertBefore('v', 'function', {
            'generic-function': {
                // e.g. foo<T>( ...
                pattern: /\b\w+\s*<\w+>(?=\()/,
                inside: {
                    function: /^\w+/,
                    generic: {
                        pattern: /<\w+>/,
                        inside: Prism.languages.v.generic.inside
                    }
                }
            }
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$9abdb5de274a074a$export$2e2bcd8739ae039.displayName = 'vala';
$9abdb5de274a074a$export$2e2bcd8739ae039.aliases = [];
function $9abdb5de274a074a$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.vala = Prism.languages.extend('clike', {
        // Classes copied from prism-csharp
        'class-name': [
            {
                // (Foo bar, Bar baz)
                pattern: /\b[A-Z]\w*(?:\.\w+)*\b(?=(?:\?\s+|\*?\s+\*?)\w)/,
                inside: {
                    punctuation: /\./
                }
            },
            {
                // [Foo]
                pattern: /(\[)[A-Z]\w*(?:\.\w+)*\b/,
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            },
            {
                // class Foo : Bar
                pattern: /(\b(?:class|interface)\s+[A-Z]\w*(?:\.\w+)*\s*:\s*)[A-Z]\w*(?:\.\w+)*\b/,
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            },
            {
                // class Foo
                pattern: /((?:\b(?:class|enum|interface|new|struct)\s+)|(?:catch\s+\())[A-Z]\w*(?:\.\w+)*\b/,
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            }
        ],
        keyword: /\b(?:abstract|as|assert|async|base|bool|break|case|catch|char|class|const|construct|continue|default|delegate|delete|do|double|dynamic|else|ensures|enum|errordomain|extern|finally|float|for|foreach|get|if|in|inline|int|int16|int32|int64|int8|interface|internal|is|lock|long|namespace|new|null|out|override|owned|params|private|protected|public|ref|requires|return|set|short|signal|sizeof|size_t|ssize_t|static|string|struct|switch|this|throw|throws|try|typeof|uchar|uint|uint16|uint32|uint64|uint8|ulong|unichar|unowned|ushort|using|value|var|virtual|void|volatile|weak|while|yield)\b/i,
        function: /\b\w+(?=\s*\()/,
        number: /(?:\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)(?:f|u?l?)?/i,
        operator: /\+\+|--|&&|\|\||<<=?|>>=?|=>|->|~|[+\-*\/%&^|=!<>]=?|\?\??|\.\.\./,
        punctuation: /[{}[\];(),.:]/,
        constant: /\b[A-Z0-9_]+\b/
    });
    Prism.languages.insertBefore('vala', 'string', {
        'raw-string': {
            pattern: /"""[\s\S]*?"""/,
            greedy: true,
            alias: 'string'
        },
        'template-string': {
            pattern: /@"[\s\S]*?"/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /\$(?:\([^)]*\)|[a-zA-Z]\w*)/,
                    inside: {
                        delimiter: {
                            pattern: /^\$\(?|\)$/,
                            alias: 'punctuation'
                        },
                        rest: Prism.languages.vala
                    }
                },
                string: /[\s\S]+/
            }
        }
    });
    Prism.languages.insertBefore('vala', 'keyword', {
        regex: {
            pattern: /\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[imsx]{0,4}(?=\s*(?:$|[\r\n,.;})\]]))/,
            greedy: true,
            inside: {
                'regex-source': {
                    pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                    lookbehind: true,
                    alias: 'language-regex',
                    inside: Prism.languages.regex
                },
                'regex-delimiter': /^\//,
                'regex-flags': /^[a-z]+$/
            }
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$394ba7ef97b97b86$export$2e2bcd8739ae039.displayName = 'velocity';
$394ba7ef97b97b86$export$2e2bcd8739ae039.aliases = [];
function $394ba7ef97b97b86$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.velocity = Prism.languages.extend('markup', {});
        var velocity = {
            variable: {
                pattern: /(^|[^\\](?:\\\\)*)\$!?(?:[a-z][\w-]*(?:\([^)]*\))?(?:\.[a-z][\w-]*(?:\([^)]*\))?|\[[^\]]+\])*|\{[^}]+\})/i,
                lookbehind: true,
                inside: {} // See below
            },
            string: {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            number: /\b\d+\b/,
            boolean: /\b(?:false|true)\b/,
            operator: /[=!<>]=?|[+*/%-]|&&|\|\||\.\.|\b(?:eq|g[et]|l[et]|n(?:e|ot))\b/,
            punctuation: /[(){}[\]:,.]/
        };
        velocity.variable.inside = {
            string: velocity['string'],
            function: {
                pattern: /([^\w-])[a-z][\w-]*(?=\()/,
                lookbehind: true
            },
            number: velocity['number'],
            boolean: velocity['boolean'],
            punctuation: velocity['punctuation']
        };
        Prism.languages.insertBefore('velocity', 'comment', {
            unparsed: {
                pattern: /(^|[^\\])#\[\[[\s\S]*?\]\]#/,
                lookbehind: true,
                greedy: true,
                inside: {
                    punctuation: /^#\[\[|\]\]#$/
                }
            },
            'velocity-comment': [
                {
                    pattern: /(^|[^\\])#\*[\s\S]*?\*#/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'comment'
                },
                {
                    pattern: /(^|[^\\])##.*/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'comment'
                }
            ],
            directive: {
                pattern: /(^|[^\\](?:\\\\)*)#@?(?:[a-z][\w-]*|\{[a-z][\w-]*\})(?:\s*\((?:[^()]|\([^()]*\))*\))?/i,
                lookbehind: true,
                inside: {
                    keyword: {
                        pattern: /^#@?(?:[a-z][\w-]*|\{[a-z][\w-]*\})|\bin\b/,
                        inside: {
                            punctuation: /[{}]/
                        }
                    },
                    rest: velocity
                }
            },
            variable: velocity['variable']
        });
        Prism.languages.velocity['tag'].inside['attr-value'].inside.rest = Prism.languages.velocity;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $8dca4130d69058ac$export$2e2bcd8739ae039.displayName = 'verilog';
$8dca4130d69058ac$export$2e2bcd8739ae039.aliases = [];
function $8dca4130d69058ac$export$2e2bcd8739ae039(Prism) {
    Prism.languages.verilog = {
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
            greedy: true
        },
        string: {
            pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
            greedy: true
        },
        'kernel-function': {
            // support for any kernel function (ex: $display())
            pattern: /\B\$\w+\b/,
            alias: 'property'
        },
        // support for user defined constants (ex: `define)
        constant: /\B`\w+\b/,
        function: /\b\w+(?=\()/,
        // support for verilog and system verilog keywords
        keyword: /\b(?:alias|and|assert|assign|assume|automatic|before|begin|bind|bins|binsof|bit|break|buf|bufif0|bufif1|byte|case|casex|casez|cell|chandle|class|clocking|cmos|config|const|constraint|context|continue|cover|covergroup|coverpoint|cross|deassign|default|defparam|design|disable|dist|do|edge|else|end|endcase|endclass|endclocking|endconfig|endfunction|endgenerate|endgroup|endinterface|endmodule|endpackage|endprimitive|endprogram|endproperty|endsequence|endspecify|endtable|endtask|enum|event|expect|export|extends|extern|final|first_match|for|force|foreach|forever|fork|forkjoin|function|generate|genvar|highz0|highz1|if|iff|ifnone|ignore_bins|illegal_bins|import|incdir|include|initial|inout|input|inside|instance|int|integer|interface|intersect|join|join_any|join_none|large|liblist|library|local|localparam|logic|longint|macromodule|matches|medium|modport|module|nand|negedge|new|nmos|nor|noshowcancelled|not|notif0|notif1|null|or|output|package|packed|parameter|pmos|posedge|primitive|priority|program|property|protected|pull0|pull1|pulldown|pullup|pulsestyle_ondetect|pulsestyle_onevent|pure|rand|randc|randcase|randsequence|rcmos|real|realtime|ref|reg|release|repeat|return|rnmos|rpmos|rtran|rtranif0|rtranif1|scalared|sequence|shortint|shortreal|showcancelled|signed|small|solve|specify|specparam|static|string|strong0|strong1|struct|super|supply0|supply1|table|tagged|task|this|throughout|time|timeprecision|timeunit|tran|tranif0|tranif1|tri|tri0|tri1|triand|trior|trireg|type|typedef|union|unique|unsigned|use|uwire|var|vectored|virtual|void|wait|wait_order|wand|weak0|weak1|while|wildcard|wire|with|within|wor|xnor|xor)\b/,
        // bold highlighting for all verilog and system verilog logic blocks
        important: /\b(?:always|always_comb|always_ff|always_latch)\b(?: *@)?/,
        // support for time ticks, vectors, and real numbers
        number: /\B##?\d+|(?:\b\d+)?'[odbh] ?[\da-fzx_?]+|\b(?:\d*[._])?\d+(?:e[-+]?\d+)?/i,
        operator: /[-+{}^~%*\/?=!<>&|]+/,
        punctuation: /[[\];(),.:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $78709f9d0e4b9c6d$export$2e2bcd8739ae039.displayName = 'vhdl';
$78709f9d0e4b9c6d$export$2e2bcd8739ae039.aliases = [];
function $78709f9d0e4b9c6d$export$2e2bcd8739ae039(Prism) {
    Prism.languages.vhdl = {
        comment: /--.+/,
        // support for all logic vectors
        'vhdl-vectors': {
            pattern: /\b[oxb]"[\da-f_]+"|"[01uxzwlh-]+"/i,
            alias: 'number'
        },
        // support for operator overloading included
        'quoted-function': {
            pattern: /"\S+?"(?=\()/,
            alias: 'function'
        },
        string: /"(?:[^\\"\r\n]|\\(?:\r\n|[\s\S]))*"/,
        attribute: {
            pattern: /\b'\w+/,
            alias: 'attr-name'
        },
        // support for predefined attributes included
        keyword: /\b(?:access|after|alias|all|architecture|array|assert|attribute|begin|block|body|buffer|bus|case|component|configuration|constant|disconnect|downto|else|elsif|end|entity|exit|file|for|function|generate|generic|group|guarded|if|impure|in|inertial|inout|is|label|library|linkage|literal|loop|map|new|next|null|of|on|open|others|out|package|port|postponed|private|procedure|process|pure|range|record|register|reject|report|return|select|severity|shared|signal|subtype|then|to|transport|type|unaffected|units|until|use|variable|view|wait|when|while|with)\b/i,
        boolean: /\b(?:false|true)\b/i,
        function: /\w+(?=\()/,
        // decimal, based, physical, and exponential numbers supported
        number: /'[01uxzwlh-]'|\b(?:\d+#[\da-f_.]+#|\d[\d_.]*)(?:e[-+]?\d+)?/i,
        operator: /[<>]=?|:=|[-+*/&=]|\b(?:abs|and|mod|nand|nor|not|or|rem|rol|ror|sla|sll|sra|srl|xnor|xor)\b/i,
        punctuation: /[{}[\];(),.:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $5c60e6cfdf15df7c$export$2e2bcd8739ae039.displayName = 'vim';
$5c60e6cfdf15df7c$export$2e2bcd8739ae039.aliases = [];
function $5c60e6cfdf15df7c$export$2e2bcd8739ae039(Prism) {
    Prism.languages.vim = {
        string: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\r\n]|'')*'/,
        comment: /".*/,
        function: /\b\w+(?=\()/,
        keyword: /\b(?:N|Next|P|Print|X|XMLent|XMLns|ab|abbreviate|abc|abclear|abo|aboveleft|al|all|ar|arga|argadd|argd|argdelete|argdo|arge|argedit|argg|argglobal|argl|arglocal|args|argu|argument|as|ascii|b|bN|bNext|ba|bad|badd|ball|bd|bdelete|be|bel|belowright|bf|bfirst|bl|blast|bm|bmodified|bn|bnext|bo|botright|bp|bprevious|br|brea|break|breaka|breakadd|breakd|breakdel|breakl|breaklist|brewind|bro|browse|bufdo|buffer|buffers|bun|bunload|bw|bwipeout|c|cN|cNext|cNfcNfile|ca|cabbrev|cabc|cabclear|cad|caddb|caddbuffer|caddexpr|caddf|caddfile|cal|call|cat|catch|cb|cbuffer|cc|ccl|cclose|cd|ce|center|cex|cexpr|cf|cfile|cfir|cfirst|cg|cgetb|cgetbuffer|cgete|cgetexpr|cgetfile|change|changes|chd|chdir|che|checkpath|checkt|checktime|cl|cla|clast|clist|clo|close|cmapc|cmapclear|cn|cnew|cnewer|cnext|cnf|cnfile|cnorea|cnoreabbrev|co|col|colder|colo|colorscheme|comc|comclear|comp|compiler|con|conf|confirm|continue|cope|copen|copy|cp|cpf|cpfile|cprevious|cq|cquit|cr|crewind|cu|cuna|cunabbrev|cunmap|cw|cwindow|d|debugg|debuggreedy|delc|delcommand|delete|delf|delfunction|delm|delmarks|di|diffg|diffget|diffoff|diffpatch|diffpu|diffput|diffsplit|diffthis|diffu|diffupdate|dig|digraphs|display|dj|djump|dl|dlist|dr|drop|ds|dsearch|dsp|dsplit|e|earlier|echoe|echoerr|echom|echomsg|echon|edit|el|else|elsei|elseif|em|emenu|en|endf|endfo|endfor|endfun|endfunction|endif|endt|endtry|endw|endwhile|ene|enew|ex|exi|exit|exu|exusage|f|file|files|filetype|fin|fina|finally|find|fini|finish|fir|first|fix|fixdel|fo|fold|foldc|foldclose|foldd|folddoc|folddoclosed|folddoopen|foldo|foldopen|for|fu|fun|function|go|goto|gr|grep|grepa|grepadd|h|ha|hardcopy|help|helpf|helpfind|helpg|helpgrep|helpt|helptags|hid|hide|his|history|ia|iabbrev|iabc|iabclear|if|ij|ijump|il|ilist|imapc|imapclear|in|inorea|inoreabbrev|isearch|isp|isplit|iu|iuna|iunabbrev|iunmap|j|join|ju|jumps|k|kee|keepalt|keepj|keepjumps|keepmarks|l|lN|lNext|lNf|lNfile|la|lad|laddb|laddbuffer|laddexpr|laddf|laddfile|lan|language|last|later|lb|lbuffer|lc|lcd|lch|lchdir|lcl|lclose|left|lefta|leftabove|let|lex|lexpr|lf|lfile|lfir|lfirst|lg|lgetb|lgetbuffer|lgete|lgetexpr|lgetfile|lgr|lgrep|lgrepa|lgrepadd|lh|lhelpgrep|list|ll|lla|llast|lli|llist|lm|lmak|lmake|lmap|lmapc|lmapclear|ln|lne|lnew|lnewer|lnext|lnf|lnfile|lnoremap|lo|loadview|loc|lockmarks|lockv|lockvar|lol|lolder|lop|lopen|lp|lpf|lpfile|lprevious|lr|lrewind|ls|lt|ltag|lu|lunmap|lv|lvimgrep|lvimgrepa|lvimgrepadd|lw|lwindow|m|ma|mak|make|mark|marks|mat|match|menut|menutranslate|mk|mkexrc|mks|mksession|mksp|mkspell|mkv|mkvie|mkview|mkvimrc|mod|mode|move|mz|mzf|mzfile|mzscheme|n|nbkey|new|next|nmapc|nmapclear|noh|nohlsearch|norea|noreabbrev|nu|number|nun|nunmap|o|omapc|omapclear|on|only|open|opt|options|ou|ounmap|p|pc|pclose|pe|ped|pedit|perl|perld|perldo|po|pop|popu|popup|pp|ppop|pre|preserve|prev|previous|print|prof|profd|profdel|profile|promptf|promptfind|promptr|promptrepl|ps|psearch|ptN|ptNext|pta|ptag|ptf|ptfirst|ptj|ptjump|ptl|ptlast|ptn|ptnext|ptp|ptprevious|ptr|ptrewind|pts|ptselect|pu|put|pw|pwd|py|pyf|pyfile|python|q|qa|qall|quit|quita|quitall|r|read|rec|recover|red|redi|redir|redo|redr|redraw|redraws|redrawstatus|reg|registers|res|resize|ret|retab|retu|return|rew|rewind|ri|right|rightb|rightbelow|ru|rub|ruby|rubyd|rubydo|rubyf|rubyfile|runtime|rv|rviminfo|sN|sNext|sa|sal|sall|san|sandbox|sargument|sav|saveas|sb|sbN|sbNext|sba|sball|sbf|sbfirst|sbl|sblast|sbm|sbmodified|sbn|sbnext|sbp|sbprevious|sbr|sbrewind|sbuffer|scrip|scripte|scriptencoding|scriptnames|se|set|setf|setfiletype|setg|setglobal|setl|setlocal|sf|sfind|sfir|sfirst|sh|shell|sign|sil|silent|sim|simalt|sl|sla|slast|sleep|sm|smagic|smap|smapc|smapclear|sme|smenu|sn|snext|sni|sniff|sno|snomagic|snor|snoremap|snoreme|snoremenu|so|sor|sort|source|sp|spe|spelld|spelldump|spellgood|spelli|spellinfo|spellr|spellrepall|spellu|spellundo|spellw|spellwrong|split|spr|sprevious|sre|srewind|st|sta|stag|star|startg|startgreplace|startinsert|startr|startreplace|stj|stjump|stop|stopi|stopinsert|sts|stselect|sun|sunhide|sunm|sunmap|sus|suspend|sv|sview|syncbind|t|tN|tNext|ta|tab|tabN|tabNext|tabc|tabclose|tabd|tabdo|tabe|tabedit|tabf|tabfind|tabfir|tabfirst|tabl|tablast|tabm|tabmove|tabn|tabnew|tabnext|tabo|tabonly|tabp|tabprevious|tabr|tabrewind|tabs|tag|tags|tc|tcl|tcld|tcldo|tclf|tclfile|te|tearoff|tf|tfirst|th|throw|tj|tjump|tl|tlast|tm|tmenu|tn|tnext|to|topleft|tp|tprevious|tr|trewind|try|ts|tselect|tu|tunmenu|u|una|unabbreviate|undo|undoj|undojoin|undol|undolist|unh|unhide|unlet|unlo|unlockvar|unm|unmap|up|update|ve|verb|verbose|version|vert|vertical|vi|vie|view|vim|vimgrep|vimgrepa|vimgrepadd|visual|viu|viusage|vmapc|vmapclear|vne|vnew|vs|vsplit|vu|vunmap|w|wN|wNext|wa|wall|wh|while|win|winc|wincmd|windo|winp|winpos|winsize|wn|wnext|wp|wprevious|wq|wqa|wqall|write|ws|wsverb|wv|wviminfo|x|xa|xall|xit|xm|xmap|xmapc|xmapclear|xme|xmenu|xn|xnoremap|xnoreme|xnoremenu|xu|xunmap|y|yank)\b/,
        builtin: /\b(?:acd|ai|akm|aleph|allowrevins|altkeymap|ambiwidth|ambw|anti|antialias|arab|arabic|arabicshape|ari|arshape|autochdir|autocmd|autoindent|autoread|autowrite|autowriteall|aw|awa|background|backspace|backup|backupcopy|backupdir|backupext|backupskip|balloondelay|ballooneval|balloonexpr|bdir|bdlay|beval|bex|bexpr|bg|bh|bin|binary|biosk|bioskey|bk|bkc|bomb|breakat|brk|browsedir|bs|bsdir|bsk|bt|bufhidden|buflisted|buftype|casemap|ccv|cdpath|cedit|cfu|ch|charconvert|ci|cin|cindent|cink|cinkeys|cino|cinoptions|cinw|cinwords|clipboard|cmdheight|cmdwinheight|cmp|cms|columns|com|comments|commentstring|compatible|complete|completefunc|completeopt|consk|conskey|copyindent|cot|cpo|cpoptions|cpt|cscopepathcomp|cscopeprg|cscopequickfix|cscopetag|cscopetagorder|cscopeverbose|cspc|csprg|csqf|cst|csto|csverb|cuc|cul|cursorcolumn|cursorline|cwh|debug|deco|def|define|delcombine|dex|dg|dict|dictionary|diff|diffexpr|diffopt|digraph|dip|dir|directory|dy|ea|ead|eadirection|eb|ed|edcompatible|ef|efm|ei|ek|enc|encoding|endofline|eol|ep|equalalways|equalprg|errorbells|errorfile|errorformat|esckeys|et|eventignore|expandtab|exrc|fcl|fcs|fdc|fde|fdi|fdl|fdls|fdm|fdn|fdo|fdt|fen|fenc|fencs|fex|ff|ffs|fileencoding|fileencodings|fileformat|fileformats|fillchars|fk|fkmap|flp|fml|fmr|foldcolumn|foldenable|foldexpr|foldignore|foldlevel|foldlevelstart|foldmarker|foldmethod|foldminlines|foldnestmax|foldtext|formatexpr|formatlistpat|formatoptions|formatprg|fp|fs|fsync|ft|gcr|gd|gdefault|gfm|gfn|gfs|gfw|ghr|gp|grepformat|grepprg|gtl|gtt|guicursor|guifont|guifontset|guifontwide|guiheadroom|guioptions|guipty|guitablabel|guitabtooltip|helpfile|helpheight|helplang|hf|hh|hi|hidden|highlight|hk|hkmap|hkmapp|hkp|hl|hlg|hls|hlsearch|ic|icon|iconstring|ignorecase|im|imactivatekey|imak|imc|imcmdline|imd|imdisable|imi|iminsert|ims|imsearch|inc|include|includeexpr|incsearch|inde|indentexpr|indentkeys|indk|inex|inf|infercase|insertmode|invacd|invai|invakm|invallowrevins|invaltkeymap|invanti|invantialias|invar|invarab|invarabic|invarabicshape|invari|invarshape|invautochdir|invautoindent|invautoread|invautowrite|invautowriteall|invaw|invawa|invbackup|invballooneval|invbeval|invbin|invbinary|invbiosk|invbioskey|invbk|invbl|invbomb|invbuflisted|invcf|invci|invcin|invcindent|invcompatible|invconfirm|invconsk|invconskey|invcopyindent|invcp|invcscopetag|invcscopeverbose|invcst|invcsverb|invcuc|invcul|invcursorcolumn|invcursorline|invdeco|invdelcombine|invdg|invdiff|invdigraph|invdisable|invea|inveb|inved|invedcompatible|invek|invendofline|inveol|invequalalways|inverrorbells|invesckeys|invet|invex|invexpandtab|invexrc|invfen|invfk|invfkmap|invfoldenable|invgd|invgdefault|invguipty|invhid|invhidden|invhk|invhkmap|invhkmapp|invhkp|invhls|invhlsearch|invic|invicon|invignorecase|invim|invimc|invimcmdline|invimd|invincsearch|invinf|invinfercase|invinsertmode|invis|invjoinspaces|invjs|invlazyredraw|invlbr|invlinebreak|invlisp|invlist|invloadplugins|invlpl|invlz|invma|invmacatsui|invmagic|invmh|invml|invmod|invmodeline|invmodifiable|invmodified|invmore|invmousef|invmousefocus|invmousehide|invnu|invnumber|invodev|invopendevice|invpaste|invpi|invpreserveindent|invpreviewwindow|invprompt|invpvw|invreadonly|invremap|invrestorescreen|invrevins|invri|invrightleft|invrightleftcmd|invrl|invrlc|invro|invrs|invru|invruler|invsb|invsc|invscb|invscrollbind|invscs|invsecure|invsft|invshellslash|invshelltemp|invshiftround|invshortname|invshowcmd|invshowfulltag|invshowmatch|invshowmode|invsi|invsm|invsmartcase|invsmartindent|invsmarttab|invsmd|invsn|invsol|invspell|invsplitbelow|invsplitright|invspr|invsr|invssl|invsta|invstartofline|invstmp|invswapfile|invswf|invta|invtagbsearch|invtagrelative|invtagstack|invtbi|invtbidi|invtbs|invtermbidi|invterse|invtextauto|invtextmode|invtf|invtgst|invtildeop|invtimeout|invtitle|invto|invtop|invtr|invttimeout|invttybuiltin|invttyfast|invtx|invvb|invvisualbell|invwa|invwarn|invwb|invweirdinvert|invwfh|invwfw|invwildmenu|invwinfixheight|invwinfixwidth|invwiv|invwmnu|invwrap|invwrapscan|invwrite|invwriteany|invwritebackup|invws|isf|isfname|isi|isident|isk|iskeyword|isprint|joinspaces|js|key|keymap|keymodel|keywordprg|km|kmp|kp|langmap|langmenu|laststatus|lazyredraw|lbr|lcs|linebreak|lines|linespace|lisp|lispwords|listchars|loadplugins|lpl|lsp|lz|macatsui|magic|makeef|makeprg|matchpairs|matchtime|maxcombine|maxfuncdepth|maxmapdepth|maxmem|maxmempattern|maxmemtot|mco|mef|menuitems|mfd|mh|mis|mkspellmem|ml|mls|mm|mmd|mmp|mmt|modeline|modelines|modifiable|modified|more|mouse|mousef|mousefocus|mousehide|mousem|mousemodel|mouses|mouseshape|mouset|mousetime|mp|mps|msm|mzq|mzquantum|nf|noacd|noai|noakm|noallowrevins|noaltkeymap|noanti|noantialias|noar|noarab|noarabic|noarabicshape|noari|noarshape|noautochdir|noautoindent|noautoread|noautowrite|noautowriteall|noaw|noawa|nobackup|noballooneval|nobeval|nobin|nobinary|nobiosk|nobioskey|nobk|nobl|nobomb|nobuflisted|nocf|noci|nocin|nocindent|nocompatible|noconfirm|noconsk|noconskey|nocopyindent|nocp|nocscopetag|nocscopeverbose|nocst|nocsverb|nocuc|nocul|nocursorcolumn|nocursorline|nodeco|nodelcombine|nodg|nodiff|nodigraph|nodisable|noea|noeb|noed|noedcompatible|noek|noendofline|noeol|noequalalways|noerrorbells|noesckeys|noet|noex|noexpandtab|noexrc|nofen|nofk|nofkmap|nofoldenable|nogd|nogdefault|noguipty|nohid|nohidden|nohk|nohkmap|nohkmapp|nohkp|nohls|noic|noicon|noignorecase|noim|noimc|noimcmdline|noimd|noincsearch|noinf|noinfercase|noinsertmode|nois|nojoinspaces|nojs|nolazyredraw|nolbr|nolinebreak|nolisp|nolist|noloadplugins|nolpl|nolz|noma|nomacatsui|nomagic|nomh|noml|nomod|nomodeline|nomodifiable|nomodified|nomore|nomousef|nomousefocus|nomousehide|nonu|nonumber|noodev|noopendevice|nopaste|nopi|nopreserveindent|nopreviewwindow|noprompt|nopvw|noreadonly|noremap|norestorescreen|norevins|nori|norightleft|norightleftcmd|norl|norlc|noro|nors|noru|noruler|nosb|nosc|noscb|noscrollbind|noscs|nosecure|nosft|noshellslash|noshelltemp|noshiftround|noshortname|noshowcmd|noshowfulltag|noshowmatch|noshowmode|nosi|nosm|nosmartcase|nosmartindent|nosmarttab|nosmd|nosn|nosol|nospell|nosplitbelow|nosplitright|nospr|nosr|nossl|nosta|nostartofline|nostmp|noswapfile|noswf|nota|notagbsearch|notagrelative|notagstack|notbi|notbidi|notbs|notermbidi|noterse|notextauto|notextmode|notf|notgst|notildeop|notimeout|notitle|noto|notop|notr|nottimeout|nottybuiltin|nottyfast|notx|novb|novisualbell|nowa|nowarn|nowb|noweirdinvert|nowfh|nowfw|nowildmenu|nowinfixheight|nowinfixwidth|nowiv|nowmnu|nowrap|nowrapscan|nowrite|nowriteany|nowritebackup|nows|nrformats|numberwidth|nuw|odev|oft|ofu|omnifunc|opendevice|operatorfunc|opfunc|osfiletype|pa|para|paragraphs|paste|pastetoggle|patchexpr|patchmode|path|pdev|penc|pex|pexpr|pfn|ph|pheader|pi|pm|pmbcs|pmbfn|popt|preserveindent|previewheight|previewwindow|printdevice|printencoding|printexpr|printfont|printheader|printmbcharset|printmbfont|printoptions|prompt|pt|pumheight|pvh|pvw|qe|quoteescape|readonly|remap|report|restorescreen|revins|rightleft|rightleftcmd|rl|rlc|ro|rs|rtp|ruf|ruler|rulerformat|runtimepath|sbo|sc|scb|scr|scroll|scrollbind|scrolljump|scrolloff|scrollopt|scs|sect|sections|secure|sel|selection|selectmode|sessionoptions|sft|shcf|shellcmdflag|shellpipe|shellquote|shellredir|shellslash|shelltemp|shelltype|shellxquote|shiftround|shiftwidth|shm|shortmess|shortname|showbreak|showcmd|showfulltag|showmatch|showmode|showtabline|shq|si|sidescroll|sidescrolloff|siso|sj|slm|smartcase|smartindent|smarttab|smc|smd|softtabstop|sol|spc|spell|spellcapcheck|spellfile|spelllang|spellsuggest|spf|spl|splitbelow|splitright|sps|sr|srr|ss|ssl|ssop|stal|startofline|statusline|stl|stmp|su|sua|suffixes|suffixesadd|sw|swapfile|swapsync|swb|swf|switchbuf|sws|sxq|syn|synmaxcol|syntax|t_AB|t_AF|t_AL|t_CS|t_CV|t_Ce|t_Co|t_Cs|t_DL|t_EI|t_F1|t_F2|t_F3|t_F4|t_F5|t_F6|t_F7|t_F8|t_F9|t_IE|t_IS|t_K1|t_K3|t_K4|t_K5|t_K6|t_K7|t_K8|t_K9|t_KA|t_KB|t_KC|t_KD|t_KE|t_KF|t_KG|t_KH|t_KI|t_KJ|t_KK|t_KL|t_RI|t_RV|t_SI|t_Sb|t_Sf|t_WP|t_WS|t_ZH|t_ZR|t_al|t_bc|t_cd|t_ce|t_cl|t_cm|t_cs|t_da|t_db|t_dl|t_fs|t_k1|t_k2|t_k3|t_k4|t_k5|t_k6|t_k7|t_k8|t_k9|t_kB|t_kD|t_kI|t_kN|t_kP|t_kb|t_kd|t_ke|t_kh|t_kl|t_kr|t_ks|t_ku|t_le|t_mb|t_md|t_me|t_mr|t_ms|t_nd|t_op|t_se|t_so|t_sr|t_te|t_ti|t_ts|t_ue|t_us|t_ut|t_vb|t_ve|t_vi|t_vs|t_xs|tabline|tabpagemax|tabstop|tagbsearch|taglength|tagrelative|tagstack|tal|tb|tbi|tbidi|tbis|tbs|tenc|term|termbidi|termencoding|terse|textauto|textmode|textwidth|tgst|thesaurus|tildeop|timeout|timeoutlen|title|titlelen|titleold|titlestring|toolbar|toolbariconsize|top|tpm|tsl|tsr|ttimeout|ttimeoutlen|ttm|tty|ttybuiltin|ttyfast|ttym|ttymouse|ttyscroll|ttytype|tw|tx|uc|ul|undolevels|updatecount|updatetime|ut|vb|vbs|vdir|verbosefile|vfile|viewdir|viewoptions|viminfo|virtualedit|visualbell|vop|wak|warn|wb|wc|wcm|wd|weirdinvert|wfh|wfw|whichwrap|wi|wig|wildchar|wildcharm|wildignore|wildmenu|wildmode|wildoptions|wim|winaltkeys|window|winfixheight|winfixwidth|winheight|winminheight|winminwidth|winwidth|wiv|wiw|wm|wmh|wmnu|wmw|wop|wrap|wrapmargin|wrapscan|writeany|writebackup|writedelay|ww)\b/,
        number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?)\b/i,
        operator: /\|\||&&|[-+.]=?|[=!](?:[=~][#?]?)?|[<>]=?[#?]?|[*\/%?]|\b(?:is(?:not)?)\b/,
        punctuation: /[{}[\](),;:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $d075f5ceed0fcf6d$export$2e2bcd8739ae039.displayName = 'visual-basic';
$d075f5ceed0fcf6d$export$2e2bcd8739ae039.aliases = [
    'vb',
    'vba'
];
function $d075f5ceed0fcf6d$export$2e2bcd8739ae039(Prism) {
    Prism.languages['visual-basic'] = {
        comment: {
            pattern: /(?:['‘’]|REM\b)(?:[^\r\n_]|_(?:\r\n?|\n)?)*/i,
            inside: {
                keyword: /^REM/i
            }
        },
        directive: {
            pattern: /#(?:Const|Else|ElseIf|End|ExternalChecksum|ExternalSource|If|Region)(?:\b_[ \t]*(?:\r\n?|\n)|.)+/i,
            alias: 'property',
            greedy: true
        },
        string: {
            pattern: /\$?["“”](?:["“”]{2}|[^"“”])*["“”]C?/i,
            greedy: true
        },
        date: {
            pattern: /#[ \t]*(?:\d+([/-])\d+\1\d+(?:[ \t]+(?:\d+[ \t]*(?:AM|PM)|\d+:\d+(?::\d+)?(?:[ \t]*(?:AM|PM))?))?|\d+[ \t]*(?:AM|PM)|\d+:\d+(?::\d+)?(?:[ \t]*(?:AM|PM))?)[ \t]*#/i,
            alias: 'number'
        },
        number: /(?:(?:\b\d+(?:\.\d+)?|\.\d+)(?:E[+-]?\d+)?|&[HO][\dA-F]+)(?:[FRD]|U?[ILS])?/i,
        boolean: /\b(?:False|Nothing|True)\b/i,
        keyword: /\b(?:AddHandler|AddressOf|Alias|And(?:Also)?|As|Boolean|ByRef|Byte|ByVal|Call|Case|Catch|C(?:Bool|Byte|Char|Date|Dbl|Dec|Int|Lng|Obj|SByte|Short|Sng|Str|Type|UInt|ULng|UShort)|Char|Class|Const|Continue|Currency|Date|Decimal|Declare|Default|Delegate|Dim|DirectCast|Do|Double|Each|Else(?:If)?|End(?:If)?|Enum|Erase|Error|Event|Exit|Finally|For|Friend|Function|Get(?:Type|XMLNamespace)?|Global|GoSub|GoTo|Handles|If|Implements|Imports|In|Inherits|Integer|Interface|Is|IsNot|Let|Lib|Like|Long|Loop|Me|Mod|Module|Must(?:Inherit|Override)|My(?:Base|Class)|Namespace|Narrowing|New|Next|Not(?:Inheritable|Overridable)?|Object|Of|On|Operator|Option(?:al)?|Or(?:Else)?|Out|Overloads|Overridable|Overrides|ParamArray|Partial|Private|Property|Protected|Public|RaiseEvent|ReadOnly|ReDim|RemoveHandler|Resume|Return|SByte|Select|Set|Shadows|Shared|short|Single|Static|Step|Stop|String|Structure|Sub|SyncLock|Then|Throw|To|Try|TryCast|Type|TypeOf|U(?:Integer|Long|Short)|Until|Using|Variant|Wend|When|While|Widening|With(?:Events)?|WriteOnly|Xor)\b/i,
        operator: /[+\-*/\\^<=>&#@$%!]|\b_(?=[ \t]*[\r\n])/,
        punctuation: /[{}().,:?]/
    };
    Prism.languages.vb = Prism.languages['visual-basic'];
    Prism.languages.vba = Prism.languages['visual-basic'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $444f169e3cccac30$export$2e2bcd8739ae039.displayName = 'warpscript';
$444f169e3cccac30$export$2e2bcd8739ae039.aliases = [];
function $444f169e3cccac30$export$2e2bcd8739ae039(Prism) {
    Prism.languages.warpscript = {
        comment: /#.*|\/\/.*|\/\*[\s\S]*?\*\//,
        string: {
            pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'|<'(?:[^\\']|'(?!>)|\\.)*'>/,
            greedy: true
        },
        variable: /\$\S+/,
        macro: {
            pattern: /@\S+/,
            alias: 'property'
        },
        // WarpScript doesn't have any keywords, these are all functions under the control category
        // https://www.warp10.io/tags/control
        keyword: /\b(?:BREAK|CHECKMACRO|CONTINUE|CUDF|DEFINED|DEFINEDMACRO|EVAL|FAIL|FOR|FOREACH|FORSTEP|IFT|IFTE|MSGFAIL|NRETURN|RETHROW|RETURN|SWITCH|TRY|UDF|UNTIL|WHILE)\b/,
        number: /[+-]?\b(?:NaN|Infinity|\d+(?:\.\d*)?(?:[Ee][+-]?\d+)?|0x[\da-fA-F]+|0b[01]+)\b/,
        boolean: /\b(?:F|T|false|true)\b/,
        punctuation: /<%|%>|[{}[\]()]/,
        // Some operators from the "operators" category
        // https://www.warp10.io/tags/operators
        operator: /==|&&?|\|\|?|\*\*?|>>>?|<<|[<>!~]=?|[-/%^]|\+!?|\b(?:AND|NOT|OR)\b/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $984388475bc1f82c$export$2e2bcd8739ae039.displayName = 'wasm';
$984388475bc1f82c$export$2e2bcd8739ae039.aliases = [];
function $984388475bc1f82c$export$2e2bcd8739ae039(Prism) {
    Prism.languages.wasm = {
        comment: [
            /\(;[\s\S]*?;\)/,
            {
                pattern: /;;.*/,
                greedy: true
            }
        ],
        string: {
            pattern: /"(?:\\[\s\S]|[^"\\])*"/,
            greedy: true
        },
        keyword: [
            {
                pattern: /\b(?:align|offset)=/,
                inside: {
                    operator: /=/
                }
            },
            {
                pattern: /\b(?:(?:f32|f64|i32|i64)(?:\.(?:abs|add|and|ceil|clz|const|convert_[su]\/i(?:32|64)|copysign|ctz|demote\/f64|div(?:_[su])?|eqz?|extend_[su]\/i32|floor|ge(?:_[su])?|gt(?:_[su])?|le(?:_[su])?|load(?:(?:8|16|32)_[su])?|lt(?:_[su])?|max|min|mul|neg?|nearest|or|popcnt|promote\/f32|reinterpret\/[fi](?:32|64)|rem_[su]|rot[lr]|shl|shr_[su]|sqrt|store(?:8|16|32)?|sub|trunc(?:_[su]\/f(?:32|64))?|wrap\/i64|xor))?|memory\.(?:grow|size))\b/,
                inside: {
                    punctuation: /\./
                }
            },
            /\b(?:anyfunc|block|br(?:_if|_table)?|call(?:_indirect)?|data|drop|elem|else|end|export|func|get_(?:global|local)|global|if|import|local|loop|memory|module|mut|nop|offset|param|result|return|select|set_(?:global|local)|start|table|tee_local|then|type|unreachable)\b/
        ],
        variable: /\$[\w!#$%&'*+\-./:<=>?@\\^`|~]+/,
        number: /[+-]?\b(?:\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:[eE][+-]?\d(?:_?\d)*)?|0x[\da-fA-F](?:_?[\da-fA-F])*(?:\.[\da-fA-F](?:_?[\da-fA-D])*)?(?:[pP][+-]?\d(?:_?\d)*)?)\b|\binf\b|\bnan(?::0x[\da-fA-F](?:_?[\da-fA-D])*)?\b/,
        punctuation: /[()]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $4b9a37daa1a6bfeb$export$2e2bcd8739ae039.displayName = 'web-idl';
$4b9a37daa1a6bfeb$export$2e2bcd8739ae039.aliases = [
    'webidl'
];
function $4b9a37daa1a6bfeb$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var id = /(?:\B-|\b_|\b)[A-Za-z][\w-]*(?![\w-])/.source;
        var type = '(?:' + /\b(?:unsigned\s+)?long\s+long(?![\w-])/.source + '|' + /\b(?:unrestricted|unsigned)\s+[a-z]+(?![\w-])/.source + '|' + /(?!(?:unrestricted|unsigned)\b)/.source + id + /(?:\s*<(?:[^<>]|<[^<>]*>)*>)?/.source + ')' + /(?:\s*\?)?/.source;
        var typeInside = {};
        Prism.languages['web-idl'] = {
            comment: {
                pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
                greedy: true
            },
            string: {
                pattern: /"[^"]*"/,
                greedy: true
            },
            namespace: {
                pattern: RegExp(/(\bnamespace\s+)/.source + id),
                lookbehind: true
            },
            'class-name': [
                {
                    pattern: /(^|[^\w-])(?:iterable|maplike|setlike)\s*<(?:[^<>]|<[^<>]*>)*>/,
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    pattern: RegExp(/(\b(?:attribute|const|deleter|getter|optional|setter)\s+)/.source + type),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // callback return type
                    pattern: RegExp('(' + /\bcallback\s+/.source + id + /\s*=\s*/.source + ')' + type),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // typedef
                    pattern: RegExp(/(\btypedef\b\s*)/.source + type),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    pattern: RegExp(/(\b(?:callback|dictionary|enum|interface(?:\s+mixin)?)\s+)(?!(?:interface|mixin)\b)/.source + id),
                    lookbehind: true
                },
                {
                    // inheritance
                    pattern: RegExp(/(:\s*)/.source + id),
                    lookbehind: true
                },
                // includes and implements
                RegExp(id + /(?=\s+(?:implements|includes)\b)/.source),
                {
                    pattern: RegExp(/(\b(?:implements|includes)\s+)/.source + id),
                    lookbehind: true
                },
                {
                    // function return type, parameter types, and dictionary members
                    pattern: RegExp(type + '(?=' + /\s*(?:\.{3}\s*)?/.source + id + /\s*[(),;=]/.source + ')'),
                    inside: typeInside
                }
            ],
            builtin: /\b(?:ArrayBuffer|BigInt64Array|BigUint64Array|ByteString|DOMString|DataView|Float32Array|Float64Array|FrozenArray|Int16Array|Int32Array|Int8Array|ObservableArray|Promise|USVString|Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray)\b/,
            keyword: [
                /\b(?:async|attribute|callback|const|constructor|deleter|dictionary|enum|getter|implements|includes|inherit|interface|mixin|namespace|null|optional|or|partial|readonly|required|setter|static|stringifier|typedef|unrestricted)\b/,
                // type keywords
                /\b(?:any|bigint|boolean|byte|double|float|iterable|long|maplike|object|octet|record|sequence|setlike|short|symbol|undefined|unsigned|void)\b/
            ],
            boolean: /\b(?:false|true)\b/,
            number: {
                pattern: /(^|[^\w-])-?(?:0x[0-9a-f]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|NaN|Infinity)(?![\w-])/i,
                lookbehind: true
            },
            operator: /\.{3}|[=:?<>-]/,
            punctuation: /[(){}[\].,;]/
        };
        for(var key in Prism.languages['web-idl'])if (key !== 'class-name') typeInside[key] = Prism.languages['web-idl'][key];
        Prism.languages['webidl'] = Prism.languages['web-idl'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $1250691c3af59f56$export$2e2bcd8739ae039.displayName = 'wgsl';
$1250691c3af59f56$export$2e2bcd8739ae039.aliases = [];
function $1250691c3af59f56$export$2e2bcd8739ae039(Prism) {
    Prism.languages.wgsl = {
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
            greedy: true
        },
        'builtin-attribute': {
            pattern: /(@)builtin\(.*?\)/,
            lookbehind: true,
            inside: {
                attribute: {
                    pattern: /^builtin/,
                    alias: 'attr-name'
                },
                punctuation: /[(),]/,
                'built-in-values': {
                    pattern: /\b(?:frag_depth|front_facing|global_invocation_id|instance_index|local_invocation_id|local_invocation_index|num_workgroups|position|sample_index|sample_mask|vertex_index|workgroup_id)\b/,
                    alias: 'attr-value'
                }
            }
        },
        attributes: {
            pattern: /(@)(?:align|binding|compute|const|fragment|group|id|interpolate|invariant|location|size|vertex|workgroup_size)/i,
            lookbehind: true,
            alias: 'attr-name'
        },
        functions: {
            pattern: /\b(fn\s+)[_a-zA-Z]\w*(?=[(<])/,
            lookbehind: true,
            alias: 'function'
        },
        keyword: /\b(?:bitcast|break|case|const|continue|continuing|default|discard|else|enable|fallthrough|fn|for|function|if|let|loop|private|return|storage|struct|switch|type|uniform|var|while|workgroup)\b/,
        builtin: /\b(?:abs|acos|acosh|all|any|array|asin|asinh|atan|atan2|atanh|atomic|atomicAdd|atomicAnd|atomicCompareExchangeWeak|atomicExchange|atomicLoad|atomicMax|atomicMin|atomicOr|atomicStore|atomicSub|atomicXor|bool|ceil|clamp|cos|cosh|countLeadingZeros|countOneBits|countTrailingZeros|cross|degrees|determinant|distance|dot|dpdx|dpdxCoarse|dpdxFine|dpdy|dpdyCoarse|dpdyFine|exp|exp2|extractBits|f32|f64|faceForward|firstLeadingBit|floor|fma|fract|frexp|fwidth|fwidthCoarse|fwidthFine|i32|i64|insertBits|inverseSqrt|ldexp|length|log|log2|mat[2-4]x[2-4]|max|min|mix|modf|normalize|override|pack2x16float|pack2x16snorm|pack2x16unorm|pack4x8snorm|pack4x8unorm|pow|ptr|quantizeToF16|radians|reflect|refract|reverseBits|round|sampler|sampler_comparison|select|shiftLeft|shiftRight|sign|sin|sinh|smoothstep|sqrt|staticAssert|step|storageBarrier|tan|tanh|textureDimensions|textureGather|textureGatherCompare|textureLoad|textureNumLayers|textureNumLevels|textureNumSamples|textureSample|textureSampleBias|textureSampleCompare|textureSampleCompareLevel|textureSampleGrad|textureSampleLevel|textureStore|texture_1d|texture_2d|texture_2d_array|texture_3d|texture_cube|texture_cube_array|texture_depth_2d|texture_depth_2d_array|texture_depth_cube|texture_depth_cube_array|texture_depth_multisampled_2d|texture_multisampled_2d|texture_storage_1d|texture_storage_2d|texture_storage_2d_array|texture_storage_3d|transpose|trunc|u32|u64|unpack2x16float|unpack2x16snorm|unpack2x16unorm|unpack4x8snorm|unpack4x8unorm|vec[2-4]|workgroupBarrier)\b/,
        'function-calls': {
            pattern: /\b[_a-z]\w*(?=\()/i,
            alias: 'function'
        },
        'class-name': /\b(?:[A-Z][A-Za-z0-9]*)\b/,
        'bool-literal': {
            pattern: /\b(?:false|true)\b/,
            alias: 'boolean'
        },
        'hex-int-literal': {
            pattern: /\b0[xX][0-9a-fA-F]+[iu]?\b(?![.pP])/,
            alias: 'number'
        },
        'hex-float-literal': {
            pattern: /\b0[xX][0-9a-fA-F]*(?:\.[0-9a-fA-F]*)?(?:[pP][+-]?\d+[fh]?)?/,
            alias: 'number'
        },
        'decimal-float-literal': [
            {
                pattern: /\d*\.\d+(?:[eE](?:\+|-)?\d+)?[fh]?/,
                alias: 'number'
            },
            {
                pattern: /\d+\.\d*(?:[eE](?:\+|-)?\d+)?[fh]?/,
                alias: 'number'
            },
            {
                pattern: /\d+[eE](?:\+|-)?\d+[fh]?/,
                alias: 'number'
            },
            {
                pattern: /\b\d+[fh]\b/,
                alias: 'number'
            }
        ],
        'int-literal': {
            pattern: /\b\d+[iu]?\b/,
            alias: 'number'
        },
        operator: [
            {
                pattern: /(?:\^|~|\|(?!\|)|\|\||&&|<<|>>|!)(?!=)/
            },
            {
                pattern: /&(?![&=])/
            },
            {
                pattern: /(?:\+=|-=|\*=|\/=|%=|\^=|&=|\|=|<<=|>>=)/
            },
            {
                pattern: /(^|[^<>=!])=(?![=>])/,
                lookbehind: true
            },
            {
                pattern: /(?:==|!=|<=|\+\+|--|(^|[^=])>=)/,
                lookbehind: true
            },
            {
                pattern: /(?:(?:[+%]|(?:\*(?!\w)))(?!=))|(?:-(?!>))|(?:\/(?!\/))/
            },
            {
                pattern: /->/
            }
        ],
        punctuation: /[@(){}[\],;<>:.]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$0490df0a3775e5e5$export$2e2bcd8739ae039.displayName = 'wiki';
$0490df0a3775e5e5$export$2e2bcd8739ae039.aliases = [];
function $0490df0a3775e5e5$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    Prism.languages.wiki = Prism.languages.extend('markup', {
        'block-comment': {
            pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
            lookbehind: true,
            alias: 'comment'
        },
        heading: {
            pattern: /^(=+)[^=\r\n].*?\1/m,
            inside: {
                punctuation: /^=+|=+$/,
                important: /.+/
            }
        },
        emphasis: {
            // TODO Multi-line
            pattern: /('{2,5}).+?\1/,
            inside: {
                'bold-italic': {
                    pattern: /(''''').+?(?=\1)/,
                    lookbehind: true,
                    alias: [
                        'bold',
                        'italic'
                    ]
                },
                bold: {
                    pattern: /(''')[^'](?:.*?[^'])?(?=\1)/,
                    lookbehind: true
                },
                italic: {
                    pattern: /('')[^'](?:.*?[^'])?(?=\1)/,
                    lookbehind: true
                },
                punctuation: /^''+|''+$/
            }
        },
        hr: {
            pattern: /^-{4,}/m,
            alias: 'punctuation'
        },
        url: [
            /ISBN +(?:97[89][ -]?)?(?:\d[ -]?){9}[\dx]\b|(?:PMID|RFC) +\d+/i,
            /\[\[.+?\]\]|\[.+?\]/
        ],
        variable: [
            /__[A-Z]+__/,
            // FIXME Nested structures should be handled
            // {{formatnum:{{#expr:{{{3}}}}}}}
            /\{{3}.+?\}{3}/,
            /\{\{.+?\}\}/
        ],
        symbol: [
            /^#redirect/im,
            /~{3,5}/
        ],
        // Handle table attrs:
        // {|
        // ! style="text-align:left;"| Item
        // |}
        'table-tag': {
            pattern: /((?:^|[|!])[|!])[^|\r\n]+\|(?!\|)/m,
            lookbehind: true,
            inside: {
                'table-bar': {
                    pattern: /\|$/,
                    alias: 'punctuation'
                },
                rest: Prism.languages.markup['tag'].inside
            }
        },
        punctuation: /^(?:\{\||\|\}|\|-|[*#:;!|])|\|\||!!/m
    });
    Prism.languages.insertBefore('wiki', 'tag', {
        // Prevent highlighting inside <nowiki>, <source> and <pre> tags
        nowiki: {
            pattern: /<(nowiki|pre|source)\b[^>]*>[\s\S]*?<\/\1>/i,
            inside: {
                tag: {
                    pattern: /<(?:nowiki|pre|source)\b[^>]*>|<\/(?:nowiki|pre|source)>/i,
                    inside: Prism.languages.markup['tag'].inside
                }
            }
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $2e21c917ded61f76$export$2e2bcd8739ae039.displayName = 'wolfram';
$2e21c917ded61f76$export$2e2bcd8739ae039.aliases = [
    'mathematica',
    'nb',
    'wl'
];
function $2e21c917ded61f76$export$2e2bcd8739ae039(Prism) {
    Prism.languages.wolfram = {
        comment: // Allow one level of nesting - note: regex taken from applescipt
        /\(\*(?:\(\*(?:[^*]|\*(?!\)))*\*\)|(?!\(\*)[\s\S])*?\*\)/,
        string: {
            pattern: /"(?:\\.|[^"\\\r\n])*"/,
            greedy: true
        },
        keyword: /\b(?:Abs|AbsArg|Accuracy|Block|Do|For|Function|If|Manipulate|Module|Nest|NestList|None|Return|Switch|Table|Which|While)\b/,
        context: {
            pattern: /\b\w+`+\w*/,
            alias: 'class-name'
        },
        blank: {
            pattern: /\b\w+_\b/,
            alias: 'regex'
        },
        'global-variable': {
            pattern: /\$\w+/,
            alias: 'variable'
        },
        boolean: /\b(?:False|True)\b/,
        number: /(?:\b(?=\d)|\B(?=\.))(?:0[bo])?(?:(?:\d|0x[\da-f])[\da-f]*(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?j?\b/i,
        operator: /\/\.|;|=\.|\^=|\^:=|:=|<<|>>|<\||\|>|:>|\|->|->|<-|@@@|@@|@|\/@|=!=|===|==|=|\+|-|\[\/-+%=\]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
        punctuation: /[{}[\];(),.:]/
    };
    Prism.languages.mathematica = Prism.languages.wolfram;
    Prism.languages.wl = Prism.languages.wolfram;
    Prism.languages.nb = Prism.languages.wolfram;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $7b93185b733a6630$export$2e2bcd8739ae039.displayName = 'wren';
$7b93185b733a6630$export$2e2bcd8739ae039.aliases = [];
function $7b93185b733a6630$export$2e2bcd8739ae039(Prism) {
    // https://wren.io/
    Prism.languages.wren = {
        // Multiline comments in Wren can have nested multiline comments
        // Comments: // and /* */
        comment: [
            {
                // support 3 levels of nesting
                // regex: \/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\/
                pattern: /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*))*\*\/)*\*\/)*\*\//,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        // Triple quoted strings are multiline but cannot have interpolation (raw strings)
        // Based on prism-python.js
        'triple-quoted-string': {
            pattern: /"""[\s\S]*?"""/,
            greedy: true,
            alias: 'string'
        },
        // see below
        'string-literal': null,
        // #!/usr/bin/env wren on the first line
        hashbang: {
            pattern: /^#!\/.+/,
            greedy: true,
            alias: 'comment'
        },
        // Attributes are special keywords to add meta data to classes
        attribute: {
            // #! attributes are stored in class properties
            // #!myvar = true
            // #attributes are not stored and dismissed at compilation
            pattern: /#!?[ \t\u3000]*\w+/,
            alias: 'keyword'
        },
        'class-name': [
            {
                // class definition
                // class Meta {}
                pattern: /(\bclass\s+)\w+/,
                lookbehind: true
            },
            // A class must always start with an uppercase.
            // File.read
            /\b[A-Z][a-z\d_]*\b/
        ],
        // A constant can be a variable, class, property or method. Just named in all uppercase letters
        constant: /\b[A-Z][A-Z\d_]*\b/,
        null: {
            pattern: /\bnull\b/,
            alias: 'keyword'
        },
        keyword: /\b(?:as|break|class|construct|continue|else|for|foreign|if|import|in|is|return|static|super|this|var|while)\b/,
        boolean: /\b(?:false|true)\b/,
        number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i,
        // Functions can be Class.method()
        function: /\b[a-z_]\w*(?=\s*[({])/i,
        operator: /<<|>>|[=!<>]=?|&&|\|\||[-+*/%~^&|?:]|\.{2,3}/,
        punctuation: /[\[\](){}.,;]/
    };
    Prism.languages.wren['string-literal'] = {
        // A single quote string is multiline and can have interpolation (similar to JS backticks ``)
        pattern: /(^|[^\\"])"(?:[^\\"%]|\\[\s\S]|%(?!\()|%\((?:[^()]|\((?:[^()]|\([^)]*\))*\))*\))*"/,
        lookbehind: true,
        greedy: true,
        inside: {
            interpolation: {
                // "%(interpolation)"
                pattern: /((?:^|[^\\])(?:\\{2})*)%\((?:[^()]|\((?:[^()]|\([^)]*\))*\))*\)/,
                lookbehind: true,
                inside: {
                    expression: {
                        pattern: /^(%\()[\s\S]+(?=\)$)/,
                        lookbehind: true,
                        inside: Prism.languages.wren
                    },
                    'interpolation-punctuation': {
                        pattern: /^%\(|\)$/,
                        alias: 'punctuation'
                    }
                }
            },
            string: /[\s\S]+/
        }
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$ac40ec14cecb0ed3$export$2e2bcd8739ae039.displayName = 'xeora';
$ac40ec14cecb0ed3$export$2e2bcd8739ae039.aliases = [
    'xeoracube'
];
function $ac40ec14cecb0ed3$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.xeora = Prism.languages.extend('markup', {
            constant: {
                pattern: /\$(?:DomainContents|PageRenderDuration)\$/,
                inside: {
                    punctuation: {
                        pattern: /\$/
                    }
                }
            },
            variable: {
                pattern: /\$@?(?:#+|[-+*~=^])?[\w.]+\$/,
                inside: {
                    punctuation: {
                        pattern: /[$.]/
                    },
                    operator: {
                        pattern: /#+|[-+*~=^@]/
                    }
                }
            },
            'function-inline': {
                pattern: /\$F:[-\w.]+\?[-\w.]+(?:,(?:(?:@[-#]*\w+\.[\w+.]\.*)*\|)*(?:(?:[\w+]|[-#*.~^]+[\w+]|=\S)(?:[^$=]|=+[^=])*=*|(?:@[-#]*\w+\.[\w+.]\.*)+(?:(?:[\w+]|[-#*~^][-#*.~^]*[\w+]|=\S)(?:[^$=]|=+[^=])*=*)?)?)?\$/,
                inside: {
                    variable: {
                        pattern: /(?:[,|])@?(?:#+|[-+*~=^])?[\w.]+/,
                        inside: {
                            punctuation: {
                                pattern: /[,.|]/
                            },
                            operator: {
                                pattern: /#+|[-+*~=^@]/
                            }
                        }
                    },
                    punctuation: {
                        pattern: /\$\w:|[$:?.,|]/
                    }
                },
                alias: 'function'
            },
            'function-block': {
                pattern: /\$XF:\{[-\w.]+\?[-\w.]+(?:,(?:(?:@[-#]*\w+\.[\w+.]\.*)*\|)*(?:(?:[\w+]|[-#*.~^]+[\w+]|=\S)(?:[^$=]|=+[^=])*=*|(?:@[-#]*\w+\.[\w+.]\.*)+(?:(?:[\w+]|[-#*~^][-#*.~^]*[\w+]|=\S)(?:[^$=]|=+[^=])*=*)?)?)?\}:XF\$/,
                inside: {
                    punctuation: {
                        pattern: /[$:{}?.,|]/
                    }
                },
                alias: 'function'
            },
            'directive-inline': {
                pattern: /\$\w(?:#\d+\+?)?(?:\[[-\w.]+\])?:[-\/\w.]+\$/,
                inside: {
                    punctuation: {
                        pattern: /\$(?:\w:|C(?:\[|#\d))?|[:{[\]]/,
                        inside: {
                            tag: {
                                pattern: /#\d/
                            }
                        }
                    }
                },
                alias: 'function'
            },
            'directive-block-open': {
                pattern: /\$\w+:\{|\$\w(?:#\d+\+?)?(?:\[[-\w.]+\])?:[-\w.]+:\{(?:![A-Z]+)?/,
                inside: {
                    punctuation: {
                        pattern: /\$(?:\w:|C(?:\[|#\d))?|[:{[\]]/,
                        inside: {
                            tag: {
                                pattern: /#\d/
                            }
                        }
                    },
                    attribute: {
                        pattern: /![A-Z]+$/,
                        inside: {
                            punctuation: {
                                pattern: /!/
                            }
                        },
                        alias: 'keyword'
                    }
                },
                alias: 'function'
            },
            'directive-block-separator': {
                pattern: /\}:[-\w.]+:\{/,
                inside: {
                    punctuation: {
                        pattern: /[:{}]/
                    }
                },
                alias: 'function'
            },
            'directive-block-close': {
                pattern: /\}:[-\w.]+\$/,
                inside: {
                    punctuation: {
                        pattern: /[:{}$]/
                    }
                },
                alias: 'function'
            }
        });
        Prism.languages.insertBefore('inside', 'punctuation', {
            variable: Prism.languages.xeora['function-inline'].inside['variable']
        }, Prism.languages.xeora['function-block']);
        Prism.languages.xeoracube = Prism.languages.xeora;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$6eb420716c757ee1$export$2e2bcd8739ae039.displayName = 'xml-doc';
$6eb420716c757ee1$export$2e2bcd8739ae039.aliases = [];
function $6eb420716c757ee1$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    (function(Prism) {
        /**
     * If the given language is present, it will insert the given doc comment grammar token into it.
     *
     * @param {string} lang
     * @param {any} docComment
     */ function insertDocComment(lang, docComment) {
            if (Prism.languages[lang]) Prism.languages.insertBefore(lang, 'comment', {
                'doc-comment': docComment
            });
        }
        var tag = Prism.languages.markup.tag;
        var slashDocComment = {
            pattern: /\/\/\/.*/,
            greedy: true,
            alias: 'comment',
            inside: {
                tag: tag
            }
        };
        var tickDocComment = {
            pattern: /'''.*/,
            greedy: true,
            alias: 'comment',
            inside: {
                tag: tag
            }
        };
        insertDocComment('csharp', slashDocComment);
        insertDocComment('fsharp', slashDocComment);
        insertDocComment('vbnet', tickDocComment);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $5c705af3a8380551$export$2e2bcd8739ae039.displayName = 'xojo';
$5c705af3a8380551$export$2e2bcd8739ae039.aliases = [];
function $5c705af3a8380551$export$2e2bcd8739ae039(Prism) {
    Prism.languages.xojo = {
        comment: {
            pattern: /(?:'|\/\/|Rem\b).+/i,
            greedy: true
        },
        string: {
            pattern: /"(?:""|[^"])*"/,
            greedy: true
        },
        number: [
            /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
            /&[bchou][a-z\d]+/i
        ],
        directive: {
            pattern: /#(?:Else|ElseIf|Endif|If|Pragma)\b/i,
            alias: 'property'
        },
        keyword: /\b(?:AddHandler|App|Array|As(?:signs)?|Auto|Boolean|Break|By(?:Ref|Val)|Byte|Call|Case|Catch|CFStringRef|CGFloat|Class|Color|Const|Continue|CString|Currency|CurrentMethodName|Declare|Delegate|Dim|Do(?:uble|wnTo)?|Each|Else(?:If)?|End|Enumeration|Event|Exception|Exit|Extends|False|Finally|For|Function|Get|GetTypeInfo|Global|GOTO|If|Implements|In|Inherits|Int(?:8|16|32|64|eger|erface)?|Lib|Loop|Me|Module|Next|Nil|Object|Optional|OSType|ParamArray|Private|Property|Protected|PString|Ptr|Raise(?:Event)?|ReDim|RemoveHandler|Return|Select(?:or)?|Self|Set|Shared|Short|Single|Soft|Static|Step|String|Sub|Super|Text|Then|To|True|Try|Ubound|UInt(?:8|16|32|64|eger)?|Until|Using|Var(?:iant)?|Wend|While|WindowPtr|WString)\b/i,
        operator: /<[=>]?|>=?|[+\-*\/\\^=]|\b(?:AddressOf|And|Ctype|IsA?|Mod|New|Not|Or|WeakAddressOf|Xor)\b/i,
        punctuation: /[.,;:()]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$794a60f48b235257$export$2e2bcd8739ae039.displayName = 'xquery';
$794a60f48b235257$export$2e2bcd8739ae039.aliases = [];
function $794a60f48b235257$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.xquery = Prism.languages.extend('markup', {
            'xquery-comment': {
                pattern: /\(:[\s\S]*?:\)/,
                greedy: true,
                alias: 'comment'
            },
            string: {
                pattern: /(["'])(?:\1\1|(?!\1)[\s\S])*\1/,
                greedy: true
            },
            extension: {
                pattern: /\(#.+?#\)/,
                alias: 'symbol'
            },
            variable: /\$[-\w:]+/,
            axis: {
                pattern: /(^|[^-])(?:ancestor(?:-or-self)?|attribute|child|descendant(?:-or-self)?|following(?:-sibling)?|parent|preceding(?:-sibling)?|self)(?=::)/,
                lookbehind: true,
                alias: 'operator'
            },
            'keyword-operator': {
                pattern: /(^|[^:-])\b(?:and|castable as|div|eq|except|ge|gt|idiv|instance of|intersect|is|le|lt|mod|ne|or|union)\b(?=$|[^:-])/,
                lookbehind: true,
                alias: 'operator'
            },
            keyword: {
                pattern: /(^|[^:-])\b(?:as|ascending|at|base-uri|boundary-space|case|cast as|collation|construction|copy-namespaces|declare|default|descending|else|empty (?:greatest|least)|encoding|every|external|for|function|if|import|in|inherit|lax|let|map|module|namespace|no-inherit|no-preserve|option|order(?: by|ed|ing)?|preserve|return|satisfies|schema|some|stable|strict|strip|then|to|treat as|typeswitch|unordered|validate|variable|version|where|xquery)\b(?=$|[^:-])/,
                lookbehind: true
            },
            function: /[\w-]+(?::[\w-]+)*(?=\s*\()/,
            'xquery-element': {
                pattern: /(element\s+)[\w-]+(?::[\w-]+)*/,
                lookbehind: true,
                alias: 'tag'
            },
            'xquery-attribute': {
                pattern: /(attribute\s+)[\w-]+(?::[\w-]+)*/,
                lookbehind: true,
                alias: 'attr-name'
            },
            builtin: {
                pattern: /(^|[^:-])\b(?:attribute|comment|document|element|processing-instruction|text|xs:(?:ENTITIES|ENTITY|ID|IDREFS?|NCName|NMTOKENS?|NOTATION|Name|QName|anyAtomicType|anyType|anyURI|base64Binary|boolean|byte|date|dateTime|dayTimeDuration|decimal|double|duration|float|gDay|gMonth|gMonthDay|gYear|gYearMonth|hexBinary|int|integer|language|long|negativeInteger|nonNegativeInteger|nonPositiveInteger|normalizedString|positiveInteger|short|string|time|token|unsigned(?:Byte|Int|Long|Short)|untyped(?:Atomic)?|yearMonthDuration))\b(?=$|[^:-])/,
                lookbehind: true
            },
            number: /\b\d+(?:\.\d+)?(?:E[+-]?\d+)?/,
            operator: [
                /[+*=?|@]|\.\.?|:=|!=|<[=<]?|>[=>]?/,
                {
                    pattern: /(\s)-(?=\s)/,
                    lookbehind: true
                }
            ],
            punctuation: /[[\](){},;:/]/
        });
        Prism.languages.xquery.tag.pattern = /<\/?(?!\d)[^\s>\/=$<%]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/;
        Prism.languages.xquery['tag'].inside['attr-value'].pattern = /=(?:("|')(?:\\[\s\S]|\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}|(?!\1)[^\\])*\1|[^\s'">=]+)/;
        Prism.languages.xquery['tag'].inside['attr-value'].inside['punctuation'] = /^="|"$/;
        Prism.languages.xquery['tag'].inside['attr-value'].inside['expression'] = {
            // Allow for two levels of nesting
            pattern: /\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}/,
            inside: Prism.languages.xquery,
            alias: 'language-xquery'
        };
        // The following will handle plain text inside tags
        var stringifyToken = function(token) {
            if (typeof token === 'string') return token;
            if (typeof token.content === 'string') return token.content;
            return token.content.map(stringifyToken).join('');
        };
        var walkTokens = function(tokens) {
            var openedTags = [];
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                var notTagNorBrace = false;
                if (typeof token !== 'string') {
                    if (token.type === 'tag' && token.content[0] && token.content[0].type === 'tag') {
                        // We found a tag, now find its kind
                        if (token.content[0].content[0].content === '</') // Closing tag
                        {
                            if (openedTags.length > 0 && openedTags[openedTags.length - 1].tagName === stringifyToken(token.content[0].content[1])) // Pop matching opening tag
                            openedTags.pop();
                        } else {
                            if (token.content[token.content.length - 1].content === '/>') ;
                            else // Opening tag
                            openedTags.push({
                                tagName: stringifyToken(token.content[0].content[1]),
                                openedBraces: 0
                            });
                        }
                    } else if (openedTags.length > 0 && token.type === 'punctuation' && token.content === '{' && // Ignore `{{`
                    (!tokens[i + 1] || tokens[i + 1].type !== 'punctuation' || tokens[i + 1].content !== '{') && (!tokens[i - 1] || tokens[i - 1].type !== 'plain-text' || tokens[i - 1].content !== '{')) // Here we might have entered an XQuery expression inside a tag
                    openedTags[openedTags.length - 1].openedBraces++;
                    else if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces > 0 && token.type === 'punctuation' && token.content === '}') // Here we might have left an XQuery expression inside a tag
                    openedTags[openedTags.length - 1].openedBraces--;
                    else if (token.type !== 'comment') notTagNorBrace = true;
                }
                if (notTagNorBrace || typeof token === 'string') {
                    if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces === 0) {
                        // Here we are inside a tag, and not inside an XQuery expression.
                        // That's plain text: drop any tokens matched.
                        var plainText = stringifyToken(token);
                        // And merge text with adjacent text
                        if (i < tokens.length - 1 && (typeof tokens[i + 1] === 'string' || tokens[i + 1].type === 'plain-text')) {
                            plainText += stringifyToken(tokens[i + 1]);
                            tokens.splice(i + 1, 1);
                        }
                        if (i > 0 && (typeof tokens[i - 1] === 'string' || tokens[i - 1].type === 'plain-text')) {
                            plainText = stringifyToken(tokens[i - 1]) + plainText;
                            tokens.splice(i - 1, 1);
                            i--;
                        }
                        if (/^\s+$/.test(plainText)) tokens[i] = plainText;
                        else tokens[i] = new Prism.Token('plain-text', plainText, null, plainText);
                    }
                }
                if (token.content && typeof token.content !== 'string') walkTokens(token.content);
            }
        };
        Prism.hooks.add('after-tokenize', function(env) {
            if (env.language !== 'xquery') return;
            walkTokens(env.tokens);
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $3fd6a28a1bc887ad$export$2e2bcd8739ae039.displayName = 'yang';
$3fd6a28a1bc887ad$export$2e2bcd8739ae039.aliases = [];
function $3fd6a28a1bc887ad$export$2e2bcd8739ae039(Prism) {
    Prism.languages.yang = {
        // https://tools.ietf.org/html/rfc6020#page-34
        // http://www.yang-central.org/twiki/bin/view/Main/YangExamples
        comment: /\/\*[\s\S]*?\*\/|\/\/.*/,
        string: {
            pattern: /"(?:[^\\"]|\\.)*"|'[^']*'/,
            greedy: true
        },
        keyword: {
            pattern: /(^|[{};\r\n][ \t]*)[a-z_][\w.-]*/i,
            lookbehind: true
        },
        namespace: {
            pattern: /(\s)[a-z_][\w.-]*(?=:)/i,
            lookbehind: true
        },
        boolean: /\b(?:false|true)\b/,
        operator: /\+/,
        punctuation: /[{};:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $2237a96aa7b23da5$export$2e2bcd8739ae039.displayName = 'zig';
$2237a96aa7b23da5$export$2e2bcd8739ae039.aliases = [];
function $2237a96aa7b23da5$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        function literal(str) {
            return function() {
                return str;
            };
        }
        var keyword = /\b(?:align|allowzero|and|anyframe|anytype|asm|async|await|break|cancel|catch|comptime|const|continue|defer|else|enum|errdefer|error|export|extern|fn|for|if|inline|linksection|nakedcc|noalias|nosuspend|null|or|orelse|packed|promise|pub|resume|return|stdcallcc|struct|suspend|switch|test|threadlocal|try|undefined|union|unreachable|usingnamespace|var|volatile|while)\b/;
        var IDENTIFIER = '\\b(?!' + keyword.source + ')(?!\\d)\\w+\\b';
        var ALIGN = /align\s*\((?:[^()]|\([^()]*\))*\)/.source;
        var PREFIX_TYPE_OP = /(?:\?|\bpromise->|(?:\[[^[\]]*\]|\*(?!\*)|\*\*)(?:\s*<ALIGN>|\s*const\b|\s*volatile\b|\s*allowzero\b)*)/.source.replace(/<ALIGN>/g, literal(ALIGN));
        var SUFFIX_EXPR = /(?:\bpromise\b|(?:\berror\.)?<ID>(?:\.<ID>)*(?!\s+<ID>))/.source.replace(/<ID>/g, literal(IDENTIFIER));
        var TYPE = '(?!\\s)(?:!?\\s*(?:' + PREFIX_TYPE_OP + '\\s*)*' + SUFFIX_EXPR + ')+';
        /*
     * A simplified grammar for Zig compile time type literals:
     *
     * TypeExpr = ( "!"? PREFIX_TYPE_OP* SUFFIX_EXPR )+
     *
     * SUFFIX_EXPR = ( \b "promise" \b | ( \b "error" "." )? IDENTIFIER ( "." IDENTIFIER )* (?! \s+ IDENTIFIER ) )
     *
     * PREFIX_TYPE_OP = "?"
     *                | \b "promise" "->"
     *                | ( "[" [^\[\]]* "]" | "*" | "**" ) ( ALIGN | "const" \b | "volatile" \b | "allowzero" \b )*
     *
     * ALIGN = "align" "(" ( [^()] | "(" [^()]* ")" )* ")"
     *
     * IDENTIFIER = \b (?! KEYWORD ) [a-zA-Z_] \w* \b
     *
     */ Prism.languages.zig = {
            comment: [
                {
                    pattern: /\/\/[/!].*/,
                    alias: 'doc-comment'
                },
                /\/{2}.*/
            ],
            string: [
                {
                    // "string" and c"string"
                    pattern: /(^|[^\\@])c?"(?:[^"\\\r\n]|\\.)*"/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    // multiline strings and c-strings
                    pattern: /([\r\n])([ \t]+c?\\{2}).*(?:(?:\r\n?|\n)\2.*)*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            char: {
                // characters 'a', '\n', '\xFF', '\u{10FFFF}'
                pattern: /(^|[^\\])'(?:[^'\\\r\n]|[\uD800-\uDFFF]{2}|\\(?:.|x[a-fA-F\d]{2}|u\{[a-fA-F\d]{1,6}\}))'/,
                lookbehind: true,
                greedy: true
            },
            builtin: /\B@(?!\d)\w+(?=\s*\()/,
            label: {
                pattern: /(\b(?:break|continue)\s*:\s*)\w+\b|\b(?!\d)\w+\b(?=\s*:\s*(?:\{|while\b))/,
                lookbehind: true
            },
            'class-name': [
                // const Foo = struct {};
                /\b(?!\d)\w+(?=\s*=\s*(?:(?:extern|packed)\s+)?(?:enum|struct|union)\s*[({])/,
                {
                    // const x: i32 = 9;
                    // var x: Bar;
                    // fn foo(x: bool, y: f32) void {}
                    pattern: RegExp(/(:\s*)<TYPE>(?=\s*(?:<ALIGN>\s*)?[=;,)])|<TYPE>(?=\s*(?:<ALIGN>\s*)?\{)/.source.replace(/<TYPE>/g, literal(TYPE)).replace(/<ALIGN>/g, literal(ALIGN))),
                    lookbehind: true,
                    inside: null // see below
                },
                {
                    // extern fn foo(x: f64) f64; (optional alignment)
                    pattern: RegExp(/(\)\s*)<TYPE>(?=\s*(?:<ALIGN>\s*)?;)/.source.replace(/<TYPE>/g, literal(TYPE)).replace(/<ALIGN>/g, literal(ALIGN))),
                    lookbehind: true,
                    inside: null // see below
                }
            ],
            'builtin-type': {
                pattern: /\b(?:anyerror|bool|c_u?(?:int|long|longlong|short)|c_longdouble|c_void|comptime_(?:float|int)|f(?:16|32|64|128)|[iu](?:8|16|32|64|128|size)|noreturn|type|void)\b/,
                alias: 'keyword'
            },
            keyword: keyword,
            function: /\b(?!\d)\w+(?=\s*\()/,
            number: /\b(?:0b[01]+|0o[0-7]+|0x[a-fA-F\d]+(?:\.[a-fA-F\d]*)?(?:[pP][+-]?[a-fA-F\d]+)?|\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)\b/,
            boolean: /\b(?:false|true)\b/,
            operator: /\.[*?]|\.{2,3}|[-=]>|\*\*|\+\+|\|\||(?:<<|>>|[-+*]%|[-+*/%^&|<>!=])=?|[?~]/,
            punctuation: /[.:,;(){}[\]]/
        };
        Prism.languages.zig['class-name'].forEach(function(obj) {
            if (obj.inside === null) obj.inside = Prism.languages.zig;
        });
    })(Prism);
}



(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f47682e33a093951$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $8467c3aacdff56ee$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $c029552e57eb42d4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $95ea2c9bcdd7f611$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $c4d1e2daa7d84c8b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0a13ac6a7fcf6722$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f7f5127772c5c04e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $64a4add7c0be4a61$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $99775d8f376cb002$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f2801efe566f5e02$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $5f9b78712ea78e48$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $eb5bcdfed284c0e2$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $c25959ac29c21b23$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $34c2ee9c440ac9ed$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $16c57dd521f1a867$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $d761452eb924cd1c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f4e156ae6ed8d0a0$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b373cdd06f88d58c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4fe2e947cede365f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $46893c7fe39cde19$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $13f495791853dbf3$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $8bc35bfd2be6822a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1da2260b608e55ec$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $ee5893254ac9a415$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $93cf65ee58a98ba9$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $825a50f0352eefcc$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $803928922a6961a4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $ae7a5bea34c537e5$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $bd73346734ce1e3f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $75d197dead828344$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $6fdeaba363e1867b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b9409e2dd4b1f152$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $5a70a1b33a6cef7a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $fde5bd5d73cb6997$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $c23e2e2dfd81122c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b245c95193e08d8c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f1ff25d1ebcd6cac$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $92013590b857bd88$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $d4e3d605b49454d4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $26acd6c806290335$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $e9431566d3fac7dd$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $c084f125db8708f6$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $8798e67056712316$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $604e26785f89d2b2$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $69bb850a8bbe91f4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0d5ca126f659299e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $beb46e0ab65e7d5b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $daeaab3980ca96e4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $84399bc3f59b1c8b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $56a51c0494ec22f0$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $8ec1bae033ed476d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $fa97cf30362824f8$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $aad082cba5464279$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $77fe7b80ef861b40$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $53052fb9d74303db$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f86df18bcfea9f70$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f4e95d0947d511df$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1f6beaffa93c6e28$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1fe20ac82cecf3eb$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $debd1f6308a90423$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $e8643cf3d5f78f91$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0814f5761e025965$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4f8b5c37b37db49e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $a0274c81b19638e1$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $732efa98354ef152$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4c72dd9423c79b65$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4849b6a31c9f2c50$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $d96e6553b79e688e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $74043824b764ef3e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $a2a3ecd8671a9cb9$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $456d34d6a0e808d3$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $09fb00aefac0036e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $dab2950de0f638d9$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $713fb0d437182828$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $9df90d7c45567ff9$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $6bf0eb89a36e65a0$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $9be5e6824314caae$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $582d3cacea24a910$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $5b71468010bc72da$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $05008d3ff07b1f36$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1f738c70877931fd$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $7290ce53648b43d9$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4e7615bc2bd38bf5$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $20b8caf8b024dc15$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $24261424b318a546$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $81a7c5742f763317$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $645d653be7f1e246$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $23b4532be12400bd$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $03636fbb6bcf9de6$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $d1ff02eb2618944d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0690cd6d0a840968$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b30f7170c1780bbb$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $589c0bdcaa161eef$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1f14745690836bca$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $c4bd90163a636571$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $d04717890a46cf2e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $79b0be010e76d7ca$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $3ad1242016c38065$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $675c24a063f84cbd$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b7509ddd058c90d0$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $ec3042630860b388$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $e41ae20b134c7e19$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b8a98b0ff64a5cd4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $a9f5bac9ba5085d8$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $5bfce00dfe9edf4d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $47dfe45f952c98c2$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1c0f2e453947e61a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $9f945d890adcf850$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $cd8c18afbde31359$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $c77c0e4272178579$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $bb09ab25dfcbb114$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f3a5ce20fdab9e50$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $621160e6c15c3eff$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $9c25dab359558e3e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $2590b32a10d9ecc8$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $abb136260c600497$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $2ae70ee16ca48837$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1ba73c5509e75af1$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $50cc4f59c8b2da7b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $e2e7d35f13665654$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $e34b34b543223ef4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $669817df648224fc$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $6c6957e69ba93803$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $7ca1ade36c00114f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $6583f09ac504dc32$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $df4a8f4049b5c047$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $dae26b846c274399$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $7f7ed36c71460d27$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $01d5a9ee0f18d738$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $3c79c65302ac0671$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $de2f160c2fe3453a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $2575e451a3a1df7f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $197381b2d5f39c0b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0b6b8e959651c37f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $cd93a27b452b7c48$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $49817f5fa65142f2$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $8a2c8b738cd1f636$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $27318f6b523d68d5$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $46a0b7b965a829bf$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $988c0ef2629271f3$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $cb363a9e19005aae$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $49ed9aeb5a3777c3$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $23ae979d55503543$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $8f95bc848ace76c7$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b338b4b197bcd1b4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $010d7940936c67fb$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $bf3c2cf9e7b7e15b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $a236d89746bc105c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $964a8a24221af55b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1ea37e5c47d5707d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $94086998b35689c5$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $5b076416d0eabdf4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $cfc1afd3507a91b5$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $350499ec8fbf9130$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $d1947654b0468835$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $edb8a8bbc6c61935$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $5796ea4f5c719733$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $c3d8d532e557e2f4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f13c2598f5dc8663$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $c8196ec3df0cee5b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f15bc5f7f9ab760a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $dff85ed6bfabe21a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0ebb485d13184e81$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $59e22f64646db583$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $fb1869ae2e02698d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b6a0f971cc211856$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0ce2bbca25db411c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $55c84b5f47c86788$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $9513a6857dddaa7a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $23da19d9f15297a4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $7306ed74be230ce9$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0032d605afbc43b2$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $ff984944cd41b96b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $aee6b2f66d7ac757$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $a4448d0866560d14$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $8d3fa3f18bccf1b2$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $fce09911b128bdb6$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $3350c1fbd5ca8b13$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $5c87aab191bc72fd$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0efdb6c99f3f7c98$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0c54d82c2339cc9c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $dd0a8f9cf86863f1$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $6be9a541d67ded55$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $436bbebbe3139e7e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4b0c7b814ccf677f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $937b72076b7797c7$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $93be80b0f58505d4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $833f205419d7e6ea$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f6e28ce82e52815a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $a71447da60e1f6e1$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $846ab470db2ff869$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $db79ad093bda0678$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4ed009a5750aab51$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $2aa93c3806b01798$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $6a65d32501c7d08f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $8ed4b18f31ffd000$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $5e75362810025a55$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $5233df02eb9ce262$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b2343da39e8ef130$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $677549b6ac647aae$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $deb4ca581bc1f27a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $5d2497dd4e3ab655$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4b3fd195950a9be7$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $380e029e8a782237$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1e6f9251c3a754c6$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $83967affbf32d3d2$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b8eebe66b02f0b09$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $ee0a699affb8796e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $bb80e878636bd8f6$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $07c52e9b9a88ab06$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b43974aae9bb9664$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $37e5b1709464e513$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4b50fa11ce89925a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $5ac9473b450a64ab$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $e427246b711a2509$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $295e7fe9e01d0862$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $48a2ee38b0d45f1e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $9d032faa85d6103d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f0ce0a61b7257e87$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $d402b3c4cd63a644$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $a42852126578ac8f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $75c09846dd2bbd2b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4c79b618a588b28d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $3b64cc26a0bd267e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $2651f31c4a94c2f1$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $2ba51d01e535556e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f20909d17a339405$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $781e96ef45d1066d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $2def36300150cc17$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $be3f5e01c2434719$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0636642bf7a5dca9$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1100e9295cc7554a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $ad8d5c52e7714ea6$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $c4f30d48e56845b8$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $32c58ead3c55b79c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $50e3d013937d7b07$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $c37f7ecb6b24967e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $9e1e815b43dfcf12$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $e01299bf75eda32d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $37dde9971f145ea3$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $27d87a17c8c1aaf3$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $390e344e43dfbcde$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $d4804f7e613d614f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $730f9a4b12501d43$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0ef3d1ceb8394e5c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $feeef9c3da6c04de$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $a0deafd0233b5617$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1aa991af509c7894$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $3a1367f4db4eb9c1$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $3f3dc76a1a6f0313$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4b8f98fbb364b5fe$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $013d5fc882b5f308$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $803656f9da2f54a6$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $fbdec31c6df2c19f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $12d6f3ddfd59c8f8$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $d0722eb1de37ae4c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $d11fe3812b565e9e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b9bd6ce061e8b23b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $9f8d1abaebbe1e7b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $352108f0900288bc$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $10278687c497f16d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f6357e1d35f66b04$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $cf1be131e0fce4fa$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $059ad53228ded3c9$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $74f53190c8211cce$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0acbc38df3a79135$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $3b31713a87a8de6a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $735a787ca1f7aae4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $38e9da697ee0f6f7$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $00d1fd220eb25cf1$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $9f2f0d409f6bf608$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $91f9e56f191bfd66$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $d826ce7b7a227512$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $e2afbfabfe840b99$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $8548b6b81abd0793$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $9abdb5de274a074a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $394ba7ef97b97b86$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $8dca4130d69058ac$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $78709f9d0e4b9c6d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $5c60e6cfdf15df7c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $d075f5ceed0fcf6d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $444f169e3cccac30$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $984388475bc1f82c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4b9a37daa1a6bfeb$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1250691c3af59f56$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0490df0a3775e5e5$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $2e21c917ded61f76$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $7b93185b733a6630$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $ac40ec14cecb0ed3$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $6eb420716c757ee1$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $5c705af3a8380551$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $794a60f48b235257$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $3fd6a28a1bc887ad$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $2237a96aa7b23da5$export$2e2bcd8739ae039));


function $f6a8c10565706ab2$var$a() {
    $f6a8c10565706ab2$var$a = function(e, r) {
        return new t(e, void 0, r);
    };
    var e = RegExp.prototype, r = new WeakMap;
    function t(e, n, i) {
        var o = new RegExp(e, n);
        return r.set(o, i || r.get(e)), $f6a8c10565706ab2$var$s(o, t.prototype);
    }
    function n(e, t) {
        var n = r.get(t);
        return Object.keys(n).reduce(function(r, t) {
            var i = n[t];
            if ("number" == typeof i) r[t] = e[i];
            else {
                for(var o = 0; void 0 === e[i[o]] && o + 1 < i.length;)o++;
                r[t] = e[i[o]];
            }
            return r;
        }, Object.create(null));
    }
    return function(e, r) {
        if ("function" != typeof r && null !== r) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(r && r.prototype, {
            constructor: {
                value: e,
                writable: !0,
                configurable: !0
            }
        }), Object.defineProperty(e, "prototype", {
            writable: !1
        }), r && $f6a8c10565706ab2$var$s(e, r);
    }(t, RegExp), t.prototype.exec = function(r) {
        var t = e.exec.call(this, r);
        if (t) {
            t.groups = n(t, this);
            var i = t.indices;
            i && (i.groups = n(i, this));
        }
        return t;
    }, t.prototype[Symbol.replace] = function(t, i) {
        if ("string" == typeof i) {
            var o = r.get(this);
            return e[Symbol.replace].call(this, t, i.replace(/\$<([^>]+)>/g, function(e, r) {
                var t = o[r];
                return "$" + (Array.isArray(t) ? t.join("$") : t);
            }));
        }
        if ("function" == typeof i) {
            var a = this;
            return e[Symbol.replace].call(this, t, function() {
                var e = arguments;
                return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(n(e, a)), i.apply(this, e);
            });
        }
        return e[Symbol.replace].call(this, t, i);
    }, $f6a8c10565706ab2$var$a.apply(this, arguments);
}
function $f6a8c10565706ab2$var$s(e, r) {
    return $f6a8c10565706ab2$var$s = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, r) {
        return e.__proto__ = r, e;
    }, $f6a8c10565706ab2$var$s(e, r);
}
function $f6a8c10565706ab2$var$l(e, r) {
    (null == r || r > e.length) && (r = e.length);
    for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
    return n;
}
function $f6a8c10565706ab2$var$u(e, r) {
    var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (t) return (t = t.call(e)).next.bind(t);
    if (Array.isArray(e) || (t = function(e, r) {
        if (e) {
            if ("string" == typeof e) return $f6a8c10565706ab2$var$l(e, r);
            var t = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f6a8c10565706ab2$var$l(e, r) : void 0;
        }
    }(e)) || r && e && "number" == typeof e.length) {
        t && (e = t);
        var n = 0;
        return function() {
            return n >= e.length ? {
                done: !0
            } : {
                done: !1,
                value: e[n++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $f6a8c10565706ab2$export$f80b9a7578ac06a = function(i) {
    return function(o) {
        return void 0 === o && (o = {}), function(e, r) {
            if (r && !e.registered(r)) throw new Error('The default language "' + r + '" is not registered with refractor.');
        }(i, o.defaultLanguage), function(r) {
            (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(r, "element", s);
        };
        function s(e, s, l) {
            var c, p;
            if (l && "pre" === l.tagName && "code" === e.tagName) {
                var f = (null == e || null == (c = e.data) ? void 0 : c.meta) || (null == e || null == (p = e.properties) ? void 0 : p.metastring) || "";
                e.properties.className ? "boolean" == typeof e.properties.className ? e.properties.className = [] : Array.isArray(e.properties.className) || (e.properties.className = [
                    e.properties.className
                ]) : e.properties.className = [];
                var m, h, d = function(e) {
                    for(var r, t = $f6a8c10565706ab2$var$u(e.properties.className); !(r = t()).done;){
                        var n = r.value;
                        if ("language-" === n.slice(0, 9)) return n.slice(9).toLowerCase();
                    }
                    return null;
                }(e);
                if (!d && o.defaultLanguage && e.properties.className.push("language-" + (d = o.defaultLanguage)), e.properties.className.push("code-highlight"), d) try {
                    var g, y;
                    y = null != (g = d) && g.includes("diff-") ? d.split("-")[1] : d, m = i.highlight((0, $58714581718e6349$export$f84e8e69fd4488a5)(e), y), l.properties.className = (l.properties.className || []).concat("language-" + y);
                } catch (r) {
                    if (!o.ignoreMissing || !/Unknown language/.test(r.message)) throw r;
                    m = e;
                }
                else m = e;
                m.children = (h = 1, function e(r) {
                    return r.reduce(function(r, t) {
                        if ("text" === t.type) {
                            var n = t.value, i = (n.match(/\n/g) || "").length;
                            if (0 === i) t.position = {
                                start: {
                                    line: h,
                                    column: 1
                                },
                                end: {
                                    line: h,
                                    column: 1
                                }
                            }, r.push(t);
                            else for(var o, a = n.split("\n"), s = $f6a8c10565706ab2$var$u(a.entries()); !(o = s()).done;){
                                var l = o.value, c = l[0], p = l[1];
                                r.push({
                                    type: "text",
                                    value: c === a.length - 1 ? p : p + "\n",
                                    position: {
                                        start: {
                                            line: h + c,
                                            column: 1
                                        },
                                        end: {
                                            line: h + c,
                                            column: 1
                                        }
                                    }
                                });
                            }
                            return h += i, r;
                        }
                        if (Object.prototype.hasOwnProperty.call(t, "children")) {
                            var f = h;
                            return t.children = e(t.children), r.push(t), t.position = {
                                start: {
                                    line: f,
                                    column: 1
                                },
                                end: {
                                    line: h,
                                    column: 1
                                }
                            }, r;
                        }
                        return r.push(t), r;
                    }, []);
                })(m.children), m.position = m.children.length > 0 ? {
                    start: {
                        line: m.children[0].position.start.line,
                        column: 0
                    },
                    end: {
                        line: m.children[m.children.length - 1].position.end.line,
                        column: 0
                    }
                } : {
                    start: {
                        line: 0,
                        column: 0
                    },
                    end: {
                        line: 0,
                        column: 0
                    }
                };
                for(var v, b = function(e) {
                    var r = /{([\d,-]+)}/, t = e.split(",").map(function(e) {
                        return e.trim();
                    }).join();
                    if (r.test(t)) {
                        var i = r.exec(t)[1], o = (0, (/*@__PURE__*/$parcel$interopDefault($97f2cf7466aff99c$exports)))(i);
                        return function(e) {
                            return o.includes(e + 1);
                        };
                    }
                    return function() {
                        return !1;
                    };
                }(f), w = function(e) {
                    var r = /*#__PURE__*/ $f6a8c10565706ab2$var$a(/showLineNumbers=(\d+)/i, {
                        lines: 1
                    });
                    if (r.test(e)) {
                        var t = r.exec(e);
                        return Number(t.groups.lines);
                    }
                    return 1;
                }(f), N = function(e) {
                    for(var r = new Array(e), t = 0; t < e; t++)r[t] = {
                        type: "element",
                        tagName: "span",
                        properties: {
                            className: []
                        },
                        children: []
                    };
                    return r;
                }(m.position.end.line), j = [
                    "showlinenumbers=false",
                    'showlinenumbers="false"',
                    "showlinenumbers={false}"
                ], x = function() {
                    var e, n, i = v.value, a = i[0], s = i[1];
                    s.properties.className = [
                        "code-line"
                    ];
                    var l = (0, $31e44c919774b7ea$export$3dea766d36a8935f)(m, function(e) {
                        return e.position.start.line <= a + 1 && e.position.end.line >= a + 1;
                    });
                    s.children = l.children, (f.toLowerCase().includes("showLineNumbers".toLowerCase()) || !0 === o.showLineNumbers || "object" == typeof o.showLineNumbers && o.showLineNumbers.includes(d)) && !j.some(function(e) {
                        return f.toLowerCase().includes(e);
                    }) && (s.properties.line = [
                        (a + w).toString()
                    ], s.properties.className.push("line-number")), b(a) && s.properties.className.push("highlight-line"), ("diff" === d || null != (e = d) && e.includes("diff-")) && "-" === (0, $58714581718e6349$export$f84e8e69fd4488a5)(s).substring(0, 1) ? s.properties.className.push("deleted") : ("diff" === d || null != (n = d) && n.includes("diff-")) && "+" === (0, $58714581718e6349$export$f84e8e69fd4488a5)(s).substring(0, 1) && s.properties.className.push("inserted");
                }, L = $f6a8c10565706ab2$var$u(N.entries()); !(v = L()).done;)x();
                N.length > 0 && "" === (0, $58714581718e6349$export$f84e8e69fd4488a5)(N[N.length - 1]).trim() && N.pop(), e.children = N;
            }
        }
    };
}, $f6a8c10565706ab2$export$d63bd6a97105214e = $f6a8c10565706ab2$export$f80b9a7578ac06a((0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390)), $f6a8c10565706ab2$export$2e2bcd8739ae039 = $f6a8c10565706ab2$export$f80b9a7578ac06a((0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390));




var $3b1c409df4bde24b$var$_templateObject;
function $3b1c409df4bde24b$var$html2Escape(sHtml) {
    return sHtml// .replace(/```(\w+)?([\s\S]*?)(\s.+)?```/g, (str: string) => {
    //   return str.replace(
    //     /[<&"]/g,
    //     (c: string) => (({ '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' } as Record<string, string>)[c]),
    //   );
    // })
    .replace(/[<&"]/g, (c)=>({
            '<': '&lt;',
            '>': '&gt;',
            '&': '&amp;',
            '"': '&quot;'
        })[c]);
}
function $3b1c409df4bde24b$export$2e2bcd8739ae039(props) {
    var { prefixCls: prefixCls } = props;
    var { markdown: markdown = '', highlightEnable: highlightEnable, dispatch: dispatch } = (0, $7fPBF.useContext)((0, $7c2cb0ce17642c75$export$27b8dd149e32f6c7));
    var preRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createRef();
    (0, $7fPBF.useEffect)(()=>{
        if (preRef.current && dispatch) dispatch({
            textareaPre: preRef.current
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!markdown) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("pre", {
        ref: preRef,
        className: prefixCls + "-text-pre wmde-markdown-color"
    });
    var mdStr = "<pre class=\"language-markdown " + prefixCls + "-text-pre wmde-markdown-color\"><code class=\"language-markdown\">" + $3b1c409df4bde24b$var$html2Escape(String.raw($3b1c409df4bde24b$var$_templateObject || ($3b1c409df4bde24b$var$_templateObject = (0, $53471605b9d4580f$export$2e2bcd8739ae039)([
        "",
        ""
    ])), markdown)) + "\n</code></pre>";
    if (highlightEnable) try {
        mdStr = (0, $896ab3348b7fb05e$export$3c91a9a75d9d4e1f)().data('settings', {
            fragment: true
        })// https://github.com/uiwjs/react-md-editor/issues/593
        // @ts-ignore
        .use((0, $f6a8c10565706ab2$export$2e2bcd8739ae039), {
            ignoreMissing: true
        }).processSync(mdStr).toString();
    } catch (error) {}
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement('div', {
        className: 'wmde-markdown-color',
        dangerouslySetInnerHTML: {
            __html: mdStr || ''
        }
    });
}





var $7fPBF = parcelRequire("7fPBF");


/**
 * The MIT License
 * Copyright (c) 2018 Dmitriy Kubyshkin
 * Copied from https://github.com/grassator/insert-text-at-cursor
 */ var $cd79195d1a384c19$var$browserSupportsTextareaTextNodes;
/**
 * @param {HTMLElement} input
 * @return {boolean}
 */ function $cd79195d1a384c19$var$canManipulateViaTextNodes(input) {
    if (input.nodeName !== 'TEXTAREA') return false;
    if (typeof $cd79195d1a384c19$var$browserSupportsTextareaTextNodes === 'undefined') {
        var textarea = document.createElement('textarea');
        textarea.value = '1';
        $cd79195d1a384c19$var$browserSupportsTextareaTextNodes = !!textarea.firstChild;
    }
    return $cd79195d1a384c19$var$browserSupportsTextareaTextNodes;
}
function $cd79195d1a384c19$export$7d6189efbd20bf69(input, text) {
    // Most of the used APIs only work with the field selected
    input.focus();
    // IE 8-10
    if (document.selection) {
        var ieRange = document.selection.createRange();
        ieRange.text = text;
        // Move cursor after the inserted text
        ieRange.collapse(false);
        ieRange.select();
        return;
    }
    // Webkit + Edge
    var isSuccess = false;
    if (text !== '') isSuccess = document.execCommand && document.execCommand('insertText', false, text);
    else isSuccess = document.execCommand && document.execCommand('delete', false);
    if (!isSuccess) {
        var start = input.selectionStart;
        var end = input.selectionEnd;
        // Firefox (non-standard method)
        if (typeof input.setRangeText === 'function') input.setRangeText(text);
        else {
            // To make a change we just need a Range, not a Selection
            var range = document.createRange();
            var textNode = document.createTextNode(text);
            if ($cd79195d1a384c19$var$canManipulateViaTextNodes(input)) {
                var node = input.firstChild;
                // If textarea is empty, just insert the text
                if (!node) input.appendChild(textNode);
                else {
                    // Otherwise we need to find a nodes for start and end
                    var offset = 0;
                    var startNode = null;
                    var endNode = null;
                    while(node && (startNode === null || endNode === null)){
                        var nodeLength = node.nodeValue.length;
                        // if start of the selection falls into current node
                        if (start >= offset && start <= offset + nodeLength) range.setStart(startNode = node, start - offset);
                        // if end of the selection falls into current node
                        if (end >= offset && end <= offset + nodeLength) range.setEnd(endNode = node, end - offset);
                        offset += nodeLength;
                        node = node.nextSibling;
                    }
                    // If there is some text selected, remove it as we should replace it
                    if (start !== end) range.deleteContents();
                }
            }
            // If the node is a textarea and the range doesn't span outside the element
            //
            // Get the commonAncestorContainer of the selected range and test its type
            // If the node is of type `#text` it means that we're still working with text nodes within our textarea element
            // otherwise, if it's of type `#document` for example it means our selection spans outside the textarea.
            if ($cd79195d1a384c19$var$canManipulateViaTextNodes(input) && range.commonAncestorContainer.nodeName === '#text') // Finally insert a new node. The browser will automatically split start and end nodes into two if necessary
            range.insertNode(textNode);
            else {
                // If the node is not a textarea or the range spans outside a textarea the only way is to replace the whole value
                var value = input.value;
                input.value = value.slice(0, start) + text + value.slice(end);
            }
        }
        // Correct the cursor position to be at the end of the insertion
        input.setSelectionRange(start + text.length, start + text.length);
        // Notify any possible listeners of the change
        var e = document.createEvent('UIEvent');
        e.initEvent('input', true, false);
        input.dispatchEvent(e);
    }
}


parcelRequire("7fPBF");
function $57170ec975fca5ef$export$bc597f78f9f82ed0(_ref) {
    var { text: text, selection: selection, prefix: prefix, suffix: suffix = prefix } = _ref;
    var result = selection;
    if (text && text.length && selection.start === selection.end) result = $57170ec975fca5ef$export$669c0d5c0b374917(text, selection.start);
    if (result.start >= prefix.length && result.end <= text.length - suffix.length) {
        var selectedTextContext = text.slice(result.start - prefix.length, result.end + suffix.length);
        if (selectedTextContext.startsWith(prefix) && selectedTextContext.endsWith(suffix)) return {
            start: result.start - prefix.length,
            end: result.end + suffix.length
        };
    }
    return result;
}
function $57170ec975fca5ef$export$e41c12847640c21(_ref2) {
    var { text: text, selection: selection } = _ref2;
    var start = text.slice(0, selection.start).lastIndexOf('\n') + 1;
    var end = text.slice(selection.end).indexOf('\n') + selection.end;
    if (end === selection.end - 1) end = text.length;
    return {
        start: start,
        end: end
    };
}
function $57170ec975fca5ef$export$7a6ac73908e24730(text, startPosition) {
    if (text === void 0) text = '';
    if (startPosition === 0) return 0;
    // rules:
    // - If we're in the first line, no breaks are needed
    // - Otherwise there must be 2 breaks before the previous character. Depending on how many breaks exist already, we
    //      may need to insert 0, 1 or 2 breaks
    var neededBreaks = 2;
    var isInFirstLine = true;
    for(var i = startPosition - 1; i >= 0 && neededBreaks >= 0; i--)switch(text.charCodeAt(i)){
        case 32:
            continue;
        case 10:
            // line break
            neededBreaks--;
            isInFirstLine = false;
            break;
        default:
            return neededBreaks;
    }
    return isInFirstLine ? 0 : neededBreaks;
}
function $57170ec975fca5ef$export$ac47e5b3b6484ab3(text, startPosition) {
    if (text === void 0) text = '';
    if (startPosition === text.length - 1) return 0;
    // rules:
    // - If we're in the first line, no breaks are needed
    // - Otherwise there must be 2 breaks before the previous character. Depending on how many breaks exist already, we
    //      may need to insert 0, 1 or 2 breaks
    var neededBreaks = 2;
    var isInLastLine = true;
    for(var i = startPosition; i < text.length && neededBreaks >= 0; i++)switch(text.charCodeAt(i)){
        case 32:
            continue;
        case 10:
            neededBreaks--;
            isInLastLine = false;
            break;
        default:
            return neededBreaks;
    }
    return isInLastLine ? 0 : neededBreaks;
}
function $57170ec975fca5ef$export$669c0d5c0b374917(text, position) {
    if (!text) throw Error("Argument 'text' should be truthy");
    var isWordDelimiter = (c)=>c === ' ' || c.charCodeAt(0) === 10;
    // leftIndex is initialized to 0 because if selection is 0, it won't even enter the iteration
    var start = 0;
    // rightIndex is initialized to text.length because if selection is equal to text.length it won't even enter the interation
    var end = text.length;
    // iterate to the left
    for(var i = position; i - 1 > -1; i--)if (isWordDelimiter(text[i - 1])) {
        start = i;
        break;
    }
    // iterate to the right
    for(var _i = position; _i < text.length; _i++)if (isWordDelimiter(text[_i])) {
        end = _i;
        break;
    }
    return {
        start: start,
        end: end
    };
}
function $57170ec975fca5ef$export$3d4c04ed49431392(_ref3) {
    var { api: api, selectedText: selectedText, selection: selection, prefix: prefix, suffix: suffix = prefix } = _ref3;
    if (selectedText.length >= prefix.length + suffix.length && selectedText.startsWith(prefix) && selectedText.endsWith(suffix)) {
        api.replaceSelection(selectedText.slice(prefix.length, suffix.length ? -suffix.length : undefined));
        api.setSelectionRange({
            start: selection.start - prefix.length,
            end: selection.end - prefix.length
        });
    } else {
        api.replaceSelection("" + prefix + selectedText + suffix);
        api.setSelectionRange({
            start: selection.start + prefix.length,
            end: selection.end + prefix.length
        });
    }
}
function $57170ec975fca5ef$export$296d1daf426952fd(selectedText, insertBefore) {
    var lines = selectedText.split(/\n/);
    var insertionLength = 0;
    var modifiedText = lines.map((item, index)=>{
        if (typeof insertBefore === 'string') {
            if (item.startsWith(insertBefore)) {
                insertionLength -= insertBefore.length;
                return item.slice(insertBefore.length);
            }
            insertionLength += insertBefore.length;
            return insertBefore + item;
        }
        if (typeof insertBefore === 'function') {
            if (item.startsWith(insertBefore(item, index))) {
                insertionLength -= insertBefore(item, index).length;
                return item.slice(insertBefore(item, index).length);
            }
            var insertionResult = insertBefore(item, index);
            insertionLength += insertionResult.length;
            return insertBefore(item, index) + item;
        }
        throw Error('insertion is expected to be either a string or a function');
    }).join('\n');
    return {
        modifiedText: modifiedText,
        insertionLength: insertionLength
    };
}



var $1b1be813ac69f87a$export$73ba5813cda80a49 = {
    name: 'bold',
    keyCommand: 'bold',
    shortcuts: 'ctrlcmd+b',
    prefix: '**',
    buttonProps: {
        'aria-label': 'Add bold text (ctrl + b)',
        title: 'Add bold text (ctrl + b)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        role: "img",
        width: "12",
        height: "12",
        viewBox: "0 0 384 512",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M304.793 243.891c33.639-18.537 53.657-54.16 53.657-95.693 0-48.236-26.25-87.626-68.626-104.179C265.138 34.01 240.849 32 209.661 32H24c-8.837 0-16 7.163-16 16v33.049c0 8.837 7.163 16 16 16h33.113v318.53H24c-8.837 0-16 7.163-16 16V464c0 8.837 7.163 16 16 16h195.69c24.203 0 44.834-1.289 66.866-7.584C337.52 457.193 376 410.647 376 350.014c0-52.168-26.573-91.684-71.207-106.123zM142.217 100.809h67.444c16.294 0 27.536 2.019 37.525 6.717 15.828 8.479 24.906 26.502 24.906 49.446 0 35.029-20.32 56.79-53.029 56.79h-76.846V100.809zm112.642 305.475c-10.14 4.056-22.677 4.907-31.409 4.907h-81.233V281.943h84.367c39.645 0 63.057 25.38 63.057 63.057.001 28.425-13.66 52.483-34.782 61.284z"
        })
    }),
    execute: (state, api)=>{
        var newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
            text: state.text,
            selection: state.selection,
            prefix: state.command.prefix
        });
        var state1 = api.setSelectionRange(newSelectionRange);
        (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
            api: api,
            selectedText: state1.selectedText,
            selection: state.selection,
            prefix: state.command.prefix
        });
    }
};


parcelRequire("7fPBF");


var $53482fb090606392$export$7bb0d5c671655cc4 = {
    name: 'codeBlock',
    keyCommand: 'codeBlock',
    shortcuts: 'ctrlcmd+shift+j',
    prefix: '```',
    buttonProps: {
        'aria-label': 'Insert Code Block (ctrl + shift + j)',
        title: 'Insert Code Block (ctrl + shift +j)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        width: "13",
        height: "13",
        role: "img",
        viewBox: "0 0 156 156",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M110.85 120.575 43.7 120.483333 43.7083334 110.091667 110.85 110.191667 110.841667 120.583333 110.85 120.575ZM85.1333334 87.1916666 43.625 86.7083332 43.7083334 76.3166666 85.2083334 76.7916666 85.1333334 87.1916666 85.1333334 87.1916666ZM110.841667 53.4166666 43.7 53.3166666 43.7083334 42.925 110.85 43.025 110.841667 53.4166666ZM36 138C27.2916666 138 20.75 136.216667 16.4 132.666667 12.1333334 129.2 10 124.308333 10 118L10 95.3333332C10 91.0666666 9.25 88.1333332 7.7333334 86.5333332 6.3166668 84.8416666 3.7333334 84 0 84L0 72C3.7333334 72 6.3083334 71.2 7.7333334 69.6 9.2416668 67.9083334 10 64.9333334 10 60.6666666L10 38C10 31.775 12.1333334 26.8833334 16.4 23.3333332 20.7583334 19.7749998 27.2916666 18 36 18L40.6666668 18 40.6666668 30 36 30C34.0212222 29.9719277 32.1263151 30.7979128 30.8 32.2666666 29.3605875 33.8216362 28.5938182 35.8823287 28.6666668 38L28.6666668 60.6666666C28.6666668 67.5083332 26.6666668 72.4 22.6666668 75.3333332 20.9317416 76.7274684 18.8640675 77.6464347 16.6666668 78 18.8916668 78.35 20.8916668 79.2416666 22.6666668 80.6666666 26.6666668 83.95 28.6666668 88.8416666 28.6666668 95.3333332L28.6666668 118C28.6666668 120.308333 29.3750002 122.216667 30.8 123.733333 32.2166666 125.241667 33.9583334 126 36 126L40.6666668 126 40.6666668 138 36 138 36 138ZM114.116667 126 118.783333 126C120.833333 126 122.566667 125.241667 123.983333 123.733333 125.422746 122.178364 126.189515 120.117671 126.116667 118L126.116667 95.3333332C126.116667 88.8333332 128.116667 83.9499998 132.116667 80.6666666 133.9 79.2416666 135.9 78.35 138.116667 78 135.919156 77.6468047 133.851391 76.7277979 132.116667 75.3333332 128.116667 72.3999998 126.116667 67.5 126.116667 60.6666666L126.116667 38C126.189515 35.8823287 125.422746 33.8216361 123.983333 32.2666666 122.657018 30.7979128 120.762111 29.9719277 118.783333 30L114.116667 30 114.116667 18 118.783333 18C127.5 18 133.983333 19.775 138.25 23.3333332 142.608333 26.8833332 144.783333 31.7749998 144.783333 38L144.783333 60.6666666C144.783333 64.9333332 145.5 67.9083332 146.916667 69.6 148.433333 71.2 151.05 72 154.783333 72L154.783333 84C151.05 84 148.433333 84.8333334 146.916667 86.5333332 145.5 88.1333332 144.783333 91.0666666 144.783333 95.3333332L144.783333 118C144.783333 124.308333 142.616667 129.2 138.25 132.666667 133.983333 136.216667 127.5 138 118.783333 138L114.116667 138 114.116667 126 114.116667 126Z"
        })
    }),
    execute: (state, api)=>{
        var newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
            text: state.text,
            selection: state.selection,
            prefix: '```\n',
            suffix: '\n```'
        });
        var state1 = api.setSelectionRange(newSelectionRange);
        // Based on context determine if new line is needed or not
        var prefix = '\n```\n';
        var suffix = '\n```\n';
        if (state1.selectedText.length >= prefix.length + suffix.length - 2 && state1.selectedText.startsWith(prefix) && state1.selectedText.endsWith(suffix)) {
            // Remove code block
            prefix = '```\n';
            suffix = '\n```';
        } else {
            // Add code block
            if (state1.selection.start >= 1 && state.text.slice(state1.selection.start - 1, state1.selection.start) === '\n' || state1.selection.start === 0) prefix = '```\n';
            if (state1.selection.end <= state.text.length - 1 && state.text.slice(state1.selection.end, state1.selection.end + 1) === '\n' || state1.selection.end === state.text.length) suffix = '\n```';
        }
        var newSelectionRange2 = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
            text: state.text,
            selection: state.selection,
            prefix: prefix,
            suffix: suffix
        });
        var state2 = api.setSelectionRange(newSelectionRange2);
        (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
            api: api,
            selectedText: state2.selectedText,
            selection: state.selection,
            prefix: prefix,
            suffix: suffix
        });
    }
};
var $53482fb090606392$export$6565f9f03506010b = {
    name: 'code',
    keyCommand: 'code',
    shortcuts: 'ctrlcmd+j',
    prefix: '`',
    buttonProps: {
        'aria-label': 'Insert code (ctrl + j)',
        title: 'Insert code (ctrl + j)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        width: "14",
        height: "14",
        role: "img",
        viewBox: "0 0 640 512",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M278.9 511.5l-61-17.7c-6.4-1.8-10-8.5-8.2-14.9L346.2 8.7c1.8-6.4 8.5-10 14.9-8.2l61 17.7c6.4 1.8 10 8.5 8.2 14.9L293.8 503.3c-1.9 6.4-8.5 10.1-14.9 8.2zm-114-112.2l43.5-46.4c4.6-4.9 4.3-12.7-.8-17.2L117 256l90.6-79.7c5.1-4.5 5.5-12.3.8-17.2l-43.5-46.4c-4.5-4.8-12.1-5.1-17-.5L3.8 247.2c-5.1 4.7-5.1 12.8 0 17.5l144.1 135.1c4.9 4.6 12.5 4.4 17-.5zm327.2.6l144.1-135.1c5.1-4.7 5.1-12.8 0-17.5L492.1 112.1c-4.8-4.5-12.4-4.3-17 .5L431.6 159c-4.6 4.9-4.3 12.7.8 17.2L523 256l-90.6 79.7c-5.1 4.5-5.5 12.3-.8 17.2l43.5 46.4c4.5 4.9 12.1 5.1 17 .6z"
        })
    }),
    execute: (state, api)=>{
        if (state.selectedText.indexOf('\n') === -1) {
            var newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
                text: state.text,
                selection: state.selection,
                prefix: state.command.prefix
            });
            var state1 = api.setSelectionRange(newSelectionRange);
            (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
                api: api,
                selectedText: state1.selectedText,
                selection: state.selection,
                prefix: state.command.prefix
            });
        } else $53482fb090606392$export$7bb0d5c671655cc4.execute(state, api);
    }
};


parcelRequire("7fPBF");


var $9708e0178a5760f3$export$4a34f930e789283c = {
    name: 'comment',
    keyCommand: 'comment',
    shortcuts: 'ctrlcmd+/',
    prefix: '<!-- ',
    suffix: ' -->',
    buttonProps: {
        'aria-label': 'Insert comment (ctrl + /)',
        title: 'Insert comment (ctrl + /)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        height: "1em",
        width: "1em",
        viewBox: "0 0 25 25",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("polygon", {
                    points: ".769 .727 24.981 .727 24.981 24.727 .769 24.727"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    stroke: "currentColor",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "3",
                    d: "M12.625,23.8787879 L8.125,19.6969697 L5.125,19.6969697 C2.63971863,19.6969697 0.625,17.8247059 0.625,15.5151515 L0.625,7.15151515 C0.625,4.84196074 2.63971863,2.96969697 5.125,2.96969697 L20.125,2.96969697 C22.6102814,2.96969697 24.625,4.84196074 24.625,7.15151515 L24.625,15.5151515 C24.625,17.8247059 22.6102814,19.6969697 20.125,19.6969697 L17.125,19.6969697 L12.625,23.8787879"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    stroke: "currentColor",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "3",
                    d: "M10.625,8.54545455 L7.25,11.3333333 L10.625,14.1212121 M15.6875,8.54545455 L19.0625,11.3333333 L15.6875,14.1212121"
                })
            ]
        })
    }),
    execute: (state, api)=>{
        var newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
            text: state.text,
            selection: state.selection,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
        var state1 = api.setSelectionRange(newSelectionRange);
        (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
            api: api,
            selectedText: state1.selectedText,
            selection: state.selection,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
    }
};


var $915c6594da096284$export$e8c9778bf415dd08 = {
    keyCommand: 'divider'
};


parcelRequire("7fPBF");

var $d82069e0665e2255$export$af93ab412ae68734 = {
    name: 'fullscreen',
    keyCommand: 'fullscreen',
    shortcuts: 'ctrlcmd+0',
    value: 'fullscreen',
    buttonProps: {
        'aria-label': 'Toggle fullscreen (ctrl + 0)',
        title: 'Toggle fullscreen (ctrl+ 0)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 520 520",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M118 171.133334L118 342.200271C118 353.766938 126.675 365.333605 141.133333 365.333605L382.634614 365.333605C394.201281 365.333605 405.767948 356.658605 405.767948 342.200271L405.767948 171.133334C405.767948 159.566667 397.092948 148 382.634614 148L141.133333 148C126.674999 148 117.999999 156.675 118 171.133334zM465.353591 413.444444L370 413.444444 370 471.222222 474.0221 471.222222C500.027624 471.222222 520.254143 451 520.254143 425L520.254143 321 462.464089 321 462.464089 413.444444 465.353591 413.444444zM471.0221 43L367 43 367 100.777778 462.353591 100.777778 462.353591 196.111111 520.143647 196.111111 520.143647 89.2222219C517.254144 63.2222219 497.027624 43 471.0221 43zM57.7900547 100.777778L153.143646 100.777778 153.143646 43 46.2320439 43C20.2265191 43 0 63.2222219 0 89.2222219L0 193.222222 57.7900547 193.222222 57.7900547 100.777778zM57.7900547 321L0 321 0 425C0 451 20.2265191 471.222222 46.2320439 471.222223L150.254143 471.222223 150.254143 413.444445 57.7900547 413.444445 57.7900547 321z"
        })
    }),
    execute: (state, api, dispatch, executeCommandState, shortcuts)=>{
        api.textArea.focus();
        if (shortcuts && dispatch && executeCommandState) dispatch({
            fullscreen: !executeCommandState.fullscreen
        });
    }
};


function $75774ac5799c70fb$export$2e2bcd8739ae039(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}



parcelRequire("7fPBF");

var $1455182fb6186464$export$e5e25fbcc1f7affe = (arr, options)=>{
    var data = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        children: arr,
        icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
            width: "12",
            height: "12",
            viewBox: "0 0 520 520",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                d: "M15.7083333,468 C7.03242448,468 0,462.030833 0,454.666667 L0,421.333333 C0,413.969167 7.03242448,408 15.7083333,408 L361.291667,408 C369.967576,408 377,413.969167 377,421.333333 L377,454.666667 C377,462.030833 369.967576,468 361.291667,468 L15.7083333,468 Z M21.6666667,366 C9.69989583,366 0,359.831861 0,352.222222 L0,317.777778 C0,310.168139 9.69989583,304 21.6666667,304 L498.333333,304 C510.300104,304 520,310.168139 520,317.777778 L520,352.222222 C520,359.831861 510.300104,366 498.333333,366 L21.6666667,366 Z M136.835938,64 L136.835937,126 L107.25,126 L107.25,251 L40.75,251 L40.75,126 L-5.68434189e-14,126 L-5.68434189e-14,64 L136.835938,64 Z M212,64 L212,251 L161.648438,251 L161.648438,64 L212,64 Z M378,64 L378,126 L343.25,126 L343.25,251 L281.75,251 L281.75,126 L238,126 L238,64 L378,64 Z M449.047619,189.550781 L520,189.550781 L520,251 L405,251 L405,64 L449.047619,64 L449.047619,189.550781 Z"
            })
        }),
        execute: ()=>{}
    }, options, {
        keyCommand: 'group'
    });
    if (Array.isArray(data.children)) data.children = data.children.map((_ref)=>{
        var item = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ((0, $75774ac5799c70fb$export$2e2bcd8739ae039)(_ref), _ref));
        item.parent = data;
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, item);
    });
    return data;
};


parcelRequire("7fPBF");


var $f1090649299d43a9$export$b4adb3f464574dcf = {
    name: 'hr',
    keyCommand: 'hr',
    shortcuts: 'ctrlcmd+h',
    prefix: '\n\n---\n',
    suffix: '',
    buttonProps: {
        'aria-label': 'Insert HR (ctrl + h)',
        title: 'Insert HR (ctrl + h)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 175 175",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M0,129 L175,129 L175,154 L0,154 L0,129 Z M3,9 L28.2158203,9 L28.2158203,47.9824219 L55.7695313,47.9824219 L55.7695313,9 L81.0966797,9 L81.0966797,107.185547 L55.7695313,107.185547 L55.7695313,68.0214844 L28.2158203,68.0214844 L28.2158203,107.185547 L3,107.185547 L3,9 Z M93.1855469,100.603516 L93.1855469,19 L135.211914,19 C143.004922,19 148.960917,19.6679621 153.080078,21.0039063 C157.199239,22.3398504 160.520495,24.8168764 163.043945,28.4350586 C165.567395,32.0532407 166.829102,36.459935 166.829102,41.6552734 C166.829102,46.1826398 165.864267,50.0883625 163.93457,53.3725586 C162.004873,56.6567547 159.351579,59.3193257 155.974609,61.3603516 C153.822255,62.6591862 150.872089,63.7353473 147.124023,64.5888672 C150.129898,65.5908253 152.319329,66.5927684 153.692383,67.5947266 C154.620122,68.2626987 155.965323,69.6913953 157.728027,71.8808594 C159.490731,74.0703234 160.668942,75.7587831 161.262695,76.9462891 L173,100.603516 L144.953125,100.603516 L131.482422,75.6660156 C129.775382,72.4374839 128.253913,70.3408251 126.917969,69.3759766 C125.0996,68.1142515 123.040051,67.4833984 120.739258,67.4833984 L118.512695,67.4833984 L118.512695,100.603516 L93.1855469,100.603516 Z M118.512695,52.0644531 L129.144531,52.0644531 C130.294928,52.0644531 132.521468,51.6933631 135.824219,50.9511719 C137.494149,50.6171858 138.857905,49.7636787 139.915527,48.390625 C140.97315,47.0175713 141.501953,45.4404386 141.501953,43.6591797 C141.501953,41.0244009 140.667001,39.0019602 138.99707,37.5917969 C137.32714,36.1816336 134.191429,35.4765625 129.589844,35.4765625 L117.512695,35.4765625 L118.512695,52.0644531 Z",
            transform: "translate(0 9)"
        })
    }),
    execute: (state, api)=>{
        var newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
            text: state.text,
            selection: state.selection,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
        var state1 = api.setSelectionRange(newSelectionRange);
        if (state1.selectedText.length >= state.command.prefix.length && state1.selectedText.startsWith(state.command.prefix)) // Remove
        (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
            api: api,
            selectedText: state1.selectedText,
            selection: state.selection,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
        else {
            // Add
            state1 = api.setSelectionRange({
                start: state.selection.start,
                end: state.selection.start
            });
            (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
                api: api,
                selectedText: state1.selectedText,
                selection: state.selection,
                prefix: state.command.prefix,
                suffix: state.command.suffix
            });
        }
    }
};


parcelRequire("7fPBF");


var $23179bbad19e1934$export$5c452ff88e35e47d = {
    name: 'image',
    keyCommand: 'image',
    shortcuts: 'ctrlcmd+k',
    prefix: '![image](',
    suffix: ')',
    buttonProps: {
        'aria-label': 'Add image (ctrl + k)',
        title: 'Add image (ctrl + k)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        width: "13",
        height: "13",
        viewBox: "0 0 20 20",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M15 9c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4-7H1c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm-1 13l-6-5-2 2-4-5-4 8V4h16v11z"
        })
    }),
    execute: (state, api)=>{
        var newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
            text: state.text,
            selection: state.selection,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
        var state1 = api.setSelectionRange(newSelectionRange);
        if (state1.selectedText.includes('http') || state1.selectedText.includes('www')) (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
            api: api,
            selectedText: state1.selectedText,
            selection: state.selection,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
        else {
            newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
                text: state.text,
                selection: state.selection,
                prefix: '![',
                suffix: ']()'
            });
            state1 = api.setSelectionRange(newSelectionRange);
            if (state1.selectedText.length === 0) (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
                api: api,
                selectedText: state1.selectedText,
                selection: state.selection,
                prefix: '![image',
                suffix: '](url)'
            });
            else (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
                api: api,
                selectedText: state1.selectedText,
                selection: state.selection,
                prefix: '![',
                suffix: ']()'
            });
        }
    }
};


parcelRequire("7fPBF");


var $272797a41233c2a2$export$5540da1282cbf565 = {
    name: 'italic',
    keyCommand: 'italic',
    shortcuts: 'ctrlcmd+i',
    prefix: '*',
    buttonProps: {
        'aria-label': 'Add italic text (ctrl + i)',
        title: 'Add italic text (ctrl + i)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        "data-name": "italic",
        width: "12",
        height: "12",
        role: "img",
        viewBox: "0 0 320 512",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M204.758 416h-33.849l62.092-320h40.725a16 16 0 0 0 15.704-12.937l6.242-32C297.599 41.184 290.034 32 279.968 32H120.235a16 16 0 0 0-15.704 12.937l-6.242 32C96.362 86.816 103.927 96 113.993 96h33.846l-62.09 320H46.278a16 16 0 0 0-15.704 12.935l-6.245 32C22.402 470.815 29.967 480 40.034 480h158.479a16 16 0 0 0 15.704-12.935l6.245-32c1.927-9.88-5.638-19.065-15.704-19.065z"
        })
    }),
    execute: (state, api)=>{
        var newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
            text: state.text,
            selection: state.selection,
            prefix: state.command.prefix
        });
        var state1 = api.setSelectionRange(newSelectionRange);
        (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
            api: api,
            selectedText: state1.selectedText,
            selection: state.selection,
            prefix: state.command.prefix
        });
    }
};


parcelRequire("7fPBF");


var $aacc1dc31941f636$export$9c30223ca0a664fb = {
    name: 'link',
    keyCommand: 'link',
    shortcuts: 'ctrlcmd+l',
    prefix: '[',
    suffix: '](url)',
    buttonProps: {
        'aria-label': 'Add a link (ctrl + l)',
        title: 'Add a link (ctrl + l)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        "data-name": "italic",
        width: "12",
        height: "12",
        role: "img",
        viewBox: "0 0 520 520",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M331.751196,182.121107 C392.438214,241.974735 391.605313,337.935283 332.11686,396.871226 C332.005129,396.991316 331.873084,397.121413 331.751196,397.241503 L263.493918,464.491645 C203.291404,523.80587 105.345257,523.797864 45.151885,464.491645 C-15.0506283,405.187427 -15.0506283,308.675467 45.151885,249.371249 L82.8416853,212.237562 C92.836501,202.39022 110.049118,208.9351 110.56511,222.851476 C111.223305,240.5867 114.451306,258.404985 120.407566,275.611815 C122.424812,281.438159 120.983487,287.882964 116.565047,292.23621 L103.272145,305.332975 C74.8052033,333.379887 73.9123737,379.047937 102.098973,407.369054 C130.563883,435.969378 177.350591,436.139505 206.033884,407.879434 L274.291163,340.6393 C302.9257,312.427264 302.805844,266.827265 274.291163,238.733318 C270.531934,235.036561 266.74528,232.16442 263.787465,230.157924 C259.544542,227.2873 256.928256,222.609848 256.731165,217.542518 C256.328935,206.967633 260.13184,196.070508 268.613213,187.714278 L289.998463,166.643567 C295.606326,161.118448 304.403592,160.439942 310.906317,164.911276 C318.353355,170.034591 325.328531,175.793397 331.751196,182.121107 Z M240.704978,55.4828366 L172.447607,122.733236 C172.325719,122.853326 172.193674,122.983423 172.081943,123.103513 C117.703294,179.334654 129.953294,261.569283 185.365841,328.828764 C191.044403,335.721376 198.762988,340.914712 206.209732,346.037661 C212.712465,350.509012 221.510759,349.829503 227.117615,344.305363 L248.502893,323.234572 C256.984277,314.87831 260.787188,303.981143 260.384957,293.406218 C260.187865,288.338869 257.571576,283.661398 253.328648,280.790763 C250.370829,278.78426 246.58417,275.912107 242.824936,272.215337 C214.310216,244.121282 206.209732,204.825874 229.906702,179.334654 L298.164073,112.094263 C326.847404,83.8340838 373.633159,84.0042113 402.099123,112.604645 C430.285761,140.92587 429.393946,186.594095 400.92595,214.641114 L387.63303,227.737929 C383.214584,232.091191 381.773257,238.536021 383.790506,244.362388 C389.746774,261.569283 392.974779,279.387637 393.632975,297.122928 C394.149984,311.039357 411.361608,317.584262 421.356437,307.736882 L459.046288,270.603053 C519.249898,211.29961 519.249898,114.787281 459.047304,55.4828366 C398.853851,-3.82360914 300.907572,-3.83161514 240.704978,55.4828366 Z"
        })
    }),
    execute: (state, api)=>{
        var newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
            text: state.text,
            selection: state.selection,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
        var state1 = api.setSelectionRange(newSelectionRange);
        if (state1.selectedText.includes('http') || state1.selectedText.includes('www')) {
            newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
                text: state.text,
                selection: state.selection,
                prefix: '[](',
                suffix: ')'
            });
            state1 = api.setSelectionRange(newSelectionRange);
            (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
                api: api,
                selectedText: state1.selectedText,
                selection: state.selection,
                prefix: '[](',
                suffix: ')'
            });
        } else if (state1.selectedText.length === 0) (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
            api: api,
            selectedText: state1.selectedText,
            selection: state.selection,
            prefix: '[title',
            suffix: '](url)'
        });
        else (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
            api: api,
            selectedText: state1.selectedText,
            selection: state.selection,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
    }
};


parcelRequire("7fPBF");


var $8a2e0a4d28b56dc0$export$8690041b1e066766 = (state, api, insertBefore)=>{
    var newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
        text: state.text,
        selection: state.selection,
        prefix: state.command.prefix
    });
    var state1 = api.setSelectionRange(newSelectionRange);
    var breaksBeforeCount = (0, $57170ec975fca5ef$export$7a6ac73908e24730)(state1.text, state1.selection.start);
    var breaksBefore = Array(breaksBeforeCount + 1).join('\n');
    var breaksAfterCount = (0, $57170ec975fca5ef$export$ac47e5b3b6484ab3)(state1.text, state1.selection.end);
    var breaksAfter = Array(breaksAfterCount + 1).join('\n');
    var { modifiedText: modifiedText, insertionLength: insertionLength } = (0, $57170ec975fca5ef$export$296d1daf426952fd)(state1.selectedText, insertBefore);
    if (insertionLength < 0) {
        // Remove
        var selectionStart = state1.selection.start;
        var selectionEnd = state1.selection.end;
        if (state1.selection.start > 0 && state.text.slice(state1.selection.start - 1, state1.selection.start) === '\n') selectionStart -= 1;
        if (state1.selection.end < state.text.length - 1 && state.text.slice(state1.selection.end, state1.selection.end + 1) === '\n') selectionEnd += 1;
        api.setSelectionRange({
            start: selectionStart,
            end: selectionEnd
        });
        api.replaceSelection("" + modifiedText);
        api.setSelectionRange({
            start: selectionStart,
            end: selectionStart + modifiedText.length
        });
    } else {
        // Add
        api.replaceSelection("" + breaksBefore + modifiedText + breaksAfter);
        var _selectionStart = state1.selection.start + breaksBeforeCount;
        var _selectionEnd = _selectionStart + modifiedText.length;
        api.setSelectionRange({
            start: _selectionStart,
            end: _selectionEnd
        });
    }
};
var $8a2e0a4d28b56dc0$export$6213d25cd68831c1 = {
    name: 'unordered-list',
    keyCommand: 'list',
    shortcuts: 'ctrl+shift+u',
    prefix: '- ',
    buttonProps: {
        'aria-label': 'Add unordered list (ctrl + shift + u)',
        title: 'Add unordered list (ctrl + shift + u)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        "data-name": "unordered-list",
        width: "12",
        height: "12",
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M96 96c0 26.51-21.49 48-48 48S0 122.51 0 96s21.49-48 48-48 48 21.49 48 48zM48 208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm0 160c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm96-236h352c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
        })
    }),
    execute: (state, api)=>{
        $8a2e0a4d28b56dc0$export$8690041b1e066766(state, api, '- ');
    }
};
var $8a2e0a4d28b56dc0$export$4d4094269a49853c = {
    name: 'ordered-list',
    keyCommand: 'list',
    shortcuts: 'ctrl+shift+o',
    prefix: '1. ',
    buttonProps: {
        'aria-label': 'Add ordered list (ctrl + shift + o)',
        title: 'Add ordered list (ctrl + shift + o)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        "data-name": "ordered-list",
        width: "12",
        height: "12",
        role: "img",
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M3.263 139.527c0-7.477 3.917-11.572 11.573-11.572h15.131V88.078c0-5.163.534-10.503.534-10.503h-.356s-1.779 2.67-2.848 3.738c-4.451 4.273-10.504 4.451-15.666-1.068l-5.518-6.231c-5.342-5.341-4.984-11.216.534-16.379l21.72-19.938C32.815 33.602 36.732 32 42.785 32H54.89c7.656 0 11.749 3.916 11.749 11.572v84.384h15.488c7.655 0 11.572 4.094 11.572 11.572v8.901c0 7.477-3.917 11.572-11.572 11.572H14.836c-7.656 0-11.573-4.095-11.573-11.572v-8.902zM2.211 304.591c0-47.278 50.955-56.383 50.955-69.165 0-7.18-5.954-8.755-9.28-8.755-3.153 0-6.479 1.051-9.455 3.852-5.079 4.903-10.507 7.004-16.111 2.451l-8.579-6.829c-5.779-4.553-7.18-9.805-2.803-15.409C13.592 201.981 26.025 192 47.387 192c19.437 0 44.476 10.506 44.476 39.573 0 38.347-46.753 46.402-48.679 56.909h39.049c7.529 0 11.557 4.027 11.557 11.382v8.755c0 7.354-4.028 11.382-11.557 11.382h-67.94c-7.005 0-12.083-4.028-12.083-11.382v-4.028zM5.654 454.61l5.603-9.28c3.853-6.654 9.105-7.004 15.584-3.152 4.903 2.101 9.63 3.152 14.359 3.152 10.155 0 14.358-3.502 14.358-8.23 0-6.654-5.604-9.106-15.934-9.106h-4.728c-5.954 0-9.28-2.101-12.258-7.88l-1.05-1.926c-2.451-4.728-1.226-9.806 2.801-14.884l5.604-7.004c6.829-8.405 12.257-13.483 12.257-13.483v-.35s-4.203 1.051-12.608 1.051H16.685c-7.53 0-11.383-4.028-11.383-11.382v-8.755c0-7.53 3.853-11.382 11.383-11.382h58.484c7.529 0 11.382 4.027 11.382 11.382v3.327c0 5.778-1.401 9.806-5.079 14.183l-17.509 20.137c19.611 5.078 28.716 20.487 28.716 34.845 0 21.363-14.358 44.126-48.503 44.126-16.636 0-28.192-4.728-35.896-9.455-5.779-4.202-6.304-9.805-2.626-15.934zM144 132h352c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
        })
    }),
    execute: (state, api)=>{
        $8a2e0a4d28b56dc0$export$8690041b1e066766(state, api, (item, index)=>index + 1 + ". ");
    }
};
var $8a2e0a4d28b56dc0$export$2edba76228b93c06 = {
    name: 'checked-list',
    keyCommand: 'list',
    shortcuts: 'ctrl+shift+c',
    prefix: '- [ ] ',
    buttonProps: {
        'aria-label': 'Add checked list (ctrl + shift + c)',
        title: 'Add checked list (ctrl + shift + c)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        "data-name": "checked-list",
        width: "12",
        height: "12",
        role: "img",
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M208 132h288c8.8 0 16-7.2 16-16V76c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16zm0 160h288c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16zm0 160h288c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16zM64 368c-26.5 0-48.6 21.5-48.6 48s22.1 48 48.6 48 48-21.5 48-48-21.5-48-48-48zm92.5-299l-72.2 72.2-15.6 15.6c-4.7 4.7-12.9 4.7-17.6 0L3.5 109.4c-4.7-4.7-4.7-12.3 0-17l15.7-15.7c4.7-4.7 12.3-4.7 17 0l22.7 22.1 63.7-63.3c4.7-4.7 12.3-4.7 17 0l17 16.5c4.6 4.7 4.6 12.3-.1 17zm0 159.6l-72.2 72.2-15.7 15.7c-4.7 4.7-12.9 4.7-17.6 0L3.5 269c-4.7-4.7-4.7-12.3 0-17l15.7-15.7c4.7-4.7 12.3-4.7 17 0l22.7 22.1 63.7-63.7c4.7-4.7 12.3-4.7 17 0l17 17c4.6 4.6 4.6 12.2-.1 16.9z"
        })
    }),
    execute: (state, api)=>{
        $8a2e0a4d28b56dc0$export$8690041b1e066766(state, api, (item, index)=>"- [ ] ");
    }
};


parcelRequire("7fPBF");

var $47528ad1eaeb011b$export$bb03fe4fe5a686f2 = {
    name: 'preview',
    keyCommand: 'preview',
    value: 'preview',
    shortcuts: 'ctrlcmd+9',
    buttonProps: {
        'aria-label': 'Preview code (ctrl + 9)',
        title: 'Preview code (ctrl + 9)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 520 520",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("polygon", {
                fill: "currentColor",
                points: "0 71.293 0 122 38.023 123 38.023 398 0 397 0 449.707 91.023 450.413 91.023 72.293"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("polygon", {
                fill: "currentColor",
                points: "148.023 72.293 520 71.293 520 122 200.023 124 200.023 397 520 396 520 449.707 148.023 450.413"
            })
        ]
    }),
    execute: (state, api, dispatch, executeCommandState, shortcuts)=>{
        api.textArea.focus();
        if (shortcuts && dispatch && executeCommandState) dispatch({
            preview: 'preview'
        });
    }
};
var $47528ad1eaeb011b$export$5f58ca08fd242e88 = {
    name: 'edit',
    keyCommand: 'preview',
    value: 'edit',
    shortcuts: 'ctrlcmd+7',
    buttonProps: {
        'aria-label': 'Edit code (ctrl + 7)',
        title: 'Edit code (ctrl + 7)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 520 520",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("polygon", {
                fill: "currentColor",
                points: "0 71.293 0 122 319 122 319 397 0 397 0 449.707 372 449.413 372 71.293"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("polygon", {
                fill: "currentColor",
                points: "429 71.293 520 71.293 520 122 481 123 481 396 520 396 520 449.707 429 449.413"
            })
        ]
    }),
    execute: (state, api, dispatch, executeCommandState, shortcuts)=>{
        api.textArea.focus();
        if (shortcuts && dispatch && executeCommandState) dispatch({
            preview: 'edit'
        });
    }
};
var $47528ad1eaeb011b$export$3449b126b33d0f8f = {
    name: 'live',
    keyCommand: 'preview',
    value: 'live',
    shortcuts: 'ctrlcmd+8',
    buttonProps: {
        'aria-label': 'Live code (ctrl + 8)',
        title: 'Live code (ctrl + 8)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 520 520",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("polygon", {
                fill: "currentColor",
                points: "0 71.293 0 122 179 122 179 397 0 397 0 449.707 232 449.413 232 71.293"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("polygon", {
                fill: "currentColor",
                points: "289 71.293 520 71.293 520 122 341 123 341 396 520 396 520 449.707 289 449.413"
            })
        ]
    }),
    execute: (state, api, dispatch, executeCommandState, shortcuts)=>{
        api.textArea.focus();
        if (shortcuts && dispatch && executeCommandState) dispatch({
            preview: 'live'
        });
    }
};


parcelRequire("7fPBF");


var $56cbd7f6d3e478f3$export$ee7a15c61bfdeb11 = {
    name: 'quote',
    keyCommand: 'quote',
    shortcuts: 'ctrlcmd+q',
    prefix: '> ',
    buttonProps: {
        'aria-label': 'Insert a quote (ctrl + q)',
        title: 'Insert a quote (ctrl + q)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 520 520",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M520,95.75 L520,225.75 C520,364.908906 457.127578,437.050625 325.040469,472.443125 C309.577578,476.586875 294.396016,464.889922 294.396016,448.881641 L294.396016,414.457031 C294.396016,404.242891 300.721328,395.025078 310.328125,391.554687 C377.356328,367.342187 414.375,349.711094 414.375,274.5 L341.25,274.5 C314.325781,274.5 292.5,252.674219 292.5,225.75 L292.5,95.75 C292.5,68.8257812 314.325781,47 341.25,47 L471.25,47 C498.174219,47 520,68.8257812 520,95.75 Z M178.75,47 L48.75,47 C21.8257813,47 0,68.8257812 0,95.75 L0,225.75 C0,252.674219 21.8257813,274.5 48.75,274.5 L121.875,274.5 C121.875,349.711094 84.8563281,367.342187 17.828125,391.554687 C8.22132813,395.025078 1.89601563,404.242891 1.89601563,414.457031 L1.89601563,448.881641 C1.89601563,464.889922 17.0775781,476.586875 32.5404687,472.443125 C164.627578,437.050625 227.5,364.908906 227.5,225.75 L227.5,95.75 C227.5,68.8257812 205.674219,47 178.75,47 Z"
        })
    }),
    execute: (state, api)=>{
        var newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
            text: state.text,
            selection: state.selection,
            prefix: state.command.prefix
        });
        var state1 = api.setSelectionRange(newSelectionRange);
        var breaksBeforeCount = (0, $57170ec975fca5ef$export$7a6ac73908e24730)(state1.text, state1.selection.start);
        var breaksBefore = Array(breaksBeforeCount + 1).join('\n');
        var breaksAfterCount = (0, $57170ec975fca5ef$export$ac47e5b3b6484ab3)(state1.text, state1.selection.end);
        var breaksAfter = Array(breaksAfterCount + 1).join('\n');
        var modifiedText = (0, $57170ec975fca5ef$export$296d1daf426952fd)(state1.selectedText, state.command.prefix);
        api.replaceSelection("" + breaksBefore + modifiedText.modifiedText + breaksAfter);
        var selectionStart = state1.selection.start + breaksBeforeCount;
        var selectionEnd = selectionStart + modifiedText.modifiedText.length;
        api.setSelectionRange({
            start: selectionStart,
            end: selectionEnd
        });
    }
};


parcelRequire("7fPBF");


var $1c24713855f6d6fa$export$19426ff118fe8be = {
    name: 'strikethrough',
    keyCommand: 'strikethrough',
    shortcuts: 'ctrl+shift+x',
    buttonProps: {
        'aria-label': 'Add strikethrough text (ctrl + shift + x)',
        title: 'Add strikethrough text (ctrl + shift + x)'
    },
    prefix: '~~',
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        "data-name": "strikethrough",
        width: "12",
        height: "12",
        role: "img",
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M496 288H16c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h480c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16zm-214.666 16c27.258 12.937 46.524 28.683 46.524 56.243 0 33.108-28.977 53.676-75.621 53.676-32.325 0-76.874-12.08-76.874-44.271V368c0-8.837-7.164-16-16-16H113.75c-8.836 0-16 7.163-16 16v19.204c0 66.845 77.717 101.82 154.487 101.82 88.578 0 162.013-45.438 162.013-134.424 0-19.815-3.618-36.417-10.143-50.6H281.334zm-30.952-96c-32.422-13.505-56.836-28.946-56.836-59.683 0-33.92 30.901-47.406 64.962-47.406 42.647 0 64.962 16.593 64.962 32.985V136c0 8.837 7.164 16 16 16h45.613c8.836 0 16-7.163 16-16v-30.318c0-52.438-71.725-79.875-142.575-79.875-85.203 0-150.726 40.972-150.726 125.646 0 22.71 4.665 41.176 12.777 56.547h129.823z"
        })
    }),
    execute: (state, api)=>{
        var newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
            text: state.text,
            selection: state.selection,
            prefix: state.command.prefix
        });
        var state1 = api.setSelectionRange(newSelectionRange);
        (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
            api: api,
            selectedText: state1.selectedText,
            selection: state.selection,
            prefix: state.command.prefix
        });
    }
};



parcelRequire("7fPBF");
parcelRequire("7fPBF");


var $88569c0108189c0e$export$32fde58c912ee8a = {
    name: 'heading1',
    keyCommand: 'heading1',
    shortcuts: 'ctrlcmd+1',
    prefix: '# ',
    suffix: '',
    buttonProps: {
        'aria-label': 'Insert Heading 1 (ctrl + 1)',
        title: 'Insert Heading 1 (ctrl + 1)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: {
            fontSize: 18,
            textAlign: 'left'
        },
        children: "Heading 1"
    }),
    execute: (state, api)=>{
        (0, $8d3503b55bbc42ae$export$cd14d34733017854)({
            state: state,
            api: api,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
    }
};
var $88569c0108189c0e$export$bafb53d6d28bbb73 = $88569c0108189c0e$export$32fde58c912ee8a;




function $8d3503b55bbc42ae$export$cd14d34733017854(_ref) {
    var { state: state, api: api, prefix: prefix, suffix: suffix = prefix } = _ref;
    var newSelectionRange = (0, $57170ec975fca5ef$export$e41c12847640c21)({
        text: state.text,
        selection: state.selection
    });
    var state1 = api.setSelectionRange(newSelectionRange);
    (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
        api: api,
        selectedText: state1.selectedText,
        selection: state.selection,
        prefix: prefix,
        suffix: suffix
    });
}
var $8d3503b55bbc42ae$export$46e4a324ac90507f = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $88569c0108189c0e$export$32fde58c912ee8a), {
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 520 520",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M15.7083333,468 C7.03242448,468 0,462.030833 0,454.666667 L0,421.333333 C0,413.969167 7.03242448,408 15.7083333,408 L361.291667,408 C369.967576,408 377,413.969167 377,421.333333 L377,454.666667 C377,462.030833 369.967576,468 361.291667,468 L15.7083333,468 Z M21.6666667,366 C9.69989583,366 0,359.831861 0,352.222222 L0,317.777778 C0,310.168139 9.69989583,304 21.6666667,304 L498.333333,304 C510.300104,304 520,310.168139 520,317.777778 L520,352.222222 C520,359.831861 510.300104,366 498.333333,366 L21.6666667,366 Z M136.835938,64 L136.835937,126 L107.25,126 L107.25,251 L40.75,251 L40.75,126 L-5.68434189e-14,126 L-5.68434189e-14,64 L136.835938,64 Z M212,64 L212,251 L161.648438,251 L161.648438,64 L212,64 Z M378,64 L378,126 L343.25,126 L343.25,251 L281.75,251 L281.75,126 L238,126 L238,64 L378,64 Z M449.047619,189.550781 L520,189.550781 L520,251 L405,251 L405,64 L449.047619,64 L449.047619,189.550781 Z"
        })
    })
});
var $8d3503b55bbc42ae$export$fb184b623420d9be = $8d3503b55bbc42ae$export$46e4a324ac90507f;



parcelRequire("7fPBF");


var $36fb40a0f726427f$export$fdf227ae9d529b82 = {
    name: 'heading2',
    keyCommand: 'heading2',
    shortcuts: 'ctrlcmd+2',
    prefix: '## ',
    suffix: '',
    buttonProps: {
        'aria-label': 'Insert Heading 2 (ctrl + 2)',
        title: 'Insert Heading 2 (ctrl + 2)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: {
            fontSize: 16,
            textAlign: 'left'
        },
        children: "Heading 2"
    }),
    execute: (state, api)=>{
        (0, $8d3503b55bbc42ae$export$cd14d34733017854)({
            state: state,
            api: api,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
    }
};
var $36fb40a0f726427f$export$a32e8f003254de0d = $36fb40a0f726427f$export$fdf227ae9d529b82;


parcelRequire("7fPBF");


var $94732458fecf1917$export$866ae29a041994c3 = {
    name: 'heading3',
    keyCommand: 'heading3',
    shortcuts: 'ctrlcmd+3',
    prefix: '### ',
    suffix: '',
    buttonProps: {
        'aria-label': 'Insert Heading 3 (ctrl + 3)',
        title: 'Insert Heading 3 (ctrl + 3)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: {
            fontSize: 15,
            textAlign: 'left'
        },
        children: "Heading 3"
    }),
    execute: (state, api)=>{
        (0, $8d3503b55bbc42ae$export$cd14d34733017854)({
            state: state,
            api: api,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
    }
};
var $94732458fecf1917$export$a764c41186b9ad10 = $94732458fecf1917$export$866ae29a041994c3;


parcelRequire("7fPBF");


var $985391ef6c21b650$export$1bb412471a29ad7f = {
    name: 'heading4',
    keyCommand: 'heading4',
    shortcuts: 'ctrlcmd+4',
    prefix: '#### ',
    suffix: '',
    buttonProps: {
        'aria-label': 'Insert Heading 4 (ctrl + 4)',
        title: 'Insert Heading 4 (ctrl + 4)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: {
            fontSize: 14,
            textAlign: 'left'
        },
        children: "Heading 4"
    }),
    execute: (state, api)=>{
        (0, $8d3503b55bbc42ae$export$cd14d34733017854)({
            state: state,
            api: api,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
    }
};
var $985391ef6c21b650$export$148c1c1fe698f02e = $985391ef6c21b650$export$1bb412471a29ad7f;


parcelRequire("7fPBF");


var $7bc18c784a97e596$export$e6417b03ea193326 = {
    name: 'heading5',
    keyCommand: 'heading5',
    shortcuts: 'ctrlcmd+5',
    prefix: '##### ',
    suffix: '',
    buttonProps: {
        'aria-label': 'Insert Heading 5 (ctrl + 5)',
        title: 'Insert Heading 5 (ctrl + 5)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: {
            fontSize: 12,
            textAlign: 'left'
        },
        children: "Heading 5"
    }),
    execute: (state, api)=>{
        (0, $8d3503b55bbc42ae$export$cd14d34733017854)({
            state: state,
            api: api,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
    }
};
var $7bc18c784a97e596$export$ce3b15c74fe7af88 = $7bc18c784a97e596$export$e6417b03ea193326;


parcelRequire("7fPBF");


var $19666cf4a41f6938$export$25fc23799c4c7dcc = {
    name: 'heading6',
    keyCommand: 'heading6',
    shortcuts: 'ctrlcmd+6',
    prefix: '###### ',
    suffix: '',
    buttonProps: {
        'aria-label': 'Insert Heading 6 (ctrl + 6)',
        title: 'Insert Heading 6 (ctrl + 6)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: {
            fontSize: 12,
            textAlign: 'left'
        },
        children: "Heading 6"
    }),
    execute: (state, api)=>{
        (0, $8d3503b55bbc42ae$export$cd14d34733017854)({
            state: state,
            api: api,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
    }
};
var $19666cf4a41f6938$export$f805de199ca30344 = $19666cf4a41f6938$export$25fc23799c4c7dcc;


parcelRequire("7fPBF");


var $8b5b65f9bb910ca3$export$9852986a3ec5f6a0 = {
    name: 'table',
    keyCommand: 'table',
    prefix: '\n| Header | Header |\n|--------|--------|\n| Cell | Cell |\n| Cell | Cell |\n| Cell | Cell |\n\n',
    suffix: '',
    buttonProps: {
        'aria-label': 'Add table',
        title: 'Add table'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        role: "img",
        width: "12",
        height: "12",
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M64 256V160H224v96H64zm0 64H224v96H64V320zm224 96V320H448v96H288zM448 256H288V160H448v96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
        })
    }),
    execute: (state, api)=>{
        var newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
            text: state.text,
            selection: state.selection,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
        var state1 = api.setSelectionRange(newSelectionRange);
        if (state1.selectedText.length >= state.command.prefix.length + state.command.suffix.length && state1.selectedText.startsWith(state.command.prefix)) // Remove
        (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
            api: api,
            selectedText: state1.selectedText,
            selection: state.selection,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
        else {
            // Add
            state1 = api.setSelectionRange({
                start: state.selection.start,
                end: state.selection.start
            });
            (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
                api: api,
                selectedText: state1.selectedText,
                selection: state.selection,
                prefix: state.command.prefix,
                suffix: state.command.suffix
            });
        }
    }
};


parcelRequire("7fPBF");


var $e06ccd15504ef7a8$export$69ad3503f98be476 = {
    name: 'issue',
    keyCommand: 'issue',
    prefix: '#',
    suffix: '',
    buttonProps: {
        'aria-label': 'Add issue',
        title: 'Add issue'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        role: "img",
        width: "12",
        height: "12",
        viewBox: "0 0 448 512",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8L197.8 128l95.1 0 11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8L357.8 128l58.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-68.9 0L325.8 320l58.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-68.9 0-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7-95.1 0-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8L90.2 384 32 384c-17.7 0-32-14.3-32-32s14.3-32 32-32l68.9 0 21.3-128L64 192c-17.7 0-32-14.3-32-32s14.3-32 32-32l68.9 0 11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zM187.1 192L165.8 320l95.1 0 21.3-128-95.1 0z"
        })
    }),
    execute: (state, api)=>{
        var newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
            text: state.text,
            selection: state.selection,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
        var state1 = api.setSelectionRange(newSelectionRange);
        (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
            api: api,
            selectedText: state1.selectedText,
            selection: state.selection,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
    }
};


parcelRequire("7fPBF");

var $68eb3de1a22c361d$export$34512e3b2db52a4e = {
    name: 'help',
    keyCommand: 'help',
    buttonProps: {
        'aria-label': 'Open help',
        title: 'Open help'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        width: "12px",
        height: "12px",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8Zm.9 13H7v-1.8h1.9V13Zm-.1-3.6v.5H7.1v-.6c.2-2.1 2-1.9 1.9-3.2.1-.7-.3-1.1-1-1.1-.8 0-1.2.7-1.2 1.6H5c0-1.7 1.2-3 2.9-3 2.3 0 3 1.4 3 2.3.1 2.3-1.9 2-2.1 3.5Z",
            fill: "currentColor"
        })
    }),
    execute: ()=>{
        window.open('https://www.markdownguide.org/basic-syntax/', '_blank', 'noreferrer');
    }
};


var $85b654349d31b699$export$7a6092e2ae7e1845 = ()=>[
        (0, $1b1be813ac69f87a$export$73ba5813cda80a49),
        (0, $272797a41233c2a2$export$5540da1282cbf565),
        (0, $1c24713855f6d6fa$export$19426ff118fe8be),
        (0, $f1090649299d43a9$export$b4adb3f464574dcf),
        (0, $1455182fb6186464$export$e5e25fbcc1f7affe)([
            (0, $88569c0108189c0e$export$bafb53d6d28bbb73),
            (0, $36fb40a0f726427f$export$a32e8f003254de0d),
            (0, $94732458fecf1917$export$a764c41186b9ad10),
            (0, $985391ef6c21b650$export$148c1c1fe698f02e),
            (0, $7bc18c784a97e596$export$ce3b15c74fe7af88),
            (0, $19666cf4a41f6938$export$f805de199ca30344)
        ], {
            name: 'title',
            groupName: 'title',
            buttonProps: {
                'aria-label': 'Insert title',
                title: 'Insert title'
            }
        }),
        (0, $915c6594da096284$export$e8c9778bf415dd08),
        (0, $aacc1dc31941f636$export$9c30223ca0a664fb),
        (0, $56cbd7f6d3e478f3$export$ee7a15c61bfdeb11),
        (0, $53482fb090606392$export$6565f9f03506010b),
        (0, $53482fb090606392$export$7bb0d5c671655cc4),
        (0, $9708e0178a5760f3$export$4a34f930e789283c),
        (0, $23179bbad19e1934$export$5c452ff88e35e47d),
        (0, $8b5b65f9bb910ca3$export$9852986a3ec5f6a0),
        (0, $915c6594da096284$export$e8c9778bf415dd08),
        (0, $8a2e0a4d28b56dc0$export$6213d25cd68831c1),
        (0, $8a2e0a4d28b56dc0$export$4d4094269a49853c),
        (0, $8a2e0a4d28b56dc0$export$2edba76228b93c06),
        (0, $915c6594da096284$export$e8c9778bf415dd08),
        (0, $68eb3de1a22c361d$export$34512e3b2db52a4e)
    ];
var $85b654349d31b699$export$6e591f5fe2c6ad02 = ()=>[
        (0, $47528ad1eaeb011b$export$5f58ca08fd242e88),
        (0, $47528ad1eaeb011b$export$3449b126b33d0f8f),
        (0, $47528ad1eaeb011b$export$bb03fe4fe5a686f2),
        (0, $915c6594da096284$export$e8c9778bf415dd08),
        (0, $d82069e0665e2255$export$af93ab412ae68734)
    ];
function $85b654349d31b699$export$56c9a4b3c99767b8(textArea) {
    var _textArea$value;
    return {
        selection: {
            start: textArea.selectionStart,
            end: textArea.selectionEnd
        },
        text: textArea.value,
        selectedText: (_textArea$value = textArea.value) == null ? void 0 : _textArea$value.slice(textArea.selectionStart, textArea.selectionEnd)
    };
}
class $85b654349d31b699$export$d45483eeb65d6c0c {
    constructor(textArea){
        this.textArea = void 0;
        this.textArea = textArea;
    }
    /**
   * Replaces the current selection with the new text. This will make the new selectedText to be empty, the
   * selection start and selection end will be the same and will both point to the end
   * @param text Text that should replace the current selection
   */ replaceSelection(text) {
        (0, $cd79195d1a384c19$export$7d6189efbd20bf69)(this.textArea, text);
        return $85b654349d31b699$export$56c9a4b3c99767b8(this.textArea);
    }
    /**
   * Selects the specified text range
   * @param selection
   */ setSelectionRange(selection) {
        this.textArea.focus();
        this.textArea.selectionStart = selection.start;
        this.textArea.selectionEnd = selection.end;
        return $85b654349d31b699$export$56c9a4b3c99767b8(this.textArea);
    }
}
class $85b654349d31b699$export$7987eb6974342a3c {
    constructor(textArea){
        this.textArea = void 0;
        this.textApi = void 0;
        this.textArea = textArea;
        this.textApi = new $85b654349d31b699$export$d45483eeb65d6c0c(textArea);
    }
    getState() {
        if (!this.textArea) return false;
        return $85b654349d31b699$export$56c9a4b3c99767b8(this.textArea);
    }
    executeCommand(command, dispatch, state, shortcuts) {
        command.execute && command.execute((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            command: command
        }, $85b654349d31b699$export$56c9a4b3c99767b8(this.textArea)), this.textApi, dispatch, state, shortcuts);
    }
}





/**
 * - `13` - `Enter`
 * - `9` - `Tab`
 */ function $7f5193ec23d3d3fe$var$stopPropagation(e) {
    e.stopPropagation();
    e.preventDefault();
}
function $7f5193ec23d3d3fe$var$handleLineMove(e, direction) {
    $7f5193ec23d3d3fe$var$stopPropagation(e);
    var target = e.target;
    var textArea = new (0, $85b654349d31b699$export$d45483eeb65d6c0c)(target);
    var selection = {
        start: target.selectionStart,
        end: target.selectionEnd
    };
    selection = (0, $57170ec975fca5ef$export$e41c12847640c21)({
        text: target.value,
        selection: selection
    });
    if (direction < 0 && selection.start <= 0 || direction > 0 && selection.end >= target.value.length) return;
    var blockText = target.value.slice(selection.start, selection.end);
    if (direction < 0) {
        var prevLineSelection = (0, $57170ec975fca5ef$export$e41c12847640c21)({
            text: target.value,
            selection: {
                start: selection.start - 1,
                end: selection.start - 1
            }
        });
        var prevLineText = target.value.slice(prevLineSelection.start, prevLineSelection.end);
        textArea.setSelectionRange({
            start: prevLineSelection.start,
            end: selection.end
        });
        (0, $cd79195d1a384c19$export$7d6189efbd20bf69)(target, blockText + "\n" + prevLineText);
        textArea.setSelectionRange({
            start: prevLineSelection.start,
            end: prevLineSelection.start + blockText.length
        });
    } else {
        var nextLineSelection = (0, $57170ec975fca5ef$export$e41c12847640c21)({
            text: target.value,
            selection: {
                start: selection.end + 1,
                end: selection.end + 1
            }
        });
        var nextLineText = target.value.slice(nextLineSelection.start, nextLineSelection.end);
        textArea.setSelectionRange({
            start: selection.start,
            end: nextLineSelection.end
        });
        (0, $cd79195d1a384c19$export$7d6189efbd20bf69)(target, nextLineText + "\n" + blockText);
        textArea.setSelectionRange({
            start: nextLineSelection.end - blockText.length,
            end: nextLineSelection.end
        });
    }
}
function $7f5193ec23d3d3fe$export$2e2bcd8739ae039(e, tabSize, defaultTabEnable) {
    if (tabSize === void 0) tabSize = 2;
    if (defaultTabEnable === void 0) defaultTabEnable = false;
    var target = e.target;
    var starVal = target.value.substr(0, target.selectionStart);
    var valArr = starVal.split('\n');
    var currentLineStr = valArr[valArr.length - 1];
    var textArea = new (0, $85b654349d31b699$export$d45483eeb65d6c0c)(target);
    /**
   * `9` - `Tab`
   */ if (!defaultTabEnable && e.code && e.code.toLowerCase() === 'tab') {
        $7f5193ec23d3d3fe$var$stopPropagation(e);
        var space = new Array(tabSize + 1).join('  ');
        if (target.selectionStart !== target.selectionEnd) {
            var _star = target.value.substring(0, target.selectionStart).split('\n');
            var _end = target.value.substring(0, target.selectionEnd).split('\n');
            var modifiedTextLine = [];
            _end.forEach((item, idx)=>{
                if (item !== _star[idx]) modifiedTextLine.push(item);
            });
            var modifiedText = modifiedTextLine.join('\n');
            var oldSelectText = target.value.substring(target.selectionStart, target.selectionEnd);
            var newStarNum = target.value.substring(0, target.selectionStart).length;
            textArea.setSelectionRange({
                start: target.value.indexOf(modifiedText),
                end: target.selectionEnd
            });
            var modifiedTextObj = (0, $57170ec975fca5ef$export$296d1daf426952fd)(modifiedText, e.shiftKey ? '' : space);
            var text = modifiedTextObj.modifiedText;
            if (e.shiftKey) text = text.split('\n').map((item)=>item.replace(new RegExp("^" + space), '')).join('\n');
            textArea.replaceSelection(text);
            var startTabSize = e.shiftKey ? -tabSize : tabSize;
            var endTabSize = e.shiftKey ? -modifiedTextLine.length * tabSize : modifiedTextLine.length * tabSize;
            textArea.setSelectionRange({
                start: newStarNum + startTabSize,
                end: newStarNum + oldSelectText.length + endTabSize
            });
        } else return (0, $cd79195d1a384c19$export$7d6189efbd20bf69)(target, space);
    } else if (e.keyCode === 13 && e.code.toLowerCase() === 'enter' && (/^(-|\*)\s/.test(currentLineStr) || /^\d+.\s/.test(currentLineStr)) && !e.shiftKey) {
        /**
     * `13` - `Enter`
     */ $7f5193ec23d3d3fe$var$stopPropagation(e);
        var startStr = '\n- ';
        if (currentLineStr.startsWith('*')) startStr = '\n* ';
        if (currentLineStr.startsWith('- [ ]') || currentLineStr.startsWith('- [X]') || currentLineStr.startsWith('- [x]')) startStr = '\n- [ ] ';
        if (/^\d+.\s/.test(currentLineStr)) startStr = "\n" + (parseInt(currentLineStr) + 1) + ". ";
        return (0, $cd79195d1a384c19$export$7d6189efbd20bf69)(target, startStr);
    } else if (e.code && e.code.toLowerCase() === 'keyd' && e.ctrlKey) {
        // Duplicate lines
        $7f5193ec23d3d3fe$var$stopPropagation(e);
        var selection = {
            start: target.selectionStart,
            end: target.selectionEnd
        };
        var savedSelection = selection;
        selection = (0, $57170ec975fca5ef$export$e41c12847640c21)({
            text: target.value,
            selection: selection
        });
        var textToDuplicate = target.value.slice(selection.start, selection.end);
        textArea.setSelectionRange({
            start: selection.end,
            end: selection.end
        });
        (0, $cd79195d1a384c19$export$7d6189efbd20bf69)(target, "\n" + textToDuplicate);
        textArea.setSelectionRange({
            start: savedSelection.start,
            end: savedSelection.end
        });
    } else if (e.code && e.code.toLowerCase() === 'arrowup' && e.altKey) $7f5193ec23d3d3fe$var$handleLineMove(e, -1);
    else if (e.code && e.code.toLowerCase() === 'arrowdown' && e.altKey) $7f5193ec23d3d3fe$var$handleLineMove(e, 1);
}





var $053231a4eb786f98$var$_excluded = [
    "prefixCls",
    "onChange"
], $053231a4eb786f98$var$_excluded2 = [
    "markdown",
    "commands",
    "fullscreen",
    "preview",
    "highlightEnable",
    "extraCommands",
    "tabSize",
    "defaultTabEnable",
    "autoFocusEnd",
    "textareaWarp",
    "dispatch"
];
function $053231a4eb786f98$export$2e2bcd8739ae039(props) {
    var { prefixCls: prefixCls, onChange: _onChange } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $053231a4eb786f98$var$_excluded);
    var _useContext = (0, $7fPBF.useContext)((0, $7c2cb0ce17642c75$export$27b8dd149e32f6c7)), { markdown: markdown, commands: commands, fullscreen: fullscreen, preview: preview, highlightEnable: highlightEnable, extraCommands: extraCommands, tabSize: tabSize, defaultTabEnable: defaultTabEnable, autoFocusEnd: autoFocusEnd, textareaWarp: textareaWarp, dispatch: dispatch } = _useContext, otherStore = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useContext, $053231a4eb786f98$var$_excluded2);
    var textRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
    var executeRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef();
    var statesRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef({
        fullscreen: fullscreen,
        preview: preview
    });
    (0, $7fPBF.useEffect)(()=>{
        statesRef.current = {
            fullscreen: fullscreen,
            preview: preview,
            highlightEnable: highlightEnable
        };
    }, [
        fullscreen,
        preview,
        highlightEnable
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (textRef.current && dispatch) {
            var commandOrchestrator = new (0, $85b654349d31b699$export$7987eb6974342a3c)(textRef.current);
            executeRef.current = commandOrchestrator;
            dispatch({
                textarea: textRef.current,
                commandOrchestrator: commandOrchestrator
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        if (autoFocusEnd && textRef.current && textareaWarp) {
            textRef.current.focus();
            var length = textRef.current.value.length;
            textRef.current.setSelectionRange(length, length);
            setTimeout(()=>{
                if (textareaWarp) textareaWarp.scrollTop = textareaWarp.scrollHeight;
                if (textRef.current) textRef.current.scrollTop = textRef.current.scrollHeight;
            }, 0);
        }
    }, [
        textareaWarp
    ]);
    var onKeyDown = (e)=>{
        (0, $7f5193ec23d3d3fe$export$2e2bcd8739ae039)(e, tabSize, defaultTabEnable);
        (0, $291b77f2b248d49a$export$2e2bcd8739ae039)(e, [
            ...commands || [],
            ...extraCommands || []
        ], executeRef.current, dispatch, statesRef.current);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (textRef.current) textRef.current.addEventListener('keydown', onKeyDown);
        return ()=>{
            if (textRef.current) // eslint-disable-next-line react-hooks/exhaustive-deps
            textRef.current.removeEventListener('keydown', onKeyDown);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        autoComplete: "off",
        autoCorrect: "off",
        autoCapitalize: "off",
        spellCheck: false
    }, other, {
        ref: textRef,
        className: prefixCls + "-text-input " + (other.className ? other.className : ''),
        value: markdown,
        onChange: (e)=>{
            dispatch && dispatch({
                markdown: e.target.value
            });
            _onChange && _onChange(e);
        }
    }));
}





var $33ce618c4c7bcc53$var$_excluded = [
    "prefixCls",
    "className",
    "onScroll",
    "renderTextarea"
];
function $33ce618c4c7bcc53$export$2e2bcd8739ae039(props) {
    var _ref = props || {}, { prefixCls: prefixCls, className: className, onScroll: onScroll, renderTextarea: renderTextarea } = _ref, otherProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $33ce618c4c7bcc53$var$_excluded);
    var { markdown: markdown, scrollTop: scrollTop, commands: commands, minHeight: minHeight, highlightEnable: highlightEnable, extraCommands: extraCommands, dispatch: dispatch } = (0, $7fPBF.useContext)((0, $7c2cb0ce17642c75$export$27b8dd149e32f6c7));
    var textRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
    var executeRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef();
    var warp = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createRef();
    (0, $7fPBF.useEffect)(()=>{
        var state = {};
        if (warp.current) {
            state.textareaWarp = warp.current || undefined;
            warp.current.scrollTop = scrollTop || 0;
        }
        if (dispatch) dispatch((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        if (textRef.current && dispatch) {
            var commandOrchestrator = new (0, $85b654349d31b699$export$7987eb6974342a3c)(textRef.current);
            executeRef.current = commandOrchestrator;
            dispatch({
                textarea: textRef.current,
                commandOrchestrator: commandOrchestrator
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var textStyle = highlightEnable ? {} : {
        WebkitTextFillColor: 'initial',
        overflow: 'auto'
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        ref: warp,
        className: prefixCls + "-area " + (className || ''),
        onScroll: onScroll,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: prefixCls + "-text",
            style: {
                minHeight: minHeight
            },
            children: renderTextarea ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(renderTextarea((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, otherProps, {
                value: markdown,
                autoComplete: 'off',
                autoCorrect: 'off',
                spellCheck: 'false',
                autoCapitalize: 'off',
                className: prefixCls + "-text-input",
                style: {
                    WebkitTextFillColor: 'inherit',
                    overflow: 'auto'
                }
            }), {
                dispatch: dispatch,
                onChange: otherProps.onChange,
                shortcuts: $291b77f2b248d49a$export$2e2bcd8739ae039,
                useContext: {
                    commands: commands,
                    extraCommands: extraCommands,
                    commandOrchestrator: executeRef.current
                }
            }), {
                ref: textRef
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fPBF.Fragment), {
                children: [
                    highlightEnable && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b1c409df4bde24b$export$2e2bcd8739ae039), {
                        prefixCls: prefixCls
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $053231a4eb786f98$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                        prefixCls: prefixCls
                    }, otherProps, {
                        style: textStyle
                    }))
                ]
            })
        })
    });
}



var $7fPBF = parcelRequire("7fPBF");


var $d1a159730de79d31$var$DragBar = (props)=>{
    var { prefixCls: prefixCls, onChange: onChange } = props || {};
    var $dom = (0, $7fPBF.useRef)(null);
    var dragRef = (0, $7fPBF.useRef)();
    var heightRef = (0, $7fPBF.useRef)(props.height);
    (0, $7fPBF.useEffect)(()=>{
        if (heightRef.current !== props.height) heightRef.current = props.height;
    }, [
        props.height
    ]);
    function handleMouseMove(event) {
        if (dragRef.current) {
            var _changedTouches$;
            var clientY = event.clientY || ((_changedTouches$ = event.changedTouches[0]) == null ? void 0 : _changedTouches$.clientY);
            var newHeight = dragRef.current.height + clientY - dragRef.current.dragY;
            if (newHeight >= props.minHeight && newHeight <= props.maxHeight) onChange && onChange(dragRef.current.height + (clientY - dragRef.current.dragY));
        }
    }
    function handleMouseUp() {
        var _$dom$current, _$dom$current2;
        dragRef.current = undefined;
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
        (_$dom$current = $dom.current) == null || _$dom$current.removeEventListener('touchmove', handleMouseMove);
        (_$dom$current2 = $dom.current) == null || _$dom$current2.removeEventListener('touchend', handleMouseUp);
    }
    function handleMouseDown(event) {
        var _changedTouches$2, _$dom$current3, _$dom$current4;
        event.preventDefault();
        var clientY = event.clientY || ((_changedTouches$2 = event.changedTouches[0]) == null ? void 0 : _changedTouches$2.clientY);
        dragRef.current = {
            height: heightRef.current,
            dragY: clientY
        };
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
        (_$dom$current3 = $dom.current) == null || _$dom$current3.addEventListener('touchmove', handleMouseMove, {
            passive: false
        });
        (_$dom$current4 = $dom.current) == null || _$dom$current4.addEventListener('touchend', handleMouseUp, {
            passive: false
        });
    }
    (0, $7fPBF.useEffect)(()=>{
        if (document) {
            var _$dom$current5, _$dom$current6;
            (_$dom$current5 = $dom.current) == null || _$dom$current5.addEventListener('touchstart', handleMouseDown, {
                passive: false
            });
            (_$dom$current6 = $dom.current) == null || _$dom$current6.addEventListener('mousedown', handleMouseDown);
        }
        return ()=>{
            if (document) {
                var _$dom$current7;
                (_$dom$current7 = $dom.current) == null || _$dom$current7.removeEventListener('touchstart', handleMouseDown);
                document.removeEventListener('mousemove', handleMouseMove);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var svg = (0, $7fPBF.useMemo)(()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
            viewBox: "0 0 512 512",
            height: "100%",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                d: "M304 256c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48 48 21.5 48 48zm120-48c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm-336 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48z"
            })
        }), []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: prefixCls + "-bar",
        ref: $dom,
        children: svg
    });
};
var $d1a159730de79d31$export$2e2bcd8739ae039 = $d1a159730de79d31$var$DragBar;





var $e910b812779972f8$var$_excluded = [
    "prefixCls",
    "className",
    "value",
    "commands",
    "commandsFilter",
    "direction",
    "extraCommands",
    "height",
    "enableScroll",
    "visibleDragbar",
    "highlightEnable",
    "preview",
    "fullscreen",
    "overflow",
    "previewOptions",
    "textareaProps",
    "maxHeight",
    "minHeight",
    "autoFocus",
    "autoFocusEnd",
    "tabSize",
    "defaultTabEnable",
    "onChange",
    "onStatistics",
    "onHeightChange",
    "hideToolbar",
    "toolbarBottom",
    "components",
    "renderTextarea"
];
function $e910b812779972f8$var$setGroupPopFalse(data) {
    if (data === void 0) data = {};
    Object.keys(data).forEach((keyname)=>{
        data[keyname] = false;
    });
    return data;
}
var $e910b812779972f8$var$InternalMDEditor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef((props, ref)=>{
    var _ref = props || {}, { prefixCls: prefixCls = 'w-md-editor', className: className, value: propsValue, commands: commands = (0, $85b654349d31b699$export$7a6092e2ae7e1845)(), commandsFilter: commandsFilter, direction: direction, extraCommands: extraCommands = (0, $85b654349d31b699$export$6e591f5fe2c6ad02)(), height: height = 200, enableScroll: enableScroll = true, visibleDragbar: visibleDragbar = typeof props.visiableDragbar === 'boolean' ? props.visiableDragbar : true, highlightEnable: highlightEnable = true, preview: previewType = 'live', fullscreen: fullscreen = false, overflow: overflow = true, previewOptions: previewOptions = {}, textareaProps: textareaProps, maxHeight: maxHeight = 1200, minHeight: minHeight = 100, autoFocus: autoFocus, autoFocusEnd: autoFocusEnd = false, tabSize: tabSize = 2, defaultTabEnable: defaultTabEnable = false, onChange: onChange, onStatistics: onStatistics, onHeightChange: onHeightChange, hideToolbar: hideToolbar, toolbarBottom: toolbarBottom = false, components: components, renderTextarea: renderTextarea } = _ref, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $e910b812779972f8$var$_excluded);
    var cmds = commands.map((item)=>commandsFilter ? commandsFilter(item, false) : item).filter(Boolean);
    var extraCmds = extraCommands.map((item)=>commandsFilter ? commandsFilter(item, true) : item).filter(Boolean);
    var [state, dispatch] = (0, $7fPBF.useReducer)((0, $7c2cb0ce17642c75$export$1650419e431d3ba3), {
        markdown: propsValue,
        preview: previewType,
        components: components,
        height: height,
        minHeight: minHeight,
        highlightEnable: highlightEnable,
        tabSize: tabSize,
        defaultTabEnable: defaultTabEnable,
        scrollTop: 0,
        scrollTopPreview: 0,
        commands: cmds,
        extraCommands: extraCmds,
        fullscreen: fullscreen,
        barPopup: {}
    });
    var container = (0, $7fPBF.useRef)(null);
    var previewRef = (0, $7fPBF.useRef)(null);
    var enableScrollRef = (0, $7fPBF.useRef)(enableScroll);
    (0, $7fPBF.useImperativeHandle)(ref, ()=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state, {
            container: container.current,
            dispatch: dispatch
        }));
    (0, $7fPBF.useMemo)(()=>enableScrollRef.current = enableScroll, [
        enableScroll
    ]);
    (0, $7fPBF.useEffect)(()=>{
        var stateInit = {};
        if (container.current) stateInit.container = container.current || undefined;
        stateInit.markdown = propsValue || '';
        stateInit.barPopup = {};
        if (dispatch) dispatch((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state, stateInit));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var cls = [
        className,
        'wmde-markdown-var',
        direction ? prefixCls + "-" + direction : null,
        prefixCls,
        state.preview ? prefixCls + "-show-" + state.preview : null,
        state.fullscreen ? prefixCls + "-fullscreen" : null
    ].filter(Boolean).join(' ').trim();
    (0, $7fPBF.useMemo)(()=>propsValue !== state.markdown && dispatch({
            markdown: propsValue || ''
        }), [
        propsValue,
        state.markdown
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $7fPBF.useMemo)(()=>previewType !== state.preview && dispatch({
            preview: previewType
        }), [
        previewType
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $7fPBF.useMemo)(()=>tabSize !== state.tabSize && dispatch({
            tabSize: tabSize
        }), [
        tabSize
    ]);
    (0, $7fPBF.useMemo)(()=>highlightEnable !== state.highlightEnable && dispatch({
            highlightEnable: highlightEnable
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        highlightEnable
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $7fPBF.useMemo)(()=>autoFocus !== state.autoFocus && dispatch({
            autoFocus: autoFocus
        }), [
        autoFocus
    ]);
    (0, $7fPBF.useMemo)(()=>autoFocusEnd !== state.autoFocusEnd && dispatch({
            autoFocusEnd: autoFocusEnd
        }), [
        autoFocusEnd
    ]);
    (0, $7fPBF.useMemo)(()=>fullscreen !== state.fullscreen && dispatch({
            fullscreen: fullscreen
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        fullscreen
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $7fPBF.useMemo)(()=>height !== state.height && dispatch({
            height: height
        }), [
        height
    ]);
    (0, $7fPBF.useMemo)(()=>height !== state.height && onHeightChange && onHeightChange(state.height, height, state), [
        height,
        onHeightChange,
        state
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $7fPBF.useMemo)(()=>commands !== state.commands && dispatch({
            commands: cmds
        }), [
        props.commands
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $7fPBF.useMemo)(()=>extraCommands !== state.extraCommands && dispatch({
            extraCommands: extraCmds
        }), [
        props.extraCommands
    ]);
    var textareaDomRef = (0, $7fPBF.useRef)();
    var active = (0, $7fPBF.useRef)('preview');
    var initScroll = (0, $7fPBF.useRef)(false);
    (0, $7fPBF.useMemo)(()=>{
        textareaDomRef.current = state.textareaWarp;
        if (state.textareaWarp) {
            state.textareaWarp.addEventListener('mouseover', ()=>{
                active.current = 'text';
            });
            state.textareaWarp.addEventListener('mouseleave', ()=>{
                active.current = 'preview';
            });
        }
    }, [
        state.textareaWarp
    ]);
    var handleScroll = (e, type)=>{
        if (!enableScrollRef.current) return;
        var textareaDom = textareaDomRef.current;
        var previewDom = previewRef.current ? previewRef.current : undefined;
        if (!initScroll.current) {
            active.current = type;
            initScroll.current = true;
        }
        if (textareaDom && previewDom) {
            var scale = (textareaDom.scrollHeight - textareaDom.offsetHeight) / (previewDom.scrollHeight - previewDom.offsetHeight);
            if (e.target === textareaDom && active.current === 'text') previewDom.scrollTop = textareaDom.scrollTop / scale;
            if (e.target === previewDom && active.current === 'preview') textareaDom.scrollTop = previewDom.scrollTop * scale;
            var scrollTop = 0;
            if (active.current === 'text') scrollTop = textareaDom.scrollTop || 0;
            else if (active.current === 'preview') scrollTop = previewDom.scrollTop || 0;
            dispatch({
                scrollTop: scrollTop
            });
        }
    };
    var previewClassName = prefixCls + "-preview " + (previewOptions.className || '');
    var handlePreviewScroll = (e)=>handleScroll(e, 'preview');
    var mdPreview = (0, $7fPBF.useMemo)(()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            ref: previewRef,
            className: previewClassName,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7b0fa6cba31fe01a$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, previewOptions, {
                onScroll: handlePreviewScroll,
                source: state.markdown || ''
            }))
        }), [
        previewClassName,
        previewOptions,
        state.markdown
    ]);
    var preview = (components == null ? void 0 : components.preview) && (components == null ? void 0 : components.preview(state.markdown || '', state, dispatch));
    if (preview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(preview)) mdPreview = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: previewClassName,
        ref: previewRef,
        onScroll: handlePreviewScroll,
        children: preview
    });
    var containerStyle = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, other.style, {
        height: state.height || '100%'
    });
    var containerClick = ()=>dispatch({
            barPopup: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $e910b812779972f8$var$setGroupPopFalse(state.barPopup))
        });
    var dragBarChange = (newHeight)=>dispatch({
            height: newHeight
        });
    var changeHandle = (evn)=>{
        onChange && onChange(evn.target.value, evn, state);
        if (textareaProps && textareaProps.onChange) textareaProps.onChange(evn);
        if (state.textarea && state.textarea instanceof HTMLTextAreaElement && onStatistics) {
            var obj = new (0, $85b654349d31b699$export$7987eb6974342a3c)(state.textarea);
            var objState = obj.getState() || {};
            onStatistics((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, objState, {
                lineCount: evn.target.value.split('\n').length,
                length: evn.target.value.length
            }));
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7c2cb0ce17642c75$export$27b8dd149e32f6c7).Provider, {
        value: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state, {
            dispatch: dispatch
        }),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            ref: container,
            className: cls
        }, other, {
            onClick: containerClick,
            style: containerStyle,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f179cc69962c631d$export$f8f240f0d25ce088), {
                    hideToolbar: hideToolbar,
                    toolbarBottom: toolbarBottom,
                    prefixCls: prefixCls,
                    overflow: overflow,
                    placement: "top"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: prefixCls + "-content",
                    children: [
                        /(edit|live)/.test(state.preview || '') && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $33ce618c4c7bcc53$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                            className: prefixCls + "-input",
                            prefixCls: prefixCls,
                            autoFocus: autoFocus
                        }, textareaProps, {
                            onChange: changeHandle,
                            renderTextarea: (components == null ? void 0 : components.textarea) || renderTextarea,
                            onScroll: (e)=>handleScroll(e, 'text')
                        })),
                        /(live|preview)/.test(state.preview || '') && mdPreview
                    ]
                }),
                visibleDragbar && !state.fullscreen && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d1a159730de79d31$export$2e2bcd8739ae039), {
                    prefixCls: prefixCls,
                    height: state.height,
                    maxHeight: maxHeight,
                    minHeight: minHeight,
                    onChange: dragBarChange
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f179cc69962c631d$export$f8f240f0d25ce088), {
                    hideToolbar: hideToolbar,
                    toolbarBottom: toolbarBottom,
                    prefixCls: prefixCls,
                    overflow: overflow,
                    placement: "bottom"
                })
            ]
        }))
    });
});
var $e910b812779972f8$var$Editor = $e910b812779972f8$var$InternalMDEditor;
$e910b812779972f8$var$Editor.Markdown = (0, $7b0fa6cba31fe01a$export$2e2bcd8739ae039);
var $e910b812779972f8$export$2e2bcd8739ae039 = $e910b812779972f8$var$Editor;













var $a046c90ce2b9f87e$export$2e2bcd8739ae039 = (0, $e910b812779972f8$export$2e2bcd8739ae039);





var $7fPBF = parcelRequire("7fPBF");


function $f5d4d30d0c746c1c$export$2e2bcd8739ae039({ value: value, onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const handleUpdate = (value)=>{
        onUpdate(value);
    };
    const customCommands = (0, $7fPBF.useMemo)(()=>{
        return (0, $85b654349d31b699$export$7a6092e2ae7e1845)().map((cmd)=>({
                ...cmd,
                buttonProps: {
                    ...cmd.buttonProps,
                    'aria-label': t(`editor.${cmd.name}`),
                    title: t(`editor.${cmd.name}`),
                    style: {
                        height: '2rem',
                        width: '2rem'
                    }
                },
                icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    "aria-hidden": "true",
                    children: cmd.icon
                })
            }));
    }, [
        t
    ]);
    const extraCommands = (0, $7fPBF.useMemo)(()=>{
        return (0, $85b654349d31b699$export$6e591f5fe2c6ad02)().map((cmd)=>({
                ...cmd,
                buttonProps: {
                    ...cmd.buttonProps,
                    'aria-label': t(`editor.${cmd.name}`),
                    title: t(`editor.${cmd.name}`),
                    style: {
                        height: '2rem',
                        width: '2rem'
                    }
                }
            }));
    }, [
        t
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a046c90ce2b9f87e$export$2e2bcd8739ae039), {
            defaultTabEnable: false,
            height: 600,
            value: value,
            commands: customCommands,
            extraCommands: extraCommands,
            onChange: handleUpdate,
            textareaProps: {
                placeholder: t('editor.placeholder'),
                maxLength: 12000
            },
            previewOptions: {
                disallowedElements: [
                    'style',
                    'script',
                    'language-js',
                    'language-css'
                ],
                rehypePlugins: [
                    [
                        (0, $952077a98b509239$export$2e2bcd8739ae039)
                    ]
                ]
            }
        })
    });
}



function $37c9dbb5637bee33$export$2e2bcd8739ae039({ sendToPortal: sendToPortal }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { currentOrg: currentOrg, membership: membership, isLoading: isLoading, canManageBilling: canManageBilling } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const { handleInputChange: handleInputChange, handleUpdateWithAlerts: handleUpdateWithAlerts, editOrganization: editOrganization, hasChanges: hasChanges } = (0, $2d24843f3708c077$export$15de29966ec5486a)(currentOrg ?? null);
    if (!currentOrg || !editOrganization || !membership) return null;
    if (isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            membership.isAdmin && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                        title: t('common:organization.settings.general.title')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d0f22230e48d02ba$export$2e2bcd8739ae039), {
                        licenseType: (0, $427978696205d868$export$5122f57547dc8eca)(currentOrg)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $09e78d309b5c4bb4$export$2e2bcd8739ae039), {
                                value: editOrganization.name ?? '',
                                onUpdate: (field, value)=>handleInputChange(field, value)
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e7f3fc00fe5d6c8d$export$2e2bcd8739ae039), {
                                value: editOrganization.description ?? '',
                                onUpdate: (field, value)=>handleInputChange(field, value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                        title: t('common:organization.settings.resources.edit'),
                        description: t('common:organization.settings.resources.description')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f5d4d30d0c746c1c$export$2e2bcd8739ae039), {
                        value: editOrganization?.customResourcesMarkdown ?? '',
                        onUpdate: (value)=>handleInputChange('customResourcesMarkdown', value ?? '')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:organization.member.aboutMe')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $82c7f1922904df08$export$2e2bcd8739ae039), {
                member: membership
            }),
            membership.isAdmin && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                        title: t('common:organization.settings.other.title')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d6e1b40cb257f60f$export$2e2bcd8739ae039), {
                        currentOrg: currentOrg,
                        canManageBilling: canManageBilling
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$de401b45f203ff7f), {
                $visuallyHide: !hasChanges,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    disabled: !hasChanges,
                    onClick: async ()=>await handleUpdateWithAlerts(),
                    children: t('common:save')
                })
            })
        ]
    });
}
const $37c9dbb5637bee33$var$Row = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    margin: 1rem;
`;





function $077db4f25b761cd8$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { currentOrg: currentOrg, isLoading: isLoading } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    if (!currentOrg || isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e8ddd06b3da44631$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:settings.orgTitle', {
                    value: currentOrg?.name
                }),
                description: t('common:organization.settings.description'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $37c9dbb5637bee33$export$2e2bcd8739ae039), {})
        ]
    });
}














parcelRequire("7fPBF");




const $dd50f9e7fc2705de$var$DeprecatedHotkeyDialog = ()=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const editProfileContainer = (0, $697752726c88b03c$export$2e2bcd8739ae039).useContainer();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const onConfirm = async ()=>{
        editProfileContainer.hotkeys.forEach((hotkey)=>{
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            hotkey.command.startsWith((0, $f44f3a5bc46b1c4c$export$b617c310e3426257)) || editProfileContainer.updateDeprecatedHotkey(hotkey, editProfileContainer.macros);
        });
        const result = await editProfileContainer.saveChanges();
        if (result?.resultType == 'Ok') {
            editProfileContainer.setIsDeprecatedHotkey(false);
            navigate(`/profiles/edit/${result?.data?.id}`, {
                replace: true
            });
        }
        editProfileContainer.setIsDeprecatedHotkey(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        open: editProfileContainer.isDeprecatedHotkey,
        onClose: onConfirm,
        description: t('common:hotkey.deprecatedDialog.description1'),
        title: t('common:hotkey.deprecatedDialog.title'),
        onConfirm: onConfirm,
        confirmButtonText: t('common:hotkey.deprecatedDialog.confirm'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
            children: t('common:hotkey.deprecatedDialog.description2')
        })
    });
};
var $dd50f9e7fc2705de$export$2e2bcd8739ae039 = $dd50f9e7fc2705de$var$DeprecatedHotkeyDialog;





var $7fPBF = parcelRequire("7fPBF");

function $c449c760a7ee086f$export$29bdea29542a2205() {
    const [searchParams, setSearchParams] = (0, $5ec159caebd3ae22$export$f1a78c17382fe22a)();
    (0, $7fPBF.useEffect)(()=>{
        const id = searchParams.get('scrollToId');
        if (!id) return;
        let attempts = 0;
        const maxAttempts = 10; // Try for a few seconds
        const interval = 300; // Check every 300ms
        const checkForElement = ()=>{
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
                element.focus();
                // Remove `scrollToId` from the URL without adding history entry
                if (searchParams.get('scrollToId')) setSearchParams((prevParams)=>{
                    const newParams = new URLSearchParams(prevParams);
                    newParams.delete('scrollToId');
                    return newParams;
                }, {
                    replace: true
                });
            } else if (attempts < maxAttempts) {
                attempts++;
                setTimeout(checkForElement, interval);
            }
        };
        checkForElement(); // Start checking for the element
    }, [
        searchParams
    ]);
    return null;
}



var $7fPBF = parcelRequire("7fPBF");





















const $abf1344db012a77a$export$7e892870081a5226 = ()=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    function prepareHotkeysForCopyMacro(macro, hotkeys) {
        const newMacro = {
            ...macro
        };
        const commands = macro.commands;
        newMacro.commands.forEach((c, i)=>{
            if (c.commandType === 'hotkey') {
                const hkLocalId = (0, $6810e10b84975c3e$export$2e2bcd8739ae039)();
                const displayName = c.command.replace((0, $f44f3a5bc46b1c4c$export$b617c310e3426257), '');
                hotkeys.push({
                    localId: hkLocalId,
                    command: c.command + '_copy',
                    displayName: t('common:hotkey.copySuffix', displayName + '_copy', {
                        name: displayName
                    }),
                    macroLocalId: macro.id
                });
                newMacro.commands[i] = {
                    ...commands[i],
                    command: c.command + '_copy',
                    hotkeyLocalId: hkLocalId
                };
            }
        });
        newMacro.id = (0, $6810e10b84975c3e$export$2e2bcd8739ae039)();
        newMacro.name = t('common:macros.copySuffix', macro.name + '_copy', {
            name: macro.name
        });
        return {
            newMacro: newMacro,
            hotkeys: hotkeys
        };
    }
    return prepareHotkeysForCopyMacro;
};



var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");

function $33444986c68d8356$export$bd0e99c4527b3b17() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const editProfileContainer = (0, $697752726c88b03c$export$2e2bcd8739ae039).useContainer();
    const prepareHotkeysForCopyMacro = (0, $abf1344db012a77a$export$7e892870081a5226)();
    const [macroToAddCommand, setMacroToAddCommand] = (0, $7fPBF.useState)();
    const [editingMacroIndex, setEditingMacroIndex] = (0, $7fPBF.useState)();
    // ── Search ────────────────────────────────────────────────────────────────
    const handleSearchChange = (e)=>{
        editProfileContainer.setFilter(e.target.value);
    };
    const handleClearSearch = ()=>{
        editProfileContainer.setFilter('');
    };
    // ── Macro-level actions ───────────────────────────────────────────────────
    const copyMacro = (macro)=>{
        const macros = editProfileContainer.macros;
        editProfileContainer.setHasChanges(true);
        const cloneMacro = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).cloneDeep(macro);
        const preparedCopy = prepareHotkeysForCopyMacro(cloneMacro, editProfileContainer.hotkeys);
        macros.unshift({
            ...preparedCopy.newMacro
        });
        editProfileContainer.updateMacros([
            ...macros
        ]);
    };
    const handleRemoveMacro = (macro)=>{
        const macros = editProfileContainer.macros;
        editProfileContainer.setHasChanges(true);
        macro.commands?.forEach((c)=>{
            if (c.commandType === 'hotkey') editProfileContainer.removeHotkeyFromMacro(c);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).remove(macros, (h)=>h === macro);
        editProfileContainer.updateMacros([
            ...macros
        ]);
    };
    const handleMacroChange = (updatedMacro)=>{
        const macros = editProfileContainer.macros;
        const index = macros.findIndex((m)=>m.id === updatedMacro.id);
        if (index !== -1) {
            macros[index] = updatedMacro;
            editProfileContainer.updateMacros([
                ...macros
            ]);
        }
        editProfileContainer.setHasChanges(true);
    };
    const handleNameChange = (text, macro)=>{
        const macros = editProfileContainer.macros;
        editProfileContainer.setHasChanges(true);
        macro.name = text;
        editProfileContainer.updateMacros([
            ...macros
        ]);
    };
    // ── Step actions ─────────────────────────────────────────────────────────
    const handleAddStep = (macroIndex)=>{
        editProfileContainer.setHasChanges(true);
        const macros = editProfileContainer.macros;
        macros[macroIndex].events.push({
            eventType: 'KeyPress',
            keys: [
                ''
            ],
            holdTimeMilliseconds: 0
        });
        editProfileContainer.updateMacros([
            ...macros
        ]);
    };
    // ── Command actions ───────────────────────────────────────────────────────
    const handleCommandChange = (value, macro, index)=>{
        editProfileContainer.setHasChanges(true);
        const originalValue = macro.commands[index].command;
        macro.commands[index].command = value;
        if (macro.commands[index].commandType === 'hotkey') {
            const hotkeyId = editProfileContainer.updateHotkeyFromMacro(value, macro, index, originalValue);
            macro.commands[index].hotkeyLocalId = hotkeyId ?? null;
        }
        editProfileContainer.updateMacros([
            ...editProfileContainer.macros
        ]);
    };
    const handleRemoveCommand = (_command, macro, index)=>{
        editProfileContainer.setHasChanges(true);
        const c = macro.commands[index];
        macro.commands.splice(index, 1);
        editProfileContainer.updateMacros([
            ...editProfileContainer.macros
        ]);
        if (c.commandType === 'hotkey') editProfileContainer.removeHotkeyFromMacro(c);
    };
    const handleAddCommand = (macro)=>{
        editProfileContainer.setHasChanges(true);
        setMacroToAddCommand(macro);
    };
    const handleAddCommandWithType = (macro, commandType)=>{
        setMacroToAddCommand(undefined);
        editProfileContainer.setHasChanges(true);
        macro?.commands.push({
            command: '',
            commandType: commandType
        });
        editProfileContainer.updateMacros([
            ...editProfileContainer.macros
        ]);
    };
    return {
        // state
        filter: editProfileContainer.filter,
        macroToAddCommand: macroToAddCommand,
        setMacroToAddCommand: setMacroToAddCommand,
        editingMacroIndex: editingMacroIndex,
        setEditingMacroIndex: setEditingMacroIndex,
        handleSearchChange: // search
        handleSearchChange,
        handleClearSearch: handleClearSearch,
        copyMacro: // macro
        copyMacro,
        handleRemoveMacro: handleRemoveMacro,
        handleMacroChange: handleMacroChange,
        handleNameChange: handleNameChange,
        handleAddStep: // steps
        handleAddStep,
        handleCommandChange: // commands
        handleCommandChange,
        handleRemoveCommand: handleRemoveCommand,
        handleAddCommand: handleAddCommand,
        handleAddCommandWithType: handleAddCommandWithType
    };
}





function $d7cbb52506443fe8$export$87aba18bb0c42cdf({ selectRef: selectRef, addMacroHref: addMacroHref, onNewMacro: onNewMacro, disabled: disabled = false }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const editProfileContainer = (0, $697752726c88b03c$export$2e2bcd8739ae039).useContainer();
    const { filter: filter, macroToAddCommand: macroToAddCommand, setMacroToAddCommand: setMacroToAddCommand, editingMacroIndex: editingMacroIndex, setEditingMacroIndex: setEditingMacroIndex, handleSearchChange: handleSearchChange, handleClearSearch: handleClearSearch, copyMacro: copyMacro, handleRemoveMacro: handleRemoveMacro, handleMacroChange: handleMacroChange, handleNameChange: handleNameChange, handleAddStep: handleAddStep, handleCommandChange: handleCommandChange, handleRemoveCommand: handleRemoveCommand, handleAddCommand: handleAddCommand, handleAddCommandWithType: handleAddCommandWithType } = (0, $33444986c68d8356$export$bd0e99c4527b3b17)();
    const { filteredMacros: filteredMacros } = (0, $138dae19c52184af$export$2e2bcd8739ae039)({
        profile: editProfileContainer,
        filter: filter
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d7cbb52506443fe8$var$MacroControlWrap, {
                ref: selectRef,
                children: [
                    editProfileContainer.macros.length > 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $51af5a17187af6b5$export$2e2bcd8739ae039), {
                        value: filter,
                        onChange: handleSearchChange,
                        onClear: handleClearSearch
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        id: "new-macro-control",
                        $color: "dashedAccent",
                        startIcon: "plus",
                        disabled: disabled,
                        to: "./controls/new",
                        children: t('common:macros.add')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$12253aa05c1176e2), {
                children: filteredMacros?.map((h, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cfa8aa82a863cabd$export$2e2bcd8739ae039), {
                        macro: h,
                        alwaysShowIcons: true,
                        id: h.id,
                        children: editingMacroIndex === i ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d7cbb52506443fe8$var$EditWrapper, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $73229ceea4361fb2$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                                        fullWidth: true,
                                        disabled: disabled,
                                        label: t('common:macros.name.title'),
                                        value: h.name,
                                        name: `${i}name`,
                                        placeholder: t('common:macros.name.placeholder'),
                                        onChange: (e)=>handleNameChange(e.target.value, h)
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$1acdcf5a973a8414), {
                                    children: t('common:input.titlePlural')
                                }),
                                h.commands?.map((c, ci)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0cb68ea454bd64de$export$2e2bcd8739ae039), {
                                        value: c.command,
                                        commandType: c.commandType,
                                        onChange: (value)=>handleCommandChange(value, h, ci),
                                        onRemove: ()=>handleRemoveCommand(c.command, h, ci)
                                    }, h.id + ci)),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                                        startIcon: "plus",
                                        onClick: ()=>handleAddCommand(h),
                                        children: t('common:input.addMore')
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$1acdcf5a973a8414), {
                                    children: t('common:event.titlePlural')
                                }),
                                h.events?.map((e, ei)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3546a67590dd0db1$export$2e2bcd8739ae039), {
                                        macro: h,
                                        step: e,
                                        stepIndex: ei,
                                        onChange: (macro)=>handleMacroChange(macro)
                                    }, ei)),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                                        startIcon: "plus",
                                        onClick: ()=>handleAddStep(i),
                                        children: t('common:event.add')
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d7cbb52506443fe8$var$ButtonContainer, {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                            $color: "secondary",
                                            $size: "small",
                                            startIcon: "replicateRows",
                                            onClick: ()=>copyMacro(h),
                                            children: t('common:copy')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                            $color: "secondary",
                                            $size: "small",
                                            startIcon: "delete",
                                            onClick: ()=>handleRemoveMacro(h),
                                            children: t('common:delete')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                            $color: "primary",
                                            $size: "small",
                                            onClick: ()=>setEditingMacroIndex(undefined),
                                            children: t('common:finishEdit')
                                        })
                                    ]
                                })
                            ]
                        }, i) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$f2170af9598ce20e), {
                            macro: h,
                            showTitle: false,
                            id: h.id,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d7cbb52506443fe8$var$ButtonContainer, {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                        $color: "secondary",
                                        $size: "small",
                                        startIcon: "edit",
                                        onClick: ()=>setEditingMacroIndex(i),
                                        children: t('common:edit')
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                        $color: "secondary",
                                        $size: "small",
                                        startIcon: "replicateRows",
                                        onClick: ()=>copyMacro(h),
                                        children: t('common:copy')
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                        $color: "secondary",
                                        $size: "small",
                                        startIcon: "delete",
                                        onClick: ()=>handleRemoveMacro(h),
                                        children: t('common:delete')
                                    })
                                ]
                            })
                        })
                    }, h.id))
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd50f9e7fc2705de$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4321e97835f672ea$export$2e2bcd8739ae039), {
                open: !!macroToAddCommand,
                onClose: ()=>setMacroToAddCommand(undefined),
                onCommandTypeSelected: (commandType)=>handleAddCommandWithType(macroToAddCommand, commandType)
            })
        ]
    });
}
const $d7cbb52506443fe8$var$MacroControlWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    flex-basis: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
    padding: 1rem 0;
`;
const $d7cbb52506443fe8$var$ButtonContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 1rem;
    margin: 2rem 0;
`;
const $d7cbb52506443fe8$var$EditWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    box-shadow: none;
    border-top: none;
    border-radius: 10px;
    padding: 1rem;
    width: 100%;
    > * {
        max-width: calc(100% - 2rem);
    }
`;


function $21f89ae18675d949$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const location = (0, $5ec159caebd3ae22$export$45d76561a5302f2b)();
    const selectRef = (0, $c449c760a7ee086f$export$29bdea29542a2205)() ?? undefined;
    const editProfileContainer = (0, $697752726c88b03c$export$2e2bcd8739ae039).useContainer();
    const [macroToAddCommand, setMacroToAddCommand] = (0, $7fPBF.useState)();
    const handleSave = async ()=>{
        editProfileContainer.organizationIdRef.current = organizationId ?? null;
        const result = await editProfileContainer.saveChanges();
        return result;
    };
    const handleAddCommandWithType = (macro, commandType)=>{
        setMacroToAddCommand(undefined);
        editProfileContainer.setHasChanges(true);
        macro?.commands.push({
            command: '',
            commandType: commandType
        });
        editProfileContainer.updateMacros([
            ...editProfileContainer.macros
        ]);
    };
    const saveAndExit = async ()=>{
        await handleSave();
    };
    if (!editProfileContainer.commandKeyMappings) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d7cbb52506443fe8$export$87aba18bb0c42cdf), {
                selectRef: selectRef,
                disabled: editProfileContainer.isPreview,
                addMacroHref: (0, $0609c53c7172c5fc$export$da6d2f7032b7150b)(`${location.pathname}/controls/new`)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd50f9e7fc2705de$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4321e97835f672ea$export$2e2bcd8739ae039), {
                open: !!macroToAddCommand,
                onClose: ()=>setMacroToAddCommand(undefined),
                onCommandTypeSelected: (commandType)=>handleAddCommandWithType(macroToAddCommand, commandType)
            }),
            editProfileContainer.hasChanges && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $258cb68b976e3a51$export$2e2bcd8739ae039), {
                hasChanges: editProfileContainer.hasChanges,
                setHasChanges: editProfileContainer.setHasChanges,
                onSave: async ()=>{
                    await editProfileContainer.saveChanges();
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$de401b45f203ff7f), {
                contentPosition: "center",
                $visuallyHide: !editProfileContainer.hasChanges || editProfileContainer.id !== undefined && editProfileContainer.originatedByProfileId !== undefined && !editProfileContainer.hasChanges,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    $color: "primary",
                    $size: "large",
                    startIcon: "save",
                    onClick: saveAndExit,
                    children: t('common:saveAndFinish')
                })
            })
        ]
    });
}







var $7fPBF = parcelRequire("7fPBF");

const $156f799d529efa2e$var$OrgProfileEditPage = ()=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const editProfileContainer = (0, $697752726c88b03c$export$2e2bcd8739ae039).useContainer();
    const { membership: membership } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const headerTextFieldRef = (0, $7fPBF.useRef)(null);
    const myRole = membership ? (0, $d227fca458ea4785$export$68befc518ea2400f)(membership) : undefined;
    // TODO text validation but not checking against all profiles
    // TODO add modified version of associated programs editor for org profiles
    // TODO check scroll to for all errors
    // TODO add error validation messaging
    // TODO figure out how to handle device custom controls might need a new container
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $73229ceea4361fb2$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bdbd121ff5ebdd35$export$2e2bcd8739ae039), {
                    variant: 'voice',
                    value: editProfileContainer.defaultLocale || (0, $3ecd3f7dea3d56de$export$f44b61b0f29ec),
                    onChange: editProfileContainer.handleLocaleChange
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $73229ceea4361fb2$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                    fullWidth: true,
                    label: t('common:profile.name'),
                    value: editProfileContainer.name,
                    placeholder: t('common:profile.nameQuestion'),
                    onChange: (e)=>{
                        editProfileContainer.updateName(e.target.value);
                        editProfileContainer.setHasChanges(true);
                    },
                    ref: headerTextFieldRef
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $73229ceea4361fb2$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                    fullWidth: true,
                    multiline: true,
                    rows: 3,
                    label: t('common:description'),
                    value: editProfileContainer.description || '',
                    placeholder: t('common:description'),
                    onChange: (e)=>{
                        editProfileContainer.updateDescription(e.target.value);
                        editProfileContainer.setHasChanges(true);
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $21f89ae18675d949$export$2e2bcd8739ae039), {})
        ]
    });
};
var $156f799d529efa2e$export$2e2bcd8739ae039 = $156f799d529efa2e$var$OrgProfileEditPage;

















/**
 * InternalNotificationCard is a component that displays a notification card with a title, subtitle, and icon.
 *
 * - `default`: allows unstyled button and text buttons to be used for constructing custom notification cards
 * - `accent` & `info`: uses the secondary colors and should be used for informational notifications
 * - `warning`: uses the warning color should be used for warning notifications
 * - `error`: uses the error color should be used for error notifications
 * - `success`: uses the success color should be used for success notifications
 *
 *  */ const $db7a41c310321878$var$InternalNotificationCard = ({ color: color = 'default', title: title, subtitle: subtitle, subtitleAction: subtitleAction, icon: icon, children: children })=>{
    const theme = (0, $d62c6f18f523e962$export$3b14a55fb2447963)();
    if (!title || !subtitle) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $12a7318cc7b914d5$export$8e508ed4a13b5a61), {
        $color: color,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($db7a41c310321878$var$FlexWrap, {
                children: [
                    icon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                        name: icon,
                        color: theme.banner[color].icon
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$5c3bdb37a55baa65), {
                        as: "h2",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $12a7318cc7b914d5$export$dc254ddf4c41e5d7), {
                $color: color,
                children: [
                    subtitle && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($db7a41c310321878$var$StyledBodyMedium, {
                        children: subtitle
                    }),
                    subtitleAction
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $12a7318cc7b914d5$export$503892287317b6c8), {
                $color: color,
                children: children
            })
        ]
    });
};
const $db7a41c310321878$var$FlexWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: row;
    gap: 1rem;
    align-items: center;
`;
const $db7a41c310321878$var$StyledBodyMedium = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb))`
    display: inline;
`;
var $db7a41c310321878$export$2e2bcd8739ae039 = $db7a41c310321878$var$InternalNotificationCard;













var $7fPBF = parcelRequire("7fPBF");






const $d6a81d2896b045d6$export$46453a0401d6cd1a = (0, $8de346382d86c747$export$2e2bcd8739ae039).summary`
    font-weight: 900;
    list-style: none;
    display: flex;
    align-items: center;
    font-weight: 900;
    gap: 0.5rem;
    ${(0, $19e0bc52fddd02b4$export$87f1b08a59e6d1dd)}
    ::after {
        content: '';
        width: 0;
        height: 0;
        border-top: 10px solid ${(props)=>props.theme.color.text};
        border-inline: 7px solid transparent;
        transition: 0.2s;
    }
`;
const $d6a81d2896b045d6$export$89693000420c0acd = (0, $8de346382d86c747$export$2e2bcd8739ae039).article`
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    color: ${(props)=>props.theme.color.text};
    p {
        display: flex;
        align-items: center;
        gap: 0.25rem;
        color: ${(props)=>props.theme.color.text};
    }
`;
const $d6a81d2896b045d6$export$3e8048d3cf2ba3fd = (0, $8de346382d86c747$export$2e2bcd8739ae039).details`
    padding: 1rem;
    border-radius: 6px;
    &[open] {
        & > summary::after {
            transform: rotate(180deg);
        }
    }
    &:focus-within {
        outline: ${(props)=>props.theme.color.text} auto 2px;
    }
`;
const $d6a81d2896b045d6$export$cf345ef34cd72655 = (0, $8de346382d86c747$export$2e2bcd8739ae039).span`
    font-weight: 100;
`;


function $c09a3f0eb9fc1127$export$2e2bcd8739ae039({ icon: icon, title: title, subtitle: subtitle, children: children }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d6a81d2896b045d6$export$3e8048d3cf2ba3fd), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d6a81d2896b045d6$export$46453a0401d6cd1a), {
                children: [
                    icon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                        name: icon
                    }),
                    title,
                    subtitle && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d6a81d2896b045d6$export$cf345ef34cd72655), {
                        children: subtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d6a81d2896b045d6$export$89693000420c0acd), {
                children: children
            })
        ]
    });
}


const $ef18313c3ee7961b$export$ee154ca4432ae97f = 'profile_conflict_indicator_id';
const $ef18313c3ee7961b$var$ProfileConflictIndicators = ({ errorOnly: errorOnly = false })=>{
    const editProfileContainer = (0, $697752726c88b03c$export$2e2bcd8739ae039).useContainer();
    const currentUserContainer = (0, $8a1185b15e8317ab$export$2e2bcd8739ae039).useContainer();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const alertsContainer = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const [scrollElementID, setScrollElementID] = (0, $7fPBF.useState)(null);
    const triggerScroll = (0, $d856e666394c520b$export$2e2bcd8739ae039)(scrollElementID);
    // error and warning conditional checks
    const showErrors = editProfileContainer.profileConflictErrors?.length > 0;
    const showWarningsBecauseNoErrors = !showErrors && editProfileContainer.profileConflictWarnings?.length > 0;
    const [userWarningOptOut, setUserWarningOptOut] = (0, $7fPBF.useState)(currentUserContainer.currentUser?.userPreferences?.isWarningConflictIndicatorsOptOut ?? false);
    const showWarnings = !userWarningOptOut && !editProfileContainer.isProfileConflictsAcknowledged && showWarningsBecauseNoErrors;
    // handlers
    const handleConflictItemClick = (scrollID, pageLink)=>{
        const element = document.getElementById(scrollID);
        if (!element && pageLink) navigate(pageLink);
        else {
            setScrollElementID(scrollID);
            triggerScroll();
        }
    };
    const handleWarningOptOut = async ()=>{
        const preferences = {
            ...currentUserContainer.currentUser?.userPreferences,
            isWarningConflictIndicatorsOptOut: !userWarningOptOut,
            featureFlags: currentUserContainer.currentUser?.userPreferences?.featureFlags ?? []
        };
        const result = await currentUserContainer.updateUserPreferences(preferences);
        if (result?.resultType == 'Ok') {
            setUserWarningOptOut(!userWarningOptOut);
            alertsContainer.showSuccess(t('common:account.success.userPreferences'));
        } else alertsContainer.showError(result?.errors?.join(', ') ?? t('common:account.error.userPreferences'));
    };
    if (!showErrors && !showWarnings) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $12a7318cc7b914d5$export$7cee909993ddd8b7), {
        id: $ef18313c3ee7961b$export$ee154ca4432ae97f,
        as: "aside",
        tabIndex: -1,
        children: [
            showErrors && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db7a41c310321878$export$2e2bcd8739ae039), {
                title: t('common:profile.conflictIndicators.errorTitle'),
                icon: "warning",
                color: "error",
                subtitle: t('common:profile.conflictIndicators.subtitle'),
                children: editProfileContainer.profileConflictErrors?.map((conflictModel, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($ef18313c3ee7961b$var$ConflictActionCard, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e), {
                                children: conflictModel.title
                            }),
                            conflictModel.subtitle && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$f51cc64edb23e9d6), {
                                children: conflictModel.subtitle
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ef18313c3ee7961b$var$ConflictItemsWrap, {
                                children: conflictModel.items.map((item, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ef18313c3ee7961b$var$StyledConflictItem, {
                                        startIcon: "warning",
                                        onClick: ()=>handleConflictItemClick(item.scrollID, item.pageLink),
                                        children: item.displayString
                                    }, `${item.key}${idx}_ConflictErrorItem`))
                            })
                        ]
                    }, `${conflictModel.title}${index}_ConflictError`))
            }),
            showWarnings && !errorOnly && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $db7a41c310321878$export$2e2bcd8739ae039), {
                title: t('common:profile.conflictIndicators.warningTitle'),
                icon: "warningTriangle",
                color: "warning",
                subtitle: t('common:profile.conflictIndicators.subtitle'),
                children: [
                    editProfileContainer.profileConflictWarnings?.map((conflictModel, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($ef18313c3ee7961b$var$ConflictActionCard, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6392222d2b8fb222$export$f37ee4cff56f2c69), {
                                    children: conflictModel.title
                                }),
                                conflictModel.subtitle && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                    children: conflictModel.subtitle
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ef18313c3ee7961b$var$ConflictItemsWrap, {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c09a3f0eb9fc1127$export$2e2bcd8739ae039), {
                                        title: t('common:profile.conflictIndicators.warningDetails'),
                                        children: conflictModel.items.map((item, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ef18313c3ee7961b$var$StyledConflictItem, {
                                                startIcon: "warningTriangle",
                                                onClick: ()=>handleConflictItemClick(item.scrollID, item.pageLink),
                                                children: item.displayString
                                            }, `${item.key}${idx}_ConflictWarningItem`))
                                    })
                                })
                            ]
                        }, `${conflictModel.title}${index}_ConflictWarning`)),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($ef18313c3ee7961b$var$WarningButtonsWrap, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ef18313c3ee7961b$var$WarningButtons, {
                                startIcon: "cancel2",
                                $color: "secondary",
                                $size: "small",
                                onClick: ()=>editProfileContainer.setIsConflictsAcknowledged(true),
                                children: t('common:profile.conflictIndicators.warningIgnore')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ef18313c3ee7961b$var$WarningButtons, {
                                startIcon: "settings",
                                $color: "secondary",
                                $size: "small",
                                onClick: handleWarningOptOut,
                                children: t('common:profile.conflictIndicators.warningDoNotShowAgain')
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $ef18313c3ee7961b$var$WarningButtons = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039))`
    &:hover {
        color: ${(0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light} !important;
    }
`;
const $ef18313c3ee7961b$var$WarningButtonsWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039))`
    gap: 1rem;
`;
const $ef18313c3ee7961b$var$ConflictItemsWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $9926e0d0274623af$export$1d02c21cd5285ce0))`
    flex-direction: column;
    display: flex;
    flex-wrap: wrap;
    margin: 1rem 0;
`;
const $ef18313c3ee7961b$var$StyledConflictItem = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $9926e0d0274623af$export$da51057063e69428))`
    text-align: left;
    justify-content: left;
    text-decoration: underline;
    z-index: 2;
    width: fit-content;
    :hover {
        text-decoration: none;
    }
`;
const $ef18313c3ee7961b$var$ConflictActionCard = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    margin: 1rem 0rem;
`;
var $ef18313c3ee7961b$export$2e2bcd8739ae039 = $ef18313c3ee7961b$var$ProfileConflictIndicators;










var $7fPBF = parcelRequire("7fPBF");



function $afabe4cc9e2cf491$export$3d73c2564f98ccd9({ disabled: disabled = false }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const location = (0, $5ec159caebd3ae22$export$45d76561a5302f2b)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const { organizationId: organizationId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const editProfileContainer = (0, $697752726c88b03c$export$2e2bcd8739ae039).useContainer();
    const profilesContainer = (0, $60065a32b4a31650$export$2e2bcd8739ae039).useContainer();
    const [anchorEl, setAnchorEl] = (0, $7fPBF.useState)(null);
    const open = Boolean(anchorEl);
    const id = open ? 'profile-options-popover' : undefined;
    const [dialogConfig, setDialogConfig] = (0, $7fPBF.useState)();
    const handleOpen = (e)=>setAnchorEl(e.currentTarget);
    const handleClose = ()=>setAnchorEl(null);
    const handleDelete = async ()=>{
        if (!editProfileContainer.id) return;
        const result = await profilesContainer.deleteProfile(editProfileContainer.id);
        if (result?.resultType == 'Ok') navigate(-1);
    };
    const copyProfile = ()=>{
        showDialog(undefined);
        if (!editProfileContainer.originalProfileRef.current) return;
        // Clone the profile with updated name
        const updatedName = t(`common:profile.copy.profileSuffix`, `${editProfileContainer.name} (copy)`, {
            name: editProfileContainer.name
        });
        const clonedProfile = editProfileContainer.getClonedProfile(editProfileContainer.originalProfileRef.current, editProfileContainer.id, updatedName);
        editProfileContainer.updateProfileState(clonedProfile);
        editProfileContainer.setHasChanges(true);
        // Navigate to appropriate new profile route based on context
        const newProfilePath = organizationId ? `/org/${organizationId}/profiles/new` : '/profiles/create';
        navigate(newProfilePath, {
            replace: true
        });
    };
    const showDialog = (config)=>{
        setDialogConfig(config);
    };
    const closeDialog = ()=>{
        setDialogConfig(undefined);
    };
    const handleShowDialog = (config)=>{
        handleClose(); // Close the popover first
        if (config == 'delete') showDialog(deleteConfig);
        else if (config == 'copy') showDialog(copyConfig);
    };
    const deleteConfig = {
        open: true,
        title: t('common:profile.delete.titleLong'),
        description: t('common:profile.delete.confirmLong'),
        cancelButtonText: t('common:cancel'),
        confirmButtonText: t('common:profile.delete.confirmButton'),
        onConfirm: handleDelete,
        onClose: closeDialog,
        onCancel: closeDialog
    };
    const copyConfig = {
        open: true,
        title: t('common:profile.copy.question'),
        description: t('common:profile.copy.description'),
        cancelButtonText: t('common:cancel'),
        confirmButtonText: t('common:profile.copy.confirm'),
        onConfirm: copyProfile,
        onClose: closeDialog,
        onCancel: closeDialog
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                $color: "quick",
                endIcon: "more",
                $size: "small",
                iconSize: 20,
                "aria-describedby": id,
                onClick: handleOpen,
                children: t('common:options')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77b3b30833fb8c12$export$2e2bcd8739ae039), {
                id: id,
                open: open,
                anchorEl: anchorEl,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($afabe4cc9e2cf491$var$PopoverContent, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            $size: "small",
                            startIcon: "automation",
                            href: (0, $0609c53c7172c5fc$export$da6d2f7032b7150b)(`${location.pathname}/advanced`),
                            children: t('common:advancedOptions')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            $size: "small",
                            startIcon: "layers",
                            disabled: disabled,
                            href: (0, $0609c53c7172c5fc$export$da6d2f7032b7150b)(`${location.pathname}/advanced/summary`),
                            children: t('common:profile.summary.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            $size: "small",
                            startIcon: "duplicate",
                            disabled: disabled,
                            onClick: ()=>handleShowDialog('copy'),
                            children: t('common:profile.copy.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            $size: "small",
                            startIcon: "userGroups",
                            disabled: disabled,
                            to: `./advanced/share`,
                            children: t('common:profile.share.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            $size: "small",
                            startIcon: "delete",
                            disabled: disabled,
                            onClick: ()=>handleShowDialog('delete'),
                            children: t('common:profile.delete.title')
                        })
                    ]
                })
            }),
            dialogConfig && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
                ...dialogConfig,
                onClose: closeDialog
            })
        ]
    });
}
const $afabe4cc9e2cf491$var$PopoverContent = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    width: 300px;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin: 1rem;
`;









var $7fPBF = parcelRequire("7fPBF");


function $b1a3a2a9b20cff10$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { profileId: profileId, organizationId: organizationId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const { getOrgAvailableCustomControls: getOrgAvailableCustomControls, orgAvailableCustomControlsRef: orgAvailableCustomControlsRef } = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const matches = (0, $5ec159caebd3ae22$export$2378eb7f5ff86053)();
    const editProfileContainer = (0, $697752726c88b03c$export$2e2bcd8739ae039).useContainer();
    const { currentOrg: currentOrg, membership: membership, isLoading: orgLoading, canEditOrganizationProfiles: canEditOrganizationProfiles } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const [isInitialized, setIsInitialized] = (0, $7fPBF.useState)(false);
    const isNew = profileId?.toLowerCase() === 'new';
    const myRole = membership ? (0, $d227fca458ea4785$export$68befc518ea2400f)(membership) : undefined;
    const canManage = myRole?.canEditOrganizationProfiles || myRole?.isAdmin;
    // Get title and description from route handle, with fallbacks
    const currentMatch = matches[matches.length - 1];
    const handle = currentMatch?.handle;
    const pageTitle = handle?.title ? t(handle.title) : isNew ? t('common:profile.createTitle') : editProfileContainer.name || t('common:profile.edit');
    const pageDescription = handle?.description ? t(handle.description) : undefined;
    (0, $7fPBF.useEffect)(()=>{
        // Don't update if user has unsaved changes (e.g., copying a profile)
        // This check MUST happen before any other logic
        if (editProfileContainer.hasChangesRef.current) {
            setIsInitialized(true);
            return;
        }
        const getDeviceTypeCustomControls = async ()=>{
            if (!currentOrg?.id) return;
            const result = await getOrgAvailableCustomControls(currentOrg.id, editProfileContainer.defaultLocaleRef.current);
            if (!result) (0, $e7df95de73caec26$export$89b472e03be495df)('alertError', t('common:errors.loadCustomControls'));
            else editProfileContainer.setAvailableCustomControls(orgAvailableCustomControlsRef.current);
            console.log('Available custom controls:', orgAvailableCustomControlsRef.current);
        };
        const initializeProfile = async ()=>{
            if (orgLoading || !currentOrg?.id) return;
            editProfileContainer.organizationIdRef.current = currentOrg.id;
            if (isNew || !profileId) {
                editProfileContainer.setDefaultProfile((0, $3ecd3f7dea3d56de$export$f44b61b0f29ec));
                setIsInitialized(true);
            } else if (profileId) {
                const success = await editProfileContainer.loadOrgPreview(profileId);
                editProfileContainer.setIsPreview(false);
                setIsInitialized(true);
            } else (0, $e7df95de73caec26$export$89b472e03be495df)('alertError', t('common:errors.loadProfile'));
        };
        setIsInitialized(false);
        initializeProfile();
        getDeviceTypeCustomControls();
        return ()=>{
            // Only reset if there are no unsaved changes (e.g., not in the middle of copying)
            if (!editProfileContainer.hasChangesRef.current) {
                editProfileContainer.setDefaultProfile((0, $3ecd3f7dea3d56de$export$f44b61b0f29ec));
                editProfileContainer.setHasChanges(false);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        profileId,
        isNew,
        currentOrg?.id,
        orgLoading
    ]);
    if (!isInitialized) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e8ddd06b3da44631$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: editProfileContainer.name || pageTitle,
                description: pageDescription,
                items: items,
                children: handle?.showActions && profileId && canEditOrganizationProfiles && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($b1a3a2a9b20cff10$var$HeaderActions, {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $afabe4cc9e2cf491$export$3d73c2564f98ccd9), {
                        disabled: !canManage || editProfileContainer.isPreview
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ef18313c3ee7961b$export$2e2bcd8739ae039), {
                errorOnly: true
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5ec159caebd3ae22$export$910ae8079b2c2852), {})
        ]
    });
}
const $b1a3a2a9b20cff10$var$HeaderActions = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
`;












var $7fPBF = parcelRequire("7fPBF");







function $4b8a9e84dae5e7a0$export$8f7032ec10a68144(initialModel) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId } = (0, $748d28edcc8cedba$export$2e2bcd8739ae039)();
    const { clientId: clientId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const { updateOrgAuthClient: updateOrgAuthClient, createOrgAuthClient: createOrgAuthClient } = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const { showSuccess: showSuccess, showError: showError } = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const [editClient, setEditClient, editClientRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(initialModel);
    (0, $7fPBF.useEffect)(()=>{
        if (initialModel) {
            // Create a copy to avoid mutating the original object
            const modelCopy = {
                ...initialModel
            };
            setEditClient(modelCopy);
        } else setEditClient((0, $710192f33815db16$export$78965615411ef913)(organizationId || ''));
    }, [
        initialModel
    ]);
    const handleFieldChange = (fieldName, value)=>{
        setEditClient((prevModel)=>prevModel ? {
                ...prevModel,
                [fieldName]: value
            } : null);
    };
    const handleInputChange = (fieldName, value)=>{
        handleFieldChange(fieldName, value);
    };
    const createUpdateRequest = ()=>{
        if (editClientRef.current && organizationId) {
            const updatedClient = editClientRef.current;
            return updatedClient;
        }
    };
    const handleUpdate = async ()=>{
        const request = createUpdateRequest();
        try {
            if (!request || !organizationId || !clientId) throw new Error('Missing data');
            const result = await updateOrgAuthClient(organizationId, clientId, request);
            if (result?.resultType === 'Ok' && result?.data) setEditClient(result.data);
            return result;
        } catch (error) {
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const handleCreate = async ()=>{
        const request = createUpdateRequest();
        try {
            if (!request || !organizationId) throw new Error('Missing data');
            const result = await createOrgAuthClient(organizationId, request);
            if (result?.resultType === 'Ok' && result?.data) setEditClient(result.data);
            return result;
        } catch (error) {
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const handleAlerts = (result)=>{
        if (result?.resultType === 'Ok') showSuccess(t('common:saved'));
        else showError(t('common:saveError'));
    };
    const handleSave = async ()=>{
        return editClientRef.current?.id ? await handleUpdate() : await handleCreate();
    };
    const handleSaveWithAlerts = async ()=>{
        const result = await handleSave();
        handleAlerts(result);
        return result;
    };
    return {
        editClient: editClient,
        setEditClient: setEditClient,
        handleFieldChange: handleFieldChange,
        handleInputChange: handleInputChange,
        handleSave: handleSave,
        handleSaveWithAlerts: handleSaveWithAlerts
    };
}




var $7fPBF = parcelRequire("7fPBF");





function $76dd6d0d6f9746d5$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId } = (0, $748d28edcc8cedba$export$2e2bcd8739ae039)();
    const { clientId: clientId, deviceId: deviceId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const alertsContainer = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const { orgAuthClients: orgAuthClients, orgDeviceTypes: orgDeviceTypes, getOrgAuthClients: getOrgAuthClients, getOrgDeviceTypes: getOrgDeviceTypes, loadingData: loadingData, loadingDataRef: loadingDataRef, handleLoadingDataChange: handleLoadingDataChange, currentOrgIdRef: currentOrgIdRef } = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const [error, setError] = (0, $7fPBF.useState)({
        client: false,
        device: false
    });
    const fetchOrgData = (0, $7fPBF.useCallback)(async ()=>{
        if (!organizationId || currentOrgIdRef.current == organizationId || loadingDataRef.current.projects) return;
        try {
            handleLoadingDataChange('projects', true);
            await Promise.all([
                getOrgAuthClients(organizationId),
                getOrgDeviceTypes(organizationId)
            ]);
            currentOrgIdRef.current = organizationId;
            setError({
                client: false,
                device: false
            });
        } catch (error) {
            alertsContainer.showError(t('common:organization.projects.error'));
            setError({
                client: true,
                device: true
            });
        } finally{
            handleLoadingDataChange('projects', false);
        }
    }, [
        organizationId
    ]);
    (0, $7fPBF.useEffect)(()=>{
        fetchOrgData();
    }, [
        fetchOrgData
    ]);
    const currentOrgClient = (0, $7fPBF.useMemo)(()=>{
        if (!orgAuthClients || !clientId) return null;
        const client = orgAuthClients?.find((client)=>client.id === clientId) ?? null;
        if (!client && error.client === false) setError((prev)=>({
                ...prev,
                client: true
            }));
        else if (error.client === true) setError((prev)=>({
                ...prev,
                client: false
            }));
        return client;
    }, [
        orgAuthClients,
        clientId
    ]);
    const currentOrgDeviceType = (0, $7fPBF.useMemo)(()=>{
        if (!orgDeviceTypes || !deviceId) return null;
        const device = orgDeviceTypes.find((device)=>device.id === deviceId) ?? null;
        if (!device && error.device === false) setError((prev)=>({
                ...prev,
                device: true
            }));
        else if (error.device === true) setError((prev)=>({
                ...prev,
                device: false
            }));
        return device;
    }, [
        orgDeviceTypes,
        deviceId
    ]);
    return {
        error: error,
        currentOrgClient: currentOrgClient,
        currentOrgDeviceType: currentOrgDeviceType,
        authClients: orgAuthClients,
        deviceTypes: orgDeviceTypes,
        isLoading: loadingData.projects
    };
}









function $0ec5f0e18dd3ab72$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
        description: t('common:organization.projects.upgrade.description'),
        fullHeight: true,
        icon: "virtualApps",
        title: t('common:organization.projects.upgrade.title'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
            href: "https://cephable.com/sdk-trial/",
            target: "_blank",
            startIcon: "plusLight",
            children: t('common:upgrade')
        })
    });
}







var $7fPBF = parcelRequire("7fPBF");






const $3faa7d453f5d11ef$export$22fa1e7523221c6e = (0, $8de346382d86c747$export$2e2bcd8739ae039)('fieldset')`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;
const $3faa7d453f5d11ef$export$e37cfa0e4472699e = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e))`
    margin-bottom: 0.5rem;
`;
const $3faa7d453f5d11ef$export$9e6d910ccc56f44f = (0, $8de346382d86c747$export$2e2bcd8739ae039)('div')`
    padding: 0.5rem 0;
    display: flex;
    gap: 1rem;
    align-items: center;
    flex-direction: row;
    flex-grow: 1;
`;
const $3faa7d453f5d11ef$export$dbe450127ad7120d = (0, $8de346382d86c747$export$2e2bcd8739ae039)('div')`
    width: 100%;
`;
const $3faa7d453f5d11ef$export$fa089c085574c34c = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$f51cc64edb23e9d6))`
    transition: all 0.3s;
    color: ${({ theme: theme })=>theme.color.error};
`;
const $3faa7d453f5d11ef$export$a82c6f1cc70eb063 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$1ef657600983666a))`
    align-self: flex-start;
`;


function $0f47f90096855080$export$2e2bcd8739ae039({ initialValues: initialValues = [
    ''
], maxItems: maxItems, placeholder: placeholder = '---', legend: legend, description: description, selectOptions: selectOptions, onChange: onChange, dialogComponent: dialogComponent, createNewItemLabel: createNewItemLabel }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [items, setItems] = (0, $7fPBF.useState)(initialValues.length === 0 ? [
        ''
    ] : initialValues);
    const [error, setError] = (0, $7fPBF.useState)();
    const [isDialogOpenProps, setDialogOpenProps] = (0, $7fPBF.useState)({
        open: false,
        index: -1
    });
    const [errorValues, setErrorValues] = (0, $7fPBF.useState)();
    const inputRefs = (0, $7fPBF.useRef)([]);
    const buttonRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(()=>{
        setItems(initialValues.length === 0 ? [
            ''
        ] : initialValues);
    }, [
        initialValues
    ]);
    const handleAddItem = ()=>{
        if (maxItems && items.length + 1 >= maxItems) setError(t('common:input.maximum', 'Max number of items.', {
            maxItems: maxItems
        }));
        setItems((prevItems)=>{
            const newItems = [
                ...prevItems,
                ''
            ];
            // Schedule a focus on the new field
            setTimeout(()=>{
                const newIndex = newItems.length - 1;
                inputRefs.current[newIndex]?.focus();
            }, 0);
            return newItems;
        });
    };
    const handleRemoveItem = (index)=>{
        const updatedItems = items.filter((_, i)=>i !== index);
        setItems(updatedItems);
        setError(null);
        onChange?.(updatedItems);
        // Move focus to the next or previous input
        setTimeout(()=>{
            if (updatedItems.length === 0) // If no items left, focus the Add button
            buttonRef.current?.focus();
            else if (inputRefs.current[index]) // Focus the next input if available
            inputRefs.current[index]?.focus();
            else if (inputRefs.current[index - 1]) // Focus the previous input
            inputRefs.current[index - 1]?.focus();
        }, 0);
    };
    const handleChangeItem = (index, value)=>{
        setError(null);
        setErrorValues(null);
        if (items.includes(value)) {
            setErrorValues(value);
            setError(t('common:input.duplicate'));
        }
        const updatedItems = [
            ...items
        ];
        updatedItems[index] = value;
        setItems(updatedItems);
        onChange?.(updatedItems);
    };
    const handleDialogOpen = (index)=>{
        setDialogOpenProps({
            open: true,
            index: index
        });
    };
    const handleDialogClose = ()=>{
        setDialogOpenProps({
            open: false,
            index: -1
        });
    };
    const handleNewItemCreated = (newValue, index)=>{
        // get current index of where dialog was opened from
        if (index == null || index === -1) return;
        const currentIndex = index;
        // Update the current empty item with the new value
        const updatedItems = [
            ...items
        ];
        updatedItems[currentIndex] = newValue;
        // Update state and notify parent
        setItems(updatedItems);
        onChange?.(updatedItems);
        // Focus the updated item
        inputRefs.current[currentIndex]?.focus();
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3faa7d453f5d11ef$export$22fa1e7523221c6e), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3faa7d453f5d11ef$export$e37cfa0e4472699e), {
                as: "legend",
                children: legend
            }),
            description && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3faa7d453f5d11ef$export$a82c6f1cc70eb063), {
                children: description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3faa7d453f5d11ef$export$dbe450127ad7120d), {
                role: "list",
                children: items.map((item, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3faa7d453f5d11ef$export$9e6d910ccc56f44f), {
                        role: "listitem",
                        children: [
                            selectOptions ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                fullWidth: true,
                                value: item,
                                onChange: (e)=>e.target.value === '__open_dialog__' ? handleDialogOpen(index) : handleChangeItem(index, e.target.value),
                                "aria-label": t('common:input.item', 'Item', {
                                    index: index + 1,
                                    label: legend
                                }),
                                error: !!error && errorValues === item,
                                inputRef: (el)=>inputRefs.current[index] = el,
                                children: [
                                    selectOptions.map((option, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                            value: option.value,
                                            children: option.label || option.value
                                        }, i)),
                                    dialogComponent && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($0f47f90096855080$var$CreateMenuItem, {
                                        value: "__open_dialog__",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                name: "plusLight"
                                            }),
                                            createNewItemLabel ?? t('common:input.add')
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039), {
                                fullWidth: true,
                                value: item,
                                placeholder: placeholder,
                                onChange: (e)=>handleChangeItem(index, e.target.value),
                                "aria-label": t('common:input.item', 'Item', {
                                    index: index + 1,
                                    label: legend
                                }),
                                error: !!error && errorValues === item,
                                inputRef: (el)=>inputRefs.current[index] = el
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bb13d1f471bb27c$export$2e2bcd8739ae039), {
                                hideBorder: true,
                                startIcon: "cancel2",
                                label: t('common:input.removeItem', 'Remove item', {
                                    index: index + 1
                                }),
                                onClick: ()=>handleRemoveItem(index)
                            })
                        ]
                    }, index))
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3faa7d453f5d11ef$export$fa089c085574c34c), {
                role: "alert",
                children: error
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                display: "flex",
                alignItems: "center",
                gap: 2,
                children: (maxItems == undefined || items.length < maxItems) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    $color: "accent",
                    startIcon: "plusLight",
                    onClick: handleAddItem,
                    ref: buttonRef,
                    children: t('common:add')
                })
            }),
            dialogComponent && dialogComponent({
                open: isDialogOpenProps.open,
                index: isDialogOpenProps.index,
                onClose: handleDialogClose,
                onCreated: handleNewItemCreated
            })
        ]
    });
}
const $0f47f90096855080$var$CreateMenuItem = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $3bdbe9250415b022$export$2e2bcd8739ae039))`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
`;



var $7fPBF = parcelRequire("7fPBF");

function $86bb7a18b305ac09$export$2e2bcd8739ae039({ additionalRedirectUris: additionalRedirectUris, authCodeRedirectUrlHost: authCodeRedirectUrlHost, onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    // Compute combined values directly - no state needed
    const displayValues = (0, $7fPBF.useMemo)(()=>{
        return authCodeRedirectUrlHost ? [
            authCodeRedirectUrlHost,
            ...additionalRedirectUris
        ] : [
            ...additionalRedirectUris
        ];
    }, [
        authCodeRedirectUrlHost,
        additionalRedirectUris
    ]);
    const handleChange = (updatedUris)=>{
        // Split back into host (first item) and additional (rest)
        const newHost = updatedUris.length > 0 ? updatedUris[0] : undefined;
        const newAdditional = updatedUris.slice(1);
        onUpdate('additionalRedirectUris', newAdditional, 'authCodeRedirectUrlHost', newHost);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0f47f90096855080$export$2e2bcd8739ae039), {
        initialValues: displayValues,
        legend: t('common:organization.projects.authRedirect.title'),
        description: t('common:organization.projects.authRedirect.description'),
        onChange: handleChange
    });
}









var $7fPBF = parcelRequire("7fPBF");






function $bc567063fd13cd58$export$d5236bf86334668(initialModel) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId } = (0, $748d28edcc8cedba$export$2e2bcd8739ae039)();
    const { deviceId: deviceId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const { showSuccess: showSuccess, showError: showError } = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const { updateOrgDeviceType: updateOrgDeviceType, createOrgDeviceType: createOrgDeviceType } = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const editDeviceTypeContainer = (0, $c6a32ec408b1369c$export$2e2bcd8739ae039).useContainer();
    (0, $7fPBF.useEffect)(()=>{
        if (deviceId && deviceId == editDeviceTypeContainer.editDeviceTypeRef.current?.id && !editDeviceTypeContainer.hasChangesRef.current || !initialModel) return;
        editDeviceTypeContainer.initializeEditor(initialModel, organizationId);
        editDeviceTypeContainer.initializeEditListing(organizationId, deviceId);
    }, [
        deviceId,
        organizationId,
        initialModel
    ]);
    const actions = {
        updateOrgDeviceType: updateOrgDeviceType,
        createOrgDeviceType: createOrgDeviceType
    };
    const handleAlerts = (result)=>{
        if (result.resultType === 'Ok') showSuccess(t('common:saved'));
        else showError(t('common:saveError'));
    };
    const handleSave = async ()=>{
        if (!organizationId) throw new Error('Missing organization ID');
        return await editDeviceTypeContainer.handleSave(actions, organizationId, deviceId);
    };
    const handleSaveWithAlerts = async ()=>{
        const result = await handleSave();
        handleAlerts(result);
        return result;
    };
    const handleCreateAndClearEditor = async ()=>{
        if (!organizationId) throw new Error('Missing organization ID');
        const result = await editDeviceTypeContainer.handleCreateAndClearEditor(actions, organizationId);
        handleAlerts(result);
        return result;
    };
    const resetEditor = ()=>{
        editDeviceTypeContainer.initializeEditor(null, organizationId);
    };
    return {
        handleSave: handleSave,
        handleSaveWithAlerts: handleSaveWithAlerts,
        handleCreateAndClearEditor: handleCreateAndClearEditor,
        handleInputChange: editDeviceTypeContainer.handleInputChange,
        editDeviceType: editDeviceTypeContainer.editDeviceType,
        resetEditor: resetEditor
    };
}



var $7fPBF = parcelRequire("7fPBF");




function $e01b516a47e1de8f$export$2e2bcd8739ae039({ value: value = '-', onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039), {
        fullWidth: true,
        label: t('common:organization.projects.deviceType.name'),
        value: value,
        placeholder: '-',
        onChange: (e)=>onUpdate('name', e.target.value)
    });
}






// List of specific fields to show checkboxes for
const $3ad34c58e371e6c3$var$specificBooleanFields = [
    'supportsVoiceInput',
    'supportsFaceInput',
    'supportsGestureInput',
    'supportsPhysicalInput',
    'supportsDigitalExtensions',
    'supportsPhysicalExtensions',
    'supportsKeyboardOutput',
    'supportsGenericControllerOutput',
    'supportsXboxControllerOutput',
    'supportsPlayStationControllerOutput',
    'supportsNintendoControllerOutput'
];
function $3ad34c58e371e6c3$export$2e2bcd8739ae039({ editDeviceType: editDeviceType, onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3faa7d453f5d11ef$export$22fa1e7523221c6e), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3faa7d453f5d11ef$export$e37cfa0e4472699e), {
                as: "legend",
                children: t('common:organization.projects.deviceType.features.title')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3faa7d453f5d11ef$export$a82c6f1cc70eb063), {
                children: t('common:organization.projects.deviceType.features.description')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ad34c58e371e6c3$var$StyledFormGroup, {
                children: $3ad34c58e371e6c3$var$specificBooleanFields.map((fieldName)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d99e6d55ec7d57a$export$2e2bcd8739ae039), {
                            checked: !!editDeviceType[fieldName],
                            onChange: (e)=>onUpdate(fieldName, e.target.checked)
                        }),
                        label: t(`common:organization.projects.deviceType.features.${fieldName}`)
                    }, fieldName))
            })
        ]
    });
}
const $3ad34c58e371e6c3$var$StyledFormGroup = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $cd2b84e36aef1fba$export$2e2bcd8739ae039))`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    width: 100%;
`;






const $f5f187ec04d6f075$var$specificBooleanFields = [
    'canAutoStart',
    'isSupported'
];
function $f5f187ec04d6f075$export$2e2bcd8739ae039({ editDeviceType: editDeviceType, onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: $f5f187ec04d6f075$var$specificBooleanFields.map((fieldName)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
                value: "start",
                control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $01917f736960ab46$export$2e2bcd8739ae039), {
                    checked: !!editDeviceType[fieldName],
                    onChange: (e)=>onUpdate(fieldName, e.target.checked)
                }),
                label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e), {
                            as: "label",
                            children: t(`common:organization.projects.deviceType.${fieldName}.title`)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$1ef657600983666a), {
                            children: t(`common:organization.projects.deviceType.${fieldName}.description`)
                        })
                    ]
                }),
                labelPlacement: "end"
            }, fieldName))
    });
}


function $42567f24cb8195b5$export$2e2bcd8739ae039({ open: open, onClose: onClose, index: index, onCreated: onCreated }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { editDeviceType: editDeviceType, handleCreateAndClearEditor: handleCreateAndClearEditor, handleInputChange: handleInputChange, resetEditor: resetEditor } = (0, $bc567063fd13cd58$export$d5236bf86334668)(null);
    const handleSaveAndClose = async ()=>{
        const response = await handleCreateAndClearEditor();
        if (response.resultType === 'Ok' && response.data) {
            onCreated?.(response.data.id, index ?? -1);
            onClose();
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        if (open) resetEditor();
    }, [
        open
    ]);
    if (!editDeviceType) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        fullWidth: true,
        open: open,
        onClose: onClose,
        onCancel: onClose,
        title: t('common:organization.projects.deviceType.action'),
        description: t('common:organization.projects.deviceType.description'),
        onConfirm: handleSaveAndClose,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$174d4944f63edcc7), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e01b516a47e1de8f$export$2e2bcd8739ae039), {
                    value: editDeviceType.name,
                    onUpdate: (field, value)=>handleInputChange(field, value)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ad34c58e371e6c3$export$2e2bcd8739ae039), {
                    editDeviceType: editDeviceType,
                    onUpdate: handleInputChange
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f5f187ec04d6f075$export$2e2bcd8739ae039), {
                    editDeviceType: editDeviceType,
                    onUpdate: handleInputChange
                })
            ]
        })
    });
}


function $1f273ff0abbe6580$export$2e2bcd8739ae039({ value: value, deviceOptions: deviceOptions, onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const selectOptions = deviceOptions.map((device)=>({
            value: device.id,
            label: device.name
        }));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0f47f90096855080$export$2e2bcd8739ae039), {
        initialValues: value,
        legend: t('common:organization.projects.deviceScopes.titleLong'),
        description: t('common:organization.projects.deviceScopes.description'),
        selectOptions: selectOptions,
        onChange: (updatedDevices)=>onUpdate('authClientDeviceTypes', updatedDevices),
        dialogComponent: ({ open: open, index: index, onClose: onClose, onCreated: onCreated })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $42567f24cb8195b5$export$2e2bcd8739ae039), {
                open: open,
                index: index,
                onClose: onClose,
                onCreated: onCreated
            }),
        createNewItemLabel: t('common:organization.projects.deviceScopes.action')
    });
}










var $7fPBF = parcelRequire("7fPBF");







var $7fPBF = parcelRequire("7fPBF");


function $7c682d04727f84e5$export$2e2bcd8739ae039({ clientId: clientId, organizationId: organizationId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const organizationContainer = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const alertsContainer = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const [showWarning, setShowWarning] = (0, $7fPBF.useState)(false);
    const handleCancelWarning = ()=>{
        setShowWarning(false);
    };
    const deleteClient = async ()=>{
        try {
            const result = await organizationContainer.deleteOrgAuthClient(organizationId, clientId);
            if (result.resultType == 'Ok') {
                navigate(-1);
                alertsContainer.showError(t('common:organization.projects.key.delete.success'));
            }
        } catch (error) {
            alertsContainer.showError(t('common:organization.projects.key.delete.error'));
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                $color: "accent",
                startIcon: "cancel2",
                onClick: ()=>setShowWarning(true),
                children: t('common:organization.projects.key.delete.title')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
                open: showWarning,
                onCancel: handleCancelWarning,
                onClose: handleCancelWarning,
                onConfirm: deleteClient,
                confirmButtonText: t('common:organization.projects.key.delete.title'),
                title: t('common:organization.projects.key.delete.title'),
                description: t('common:organization.projects.key.delete.description')
            })
        ]
    });
}








var $7fPBF = parcelRequire("7fPBF");







function $f2dd45cbffb74c92$export$2e2bcd8739ae039({ secret: secret, open: open, onClose: onClose }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { showSuccess: showSuccess } = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const copySecret = ()=>{
        navigator.clipboard.writeText(secret ?? '').then(()=>{
            showSuccess(t('common:profile.share.copied'));
        });
    };
    if (!secret) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        onConfirm: onClose,
        confirmButtonText: t('common:done'),
        title: t('common:organization.projects.secret.title'),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce), {
                    children: t('common:organization.projects.secret.description')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $61f23b7617a6c4bc$export$2e2bcd8739ae039), {
                value: secret ?? '',
                readOnly: true,
                onClick: copySecret,
                inputLabel: t('common:organization.projects.secret.title'),
                actionLabel: t('common:organization.projects.secret.copy')
            })
        ]
    });
}


function $fe218ac773675bd0$export$2e2bcd8739ae039({ clientId: clientId, organizationId: organizationId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { rotateClientSecret: rotateClientSecret } = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    const alertsContainer = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const [showWarning, setShowWarning] = (0, $7fPBF.useState)(false);
    const [showSecret, setShowSecret] = (0, $7fPBF.useState)(false);
    const [result, setResult] = (0, $7fPBF.useState)(null);
    const handleCancelWarning = ()=>{
        setShowWarning(false);
    };
    const handleRotateClientSecret = async ()=>{
        setShowWarning(false);
        try {
            const response = await rotateClientSecret(organizationId, clientId);
            if (response?.resultType == 'Ok') {
                setResult(response.data);
                setShowSecret(true);
            }
        } catch (error) {
            alertsContainer.showError(t('common:organization.projects.secret.rotate.error'));
        }
    };
    if (!organizationId || !clientId) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                $color: "accent",
                startIcon: "repeat",
                onClick: ()=>setShowWarning(true),
                children: t('common:organization.projects.secret.rotate.title')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
                open: showWarning,
                onCancel: handleCancelWarning,
                onClose: handleCancelWarning,
                onConfirm: handleRotateClientSecret,
                confirmButtonText: t('common:continue'),
                title: t('common:organization.projects.secret.rotate.title'),
                description: t('common:organization.projects.secret.rotate.description')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f2dd45cbffb74c92$export$2e2bcd8739ae039), {
                secret: result?.secret ?? '',
                open: showSecret,
                onClose: ()=>setShowSecret(false)
            })
        ]
    });
}


function $b144367e0a20d9c5$export$2e2bcd8739ae039({ clientId: clientId, organizationId: organizationId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [showKey, setShowKey] = (0, $7fPBF.useState)(false);
    const alertsContainer = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    if (!clientId) return null;
    const handleKeyViewToggle = ()=>{
        setShowKey(!showKey);
    };
    const copyKey = ()=>{
        navigator.clipboard.writeText(clientId).then(()=>{
            alertsContainer.showSuccess(t('common:profile.share.copied'));
        });
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($b144367e0a20d9c5$var$Content, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $61f23b7617a6c4bc$export$2e2bcd8739ae039), {
                value: showKey ? clientId : (0, $9bc694be59ba7dc7$export$94edfa5bee6a54b8)(clientId),
                readOnly: true,
                onClick: copyKey,
                inputLabel: t('common:organization.projects.key.title'),
                actionLabel: t('common:organization.projects.key.copy')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $347ffda0d89c401a$export$564cbe3426fc093a), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        $color: "accent",
                        startIcon: "eye",
                        onClick: handleKeyViewToggle,
                        children: t('common:organization.projects.key.view')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fe218ac773675bd0$export$2e2bcd8739ae039), {
                        organizationId: organizationId,
                        clientId: clientId
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7c682d04727f84e5$export$2e2bcd8739ae039), {
                        organizationId: organizationId,
                        clientId: clientId
                    })
                ]
            })
        ]
    });
}
const $b144367e0a20d9c5$var$Content = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
`;





function $98c9acefb60389ed$export$2e2bcd8739ae039({ value: value = '', onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039), {
        fullWidth: true,
        label: t('common:organization.projects.name'),
        value: value,
        placeholder: '-',
        onChange: (e)=>onUpdate('name', e.target.value)
    });
}





function $50c02032c88163c7$export$2e2bcd8739ae039({ value: value = '', onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039), {
        fullWidth: true,
        label: t('common:organization.projects.originHost.title'),
        value: value,
        placeholder: 'https://abcd.com',
        onChange: (e)=>onUpdate('originHost', e.target.value)
    });
}



/** @jsxImportSource @emotion/react */ 

parcelRequire("7fPBF");








var $addf5d80adbc84db$export$ffb0004e005737fa = $824c049f32d4395d$exports.Fragment;
var $addf5d80adbc84db$export$34b9dba7ce09269b = function jsx(type, props, key) {
    if (!(0, $d62c6f18f523e962$export$dda1d9f60106f0e9).call(props, 'css')) return $824c049f32d4395d$exports.jsx(type, props, key);
    return $824c049f32d4395d$exports.jsx((0, $d62c6f18f523e962$export$a9c23c6ac3fc3eca), (0, $d62c6f18f523e962$export$db3b6bfb95261072)(type, props), key);
};
var $addf5d80adbc84db$export$25062201e9e25d76 = function jsxs(type, props, key) {
    if (!(0, $d62c6f18f523e962$export$dda1d9f60106f0e9).call(props, 'css')) return $824c049f32d4395d$exports.jsxs(type, props, key);
    return $824c049f32d4395d$exports.jsxs((0, $d62c6f18f523e962$export$a9c23c6ac3fc3eca), (0, $d62c6f18f523e962$export$db3b6bfb95261072)(type, props), key);
};









const $cef4d3c57a62fbd6$export$2e05d2650e03ee9e = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== 'first'
})`
    padding: 0 0 0.5rem 0;
    ${(props)=>!props.first && `padding-top: 0.5rem;`};
    width: 100%;
    border-bottom: 1px solid ${(props)=>props.theme.input.border};
`;
const $cef4d3c57a62fbd6$export$8a566344fe5517e6 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $206020d7e70b2617$export$2e2bcd8739ae039))`
    margin: 0;
`;






function $df4d569ff53deb23$export$2e2bcd8739ae039({ label: label, description: description, subOption: subOption = false }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($df4d569ff53deb23$var$LabelWrapper, {
        subOption: subOption,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($df4d569ff53deb23$var$Label, {
                children: label
            }),
            description && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                children: description
            })
        ]
    });
}
const $df4d569ff53deb23$var$Label = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd))`
    color: ${(props)=>props.theme.color.text};
`;
const $df4d569ff53deb23$var$LabelWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== 'subOption'
})`
    display: grid;
    grid-template-columns: 13rem auto;
    column-gap: ${(props)=>props.subOption ? '1rem' : '3rem'};
    align-items: center;
`;


function $5569661c7d97b5c7$export$2e2bcd8739ae039({ option: option, state: state, handleParentChange: handleParentChange, handleSubOptionChange: handleSubOptionChange }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cef4d3c57a62fbd6$export$2e05d2650e03ee9e), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cef4d3c57a62fbd6$export$8a566344fe5517e6), {
                control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d99e6d55ec7d57a$export$2e2bcd8739ae039), {
                    checked: !!state[option.value],
                    onChange: ()=>handleParentChange(option.value, !!option.subOptions?.length),
                    indeterminate: option.subOptions ? option.subOptions.some((sub)=>state[sub.value]) && !option.subOptions.every((sub)=>state[sub.value]) : false
                }),
                label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $df4d569ff53deb23$export$2e2bcd8739ae039), {
                    label: option.label,
                    description: option.description
                })
            }),
            option.subOptions && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                children: option.subOptions.map((subOption)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5569661c7d97b5c7$var$SubSection, {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cef4d3c57a62fbd6$export$8a566344fe5517e6), {
                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d99e6d55ec7d57a$export$2e2bcd8739ae039), {
                                checked: state[subOption.value],
                                onChange: ()=>handleSubOptionChange(option.value, subOption.value)
                            }),
                            label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $df4d569ff53deb23$export$2e2bcd8739ae039), {
                                label: subOption.label,
                                description: subOption.description,
                                subOption: true
                            })
                        })
                    }, subOption.value))
            })
        ]
    });
}
const $5569661c7d97b5c7$var$SubSection = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $77ec199cefd4182a$export$2e2bcd8739ae039))`
    margin-left: 2rem;
`;





function $a6e7a7946e260452$export$2e2bcd8739ae039({ checked: checked, indeterminate: indeterminate, onChange: onChange, label: label }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cef4d3c57a62fbd6$export$2e05d2650e03ee9e), {
        first: true,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cef4d3c57a62fbd6$export$8a566344fe5517e6), {
            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d99e6d55ec7d57a$export$2e2bcd8739ae039), {
                size: "medium",
                checked: checked,
                indeterminate: indeterminate,
                onChange: onChange
            }),
            label: label
        })
    });
}


function $ddeece3e20817772$export$2e2bcd8739ae039({ legend: legend, selectAllLabel: selectAllLabel, options: options, activeValues: activeValues = [], onUpdate: onUpdate }) {
    const state = $ddeece3e20817772$var$mapActiveValuesToState(options, activeValues);
    const handleParentChange = (parentValue, hasSubOptions)=>{
        const isChecked = !state[parentValue];
        const updatedValues = $ddeece3e20817772$var$updateParentValues(activeValues, options, parentValue, isChecked);
        onUpdate(updatedValues);
    };
    const handleSubOptionChange = (parentValue, subValue)=>{
        const updatedValues = $ddeece3e20817772$var$updateSubOptionValues(activeValues, options, parentValue, subValue);
        onUpdate(updatedValues);
    };
    const handleSelectAllChange = ()=>{
        const allChecked = $ddeece3e20817772$var$areAllOptionsChecked(state, options);
        const updatedValues = $ddeece3e20817772$var$toggleAllValues(activeValues, options, !allChecked);
        onUpdate(updatedValues);
    };
    return /*#__PURE__*/ (0, $addf5d80adbc84db$export$34b9dba7ce09269b)($ddeece3e20817772$var$Scrollable, {
        children: /*#__PURE__*/ (0, $addf5d80adbc84db$export$25062201e9e25d76)((0, $3faa7d453f5d11ef$export$22fa1e7523221c6e), {
            children: [
                /*#__PURE__*/ (0, $addf5d80adbc84db$export$34b9dba7ce09269b)((0, $3faa7d453f5d11ef$export$e37cfa0e4472699e), {
                    as: "legend",
                    children: legend
                }),
                selectAllLabel && /*#__PURE__*/ (0, $addf5d80adbc84db$export$34b9dba7ce09269b)((0, $a6e7a7946e260452$export$2e2bcd8739ae039), {
                    checked: $ddeece3e20817772$var$areAllOptionsChecked(state, options),
                    indeterminate: $ddeece3e20817772$var$areSomeOptionsChecked(state, options) && !$ddeece3e20817772$var$areAllOptionsChecked(state, options),
                    onChange: handleSelectAllChange,
                    label: selectAllLabel
                }),
                options && options.map((option)=>/*#__PURE__*/ (0, $addf5d80adbc84db$export$34b9dba7ce09269b)((0, $5569661c7d97b5c7$export$2e2bcd8739ae039), {
                        option: option,
                        state: state,
                        handleParentChange: handleParentChange,
                        handleSubOptionChange: handleSubOptionChange
                    }, option.value))
            ]
        })
    });
}
const $ddeece3e20817772$var$mapActiveValuesToState = (options = [], activeValues = [])=>options.reduce((acc, option)=>{
        acc[option.value] = activeValues.includes(option.value);
        if (option.subOptions) option.subOptions.forEach((subOption)=>{
            acc[subOption.value] = activeValues.includes(subOption.value);
        });
        return acc;
    }, {});
const $ddeece3e20817772$var$updateParentValues = (activeValues, options, parentValue, isChecked)=>{
    const parentOption = options.find((opt)=>opt.value === parentValue);
    let updatedValues = [
        ...activeValues
    ];
    if (isChecked) // Add parent and all sub-options
    updatedValues = Array.from(new Set([
        ...updatedValues,
        parentValue,
        ...parentOption?.subOptions?.map((sub)=>sub.value) || []
    ]));
    else // Remove parent and all sub-options
    updatedValues = updatedValues.filter((value)=>value !== parentValue && !parentOption?.subOptions?.some((sub)=>sub.value === value));
    return updatedValues;
};
const $ddeece3e20817772$var$updateSubOptionValues = (activeValues, options, parentValue, subValue)=>{
    const parentOption = options.find((opt)=>opt.value === parentValue);
    let updatedValues = [
        ...activeValues
    ];
    if (updatedValues.includes(subValue)) // Remove sub-option
    updatedValues = updatedValues.filter((value)=>value !== subValue);
    else // Add sub-option
    updatedValues = [
        ...updatedValues,
        subValue
    ];
    // Check if all siblings are selected to toggle parent
    if (parentOption?.subOptions?.every((sub)=>updatedValues.includes(sub.value))) updatedValues = [
        ...updatedValues,
        parentValue
    ];
    else updatedValues = updatedValues.filter((value)=>value !== parentValue);
    return updatedValues;
};
const $ddeece3e20817772$var$toggleAllValues = (activeValues, options, isChecked)=>{
    if (isChecked) // Select all options and sub-options
    return Array.from(new Set(options.flatMap((option)=>[
            option.value,
            ...option.subOptions?.map((sub)=>sub.value) || []
        ])));
    // Deselect all
    return [];
};
const $ddeece3e20817772$var$areAllOptionsChecked = (state, options)=>options.every((option)=>state[option.value] && option.subOptions?.every((sub)=>state[sub.value]) !== false);
const $ddeece3e20817772$var$areSomeOptionsChecked = (state, options)=>options.some((option)=>state[option.value] || option.subOptions?.some((sub)=>state[sub.value]) === true);
const $ddeece3e20817772$var$Scrollable = (0, $8de346382d86c747$export$2e2bcd8739ae039)('div')`
    overflow-x: auto;
    padding: 0 0.25rem;
`;




var $7fPBF = parcelRequire("7fPBF");

function $b3442ae70315e7e8$export$95fa510925bbc2d1() {
    const [error, setError] = (0, $7fPBF.useState)(false);
    const { getScopes: fetchScopes, scopes: scopes, setScopes: setScopes, scopesRef: scopesRef, loadingData: loadingData, handleLoadingDataChange: handleLoadingDataChange } = (0, $55ce97f088539572$export$2e2bcd8739ae039).useContainer();
    // List of IDs to exclude due to generic all scopes that were added before we opted for null scope approach.
    const excludedIds = [
        '9760cf0c-fa0a-4023-8822-54c8d2112fd7',
        '9e87110e-cd07-4025-ae8b-db9f9840758e',
        '0887b18e-fb6b-4a2a-92cf-8641e1d19485',
        '2cf82a34-a1ee-44cf-98ce-9fe6e09756fd'
    ];
    const toPascalCase = (str)=>{
        return str.split('_').map((word)=>word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
        .join('');
    };
    (0, $7fPBF.useEffect)(()=>{
        const getScopes = async ()=>{
            try {
                handleLoadingDataChange('scopes', true);
                const data = await fetchScopes();
                // Filter out excluded IDs, then map and sort the data alphabetically by label
                const sortedScopes = data.filter((scope)=>!excludedIds.includes(scope.id)).map((scope)=>({
                        label: toPascalCase(scope.name),
                        value: scope.id,
                        description: scope.description
                    })).sort((a, b)=>a.label.localeCompare(b.label));
                setScopes(sortedScopes);
                setError(false);
            } catch (err) {
                setError(true);
            } finally{
                handleLoadingDataChange('scopes', false);
            }
        };
        if (scopesRef.current.length === 0) getScopes();
    }, []);
    return {
        scopes: scopes,
        loading: loadingData.scopes,
        error: error
    };
}



function $f61ab26e94239cef$export$2e2bcd8739ae039({ value: value, onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { scopes: scopes, loading: loading, error: error } = (0, $b3442ae70315e7e8$export$95fa510925bbc2d1)();
    const handleStateChange = (updatedState)=>{
        onUpdate('authClientScopes', updatedState);
    };
    if (!scopes || error || loading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ddeece3e20817772$export$2e2bcd8739ae039), {
        legend: t('common:organization.projects.scopes.manage'),
        options: scopes,
        activeValues: value,
        onUpdate: handleStateChange
    });
}





var $7fPBF = parcelRequire("7fPBF");

function $d5d3b4079485dd94$export$2e2bcd8739ae039({ tokenAdditionalRedirectUris: tokenAdditionalRedirectUris, tokenRedirectUrlHost: tokenRedirectUrlHost, onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    // Compute combined values directly - no state needed
    const displayValues = (0, $7fPBF.useMemo)(()=>{
        return tokenRedirectUrlHost ? [
            tokenRedirectUrlHost,
            ...tokenAdditionalRedirectUris
        ] : [
            ...tokenAdditionalRedirectUris
        ];
    }, [
        tokenRedirectUrlHost,
        tokenAdditionalRedirectUris
    ]);
    const handleChange = (updatedUris)=>{
        // Split back into host (first item) and additional (rest)
        const newHost = updatedUris.length > 0 ? updatedUris[0] : undefined;
        const newAdditional = updatedUris.slice(1);
        onUpdate('tokenAdditionalRedirectUris', newAdditional, 'tokenRedirectUrlHost', newHost);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0f47f90096855080$export$2e2bcd8739ae039), {
        initialValues: displayValues,
        legend: t('common:organization.projects.tokenRedirect.title'),
        description: t('common:organization.projects.tokenRedirect.description'),
        onChange: handleChange
    });
}


function $712a21b5a921b4f4$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId, clientId: clientId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const { currentOrg: currentOrg, canCreateAuthClients: canCreateAuthClients, isLoading: isLoading } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const { deviceTypes: deviceTypes, currentOrgClient: currentOrgClient, error: error, isLoading: isLoadingProjects } = (0, $76dd6d0d6f9746d5$export$2e2bcd8739ae039)();
    const { editClient: editClient, handleInputChange: handleInputChange, handleSaveWithAlerts: handleSave } = (0, $4b8a9e84dae5e7a0$export$8f7032ec10a68144)(currentOrgClient);
    if (!currentOrgClient || !deviceTypes || !editClient || isLoadingProjects || isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {});
    if (!organizationId || !clientId || !currentOrg || error.client || !canCreateAuthClients || organizationId !== currentOrg.id) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f8f95b189a35cb2e$export$2e2bcd8739ae039), {});
    if (!currentOrg.isDeveloperAccess || !currentOrg.canCreateAuthClients) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0ec5f0e18dd3ab72$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$54fb318478ce42e9), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:organization.projects.key.title')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b144367e0a20d9c5$export$2e2bcd8739ae039), {
                    organizationId: organizationId,
                    clientId: currentOrgClient.id
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:organization.projects.clients.settings')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98c9acefb60389ed$export$2e2bcd8739ae039), {
                        value: editClient.name,
                        onUpdate: (field, value)=>handleInputChange(field, value)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $50c02032c88163c7$export$2e2bcd8739ae039), {
                        value: editClient.originHost,
                        onUpdate: (field, value)=>handleInputChange(field, value)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d5d3b4079485dd94$export$2e2bcd8739ae039), {
                        tokenAdditionalRedirectUris: editClient.tokenAdditionalRedirectUris,
                        tokenRedirectUrlHost: editClient.tokenRedirectUrlHost,
                        onUpdate: (additionalField, additionalValue, hostField, hostValue)=>{
                            handleInputChange(additionalField, additionalValue);
                            handleInputChange(hostField, hostValue);
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $86bb7a18b305ac09$export$2e2bcd8739ae039), {
                        additionalRedirectUris: editClient.additionalRedirectUris,
                        authCodeRedirectUrlHost: editClient.authCodeRedirectUrlHost,
                        onUpdate: (additionalField, additionalValue, hostField, hostValue)=>{
                            handleInputChange(additionalField, additionalValue);
                            handleInputChange(hostField, hostValue);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:organization.projects.scopes.title')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f61ab26e94239cef$export$2e2bcd8739ae039), {
                    value: editClient.authClientScopes,
                    onUpdate: (field, value)=>handleInputChange(field, value)
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:organization.projects.deviceScopes.title')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1f273ff0abbe6580$export$2e2bcd8739ae039), {
                    value: editClient.authClientDeviceTypes,
                    deviceOptions: deviceTypes ?? [],
                    onUpdate: (field, value)=>handleInputChange(field, value)
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                onClick: handleSave,
                children: t('common:save')
            })
        ]
    });
}




function $f1f3f26007c0cbd9$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { currentOrgClient: currentOrgClient } = (0, $76dd6d0d6f9746d5$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: currentOrgClient?.name ?? t('common:organization.projects.clients.title'),
                description: t('common:organization.projects.clients.description'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $712a21b5a921b4f4$export$2e2bcd8739ae039), {})
        ]
    });
}












var $7fPBF = parcelRequire("7fPBF");

// Locale flags for display
const $454d6d8464fffdd6$var$LOCALE_FLAGS = {
    en: "\uD83C\uDDFA\uD83C\uDDF8",
    es: "\uD83C\uDDEA\uD83C\uDDF8",
    fr: "\uD83C\uDDEB\uD83C\uDDF7",
    it: "\uD83C\uDDEE\uD83C\uDDF9",
    de: "\uD83C\uDDE9\uD83C\uDDEA",
    ja: "\uD83C\uDDEF\uD83C\uDDF5"
};
// Map document type IDs to DeviceTypeClientListingModel field names
const $454d6d8464fffdd6$var$DOCUMENT_TYPE_FIELD_MAP = {
    metadata: 'markdownDescription',
    troubleshooting: 'markdownTroubleshootingInstructions',
    onboarding: 'markdownOnboardingInstructions',
    'client-listing': 'markdownDescription'
};
function $454d6d8464fffdd6$export$9ee234e2f2bcf99f(organizationId, deviceId) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { editListing: editListing, setEditListing: setEditListing, setListingHasChanges: setListingHasChanges } = (0, $c6a32ec408b1369c$export$2e2bcd8739ae039).useContainer();
    const [activeDocument, setActiveDocument] = (0, $7fPBF.useState)('metadata');
    const [activeLocale, setActiveLocale] = (0, $7fPBF.useState)('en');
    const [isSaving, setIsSaving] = (0, $7fPBF.useState)(false);
    const LOCALES = (0, $7fPBF.useMemo)(()=>(0, $3ecd3f7dea3d56de$export$df1c34db1371eeed).display.map((code)=>({
                code: code,
                label: t(`common:localization.localesShort.${code}`),
                flag: $454d6d8464fffdd6$var$LOCALE_FLAGS[code]
            })), [
        t
    ]);
    // Validation helper for URL fields
    const isValidUrl = (url, isOptional = false)=>{
        if (!url || url.trim() === '') return isOptional;
        return url.startsWith('http://') || url.startsWith('https://');
    };
    // Helper function to check if a listing is complete
    const isListingComplete = (listing)=>{
        if (!editListing) return false;
        const anyHasOnboarding = editListing.some((l)=>l.markdownOnboardingInstructions && l.markdownOnboardingInstructions.length > 1);
        const anyHasTroubleshooting = editListing.some((l)=>l.markdownTroubleshootingInstructions && l.markdownTroubleshootingInstructions.length > 1);
        const requiredFields = [
            listing.title,
            listing.shortDescription,
            isValidUrl(listing.iconUrl),
            isValidUrl(listing.darkModeIconUrl),
            listing.markdownDescription && listing.markdownDescription.length > 25 || listing.externalLink && listing.externalLink.trim() !== ''
        ];
        // Validate optional external link if provided
        if (listing.externalLink && listing.externalLink.trim() !== '') requiredFields.push(isValidUrl(listing.externalLink, true));
        if (anyHasOnboarding) requiredFields.push(listing.markdownOnboardingInstructions && listing.markdownOnboardingInstructions.length > 25);
        if (anyHasTroubleshooting) requiredFields.push(listing.markdownTroubleshootingInstructions && listing.markdownTroubleshootingInstructions.length > 25);
        return requiredFields.every(Boolean);
    };
    // Calculate completion percentage for each locale
    const getLocaleCompletion = (localeCode)=>{
        if (!editListing) return 0;
        const listing = editListing.find((l)=>l.locale === localeCode);
        if (!listing) return 0;
        const anyHasOnboarding = editListing.some((l)=>l.markdownOnboardingInstructions && l.markdownOnboardingInstructions.length > 1);
        const anyHasTroubleshooting = editListing.some((l)=>l.markdownTroubleshootingInstructions && l.markdownTroubleshootingInstructions.length > 1);
        let filled = [
            listing.title,
            listing.shortDescription,
            isValidUrl(listing.iconUrl),
            isValidUrl(listing.darkModeIconUrl),
            listing.markdownDescription && listing.markdownDescription.length > 25 || listing.externalLink && listing.externalLink.trim() !== ''
        ].filter(Boolean).length;
        let total = 5;
        if (anyHasOnboarding) {
            total += 1;
            filled += listing.markdownOnboardingInstructions && listing.markdownOnboardingInstructions.length > 25 ? 1 : 0;
        }
        if (anyHasTroubleshooting) {
            total += 1;
            filled += listing.markdownTroubleshootingInstructions && listing.markdownTroubleshootingInstructions.length > 25 ? 1 : 0;
        }
        return Math.round(filled / total * 100);
    };
    // Handle content changes for markdown fields
    const handleContentChange = (value)=>{
        if (value !== undefined && editListing) {
            const fieldName = $454d6d8464fffdd6$var$DOCUMENT_TYPE_FIELD_MAP[activeDocument];
            const updatedListing = editListing.map((listing)=>{
                if (listing.locale === activeLocale) return {
                    ...listing,
                    [fieldName]: value
                };
                return listing;
            });
            setEditListing(updatedListing);
            setListingHasChanges(true);
        }
    };
    // Handle metadata field changes
    const handleMetadataFieldChange = (fieldName, value)=>{
        if (editListing) {
            const updatedListing = editListing.map((listing)=>{
                if (listing.locale === activeLocale) return {
                    ...listing,
                    [fieldName]: value
                };
                return listing;
            });
            setEditListing(updatedListing);
            setListingHasChanges(true);
        }
    };
    // Save listings
    const saveListings = async (onSuccess, onError)=>{
        if (!organizationId || !deviceId || !editListing) {
            onError(t('common:saveError'));
            return false;
        }
        // Filter to only complete listings
        const completeListings = editListing.filter(isListingComplete);
        const incompleteListings = editListing.filter((listing)=>!isListingComplete(listing));
        if (completeListings.length === 0) {
            onError('All locales are incomplete. Please complete at least one locale to 100% before saving.');
            return false;
        }
        setIsSaving(true);
        try {
            // Create en-us as a copy of en if en exists
            let listingsToSave = [
                ...completeListings
            ];
            const enListing = completeListings.find((l)=>l.locale === 'en');
            if (enListing) {
                const hasEnUs = completeListings.some((l)=>l.locale === 'en-us');
                if (!hasEnUs) {
                    const enUsListing = {
                        ...enListing,
                        locale: 'en-us'
                    };
                    listingsToSave.push(enUsListing);
                }
            }
            const request = {
                listings: (0, $710192f33815db16$export$e0ee21b9e212f3d0)(listingsToSave)
            };
            const response = await $1a4c36336f303477$export$2fbd549f3e7afb42(organizationId, deviceId, request);
            if (response.resultType === 'Ok') {
                // Show success message with incomplete locale info
                if (incompleteListings.length > 0) {
                    const enListing = completeListings.find((l)=>l.locale === 'en');
                    const hasEnUs = completeListings.some((l)=>l.locale === 'en-us');
                    const supportedLocaleCodes = LOCALES.map((loc)=>loc.code);
                    const actuallyIncompleteListings = incompleteListings.filter((l)=>!(l.locale === 'en-us' && enListing && !hasEnUs) && supportedLocaleCodes.includes(l.locale));
                    if (actuallyIncompleteListings.length > 0) {
                        const incompleteLocales = actuallyIncompleteListings.map((l)=>{
                            const localeInfo = LOCALES.find((loc)=>loc.code === l.locale);
                            return localeInfo ? `${localeInfo.flag} ${localeInfo.label}` : l.locale;
                        }).join(', ');
                        onSuccess(`Saved ${listingsToSave.length} complete locale(s). ` + `Incomplete locales not saved: ${incompleteLocales}`);
                    } else onSuccess(`Saved ${listingsToSave.length} locale(s) successfully.`);
                } else onSuccess(t('common:saved'));
                setListingHasChanges(false);
                // Reload the listings to get updated data
                const refreshResult = await $1a4c36336f303477$export$f942174137d3f696(organizationId, deviceId);
                if (refreshResult.resultType === 'Ok' && refreshResult.data) setEditListing(refreshResult.data);
                return true;
            } else {
                const errorMessage = response.errors ? response.errors.join(', ') : '';
                onError(t('common:saveError') + (errorMessage ? ': ' + errorMessage : ''));
                return false;
            }
        } catch (error) {
            console.error('Error saving device type client listings:', error);
            onError(t('common:saveError'));
            return false;
        } finally{
            setIsSaving(false);
        }
    };
    // Get current content for the active document and locale
    const currentContent = (0, $7fPBF.useMemo)(()=>{
        if (!editListing) return '';
        const listing = editListing.find((l)=>l.locale === activeLocale);
        if (!listing) return '';
        const fieldName = $454d6d8464fffdd6$var$DOCUMENT_TYPE_FIELD_MAP[activeDocument];
        return listing[fieldName] || '';
    }, [
        editListing,
        activeLocale,
        activeDocument
    ]);
    // Get current listing for metadata fields
    const currentListing = (0, $7fPBF.useMemo)(()=>{
        if (!editListing) return null;
        return editListing.find((l)=>l.locale === activeLocale);
    }, [
        editListing,
        activeLocale
    ]);
    const isDocumentEmpty = (documentType)=>{
        if (!editListing) return true;
        const listing = editListing.find((l)=>l.locale === activeLocale);
        if (!listing) return true;
        const fieldName = $454d6d8464fffdd6$var$DOCUMENT_TYPE_FIELD_MAP[documentType];
        const content = listing[fieldName];
        return !content || content.length === 0;
    };
    // Check if a specific document is complete for the current locale
    const isDocumentComplete = (documentType)=>{
        if (!editListing || !currentListing) return false;
        // Check if any locale has onboarding or troubleshooting instructions
        const anyHasOnboarding = editListing.some((l)=>l.markdownOnboardingInstructions && l.markdownOnboardingInstructions.length > 1);
        const anyHasTroubleshooting = editListing.some((l)=>l.markdownTroubleshootingInstructions && l.markdownTroubleshootingInstructions.length > 1);
        switch(documentType){
            case 'metadata':
                return !!(currentListing.title && currentListing.shortDescription && isValidUrl(currentListing.iconUrl) && isValidUrl(currentListing.darkModeIconUrl) && (currentListing.markdownDescription && currentListing.markdownDescription.length > 25 || currentListing.externalLink && currentListing.externalLink.trim() !== ''));
            case 'troubleshooting':
                // Only required if any locale has troubleshooting
                if (!anyHasTroubleshooting) return true;
                return !!(currentListing.markdownTroubleshootingInstructions && currentListing.markdownTroubleshootingInstructions.length > 25);
            case 'onboarding':
                // Only required if any locale has onboarding
                if (!anyHasOnboarding) return true;
                return !!(currentListing.markdownOnboardingInstructions && currentListing.markdownOnboardingInstructions.length > 25);
            case 'client-listing':
                return !!(currentListing.markdownDescription && currentListing.markdownDescription.length > 25);
            default:
                return false;
        }
    };
    return {
        activeDocument: // State
        activeDocument,
        setActiveDocument: setActiveDocument,
        activeLocale: activeLocale,
        setActiveLocale: setActiveLocale,
        isSaving: isSaving,
        LOCALES: LOCALES,
        currentContent: // Computed values
        currentContent,
        currentListing: currentListing,
        isValidUrl: // Functions
        isValidUrl,
        isListingComplete: isListingComplete,
        getLocaleCompletion: getLocaleCompletion,
        handleContentChange: handleContentChange,
        handleMetadataFieldChange: handleMetadataFieldChange,
        saveListings: saveListings,
        isDocumentComplete: isDocumentComplete,
        isDocumentEmpty: isDocumentEmpty
    };
}















var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");
function $c3429429cdbbe82f$export$2e2bcd8739ae039(children) {
    return $7fPBF.Children.toArray(children).filter((child)=>/*#__PURE__*/ $7fPBF.isValidElement(child));
}









function $94403c25c532988f$export$b85c003f960b1f3a(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiButtonGroup', slot);
}
const $94403c25c532988f$var$buttonGroupClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiButtonGroup', [
    'root',
    'contained',
    'outlined',
    'text',
    'disableElevation',
    'disabled',
    'firstButton',
    'fullWidth',
    'horizontal',
    'vertical',
    'colorPrimary',
    'colorSecondary',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'groupedText',
    'groupedTextHorizontal',
    'groupedTextVertical',
    'groupedTextPrimary',
    'groupedTextSecondary',
    'groupedOutlined',
    'groupedOutlinedHorizontal',
    'groupedOutlinedVertical',
    'groupedOutlinedPrimary',
    'groupedOutlinedSecondary',
    'groupedContained',
    'groupedContainedHorizontal',
    'groupedContainedVertical',
    'groupedContainedPrimary',
    'groupedContainedSecondary',
    'lastButton',
    'middleButton'
]);
var $94403c25c532988f$export$2e2bcd8739ae039 = $94403c25c532988f$var$buttonGroupClasses;





'use client';
const $078cc07d54c9b00d$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        {
            [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).grouped}`]: styles.grouped
        },
        {
            [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.variant)}`]
        },
        {
            [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.variant)}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.variant)}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`]
        },
        {
            [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).firstButton}`]: styles.firstButton
        },
        {
            [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).lastButton}`]: styles.lastButton
        },
        {
            [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).middleButton}`]: styles.middleButton
        },
        styles.root,
        styles[ownerState.variant],
        ownerState.disableElevation === true && styles.disableElevation,
        ownerState.fullWidth && styles.fullWidth,
        ownerState.orientation === 'vertical' && styles.vertical
    ];
};
const $078cc07d54c9b00d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, disableElevation: disableElevation, fullWidth: fullWidth, orientation: orientation, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            orientation,
            fullWidth && 'fullWidth',
            disableElevation && 'disableElevation',
            `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`
        ],
        grouped: [
            'grouped',
            `grouped${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(orientation)}`,
            `grouped${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(variant)}`,
            `grouped${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(variant)}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(orientation)}`,
            `grouped${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(variant)}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $94403c25c532988f$export$b85c003f960b1f3a), classes);
};
const $078cc07d54c9b00d$var$ButtonGroupRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiButtonGroup',
    slot: 'Root',
    overridesResolver: $078cc07d54c9b00d$var$overridesResolver
})((0, $574bade4fe8533ba$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    boxShadow: (theme.vars || theme).shadows[2]
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none'
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    flexDirection: 'column',
                    [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).lastButton},& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderTopLeftRadius: 0
                    },
                    [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).firstButton},& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottomRightRadius: 0,
                        borderBottomLeftRadius: 0
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).firstButton},& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).lastButton},& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).middleButton}`]: {
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0
                    }
                }
            },
            {
                props: {
                    variant: 'text',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).firstButton},& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).middleButton}`]: {
                        borderRight: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                        [`&.${(0, $94403c25c532988f$export$2e2bcd8739ae039).disabled}`]: {
                            borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'text',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).firstButton},& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottom: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                        [`&.${(0, $94403c25c532988f$export$2e2bcd8739ae039).disabled}`]: {
                            borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $061b5988a3817e26$export$2e2bcd8739ae039)()).flatMap(([color])=>[
                    {
                        props: {
                            variant: 'text',
                            color: color
                        },
                        style: {
                            [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).firstButton},& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).middleButton}`]: {
                                borderColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.5)` : (0, $4afad3ab73a4d920$export$58f0f39f63f3cf42)(theme.palette[color].main, 0.5)
                            }
                        }
                    }
                ]),
            {
                props: {
                    variant: 'outlined',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).firstButton},& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).middleButton}`]: {
                        borderRightColor: 'transparent',
                        '&:hover': {
                            borderRightColor: 'currentColor'
                        }
                    },
                    [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).lastButton},& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).middleButton}`]: {
                        marginLeft: -1
                    }
                }
            },
            {
                props: {
                    variant: 'outlined',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).firstButton},& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottomColor: 'transparent',
                        '&:hover': {
                            borderBottomColor: 'currentColor'
                        }
                    },
                    [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).lastButton},& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).middleButton}`]: {
                        marginTop: -1
                    }
                }
            },
            {
                props: {
                    variant: 'contained',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).firstButton},& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).middleButton}`]: {
                        borderRight: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
                        [`&.${(0, $94403c25c532988f$export$2e2bcd8739ae039).disabled}`]: {
                            borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'contained',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).firstButton},& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
                        [`&.${(0, $94403c25c532988f$export$2e2bcd8739ae039).disabled}`]: {
                            borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $061b5988a3817e26$export$2e2bcd8739ae039)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        variant: 'contained',
                        color: color
                    },
                    style: {
                        [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).firstButton},& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).middleButton}`]: {
                            borderColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                }))
        ],
        [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).grouped}`]: {
            minWidth: 40,
            boxShadow: 'none',
            props: {
                variant: 'contained'
            },
            style: {
                '&:hover': {
                    boxShadow: 'none'
                }
            }
        }
    })));
const $078cc07d54c9b00d$var$ButtonGroup = /*#__PURE__*/ $7fPBF.forwardRef(function ButtonGroup(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiButtonGroup'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, disableRipple: disableRipple = false, fullWidth: fullWidth = false, orientation: orientation = 'horizontal', size: size = 'medium', variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        disableRipple: disableRipple,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size,
        variant: variant
    };
    const classes = $078cc07d54c9b00d$var$useUtilityClasses(ownerState);
    const context = $7fPBF.useMemo(()=>({
            className: classes.grouped,
            color: color,
            disabled: disabled,
            disableElevation: disableElevation,
            disableFocusRipple: disableFocusRipple,
            disableRipple: disableRipple,
            fullWidth: fullWidth,
            size: size,
            variant: variant
        }), [
        color,
        disabled,
        disableElevation,
        disableFocusRipple,
        disableRipple,
        fullWidth,
        size,
        variant,
        classes.grouped
    ]);
    const validChildren = (0, $c3429429cdbbe82f$export$2e2bcd8739ae039)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($078cc07d54c9b00d$var$ButtonGroupRoot, {
        as: component,
        role: "group",
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40ed7573a59c2be9$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e319f5c3a4402058$export$2e2bcd8739ae039).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    });
});
var $078cc07d54c9b00d$export$2e2bcd8739ae039 = $078cc07d54c9b00d$var$ButtonGroup;



const $39fdc36270d4c003$export$2e54018d3f9b15e2 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $078cc07d54c9b00d$export$2e2bcd8739ae039))`
    margin: 0.5rem 0 0 0;
    background-color: ${(props)=>props.theme.button.secondary.background};
    color: ${(props)=>props.theme.button.secondary.text};
`;
const $39fdc36270d4c003$export$2cf8749a323c7474 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $45be1777d6a28263$export$2e2bcd8739ae039))`
    font-size: 0.85rem;
    text-transform: none;
    background-color: ${(props)=>props.theme.button.secondary.background};
    color: ${(props)=>props.theme.button.secondary.text};
    &:hover {
        background-color: ${(props)=>props.theme.button.accent.hoverBackground};
        color: ${(props)=>props.theme.button.accent.hoverText};
    }
`;
const $39fdc36270d4c003$export$e018019c2d136eee = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $45be1777d6a28263$export$2e2bcd8739ae039))`
    max-width: fit-content;
    background-color: ${(props)=>props.theme.button.secondary.background};
    color: ${(props)=>props.theme.button.secondary.text};
    &:hover {
        background-color: ${(props)=>props.theme.button.accent.hoverBackground};
        color: ${(props)=>props.theme.button.accent.hoverText};
    }
`;
const $39fdc36270d4c003$export$f4f1ce1dc21e0917 = (0, $8de346382d86c747$export$2e2bcd8739ae039).span`
    ${(0, $b091aef3a32d2bd8$export$90f89b8a63d85ede)}
`;


function $94228c19da943b16$export$2e2bcd8739ae039({ options: options, renderOptionLabel: renderOptionLabel = (option)=>option, onSelect: onSelect, selectedIndex: selectedIndexProp, initialSelectedIndex: initialSelectedIndex = 0, buttonLabel: buttonLabel, groupLabel: groupLabel, onOpen: onOpen }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    const isControlled = selectedIndexProp !== undefined;
    const [uncontrolledIndex, setUncontrolledIndex] = (0, $7fPBF.useState)(initialSelectedIndex);
    const selectedIndex = isControlled ? selectedIndexProp : uncontrolledIndex;
    const anchorRef = (0, $7fPBF.useRef)(null);
    const uuid = (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)();
    const isSingleOption = options.length <= 1;
    const handleMenuItemClick = (_event, index)=>{
        if (!isControlled) setUncontrolledIndex(index);
        setOpen(false);
        onSelect(options[index], index);
    };
    const handleToggle = ()=>{
        setOpen((prev)=>{
            const next = !prev;
            if (!prev && onOpen) onOpen();
            return next;
        });
    };
    const handleClose = (event)=>{
        if (anchorRef.current?.contains(event.target)) return;
        setOpen(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $39fdc36270d4c003$export$2e54018d3f9b15e2), {
                fullWidth: true,
                variant: "contained",
                ref: anchorRef,
                "aria-label": groupLabel,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $39fdc36270d4c003$export$2cf8749a323c7474), {
                        fullWidth: true,
                        onClick: handleToggle,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $39fdc36270d4c003$export$f4f1ce1dc21e0917), {
                            children: buttonLabel ?? renderOptionLabel(options[selectedIndex])
                        })
                    }),
                    !isSingleOption && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $39fdc36270d4c003$export$e018019c2d136eee), {
                        size: "small",
                        "aria-controls": open ? uuid + 'split-button-menu' : undefined,
                        "aria-expanded": open ? 'true' : undefined,
                        "aria-haspopup": "menu",
                        "aria-label": t('common:expandMenu'),
                        onClick: handleToggle,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                            name: "expandArrow",
                            size: 16
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2ecffc9bd505b8cc$export$2e2bcd8739ae039), {
                sx: {
                    zIndex: 1
                },
                open: open,
                anchorEl: anchorRef.current,
                transition: true,
                disablePortal: true,
                children: ({ TransitionProps: TransitionProps, placement: placement })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7ec2c0aa92d4d29c$export$2e2bcd8739ae039), {
                        ...TransitionProps,
                        style: {
                            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $feb114cb8fcb331a$export$58385c17fee43f89), {
                                onClickAway: handleClose,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9cb95136bc90d127$export$2e2bcd8739ae039), {
                                    id: uuid + 'split-button-menu',
                                    autoFocusItem: true,
                                    children: options && options.map((option, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                            selected: index === selectedIndex,
                                            onClick: (event)=>handleMenuItemClick(event, index),
                                            children: renderOptionLabel(option)
                                        }, index))
                                })
                            })
                        })
                    })
            })
        ]
    });
}






var $7fPBF = parcelRequire("7fPBF");


const $9d497189a1b403bd$var$TabButton = /*#__PURE__*/ (0, $7fPBF.forwardRef)(({ isActive: isActive, statusAlert: statusAlert, children: children, iconName: iconName = 'check', iconColor: iconColor, ...restProps }, ref)=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($9d497189a1b403bd$var$TabButtonStyle, {
        statusAlert: statusAlert,
        isActive: isActive,
        ...restProps,
        ref: ref,
        children: [
            (isActive || iconName) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                name: iconName,
                size: 16,
                color: iconColor
            }),
            children
        ]
    });
});
$9d497189a1b403bd$var$TabButton.displayName = 'TabButton';
var $9d497189a1b403bd$export$2e2bcd8739ae039 = $9d497189a1b403bd$var$TabButton;
const $9d497189a1b403bd$var$TabButtonStyle = (0, $8de346382d86c747$export$2e2bcd8739ae039).button`
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 8px 16px;
    border: ${(props)=>props.isActive ? `1px solid ${props.theme.color.text}` : '1px solid transparent'};
    background: ${(props)=>props.isActive ? props.theme.color.accent : props.theme.color.cardHover};
    color: ${(props)=>props.isActive ? props.theme.color.background : props.theme.button.secondary.text};
    ${(props)=>props.isActive && `text-decoration: underline;`};
    cursor: pointer;
    border-radius: 50px;
    transition: all 0.2s ease;
    ${(props)=>props.statusAlert === 'warning' && ` background: ${(0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2_light}; color: ${(0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark};`}
    ${(props)=>props.statusAlert === 'error' && ` color: ${(0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light}; background: ${(0, $8951886a6b49e92a$export$35e9368ef982300f).error};`}
    ${(props)=>props.statusAlert === 'success' && ` background: ${(0, $8951886a6b49e92a$export$35e9368ef982300f).success_serious}; color: ${(0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light};`}

    &:hover {
        background: ${(props)=>props.theme.button.secondary.text};
        color: ${(props)=>props.theme.color.background};
    }
    &:focus {
        outline: none !important;
        box-shadow: none !important;
    }
    ${(0, $19e0bc52fddd02b4$export$87f1b08a59e6d1dd)}
`;












const $a326367fe13d13bb$var$ContentWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex: 1;
    gap: 0.5rem;
`;
const $a326367fe13d13bb$var$Sidebar = (0, $8de346382d86c747$export$2e2bcd8739ae039).aside`
    display: flex;
    width: fit-content;
    flex-shrink: 0;
    flex-direction: column;
    padding-right: 0.5rem;
    border-right: 1px solid ${(props)=>props.theme.color.border};
    background-color: var(--sidebar);
    gap: 1rem;
`;
const $a326367fe13d13bb$var$SectionLabel = (0, $8de346382d86c747$export$2e2bcd8739ae039).label`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.75rem;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    padding-top: 1rem;
    color: var(--muted-foreground);
`;
const $a326367fe13d13bb$var$NavList = (0, $8de346382d86c747$export$2e2bcd8739ae039).ul`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;
const $a326367fe13d13bb$var$CompletionButton = (0, $8de346382d86c747$export$2e2bcd8739ae039).button`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
    padding: 0.375rem 0.5rem;
    font-size: 0.75rem;
    border-radius: 0.375rem;
    background-color: ${({ $isActive: $isActive, theme: theme })=>$isActive ? theme.color.accent + '30' : 'transparent'};
    color: ${(props)=>props.theme.color.text};
    transition: background-color 0.2s;
    cursor: pointer;
    border: none;
    text-align: left;

    &:hover {
        background-color: ${({ $isActive: $isActive, theme: theme })=>$isActive ? theme.color.accent + '30' : theme.color.accent + '15'};
    }
`;
const $a326367fe13d13bb$var$CompletionLabel = (0, $8de346382d86c747$export$2e2bcd8739ae039).span`
    flex: 1;
    color: ${(props)=>props.theme.color.text};
`;
const $a326367fe13d13bb$var$CompletionPercentage = (0, $8de346382d86c747$export$2e2bcd8739ae039).span`
    font-weight: 500;
    color: ${({ $isComplete: $isComplete, theme: theme })=>$isComplete ? theme.color.success : theme.color.textBody};
`;
const $a326367fe13d13bb$var$MainContent = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 1rem 0;
`;
const $a326367fe13d13bb$var$EditorSection = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    flex: 1;
    overflow: hidden;
`;
const $a326367fe13d13bb$var$EditorContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    height: 100%;
    border-radius: 0.5rem;
    border: 1px solid var(--border);
    background-color: var(--card);
    overflow: hidden;
`;
const $a326367fe13d13bb$var$MetadataForm = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding: 1.5rem;
    overflow-y: auto;
    height: 100%;
`;
const $a326367fe13d13bb$var$StyledTextField = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039))`
    & .MuiOutlinedInput-root {
        &.Mui-error .MuiOutlinedInput-notchedOutline {
            border-color: ${(props)=>props.theme.color.danger};
        }
        &.Mui-error:hover .MuiOutlinedInput-notchedOutline {
            border-color: ${(props)=>props.theme.color.danger};
        }
        &.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline {
            border-color: ${(props)=>props.theme.color.danger};
        }
    }
    & .MuiFormHelperText-root.Mui-error {
        color: ${(props)=>props.theme.color.danger};
    }
`;
const $a326367fe13d13bb$var$DocumentDescription = (0, $8de346382d86c747$export$2e2bcd8739ae039).div`
    color: ${(props)=>props.theme.color.textBody};
    margin-bottom: 1rem;
    padding: 1rem;
    background-color: ${(props)=>props.theme.color.cardHover};
    border-radius: 0.375rem;
    border: 1px solid ${(props)=>props.theme.color.border};
`;
const $a326367fe13d13bb$var$DOCUMENT_TYPES = [
    {
        id: 'metadata',
        icon: 'fileMd'
    },
    {
        id: 'client-listing',
        icon: 'fileMd'
    },
    {
        id: 'troubleshooting',
        icon: 'fileMd'
    },
    {
        id: 'onboarding',
        icon: 'fileMd'
    }
];
function $a326367fe13d13bb$export$2e2bcd8739ae039({ hideSaveButton: hideSaveButton = false }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId } = (0, $748d28edcc8cedba$export$2e2bcd8739ae039)();
    const { deviceId: deviceId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const { showSuccess: showSuccess, showError: showError } = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const { loadingListing: loadingListing, listingHasChanges: listingHasChanges } = (0, $c6a32ec408b1369c$export$2e2bcd8739ae039).useContainer();
    const { activeDocument: activeDocument, setActiveDocument: setActiveDocument, activeLocale: activeLocale, setActiveLocale: setActiveLocale, isSaving: isSaving, LOCALES: LOCALES, currentContent: currentContent, currentListing: currentListing, isValidUrl: isValidUrl, getLocaleCompletion: getLocaleCompletion, handleContentChange: handleContentChange, handleMetadataFieldChange: handleMetadataFieldChange, saveListings: saveListings, isDocumentComplete: isDocumentComplete, isDocumentEmpty: isDocumentEmpty } = (0, $454d6d8464fffdd6$export$9ee234e2f2bcf99f)(organizationId, deviceId);
    const handleSave = async ()=>{
        await saveListings(showSuccess, showError);
    };
    if (loadingListing) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$b1ae020268e0b4d5), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: 'Cephable In-App Documentation Editor',
                $sticky: true,
                children: !hideSaveButton && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    onClick: handleSave,
                    disabled: !listingHasChanges || isSaving,
                    children: isSaving ? t('common:saving') : t('common:save')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($a326367fe13d13bb$var$ContentWrapper, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($a326367fe13d13bb$var$Sidebar, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($a326367fe13d13bb$var$SectionLabel, {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                name: "globe",
                                                ariaLabel: t('common:localization.titleShort')
                                            }),
                                            t('common:localization.titleShort')
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $94228c19da943b16$export$2e2bcd8739ae039), {
                                        options: LOCALES.map((locale)=>locale.code),
                                        selectedIndex: LOCALES.findIndex((l)=>l.code === activeLocale),
                                        renderOptionLabel: (option)=>{
                                            const locale = LOCALES.find((l)=>l.code === option);
                                            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                                                className: "flex items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                        children: locale?.flag
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                        children: locale?.label
                                                    })
                                                ]
                                            });
                                        },
                                        groupLabel: t('common:localization.select'),
                                        onSelect: (option)=>setActiveLocale(option)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a326367fe13d13bb$var$SectionLabel, {
                                id: "documents-label",
                                children: t('common:organization.documents')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a326367fe13d13bb$var$NavList, {
                                "aria-labelledby": "documents-label",
                                children: $a326367fe13d13bb$var$DOCUMENT_TYPES.map((doc)=>{
                                    const isComplete = isDocumentComplete(doc.id);
                                    const isEmpty = isDocumentEmpty(doc.id);
                                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9d497189a1b403bd$export$2e2bcd8739ae039), {
                                        isActive: activeDocument === doc.id,
                                        iconName: isComplete ? 'check' : 'warningTriangle',
                                        statusAlert: isComplete ? 'success' : 'warning',
                                        onClick: ()=>setActiveDocument(doc.id),
                                        children: t(`common:organization.${doc.id}.title`)
                                    }, doc.id);
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a326367fe13d13bb$var$SectionLabel, {
                                id: "completion-status-label",
                                children: t('common:organization.completionStatus.title')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a326367fe13d13bb$var$NavList, {
                                "aria-labelledby": "completion-status-label",
                                children: LOCALES.map((locale)=>{
                                    const percentage = getLocaleCompletion(locale.code);
                                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($a326367fe13d13bb$var$CompletionButton, {
                                        $isActive: activeLocale === locale.code,
                                        onClick: ()=>setActiveLocale(locale.code),
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                children: percentage == 100 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                    name: "check",
                                                    size: 15,
                                                    ariaLabel: t('common:organization.completionStatus.complete')
                                                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                    name: "warningTriangle",
                                                    size: 15,
                                                    ariaLabel: t('common:organization.completionStatus.incomplete')
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a326367fe13d13bb$var$CompletionLabel, {
                                                children: locale.label
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($a326367fe13d13bb$var$CompletionPercentage, {
                                                $isComplete: percentage === 100,
                                                children: [
                                                    percentage,
                                                    "%"
                                                ]
                                            })
                                        ]
                                    }, locale.code);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($a326367fe13d13bb$var$MainContent, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a326367fe13d13bb$var$DocumentDescription, {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                    children: t(`common:organization.${activeDocument}.editorDescription`)
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a326367fe13d13bb$var$EditorSection, {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a326367fe13d13bb$var$EditorContainer, {
                                    children: activeDocument === 'metadata' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($a326367fe13d13bb$var$MetadataForm, {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a326367fe13d13bb$var$StyledTextField, {
                                                id: "title",
                                                label: t('common:organization.metadata.metatitle.label'),
                                                value: currentListing?.title || '',
                                                onChange: (e)=>handleMetadataFieldChange('title', e.target.value),
                                                placeholder: t('common:organization.metadata.metatitle.placeholder')
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a326367fe13d13bb$var$StyledTextField, {
                                                id: "shortDescription",
                                                label: t('common:organization.metadata.shortDescription.label'),
                                                value: currentListing?.shortDescription || '',
                                                onChange: (e)=>handleMetadataFieldChange('shortDescription', e.target.value),
                                                placeholder: t('common:organization.metadata.shortDescription.placeholder'),
                                                multiline: true,
                                                rows: 3
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$f51cc64edb23e9d6), {
                                                children: t('common:organization.metadata.iconUrl.description')
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a326367fe13d13bb$var$StyledTextField, {
                                                id: "iconUrl",
                                                label: t('common:organization.metadata.iconUrl.label'),
                                                value: currentListing?.iconUrl || '',
                                                onChange: (e)=>handleMetadataFieldChange('iconUrl', e.target.value),
                                                placeholder: "Enter icon URL (must start with http:// or https://)",
                                                error: !isValidUrl(currentListing?.iconUrl),
                                                helperText: !isValidUrl(currentListing?.iconUrl) ? t('common:organization.metadata.urlError') : ''
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a326367fe13d13bb$var$StyledTextField, {
                                                id: "darkModeIconUrl",
                                                label: t('common:organization.metadata.darkModeIconUrl.label'),
                                                value: currentListing?.darkModeIconUrl || '',
                                                onChange: (e)=>handleMetadataFieldChange('darkModeIconUrl', e.target.value),
                                                placeholder: t('common:organization.metadata.darkModeIconUrl.placeholder'),
                                                error: !isValidUrl(currentListing?.darkModeIconUrl),
                                                helperText: !isValidUrl(currentListing?.darkModeIconUrl) ? t('common:organization.metadata.urlError') : ''
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$f51cc64edb23e9d6), {
                                                children: t('common:organization.metadata.externalLink.description')
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a326367fe13d13bb$var$StyledTextField, {
                                                id: "externalLink",
                                                label: t('common:organization.metadata.externalLink.label'),
                                                value: currentListing?.externalLink || '',
                                                onChange: (e)=>handleMetadataFieldChange('externalLink', e.target.value),
                                                placeholder: t('common:organization.metadata.externalLink.placeholder'),
                                                error: !!(currentListing?.externalLink && currentListing.externalLink.trim() !== '' && !isValidUrl(currentListing?.externalLink, true)),
                                                helperText: currentListing?.externalLink && currentListing.externalLink.trim() !== '' && !isValidUrl(currentListing?.externalLink, true) ? t('common:organization.metadata.urlError') : ''
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f5d4d30d0c746c1c$export$2e2bcd8739ae039), {
                                        value: currentContent,
                                        onUpdate: handleContentChange
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}














const $d17cda234e660d8e$export$6102c700e909f46e = ()=>({
        disableVoiceInput: false,
        disableHotkeyInput: false,
        disableCameraInput: false,
        disableMultiInputs: false,
        maximumCommandsPerSecond: undefined,
        maximumCommandsPerMinute: undefined,
        maximumMacroLength: undefined,
        macroStepRules: undefined
    });



var $7fPBF = parcelRequire("7fPBF");











function $12686fdc2c572a78$export$2e2bcd8739ae039({ throttleRules: throttleRules, onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    // Initialize with default values if throttleRules is undefined
    const currentRules = throttleRules ?? (0, $d17cda234e660d8e$export$6102c700e909f46e)();
    const handleBooleanChange = (field, value)=>{
        onUpdate({
            ...currentRules,
            [field]: value
        });
    };
    const handleNumberChange = (field, value)=>{
        if (value === '') {
            onUpdate({
                ...currentRules,
                [field]: undefined
            });
            return;
        }
        const numValue = parseInt(value, 10);
        if (!isNaN(numValue) && numValue >= 0) onUpdate({
            ...currentRules,
            [field]: numValue
        });
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3faa7d453f5d11ef$export$22fa1e7523221c6e), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3faa7d453f5d11ef$export$e37cfa0e4472699e), {
                as: "legend",
                children: t('common:organization.projects.deviceType.throttleRules.title')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3faa7d453f5d11ef$export$a82c6f1cc70eb063), {
                children: t('common:organization.projects.deviceType.throttleRules.description')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($12686fdc2c572a78$var$StyledFormGroup, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d99e6d55ec7d57a$export$2e2bcd8739ae039), {
                            checked: currentRules.disableVoiceInput,
                            onChange: (e)=>handleBooleanChange('disableVoiceInput', e.target.checked)
                        }),
                        label: t('common:organization.projects.deviceType.throttleRules.disableVoiceInput')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d99e6d55ec7d57a$export$2e2bcd8739ae039), {
                            checked: currentRules.disableHotkeyInput,
                            onChange: (e)=>handleBooleanChange('disableHotkeyInput', e.target.checked)
                        }),
                        label: t('common:organization.projects.deviceType.throttleRules.disableHotkeyInput')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d99e6d55ec7d57a$export$2e2bcd8739ae039), {
                            checked: currentRules.disableCameraInput,
                            onChange: (e)=>handleBooleanChange('disableCameraInput', e.target.checked)
                        }),
                        label: t('common:organization.projects.deviceType.throttleRules.disableCameraInput')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($12686fdc2c572a78$var$NumberInputsContainer, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039), {
                        type: "number",
                        label: t('common:organization.projects.deviceType.throttleRules.maximumCommandsPerSecond'),
                        value: currentRules.maximumCommandsPerSecond ?? '',
                        onChange: (e)=>handleNumberChange('maximumCommandsPerSecond', e.target.value),
                        inputProps: {
                            min: 0
                        },
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039), {
                        type: "number",
                        label: t('common:organization.projects.deviceType.throttleRules.maximumCommandsPerMinute'),
                        value: currentRules.maximumCommandsPerMinute ?? '',
                        onChange: (e)=>handleNumberChange('maximumCommandsPerMinute', e.target.value),
                        inputProps: {
                            min: 0
                        },
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039), {
                        type: "number",
                        label: t('common:organization.projects.deviceType.throttleRules.maximumMacroLength'),
                        value: currentRules.maximumMacroLength ?? '',
                        onChange: (e)=>handleNumberChange('maximumMacroLength', e.target.value),
                        inputProps: {
                            min: 0
                        },
                        fullWidth: true
                    })
                ]
            })
        ]
    });
}
const $12686fdc2c572a78$var$StyledFormGroup = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $cd2b84e36aef1fba$export$2e2bcd8739ae039))`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    width: 100%;
    margin-bottom: 16px;
`;
const $12686fdc2c572a78$var$NumberInputsContainer = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div')`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 16px;
    width: 100%;
`;



function $ed3a310fcee8addc$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId, deviceId: deviceId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const { showSuccess: showSuccess, showError: showError } = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const { currentOrg: currentOrg, canCreateAuthClients: canCreateAuthClients, isLoading: isLoading } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const { currentOrgDeviceType: currentOrgDeviceType, error: error, isLoading: isLoadingProject } = (0, $76dd6d0d6f9746d5$export$2e2bcd8739ae039)();
    const { handleSave: handleSaveDeviceType } = (0, $bc567063fd13cd58$export$d5236bf86334668)(currentOrgDeviceType);
    const { editDeviceType: editDeviceType, handleInputChange: handleInputChange, hasChanges: hasChanges, listingHasChanges: listingHasChanges, editListing: editListing, setListingHasChanges: setListingHasChanges } = (0, $c6a32ec408b1369c$export$2e2bcd8739ae039).useContainer();
    const [isSaving, setIsSaving] = (0, $7fPBF.useState)(false);
    const [throttleRules, setThrottleRules] = (0, $7fPBF.useState)(currentOrgDeviceType?.commandThrottleRules);
    const [throttleRulesChanged, setThrottleRulesChanged] = (0, $7fPBF.useState)(false);
    // Sync throttle rules when currentOrgDeviceType changes
    (0, $7fPBF.useEffect)(()=>{
        setThrottleRules(currentOrgDeviceType?.commandThrottleRules);
        setThrottleRulesChanged(false);
    }, [
        currentOrgDeviceType
    ]);
    const handleThrottleRulesUpdate = (rules)=>{
        setThrottleRules(rules);
        setThrottleRulesChanged(true);
    };
    const handleUnifiedSave = async ()=>{
        if (!organizationId || !deviceId) return;
        setIsSaving(true);
        let deviceTypeSaveSuccess = true;
        let listingSaveSuccess = true;
        let throttleRulesSaveSuccess = true;
        try {
            // Save device type if it has changes
            if (hasChanges) {
                const deviceTypeResult = await handleSaveDeviceType();
                deviceTypeSaveSuccess = deviceTypeResult.resultType === 'Ok';
            }
            // Save throttle rules if they have changes
            if (throttleRulesChanged) {
                const rulesPayload = throttleRules ?? (0, $d17cda234e660d8e$export$6102c700e909f46e)();
                const throttleRulesResult = await $1a4c36336f303477$export$b7d20456d96f632(organizationId, deviceId, rulesPayload);
                throttleRulesSaveSuccess = throttleRulesResult.resultType === 'Ok';
                if (throttleRulesSaveSuccess) setThrottleRulesChanged(false);
            }
            // Save client listings if they have changes
            if (listingHasChanges && editListing) {
                // Helper to validate URL format
                const isValidUrl = (url, isOptional = false)=>{
                    if (!url || url.trim() === '') return isOptional;
                    return url.startsWith('http://') || url.startsWith('https://');
                };
                // Helper to check if a listing is complete
                const isListingComplete = (listing)=>{
                    const anyHasOnboarding = editListing.some((l)=>l.markdownOnboardingInstructions && l.markdownOnboardingInstructions.length > 1);
                    const anyHasTroubleshooting = editListing.some((l)=>l.markdownTroubleshootingInstructions && l.markdownTroubleshootingInstructions.length > 1);
                    const requiredFields = [
                        listing.title,
                        listing.shortDescription,
                        isValidUrl(listing.iconUrl),
                        isValidUrl(listing.darkModeIconUrl),
                        listing.markdownDescription && listing.markdownDescription.length > 25 || listing.externalLink && listing.externalLink.trim() !== ''
                    ];
                    // Validate optional external link if provided
                    if (listing.externalLink && listing.externalLink.trim() !== '') requiredFields.push(isValidUrl(listing.externalLink, true));
                    if (anyHasOnboarding) requiredFields.push(listing.markdownOnboardingInstructions && listing.markdownOnboardingInstructions.length > 25);
                    if (anyHasTroubleshooting) requiredFields.push(listing.markdownTroubleshootingInstructions && listing.markdownTroubleshootingInstructions.length > 25);
                    return requiredFields.every(Boolean);
                };
                // Filter to only complete listings
                const completeListings = editListing.filter(isListingComplete);
                const incompleteListings = editListing.filter((listing)=>!isListingComplete(listing));
                if (completeListings.length === 0) {
                    showError('All locales are incomplete. Please complete at least one locale to 100% before saving.');
                    listingSaveSuccess = false;
                } else {
                    // Create en-us as a copy of en if en exists
                    let listingsToSave = [
                        ...completeListings
                    ];
                    const enListing = completeListings.find((l)=>l.locale === 'en');
                    if (enListing) {
                        // Check if en-us already exists in complete listings
                        const hasEnUs = completeListings.some((l)=>l.locale === 'en-us');
                        if (!hasEnUs) {
                            // Create en-us as a copy of en
                            const enUsListing = {
                                ...enListing,
                                locale: 'en-us'
                            };
                            listingsToSave.push(enUsListing);
                        }
                    }
                    const request = {
                        listings: (0, $710192f33815db16$export$e0ee21b9e212f3d0)(listingsToSave)
                    };
                    // Use PUT for both create and update (upsert)
                    const response = await $1a4c36336f303477$export$2fbd549f3e7afb42(organizationId, deviceId, request);
                    listingSaveSuccess = response.resultType === 'Ok';
                    if (listingSaveSuccess) {
                        setListingHasChanges(false);
                        // Reload the listings
                        const refreshResult = await $1a4c36336f303477$export$f942174137d3f696(organizationId, deviceId);
                        refreshResult.resultType === 'Ok' && refreshResult.data;
                        // Show info about incomplete locales
                        if (incompleteListings.length > 0) {
                            // Filter out en-us from incomplete list if it was auto-generated
                            const enListing = completeListings.find((l)=>l.locale === 'en');
                            const hasEnUs = completeListings.some((l)=>l.locale === 'en-us');
                            const supportedLocaleCodes = [
                                'en',
                                'es',
                                'fr',
                                'it',
                                'de',
                                'ja'
                            ];
                            const actuallyIncompleteListings = incompleteListings.filter((l)=>!(l.locale === 'en-us' && enListing && !hasEnUs) && supportedLocaleCodes.includes(l.locale));
                            if (actuallyIncompleteListings.length > 0) {
                                const incompleteLocales = actuallyIncompleteListings.map((l)=>l.locale).join(', ');
                                showSuccess(`Saved successfully. Incomplete locales not saved: ${incompleteLocales.toUpperCase()}`);
                                return; // Early return to avoid the generic success message
                            }
                        }
                    }
                }
            }
            // Show appropriate success/error message
            if (deviceTypeSaveSuccess && listingSaveSuccess && throttleRulesSaveSuccess) showSuccess(t('common:saved'));
            else showError(t('common:saveError'));
        } catch (error) {
            console.error('Error saving:', error);
            showError(t('common:saveError'));
        } finally{
            setIsSaving(false);
        }
    };
    const hasAnyChanges = hasChanges || listingHasChanges || throttleRulesChanged;
    if (!organizationId || !deviceId) return null;
    if (!currentOrgDeviceType || !editDeviceType || isLoading || isLoadingProject) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {});
    if (!currentOrg || !canCreateAuthClients || error.device) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f8f95b189a35cb2e$export$2e2bcd8739ae039), {});
    if (!currentOrg.isDeveloperAccess || !currentOrg.canCreateAuthClients) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0ec5f0e18dd3ab72$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$54fb318478ce42e9), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:settings.title')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e01b516a47e1de8f$export$2e2bcd8739ae039), {
                        value: editDeviceType.name,
                        onUpdate: (field, value)=>handleInputChange(field, value)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e7f3fc00fe5d6c8d$export$2e2bcd8739ae039), {
                        value: editDeviceType.description,
                        onUpdate: (field, value)=>handleInputChange(field, value)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ad34c58e371e6c3$export$2e2bcd8739ae039), {
                        editDeviceType: editDeviceType,
                        onUpdate: handleInputChange
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f5f187ec04d6f075$export$2e2bcd8739ae039), {
                        editDeviceType: editDeviceType,
                        onUpdate: handleInputChange
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $12686fdc2c572a78$export$2e2bcd8739ae039), {
                        throttleRules: throttleRules,
                        onUpdate: handleThrottleRulesUpdate
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a326367fe13d13bb$export$2e2bcd8739ae039), {
                hideSaveButton: true
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                onClick: handleUnifiedSave,
                disabled: !hasAnyChanges || isSaving,
                children: isSaving ? t('common:saving') : t('common:save')
            })
        ]
    });
}




function $2be582792e299f82$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { currentOrgDeviceType: currentOrgDeviceType } = (0, $76dd6d0d6f9746d5$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: currentOrgDeviceType?.name ?? t('common:organization.projects.deviceType.title'),
                description: currentOrgDeviceType?.id ? `${t('common:organization.projects.deviceType.id')}:  ${currentOrgDeviceType.id}` : t('common:organization.projects.deviceType.description'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ed3a310fcee8addc$export$2e2bcd8739ae039), {})
        ]
    });
}






















function $78d4a77ac2e2ef58$export$2e2bcd8739ae039({ clientId: clientId, title: title, createdDate: createdDate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const getRelativeTime = (0, $1e6a0781013949e7$export$2e2bcd8739ae039)();
    createdDate = createdDate || new Date().toISOString();
    const handleNavigate = ()=>{
        navigate(`client/${clientId}`);
    };
    if (!clientId || !title || !createdDate) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f034ea975db3d0b$export$2e2bcd8739ae039), {
        iconSize: 24,
        title: title,
        description: t('common:profile.share.created', 'Created: ', {
            value: getRelativeTime(new Date(createdDate))
        }),
        onClick: handleNavigate,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$1ef657600983666a), {
            as: "span",
            children: t('common:organization.projects.key.title') + ': ' + (0, $9bc694be59ba7dc7$export$94edfa5bee6a54b8)(clientId)
        })
    });
}





var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");






function $5201702d84bc65d1$export$2e2bcd8739ae039({ open: open, onClose: onClose }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { editClient: editClient, handleSave: handleSave, handleInputChange: handleInputChange } = (0, $4b8a9e84dae5e7a0$export$8f7032ec10a68144)(null);
    const [showSecret, setShowSecret] = (0, $7fPBF.useState)(false);
    const handleSaveAndClose = async ()=>{
        const response = await handleSave();
        if (response.resultType == 'Ok') {
            onClose();
            setShowSecret(true);
        }
    };
    if (!editClient) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
                fullWidth: true,
                open: open,
                onClose: onClose,
                onCancel: onClose,
                title: t('common:organization.projects.clients.create'),
                description: t('common:organization.projects.clients.description'),
                onConfirm: handleSaveAndClose,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$174d4944f63edcc7), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98c9acefb60389ed$export$2e2bcd8739ae039), {
                            value: editClient.name ?? '',
                            onUpdate: (field, value)=>handleInputChange(field, value)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $50c02032c88163c7$export$2e2bcd8739ae039), {
                            value: editClient.originHost,
                            onUpdate: (field, value)=>handleInputChange(field, value)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d5d3b4079485dd94$export$2e2bcd8739ae039), {
                            tokenAdditionalRedirectUris: editClient.tokenAdditionalRedirectUris,
                            tokenRedirectUrlHost: editClient.tokenRedirectUrlHost,
                            onUpdate: (additionalField, additionalValue, hostField, hostValue)=>{
                                handleInputChange(additionalField, additionalValue);
                                handleInputChange(hostField, hostValue);
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $86bb7a18b305ac09$export$2e2bcd8739ae039), {
                            additionalRedirectUris: editClient.additionalRedirectUris,
                            authCodeRedirectUrlHost: editClient.authCodeRedirectUrlHost,
                            onUpdate: (additionalField, additionalValue, hostField, hostValue)=>{
                                handleInputChange(additionalField, additionalValue);
                                handleInputChange(hostField, hostValue);
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f2dd45cbffb74c92$export$2e2bcd8739ae039), {
                open: showSecret,
                secret: editClient.secret,
                onClose: ()=>setShowSecret(false)
            })
        ]
    });
}


function $79fb8802f7614534$export$2e2bcd8739ae039({ $color: $color = 'accent', $size: $size = 'small', startIcon: startIcon = 'plusLight', ...restProps }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [openDialog, setOpenDialog] = (0, $7fPBF.useState)(false);
    const handleOpenDialog = ()=>setOpenDialog(true);
    const handleCloseDialog = ()=>setOpenDialog(false);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                $color: $color,
                $size: $size,
                onClick: handleOpenDialog,
                startIcon: startIcon,
                ...restProps,
                children: t('common:organization.projects.clients.create')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5201702d84bc65d1$export$2e2bcd8739ae039), {
                open: openDialog,
                onClose: handleCloseDialog
            })
        ]
    });
}





var $7fPBF = parcelRequire("7fPBF");


function $73aed8982a72a65d$export$2e2bcd8739ae039({ $color: $color = 'accent', $size: $size = 'small', startIcon: startIcon = 'plusLight', ...restProps }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [openDialog, setOpenDialog] = (0, $7fPBF.useState)(false);
    const handleOpenDialog = ()=>setOpenDialog(true);
    const handleCloseDialog = ()=>setOpenDialog(false);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                $color: $color,
                $size: $size,
                onClick: handleOpenDialog,
                startIcon: startIcon,
                ...restProps,
                children: t('common:organization.projects.deviceType.action')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $42567f24cb8195b5$export$2e2bcd8739ae039), {
                open: openDialog,
                onClose: handleCloseDialog
            })
        ]
    });
}







function $51b9dde09f5e56b2$export$2e2bcd8739ae039({ deviceTypeId: deviceTypeId, title: title }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const handleNavigate = ()=>{
        navigate(`device/${deviceTypeId}`);
    };
    if (!deviceTypeId || !title) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f034ea975db3d0b$export$2e2bcd8739ae039), {
        iconSize: 24,
        title: title,
        description: t('common:organization.projects.deviceType.id') + ': ' + (0, $9bc694be59ba7dc7$export$94edfa5bee6a54b8)(deviceTypeId),
        onClick: handleNavigate
    });
}







function $88bab46ef376a28f$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
        description: t('common:organization.projects.create.first.description'),
        fullHeight: true,
        title: t('common:organization.projects.create.first.title'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
            onClick: ()=>navigate('new'),
            startIcon: "plusLight",
            children: t('common:organization.projects.create.title')
        })
    });
}



function $4e320ec7bd47b761$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { currentOrg: currentOrg, isExpiredOrg: isExpiredOrg, canManageBilling: canManageBilling, canCreateAuthClients: canCreateAuthClients, isLoading: isLoading, isManagedOrg: isManagedOrg } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const { authClients: authClients, deviceTypes: deviceTypes, isLoading: isLoadingProjects } = (0, $76dd6d0d6f9746d5$export$2e2bcd8739ae039)();
    if (isLoading || isLoadingProjects) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {});
    if (!currentOrg) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f8f95b189a35cb2e$export$2e2bcd8739ae039), {});
    if (!currentOrg.canCreateAuthClients) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f8f95b189a35cb2e$export$2e2bcd8739ae039), {});
    if (isExpiredOrg) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d1ebcf00b940bfdd$export$2e2bcd8739ae039), {
        organizationId: currentOrg.id,
        canManageBilling: canManageBilling,
        isManagedOrg: isManagedOrg,
        customBillingUrl: currentOrg.customBillingUrl
    });
    if (!currentOrg || !canCreateAuthClients) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f8f95b189a35cb2e$export$2e2bcd8739ae039), {});
    if (!currentOrg.isDeveloperAccess) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0ec5f0e18dd3ab72$export$2e2bcd8739ae039), {});
    if (!currentOrg.canCreateAuthClients) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0ec5f0e18dd3ab72$export$2e2bcd8739ae039), {});
    if (authClients.length === 0 && deviceTypes.length === 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $88bab46ef376a28f$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:organization.projects.clients.title'),
                description: t('common:organization.projects.clients.description')
            }),
            authClients.map((client)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $78d4a77ac2e2ef58$export$2e2bcd8739ae039), {
                    clientId: client.id,
                    title: client.name ?? '-',
                    createdDate: client.createdDate
                }, client.id)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $347ffda0d89c401a$export$56d6cb3330e62b54), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $79fb8802f7614534$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:organization.projects.deviceType.title'),
                description: t('common:organization.projects.deviceType.description')
            }),
            deviceTypes && deviceTypes.map((device)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $51b9dde09f5e56b2$export$2e2bcd8739ae039), {
                    deviceTypeId: device.id,
                    title: device.name ?? device.id
                }, device.id)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $347ffda0d89c401a$export$56d6cb3330e62b54), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $73aed8982a72a65d$export$2e2bcd8739ae039), {})
            })
        ]
    });
}






function $f07d8ec8cbd03474$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { isExpiredOrg: isExpiredOrg, currentOrg: currentOrg } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    if (!currentOrg) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e8ddd06b3da44631$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: currentOrg?.name + ' ' + t('common:organization.projects.title'),
                description: t('common:organization.projects.description'),
                items: items,
                children: !isExpiredOrg && (currentOrg.canCreateAuthClients || currentOrg.isDeveloperAccess) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    $color: "secondary",
                    startIcon: "plus",
                    onClick: ()=>navigate('new'),
                    children: t('common:organization.projects.create.title')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4e320ec7bd47b761$export$2e2bcd8739ae039), {})
        ]
    });
}
















function $fd3af74d2f3a641d$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $348d9e775387b4da$export$85a4c3b5f32264b8), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6601f3edf09b4a92$export$2e2bcd8739ae039), {
                name: "javaScript",
                title: t('common:developer.sdk.javascript.title'),
                description: t('common:developer.sdk.javascript.description'),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                    endIcon: "externalLink",
                    variant: "subsection",
                    href: "https://www.npmjs.com/package/@cephable/cephable-web",
                    children: t('common:developer.sdk.javascript.action')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6601f3edf09b4a92$export$2e2bcd8739ae039), {
                name: "windows11",
                title: t('common:developer.sdk.net.title'),
                description: t('common:developer.sdk.net.description'),
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                        endIcon: "externalLink",
                        variant: "subsection",
                        href: "https://www.nuget.org/packages/Cephable.Core",
                        children: t('common:developer.sdk.net.actionCore')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                        endIcon: "externalLink",
                        variant: "subsection",
                        href: "https://www.nuget.org/packages/Cephable.WPF",
                        children: t('common:developer.sdk.net.actionWpf')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a5e039f9955fc75e$export$2e2bcd8739ae039), {
                name: "sdk",
                title: t('common:developer.sdk.more.title'),
                description: t('common:developer.sdk.more.description'),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    $color: "secondary",
                    href: "https://forms.office.com/Pages/ResponsePage.aspx?id=nXUREBN1JUCrY3YZ6NyUADMAro2v4K5DnCn2crFpV3hUOEY0OVhPTDE3REsyRU81QTBVVElTWkpMSC4u",
                    startIcon: "plusLight",
                    children: t('common:developer.sdk.more.action')
                })
            })
        ]
    });
}










var $7fPBF = parcelRequire("7fPBF");














function $903c940fba92da6d$export$2e2bcd8739ae039({ active: active, handleSectionChange: handleSectionChange, handleSave: handleSave }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($903c940fba92da6d$var$StyledButtonRow, {
        children: [
            active > 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                $color: "simple",
                $size: "small",
                onClick: ()=>handleSectionChange(active - 1),
                children: t('common:previous')
            }),
            handleSave ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                onClick: handleSave,
                children: t('common:save')
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                $color: "secondary",
                onClick: ()=>handleSectionChange(active + 1),
                children: t('common:next')
            })
        ]
    });
}
const $903c940fba92da6d$var$StyledButtonRow = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $347ffda0d89c401a$export$564cbe3426fc093a))`
    justify-content: flex-end;
`;


function $65e6bcb675663333$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId } = (0, $5ec159caebd3ae22$export$99eaa27ddbbb95ef)();
    const navigate = (0, $5ec159caebd3ae22$export$9770f232ac06a008)();
    const { deviceTypes: deviceTypes } = (0, $76dd6d0d6f9746d5$export$2e2bcd8739ae039)();
    const initialClientModel = (0, $7fPBF.useMemo)(()=>(0, $710192f33815db16$export$78965615411ef913)(organizationId || ''), [
        organizationId
    ]);
    const initialDeviceModel = (0, $7fPBF.useMemo)(()=>(0, $710192f33815db16$export$c9f16ca2d09e032e)(organizationId || ''), [
        organizationId
    ]);
    const { showError: showError, showSuccess: showSuccess } = (0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).useContainer();
    const [showSecret, setShowSecret] = (0, $7fPBF.useState)(false);
    const { editClient: editClient, handleInputChange: handleInputChange, handleSave: handleClientSave } = (0, $4b8a9e84dae5e7a0$export$8f7032ec10a68144)(initialClientModel);
    const { handleSave: handleDeviceSave } = (0, $bc567063fd13cd58$export$d5236bf86334668)(initialDeviceModel);
    const { editDeviceType: editDeviceType, handleInputChange: handleDeviceChange = handleInputChange } = (0, $c6a32ec408b1369c$export$2e2bcd8739ae039).useContainer();
    const [activeSection, setActiveSection, activeSectionRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(1);
    const updateActiveSection = (section)=>{
        if (section < 1 || section > 5) return;
        setActiveSection(section);
    };
    const save = async ()=>{
        try {
            const clientResponse = await handleClientSave();
            const deviceResponse = await handleDeviceSave();
            if (clientResponse?.resultType == 'Ok' && deviceResponse?.resultType == 'Ok') {
                setShowSecret(true);
                showSuccess(t('common:organization.projects.create.success'));
            } else showError(t('common:saveError'));
        } catch (error) {
            showError(t('common:saveError'));
        }
    };
    const handleCloseSecret = ()=>{
        setShowSecret(false);
        navigate(-1);
    };
    if (!organizationId || !editClient || !editDeviceType) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                complete: activeSection > 1,
                description: t('common:organization.projects.create.details.description'),
                number: 1,
                title: t('common:organization.projects.create.details.title'),
                variant: activeSection === 1 ? 'default' : 'small'
            }),
            activeSection === 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98c9acefb60389ed$export$2e2bcd8739ae039), {
                        value: editClient.name,
                        onUpdate: handleInputChange
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $903c940fba92da6d$export$2e2bcd8739ae039), {
                        active: activeSection,
                        handleSectionChange: updateActiveSection
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                complete: activeSection > 2,
                description: t('common:organization.projects.sdk.description'),
                number: 2,
                title: t('common:organization.projects.sdk.title'),
                variant: activeSection === 2 ? 'default' : 'small'
            }),
            activeSection === 2 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fd3af74d2f3a641d$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $903c940fba92da6d$export$2e2bcd8739ae039), {
                        active: activeSection,
                        handleSectionChange: updateActiveSection
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                complete: activeSection > 3,
                description: t('common:organization.projects.clients.description'),
                number: 3,
                title: t('common:organization.projects.clients.configure'),
                variant: activeSection === 3 ? 'default' : 'small'
            }),
            activeSection === 3 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $50c02032c88163c7$export$2e2bcd8739ae039), {
                        value: editClient.originHost,
                        onUpdate: handleInputChange
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d5d3b4079485dd94$export$2e2bcd8739ae039), {
                        tokenAdditionalRedirectUris: editClient.tokenAdditionalRedirectUris,
                        tokenRedirectUrlHost: editClient.tokenRedirectUrlHost,
                        onUpdate: (additionalField, additionalValue, hostField, hostValue)=>{
                            handleInputChange(additionalField, additionalValue);
                            handleInputChange(hostField, hostValue);
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $86bb7a18b305ac09$export$2e2bcd8739ae039), {
                        additionalRedirectUris: editClient.additionalRedirectUris,
                        authCodeRedirectUrlHost: editClient.authCodeRedirectUrlHost,
                        onUpdate: (additionalField, additionalValue, hostField, hostValue)=>{
                            handleInputChange(additionalField, additionalValue);
                            handleInputChange(hostField, hostValue);
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $903c940fba92da6d$export$2e2bcd8739ae039), {
                        active: activeSection,
                        handleSectionChange: updateActiveSection
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                complete: activeSection > 4,
                description: t('common:organization.projects.scopes.description'),
                number: 4,
                title: t('common:organization.projects.scopes.configure'),
                variant: activeSection === 4 ? 'default' : 'small'
            }),
            activeSection === 4 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f61ab26e94239cef$export$2e2bcd8739ae039), {
                        value: editClient.authClientScopes,
                        onUpdate: (field, value)=>handleInputChange(field, value)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $903c940fba92da6d$export$2e2bcd8739ae039), {
                        active: activeSection,
                        handleSectionChange: updateActiveSection
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                complete: activeSection > 5,
                description: t('common:organization.projects.deviceScopes.description'),
                number: 5,
                title: t('common:organization.projects.deviceScopes.configure'),
                variant: activeSection === 5 ? 'default' : 'small'
            }),
            activeSection === 5 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1f273ff0abbe6580$export$2e2bcd8739ae039), {
                        value: editClient.authClientDeviceTypes,
                        onUpdate: handleInputChange,
                        deviceOptions: deviceTypes
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $903c940fba92da6d$export$2e2bcd8739ae039), {
                        active: activeSection,
                        handleSectionChange: updateActiveSection,
                        handleSave: save
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f2dd45cbffb74c92$export$2e2bcd8739ae039), {
                secret: editClient.secret,
                open: showSecret,
                onClose: handleCloseSecret
            })
        ]
    });
}



function $ffc3d2d483d5abdd$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:organization.projects.create.titleLong'),
                description: t('common:organization.projects.description'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65e6bcb675663333$export$2e2bcd8739ae039), {})
        ]
    });
}













function $efd6ce3b83edd707$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:developer.titleLong'),
                description: t('common:developer.description'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:developer.sdk.title'),
                description: t('common:developer.sdk.description')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fd3af74d2f3a641d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:developer.demo.samples'),
                description: t('common:developer.demo.description')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $348d9e775387b4da$export$85a4c3b5f32264b8), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6601f3edf09b4a92$export$2e2bcd8739ae039), {
                        name: "globe",
                        title: t('common:developer.demo.web.title'),
                        description: t('common:developer.demo.web.description'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                            endIcon: "externalLink",
                            variant: "subsection",
                            href: "https://web-samples.cephable.com/",
                            children: t('common:developer.demo.web.action')
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6601f3edf09b4a92$export$2e2bcd8739ae039), {
                        name: "unity",
                        title: t('common:developer.demo.unity.title'),
                        description: t('common:developer.demo.unity.description'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                            endIcon: "externalLink",
                            variant: "subsection",
                            href: "https://github.com/Cephable/Cephable-Unity-Samples",
                            children: t('common:developer.demo.unity.action')
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6601f3edf09b4a92$export$2e2bcd8739ae039), {
                        name: "multipleDevices",
                        title: t('common:developer.demo.other.title'),
                        description: t('common:developer.demo.other.description'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                            endIcon: "externalLink",
                            variant: "subsection",
                            href: "https://github.com/Cephable/Cephable-VirtualController-Sample",
                            children: t('common:developer.demo.other.action')
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6601f3edf09b4a92$export$2e2bcd8739ae039), {
                        name: "globe",
                        title: t('common:developer.demo.game.title'),
                        description: t('common:developer.demo.game.description'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                            endIcon: "externalLink",
                            variant: "subsection",
                            href: "https://try.cephable.com/",
                            children: t('common:developer.demo.game.action')
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:developer.other.title'),
                description: t('common:developer.other.description')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $348d9e775387b4da$export$85a4c3b5f32264b8), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6601f3edf09b4a92$export$2e2bcd8739ae039), {
                        name: "code",
                        title: t('common:developer.other.api.title'),
                        description: t('common:developer.other.api.description'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbaab975a9dfe13$export$2e2bcd8739ae039), {
                            endIcon: "externalLink",
                            variant: "subsection",
                            href: "https://services.cephable.com/swagger/index.html",
                            children: "Learn More"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a5e039f9955fc75e$export$2e2bcd8739ae039), {
                        name: "help",
                        title: t('common:developer.other.support.title'),
                        description: t('common:developer.other.support.description'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            href: "https://discord.gg/YSDpstxXb5",
                            startIcon: "plusLight",
                            children: t('common:developer.other.support.action')
                        })
                    })
                ]
            })
        ]
    });
}


const $e938c8b8c236f168$var$getBillingRoutes = ()=>[
        {
            path: 'upgrade',
            children: [
                {
                    index: true,
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fa7643c656d80855$export$2e2bcd8739ae039), {}),
                    handle: {
                        crumbKey: 'common:license.redirect.title'
                    }
                },
                {
                    path: 'product/:productId',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fa7643c656d80855$export$2e2bcd8739ae039), {}),
                    handle: {
                        crumbKey: 'common:license.redirect.title'
                    }
                }
            ]
        },
        {
            path: 'error',
            element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $572ce21afb4be0ad$export$2e2bcd8739ae039), {}),
            handle: {
                crumbKey: 'common:license.redirect.error'
            }
        }
    ];
const $e938c8b8c236f168$var$getProfileRoutes = ()=>[
        {
            index: true,
            handle: {
                showActions: true
            },
            element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $156f799d529efa2e$export$2e2bcd8739ae039), {})
        },
        {
            path: 'controls/:index',
            element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8f0c21677a1de5b0$export$2e2bcd8739ae039), {}),
            handle: {
                crumbKey: 'common:macros.new'
            }
        },
        {
            path: 'advanced',
            handle: {
                crumbKey: 'common:advancedOptions',
                title: 'common:profile.advancedOptions'
            },
            children: [
                {
                    index: true,
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e30fe951f2edb943$export$2e2bcd8739ae039), {})
                },
                {
                    path: 'hotkeys',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2a7f35c066805bff$export$2e2bcd8739ae039), {}),
                    handle: {
                        crumbKey: 'common:hotkey.title',
                        title: 'common:hotkey.title',
                        description: 'common:hotkey.usagePrompt'
                    }
                },
                {
                    path: 'keybindings',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $48f7f3d9d01bd5f7$export$2e2bcd8739ae039), {}),
                    handle: {
                        crumbKey: 'common:keys.title',
                        title: 'common:keys.title',
                        description: 'common:keys.description'
                    }
                },
                {
                    path: 'dictation',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $013893ecb4f625ea$export$2e2bcd8739ae039), {}),
                    handle: {
                        crumbKey: 'common:dictation.title',
                        title: 'common:dictation.title',
                        description: 'common:dictation.description'
                    }
                },
                {
                    path: 'suggested-prompts',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7d3c7fab6a83fa5f$export$2e2bcd8739ae039), {}),
                    handle: {
                        crumbKey: 'common:suggestedPrompts.title',
                        title: 'common:suggestedPrompts.title',
                        description: 'common:suggestedPrompts.description'
                    }
                },
                {
                    path: 'summary',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4025efcf1cd15ab4$export$2e2bcd8739ae039), {}),
                    handle: {
                        crumbKey: 'common:profile.summary.title',
                        title: 'common:profile.summary.title',
                        description: 'common:profile.summary.description'
                    }
                },
                {
                    path: 'share',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7a1bf8f9f1406bc7$export$2e2bcd8739ae039), {}),
                    handle: {
                        crumbKey: 'common:share',
                        title: 'common:profile.share.title',
                        description: 'common:profile.share.description'
                    }
                }
            ]
        }
    ];
const $e938c8b8c236f168$var$getOrgRoutes = ()=>[
        {
            element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6da00e256676a096$export$2e2bcd8739ae039), {}),
            index: true
        },
        {
            path: 'billing/compare',
            handle: {
                crumbKey: 'common:billing.upgrade.compare'
            },
            element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8fb8c11d74adb839$export$2e2bcd8739ae039), {})
        },
        {
            path: 'billing/redirect',
            children: $e938c8b8c236f168$var$getBillingRoutes()
        },
        {
            path: 'trial/redirect',
            children: $e938c8b8c236f168$var$getBillingRoutes()
        },
        {
            path: 'license',
            element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4643a3bccc023815$export$2e2bcd8739ae039), {}),
            handle: {
                crumbKey: 'common:license.activate.title'
            }
        },
        {
            path: 'members',
            handle: {
                crumbKey: 'common:organization.member.titlePlural'
            },
            children: [
                {
                    index: true,
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e25675874c945d68$export$2e2bcd8739ae039), {})
                },
                {
                    path: 'invites',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $baa978b131a43e54$export$2e2bcd8739ae039), {}),
                    handle: {
                        crumbKey: 'common:organization.invite.titlePlural'
                    }
                }
            ]
        },
        {
            path: 'projects',
            handle: {
                crumbKey: 'common:organization.projects.title'
            },
            children: [
                {
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f07d8ec8cbd03474$export$2e2bcd8739ae039), {}),
                    index: true
                },
                {
                    path: 'new',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ffc3d2d483d5abdd$export$2e2bcd8739ae039), {}),
                    handle: {
                        crumbKey: 'common:organization.projects.create.title'
                    }
                },
                {
                    path: 'client/:clientId',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f1f3f26007c0cbd9$export$2e2bcd8739ae039), {}),
                    handle: {
                        crumbKey: 'common:organization.projects.clients.title'
                    }
                },
                {
                    path: 'device/:deviceId',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2be582792e299f82$export$2e2bcd8739ae039), {}),
                    handle: {
                        crumbKey: 'common:organization.projects.deviceType.title'
                    }
                }
            ]
        },
        {
            path: 'metrics',
            handle: {
                crumbKey: 'common:organization.metrics.title'
            },
            children: [
                {
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $71606fe9d87fd62f$export$2e2bcd8739ae039), {}),
                    index: true
                },
                {
                    path: ':clientId',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdd92f3efb1b659$export$2e2bcd8739ae039), {
                        pageTitle: "Org Metrics Client Detail"
                    }),
                    handle: {
                        crumbKey: 'common:organization.project.title'
                    }
                }
            ]
        },
        {
            path: 'documentation',
            handle: {
                crumbKey: 'common:resources.title'
            },
            children: [
                {
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0870cb345d848b86$export$2e2bcd8739ae039), {}),
                    index: true
                }
            ]
        },
        {
            path: 'settings',
            handle: {
                crumbKey: 'common:organization.settings.title'
            },
            children: [
                {
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $077db4f25b761cd8$export$2e2bcd8739ae039), {}),
                    index: true
                }
            ]
        },
        {
            path: 'profiles',
            handle: {
                crumbKey: 'common:profile.title',
                title: 'common:profile.title'
            },
            children: [
                {
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30ba1e267b5a3af7$export$2e2bcd8739ae039), {}),
                    index: true
                },
                {
                    path: 'new',
                    handle: {
                        crumbKey: 'common:create'
                    },
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b1a3a2a9b20cff10$export$2e2bcd8739ae039), {}),
                    children: $e938c8b8c236f168$var$getProfileRoutes()
                },
                {
                    path: 'edit/:profileId',
                    handle: {
                        crumbKey: 'common:edit'
                    },
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b1a3a2a9b20cff10$export$2e2bcd8739ae039), {}),
                    children: $e938c8b8c236f168$var$getProfileRoutes()
                },
                {
                    path: 'preview/:profileId',
                    handle: {
                        crumbKey: 'common:profile.preview',
                        description: 'common:profile.previewDescription'
                    },
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b1a3a2a9b20cff10$export$2e2bcd8739ae039), {}),
                    children: [
                        {
                            index: true,
                            element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7ac5e11d07b654ce$export$2e2bcd8739ae039), {})
                        }
                    ]
                }
            ]
        }
    ];
const $e938c8b8c236f168$var$router = (0, $5ec159caebd3ae22$export$1ba7ed8a3a7b3765)([
    {
        path: '/',
        handle: {
            crumbKey: 'common:dashboard.title'
        },
        children: [
            {
                path: 'login',
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d308289446e38196$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3fc44e910064c4f6$export$2e2bcd8739ae039), {})
                })
            },
            {
                path: 'authcallback',
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d308289446e38196$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f6147295756e879a$export$2e2bcd8739ae039), {})
                })
            },
            {
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18eb3fb4329f0ffa$export$2e2bcd8739ae039), {}),
                children: [
                    {
                        index: true,
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1571b35751ed6eec$export$2e2bcd8739ae039), {})
                    },
                    {
                        path: 'upgrade',
                        handle: {
                            crumbKey: 'common:upgrade'
                        },
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8fb8c11d74adb839$export$2e2bcd8739ae039), {})
                    },
                    {
                        path: 'my-account',
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6895f6b5d8df95cd$export$2e2bcd8739ae039), {}),
                        handle: {
                            crumbKey: 'common:account.settings'
                        }
                    },
                    {
                        path: 'notifications',
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9a22a8e524cd97e1$export$2e2bcd8739ae039), {}),
                        handle: {
                            crumbKey: 'common:notifications.title'
                        }
                    },
                    {
                        path: 'org/:organizationId',
                        handle: {
                            crumbKey: 'common:organization.title'
                        },
                        children: [
                            ...$e938c8b8c236f168$var$getOrgRoutes(),
                            {
                                path: 'managed',
                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $776f18f1a04f38af$export$2e2bcd8739ae039), {}),
                                handle: {
                                    crumbKey: 'common:organization.managed.title'
                                }
                            },
                            {
                                path: 'managed/:managedOrgId',
                                handle: {
                                    crumbKey: 'common:organization.managed.title'
                                },
                                children: $e938c8b8c236f168$var$getOrgRoutes()
                            },
                            {
                                path: 'licensekey',
                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b9b520f8e9a5b827$export$2e2bcd8739ae039), {}),
                                handle: {
                                    crumbKey: 'common:license.key.title'
                                }
                            },
                            {
                                path: 'purchase',
                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d391d99bd393b0cc$export$2e2bcd8739ae039), {}),
                                handle: {
                                    crumbKey: 'common:license.key.product.title'
                                }
                            },
                            {
                                path: 'product/:productId',
                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fa7643c656d80855$export$2e2bcd8739ae039), {}),
                                handle: {
                                    crumbKey: 'common:license.redirect.title'
                                }
                            }
                        ]
                    },
                    {
                        path: 'developer',
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $efd6ce3b83edd707$export$2e2bcd8739ae039), {}),
                        handle: {
                            crumbKey: 'common:developer.title'
                        }
                    },
                    {
                        path: 'support',
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdd92f3efb1b659$export$2e2bcd8739ae039), {
                            pageTitle: "Support"
                        }),
                        handle: {
                            crumbKey: 'common:support.title'
                        }
                    }
                ]
            },
            {
                path: '*',
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d308289446e38196$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b4fdfd1bcb4375a9$export$2e2bcd8739ae039), {})
                }),
                handle: {
                    crumbKey: 'common:notFound'
                }
            }
        ]
    }
]);
function $e938c8b8c236f168$export$2e2bcd8739ae039() {
    const restructureUrl = ()=>{
        const { search: search, hash: hash } = window.location;
        // If there are query parameters but they are before the hash
        // specifically addresses the base url overwriting that happens with auth callbacks
        if (search && !hash.includes('?')) {
            let newHash = hash || '#/';
            const params = new URLSearchParams(search);
            // Directly move to authcallback if code is present to minimize the number of redirects
            if (search.includes('code')) newHash = '#/authcallback';
            const newUrl = `${window.location.origin}${newHash}${search}`;
            window.history.replaceState(null, '', newUrl);
            window.location.reload();
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        restructureUrl();
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5ec159caebd3ae22$export$323e4fc2fa4753fb), {
        router: $e938c8b8c236f168$var$router
    });
}


const $e6b179db45cb0d87$var$AppWithProviders = ()=>{
    window.ADMIN_ENVIRONMENT = 'true';
    window.commandHandlers = [];
    window.commandMacroHandler = [];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c6dc2c2d62651942$export$e6cf561029f29d90), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $19e0bc52fddd02b4$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cbc6c65ed9f8bf86$export$dc45bdc734ce6f1e), {
                dateAdapter: (0, $3281ad3dbde45caa$export$33545c6a80bae043),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5eb45bbdec4cc6a0$export$2e2bcd8739ae039).Provider, {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d8990c2b9fb87b75$export$2e2bcd8739ae039).Provider, {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $455682785eac4c5b$export$2e2bcd8739ae039).Provider, {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8a1185b15e8317ab$export$2e2bcd8739ae039).Provider, {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $55ce97f088539572$export$2e2bcd8739ae039).Provider, {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $57ef534a0961ba07$export$2e2bcd8739ae039).Provider, {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $43d630686eddb628$export$2e2bcd8739ae039).Provider, {
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b8d2d4cc121e033d$export$2e2bcd8739ae039).Provider, {
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $60065a32b4a31650$export$2e2bcd8739ae039).Provider, {
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ba024c453c69bc05$export$2e2bcd8739ae039).Provider, {
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c6a32ec408b1369c$export$2e2bcd8739ae039).Provider, {
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $697752726c88b03c$export$2e2bcd8739ae039).Provider, {
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3521ff40d609c2ed$export$2e2bcd8739ae039).Provider, {
                                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e938c8b8c236f168$export$2e2bcd8739ae039), {})
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
var $e6b179db45cb0d87$export$2e2bcd8739ae039 = $e6b179db45cb0d87$var$AppWithProviders;


const $17e918899ef0ee5d$var$theme = (0, $ca3239ce6bf6e490$export$2e2bcd8739ae039)({
    palette: {
        primary: {
            main: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary
        },
        secondary: {
            main: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary
        },
        error: {
            main: (0, $8951886a6b49e92a$export$35e9368ef982300f).error
        }
    }
});
const $17e918899ef0ee5d$var$rootElement = document.getElementById('root');
if (!$17e918899ef0ee5d$var$rootElement) throw new Error('Root element not found');
const $17e918899ef0ee5d$var$root = (0, $f11ec298ebcca059$export$882461b6382ed46c)($17e918899ef0ee5d$var$rootElement);
$17e918899ef0ee5d$var$root.render(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e6b179db45cb0d87$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=admin.df0d0f4a.js.map
